;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="a6f49dde-144e-4e06-b527-daa5ba77e321",e._sentryDebugIdIdentifier="sentry-dbid-a6f49dde-144e-4e06-b527-daa5ba77e321")}catch(e){}}();
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 61835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iN": function() { return /* reexport */ blue; },
  "R_": function() { return /* reexport */ generate; },
  "EV": function() { return /* reexport */ gold; },
  "Ti": function() { return /* reexport */ presetPalettes; },
  "ez": function() { return /* reexport */ presetPrimaryColors; }
});

// UNUSED EXPORTS: blueDark, cyan, cyanDark, geekblue, geekblueDark, goldDark, gray, green, greenDark, grey, greyDark, lime, limeDark, magenta, magentaDark, orange, orangeDark, presetDarkPalettes, purple, purpleDark, red, redDark, volcano, volcanoDark, yellow, yellowDark

// EXTERNAL MODULE: ./node_modules/@ant-design/fast-color/es/index.js + 1 modules
var es = __webpack_require__(99620);
;// CONCATENATED MODULE: ./node_modules/@ant-design/colors/es/generate.js

var hueStep = 2; // 色相阶梯
var saturationStep = 0.16; // 饱和度阶梯，浅色部分
var saturationStep2 = 0.05; // 饱和度阶梯，深色部分
var brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
var brightnessStep2 = 0.15; // 亮度阶梯，深色部分
var lightColorCount = 5; // 浅色数量，主色上
var darkColorCount = 4; // 深色数量，主色下

// 暗色主题颜色映射关系表
var darkColorMap = [{
  index: 7,
  amount: 15
}, {
  index: 6,
  amount: 25
}, {
  index: 5,
  amount: 30
}, {
  index: 5,
  amount: 45
}, {
  index: 5,
  amount: 65
}, {
  index: 5,
  amount: 85
}, {
  index: 4,
  amount: 90
}, {
  index: 3,
  amount: 95
}, {
  index: 2,
  amount: 97
}, {
  index: 1,
  amount: 98
}];
function getHue(hsv, i, light) {
  var hue;
  // 根据色相不同，色相转向不同
  if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
    hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
  } else {
    hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
  }
  if (hue < 0) {
    hue += 360;
  } else if (hue >= 360) {
    hue -= 360;
  }
  return hue;
}
function getSaturation(hsv, i, light) {
  // grey color don't change saturation
  if (hsv.h === 0 && hsv.s === 0) {
    return hsv.s;
  }
  var saturation;
  if (light) {
    saturation = hsv.s - saturationStep * i;
  } else if (i === darkColorCount) {
    saturation = hsv.s + saturationStep;
  } else {
    saturation = hsv.s + saturationStep2 * i;
  }
  // 边界值修正
  if (saturation > 1) {
    saturation = 1;
  }
  // 第一格的 s 限制在 0.06-0.1 之间
  if (light && i === lightColorCount && saturation > 0.1) {
    saturation = 0.1;
  }
  if (saturation < 0.06) {
    saturation = 0.06;
  }
  return Math.round(saturation * 100) / 100;
}
function getValue(hsv, i, light) {
  var value;
  if (light) {
    value = hsv.v + brightnessStep1 * i;
  } else {
    value = hsv.v - brightnessStep2 * i;
  }
  // Clamp value between 0 and 1
  value = Math.max(0, Math.min(1, value));
  return Math.round(value * 100) / 100;
}
function generate(color) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var patterns = [];
  var pColor = new es/* FastColor */.t(color);
  var hsv = pColor.toHsv();
  for (var i = lightColorCount; i > 0; i -= 1) {
    var c = new es/* FastColor */.t({
      h: getHue(hsv, i, true),
      s: getSaturation(hsv, i, true),
      v: getValue(hsv, i, true)
    });
    patterns.push(c);
  }
  patterns.push(pColor);
  for (var _i = 1; _i <= darkColorCount; _i += 1) {
    var _c = new es/* FastColor */.t({
      h: getHue(hsv, _i),
      s: getSaturation(hsv, _i),
      v: getValue(hsv, _i)
    });
    patterns.push(_c);
  }

  // dark theme patterns
  if (opts.theme === 'dark') {
    return darkColorMap.map(function (_ref) {
      var index = _ref.index,
        amount = _ref.amount;
      return new es/* FastColor */.t(opts.backgroundColor || '#141414').mix(patterns[index], amount).toHexString();
    });
  }
  return patterns.map(function (c) {
    return c.toHexString();
  });
}
;// CONCATENATED MODULE: ./node_modules/@ant-design/colors/es/presets.js
// Generated by script. Do NOT modify!

var presetPrimaryColors = {
  "red": "#F5222D",
  "volcano": "#FA541C",
  "orange": "#FA8C16",
  "gold": "#FAAD14",
  "yellow": "#FADB14",
  "lime": "#A0D911",
  "green": "#52C41A",
  "cyan": "#13C2C2",
  "blue": "#1677FF",
  "geekblue": "#2F54EB",
  "purple": "#722ED1",
  "magenta": "#EB2F96",
  "grey": "#666666"
};
var red = ["#fff1f0", "#ffccc7", "#ffa39e", "#ff7875", "#ff4d4f", "#f5222d", "#cf1322", "#a8071a", "#820014", "#5c0011"];
red.primary = red[5];
var volcano = ["#fff2e8", "#ffd8bf", "#ffbb96", "#ff9c6e", "#ff7a45", "#fa541c", "#d4380d", "#ad2102", "#871400", "#610b00"];
volcano.primary = volcano[5];
var orange = ["#fff7e6", "#ffe7ba", "#ffd591", "#ffc069", "#ffa940", "#fa8c16", "#d46b08", "#ad4e00", "#873800", "#612500"];
orange.primary = orange[5];
var gold = ["#fffbe6", "#fff1b8", "#ffe58f", "#ffd666", "#ffc53d", "#faad14", "#d48806", "#ad6800", "#874d00", "#613400"];
gold.primary = gold[5];
var yellow = ["#feffe6", "#ffffb8", "#fffb8f", "#fff566", "#ffec3d", "#fadb14", "#d4b106", "#ad8b00", "#876800", "#614700"];
yellow.primary = yellow[5];
var lime = ["#fcffe6", "#f4ffb8", "#eaff8f", "#d3f261", "#bae637", "#a0d911", "#7cb305", "#5b8c00", "#3f6600", "#254000"];
lime.primary = lime[5];
var green = ["#f6ffed", "#d9f7be", "#b7eb8f", "#95de64", "#73d13d", "#52c41a", "#389e0d", "#237804", "#135200", "#092b00"];
green.primary = green[5];
var cyan = ["#e6fffb", "#b5f5ec", "#87e8de", "#5cdbd3", "#36cfc9", "#13c2c2", "#08979c", "#006d75", "#00474f", "#002329"];
cyan.primary = cyan[5];
var blue = ["#e6f4ff", "#bae0ff", "#91caff", "#69b1ff", "#4096ff", "#1677ff", "#0958d9", "#003eb3", "#002c8c", "#001d66"];
blue.primary = blue[5];
var geekblue = ["#f0f5ff", "#d6e4ff", "#adc6ff", "#85a5ff", "#597ef7", "#2f54eb", "#1d39c4", "#10239e", "#061178", "#030852"];
geekblue.primary = geekblue[5];
var purple = ["#f9f0ff", "#efdbff", "#d3adf7", "#b37feb", "#9254de", "#722ed1", "#531dab", "#391085", "#22075e", "#120338"];
purple.primary = purple[5];
var magenta = ["#fff0f6", "#ffd6e7", "#ffadd2", "#ff85c0", "#f759ab", "#eb2f96", "#c41d7f", "#9e1068", "#780650", "#520339"];
magenta.primary = magenta[5];
var grey = ["#a6a6a6", "#999999", "#8c8c8c", "#808080", "#737373", "#666666", "#404040", "#1a1a1a", "#000000", "#000000"];
grey.primary = grey[5];
var gray = (/* unused pure expression or super */ null && (grey));
var presetPalettes = {
  red: red,
  volcano: volcano,
  orange: orange,
  gold: gold,
  yellow: yellow,
  lime: lime,
  green: green,
  cyan: cyan,
  blue: blue,
  geekblue: geekblue,
  purple: purple,
  magenta: magenta,
  grey: grey
};
var redDark = ["#2a1215", "#431418", "#58181c", "#791a1f", "#a61d24", "#d32029", "#e84749", "#f37370", "#f89f9a", "#fac8c3"];
redDark.primary = redDark[5];
var volcanoDark = ["#2b1611", "#441d12", "#592716", "#7c3118", "#aa3e19", "#d84a1b", "#e87040", "#f3956a", "#f8b692", "#fad4bc"];
volcanoDark.primary = volcanoDark[5];
var orangeDark = ["#2b1d11", "#442a11", "#593815", "#7c4a15", "#aa6215", "#d87a16", "#e89a3c", "#f3b765", "#f8cf8d", "#fae3b7"];
orangeDark.primary = orangeDark[5];
var goldDark = ["#2b2111", "#443111", "#594214", "#7c5914", "#aa7714", "#d89614", "#e8b339", "#f3cc62", "#f8df8b", "#faedb5"];
goldDark.primary = goldDark[5];
var yellowDark = ["#2b2611", "#443b11", "#595014", "#7c6e14", "#aa9514", "#d8bd14", "#e8d639", "#f3ea62", "#f8f48b", "#fafab5"];
yellowDark.primary = yellowDark[5];
var limeDark = ["#1f2611", "#2e3c10", "#3e4f13", "#536d13", "#6f9412", "#8bbb11", "#a9d134", "#c9e75d", "#e4f88b", "#f0fab5"];
limeDark.primary = limeDark[5];
var greenDark = ["#162312", "#1d3712", "#274916", "#306317", "#3c8618", "#49aa19", "#6abe39", "#8fd460", "#b2e58b", "#d5f2bb"];
greenDark.primary = greenDark[5];
var cyanDark = ["#112123", "#113536", "#144848", "#146262", "#138585", "#13a8a8", "#33bcb7", "#58d1c9", "#84e2d8", "#b2f1e8"];
cyanDark.primary = cyanDark[5];
var blueDark = ["#111a2c", "#112545", "#15325b", "#15417e", "#1554ad", "#1668dc", "#3c89e8", "#65a9f3", "#8dc5f8", "#b7dcfa"];
blueDark.primary = blueDark[5];
var geekblueDark = ["#131629", "#161d40", "#1c2755", "#203175", "#263ea0", "#2b4acb", "#5273e0", "#7f9ef3", "#a8c1f8", "#d2e0fa"];
geekblueDark.primary = geekblueDark[5];
var purpleDark = ["#1a1325", "#24163a", "#301c4d", "#3e2069", "#51258f", "#642ab5", "#854eca", "#ab7ae0", "#cda8f0", "#ebd7fa"];
purpleDark.primary = purpleDark[5];
var magentaDark = ["#291321", "#40162f", "#551c3b", "#75204f", "#a02669", "#cb2b83", "#e0529c", "#f37fb7", "#f8a8cc", "#fad2e3"];
magentaDark.primary = magentaDark[5];
var greyDark = ["#151515", "#1f1f1f", "#2d2d2d", "#393939", "#494949", "#5a5a5a", "#6a6a6a", "#7b7b7b", "#888888", "#969696"];
greyDark.primary = greyDark[5];
var presetDarkPalettes = {
  red: redDark,
  volcano: volcanoDark,
  orange: orangeDark,
  gold: goldDark,
  yellow: yellowDark,
  lime: limeDark,
  green: greenDark,
  cyan: cyanDark,
  blue: blueDark,
  geekblue: geekblueDark,
  purple: purpleDark,
  magenta: magentaDark,
  grey: greyDark
};
;// CONCATENATED MODULE: ./node_modules/@ant-design/colors/es/index.js



/***/ }),

/***/ 89158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rb": function() { return /* reexport */ util_genStyleUtils; },
  "IX": function() { return /* reexport */ merge; }
});

// UNUSED EXPORTS: genCalc, statistic, statisticToken

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs/es/index.js + 37 modules
var es = __webpack_require__(68946);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6223);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(79427);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(88569);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(34766);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js
var createSuper = __webpack_require__(56302);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs-utils/es/util/calc/calculator.js


var AbstractCalculator = /*#__PURE__*/(0,createClass/* default */.Z)(function AbstractCalculator() {
  (0,classCallCheck/* default */.Z)(this, AbstractCalculator);
});
/* harmony default export */ var calculator = (AbstractCalculator);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs-utils/es/util/calc/CSSCalculator.js








var CALC_UNIT = 'CALC_UNIT';
var regexp = new RegExp(CALC_UNIT, 'g');
function unit(value) {
  if (typeof value === 'number') {
    return "".concat(value).concat(CALC_UNIT);
  }
  return value;
}
var CSSCalculator = /*#__PURE__*/function (_AbstractCalculator) {
  (0,inherits/* default */.Z)(CSSCalculator, _AbstractCalculator);
  var _super = (0,createSuper/* default */.Z)(CSSCalculator);
  function CSSCalculator(num, unitlessCssVar) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, CSSCalculator);
    _this = _super.call(this);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "result", '');
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "unitlessCssVar", void 0);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "lowPriority", void 0);
    var numType = (0,esm_typeof/* default */.Z)(num);
    _this.unitlessCssVar = unitlessCssVar;
    if (num instanceof CSSCalculator) {
      _this.result = "(".concat(num.result, ")");
    } else if (numType === 'number') {
      _this.result = unit(num);
    } else if (numType === 'string') {
      _this.result = num;
    }
    return _this;
  }
  (0,createClass/* default */.Z)(CSSCalculator, [{
    key: "add",
    value: function add(num) {
      if (num instanceof CSSCalculator) {
        this.result = "".concat(this.result, " + ").concat(num.getResult());
      } else if (typeof num === 'number' || typeof num === 'string') {
        this.result = "".concat(this.result, " + ").concat(unit(num));
      }
      this.lowPriority = true;
      return this;
    }
  }, {
    key: "sub",
    value: function sub(num) {
      if (num instanceof CSSCalculator) {
        this.result = "".concat(this.result, " - ").concat(num.getResult());
      } else if (typeof num === 'number' || typeof num === 'string') {
        this.result = "".concat(this.result, " - ").concat(unit(num));
      }
      this.lowPriority = true;
      return this;
    }
  }, {
    key: "mul",
    value: function mul(num) {
      if (this.lowPriority) {
        this.result = "(".concat(this.result, ")");
      }
      if (num instanceof CSSCalculator) {
        this.result = "".concat(this.result, " * ").concat(num.getResult(true));
      } else if (typeof num === 'number' || typeof num === 'string') {
        this.result = "".concat(this.result, " * ").concat(num);
      }
      this.lowPriority = false;
      return this;
    }
  }, {
    key: "div",
    value: function div(num) {
      if (this.lowPriority) {
        this.result = "(".concat(this.result, ")");
      }
      if (num instanceof CSSCalculator) {
        this.result = "".concat(this.result, " / ").concat(num.getResult(true));
      } else if (typeof num === 'number' || typeof num === 'string') {
        this.result = "".concat(this.result, " / ").concat(num);
      }
      this.lowPriority = false;
      return this;
    }
  }, {
    key: "getResult",
    value: function getResult(force) {
      return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
    }
  }, {
    key: "equal",
    value: function equal(options) {
      var _this2 = this;
      var _ref = options || {},
        cssUnit = _ref.unit;
      var mergedUnit = true;
      if (typeof cssUnit === 'boolean') {
        mergedUnit = cssUnit;
      } else if (Array.from(this.unitlessCssVar).some(function (cssVar) {
        return _this2.result.includes(cssVar);
      })) {
        mergedUnit = false;
      }
      this.result = this.result.replace(regexp, mergedUnit ? 'px' : '');
      if (typeof this.lowPriority !== 'undefined') {
        return "calc(".concat(this.result, ")");
      }
      return this.result;
    }
  }]);
  return CSSCalculator;
}(calculator);

;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs-utils/es/util/calc/NumCalculator.js







var NumCalculator = /*#__PURE__*/function (_AbstractCalculator) {
  (0,inherits/* default */.Z)(NumCalculator, _AbstractCalculator);
  var _super = (0,createSuper/* default */.Z)(NumCalculator);
  function NumCalculator(num) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, NumCalculator);
    _this = _super.call(this);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "result", 0);
    if (num instanceof NumCalculator) {
      _this.result = num.result;
    } else if (typeof num === 'number') {
      _this.result = num;
    }
    return _this;
  }
  (0,createClass/* default */.Z)(NumCalculator, [{
    key: "add",
    value: function add(num) {
      if (num instanceof NumCalculator) {
        this.result += num.result;
      } else if (typeof num === 'number') {
        this.result += num;
      }
      return this;
    }
  }, {
    key: "sub",
    value: function sub(num) {
      if (num instanceof NumCalculator) {
        this.result -= num.result;
      } else if (typeof num === 'number') {
        this.result -= num;
      }
      return this;
    }
  }, {
    key: "mul",
    value: function mul(num) {
      if (num instanceof NumCalculator) {
        this.result *= num.result;
      } else if (typeof num === 'number') {
        this.result *= num;
      }
      return this;
    }
  }, {
    key: "div",
    value: function div(num) {
      if (num instanceof NumCalculator) {
        this.result /= num.result;
      } else if (typeof num === 'number') {
        this.result /= num;
      }
      return this;
    }
  }, {
    key: "equal",
    value: function equal() {
      return this.result;
    }
  }]);
  return NumCalculator;
}(calculator);
/* harmony default export */ var calc_NumCalculator = (NumCalculator);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs-utils/es/util/calc/index.js


var genCalc = function genCalc(type, unitlessCssVar) {
  var Calculator = type === 'css' ? CSSCalculator : calc_NumCalculator;
  return function (num) {
    return new Calculator(num, unitlessCssVar);
  };
};
/* harmony default export */ var util_calc = (genCalc);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs-utils/es/util/getCompVarPrefix.js
var getCompVarPrefix = function getCompVarPrefix(component, prefix) {
  return "".concat([prefix, component.replace(/([A-Z]+)([A-Z][a-z]+)/g, '$1-$2').replace(/([a-z])([A-Z])/g, '$1-$2')].filter(Boolean).join('-'));
};
/* harmony default export */ var util_getCompVarPrefix = (getCompVarPrefix);
// EXTERNAL MODULE: ./node_modules/rc-util/es/index.js
var rc_util_es = __webpack_require__(57433);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs-utils/es/util/getComponentToken.js



function getComponentToken(component, token, defaultToken, options) {
  var customToken = (0,objectSpread2/* default */.Z)({}, token[component]);
  if (options !== null && options !== void 0 && options.deprecatedTokens) {
    var deprecatedTokens = options.deprecatedTokens;
    deprecatedTokens.forEach(function (_ref) {
      var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
        oldTokenKey = _ref2[0],
        newTokenKey = _ref2[1];
      if (false) {}

      // Should wrap with `if` clause, or there will be `undefined` in object.
      if (customToken !== null && customToken !== void 0 && customToken[oldTokenKey] || customToken !== null && customToken !== void 0 && customToken[newTokenKey]) {
        var _customToken$newToken;
        (_customToken$newToken = customToken[newTokenKey]) !== null && _customToken$newToken !== void 0 ? _customToken$newToken : customToken[newTokenKey] = customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey];
      }
    });
  }
  var mergedToken = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, defaultToken), customToken);

  // Remove same value as global token to minimize size
  Object.keys(mergedToken).forEach(function (key) {
    if (mergedToken[key] === token[key]) {
      delete mergedToken[key];
    }
  });
  return mergedToken;
}
/* harmony default export */ var util_getComponentToken = (getComponentToken);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs-utils/es/util/statistic.js


var enableStatistic =  false || typeof CSSINJS_STATISTIC !== 'undefined';
var recording = true;

/**
 * This function will do as `Object.assign` in production. But will use Object.defineProperty:get to
 * pass all value access in development. To support statistic field usage with alias token.
 */
function merge() {
  for (var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++) {
    objs[_key] = arguments[_key];
  }
  /* istanbul ignore next */
  if (!enableStatistic) {
    return Object.assign.apply(Object, [{}].concat(objs));
  }
  recording = false;
  var ret = {};
  objs.forEach(function (obj) {
    if ((0,esm_typeof/* default */.Z)(obj) !== 'object') {
      return;
    }
    var keys = Object.keys(obj);
    keys.forEach(function (key) {
      Object.defineProperty(ret, key, {
        configurable: true,
        enumerable: true,
        get: function get() {
          return obj[key];
        }
      });
    });
  });
  recording = true;
  return ret;
}

/** @internal Internal Usage. Not use in your production. */
var statistic = {};

/** @internal Internal Usage. Not use in your production. */
var _statistic_build_ = {};

/* istanbul ignore next */
function noop() {}

/** Statistic token usage case. Should use `merge` function if you do not want spread record. */
var statisticToken = function statisticToken(token) {
  var tokenKeys;
  var proxy = token;
  var flush = noop;
  if (enableStatistic && typeof Proxy !== 'undefined') {
    tokenKeys = new Set();
    proxy = new Proxy(token, {
      get: function get(obj, prop) {
        if (recording) {
          var _tokenKeys;
          (_tokenKeys = tokenKeys) === null || _tokenKeys === void 0 || _tokenKeys.add(prop);
        }
        return obj[prop];
      }
    });
    flush = function flush(componentName, componentToken) {
      var _statistic$componentN;
      statistic[componentName] = {
        global: Array.from(tokenKeys),
        component: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, (_statistic$componentN = statistic[componentName]) === null || _statistic$componentN === void 0 ? void 0 : _statistic$componentN.component), componentToken)
      };
    };
  }
  return {
    token: proxy,
    keys: tokenKeys,
    flush: flush
  };
};
/* harmony default export */ var util_statistic = (statisticToken);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs-utils/es/util/getDefaultComponentToken.js

function getDefaultComponentToken(component, token, getDefaultToken) {
  if (typeof getDefaultToken === 'function') {
    var _token$component;
    return getDefaultToken(merge(token, (_token$component = token[component]) !== null && _token$component !== void 0 ? _token$component : {}));
  }
  return getDefaultToken !== null && getDefaultToken !== void 0 ? getDefaultToken : {};
}
/* harmony default export */ var util_getDefaultComponentToken = (getDefaultComponentToken);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs-utils/es/util/maxmin.js

function genMaxMin(type) {
  if (type === 'js') {
    return {
      max: Math.max,
      min: Math.min
    };
  }
  return {
    max: function max() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return "max(".concat(args.map(function (value) {
        return (0,es/* unit */.bf)(value);
      }).join(','), ")");
    },
    min: function min() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return "min(".concat(args.map(function (value) {
        return (0,es/* unit */.bf)(value);
      }).join(','), ")");
    }
  };
}
/* harmony default export */ var maxmin = (genMaxMin);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs-utils/es/_util/hooks/useUniqueMemo.js





var BEAT_LIMIT = 1000 * 60 * 10;

/**
 * A helper class to map keys to values.
 * It supports both primitive keys and object keys.
 */
var ArrayKeyMap = /*#__PURE__*/function () {
  function ArrayKeyMap() {
    (0,classCallCheck/* default */.Z)(this, ArrayKeyMap);
    (0,defineProperty/* default */.Z)(this, "map", new Map());
    // Use WeakMap to avoid memory leak
    (0,defineProperty/* default */.Z)(this, "objectIDMap", new WeakMap());
    (0,defineProperty/* default */.Z)(this, "nextID", 0);
    (0,defineProperty/* default */.Z)(this, "lastAccessBeat", new Map());
    // We will clean up the cache when reach the limit
    (0,defineProperty/* default */.Z)(this, "accessBeat", 0);
  }
  (0,createClass/* default */.Z)(ArrayKeyMap, [{
    key: "set",
    value: function set(keys, value) {
      // New set will trigger clear
      this.clear();

      // Set logic
      var compositeKey = this.getCompositeKey(keys);
      this.map.set(compositeKey, value);
      this.lastAccessBeat.set(compositeKey, Date.now());
    }
  }, {
    key: "get",
    value: function get(keys) {
      var compositeKey = this.getCompositeKey(keys);
      var cache = this.map.get(compositeKey);
      this.lastAccessBeat.set(compositeKey, Date.now());
      this.accessBeat += 1;
      return cache;
    }
  }, {
    key: "getCompositeKey",
    value: function getCompositeKey(keys) {
      var _this = this;
      var ids = keys.map(function (key) {
        if (key && (0,esm_typeof/* default */.Z)(key) === 'object') {
          return "obj_".concat(_this.getObjectID(key));
        }
        return "".concat((0,esm_typeof/* default */.Z)(key), "_").concat(key);
      });
      return ids.join('|');
    }
  }, {
    key: "getObjectID",
    value: function getObjectID(obj) {
      if (this.objectIDMap.has(obj)) {
        return this.objectIDMap.get(obj);
      }
      var id = this.nextID;
      this.objectIDMap.set(obj, id);
      this.nextID += 1;
      return id;
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;
      if (this.accessBeat > 10000) {
        var now = Date.now();
        this.lastAccessBeat.forEach(function (beat, key) {
          if (now - beat > BEAT_LIMIT) {
            _this2.map.delete(key);
            _this2.lastAccessBeat.delete(key);
          }
        });
        this.accessBeat = 0;
      }
    }
  }]);
  return ArrayKeyMap;
}();
var uniqueMap = new ArrayKeyMap();

/**
 * Like `useMemo`, but this hook result will be shared across all instances.
 */
function useUniqueMemo(memoFn, deps) {
  return react.useMemo(function () {
    var cachedValue = uniqueMap.get(deps);
    if (cachedValue) {
      return cachedValue;
    }
    var newValue = memoFn();
    uniqueMap.set(deps, newValue);
    return newValue;
  }, deps);
}
/* harmony default export */ var hooks_useUniqueMemo = (useUniqueMemo);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs-utils/es/hooks/useCSP.js
/**
 * Provide a default hook since not everyone needs to config this.
 */
var useDefaultCSP = function useDefaultCSP() {
  return {};
};
/* harmony default export */ var hooks_useCSP = (useDefaultCSP);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs-utils/es/util/genStyleUtils.js














function genStyleUtils(config) {
  // Dependency inversion for preparing basic config.
  var _config$useCSP = config.useCSP,
    useCSP = _config$useCSP === void 0 ? hooks_useCSP : _config$useCSP,
    useToken = config.useToken,
    usePrefix = config.usePrefix,
    getResetStyles = config.getResetStyles,
    getCommonStyle = config.getCommonStyle,
    getCompUnitless = config.getCompUnitless;
  function genStyleHooks(component, styleFn, getDefaultToken, options) {
    var componentName = Array.isArray(component) ? component[0] : component;
    function prefixToken(key) {
      return "".concat(String(componentName)).concat(key.slice(0, 1).toUpperCase()).concat(key.slice(1));
    }

    // Fill unitless
    var originUnitless = (options === null || options === void 0 ? void 0 : options.unitless) || {};
    var originCompUnitless = typeof getCompUnitless === 'function' ? getCompUnitless(component) : {};
    var compUnitless = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, originCompUnitless), {}, (0,defineProperty/* default */.Z)({}, prefixToken('zIndexPopup'), true));
    Object.keys(originUnitless).forEach(function (key) {
      compUnitless[prefixToken(key)] = originUnitless[key];
    });

    // Options
    var mergedOptions = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, options), {}, {
      unitless: compUnitless,
      prefixToken: prefixToken
    });

    // Hooks
    var useStyle = genComponentStyleHook(component, styleFn, getDefaultToken, mergedOptions);
    var useCSSVar = genCSSVarRegister(componentName, getDefaultToken, mergedOptions);
    return function (prefixCls) {
      var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
      var _useStyle = useStyle(prefixCls, rootCls),
        _useStyle2 = (0,slicedToArray/* default */.Z)(_useStyle, 2),
        hashId = _useStyle2[1];
      var _useCSSVar = useCSSVar(rootCls),
        _useCSSVar2 = (0,slicedToArray/* default */.Z)(_useCSSVar, 2),
        wrapCSSVar = _useCSSVar2[0],
        cssVarCls = _useCSSVar2[1];
      return [wrapCSSVar, hashId, cssVarCls];
    };
  }
  function genCSSVarRegister(component, getDefaultToken, options) {
    var compUnitless = options.unitless,
      _options$injectStyle = options.injectStyle,
      injectStyle = _options$injectStyle === void 0 ? true : _options$injectStyle,
      prefixToken = options.prefixToken,
      ignore = options.ignore;
    var CSSVarRegister = function CSSVarRegister(_ref) {
      var rootCls = _ref.rootCls,
        _ref$cssVar = _ref.cssVar,
        cssVar = _ref$cssVar === void 0 ? {} : _ref$cssVar;
      var _useToken = useToken(),
        realToken = _useToken.realToken;
      (0,es/* useCSSVarRegister */.CI)({
        path: [component],
        prefix: cssVar.prefix,
        key: cssVar.key,
        unitless: compUnitless,
        ignore: ignore,
        token: realToken,
        scope: rootCls
      }, function () {
        var defaultToken = util_getDefaultComponentToken(component, realToken, getDefaultToken);
        var componentToken = util_getComponentToken(component, realToken, defaultToken, {
          deprecatedTokens: options === null || options === void 0 ? void 0 : options.deprecatedTokens
        });
        Object.keys(defaultToken).forEach(function (key) {
          componentToken[prefixToken(key)] = componentToken[key];
          delete componentToken[key];
        });
        return componentToken;
      });
      return null;
    };
    var useCSSVar = function useCSSVar(rootCls) {
      var _useToken2 = useToken(),
        cssVar = _useToken2.cssVar;
      return [function (node) {
        return injectStyle && cssVar ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(CSSVarRegister, {
          rootCls: rootCls,
          cssVar: cssVar,
          component: component
        }), node) : node;
      }, cssVar === null || cssVar === void 0 ? void 0 : cssVar.key];
    };
    return useCSSVar;
  }
  function genComponentStyleHook(componentName, styleFn, getDefaultToken) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var cells = Array.isArray(componentName) ? componentName : [componentName, componentName];
    var _cells = (0,slicedToArray/* default */.Z)(cells, 1),
      component = _cells[0];
    var concatComponent = cells.join('-');
    var mergedLayer = config.layer || {
      name: 'antd'
    };

    // Return new style hook
    return function (prefixCls) {
      var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
      var _useToken3 = useToken(),
        theme = _useToken3.theme,
        realToken = _useToken3.realToken,
        hashId = _useToken3.hashId,
        token = _useToken3.token,
        cssVar = _useToken3.cssVar;
      var _usePrefix = usePrefix(),
        rootPrefixCls = _usePrefix.rootPrefixCls,
        iconPrefixCls = _usePrefix.iconPrefixCls;
      var csp = useCSP();
      var type = cssVar ? 'css' : 'js';

      // Use unique memo to share the result across all instances
      var calc = hooks_useUniqueMemo(function () {
        var unitlessCssVar = new Set();
        if (cssVar) {
          Object.keys(options.unitless || {}).forEach(function (key) {
            // Some component proxy the AliasToken (e.g. Image) and some not (e.g. Modal)
            // We should both pass in `unitlessCssVar` to make sure the CSSVar can be unitless.
            unitlessCssVar.add((0,es/* token2CSSVar */.ks)(key, cssVar.prefix));
            unitlessCssVar.add((0,es/* token2CSSVar */.ks)(key, util_getCompVarPrefix(component, cssVar.prefix)));
          });
        }
        return util_calc(type, unitlessCssVar);
      }, [type, component, cssVar === null || cssVar === void 0 ? void 0 : cssVar.prefix]);
      var _genMaxMin = maxmin(type),
        max = _genMaxMin.max,
        min = _genMaxMin.min;

      // Shared config
      var sharedConfig = {
        theme: theme,
        token: token,
        hashId: hashId,
        nonce: function nonce() {
          return csp.nonce;
        },
        clientOnly: options.clientOnly,
        layer: mergedLayer,
        // antd is always at top of styles
        order: options.order || -999
      };

      // This if statement is safe, as it will only be used if the generator has the function. It's not dynamic.
      if (typeof getResetStyles === 'function') {
        // Generate style for all need reset tags.
        (0,es/* useStyleRegister */.xy)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, sharedConfig), {}, {
          clientOnly: false,
          path: ['Shared', rootPrefixCls]
        }), function () {
          return getResetStyles(token, {
            prefix: {
              rootPrefixCls: rootPrefixCls,
              iconPrefixCls: iconPrefixCls
            },
            csp: csp
          });
        });
      }
      var wrapSSR = (0,es/* useStyleRegister */.xy)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, sharedConfig), {}, {
        path: [concatComponent, prefixCls, iconPrefixCls]
      }), function () {
        if (options.injectStyle === false) {
          return [];
        }
        var _statisticToken = util_statistic(token),
          proxyToken = _statisticToken.token,
          flush = _statisticToken.flush;
        var defaultComponentToken = util_getDefaultComponentToken(component, realToken, getDefaultToken);
        var componentCls = ".".concat(prefixCls);
        var componentToken = util_getComponentToken(component, realToken, defaultComponentToken, {
          deprecatedTokens: options.deprecatedTokens
        });
        if (cssVar && defaultComponentToken && (0,esm_typeof/* default */.Z)(defaultComponentToken) === 'object') {
          Object.keys(defaultComponentToken).forEach(function (key) {
            defaultComponentToken[key] = "var(".concat((0,es/* token2CSSVar */.ks)(key, util_getCompVarPrefix(component, cssVar.prefix)), ")");
          });
        }
        var mergedToken = merge(proxyToken, {
          componentCls: componentCls,
          prefixCls: prefixCls,
          iconCls: ".".concat(iconPrefixCls),
          antCls: ".".concat(rootPrefixCls),
          calc: calc,
          // @ts-ignore
          max: max,
          // @ts-ignore
          min: min
        }, cssVar ? defaultComponentToken : componentToken);
        var styleInterpolation = styleFn(mergedToken, {
          hashId: hashId,
          prefixCls: prefixCls,
          rootPrefixCls: rootPrefixCls,
          iconPrefixCls: iconPrefixCls
        });
        flush(component, componentToken);
        var commonStyle = typeof getCommonStyle === 'function' ? getCommonStyle(mergedToken, prefixCls, rootCls, options.resetFont) : null;
        return [options.resetStyle === false ? null : commonStyle, styleInterpolation];
      });
      return [wrapSSR, hashId];
    };
  }
  function genSubStyleComponent(componentName, styleFn, getDefaultToken) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var useStyle = genComponentStyleHook(componentName, styleFn, getDefaultToken, (0,objectSpread2/* default */.Z)({
      resetStyle: false,
      // Sub Style should default after root one
      order: -998
    }, options));
    var StyledComponent = function StyledComponent(_ref2) {
      var prefixCls = _ref2.prefixCls,
        _ref2$rootCls = _ref2.rootCls,
        rootCls = _ref2$rootCls === void 0 ? prefixCls : _ref2$rootCls;
      useStyle(prefixCls, rootCls);
      return null;
    };
    if (false) {}
    return StyledComponent;
  }
  return {
    genStyleHooks: genStyleHooks,
    genSubStyleComponent: genSubStyleComponent,
    genComponentStyleHook: genComponentStyleHook
  };
}
/* harmony default export */ var util_genStyleUtils = (genStyleUtils);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs-utils/es/index.js




/***/ }),

/***/ 68946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E4": function() { return /* reexport */ Keyframes; },
  "uP": function() { return /* reexport */ es_StyleContext; },
  "V9": function() { return /* reexport */ StyleProvider; },
  "jG": function() { return /* reexport */ createTheme; },
  "t2": function() { return /* reexport */ getComputedToken; },
  "ks": function() { return /* reexport */ token2CSSVar; },
  "bf": function() { return /* reexport */ util_unit; },
  "CI": function() { return /* reexport */ hooks_useCSSVarRegister; },
  "fp": function() { return /* reexport */ useCacheToken; },
  "xy": function() { return /* reexport */ useStyleRegister; }
});

// UNUSED EXPORTS: NaNLinter, Theme, _experimental, createCache, extractStyle, genCalc, legacyLogicalPropertiesTransformer, legacyNotSelectorLinter, logicalPropertiesLinter, parentSelectorLinter, px2remTransformer

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/node_modules/@emotion/hash/dist/hash.browser.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
    i = 0,
    len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array

  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.

  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}
/* harmony default export */ var hash_browser_esm = (murmur2);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/dynamicCSS.js
var dynamicCSS = __webpack_require__(6779);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMemo.js
var useMemo = __webpack_require__(99834);
// EXTERNAL MODULE: ./node_modules/rc-util/es/isEqual.js
var isEqual = __webpack_require__(55159);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6223);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(79427);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/Cache.js



// [times, realValue]

var SPLIT = '%';

/** Connect key with `SPLIT` */
function pathKey(keys) {
  return keys.join(SPLIT);
}
var Entity = /*#__PURE__*/function () {
  function Entity(instanceId) {
    (0,classCallCheck/* default */.Z)(this, Entity);
    (0,defineProperty/* default */.Z)(this, "instanceId", void 0);
    /** @private Internal cache map. Do not access this directly */
    (0,defineProperty/* default */.Z)(this, "cache", new Map());
    (0,defineProperty/* default */.Z)(this, "extracted", new Set());
    this.instanceId = instanceId;
  }
  (0,createClass/* default */.Z)(Entity, [{
    key: "get",
    value: function get(keys) {
      return this.opGet(pathKey(keys));
    }

    /** A fast get cache with `get` concat. */
  }, {
    key: "opGet",
    value: function opGet(keyPathStr) {
      return this.cache.get(keyPathStr) || null;
    }
  }, {
    key: "update",
    value: function update(keys, valueFn) {
      return this.opUpdate(pathKey(keys), valueFn);
    }

    /** A fast get cache with `get` concat. */
  }, {
    key: "opUpdate",
    value: function opUpdate(keyPathStr, valueFn) {
      var prevValue = this.cache.get(keyPathStr);
      var nextValue = valueFn(prevValue);
      if (nextValue === null) {
        this.cache.delete(keyPathStr);
      } else {
        this.cache.set(keyPathStr, nextValue);
      }
    }
  }]);
  return Entity;
}();
/* harmony default export */ var Cache = (Entity);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/StyleContext.js


var _excluded = ["children"];




var ATTR_TOKEN = 'data-token-hash';
var ATTR_MARK = 'data-css-hash';
var ATTR_CACHE_PATH = 'data-cache-path';

// Mark css-in-js instance in style element
var CSS_IN_JS_INSTANCE = '__cssinjs_instance__';
function createCache() {
  var cssinjsInstanceId = Math.random().toString(12).slice(2);

  // Tricky SSR: Move all inline style to the head.
  // PS: We do not recommend tricky mode.
  if (typeof document !== 'undefined' && document.head && document.body) {
    var styles = document.body.querySelectorAll("style[".concat(ATTR_MARK, "]")) || [];
    var firstChild = document.head.firstChild;
    Array.from(styles).forEach(function (style) {
      style[CSS_IN_JS_INSTANCE] = style[CSS_IN_JS_INSTANCE] || cssinjsInstanceId;

      // Not force move if no head
      if (style[CSS_IN_JS_INSTANCE] === cssinjsInstanceId) {
        document.head.insertBefore(style, firstChild);
      }
    });

    // Deduplicate of moved styles
    var styleHash = {};
    Array.from(document.querySelectorAll("style[".concat(ATTR_MARK, "]"))).forEach(function (style) {
      var hash = style.getAttribute(ATTR_MARK);
      if (styleHash[hash]) {
        if (style[CSS_IN_JS_INSTANCE] === cssinjsInstanceId) {
          var _style$parentNode;
          (_style$parentNode = style.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style);
        }
      } else {
        styleHash[hash] = true;
      }
    });
  }
  return new Cache(cssinjsInstanceId);
}
var StyleContext = /*#__PURE__*/react.createContext({
  hashPriority: 'low',
  cache: createCache(),
  defaultCache: true
});
var StyleProvider = function StyleProvider(props) {
  var children = props.children,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded);
  var parentContext = react.useContext(StyleContext);
  var context = (0,useMemo/* default */.Z)(function () {
    var mergedContext = (0,objectSpread2/* default */.Z)({}, parentContext);
    Object.keys(restProps).forEach(function (key) {
      var value = restProps[key];
      if (restProps[key] !== undefined) {
        mergedContext[key] = value;
      }
    });
    var cache = restProps.cache;
    mergedContext.cache = mergedContext.cache || createCache();
    mergedContext.defaultCache = !cache && parentContext.defaultCache;
    return mergedContext;
  }, [parentContext, restProps], function (prev, next) {
    return !(0,isEqual/* default */.Z)(prev[0], next[0], true) || !(0,isEqual/* default */.Z)(prev[1], next[1], true);
  });
  return /*#__PURE__*/react.createElement(StyleContext.Provider, {
    value: context
  }, children);
};
/* harmony default export */ var es_StyleContext = (StyleContext);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/canUseDom.js
var canUseDom = __webpack_require__(55304);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(88569);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(34766);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js
var createSuper = __webpack_require__(56302);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/theme/calc/calculator.js


var AbstractCalculator = /*#__PURE__*/(0,createClass/* default */.Z)(function AbstractCalculator() {
  (0,classCallCheck/* default */.Z)(this, AbstractCalculator);
});
/* harmony default export */ var calculator = (AbstractCalculator);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/theme/calc/CSSCalculator.js








var CALC_UNIT = 'CALC_UNIT';
var regexp = new RegExp(CALC_UNIT, 'g');
function unit(value) {
  if (typeof value === 'number') {
    return "".concat(value).concat(CALC_UNIT);
  }
  return value;
}
var CSSCalculator_CSSCalculator = /*#__PURE__*/function (_AbstractCalculator) {
  (0,inherits/* default */.Z)(CSSCalculator, _AbstractCalculator);
  var _super = (0,createSuper/* default */.Z)(CSSCalculator);
  function CSSCalculator(num, unitlessCssVar) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, CSSCalculator);
    _this = _super.call(this);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "result", '');
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "unitlessCssVar", void 0);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "lowPriority", void 0);
    var numType = (0,esm_typeof/* default */.Z)(num);
    _this.unitlessCssVar = unitlessCssVar;
    if (num instanceof CSSCalculator) {
      _this.result = "(".concat(num.result, ")");
    } else if (numType === 'number') {
      _this.result = unit(num);
    } else if (numType === 'string') {
      _this.result = num;
    }
    return _this;
  }
  (0,createClass/* default */.Z)(CSSCalculator, [{
    key: "add",
    value: function add(num) {
      if (num instanceof CSSCalculator) {
        this.result = "".concat(this.result, " + ").concat(num.getResult());
      } else if (typeof num === 'number' || typeof num === 'string') {
        this.result = "".concat(this.result, " + ").concat(unit(num));
      }
      this.lowPriority = true;
      return this;
    }
  }, {
    key: "sub",
    value: function sub(num) {
      if (num instanceof CSSCalculator) {
        this.result = "".concat(this.result, " - ").concat(num.getResult());
      } else if (typeof num === 'number' || typeof num === 'string') {
        this.result = "".concat(this.result, " - ").concat(unit(num));
      }
      this.lowPriority = true;
      return this;
    }
  }, {
    key: "mul",
    value: function mul(num) {
      if (this.lowPriority) {
        this.result = "(".concat(this.result, ")");
      }
      if (num instanceof CSSCalculator) {
        this.result = "".concat(this.result, " * ").concat(num.getResult(true));
      } else if (typeof num === 'number' || typeof num === 'string') {
        this.result = "".concat(this.result, " * ").concat(num);
      }
      this.lowPriority = false;
      return this;
    }
  }, {
    key: "div",
    value: function div(num) {
      if (this.lowPriority) {
        this.result = "(".concat(this.result, ")");
      }
      if (num instanceof CSSCalculator) {
        this.result = "".concat(this.result, " / ").concat(num.getResult(true));
      } else if (typeof num === 'number' || typeof num === 'string') {
        this.result = "".concat(this.result, " / ").concat(num);
      }
      this.lowPriority = false;
      return this;
    }
  }, {
    key: "getResult",
    value: function getResult(force) {
      return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
    }
  }, {
    key: "equal",
    value: function equal(options) {
      var _this2 = this;
      var _ref = options || {},
        cssUnit = _ref.unit;
      var mergedUnit = true;
      if (typeof cssUnit === 'boolean') {
        mergedUnit = cssUnit;
      } else if (Array.from(this.unitlessCssVar).some(function (cssVar) {
        return _this2.result.includes(cssVar);
      })) {
        mergedUnit = false;
      }
      this.result = this.result.replace(regexp, mergedUnit ? 'px' : '');
      if (typeof this.lowPriority !== 'undefined') {
        return "calc(".concat(this.result, ")");
      }
      return this.result;
    }
  }]);
  return CSSCalculator;
}(calculator);

;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/theme/calc/index.js


var genCalc = function genCalc(type, unitlessCssVar) {
  var Calculator = type === 'css' ? CSSCalculator : NumCalculator;
  return function (num) {
    return new Calculator(num, unitlessCssVar);
  };
};
/* harmony default export */ var calc = ((/* unused pure expression or super */ null && (genCalc)));
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/theme/ThemeCache.js




// ================================== Cache ==================================

function sameDerivativeOption(left, right) {
  if (left.length !== right.length) {
    return false;
  }
  for (var i = 0; i < left.length; i++) {
    if (left[i] !== right[i]) {
      return false;
    }
  }
  return true;
}
var ThemeCache = /*#__PURE__*/function () {
  function ThemeCache() {
    (0,classCallCheck/* default */.Z)(this, ThemeCache);
    (0,defineProperty/* default */.Z)(this, "cache", void 0);
    (0,defineProperty/* default */.Z)(this, "keys", void 0);
    (0,defineProperty/* default */.Z)(this, "cacheCallTimes", void 0);
    this.cache = new Map();
    this.keys = [];
    this.cacheCallTimes = 0;
  }
  (0,createClass/* default */.Z)(ThemeCache, [{
    key: "size",
    value: function size() {
      return this.keys.length;
    }
  }, {
    key: "internalGet",
    value: function internalGet(derivativeOption) {
      var _cache2, _cache3;
      var updateCallTimes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var cache = {
        map: this.cache
      };
      derivativeOption.forEach(function (derivative) {
        if (!cache) {
          cache = undefined;
        } else {
          var _cache;
          cache = (_cache = cache) === null || _cache === void 0 || (_cache = _cache.map) === null || _cache === void 0 ? void 0 : _cache.get(derivative);
        }
      });
      if ((_cache2 = cache) !== null && _cache2 !== void 0 && _cache2.value && updateCallTimes) {
        cache.value[1] = this.cacheCallTimes++;
      }
      return (_cache3 = cache) === null || _cache3 === void 0 ? void 0 : _cache3.value;
    }
  }, {
    key: "get",
    value: function get(derivativeOption) {
      var _this$internalGet;
      return (_this$internalGet = this.internalGet(derivativeOption, true)) === null || _this$internalGet === void 0 ? void 0 : _this$internalGet[0];
    }
  }, {
    key: "has",
    value: function has(derivativeOption) {
      return !!this.internalGet(derivativeOption);
    }
  }, {
    key: "set",
    value: function set(derivativeOption, value) {
      var _this = this;
      // New cache
      if (!this.has(derivativeOption)) {
        if (this.size() + 1 > ThemeCache.MAX_CACHE_SIZE + ThemeCache.MAX_CACHE_OFFSET) {
          var _this$keys$reduce = this.keys.reduce(function (result, key) {
              var _result = (0,slicedToArray/* default */.Z)(result, 2),
                callTimes = _result[1];
              if (_this.internalGet(key)[1] < callTimes) {
                return [key, _this.internalGet(key)[1]];
              }
              return result;
            }, [this.keys[0], this.cacheCallTimes]),
            _this$keys$reduce2 = (0,slicedToArray/* default */.Z)(_this$keys$reduce, 1),
            targetKey = _this$keys$reduce2[0];
          this.delete(targetKey);
        }
        this.keys.push(derivativeOption);
      }
      var cache = this.cache;
      derivativeOption.forEach(function (derivative, index) {
        if (index === derivativeOption.length - 1) {
          cache.set(derivative, {
            value: [value, _this.cacheCallTimes++]
          });
        } else {
          var cacheValue = cache.get(derivative);
          if (!cacheValue) {
            cache.set(derivative, {
              map: new Map()
            });
          } else if (!cacheValue.map) {
            cacheValue.map = new Map();
          }
          cache = cache.get(derivative).map;
        }
      });
    }
  }, {
    key: "deleteByPath",
    value: function deleteByPath(currentCache, derivatives) {
      var cache = currentCache.get(derivatives[0]);
      if (derivatives.length === 1) {
        var _cache$value;
        if (!cache.map) {
          currentCache.delete(derivatives[0]);
        } else {
          currentCache.set(derivatives[0], {
            map: cache.map
          });
        }
        return (_cache$value = cache.value) === null || _cache$value === void 0 ? void 0 : _cache$value[0];
      }
      var result = this.deleteByPath(cache.map, derivatives.slice(1));
      if ((!cache.map || cache.map.size === 0) && !cache.value) {
        currentCache.delete(derivatives[0]);
      }
      return result;
    }
  }, {
    key: "delete",
    value: function _delete(derivativeOption) {
      // If cache exists
      if (this.has(derivativeOption)) {
        this.keys = this.keys.filter(function (item) {
          return !sameDerivativeOption(item, derivativeOption);
        });
        return this.deleteByPath(this.cache, derivativeOption);
      }
      return undefined;
    }
  }]);
  return ThemeCache;
}();
(0,defineProperty/* default */.Z)(ThemeCache, "MAX_CACHE_SIZE", 20);
(0,defineProperty/* default */.Z)(ThemeCache, "MAX_CACHE_OFFSET", 5);

// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(13764);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/theme/Theme.js




var uuid = 0;

/**
 * Theme with algorithms to derive tokens from design tokens.
 * Use `createTheme` first which will help to manage the theme instance cache.
 */
var Theme = /*#__PURE__*/function () {
  function Theme(derivatives) {
    (0,classCallCheck/* default */.Z)(this, Theme);
    (0,defineProperty/* default */.Z)(this, "derivatives", void 0);
    (0,defineProperty/* default */.Z)(this, "id", void 0);
    this.derivatives = Array.isArray(derivatives) ? derivatives : [derivatives];
    this.id = uuid;
    if (derivatives.length === 0) {
      (0,warning/* warning */.Kp)(derivatives.length > 0, '[Ant Design CSS-in-JS] Theme should have at least one derivative function.');
    }
    uuid += 1;
  }
  (0,createClass/* default */.Z)(Theme, [{
    key: "getDerivativeToken",
    value: function getDerivativeToken(token) {
      return this.derivatives.reduce(function (result, derivative) {
        return derivative(token, result);
      }, undefined);
    }
  }]);
  return Theme;
}();

;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/theme/createTheme.js


var cacheThemes = new ThemeCache();

/**
 * Same as new Theme, but will always return same one if `derivative` not changed.
 */
function createTheme(derivatives) {
  var derivativeArr = Array.isArray(derivatives) ? derivatives : [derivatives];
  // Create new theme if not exist
  if (!cacheThemes.has(derivativeArr)) {
    cacheThemes.set(derivativeArr, new Theme(derivativeArr));
  }

  // Get theme from cache and return
  return cacheThemes.get(derivativeArr);
}
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/theme/index.js




;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/util/index.js









// Create a cache for memo concat

var resultCache = new WeakMap();
var RESULT_VALUE = {};
function memoResult(callback, deps) {
  var current = resultCache;
  for (var i = 0; i < deps.length; i += 1) {
    var dep = deps[i];
    if (!current.has(dep)) {
      current.set(dep, new WeakMap());
    }
    current = current.get(dep);
  }
  if (!current.has(RESULT_VALUE)) {
    current.set(RESULT_VALUE, callback());
  }
  return current.get(RESULT_VALUE);
}

// Create a cache here to avoid always loop generate
var flattenTokenCache = new WeakMap();

/**
 * Flatten token to string, this will auto cache the result when token not change
 */
function flattenToken(token) {
  var str = flattenTokenCache.get(token) || '';
  if (!str) {
    Object.keys(token).forEach(function (key) {
      var value = token[key];
      str += key;
      if (value instanceof Theme) {
        str += value.id;
      } else if (value && (0,esm_typeof/* default */.Z)(value) === 'object') {
        str += flattenToken(value);
      } else {
        str += value;
      }
    });

    // https://github.com/ant-design/ant-design/issues/48386
    // Should hash the string to avoid style tag name too long
    str = hash_browser_esm(str);

    // Put in cache
    flattenTokenCache.set(token, str);
  }
  return str;
}

/**
 * Convert derivative token to key string
 */
function token2key(token, salt) {
  return hash_browser_esm("".concat(salt, "_").concat(flattenToken(token)));
}
var randomSelectorKey = "random-".concat(Date.now(), "-").concat(Math.random()).replace(/\./g, '');

// Magic `content` for detect selector support
var checkContent = '_bAmBoO_';
function supportSelector(styleStr, handleElement, supportCheck) {
  if ((0,canUseDom/* default */.Z)()) {
    var _getComputedStyle$con, _ele$parentNode;
    (0,dynamicCSS/* updateCSS */.hq)(styleStr, randomSelectorKey);
    var _ele = document.createElement('div');
    _ele.style.position = 'fixed';
    _ele.style.left = '0';
    _ele.style.top = '0';
    handleElement === null || handleElement === void 0 || handleElement(_ele);
    document.body.appendChild(_ele);
    if (false) {}
    var support = supportCheck ? supportCheck(_ele) : (_getComputedStyle$con = getComputedStyle(_ele).content) === null || _getComputedStyle$con === void 0 ? void 0 : _getComputedStyle$con.includes(checkContent);
    (_ele$parentNode = _ele.parentNode) === null || _ele$parentNode === void 0 || _ele$parentNode.removeChild(_ele);
    (0,dynamicCSS/* removeCSS */.jL)(randomSelectorKey);
    return support;
  }
  return false;
}
var canLayer = (/* unused pure expression or super */ null && (undefined));
function supportLayer() {
  if (canLayer === undefined) {
    canLayer = supportSelector("@layer ".concat(randomSelectorKey, " { .").concat(randomSelectorKey, " { content: \"").concat(checkContent, "\"!important; } }"), function (ele) {
      ele.className = randomSelectorKey;
    });
  }
  return canLayer;
}
var canWhere = undefined;
function supportWhere() {
  if (canWhere === undefined) {
    canWhere = supportSelector(":where(.".concat(randomSelectorKey, ") { content: \"").concat(checkContent, "\"!important; }"), function (ele) {
      ele.className = randomSelectorKey;
    });
  }
  return canWhere;
}
var canLogic = undefined;
function supportLogicProps() {
  if (canLogic === undefined) {
    canLogic = supportSelector(".".concat(randomSelectorKey, " { inset-block: 93px !important; }"), function (ele) {
      ele.className = randomSelectorKey;
    }, function (ele) {
      return getComputedStyle(ele).bottom === '93px';
    });
  }
  return canLogic;
}
var isClientSide = (0,canUseDom/* default */.Z)();
function util_unit(num) {
  if (typeof num === 'number') {
    return "".concat(num, "px");
  }
  return num;
}
function util_toStyleStr(style, tokenKey, styleId) {
  var customizeAttrs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var plain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  if (plain) {
    return style;
  }
  var attrs = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, customizeAttrs), {}, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, ATTR_TOKEN, tokenKey), ATTR_MARK, styleId));
  var attrStr = Object.keys(attrs).map(function (attr) {
    var val = attrs[attr];
    return val ? "".concat(attr, "=\"").concat(val, "\"") : null;
  }).filter(function (v) {
    return v;
  }).join(' ');
  return "<style ".concat(attrStr, ">").concat(style, "</style>");
}
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/util/css-variables.js

var token2CSSVar = function token2CSSVar(token) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return "--".concat(prefix ? "".concat(prefix, "-") : '').concat(token).replace(/([a-z0-9])([A-Z])/g, '$1-$2').replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, '$1-$2').replace(/([a-z])([A-Z0-9])/g, '$1-$2').toLowerCase();
};
var serializeCSSVar = function serializeCSSVar(cssVars, hashId, options) {
  if (!Object.keys(cssVars).length) {
    return '';
  }
  return ".".concat(hashId).concat(options !== null && options !== void 0 && options.scope ? ".".concat(options.scope) : '', "{").concat(Object.entries(cssVars).map(function (_ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return "".concat(key, ":").concat(value, ";");
  }).join(''), "}");
};
var transformToken = function transformToken(token, themeKey, config) {
  var cssVars = {};
  var result = {};
  Object.entries(token).forEach(function (_ref3) {
    var _config$preserve, _config$ignore;
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    if (config !== null && config !== void 0 && (_config$preserve = config.preserve) !== null && _config$preserve !== void 0 && _config$preserve[key]) {
      result[key] = value;
    } else if ((typeof value === 'string' || typeof value === 'number') && !(config !== null && config !== void 0 && (_config$ignore = config.ignore) !== null && _config$ignore !== void 0 && _config$ignore[key])) {
      var _config$unitless;
      var cssVar = token2CSSVar(key, config === null || config === void 0 ? void 0 : config.prefix);
      cssVars[cssVar] = typeof value === 'number' && !(config !== null && config !== void 0 && (_config$unitless = config.unitless) !== null && _config$unitless !== void 0 && _config$unitless[key]) ? "".concat(value, "px") : String(value);
      result[key] = "var(".concat(cssVar, ")");
    }
  });
  return [result, serializeCSSVar(cssVars, themeKey, {
    scope: config === null || config === void 0 ? void 0 : config.scope
  })];
};
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useLayoutEffect.js
var useLayoutEffect = __webpack_require__(76963);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/hooks/useCompatibleInsertionEffect.js

// import canUseDom from 'rc-util/lib/Dom/canUseDom';



// We need fully clone React function here
// to avoid webpack warning React 17 do not export `useId`
var fullClone = (0,objectSpread2/* default */.Z)({}, react_namespaceObject);
var useInsertionEffect = fullClone.useInsertionEffect;
/**
 * Polyfill `useInsertionEffect` for React < 18
 * @param renderEffect will be executed in `useMemo`, and do not have callback
 * @param effect will be executed in `useLayoutEffect`
 * @param deps
 */
var useInsertionEffectPolyfill = function useInsertionEffectPolyfill(renderEffect, effect, deps) {
  react.useMemo(renderEffect, deps);
  (0,useLayoutEffect/* default */.Z)(function () {
    return effect(true);
  }, deps);
};

/**
 * Compatible `useInsertionEffect`
 * will use `useInsertionEffect` if React version >= 18,
 * otherwise use `useInsertionEffectPolyfill`.
 */
var useCompatibleInsertionEffect = useInsertionEffect ? function (renderEffect, effect, deps) {
  return useInsertionEffect(function () {
    renderEffect();
    return effect();
  }, deps);
} : useInsertionEffectPolyfill;
/* harmony default export */ var hooks_useCompatibleInsertionEffect = (useCompatibleInsertionEffect);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/hooks/useEffectCleanupRegister.js



var useEffectCleanupRegister_fullClone = (0,objectSpread2/* default */.Z)({}, react_namespaceObject);
var useEffectCleanupRegister_useInsertionEffect = useEffectCleanupRegister_fullClone.useInsertionEffect;

// DO NOT register functions in useEffect cleanup function, or functions that registered will never be called.
var useCleanupRegister = function useCleanupRegister(deps) {
  var effectCleanups = [];
  var cleanupFlag = false;
  function register(fn) {
    if (cleanupFlag) {
      if (false) {}
      return;
    }
    effectCleanups.push(fn);
  }
  react.useEffect(function () {
    // Compatible with strict mode
    cleanupFlag = false;
    return function () {
      cleanupFlag = true;
      if (effectCleanups.length) {
        effectCleanups.forEach(function (fn) {
          return fn();
        });
      }
    };
  }, deps);
  return register;
};
var useRun = function useRun() {
  return function (fn) {
    fn();
  };
};

// Only enable register in React 18
var useEffectCleanupRegister = typeof useEffectCleanupRegister_useInsertionEffect !== 'undefined' ? useCleanupRegister : useRun;
/* harmony default export */ var hooks_useEffectCleanupRegister = (useEffectCleanupRegister);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/hooks/useHMR.js
function useProdHMR() {
  return false;
}
var webpackHMR = false;
function useDevHMR() {
  return webpackHMR;
}
/* harmony default export */ var useHMR = ( true ? useProdHMR : 0);

// Webpack `module.hot.accept` do not support any deps update trigger
// We have to hack handler to force mark as HRM
if (false) { var originWebpackHotUpdate, win; }
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/hooks/useGlobalCache.js








function useGlobalCache(prefix, keyPath, cacheFn, onCacheRemove,
// Add additional effect trigger by `useInsertionEffect`
onCacheEffect) {
  var _React$useContext = react.useContext(es_StyleContext),
    globalCache = _React$useContext.cache;
  var fullPath = [prefix].concat((0,toConsumableArray/* default */.Z)(keyPath));
  var fullPathStr = pathKey(fullPath);
  var register = hooks_useEffectCleanupRegister([fullPathStr]);
  var HMRUpdate = useHMR();
  var buildCache = function buildCache(updater) {
    globalCache.opUpdate(fullPathStr, function (prevCache) {
      var _ref = prevCache || [undefined, undefined],
        _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
        _ref2$ = _ref2[0],
        times = _ref2$ === void 0 ? 0 : _ref2$,
        cache = _ref2[1];

      // HMR should always ignore cache since developer may change it
      var tmpCache = cache;
      if (false) {}
      var mergedCache = tmpCache || cacheFn();
      var data = [times, mergedCache];

      // Call updater if need additional logic
      return updater ? updater(data) : data;
    });
  };

  // Create cache
  react.useMemo(function () {
    buildCache();
  }, /* eslint-disable react-hooks/exhaustive-deps */
  [fullPathStr]
  /* eslint-enable */);
  var cacheEntity = globalCache.opGet(fullPathStr);

  // HMR clean the cache but not trigger `useMemo` again
  // Let's fallback of this
  // ref https://github.com/ant-design/cssinjs/issues/127
  if (false) {}
  var cacheContent = cacheEntity[1];

  // Remove if no need anymore
  hooks_useCompatibleInsertionEffect(function () {
    onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
  }, function (polyfill) {
    // It's bad to call build again in effect.
    // But we have to do this since StrictMode will call effect twice
    // which will clear cache on the first time.
    buildCache(function (_ref3) {
      var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
        times = _ref4[0],
        cache = _ref4[1];
      if (polyfill && times === 0) {
        onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
      }
      return [times + 1, cache];
    });
    return function () {
      globalCache.opUpdate(fullPathStr, function (prevCache) {
        var _ref5 = prevCache || [],
          _ref6 = (0,slicedToArray/* default */.Z)(_ref5, 2),
          _ref6$ = _ref6[0],
          times = _ref6$ === void 0 ? 0 : _ref6$,
          cache = _ref6[1];
        var nextCount = times - 1;
        if (nextCount === 0) {
          // Always remove styles in useEffect callback
          register(function () {
            // With polyfill, registered callback will always be called synchronously
            // But without polyfill, it will be called in effect clean up,
            // And by that time this cache is cleaned up.
            if (polyfill || !globalCache.opGet(fullPathStr)) {
              onCacheRemove === null || onCacheRemove === void 0 || onCacheRemove(cache, false);
            }
          });
          return null;
        }
        return [times - 1, cache];
      });
    };
  }, [fullPathStr]);
  return cacheContent;
}
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/hooks/useCacheToken.js










var EMPTY_OVERRIDE = {};

// Generate different prefix to make user selector break in production env.
// This helps developer not to do style override directly on the hash id.
var hashPrefix =  false ? 0 : 'css';
var tokenKeys = new Map();
function recordCleanToken(tokenKey) {
  tokenKeys.set(tokenKey, (tokenKeys.get(tokenKey) || 0) + 1);
}
function removeStyleTags(key, instanceId) {
  if (typeof document !== 'undefined') {
    var styles = document.querySelectorAll("style[".concat(ATTR_TOKEN, "=\"").concat(key, "\"]"));
    styles.forEach(function (style) {
      if (style[CSS_IN_JS_INSTANCE] === instanceId) {
        var _style$parentNode;
        (_style$parentNode = style.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style);
      }
    });
  }
}
var TOKEN_THRESHOLD = 0;

// Remove will check current keys first
function cleanTokenStyle(tokenKey, instanceId) {
  tokenKeys.set(tokenKey, (tokenKeys.get(tokenKey) || 0) - 1);
  var cleanableKeyList = new Set();
  tokenKeys.forEach(function (value, key) {
    if (value <= 0) cleanableKeyList.add(key);
  });

  // Should keep tokens under threshold for not to insert style too often
  if (tokenKeys.size - cleanableKeyList.size > TOKEN_THRESHOLD) {
    cleanableKeyList.forEach(function (key) {
      removeStyleTags(key, instanceId);
      tokenKeys.delete(key);
    });
  }
}
var getComputedToken = function getComputedToken(originToken, overrideToken, theme, format) {
  var derivativeToken = theme.getDerivativeToken(originToken);

  // Merge with override
  var mergedDerivativeToken = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, derivativeToken), overrideToken);

  // Format if needed
  if (format) {
    mergedDerivativeToken = format(mergedDerivativeToken);
  }
  return mergedDerivativeToken;
};
var TOKEN_PREFIX = 'token';
/**
 * Cache theme derivative token as global shared one
 * @param theme Theme entity
 * @param tokens List of tokens, used for cache. Please do not dynamic generate object directly
 * @param option Additional config
 * @returns Call Theme.getDerivativeToken(tokenObject) to get token
 */
function useCacheToken(theme, tokens) {
  var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _useContext = (0,react.useContext)(es_StyleContext),
    instanceId = _useContext.cache.instanceId,
    container = _useContext.container;
  var _option$salt = option.salt,
    salt = _option$salt === void 0 ? '' : _option$salt,
    _option$override = option.override,
    override = _option$override === void 0 ? EMPTY_OVERRIDE : _option$override,
    formatToken = option.formatToken,
    compute = option.getComputedToken,
    cssVar = option.cssVar;

  // Basic - We do basic cache here
  var mergedToken = memoResult(function () {
    return Object.assign.apply(Object, [{}].concat((0,toConsumableArray/* default */.Z)(tokens)));
  }, tokens);
  var tokenStr = flattenToken(mergedToken);
  var overrideTokenStr = flattenToken(override);
  var cssVarStr = cssVar ? flattenToken(cssVar) : '';
  var cachedToken = useGlobalCache(TOKEN_PREFIX, [salt, theme.id, tokenStr, overrideTokenStr, cssVarStr], function () {
    var _cssVar$key;
    var mergedDerivativeToken = compute ? compute(mergedToken, override, theme) : getComputedToken(mergedToken, override, theme, formatToken);

    // Replace token value with css variables
    var actualToken = (0,objectSpread2/* default */.Z)({}, mergedDerivativeToken);
    var cssVarsStr = '';
    if (!!cssVar) {
      var _transformToken = transformToken(mergedDerivativeToken, cssVar.key, {
        prefix: cssVar.prefix,
        ignore: cssVar.ignore,
        unitless: cssVar.unitless,
        preserve: cssVar.preserve
      });
      var _transformToken2 = (0,slicedToArray/* default */.Z)(_transformToken, 2);
      mergedDerivativeToken = _transformToken2[0];
      cssVarsStr = _transformToken2[1];
    }

    // Optimize for `useStyleRegister` performance
    var tokenKey = token2key(mergedDerivativeToken, salt);
    mergedDerivativeToken._tokenKey = tokenKey;
    actualToken._tokenKey = token2key(actualToken, salt);
    var themeKey = (_cssVar$key = cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) !== null && _cssVar$key !== void 0 ? _cssVar$key : tokenKey;
    mergedDerivativeToken._themeKey = themeKey;
    recordCleanToken(themeKey);
    var hashId = "".concat(hashPrefix, "-").concat(hash_browser_esm(tokenKey));
    mergedDerivativeToken._hashId = hashId; // Not used

    return [mergedDerivativeToken, hashId, actualToken, cssVarsStr, (cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) || ''];
  }, function (cache) {
    // Remove token will remove all related style
    cleanTokenStyle(cache[0]._themeKey, instanceId);
  }, function (_ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 4),
      token = _ref2[0],
      cssVarsStr = _ref2[3];
    if (cssVar && cssVarsStr) {
      var style = (0,dynamicCSS/* updateCSS */.hq)(cssVarsStr, hash_browser_esm("css-variables-".concat(token._themeKey)), {
        mark: ATTR_MARK,
        prepend: 'queue',
        attachTo: container,
        priority: -999
      });
      style[CSS_IN_JS_INSTANCE] = instanceId;

      // Used for `useCacheToken` to remove on batch when token removed
      style.setAttribute(ATTR_TOKEN, token._themeKey);
    }
  });
  return cachedToken;
}
var extract = function extract(cache, effectStyles, options) {
  var _cache = (0,slicedToArray/* default */.Z)(cache, 5),
    realToken = _cache[2],
    styleStr = _cache[3],
    cssVarKey = _cache[4];
  var _ref3 = options || {},
    plain = _ref3.plain;
  if (!styleStr) {
    return null;
  }
  var styleId = realToken._tokenKey;
  var order = -999;

  // ====================== Style ======================
  // Used for rc-util
  var sharedAttrs = {
    'data-rc-order': 'prependQueue',
    'data-rc-priority': "".concat(order)
  };
  var styleText = util_toStyleStr(styleStr, cssVarKey, styleId, sharedAttrs, plain);
  return [order, styleId, styleText];
};
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitless_browser_esm = __webpack_require__(86130);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/node_modules/stylis/src/Enum.js
var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';
var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var PAGE = '@page';
var MEDIA = '@media';
var IMPORT = '@import';
var CHARSET = '@charset';
var VIEWPORT = '@viewport';
var SUPPORTS = '@supports';
var DOCUMENT = '@document';
var NAMESPACE = '@namespace';
var KEYFRAMES = '@keyframes';
var FONT_FACE = '@font-face';
var COUNTER_STYLE = '@counter-style';
var FONT_FEATURE_VALUES = '@font-feature-values';
var LAYER = '@layer';
var SCOPE = '@scope';
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash(value, length) {
  return charat(value, 0) ^ 45 ? (((length << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}

/**
 * @param {string} value
 * @return {string}
 */
function trim(value) {
  return value.trim();
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}

/**
 * @param {string} value
 * @param {string} search
 * @param {number} position
 * @return {number}
 */
function indexof(value, search, position) {
  return value.indexOf(search, position);
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat(value, index) {
  return value.charCodeAt(index) | 0;
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr(value, begin, end) {
  return value.slice(begin, end);
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen(value) {
  return value.length;
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof(value) {
  return value.length;
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append(value, array) {
  return array.push(value), value;
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine(array, callback) {
  return array.map(callback).join('');
}

/**
 * @param {string[]} array
 * @param {RegExp} pattern
 * @return {string[]}
 */
function filter(array, pattern) {
  return array.filter(function (value) {
    return !match(value, pattern);
  });
}
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize(children, callback) {
  var output = '';
  for (var i = 0; i < children.length; i++) output += callback(children[i], i, children, callback) || '';
  return output;
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify(element, index, children, callback) {
  switch (element.type) {
    case LAYER:
      if (element.children.length) break;
    case IMPORT:
    case NAMESPACE:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return '';
    case KEYFRAMES:
      return element.return = element.value + '{' + serialize(element.children, callback) + '}';
    case RULESET:
      if (!strlen(element.value = element.props.join(','))) return '';
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/node_modules/stylis/src/Tokenizer.js

var line = 1;
var column = 1;
var Tokenizer_length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {object[]} siblings
 * @param {number} length
 */
function node(value, root, parent, type, props, children, length, siblings) {
  return {
    value: value,
    root: root,
    parent: parent,
    type: type,
    props: props,
    children: children,
    line: line,
    column: column,
    length: length,
    return: '',
    siblings: siblings
  };
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy(root, props) {
  return assign(node('', null, null, '', null, null, 0, root.siblings), root, {
    length: -root.length
  }, props);
}

/**
 * @param {object} root
 */
function lift(root) {
  while (root.root) root = copy(root.root, {
    children: [root]
  });
  append(root, root.siblings);
}

/**
 * @return {number}
 */
function Tokenizer_char() {
  return character;
}

/**
 * @return {number}
 */
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10) column = 1, line--;
  return character;
}

/**
 * @return {number}
 */
function next() {
  character = position < Tokenizer_length ? charat(characters, position++) : 0;
  if (column++, character === 10) column = 1, line++;
  return character;
}

/**
 * @return {number}
 */
function peek() {
  return charat(characters, position);
}

/**
 * @return {number}
 */
function caret() {
  return position;
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice(begin, end) {
  return substr(characters, begin, end);
}

/**
 * @param {number} type
 * @return {number}
 */
function token(type) {
  switch (type) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc(value) {
  return line = column = 1, Tokenizer_length = strlen(characters = value), position = 0, [];
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc(value) {
  return characters = '', value;
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit(type) {
  return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}

/**
 * @param {string} value
 * @return {string[]}
 */
function tokenize(value) {
  return dealloc(tokenizer(alloc(value)));
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace(type) {
  while (character = peek()) if (character < 33) next();else break;
  return token(type) > 2 || token(character) > 3 ? '' : ' ';
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer(children) {
  while (next()) switch (token(character)) {
    case 0:
      append(identifier(position - 1), children);
      break;
    case 2:
      append(delimit(character), children);
      break;
    default:
      append(from(character), children);
  }
  return children;
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping(index, count) {
  while (--count && next())
  // not 0-9 A-F a-f
  if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97) break;
  return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32));
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter(type) {
  while (next()) switch (character) {
    // ] ) " '
    case type:
      return position;
    // " '
    case 34:
    case 39:
      if (type !== 34 && type !== 39) delimiter(character);
      break;
    // (
    case 40:
      if (type === 41) delimiter(type);
      break;
    // \
    case 92:
      next();
      break;
  }
  return position;
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter(type, index) {
  while (next())
  // //
  if (type + character === 47 + 10) break;
  // /*
  else if (type + character === 42 + 42 && peek() === 47) break;
  return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next());
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier(index) {
  while (!token(peek())) next();
  return slice(index, position);
}
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile(value) {
  return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value));
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index = 0;
  var offset = 0;
  var length = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character = 0;
  var type = '';
  var props = rules;
  var children = rulesets;
  var reference = rule;
  var characters = type;
  while (scanning) switch (previous = character, character = next()) {
    // (
    case 40:
      if (previous != 108 && charat(characters, length - 1) == 58) {
        if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f', abs(index ? points[index - 1] : 0)) != -1) ampersand = -1;
        break;
      }
    // " ' [
    case 34:
    case 39:
    case 91:
      characters += delimit(character);
      break;
    // \t \n \r \s
    case 9:
    case 10:
    case 13:
    case 32:
      characters += whitespace(previous);
      break;
    // \
    case 92:
      characters += escaping(caret() - 1, 7);
      continue;
    // /
    case 47:
      switch (peek()) {
        case 42:
        case 47:
          Utility_append(comment(commenter(next(), caret()), root, parent, declarations), declarations);
          if ((token(previous || 1) == 5 || token(peek() || 1) == 5) && strlen(characters) && substr(characters, -1, void 0) !== ' ') characters += ' ';
          break;
        default:
          characters += '/';
      }
      break;
    // {
    case 123 * variable:
      points[index++] = strlen(characters) * ampersand;
    // } ; \0
    case 125 * variable:
    case 59:
    case 0:
      switch (character) {
        // \0 }
        case 0:
        case 125:
          scanning = 0;
        // ;
        case 59 + offset:
          if (ampersand == -1) characters = replace(characters, /\f/g, '');
          if (property > 0 && (strlen(characters) - length || variable === 0 && previous === 47)) Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1, declarations) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2, declarations), declarations);
          break;
        // @ ;
        case 59:
          characters += ';';
        // { rule/at-rule
        default:
          Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length, rulesets), rulesets);
          if (character === 123) if (offset === 0) parse(characters, root, reference, reference, props, rulesets, length, points, children);else {
            switch (atrule) {
              // c(ontainer)
              case 99:
                if (charat(characters, 3) === 110) break;
              // l(ayer)
              case 108:
                if (charat(characters, 2) === 97) break;
              default:
                offset = 0;
              // d(ocument) m(edia) s(upports)
              case 100:
              case 109:
              case 115:
            }
            if (offset) parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length, children), children), rules, children, length, points, rule ? props : children);else parse(characters, reference, reference, reference, [''], children, 0, points, children);
          }
      }
      index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
      break;
    // :
    case 58:
      length = 1 + strlen(characters), property = previous;
    default:
      if (variable < 1) if (character == 123) --variable;else if (character == 125 && variable++ == 0 && prev() == 125) continue;
      switch (characters += Utility_from(character), character * variable) {
        // &
        case 38:
          ampersand = offset > 0 ? 1 : (characters += '\f', -1);
          break;
        // ,
        case 44:
          points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
          break;
        // @
        case 64:
          // -
          if (peek() === 45) characters += delimit(next());
          atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
          break;
        // -
        case 45:
          if (previous === 45 && strlen(characters) == 2) variable = 0;
      }
  }
  return rulesets;
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @param {object[]} siblings
 * @return {object}
 */
function ruleset(value, root, parent, index, offset, rules, points, type, props, children, length, siblings) {
  var post = offset - 1;
  var rule = offset === 0 ? rules : [''];
  var size = sizeof(rule);
  for (var i = 0, j = 0, k = 0; i < index; ++i) for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x) if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x]))) props[k++] = z;
  return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length, siblings);
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @param {object[]} siblings
 * @return {object}
 */
function comment(value, root, parent, siblings) {
  return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), substr(value, 2, -2), 0, siblings);
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @param {object[]} siblings
 * @return {object}
 */
function declaration(value, root, parent, length, siblings) {
  return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length, siblings);
}
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/linters/utils.js

function utils_lintWarning(message, info) {
  var path = info.path,
    parentSelectors = info.parentSelectors;
  devWarning(false, "[Ant Design CSS-in-JS] ".concat(path ? "Error in ".concat(path, ": ") : '').concat(message).concat(parentSelectors.length ? " Selector: ".concat(parentSelectors.join(' | ')) : ''));
}
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/linters/contentQuotesLinter.js

var linter = function linter(key, value, info) {
  if (key === 'content') {
    // From emotion: https://github.com/emotion-js/emotion/blob/main/packages/serialize/src/index.js#L63
    var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
    var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
    if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
      lintWarning("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(value, "\"'`."), info);
    }
  }
};
/* harmony default export */ var contentQuotesLinter = ((/* unused pure expression or super */ null && (linter)));
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/linters/hashedAnimationLinter.js

var hashedAnimationLinter_linter = function linter(key, value, info) {
  if (key === 'animation') {
    if (info.hashId && value !== 'none') {
      lintWarning("You seem to be using hashed animation '".concat(value, "', in which case 'animationName' with Keyframe as value is recommended."), info);
    }
  }
};
/* harmony default export */ var hashedAnimationLinter = ((/* unused pure expression or super */ null && (hashedAnimationLinter_linter)));
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/linters/legacyNotSelectorLinter.js

function isConcatSelector(selector) {
  var _selector$match;
  var notContent = ((_selector$match = selector.match(/:not\(([^)]*)\)/)) === null || _selector$match === void 0 ? void 0 : _selector$match[1]) || '';

  // split selector. e.g.
  // `h1#a.b` => ['h1', #a', '.b']
  var splitCells = notContent.split(/(\[[^[]*])|(?=[.#])/).filter(function (str) {
    return str;
  });
  return splitCells.length > 1;
}
function parsePath(info) {
  return info.parentSelectors.reduce(function (prev, cur) {
    if (!prev) {
      return cur;
    }
    return cur.includes('&') ? cur.replace(/&/g, prev) : "".concat(prev, " ").concat(cur);
  }, '');
}
var legacyNotSelectorLinter_linter = function linter(key, value, info) {
  var parentSelectorPath = parsePath(info);
  var notList = parentSelectorPath.match(/:not\([^)]*\)/g) || [];
  if (notList.length > 0 && notList.some(isConcatSelector)) {
    lintWarning("Concat ':not' selector not support in legacy browsers.", info);
  }
};
/* harmony default export */ var legacyNotSelectorLinter = ((/* unused pure expression or super */ null && (legacyNotSelectorLinter_linter)));
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/linters/logicalPropertiesLinter.js

var logicalPropertiesLinter_linter = function linter(key, value, info) {
  switch (key) {
    case 'marginLeft':
    case 'marginRight':
    case 'paddingLeft':
    case 'paddingRight':
    case 'left':
    case 'right':
    case 'borderLeft':
    case 'borderLeftWidth':
    case 'borderLeftStyle':
    case 'borderLeftColor':
    case 'borderRight':
    case 'borderRightWidth':
    case 'borderRightStyle':
    case 'borderRightColor':
    case 'borderTopLeftRadius':
    case 'borderTopRightRadius':
    case 'borderBottomLeftRadius':
    case 'borderBottomRightRadius':
      lintWarning("You seem to be using non-logical property '".concat(key, "' which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
      return;
    case 'margin':
    case 'padding':
    case 'borderWidth':
    case 'borderStyle':
      // case 'borderColor':
      if (typeof value === 'string') {
        var valueArr = value.split(' ').map(function (item) {
          return item.trim();
        });
        if (valueArr.length === 4 && valueArr[1] !== valueArr[3]) {
          lintWarning("You seem to be using '".concat(key, "' property with different left ").concat(key, " and right ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
        }
      }
      return;
    case 'clear':
    case 'textAlign':
      if (value === 'left' || value === 'right') {
        lintWarning("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
      }
      return;
    case 'borderRadius':
      if (typeof value === 'string') {
        var radiusGroups = value.split('/').map(function (item) {
          return item.trim();
        });
        var invalid = radiusGroups.reduce(function (result, group) {
          if (result) {
            return result;
          }
          var radiusArr = group.split(' ').map(function (item) {
            return item.trim();
          });
          // borderRadius: '2px 4px'
          if (radiusArr.length >= 2 && radiusArr[0] !== radiusArr[1]) {
            return true;
          }
          // borderRadius: '4px 4px 2px'
          if (radiusArr.length === 3 && radiusArr[1] !== radiusArr[2]) {
            return true;
          }
          // borderRadius: '4px 4px 2px 4px'
          if (radiusArr.length === 4 && radiusArr[2] !== radiusArr[3]) {
            return true;
          }
          return result;
        }, false);
        if (invalid) {
          lintWarning("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
        }
      }
      return;
    default:
  }
};
/* harmony default export */ var logicalPropertiesLinter = ((/* unused pure expression or super */ null && (logicalPropertiesLinter_linter)));
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/linters/NaNLinter.js

var NaNLinter_linter = function linter(key, value, info) {
  if (typeof value === 'string' && /NaN/g.test(value) || Number.isNaN(value)) {
    lintWarning("Unexpected 'NaN' in property '".concat(key, ": ").concat(value, "'."), info);
  }
};
/* harmony default export */ var NaNLinter = ((/* unused pure expression or super */ null && (NaNLinter_linter)));
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/linters/parentSelectorLinter.js

var parentSelectorLinter_linter = function linter(key, value, info) {
  if (info.parentSelectors.some(function (selector) {
    var selectors = selector.split(',');
    return selectors.some(function (item) {
      return item.split('&').length > 2;
    });
  })) {
    lintWarning('Should not use more than one `&` in a selector.', info);
  }
};
/* harmony default export */ var parentSelectorLinter = ((/* unused pure expression or super */ null && (parentSelectorLinter_linter)));
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/linters/index.js






;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/util/cacheMapUtil.js



var cacheMapUtil_ATTR_CACHE_MAP = 'data-ant-cssinjs-cache-path';

/**
 * This marks style from the css file.
 * Which means not exist in `<style />` tag.
 */
var CSS_FILE_STYLE = '_FILE_STYLE__';
function cacheMapUtil_serialize(cachePathMap) {
  return Object.keys(cachePathMap).map(function (path) {
    var hash = cachePathMap[path];
    return "".concat(path, ":").concat(hash);
  }).join(';');
}
var cachePathMap;
var fromCSSFile = true;

/**
 * @private Test usage only. Can save remove if no need.
 */
function cacheMapUtil_reset(mockCache) {
  var fromFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  cachePathMap = mockCache;
  fromCSSFile = fromFile;
}
function prepare() {
  if (!cachePathMap) {
    cachePathMap = {};
    if ((0,canUseDom/* default */.Z)()) {
      var div = document.createElement('div');
      div.className = cacheMapUtil_ATTR_CACHE_MAP;
      div.style.position = 'fixed';
      div.style.visibility = 'hidden';
      div.style.top = '-9999px';
      document.body.appendChild(div);
      var content = getComputedStyle(div).content || '';
      content = content.replace(/^"/, '').replace(/"$/, '');

      // Fill data
      content.split(';').forEach(function (item) {
        var _item$split = item.split(':'),
          _item$split2 = (0,slicedToArray/* default */.Z)(_item$split, 2),
          path = _item$split2[0],
          hash = _item$split2[1];
        cachePathMap[path] = hash;
      });

      // Remove inline record style
      var inlineMapStyle = document.querySelector("style[".concat(cacheMapUtil_ATTR_CACHE_MAP, "]"));
      if (inlineMapStyle) {
        var _inlineMapStyle$paren;
        fromCSSFile = false;
        (_inlineMapStyle$paren = inlineMapStyle.parentNode) === null || _inlineMapStyle$paren === void 0 || _inlineMapStyle$paren.removeChild(inlineMapStyle);
      }
      document.body.removeChild(div);
    }
  }
}
function existPath(path) {
  prepare();
  return !!cachePathMap[path];
}
function getStyleAndHash(path) {
  var hash = cachePathMap[path];
  var styleStr = null;
  if (hash && (0,canUseDom/* default */.Z)()) {
    if (fromCSSFile) {
      styleStr = CSS_FILE_STYLE;
    } else {
      var _style = document.querySelector("style[".concat(ATTR_MARK, "=\"").concat(cachePathMap[path], "\"]"));
      if (_style) {
        styleStr = _style.innerHTML;
      } else {
        // Clean up since not exist anymore
        delete cachePathMap[path];
      }
    }
  }
  return [styleStr, hash];
}
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/hooks/useStyleRegister.js









// @ts-ignore







var SKIP_CHECK = '_skip_check_';
var MULTI_VALUE = '_multi_value_';
// ============================================================================
// ==                                 Parser                                 ==
// ============================================================================
// Preprocessor style content to browser support one
function normalizeStyle(styleStr) {
  var serialized = serialize(compile(styleStr), stringify);
  return serialized.replace(/\{%%%\:[^;];}/g, ';');
}
function isCompoundCSSProperty(value) {
  return (0,esm_typeof/* default */.Z)(value) === 'object' && value && (SKIP_CHECK in value || MULTI_VALUE in value);
}

// 注入 hash 值
function injectSelectorHash(key, hashId, hashPriority) {
  if (!hashId) {
    return key;
  }
  var hashClassName = ".".concat(hashId);
  var hashSelector = hashPriority === 'low' ? ":where(".concat(hashClassName, ")") : hashClassName;

  // 注入 hashId
  var keys = key.split(',').map(function (k) {
    var _firstPath$match;
    var fullPath = k.trim().split(/\s+/);

    // 如果 Selector 第一个是 HTML Element，那我们就插到它的后面。反之，就插到最前面。
    var firstPath = fullPath[0] || '';
    var htmlElement = ((_firstPath$match = firstPath.match(/^\w+/)) === null || _firstPath$match === void 0 ? void 0 : _firstPath$match[0]) || '';
    firstPath = "".concat(htmlElement).concat(hashSelector).concat(firstPath.slice(htmlElement.length));
    return [firstPath].concat((0,toConsumableArray/* default */.Z)(fullPath.slice(1))).join(' ');
  });
  return keys.join(',');
}
// Parse CSSObject to style content
var parseStyle = function parseStyle(interpolation) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      root: true,
      parentSelectors: []
    },
    root = _ref.root,
    injectHash = _ref.injectHash,
    parentSelectors = _ref.parentSelectors;
  var hashId = config.hashId,
    layer = config.layer,
    path = config.path,
    hashPriority = config.hashPriority,
    _config$transformers = config.transformers,
    transformers = _config$transformers === void 0 ? [] : _config$transformers,
    _config$linters = config.linters,
    linters = _config$linters === void 0 ? [] : _config$linters;
  var styleStr = '';
  var effectStyle = {};
  function parseKeyframes(keyframes) {
    var animationName = keyframes.getName(hashId);
    if (!effectStyle[animationName]) {
      var _parseStyle = parseStyle(keyframes.style, config, {
          root: false,
          parentSelectors: parentSelectors
        }),
        _parseStyle2 = (0,slicedToArray/* default */.Z)(_parseStyle, 1),
        _parsedStr = _parseStyle2[0];
      effectStyle[animationName] = "@keyframes ".concat(keyframes.getName(hashId)).concat(_parsedStr);
    }
  }
  function flattenList(list) {
    var fullList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    list.forEach(function (item) {
      if (Array.isArray(item)) {
        flattenList(item, fullList);
      } else if (item) {
        fullList.push(item);
      }
    });
    return fullList;
  }
  var flattenStyleList = flattenList(Array.isArray(interpolation) ? interpolation : [interpolation]);
  flattenStyleList.forEach(function (originStyle) {
    // Only root level can use raw string
    var style = typeof originStyle === 'string' && !root ? {} : originStyle;
    if (typeof style === 'string') {
      styleStr += "".concat(style, "\n");
    } else if (style._keyframe) {
      // Keyframe
      parseKeyframes(style);
    } else {
      var mergedStyle = transformers.reduce(function (prev, trans) {
        var _trans$visit;
        return (trans === null || trans === void 0 || (_trans$visit = trans.visit) === null || _trans$visit === void 0 ? void 0 : _trans$visit.call(trans, prev)) || prev;
      }, style);

      // Normal CSSObject
      Object.keys(mergedStyle).forEach(function (key) {
        var value = mergedStyle[key];
        if ((0,esm_typeof/* default */.Z)(value) === 'object' && value && (key !== 'animationName' || !value._keyframe) && !isCompoundCSSProperty(value)) {
          var subInjectHash = false;

          // 当成嵌套对象来处理
          var mergedKey = key.trim();
          // Whether treat child as root. In most case it is false.
          var nextRoot = false;

          // 拆分多个选择器
          if ((root || injectHash) && hashId) {
            if (mergedKey.startsWith('@')) {
              // 略过媒体查询，交给子节点继续插入 hashId
              subInjectHash = true;
            } else if (mergedKey === '&') {
              // 抹掉 root selector 上的单个 &
              mergedKey = injectSelectorHash('', hashId, hashPriority);
            } else {
              // 注入 hashId
              mergedKey = injectSelectorHash(key, hashId, hashPriority);
            }
          } else if (root && !hashId && (mergedKey === '&' || mergedKey === '')) {
            // In case of `{ '&': { a: { color: 'red' } } }` or `{ '': { a: { color: 'red' } } }` without hashId,
            // we will get `&{a:{color:red;}}` or `{a:{color:red;}}` string for stylis to compile.
            // But it does not conform to stylis syntax,
            // and finally we will get `{color:red;}` as css, which is wrong.
            // So we need to remove key in root, and treat child `{ a: { color: 'red' } }` as root.
            mergedKey = '';
            nextRoot = true;
          }
          var _parseStyle3 = parseStyle(value, config, {
              root: nextRoot,
              injectHash: subInjectHash,
              parentSelectors: [].concat((0,toConsumableArray/* default */.Z)(parentSelectors), [mergedKey])
            }),
            _parseStyle4 = (0,slicedToArray/* default */.Z)(_parseStyle3, 2),
            _parsedStr2 = _parseStyle4[0],
            childEffectStyle = _parseStyle4[1];
          effectStyle = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, effectStyle), childEffectStyle);
          styleStr += "".concat(mergedKey).concat(_parsedStr2);
        } else {
          var _value;
          function appendStyle(cssKey, cssValue) {
            if (false) {}

            // 如果是样式则直接插入
            var styleName = cssKey.replace(/[A-Z]/g, function (match) {
              return "-".concat(match.toLowerCase());
            });

            // Auto suffix with px
            var formatValue = cssValue;
            if (!unitless_browser_esm/* default */.Z[cssKey] && typeof formatValue === 'number' && formatValue !== 0) {
              formatValue = "".concat(formatValue, "px");
            }

            // handle animationName & Keyframe value
            if (cssKey === 'animationName' && cssValue !== null && cssValue !== void 0 && cssValue._keyframe) {
              parseKeyframes(cssValue);
              formatValue = cssValue.getName(hashId);
            }
            styleStr += "".concat(styleName, ":").concat(formatValue, ";");
          }
          var actualValue = (_value = value === null || value === void 0 ? void 0 : value.value) !== null && _value !== void 0 ? _value : value;
          if ((0,esm_typeof/* default */.Z)(value) === 'object' && value !== null && value !== void 0 && value[MULTI_VALUE] && Array.isArray(actualValue)) {
            actualValue.forEach(function (item) {
              appendStyle(key, item);
            });
          } else {
            appendStyle(key, actualValue);
          }
        }
      });
    }
  });
  if (!root) {
    styleStr = "{".concat(styleStr, "}");
  } else if (layer) {
    // fixme: https://github.com/thysultan/stylis/pull/339
    if (styleStr) {
      styleStr = "@layer ".concat(layer.name, " {").concat(styleStr, "}");
    }
    if (layer.dependencies) {
      effectStyle["@layer ".concat(layer.name)] = layer.dependencies.map(function (deps) {
        return "@layer ".concat(deps, ", ").concat(layer.name, ";");
      }).join('\n');
    }
  }
  return [styleStr, effectStyle];
};

// ============================================================================
// ==                                Register                                ==
// ============================================================================
function uniqueHash(path, styleStr) {
  return hash_browser_esm("".concat(path.join('%')).concat(styleStr));
}
function Empty() {
  return null;
}
var STYLE_PREFIX = 'style';
/**
 * Register a style to the global style sheet.
 */
function useStyleRegister(info, styleFn) {
  var token = info.token,
    path = info.path,
    hashId = info.hashId,
    layer = info.layer,
    nonce = info.nonce,
    clientOnly = info.clientOnly,
    _info$order = info.order,
    order = _info$order === void 0 ? 0 : _info$order;
  var _React$useContext = react.useContext(es_StyleContext),
    autoClear = _React$useContext.autoClear,
    mock = _React$useContext.mock,
    defaultCache = _React$useContext.defaultCache,
    hashPriority = _React$useContext.hashPriority,
    container = _React$useContext.container,
    ssrInline = _React$useContext.ssrInline,
    transformers = _React$useContext.transformers,
    linters = _React$useContext.linters,
    cache = _React$useContext.cache,
    enableLayer = _React$useContext.layer;
  var tokenKey = token._tokenKey;
  var fullPath = [tokenKey];
  if (enableLayer) {
    fullPath.push('layer');
  }
  fullPath.push.apply(fullPath, (0,toConsumableArray/* default */.Z)(path));

  // Check if need insert style
  var isMergedClientSide = isClientSide;
  if (false) {}
  var _useGlobalCache = useGlobalCache(STYLE_PREFIX, fullPath,
    // Create cache if needed
    function () {
      var cachePath = fullPath.join('|');

      // Get style from SSR inline style directly
      if (existPath(cachePath)) {
        var _getStyleAndHash = getStyleAndHash(cachePath),
          _getStyleAndHash2 = (0,slicedToArray/* default */.Z)(_getStyleAndHash, 2),
          inlineCacheStyleStr = _getStyleAndHash2[0],
          styleHash = _getStyleAndHash2[1];
        if (inlineCacheStyleStr) {
          return [inlineCacheStyleStr, tokenKey, styleHash, {}, clientOnly, order];
        }
      }

      // Generate style
      var styleObj = styleFn();
      var _parseStyle5 = parseStyle(styleObj, {
          hashId: hashId,
          hashPriority: hashPriority,
          layer: enableLayer ? layer : undefined,
          path: path.join('-'),
          transformers: transformers,
          linters: linters
        }),
        _parseStyle6 = (0,slicedToArray/* default */.Z)(_parseStyle5, 2),
        parsedStyle = _parseStyle6[0],
        effectStyle = _parseStyle6[1];
      var styleStr = normalizeStyle(parsedStyle);
      var styleId = uniqueHash(fullPath, styleStr);
      return [styleStr, tokenKey, styleId, effectStyle, clientOnly, order];
    },
    // Remove cache if no need
    function (_ref2, fromHMR) {
      var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 3),
        styleId = _ref3[2];
      if ((fromHMR || autoClear) && isClientSide) {
        (0,dynamicCSS/* removeCSS */.jL)(styleId, {
          mark: ATTR_MARK,
          attachTo: container
        });
      }
    },
    // Effect: Inject style here
    function (_ref4) {
      var _ref5 = (0,slicedToArray/* default */.Z)(_ref4, 4),
        styleStr = _ref5[0],
        _ = _ref5[1],
        styleId = _ref5[2],
        effectStyle = _ref5[3];
      if (isMergedClientSide && styleStr !== CSS_FILE_STYLE) {
        var mergedCSSConfig = {
          mark: ATTR_MARK,
          prepend: enableLayer ? false : 'queue',
          attachTo: container,
          priority: order
        };
        var nonceStr = typeof nonce === 'function' ? nonce() : nonce;
        if (nonceStr) {
          mergedCSSConfig.csp = {
            nonce: nonceStr
          };
        }

        // ================= Split Effect Style =================
        // We will split effectStyle here since @layer should be at the top level
        var effectLayerKeys = [];
        var effectRestKeys = [];
        Object.keys(effectStyle).forEach(function (key) {
          if (key.startsWith('@layer')) {
            effectLayerKeys.push(key);
          } else {
            effectRestKeys.push(key);
          }
        });

        // ================= Inject Layer Style =================
        // Inject layer style
        effectLayerKeys.forEach(function (effectKey) {
          (0,dynamicCSS/* updateCSS */.hq)(normalizeStyle(effectStyle[effectKey]), "_layer-".concat(effectKey), (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, mergedCSSConfig), {}, {
            prepend: true
          }));
        });

        // ==================== Inject Style ====================
        // Inject style
        var style = (0,dynamicCSS/* updateCSS */.hq)(styleStr, styleId, mergedCSSConfig);
        style[CSS_IN_JS_INSTANCE] = cache.instanceId;

        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute(ATTR_TOKEN, tokenKey);

        // Debug usage. Dev only
        if (false) {}

        // ================ Inject Effect Style =================
        // Inject client side effect style
        effectRestKeys.forEach(function (effectKey) {
          (0,dynamicCSS/* updateCSS */.hq)(normalizeStyle(effectStyle[effectKey]), "_effect-".concat(effectKey), mergedCSSConfig);
        });
      }
    }),
    _useGlobalCache2 = (0,slicedToArray/* default */.Z)(_useGlobalCache, 3),
    cachedStyleStr = _useGlobalCache2[0],
    cachedTokenKey = _useGlobalCache2[1],
    cachedStyleId = _useGlobalCache2[2];
  return function (node) {
    var styleNode;
    if (!ssrInline || isMergedClientSide || !defaultCache) {
      styleNode = /*#__PURE__*/react.createElement(Empty, null);
    } else {
      styleNode = /*#__PURE__*/react.createElement("style", (0,esm_extends/* default */.Z)({}, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, ATTR_TOKEN, cachedTokenKey), ATTR_MARK, cachedStyleId), {
        dangerouslySetInnerHTML: {
          __html: cachedStyleStr
        }
      }));
    }
    return /*#__PURE__*/react.createElement(react.Fragment, null, styleNode, node);
  };
}
var useStyleRegister_extract = function extract(cache, effectStyles, options) {
  var _cache = (0,slicedToArray/* default */.Z)(cache, 6),
    styleStr = _cache[0],
    tokenKey = _cache[1],
    styleId = _cache[2],
    effectStyle = _cache[3],
    clientOnly = _cache[4],
    order = _cache[5];
  var _ref7 = options || {},
    plain = _ref7.plain;

  // Skip client only style
  if (clientOnly) {
    return null;
  }
  var keyStyleText = styleStr;

  // ====================== Share ======================
  // Used for rc-util
  var sharedAttrs = {
    'data-rc-order': 'prependQueue',
    'data-rc-priority': "".concat(order)
  };

  // ====================== Style ======================
  keyStyleText = util_toStyleStr(styleStr, tokenKey, styleId, sharedAttrs, plain);

  // =============== Create effect style ===============
  if (effectStyle) {
    Object.keys(effectStyle).forEach(function (effectKey) {
      // Effect style can be reused
      if (!effectStyles[effectKey]) {
        effectStyles[effectKey] = true;
        var effectStyleStr = normalizeStyle(effectStyle[effectKey]);
        var effectStyleHTML = util_toStyleStr(effectStyleStr, tokenKey, "_effect-".concat(effectKey), sharedAttrs, plain);
        if (effectKey.startsWith('@layer')) {
          keyStyleText = effectStyleHTML + keyStyleText;
        } else {
          keyStyleText += effectStyleHTML;
        }
      }
    });
  }
  return [order, styleId, keyStyleText];
};
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/hooks/useCSSVarRegister.js









var CSS_VAR_PREFIX = 'cssVar';
var useCSSVarRegister = function useCSSVarRegister(config, fn) {
  var key = config.key,
    prefix = config.prefix,
    unitless = config.unitless,
    ignore = config.ignore,
    token = config.token,
    _config$scope = config.scope,
    scope = _config$scope === void 0 ? '' : _config$scope;
  var _useContext = (0,react.useContext)(es_StyleContext),
    instanceId = _useContext.cache.instanceId,
    container = _useContext.container;
  var tokenKey = token._tokenKey;
  var stylePath = [].concat((0,toConsumableArray/* default */.Z)(config.path), [key, scope, tokenKey]);
  var cache = useGlobalCache(CSS_VAR_PREFIX, stylePath, function () {
    var originToken = fn();
    var _transformToken = transformToken(originToken, key, {
        prefix: prefix,
        unitless: unitless,
        ignore: ignore,
        scope: scope
      }),
      _transformToken2 = (0,slicedToArray/* default */.Z)(_transformToken, 2),
      mergedToken = _transformToken2[0],
      cssVarsStr = _transformToken2[1];
    var styleId = uniqueHash(stylePath, cssVarsStr);
    return [mergedToken, cssVarsStr, styleId, key];
  }, function (_ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 3),
      styleId = _ref2[2];
    if (isClientSide) {
      (0,dynamicCSS/* removeCSS */.jL)(styleId, {
        mark: ATTR_MARK,
        attachTo: container
      });
    }
  }, function (_ref3) {
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 3),
      cssVarsStr = _ref4[1],
      styleId = _ref4[2];
    if (!cssVarsStr) {
      return;
    }
    var style = (0,dynamicCSS/* updateCSS */.hq)(cssVarsStr, styleId, {
      mark: ATTR_MARK,
      prepend: 'queue',
      attachTo: container,
      priority: -999
    });
    style[CSS_IN_JS_INSTANCE] = instanceId;

    // Used for `useCacheToken` to remove on batch when token removed
    style.setAttribute(ATTR_TOKEN, key);
  });
  return cache;
};
var useCSSVarRegister_extract = function extract(cache, effectStyles, options) {
  var _cache = (0,slicedToArray/* default */.Z)(cache, 4),
    styleStr = _cache[1],
    styleId = _cache[2],
    cssVarKey = _cache[3];
  var _ref5 = options || {},
    plain = _ref5.plain;
  if (!styleStr) {
    return null;
  }
  var order = -999;

  // ====================== Style ======================
  // Used for rc-util
  var sharedAttrs = {
    'data-rc-order': 'prependQueue',
    'data-rc-priority': "".concat(order)
  };
  var styleText = util_toStyleStr(styleStr, cssVarKey, styleId, sharedAttrs, plain);
  return [order, styleId, styleText];
};
/* harmony default export */ var hooks_useCSSVarRegister = (useCSSVarRegister);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/extractStyle.js







var ExtractStyleFns = (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, STYLE_PREFIX, useStyleRegister_extract), TOKEN_PREFIX, extract), CSS_VAR_PREFIX, useCSSVarRegister_extract);
function isNotNull(value) {
  return value !== null;
}
function extractStyle(cache, options) {
  var _ref = typeof options === 'boolean' ? {
      plain: options
    } : options || {},
    _ref$plain = _ref.plain,
    plain = _ref$plain === void 0 ? false : _ref$plain,
    _ref$types = _ref.types,
    types = _ref$types === void 0 ? ['style', 'token', 'cssVar'] : _ref$types,
    _ref$once = _ref.once,
    once = _ref$once === void 0 ? false : _ref$once;
  var matchPrefixRegexp = new RegExp("^(".concat((typeof types === 'string' ? [types] : types).join('|'), ")%"));

  // prefix with `style` is used for `useStyleRegister` to cache style context
  var styleKeys = Array.from(cache.cache.keys()).filter(function (key) {
    return matchPrefixRegexp.test(key);
  });

  // Common effect styles like animation
  var effectStyles = {};

  // Mapping of cachePath to style hash
  var cachePathMap = {};
  var styleText = '';
  styleKeys.map(function (key) {
    if (once && cache.extracted.has(key)) {
      return null; // Skip if already extracted
    }
    var cachePath = key.replace(matchPrefixRegexp, '').replace(/%/g, '|');
    var _key$split = key.split('%'),
      _key$split2 = _slicedToArray(_key$split, 1),
      prefix = _key$split2[0];
    var extractFn = ExtractStyleFns[prefix];
    var extractedStyle = extractFn(cache.cache.get(key)[1], effectStyles, {
      plain: plain
    });
    if (!extractedStyle) {
      return null;
    }
    var _extractedStyle = _slicedToArray(extractedStyle, 3),
      order = _extractedStyle[0],
      styleId = _extractedStyle[1],
      styleStr = _extractedStyle[2];
    if (key.startsWith('style')) {
      cachePathMap[cachePath] = styleId;
    }

    // record that this style has been extracted
    cache.extracted.add(key);
    return [order, styleStr];
  }).filter(isNotNull).sort(function (_ref2, _ref3) {
    var _ref4 = _slicedToArray(_ref2, 1),
      o1 = _ref4[0];
    var _ref5 = _slicedToArray(_ref3, 1),
      o2 = _ref5[0];
    return o1 - o2;
  }).forEach(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
      style = _ref7[1];
    styleText += style;
  });

  // ==================== Fill Cache Path ====================
  styleText += toStyleStr(".".concat(ATTR_CACHE_MAP, "{content:\"").concat(serializeCacheMap(cachePathMap), "\";}"), undefined, undefined, _defineProperty({}, ATTR_CACHE_MAP, ATTR_CACHE_MAP), plain);
  return styleText;
}
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/Keyframes.js



var Keyframe = /*#__PURE__*/function () {
  function Keyframe(name, style) {
    (0,classCallCheck/* default */.Z)(this, Keyframe);
    (0,defineProperty/* default */.Z)(this, "name", void 0);
    (0,defineProperty/* default */.Z)(this, "style", void 0);
    (0,defineProperty/* default */.Z)(this, "_keyframe", true);
    this.name = name;
    this.style = style;
  }
  (0,createClass/* default */.Z)(Keyframe, [{
    key: "getName",
    value: function getName() {
      var hashId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return hashId ? "".concat(hashId, "-").concat(this.name) : this.name;
    }
  }]);
  return Keyframe;
}();
/* harmony default export */ var Keyframes = (Keyframe);
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/transformers/legacyLogicalProperties.js

function splitValues(value) {
  if (typeof value === 'number') {
    return [[value], false];
  }
  var rawStyle = String(value).trim();
  var importantCells = rawStyle.match(/(.*)(!important)/);
  var splitStyle = (importantCells ? importantCells[1] : rawStyle).trim().split(/\s+/);

  // Combine styles split in brackets, like `calc(1px + 2px)`
  var temp = [];
  var brackets = 0;
  return [splitStyle.reduce(function (list, item) {
    if (item.includes('(') || item.includes(')')) {
      var left = item.split('(').length - 1;
      var right = item.split(')').length - 1;
      brackets += left - right;
    }
    if (brackets >= 0) temp.push(item);
    if (brackets === 0) {
      list.push(temp.join(' '));
      temp = [];
    }
    return list;
  }, []), !!importantCells];
}
function noSplit(list) {
  list.notSplit = true;
  return list;
}
var keyMap = {
  // Inset
  inset: ['top', 'right', 'bottom', 'left'],
  insetBlock: ['top', 'bottom'],
  insetBlockStart: ['top'],
  insetBlockEnd: ['bottom'],
  insetInline: ['left', 'right'],
  insetInlineStart: ['left'],
  insetInlineEnd: ['right'],
  // Margin
  marginBlock: ['marginTop', 'marginBottom'],
  marginBlockStart: ['marginTop'],
  marginBlockEnd: ['marginBottom'],
  marginInline: ['marginLeft', 'marginRight'],
  marginInlineStart: ['marginLeft'],
  marginInlineEnd: ['marginRight'],
  // Padding
  paddingBlock: ['paddingTop', 'paddingBottom'],
  paddingBlockStart: ['paddingTop'],
  paddingBlockEnd: ['paddingBottom'],
  paddingInline: ['paddingLeft', 'paddingRight'],
  paddingInlineStart: ['paddingLeft'],
  paddingInlineEnd: ['paddingRight'],
  // Border
  borderBlock: noSplit(['borderTop', 'borderBottom']),
  borderBlockStart: noSplit(['borderTop']),
  borderBlockEnd: noSplit(['borderBottom']),
  borderInline: noSplit(['borderLeft', 'borderRight']),
  borderInlineStart: noSplit(['borderLeft']),
  borderInlineEnd: noSplit(['borderRight']),
  // Border width
  borderBlockWidth: ['borderTopWidth', 'borderBottomWidth'],
  borderBlockStartWidth: ['borderTopWidth'],
  borderBlockEndWidth: ['borderBottomWidth'],
  borderInlineWidth: ['borderLeftWidth', 'borderRightWidth'],
  borderInlineStartWidth: ['borderLeftWidth'],
  borderInlineEndWidth: ['borderRightWidth'],
  // Border style
  borderBlockStyle: ['borderTopStyle', 'borderBottomStyle'],
  borderBlockStartStyle: ['borderTopStyle'],
  borderBlockEndStyle: ['borderBottomStyle'],
  borderInlineStyle: ['borderLeftStyle', 'borderRightStyle'],
  borderInlineStartStyle: ['borderLeftStyle'],
  borderInlineEndStyle: ['borderRightStyle'],
  // Border color
  borderBlockColor: ['borderTopColor', 'borderBottomColor'],
  borderBlockStartColor: ['borderTopColor'],
  borderBlockEndColor: ['borderBottomColor'],
  borderInlineColor: ['borderLeftColor', 'borderRightColor'],
  borderInlineStartColor: ['borderLeftColor'],
  borderInlineEndColor: ['borderRightColor'],
  // Border radius
  borderStartStartRadius: ['borderTopLeftRadius'],
  borderStartEndRadius: ['borderTopRightRadius'],
  borderEndStartRadius: ['borderBottomLeftRadius'],
  borderEndEndRadius: ['borderBottomRightRadius']
};
function wrapImportantAndSkipCheck(value, important) {
  var parsedValue = value;
  if (important) {
    parsedValue = "".concat(parsedValue, " !important");
  }
  return {
    _skip_check_: true,
    value: parsedValue
  };
}

/**
 * Convert css logical properties to legacy properties.
 * Such as: `margin-block-start` to `margin-top`.
 * Transform list:
 * - inset
 * - margin
 * - padding
 * - border
 */
var transform = {
  visit: function visit(cssObj) {
    var clone = {};
    Object.keys(cssObj).forEach(function (key) {
      var value = cssObj[key];
      var matchValue = keyMap[key];
      if (matchValue && (typeof value === 'number' || typeof value === 'string')) {
        var _splitValues = splitValues(value),
          _splitValues2 = (0,slicedToArray/* default */.Z)(_splitValues, 2),
          _values = _splitValues2[0],
          _important = _splitValues2[1];
        if (matchValue.length && matchValue.notSplit) {
          // not split means always give same value like border
          matchValue.forEach(function (matchKey) {
            clone[matchKey] = wrapImportantAndSkipCheck(value, _important);
          });
        } else if (matchValue.length === 1) {
          // Handle like `marginBlockStart` => `marginTop`
          clone[matchValue[0]] = wrapImportantAndSkipCheck(_values[0], _important);
        } else if (matchValue.length === 2) {
          // Handle like `marginBlock` => `marginTop` & `marginBottom`
          matchValue.forEach(function (matchKey, index) {
            var _values$index;
            clone[matchKey] = wrapImportantAndSkipCheck((_values$index = _values[index]) !== null && _values$index !== void 0 ? _values$index : _values[0], _important);
          });
        } else if (matchValue.length === 4) {
          // Handle like `inset` => `top` & `right` & `bottom` & `left`
          matchValue.forEach(function (matchKey, index) {
            var _ref, _values$index2;
            clone[matchKey] = wrapImportantAndSkipCheck((_ref = (_values$index2 = _values[index]) !== null && _values$index2 !== void 0 ? _values$index2 : _values[index - 2]) !== null && _ref !== void 0 ? _ref : _values[0], _important);
          });
        } else {
          clone[key] = value;
        }
      } else {
        clone[key] = value;
      }
    });
    return clone;
  }
};
/* harmony default export */ var legacyLogicalProperties = ((/* unused pure expression or super */ null && (transform)));
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/transformers/px2rem.js


/**
 * respect https://github.com/cuth/postcss-pxtorem
 */
// @ts-ignore

var pxRegex = /url\([^)]+\)|var\([^)]+\)|(\d*\.?\d+)px/g;
function toFixed(number, precision) {
  var multiplier = Math.pow(10, precision + 1),
    wholeNumber = Math.floor(number * multiplier);
  return Math.round(wholeNumber / 10) * 10 / multiplier;
}
var px2rem_transform = function transform() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$rootValue = options.rootValue,
    rootValue = _options$rootValue === void 0 ? 16 : _options$rootValue,
    _options$precision = options.precision,
    precision = _options$precision === void 0 ? 5 : _options$precision,
    _options$mediaQuery = options.mediaQuery,
    mediaQuery = _options$mediaQuery === void 0 ? false : _options$mediaQuery;
  var pxReplace = function pxReplace(m, $1) {
    if (!$1) return m;
    var pixels = parseFloat($1);
    // covenant: pixels <= 1, not transform to rem @zombieJ
    if (pixels <= 1) return m;
    var fixedVal = toFixed(pixels / rootValue, precision);
    return "".concat(fixedVal, "rem");
  };
  var visit = function visit(cssObj) {
    var clone = _objectSpread({}, cssObj);
    Object.entries(cssObj).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      if (typeof value === 'string' && value.includes('px')) {
        var newValue = value.replace(pxRegex, pxReplace);
        clone[key] = newValue;
      }

      // no unit
      if (!unitless[key] && typeof value === 'number' && value !== 0) {
        clone[key] = "".concat(value, "px").replace(pxRegex, pxReplace);
      }

      // Media queries
      var mergedKey = key.trim();
      if (mergedKey.startsWith('@') && mergedKey.includes('px') && mediaQuery) {
        var newKey = key.replace(pxRegex, pxReplace);
        clone[newKey] = clone[key];
        delete clone[key];
      }
    });
    return clone;
  };
  return {
    visit: visit
  };
};
/* harmony default export */ var px2rem = ((/* unused pure expression or super */ null && (px2rem_transform)));
;// CONCATENATED MODULE: ./node_modules/@ant-design/cssinjs/es/index.js













var _experimental = {
  supportModernCSS: function supportModernCSS() {
    return supportWhere() && supportLogicProps();
  }
};

/***/ }),

/***/ 99620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* reexport */ FastColor; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
;// CONCATENATED MODULE: ./node_modules/@ant-design/fast-color/es/FastColor.js

const round = Math.round;

/**
 * Support format, alpha unit will check the % mark:
 * - rgba(102, 204, 255, .5)      -> [102, 204, 255, 0.5]
 * - rgb(102 204 255 / .5)        -> [102, 204, 255, 0.5]
 * - rgb(100%, 50%, 0% / 50%)     -> [255, 128, 0, 0.5]
 * - hsl(270, 60, 40, .5)         -> [270, 60, 40, 0.5]
 * - hsl(270deg 60% 40% / 50%)   -> [270, 60, 40, 0.5]
 *
 * When `base` is provided, the percentage value will be divided by `base`.
 */
function splitColorStr(str, parseNum) {
  const match = str
  // Remove str before `(`
  .replace(/^[^(]*\((.*)/, '$1')
  // Remove str after `)`
  .replace(/\).*/, '').match(/\d*\.?\d+%?/g) || [];
  const numList = match.map(item => parseFloat(item));
  for (let i = 0; i < 3; i += 1) {
    numList[i] = parseNum(numList[i] || 0, match[i] || '', i);
  }

  // For alpha. 50% should be 0.5
  if (match[3]) {
    numList[3] = match[3].includes('%') ? numList[3] / 100 : numList[3];
  } else {
    // By default, alpha is 1
    numList[3] = 1;
  }
  return numList;
}
const parseHSVorHSL = (num, _, index) => index === 0 ? num : num / 100;

/** round and limit number to integer between 0-255 */
function limitRange(value, max) {
  const mergedMax = max || 255;
  if (value > mergedMax) {
    return mergedMax;
  }
  if (value < 0) {
    return 0;
  }
  return value;
}
class FastColor {
  constructor(input) {
    /**
     * All FastColor objects are valid. So isValid is always true. This property is kept to be compatible with TinyColor.
     */
    (0,defineProperty/* default */.Z)(this, "isValid", true);
    /**
     * Red, R in RGB
     */
    (0,defineProperty/* default */.Z)(this, "r", 0);
    /**
     * Green, G in RGB
     */
    (0,defineProperty/* default */.Z)(this, "g", 0);
    /**
     * Blue, B in RGB
     */
    (0,defineProperty/* default */.Z)(this, "b", 0);
    /**
     * Alpha/Opacity, A in RGBA/HSLA
     */
    (0,defineProperty/* default */.Z)(this, "a", 1);
    // HSV privates
    (0,defineProperty/* default */.Z)(this, "_h", void 0);
    (0,defineProperty/* default */.Z)(this, "_s", void 0);
    (0,defineProperty/* default */.Z)(this, "_l", void 0);
    (0,defineProperty/* default */.Z)(this, "_v", void 0);
    // intermediate variables to calculate HSL/HSV
    (0,defineProperty/* default */.Z)(this, "_max", void 0);
    (0,defineProperty/* default */.Z)(this, "_min", void 0);
    (0,defineProperty/* default */.Z)(this, "_brightness", void 0);
    /**
     * Always check 3 char in the object to determine the format.
     * We not use function in check to save bundle size.
     * e.g. 'rgb' -> { r: 0, g: 0, b: 0 }.
     */
    function matchFormat(str) {
      return str[0] in input && str[1] in input && str[2] in input;
    }
    if (!input) {
      // Do nothing since already initialized
    } else if (typeof input === 'string') {
      const trimStr = input.trim();
      function matchPrefix(prefix) {
        return trimStr.startsWith(prefix);
      }
      if (/^#?[A-F\d]{3,8}$/i.test(trimStr)) {
        this.fromHexString(trimStr);
      } else if (matchPrefix('rgb')) {
        this.fromRgbString(trimStr);
      } else if (matchPrefix('hsl')) {
        this.fromHslString(trimStr);
      } else if (matchPrefix('hsv') || matchPrefix('hsb')) {
        this.fromHsvString(trimStr);
      }
    } else if (input instanceof FastColor) {
      this.r = input.r;
      this.g = input.g;
      this.b = input.b;
      this.a = input.a;
      this._h = input._h;
      this._s = input._s;
      this._l = input._l;
      this._v = input._v;
    } else if (matchFormat('rgb')) {
      this.r = limitRange(input.r);
      this.g = limitRange(input.g);
      this.b = limitRange(input.b);
      this.a = typeof input.a === 'number' ? limitRange(input.a, 1) : 1;
    } else if (matchFormat('hsl')) {
      this.fromHsl(input);
    } else if (matchFormat('hsv')) {
      this.fromHsv(input);
    } else {
      throw new Error('@ant-design/fast-color: unsupported input ' + JSON.stringify(input));
    }
  }

  // ======================= Setter =======================

  setR(value) {
    return this._sc('r', value);
  }
  setG(value) {
    return this._sc('g', value);
  }
  setB(value) {
    return this._sc('b', value);
  }
  setA(value) {
    return this._sc('a', value, 1);
  }
  setHue(value) {
    const hsv = this.toHsv();
    hsv.h = value;
    return this._c(hsv);
  }

  // ======================= Getter =======================
  /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */
  getLuminance() {
    function adjustGamma(raw) {
      const val = raw / 255;
      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }
    const R = adjustGamma(this.r);
    const G = adjustGamma(this.g);
    const B = adjustGamma(this.b);
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
  }
  getHue() {
    if (typeof this._h === 'undefined') {
      const delta = this.getMax() - this.getMin();
      if (delta === 0) {
        this._h = 0;
      } else {
        this._h = round(60 * (this.r === this.getMax() ? (this.g - this.b) / delta + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / delta + 2 : (this.r - this.g) / delta + 4));
      }
    }
    return this._h;
  }
  getSaturation() {
    if (typeof this._s === 'undefined') {
      const delta = this.getMax() - this.getMin();
      if (delta === 0) {
        this._s = 0;
      } else {
        this._s = delta / this.getMax();
      }
    }
    return this._s;
  }
  getLightness() {
    if (typeof this._l === 'undefined') {
      this._l = (this.getMax() + this.getMin()) / 510;
    }
    return this._l;
  }
  getValue() {
    if (typeof this._v === 'undefined') {
      this._v = this.getMax() / 255;
    }
    return this._v;
  }

  /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */
  getBrightness() {
    if (typeof this._brightness === 'undefined') {
      this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1000;
    }
    return this._brightness;
  }

  // ======================== Func ========================

  darken(amount = 10) {
    const h = this.getHue();
    const s = this.getSaturation();
    let l = this.getLightness() - amount / 100;
    if (l < 0) {
      l = 0;
    }
    return this._c({
      h,
      s,
      l,
      a: this.a
    });
  }
  lighten(amount = 10) {
    const h = this.getHue();
    const s = this.getSaturation();
    let l = this.getLightness() + amount / 100;
    if (l > 1) {
      l = 1;
    }
    return this._c({
      h,
      s,
      l,
      a: this.a
    });
  }

  /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */
  mix(input, amount = 50) {
    const color = this._c(input);
    const p = amount / 100;
    const calc = key => (color[key] - this[key]) * p + this[key];
    const rgba = {
      r: round(calc('r')),
      g: round(calc('g')),
      b: round(calc('b')),
      a: round(calc('a') * 100) / 100
    };
    return this._c(rgba);
  }

  /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */
  tint(amount = 10) {
    return this.mix({
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }, amount);
  }

  /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */
  shade(amount = 10) {
    return this.mix({
      r: 0,
      g: 0,
      b: 0,
      a: 1
    }, amount);
  }
  onBackground(background) {
    const bg = this._c(background);
    const alpha = this.a + bg.a * (1 - this.a);
    const calc = key => {
      return round((this[key] * this.a + bg[key] * bg.a * (1 - this.a)) / alpha);
    };
    return this._c({
      r: calc('r'),
      g: calc('g'),
      b: calc('b'),
      a: alpha
    });
  }

  // ======================= Status =======================
  isDark() {
    return this.getBrightness() < 128;
  }
  isLight() {
    return this.getBrightness() >= 128;
  }

  // ======================== MISC ========================
  equals(other) {
    return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a;
  }
  clone() {
    return this._c(this);
  }

  // ======================= Format =======================
  toHexString() {
    let hex = '#';
    const rHex = (this.r || 0).toString(16);
    hex += rHex.length === 2 ? rHex : '0' + rHex;
    const gHex = (this.g || 0).toString(16);
    hex += gHex.length === 2 ? gHex : '0' + gHex;
    const bHex = (this.b || 0).toString(16);
    hex += bHex.length === 2 ? bHex : '0' + bHex;
    if (typeof this.a === 'number' && this.a >= 0 && this.a < 1) {
      const aHex = round(this.a * 255).toString(16);
      hex += aHex.length === 2 ? aHex : '0' + aHex;
    }
    return hex;
  }

  /** CSS support color pattern */
  toHsl() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      l: this.getLightness(),
      a: this.a
    };
  }

  /** CSS support color pattern */
  toHslString() {
    const h = this.getHue();
    const s = round(this.getSaturation() * 100);
    const l = round(this.getLightness() * 100);
    return this.a !== 1 ? `hsla(${h},${s}%,${l}%,${this.a})` : `hsl(${h},${s}%,${l}%)`;
  }

  /** Same as toHsb */
  toHsv() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      v: this.getValue(),
      a: this.a
    };
  }
  toRgb() {
    return {
      r: this.r,
      g: this.g,
      b: this.b,
      a: this.a
    };
  }
  toRgbString() {
    return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
  }
  toString() {
    return this.toRgbString();
  }

  // ====================== Privates ======================
  /** Return a new FastColor object with one channel changed */
  _sc(rgb, value, max) {
    const clone = this.clone();
    clone[rgb] = limitRange(value, max);
    return clone;
  }
  _c(input) {
    return new this.constructor(input);
  }
  getMax() {
    if (typeof this._max === 'undefined') {
      this._max = Math.max(this.r, this.g, this.b);
    }
    return this._max;
  }
  getMin() {
    if (typeof this._min === 'undefined') {
      this._min = Math.min(this.r, this.g, this.b);
    }
    return this._min;
  }
  fromHexString(trimStr) {
    const withoutPrefix = trimStr.replace('#', '');
    function connectNum(index1, index2) {
      return parseInt(withoutPrefix[index1] + withoutPrefix[index2 || index1], 16);
    }
    if (withoutPrefix.length < 6) {
      // #rgb or #rgba
      this.r = connectNum(0);
      this.g = connectNum(1);
      this.b = connectNum(2);
      this.a = withoutPrefix[3] ? connectNum(3) / 255 : 1;
    } else {
      // #rrggbb or #rrggbbaa
      this.r = connectNum(0, 1);
      this.g = connectNum(2, 3);
      this.b = connectNum(4, 5);
      this.a = withoutPrefix[6] ? connectNum(6, 7) / 255 : 1;
    }
  }
  fromHsl({
    h,
    s,
    l,
    a
  }) {
    this._h = h % 360;
    this._s = s;
    this._l = l;
    this.a = typeof a === 'number' ? a : 1;
    if (s <= 0) {
      const rgb = round(l * 255);
      this.r = rgb;
      this.g = rgb;
      this.b = rgb;
    }
    let r = 0,
      g = 0,
      b = 0;
    const huePrime = h / 60;
    const chroma = (1 - Math.abs(2 * l - 1)) * s;
    const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    if (huePrime >= 0 && huePrime < 1) {
      r = chroma;
      g = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
      r = secondComponent;
      g = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
      g = chroma;
      b = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
      g = secondComponent;
      b = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
      r = secondComponent;
      b = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
      r = chroma;
      b = secondComponent;
    }
    const lightnessModification = l - chroma / 2;
    this.r = round((r + lightnessModification) * 255);
    this.g = round((g + lightnessModification) * 255);
    this.b = round((b + lightnessModification) * 255);
  }
  fromHsv({
    h,
    s,
    v,
    a
  }) {
    this._h = h % 360;
    this._s = s;
    this._v = v;
    this.a = typeof a === 'number' ? a : 1;
    const vv = round(v * 255);
    this.r = vv;
    this.g = vv;
    this.b = vv;
    if (s <= 0) {
      return;
    }
    const hh = h / 60;
    const i = Math.floor(hh);
    const ff = hh - i;
    const p = round(v * (1.0 - s) * 255);
    const q = round(v * (1.0 - s * ff) * 255);
    const t = round(v * (1.0 - s * (1.0 - ff)) * 255);
    switch (i) {
      case 0:
        this.g = t;
        this.b = p;
        break;
      case 1:
        this.r = q;
        this.b = p;
        break;
      case 2:
        this.r = p;
        this.b = t;
        break;
      case 3:
        this.r = p;
        this.g = q;
        break;
      case 4:
        this.r = t;
        this.g = p;
        break;
      case 5:
      default:
        this.g = p;
        this.b = q;
        break;
    }
  }
  fromHsvString(trimStr) {
    const cells = splitColorStr(trimStr, parseHSVorHSL);
    this.fromHsv({
      h: cells[0],
      s: cells[1],
      v: cells[2],
      a: cells[3]
    });
  }
  fromHslString(trimStr) {
    const cells = splitColorStr(trimStr, parseHSVorHSL);
    this.fromHsl({
      h: cells[0],
      s: cells[1],
      l: cells[2],
      a: cells[3]
    });
  }
  fromRgbString(trimStr) {
    const cells = splitColorStr(trimStr, (num, txt) =>
    // Convert percentage to number. e.g. 50% -> 128
    txt.includes('%') ? round(num / 100 * 255) : num);
    this.r = cells[0];
    this.g = cells[1];
    this.b = cells[2];
    this.a = cells[3];
  }
}
;// CONCATENATED MODULE: ./node_modules/@ant-design/fast-color/es/index.js



/***/ }),

/***/ 92902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AntdIcon; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@ant-design/colors/es/index.js + 2 modules
var es = __webpack_require__(61835);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Context.js
var Context = __webpack_require__(15479);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/dynamicCSS.js
var dynamicCSS = __webpack_require__(6779);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/shadow.js
var shadow = __webpack_require__(96585);
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(13764);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/utils.js








function camelCase(input) {
  return input.replace(/-(.)/g, function (match, g) {
    return g.toUpperCase();
  });
}
function utils_warning(valid, message) {
  (0,warning/* default */.ZP)(valid, "[@ant-design/icons] ".concat(message));
}
function isIconDefinition(target) {
  return (0,esm_typeof/* default */.Z)(target) === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && ((0,esm_typeof/* default */.Z)(target.icon) === 'object' || typeof target.icon === 'function');
}
function normalizeAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(attrs).reduce(function (acc, key) {
    var val = attrs[key];
    switch (key) {
      case 'class':
        acc.className = val;
        delete acc.class;
        break;
      default:
        delete acc[key];
        acc[camelCase(key)] = val;
    }
    return acc;
  }, {});
}
function generate(node, key, rootProps) {
  if (!rootProps) {
    return /*#__PURE__*/react.createElement(node.tag, (0,objectSpread2/* default */.Z)({
      key: key
    }, normalizeAttrs(node.attrs)), (node.children || []).map(function (child, index) {
      return generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
  }
  return /*#__PURE__*/react.createElement(node.tag, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
    key: key
  }, normalizeAttrs(node.attrs)), rootProps), (node.children || []).map(function (child, index) {
    return generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
  }));
}
function getSecondaryColor(primaryColor) {
  // choose the second color
  return (0,es/* generate */.R_)(primaryColor)[0];
}
function normalizeTwoToneColors(twoToneColor) {
  if (!twoToneColor) {
    return [];
  }
  return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
}

// These props make sure that the SVG behaviours like general text.
// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
var svgBaseProps = {
  width: '1em',
  height: '1em',
  fill: 'currentColor',
  'aria-hidden': 'true',
  focusable: 'false'
};
var iconStyles = "\n.anticon {\n  display: inline-flex;\n  align-items: center;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var useInsertStyles = function useInsertStyles(eleRef) {
  var _useContext = (0,react.useContext)(Context/* default */.Z),
    csp = _useContext.csp,
    prefixCls = _useContext.prefixCls,
    layer = _useContext.layer;
  var mergedStyleStr = iconStyles;
  if (prefixCls) {
    mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
  }
  if (layer) {
    mergedStyleStr = "@layer ".concat(layer, " {\n").concat(mergedStyleStr, "\n}");
  }
  (0,react.useEffect)(function () {
    var ele = eleRef.current;
    var shadowRoot = (0,shadow/* getShadowRoot */.A)(ele);
    (0,dynamicCSS/* updateCSS */.hq)(mergedStyleStr, '@ant-design-icons', {
      prepend: !layer,
      csp: csp,
      attachTo: shadowRoot
    });
  }, []);
};
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/components/IconBase.js


var _excluded = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"];


var twoToneColorPalette = {
  primaryColor: '#333',
  secondaryColor: '#E6E6E6',
  calculated: false
};
function setTwoToneColors(_ref) {
  var primaryColor = _ref.primaryColor,
    secondaryColor = _ref.secondaryColor;
  twoToneColorPalette.primaryColor = primaryColor;
  twoToneColorPalette.secondaryColor = secondaryColor || getSecondaryColor(primaryColor);
  twoToneColorPalette.calculated = !!secondaryColor;
}
function getTwoToneColors() {
  return (0,objectSpread2/* default */.Z)({}, twoToneColorPalette);
}
var IconBase = function IconBase(props) {
  var icon = props.icon,
    className = props.className,
    onClick = props.onClick,
    style = props.style,
    primaryColor = props.primaryColor,
    secondaryColor = props.secondaryColor,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded);
  var svgRef = react.useRef();
  var colors = twoToneColorPalette;
  if (primaryColor) {
    colors = {
      primaryColor: primaryColor,
      secondaryColor: secondaryColor || getSecondaryColor(primaryColor)
    };
  }
  useInsertStyles(svgRef);
  utils_warning(isIconDefinition(icon), "icon should be icon definiton, but got ".concat(icon));
  if (!isIconDefinition(icon)) {
    return null;
  }
  var target = icon;
  if (target && typeof target.icon === 'function') {
    target = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, target), {}, {
      icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
  }
  return generate(target.icon, "svg-".concat(target.name), (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
    className: className,
    onClick: onClick,
    style: style,
    'data-icon': target.name,
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true'
  }, restProps), {}, {
    ref: svgRef
  }));
};
IconBase.displayName = 'IconReact';
IconBase.getTwoToneColors = getTwoToneColors;
IconBase.setTwoToneColors = setTwoToneColors;
/* harmony default export */ var components_IconBase = (IconBase);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/components/twoTonePrimaryColor.js



function setTwoToneColor(twoToneColor) {
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor),
    _normalizeTwoToneColo2 = (0,slicedToArray/* default */.Z)(_normalizeTwoToneColo, 2),
    primaryColor = _normalizeTwoToneColo2[0],
    secondaryColor = _normalizeTwoToneColo2[1];
  return components_IconBase.setTwoToneColors({
    primaryColor: primaryColor,
    secondaryColor: secondaryColor
  });
}
function getTwoToneColor() {
  var colors = components_IconBase.getTwoToneColors();
  if (!colors.calculated) {
    return colors.primaryColor;
  }
  return [colors.primaryColor, colors.secondaryColor];
}
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js
'use client';





var AntdIcon_excluded = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];







// Initial setting
// should move it to antd main repo?
setTwoToneColor(es/* blue.primary */.iN.primary);

// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-488848720

var Icon = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var className = props.className,
    icon = props.icon,
    spin = props.spin,
    rotate = props.rotate,
    tabIndex = props.tabIndex,
    onClick = props.onClick,
    twoToneColor = props.twoToneColor,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, AntdIcon_excluded);
  var _React$useContext = react.useContext(Context/* default */.Z),
    _React$useContext$pre = _React$useContext.prefixCls,
    prefixCls = _React$useContext$pre === void 0 ? 'anticon' : _React$useContext$pre,
    rootClassName = _React$useContext.rootClassName;
  var classString = classnames_default()(rootClassName, prefixCls, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), "".concat(prefixCls, "-spin"), !!spin || icon.name === 'loading'), className);
  var iconTabIndex = tabIndex;
  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }
  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : undefined;
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor),
    _normalizeTwoToneColo2 = (0,slicedToArray/* default */.Z)(_normalizeTwoToneColo, 2),
    primaryColor = _normalizeTwoToneColo2[0],
    secondaryColor = _normalizeTwoToneColo2[1];
  return /*#__PURE__*/react.createElement("span", (0,esm_extends/* default */.Z)({
    role: "img",
    "aria-label": icon.name
  }, restProps, {
    ref: ref,
    tabIndex: iconTabIndex,
    onClick: onClick,
    className: classString
  }), /*#__PURE__*/react.createElement(components_IconBase, {
    icon: icon,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    style: svgStyle
  }));
});
Icon.displayName = 'AntdIcon';
Icon.getTwoToneColor = getTwoToneColor;
Icon.setTwoToneColor = setTwoToneColor;
/* harmony default export */ var AntdIcon = (Icon);

/***/ }),

/***/ 15479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);

var IconContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
/* harmony default export */ __webpack_exports__["Z"] = (IconContext);

/***/ }),

/***/ 51055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_BarsOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/BarsOutlined.js
// This icon file is generated automatically.
var BarsOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"
      }
    }]
  },
  "name": "bars",
  "theme": "outlined"
};
/* harmony default export */ var asn_BarsOutlined = (BarsOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/BarsOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BarsOutlined_BarsOutlined = function BarsOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_BarsOutlined
  }));
};

/**![bars](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTJIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHpNMTA0IDIyOGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHptMCAyODRhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTAgMjg0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAweiIgLz48L3N2Zz4=) */
var RefIcon = /*#__PURE__*/react.forwardRef(BarsOutlined_BarsOutlined);
if (false) {}
/* harmony default export */ var icons_BarsOutlined = (RefIcon);

/***/ }),

/***/ 9974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_CalendarOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/CalendarOutlined.js
// This icon file is generated automatically.
var CalendarOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z"
      }
    }]
  },
  "name": "calendar",
  "theme": "outlined"
};
/* harmony default export */ var asn_CalendarOutlined = (CalendarOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/CalendarOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CalendarOutlined_CalendarOutlined = function CalendarOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_CalendarOutlined
  }));
};

/**![calendar](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MCAxODRINzEydi02NGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NjRIMzg0di02NGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NjRIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY2NjRjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjIxNmMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDY1NkgxODRWNDYwaDY1NnYzODB6TTE4NCAzOTJWMjU2aDEyOHY0OGMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04di00OGgyNTZ2NDhjMCA0LjQgMy42IDggOCA4aDU2YzQuNCAwIDgtMy42IDgtOHYtNDhoMTI4djEzNkgxODR6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/react.forwardRef(CalendarOutlined_CalendarOutlined);
if (false) {}
/* harmony default export */ var icons_CalendarOutlined = (RefIcon);

/***/ }),

/***/ 75412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_CaretDownFilled; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/CaretDownFilled.js
// This icon file is generated automatically.
var CaretDownFilled = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
      }
    }]
  },
  "name": "caret-down",
  "theme": "filled"
};
/* harmony default export */ var asn_CaretDownFilled = (CaretDownFilled);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/CaretDownFilled.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CaretDownFilled_CaretDownFilled = function CaretDownFilled(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_CaretDownFilled
  }));
};

/**![caret-down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0MC40IDMwMEgxODMuNmMtMTkuNyAwLTMwLjcgMjAuOC0xOC41IDM1bDMyOC40IDM4MC44YzkuNCAxMC45IDI3LjUgMTAuOSAzNyAwTDg1OC45IDMzNWMxMi4yLTE0LjIgMS4yLTM1LTE4LjUtMzV6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/react.forwardRef(CaretDownFilled_CaretDownFilled);
if (false) {}
/* harmony default export */ var icons_CaretDownFilled = (RefIcon);

/***/ }),

/***/ 9448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_CaretDownOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/CaretDownOutlined.js
// This icon file is generated automatically.
var CaretDownOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
      }
    }]
  },
  "name": "caret-down",
  "theme": "outlined"
};
/* harmony default export */ var asn_CaretDownOutlined = (CaretDownOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/CaretDownOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CaretDownOutlined_CaretDownOutlined = function CaretDownOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_CaretDownOutlined
  }));
};

/**![caret-down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0MC40IDMwMEgxODMuNmMtMTkuNyAwLTMwLjcgMjAuOC0xOC41IDM1bDMyOC40IDM4MC44YzkuNCAxMC45IDI3LjUgMTAuOSAzNyAwTDg1OC45IDMzNWMxMi4yLTE0LjIgMS4yLTM1LTE4LjUtMzV6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/react.forwardRef(CaretDownOutlined_CaretDownOutlined);
if (false) {}
/* harmony default export */ var icons_CaretDownOutlined = (RefIcon);

/***/ }),

/***/ 22844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_CaretUpOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/CaretUpOutlined.js
// This icon file is generated automatically.
var CaretUpOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"
      }
    }]
  },
  "name": "caret-up",
  "theme": "outlined"
};
/* harmony default export */ var asn_CaretUpOutlined = (CaretUpOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/CaretUpOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CaretUpOutlined_CaretUpOutlined = function CaretUpOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_CaretUpOutlined
  }));
};

/**![caret-up](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1OC45IDY4OUw1MzAuNSAzMDguMmMtOS40LTEwLjktMjcuNS0xMC45LTM3IDBMMTY1LjEgNjg5Yy0xMi4yIDE0LjItMS4yIDM1IDE4LjUgMzVoNjU2LjhjMTkuNyAwIDMwLjctMjAuOCAxOC41LTM1eiIgLz48L3N2Zz4=) */
var RefIcon = /*#__PURE__*/react.forwardRef(CaretUpOutlined_CaretUpOutlined);
if (false) {}
/* harmony default export */ var icons_CaretUpOutlined = (RefIcon);

/***/ }),

/***/ 14007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_CheckCircleFilled; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/CheckCircleFilled.js
// This icon file is generated automatically.
var CheckCircleFilled = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
      }
    }]
  },
  "name": "check-circle",
  "theme": "filled"
};
/* harmony default export */ var asn_CheckCircleFilled = (CheckCircleFilled);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/CheckCircleFilled.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CheckCircleFilled_CheckCircleFilled = function CheckCircleFilled(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_CheckCircleFilled
  }));
};

/**![check-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0xOTMuNSAzMDEuN2wtMjEwLjYgMjkyYTMxLjggMzEuOCAwIDAxLTUxLjcgMEwzMTguNSA0ODQuOWMtMy44LTUuMyAwLTEyLjcgNi41LTEyLjdoNDYuOWMxMC4yIDAgMTkuOSA0LjkgMjUuOSAxMy4zbDcxLjIgOTguOCAxNTcuMi0yMThjNi04LjMgMTUuNi0xMy4zIDI1LjktMTMuM0g2OTljNi41IDAgMTAuMyA3LjQgNi41IDEyLjd6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/react.forwardRef(CheckCircleFilled_CheckCircleFilled);
if (false) {}
/* harmony default export */ var icons_CheckCircleFilled = (RefIcon);

/***/ }),

/***/ 71109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_CheckOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/CheckOutlined.js
// This icon file is generated automatically.
var CheckOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
      }
    }]
  },
  "name": "check",
  "theme": "outlined"
};
/* harmony default export */ var asn_CheckOutlined = (CheckOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/CheckOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CheckOutlined_CheckOutlined = function CheckOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_CheckOutlined
  }));
};

/**![check](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTBoLTY5LjljLTkuOCAwLTE5LjEgNC41LTI1LjEgMTIuMkw0MDQuNyA3MjQuNSAyMDcgNDc0YTMyIDMyIDAgMDAtMjUuMS0xMi4ySDExMmMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlsMjczLjkgMzQ3YzEyLjggMTYuMiAzNy40IDE2LjIgNTAuMyAwbDQ4OC40LTYxOC45YzQuMS01LjEuNC0xMi44LTYuMy0xMi44eiIgLz48L3N2Zz4=) */
var RefIcon = /*#__PURE__*/react.forwardRef(CheckOutlined_CheckOutlined);
if (false) {}
/* harmony default export */ var icons_CheckOutlined = (RefIcon);

/***/ }),

/***/ 7243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_ClockCircleOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/ClockCircleOutlined.js
// This icon file is generated automatically.
var ClockCircleOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
      }
    }]
  },
  "name": "clock-circle",
  "theme": "outlined"
};
/* harmony default export */ var asn_ClockCircleOutlined = (ClockCircleOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/ClockCircleOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ClockCircleOutlined_ClockCircleOutlined = function ClockCircleOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_ClockCircleOutlined
  }));
};

/**![clock-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTY4Ni43IDYzOC42TDU0NC4xIDUzNS41VjI4OGMwLTQuNC0zLjYtOC04LThINDg4Yy00LjQgMC04IDMuNi04IDh2Mjc1LjRjMCAyLjYgMS4yIDUgMy4zIDYuNWwxNjUuNCAxMjAuNmMzLjYgMi42IDguNiAxLjggMTEuMi0xLjdsMjguNi0zOWMyLjYtMy43IDEuOC04LjctMS44LTExLjJ6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/react.forwardRef(ClockCircleOutlined_ClockCircleOutlined);
if (false) {}
/* harmony default export */ var icons_ClockCircleOutlined = (RefIcon);

/***/ }),

/***/ 16088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_CloseCircleFilled; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/CloseCircleFilled.js
// This icon file is generated automatically.
var CloseCircleFilled = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "fill-rule": "evenodd",
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
      }
    }]
  },
  "name": "close-circle",
  "theme": "filled"
};
/* harmony default export */ var asn_CloseCircleFilled = (CloseCircleFilled);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/CloseCircleFilled.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CloseCircleFilled_CloseCircleFilled = function CloseCircleFilled(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_CloseCircleFilled
  }));
};

/**![close-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNTEyIDY0YzI0Ny40IDAgNDQ4IDIwMC42IDQ0OCA0NDhTNzU5LjQgOTYwIDUxMiA5NjAgNjQgNzU5LjQgNjQgNTEyIDI2NC42IDY0IDUxMiA2NHptMTI3Ljk4IDI3NC44MmgtLjA0bC0uMDguMDZMNTEyIDQ2Ni43NSAzODQuMTQgMzM4Ljg4Yy0uMDQtLjA1LS4wNi0uMDYtLjA4LS4wNmEuMTIuMTIgMCAwMC0uMDcgMGMtLjAzIDAtLjA1LjAxLS4wOS4wNWwtNDUuMDIgNDUuMDJhLjIuMiAwIDAwLS4wNS4wOS4xMi4xMiAwIDAwMCAuMDd2LjAyYS4yNy4yNyAwIDAwLjA2LjA2TDQ2Ni43NSA1MTIgMzM4Ljg4IDYzOS44NmMtLjA1LjA0LS4wNi4wNi0uMDYuMDhhLjEyLjEyIDAgMDAwIC4wN2MwIC4wMy4wMS4wNS4wNS4wOWw0NS4wMiA0NS4wMmEuMi4yIDAgMDAuMDkuMDUuMTIuMTIgMCAwMC4wNyAwYy4wMiAwIC4wNC0uMDEuMDgtLjA1TDUxMiA1NTcuMjVsMTI3Ljg2IDEyNy44N2MuMDQuMDQuMDYuMDUuMDguMDVhLjEyLjEyIDAgMDAuMDcgMGMuMDMgMCAuMDUtLjAxLjA5LS4wNWw0NS4wMi00NS4wMmEuMi4yIDAgMDAuMDUtLjA5LjEyLjEyIDAgMDAwLS4wN3YtLjAyYS4yNy4yNyAwIDAwLS4wNS0uMDZMNTU3LjI1IDUxMmwxMjcuODctMTI3Ljg2Yy4wNC0uMDQuMDUtLjA2LjA1LS4wOGEuMTIuMTIgMCAwMDAtLjA3YzAtLjAzLS4wMS0uMDUtLjA1LS4wOWwtNDUuMDItNDUuMDJhLjIuMiAwIDAwLS4wOS0uMDUuMTIuMTIgMCAwMC0uMDcgMHoiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/react.forwardRef(CloseCircleFilled_CloseCircleFilled);
if (false) {}
/* harmony default export */ var icons_CloseCircleFilled = (RefIcon);

/***/ }),

/***/ 27289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_CloseOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/CloseOutlined.js
// This icon file is generated automatically.
var CloseOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "fill-rule": "evenodd",
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
      }
    }]
  },
  "name": "close",
  "theme": "outlined"
};
/* harmony default export */ var asn_CloseOutlined = (CloseOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/CloseOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CloseOutlined_CloseOutlined = function CloseOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_CloseOutlined
  }));
};

/**![close](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNzk5Ljg2IDE2Ni4zMWMuMDIgMCAuMDQuMDIuMDguMDZsNTcuNjkgNTcuN2MuMDQuMDMuMDUuMDUuMDYuMDhhLjEyLjEyIDAgMDEwIC4wNmMwIC4wMy0uMDIuMDUtLjA2LjA5TDU2OS45MyA1MTJsMjg3LjcgMjg3LjdjLjA0LjA0LjA1LjA2LjA2LjA5YS4xMi4xMiAwIDAxMCAuMDdjMCAuMDItLjAyLjA0LS4wNi4wOGwtNTcuNyA1Ny42OWMtLjAzLjA0LS4wNS4wNS0uMDcuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMyAwLS4wNS0uMDItLjA5LS4wNkw1MTIgNTY5LjkzbC0yODcuNyAyODcuN2MtLjA0LjA0LS4wNi4wNS0uMDkuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMiAwLS4wNC0uMDItLjA4LS4wNmwtNTcuNjktNTcuN2MtLjA0LS4wMy0uMDUtLjA1LS4wNi0uMDdhLjEyLjEyIDAgMDEwLS4wN2MwLS4wMy4wMi0uMDUuMDYtLjA5TDQ1NC4wNyA1MTJsLTI4Ny43LTI4Ny43Yy0uMDQtLjA0LS4wNS0uMDYtLjA2LS4wOWEuMTIuMTIgMCAwMTAtLjA3YzAtLjAyLjAyLS4wNC4wNi0uMDhsNTcuNy01Ny42OWMuMDMtLjA0LjA1LS4wNS4wNy0uMDZhLjEyLjEyIDAgMDEuMDcgMGMuMDMgMCAuMDUuMDIuMDkuMDZMNTEyIDQ1NC4wN2wyODcuNy0yODcuN2MuMDQtLjA0LjA2LS4wNS4wOS0uMDZhLjEyLjEyIDAgMDEuMDcgMHoiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/react.forwardRef(CloseOutlined_CloseOutlined);
if (false) {}
/* harmony default export */ var icons_CloseOutlined = (RefIcon);

/***/ }),

/***/ 30376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_CopyOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/CopyOutlined.js
// This icon file is generated automatically.
var CopyOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"
      }
    }]
  },
  "name": "copy",
  "theme": "outlined"
};
/* harmony default export */ var asn_CopyOutlined = (CopyOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/CopyOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CopyOutlined_CopyOutlined = function CopyOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_CopyOutlined
  }));
};

/**![copy](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA2NEgyOTZjLTQuNCAwLTggMy42LTggOHY1NmMwIDQuNCAzLjYgOCA4IDhoNDk2djY4OGMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04Vjk2YzAtMTcuNy0xNC4zLTMyLTMyLTMyek03MDQgMTkySDE5MmMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2NTMwLjdjMCA4LjUgMy40IDE2LjYgOS40IDIyLjZsMTczLjMgMTczLjNjMi4yIDIuMiA0LjcgNCA3LjQgNS41djEuOWg0LjJjMy41IDEuMyA3LjIgMiAxMSAySDcwNGMxNy43IDAgMzItMTQuMyAzMi0zMlYyMjRjMC0xNy43LTE0LjMtMzItMzItMzJ6TTM1MCA4NTYuMkwyNjMuOSA3NzBIMzUwdjg2LjJ6TTY2NCA4ODhINDE0Vjc0NmMwLTIyLjEtMTcuOS00MC00MC00MEgyMzJWMjY0aDQzMnY2MjR6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/react.forwardRef(CopyOutlined_CopyOutlined);
if (false) {}
/* harmony default export */ var icons_CopyOutlined = (RefIcon);

/***/ }),

/***/ 4183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_DeleteOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/DeleteOutlined.js
// This icon file is generated automatically.
var DeleteOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"
      }
    }]
  },
  "name": "delete",
  "theme": "outlined"
};
/* harmony default export */ var asn_DeleteOutlined = (DeleteOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/DeleteOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DeleteOutlined_DeleteOutlined = function DeleteOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_DeleteOutlined
  }));
};

/**![delete](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM2MCAxODRoLThjNC40IDAgOC0zLjYgOC04djhoMzA0di04YzAgNC40IDMuNiA4IDggOGgtOHY3Mmg3MnYtODBjMC0zNS4zLTI4LjctNjQtNjQtNjRIMzUyYy0zNS4zIDAtNjQgMjguNy02NCA2NHY4MGg3MnYtNzJ6bTUwNCA3MkgxNjBjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjMyYzAgNC40IDMuNiA4IDggOGg2MC40bDI0LjcgNTIzYzEuNiAzNC4xIDI5LjggNjEgNjMuOSA2MWg0NTRjMzQuMiAwIDYyLjMtMjYuOCA2My45LTYxbDI0LjctNTIzSDg4OGM0LjQgMCA4LTMuNiA4LTh2LTMyYzAtMTcuNy0xNC4zLTMyLTMyLTMyek03MzEuMyA4NDBIMjkyLjdsLTI0LjItNTEyaDQ4N2wtMjQuMiA1MTJ6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/react.forwardRef(DeleteOutlined_DeleteOutlined);
if (false) {}
/* harmony default export */ var icons_DeleteOutlined = (RefIcon);

/***/ }),

/***/ 55737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_DoubleLeftOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/DoubleLeftOutlined.js
// This icon file is generated automatically.
var DoubleLeftOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z"
      }
    }]
  },
  "name": "double-left",
  "theme": "outlined"
};
/* harmony default export */ var asn_DoubleLeftOutlined = (DoubleLeftOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/DoubleLeftOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DoubleLeftOutlined_DoubleLeftOutlined = function DoubleLeftOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_DoubleLeftOutlined
  }));
};

/**![double-left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI3Mi45IDUxMmwyNjUuNC0zMzkuMWM0LjEtNS4yLjQtMTIuOS02LjMtMTIuOWgtNzcuM2MtNC45IDAtOS42IDIuMy0xMi42IDYuMUwxODYuOCA0OTIuM2EzMS45OSAzMS45OSAwIDAwMCAzOS41bDI1NS4zIDMyNi4xYzMgMy45IDcuNyA2LjEgMTIuNiA2LjFINTMyYzYuNyAwIDEwLjQtNy43IDYuMy0xMi45TDI3Mi45IDUxMnptMzA0IDBsMjY1LjQtMzM5LjFjNC4xLTUuMi40LTEyLjktNi4zLTEyLjloLTc3LjNjLTQuOSAwLTkuNiAyLjMtMTIuNiA2LjFMNDkwLjggNDkyLjNhMzEuOTkgMzEuOTkgMCAwMDAgMzkuNWwyNTUuMyAzMjYuMWMzIDMuOSA3LjcgNi4xIDEyLjYgNi4xSDgzNmM2LjcgMCAxMC40LTcuNyA2LjMtMTIuOUw1NzYuOSA1MTJ6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/react.forwardRef(DoubleLeftOutlined_DoubleLeftOutlined);
if (false) {}
/* harmony default export */ var icons_DoubleLeftOutlined = (RefIcon);

/***/ }),

/***/ 24459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_DoubleRightOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/DoubleRightOutlined.js
// This icon file is generated automatically.
var DoubleRightOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"
      }
    }]
  },
  "name": "double-right",
  "theme": "outlined"
};
/* harmony default export */ var asn_DoubleRightOutlined = (DoubleRightOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/DoubleRightOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DoubleRightOutlined_DoubleRightOutlined = function DoubleRightOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_DoubleRightOutlined
  }));
};

/**![double-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUzMy4yIDQ5Mi4zTDI3Ny45IDE2Ni4xYy0zLTMuOS03LjctNi4xLTEyLjYtNi4xSDE4OGMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlMNDQ3LjEgNTEyIDE4MS43IDg1MS4xQTcuOTggNy45OCAwIDAwMTg4IDg2NGg3Ny4zYzQuOSAwIDkuNi0yLjMgMTIuNi02LjFsMjU1LjMtMzI2LjFjOS4xLTExLjcgOS4xLTI3LjkgMC0zOS41em0zMDQgMEw1ODEuOSAxNjYuMWMtMy0zLjktNy43LTYuMS0xMi42LTYuMUg0OTJjLTYuNyAwLTEwLjQgNy43LTYuMyAxMi45TDc1MS4xIDUxMiA0ODUuNyA4NTEuMUE3Ljk4IDcuOTggMCAwMDQ5MiA4NjRoNzcuM2M0LjkgMCA5LjYtMi4zIDEyLjYtNi4xbDI1NS4zLTMyNi4xYzkuMS0xMS43IDkuMS0yNy45IDAtMzkuNXoiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/react.forwardRef(DoubleRightOutlined_DoubleRightOutlined);
if (false) {}
/* harmony default export */ var icons_DoubleRightOutlined = (RefIcon);

/***/ }),

/***/ 16954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_DownOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/DownOutlined.js
// This icon file is generated automatically.
var DownOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
      }
    }]
  },
  "name": "down",
  "theme": "outlined"
};
/* harmony default export */ var asn_DownOutlined = (DownOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/DownOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DownOutlined_DownOutlined = function DownOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_DownOutlined
  }));
};

/**![down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4NCAyNTZoLTc1Yy01LjEgMC05LjkgMi41LTEyLjkgNi42TDUxMiA2NTQuMiAyMjcuOSAyNjIuNmMtMy00LjEtNy44LTYuNi0xMi45LTYuNmgtNzVjLTYuNSAwLTEwLjMgNy40LTYuNSAxMi43bDM1Mi42IDQ4Ni4xYzEyLjggMTcuNiAzOSAxNy42IDUxLjcgMGwzNTIuNi00ODYuMWMzLjktNS4zLjEtMTIuNy02LjQtMTIuN3oiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/react.forwardRef(DownOutlined_DownOutlined);
if (false) {}
/* harmony default export */ var icons_DownOutlined = (RefIcon);

/***/ }),

/***/ 84491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_DownloadOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/DownloadOutlined.js
// This icon file is generated automatically.
var DownloadOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
      }
    }]
  },
  "name": "download",
  "theme": "outlined"
};
/* harmony default export */ var asn_DownloadOutlined = (DownloadOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/DownloadOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DownloadOutlined_DownloadOutlined = function DownloadOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_DownloadOutlined
  }));
};

/**![download](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUwNS43IDY2MWE4IDggMCAwMDEyLjYgMGwxMTItMTQxLjdjNC4xLTUuMi40LTEyLjktNi4zLTEyLjloLTc0LjFWMTY4YzAtNC40LTMuNi04LTgtOGgtNjBjLTQuNCAwLTggMy42LTggOHYzMzguM0g0MDBjLTYuNyAwLTEwLjQgNy43LTYuMyAxMi45bDExMiAxNDEuOHpNODc4IDYyNmgtNjBjLTQuNCAwLTggMy42LTggOHYxNTRIMjE0VjYzNGMwLTQuNC0zLjYtOC04LThoLTYwYy00LjQgMC04IDMuNi04IDh2MTk4YzAgMTcuNyAxNC4zIDMyIDMyIDMyaDY4NGMxNy43IDAgMzItMTQuMyAzMi0zMlY2MzRjMC00LjQtMy42LTgtOC04eiIgLz48L3N2Zz4=) */
var RefIcon = /*#__PURE__*/react.forwardRef(DownloadOutlined_DownloadOutlined);
if (false) {}
/* harmony default export */ var icons_DownloadOutlined = (RefIcon);

/***/ }),

/***/ 46835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_EditOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/EditOutlined.js
// This icon file is generated automatically.
var EditOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"
      }
    }]
  },
  "name": "edit",
  "theme": "outlined"
};
/* harmony default export */ var asn_EditOutlined = (EditOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/EditOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EditOutlined_EditOutlined = function EditOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_EditOutlined
  }));
};

/**![edit](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI1Ny43IDc1MmMyIDAgNC0uMiA2LS41TDQzMS45IDcyMmMyLS40IDMuOS0xLjMgNS4zLTIuOGw0MjMuOS00MjMuOWE5Ljk2IDkuOTYgMCAwMDAtMTQuMUw2OTQuOSAxMTQuOWMtMS45LTEuOS00LjQtMi45LTcuMS0yLjlzLTUuMiAxLTcuMSAyLjlMMjU2LjggNTM4LjhjLTEuNSAxLjUtMi40IDMuMy0yLjggNS4zbC0yOS41IDE2OC4yYTMzLjUgMzMuNSAwIDAwOS40IDI5LjhjNi42IDYuNCAxNC45IDkuOSAyMy44IDkuOXptNjcuNC0xNzQuNEw2ODcuOCAyMTVsNzMuMyA3My4zLTM2Mi43IDM2Mi42LTg4LjkgMTUuNyAxNS42LTg5ek04ODAgODM2SDE0NGMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2MzZjMCA0LjQgMy42IDggOCA4aDc4NGM0LjQgMCA4LTMuNiA4LTh2LTM2YzAtMTcuNy0xNC4zLTMyLTMyLTMyeiIgLz48L3N2Zz4=) */
var RefIcon = /*#__PURE__*/react.forwardRef(EditOutlined_EditOutlined);
if (false) {}
/* harmony default export */ var icons_EditOutlined = (RefIcon);

/***/ }),

/***/ 5745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_EllipsisOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/EllipsisOutlined.js
// This icon file is generated automatically.
var EllipsisOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"
      }
    }]
  },
  "name": "ellipsis",
  "theme": "outlined"
};
/* harmony default export */ var asn_EllipsisOutlined = (EllipsisOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/EllipsisOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EllipsisOutlined_EllipsisOutlined = function EllipsisOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_EllipsisOutlined
  }));
};

/**![ellipsis](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE3NiA1MTFhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTI4MCAwYTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAwem0yODAgMGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHoiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/react.forwardRef(EllipsisOutlined_EllipsisOutlined);
if (false) {}
/* harmony default export */ var icons_EllipsisOutlined = (RefIcon);

/***/ }),

/***/ 54315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_EnterOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/EnterOutlined.js
// This icon file is generated automatically.
var EnterOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z"
      }
    }]
  },
  "name": "enter",
  "theme": "outlined"
};
/* harmony default export */ var asn_EnterOutlined = (EnterOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/EnterOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EnterOutlined_EnterOutlined = function EnterOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_EnterOutlined
  }));
};

/**![enter](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2NCAxNzBoLTYwYy00LjQgMC04IDMuNi04IDh2NTE4SDMxMHYtNzNjMC02LjctNy44LTEwLjUtMTMtNi4zbC0xNDEuOSAxMTJhOCA4IDAgMDAwIDEyLjZsMTQxLjkgMTEyYzUuMyA0LjIgMTMgLjQgMTMtNi4zdi03NWg0OThjMzUuMyAwIDY0LTI4LjcgNjQtNjRWMTc4YzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/react.forwardRef(EnterOutlined_EnterOutlined);
if (false) {}
/* harmony default export */ var icons_EnterOutlined = (RefIcon);

/***/ }),

/***/ 37588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_ExclamationCircleFilled; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/ExclamationCircleFilled.js
// This icon file is generated automatically.
var ExclamationCircleFilled = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
      }
    }]
  },
  "name": "exclamation-circle",
  "theme": "filled"
};
/* harmony default export */ var asn_ExclamationCircleFilled = (ExclamationCircleFilled);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/ExclamationCircleFilled.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ExclamationCircleFilled_ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_ExclamationCircleFilled
  }));
};

/**![exclamation-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0tMzIgMjMyYzAtNC40IDMuNi04IDgtOGg0OGM0LjQgMCA4IDMuNiA4IDh2MjcyYzAgNC40LTMuNiA4LTggOGgtNDhjLTQuNCAwLTgtMy42LTgtOFYyOTZ6bTMyIDQ0MGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/react.forwardRef(ExclamationCircleFilled_ExclamationCircleFilled);
if (false) {}
/* harmony default export */ var icons_ExclamationCircleFilled = (RefIcon);

/***/ }),

/***/ 29952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_EyeInvisibleOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/EyeInvisibleOutlined.js
// This icon file is generated automatically.
var EyeInvisibleOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"
      }
    }]
  },
  "name": "eye-invisible",
  "theme": "outlined"
};
/* harmony default export */ var asn_EyeInvisibleOutlined = (EyeInvisibleOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/EyeInvisibleOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EyeInvisibleOutlined_EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_EyeInvisibleOutlined
  }));
};

/**![eye-invisible](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yUTg4OS40NyAzNzUuMTEgODE2LjcgMzA1bC01MC44OCA1MC44OEM4MDcuMzEgMzk1LjUzIDg0My40NSA0NDcuNCA4NzQuNyA1MTIgNzkxLjUgNjg0LjIgNjczLjQgNzY2IDUxMiA3NjZxLTcyLjY3IDAtMTMzLjg3LTIyLjM4TDMyMyA3OTguNzVRNDA4IDgzOCA1MTIgODM4cTI4OC4zIDAgNDMwLjItMzAwLjNhNjAuMjkgNjAuMjkgMCAwMDAtNTEuNXptLTYzLjU3LTMyMC42NEw4MzYgMTIyLjg4YTggOCAwIDAwLTExLjMyIDBMNzE1LjMxIDIzMi4yUTYyNC44NiAxODYgNTEyIDE4NnEtMjg4LjMgMC00MzAuMiAzMDAuM2E2MC4zIDYwLjMgMCAwMDAgNTEuNXE1Ni42OSAxMTkuNCAxMzYuNSAxOTEuNDFMMTEyLjQ4IDgzNWE4IDggMCAwMDAgMTEuMzFMMTU1LjE3IDg4OWE4IDggMCAwMDExLjMxIDBsNzEyLjE1LTcxMi4xMmE4IDggMCAwMDAtMTEuMzJ6TTE0OS4zIDUxMkMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGM1NC41NCAwIDEwNC4xMyA5LjM2IDE0OS4xMiAyOC4zOWwtNzAuMyA3MC4zYTE3NiAxNzYgMCAwMC0yMzguMTMgMjM4LjEzbC04My40MiA4My40MkMyMjMuMSA2MzcuNDkgMTgzLjMgNTgyLjI4IDE0OS4zIDUxMnptMjQ2LjcgMGExMTIuMTEgMTEyLjExIDAgMDExNDYuMi0xMDYuNjlMNDAxLjMxIDU0Ni4yQTExMiAxMTIgMCAwMTM5NiA1MTJ6IiAvPjxwYXRoIGQ9Ik01MDggNjI0Yy0zLjQ2IDAtNi44Ny0uMTYtMTAuMjUtLjQ3bC01Mi44MiA1Mi44MmExNzYuMDkgMTc2LjA5IDAgMDAyMjcuNDItMjI3LjQybC01Mi44MiA1Mi44MmMuMzEgMy4zOC40NyA2Ljc5LjQ3IDEwLjI1YTExMS45NCAxMTEuOTQgMCAwMS0xMTIgMTEyeiIgLz48L3N2Zz4=) */
var RefIcon = /*#__PURE__*/react.forwardRef(EyeInvisibleOutlined_EyeInvisibleOutlined);
if (false) {}
/* harmony default export */ var icons_EyeInvisibleOutlined = (RefIcon);

/***/ }),

/***/ 7282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_EyeOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/EyeOutlined.js
// This icon file is generated automatically.
var EyeOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
      }
    }]
  },
  "name": "eye",
  "theme": "outlined"
};
/* harmony default export */ var asn_EyeOutlined = (EyeOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/EyeOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EyeOutlined_EyeOutlined = function EyeOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_EyeOutlined
  }));
};

/**![eye](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yQzg0Ny40IDI4Ni41IDcwNC4xIDE4NiA1MTIgMTg2Yy0xOTIuMiAwLTMzNS40IDEwMC41LTQzMC4yIDMwMC4zYTYwLjMgNjAuMyAwIDAwMCA1MS41QzE3Ni42IDczNy41IDMxOS45IDgzOCA1MTIgODM4YzE5Mi4yIDAgMzM1LjQtMTAwLjUgNDMwLjItMzAwLjMgNy43LTE2LjIgNy43LTM1IDAtNTEuNXpNNTEyIDc2NmMtMTYxLjMgMC0yNzkuNC04MS44LTM2Mi43LTI1NEMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGMxNjEuMyAwIDI3OS40IDgxLjggMzYyLjcgMjU0Qzc5MS41IDY4NC4yIDY3My40IDc2NiA1MTIgNzY2em0tNC00MzBjLTk3LjIgMC0xNzYgNzguOC0xNzYgMTc2czc4LjggMTc2IDE3NiAxNzYgMTc2LTc4LjggMTc2LTE3Ni03OC44LTE3Ni0xNzYtMTc2em0wIDI4OGMtNjEuOSAwLTExMi01MC4xLTExMi0xMTJzNTAuMS0xMTIgMTEyLTExMiAxMTIgNTAuMSAxMTIgMTEyLTUwLjEgMTEyLTExMiAxMTJ6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/react.forwardRef(EyeOutlined_EyeOutlined);
if (false) {}
/* harmony default export */ var icons_EyeOutlined = (RefIcon);

/***/ }),

/***/ 7290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_FileOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/FileOutlined.js
// This icon file is generated automatically.
var FileOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"
      }
    }]
  },
  "name": "file",
  "theme": "outlined"
};
/* harmony default export */ var asn_FileOutlined = (FileOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/FileOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileOutlined_FileOutlined = function FileOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_FileOutlined
  }));
};

/**![file](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTc5MC4yIDMyNkg2MDJWMTM3LjhMNzkwLjIgMzI2em0xLjggNTYySDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHoiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/react.forwardRef(FileOutlined_FileOutlined);
if (false) {}
/* harmony default export */ var icons_FileOutlined = (RefIcon);

/***/ }),

/***/ 64204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_FileTwoTone; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/FileTwoTone.js
// This icon file is generated automatically.
var FileTwoTone = {
  "icon": function render(primaryColor, secondaryColor) {
    return {
      "tag": "svg",
      "attrs": {
        "viewBox": "64 64 896 896",
        "focusable": "false"
      },
      "children": [{
        "tag": "path",
        "attrs": {
          "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42z",
          "fill": secondaryColor
        }
      }, {
        "tag": "path",
        "attrs": {
          "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z",
          "fill": primaryColor
        }
      }]
    };
  },
  "name": "file",
  "theme": "twotone"
};
/* harmony default export */ var asn_FileTwoTone = (FileTwoTone);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/FileTwoTone.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileTwoTone_FileTwoTone = function FileTwoTone(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_FileTwoTone
  }));
};

/**![file](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUzNCAzNTJWMTM2SDIzMnY3NTJoNTYwVjM5NEg1NzZhNDIgNDIgMCAwMS00Mi00MnoiIGZpbGw9IiNlNmY0ZmYiIC8+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTYwMiAxMzcuOEw3OTAuMiAzMjZINjAyVjEzNy44ek03OTIgODg4SDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHoiIGZpbGw9IiMxNjc3ZmYiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/react.forwardRef(FileTwoTone_FileTwoTone);
if (false) {}
/* harmony default export */ var icons_FileTwoTone = (RefIcon);

/***/ }),

/***/ 58032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_FilterFilled; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/FilterFilled.js
// This icon file is generated automatically.
var FilterFilled = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z"
      }
    }]
  },
  "name": "filter",
  "theme": "filled"
};
/* harmony default export */ var asn_FilterFilled = (FilterFilled);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/FilterFilled.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FilterFilled_FilterFilled = function FilterFilled(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_FilterFilled
  }));
};

/**![filter](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM0OSA4MzhjMCAxNy43IDE0LjIgMzIgMzEuOCAzMmgyNjIuNGMxNy42IDAgMzEuOC0xNC4zIDMxLjgtMzJWNjQySDM0OXYxOTZ6bTUzMS4xLTY4NEgxNDMuOWMtMjQuNSAwLTM5LjggMjYuNy0yNy41IDQ4bDIyMS4zIDM3NmgzNDguOGwyMjEuMy0zNzZjMTIuMS0yMS4zLTMuMi00OC0yNy43LTQ4eiIgLz48L3N2Zz4=) */
var RefIcon = /*#__PURE__*/react.forwardRef(FilterFilled_FilterFilled);
if (false) {}
/* harmony default export */ var icons_FilterFilled = (RefIcon);

/***/ }),

/***/ 11965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_FolderOpenOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/FolderOpenOutlined.js
// This icon file is generated automatically.
var FolderOpenOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z"
      }
    }]
  },
  "name": "folder-open",
  "theme": "outlined"
};
/* harmony default export */ var asn_FolderOpenOutlined = (FolderOpenOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/FolderOpenOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FolderOpenOutlined_FolderOpenOutlined = function FolderOpenOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_FolderOpenOutlined
  }));
};

/**![folder-open](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCA0NDRIODIwVjMzMC40YzAtMTcuNy0xNC4zLTMyLTMyLTMySDQ3M0wzNTUuNyAxODYuMmE4LjE1IDguMTUgMCAwMC01LjUtMi4ySDk2Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY1OTJjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjk4YzEzIDAgMjQuOC03LjkgMjkuNy0yMGwxMzQtMzMyYzEuNS0zLjggMi4zLTcuOSAyLjMtMTIgMC0xNy43LTE0LjMtMzItMzItMzJ6TTEzNiAyNTZoMTg4LjVsMTE5LjYgMTE0LjRINzQ4VjQ0NEgyMzhjLTEzIDAtMjQuOCA3LjktMjkuNyAyMEwxMzYgNjQzLjJWMjU2em02MzUuMyA1MTJIMTU5bDEwMy4zLTI1Nmg2MTIuNEw3NzEuMyA3Njh6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/react.forwardRef(FolderOpenOutlined_FolderOpenOutlined);
if (false) {}
/* harmony default export */ var icons_FolderOpenOutlined = (RefIcon);

/***/ }),

/***/ 92544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_FolderOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/FolderOutlined.js
// This icon file is generated automatically.
var FolderOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
      }
    }]
  },
  "name": "folder",
  "theme": "outlined"
};
/* harmony default export */ var asn_FolderOutlined = (FolderOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/FolderOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FolderOutlined_FolderOutlined = function FolderOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_FolderOutlined
  }));
};

/**![folder](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MCAyOTguNEg1MjFMNDAzLjcgMTg2LjJhOC4xNSA4LjE1IDAgMDAtNS41LTIuMkgxNDRjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjU5MmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg3MzZjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzMwLjRjMC0xNy43LTE0LjMtMzItMzItMzJ6TTg0MCA3NjhIMTg0VjI1NmgxODguNWwxMTkuNiAxMTQuNEg4NDBWNzY4eiIgLz48L3N2Zz4=) */
var RefIcon = /*#__PURE__*/react.forwardRef(FolderOutlined_FolderOutlined);
if (false) {}
/* harmony default export */ var icons_FolderOutlined = (RefIcon);

/***/ }),

/***/ 84216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_HolderOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/HolderOutlined.js
// This icon file is generated automatically.
var HolderOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z"
      }
    }]
  },
  "name": "holder",
  "theme": "outlined"
};
/* harmony default export */ var asn_HolderOutlined = (HolderOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/HolderOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var HolderOutlined_HolderOutlined = function HolderOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_HolderOutlined
  }));
};

/**![holder](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMwMCAyNzYuNWE1NiA1NiAwIDEwNTYtOTcgNTYgNTYgMCAwMC01NiA5N3ptMCAyODRhNTYgNTYgMCAxMDU2LTk3IDU2IDU2IDAgMDAtNTYgOTd6TTY0MCAyMjhhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMDAtMTEyIDB6bTAgMjg0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDAwLTExMiAwek0zMDAgODQ0LjVhNTYgNTYgMCAxMDU2LTk3IDU2IDU2IDAgMDAtNTYgOTd6TTY0MCA3OTZhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMDAtMTEyIDB6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/react.forwardRef(HolderOutlined_HolderOutlined);
if (false) {}
/* harmony default export */ var icons_HolderOutlined = (RefIcon);

/***/ }),

/***/ 42178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_InfoCircleFilled; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/InfoCircleFilled.js
// This icon file is generated automatically.
var InfoCircleFilled = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
      }
    }]
  },
  "name": "info-circle",
  "theme": "filled"
};
/* harmony default export */ var asn_InfoCircleFilled = (InfoCircleFilled);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/InfoCircleFilled.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var InfoCircleFilled_InfoCircleFilled = function InfoCircleFilled(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_InfoCircleFilled
  }));
};

/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0zMiA2NjRjMCA0LjQtMy42IDgtOCA4aC00OGMtNC40IDAtOC0zLjYtOC04VjQ1NmMwLTQuNCAzLjYtOCA4LThoNDhjNC40IDAgOCAzLjYgOCA4djI3MnptLTMyLTM0NGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/react.forwardRef(InfoCircleFilled_InfoCircleFilled);
if (false) {}
/* harmony default export */ var icons_InfoCircleFilled = (RefIcon);

/***/ }),

/***/ 58113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_LeftOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/LeftOutlined.js
// This icon file is generated automatically.
var LeftOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
      }
    }]
  },
  "name": "left",
  "theme": "outlined"
};
/* harmony default export */ var asn_LeftOutlined = (LeftOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/LeftOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LeftOutlined_LeftOutlined = function LeftOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_LeftOutlined
  }));
};

/**![left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcyNCAyMTguM1YxNDFjMC02LjctNy43LTEwLjQtMTIuOS02LjNMMjYwLjMgNDg2LjhhMzEuODYgMzEuODYgMCAwMDAgNTAuM2w0NTAuOCAzNTIuMWM1LjMgNC4xIDEyLjkuNCAxMi45LTYuM3YtNzcuM2MwLTQuOS0yLjMtOS42LTYuMS0xMi42bC0zNjAtMjgxIDM2MC0yODEuMWMzLjgtMyA2LjEtNy43IDYuMS0xMi42eiIgLz48L3N2Zz4=) */
var RefIcon = /*#__PURE__*/react.forwardRef(LeftOutlined_LeftOutlined);
if (false) {}
/* harmony default export */ var icons_LeftOutlined = (RefIcon);

/***/ }),

/***/ 50733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_LoadingOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/LoadingOutlined.js
// This icon file is generated automatically.
var LoadingOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
      }
    }]
  },
  "name": "loading",
  "theme": "outlined"
};
/* harmony default export */ var asn_LoadingOutlined = (LoadingOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/LoadingOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LoadingOutlined_LoadingOutlined = function LoadingOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_LoadingOutlined
  }));
};

/**![loading](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk4OCA1NDhjLTE5LjkgMC0zNi0xNi4xLTM2LTM2IDAtNTkuNC0xMS42LTExNy0zNC42LTE3MS4zYTQ0MC40NSA0NDAuNDUgMCAwMC05NC4zLTEzOS45IDQzNy43MSA0MzcuNzEgMCAwMC0xMzkuOS05NC4zQzYyOSA4My42IDU3MS40IDcyIDUxMiA3MmMtMTkuOSAwLTM2LTE2LjEtMzYtMzZzMTYuMS0zNiAzNi0zNmM2OS4xIDAgMTM2LjIgMTMuNSAxOTkuMyA0MC4zQzc3Mi4zIDY2IDgyNyAxMDMgODc0IDE1MGM0NyA0NyA4My45IDEwMS44IDEwOS43IDE2Mi43IDI2LjcgNjMuMSA0MC4yIDEzMC4yIDQwLjIgMTk5LjMuMSAxOS45LTE2IDM2LTM1LjkgMzZ6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/react.forwardRef(LoadingOutlined_LoadingOutlined);
if (false) {}
/* harmony default export */ var icons_LoadingOutlined = (RefIcon);

/***/ }),

/***/ 2094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_MinusSquareOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/MinusSquareOutlined.js
// This icon file is generated automatically.
var MinusSquareOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
      }
    }]
  },
  "name": "minus-square",
  "theme": "outlined"
};
/* harmony default export */ var asn_MinusSquareOutlined = (MinusSquareOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/MinusSquareOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MinusSquareOutlined_MinusSquareOutlined = function MinusSquareOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_MinusSquareOutlined
  }));
};

/**![minus-square](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMyOCA1NDRoMzY4YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04SDMyOGMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOHoiIC8+PHBhdGggZD0iTTg4MCAxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjE0NGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDcyOEgxODRWMTg0aDY1NnY2NTZ6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/react.forwardRef(MinusSquareOutlined_MinusSquareOutlined);
if (false) {}
/* harmony default export */ var icons_MinusSquareOutlined = (RefIcon);

/***/ }),

/***/ 31909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_PaperClipOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/PaperClipOutlined.js
// This icon file is generated automatically.
var PaperClipOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"
      }
    }]
  },
  "name": "paper-clip",
  "theme": "outlined"
};
/* harmony default export */ var asn_PaperClipOutlined = (PaperClipOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/PaperClipOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PaperClipOutlined_PaperClipOutlined = function PaperClipOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_PaperClipOutlined
  }));
};

/**![paper-clip](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc3OS4zIDE5Ni42Yy05NC4yLTk0LjItMjQ3LjYtOTQuMi0zNDEuNyAwbC0yNjEgMjYwLjhjLTEuNyAxLjctMi42IDQtMi42IDYuNHMuOSA0LjcgMi42IDYuNGwzNi45IDM2LjlhOSA5IDAgMDAxMi43IDBsMjYxLTI2MC44YzMyLjQtMzIuNCA3NS41LTUwLjIgMTIxLjMtNTAuMnM4OC45IDE3LjggMTIxLjIgNTAuMmMzMi40IDMyLjQgNTAuMiA3NS41IDUwLjIgMTIxLjIgMCA0NS44LTE3LjggODguOC01MC4yIDEyMS4ybC0yNjYgMjY1LjktNDMuMSA0My4xYy00MC4zIDQwLjMtMTA1LjggNDAuMy0xNDYuMSAwLTE5LjUtMTkuNS0zMC4yLTQ1LjQtMzAuMi03M3MxMC43LTUzLjUgMzAuMi03M2wyNjMuOS0yNjMuOGM2LjctNi42IDE1LjUtMTAuMyAyNC45LTEwLjNoLjFjOS40IDAgMTguMSAzLjcgMjQuNyAxMC4zIDYuNyA2LjcgMTAuMyAxNS41IDEwLjMgMjQuOSAwIDkuMy0zLjcgMTguMS0xMC4zIDI0LjdMMzcyLjQgNjUzYy0xLjcgMS43LTIuNiA0LTIuNiA2LjRzLjkgNC43IDIuNiA2LjRsMzYuOSAzNi45YTkgOSAwIDAwMTIuNyAwbDIxNS42LTIxNS42YzE5LjktMTkuOSAzMC44LTQ2LjMgMzAuOC03NC40cy0xMS01NC42LTMwLjgtNzQuNGMtNDEuMS00MS4xLTEwNy45LTQxLTE0OSAwTDQ2MyAzNjQgMjI0LjggNjAyLjFBMTcyLjIyIDE3Mi4yMiAwIDAwMTc0IDcyNC44YzAgNDYuMyAxOC4xIDg5LjggNTAuOCAxMjIuNSAzMy45IDMzLjggNzguMyA1MC43IDEyMi43IDUwLjcgNDQuNCAwIDg4LjgtMTYuOSAxMjIuNi01MC43bDMwOS4yLTMwOUM4MjQuOCA0OTIuNyA4NTAgNDMyIDg1MCAzNjcuNWMuMS02NC42LTI1LjEtMTI1LjMtNzAuNy0xNzAuOXoiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/react.forwardRef(PaperClipOutlined_PaperClipOutlined);
if (false) {}
/* harmony default export */ var icons_PaperClipOutlined = (RefIcon);

/***/ }),

/***/ 90396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_PictureTwoTone; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/PictureTwoTone.js
// This icon file is generated automatically.
var PictureTwoTone = {
  "icon": function render(primaryColor, secondaryColor) {
    return {
      "tag": "svg",
      "attrs": {
        "viewBox": "64 64 896 896",
        "focusable": "false"
      },
      "children": [{
        "tag": "path",
        "attrs": {
          "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z",
          "fill": primaryColor
        }
      }, {
        "tag": "path",
        "attrs": {
          "d": "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z",
          "fill": secondaryColor
        }
      }, {
        "tag": "path",
        "attrs": {
          "d": "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z",
          "fill": secondaryColor
        }
      }, {
        "tag": "path",
        "attrs": {
          "d": "M276 368a28 28 0 1056 0 28 28 0 10-56 0z",
          "fill": secondaryColor
        }
      }, {
        "tag": "path",
        "attrs": {
          "d": "M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z",
          "fill": primaryColor
        }
      }]
    };
  },
  "name": "picture",
  "theme": "twotone"
};
/* harmony default export */ var asn_PictureTwoTone = (PictureTwoTone);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/PictureTwoTone.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PictureTwoTone_PictureTwoTone = function PictureTwoTone(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_PictureTwoTone
  }));
};

/**![picture](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCAxNjBIOTZjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjY0MGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg4MzJjMTcuNyAwIDMyLTE0LjMgMzItMzJWMTkyYzAtMTcuNy0xNC4zLTMyLTMyLTMyem0tNDAgNjMySDEzNnYtMzkuOWwxMzguNS0xNjQuMyAxNTAuMSAxNzhMNjU4LjEgNDg5IDg4OCA3NjEuNlY3OTJ6bTAtMTI5LjhMNjY0LjIgMzk2LjhjLTMuMi0zLjgtOS0zLjgtMTIuMiAwTDQyNC42IDY2Ni40bC0xNDQtMTcwLjdjLTMuMi0zLjgtOS0zLjgtMTIuMiAwTDEzNiA2NTIuN1YyMzJoNzUydjQzMC4yeiIgZmlsbD0iIzE2NzdmZiIgLz48cGF0aCBkPSJNNDI0LjYgNzY1LjhsLTE1MC4xLTE3OEwxMzYgNzUyLjFWNzkyaDc1MnYtMzAuNEw2NTguMSA0ODl6IiBmaWxsPSIjZTZmNGZmIiAvPjxwYXRoIGQ9Ik0xMzYgNjUyLjdsMTMyLjQtMTU3YzMuMi0zLjggOS0zLjggMTIuMiAwbDE0NCAxNzAuN0w2NTIgMzk2LjhjMy4yLTMuOCA5LTMuOCAxMi4yIDBMODg4IDY2Mi4yVjIzMkgxMzZ2NDIwLjd6TTMwNCAyODBhODggODggMCAxMTAgMTc2IDg4IDg4IDAgMDEwLTE3NnoiIGZpbGw9IiNlNmY0ZmYiIC8+PHBhdGggZD0iTTI3NiAzNjhhMjggMjggMCAxMDU2IDAgMjggMjggMCAxMC01NiAweiIgZmlsbD0iI2U2ZjRmZiIgLz48cGF0aCBkPSJNMzA0IDQ1NmE4OCA4OCAwIDEwMC0xNzYgODggODggMCAwMDAgMTc2em0wLTExNmMxNS41IDAgMjggMTIuNSAyOCAyOHMtMTIuNSAyOC0yOCAyOC0yOC0xMi41LTI4LTI4IDEyLjUtMjggMjgtMjh6IiBmaWxsPSIjMTY3N2ZmIiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/react.forwardRef(PictureTwoTone_PictureTwoTone);
if (false) {}
/* harmony default export */ var icons_PictureTwoTone = (RefIcon);

/***/ }),

/***/ 81074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_PlusOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/PlusOutlined.js
// This icon file is generated automatically.
var PlusOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"
      }
    }]
  },
  "name": "plus",
  "theme": "outlined"
};
/* harmony default export */ var asn_PlusOutlined = (PlusOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/PlusOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PlusOutlined_PlusOutlined = function PlusOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_PlusOutlined
  }));
};

/**![plus](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ4MiAxNTJoNjBxOCAwIDggOHY3MDRxMCA4LTggOGgtNjBxLTggMC04LThWMTYwcTAtOCA4LTh6IiAvPjxwYXRoIGQ9Ik0xOTIgNDc0aDY3MnE4IDAgOCA4djYwcTAgOC04IDhIMTYwcS04IDAtOC04di02MHEwLTggOC04eiIgLz48L3N2Zz4=) */
var RefIcon = /*#__PURE__*/react.forwardRef(PlusOutlined_PlusOutlined);
if (false) {}
/* harmony default export */ var icons_PlusOutlined = (RefIcon);

/***/ }),

/***/ 86856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_PlusSquareOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/PlusSquareOutlined.js
// This icon file is generated automatically.
var PlusSquareOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
      }
    }]
  },
  "name": "plus-square",
  "theme": "outlined"
};
/* harmony default export */ var asn_PlusSquareOutlined = (PlusSquareOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/PlusSquareOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PlusSquareOutlined_PlusSquareOutlined = function PlusSquareOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_PlusSquareOutlined
  }));
};

/**![plus-square](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMyOCA1NDRoMTUydjE1MmMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04VjU0NGgxNTJjNC40IDAgOC0zLjYgOC04di00OGMwLTQuNC0zLjYtOC04LThINTQ0VjMyOGMwLTQuNC0zLjYtOC04LThoLTQ4Yy00LjQgMC04IDMuNi04IDh2MTUySDMyOGMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOHoiIC8+PHBhdGggZD0iTTg4MCAxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjE0NGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDcyOEgxODRWMTg0aDY1NnY2NTZ6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/react.forwardRef(PlusSquareOutlined_PlusSquareOutlined);
if (false) {}
/* harmony default export */ var icons_PlusSquareOutlined = (RefIcon);

/***/ }),

/***/ 95092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_RightOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/RightOutlined.js
// This icon file is generated automatically.
var RightOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
      }
    }]
  },
  "name": "right",
  "theme": "outlined"
};
/* harmony default export */ var asn_RightOutlined = (RightOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/RightOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RightOutlined_RightOutlined = function RightOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_RightOutlined
  }));
};

/**![right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc2NS43IDQ4Ni44TDMxNC45IDEzNC43QTcuOTcgNy45NyAwIDAwMzAyIDE0MXY3Ny4zYzAgNC45IDIuMyA5LjYgNi4xIDEyLjZsMzYwIDI4MS4xLTM2MCAyODEuMWMtMy45IDMtNi4xIDcuNy02LjEgMTIuNlY4ODNjMCA2LjcgNy43IDEwLjQgMTIuOSA2LjNsNDUwLjgtMzUyLjFhMzEuOTYgMzEuOTYgMCAwMDAtNTAuNHoiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/react.forwardRef(RightOutlined_RightOutlined);
if (false) {}
/* harmony default export */ var icons_RightOutlined = (RefIcon);

/***/ }),

/***/ 50780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_RotateLeftOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/RotateLeftOutlined.js
// This icon file is generated automatically.
var RotateLeftOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "defs",
      "attrs": {},
      "children": [{
        "tag": "style",
        "attrs": {}
      }]
    }, {
      "tag": "path",
      "attrs": {
        "d": "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z"
      }
    }]
  },
  "name": "rotate-left",
  "theme": "outlined"
};
/* harmony default export */ var asn_RotateLeftOutlined = (RotateLeftOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/RotateLeftOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RotateLeftOutlined_RotateLeftOutlined = function RotateLeftOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_RotateLeftOutlined
  }));
};

/**![rotate-left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik02NzIgNDE4SDE0NGMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2NDE0YzAgMTcuNyAxNC4zIDMyIDMyIDMyaDUyOGMxNy43IDAgMzItMTQuMyAzMi0zMlY0NTBjMC0xNy43LTE0LjMtMzItMzItMzJ6bS00NCA0MDJIMTg4VjQ5NGg0NDB2MzI2eiIgLz48cGF0aCBkPSJNODE5LjMgMzI4LjVjLTc4LjgtMTAwLjctMTk2LTE1My42LTMxNC42LTE1NC4ybC0uMi02NGMwLTYuNS03LjYtMTAuMS0xMi42LTYuMWwtMTI4IDEwMWMtNCAzLjEtMy45IDkuMSAwIDEyLjNMNDkyIDMxOC42YzUuMSA0IDEyLjcuNCAxMi42LTYuMXYtNjMuOWMxMi45LjEgMjUuOS45IDM4LjggMi41IDQyLjEgNS4yIDgyLjEgMTguMiAxMTkgMzguNyAzOC4xIDIxLjIgNzEuMiA0OS43IDk4LjQgODQuMyAyNy4xIDM0LjcgNDYuNyA3My43IDU4LjEgMTE1LjhhMzI1Ljk1IDMyNS45NSAwIDAxNi41IDE0MC45aDc0LjljMTQuOC0xMDMuNi0xMS4zLTIxMy04MS0zMDIuM3oiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/react.forwardRef(RotateLeftOutlined_RotateLeftOutlined);
if (false) {}
/* harmony default export */ var icons_RotateLeftOutlined = (RefIcon);

/***/ }),

/***/ 58421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_RotateRightOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/RotateRightOutlined.js
// This icon file is generated automatically.
var RotateRightOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "defs",
      "attrs": {},
      "children": [{
        "tag": "style",
        "attrs": {}
      }]
    }, {
      "tag": "path",
      "attrs": {
        "d": "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z"
      }
    }]
  },
  "name": "rotate-right",
  "theme": "outlined"
};
/* harmony default export */ var asn_RotateRightOutlined = (RotateRightOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/RotateRightOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RotateRightOutlined_RotateRightOutlined = function RotateRightOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_RotateRightOutlined
  }));
};

/**![rotate-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik00ODAuNSAyNTEuMmMxMy0xLjYgMjUuOS0yLjQgMzguOC0yLjV2NjMuOWMwIDYuNSA3LjUgMTAuMSAxMi42IDYuMUw2NjAgMjE3LjZjNC0zLjIgNC05LjIgMC0xMi4zbC0xMjgtMTAxYy01LjEtNC0xMi42LS40LTEyLjYgNi4xbC0uMiA2NGMtMTE4LjYuNS0yMzUuOCA1My40LTMxNC42IDE1NC4yQTM5OS43NSAzOTkuNzUgMCAwMDEyMy41IDYzMWg3NC45Yy0uOS01LjMtMS43LTEwLjctMi40LTE2LjEtNS4xLTQyLjEtMi4xLTg0LjEgOC45LTEyNC44IDExLjQtNDIuMiAzMS04MS4xIDU4LjEtMTE1LjggMjcuMi0zNC43IDYwLjMtNjMuMiA5OC40LTg0LjMgMzctMjAuNiA3Ni45LTMzLjYgMTE5LjEtMzguOHoiIC8+PHBhdGggZD0iTTg4MCA0MThIMzUyYy0xNy43IDAtMzIgMTQuMy0zMiAzMnY0MTRjMCAxNy43IDE0LjMgMzIgMzIgMzJoNTI4YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjQ1MGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQ0IDQwMkgzOTZWNDk0aDQ0MHYzMjZ6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/react.forwardRef(RotateRightOutlined_RotateRightOutlined);
if (false) {}
/* harmony default export */ var icons_RotateRightOutlined = (RefIcon);

/***/ }),

/***/ 66148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_SearchOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/SearchOutlined.js
// This icon file is generated automatically.
var SearchOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
      }
    }]
  },
  "name": "search",
  "theme": "outlined"
};
/* harmony default export */ var asn_SearchOutlined = (SearchOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/SearchOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SearchOutlined_SearchOutlined = function SearchOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_SearchOutlined
  }));
};

/**![search](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOS42IDg1NC41TDY0OS45IDU5NC44QzY5MC4yIDU0Mi43IDcxMiA0NzkgNzEyIDQxMmMwLTgwLjItMzEuMy0xNTUuNC04Ny45LTIxMi4xLTU2LjYtNTYuNy0xMzItODcuOS0yMTIuMS04Ny45cy0xNTUuNSAzMS4zLTIxMi4xIDg3LjlDMTQzLjIgMjU2LjUgMTEyIDMzMS44IDExMiA0MTJjMCA4MC4xIDMxLjMgMTU1LjUgODcuOSAyMTIuMUMyNTYuNSA2ODAuOCAzMzEuOCA3MTIgNDEyIDcxMmM2NyAwIDEzMC42LTIxLjggMTgyLjctNjJsMjU5LjcgMjU5LjZhOC4yIDguMiAwIDAwMTEuNiAwbDQzLjYtNDMuNWE4LjIgOC4yIDAgMDAwLTExLjZ6TTU3MC40IDU3MC40QzUyOCA2MTIuNyA0NzEuOCA2MzYgNDEyIDYzNnMtMTE2LTIzLjMtMTU4LjQtNjUuNkMyMTEuMyA1MjggMTg4IDQ3MS44IDE4OCA0MTJzMjMuMy0xMTYuMSA2NS42LTE1OC40QzI5NiAyMTEuMyAzNTIuMiAxODggNDEyIDE4OHMxMTYuMSAyMy4yIDE1OC40IDY1LjZTNjM2IDM1Mi4yIDYzNiA0MTJzLTIzLjMgMTE2LjEtNjUuNiAxNTguNHoiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/react.forwardRef(SearchOutlined_SearchOutlined);
if (false) {}
/* harmony default export */ var icons_SearchOutlined = (RefIcon);

/***/ }),

/***/ 53624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_SwapOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/SwapOutlined.js
// This icon file is generated automatically.
var SwapOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
      }
    }]
  },
  "name": "swap",
  "theme": "outlined"
};
/* harmony default export */ var asn_SwapOutlined = (SwapOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/SwapOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SwapOutlined_SwapOutlined = function SwapOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_SwapOutlined
  }));
};

/**![swap](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0Ny45IDU5MkgxNTJjLTQuNCAwLTggMy42LTggOHY2MGMwIDQuNCAzLjYgOCA4IDhoNjA1LjJMNjEyLjkgODUxYy00LjEgNS4yLS40IDEzIDYuMyAxM2g3Mi41YzQuOSAwIDkuNS0yLjIgMTIuNi02LjFsMTY4LjgtMjE0LjFjMTYuNS0yMSAxLjYtNTEuOC0yNS4yLTUxLjh6TTg3MiAzNTZIMjY2LjhsMTQ0LjMtMTgzYzQuMS01LjIuNC0xMy02LjMtMTNoLTcyLjVjLTQuOSAwLTkuNSAyLjItMTIuNiA2LjFMMTUwLjkgMzgwLjJjLTE2LjUgMjEtMS42IDUxLjggMjUuMSA1MS44aDY5NmM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/react.forwardRef(SwapOutlined_SwapOutlined);
if (false) {}
/* harmony default export */ var icons_SwapOutlined = (RefIcon);

/***/ }),

/***/ 55056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_SwapRightOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/SwapRightOutlined.js
// This icon file is generated automatically.
var SwapRightOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z"
      }
    }]
  },
  "name": "swap-right",
  "theme": "outlined"
};
/* harmony default export */ var asn_SwapRightOutlined = (SwapRightOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/SwapRightOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SwapRightOutlined_SwapRightOutlined = function SwapRightOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_SwapRightOutlined
  }));
};

/**![swap-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg3My4xIDU5Ni4ybC0xNjQtMjA4QTMyIDMyIDAgMDA2ODQgMzc2aC02NC44Yy02LjcgMC0xMC40IDcuNy02LjMgMTNsMTQ0LjMgMTgzSDE1MmMtNC40IDAtOCAzLjYtOCA4djYwYzAgNC40IDMuNiA4IDggOGg2OTUuOWMyNi44IDAgNDEuNy0zMC44IDI1LjItNTEuOHoiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/react.forwardRef(SwapRightOutlined_SwapRightOutlined);
if (false) {}
/* harmony default export */ var icons_SwapRightOutlined = (RefIcon);

/***/ }),

/***/ 47997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_ZoomInOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/ZoomInOutlined.js
// This icon file is generated automatically.
var ZoomInOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
      }
    }]
  },
  "name": "zoom-in",
  "theme": "outlined"
};
/* harmony default export */ var asn_ZoomInOutlined = (ZoomInOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/ZoomInOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ZoomInOutlined_ZoomInOutlined = function ZoomInOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_ZoomInOutlined
  }));
};

/**![zoom-in](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYzNyA0NDNINTE5VjMwOWMwLTQuNC0zLjYtOC04LThoLTYwYy00LjQgMC04IDMuNi04IDh2MTM0SDMyNWMtNC40IDAtOCAzLjYtOCA4djYwYzAgNC40IDMuNiA4IDggOGgxMTh2MTM0YzAgNC40IDMuNiA4IDggOGg2MGM0LjQgMCA4LTMuNiA4LThWNTE5aDExOGM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOHptMjg0IDQyNEw3NzUgNzIxYzEyMi4xLTE0OC45IDExMy42LTM2OS41LTI2LTUwOS0xNDgtMTQ4LjEtMzg4LjQtMTQ4LjEtNTM3IDAtMTQ4LjEgMTQ4LjYtMTQ4LjEgMzg5IDAgNTM3IDEzOS41IDEzOS42IDM2MC4xIDE0OC4xIDUwOSAyNmwxNDYgMTQ2YzMuMiAyLjggOC4zIDIuOCAxMSAwbDQzLTQzYzIuOC0yLjcgMi44LTcuOCAwLTExek02OTYgNjk2Yy0xMTguOCAxMTguNy0zMTEuMiAxMTguNy00MzAgMC0xMTguNy0xMTguOC0xMTguNy0zMTEuMiAwLTQzMCAxMTguOC0xMTguNyAzMTEuMi0xMTguNyA0MzAgMCAxMTguNyAxMTguOCAxMTguNyAzMTEuMiAwIDQzMHoiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/react.forwardRef(ZoomInOutlined_ZoomInOutlined);
if (false) {}
/* harmony default export */ var icons_ZoomInOutlined = (RefIcon);

/***/ }),

/***/ 6106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_ZoomOutOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/ZoomOutOutlined.js
// This icon file is generated automatically.
var ZoomOutOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
      }
    }]
  },
  "name": "zoom-out",
  "theme": "outlined"
};
/* harmony default export */ var asn_ZoomOutOutlined = (ZoomOutOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/ZoomOutOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ZoomOutOutlined_ZoomOutOutlined = function ZoomOutOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_ZoomOutOutlined
  }));
};

/**![zoom-out](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYzNyA0NDNIMzI1Yy00LjQgMC04IDMuNi04IDh2NjBjMCA0LjQgMy42IDggOCA4aDMxMmM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOHptMjg0IDQyNEw3NzUgNzIxYzEyMi4xLTE0OC45IDExMy42LTM2OS41LTI2LTUwOS0xNDgtMTQ4LjEtMzg4LjQtMTQ4LjEtNTM3IDAtMTQ4LjEgMTQ4LjYtMTQ4LjEgMzg5IDAgNTM3IDEzOS41IDEzOS42IDM2MC4xIDE0OC4xIDUwOSAyNmwxNDYgMTQ2YzMuMiAyLjggOC4zIDIuOCAxMSAwbDQzLTQzYzIuOC0yLjcgMi44LTcuOCAwLTExek02OTYgNjk2Yy0xMTguOCAxMTguNy0zMTEuMiAxMTguNy00MzAgMC0xMTguNy0xMTguOC0xMTguNy0zMTEuMiAwLTQzMCAxMTguOC0xMTguNyAzMTEuMi0xMTguNyA0MzAgMCAxMTguNyAxMTguOCAxMTguNyAzMTEuMiAwIDQzMHoiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/react.forwardRef(ZoomOutOutlined_ZoomOutOutlined);
if (false) {}
/* harmony default export */ var icons_ZoomOutOutlined = (RefIcon);

/***/ }),

/***/ 92608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createCache; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/sheet/dist/emotion-sheet.esm.js
var isDevelopment = false;

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */

  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  } // this function should always return with a value
  // TS can't understand it though so we make it stop complaining here

  return undefined;
}
function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);
  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }
  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}
var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;
    this._insertTag = function (tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options.speedy === undefined ? !isDevelopment : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {}
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function (tag) {
      var _tag$parentNode;
      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet;
}();

;// CONCATENATED MODULE: ./node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash(value, length) {
  return Utility_charat(value, 0) ^ 45 ? (((length << 2 ^ Utility_charat(value, 0)) << 2 ^ Utility_charat(value, 1)) << 2 ^ Utility_charat(value, 2)) << 2 ^ Utility_charat(value, 3) : 0;
}

/**
 * @param {string} value
 * @return {string}
 */
function trim(value) {
  return value.trim();
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function Utility_match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function Utility_replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof(value, search) {
  return value.indexOf(search);
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat(value, index) {
  return value.charCodeAt(index) | 0;
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr(value, begin, end) {
  return value.slice(begin, end);
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen(value) {
  return value.length;
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof(value) {
  return value.length;
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append(value, array) {
  return array.push(value), value;
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine(array, callback) {
  return array.map(callback).join('');
}
;// CONCATENATED MODULE: ./node_modules/stylis/src/Tokenizer.js

var line = 1;
var column = 1;
var Tokenizer_length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node(value, root, parent, type, props, children, length) {
  return {
    value: value,
    root: root,
    parent: parent,
    type: type,
    props: props,
    children: children,
    line: line,
    column: column,
    length: length,
    return: ''
  };
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function Tokenizer_copy(root, props) {
  return Utility_assign(node('', null, null, '', null, null, 0), root, {
    length: -root.length
  }, props);
}

/**
 * @return {number}
 */
function Tokenizer_char() {
  return character;
}

/**
 * @return {number}
 */
function prev() {
  character = position > 0 ? Utility_charat(characters, --position) : 0;
  if (column--, character === 10) column = 1, line--;
  return character;
}

/**
 * @return {number}
 */
function next() {
  character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0;
  if (column++, character === 10) column = 1, line++;
  return character;
}

/**
 * @return {number}
 */
function peek() {
  return Utility_charat(characters, position);
}

/**
 * @return {number}
 */
function caret() {
  return position;
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice(begin, end) {
  return Utility_substr(characters, begin, end);
}

/**
 * @param {number} type
 * @return {number}
 */
function token(type) {
  switch (type) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc(value) {
  return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, [];
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc(value) {
  return characters = '', value;
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit(type) {
  return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize(value) {
  return dealloc(tokenizer(alloc(value)));
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace(type) {
  while (character = peek()) if (character < 33) next();else break;
  return token(type) > 2 || token(character) > 3 ? '' : ' ';
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer(children) {
  while (next()) switch (token(character)) {
    case 0:
      append(identifier(position - 1), children);
      break;
    case 2:
      append(delimit(character), children);
      break;
    default:
      append(from(character), children);
  }
  return children;
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping(index, count) {
  while (--count && next())
  // not 0-9 A-F a-f
  if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97) break;
  return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32));
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter(type) {
  while (next()) switch (character) {
    // ] ) " '
    case type:
      return position;
    // " '
    case 34:
    case 39:
      if (type !== 34 && type !== 39) delimiter(character);
      break;
    // (
    case 40:
      if (type === 41) delimiter(type);
      break;
    // \
    case 92:
      next();
      break;
  }
  return position;
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter(type, index) {
  while (next())
  // //
  if (type + character === 47 + 10) break;
  // /*
  else if (type + character === 42 + 42 && peek() === 47) break;
  return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next());
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier(index) {
  while (!token(peek())) next();
  return slice(index, position);
}
;// CONCATENATED MODULE: ./node_modules/stylis/src/Enum.js
var Enum_MS = '-ms-';
var Enum_MOZ = '-moz-';
var Enum_WEBKIT = '-webkit-';
var COMMENT = 'comm';
var Enum_RULESET = 'rule';
var Enum_DECLARATION = 'decl';
var PAGE = '@page';
var MEDIA = '@media';
var IMPORT = '@import';
var CHARSET = '@charset';
var VIEWPORT = '@viewport';
var SUPPORTS = '@supports';
var DOCUMENT = '@document';
var NAMESPACE = '@namespace';
var Enum_KEYFRAMES = '@keyframes';
var FONT_FACE = '@font-face';
var COUNTER_STYLE = '@counter-style';
var FONT_FEATURE_VALUES = '@font-feature-values';
var LAYER = '@layer';
;// CONCATENATED MODULE: ./node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function Serializer_serialize(children, callback) {
  var output = '';
  var length = Utility_sizeof(children);
  for (var i = 0; i < length; i++) output += callback(children[i], i, children, callback) || '';
  return output;
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify(element, index, children, callback) {
  switch (element.type) {
    case LAYER:
      if (element.children.length) break;
    case IMPORT:
    case Enum_DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return '';
    case Enum_KEYFRAMES:
      return element.return = element.value + '{' + Serializer_serialize(element.children, callback) + '}';
    case Enum_RULESET:
      element.value = element.props.join(',');
  }
  return Utility_strlen(children = Serializer_serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}
;// CONCATENATED MODULE: ./node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware(collection) {
  var length = Utility_sizeof(collection);
  return function (element, index, children, callback) {
    var output = '';
    for (var i = 0; i < length; i++) output += collection[i](element, index, children, callback) || '';
    return output;
  };
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet(callback) {
  return function (element) {
    if (!element.root) if (element = element.return) callback(element);
  };
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element.return) switch (element.type) {
    case DECLARATION:
      element.return = prefix(element.value, element.length, children);
      return;
    case KEYFRAMES:
      return serialize([copy(element, {
        value: replace(element.value, '@', '@' + WEBKIT)
      })], callback);
    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize([copy(element, {
              props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder
          case '::placeholder':
            return serialize([copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }
        return '';
      });
  }
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace(element) {
  switch (element.type) {
    case RULESET:
      element.props = element.props.map(function (value) {
        return combine(tokenize(value), function (value, index, children) {
          switch (charat(value, 0)) {
            // \f
            case 12:
              return substr(value, 1, strlen(value));
            // \0 ( + > ~
            case 0:
            case 40:
            case 43:
            case 62:
            case 126:
              return value;
            // :
            case 58:
              if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1);
            // \s
            case 32:
              return index === 1 ? '' : value;
            default:
              switch (index) {
                case 0:
                  element = value;
                  return sizeof(children) > 1 ? '' : value;
                case index = sizeof(children) - 1:
                case 2:
                  return index === 2 ? value + element + element : value + element;
                default:
                  return value;
              }
          }
        });
      });
  }
}
;// CONCATENATED MODULE: ./node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile(value) {
  return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value));
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index = 0;
  var offset = 0;
  var length = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character = 0;
  var type = '';
  var props = rules;
  var children = rulesets;
  var reference = rule;
  var characters = type;
  while (scanning) switch (previous = character, character = next()) {
    // (
    case 40:
      if (previous != 108 && Utility_charat(characters, length - 1) == 58) {
        if (indexof(characters += Utility_replace(delimit(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
        break;
      }
    // " ' [
    case 34:
    case 39:
    case 91:
      characters += delimit(character);
      break;
    // \t \n \r \s
    case 9:
    case 10:
    case 13:
    case 32:
      characters += whitespace(previous);
      break;
    // \
    case 92:
      characters += escaping(caret() - 1, 7);
      continue;
    // /
    case 47:
      switch (peek()) {
        case 42:
        case 47:
          Utility_append(comment(commenter(next(), caret()), root, parent), declarations);
          break;
        default:
          characters += '/';
      }
      break;
    // {
    case 123 * variable:
      points[index++] = Utility_strlen(characters) * ampersand;
    // } ; \0
    case 125 * variable:
    case 59:
    case 0:
      switch (character) {
        // \0 }
        case 0:
        case 125:
          scanning = 0;
        // ;
        case 59 + offset:
          if (ampersand == -1) characters = Utility_replace(characters, /\f/g, '');
          if (property > 0 && Utility_strlen(characters) - length) Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(Utility_replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
          break;
        // @ ;
        case 59:
          characters += ';';
        // { rule/at-rule
        default:
          Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
          if (character === 123) if (offset === 0) parse(characters, root, reference, reference, props, rulesets, length, points, children);else switch (atrule === 99 && Utility_charat(characters, 3) === 110 ? 100 : atrule) {
            // d l m s
            case 100:
            case 108:
            case 109:
            case 115:
              parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
              break;
            default:
              parse(characters, reference, reference, reference, [''], children, 0, points, children);
          }
      }
      index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
      break;
    // :
    case 58:
      length = 1 + Utility_strlen(characters), property = previous;
    default:
      if (variable < 1) if (character == 123) --variable;else if (character == 125 && variable++ == 0 && prev() == 125) continue;
      switch (characters += Utility_from(character), character * variable) {
        // &
        case 38:
          ampersand = offset > 0 ? 1 : (characters += '\f', -1);
          break;
        // ,
        case 44:
          points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1;
          break;
        // @
        case 64:
          // -
          if (peek() === 45) characters += delimit(next());
          atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++;
          break;
        // -
        case 45:
          if (previous === 45 && Utility_strlen(characters) == 2) variable = 0;
      }
  }
  return rulesets;
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset(value, root, parent, index, offset, rules, points, type, props, children, length) {
  var post = offset - 1;
  var rule = offset === 0 ? rules : [''];
  var size = Utility_sizeof(rule);
  for (var i = 0, j = 0, k = 0; i < index; ++i) for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x) if (z = trim(j > 0 ? rule[x] + ' ' + y : Utility_replace(y, /&\f/g, rule[x]))) props[k++] = z;
  return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length);
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment(value, root, parent) {
  return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0);
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration(value, root, parent, length) {
  return node(value, root, parent, Enum_DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length);
}
;// CONCATENATED MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js




var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;
  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }
    if (token(character)) {
      break;
    }
    next();
  }
  return slice(begin, position);
};
var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;
  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }
        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;
      case 2:
        parsed[index] += delimit(character);
        break;
      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());
  return parsed;
};
var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11

var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent ||
  // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }
  var value = element.value;
  var parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case

  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */ && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"

  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;
    if (
    // charcode for l
    value.charCodeAt(0) === 108 &&
    // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};

/* eslint-disable no-fallthrough */

function emotion_cache_browser_esm_prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return Enum_WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Enum_WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Enum_WEBKIT + value + Enum_MOZ + value + Enum_MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return Enum_WEBKIT + value + Enum_MS + value + value;
    // order

    case 6165:
      return Enum_WEBKIT + value + Enum_MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return Enum_WEBKIT + value + Utility_replace(value, /(\w+).+(:[^]+)/, Enum_WEBKIT + 'box-$1$2' + Enum_MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return Enum_WEBKIT + value + Enum_MS + 'flex-item-' + Utility_replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return Enum_WEBKIT + value + Enum_MS + 'flex-line-pack' + Utility_replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return Enum_WEBKIT + 'box-' + Utility_replace(value, '-grow', '') + Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return Enum_WEBKIT + Utility_replace(value, /([^-])(transform)/g, '$1' + Enum_WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return Utility_replace(Utility_replace(Utility_replace(value, /(zoom-|grab)/, Enum_WEBKIT + '$1'), /(image-set)/, Enum_WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return Utility_replace(value, /(image-set\([^]*)/, Enum_WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return Utility_replace(Utility_replace(value, /(.+:)(flex-)?(.*)/, Enum_WEBKIT + 'box-pack:$3' + Enum_MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + Enum_WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Utility_replace(value, /(.+)-inline(.+)/, Enum_WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (Utility_strlen(value) - 1 - length > 6) switch (Utility_charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (Utility_charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return Utility_replace(value, /(.+:)(.+)-([^]+)/, '$1' + Enum_WEBKIT + '$2-$3' + '$1' + Enum_MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? emotion_cache_browser_esm_prefix(Utility_replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (Utility_charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return Utility_replace(value, ':', ':' + Enum_WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return Utility_replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + Enum_WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + Enum_WEBKIT + '$2$3' + '$1' + Enum_MS + '$2box$3') + value;
      }
      break;
    // writing-mode

    case 5936:
      switch (Utility_charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }
      return Enum_WEBKIT + value + Enum_MS + value + value;
  }
  return value;
}
var emotion_cache_browser_esm_prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case Enum_DECLARATION:
      element["return"] = emotion_cache_browser_esm_prefix(element.value, element.length);
      break;
    case Enum_KEYFRAMES:
      return Serializer_serialize([Tokenizer_copy(element, {
        value: Utility_replace(element.value, '@', '@' + Enum_WEBKIT)
      })], callback);
    case Enum_RULESET:
      if (element.length) return Utility_combine(element.props, function (value) {
        switch (Utility_match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(read-\w+)/, ':' + Enum_MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_WEBKIT + 'input-$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_MOZ + '$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, Enum_MS + 'input-$1')]
            })], callback);
        }
        return '';
      });
  }
};
var defaultStylisPlugins = [emotion_cache_browser_esm_prefixer];
var createCache = function createCache(options) {
  var key = options.key;
  if (key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');
      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options.container || document.head;
    Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' ');
      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }
      nodesToHydrate.push(node);
    });
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
      return Serializer_serialize(compile(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }
  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};


/***/ }),

/***/ 96531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ memoize; }
/* harmony export */ });
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}


/***/ }),

/***/ 17867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iv": function() { return /* binding */ css; },
  "tZ": function() { return /* binding */ jsx; },
  "F4": function() { return /* binding */ keyframes; }
});

// UNUSED EXPORTS: CacheProvider, ClassNames, Global, ThemeContext, ThemeProvider, __unsafe_useEmotionCache, createElement, useTheme, withEmotionCache, withTheme

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 7 modules
var emotion_cache_browser_esm = __webpack_require__(92608);
;// CONCATENATED MODULE: ./node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var isBrowser = true;
function emotion_utils_browser_esm_getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var emotion_utils_browser_esm_registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if (
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false ||
  // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var emotion_utils_browser_esm_insertStyles = function insertStyles(cache, serialized, isStringTag) {
  emotion_utils_browser_esm_registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;
  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;
    do {
      cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
      current = current.next;
    } while (current !== undefined);
  }
};

;// CONCATENATED MODULE: ./node_modules/@emotion/hash/dist/emotion-hash.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
    i = 0,
    len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array

  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.

  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(96531);
;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.esm.js



var emotion_serialize_esm_isDevelopment = false;
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};
var processStyleName = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }
  return value;
};
var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }
  var componentSelector = interpolation;
  if (componentSelector.__emotion_styles !== undefined) {
    return componentSelector;
  }
  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }
    case 'object':
      {
        var keyframes = interpolation;
        if (keyframes.anim === 1) {
          cursor = {
            name: keyframes.name,
            styles: keyframes.styles,
            next: cursor
          };
          return keyframes.name;
        }
        var serializedStyles = interpolation;
        if (serializedStyles.styles !== undefined) {
          var next = serializedStyles.next;
          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }
          var styles = serializedStyles.styles + ";";
          return styles;
        }
        return createStringFromObject(mergedProps, registered, interpolation);
      }
    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }
        break;
      }
  } // finalize string values (regular strings and functions interpolated into css calls)

  var asString = interpolation;
  if (registered == null) {
    return asString;
  }
  var cached = registered[asString];
  return cached !== undefined ? cached : asString;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = '';
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value = obj[key];
      if (typeof value !== 'object') {
        var asString = value;
        if (registered != null && registered[asString] !== undefined) {
          string += key + "{" + registered[asString] + "}";
        } else if (isProcessableValue(asString)) {
          string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (key === 'NO_COMPONENT_SELECTOR' && emotion_serialize_esm_isDevelopment) {
          throw new Error(noComponentSelectorMessage);
        }
        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(key) + ":" + interpolated + ";";
                break;
              }
            default:
              {
                string += key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list

var cursor;
function emotion_serialize_esm_serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }
  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];
  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;
    styles += asTemplateStringsArr[0];
  } // we start at 1 since we've already handled the first arg

  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      var templateStringsArr = strings;
      styles += templateStringsArr[i];
    }
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time

  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + match[1];
  }
  var name = murmur2(styles) + identifierName;
  return {
    name: name,
    styles: styles,
    next: cursor
  };
}

;// CONCATENATED MODULE: ./node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js

var syncFallback = function syncFallback(create) {
  return create();
};
var useInsertionEffect = react_namespaceObject['useInsertion' + 'Effect'] ? react_namespaceObject['useInsertion' + 'Effect'] : false;
var emotion_use_insertion_effect_with_fallbacks_browser_esm_useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var emotion_use_insertion_effect_with_fallbacks_browser_esm_useInsertionEffectWithLayoutFallback = useInsertionEffect || react.useLayoutEffect;

;// CONCATENATED MODULE: ./node_modules/@emotion/react/dist/emotion-element-f0de968e.browser.esm.js









var emotion_element_f0de968e_browser_esm_isDevelopment = false;
var EmotionCacheContext = /* #__PURE__ */react.createContext(
// we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */(0,emotion_cache_browser_esm/* default */.Z)({
  key: 'css'
}) : null);
var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};
var emotion_element_f0de968e_browser_esm_withEmotionCache = function withEmotionCache(func) {
  return /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};
var emotion_element_f0de968e_browser_esm_ThemeContext = /* #__PURE__ */react.createContext({});
var useTheme = function useTheme() {
  return React.useContext(emotion_element_f0de968e_browser_esm_ThemeContext);
};
var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);
    return mergedTheme;
  }
  return _extends({}, outerTheme, theme);
};
var createCacheWithTheme = /* #__PURE__ */(/* unused pure expression or super */ null && (weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
})));
var ThemeProvider = function ThemeProvider(props) {
  var theme = React.useContext(emotion_element_f0de968e_browser_esm_ThemeContext);
  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }
  return /*#__PURE__*/React.createElement(emotion_element_f0de968e_browser_esm_ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';
  var WithTheme = /*#__PURE__*/React.forwardRef(function render(props, ref) {
    var theme = React.useContext(emotion_element_f0de968e_browser_esm_ThemeContext);
    return /*#__PURE__*/React.createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  });
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}
var hasOwn = {}.hasOwnProperty;
var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  var newProps = {};
  for (var _key in props) {
    if (hasOwn.call(props, _key)) {
      newProps[_key] = props[_key];
    }
  }
  newProps[typePropName] = type; // Runtime labeling is an opt-in feature because:

  return newProps;
};
var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
    serialized = _ref.serialized,
    isStringTag = _ref.isStringTag;
  emotion_utils_browser_esm_registerStyles(cache, serialized, isStringTag);
  emotion_use_insertion_effect_with_fallbacks_browser_esm_useInsertionEffectAlwaysWithSyncFallback(function () {
    return emotion_utils_browser_esm_insertStyles(cache, serialized, isStringTag);
  });
  return null;
};
var Emotion = /* #__PURE__ */emotion_element_f0de968e_browser_esm_withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }
  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';
  if (typeof props.className === 'string') {
    className = emotion_utils_browser_esm_getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = emotion_serialize_esm_serializeStyles(registeredStyles, undefined, react.useContext(emotion_element_f0de968e_browser_esm_ThemeContext));
  className += cache.key + "-" + serialized.name;
  var newProps = {};
  for (var _key2 in props) {
    if (hasOwn.call(props, _key2) && _key2 !== 'css' && _key2 !== typePropName && !emotion_element_f0de968e_browser_esm_isDevelopment) {
      newProps[_key2] = props[_key2];
    }
  }
  newProps.className = className;
  if (ref) {
    newProps.ref = ref;
  }
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/react.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;

// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(89483);
;// CONCATENATED MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js











var jsx = function jsx(type, props) {
  // eslint-disable-next-line prefer-rest-params
  var args = arguments;
  if (props == null || !hasOwn.call(props, 'css')) {
    return react.createElement.apply(undefined, args);
  }
  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion$1;
  createElementArgArray[1] = createEmotionProps(type, props);
  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }
  return react.createElement.apply(null, createElementArgArray);
};
(function (_jsx) {
  var JSX;
  (function (_JSX) {})(JSX || (JSX = _jsx.JSX || (_jsx.JSX = {})));
})(jsx || (jsx = {}));

// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, React.useContext(ThemeContext));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything

  var sheetRef = React.useRef();
  useInsertionEffectWithLayoutFallback(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false;
    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }
    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }
    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffectWithLayoutFallback(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
      rehydrating = sheetRefCurrent[1];
    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }
    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }
    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }
    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
})));
function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return emotion_serialize_esm_serializeStyles(args);
}
function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name;
  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';
  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;
    switch (typeof arg) {
      case 'boolean':
        break;
      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';
            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }
          break;
        }
      default:
        {
          toAdd = arg;
        }
    }
    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }
  return cls;
};
function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
  if (registeredStyles.length < 2) {
    return className;
  }
  return rawClassName + css(registeredStyles);
}
var emotion_react_browser_esm_Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
    serializedArr = _ref.serializedArr;
  useInsertionEffectAlwaysWithSyncFallback(function () {
    for (var i = 0; i < serializedArr.length; i++) {
      insertStyles(cache, serializedArr[i], false);
    }
  });
  return null;
};
var ClassNames = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];
  var css = function css() {
    if (hasRendered && isDevelopment) {
      throw new Error('css can only be used during render');
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };
  var cx = function cx() {
    if (hasRendered && isDevelopment) {
      throw new Error('cx can only be used during render');
    }
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return merge(cache.registered, css, classnames(args));
  };
  var content = {
    css: css,
    cx: cx,
    theme: React.useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(emotion_react_browser_esm_Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
})));


/***/ }),

/***/ 86130:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
/* harmony default export */ __webpack_exports__["Z"] = (unitlessKeys);

/***/ }),

/***/ 90451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Composite": function() { return /* binding */ Composite; },
  "CompositeItem": function() { return /* binding */ CompositeItem; },
  "FloatingArrow": function() { return /* binding */ FloatingArrow; },
  "FloatingDelayGroup": function() { return /* binding */ FloatingDelayGroup; },
  "FloatingFocusManager": function() { return /* binding */ FloatingFocusManager; },
  "FloatingList": function() { return /* binding */ FloatingList; },
  "FloatingNode": function() { return /* binding */ FloatingNode; },
  "FloatingOverlay": function() { return /* binding */ FloatingOverlay; },
  "FloatingPortal": function() { return /* binding */ FloatingPortal; },
  "FloatingTree": function() { return /* binding */ FloatingTree; },
  "NextFloatingDelayGroup": function() { return /* binding */ NextFloatingDelayGroup; },
  "arrow": function() { return /* reexport */ arrow; },
  "autoPlacement": function() { return /* reexport */ autoPlacement; },
  "autoUpdate": function() { return /* reexport */ floating_ui_dom/* autoUpdate */.Me; },
  "computePosition": function() { return /* reexport */ floating_ui_dom/* computePosition */.oo; },
  "detectOverflow": function() { return /* reexport */ floating_ui_dom/* detectOverflow */.US; },
  "flip": function() { return /* reexport */ flip; },
  "getOverflowAncestors": function() { return /* reexport */ floating_ui_utils_dom/* getOverflowAncestors */.Kx; },
  "hide": function() { return /* reexport */ hide; },
  "inline": function() { return /* reexport */ inline; },
  "inner": function() { return /* binding */ inner; },
  "limitShift": function() { return /* reexport */ limitShift; },
  "offset": function() { return /* reexport */ offset; },
  "platform": function() { return /* reexport */ floating_ui_dom/* platform */.Jv; },
  "safePolygon": function() { return /* binding */ safePolygon; },
  "shift": function() { return /* reexport */ shift; },
  "size": function() { return /* reexport */ size; },
  "useClick": function() { return /* binding */ useClick; },
  "useClientPoint": function() { return /* binding */ useClientPoint; },
  "useDelayGroup": function() { return /* binding */ useDelayGroup; },
  "useDelayGroupContext": function() { return /* binding */ useDelayGroupContext; },
  "useDismiss": function() { return /* binding */ useDismiss; },
  "useFloating": function() { return /* binding */ floating_ui_react_esm_useFloating; },
  "useFloatingNodeId": function() { return /* binding */ useFloatingNodeId; },
  "useFloatingParentNodeId": function() { return /* binding */ useFloatingParentNodeId; },
  "useFloatingPortalNode": function() { return /* binding */ useFloatingPortalNode; },
  "useFloatingRootContext": function() { return /* binding */ useFloatingRootContext; },
  "useFloatingTree": function() { return /* binding */ useFloatingTree; },
  "useFocus": function() { return /* binding */ useFocus; },
  "useHover": function() { return /* binding */ useHover; },
  "useId": function() { return /* binding */ useId; },
  "useInnerOffset": function() { return /* binding */ useInnerOffset; },
  "useInteractions": function() { return /* binding */ useInteractions; },
  "useListItem": function() { return /* binding */ useListItem; },
  "useListNavigation": function() { return /* binding */ useListNavigation; },
  "useMergeRefs": function() { return /* binding */ useMergeRefs; },
  "useNextDelayGroup": function() { return /* binding */ useNextDelayGroup; },
  "useRole": function() { return /* binding */ useRole; },
  "useTransitionStatus": function() { return /* binding */ useTransitionStatus; },
  "useTransitionStyles": function() { return /* binding */ useTransitionStyles; },
  "useTypeahead": function() { return /* binding */ useTypeahead; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ./node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
var floating_ui_utils_dom = __webpack_require__(68504);
// EXTERNAL MODULE: ./node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var floating_ui_utils = __webpack_require__(95653);
;// CONCATENATED MODULE: ./node_modules/tabbable/dist/index.esm.js
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
// NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var candidateSelectors = ['input:not([inert])', 'select:not([inert])', 'textarea:not([inert])', 'a[href]:not([inert])', 'button:not([inert])', '[tabindex]:not(slot):not([inert])', 'audio[controls]:not([inert])', 'video[controls]:not([inert])', '[contenteditable]:not([contenteditable="false"]):not([inert])', 'details>summary:first-of-type:not([inert])', 'details:not([inert])'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function (element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};

/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */
var isInert = function isInert(node, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
  //  JS API property; we have to check the attribute, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's an active element
  var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
  var inert = inertAtt === '' || inertAtt === 'true';

  // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
  //  if it weren't for `matches()` not being a function on shadow roots; the following
  //  code works for any kind of node
  // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
  //  so it likely would not support `:is([inert] *)` either...
  var result = inert || lookUp && node && isInert(node.parentNode); // recursive

  return result;
};

/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */
var isContentEditable = function isContentEditable(node) {
  var _node$getAttribute2;
  // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
  //  to use the attribute directly to check for this, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's a non-editable element
  var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
  return attValue === '' || attValue === 'true';
};

/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */
var getCandidates = function getCandidates(el, includeContainer, filter) {
  // even if `includeContainer=false`, we still have to check it for inertness because
  //  if it's inert, all its children are inert
  if (isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};

/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */

/**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */

/**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */

/**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */

/**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */
var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (isInert(element, false)) {
      // no need to look up since we're drilling down
      // anything inside this container will also be inert
      continue;
    }
    if (element.tagName === 'SLOT') {
      // add shadow dom slot scope (slot itself cannot be focusable)
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      // check candidate element
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }

      // iterate over shadow content if possible
      var shadowRoot = element.shadowRoot ||
      // check for an undisclosed shadow
      typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);

      // no inert look up because we're already drilling down and checking for inertness
      //  on the way down, so all containers to this root node should have already been
      //  vetted as non-inert
      var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
        //  shadow exists, so look at light dom children as fallback BUT create a scope for any
        //  child candidates found because they're likely slotted elements (elements that are
        //  children of the web component element (which has the shadow), in the light dom, but
        //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
        //  _after_ we return from this recursive call
        var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        // there's not shadow so just dig into the element's (light dom) children
        //  __without__ giving the element special scope treatment
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};

/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */
var hasTabIndex = function hasTabIndex(node) {
  return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};

/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */
var getTabIndex = function getTabIndex(node) {
  if (!node) {
    throw new Error('No node provided');
  }
  if (node.tabIndex < 0) {
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    // yet they are still part of the regular tab order; in FF, they get a default
    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    // order, consider their tab index to be 0.
    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) {
      return 0;
    }
  }
  return node.tabIndex;
};

/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */
var getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
  var tabIndex = getTabIndex(node);
  if (tabIndex < 0 && isScope && !hasTabIndex(node)) {
    return 0;
  }
  return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};
var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
  var _nodeRoot;
  // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
  //  (but NOT _the_ document; see second 'If' comment below for more).
  // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
  //  is attached, and the one we need to check if it's in the document or not (because the
  //  shadow, and all nodes it contains, is never considered in the document since shadows
  //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
  //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
  //  visibility, including all the nodes it contains). The host could be any normal node,
  //  or a custom element (i.e. web component). Either way, that's the one that is considered
  //  part of the document, not the shadow root, nor any of its children (i.e. the node being
  //  tested).
  // To further complicate things, we have to look all the way up until we find a shadow HOST
  //  that is attached (or find none) because the node might be in nested shadows...
  // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
  //  document (per the docs) and while it's a Document-type object, that document does not
  //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
  //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
  //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
  //  node is actually detached.
  // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
  //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
  //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
  //  `ownerDocument` will be `null`, hence the optional chaining on it.
  var nodeRoot = node && getRootNode(node);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;

  // in some cases, a detached node will return itself as the root instead of a document or
  //  shadow root object, in which case, we shouldn't try to look further up the host chain
  var attached = false;
  if (nodeRoot && nodeRoot !== node) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
      //  which means we need to get the host's host and check if that parent host is contained
      //  in (i.e. attached to) the document
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
    width = _node$getBoundingClie.width,
    height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
  var displayCheck = _ref.displayCheck,
    getShadowRoot = _ref.getShadowRoot;
  // NOTE: visibility will be `undefined` if node is detached from the document
  //  (see notes about this further down), which means we will consider it visible
  //  (this is legacy behavior from a very long way back)
  // NOTE: we check this regardless of `displayCheck="none"` because this is a
  //  _visibility_ check, not a _display_ check
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }
  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }
  if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
    if (typeof getShadowRoot === 'function') {
      // figure out if we should consider the node to be in an undisclosed shadow and use the
      //  'non-zero-area' fallback
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
        ) {
          // node has an undisclosed shadow which means we can only treat it as a black box, so we
          //  fall back to a non-zero-area test
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          // iterate up slot
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          // cross shadow boundary
          node = rootNode.host;
        } else {
          // iterate up normal dom
          node = parentElement;
        }
      }
      node = originalNode;
    }
    // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
    //  it might be a falsy value, which means shadow DOM support is disabled

    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
    //  now we can just test to see if it would normally be visible or not, provided it's
    //  attached to the main document.
    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.

    if (isNodeAttached(node)) {
      // this works wherever the node is: if there's at least one client rect, it's
      //  somehow displayed; it also covers the CSS 'display: contents' case where the
      //  node itself is hidden in place of its contents; and there's no need to search
      //  up the hierarchy either
      return !node.getClientRects().length;
    }

    // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.
    //
    // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
    //  nodes as visible with the 'none' fallback.__
    if (displayCheck !== 'legacy-full') {
      return true; // hidden
    }
    // else, fallback to 'none' mode and consider the node visible
  } else if (displayCheck === 'non-zero-area') {
    // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
  }

  // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
  //  it's visible
  return false;
};

// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    // check if `node` is contained in a disabled <fieldset>
    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> among the children of the disabled <fieldset>
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          // when the first <legend> (in document order) is found
          if (child.tagName === 'LEGEND') {
            // if its parent <fieldset> is not nested in another disabled <fieldset>,
            // return whether `node` is a descendant of its first <legend>
            return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        }
        // the disabled <fieldset> containing `node` has no <legend>
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }

  // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled ||
  // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  isInert(node) || isHiddenInput(node) || isHidden(node, options) ||
  // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  // If a custom element has an explicit negative tabindex,
  // browsers will not allow tab targeting said element's children.
  return false;
};

/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */
var sortByOrder = function sortByOrder(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function (item, i) {
    var isScope = !!item.scopeParent;
    var element = isScope ? item.scopeParent : item;
    var candidateTabindex = getSortOrderTabIndex(element, isScope);
    var elements = isScope ? sortByOrder(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item: item,
        isScope: isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};
var focusable = function focusable(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }
  return candidates;
};
var isTabbable = function isTabbable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches.call(node, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* #__PURE__ */(/* unused pure expression or super */ null && (candidateSelectors.concat('iframe').join(',')));
var isFocusable = function isFocusable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(options, node);
};

;// CONCATENATED MODULE: ./node_modules/@floating-ui/react/dist/floating-ui.react.utils.mjs






// Avoid Chrome DevTools blue warning.
function getPlatform() {
  const uaData = navigator.userAgentData;
  if (uaData != null && uaData.platform) {
    return uaData.platform;
  }
  return navigator.platform;
}
function getUserAgent() {
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    return uaData.brands.map(_ref => {
      let {
        brand,
        version
      } = _ref;
      return brand + "/" + version;
    }).join(' ');
  }
  return navigator.userAgent;
}
function isSafari() {
  // Chrome DevTools does not complain about navigator.vendor
  return /apple/i.test(navigator.vendor);
}
function isAndroid() {
  const re = /android/i;
  return re.test(getPlatform()) || re.test(getUserAgent());
}
function isMac() {
  return getPlatform().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function isJSDOM() {
  return getUserAgent().includes('jsdom/');
}
const FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled])," + "[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
const ARROW_LEFT = 'ArrowLeft';
const ARROW_RIGHT = 'ArrowRight';
const ARROW_UP = 'ArrowUp';
const ARROW_DOWN = 'ArrowDown';
function activeElement(doc) {
  let activeElement = doc.activeElement;
  while (((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null) {
    var _activeElement;
    activeElement = activeElement.shadowRoot.activeElement;
  }
  return activeElement;
}
function contains(parent, child) {
  if (!parent || !child) {
    return false;
  }
  const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();

  // First, attempt with faster native method
  if (parent.contains(child)) {
    return true;
  }

  // then fallback to custom implementation with Shadow DOM support
  if (rootNode && (0,floating_ui_utils_dom/* isShadowRoot */.Zq)(rootNode)) {
    let next = child;
    while (next) {
      if (parent === next) {
        return true;
      }
      // @ts-ignore
      next = next.parentNode || next.host;
    }
  }

  // Give up, the result is false
  return false;
}
function getTarget(event) {
  if ('composedPath' in event) {
    return event.composedPath()[0];
  }

  // TS thinks `event` is of type never as it assumes all browsers support
  // `composedPath()`, but browsers without shadow DOM don't.
  return event.target;
}
function isEventTargetWithin(event, node) {
  if (node == null) {
    return false;
  }
  if ('composedPath' in event) {
    return event.composedPath().includes(node);
  }

  // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
  const e = event;
  return e.target != null && node.contains(e.target);
}
function isRootElement(element) {
  return element.matches('html,body');
}
function getDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}
function isTypeableElement(element) {
  return (0,floating_ui_utils_dom/* isHTMLElement */.Re)(element) && element.matches(TYPEABLE_SELECTOR);
}
function isTypeableCombobox(element) {
  if (!element) return false;
  return element.getAttribute('role') === 'combobox' && isTypeableElement(element);
}
function matchesFocusVisible(element) {
  // We don't want to block focus from working with `visibleOnly`
  // (JSDOM doesn't match `:focus-visible` when the element has `:focus`)
  if (!element || isJSDOM()) return true;
  try {
    return element.matches(':focus-visible');
  } catch (_e) {
    return true;
  }
}
function getFloatingFocusElement(floatingElement) {
  if (!floatingElement) {
    return null;
  }
  // Try to find the element that has `{...getFloatingProps()}` spread on it.
  // This indicates the floating element is acting as a positioning wrapper, and
  // so focus should be managed on the child element with the event handlers and
  // aria props.
  return floatingElement.hasAttribute(FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
function getNodeChildren(nodes, id, onlyOpenChildren) {
  if (onlyOpenChildren === void 0) {
    onlyOpenChildren = true;
  }
  const directChildren = nodes.filter(node => {
    var _node$context;
    return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
  });
  return directChildren.flatMap(child => [child, ...getNodeChildren(nodes, child.id, onlyOpenChildren)]);
}
function getDeepestNode(nodes, id) {
  let deepestNodeId;
  let maxDepth = -1;
  function findDeepest(nodeId, depth) {
    if (depth > maxDepth) {
      deepestNodeId = nodeId;
      maxDepth = depth;
    }
    const children = getNodeChildren(nodes, nodeId);
    children.forEach(child => {
      findDeepest(child.id, depth + 1);
    });
  }
  findDeepest(id, 0);
  return nodes.find(node => node.id === deepestNodeId);
}
function getNodeAncestors(nodes, id) {
  var _nodes$find;
  let allAncestors = [];
  let currentParentId = (_nodes$find = nodes.find(node => node.id === id)) == null ? void 0 : _nodes$find.parentId;
  while (currentParentId) {
    const currentNode = nodes.find(node => node.id === currentParentId);
    currentParentId = currentNode == null ? void 0 : currentNode.parentId;
    if (currentNode) {
      allAncestors = allAncestors.concat(currentNode);
    }
  }
  return allAncestors;
}
function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}
function isReactEvent(event) {
  return 'nativeEvent' in event;
}

// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function isVirtualClick(event) {
  // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
  // Try to find a workaround for this. `react-aria` source still has the check.
  if (event.mozInputSource === 0 && event.isTrusted) {
    return true;
  }
  if (isAndroid() && event.pointerType) {
    return event.type === 'click' && event.buttons === 1;
  }
  return event.detail === 0 && !event.pointerType;
}
function isVirtualPointerEvent(event) {
  if (isJSDOM()) return false;
  return !isAndroid() && event.width === 0 && event.height === 0 || isAndroid() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' ||
  // iOS VoiceOver returns 0.333• for width/height.
  event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function isMouseLikePointerType(pointerType, strict) {
  // On some Linux machines with Chromium, mouse inputs return a `pointerType`
  // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
  const values = ['mouse', 'pen'];
  if (!strict) {
    values.push('', undefined);
  }
  return values.includes(pointerType);
}
var isClient = typeof document !== 'undefined';
var noop = function noop() {};
var floating_ui_react_utils_index = isClient ? react.useLayoutEffect : noop;

// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const SafeReact = {
  ...react_namespaceObject
};
function useLatestRef(value) {
  const ref = react.useRef(value);
  floating_ui_react_utils_index(() => {
    ref.current = value;
  });
  return ref;
}
const useInsertionEffect = SafeReact.useInsertionEffect;
const useSafeInsertionEffect = useInsertionEffect || (fn => fn());
function useEffectEvent(callback) {
  const ref = react.useRef(() => {
    if (false) {}
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return react.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}
function isDifferentGridRow(index, cols, prevRow) {
  return Math.floor(index / cols) !== prevRow;
}
function isIndexOutOfListBounds(listRef, index) {
  return index < 0 || index >= listRef.current.length;
}
function getMinListIndex(listRef, disabledIndices) {
  return findNonDisabledListIndex(listRef, {
    disabledIndices
  });
}
function getMaxListIndex(listRef, disabledIndices) {
  return findNonDisabledListIndex(listRef, {
    decrement: true,
    startingIndex: listRef.current.length,
    disabledIndices
  });
}
function findNonDisabledListIndex(listRef, _temp) {
  let {
    startingIndex = -1,
    decrement = false,
    disabledIndices,
    amount = 1
  } = _temp === void 0 ? {} : _temp;
  let index = startingIndex;
  do {
    index += decrement ? -amount : amount;
  } while (index >= 0 && index <= listRef.current.length - 1 && isListIndexDisabled(listRef, index, disabledIndices));
  return index;
}
function getGridNavigatedIndex(listRef, _ref) {
  let {
    event,
    orientation,
    loop,
    rtl,
    cols,
    disabledIndices,
    minIndex,
    maxIndex,
    prevIndex,
    stopEvent: stop = false
  } = _ref;
  let nextIndex = prevIndex;
  if (event.key === ARROW_UP) {
    stop && stopEvent(event);
    if (prevIndex === -1) {
      nextIndex = maxIndex;
    } else {
      nextIndex = findNonDisabledListIndex(listRef, {
        startingIndex: nextIndex,
        amount: cols,
        decrement: true,
        disabledIndices
      });
      if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
        const col = prevIndex % cols;
        const maxCol = maxIndex % cols;
        const offset = maxIndex - (maxCol - col);
        if (maxCol === col) {
          nextIndex = maxIndex;
        } else {
          nextIndex = maxCol > col ? offset : offset - cols;
        }
      }
    }
    if (isIndexOutOfListBounds(listRef, nextIndex)) {
      nextIndex = prevIndex;
    }
  }
  if (event.key === ARROW_DOWN) {
    stop && stopEvent(event);
    if (prevIndex === -1) {
      nextIndex = minIndex;
    } else {
      nextIndex = findNonDisabledListIndex(listRef, {
        startingIndex: prevIndex,
        amount: cols,
        disabledIndices
      });
      if (loop && prevIndex + cols > maxIndex) {
        nextIndex = findNonDisabledListIndex(listRef, {
          startingIndex: prevIndex % cols - cols,
          amount: cols,
          disabledIndices
        });
      }
    }
    if (isIndexOutOfListBounds(listRef, nextIndex)) {
      nextIndex = prevIndex;
    }
  }

  // Remains on the same row/column.
  if (orientation === 'both') {
    const prevRow = (0,floating_ui_utils/* floor */.GW)(prevIndex / cols);
    if (event.key === (rtl ? ARROW_LEFT : ARROW_RIGHT)) {
      stop && stopEvent(event);
      if (prevIndex % cols !== cols - 1) {
        nextIndex = findNonDisabledListIndex(listRef, {
          startingIndex: prevIndex,
          disabledIndices
        });
        if (loop && isDifferentGridRow(nextIndex, cols, prevRow)) {
          nextIndex = findNonDisabledListIndex(listRef, {
            startingIndex: prevIndex - prevIndex % cols - 1,
            disabledIndices
          });
        }
      } else if (loop) {
        nextIndex = findNonDisabledListIndex(listRef, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices
        });
      }
      if (isDifferentGridRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    if (event.key === (rtl ? ARROW_RIGHT : ARROW_LEFT)) {
      stop && stopEvent(event);
      if (prevIndex % cols !== 0) {
        nextIndex = findNonDisabledListIndex(listRef, {
          startingIndex: prevIndex,
          decrement: true,
          disabledIndices
        });
        if (loop && isDifferentGridRow(nextIndex, cols, prevRow)) {
          nextIndex = findNonDisabledListIndex(listRef, {
            startingIndex: prevIndex + (cols - prevIndex % cols),
            decrement: true,
            disabledIndices
          });
        }
      } else if (loop) {
        nextIndex = findNonDisabledListIndex(listRef, {
          startingIndex: prevIndex + (cols - prevIndex % cols),
          decrement: true,
          disabledIndices
        });
      }
      if (isDifferentGridRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    const lastRow = (0,floating_ui_utils/* floor */.GW)(maxIndex / cols) === prevRow;
    if (isIndexOutOfListBounds(listRef, nextIndex)) {
      if (loop && lastRow) {
        nextIndex = event.key === (rtl ? ARROW_RIGHT : ARROW_LEFT) ? maxIndex : findNonDisabledListIndex(listRef, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices
        });
      } else {
        nextIndex = prevIndex;
      }
    }
  }
  return nextIndex;
}

/** For each cell index, gets the item index that occupies that cell */
function createGridCellMap(sizes, cols, dense) {
  const cellMap = [];
  let startIndex = 0;
  sizes.forEach((_ref2, index) => {
    let {
      width,
      height
    } = _ref2;
    if (width > cols) {
      if (false) {}
    }
    let itemPlaced = false;
    if (dense) {
      startIndex = 0;
    }
    while (!itemPlaced) {
      const targetCells = [];
      for (let i = 0; i < width; i++) {
        for (let j = 0; j < height; j++) {
          targetCells.push(startIndex + i + j * cols);
        }
      }
      if (startIndex % cols + width <= cols && targetCells.every(cell => cellMap[cell] == null)) {
        targetCells.forEach(cell => {
          cellMap[cell] = index;
        });
        itemPlaced = true;
      } else {
        startIndex++;
      }
    }
  });

  // convert into a non-sparse array
  return [...cellMap];
}

/** Gets cell index of an item's corner or -1 when index is -1. */
function getGridCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
  if (index === -1) return -1;
  const firstCellIndex = cellMap.indexOf(index);
  const sizeItem = sizes[index];
  switch (corner) {
    case 'tl':
      return firstCellIndex;
    case 'tr':
      if (!sizeItem) {
        return firstCellIndex;
      }
      return firstCellIndex + sizeItem.width - 1;
    case 'bl':
      if (!sizeItem) {
        return firstCellIndex;
      }
      return firstCellIndex + (sizeItem.height - 1) * cols;
    case 'br':
      return cellMap.lastIndexOf(index);
  }
}

/** Gets all cell indices that correspond to the specified indices */
function getGridCellIndices(indices, cellMap) {
  return cellMap.flatMap((index, cellIndex) => indices.includes(index) ? [cellIndex] : []);
}
function isListIndexDisabled(listRef, index, disabledIndices) {
  if (typeof disabledIndices === 'function') {
    return disabledIndices(index);
  } else if (disabledIndices) {
    return disabledIndices.includes(index);
  }
  const element = listRef.current[index];
  return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}
const getTabbableOptions = () => ({
  getShadowRoot: true,
  displayCheck:
  // JSDOM does not support the `tabbable` library. To solve this we can
  // check if `ResizeObserver` is a real function (not polyfilled), which
  // determines if the current environment is JSDOM-like.
  typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
});
function getTabbableIn(container, dir) {
  const list = tabbable(container, getTabbableOptions());
  const len = list.length;
  if (len === 0) return;
  const active = activeElement(getDocument(container));
  const index = list.indexOf(active);
  const nextIndex = index === -1 ? dir === 1 ? 0 : len - 1 : index + dir;
  return list[nextIndex];
}
function getNextTabbable(referenceElement) {
  return getTabbableIn(getDocument(referenceElement).body, 1) || referenceElement;
}
function getPreviousTabbable(referenceElement) {
  return getTabbableIn(getDocument(referenceElement).body, -1) || referenceElement;
}
function isOutsideEvent(event, container) {
  const containerElement = container || event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !relatedTarget || !contains(containerElement, relatedTarget);
}
function disableFocusInside(container) {
  const tabbableElements = tabbable(container, getTabbableOptions());
  tabbableElements.forEach(element => {
    element.dataset.tabindex = element.getAttribute('tabindex') || '';
    element.setAttribute('tabindex', '-1');
  });
}
function enableFocusInside(container) {
  const elements = container.querySelectorAll('[data-tabindex]');
  elements.forEach(element => {
    const tabindex = element.dataset.tabindex;
    delete element.dataset.tabindex;
    if (tabindex) {
      element.setAttribute('tabindex', tabindex);
    } else {
      element.removeAttribute('tabindex');
    }
  });
}

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(85202);
// EXTERNAL MODULE: ./node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs + 1 modules
var floating_ui_dom = __webpack_require__(45959);
;// CONCATENATED MODULE: ./node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs





var floating_ui_react_dom_isClient = typeof document !== 'undefined';
var floating_ui_react_dom_noop = function noop() {};
var index = floating_ui_react_dom_isClient ? react.useLayoutEffect : floating_ui_react_dom_noop;

// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === 'function' && a.toString() === b.toString()) {
    return true;
  }
  let length;
  let i;
  let keys;
  if (a && b && typeof a === 'object') {
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0;) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0;) {
      const key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}
function getDPR(element) {
  if (typeof window === 'undefined') {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}
function floating_ui_react_dom_useLatestRef(value) {
  const ref = react.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}

/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = react.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = react.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = react.useState(null);
  const [_floating, _setFloating] = react.useState(null);
  const setReference = react.useCallback(node => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = react.useCallback(node => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = react.useRef(null);
  const floatingRef = react.useRef(null);
  const dataRef = react.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = floating_ui_react_dom_useLatestRef(whileElementsMounted);
  const platformRef = floating_ui_react_dom_useLatestRef(platform);
  const openRef = floating_ui_react_dom_useLatestRef(open);
  const update = react.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    (0,floating_ui_dom/* computePosition */.oo)(referenceRef.current, floatingRef.current, config).then(data => {
      const fullData = {
        ...data,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: openRef.current !== false
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        react_dom.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef, openRef]);
  index(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData(data => ({
        ...data,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = react.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = react.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = react.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = react.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...(getDPR(elements.floating) >= 1.5 && {
          willChange: 'transform'
        })
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return react.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$1 = options => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, 'current');
  }
  return {
    name: 'arrow',
    options,
    fn(state) {
      const {
        element,
        padding
      } = typeof options === 'function' ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return (0,floating_ui_dom/* arrow */.x7)({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      }
      if (element) {
        return (0,floating_ui_dom/* arrow */.x7)({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = (options, deps) => ({
  ...(0,floating_ui_dom/* offset */.cv)(options),
  options: [options, deps]
});

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = (options, deps) => ({
  ...(0,floating_ui_dom/* shift */.uY)(options),
  options: [options, deps]
});

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift = (options, deps) => ({
  ...(0,floating_ui_dom/* limitShift */.dr)(options),
  options: [options, deps]
});

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = (options, deps) => ({
  ...(0,floating_ui_dom/* flip */.RR)(options),
  options: [options, deps]
});

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = (options, deps) => ({
  ...(0,floating_ui_dom/* size */.dp)(options),
  options: [options, deps]
});

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement = (options, deps) => ({
  ...(0,floating_ui_dom/* autoPlacement */.X5)(options),
  options: [options, deps]
});

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide = (options, deps) => ({
  ...(0,floating_ui_dom/* hide */.Cp)(options),
  options: [options, deps]
});

/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const inline = (options, deps) => ({
  ...(0,floating_ui_dom/* inline */.Qo)(options),
  options: [options, deps]
});

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = (options, deps) => ({
  ...arrow$1(options),
  options: [options, deps]
});

;// CONCATENATED MODULE: ./node_modules/@floating-ui/react/dist/floating-ui.react.esm.js










/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */
function useMergeRefs(refs) {
  const cleanupRef = react.useRef(undefined);
  const refEffect = react.useCallback(instance => {
    const cleanups = refs.map(ref => {
      if (ref == null) {
        return;
      }
      if (typeof ref === 'function') {
        const refCallback = ref;
        const refCleanup = refCallback(instance);
        return typeof refCleanup === 'function' ? refCleanup : () => {
          refCallback(null);
        };
      }
      ref.current = instance;
      return () => {
        ref.current = null;
      };
    });
    return () => {
      cleanups.forEach(refCleanup => refCleanup == null ? void 0 : refCleanup());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
  return react.useMemo(() => {
    if (refs.every(ref => ref == null)) {
      return null;
    }
    return value => {
      if (cleanupRef.current) {
        cleanupRef.current();
        cleanupRef.current = undefined;
      }
      if (value != null) {
        cleanupRef.current = refEffect(value);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}
function sortByDocumentPosition(a, b) {
  const position = a.compareDocumentPosition(b);
  if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
    return -1;
  }
  if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) {
    return 1;
  }
  return 0;
}
const FloatingListContext = /*#__PURE__*/react.createContext({
  register: () => {},
  unregister: () => {},
  map: /*#__PURE__*/new Map(),
  elementsRef: {
    current: []
  }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */
function FloatingList(props) {
  const {
    children,
    elementsRef,
    labelsRef
  } = props;
  const [nodes, setNodes] = react.useState(() => new Set());
  const register = react.useCallback(node => {
    setNodes(prevSet => new Set(prevSet).add(node));
  }, []);
  const unregister = react.useCallback(node => {
    setNodes(prevSet => {
      const set = new Set(prevSet);
      set.delete(node);
      return set;
    });
  }, []);
  const map = react.useMemo(() => {
    const newMap = new Map();
    const sortedNodes = Array.from(nodes.keys()).sort(sortByDocumentPosition);
    sortedNodes.forEach((node, index) => {
      newMap.set(node, index);
    });
    return newMap;
  }, [nodes]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FloatingListContext.Provider, {
    value: react.useMemo(() => ({
      register,
      unregister,
      map,
      elementsRef,
      labelsRef
    }), [register, unregister, map, elementsRef, labelsRef]),
    children: children
  });
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */
function useListItem(props) {
  if (props === void 0) {
    props = {};
  }
  const {
    label
  } = props;
  const {
    register,
    unregister,
    map,
    elementsRef,
    labelsRef
  } = react.useContext(FloatingListContext);
  const [index, setIndex] = react.useState(null);
  const componentRef = react.useRef(null);
  const ref = react.useCallback(node => {
    componentRef.current = node;
    if (index !== null) {
      elementsRef.current[index] = node;
      if (labelsRef) {
        var _node$textContent;
        const isLabelDefined = label !== undefined;
        labelsRef.current[index] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
      }
    }
  }, [index, elementsRef, labelsRef, label]);
  floating_ui_react_utils_index(() => {
    const node = componentRef.current;
    if (node) {
      register(node);
      return () => {
        unregister(node);
      };
    }
  }, [register, unregister]);
  floating_ui_react_utils_index(() => {
    const index = componentRef.current ? map.get(componentRef.current) : null;
    if (index != null) {
      setIndex(index);
    }
  }, [map]);
  return react.useMemo(() => ({
    ref,
    index: index == null ? -1 : index
  }), [index, ref]);
}
const floating_ui_react_esm_FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const ACTIVE_KEY = 'active';
const SELECTED_KEY = 'selected';
const floating_ui_react_esm_ARROW_LEFT = 'ArrowLeft';
const floating_ui_react_esm_ARROW_RIGHT = 'ArrowRight';
const floating_ui_react_esm_ARROW_UP = 'ArrowUp';
const floating_ui_react_esm_ARROW_DOWN = 'ArrowDown';
function renderJsx(render, computedProps) {
  if (typeof render === 'function') {
    return render(computedProps);
  }
  if (render) {
    return /*#__PURE__*/react.cloneElement(render, computedProps);
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    ...computedProps
  });
}
const CompositeContext = /*#__PURE__*/react.createContext({
  activeIndex: 0,
  onNavigate: () => {}
});
const horizontalKeys = [floating_ui_react_esm_ARROW_LEFT, floating_ui_react_esm_ARROW_RIGHT];
const verticalKeys = [floating_ui_react_esm_ARROW_UP, floating_ui_react_esm_ARROW_DOWN];
const allKeys = [...horizontalKeys, ...verticalKeys];

/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */
const Composite = /*#__PURE__*/react.forwardRef(function Composite(props, forwardedRef) {
  const {
    render,
    orientation = 'both',
    loop = true,
    rtl = false,
    cols = 1,
    disabledIndices,
    activeIndex: externalActiveIndex,
    onNavigate: externalSetActiveIndex,
    itemSizes,
    dense = false,
    ...domProps
  } = props;
  const [internalActiveIndex, internalSetActiveIndex] = react.useState(0);
  const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
  const onNavigate = useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
  const elementsRef = react.useRef([]);
  const renderElementProps = render && typeof render !== 'function' ? render.props : {};
  const contextValue = react.useMemo(() => ({
    activeIndex,
    onNavigate
  }), [activeIndex, onNavigate]);
  const isGrid = cols > 1;
  function handleKeyDown(event) {
    if (!allKeys.includes(event.key)) return;
    let nextIndex = activeIndex;
    const minIndex = getMinListIndex(elementsRef, disabledIndices);
    const maxIndex = getMaxListIndex(elementsRef, disabledIndices);
    const horizontalEndKey = rtl ? floating_ui_react_esm_ARROW_LEFT : floating_ui_react_esm_ARROW_RIGHT;
    const horizontalStartKey = rtl ? floating_ui_react_esm_ARROW_RIGHT : floating_ui_react_esm_ARROW_LEFT;
    if (isGrid) {
      const sizes = itemSizes || Array.from({
        length: elementsRef.current.length
      }, () => ({
        width: 1,
        height: 1
      }));
      // To calculate movements on the grid, we use hypothetical cell indices
      // as if every item was 1x1, then convert back to real indices.
      const cellMap = createGridCellMap(sizes, cols, dense);
      const minGridIndex = cellMap.findIndex(index => index != null && !isListIndexDisabled(elementsRef, index, disabledIndices));
      // last enabled index
      const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex) => index != null && !isListIndexDisabled(elementsRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
      const maybeNextIndex = cellMap[getGridNavigatedIndex({
        current: cellMap.map(itemIndex => itemIndex ? elementsRef.current[itemIndex] : null)
      }, {
        event,
        orientation,
        loop,
        rtl,
        cols,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: getGridCellIndices([...((typeof disabledIndices !== 'function' ? disabledIndices : null) || elementsRef.current.map((_, index) => isListIndexDisabled(elementsRef, index, disabledIndices) ? index : undefined)), undefined], cellMap),
        minIndex: minGridIndex,
        maxIndex: maxGridIndex,
        prevIndex: getGridCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols,
        // use a corner matching the edge closest to the direction we're
        // moving in so we don't end up in the same item. Prefer
        // top/left over bottom/right.
        event.key === floating_ui_react_esm_ARROW_DOWN ? 'bl' : event.key === horizontalEndKey ? 'tr' : 'tl')
      })];
      if (maybeNextIndex != null) {
        nextIndex = maybeNextIndex;
      }
    }
    const toEndKeys = {
      horizontal: [horizontalEndKey],
      vertical: [floating_ui_react_esm_ARROW_DOWN],
      both: [horizontalEndKey, floating_ui_react_esm_ARROW_DOWN]
    }[orientation];
    const toStartKeys = {
      horizontal: [horizontalStartKey],
      vertical: [floating_ui_react_esm_ARROW_UP],
      both: [horizontalStartKey, floating_ui_react_esm_ARROW_UP]
    }[orientation];
    const preventedKeys = isGrid ? allKeys : {
      horizontal: horizontalKeys,
      vertical: verticalKeys,
      both: allKeys
    }[orientation];
    if (nextIndex === activeIndex && [...toEndKeys, ...toStartKeys].includes(event.key)) {
      if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) {
        nextIndex = minIndex;
      } else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) {
        nextIndex = maxIndex;
      } else {
        nextIndex = findNonDisabledListIndex(elementsRef, {
          startingIndex: nextIndex,
          decrement: toStartKeys.includes(event.key),
          disabledIndices
        });
      }
    }
    if (nextIndex !== activeIndex && !isIndexOutOfListBounds(elementsRef, nextIndex)) {
      var _elementsRef$current$;
      event.stopPropagation();
      if (preventedKeys.includes(event.key)) {
        event.preventDefault();
      }
      onNavigate(nextIndex);
      (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
    }
  }
  const computedProps = {
    ...domProps,
    ...renderElementProps,
    ref: forwardedRef,
    'aria-orientation': orientation === 'both' ? undefined : orientation,
    onKeyDown(e) {
      domProps.onKeyDown == null || domProps.onKeyDown(e);
      renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
      handleKeyDown(e);
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CompositeContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FloatingList, {
      elementsRef: elementsRef,
      children: renderJsx(render, computedProps)
    })
  });
});
/**
 * @see https://floating-ui.com/docs/Composite
 */
const CompositeItem = /*#__PURE__*/react.forwardRef(function CompositeItem(props, forwardedRef) {
  const {
    render,
    ...domProps
  } = props;
  const renderElementProps = render && typeof render !== 'function' ? render.props : {};
  const {
    activeIndex,
    onNavigate
  } = react.useContext(CompositeContext);
  const {
    ref,
    index
  } = useListItem();
  const mergedRef = useMergeRefs([ref, forwardedRef, renderElementProps.ref]);
  const isActive = activeIndex === index;
  const computedProps = {
    ...domProps,
    ...renderElementProps,
    ref: mergedRef,
    tabIndex: isActive ? 0 : -1,
    'data-active': isActive ? '' : undefined,
    onFocus(e) {
      domProps.onFocus == null || domProps.onFocus(e);
      renderElementProps.onFocus == null || renderElementProps.onFocus(e);
      onNavigate(index);
    }
  };
  return renderJsx(render, computedProps);
});

// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const floating_ui_react_esm_SafeReact = {
  ...react_namespaceObject
};
let serverHandoffComplete = false;
let count = 0;
const genId = () =>
// Ensure the id is unique with multiple independent versions of Floating UI
// on <React 18
"floating-ui-" + Math.random().toString(36).slice(2, 6) + count++;
function useFloatingId() {
  const [id, setId] = react.useState(() => serverHandoffComplete ? genId() : undefined);
  floating_ui_react_utils_index(() => {
    if (id == null) {
      setId(genId());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  react.useEffect(() => {
    serverHandoffComplete = true;
  }, []);
  return id;
}
const useReactId = floating_ui_react_esm_SafeReact.useId;

/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */
const useId = useReactId || useFloatingId;
let devMessageSet;
if (false) {}
function warn() {
  var _devMessageSet;
  for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
    messages[_key] = arguments[_key];
  }
  const message = "Floating UI: " + messages.join(' ');
  if (!((_devMessageSet = devMessageSet) != null && _devMessageSet.has(message))) {
    var _devMessageSet2;
    (_devMessageSet2 = devMessageSet) == null || _devMessageSet2.add(message);
    console.warn(message);
  }
}
function error() {
  var _devMessageSet3;
  for (var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    messages[_key2] = arguments[_key2];
  }
  const message = "Floating UI: " + messages.join(' ');
  if (!((_devMessageSet3 = devMessageSet) != null && _devMessageSet3.has(message))) {
    var _devMessageSet4;
    (_devMessageSet4 = devMessageSet) == null || _devMessageSet4.add(message);
    console.error(message);
  }
}

/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */
const FloatingArrow = /*#__PURE__*/react.forwardRef(function FloatingArrow(props, ref) {
  const {
    context: {
      placement,
      elements: {
        floating
      },
      middlewareData: {
        arrow,
        shift
      }
    },
    width = 14,
    height = 7,
    tipRadius = 0,
    strokeWidth = 0,
    staticOffset,
    stroke,
    d,
    style: {
      transform,
      ...restStyle
    } = {},
    ...rest
  } = props;
  if (false) {}
  const clipPathId = useId();
  const [isRTL, setIsRTL] = react.useState(false);

  // https://github.com/floating-ui/floating-ui/issues/2932
  floating_ui_react_utils_index(() => {
    if (!floating) return;
    const isRTL = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(floating).direction === 'rtl';
    if (isRTL) {
      setIsRTL(true);
    }
  }, [floating]);
  if (!floating) {
    return null;
  }
  const [side, alignment] = placement.split('-');
  const isVerticalSide = side === 'top' || side === 'bottom';
  let computedStaticOffset = staticOffset;
  if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) {
    computedStaticOffset = null;
  }

  // Strokes must be double the border width, this ensures the stroke's width
  // works as you'd expect.
  const computedStrokeWidth = strokeWidth * 2;
  const halfStrokeWidth = computedStrokeWidth / 2;
  const svgX = width / 2 * (tipRadius / -8 + 1);
  const svgY = height / 2 * tipRadius / 4;
  const isCustomShape = !!d;
  const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
  let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
  if (computedStaticOffset && isRTL) {
    xOffsetProp = alignment === 'end' ? 'left' : 'right';
  }
  const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
  const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
  const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
  const rotation = {
    top: isCustomShape ? 'rotate(180deg)' : '',
    left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
    bottom: isCustomShape ? '' : 'rotate(180deg)',
    right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
  }[side];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    ...rest,
    "aria-hidden": true,
    ref: ref,
    width: isCustomShape ? width : width + computedStrokeWidth,
    height: width,
    viewBox: "0 0 " + width + " " + (height > width ? height : width),
    style: {
      position: 'absolute',
      pointerEvents: 'none',
      [xOffsetProp]: arrowX,
      [yOffsetProp]: arrowY,
      [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
      transform: [rotation, transform].filter(t => !!t).join(' '),
      ...restStyle
    },
    children: [computedStrokeWidth > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      clipPath: "url(#" + clipPathId + ")",
      fill: "none",
      stroke: stroke
      // Account for the stroke on the fill path rendered below.
      ,

      strokeWidth: computedStrokeWidth + (d ? 0 : 1),
      d: dValue
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      stroke: computedStrokeWidth && !d ? rest.fill : 'none',
      d: dValue
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
      id: clipPathId,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + computedStrokeWidth,
        height: width
      })
    })]
  });
});
function createEventEmitter() {
  const map = new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null || _map$get.forEach(listener => listener(data));
    },
    on(event, listener) {
      if (!map.has(event)) {
        map.set(event, new Set());
      }
      map.get(event).add(listener);
    },
    off(event, listener) {
      var _map$get2;
      (_map$get2 = map.get(event)) == null || _map$get2.delete(listener);
    }
  };
}
const FloatingNodeContext = /*#__PURE__*/react.createContext(null);
const FloatingTreeContext = /*#__PURE__*/react.createContext(null);

/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = react.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};

/**
 * Returns the nearest floating tree context, if available.
 */
const useFloatingTree = () => react.useContext(FloatingTreeContext);

/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */
function useFloatingNodeId(customParentId) {
  const id = useId();
  const tree = useFloatingTree();
  const reactParentId = useFloatingParentNodeId();
  const parentId = customParentId || reactParentId;
  floating_ui_react_utils_index(() => {
    if (!id) return;
    const node = {
      id,
      parentId
    };
    tree == null || tree.addNode(node);
    return () => {
      tree == null || tree.removeNode(node);
    };
  }, [tree, id, parentId]);
  return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */
function FloatingNode(props) {
  const {
    children,
    id
  } = props;
  const parentId = useFloatingParentNodeId();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FloatingNodeContext.Provider, {
    value: react.useMemo(() => ({
      id,
      parentId
    }), [id, parentId]),
    children: children
  });
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */
function FloatingTree(props) {
  const {
    children
  } = props;
  const nodesRef = react.useRef([]);
  const addNode = react.useCallback(node => {
    nodesRef.current = [...nodesRef.current, node];
  }, []);
  const removeNode = react.useCallback(node => {
    nodesRef.current = nodesRef.current.filter(n => n !== node);
  }, []);
  const [events] = react.useState(() => createEventEmitter());
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FloatingTreeContext.Provider, {
    value: react.useMemo(() => ({
      nodesRef,
      addNode,
      removeNode,
      events
    }), [addNode, removeNode, events]),
    children: children
  });
}
function createAttribute(name) {
  return "data-floating-ui-" + name;
}
function clearTimeoutIfSet(timeoutRef) {
  if (timeoutRef.current !== -1) {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = -1;
  }
}
const safePolygonIdentifier = /*#__PURE__*/createAttribute('safe-polygon');
function getDelay(value, prop, pointerType) {
  if (pointerType && !isMouseLikePointerType(pointerType)) {
    return 0;
  }
  if (typeof value === 'number') {
    return value;
  }
  if (typeof value === 'function') {
    const result = value();
    if (typeof result === 'number') {
      return result;
    }
    return result == null ? void 0 : result[prop];
  }
  return value == null ? void 0 : value[prop];
}
function getRestMs(value) {
  if (typeof value === 'function') {
    return value();
  }
  return value;
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */
function useHover(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    events,
    elements
  } = context;
  const {
    enabled = true,
    delay = 0,
    handleClose = null,
    mouseOnly = false,
    restMs = 0,
    move = true
  } = props;
  const tree = useFloatingTree();
  const parentId = useFloatingParentNodeId();
  const handleCloseRef = useLatestRef(handleClose);
  const delayRef = useLatestRef(delay);
  const openRef = useLatestRef(open);
  const restMsRef = useLatestRef(restMs);
  const pointerTypeRef = react.useRef();
  const timeoutRef = react.useRef(-1);
  const handlerRef = react.useRef();
  const restTimeoutRef = react.useRef(-1);
  const blockMouseMoveRef = react.useRef(true);
  const performedPointerEventsMutationRef = react.useRef(false);
  const unbindMouseMoveRef = react.useRef(() => {});
  const restTimeoutPendingRef = react.useRef(false);
  const isHoverOpen = useEffectEvent(() => {
    var _dataRef$current$open;
    const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
    return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
  });

  // When closing before opening, clear the delay timeouts to cancel it
  // from showing.
  react.useEffect(() => {
    if (!enabled) return;
    function onOpenChange(_ref) {
      let {
        open
      } = _ref;
      if (!open) {
        clearTimeoutIfSet(timeoutRef);
        clearTimeoutIfSet(restTimeoutRef);
        blockMouseMoveRef.current = true;
        restTimeoutPendingRef.current = false;
      }
    }
    events.on('openchange', onOpenChange);
    return () => {
      events.off('openchange', onOpenChange);
    };
  }, [enabled, events]);
  react.useEffect(() => {
    if (!enabled) return;
    if (!handleCloseRef.current) return;
    if (!open) return;
    function onLeave(event) {
      if (isHoverOpen()) {
        onOpenChange(false, event, 'hover');
      }
    }
    const html = getDocument(elements.floating).documentElement;
    html.addEventListener('mouseleave', onLeave);
    return () => {
      html.removeEventListener('mouseleave', onLeave);
    };
  }, [elements.floating, open, onOpenChange, enabled, handleCloseRef, isHoverOpen]);
  const closeWithDelay = react.useCallback(function (event, runElseBranch, reason) {
    if (runElseBranch === void 0) {
      runElseBranch = true;
    }
    if (reason === void 0) {
      reason = 'hover';
    }
    const closeDelay = getDelay(delayRef.current, 'close', pointerTypeRef.current);
    if (closeDelay && !handlerRef.current) {
      clearTimeoutIfSet(timeoutRef);
      timeoutRef.current = window.setTimeout(() => onOpenChange(false, event, reason), closeDelay);
    } else if (runElseBranch) {
      clearTimeoutIfSet(timeoutRef);
      onOpenChange(false, event, reason);
    }
  }, [delayRef, onOpenChange]);
  const cleanupMouseMoveHandler = useEffectEvent(() => {
    unbindMouseMoveRef.current();
    handlerRef.current = undefined;
  });
  const clearPointerEvents = useEffectEvent(() => {
    if (performedPointerEventsMutationRef.current) {
      const body = getDocument(elements.floating).body;
      body.style.pointerEvents = '';
      body.removeAttribute(safePolygonIdentifier);
      performedPointerEventsMutationRef.current = false;
    }
  });
  const isClickLikeOpenEvent = useEffectEvent(() => {
    return dataRef.current.openEvent ? ['click', 'mousedown'].includes(dataRef.current.openEvent.type) : false;
  });

  // Registering the mouse events on the reference directly to bypass React's
  // delegation system. If the cursor was on a disabled element and then entered
  // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
  react.useEffect(() => {
    if (!enabled) return;
    function onReferenceMouseEnter(event) {
      clearTimeoutIfSet(timeoutRef);
      blockMouseMoveRef.current = false;
      if (mouseOnly && !isMouseLikePointerType(pointerTypeRef.current) || getRestMs(restMsRef.current) > 0 && !getDelay(delayRef.current, 'open')) {
        return;
      }
      const openDelay = getDelay(delayRef.current, 'open', pointerTypeRef.current);
      if (openDelay) {
        timeoutRef.current = window.setTimeout(() => {
          if (!openRef.current) {
            onOpenChange(true, event, 'hover');
          }
        }, openDelay);
      } else if (!open) {
        onOpenChange(true, event, 'hover');
      }
    }
    function onReferenceMouseLeave(event) {
      if (isClickLikeOpenEvent()) {
        clearPointerEvents();
        return;
      }
      unbindMouseMoveRef.current();
      const doc = getDocument(elements.floating);
      clearTimeoutIfSet(restTimeoutRef);
      restTimeoutPendingRef.current = false;
      if (handleCloseRef.current && dataRef.current.floatingContext) {
        // Prevent clearing `onScrollMouseLeave` timeout.
        if (!open) {
          clearTimeoutIfSet(timeoutRef);
        }
        handlerRef.current = handleCloseRef.current({
          ...dataRef.current.floatingContext,
          tree,
          x: event.clientX,
          y: event.clientY,
          onClose() {
            clearPointerEvents();
            cleanupMouseMoveHandler();
            if (!isClickLikeOpenEvent()) {
              closeWithDelay(event, true, 'safe-polygon');
            }
          }
        });
        const handler = handlerRef.current;
        doc.addEventListener('mousemove', handler);
        unbindMouseMoveRef.current = () => {
          doc.removeEventListener('mousemove', handler);
        };
        return;
      }

      // Allow interactivity without `safePolygon` on touch devices. With a
      // pointer, a short close delay is an alternative, so it should work
      // consistently.
      const shouldClose = pointerTypeRef.current === 'touch' ? !contains(elements.floating, event.relatedTarget) : true;
      if (shouldClose) {
        closeWithDelay(event);
      }
    }

    // Ensure the floating element closes after scrolling even if the pointer
    // did not move.
    // https://github.com/floating-ui/floating-ui/discussions/1692
    function onScrollMouseLeave(event) {
      if (isClickLikeOpenEvent()) return;
      if (!dataRef.current.floatingContext) return;
      handleCloseRef.current == null || handleCloseRef.current({
        ...dataRef.current.floatingContext,
        tree,
        x: event.clientX,
        y: event.clientY,
        onClose() {
          clearPointerEvents();
          cleanupMouseMoveHandler();
          if (!isClickLikeOpenEvent()) {
            closeWithDelay(event);
          }
        }
      })(event);
    }
    function onFloatingMouseEnter() {
      clearTimeoutIfSet(timeoutRef);
    }
    function onFloatingMouseLeave(event) {
      if (!isClickLikeOpenEvent()) {
        closeWithDelay(event, false);
      }
    }
    if ((0,floating_ui_utils_dom/* isElement */.kK)(elements.domReference)) {
      const reference = elements.domReference;
      const floating = elements.floating;
      if (open) {
        reference.addEventListener('mouseleave', onScrollMouseLeave);
      }
      if (move) {
        reference.addEventListener('mousemove', onReferenceMouseEnter, {
          once: true
        });
      }
      reference.addEventListener('mouseenter', onReferenceMouseEnter);
      reference.addEventListener('mouseleave', onReferenceMouseLeave);
      if (floating) {
        floating.addEventListener('mouseleave', onScrollMouseLeave);
        floating.addEventListener('mouseenter', onFloatingMouseEnter);
        floating.addEventListener('mouseleave', onFloatingMouseLeave);
      }
      return () => {
        if (open) {
          reference.removeEventListener('mouseleave', onScrollMouseLeave);
        }
        if (move) {
          reference.removeEventListener('mousemove', onReferenceMouseEnter);
        }
        reference.removeEventListener('mouseenter', onReferenceMouseEnter);
        reference.removeEventListener('mouseleave', onReferenceMouseLeave);
        if (floating) {
          floating.removeEventListener('mouseleave', onScrollMouseLeave);
          floating.removeEventListener('mouseenter', onFloatingMouseEnter);
          floating.removeEventListener('mouseleave', onFloatingMouseLeave);
        }
      };
    }
  }, [elements, enabled, context, mouseOnly, move, closeWithDelay, cleanupMouseMoveHandler, clearPointerEvents, onOpenChange, open, openRef, tree, delayRef, handleCloseRef, dataRef, isClickLikeOpenEvent, restMsRef]);

  // Block pointer-events of every element other than the reference and floating
  // while the floating element is open and has a `handleClose` handler. Also
  // handles nested floating elements.
  // https://github.com/floating-ui/floating-ui/issues/1722
  floating_ui_react_utils_index(() => {
    var _handleCloseRef$curre;
    if (!enabled) return;
    if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && (_handleCloseRef$curre = _handleCloseRef$curre.__options) != null && _handleCloseRef$curre.blockPointerEvents && isHoverOpen()) {
      performedPointerEventsMutationRef.current = true;
      const floatingEl = elements.floating;
      if ((0,floating_ui_utils_dom/* isElement */.kK)(elements.domReference) && floatingEl) {
        var _tree$nodesRef$curren;
        const body = getDocument(elements.floating).body;
        body.setAttribute(safePolygonIdentifier, '');
        const ref = elements.domReference;
        const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find(node => node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
        if (parentFloating) {
          parentFloating.style.pointerEvents = '';
        }
        body.style.pointerEvents = 'none';
        ref.style.pointerEvents = 'auto';
        floatingEl.style.pointerEvents = 'auto';
        return () => {
          body.style.pointerEvents = '';
          ref.style.pointerEvents = '';
          floatingEl.style.pointerEvents = '';
        };
      }
    }
  }, [enabled, open, parentId, elements, tree, handleCloseRef, isHoverOpen]);
  floating_ui_react_utils_index(() => {
    if (!open) {
      pointerTypeRef.current = undefined;
      restTimeoutPendingRef.current = false;
      cleanupMouseMoveHandler();
      clearPointerEvents();
    }
  }, [open, cleanupMouseMoveHandler, clearPointerEvents]);
  react.useEffect(() => {
    return () => {
      cleanupMouseMoveHandler();
      clearTimeoutIfSet(timeoutRef);
      clearTimeoutIfSet(restTimeoutRef);
      clearPointerEvents();
    };
  }, [enabled, elements.domReference, cleanupMouseMoveHandler, clearPointerEvents]);
  const reference = react.useMemo(() => {
    function setPointerRef(event) {
      pointerTypeRef.current = event.pointerType;
    }
    return {
      onPointerDown: setPointerRef,
      onPointerEnter: setPointerRef,
      onMouseMove(event) {
        const {
          nativeEvent
        } = event;
        function handleMouseMove() {
          if (!blockMouseMoveRef.current && !openRef.current) {
            onOpenChange(true, nativeEvent, 'hover');
          }
        }
        if (mouseOnly && !isMouseLikePointerType(pointerTypeRef.current)) {
          return;
        }
        if (open || getRestMs(restMsRef.current) === 0) {
          return;
        }

        // Ignore insignificant movements to account for tremors.
        if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) {
          return;
        }
        clearTimeoutIfSet(restTimeoutRef);
        if (pointerTypeRef.current === 'touch') {
          handleMouseMove();
        } else {
          restTimeoutPendingRef.current = true;
          restTimeoutRef.current = window.setTimeout(handleMouseMove, getRestMs(restMsRef.current));
        }
      }
    };
  }, [mouseOnly, onOpenChange, open, openRef, restMsRef]);
  return react.useMemo(() => enabled ? {
    reference
  } : {}, [enabled, reference]);
}
const NOOP = () => {};
const FloatingDelayGroupContext = /*#__PURE__*/react.createContext({
  delay: 0,
  initialDelay: 0,
  timeoutMs: 0,
  currentId: null,
  setCurrentId: NOOP,
  setState: NOOP,
  isInstantPhase: false
});

/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */
const useDelayGroupContext = () => react.useContext(FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */
function FloatingDelayGroup(props) {
  const {
    children,
    delay,
    timeoutMs = 0
  } = props;
  const [state, setState] = react.useReducer((prev, next) => ({
    ...prev,
    ...next
  }), {
    delay,
    timeoutMs,
    initialDelay: delay,
    currentId: null,
    isInstantPhase: false
  });
  const initialCurrentIdRef = react.useRef(null);
  const setCurrentId = react.useCallback(currentId => {
    setState({
      currentId
    });
  }, []);
  floating_ui_react_utils_index(() => {
    if (state.currentId) {
      if (initialCurrentIdRef.current === null) {
        initialCurrentIdRef.current = state.currentId;
      } else if (!state.isInstantPhase) {
        setState({
          isInstantPhase: true
        });
      }
    } else {
      if (state.isInstantPhase) {
        setState({
          isInstantPhase: false
        });
      }
      initialCurrentIdRef.current = null;
    }
  }, [state.currentId, state.isInstantPhase]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FloatingDelayGroupContext.Provider, {
    value: react.useMemo(() => ({
      ...state,
      setState,
      setCurrentId
    }), [state, setCurrentId]),
    children: children
  });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */
function useDelayGroup(context, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    open,
    onOpenChange,
    floatingId
  } = context;
  const {
    id: optionId,
    enabled = true
  } = options;
  const id = optionId != null ? optionId : floatingId;
  const groupContext = useDelayGroupContext();
  const {
    currentId,
    setCurrentId,
    initialDelay,
    setState,
    timeoutMs
  } = groupContext;
  floating_ui_react_utils_index(() => {
    if (!enabled) return;
    if (!currentId) return;
    setState({
      delay: {
        open: 1,
        close: getDelay(initialDelay, 'close')
      }
    });
    if (currentId !== id) {
      onOpenChange(false);
    }
  }, [enabled, id, onOpenChange, setState, currentId, initialDelay]);
  floating_ui_react_utils_index(() => {
    function unset() {
      onOpenChange(false);
      setState({
        delay: initialDelay,
        currentId: null
      });
    }
    if (!enabled) return;
    if (!currentId) return;
    if (!open && currentId === id) {
      if (timeoutMs) {
        const timeout = window.setTimeout(unset, timeoutMs);
        return () => {
          clearTimeout(timeout);
        };
      }
      unset();
    }
  }, [enabled, open, setState, currentId, id, onOpenChange, initialDelay, timeoutMs]);
  floating_ui_react_utils_index(() => {
    if (!enabled) return;
    if (setCurrentId === NOOP || !open) return;
    setCurrentId(id);
  }, [enabled, open, setCurrentId, id]);
  return groupContext;
}
const NextFloatingDelayGroupContext = /*#__PURE__*/react.createContext({
  hasProvider: false,
  timeoutMs: 0,
  delayRef: {
    current: 0
  },
  initialDelayRef: {
    current: 0
  },
  timeoutIdRef: {
    current: -1
  },
  currentIdRef: {
    current: null
  },
  currentContextRef: {
    current: null
  }
});
/**
 * Experimental next version of `FloatingDelayGroup` to become the default
 * in the future. This component is not yet stable.
 * Provides context for a group of floating elements that should share a
 * `delay`. Unlike `FloatingDelayGroup`, `useNextDelayGroup` with this
 * component does not cause a re-render of unrelated consumers of the
 * context when the delay changes.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */
function NextFloatingDelayGroup(props) {
  const {
    children,
    delay,
    timeoutMs = 0
  } = props;
  const delayRef = react.useRef(delay);
  const initialDelayRef = react.useRef(delay);
  const currentIdRef = react.useRef(null);
  const currentContextRef = react.useRef(null);
  const timeoutIdRef = react.useRef(-1);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(NextFloatingDelayGroupContext.Provider, {
    value: react.useMemo(() => ({
      hasProvider: true,
      delayRef,
      initialDelayRef,
      currentIdRef,
      timeoutMs,
      currentContextRef,
      timeoutIdRef
    }), [timeoutMs]),
    children: children
  });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `NextFloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */
function useNextDelayGroup(context, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    open,
    onOpenChange,
    floatingId
  } = context;
  const {
    enabled = true
  } = options;
  const groupContext = react.useContext(NextFloatingDelayGroupContext);
  const {
    currentIdRef,
    delayRef,
    timeoutMs,
    initialDelayRef,
    currentContextRef,
    hasProvider,
    timeoutIdRef
  } = groupContext;
  const [isInstantPhase, setIsInstantPhase] = react.useState(false);
  floating_ui_react_utils_index(() => {
    function unset() {
      var _currentContextRef$cu;
      setIsInstantPhase(false);
      (_currentContextRef$cu = currentContextRef.current) == null || _currentContextRef$cu.setIsInstantPhase(false);
      currentIdRef.current = null;
      currentContextRef.current = null;
      delayRef.current = initialDelayRef.current;
    }
    if (!enabled) return;
    if (!currentIdRef.current) return;
    if (!open && currentIdRef.current === floatingId) {
      setIsInstantPhase(false);
      if (timeoutMs) {
        timeoutIdRef.current = window.setTimeout(unset, timeoutMs);
        return () => {
          clearTimeout(timeoutIdRef.current);
        };
      }
      unset();
    }
  }, [enabled, open, floatingId, currentIdRef, delayRef, timeoutMs, initialDelayRef, currentContextRef, timeoutIdRef]);
  floating_ui_react_utils_index(() => {
    if (!enabled) return;
    if (!open) return;
    const prevContext = currentContextRef.current;
    const prevId = currentIdRef.current;
    currentContextRef.current = {
      onOpenChange,
      setIsInstantPhase
    };
    currentIdRef.current = floatingId;
    delayRef.current = {
      open: 0,
      close: getDelay(initialDelayRef.current, 'close')
    };
    if (prevId !== null && prevId !== floatingId) {
      clearTimeoutIfSet(timeoutIdRef);
      setIsInstantPhase(true);
      prevContext == null || prevContext.setIsInstantPhase(true);
      prevContext == null || prevContext.onOpenChange(false);
    } else {
      setIsInstantPhase(false);
      prevContext == null || prevContext.setIsInstantPhase(false);
    }
  }, [enabled, open, floatingId, onOpenChange, currentIdRef, delayRef, timeoutMs, initialDelayRef, currentContextRef, timeoutIdRef]);
  floating_ui_react_utils_index(() => {
    return () => {
      currentContextRef.current = null;
    };
  }, [currentContextRef]);
  return react.useMemo(() => ({
    hasProvider,
    delayRef,
    isInstantPhase
  }), [hasProvider, delayRef, isInstantPhase]);
}
let rafId = 0;
function enqueueFocus(el, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    preventScroll = false,
    cancelPrevious = true,
    sync = false
  } = options;
  cancelPrevious && cancelAnimationFrame(rafId);
  const exec = () => el == null ? void 0 : el.focus({
    preventScroll
  });
  if (sync) {
    exec();
  } else {
    rafId = requestAnimationFrame(exec);
  }
}
function floating_ui_react_esm_contains(parent, child) {
  if (!parent || !child) {
    return false;
  }
  const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();

  // First, attempt with faster native method
  if (parent.contains(child)) {
    return true;
  }

  // then fallback to custom implementation with Shadow DOM support
  if (rootNode && (0,floating_ui_utils_dom/* isShadowRoot */.Zq)(rootNode)) {
    let next = child;
    while (next) {
      if (parent === next) {
        return true;
      }
      // @ts-ignore
      next = next.parentNode || next.host;
    }
  }

  // Give up, the result is false
  return false;
}
function floating_ui_react_esm_getTarget(event) {
  if ('composedPath' in event) {
    return event.composedPath()[0];
  }

  // TS thinks `event` is of type never as it assumes all browsers support
  // `composedPath()`, but browsers without shadow DOM don't.
  return event.target;
}
function floating_ui_react_esm_getDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}

// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
const counters = {
  inert: /*#__PURE__*/new WeakMap(),
  'aria-hidden': /*#__PURE__*/new WeakMap(),
  none: /*#__PURE__*/new WeakMap()
};
function getCounterMap(control) {
  if (control === 'inert') return counters.inert;
  if (control === 'aria-hidden') return counters['aria-hidden'];
  return counters.none;
}
let uncontrolledElementsSet = /*#__PURE__*/new WeakSet();
let markerMap = {};
let lockCount$1 = 0;
const supportsInert = () => typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
const unwrapHost = node => node && (node.host || unwrapHost(node.parentNode));
const correctElements = (parent, targets) => targets.map(target => {
  if (parent.contains(target)) {
    return target;
  }
  const correctedTarget = unwrapHost(target);
  if (parent.contains(correctedTarget)) {
    return correctedTarget;
  }
  return null;
}).filter(x => x != null);
function applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
  const markerName = 'data-floating-ui-inert';
  const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
  const avoidElements = correctElements(body, uncorrectedAvoidElements);
  const elementsToKeep = new Set();
  const elementsToStop = new Set(avoidElements);
  const hiddenElements = [];
  if (!markerMap[markerName]) {
    markerMap[markerName] = new WeakMap();
  }
  const markerCounter = markerMap[markerName];
  avoidElements.forEach(keep);
  deep(body);
  elementsToKeep.clear();
  function keep(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    el.parentNode && keep(el.parentNode);
  }
  function deep(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    [].forEach.call(parent.children, node => {
      if ((0,floating_ui_utils_dom/* getNodeName */.wk)(node) === 'script') return;
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
        const alreadyHidden = attr !== null && attr !== 'false';
        const counterMap = getCounterMap(controlAttribute);
        const counterValue = (counterMap.get(node) || 0) + 1;
        const markerValue = (markerCounter.get(node) || 0) + 1;
        counterMap.set(node, counterValue);
        markerCounter.set(node, markerValue);
        hiddenElements.push(node);
        if (counterValue === 1 && alreadyHidden) {
          uncontrolledElementsSet.add(node);
        }
        if (markerValue === 1) {
          node.setAttribute(markerName, '');
        }
        if (!alreadyHidden && controlAttribute) {
          node.setAttribute(controlAttribute, controlAttribute === 'inert' ? '' : 'true');
        }
      }
    });
  }
  lockCount$1++;
  return () => {
    hiddenElements.forEach(element => {
      const counterMap = getCounterMap(controlAttribute);
      const currentCounterValue = counterMap.get(element) || 0;
      const counterValue = currentCounterValue - 1;
      const markerValue = (markerCounter.get(element) || 0) - 1;
      counterMap.set(element, counterValue);
      markerCounter.set(element, markerValue);
      if (!counterValue) {
        if (!uncontrolledElementsSet.has(element) && controlAttribute) {
          element.removeAttribute(controlAttribute);
        }
        uncontrolledElementsSet.delete(element);
      }
      if (!markerValue) {
        element.removeAttribute(markerName);
      }
    });
    lockCount$1--;
    if (!lockCount$1) {
      counters.inert = new WeakMap();
      counters['aria-hidden'] = new WeakMap();
      counters.none = new WeakMap();
      uncontrolledElementsSet = new WeakSet();
      markerMap = {};
    }
  };
}
function markOthers(avoidElements, ariaHidden, inert) {
  if (ariaHidden === void 0) {
    ariaHidden = false;
  }
  if (inert === void 0) {
    inert = false;
  }
  const body = floating_ui_react_esm_getDocument(avoidElements[0]).body;
  return applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live],[role="status"],output'))), body, ariaHidden, inert);
}
const HIDDEN_STYLES = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'fixed',
  whiteSpace: 'nowrap',
  width: '1px',
  top: 0,
  left: 0
};
const FocusGuard = /*#__PURE__*/react.forwardRef(function FocusGuard(props, ref) {
  const [role, setRole] = react.useState();
  floating_ui_react_utils_index(() => {
    if (isSafari()) {
      // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
      // on VoiceOver does trigger the onFocus event, so we can use the focus
      // trap element. On Safari, only buttons trigger the onFocus event.
      // NB: "group" role in the Sandbox no longer appears to work, must be a
      // button role.
      setRole('button');
    }
  }, []);
  const restProps = {
    ref,
    tabIndex: 0,
    // Role is only for VoiceOver
    role,
    'aria-hidden': role ? undefined : true,
    [createAttribute('focus-guard')]: '',
    style: HIDDEN_STYLES
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    ...props,
    ...restProps
  });
});
const PortalContext = /*#__PURE__*/react.createContext(null);
const attr = /*#__PURE__*/createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */
function useFloatingPortalNode(props) {
  if (props === void 0) {
    props = {};
  }
  const {
    id,
    root
  } = props;
  const uniqueId = useId();
  const portalContext = usePortalContext();
  const [portalNode, setPortalNode] = react.useState(null);
  const portalNodeRef = react.useRef(null);
  floating_ui_react_utils_index(() => {
    return () => {
      portalNode == null || portalNode.remove();
      // Allow the subsequent layout effects to create a new node on updates.
      // The portal node will still be cleaned up on unmount.
      // https://github.com/floating-ui/floating-ui/issues/2454
      queueMicrotask(() => {
        portalNodeRef.current = null;
      });
    };
  }, [portalNode]);
  floating_ui_react_utils_index(() => {
    // Wait for the uniqueId to be generated before creating the portal node in
    // React <18 (using `useFloatingId` instead of the native `useId`).
    // https://github.com/floating-ui/floating-ui/issues/2778
    if (!uniqueId) return;
    if (portalNodeRef.current) return;
    const existingIdRoot = id ? document.getElementById(id) : null;
    if (!existingIdRoot) return;
    const subRoot = document.createElement('div');
    subRoot.id = uniqueId;
    subRoot.setAttribute(attr, '');
    existingIdRoot.appendChild(subRoot);
    portalNodeRef.current = subRoot;
    setPortalNode(subRoot);
  }, [id, uniqueId]);
  floating_ui_react_utils_index(() => {
    // Wait for the root to exist before creating the portal node. The root must
    // be stored in state, not a ref, for this to work reactively.
    if (root === null) return;
    if (!uniqueId) return;
    if (portalNodeRef.current) return;
    let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
    if (container && !(0,floating_ui_utils_dom/* isNode */.UG)(container)) container = container.current;
    container = container || document.body;
    let idWrapper = null;
    if (id) {
      idWrapper = document.createElement('div');
      idWrapper.id = id;
      container.appendChild(idWrapper);
    }
    const subRoot = document.createElement('div');
    subRoot.id = uniqueId;
    subRoot.setAttribute(attr, '');
    container = idWrapper || container;
    container.appendChild(subRoot);
    portalNodeRef.current = subRoot;
    setPortalNode(subRoot);
  }, [id, root, uniqueId, portalContext]);
  return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */
function FloatingPortal(props) {
  const {
    children,
    id,
    root,
    preserveTabOrder = true
  } = props;
  const portalNode = useFloatingPortalNode({
    id,
    root
  });
  const [focusManagerState, setFocusManagerState] = react.useState(null);
  const beforeOutsideRef = react.useRef(null);
  const afterOutsideRef = react.useRef(null);
  const beforeInsideRef = react.useRef(null);
  const afterInsideRef = react.useRef(null);
  const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
  const open = focusManagerState == null ? void 0 : focusManagerState.open;
  const shouldRenderGuards =
  // The FocusManager and therefore floating element are currently open/
  // rendered.
  !!focusManagerState &&
  // Guards are only for non-modal focus management.
  !focusManagerState.modal &&
  // Don't render if unmount is transitioning.
  focusManagerState.open && preserveTabOrder && !!(root || portalNode);

  // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
  react.useEffect(() => {
    if (!portalNode || !preserveTabOrder || modal) {
      return;
    }

    // Make sure elements inside the portal element are tabbable only when the
    // portal has already been focused, either by tabbing into a focus trap
    // element outside or using the mouse.
    function onFocus(event) {
      if (portalNode && isOutsideEvent(event)) {
        const focusing = event.type === 'focusin';
        const manageFocus = focusing ? enableFocusInside : disableFocusInside;
        manageFocus(portalNode);
      }
    }
    // Listen to the event on the capture phase so they run before the focus
    // trap elements onFocus prop is called.
    portalNode.addEventListener('focusin', onFocus, true);
    portalNode.addEventListener('focusout', onFocus, true);
    return () => {
      portalNode.removeEventListener('focusin', onFocus, true);
      portalNode.removeEventListener('focusout', onFocus, true);
    };
  }, [portalNode, preserveTabOrder, modal]);
  react.useEffect(() => {
    if (!portalNode) return;
    if (open) return;
    enableFocusInside(portalNode);
  }, [open, portalNode]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PortalContext.Provider, {
    value: react.useMemo(() => ({
      preserveTabOrder,
      beforeOutsideRef,
      afterOutsideRef,
      beforeInsideRef,
      afterInsideRef,
      portalNode,
      setFocusManagerState
    }), [preserveTabOrder, portalNode]),
    children: [shouldRenderGuards && portalNode && /*#__PURE__*/(0,jsx_runtime.jsx)(FocusGuard, {
      "data-type": "outside",
      ref: beforeOutsideRef,
      onFocus: event => {
        if (isOutsideEvent(event, portalNode)) {
          var _beforeInsideRef$curr;
          (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
        } else {
          const domReference = focusManagerState ? focusManagerState.domReference : null;
          const prevTabbable = getPreviousTabbable(domReference);
          prevTabbable == null || prevTabbable.focus();
        }
      }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      "aria-owns": portalNode.id,
      style: HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/react_dom.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/(0,jsx_runtime.jsx)(FocusGuard, {
      "data-type": "outside",
      ref: afterOutsideRef,
      onFocus: event => {
        if (isOutsideEvent(event, portalNode)) {
          var _afterInsideRef$curre;
          (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
        } else {
          const domReference = focusManagerState ? focusManagerState.domReference : null;
          const nextTabbable = getNextTabbable(domReference);
          nextTabbable == null || nextTabbable.focus();
          (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null ? void 0 : focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
        }
      }
    })]
  });
}
const usePortalContext = () => react.useContext(PortalContext);
function useLiteMergeRefs(refs) {
  return react.useMemo(() => {
    return value => {
      refs.forEach(ref => {
        if (ref) {
          ref.current = value;
        }
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}
const LIST_LIMIT = 20;
let previouslyFocusedElements = [];
function clearDisconnectedPreviouslyFocusedElements() {
  previouslyFocusedElements = previouslyFocusedElements.filter(el => el.isConnected);
}
function addPreviouslyFocusedElement(element) {
  clearDisconnectedPreviouslyFocusedElements();
  if (element && (0,floating_ui_utils_dom/* getNodeName */.wk)(element) !== 'body') {
    previouslyFocusedElements.push(element);
    if (previouslyFocusedElements.length > LIST_LIMIT) {
      previouslyFocusedElements = previouslyFocusedElements.slice(-20);
    }
  }
}
function getPreviouslyFocusedElement() {
  clearDisconnectedPreviouslyFocusedElements();
  return previouslyFocusedElements[previouslyFocusedElements.length - 1];
}
function getFirstTabbableElement(container) {
  const tabbableOptions = getTabbableOptions();
  if (isTabbable(container, tabbableOptions)) {
    return container;
  }
  return tabbable(container, tabbableOptions)[0] || container;
}
function handleTabIndex(floatingFocusElement, orderRef) {
  var _floatingFocusElement;
  if (!orderRef.current.includes('floating') && !((_floatingFocusElement = floatingFocusElement.getAttribute('role')) != null && _floatingFocusElement.includes('dialog'))) {
    return;
  }
  const options = getTabbableOptions();
  const focusableElements = focusable(floatingFocusElement, options);
  const tabbableContent = focusableElements.filter(element => {
    const dataTabIndex = element.getAttribute('data-tabindex') || '';
    return isTabbable(element, options) || element.hasAttribute('data-tabindex') && !dataTabIndex.startsWith('-');
  });
  const tabIndex = floatingFocusElement.getAttribute('tabindex');
  if (orderRef.current.includes('floating') || tabbableContent.length === 0) {
    if (tabIndex !== '0') {
      floatingFocusElement.setAttribute('tabindex', '0');
    }
  } else if (tabIndex !== '-1' || floatingFocusElement.hasAttribute('data-tabindex') && floatingFocusElement.getAttribute('data-tabindex') !== '-1') {
    floatingFocusElement.setAttribute('tabindex', '-1');
    floatingFocusElement.setAttribute('data-tabindex', '-1');
  }
}
const VisuallyHiddenDismiss = /*#__PURE__*/react.forwardRef(function VisuallyHiddenDismiss(props, ref) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
    ...props,
    type: "button",
    ref: ref,
    tabIndex: -1,
    style: HIDDEN_STYLES
  });
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */
function FloatingFocusManager(props) {
  const {
    context,
    children,
    disabled = false,
    order = ['content'],
    guards: _guards = true,
    initialFocus = 0,
    returnFocus = true,
    restoreFocus = false,
    modal = true,
    visuallyHiddenDismiss = false,
    closeOnFocusOut = true,
    outsideElementsInert = false,
    getInsideElements: _getInsideElements = () => []
  } = props;
  const {
    open,
    onOpenChange,
    events,
    dataRef,
    elements: {
      domReference,
      floating
    }
  } = context;
  const getNodeId = useEffectEvent(() => {
    var _dataRef$current$floa;
    return (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
  });
  const getInsideElements = useEffectEvent(_getInsideElements);
  const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
  // If the reference is a combobox and is typeable (e.g. input/textarea),
  // there are different focus semantics. The guards should not be rendered, but
  // aria-hidden should be applied to all nodes still. Further, the visually
  // hidden dismiss button should only appear at the end of the list, not the
  // start.
  const isUntrappedTypeableCombobox = isTypeableCombobox(domReference) && ignoreInitialFocus;

  // Force the guards to be rendered if the `inert` attribute is not supported.
  const inertSupported = supportsInert();
  const guards = inertSupported ? _guards : true;
  const useInert = !guards || inertSupported && outsideElementsInert;
  const orderRef = useLatestRef(order);
  const initialFocusRef = useLatestRef(initialFocus);
  const returnFocusRef = useLatestRef(returnFocus);
  const tree = useFloatingTree();
  const portalContext = usePortalContext();
  const startDismissButtonRef = react.useRef(null);
  const endDismissButtonRef = react.useRef(null);
  const preventReturnFocusRef = react.useRef(false);
  const isPointerDownRef = react.useRef(false);
  const tabbableIndexRef = react.useRef(-1);
  const blurTimeoutRef = react.useRef(-1);
  const isInsidePortal = portalContext != null;
  const floatingFocusElement = getFloatingFocusElement(floating);
  const getTabbableContent = useEffectEvent(function (container) {
    if (container === void 0) {
      container = floatingFocusElement;
    }
    return container ? tabbable(container, getTabbableOptions()) : [];
  });
  const getTabbableElements = useEffectEvent(container => {
    const content = getTabbableContent(container);
    return orderRef.current.map(type => {
      if (domReference && type === 'reference') {
        return domReference;
      }
      if (floatingFocusElement && type === 'floating') {
        return floatingFocusElement;
      }
      return content;
    }).filter(Boolean).flat();
  });
  react.useEffect(() => {
    if (disabled) return;
    if (!modal) return;
    function onKeyDown(event) {
      if (event.key === 'Tab') {
        // The focus guards have nothing to focus, so we need to stop the event.
        if (contains(floatingFocusElement, activeElement(getDocument(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) {
          stopEvent(event);
        }
        const els = getTabbableElements();
        const target = getTarget(event);
        if (orderRef.current[0] === 'reference' && target === domReference) {
          stopEvent(event);
          if (event.shiftKey) {
            enqueueFocus(els[els.length - 1]);
          } else {
            enqueueFocus(els[1]);
          }
        }
        if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
          stopEvent(event);
          enqueueFocus(els[0]);
        }
      }
    }
    const doc = getDocument(floatingFocusElement);
    doc.addEventListener('keydown', onKeyDown);
    return () => {
      doc.removeEventListener('keydown', onKeyDown);
    };
  }, [disabled, domReference, floatingFocusElement, modal, orderRef, isUntrappedTypeableCombobox, getTabbableContent, getTabbableElements]);
  react.useEffect(() => {
    if (disabled) return;
    if (!floating) return;
    function handleFocusIn(event) {
      const target = getTarget(event);
      const tabbableContent = getTabbableContent();
      const tabbableIndex = tabbableContent.indexOf(target);
      if (tabbableIndex !== -1) {
        tabbableIndexRef.current = tabbableIndex;
      }
    }
    floating.addEventListener('focusin', handleFocusIn);
    return () => {
      floating.removeEventListener('focusin', handleFocusIn);
    };
  }, [disabled, floating, getTabbableContent]);
  react.useEffect(() => {
    if (disabled) return;
    if (!closeOnFocusOut) return;

    // In Safari, buttons lose focus when pressing them.
    function handlePointerDown() {
      isPointerDownRef.current = true;
      setTimeout(() => {
        isPointerDownRef.current = false;
      });
    }
    function handleFocusOutside(event) {
      const relatedTarget = event.relatedTarget;
      const currentTarget = event.currentTarget;
      const target = getTarget(event);
      queueMicrotask(() => {
        const nodeId = getNodeId();
        const movedToUnrelatedNode = !(contains(domReference, relatedTarget) || contains(floating, relatedTarget) || contains(relatedTarget, floating) || contains(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute(createAttribute('focus-guard')) || tree && (getNodeChildren(tree.nodesRef.current, nodeId).find(node => {
          var _node$context, _node$context2;
          return contains((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || contains((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
        }) || getNodeAncestors(tree.nodesRef.current, nodeId).find(node => {
          var _node$context3, _node$context4, _node$context5;
          return [(_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating, getFloatingFocusElement((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.floating)].includes(relatedTarget) || ((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.domReference) === relatedTarget;
        })));
        if (currentTarget === domReference && floatingFocusElement) {
          handleTabIndex(floatingFocusElement, orderRef);
        }

        // Restore focus to the previous tabbable element index to prevent
        // focus from being lost outside the floating tree.
        if (restoreFocus && currentTarget !== domReference && !(target != null && target.isConnected) && activeElement(getDocument(floatingFocusElement)) === getDocument(floatingFocusElement).body) {
          // Let `FloatingPortal` effect knows that focus is still inside the
          // floating tree.
          if ((0,floating_ui_utils_dom/* isHTMLElement */.Re)(floatingFocusElement)) {
            floatingFocusElement.focus();
          }
          const prevTabbableIndex = tabbableIndexRef.current;
          const tabbableContent = getTabbableContent();
          const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
          if ((0,floating_ui_utils_dom/* isHTMLElement */.Re)(nodeToFocus)) {
            nodeToFocus.focus();
          }
        }

        // https://github.com/floating-ui/floating-ui/issues/3060
        if (dataRef.current.insideReactTree) {
          dataRef.current.insideReactTree = false;
          return;
        }

        // Focus did not move inside the floating tree, and there are no tabbable
        // portal guards to handle closing.
        if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current &&
        // Fix React 18 Strict Mode returnFocus due to double rendering.
        relatedTarget !== getPreviouslyFocusedElement()) {
          preventReturnFocusRef.current = true;
          onOpenChange(false, event, 'focus-out');
        }
      });
    }
    const shouldHandleBlurCapture = Boolean(!tree && portalContext);
    function markInsideReactTree() {
      clearTimeoutIfSet(blurTimeoutRef);
      dataRef.current.insideReactTree = true;
      blurTimeoutRef.current = window.setTimeout(() => {
        dataRef.current.insideReactTree = false;
      });
    }
    if (floating && (0,floating_ui_utils_dom/* isHTMLElement */.Re)(domReference)) {
      domReference.addEventListener('focusout', handleFocusOutside);
      domReference.addEventListener('pointerdown', handlePointerDown);
      floating.addEventListener('focusout', handleFocusOutside);
      if (shouldHandleBlurCapture) {
        floating.addEventListener('focusout', markInsideReactTree, true);
      }
      return () => {
        domReference.removeEventListener('focusout', handleFocusOutside);
        domReference.removeEventListener('pointerdown', handlePointerDown);
        floating.removeEventListener('focusout', handleFocusOutside);
        if (shouldHandleBlurCapture) {
          floating.removeEventListener('focusout', markInsideReactTree, true);
        }
      };
    }
  }, [disabled, domReference, floating, floatingFocusElement, modal, tree, portalContext, onOpenChange, closeOnFocusOut, restoreFocus, getTabbableContent, isUntrappedTypeableCombobox, getNodeId, orderRef, dataRef]);
  const beforeGuardRef = react.useRef(null);
  const afterGuardRef = react.useRef(null);
  const mergedBeforeGuardRef = useLiteMergeRefs([beforeGuardRef, portalContext == null ? void 0 : portalContext.beforeInsideRef]);
  const mergedAfterGuardRef = useLiteMergeRefs([afterGuardRef, portalContext == null ? void 0 : portalContext.afterInsideRef]);
  react.useEffect(() => {
    var _portalContext$portal, _ancestors$find;
    if (disabled) return;
    if (!floating) return;

    // Don't hide portals nested within the parent portal.
    const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + createAttribute('portal') + "]")) || []);
    const ancestors = tree ? getNodeAncestors(tree.nodesRef.current, getNodeId()) : [];
    const rootAncestorComboboxDomReference = (_ancestors$find = ancestors.find(node => {
      var _node$context6;
      return isTypeableCombobox(((_node$context6 = node.context) == null ? void 0 : _node$context6.elements.domReference) || null);
    })) == null || (_ancestors$find = _ancestors$find.context) == null ? void 0 : _ancestors$find.elements.domReference;
    const insideElements = [floating, rootAncestorComboboxDomReference, ...portalNodes, ...getInsideElements(), startDismissButtonRef.current, endDismissButtonRef.current, beforeGuardRef.current, afterGuardRef.current, portalContext == null ? void 0 : portalContext.beforeOutsideRef.current, portalContext == null ? void 0 : portalContext.afterOutsideRef.current, orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null].filter(x => x != null);
    const cleanup = modal || isUntrappedTypeableCombobox ? markOthers(insideElements, !useInert, useInert) : markOthers(insideElements);
    return () => {
      cleanup();
    };
  }, [disabled, domReference, floating, modal, orderRef, portalContext, isUntrappedTypeableCombobox, guards, useInert, tree, getNodeId, getInsideElements]);
  floating_ui_react_utils_index(() => {
    if (disabled || !(0,floating_ui_utils_dom/* isHTMLElement */.Re)(floatingFocusElement)) return;
    const doc = getDocument(floatingFocusElement);
    const previouslyFocusedElement = activeElement(doc);

    // Wait for any layout effect state setters to execute to set `tabIndex`.
    queueMicrotask(() => {
      const focusableElements = getTabbableElements(floatingFocusElement);
      const initialFocusValue = initialFocusRef.current;
      const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
      const focusAlreadyInsideFloatingEl = contains(floatingFocusElement, previouslyFocusedElement);
      if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) {
        enqueueFocus(elToFocus, {
          preventScroll: elToFocus === floatingFocusElement
        });
      }
    });
  }, [disabled, open, floatingFocusElement, ignoreInitialFocus, getTabbableElements, initialFocusRef]);
  floating_ui_react_utils_index(() => {
    if (disabled || !floatingFocusElement) return;
    const doc = getDocument(floatingFocusElement);
    const previouslyFocusedElement = activeElement(doc);
    addPreviouslyFocusedElement(previouslyFocusedElement);

    // Dismissing via outside press should always ignore `returnFocus` to
    // prevent unwanted scrolling.
    function onOpenChange(_ref) {
      let {
        reason,
        event,
        nested
      } = _ref;
      if (['hover', 'safe-polygon'].includes(reason) && event.type === 'mouseleave') {
        preventReturnFocusRef.current = true;
      }
      if (reason !== 'outside-press') return;
      if (nested) {
        preventReturnFocusRef.current = false;
      } else if (isVirtualClick(event) || isVirtualPointerEvent(event)) {
        preventReturnFocusRef.current = false;
      } else {
        let isPreventScrollSupported = false;
        document.createElement('div').focus({
          get preventScroll() {
            isPreventScrollSupported = true;
            return false;
          }
        });
        if (isPreventScrollSupported) {
          preventReturnFocusRef.current = false;
        } else {
          preventReturnFocusRef.current = true;
        }
      }
    }
    events.on('openchange', onOpenChange);
    const fallbackEl = doc.createElement('span');
    fallbackEl.setAttribute('tabindex', '-1');
    fallbackEl.setAttribute('aria-hidden', 'true');
    Object.assign(fallbackEl.style, HIDDEN_STYLES);
    if (isInsidePortal && domReference) {
      domReference.insertAdjacentElement('afterend', fallbackEl);
    }
    function getReturnElement() {
      if (typeof returnFocusRef.current === 'boolean') {
        const el = domReference || getPreviouslyFocusedElement();
        return el && el.isConnected ? el : fallbackEl;
      }
      return returnFocusRef.current.current || fallbackEl;
    }
    return () => {
      events.off('openchange', onOpenChange);
      const activeEl = activeElement(doc);
      const isFocusInsideFloatingTree = contains(floating, activeEl) || tree && getNodeChildren(tree.nodesRef.current, getNodeId(), false).some(node => {
        var _node$context7;
        return contains((_node$context7 = node.context) == null ? void 0 : _node$context7.elements.floating, activeEl);
      });
      const returnElement = getReturnElement();
      queueMicrotask(() => {
        // This is `returnElement`, if it's tabbable, or its first tabbable child.
        const tabbableReturnElement = getFirstTabbableElement(returnElement);
        if (
        // eslint-disable-next-line react-hooks/exhaustive-deps
        returnFocusRef.current && !preventReturnFocusRef.current && (0,floating_ui_utils_dom/* isHTMLElement */.Re)(tabbableReturnElement) && (
        // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        tabbableReturnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) {
          tabbableReturnElement.focus({
            preventScroll: true
          });
        }
        fallbackEl.remove();
      });
    };
  }, [disabled, floating, floatingFocusElement, returnFocusRef, dataRef, events, tree, isInsidePortal, domReference, getNodeId]);
  react.useEffect(() => {
    // The `returnFocus` cleanup behavior is inside a microtask; ensure we
    // wait for it to complete before resetting the flag.
    queueMicrotask(() => {
      preventReturnFocusRef.current = false;
    });
    return () => {
      queueMicrotask(clearDisconnectedPreviouslyFocusedElements);
    };
  }, [disabled]);

  // Synchronize the `context` & `modal` value to the FloatingPortal context.
  // It will decide whether or not it needs to render its own guards.
  floating_ui_react_utils_index(() => {
    if (disabled) return;
    if (!portalContext) return;
    portalContext.setFocusManagerState({
      modal,
      closeOnFocusOut,
      open,
      onOpenChange,
      domReference
    });
    return () => {
      portalContext.setFocusManagerState(null);
    };
  }, [disabled, portalContext, modal, open, onOpenChange, closeOnFocusOut, domReference]);
  floating_ui_react_utils_index(() => {
    if (disabled) return;
    if (!floatingFocusElement) return;
    handleTabIndex(floatingFocusElement, orderRef);
  }, [disabled, floatingFocusElement, orderRef]);
  function renderDismissButton(location) {
    if (disabled || !visuallyHiddenDismiss || !modal) {
      return null;
    }
    return /*#__PURE__*/(0,jsx_runtime.jsx)(VisuallyHiddenDismiss, {
      ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
      onClick: event => onOpenChange(false, event.nativeEvent),
      children: typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss'
    });
  }
  const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [shouldRenderGuards && /*#__PURE__*/(0,jsx_runtime.jsx)(FocusGuard, {
      "data-type": "inside",
      ref: mergedBeforeGuardRef,
      onFocus: event => {
        if (modal) {
          const els = getTabbableElements();
          enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
        } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
          preventReturnFocusRef.current = false;
          if (isOutsideEvent(event, portalContext.portalNode)) {
            const nextTabbable = getNextTabbable(domReference);
            nextTabbable == null || nextTabbable.focus();
          } else {
            var _portalContext$before;
            (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
          }
        }
      }
    }), !isUntrappedTypeableCombobox && renderDismissButton('start'), children, renderDismissButton('end'), shouldRenderGuards && /*#__PURE__*/(0,jsx_runtime.jsx)(FocusGuard, {
      "data-type": "inside",
      ref: mergedAfterGuardRef,
      onFocus: event => {
        if (modal) {
          enqueueFocus(getTabbableElements()[0]);
        } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
          if (closeOnFocusOut) {
            preventReturnFocusRef.current = true;
          }
          if (isOutsideEvent(event, portalContext.portalNode)) {
            const prevTabbable = getPreviousTabbable(domReference);
            prevTabbable == null || prevTabbable.focus();
          } else {
            var _portalContext$afterO;
            (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
          }
        }
      }
    })]
  });
}
let lockCount = 0;
const scrollbarProperty = '--floating-ui-scrollbar-width';
function enableScrollLock() {
  const platform = getPlatform();
  const isIOS = /iP(hone|ad|od)|iOS/.test(platform) ||
  // iPads can claim to be MacIntel
  platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  const bodyStyle = document.body.style;
  // RTL <body> scrollbar
  const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
  const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
  const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
  bodyStyle.overflow = 'hidden';
  bodyStyle.setProperty(scrollbarProperty, scrollbarWidth + "px");
  if (scrollbarWidth) {
    bodyStyle[paddingProp] = scrollbarWidth + "px";
  }

  // Only iOS doesn't respect `overflow: hidden` on document.body, and this
  // technique has fewer side effects.
  if (isIOS) {
    var _window$visualViewpor, _window$visualViewpor2;
    // iOS 12 does not support `visualViewport`.
    const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
    const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
    Object.assign(bodyStyle, {
      position: 'fixed',
      top: -(scrollY - Math.floor(offsetTop)) + "px",
      left: -(scrollX - Math.floor(offsetLeft)) + "px",
      right: '0'
    });
  }
  return () => {
    Object.assign(bodyStyle, {
      overflow: '',
      [paddingProp]: ''
    });
    bodyStyle.removeProperty(scrollbarProperty);
    if (isIOS) {
      Object.assign(bodyStyle, {
        position: '',
        top: '',
        left: '',
        right: ''
      });
      window.scrollTo(scrollX, scrollY);
    }
  };
}
let cleanup = () => {};

/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */
const FloatingOverlay = /*#__PURE__*/react.forwardRef(function FloatingOverlay(props, ref) {
  const {
    lockScroll = false,
    ...rest
  } = props;
  floating_ui_react_utils_index(() => {
    if (!lockScroll) return;
    lockCount++;
    if (lockCount === 1) {
      cleanup = enableScrollLock();
    }
    return () => {
      lockCount--;
      if (lockCount === 0) {
        cleanup();
      }
    };
  }, [lockScroll]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    ref: ref,
    ...rest,
    style: {
      position: 'fixed',
      overflow: 'auto',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...rest.style
    }
  });
});
function isButtonTarget(event) {
  return (0,floating_ui_utils_dom/* isHTMLElement */.Re)(event.target) && event.target.tagName === 'BUTTON';
}
function isAnchorTarget(event) {
  return (0,floating_ui_utils_dom/* isHTMLElement */.Re)(event.target) && event.target.tagName === 'A';
}
function isSpaceIgnored(element) {
  return isTypeableElement(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */
function useClick(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    elements: {
      domReference
    }
  } = context;
  const {
    enabled = true,
    event: eventOption = 'click',
    toggle = true,
    ignoreMouse = false,
    keyboardHandlers = true,
    stickIfOpen = true
  } = props;
  const pointerTypeRef = react.useRef();
  const didKeyDownRef = react.useRef(false);
  const reference = react.useMemo(() => ({
    onPointerDown(event) {
      pointerTypeRef.current = event.pointerType;
    },
    onMouseDown(event) {
      const pointerType = pointerTypeRef.current;

      // Ignore all buttons except for the "main" button.
      // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
      if (event.button !== 0) return;
      if (eventOption === 'click') return;
      if (isMouseLikePointerType(pointerType, true) && ignoreMouse) return;
      if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'mousedown' : true)) {
        onOpenChange(false, event.nativeEvent, 'click');
      } else {
        // Prevent stealing focus from the floating element
        event.preventDefault();
        onOpenChange(true, event.nativeEvent, 'click');
      }
    },
    onClick(event) {
      const pointerType = pointerTypeRef.current;
      if (eventOption === 'mousedown' && pointerTypeRef.current) {
        pointerTypeRef.current = undefined;
        return;
      }
      if (isMouseLikePointerType(pointerType, true) && ignoreMouse) return;
      if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'click' : true)) {
        onOpenChange(false, event.nativeEvent, 'click');
      } else {
        onOpenChange(true, event.nativeEvent, 'click');
      }
    },
    onKeyDown(event) {
      pointerTypeRef.current = undefined;
      if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event)) {
        return;
      }
      if (event.key === ' ' && !isSpaceIgnored(domReference)) {
        // Prevent scrolling
        event.preventDefault();
        didKeyDownRef.current = true;
      }
      if (isAnchorTarget(event)) {
        return;
      }
      if (event.key === 'Enter') {
        if (open && toggle) {
          onOpenChange(false, event.nativeEvent, 'click');
        } else {
          onOpenChange(true, event.nativeEvent, 'click');
        }
      }
    },
    onKeyUp(event) {
      if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event) || isSpaceIgnored(domReference)) {
        return;
      }
      if (event.key === ' ' && didKeyDownRef.current) {
        didKeyDownRef.current = false;
        if (open && toggle) {
          onOpenChange(false, event.nativeEvent, 'click');
        } else {
          onOpenChange(true, event.nativeEvent, 'click');
        }
      }
    }
  }), [dataRef, domReference, eventOption, ignoreMouse, keyboardHandlers, onOpenChange, open, stickIfOpen, toggle]);
  return react.useMemo(() => enabled ? {
    reference
  } : {}, [enabled, reference]);
}
function createVirtualElement(domElement, data) {
  let offsetX = null;
  let offsetY = null;
  let isAutoUpdateEvent = false;
  return {
    contextElement: domElement || undefined,
    getBoundingClientRect() {
      var _data$dataRef$current;
      const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      };
      const isXAxis = data.axis === 'x' || data.axis === 'both';
      const isYAxis = data.axis === 'y' || data.axis === 'both';
      const canTrackCursorOnAutoUpdate = ['mouseenter', 'mousemove'].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
      let width = domRect.width;
      let height = domRect.height;
      let x = domRect.x;
      let y = domRect.y;
      if (offsetX == null && data.x && isXAxis) {
        offsetX = domRect.x - data.x;
      }
      if (offsetY == null && data.y && isYAxis) {
        offsetY = domRect.y - data.y;
      }
      x -= offsetX || 0;
      y -= offsetY || 0;
      width = 0;
      height = 0;
      if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
        width = data.axis === 'y' ? domRect.width : 0;
        height = data.axis === 'x' ? domRect.height : 0;
        x = isXAxis && data.x != null ? data.x : x;
        y = isYAxis && data.y != null ? data.y : y;
      } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
        height = data.axis === 'x' ? domRect.height : height;
        width = data.axis === 'y' ? domRect.width : width;
      }
      isAutoUpdateEvent = true;
      return {
        width,
        height,
        x,
        y,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x
      };
    }
  };
}
function isMouseBasedEvent(event) {
  return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */
function useClientPoint(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    dataRef,
    elements: {
      floating,
      domReference
    },
    refs
  } = context;
  const {
    enabled = true,
    axis = 'both',
    x = null,
    y = null
  } = props;
  const initialRef = react.useRef(false);
  const cleanupListenerRef = react.useRef(null);
  const [pointerType, setPointerType] = react.useState();
  const [reactive, setReactive] = react.useState([]);
  const setReference = useEffectEvent((x, y) => {
    if (initialRef.current) return;

    // Prevent setting if the open event was not a mouse-like one
    // (e.g. focus to open, then hover over the reference element).
    // Only apply if the event exists.
    if (dataRef.current.openEvent && !isMouseBasedEvent(dataRef.current.openEvent)) {
      return;
    }
    refs.setPositionReference(createVirtualElement(domReference, {
      x,
      y,
      axis,
      dataRef,
      pointerType
    }));
  });
  const handleReferenceEnterOrMove = useEffectEvent(event => {
    if (x != null || y != null) return;
    if (!open) {
      setReference(event.clientX, event.clientY);
    } else if (!cleanupListenerRef.current) {
      // If there's no cleanup, there's no listener, but we want to ensure
      // we add the listener if the cursor landed on the floating element and
      // then back on the reference (i.e. it's interactive).
      setReactive([]);
    }
  });

  // If the pointer is a mouse-like pointer, we want to continue following the
  // mouse even if the floating element is transitioning out. On touch
  // devices, this is undesirable because the floating element will move to
  // the dismissal touch point.
  const openCheck = isMouseLikePointerType(pointerType) ? floating : open;
  const addListener = react.useCallback(() => {
    // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
    if (!openCheck || !enabled || x != null || y != null) return;
    const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(floating);
    function handleMouseMove(event) {
      const target = getTarget(event);
      if (!contains(floating, target)) {
        setReference(event.clientX, event.clientY);
      } else {
        win.removeEventListener('mousemove', handleMouseMove);
        cleanupListenerRef.current = null;
      }
    }
    if (!dataRef.current.openEvent || isMouseBasedEvent(dataRef.current.openEvent)) {
      win.addEventListener('mousemove', handleMouseMove);
      const cleanup = () => {
        win.removeEventListener('mousemove', handleMouseMove);
        cleanupListenerRef.current = null;
      };
      cleanupListenerRef.current = cleanup;
      return cleanup;
    }
    refs.setPositionReference(domReference);
  }, [openCheck, enabled, x, y, floating, dataRef, refs, domReference, setReference]);
  react.useEffect(() => {
    return addListener();
  }, [addListener, reactive]);
  react.useEffect(() => {
    if (enabled && !floating) {
      initialRef.current = false;
    }
  }, [enabled, floating]);
  react.useEffect(() => {
    if (!enabled && open) {
      initialRef.current = true;
    }
  }, [enabled, open]);
  floating_ui_react_utils_index(() => {
    if (enabled && (x != null || y != null)) {
      initialRef.current = false;
      setReference(x, y);
    }
  }, [enabled, x, y, setReference]);
  const reference = react.useMemo(() => {
    function setPointerTypeRef(_ref) {
      let {
        pointerType
      } = _ref;
      setPointerType(pointerType);
    }
    return {
      onPointerDown: setPointerTypeRef,
      onPointerEnter: setPointerTypeRef,
      onMouseMove: handleReferenceEnterOrMove,
      onMouseEnter: handleReferenceEnterOrMove
    };
  }, [handleReferenceEnterOrMove]);
  return react.useMemo(() => enabled ? {
    reference
  } : {}, [enabled, reference]);
}
const bubbleHandlerKeys = {
  pointerdown: 'onPointerDown',
  mousedown: 'onMouseDown',
  click: 'onClick'
};
const captureHandlerKeys = {
  pointerdown: 'onPointerDownCapture',
  mousedown: 'onMouseDownCapture',
  click: 'onClickCapture'
};
const normalizeProp = normalizable => {
  var _normalizable$escapeK, _normalizable$outside;
  return {
    escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
    outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
  };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */
function useDismiss(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    elements,
    dataRef
  } = context;
  const {
    enabled = true,
    escapeKey = true,
    outsidePress: unstable_outsidePress = true,
    outsidePressEvent = 'pointerdown',
    referencePress = false,
    referencePressEvent = 'pointerdown',
    ancestorScroll = false,
    bubbles,
    capture
  } = props;
  const tree = useFloatingTree();
  const outsidePressFn = useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : () => false);
  const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
  const endedOrStartedInsideRef = react.useRef(false);
  const {
    escapeKey: escapeKeyBubbles,
    outsidePress: outsidePressBubbles
  } = normalizeProp(bubbles);
  const {
    escapeKey: escapeKeyCapture,
    outsidePress: outsidePressCapture
  } = normalizeProp(capture);
  const isComposingRef = react.useRef(false);
  const closeOnEscapeKeyDown = useEffectEvent(event => {
    var _dataRef$current$floa;
    if (!open || !enabled || !escapeKey || event.key !== 'Escape') {
      return;
    }

    // Wait until IME is settled. Pressing `Escape` while composing should
    // close the compose menu, but not the floating element.
    if (isComposingRef.current) {
      return;
    }
    const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
    const children = tree ? getNodeChildren(tree.nodesRef.current, nodeId) : [];
    if (!escapeKeyBubbles) {
      event.stopPropagation();
      if (children.length > 0) {
        let shouldDismiss = true;
        children.forEach(child => {
          var _child$context;
          if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
            shouldDismiss = false;
            return;
          }
        });
        if (!shouldDismiss) {
          return;
        }
      }
    }
    onOpenChange(false, isReactEvent(event) ? event.nativeEvent : event, 'escape-key');
  });
  const closeOnEscapeKeyDownCapture = useEffectEvent(event => {
    var _getTarget2;
    const callback = () => {
      var _getTarget;
      closeOnEscapeKeyDown(event);
      (_getTarget = getTarget(event)) == null || _getTarget.removeEventListener('keydown', callback);
    };
    (_getTarget2 = getTarget(event)) == null || _getTarget2.addEventListener('keydown', callback);
  });
  const closeOnPressOutside = useEffectEvent(event => {
    var _dataRef$current$floa2;
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    const insideReactTree = dataRef.current.insideReactTree;
    dataRef.current.insideReactTree = false;

    // When click outside is lazy (`click` event), handle dragging.
    // Don't close if:
    // - The click started inside the floating element.
    // - The click ended inside the floating element.
    const endedOrStartedInside = endedOrStartedInsideRef.current;
    endedOrStartedInsideRef.current = false;
    if (outsidePressEvent === 'click' && endedOrStartedInside) {
      return;
    }
    if (insideReactTree) {
      return;
    }
    if (typeof outsidePress === 'function' && !outsidePress(event)) {
      return;
    }
    const target = getTarget(event);
    const inertSelector = "[" + createAttribute('inert') + "]";
    const markers = getDocument(elements.floating).querySelectorAll(inertSelector);
    let targetRootAncestor = (0,floating_ui_utils_dom/* isElement */.kK)(target) ? target : null;
    while (targetRootAncestor && !(0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(targetRootAncestor)) {
      const nextParent = (0,floating_ui_utils_dom/* getParentNode */.Ow)(targetRootAncestor);
      if ((0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(nextParent) || !(0,floating_ui_utils_dom/* isElement */.kK)(nextParent)) {
        break;
      }
      targetRootAncestor = nextParent;
    }

    // Check if the click occurred on a third-party element injected after the
    // floating element rendered.
    if (markers.length && (0,floating_ui_utils_dom/* isElement */.kK)(target) && !isRootElement(target) &&
    // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !contains(target, elements.floating) &&
    // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(markers).every(marker => !contains(targetRootAncestor, marker))) {
      return;
    }

    // Check if the click occurred on the scrollbar
    if ((0,floating_ui_utils_dom/* isHTMLElement */.Re)(target) && floating) {
      const lastTraversableNode = (0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(target);
      const style = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(target);
      const scrollRe = /auto|scroll/;
      const isScrollableX = lastTraversableNode || scrollRe.test(style.overflowX);
      const isScrollableY = lastTraversableNode || scrollRe.test(style.overflowY);
      const canScrollX = isScrollableX && target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
      const canScrollY = isScrollableY && target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
      const isRTL = style.direction === 'rtl';

      // Check click position relative to scrollbar.
      // In some browsers it is possible to change the <body> (or window)
      // scrollbar to the left side, but is very rare and is difficult to
      // check for. Plus, for modal dialogs with backdrops, it is more
      // important that the backdrop is checked but not so much the window.
      const pressedVerticalScrollbar = canScrollY && (isRTL ? event.offsetX <= target.offsetWidth - target.clientWidth : event.offsetX > target.clientWidth);
      const pressedHorizontalScrollbar = canScrollX && event.offsetY > target.clientHeight;
      if (pressedVerticalScrollbar || pressedHorizontalScrollbar) {
        return;
      }
    }
    const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
    const targetIsInsideChildren = tree && getNodeChildren(tree.nodesRef.current, nodeId).some(node => {
      var _node$context;
      return isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
    });
    if (isEventTargetWithin(event, elements.floating) || isEventTargetWithin(event, elements.domReference) || targetIsInsideChildren) {
      return;
    }
    const children = tree ? getNodeChildren(tree.nodesRef.current, nodeId) : [];
    if (children.length > 0) {
      let shouldDismiss = true;
      children.forEach(child => {
        var _child$context2;
        if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
          shouldDismiss = false;
          return;
        }
      });
      if (!shouldDismiss) {
        return;
      }
    }
    onOpenChange(false, event, 'outside-press');
  });
  const closeOnPressOutsideCapture = useEffectEvent(event => {
    var _getTarget4;
    const callback = () => {
      var _getTarget3;
      closeOnPressOutside(event);
      (_getTarget3 = getTarget(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
    };
    (_getTarget4 = getTarget(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
  });
  react.useEffect(() => {
    if (!open || !enabled) {
      return;
    }
    dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
    dataRef.current.__outsidePressBubbles = outsidePressBubbles;
    let compositionTimeout = -1;
    function onScroll(event) {
      onOpenChange(false, event, 'ancestor-scroll');
    }
    function handleCompositionStart() {
      window.clearTimeout(compositionTimeout);
      isComposingRef.current = true;
    }
    function handleCompositionEnd() {
      // Safari fires `compositionend` before `keydown`, so we need to wait
      // until the next tick to set `isComposing` to `false`.
      // https://bugs.webkit.org/show_bug.cgi?id=165004
      compositionTimeout = window.setTimeout(() => {
        isComposingRef.current = false;
      },
      // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
      // Only apply to WebKit for the test to remain 0ms.
      (0,floating_ui_utils_dom/* isWebKit */.Pf)() ? 5 : 0);
    }
    const doc = getDocument(elements.floating);
    if (escapeKey) {
      doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
      doc.addEventListener('compositionstart', handleCompositionStart);
      doc.addEventListener('compositionend', handleCompositionEnd);
    }
    outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
    let ancestors = [];
    if (ancestorScroll) {
      if ((0,floating_ui_utils_dom/* isElement */.kK)(elements.domReference)) {
        ancestors = (0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(elements.domReference);
      }
      if ((0,floating_ui_utils_dom/* isElement */.kK)(elements.floating)) {
        ancestors = ancestors.concat((0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(elements.floating));
      }
      if (!(0,floating_ui_utils_dom/* isElement */.kK)(elements.reference) && elements.reference && elements.reference.contextElement) {
        ancestors = ancestors.concat((0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(elements.reference.contextElement));
      }
    }

    // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
    ancestors = ancestors.filter(ancestor => {
      var _doc$defaultView;
      return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
    });
    ancestors.forEach(ancestor => {
      ancestor.addEventListener('scroll', onScroll, {
        passive: true
      });
    });
    return () => {
      if (escapeKey) {
        doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
        doc.removeEventListener('compositionstart', handleCompositionStart);
        doc.removeEventListener('compositionend', handleCompositionEnd);
      }
      outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
      ancestors.forEach(ancestor => {
        ancestor.removeEventListener('scroll', onScroll);
      });
      window.clearTimeout(compositionTimeout);
    };
  }, [dataRef, elements, escapeKey, outsidePress, outsidePressEvent, open, onOpenChange, ancestorScroll, enabled, escapeKeyBubbles, outsidePressBubbles, closeOnEscapeKeyDown, escapeKeyCapture, closeOnEscapeKeyDownCapture, closeOnPressOutside, outsidePressCapture, closeOnPressOutsideCapture]);
  react.useEffect(() => {
    dataRef.current.insideReactTree = false;
  }, [dataRef, outsidePress, outsidePressEvent]);
  const reference = react.useMemo(() => ({
    onKeyDown: closeOnEscapeKeyDown,
    ...(referencePress && {
      [bubbleHandlerKeys[referencePressEvent]]: event => {
        onOpenChange(false, event.nativeEvent, 'reference-press');
      },
      ...(referencePressEvent !== 'click' && {
        onClick(event) {
          onOpenChange(false, event.nativeEvent, 'reference-press');
        }
      })
    })
  }), [closeOnEscapeKeyDown, onOpenChange, referencePress, referencePressEvent]);
  const floating = react.useMemo(() => ({
    onKeyDown: closeOnEscapeKeyDown,
    onMouseDown() {
      endedOrStartedInsideRef.current = true;
    },
    onMouseUp() {
      endedOrStartedInsideRef.current = true;
    },
    [captureHandlerKeys[outsidePressEvent]]: () => {
      dataRef.current.insideReactTree = true;
    }
  }), [closeOnEscapeKeyDown, outsidePressEvent, dataRef]);
  return react.useMemo(() => enabled ? {
    reference,
    floating
  } : {}, [enabled, reference, floating]);
}
function useFloatingRootContext(options) {
  const {
    open = false,
    onOpenChange: onOpenChangeProp,
    elements: elementsProp
  } = options;
  const floatingId = useId();
  const dataRef = react.useRef({});
  const [events] = react.useState(() => createEventEmitter());
  const nested = useFloatingParentNodeId() != null;
  if (false) {}
  const [positionReference, setPositionReference] = react.useState(elementsProp.reference);
  const onOpenChange = useEffectEvent((open, event, reason) => {
    dataRef.current.openEvent = open ? event : undefined;
    events.emit('openchange', {
      open,
      event,
      reason,
      nested
    });
    onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
  });
  const refs = react.useMemo(() => ({
    setPositionReference
  }), []);
  const elements = react.useMemo(() => ({
    reference: positionReference || elementsProp.reference || null,
    floating: elementsProp.floating || null,
    domReference: elementsProp.reference
  }), [positionReference, elementsProp.reference, elementsProp.floating]);
  return react.useMemo(() => ({
    dataRef,
    open,
    onOpenChange,
    elements,
    events,
    floatingId,
    refs
  }), [open, onOpenChange, elements, events, floatingId, refs]);
}

/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */
function floating_ui_react_esm_useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    nodeId
  } = options;
  const internalRootContext = useFloatingRootContext({
    ...options,
    elements: {
      reference: null,
      floating: null,
      ...options.elements
    }
  });
  const rootContext = options.rootContext || internalRootContext;
  const computedElements = rootContext.elements;
  const [_domReference, setDomReference] = react.useState(null);
  const [positionReference, _setPositionReference] = react.useState(null);
  const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
  const domReference = optionDomReference || _domReference;
  const domReferenceRef = react.useRef(null);
  const tree = useFloatingTree();
  floating_ui_react_utils_index(() => {
    if (domReference) {
      domReferenceRef.current = domReference;
    }
  }, [domReference]);
  const position = useFloating({
    ...options,
    elements: {
      ...computedElements,
      ...(positionReference && {
        reference: positionReference
      })
    }
  });
  const setPositionReference = react.useCallback(node => {
    const computedPositionReference = (0,floating_ui_utils_dom/* isElement */.kK)(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      getClientRects: () => node.getClientRects(),
      contextElement: node
    } : node;
    // Store the positionReference in state if the DOM reference is specified externally via the
    // `elements.reference` option. This ensures that it won't be overridden on future renders.
    _setPositionReference(computedPositionReference);
    position.refs.setReference(computedPositionReference);
  }, [position.refs]);
  const setReference = react.useCallback(node => {
    if ((0,floating_ui_utils_dom/* isElement */.kK)(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }

    // Backwards-compatibility for passing a virtual element to `reference`
    // after it has set the DOM reference.
    if ((0,floating_ui_utils_dom/* isElement */.kK)(position.refs.reference.current) || position.refs.reference.current === null ||
    // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !(0,floating_ui_utils_dom/* isElement */.kK)(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  const refs = react.useMemo(() => ({
    ...position.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position.refs, setReference, setPositionReference]);
  const elements = react.useMemo(() => ({
    ...position.elements,
    domReference: domReference
  }), [position.elements, domReference]);
  const context = react.useMemo(() => ({
    ...position,
    ...rootContext,
    refs,
    elements,
    nodeId
  }), [position, refs, elements, nodeId, rootContext]);
  floating_ui_react_utils_index(() => {
    rootContext.dataRef.current.floatingContext = context;
    const node = tree == null ? void 0 : tree.nodesRef.current.find(node => node.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return react.useMemo(() => ({
    ...position,
    context,
    refs,
    elements
  }), [position, refs, elements, context]);
}
function isMacSafari() {
  return isMac() && isSafari();
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */
function useFocus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    events,
    dataRef,
    elements
  } = context;
  const {
    enabled = true,
    visibleOnly = true
  } = props;
  const blockFocusRef = react.useRef(false);
  const timeoutRef = react.useRef(-1);
  const keyboardModalityRef = react.useRef(true);
  react.useEffect(() => {
    if (!enabled) return;
    const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(elements.domReference);

    // If the reference was focused and the user left the tab/window, and the
    // floating element was not open, the focus should be blocked when they
    // return to the tab/window.
    function onBlur() {
      if (!open && (0,floating_ui_utils_dom/* isHTMLElement */.Re)(elements.domReference) && elements.domReference === activeElement(getDocument(elements.domReference))) {
        blockFocusRef.current = true;
      }
    }
    function onKeyDown() {
      keyboardModalityRef.current = true;
    }
    function onPointerDown() {
      keyboardModalityRef.current = false;
    }
    win.addEventListener('blur', onBlur);
    if (isMacSafari()) {
      win.addEventListener('keydown', onKeyDown, true);
      win.addEventListener('pointerdown', onPointerDown, true);
    }
    return () => {
      win.removeEventListener('blur', onBlur);
      if (isMacSafari()) {
        win.removeEventListener('keydown', onKeyDown, true);
        win.removeEventListener('pointerdown', onPointerDown, true);
      }
    };
  }, [elements.domReference, open, enabled]);
  react.useEffect(() => {
    if (!enabled) return;
    function onOpenChange(_ref) {
      let {
        reason
      } = _ref;
      if (reason === 'reference-press' || reason === 'escape-key') {
        blockFocusRef.current = true;
      }
    }
    events.on('openchange', onOpenChange);
    return () => {
      events.off('openchange', onOpenChange);
    };
  }, [events, enabled]);
  react.useEffect(() => {
    return () => {
      clearTimeoutIfSet(timeoutRef);
    };
  }, []);
  const reference = react.useMemo(() => ({
    onMouseLeave() {
      blockFocusRef.current = false;
    },
    onFocus(event) {
      if (blockFocusRef.current) return;
      const target = getTarget(event.nativeEvent);
      if (visibleOnly && (0,floating_ui_utils_dom/* isElement */.kK)(target)) {
        // Safari fails to match `:focus-visible` if focus was initially
        // outside the document.
        if (isMacSafari() && !event.relatedTarget) {
          if (!keyboardModalityRef.current && !isTypeableElement(target)) {
            return;
          }
        } else if (!matchesFocusVisible(target)) {
          return;
        }
      }
      onOpenChange(true, event.nativeEvent, 'focus');
    },
    onBlur(event) {
      blockFocusRef.current = false;
      const relatedTarget = event.relatedTarget;
      const nativeEvent = event.nativeEvent;

      // Hit the non-modal focus management portal guard. Focus will be
      // moved into the floating element immediately after.
      const movedToFocusGuard = (0,floating_ui_utils_dom/* isElement */.kK)(relatedTarget) && relatedTarget.hasAttribute(createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';

      // Wait for the window blur listener to fire.
      timeoutRef.current = window.setTimeout(() => {
        var _dataRef$current$floa;
        const activeEl = activeElement(elements.domReference ? elements.domReference.ownerDocument : document);

        // Focus left the page, keep it open.
        if (!relatedTarget && activeEl === elements.domReference) return;

        // When focusing the reference element (e.g. regular click), then
        // clicking into the floating element, prevent it from hiding.
        // Note: it must be focusable, e.g. `tabindex="-1"`.
        // We can not rely on relatedTarget to point to the correct element
        // as it will only point to the shadow host of the newly focused element
        // and not the element that actually has received focus if it is located
        // inside a shadow root.
        if (contains((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || contains(elements.domReference, activeEl) || movedToFocusGuard) {
          return;
        }
        onOpenChange(false, nativeEvent, 'focus');
      });
    }
  }), [dataRef, elements.domReference, onOpenChange, visibleOnly]);
  return react.useMemo(() => enabled ? {
    reference
  } : {}, [enabled, reference]);
}
function mergeProps(userProps, propsList, elementKey) {
  const map = new Map();
  const isItem = elementKey === 'item';
  let domUserProps = userProps;
  if (isItem && userProps) {
    const {
      [ACTIVE_KEY]: _,
      [SELECTED_KEY]: __,
      ...validProps
    } = userProps;
    domUserProps = validProps;
  }
  return {
    ...(elementKey === 'floating' && {
      tabIndex: -1,
      [floating_ui_react_esm_FOCUSABLE_ATTRIBUTE]: ''
    }),
    ...domUserProps,
    ...propsList.map(value => {
      const propsOrGetProps = value ? value[elementKey] : null;
      if (typeof propsOrGetProps === 'function') {
        return userProps ? propsOrGetProps(userProps) : null;
      }
      return propsOrGetProps;
    }).concat(userProps).reduce((acc, props) => {
      if (!props) {
        return acc;
      }
      Object.entries(props).forEach(_ref => {
        let [key, value] = _ref;
        if (isItem && [ACTIVE_KEY, SELECTED_KEY].includes(key)) {
          return;
        }
        if (key.indexOf('on') === 0) {
          if (!map.has(key)) {
            map.set(key, []);
          }
          if (typeof value === 'function') {
            var _map$get;
            (_map$get = map.get(key)) == null || _map$get.push(value);
            acc[key] = function () {
              var _map$get2;
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map(fn => fn(...args)).find(val => val !== undefined);
            };
          }
        } else {
          acc[key] = value;
        }
      });
      return acc;
    }, {})
  };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */
function useInteractions(propsList) {
  if (propsList === void 0) {
    propsList = [];
  }
  const referenceDeps = propsList.map(key => key == null ? void 0 : key.reference);
  const floatingDeps = propsList.map(key => key == null ? void 0 : key.floating);
  const itemDeps = propsList.map(key => key == null ? void 0 : key.item);
  const getReferenceProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'reference'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  referenceDeps);
  const getFloatingProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'floating'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  floatingDeps);
  const getItemProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'item'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  itemDeps);
  return react.useMemo(() => ({
    getReferenceProps,
    getFloatingProps,
    getItemProps
  }), [getReferenceProps, getFloatingProps, getItemProps]);
}
const ESCAPE = 'Escape';
function doSwitch(orientation, vertical, horizontal) {
  switch (orientation) {
    case 'vertical':
      return vertical;
    case 'horizontal':
      return horizontal;
    default:
      return vertical || horizontal;
  }
}
function isMainOrientationKey(key, orientation) {
  const vertical = key === floating_ui_react_esm_ARROW_UP || key === floating_ui_react_esm_ARROW_DOWN;
  const horizontal = key === floating_ui_react_esm_ARROW_LEFT || key === floating_ui_react_esm_ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal);
}
function isMainOrientationToEndKey(key, orientation, rtl) {
  const vertical = key === floating_ui_react_esm_ARROW_DOWN;
  const horizontal = rtl ? key === floating_ui_react_esm_ARROW_LEFT : key === floating_ui_react_esm_ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function isCrossOrientationOpenKey(key, orientation, rtl) {
  const vertical = rtl ? key === floating_ui_react_esm_ARROW_LEFT : key === floating_ui_react_esm_ARROW_RIGHT;
  const horizontal = key === floating_ui_react_esm_ARROW_DOWN;
  return doSwitch(orientation, vertical, horizontal);
}
function isCrossOrientationCloseKey(key, orientation, rtl, cols) {
  const vertical = rtl ? key === floating_ui_react_esm_ARROW_RIGHT : key === floating_ui_react_esm_ARROW_LEFT;
  const horizontal = key === floating_ui_react_esm_ARROW_UP;
  if (orientation === 'both' || orientation === 'horizontal' && cols && cols > 1) {
    return key === ESCAPE;
  }
  return doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */
function useListNavigation(context, props) {
  const {
    open,
    onOpenChange,
    elements,
    floatingId
  } = context;
  const {
    listRef,
    activeIndex,
    onNavigate: unstable_onNavigate = () => {},
    enabled = true,
    selectedIndex = null,
    allowEscape = false,
    loop = false,
    nested = false,
    rtl = false,
    virtual = false,
    focusItemOnOpen = 'auto',
    focusItemOnHover = true,
    openOnArrowKeyDown = true,
    disabledIndices = undefined,
    orientation = 'vertical',
    parentOrientation,
    cols = 1,
    scrollItemIntoView = true,
    virtualItemRef,
    itemSizes,
    dense = false
  } = props;
  if (false) {}
  const floatingFocusElement = getFloatingFocusElement(elements.floating);
  const floatingFocusElementRef = useLatestRef(floatingFocusElement);
  const parentId = useFloatingParentNodeId();
  const tree = useFloatingTree();
  floating_ui_react_utils_index(() => {
    context.dataRef.current.orientation = orientation;
  }, [context, orientation]);
  const onNavigate = useEffectEvent(() => {
    unstable_onNavigate(indexRef.current === -1 ? null : indexRef.current);
  });
  const typeableComboboxReference = isTypeableCombobox(elements.domReference);
  const focusItemOnOpenRef = react.useRef(focusItemOnOpen);
  const indexRef = react.useRef(selectedIndex != null ? selectedIndex : -1);
  const keyRef = react.useRef(null);
  const isPointerModalityRef = react.useRef(true);
  const previousOnNavigateRef = react.useRef(onNavigate);
  const previousMountedRef = react.useRef(!!elements.floating);
  const previousOpenRef = react.useRef(open);
  const forceSyncFocusRef = react.useRef(false);
  const forceScrollIntoViewRef = react.useRef(false);
  const disabledIndicesRef = useLatestRef(disabledIndices);
  const latestOpenRef = useLatestRef(open);
  const scrollItemIntoViewRef = useLatestRef(scrollItemIntoView);
  const selectedIndexRef = useLatestRef(selectedIndex);
  const [activeId, setActiveId] = react.useState();
  const [virtualId, setVirtualId] = react.useState();
  const focusItem = useEffectEvent(() => {
    function runFocus(item) {
      if (virtual) {
        var _item$id;
        if ((_item$id = item.id) != null && _item$id.endsWith('-fui-option')) {
          item.id = floatingId + "-" + Math.random().toString(16).slice(2, 10);
        }
        setActiveId(item.id);
        tree == null || tree.events.emit('virtualfocus', item);
        if (virtualItemRef) {
          virtualItemRef.current = item;
        }
      } else {
        enqueueFocus(item, {
          sync: forceSyncFocusRef.current,
          preventScroll: true
        });
      }
    }
    const initialItem = listRef.current[indexRef.current];
    const forceScrollIntoView = forceScrollIntoViewRef.current;
    if (initialItem) {
      runFocus(initialItem);
    }
    const scheduler = forceSyncFocusRef.current ? v => v() : requestAnimationFrame;
    scheduler(() => {
      const waitedItem = listRef.current[indexRef.current] || initialItem;
      if (!waitedItem) return;
      if (!initialItem) {
        runFocus(waitedItem);
      }
      const scrollIntoViewOptions = scrollItemIntoViewRef.current;
      const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
      if (shouldScrollIntoView) {
        // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
        // by all browsers.
        waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
          block: 'nearest',
          inline: 'nearest'
        } : scrollIntoViewOptions);
      }
    });
  });

  // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
  // element. Also, reset `activeIndex` upon closing the floating element.
  floating_ui_react_utils_index(() => {
    if (!enabled) return;
    if (open && elements.floating) {
      if (focusItemOnOpenRef.current && selectedIndex != null) {
        // Regardless of the pointer modality, we want to ensure the selected
        // item comes into view when the floating element is opened.
        forceScrollIntoViewRef.current = true;
        indexRef.current = selectedIndex;
        onNavigate();
      }
    } else if (previousMountedRef.current) {
      // Since the user can specify `onNavigate` conditionally
      // (onNavigate: open ? setActiveIndex : setSelectedIndex),
      // we store and call the previous function.
      indexRef.current = -1;
      previousOnNavigateRef.current();
    }
  }, [enabled, open, elements.floating, selectedIndex, onNavigate]);

  // Sync `activeIndex` to be the focused item while the floating element is
  // open.
  floating_ui_react_utils_index(() => {
    if (!enabled) return;
    if (!open) return;
    if (!elements.floating) return;
    if (activeIndex == null) {
      forceSyncFocusRef.current = false;
      if (selectedIndexRef.current != null) {
        return;
      }

      // Reset while the floating element was open (e.g. the list changed).
      if (previousMountedRef.current) {
        indexRef.current = -1;
        focusItem();
      }

      // Initial sync.
      if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
        let runs = 0;
        const waitForListPopulated = () => {
          if (listRef.current[0] == null) {
            // Avoid letting the browser paint if possible on the first try,
            // otherwise use rAF. Don't try more than twice, since something
            // is wrong otherwise.
            if (runs < 2) {
              const scheduler = runs ? requestAnimationFrame : queueMicrotask;
              scheduler(waitForListPopulated);
            }
            runs++;
          } else {
            indexRef.current = keyRef.current == null || isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? getMinListIndex(listRef, disabledIndicesRef.current) : getMaxListIndex(listRef, disabledIndicesRef.current);
            keyRef.current = null;
            onNavigate();
          }
        };
        waitForListPopulated();
      }
    } else if (!isIndexOutOfListBounds(listRef, activeIndex)) {
      indexRef.current = activeIndex;
      focusItem();
      forceScrollIntoViewRef.current = false;
    }
  }, [enabled, open, elements.floating, activeIndex, selectedIndexRef, nested, listRef, orientation, rtl, onNavigate, focusItem, disabledIndicesRef]);

  // Ensure the parent floating element has focus when a nested child closes
  // to allow arrow key navigation to work after the pointer leaves the child.
  floating_ui_react_utils_index(() => {
    var _nodes$find;
    if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) {
      return;
    }
    const nodes = tree.nodesRef.current;
    const parent = (_nodes$find = nodes.find(node => node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
    const activeEl = activeElement(getDocument(elements.floating));
    const treeContainsActiveEl = nodes.some(node => node.context && contains(node.context.elements.floating, activeEl));
    if (parent && !treeContainsActiveEl && isPointerModalityRef.current) {
      parent.focus({
        preventScroll: true
      });
    }
  }, [enabled, elements.floating, tree, parentId, virtual]);
  floating_ui_react_utils_index(() => {
    if (!enabled) return;
    if (!tree) return;
    if (!virtual) return;
    if (parentId) return;
    function handleVirtualFocus(item) {
      setVirtualId(item.id);
      if (virtualItemRef) {
        virtualItemRef.current = item;
      }
    }
    tree.events.on('virtualfocus', handleVirtualFocus);
    return () => {
      tree.events.off('virtualfocus', handleVirtualFocus);
    };
  }, [enabled, tree, virtual, parentId, virtualItemRef]);
  floating_ui_react_utils_index(() => {
    previousOnNavigateRef.current = onNavigate;
    previousOpenRef.current = open;
    previousMountedRef.current = !!elements.floating;
  });
  floating_ui_react_utils_index(() => {
    if (!open) {
      keyRef.current = null;
      focusItemOnOpenRef.current = focusItemOnOpen;
    }
  }, [open, focusItemOnOpen]);
  const hasActiveIndex = activeIndex != null;
  const item = react.useMemo(() => {
    function syncCurrentTarget(currentTarget) {
      if (!latestOpenRef.current) return;
      const index = listRef.current.indexOf(currentTarget);
      if (index !== -1 && indexRef.current !== index) {
        indexRef.current = index;
        onNavigate();
      }
    }
    const props = {
      onFocus(_ref) {
        let {
          currentTarget
        } = _ref;
        forceSyncFocusRef.current = true;
        syncCurrentTarget(currentTarget);
      },
      onClick: _ref2 => {
        let {
          currentTarget
        } = _ref2;
        return currentTarget.focus({
          preventScroll: true
        });
      },
      // Safari
      onMouseMove(_ref3) {
        let {
          currentTarget
        } = _ref3;
        forceSyncFocusRef.current = true;
        forceScrollIntoViewRef.current = false;
        if (focusItemOnHover) {
          syncCurrentTarget(currentTarget);
        }
      },
      onPointerLeave(_ref4) {
        let {
          pointerType
        } = _ref4;
        if (!isPointerModalityRef.current || pointerType === 'touch') {
          return;
        }
        forceSyncFocusRef.current = true;
        if (!focusItemOnHover) {
          return;
        }
        indexRef.current = -1;
        onNavigate();
        if (!virtual) {
          var _floatingFocusElement;
          (_floatingFocusElement = floatingFocusElementRef.current) == null || _floatingFocusElement.focus({
            preventScroll: true
          });
        }
      }
    };
    return props;
  }, [latestOpenRef, floatingFocusElementRef, focusItemOnHover, listRef, onNavigate, virtual]);
  const getParentOrientation = react.useCallback(() => {
    var _tree$nodesRef$curren;
    return parentOrientation != null ? parentOrientation : tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find(node => node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.dataRef) == null ? void 0 : _tree$nodesRef$curren.current.orientation;
  }, [parentId, tree, parentOrientation]);
  const commonOnKeyDown = useEffectEvent(event => {
    isPointerModalityRef.current = false;
    forceSyncFocusRef.current = true;

    // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
    // don't appear to suffer from this. `event.isComposing` is avoided due to
    // Safari not supporting it properly (although it's not needed in the first
    // place for Safari, just avoiding any possible issues).
    if (event.which === 229) {
      return;
    }

    // If the floating element is animating out, ignore navigation. Otherwise,
    // the `activeIndex` gets set to 0 despite not being open so the next time
    // the user ArrowDowns, the first item won't be focused.
    if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) {
      return;
    }
    if (nested && isCrossOrientationCloseKey(event.key, orientation, rtl, cols)) {
      // If the nested list's close key is also the parent navigation key,
      // let the parent navigate. Otherwise, stop propagating the event.
      if (!isMainOrientationKey(event.key, getParentOrientation())) {
        stopEvent(event);
      }
      onOpenChange(false, event.nativeEvent, 'list-navigation');
      if ((0,floating_ui_utils_dom/* isHTMLElement */.Re)(elements.domReference)) {
        if (virtual) {
          tree == null || tree.events.emit('virtualfocus', elements.domReference);
        } else {
          elements.domReference.focus();
        }
      }
      return;
    }
    const currentIndex = indexRef.current;
    const minIndex = getMinListIndex(listRef, disabledIndices);
    const maxIndex = getMaxListIndex(listRef, disabledIndices);
    if (!typeableComboboxReference) {
      if (event.key === 'Home') {
        stopEvent(event);
        indexRef.current = minIndex;
        onNavigate();
      }
      if (event.key === 'End') {
        stopEvent(event);
        indexRef.current = maxIndex;
        onNavigate();
      }
    }

    // Grid navigation.
    if (cols > 1) {
      const sizes = itemSizes || Array.from({
        length: listRef.current.length
      }, () => ({
        width: 1,
        height: 1
      }));
      // To calculate movements on the grid, we use hypothetical cell indices
      // as if every item was 1x1, then convert back to real indices.
      const cellMap = createGridCellMap(sizes, cols, dense);
      const minGridIndex = cellMap.findIndex(index => index != null && !isListIndexDisabled(listRef, index, disabledIndices));
      // last enabled index
      const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex) => index != null && !isListIndexDisabled(listRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
      const index = cellMap[getGridNavigatedIndex({
        current: cellMap.map(itemIndex => itemIndex != null ? listRef.current[itemIndex] : null)
      }, {
        event,
        orientation,
        loop,
        rtl,
        cols,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: getGridCellIndices([...((typeof disabledIndices !== 'function' ? disabledIndices : null) || listRef.current.map((_, index) => isListIndexDisabled(listRef, index, disabledIndices) ? index : undefined)), undefined], cellMap),
        minIndex: minGridIndex,
        maxIndex: maxGridIndex,
        prevIndex: getGridCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols,
        // use a corner matching the edge closest to the direction
        // we're moving in so we don't end up in the same item. Prefer
        // top/left over bottom/right.
        event.key === floating_ui_react_esm_ARROW_DOWN ? 'bl' : event.key === (rtl ? floating_ui_react_esm_ARROW_LEFT : floating_ui_react_esm_ARROW_RIGHT) ? 'tr' : 'tl'),
        stopEvent: true
      })];
      if (index != null) {
        indexRef.current = index;
        onNavigate();
      }
      if (orientation === 'both') {
        return;
      }
    }
    if (isMainOrientationKey(event.key, orientation)) {
      stopEvent(event);

      // Reset the index if no item is focused.
      if (open && !virtual && activeElement(event.currentTarget.ownerDocument) === event.currentTarget) {
        indexRef.current = isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
        onNavigate();
        return;
      }
      if (isMainOrientationToEndKey(event.key, orientation, rtl)) {
        if (loop) {
          indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : findNonDisabledListIndex(listRef, {
            startingIndex: currentIndex,
            disabledIndices
          });
        } else {
          indexRef.current = Math.min(maxIndex, findNonDisabledListIndex(listRef, {
            startingIndex: currentIndex,
            disabledIndices
          }));
        }
      } else {
        if (loop) {
          indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : findNonDisabledListIndex(listRef, {
            startingIndex: currentIndex,
            decrement: true,
            disabledIndices
          });
        } else {
          indexRef.current = Math.max(minIndex, findNonDisabledListIndex(listRef, {
            startingIndex: currentIndex,
            decrement: true,
            disabledIndices
          }));
        }
      }
      if (isIndexOutOfListBounds(listRef, indexRef.current)) {
        indexRef.current = -1;
      }
      onNavigate();
    }
  });
  const ariaActiveDescendantProp = react.useMemo(() => {
    return virtual && open && hasActiveIndex && {
      'aria-activedescendant': virtualId || activeId
    };
  }, [virtual, open, hasActiveIndex, virtualId, activeId]);
  const floating = react.useMemo(() => {
    return {
      'aria-orientation': orientation === 'both' ? undefined : orientation,
      ...(!typeableComboboxReference ? ariaActiveDescendantProp : {}),
      onKeyDown: commonOnKeyDown,
      onPointerMove() {
        isPointerModalityRef.current = true;
      }
    };
  }, [ariaActiveDescendantProp, commonOnKeyDown, orientation, typeableComboboxReference]);
  const reference = react.useMemo(() => {
    function checkVirtualMouse(event) {
      if (focusItemOnOpen === 'auto' && isVirtualClick(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    function checkVirtualPointer(event) {
      // `pointerdown` fires first, reset the state then perform the checks.
      focusItemOnOpenRef.current = focusItemOnOpen;
      if (focusItemOnOpen === 'auto' && isVirtualPointerEvent(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    return {
      ...ariaActiveDescendantProp,
      onKeyDown(event) {
        isPointerModalityRef.current = false;
        const isArrowKey = event.key.startsWith('Arrow');
        const isHomeOrEndKey = ['Home', 'End'].includes(event.key);
        const isMoveKey = isArrowKey || isHomeOrEndKey;
        const isCrossOpenKey = isCrossOrientationOpenKey(event.key, orientation, rtl);
        const isCrossCloseKey = isCrossOrientationCloseKey(event.key, orientation, rtl, cols);
        const isParentCrossOpenKey = isCrossOrientationOpenKey(event.key, getParentOrientation(), rtl);
        const isMainKey = isMainOrientationKey(event.key, orientation);
        const isNavigationKey = (nested ? isParentCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
        if (virtual && open) {
          const rootNode = tree == null ? void 0 : tree.nodesRef.current.find(node => node.parentId == null);
          const deepestNode = tree && rootNode ? getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
          if (isMoveKey && deepestNode && virtualItemRef) {
            const eventObject = new KeyboardEvent('keydown', {
              key: event.key,
              bubbles: true
            });
            if (isCrossOpenKey || isCrossCloseKey) {
              var _deepestNode$context, _deepestNode$context2;
              const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
              const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find(item => (item == null ? void 0 : item.id) === activeId) : null;
              if (dispatchItem) {
                stopEvent(event);
                dispatchItem.dispatchEvent(eventObject);
                setVirtualId(undefined);
              }
            }
            if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
              if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                var _deepestNode$context$;
                stopEvent(event);
                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                return;
              }
            }
          }
          return commonOnKeyDown(event);
        }
        // If a floating element should not open on arrow key down, avoid
        // setting `activeIndex` while it's closed.
        if (!open && !openOnArrowKeyDown && isArrowKey) {
          return;
        }
        if (isNavigationKey) {
          const isParentMainKey = isMainOrientationKey(event.key, getParentOrientation());
          keyRef.current = nested && isParentMainKey ? null : event.key;
        }
        if (nested) {
          if (isParentCrossOpenKey) {
            stopEvent(event);
            if (open) {
              indexRef.current = getMinListIndex(listRef, disabledIndicesRef.current);
              onNavigate();
            } else {
              onOpenChange(true, event.nativeEvent, 'list-navigation');
            }
          }
          return;
        }
        if (isMainKey) {
          if (selectedIndex != null) {
            indexRef.current = selectedIndex;
          }
          stopEvent(event);
          if (!open && openOnArrowKeyDown) {
            onOpenChange(true, event.nativeEvent, 'list-navigation');
          } else {
            commonOnKeyDown(event);
          }
          if (open) {
            onNavigate();
          }
        }
      },
      onFocus() {
        if (open && !virtual) {
          indexRef.current = -1;
          onNavigate();
        }
      },
      onPointerDown: checkVirtualPointer,
      onPointerEnter: checkVirtualPointer,
      onMouseDown: checkVirtualMouse,
      onClick: checkVirtualMouse
    };
  }, [activeId, ariaActiveDescendantProp, cols, commonOnKeyDown, disabledIndicesRef, focusItemOnOpen, listRef, nested, onNavigate, onOpenChange, open, openOnArrowKeyDown, orientation, getParentOrientation, rtl, selectedIndex, tree, virtual, virtualItemRef]);
  return react.useMemo(() => enabled ? {
    reference,
    floating,
    item
  } : {}, [enabled, reference, floating, item]);
}
const componentRoleToAriaRoleMap = /*#__PURE__*/new Map([['select', 'listbox'], ['combobox', 'listbox'], ['label', false]]);

/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */
function useRole(context, props) {
  var _elements$domReferenc, _componentRoleToAriaR;
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    elements,
    floatingId: defaultFloatingId
  } = context;
  const {
    enabled = true,
    role = 'dialog'
  } = props;
  const defaultReferenceId = useId();
  const referenceId = ((_elements$domReferenc = elements.domReference) == null ? void 0 : _elements$domReferenc.id) || defaultReferenceId;
  const floatingId = react.useMemo(() => {
    var _getFloatingFocusElem;
    return ((_getFloatingFocusElem = getFloatingFocusElement(elements.floating)) == null ? void 0 : _getFloatingFocusElem.id) || defaultFloatingId;
  }, [elements.floating, defaultFloatingId]);
  const ariaRole = (_componentRoleToAriaR = componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
  const parentId = useFloatingParentNodeId();
  const isNested = parentId != null;
  const reference = react.useMemo(() => {
    if (ariaRole === 'tooltip' || role === 'label') {
      return {
        ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
      };
    }
    return {
      'aria-expanded': open ? 'true' : 'false',
      'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
      'aria-controls': open ? floatingId : undefined,
      ...(ariaRole === 'listbox' && {
        role: 'combobox'
      }),
      ...(ariaRole === 'menu' && {
        id: referenceId
      }),
      ...(ariaRole === 'menu' && isNested && {
        role: 'menuitem'
      }),
      ...(role === 'select' && {
        'aria-autocomplete': 'none'
      }),
      ...(role === 'combobox' && {
        'aria-autocomplete': 'list'
      })
    };
  }, [ariaRole, floatingId, isNested, open, referenceId, role]);
  const floating = react.useMemo(() => {
    const floatingProps = {
      id: floatingId,
      ...(ariaRole && {
        role: ariaRole
      })
    };
    if (ariaRole === 'tooltip' || role === 'label') {
      return floatingProps;
    }
    return {
      ...floatingProps,
      ...(ariaRole === 'menu' && {
        'aria-labelledby': referenceId
      })
    };
  }, [ariaRole, floatingId, referenceId, role]);
  const item = react.useCallback(_ref => {
    let {
      active,
      selected
    } = _ref;
    const commonProps = {
      role: 'option',
      ...(active && {
        id: floatingId + "-fui-option"
      })
    };

    // For `menu`, we are unable to tell if the item is a `menuitemradio`
    // or `menuitemcheckbox`. For backwards-compatibility reasons, also
    // avoid defaulting to `menuitem` as it may overwrite custom role props.
    switch (role) {
      case 'select':
      case 'combobox':
        return {
          ...commonProps,
          'aria-selected': selected
        };
    }
    return {};
  }, [floatingId, role]);
  return react.useMemo(() => enabled ? {
    reference,
    floating,
    item
  } : {}, [enabled, reference, floating, item]);
}

// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const camelCaseToKebabCase = str => str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? '-' : '') + $.toLowerCase());
function execWithArgsOrReturn(valueOrFn, args) {
  return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function useDelayUnmount(open, durationMs) {
  const [isMounted, setIsMounted] = react.useState(open);
  if (open && !isMounted) {
    setIsMounted(true);
  }
  react.useEffect(() => {
    if (!open && isMounted) {
      const timeout = setTimeout(() => setIsMounted(false), durationMs);
      return () => clearTimeout(timeout);
    }
  }, [open, isMounted, durationMs]);
  return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */
function useTransitionStatus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    elements: {
      floating
    }
  } = context;
  const {
    duration = 250
  } = props;
  const isNumberDuration = typeof duration === 'number';
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [status, setStatus] = react.useState('unmounted');
  const isMounted = useDelayUnmount(open, closeDuration);
  if (!isMounted && status === 'close') {
    setStatus('unmounted');
  }
  floating_ui_react_utils_index(() => {
    if (!floating) return;
    if (open) {
      setStatus('initial');
      const frame = requestAnimationFrame(() => {
        // Ensure it opens before paint. With `FloatingDelayGroup`,
        // this avoids a flicker when moving between floating elements
        // to ensure one is always open with no missing frames.
        react_dom.flushSync(() => {
          setStatus('open');
        });
      });
      return () => {
        cancelAnimationFrame(frame);
      };
    }
    setStatus('close');
  }, [open, floating]);
  return {
    isMounted,
    status
  };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */
function useTransitionStyles(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    initial: unstable_initial = {
      opacity: 0
    },
    open: unstable_open,
    close: unstable_close,
    common: unstable_common,
    duration = 250
  } = props;
  const placement = context.placement;
  const side = placement.split('-')[0];
  const fnArgs = react.useMemo(() => ({
    side,
    placement
  }), [side, placement]);
  const isNumberDuration = typeof duration === 'number';
  const openDuration = (isNumberDuration ? duration : duration.open) || 0;
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [styles, setStyles] = react.useState(() => ({
    ...execWithArgsOrReturn(unstable_common, fnArgs),
    ...execWithArgsOrReturn(unstable_initial, fnArgs)
  }));
  const {
    isMounted,
    status
  } = useTransitionStatus(context, {
    duration
  });
  const initialRef = useLatestRef(unstable_initial);
  const openRef = useLatestRef(unstable_open);
  const closeRef = useLatestRef(unstable_close);
  const commonRef = useLatestRef(unstable_common);
  floating_ui_react_utils_index(() => {
    const initialStyles = execWithArgsOrReturn(initialRef.current, fnArgs);
    const closeStyles = execWithArgsOrReturn(closeRef.current, fnArgs);
    const commonStyles = execWithArgsOrReturn(commonRef.current, fnArgs);
    const openStyles = execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key) => {
      acc[key] = '';
      return acc;
    }, {});
    if (status === 'initial') {
      setStyles(styles => ({
        transitionProperty: styles.transitionProperty,
        ...commonStyles,
        ...initialStyles
      }));
    }
    if (status === 'open') {
      setStyles({
        transitionProperty: Object.keys(openStyles).map(camelCaseToKebabCase).join(','),
        transitionDuration: openDuration + "ms",
        ...commonStyles,
        ...openStyles
      });
    }
    if (status === 'close') {
      const styles = closeStyles || initialStyles;
      setStyles({
        transitionProperty: Object.keys(styles).map(camelCaseToKebabCase).join(','),
        transitionDuration: closeDuration + "ms",
        ...commonStyles,
        ...styles
      });
    }
  }, [closeDuration, closeRef, initialRef, openRef, commonRef, openDuration, status, fnArgs]);
  return {
    isMounted,
    styles
  };
}

/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */
function useTypeahead(context, props) {
  var _ref;
  const {
    open,
    dataRef
  } = context;
  const {
    listRef,
    activeIndex,
    onMatch: unstable_onMatch,
    onTypingChange: unstable_onTypingChange,
    enabled = true,
    findMatch = null,
    resetMs = 750,
    ignoreKeys = [],
    selectedIndex = null
  } = props;
  const timeoutIdRef = react.useRef(-1);
  const stringRef = react.useRef('');
  const prevIndexRef = react.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
  const matchIndexRef = react.useRef(null);
  const onMatch = useEffectEvent(unstable_onMatch);
  const onTypingChange = useEffectEvent(unstable_onTypingChange);
  const findMatchRef = useLatestRef(findMatch);
  const ignoreKeysRef = useLatestRef(ignoreKeys);
  floating_ui_react_utils_index(() => {
    if (open) {
      clearTimeoutIfSet(timeoutIdRef);
      matchIndexRef.current = null;
      stringRef.current = '';
    }
  }, [open]);
  floating_ui_react_utils_index(() => {
    // Sync arrow key navigation but not typeahead navigation.
    if (open && stringRef.current === '') {
      var _ref2;
      prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
    }
  }, [open, selectedIndex, activeIndex]);
  const setTypingChange = useEffectEvent(value => {
    if (value) {
      if (!dataRef.current.typing) {
        dataRef.current.typing = value;
        onTypingChange(value);
      }
    } else {
      if (dataRef.current.typing) {
        dataRef.current.typing = value;
        onTypingChange(value);
      }
    }
  });
  const onKeyDown = useEffectEvent(event => {
    function getMatchingIndex(list, orderedList, string) {
      const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find(text => (text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
      return str ? list.indexOf(str) : -1;
    }
    const listContent = listRef.current;
    if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
      if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) {
        setTypingChange(false);
      } else if (event.key === ' ') {
        stopEvent(event);
      }
    }
    if (listContent == null || ignoreKeysRef.current.includes(event.key) ||
    // Character key.
    event.key.length !== 1 ||
    // Modifier key.
    event.ctrlKey || event.metaKey || event.altKey) {
      return;
    }
    if (open && event.key !== ' ') {
      stopEvent(event);
      setTypingChange(true);
    }

    // Bail out if the list contains a word like "llama" or "aaron". TODO:
    // allow it in this case, too.
    const allowRapidSuccessionOfFirstLetter = listContent.every(text => {
      var _text$, _text$2;
      return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
    });

    // Allows the user to cycle through items that start with the same letter
    // in rapid succession.
    if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
      stringRef.current = '';
      prevIndexRef.current = matchIndexRef.current;
    }
    stringRef.current += event.key;
    clearTimeoutIfSet(timeoutIdRef);
    timeoutIdRef.current = window.setTimeout(() => {
      stringRef.current = '';
      prevIndexRef.current = matchIndexRef.current;
      setTypingChange(false);
    }, resetMs);
    const prevIndex = prevIndexRef.current;
    const index = getMatchingIndex(listContent, [...listContent.slice((prevIndex || 0) + 1), ...listContent.slice(0, (prevIndex || 0) + 1)], stringRef.current);
    if (index !== -1) {
      onMatch(index);
      matchIndexRef.current = index;
    } else if (event.key !== ' ') {
      stringRef.current = '';
      setTypingChange(false);
    }
  });
  const reference = react.useMemo(() => ({
    onKeyDown
  }), [onKeyDown]);
  const floating = react.useMemo(() => {
    return {
      onKeyDown,
      onKeyUp(event) {
        if (event.key === ' ') {
          setTypingChange(false);
        }
      }
    };
  }, [onKeyDown, setTypingChange]);
  return react.useMemo(() => enabled ? {
    reference,
    floating
  } : {}, [enabled, reference, floating]);
}
function getArgsWithCustomFloatingHeight(state, height) {
  return {
    ...state,
    rects: {
      ...state.rects,
      floating: {
        ...state.rects.floating,
        height
      }
    }
  };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */
const inner = props => ({
  name: 'inner',
  options: props,
  async fn(state) {
    const {
      listRef,
      overflowRef,
      onFallbackChange,
      offset: innerOffset = 0,
      index = 0,
      minItemsVisible = 4,
      referenceOverflowThreshold = 0,
      scrollRef,
      ...detectOverflowOptions
    } = (0,floating_ui_utils/* evaluate */.ku)(props, state);
    const {
      rects,
      elements: {
        floating
      }
    } = state;
    const item = listRef.current[index];
    const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;

    // Valid combinations:
    // 1. Floating element is the scrollRef and has a border (default)
    // 2. Floating element is not the scrollRef, floating element has a border
    // 3. Floating element is not the scrollRef, scrollRef has a border
    // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
    // allowed as VoiceOver doesn't work.
    const clientTop = floating.clientTop || scrollEl.clientTop;
    const floatingIsBordered = floating.clientTop !== 0;
    const scrollElIsBordered = scrollEl.clientTop !== 0;
    const floatingIsScrollEl = floating === scrollEl;
    if (false) {}
    if (!item) {
      return {};
    }
    const nextArgs = {
      ...state,
      ...(await offset(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state))
    };
    const overflow = await (0,floating_ui_dom/* detectOverflow */.US)(getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
    const refOverflow = await (0,floating_ui_dom/* detectOverflow */.US)(nextArgs, {
      ...detectOverflowOptions,
      elementContext: 'reference'
    });
    const diffY = (0,floating_ui_utils/* max */.Fp)(0, overflow.top);
    const nextY = nextArgs.y + diffY;
    const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
    const rounder = isScrollable ? v => v : floating_ui_utils/* round */.NM;
    const maxHeight = rounder((0,floating_ui_utils/* max */.Fp)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0,floating_ui_utils/* max */.Fp)(0, overflow.bottom)));
    scrollEl.style.maxHeight = maxHeight + "px";
    scrollEl.scrollTop = diffY;

    // There is not enough space, fallback to standard anchored positioning
    if (onFallbackChange) {
      const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0,floating_ui_utils/* min */.VV)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
      react_dom.flushSync(() => onFallbackChange(shouldFallback));
    }
    if (overflowRef) {
      overflowRef.current = await (0,floating_ui_dom/* detectOverflow */.US)(getArgsWithCustomFloatingHeight({
        ...nextArgs,
        y: nextY
      }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
    }
    return {
      y: nextY
    };
  }
});
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */
function useInnerOffset(context, props) {
  const {
    open,
    elements
  } = context;
  const {
    enabled = true,
    overflowRef,
    scrollRef,
    onChange: unstable_onChange
  } = props;
  const onChange = useEffectEvent(unstable_onChange);
  const controlledScrollingRef = react.useRef(false);
  const prevScrollTopRef = react.useRef(null);
  const initialOverflowRef = react.useRef(null);
  react.useEffect(() => {
    if (!enabled) return;
    function onWheel(e) {
      if (e.ctrlKey || !el || overflowRef.current == null) {
        return;
      }
      const dY = e.deltaY;
      const isAtTop = overflowRef.current.top >= -0.5;
      const isAtBottom = overflowRef.current.bottom >= -0.5;
      const remainingScroll = el.scrollHeight - el.clientHeight;
      const sign = dY < 0 ? -1 : 1;
      const method = dY < 0 ? 'max' : 'min';
      if (el.scrollHeight <= el.clientHeight) {
        return;
      }
      if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
        e.preventDefault();
        react_dom.flushSync(() => {
          onChange(d => d + Math[method](dY, remainingScroll * sign));
        });
      } else if (/firefox/i.test(getUserAgent())) {
        // Needed to propagate scrolling during momentum scrolling phase once
        // it gets limited by the boundary. UX improvement, not critical.
        el.scrollTop += dY;
      }
    }
    const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
    if (open && el) {
      el.addEventListener('wheel', onWheel);

      // Wait for the position to be ready.
      requestAnimationFrame(() => {
        prevScrollTopRef.current = el.scrollTop;
        if (overflowRef.current != null) {
          initialOverflowRef.current = {
            ...overflowRef.current
          };
        }
      });
      return () => {
        prevScrollTopRef.current = null;
        initialOverflowRef.current = null;
        el.removeEventListener('wheel', onWheel);
      };
    }
  }, [enabled, open, elements.floating, overflowRef, scrollRef, onChange]);
  const floating = react.useMemo(() => ({
    onKeyDown() {
      controlledScrollingRef.current = true;
    },
    onWheel() {
      controlledScrollingRef.current = false;
    },
    onPointerMove() {
      controlledScrollingRef.current = false;
    },
    onScroll() {
      const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
      if (!overflowRef.current || !el || !controlledScrollingRef.current) {
        return;
      }
      if (prevScrollTopRef.current !== null) {
        const scrollDiff = el.scrollTop - prevScrollTopRef.current;
        if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) {
          react_dom.flushSync(() => onChange(d => d + scrollDiff));
        }
      }

      // [Firefox] Wait for the height change to have been applied.
      requestAnimationFrame(() => {
        prevScrollTopRef.current = el.scrollTop;
      });
    }
  }), [elements.floating, onChange, overflowRef, scrollRef]);
  return react.useMemo(() => enabled ? {
    floating
  } : {}, [enabled, floating]);
}
function floating_ui_react_esm_getNodeChildren(nodes, id, onlyOpenChildren) {
  if (onlyOpenChildren === void 0) {
    onlyOpenChildren = true;
  }
  const directChildren = nodes.filter(node => {
    var _node$context;
    return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
  });
  return directChildren.flatMap(child => [child, ...floating_ui_react_esm_getNodeChildren(nodes, child.id, onlyOpenChildren)]);
}
function isPointInPolygon(point, polygon) {
  const [x, y] = point;
  let isInside = false;
  const length = polygon.length;
  for (let i = 0, j = length - 1; i < length; j = i++) {
    const [xi, yi] = polygon[i] || [0, 0];
    const [xj, yj] = polygon[j] || [0, 0];
    const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
    if (intersect) {
      isInside = !isInside;
    }
  }
  return isInside;
}
function isInside(point, rect) {
  return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */
function safePolygon(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    buffer = 0.5,
    blockPointerEvents = false,
    requireIntent = true
  } = options;
  const timeoutRef = {
    current: -1
  };
  let hasLanded = false;
  let lastX = null;
  let lastY = null;
  let lastCursorTime = typeof performance !== 'undefined' ? performance.now() : 0;
  function getCursorSpeed(x, y) {
    const currentTime = performance.now();
    const elapsedTime = currentTime - lastCursorTime;
    if (lastX === null || lastY === null || elapsedTime === 0) {
      lastX = x;
      lastY = y;
      lastCursorTime = currentTime;
      return null;
    }
    const deltaX = x - lastX;
    const deltaY = y - lastY;
    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    const speed = distance / elapsedTime; // px / ms

    lastX = x;
    lastY = y;
    lastCursorTime = currentTime;
    return speed;
  }
  const fn = _ref => {
    let {
      x,
      y,
      placement,
      elements,
      onClose,
      nodeId,
      tree
    } = _ref;
    return function onMouseMove(event) {
      function close() {
        clearTimeoutIfSet(timeoutRef);
        onClose();
      }
      clearTimeoutIfSet(timeoutRef);
      if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) {
        return;
      }
      const {
        clientX,
        clientY
      } = event;
      const clientPoint = [clientX, clientY];
      const target = floating_ui_react_esm_getTarget(event);
      const isLeave = event.type === 'mouseleave';
      const isOverFloatingEl = floating_ui_react_esm_contains(elements.floating, target);
      const isOverReferenceEl = floating_ui_react_esm_contains(elements.domReference, target);
      const refRect = elements.domReference.getBoundingClientRect();
      const rect = elements.floating.getBoundingClientRect();
      const side = placement.split('-')[0];
      const cursorLeaveFromRight = x > rect.right - rect.width / 2;
      const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
      const isOverReferenceRect = isInside(clientPoint, refRect);
      const isFloatingWider = rect.width > refRect.width;
      const isFloatingTaller = rect.height > refRect.height;
      const left = (isFloatingWider ? refRect : rect).left;
      const right = (isFloatingWider ? refRect : rect).right;
      const top = (isFloatingTaller ? refRect : rect).top;
      const bottom = (isFloatingTaller ? refRect : rect).bottom;
      if (isOverFloatingEl) {
        hasLanded = true;
        if (!isLeave) {
          return;
        }
      }
      if (isOverReferenceEl) {
        hasLanded = false;
      }
      if (isOverReferenceEl && !isLeave) {
        hasLanded = true;
        return;
      }

      // Prevent overlapping floating element from being stuck in an open-close
      // loop: https://github.com/floating-ui/floating-ui/issues/1910
      if (isLeave && (0,floating_ui_utils_dom/* isElement */.kK)(event.relatedTarget) && floating_ui_react_esm_contains(elements.floating, event.relatedTarget)) {
        return;
      }

      // If any nested child is open, abort.
      if (tree && floating_ui_react_esm_getNodeChildren(tree.nodesRef.current, nodeId).length) {
        return;
      }

      // If the pointer is leaving from the opposite side, the "buffer" logic
      // creates a point where the floating element remains open, but should be
      // ignored.
      // A constant of 1 handles floating point rounding errors.
      if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) {
        return close();
      }

      // Ignore when the cursor is within the rectangular trough between the
      // two elements. Since the triangle is created from the cursor point,
      // which can start beyond the ref element's edge, traversing back and
      // forth from the ref to the floating element can cause it to close. This
      // ensures it always remains open in that case.
      let rectPoly = [];
      switch (side) {
        case 'top':
          rectPoly = [[left, refRect.top + 1], [left, rect.bottom - 1], [right, rect.bottom - 1], [right, refRect.top + 1]];
          break;
        case 'bottom':
          rectPoly = [[left, rect.top + 1], [left, refRect.bottom - 1], [right, refRect.bottom - 1], [right, rect.top + 1]];
          break;
        case 'left':
          rectPoly = [[rect.right - 1, bottom], [rect.right - 1, top], [refRect.left + 1, top], [refRect.left + 1, bottom]];
          break;
        case 'right':
          rectPoly = [[refRect.right - 1, bottom], [refRect.right - 1, top], [rect.left + 1, top], [rect.left + 1, bottom]];
          break;
      }
      function getPolygon(_ref2) {
        let [x, y] = _ref2;
        switch (side) {
          case 'top':
            {
              const cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              const cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
          case 'bottom':
            {
              const cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              const cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
          case 'left':
            {
              const cursorPointOne = [x + buffer + 1, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const cursorPointTwo = [x + buffer + 1, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const commonPoints = [[cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer, rect.bottom]];
              return [...commonPoints, cursorPointOne, cursorPointTwo];
            }
          case 'right':
            {
              const cursorPointOne = [x - buffer, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const cursorPointTwo = [x - buffer, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const commonPoints = [[cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer, rect.bottom]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
        }
      }
      if (isPointInPolygon([clientX, clientY], rectPoly)) {
        return;
      }
      if (hasLanded && !isOverReferenceRect) {
        return close();
      }
      if (!isLeave && requireIntent) {
        const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
        const cursorSpeedThreshold = 0.1;
        if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) {
          return close();
        }
      }
      if (!isPointInPolygon([clientX, clientY], getPolygon([x, y]))) {
        close();
      } else if (!hasLanded && requireIntent) {
        timeoutRef.current = window.setTimeout(close, 40);
      }
    };
  };
  fn.__options = {
    blockPointerEvents
  };
  return fn;
}


/***/ }),

/***/ 27553:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var categories = [__webpack_require__(27239), __webpack_require__(75911), __webpack_require__(73535), __webpack_require__(73020), __webpack_require__(4384), __webpack_require__(19593), __webpack_require__(88952), __webpack_require__(15154), __webpack_require__(58954), __webpack_require__(4316), __webpack_require__(77021), __webpack_require__(37946)];
for (var c in categories) {
  var category = categories[c];
  for (var f in category) {
    exports[f] = exports[f] || category[f];
  }
}
exports.utils = {
  errors: __webpack_require__(95369)
};

/***/ }),

/***/ 27239:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var mathTrig = __webpack_require__(4384);
var statistical = __webpack_require__(77021);
var engineering = __webpack_require__(73535);
var dateTime = __webpack_require__(88952);
function set(fn, root) {
  if (root) {
    for (var i in root) {
      fn[i] = root[i];
    }
  }
  return fn;
}
exports.BETADIST = statistical.BETA.DIST;
exports.BETAINV = statistical.BETA.INV;
exports.BINOMDIST = statistical.BINOM.DIST;
exports.CEILING = exports.ISOCEILING = set(mathTrig.CEILING.MATH, mathTrig.CEILING);
exports.CEILINGMATH = mathTrig.CEILING.MATH;
exports.CEILINGPRECISE = mathTrig.CEILING.PRECISE;
exports.CHIDIST = statistical.CHISQ.DIST;
exports.CHIDISTRT = statistical.CHISQ.DIST.RT;
exports.CHIINV = statistical.CHISQ.INV;
exports.CHIINVRT = statistical.CHISQ.INV.RT;
exports.CHITEST = statistical.CHISQ.TEST;
exports.CONFIDENCE = set(statistical.CONFIDENCE.NORM, statistical.CONFIDENCE);
exports.COVAR = statistical.COVARIANCE.P;
exports.COVARIANCEP = statistical.COVARIANCE.P;
exports.COVARIANCES = statistical.COVARIANCE.S;
exports.CRITBINOM = statistical.BINOM.INV;
exports.EXPONDIST = statistical.EXPON.DIST;
exports.ERFCPRECISE = engineering.ERFC.PRECISE;
exports.ERFPRECISE = engineering.ERF.PRECISE;
exports.FDIST = statistical.F.DIST;
exports.FDISTRT = statistical.F.DIST.RT;
exports.FINVRT = statistical.F.INV.RT;
exports.FINV = statistical.F.INV;
exports.FLOOR = set(mathTrig.FLOOR.MATH, mathTrig.FLOOR);
exports.FLOORMATH = mathTrig.FLOOR.MATH;
exports.FLOORPRECISE = mathTrig.FLOOR.PRECISE;
exports.FTEST = statistical.F.TEST;
exports.GAMMADIST = statistical.GAMMA.DIST;
exports.GAMMAINV = statistical.GAMMA.INV;
exports.GAMMALNPRECISE = statistical.GAMMALN.PRECISE;
exports.HYPGEOMDIST = statistical.HYPGEOM.DIST;
exports.LOGINV = statistical.LOGNORM.INV;
exports.LOGNORMINV = statistical.LOGNORM.INV;
exports.LOGNORMDIST = statistical.LOGNORM.DIST;
exports.MODE = set(statistical.MODE.SNGL, statistical.MODE);
exports.MODEMULT = statistical.MODE.MULT;
exports.MODESNGL = statistical.MODE.SNGL;
exports.NEGBINOMDIST = statistical.NEGBINOM.DIST;
exports.NETWORKDAYSINTL = dateTime.NETWORKDAYS.INTL;
exports.NORMDIST = statistical.NORM.DIST;
exports.NORMINV = statistical.NORM.INV;
exports.NORMSDIST = statistical.NORM.S.DIST;
exports.NORMSINV = statistical.NORM.S.INV;
exports.PERCENTILE = set(statistical.PERCENTILE.EXC, statistical.PERCENTILE);
exports.PERCENTILEEXC = statistical.PERCENTILE.EXC;
exports.PERCENTILEINC = statistical.PERCENTILE.INC;
exports.PERCENTRANK = set(statistical.PERCENTRANK.INC, statistical.PERCENTRANK);
exports.PERCENTRANKEXC = statistical.PERCENTRANK.EXC;
exports.PERCENTRANKINC = statistical.PERCENTRANK.INC;
exports.POISSON = set(statistical.POISSON.DIST, statistical.POISSON);
exports.POISSONDIST = statistical.POISSON.DIST;
exports.QUARTILE = set(statistical.QUARTILE.INC, statistical.QUARTILE);
exports.QUARTILEEXC = statistical.QUARTILE.EXC;
exports.QUARTILEINC = statistical.QUARTILE.INC;
exports.RANK = set(statistical.RANK.EQ, statistical.RANK);
exports.RANKAVG = statistical.RANK.AVG;
exports.RANKEQ = statistical.RANK.EQ;
exports.SKEWP = statistical.SKEW.P;
exports.STDEV = set(statistical.STDEV.S, statistical.STDEV);
exports.STDEVP = statistical.STDEV.P;
exports.STDEVS = statistical.STDEV.S;
exports.TDIST = statistical.T.DIST;
exports.TDISTRT = statistical.T.DIST.RT;
exports.TINV = statistical.T.INV;
exports.TTEST = statistical.T.TEST;
exports.VAR = set(statistical.VAR.S, statistical.VAR);
exports.VARP = statistical.VAR.P;
exports.VARS = statistical.VAR.S;
exports.WEIBULL = set(statistical.WEIBULL.DIST, statistical.WEIBULL);
exports.WEIBULLDIST = statistical.WEIBULL.DIST;
exports.WORKDAYINTL = dateTime.WORKDAY.INTL;
exports.ZTEST = statistical.Z.TEST;

/***/ }),

/***/ 75911:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var error = __webpack_require__(95369);
var stats = __webpack_require__(77021);
var maths = __webpack_require__(4384);
var utils = __webpack_require__(30166);
var evalExpression = __webpack_require__(60001);
function compact(array) {
  var result = [];
  utils.arrayEach(array, function (value) {
    if (value) {
      result.push(value);
    }
  });
  return result;
}
exports.FINDFIELD = function (database, title) {
  var index = null;
  utils.arrayEach(database, function (value, i) {
    if (value[0] === title) {
      index = i;
      return false;
    }
  });

  // Return error if the input field title is incorrect
  if (index == null) {
    return error.value;
  }
  return index;
};
function findResultIndex(database, criterias) {
  var matches = {};
  for (var i = 1; i < database[0].length; ++i) {
    matches[i] = true;
  }
  var maxCriteriaLength = criterias[0].length;
  for (i = 1; i < criterias.length; ++i) {
    if (criterias[i].length > maxCriteriaLength) {
      maxCriteriaLength = criterias[i].length;
    }
  }
  for (var k = 1; k < database.length; ++k) {
    for (var l = 1; l < database[k].length; ++l) {
      var currentCriteriaResult = false;
      var hasMatchingCriteria = false;
      for (var j = 0; j < criterias.length; ++j) {
        var criteria = criterias[j];
        if (criteria.length < maxCriteriaLength) {
          continue;
        }
        var criteriaField = criteria[0];
        if (database[k][0] !== criteriaField) {
          continue;
        }
        hasMatchingCriteria = true;
        for (var p = 1; p < criteria.length; ++p) {
          if (!currentCriteriaResult) {
            var isWildcard = criteria[p] === void 0 || criteria[p] === '*';
            if (isWildcard) {
              currentCriteriaResult = true;
            } else {
              var tokenizedCriteria = evalExpression.parse(criteria[p] + '');
              var tokens = [evalExpression.createToken(database[k][l], evalExpression.TOKEN_TYPE_LITERAL)].concat(tokenizedCriteria);
              currentCriteriaResult = evalExpression.compute(tokens);
            }
          }
        }
      }
      if (hasMatchingCriteria) {
        matches[l] = matches[l] && currentCriteriaResult;
      }
    }
  }
  var result = [];
  for (var n = 0; n < database[0].length; ++n) {
    if (matches[n]) {
      result.push(n - 1);
    }
  }
  return result;
}

// Database functions
exports.DAVERAGE = function (database, field, criteria) {
  // Return error if field is not a number and not a string
  if (isNaN(field) && typeof field !== "string") {
    return error.value;
  }
  var resultIndexes = findResultIndex(database, criteria);
  var targetFields = [];
  if (typeof field === "string") {
    var index = exports.FINDFIELD(database, field);
    targetFields = utils.rest(database[index]);
  } else {
    targetFields = utils.rest(database[field]);
  }
  var sum = 0;
  utils.arrayEach(resultIndexes, function (value) {
    sum += targetFields[value];
  });
  return resultIndexes.length === 0 ? error.div0 : sum / resultIndexes.length;
};
exports.DCOUNT = function (database, field, criteria) {
  // Return error if field is not a number and not a string
  if (isNaN(field) && typeof field !== "string") {
    return error.value;
  }
  var resultIndexes = findResultIndex(database, criteria);
  var targetFields = [];
  if (typeof field === "string") {
    var index = exports.FINDFIELD(database, field);
    targetFields = utils.rest(database[index]);
  } else {
    targetFields = utils.rest(database[field]);
  }
  var targetValues = [];
  utils.arrayEach(resultIndexes, function (value) {
    targetValues.push(targetFields[value]);
  });
  return stats.COUNT(targetValues);
};
exports.DCOUNTA = function (database, field, criteria) {
  // Return error if field is not a number and not a string
  if (isNaN(field) && typeof field !== "string") {
    return error.value;
  }
  var resultIndexes = findResultIndex(database, criteria);
  var targetFields = [];
  if (typeof field === "string") {
    var index = exports.FINDFIELD(database, field);
    targetFields = utils.rest(database[index]);
  } else {
    targetFields = utils.rest(database[field]);
  }
  var targetValues = [];
  utils.arrayEach(resultIndexes, function (value) {
    targetValues.push(targetFields[value]);
  });
  return stats.COUNTA(targetValues);
};
exports.DGET = function (database, field, criteria) {
  // Return error if field is not a number and not a string
  if (isNaN(field) && typeof field !== "string") {
    return error.value;
  }
  var resultIndexes = findResultIndex(database, criteria);
  var targetFields = [];
  if (typeof field === "string") {
    var index = exports.FINDFIELD(database, field);
    targetFields = utils.rest(database[index]);
  } else {
    targetFields = utils.rest(database[field]);
  }

  // Return error if no record meets the criteria
  if (resultIndexes.length === 0) {
    return error.value;
  }
  // Returns the #NUM! error value because more than one record meets the
  // criteria
  if (resultIndexes.length > 1) {
    return error.num;
  }
  return targetFields[resultIndexes[0]];
};
exports.DMAX = function (database, field, criteria) {
  // Return error if field is not a number and not a string
  if (isNaN(field) && typeof field !== "string") {
    return error.value;
  }
  var resultIndexes = findResultIndex(database, criteria);
  var targetFields = [];
  if (typeof field === "string") {
    var index = exports.FINDFIELD(database, field);
    targetFields = utils.rest(database[index]);
  } else {
    targetFields = utils.rest(database[field]);
  }
  var maxValue = targetFields[resultIndexes[0]];
  utils.arrayEach(resultIndexes, function (value) {
    if (maxValue < targetFields[value]) {
      maxValue = targetFields[value];
    }
  });
  return maxValue;
};
exports.DMIN = function (database, field, criteria) {
  // Return error if field is not a number and not a string
  if (isNaN(field) && typeof field !== "string") {
    return error.value;
  }
  var resultIndexes = findResultIndex(database, criteria);
  var targetFields = [];
  if (typeof field === "string") {
    var index = exports.FINDFIELD(database, field);
    targetFields = utils.rest(database[index]);
  } else {
    targetFields = utils.rest(database[field]);
  }
  var minValue = targetFields[resultIndexes[0]];
  utils.arrayEach(resultIndexes, function (value) {
    if (minValue > targetFields[value]) {
      minValue = targetFields[value];
    }
  });
  return minValue;
};
exports.DPRODUCT = function (database, field, criteria) {
  // Return error if field is not a number and not a string
  if (isNaN(field) && typeof field !== "string") {
    return error.value;
  }
  var resultIndexes = findResultIndex(database, criteria);
  var targetFields = [];
  if (typeof field === "string") {
    var index = exports.FINDFIELD(database, field);
    targetFields = utils.rest(database[index]);
  } else {
    targetFields = utils.rest(database[field]);
  }
  var targetValues = [];
  utils.arrayEach(resultIndexes, function (value) {
    targetValues.push(targetFields[value]);
  });
  targetValues = compact(targetValues);
  var result = 1;
  utils.arrayEach(targetValues, function (value) {
    result *= value;
  });
  return result;
};
exports.DSTDEV = function (database, field, criteria) {
  // Return error if field is not a number and not a string
  if (isNaN(field) && typeof field !== "string") {
    return error.value;
  }
  var resultIndexes = findResultIndex(database, criteria);
  var targetFields = [];
  if (typeof field === "string") {
    var index = exports.FINDFIELD(database, field);
    targetFields = utils.rest(database[index]);
  } else {
    targetFields = utils.rest(database[field]);
  }
  var targetValues = [];
  utils.arrayEach(resultIndexes, function (value) {
    targetValues.push(targetFields[value]);
  });
  targetValues = compact(targetValues);
  return stats.STDEV.S(targetValues);
};
exports.DSTDEVP = function (database, field, criteria) {
  // Return error if field is not a number and not a string
  if (isNaN(field) && typeof field !== "string") {
    return error.value;
  }
  var resultIndexes = findResultIndex(database, criteria);
  var targetFields = [];
  if (typeof field === "string") {
    var index = exports.FINDFIELD(database, field);
    targetFields = utils.rest(database[index]);
  } else {
    targetFields = utils.rest(database[field]);
  }
  var targetValues = [];
  utils.arrayEach(resultIndexes, function (value) {
    targetValues.push(targetFields[value]);
  });
  targetValues = compact(targetValues);
  return stats.STDEV.P(targetValues);
};
exports.DSUM = function (database, field, criteria) {
  // Return error if field is not a number and not a string
  if (isNaN(field) && typeof field !== "string") {
    return error.value;
  }
  var resultIndexes = findResultIndex(database, criteria);
  var targetFields = [];
  if (typeof field === "string") {
    var index = exports.FINDFIELD(database, field);
    targetFields = utils.rest(database[index]);
  } else {
    targetFields = utils.rest(database[field]);
  }
  var targetValues = [];
  utils.arrayEach(resultIndexes, function (value) {
    targetValues.push(targetFields[value]);
  });
  return maths.SUM(targetValues);
};
exports.DVAR = function (database, field, criteria) {
  // Return error if field is not a number and not a string
  if (isNaN(field) && typeof field !== "string") {
    return error.value;
  }
  var resultIndexes = findResultIndex(database, criteria);
  var targetFields = [];
  if (typeof field === "string") {
    var index = exports.FINDFIELD(database, field);
    targetFields = utils.rest(database[index]);
  } else {
    targetFields = utils.rest(database[field]);
  }
  var targetValues = [];
  utils.arrayEach(resultIndexes, function (value) {
    targetValues.push(targetFields[value]);
  });
  return stats.VAR.S(targetValues);
};
exports.DVARP = function (database, field, criteria) {
  // Return error if field is not a number and not a string
  if (isNaN(field) && typeof field !== "string") {
    return error.value;
  }
  var resultIndexes = findResultIndex(database, criteria);
  var targetFields = [];
  if (typeof field === "string") {
    var index = exports.FINDFIELD(database, field);
    targetFields = utils.rest(database[index]);
  } else {
    targetFields = utils.rest(database[field]);
  }
  var targetValues = [];
  utils.arrayEach(resultIndexes, function (value) {
    targetValues.push(targetFields[value]);
  });
  return stats.VAR.P(targetValues);
};

/***/ }),

/***/ 88952:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var error = __webpack_require__(95369);
var utils = __webpack_require__(30166);
var d1900 = new Date(Date.UTC(1900, 0, 1));
var WEEK_STARTS = [undefined, 0, 1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 1, 2, 3, 4, 5, 6, 0];
var WEEK_TYPES = [[], [1, 2, 3, 4, 5, 6, 7], [7, 1, 2, 3, 4, 5, 6], [6, 0, 1, 2, 3, 4, 5], [], [], [], [], [], [], [], [7, 1, 2, 3, 4, 5, 6], [6, 7, 1, 2, 3, 4, 5], [5, 6, 7, 1, 2, 3, 4], [4, 5, 6, 7, 1, 2, 3], [3, 4, 5, 6, 7, 1, 2], [2, 3, 4, 5, 6, 7, 1], [1, 2, 3, 4, 5, 6, 7]];
var WEEKEND_TYPES = [[], [6, 0], [0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 6], undefined, undefined, undefined, [0, 0], [1, 1], [2, 2], [3, 3], [4, 4], [5, 5], [6, 6]];
exports.DATE = function (year, month, day) {
  var result;
  year = utils.parseNumber(year);
  month = utils.parseNumber(month);
  day = utils.parseNumber(day);
  if (utils.anyIsError(year, month, day)) {
    result = error.value;
  } else {
    result = new Date(year, month - 1, day);
    if (result.getFullYear() < 0) {
      result = error.num;
    }
  }
  return result;
};
exports.DATEDIF = function (start_date, end_date, unit) {
  unit = unit.toUpperCase();
  start_date = utils.parseDate(start_date);
  end_date = utils.parseDate(end_date);
  var start_date_year = start_date.getFullYear();
  var start_date_month = start_date.getMonth();
  var start_date_day = start_date.getDate();
  var end_date_year = end_date.getFullYear();
  var end_date_month = end_date.getMonth();
  var end_date_day = end_date.getDate();
  var result;
  switch (unit) {
    case 'Y':
      result = Math.floor(exports.YEARFRAC(start_date, end_date));
      break;
    case 'D':
      result = exports.DAYS(end_date, start_date);
      break;
    case 'M':
      result = end_date_month - start_date_month + 12 * (end_date_year - start_date_year);
      if (end_date_day < start_date_day) {
        result--;
      }
      break;
    case 'MD':
      if (start_date_day <= end_date_day) {
        result = end_date_day - start_date_day;
      } else {
        if (end_date_month === 0) {
          start_date.setFullYear(end_date_year - 1);
          start_date.setMonth(12);
        } else {
          start_date.setFullYear(end_date_year);
          start_date.setMonth(end_date_month - 1);
        }
        result = exports.DAYS(end_date, start_date);
      }
      break;
    case 'YM':
      result = end_date_month - start_date_month + 12 * (end_date_year - start_date_year);
      if (end_date_day < start_date_day) {
        result--;
      }
      result = result % 12;
      break;
    case 'YD':
      if (end_date_month > start_date_month || end_date_month === start_date_month && end_date_day < start_date_day) {
        start_date.setFullYear(end_date_year);
      } else {
        start_date.setFullYear(end_date_year - 1);
      }
      result = exports.DAYS(end_date, start_date);
      break;
  }
  return result;
};
exports.DATEVALUE = function (date_text) {
  if (typeof date_text !== 'string') {
    return error.value;
  }
  var date = Date.parse(date_text);
  if (isNaN(date)) {
    return error.value;
  }
  return new Date(date_text);
};
exports.DAY = function (serial_number) {
  var date = utils.parseDate(serial_number);
  if (date instanceof Error) {
    return date;
  }
  return date.getDate();
};
function startOfDay(date) {
  var newDate = new Date(date);
  newDate.setHours(0, 0, 0, 0);
  return newDate;
}
exports.DAYS = function (end_date, start_date) {
  end_date = utils.parseDate(end_date);
  start_date = utils.parseDate(start_date);
  if (end_date instanceof Error) {
    return end_date;
  }
  if (start_date instanceof Error) {
    return start_date;
  }
  return serial(startOfDay(end_date)) - serial(startOfDay(start_date));
};
exports.DAYS360 = function (start_date, end_date, method) {
  method = utils.parseBool(method || 'false');
  start_date = utils.parseDate(start_date);
  end_date = utils.parseDate(end_date);
  if (start_date instanceof Error) {
    return start_date;
  }
  if (end_date instanceof Error) {
    return end_date;
  }
  if (method instanceof Error) {
    return method;
  }
  var sm = start_date.getMonth();
  var em = end_date.getMonth();
  var sd, ed;
  if (method) {
    sd = start_date.getDate() === 31 ? 30 : start_date.getDate();
    ed = end_date.getDate() === 31 ? 30 : end_date.getDate();
  } else {
    var smd = new Date(start_date.getFullYear(), sm + 1, 0).getDate();
    var emd = new Date(end_date.getFullYear(), em + 1, 0).getDate();
    sd = start_date.getDate() === smd ? 30 : start_date.getDate();
    if (end_date.getDate() === emd) {
      if (sd < 30) {
        em++;
        ed = 1;
      } else {
        ed = 30;
      }
    } else {
      ed = end_date.getDate();
    }
  }
  return 360 * (end_date.getFullYear() - start_date.getFullYear()) + 30 * (em - sm) + (ed - sd);
};
exports.EDATE = function (start_date, months) {
  start_date = utils.parseDate(start_date);
  if (start_date instanceof Error) {
    return start_date;
  }
  if (isNaN(months)) {
    return error.value;
  }
  months = parseInt(months, 10);
  start_date.setMonth(start_date.getMonth() + months);
  return start_date;
};
exports.EOMONTH = function (start_date, months) {
  start_date = utils.parseDate(start_date);
  if (start_date instanceof Error) {
    return start_date;
  }
  if (isNaN(months)) {
    return error.value;
  }
  months = parseInt(months, 10);
  return new Date(start_date.getFullYear(), start_date.getMonth() + months + 1, 0);
};
exports.HOUR = function (serial_number) {
  serial_number = utils.parseDate(serial_number);
  if (serial_number instanceof Error) {
    return serial_number;
  }
  return serial_number.getHours();
};
exports.INTERVAL = function (second) {
  if (typeof second !== 'number' && typeof second !== 'string') {
    return error.value;
  } else {
    second = parseInt(second, 10);
  }
  var year = Math.floor(second / 946080000);
  second = second % 946080000;
  var month = Math.floor(second / 2592000);
  second = second % 2592000;
  var day = Math.floor(second / 86400);
  second = second % 86400;
  var hour = Math.floor(second / 3600);
  second = second % 3600;
  var min = Math.floor(second / 60);
  second = second % 60;
  var sec = second;
  year = year > 0 ? year + 'Y' : '';
  month = month > 0 ? month + 'M' : '';
  day = day > 0 ? day + 'D' : '';
  hour = hour > 0 ? hour + 'H' : '';
  min = min > 0 ? min + 'M' : '';
  sec = sec > 0 ? sec + 'S' : '';
  return 'P' + year + month + day + 'T' + hour + min + sec;
};
exports.ISOWEEKNUM = function (date) {
  date = utils.parseDate(date);
  if (date instanceof Error) {
    return date;
  }
  date = startOfDay(date);
  date.setDate(date.getDate() + 4 - (date.getDay() || 7));
  var yearStart = new Date(date.getFullYear(), 0, 1);
  return Math.ceil(((date - yearStart) / 86400000 + 1) / 7);
};
exports.MINUTE = function (serial_number) {
  serial_number = utils.parseDate(serial_number);
  if (serial_number instanceof Error) {
    return serial_number;
  }
  return serial_number.getMinutes();
};
exports.MONTH = function (serial_number) {
  serial_number = utils.parseDate(serial_number);
  if (serial_number instanceof Error) {
    return serial_number;
  }
  return serial_number.getMonth() + 1;
};
exports.NETWORKDAYS = function (start_date, end_date, holidays) {
  return this.NETWORKDAYS.INTL(start_date, end_date, 1, holidays);
};
exports.NETWORKDAYS.INTL = function (start_date, end_date, weekend, holidays) {
  start_date = utils.parseDate(start_date);
  if (start_date instanceof Error) {
    return start_date;
  }
  end_date = utils.parseDate(end_date);
  if (end_date instanceof Error) {
    return end_date;
  }
  var isMask = false;
  var maskDays = [];
  var maskIndex = [1, 2, 3, 4, 5, 6, 0];
  var maskRegex = new RegExp('^[0|1]{7}$');
  if (weekend === undefined) {
    weekend = WEEKEND_TYPES[1];
  } else if (typeof weekend === 'string' && maskRegex.test(weekend)) {
    isMask = true;
    weekend = weekend.split('');
    for (i = 0; i < weekend.length; i++) {
      if (weekend[i] === '1') {
        maskDays.push(maskIndex[i]);
      }
    }
  } else {
    weekend = WEEKEND_TYPES[weekend];
  }
  if (!(weekend instanceof Array)) {
    return error.value;
  }
  if (holidays === undefined) {
    holidays = [];
  } else if (!(holidays instanceof Array)) {
    holidays = [holidays];
  }
  for (var i = 0; i < holidays.length; i++) {
    var h = utils.parseDate(holidays[i]);
    if (h instanceof Error) {
      return h;
    }
    holidays[i] = h;
  }
  var days = Math.round((end_date - start_date) / (1000 * 60 * 60 * 24)) + 1;
  var total = days;
  var day = start_date;
  for (i = 0; i < days; i++) {
    var d = new Date().getTimezoneOffset() > 0 ? day.getUTCDay() : day.getDay();
    var dec = isMask ? maskDays.includes(d) : d === weekend[0] || d === weekend[1];
    for (var j = 0; j < holidays.length; j++) {
      var holiday = holidays[j];
      if (holiday.getDate() === day.getDate() && holiday.getMonth() === day.getMonth() && holiday.getFullYear() === day.getFullYear()) {
        dec = true;
        break;
      }
    }
    if (dec) {
      total--;
    }
    day.setDate(day.getDate() + 1);
  }
  return total;
};
exports.NOW = function () {
  return new Date();
};
exports.SECOND = function (serial_number) {
  serial_number = utils.parseDate(serial_number);
  if (serial_number instanceof Error) {
    return serial_number;
  }
  return serial_number.getSeconds();
};
exports.TIME = function (hour, minute, second) {
  hour = utils.parseNumber(hour);
  minute = utils.parseNumber(minute);
  second = utils.parseNumber(second);
  if (utils.anyIsError(hour, minute, second)) {
    return error.value;
  }
  if (hour < 0 || minute < 0 || second < 0) {
    return error.num;
  }
  return (3600 * hour + 60 * minute + second) / 86400;
};
exports.TIMEVALUE = function (time_text) {
  time_text = utils.parseDate(time_text);
  if (time_text instanceof Error) {
    return time_text;
  }
  return (3600 * time_text.getHours() + 60 * time_text.getMinutes() + time_text.getSeconds()) / 86400;
};
exports.TODAY = function () {
  return startOfDay(new Date());
};
exports.WEEKDAY = function (serial_number, return_type) {
  serial_number = utils.parseDate(serial_number);
  if (serial_number instanceof Error) {
    return serial_number;
  }
  if (return_type === undefined) {
    return_type = 1;
  }
  var day = serial_number.getDay();
  return WEEK_TYPES[return_type][day];
};
exports.WEEKNUM = function (serial_number, return_type) {
  serial_number = utils.parseDate(serial_number);
  if (serial_number instanceof Error) {
    return serial_number;
  }
  if (return_type === undefined) {
    return_type = 1;
  }
  if (return_type === 21) {
    return this.ISOWEEKNUM(serial_number);
  }
  var week_start = WEEK_STARTS[return_type];
  var jan = new Date(serial_number.getFullYear(), 0, 1);
  var inc = jan.getDay() < week_start ? 1 : 0;
  jan -= Math.abs(jan.getDay() - week_start) * 24 * 60 * 60 * 1000;
  return Math.floor((serial_number - jan) / (1000 * 60 * 60 * 24) / 7 + 1) + inc;
};
exports.WORKDAY = function (start_date, days, holidays) {
  return this.WORKDAY.INTL(start_date, days, 1, holidays);
};
exports.WORKDAY.INTL = function (start_date, days, weekend, holidays) {
  start_date = utils.parseDate(start_date);
  if (start_date instanceof Error) {
    return start_date;
  }
  days = utils.parseNumber(days);
  if (days instanceof Error) {
    return days;
  }
  if (days < 0) {
    return error.num;
  }
  if (weekend === undefined) {
    weekend = WEEKEND_TYPES[1];
  } else {
    weekend = WEEKEND_TYPES[weekend];
  }
  if (!(weekend instanceof Array)) {
    return error.value;
  }
  if (holidays === undefined) {
    holidays = [];
  } else if (!(holidays instanceof Array)) {
    holidays = [holidays];
  }
  for (var i = 0; i < holidays.length; i++) {
    var h = utils.parseDate(holidays[i]);
    if (h instanceof Error) {
      return h;
    }
    holidays[i] = h;
  }
  var d = 0;
  while (d < days) {
    start_date.setDate(start_date.getDate() + 1);
    var day = start_date.getDay();
    if (day === weekend[0] || day === weekend[1]) {
      continue;
    }
    for (var j = 0; j < holidays.length; j++) {
      var holiday = holidays[j];
      if (holiday.getDate() === start_date.getDate() && holiday.getMonth() === start_date.getMonth() && holiday.getFullYear() === start_date.getFullYear()) {
        d--;
        break;
      }
    }
    d++;
  }
  return start_date;
};
exports.YEAR = function (serial_number) {
  serial_number = utils.parseDate(serial_number);
  if (serial_number instanceof Error) {
    return serial_number;
  }
  return serial_number.getFullYear();
};
function isLeapYear(year) {
  return new Date(year, 1, 29).getMonth() === 1;
}

// TODO : Use DAYS ?
function daysBetween(start_date, end_date) {
  return Math.ceil((end_date - start_date) / 1000 / 60 / 60 / 24);
}
exports.YEARFRAC = function (start_date, end_date, basis) {
  start_date = utils.parseDate(start_date);
  if (start_date instanceof Error) {
    return start_date;
  }
  end_date = utils.parseDate(end_date);
  if (end_date instanceof Error) {
    return end_date;
  }
  basis = basis || 0;
  var sd = start_date.getDate();
  var sm = start_date.getMonth() + 1;
  var sy = start_date.getFullYear();
  var ed = end_date.getDate();
  var em = end_date.getMonth() + 1;
  var ey = end_date.getFullYear();
  switch (basis) {
    case 0:
      // US (NASD) 30/360
      if (sd === 31 && ed === 31) {
        sd = 30;
        ed = 30;
      } else if (sd === 31) {
        sd = 30;
      } else if (sd === 30 && ed === 31) {
        ed = 30;
      }
      return (ed + em * 30 + ey * 360 - (sd + sm * 30 + sy * 360)) / 360;
    case 1:
      // Actual/actual
      var feb29Between = function (date1, date2) {
        var year1 = date1.getFullYear();
        var mar1year1 = new Date(year1, 2, 1);
        if (isLeapYear(year1) && date1 < mar1year1 && date2 >= mar1year1) {
          return true;
        }
        var year2 = date2.getFullYear();
        var mar1year2 = new Date(year2, 2, 1);
        return isLeapYear(year2) && date2 >= mar1year2 && date1 < mar1year2;
      };
      var ylength = 365;
      if (sy === ey || sy + 1 === ey && (sm > em || sm === em && sd >= ed)) {
        if (sy === ey && isLeapYear(sy) || feb29Between(start_date, end_date) || em === 1 && ed === 29) {
          ylength = 366;
        }
        return daysBetween(start_date, end_date) / ylength;
      }
      var years = ey - sy + 1;
      var days = (new Date(ey + 1, 0, 1) - new Date(sy, 0, 1)) / 1000 / 60 / 60 / 24;
      var average = days / years;
      return daysBetween(start_date, end_date) / average;
    case 2:
      // Actual/360
      return daysBetween(start_date, end_date) / 360;
    case 3:
      // Actual/365
      return daysBetween(start_date, end_date) / 365;
    case 4:
      // European 30/360
      return (ed + em * 30 + ey * 360 - (sd + sm * 30 + sy * 360)) / 360;
  }
};
function serial(date) {
  var addOn = date > -2203891200000 ? 2 : 1;
  return Math.ceil((date - d1900) / 86400000) + addOn;
}

/***/ }),

/***/ 73535:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var error = __webpack_require__(95369);
var jStat = __webpack_require__(24925);
var text = __webpack_require__(19593);
var utils = __webpack_require__(30166);
var bessel = __webpack_require__(4487);
function isValidBinaryNumber(number) {
  return /^[01]{1,10}$/.test(number);
}
exports.BESSELI = function (x, n) {
  x = utils.parseNumber(x);
  n = utils.parseNumber(n);
  if (utils.anyIsError(x, n)) {
    return error.value;
  }
  return bessel.besseli(x, n);
};
exports.BESSELJ = function (x, n) {
  x = utils.parseNumber(x);
  n = utils.parseNumber(n);
  if (utils.anyIsError(x, n)) {
    return error.value;
  }
  return bessel.besselj(x, n);
};
exports.BESSELK = function (x, n) {
  x = utils.parseNumber(x);
  n = utils.parseNumber(n);
  if (utils.anyIsError(x, n)) {
    return error.value;
  }
  return bessel.besselk(x, n);
};
exports.BESSELY = function (x, n) {
  x = utils.parseNumber(x);
  n = utils.parseNumber(n);
  if (utils.anyIsError(x, n)) {
    return error.value;
  }
  return bessel.bessely(x, n);
};
exports.BIN2DEC = function (number) {
  // Return error if number is not binary or contains more than 10 characters (10 digits)
  if (!isValidBinaryNumber(number)) {
    return error.num;
  }

  // Convert binary number to decimal
  var result = parseInt(number, 2);

  // Handle negative numbers
  var stringified = number.toString();
  if (stringified.length === 10 && stringified.substring(0, 1) === '1') {
    return parseInt(stringified.substring(1), 2) - 512;
  } else {
    return result;
  }
};
exports.BIN2HEX = function (number, places) {
  // Return error if number is not binary or contains more than 10 characters (10 digits)
  if (!isValidBinaryNumber(number)) {
    return error.num;
  }

  // Ignore places and return a 10-character hexadecimal number if number is negative
  var stringified = number.toString();
  if (stringified.length === 10 && stringified.substring(0, 1) === '1') {
    return (1099511627264 + parseInt(stringified.substring(1), 2)).toString(16);
  }

  // Convert binary number to hexadecimal
  var result = parseInt(number, 2).toString(16);

  // Return hexadecimal number using the minimum number of characters necessary if places is undefined
  if (places === undefined) {
    return result;
  } else {
    // Return error if places is nonnumeric
    if (isNaN(places)) {
      return error.value;
    }

    // Return error if places is negative
    if (places < 0) {
      return error.num;
    }

    // Truncate places in case it is not an integer
    places = Math.floor(places);

    // Pad return value with leading 0s (zeros) if necessary (using Underscore.string)
    return places >= result.length ? text.REPT('0', places - result.length) + result : error.num;
  }
};
exports.BIN2OCT = function (number, places) {
  // Return error if number is not binary or contains more than 10 characters (10 digits)
  if (!isValidBinaryNumber(number)) {
    return error.num;
  }

  // Ignore places and return a 10-character octal number if number is negative
  var stringified = number.toString();
  if (stringified.length === 10 && stringified.substring(0, 1) === '1') {
    return (1073741312 + parseInt(stringified.substring(1), 2)).toString(8);
  }

  // Convert binary number to octal
  var result = parseInt(number, 2).toString(8);

  // Return octal number using the minimum number of characters necessary if places is undefined
  if (places === undefined) {
    return result;
  } else {
    // Return error if places is nonnumeric
    if (isNaN(places)) {
      return error.value;
    }

    // Return error if places is negative
    if (places < 0) {
      return error.num;
    }

    // Truncate places in case it is not an integer
    places = Math.floor(places);

    // Pad return value with leading 0s (zeros) if necessary (using Underscore.string)
    return places >= result.length ? text.REPT('0', places - result.length) + result : error.num;
  }
};
exports.BITAND = function (number1, number2) {
  // Return error if either number is a non-numeric value
  number1 = utils.parseNumber(number1);
  number2 = utils.parseNumber(number2);
  if (utils.anyIsError(number1, number2)) {
    return error.value;
  }

  // Return error if either number is less than 0
  if (number1 < 0 || number2 < 0) {
    return error.num;
  }

  // Return error if either number is a non-integer
  if (Math.floor(number1) !== number1 || Math.floor(number2) !== number2) {
    return error.num;
  }

  // Return error if either number is greater than (2^48)-1
  if (number1 > 281474976710655 || number2 > 281474976710655) {
    return error.num;
  }

  // Return bitwise AND of two numbers
  return number1 & number2;
};
exports.BITLSHIFT = function (number, shift) {
  number = utils.parseNumber(number);
  shift = utils.parseNumber(shift);
  if (utils.anyIsError(number, shift)) {
    return error.value;
  }

  // Return error if number is less than 0
  if (number < 0) {
    return error.num;
  }

  // Return error if number is a non-integer
  if (Math.floor(number) !== number) {
    return error.num;
  }

  // Return error if number is greater than (2^48)-1
  if (number > 281474976710655) {
    return error.num;
  }

  // Return error if the absolute value of shift is greater than 53
  if (Math.abs(shift) > 53) {
    return error.num;
  }

  // Return number shifted by shift bits to the left or to the right if shift is negative
  return shift >= 0 ? number << shift : number >> -shift;
};
exports.BITOR = function (number1, number2) {
  number1 = utils.parseNumber(number1);
  number2 = utils.parseNumber(number2);
  if (utils.anyIsError(number1, number2)) {
    return error.value;
  }

  // Return error if either number is less than 0
  if (number1 < 0 || number2 < 0) {
    return error.num;
  }

  // Return error if either number is a non-integer
  if (Math.floor(number1) !== number1 || Math.floor(number2) !== number2) {
    return error.num;
  }

  // Return error if either number is greater than (2^48)-1
  if (number1 > 281474976710655 || number2 > 281474976710655) {
    return error.num;
  }

  // Return bitwise OR of two numbers
  return number1 | number2;
};
exports.BITRSHIFT = function (number, shift) {
  number = utils.parseNumber(number);
  shift = utils.parseNumber(shift);
  if (utils.anyIsError(number, shift)) {
    return error.value;
  }

  // Return error if number is less than 0
  if (number < 0) {
    return error.num;
  }

  // Return error if number is a non-integer
  if (Math.floor(number) !== number) {
    return error.num;
  }

  // Return error if number is greater than (2^48)-1
  if (number > 281474976710655) {
    return error.num;
  }

  // Return error if the absolute value of shift is greater than 53
  if (Math.abs(shift) > 53) {
    return error.num;
  }

  // Return number shifted by shift bits to the right or to the left if shift is negative
  return shift >= 0 ? number >> shift : number << -shift;
};
exports.BITXOR = function (number1, number2) {
  number1 = utils.parseNumber(number1);
  number2 = utils.parseNumber(number2);
  if (utils.anyIsError(number1, number2)) {
    return error.value;
  }

  // Return error if either number is less than 0
  if (number1 < 0 || number2 < 0) {
    return error.num;
  }

  // Return error if either number is a non-integer
  if (Math.floor(number1) !== number1 || Math.floor(number2) !== number2) {
    return error.num;
  }

  // Return error if either number is greater than (2^48)-1
  if (number1 > 281474976710655 || number2 > 281474976710655) {
    return error.num;
  }

  // Return bitwise XOR of two numbers
  return number1 ^ number2;
};
exports.COMPLEX = function (real, imaginary, suffix) {
  real = utils.parseNumber(real);
  imaginary = utils.parseNumber(imaginary);
  if (utils.anyIsError(real, imaginary)) {
    return real;
  }

  // Set suffix
  suffix = suffix === undefined ? 'i' : suffix;

  // Return error if suffix is neither "i" nor "j"
  if (suffix !== 'i' && suffix !== 'j') {
    return error.value;
  }

  // Return complex number
  if (real === 0 && imaginary === 0) {
    return 0;
  } else if (real === 0) {
    return imaginary === 1 ? suffix : imaginary.toString() + suffix;
  } else if (imaginary === 0) {
    return real.toString();
  } else {
    var sign = imaginary > 0 ? '+' : '';
    return real.toString() + sign + (imaginary === 1 ? suffix : imaginary.toString() + suffix);
  }
};
exports.CONVERT = function (number, from_unit, to_unit) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }

  // List of units supported by CONVERT and units defined by the International System of Units
  // [Name, Symbol, Alternate symbols, Quantity, ISU, CONVERT, Conversion ratio]
  var units = [["a.u. of action", "?", null, "action", false, false, 1.05457168181818e-34], ["a.u. of charge", "e", null, "electric_charge", false, false, 1.60217653141414e-19], ["a.u. of energy", "Eh", null, "energy", false, false, 4.35974417757576e-18], ["a.u. of length", "a?", null, "length", false, false, 5.29177210818182e-11], ["a.u. of mass", "m?", null, "mass", false, false, 9.10938261616162e-31], ["a.u. of time", "?/Eh", null, "time", false, false, 2.41888432650516e-17], ["admiralty knot", "admkn", null, "speed", false, true, 0.514773333], ["ampere", "A", null, "electric_current", true, false, 1], ["ampere per meter", "A/m", null, "magnetic_field_intensity", true, false, 1], ["ångström", "Å", ["ang"], "length", false, true, 1e-10], ["are", "ar", null, "area", false, true, 100], ["astronomical unit", "ua", null, "length", false, false, 1.49597870691667e-11], ["bar", "bar", null, "pressure", false, false, 100000], ["barn", "b", null, "area", false, false, 1e-28], ["becquerel", "Bq", null, "radioactivity", true, false, 1], ["bit", "bit", ["b"], "information", false, true, 1], ["btu", "BTU", ["btu"], "energy", false, true, 1055.05585262], ["byte", "byte", null, "information", false, true, 8], ["candela", "cd", null, "luminous_intensity", true, false, 1], ["candela per square metre", "cd/m?", null, "luminance", true, false, 1], ["coulomb", "C", null, "electric_charge", true, false, 1], ["cubic ångström", "ang3", ["ang^3"], "volume", false, true, 1e-30], ["cubic foot", "ft3", ["ft^3"], "volume", false, true, 0.028316846592], ["cubic inch", "in3", ["in^3"], "volume", false, true, 0.000016387064], ["cubic light-year", "ly3", ["ly^3"], "volume", false, true, 8.46786664623715e-47], ["cubic metre", "m?", null, "volume", true, true, 1], ["cubic mile", "mi3", ["mi^3"], "volume", false, true, 4168181825.44058], ["cubic nautical mile", "Nmi3", ["Nmi^3"], "volume", false, true, 6352182208], ["cubic Pica", "Pica3", ["Picapt3", "Pica^3", "Picapt^3"], "volume", false, true, 7.58660370370369e-8], ["cubic yard", "yd3", ["yd^3"], "volume", false, true, 0.764554857984], ["cup", "cup", null, "volume", false, true, 0.0002365882365], ["dalton", "Da", ["u"], "mass", false, false, 1.66053886282828e-27], ["day", "d", ["day"], "time", false, true, 86400], ["degree", "°", null, "angle", false, false, 0.0174532925199433], ["degrees Rankine", "Rank", null, "temperature", false, true, 0.555555555555556], ["dyne", "dyn", ["dy"], "force", false, true, 0.00001], ["electronvolt", "eV", ["ev"], "energy", false, true, 1.60217656514141], ["ell", "ell", null, "length", false, true, 1.143], ["erg", "erg", ["e"], "energy", false, true, 1e-7], ["farad", "F", null, "electric_capacitance", true, false, 1], ["fluid ounce", "oz", null, "volume", false, true, 0.0000295735295625], ["foot", "ft", null, "length", false, true, 0.3048], ["foot-pound", "flb", null, "energy", false, true, 1.3558179483314], ["gal", "Gal", null, "acceleration", false, false, 0.01], ["gallon", "gal", null, "volume", false, true, 0.003785411784], ["gauss", "G", ["ga"], "magnetic_flux_density", false, true, 1], ["grain", "grain", null, "mass", false, true, 0.0000647989], ["gram", "g", null, "mass", false, true, 0.001], ["gray", "Gy", null, "absorbed_dose", true, false, 1], ["gross registered ton", "GRT", ["regton"], "volume", false, true, 2.8316846592], ["hectare", "ha", null, "area", false, true, 10000], ["henry", "H", null, "inductance", true, false, 1], ["hertz", "Hz", null, "frequency", true, false, 1], ["horsepower", "HP", ["h"], "power", false, true, 745.69987158227], ["horsepower-hour", "HPh", ["hh", "hph"], "energy", false, true, 2684519.538], ["hour", "h", ["hr"], "time", false, true, 3600], ["imperial gallon (U.K.)", "uk_gal", null, "volume", false, true, 0.00454609], ["imperial hundredweight", "lcwt", ["uk_cwt", "hweight"], "mass", false, true, 50.802345], ["imperial quart (U.K)", "uk_qt", null, "volume", false, true, 0.0011365225], ["imperial ton", "brton", ["uk_ton", "LTON"], "mass", false, true, 1016.046909], ["inch", "in", null, "length", false, true, 0.0254], ["international acre", "uk_acre", null, "area", false, true, 4046.8564224], ["IT calorie", "cal", null, "energy", false, true, 4.1868], ["joule", "J", null, "energy", true, true, 1], ["katal", "kat", null, "catalytic_activity", true, false, 1], ["kelvin", "K", ["kel"], "temperature", true, true, 1], ["kilogram", "kg", null, "mass", true, true, 1], ["knot", "kn", null, "speed", false, true, 0.514444444444444], ["light-year", "ly", null, "length", false, true, 9460730472580800], ["litre", "L", ["l", "lt"], "volume", false, true, 0.001], ["lumen", "lm", null, "luminous_flux", true, false, 1], ["lux", "lx", null, "illuminance", true, false, 1], ["maxwell", "Mx", null, "magnetic_flux", false, false, 1e-18], ["measurement ton", "MTON", null, "volume", false, true, 1.13267386368], ["meter per hour", "m/h", ["m/hr"], "speed", false, true, 0.00027777777777778], ["meter per second", "m/s", ["m/sec"], "speed", true, true, 1], ["meter per second squared", "m?s??", null, "acceleration", true, false, 1], ["parsec", "pc", ["parsec"], "length", false, true, 30856775814671900], ["meter squared per second", "m?/s", null, "kinematic_viscosity", true, false, 1], ["metre", "m", null, "length", true, true, 1], ["miles per hour", "mph", null, "speed", false, true, 0.44704], ["millimetre of mercury", "mmHg", null, "pressure", false, false, 133.322], ["minute", "?", null, "angle", false, false, 0.000290888208665722], ["minute", "min", ["mn"], "time", false, true, 60], ["modern teaspoon", "tspm", null, "volume", false, true, 0.000005], ["mole", "mol", null, "amount_of_substance", true, false, 1], ["morgen", "Morgen", null, "area", false, true, 2500], ["n.u. of action", "?", null, "action", false, false, 1.05457168181818e-34], ["n.u. of mass", "m?", null, "mass", false, false, 9.10938261616162e-31], ["n.u. of speed", "c?", null, "speed", false, false, 299792458], ["n.u. of time", "?/(me?c??)", null, "time", false, false, 1.28808866778687e-21], ["nautical mile", "M", ["Nmi"], "length", false, true, 1852], ["newton", "N", null, "force", true, true, 1], ["œrsted", "Oe ", null, "magnetic_field_intensity", false, false, 79.5774715459477], ["ohm", "Ω", null, "electric_resistance", true, false, 1], ["ounce mass", "ozm", null, "mass", false, true, 0.028349523125], ["pascal", "Pa", null, "pressure", true, false, 1], ["pascal second", "Pa?s", null, "dynamic_viscosity", true, false, 1], ["pferdestärke", "PS", null, "power", false, true, 735.49875], ["phot", "ph", null, "illuminance", false, false, 0.0001], ["pica (1/6 inch)", "pica", null, "length", false, true, 0.00035277777777778], ["pica (1/72 inch)", "Pica", ["Picapt"], "length", false, true, 0.00423333333333333], ["poise", "P", null, "dynamic_viscosity", false, false, 0.1], ["pond", "pond", null, "force", false, true, 0.00980665], ["pound force", "lbf", null, "force", false, true, 4.4482216152605], ["pound mass", "lbm", null, "mass", false, true, 0.45359237], ["quart", "qt", null, "volume", false, true, 0.000946352946], ["radian", "rad", null, "angle", true, false, 1], ["second", "?", null, "angle", false, false, 0.00000484813681109536], ["second", "s", ["sec"], "time", true, true, 1], ["short hundredweight", "cwt", ["shweight"], "mass", false, true, 45.359237], ["siemens", "S", null, "electrical_conductance", true, false, 1], ["sievert", "Sv", null, "equivalent_dose", true, false, 1], ["slug", "sg", null, "mass", false, true, 14.59390294], ["square ångström", "ang2", ["ang^2"], "area", false, true, 1e-20], ["square foot", "ft2", ["ft^2"], "area", false, true, 0.09290304], ["square inch", "in2", ["in^2"], "area", false, true, 0.00064516], ["square light-year", "ly2", ["ly^2"], "area", false, true, 8.95054210748189e+31], ["square meter", "m?", null, "area", true, true, 1], ["square mile", "mi2", ["mi^2"], "area", false, true, 2589988.110336], ["square nautical mile", "Nmi2", ["Nmi^2"], "area", false, true, 3429904], ["square Pica", "Pica2", ["Picapt2", "Pica^2", "Picapt^2"], "area", false, true, 0.00001792111111111], ["square yard", "yd2", ["yd^2"], "area", false, true, 0.83612736], ["statute mile", "mi", null, "length", false, true, 1609.344], ["steradian", "sr", null, "solid_angle", true, false, 1], ["stilb", "sb", null, "luminance", false, false, 0.0001], ["stokes", "St", null, "kinematic_viscosity", false, false, 0.0001], ["stone", "stone", null, "mass", false, true, 6.35029318], ["tablespoon", "tbs", null, "volume", false, true, 0.0000147868], ["teaspoon", "tsp", null, "volume", false, true, 0.00000492892], ["tesla", "T", null, "magnetic_flux_density", true, true, 1], ["thermodynamic calorie", "c", null, "energy", false, true, 4.184], ["ton", "ton", null, "mass", false, true, 907.18474], ["tonne", "t", null, "mass", false, false, 1000], ["U.K. pint", "uk_pt", null, "volume", false, true, 0.00056826125], ["U.S. bushel", "bushel", null, "volume", false, true, 0.03523907], ["U.S. oil barrel", "barrel", null, "volume", false, true, 0.158987295], ["U.S. pint", "pt", ["us_pt"], "volume", false, true, 0.000473176473], ["U.S. survey mile", "survey_mi", null, "length", false, true, 1609.347219], ["U.S. survey/statute acre", "us_acre", null, "area", false, true, 4046.87261], ["volt", "V", null, "voltage", true, false, 1], ["watt", "W", null, "power", true, true, 1], ["watt-hour", "Wh", ["wh"], "energy", false, true, 3600], ["weber", "Wb", null, "magnetic_flux", true, false, 1], ["yard", "yd", null, "length", false, true, 0.9144], ["year", "yr", null, "time", false, true, 31557600]];

  // Binary prefixes
  // [Name, Prefix power of 2 value, Previx value, Abbreviation, Derived from]
  var binary_prefixes = {
    Yi: ["yobi", 80, 1208925819614629174706176, "Yi", "yotta"],
    Zi: ["zebi", 70, 1180591620717411303424, "Zi", "zetta"],
    Ei: ["exbi", 60, 1152921504606846976, "Ei", "exa"],
    Pi: ["pebi", 50, 1125899906842624, "Pi", "peta"],
    Ti: ["tebi", 40, 1099511627776, "Ti", "tera"],
    Gi: ["gibi", 30, 1073741824, "Gi", "giga"],
    Mi: ["mebi", 20, 1048576, "Mi", "mega"],
    ki: ["kibi", 10, 1024, "ki", "kilo"]
  };

  // Unit prefixes
  // [Name, Multiplier, Abbreviation]
  var unit_prefixes = {
    Y: ["yotta", 1e+24, "Y"],
    Z: ["zetta", 1e+21, "Z"],
    E: ["exa", 1e+18, "E"],
    P: ["peta", 1e+15, "P"],
    T: ["tera", 1e+12, "T"],
    G: ["giga", 1e+09, "G"],
    M: ["mega", 1e+06, "M"],
    k: ["kilo", 1e+03, "k"],
    h: ["hecto", 1e+02, "h"],
    e: ["dekao", 1e+01, "e"],
    d: ["deci", 1e-01, "d"],
    c: ["centi", 1e-02, "c"],
    m: ["milli", 1e-03, "m"],
    u: ["micro", 1e-06, "u"],
    n: ["nano", 1e-09, "n"],
    p: ["pico", 1e-12, "p"],
    f: ["femto", 1e-15, "f"],
    a: ["atto", 1e-18, "a"],
    z: ["zepto", 1e-21, "z"],
    y: ["yocto", 1e-24, "y"]
  };

  // Initialize units and multipliers
  var from = null;
  var to = null;
  var base_from_unit = from_unit;
  var base_to_unit = to_unit;
  var from_multiplier = 1;
  var to_multiplier = 1;
  var alt;

  // Lookup from and to units
  for (var i = 0; i < units.length; i++) {
    alt = units[i][2] === null ? [] : units[i][2];
    if (units[i][1] === base_from_unit || alt.indexOf(base_from_unit) >= 0) {
      from = units[i];
    }
    if (units[i][1] === base_to_unit || alt.indexOf(base_to_unit) >= 0) {
      to = units[i];
    }
  }

  // Lookup from prefix
  if (from === null) {
    var from_binary_prefix = binary_prefixes[from_unit.substring(0, 2)];
    var from_unit_prefix = unit_prefixes[from_unit.substring(0, 1)];

    // Handle dekao unit prefix (only unit prefix with two characters)
    if (from_unit.substring(0, 2) === 'da') {
      from_unit_prefix = ["dekao", 1e+01, "da"];
    }

    // Handle binary prefixes first (so that 'Yi' is processed before 'Y')
    if (from_binary_prefix) {
      from_multiplier = from_binary_prefix[2];
      base_from_unit = from_unit.substring(2);
    } else if (from_unit_prefix) {
      from_multiplier = from_unit_prefix[1];
      base_from_unit = from_unit.substring(from_unit_prefix[2].length);
    }

    // Lookup from unit
    for (var j = 0; j < units.length; j++) {
      alt = units[j][2] === null ? [] : units[j][2];
      if (units[j][1] === base_from_unit || alt.indexOf(base_from_unit) >= 0) {
        from = units[j];
      }
    }
  }

  // Lookup to prefix
  if (to === null) {
    var to_binary_prefix = binary_prefixes[to_unit.substring(0, 2)];
    var to_unit_prefix = unit_prefixes[to_unit.substring(0, 1)];

    // Handle dekao unit prefix (only unit prefix with two characters)
    if (to_unit.substring(0, 2) === 'da') {
      to_unit_prefix = ["dekao", 1e+01, "da"];
    }

    // Handle binary prefixes first (so that 'Yi' is processed before 'Y')
    if (to_binary_prefix) {
      to_multiplier = to_binary_prefix[2];
      base_to_unit = to_unit.substring(2);
    } else if (to_unit_prefix) {
      to_multiplier = to_unit_prefix[1];
      base_to_unit = to_unit.substring(to_unit_prefix[2].length);
    }

    // Lookup to unit
    for (var k = 0; k < units.length; k++) {
      alt = units[k][2] === null ? [] : units[k][2];
      if (units[k][1] === base_to_unit || alt.indexOf(base_to_unit) >= 0) {
        to = units[k];
      }
    }
  }

  // Return error if a unit does not exist
  if (from === null || to === null) {
    return error.na;
  }

  // Return error if units represent different quantities
  if (from[3] !== to[3]) {
    return error.na;
  }

  // Return converted number
  return number * from[6] * from_multiplier / (to[6] * to_multiplier);
};
exports.DEC2BIN = function (number, places) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }

  // Return error if number is not decimal, is lower than -512, or is greater than 511
  if (!/^-?[0-9]{1,3}$/.test(number) || number < -512 || number > 511) {
    return error.num;
  }

  // Ignore places and return a 10-character binary number if number is negative
  if (number < 0) {
    return '1' + text.REPT('0', 9 - (512 + number).toString(2).length) + (512 + number).toString(2);
  }

  // Convert decimal number to binary
  var result = parseInt(number, 10).toString(2);

  // Return binary number using the minimum number of characters necessary if places is undefined
  if (typeof places === 'undefined') {
    return result;
  } else {
    // Return error if places is nonnumeric
    if (isNaN(places)) {
      return error.value;
    }

    // Return error if places is negative
    if (places < 0) {
      return error.num;
    }

    // Truncate places in case it is not an integer
    places = Math.floor(places);

    // Pad return value with leading 0s (zeros) if necessary (using Underscore.string)
    return places >= result.length ? text.REPT('0', places - result.length) + result : error.num;
  }
};
exports.DEC2HEX = function (number, places) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }

  // Return error if number is not decimal, is lower than -549755813888, or is greater than 549755813887
  if (!/^-?[0-9]{1,12}$/.test(number) || number < -549755813888 || number > 549755813887) {
    return error.num;
  }

  // Ignore places and return a 10-character hexadecimal number if number is negative
  if (number < 0) {
    return (1099511627776 + number).toString(16);
  }

  // Convert decimal number to hexadecimal
  var result = parseInt(number, 10).toString(16);

  // Return hexadecimal number using the minimum number of characters necessary if places is undefined
  if (typeof places === 'undefined') {
    return result;
  } else {
    // Return error if places is nonnumeric
    if (isNaN(places)) {
      return error.value;
    }

    // Return error if places is negative
    if (places < 0) {
      return error.num;
    }

    // Truncate places in case it is not an integer
    places = Math.floor(places);

    // Pad return value with leading 0s (zeros) if necessary (using Underscore.string)
    return places >= result.length ? text.REPT('0', places - result.length) + result : error.num;
  }
};
exports.DEC2OCT = function (number, places) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }

  // Return error if number is not decimal, is lower than -549755813888, or is greater than 549755813887
  if (!/^-?[0-9]{1,9}$/.test(number) || number < -536870912 || number > 536870911) {
    return error.num;
  }

  // Ignore places and return a 10-character octal number if number is negative
  if (number < 0) {
    return (1073741824 + number).toString(8);
  }

  // Convert decimal number to octal
  var result = parseInt(number, 10).toString(8);

  // Return octal number using the minimum number of characters necessary if places is undefined
  if (typeof places === 'undefined') {
    return result;
  } else {
    // Return error if places is nonnumeric
    if (isNaN(places)) {
      return error.value;
    }

    // Return error if places is negative
    if (places < 0) {
      return error.num;
    }

    // Truncate places in case it is not an integer
    places = Math.floor(places);

    // Pad return value with leading 0s (zeros) if necessary (using Underscore.string)
    return places >= result.length ? text.REPT('0', places - result.length) + result : error.num;
  }
};
exports.DELTA = function (number1, number2) {
  // Set number2 to zero if undefined
  number2 = number2 === undefined ? 0 : number2;
  number1 = utils.parseNumber(number1);
  number2 = utils.parseNumber(number2);
  if (utils.anyIsError(number1, number2)) {
    return error.value;
  }

  // Return delta
  return number1 === number2 ? 1 : 0;
};

// TODO: why is upper_bound not used ? The excel documentation has no examples with upper_bound
exports.ERF = function (lower_bound, upper_bound) {
  // Set number2 to zero if undefined
  upper_bound = upper_bound === undefined ? 0 : upper_bound;
  lower_bound = utils.parseNumber(lower_bound);
  upper_bound = utils.parseNumber(upper_bound);
  if (utils.anyIsError(lower_bound, upper_bound)) {
    return error.value;
  }
  return jStat.erf(lower_bound);
};

// TODO
exports.ERF.PRECISE = function () {
  throw new Error('ERF.PRECISE is not implemented');
};
exports.ERFC = function (x) {
  // Return error if x is not a number
  if (isNaN(x)) {
    return error.value;
  }
  return jStat.erfc(x);
};

// TODO
exports.ERFC.PRECISE = function () {
  throw new Error('ERFC.PRECISE is not implemented');
};
exports.GESTEP = function (number, step) {
  step = step || 0;
  number = utils.parseNumber(number);
  if (utils.anyIsError(step, number)) {
    return number;
  }

  // Return delta
  return number >= step ? 1 : 0;
};
exports.HEX2BIN = function (number, places) {
  // Return error if number is not hexadecimal or contains more than ten characters (10 digits)
  if (!/^[0-9A-Fa-f]{1,10}$/.test(number)) {
    return error.num;
  }

  // Check if number is negative
  var negative = number.length === 10 && number.substring(0, 1).toLowerCase() === 'f' ? true : false;

  // Convert hexadecimal number to decimal
  var decimal = negative ? parseInt(number, 16) - 1099511627776 : parseInt(number, 16);

  // Return error if number is lower than -512 or greater than 511
  if (decimal < -512 || decimal > 511) {
    return error.num;
  }

  // Ignore places and return a 10-character binary number if number is negative
  if (negative) {
    return '1' + text.REPT('0', 9 - (512 + decimal).toString(2).length) + (512 + decimal).toString(2);
  }

  // Convert decimal number to binary
  var result = decimal.toString(2);

  // Return binary number using the minimum number of characters necessary if places is undefined
  if (places === undefined) {
    return result;
  } else {
    // Return error if places is nonnumeric
    if (isNaN(places)) {
      return error.value;
    }

    // Return error if places is negative
    if (places < 0) {
      return error.num;
    }

    // Truncate places in case it is not an integer
    places = Math.floor(places);

    // Pad return value with leading 0s (zeros) if necessary (using Underscore.string)
    return places >= result.length ? text.REPT('0', places - result.length) + result : error.num;
  }
};
exports.HEX2DEC = function (number) {
  // Return error if number is not hexadecimal or contains more than ten characters (10 digits)
  if (!/^[0-9A-Fa-f]{1,10}$/.test(number)) {
    return error.num;
  }

  // Convert hexadecimal number to decimal
  var decimal = parseInt(number, 16);

  // Return decimal number
  return decimal >= 549755813888 ? decimal - 1099511627776 : decimal;
};
exports.HEX2OCT = function (number, places) {
  // Return error if number is not hexadecimal or contains more than ten characters (10 digits)
  if (!/^[0-9A-Fa-f]{1,10}$/.test(number)) {
    return error.num;
  }

  // Convert hexadecimal number to decimal
  var decimal = parseInt(number, 16);

  // Return error if number is positive and greater than 0x1fffffff (536870911)
  if (decimal > 536870911 && decimal < 1098974756864) {
    return error.num;
  }

  // Ignore places and return a 10-character octal number if number is negative
  if (decimal >= 1098974756864) {
    return (decimal - 1098437885952).toString(8);
  }

  // Convert decimal number to octal
  var result = decimal.toString(8);

  // Return octal number using the minimum number of characters necessary if places is undefined
  if (places === undefined) {
    return result;
  } else {
    // Return error if places is nonnumeric
    if (isNaN(places)) {
      return error.value;
    }

    // Return error if places is negative
    if (places < 0) {
      return error.num;
    }

    // Truncate places in case it is not an integer
    places = Math.floor(places);

    // Pad return value with leading 0s (zeros) if necessary (using Underscore.string)
    return places >= result.length ? text.REPT('0', places - result.length) + result : error.num;
  }
};
exports.IMABS = function (inumber) {
  // Lookup real and imaginary coefficients using exports.js [http://formulajs.org]
  var x = exports.IMREAL(inumber);
  var y = exports.IMAGINARY(inumber);

  // Return error if either coefficient is not a number
  if (utils.anyIsError(x, y)) {
    return error.value;
  }

  // Return absolute value of complex number
  return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
};
exports.IMAGINARY = function (inumber) {
  if (inumber === undefined || inumber === true || inumber === false) {
    return error.value;
  }

  // Return 0 if inumber is equal to 0
  if (inumber === 0 || inumber === '0') {
    return 0;
  }

  // Handle special cases
  if (['i', 'j'].indexOf(inumber) >= 0) {
    return 1;
  }

  // Force string type
  inumber = inumber + '';

  // Normalize imaginary coefficient
  inumber = inumber.replace('+i', '+1i').replace('-i', '-1i').replace('+j', '+1j').replace('-j', '-1j');

  // Lookup sign
  var plus = inumber.indexOf('+');
  var minus = inumber.indexOf('-');
  if (plus === 0) {
    plus = inumber.indexOf('+', 1);
  }
  if (minus === 0) {
    minus = inumber.indexOf('-', 1);
  }

  // Lookup imaginary unit
  var last = inumber.substring(inumber.length - 1, inumber.length);
  var unit = last === 'i' || last === 'j';
  if (plus >= 0 || minus >= 0) {
    // Return error if imaginary unit is neither i nor j
    if (!unit) {
      return error.num;
    }

    // Return imaginary coefficient of complex number
    if (plus >= 0) {
      return isNaN(inumber.substring(0, plus)) || isNaN(inumber.substring(plus + 1, inumber.length - 1)) ? error.num : Number(inumber.substring(plus + 1, inumber.length - 1));
    } else {
      return isNaN(inumber.substring(0, minus)) || isNaN(inumber.substring(minus + 1, inumber.length - 1)) ? error.num : -Number(inumber.substring(minus + 1, inumber.length - 1));
    }
  } else {
    if (unit) {
      return isNaN(inumber.substring(0, inumber.length - 1)) ? error.num : inumber.substring(0, inumber.length - 1);
    } else {
      return isNaN(inumber) ? error.num : 0;
    }
  }
};
exports.IMARGUMENT = function (inumber) {
  // Lookup real and imaginary coefficients using exports.js [http://formulajs.org]
  var x = exports.IMREAL(inumber);
  var y = exports.IMAGINARY(inumber);

  // Return error if either coefficient is not a number
  if (utils.anyIsError(x, y)) {
    return error.value;
  }

  // Return error if inumber is equal to zero
  if (x === 0 && y === 0) {
    return error.div0;
  }

  // Return PI/2 if x is equal to zero and y is positive
  if (x === 0 && y > 0) {
    return Math.PI / 2;
  }

  // Return -PI/2 if x is equal to zero and y is negative
  if (x === 0 && y < 0) {
    return -Math.PI / 2;
  }

  // Return zero if x is negative and y is equal to zero
  if (y === 0 && x > 0) {
    return 0;
  }

  // Return zero if x is negative and y is equal to zero
  if (y === 0 && x < 0) {
    return -Math.PI;
  }

  // Return argument of complex number
  if (x > 0) {
    return Math.atan(y / x);
  } else if (x < 0 && y >= 0) {
    return Math.atan(y / x) + Math.PI;
  } else {
    return Math.atan(y / x) - Math.PI;
  }
};
exports.IMCONJUGATE = function (inumber) {
  // Lookup real and imaginary coefficients using exports.js [http://formulajs.org]
  var x = exports.IMREAL(inumber);
  var y = exports.IMAGINARY(inumber);
  if (utils.anyIsError(x, y)) {
    return error.value;
  }

  // Lookup imaginary unit
  var unit = inumber.substring(inumber.length - 1);
  unit = unit === 'i' || unit === 'j' ? unit : 'i';

  // Return conjugate of complex number
  return y !== 0 ? exports.COMPLEX(x, -y, unit) : inumber;
};
exports.IMCOS = function (inumber) {
  // Lookup real and imaginary coefficients using exports.js [http://formulajs.org]
  var x = exports.IMREAL(inumber);
  var y = exports.IMAGINARY(inumber);
  if (utils.anyIsError(x, y)) {
    return error.value;
  }

  // Lookup imaginary unit
  var unit = inumber.substring(inumber.length - 1);
  unit = unit === 'i' || unit === 'j' ? unit : 'i';

  // Return cosine of complex number
  return exports.COMPLEX(Math.cos(x) * (Math.exp(y) + Math.exp(-y)) / 2, -Math.sin(x) * (Math.exp(y) - Math.exp(-y)) / 2, unit);
};
exports.IMCOSH = function (inumber) {
  // Lookup real and imaginary coefficients using exports.js [http://formulajs.org]
  var x = exports.IMREAL(inumber);
  var y = exports.IMAGINARY(inumber);
  if (utils.anyIsError(x, y)) {
    return error.value;
  }

  // Lookup imaginary unit
  var unit = inumber.substring(inumber.length - 1);
  unit = unit === 'i' || unit === 'j' ? unit : 'i';

  // Return hyperbolic cosine of complex number
  return exports.COMPLEX(Math.cos(y) * (Math.exp(x) + Math.exp(-x)) / 2, Math.sin(y) * (Math.exp(x) - Math.exp(-x)) / 2, unit);
};
exports.IMCOT = function (inumber) {
  // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
  var x = exports.IMREAL(inumber);
  var y = exports.IMAGINARY(inumber);
  if (utils.anyIsError(x, y)) {
    return error.value;
  }

  // Return cotangent of complex number
  return exports.IMDIV(exports.IMCOS(inumber), exports.IMSIN(inumber));
};
exports.IMDIV = function (inumber1, inumber2) {
  // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
  var a = exports.IMREAL(inumber1);
  var b = exports.IMAGINARY(inumber1);
  var c = exports.IMREAL(inumber2);
  var d = exports.IMAGINARY(inumber2);
  if (utils.anyIsError(a, b, c, d)) {
    return error.value;
  }

  // Lookup imaginary unit
  var unit1 = inumber1.substring(inumber1.length - 1);
  var unit2 = inumber2.substring(inumber2.length - 1);
  var unit = 'i';
  if (unit1 === 'j') {
    unit = 'j';
  } else if (unit2 === 'j') {
    unit = 'j';
  }

  // Return error if inumber2 is null
  if (c === 0 && d === 0) {
    return error.num;
  }

  // Return exponential of complex number
  var den = c * c + d * d;
  return exports.COMPLEX((a * c + b * d) / den, (b * c - a * d) / den, unit);
};
exports.IMEXP = function (inumber) {
  // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
  var x = exports.IMREAL(inumber);
  var y = exports.IMAGINARY(inumber);
  if (utils.anyIsError(x, y)) {
    return error.value;
  }

  // Lookup imaginary unit
  var unit = inumber.substring(inumber.length - 1);
  unit = unit === 'i' || unit === 'j' ? unit : 'i';

  // Return exponential of complex number
  var e = Math.exp(x);
  return exports.COMPLEX(e * Math.cos(y), e * Math.sin(y), unit);
};
exports.IMLN = function (inumber) {
  // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
  var x = exports.IMREAL(inumber);
  var y = exports.IMAGINARY(inumber);
  if (utils.anyIsError(x, y)) {
    return error.value;
  }

  // Lookup imaginary unit
  var unit = inumber.substring(inumber.length - 1);
  unit = unit === 'i' || unit === 'j' ? unit : 'i';

  // Return exponential of complex number
  return exports.COMPLEX(Math.log(Math.sqrt(x * x + y * y)), Math.atan(y / x), unit);
};
exports.IMLOG10 = function (inumber) {
  // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
  var x = exports.IMREAL(inumber);
  var y = exports.IMAGINARY(inumber);
  if (utils.anyIsError(x, y)) {
    return error.value;
  }

  // Lookup imaginary unit
  var unit = inumber.substring(inumber.length - 1);
  unit = unit === 'i' || unit === 'j' ? unit : 'i';

  // Return exponential of complex number
  return exports.COMPLEX(Math.log(Math.sqrt(x * x + y * y)) / Math.log(10), Math.atan(y / x) / Math.log(10), unit);
};
exports.IMLOG2 = function (inumber) {
  // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
  var x = exports.IMREAL(inumber);
  var y = exports.IMAGINARY(inumber);
  if (utils.anyIsError(x, y)) {
    return error.value;
  }

  // Lookup imaginary unit
  var unit = inumber.substring(inumber.length - 1);
  unit = unit === 'i' || unit === 'j' ? unit : 'i';

  // Return exponential of complex number
  return exports.COMPLEX(Math.log(Math.sqrt(x * x + y * y)) / Math.log(2), Math.atan(y / x) / Math.log(2), unit);
};
exports.IMPOWER = function (inumber, number) {
  number = utils.parseNumber(number);
  var x = exports.IMREAL(inumber);
  var y = exports.IMAGINARY(inumber);
  if (utils.anyIsError(number, x, y)) {
    return error.value;
  }

  // Lookup imaginary unit
  var unit = inumber.substring(inumber.length - 1);
  unit = unit === 'i' || unit === 'j' ? unit : 'i';

  // Calculate power of modulus
  var p = Math.pow(exports.IMABS(inumber), number);

  // Calculate argument
  var t = exports.IMARGUMENT(inumber);

  // Return exponential of complex number
  return exports.COMPLEX(p * Math.cos(number * t), p * Math.sin(number * t), unit);
};
exports.IMPRODUCT = function () {
  // Initialize result
  var result = arguments[0];
  if (!arguments.length) {
    return error.value;
  }

  // Loop on all numbers
  for (var i = 1; i < arguments.length; i++) {
    // Lookup coefficients of two complex numbers
    var a = exports.IMREAL(result);
    var b = exports.IMAGINARY(result);
    var c = exports.IMREAL(arguments[i]);
    var d = exports.IMAGINARY(arguments[i]);
    if (utils.anyIsError(a, b, c, d)) {
      return error.value;
    }

    // Complute product of two complex numbers
    result = exports.COMPLEX(a * c - b * d, a * d + b * c);
  }

  // Return product of complex numbers
  return result;
};
exports.IMREAL = function (inumber) {
  if (inumber === undefined || inumber === true || inumber === false) {
    return error.value;
  }

  // Return 0 if inumber is equal to 0
  if (inumber === 0 || inumber === '0') {
    return 0;
  }

  // Handle special cases
  if (['i', '+i', '1i', '+1i', '-i', '-1i', 'j', '+j', '1j', '+1j', '-j', '-1j'].indexOf(inumber) >= 0) {
    return 0;
  }

  // Force String type
  inumber = inumber + '';

  // Lookup sign
  var plus = inumber.indexOf('+');
  var minus = inumber.indexOf('-');
  if (plus === 0) {
    plus = inumber.indexOf('+', 1);
  }
  if (minus === 0) {
    minus = inumber.indexOf('-', 1);
  }

  // Lookup imaginary unit
  var last = inumber.substring(inumber.length - 1, inumber.length);
  var unit = last === 'i' || last === 'j';
  if (plus >= 0 || minus >= 0) {
    // Return error if imaginary unit is neither i nor j
    if (!unit) {
      return error.num;
    }

    // Return real coefficient of complex number
    if (plus >= 0) {
      return isNaN(inumber.substring(0, plus)) || isNaN(inumber.substring(plus + 1, inumber.length - 1)) ? error.num : Number(inumber.substring(0, plus));
    } else {
      return isNaN(inumber.substring(0, minus)) || isNaN(inumber.substring(minus + 1, inumber.length - 1)) ? error.num : Number(inumber.substring(0, minus));
    }
  } else {
    if (unit) {
      return isNaN(inumber.substring(0, inumber.length - 1)) ? error.num : 0;
    } else {
      return isNaN(inumber) ? error.num : inumber;
    }
  }
};
exports.IMSEC = function (inumber) {
  // Return error if inumber is a logical value
  if (inumber === true || inumber === false) {
    return error.value;
  }

  // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
  var x = exports.IMREAL(inumber);
  var y = exports.IMAGINARY(inumber);
  if (utils.anyIsError(x, y)) {
    return error.value;
  }

  // Return secant of complex number
  return exports.IMDIV('1', exports.IMCOS(inumber));
};
exports.IMSECH = function (inumber) {
  // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
  var x = exports.IMREAL(inumber);
  var y = exports.IMAGINARY(inumber);
  if (utils.anyIsError(x, y)) {
    return error.value;
  }

  // Return hyperbolic secant of complex number
  return exports.IMDIV('1', exports.IMCOSH(inumber));
};
exports.IMSIN = function (inumber) {
  // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
  var x = exports.IMREAL(inumber);
  var y = exports.IMAGINARY(inumber);
  if (utils.anyIsError(x, y)) {
    return error.value;
  }

  // Lookup imaginary unit
  var unit = inumber.substring(inumber.length - 1);
  unit = unit === 'i' || unit === 'j' ? unit : 'i';

  // Return sine of complex number
  return exports.COMPLEX(Math.sin(x) * (Math.exp(y) + Math.exp(-y)) / 2, Math.cos(x) * (Math.exp(y) - Math.exp(-y)) / 2, unit);
};
exports.IMSINH = function (inumber) {
  // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
  var x = exports.IMREAL(inumber);
  var y = exports.IMAGINARY(inumber);
  if (utils.anyIsError(x, y)) {
    return error.value;
  }

  // Lookup imaginary unit
  var unit = inumber.substring(inumber.length - 1);
  unit = unit === 'i' || unit === 'j' ? unit : 'i';

  // Return hyperbolic sine of complex number
  return exports.COMPLEX(Math.cos(y) * (Math.exp(x) - Math.exp(-x)) / 2, Math.sin(y) * (Math.exp(x) + Math.exp(-x)) / 2, unit);
};
exports.IMSQRT = function (inumber) {
  // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
  var x = exports.IMREAL(inumber);
  var y = exports.IMAGINARY(inumber);
  if (utils.anyIsError(x, y)) {
    return error.value;
  }

  // Lookup imaginary unit
  var unit = inumber.substring(inumber.length - 1);
  unit = unit === 'i' || unit === 'j' ? unit : 'i';

  // Calculate power of modulus
  var s = Math.sqrt(exports.IMABS(inumber));

  // Calculate argument
  var t = exports.IMARGUMENT(inumber);

  // Return exponential of complex number
  return exports.COMPLEX(s * Math.cos(t / 2), s * Math.sin(t / 2), unit);
};
exports.IMCSC = function (inumber) {
  // Return error if inumber is a logical value
  if (inumber === true || inumber === false) {
    return error.value;
  }

  // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
  var x = exports.IMREAL(inumber);
  var y = exports.IMAGINARY(inumber);

  // Return error if either coefficient is not a number
  if (utils.anyIsError(x, y)) {
    return error.num;
  }

  // Return cosecant of complex number
  return exports.IMDIV('1', exports.IMSIN(inumber));
};
exports.IMCSCH = function (inumber) {
  // Return error if inumber is a logical value
  if (inumber === true || inumber === false) {
    return error.value;
  }

  // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
  var x = exports.IMREAL(inumber);
  var y = exports.IMAGINARY(inumber);

  // Return error if either coefficient is not a number
  if (utils.anyIsError(x, y)) {
    return error.num;
  }

  // Return hyperbolic cosecant of complex number
  return exports.IMDIV('1', exports.IMSINH(inumber));
};
exports.IMSUB = function (inumber1, inumber2) {
  // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
  var a = this.IMREAL(inumber1);
  var b = this.IMAGINARY(inumber1);
  var c = this.IMREAL(inumber2);
  var d = this.IMAGINARY(inumber2);
  if (utils.anyIsError(a, b, c, d)) {
    return error.value;
  }

  // Lookup imaginary unit
  var unit1 = inumber1.substring(inumber1.length - 1);
  var unit2 = inumber2.substring(inumber2.length - 1);
  var unit = 'i';
  if (unit1 === 'j') {
    unit = 'j';
  } else if (unit2 === 'j') {
    unit = 'j';
  }

  // Return _ of two complex numbers
  return this.COMPLEX(a - c, b - d, unit);
};
exports.IMSUM = function () {
  if (!arguments.length) {
    return error.value;
  }
  var args = utils.flatten(arguments);

  // Initialize result
  var result = args[0];

  // Loop on all numbers
  for (var i = 1; i < args.length; i++) {
    // Lookup coefficients of two complex numbers
    var a = this.IMREAL(result);
    var b = this.IMAGINARY(result);
    var c = this.IMREAL(args[i]);
    var d = this.IMAGINARY(args[i]);
    if (utils.anyIsError(a, b, c, d)) {
      return error.value;
    }

    // Complute product of two complex numbers
    result = this.COMPLEX(a + c, b + d);
  }

  // Return sum of complex numbers
  return result;
};
exports.IMTAN = function (inumber) {
  // Return error if inumber is a logical value
  if (inumber === true || inumber === false) {
    return error.value;
  }

  // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
  var x = exports.IMREAL(inumber);
  var y = exports.IMAGINARY(inumber);
  if (utils.anyIsError(x, y)) {
    return error.value;
  }

  // Return tangent of complex number
  return this.IMDIV(this.IMSIN(inumber), this.IMCOS(inumber));
};
exports.OCT2BIN = function (number, places) {
  // Return error if number is not hexadecimal or contains more than ten characters (10 digits)
  if (!/^[0-7]{1,10}$/.test(number)) {
    return error.num;
  }

  // Check if number is negative
  var negative = number.length === 10 && number.substring(0, 1) === '7' ? true : false;

  // Convert octal number to decimal
  var decimal = negative ? parseInt(number, 8) - 1073741824 : parseInt(number, 8);

  // Return error if number is lower than -512 or greater than 511
  if (decimal < -512 || decimal > 511) {
    return error.num;
  }

  // Ignore places and return a 10-character binary number if number is negative
  if (negative) {
    return '1' + text.REPT('0', 9 - (512 + decimal).toString(2).length) + (512 + decimal).toString(2);
  }

  // Convert decimal number to binary
  var result = decimal.toString(2);

  // Return binary number using the minimum number of characters necessary if places is undefined
  if (typeof places === 'undefined') {
    return result;
  } else {
    // Return error if places is nonnumeric
    if (isNaN(places)) {
      return error.value;
    }

    // Return error if places is negative
    if (places < 0) {
      return error.num;
    }

    // Truncate places in case it is not an integer
    places = Math.floor(places);

    // Pad return value with leading 0s (zeros) if necessary (using Underscore.string)
    return places >= result.length ? text.REPT('0', places - result.length) + result : error.num;
  }
};
exports.OCT2DEC = function (number) {
  // Return error if number is not octal or contains more than ten characters (10 digits)
  if (!/^[0-7]{1,10}$/.test(number)) {
    return error.num;
  }

  // Convert octal number to decimal
  var decimal = parseInt(number, 8);

  // Return decimal number
  return decimal >= 536870912 ? decimal - 1073741824 : decimal;
};
exports.OCT2HEX = function (number, places) {
  // Return error if number is not octal or contains more than ten characters (10 digits)
  if (!/^[0-7]{1,10}$/.test(number)) {
    return error.num;
  }

  // Convert octal number to decimal
  var decimal = parseInt(number, 8);

  // Ignore places and return a 10-character octal number if number is negative
  if (decimal >= 536870912) {
    return 'ff' + (decimal + 3221225472).toString(16);
  }

  // Convert decimal number to hexadecimal
  var result = decimal.toString(16);

  // Return hexadecimal number using the minimum number of characters necessary if places is undefined
  if (places === undefined) {
    return result;
  } else {
    // Return error if places is nonnumeric
    if (isNaN(places)) {
      return error.value;
    }

    // Return error if places is negative
    if (places < 0) {
      return error.num;
    }

    // Truncate places in case it is not an integer
    places = Math.floor(places);

    // Pad return value with leading 0s (zeros) if necessary (using Underscore.string)
    return places >= result.length ? text.REPT('0', places - result.length) + result : error.num;
  }
};

/***/ }),

/***/ 15154:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var error = __webpack_require__(95369);
var dateTime = __webpack_require__(88952);
var utils = __webpack_require__(30166);
function validDate(d) {
  return d && d.getTime && !isNaN(d.getTime());
}
function ensureDate(d) {
  return d instanceof Date ? d : new Date(d);
}
exports.ACCRINT = function (issue, first, settlement, rate, par, frequency, basis) {
  // Return error if either date is invalid
  issue = ensureDate(issue);
  first = ensureDate(first);
  settlement = ensureDate(settlement);
  if (!validDate(issue) || !validDate(first) || !validDate(settlement)) {
    return error.value;
  }

  // Return error if either rate or par are lower than or equal to zero
  if (rate <= 0 || par <= 0) {
    return error.num;
  }

  // Return error if frequency is neither 1, 2, or 4
  if ([1, 2, 4].indexOf(frequency) === -1) {
    return error.num;
  }

  // Return error if basis is neither 0, 1, 2, 3, or 4
  if ([0, 1, 2, 3, 4].indexOf(basis) === -1) {
    return error.num;
  }

  // Return error if settlement is before or equal to issue
  if (settlement <= issue) {
    return error.num;
  }

  // Set default values
  par = par || 0;
  basis = basis || 0;

  // Compute accrued interest
  return par * rate * dateTime.YEARFRAC(issue, settlement, basis);
};

// TODO
exports.ACCRINTM = function () {
  throw new Error('ACCRINTM is not implemented');
};

// TODO
exports.AMORDEGRC = function () {
  throw new Error('AMORDEGRC is not implemented');
};

// TODO
exports.AMORLINC = function () {
  throw new Error('AMORLINC is not implemented');
};

// TODO
exports.COUPDAYBS = function () {
  throw new Error('COUPDAYBS is not implemented');
};

// TODO
exports.COUPDAYS = function () {
  throw new Error('COUPDAYS is not implemented');
};

// TODO
exports.COUPDAYSNC = function () {
  throw new Error('COUPDAYSNC is not implemented');
};

// TODO
exports.COUPNCD = function () {
  throw new Error('COUPNCD is not implemented');
};

// TODO
exports.COUPNUM = function () {
  throw new Error('COUPNUM is not implemented');
};

// TODO
exports.COUPPCD = function () {
  throw new Error('COUPPCD is not implemented');
};
exports.CUMIPMT = function (rate, periods, value, start, end, type) {
  rate = utils.parseNumber(rate);
  periods = utils.parseNumber(periods);
  value = utils.parseNumber(value);
  if (utils.anyIsError(rate, periods, value)) {
    return error.value;
  }
  if (rate <= 0 || periods <= 0 || value <= 0) {
    return error.num;
  }
  if (start < 1 || end < 1 || start > end) {
    return error.num;
  }
  if (type !== 0 && type !== 1) {
    return error.num;
  }
  var payment = exports.PMT(rate, periods, value, 0, type);
  var interest = 0;
  if (start === 1) {
    if (type === 0) {
      interest = -value;
    }
    start++;
  }
  for (var i = start; i <= end; i++) {
    if (type === 1) {
      interest += exports.FV(rate, i - 2, payment, value, 1) - payment;
    } else {
      interest += exports.FV(rate, i - 1, payment, value, 0);
    }
  }
  interest *= rate;
  return interest;
};
exports.CUMPRINC = function (rate, periods, value, start, end, type) {
  // Credits: algorithm inspired by Apache OpenOffice
  // Credits: Hannes Stiebitzhofer for the translations of function and variable names

  rate = utils.parseNumber(rate);
  periods = utils.parseNumber(periods);
  value = utils.parseNumber(value);
  if (utils.anyIsError(rate, periods, value)) {
    return error.value;
  }

  // Return error if either rate, periods, or value are lower than or equal to zero
  if (rate <= 0 || periods <= 0 || value <= 0) {
    return error.num;
  }

  // Return error if start < 1, end < 1, or start > end
  if (start < 1 || end < 1 || start > end) {
    return error.num;
  }

  // Return error if type is neither 0 nor 1
  if (type !== 0 && type !== 1) {
    return error.num;
  }

  // Compute cumulative principal
  var payment = exports.PMT(rate, periods, value, 0, type);
  var principal = 0;
  if (start === 1) {
    if (type === 0) {
      principal = payment + value * rate;
    } else {
      principal = payment;
    }
    start++;
  }
  for (var i = start; i <= end; i++) {
    if (type > 0) {
      principal += payment - (exports.FV(rate, i - 2, payment, value, 1) - payment) * rate;
    } else {
      principal += payment - exports.FV(rate, i - 1, payment, value, 0) * rate;
    }
  }

  // Return cumulative principal
  return principal;
};
exports.DB = function (cost, salvage, life, period, month) {
  // Initialize month
  month = month === undefined ? 12 : month;
  cost = utils.parseNumber(cost);
  salvage = utils.parseNumber(salvage);
  life = utils.parseNumber(life);
  period = utils.parseNumber(period);
  month = utils.parseNumber(month);
  if (utils.anyIsError(cost, salvage, life, period, month)) {
    return error.value;
  }

  // Return error if any of the parameters is negative
  if (cost < 0 || salvage < 0 || life < 0 || period < 0) {
    return error.num;
  }

  // Return error if month is not an integer between 1 and 12
  if ([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].indexOf(month) === -1) {
    return error.num;
  }

  // Return error if period is greater than life
  if (period > life) {
    return error.num;
  }

  // Return 0 (zero) if salvage is greater than or equal to cost
  if (salvage >= cost) {
    return 0;
  }

  // Rate is rounded to three decimals places
  var rate = (1 - Math.pow(salvage / cost, 1 / life)).toFixed(3);

  // Compute initial depreciation
  var initial = cost * rate * month / 12;

  // Compute total depreciation
  var total = initial;
  var current = 0;
  var ceiling = period === life ? life - 1 : period;
  for (var i = 2; i <= ceiling; i++) {
    current = (cost - total) * rate;
    total += current;
  }

  // Depreciation for the first and last periods are special cases
  if (period === 1) {
    // First period
    return initial;
  } else if (period === life) {
    // Last period
    return (cost - total) * rate;
  } else {
    return current;
  }
};
exports.DDB = function (cost, salvage, life, period, factor) {
  // Initialize factor
  factor = factor === undefined ? 2 : factor;
  cost = utils.parseNumber(cost);
  salvage = utils.parseNumber(salvage);
  life = utils.parseNumber(life);
  period = utils.parseNumber(period);
  factor = utils.parseNumber(factor);
  if (utils.anyIsError(cost, salvage, life, period, factor)) {
    return error.value;
  }

  // Return error if any of the parameters is negative or if factor is null
  if (cost < 0 || salvage < 0 || life < 0 || period < 0 || factor <= 0) {
    return error.num;
  }

  // Return error if period is greater than life
  if (period > life) {
    return error.num;
  }

  // Return 0 (zero) if salvage is greater than or equal to cost
  if (salvage >= cost) {
    return 0;
  }

  // Compute depreciation
  var total = 0;
  var current = 0;
  for (var i = 1; i <= period; i++) {
    current = Math.min((cost - total) * (factor / life), cost - salvage - total);
    total += current;
  }

  // Return depreciation
  return current;
};

// TODO
exports.DISC = function () {
  throw new Error('DISC is not implemented');
};
exports.DOLLARDE = function (dollar, fraction) {
  // Credits: algorithm inspired by Apache OpenOffice

  dollar = utils.parseNumber(dollar);
  fraction = utils.parseNumber(fraction);
  if (utils.anyIsError(dollar, fraction)) {
    return error.value;
  }

  // Return error if fraction is negative
  if (fraction < 0) {
    return error.num;
  }

  // Return error if fraction is greater than or equal to 0 and less than 1
  if (fraction >= 0 && fraction < 1) {
    return error.div0;
  }

  // Truncate fraction if it is not an integer
  fraction = parseInt(fraction, 10);

  // Compute integer part
  var result = parseInt(dollar, 10);

  // Add decimal part
  result += dollar % 1 * Math.pow(10, Math.ceil(Math.log(fraction) / Math.LN10)) / fraction;

  // Round result
  var power = Math.pow(10, Math.ceil(Math.log(fraction) / Math.LN2) + 1);
  result = Math.round(result * power) / power;

  // Return converted dollar price
  return result;
};
exports.DOLLARFR = function (dollar, fraction) {
  // Credits: algorithm inspired by Apache OpenOffice

  dollar = utils.parseNumber(dollar);
  fraction = utils.parseNumber(fraction);
  if (utils.anyIsError(dollar, fraction)) {
    return error.value;
  }

  // Return error if fraction is negative
  if (fraction < 0) {
    return error.num;
  }

  // Return error if fraction is greater than or equal to 0 and less than 1
  if (fraction >= 0 && fraction < 1) {
    return error.div0;
  }

  // Truncate fraction if it is not an integer
  fraction = parseInt(fraction, 10);

  // Compute integer part
  var result = parseInt(dollar, 10);

  // Add decimal part
  result += dollar % 1 * Math.pow(10, -Math.ceil(Math.log(fraction) / Math.LN10)) * fraction;

  // Return converted dollar price
  return result;
};

// TODO
exports.DURATION = function () {
  throw new Error('DURATION is not implemented');
};
exports.EFFECT = function (rate, periods) {
  rate = utils.parseNumber(rate);
  periods = utils.parseNumber(periods);
  if (utils.anyIsError(rate, periods)) {
    return error.value;
  }

  // Return error if rate <=0 or periods < 1
  if (rate <= 0 || periods < 1) {
    return error.num;
  }

  // Truncate periods if it is not an integer
  periods = parseInt(periods, 10);

  // Return effective annual interest rate
  return Math.pow(1 + rate / periods, periods) - 1;
};
exports.FV = function (rate, periods, payment, value, type) {
  // Credits: algorithm inspired by Apache OpenOffice

  value = value || 0;
  type = type || 0;
  rate = utils.parseNumber(rate);
  periods = utils.parseNumber(periods);
  payment = utils.parseNumber(payment);
  value = utils.parseNumber(value);
  type = utils.parseNumber(type);
  if (utils.anyIsError(rate, periods, payment, value, type)) {
    return error.value;
  }

  // Return future value
  var result;
  if (rate === 0) {
    result = value + payment * periods;
  } else {
    var term = Math.pow(1 + rate, periods);
    if (type === 1) {
      result = value * term + payment * (1 + rate) * (term - 1) / rate;
    } else {
      result = value * term + payment * (term - 1) / rate;
    }
  }
  return -result;
};
exports.FVSCHEDULE = function (principal, schedule) {
  principal = utils.parseNumber(principal);
  schedule = utils.parseNumberArray(utils.flatten(schedule));
  if (utils.anyIsError(principal, schedule)) {
    return error.value;
  }
  var n = schedule.length;
  var future = principal;

  // Apply all interests in schedule
  for (var i = 0; i < n; i++) {
    // Apply scheduled interest
    future *= 1 + schedule[i];
  }

  // Return future value
  return future;
};

// TODO
exports.INTRATE = function () {
  throw new Error('INTRATE is not implemented');
};
exports.IPMT = function (rate, period, periods, present, future, type) {
  // Credits: algorithm inspired by Apache OpenOffice

  future = future || 0;
  type = type || 0;
  rate = utils.parseNumber(rate);
  period = utils.parseNumber(period);
  periods = utils.parseNumber(periods);
  present = utils.parseNumber(present);
  future = utils.parseNumber(future);
  type = utils.parseNumber(type);
  if (utils.anyIsError(rate, period, periods, present, future, type)) {
    return error.value;
  }

  // Compute payment
  var payment = exports.PMT(rate, periods, present, future, type);

  // Compute interest
  var interest;
  if (period === 1) {
    if (type === 1) {
      interest = 0;
    } else {
      interest = -present;
    }
  } else {
    if (type === 1) {
      interest = exports.FV(rate, period - 2, payment, present, 1) - payment;
    } else {
      interest = exports.FV(rate, period - 1, payment, present, 0);
    }
  }

  // Return interest
  return interest * rate;
};
exports.IRR = function (values, guess) {
  // Credits: algorithm inspired by Apache OpenOffice

  guess = guess || 0;
  values = utils.parseNumberArray(utils.flatten(values));
  guess = utils.parseNumber(guess);
  if (utils.anyIsError(values, guess)) {
    return error.value;
  }

  // Calculates the resulting amount
  var irrResult = function (values, dates, rate) {
    var r = rate + 1;
    var result = values[0];
    for (var i = 1; i < values.length; i++) {
      result += values[i] / Math.pow(r, (dates[i] - dates[0]) / 365);
    }
    return result;
  };

  // Calculates the first derivation
  var irrResultDeriv = function (values, dates, rate) {
    var r = rate + 1;
    var result = 0;
    for (var i = 1; i < values.length; i++) {
      var frac = (dates[i] - dates[0]) / 365;
      result -= frac * values[i] / Math.pow(r, frac + 1);
    }
    return result;
  };

  // Initialize dates and check that values contains at least one positive value and one negative value
  var dates = [];
  var positive = false;
  var negative = false;
  for (var i = 0; i < values.length; i++) {
    dates[i] = i === 0 ? 0 : dates[i - 1] + 365;
    if (values[i] > 0) {
      positive = true;
    }
    if (values[i] < 0) {
      negative = true;
    }
  }

  // Return error if values does not contain at least one positive value and one negative value
  if (!positive || !negative) {
    return error.num;
  }

  // Initialize guess and resultRate
  guess = guess === undefined ? 0.1 : guess;
  var resultRate = guess;

  // Set maximum epsilon for end of iteration
  var epsMax = 1e-10;

  // Implement Newton's method
  var newRate, epsRate, resultValue;
  var contLoop = true;
  do {
    resultValue = irrResult(values, dates, resultRate);
    newRate = resultRate - resultValue / irrResultDeriv(values, dates, resultRate);
    epsRate = Math.abs(newRate - resultRate);
    resultRate = newRate;
    contLoop = epsRate > epsMax && Math.abs(resultValue) > epsMax;
  } while (contLoop);

  // Return internal rate of return
  return resultRate;
};
exports.ISPMT = function (rate, period, periods, value) {
  rate = utils.parseNumber(rate);
  period = utils.parseNumber(period);
  periods = utils.parseNumber(periods);
  value = utils.parseNumber(value);
  if (utils.anyIsError(rate, period, periods, value)) {
    return error.value;
  }

  // Return interest
  return value * rate * (period / periods - 1);
};

// TODO
exports.MDURATION = function () {
  throw new Error('MDURATION is not implemented');
};
exports.MIRR = function (values, finance_rate, reinvest_rate) {
  values = utils.parseNumberArray(utils.flatten(values));
  finance_rate = utils.parseNumber(finance_rate);
  reinvest_rate = utils.parseNumber(reinvest_rate);
  if (utils.anyIsError(values, finance_rate, reinvest_rate)) {
    return error.value;
  }

  // Initialize number of values
  var n = values.length;

  // Lookup payments (negative values) and incomes (positive values)
  var payments = [];
  var incomes = [];
  for (var i = 0; i < n; i++) {
    if (values[i] < 0) {
      payments.push(values[i]);
    } else {
      incomes.push(values[i]);
    }
  }

  // Return modified internal rate of return
  var num = -exports.NPV(reinvest_rate, incomes) * Math.pow(1 + reinvest_rate, n - 1);
  var den = exports.NPV(finance_rate, payments) * (1 + finance_rate);
  return Math.pow(num / den, 1 / (n - 1)) - 1;
};
exports.NOMINAL = function (rate, periods) {
  rate = utils.parseNumber(rate);
  periods = utils.parseNumber(periods);
  if (utils.anyIsError(rate, periods)) {
    return error.value;
  }

  // Return error if rate <=0 or periods < 1
  if (rate <= 0 || periods < 1) {
    return error.num;
  }

  // Truncate periods if it is not an integer
  periods = parseInt(periods, 10);

  // Return nominal annual interest rate
  return (Math.pow(rate + 1, 1 / periods) - 1) * periods;
};
exports.NPER = function (rate, payment, present, future, type) {
  type = type === undefined ? 0 : type;
  future = future === undefined ? 0 : future;
  rate = utils.parseNumber(rate);
  payment = utils.parseNumber(payment);
  present = utils.parseNumber(present);
  future = utils.parseNumber(future);
  type = utils.parseNumber(type);
  if (utils.anyIsError(rate, payment, present, future, type)) {
    return error.value;
  }
  if (rate === 0) {
    return -(present + future) / payment;
  } else {
    var num = payment * (1 + rate * type) - future * rate;
    var den = present * rate + payment * (1 + rate * type);
    return Math.log(num / den) / Math.log(1 + rate);
  }
};
exports.NPV = function () {
  var args = utils.parseNumberArray(utils.flatten(arguments));
  if (args instanceof Error) {
    return args;
  }

  // Lookup rate
  var rate = args[0];

  // Initialize net present value
  var value = 0;

  // Loop on all values
  for (var j = 1; j < args.length; j++) {
    value += args[j] / Math.pow(1 + rate, j);
  }

  // Return net present value
  return value;
};

// TODO
exports.ODDFPRICE = function () {
  throw new Error('ODDFPRICE is not implemented');
};

// TODO
exports.ODDFYIELD = function () {
  throw new Error('ODDFYIELD is not implemented');
};

// TODO
exports.ODDLPRICE = function () {
  throw new Error('ODDLPRICE is not implemented');
};

// TODO
exports.ODDLYIELD = function () {
  throw new Error('ODDLYIELD is not implemented');
};
exports.PDURATION = function (rate, present, future) {
  rate = utils.parseNumber(rate);
  present = utils.parseNumber(present);
  future = utils.parseNumber(future);
  if (utils.anyIsError(rate, present, future)) {
    return error.value;
  }

  // Return error if rate <=0
  if (rate <= 0) {
    return error.num;
  }

  // Return number of periods
  return (Math.log(future) - Math.log(present)) / Math.log(1 + rate);
};
exports.PMT = function (rate, periods, present, future, type) {
  // Credits: algorithm inspired by Apache OpenOffice

  future = future || 0;
  type = type || 0;
  rate = utils.parseNumber(rate);
  periods = utils.parseNumber(periods);
  present = utils.parseNumber(present);
  future = utils.parseNumber(future);
  type = utils.parseNumber(type);
  if (utils.anyIsError(rate, periods, present, future, type)) {
    return error.value;
  }

  // Return payment
  var result;
  if (rate === 0) {
    result = (present + future) / periods;
  } else {
    var term = Math.pow(1 + rate, periods);
    if (type === 1) {
      result = (future * rate / (term - 1) + present * rate / (1 - 1 / term)) / (1 + rate);
    } else {
      result = future * rate / (term - 1) + present * rate / (1 - 1 / term);
    }
  }
  return -result;
};
exports.PPMT = function (rate, period, periods, present, future, type) {
  future = future || 0;
  type = type || 0;
  rate = utils.parseNumber(rate);
  periods = utils.parseNumber(periods);
  present = utils.parseNumber(present);
  future = utils.parseNumber(future);
  type = utils.parseNumber(type);
  if (utils.anyIsError(rate, periods, present, future, type)) {
    return error.value;
  }
  return exports.PMT(rate, periods, present, future, type) - exports.IPMT(rate, period, periods, present, future, type);
};

// TODO
exports.PRICE = function () {
  throw new Error('PRICE is not implemented');
};

// TODO
exports.PRICEDISC = function () {
  throw new Error('PRICEDISC is not implemented');
};

// TODO
exports.PRICEMAT = function () {
  throw new Error('PRICEMAT is not implemented');
};
exports.PV = function (rate, periods, payment, future, type) {
  future = future || 0;
  type = type || 0;
  rate = utils.parseNumber(rate);
  periods = utils.parseNumber(periods);
  payment = utils.parseNumber(payment);
  future = utils.parseNumber(future);
  type = utils.parseNumber(type);
  if (utils.anyIsError(rate, periods, payment, future, type)) {
    return error.value;
  }

  // Return present value
  if (rate === 0) {
    return -payment * periods - future;
  } else {
    return ((1 - Math.pow(1 + rate, periods)) / rate * payment * (1 + rate * type) - future) / Math.pow(1 + rate, periods);
  }
};
exports.RATE = function (periods, payment, present, future, type, guess) {
  guess = guess === undefined ? 0.01 : guess;
  future = future === undefined ? 0 : future;
  type = type === undefined ? 0 : type;
  periods = utils.parseNumber(periods);
  payment = utils.parseNumber(payment);
  present = utils.parseNumber(present);
  future = utils.parseNumber(future);
  type = utils.parseNumber(type);
  guess = utils.parseNumber(guess);
  if (utils.anyIsError(periods, payment, present, future, type, guess)) {
    return error.value;
  }
  var epsMax = 1e-10;
  var iterMax = 20;
  var rate = guess;
  type = type ? 1 : 0;
  for (var i = 0; i < iterMax; i++) {
    if (rate <= -1) {
      return error.num;
    }
    var y, f;
    if (Math.abs(rate) < epsMax) {
      y = present * (1 + periods * rate) + payment * (1 + rate * type) * periods + future;
    } else {
      f = Math.pow(1 + rate, periods);
      y = present * f + payment * (1 / rate + type) * (f - 1) + future;
    }
    if (Math.abs(y) < epsMax) {
      return rate;
    }
    var dy;
    if (Math.abs(rate) < epsMax) {
      dy = present * periods + payment * type * periods;
    } else {
      f = Math.pow(1 + rate, periods);
      var df = periods * Math.pow(1 + rate, periods - 1);
      dy = present * df + payment * (1 / rate + type) * df + payment * (-1 / (rate * rate)) * (f - 1);
    }
    rate -= y / dy;
  }
  return rate;
};

// TODO
exports.RECEIVED = function () {
  throw new Error('RECEIVED is not implemented');
};
exports.RRI = function (periods, present, future) {
  periods = utils.parseNumber(periods);
  present = utils.parseNumber(present);
  future = utils.parseNumber(future);
  if (utils.anyIsError(periods, present, future)) {
    return error.value;
  }

  // Return error if periods or present is equal to 0 (zero)
  if (periods === 0 || present === 0) {
    return error.num;
  }

  // Return equivalent interest rate
  return Math.pow(future / present, 1 / periods) - 1;
};
exports.SLN = function (cost, salvage, life) {
  cost = utils.parseNumber(cost);
  salvage = utils.parseNumber(salvage);
  life = utils.parseNumber(life);
  if (utils.anyIsError(cost, salvage, life)) {
    return error.value;
  }

  // Return error if life equal to 0 (zero)
  if (life === 0) {
    return error.num;
  }

  // Return straight-line depreciation
  return (cost - salvage) / life;
};
exports.SYD = function (cost, salvage, life, period) {
  // Return error if any of the parameters is not a number
  cost = utils.parseNumber(cost);
  salvage = utils.parseNumber(salvage);
  life = utils.parseNumber(life);
  period = utils.parseNumber(period);
  if (utils.anyIsError(cost, salvage, life, period)) {
    return error.value;
  }

  // Return error if life equal to 0 (zero)
  if (life === 0) {
    return error.num;
  }

  // Return error if period is lower than 1 or greater than life
  if (period < 1 || period > life) {
    return error.num;
  }

  // Truncate period if it is not an integer
  period = parseInt(period, 10);

  // Return straight-line depreciation
  return (cost - salvage) * (life - period + 1) * 2 / (life * (life + 1));
};
exports.TBILLEQ = function (settlement, maturity, discount) {
  settlement = utils.parseDate(settlement);
  maturity = utils.parseDate(maturity);
  discount = utils.parseNumber(discount);
  if (utils.anyIsError(settlement, maturity, discount)) {
    return error.value;
  }

  // Return error if discount is lower than or equal to zero
  if (discount <= 0) {
    return error.num;
  }

  // Return error if settlement is greater than maturity
  if (settlement > maturity) {
    return error.num;
  }

  // Return error if maturity is more than one year after settlement
  if (maturity - settlement > 365 * 24 * 60 * 60 * 1000) {
    return error.num;
  }

  // Return bond-equivalent yield
  return 365 * discount / (360 - discount * dateTime.DAYS360(settlement, maturity, false));
};
exports.TBILLPRICE = function (settlement, maturity, discount) {
  settlement = utils.parseDate(settlement);
  maturity = utils.parseDate(maturity);
  discount = utils.parseNumber(discount);
  if (utils.anyIsError(settlement, maturity, discount)) {
    return error.value;
  }

  // Return error if discount is lower than or equal to zero
  if (discount <= 0) {
    return error.num;
  }

  // Return error if settlement is greater than maturity
  if (settlement > maturity) {
    return error.num;
  }

  // Return error if maturity is more than one year after settlement
  if (maturity - settlement > 365 * 24 * 60 * 60 * 1000) {
    return error.num;
  }

  // Return bond-equivalent yield
  return 100 * (1 - discount * dateTime.DAYS360(settlement, maturity, false) / 360);
};
exports.TBILLYIELD = function (settlement, maturity, price) {
  settlement = utils.parseDate(settlement);
  maturity = utils.parseDate(maturity);
  price = utils.parseNumber(price);
  if (utils.anyIsError(settlement, maturity, price)) {
    return error.value;
  }

  // Return error if price is lower than or equal to zero
  if (price <= 0) {
    return error.num;
  }

  // Return error if settlement is greater than maturity
  if (settlement > maturity) {
    return error.num;
  }

  // Return error if maturity is more than one year after settlement
  if (maturity - settlement > 365 * 24 * 60 * 60 * 1000) {
    return error.num;
  }

  // Return bond-equivalent yield
  return (100 - price) * 360 / (price * dateTime.DAYS360(settlement, maturity, false));
};

// TODO
exports.VDB = function () {
  throw new Error('VDB is not implemented');
};
exports.XIRR = function (values, dates, guess) {
  // Credits: algorithm inspired by Apache OpenOffice

  values = utils.parseNumberArray(utils.flatten(values));
  dates = utils.parseDateArray(utils.flatten(dates));
  guess = utils.parseNumber(guess);
  if (utils.anyIsError(values, dates, guess)) {
    return error.value;
  }

  // Calculates the resulting amount
  var irrResult = function (values, dates, rate) {
    var r = rate + 1;
    var result = values[0];
    for (var i = 1; i < values.length; i++) {
      result += values[i] / Math.pow(r, dateTime.DAYS(dates[i], dates[0]) / 365);
    }
    return result;
  };

  // Calculates the first derivation
  var irrResultDeriv = function (values, dates, rate) {
    var r = rate + 1;
    var result = 0;
    for (var i = 1; i < values.length; i++) {
      var frac = dateTime.DAYS(dates[i], dates[0]) / 365;
      result -= frac * values[i] / Math.pow(r, frac + 1);
    }
    return result;
  };

  // Check that values contains at least one positive value and one negative value
  var positive = false;
  var negative = false;
  for (var i = 0; i < values.length; i++) {
    if (values[i] > 0) {
      positive = true;
    }
    if (values[i] < 0) {
      negative = true;
    }
  }

  // Return error if values does not contain at least one positive value and one negative value
  if (!positive || !negative) {
    return error.num;
  }

  // Initialize guess and resultRate
  guess = guess || 0.1;
  var resultRate = guess;

  // Set maximum epsilon for end of iteration
  var epsMax = 1e-10;

  // Implement Newton's method
  var newRate, epsRate, resultValue;
  var contLoop = true;
  do {
    resultValue = irrResult(values, dates, resultRate);
    newRate = resultRate - resultValue / irrResultDeriv(values, dates, resultRate);
    epsRate = Math.abs(newRate - resultRate);
    resultRate = newRate;
    contLoop = epsRate > epsMax && Math.abs(resultValue) > epsMax;
  } while (contLoop);

  // Return internal rate of return
  return resultRate;
};
exports.XNPV = function (rate, values, dates) {
  rate = utils.parseNumber(rate);
  values = utils.parseNumberArray(utils.flatten(values));
  dates = utils.parseDateArray(utils.flatten(dates));
  if (utils.anyIsError(rate, values, dates)) {
    return error.value;
  }
  var result = 0;
  for (var i = 0; i < values.length; i++) {
    result += values[i] / Math.pow(1 + rate, dateTime.DAYS(dates[i], dates[0]) / 365);
  }
  return result;
};

// TODO
exports.YIELD = function () {
  throw new Error('YIELD is not implemented');
};

// TODO
exports.YIELDDISC = function () {
  throw new Error('YIELDDISC is not implemented');
};

// TODO
exports.YIELDMAT = function () {
  throw new Error('YIELDMAT is not implemented');
};

/***/ }),

/***/ 58954:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var error = __webpack_require__(95369);

// TODO
exports.CELL = function () {
  throw new Error('CELL is not implemented');
};
exports.ERROR = {};
exports.ERROR.TYPE = function (error_val) {
  switch (error_val) {
    case error.nil:
      return 1;
    case error.div0:
      return 2;
    case error.value:
      return 3;
    case error.ref:
      return 4;
    case error.name:
      return 5;
    case error.num:
      return 6;
    case error.na:
      return 7;
    case error.data:
      return 8;
  }
  return error.na;
};

// TODO
exports.INFO = function () {
  throw new Error('INFO is not implemented');
};
exports.ISBLANK = function (value) {
  return value === null;
};
exports.ISBINARY = function (number) {
  return /^[01]{1,10}$/.test(number);
};
exports.ISERR = function (value) {
  return [error.value, error.ref, error.div0, error.num, error.name, error.nil].indexOf(value) >= 0 || typeof value === 'number' && (isNaN(value) || !isFinite(value));
};
exports.ISERROR = function (value) {
  return exports.ISERR(value) || value === error.na;
};
exports.ISEVEN = function (number) {
  return Math.floor(Math.abs(number)) & 1 ? false : true;
};

// TODO
exports.ISFORMULA = function () {
  throw new Error('ISFORMULA is not implemented');
};
exports.ISLOGICAL = function (value) {
  return value === true || value === false;
};
exports.ISNA = function (value) {
  return value === error.na;
};
exports.ISNONTEXT = function (value) {
  return typeof value !== 'string';
};
exports.ISNUMBER = function (value) {
  return typeof value === 'number' && !isNaN(value) && isFinite(value);
};
exports.ISODD = function (number) {
  return Math.floor(Math.abs(number)) & 1 ? true : false;
};

// TODO
exports.ISREF = function () {
  throw new Error('ISREF is not implemented');
};
exports.ISTEXT = function (value) {
  return typeof value === 'string';
};
exports.N = function (value) {
  if (this.ISNUMBER(value)) {
    return value;
  }
  if (value instanceof Date) {
    return value.getTime();
  }
  if (value === true) {
    return 1;
  }
  if (value === false) {
    return 0;
  }
  if (this.ISERROR(value)) {
    return value;
  }
  return 0;
};
exports.NA = function () {
  return error.na;
};

// TODO
exports.SHEET = function () {
  throw new Error('SHEET is not implemented');
};

// TODO
exports.SHEETS = function () {
  throw new Error('SHEETS is not implemented');
};
exports.TYPE = function (value) {
  if (this.ISNUMBER(value)) {
    return 1;
  }
  if (this.ISTEXT(value)) {
    return 2;
  }
  if (this.ISLOGICAL(value)) {
    return 4;
  }
  if (this.ISERROR(value)) {
    return 16;
  }
  if (Array.isArray(value)) {
    return 64;
  }
};

/***/ }),

/***/ 73020:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var error = __webpack_require__(95369);
var utils = __webpack_require__(30166);
var information = __webpack_require__(58954);
exports.AND = function () {
  var args = utils.flatten(arguments);
  var result = error.value;
  for (var i = 0; i < args.length; i++) {
    if (args[i] instanceof Error) {
      return args[i];
    }
    if (args[i] === undefined || args[i] === null || typeof args[i] === "string") {
      continue;
    }
    if (result === error.value) {
      result = true;
    }
    if (!args[i]) {
      result = false;
    }
  }
  return result;
};
exports.CHOOSE = function () {
  if (arguments.length < 2) {
    return error.na;
  }
  var index = arguments[0];
  if (index < 1 || index > 254) {
    return error.value;
  }
  if (arguments.length < index + 1) {
    return error.value;
  }
  return arguments[index];
};
exports.FALSE = function () {
  return false;
};
exports.IF = function (test, then_value, otherwise_value) {
  if (test instanceof Error) {
    return test;
  }
  then_value = arguments.length >= 2 ? then_value : true;
  if (then_value === undefined || then_value === null) {
    then_value = 0;
  }
  otherwise_value = arguments.length === 3 ? otherwise_value : false;
  if (otherwise_value === undefined || otherwise_value === null) {
    otherwise_value = 0;
  }
  return test ? then_value : otherwise_value;
};
exports.IFS = function () {
  for (var i = 0; i < arguments.length / 2; i++) {
    if (arguments[i * 2]) {
      return arguments[i * 2 + 1];
    }
  }
  return error.na;
};
exports.IFERROR = function (value, valueIfError) {
  if (information.ISERROR(value)) {
    return valueIfError;
  }
  return value;
};
exports.IFNA = function (value, value_if_na) {
  return value === error.na ? value_if_na : value;
};
exports.NOT = function (logical) {
  if (typeof logical === "string") {
    return error.value;
  }
  if (logical instanceof Error) {
    return logical;
  }
  return !logical;
};
exports.OR = function () {
  var args = utils.flatten(arguments);
  var result = error.value;
  for (var i = 0; i < args.length; i++) {
    if (args[i] instanceof Error) {
      return args[i];
    }
    if (args[i] === undefined || args[i] === null || typeof args[i] === "string") {
      continue;
    }
    if (result === error.value) {
      result = false;
    }
    if (args[i]) {
      result = true;
    }
  }
  return result;
};
exports.TRUE = function () {
  return true;
};
exports.XOR = function () {
  var args = utils.flatten(arguments);
  var result = error.value;
  for (var i = 0; i < args.length; i++) {
    if (args[i] instanceof Error) {
      return args[i];
    }
    if (args[i] === undefined || args[i] === null || typeof args[i] === "string") {
      continue;
    }
    if (result === error.value) {
      result = 0;
    }
    if (args[i]) {
      result++;
    }
  }
  if (result === error.value) {
    return result;
  }
  return Math.floor(Math.abs(result)) & 1 ? true : false;
};
exports.SWITCH = function () {
  var result;
  if (arguments.length > 0) {
    var targetValue = arguments[0];
    var argc = arguments.length - 1;
    var switchCount = Math.floor(argc / 2);
    var switchSatisfied = false;
    var hasDefaultClause = argc % 2 !== 0;
    var defaultClause = argc % 2 === 0 ? null : arguments[arguments.length - 1];
    if (switchCount) {
      for (var index = 0; index < switchCount; index++) {
        if (targetValue === arguments[index * 2 + 1]) {
          result = arguments[index * 2 + 2];
          switchSatisfied = true;
          break;
        }
      }
    }
    if (!switchSatisfied) {
      result = hasDefaultClause ? defaultClause : error.na;
    }
  } else {
    result = error.value;
  }
  return result;
};

/***/ }),

/***/ 4316:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var error = __webpack_require__(95369);
var utils = __webpack_require__(30166);
exports.MATCH = function (lookupValue, lookupArray, matchType) {
  if (!lookupValue && !lookupArray) {
    return error.na;
  }
  if (arguments.length === 2) {
    matchType = 1;
  }
  if (!(lookupArray instanceof Array)) {
    return error.na;
  }
  lookupArray = utils.flatten(lookupArray);
  if (matchType !== -1 && matchType !== 0 && matchType !== 1) {
    return error.na;
  }
  var index;
  var indexValue;
  for (var idx = 0; idx < lookupArray.length; idx++) {
    if (matchType === 1) {
      if (lookupArray[idx] === lookupValue) {
        return idx + 1;
      } else if (lookupArray[idx] < lookupValue) {
        if (!indexValue) {
          index = idx + 1;
          indexValue = lookupArray[idx];
        } else if (lookupArray[idx] > indexValue) {
          index = idx + 1;
          indexValue = lookupArray[idx];
        }
      }
    } else if (matchType === 0) {
      if (typeof lookupValue === 'string') {
        lookupValue = lookupValue.replace(/\?/g, '.');
        if (lookupArray[idx].toLowerCase().match(lookupValue.toLowerCase())) {
          return idx + 1;
        }
      } else {
        if (lookupArray[idx] === lookupValue) {
          return idx + 1;
        }
      }
    } else if (matchType === -1) {
      if (lookupArray[idx] === lookupValue) {
        return idx + 1;
      } else if (lookupArray[idx] > lookupValue) {
        if (!indexValue) {
          index = idx + 1;
          indexValue = lookupArray[idx];
        } else if (lookupArray[idx] < indexValue) {
          index = idx + 1;
          indexValue = lookupArray[idx];
        }
      }
    }
  }
  return index ? index : error.na;
};
exports.VLOOKUP = function (needle, table, index, rangeLookup) {
  if (!table || !index) {
    return error.na;
  }
  rangeLookup = !(rangeLookup === 0 || rangeLookup === false);
  var result = error.na;
  var isNumberLookup = typeof needle === "number";
  var exactMatchOnly = false;
  for (var i = 0; i < table.length; i++) {
    var row = table[i];
    if (row[0] === needle) {
      result = index < row.length + 1 ? row[index - 1] : error.ref;
      break;
    } else if (!exactMatchOnly && (isNumberLookup && rangeLookup && row[0] <= needle || rangeLookup && typeof row[0] === "string" && row[0].localeCompare(needle) < 0)) {
      result = index < row.length + 1 ? row[index - 1] : error.ref;
    }
    if (isNumberLookup && row[0] > needle) {
      exactMatchOnly = true;
    }
  }
  return result;
};
exports.HLOOKUP = function (needle, table, index, rangeLookup) {
  return exports.VLOOKUP(needle, utils.transpose(table), index, rangeLookup);
};
exports.LOOKUP = function (searchCriterion, array, resultArray) {
  array = utils.flatten(array);
  resultArray = utils.flatten(resultArray);
  var isNumberLookup = typeof searchCriterion === "number";
  var result = error.na;
  for (var i = 0; i < array.length; i++) {
    if (array[i] === searchCriterion) {
      return resultArray[i];
    } else if (isNumberLookup && array[i] <= searchCriterion || typeof array[i] === "string" && array[i].localeCompare(searchCriterion) < 0) {
      result = resultArray[i];
    } else if (isNumberLookup && array[i] > searchCriterion) {
      return result;
    }
  }
  return result;
};
exports.INDEX = function (cellRange, rowNumber, columnNumber) {
  var someError = utils.anyError(cellRange, rowNumber, columnNumber);
  if (someError) {
    return someError;
  }
  if (!Array.isArray(cellRange)) {
    return error.value;
  }
  var isOneDimensionRange = cellRange.length > 0 && !Array.isArray(cellRange[0]);
  if (isOneDimensionRange && !columnNumber) {
    columnNumber = rowNumber;
    rowNumber = 1;
  } else {
    columnNumber = columnNumber ? columnNumber : 1;
    rowNumber = rowNumber ? rowNumber : 1;
  }
  if (columnNumber < 0 || rowNumber < 0) {
    return error.value;
  }
  if (isOneDimensionRange && rowNumber === 1 && columnNumber <= cellRange.length) {
    return cellRange[columnNumber - 1];
  } else if (rowNumber <= cellRange.length && columnNumber <= cellRange[rowNumber - 1].length) {
    return cellRange[rowNumber - 1][columnNumber - 1];
  }
  return error.ref;
};

/***/ }),

/***/ 4384:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var utils = __webpack_require__(30166);
var error = __webpack_require__(95369);
var statistical = __webpack_require__(77021);
var information = __webpack_require__(58954);
var evalExpression = __webpack_require__(60001);
exports.ABS = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  var result = Math.abs(number);
  return result;
};
exports.ACOS = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  var result = Math.acos(number);
  if (isNaN(result)) {
    result = error.num;
  }
  return result;
};
exports.ACOSH = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  var result = Math.log(number + Math.sqrt(number * number - 1));
  if (isNaN(result)) {
    result = error.num;
  }
  return result;
};
exports.ACOT = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  var result = Math.atan(1 / number);
  return result;
};
exports.ACOTH = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  var result = 0.5 * Math.log((number + 1) / (number - 1));
  if (isNaN(result)) {
    result = error.num;
  }
  return result;
};

//TODO: use options
exports.AGGREGATE = function (function_num, options, ref1, ref2) {
  function_num = utils.parseNumber(function_num);
  options = utils.parseNumber(function_num);
  if (utils.anyIsError(function_num, options)) {
    return error.value;
  }
  switch (function_num) {
    case 1:
      return statistical.AVERAGE(ref1);
    case 2:
      return statistical.COUNT(ref1);
    case 3:
      return statistical.COUNTA(ref1);
    case 4:
      return statistical.MAX(ref1);
    case 5:
      return statistical.MIN(ref1);
    case 6:
      return exports.PRODUCT(ref1);
    case 7:
      return statistical.STDEV.S(ref1);
    case 8:
      return statistical.STDEV.P(ref1);
    case 9:
      return exports.SUM(ref1);
    case 10:
      return statistical.VAR.S(ref1);
    case 11:
      return statistical.VAR.P(ref1);
    case 12:
      return statistical.MEDIAN(ref1);
    case 13:
      return statistical.MODE.SNGL(ref1);
    case 14:
      return statistical.LARGE(ref1, ref2);
    case 15:
      return statistical.SMALL(ref1, ref2);
    case 16:
      return statistical.PERCENTILE.INC(ref1, ref2);
    case 17:
      return statistical.QUARTILE.INC(ref1, ref2);
    case 18:
      return statistical.PERCENTILE.EXC(ref1, ref2);
    case 19:
      return statistical.QUARTILE.EXC(ref1, ref2);
  }
};
exports.ARABIC = function (text) {
  if (text === undefined || text === null) {
    return 0;
  }
  if (text instanceof Error) {
    return text;
  }
  // Credits: Rafa? Kukawski
  if (!/^M*(?:D?C{0,3}|C[MD])(?:L?X{0,3}|X[CL])(?:V?I{0,3}|I[XV])$/.test(text)) {
    return error.value;
  }
  var r = 0;
  text.replace(/[MDLV]|C[MD]?|X[CL]?|I[XV]?/g, function (i) {
    r += {
      M: 1000,
      CM: 900,
      D: 500,
      CD: 400,
      C: 100,
      XC: 90,
      L: 50,
      XL: 40,
      X: 10,
      IX: 9,
      V: 5,
      IV: 4,
      I: 1
    }[i];
  });
  return r;
};
exports.ASIN = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  var result = Math.asin(number);
  if (isNaN(result)) {
    result = error.num;
  }
  return result;
};
exports.ASINH = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  return Math.log(number + Math.sqrt(number * number + 1));
};
exports.ATAN = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  return Math.atan(number);
};
exports.ATAN2 = function (number_x, number_y) {
  number_x = utils.parseNumber(number_x);
  number_y = utils.parseNumber(number_y);
  var anyError = utils.anyError(number_x, number_y);
  if (anyError) {
    return anyError;
  }
  return Math.atan2(number_x, number_y);
};
exports.ATANH = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  var result = Math.log((1 + number) / (1 - number)) / 2;
  if (isNaN(result)) {
    result = error.num;
  }
  return result;
};
exports.BASE = function (number, radix, min_length) {
  number = utils.parseNumber(number);
  radix = utils.parseNumber(radix);
  min_length = utils.parseNumber(min_length);
  var anyError = utils.anyError(number, radix, min_length);
  if (anyError) {
    return anyError;
  }
  if (radix === 0) {
    return error.num;
  }
  var result = number.toString(radix);
  return new Array(Math.max(min_length + 1 - result.length, 0)).join('0') + result;
};
exports.CEILING = function (number, significance, mode) {
  number = utils.parseNumber(number);
  significance = utils.parseNumber(significance);
  mode = utils.parseNumber(mode);
  var anyError = utils.anyError(number, significance, mode);
  if (anyError) {
    return anyError;
  }
  if (significance === 0) {
    return 0;
  }
  significance = Math.abs(significance);
  var precision = -Math.floor(Math.log(significance) / Math.log(10));
  if (number >= 0) {
    return exports.ROUND(Math.ceil(number / significance) * significance, precision);
  } else {
    if (mode === 0) {
      return -exports.ROUND(Math.floor(Math.abs(number) / significance) * significance, precision);
    } else {
      return -exports.ROUND(Math.ceil(Math.abs(number) / significance) * significance, precision);
    }
  }
};
exports.CEILING.MATH = exports.CEILING;
exports.CEILING.PRECISE = exports.CEILING;
exports.COMBIN = function (number, number_chosen) {
  number = utils.parseNumber(number);
  number_chosen = utils.parseNumber(number_chosen);
  var anyError = utils.anyError(number, number_chosen);
  if (anyError) {
    return anyError;
  }
  if (number < number_chosen) {
    return error.num;
  }
  return exports.FACT(number) / (exports.FACT(number_chosen) * exports.FACT(number - number_chosen));
};
exports.COMBINA = function (number, number_chosen) {
  number = utils.parseNumber(number);
  number_chosen = utils.parseNumber(number_chosen);
  var anyError = utils.anyError(number, number_chosen);
  if (anyError) {
    return anyError;
  }
  if (number < number_chosen) {
    return error.num;
  }
  return number === 0 && number_chosen === 0 ? 1 : exports.COMBIN(number + number_chosen - 1, number - 1);
};
exports.COS = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  return Math.cos(number);
};
exports.COSH = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  return (Math.exp(number) + Math.exp(-number)) / 2;
};
exports.COT = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  if (number === 0) {
    return error.div0;
  }
  return 1 / Math.tan(number);
};
exports.COTH = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  if (number === 0) {
    return error.div0;
  }
  var e2 = Math.exp(2 * number);
  return (e2 + 1) / (e2 - 1);
};
exports.CSC = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  if (number === 0) {
    return error.div0;
  }
  return 1 / Math.sin(number);
};
exports.CSCH = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  if (number === 0) {
    return error.div0;
  }
  return 2 / (Math.exp(number) - Math.exp(-number));
};
exports.DECIMAL = function (number, radix) {
  if (arguments.length < 1) {
    return error.value;
  }
  number = utils.parseNumber(number);
  radix = utils.parseNumber(radix);
  var anyError = utils.anyError(number, radix);
  if (anyError) {
    return anyError;
  }
  if (radix === 0) {
    return error.num;
  }
  return parseInt(number, radix);
};
exports.DEGREES = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  return number * 180 / Math.PI;
};
exports.EVEN = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  return exports.CEILING(number, -2, -1);
};
exports.EXP = function (number) {
  if (arguments.length < 1) {
    return error.na;
  }
  if (arguments.length > 1) {
    return error.error;
  }
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  number = Math.exp(number);
  return number;
};
var MEMOIZED_FACT = [];
exports.FACT = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  var n = Math.floor(number);
  if (n === 0 || n === 1) {
    return 1;
  } else if (MEMOIZED_FACT[n] > 0) {
    return MEMOIZED_FACT[n];
  } else {
    MEMOIZED_FACT[n] = exports.FACT(n - 1) * n;
    return MEMOIZED_FACT[n];
  }
};
exports.FACTDOUBLE = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  var n = Math.floor(number);
  if (n <= 0) {
    return 1;
  } else {
    return n * exports.FACTDOUBLE(n - 2);
  }
};
exports.FLOOR = function (number, significance) {
  number = utils.parseNumber(number);
  significance = utils.parseNumber(significance);
  var anyError = utils.anyError(number, significance);
  if (anyError) {
    return anyError;
  }
  if (significance === 0) {
    return 0;
  }
  if (!(number >= 0 && significance > 0) && !(number <= 0 && significance < 0)) {
    return error.num;
  }
  significance = Math.abs(significance);
  var precision = -Math.floor(Math.log(significance) / Math.log(10));
  if (number >= 0) {
    return exports.ROUND(Math.floor(number / significance) * significance, precision);
  } else {
    return -exports.ROUND(Math.ceil(Math.abs(number) / significance), precision);
  }
};

//TODO: Verify
exports.FLOOR.MATH = function (number, significance, mode) {
  if (significance instanceof Error) {
    return significance;
  }
  significance = significance === undefined ? 0 : significance;
  number = utils.parseNumber(number);
  significance = utils.parseNumber(significance);
  mode = utils.parseNumber(mode);
  var anyError = utils.anyError(number, significance, mode);
  if (anyError) {
    return anyError;
  }
  if (significance === 0) {
    return 0;
  }
  significance = significance ? Math.abs(significance) : 1;
  var precision = -Math.floor(Math.log(significance) / Math.log(10));
  if (number >= 0) {
    return exports.ROUND(Math.floor(number / significance) * significance, precision);
  } else if (mode === 0 || mode === undefined) {
    return -exports.ROUND(Math.ceil(Math.abs(number) / significance) * significance, precision);
  }
  return -exports.ROUND(Math.floor(Math.abs(number) / significance) * significance, precision);
};

// Deprecated
exports.FLOOR.PRECISE = exports.FLOOR.MATH;

// adapted http://rosettacode.org/wiki/Greatest_common_divisor#JavaScript
exports.GCD = function () {
  var range = utils.parseNumberArray(utils.flatten(arguments));
  if (range instanceof Error) {
    return range;
  }
  var n = range.length;
  var r0 = range[0];
  var x = r0 < 0 ? -r0 : r0;
  for (var i = 1; i < n; i++) {
    var ri = range[i];
    var y = ri < 0 ? -ri : ri;
    while (x && y) {
      if (x > y) {
        x %= y;
      } else {
        y %= x;
      }
    }
    x += y;
  }
  return x;
};
exports.INT = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  return Math.floor(number);
};

//TODO: verify
exports.ISO = {
  CEILING: exports.CEILING
};
exports.LCM = function () {
  // Credits: Jonas Raoni Soares Silva
  var o = utils.parseNumberArray(utils.flatten(arguments));
  if (o instanceof Error) {
    return o;
  }
  for (var i, j, n, d, r = 1; (n = o.pop()) !== undefined;) {
    if (n === 0) {
      return 0;
    }
    while (n > 1) {
      if (n % 2) {
        for (i = 3, j = Math.floor(Math.sqrt(n)); i <= j && n % i; i += 2) {
          //empty
        }
        d = i <= j ? i : n;
      } else {
        d = 2;
      }
      for (n /= d, r *= d, i = o.length; i; o[--i] % d === 0 && (o[i] /= d) === 1 && o.splice(i, 1)) {
        //empty
      }
    }
  }
  return r;
};
exports.LN = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  if (number === 0) {
    return error.num;
  }
  return Math.log(number);
};
exports.LN10 = function () {
  return Math.log(10);
};
exports.LN2 = function () {
  return Math.log(2);
};
exports.LOG10E = function () {
  return Math.LOG10E;
};
exports.LOG2E = function () {
  return Math.LOG2E;
};
exports.LOG = function (number, base) {
  number = utils.parseNumber(number);
  base = utils.parseNumber(base);
  var anyError = utils.anyError(number, base);
  if (anyError) {
    return anyError;
  }
  if (number === 0 || base === 0) {
    return error.num;
  }
  return Math.log(number) / Math.log(base);
};
exports.LOG10 = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  if (number === 0) {
    return error.num;
  }
  return Math.log(number) / Math.log(10);
};
exports.MOD = function (dividend, divisor) {
  dividend = utils.parseNumber(dividend);
  divisor = utils.parseNumber(divisor);
  var anyError = utils.anyError(dividend, divisor);
  if (anyError) {
    return anyError;
  }
  if (divisor === 0) {
    return error.div0;
  }
  var modulus = Math.abs(dividend % divisor);
  modulus = dividend < 0 ? divisor - modulus : modulus;
  return divisor > 0 ? modulus : -modulus;
};
exports.MROUND = function (number, multiple) {
  number = utils.parseNumber(number);
  multiple = utils.parseNumber(multiple);
  var anyError = utils.anyError(number, multiple);
  if (anyError) {
    return anyError;
  }
  if (number * multiple === 0) {
    return 0;
  }
  if (number * multiple < 0) {
    return error.num;
  }
  return Math.round(number / multiple) * multiple;
};
exports.MULTINOMIAL = function () {
  var args = utils.parseNumberArray(utils.flatten(arguments));
  if (args instanceof Error) {
    return args;
  }
  var sum = 0;
  var divisor = 1;
  for (var i = 0; i < args.length; i++) {
    sum += args[i];
    divisor *= exports.FACT(args[i]);
  }
  return exports.FACT(sum) / divisor;
};
exports.ODD = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  var temp = Math.ceil(Math.abs(number));
  temp = temp & 1 ? temp : temp + 1;
  return number >= 0 ? temp : -temp;
};
exports.PI = function () {
  return Math.PI;
};
exports.E = function () {
  return Math.E;
};
exports.POWER = function (number, power) {
  number = utils.parseNumber(number);
  power = utils.parseNumber(power);
  var anyError = utils.anyError(number, power);
  if (anyError) {
    return anyError;
  }
  if (number === 0 && power === 0) {
    return error.num;
  }
  var result = Math.pow(number, power);
  if (isNaN(result)) {
    return error.num;
  }
  return result;
};
exports.PRODUCT = function () {
  var flatArguments = utils.flatten(arguments);
  var flatArgumentsDefined = flatArguments.filter(function (arg) {
    return arg !== undefined && arg !== null;
  });
  if (flatArgumentsDefined.length === 0) {
    return 0;
  }
  var args = utils.parseNumberArray(flatArgumentsDefined);
  if (args instanceof Error) {
    return args;
  }
  var result = 1;
  for (var i = 0; i < args.length; i++) {
    result *= args[i];
  }
  return result;
};
exports.QUOTIENT = function (numerator, denominator) {
  numerator = utils.parseNumber(numerator);
  denominator = utils.parseNumber(denominator);
  var anyError = utils.anyError(numerator, denominator);
  if (anyError) {
    return anyError;
  }
  return parseInt(numerator / denominator, 10);
};
exports.RADIANS = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  return number * Math.PI / 180;
};
exports.RAND = function () {
  return Math.random();
};
exports.RANDBETWEEN = function (bottom, top) {
  bottom = utils.parseNumber(bottom);
  top = utils.parseNumber(top);
  var anyError = utils.anyError(bottom, top);
  if (anyError) {
    return anyError;
  }
  // Creative Commons Attribution 3.0 License
  // Copyright (c) 2012 eqcode
  return bottom + Math.ceil((top - bottom + 1) * Math.random()) - 1;
};

// TODO
exports.ROMAN = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  // The MIT License
  // Copyright (c) 2008 Steven Levithan
  var digits = String(number).split('');
  var key = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM', '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC', '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
  var roman = '';
  var i = 3;
  while (i--) {
    roman = (key[+digits.pop() + i * 10] || '') + roman;
  }
  return new Array(+digits.join('') + 1).join('M') + roman;
};
exports.ROUND = function (number, digits) {
  number = utils.parseNumber(number);
  digits = utils.parseNumber(digits);
  var anyError = utils.anyError(number, digits);
  if (anyError) {
    return anyError;
  }
  return Math.round(number * Math.pow(10, digits)) / Math.pow(10, digits);
};
exports.ROUNDDOWN = function (number, digits) {
  number = utils.parseNumber(number);
  digits = utils.parseNumber(digits);
  var anyError = utils.anyError(number, digits);
  if (anyError) {
    return anyError;
  }
  var sign = number > 0 ? 1 : -1;
  return sign * Math.floor(Math.abs(number) * Math.pow(10, digits)) / Math.pow(10, digits);
};
exports.ROUNDUP = function (number, digits) {
  number = utils.parseNumber(number);
  digits = utils.parseNumber(digits);
  var anyError = utils.anyError(number, digits);
  if (anyError) {
    return anyError;
  }
  var sign = number > 0 ? 1 : -1;
  return sign * Math.ceil(Math.abs(number) * Math.pow(10, digits)) / Math.pow(10, digits);
};
exports.SEC = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  return 1 / Math.cos(number);
};
exports.SECH = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  return 2 / (Math.exp(number) + Math.exp(-number));
};
exports.SERIESSUM = function (x, n, m, coefficients) {
  x = utils.parseNumber(x);
  n = utils.parseNumber(n);
  m = utils.parseNumber(m);
  coefficients = utils.parseNumberArray(coefficients);
  if (utils.anyIsError(x, n, m, coefficients)) {
    return error.value;
  }
  var result = coefficients[0] * Math.pow(x, n);
  for (var i = 1; i < coefficients.length; i++) {
    result += coefficients[i] * Math.pow(x, n + i * m);
  }
  return result;
};
exports.SIGN = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  if (number < 0) {
    return -1;
  } else if (number === 0) {
    return 0;
  } else {
    return 1;
  }
};
exports.SIN = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  return Math.sin(number);
};
exports.SINH = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  return (Math.exp(number) - Math.exp(-number)) / 2;
};
exports.SQRT = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  if (number < 0) {
    return error.num;
  }
  return Math.sqrt(number);
};
exports.SQRTPI = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  return Math.sqrt(number * Math.PI);
};
exports.SQRT1_2 = function () {
  return 1 / Math.sqrt(2);
};
exports.SQRT2 = function () {
  return Math.sqrt(2);
};
exports.SUBTOTAL = function (function_code, ref1) {
  function_code = utils.parseNumber(function_code);
  if (function_code instanceof Error) {
    return function_code;
  }
  switch (function_code) {
    case 1:
      return statistical.AVERAGE(ref1);
    case 2:
      return statistical.COUNT(ref1);
    case 3:
      return statistical.COUNTA(ref1);
    case 4:
      return statistical.MAX(ref1);
    case 5:
      return statistical.MIN(ref1);
    case 6:
      return exports.PRODUCT(ref1);
    case 7:
      return statistical.STDEV.S(ref1);
    case 8:
      return statistical.STDEV.P(ref1);
    case 9:
      return exports.SUM(ref1);
    case 10:
      return statistical.VAR.S(ref1);
    case 11:
      return statistical.VAR.P(ref1);
    // no hidden values for us
    case 101:
      return statistical.AVERAGE(ref1);
    case 102:
      return statistical.COUNT(ref1);
    case 103:
      return statistical.COUNTA(ref1);
    case 104:
      return statistical.MAX(ref1);
    case 105:
      return statistical.MIN(ref1);
    case 106:
      return exports.PRODUCT(ref1);
    case 107:
      return statistical.STDEV.S(ref1);
    case 108:
      return statistical.STDEV.P(ref1);
    case 109:
      return exports.SUM(ref1);
    case 110:
      return statistical.VAR.S(ref1);
    case 111:
      return statistical.VAR.P(ref1);
  }
};
exports.ADD = function (num1, num2) {
  if (arguments.length !== 2) {
    return error.na;
  }
  num1 = utils.parseNumber(num1);
  num2 = utils.parseNumber(num2);
  var anyError = utils.anyError(num1, num2);
  if (anyError) {
    return anyError;
  }
  return num1 + num2;
};
exports.MINUS = function (num1, num2) {
  if (arguments.length !== 2) {
    return error.na;
  }
  num1 = utils.parseNumber(num1);
  num2 = utils.parseNumber(num2);
  var anyError = utils.anyError(num1, num2);
  if (anyError) {
    return anyError;
  }
  return num1 - num2;
};
exports.DIVIDE = function (dividend, divisor) {
  if (arguments.length !== 2) {
    return error.na;
  }
  dividend = utils.parseNumber(dividend);
  divisor = utils.parseNumber(divisor);
  var anyError = utils.anyError(dividend, divisor);
  if (anyError) {
    return anyError;
  }
  if (divisor === 0) {
    return error.div0;
  }
  return dividend / divisor;
};
exports.MULTIPLY = function (factor1, factor2) {
  if (arguments.length !== 2) {
    return error.na;
  }
  factor1 = utils.parseNumber(factor1);
  factor2 = utils.parseNumber(factor2);
  var anyError = utils.anyError(factor1, factor2);
  if (anyError) {
    return anyError;
  }
  return factor1 * factor2;
};
exports.GT = function (num1, num2) {
  if (arguments.length !== 2) {
    return error.na;
  }
  if (num1 instanceof Error) {
    return num1;
  }
  if (num2 instanceof Error) {
    return num2;
  }
  if (utils.anyIsString(num1, num2)) {
    num1 = utils.parseString(num1);
    num2 = utils.parseString(num2);
  } else {
    num1 = utils.parseNumber(num1);
    num2 = utils.parseNumber(num2);
  }
  var anyError = utils.anyError(num1, num2);
  if (anyError) {
    return anyError;
  }
  return num1 > num2;
};
exports.GTE = function (num1, num2) {
  if (arguments.length !== 2) {
    return error.na;
  }
  if (utils.anyIsString(num1, num2)) {
    num1 = utils.parseString(num1);
    num2 = utils.parseString(num2);
  } else {
    num1 = utils.parseNumber(num1);
    num2 = utils.parseNumber(num2);
  }
  var anyError = utils.anyError(num1, num2);
  if (anyError) {
    return anyError;
  }
  return num1 >= num2;
};
exports.LT = function (num1, num2) {
  if (arguments.length !== 2) {
    return error.na;
  }
  if (utils.anyIsString(num1, num2)) {
    num1 = utils.parseString(num1);
    num2 = utils.parseString(num2);
  } else {
    num1 = utils.parseNumber(num1);
    num2 = utils.parseNumber(num2);
  }
  var anyError = utils.anyError(num1, num2);
  if (anyError) {
    return anyError;
  }
  return num1 < num2;
};
exports.LTE = function (num1, num2) {
  if (arguments.length !== 2) {
    return error.na;
  }
  if (utils.anyIsString(num1, num2)) {
    num1 = utils.parseString(num1);
    num2 = utils.parseString(num2);
  } else {
    num1 = utils.parseNumber(num1);
    num2 = utils.parseNumber(num2);
  }
  var anyError = utils.anyError(num1, num2);
  if (anyError) {
    return anyError;
  }
  return num1 <= num2;
};
exports.EQ = function (value1, value2) {
  if (arguments.length !== 2) {
    return error.na;
  }
  if (value1 instanceof Error) {
    return value1;
  }
  if (value2 instanceof Error) {
    return value2;
  }
  if (value1 === null) {
    value1 = undefined;
  }
  if (value2 === null) {
    value2 = undefined;
  }
  return value1 === value2;
};
exports.NE = function (value1, value2) {
  if (arguments.length !== 2) {
    return error.na;
  }
  if (value1 instanceof Error) {
    return value1;
  }
  if (value2 instanceof Error) {
    return value2;
  }
  if (value1 === null) {
    value1 = undefined;
  }
  if (value2 === null) {
    value2 = undefined;
  }
  return value1 !== value2;
};
exports.POW = function (base, exponent) {
  if (arguments.length !== 2) {
    return error.na;
  }
  return exports.POWER(base, exponent);
};
exports.SUM = function () {
  var result = 0;
  utils.arrayEach(utils.argsToArray(arguments), function (value) {
    if (result instanceof Error) {
      return false;
    } else if (value instanceof Error) {
      result = value;
    } else if (typeof value === 'number') {
      result += value;
    } else if (typeof value === 'string') {
      var parsed = parseFloat(value);
      !isNaN(parsed) && (result += parsed);
    } else if (Array.isArray(value)) {
      var inner_result = exports.SUM.apply(null, value);
      if (inner_result instanceof Error) {
        result = inner_result;
      } else {
        result += inner_result;
      }
    }
  });
  return result;
};
exports.SUMIF = function (range, criteria, sumRange) {
  range = utils.flatten(range);
  if (sumRange) {
    sumRange = utils.flatten(sumRange);
  } else {
    sumRange = range;
  }
  if (range instanceof Error) {
    return range;
  }
  if (criteria === undefined || criteria === null || criteria instanceof Error) {
    return 0;
  }
  var result = 0;
  var isWildcard = criteria === '*';
  var tokenizedCriteria = isWildcard ? null : evalExpression.parse(criteria + '');
  for (var i = 0; i < range.length; i++) {
    var value = range[i];
    var sumValue = sumRange[i];
    if (isWildcard) {
      result += value;
    } else {
      var tokens = [evalExpression.createToken(value, evalExpression.TOKEN_TYPE_LITERAL)].concat(tokenizedCriteria);
      result += evalExpression.compute(tokens) ? sumValue : 0;
    }
  }
  return result;
};
exports.SUMIFS = function () {
  var args = utils.argsToArray(arguments);
  var range = utils.parseNumberArray(utils.flatten(args.shift()));
  if (range instanceof Error) {
    return range;
  }
  var criterias = args;
  var criteriaLength = criterias.length / 2;
  for (var i = 0; i < criteriaLength; i++) {
    criterias[i * 2] = utils.flatten(criterias[i * 2]);
  }
  var result = 0;
  for (var i = 0; i < range.length; i++) {
    var isMeetCondition = false;
    for (var j = 0; j < criteriaLength; j++) {
      var valueToTest = criterias[j * 2][i];
      var criteria = criterias[j * 2 + 1];
      var isWildcard = criteria === void 0 || criteria === '*';
      var computedResult = false;
      if (isWildcard) {
        computedResult = true;
      } else {
        var tokenizedCriteria = evalExpression.parse(criteria + '');
        var tokens = [evalExpression.createToken(valueToTest, evalExpression.TOKEN_TYPE_LITERAL)].concat(tokenizedCriteria);
        computedResult = evalExpression.compute(tokens);
      }

      // Criterias are calculated as AND so any `false` breakes the loop as unmeet condition
      if (!computedResult) {
        isMeetCondition = false;
        break;
      }
      isMeetCondition = true;
    }
    if (isMeetCondition) {
      result += range[i];
    }
  }
  return result;
};
exports.SUMPRODUCT = function () {
  if (!arguments || arguments.length === 0) {
    return error.value;
  }
  var arrays = arguments.length + 1;
  var result = 0;
  var product;
  var k;
  var _i;
  var _ij;
  for (var i = 0; i < arguments[0].length; i++) {
    if (!(arguments[0][i] instanceof Array)) {
      product = 1;
      for (k = 1; k < arrays; k++) {
        var _i_arg = arguments[k - 1][i];
        if (_i_arg instanceof Error) {
          return _i_arg;
        }
        _i = utils.parseNumber(_i_arg);
        if (_i instanceof Error) {
          return _i;
        }
        product *= _i;
      }
      result += product;
    } else {
      for (var j = 0; j < arguments[0][i].length; j++) {
        product = 1;
        for (k = 1; k < arrays; k++) {
          var _ij_arg = arguments[k - 1][i][j];
          if (_ij_arg instanceof Error) {
            return _ij_arg;
          }
          _ij = utils.parseNumber(_ij_arg);
          if (_ij instanceof Error) {
            return _ij;
          }
          product *= _ij;
        }
        result += product;
      }
    }
  }
  return result;
};
exports.SUMSQ = function () {
  var numbers = utils.parseNumberArray(utils.flatten(arguments));
  if (numbers instanceof Error) {
    return numbers;
  }
  var result = 0;
  var length = numbers.length;
  for (var i = 0; i < length; i++) {
    result += information.ISNUMBER(numbers[i]) ? numbers[i] * numbers[i] : 0;
  }
  return result;
};
exports.SUMX2MY2 = function (array_x, array_y) {
  array_x = utils.parseNumberArray(utils.flatten(array_x));
  array_y = utils.parseNumberArray(utils.flatten(array_y));
  if (utils.anyIsError(array_x, array_y)) {
    return error.value;
  }
  var result = 0;
  for (var i = 0; i < array_x.length; i++) {
    result += array_x[i] * array_x[i] - array_y[i] * array_y[i];
  }
  return result;
};
exports.SUMX2PY2 = function (array_x, array_y) {
  array_x = utils.parseNumberArray(utils.flatten(array_x));
  array_y = utils.parseNumberArray(utils.flatten(array_y));
  if (utils.anyIsError(array_x, array_y)) {
    return error.value;
  }
  var result = 0;
  array_x = utils.parseNumberArray(utils.flatten(array_x));
  array_y = utils.parseNumberArray(utils.flatten(array_y));
  for (var i = 0; i < array_x.length; i++) {
    result += array_x[i] * array_x[i] + array_y[i] * array_y[i];
  }
  return result;
};
exports.SUMXMY2 = function (array_x, array_y) {
  array_x = utils.parseNumberArray(utils.flatten(array_x));
  array_y = utils.parseNumberArray(utils.flatten(array_y));
  if (utils.anyIsError(array_x, array_y)) {
    return error.value;
  }
  var result = 0;
  array_x = utils.flatten(array_x);
  array_y = utils.flatten(array_y);
  for (var i = 0; i < array_x.length; i++) {
    result += Math.pow(array_x[i] - array_y[i], 2);
  }
  return result;
};
exports.TAN = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  return Math.tan(number);
};
exports.TANH = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  var e2 = Math.exp(2 * number);
  return (e2 - 1) / (e2 + 1);
};
exports.TRUNC = function (number, digits) {
  number = utils.parseNumber(number);
  digits = utils.parseNumber(digits);
  var anyError = utils.anyError(number, digits);
  if (anyError) {
    return anyError;
  }
  var sign = number > 0 ? 1 : -1;
  return sign * Math.floor(Math.abs(number) * Math.pow(10, digits)) / Math.pow(10, digits);
};

/***/ }),

/***/ 37946:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var utils = __webpack_require__(30166);
var error = __webpack_require__(95369);
exports.UNIQUE = function () {
  var result = [];
  for (var i = 0; i < arguments.length; ++i) {
    var hasElement = false;
    var element = arguments[i];

    // Check if we've already seen this element.
    for (var j = 0; j < result.length; ++j) {
      hasElement = result[j] === element;
      if (hasElement) {
        break;
      }
    }

    // If we did not find it, add it to the result.
    if (!hasElement) {
      result.push(element);
    }
  }
  return result;
};
exports.FLATTEN = utils.flatten;
exports.ARGS2ARRAY = function () {
  return Array.prototype.slice.call(arguments, 0);
};
exports.REFERENCE = function (context, reference) {
  if (!arguments.length) {
    return error.error;
  }
  try {
    var path = reference.split('.');
    var result = context;
    for (var i = 0; i < path.length; ++i) {
      var step = path[i];
      if (step[step.length - 1] === ']') {
        var opening = step.indexOf('[');
        var index = step.substring(opening + 1, step.length - 1);
        result = result[step.substring(0, opening)][index];
      } else {
        result = result[step];
      }
    }
    return result;
  } catch (error) {}
};
exports.JOIN = function (array, separator) {
  return array.join(separator);
};
exports.NUMBERS = function () {
  var possibleNumbers = utils.flatten(arguments);
  return possibleNumbers.filter(function (el) {
    return typeof el === 'number';
  });
};

/***/ }),

/***/ 77021:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var mathTrig = __webpack_require__(4384);
var text = __webpack_require__(19593);
var jStat = __webpack_require__(24925);
var utils = __webpack_require__(30166);
var evalExpression = __webpack_require__(60001);
var error = __webpack_require__(95369);
var misc = __webpack_require__(37946);
var SQRT2PI = 2.5066282746310002;
exports.AVEDEV = function () {
  var flatArguments = utils.flatten(arguments);
  var flatArgumentsDefined = flatArguments.filter(utils.isDefined);
  if (flatArgumentsDefined.length === 0) {
    return error.num;
  }
  var range = utils.parseNumberArray(flatArgumentsDefined);
  if (range instanceof Error) {
    return range;
  }
  return jStat.sum(jStat(range).subtract(jStat.mean(range)).abs()[0]) / range.length;
};
exports.AVERAGE = function () {
  var flatArguments = utils.flatten(arguments);
  var flatArgumentsDefined = flatArguments.filter(utils.isDefined);
  if (flatArgumentsDefined.length === 0) {
    return error.div0;
  }
  var someError = utils.anyError.apply(undefined, flatArgumentsDefined);
  if (someError) {
    return someError;
  }
  var range = utils.numbers(flatArgumentsDefined);
  var n = range.length;
  var sum = 0;
  var count = 0;
  var result;
  for (var i = 0; i < n; i++) {
    sum += range[i];
    count += 1;
  }
  result = sum / count;
  if (isNaN(result)) {
    result = error.num;
  }
  return result;
};
exports.AVERAGEA = function () {
  var flatArguments = utils.flatten(arguments);
  var flatArgumentsDefined = flatArguments.filter(utils.isDefined);
  if (flatArgumentsDefined.length === 0) {
    return error.div0;
  }
  var someError = utils.anyError.apply(undefined, flatArgumentsDefined);
  if (someError) {
    return someError;
  }
  var range = flatArgumentsDefined;
  var n = range.length;
  var sum = 0;
  var count = 0;
  var result;
  for (var i = 0; i < n; i++) {
    var el = range[i];
    if (typeof el === 'number') {
      sum += el;
    }
    if (el === true) {
      sum++;
    }
    if (el !== null) {
      count++;
    }
  }
  result = sum / count;
  if (isNaN(result)) {
    result = error.num;
  }
  return result;
};
exports.AVERAGEIF = function (range, criteria, average_range) {
  if (arguments.length <= 1) {
    return error.na;
  }
  average_range = average_range || range;
  var flatAverageRange = utils.flatten(average_range);
  var flatAverageRangeDefined = flatAverageRange.filter(utils.isDefined);
  average_range = utils.parseNumberArray(flatAverageRangeDefined);
  range = utils.flatten(range);
  if (average_range instanceof Error) {
    return average_range;
  }
  var average_count = 0;
  var result = 0;
  var isWildcard = criteria === void 0 || criteria === '*';
  var tokenizedCriteria = isWildcard ? null : evalExpression.parse(criteria + '');
  for (var i = 0; i < range.length; i++) {
    var value = range[i];
    if (isWildcard) {
      result += average_range[i];
      average_count++;
    } else {
      var tokens = [evalExpression.createToken(value, evalExpression.TOKEN_TYPE_LITERAL)].concat(tokenizedCriteria);
      if (evalExpression.compute(tokens)) {
        result += average_range[i];
        average_count++;
      }
    }
  }
  return result / average_count;
};
exports.AVERAGEIFS = function () {
  // Does not work with multi dimensional ranges yet!
  // http://office.microsoft.com/en-001/excel-help/averageifs-function-HA010047493.aspx
  var args = utils.argsToArray(arguments);
  var criteriaLength = (args.length - 1) / 2;
  var range = utils.flatten(args[0]);
  var count = 0;
  var result = 0;
  for (var i = 0; i < range.length; i++) {
    var isMeetCondition = false;
    for (var j = 0; j < criteriaLength; j++) {
      var value = args[2 * j + 1][i];
      var criteria = args[2 * j + 2];
      var isWildcard = criteria === void 0 || criteria === '*';
      var computedResult = false;
      if (isWildcard) {
        computedResult = true;
      } else {
        var tokenizedCriteria = evalExpression.parse(criteria + '');
        var tokens = [evalExpression.createToken(value, evalExpression.TOKEN_TYPE_LITERAL)].concat(tokenizedCriteria);
        computedResult = evalExpression.compute(tokens);
      }

      // Criterias are calculated as AND so any `false` breakes the loop as unmeet condition
      if (!computedResult) {
        isMeetCondition = false;
        break;
      }
      isMeetCondition = true;
    }
    if (isMeetCondition) {
      result += range[i];
      count++;
    }
  }
  var average = result / count;
  if (isNaN(average)) {
    return 0;
  } else {
    return average;
  }
};
exports.BETA = {};
exports.BETA.DIST = function (x, alpha, beta, cumulative, A, B) {
  if (arguments.length < 4) {
    return error.value;
  }
  A = A === undefined ? 0 : A;
  B = B === undefined ? 1 : B;
  x = utils.parseNumber(x);
  alpha = utils.parseNumber(alpha);
  beta = utils.parseNumber(beta);
  A = utils.parseNumber(A);
  B = utils.parseNumber(B);
  if (utils.anyIsError(x, alpha, beta, A, B)) {
    return error.value;
  }
  x = (x - A) / (B - A);
  return cumulative ? jStat.beta.cdf(x, alpha, beta) : jStat.beta.pdf(x, alpha, beta);
};
exports.BETA.INV = function (probability, alpha, beta, A, B) {
  A = A === undefined ? 0 : A;
  B = B === undefined ? 1 : B;
  probability = utils.parseNumber(probability);
  alpha = utils.parseNumber(alpha);
  beta = utils.parseNumber(beta);
  A = utils.parseNumber(A);
  B = utils.parseNumber(B);
  if (utils.anyIsError(probability, alpha, beta, A, B)) {
    return error.value;
  }
  return jStat.beta.inv(probability, alpha, beta) * (B - A) + A;
};
exports.BINOM = {};
exports.BINOM.DIST = function (successes, trials, probability, cumulative) {
  successes = utils.parseNumber(successes);
  trials = utils.parseNumber(trials);
  probability = utils.parseNumber(probability);
  cumulative = utils.parseNumber(cumulative);
  if (utils.anyIsError(successes, trials, probability, cumulative)) {
    return error.value;
  }
  return cumulative ? jStat.binomial.cdf(successes, trials, probability) : jStat.binomial.pdf(successes, trials, probability);
};
exports.BINOM.DIST.RANGE = function (trials, probability, successes, successes2) {
  successes2 = successes2 === undefined ? successes : successes2;
  trials = utils.parseNumber(trials);
  probability = utils.parseNumber(probability);
  successes = utils.parseNumber(successes);
  successes2 = utils.parseNumber(successes2);
  if (utils.anyIsError(trials, probability, successes, successes2)) {
    return error.value;
  }
  var result = 0;
  for (var i = successes; i <= successes2; i++) {
    result += mathTrig.COMBIN(trials, i) * Math.pow(probability, i) * Math.pow(1 - probability, trials - i);
  }
  return result;
};
exports.BINOM.INV = function (trials, probability, alpha) {
  trials = utils.parseNumber(trials);
  probability = utils.parseNumber(probability);
  alpha = utils.parseNumber(alpha);
  if (utils.anyIsError(trials, probability, alpha)) {
    return error.value;
  }
  var x = 0;
  while (x <= trials) {
    if (jStat.binomial.cdf(x, trials, probability) >= alpha) {
      return x;
    }
    x++;
  }
};
exports.CHISQ = {};
exports.CHISQ.DIST = function (x, k, cumulative) {
  x = utils.parseNumber(x);
  k = utils.parseNumber(k);
  if (utils.anyIsError(x, k)) {
    return error.value;
  }
  return cumulative ? jStat.chisquare.cdf(x, k) : jStat.chisquare.pdf(x, k);
};
exports.CHISQ.DIST.RT = function (x, k) {
  if (!x | !k) {
    return error.na;
  }
  if (x < 1 || k > Math.pow(10, 10)) {
    return error.num;
  }
  if (typeof x !== 'number' || typeof k !== 'number') {
    return error.value;
  }
  return 1 - jStat.chisquare.cdf(x, k);
};
exports.CHISQ.INV = function (probability, k) {
  probability = utils.parseNumber(probability);
  k = utils.parseNumber(k);
  if (utils.anyIsError(probability, k)) {
    return error.value;
  }
  return jStat.chisquare.inv(probability, k);
};
exports.CHISQ.INV.RT = function (p, k) {
  if (!p | !k) {
    return error.na;
  }
  if (p < 0 || p > 1 || k < 1 || k > Math.pow(10, 10)) {
    return error.num;
  }
  if (typeof p !== 'number' || typeof k !== 'number') {
    return error.value;
  }
  return jStat.chisquare.inv(1.0 - p, k);
};
exports.CHISQ.TEST = function (observed, expected) {
  if (arguments.length !== 2) {
    return error.na;
  }
  if (!(observed instanceof Array) || !(expected instanceof Array)) {
    return error.value;
  }
  if (observed.length !== expected.length) {
    return error.value;
  }
  if (observed[0] && expected[0] && observed[0].length !== expected[0].length) {
    return error.value;
  }
  var row = observed.length;
  var tmp, i, j;

  // Convert single-dimension array into two-dimension array
  for (i = 0; i < row; i++) {
    if (!(observed[i] instanceof Array)) {
      tmp = observed[i];
      observed[i] = [];
      observed[i].push(tmp);
    }
    if (!(expected[i] instanceof Array)) {
      tmp = expected[i];
      expected[i] = [];
      expected[i].push(tmp);
    }
  }
  var col = observed[0].length;
  var dof = col === 1 ? row - 1 : (row - 1) * (col - 1);
  var xsqr = 0;
  var Pi = Math.PI;
  for (i = 0; i < row; i++) {
    for (j = 0; j < col; j++) {
      xsqr += Math.pow(observed[i][j] - expected[i][j], 2) / expected[i][j];
    }
  }

  // Get independency by X square and its degree of freedom
  function ChiSq(xsqr, dof) {
    var p = Math.exp(-0.5 * xsqr);
    if (dof % 2 === 1) {
      p = p * Math.sqrt(2 * xsqr / Pi);
    }
    var k = dof;
    while (k >= 2) {
      p = p * xsqr / k;
      k = k - 2;
    }
    var t = p;
    var a = dof;
    while (t > 0.0000000001 * p) {
      a = a + 2;
      t = t * xsqr / a;
      p = p + t;
    }
    return 1 - p;
  }
  return Math.round(ChiSq(xsqr, dof) * 1000000) / 1000000;
};
exports.COLUMN = function (matrix, index) {
  if (arguments.length !== 2) {
    return error.na;
  }
  if (index < 0) {
    return error.num;
  }
  if (!(matrix instanceof Array) || typeof index !== 'number') {
    return error.value;
  }
  if (matrix.length === 0) {
    return undefined;
  }
  return jStat.col(matrix, index);
};
exports.COLUMNS = function (matrix) {
  if (arguments.length !== 1) {
    return error.na;
  }
  if (!(matrix instanceof Array)) {
    return error.value;
  }
  if (matrix.length === 0) {
    return 0;
  }
  return jStat.cols(matrix);
};
exports.CONFIDENCE = {};
exports.CONFIDENCE.NORM = function (alpha, sd, n) {
  alpha = utils.parseNumber(alpha);
  sd = utils.parseNumber(sd);
  n = utils.parseNumber(n);
  if (utils.anyIsError(alpha, sd, n)) {
    return error.value;
  }
  return jStat.normalci(1, alpha, sd, n)[1] - 1;
};
exports.CONFIDENCE.T = function (alpha, sd, n) {
  alpha = utils.parseNumber(alpha);
  sd = utils.parseNumber(sd);
  n = utils.parseNumber(n);
  if (utils.anyIsError(alpha, sd, n)) {
    return error.value;
  }
  return jStat.tci(1, alpha, sd, n)[1] - 1;
};
exports.CORREL = function (array1, array2) {
  array1 = utils.parseNumberArray(utils.flatten(array1));
  array2 = utils.parseNumberArray(utils.flatten(array2));
  if (utils.anyIsError(array1, array2)) {
    return error.value;
  }
  return jStat.corrcoeff(array1, array2);
};
exports.COUNT = function () {
  var flatArguments = utils.flatten(arguments);
  return utils.numbers(flatArguments).length;
};
exports.COUNTA = function () {
  var flatArguments = utils.flatten(arguments);
  return flatArguments.length - exports.COUNTBLANK(flatArguments);
};
exports.COUNTIN = function (range, value) {
  var result = 0;
  range = utils.flatten(range);
  for (var i = 0; i < range.length; i++) {
    if (range[i] === value) {
      result++;
    }
  }
  return result;
};
exports.COUNTBLANK = function () {
  var range = utils.flatten(arguments);
  var blanks = 0;
  var element;
  for (var i = 0; i < range.length; i++) {
    element = range[i];
    if (element === undefined || element === null || element === '') {
      blanks++;
    }
  }
  return blanks;
};
exports.COUNTIF = function (range, criteria) {
  range = utils.flatten(range);
  var isWildcard = criteria === void 0 || criteria === '*';
  if (isWildcard) {
    return range.length;
  }
  var matches = 0;
  var tokenizedCriteria = evalExpression.parse(criteria + '');
  for (var i = 0; i < range.length; i++) {
    var value = range[i];
    var tokens = [evalExpression.createToken(value, evalExpression.TOKEN_TYPE_LITERAL)].concat(tokenizedCriteria);
    if (evalExpression.compute(tokens)) {
      matches++;
    }
  }
  return matches;
};
exports.COUNTIFS = function () {
  var args = utils.argsToArray(arguments);
  var results = new Array(utils.flatten(args[0]).length);
  for (var i = 0; i < results.length; i++) {
    results[i] = true;
  }
  for (i = 0; i < args.length; i += 2) {
    var range = utils.flatten(args[i]);
    var criteria = args[i + 1];
    var isWildcard = criteria === void 0 || criteria === '*';
    if (!isWildcard) {
      var tokenizedCriteria = evalExpression.parse(criteria + '');
      for (var j = 0; j < range.length; j++) {
        var value = range[j];
        var tokens = [evalExpression.createToken(value, evalExpression.TOKEN_TYPE_LITERAL)].concat(tokenizedCriteria);
        results[j] = results[j] && evalExpression.compute(tokens);
      }
    }
  }
  var result = 0;
  for (i = 0; i < results.length; i++) {
    if (results[i]) {
      result++;
    }
  }
  return result;
};
exports.COUNTUNIQUE = function () {
  return misc.UNIQUE.apply(null, utils.flatten(arguments)).length;
};
exports.COVARIANCE = {};
exports.COVARIANCE.P = function (array1, array2) {
  array1 = utils.parseNumberArray(utils.flatten(array1));
  array2 = utils.parseNumberArray(utils.flatten(array2));
  if (utils.anyIsError(array1, array2)) {
    return error.value;
  }
  var mean1 = jStat.mean(array1);
  var mean2 = jStat.mean(array2);
  var result = 0;
  var n = array1.length;
  for (var i = 0; i < n; i++) {
    result += (array1[i] - mean1) * (array2[i] - mean2);
  }
  return result / n;
};
exports.COVARIANCE.S = function (array1, array2) {
  array1 = utils.parseNumberArray(utils.flatten(array1));
  array2 = utils.parseNumberArray(utils.flatten(array2));
  if (utils.anyIsError(array1, array2)) {
    return error.value;
  }
  return jStat.covariance(array1, array2);
};
exports.DEVSQ = function () {
  var range = utils.parseNumberArray(utils.flatten(arguments));
  if (range instanceof Error) {
    return range;
  }
  var mean = jStat.mean(range);
  var result = 0;
  for (var i = 0; i < range.length; i++) {
    result += Math.pow(range[i] - mean, 2);
  }
  return result;
};
exports.EXPON = {};
exports.EXPON.DIST = function (x, lambda, cumulative) {
  x = utils.parseNumber(x);
  lambda = utils.parseNumber(lambda);
  if (utils.anyIsError(x, lambda)) {
    return error.value;
  }
  return cumulative ? jStat.exponential.cdf(x, lambda) : jStat.exponential.pdf(x, lambda);
};
exports.F = {};
exports.F.DIST = function (x, d1, d2, cumulative) {
  x = utils.parseNumber(x);
  d1 = utils.parseNumber(d1);
  d2 = utils.parseNumber(d2);
  if (utils.anyIsError(x, d1, d2)) {
    return error.value;
  }
  return cumulative ? jStat.centralF.cdf(x, d1, d2) : jStat.centralF.pdf(x, d1, d2);
};
exports.F.DIST.RT = function (x, d1, d2) {
  if (arguments.length !== 3) {
    return error.na;
  }
  if (x < 0 || d1 < 1 || d2 < 1) {
    return error.num;
  }
  if (typeof x !== 'number' || typeof d1 !== 'number' || typeof d2 !== 'number') {
    return error.value;
  }
  return 1 - jStat.centralF.cdf(x, d1, d2);
};
exports.F.INV = function (probability, d1, d2) {
  probability = utils.parseNumber(probability);
  d1 = utils.parseNumber(d1);
  d2 = utils.parseNumber(d2);
  if (utils.anyIsError(probability, d1, d2)) {
    return error.value;
  }
  if (probability <= 0.0 || probability > 1.0) {
    return error.num;
  }
  return jStat.centralF.inv(probability, d1, d2);
};
exports.F.INV.RT = function (p, d1, d2) {
  if (arguments.length !== 3) {
    return error.na;
  }
  if (p < 0 || p > 1 || d1 < 1 || d1 > Math.pow(10, 10) || d2 < 1 || d2 > Math.pow(10, 10)) {
    return error.num;
  }
  if (typeof p !== 'number' || typeof d1 !== 'number' || typeof d2 !== 'number') {
    return error.value;
  }
  return jStat.centralF.inv(1.0 - p, d1, d2);
};
exports.F.TEST = function (array1, array2) {
  if (!array1 || !array2) {
    return error.na;
  }
  if (!(array1 instanceof Array) || !(array2 instanceof Array)) {
    return error.na;
  }
  if (array1.length < 2 || array2.length < 2) {
    return error.div0;
  }
  var sumOfSquares = function (values, x1) {
    var sum = 0;
    for (var i = 0; i < values.length; i++) {
      sum += Math.pow(values[i] - x1, 2);
    }
    return sum;
  };
  var x1 = mathTrig.SUM(array1) / array1.length;
  var x2 = mathTrig.SUM(array2) / array2.length;
  var sum1 = sumOfSquares(array1, x1) / (array1.length - 1);
  var sum2 = sumOfSquares(array2, x2) / (array2.length - 1);
  return sum1 / sum2;
};
exports.FISHER = function (x) {
  x = utils.parseNumber(x);
  if (x instanceof Error) {
    return x;
  }
  return Math.log((1 + x) / (1 - x)) / 2;
};
exports.FISHERINV = function (y) {
  y = utils.parseNumber(y);
  if (y instanceof Error) {
    return y;
  }
  var e2y = Math.exp(2 * y);
  return (e2y - 1) / (e2y + 1);
};
exports.FORECAST = function (x, data_y, data_x) {
  x = utils.parseNumber(x);
  data_y = utils.parseNumberArray(utils.flatten(data_y));
  data_x = utils.parseNumberArray(utils.flatten(data_x));
  if (utils.anyIsError(x, data_y, data_x)) {
    return error.value;
  }
  var xmean = jStat.mean(data_x);
  var ymean = jStat.mean(data_y);
  var n = data_x.length;
  var num = 0;
  var den = 0;
  for (var i = 0; i < n; i++) {
    num += (data_x[i] - xmean) * (data_y[i] - ymean);
    den += Math.pow(data_x[i] - xmean, 2);
  }
  var b = num / den;
  var a = ymean - b * xmean;
  return a + b * x;
};
exports.FREQUENCY = function (data, bins) {
  data = utils.parseNumberArray(utils.flatten(data));
  bins = utils.parseNumberArray(utils.flatten(bins));
  if (utils.anyIsError(data, bins)) {
    return error.value;
  }
  var n = data.length;
  var b = bins.length;
  var r = [];
  for (var i = 0; i <= b; i++) {
    r[i] = 0;
    for (var j = 0; j < n; j++) {
      if (i === 0) {
        if (data[j] <= bins[0]) {
          r[0] += 1;
        }
      } else if (i < b) {
        if (data[j] > bins[i - 1] && data[j] <= bins[i]) {
          r[i] += 1;
        }
      } else if (i === b) {
        if (data[j] > bins[b - 1]) {
          r[b] += 1;
        }
      }
    }
  }
  return r;
};
exports.GAMMA = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  if (number === 0) {
    return error.num;
  }
  if (parseInt(number, 10) === number && number < 0) {
    return error.num;
  }
  return jStat.gammafn(number);
};
exports.GAMMA.DIST = function (value, alpha, beta, cumulative) {
  if (arguments.length !== 4) {
    return error.na;
  }
  if (value < 0 || alpha <= 0 || beta <= 0) {
    return error.value;
  }
  if (typeof value !== 'number' || typeof alpha !== 'number' || typeof beta !== 'number') {
    return error.value;
  }
  return cumulative ? jStat.gamma.cdf(value, alpha, beta, true) : jStat.gamma.pdf(value, alpha, beta, false);
};
exports.GAMMA.INV = function (probability, alpha, beta) {
  if (arguments.length !== 3) {
    return error.na;
  }
  if (probability < 0 || probability > 1 || alpha <= 0 || beta <= 0) {
    return error.num;
  }
  if (typeof probability !== 'number' || typeof alpha !== 'number' || typeof beta !== 'number') {
    return error.value;
  }
  return jStat.gamma.inv(probability, alpha, beta);
};
exports.GAMMALN = function (number) {
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  return jStat.gammaln(number);
};
exports.GAMMALN.PRECISE = function (x) {
  if (arguments.length !== 1) {
    return error.na;
  }
  if (x <= 0) {
    return error.num;
  }
  if (typeof x !== 'number') {
    return error.value;
  }
  return jStat.gammaln(x);
};
exports.GAUSS = function (z) {
  z = utils.parseNumber(z);
  if (z instanceof Error) {
    return z;
  }
  return jStat.normal.cdf(z, 0, 1) - 0.5;
};
exports.GEOMEAN = function () {
  var args = utils.parseNumberArray(utils.flatten(arguments));
  if (args instanceof Error) {
    return args;
  }
  return jStat.geomean(args);
};
exports.GROWTH = function (known_y, known_x, new_x, use_const) {
  // Credits: Ilmari Karonen (http://stackoverflow.com/questions/14161990/how-to-implement-growth-function-in-javascript)

  known_y = utils.parseNumberArray(known_y);
  if (known_y instanceof Error) {
    return known_y;
  }

  // Default values for optional parameters:
  var i;
  if (known_x === undefined) {
    known_x = [];
    for (i = 1; i <= known_y.length; i++) {
      known_x.push(i);
    }
  }
  if (new_x === undefined) {
    new_x = [];
    for (i = 1; i <= known_y.length; i++) {
      new_x.push(i);
    }
  }
  known_x = utils.parseNumberArray(known_x);
  new_x = utils.parseNumberArray(new_x);
  if (utils.anyIsError(known_x, new_x)) {
    return error.value;
  }
  if (use_const === undefined) {
    use_const = true;
  }

  // Calculate sums over the data:
  var n = known_y.length;
  var avg_x = 0;
  var avg_y = 0;
  var avg_xy = 0;
  var avg_xx = 0;
  for (i = 0; i < n; i++) {
    var x = known_x[i];
    var y = Math.log(known_y[i]);
    avg_x += x;
    avg_y += y;
    avg_xy += x * y;
    avg_xx += x * x;
  }
  avg_x /= n;
  avg_y /= n;
  avg_xy /= n;
  avg_xx /= n;

  // Compute linear regression coefficients:
  var beta;
  var alpha;
  if (use_const) {
    beta = (avg_xy - avg_x * avg_y) / (avg_xx - avg_x * avg_x);
    alpha = avg_y - beta * avg_x;
  } else {
    beta = avg_xy / avg_xx;
    alpha = 0;
  }

  // Compute and return result array:
  var new_y = [];
  for (i = 0; i < new_x.length; i++) {
    new_y.push(Math.exp(alpha + beta * new_x[i]));
  }
  return new_y;
};
exports.HARMEAN = function () {
  var range = utils.parseNumberArray(utils.flatten(arguments));
  if (range instanceof Error) {
    return range;
  }
  var n = range.length;
  var den = 0;
  for (var i = 0; i < n; i++) {
    den += 1 / range[i];
  }
  return n / den;
};
exports.HYPGEOM = {};
exports.HYPGEOM.DIST = function (x, n, M, N, cumulative) {
  x = utils.parseNumber(x);
  n = utils.parseNumber(n);
  M = utils.parseNumber(M);
  N = utils.parseNumber(N);
  if (utils.anyIsError(x, n, M, N)) {
    return error.value;
  }
  function pdf(x, n, M, N) {
    return mathTrig.COMBIN(M, x) * mathTrig.COMBIN(N - M, n - x) / mathTrig.COMBIN(N, n);
  }
  function cdf(x, n, M, N) {
    var result = 0;
    for (var i = 0; i <= x; i++) {
      result += pdf(i, n, M, N);
    }
    return result;
  }
  return cumulative ? cdf(x, n, M, N) : pdf(x, n, M, N);
};
exports.INTERCEPT = function (known_y, known_x) {
  known_y = utils.parseNumberArray(known_y);
  known_x = utils.parseNumberArray(known_x);
  if (utils.anyIsError(known_y, known_x)) {
    return error.value;
  }
  if (known_y.length !== known_x.length) {
    return error.na;
  }
  return exports.FORECAST(0, known_y, known_x);
};
exports.KURT = function () {
  var range = utils.parseNumberArray(utils.flatten(arguments));
  if (range instanceof Error) {
    return range;
  }
  var mean = jStat.mean(range);
  var n = range.length;
  var sigma = 0;
  for (var i = 0; i < n; i++) {
    sigma += Math.pow(range[i] - mean, 4);
  }
  sigma = sigma / Math.pow(jStat.stdev(range, true), 4);
  return n * (n + 1) / ((n - 1) * (n - 2) * (n - 3)) * sigma - 3 * (n - 1) * (n - 1) / ((n - 2) * (n - 3));
};
exports.LARGE = function (range, k) {
  range = utils.parseNumberArray(utils.flatten(range));
  k = utils.parseNumber(k);
  if (utils.anyIsError(range, k)) {
    return range;
  }
  if (k < 0 || range.length < k) {
    return error.value;
  }
  return range.sort(function (a, b) {
    return b - a;
  })[k - 1];
};
exports.LINEST = function (data_y, data_x) {
  data_y = utils.parseNumberArray(utils.flatten(data_y));
  data_x = utils.parseNumberArray(utils.flatten(data_x));
  if (utils.anyIsError(data_y, data_x)) {
    return error.value;
  }
  var ymean = jStat.mean(data_y);
  var xmean = jStat.mean(data_x);
  var n = data_x.length;
  var num = 0;
  var den = 0;
  for (var i = 0; i < n; i++) {
    num += (data_x[i] - xmean) * (data_y[i] - ymean);
    den += Math.pow(data_x[i] - xmean, 2);
  }
  var m = num / den;
  var b = ymean - m * xmean;
  return [m, b];
};

// According to Microsoft:
// http://office.microsoft.com/en-us/starter-help/logest-function-HP010342665.aspx
// LOGEST returns are based on the following linear model:
// ln y = x1 ln m1 + ... + xn ln mn + ln b
exports.LOGEST = function (data_y, data_x) {
  data_y = utils.parseNumberArray(utils.flatten(data_y));
  data_x = utils.parseNumberArray(utils.flatten(data_x));
  if (utils.anyIsError(data_y, data_x)) {
    return error.value;
  }
  for (var i = 0; i < data_y.length; i++) {
    data_y[i] = Math.log(data_y[i]);
  }
  var result = exports.LINEST(data_y, data_x);
  result[0] = Math.round(Math.exp(result[0]) * 1000000) / 1000000;
  result[1] = Math.round(Math.exp(result[1]) * 1000000) / 1000000;
  return result;
};
exports.LOGNORM = {};
exports.LOGNORM.DIST = function (x, mean, sd, cumulative) {
  x = utils.parseNumber(x);
  mean = utils.parseNumber(mean);
  sd = utils.parseNumber(sd);
  if (utils.anyIsError(x, mean, sd)) {
    return error.value;
  }
  return cumulative ? jStat.lognormal.cdf(x, mean, sd) : jStat.lognormal.pdf(x, mean, sd);
};
exports.LOGNORM.INV = function (probability, mean, sd) {
  probability = utils.parseNumber(probability);
  mean = utils.parseNumber(mean);
  sd = utils.parseNumber(sd);
  if (utils.anyIsError(probability, mean, sd)) {
    return error.value;
  }
  return jStat.lognormal.inv(probability, mean, sd);
};
exports.MAX = function () {
  var flatArguments = utils.flatten(arguments);
  var someError = utils.anyError.apply(undefined, flatArguments);
  if (someError) {
    return someError;
  }
  var range = utils.numbers(flatArguments);
  return range.length === 0 ? 0 : Math.max.apply(Math, range);
};
exports.MAXA = function () {
  var flatArguments = utils.flatten(arguments);
  var someError = utils.anyError.apply(undefined, flatArguments);
  if (someError) {
    return someError;
  }
  var range = utils.arrayValuesToNumbers(flatArguments);
  range = range.map(function (value) {
    return value === undefined || value === null ? 0 : value;
  });
  return range.length === 0 ? 0 : Math.max.apply(Math, range);
};
exports.MEDIAN = function () {
  var flatArguments = utils.flatten(arguments);
  var someError = utils.anyError.apply(undefined, flatArguments);
  if (someError) {
    return someError;
  }
  var range = utils.arrayValuesToNumbers(flatArguments);
  var result = jStat.median(range);
  if (isNaN(result)) {
    result = error.num;
  }
  return result;
};
exports.MIN = function () {
  var flatArguments = utils.flatten(arguments);
  var someError = utils.anyError.apply(undefined, flatArguments);
  if (someError) {
    return someError;
  }
  var range = utils.numbers(flatArguments);
  return range.length === 0 ? 0 : Math.min.apply(Math, range);
};
exports.MINA = function () {
  var flatArguments = utils.flatten(arguments);
  var someError = utils.anyError.apply(undefined, flatArguments);
  if (someError) {
    return someError;
  }
  var range = utils.arrayValuesToNumbers(flatArguments);
  range = range.map(function (value) {
    return value === undefined || value === null ? 0 : value;
  });
  return range.length === 0 ? 0 : Math.min.apply(Math, range);
};
exports.MODE = {};
exports.MODE.MULT = function () {
  // Credits: Roönaän
  var range = utils.parseNumberArray(utils.flatten(arguments));
  if (range instanceof Error) {
    return range;
  }
  var n = range.length;
  var count = {};
  var maxItems = [];
  var max = 0;
  var currentItem;
  for (var i = 0; i < n; i++) {
    currentItem = range[i];
    count[currentItem] = count[currentItem] ? count[currentItem] + 1 : 1;
    if (count[currentItem] > max) {
      max = count[currentItem];
      maxItems = [];
    }
    if (count[currentItem] === max) {
      maxItems[maxItems.length] = currentItem;
    }
  }
  return maxItems;
};
exports.MODE.SNGL = function () {
  var range = utils.parseNumberArray(utils.flatten(arguments));
  if (range instanceof Error) {
    return range;
  }
  return exports.MODE.MULT(range).sort(function (a, b) {
    return a - b;
  })[0];
};
exports.NEGBINOM = {};
exports.NEGBINOM.DIST = function (k, r, p, cumulative) {
  k = utils.parseNumber(k);
  r = utils.parseNumber(r);
  p = utils.parseNumber(p);
  if (utils.anyIsError(k, r, p)) {
    return error.value;
  }
  return cumulative ? jStat.negbin.cdf(k, r, p) : jStat.negbin.pdf(k, r, p);
};
exports.NORM = {};
exports.NORM.DIST = function (x, mean, sd, cumulative) {
  x = utils.parseNumber(x);
  mean = utils.parseNumber(mean);
  sd = utils.parseNumber(sd);
  if (utils.anyIsError(x, mean, sd)) {
    return error.value;
  }
  if (sd <= 0) {
    return error.num;
  }

  // Return normal distribution computed by jStat [http://jstat.org]
  return cumulative ? jStat.normal.cdf(x, mean, sd) : jStat.normal.pdf(x, mean, sd);
};
exports.NORM.INV = function (probability, mean, sd) {
  probability = utils.parseNumber(probability);
  mean = utils.parseNumber(mean);
  sd = utils.parseNumber(sd);
  if (utils.anyIsError(probability, mean, sd)) {
    return error.value;
  }
  return jStat.normal.inv(probability, mean, sd);
};
exports.NORM.S = {};
exports.NORM.S.DIST = function (z, cumulative) {
  z = utils.parseNumber(z);
  if (z instanceof Error) {
    return error.value;
  }
  return cumulative ? jStat.normal.cdf(z, 0, 1) : jStat.normal.pdf(z, 0, 1);
};
exports.NORM.S.INV = function (probability) {
  probability = utils.parseNumber(probability);
  if (probability instanceof Error) {
    return error.value;
  }
  return jStat.normal.inv(probability, 0, 1);
};
exports.PEARSON = function (data_x, data_y) {
  data_y = utils.parseNumberArray(utils.flatten(data_y));
  data_x = utils.parseNumberArray(utils.flatten(data_x));
  if (utils.anyIsError(data_y, data_x)) {
    return error.value;
  }
  var xmean = jStat.mean(data_x);
  var ymean = jStat.mean(data_y);
  var n = data_x.length;
  var num = 0;
  var den1 = 0;
  var den2 = 0;
  for (var i = 0; i < n; i++) {
    num += (data_x[i] - xmean) * (data_y[i] - ymean);
    den1 += Math.pow(data_x[i] - xmean, 2);
    den2 += Math.pow(data_y[i] - ymean, 2);
  }
  return num / Math.sqrt(den1 * den2);
};
exports.PERCENTILE = {};
exports.PERCENTILE.EXC = function (array, k) {
  array = utils.parseNumberArray(utils.flatten(array));
  k = utils.parseNumber(k);
  if (utils.anyIsError(array, k)) {
    return error.value;
  }
  array = array.sort(function (a, b) {
    {
      return a - b;
    }
  });
  var n = array.length;
  if (k < 1 / (n + 1) || k > 1 - 1 / (n + 1)) {
    return error.num;
  }
  var l = k * (n + 1) - 1;
  var fl = Math.floor(l);
  return utils.cleanFloat(l === fl ? array[l] : array[fl] + (l - fl) * (array[fl + 1] - array[fl]));
};
exports.PERCENTILE.INC = function (array, k) {
  array = utils.parseNumberArray(utils.flatten(array));
  k = utils.parseNumber(k);
  if (utils.anyIsError(array, k)) {
    return error.value;
  }
  array = array.sort(function (a, b) {
    return a - b;
  });
  var n = array.length;
  var l = k * (n - 1);
  var fl = Math.floor(l);
  return utils.cleanFloat(l === fl ? array[l] : array[fl] + (l - fl) * (array[fl + 1] - array[fl]));
};
exports.PERCENTRANK = {};
exports.PERCENTRANK.EXC = function (array, x, significance) {
  significance = significance === undefined ? 3 : significance;
  array = utils.parseNumberArray(utils.flatten(array));
  x = utils.parseNumber(x);
  significance = utils.parseNumber(significance);
  if (utils.anyIsError(array, x, significance)) {
    return error.value;
  }
  array = array.sort(function (a, b) {
    return a - b;
  });
  var uniques = misc.UNIQUE.apply(null, array);
  var n = array.length;
  var m = uniques.length;
  var power = Math.pow(10, significance);
  var result = 0;
  var match = false;
  var i = 0;
  while (!match && i < m) {
    if (x === uniques[i]) {
      result = (array.indexOf(uniques[i]) + 1) / (n + 1);
      match = true;
    } else if (x >= uniques[i] && (x < uniques[i + 1] || i === m - 1)) {
      result = (array.indexOf(uniques[i]) + 1 + (x - uniques[i]) / (uniques[i + 1] - uniques[i])) / (n + 1);
      match = true;
    }
    i++;
  }
  return Math.floor(result * power) / power;
};
exports.PERCENTRANK.INC = function (array, x, significance) {
  significance = significance === undefined ? 3 : significance;
  array = utils.parseNumberArray(utils.flatten(array));
  x = utils.parseNumber(x);
  significance = utils.parseNumber(significance);
  if (utils.anyIsError(array, x, significance)) {
    return error.value;
  }
  array = array.sort(function (a, b) {
    return a - b;
  });
  var uniques = misc.UNIQUE.apply(null, array);
  var n = array.length;
  var m = uniques.length;
  var power = Math.pow(10, significance);
  var result = 0;
  var match = false;
  var i = 0;
  while (!match && i < m) {
    if (x === uniques[i]) {
      result = array.indexOf(uniques[i]) / (n - 1);
      match = true;
    } else if (x >= uniques[i] && (x < uniques[i + 1] || i === m - 1)) {
      result = (array.indexOf(uniques[i]) + (x - uniques[i]) / (uniques[i + 1] - uniques[i])) / (n - 1);
      match = true;
    }
    i++;
  }
  return Math.floor(result * power) / power;
};
exports.PERMUT = function (number, number_chosen) {
  number = utils.parseNumber(number);
  number_chosen = utils.parseNumber(number_chosen);
  if (utils.anyIsError(number, number_chosen)) {
    return error.value;
  }
  return mathTrig.FACT(number) / mathTrig.FACT(number - number_chosen);
};
exports.PERMUTATIONA = function (number, number_chosen) {
  number = utils.parseNumber(number);
  number_chosen = utils.parseNumber(number_chosen);
  if (utils.anyIsError(number, number_chosen)) {
    return error.value;
  }
  return Math.pow(number, number_chosen);
};
exports.PHI = function (x) {
  x = utils.parseNumber(x);
  if (x instanceof Error) {
    return error.value;
  }
  return Math.exp(-0.5 * x * x) / SQRT2PI;
};
exports.POISSON = {};
exports.POISSON.DIST = function (x, mean, cumulative) {
  x = utils.parseNumber(x);
  mean = utils.parseNumber(mean);
  if (utils.anyIsError(x, mean)) {
    return error.value;
  }
  return cumulative ? jStat.poisson.cdf(x, mean) : jStat.poisson.pdf(x, mean);
};
exports.PROB = function (range, probability, lower, upper) {
  if (lower === undefined) {
    return 0;
  }
  upper = upper === undefined ? lower : upper;
  range = utils.parseNumberArray(utils.flatten(range));
  probability = utils.parseNumberArray(utils.flatten(probability));
  lower = utils.parseNumber(lower);
  upper = utils.parseNumber(upper);
  if (utils.anyIsError(range, probability, lower, upper)) {
    return error.value;
  }
  if (lower === upper) {
    return range.indexOf(lower) >= 0 ? probability[range.indexOf(lower)] : 0;
  }
  var sorted = range.sort(function (a, b) {
    return a - b;
  });
  var n = sorted.length;
  var result = 0;
  for (var i = 0; i < n; i++) {
    if (sorted[i] >= lower && sorted[i] <= upper) {
      result += probability[range.indexOf(sorted[i])];
    }
  }
  return result;
};
exports.QUARTILE = {};
exports.QUARTILE.EXC = function (range, quart) {
  range = utils.parseNumberArray(utils.flatten(range));
  quart = utils.parseNumber(quart);
  if (utils.anyIsError(range, quart)) {
    return error.value;
  }
  switch (quart) {
    case 1:
      return exports.PERCENTILE.EXC(range, 0.25);
    case 2:
      return exports.PERCENTILE.EXC(range, 0.5);
    case 3:
      return exports.PERCENTILE.EXC(range, 0.75);
    default:
      return error.num;
  }
};
exports.QUARTILE.INC = function (range, quart) {
  range = utils.parseNumberArray(utils.flatten(range));
  quart = utils.parseNumber(quart);
  if (utils.anyIsError(range, quart)) {
    return error.value;
  }
  switch (quart) {
    case 1:
      return exports.PERCENTILE.INC(range, 0.25);
    case 2:
      return exports.PERCENTILE.INC(range, 0.5);
    case 3:
      return exports.PERCENTILE.INC(range, 0.75);
    default:
      return error.num;
  }
};
exports.RANK = {};
exports.RANK.AVG = function (number, range, order) {
  number = utils.parseNumber(number);
  range = utils.parseNumberArray(utils.flatten(range));
  if (utils.anyIsError(number, range)) {
    return error.value;
  }
  range = utils.flatten(range);
  order = order || false;
  var sort = order ? function (a, b) {
    return a - b;
  } : function (a, b) {
    return b - a;
  };
  range = range.sort(sort);
  var length = range.length;
  var count = 0;
  for (var i = 0; i < length; i++) {
    if (range[i] === number) {
      count++;
    }
  }
  return count > 1 ? (2 * range.indexOf(number) + count + 1) / 2 : range.indexOf(number) + 1;
};
exports.RANK.EQ = function (number, range, order) {
  number = utils.parseNumber(number);
  range = utils.parseNumberArray(utils.flatten(range));
  if (utils.anyIsError(number, range)) {
    return error.value;
  }
  order = order || false;
  var sort = order ? function (a, b) {
    return a - b;
  } : function (a, b) {
    return b - a;
  };
  range = range.sort(sort);
  return range.indexOf(number) + 1;
};
exports.ROW = function (matrix, index) {
  if (arguments.length !== 2) {
    return error.na;
  }
  if (index < 0) {
    return error.num;
  }
  if (!(matrix instanceof Array) || typeof index !== 'number') {
    return error.value;
  }
  if (matrix.length === 0) {
    return undefined;
  }
  return jStat.row(matrix, index);
};
exports.ROWS = function (matrix) {
  if (arguments.length !== 1) {
    return error.na;
  }
  if (!(matrix instanceof Array)) {
    return error.value;
  }
  if (matrix.length === 0) {
    return 0;
  }
  return jStat.rows(matrix);
};
exports.RSQ = function (data_x, data_y) {
  // no need to flatten here, PEARSON will take care of that
  data_x = utils.parseNumberArray(utils.flatten(data_x));
  data_y = utils.parseNumberArray(utils.flatten(data_y));
  if (utils.anyIsError(data_x, data_y)) {
    return error.value;
  }
  return Math.pow(exports.PEARSON(data_x, data_y), 2);
};
exports.SKEW = function () {
  var range = utils.parseNumberArray(utils.flatten(arguments));
  if (range instanceof Error) {
    return range;
  }
  var mean = jStat.mean(range);
  var n = range.length;
  var sigma = 0;
  for (var i = 0; i < n; i++) {
    sigma += Math.pow(range[i] - mean, 3);
  }
  return n * sigma / ((n - 1) * (n - 2) * Math.pow(jStat.stdev(range, true), 3));
};
exports.SKEW.P = function () {
  var range = utils.parseNumberArray(utils.flatten(arguments));
  if (range instanceof Error) {
    return range;
  }
  var mean = jStat.mean(range);
  var n = range.length;
  var m2 = 0;
  var m3 = 0;
  for (var i = 0; i < n; i++) {
    m3 += Math.pow(range[i] - mean, 3);
    m2 += Math.pow(range[i] - mean, 2);
  }
  m3 = m3 / n;
  m2 = m2 / n;
  return m3 / Math.pow(m2, 3 / 2);
};
exports.SLOPE = function (data_y, data_x) {
  data_y = utils.parseNumberArray(utils.flatten(data_y));
  data_x = utils.parseNumberArray(utils.flatten(data_x));
  if (utils.anyIsError(data_y, data_x)) {
    return error.value;
  }
  var xmean = jStat.mean(data_x);
  var ymean = jStat.mean(data_y);
  var n = data_x.length;
  var num = 0;
  var den = 0;
  for (var i = 0; i < n; i++) {
    num += (data_x[i] - xmean) * (data_y[i] - ymean);
    den += Math.pow(data_x[i] - xmean, 2);
  }
  return num / den;
};
exports.SMALL = function (range, k) {
  range = utils.parseNumberArray(utils.flatten(range));
  k = utils.parseNumber(k);
  if (utils.anyIsError(range, k)) {
    return range;
  }
  return range.sort(function (a, b) {
    return a - b;
  })[k - 1];
};
exports.STANDARDIZE = function (x, mean, sd) {
  x = utils.parseNumber(x);
  mean = utils.parseNumber(mean);
  sd = utils.parseNumber(sd);
  if (utils.anyIsError(x, mean, sd)) {
    return error.value;
  }
  return (x - mean) / sd;
};
exports.STDEV = {};
exports.STDEV.P = function () {
  var v = exports.VAR.P.apply(this, arguments);
  var result = Math.sqrt(v);
  if (isNaN(result)) {
    result = error.num;
  }
  return result;
};
exports.STDEV.S = function () {
  var v = exports.VAR.S.apply(this, arguments);
  var result = Math.sqrt(v);
  return result;
};
exports.STDEVA = function () {
  var v = exports.VARA.apply(this, arguments);
  var result = Math.sqrt(v);
  return result;
};
exports.STDEVPA = function () {
  var v = exports.VARPA.apply(this, arguments);
  var result = Math.sqrt(v);
  if (isNaN(result)) {
    result = error.num;
  }
  return result;
};
exports.STEYX = function (data_y, data_x) {
  data_y = utils.parseNumberArray(utils.flatten(data_y));
  data_x = utils.parseNumberArray(utils.flatten(data_x));
  if (utils.anyIsError(data_y, data_x)) {
    return error.value;
  }
  var xmean = jStat.mean(data_x);
  var ymean = jStat.mean(data_y);
  var n = data_x.length;
  var lft = 0;
  var num = 0;
  var den = 0;
  for (var i = 0; i < n; i++) {
    lft += Math.pow(data_y[i] - ymean, 2);
    num += (data_x[i] - xmean) * (data_y[i] - ymean);
    den += Math.pow(data_x[i] - xmean, 2);
  }
  return Math.sqrt((lft - num * num / den) / (n - 2));
};
exports.TRANSPOSE = function (matrix) {
  if (!matrix) {
    return error.na;
  }
  return jStat.transpose(matrix);
};
exports.T = text.T;
exports.T.DIST = function (x, df, tails) {
  if (tails !== 1 && tails !== 2) {
    return error.num;
  }
  return tails === 1 ? exports.T.DIST.RT(x, df) : exports.T.DIST['2T'](x, df);
};
exports.T.DIST["2T"] = function (x, df) {
  if (arguments.length !== 2) {
    return error.na;
  }
  if (x < 0 || df < 1) {
    return error.num;
  }
  if (typeof x !== 'number' || typeof df !== 'number') {
    return error.value;
  }
  return (1 - jStat.studentt.cdf(x, df)) * 2;
};
exports.T.DIST.RT = function (x, df) {
  if (arguments.length !== 2) {
    return error.na;
  }
  if (x < 0 || df < 1) {
    return error.num;
  }
  if (typeof x !== 'number' || typeof df !== 'number') {
    return error.value;
  }
  return 1 - jStat.studentt.cdf(x, df);
};
exports.T.INV = function (probability, df) {
  probability = utils.parseNumber(probability);
  df = utils.parseNumber(df);
  if (utils.anyIsError(probability, df)) {
    return error.value;
  }
  return jStat.studentt.inv(probability, df);
};
exports.T.INV["2T"] = function (probability, df) {
  probability = utils.parseNumber(probability);
  df = utils.parseNumber(df);
  if (probability <= 0 || probability > 1 || df < 1) {
    return error.num;
  }
  if (utils.anyIsError(probability, df)) {
    return error.value;
  }
  return Math.abs(jStat.studentt.inv(probability / 2, df));
};

// The algorithm can be found here:
// http://www.chem.uoa.gr/applets/AppletTtest/Appl_Ttest2.html
exports.T.TEST = function (data_x, data_y) {
  data_x = utils.parseNumberArray(utils.flatten(data_x));
  data_y = utils.parseNumberArray(utils.flatten(data_y));
  if (utils.anyIsError(data_x, data_y)) {
    return error.value;
  }
  var mean_x = jStat.mean(data_x);
  var mean_y = jStat.mean(data_y);
  var s_x = 0;
  var s_y = 0;
  var i;
  for (i = 0; i < data_x.length; i++) {
    s_x += Math.pow(data_x[i] - mean_x, 2);
  }
  for (i = 0; i < data_y.length; i++) {
    s_y += Math.pow(data_y[i] - mean_y, 2);
  }
  s_x = s_x / (data_x.length - 1);
  s_y = s_y / (data_y.length - 1);
  var t = Math.abs(mean_x - mean_y) / Math.sqrt(s_x / data_x.length + s_y / data_y.length);
  return exports.T.DIST['2T'](t, data_x.length + data_y.length - 2);
};
exports.TREND = function (data_y, data_x, new_data_x) {
  data_y = utils.parseNumberArray(utils.flatten(data_y));
  data_x = utils.parseNumberArray(utils.flatten(data_x));
  new_data_x = utils.parseNumberArray(utils.flatten(new_data_x));
  if (utils.anyIsError(data_y, data_x, new_data_x)) {
    return error.value;
  }
  var linest = exports.LINEST(data_y, data_x);
  var m = linest[0];
  var b = linest[1];
  var result = [];
  new_data_x.forEach(function (x) {
    result.push(m * x + b);
  });
  return result;
};
exports.TRIMMEAN = function (range, percent) {
  range = utils.parseNumberArray(utils.flatten(range));
  percent = utils.parseNumber(percent);
  if (utils.anyIsError(range, percent)) {
    return error.value;
  }
  var trim = mathTrig.FLOOR(range.length * percent, 2) / 2;
  return jStat.mean(utils.initial(utils.rest(range.sort(function (a, b) {
    return a - b;
  }), trim), trim));
};
exports.VAR = {};
exports.VAR.P = function () {
  var range = utils.numbers(utils.flatten(arguments));
  var n = range.length;
  var sigma = 0;
  var mean = exports.AVERAGE(range);
  var result;
  for (var i = 0; i < n; i++) {
    sigma += Math.pow(range[i] - mean, 2);
  }
  result = sigma / n;
  if (isNaN(result)) {
    result = error.num;
  }
  return result;
};
exports.VAR.S = function () {
  var range = utils.numbers(utils.flatten(arguments));
  var n = range.length;
  var sigma = 0;
  var mean = exports.AVERAGE(range);
  for (var i = 0; i < n; i++) {
    sigma += Math.pow(range[i] - mean, 2);
  }
  return sigma / (n - 1);
};
exports.VARA = function () {
  var range = utils.flatten(arguments);
  var n = range.length;
  var sigma = 0;
  var count = 0;
  var mean = exports.AVERAGEA(range);
  for (var i = 0; i < n; i++) {
    var el = range[i];
    if (typeof el === 'number') {
      sigma += Math.pow(el - mean, 2);
    } else if (el === true) {
      sigma += Math.pow(1 - mean, 2);
    } else {
      sigma += Math.pow(0 - mean, 2);
    }
    if (el !== null) {
      count++;
    }
  }
  return sigma / (count - 1);
};
exports.VARPA = function () {
  var range = utils.flatten(arguments);
  var n = range.length;
  var sigma = 0;
  var count = 0;
  var mean = exports.AVERAGEA(range);
  var result;
  for (var i = 0; i < n; i++) {
    var el = range[i];
    if (typeof el === 'number') {
      sigma += Math.pow(el - mean, 2);
    } else if (el === true) {
      sigma += Math.pow(1 - mean, 2);
    } else {
      sigma += Math.pow(0 - mean, 2);
    }
    if (el !== null) {
      count++;
    }
  }
  result = sigma / count;
  if (isNaN(result)) {
    result = error.num;
  }
  return result;
};
exports.WEIBULL = {};
exports.WEIBULL.DIST = function (x, alpha, beta, cumulative) {
  x = utils.parseNumber(x);
  alpha = utils.parseNumber(alpha);
  beta = utils.parseNumber(beta);
  if (utils.anyIsError(x, alpha, beta)) {
    return error.value;
  }
  return cumulative ? 1 - Math.exp(-Math.pow(x / beta, alpha)) : Math.pow(x, alpha - 1) * Math.exp(-Math.pow(x / beta, alpha)) * alpha / Math.pow(beta, alpha);
};
exports.Z = {};
exports.Z.TEST = function (range, x, sd) {
  range = utils.parseNumberArray(utils.flatten(range));
  x = utils.parseNumber(x);
  if (utils.anyIsError(range, x)) {
    return error.value;
  }
  sd = sd || exports.STDEV.S(range);
  var n = range.length;
  return 1 - exports.NORM.S.DIST((exports.AVERAGE(range) - x) / (sd / Math.sqrt(n)), true);
};

/***/ }),

/***/ 19593:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var utils = __webpack_require__(30166);
var error = __webpack_require__(95369);

//TODO
exports.ASC = function () {
  throw new Error('ASC is not implemented');
};

//TODO
exports.BAHTTEXT = function () {
  throw new Error('BAHTTEXT is not implemented');
};
exports.CHAR = function (number) {
  number = utils.parseNumber(number);
  if (number === 0) {
    return error.value;
  }
  if (number instanceof Error) {
    return number;
  }
  return String.fromCharCode(number);
};
exports.CLEAN = function (text) {
  if (utils.anyIsError(text)) {
    return text;
  }
  text = text || '';
  var re = /[\0-\x1F]/g;
  return text.replace(re, "");
};
exports.CODE = function (text) {
  if (utils.anyIsError(text)) {
    return text;
  }
  text = text || '';
  var result = text.charCodeAt(0);
  if (isNaN(result)) {
    result = error.value;
  }
  return result;
};
exports.CONCATENATE = function () {
  var args = utils.flatten(arguments);
  var someError = utils.anyError.apply(undefined, args);
  if (someError) {
    return someError;
  }
  var trueFound = 0;
  while ((trueFound = args.indexOf(true)) > -1) {
    args[trueFound] = 'TRUE';
  }
  var falseFound = 0;
  while ((falseFound = args.indexOf(false)) > -1) {
    args[falseFound] = 'FALSE';
  }
  return args.join('');
};
exports.CONCAT = exports.CONCATENATE;

//TODO
exports.DBCS = function () {
  throw new Error('DBCS is not implemented');
};

//TODO
exports.DOLLAR = function () {
  throw new Error('DOLLAR is not implemented');
};
exports.EXACT = function (text1, text2) {
  if (arguments.length !== 2) {
    return error.na;
  }
  var someError = utils.anyError(text1, text2);
  if (someError) {
    return someError;
  }
  text1 = utils.parseString(text1);
  text2 = utils.parseString(text2);
  return text1 === text2;
};
exports.FIND = function (find_text, within_text, position) {
  if (arguments.length < 2) {
    return error.na;
  }
  find_text = utils.parseString(find_text);
  within_text = utils.parseString(within_text);
  position = position === undefined ? 0 : position;
  var found_index = within_text.indexOf(find_text, position - 1);
  if (found_index === -1) {
    return error.value;
  }
  return found_index + 1;
};

//TODO
exports.FIXED = function () {
  throw new Error('FIXED is not implemented');
};
exports.HTML2TEXT = function (value) {
  if (utils.anyIsError(value)) {
    return value;
  }
  var result = '';
  if (value) {
    if (value instanceof Array) {
      value.forEach(function (line) {
        if (result !== '') {
          result += '\n';
        }
        result += line.replace(/<(?:.|\n)*?>/gm, '');
      });
    } else {
      result = value.replace(/<(?:.|\n)*?>/gm, '');
    }
  }
  return result;
};
exports.LEFT = function (text, number) {
  var someError = utils.anyError(text, number);
  if (someError) {
    return someError;
  }
  text = utils.parseString(text);
  number = number === undefined ? 1 : number;
  number = utils.parseNumber(number);
  if (number instanceof Error || typeof text !== 'string') {
    return error.value;
  }
  return text.substring(0, number);
};
exports.LEN = function (text) {
  if (arguments.length === 0) {
    return error.error;
  }
  if (text instanceof Error) {
    return text;
  }
  if (Array.isArray(text)) {
    return error.value;
  }
  var textAsString = utils.parseString(text);
  return textAsString.length;
};
exports.LOWER = function (text) {
  if (arguments.length !== 1) {
    return error.value;
  }
  text = utils.parseString(text);
  if (utils.anyIsError(text)) {
    return text;
  }
  return text.toLowerCase();
};
exports.MID = function (text, start, number) {
  if (start === undefined || start === null) {
    return error.value;
  }
  start = utils.parseNumber(start);
  number = utils.parseNumber(number);
  if (utils.anyIsError(start, number) || typeof text !== 'string') {
    return number;
  }
  var begin = start - 1;
  var end = begin + number;
  return text.substring(begin, end);
};

// TODO
exports.NUMBERVALUE = function (text, decimal_separator, group_separator) {
  decimal_separator = typeof decimal_separator === 'undefined' ? '.' : decimal_separator;
  group_separator = typeof group_separator === 'undefined' ? ',' : group_separator;
  return Number(text.replace(decimal_separator, '.').replace(group_separator, ''));
};

// TODO
exports.PRONETIC = function () {
  throw new Error('PRONETIC is not implemented');
};
exports.PROPER = function (text) {
  if (utils.anyIsError(text)) {
    return text;
  }
  if (isNaN(text) && typeof text === 'number') {
    return error.value;
  }
  text = utils.parseString(text);
  return text.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};
exports.REGEXEXTRACT = function (text, regular_expression) {
  if (arguments.length < 2) {
    return error.na;
  }
  var match = text.match(new RegExp(regular_expression));
  return match ? match[match.length > 1 ? match.length - 1 : 0] : null;
};
exports.REGEXMATCH = function (text, regular_expression, full) {
  if (arguments.length < 2) {
    return error.na;
  }
  var match = text.match(new RegExp(regular_expression));
  return full ? match : !!match;
};
exports.REGEXREPLACE = function (text, regular_expression, replacement) {
  if (arguments.length < 3) {
    return error.na;
  }
  return text.replace(new RegExp(regular_expression), replacement);
};
exports.REPLACE = function (text, position, length, new_text) {
  position = utils.parseNumber(position);
  length = utils.parseNumber(length);
  if (utils.anyIsError(position, length) || typeof text !== 'string' || typeof new_text !== 'string') {
    return error.value;
  }
  return text.substr(0, position - 1) + new_text + text.substr(position - 1 + length);
};
exports.REPT = function (text, number) {
  var someError = utils.anyError(text, number);
  if (someError) {
    return someError;
  }
  text = utils.parseString(text);
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  return new Array(number + 1).join(text);
};
exports.RIGHT = function (text, number) {
  var someError = utils.anyError(text, number);
  if (someError) {
    return someError;
  }
  text = utils.parseString(text);
  number = number === undefined ? 1 : number;
  number = utils.parseNumber(number);
  if (number instanceof Error) {
    return number;
  }
  return text.substring(text.length - number);
};
exports.SEARCH = function (find_text, within_text, position) {
  var foundAt;
  if (typeof find_text !== 'string' || typeof within_text !== 'string') {
    return error.value;
  }
  position = position === undefined ? 0 : position;
  foundAt = within_text.toLowerCase().indexOf(find_text.toLowerCase(), position - 1) + 1;
  return foundAt === 0 ? error.value : foundAt;
};
exports.SPLIT = function (text, separator) {
  return text.split(separator);
};
exports.SUBSTITUTE = function (text, old_text, new_text, occurrence) {
  if (arguments.length < 3) {
    return error.na;
  }
  if (!text || !old_text) {
    return text;
  } else if (occurrence === undefined) {
    return text.split(old_text).join(new_text);
  } else {
    occurrence = Math.floor(Number(occurrence));
    if (Number.isNaN(occurrence) || occurrence <= 0) {
      return error.value;
    }
    var index = 0;
    var i = 0;
    while (index > -1 && text.indexOf(old_text, index) > -1) {
      index = text.indexOf(old_text, index + 1);
      i++;
      if (index > -1 && i === occurrence) {
        return text.substring(0, index) + new_text + text.substring(index + old_text.length);
      }
    }
    return text;
  }
};
exports.T = function (value) {
  if (value instanceof Error) {
    return value;
  }
  return typeof value === "string" ? value : '';
};

// TODO incomplete implementation
exports.TEXT = function () {
  throw new Error('TEXT is not implemented');
};
exports.TRIM = function (text) {
  text = utils.parseString(text);
  if (text instanceof Error) {
    return text;
  }
  return text.replace(/\s+/g, ' ').trim();
};
exports.UNICHAR = exports.CHAR;
exports.UNICODE = exports.CODE;
exports.UPPER = function (text) {
  text = utils.parseString(text);
  if (text instanceof Error) {
    return text;
  }
  return text.toUpperCase();
};
exports.VALUE = function (num) {
  var anyError = utils.anyError(num);
  if (anyError) {
    return anyError;
  }
  if (typeof num !== 'string') {
    return error.value;
  }
  var isPercent = /(%)$/.test(num) || /^(%)/.test(num);
  num = num.replace(/^[^0-9-]{0,3}/, '');
  num = num.replace(/[^0-9]{0,3}$/, '');
  num = num.replace(/[\ ,]/g, '');
  if (num === '') {
    return error.value;
  }
  var output = Number(num);
  if (isNaN(output)) {
    return error.value;
  }
  output = output || 0;
  if (isPercent) {
    output = output * 0.01;
  }
  return output;
};

/***/ }),

/***/ 30166:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var error = __webpack_require__(95369);
exports.flattenShallow = function (array) {
  if (!array || !array.reduce) {
    return array;
  }
  return array.reduce(function (a, b) {
    var aIsArray = Array.isArray(a);
    var bIsArray = Array.isArray(b);
    if (aIsArray && bIsArray) {
      return a.concat(b);
    }
    if (aIsArray) {
      a.push(b);
      return a;
    }
    if (bIsArray) {
      return [a].concat(b);
    }
    return [a, b];
  });
};
exports.isFlat = function (array) {
  if (!array) {
    return false;
  }
  for (var i = 0; i < array.length; ++i) {
    if (Array.isArray(array[i])) {
      return false;
    }
  }
  return true;
};
exports.flatten = function () {
  var result = exports.argsToArray.apply(null, arguments);
  while (!exports.isFlat(result)) {
    result = exports.flattenShallow(result);
  }
  return result;
};
exports.argsToArray = function (args) {
  var result = [];
  exports.arrayEach(args, function (value) {
    result.push(value);
  });
  return result;
};
exports.numbers = function () {
  var possibleNumbers = this.flatten.apply(null, arguments);
  return possibleNumbers.filter(function (el) {
    return typeof el === 'number';
  });
};
exports.cleanFloat = function (number) {
  var power = 1e14;
  return Math.round(number * power) / power;
};
exports.parseBool = function (bool) {
  if (typeof bool === 'boolean') {
    return bool;
  }
  if (bool instanceof Error) {
    return bool;
  }
  if (typeof bool === 'number') {
    return bool !== 0;
  }
  if (typeof bool === 'string') {
    var up = bool.toUpperCase();
    if (up === 'TRUE') {
      return true;
    }
    if (up === 'FALSE') {
      return false;
    }
  }
  if (bool instanceof Date && !isNaN(bool)) {
    return true;
  }
  return error.value;
};
exports.parseNumber = function (string) {
  if (string instanceof Error) {
    return string;
  }
  if (string === undefined || string === null || string === '') {
    return 0;
  }
  if (typeof string === "boolean") {
    string = +string;
  }
  if (!isNaN(string)) {
    return parseFloat(string);
  }
  return error.value;
};
exports.parseString = function (string) {
  if (string instanceof Error) {
    return string;
  }
  if (string === undefined || string === null) {
    return '';
  }
  return string.toString();
};
exports.parseNumberArray = function (arr) {
  var len;
  if (!arr || (len = arr.length) === 0) {
    return error.value;
  }
  var parsed;
  while (len--) {
    if (arr[len] instanceof Error) {
      return arr[len];
    }
    parsed = exports.parseNumber(arr[len]);
    if (parsed instanceof Error) {
      return parsed;
    }
    arr[len] = parsed;
  }
  return arr;
};
exports.parseMatrix = function (matrix) {
  var n;
  if (!matrix || (n = matrix.length) === 0) {
    return error.value;
  }
  var pnarr;
  for (var i = 0; i < matrix.length; i++) {
    pnarr = exports.parseNumberArray(matrix[i]);
    matrix[i] = pnarr;
    if (pnarr instanceof Error) {
      return pnarr;
    }
  }
  return matrix;
};
function serialNumberToDate(serial) {
  if (serial < 60) {
    serial += 1;
  }
  var utc_days = Math.floor(serial - 25569);
  var utc_value = utc_days * 86400;
  var date_info = new Date(utc_value * 1000);
  var fractional_day = serial - Math.floor(serial) + 0.0000001;
  var total_seconds = Math.floor(86400 * fractional_day);
  var seconds = total_seconds % 60;
  total_seconds -= seconds;
  var hours = Math.floor(total_seconds / (60 * 60));
  var minutes = Math.floor(total_seconds / 60) % 60;
  var days = date_info.getDate();
  var month = date_info.getMonth();
  if (serial >= 60 && serial < 61) {
    var days = 29;
    var month = 1;
  }
  return new Date(date_info.getFullYear(), month, days, hours, minutes, seconds);
}
exports.parseDate = function (date) {
  if (!isNaN(date)) {
    if (date instanceof Date) {
      return new Date(date);
    }
    var d = parseFloat(date);
    if (d < 0 || d >= 2958466) {
      return error.num;
    }
    return serialNumberToDate(d);
  }
  if (typeof date === 'string') {
    date = new Date(date);
    if (!isNaN(date)) {
      return date;
    }
  }
  return error.value;
};
exports.parseDateArray = function (arr) {
  var len = arr.length;
  var parsed;
  while (len--) {
    parsed = this.parseDate(arr[len]);
    if (parsed === error.value) {
      return parsed;
    }
    arr[len] = parsed;
  }
  return arr;
};
exports.anyError = function () {
  for (var n = 0; n < arguments.length; n++) {
    if (arguments[n] instanceof Error) {
      return arguments[n];
    }
  }
  return undefined;
};
exports.isDefined = function (arg) {
  return arg !== undefined && arg !== null;
};
exports.anyIsError = function () {
  var n = arguments.length;
  while (n--) {
    if (arguments[n] instanceof Error) {
      return true;
    }
  }
  return false;
};
exports.anyIsString = function () {
  var n = arguments.length;
  while (n--) {
    if (typeof arguments[n] === 'string') {
      return true;
    }
  }
  return false;
};
exports.arrayValuesToNumbers = function (arr) {
  var n = arr.length;
  var el;
  while (n--) {
    el = arr[n];
    if (typeof el === 'number') {
      continue;
    }
    if (el === true) {
      arr[n] = 1;
      continue;
    }
    if (el === false) {
      arr[n] = 0;
      continue;
    }
    if (typeof el === 'string') {
      var number = this.parseNumber(el);
      if (number instanceof Error) {
        arr[n] = 0;
      } else {
        arr[n] = number;
      }
    }
  }
  return arr;
};
exports.rest = function (array, idx) {
  idx = idx || 1;
  if (!array || typeof array.slice !== 'function') {
    return array;
  }
  return array.slice(idx);
};
exports.initial = function (array, idx) {
  idx = idx || 1;
  if (!array || typeof array.slice !== 'function') {
    return array;
  }
  return array.slice(0, array.length - idx);
};
exports.arrayEach = function (array, iteratee) {
  var index = -1,
    length = array.length;
  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
};
exports.transpose = function (matrix) {
  if (!matrix) {
    return error.value;
  }
  return matrix[0].map(function (col, i) {
    return matrix.map(function (row) {
      return row[i];
    });
  });
};

/***/ }),

/***/ 60001:
/***/ (function(__unused_webpack_module, exports) {

var defaultOperator = '=';
var validSymbols = ['>', '>=', '<', '<=', '=', '<>'];
var TOKEN_TYPE_OPERATOR = 'operator';
var TOKEN_TYPE_LITERAL = 'literal';
var SUPPORTED_TOKENS = [TOKEN_TYPE_OPERATOR, TOKEN_TYPE_LITERAL];
exports.TOKEN_TYPE_OPERATOR = TOKEN_TYPE_OPERATOR;
exports.TOKEN_TYPE_LITERAL = TOKEN_TYPE_LITERAL;

/**
 * Create token which describe passed symbol/value.
 *
 * @param {String} value Value/Symbol to describe.
 * @param {String} type Type of the token 'operator' or 'literal'.
 * @return {Object}
 */
function createToken(value, type) {
  if (SUPPORTED_TOKENS.indexOf(type) === -1) {
    throw new Error('Unsupported token type: ' + type);
  }
  return {
    value: value,
    type: type
  };
}

/**
 * Tries to cast numeric values to their type passed as a string.
 *
 * @param {*} value
 * @return {*}
 */
function castValueToCorrectType(value) {
  if (typeof value !== 'string') {
    return value;
  }
  if (/^\d+(\.\d+)?$/.test(value)) {
    value = value.indexOf('.') === -1 ? parseInt(value, 10) : parseFloat(value);
  }
  return value;
}

/**
 * Generate stream of tokens from passed expression.
 *
 * @param {String} expression
 * @return {String[]}
 */
function tokenizeExpression(expression) {
  var expressionLength = expression.length;
  var tokens = [];
  var cursorIndex = 0;
  var processedValue = '';
  var processedSymbol = '';
  while (cursorIndex < expressionLength) {
    var char = expression.charAt(cursorIndex);
    switch (char) {
      case '>':
      case '<':
      case '=':
        processedSymbol = processedSymbol + char;
        if (processedValue.length > 0) {
          tokens.push(processedValue);
          processedValue = '';
        }
        break;
      default:
        if (processedSymbol.length > 0) {
          tokens.push(processedSymbol);
          processedSymbol = '';
        }
        processedValue = processedValue + char;
        break;
    }
    cursorIndex++;
  }
  if (processedValue.length > 0) {
    tokens.push(processedValue);
  }
  if (processedSymbol.length > 0) {
    tokens.push(processedSymbol);
  }
  return tokens;
}
;

/**
 * Analyze and convert tokens to an object which describes their meaning.
 *
 * @param {String[]} tokens
 * @return {Object[]}
 */
function analyzeTokens(tokens) {
  var literalValue = '';
  var analyzedTokens = [];
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];
    if (i === 0 && validSymbols.indexOf(token) >= 0) {
      analyzedTokens.push(createToken(token, TOKEN_TYPE_OPERATOR));
    } else {
      literalValue += token;
    }
  }
  if (literalValue.length > 0) {
    analyzedTokens.push(createToken(castValueToCorrectType(literalValue), TOKEN_TYPE_LITERAL));
  }
  if (analyzedTokens.length > 0 && analyzedTokens[0].type !== TOKEN_TYPE_OPERATOR) {
    analyzedTokens.unshift(createToken(defaultOperator, TOKEN_TYPE_OPERATOR));
  }
  return analyzedTokens;
}
;

/**
 * Compute/Evaluate an expression passed as an array of tokens.
 *
 * @param {Object[]} tokens
 * @return {Boolean}
 */
function computeExpression(tokens) {
  var values = [];
  var operator;
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];
    switch (token.type) {
      case TOKEN_TYPE_OPERATOR:
        operator = token.value;
        break;
      case TOKEN_TYPE_LITERAL:
        values.push(token.value);
        break;
    }
  }
  return evaluate(values, operator);
}
;

/**
 * Evaluate values based on passed math operator.
 *
 * @param {*} values
 * @param {String} operator
 * @return {Boolean}
 */
function evaluate(values, operator) {
  var result = false;
  switch (operator) {
    case '>':
      result = values[0] > values[1];
      break;
    case '>=':
      result = values[0] >= values[1];
      break;
    case '<':
      result = values[0] < values[1];
      break;
    case '<=':
      result = values[0] <= values[1];
      break;
    case '=':
      result = values[0] == values[1];
      break;
    case '<>':
      result = values[0] != values[1];
      break;
  }
  return result;
}
exports.parse = function (expression) {
  return analyzeTokens(tokenizeExpression(expression));
};
exports.createToken = createToken;
exports.compute = computeExpression;

/***/ }),

/***/ 95369:
/***/ (function(__unused_webpack_module, exports) {

exports.nil = new Error('#NULL!');
exports.div0 = new Error('#DIV/0!');
exports.value = new Error('#VALUE!');
exports.ref = new Error('#REF!');
exports.name = new Error('#NAME?');
exports.num = new Error('#NUM!');
exports.na = new Error('#N/A');
exports.error = new Error('#ERROR!');
exports.data = new Error('#GETTING_DATA');

/***/ }),

/***/ 46137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ Workbook; }
});

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(10103);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(80599);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(79555);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
var tiny_emitter = __webpack_require__(91618);
var tiny_emitter_default = /*#__PURE__*/__webpack_require__.n(tiny_emitter);
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/helper/number.js
/**
 * Convert value into number.
 *
 * @param {String|Number} number
 * @returns {*}
 */
function toNumber(number) {
  var result;
  if (typeof number === "number") {
    result = number;
  } else if (typeof number === "string") {
    result = number.indexOf(".") > -1 ? parseFloat(number) : parseInt(number, 10);
  }
  return result;
}
/**
 * Invert provided number.
 *
 * @param {Number} number
 * @returns {Number} Returns inverted number.
 */

function invertNumber(number) {
  return -1 * toNumber(number);
}
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/error.js
var _errors;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var ERROR = "ERROR";
var ERROR_DIV_ZERO = "DIV/0";
var ERROR_NAME = "NAME";
var ERROR_NOT_AVAILABLE = "N/A";
var ERROR_NULL = "NULL";
var ERROR_NUM = "NUM";
var ERROR_REF = "REF";
var ERROR_VALUE = "VALUE";
var errors = (_errors = {}, _defineProperty(_errors, ERROR, "#ERROR!"), _defineProperty(_errors, ERROR_DIV_ZERO, "#DIV/0!"), _defineProperty(_errors, ERROR_NAME, "#NAME?"), _defineProperty(_errors, ERROR_NOT_AVAILABLE, "#N/A"), _defineProperty(_errors, ERROR_NULL, "#NULL!"), _defineProperty(_errors, ERROR_NUM, "#NUM!"), _defineProperty(_errors, ERROR_REF, "#REF!"), _defineProperty(_errors, ERROR_VALUE, "#VALUE!"), _errors);
/**
 * Return error type based on provided error id.
 *
 * @param {String} type Error type.
 * @returns {String|null} Returns error id.
 */

function error_error(type) {
  var result;
  type = (type + "").replace(/#|!|\?/g, "");
  if (errors[type]) {
    result = errors[type];
  }
  return result ? result : null;
}
/**
 * Check if error type is strict valid with knows errors.
 *
 * @param {String} Error type.
 * @return {Boolean}
 */

function isValidStrict(type) {
  var valid = false;
  for (var i in errors) {
    if (Object.prototype.hasOwnProperty.call(errors, i) && errors[i] === type) {
      valid = true;
      break;
    }
  }
  return valid;
}
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/evaluate-by-operator/operator/add.js


var SYMBOL = "+";
function func(first) {
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }
  var result = rest.reduce(function (acc, value) {
    return acc + toNumber(value || 0);
  }, toNumber(first || 0));
  if (isNaN(result)) {
    throw Error(ERROR_VALUE);
  }
  return result;
}
func.SYMBOL = SYMBOL;
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/evaluate-by-operator/operator/ampersand.js
var ampersand_SYMBOL = "&";
function ampersand_func() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }
  return params.reduce(function (acc, value) {
    return acc + value.toString();
  }, "");
}
ampersand_func.SYMBOL = ampersand_SYMBOL;
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/evaluate-by-operator/operator/divide.js


var divide_SYMBOL = "/";
function divide_func(first) {
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }
  var result = rest.reduce(function (acc, value) {
    return acc / toNumber(value);
  }, toNumber(first));
  if (result === Infinity) {
    return ERROR_DIV_ZERO; // throw Error(ERROR_DIV_ZERO);
  }
  if (isNaN(result)) {
    return ERROR_VALUE; // throw Error(ERROR_VALUE);
  }
  return result;
}
divide_func.SYMBOL = divide_SYMBOL;
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/evaluate-by-operator/operator/equal.js
var equal_SYMBOL = "=";
function equal_func(exp1, exp2) {
  return exp1 === exp2;
}
equal_func.SYMBOL = equal_SYMBOL;
// EXTERNAL MODULE: ./node_modules/@formulajs/formulajs/index.js
var formulajs = __webpack_require__(27553);
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/supported-formulas.js

var SUPPORTED_FORMULAS = Object.keys(formulajs);
/* harmony default export */ var supported_formulas = (SUPPORTED_FORMULAS);
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/evaluate-by-operator/operator/formula-function.js



var formula_function_SYMBOL = supported_formulas;
function formula_function_func(symbol) {
  return function __formulaFunction() {
    symbol = symbol.toUpperCase();
    var symbolParts = symbol.split(".");
    var foundFormula = false;
    var result;
    if (symbolParts.length === 1) {
      if (formulajs[symbolParts[0]]) {
        foundFormula = true;
        result = formulajs[symbolParts[0]].apply(formulajs, arguments);
      }
    } else {
      var length = symbolParts.length;
      var index = 0;
      var nestedFormula = formulajs;
      while (index < length) {
        nestedFormula = nestedFormula[symbolParts[index]];
        index++;
        if (!nestedFormula) {
          nestedFormula = null;
          break;
        }
      }
      if (nestedFormula) {
        foundFormula = true;
        result = nestedFormula.apply(void 0, arguments);
      }
    }
    if (!foundFormula) {
      throw Error(ERROR_NAME);
    }
    return result;
  };
}
formula_function_func.isFactory = true;
formula_function_func.SYMBOL = formula_function_SYMBOL;
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/evaluate-by-operator/operator/greater-than.js
var greater_than_SYMBOL = ">";
function greater_than_func(exp1, exp2) {
  return exp1 > exp2;
}
greater_than_func.SYMBOL = greater_than_SYMBOL;
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/evaluate-by-operator/operator/greater-than-or-equal.js
var greater_than_or_equal_SYMBOL = ">=";
function greater_than_or_equal_func(exp1, exp2) {
  return exp1 >= exp2;
}
greater_than_or_equal_func.SYMBOL = greater_than_or_equal_SYMBOL;
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/evaluate-by-operator/operator/less-than.js
var less_than_SYMBOL = "<";
function less_than_func(exp1, exp2) {
  return exp1 < exp2;
}
less_than_func.SYMBOL = less_than_SYMBOL;
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/evaluate-by-operator/operator/less-than-or-equal.js
var less_than_or_equal_SYMBOL = "<=";
function less_than_or_equal_func(exp1, exp2) {
  return exp1 <= exp2;
}
less_than_or_equal_func.SYMBOL = less_than_or_equal_SYMBOL;
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/evaluate-by-operator/operator/minus.js


var minus_SYMBOL = "-";
function minus_func(first) {
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }
  var result = rest.reduce(function (acc, value) {
    return acc - toNumber(value);
  }, toNumber(first));
  if (isNaN(result)) {
    throw Error(ERROR_VALUE);
  }
  return result;
}
minus_func.SYMBOL = minus_SYMBOL;
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/evaluate-by-operator/operator/multiply.js


var multiply_SYMBOL = "*";
function multiply_func(first) {
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }
  var result = rest.reduce(function (acc, value) {
    return acc * toNumber(value);
  }, toNumber(first));
  if (isNaN(result)) {
    throw Error(ERROR_VALUE);
  }
  return result;
}
multiply_func.SYMBOL = multiply_SYMBOL;
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/evaluate-by-operator/operator/not-equal.js
var not_equal_SYMBOL = "<>";
function not_equal_func(exp1, exp2) {
  return exp1 !== exp2;
}
not_equal_func.SYMBOL = not_equal_SYMBOL;
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/evaluate-by-operator/operator/power.js


var power_SYMBOL = "^";
function power_func(exp1, exp2) {
  var result = Math.pow(toNumber(exp1), toNumber(exp2));
  if (isNaN(result)) {
    throw Error(ERROR_VALUE);
  }
  return result;
}
power_func.SYMBOL = power_SYMBOL;
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/evaluate-by-operator/evaluate-by-operator.js
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

/* eslint-disable import/no-named-as-default-member */














var availableOperators = Object.create(null);
/**
 * Evaluate values by operator id.git
 *
 * @param {String} operator Operator id.
 * @param {Array} [params=[]] Arguments to evaluate.
 * @returns {*}
 */

function evaluateByOperator(operator) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  operator = operator.toUpperCase();
  if (!availableOperators[operator]) {
    throw Error(ERROR_NAME);
  }
  return availableOperators[operator].apply(availableOperators, _toConsumableArray(params));
}
/**
 * Register operator.
 *
 * @param {String|Array} symbol Symbol to register.
 * @param {Function} func Logic to register for this symbol.
 */

function registerOperation(symbol, func) {
  if (!Array.isArray(symbol)) {
    symbol = [symbol.toUpperCase()];
  }
  symbol.forEach(function (s) {
    if (func.isFactory) {
      availableOperators[s] = func(s);
    } else {
      availableOperators[s] = func;
    }
  });
}
registerOperation(func.SYMBOL, func);
registerOperation(ampersand_func.SYMBOL, ampersand_func);
registerOperation(divide_func.SYMBOL, divide_func);
registerOperation(equal_func.SYMBOL, equal_func);
registerOperation(power_func.SYMBOL, power_func);
registerOperation(formula_function_func.SYMBOL, formula_function_func);
registerOperation(greater_than_func.SYMBOL, greater_than_func);
registerOperation(greater_than_or_equal_func.SYMBOL, greater_than_or_equal_func);
registerOperation(less_than_func.SYMBOL, less_than_func);
registerOperation(less_than_or_equal_func.SYMBOL, less_than_or_equal_func);
registerOperation(multiply_func.SYMBOL, multiply_func);
registerOperation(not_equal_func.SYMBOL, not_equal_func);
registerOperation(minus_func.SYMBOL, minus_func);
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/grammar-parser/grammar-parser.js
/* parser generated by jison 0.4.18 */

/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/

/* addresses */
var simpleSheetName = "[A-Za-z0-9_\xC0-\u02AF]+";
var quotedSheetName = "'(?:(?!').|'')*'";
var sheetNameRegexp = "(?:".concat(simpleSheetName, "|").concat(quotedSheetName, ")!");
var ABSOLUTE_CELL = new RegExp("^(?:".concat(sheetNameRegexp, ")?(?:[$][A-Za-z]+[$][0-9]+)"));
var MIXED_CELL_COL = new RegExp("^(?:".concat(sheetNameRegexp, ")?(?:[$][A-Za-z]+[0-9]*)"));
var MIXED_CELL_ROW = new RegExp("^(?:".concat(sheetNameRegexp, ")?(?:[A-Za-z]*[$][0-9]+)"));
var RELATIVE_CELL = new RegExp("^(?:".concat(sheetNameRegexp, ")?(?:(?:[A-Za-z]+[0-9]*)|(?:[A-Za-z]*[0-9]+))(?!\\d)(?!\\.)"));
var NUMONLY = /^(?:[0-9]+$)/;
var stackCache;
var o = function o(k, v, _o, l) {
    for (_o = _o || {}, l = k.length; l--; _o[k[l]] = v) {
      ;
    }
    return _o;
  },
  $V0 = [1, 5],
  $V1 = [1, 8],
  $V2 = [1, 6],
  $V3 = [1, 7],
  $V4 = [1, 9],
  $V5 = [1, 14],
  $V6 = [1, 15],
  $V7 = [1, 16],
  $V8 = [1, 12],
  $V9 = [1, 13],
  $Va = [1, 17],
  $Vb = [1, 19],
  $Vc = [1, 20],
  $Vd = [1, 21],
  $Ve = [1, 22],
  $Vf = [1, 23],
  $Vg = [1, 24],
  $Vh = [1, 25],
  $Vi = [1, 26],
  $Vj = [1, 27],
  $Vk = [1, 28],
  $Vl = [5, 9, 10, 11, 13, 14, 15, 16, 17, 18, 19, 20, 29, 30],
  $Vm = [5, 9, 10, 11, 13, 14, 15, 16, 17, 18, 19, 20, 29, 30, 32],
  $Vn = [5, 9, 10, 11, 13, 14, 15, 16, 17, 18, 19, 20, 29, 30, 34],
  $Vo = [5, 10, 11, 13, 14, 15, 16, 17, 29, 30],
  $Vp = [5, 10, 13, 14, 15, 16, 29, 30],
  $Vq = [5, 10, 11, 13, 14, 15, 16, 17, 18, 19, 29, 30],
  $Vr = [13, 29, 30];
var parser = {
  trace: function trace() {},
  yy: {},
  symbols_: {
    error: 2,
    expressions: 3,
    expression: 4,
    EOF: 5,
    variableSequence: 6,
    number: 7,
    STRING: 8,
    "&": 9,
    "=": 10,
    "+": 11,
    "(": 12,
    ")": 13,
    "<": 14,
    ">": 15,
    NOT: 16,
    "-": 17,
    "*": 18,
    "/": 19,
    "^": 20,
    FUNCTION: 21,
    expseq: 22,
    cell: 23,
    ABSOLUTE_CELL: 24,
    RELATIVE_CELL: 25,
    MIXED_CELL: 26,
    ":": 27,
    ARRAY: 28,
    ";": 29,
    ",": 30,
    VARIABLE: 31,
    DECIMAL: 32,
    NUMBER: 33,
    "%": 34,
    ERROR: 35,
    $accept: 0,
    $end: 1
  },
  terminals_: {
    5: "EOF",
    8: "STRING",
    9: "&",
    10: "=",
    11: "+",
    12: "(",
    13: ")",
    14: "<",
    15: ">",
    16: "NOT",
    17: "-",
    18: "*",
    19: "/",
    20: "^",
    21: "FUNCTION",
    24: "ABSOLUTE_CELL",
    25: "RELATIVE_CELL",
    26: "MIXED_CELL",
    27: ":",
    28: "ARRAY",
    29: ";",
    30: ",",
    31: "VARIABLE",
    32: "DECIMAL",
    33: "NUMBER",
    34: "%",
    35: "ERROR"
  },
  productions_: [0, [3, 2], [4, 1], [4, 1], [4, 1], [4, 3], [4, 3], [4, 3], [4, 3], [4, 4], [4, 4], [4, 4], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 2], [4, 2], [4, 3], [4, 4], [4, 1], [4, 1], [4, 2], [23, 1], [23, 1], [23, 1], [23, 3], [23, 3], [23, 3], [23, 3], [23, 3], [23, 3], [23, 3], [23, 3], [23, 3], [22, 1], [22, 1], [22, 3], [22, 3], [6, 1], [6, 3], [7, 1], [7, 3], [7, 2], [2, 1]],
  performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate
  /* action[1] */, $$
  /* vstack */, _$
  /* lstack */) {
    /* this == yyval */
    var $0 = $$.length - 1;
    switch (yystate) {
      case 1:
        return $$[$0 - 1];
        break;
      case 2:
        this.$ = yy.callVariable($$[$0][0]);
        break;
      case 3:
        this.$ = yy.toNumber($$[$0]);
        break;
      case 4:
        this.$ = yy.trimEdges($$[$0]);
        break;
      case 5:
        this.$ = yy.evaluateByOperator("&", [$$[$0 - 2], $$[$0]]);
        break;
      case 6:
        this.$ = yy.evaluateByOperator("=", [$$[$0 - 2], $$[$0]]);
        break;
      case 7:
        this.$ = yy.evaluateByOperator("+", [$$[$0 - 2], $$[$0]]);
        break;
      case 8:
        this.$ = $$[$0 - 1];
        break;
      case 9:
        this.$ = yy.evaluateByOperator("<=", [$$[$0 - 3], $$[$0]]);
        break;
      case 10:
        this.$ = yy.evaluateByOperator(">=", [$$[$0 - 3], $$[$0]]);
        break;
      case 11:
        this.$ = yy.evaluateByOperator("<>", [$$[$0 - 3], $$[$0]]);
        break;
      case 12:
        this.$ = yy.evaluateByOperator("NOT", [$$[$0 - 2], $$[$0]]);
        break;
      case 13:
        this.$ = yy.evaluateByOperator(">", [$$[$0 - 2], $$[$0]]);
        break;
      case 14:
        this.$ = yy.evaluateByOperator("<", [$$[$0 - 2], $$[$0]]);
        break;
      case 15:
        this.$ = yy.evaluateByOperator("-", [$$[$0 - 2], $$[$0]]);
        break;
      case 16:
        this.$ = yy.evaluateByOperator("*", [$$[$0 - 2], $$[$0]]);
        break;
      case 17:
        this.$ = yy.evaluateByOperator("/", [$$[$0 - 2], $$[$0]]);
        break;
      case 18:
        this.$ = yy.evaluateByOperator("^", [$$[$0 - 2], $$[$0]]);
        break;
      case 19:
        var n1 = yy.invertNumber($$[$0]);
        this.$ = n1;
        if (isNaN(this.$)) {
          this.$ = 0;
        }
        break;
      case 20:
        var n1 = yy.toNumber($$[$0]);
        this.$ = n1;
        if (isNaN(this.$)) {
          this.$ = 0;
        }
        break;
      case 21:
        this.$ = yy.callFunction($$[$0 - 2]);
        break;
      case 22:
        this.$ = yy.callFunction($$[$0 - 3], $$[$0 - 1]);
        break;
      case 26:
      case 27:
      case 28:
        this.$ = yy.cellValue($$[$0]);
        break;
      case 29:
      case 30:
      case 31:
      case 32:
      case 33:
      case 34:
      case 35:
      case 36:
      case 37:
        this.$ = yy.rangeValue($$[$0 - 2], $$[$0]);
        break;
      case 38:
      case 42:
        this.$ = [$$[$0]];
        break;
      case 39:
        this.$ = yy.trimEdges(yytext).split(",");
        break;
      case 40:
      case 41:
        $$[$0 - 2].push($$[$0]);
        this.$ = $$[$0 - 2];
        break;
      case 43:
        this.$ = Array.isArray($$[$0 - 2]) ? $$[$0 - 2] : [$$[$0 - 2]];
        this.$.push($$[$0]);
        break;
      case 44:
        this.$ = $$[$0];
        break;
      case 45:
        this.$ = ($$[$0 - 2] + "." + $$[$0]) * 1;
        break;
      case 46:
        this.$ = $$[$0 - 1] * 0.01;
        break;
      case 47:
        this.$ = yy.throwError($$[$0]);
        break;
    }
  },
  table: [{
    2: 11,
    3: 1,
    4: 2,
    6: 3,
    7: 4,
    8: $V0,
    11: $V1,
    12: $V2,
    17: $V3,
    21: $V4,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    31: $V8,
    33: $V9,
    35: $Va
  }, {
    1: [3]
  }, {
    5: [1, 18],
    9: $Vb,
    10: $Vc,
    11: $Vd,
    14: $Ve,
    15: $Vf,
    16: $Vg,
    17: $Vh,
    18: $Vi,
    19: $Vj,
    20: $Vk
  }, o($Vl, [2, 2], {
    32: [1, 29]
  }), o($Vl, [2, 3], {
    34: [1, 30]
  }), o($Vl, [2, 4]), {
    2: 11,
    4: 31,
    6: 3,
    7: 4,
    8: $V0,
    11: $V1,
    12: $V2,
    17: $V3,
    21: $V4,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    31: $V8,
    33: $V9,
    35: $Va
  }, {
    2: 11,
    4: 32,
    6: 3,
    7: 4,
    8: $V0,
    11: $V1,
    12: $V2,
    17: $V3,
    21: $V4,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    31: $V8,
    33: $V9,
    35: $Va
  }, {
    2: 11,
    4: 33,
    6: 3,
    7: 4,
    8: $V0,
    11: $V1,
    12: $V2,
    17: $V3,
    21: $V4,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    31: $V8,
    33: $V9,
    35: $Va
  }, {
    12: [1, 34]
  }, o($Vl, [2, 23]), o($Vl, [2, 24], {
    2: 35,
    35: $Va
  }), o($Vm, [2, 42]), o($Vn, [2, 44], {
    32: [1, 36]
  }), o($Vl, [2, 26], {
    27: [1, 37]
  }), o($Vl, [2, 27], {
    27: [1, 38]
  }), o($Vl, [2, 28], {
    27: [1, 39]
  }), o([5, 9, 10, 11, 13, 14, 15, 16, 17, 18, 19, 20, 29, 30, 35], [2, 47]), {
    1: [2, 1]
  }, {
    2: 11,
    4: 40,
    6: 3,
    7: 4,
    8: $V0,
    11: $V1,
    12: $V2,
    17: $V3,
    21: $V4,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    31: $V8,
    33: $V9,
    35: $Va
  }, {
    2: 11,
    4: 41,
    6: 3,
    7: 4,
    8: $V0,
    11: $V1,
    12: $V2,
    17: $V3,
    21: $V4,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    31: $V8,
    33: $V9,
    35: $Va
  }, {
    2: 11,
    4: 42,
    6: 3,
    7: 4,
    8: $V0,
    11: $V1,
    12: $V2,
    17: $V3,
    21: $V4,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    31: $V8,
    33: $V9,
    35: $Va
  }, {
    2: 11,
    4: 45,
    6: 3,
    7: 4,
    8: $V0,
    10: [1, 43],
    11: $V1,
    12: $V2,
    15: [1, 44],
    17: $V3,
    21: $V4,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    31: $V8,
    33: $V9,
    35: $Va
  }, {
    2: 11,
    4: 47,
    6: 3,
    7: 4,
    8: $V0,
    10: [1, 46],
    11: $V1,
    12: $V2,
    17: $V3,
    21: $V4,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    31: $V8,
    33: $V9,
    35: $Va
  }, {
    2: 11,
    4: 48,
    6: 3,
    7: 4,
    8: $V0,
    11: $V1,
    12: $V2,
    17: $V3,
    21: $V4,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    31: $V8,
    33: $V9,
    35: $Va
  }, {
    2: 11,
    4: 49,
    6: 3,
    7: 4,
    8: $V0,
    11: $V1,
    12: $V2,
    17: $V3,
    21: $V4,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    31: $V8,
    33: $V9,
    35: $Va
  }, {
    2: 11,
    4: 50,
    6: 3,
    7: 4,
    8: $V0,
    11: $V1,
    12: $V2,
    17: $V3,
    21: $V4,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    31: $V8,
    33: $V9,
    35: $Va
  }, {
    2: 11,
    4: 51,
    6: 3,
    7: 4,
    8: $V0,
    11: $V1,
    12: $V2,
    17: $V3,
    21: $V4,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    31: $V8,
    33: $V9,
    35: $Va
  }, {
    2: 11,
    4: 52,
    6: 3,
    7: 4,
    8: $V0,
    11: $V1,
    12: $V2,
    17: $V3,
    21: $V4,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    31: $V8,
    33: $V9,
    35: $Va
  }, {
    31: [1, 53]
  }, o($Vn, [2, 46]), {
    9: $Vb,
    10: $Vc,
    11: $Vd,
    13: [1, 54],
    14: $Ve,
    15: $Vf,
    16: $Vg,
    17: $Vh,
    18: $Vi,
    19: $Vj,
    20: $Vk
  }, o($Vo, [2, 19], {
    9: $Vb,
    18: $Vi,
    19: $Vj,
    20: $Vk
  }), o($Vo, [2, 20], {
    9: $Vb,
    18: $Vi,
    19: $Vj,
    20: $Vk
  }), {
    2: 11,
    4: 57,
    6: 3,
    7: 4,
    8: $V0,
    11: $V1,
    12: $V2,
    13: [1, 55],
    17: $V3,
    21: $V4,
    22: 56,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    28: [1, 58],
    31: $V8,
    33: $V9,
    35: $Va
  }, o($Vl, [2, 25]), {
    33: [1, 59]
  }, {
    24: [1, 60],
    25: [1, 61],
    26: [1, 62]
  }, {
    24: [1, 63],
    25: [1, 64],
    26: [1, 65]
  }, {
    24: [1, 66],
    25: [1, 67],
    26: [1, 68]
  }, o($Vl, [2, 5]), o([5, 10, 13, 29, 30], [2, 6], {
    9: $Vb,
    11: $Vd,
    14: $Ve,
    15: $Vf,
    16: $Vg,
    17: $Vh,
    18: $Vi,
    19: $Vj,
    20: $Vk
  }), o($Vo, [2, 7], {
    9: $Vb,
    18: $Vi,
    19: $Vj,
    20: $Vk
  }), {
    2: 11,
    4: 69,
    6: 3,
    7: 4,
    8: $V0,
    11: $V1,
    12: $V2,
    17: $V3,
    21: $V4,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    31: $V8,
    33: $V9,
    35: $Va
  }, {
    2: 11,
    4: 70,
    6: 3,
    7: 4,
    8: $V0,
    11: $V1,
    12: $V2,
    17: $V3,
    21: $V4,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    31: $V8,
    33: $V9,
    35: $Va
  }, o($Vp, [2, 14], {
    9: $Vb,
    11: $Vd,
    17: $Vh,
    18: $Vi,
    19: $Vj,
    20: $Vk
  }), {
    2: 11,
    4: 71,
    6: 3,
    7: 4,
    8: $V0,
    11: $V1,
    12: $V2,
    17: $V3,
    21: $V4,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    31: $V8,
    33: $V9,
    35: $Va
  }, o($Vp, [2, 13], {
    9: $Vb,
    11: $Vd,
    17: $Vh,
    18: $Vi,
    19: $Vj,
    20: $Vk
  }), o([5, 10, 13, 16, 29, 30], [2, 12], {
    9: $Vb,
    11: $Vd,
    14: $Ve,
    15: $Vf,
    17: $Vh,
    18: $Vi,
    19: $Vj,
    20: $Vk
  }), o($Vo, [2, 15], {
    9: $Vb,
    18: $Vi,
    19: $Vj,
    20: $Vk
  }), o($Vq, [2, 16], {
    9: $Vb,
    20: $Vk
  }), o($Vq, [2, 17], {
    9: $Vb,
    20: $Vk
  }), o([5, 10, 11, 13, 14, 15, 16, 17, 18, 19, 20, 29, 30], [2, 18], {
    9: $Vb
  }), o($Vm, [2, 43]), o($Vl, [2, 8]), o($Vl, [2, 21]), {
    13: [1, 72],
    29: [1, 73],
    30: [1, 74]
  }, o($Vr, [2, 38], {
    9: $Vb,
    10: $Vc,
    11: $Vd,
    14: $Ve,
    15: $Vf,
    16: $Vg,
    17: $Vh,
    18: $Vi,
    19: $Vj,
    20: $Vk
  }), o($Vr, [2, 39]), o($Vn, [2, 45]), o($Vl, [2, 29]), o($Vl, [2, 30]), o($Vl, [2, 31]), o($Vl, [2, 32]), o($Vl, [2, 33]), o($Vl, [2, 34]), o($Vl, [2, 35]), o($Vl, [2, 36]), o($Vl, [2, 37]), o($Vp, [2, 9], {
    9: $Vb,
    11: $Vd,
    17: $Vh,
    18: $Vi,
    19: $Vj,
    20: $Vk
  }), o($Vp, [2, 11], {
    9: $Vb,
    11: $Vd,
    17: $Vh,
    18: $Vi,
    19: $Vj,
    20: $Vk
  }), o($Vp, [2, 10], {
    9: $Vb,
    11: $Vd,
    17: $Vh,
    18: $Vi,
    19: $Vj,
    20: $Vk
  }), o($Vl, [2, 22]), {
    2: 11,
    4: 75,
    6: 3,
    7: 4,
    8: $V0,
    11: $V1,
    12: $V2,
    17: $V3,
    21: $V4,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    31: $V8,
    33: $V9,
    35: $Va
  }, {
    2: 11,
    4: 76,
    6: 3,
    7: 4,
    8: $V0,
    11: $V1,
    12: $V2,
    17: $V3,
    21: $V4,
    23: 10,
    24: $V5,
    25: $V6,
    26: $V7,
    31: $V8,
    33: $V9,
    35: $Va
  }, o($Vr, [2, 40], {
    9: $Vb,
    10: $Vc,
    11: $Vd,
    14: $Ve,
    15: $Vf,
    16: $Vg,
    17: $Vh,
    18: $Vi,
    19: $Vj,
    20: $Vk
  }), o($Vr, [2, 41], {
    9: $Vb,
    10: $Vc,
    11: $Vd,
    14: $Ve,
    15: $Vf,
    16: $Vg,
    17: $Vh,
    18: $Vi,
    19: $Vj,
    20: $Vk
  })],
  defaultActions: {
    18: [2, 1]
  },
  parseError: function parseError(str, hash) {
    if (hash.recoverable) {
      this.trace(str);
    } else {
      var error = new Error(str);
      error.hash = hash;
      throw error;
    }
  },
  parse: function parse(input) {
    var self = this,
      stack = [0],
      tstack = [],
      // token stack
      vstack = [null],
      // semantic value stack
      lstack = [],
      // location stack
      table = this.table,
      yytext = "",
      yylineno = 0,
      yyleng = 0,
      recovering = 0,
      TERROR = 2,
      EOF = 1;
    var args = lstack.slice.call(arguments, 1); //this.reductionCount = this.shiftCount = 0;

    var lexer = Object.create(this.lexer);
    var sharedState = {
      yy: {}
    }; // copy state

    for (var k in this.yy) {
      if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
        sharedState.yy[k] = this.yy[k];
      }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == "undefined") {
      lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === "function") {
      this.parseError = sharedState.yy.parseError;
    } else {
      this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
      stack.length = stack.length - 2 * n;
      vstack.length = vstack.length - n;
      lstack.length = lstack.length - n;
    }
    var lex = function lex() {
      var token;
      token = lexer.lex() || EOF; // if token isn't its numeric value, convert

      if (typeof token !== "number") {
        token = self.symbols_[token] || token;
      }
      return token;
    };
    var symbol,
      preErrorSymbol,
      state,
      action,
      a,
      r,
      yyval = {},
      p,
      len,
      newState,
      expected;
    while (true) {
      // retreive state number from top of stack
      stackCache = stack;
      state = stack[stack.length - 1]; // use default actions if available

      if (this.defaultActions[state]) {
        action = this.defaultActions[state];
      } else {
        if (symbol === null || typeof symbol == "undefined") {
          symbol = lex();
        } // read action for current state and first input

        action = table[state] && table[state][symbol];
      } // handle parse error

      if (typeof action === "undefined" || !action.length || !action[0]) {
        // Return the rule stack depth where the nearest error rule can be found.
        // Return FALSE when no error recovery rule was found.
        var locateNearestErrorRecoveryRule = function locateNearestErrorRecoveryRule(state) {
          var stack_probe = stack.length - 1;
          var depth = 0; // try to recover from error

          for (;;) {
            // check for error recovery rule in this state
            if (TERROR.toString() in table[state]) {
              return depth;
            }
            if (state === 0 || stack_probe < 2) {
              return false; // No suitable error recovery rule available.
            }
            stack_probe -= 2; // popStack(1): [symbol, action]

            state = stack[stack_probe];
            ++depth;
          }
        };
        var error_rule_depth;
        var errStr = "";
        if (!recovering) {
          // first see if there's any chance at hitting an error recovery rule:
          error_rule_depth = locateNearestErrorRecoveryRule(state); // Report error

          expected = [];
          for (p in table[state]) {
            if (this.terminals_[p] && p > TERROR) {
              expected.push("'" + this.terminals_[p] + "'");
            }
          }
          if (lexer.showPosition) {
            errStr = "Parse error on line " + (yylineno + 1) + ":\n" + lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
          } else {
            errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == EOF ? "end of input" : "'" + (this.terminals_[symbol] || symbol) + "'");
          }
          this.parseError(errStr, {
            text: lexer.match,
            token: this.terminals_[symbol] || symbol,
            line: lexer.yylineno,
            loc: yyloc,
            expected: expected,
            recoverable: error_rule_depth !== false
          });
        } else if (preErrorSymbol !== EOF) {
          error_rule_depth = locateNearestErrorRecoveryRule(state);
        } // just recovered from another error

        if (recovering == 3) {
          if (symbol === EOF || preErrorSymbol === EOF) {
            throw new Error(errStr || "Parsing halted while starting to recover from another error.");
          } // discard current lookahead and grab another

          yyleng = lexer.yyleng;
          yytext = lexer.yytext;
          yylineno = lexer.yylineno;
          yyloc = lexer.yylloc;
          symbol = lex();
        } // try to recover from error

        if (error_rule_depth === false) {
          throw new Error(errStr || "Parsing halted. No suitable error recovery rule available.");
        }
        popStack(error_rule_depth);
        preErrorSymbol = symbol == TERROR ? null : symbol; // save the lookahead token

        symbol = TERROR; // insert generic error symbol as new lookahead

        state = stack[stack.length - 1];
        action = table[state] && table[state][TERROR];
        recovering = 3; // allow 3 real symbols to be shifted before reporting a new error
      } // this shouldn't happen, unless resolve defaults are off

      if (action[0] instanceof Array && action.length > 1) {
        throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
      }
      switch (action[0]) {
        case 1:
          // shift
          //this.shiftCount++;
          stack.push(symbol);
          vstack.push(lexer.yytext);
          lstack.push(lexer.yylloc);
          stack.push(action[1]); // push state

          symbol = null;
          if (!preErrorSymbol) {
            // normal execution/no error
            yyleng = lexer.yyleng;
            yytext = lexer.yytext;
            yylineno = lexer.yylineno;
            yyloc = lexer.yylloc;
            if (recovering > 0) {
              recovering--;
            }
          } else {
            // error just occurred, resume old lookahead f/ before error
            symbol = preErrorSymbol;
            preErrorSymbol = null;
          }
          break;
        case 2:
          // reduce
          //this.reductionCount++;
          len = this.productions_[action[1]][1]; // perform semantic action

          yyval.$ = vstack[vstack.length - len]; // default to $$ = $1
          // default location, uses first token for firsts, last for lasts

          yyval._$ = {
            first_line: lstack[lstack.length - (len || 1)].first_line,
            last_line: lstack[lstack.length - 1].last_line,
            first_column: lstack[lstack.length - (len || 1)].first_column,
            last_column: lstack[lstack.length - 1].last_column
          };
          if (ranges) {
            yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
          }
          r = this.performAction.apply(yyval, [yytext, yyleng, yylineno, sharedState.yy, action[1], vstack, lstack].concat(args));
          if (typeof r !== "undefined") {
            return r;
          } // pop off stack

          if (len) {
            stack = stack.slice(0, -1 * len * 2);
            vstack = vstack.slice(0, -1 * len);
            lstack = lstack.slice(0, -1 * len);
          }
          stack.push(this.productions_[action[1]][0]); // push nonterminal (reduce)

          vstack.push(yyval.$);
          lstack.push(yyval._$); // goto new state = table[STATE][NONTERMINAL]

          newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
          stack.push(newState);
          break;
        case 3:
          // accept
          return true;
      }
    }
    return true;
  }
};
/* generated by jison-lex 0.3.4 */

var lexer = function () {
  var lexer = {
    EOF: 1,
    parseError: function parseError(str, hash) {
      if (this.yy.parser) {
        this.yy.parser.parseError(str, hash);
      } else {
        throw new Error(str);
      }
    },
    // resets the lexer, sets new input
    setInput: function setInput(input, yy) {
      this.yy = yy || this.yy || {};
      this._input = input;
      this._more = this._backtrack = this.done = false;
      this.yylineno = this.yyleng = 0;
      this.yytext = this.matched = this.match = "";
      this.conditionStack = ["INITIAL"];
      this.yylloc = {
        first_line: 1,
        first_column: 0,
        last_line: 1,
        last_column: 0
      };
      if (this.options.ranges) {
        this.yylloc.range = [0, 0];
      }
      this.offset = 0;
      return this;
    },
    // consumes and returns one char from the input
    input: function input() {
      var ch = this._input[0];
      this.yytext += ch;
      this.yyleng++;
      this.offset++;
      this.match += ch;
      this.matched += ch;
      var lines = ch.match(/(?:\r\n?|\n).*/g);
      if (lines) {
        this.yylineno++;
        this.yylloc.last_line++;
      } else {
        this.yylloc.last_column++;
      }
      if (this.options.ranges) {
        this.yylloc.range[1]++;
      }
      this._input = this._input.slice(1);
      return ch;
    },
    // unshifts one char (or a string) into the input
    unput: function unput(ch) {
      var len = ch.length;
      var lines = ch.split(/(?:\r\n?|\n)/g);
      this._input = ch + this._input;
      this.yytext = this.yytext.substr(0, this.yytext.length - len); //this.yyleng -= len;

      this.offset -= len;
      var oldLines = this.match.split(/(?:\r\n?|\n)/g);
      this.match = this.match.substr(0, this.match.length - 1);
      this.matched = this.matched.substr(0, this.matched.length - 1);
      if (lines.length - 1) {
        this.yylineno -= lines.length - 1;
      }
      var r = this.yylloc.range;
      this.yylloc = {
        first_line: this.yylloc.first_line,
        last_line: this.yylineno + 1,
        first_column: this.yylloc.first_column,
        last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
      };
      if (this.options.ranges) {
        this.yylloc.range = [r[0], r[0] + this.yyleng - len];
      }
      this.yyleng = this.yytext.length;
      return this;
    },
    // When called from action, caches matched text and appends it on next action
    more: function more() {
      this._more = true;
      return this;
    },
    // When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
    reject: function reject() {
      if (this.options.backtrack_lexer) {
        this._backtrack = true;
      } else {
        return this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
          text: "",
          token: null,
          line: this.yylineno
        });
      }
      return this;
    },
    // retain first n characters of the match
    less: function less(n) {
      this.unput(this.match.slice(n));
    },
    // displays already matched input, i.e. for error messages
    pastInput: function pastInput() {
      var past = this.matched.substr(0, this.matched.length - this.match.length);
      return (past.length > 20 ? "..." : "") + past.substr(-20).replace(/\n/g, "");
    },
    // displays upcoming input, i.e. for error messages
    upcomingInput: function upcomingInput() {
      var next = this.match;
      if (next.length < 20) {
        next += this._input.substr(0, 20 - next.length);
      }
      return (next.substr(0, 20) + (next.length > 20 ? "..." : "")).replace(/\n/g, "");
    },
    // displays the character position where the lexing error occurred, i.e. for error messages
    showPosition: function showPosition() {
      var pre = this.pastInput();
      var c = new Array(pre.length + 1).join("-");
      return pre + this.upcomingInput() + "\n" + c + "^";
    },
    // test the lexed token: return FALSE when not a match, otherwise return token
    test_match: function test_match(match, indexed_rule) {
      var token, lines, backup;
      if (this.options.backtrack_lexer) {
        // save context
        backup = {
          yylineno: this.yylineno,
          yylloc: {
            first_line: this.yylloc.first_line,
            last_line: this.last_line,
            first_column: this.yylloc.first_column,
            last_column: this.yylloc.last_column
          },
          yytext: this.yytext,
          match: this.match,
          matches: this.matches,
          matched: this.matched,
          yyleng: this.yyleng,
          offset: this.offset,
          _more: this._more,
          _input: this._input,
          yy: this.yy,
          conditionStack: this.conditionStack.slice(0),
          done: this.done
        };
        if (this.options.ranges) {
          backup.yylloc.range = this.yylloc.range.slice(0);
        }
      }
      lines = match[0].match(/(?:\r\n?|\n).*/g);
      if (lines) {
        this.yylineno += lines.length;
      }
      this.yylloc = {
        first_line: this.yylloc.last_line,
        last_line: this.yylineno + 1,
        first_column: this.yylloc.last_column,
        last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length
      };
      this.yytext += match[0];
      this.match += match[0];
      this.matches = match;
      this.yyleng = this.yytext.length;
      if (this.options.ranges) {
        this.yylloc.range = [this.offset, this.offset += this.yyleng];
      }
      this._more = false;
      this._backtrack = false;
      this._input = this._input.slice(match[0].length);
      this.matched += match[0];
      token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
      if (this.done && this._input) {
        this.done = false;
      }
      if (token) {
        return token;
      } else if (this._backtrack) {
        // recover context
        for (var k in backup) {
          this[k] = backup[k];
        }
        return false; // rule action called reject() implying the next rule should be tested instead.
      }
      return false;
    },
    // return next match in input
    next: function next() {
      if (this.done) {
        return this.EOF;
      }
      if (!this._input) {
        this.done = true;
      }
      var token, match, tempMatch, index;
      if (!this._more) {
        this.yytext = "";
        this.match = "";
      }
      var rules = this._currentRules();
      for (var i = 0; i < rules.length; i++) {
        tempMatch = this._input.match(this.rules[rules[i]]);
        if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
          match = tempMatch;
          index = i;
          var stackLen = stackCache.length;
          if (rules[i] === 8 && match[0].match(NUMONLY) && !(match.input.slice(match[0].length)[0] === ":" || stackLen > 3 && stackCache[stackLen - 4] === 25 && stackCache[stackLen - 2] === 27)) {
            match = false;
            continue;
          }
          if (this.options.backtrack_lexer) {
            token = this.test_match(tempMatch, rules[i]);
            if (token !== false) {
              return token;
            } else if (this._backtrack) {
              match = false;
              continue; // rule action called reject() implying a rule MISmatch.
            } else {
              // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
              return false;
            }
          } else if (!this.options.flex) {
            break;
          }
        }
      }
      if (match) {
        token = this.test_match(match, rules[index]);
        if (token !== false) {
          return token;
        } // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)

        return false;
      }
      if (this._input === "") {
        return this.EOF;
      } else {
        return this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
          text: "",
          token: null,
          line: this.yylineno
        });
      }
    },
    // return next match that has a token
    lex: function lex() {
      var r = this.next();
      if (r) {
        return r;
      } else {
        return this.lex();
      }
    },
    // activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
    begin: function begin(condition) {
      this.conditionStack.push(condition);
    },
    // pop the previously active lexer condition state off the condition stack
    popState: function popState() {
      var n = this.conditionStack.length - 1;
      if (n > 0) {
        return this.conditionStack.pop();
      } else {
        return this.conditionStack[0];
      }
    },
    // produce the lexer rule set which is active for the currently active lexer condition state
    _currentRules: function _currentRules() {
      if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
        return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
      } else {
        return this.conditions["INITIAL"].rules;
      }
    },
    // return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
    topState: function topState(n) {
      n = this.conditionStack.length - 1 - Math.abs(n || 0);
      if (n >= 0) {
        return this.conditionStack[n];
      } else {
        return "INITIAL";
      }
    },
    // alias for begin(condition)
    pushState: function pushState(condition) {
      this.begin(condition);
    },
    // return the number of states currently on the stack
    stateStackSize: function stateStackSize() {
      return this.conditionStack.length;
    },
    options: {},
    performAction: function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
      var YYSTATE = YY_START;
      switch ($avoiding_name_collisions) {
        case 0
        /* skip whitespace */:
          break;
        case 1:
          return 8;
          break;
        case 2:
          return 8;
          break;
        case 3:
          return 21;
          break;
        case 4:
          return 35;
          break;
        case 5:
          return 24;
          break;
        case 6:
          return 26;
          break;
        case 7:
          return 26;
          break;
        case 8:
          return 25;
          break;
        case 9:
          return 21;
          break;
        case 10:
          return 31;
          break;
        case 11:
          return 31;
          break;
        case 12:
          return 33;
          break;
        case 13:
          return 28;
          break;
        case 14:
          return 9;
          break;
        case 15:
          return " ";
          break;
        case 16:
          return 32;
          break;
        case 17:
          return 27;
          break;
        case 18:
          return 29;
          break;
        case 19:
          return 30;
          break;
        case 20:
          return 18;
          break;
        case 21:
          return 19;
          break;
        case 22:
          return 17;
          break;
        case 23:
          return 11;
          break;
        case 24:
          return 20;
          break;
        case 25:
          return 12;
          break;
        case 26:
          return 13;
          break;
        case 27:
          return 15;
          break;
        case 28:
          return 14;
          break;
        case 29:
          return 16;
          break;
        case 30:
          return '"';
          break;
        case 31:
          return "'";
          break;
        case 32:
          return "!";
          break;
        case 33:
          return 10;
          break;
        case 34:
          return 34;
          break;
        case 35:
          return "#";
          break;
        case 36:
          return 5;
          break;
      }
    },
    rules: [/^(?:\s+)/, /^(?:"(\\["]|[^"])*")/, /^(?:'(\\[']|[^'])*'[^'!])/, /^(?:[A-Za-z]{1,}[A-Za-z_0-9\.]+(?=[(]))/, /^(?:#[A-Z0-9\/]+(!|\?)?)/, ABSOLUTE_CELL, MIXED_CELL_COL, MIXED_CELL_ROW, RELATIVE_CELL, /^(?:[A-Za-z\.]+(?=[(]))/, /^(?:[A-Za-z]{1,}[A-Za-z_0-9]+)/, /^(?:[A-Za-z_]+)/, /^(?:[0-9]+)/, /^(?:\[(.*)?\])/, /^(?:&)/, /^(?: )/, /^(?:[.])/, /^(?::)/, /^(?:;)/, /^(?:,)/, /^(?:\*)/, /^(?:\/)/, /^(?:-)/, /^(?:\+)/, /^(?:\^)/, /^(?:\()/, /^(?:\))/, /^(?:>)/, /^(?:<)/, /^(?:NOT\b)/, /^(?:")/, /^(?:')/, /^(?:!)/, /^(?:=)/, /^(?:%)/, /^(?:[#])/, /^(?:$)/],
    conditions: {
      INITIAL: {
        rules: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36],
        inclusive: true
      }
    }
  };
  return lexer;
}();
parser.lexer = lexer;
function grammar_parser_Parser() {
  this.yy = {};
}
grammar_parser_Parser.prototype = parser;
parser.Parser = grammar_parser_Parser;
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/helper/string.js
/* eslint-disable import/prefer-default-export */

/**
 * Trim value by cutting character starting from the beginning and ending at the same time.
 *
 * @param {String} string String to trimming.
 * @param {Number} [margin=1] Number of character to cut.
 * @returns {String}
 */
function trimEdges(string) {
  var margin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  string = string.substring(margin, string.length - margin);
  return string;
}
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/helper/cell.js
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || cell_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function cell_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return cell_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return cell_arrayLikeToArray(o, minLen);
}
function cell_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/**
 * Convert row label to index.
 *
 * @param {String} label Row label (eq. '1', '5')
 * @returns {Number} Returns -1 if label is not recognized otherwise proper row index.
 */
function rowLabelToIndex(label) {
  var result = parseInt(label, 10);
  if (isNaN(result)) {
    result = -1;
  } else {
    result = Math.max(result - 1, -1);
  }
  return result;
}
/**
 * Convert row index to label.
 *
 * @param {Number} row Row index.
 * @returns {String} Returns row label (eq. '1', '7').
 */

function rowIndexToLabel(row) {
  var result = "";
  if (row >= 0) {
    result = "".concat(row + 1);
  }
  return result;
}
var COLUMN_LABEL_BASE = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
var COLUMN_LABEL_BASE_LENGTH = COLUMN_LABEL_BASE.length;
/**
 * Convert column label to index.
 *
 * @param {String} label Column label (eq. 'ABB', 'CNQ')
 * @returns {Number} Returns -1 if label is not recognized otherwise proper column index.
 */

function columnLabelToIndex(label) {
  var result = 0;
  if (typeof label === "string") {
    label = label.toUpperCase();
    for (var i = 0, j = label.length - 1; i < label.length; i += 1, j -= 1) {
      result += Math.pow(COLUMN_LABEL_BASE_LENGTH, j) * (COLUMN_LABEL_BASE.indexOf(label[i]) + 1);
    }
  }
  --result;
  return result;
}
/**
 * Convert column index to label.
 *
 * @param {Number} column Column index.
 * @returns {String} Returns column label (eq. 'ABB', 'CNQ').
 */

function columnIndexToLabel(column) {
  var result = "";
  while (column >= 0) {
    result = String.fromCharCode(column % COLUMN_LABEL_BASE_LENGTH + 97) + result;
    column = Math.floor(column / COLUMN_LABEL_BASE_LENGTH) - 1;
  }
  return result.toUpperCase();
}
var cell_simpleSheetName = "[A-Za-z0-9_\xC0-\u02AF]+";
var cell_quotedSheetName = "'(?:(?!').|'')*'";
var cell_sheetNameRegexp = "(".concat(cell_simpleSheetName, "|").concat(cell_quotedSheetName, ")!");
var LABEL_EXTRACT_REGEXP = new RegExp("^(?:".concat(cell_sheetNameRegexp, ")?([$])?([A-Za-z]*)([$])?([0-9]*)$"));
/**
 * Extract cell coordinates.
 *
 * @param {String} label Cell coordinates (eq. 'A1', '$B6', '$N$98').
 * @returns {Array} Returns an array of objects.
 */

function extractLabel(label) {
  if (typeof label !== "string" || !LABEL_EXTRACT_REGEXP.test(label)) {
    return [];
  }
  var _label$toUpperCase$ma = label.toUpperCase().match(LABEL_EXTRACT_REGEXP),
    _label$toUpperCase$ma2 = _slicedToArray(_label$toUpperCase$ma, 6),
    sheetNameStr = _label$toUpperCase$ma2[1],
    columnAbs = _label$toUpperCase$ma2[2],
    column = _label$toUpperCase$ma2[3],
    rowAbs = _label$toUpperCase$ma2[4],
    row = _label$toUpperCase$ma2[5];
  if (column == null && row == null) return [];
  var sheetName = sheetNameStr == null ? null : label.slice(0, sheetNameStr.length).replace(/^'|'$/g, "").replace(/''/g, "'");
  return [{
    index: rowLabelToIndex(row),
    label: row,
    isAbsolute: rowAbs === "$"
  }, {
    index: columnLabelToIndex(column),
    label: column,
    isAbsolute: columnAbs === "$"
  }, sheetName];
}
/**
 * Convert row and column indexes into cell label.
 *
 * @param {Object} row Object with `index` and `isAbsolute` properties.
 * @param {Object} column Object with `index` and `isAbsolute` properties.
 * @returns {String} Returns cell label.
 */

function toLabel(row, column) {
  var rowLabel = (row.isAbsolute ? "$" : "") + rowIndexToLabel(row.index);
  var columnLabel = (column.isAbsolute ? "$" : "") + columnIndexToLabel(column.index);
  return columnLabel + rowLabel;
}
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/parser.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function parser_slicedToArray(arr, i) {
  return parser_arrayWithHoles(arr) || parser_iterableToArrayLimit(arr, i) || parser_unsupportedIterableToArray(arr, i) || parser_nonIterableRest();
}
function parser_nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function parser_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return parser_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return parser_arrayLikeToArray(o, minLen);
}
function parser_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function parser_iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function parser_arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}







/**
 * @class Parser
 */

var Parser = /*#__PURE__*/function (_Emitter) {
  _inherits(Parser, _Emitter);
  var _super = _createSuper(Parser);
  function Parser() {
    var _this;
    _classCallCheck(this, Parser);
    _this = _super.call(this);
    _this.parser = new grammar_parser_Parser();
    _this.parser.yy = {
      toNumber: toNumber,
      trimEdges: trimEdges,
      invertNumber: invertNumber,
      throwError: function throwError(errorName) {
        return _this._throwError(errorName);
      },
      callVariable: function callVariable(variable) {
        return _this._callVariable(variable);
      },
      evaluateByOperator: evaluateByOperator,
      callFunction: function callFunction(name, params) {
        return _this._callFunction(name, params);
      },
      cellValue: function cellValue(value) {
        return _this._callCellValue(value);
      },
      rangeValue: function rangeValue(start, end) {
        return _this._callRangeValue(start, end);
      }
    };
    _this.variables = Object.create(null);
    _this.functions = Object.create(null);
    _this.options = Object.create(null);
    _this.setVariable("TRUE", true).setVariable("FALSE", false).setVariable("NULL", null);
    return _this;
  }
  /**
   * Parse formula expression.
   *
   * @param {string} expression to parse.
   * @param {object} options additional params.
   * @param {string} options.sheetId id of sheet which the formula expression belongs to.
   * @return {*} Returns an object with tow properties `error` and `result`.
   */

  _createClass(Parser, [{
    key: "parse",
    value: function parse(expression, options) {
      var result = null;
      var error = null;
      this.options = options;
      try {
        if (expression === "") {
          result = "";
        } else {
          result = this.parser.parse(expression);
        }
      } catch (ex) {
        var message = error_error(ex.message);
        if (message) {
          error = message;
        } else {
          error = error_error(ERROR);
        }
      }
      if (result instanceof Error) {
        error = error_error(result.message) || error_error(ERROR);
        result = null;
      }
      return {
        error: error,
        result: result
      };
    }
    /**
     * Set predefined variable name which can be visible while parsing formula expression.
     *
     * @param {String} name Variable name.
     * @param {*} value Variable value.
     * @returns {Parser}
     */
  }, {
    key: "setVariable",
    value: function setVariable(name, value) {
      this.variables[name] = value;
      return this;
    }
    /**
     * Get variable name.
     *
     * @param {String} name Variable name.
     * @returns {*}
     */
  }, {
    key: "getVariable",
    value: function getVariable(name) {
      return this.variables[name];
    }
    /**
     * Retrieve variable value by its name.
     *
     * @param name Variable name.
     * @returns {*}
     * @private
     */
  }, {
    key: "_callVariable",
    value: function _callVariable(name) {
      var value = this.getVariable(name);
      this.emit("callVariable", name, function (newValue) {
        if (newValue !== void 0) {
          value = newValue;
        }
      });
      if (value === void 0) {
        throw Error(ERROR_NAME);
      }
      return value;
    }
    /**
     * Set custom function which can be visible while parsing formula expression.
     *
     * @param {String} name Custom function name.
     * @param {Function} fn Custom function.
     * @returns {Parser}
     */
  }, {
    key: "setFunction",
    value: function setFunction(name, fn) {
      this.functions[name] = fn;
      return this;
    }
    /**
     * Get custom function.
     *
     * @param {String} name Custom function name.
     * @returns {*}
     */
  }, {
    key: "getFunction",
    value: function getFunction(name) {
      return this.functions[name];
    }
    /**
     * Call function with provided params.
     *
     * @param name Function name.
     * @param params Function params.
     * @returns {*}
     * @private
     */
  }, {
    key: "_callFunction",
    value: function _callFunction(name) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var fn = this.getFunction(name);
      var value;
      if (fn) {
        value = fn(params);
      }
      this.emit("callFunction", name, params, function (newValue) {
        if (newValue !== void 0) {
          value = newValue;
        }
      });
      return value === void 0 ? evaluateByOperator(name, params) : value;
    }
    /**
     * Retrieve value by its label (`B3`, `B$3`, `B$3`, `$B$3`).
     *
     * @param {String} label Coordinates.
     * @returns {*}
     * @private
     */
  }, {
    key: "_callCellValue",
    value: function _callCellValue(label) {
      var _extractLabel = extractLabel(label),
        _extractLabel2 = parser_slicedToArray(_extractLabel, 3),
        row = _extractLabel2[0],
        column = _extractLabel2[1],
        sheetName = _extractLabel2[2];
      if ((column === null || column === void 0 ? void 0 : column.index) === -1) {
        if (row.isAbsolute || column.isAbsolute) {
          throw Error(ERROR_NAME);
        }
        return row.index + 1;
      } else if ((row === null || row === void 0 ? void 0 : row.index) === -1) {
        throw Error(ERROR_NAME);
      }
      var value = void 0;
      this.emit("callCellValue", {
        label: label,
        row: row,
        column: column,
        sheetName: sheetName
      }, this.options, function (_value) {
        value = _value;
      });
      return value;
    }
    /**
     * Retrieve value by its label (`B3:A1`, `B$3:A1`, `B$3:$A1`, `$B$3:A$1`).
     *
     * @param {String} startLabel Coordinates of the first cell.
     * @param {String} endLabel Coordinates of the last cell.
     * @returns {Array} Returns an array of mixed values.
     * @private
     */
  }, {
    key: "_callRangeValue",
    value: function _callRangeValue(startLabel, endLabel) {
      var _extractLabel3 = extractLabel(startLabel),
        _extractLabel4 = parser_slicedToArray(_extractLabel3, 3),
        startRow = _extractLabel4[0],
        startColumn = _extractLabel4[1],
        startSheetName = _extractLabel4[2];
      var _extractLabel5 = extractLabel(endLabel),
        _extractLabel6 = parser_slicedToArray(_extractLabel5, 3),
        endRow = _extractLabel6[0],
        endColumn = _extractLabel6[1],
        endSheetName = _extractLabel6[2];
      if (endSheetName != null && startSheetName != endSheetName) {
        throw Error(ERROR_VALUE);
      }
      var startCell = {};
      var endCell = {};
      startCell.sheetName = startSheetName;
      if (startRow.index <= endRow.index) {
        startCell.row = startRow;
        endCell.row = endRow;
      } else {
        startCell.row = endRow;
        endCell.row = startRow;
      }
      if (startColumn.index <= endColumn.index) {
        startCell.column = startColumn;
        endCell.column = endColumn;
      } else {
        startCell.column = endColumn;
        endCell.column = startColumn;
      }
      startCell.label = toLabel(startCell.row, startCell.column);
      endCell.label = toLabel(endCell.row, endCell.column);
      var value = [];
      this.emit("callRangeValue", startCell, endCell, this.options, function () {
        var _value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        value = _value;
      });
      return value;
    }
    /**
     * Try to throw error by its name.
     *
     * @param {String} errorName Error name.
     * @returns {String}
     * @private
     */
  }, {
    key: "_throwError",
    value: function _throwError(errorName) {
      if (isValidStrict(errorName)) {
        throw Error(errorName);
      }
      throw Error(ERROR);
    }
  }]);
  return Parser;
}((tiny_emitter_default()));
/* harmony default export */ var es_parser = (Parser);
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/formula-parser/es/index.js





// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(55402);
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/core/dist/index.esm.js
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread2(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){index_esm_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function index_esm_typeof(obj){"@babel/helpers - typeof";return index_esm_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},index_esm_typeof(obj);}function index_esm_classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function index_esm_defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function index_esm_createClass(Constructor,protoProps,staticProps){if(protoProps)index_esm_defineProperties(Constructor.prototype,protoProps);if(staticProps)index_esm_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function index_esm_defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function index_esm_slicedToArray(arr,i){return index_esm_arrayWithHoles(arr)||index_esm_iterableToArrayLimit(arr,i)||index_esm_unsupportedIterableToArray(arr,i)||index_esm_nonIterableRest();}function index_esm_toConsumableArray(arr){return index_esm_arrayWithoutHoles(arr)||index_esm_iterableToArray(arr)||index_esm_unsupportedIterableToArray(arr)||index_esm_nonIterableSpread();}function index_esm_arrayWithoutHoles(arr){if(Array.isArray(arr))return index_esm_arrayLikeToArray(arr);}function index_esm_arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function index_esm_iterableToArray(iter){if(typeof Symbol!=="undefined"&&iter[Symbol.iterator]!=null||iter["@@iterator"]!=null)return Array.from(iter);}function index_esm_iterableToArrayLimit(arr,i){var _i=arr==null?null:typeof Symbol!=="undefined"&&arr[Symbol.iterator]||arr["@@iterator"];if(_i==null)return;var _arr=[];var _n=true;var _d=false;var _s,_e;try{for(_i=_i.call(arr);!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function index_esm_unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return index_esm_arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return index_esm_arrayLikeToArray(o,minLen);}function index_esm_arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++)arr2[i]=arr[i];return arr2;}function index_esm_nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function index_esm_nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var en={generalDialog:{partiallyError:"Cannot perform this operation on partially merged cells",readOnlyError:"Cannot perform this operation in read-only mode",dataNullError:"Cannot perform this operation on data that does not exist",noSeletionError:"The selection operation has not been performed yet",cannotSelectMultiple:"Cannot select multiple selections"},functionlist:[{n:"SUMIF",t:0,d:"Returns a conditional sum across a range.",a:"A conditional sum across a range.",m:[2,3],p:[{name:"range",detail:"The range which is tested against `criterion`.",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"criterion",detail:"The pattern or test to apply to `range`.",example:'">20"',require:"m",repeat:"n",type:"rangeall"},{name:"sum_range",detail:"The range to be summed, if different from `range`.",example:"B1:B10",require:"o",repeat:"n",type:"range"}]},{n:"TAN",t:0,d:"Returns the tangent of an angle provided in radians.",a:"Tangent of an angle provided in radians.",m:[1,1],p:[{name:"angle",detail:"The angle to find the tangent of, in radians.",example:"45*PI()/180",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TANH",t:0,d:"Returns the hyperbolic tangent of any real number.",a:"Hyperbolic tangent of any real number.",m:[1,1],p:[{name:"value",detail:"Any real value to calculate the hyperbolic tangent of.",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CEILING",t:0,d:"Rounds a number up to the nearest integer multiple of specified significance `factor`.",a:"Rounds number up to nearest multiple of a factor.",m:[2,2],p:[{name:"value",detail:"The value to round up to the nearest integer multiple of `factor`.",example:"23.25",require:"m",repeat:"n",type:"rangenumber"},{name:"factor",detail:"The number to whose multiples `value` will be rounded.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ATAN",t:0,d:"Returns the inverse tangent of a value, in radians.",a:"Inverse tangent of a value, in radians.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse tangent.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ASINH",t:0,d:"Returns the inverse hyperbolic sine of a number.",a:"Inverse hyperbolic sine of a number.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse hyperbolic sine.",example:"0.9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ABS",t:0,d:"Returns the absolute value of a number.",a:"Absolute value of a number.",m:[1,1],p:[{name:"value",detail:"The number of which to return the absolute value.",example:"-2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ACOS",t:0,d:"Returns the inverse cosine of a value, in radians.",a:"Inverse cosine of a value, in radians.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse cosine. Must be between `-1` and `1`, inclusive.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ACOSH",t:0,d:"Returns the inverse hyperbolic cosine of a number.",a:"Inverse hyperbolic cosine of a number.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse hyperbolic cosine. Must be greater than or equal to `1`.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MULTINOMIAL",t:0,d:"Returns the factorial of the sum of values divided by the product of the values' factorials.",a:"Multinomial distribution function.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider.",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to consider.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"ATANH",t:0,d:"Returns the inverse hyperbolic tangent of a number.",a:"Inverse hyperbolic tangent of a number.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse hyperbolic tangent. Must be between -1 and 1, exclusive.",example:"0.9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ATAN2",t:0,d:"Returns the angle between the x-axis and a line segment from the origin (0,0) to specified coordinate pair (`x`,`y`), in radians.",a:"Arctangent of a value.",m:[2,2],p:[{name:"x",detail:"The x coordinate of the endpoint of the line segment for which to calculate the angle from the x-axis.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"y",detail:"The y coordinate of the endpoint of the line segment for which to calculate the angle from the x-axis.",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUNTBLANK",t:1,d:"Returns the number of empty values in a list of values and ranges.",a:"Number of empty values.",m:[1,1],p:[{name:"value1",detail:"The first value or range in which to count the number of blanks.",example:"A2:C100",require:"m",repeat:"n",type:"range"}]},{n:"COSH",t:0,d:"Returns the hyperbolic cosine of any real number.",a:"Hyperbolic cosine of any real number.",m:[1,1],p:[{name:"value",detail:"Any real value to calculate the hyperbolic cosine of.",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"INT",t:0,d:"Rounds a number down to the nearest integer that is less than or equal to it.",a:"Rounds number down to nearest integer.",m:[1,1],p:[{name:"value",detail:"The value to round down to the nearest integer.",example:"99.44",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ISEVEN",t:0,d:"Checks whether the provided value is even.",a:"Whether the provided value is even.",m:[1,1],p:[{name:"value",detail:"The value to be verified as even.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ISODD",t:0,d:"Checks whether the provided value is odd.",a:"Whether the provided value is odd.",m:[1,1],p:[{name:"value",detail:"The value to be verified as odd.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LCM",t:0,d:"Returns the least common multiple of one or more integers.",a:"Least common multiple of one or more integers.",m:[1,255],p:[{name:"value1",detail:"The first value or range whose factors to consider in a calculation to find the least common multiple.",example:"A2:A5",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges whose factors to consider to find the least common multiple.",example:"3",require:"o",repeat:"y",type:"rangeall"}]},{n:"LN",t:0,d:"Returns the logarithm of a number, base e (Euler's number).",a:"The logarithm of a number, base e (euler's number).",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the logarithm, base e.",example:"100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LOG",t:0,d:"Returns the logarithm of a number with respect to a base.",a:"The logarithm of a number with respect to a base.",m:[1,2],p:[{name:"value",detail:"The value for which to calculate the logarithm.",example:"128",require:"m",repeat:"n",type:"rangenumber"},{name:"base",detail:"The base to use for calculation of the logarithm.",example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"LOG10",t:0,d:"Returns the logarithm of a number, base 10.",a:"The logarithm of a number, base 10.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the logarithm, base 10.",example:"100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MOD",t:0,d:"Returns the result of the modulo operator, the remainder after a division operation.",a:"Modulo (remainder) operator.",m:[2,2],p:[{name:"dividend",detail:"The number to be divided to find the remainder.",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"divisor",detail:"The number to divide by.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MROUND",t:0,d:"Rounds one number to the nearest integer multiple of another.",a:"Rounds a number to the nearest integer multiple.",m:[2,2],p:[{name:"value",detail:"The number to round to the nearest integer multiple of another.",example:"21",require:"m",repeat:"n",type:"rangenumber"},{name:"factor",detail:"The number to whose multiples `value` will be rounded.",example:"14",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ODD",t:0,d:"Rounds a number up to the nearest odd integer.",a:"Rounds a number up to the nearest odd integer.",m:[1,1],p:[{name:"value",detail:"The value to round to the next greatest odd number.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMSQ",t:0,d:"Returns the sum of the squares of a series of numbers and/or cells.",a:"Sum of squares.",m:[1,255],p:[{name:"value1",detail:"The first number or range whose squares to add together.",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional numbers or ranges whose squares to add to the square(s) of `value1`.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"COMBIN",t:0,d:"Returns the number of ways to choose some number of objects from a pool of a given size of objects.",a:"Number of combinations from a set of objects.",m:[2,2],p:[{name:"n",detail:"The size of the pool of objects to choose from.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"k",detail:"The number of objects to choose.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUM",t:0,d:"Returns the sum of a series of numbers and/or cells.",a:"Sum of a series of numbers and/or cells.",m:[1,255],p:[{name:"value1",detail:"The first number or range to add together.",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional numbers or ranges to add to `value1`.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"SUBTOTAL",t:0,d:"Returns a subtotal for a vertical range of cells using a specified aggregation function.",a:"Subtotal for a range using a specific function.",m:[2,256],p:[{name:"function_code",detail:"The function to use in subtotal aggregation.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"range1",detail:"The first range over which to calculate a subtotal.",example:"A2:A5",require:"m",repeat:"n",type:"range"},{name:"range2",detail:"Additional ranges over which to calculate subtotals.",example:"B2:B8",require:"o",repeat:"y",type:"range"}]},{n:"ASIN",t:0,d:"Returns the inverse sine of a value, in radians.",a:"Inverse sine of a value, in radians.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse sine. Must be between `-1` and `1`, inclusive.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUNTIF",t:1,d:"Returns a conditional count across a range.",a:"A conditional count across a range.",m:[2,2],p:[{name:"range",detail:"The range that is tested against `criterion`.",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"criterion",detail:"The pattern or test to apply to `range`.",example:'">20"',require:"m",repeat:"n",type:"rangeall"}]},{n:"RADIANS",t:0,d:"Converts an angle value in degrees to radians.",a:"Converts an angle value in degrees to radians.",m:[1,1],p:[{name:"angle",detail:"The angle to convert from degrees to radians.",example:"180",require:"m",repeat:"n",type:"rangenumber"}]},{n:"RAND",t:0,d:"Returns a random number between 0 inclusive and 1 exclusive.",a:"A random number between 0 inclusive and 1 exclusive.",m:[0,0],p:[]},{n:"COUNTUNIQUE",t:0,d:"Counts the number of unique values in a list of specified values and ranges.",a:"Counts number of unique values in a range.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider for uniqueness.",example:"A1:C100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to consider for uniqueness.",example:"1",require:"o",repeat:"n",type:"rangeall"}]},{n:"DEGREES",t:0,d:"Converts an angle value in radians to degrees.",a:"Converts an angle value in radians to degrees.",m:[1,1],p:[{name:"angle",detail:"The angle to convert from radians to degrees.",example:"PI()",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ERFC",t:9,d:"Returns the complementary Gauss error function of a value.",a:"Complementary gauss error function of a value.",m:[1,1],p:[{name:"z",detail:"The number for which to calculate the complementary Gauss error function.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"EVEN",t:0,d:"Rounds a number up to the nearest even integer.",a:"Rounds a number up to the nearest even integer.",m:[1,1],p:[{name:"value",detail:"The value to round to the next greatest even number.",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"EXP",t:0,d:"Returns Euler's number, e (~2.718) raised to a power.",a:"Euler's number, e (~2.718) raised to a power.",m:[1,1],p:[{name:"exponent",detail:"The exponent to raise e to.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FACT",t:0,d:"Returns the factorial of a number.",a:"Factorial of a number.",m:[1,1],p:[{name:"value",detail:"The number or reference to a number whose factorial will be calculated and returned.",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FACTDOUBLE",t:0,d:'Returns the "double factorial" of a number.',a:'"double factorial" of a number.',m:[1,1],p:[{name:"value",detail:"The number or reference to a number whose double factorial will be calculated and returned.",example:"6",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PI",t:0,d:"Returns the value of Pi to 14 decimal places.",a:"The number pi.",m:[0,0],p:[]},{n:"FLOOR",t:0,d:"Rounds a number down to the nearest integer multiple of specified significance `factor`.",a:"Rounds number down to nearest multiple of a factor.",m:[2,2],p:[{name:"value",detail:"The value to round down to the nearest integer multiple of `factor`.",example:"23.25",require:"m",repeat:"n",type:"rangenumber"},{name:"factor",detail:"The number to whose multiples `value` will be rounded.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GCD",t:0,d:"Returns the greatest common divisor of one or more integers.",a:"Greatest common divisor of one or more integers.",m:[1,255],p:[{name:"value1",detail:"The first value or range whose factors to consider in a calculation to find the greatest common divisor.",example:"A2:A5",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges whose factors to consider to find the greatest common divisor.",example:"96",require:"o",repeat:"y",type:"rangeall"}]},{n:"RANDBETWEEN",t:0,d:"Returns a uniformly random integer between two values, inclusive.",a:"Random integer between two values, inclusive.",m:[2,2],p:[{name:"low",detail:"The low end of the random range.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"high",detail:"The high end of the random range.",example:"10",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ROUND",t:0,d:"Rounds a number to a certain number of decimal places according to standard rules.",a:"Rounds a number according to standard rules.",m:[2,2],p:[{name:"value",detail:"The value to round to `places` number of places.",example:"99.44",require:"m",repeat:"n",type:"rangenumber"},{name:"places",detail:"The number of decimal places to which to round.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ROUNDDOWN",t:0,d:"Rounds a number to a certain number of decimal places, always rounding down to the next valid increment.",a:"Rounds down a number.",m:[2,2],p:[{name:"value",detail:"The value to round to `places` number of places, always rounding down.",example:"99.44",require:"m",repeat:"n",type:"rangenumber"},{name:"places",detail:"The number of decimal places to which to round.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ROUNDUP",t:0,d:"Rounds a number to a certain number of decimal places, always rounding up to the next valid increment.",a:"Rounds up a number.",m:[2,2],p:[{name:"value",detail:"The value to round to `places` number of places, always rounding up.",example:"99.44",require:"m",repeat:"n",type:"rangenumber"},{name:"places",detail:"The number of decimal places to which to round.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SERIESSUM",t:0,d:"Given parameters `x`, `n`, `m`, and `a`, returns the power series sum a",a:"Sum of a power series.",m:[4,4],p:[{name:"x",detail:"The input to the power series. Varies depending on the type of approximation, may be angle, exponent, or some other value.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"n",detail:"The initial power to which to raise `x` in the power series.",example:"0",require:"m",repeat:"n",type:"rangenumber"},{name:"m",detail:"The additive increment by which to increase `x`.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"a",detail:"The array or range containing the coefficients of the power series.",example:"{FACT(0)",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SIGN",t:0,d:"Given an input number, returns `-1` if it is negative, `1` if positive, and `0` if it is zero.",a:"Sign of a provided number (+/-/0).",m:[1,1],p:[{name:"value",detail:"The value whose sign will be evaluated.",example:"-42",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SIN",t:0,d:"Returns the sine of an angle provided in radians.",a:"Sine of an angle provided in radians.",m:[1,1],p:[{name:"angle",detail:"The angle to find the sine of, in radians.",example:"PI()",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SINH",t:0,d:"Returns the hyperbolic sine of any real number.",a:"Hyperbolic sine of any real number.",m:[1,1],p:[{name:"value",detail:"Any real value to calculate the hyperbolic sine of.",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SQRT",t:0,d:"Returns the positive square root of a positive number.",a:"Positive square root of a positive number.",m:[1,1],p:[{name:"value",detail:"The number for which to calculate the positive square root.",example:"9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SQRTPI",t:0,d:"Returns the positive square root of the product of Pi and the given positive number.",a:"Square root of the product of pi and number.",m:[1,1],p:[{name:"value",detail:"The number which will be multiplied by Pi and have the product's square root returned",example:"9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GAMMALN",t:1,d:"Returns the logarithm of a specified Gamma function, base e (Euler's number).",a:"Logarithm of gamma function.",m:[1,1],p:[{name:"value",detail:"The input to the Gamma function. The natural logarithm of Gamma(`value`) will be returned.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COS",t:0,d:"Returns the cosine of an angle provided in radians.",a:"Cosine of an angle provided in radians.",m:[1,1],p:[{name:"angle",detail:"The angle to find the cosine of, in radians.",example:"PI()",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TRUNC",t:0,d:"Truncates a number to a certain number of significant digits by omitting less significant digits.",a:"Truncates a number.",m:[1,2],p:[{name:"value",detail:"The value to be truncated.",example:"3.141592654",require:"m",repeat:"n",type:"rangenumber"},{name:"places",detail:"The number of significant digits to the right of the decimal point to retain.",example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"QUOTIENT",t:0,d:"Returns one number divided by another.",a:"One number divided by another.",m:[2,2],p:[{name:"dividend",detail:"The number to be divided.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"divisor",detail:"The number to divide by.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"POWER",t:0,d:"Returns a number raised to a power.",a:"A number raised to a power.",m:[2,2],p:[{name:"base",detail:"The number to raise to the `exponent` power.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"exponent",detail:"The exponent to raise `base` to.",example:"0.5",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMIFS",t:0,d:"Returns the sum of a range depending on multiple criteria.",a:"Sums a range depending on multiple criteria.",m:[3,257],p:[{name:"sum_range",detail:"The range to sum.",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"criteria_range1",detail:"The range to check against criterion1.",example:" B1:B10",require:"m",repeat:"n",type:"range"},{name:"criterion1",detail:"The pattern or test to apply to criteria_range1.",example:' ">20"',require:"m",repeat:"n",type:"rangeall"},{name:"criteria_range2",detail:"Additional ranges to check.",example:" C1:C10",require:"o",repeat:"y",type:"rangeall"}]},{n:"COUNTIFS",t:1,d:"Returns the count of a range depending on multiple criteria.",a:"Count values depending on multiple criteria.",m:[2,256],p:[{name:"criteria_range1",detail:"The range to check against `criterion1`.",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"criterion1",detail:"The pattern or test to apply to `criteria_range1`.",example:' ">20"',require:"m",repeat:"n",type:"rangeall"},{name:"criteria_range2",detail:"Additional ranges to check.",example:" B1:B10",require:"o",repeat:"y",type:"rangeall"}]},{n:"PRODUCT",t:0,d:"Returns the result of multiplying a series of numbers together.",a:"Result of multiplying a series of numbers together.",m:[1,255],p:[{name:"factor1",detail:"The first number or range to calculate for the product.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"factor2",detail:"More numbers or ranges to calculate for the product.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"HARMEAN",t:1,d:"Calculates the harmonic mean of a dataset.",a:"The harmonic mean of a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the population.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the population.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"HYPGEOMDIST",t:1,d:"Calculates the probability of drawing a certain number of successes in a certain number of tries given a population of a certain size containing a certain number of successes, without replacement of draws.",a:"Hypergeometric distribution probability.",m:[5,5],p:[{name:"num_successes",detail:"The desired number of successes.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"num_draws",detail:"The number of permitted draws.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"successes_in_pop",detail:"The total number of successes in the population.",example:"20",require:"m",repeat:"n",type:"rangenumber"},{name:"pop_size",detail:"The total size of the population",example:"40",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Determine the logical value of the function form. \n\nIf cumulative is TRUE(), HYPGEOM.DIST returns the cumulative distribution function;\n\nif FALSE(), it returns the probability density function.",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"INTERCEPT",t:1,d:"Calculates the y-value at which the line resulting from linear regression of a dataset will intersect the y-axis (x=0).",a:"Y-intercept of line derived via linear regression.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"KURT",t:1,d:'Calculates the kurtosis of a dataset, which describes the shape, and in particular the "peakedness" of that dataset.',a:"Kurtosis of a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the dataset.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the dataset.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"LARGE",t:1,d:"Returns the nth largest element from a data set, where n is user-defined.",a:"Nth largest element from a data set.",m:[2,2],p:[{name:"data",detail:"Array or range containing the dataset to consider.",example:"A2:B100",require:"m",repeat:"n",type:"rangenumber"},{name:"n",detail:"The rank from largest to smallest of the element to return.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"STDEVA",t:1,d:"Calculates the standard deviation based on a sample, setting text to the value `0`.",a:"Standard deviation of sample (text as 0).",m:[1,255],p:[{name:"value1",detail:"The first value or range of the sample.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the sample.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"STDEVP",t:1,d:"Calculates the standard deviation based on an entire population.",a:"Standard deviation of an entire population.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the population.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the population.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"GEOMEAN",t:1,d:"Calculates the geometric mean of a dataset.",a:"The geometric mean of a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the population.",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to include in the population.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"RANK_EQ",t:1,d:"Returns the rank of a specified value in a dataset. If there is more than one entry of the same value in the dataset, the top rank of the entries will be returned.",a:"Top rank of a specified value in a dataset.",m:[2,3],p:[{name:"value",detail:"The value whose rank will be determined.",example:"A10",require:"m",repeat:"n",type:"rangenumber"},{name:"data",detail:"The array or range containing the dataset to consider.",example:"A1:A100",require:"m",repeat:"n",type:"range"},{name:"is_ascending",detail:"Whether to consider the values in `data` in descending or ascending order. If omitted, the default is descending (FALSE).",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"RANK_AVG",t:1,d:"Returns the rank of a specified value in a dataset. If there is more than one entry of the same value in the dataset, the average rank of the entries will be returned.",a:"Average rank of a specified value in a dataset.",m:[2,3],p:[{name:"value",detail:"The value whose rank will be determined.",example:"A10",require:"m",repeat:"n",type:"rangenumber"},{name:"data",detail:"The array or range containing the dataset to consider.",example:"A1:A100",require:"m",repeat:"n",type:"range"},{name:"is_ascending",detail:"Whether to consider the values in `data` in descending or ascending order. If omitted, the default is descending (FALSE).",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"PERCENTRANK_EXC",t:1,d:"Returns the percentage rank (percentile) from 0 to 1 exclusive of a specified value in a dataset.",a:"Percentage rank (percentile) from 0 to 1 exclusive.",m:[2,3],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A1:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value",detail:"The value whose percentage rank will be determined.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"significant_digits",detail:"The number of significant figures to use in the calculation. Default is 3.",example:"4",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PERCENTRANK_INC",t:1,d:"Returns the percentage rank (percentile) from 0 to 1 inclusive of a specified value in a dataset.",a:"Percentage rank (percentile) from 0 to 1 inclusive.",m:[2,3],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A1:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value",detail:"The value whose percentage rank will be determined.",example:" A2",require:"m",repeat:"n",type:"rangenumber"},{name:"significant_digits",detail:"The number of significant figures to use in the calculation. Default is 3.",example:"4",require:"o",repeat:"n",type:"rangenumber"}]},{n:"FORECAST",t:1,d:"Calculates the expected y-value for a specified x based on a linear regression of a dataset.",a:"Expected y-value based of linear regression.",m:[3,3],p:[{name:"x",detail:"The value on the x-axis to forecast.",example:"A1",require:"m",repeat:"n",type:"rangenumber"},{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FISHERINV",t:1,d:"Returns the inverse Fisher transformation of a specified value.",a:"Inverse fisher transformation of a specified value.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse Fisher transformation.",example:"0.962",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FISHER",t:1,d:"Returns the Fisher transformation of a specified value.",a:"Fisher transformation of a specified value.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the Fisher transformation.",example:"0.962",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MODE_SNGL",t:1,d:"Returns the most commonly occurring value in a dataset.",a:"Most commonly occurring value in a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating mode.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to consider when calculating mode.",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"WEIBULL_DIST",t:1,d:"Returns the value of the Weibull distribution function (or Weibull cumulative distribution function) for a specified shape and scale.",a:"Weibull distribution function.",m:[4,4],p:[{name:"x",detail:"The input to the Weibull distribution function.",example:"2.4",require:"m",repeat:"n",type:"rangenumber"},{name:"shape",detail:"The shape parameter of the Weibull distribution function.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"scale",detail:"The scale parameter of the Weibull distribution function.",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Whether to use the cumulative distribution function.",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"COUNT",t:1,d:"Returns the number of numeric values in a dataset.",a:"The number of numeric values in dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when counting.",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to consider when counting.",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"COUNTA",t:1,d:"Returns the number of values in a dataset.",a:"The number of values in a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when counting.",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to consider when counting.",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"AVEDEV",t:1,d:"Calculates the average of the magnitudes of deviations of data from a dataset's mean.",a:"Average magnitude of deviations from mean.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the sample.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the sample.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"AVERAGE",t:1,d:"Returns the numerical average value in a dataset, ignoring text.",a:"Numerical average value in a dataset, ignoring text.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the average value.",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to consider when calculating the average value.",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"AVERAGEA",t:1,d:"Returns the numerical average value in a dataset.",a:"Numerical average value in a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the average value.",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to consider when calculating the average value.",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"BINOM_DIST",t:1,d:"Calculates the probability of drawing a certain number of successes (or a maximum number of successes) in a certain number of tries given a population of a certain size containing a certain number of successes, with replacement of draws.",a:"Binomial distribution probability.",m:[4,4],p:[{name:"num_successes",detail:"The number of successes for which to calculate the probability in `num_trials` trials.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"num_trials",detail:"The number of independent trials.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"prob_success",detail:"The probability of success in any given trial.",example:"0.005",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Whether to use the binomial cumulative distribution.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"BINOM_INV",t:1,d:"Calculates the smallest value for which the cumulative binomial distribution is greater than or equal to a specified criteria.",a:"Inverse cumulative binomial distribution function.",m:[3,3],p:[{name:"num_trials",detail:"The number of independent trials.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"prob_success",detail:"The probability of success in any given trial.",example:"0.005",require:"m",repeat:"n",type:"rangenumber"},{name:"target_prob",detail:"The desired threshold probability.",example:"0.8",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CONFIDENCE_NORM",t:1,d:"Calculates the width of half the confidence interval for a normal distribution.",a:"Confidence interval for a normal distribution.",m:[3,3],p:[{name:"alpha",detail:"One minus the desired confidence level. E.g. `0.1` for `0.9`, or 90%, confidence.",example:"0.05",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation of the population.",example:"1.6",require:"m",repeat:"n",type:"rangenumber"},{name:"pop_size",detail:"The size of the population.",example:"250",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CORREL",t:1,d:"Calculates r, the Pearson product-moment correlation coefficient of a dataset.",a:"Pearson Product-Moment Correlation Coefficient.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COVARIANCE_P",t:1,d:"Calculates the covariance of a dataset.",a:"The covariance of a dataset.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COVARIANCE_S",t:1,d:"Calculates the sample covariance of a dataset.",a:"The sample covariance of a dataset.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DEVSQ",t:1,d:"Calculates the sum of squares of deviations based on a sample.",a:"The sum of squares of deviations based on a sample.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the sample.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the sample.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"EXPON_DIST",t:1,d:"Returns the value of the exponential distribution function with a specified lambda at a specified value.",a:"Exponential distribution function.",m:[3,3],p:[{name:"x",detail:"The input to the exponential distribution function.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"lambda",detail:"The lambda to specify the exponential distribution function.",example:"0.5",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Whether to use the exponential cumulative distribution.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"AVERAGEIF",t:1,d:"Returns the average of a range depending on criteria.",a:"Average of values depending on criteria.",m:[2,3],p:[{name:"criteria_range",detail:"The range to check against `criterion`.",example:"A1:A10",require:"m",repeat:"n",type:"rangeall"},{name:"criterion",detail:"The pattern or test to apply to `criteria_range`.",example:'">20"',require:"m",repeat:"n",type:"rangeall"},{name:"average_range",detail:"The range to average. If not included, `criteria_range` is used for the average instead.",example:"B1:B10",require:"o",repeat:"n",type:"rangeall"}]},{n:"AVERAGEIFS",t:1,d:"Returns the average of a range depending on multiple criteria.",a:"Average of values depending on multiple criteria.",m:[2,255],p:[{name:"average_range",detail:"The range to average.",example:"A1:A10",require:"m",repeat:"n",type:"rangeall"},{name:"criteria_range1",detail:"The range to check against `criterion1`.",example:" B1:B10",require:"m",repeat:"n",type:"rangeall"},{name:"criterion1",detail:"The pattern or test to apply to `criteria_range1`.",example:' ">20"',require:"m",repeat:"n",type:"rangeall"},{name:"criteria_range2",detail:"Additional ranges to check.",example:" C1:C10",require:"m",repeat:"n",type:"rangeall"}]},{n:"PERMUT",t:1,d:"Returns the number of ways to choose some number of objects from a pool of a given size of objects, considering order.",a:"Number of permutations from a number of objects.",m:[2,2],p:[{name:"n",detail:"The size of the pool of objects to choose from.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"k",detail:"The number of objects to choose.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TRIMMEAN",t:1,d:"Calculates the mean of a dataset excluding some proportion of data from the high and low ends of the dataset.",a:"Mean of a dataset excluding high/low ends.",m:[2,2],p:[{name:"data",detail:"Array or range containing the dataset to consider.",example:"A2:A100",require:"m",repeat:"n",type:"range"},{name:"exclude_proportion",detail:"The proportion of the dataset to exclude, from the extremities of the set.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PERCENTILE_EXC",t:1,d:"Returns the value at a given percentile of a dataset exclusive of 0 and 1.",a:"Value at a given percentile of a dataset exclusive of 0 and 1.",m:[2,2],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"percentile",detail:"The percentile, exclusive of 0 and 1, whose value within 'data' will be calculated and returned.",example:"0.25",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PERCENTILE_INC",t:1,d:"Returns the value at a given percentile of a dataset.",a:"Value at a given percentile of a dataset.",m:[2,2],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"percentile",detail:"The percentile whose value within `data` will be calculated and returned.`",example:"0.25",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PEARSON",t:1,d:"Calculates r, the Pearson product-moment correlation coefficient of a dataset.",a:"Pearson Product-Moment Correlation Coefficient.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NORM_S_INV",t:1,d:"Returns the value of the inverse standard normal distribution function for a specified value.",a:"Inverse standard normal distribution function.",m:[1,1],p:[{name:"x",detail:"The input to the inverse standard normal distribution function.",example:"0.75",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NORM_S_DIST",t:1,d:"Returns the value of the standard normal cumulative distribution function for a specified value.",a:"Standard normal cumulative distribution function.",m:[2,2],p:[{name:"x",detail:"The input to the standard normal cumulative distribution function.",example:"2.4",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Determine the logical value of the function form. \n\nIf TRUE(), it returns the cumulative distribution function;\n\nIf it is FALSE(), it returns the probability density function.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"NORM_INV",t:1,d:"Returns the value of the inverse normal distribution function for a specified value, mean, and standard deviation.",a:"Inverse normal distribution function.",m:[3,3],p:[{name:"x",detail:"The input to the inverse normal distribution function.",example:"0.75",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"The mean (mu) of the normal distribution function.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation (sigma) of the normal distribution function.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NORM_DIST",t:1,d:"Returns the value of the normal distribution function (or normal cumulative distribution function) for a specified value, mean, and standard deviation.",a:"Normal distribution function.",m:[4,4],p:[{name:"x",detail:"The input to the normal distribution function.",example:"2.4",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"The mean (mu) of the normal distribution function.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation (sigma) of the normal distribution function.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Whether to use the normal cumulative distribution function rather than the distribution function.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"NEGBINOM_DIST",t:1,d:"Calculates the probability of drawing a certain number of failures before a certain number of successes given a probability of success in independent trials.",a:"Negative binomial distribution probability.",m:[4,4],p:[{name:"num_failures",detail:"The number of failures to model.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"num_successes",detail:"The number of successes to model.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"prob_success",detail:"The probability of success in any given trial.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Determine the logical value of the function form. \n\nIf TRUE(), it returns the cumulative distribution function;\n\nIf it is FALSE(), it returns the probability density function.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"MINA",t:1,d:"Returns the minimum numeric value in a dataset.",a:"Minimum numeric value in a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the minimum value.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to consider when calculating the minimum value.",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MIN",t:1,d:"Returns the minimum value in a numeric dataset.",a:"Minimum value in a numeric dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the minimum value.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to consider when calculating the minimum value.",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MEDIAN",t:1,d:"Returns the median value in a numeric dataset.",a:"Median value in a numeric dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the median value.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to consider when calculating the median value.",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MAXA",t:1,d:"Returns the maximum numeric value in a dataset.",a:"Maximum numeric value in a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the maximum value.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to consider when calculating the maximum value.",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MAX",t:1,d:"Returns the maximum value in a numeric dataset.",a:"Maximum value in a numeric dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the maximum value.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to consider when calculating the maximum value.",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"LOGNORM_INV",t:1,d:"Returns the value of the inverse log-normal cumulative distribution with given mean and standard deviation at a specified value.",a:"Inverse log-normal cumulative distribution function.",m:[3,3],p:[{name:"x",detail:"The input to the inverse log-normal cumulative distribution function.",example:"0.4",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"The mean (mu) of the inverse log-normal cumulative distribution function.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation (sigma) of the inverse log-normal cumulative distribution function.",example:"6",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LOGNORM_DIST",t:1,d:"Returns the value of the log-normal cumulative distribution with given mean and standard deviation at a specified value.",a:"Log-normal cumulative distribution probability.",m:[4,4],p:[{name:"x",detail:"The input to the log-normal cumulative distribution function.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"The mean (mu) of the log-normal cumulative distribution function.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation (sigma) of the log-normal cumulative distribution function.",example:"6",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Determine the logical value of the function form. \n\nIf TRUE(), it returns the cumulative distribution function;\n\nIf it is FALSE(), it returns the probability density function.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"Z_TEST",t:1,d:"Returns the one-tailed p-value of a Z-test with standard distribution.",a:"One-tailed p-value of a z-test.",m:[2,3],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A2:A100",require:"m",repeat:"n",type:"range"},{name:"value",detail:"The test statistic to use in the Z-test.",example:"B2",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation to assume for the Z-test. If this is not provided, the standard deviation of the data will be used.",example:"3",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PROB",t:1,d:"Given a set of values and corresponding probabilities, calculates the probability that a value chosen at random falls between two limits.",a:"Probability values lie in a range.",m:[3,4],p:[{name:"data",detail:"Array or range containing the dataset to consider.",example:"A3:A6",require:"m",repeat:"n",type:"range"},{name:"probabilities",detail:"Array or range containing probabilities corresponding to `data`.",example:"2",require:"m",repeat:"n",type:"range"},{name:"low_limit",detail:"The lower bound on the value range for which to calculate the probability.",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"high_limit",detail:"The upper bound on the value range for which to calculate the probability.",example:"4",require:"o",repeat:"n",type:"rangenumber"}]},{n:"QUARTILE_EXC",t:1,d:"Returns a value nearest to a specified quartile of a dataset exclusive of 0 and 4.",a:"Value nearest to a specific quartile of a dataset exclusive of 0 and 4.",m:[2,2],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"quartile_number",detail:"Which quartile to return.",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"QUARTILE_INC",t:1,d:"Returns a value nearest to a specified quartile of a dataset.",a:"Value nearest to a specific quartile of a dataset.",m:[2,2],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"quartile_number",detail:"Which quartile value to return.",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"POISSON_DIST",t:1,d:"Returns the value of the Poisson distribution function (or Poisson cumulative distribution function) for a specified value and mean.",a:"Poisson distribution function.",m:[3,3],p:[{name:"x",detail:"The input to the Poisson distribution function.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"The mean (mu) of the Poisson distribution function.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Whether to use the Poisson cumulative distribution function rather than the distribution function.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"RSQ",t:1,d:"Calculates the square of r, the Pearson product-moment correlation coefficient of a dataset.",a:"Square of the correlation coefficient.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_DIST",t:1,d:"Calculates the left tail probability for a Student's t-distribution with a given input (x).",a:"The left-tailed Student's t-distribution",m:[3,3],p:[{name:"x",detail:"The input to the t-distribution function.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"The number of degrees of freedom.",example:"30",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"If cumulative is TRUE, T.DIST returns the cumulative distribution function; if FALSE, it returns the probability density function.",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"T_DIST_2T",t:1,d:"Calculates the probability for two tailed Student's t-distribution with a given input (x).",a:"The two tailed Student's t-distribution",m:[2,2],p:[{name:"x",detail:"The input to the t-distribution function.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"The number of degrees of freedom.",example:"30",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_DIST_RT",t:1,d:"Calculates the right tail probability for a Student's t-distribution with a given input (x).",a:"The right-tailed Student's t-distribution",m:[2,2],p:[{name:"x",detail:"The input to the t-distribution function.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"The number of degrees of freedom.",example:"30",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_INV",t:1,d:"Calculates the negative inverse of the one-tailed TDIST function.",a:"T.INV",m:[2,2],p:[{name:"probability",detail:"The probability associated with the two-tailed t-distribution.",example:"0.35",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"The number of degrees of freedom.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_INV_2T",t:1,d:"Calculates the inverse of the two-tailed TDIST function.",a:"T.INV.2T",m:[2,2],p:[{name:"probability",detail:"The probability associated with the two-tailed t-distribution.",example:"0.35",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"The number of degrees of freedom.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_TEST",t:1,d:"t-test. Returns the probability associated with Student's t-test. Determines whether two samples are likely to have come from the same two underlying populations that have the same mean.",a:"Returns the probability associated with t-test.",m:[4,4],p:[{name:"range1",detail:"The first sample of data or group of cells to consider for the t-test.",example:"A1:A4",require:"m",repeat:"n",type:"rangenumber"},{name:"range2",detail:"The second sample of data or group of cells to consider for the t-test.",example:"B1:B4",require:"m",repeat:"n",type:"rangenumber"},{name:"tails",detail:"Specifies the number of distribution tails.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"type",detail:"Specifies the type of t-test.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"F_DIST",t:1,d:"Calculates the left-tailed F probability distribution (degree of diversity) for two data sets with given input x. Alternately called Fisher-Snedecor distribution or Snedecor's F distribution.",a:"F probability distribution (left-tailed).",m:[4,4],p:[{name:"x",detail:"The input to the F probability distribution function. The value at which to evaluate the function.",example:"15.35",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom1",detail:"The numerator of the number of degrees of freedom.",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom2",detail:"The denominator of the number of degrees of freedom.",example:"6",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Logical value that determines the form of the function.",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"F_DIST_RT",t:1,d:"Calculates the right-tailed F probability distribution (degree of diversity) for two data sets with given input x. Alternately called Fisher-Snedecor distribution or Snedecor's F distribution.",a:"F probability distribution.",m:[3,3],p:[{name:"x",detail:"The input to the F probability distribution function. The value at which to evaluate the function.",example:"15.35",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom1",detail:"The numerator of the number of degrees of freedom.",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom2",detail:"The denominator of the number of degrees of freedom.",example:"6",require:"m",repeat:"n",type:"rangenumber"}]},{n:"VAR_P",t:1,d:"Calculates the variance based on an entire population.",a:"Variance of entire population.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the population.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the population.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"VAR_S",t:1,d:"Calculates the variance based on a sample.",a:"Variance.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the sample.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the sample.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"VARA",t:1,d:"Calculates the variance based on a sample, setting text to the value `0`.",a:"Variance of sample (text as 0).",m:[1,255],p:[{name:"value1",detail:"The first value or range of the sample.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the sample.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"VARPA",t:1,d:"Calculates the variance based on an entire population, setting text to the value `0`.",a:"Variance of entire population (text as 0).",m:[1,255],p:[{name:"value1",detail:"The first value or range of the population.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the population.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"STEYX",t:1,d:"Calculates the standard error of the predicted y-value for each x in the regression of a dataset.",a:"Standard error of predicted y-values in regression.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"STANDARDIZE",t:1,d:"Calculates the normalized equivalent of a random variable given mean and standard deviation of the distribution.",a:"Normalized equivalent of a random variable.",m:[3,3],p:[{name:"value",detail:"The value of the random variable to normalize.",example:"96",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"The mean of the distribution.",example:"80",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation of the distribution.",example:"6.7",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SMALL",t:1,d:"Returns the nth smallest element from a data set, where n is user-defined.",a:"Nth smallest element in a data set.",m:[2,2],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A2:B100",require:"m",repeat:"n",type:"range"},{name:"n",detail:"The rank from smallest to largest of the element to return.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SLOPE",t:1,d:"Calculates the slope of the line resulting from linear regression of a dataset.",a:"Slope of line from linear regression of data.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SKEW",t:1,d:"Calculates the skewness of a dataset, which describes the symmetry of that dataset about the mean.",a:"Skewness of a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the dataset.",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to include in the dataset.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"SKEW_P",t:1,d:"Calculates the skewness of a dataset, which describes the symmetry of that dataset about the mean. This assumes the dataset is for the population.",a:"Skewness of a population's dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the dataset.",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to include in the dataset.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"VLOOKUP",t:2,d:"Vertical lookup. Searches down the first column of a range for a key and returns the value of a specified cell in the row found.",a:"Vertical lookup.",m:[3,4],p:[{name:"search_key",detail:'The value to search for. For example, `42`, `"Cats"`, or `I24`.',example:"10003",require:"m",repeat:"n",type:"rangeall"},{name:"range",detail:"The range to consider for the search. The first column in the range is searched for the key specified in `search_key`.",example:"A2:B26",require:"m",repeat:"n",type:"rangeall"},{name:"index",detail:"The column index of the value to be returned, where the first column in `range` is numbered 1.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"is_sorted",detail:"Indicates whether the column to be searched (the first column of the specified range) is sorted, in which case the closest match for `search_key` will be returned.",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"HLOOKUP",t:2,d:"Horizontal lookup. Searches across the first row of a range for a key and returns the value of a specified cell in the column found.",a:"Horizontal lookup",m:[3,4],p:[{name:"search_key",detail:'The value to search for. For example, `42`, `"Cats"`, or `I24`.',example:"10003",require:"m",repeat:"n",type:"rangeall"},{name:"range",detail:"The range to consider for the search. The first row in the range is searched for the key specified in `search_key`.",example:"A2:Z6",require:"m",repeat:"n",type:"rangeall"},{name:"index",detail:"The row index of the value to be returned, where the first row in `range` is numbered 1.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"is_sorted",detail:"Indicates whether the row to be searched (the first row of the specified range) is sorted.",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"LOOKUP",t:2,d:"Looks through a sorted row or column for a key and returns the value of the cell in a result range located in the same position as the search row or column.",a:"Look up a value.",m:[2,3],p:[{name:"search_key",detail:'The value to search for in the row or column. For example, `42`, `"Cats"`, or `I24`.',example:"10003",require:"m",repeat:"n",type:"rangeall"},{name:"search_range|search_result_array",detail:"One method of using this function is to provide a single sorted row or column `search_range` to look through for the `search_key` with a second argument `result_range`. The other way is to combine these two arguments into one `search_result_array` where the first row or column is searched and a value is returned from the last row or column in the array. If `search_key` is not found, a non-exact match may be returned.",example:"A1:A100",require:"m",repeat:"n",type:"rangeall"},{name:"result_range",detail:"The range from which to return a result. The value returned corresponds to the location where `search_key` is found in `search_range`. This range must be only a single row or column and should not be used if using the `search_result_array` method.",example:"B1:B100",require:"o",repeat:"n",type:"rangeall"}]},{n:"ADDRESS",t:2,d:"Returns a cell reference as a string.",a:"Cell reference as a string.",m:[2,5],p:[{name:"row",detail:"The row number of the cell reference",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"column",detail:"The column number (not name) of the cell reference. `A` is column number `1`.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"absolute_relative_mode",detail:"An indicator of whether the reference is row/column absolute. `1` is row and column absolute (e.g. $A$1), `2` is row absolute and column relative (e.g. A$1), `3` is row relative and column absolute (e.g. $A1), and `4` is row and column relative (e.g. A1).",example:"4",require:"o",repeat:"n",type:"rangenumber"},{name:"use_a1_notation",detail:"A boolean indicating whether to use `A1` style notation (TRUE) or `R1C1` style notation (FALSE).",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"},{name:"sheet",detail:"Text indicating the name of the sheet into which the address points.",example:'"Sheet2"',require:"o",repeat:"n",type:"rangeall"}]},{n:"INDIRECT",t:2,d:"Returns a cell reference specified by a string.",a:"A cell reference specified by a string.",m:[1,2],p:[{name:"cell_reference_as_string",detail:"A cell reference, written as a string with surrounding quotation marks.",example:'"Sheet2!"&B10',require:"m",repeat:"n",type:"rangeall"},{name:"is_A1_notation",detail:"Indicates if the cell reference is in A1 notation (TRUE) or R1C1 notation (FALSE).",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"ROW",t:2,d:"Returns the row number of a specified cell.",a:"Row number of a specified cell.",m:[0,1],p:[{name:"cell_reference",detail:"The cell whose row number will be returned.",example:"A9",require:"o",repeat:"n",type:"rangeall"}]},{n:"ROWS",t:2,d:"Returns the number of rows in a specified array or range.",a:"Number of rows in a specified array or range.",m:[1,1],p:[{name:"range",detail:"The range whose row count will be returned.",example:"A9:A62",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COLUMN",t:2,d:"Returns the column number of a specified cell, with `A=1`.",a:"Column number of a specified cell.",m:[0,1],p:[{name:"cell_reference",detail:"The cell whose column number will be returned. Column `A` corresponds to `1`.",example:"A9",require:"o",repeat:"n",type:"rangeall"}]},{n:"COLUMNS",t:2,d:"Returns the number of columns in a specified array or range.",a:"Number of columns in a specified array or range.",m:[1,1],p:[{name:"range",detail:"The range whose column count will be returned.",example:"A9:W62",require:"m",repeat:"n",type:"rangenumber"}]},{n:"OFFSET",t:2,d:"Returns a range reference shifted a specified number of rows and columns from a starting cell reference.",a:"A range reference offset relative to a cell.",m:[3,5],p:[{name:"cell_reference",detail:"The starting point from which to count the offset rows and columns.",example:"A2",require:"m",repeat:"n",type:"range"},{name:"offset_rows",detail:"The number of rows to offset by.",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"offset_columns",detail:"The number of columns to offset by.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"height",detail:"The height of the range to return starting at the offset target.",example:"2",require:"o",repeat:"n",type:"rangenumber"},{name:"width",detail:"The width of the range to return starting at the offset target.",example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"MATCH",t:2,d:"Returns the relative position of an item in a range that matches a specified value.",a:"Position of item in range that matches value.",m:[2,3],p:[{name:"search_key",detail:'The value to search for. For example, `42`, `"Cats"`, or `I24`.',example:'"Sunday"',require:"m",repeat:"n",type:"rangeall"},{name:"range",detail:"The one-dimensional array to be searched.",example:"A2:A9",require:"m",repeat:"n",type:"range"},{name:"search_type",detail:"The search method. `1` (default) finds the largest value less than or equal to `search_key` when `range` is sorted in ascending order. `0` finds the exact value when `range` is unsorted. `-1` finds the smallest value greater than or equal to `search_key` when `range` is sorted in descending order.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"INDEX",t:2,d:"Returns the content of a cell, specified by row and column offset.",a:"Content of cell specified by row and column offset.",m:[2,3],p:[{name:"reference",detail:"The array of cells to be offset into.",example:"A1:C20",require:"m",repeat:"n",type:"range"},{name:"row",detail:"The number of offset rows.",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"column",detail:"The number of offset columns.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GETPIVOTDATA",t:2,d:"Extracts an aggregated value from a pivot table that corresponds to the specified row and column headings.",a:"Extracts an aggregated value from a pivot table that corresponds to the specified row and column headings.",m:[2,254],p:[{name:"value_name",detail:"The name of the value in the pivot table for which you want to get data.",example:'"SUM of number of units"',require:"m",repeat:"n",type:"rangeall"},{name:"any_pivot_table_cell",detail:"Any reference to a cell in the desired pivot table (top corner recommended).",example:"'Pivot table'!A1",require:"m",repeat:"n",type:"rangeall"},{name:"original_column",detail:"The name of the column in the original data set (not the pivot table).",example:'"division"',require:"o",repeat:"y",type:"rangeall"},{name:"pivot_item",detail:"The name of the row or column shown in the pivot table corresponding to *original_column* that you want to retrieve.",example:'"east"',require:"o",repeat:"y",type:"rangeall"}]},{n:"CHOOSE",t:2,d:"Returns an element from a list of choices based on index.",a:"An element from a list of choices based on index.",m:[2,255],p:[{name:"index",detail:"Which choice (of the up to 30 provided) to return.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"choice1",detail:"A potential value to return. Required. May be a reference to a cell or an individual value.",example:'"A"',require:"m",repeat:"n",type:"rangeall"},{name:"choice2",detail:"Additional values among which to choose.",example:'"B"',require:"o",repeat:"y",type:"rangeall"}]},{n:"HYPERLINK",t:2,d:"Creates a hyperlink inside a cell.",a:"Creates a hyperlink inside a cell.",p:[{name:"url",detail:"The full URL of the link location enclosed in quotation marks, or a reference to a cell containing such a URL.",example:'"http://www.luckysheet.com/"',require:"m",repeat:"n",type:"rangeall"},{name:"link_label",detail:"The text to display in the cell as the link, enclosed in quotation marks, or a reference to a cell containing such a label.",example:'"luckysheet"',require:"m",repeat:"n",type:"rangeall"}]},{n:"TIME",t:6,d:"Converts a provided hour, minute, and second into a time.",a:"Converts hour/minute/second into a time.",m:[3,3],p:[{name:"hour",detail:"The hour component of the time.",example:"11",require:"m",repeat:"n",type:"rangenumber"},{name:"minute",detail:"The minute component of the time.",example:"40",require:"m",repeat:"n",type:"rangenumber"},{name:"second",detail:"The second component of the time.",example:"59",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TIMEVALUE",t:6,d:"Returns the fraction of a 24-hour day the time represents.",a:"Converts a time string into its serial number representation.",m:[1,1],p:[{name:"time_string",detail:"The string that holds the time representation.",example:'"2:15 PM"',require:"m",repeat:"n",type:"rangeall"}]},{n:"EOMONTH",t:6,d:"Returns a date on the last day of a month that falls a specified number of months before or after another date.",a:"Last day of a month before or after a date.",m:[2,2],p:[{name:"start_date",detail:"The date from which to calculate the result.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"months",detail:"The number of months before (negative) or after (positive) 'start_date' to consider.",example:"7",require:"m",repeat:"n",type:"rangenumber"}]},{n:"EDATE",t:6,d:"Returns a date a specified number of months before or after another date.",a:"Date a number of months before/after another date.",m:[2,2],p:[{name:"start_date",detail:"The date from which to calculate the result.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"months",detail:"The number of months before (negative) or after (positive) 'start_date' to calculate.",example:"7",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SECOND",t:6,d:"Returns the second component of a specific time, in numeric format.",a:"Second component of a specific time.",m:[1,1],p:[{name:"time",detail:"The time from which to calculate the second component",example:"TIME(11",require:"m",repeat:"n",type:"rangeall"}]},{n:"MINUTE",t:6,d:"Returns the minute component of a specific time, in numeric format.",a:"Minute component of a specific time.",m:[1,1],p:[{name:"time",detail:"The time from which to calculate the minute component.",example:"TIME(11",require:"m",repeat:"n",type:"rangeall"}]},{n:"HOUR",t:6,d:"Returns the hour component of a specific time, in numeric format.",a:"Hour component of a specific time.",m:[1,1],p:[{name:"time",detail:"The time from which to calculate the hour component.",example:"TIME(11",require:"m",repeat:"n",type:"rangeall"}]},{n:"NOW",t:6,d:"Returns the current date and time as a date value.",a:"Current date and time as a date value.",m:[0,0],p:[]},{n:"NETWORKDAYS",t:6,d:"Returns the number of net working days between two provided days.",a:"Net working days between two provided days.",m:[2,3],p:[{name:"start_date",detail:"The start date of the period from which to calculate the number of net working days.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"The end date of the period from which to calculate the number of net working days.",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"holidays",detail:"A range or array constant containing the date serial numbers to consider holidays.",example:"16)",require:"o",repeat:"n",type:"rangeall"}]},{n:"NETWORKDAYS_INTL",t:6,d:"Returns the number of net working days between two provided days excluding specified weekend days and holidays.",a:"Net working days between two dates (specifying weekends).",m:[2,4],p:[{name:"start_date",detail:"The start date of the period from which to calculate the number of net working days.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"The end date of the period from which to calculate the number of net working days.",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"weekend",detail:"A number or string representing which days of the week are considered weekends.",example:"16)",require:"o",repeat:"n",type:"rangeall"},{name:"holidays",detail:"A range or array constant containing the dates to consider as holidays.",example:"DATE(1969",require:"o",repeat:"n",type:"rangeall"}]},{n:"ISOWEEKNUM",t:6,d:"Returns a number representing the ISO week of the year where the provided date falls.",a:"ISO week number of the year.",m:[1,1],p:[{name:"date",detail:"The date for which to determine the ISO week number. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"WEEKNUM",t:6,d:"Returns a number representing the week of the year where the provided date falls.",a:"Week number of the year.",m:[1,2],p:[{name:"date",detail:"The date for which to determine the week number. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"type",detail:"A number representing the day that a week starts on. Sunday = 1.",example:"7",require:"o",repeat:"n",type:"rangenumber"}]},{n:"WEEKDAY",t:6,d:"Returns a number representing the day of the week of the date provided.",a:"Day of the week of the date provided (as number).",m:[1,2],p:[{name:"date",detail:"The date for which to determine the day of the week. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"type",detail:"A number indicating which numbering system to use to represent weekdays. By default, counts starting with Sunday = 1.",example:"7",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DAY",t:6,d:"Returns the day of the month that a specific date falls on, in numeric format.",a:"Day of the month that a specific date falls on.",m:[1,1],p:[{name:"date",detail:"The date from which to extract the day.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"DAYS",t:6,d:"Returns the number of days between two dates.",a:"Number of days between two dates.",m:[2,2],p:[{name:"end_date",detail:"The end of the date range.",example:"2011-3-15",require:"m",repeat:"n",type:"rangeall"},{name:"start_date",detail:"The start of the date range.",example:"2011-2-1",require:"m",repeat:"n",type:"rangeall"}]},{n:"DAYS360",t:6,d:"Returns the difference between two days based on the 360 day year used in some financial interest calculations.",a:"Days between two dates on a 360-day year.",m:[2,3],p:[{name:"start_date",detail:"The start date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"The end date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"method",detail:"An indicator of what day count method to use.",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"DATE",t:6,d:"Converts a provided year, month, and day into a date.",a:"Converts year/month/day into a date.",m:[3,3],p:[{name:"year",detail:"The year component of the date.",example:"1969",require:"m",repeat:"n",type:"rangenumber"},{name:"month",detail:"The month component of the date.",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"day",detail:"The day component of the date.",example:"20",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DATEVALUE",t:6,d:"Converts a provided date string in a known format to a date value.",a:"Converts a date string to a date value.",m:[1,1],p:[{name:"date_string",detail:"The string representing the date.",example:'"1969-7-20"',require:"m",repeat:"n",type:"rangeall"}]},{n:"DATEDIF",t:6,d:"Calculates the number of days, months, or years between two dates.",a:"Date Difference.",m:[3,3],p:[{name:"start_date",detail:"The start date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"The end date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"unit",detail:'A string abbreviation for unit of time. For example, "M" for month. Accepted values are "Y","M","D","MD","YM","YD".',example:"16)",require:"m",repeat:"n",type:"rangeall"}]},{n:"WORKDAY",t:6,d:"Calculates the date after a number of working days from a specified start date.",a:"Number of working days from start date.",m:[2,3],p:[{name:"start_date",detail:"The date from which to begin counting.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"num_days",detail:"The number of working days to advance from `start_date`. If negative, counts backwards.",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"holidays",detail:"A range or array constant containing the dates to consider holidays.",example:"16)",require:"o",repeat:"n",type:"rangeall"}]},{n:"WORKDAY_INTL",t:6,d:"Calculates the date after a specified number of workdays excluding specified weekend days and holidays.",a:"Date after a number of workdays (specifying weekends).",m:[2,4],p:[{name:"start_date",detail:"The date from which to begin counting.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"num_days",detail:"The number of working days to advance from `start_date`. If negative, counts backwards.",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"weekend",detail:"A number or string representing which days of the week are considered weekends.",example:"16)",require:"o",repeat:"n",type:"rangeall"},{name:"holidays",detail:"A range or array constant containing the dates to consider holidays.",example:"DATE(1969",require:"o",repeat:"n",type:"rangeall"}]},{n:"YEAR",t:6,d:"Returns the year specified by a given date.",a:"Year specified by a given date.",m:[1,1],p:[{name:"date",detail:"The date from which to extract the year.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"YEARFRAC",t:6,d:"Returns the number of years, including fractional years, between two dates using a specified day count convention.",a:"Exact number of years between two dates.",m:[2,3],p:[{name:"start_date",detail:"The start date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"The end date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"16)",require:"o",repeat:"n",type:"rangenumber"}]},{n:"TODAY",t:6,d:"Returns the current date as a date value.",a:"Current date as a date value.",m:[0,0],p:[]},{n:"MONTH",t:6,d:"Returns the month of the year a specific date falls in, in numeric format.",a:"Month of the year a specific date falls in.",m:[1,1],p:[{name:"date",detail:"The date from which to extract the month.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"EFFECT",t:8,d:"Calculates the annual effective interest rate given the nominal rate and number of compounding periods per year.",a:"Annual effective interest rate.",m:[2,2],p:[{name:"nominal_rate",detail:"The nominal interest rate per year.",example:"0.99",require:"m",repeat:"n",type:"rangenumber"},{name:"periods_per_year",detail:"The number of compounding periods per year.",example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DOLLAR",t:12,d:"Formats a number into the currency specific to your spreadsheet locale.",a:"Formats a number as currency specific to your spreadsheet locale.",m:[1,2],p:[{name:"number",detail:"The value to be formatted.",example:"1.2351",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_places",detail:"The number of decimal places to display.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DOLLARDE",t:8,d:"Converts a price quotation given as a decimal fraction into a decimal value.",a:"Converts a decimal fraction to decimal value.",m:[2,2],p:[{name:"fractional_price",detail:"The price quotation given using fractional decimal conventions.",example:"100.10",require:"m",repeat:"n",type:"rangenumber"},{name:"unit",detail:"The units of the fraction, e.g. `8` for 1/8ths or `32` for 1/32nds.",example:"32",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DOLLARFR",t:8,d:"Converts a price quotation given as a decimal value into a decimal fraction.",a:"Converts a decimal value to decimal fraction.",m:[2,2],p:[{name:"decimal_price",detail:"The price quotation given as a decimal value.",example:"100.125",require:"m",repeat:"n",type:"rangenumber"},{name:"unit",detail:"The units of the desired fraction, e.g. `8` for 1/8ths or `32` for 1/32nds.",example:"32",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DB",t:8,d:"Calculates the depreciation of an asset for a specified period using the arithmetic declining balance method.",a:"Depreciation via declining balance method.",m:[4,5],p:[{name:"cost",detail:"The initial cost of the asset.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"The value of the asset at the end of depreciation.",example:"50",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"The number of periods over which the asset is depreciated.",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"The single period within `life` for which to calculate depreciation.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"month",detail:"The number of months in the first year of depreciation.",example:"10",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DDB",t:8,d:"Calculates the depreciation of an asset for a specified period using the double-declining balance method.",a:"Depreciation via double-declining balance method.",m:[4,5],p:[{name:"cost",detail:"The initial cost of the asset.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"The value of the asset at the end of depreciation.",example:"50",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"The number of periods over which the asset is depreciated.",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"The single period within `life` for which to calculate depreciation.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"factor",detail:"The factor by which depreciation decreases.",example:"2.25",require:"m",repeat:"n",type:"rangenumber"}]},{n:"RATE",t:8,d:"Calculates the interest rate of an annuity investment based on constant-amount periodic payments and the assumption of a constant interest rate.",a:"Interest rate of an annuity investment.",m:[3,6],p:[{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"payment_per_period",detail:"The amount per period to be paid.",example:"-100",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"400",require:"m",repeat:"n",type:"rangenumber"},{name:"future_value",detail:"The future value remaining after the final payment has been made.",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"rate_guess",detail:"An estimate for what the interest rate will be.",example:"0.1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"CUMPRINC",t:8,d:"Calculates the cumulative principal paid over a range of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",a:"Cumulative principal paid over a set of periods.",m:[6,6],p:[{name:"rate",detail:"The interest rate.",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"first_period",detail:"The number of the payment period to begin the cumulative calculation.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"last_period",detail:"The number of the payment period to end the cumulative calculation.",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUPNUM",t:8,d:"Calculates the number of coupons, or interest payments, between the settlement date and the maturity date of the investment.",a:"Number of coupons between settlement and maturity.",m:[3,4],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"02",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"SYD",t:8,d:"Calculates the depreciation of an asset for a specified period using the sum of years digits method.",a:"Depreciation via sum of years digits method.",m:[4,4],p:[{name:"cost",detail:"The initial cost of the asset.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"The value of the asset at the end of depreciation.",example:"50",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"The number of periods over which the asset is depreciated.",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"The single period within `life` for which to calculate depreciation.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TBILLEQ",t:8,d:"Calculates the equivalent annualized rate of return of a US Treasury Bill based on discount rate.",a:"Equivalent rate of return for a Treasury bill.",m:[3,3],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"discount",detail:"The discount rate of the bill at time of purchase.",example:"2)",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TBILLYIELD",t:8,d:"Calculates the yield of a US Treasury Bill based on price.",a:"The yield of a us treasury bill based on price.",m:[3,3],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"price",detail:"The price at which the security is bought per 100 face value.",example:"95",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TBILLPRICE",t:8,d:"Calculates the price of a US Treasury Bill based on discount rate.",a:"Price of US treasury bill.",m:[3,3],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"discount",detail:"The discount rate of the bill at time of purchase.",example:"0.09",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PV",t:8,d:"Calculates the present value of an annuity investment based on constant-amount periodic payments and a constant interest rate.",a:"Present value of an annuity investment.",m:[3,5],p:[{name:"rate",detail:"The interest rate.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"payment_amount",detail:"The amount per period to be paid.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"future_value",detail:"The future value remaining after the final payment has been made.",example:"D2",require:"o",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"ACCRINT",t:8,d:"Calculates the accrued interest of a security that has periodic payments.",a:"Accrued interest of security with periodic payments.",m:[6,8],p:[{name:"issue",detail:"The date the security was initially issued.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"first_payment",detail:"The first date interest will be paid.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"10000",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"calc_method",detail:"[Optional-defaults to TRUE()] - A logical value that specifies the method used to calculate the total accrued interest when the settlement date is later than the first interest accrual date. \n\nIf the value is TRUE, the total accrued interest from the issue date to the settlement date is returned. \n\nIf the value is FALSE, return the accrued interest from the first interest accrual date to the settlement date.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"ACCRINTM",t:8,d:"Calculates the accrued interest of a security that pays interest at maturity.",a:"Accrued interest of security paying at maturity.",m:[4,5],p:[{name:"issue",detail:"The date the security was initially issued.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity date of the security.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"1000",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUPDAYBS",t:8,d:"Calculates the number of days from the first coupon, or interest payment, until settlement.",a:"Number of days from first coupon to settlement.",m:[3,4],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPDAYS",t:8,d:"Calculates the number of days in the coupon, or interest payment, period that contains the specified settlement date.",a:"Days in coupon period containing settlement date.",m:[3,4],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPDAYSNC",t:8,d:"Calculates the number of days from the settlement date until the next coupon, or interest payment.",a:"Days from settlement until next coupon.",m:[3,4],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPNCD",t:8,d:"Calculates next coupon, or interest payment, date after the settlement date.",a:"Next coupon date after the settlement date.",m:[3,4],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"01)",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"DATE(2019",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPPCD",t:8,d:"Calculates last coupon, or interest payment, date before the settlement date.",a:"Last coupon date before settlement date.",m:[3,4],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"01)",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"DATE(2019",require:"o",repeat:"n",type:"rangenumber"}]},{n:"FV",t:8,d:"Calculates the future value of an annuity investment based on constant-amount periodic payments and a constant interest rate.",a:"Future value of an annuity investment.",m:[3,5],p:[{name:"rate",detail:"The interest rate.",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"payment_amount",detail:"The amount per period to be paid.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"400",require:"m",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FVSCHEDULE",t:8,d:"Calculates the future value of some principal based on a specified series of potentially varying interest rates.",a:"Future value of principal from series of rates.",m:[2,2],p:[{name:"principal",detail:"The amount of initial capital or value to compound against.",example:"10000",require:"m",repeat:"n",type:"rangenumber"},{name:"rate_schedule",detail:"A series of interest rates to compound against the `principal`.",example:"A2:A100",require:"m",repeat:"n",type:"range"}]},{n:"YIELD",t:8,d:"Calculates the annual yield of a security paying periodic interest, such as a US Treasury Bond, based on price.",a:"Annual yield of a security paying periodic interest.",m:[6,7],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.057",require:"m",repeat:"n",type:"rangenumber"},{name:"price",detail:"The price at which the security is bought per 100 face value.",example:"95",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"YIELDDISC",t:8,d:"Calculates the annual yield of a discount (non-interest-bearing) security, based on price.",a:"Annual yield of a discount security.",m:[4,5],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"price",detail:"The price at which the security is bought per 100 face value.",example:"95",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NOMINAL",t:8,d:"Calculates the annual nominal interest rate given the effective rate and number of compounding periods per year.",a:"Annual nominal interest rate.",m:[2,2],p:[{name:"effective_rate",detail:"The effective interest rate per year.",example:"0.85",require:"m",repeat:"n",type:"rangenumber"},{name:"periods_per_year",detail:"The number of compounding periods per year.",example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"XIRR",t:8,d:"Calculates the internal rate of return of an investment based on a specified series of potentially irregularly spaced cash flows.",a:"Internal rate of return given non-periodic cashflows.",m:[2,3],p:[{name:"cashflow_amounts",detail:"An array or range containing the income or payments associated with the investment.",example:"B2:B25",require:"m",repeat:"n",type:"range"},{name:"cashflow_dates",detail:"An array or range with dates corresponding to the cash flows in `cashflow_amounts`.",example:"C2:C25",require:"m",repeat:"n",type:"range"},{name:"rate_guess",detail:"An estimate for what the internal rate of return will be.",example:"250",require:"o",repeat:"n",type:"rangenumber"}]},{n:"MIRR",t:8,d:"Calculates the modified internal rate of return on an investment based on a series of periodic cash flows and the difference between the interest rate paid on financing versus the return received on reinvested income.",a:"Modified internal rate of return.",m:[3,3],p:[{name:"cashflow_amounts",detail:"An array or range containing the income or payments associated with the investment.",example:"A2:A25",require:"m",repeat:"n",type:"range"},{name:"financing_rate",detail:"The interest rate paid on funds invested.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"reinvestment_return_rate",detail:"The return (as a percentage) earned on reinvestment of income received from the investment.",example:"0.12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"IRR",t:8,d:"Calculates the internal rate of return on an investment based on a series of periodic cash flows.",a:"Internal rate of return given periodic cashflows.",m:[1,2],p:[{name:"cashflow_amounts",detail:"An array or range containing the income or payments associated with the investment.",example:"A2:A25",require:"m",repeat:"n",type:"range"},{name:"rate_guess",detail:"An estimate for what the internal rate of return will be.",example:"200",require:"o",repeat:"n",type:"rangenumber"}]},{n:"NPV",t:8,d:"Calculates the net present value of an investment based on a series of periodic cash flows and a discount rate.",a:"The net present value of an investment based on a series of periodic cash flows and a discount rate.",m:[2,255],p:[{name:"discount",detail:"The discount rate of the investment over one period.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"cashflow1",detail:"The first future cash flow.",example:"200",require:"m",repeat:"n",type:"rangeall"},{name:"cashflow2",detail:"Additional future cash flows.",example:"250",require:"o",repeat:"y",type:"rangeall"}]},{n:"XNPV",t:8,d:"Calculates the net present value of an investment based on a specified series of potentially irregularly spaced cash flows and a discount rate.",a:"Net present value given non-periodic cashflows.",m:[3,3],p:[{name:"discount",detail:"The discount rate of the investment over one period.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"cashflow_amounts",detail:"A range of cells containing the income or payments associated with the investment.",example:"B2:B25",require:"m",repeat:"n",type:"range"},{name:"cashflow_dates",detail:"A range of cells with dates corresponding to the cash flows in `cashflow_amounts`.",example:"C2:C25",require:"m",repeat:"n",type:"range"}]},{n:"CUMIPMT",t:8,d:"Calculates the cumulative interest over a range of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",a:"Cumulative interest paid over a set of periods.",m:[6,6],p:[{name:"rate",detail:"The interest rate.",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"first_period",detail:"The number of the payment period to begin the cumulative calculation.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"last_period",detail:"The number of the payment period to end the cumulative calculation.",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PMT",t:8,d:"Calculates the periodic payment for an annuity investment based on constant-amount periodic payments and a constant interest rate.",a:"Periodic payment for an annuity investment.",m:[3,5],p:[{name:"rate",detail:"The interest rate.",example:"0.08",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:" 100000",require:"m",repeat:"n",type:"rangenumber"},{name:"future_value",detail:"The future value remaining after the final payment has been made.",example:"D2",require:"m",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"IPMT",t:8,d:"Calculates the payment on interest for an investment based on constant-amount periodic payments and a constant interest rate.",a:"Payment on interest for an investment.",m:[4,6],p:[{name:"rate",detail:"The interest rate.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"The amortization period, in terms of number of periods.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"80000",require:"m",repeat:"n",type:"rangenumber"},{name:"future_value",detail:"The future value remaining after the final payment has been made.",example:"E2",require:"m",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PPMT",t:8,d:"Calculates the payment on the principal of an investment based on constant-amount periodic payments and a constant interest rate.",a:"Payment on the principal of an investment.",m:[4,6],p:[{name:"rate",detail:"The interest rate.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"The amortization period, in terms of number of periods.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"3*12",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"100000",require:"m",repeat:"n",type:"rangenumber"},{name:"future_value",detail:"The future value remaining after the final payment has been made.",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"INTRATE",t:8,d:"Calculates the effective interest rate generated when an investment is purchased at one price and sold at another with no interest or dividends generated by the investment itself.",a:"Calculates effective interest rate.",m:[4,5],p:[{name:"buy_date",detail:"The date of purchase of the investment.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"sell_date",detail:"The date of sale of the investment.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"buy_price",detail:"The price at which the investment was purchased.",example:"100000",require:"m",repeat:"n",type:"rangenumber"},{name:"sell_price",detail:"The price at which the investment was sold.",example:"101200",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PRICE",t:8,d:"Calculates the price of a security paying periodic interest, such as a US Treasury Bond, based on expected yield.",a:"Price of a security paying periodic interest.",m:[6,7],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.057",require:"m",repeat:"n",type:"rangenumber"},{name:"yield",detail:"The expected annual yield of the security.",example:"0.065",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PRICEDISC",t:8,d:"Calculates the price of a discount (non-interest-bearing) security, based on expected yield.",a:"Price of a discount security.",m:[4,5],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"discount",detail:"The discount rate of the security at time of purchase.",example:"0.0525",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PRICEMAT",t:8,d:"Calculates the price of a security paying interest at maturity, based on expected yield.",a:"Price of security paying interest at maturity.",m:[5,6],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"issue",detail:"The date the security was initially issued.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.061",require:"m",repeat:"n",type:"rangenumber"},{name:"yield",detail:"The expected annual yield of the security.",example:"0.061",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"RECEIVED",t:8,d:"Calculates the amount received at maturity for an investment in fixed-income securities purchased on a given date.",a:"Amount received at maturity for a security.",m:[4,5],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"investment",detail:"The amount invested (irrespective of face value of each security).",example:"10000000",require:"m",repeat:"n",type:"rangenumber"},{name:"discount",detail:"The discount rate of the security invested in.",example:"0.0575",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"12",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DISC",t:8,d:"Calculates the discount rate of a security based on price.",a:"The discount rate of a security based on price.",m:[4,5],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"price",detail:"The price at which the security is bought per 100 face value.",example:"97.975",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"12",require:"o",repeat:"n",type:"rangenumber"}]},{n:"NPER",t:8,d:"Calculates the number of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",a:"Number of payment periods for an investment.",m:[3,5],p:[{name:"rate",detail:"The interest rate.",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"payment_amount",detail:"The amount of each payment made.",example:"500",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"40000",require:"m",repeat:"n",type:"rangenumber"},{name:"future_value",detail:"The future value remaining after the final payment has been made.",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"SLN",t:8,d:"Calculates the depreciation of an asset for one period using the straight-line method.",a:"Depreciation of asset using the straight-line method.",m:[3,3],p:[{name:"cost",detail:"The initial cost of the asset.",example:"300000",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"The value of the asset at the end of depreciation.",example:"75000",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"The number of periods over which the asset is depreciated.",example:"10",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DURATION",t:8,d:"Calculates the number of compounding periods required for an investment of a specified present value appreciating at a given rate to reach a target value.",a:"Number of periods for an investment to reach a value.",m:[5,6],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.08",require:"m",repeat:"n",type:"rangenumber"},{name:"yield",detail:"The expected annual yield of the security.",example:"0.09",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"MDURATION",t:8,d:"Calculates the modified Macaulay duration of a security paying periodic interest, such as a US Treasury Bond, based on expected yield.",a:"Modified Macaulay duration.",m:[5,6],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.08",require:"m",repeat:"n",type:"rangenumber"},{name:"yield",detail:"The expected annual yield of the security.",example:"0.09",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"BIN2DEC",t:9,d:"Converts a signed binary number to decimal format.",a:"Converts a signed binary number to decimal format.",m:[1,1],p:[{name:"signed_binary_number",detail:"The signed 10-bit binary value to be converted to decimal, provided as a string.",example:"101",require:"m",repeat:"n",type:"rangeall"}]},{n:"BIN2HEX",t:9,d:"Converts a signed binary number to signed hexadecimal format.",a:"Converts a binary number to hexadecimal.",m:[1,2],p:[{name:"signed_binary_number",detail:"The signed 10-bit binary value to be converted to signed hexademical, provided as a string.",example:"101",require:"m",repeat:"n",type:"rangeall"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"BIN2OCT",t:9,d:"Converts a signed binary number to signed octal format.",a:"Converts a binary number to octal.",m:[1,2],p:[{name:"signed_binary_number",detail:"The signed 10-bit binary value to be converted to signed octal, provided as a string.",example:"101",require:"m",repeat:"n",type:"rangeall"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DEC2BIN",t:9,d:"Converts a decimal number to signed binary format.",a:"Converts a decimal number to signed binary format.",m:[1,2],p:[{name:"decimal_number",detail:"The decimal value to be converted to signed binary, provided as a string.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DEC2HEX",t:9,d:"Converts a decimal number to signed hexadecimal format.",a:"Converts a decimal number to hexadecimal.",m:[1,2],p:[{name:"decimal_number",detail:"The decimal value to be converted to signed hexadecimal, provided as a string.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DEC2OCT",t:9,d:"Converts a decimal number to signed octal format.",a:"Converts a decimal number to signed octal format.",m:[1,2],p:[{name:"decimal_number",detail:"The decimal value to be converted to signed octal, provided as a string.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"HEX2BIN",t:9,d:"Converts a signed hexadecimal number to signed binary format.",a:"Converts a hexadecimal number to binary.",m:[1,2],p:[{name:"signed_hexadecimal_number",detail:"The signed 40-bit hexadecimal value to be converted to signed binary, provided as a string.",example:'"f3"',require:"m",repeat:"n",type:"rangeall"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"HEX2DEC",t:9,d:"Converts a signed hexadecimal number to decimal format.",a:"Converts a hexadecimal number to decimal.",m:[1,1],p:[{name:"signed_hexadecimal_number",detail:"The signed 40-bit hexadecimal value to be converted to decimal, provided as a string.",example:'"f3"',require:"m",repeat:"n",type:"rangeall"}]},{n:"HEX2OCT",t:9,d:"Converts a signed hexadecimal number to signed octal format.",a:"Converts a hexadecimal number to octal.",m:[1,2],p:[{name:"signed_hexadecimal_number",detail:"The signed 40-bit hexadecimal value to be converted to signed octal, provided as a string.",example:'"f3"',require:"m",repeat:"n",type:"rangeall"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"OCT2BIN",t:9,d:"Converts a signed octal number to signed binary format.",a:"Converts an octal number to binary.",m:[1,2],p:[{name:"signed_octal_number",detail:"The signed 30-bit octal value to be converted to signed binary, provided as a string.",example:"37",require:"m",repeat:"n",type:"rangeall"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"OCT2DEC",t:9,d:"Converts a signed octal number to decimal format.",a:"Converts a signed octal number to decimal format.",m:[1,1],p:[{name:"signed_octal_number",detail:"The signed 30-bit octal value to be converted to decimal, provided as a string.",example:"37",require:"m",repeat:"n",type:"rangeall"}]},{n:"OCT2HEX",t:9,d:"Converts a signed octal number to signed hexadecimal format.",a:"Converts an octal number to hexadecimal.",m:[1,2],p:[{name:"signed_octal_number",detail:"The signed 30-bit octal value to be converted to signed hexadecimal, provided as a string.",example:"37",require:"m",repeat:"n",type:"rangeall"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COMPLEX",t:9,d:"Creates a complex number given real and imaginary coefficients.",a:"Creates a complex number.",m:[2,3],p:[{name:"real_part",detail:"The real coefficient.",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"imaginary_part",detail:"The imaginary coefficient.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"suffix",detail:"The suffix for the imaginary coefficient, can only be 'i' or 'j'. If omitted, 'i' will be used.",example:'"j"',require:"o",repeat:"n",type:"rangestring"}]},{n:"IMREAL",t:9,d:"Returns the real coefficient of a complex number.",a:"The real coefficient of a complex number.",m:[1,1],p:[{name:"complex_number",detail:"The complex number, in the a+bi or a+bj format.",example:'"4+5i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMAGINARY",t:9,d:"Returns the imaginary coefficient of a complex number.",a:"The imaginary coefficient of a complex number.",m:[1,1],p:[{name:"complex_number",detail:"The complex number, in the a+bi or a+bj format.",example:'"4+5i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMCONJUGATE",t:9,d:"Returns the complex conjugate of a number.",a:"The complex conjugate of a number.",m:[1,1],p:[{name:"number",detail:"The complex number to calculate the conjugate for.",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMABS",t:9,d:"Returns absolute value (or modulus) of a complex number.",a:"The absolute value of a complex number.",m:[1,1],p:[{name:"number",detail:"The complex number to calculate the absolute value of.",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"DELTA",t:9,d:"Compare two numeric values, returning 1 if they're equal.",a:"Compare two numeric values.",m:[1,2],p:[{name:"number1",detail:"The first number to compare.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"number2",detail:"The second number to compare.",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"IMSUM",t:9,d:"Returns the sum of a series of complex numbers.",a:"Sum of a series of complex numbers.",m:[1,255],p:[{name:"value1",detail:"The first complex number or range to add together.",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional complex numbers or ranges to add to `value1`.",example:'"5-3i"',require:"o",repeat:"y",type:"rangeall"}]},{n:"IMSUB",t:9,d:"Returns the difference between two complex numbers.",a:"The difference between two complex numbers.",m:[2,2],p:[{name:"first_number",detail:"The complex number to subtract second_number from.",example:'"6+5i"',require:"m",repeat:"n",type:"rangeall"},{name:"second_number",detail:"The complex number to subtract from first_number.",example:'"2+3i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMPRODUCT",t:9,d:"Returns the result of multiplying a series of complex numbers together.",a:"Result of multiplying a series of complex numbers together.",m:[1,255],p:[{name:"factor1",detail:"The first number or range to calculate for the product.",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"},{name:"factor2",detail:"Additional complex numbers or ranges to calculate for the product.",example:'"5-3i"',require:"o",repeat:"y",type:"rangeall"}]},{n:"IMDIV",t:9,d:"Returns one complex number divided by another.",a:"One complex number divided by another.",m:[2,2],p:[{name:"dividend",detail:"The complex number to be divided.",example:'"11+16i"',require:"m",repeat:"n",type:"rangeall"},{name:"divisor",detail:"The complex number to divide by.",example:'"3+2i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"NOT",t:10,d:"Returns the opposite of a logical value - `NOT(TRUE)` returns `FALSE`; `NOT(FALSE)` returns `TRUE`.",a:"Returns opposite of provided logical value.",m:[1,1],p:[{name:"logical_expression",detail:"An expression or reference to a cell holding an expression that represents some logical value.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"TRUE",t:10,d:"Returns the logical value `TRUE`.",a:"Logical value `true`.",m:[0,0],p:[]},{n:"FALSE",t:10,d:"Returns the logical value `FALSE`.",a:"Logical value `false`.",m:[0,0],p:[]},{n:"AND",t:10,d:"Returns true if all of the provided arguments are logically true, and false if any of the provided arguments are logically false.",a:"Logical `and` operator.",m:[1,255],p:[{name:"logical_expression1",detail:"An expression or reference to a cell containing an expression that represents some logical value, i.e. `TRUE` or `FALSE`, or an expression that can be coerced to a logical value.",example:'A2 = "foo"',require:"m",repeat:"n",type:"rangeall"},{name:"logical_expression2",detail:"More expressions that represent logical values.",example:'A3 = "bar"',require:"o",repeat:"y",type:"rangeall"}]},{n:"IFERROR",t:10,d:"Returns the first argument if it is not an error value, otherwise returns the second argument if present, or a blank if the second argument is absent.",a:"Value if it is not an error, otherwise 2nd argument.",m:[2,2],p:[{name:"value",detail:"The value to return if `value` itself is not an error.",example:"A1",require:"m",repeat:"n",type:"rangeall"},{name:"value_if_error",detail:"The value the function returns if `value` is an error.",example:'"Error in cell A1"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IF",t:10,d:"Returns one value if a logical expression is `TRUE` and another if it is `FALSE`.",a:"Returns value depending on logical expression.",m:[2,3],p:[{name:"logical_expression",detail:"An expression or reference to a cell containing an expression that represents some logical value, i.e. `TRUE` or `FALSE`.",example:'A2 = "foo"',require:"m",repeat:"n",type:"rangeall"},{name:"value_if_true",detail:"The value the function returns if `logical_expression` is `TRUE`.",example:'"A2 is foo"',require:"m",repeat:"n",type:"rangeall"},{name:"value_if_false",detail:"The value the function returns if `logical_expression` is `FALSE`.",example:'"A2 was false"',require:"o",repeat:"n",type:"rangeall"}]},{n:"OR",t:10,d:"Returns true if any of the provided arguments are logically true, and false if all of the provided arguments are logically false.",a:"Logical `or` operator.",m:[1,255],p:[{name:"logical_expression1",detail:"An expression or reference to a cell containing an expression that represents some logical value, i.e. `TRUE` or `FALSE`, or an expression that can be coerced to a logical value.",example:'A2 = "foo"',require:"m",repeat:"n",type:"rangeall"},{name:"logical_expression2",detail:"More expressions that evaluate to logical values.",example:' A3 = "bar"',require:"m",repeat:"n",type:"rangeall"}]},{n:"NE",t:11,d:"Returns `TRUE` if two specified values are not equal and `FALSE` otherwise. Equivalent to the `!=` operator.",a:"Not equal.",m:[2,2],p:[{name:"value1",detail:"The first value.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The value to test against `value1` for inequality.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"EQ",t:11,d:"Returns `TRUE` if two specified values are equal and `FALSE` otherwise. Equivalent to the `==` operator.",a:"Equal.",m:[2,2],p:[{name:"value1",detail:"The first value.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The value to test against `value1` for equality.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"GT",t:11,d:"Returns `TRUE` if the first argument is strictly greater than the second, and `FALSE` otherwise. Equivalent to the `>` operator.",a:"Strictly greater than.",m:[2,2],p:[{name:"value1",detail:"The value to test as being greater than `value2`.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The second value.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"GTE",t:11,d:"Returns `TRUE` if the first argument is greater than or equal to the second, and `FALSE` otherwise. Equivalent to the `>=` operator.",a:"Greater than or equal to.",m:[2,2],p:[{name:"value1",detail:"The value to test as being greater than or equal to `value2`.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The second value.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"LT",t:11,d:"Returns `TRUE` if the first argument is strictly less than the second, and `FALSE` otherwise. Equivalent to the `<` operator.",a:"Less than.",m:[2,2],p:[{name:"value1",detail:"The value to test as being less than `value2`.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The second value.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"LTE",t:11,d:"Returns `TRUE` if the first argument is less than or equal to the second, and `FALSE` otherwise. Equivalent to the `<=` operator.",a:"Less than or equal to.",m:[2,2],p:[{name:"value1",detail:"The value to test as being less than or equal to `value2`.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The second value.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"ADD",t:11,d:"Returns the sum of two numbers. Equivalent to the `+` operator.",a:"Sum of two numbers",m:[2,2],p:[{name:"value1",detail:"The first addend.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"The second addend.",example:"A3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MINUS",t:11,d:"Returns the difference of two numbers. Equivalent to the `-` operator.",a:"Difference of two numbers",m:[2,2],p:[{name:"value1",detail:"The minuend, or number to be subtracted from.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"The subtrahend, or number to subtract from `value1`.",example:"A3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MULTIPLY",t:11,d:"Returns the product of two numbers. Equivalent to the `*` operator.",a:"Product of two numbers",m:[2,2],p:[{name:"factor1",detail:"The first multiplicand.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"factor2",detail:"The second multiplicand.",example:"B2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DIVIDE",t:11,d:"Returns one number divided by another. Equivalent to the `/` operator.",a:"One number divided by another",m:[2,2],p:[{name:"dividend",detail:"The number to be divided.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"divisor",detail:"The number to divide by.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CONCAT",t:11,d:"Returns the concatenation of two values. Equivalent to the `&` operator.",a:"Concatenation of two values",m:[2,2],p:[{name:"value1",detail:"The value to which `value2` will be appended.",example:'"de"',require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The value to append to `value1`.",example:'"mystify"',require:"m",repeat:"n",type:"rangeall"}]},{n:"UNARY_PERCENT",t:11,d:"Returns a value interpreted as a percentage; that is, `UNARY_PERCENT(100)` equals `1`.",a:"Value interpreted as a percentage.",m:[1,1],p:[{name:"percentage",detail:"The value to interpret as a percentage.",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CONCATENATE",t:12,d:"Appends strings to one another.",a:"Appends strings to one another.",m:[1,255],p:[{name:"string1",detail:"The initial string.",example:'"Super"',require:"m",repeat:"n",type:"rangeall"},{name:"string2",detail:"More strings to append in sequence.",example:'"calla"',require:"o",repeat:"y",type:"rangeall"}]},{n:"CODE",t:12,d:"Returns the numeric Unicode map value of the first character in the string provided.",a:"Numeric unicode map value of character.",m:[1,1],p:[{name:"string",detail:"The string whose first character's Unicode map value will be returned.",example:'"a"',require:"m",repeat:"n",type:"rangeall"}]},{n:"CHAR",t:12,d:"Convert a number into a character according to the current Unicode table.",a:"Gets character associated with number.",m:[1,1],p:[{name:"table_number",detail:"The number of the character to look up from the current Unicode table in decimal format.",example:"97",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ARABIC",t:12,d:"Computes the value of a Roman numeral.",a:"Computes the value of a roman numeral.",m:[1,1],p:[{name:"roman_numeral",detail:"The Roman numeral to format, whose value must be between 1 and 3999, inclusive.",example:'"XIV"',require:"m",repeat:"n",type:"rangeall"}]},{n:"ROMAN",t:12,d:"Formats a number in Roman numerals.",a:"Formats a number in Roman numerals.",m:[1,1],p:[{name:"number",detail:"The number to format, between 1 and 3999, inclusive.",example:"499",require:"m",repeat:"n",type:"rangenumber"}]},{n:"REGEXEXTRACT",t:12,d:"Extracts matching substrings according to a regular expression.",a:"Extracts matching substrings with regular expression.",m:[2,2],p:[{name:"text",detail:"The input text.",example:'"Needle in a haystack"',require:"m",repeat:"n",type:"rangeall"},{name:"regular_expression",detail:"The first part of `text` that matches this expression will be returned.",example:'".e{2}dle"',require:"m",repeat:"n",type:"rangeall"}]},{n:"REGEXMATCH",t:12,d:"Whether a piece of text matches a regular expression.",a:"Whether a piece of text matches regular expression.",m:[2,2],p:[{name:"text",detail:"The text to be tested against the regular expression.",example:'"Spreadsheets"',require:"m",repeat:"n",type:"rangeall"},{name:"regular_expression",detail:"The regular expression to test the text against.",example:'"S.r"',require:"m",repeat:"n",type:"rangeall"}]},{n:"REGEXREPLACE",t:12,d:"Replaces part of a text string with a different text string using regular expressions.",a:"Replaces text with regular expressions.",m:[3,3],p:[{name:"text",detail:"The text, a part of which will be replaced.",example:'"Spreadsheets"',require:"m",repeat:"n",type:"rangeall"},{name:"regular_expression",detail:"The regular expression.  All matching instances in `text` will be replaced.",example:'"S.*d"',require:"m",repeat:"n",type:"rangeall"},{name:"replacement",detail:"The text which will be inserted into the original text.",example:'"Bed"',require:"m",repeat:"n",type:"rangeall"}]},{n:"T",t:12,d:"Returns string arguments as text, or the empty string if the value is not text.",a:"String arguments as text.",m:[1,1],p:[{name:"value",detail:"The argument to be converted to text.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"FIXED",t:12,d:"Formats a number with a fixed number of decimal places.",a:"Formats number with fixed number of decimal places.",m:[1,3],p:[{name:"number",detail:"The number to format.",example:"3.141592653",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_places",detail:"The number of decimal places to display in the result.",example:"2",require:"o",repeat:"n",type:"rangenumber"},{name:"suppress_separator",detail:"Whether or not to suppress the thousands separator used in some locales (e.g. `1,000` becomes `1000`). Separators will be present if this value is 0 or omitted, and absent otherwise.",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"FIND",t:12,d:"Returns the position at which a string is first found within text where the capitalization of letters matters. Returns `#VALUE!` if the string is not found.",a:"First position of string found in text, case-sensitive.",m:[2,3],p:[{name:"search_for",detail:"The string to look for within `text_to_search`.",example:'"n"',require:"m",repeat:"n",type:"rangeall"},{name:"text_to_search",detail:"The text to search for the first occurrence of `search_for`.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"starting_at",detail:"The character within `text_to_search` at which to start the search.",example:"14",require:"o",repeat:"n",type:"rangenumber"}]},{n:"FINDB",t:12,d:"Returns the position at which a string is first found within text counting each double-character as 2.",a:"Position at which a string is first found within text (binary).",m:[2,3],p:[{name:"search_for",detail:"The string to look for within `text_to_search`.",example:'"new"',require:"m",repeat:"n",type:"rangeall"},{name:"text_to_search",detail:"The text to search for the first occurrence of `search_for`.",example:'"new year"',require:"m",repeat:"n",type:"rangeall"},{name:"starting_at",detail:"The character within `text_to_search` at which to start the search.",example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"JOIN",t:12,d:"Concatenates the elements of one or more one-dimensional arrays using a specified delimiter.",a:"Concatenates elements of arrays with delimiter.",m:[2,255],p:[{name:"delimiter",detail:"The character or string to place between each concatenated value.",example:'" and-a "',require:"m",repeat:"n",type:"rangeall"},{name:"value_or_array1",detail:"The value or values to be appended using `delimiter`.",example:"{1",require:"m",repeat:"n",type:"rangeall"},{name:"value_or_array2",detail:"More values to be appended using `delimiter`.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"LEFT",t:12,d:"Returns a substring from the beginning of a specified string.",a:"Substring from beginning of specified string.",m:[1,2],p:[{name:"string",detail:"The string from which the left portion will be returned.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"number_of_characters",detail:"The number of characters to return from the left side of `string`.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"RIGHT",t:12,d:"Returns a substring from the end of a specified string.",a:"A substring from the end of a specified string.",m:[1,2],p:[{name:"string",detail:"The string from which the right portion will be returned.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"number_of_characters",detail:"The number of characters to return from the right side of `string`.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MID",t:12,d:"Returns a segment of a string.",a:"A segment of a string.",m:[3,3],p:[{name:"string",detail:"The string to extract a segment from.",example:'"get this"',require:"m",repeat:"n",type:"rangeall"},{name:"starting_at",detail:"The index from the left of `string` from which to begin extracting. The first character in `string` has the index 1.",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"extract_length",detail:"The length of the segment to extract.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LEN",t:12,d:"Returns the length of a string.",a:"Length of a string.",m:[1,1],p:[{name:"text",detail:"The string whose length will be returned.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"LENB",t:12,d:"Returns the length of a string in bytes.",a:"Length of a string in bytes.",m:[1,1],p:[{name:"text",detail:"The string whose length will be returned.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"LOWER",t:12,d:"Converts a specified string to lowercase.",a:"Converts a specified string to lowercase.",m:[1,1],p:[{name:"text",detail:"The string to convert to lowercase.",example:'"LOREM IPSUM"',require:"m",repeat:"n",type:"rangeall"}]},{n:"UPPER",t:12,d:"Converts a specified string to uppercase.",a:"Converts a specified string to uppercase.",m:[1,1],p:[{name:"text",detail:"The string to convert to uppercase.",example:'"lorem ipsum"',require:"m",repeat:"n",type:"rangeall"}]},{n:"EXACT",t:12,d:"Tests whether two strings are identical.",a:"Tests whether two strings are identical.",m:[2,2],p:[{name:"string1",detail:"The first string to compare",example:"A1",require:"m",repeat:"n",type:"rangeall"},{name:"string2",detail:"The second string to compare",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"REPLACE",t:12,d:"Replaces part of a text string with a different text string.",a:"Replaces part of a text string with different text.",m:[4,4],p:[{name:"text",detail:"The text, a part of which will be replaced.",example:'"Spreadsheets"',require:"m",repeat:"n",type:"rangeall"},{name:"position",detail:"The position where the replacement will begin (starting from 1).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"length",detail:"The number of characters in the text to be replaced.",example:"6",require:"m",repeat:"n",type:"rangenumber"},{name:"new_text",detail:"The text which will be inserted into the original text.",example:'"Bed"',require:"m",repeat:"n",type:"rangeall"}]},{n:"REPT",t:12,d:"Returns specified text repeated a number of times.",a:"Specified text repeated a number of times.",m:[2,2],p:[{name:"text_to_repeat",detail:"The character or string to repeat.",example:'"ha"',require:"m",repeat:"n",type:"rangeall"},{name:"number_of_repetitions",detail:"The number of times `text_to_repeat` should appear in the value returned.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SEARCH",t:12,d:"Returns the position at which a string is first found within text and ignores capitalization of letters. Returns `#VALUE!` if the string is not found.",a:"First position of string found in text, ignoring case.",m:[2,3],p:[{name:"search_for",detail:"The string to look for within `text_to_search`.",example:'"n"',require:"m",repeat:"n",type:"rangeall"},{name:"text_to_search",detail:"The text to search for the first occurrence of `search_for`.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"starting_at",detail:"The character within `text_to_search` at which to start the search.",example:"14",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUBSTITUTE",t:12,d:"Replaces existing text with new text in a string.",a:"Replaces existing text with new text in a string.",m:[3,4],p:[{name:"text_to_search",detail:"The text within which to search and replace.",example:'"search for it"',require:"m",repeat:"n",type:"rangeall"},{name:"search_for",detail:"The string to search for within `text_to_search`.",example:'"search for"',require:"m",repeat:"n",type:"rangeall"},{name:"replace_with",detail:"The string that will replace `search_for`.",example:'"Google"',require:"m",repeat:"n",type:"rangeall"},{name:"occurrence_number",detail:"The instance of `search_for` within `text_to_search` to replace with `replace_with`. By default, all occurrences of `search_for` are replaced; however, if `occurrence_number` is specified, only the indicated instance of `search_for` is replaced.",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CLEAN",t:12,d:"Returns the text with the non-printable ASCII characters removed.",a:"Removes non-printable characters from a piece of text.",m:[1,1],p:[{name:"text",detail:"The text whose non-printable characters are to be removed.",example:'"AF"&CHAR(31)',require:"m",repeat:"n",type:"rangeall"}]},{n:"TEXT",t:12,d:"Converts a number into text according to a specified format.",a:"Formats a number into text.",m:[2,2],p:[{name:"number",detail:"The number, date, or time to format.",example:"1.23",require:"m",repeat:"n",type:"rangenumber"},{name:"format",detail:"The pattern by which to format the number, enclosed in quotation marks.",example:'"$0.00"',require:"m",repeat:"n",type:"rangeall"}]},{n:"TRIM",t:12,d:"Removes leading, trailing, and repeated spaces in text.",a:"Removes space characters.",m:[1,1],p:[{name:"text",detail:"The text or reference to a cell containing text to be trimmed.",example:'" lorem ipsum"',require:"m",repeat:"n",type:"rangeall"}]},{n:"VALUE",t:12,d:"Converts a string in any of the date, time or number formats that Google Sheets understands into a number.",a:"Converts a date/time/number string into a number.",m:[1,1],p:[{name:"text",detail:"The string containing the value to be converted.",example:'"123"',require:"m",repeat:"n",type:"rangeall"}]},{n:"PROPER",t:12,d:"Capitalizes each word in a specified string.",a:"Capitalizes each word in a specified string.",m:[1,1],p:[{name:"text_to_capitalize",detail:"The text which will be returned with the first letter of each word in uppercase and all other letters in lowercase.",example:'"united states"',require:"m",repeat:"n",type:"rangeall"}]},{n:"CONVERT",t:13,d:"Converts a numeric value to a different unit of measure.",a:"Unit conversion for numbers.",m:[3,3],p:[{name:"value",detail:"The numeric value in `start_unit` to convert to `end_unit`.",example:"5.1",require:"m",repeat:"n",type:"rangenumber"},{name:"start_unit",detail:"The starting unit, the unit currently assigned to `value`.",example:'"g"',require:"m",repeat:"n",type:"rangeall"},{name:"end_unit",detail:"The unit of measure into which to convert the argument, `value`.",example:'"kg"',require:"m",repeat:"n",type:"rangeall"}]},{n:"SUMX2MY2",t:14,d:"Calculates the sum of the differences of the squares of values in two arrays.",a:"Sum of the differences of squares.",m:[2,2],p:[{name:"array_x",detail:"The array or range of values whose squares will be reduced by the squares of corresponding entries in `array_y` and added together.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"array_y",detail:"The array or range of values whose squares will be subtracted from the squares of corresponding entries in `array_x` and added together.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMX2PY2",t:14,d:"Calculates the sum of the sums of the squares of values in two arrays.",a:"Sum of the sums of squares.",m:[2,2],p:[{name:"array_x",detail:"The array or range of values whose squares will be added to the squares of corresponding entries in `array_y` and added together.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"array_y",detail:"The array or range of values whose squares will be added to the squares of corresponding entries in `array_x` and added together.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMXMY2",t:14,d:"Calculates the sum of the squares of differences of values in two arrays.",a:"Sum of the squares of differences.",m:[2,2],p:[{name:"array_x",detail:"The array or range of values that will be reduced by corresponding entries in `array_y`, squared, and added together.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"array_y",detail:"The array or range of values that will be subtracted from corresponding entries in `array_x`, the result squared, and all such results added together.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TRANSPOSE",t:14,d:"Transposes the rows and columns of an array or range of cells.",a:"Transposes the rows and columns of an array.",m:[1,1],p:[{name:"array_or_range",detail:"The array or range whose rows and columns will be swapped.",example:"{1,2}",require:"m",repeat:"n",type:"range"}]},{n:"TREND",t:14,d:"Given partial data about a linear trend, fits an ideal linear trend using the least squares method and/or predicts further values.",a:"Fits points to linear trend derived via least-squares.",m:[1,4],p:[{name:"known_data_y",detail:"The array or range containing dependent (y) values that are already known, used to curve fit an ideal linear trend.",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_data_x",detail:"The values of the independent variable(s) corresponding with `known_data_y`.",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"new_data_x",detail:"The data points to return the `y` values for on the ideal curve fit.",example:"A11:A13",require:"o",repeat:"n",type:"rangenumber"},{name:"b",detail:"Given a general linear form of `y = m*x+b` for a curve fit, calculates `b` if `TRUE` or forces `b` to be `0` and only calculates the `m` values if `FALSE`, i.e. forces the curve fit to pass through the origin.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"FREQUENCY",t:14,d:"Calculates the frequency distribution of a one-column array into specified classes.",a:"The frequency distribution of array.",m:[2,2],p:[{name:"data",detail:"The array or range containing the values to be counted.",example:"A2:A40",require:"m",repeat:"n",type:"rangenumber"},{name:"classes",detail:"The array or range containing the set of classes.",example:"B2:B5",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GROWTH",t:14,d:"Given partial data about an exponential growth trend, fits an ideal exponential growth trend and/or predicts further values.",a:"Fits points to exponential growth trend.",m:[1,4],p:[{name:"known_data_y",detail:"The array or range containing dependent (y) values that are already known, used to curve fit an ideal exponential growth curve.",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_data_x",detail:"The values of the independent variable(s) corresponding with `known_data_y`.",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"new_data_x",detail:"The data points to return the `y` values for on the ideal curve fit.",example:"A11:A13",require:"o",repeat:"n",type:"rangenumber"},{name:"b",detail:"Given a general exponential form of `y = b*m^x` for a curve fit, calculates `b` if `TRUE` or forces `b` to be `1` and only calculates the `m` values if `FALSE`.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"LINEST",t:14,d:"Given partial data about a linear trend, calculates various parameters about the ideal linear trend using the least-squares method.",a:"Best-fit linear trend via least-squares.",m:[1,4],p:[{name:"known_data_y",detail:"The array or range containing dependent (y) values that are already known, used to curve fit an ideal linear trend.",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_data_x",detail:"The values of the independent variable(s) corresponding with `known_data_y`.",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"calculate_b",detail:"Given a linear form of `y = m*x+b`, calculates the y-intercept (`b`) if `TRUE`. Otherwise, forces `b` to be `0` and only calculates the `m` values if `FALSE`, i.e. forces the curve fit to pass through the origin.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"},{name:"verbose",detail:"A flag specifying whether to return additional regression statistics or only the linear coefficients and the y-intercept (default).",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"LOGEST",t:14,d:"Given partial data about an exponential growth curve, calculates various parameters about the best fit ideal exponential growth curve.",a:"Best-fit exponential growth curve.",m:[1,4],p:[{name:"known_data_y",detail:"The array or range containing dependent (y) values that are already known, used to curve fit an ideal exponential growth curve.",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_data_x",detail:"The values of the independent variable(s) corresponding with `known_data_y`.",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"b",detail:"Given a general exponential form of `y = b*m^x` for a curve fit, calculates `b` if `TRUE` or forces `b` to be `1` and only calculates the `m` values if `FALSE`.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"},{name:"verbose",detail:"A flag specifying whether to return additional regression statistics or only the calculated coefficient and exponents.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"MDETERM",t:14,d:"Returns the matrix determinant of a square matrix specified as an array or range.",a:"Matrix determinant of a square matrix.",m:[1,1],p:[{name:"square_matrix",detail:"An array or range with an equal number of rows and columns representing a matrix whose determinant will be calculated.",example:"A1:D4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MINVERSE",t:14,d:"Returns the multiplicative inverse of a square matrix specified as an array or range.",a:"Multiplicative inverse of square matrix.",m:[1,1],p:[{name:"square_matrix",detail:"An array or range with an equal number of rows and columns representing a matrix whose multiplicative inverse will be calculated.",example:"A1:D4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MMULT",t:14,d:"Calculates the matrix product of two matrices specified as arrays or ranges.",a:"The matrix product of two matrices.",m:[2,2],p:[{name:"matrix1",detail:"The first matrix in the matrix multiplication operation, represented as an array or range.",example:"A1:B3",require:"m",repeat:"n",type:"rangenumber"},{name:"matrix2",detail:"The second matrix in the matrix multiplication operation, represented as an array or range.",example:"C1:F2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMPRODUCT",t:14,d:"Calculates the sum of the products of corresponding entries in two equal-sized arrays or ranges.",a:"Sum of products of elements in two arrays.",m:[1,255],p:[{name:"array1",detail:"The first array or range whose entries will be multiplied with corresponding entries in the second such array or range.",example:"A2:C5",require:"m",repeat:"n",type:"rangenumber"},{name:"array2",detail:"The second array or range whose entries will be multiplied with corresponding entries in the first such array or range.",example:"D2:F5",require:"o",repeat:"y",type:"rangenumber"}]},{n:"ISFORMULA",t:15,d:"Checks whether a value is a formula.",a:"Whether a value is a formula.",m:[1,1],p:[{name:"cell",detail:"The cell to be verified as containing a formula.",example:"A2",require:"m",repeat:"n",type:"range"}]},{n:"CELL",t:15,d:"Returns the requested information about the specified cell.",a:"Gets information about a cell.",m:[2,2],p:[{name:"info_type",detail:"The type of information requested (see article for available types)",example:'"type"',require:"m",repeat:"n",type:"rangeall"},{name:"reference",detail:"The reference to the cell.",example:"C2",require:"m",repeat:"n",type:"range"}]},{n:"NA",t:15,d:'Returns the "value not available" error, `#N/A`.',a:"The `#N/A` error.",m:[0,0],p:[]},{n:"ERROR_TYPE",t:15,d:"Returns a number corresponding to the error value in a different cell.",a:"Error value of cell (as number).",m:[1,1],p:[{name:"reference",detail:"The cell to find the error number for although you can also provide the error value directly.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISBLANK",t:15,d:"Checks whether the referenced cell is empty.",a:"Whether the referenced cell is empty.",m:[1,1],p:[{name:"value",detail:"Reference to the cell that will be checked for emptiness.",example:"A2",require:"m",repeat:"n",type:"range"}]},{n:"ISERR",t:15,d:"Checks whether a value is an error other than `#N/A`.",a:"Whether a value is an error other than `#n/a`.",m:[1,1],p:[{name:"value",detail:"The value to be verified as an error type other than `#N/A`.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISERROR",t:15,d:"Checks whether a value is an error.",a:"Whether a value is an error.",m:[1,1],p:[{name:"value",detail:"The value to be verified as an error type.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISLOGICAL",t:15,d:"Checks whether a value is `TRUE` or `FALSE`.",a:"Whether a value is `true` or `false`.",m:[1,1],p:[{name:"value",detail:"The value to be verified as a logical `TRUE` or `FALSE`.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISNA",t:15,d:"Checks whether a value is the error `#N/A`.",a:"Whether a value is the error `#n/a`.",m:[1,1],p:[{name:"value",detail:"The value to be compared with the error value `#N/A`.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISNONTEXT",t:15,d:"Checks whether a value is non-textual.",a:"Whether a value is non-textual.",m:[1,1],p:[{name:"value",detail:"The value to be checked.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISNUMBER",t:15,d:"Checks whether a value is a number.",a:"Whether a value is a number.",m:[1,1],p:[{name:"value",detail:"The value to be verified as a number.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISREF",t:15,d:"Checks whether a value is a valid cell reference.",a:"Whether a value is a valid cell reference.",m:[1,1],p:[{name:"value",detail:"The value to be verified as a cell reference.",example:"A2",require:"m",repeat:"n",type:"range"}]},{n:"ISTEXT",t:15,d:"Checks whether a value is text.",a:"Whether a value is text.",m:[1,1],p:[{name:"value",detail:"The value to be verified as text.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"TYPE",t:15,d:"Returns a number associated with the type of data passed into the function.",a:"Get the type of a value.",m:[1,1],p:[{name:"value",detail:"The value whose type is to be determined.",example:"C4",require:"m",repeat:"n",type:"rangeall"}]},{n:"N",t:15,d:"Returns the argument provided as a number. Text is converted to 0 and errors are returned as-is.",a:"Argument provided as a number.",m:[1,1],p:[{name:"value",detail:"The argument to be converted to a number.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"TO_DATE",t:16,d:"Converts a provided number to a date.",a:"Converts a provided number to a date.",m:[1,1],p:[{name:"value",detail:"The argument or reference to a cell to be converted to a date.",example:"25405",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TO_PURE_NUMBER",t:16,d:"Converts a provided date/time, percentage, currency or other formatted numeric value to a pure number without formatting.",a:"Converts any numeric value to a pure number.",m:[1,1],p:[{name:"value",detail:"The argument or reference to a cell to be converted to a pure number.",example:"50%",require:"m",repeat:"n",type:"rangeall"}]},{n:"TO_TEXT",t:16,d:"Converts a provided numeric value to a text value.",a:"Converts a provided numeric value to a text value.",m:[1,1],p:[{name:"value",detail:"The argument or reference to a cell to be converted to text.",example:"24",require:"m",repeat:"n",type:"rangeall"}]},{n:"TO_DOLLARS",t:16,d:"Converts a provided number to a dollar value.",a:"Converts a provided number to a dollar value.",m:[1,1],p:[{name:"value",detail:"The argument or reference to a cell to be converted to a dollar value.",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TO_PERCENT",t:16,d:"Converts a provided number to a percentage.",a:"Converts a provided number to a percentage.",m:[1,1],p:[{name:"value",detail:"The argument or reference to a cell to be converted to a percentage.",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DGET",t:17,d:"Returns a single value from a database table-like array or range using a SQL-like query.",a:"Single value from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DMAX",t:17,d:"Returns the maximum value selected from a database table-like array or range using a SQL-like query.",a:"Maximum of values from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DMIN",t:17,d:"Returns the minimum value selected from a database table-like array or range using a SQL-like query.",a:"Minimum of values from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DAVERAGE",t:17,d:"Returns the average of a set of values selected from a database table-like array or range using a SQL-like query.",a:"Average of a set of values from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DCOUNT",t:17,d:"Counts numeric values selected from a database table-like array or range using a SQL-like query.",a:"Counts values from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DCOUNTA",t:17,d:"Counts values, including text, selected from a database table-like array or range using a SQL-like query.",a:"Counts values and text from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DPRODUCT",t:17,d:"Returns the product of values selected from a database table-like array or range using a SQL-like query.",a:"Product of values from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DSTDEV",t:17,d:"Returns the standard deviation of a population sample selected from a database table-like array or range using a SQL-like query.",a:"Standard deviation of population sample from table.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DSTDEVP",t:17,d:"Returns the standard deviation of an entire population selected from a database table-like array or range using a SQL-like query.",a:"Standard deviation of entire population from table.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DSUM",t:17,d:"Returns the sum of values selected from a database table-like array or range using a SQL-like query.",a:"Sum of values from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DVAR",t:17,d:"Returns the variance of a population sample selected from a database table-like array or range using a SQL-like query.",a:"Variance of population sample from table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DVARP",t:17,d:"Returns the variance of an entire population selected from a database table-like array or range using a SQL-like query.",a:"Variance of a population from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"AGE_BY_IDCARD",t:"3",d:"Calculate the age based on the Chinese ID number. Support 15 or 18",a:"Get age based on ID number.",m:[1,2],p:[{name:"ID number",example:"A1",detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"},{name:"Deadline",example:'"2017-10-01"',detail:"The deadline or range of age calculation. The default is the current day.",require:"o",repeat:"n",type:"rangedatetime"}]},{n:"SEX_BY_IDCARD",t:"3",d:"Calculate gender based on Chinese ID number. Support 15 or 18",a:"Get gender based on ID number.",m:[1,1],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"}]},{n:"BIRTHDAY_BY_IDCARD",t:"3",d:"Calculate the birthday based on the Chinese ID number. Support 15 or 18",a:"Get the birthday based on the ID number.",m:[1,2],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"},{name:"Birthday format",example:"0",detail:"Date type, default:0:[1900/01/01], 1:[1900-01-01], 2:[1900年1月1日]",require:"o",repeat:"n",type:"rangeall"}]},{n:"PROVINCE_BY_IDCARD",t:"3",d:"Calculate the province of birthplace based on the Chinese ID number. Support 15 or 18",a:"Get the province of birthplace based on the ID number.",m:[1,1],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"}]},{n:"CITY_BY_IDCARD",t:"3",d:"Calculate the city of birthplace based on the Chinese ID number. Support 15 or 18",a:"Get the city of birthplace based on the ID number.",m:[1,1],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"}]},{n:"STAR_BY_IDCARD",t:"3",d:"Calculate the constellation based on the Chinese ID number. Support 15 or 18",a:"Get the constellation based on the ID number.",m:[1,1],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"}]},{n:"ANIMAL_BY_IDCARD",t:"3",d:"Calculate the zodiac (rat, ox, tiger, rabbit...) based on the Chinese ID number. Support 15 or 18",a:"Get the zodiac according to the ID number.",m:[1,1],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISIDCARD",t:"3",d:"Verify that the format of the ID card is correct. Support 15 or 18",a:"Verify the correctness of the ID card format.",m:[1,1],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"}]},{n:"DM_TEXT_CUTWORD",t:"4",d:"Text segmentation. Split a series of words into a series of individual words",a:"Chinese text segmentation.",m:[1,2],p:[{name:"Text",example:'"I came to Beijing Tsinghua University"',detail:"Any text that needs word segmentation.",require:"m",repeat:"n",type:"rangeall"},{name:"Word segmentation mode",example:"0",detail:"The default is 0[precision mode], 1[full mode], 2[search engine mode].",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DM_TEXT_TFIDF",t:"4",d:"Use tf-idf algorithm for keyword extraction. Identify keywords from a series of text",a:"tf-idf keyword recognition.",m:[1,3],p:[{name:"Text",example:'"I came to Beijing Tsinghua University"',detail:"Any text that needs word segmentation.",require:"m",repeat:"n",type:"rangeall"},{name:"Number of keywords",example:"20",detail:"The number of keywords returned by the algorithm, the default is 20",require:"o",repeat:"n",type:"rangenumber"},{name:"Corpus",example:"1",detail:"Select a corpus in a specific field, the default is 0[General], 1[Finance], 2[Medical]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DM_TEXT_TEXTRANK",t:"4",d:"Use TextRank algorithm to extract keywords. Identify keywords from a series of text",a:"TextRank keyword recognition.",m:[1,3],p:[{name:"Text",example:'"I came to Beijing Tsinghua University"',detail:"Any text that needs word segmentation.",require:"m",repeat:"n",type:"rangeall"},{name:"Number of keywords",example:"20",detail:"The number of keywords returned by the algorithm, the default is 20",require:"o",repeat:"n",type:"rangenumber"},{name:"Corpus",example:"1",detail:"Select a corpus in a specific field, the default is 0[General], 1[Finance], 2[Medical]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_CLOSE",t:"5",d:"According to the stock code and date, return the corresponding stock closing price of A shares.",a:"Returns the closing price of stock.",m:[1,3],p:[{name:"Stock code",example:'"000001"',detail:"6-digit stock code, required.",require:"m",repeat:"n",type:"rangeall"},{name:"Date",example:"2015-01-08",detail:"The trading day of the stock, the default is the latest trading day",require:"o",repeat:"n",type:"rangedate"},{name:"Reversion and exclusion",example:"0",detail:"Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_OPEN",t:"5",d:"According to the stock code and date, return the opening price of stock.",a:"Return the opening price of a shares.",m:[1,3],p:[{name:"Stock code",example:'"000001"',detail:"6-digit stock code, required.",require:"m",repeat:"n",type:"rangeall"},{name:"Date",example:"2015-01-08",detail:"The trading day of the stock, the default is the latest trading day",require:"o",repeat:"n",type:"rangedate"},{name:"Reversion and exclusion",example:"0",detail:"Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_MAX",t:"5",d:"According to the stock code and date, return the highest price of stock.",a:"Return the highest price of stock.",m:[1,3],p:[{name:"Stock code",example:'"000001"',detail:"6-digit stock code, required.",require:"m",repeat:"n",type:"rangeall"},{name:"Date",example:"2015-01-08",detail:"The trading day of the stock, the default is the latest trading day",require:"o",repeat:"n",type:"rangedate"},{name:"Reversion and exclusion",example:"0",detail:"Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_MIN",t:"5",d:"According to the stock code and date, return the lowest price of stock.",a:"Returns the lowest price of stock.",m:[1,3],p:[{name:"Stock code",example:'"000001"',detail:"6-digit stock code, required.",require:"m",repeat:"n",type:"rangeall"},{name:"Date",example:"2015-01-08",detail:"The trading day of the stock, the default is the latest trading day",require:"o",repeat:"n",type:"rangedate"},{name:"Reversion and exclusion",example:"0",detail:"Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_VOLUMN",t:"5",d:"According to the stock code and date, return the corresponding stock trading volume of A shares.",a:"Returns the corresponding stock trading volume of A shares.",m:[1,3],p:[{name:"Stock code",example:'"000001"',detail:"6-digit stock code, required.",require:"m",repeat:"n",type:"rangeall"},{name:"Date",example:"2015-01-08",detail:"The trading day of the stock, the default is the latest trading day",require:"o",repeat:"n",type:"rangedate"},{name:"Reversion and exclusion",example:"0",detail:"Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_AMOUNT",t:"5",d:"According to the stock code and date, return the corresponding stock turnover of A shares.",a:"Returns the corresponding stock turnover of A shares.",m:[1,3],p:[{name:"Stock code",example:'"000001"',detail:"6-digit stock code, required.",require:"m",repeat:"n",type:"rangeall"},{name:"Date",example:"2015-01-08",detail:"The trading day of the stock, the default is the latest trading day",require:"o",repeat:"n",type:"rangedate"},{name:"Reversion and exclusion",example:"0",detail:"Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"ISDATE",t:"6",d:"Returns whether a value is a date.",a:"Whether a value is a date.",m:[1,1],p:[{name:"value",example:'"1990-01-01"',detail:"The value to be verified as a date.",require:"m",repeat:"n",type:"rangeall"}]},{n:"LINESPLINES",t:"3",d:"Generate sparklines embedded in the cell to describe the continuous trend of data",a:"Generate sparklines line chart",m:[1,8],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Line color",example:"#2ec7c9",detail:"The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #2ec7c9",require:"o",repeat:"n",type:"rangeall"},{name:"Line thickness",example:"1",detail:"Line thickness of the line graph, the default is 1px",require:"o",repeat:"n",type:"rangeall"},{name:"Auxiliary line",example:"avg",detail:"A horizontal line, which can be min, max, avg, median, range or custom value, default 0 none",require:"o",repeat:"n",type:"rangeall"},{name:"Auxiliary line color",example:"#000",detail:"Color setting of auxiliary line, same as line color configuration, default #000",require:"o",repeat:"n",type:"rangeall"},{name:"Maximum mark",example:"#fc5c5c",detail:"Identifies the maximum value of the line graph, the same line color configuration, default 0 does not display",require:"o",repeat:"n",type:"rangeall"},{name:"Minimum mark",example:"#fc5c5c",detail:"Identify the minimum value of the line graph, the same line color configuration, default 0 does not display",require:"o",repeat:"n",type:"rangeall"},{name:"Mark size",example:"1.5",detail:"The maximum and minimum mark size settings, the default is 1.5",require:"o",repeat:"n",type:"rangeall"}]},{n:"AREASPLINES",t:"3",d:"Generate sparklines embedded in the cell area chart, generally used to describe the continuous cumulative value trend of the data",a:"Generate sparklines area chart",m:[1,5],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Line color",example:"#2ec7c9",detail:"The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #2ec7c9",require:"o",repeat:"n",type:"rangeall"},{name:"Fill color",example:"#CCF3F4",detail:"Form an area chart, the same line color configuration, default 0 does not display",require:"o",repeat:"n",type:"rangeall"},{name:"Line thickness",example:"1",detail:"Line thickness of the line graph, the default is 1px",require:"o",repeat:"n",type:"rangeall"},{name:"Auxiliary line",example:"avg",detail:"A horizontal line, which can be min, max, avg, median, range or custom value, default 0 none",require:"o",repeat:"n",type:"rangeall"},{name:"Auxiliary line color",example:"#000",detail:"Color setting of auxiliary line, same as line color configuration, default #000",require:"o",repeat:"n",type:"rangeall"}]},{n:"COLUMNSPLINES",t:"3",d:"Generate sparklines embedded in the vertical histogram of cells, generally used to describe the size of discrete data",a:"Generate sparklines vertical histogram",m:[1,6],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Bar interval",example:"1",detail:"The distance between bars, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Bar color",example:"#fc5c5c",detail:"The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #fc5c5c",require:"o",repeat:"n",type:"rangeall"},{name:"Negative bar color",example:"#97b552",detail:"Negative bar color setting, representing the color of negative value, same as the bar color configuration, default #97b552",require:"o",repeat:"n",type:"rangeall"},{name:"Max",example:"100",detail:"The maximum value of the bar chart, used to standardize the length of the bar chart, the default is to automatically calculate false, auto, null",require:"o",repeat:"n",type:"rangeall"},{name:"Color palette",example:"#97b552",detail:"The color palette can set the color of each bar individually, multiple settings can be set, and two formats are supported: 1 color such as #000, which means that the color of the first bar is black; 2 value range: color, such as -2:# 000 indicates that the bar with a value of -2 is black, 0:5:#000 indicates that the bar with a value of 0-5 is black, and the default is empty",require:"o",repeat:"y",type:"rangeall"}]},{n:"STACKCOLUMNSPLINES",t:"3",d:"Generate sparklines, a cumulative vertical histogram embedded in a cell, generally used to describe the numerical size of multiple dimensions of discrete data",a:"Generate sparklines cumulative vertical histogram",m:[1,5],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Stack by column",example:"1",detail:"If you need to stack by row, set this item to false or 0, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Bar interval",example:"1",detail:"The distance between bars, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Max",example:"100",detail:"The maximum value of the cumulative bar, used to regulate the length of the bar, the default is to automatically calculate false, auto, null",require:"o",repeat:"n",type:"rangeall"},{name:"Color palette",example:"#97b552",detail:"The color palette can individually set the bar color of each dimension, which can be set to the range of A1:A10, etc. The default is #2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",require:"o",repeat:"y",type:"rangeall"}]},{n:"BARSPLINES",t:"3",d:"Generate sparklines embedded in the cell, generally used to describe the size of discrete data",a:"Generate sparklines horizontal bar graph",m:[1,6],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Bar interval",example:"1",detail:"The distance between bars, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Bar color",example:"#fc5c5c",detail:"The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #fc5c5c",require:"o",repeat:"n",type:"rangeall"},{name:"Negative bar color",example:"#97b552",detail:"Negative bar color setting, representing the color of negative value, same as the bar color configuration, default #97b552",require:"o",repeat:"n",type:"rangeall"},{name:"Max",example:"100",detail:"The maximum value of the bar chart, used to standardize the length of the bar chart, the default is to automatically calculate false, auto, null",require:"o",repeat:"n",type:"rangeall"},{name:"Color palette",example:"#97b552",detail:"The color palette can set the color of each bar individually, multiple settings can be set, and two formats are supported: 1 color such as #000, which means that the color of the first bar is black; 2 value range: color, such as -2:# 000 indicates that the bar with a value of -2 is black, 0:5:#000 indicates that the bar with a value of 0-5 is black, and the default is empty",require:"o",repeat:"y",type:"rangeall"}]},{n:"STACKBARSPLINES",t:"3",d:"Generate sparklines, a cumulative horizontal bar graph embedded in a cell, which is generally used to describe the numerical size of multiple dimensions of discrete data",a:"Generate sparklines cumulative horizontal bar graph",m:[1,5],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Stack by column",example:"1",detail:"If you need to stack by row, set this item to false or 0, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Bar interval",example:"1",detail:"The distance between bars, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Max",example:"100",detail:"The maximum value of the cumulative bar, used to regulate the length of the bar, the default is to automatically calculate false, auto, null",require:"o",repeat:"n",type:"rangeall"},{name:"Color palette",example:"#97b552",detail:"The color palette can individually set the bar color of each dimension, which can be set to the range of A1:A10, etc. The default is #2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",require:"o",repeat:"y",type:"rangeall"}]},{n:"DISCRETESPLINES",t:"3",d:"Generate sparklines embedded in the cell, generally used to describe the trend of discrete data",a:"Generate sparklines discrete graph",m:[1,4],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Segmentation threshold",example:"1",detail:"Discrete graph column color distinction, for example: if the value is 0, blue is greater than 0, red is less than 0, and the default is 0",require:"o",repeat:"n",type:"rangeall"},{name:"Above threshold color",example:"#2ec7c9",detail:"The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #2ec7c9",require:"o",repeat:"n",type:"rangeall"},{name:"Below threshold color",example:"#fc5c5c",detail:"The color setting of the bar below the threshold, the same as the color above the threshold, default #fc5c5c",require:"o",repeat:"n",type:"rangeall"}]},{n:"TRISTATESPLINES",t:"3",d:"Generate sparklines, a three-state graph embedded in the cell, which is generally used to describe the trend of three situations, such as winning, losing, or drawing.",a:"Generate sparklines three-state graph",m:[1,6],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Bar interval",example:"1",detail:"The distance between bars, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Bar color",example:"#fc5c5c",detail:"The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #fc5c5c",require:"o",repeat:"n",type:"rangeall"},{name:"Negative bar color",example:"#97b552",detail:"Negative bar color setting, representing the color of negative value, same as the bar color configuration, default #97b552",require:"o",repeat:"n",type:"rangeall"},{name:"Zero value bar color",example:"#999",detail:"Zero value bar color setting, representing 0 value color, the same color configuration of the bar, default #999",require:"o",repeat:"n",type:"rangeall"},{name:"Color palette",example:"#97b552",detail:"The color palette can set the color of each bar individually, multiple settings can be set, and two formats are supported: 1 color such as #000, which means that the color of the first bar is black; 2 value range: color, such as -2:# 000 indicates that the bar with a value of -2 is black, 0:5:#000 indicates that the bar with a value of 0-5 is black, and the default is empty",require:"o",repeat:"y",type:"rangeall"}]},{n:"PIESPLINES",t:"3",d:"Generate sparklines pie chart embedded in the cell, generally used to describe the proportion of data",a:"Generate sparklines pie chart",m:[1,5],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Rotation angle",example:"0",detail:"The rotation angle of the pie chart, the default is 0",require:"o",repeat:"n",type:"rangeall"},{name:"border",example:"0",detail:"Pie chart border size, default is none 0",require:"o",repeat:"n",type:"rangeall"},{name:"Border color",example:"#000",detail:"The border color of the pie chart, the default is #000",require:"o",repeat:"n",type:"rangeall"},{name:"Color palette",example:"#97b552",detail:"The color of the slice can be set in the palette, which can be set to the range of A1:A10, etc. The default is #2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",require:"o",repeat:"y",type:"rangeall"}]},{n:"BOXSPLINES",t:"3",d:"Generate sparklines embedded in the cell box plot, generally used to describe the statistical distribution of the data set",a:"Generate sparklines box plot",m:[1,4],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Outlier ratio",example:"1.5",detail:"The threshold range of outliers, if it is 0 or false, it will not be displayed, the default is 1.5 times",require:"o",repeat:"n",type:"rangeall"},{name:"Target value",example:"10",detail:"The target value setting on the box plot, the default is false and does not display",require:"o",repeat:"n",type:"rangeall"},{name:"Point size",example:"1.5",detail:"The radius of the target point and outlier is set, the default is 1.5",require:"o",repeat:"n",type:"rangeall"}]},{n:"BULLETSPLINES",t:"3",d:"Generate sparklines embedded in the cell, generally used to describe the task achievement rate",a:"Generating sparklines bullets",m:[2,3],p:[{name:"Target",example:"10",detail:"The numerical value can be calculated effectively for the achieved target value, such as A1, 100, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"achieved",example:"8",detail:"Only when the value is completed can the value be calculated effectively, such as A1, 100, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Contrast",example:"12",detail:"Comparative values, such as excess, minimum, and bottom line for awards, can be effectively calculated, such as A1, 100, etc. You can set up to 9 comparison values",require:"o",repeat:"y",type:"rangeall"}]},{n:"COMPOSESPLINES",t:"3",d:"Support multiple types of pictures in the same cell, each parameter represents a sparklines diagram",a:"Combine sparklines graphs into one cell",m:[1,1],p:[{name:"config",example:"PIESPLINES(A1:A20)",detail:"Sparklines chart settings, such as A1:A20, a completed pie chart, line chart settings, etc.",require:"m",repeat:"y",type:"rangeall"}]},{n:"SORT",t:"14",d:"Sorts the rows of a given array or range by the values in one or more columns.",a:"Sorts rows of range by specified column.",m:[1,4],p:[{name:"range",detail:"The data to be sorted.",example:"A2:A17",require:"m",repeat:"n",type:"rangenumber"},{name:"sort_column",detail:"The index of the column in `range` or a range outside of `range` containing the values by which to sort.",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"is_ascending",detail:"`TRUE` or `FALSE` indicating whether to sort `sort_column` in ascending order. `FALSE` sorts in descending order.",example:"-1",require:"o",repeat:"n",type:"rangenumber"},{name:"sort_column2",detail:"Additional columns.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"FILTER",t:"14",d:"Returns a filtered version of the source range, returning only rows or columns which meet the specified conditions.",a:"Filters a range based off provided conditions.",m:[2,3],p:[{name:"range",detail:"The data to be filtered.",example:"A5:D20",require:"m",repeat:"n",type:"range"},{name:"condition1",detail:"A column or row containing true or false values corresponding to the first column or row of `range`, or an array formula evaluating to true or false.",example:"1",require:"m",repeat:"n",type:"range"},{name:"condition2",detail:"Additional rows or columns containing boolean values `TRUE` or `FALSE` indicating whether the corresponding row or column in `range` should pass through `FILTER`. Can also contain array formula expressions which evaluate to such rows or columns. All conditions must be of the same type (row or column). Mixing row conditions and column conditions is not permitted.",example:'""',require:"o",repeat:"n",type:"rangeall"}]},{n:"UNIQUE",t:"14",d:"Returns unique rows in the provided source range, discarding duplicates. Rows are returned in the order in which they first appear in the source range.",a:"Unique rows in the provided source range.",m:[1,3],p:[{name:"range",detail:"The data to filter by unique entries.",example:"A2:B26",require:"m",repeat:"n",type:"rangenumber"},{name:"by_col",detail:"[Option] - Logical value, indicating how to compare; by row = FALSE() or omitted; by column = TRUE().",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"},{name:"occurs_once",detail:"[Option] - Logical value, only one occurrence in the unique value is returned = TRUE(); including all unique values = FALSE() or omitted.",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"RANDARRAY",t:"14",d:"Returns a grid of random numbers between 0 inclusive and 1 exclusive. The grid size will match the provided rows and columns arguments. If neither rows nor columns are provided, then the grid will be size 1 x 1.",a:"Returns a grid of random numbers.",m:[0,2],p:[{name:"rows",detail:"The number of rows to populate with a random number.",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"columns",detail:"The number of columns to populate with a random number.",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"SEQUENCE",t:"14",d:"Returns a grid of sequential numbers starting at a specified start value and  increasing by a specified step size. By default, the sequence starts at and  increases by 1.",a:"Returns a grid of sequential numbers.",m:[1,4],p:[{name:"rows",detail:"The number of rows in the function's resulting grid.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"columns",detail:"The number of columns in the function's resulting grid. If omitted, the result grid will have 1 column.",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"start",detail:"The number, at which to start the sequence. If omitted, the sequence will start at 1.",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"step",detail:"The amount each value in the sequence will differ by. If omitted, each value will differ by 1.",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"EVALUATE",t:"3",d:"Evaluate a formula or expression expressed in words and return the result",a:"Evaluate according to literal formula or expression.",m:[1,1],p:[{name:"expression",example:'"A1+5*2^2"',detail:"Formula or expression",require:"m",repeat:"n",type:"rangeall"}]},{n:"REMOTE",t:"5",d:"Calls a function on a remote server",a:"Calls a function on a remote back end server/API.",m:[1,1],p:[{name:"remote_expression",example:"SUM(A1:A10000000)",detail:"Formula",require:"m",repeat:"n",type:"string"}]}],toolbar:{toolbar:"Toolbar",undo:"Undo",redo:"Redo","clear-format":"Clear Format","format-painter":"Format-Painter",paintFormat:"Paint format","currency-format":"Format as currency","percentage-format":"Format as percent","number-decrease":"Decrease decimal places","number-increase":"Increase decimal places",moreFormats:"More formats","border-all":"Border All","merge-all":"Merge All Cell",font:"Font","font-size":"Font size",bold:"Bold (Ctrl+B)",italic:"Italic (Ctrl+I)","strike-through":"Strikethrough (Alt+Shift+5)",underline:"Underline","font-color":"Font color","align-left":"Left aligned","align-center":"Horizontal Center","align-right":"Right aligned","align-top":"Top aligned","align-mid":"Vertical Center","align-bottom":"Bottom aligned",chooseColor:"choose color",resetColor:"Reset",customColor:"CUSTOM",alternatingColors:"Alternating colors",confirmColor:"OK",cancelColor:"Cancel",collapse:"Collapse",background:"Fill color",border:"Border",borderStyle:"Border style","merge-cell":"Merge cells",chooseMergeType:"Choose merge type",horizontalAlign:"Horizontal align",verticalAlign:"Vertical align",alignment:"Alignment",textWrap:"Text wrap",textWrapMode:"Text wrap mode",textRotate:"Text rotate",textRotateMode:"Text rotate mode",freeze:"Freeze",sort:"Sort",filter:"Filter",sortAndFilter:"Sort and filter",findAndReplace:"Find and replace","formula-sum":"SUM",autoSum:"Auto SUM",moreFunction:"More functions",conditionalFormat:"Conditional format",comment:"Comment",pivotTable:"Pivot Table",chart:"Chart",screenshot:"Screenshot",splitColumn:"Split text",insertImage:"Insert image",insertLink:"Insert link",dataVerification:"Data verification",protection:"Protect the sheet",clearText:"Clear color",noColorSelectedText:"No color is selected",toolMore:"More",toolLess:"Less",toolClose:"Close",toolMoreTip:"More features",moreOptions:"More options",cellFormat:"Cell format config",print:"Print"},alternatingColors:{applyRange:"Apply to range",selectRange:"Select a data range",header:"Header",footer:"Footer",errorInfo:"Cannot perform this operation on multiple selection areas, please select a single area and try again",textTitle:"Format style",custom:"CUSTOM",close:"close",selectionTextColor:"Click to select text color",selectionCellColor:"Click to select cell color",removeColor:"Remove alternating colors",colorShow:"color",currentColor:"Current",tipSelectRange:"Please select the range of alternating colors",errorNoRange:"No range is selected",errorExistColors:"Alternating colors already exist and cannot be edited"},button:{confirm:"OK",cancel:"Cancel",close:"Close",update:"Update",delete:"Delete",insert:"Insert",prevPage:"Previous",nextPage:"Next",total:"total:"},paint:{start:"Paint format start",end:"ESC",tipSelectRange:"Please select the range to be copied",tipNotMulti:"Cannot perform this operation on multiple selection ranges"},format:{moreCurrency:"More currency formats",moreDateTime:"More date and time formats",moreNumber:"More number formats",titleCurrency:"Currency formats",decimalPlaces:"Decimal places",titleDateTime:"Date and time formats",titleNumber:"Number formats",tipDecimalPlaces:"The decimal places must be between 0-9!",select:"Select",format:"format",currency:"currency"},info:{detailUpdate:"New opened",detailSave:"Local cache restored",row:"",column:"",loading:"Loading...",copy:"Copy",return:"Exit",rename:"Rename",tips:"WorkBook rename",noName:"Untitled spreadsheet",wait:"waiting for update",add:"Add",addLast:"more rows at bottom",backTop:"Back to the top",pageInfo:"Total ${total}，${totalPage} page，current ${currentPage}",nextPage:"Next",tipInputNumber:"Please enter the number",tipInputNumberLimit:"The increase range is limited to 1-100",tipRowHeightLimit:"Row height must be between 0 ~ 545",tipColumnWidthLimit:"The column width must be between 0 ~ 2038",pageInfoFull:"Total ${total}，${totalPage} page，All data displayed"},currencyDetail:[{name:"RMB",pos:"before",value:"¥"},{name:"US dollar",pos:"before",value:"$"},{name:"EUR",pos:"before",value:"€"},{name:"GBP",pos:"before",value:"￡"},{name:"HK",pos:"before",value:"$"},{name:"JPY",pos:"before",value:"￥"},{name:"Albanian Lek",pos:"before",value:"Lek"},{name:"Algerian Dinar",pos:"before",value:"din"},{name:"Afghani",pos:"after",value:"Af"},{name:"Argentine Peso",pos:"before",value:"$"},{name:"United Arab Emirates Dirham",pos:"before",value:"dh"},{name:"Aruban Florin",pos:"before",value:"Afl"},{name:"Omani Rial",pos:"before",value:"Rial"},{name:"Azerbaijani manat",pos:"before",value:"?"},{name:"Egyptian Pound",pos:"before",value:"￡"},{name:"Ethiopian Birr",pos:"before",value:"Birr"},{name:"Angola Kwanza",pos:"before",value:"Kz"},{name:"Australian Dollar",pos:"before",value:"$"},{name:"Patacas",pos:"before",value:"MOP"},{name:"Barbados Dollar",pos:"before",value:"$"},{name:"Papua New Guinea Kina",pos:"before",value:"PGK"},{name:"Bahamian Dollar",pos:"before",value:"$"},{name:"Pakistan Rupee",pos:"before",value:"Rs"},{name:"Paraguayan Guarani",pos:"after",value:"Gs"},{name:"Bahraini Dinar",pos:"before",value:"din"},{name:"Panamanian Balboa",pos:"before",value:"B/"},{name:"Brazilian real",pos:"before",value:"R$"},{name:"Belarusian ruble",pos:"after",value:"р"},{name:"Bermudian Dollar",pos:"before",value:"$"},{name:"Bulgarian Lev",pos:"before",value:"lev"},{name:"Iceland Krona",pos:"before",value:"kr"},{name:"Bosnia-Herzegovina Convertible Mark",pos:"before",value:"KM"},{name:"Polish Zloty",pos:"after",value:"z?"},{name:"Boliviano",pos:"before",value:"Bs"},{name:"Belize Dollar",pos:"before",value:"$"},{name:"Botswana Pula",pos:"before",value:"P"},{name:"Not Dannuzhamu",pos:"before",value:"Nu"},{name:"Burundi Franc",pos:"before",value:"FBu"},{name:"North Korean Won",pos:"before",value:"?KP"},{name:"Danish Krone",pos:"after",value:"kr"},{name:"East Caribbean Dollar",pos:"before",value:"$"},{name:"Dominica Peso",pos:"before",value:"RD$"},{name:"Russian Ruble",pos:"after",value:"?"},{name:"Eritrean Nakfa",pos:"before",value:"Nfk"},{name:"CFA franc",pos:"before",value:"CFA"},{name:"Philippine Peso",pos:"before",value:"?"},{name:"Fiji Dollar",pos:"before",value:"$"},{name:"Cape Verde Escudo",pos:"before",value:"CVE"},{name:"Falkland Islands Pound",pos:"before",value:"￡"},{name:"Gambian Dalasi",pos:"before",value:"GMD"},{name:"Congolese franc",pos:"before",value:"FrCD"},{name:"Colombian Peso",pos:"before",value:"$"},{name:"Costa Rican Colon",pos:"before",value:"?"},{name:"Cuban Peso",pos:"before",value:"$"},{name:"Cuban convertible peso",pos:"before",value:"$"},{name:"Guyana Dollar",pos:"before",value:"$"},{name:"Kazakhstan Tenge",pos:"before",value:"?"},{name:"Haitian gourde",pos:"before",value:"HTG"},{name:"won",pos:"before",value:"?"},{name:"Netherlands Antilles Guilder",pos:"before",value:"NAf."},{name:"Honduras lempiras",pos:"before",value:"L"},{name:"Djibouti Franc",pos:"before",value:"Fdj"},{name:"Kyrgyzstan Som",pos:"before",value:"KGS"},{name:"Guinea Franc",pos:"before",value:"FG"},{name:"Canadian Dollar",pos:"before",value:"$"},{name:"Ghanaian Cedi",pos:"before",value:"GHS"},{name:"Cambodian riel",pos:"before",value:"Riel"},{name:"Czech Koruna",pos:"after",value:"K?"},{name:"Zimbabwe Dollar",pos:"before",value:"$"},{name:"Qatari Riyal",pos:"before",value:"Rial"},{name:"Cayman Islands Dollar",pos:"before",value:"$"},{name:"Comorian franc",pos:"before",value:"CF"},{name:"Kuwaiti Dinar",pos:"before",value:"din"},{name:"Croatian Kuna",pos:"before",value:"kn"},{name:"Kenyan Shilling",pos:"before",value:"Ksh"},{name:"Lesotho Loti",pos:"before",value:"LSL"},{name:"Lao Kip",pos:"before",value:"?"},{name:"Lebanese Pound",pos:"before",value:"L￡"},{name:"Lithuanian litas",pos:"before",value:"Lt"},{name:"Libyan Dinar",pos:"before",value:"din"},{name:"Liberian Dollar",pos:"before",value:"$"},{name:"Rwanda Franc",pos:"before",value:"RF"},{name:"Romanian Leu",pos:"before",value:"RON"},{name:"Malagasy Ariary",pos:"before",value:"Ar"},{name:"Maldivian Rufiyaa",pos:"before",value:"Rf"},{name:"Malawi Kwacha",pos:"before",value:"MWK"},{name:"Malaysian Ringgit",pos:"before",value:"RM"},{name:"Macedonia wearing Dinar",pos:"before",value:"din"},{name:"Mauritius Rupee",pos:"before",value:"MURs"},{name:"Mauritanian Ouguiya",pos:"before",value:"MRO"},{name:"Mongolian Tugrik",pos:"before",value:"?"},{name:"Bangladeshi Taka",pos:"before",value:"?"},{name:"Peruvian Nuevo Sol",pos:"before",value:"S/"},{name:"Myanmar Kyat",pos:"before",value:"K"},{name:"Moldovan Leu",pos:"before",value:"MDL"},{name:"Moroccan Dirham",pos:"before",value:"dh"},{name:"Mozambique Metical",pos:"before",value:"MTn"},{name:"Mexican Peso",pos:"before",value:"$"},{name:"Namibian Dollar",pos:"before",value:"$"},{name:"South African Rand",pos:"before",value:"R"},{name:"South Sudanese Pound",pos:"before",value:"￡"},{name:"Nicaragua Cordoba",pos:"before",value:"C$"},{name:"Nepalese Rupee",pos:"before",value:"Rs"},{name:"Nigerian Naira",pos:"before",value:"?"},{name:"Norwegian Krone",pos:"after",value:"kr"},{name:"Georgian Lari",pos:"before",value:"GEL"},{name:"Swedish Krona",pos:"after",value:"kr"},{name:"Swiss Franc",pos:"before",value:"CHF"},{name:"Serbian Dinar",pos:"before",value:"din"},{name:"Sierra Leone",pos:"before",value:"SLL"},{name:"Seychelles Rupee",pos:"before",value:"SCR"},{name:"Saudi Riyal",pos:"before",value:"Rial"},{name:"Sao Tome Dobra",pos:"before",value:"Db"},{name:"Saint Helena pound",pos:"before",value:"￡"},{name:"Sri Lanka Rupee",pos:"before",value:"Rs"},{name:"Swaziland Lilangeni",pos:"before",value:"SZL"},{name:"Sudanese Pound",pos:"before",value:"SDG"},{name:"Surinamese dollar",pos:"before",value:"$"},{name:"Solomon Islands Dollar",pos:"before",value:"$"},{name:"Somali Shilling",pos:"before",value:"SOS"},{name:"Tajikistan Somoni",pos:"before",value:"Som"},{name:"Pacific Franc",pos:"after",value:"FCFP"},{name:"Thai Baht",pos:"before",value:"?"},{name:"Tanzanian Shilling",pos:"before",value:"TSh"},{name:"Tongan Pa'anga",pos:"before",value:"T$"},{name:"Trinidad and Tobago Dollar",pos:"before",value:"$"},{name:"Tunisian Dinar",pos:"before",value:"din"},{name:"Turkish Lira",pos:"before",value:"?"},{name:"Vanuatu Vatu",pos:"before",value:"VUV"},{name:"Guatemalan Quetzal",pos:"before",value:"Q"},{name:"Commission Bolivar",pos:"before",value:"Bs"},{name:"Brunei Dollar",pos:"before",value:"$"},{name:"Ugandan Shilling",pos:"before",value:"UGX"},{name:"Ukrainian Hryvnia",pos:"before",value:"грн."},{name:"Uruguayan Peso",pos:"before",value:"$"},{name:"Uzbekistan som",pos:"before",value:"so?m"},{name:"Western Samoa Tala",pos:"before",value:"WST"},{name:"Singapore Dollar",pos:"before",value:"$"},{name:"NT",pos:"before",value:"NT$"},{name:"New Zealand Dollar",pos:"before",value:"$"},{name:"Hungarian Forint",pos:"before",value:"Ft"},{name:"Syrian Pound",pos:"before",value:"￡"},{name:"Jamaican Dollar",pos:"before",value:"$"},{name:"Armenian Dram",pos:"before",value:"Dram"},{name:"Yemeni Rial",pos:"before",value:"Rial"},{name:"Iraqi Dinar",pos:"before",value:"din"},{name:"Iranian Rial",pos:"before",value:"Rial"},{name:"New Israeli Shekel",pos:"before",value:"?"},{name:"Indian Rupee",pos:"before",value:"?"},{name:"Indonesian Rupiah",pos:"before",value:"Rp"},{name:"Jordanian Dinar",pos:"before",value:"din"},{name:"VND",pos:"after",value:"?"},{name:"Zambian Kwacha",pos:"before",value:"ZMW"},{name:"Gibraltar Pound",pos:"before",value:"￡"},{name:"Chilean Peso",pos:"before",value:"$"},{name:"CFA Franc BEAC",pos:"before",value:"FCFA"}],defaultFmt:function defaultFmt(currency){return[{text:"Automatic",value:"General",example:""},{text:"Plain text",value:"@",example:""},{text:"",value:"split",example:""},{text:"Number",value:"##0.00",example:"1000.12"},{text:"Percent",value:"#0.00%",example:"12.21%"},{text:"Scientific",value:"0.00E+00",example:"1.01E+5"},{text:"",value:"split",example:""},{text:"Accounting",value:"".concat(currency,"(0.00)"),example:"".concat(currency,"(1200.09)")},{text:"Currency",value:"".concat(currency,"0.00"),example:"".concat(currency,"1200.09")},{text:"",value:"split",example:""},{text:"Date",value:"yyyy-MM-dd",example:"2017-11-29"},{text:"Time",value:"hh:mm AM/PM",example:"3:00 PM"},{text:"Time 24H",value:"hh:mm",example:"15:00"},{text:"Date time",value:"yyyy-MM-dd hh:mm AM/PM",example:"2017-11-29 3:00 PM"},{text:"Date time 24 H",value:"yyyy-MM-dd hh:mm",example:"2017-11-29 15:00"},{text:"",value:"split",example:""},{text:"Custom formats",value:"fmtOtherSelf",example:"",icon:"rightArrow"}];},dateFmtList:[{name:"1930-08-05",value:"yyyy-MM-dd"},{name:"1930/8/5",value:"yyyy/MM/dd"},{name:"08-05",value:"MM-dd"},{name:"8-5",value:"M-d"},{name:"13:30:30",value:"h:mm:ss"},{name:"13:30",value:"h:mm"},{name:"PM 01:30",value:"AM/PM hh:mm"},{name:"PM 1:30",value:"AM/PM h:mm"},{name:"PM 1:30:30",value:"AM/PM h:mm:ss"},{name:"08-05 PM 01:30",value:"MM-dd AM/PM hh:mm"}],fontFamily:{MicrosoftYaHei:"YaHei"},fontarray:["Times New Roman","Arial","Tahoma","Verdana"],fontjson:{"times new roman":0,arial:1,tahoma:2,verdana:3},border:{borderTop:"Top border",borderBottom:"Bottom border",borderLeft:"Left border",borderRight:"Right border",borderNone:"No border",borderAll:"All borders",borderOutside:"Outside border",borderInside:"Inside border",borderHorizontal:"Horizontal borders",borderVertical:"Vertical borders",borderColor:"border color",borderSize:"border size",borderSlash:"Slash border",borderDefault:"default",borderStyle:"border style"},merge:{mergeAll:"Merge all",mergeV:"Merge Vertically",mergeH:"Merge Horizontally",mergeCancel:"Unmerge",overlappingError:"Cannot merge overlapping areas",partiallyError:"Cannot perform this operation on partially merged cells"},align:{left:"left",center:"center",right:"right",top:"Top",middle:"Middle",bottom:"Bottom"},textWrap:{overflow:"Overflow",wrap:"Wrap",clip:"Clip"},rotation:{none:"None",angleup:"Tilt Up",angledown:"Tilt Down",vertical:"Stack Vertically",rotationUp:"Rotate Up",rotationDown:"Rotate Down"},freezen:{default:"Freeze",freezenRow:"First Row",freezenColumn:"First Column",freezenRC:"Both",freezenRowRange:"Freeze to current row",freezenColumnRange:"Freeze to current column",freezenRCRange:"Freeze to current cell",freezenCancel:"Cancel freezing",noSeletionError:"No Range to be selected",rangeRCOverErrorTitle:"Freeze reminder",rangeRCOverError:"The frozen pane is beyond the visible range, which will lead to abnormal operation. Please reset the frozen area."},sort:{asc:"Ascending ",desc:"Descending ",custom:"Custom sort",hasTitle:"Data has a header row",sortBy:"Sort by",addOthers:"Add another sort column",close:"close",confirm:"sort",columnOperation:"Column",secondaryTitle:"then by",sortTitle:"Sort range",sortRangeTitle:"Sort range from",sortRangeTitleTo:"to",noRangeError:"Cannot perform this operation on multiple selection areas, please select a single range and try again",mergeError:"There are merged cells in the selection, this operation cannot be performed!"},filter:{filter:"create filter",sortByAsc:"Ascending sort",sortByDesc:"Descending sort",filterByColor:"Filter by color",filterByCondition:"Filter by condition",filterByValues:"Filter by values",filiterInputNone:"None",filiterInputTip:"Enter filter value",filiterRangeStartTip:"Value for formula",filiterRangeEndTip:"Value for formula",filterValueByAllBtn:"Check all",filterValueByClearBtn:"Clear",filterValueByInverseBtn:"Inverse",filterValueByTip:"filter By Values",filterConform:"Confirm",filterCancel:"Cancel",clearFilter:"Clear filter",conditionNone:"None",conditionCellIsNull:"Is empty",conditionCellNotNull:"Is not empty",conditionCellTextContain:"Text contains",conditionCellTextNotContain:"Text does not contain",conditionCellTextStart:"Text starts with",conditionCellTextEnd:"Text ends with",conditionCellTextEqual:"Text is exactly",conditionCellDateEqual:"Date is",conditionCellDateBefore:"Date is before",conditionCellDateAfter:"Date is after",conditionCellGreater:"Greater than",conditionCellGreaterEqual:"Greater than or equal to",conditionCellLess:"Less than",conditionCellLessEqual:"Less than or equal to",conditionCellEqual:"Is equal to",conditionCellNotEqual:"Is not equal to",conditionCellBetween:"Is between",conditionCellNotBetween:"Is not between",filiterMoreDataTip:"Big amount of data! please wait",filiterMonthText:"Month",filiterYearText:"Year",filiterByColorTip:"Filter by cell color",filiterByTextColorTip:"Filter by font color",filterContainerOneColorTip:"This column contains only one color",filterDateFormatTip:"Date format",valueBlank:"(Null)",mergeError:"There are merged cells in the filter selection, this operation cannot be performed!"},rightclick:{copy:"Copy",copyAs:"Copy as",paste:"Paste",insert:"Insert",image:"Insert image",link:"Insert link",delete:"Delete",deleteCell:"Delete cell",deleteSelected:"Delete selected ",hide:"Hide",hideSelected:"Hide selected ",showHide:"Show hidden ",to:"Towards",left:"Left",right:"Right",top:"Above",bottom:"Below",moveLeft:"Move left",moveUp:"Move up",add:"Add",row:"Row",column:"Column",width:"Width",height:"Height",number:"Number",confirm:"Confirm",orderAZ:"Ascending sort",orderZA:"Descending sort",clearContent:"Clear content",matrix:"Matrix operation",sortSelection:"Sort",filterSelection:"Filter",chartGeneration:"Create chart",firstLineTitle:"first line title",untitled:"untitled",array1:"One-dimensional array",array2:"Two-dimensional array",array3:"Multidimensional Arrays",diagonal:"Diagonal",antiDiagonal:"Anti-diagonal",diagonalOffset:"Diagonal offset",offset:"Offset",boolean:"Boolean",flip:"Flip",upAndDown:"Up and down",leftAndRight:"Left and right",clockwise:"Clockwise",counterclockwise:"Counterclockwise",transpose:"Transpose",matrixCalculation:"Matrix calculation",plus:"Plus",minus:"Minus",multiply:"Multiply",divided:"Divided",power:"Power",root:"Root",log:"Log",delete0:"Delete 0 values at both ends",removeDuplicate:"Remove duplicate values",byRow:"By row",byCol:"By column",generateNewMatrix:"Generate new matrix",noMulti:"Cannot perform this operation on multiple selection areas, please select a single area",cannotDeleteAllRow:"Cannot delete all rows",cannotDeleteAllColumn:"Cannot delete all columns",cannotDeleteRowReadOnly:"Cannot delete row readonly",cannotDeleteColumnReadOnly:"Cannot delete column readonly",cannotInsertOnRowReadOnly:"Cannot insert on read-only row",cannotInsertOnColumnReadOnly:"Cannot insert into read-only column",rowOverLimit:"10000 row limit exceeded",columnOverLimit:"1000 column limit exceeded"},comment:{insert:"Insert",edit:"Edit",delete:"Delete",showOne:"Show/Hide",showAll:"Show/Hide All"},screenshot:{screenshotTipNoSelection:"Please select the scope of the screenshot",screenshotTipTitle:"Warning！",screenshotTipHasMerge:"This operation cannot be performed on merged cells",screenshotTipHasMulti:"This operation cannot be performed on multiple selection regions",screenshotTipSuccess:"Successful",screenshotImageName:"Screenshot",downLoadClose:"Close",downLoadCopy:"Copy to clipboard",downLoadBtn:"Download",browserNotTip:"not supported by IE browser!",rightclickTip:'Please right-click "copy" on the picture',successTip:'Successfully (if pasting fails, please right-click on the image to "copy image")'},splitText:{splitDelimiters:"Delimiters",splitOther:"Other",splitContinueSymbol:"Consecutive separators are treated as a single",splitDataPreview:"Preview",splitTextTitle:"Split text",splitConfirmToExe:"There is already data here, do you want to replace it?",splitSymbols:[{name:"Tab",value:"Tab"},{name:"semicolon",value:"semicolon"},{name:"comma",value:"comma"},{name:"space",value:"space"}],tipNoMulti:"Cannot perform this operation on multiple selection areas, please select a single area and try again",tipNoMultiColumn:"Only one column of data can be converted at a time. The selected area can have multiple rows but not multiple columns. Please try again after selecting a single column range",tipNoSelect:"You cannot separate a cell without selecting it"},imageText:{imageSetting:"Image setting",close:"Close",conventional:"Conventional",moveCell1:"Move and resize cells",moveCell2:"Move and do not resize the cell",moveCell3:"Do not move and resize the cell",fixedPos:"Fixed position",border:"Border",width:"Width",radius:"Radius",style:"Style",solid:"Solid",dashed:"Dashed",dotted:"Dotted",double:"Double",color:"Color"},punctuation:{tab:"Tab",semicolon:"semicolon",comma:"comma",space:"space"},findAndReplace:{find:"Find",replace:"Replace",goto:"Go to",location:"Location",formula:"Formula",date:"Date",number:"Number",string:"String",error:"Error",condition:"Condition",rowSpan:"Row span",columnSpan:"Column span",locationExample:"Location",lessTwoRowTip:"Please select at least two rows",lessTwoColumnTip:"Please select at least two columns",findTextbox:"Find Content",replaceTextbox:"Replace Content",regexTextbox:"Regular Expression",wholeTextbox:"Whole word",distinguishTextbox:"Case sensitive",allReplaceBtn:"Replace All",replaceBtn:"Replace",allFindBtn:"Find All",findBtn:"Find next",noFindTip:"The content was not found",modeTip:"This operation is not available in this mode",searchTargetSheet:"Sheet",searchTargetCell:"Cell",searchTargetValue:"Value",searchInputTip:"Please enter the search content",noReplceTip:"There is nothing to replace",noMatchTip:"No match found",successTip:"${xlength} items found",locationConstant:"Constant",locationFormula:"Formula",locationDate:"Date",locationDigital:"Number",locationString:"String",locationBool:"Logical",locationError:"Error",locationNull:"Null",locationCondition:"Conditional format",locationRowSpan:"Row span",locationColumnSpan:"Column span",locationTiplessTwoRow:"Please select at least two rows",locationTiplessTwoColumn:"Please select at least two columns",locationTipNotFindCell:"Cell not found"},sheetconfig:{delete:"Delete",copy:"Copy",rename:"Rename",changeColor:"Change color",hide:"Hide",unhide:"Unhide",moveLeft:"Move left",moveRight:"Move right",resetColor:"Reset color",cancelText:"Cancel",chooseText:"Confirm color",focus:"Focus",tipNameRepeat:"The name of the tab page cannot be repeated! Please revise",noMoreSheet:"The workbook contains at least one visual worksheet. To delete the selected worksheet, please insert a new worksheet or show a hidden worksheet.",confirmDelete:"Are you sure to delete",redoDelete:"Can be undo by Ctrl+Z",noHide:"Can't hide, at least keep one sheet tag",chartEditNoOpt:"This operation is not allowed in chart editing mode!",sheetNameSpecCharError:"The name cannot contain:[ ] :  ? * / ' \"",sheetNamecannotIsEmptyError:"Sheet name cannot be empty"},conditionformat:{conditionformat_greaterThan:"Conditionformat-GreaterThan",conditionformat_greaterThan_title:"Format cells greater than",conditionformat_lessThan:"Conditionformat-LessThan",conditionformat_lessThan_title:"Format cells smaller than",conditionformat_between:"Conditionformat-Betweenness",conditionformat_between_title:"Format cells with values between",conditionformat_equal:"Conditionformat-Equal",conditionformat_equal_title:"Format cells equal to",conditionformat_textContains:"Conditionformat-TextContains",conditionformat_textContains_title:"Format cells containing the following text",conditionformat_occurrenceDate:"Conditionformat-OccurrenceDate",conditionformat_occurrenceDate_title:"Format cells containing the following dates",conditionformat_duplicateValue:"Conditionformat-DuplicateValue",conditionformat_duplicateValue_title:"Format cells containing the following types of values",conditionformat_top10:"Conditionformat-Top10",conditionformat_top10_percent:"Conditionformat-Top10%",conditionformat_top10_title:"Format the cells with the highest value",conditionformat_last10:"Conditionformat-Last10",conditionformat_last10_percent:"Conditionformat-Last10%",conditionformat_last10_title:"Format the cells with the smallest value",conditionformat_aboveAverage:"Conditionformat-AboveAverage",conditionformat_aboveAverage_title:"Format cells above average",conditionformat_belowAverage:"Conditionformat-SubAverage",conditionformat_belowAverage_title:"Format cells below average",rule:"Rule",newRule:"New rule",editRule:"Edit rule",deleteRule:"Delete rule",deleteCellRule:"Delete cell rule",deleteSheetRule:"Delete sheet rule",manageRules:"Management rules",showRules:"Show its formatting rules",highlightCellRules:"Highlight cell rules",itemSelectionRules:"Item selection rules",conditionformatManageRules:"Conditional Formatting Rule Manager",format:"Format",setFormat:"Set format",setAs:"Set as",setAsByArea:"For the selected area, set to",applyRange:"Apply range",selectRange:"Select application range",selectRange_percent:"Percentage of selected range",selectRange_average:"Average value of selected range",selectRange_value:"Value in the selected range",pleaseSelectRange:"Please select application range",selectDataRange:"Select data range",selectCell:"select cell",pleaseSelectCell:"Please select cell",pleaseSelectADate:"Please select a date",pleaseEnterInteger:"Please enter an integer between 1 and 1000",onlySingleCell:"Only a single cell can be referenced",conditionValueCanOnly:"The condition value can only be a number or a single cell",ruleTypeItem1:"Format all cells based on their respective values",ruleTypeItem2:"Only format cells that contain",ruleTypeItem2_title:"Only for cells that meet the following conditions",ruleTypeItem3:"Format only the top or bottom numbers",ruleTypeItem3_title:"Is the value in the following ranking",ruleTypeItem4:"Format only values above or below the average",ruleTypeItem4_title:"Is a value that satisfies the following conditions",ruleTypeItem5:"Format only unique or repeated values",ruleTypeItem6:"Use formulas to determine which cells to format",formula:"Formula",textColor:"Text color",cellColor:"Cell color",confirm:"Confirm",confirmColor:"Confirm color",cancel:"Cancel",close:"Close",clearColorSelect:"Clear color select",sheet:"Sheet",currentSheet:"Current Sheet",dataBar:"data bar",dataBarColor:"data bar color",gradientDataBar_1:"Blue-white gradient data bar",gradientDataBar_2:"Green-white gradient data bar",gradientDataBar_3:"Red-white gradient data bar",gradientDataBar_4:"Orange-white gradient stripes",gradientDataBar_5:"Light blue-white gradient stripes",gradientDataBar_6:"Purple-white gradient data bar",solidColorDataBar_1:"Blue data bar",solidColorDataBar_2:"Green data bar",solidColorDataBar_3:"Red data bar",solidColorDataBar_4:"Orange data bar",solidColorDataBar_5:"Light blue data bar",solidColorDataBar_6:"Purple data bar",colorGradation:"color gradation",colorGradation_1:"Green-yellow-red color gradation",colorGradation_2:"Red-yellow-green color gradation",colorGradation_3:"Green-white-red color gradation",colorGradation_4:"Red-white-green color gradation",colorGradation_5:"Blue-white-red color gradation",colorGradation_6:"Red-white-blue color gradation",colorGradation_7:"White-red color gradation",colorGradation_8:"Red-white color gradation",colorGradation_9:"Green-white color gradation",colorGradation_10:"White-green color gradation",colorGradation_11:"Green-yellow color gradation",colorGradation_12:"Yellow-green color gradation",icons:"icons",pleaseSelectIcon:"Please click to select a group of icons:",cellValue:"Cell value",specificText:"Specific text",occurrenceDate:"Date",greaterThan:"Greater than",lessThan:"Less than",between:"Between",equal:"Equal",in:"In",between2:"",contain:"Contain",textContains:"Text contains",duplicateValue:"Duplicate value",uniqueValue:"Unique value",top:"Top",top10:"Top 10",top10_percent:"Top 10%",last:"Last",last10:"Last 10",last10_percent:"Last 10%",oneself:"",above:"Above",aboveAverage:"Above average",below:"Below",belowAverage:"Below average",all:"All",yesterday:"YTD",today:"Today",tomorrow:"Tomorrow",lastWeek:"Last week",thisWeek:"This week",lastMonth:"Last month",thisMonth:"This month",lastYear:"Last year",thisYear:"This year",last7days:"Last 7 days",last30days:"Last 30 days",next7days:"Next 7 days",next30days:"Next 30 days",next60days:"Next 60 days",chooseRuleType:"Choose rule type",editRuleDescription:"Edit rule description",newFormatRule:"New format rule",editFormatRule:"Edit format rule",formatStyle:"Style",fillType:"Fill",color:"Color",twocolor:"Two-color",tricolor:"Tricolor",multicolor:"Multi color",grayColor:"Gray color",gradient:"Gradient",solid:"Solid",maxValue:"Max value",medianValue:"Median value",minValue:"Min value",direction:"Direction",threeWayArrow:"Three-way arrow",fourWayArrow:"Four-way arrow",fiveWayArrow:"Five-way arrow",threeTriangles:"Three triangles",shape:"Shape",threeColorTrafficLight:"Three-color traffic light",fourColorTrafficLight:"Four-color traffic light",threeSigns:"Three signs",greenRedBlackGradient:"Green-red-black gradient",rimless:"Rimless",bordered:"Bordered",mark:"Mark",threeSymbols:"Three symbols",tricolorFlag:"Tricolor flag",circled:"Circled",noCircle:"No circle",grade:"Grade",grade4:"4 Grade",grade5:"5 Grade",threeStars:"3 Stars",fiveQuadrantDiagram:"Five-quadrant diagram",fiveBoxes:"5 Boxes"},insertLink:{linkText:"Display text",linkType:"Link type",linkAddress:"Link address",linkSheet:"Worksheet",linkCell:"Cell range",linkTooltip:"Tooltip",selectCellRange:"Select cell range",cellRangePlaceholder:"Select cells using the cursor or enter directly",placeholder1:"Please enter the web link address",placeholder2:"Please enter the cell to be quoted, example A1",placeholder3:"Please enter the prompt content",tooltipInfo1:"Please enter a valid link",invalidCellRangeTip:"Please enter the correct ell range, such as Sheet1!A1:C8",openLink:"Open link",goTo:"Go to ${linkAddress}"},linkTypeList:[{text:"Webpages",value:"webpage"},{text:"Cell range",value:"cellrange"},{text:"Sheet",value:"sheet"}],dataVerification:{cellRange:"Cell range",selectCellRange:"Click to select a cell range",selectCellRange2:"Please select a range of cells",verificationCondition:"Verification condition",allowMultiSelect:"Allow multiple selection",dropdown:"drop-down list",checkbox:"Checkbox",number:"Number",number_integer:"Number-integer",number_decimal:"Number-decimal",text_content:"Text-content",text_length:"Text-length",date:"Date",validity:"Effectiveness",placeholder1:"Please enter the options, separated by commas, such as 1,2,3,4,5",placeholder2:"Please enter content",placeholder3:"Numeric value, such as 10",placeholder4:"Please enter the specified text",placeholder5:"Please enter the prompt displayed when the cell is selected",selected:"Selected",notSelected:"Not selected",between:"Between",notBetween:"Not between",equal:"Equal",notEqualTo:"Not equal to",moreThanThe:"More than the",lessThan:"Less than",greaterOrEqualTo:"Greater or equal to",lessThanOrEqualTo:"Less than or equal to",include:"Include",exclude:"Exclude",earlierThan:"Earlier than",noEarlierThan:"No earlier than",laterThan:"Later than",noLaterThan:"No later than",identificationNumber:"Identification number",phoneNumber:"Phone number",remote:"Automatic remote acquisition option",prohibitInput:"Prohibit input when input data is invalid",hintShow:"Show prompt when the cell is selected",deleteVerification:"Delete verification",tooltipInfo1:"The drop-down list option cannot be empty",tooltipInfo2:"Checkbox content cannot be empty",tooltipInfo3:"The value entered is not a numeric type",tooltipInfo4:"The value 2 cannot be less than the value 1",tooltipInfo5:"The text content cannot be empty",tooltipInfo6:"The value entered is not a date type",tooltipInfo7:"Date 2 cannot be less than date 1",textlengthInteger:"Text length must be an integer greater than or equal to 0"},formula:{sum:"Sum",average:"Average",count:"Count",max:"Max",min:"Min",ifGenerate:"If formula generator",find:"Learn more",tipNotBelongToIf:"This cell function does not belong to the if formula!",tipSelectCell:"Please select the cell to insert the function",ifGenCompareValueTitle:"Comparison value",ifGenSelectCellTitle:"Click to select cell",ifGenRangeTitle:"Range",ifGenRangeTo:"to",ifGenRangeEvaluate:"Range evaluate",ifGenSelectRangeTitle:"Click to select range",ifGenCutWay:"Partition way",ifGenCutSame:"Same Partition value",ifGenCutNpiece:"Partition by N",ifGenCutCustom:"Custom",ifGenCutConfirm:"Confirm",ifGenTipSelectCell:"Select cells",ifGenTipSelectCellPlace:"Please select cells",ifGenTipSelectRange:"Select range",ifGenTipSelectRangePlace:"Please select range",ifGenTipNotNullValue:"The comparison value cannot be empty!",ifGenTipLableTitile:"Label",ifGenTipRangeNotforNull:"The range cannot be empty!",ifGenTipCutValueNotforNull:"The partition value cannot be empty!",ifGenTipNotGenCondition:"No conditions are available for generation!"},formulaMore:{valueTitle:"Value",tipSelectDataRange:"Select data range",tipDataRangeTile:"Data range",findFunctionTitle:"Search function",tipInputFunctionName:"Function name or brief description of function",Array:"Array",Database:"Database",Date:"Date",Engineering:"Engineering",Filter:"Filter",Financial:"Financial",luckysheet:"Luckysheet",other:"Other",Logical:"Logical",Lookup:"Lookup",Math:"Math",Operator:"Operator",Parser:"Parser",Statistical:"Statistical",Text:"Text",dataMining:"Data Mining",selectFunctionTitle:"Select a function",calculationResult:"Result",tipSuccessText:"Success",tipParamErrorText:"Parameter type error",helpClose:"Close",helpCollapse:"Collapse",helpExample:"Example",helpAbstract:"Abstract",execfunctionError:"Error in the formula",execfunctionSelfError:"The formula cannot refer to its own cell",execfunctionSelfErrorResult:"The formula cannot refer to its own cell, which will lead to inaccurate calculation results",allowRepeatText:"Repeatable",allowOptionText:"Optional",selectCategory:"Or select a category"},drag:{noMerge:"Cannot perform this operation on merged cells",affectPivot:"This change cannot be made to the selected cell because it will affect the pivot table!",noMulti:"Cannot perform this operation on multiple selection areas, please select a single area",noPaste:"Unable to paste this content here, please select a cell in the paste area and try to paste again",noPartMerge:"Cannot perform this operation on partially merged cells",inputCorrect:"Please enter the correct value",notLessOne:"The number of rows and columns cannot be less than 1",offsetColumnLessZero:"The offset column cannot be negative!",pasteMustKeybordAlert:"在表格中进行复制粘贴: Ctrl + C 进行复制, Ctrl + V 进行粘贴, Ctrl + X 进行剪切",pasteMustKeybordAlertHTMLTitle:"在表格中进行复制粘贴",pasteMustKeybordAlertHTML:"<span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + C</span>&nbsp;&nbsp;进行复制<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + V</span>&nbsp;&nbsp;进行粘贴<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + X</span>&nbsp;&nbsp;进行剪切"},pivotTable:{title:"Pivot Table",closePannel:"Close",editRange:"Range",tipPivotFieldSelected:"Select the fields",tipClearSelectedField:"Clear all fields",btnClearSelectedField:"Clear",btnFilter:"Filter",titleRow:"Row",titleColumn:"Column",titleValue:"Value",tipShowColumn:"Statistics fields are displayed as columns",tipShowRow:"Statistics fields are displayed as rows",titleSelectionDataRange:"Select range",titleDataRange:"Data range",valueSum:"SUM",valueStatisticsSUM:"Sum",valueStatisticsCOUNT:"Count",valueStatisticsCOUNTA:"Count A",valueStatisticsCOUNTUNIQUE:"Count Unique",valueStatisticsAVERAGE:"Average",valueStatisticsMAX:"Max",valueStatisticsMIN:"Min",valueStatisticsMEDIAN:"Median",valueStatisticsPRODUCT:"Product",valueStatisticsSTDEV:"Stdev",valueStatisticsSTDEVP:"Stdevp",valueStatisticslet:"Var",valueStatisticsVARP:"VarP",errorNotAllowEdit:"This operation is prohibited in non-editing mode!",errorNotAllowMulti:"Cannot perform this operation on multiple selection areas, please select a single range and try again",errorSelectRange:"Please select the range of the new pivot table",errorIsDamage:"The source data of this pivot table is corrupted!",errorNotAllowPivotData:"Cannot select pivot table as source data!",errorSelectionRange:"Selection failed, wrong input range!",errorIncreaseRange:"Please expand the selected range!",titleAddColumn:"Add column to pivot table",titleMoveColumn:"Move the column to the white box below",titleClearColumnFilter:"Clear the filter for this column",titleFilterColumn:"Filter",titleSort:"Sort",titleNoSort:"No sort",titleSortAsc:"ASC",titleSortDesc:"DESC",titleSortBy:"Sort by",titleShowSum:"Show total",titleStasticTrue:"Yes",titleStasticFalse:"No"},dropCell:{copyCell:"Copy",sequence:"Sequence",onlyFormat:"Only format",noFormat:"Not format",day:"Day",workDay:"Work Day",month:"Month",year:"Year",chineseNumber:"Chinese numbers"},imageCtrl:{borderTile:"Image border color",borderCur:"Color"},protection:{protectiontTitle:"Protection",enterPassword:"Enter a password (optional)",enterHintTitle:"Prompt when editing is prohibited (optional)",enterHint:"The cell or chart you are trying to change is in a protected worksheet. If you want to change it, please unprotect the worksheet. You may need to enter a password",swichProtectionTip:"Protect the sheet and contents of locked cells",authorityTitle:"Allow users of this sheet to:",selectLockedCells:"Select locked cells",selectunLockedCells:"Select unlocked cells",formatCells:"Format cells",formatColumns:"Format columns",formatRows:"Format rows",insertColumns:"Insert columns",insertRows:"Insert rows",insertHyperlinks:"Insert hyperlinks",deleteColumns:"Delete columns",deleteRows:"Delete rows",sort:"Sort",filter:"Filter",usePivotTablereports:"Use Pivot Table reports",editObjects:"Edit objects",editScenarios:"Edit scenarios",allowRangeTitle:"Allow users of range to:",allowRangeAdd:"New...",allowRangeAddTitle:"Title",allowRangeAddSqrf:"Reference",selectCellRange:"Click to select a cell range",selectCellRangeHolder:"Cell range",allowRangeAddTitlePassword:"Password",allowRangeAddTitleHint:"Prompt",allowRangeAddTitleHintTitle:"Prompt when a password is set (optional)",allowRangeAddtitleDefault:"Input range name",rangeItemDblclick:"Double click to edit",rangeItemHasPassword:"Has password",rangeItemErrorTitleNull:"Title is null",rangeItemErrorRangeNull:"Reference is null",rangeItemErrorRange:"Reference is error",validationTitle:"Password validation",validationTips:"Need to enter a password to unlock the protection of the worksheet",validationInputHint:"Enter a password",checkPasswordNullalert:"Password is required!",checkPasswordWrongalert:"Incorrect password, please try again!",checkPasswordSucceedalert:"Unlock Succeed!",defaultRangeHintText:"The cell is being password protected.",defaultSheetHintText:"The cell or chart is in a protected worksheet. To make changes, please unprotect the worksheet. You may need to enter a password"},cellFormat:{cellFormatTitle:"Format cells",protection:"Protection",locked:"Locked",hidden:"Hidden",protectionTips:"To lock cells or hide formulas, protect the worksheet. On the toolbar, Click Protect Sheet Button",tipsPart:"Partial checked",tipsAll:"All checked",selectionIsNullAlert:"Selection is required!",sheetDataIsNullAlert:"error, Data is none!"},print:{normalBtn:"Normal",layoutBtn:"Page Layout",pageBtn:"Page break preview",menuItemPrint:"Print (Ctrl+P)",menuItemAreas:"Print areas",menuItemRows:"Print title rows",menuItemColumns:"Print title columns"},edit:{typing:"typing"},websocket:{success:"WebSocket connection success",refresh:"An error occurred in the WebSocket connection, please refresh the page!",wait:"An error occurred in the WebSocket connection, please be patient!",close:"WebSocket connection closed",contact:"Server communication error occurred, please refresh the page and try again, if not, please contact the administrator!",support:"The current browser does not support WebSocket"}};var zh={generalDialog:{partiallyError:"无法对部分合并单元格执行此操作",readOnlyError:"无法对只读模式执行此操作",dataNullError:"无法对不存在的数据执行此操作",noSeletionError:"还未进行选区操作",cannotSelectMultiple:"无法选择多选区"},functionlist:[{n:"SUMIF",t:0,d:"对范围中符合指定条件的值求和。",a:"对范围中符合指定条件的值求和。",m:[2,3],p:[{name:"范围",detail:"要根据条件进行检测的范围。",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"条件",detail:"要应用于范围的模式或测试条件。\n\n如果范围包含的是要检测的文本，则条件必须为字符串。条件可以包含通配符，包括用于匹配单个字符的?或用于匹配零个或连续多个字符的*。要匹配问号星号本身，请在该字符前面加上波浪号(~)前缀（即~?和~*）。字符串条件必须用引号括起来。函数会检查范围中的每个单元格与条件是否相等或匹配（如果使用了通配符）。\n\n如果范围包含的是要检测的数字，则条件可以是字符串也可以是数字。如果给定的条件是一个数字，则检查范围中的每个单元格是否等于条件。另外，条件也可能是包含数字的字符串（也将对其进行相等检测），或者带有以下前缀的数字：=（检查是否相等）、>（检查范围单元格的值是否大于条件值）或<（检查范围单元格的值是否小于条件值）",example:'">20"',require:"m",repeat:"n",type:"rangeall"},{name:"求和范围",detail:"要求和的范围（如果与范围不同）。",example:"B1:B10",require:"o",repeat:"n",type:"range"}]},{n:"TAN",t:0,d:"返回已知角度的正切值。",a:"返回已知角度的正切值。",m:[1,1],p:[{name:"角度",detail:"要求其正切值的角度，以弧度表示。",example:"45*PI()/180",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TANH",t:0,d:"返回给定实数的双曲正切值。",a:"返回给定实数的双曲正切值。",m:[1,1],p:[{name:"值",detail:"要计算其双曲正切值的实数。",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CEILING",t:0,d:"将数值向上取整为最接近的指定因数的倍数。",a:"将数值向上取整为最接近的指定因数的倍数。",m:[2,2],p:[{name:"值",detail:"要向上舍入的数值。",example:"23.25",require:"m",repeat:"n",type:"rangenumber"},{name:"因数",detail:"要将值舍入到此数的整数倍。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ATAN",t:0,d:"返回数值的反正切值，以弧度表示。",a:"返回数值的反正切值",m:[1,1],p:[{name:"值",detail:"要计算其反正切值的数值。",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ASINH",t:0,d:"返回数值的反双曲正弦值。",a:"返回数值的反双曲正弦值。",m:[1,1],p:[{name:"值",detail:"要计算其反双曲正弦值的数值。",example:"0.9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ABS",t:0,d:"返回数值的绝对值。",a:"返回数值的绝对值。",m:[1,1],p:[{name:"value",detail:"要返回其绝对值的数。",example:"-2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ACOS",t:0,d:"返回数值的反余弦值，以弧度表示。",a:"返回数值的反余弦值",m:[1,1],p:[{name:"值",detail:"要计算其反余弦值的数值。必须介于-1和1之间，包括两端值。",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ACOSH",t:0,d:"返回数值的反双曲余弦值。",a:"返回数值的反双曲余弦值。",m:[1,1],p:[{name:"值",detail:"要计算其反双曲余弦值的数值。必须大于等于1。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MULTINOMIAL",t:0,d:"返回参数和的阶乘除以各参数阶乘的乘积后得到的值。",a:"返回参数和的阶乘除以各参数阶乘的乘积后得到的值。",m:[1,255],p:[{name:"值1",detail:"用于计算的第一项数值或范围。",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"值2",detail:"用于计算的其他数值或范围。",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"ATANH",t:0,d:"返回数值的反双曲正切值。",a:"返回数值的反双曲正切值。",m:[1,1],p:[{name:"值",detail:"要计算其反双曲正切值的数值。必须介于-1和1之间（不包括-1和1）。",example:"0.9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ATAN2",t:0,d:"以弧度为单位返回 x 轴与从原点 (0,0) 到指定坐标点 (`x`,`y`) 之间连线的夹角。",a:"以弧度为单位返回 x 轴与从原点 (0,0) 到指定坐标点 (`x`,`y`) 之间连线的夹角。",m:[2,2],p:[{name:"x",detail:"要计算其与x轴夹角大小的线段的终点x坐标。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"y",detail:"要计算其与x轴夹角大小的线段的终点y坐标。",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUNTBLANK",t:1,d:"返回给定范围内的空单元格数。",a:"返回给定范围内的空单元格数。",m:[1,1],p:[{name:"范围",detail:"要统计空白单元格数量的范围。",example:"A2:C100",require:"m",repeat:"n",type:"range"}]},{n:"COSH",t:0,d:"返回给定实数的双曲余弦值。",a:"返回给定实数的双曲余弦值。",m:[1,1],p:[{name:"值",detail:"要计算其双曲余弦值的实数值。",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"INT",t:0,d:"将数值向下取整为小于或等于该数的最接近的整数。",a:"将数值向下取整为小于或等于该数的最接近的整数。",m:[1,1],p:[{name:"值",detail:"要向下取整为最接近的整数的数值。",example:"99.44",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ISEVEN",t:0,d:"检查所提供的数值是否为偶数。",a:"检查所提供的数值是否为偶数。",m:[1,1],p:[{name:"值",detail:"要验证其是否为偶数的数值。\n\n如果值为偶数或指向包含偶数的单元格的引用，ISEVEN将返回TRUE，否则返回FALSE。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ISODD",t:0,d:"检查所提供的数值是否为奇数。",a:"检查所提供的数值是否为奇数。",m:[1,1],p:[{name:"值",detail:"要验证其是否为奇数的数值。\n\n如果值为奇数或指向包含奇数的单元格，ISODD将返回TRUE，否则返回FALSE。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LCM",t:0,d:"返回一个或多个整数的最小公倍数。",a:"返回一个或多个整数的最小公倍数。",m:[1,255],p:[{name:"值1",detail:"要在求最小公倍数数的计算中检查其因数的第一项数值或范围。",example:"A2:A5",require:"m",repeat:"n",type:"rangeall"},{name:"值2",detail:"[可选] - 在求最小公倍数时要考虑其因数的其他数值或范围。",example:"3",require:"o",repeat:"y",type:"rangeall"}]},{n:"LN",t:0,d:"返回数值以 e（欧拉数）为底的对数。",a:"返回数值以 e（欧拉数）为底的对数。",m:[1,1],p:[{name:"值",detail:"要以 e 为底数计算其对数的值。\n\n值必须为正数。",example:"100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LOG",t:0,d:"根据指定底数返回数字的对数。",a:"根据指定底数返回数字的对数。",m:[1,2],p:[{name:"值",detail:"想要计算其对数的正实数。",example:"128",require:"m",repeat:"n",type:"rangenumber"},{name:"底数",detail:"[可选] - 对数的底数。",example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"LOG10",t:0,d:"返回数值以10为底的对数。",a:"返回数值以10为底的对数。",m:[1,1],p:[{name:"值",detail:"要计算其以10为底的对数的数值。\n\n值必须为正值。",example:"100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MOD",t:0,d:"返回两数相除的余数, 结果的符号与除数相同。",a:"返回两数相除的余数。",m:[2,2],p:[{name:"被除数",detail:"要将其相除以得到余数的数值。",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"除数",detail:"用于除其他数的数值。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MROUND",t:0,d:"将数值取整为另一整数最接近的整数倍。",a:"将数值取整为另一整数最接近的整数倍。",m:[2,2],p:[{name:"值",detail:"要取整为另一整数最接近的整数倍的数值。",example:"21",require:"m",repeat:"n",type:"rangenumber"},{name:"因数",detail:"值将取此因数的整数倍。",example:"14",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ODD",t:0,d:"将数值向上取整为最接近的奇整数。",a:"将数值向上取整为最接近的奇整数。",m:[1,1],p:[{name:"值",detail:"要向上取整的数值，取整值为大于此值的最接近的奇数。\n\n如果值为负数，则将其取整为绝对值大于该值的相邻负奇数。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMSQ",t:0,d:"返回一组数值和/或单元格的平方总和。",a:"返回一组数值和/或单元格的平方总和。",m:[1,255],p:[{name:"值1",detail:"要将其平方相加的第一个数值或范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"值2, ...",detail:"[可选] - 要将其平方与值1的平方相加的其他数值或范围。",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"COMBIN",t:0,d:"给定集合中的对象总数和要选择的对象数量，返回共有多少种不同选择方式。",a:"给定集合中的对象总数和要选择的对象数量",m:[2,2],p:[{name:"n",detail:"要从中进行选择的对象集合的大小。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"k",detail:"要选择的对象数量。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUM",t:0,d:"返回一组数值和/或单元格的总和。",a:"返回一组数值和/或单元格的总和。",m:[1,255],p:[{name:"值1",detail:"要相加的第一个数值或范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"值2",detail:"[可选] - 要相加的其他数值或范围。",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"SUBTOTAL",t:0,d:"使用指定的汇总函数，返回一系列纵向单元格的分类汇总。",a:"使用指定的汇总函数",m:[2,256],p:[{name:"函数代码",detail:"用于计算分类汇总的函数。\n\n1代表AVERAGE\n\n2代表COUNT\n\n3代表COUNTA\n\n4代表MAX\n\n5代表MIN\n\n6代表PRODUCT\n\n7代表STDEV\n\n8代表STDEVP\n\n9代表SUM\n\n10代表VAR\n\n11代表VARP\n\n通过在这些2位代码前附加10（对于1位代码）或1（对于2位代码），可以将隐藏值忽略。例如，102代表忽略隐藏单元格的COUNT，而110则代表忽略隐藏值的VAR。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"范围1",detail:"要计算分类汇总的第一个范围。",example:"A2:A5",require:"m",repeat:"n",type:"range"},{name:"范围2",detail:"[可选] - 要计算分类汇总的其他范围。",example:"B2:B8",require:"o",repeat:"y",type:"range"}]},{n:"ASIN",t:0,d:"返回数值的反正弦值，以弧度表示。",a:"返回数值的反正弦值",m:[1,1],p:[{name:"值",detail:"要计算其反正弦值的数值。必须介于-1和1之间，包括两端值。",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUNTIF",t:1,d:"返回范围内满足某个条件的单元格的数量。",a:"返回范围内满足某个条件的单元格的数量。",m:[2,2],p:[{name:"范围",detail:"要根据条件进行检测的范围。",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"条件",detail:"要应用于范围的模式或测试条件。\n\n如果范围包含的是要检测的文本，则条件必须为字符串。条件可以包含通配符，包括用于匹配单个字符的?或用于匹配零个或连续多个字符的*。要匹配问号星号本身，请在该字符前面加上波浪号(~)前缀（即~?和~*）。字符串条件必须用引号括起来。函数会检查范围中的每个单元格与条件是否相等或匹配（如果使用了通配符）。\n\n如果范围包含的是要检测的数字，则条件可以是字符串也可以是数字。如果给定的条件是一个数字，则检查范围中的每个单元格是否等于条件。另外，条件也可能是包含数字的字符串（也将对其进行相等检测），或者带有以下前缀的数字：=、>、>=、<或<=，这些条件将分别用于检查范围中的单元格是否等于、大于、大于等于、小于、小于等于条件值。",example:'">20"',require:"m",repeat:"n",type:"rangeall"}]},{n:"RADIANS",t:0,d:"将以度表示的角度值转换为弧度。",a:"将以度表示的角度值转换为弧度。",m:[1,1],p:[{name:"角度",detail:"要从度转换为弧度的角度。",example:"180",require:"m",repeat:"n",type:"rangenumber"}]},{n:"RAND",t:0,d:"返回一个介于0和1之间（包括0但不包括1）的随机数。",a:"返回一个介于0和1之间（包括0但不包括1）的随机数。",m:[0,0],p:[]},{n:"COUNTUNIQUE",t:0,d:"计算一列指定值和范围中不重复数值的个数。",a:"计算一列指定值和范围中不重复数值的个数。",m:[1,255],p:[{name:"值1",detail:"要检查其是否唯一的第一个值或范围。",example:"A1:C100",require:"m",repeat:"n",type:"rangeall"},{name:"值2",detail:"[可选] - 要检查是否唯一的其他值或范围。",example:"1",require:"o",repeat:"n",type:"rangeall"}]},{n:"DEGREES",t:0,d:"将以弧度表示的角度值转换为度。",a:"将以弧度表示的角度值转换为度。",m:[1,1],p:[{name:"角度",detail:"要从弧度转换为度的角度。",example:"PI()",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ERFC",t:9,d:"返回数值的互补高斯误差函数。",a:"返回数值的互补高斯误差函数。",m:[1,1],p:[{name:"z",detail:"要为其计算互补高斯误差函数的数值。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"EVEN",t:0,d:"将数值向上取整为最接近的偶整数。",a:"将数值向上取整为最接近的偶整数。",m:[1,1],p:[{name:"值",detail:"要向上取整的数值，取整值为大于此值的最接近的偶数。\n\n如果值为负数，则将其取整为绝对值大于该值的相邻负偶数。",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"EXP",t:0,d:"返回欧拉数 e (~2.718) 的指定次幂。",a:"返回欧拉数 e (~2.718) 的指定次幂。",m:[1,1],p:[{name:"指数",detail:"指定e的自乘幂次值。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FACT",t:0,d:"返回数值的阶乘。",a:"返回数值的阶乘。",m:[1,1],p:[{name:"值",detail:"要计算并返回其阶乘的数字或对数字（所在单元格）的引用。",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FACTDOUBLE",t:0,d:"返回数值的“双阶乘”。",a:"返回数值的“双阶乘”。",m:[1,1],p:[{name:"值",detail:"要计算并返回其双阶乘的数字或对数字（所在单元格）的引用。",example:"6",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PI",t:0,d:"返回带有14位小数的 PI 值。",a:"返回带有14位小数的 PI 值。",m:[0,0],p:[]},{n:"FLOOR",t:0,d:"将数值向下取整为指定因数的最接近的整数倍。",a:"将数值向下取整为指定因数的最接近的整数倍。",m:[2,2],p:[{name:"值",detail:"要向下舍入为因数的最接近整数倍的数值。",example:"23.25",require:"m",repeat:"n",type:"rangenumber"},{name:"因数",detail:"要将值舍入到此数的整数倍。\n\n因数不得为0。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GCD",t:0,d:"返回一个或多个整数的最大公约数。",a:"返回一个或多个整数的最大公约数。",m:[1,255],p:[{name:"值1",detail:"要在查找最大公约数的计算中检查其因数的第一项数值或范围。",example:"A2:A5",require:"m",repeat:"n",type:"rangeall"},{name:"值2",detail:"[可选] - 在求最大公约数时要考虑其因数的其他数值或范围。",example:"96",require:"o",repeat:"y",type:"rangeall"}]},{n:"RANDBETWEEN",t:0,d:"返回介于两个整数之间（包括这两个整数）的随机数。",a:"返回介于两个整数之间（包括这两个整数）的随机数。",m:[2,2],p:[{name:"下界",detail:"随机值范围的下界。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"上界",detail:"随机值范围的上界。",example:"10",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ROUND",t:0,d:"将数字四舍五入到指定的位数。",a:"将数字四舍五入到指定的位数。",m:[2,2],p:[{name:"值",detail:"要四舍五入的数字。",example:"99.44",require:"m",repeat:"n",type:"rangenumber"},{name:"位数",detail:"要进行四舍五入运算的位数。\n\n位数可以取负值，在这种情况下会将值的小数点左侧部分舍入到指定的位数。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ROUNDDOWN",t:0,d:"朝着零的方向将数字进行向下舍入。",a:"朝着零的方向将数字进行向下舍入。",m:[2,2],p:[{name:"值",detail:"需要向下舍入的任意实数。",example:"99.44",require:"m",repeat:"n",type:"rangenumber"},{name:"位数",detail:"要通过舍入达到的小数位数。\n\n位数可以取负值，在这种情况下会将值的小数点左侧部分舍入到指定的位数。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ROUNDUP",t:0,d:"朝着远离 0（零）的方向将数字进行向上舍入。",a:"朝着远离 0（零）的方向将数字进行向上舍入。",m:[2,2],p:[{name:"值",detail:"要将其舍入为位数位数字的值，始终向上舍入。",example:"99.44",require:"m",repeat:"n",type:"rangenumber"},{name:"位数",detail:"要通过舍入达到的小数位数。\n\n位数可以取负值，在这种情况下会将值的小数点左侧部分舍入到指定的位数。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SERIESSUM",t:0,d:"给定参数 x、n、m 和 a，返回幂级数的和 a1xn + a2x(n+m) + ... + aix(n+(i-1)m)，其中 i 为范围 a 中的项数。",a:"给定参数 x、n、m 和 a",m:[4,4],p:[{name:"x",detail:"幂级数的输入值。随相应的近似类型而变，有可能为角度、指数或其他一些值。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"n",detail:"在幂级数中x的初始自乘幂次。",example:"0",require:"m",repeat:"n",type:"rangenumber"},{name:"m",detail:"x的幂次中的附加增量。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"a",detail:"包含幂级数系数的数组或范围。",example:"{FACT(0)",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SIGN",t:0,d:"给定输入数值，如果为负返回-1；如果为正返回1；如果为零则返回0。",a:"给定输入数值",m:[1,1],p:[{name:"值",detail:"要返回其符号的数值。",example:"-42",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SIN",t:0,d:"给定角度（以弧度表示），返回其正弦值。",a:"给定角度（以弧度表示）",m:[1,1],p:[{name:"角度",detail:"要返回其正弦值的角度，以弧度表示。",example:"PI()",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SINH",t:0,d:"返回给定实数的双曲正弦值。",a:"返回给定实数的双曲正弦值。",m:[1,1],p:[{name:"值",detail:"要计算其双曲正弦值的实数值。",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SQRT",t:0,d:"返回一个正数的正平方根。",a:"返回一个正数的正平方根。",m:[1,1],p:[{name:"值",detail:"要计算其正平方根的数值。\n\n值必须为正数；如果为负，SQRT 将返回 #NUM! 错误。",example:"9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SQRTPI",t:0,d:"返回 PI 与给定正数乘积的正平方根。",a:"返回 PI 与给定正数乘积的正平方根。",m:[1,1],p:[{name:"值",detail:"要将其与 PI 相乘并返回该乘积的平方根的数值\n\n值必须为正数；如果为负数，SQRTPI 将返回 #NUM! 错误。",example:"9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GAMMALN",t:1,d:"返回指定伽玛函数的以 e（欧拉数）为底的对数。",a:"返回指定伽玛函数的以 e（欧拉数）为底的对数。",m:[1,1],p:[{name:"值",detail:"伽玛函数的输入值。返回的将是伽玛 (值) 的自然对数。\n\n值必须为正数。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COS",t:0,d:"返回给定角度的余弦值（角度以弧度表示）。",a:"返回给定角度的余弦值（角度以弧度表示）。",m:[1,1],p:[{name:"角度",detail:"要取其余弦值的角度，以弧度表示。",example:"PI()",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TRUNC",t:0,d:"截除指定有效位之外的部分，取数据的指定有效位。",a:"截除指定有效位之外的部分",m:[1,2],p:[{name:"值",detail:"要截取的数据。",example:"3.141592654",require:"m",repeat:"n",type:"rangenumber"},{name:"位数",detail:"[可选 - 默认值为0] - 小数点右侧要保留的有效位数。\n\n如果位数大于值中的有效位数，则将“值”原样返回。\n\n位数可以取负值，在这种情况下会将小数点左侧指定位数的值更改为零。小数点右侧的所有位数都会被舍弃。如果值的所有位都被更改为零，则TRUNC会返回0。",example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"QUOTIENT",t:0,d:"返回以一个数除以另一个数所得的结果，不包含余数。",a:"返回以一个数除以另一个数所得的结果",m:[2,2],p:[{name:"被除数",detail:"要被除的数值。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"除数",detail:"用于除其他数的数值。\n\n除数不得为0。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"POWER",t:0,d:"返回数值的指定次幂。",a:"返回数值的指定次幂。",m:[2,2],p:[{name:"底数",detail:"要计算其指数次幂的数值。\n\n如果底数为负，则指数必须为整数。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"指数",detail:"指定底数的自乘幂次值。",example:"0.5",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMIFS",t:0,d:"根据多项条件返回范围之和。",a:"根据多项条件返回范围之和。",m:[3,257],p:[{name:"求和范围",detail:"要对其求和的范围。",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"条件范围1",detail:"要在哪个范围内检查条件1。",example:" B1:B10",require:"m",repeat:"n",type:"range"},{name:"条件1",detail:"要应用于条件范围1的模式或测试条件。",example:' ">20"',require:"m",repeat:"n",type:"rangeall"},{name:"条件范围2, 条件2...",detail:"[ 可选 ] - 要检查的其他范围和条件。",example:" C1:C10",require:"o",repeat:"y",type:"rangeall"}]},{n:"COUNTIFS",t:1,d:"根据多项条件返回范围中的单元格数量。",a:"根据多项条件返回范围中的单元格数量。",m:[2,256],p:[{name:"条件范围1",detail:"要在哪个范围内检查条件1。",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"条件1",detail:"要应用于条件范围1的模式或测试条件。",example:' ">20"',require:"m",repeat:"n",type:"rangeall"},{name:"条件范围2, 条件2...",detail:"[ 可选 ] - 要检查的其他范围和条件，可重复。",example:" B1:B10",require:"o",repeat:"y",type:"rangeall"}]},{n:"PRODUCT",t:0,d:"返回将一组数相乘所得的结果。",a:"返回将一组数相乘所得的结果。",m:[1,255],p:[{name:"乘数1",detail:"用于计算乘积的第一个数值或范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"乘数2 ... 乘数30",detail:"[可选] - 要相乘的其他数值。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"HARMEAN",t:1,d:"计算数据集的调和平均值。",a:"计算数据集的调和平均值。",m:[1,255],p:[{name:"值1",detail:"样本中的第一项值或范围。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, ...",detail:"[可选] - 数据集中包含的其他数值或范围。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"HYPGEOMDIST",t:1,d:"返回超几何分布。 如果已知样本量、总体成功次数和总体大小，则 HYPGEOM.DIST 返回样本取得已知成功次数的概率。",a:"返回超几何分布。",m:[5,5],p:[{name:"Sample_s",detail:"样本中成功的次数。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"Number_sample",detail:"样本量。",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"Population_s",detail:"总体中成功的次数。",example:"20",require:"m",repeat:"n",type:"rangenumber"},{name:"Number_pop",detail:"总体大小。",example:"40",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"决定函数形式的逻辑值。\n\n如果 cumulative 为 TRUE()，则 HYPGEOM.DIST 返回累积分布函数；\n\n如果为 FALSE()，则返回概率密度函数。",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"INTERCEPT",t:1,d:"计算数据集的线性回归方程直线与 Y 轴的相交点 (x=0) 的 y 值。",a:"计算数据集的线性回归方程直线与 Y 轴的相交点 (x=0) 的 y 值。",m:[2,2],p:[{name:"数据_y",detail:"代表因变量数据数组或矩阵的范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"数据_x",detail:"代表自变量数据数组或矩阵的范围。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"KURT",t:1,d:"计算数据集的峭度，该指标指示数据集（分布）的形态，尤其是该形态的陡峭程度。",a:"计算数据集的峭度",m:[1,255],p:[{name:"值1",detail:"数据集中的第一个值或范围。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, ...",detail:"[可选] - 数据集中包含的其他值或范围。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"LARGE",t:1,d:"返回数据集中第 n 个最大元素，n 由用户指定。",a:"返回数据集中第 n 个最大元素",m:[2,2],p:[{name:"数据",detail:"包含相关数据集的数组或范围。",example:"A2:B100",require:"m",repeat:"n",type:"rangenumber"},{name:"n",detail:"要返回的元素的排行位置（从大到小顺序）。\n\n例如，将n设为4将使LARGE返回数据中排名第4的最大元素。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"STDEVA",t:1,d:"基于样本计算标准偏差，将文本取值为0。",a:"基于样本计算标准偏差",m:[1,255],p:[{name:"值1",detail:"样本中的第一项值或范围。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"值2,…",detail:"[可选] - 样本中包含的其他值或范围。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"STDEVP",t:1,d:"基于样本总体计算标准偏差。",a:"基于样本总体计算标准偏差。",m:[1,255],p:[{name:"值1",detail:"数据集中的第一个值或范围。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, ...",detail:"[可选] - 数据集中包含的其他值或范围。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"GEOMEAN",t:1,d:"计算数据集的几何平均值。",a:"计算数据集的几何平均值。",m:[1,255],p:[{name:"值1",detail:"样本中的第一项值或范围。",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"值2, ...",detail:"[可选] - 数据集中包含的其他数值或范围。",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"RANK_EQ",t:1,d:"返回指定值在数据集中的排名。如果相同的值在数据集中存在多项，则返回其中的最高排名。",a:"返回指定值在数据集中的排名。如果相同的值在数据集中存在多项，则返回其中的最高排名。",m:[2,3],p:[{name:"number",detail:"要确定其排名的值。",example:"A10",require:"m",repeat:"n",type:"rangenumber"},{name:"ref",detail:"包含相关数据集的数组或范围。",example:"A1:A100",require:"m",repeat:"n",type:"range"},{name:"order",detail:"[可选 - 默认为按降序 (FALSE()) ] - 要按升序还是按降序考虑“data”中的值。",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"RANK_AVG",t:1,d:"返回指定值在数据集中的排名。如果相同的值在数据集中存在多项，则返回这些项排名的平均值。",a:"返回指定值在数据集中的排名。如果相同的值在数据集中存在多项，则返回这些项排名的平均值。",m:[2,3],p:[{name:"number",detail:"要确定其排名的值。",example:"A10",require:"m",repeat:"n",type:"rangenumber"},{name:"ref",detail:"包含相关数据集的数组或范围。",example:"A1:A100",require:"m",repeat:"n",type:"range"},{name:"order",detail:"[可选 - 默认为按降序 (FALSE()) ] - 要按升序还是按降序考虑“data”中的值。",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"PERCENTRANK_EXC",t:1,d:"以百分数形式返回指定值在给定数据集中的百分比排名（介于0和1之间，不包括两端值）。",a:"以百分数形式返回指定值在给定数据集中的百分比排名（介于0和1之间，不包括两端值）。",m:[2,3],p:[{name:"data",detail:"包含相关数据集的数组或范围。",example:"A1:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"x",detail:"要确定其百分比排位的值。",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"significance",detail:"[可选 - 默认值为 3] - 要在计算中使用的有效位数。",example:"4",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PERCENTRANK_INC",t:1,d:"以百分比形式返回指定值在给定数据集中的百分比排名（介于0和1之间，包括两端值）。",a:"以百分比形式返回指定值在给定数据集中的百分比排名（介于0和1之间，包括两端值）。",m:[2,3],p:[{name:"data",detail:"包含相关数据集的数组或范围。",example:"A1:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"x",detail:"要确定其百分比排位的值。",example:" A2",require:"m",repeat:"n",type:"rangenumber"},{name:"significance",detail:"[可选 - 默认值为 3] - 要在计算中使用的有效位数。",example:"4",require:"o",repeat:"n",type:"rangenumber"}]},{n:"FORECAST",t:1,d:"基于数据集的线性回归，计算指定 x 的预期 y 值。",a:"基于数据集的线性回归",m:[3,3],p:[{name:"x",detail:"x轴上用于预测的值。",example:"A1",require:"m",repeat:"n",type:"rangenumber"},{name:"数据_y",detail:"代表因变量数据数组或矩阵的范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"数据_x",detail:"代表自变量数据数组或矩阵的范围。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FISHERINV",t:1,d:"返回指定数值的 Fisher 逆变换。",a:"返回指定数值的 Fisher 逆变换。",m:[1,1],p:[{name:"y",detail:"要计算其Fisher逆变换的数值。",example:"0.962",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FISHER",t:1,d:"返回指定数值的 Fisher 变换。",a:"返回指定数值的 Fisher 变换。",m:[1,1],p:[{name:"x",detail:"要计算其Fisher变换的数值。",example:"0.962",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MODE_SNGL",t:1,d:"返回数据集中出现次数最多的值。",a:"返回数据集中出现次数最多的值。",m:[1,255],p:[{name:"值1",detail:"计算模式时要检查的第一个值或范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, ...",detail:"[可选] - 在计算模式时要考虑的其他数值或范围。",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"WEIBULL_DIST",t:1,d:"给定形状和尺度，返回韦伯分布函数（或韦伯累积分布函数）的值。",a:"给定形状和尺度",m:[4,4],p:[{name:"x",detail:"WEIBULL 分布函数的输入值。",example:"2.4",require:"m",repeat:"n",type:"rangenumber"},{name:"alpha",detail:"Weibull 分布函数的形状参数。\n\nalpha 值必须大于 0。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"beta",detail:"Weibull 分布函数的尺度参数。\n\nbeta 值必须大于 0。",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"TRUE() 表示使用累积分布函数，FALSE() 则表示使用概率密度函数。",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"COUNT",t:1,d:"返回数据集中数值的个数。",a:"返回数据集中数值的个数。",m:[1,255],p:[{name:"值1",detail:"计数时要检查的第一个值或范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"值2, ...",detail:"[可选] - 在计数时要检查的其他值或范围。",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"COUNTA",t:1,d:"返回数据集中值的数量。",a:"返回数据集中值的数量。",m:[1,255],p:[{name:"值1",detail:"计数时要检查的第一个值或范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"值2, ...",detail:"[可选] - 在计数时要检查的其他值或范围。",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"AVEDEV",t:1,d:"计算数据与数据集均值之间的偏差大小的平均值。",a:"计算数据与数据集均值之间的偏差大小的平均值。",m:[1,255],p:[{name:"值1",detail:"样本中的第一项值或范围。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, ...",detail:"[可选] - 样本中包含的其他值或范围。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"AVERAGE",t:1,d:"返回数据集的算术平均值，对文本忽略不计。",a:"返回数据集的算术平均值",m:[1,255],p:[{name:"值1",detail:"计算平均值时用到的第一个数值或范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"值2, ...",detail:"[可选] - 在计算平均值时要考虑的其他数值或范围。",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"AVERAGEA",t:1,d:"返回数据集的算术平均值。",a:"返回数据集的算术平均值。",m:[1,255],p:[{name:"值1",detail:"计算平均值时用到的第一个数值或范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"值2, ...",detail:"[可选] - 在计算平均值时要考虑的其他数值或范围。",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"BINOM_DIST",t:1,d:"返回一元二项式分布的概率。",a:"返回一元二项式分布的概率。",m:[4,4],p:[{name:"number_s",detail:"试验的成功次数。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"trials",detail:"独立检验的次数。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"probability_s",detail:"任一给定检验的成功概率。",example:"0.005",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"是否使用二项式累积分布。",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"BINOM_INV",t:1,d:"计算累积二项式分布大于或等于指定条件的最小值。",a:"计算累积二项式分布大于或等于指定条件的最小值。",m:[3,3],p:[{name:"trials",detail:"贝努利试验次数。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"probability_s",detail:"任一次给定检验的成功概率。",example:"0.005",require:"m",repeat:"n",type:"rangenumber"},{name:"alpha",detail:"期望的临界概率。",example:"0.8",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CONFIDENCE_NORM",t:1,d:"计算正态分布的置信区间的一半宽度。",a:"计算正态分布的置信区间的一半宽度。",m:[3,3],p:[{name:"alpha",detail:"用来计算置信水平的显著性水平。\n\n置信水平等于 100*(1 - alpha)%，亦即，如果 alpha 为 0.05，则置信水平为 95%。",example:"0.05",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_dev",detail:"数据区域的总体标准偏差。",example:"1.6",require:"m",repeat:"n",type:"rangenumber"},{name:"size",detail:"样本总量的大小。",example:"250",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CORREL",t:1,d:"计算给定数据集的皮尔逊积矩相关系数 r。",a:"计算给定数据集的皮尔逊积矩相关系数 r。",m:[2,2],p:[{name:"数据_y",detail:"代表因变量数据数组或矩阵的范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"数据_x",detail:"代表自变量数据数组或矩阵的范围。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COVARIANCE_P",t:1,d:"计算数据集的总体协方差。",a:"计算数据集的总体协方差。",m:[2,2],p:[{name:"数据_x",detail:"代表自变量数据数组或矩阵的范围。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"},{name:"数据_y",detail:"代表因变量数据数组或矩阵的范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COVARIANCE_S",t:1,d:"计算数据集的样本协方差。",a:"计算数据集的样本协方差。",m:[2,2],p:[{name:"数据_x",detail:"代表自变量数据数组或矩阵的范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"数据_y",detail:"代表因变量数据数组或矩阵的范围。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DEVSQ",t:1,d:"基于样本计算其偏差的平方和。",a:"基于样本计算其偏差的平方和。",m:[1,255],p:[{name:"值1",detail:"样本中的第一项值或范围。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, ...",detail:"[可选] - 样本中包含的其他值或范围。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"EXPON_DIST",t:1,d:"返回带有指定 Lambda 和指定值的指数分布函数的值。",a:"返回带有指定 Lambda 和指定值的指数分布函数的值。",m:[3,3],p:[{name:"x",detail:"指数分布函数的输入值。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"lambda",detail:"用于指定指数分布函数的 lambda 值。",example:"0.5",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"是否使用指数累积分布。",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"AVERAGEIF",t:1,d:"根据条件返回范围的平均值。",a:"根据条件返回范围的平均值。",m:[2,3],p:[{name:"criteria_range",detail:"要对其检查 criterion 的范围。",example:"A1:A10",require:"m",repeat:"n",type:"rangeall"},{name:"criterion",detail:'要应用于 criteria_range 的模式或测试条件。\n\n等于："文本" 或 1 或 "=文本" 或 "=1"\n\n大于：">1"\n\n大于等于：">=1"\n\n小于："<1"\n\n小于等于："<=1"\n\n不等于："<>1"或"<>文本"',example:'">20"',require:"m",repeat:"n",type:"rangeall"},{name:"average_range",detail:"[可选] - 要计算平均值的范围。如果未提供此参数，则改用 criteria_range 来计算平均值。",example:"B1:B10",require:"o",repeat:"n",type:"rangeall"}]},{n:"AVERAGEIFS",t:1,d:"根据多项条件返回范围的平均值。",a:"根据多项条件返回范围的平均值。",m:[2,255],p:[{name:"average_range",detail:"要计算平均值的范围。",example:"A1:A10",require:"m",repeat:"n",type:"rangeall"},{name:"criteria_range1",detail:"要对其检查 criterion1 的范围。",example:" B1:B10",require:"m",repeat:"n",type:"rangeall"},{name:"criterion1",detail:"要应用于 criteria_range1 的模式或测试条件。",example:' ">20"',require:"m",repeat:"n",type:"rangeall"},{name:"criteria_range2, criterion2, ...",detail:"[可选] - 要检查的其他范围和条件。",example:" C1:C10",require:"m",repeat:"n",type:"rangeall"}]},{n:"PERMUT",t:1,d:"返回可从数字对象中选择的给定数目对象的排列数。",a:"返回可从数字对象中选择的给定数目对象的排列数。",m:[2,2],p:[{name:"number",detail:"表示对象个数的整数。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"number_chosen",detail:"表示每个排列中对象个数的整数。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TRIMMEAN",t:1,d:"在排除数据集高低两端的部分数据之后计算所得的均值。",a:"在排除数据集高低两端的部分数据之后计算所得的均值。",m:[2,2],p:[{name:"数据",detail:"包含相关数据集的数组或范围。",example:"A2:A100",require:"m",repeat:"n",type:"range"},{name:"排除比例",detail:"要从数据集的极值部分排除的数据占数据集的比例。\n\n排除比例必须大于等于0且小于1。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PERCENTILE_EXC",t:1,d:"返回数组的 K 百分点值，K 介于 0 到 1 之间，不含 0 与 1。",a:"返回数组的 K 百分点值，K 介于 0 到 1 之间，不含 0 与 1。",m:[2,2],p:[{name:"array",detail:"定义相对位置的数组或数据区域。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"k",detail:"0 到 1 之间的百分点值，不包含 0 和 1。",example:"0.25",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PERCENTILE_INC",t:1,d:"返回数组的 K 百分点值，K 介于 0 到 1 之间，包含 0 与 1。",a:"返回数组的 K 百分点值，K 介于 0 到 1 之间，包含 0 与 1。",m:[2,2],p:[{name:"array",detail:"定义相对位置的数组或数据区域。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"k",detail:"0 到 1 之间的百分点值，包含 0 和 1。",example:"0.25",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PEARSON",t:1,d:"返回皮尔生(Pearson)乘积矩相关系数 r。",a:"返回皮尔生(Pearson)乘积矩相关系数 r。",m:[2,2],p:[{name:"数据_x",detail:"代表自变量数据数组或矩阵的范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"数据_y",detail:"代表因变量数据数组或矩阵的范围。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NORM_S_INV",t:1,d:"返回标准正态累积分布函数的反函数值。 该分布的平均值为 0，标准偏差为 1。",a:"返回标准正态累积分布函数的反函数值。 该分布的平均值为 0，标准偏差为 1。",m:[1,1],p:[{name:"probability",detail:"对应于正态分布的概率。",example:"0.75",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NORM_S_DIST",t:1,d:"返回标准正态分布函数（该分布的平均值为 0，标准偏差为 1）。",a:"返回标准正态分布函数（该分布的平均值为 0，标准偏差为 1）。",m:[2,2],p:[{name:"z",detail:"需要计算其分布的数值。",example:"2.4",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"决定函数形式的逻辑值。\n\n如果为 TRUE()，则返回累积分布函数；\n\n如果为 FALSE()，则返回概率密度函数。",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"NORM_INV",t:1,d:"返回指定平均值和标准偏差的正态累积分布函数的反函数值。",a:"返回指定平均值和标准偏差的正态累积分布函数的反函数值。",m:[3,3],p:[{name:"probability",detail:"对应于正态分布的概率。",example:"0.75",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"分布的算术平均值。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_dev",detail:"分布的标准偏差。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NORM_DIST",t:1,d:"返回指定平均值和标准偏差的正态分布函数。",a:"返回指定平均值和标准偏差的正态分布函数。",m:[4,4],p:[{name:"x",detail:"需要计算其分布的数值。",example:"2.4",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"分布的算术平均值。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_dev",detail:"分布的标准偏差。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"决定函数形式的逻辑值。\n\n如果为 TRUE()，则返回累积分布函数；\n\n如果为 FALSE()，则返回概率密度函数。",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"NEGBINOM_DIST",t:1,d:"返回负二项式分布。",a:"返回负二项式分布。",m:[4,4],p:[{name:"number_f",detail:"要模拟的失败次数。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"number_s",detail:"要模拟的成功次数。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"probability_s",detail:"任一次给定检验的成功概率。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"决定函数形式的逻辑值。\n\n如果为 TRUE()，则返回累积分布函数；\n\n如果为 FALSE()，则返回概率密度函数。",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"MINA",t:1,d:"返回数据集中的最小数值。",a:"返回数据集中的最小数值。",m:[1,255],p:[{name:"值1",detail:"计算最小值时所用的第一个值或范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"值2",detail:"[可选] - 在计算最小值时要考虑的其他数值或范围。",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MIN",t:1,d:"返回数值数据集中的最小值。",a:"返回数值数据集中的最小值。",m:[1,255],p:[{name:"值1",detail:"计算最小值时所用的第一个值或范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"值2",detail:"[可选] - 在计算最小值时要考虑的其他数值或范围。",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MEDIAN",t:1,d:"返回数值数据集中的中值。",a:"返回数值数据集中的中值。",m:[1,255],p:[{name:"值1",detail:"计算中值时所用的第一个数值或范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"值2",detail:"[可选] - 在计算中值时要考虑的其他数值或范围。",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MAXA",t:1,d:"返回数据集中的最大数值。",a:"返回数据集中的最大数值。",m:[1,255],p:[{name:"值1",detail:"计算最大值时所用的第一个值或范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, ...",detail:"[可选] - 在计算最大值时要考虑的其他数值或范围。",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MAX",t:1,d:"返回数值数据集中的最大值。",a:"返回数值数据集中的最大值。",m:[1,255],p:[{name:"值1",detail:"计算最大值时所用的第一个值或范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"值2",detail:"[可选] - 在计算最大值时要考虑的其他数值或范围。",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"LOGNORM_INV",t:1,d:"返回 x 的对数累积分布函数的反函数值。",a:"返回 x 的对数累积分布函数的反函数值。",m:[3,3],p:[{name:"probability",detail:"与对数分布相关的概率，介于 0 与 1 之间（不含 0 与 1）。",example:"0.4",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"ln(x) 的平均值。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_dev",detail:"ln(x) 的标准偏差，正数。",example:"6",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LOGNORM_DIST",t:1,d:"返回 x 的对数分布函数。",a:"返回 x 的对数分布函数。",m:[4,4],p:[{name:"x",detail:"用来计算函数的值。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"ln(x) 的平均值。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_dev",detail:"ln(x) 的标准偏差，正数。",example:"6",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"决定函数形式的逻辑值。\n\n如果为 TRUE()，则返回累积分布函数；\n\n如果为 FALSE()，则返回概率密度函数。",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"Z_TEST",t:1,d:"返回 z 检验的单尾 P 值。",a:"返回 z 检验的单尾 P 值。",m:[2,3],p:[{name:"array",detail:"用来检验 x 的数组或数据区域。",example:"A2:A100",require:"m",repeat:"n",type:"range"},{name:"x",detail:"要测试的值。",example:"B2",require:"m",repeat:"n",type:"rangenumber"},{name:"sigma",detail:"[可选] - 总体（已知）标准偏差。 如果省略，则使用样本标准偏差。",example:"3",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PROB",t:1,d:"返回区域中的数值落在指定区间内的概率。",a:"返回区域中的数值落在指定区间内的概率。",m:[3,4],p:[{name:"x_range",detail:"具有各自相应概率值的 x 数值区域。",example:"A3:A6",require:"m",repeat:"n",type:"range"},{name:"prob_range",detail:"与 x_range 中的值相关联的一组概率值。",example:"2",require:"m",repeat:"n",type:"range"},{name:"lower_limit",detail:"要计算其概率的数值下界。",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"upper_limit",detail:"[可选 - 默认值为下界] - 要计算其概率的可选数值上界。\n\n如果省略上界，PROB则计算随机选取相应值的次数恰好等于下界的概率。",example:"4",require:"o",repeat:"n",type:"rangenumber"}]},{n:"QUARTILE_EXC",t:1,d:"基于 0 到 1 之间（不包括 0 和 1）的百分点值返回数据集的四分位数。",a:"基于 0 到 1 之间（不包括 0 和 1）的百分点值返回数据集的四分位数。",m:[2,2],p:[{name:"array",detail:"要求得四分位数值的数组或数字型单元格区域。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"quart",detail:"要返回第几个四分位值。\n\n1返回数据中最靠近第一个四分位值的值（25%标记）。\n\n2返回数据中最接近中值的值（50%标记）。\n\n3返回数据中最接近第三个四分位值的值（75%标记）。",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"QUARTILE_INC",t:1,d:"根据 0 到 1 之间的百分点值（包含 0 和 1）返回数据集的四分位数。",a:"根据 0 到 1 之间的百分点值（包含 0 和 1）返回数据集的四分位数。",m:[2,2],p:[{name:"array",detail:"要求得四分位数值的数组或数字型单元格区域。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"quart",detail:"要返回第几个四分位值。\n\n0返回数据中的最小值（0%标记）。\n\n1返回数据中最靠近第一个四分位值的值（25%标记）。\n\n2返回数据中最接近中值的值（50%标记）。\n\n3返回数据中最接近第三个四分位值的值（75%标记）。\n\n4返回数据中的最大值（100%标记）。",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"POISSON_DIST",t:1,d:"返回泊松分布。",a:"返回泊松分布。",m:[3,3],p:[{name:"x",detail:"事件数。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"期望值。非负数",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"一逻辑值，确定所返回的概率分布的形式。\n\n如果为 TRUE()，则返回发生的随机事件数在零（含零）和 x（含 x）之间的累积泊松概率；\n\n如果为 FALSE()，则返回发生的事件数正好是 x 的泊松概率密度函数。",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"RSQ",t:1,d:"返回皮尔生(Pearson)乘积矩相关系数 r 的平方。",a:"返回皮尔生(Pearson)乘积矩相关系数 r 的平方。",m:[2,2],p:[{name:"数据_y",detail:"代表因变量数据数组或矩阵的范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"数据_x",detail:"代表自变量数据数组或矩阵的范围。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_DIST",t:1,d:"返回学生的左尾 t 分布。",a:"返回学生的左尾 t 分布。",m:[3,3],p:[{name:"x",detail:"T-分布函数的输入。",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"自由度数值。",example:"30",require:"m",repeat:"n",type:"rangenumber"},{name:"tails",detail:"决定函数形式的逻辑值。\n\n如果 cumulative 为 TRUE()，则 HYPGEOM.DIST 返回累积分布函数；\n\n如果为 FALSE()，则返回概率密度函数。",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"T_DIST_2T",t:1,d:"返回学生的双尾 t 分布。",a:"返回学生的双尾 t 分布。",m:[2,2],p:[{name:"x",detail:"T-分布函数的输入。",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"自由度数值。",example:"30",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_DIST_RT",t:1,d:"返回学生的右尾 t 分布。",a:"返回学生的右尾 t 分布。",m:[2,2],p:[{name:"x",detail:"T-分布函数的输入。",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"自由度数值。",example:"30",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_INV",t:1,d:"返回学生的 t 分布的左尾反函数。",a:"返回学生的 t 分布的左尾反函数。",m:[2,2],p:[{name:"probability",detail:"与学生的 t 分布相关的概率。\n\n必须大于 0 且小于 1。",example:"0.35",require:"m",repeat:"n",type:"rangenumber"},{name:"deg_freedom",detail:"自由度数值。\n\n如果所提供的参数不是整数，将截取其整数部分。\n\n必须大于等于 1。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_INV_2T",t:1,d:"返回学生 t 分布的双尾反函数。",a:"返回学生 t 分布的双尾反函数。",m:[2,2],p:[{name:"probability",detail:"与学生的 t 分布相关的概率。\n\n必须大于 0 且小于1。",example:"0.35",require:"m",repeat:"n",type:"rangenumber"},{name:"deg_freedom",detail:"自由度数值。\n\n如果所提供的参数不是整数，将截取其整数部分。\n\n必须大于等于 1。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_TEST",t:1,d:"返回与t-检验相关的概率。用于判断两个样本是否可能是出自平均值相同的两个样本总体。",a:"返回与t-检验相关的概率。用于判断两个样本是否可能是出自平均值相同的两个样本总体。",m:[4,4],p:[{name:"array1",detail:"将用于 t 检验的第一个数据样本或第一组单元格。",example:"A1:A4",require:"m",repeat:"n",type:"rangenumber"},{name:"array2",detail:"将用于 t 检验的第二个数据样本或第二组单元格。",example:"B1:B4",require:"m",repeat:"n",type:"rangenumber"},{name:"tails",detail:"指定分布的尾数。\n\n如果为 1：使用单尾分布。\n\n如果为 2：使用双尾分布。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"type",detail:"指定 t 检验的类型。\n\n如果为 1：执行配对检验。\n\n如果为 2：执行双样本等方差（同方差）检验。\n\n如果为3：执行双样本不等方差（异方差）检验。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"F_DIST",t:1,d:"给定输入值 x，计算两个数据集的左尾 F 概率分布（差异程度）。此分布也称为 Fisher-Snedecor 分布或 Snedecor F 分布。",a:"给定输入值 x",m:[4,4],p:[{name:"x",detail:"用来计算函数的值。",example:"15.35",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom1",detail:"分子自由度。",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom2",detail:"分母自由度。",example:"6",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"用于确定函数形式的逻辑值。默认值为 FALSE。\n\n如果为 TRUE()：F.DIST 将返回累积分布函数值。\n\n如果为 FALSE()：F.DIST 将返回概率密度函数值。",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"F_DIST_RT",t:1,d:"给定输入x，计算两个数据集的右尾F概率分布（差异程度）。 此分布也称为Fisher-Snedecor分布或Snedecor F分布。",a:"给定输入x",m:[3,3],p:[{name:"x",detail:"用来计算函数的值。",example:"15.35",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom1",detail:"分子自由度。",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom2",detail:"分母自由度。",example:"6",require:"m",repeat:"n",type:"rangenumber"}]},{n:"VAR_P",t:1,d:"基于样本总体计算方差。",a:"基于样本总体计算方差。",m:[1,255],p:[{name:"值1",detail:"数据集中的第一个值或范围。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, …",detail:"[可选] - 数据集中包含的其他值或范围。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"VAR_S",t:1,d:"基于样本计算方差。",a:"基于样本计算方差。",m:[1,255],p:[{name:"值1",detail:"样本中的第一项值或范围。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, …",detail:"[可选] - 样本中包含的其他值或范围。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"VARA",t:1,d:"基于样本计算方差，将文本取值为0。",a:"基于样本计算方差",m:[1,255],p:[{name:"value1",detail:"样本中的第一项值或范围。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2, ...",detail:"[可选] - 样本中包含的其他值或范围。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"VARPA",t:1,d:"基于样本总体计算方差，将文本取值为0。",a:"基于样本总体计算方差",m:[1,255],p:[{name:"值1",detail:"样本中的第一项值或范围。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, ...",detail:"[可选] - 数据集中包含的其他数值或范围。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"STEYX",t:1,d:"返回通过线性回归法预测每个 x 的 y 值时所产生的标准误差。",a:"返回通过线性回归法预测每个 x 的 y 值时所产生的标准误差。",m:[2,2],p:[{name:"数据_y",detail:"代表因变量数据数组或矩阵的范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"数据_x",detail:"代表自变量数据数组或矩阵的范围。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"STANDARDIZE",t:1,d:"给定分布的均值和标准偏差，计算一个随机变量正态化的相应值。",a:"给定分布的均值和标准偏差，计算一个随机变量正态化的相应值。",m:[3,3],p:[{name:"x",detail:"要正态化的随机变量值。",example:"96",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"分布的均值。",example:"80",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_dev",detail:"分布的标准偏差。",example:"6.7",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SMALL",t:1,d:"返回数据集中的第 k 个最小值。",a:"返回数据集中的第 k 个最小值。",m:[2,2],p:[{name:"array",detail:"需要找到第 k 个最小值的数组或数值数据区域。",example:"A2:B100",require:"m",repeat:"n",type:"range"},{name:"k",detail:"要返回的数据在数组或数据区域里的位置（从小到大）。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SLOPE",t:1,d:"计算通过数据集的线性回归得到的直线的斜率。",a:"计算通过数据集的线性回归得到的直线的斜率。",m:[2,2],p:[{name:"数据_y",detail:"代表因变量数据数组或矩阵的范围。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"数据_x",detail:"代表自变量数据数组或矩阵的范围。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SKEW",t:1,d:"返回分布的偏斜度。 偏斜度表明分布相对于平均值的不对称程度。 正偏斜度表明分布的不对称尾部趋向于更多正值。 负偏斜度表明分布的不对称尾部趋向于更多负值。",a:"返回分布的偏斜度。",m:[1,255],p:[{name:"值1",detail:"数据集中的第一个值或范围。",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"值2, ...",detail:"[可选] - 数据集中包含的其他值或范围。",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"SKEW_P",t:1,d:"返回基于样本总体的分布不对称度：表明分布相对于平均值的不对称程度。",a:"返回基于样本总体的分布不对称度：表明分布相对于平均值的不对称程度。",m:[1,255],p:[{name:"值1",detail:"数据集中的第一个值或范围。",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"值2, ...",detail:"[可选] - 数据集中包含的其他值或范围。",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"VLOOKUP",t:2,d:"纵向查找。在范围的第一列中自上而下搜索某个键值，并返回所找到的行中指定单元格的值。",a:"纵向查找。在范围的第一列中自上而下搜索某个键值",m:[3,4],p:[{name:"搜索键值",detail:'要搜索的值，如 42、"Cats" 或 I24。',example:"10003",require:"m",repeat:"n",type:"rangeall"},{name:"范围",detail:"要进行搜索的范围。VLOOKUP 将在该范围的第一列中搜索搜索键值中指定的键值。",example:"A2:B26",require:"m",repeat:"n",type:"rangeall"},{name:"索引",detail:"要返回的值的列索引，范围中的第一列编号为 1。\n\n如果索引不是介于 1 和范围中的列数之间，将返回 #VALUE! 。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"已排序",detail:"[默认值为 TRUE() ] - 指示要搜索的列（指定范围的第一列）是否已排序。大多数情况下，建议设为 FALSE()。\n\n建议将已排序设为 FALSE。如果设为 FALSE，将返回完全匹配项。如果存在多个匹配值，将返回找到的第一个值对应的单元格的内容，如果找不到匹配值，则返回 #N/A。\n\n如果将已排序设为 TRUE 或省略，将返回（小于或等于搜索键值的）最接近的匹配项。如果搜索的列中所有的值均大于搜索键值，则返回 #N/A。",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"HLOOKUP",t:2,d:"横向查找。在范围的第一行中搜索某个键值，并返回所找到的列中指定单元格的值。",a:"横向查找。在范围的第一行中搜索某个键值",m:[3,4],p:[{name:"搜索键值",detail:'要搜索的值。例如，42、"Cats"或I24。',example:"10003",require:"m",repeat:"n",type:"rangeall"},{name:"范围",detail:"要进行搜索的范围。将在该范围的第一行中搜索在搜索键值中指定的键值。",example:"A2:Z6",require:"m",repeat:"n",type:"rangeall"},{name:"索引",detail:"要返回的值的行索引，范围中的第一行编号为1。\n\n如果索引不是介于1和范围中的行数之间，将返回#VALUE!。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"已排序",detail:"[可选 - 默认值为TRUE()] - 指示要搜索的行（指定范围的第一行）是否已排序。\n\n如果将已排序设为TRUE或省略，将返回最接近的匹配值（小于或等于搜索键值）。如果在搜索的行中所有的值均大于搜索键值，则返回#N/A。\n\n如果将已排序设为TRUE或将其省略，而范围的首行并非处于已排序状态，则返回值可能会是错误的。\n\n如果将已排序设为FALSE，则仅返回完全匹配。如果存在多个匹配值，将返回与找到的第一个值对应的单元格的内容，如果找不到匹配值则返回#N/A。",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"LOOKUP",t:2,d:"在行或列中查找相应键，并将相应单元格的值返回到与搜索行或列所在位置相同的结果范围中。",a:"在行或列中查找相应键",m:[2,3],p:[{name:"搜索键值",detail:'要在行或列中搜索的值。例如，42、"Cats" 或 I24。',example:"10003",require:"m",repeat:"n",type:"rangeall"},{name:"搜索范围 | 搜索结果数组",detail:"使用 LOOKUP 的一种方法是给定单行或单列形式的搜索范围进行搜索查找，这种方式要用到另一个参数结果范围。另一种方式是将这两个参数合并为一个搜索结果数组，其中第一行或第一列用于搜索，并将返回值放在该数组的最后一行或最后一列中。",example:"A1:A100",require:"m",repeat:"n",type:"rangeall"},{name:"结果范围",detail:"[ 可选 ] - 用于存放返回结果的范围。返回值对应于在搜索范围中找到搜索键值的位置。此范围必须仅为单行或单列，而如果您使用的是搜索结果数组方式，则不应提供此参数。",example:"B1:B100",require:"o",repeat:"n",type:"rangeall"}]},{n:"ADDRESS",t:2,d:"返回字符串形式的单元格引用。",a:"返回字符串形式的单元格引用。",m:[2,5],p:[{name:"row_num",detail:"一个数值，指定要在单元格引用中使用的行号。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"column_num",detail:"一个数值，指定要在单元格引用中使用的列号（而非名称）。A列的编号为1。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"abs_num",detail:"[可选 - 默认值为1] - 一个数值，指定要返回的引用类型。\n\n1 表示行列均采用绝对值（例如$A$1）；\n\n2 表示采用绝对行号，相对列标（例如A$1）；\n\n3 表示采用相对行号，绝对列标（例如$A1）；\n\n4 表示行列均采用相对值（例如A1）。",example:"4",require:"o",repeat:"n",type:"rangenumber"},{name:"A1",detail:"[可选 - 默认值为TRUE()] - 一个布尔值，指示采用A1标记形式(TRUE)还是R1C1标记形式(FALSE)。",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"},{name:"sheet_text",detail:"[可选 - 默认缺省] - 用于指定地址所指向的工作表名称。",example:'"Sheet2"',require:"o",repeat:"n",type:"rangeall"}]},{n:"INDIRECT",t:2,d:"返回以字符串指定的单元格引用。",a:"返回以字符串指定的单元格引用。",m:[1,2],p:[{name:"ref_text",detail:"以带引号的字符串形式提供的单元格引用。",example:'"Sheet2!"&B10',require:"m",repeat:"n",type:"rangeall"},{name:"A1",detail:"[可选 - 默认值为TRUE()] - 一个布尔值，指示采用A1标记形式(TRUE)还是R1C1标记形式(FALSE)。",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"ROW",t:2,d:"返回指定单元格的行号",a:"返回指定单元格的行号",m:[0,1],p:[{name:"reference",detail:"[可选 - 默认为此公式所在的单元格] - 要返回其行号的单元格。\n\n如果单元格引用指向的范围其宽度大于一个单元格，而此公式不是用作数组公式的，这时会仅返回单元格引用中首行的编号值。",example:"A9",require:"o",repeat:"n",type:"rangeall"}]},{n:"ROWS",t:2,d:"返回指定数组或范围中的行数。",a:"返回指定数组或范围中的行数。",m:[1,1],p:[{name:"array",detail:"要返回其行数的范围。",example:"A9:A62",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COLUMN",t:2,d:"按照 `A=1` 的规则返回指定单元格的列号。",a:"按照 `A=1` 的规则返回指定单元格的列号。",m:[0,1],p:[{name:"reference",detail:"[可选 - 默认为包含此公式的单元格] - 要返回其列号的单元格。A列对应的编号为1。\n\n如果单元格引用是宽度超过一个单元格的范围，而此公式不是作为数组公式来使用的，因此将返回单元格引用中的第一列的位置。",example:"A9",require:"o",repeat:"n",type:"rangeall"}]},{n:"COLUMNS",t:2,d:"返回指定数组或范围中的列数。",a:"返回指定数组或范围中的列数。",m:[1,1],p:[{name:"array",detail:"要返回其列数的范围。",example:"A9:W62",require:"m",repeat:"n",type:"rangenumber"}]},{n:"OFFSET",t:2,d:"给定某范围的起始单元格引用以及该范围涵盖的行列数量，返回该范围的引用。",a:"给定某范围的起始单元格引用以及该范围涵盖的行列数量，返回该范围的引用。",m:[3,5],p:[{name:"reference",detail:"用于计算行列偏移量的起点。",example:"A2",require:"m",repeat:"n",type:"range"},{name:"rows",detail:"要偏移的行数。\n\n行偏移量必须是整数，但也可以是负数。如果提供的参数带有小数，小数部分将被截去。",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"cols",detail:"要偏移的列数。\n\n列偏移量必须是整数，但也可以是负数。如果提供的参数带有小数，小数部分将被截去。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"height",detail:"[可选] - 要从偏移目标开始返回的范围的高度。",example:"2",require:"o",repeat:"n",type:"rangenumber"},{name:"width",detail:"[可选] - 要从偏移目标开始返回的范围的宽度。",example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"MATCH",t:2,d:"在单元格中搜索指定项，然后返回该项在单元格区域中的相对位置。",a:"在单元格中搜索指定项，然后返回该项在单元格区域中的相对位置。",m:[2,3],p:[{name:"lookup_value",detail:"要在 lookup_array 中匹配的值。",example:'"Sunday"',require:"m",repeat:"n",type:"rangeall"},{name:"lookup_array",detail:"要搜索的单元格区域。\n\n如果所用的范围的高度和宽度均大于1，MATCH将返回#N/A!。",example:"A2:A9",require:"m",repeat:"n",type:"range"},{name:"match_type",detail:"[可选 - 默认值为1] - 要采用的搜索方式。\n\n1为默认类型，此时MATCH会假设范围已按升序排序，并返回小于等于搜索键值的最大值。\n\n0表示完全匹配，在范围未排序的情况下需要使用此方式。\n\n-1让MATCH假设范围是按降序排序的，并返回大于等于搜索键值的最小值。",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"INDEX",t:2,d:"返回表格或中的元素值，此元素由行号和列号的索引值给定。",a:"返回表格或中的元素值，此元素由行号和列号的索引值给定。",m:[2,3],p:[{name:"array",detail:"单元格区域或数组常量。",example:"A1:C20",require:"m",repeat:"n",type:"range"},{name:"row_num",detail:"选择数组中的某行，函数从该行返回数值。",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"column_num",detail:"选择数组中的某列，函数从该列返回数值。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GETPIVOTDATA",t:2,d:"从与指定行和列标题对应的数据透视表中提取汇总值。",a:"从与指定行和列标题对应的数据透视表中提取汇总值。",m:[2,254],p:[{name:"data_field",detail:"您想从数据透视表中获取其数据的值名称。\n值名称必须括在引号中或是指向包含相关文本的任何单元格的引用。\n如果有多个值字段，则必须使用数据透视表中显示的确切名称（如“销售总额”）。",example:'"SUM of number of units"',require:"m",repeat:"n",type:"rangeall"},{name:"pivot_table",detail:"目标数据透视表中的任何单元格的引用（推荐位于顶角的单元格）。",example:"'Pivot table'!A1",require:"m",repeat:"n",type:"rangeall"},{name:"field1",detail:"[可选] - 源数据集（不是数据透视表）中列的名称。",example:'"division"',require:"o",repeat:"y",type:"rangeall"},{name:"item1",detail:"[可选] - 数据透视表中显示的与您要检索的字段名称 1 相对应的行或列的名称。",example:'"east"',require:"o",repeat:"y",type:"rangeall"}]},{n:"CHOOSE",t:2,d:"基于索引返回选项列表中的元素。",a:"基于索引返回选项列表中的元素。",m:[2,255],p:[{name:"index_num",detail:"指定要返回哪一项。\n\n如果索引为零、负值或大于提供的选择数量，将返回#VALUE!错误。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"value1",detail:"一项可能的返回值。必须提供。可以是单元格引用或单独的值。",example:'"A"',require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"[可选] - 其他可以选择的值。选择",example:'"B"',require:"o",repeat:"y",type:"rangeall"}]},{n:"HYPERLINK",t:2,d:"在单元格内创建一个超链接。",a:"在单元格内创建一个超链接。",p:[{name:"网址",detail:"以引号括住的链接位置的完整网址，或对包含这种网址的单元格的引用。\n\n仅允许某些链接类型。其中包括：http://、https://、mailto:、aim:、ftp://、gopher://、telnet://和news://，明确禁用使用其他协议。如果指定的是其他协议，将会在单元格中显示链接标签，但该标签不会以链接形式呈现。\n\n如果未指定协议，则假设使用http://，并将其作为网址的前缀。",example:'"http://www.google.com/"',require:"m",repeat:"n",type:"rangeall"},{name:"链接标签",detail:'[可选 - 默认为网址] - 要在单元格中作为链接显示的文本（用引号括起来的），或者指向包含这种标签的单元格的引用。\n\n如果链接标签是指向某个空单元格的引用，如果网址有效，就将其作为链接显示，否则作为纯文本显示。\n\n如果链接标签为空字符串常量("")，所在单元格显示的内容将为空白，但通过点击该单元格或转入该单元格仍然可以访问链接。',example:'"Google"',require:"m",repeat:"n",type:"rangeall"}]},{n:"TIME",t:6,d:"将给定的小时、分钟和秒转换为时间。",a:"将给定的小时、分钟和秒转换为时间。",m:[3,3],p:[{name:"小时",detail:"0（零）到 32767 之间的数字，代表小时。\n\n任何大于 23 的值都会除以 24，余数将作为小时值。",example:"11",require:"m",repeat:"n",type:"rangenumber"},{name:"分钟",detail:"0（零）到 32767 之间的数字，代表分钟。\n\n任何大于 59 的值将转换为小时和分钟。",example:"40",require:"m",repeat:"n",type:"rangenumber"},{name:"秒",detail:"0（零）到 32767 之间的数字，代表秒。\n\n任何大于 59 的值将转换为小时、分钟和秒。",example:"59",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TIMEVALUE",t:6,d:"按一天24小时返回该时间的分数表示。",a:"按一天24小时返回该时间的分数表示。",m:[1,1],p:[{name:"time_text",detail:"用于表示时间的字符串。",example:'"2:15 PM"',require:"m",repeat:"n",type:"rangeall"}]},{n:"EOMONTH",t:6,d:"返回某个月份最后一天的序列号，该月份在另一个日期之前或之后的数个月（月数由参数指定）。",a:"返回某个月份最后一天的序列号",m:[2,2],p:[{name:"start_date",detail:"用于计算结果的参照日期。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"months",detail:"用于计算的起始日期之前（负）或之后（正）的月数。返回的是计算所得月份的最后那天。",example:"7",require:"m",repeat:"n",type:"rangenumber"}]},{n:"EDATE",t:6,d:"返回表示某个日期的序列号，该日期在另一个日期的数月之前/之后。",a:"返回表示某个日期的序列号",m:[2,2],p:[{name:"start_date",detail:"用于计算结果的参照日期。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"months",detail:"用于计算的起始日期之前（负）或之后（正）的月数。",example:"7",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SECOND",t:6,d:"返回时间值的秒数。 秒数是 0（零）到 59 范围内的整数。",a:"返回时间值的秒数。 秒数是 0（零）到 59 范围内的整数。",m:[1,1],p:[{name:"时间",detail:"用于计算秒钟部分的时间。必须为以下值之一：指向包含日期/时间值的单元格的引用、返回日期/时间的函数或者数字。",example:"TIME(11",require:"m",repeat:"n",type:"rangeall"}]},{n:"MINUTE",t:6,d:"以数字格式返回特定时间的分钟部分。",a:"以数字格式返回特定时间的分钟部分。",m:[1,1],p:[{name:"时间",detail:"用于计算分钟部分的时间。必须为以下值之一：指向包含日期/时间值的单元格的引用、返回日期/时间的函数或者数字。",example:"TIME(11",require:"m",repeat:"n",type:"rangeall"}]},{n:"HOUR",t:6,d:"以数字格式返回特定时间的小时部分。",a:"以数字格式返回特定时间的小时部分。",m:[1,1],p:[{name:"时间",detail:"用于计算小时部分的时间。必须为以下值之一：指向包含日期/时间值的单元格的引用、返回日期/时间的函数或者数字。",example:"TIME(11",require:"m",repeat:"n",type:"rangeall"}]},{n:"NOW",t:6,d:"以日期值格式返回当前日期和时间。",a:"以日期值格式返回当前日期和时间。",m:[0,0],p:[]},{n:"NETWORKDAYS",t:6,d:"返回所提供的两个日期之间的净工作日天数。",a:"返回所提供的两个日期之间的净工作日天数。",m:[2,3],p:[{name:"start_date",detail:"用于计算净工作日天数的时间段开始日期。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"用于计算净工作日天数的时间段结束日期。",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"holidays",detail:"[可选] - 一个范围或数组常量，其中包含作为节假日的日期序号。\n\n在节假日数组中提供的值必须是日期序号值（例如由N所返回的值）或日期值（例如由DATE、DATEVALUE或TO_DATE返回的值）。由范围指定的值应该是标准的日期值或日期序数值。",example:"16)",require:"o",repeat:"n",type:"rangeall"}]},{n:"NETWORKDAYS_INTL",t:6,d:"返回给定的两个日期之间的净工作日天数（排除指定的周末和节假日）。",a:"返回给定的两个日期之间的净工作日天数（排除指定的周末和节假日）。",m:[2,4],p:[{name:"start_date",detail:"用于计算净工作日天数的时间段开始日期。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"用于计算净工作日天数的时间段结束日期。",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"weekend",detail:"[可选 - 默认值为1] - 用于表示哪些天为周末的数字或字符串。\n字符串方式：可以使用由0和1组成的字符串来指定周末，串中的第一个数字字符代表周一，最后一个则代表周日。零表示这一天是工作日，1表示这一天为周末。例如，“0000011”表示将周六和周日作为周末。\n数字方式：这种方式不使用上述字符串形式，而是使用一个数字。1 =周六/周日为周末，2 =周日/周一为周末，依此类推则7 =周五/周六。11 =周日为唯一周末，12 =周一为唯一周末，依此类推则17 =周六为唯一周末。",example:"16)",require:"o",repeat:"n",type:"rangeall"},{name:"holidays",detail:"[ 可选 ] - 这是一个范围或数组常量，其中包含作为节假日的日期。\n在节假日数组内提供的值必须为日期序数值（例如N的返回值）或日期值（例如DATE、DATEVALUE或TO_DATE的返回值）。由范围指定的值应该是标准的日期值或日期序数值。",example:"DATE(1969",require:"o",repeat:"n",type:"rangeall"}]},{n:"ISOWEEKNUM",t:6,d:"返回给定日期在全年中的 ISO 周数。",a:"返回给定日期在全年中的 ISO 周数。",m:[1,1],p:[{name:"date",detail:"用于日期和时间计算的日期-时间代码。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"WEEKNUM",t:6,d:"返回特定日期的周数。",a:"返回特定日期的周数。",m:[1,2],p:[{name:"serial_number",detail:"要确定其位于第几周的日期，必须是对包含日期的单元格的引用、返回日期类型的函数或者数字。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"return_type",detail:"[可选 - 默认值为 1 ] - 代表一周起始日的数字，系统也使用该数字来确定一年的第一周（1=周日，2=周一）。",example:"7",require:"o",repeat:"n",type:"rangenumber"}]},{n:"WEEKDAY",t:6,d:"返回一个数字，对应于给定日期所在的星期几。",a:"返回一个数字，对应于给定日期所在的星期几。",m:[1,2],p:[{name:"serial_number",detail:"要为其确定星期几的日期。必须是对包含日期的单元格的引用、返回日期类型的函数或者数字。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"return_type",detail:"[可选 - 默认值为 1] - 以数字指示使用哪种编号顺序来表示星期几。默认情况下，按星期日 (= 1) 开始计算。\n\n如果类型为 1，则星期值将从星期日开始算起，并且星期日的值为 1，因此星期六的值就是 7。\n\n如果类型为 2，则星期值将从星期一开始算起，并且星期一的值为 1，因此星期日的值就是 7。\n\n如果类型为 3，则星期值将从星期一算起，并且星期一的值为 0，因此星期日的值就是 6。",example:"7",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DAY",t:6,d:"以数字格式返回特定日期所在的当月几号。",a:"以数字格式返回特定日期所在的当月几号。",m:[1,1],p:[{name:"serial_number",detail:"要从中提取具体几号的日期。必须是以下一种：对包含日期的单元格的引用、返回日期类型的函数或者数字。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"DAYS",t:6,d:"返回两个日期之间的天数。",a:"返回两个日期之间的天数。",m:[2,2],p:[{name:"end_date",detail:"计算中要使用的结束日期。必须是以下一种：对包含日期的单元格的引用、返回日期类型的函数或者数字。",example:"2011-3-15",require:"m",repeat:"n",type:"rangeall"},{name:"start_date",detail:"计算中要使用的开始日期。必须是以下一种：对包含日期的单元格的引用、返回日期类型的函数或者数字。",example:"2011-2-1",require:"m",repeat:"n",type:"rangeall"}]},{n:"DAYS360",t:6,d:"按照每年360天，返回两个日期之间的差（用于计算利息）。",a:"按照每年360天，返回两个日期之间的差（用于计算利息）。",m:[2,3],p:[{name:"start_date",detail:"计算中要使用的开始日期。必须是以下一种：对包含日期的单元格的引用、返回日期类型的函数或者数字。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"计算中要使用的结束日期。必须是以下一种：对包含日期的单元格的引用、返回日期类型的函数或者数字。",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"method",detail:"[可选 - 默认为FALSE()] - 指示要使用哪种天数计算方法。\n\nFALSE - 采用美国 (NASD) 方法时，如果起始日期为某月的最后一天，为便于计算，会将起始日期的当月几号更改为30。此外，如果结束日期是所在月份的最后一天，而且起始日期在其所在月的30号之前，则将结束日期更改为结束日期之后那个月的第一天，否则将结束日期更改为该月的30号。\n\nTRUE - 采用欧洲方法时，会将所有日期在31号的起始日期或结束日期更改为当月的30号。",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"DATE",t:6,d:"将提供的年、月、日转换为日期。",a:"将提供的年、月、日转换为日期。",m:[3,3],p:[{name:"year",detail:"日期的年份部分，包含一到四位数字。\n\n介于 0（零）到 1899 之间，会将该值与 1900 相加来计算年份；\n\n介于 1900 到 9999 之间，将使用该数值作为年份；\n\n小于 0 或大于等于 10000，返回 错误值 #NUM!。",example:"1969",require:"m",repeat:"n",type:"rangenumber"},{name:"month",detail:"日期的月份部分，一个正整数或负整数。\n\n如果 month 大于 12，则 month 会将该月份数与指定年中的第一个月相加。\n\n如果 month 小于 1，month 则从指定年份的一月份开始递减该月份数，然后再加上 1 个月。",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"day",detail:"日期的日部分，一个正整数或负整数。\n\n如果 day 大于月中指定的天数，则 day 会将天数与该月中的第一天相加。\n\n如果 day 小于 1，则 day 从指定月份的第一天开始递减该天数，然后再加上 1 天。",example:"20",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DATEVALUE",t:6,d:"将提供的日期字符串转换为日期的序列号。",a:"将提供的日期字符串转换为日期的序列号。",m:[1,1],p:[{name:"date_text",detail:"表示日期的字符串。",example:'"1969-7-20"',require:"m",repeat:"n",type:"rangeall"}]},{n:"DATEDIF",t:6,d:"计算两个日期之间的天数、月数或年数。",a:"计算两个日期之间的天数、月数或年数。",m:[3,3],p:[{name:"起始日期",detail:"计算中要使用的开始日期。必须是对包含DATE值的单元格的引用、返回DATE类型的函数或数字。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"结束日期",detail:"计算中要使用的结束日期。必须是对包含DATE值的单元格的引用、返回DATE类型的函数或数字。",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"单位",detail:'时间单位的缩写文字。例如 "M" 代表月。有效值包括："Y"、"M"、"D"、"MD"、"YM" 和 "YD"。\n\n"Y"：返回起始日期和结束日期之间的整年数。\n\n"M"：返回起始日期和结束日期之间的整月数。\n\n"D"：返回起始日期和结束日期之间的天数。\n\n"MD"：返回起始日期和结束日期之间的天数（不计整月数）。\n\n"YM"：返回起始日期和结束日期之间的整月数（不计整年数）。\n\n"YD"：返回起始日期和结束日期之间的天数（假设起始日期和结束日期的间隔不超过一年）。',example:"16)",require:"m",repeat:"n",type:"rangeall"}]},{n:"WORKDAY",t:6,d:"指定工作日天数，计算结束日期。",a:"指定工作日天数，计算结束日期。",m:[2,3],p:[{name:"start_date",detail:"计算的开始日期。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"days",detail:"start_date 之前或之后不含周末及节假日的天数。\n\n为正值将生成未来日期；\n\n为负值生成过去日期。",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"holidays",detail:"[可选] - 一个范围或数组常量，其中包含作为节假日的日期序号。\n\n在节假日数组中提供的值必须是日期序号值（例如由N所返回的值）或日期值（例如由DATE、DATEVALUE或TO_DATE返回的值）。由范围指定的值应该是标准的日期值或日期序数值。",example:"16)",require:"o",repeat:"n",type:"rangeall"}]},{n:"WORKDAY_INTL",t:6,d:"返回指定的若干个工作日之前或之后的日期的序列号（使用自定义周末参数）。 ",a:"返回指定的若干个工作日之前或之后的日期的序列号（使用自定义周末参数）。 ",m:[2,4],p:[{name:"start_date",detail:"开始日期（将被截尾取整）。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"days",detail:"start_date 之前或之后的工作日的天数。\n\n正值表示未来日期；\n\n负值表示过去日期；\n\n零值表示开始日期。",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"weekend",detail:"[可选 - 默认值为1] - 用于表示哪些天为周末的数字或字符串。\n字符串方式：可以使用由0和1组成的字符串来指定周末，串中的第一个数字字符代表周一，最后一个则代表周日。零表示这一天是工作日，1表示这一天为周末。例如，“0000011”表示将周六和周日作为周末。\n数字方式：这种方式不使用上述字符串形式，而是使用一个数字。1 =周六/周日为周末，2 =周日/周一为周末，依此类推则7 =周五/周六。11 =周日为唯一周末，12 =周一为唯一周末，依此类推则17 =周六为唯一周末。",example:"16)",require:"o",repeat:"n",type:"rangeall"},{name:"holidays",detail:"[ 可选 ] - 这是一个范围或数组常量，其中包含作为节假日的日期。\n在节假日数组内提供的值必须为日期序数值（例如N的返回值）或日期值（例如DATE、DATEVALUE或TO_DATE的返回值）。由范围指定的值应该是标准的日期值或日期序数值。",example:"DATE(1969",require:"o",repeat:"n",type:"rangeall"}]},{n:"YEAR",t:6,d:"返回对应于某个日期的年份。 Year 作为 1900 - 9999 之间的整数返回。",a:"返回对应于某个日期的年份。 Year 作为 1900 - 9999 之间的整数返回。",m:[1,1],p:[{name:"serial_number",detail:"用于计算年份的日期。必须是以下一种：对包含日期的单元格的引用、返回日期类型的函数或者数字。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"YEARFRAC",t:6,d:"返回 start_date 和 end_date 之间的天数占全年天数的百分比。",a:"返回 start_date 和 end_date 之间的天数占全年天数的百分比。",m:[2,3],p:[{name:"start_date",detail:"计算中要使用的开始日期。必须是以下一种：对包含日期的单元格的引用、返回日期类型的函数或者数字。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"计算中要使用的结束日期。必须是以下一种：对包含日期的单元格的引用、返回日期类型的函数或者数字。",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"basis",detail:"[可选 - 默认为0] - 要使用的日计数基准类型。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",example:"16)",require:"o",repeat:"n",type:"rangenumber"}]},{n:"TODAY",t:6,d:"以日期值格式返回当前日期。",a:"以日期值格式返回当前日期。",m:[0,0],p:[]},{n:"MONTH",t:6,d:"返回日期（以序列数表示）中的月份。 月份是介于 1（一月）到 12（十二月）之间的整数。",a:"返回日期（以序列数表示）中的月份。 月份是介于 1（一月）到 12（十二月）之间的整数。",m:[1,1],p:[{name:"serial_number",detail:"要从中提取月份的日期。必须是以下一种：对包含日期的单元格的引用、返回日期类型的函数或者数字。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"EFFECT",t:8,d:"根据名义利率及每年的复利计息期数来计算实际年利率。",a:"根据名义利率及每年的复利计息期数来计算实际年利率。",m:[2,2],p:[{name:"nominal_rate",detail:"每年的名义利率。",example:"0.99",require:"m",repeat:"n",type:"rangenumber"},{name:"npery",detail:"每年的复利计算期数。",example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DOLLAR",t:12,d:"将数字格式设置为与语言区域相对应的货币格式。",a:"将数字格式设置为与语言区域相对应的货币格式。",m:[1,2],p:[{name:"number",detail:"要设置格式的值。",example:"1.2351",require:"m",repeat:"n",type:"rangenumber"},{name:"decimals",detail:"[可选 - 默认值为 2] - 要显示的小数位数。\n\n如果这是负数，则将数字四舍五入到小数点左侧。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DOLLARDE",t:8,d:"将以整数部分和分数部分转换为以小数部分表示的金额数字",a:"将以整数部分和分数部分转换为以小数部分表示的金额数字",m:[2,2],p:[{name:"fractional_dollar",detail:"以整数部份和分数部分表示的数字，用小数点隔开。",example:"100.10",require:"m",repeat:"n",type:"rangenumber"},{name:"fraction",detail:"用作分数中的分母的整数。",example:"32",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DOLLARFR",t:8,d:"将小数转换为分数表示的金额数字。",a:"将小数转换为分数表示的金额数字。",m:[2,2],p:[{name:"decimal_dollar",detail:"小数。",example:"100.125",require:"m",repeat:"n",type:"rangenumber"},{name:"fraction",detail:"用作分数中的分母的整数。",example:"32",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DB",t:8,d:"使用固定余额递减法，返回指定期间内某项固定资产的折旧值。",a:"使用固定余额递减法，返回指定期间内某项固定资产的折旧值。",m:[4,5],p:[{name:"cost",detail:"资产原值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"折旧末尾时的值（有时也称为资产残值）。",example:"50",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"资产的折旧期数（有时也称作资产的使用寿命）。",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"在使用期限内要计算折旧的折旧期。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"month",detail:"[可选 - 默认值为12] - 折旧第一年中的月数。",example:"10",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DDB",t:8,d:"用双倍余额递减法，返回指定期间内某项固定资产的折旧值。",a:"用双倍余额递减法，返回指定期间内某项固定资产的折旧值。",m:[4,5],p:[{name:"cost",detail:"资产原值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"折旧末尾时的值（有时也称为资产残值）。",example:"50",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"资产的折旧期数（有时也称作资产的使用寿命）。",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"在使用期限内要计算折旧的折旧期。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"factor",detail:"[可选 - 默认值为2] - 折旧的递减系数。",example:"2.25",require:"m",repeat:"n",type:"rangenumber"}]},{n:"RATE",t:8,d:"返回年金每期的利率。",a:"返回年金每期的利率。",m:[3,6],p:[{name:"nper",detail:"年金的付款总期数。",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"pmt",detail:"每期的付款金额，在年金周期内不能更改。",example:"-100",require:"m",repeat:"n",type:"rangenumber"},{name:"pv",detail:"现值即一系列未来付款当前值的总和。",example:"400",require:"m",repeat:"n",type:"rangenumber"},{name:"fv",detail:"[可选 - 默认值为0] - 未来值，或在最后一次付款后希望得到的现金余额。",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"type",detail:"[可选 - 默认值为0] - 指定各期的付款时间是在期初还是期末。\n\n0 表示期末；\n\n1 表示期初。",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"guess",detail:"[可选 - 默认值为0.1] - 预期利率。",example:"0.1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"CUMPRINC",t:8,d:"基于等额分期付款和固定利率，计算投资在多个付款期内的累计本金偿还额。",a:"基于等额分期付款和固定利率，计算投资在多个付款期内的累计本金偿还额。",m:[6,6],p:[{name:"rate",detail:"利率。",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"nper",detail:"总付款期数。",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"pv",detail:"年金的现值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"start_period",detail:"开始累计计算的付款期序号。\n\n首期必须大于等于1。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"end_period",detail:"结束累计计算的付款期序号。\n\n末期必须大于首期。",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"type",detail:"指定各期的付款时间是在期初还是期末。\n\n0 表示期末；\n\n1 表示期初。",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUPNUM",t:8,d:"返回在结算日和到期日之间的付息次数，向上舍入到最近的整数。",a:"返回在结算日和到期日之间的付息次数，向上舍入到最近的整数。",m:[3,4],p:[{name:"settlement",detail:"有价证券的结算日。有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有价证券的到期日。到期日是有价证券有效期截止时的日期。",example:"02",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:"[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"SYD",t:8,d:"返回在指定期间内资产按年限总和折旧法计算的折旧。",a:"返回在指定期间内资产按年限总和折旧法计算的折旧。",m:[4,4],p:[{name:"cost",detail:"资产原值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"折旧末尾时的值（有时也称为资产残值）。",example:"50",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"资产的折旧期数（有时也称作资产的使用寿命）。",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"在使用期限内要计算折旧的折旧期。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TBILLEQ",t:8,d:"基于贴现率计算美国政府短期债券的等效年化收益率。",a:"基于贴现率计算美国政府短期债券的等效年化收益率。",m:[3,3],p:[{name:"settlement",detail:"债券的结算日期，此日期为债券发行后交付给买家的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"债券的到期或结束日期，届时可将其以面值或票面价值赎回。",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"discount",detail:"债券购买时的贴现率。",example:"2)",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TBILLYIELD",t:8,d:"基于价格计算美国政府短期债券的收益率。",a:"基于价格计算美国政府短期债券的收益率。",m:[3,3],p:[{name:"settlement",detail:"债券的结算日期，此日期为债券发行后交付给买家的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"债券的到期或结束日期，届时可将其以面值或票面价值赎回。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"pr",detail:"债券的购买价格。",example:"95",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TBILLPRICE",t:8,d:"基于贴现率计算美国政府短期债券的价格。",a:"基于贴现率计算美国政府短期债券的价格。",m:[3,3],p:[{name:"settlement",detail:"债券的结算日期，此日期为债券发行后交付给买家的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"债券的到期或结束日期，届时可将其以面值或票面价值赎回。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"discount",detail:"债券购买时的贴现率。",example:"0.09",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PV",t:8,d:"基于等额分期付款和固定利率，计算年金投资的现值。",a:"基于等额分期付款和固定利率，计算年金投资的现值。",m:[3,5],p:[{name:"rate",detail:"各期利率。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"nper",detail:"年金的付款总期数。",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"pmt",detail:"每期的付款金额，在年金周期内不能更改。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"fv",detail:"[可选] - 未来值，或在最后一次付款后希望得到的现金余额。",example:"D2",require:"o",repeat:"n",type:"rangenumber"},{name:"type",detail:"[可选 - 默认值为0] - 指定各期的付款时间是在期初还是期末。\n\n0 表示期末；\n\n1 表示期初。",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"ACCRINT",t:8,d:"返回定期付息证券的应计利息。",a:"返回定期付息证券的应计利息。",m:[6,8],p:[{name:"issue",detail:"有价证券的发行日。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"first_interest",detail:"有价证券的首次计息日。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"settlement",detail:"有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"有价证券的年息票利率。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"par",detail:"证券的票面值。",example:"10000",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:"[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示““欧洲30/360”方法” - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"calc_method",detail:"[可选 - 默认为TRUE()] - 一个逻辑值，指定当结算日期晚于首次计息日期时用于计算总应计利息的方法。\n\n如果值为 TRUE，则返回从发行日到结算日的总应计利息。\n\n如果值为 FALSE，则返回从首次计息日到结算日的应计利息。",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"ACCRINTM",t:8,d:"返回在到期日支付利息的有价证券的应计利息。",a:"返回在到期日支付利息的有价证券的应计利息。",m:[4,5],p:[{name:"issue",detail:"有价证券的发行日。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"settlement",detail:"有价证券的到期日。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"有价证券的年息票利率。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"par",detail:"证券的票面值。",example:"1000",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:"[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUPDAYBS",t:8,d:"返回从付息期开始到结算日的天数。",a:"返回从付息期开始到结算日的天数。",m:[3,4],p:[{name:"settlement",detail:"有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有价证券的到期日。 到期日是有价证券有效期截止时的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:"[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPDAYS",t:8,d:"返回结算日所在的付息期的天数。",a:"返回结算日所在的付息期的天数。",m:[3,4],p:[{name:"settlement",detail:"有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有价证券的到期日。 到期日是有价证券有效期截止时的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:"[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPDAYSNC",t:8,d:"返回从结算日到下一票息支付日之间的天数。",a:"返回从结算日到下一票息支付日之间的天数。",m:[3,4],p:[{name:"settlement",detail:"有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有价证券的到期日。 到期日是有价证券有效期截止时的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:"[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPNCD",t:8,d:"计算结算日之后的下一票息或利息派发日期。",a:"计算结算日之后的下一票息或利息派发日期。",m:[3,4],p:[{name:"settlement",detail:"有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有价证券的到期日。 到期日是有价证券有效期截止时的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",example:"01)",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:"[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",example:"DATE(2019",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPPCD",t:8,d:"计算结算日之前的最后一个票息或利息支付日。",a:"计算结算日之前的最后一个票息或利息支付日。",m:[3,4],p:[{name:"settlement",detail:"有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有价证券的到期日。 到期日是有价证券有效期截止时的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",example:"01)",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:"[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",example:"DATE(2019",require:"o",repeat:"n",type:"rangenumber"}]},{n:"FV",t:8,d:"基于等额分期付款和固定利率，计算年金投资的未来价值。",a:"基于等额分期付款和固定利率，计算年金投资的未来价值。",m:[3,5],p:[{name:"rate",detail:"各期利率。",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"nper",detail:"年金的付款总期数。",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"pmt",detail:"各期所应支付的金额，在整个年金期间保持不变。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"pv",detail:"[可选 - 默认值为 0 ] - 现值，或一系列未来付款的当前值的累积和。",example:"400",require:"m",repeat:"n",type:"rangenumber"},{name:"type",detail:"[可选 - 默认值为 0 ] - 指定各期的付款时间是在期初还是期末。\n\n0 表示期末；\n\n1 表示期初。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FVSCHEDULE",t:8,d:"返回应用一系列复利率计算的初始本金的未来值。",a:"返回应用一系列复利率计算的初始本金的未来值。",m:[2,2],p:[{name:"principal",detail:"现值。",example:"10000",require:"m",repeat:"n",type:"rangenumber"},{name:"schedule",detail:"用于计算本金复利的一组利率。\n\n利率表必须是范围或数组，其中包含要用于计算复利的一组利率。这些利率值应该以十进制小数形式表示，或者使用UNARY_PERCENT以百分比形式表示，即表示为0.09或UNARY_PERCENT(9)，而不要表示为9。",example:"A2:A100",require:"m",repeat:"n",type:"range"}]},{n:"YIELD",t:8,d:"返回定期支付利息的债券的收益率。",a:"返回定期支付利息的债券的收益率。",m:[6,7],p:[{name:"settlement",detail:"有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有价证券的到期日。 到期日是有价证券有效期截止时的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"有价证券的年息票利率。",example:"0.057",require:"m",repeat:"n",type:"rangenumber"},{name:"pr",detail:"有价证券的价格。",example:"95",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"有价证券的清偿价值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:"[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"YIELDDISC",t:8,d:"基于价格计算折价发行的（不带息）债券的年收益率。",a:"基于价格计算折价发行的（不带息）债券的年收益率。",m:[4,5],p:[{name:"settlement",detail:"有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有价证券的到期日。 到期日是有价证券有效期截止时的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"pr",detail:"有价证券的价格。",example:"95",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"有价证券的清偿价值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:"[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NOMINAL",t:8,d:"基于给定的实际利率和年复利期数，返回名义年利率。",a:"基于给定的实际利率和年复利期数，返回名义年利率。",m:[2,2],p:[{name:"effect_rate",detail:"每年的实际利率。",example:"0.85",require:"m",repeat:"n",type:"rangenumber"},{name:"npery",detail:"每年的复利期数。",example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"XIRR",t:8,d:"返回一组不一定定期发生的现金流的内部收益率。",a:"返回一组不一定定期发生的现金流的内部收益率。",m:[2,3],p:[{name:"values",detail:"其中含有投资相关收益或支出的数组或范围。\n\n现金流数额中必须至少包含一项负的和一项正的现金流金额才能计算回报率。",example:"B2:B25",require:"m",repeat:"n",type:"range"},{name:"dates",detail:"与现金流数额参数中的现金流对应的日期数组或范围。",example:"C2:C25",require:"m",repeat:"n",type:"range"},{name:"guess",detail:"[可选 - 默认值为0.1] - 对内部回报率的估算值。",example:"250",require:"o",repeat:"n",type:"rangenumber"}]},{n:"MIRR",t:8,d:"返回一系列定期现金流的修改后内部收益率。",a:"返回一系列定期现金流的修改后内部收益率。",m:[3,3],p:[{name:"values",detail:"其中含有投资相关收益或支出的数组或范围。\n\n现金流数额中必须至少包含一项负的和一项正的现金流金额才能计算回报率。",example:"A2:A25",require:"m",repeat:"n",type:"range"},{name:"finance_rate",detail:"现金流中使用的资金支付的利率。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"reinvest_rate",detail:"将现金流再投资的收益率。",example:"0.12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"IRR",t:8,d:"返回由值中的数字表示的一系列现金流的内部收益率。 ",a:"返回由值中的数字表示的一系列现金流的内部收益率。 ",m:[1,2],p:[{name:"values",detail:"其中含有投资相关收益或支出的数组或范围。\n\n现金流数额中必须至少包含一项负的和一项正的现金流金额才能计算回报率。",example:"A2:A25",require:"m",repeat:"n",type:"range"},{name:"guess",detail:"[可选 - 默认为 0.1] - 内部收益率的估值。",example:"200",require:"o",repeat:"n",type:"rangenumber"}]},{n:"NPV",t:8,d:"使用贴现率和一系列未来支出（负值）和收益（正值）来计算一项投资的净现值。",a:"使用贴现率和一系列未来支出（负值）和收益（正值）来计算一项投资的净现值。",m:[2,255],p:[{name:"rate",detail:"某一期间的贴现率。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"value1",detail:"第一笔支出（负值）和收益（正值）。",example:"200",require:"m",repeat:"n",type:"rangeall"},{name:"value2, ...",detail:"[可选] - 其他支出（负值）和收益（正值）。",example:"250",require:"o",repeat:"y",type:"rangeall"}]},{n:"XNPV",t:8,d:"返回一组现金流的净现值，这些现金流不一定定期发生。",a:"返回一组现金流的净现值，这些现金流不一定定期发生。",m:[3,3],p:[{name:"rate",detail:"应用于现金流的贴现率。",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"values",detail:"与 dates 中的支付时间相对应的一系列现金流。",example:"B2:B25",require:"m",repeat:"n",type:"range"},{name:"dates",detail:"与现金流支付相对应的支付日期表。",example:"C2:C25",require:"m",repeat:"n",type:"range"}]},{n:"CUMIPMT",t:8,d:"基于等额分期付款和固定利率，计算投资在一系列付款期内的累计利息。",a:"基于等额分期付款和固定利率，计算投资在一系列付款期内的累计利息。",m:[6,6],p:[{name:"rate",detail:"利息率。",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"nper",detail:"总付款期数。",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"pv",detail:"现值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"start_period",detail:"开始累计计算的付款期序号。\n\n首期必须大于等于1。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"end_period",detail:"结束累计计算的付款期序号。\n\n末期必须大于首期。",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"type",detail:"指定各期的付款时间是在期初还是期末。\n\n0 表示期末；\n\n1 表示期初。",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PMT",t:8,d:"用于根据固定付款额和固定利率计算贷款的付款额。",a:"用于根据固定付款额和固定利率计算贷款的付款额。",m:[3,5],p:[{name:"rate",detail:"贷款利率。",example:"0.08",require:"m",repeat:"n",type:"rangenumber"},{name:"nper",detail:"该项贷款的付款总数。",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"pv",detail:"现值，或一系列未来付款额现在所值的总额，也叫本金。",example:" 100000",require:"m",repeat:"n",type:"rangenumber"},{name:"fv",detail:"[可选 - 默认值为 0] - 未来值，或在最后一次付款后希望得到的现金余额。",example:"D2",require:"m",repeat:"n",type:"rangenumber"},{name:"type",detail:"[可选 - 默认值为 0] - 指定各期的付款时间是在期初还是期末。\n\n0 表示期末；\n\n1 表示期初。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"IPMT",t:8,d:"基于固定利率及等额分期付款方式，返回给定期数内对投资的利息偿还额。",a:"基于固定利率及等额分期付款方式，返回给定期数内对投资的利息偿还额。",m:[4,6],p:[{name:"rate",detail:"各期利率。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"per",detail:"用于计算其利息数额的期数，必须在 1 到 nper 之间。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"nper",detail:"年金的付款总期数。",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"pv",detail:"现值，或一系列未来付款的当前值的累积和。",example:"80000",require:"m",repeat:"n",type:"rangenumber"},{name:"fv",detail:"[可选 - 默认值为 0] - 未来值，或在最后一次付款后希望得到的现金余额。",example:"E2",require:"m",repeat:"n",type:"rangenumber"},{name:"type",detail:"[可选 - 默认值为 0] - 指定各期的付款时间是在期初还是期末。\n\n0 表示期末；\n\n1 表示期初。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PPMT",t:8,d:"返回根据定期固定付款和固定利率而定的投资在已知期间内的本金偿付额。",a:"返回根据定期固定付款和固定利率而定的投资在已知期间内的本金偿付额。",m:[4,6],p:[{name:"rate",detail:"各期利率。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"per",detail:"指定期数，该值必须在 1 到 nper 范围内。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"nper",detail:"年金的付款总期数。",example:"3*12",require:"m",repeat:"n",type:"rangenumber"},{name:"pv",detail:"现值即一系列未来付款当前值的总和。",example:"100000",require:"m",repeat:"n",type:"rangenumber"},{name:"fv",detail:"[可选 - 默认值为 0] - 未来值，或在最后一次付款后希望得到的现金余额。",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"type",detail:"[可选 - 默认值为 0] - 指定各期的付款时间是在期初还是期末。\n\n0 表示期末；\n\n1 表示期初。",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"INTRATE",t:8,d:"返回完全投资型证券的利率。",a:"返回完全投资型证券的利率。",m:[4,5],p:[{name:"settlement",detail:"有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有价证券的到期日。 到期日是有价证券有效期截止时的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"investment",detail:"有价证券的投资额。",example:"100000",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"有价证券到期时的兑换值。",example:"101200",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:"[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PRICE",t:8,d:"返回定期付息的面值 ￥100 的有价证券的价格。",a:"返回定期付息的面值 ￥100 的有价证券的价格。",m:[6,7],p:[{name:"settlement",detail:"有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有价证券的到期日。 到期日是有价证券有效期截止时的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"有价证券的年息票利率。",example:"0.057",require:"m",repeat:"n",type:"rangenumber"},{name:"yld",detail:"有价证券的年收益率。",example:"0.065",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"面值 ￥100 的有价证券的清偿价值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:"[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PRICEDISC",t:8,d:"返回折价发行的面值 ￥100 的有价证券的价格。",a:"返回折价发行的面值 ￥100 的有价证券的价格。",m:[4,5],p:[{name:"settlement",detail:"有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有价证券的到期日。 到期日是有价证券有效期截止时的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"discount",detail:"有价证券的贴现率。",example:"0.0525",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"面值 ￥100 的有价证券的清偿价值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:"[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PRICEMAT",t:8,d:"返回到期付息的面值 ￥100 的有价证券的价格。",a:"返回到期付息的面值 ￥100 的有价证券的价格。",m:[5,6],p:[{name:"settlement",detail:"有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有价证券的到期日。 到期日是有价证券有效期截止时的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"issue",detail:"有价证券的发行日。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"有价证券在发行日的利率。",example:"0.061",require:"m",repeat:"n",type:"rangenumber"},{name:"yld",detail:"有价证券的年收益率。",example:"0.061",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:"[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"RECEIVED",t:8,d:"返回一次性付息的有价证券到期收回的金额。",a:"返回一次性付息的有价证券到期收回的金额。",m:[4,5],p:[{name:"settlement",detail:"有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有价证券的到期日。 到期日是有价证券有效期截止时的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"investment",detail:"有价证券的投资额。",example:"10000000",require:"m",repeat:"n",type:"rangenumber"},{name:"discount",detail:"有价证券的贴现率。",example:"0.0575",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:"[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",example:"12",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DISC",t:8,d:"返回有价证券的贴现率。",a:"返回有价证券的贴现率。",m:[4,5],p:[{name:"settlement",detail:"有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有价证券的到期日。 到期日是有价证券有效期截止时的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"pr",detail:"有价证券的价格（按面值为 ￥100 计算）。",example:"97.975",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"面值 ￥100 的有价证券的清偿价值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:"[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",example:"12",require:"o",repeat:"n",type:"rangenumber"}]},{n:"NPER",t:8,d:"基于固定利率及等额分期付款方式，返回某项投资的总期数。",a:"基于固定利率及等额分期付款方式，返回某项投资的总期数。",m:[3,5],p:[{name:"rate",detail:"各期利率。",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"pmt",detail:"各期所应支付的金额，在整个年金期间保持不变。",example:"500",require:"m",repeat:"n",type:"rangenumber"},{name:"pv",detail:"现值，或一系列未来付款的当前值的累积和。",example:"40000",require:"m",repeat:"n",type:"rangenumber"},{name:"fv",detail:"[可选 - 默认值为0] - 未来值，或在最后一次付款后希望得到的现金余额。",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"type",detail:"[可选 - 默认值为0] - 指定各期的付款时间是在期初还是期末。\n\n0 表示期末；\n\n1 表示期初。",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"SLN",t:8,d:"返回一个期间内的资产的直线折旧。",a:"返回一个期间内的资产的直线折旧。",m:[3,3],p:[{name:"cost",detail:"资产原值。",example:"300000",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"折旧末尾时的值（有时也称为资产残值）。",example:"75000",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"资产的折旧期数（有时也称作资产的使用寿命）。",example:"10",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DURATION",t:8,d:"返回假设面值 ￥100 的定期付息有价证券的修正期限。",a:"返回假设面值 ￥100 的定期付息有价证券的修正期限。",m:[5,6],p:[{name:"settlement",detail:"有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有价证券的到期日。 到期日是有价证券有效期截止时的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"coupon",detail:"有价证券的年息票利率。",example:"0.08",require:"m",repeat:"n",type:"rangenumber"},{name:"yld",detail:"有价证券的年收益率。",example:"0.09",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:"[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"MDURATION",t:8,d:"返回假设面值 ￥100 的有价证券的 Macauley 修正期限。",a:"返回假设面值 ￥100 的有价证券的 Macauley 修正期限。",m:[5,6],p:[{name:"settlement",detail:"有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有价证券的到期日。 到期日是有价证券有效期截止时的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"coupon",detail:"有价证券的年息票利率。",example:"0.08",require:"m",repeat:"n",type:"rangenumber"},{name:"yld",detail:"有价证券的年收益率。",example:"0.09",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:"[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"BIN2DEC",t:9,d:"将二进制数转换为十进制数。",a:"将二进制数转换为十进制数。",m:[1,1],p:[{name:"number",detail:'要转换为十进制数的带符号的10位二进制数值（以字符串形式提供）。\n\n带符号的二进制数的最高位是符号位；也就是说，负数是以二的补码形式表示的。\n\n对于此函数，最大的正数输入值为0111111111，最小的负数输入值为1000000000。\n\n如果所提供的带符号的二进制数是有效的二进制数，会自动将其转换为相应的字符串输入。例如，BIN2DEC(100)和BIN2DEC("100")得出的结果相同，均为4。',example:"101",require:"m",repeat:"n",type:"rangeall"}]},{n:"BIN2HEX",t:9,d:"将二进制数转换为十六进制数。",a:"将二进制数转换为十六进制数。",m:[1,2],p:[{name:"number",detail:'要转换为带符号的十六进制数的带符号的10位二进制数值（以字符串形式提供）。\n\n带符号的二进制数的最高位是符号位；也就是说，负数是以二的补码形式表示的。\n\n对于此函数，最大的正数输入值为0111111111，最小的负数输入值为1000000000。\n\n如果所提供的带符号的二进制数是有效的二进制数，会自动将其转换为相应的字符串输入。例如，BIN2HEX(11111)和BIN2HEX("11111")得出 的结果相同，均为1F。',example:"101",require:"m",repeat:"n",type:"rangeall"},{name:"places",detail:'[ 可选 ] - 结果中要确保的有效位数。\n\n如果设置的有效位数大于结果中的有效位数，则在结果的左侧填充0，使总有效位数达到有效位数。例如，BIN2HEX("11111",8)所得的结果值为0000001F。\n\n如果带符号的二进制数的最高位为1，则忽略此值；即当提供的带符号的二进制数大于等于1000000000时忽略此值。',example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"BIN2OCT",t:9,d:"将二进制数转换为八进制数。",a:"将二进制数转换为八进制数。",m:[1,2],p:[{name:"number",detail:'要转换为带符号的八进制数的带符号的10位二进制数值（以字符串形式提供）。\n\n带符号的二进制数的最高位是符号位；也就是说，负数是以二的补码形式表示的。\n\n对于此函数，最大的正数输入值为0111111111，最小的负数输入值为1000000000。\n\n如果所提供的带符号的二进制数是有效的二进制数，会自动将其转换为相应的字符串输入。例如，BIN2OCT(11111)和BIN2OCT("11111")得出的结果相同，均为37。',example:"101",require:"m",repeat:"n",type:"rangeall"},{name:"places",detail:'[ 可选 ] - 结果中要确保的有效位数。\n\n如果设置的有效位数大于结果中的有效位数，则在结果的左侧填充0，使总有效位数达到有效位数。例如，BIN2OCT("11111")得到的结果值为00000037。\n\n如果带符号的二进制数的最高位为1，则忽略此值；即当提供的带符号的二进制数大于等于1000000000时忽略此值。',example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DEC2BIN",t:9,d:"将十进制数转换为二进制数。",a:"将十进制数转换为二进制数。",m:[1,2],p:[{name:"number",detail:'要转换为带符号的二进制数的十进制数值（以字符串形式提供）。\n\n对于此函数，最大的正数输入值为511，最小的负数输入值为-512。\n\n如果所提供的十进制数是有效的十进制数，会自动将其转换为相应的字符串输入。例如，DEC2BIN(199)和DEC2BIN("199")得出的结果相同，均为11000111。',example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"places",detail:"[ 可选 ] - 结果中要确保的有效位数。\n\n如果设置的有效位数大于结果中的有效位数，则在结果的左侧填充0，使总有效位数达到有效位数。\n\n如果十进制数为负数，则忽略此值。",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DEC2HEX",t:9,d:"将十进制数转换为十六进制数。",a:"将十进制数转换为十六进制数。",m:[1,2],p:[{name:"number",detail:'要转换为带符号的十六进制数的十进制数值（以字符串形式提供）。\n\n此函数可接受的最大正数值为549755813887，最小负数值为-549755814888。\n\n如果所提供的十进制数是有效的十进制数，会自动将其转换为相应的字符串输入。例如，DEC2HEX(100)和DEC2HEX("100")得出的结果相同，均为64。',example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"places",detail:"[ 可选 ] - 结果中要确保的有效位数。\n\n如果设置的有效位数大于结果中的有效位数，则在结果的左侧填充0，使总有效位数达到有效位数。\n\n如果十进制数为负数，则忽略此值。",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DEC2OCT",t:9,d:"将十进制数转换为八进制数。",a:"将十进制数转换为八进制数。",m:[1,2],p:[{name:"number",detail:'要转换为带符号的八进制数的十进制数值（以字符串形式提供）。\n\n此函数可接受的最大正数值为536870911，最小负数值为-53687092。\n\n如果所提供的十进制数是有效的十进制数，会自动将其转换为相应的字符串输入。例如，DEC2OCT(199)和DEC2OCT("199")得出的结果相同，均为307。',example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"places",detail:"[ 可选 ] - 结果中要确保的有效位数。\n\n如果设置的有效位数大于结果中的有效位数，则在结果的左侧填充0，使总有效位数达到有效位数。\n\n如果十进制数为负数，则忽略此值。",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"HEX2BIN",t:9,d:"将十六进制数转换为二进制数。",a:"将十六进制数转换为二进制数。",m:[1,2],p:[{name:"number",detail:'要转换为带符号的二进制数的带符号的40位十六进制数值（以字符串形式提供）。\n\n带符号的十六进制数的最高位是符号位；也就是说，负数是以二的补码形式表示的。\n\n此函数可接受的最大正数值为1FF，最小负数值为FFFFFFFE00。\n\n如果所提供的带符号的十六进制数是有效的十六进制数，函数会自动将其转换为相应的字符串输入。例如，HEX2BIN(199)和HEX2BIN("199")得出的结果相同，均为110011001。',example:'"f3"',require:"m",repeat:"n",type:"rangeall"},{name:"places",detail:"[ 可选 ] - 结果中要确保的有效位数。\n\n如果设置的有效位数大于结果中的有效位数，则在结果的左侧填充0，使总有效位数达到有效位数。\n\n如果带符号的十六进制数的最高位为1，则忽略此值；即当提供的带符号的十六进制数大于等于8000000000时忽略此值。",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"HEX2DEC",t:9,d:"将十六进制数转换为十进制数。",a:"将十六进制数转换为十进制数。",m:[1,1],p:[{name:"number",detail:'要转换为十进制数的带符号的40位十六进制数值（以字符串形式提供）。\n\n带符号的十六进制数的最高位是符号位；也就是说，负数是以二的补码形式表示的。\n\n此函数可接受的最大正数值为7fffffffff，最小负数值为8000000000。\n\n如果所提供的带符号的十六进制数是有效的十六进制数，函数会自动将其转换为相应的字符串输入。例如，HEX2DEC(199)和HEX2DEC("199")得出的结果相同，均为409。',example:'"f3"',require:"m",repeat:"n",type:"rangeall"}]},{n:"HEX2OCT",t:9,d:"将十六进制数转换为八进制数。",a:"将十六进制数转换为八进制数。",m:[1,2],p:[{name:"number",detail:'要转换为带符号的八进制数的带符号的40位十六进制数值（以字符串形式提供）。\n\n带符号的十六进制数的最高位是符号位；也就是说，负数是以二的补码形式表示的。\n\n此函数可接受的最大正数值为1FFFFFFF，最小负数值为FFE0000000。\n\n如果所提供的带符号的十六进制数是有效的十六进制数，函数会自动将其转换为相应的字符串输入。例如，HEX2OCT(199)和HEX2OCT("199")得出的结果相同，均为631。',example:'"f3"',require:"m",repeat:"n",type:"rangeall"},{name:"places",detail:"[ 可选 ] - 结果中要确保的有效位数。\n\n如果设置的有效位数大于结果中的有效位数，则在结果的左侧填充0，使总有效位数达到有效位数。\n\n如果带符号的十六进制数的最高位为1，则忽略此值；即当给定的带符号的十六进制数大于等于8000000000时忽略此值。",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"OCT2BIN",t:9,d:"将八进制数转换为二进制数。",a:"将八进制数转换为二进制数。",m:[1,2],p:[{name:"number",detail:'要转换为带符号的二进制数的带符号的30位八进制数值（以字符串形式提供）。\n\n带符号的八进制数的最高位是符号位；也就是说，负数是以二的补码形式表示的。\n\n此函数可接受的最大正数值为777，最小负数值为7777777000。\n\n如果所提供的带符号的八进制数是有效的八进制数，函数会自动将其转换为相应的字符串输入。例如，OCT2BIN(177)和OCT2BIN("177")得出的结果相同，均为1111111。',example:"37",require:"m",repeat:"n",type:"rangeall"},{name:"places",detail:"[ 可选 ] - 结果中要确保的有效位数。\n\n如果设置的有效位数大于结果中的有效位数，则在结果的左侧填充0，使总有效位数达到有效位数。\n\n如果带符号的八进制数的最高位为1，则忽略此值；即当给定的带符号的八进制数大于等于4000000000时忽略此值。",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"OCT2DEC",t:9,d:"将八进制数转换为十进制数。",a:"将八进制数转换为十进制数。",m:[1,1],p:[{name:"number",detail:'要转换为十进制数的带符号的30位八进制数值（以字符串形式提供）。\n\n带符号的ba进制数的最高位是符号位；也就是说，负数是以二的补码形式表示的。\n\n此函数可接受的最大正数值为3777777777，最小负数值为4000000000。\n\n如果所提供的带符号的八进制数是有效的八进制数，函数会自动将其转换为相应的字符串输入。例如，OCT2DEC(177)和OCT2DEC("177")得出的结果相同，均为127。',example:"37",require:"m",repeat:"n",type:"rangeall"}]},{n:"OCT2HEX",t:9,d:"将八进制数转换为十六进制数。",a:"将八进制数转换为十六进制数。",m:[1,2],p:[{name:"number",detail:'要转换为带符号的十六进制数的带符号的30位八进制数值（以字符串形式提供）。\n\n带符号的ba进制数的最高位是符号位；也就是说，负数是以二的补码形式表示的。\n\n此函数可接受的最大正数值为3777777777，最小负数值为4000000000。\n\n如果所提供的带符号的八进制数是有效的八进制数，函数会自动将其转换为相应的字符串输入。例如，OCT2HEX(177)和OCT2HEX("177")得出的结果相同，均为7F。',example:"37",require:"m",repeat:"n",type:"rangeall"},{name:"places",detail:"[ 可选 ] - 结果中要确保的有效位数。\n\n如果设置的有效位数大于结果中的有效位数，则在结果的左侧填充0，使总有效位数达到有效位数。\n\n如果带符号的八进制数的最高位为1，则忽略此值；即当给定的带符号的八进制数大于等于4000000000时忽略此值。",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COMPLEX",t:9,d:"将实系数及虚系数转换为 x+yi 或 x+yj 形式的复数。",a:"将实系数及虚系数转换为 x+yi 或 x+yj 形式的复数。",m:[2,3],p:[{name:"real_num",detail:"复数的实系数。",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"i_num",detail:"复数的虚系数。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"suffix",detail:'[可选 - 默认为 "i"] - 复数中虚系数的后缀。',example:'"j"',require:"o",repeat:"n",type:"rangestring"}]},{n:"IMREAL",t:9,d:"返回以 x+yi 或 x+yj 文本格式表示的复数的实系数。",a:"返回以 x+yi 或 x+yj 文本格式表示的复数的实系数。",m:[1,1],p:[{name:"inumber",detail:"需要计算其实系数的复数。",example:'"4+5i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMAGINARY",t:9,d:"返回以 x+yi 或 x+yj 文本格式表示的复数的虚系数。",a:"返回以 x+yi 或 x+yj 文本格式表示的复数的虚系数。",m:[1,1],p:[{name:"inumber",detail:"需要计算其虚系数的复数。",example:'"4+5i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMCONJUGATE",t:9,d:"返回以 x+yi 或 x+yj 文本格式表示的复数的共轭复数。",a:"返回以 x+yi 或 x+yj 文本格式表示的复数的共轭复数。",m:[1,1],p:[{name:"inumber",detail:"需要计算其共轭数的复数。",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMABS",t:9,d:"返回以 x+yi 或 x+yj 文本格式表示的复数的绝对值（模）。",a:"返回以 x+yi 或 x+yj 文本格式表示的复数的绝对值（模）。",m:[1,1],p:[{name:"inumber",detail:"要计算其绝对值的复数。",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"DELTA",t:9,d:"检验两个值是否相等。 如果 number1=number2，则返回 1；否则返回 0。",a:"检验两个值是否相等。 如果 number1=number2，则返回 1；否则返回 0。",m:[1,2],p:[{name:"number1",detail:"第一个数字。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"number2",detail:"[可选 - 默认为 0] - 第二个数字。",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"IMSUM",t:9,d:"返回以 x+yi 或 x+yj 文本格式表示的 1 至 255 个复数的和。",a:"返回以 x+yi 或 x+yj 文本格式表示的 1 至 255 个复数的和。",m:[1,255],p:[{name:"inumber1",detail:"要相加的第一个复数",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"},{name:"inumber2, …",detail:"[可选] - 要与值1 相加的其他复数",example:'"5-3i"',require:"o",repeat:"y",type:"rangeall"}]},{n:"IMSUB",t:9,d:"返回以 x+yi 或 x+yj 文本格式表示的两个复数的差。",a:"返回以 x+yi 或 x+yj 文本格式表示的两个复数的差。",m:[2,2],p:[{name:"inumber1",detail:"从（复）数中减去 inumber2。",example:'"6+5i"',require:"m",repeat:"n",type:"rangeall"},{name:"inumber2",detail:"从 inumber1 中减（复）数。",example:'"2+3i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMPRODUCT",t:9,d:"返回以 x+yi 或 x+yj 文本格式表示的 1 至 255 个复数的乘积。",a:"返回以 x+yi 或 x+yj 文本格式表示的 1 至 255 个复数的乘积。",m:[1,255],p:[{name:"inumber1",detail:"用于计算乘积的第一个复数",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"},{name:"inumber2, …",detail:"[可选] - 要相乘的其他复数。",example:'"5-3i"',require:"o",repeat:"y",type:"rangeall"}]},{n:"IMDIV",t:9,d:"返回以 x+yi 或 x+yj 文本格式表示的两个复数的商。",a:"返回以 x+yi 或 x+yj 文本格式表示的两个复数的商。",m:[2,2],p:[{name:"inumber1",detail:"复数分子或被除数。",example:'"11+16i"',require:"m",repeat:"n",type:"rangeall"},{name:"inumber2",detail:"复数分母或除数。",example:'"3+2i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"NOT",t:10,d:"返回某个逻辑值的相反值 - “NOT(TRUE())”将返回 FALSE；“NOT(FALSE())”将返回 TRUE。",a:"返回某个逻辑值的相反值 - “NOT(TRUE())”将返回 FALSE；“NOT(FALSE())”将返回 TRUE。",m:[1,1],p:[{name:"logical",detail:"计算结果为 TRUE 或 FALSE 的任何值或表达式。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"TRUE",t:10,d:"返回逻辑值 TRUE。",a:"返回逻辑值 TRUE。",m:[0,0],p:[]},{n:"FALSE",t:10,d:"返回逻辑值 FALSE。",a:"返回逻辑值 FALSE。",m:[0,0],p:[]},{n:"AND",t:10,d:"所有参数的计算结果为 TRUE 时，返回 TRUE；只要有一个参数的计算结果为 FALSE，即返回 FALSE。",a:"所有参数的计算结果为 TRUE 时，返回 TRUE；只要有一个参数的计算结果为 FALSE，即返回 FALSE。",m:[1,255],p:[{name:"logical1",detail:"要测试的第一个条件，其计算结果可以为 TRUE 或 FALSE。",example:'A2 = "foo"',require:"m",repeat:"n",type:"rangeall"},{name:"logical2,...",detail:"[可选] - 要测试的其他条件，其计算结果可以为 TRUE 或 FALSE，最多可包含 255 个条件。",example:'A3 = "bar"',require:"o",repeat:"y",type:"rangeall"}]},{n:"IFERROR",t:10,d:"如果第一个参数不是错误值，就返回第一个参数；否则，返回第二个参数。",a:"如果第一个参数不是错误值",m:[2,2],p:[{name:"value",detail:"检查是否存在错误的参数。",example:"A1",require:"m",repeat:"n",type:"rangeall"},{name:"value_if_error",detail:"公式的计算结果错误时返回的值。 计算以下错误类型：#N/A、#VALUE!、#REF!、#DIV/0!、#NUM!、#NAME? 或 #NULL!。",example:'"Error in cell A1"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IF",t:10,d:"当逻辑表达式的值为 TRUE 时返回一个值，而当其为 FALSE 时返回另一个值。",a:"当逻辑表达式的值为 TRUE 时返回一个值，而当其为 FALSE 时返回另一个值。",m:[2,3],p:[{name:"logical_test",detail:"一个表达式或对包含表达式的单元格的引用，该表达式代表某种逻辑值（即TRUE或FALSE）。",example:'A2 = "foo"',require:"m",repeat:"n",type:"rangeall"},{name:"value_if_true",detail:"当逻辑表达式为TRUE时的返回值。",example:'"A2 is foo"',require:"m",repeat:"n",type:"rangeall"},{name:"value_if_false",detail:"[可选 - 默认为空白] - 当逻辑表达式等于FALSE时的函数返回值。",example:'"A2 was false"',require:"o",repeat:"n",type:"rangeall"}]},{n:"OR",t:10,d:"只要有一个参数的计算结果为 TRUE 时，返回 TRUE；所有参数的计算结果为 FALSE，即返回 FALSE。",a:"只要有一个参数的计算结果为 TRUE 时，返回 TRUE；所有参数的计算结果为 FALSE，即返回 FALSE。",m:[1,255],p:[{name:"logical1",detail:"要测试的第一个条件，其计算结果可以为 TRUE 或 FALSE。",example:'A2 = "foo"',require:"m",repeat:"n",type:"rangeall"},{name:"逻辑表达式2",detail:"[可选] - 其他表达式或对包含表达式的单元格的引用，这些表达式代表某种逻辑值（即TRUE或FALSE）或者可以强制转换为逻辑值。",example:' A3 = "bar"',require:"m",repeat:"n",type:"rangeall"}]},{n:"NE",t:11,d:"如果指定的值不相等，则返回“TRUE”；否则返回“FALSE”。相当于“<>”运算符。",a:"如果指定的值不相等，则返回“TRUE”；否则返回“FALSE”。相当于“<>”运算符。",m:[2,2],p:[{name:"value1",detail:"第一个值。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"要检查是否与 value1 不相等的值。",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"EQ",t:11,d:"如果指定的值相等，则返回“TRUE”；否则返回“FALSE”。相当于“=”运算符。",a:"如果指定的值相等，则返回“TRUE”；否则返回“FALSE”。相当于“=”运算符。",m:[2,2],p:[{name:"value1",detail:"第一个值。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"要检查是否与 value1 相等的值。",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"GT",t:11,d:"如果第一个参数严格大于第二个，则返回 TRUE；否则返回 FALSE。相当于“>”运算符。",a:"如果第一个参数严格大于第二个，则返回 TRUE；否则返回 FALSE。相当于“>”运算符。",m:[2,2],p:[{name:"value1",detail:"要测试其是否大于 value2 的值。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"第二个值。",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"GTE",t:11,d:"如果第一个参数大于或等于第二个，则返回 TRUE；否则返回 FALSE。相当于“>=”运算符。",a:"如果第一个参数大于或等于第二个，则返回 TRUE；否则返回 FALSE。相当于“>=”运算符。",m:[2,2],p:[{name:"value1",detail:"要测试其是否大于等于 value2 的值。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"第二个值。",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"LT",t:11,d:"如果第一个参数严格小于第二个，则返回 TRUE；否则返回 FALSE。相当于“<”运算符。",a:"如果第一个参数严格小于第二个，则返回 TRUE；否则返回 FALSE。相当于“<”运算符。",m:[2,2],p:[{name:"value1",detail:"要测试其是否小于 value2 的值。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"第二个值。",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"LTE",t:11,d:"如果第一个参数小于或等于第二个，则返回 TRUE；否则返回 FALSE。相当于“<=”运算符。",a:"如果第一个参数小于或等于第二个，则返回 TRUE；否则返回 FALSE。相当于“<=”运算符。",m:[2,2],p:[{name:"value1",detail:"要测试其是否小于等于 value2 的值。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"第二个值。",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"ADD",t:11,d:"返回两个数值之和。相当于 `+` 运算符。",a:"返回两个数值之和。相当于 `+` 运算符。",m:[2,2],p:[{name:"value1",detail:"第一个加数。",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"第二个加数。",example:"A3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MINUS",t:11,d:"返回两个数值之差。相当于“-”运算符。",a:"返回两个数值之差。相当于“-”运算符。",m:[2,2],p:[{name:"value1",detail:"被减数，即要对其计减的数值。",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"减数，即要从 value1 中减除的数值。",example:"A3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MULTIPLY",t:11,d:"返回两个数的乘积。相当于“*”运算符。",a:"返回两个数的乘积。相当于“*”运算符。",m:[2,2],p:[{name:"value1",detail:"第一个乘数。",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"第二个乘数。",example:"B2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DIVIDE",t:11,d:"返回两个参数相除所得的结果。相当于 `/` 运算符。",a:"返回两个参数相除所得的结果。相当于 `/` 运算符。",m:[2,2],p:[{name:"value1",detail:"要被除的数值。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"用于除其他数的数值。\n\n除数不得为0。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CONCAT",t:11,d:"返回两个值的串联。相当于 `&` 运算符。",a:"返回两个值的串联。相当于 `&` 运算符。",m:[2,2],p:[{name:"value1",detail:"value2 将附于其后的值。",example:'"de"',require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"要附于 value1 之后的值。",example:'"mystify"',require:"m",repeat:"n",type:"rangeall"}]},{n:"UNARY_PERCENT",t:11,d:"返回按百分比解释的数值。例如，“UNARY_PERCENT(100)”等于1。",a:"返回按百分比解释的数值。例如，“UNARY_PERCENT(100)”等于1。",m:[1,1],p:[{name:"number",detail:"要作为百分比解释的数值。",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CONCATENATE",t:12,d:"将两个或多个文本字符串联接为一个字符串。",a:"将两个或多个文本字符串联接为一个字符串。",m:[1,255],p:[{name:"text1",detail:"初始字符串。",example:'"Super"',require:"m",repeat:"n",type:"rangeall"},{name:"text2 ...",detail:"[可选] - 要按顺序连接在一起的其他字符串。",example:'"calla"',require:"o",repeat:"y",type:"rangeall"}]},{n:"CODE",t:12,d:"返回所提供的字符串中首字符的 Unicode 映射值。",a:"返回所提供的字符串中首字符的 Unicode 映射值。",m:[1,1],p:[{name:"text",detail:"要返回其首字符的Unicode映射值的字符串。",example:'"a"',require:"m",repeat:"n",type:"rangeall"}]},{n:"CHAR",t:12,d:"按照当前 Unicode 编码表，将数字转换为对应的字符。",a:"按照当前 Unicode 编码表，将数字转换为对应的字符。",m:[1,1],p:[{name:"number",detail:"介于 1 到 255 之间的数字。",example:"97",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ARABIC",t:12,d:"将罗马数字转换为阿拉伯数字。",a:"将罗马数字转换为阿拉伯数字。",m:[1,1],p:[{name:"text",detail:"要转换格式的罗马数字",example:'"XIV"',require:"m",repeat:"n",type:"rangeall"}]},{n:"ROMAN",t:12,d:"将数字格式设置为罗马数字形式。",a:"将数字格式设置为罗马数字形式。",m:[1,1],p:[{name:"number",detail:"要设置格式的数字，介于1到3999之间（包括这两个数字）。",example:"499",require:"m",repeat:"n",type:"rangenumber"}]},{n:"REGEXEXTRACT",t:12,d:"按照正则表达式提取匹配的子串。",a:"按照正则表达式提取匹配的子串。",m:[2,2],p:[{name:"text",detail:"输入文本。",example:'"Needle in a haystack"',require:"m",repeat:"n",type:"rangeall"},{name:"regular_expression",detail:"此函数将返回文本中符合此表达式的第一个子串。",example:'".e{2}dle"',require:"m",repeat:"n",type:"rangeall"}]},{n:"REGEXMATCH",t:12,d:"判断一段文本是否与正则表达式相匹配。",a:"判断一段文本是否与正则表达式相匹配。",m:[2,2],p:[{name:"text",detail:"要用正则表达式测试的文本。",example:'"Spreadsheets"',require:"m",repeat:"n",type:"rangeall"},{name:"regular_expression",detail:"用来测试文本的正则表达式。",example:'"S.r"',require:"m",repeat:"n",type:"rangeall"}]},{n:"REGEXREPLACE",t:12,d:"使用正则表达式将文本字符串中的一部分替换为其他文本字符串。",a:"使用正则表达式将文本字符串中的一部分替换为其他文本字符串。",m:[3,3],p:[{name:"text",detail:"要对其局部进行替换操作的文本。",example:'"Spreadsheets"',require:"m",repeat:"n",type:"rangeall"},{name:"regular_expression",detail:"正则表达式。 text 中所有匹配的实例都将被替换。",example:'"S.*d"',require:"m",repeat:"n",type:"rangeall"},{name:"replacement",detail:"要插入到原有文本中的文本。",example:'"Bed"',require:"m",repeat:"n",type:"rangeall"}]},{n:"T",t:12,d:"返回文本格式的字符串参数。",a:"返回文本格式的字符串参数。",m:[1,1],p:[{name:"value",detail:"要转换为文本的参数。\n\n如果值为文本，T将返回值本身。\n\n如果值为指向包含文本的单元格的引用，T将返回值中的内容。\n\n如果值为错误值或包含错误值的单元格，T将返回该错误值。\n\n对于所有其他情况，T将返回空串。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"FIXED",t:12,d:"以固定的小数位数设置数字的格式。",a:"以固定的小数位数设置数字的格式。",m:[1,3],p:[{name:"number",detail:"要进行舍入并转换为文本的数字。",example:"3.141592653",require:"m",repeat:"n",type:"rangenumber"},{name:"decimals",detail:"[可选 - 默认值为2] - 结果中要显示的小数位数。\n\n如果数值的有效位数小于小数位数，将以零填充。如果数值的有效位数大于小数位数，则将其舍入到所需的小数位数而不是将其截断。",example:"2",require:"o",repeat:"n",type:"rangenumber"},{name:"no_commas",detail:"[可选 - 默认值为FALSE()] - 一个逻辑值，如果为 TRUE()，则会禁止 FIXED 在返回的文本中包含逗号。",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"FIND",t:12,d:"返回字符串在文本中首次出现的位置（区分大小写）。",a:"返回字符串在文本中首次出现的位置（区分大小写）。",m:[2,3],p:[{name:"find_text",detail:"要在要搜索的文本中查找的字符串。",example:'"n"',require:"m",repeat:"n",type:"rangeall"},{name:"within_text",detail:"要在其中搜索搜索字符串的首次出现位置的文本。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"start_num",detail:"[可选 - 默认值为1] - 要在要搜索的文本中开始搜索的字符位置。",example:"14",require:"o",repeat:"n",type:"rangenumber"}]},{n:"FINDB",t:12,d:"返回某个字符串在文本中首次出现的位置（每个双字节字符占两个位置）。",a:"返回某个字符串在文本中首次出现的位置（每个双字节字符占两个位置）。",m:[2,3],p:[{name:"find_text",detail:"要在要搜索的文本中查找的字符串。",example:'"新"',require:"m",repeat:"n",type:"rangeall"},{name:"within_text",detail:"要在其中搜索搜索字符串的首次出现位置的文本。",example:'"农历新年"',require:"m",repeat:"n",type:"rangeall"},{name:"start_num",detail:"[可选 - 默认值为 1] - 要在要搜索的文本中开始搜索的字符位置。",example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"JOIN",t:12,d:"将一个或多个使用指定定界符的一维数组的元素连接到一起。",a:"将一个或多个使用指定定界符的一维数组的元素连接到一起。",m:[2,255],p:[{name:"separator",detail:"置于相互连接的值之间的字符或字符串。\n\n定界符可以为空，例如JOIN(,{1,2,3})。",example:'" and-a "',require:"m",repeat:"n",type:"rangeall"},{name:"array1",detail:"要使用定界符连接的一个或多个值。",example:"{1",require:"m",repeat:"n",type:"rangeall"},{name:"array2, ...",detail:"[可选] - 要使用定界符连接的其他值或数组。",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"LEFT",t:12,d:"从文本字符串的第一个字符开始返回指定个数的字符。",a:"从文本字符串的第一个字符开始返回指定个数的字符。",m:[1,2],p:[{name:"text",detail:"包含要提取的字符的文本字符串。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"num_chars",detail:"[可选 - 默认值为1] - 指定要由 LEFT 提取的字符的数量。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"RIGHT",t:12,d:"根据所指定的字符数返回文本字符串中最后一个或多个字符。",a:"根据所指定的字符数返回文本字符串中最后一个或多个字符。",m:[1,2],p:[{name:"text",detail:"包含要提取的字符的文本字符串。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"num_chars",detail:"[可选 - 默认值为1] - 指定要由 RIGHT 提取的字符的数量。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MID",t:12,d:"返回文本字符串中从指定位置开始的特定数目的字符。",a:"返回文本字符串中从指定位置开始的特定数目的字符。",m:[3,3],p:[{name:"text",detail:"包含要提取的字符的文本字符串。",example:'"get this"',require:"m",repeat:"n",type:"rangeall"},{name:"start_num",detail:"要从字符串中开始提取的位置。字符串中第一个字符的索引为1。",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"num_chars",detail:"指定要由 MID 提取的字符的数量。\n\n如果提取的字符数尚不足提取长度个字符时就到达了字符串尾部，则MID返回从开始位置到字符串尾部的字符。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LEN",t:12,d:"返回给定字符串的长度。",a:"返回给定字符串的长度。",m:[1,1],p:[{name:"text",detail:"要返回其长度的字符串。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"LENB",t:12,d:"返回文本中所包含的字符数。与双字节字符集(DBCS)一起使用。",a:"返回文本中所包含的字符数。与双字节字符集(DBCS)一起使用。",m:[1,1],p:[{name:"text",detail:"要返回其字节数的字符串。（一个汉字为两个字节数）",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"LOWER",t:12,d:"将指定字符串中的字母转换为小写。",a:"将指定字符串中的字母转换为小写。",m:[1,1],p:[{name:"text",detail:"要转换为小写的字符串。",example:'"LOREM IPSUM"',require:"m",repeat:"n",type:"rangeall"}]},{n:"UPPER",t:12,d:"将指定字符串中的字母转换为大写。",a:"将指定字符串中的字母转换为大写。",m:[1,1],p:[{name:"text",detail:"要转换为大写的字符串。",example:'"lorem ipsum"',require:"m",repeat:"n",type:"rangeall"}]},{n:"EXACT",t:12,d:"比较两个字符串是否相同。",a:"比较两个字符串是否相同。",m:[2,2],p:[{name:"text1",detail:"要比较的第一个字符串。",example:"A1",require:"m",repeat:"n",type:"rangeall"},{name:"text2",detail:"要比较的第二个字符串。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"REPLACE",t:12,d:"将文本字符串的一部分替换为其他文本字符串。",a:"将文本字符串的一部分替换为其他文本字符串。",m:[4,4],p:[{name:"old_text",detail:"要对其局部进行替换操作的文本。",example:'"Spreadsheets"',require:"m",repeat:"n",type:"rangeall"},{name:"start_num",detail:"开始进行替换操作的位置（文本开头位置为 1）。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"num_chars",detail:"要在文本中替换的字符个数。",example:"6",require:"m",repeat:"n",type:"rangenumber"},{name:"new_text",detail:"要插入到原有文本中的文本。",example:'"Bed"',require:"m",repeat:"n",type:"rangeall"}]},{n:"REPT",t:12,d:"返回指定文本的多次重复。",a:"返回指定文本的多次重复。",m:[2,2],p:[{name:"text",detail:"要重复的字符或字符串。",example:'"ha"',require:"m",repeat:"n",type:"rangeall"},{name:"number_times",detail:"要重复的文本要在返回值中出现的次数。\n\n最大重复次数为100。即使重复次数大于100，REPT也仅将相应文本重复100次。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SEARCH",t:12,d:"返回字符串在文本中首次出现的位置（不区分大小写）。",a:"返回字符串在文本中首次出现的位置（不区分大小写）。",m:[2,3],p:[{name:"find_text",detail:"要在要搜索的文本中查找的字符串。",example:'"n"',require:"m",repeat:"n",type:"rangeall"},{name:"within_text",detail:"要在其中搜索搜索字符串的首次出现位置的文本。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"start_num",detail:"[ 可选 - 默认值为1 ] - 要在要搜索的文本中开始搜索的字符位置。",example:"14",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUBSTITUTE",t:12,d:"在文本字符串中用 new_text 替换 old_text。",a:"在文本字符串中用 new_text 替换 old_text。",m:[3,4],p:[{name:"text",detail:"需要替换其中字符的文本，或对含有文本（需要替换其中字符）的单元格的引用。",example:'"search for it"',require:"m",repeat:"n",type:"rangeall"},{name:"old_text",detail:"需要替换的文本。",example:'"search for"',require:"m",repeat:"n",type:"rangeall"},{name:"new_text",detail:"用于替换 old_text 的文本。",example:'"Google"',require:"m",repeat:"n",type:"rangeall"},{name:"instance_num",detail:"[ 可选 ] - 指定要用 new_text 替换 old_text 的事件。 如果指定了 instance_num，则只有满足要求的 old_text 被替换。 否则，文本中出现的所有 old_text 都会更改为 new_text。",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CLEAN",t:12,d:"移除文本中的不可打印 ASCII 字符后将其返回。",a:"移除文本中的不可打印 ASCII 字符后将其返回。",m:[1,1],p:[{name:"text",detail:"要移除其中不可打印字符的文本。",example:'"AF"&CHAR(31)',require:"m",repeat:"n",type:"rangeall"}]},{n:"TEXT",t:12,d:"按照指定格式将数字转换为文本。",a:"按照指定格式将数字转换为文本。",m:[2,2],p:[{name:"value",detail:"要设置格式的数字、日期或时间。",example:"1.23",require:"m",repeat:"n",type:"rangenumber"},{name:"format_text",detail:'以括号括起来的模式串，将按该模式设置数字的格式。\n\n0表示在数值位数少于格式指定的位数时必定以零填充。例如，TEXT(12.3,"000.00")将返回012.30。当数值的小数位数超过模式指定的小数位数时，四舍五入为指定的小数位数。例如，TEXT(12.305,"00.00")将返回12.31。\n\n#类似于0，但并不是在小数点的两侧都以零填充。例如，TEXT(12.3,"###.##")将返回12.3。',example:'"$0.00"',require:"m",repeat:"n",type:"rangeall"}]},{n:"TRIM",t:12,d:"删除指定字符串前后的空格。",a:"删除指定字符串前后的空格。",m:[1,1],p:[{name:"text",detail:"要修剪的字符串或指向包含该字符串的单元格的引用。",example:'" lorem ipsum"',require:"m",repeat:"n",type:"rangeall"}]},{n:"VALUE",t:12,d:"将可识别的任何日期、时间或数字格式的字符串转换为数字。",a:"将可识别的任何日期、时间或数字格式的字符串转换为数字。",m:[1,1],p:[{name:"text",detail:"包含要转换的值的字符串。",example:'"123"',require:"m",repeat:"n",type:"rangeall"}]},{n:"PROPER",t:12,d:"将指定字符串中每个单词的首字母转为大写。",a:"将指定字符串中每个单词的首字母转为大写。",m:[1,1],p:[{name:"text",detail:"要转换的文本，其中每个单词的首字母都将转为大写，所有其他字母则转为小写。",example:'"united states"',require:"m",repeat:"n",type:"rangeall"}]},{n:"CONVERT",t:13,d:"将数字从一种度量系统转换为另一种度量系统。",a:"将数字从一种度量系统转换为另一种度量系统。",m:[3,3],p:[{name:"number",detail:"是以 from_unit 为单位的需要进行转换的数值。",example:"5.1",require:"m",repeat:"n",type:"rangenumber"},{name:"from_unit",detail:"是数值的单位。",example:'"g"',require:"m",repeat:"n",type:"rangeall"},{name:"to_unit",detail:"是结果的单位。",example:'"kg"',require:"m",repeat:"n",type:"rangeall"}]},{n:"SUMX2MY2",t:14,d:"返回两数组中对应数值的平方差之和。",a:"返回两数组中对应数值的平方差之和。",m:[2,2],p:[{name:"array_x",detail:"第一个数组或数值区域。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"array_y",detail:"第二个数组或数值区域。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMX2PY2",t:14,d:"返回两数组中对应数值的平方和之和。",a:"返回两数组中对应数值的平方和之和。",m:[2,2],p:[{name:"array_x",detail:"第一个数组或数值区域。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"array_y",detail:"第二个数组或数值区域。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMXMY2",t:14,d:"返回两数组中对应数值之差的平方和。",a:"返回两数组中对应数值之差的平方和。",m:[2,2],p:[{name:"array_x",detail:"第一个数组或数值区域。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"array_y",detail:"第二个数组或数值区域。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TRANSPOSE",t:14,d:"将数组或单元格范围的行列转置。",a:"将数组或单元格范围的行列转置。",m:[1,1],p:[{name:"array",detail:"要将其行列互换的数组或范围。",example:"{1,2}",require:"m",repeat:"n",type:"range"}]},{n:"TREND",t:14,d:"返回线性趋势值。",a:"返回线性趋势值。",m:[1,4],p:[{name:"known_y",detail:"关系表达式 y = mx + b 中已知的 y 值集合。\n\n如果 known_y 为二维数组或范围，则 known_x 的维数必须与之相同，或者省略此参数。\n\n如果 known_y 为一维数组或范围，known_x 则可代表二维数组或范围中的多个自变量。也就是说，如果 known_y 为单行，则将 known_x 中的每行解释为各自独立的值，类似情况也适用于 known_y 为单列的情况。",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_x",detail:"[可选 - 默认该数组为{1,2,3,...},其大小与 known_y 相同] - 关系表达式 y = mx + b 中已知的可选 x 值集合。\n\n如果 known_y 为一维数组或范围，known_x 则可代表二维数组或范围中的多个自变量。也就是说，如果 known_y 为单行，则将 known_x 中的每行解释为各自独立的值，类似情况也适用于 known_y 为单列的情况。",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"new_x",detail:"[可选 - 默认与 known_x 相同] -  需要函数 TREND 返回对应 y 值的新 x 值。",example:"A11:A13",require:"o",repeat:"n",type:"rangenumber"},{name:"const",detail:"[可选 - 默认值为TRUE()] - 一个逻辑值，用于指定是否将常量 b 强制设为 0。\n\nTRUE() 表示 b 将按正常计算；\n\nFALSE() 表示 b 将被设为 0（零），m 将被调整以使 y = mx。",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"FREQUENCY",t:14,d:"计算数值在某个区域内的出现频率，然后返回一个垂直数组。",a:"计算数值在某个区域内的出现频率，然后返回一个垂直数组。",m:[2,2],p:[{name:"data_array",detail:"要对其频率进行计数的一组数值或对这组数值的引用。",example:"A2:A40",require:"m",repeat:"n",type:"rangenumber"},{name:"bins_array",detail:"要将 data_array 中的值插入到的间隔数组或对间隔的引用。\n\n为清晰起见，应将类别排序，但如果未排序，FREQUENCY会在内部对这些指定的值进行排序并返回正确结果。",example:"B2:B5",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GROWTH",t:14,d:"使用现有数据计算预测的指数等比。",a:"使用现有数据计算预测的指数等比。",m:[1,4],p:[{name:"known_y",detail:"关系表达式 y = b*m^x 中已知的 y 值集合。\n\n如果已知数据_y为二维数组或范围，则已知数据_x的维数必须与之相同，或者省略此参数。\n\n如果已知数据_y为一维数组或范围，已知数据_x则可代表二维数组或范围中的多个自变量。也就是说，如果已知数据_y为单行，则将已知数据_x中的每行解释为各自独立的值，类似情况也适用于已知数据_y为单列的情况。",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_x",detail:"[可选 - 默认该数组为{1,2,3,...},其大小与 known_y 相同] - 关系表达式 y = b*m^x 中已知的可选 x 值集合。\n\n如果已知数据_y为一维数组或范围，已知数据_x则可代表二维数组或范围中的多个自变量。也就是说，如果已知数据_y为单行，则将已知数据_x中的每行解释为各自独立的值，类似情况也适用于已知数据_y为单列的情况。",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"new_x",detail:"[可选 - 默认与 known_x 相同] - 需要函数 GROWTH 返回对应 y 值的新 x 值。",example:"A11:A13",require:"o",repeat:"n",type:"rangenumber"},{name:"const",detail:"[可选 - 默认值为TRUE()] -一个逻辑值，用于指定是否将常量 b 强制设为 1。\n\nTRUE() 表示 b 将按正常计算；\n\nFALSE() 表示 b 将被设为 1，m 将被调整以使 y = m^x。",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"LINEST",t:14,d:"可通过使用最小二乘法计算与现有数据最佳拟合的直线，来计算某直线的统计值，然后返回描述此直线的数组。",a:"可通过使用最小二乘法计算与现有数据最佳拟合的直线，来计算某直线的统计值，然后返回描述此直线的数组。",m:[1,4],p:[{name:"known_y",detail:"关系表达式 y = mx + b 中已知的 y 值集合。\n\n如果 known_y 为二维数组或范围，则 known_x 的维数必须与之相同，或者省略此参数。\n\n如果 known_y 为一维数组或范围，known_x 则可代表二维数组或范围中的多个自变量。也就是说，如果 known_y 为单行，则将 known_x 中的每行解释为各自独立的值，类似情况也适用于 known_y 为单列的情况。",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_x",detail:"[可选 - 默认该数组为{1,2,3,...},其大小与 known_y 相同] - 关系表达式 y = mx + b 中已知的可选 x 值集合。\n\n如果 known_y 为一维数组或范围，known_x 则可代表二维数组或范围中的多个自变量。也就是说，如果 known_y 为单行，则将 known_x 中的每行解释为各自独立的值，类似情况也适用于 known_y 为单列的情况。",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"const",detail:"[可选 - 默认值为TRUE()] - 一个逻辑值，用于指定是否将常量 b 强制设为 0。\n\nTRUE() 表示 b 将按正常计算；\n\nFALSE() 表示 b 将被设为 0（零），m 将被调整以使 y = mx。",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"},{name:"stats",detail:"[可选 - 默认值为FALSE()] - 一个逻辑值，用于指定是否返回附加回归统计值。\n\n如果详细为TRUE，除了对应于每个自变量的一组线性系数和y截距之外，LINEST还返回以下信息：\n\n每项系数和截距的标准误差、\n\n限定系数（介于0和1之间，1表示完全相关）、\n\n因变量值的标准误差、\n\nF统计或F观测值，指示所观测到的因变量和自变量变量之间的关系是随机的还是线性的、\n\n自由度，用于在参照表中查找F统计值以估算可信度、\n\n回归平方和，以及\n\n残差平方和。",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"LOGEST",t:14,d:"在回归分析中，计算最符合数据的指数回归拟合曲线，并返回描述该曲线的数值数组。",a:"在回归分析中，计算最符合数据的指数回归拟合曲线，并返回描述该曲线的数值数组。",m:[1,4],p:[{name:"known_y",detail:"关系表达式 y = mx + b 中已知的 y 值集合。\n\n如果 known_y 为二维数组或范围，则 known_x 的维数必须与之相同，或者省略此参数。\n\n如果 known_y 为一维数组或范围，known_x 则可代表二维数组或范围中的多个自变量。也就是说，如果 known_y 为单行，则将 known_x 中的每行解释为各自独立的值，类似情况也适用于 known_y 为单列的情况。",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_x",detail:"[可选 - 默认该数组为{1,2,3,...},其大小与 known_y 相同] - 关系表达式 y = mx + b 中已知的可选 x 值集合。\n\n如果 known_y 为一维数组或范围，known_x 则可代表二维数组或范围中的多个自变量。也就是说，如果 known_y 为单行，则将 known_x 中的每行解释为各自独立的值，类似情况也适用于 known_y 为单列的情况。",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"const",detail:"[可选 - 默认值为TRUE()] - 一个逻辑值，用于指定是否将常量 b 强制设为 0。\n\nTRUE() 表示 b 将按正常计算；\n\nFALSE() 表示 b 将被设为 0（零），m 将被调整以使 y = mx。",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"},{name:"stats",detail:"[可选 - 默认值为FALSE()] - 一个逻辑值，用于指定是否返回附加回归统计值。\n\n如果详细为TRUE，则除了为每个自变量和系数 b 返回一组指数值之外，LOGEST 还将返回以下数据：\n\n每项指数和系数的标准误差、\n\n限定系数（介于 0 和 1 之间，1 表示完全相关）、\n\n因变量值的标准误差、\n\nF 统计或 F 观测值，指示所观测到的因变量和自变量之间的关系是随机的还是指数的、\n\n自由度 - 用于在参照表中查找 F 统计值以估算可信度、\n\n回归平方和，以及\n\n残差平方和。",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"MDETERM",t:14,d:"返回一个数组的矩阵行列式的值。",a:"返回一个数组的矩阵行列式的值。",m:[1,1],p:[{name:"array",detail:"行数和列数相等的数值数组。",example:"A1:D4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MINVERSE",t:14,d:"返回数组中存储的矩阵的逆矩阵。",a:"返回数组中存储的矩阵的逆矩阵。",m:[1,1],p:[{name:"array",detail:"行数和列数相等的数值数组。",example:"A1:D4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MMULT",t:14,d:"返回两个数组的矩阵乘积。结果矩阵的行数与 array1 的行数相同，矩阵的列数与 array2 的列数相同。",a:"返回两个数组的矩阵乘积。结果矩阵的行数与 array1 的行数相同，矩阵的列数与 array2 的列数相同。",m:[2,2],p:[{name:"array1",detail:"要进行矩阵乘法运算的第一个矩阵数组。\n\narray1 列数必须与 array2 的行数相同",example:"A1:B3",require:"m",repeat:"n",type:"rangenumber"},{name:"array2",detail:"要进行矩阵乘法运算的第二个矩阵数组。\n\narray2 的行数必须与 array1 列数相同",example:"C1:F2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMPRODUCT",t:14,d:"在给定的几组数组中，将数组间对应的元素相乘，并返回乘积之和。",a:"在给定的几组数组中，将数组间对应的元素相乘，并返回乘积之和。",m:[1,255],p:[{name:"array1",detail:"其相应元素需要进行相乘并求和的第一个数组参数。",example:"A2:C5",require:"m",repeat:"n",type:"rangenumber"},{name:"array2",detail:"[可选] - 其相应元素需要进行相乘并求和的其它数组参数。",example:"D2:F5",require:"o",repeat:"y",type:"rangenumber"}]},{n:"ISFORMULA",t:15,d:"检查公式是否位于引用的单元格中。",a:"检查公式是否位于引用的单元格中。",m:[1,1],p:[{name:"cell",detail:"要检查是否存在公式的单元格。\n\n如果 cell 为包含公式的单元格，则 ISFORMULA 将返回 TRUE。如果 cell 为相应单元格范围，则当该范围内的首个单元格包含公式时，系统会返回 TRUE。如果是任何其他值，系统都将返回 FALSE。",example:"A2",require:"m",repeat:"n",type:"range"}]},{n:"CELL",t:15,d:"返回有关单元格的格式、位置或内容的信息。",a:"返回有关单元格的格式、位置或内容的信息。",m:[2,2],p:[{name:"info_type",detail:"一个文本值，指定要返回的单元格信息的类型。",example:'"type"',require:"m",repeat:"n",type:"rangeall"},{name:"reference",detail:"需要其相关信息的单元格。",example:"C2",require:"m",repeat:"n",type:"range"}]},{n:"NA",t:15,d:"返回错误值 #N/A。",a:"返回错误值 #N/A。",m:[0,0],p:[]},{n:"ERROR_TYPE",t:15,d:"返回与其他单元格中的错误值相对应的数字。",a:"返回与其他单元格中的错误值相对应的数字。",m:[1,1],p:[{name:"error_val",detail:"用于查找错误号的单元格，虽然您也可以直接提供错误值。",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISBLANK",t:15,d:"检查所引用的单元格是否为空。",a:"检查所引用的单元格是否为空。",m:[1,1],p:[{name:"value",detail:"对要检查其是否为空的单元格的引用。\n\n如果是空单元格，则 TRUE；否则返回 FALSE。",example:"A2",require:"m",repeat:"n",type:"range"}]},{n:"ISERR",t:15,d:"检查某个值是否为 #N/A 以外的错误值。",a:"检查某个值是否为 #N/A 以外的错误值。",m:[1,1],p:[{name:"value",detail:"要验证其是否为#N/A以外的错误类型的值。\n\n如果值是除#N/A之外的任何错误（包括#DIV/0!、#NAME?、#NULL!、#NUM!、#VALUE!和#REF!），ISERR将返回TRUE。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISERROR",t:15,d:"检查某个值是否为错误值。",a:"检查某个值是否为错误值。",m:[1,1],p:[{name:"value",detail:"要验证其是否为错误类型的值。\n\n只要值是某种错误值（包括#DIV/0!、#N/A、#NAME?、#NULL!、#NUM!、#VALUE!和#REF!），ISERROR就会返回TRUE。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISLOGICAL",t:15,d:"检查某个值是 TRUE 还是 FALSE。",a:"检查某个值是 TRUE 还是 FALSE。",m:[1,1],p:[{name:"value",detail:"要验证其为逻辑TRUE还是逻辑FALSE的值。\n\n*如果值为TRUE或FALSE，或为指向值为TRUE或FALSE的单元格的引用，ISLOGICAL将返回TRUE。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISNA",t:15,d:"检查某个值是否为错误值 #N/A。",a:"检查某个值是否为错误值 #N/A。",m:[1,1],p:[{name:"value",detail:"要与错误值#N/A进行比较的值。\n\n*如果值为#N/A或指向包含#N/A的单元格的引用，则ISNA将返回TRUE，否则返回FALSE。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISNONTEXT",t:15,d:"检查某个值是否为非文本。",a:"检查某个值是否为非文本。",m:[1,1],p:[{name:"value",detail:"要检查的文本。\n\n*如果参数为文本值或指向包含文本的单元格的引用，ISNONTEXT将返回FALSE，否则返回TRUE。\n\n当值为指向空单元格的引用时，ISNONTEXT会返回TRUE。\n\n当值为空字符串时，ISNONTEXT将返回FALSE，因为空串被视作文本。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISNUMBER",t:15,d:"检查某个值是否为数字。",a:"检查某个值是否为数字。",m:[1,1],p:[{name:"value",detail:"要验证其是否为数字的值。\n\n*如果参数为数字或指向内容为数字值的单元格的引用，ISNUMBER将返回TRUE，否则返回FALSE。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISREF",t:15,d:"检查某个值是否为有效的单元格引用。",a:"检查某个值是否为有效的单元格引用。",m:[1,1],p:[{name:"value",detail:"要验证其是否为单元格引用的值。\n\n*如果参数是有效的单元格引用，ISREF将返回TRUE，否则返回FALSE。",example:"A2",require:"m",repeat:"n",type:"range"}]},{n:"ISTEXT",t:15,d:"检查某个值是否为文本。",a:"检查某个值是否为文本。",m:[1,1],p:[{name:"value",detail:"要验证其是否为文本的值。\n\n如果参数为文本值或指向包含文本值的单元格的引用，ISTEXT将返回TRUE，否则返回FALSE。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"TYPE",t:15,d:"返回数值的类型。",a:"返回数值的类型。",m:[1,1],p:[{name:"value",detail:"要确定其类型的数据。\n\n数字 返回 1;\n\n文本 返回 2;\n\n逻辑值 返回 4;\n\n错误值 返回 16;\n\n数组 返回 64;",example:"C4",require:"m",repeat:"n",type:"rangeall"}]},{n:"N",t:15,d:"返回转化为数值后的值。",a:"返回转化为数值后的值。",m:[1,1],p:[{name:"value",detail:"要转换为数字的参数。\n\n如果值为数字，则返回该数字。\n\n如果值为日期，则返回该日期的序列号。\n\n如果值为TRUE，则返回1。\n\n如果值为FALSE，则返回0。\n\n如果值为错误值，则返回错误值。\n\n如果值为其他值，则返回0。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"TO_DATE",t:16,d:"将指定的数字转换为日期。",a:"将指定的数字转换为日期。",m:[1,1],p:[{name:"value",detail:"要转换为日期的参数或其单元格引用。\n\n如果值为数字或指向内容为数值的单元格的引用，TO_DATE会将值转换为相应的日期并返回，值代表从十二月30日到对应的日期之间的天数，\n\n负值表示对应的日期在十二月30日之前，而小数值则代表一天中从午夜算起的时间。\n如果值不是数字或指向内容为数值的单元格的引用，则TO_DATE将在不做任何修改的情况下返回值。",example:"25405",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TO_PURE_NUMBER",t:16,d:"将给定的日期/时间、百分比、货币金额或其他格式的数值转换为不带格式的纯数字。",a:"将给定的日期/时间、百分比、货币金额或其他格式的数值转换为不带格式的纯数字。",m:[1,1],p:[{name:"value",detail:"要转换为纯数字的参数或其单元格引用。\n\n如果值为数字或指向包含数值的单元格的引用，TO_PURE_NUMBER将以不带任何格式与解释的形式返回值。\n\n如果值不是数字或指向内容为数值的单元格的引用，则TO_PERCENT将在不做任何修改的情况下返回值。",example:"50%",require:"m",repeat:"n",type:"rangeall"}]},{n:"TO_TEXT",t:16,d:"将给定的数字值转换为文本格式。",a:"将给定的数字值转换为文本格式。",m:[1,1],p:[{name:"value",detail:"要转换为文本的参数或其单元格引用。\n\n如果值为数字或指向包含数值的单元格的引用，TO_TEXT将返回字符串形式的值，并保持现有格式。即原为货币的仍为货币，原为十进制数的仍为十进制数，原为百分比的仍为百分比，原为日期的仍为日期。\n\n如果值不是数字或指向内容为数值的单元格的引用，则TO_TEXT将在不做任何修改的情况下返回值。",example:"24",require:"m",repeat:"n",type:"rangeall"}]},{n:"TO_DOLLARS",t:16,d:"将指定的数字转换为美元金额。",a:"将指定的数字转换为美元金额。",m:[1,1],p:[{name:"value",detail:"要转换为美元金额的参数或其单元格引用。\n\n如果值不是数字或指向内容为数值的单元格的引用，则 TO_DOLLARS 将在不做任何修改的情况下返回值。",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TO_PERCENT",t:16,d:"将指定的数字转换为百分比。",a:"将指定的数字转换为百分比。",m:[1,1],p:[{name:"value",detail:"要转换为百分比的参数或其单元格引用。\n\n如果值为数字或指向包含数值的单元格的引用，TO_PERCENT会以1 = 100%为标准，将值转换为百分比。\n\n如果值不是数字或指向内容为数值的单元格的引用，则TO_PERCENT将在不做任何修改的情况下返回值。",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DGET",t:17,d:"使用 SQL 式查询，从列表或数据库的列中提取符合指定条件的单个值。",a:"使用 SQL 式查询，从列表或数据库的列中提取符合指定条件的单个值。",m:[3,3],p:[{name:"database",detail:"构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DMAX",t:17,d:"使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的最大数字。",a:"使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的最大数字。",m:[3,3],p:[{name:"database",detail:"构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DMIN",t:17,d:"使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的最小数字。",a:"使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的最小数字。",m:[3,3],p:[{name:"database",detail:"构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DAVERAGE",t:17,d:"使用 SQL 式查询，对列表或数据库中满足指定条件的记录字段（列）中的数值求平均值。",a:"使用 SQL 式查询，对列表或数据库中满足指定条件的记录字段（列）中的数值求平均值。",m:[3,3],p:[{name:"database",detail:"构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DCOUNT",t:17,d:"使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中包含数字的单元格的个数。",a:"使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中包含数字的单元格的个数。",m:[3,3],p:[{name:"database",detail:"构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DCOUNTA",t:17,d:"使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的非空单元格的个数。",a:"使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的非空单元格的个数。",m:[3,3],p:[{name:"database",detail:"构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DPRODUCT",t:17,d:"使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的数值的乘积。",a:"使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的数值的乘积。",m:[3,3],p:[{name:"database",detail:"构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DSTDEV",t:17,d:"使用 SQL 式查询，返回利用列表或数据库中满足指定条件的记录字段（列）中的数字作为一个样本估算出的总体标准偏差。",a:"使用 SQL 式查询，返回利用列表或数据库中满足指定条件的记录字段（列）中的数字作为一个样本估算出的总体标准偏差。",m:[3,3],p:[{name:"database",detail:"构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DSTDEVP",t:17,d:"使用 SQL 式查询，返回利用列表或数据库中满足指定条件的记录字段（列）中的数字作为样本总体计算出的总体标准偏差。",a:"使用 SQL 式查询，返回利用列表或数据库中满足指定条件的记录字段（列）中的数字作为样本总体计算出的总体标准偏差。",m:[3,3],p:[{name:"database",detail:"构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DSUM",t:17,d:"使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的数字之和。",a:"使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的数字之和。",m:[3,3],p:[{name:"database",detail:"构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DVAR",t:17,d:"使用 SQL 式查询，返回利用列表或数据库中满足指定条件的记录字段（列）中的数字作为一个样本估算出的总体方差。",a:"使用 SQL 式查询，返回利用列表或数据库中满足指定条件的记录字段（列）中的数字作为一个样本估算出的总体方差。",m:[3,3],p:[{name:"database",detail:"构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DVARP",t:17,d:"使用 SQL 式查询，通过使用列表或数据库中满足指定条件的记录字段（列）中的数字计算样本总体的样本总体方差。",a:"使用 SQL 式查询，通过使用列表或数据库中满足指定条件的记录字段（列）中的数字计算样本总体的样本总体方差。",m:[3,3],p:[{name:"database",detail:"构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"AGE_BY_IDCARD",t:"3",d:"根据中国身份证号计算出年龄。支持15位或18位身份证",a:"根据身份证号得到年龄。",m:[1,2],p:[{name:"身份证号",example:"A1",detail:"15位或者18位的身份证号或范围。",require:"m",repeat:"n",type:"rangeall"},{name:"截止日期",example:'"2017-10-01"',detail:"年龄计算的截止日期或范围，默认为当日。",require:"o",repeat:"n",type:"rangedatetime"}]},{n:"SEX_BY_IDCARD",t:"3",d:"根据中国身份证号计算出性别。支持15位或18位身份证",a:"根据身份证号得到性别。",m:[1,1],p:[{name:"身份证号",example:'"31033519900101XXXX"',detail:"15位或者18位的身份证号或范围。",require:"m",repeat:"n",type:"rangeall"}]},{n:"BIRTHDAY_BY_IDCARD",t:"3",d:"根据中国身份证号计算出生日。支持15位或18位身份证",a:"根据身份证号得到生日。",m:[1,2],p:[{name:"身份证号",example:'"31033519900101XXXX"',detail:"15位或者18位的身份证号或范围。",require:"m",repeat:"n",type:"rangeall"},{name:"生日格式",example:"0",detail:"日期类型,默认0:[1900/01/01], 1:[1900-01-01], 2:[1900年1月1日]",require:"o",repeat:"n",type:"rangeall"}]},{n:"PROVINCE_BY_IDCARD",t:"3",d:"根据中国身份证号计算出籍贯的省份。支持15位或18位身份证",a:"根据身份证号得到籍贯的省份。",m:[1,1],p:[{name:"身份证号",example:'"31033519900101XXXX"',detail:"15位或者18位的身份证号或范围。",require:"m",repeat:"n",type:"rangeall"}]},{n:"CITY_BY_IDCARD",t:"3",d:"根据中国身份证号计算出籍贯的城市。支持15位或18位身份证",a:"根据身份证号得到籍贯的城市。",m:[1,1],p:[{name:"身份证号",example:'"31033519900101XXXX"',detail:"15位或者18位的身份证号或范围。",require:"m",repeat:"n",type:"rangeall"}]},{n:"STAR_BY_IDCARD",t:"3",d:"根据中国身份证号计算出星座。支持15位或18位身份证",a:"根据身份证号得到星座。",m:[1,1],p:[{name:"身份证号",example:'"31033519900101XXXX"',detail:"15位或者18位的身份证号或范围。",require:"m",repeat:"n",type:"rangeall"}]},{n:"ANIMAL_BY_IDCARD",t:"3",d:"根据中国身份证号计算出生肖（鼠、牛、虎、兔...）。支持15位或18位身份证",a:"根据身份证号得到生肖。",m:[1,1],p:[{name:"身份证号",example:'"31033519900101XXXX"',detail:"15位或者18位的身份证号或范围。",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISIDCARD",t:"3",d:"验证身份证的格式是否正确。支持15位或18位身份证",a:"验证身份证格式正确性。",m:[1,1],p:[{name:"身份证号",example:'"31033519900101XXXX"',detail:"15位或者18位的身份证号或范围。",require:"m",repeat:"n",type:"rangeall"}]},{n:"DM_TEXT_CUTWORD",t:"4",d:"文本分词。把一连串文字拆分为一系列单独词语",a:"中文文本分词。",m:[1,2],p:[{name:"文本",example:'"我来到北京清华大学"',detail:"任意需要分词的文本。",require:"m",repeat:"n",type:"rangeall"},{name:"分词模式",example:"0",detail:"默认为0[精确模式], 1[全模式], 2[搜索引擎模式]。",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DM_TEXT_TFIDF",t:"4",d:"采用tf-idf算法进行关键词提取。从一连串文字中识别关键词",a:"tf-idf关键词识别。",m:[1,3],p:[{name:"文本",example:'"我来到北京清华大学"',detail:"任意需要分词的文本。",require:"m",repeat:"n",type:"rangeall"},{name:"关键词个数",example:"20",detail:"算法返回的关键词个数，默认20",require:"o",repeat:"n",type:"rangenumber"},{name:"语料库",example:"1",detail:"选择特定领域的语料库，默认0[通用], 1[金融], 2[医疗]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DM_TEXT_TEXTRANK",t:"4",d:"采用TextRank算法进行关键词提取。从一连串文字中识别关键词",a:"TextRank关键词识别。",m:[1,3],p:[{name:"文本",example:'"我来到北京清华大学"',detail:"任意需要分词的文本。",require:"m",repeat:"n",type:"rangeall"},{name:"关键词个数",example:"20",detail:"算法返回的关键词个数，默认20",require:"o",repeat:"n",type:"rangenumber"},{name:"语料库",example:"1",detail:"选择特定领域的语料库，默认0[通用], 1[金融], 2[医疗]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_CLOSE",t:"5",d:"根据股票代码和日期，返回A股对应股票收盘价。",a:"返回A股对应股票收盘价。",m:[1,3],p:[{name:"股票代码",example:'"000001"',detail:"6位股票代码，必填项。",require:"m",repeat:"n",type:"rangeall"},{name:"日期",example:"2015-01-08",detail:"股票的交易日，默认为最新交易日",require:"o",repeat:"n",type:"rangedate"},{name:"复权除权",example:"0",detail:"选择股票的除权复权类型，默认0[前复权], 1[原始价格], 2[后复权]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_OPEN",t:"5",d:"根据股票代码和日期，返回A股对应股票开盘价。",a:"返回A股对应股票开盘价。",m:[1,3],p:[{name:"股票代码",example:'"000001"',detail:"6位股票代码，必填项。",require:"m",repeat:"n",type:"rangeall"},{name:"日期",example:"2015-01-08",detail:"股票的交易日，默认为最新交易日",require:"o",repeat:"n",type:"rangedate"},{name:"复权除权",example:"0",detail:"选择股票的除权复权类型，默认0[前复权], 1[原始价格], 2[后复权]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_MAX",t:"5",d:"根据股票代码和日期，返回A股对应股票最高价。",a:"返回A股对应股票最高价。",m:[1,3],p:[{name:"股票代码",example:'"000001"',detail:"6位股票代码，必填项。",require:"m",repeat:"n",type:"rangeall"},{name:"日期",example:"2015-01-08",detail:"股票的交易日，默认为最新交易日",require:"o",repeat:"n",type:"rangedate"},{name:"复权除权",example:"0",detail:"选择股票的除权复权类型，默认0[前复权], 1[原始价格], 2[后复权]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_MIN",t:"5",d:"根据股票代码和日期，返回A股对应股票最低价。",a:"返回A股对应股票最低价。",m:[1,3],p:[{name:"股票代码",example:'"000001"',detail:"6位股票代码，必填项。",require:"m",repeat:"n",type:"rangeall"},{name:"日期",example:"2015-01-08",detail:"股票的交易日，默认为最新交易日",require:"o",repeat:"n",type:"rangedate"},{name:"复权除权",example:"0",detail:"选择股票的除权复权类型，默认0[前复权], 1[原始价格], 2[后复权]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_VOLUMN",t:"5",d:"根据股票代码和日期，返回A股对应股票成交量。",a:"返回A股对应股票成交量。",m:[1,3],p:[{name:"股票代码",example:'"000001"',detail:"6位股票代码，必填项。",require:"m",repeat:"n",type:"rangeall"},{name:"日期",example:"2015-01-08",detail:"股票的交易日，默认为最新交易日",require:"o",repeat:"n",type:"rangedate"},{name:"复权除权",example:"0",detail:"选择股票的除权复权类型，默认0[前复权], 1[原始价格], 2[后复权]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_AMOUNT",t:"5",d:"根据股票代码和日期，返回A股对应股票成交额。",a:"返回A股对应股票成交额。",m:[1,3],p:[{name:"股票代码",example:'"000001"',detail:"6位股票代码，必填项。",require:"m",repeat:"n",type:"rangeall"},{name:"日期",example:"2015-01-08",detail:"股票的交易日，默认为最新交易日",require:"o",repeat:"n",type:"rangedate"},{name:"复权除权",example:"0",detail:"选择股票的除权复权类型，默认0[前复权], 1[原始价格], 2[后复权]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"ISDATE",t:"6",d:"验证日期的格式是否正确。支持多种日期格式",a:"验证日期格式正确性。",m:[1,1],p:[{name:"日期",example:'"1990-01-01"',detail:"日期值，例如1990/01/01, 1990年1月1日等。",require:"m",repeat:"n",type:"rangeall"}]},{n:"LINESPLINES",t:"3",d:"生成嵌入在单元格内的折线图sparklines，用于描述数据的连续走势",a:"生成单元格折线图",m:[1,8],p:[{name:"数据范围",example:"A1:A20",detail:"数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"线条颜色",example:"#2ec7c9",detail:"线图的线条颜色，可以是否个范围A1、色表索引数值或者具体颜色值，设置为0或false则不显示，支持regx、rgb、rgba等。默认#2ec7c9",require:"o",repeat:"n",type:"rangeall"},{name:"线条粗细",example:"1",detail:"折线图线段粗细，默认为1px",require:"o",repeat:"n",type:"rangeall"},{name:"辅助线",example:"avg",detail:"一条横线，可以是min、max、avg、median、范围或自定义数值，默认0无",require:"o",repeat:"n",type:"rangeall"},{name:"辅助线颜色",example:"#000",detail:"辅助线的颜色设置，同线条颜色配置，默认#000",require:"o",repeat:"n",type:"rangeall"},{name:"最大值标识",example:"#fc5c5c",detail:"标识线图最大值，同线条颜色配置，默认0不显示",require:"o",repeat:"n",type:"rangeall"},{name:"最小值标识",example:"#fc5c5c",detail:"标识线图最小值，同线条颜色配置，默认0不显示",require:"o",repeat:"n",type:"rangeall"},{name:"标识大小",example:"1.5",detail:"最大值和最小值的标识大小设置，默认为1.5",require:"o",repeat:"n",type:"rangeall"}]},{n:"AREASPLINES",t:"3",d:"生成嵌入在单元格内的面积图sparklines，一般用于描述数据的连续累积值走势",a:"生成单元格面积图",m:[1,5],p:[{name:"数据范围",example:"A1:A20",detail:"数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"线条颜色",example:"#2ec7c9",detail:"线图的线条颜色，可以是否个范围A1、色表索引数值或者具体颜色值，设置为0或false则不显示，支持regx、rgb、rgba等。默认#2ec7c9",require:"o",repeat:"n",type:"rangeall"},{name:"填充颜色",example:"#CCF3F4",detail:"形成面积图，同线条颜色配置，默认0不显示",require:"o",repeat:"n",type:"rangeall"},{name:"线条粗细",example:"1",detail:"折线图线段粗细，默认为1px",require:"o",repeat:"n",type:"rangeall"},{name:"辅助线",example:"avg",detail:"一条横线，可以是min、max、avg、median、范围或自定义数值，默认0无",require:"o",repeat:"n",type:"rangeall"},{name:"辅助线颜色",example:"#000",detail:"辅助线的颜色设置，同线条颜色配置，默认#000",require:"o",repeat:"n",type:"rangeall"}]},{n:"COLUMNSPLINES",t:"3",d:"生成嵌入在单元格内的垂直柱状图sparklines，一般用于描述离散数据之间的大小情况",a:"生成单元格垂直柱状图",m:[1,6],p:[{name:"数据范围",example:"A1:A20",detail:"数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"柱条间隔",example:"1",detail:"柱条之间的间隔距离，默认为1",require:"o",repeat:"n",type:"rangeall"},{name:"柱条颜色",example:"#fc5c5c",detail:"线图的线条颜色，可以是否个范围A1、色表索引数值或者具体颜色值，设置为0或false则不显示，支持regx、rgb、rgba等。默认#fc5c5c",require:"o",repeat:"n",type:"rangeall"},{name:"负向柱条颜色",example:"#97b552",detail:"负向柱条颜色设置，代表负值的颜色，同柱条颜色配置，默认#97b552",require:"o",repeat:"n",type:"rangeall"},{name:"最大值",example:"100",detail:"柱图最大值，用于规范柱图长度，默认为自动计算false、auto、null",require:"o",repeat:"n",type:"rangeall"},{name:"色板",example:"#97b552",detail:"调色板可以单独设置每个柱条的颜色，可设置多个，支持两种格式：1颜色例如#000，代表第一个柱的颜色是黑色；2数值范围:颜色，例如-2:#000表示数值为-2的柱为黑色，0:5:#000表示数值0-5的柱为黑色，默认为空",require:"o",repeat:"y",type:"rangeall"}]},{n:"STACKCOLUMNSPLINES",t:"3",d:"生成嵌入在单元格内的累积垂直柱状图sparklines，一般用于描述离散数据多个维度的数值大小",a:"生成单元格累积垂直柱状图",m:[1,5],p:[{name:"数据范围",example:"A1:A20",detail:"数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"按列堆积",example:"1",detail:"如果需要按行堆积则本项设为false或0，默认为是1",require:"o",repeat:"n",type:"rangeall"},{name:"柱条间隔",example:"1",detail:"柱条之间的间隔距离，默认为1",require:"o",repeat:"n",type:"rangeall"},{name:"最大值",example:"100",detail:"累积柱图最大值，用于规范柱图长度，默认为自动计算false、auto、null",require:"o",repeat:"n",type:"rangeall"},{name:"累积色板",example:"#97b552",detail:"调色板可以单独设置每个维度的柱条颜色，可设置为A1:A10等范围，默认为#2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",require:"o",repeat:"y",type:"rangeall"}]},{n:"BARSPLINES",t:"3",d:"生成嵌入在单元格内的横向条形图sparklines，一般用于描述离散数据之间的大小情况",a:"生成单元格横向条形图",m:[1,6],p:[{name:"数据范围",example:"A1:A20",detail:"数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"柱条间隔",example:"1",detail:"柱条之间的间隔距离，默认为1",require:"o",repeat:"n",type:"rangeall"},{name:"柱条颜色",example:"#fc5c5c",detail:"线图的线条颜色，可以是否个范围A1、色表索引数值或者具体颜色值，设置为0或false则不显示，支持regx、rgb、rgba等。默认#fc5c5c",require:"o",repeat:"n",type:"rangeall"},{name:"负向柱条颜色",example:"#97b552",detail:"负向柱条颜色设置，代表负值的颜色，同柱条颜色配置，默认#97b552",require:"o",repeat:"n",type:"rangeall"},{name:"最大值",example:"100",detail:"柱图最大值，用于规范柱图长度，默认为自动计算false、auto、null",require:"o",repeat:"n",type:"rangeall"},{name:"色板",example:"#97b552",detail:"调色板可以单独设置每个柱条的颜色，可设置多个，支持两种格式：1颜色例如#000，代表第一个柱的颜色是黑色；2数值范围:颜色，例如-2:#000表示数值为-2的柱为黑色，0:5:#000表示数值0-5的柱为黑色，默认为空",require:"o",repeat:"y",type:"rangeall"}]},{n:"STACKBARSPLINES",t:"3",d:"生成嵌入在单元格内的累积横向条形图sparklines，一般用于描述离散数据多个维度的数值大小",a:"生成单元格累积横向条形图",m:[1,5],p:[{name:"数据范围",example:"A1:A20",detail:"数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"按列堆积",example:"1",detail:"如果需要按行堆积则本项设为false或0，默认为是1",require:"o",repeat:"n",type:"rangeall"},{name:"柱条间隔",example:"1",detail:"柱条之间的间隔距离，默认为1",require:"o",repeat:"n",type:"rangeall"},{name:"最大值",example:"100",detail:"累积柱图最大值，用于规范柱图长度，默认为自动计算false、auto、null",require:"o",repeat:"n",type:"rangeall"},{name:"累积色板",example:"#97b552",detail:"调色板可以单独设置每个维度的柱条颜色，可设置为A1:A10等范围，默认为#2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",require:"o",repeat:"y",type:"rangeall"}]},{n:"DISCRETESPLINES",t:"3",d:"生成嵌入在单元格内的离散图sparklines，一般用于描述离散数据走势",a:"生成单元格离散图",m:[1,4],p:[{name:"数据范围",example:"A1:A20",detail:"数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"分割阈值",example:"1",detail:"离散图柱形颜色的区分，例如：该值为0，则大于0为蓝色，小于0为红色，默认为0",require:"o",repeat:"n",type:"rangeall"},{name:"阈值以上颜色",example:"#2ec7c9",detail:"线图的线条颜色，可以是否个范围A1、色表索引数值或者具体颜色值，设置为0或false则不显示，支持regx、rgb、rgba等。默认#2ec7c9",require:"o",repeat:"n",type:"rangeall"},{name:"阈值以下颜色",example:"#fc5c5c",detail:"阈值以下柱条颜色设置，同阈值以上颜色，默认#fc5c5c",require:"o",repeat:"n",type:"rangeall"}]},{n:"TRISTATESPLINES",t:"3",d:"生成嵌入在单元格内的三态图sparklines，一般用于描述三种态势的走势例如胜负平",a:"生成单元格三态图",m:[1,6],p:[{name:"数据范围",example:"A1:A20",detail:"数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"柱条间隔",example:"1",detail:"柱条之间的间隔距离，默认为1",require:"o",repeat:"n",type:"rangeall"},{name:"柱条颜色",example:"#fc5c5c",detail:"线图的线条颜色，可以是否个范围A1、色表索引数值或者具体颜色值，设置为0或false则不显示，支持regx、rgb、rgba等。默认#fc5c5c",require:"o",repeat:"n",type:"rangeall"},{name:"负向柱条颜色",example:"#97b552",detail:"负向柱条颜色设置，代表负值的颜色，同柱条颜色配置，默认#97b552",require:"o",repeat:"n",type:"rangeall"},{name:"零值柱条颜色",example:"#999",detail:"零值柱条颜色设置，代表0值颜色，同柱条颜色配置，默认#999",require:"o",repeat:"n",type:"rangeall"},{name:"色板",example:"#97b552",detail:"调色板可以单独设置每个柱条的颜色，可设置多个，支持两种格式：1颜色例如#000，代表第一个柱的颜色是黑色；2数值范围:颜色，例如-2:#000表示数值为-2的柱为黑色，0-5:#000表示数值0-5的柱为黑色，默认为空",require:"o",repeat:"y",type:"rangeall"}]},{n:"PIESPLINES",t:"3",d:"生成嵌入在单元格内的饼图sparklines，一般用于描述数据占比",a:"生成单元格饼图",m:[1,5],p:[{name:"数据范围",example:"A1:A20",detail:"数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"旋转角度",example:"0",detail:"饼图的旋转角度，默认为0",require:"o",repeat:"n",type:"rangeall"},{name:"饼图边框",example:"0",detail:"饼图边框大小，默认为无0",require:"o",repeat:"n",type:"rangeall"},{name:"边框颜色",example:"#000",detail:"饼图边框颜色，默认为#000",require:"o",repeat:"n",type:"rangeall"},{name:"饼图色板",example:"#97b552",detail:"调色板可以设置切片的颜色，可设置为A1:A10等范围，默认为#2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",require:"o",repeat:"y",type:"rangeall"}]},{n:"BOXSPLINES",t:"3",d:"生成嵌入在单元格内的箱线图sparklines，一般用于描述数据集的统计分布",a:"生成单元格箱线图",m:[1,4],p:[{name:"数据范围",example:"A1:A20",detail:"数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"离群点比例",example:"1.5",detail:"离群点的阈值范围，如果为0或false则不显示，默认为1.5倍",require:"o",repeat:"n",type:"rangeall"},{name:"目标点值",example:"10",detail:"箱线图上的目标值设置，默认为false不显示",require:"o",repeat:"n",type:"rangeall"},{name:"数据点大小",example:"1.5",detail:"目标点和离群点的半径大小设置，默认为1.5",require:"o",repeat:"n",type:"rangeall"}]},{n:"BULLETSPLINES",t:"3",d:"生成嵌入在单元格内的子弹图sparklines，一般用于描述任务达成率",a:"生成单元格子弹图",m:[2,3],p:[{name:"目标",example:"10",detail:"达成的目标值，数值才能被有效计算，例如A1， 100等。",require:"m",repeat:"n",type:"rangeall"},{name:"实际完成",example:"8",detail:"目前完成值，数值才能被有效计算，例如A1， 100等。",require:"m",repeat:"n",type:"rangeall"},{name:"对比值",example:"12",detail:"对比值，例如超额、最低、获奖底线等，数值才能被有效计算，例如A1， 100等。可以设置最多9个对比值",require:"o",repeat:"y",type:"rangeall"}]},{n:"COMPOSESPLINES",t:"3",d:"支持多个类型的图画在同一个单元格,每个参数代表一个sparklines图",a:"组合sparklines图到一个单元格",m:[1,1],p:[{name:"图设置",example:"PIESPLINES(A1:A20)",detail:"sparklines图设置，例如A1:A20， 一个完成的饼图、线图设置等。",require:"m",repeat:"y",type:"rangeall"}]},{n:"SORT",t:"14",d:"返回数组中元素的排序数组。返回的数组与提供的数组参数形状相同。",a:"返回数组中元素的排序数组。返回的数组与提供的数组参数形状相同。",m:[1,4],p:[{name:"array",detail:"要排序的范围或数组。",example:"A2:A17",require:"m",repeat:"n",type:"rangenumber"},{name:"sort_index",detail:"[可选] - 表示要排序的行或列的数字。（默认row1/col1）",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"sort_order",detail:"[可选] - 表示所需排序顺序的数字；1表示升序（默认），-1表示降序。",example:"-1",require:"o",repeat:"n",type:"rangenumber"},{name:"by_col",detail:"[可选] - 表示所需排序方向的逻辑值；按行排序为FALSE()（默认），按列排序为TRUE()。",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"FILTER",t:"14",d:"基于一个布尔（真/假）数组过滤一个数组。",a:"基于一个布尔（真/假）数组过滤一个数组。",m:[2,3],p:[{name:"array",detail:"要筛选的数组或范围。",example:"A5:D20",require:"m",repeat:"n",type:"range"},{name:"include",detail:"布尔数组，其高度或宽度与数组相同",example:"1",require:"m",repeat:"n",type:"range"},{name:"if_empty",detail:"[可选] - 如果包含数组中的所有值都为空(filter不返回任何值)，则返回的值。",example:'""',require:"o",repeat:"n",type:"rangeall"}]},{n:"UNIQUE",t:"14",d:"返回列表或区域中的唯一值的列表。",a:"返回列表或区域中的唯一值的列表。",m:[1,3],p:[{name:"array",detail:"从其返回唯一值的数组或区域。",example:"A2:B26",require:"m",repeat:"n",type:"rangenumber"},{name:"by_col",detail:"[可选] - 逻辑值，指示如何比较；按行 = FALSE() 或省略；按列 = TRUE()。",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"},{name:"occurs_once",detail:"[可选] - 逻辑值，仅返回唯一值中出现一次 = TRUE()；包括所有唯一值 = FALSE() 或省略。",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"RANDARRAY",t:"14",d:"返回 0 到 1 之间的随机数字数组。",a:"返回 0 到 1 之间的随机数字数组。",m:[0,2],p:[{name:"rows",detail:"[可选] - 要返回的行数。",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"cols",detail:"[可选] - 要返回的列数。",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"SEQUENCE",t:"14",d:"生成数字序列的列表。",a:"生成数字序列的列表。",m:[1,4],p:[{name:"rows",detail:"要返回的行数。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"cols",detail:"[可选] - 要返回的列数。",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"start",detail:"[可选] - 序列中的第一个数字。",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"step",detail:"[可选] - 序列中每个序列值的增量。",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"EVALUATE",t:"3",d:"对以文字表示的公式或者表达式求值，并返回结果。",a:"根据文字公式或者表达式求值。",m:[1,1],p:[{name:"公式",example:'"A1+5*2^2"',detail:"公式或表达式",require:"m",repeat:"n",type:"rangeall"}]}],toolbar:{toolbar:"工具栏",undo:"撤销",redo:"重做","clear-format":"清除格式","format-painter":"格式刷","currency-format":"货币格式","percentage-format":"百分比格式","number-decrease":"减少小数位数","number-increase":"增加小数位数",moreFormats:"更多格式","border-all":"所有边框","merge-all":"全部合并单元格",font:"字体","font-size":"字号",bold:"粗体 (Ctrl+B)",italic:"斜体 (Ctrl+I)","strike-through":"删除线 (Alt+Shift+5)",underline:"下划线","font-color":"文本颜色","align-left":"左对齐","align-center":"水平居中","align-right":"右对齐","align-top":"上对齐","align-mid":"垂直居中","align-bottom":"下对齐",chooseColor:"颜色选择",resetColor:"重置颜色",customColor:"自定义",alternatingColors:"交替颜色",confirmColor:"确定颜色",cancelColor:"取消",collapse:"收起",background:"背景色",border:"边框",borderStyle:"边框类型","merge-cell":"合并单元格",chooseMergeType:"选择合并类型",horizontalAlign:"水平对齐",verticalAlign:"垂直对齐",alignment:"对齐方式",textWrap:"文本换行",textWrapMode:"换行方式",textRotate:"文本旋转",textRotateMode:"旋转方式",freeze:"冻结",sort:"排序",filter:"筛选",sortAndFilter:"排序和筛选",findAndReplace:"查找替换","formula-sum":"求和",autoSum:"自动求和",moreFunction:"更多函数",conditionalFormat:"条件格式",comment:"批注",pivotTable:"数据透视表",chart:"图表",screenshot:"截图",splitColumn:"分列",insertImage:"插入图片",insertLink:"插入链接",dataVerification:"数据验证",protection:"保护工作表内容",clearText:"清除颜色选择",noColorSelectedText:"没有颜色被选择",toolMore:"更多",toolLess:"少于",toolClose:"收起",toolMoreTip:"更多功能",moreOptions:"更多选项",cellFormat:"设置单元格格式",print:"打印"},alternatingColors:{applyRange:"应用范围",selectRange:"选择应用范围",header:"页眉",footer:"页脚",errorInfo:"不能对多重选择区域执行此操作，请选择单个区域，然后再试",textTitle:"格式样式",custom:"自定义",close:"关闭",selectionTextColor:"选择文本颜色",selectionCellColor:"选择单元格颜色",removeColor:"移除交替颜色",colorShow:"颜色",currentColor:"当前颜色",tipSelectRange:"请选择交替颜色应用范围",errorNoRange:"您选择的应用范围不是选区！",errorExistColors:"您选择的应用范围已存在交替颜色且不属于你要编辑的应用范围！"},button:{confirm:"确定",cancel:"取消",close:"关闭",update:"Update",delete:"Delete",insert:"新建",prevPage:"上一页",nextPage:"下一页",total:"总共："},paint:{start:"格式刷开启",end:"ESC键退出",tipSelectRange:"请选择需要复制格式的区域",tipNotMulti:"无法对多重选择区域执行此操作"},format:{moreCurrency:"更多货币格式",moreDateTime:"更多日期与时间格式",moreNumber:"更多数字格式",titleCurrency:"货币格式",decimalPlaces:"小数位数",titleDateTime:"日期与时间格式",titleNumber:"数字格式",tipDecimalPlaces:"小数位数必须在0-9之间！",select:"选择",format:"格式",currency:"货币"},info:{detailUpdate:"新打开",detailSave:"已恢复本地缓存",row:"行",column:"列",loading:"加载中···",copy:"副本",return:"返回",rename:"重命名",tips:"表格重命名",noName:"无标题的电子表格",wait:"待更新",add:"添加",addLast:"在底部添加",backTop:"回到顶部",pageInfo:"共${total}条，${totalPage}页，当前已显示${currentPage}页",nextPage:"下一页",tipInputNumber:"请输入数字",tipInputNumberLimit:"增加范围限制在1-100",tipRowHeightLimit:"行高必须在0 ~ 545之间",tipColumnWidthLimit:"列宽必须在0 ~ 2038之间",pageInfoFull:"共${total}条，${totalPage}页，已显示全部数据"},currencyDetail:[{name:"人民币",pos:"before",value:"¥"},{name:"美元",pos:"before",value:"$"},{name:"欧元",pos:"before",value:"€"},{name:"英镑",pos:"before",value:"￡"},{name:"港元",pos:"before",value:"$"},{name:"日元",pos:"before",value:"￥"},{name:"阿尔巴尼亚列克",pos:"before",value:"Lek"},{name:"阿尔及利亚第纳尔",pos:"before",value:"din"},{name:"阿富汗尼",pos:"after",value:"Af"},{name:"阿根廷比索",pos:"before",value:"$"},{name:"阿拉伯联合酋长国迪拉姆",pos:"before",value:"dh"},{name:"阿鲁巴弗罗林",pos:"before",value:"Afl"},{name:"阿曼里亚尔",pos:"before",value:"Rial"},{name:"阿塞拜疆马纳特",pos:"before",value:"?"},{name:"埃及镑",pos:"before",value:"￡"},{name:"埃塞俄比亚比尔",pos:"before",value:"Birr"},{name:"安哥拉宽扎",pos:"before",value:"Kz"},{name:"澳大利亚元",pos:"before",value:"$"},{name:"澳门元",pos:"before",value:"MOP"},{name:"巴巴多斯元",pos:"before",value:"$"},{name:"巴布亚新几内亚基那",pos:"before",value:"PGK"},{name:"巴哈马元",pos:"before",value:"$"},{name:"巴基斯坦卢比",pos:"before",value:"Rs"},{name:"巴拉圭瓜拉尼",pos:"after",value:"Gs"},{name:"巴林第纳尔",pos:"before",value:"din"},{name:"巴拿马巴波亚",pos:"before",value:"B/"},{name:"巴西里亚伊",pos:"before",value:"R$"},{name:"白俄罗斯卢布",pos:"after",value:"р"},{name:"百慕大元",pos:"before",value:"$"},{name:"保加利亚列弗",pos:"before",value:"lev"},{name:"冰岛克朗",pos:"before",value:"kr"},{name:"波黑可兑换马克",pos:"before",value:"KM"},{name:"波兰兹罗提",pos:"after",value:"z?"},{name:"玻利维亚诺",pos:"before",value:"Bs"},{name:"伯利兹元",pos:"before",value:"$"},{name:"博茨瓦纳普拉",pos:"before",value:"P"},{name:"不丹努扎姆",pos:"before",value:"Nu"},{name:"布隆迪法郎",pos:"before",value:"FBu"},{name:"朝鲜圆",pos:"before",value:"?KP"},{name:"丹麦克朗",pos:"after",value:"kr"},{name:"东加勒比元",pos:"before",value:"$"},{name:"多米尼加比索",pos:"before",value:"RD$"},{name:"俄国卢布",pos:"after",value:"?"},{name:"厄立特里亚纳克法",pos:"before",value:"Nfk"},{name:"非洲金融共同体法郎",pos:"before",value:"CFA"},{name:"菲律宾比索",pos:"before",value:"?"},{name:"斐济元",pos:"before",value:"$"},{name:"佛得角埃斯库多",pos:"before",value:"CVE"},{name:"福克兰群岛镑",pos:"before",value:"￡"},{name:"冈比亚达拉西",pos:"before",value:"GMD"},{name:"刚果法郎",pos:"before",value:"FrCD"},{name:"哥伦比亚比索",pos:"before",value:"$"},{name:"哥斯达黎加科朗",pos:"before",value:"?"},{name:"古巴比索",pos:"before",value:"$"},{name:"古巴可兑换比索",pos:"before",value:"$"},{name:"圭亚那元",pos:"before",value:"$"},{name:"哈萨克斯坦坚戈",pos:"before",value:"?"},{name:"海地古德",pos:"before",value:"HTG"},{name:"韩元",pos:"before",value:"?"},{name:"荷属安的列斯盾",pos:"before",value:"NAf."},{name:"洪都拉斯拉伦皮拉",pos:"before",value:"L"},{name:"吉布提法郎",pos:"before",value:"Fdj"},{name:"吉尔吉斯斯坦索姆",pos:"before",value:"KGS"},{name:"几内亚法郎",pos:"before",value:"FG"},{name:"加拿大元",pos:"before",value:"$"},{name:"加纳塞地",pos:"before",value:"GHS"},{name:"柬埔寨瑞尔",pos:"before",value:"Riel"},{name:"捷克克朗",pos:"after",value:"K?"},{name:"津巴布韦元",pos:"before",value:"$"},{name:"卡塔尔里亚尔",pos:"before",value:"Rial"},{name:"开曼群岛元",pos:"before",value:"$"},{name:"科摩罗法郎",pos:"before",value:"CF"},{name:"科威特第纳尔",pos:"before",value:"din"},{name:"克罗地亚库纳",pos:"before",value:"kn"},{name:"肯尼亚先令",pos:"before",value:"Ksh"},{name:"莱索托洛蒂",pos:"before",value:"LSL"},{name:"老挝基普",pos:"before",value:"?"},{name:"黎巴嫩镑",pos:"before",value:"L￡"},{name:"立陶宛立特",pos:"before",value:"Lt"},{name:"利比亚第纳尔",pos:"before",value:"din"},{name:"利比亚元",pos:"before",value:"$"},{name:"卢旺达法郎",pos:"before",value:"RF"},{name:"罗马尼亚列伊",pos:"before",value:"RON"},{name:"马达加斯加阿里亚里",pos:"before",value:"Ar"},{name:"马尔代夫拉菲亚",pos:"before",value:"Rf"},{name:"马拉维克瓦查",pos:"before",value:"MWK"},{name:"马来西亚林吉特",pos:"before",value:"RM"},{name:"马其顿戴第纳尔",pos:"before",value:"din"},{name:"毛里求斯卢比",pos:"before",value:"MURs"},{name:"毛里塔尼亚乌吉亚",pos:"before",value:"MRO"},{name:"蒙古图格里克",pos:"before",value:"?"},{name:"孟加拉塔卡",pos:"before",value:"?"},{name:"秘鲁新索尔",pos:"before",value:"S/"},{name:"缅甸开亚特",pos:"before",value:"K"},{name:"摩尔多瓦列伊",pos:"before",value:"MDL"},{name:"摩洛哥迪拉姆",pos:"before",value:"dh"},{name:"莫桑比克梅蒂卡尔",pos:"before",value:"MTn"},{name:"墨西哥比索",pos:"before",value:"$"},{name:"纳米比亚元",pos:"before",value:"$"},{name:"南非兰特",pos:"before",value:"R"},{name:"南苏丹镑",pos:"before",value:"￡"},{name:"尼加拉瓜科多巴",pos:"before",value:"C$"},{name:"尼泊尔卢比",pos:"before",value:"Rs"},{name:"尼日利亚奈拉",pos:"before",value:"?"},{name:"挪威克朗",pos:"after",value:"kr"},{name:"乔治亚拉瑞",pos:"before",value:"GEL"},{name:"瑞典克朗",pos:"after",value:"kr"},{name:"瑞士法郎",pos:"before",value:"CHF"},{name:"塞尔维亚第纳尔",pos:"before",value:"din"},{name:"塞拉利昂利昂",pos:"before",value:"SLL"},{name:"塞舌尔卢比",pos:"before",value:"SCR"},{name:"沙特里亚尔",pos:"before",value:"Rial"},{name:"圣多美多布拉",pos:"before",value:"Db"},{name:"圣赫勒拿群岛磅",pos:"before",value:"￡"},{name:"斯里兰卡卢比",pos:"before",value:"Rs"},{name:"斯威士兰里兰吉尼",pos:"before",value:"SZL"},{name:"苏丹镑",pos:"before",value:"SDG"},{name:"苏里南元",pos:"before",value:"$"},{name:"所罗门群岛元",pos:"before",value:"$"},{name:"索马里先令",pos:"before",value:"SOS"},{name:"塔吉克斯坦索莫尼",pos:"before",value:"Som"},{name:"太平洋法郎",pos:"after",value:"FCFP"},{name:"泰国铢",pos:"before",value:"?"},{name:"坦桑尼亚先令",pos:"before",value:"TSh"},{name:"汤加潘加",pos:"before",value:"T$"},{name:"特立尼达和多巴哥元",pos:"before",value:"$"},{name:"突尼斯第纳尔",pos:"before",value:"din"},{name:"土耳其里拉",pos:"before",value:"?"},{name:"瓦努阿图瓦图",pos:"before",value:"VUV"},{name:"危地马拉格查尔",pos:"before",value:"Q"},{name:"委内瑞拉博利瓦",pos:"before",value:"Bs"},{name:"文莱元",pos:"before",value:"$"},{name:"乌干达先令",pos:"before",value:"UGX"},{name:"乌克兰格里夫尼亚",pos:"before",value:"грн."},{name:"乌拉圭比索",pos:"before",value:"$"},{name:"乌兹别克斯坦苏姆",pos:"before",value:"so?m"},{name:"西萨摩亚塔拉",pos:"before",value:"WST"},{name:"新加坡元",pos:"before",value:"$"},{name:"新台币",pos:"before",value:"NT$"},{name:"新西兰元",pos:"before",value:"$"},{name:"匈牙利福林",pos:"before",value:"Ft"},{name:"叙利亚镑",pos:"before",value:"￡"},{name:"牙买加元",pos:"before",value:"$"},{name:"亚美尼亚德拉姆",pos:"before",value:"Dram"},{name:"也门里亚尔",pos:"before",value:"Rial"},{name:"伊拉克第纳尔",pos:"before",value:"din"},{name:"伊朗里亚尔",pos:"before",value:"Rial"},{name:"以色列新谢克尔",pos:"before",value:"?"},{name:"印度卢比",pos:"before",value:"?"},{name:"印度尼西亚卢比",pos:"before",value:"Rp"},{name:"约旦第纳尔",pos:"before",value:"din"},{name:"越南盾",pos:"after",value:"?"},{name:"赞比亚克瓦查",pos:"before",value:"ZMW"},{name:"直布罗陀镑",pos:"before",value:"￡"},{name:"智利比索",pos:"before",value:"$"},{name:"中非金融合作法郎",pos:"before",value:"FCFA"}],defaultFmt:function defaultFmt(currency){return[{text:"自动",value:"General",example:""},{text:"纯文本",value:"@",example:""},{text:"",value:"split",example:""},{text:"数字",value:"##0.00",example:"1000.12"},{text:"百分比",value:"#0.00%",example:"12.21%"},{text:"科学计数",value:"0.00E+00",example:"1.01E+5"},{text:"",value:"split",example:""},{text:"会计",value:"".concat(currency,"(0.00)"),example:"".concat(currency,"(1200.09)")},{text:"万元",value:"w",example:"1亿2000万2500"},{text:"货币",value:"".concat(currency,"0.00"),example:"".concat(currency,"1200.09")},{text:"万元2位小数",value:"w0.00",example:"2万2500.55"},{text:"",value:"split",example:""},{text:"日期",value:"yyyy-MM-dd",example:"2017-11-29"},{text:"时间",value:"hh:mm AM/PM",example:"3:00 PM"},{text:"时间24H",value:"hh:mm",example:"15:00"},{text:"日期时间",value:"yyyy-MM-dd hh:mm AM/PM",example:"2017-11-29 3:00 PM"},{text:"日期时间24H",value:"yyyy-MM-dd hh:mm",example:"2017-11-29 15:00"},{text:"",value:"split",example:""},{text:"自定义格式",value:"fmtOtherSelf",example:"",icon:"rightArrow"}];},dateFmtList:[{name:"1930-08-05",value:"yyyy-MM-dd"},{name:"1930/8/5",value:"yyyy/MM/dd"},{name:"1930年8月5日",value:'yyyy"年"M"月"d"日"'},{name:"08-05",value:"MM-dd"},{name:"8-5",value:"M-d"},{name:"8月5日",value:'M"月"d"日"'},{name:"13:30:30",value:"h:mm:ss"},{name:"13:30",value:"h:mm"},{name:"下午01:30",value:"上午/下午 hh:mm"},{name:"下午1:30",value:"上午/下午 h:mm"},{name:"下午1:30:30",value:"上午/下午 h:mm:ss"},{name:"08-05 下午01:30",value:"MM-dd 上午/下午 hh:mm"}],fontFamily:{MicrosoftYaHei:"Microsoft YaHei"},fontarray:["Times New Roman","Arial","Tahoma","Verdana","微软雅黑","宋体","黑体","楷体","仿宋","新宋体","华文新魏","华文行楷","华文隶书"],fontjson:{"times new roman":0,arial:1,tahoma:2,verdana:3,微软雅黑:4,"microsoft yahei":4,宋体:5,simsun:5,黑体:6,simhei:6,楷体:7,kaiti:7,仿宋:8,fangsong:8,新宋体:9,nsimsun:9,华文新魏:10,stxinwei:10,华文行楷:11,stxingkai:11,华文隶书:12,stliti:12},border:{borderTop:"上框线",borderBottom:"下框线",borderLeft:"左框线",borderRight:"右框线",borderNone:"无",borderAll:"所有",borderOutside:"外侧",borderInside:"内侧",borderHorizontal:"内侧横线",borderVertical:"内侧竖线",borderColor:"边框颜色",borderSize:"边框粗细",borderSlash:"边框斜线",borderDefault:"默认样式",borderStyle:"边框样式"},merge:{mergeAll:"全部合并",mergeV:"垂直合并",mergeH:"水平合并",mergeCancel:"取消合并",overlappingError:"不能合并重叠区域",partiallyError:"无法对部分合并单元格执行此操作"},align:{left:"左对齐",center:"中间对齐",right:"右对齐",top:"顶部对齐",middle:"居中对齐",bottom:"底部对齐"},textWrap:{overflow:"溢出",wrap:"自动换行",clip:"截断"},rotation:{none:"无旋转",angleup:"向上倾斜",angledown:"向下倾斜",vertical:"竖排文字",rotationUp:"向上90°",rotationDown:"向下90°"},freezen:{default:"冻结第一行",freezenRow:"冻结第一行",freezenColumn:"冻结第A列",freezenRC:"冻结第一行第A列",freezenRowRange:"冻结至当前行",freezenColumnRange:"冻结至当前列",freezenRCRange:"冻结至当前行列",freezenCancel:"取消冻结",noSeletionError:"没有选区",rangeRCOverErrorTitle:"冻结提醒",rangeRCOverError:"冻结窗格超过可见范围，会导致无法正常操作，请重新设置冻结区域。"},sort:{asc:"升序",desc:"降序",custom:"自定义排序",hasTitle:"数据具有标题行",sortBy:"排序依据",addOthers:"添加其他排序列",close:"关闭",confirm:"排序",columnOperation:"列",secondaryTitle:"次要排序",sortTitle:"排序范围",sortRangeTitle:"排序范围从",sortRangeTitleTo:"到",noRangeError:"不能对多重选择区域执行此操作，请选择单个区域，然后再试",mergeError:"选区有合并单元格，无法执行此操作！"},filter:{filter:"筛选",clearFilter:"清除筛选",sortByAsc:"升序排列",sortByDesc:"降序排列",filterByColor:"按颜色筛选",filterByCondition:"按条件过滤",filterByValues:"按值过滤",filiterInputNone:"无",filiterInputTip:"输入筛选值",filiterRangeStartTip:"范围开始",filiterRangeEndTip:"范围结束",filterValueByAllBtn:"全选",filterValueByClearBtn:"清除",filterValueByInverseBtn:"反选",filterValueByTip:"按照值进行筛选",filterConform:"确 认",filterCancel:"取 消",conditionNone:"无",conditionCellIsNull:"单元格为空",conditionCellNotNull:"单元格有数据",conditionCellTextContain:"文本包含",conditionCellTextNotContain:"文本不包含",conditionCellTextStart:"文本开头为",conditionCellTextEnd:"文本结尾为",conditionCellTextEqual:"文本等于",conditionCellDateEqual:"日期等于",conditionCellDateBefore:"日期早于",conditionCellDateAfter:"日期晚于",conditionCellGreater:"大于",conditionCellGreaterEqual:"大于等于",conditionCellLess:"小于",conditionCellLessEqual:"小于等于",conditionCellEqual:"等于",conditionCellNotEqual:"不等于",conditionCellBetween:"介于",conditionCellNotBetween:"不在其中",filiterMoreDataTip:"数据量大！请稍后",filiterMonthText:"月",filiterYearText:"年",filiterByColorTip:"按单元格颜色筛选",filiterByTextColorTip:"按单元格字体颜色筛选",filterContainerOneColorTip:"本列仅包含一种颜色",filterDateFormatTip:"日期格式",valueBlank:"(空白)",mergeError:"筛选选区有合并单元格，无法执行此操作！"},rightclick:{copy:"复制",copyAs:"复制为",paste:"粘贴",insert:"插入",image:"插入图片",link:"插入链接",delete:"删除",deleteCell:"删除单元格",deleteSelected:"删除选中",hide:"隐藏",hideSelected:"隐藏选中",showHide:"显示隐藏",to:"向",left:"左",right:"右",top:"上",bottom:"下",moveLeft:"左移",moveUp:"上移",add:"增加",row:"行",column:"列",width:"宽",height:"高",number:"数字",confirm:"确认",orderAZ:"升序排列",orderZA:"降序排列",clearContent:"清除内容",matrix:"矩阵操作选区",sortSelection:"排序选区",filterSelection:"筛选选区",chartGeneration:"图表生成",firstLineTitle:"首行为标题",untitled:"无标题",array1:"一维数组",array2:"二维数组",array3:"多维数组",diagonal:"对角线",antiDiagonal:"反对角线",diagonalOffset:"对角偏移",offset:"偏移量",boolean:"布尔值",flip:"翻转",upAndDown:"上下",leftAndRight:"左右",clockwise:"顺时针",counterclockwise:"逆时针",transpose:"转置",matrixCalculation:"矩阵计算",plus:"加",minus:"减",multiply:"乘",divided:"除",power:"次方",root:"次方根",log:"log",delete0:"删除两端0值",removeDuplicate:"删除重复值",byRow:"按行",byCol:"按列",generateNewMatrix:"生成新矩阵",noMulti:"无法对多重选择区域执行此操作,请选择单个区域",cannotDeleteAllRow:"无法删除所有行",cannotDeleteAllColumn:"无法删除所有列",cannotDeleteRowReadOnly:"无法删除只读行",cannotDeleteColumnReadOnly:"无法删除只读列",cannotInsertOnRowReadOnly:"无法对只读行插入",cannotInsertOnColumnReadOnly:"无法对只读列插入",rowOverLimit:"超出10000行限制",columnOverLimit:"超出1000列限制"},comment:{insert:"新建批注",edit:"编辑批注",delete:"删除",showOne:"显示/隐藏批注",showAll:"显示/隐藏所有批注"},screenshot:{screenshotTipNoSelection:"请框选需要截图的范围",screenshotTipTitle:"提示！",screenshotTipHasMerge:"无法对合并单元格执行此操作",screenshotTipHasMulti:"无法对多重选择区域执行此操作",screenshotTipSuccess:"截取成功",screenshotImageName:"截图",downLoadClose:"关闭",downLoadCopy:"复制到剪切板",downLoadBtn:"下载",browserNotTip:"下载功能IE浏览器不支持！",rightclickTip:"请在图片上右键点击'复制'",successTip:"已成功复制（如果粘贴失败，请在图片上右键点击'复制图片'）"},splitText:{splitDelimiters:"分割符号",splitOther:"其它",splitContinueSymbol:"连续分隔符号视为单个处理",splitDataPreview:"数据预览",splitTextTitle:"文本分列",splitConfirmToExe:"此处已有数据，是否替换它？",splitSymbols:[{name:"Tab键",value:"Tab"},{name:"分号",value:"semicolon"},{name:"逗号",value:"comma"},{name:"空格",value:"space"}],tipNoMulti:"不能对多重选择区域执行此操作，请选择单个区域，然后再试",tipNoMultiColumn:"一次只能转换一列数据，选定区域可以有多行，但不能有多列，请在选定单列区域以后再试",tipNoSelect:"没有选择单元格不能进行分列"},imageText:{imageSetting:"图片设置",close:"关闭",conventional:"常规",moveCell1:"移动并调整单元格大小",moveCell2:"移动并且不调整单元格的大小",moveCell3:"不要移动单元格并调整其大小",fixedPos:"固定位置",border:"边框",width:"宽度",radius:"半径",style:"样式",solid:"实线",dashed:"虚线",dotted:"点状",double:"双线",color:"颜色"},punctuation:{tab:"Tab 键",semicolon:"分号",comma:"逗号",space:"空格"},findAndReplace:{find:"查找",replace:"替换",goto:"转到",location:"定位条件",formula:"公式",date:"日期",number:"数字",string:"字符",error:"错误",condition:"条件格式",rowSpan:"间隔行",columnSpan:"间隔列",locationExample:"定位",lessTwoRowTip:"请选择最少两行",lessTwoColumnTip:"请选择最少两行",findTextbox:"查找内容",replaceTextbox:"替换内容",regexTextbox:"正则表达式匹配",wholeTextbox:"整词匹配",distinguishTextbox:"区分大小写匹配",allReplaceBtn:"全部替换",replaceBtn:"替换",allFindBtn:"查找全部",findBtn:"查找下一个",noFindTip:"没有查找到该内容",modeTip:"该模式下不可进行此操作",searchTargetSheet:"工作表",searchTargetCell:"单元格",searchTargetValue:"值",searchInputTip:"请输入查找内容",noReplceTip:"没有可替换的内容",noMatchTip:"找不到匹配项",successTip:"已经帮您搜索并进行了${xlength}处替换",locationConstant:"常量",locationFormula:"公式",locationDate:"日期",locationDigital:"数字",locationString:"字符",locationBool:"逻辑值",locationError:"错误",locationNull:"空值",locationCondition:"条件格式",locationRowSpan:"间隔行",locationColumnSpan:"间隔列",locationTiplessTwoRow:"请选择最少两行",locationTiplessTwoColumn:"请选择最少两列",locationTipNotFindCell:"未找到单元格"},sheetconfig:{delete:"删除",copy:"复制",rename:"重命名",changeColor:"更改颜色",hide:"隐藏",unhide:"取消隐藏",moveLeft:"向左移",moveRight:"向右移",resetColor:"重置颜色",cancelText:"取消",chooseText:"确定颜色",focus:"聚焦",tipNameRepeat:"标签页的名称不能重复！请重新修改",noMoreSheet:"工作薄内至少含有一张可视工作表。若需删除选定的工作表，请先插入一张新工作表或显示一张隐藏的工作表。",confirmDelete:"是否删除",redoDelete:"可以通过Ctrl+Z撤销删除",noHide:"不能隐藏, 至少保留一个sheet标签",chartEditNoOpt:"图表编辑模式下不允许该操作！",sheetNameSpecCharError:"名称不能超过31个字符，首尾不能是' 且名称不能包含:\r\n[ ] : \\ ? * /",sheetNamecannotIsEmptyError:"名称不能为空!"},conditionformat:{conditionformat_greaterThan:"条件格式——大于",conditionformat_greaterThan_title:"为大于以下值的单元格设置格式",conditionformat_lessThan:"条件格式——小于",conditionformat_lessThan_title:"为小于以下值的单元格设置格式",conditionformat_between:"条件格式——介于",conditionformat_between_title:"为介于以下值的单元格设置格式",conditionformat_equal:"条件格式——等于",conditionformat_equal_title:"为等于以下值的单元格设置格式",conditionformat_textContains:"条件格式——文本包含",conditionformat_textContains_title:"为包含以下文本的单元格设置格式",conditionformat_occurrenceDate:"条件格式——发生日期",conditionformat_occurrenceDate_title:"为包含以下日期的单元格设置格式",conditionformat_duplicateValue:"条件格式——重复值",conditionformat_duplicateValue_title:"为包含以下类型值的单元格设置格式",conditionformat_top10:"条件格式——前 10 项",conditionformat_top10_percent:"条件格式——前 10%",conditionformat_top10_title:"为值最大的那些单元格设置格式",conditionformat_last10:"条件格式——最后 10 项",conditionformat_last10_percent:"条件格式——最后 10%",conditionformat_last10_title:"为值最小的那些单元格设置格式",conditionformat_aboveAverage:"条件格式——高于平均值",conditionformat_aboveAverage_title:"为高于平均值的单元格设置格式",conditionformat_belowAverage:"条件格式——低于平均值",conditionformat_belowAverage_title:"为低于平均值的单元格设置格式",rule:"规则",newRule:"新建规则",editRule:"编辑规则",deleteRule:"删除规则",deleteCellRule:"清除所选单元格的规则",deleteSheetRule:"清除整个工作表的规则",manageRules:"管理规则",showRules:"显示其格式规则",highlightCellRules:"突出显示单元格规则",itemSelectionRules:"项目选取规则",conditionformatManageRules:"条件格式规则管理器",format:"格式",setFormat:"设置格式",setAs:"设置为",setAsByArea:"针对选定区域，设置为",applyRange:"应用范围",selectRange:"点击选择应用范围",selectRange_percent:"所选范围的百分比",selectRange_average:"选定范围的平均值",selectRange_value:"选定范围中的数值",pleaseSelectRange:"请选择应用范围",selectDataRange:"点击选择数据范围",selectCell:"选择单元格",pleaseSelectCell:"请选择单元格",pleaseSelectADate:"请选择日期",pleaseEnterInteger:"请输入一个介于 1 和 1000 之间的整数",onlySingleCell:"只能对单个单元格进行引用",conditionValueCanOnly:"条件值只能是数字或者单个单元格",ruleTypeItem1:"基于各自值设置所有单元格的格式",ruleTypeItem2:"只为包含以下内容的单元格设置格式",ruleTypeItem2_title:"只为满足以下条件的单元格",ruleTypeItem3:"仅对排名靠前或靠后的数值设置格式",ruleTypeItem3_title:"为以下排名内的值",ruleTypeItem4:"仅对高于或低于平均值的数值设置格式",ruleTypeItem4_title:"为满足以下条件的值",ruleTypeItem5:"仅对唯一值或重复值设置格式",ruleTypeItem6:"使用公式确定要设置格式的单元格",formula:"公式",textColor:"文本颜色",cellColor:"单元格颜色",confirm:"确定",confirmColor:"确定颜色",cancel:"取消",close:"关闭",clearColorSelect:"清除颜色选择",sheet:"表",currentSheet:"当前工作表",dataBar:"数据条",dataBarColor:"数据条颜色",gradientDataBar_1:"蓝-白渐变数据条",gradientDataBar_2:"绿-白渐变数据条",gradientDataBar_3:"红-白渐变数据条",gradientDataBar_4:"橙-白渐变数据条",gradientDataBar_5:"浅蓝-白渐变数据条",gradientDataBar_6:"紫-白渐变数据条",solidColorDataBar_1:"蓝色数据条",solidColorDataBar_2:"绿色数据条",solidColorDataBar_3:"红色数据条",solidColorDataBar_4:"橙色数据条",solidColorDataBar_5:"浅蓝色数据条",solidColorDataBar_6:"紫色数据条",colorGradation:"色阶",colorGradation_1:"绿-黄-红色阶",colorGradation_2:"红-黄-绿色阶",colorGradation_3:"绿-白-红色阶",colorGradation_4:"红-白-绿色阶",colorGradation_5:"蓝-白-红色阶",colorGradation_6:"红-白-蓝色阶",colorGradation_7:"白-红色阶",colorGradation_8:"红-白色阶",colorGradation_9:"绿-白色阶",colorGradation_10:"白-绿色阶",colorGradation_11:"绿-黄色阶",colorGradation_12:"黄-绿色阶",icons:"图标集",pleaseSelectIcon:"请点击选择一组图标：",cellValue:"单元格值",specificText:"特定文本",occurrenceDate:"发生日期",greaterThan:"大于",lessThan:"小于",between:"介于",equal:"等于",in:"和",to:"到",between2:"之间",contain:"包含",textContains:"文本包含",duplicateValue:"重复值",uniqueValue:"唯一值",top:"前",top10:"前 10 项",top10_percent:"前 10%",last:"后",last10:"后 10 项",last10_percent:"后 10%",oneself:"个",above:"高于",aboveAverage:"高于平均值",below:"低于",belowAverage:"低于平均值",all:"全部",yesterday:"昨天",today:"今天",tomorrow:"明天",lastWeek:"上周",thisWeek:"本周",lastMonth:"上月",thisMonth:"本月",lastYear:"去年",thisYear:"本年",last7days:"最近7天",last30days:"最近30天",next7days:"未来7天",next30days:"未来30天",next60days:"未来60天",chooseRuleType:"选择规则类型",editRuleDescription:"编辑规则说明",newFormatRule:"新建格式规则",editFormatRule:"编辑格式规则",formatStyle:"格式样式",fillType:"填充类型",color:"颜色",twocolor:"双色",tricolor:"三色",multicolor:"彩色",grayColor:"灰色",gradient:"渐变",solid:"实心",maxValue:"最大值",medianValue:"中间值",minValue:"最小值",direction:"方向",threeWayArrow:"三向箭头",fourWayArrow:"四向箭头",fiveWayArrow:"五向箭头",threeTriangles:"3个三角形",shape:"形状",threeColorTrafficLight:"三色交通灯",fourColorTrafficLight:"四色交通灯",threeSigns:"三标志",greenRedBlackGradient:"绿-红-黑渐变",rimless:"无边框",bordered:"有边框",mark:"标记",threeSymbols:"三个符号",tricolorFlag:"三色旗",circled:"有圆圈",noCircle:"无圆圈",grade:"等级",grade4:"四等级",grade5:"五等级",threeStars:"3个星形",fiveQuadrantDiagram:"五象限图",fiveBoxes:"5个框"},insertLink:{linkText:"显示文本",linkType:"链接类型",linkAddress:"链接地址",linkSheet:"工作表",linkCell:"单元格范围",linkTooltip:"提示",selectCellRange:"选择单元格范围",cellRangePlaceholder:"可用鼠标框选单元格，或直接输入范围",placeholder1:"请输入网页链接地址",placeholder2:"请输入要引用的单元格，例A1",placeholder3:"请输入提示内容",tooltipInfo1:"请输入有效的链接",invalidCellRangeTip:"请输入正确的单元格范围，比如 工作表1!A1:C8",openLink:"打开链接",goTo:"跳转至 ${linkAddress}"},linkTypeList:[{text:"网页",value:"webpage"},{text:"单元格范围",value:"cellrange"},{text:"工作表",value:"sheet"}],dataVerification:{cellRange:"单元格范围",selectCellRange:"点击选择单元格范围",selectCellRange2:"请选择单元格范围",verificationCondition:"验证条件",allowMultiSelect:"是否允许多选",dropdown:"下拉列表",checkbox:"复选框",number:"数字",number_integer:"数字-整数",number_decimal:"数字-小数",text_content:"文本-内容",text_length:"文本-长度",date:"日期",validity:"有效性",placeholder1:"请输入选项，以英文逗号分隔，如1,2,3,4,5",placeholder2:"请输入内容",placeholder3:"数值，如10",placeholder4:"请输入指定的文本",placeholder5:"请输入选中单元格时显示的提示语",selected:"选择时",notSelected:"未选择",between:"介于",notBetween:"不介于",equal:"等于",notEqualTo:"不等于",moreThanThe:"大于",lessThan:"小于",greaterOrEqualTo:"大于等于",lessThanOrEqualTo:"小于等于",include:"包括",exclude:"不包括",earlierThan:"早于",noEarlierThan:"不早于",laterThan:"晚于",noLaterThan:"不晚于",identificationNumber:"身份证号码",phoneNumber:"手机号",remote:"自动远程获取选项",prohibitInput:"输入数据无效时禁止输入",hintShow:"选中单元格时显示提示语",deleteVerification:"删除验证",tooltipInfo1:"下拉列表选项不可为空",tooltipInfo2:"复选框内容不可为空",tooltipInfo3:"输入的值不是数值类型",tooltipInfo4:"数值2不能小于数值1",tooltipInfo5:"文本内容不能为空",tooltipInfo6:"输入的值不是日期类型",tooltipInfo7:"日期2不能小于日期1",textlengthInteger:"文本长度必须是大于等于0的整数"},formula:{sum:"求和",average:"平均值",count:"计数",max:"最大值",min:"最小值",ifGenerate:"if公式生成器",find:"更多函数",tipNotBelongToIf:"该单元格函数不属于if公式！",tipSelectCell:"请选择单元格插入函数",ifGenCompareValueTitle:"比较值",ifGenSelectCellTitle:"点击选择单元格",ifGenRangeTitle:"范围",ifGenRangeTo:"至",ifGenRangeEvaluate:"范围评估",ifGenSelectRangeTitle:"点击选择范围",ifGenCutWay:"划分方式",ifGenCutSame:"划分值相同",ifGenCutNpiece:"划分为N份",ifGenCutCustom:"自定义输入",ifGenCutConfirm:"生成",ifGenTipSelectCell:"选择单元格",ifGenTipSelectCellPlace:"请选择单元格",ifGenTipSelectRange:"选择单范围",ifGenTipSelectRangePlace:"请选择范围",ifGenTipNotNullValue:"比较值不能为空！",ifGenTipLableTitile:"标签",ifGenTipRangeNotforNull:"范围不能为空！",ifGenTipCutValueNotforNull:"划分值不能为空！",ifGenTipNotGenCondition:"没有生成可用的条件！"},formulaMore:{valueTitle:"值",tipSelectDataRange:"选取数据范围",tipDataRangeTile:"数据范围",findFunctionTitle:"查找函数",tipInputFunctionName:"请输入您要查找的函数名称或函数功能的简要描述",Array:"数组",Database:"数据源",Date:"日期",Engineering:"工程计算",Filter:"过滤器",Financial:"财务",luckysheet:"Luckysheet内置",other:"其它",Logical:"逻辑",Lookup:"查找",Math:"数学",Operator:"运算符",Parser:"转换工具",Statistical:"统计",Text:"文本",dataMining:"数据挖掘",selectFunctionTitle:"选择函数",calculationResult:"计算结果",tipSuccessText:"成功",tipParamErrorText:"参数类型错误",helpClose:"关闭",helpCollapse:"收起",helpExample:"示例",helpAbstract:"摘要",execfunctionError:'提示", "公式存在错误',execfunctionSelfError:"公式不可引用其本身的单元格",execfunctionSelfErrorResult:"公式不可引用其本身的单元格，会导致计算结果不准确",allowRepeatText:"可重复",allowOptionText:"可选",selectCategory:"或选择类别"},drag:{noMerge:"无法对合并单元格执行此操作",affectPivot:"无法对所选单元格进行此更改，因为它会影响数据透视表！",noMulti:"无法对多重选择区域执行此操作,请选择单个区域",noPaste:"无法在此处粘贴此内容，请选择粘贴区域的一个单元格，然后再次尝试粘贴",noPartMerge:"无法对部分合并单元格执行此操作",inputCorrect:"请输入正确的数值",notLessOne:"行列数不能小于1",offsetColumnLessZero:"偏移列不能为负数！",pasteMustKeybordAlert:"Copy and paste in the Sheet: Ctrl + C to copy, Ctrl + V to paste, Ctrl + X to cut",pasteMustKeybordAlertHTMLTitle:"Copy and paste in the Sheet",pasteMustKeybordAlertHTML:"<span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + C</span>&nbsp;&nbsp;to copy<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + V</span>&nbsp;&nbsp;to paste<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + X</span>&nbsp;&nbsp;to cut"},pivotTable:{title:"数据透视表",closePannel:"关闭",editRange:"编辑范围",tipPivotFieldSelected:"选择需要添加到数据透视表的字段",tipClearSelectedField:"清除所有已选字段",btnClearSelectedField:"清除",btnFilter:"筛选",titleRow:"行",titleColumn:"列",titleValue:"数值",tipShowColumn:"统计字段显示为列",tipShowRow:"统计字段显示为行",titleSelectionDataRange:"选取数据范围",titleDataRange:"数据范围",valueSum:"总计",valueStatisticsSUM:"求和",valueStatisticsCOUNT:"数值计数",valueStatisticsCOUNTA:"计数",valueStatisticsCOUNTUNIQUE:"去重计数",valueStatisticsAVERAGE:"平均值",valueStatisticsMAX:"最大值",valueStatisticsMIN:"最小值",valueStatisticsMEDIAN:"中位数",valueStatisticsPRODUCT:"乘积",valueStatisticsSTDEV:"标准差",valueStatisticsSTDEVP:"整体标准差",valueStatisticslet:"方差",valueStatisticsVARP:"整体方差",errorNotAllowEdit:"非编辑模式下禁止该操作！",errorNotAllowMulti:"不能对多重选择区域执行此操作，请选择单个区域，然后再试",errorSelectRange:"请选择新建透视表的区域",errorIsDamage:"此数据透视表的源数据已损坏！",errorNotAllowPivotData:"不可选择数据透视表为源数据！",errorSelectionRange:"选择失败, 输入范围错误！",errorIncreaseRange:"请扩大选择的数据范围!",titleAddColumn:"添加列到数据透视表",titleMoveColumn:"移动该列到下方白框",titleClearColumnFilter:"清除该列的筛选条件",titleFilterColumn:"筛选该列",titleSort:"排序",titleNoSort:"无排序",titleSortAsc:"升序",titleSortDesc:"降序",titleSortBy:"排序依据",titleShowSum:"显示总计",titleStasticTrue:"是",titleStasticFalse:"否"},dropCell:{copyCell:"复制单元格",sequence:"填充序列",onlyFormat:"仅填充格式",noFormat:"不带格式填充",day:"以天数填充",workDay:"以工作日填充",month:"以月填充",year:"以年填充",chineseNumber:"以中文小写数字填充"},imageCtrl:{borderTile:"图片边框颜色选择",borderCur:"当前颜色"},protection:{protectiontTitle:"保护工作表",enterPassword:"请输入密码（可留空）",enterHint:"您试图更改的单元格或图表位于受保护的工作表中。若要更改，请取消工作表保护。您可能需要输入密码",swichProtectionTip:"保护工作表及锁定的单元格内容",authorityTitle:"允许此工作表的用户进行:",selectLockedCells:"选定锁定单元格",selectunLockedCells:"选定解除锁定的单元格",formatCells:"设置单元格格式",formatColumns:"设置列格式",formatRows:"设置行格式",insertColumns:"插入列",insertRows:"插入行",insertHyperlinks:"插入超链接",deleteColumns:"删除列",deleteRows:"删除行",sort:"排序",filter:"使用自动筛选",usePivotTablereports:"使用数据透视表和报表",editObjects:"编辑对象",editScenarios:"编辑方案",allowRangeTitle:"允许用户编辑区域",allowRangeAdd:"新建...",allowRangeAddTitle:"标题",allowRangeAddSqrf:"引用单元格",selectCellRange:"点击选择单元格范围",selectCellRangeHolder:"请输入单元格范围",allowRangeAddTitlePassword:"密码",allowRangeAddTitleHint:"提示",allowRangeAddTitleHintTitle:"设置密码后，提示用户输入密码(可留空)",allowRangeAddtitleDefault:"请输入区域名称",rangeItemDblclick:"双击进行编辑",rangeItemHasPassword:"已设置密码",rangeItemErrorTitleNull:"标题不能为空",rangeItemErrorRangeNull:"单元格范围不能为空",rangeItemErrorRange:"单元格范围格式错误",validationTitle:"验证提示",validationTips:"需要输入密码来撤销工作表的保护",validationInputHint:"请输入密码",checkPasswordNullalert:"密码不能为空！",checkPasswordWrongalert:"密码错误，请重试！",checkPasswordSucceedalert:"解锁成功，可以编辑该区域!",defaultRangeHintText:"该单元格正在受密码保护。",defaultSheetHintText:"该单元格或图表位于受保护的工作表中，若要进行更改，请取消工作表保护，您可能需要输入密码。"},cellFormat:{cellFormatTitle:"设置单元格格式",protection:"保护",locked:"锁定单元格",hidden:"隐藏公式",protectionTips:"只有保护工作表功能(在菜单栏点击保护工作表按钮进行设置)开启后，锁定单元格或隐藏公式才能生效",tipsPart:"部分选中",tipsAll:"全部选中",selectionIsNullAlert:"请选择一个范围！",sheetDataIsNullAlert:"数据为空无法设置！"},print:{normalBtn:"常规视图",layoutBtn:"页面布局",pageBtn:"分页预览",menuItemPrint:"打印(Ctrl+P)",menuItemAreas:"打印区域",menuItemRows:"打印标题行",menuItemColumns:"打印标题列"},edit:{typing:"正在输入"},websocket:{success:"WebSocket连接成功",refresh:"WebSocket连接发生错误, 请刷新页面！",wait:"WebSocket连接发生错误, 请耐心等待！",close:"WebSocket连接关闭",contact:"服务器通信发生错误，请刷新页面后再试，如若不行请联系管理员！",support:"当前浏览器不支持WebSocket"}};var es={generalDialog:{partiallyError:"No se puede realizar esta operación en celdas parcialmente unidas",readOnlyError:"No se puede realizar esto en modo de solo lectura",dataNullError:"No se puede hacer esto con datos que no existen",noSeletionError:"The selection operation has not been performed yetLa operación de selección aún no se ha realizado",cannotSelectMultiple:"No se puede seleccionar la zona de selección múltiple"},functionlist:[{n:"SUMIF",t:0,d:"Returns a conditional sum across a range.",a:"A conditional sum across a range.",m:[2,3],p:[{name:"range",detail:"The range which is tested against `criterion`.",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"criterion",detail:"The pattern or test to apply to `range`.",example:'">20"',require:"m",repeat:"n",type:"rangeall"},{name:"sum_range",detail:"The range to be summed, if different from `range`.",example:"B1:B10",require:"o",repeat:"n",type:"range"}]},{n:"TAN",t:0,d:"Returns the tangent of an angle provided in radians.",a:"Tangent of an angle provided in radians.",m:[1,1],p:[{name:"angle",detail:"The angle to find the tangent of, in radians.",example:"45*PI()/180",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TANH",t:0,d:"Returns the hyperbolic tangent of any real number.",a:"Hyperbolic tangent of any real number.",m:[1,1],p:[{name:"value",detail:"Any real value to calculate the hyperbolic tangent of.",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CEILING",t:0,d:"Rounds a number up to the nearest integer multiple of specified significance `factor`.",a:"Rounds number up to nearest multiple of a factor.",m:[2,2],p:[{name:"value",detail:"The value to round up to the nearest integer multiple of `factor`.",example:"23.25",require:"m",repeat:"n",type:"rangenumber"},{name:"factor",detail:"The number to whose multiples `value` will be rounded.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ATAN",t:0,d:"Returns the inverse tangent of a value, in radians.",a:"Inverse tangent of a value, in radians.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse tangent.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ASINH",t:0,d:"Returns the inverse hyperbolic sine of a number.",a:"Inverse hyperbolic sine of a number.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse hyperbolic sine.",example:"0.9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ABS",t:0,d:"Returns the absolute value of a number.",a:"Absolute value of a number.",m:[1,1],p:[{name:"value",detail:"The number of which to return the absolute value.",example:"-2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ACOS",t:0,d:"Returns the inverse cosine of a value, in radians.",a:"Inverse cosine of a value, in radians.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse cosine. Must be between `-1` and `1`, inclusive.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ACOSH",t:0,d:"Returns the inverse hyperbolic cosine of a number.",a:"Inverse hyperbolic cosine of a number.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse hyperbolic cosine. Must be greater than or equal to `1`.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MULTINOMIAL",t:0,d:"Returns the factorial of the sum of values divided by the product of the values' factorials.",a:"Multinomial distribution function.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider.",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to consider.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"ATANH",t:0,d:"Returns the inverse hyperbolic tangent of a number.",a:"Inverse hyperbolic tangent of a number.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse hyperbolic tangent. Must be between -1 and 1, exclusive.",example:"0.9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ATAN2",t:0,d:"Returns the angle between the x-axis and a line segment from the origin (0,0) to specified coordinate pair (`x`,`y`), in radians.",a:"Arctangent of a value.",m:[2,2],p:[{name:"x",detail:"The x coordinate of the endpoint of the line segment for which to calculate the angle from the x-axis.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"y",detail:"The y coordinate of the endpoint of the line segment for which to calculate the angle from the x-axis.",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUNTBLANK",t:1,d:"Returns the number of empty values in a list of values and ranges.",a:"Number of empty values.",m:[1,1],p:[{name:"value1",detail:"The first value or range in which to count the number of blanks.",example:"A2:C100",require:"m",repeat:"n",type:"range"}]},{n:"COSH",t:0,d:"Returns the hyperbolic cosine of any real number.",a:"Hyperbolic cosine of any real number.",m:[1,1],p:[{name:"value",detail:"Any real value to calculate the hyperbolic cosine of.",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"INT",t:0,d:"Rounds a number down to the nearest integer that is less than or equal to it.",a:"Rounds number down to nearest integer.",m:[1,1],p:[{name:"value",detail:"The value to round down to the nearest integer.",example:"99.44",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ISEVEN",t:0,d:"Checks whether the provided value is even.",a:"Whether the provided value is even.",m:[1,1],p:[{name:"value",detail:"The value to be verified as even.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ISODD",t:0,d:"Checks whether the provided value is odd.",a:"Whether the provided value is odd.",m:[1,1],p:[{name:"value",detail:"The value to be verified as odd.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LCM",t:0,d:"Returns the least common multiple of one or more integers.",a:"Least common multiple of one or more integers.",m:[1,255],p:[{name:"value1",detail:"The first value or range whose factors to consider in a calculation to find the least common multiple.",example:"A2:A5",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges whose factors to consider to find the least common multiple.",example:"3",require:"o",repeat:"y",type:"rangeall"}]},{n:"LN",t:0,d:"Returns the logarithm of a number, base e (Euler's number).",a:"The logarithm of a number, base e (euler's number).",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the logarithm, base e.",example:"100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LOG",t:0,d:"Returns the logarithm of a number with respect to a base.",a:"The logarithm of a number with respect to a base.",m:[1,2],p:[{name:"value",detail:"The value for which to calculate the logarithm.",example:"128",require:"m",repeat:"n",type:"rangenumber"},{name:"base",detail:"The base to use for calculation of the logarithm.",example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"LOG10",t:0,d:"Returns the logarithm of a number, base 10.",a:"The logarithm of a number, base 10.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the logarithm, base 10.",example:"100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MOD",t:0,d:"Returns the result of the modulo operator, the remainder after a division operation.",a:"Modulo (remainder) operator.",m:[2,2],p:[{name:"dividend",detail:"The number to be divided to find the remainder.",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"divisor",detail:"The number to divide by.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MROUND",t:0,d:"Rounds one number to the nearest integer multiple of another.",a:"Rounds a number to the nearest integer multiple.",m:[2,2],p:[{name:"value",detail:"The number to round to the nearest integer multiple of another.",example:"21",require:"m",repeat:"n",type:"rangenumber"},{name:"factor",detail:"The number to whose multiples `value` will be rounded.",example:"14",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ODD",t:0,d:"Rounds a number up to the nearest odd integer.",a:"Rounds a number up to the nearest odd integer.",m:[1,1],p:[{name:"value",detail:"The value to round to the next greatest odd number.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMSQ",t:0,d:"Returns the sum of the squares of a series of numbers and/or cells.",a:"Sum of squares.",m:[1,255],p:[{name:"value1",detail:"The first number or range whose squares to add together.",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional numbers or ranges whose squares to add to the square(s) of `value1`.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"COMBIN",t:0,d:"Returns the number of ways to choose some number of objects from a pool of a given size of objects.",a:"Number of combinations from a set of objects.",m:[2,2],p:[{name:"n",detail:"The size of the pool of objects to choose from.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"k",detail:"The number of objects to choose.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUM",t:0,d:"Returns the sum of a series of numbers and/or cells.",a:"Sum of a series of numbers and/or cells.",m:[1,255],p:[{name:"value1",detail:"The first number or range to add together.",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional numbers or ranges to add to `value1`.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"SUBTOTAL",t:0,d:"Returns a subtotal for a vertical range of cells using a specified aggregation function.",a:"Subtotal for a range using a specific function.",m:[2,256],p:[{name:"function_code",detail:"The function to use in subtotal aggregation.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"range1",detail:"The first range over which to calculate a subtotal.",example:"A2:A5",require:"m",repeat:"n",type:"range"},{name:"range2",detail:"Additional ranges over which to calculate subtotals.",example:"B2:B8",require:"o",repeat:"y",type:"range"}]},{n:"ASIN",t:0,d:"Returns the inverse sine of a value, in radians.",a:"Inverse sine of a value, in radians.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse sine. Must be between `-1` and `1`, inclusive.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUNTIF",t:1,d:"Returns a conditional count across a range.",a:"A conditional count across a range.",m:[2,2],p:[{name:"range",detail:"The range that is tested against `criterion`.",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"criterion",detail:"The pattern or test to apply to `range`.",example:'">20"',require:"m",repeat:"n",type:"rangeall"}]},{n:"RADIANS",t:0,d:"Converts an angle value in degrees to radians.",a:"Converts an angle value in degrees to radians.",m:[1,1],p:[{name:"angle",detail:"The angle to convert from degrees to radians.",example:"180",require:"m",repeat:"n",type:"rangenumber"}]},{n:"RAND",t:0,d:"Returns a random number between 0 inclusive and 1 exclusive.",a:"A random number between 0 inclusive and 1 exclusive.",m:[0,0],p:[]},{n:"COUNTUNIQUE",t:0,d:"Counts the number of unique values in a list of specified values and ranges.",a:"Counts number of unique values in a range.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider for uniqueness.",example:"A1:C100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to consider for uniqueness.",example:"1",require:"o",repeat:"n",type:"rangeall"}]},{n:"DEGREES",t:0,d:"Converts an angle value in radians to degrees.",a:"Converts an angle value in radians to degrees.",m:[1,1],p:[{name:"angle",detail:"The angle to convert from radians to degrees.",example:"PI()",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ERFC",t:9,d:"Returns the complementary Gauss error function of a value.",a:"Complementary gauss error function of a value.",m:[1,1],p:[{name:"z",detail:"The number for which to calculate the complementary Gauss error function.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"EVEN",t:0,d:"Rounds a number up to the nearest even integer.",a:"Rounds a number up to the nearest even integer.",m:[1,1],p:[{name:"value",detail:"The value to round to the next greatest even number.",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"EXP",t:0,d:"Returns Euler's number, e (~2.718) raised to a power.",a:"Euler's number, e (~2.718) raised to a power.",m:[1,1],p:[{name:"exponent",detail:"The exponent to raise e to.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FACT",t:0,d:"Returns the factorial of a number.",a:"Factorial of a number.",m:[1,1],p:[{name:"value",detail:"The number or reference to a number whose factorial will be calculated and returned.",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FACTDOUBLE",t:0,d:'Returns the "double factorial" of a number.',a:'"double factorial" of a number.',m:[1,1],p:[{name:"value",detail:"The number or reference to a number whose double factorial will be calculated and returned.",example:"6",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PI",t:0,d:"Returns the value of Pi to 14 decimal places.",a:"The number pi.",m:[0,0],p:[]},{n:"FLOOR",t:0,d:"Rounds a number down to the nearest integer multiple of specified significance `factor`.",a:"Rounds number down to nearest multiple of a factor.",m:[2,2],p:[{name:"value",detail:"The value to round down to the nearest integer multiple of `factor`.",example:"23.25",require:"m",repeat:"n",type:"rangenumber"},{name:"factor",detail:"The number to whose multiples `value` will be rounded.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GCD",t:0,d:"Returns the greatest common divisor of one or more integers.",a:"Greatest common divisor of one or more integers.",m:[1,255],p:[{name:"value1",detail:"The first value or range whose factors to consider in a calculation to find the greatest common divisor.",example:"A2:A5",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges whose factors to consider to find the greatest common divisor.",example:"96",require:"o",repeat:"y",type:"rangeall"}]},{n:"RANDBETWEEN",t:0,d:"Returns a uniformly random integer between two values, inclusive.",a:"Random integer between two values, inclusive.",m:[2,2],p:[{name:"low",detail:"The low end of the random range.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"high",detail:"The high end of the random range.",example:"10",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ROUND",t:0,d:"Rounds a number to a certain number of decimal places according to standard rules.",a:"Rounds a number according to standard rules.",m:[2,2],p:[{name:"value",detail:"The value to round to `places` number of places.",example:"99.44",require:"m",repeat:"n",type:"rangenumber"},{name:"places",detail:"The number of decimal places to which to round.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ROUNDDOWN",t:0,d:"Rounds a number to a certain number of decimal places, always rounding down to the next valid increment.",a:"Rounds down a number.",m:[2,2],p:[{name:"value",detail:"The value to round to `places` number of places, always rounding down.",example:"99.44",require:"m",repeat:"n",type:"rangenumber"},{name:"places",detail:"The number of decimal places to which to round.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ROUNDUP",t:0,d:"Rounds a number to a certain number of decimal places, always rounding up to the next valid increment.",a:"Rounds up a number.",m:[2,2],p:[{name:"value",detail:"The value to round to `places` number of places, always rounding up.",example:"99.44",require:"m",repeat:"n",type:"rangenumber"},{name:"places",detail:"The number of decimal places to which to round.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SERIESSUM",t:0,d:"Given parameters `x`, `n`, `m`, and `a`, returns the power series sum a",a:"Sum of a power series.",m:[4,4],p:[{name:"x",detail:"The input to the power series. Varies depending on the type of approximation, may be angle, exponent, or some other value.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"n",detail:"The initial power to which to raise `x` in the power series.",example:"0",require:"m",repeat:"n",type:"rangenumber"},{name:"m",detail:"The additive increment by which to increase `x`.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"a",detail:"The array or range containing the coefficients of the power series.",example:"{FACT(0)",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SIGN",t:0,d:"Given an input number, returns `-1` if it is negative, `1` if positive, and `0` if it is zero.",a:"Sign of a provided number (+/-/0).",m:[1,1],p:[{name:"value",detail:"The value whose sign will be evaluated.",example:"-42",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SIN",t:0,d:"Returns the sine of an angle provided in radians.",a:"Sine of an angle provided in radians.",m:[1,1],p:[{name:"angle",detail:"The angle to find the sine of, in radians.",example:"PI()",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SINH",t:0,d:"Returns the hyperbolic sine of any real number.",a:"Hyperbolic sine of any real number.",m:[1,1],p:[{name:"value",detail:"Any real value to calculate the hyperbolic sine of.",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SQRT",t:0,d:"Returns the positive square root of a positive number.",a:"Positive square root of a positive number.",m:[1,1],p:[{name:"value",detail:"The number for which to calculate the positive square root.",example:"9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SQRTPI",t:0,d:"Returns the positive square root of the product of Pi and the given positive number.",a:"Square root of the product of pi and number.",m:[1,1],p:[{name:"value",detail:"The number which will be multiplied by Pi and have the product's square root returned",example:"9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GAMMALN",t:1,d:"Returns the logarithm of a specified Gamma function, base e (Euler's number).",a:"Logarithm of gamma function.",m:[1,1],p:[{name:"value",detail:"The input to the Gamma function. The natural logarithm of Gamma(`value`) will be returned.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COS",t:0,d:"Returns the cosine of an angle provided in radians.",a:"Cosine of an angle provided in radians.",m:[1,1],p:[{name:"angle",detail:"The angle to find the cosine of, in radians.",example:"PI()",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TRUNC",t:0,d:"Truncates a number to a certain number of significant digits by omitting less significant digits.",a:"Truncates a number.",m:[1,2],p:[{name:"value",detail:"The value to be truncated.",example:"3.141592654",require:"m",repeat:"n",type:"rangenumber"},{name:"places",detail:"The number of significant digits to the right of the decimal point to retain.",example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"QUOTIENT",t:0,d:"Returns one number divided by another.",a:"One number divided by another.",m:[2,2],p:[{name:"dividend",detail:"The number to be divided.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"divisor",detail:"The number to divide by.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"POWER",t:0,d:"Returns a number raised to a power.",a:"A number raised to a power.",m:[2,2],p:[{name:"base",detail:"The number to raise to the `exponent` power.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"exponent",detail:"The exponent to raise `base` to.",example:"0.5",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMIFS",t:0,d:"Returns the sum of a range depending on multiple criteria.",a:"Sums a range depending on multiple criteria.",m:[3,257],p:[{name:"sum_range",detail:"The range to sum.",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"criteria_range1",detail:"The range to check against criterion1.",example:" B1:B10",require:"m",repeat:"n",type:"range"},{name:"criterion1",detail:"The pattern or test to apply to criteria_range1.",example:' ">20"',require:"m",repeat:"n",type:"rangeall"},{name:"criteria_range2",detail:"Additional ranges to check.",example:" C1:C10",require:"o",repeat:"y",type:"rangeall"}]},{n:"COUNTIFS",t:1,d:"Returns the count of a range depending on multiple criteria.",a:"Count values depending on multiple criteria.",m:[2,256],p:[{name:"criteria_range1",detail:"The range to check against `criterion1`.",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"criterion1",detail:"The pattern or test to apply to `criteria_range1`.",example:' ">20"',require:"m",repeat:"n",type:"rangeall"},{name:"criteria_range2",detail:"Additional ranges to check.",example:" B1:B10",require:"o",repeat:"y",type:"rangeall"}]},{n:"PRODUCT",t:0,d:"Returns the result of multiplying a series of numbers together.",a:"Result of multiplying a series of numbers together.",m:[1,255],p:[{name:"factor1",detail:"The first number or range to calculate for the product.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"factor2",detail:"More numbers or ranges to calculate for the product.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"HARMEAN",t:1,d:"Calculates the harmonic mean of a dataset.",a:"The harmonic mean of a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the population.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the population.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"HYPGEOMDIST",t:1,d:"Calculates the probability of drawing a certain number of successes in a certain number of tries given a population of a certain size containing a certain number of successes, without replacement of draws.",a:"Hypergeometric distribution probability.",m:[5,5],p:[{name:"num_successes",detail:"The desired number of successes.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"num_draws",detail:"The number of permitted draws.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"successes_in_pop",detail:"The total number of successes in the population.",example:"20",require:"m",repeat:"n",type:"rangenumber"},{name:"pop_size",detail:"The total size of the population",example:"40",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Determine the logical value of the function form. \n\nIf cumulative is TRUE(), HYPGEOM.DIST returns the cumulative distribution function;\n\nif FALSE(), it returns the probability density function.",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"INTERCEPT",t:1,d:"Calculates the y-value at which the line resulting from linear regression of a dataset will intersect the y-axis (x=0).",a:"Y-intercept of line derived via linear regression.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"KURT",t:1,d:'Calculates the kurtosis of a dataset, which describes the shape, and in particular the "peakedness" of that dataset.',a:"Kurtosis of a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the dataset.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the dataset.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"LARGE",t:1,d:"Returns the nth largest element from a data set, where n is user-defined.",a:"Nth largest element from a data set.",m:[2,2],p:[{name:"data",detail:"Array or range containing the dataset to consider.",example:"A2:B100",require:"m",repeat:"n",type:"rangenumber"},{name:"n",detail:"The rank from largest to smallest of the element to return.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"STDEVA",t:1,d:"Calculates the standard deviation based on a sample, setting text to the value `0`.",a:"Standard deviation of sample (text as 0).",m:[1,255],p:[{name:"value1",detail:"The first value or range of the sample.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the sample.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"STDEVP",t:1,d:"Calculates the standard deviation based on an entire population.",a:"Standard deviation of an entire population.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the population.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the population.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"GEOMEAN",t:1,d:"Calculates the geometric mean of a dataset.",a:"The geometric mean of a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the population.",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to include in the population.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"RANK_EQ",t:1,d:"Returns the rank of a specified value in a dataset. If there is more than one entry of the same value in the dataset, the top rank of the entries will be returned.",a:"Top rank of a specified value in a dataset.",m:[2,3],p:[{name:"value",detail:"The value whose rank will be determined.",example:"A10",require:"m",repeat:"n",type:"rangenumber"},{name:"data",detail:"The array or range containing the dataset to consider.",example:"A1:A100",require:"m",repeat:"n",type:"range"},{name:"is_ascending",detail:"Whether to consider the values in `data` in descending or ascending order. If omitted, the default is descending (FALSE).",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"RANK_AVG",t:1,d:"Returns the rank of a specified value in a dataset. If there is more than one entry of the same value in the dataset, the average rank of the entries will be returned.",a:"Average rank of a specified value in a dataset.",m:[2,3],p:[{name:"value",detail:"The value whose rank will be determined.",example:"A10",require:"m",repeat:"n",type:"rangenumber"},{name:"data",detail:"The array or range containing the dataset to consider.",example:"A1:A100",require:"m",repeat:"n",type:"range"},{name:"is_ascending",detail:"Whether to consider the values in `data` in descending or ascending order. If omitted, the default is descending (FALSE).",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"PERCENTRANK_EXC",t:1,d:"Returns the percentage rank (percentile) from 0 to 1 exclusive of a specified value in a dataset.",a:"Percentage rank (percentile) from 0 to 1 exclusive.",m:[2,3],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A1:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value",detail:"The value whose percentage rank will be determined.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"significant_digits",detail:"The number of significant figures to use in the calculation. Default is 3.",example:"4",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PERCENTRANK_INC",t:1,d:"Returns the percentage rank (percentile) from 0 to 1 inclusive of a specified value in a dataset.",a:"Percentage rank (percentile) from 0 to 1 inclusive.",m:[2,3],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A1:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value",detail:"The value whose percentage rank will be determined.",example:" A2",require:"m",repeat:"n",type:"rangenumber"},{name:"significant_digits",detail:"The number of significant figures to use in the calculation. Default is 3.",example:"4",require:"o",repeat:"n",type:"rangenumber"}]},{n:"FORECAST",t:1,d:"Calculates the expected y-value for a specified x based on a linear regression of a dataset.",a:"Expected y-value based of linear regression.",m:[3,3],p:[{name:"x",detail:"The value on the x-axis to forecast.",example:"A1",require:"m",repeat:"n",type:"rangenumber"},{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FISHERINV",t:1,d:"Returns the inverse Fisher transformation of a specified value.",a:"Inverse fisher transformation of a specified value.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse Fisher transformation.",example:"0.962",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FISHER",t:1,d:"Returns the Fisher transformation of a specified value.",a:"Fisher transformation of a specified value.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the Fisher transformation.",example:"0.962",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MODE_SNGL",t:1,d:"Returns the most commonly occurring value in a dataset.",a:"Most commonly occurring value in a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating mode.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to consider when calculating mode.",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"WEIBULL_DIST",t:1,d:"Returns the value of the Weibull distribution function (or Weibull cumulative distribution function) for a specified shape and scale.",a:"Weibull distribution function.",m:[4,4],p:[{name:"x",detail:"The input to the Weibull distribution function.",example:"2.4",require:"m",repeat:"n",type:"rangenumber"},{name:"shape",detail:"The shape parameter of the Weibull distribution function.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"scale",detail:"The scale parameter of the Weibull distribution function.",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Whether to use the cumulative distribution function.",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"COUNT",t:1,d:"Returns the number of numeric values in a dataset.",a:"The number of numeric values in dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when counting.",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to consider when counting.",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"COUNTA",t:1,d:"Returns the number of values in a dataset.",a:"The number of values in a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when counting.",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to consider when counting.",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"AVEDEV",t:1,d:"Calculates the average of the magnitudes of deviations of data from a dataset's mean.",a:"Average magnitude of deviations from mean.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the sample.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the sample.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"AVERAGE",t:1,d:"Returns the numerical average value in a dataset, ignoring text.",a:"Numerical average value in a dataset, ignoring text.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the average value.",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to consider when calculating the average value.",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"AVERAGEA",t:1,d:"Returns the numerical average value in a dataset.",a:"Numerical average value in a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the average value.",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to consider when calculating the average value.",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"BINOM_DIST",t:1,d:"Calculates the probability of drawing a certain number of successes (or a maximum number of successes) in a certain number of tries given a population of a certain size containing a certain number of successes, with replacement of draws.",a:"Binomial distribution probability.",m:[4,4],p:[{name:"num_successes",detail:"The number of successes for which to calculate the probability in `num_trials` trials.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"num_trials",detail:"The number of independent trials.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"prob_success",detail:"The probability of success in any given trial.",example:"0.005",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Whether to use the binomial cumulative distribution.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"BINOM_INV",t:1,d:"Calculates the smallest value for which the cumulative binomial distribution is greater than or equal to a specified criteria.",a:"Inverse cumulative binomial distribution function.",m:[3,3],p:[{name:"num_trials",detail:"The number of independent trials.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"prob_success",detail:"The probability of success in any given trial.",example:"0.005",require:"m",repeat:"n",type:"rangenumber"},{name:"target_prob",detail:"The desired threshold probability.",example:"0.8",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CONFIDENCE_NORM",t:1,d:"Calculates the width of half the confidence interval for a normal distribution.",a:"Confidence interval for a normal distribution.",m:[3,3],p:[{name:"alpha",detail:"One minus the desired confidence level. E.g. `0.1` for `0.9`, or 90%, confidence.",example:"0.05",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation of the population.",example:"1.6",require:"m",repeat:"n",type:"rangenumber"},{name:"pop_size",detail:"The size of the population.",example:"250",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CORREL",t:1,d:"Calculates r, the Pearson product-moment correlation coefficient of a dataset.",a:"Pearson Product-Moment Correlation Coefficient.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COVARIANCE_P",t:1,d:"Calculates the covariance of a dataset.",a:"The covariance of a dataset.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COVARIANCE_S",t:1,d:"Calculates the sample covariance of a dataset.",a:"The sample covariance of a dataset.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DEVSQ",t:1,d:"Calculates the sum of squares of deviations based on a sample.",a:"The sum of squares of deviations based on a sample.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the sample.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the sample.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"EXPON_DIST",t:1,d:"Returns the value of the exponential distribution function with a specified lambda at a specified value.",a:"Exponential distribution function.",m:[3,3],p:[{name:"x",detail:"The input to the exponential distribution function.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"lambda",detail:"The lambda to specify the exponential distribution function.",example:"0.5",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Whether to use the exponential cumulative distribution.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"AVERAGEIF",t:1,d:"Returns the average of a range depending on criteria.",a:"Average of values depending on criteria.",m:[2,3],p:[{name:"criteria_range",detail:"The range to check against `criterion`.",example:"A1:A10",require:"m",repeat:"n",type:"rangeall"},{name:"criterion",detail:"The pattern or test to apply to `criteria_range`.",example:'">20"',require:"m",repeat:"n",type:"rangeall"},{name:"average_range",detail:"The range to average. If not included, `criteria_range` is used for the average instead.",example:"B1:B10",require:"o",repeat:"n",type:"rangeall"}]},{n:"AVERAGEIFS",t:1,d:"Returns the average of a range depending on multiple criteria.",a:"Average of values depending on multiple criteria.",m:[2,255],p:[{name:"average_range",detail:"The range to average.",example:"A1:A10",require:"m",repeat:"n",type:"rangeall"},{name:"criteria_range1",detail:"The range to check against `criterion1`.",example:" B1:B10",require:"m",repeat:"n",type:"rangeall"},{name:"criterion1",detail:"The pattern or test to apply to `criteria_range1`.",example:' ">20"',require:"m",repeat:"n",type:"rangeall"},{name:"criteria_range2",detail:"Additional ranges to check.",example:" C1:C10",require:"m",repeat:"n",type:"rangeall"}]},{n:"PERMUT",t:1,d:"Returns the number of ways to choose some number of objects from a pool of a given size of objects, considering order.",a:"Number of permutations from a number of objects.",m:[2,2],p:[{name:"n",detail:"The size of the pool of objects to choose from.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"k",detail:"The number of objects to choose.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TRIMMEAN",t:1,d:"Calculates the mean of a dataset excluding some proportion of data from the high and low ends of the dataset.",a:"Mean of a dataset excluding high/low ends.",m:[2,2],p:[{name:"data",detail:"Array or range containing the dataset to consider.",example:"A2:A100",require:"m",repeat:"n",type:"range"},{name:"exclude_proportion",detail:"The proportion of the dataset to exclude, from the extremities of the set.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PERCENTILE_EXC",t:1,d:"Returns the value at a given percentile of a dataset exclusive of 0 and 1.",a:"Value at a given percentile of a dataset exclusive of 0 and 1.",m:[2,2],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"percentile",detail:"The percentile, exclusive of 0 and 1, whose value within 'data' will be calculated and returned.",example:"0.25",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PERCENTILE_INC",t:1,d:"Returns the value at a given percentile of a dataset.",a:"Value at a given percentile of a dataset.",m:[2,2],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"percentile",detail:"The percentile whose value within `data` will be calculated and returned.`",example:"0.25",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PEARSON",t:1,d:"Calculates r, the Pearson product-moment correlation coefficient of a dataset.",a:"Pearson Product-Moment Correlation Coefficient.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NORM_S_INV",t:1,d:"Returns the value of the inverse standard normal distribution function for a specified value.",a:"Inverse standard normal distribution function.",m:[1,1],p:[{name:"x",detail:"The input to the inverse standard normal distribution function.",example:"0.75",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NORM_S_DIST",t:1,d:"Returns the value of the standard normal cumulative distribution function for a specified value.",a:"Standard normal cumulative distribution function.",m:[2,2],p:[{name:"x",detail:"The input to the standard normal cumulative distribution function.",example:"2.4",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Determine the logical value of the function form. \n\nIf TRUE(), it returns the cumulative distribution function;\n\nIf it is FALSE(), it returns the probability density function.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"NORM_INV",t:1,d:"Returns the value of the inverse normal distribution function for a specified value, mean, and standard deviation.",a:"Inverse normal distribution function.",m:[3,3],p:[{name:"x",detail:"The input to the inverse normal distribution function.",example:"0.75",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"The mean (mu) of the normal distribution function.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation (sigma) of the normal distribution function.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NORM_DIST",t:1,d:"Returns the value of the normal distribution function (or normal cumulative distribution function) for a specified value, mean, and standard deviation.",a:"Normal distribution function.",m:[4,4],p:[{name:"x",detail:"The input to the normal distribution function.",example:"2.4",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"The mean (mu) of the normal distribution function.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation (sigma) of the normal distribution function.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Whether to use the normal cumulative distribution function rather than the distribution function.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"NEGBINOM_DIST",t:1,d:"Calculates the probability of drawing a certain number of failures before a certain number of successes given a probability of success in independent trials.",a:"Negative binomial distribution probability.",m:[4,4],p:[{name:"num_failures",detail:"The number of failures to model.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"num_successes",detail:"The number of successes to model.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"prob_success",detail:"The probability of success in any given trial.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Determine the logical value of the function form. \n\nIf TRUE(), it returns the cumulative distribution function;\n\nIf it is FALSE(), it returns the probability density function.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"MINA",t:1,d:"Returns the minimum numeric value in a dataset.",a:"Minimum numeric value in a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the minimum value.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to consider when calculating the minimum value.",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MIN",t:1,d:"Returns the minimum value in a numeric dataset.",a:"Minimum value in a numeric dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the minimum value.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to consider when calculating the minimum value.",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MEDIAN",t:1,d:"Returns the median value in a numeric dataset.",a:"Median value in a numeric dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the median value.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to consider when calculating the median value.",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MAXA",t:1,d:"Returns the maximum numeric value in a dataset.",a:"Maximum numeric value in a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the maximum value.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to consider when calculating the maximum value.",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MAX",t:1,d:"Returns the maximum value in a numeric dataset.",a:"Maximum value in a numeric dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the maximum value.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to consider when calculating the maximum value.",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"LOGNORM_INV",t:1,d:"Returns the value of the inverse log-normal cumulative distribution with given mean and standard deviation at a specified value.",a:"Inverse log-normal cumulative distribution function.",m:[3,3],p:[{name:"x",detail:"The input to the inverse log-normal cumulative distribution function.",example:"0.4",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"The mean (mu) of the inverse log-normal cumulative distribution function.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation (sigma) of the inverse log-normal cumulative distribution function.",example:"6",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LOGNORM_DIST",t:1,d:"Returns the value of the log-normal cumulative distribution with given mean and standard deviation at a specified value.",a:"Log-normal cumulative distribution probability.",m:[4,4],p:[{name:"x",detail:"The input to the log-normal cumulative distribution function.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"The mean (mu) of the log-normal cumulative distribution function.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation (sigma) of the log-normal cumulative distribution function.",example:"6",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Determine the logical value of the function form. \n\nIf TRUE(), it returns the cumulative distribution function;\n\nIf it is FALSE(), it returns the probability density function.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"Z_TEST",t:1,d:"Returns the one-tailed p-value of a Z-test with standard distribution.",a:"One-tailed p-value of a z-test.",m:[2,3],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A2:A100",require:"m",repeat:"n",type:"range"},{name:"value",detail:"The test statistic to use in the Z-test.",example:"B2",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation to assume for the Z-test. If this is not provided, the standard deviation of the data will be used.",example:"3",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PROB",t:1,d:"Given a set of values and corresponding probabilities, calculates the probability that a value chosen at random falls between two limits.",a:"Probability values lie in a range.",m:[3,4],p:[{name:"data",detail:"Array or range containing the dataset to consider.",example:"A3:A6",require:"m",repeat:"n",type:"range"},{name:"probabilities",detail:"Array or range containing probabilities corresponding to `data`.",example:"2",require:"m",repeat:"n",type:"range"},{name:"low_limit",detail:"The lower bound on the value range for which to calculate the probability.",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"high_limit",detail:"The upper bound on the value range for which to calculate the probability.",example:"4",require:"o",repeat:"n",type:"rangenumber"}]},{n:"QUARTILE_EXC",t:1,d:"Returns a value nearest to a specified quartile of a dataset exclusive of 0 and 4.",a:"Value nearest to a specific quartile of a dataset exclusive of 0 and 4.",m:[2,2],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"quartile_number",detail:"Which quartile to return.",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"QUARTILE_INC",t:1,d:"Returns a value nearest to a specified quartile of a dataset.",a:"Value nearest to a specific quartile of a dataset.",m:[2,2],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"quartile_number",detail:"Which quartile value to return.",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"POISSON_DIST",t:1,d:"Returns the value of the Poisson distribution function (or Poisson cumulative distribution function) for a specified value and mean.",a:"Poisson distribution function.",m:[3,3],p:[{name:"x",detail:"The input to the Poisson distribution function.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"The mean (mu) of the Poisson distribution function.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Whether to use the Poisson cumulative distribution function rather than the distribution function.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"RSQ",t:1,d:"Calculates the square of r, the Pearson product-moment correlation coefficient of a dataset.",a:"Square of the correlation coefficient.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_DIST",t:1,d:"Calculates the left tail probability for a Student's t-distribution with a given input (x).",a:"The left-tailed Student's t-distribution",m:[3,3],p:[{name:"x",detail:"The input to the t-distribution function.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"The number of degrees of freedom.",example:"30",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"If cumulative is TRUE, T.DIST returns the cumulative distribution function; if FALSE, it returns the probability density function.",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"T_DIST_2T",t:1,d:"Calculates the probability for two tailed Student's t-distribution with a given input (x).",a:"The two tailed Student's t-distribution",m:[2,2],p:[{name:"x",detail:"The input to the t-distribution function.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"The number of degrees of freedom.",example:"30",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_DIST_RT",t:1,d:"Calculates the right tail probability for a Student's t-distribution with a given input (x).",a:"The right-tailed Student's t-distribution",m:[2,2],p:[{name:"x",detail:"The input to the t-distribution function.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"The number of degrees of freedom.",example:"30",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_INV",t:1,d:"Calculates the negative inverse of the one-tailed TDIST function.",a:"T.INV",m:[2,2],p:[{name:"probability",detail:"The probability associated with the two-tailed t-distribution.",example:"0.35",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"The number of degrees of freedom.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_INV_2T",t:1,d:"Calculates the inverse of the two-tailed TDIST function.",a:"T.INV.2T",m:[2,2],p:[{name:"probability",detail:"The probability associated with the two-tailed t-distribution.",example:"0.35",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"The number of degrees of freedom.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_TEST",t:1,d:"t-test. Returns the probability associated with Student's t-test. Determines whether two samples are likely to have come from the same two underlying populations that have the same mean.",a:"Returns the probability associated with t-test.",m:[4,4],p:[{name:"range1",detail:"The first sample of data or group of cells to consider for the t-test.",example:"A1:A4",require:"m",repeat:"n",type:"rangenumber"},{name:"range2",detail:"The second sample of data or group of cells to consider for the t-test.",example:"B1:B4",require:"m",repeat:"n",type:"rangenumber"},{name:"tails",detail:"Specifies the number of distribution tails.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"type",detail:"Specifies the type of t-test.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"F_DIST",t:1,d:"Calculates the left-tailed F probability distribution (degree of diversity) for two data sets with given input x. Alternately called Fisher-Snedecor distribution or Snedecor's F distribution.",a:"F probability distribution (left-tailed).",m:[4,4],p:[{name:"x",detail:"The input to the F probability distribution function. The value at which to evaluate the function.",example:"15.35",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom1",detail:"The numerator of the number of degrees of freedom.",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom2",detail:"The denominator of the number of degrees of freedom.",example:"6",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Logical value that determines the form of the function.",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"F_DIST_RT",t:1,d:"Calculates the right-tailed F probability distribution (degree of diversity) for two data sets with given input x. Alternately called Fisher-Snedecor distribution or Snedecor's F distribution.",a:"F probability distribution.",m:[3,3],p:[{name:"x",detail:"The input to the F probability distribution function. The value at which to evaluate the function.",example:"15.35",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom1",detail:"The numerator of the number of degrees of freedom.",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom2",detail:"The denominator of the number of degrees of freedom.",example:"6",require:"m",repeat:"n",type:"rangenumber"}]},{n:"VAR_P",t:1,d:"Calculates the variance based on an entire population.",a:"Variance of entire population.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the population.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the population.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"VAR_S",t:1,d:"Calculates the variance based on a sample.",a:"Variance.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the sample.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the sample.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"VARA",t:1,d:"Calculates the variance based on a sample, setting text to the value `0`.",a:"Variance of sample (text as 0).",m:[1,255],p:[{name:"value1",detail:"The first value or range of the sample.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the sample.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"VARPA",t:1,d:"Calculates the variance based on an entire population, setting text to the value `0`.",a:"Variance of entire population (text as 0).",m:[1,255],p:[{name:"value1",detail:"The first value or range of the population.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the population.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"STEYX",t:1,d:"Calculates the standard error of the predicted y-value for each x in the regression of a dataset.",a:"Standard error of predicted y-values in regression.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"STANDARDIZE",t:1,d:"Calculates the normalized equivalent of a random variable given mean and standard deviation of the distribution.",a:"Normalized equivalent of a random variable.",m:[3,3],p:[{name:"value",detail:"The value of the random variable to normalize.",example:"96",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"The mean of the distribution.",example:"80",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation of the distribution.",example:"6.7",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SMALL",t:1,d:"Returns the nth smallest element from a data set, where n is user-defined.",a:"Nth smallest element in a data set.",m:[2,2],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A2:B100",require:"m",repeat:"n",type:"range"},{name:"n",detail:"The rank from smallest to largest of the element to return.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SLOPE",t:1,d:"Calculates the slope of the line resulting from linear regression of a dataset.",a:"Slope of line from linear regression of data.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SKEW",t:1,d:"Calculates the skewness of a dataset, which describes the symmetry of that dataset about the mean.",a:"Skewness of a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the dataset.",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to include in the dataset.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"SKEW_P",t:1,d:"Calculates the skewness of a dataset, which describes the symmetry of that dataset about the mean. This assumes the dataset is for the population.",a:"Skewness of a population's dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the dataset.",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to include in the dataset.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"VLOOKUP",t:2,d:"Vertical lookup. Searches down the first column of a range for a key and returns the value of a specified cell in the row found.",a:"Vertical lookup.",m:[3,4],p:[{name:"search_key",detail:'The value to search for. For example, `42`, `"Cats"`, or `I24`.',example:"10003",require:"m",repeat:"n",type:"rangeall"},{name:"range",detail:"The range to consider for the search. The first column in the range is searched for the key specified in `search_key`.",example:"A2:B26",require:"m",repeat:"n",type:"rangeall"},{name:"index",detail:"The column index of the value to be returned, where the first column in `range` is numbered 1.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"is_sorted",detail:"Indicates whether the column to be searched (the first column of the specified range) is sorted, in which case the closest match for `search_key` will be returned.",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"HLOOKUP",t:2,d:"Horizontal lookup. Searches across the first row of a range for a key and returns the value of a specified cell in the column found.",a:"Horizontal lookup",m:[3,4],p:[{name:"search_key",detail:'The value to search for. For example, `42`, `"Cats"`, or `I24`.',example:"10003",require:"m",repeat:"n",type:"rangeall"},{name:"range",detail:"The range to consider for the search. The first row in the range is searched for the key specified in `search_key`.",example:"A2:Z6",require:"m",repeat:"n",type:"rangeall"},{name:"index",detail:"The row index of the value to be returned, where the first row in `range` is numbered 1.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"is_sorted",detail:"Indicates whether the row to be searched (the first row of the specified range) is sorted.",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"LOOKUP",t:2,d:"Looks through a sorted row or column for a key and returns the value of the cell in a result range located in the same position as the search row or column.",a:"Look up a value.",m:[2,3],p:[{name:"search_key",detail:'The value to search for in the row or column. For example, `42`, `"Cats"`, or `I24`.',example:"10003",require:"m",repeat:"n",type:"rangeall"},{name:"search_range|search_result_array",detail:"One method of using this function is to provide a single sorted row or column `search_range` to look through for the `search_key` with a second argument `result_range`. The other way is to combine these two arguments into one `search_result_array` where the first row or column is searched and a value is returned from the last row or column in the array. If `search_key` is not found, a non-exact match may be returned.",example:"A1:A100",require:"m",repeat:"n",type:"rangeall"},{name:"result_range",detail:"The range from which to return a result. The value returned corresponds to the location where `search_key` is found in `search_range`. This range must be only a single row or column and should not be used if using the `search_result_array` method.",example:"B1:B100",require:"o",repeat:"n",type:"rangeall"}]},{n:"ADDRESS",t:2,d:"Returns a cell reference as a string.",a:"Cell reference as a string.",m:[2,5],p:[{name:"row",detail:"The row number of the cell reference",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"column",detail:"The column number (not name) of the cell reference. `A` is column number `1`.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"absolute_relative_mode",detail:"An indicator of whether the reference is row/column absolute. `1` is row and column absolute (e.g. $A$1), `2` is row absolute and column relative (e.g. A$1), `3` is row relative and column absolute (e.g. $A1), and `4` is row and column relative (e.g. A1).",example:"4",require:"o",repeat:"n",type:"rangenumber"},{name:"use_a1_notation",detail:"A boolean indicating whether to use `A1` style notation (TRUE) or `R1C1` style notation (FALSE).",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"},{name:"sheet",detail:"Text indicating the name of the sheet into which the address points.",example:'"Sheet2"',require:"o",repeat:"n",type:"rangeall"}]},{n:"INDIRECT",t:2,d:"Returns a cell reference specified by a string.",a:"A cell reference specified by a string.",m:[1,2],p:[{name:"cell_reference_as_string",detail:"A cell reference, written as a string with surrounding quotation marks.",example:'"Sheet2!"&B10',require:"m",repeat:"n",type:"rangeall"},{name:"is_A1_notation",detail:"Indicates if the cell reference is in A1 notation (TRUE) or R1C1 notation (FALSE).",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"ROW",t:2,d:"Returns the row number of a specified cell.",a:"Row number of a specified cell.",m:[0,1],p:[{name:"cell_reference",detail:"The cell whose row number will be returned.",example:"A9",require:"o",repeat:"n",type:"rangeall"}]},{n:"ROWS",t:2,d:"Returns the number of rows in a specified array or range.",a:"Number of rows in a specified array or range.",m:[1,1],p:[{name:"range",detail:"The range whose row count will be returned.",example:"A9:A62",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COLUMN",t:2,d:"Returns the column number of a specified cell, with `A=1`.",a:"Column number of a specified cell.",m:[0,1],p:[{name:"cell_reference",detail:"The cell whose column number will be returned. Column `A` corresponds to `1`.",example:"A9",require:"o",repeat:"n",type:"rangeall"}]},{n:"COLUMNS",t:2,d:"Returns the number of columns in a specified array or range.",a:"Number of columns in a specified array or range.",m:[1,1],p:[{name:"range",detail:"The range whose column count will be returned.",example:"A9:W62",require:"m",repeat:"n",type:"rangenumber"}]},{n:"OFFSET",t:2,d:"Returns a range reference shifted a specified number of rows and columns from a starting cell reference.",a:"A range reference offset relative to a cell.",m:[3,5],p:[{name:"cell_reference",detail:"The starting point from which to count the offset rows and columns.",example:"A2",require:"m",repeat:"n",type:"range"},{name:"offset_rows",detail:"The number of rows to offset by.",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"offset_columns",detail:"The number of columns to offset by.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"height",detail:"The height of the range to return starting at the offset target.",example:"2",require:"o",repeat:"n",type:"rangenumber"},{name:"width",detail:"The width of the range to return starting at the offset target.",example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"MATCH",t:2,d:"Returns the relative position of an item in a range that matches a specified value.",a:"Position of item in range that matches value.",m:[2,3],p:[{name:"search_key",detail:'The value to search for. For example, `42`, `"Cats"`, or `I24`.',example:'"Sunday"',require:"m",repeat:"n",type:"rangeall"},{name:"range",detail:"The one-dimensional array to be searched.",example:"A2:A9",require:"m",repeat:"n",type:"range"},{name:"search_type",detail:"The search method. `1` (default) finds the largest value less than or equal to `search_key` when `range` is sorted in ascending order. `0` finds the exact value when `range` is unsorted. `-1` finds the smallest value greater than or equal to `search_key` when `range` is sorted in descending order.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"INDEX",t:2,d:"Returns the content of a cell, specified by row and column offset.",a:"Content of cell specified by row and column offset.",m:[2,3],p:[{name:"reference",detail:"The array of cells to be offset into.",example:"A1:C20",require:"m",repeat:"n",type:"range"},{name:"row",detail:"The number of offset rows.",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"column",detail:"The number of offset columns.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GETPIVOTDATA",t:2,d:"Extracts an aggregated value from a pivot table that corresponds to the specified row and column headings.",a:"Extracts an aggregated value from a pivot table that corresponds to the specified row and column headings.",m:[2,254],p:[{name:"value_name",detail:"The name of the value in the pivot table for which you want to get data.",example:'"SUM of number of units"',require:"m",repeat:"n",type:"rangeall"},{name:"any_pivot_table_cell",detail:"Any reference to a cell in the desired pivot table (top corner recommended).",example:"'Pivot table'!A1",require:"m",repeat:"n",type:"rangeall"},{name:"original_column",detail:"The name of the column in the original data set (not the pivot table).",example:'"division"',require:"o",repeat:"y",type:"rangeall"},{name:"pivot_item",detail:"The name of the row or column shown in the pivot table corresponding to *original_column* that you want to retrieve.",example:'"east"',require:"o",repeat:"y",type:"rangeall"}]},{n:"CHOOSE",t:2,d:"Returns an element from a list of choices based on index.",a:"An element from a list of choices based on index.",m:[2,255],p:[{name:"index",detail:"Which choice (of the up to 30 provided) to return.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"choice1",detail:"A potential value to return. Required. May be a reference to a cell or an individual value.",example:'"A"',require:"m",repeat:"n",type:"rangeall"},{name:"choice2",detail:"Additional values among which to choose.",example:'"B"',require:"o",repeat:"y",type:"rangeall"}]},{n:"HYPERLINK",t:2,d:"Creates a hyperlink inside a cell.",a:"Creates a hyperlink inside a cell.",p:[{name:"url",detail:"The full URL of the link location enclosed in quotation marks, or a reference to a cell containing such a URL.",example:'"http://www.luckysheet.com/"',require:"m",repeat:"n",type:"rangeall"},{name:"link_label",detail:"The text to display in the cell as the link, enclosed in quotation marks, or a reference to a cell containing such a label.",example:'"luckysheet"',require:"m",repeat:"n",type:"rangeall"}]},{n:"TIME",t:6,d:"Converts a provided hour, minute, and second into a time.",a:"Converts hour/minute/second into a time.",m:[3,3],p:[{name:"hour",detail:"The hour component of the time.",example:"11",require:"m",repeat:"n",type:"rangenumber"},{name:"minute",detail:"The minute component of the time.",example:"40",require:"m",repeat:"n",type:"rangenumber"},{name:"second",detail:"The second component of the time.",example:"59",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TIMEVALUE",t:6,d:"Returns the fraction of a 24-hour day the time represents.",a:"Converts a time string into its serial number representation.",m:[1,1],p:[{name:"time_string",detail:"The string that holds the time representation.",example:'"2:15 PM"',require:"m",repeat:"n",type:"rangeall"}]},{n:"EOMONTH",t:6,d:"Returns a date on the last day of a month that falls a specified number of months before or after another date.",a:"Last day of a month before or after a date.",m:[2,2],p:[{name:"start_date",detail:"The date from which to calculate the result.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"months",detail:"The number of months before (negative) or after (positive) 'start_date' to consider.",example:"7",require:"m",repeat:"n",type:"rangenumber"}]},{n:"EDATE",t:6,d:"Returns a date a specified number of months before or after another date.",a:"Date a number of months before/after another date.",m:[2,2],p:[{name:"start_date",detail:"The date from which to calculate the result.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"months",detail:"The number of months before (negative) or after (positive) 'start_date' to calculate.",example:"7",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SECOND",t:6,d:"Returns the second component of a specific time, in numeric format.",a:"Second component of a specific time.",m:[1,1],p:[{name:"time",detail:"The time from which to calculate the second component",example:"TIME(11",require:"m",repeat:"n",type:"rangeall"}]},{n:"MINUTE",t:6,d:"Returns the minute component of a specific time, in numeric format.",a:"Minute component of a specific time.",m:[1,1],p:[{name:"time",detail:"The time from which to calculate the minute component.",example:"TIME(11",require:"m",repeat:"n",type:"rangeall"}]},{n:"HOUR",t:6,d:"Returns the hour component of a specific time, in numeric format.",a:"Hour component of a specific time.",m:[1,1],p:[{name:"time",detail:"The time from which to calculate the hour component.",example:"TIME(11",require:"m",repeat:"n",type:"rangeall"}]},{n:"NOW",t:6,d:"Returns the current date and time as a date value.",a:"Current date and time as a date value.",m:[0,0],p:[]},{n:"NETWORKDAYS",t:6,d:"Returns the number of net working days between two provided days.",a:"Net working days between two provided days.",m:[2,3],p:[{name:"start_date",detail:"The start date of the period from which to calculate the number of net working days.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"The end date of the period from which to calculate the number of net working days.",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"holidays",detail:"A range or array constant containing the date serial numbers to consider holidays.",example:"16)",require:"o",repeat:"n",type:"rangeall"}]},{n:"NETWORKDAYS_INTL",t:6,d:"Returns the number of net working days between two provided days excluding specified weekend days and holidays.",a:"Net working days between two dates (specifying weekends).",m:[2,4],p:[{name:"start_date",detail:"The start date of the period from which to calculate the number of net working days.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"The end date of the period from which to calculate the number of net working days.",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"weekend",detail:"A number or string representing which days of the week are considered weekends.",example:"16)",require:"o",repeat:"n",type:"rangeall"},{name:"holidays",detail:"A range or array constant containing the dates to consider as holidays.",example:"DATE(1969",require:"o",repeat:"n",type:"rangeall"}]},{n:"ISOWEEKNUM",t:6,d:"Returns a number representing the ISO week of the year where the provided date falls.",a:"ISO week number of the year.",m:[1,1],p:[{name:"date",detail:"The date for which to determine the ISO week number. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"WEEKNUM",t:6,d:"Returns a number representing the week of the year where the provided date falls.",a:"Week number of the year.",m:[1,2],p:[{name:"date",detail:"The date for which to determine the week number. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"type",detail:"A number representing the day that a week starts on. Sunday = 1.",example:"7",require:"o",repeat:"n",type:"rangenumber"}]},{n:"WEEKDAY",t:6,d:"Returns a number representing the day of the week of the date provided.",a:"Day of the week of the date provided (as number).",m:[1,2],p:[{name:"date",detail:"The date for which to determine the day of the week. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"type",detail:"A number indicating which numbering system to use to represent weekdays. By default, counts starting with Sunday = 1.",example:"7",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DAY",t:6,d:"Returns the day of the month that a specific date falls on, in numeric format.",a:"Day of the month that a specific date falls on.",m:[1,1],p:[{name:"date",detail:"The date from which to extract the day.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"DAYS",t:6,d:"Returns the number of days between two dates.",a:"Number of days between two dates.",m:[2,2],p:[{name:"end_date",detail:"The end of the date range.",example:"2011-3-15",require:"m",repeat:"n",type:"rangeall"},{name:"start_date",detail:"The start of the date range.",example:"2011-2-1",require:"m",repeat:"n",type:"rangeall"}]},{n:"DAYS360",t:6,d:"Returns the difference between two days based on the 360 day year used in some financial interest calculations.",a:"Days between two dates on a 360-day year.",m:[2,3],p:[{name:"start_date",detail:"The start date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"The end date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"method",detail:"An indicator of what day count method to use.",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"DATE",t:6,d:"Converts a provided year, month, and day into a date.",a:"Converts year/month/day into a date.",m:[3,3],p:[{name:"year",detail:"The year component of the date.",example:"1969",require:"m",repeat:"n",type:"rangenumber"},{name:"month",detail:"The month component of the date.",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"day",detail:"The day component of the date.",example:"20",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DATEVALUE",t:6,d:"Converts a provided date string in a known format to a date value.",a:"Converts a date string to a date value.",m:[1,1],p:[{name:"date_string",detail:"The string representing the date.",example:'"1969-7-20"',require:"m",repeat:"n",type:"rangeall"}]},{n:"DATEDIF",t:6,d:"Calculates the number of days, months, or years between two dates.",a:"Date Difference.",m:[3,3],p:[{name:"start_date",detail:"The start date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"The end date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"unit",detail:'A string abbreviation for unit of time. For example, "M" for month. Accepted values are "Y","M","D","MD","YM","YD".',example:"16)",require:"m",repeat:"n",type:"rangeall"}]},{n:"WORKDAY",t:6,d:"Calculates the date after a number of working days from a specified start date.",a:"Number of working days from start date.",m:[2,3],p:[{name:"start_date",detail:"The date from which to begin counting.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"num_days",detail:"The number of working days to advance from `start_date`. If negative, counts backwards.",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"holidays",detail:"A range or array constant containing the dates to consider holidays.",example:"16)",require:"o",repeat:"n",type:"rangeall"}]},{n:"WORKDAY_INTL",t:6,d:"Calculates the date after a specified number of workdays excluding specified weekend days and holidays.",a:"Date after a number of workdays (specifying weekends).",m:[2,4],p:[{name:"start_date",detail:"The date from which to begin counting.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"num_days",detail:"The number of working days to advance from `start_date`. If negative, counts backwards.",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"weekend",detail:"A number or string representing which days of the week are considered weekends.",example:"16)",require:"o",repeat:"n",type:"rangeall"},{name:"holidays",detail:"A range or array constant containing the dates to consider holidays.",example:"DATE(1969",require:"o",repeat:"n",type:"rangeall"}]},{n:"YEAR",t:6,d:"Returns the year specified by a given date.",a:"Year specified by a given date.",m:[1,1],p:[{name:"date",detail:"The date from which to extract the year.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"YEARFRAC",t:6,d:"Returns the number of years, including fractional years, between two dates using a specified day count convention.",a:"Exact number of years between two dates.",m:[2,3],p:[{name:"start_date",detail:"The start date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"The end date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"16)",require:"o",repeat:"n",type:"rangenumber"}]},{n:"TODAY",t:6,d:"Returns the current date as a date value.",a:"Current date as a date value.",m:[0,0],p:[]},{n:"MONTH",t:6,d:"Returns the month of the year a specific date falls in, in numeric format.",a:"Month of the year a specific date falls in.",m:[1,1],p:[{name:"date",detail:"The date from which to extract the month.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"EFFECT",t:8,d:"Calculates the annual effective interest rate given the nominal rate and number of compounding periods per year.",a:"Annual effective interest rate.",m:[2,2],p:[{name:"nominal_rate",detail:"The nominal interest rate per year.",example:"0.99",require:"m",repeat:"n",type:"rangenumber"},{name:"periods_per_year",detail:"The number of compounding periods per year.",example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DOLLAR",t:12,d:"Formats a number into the currency specific to your spreadsheet locale.",a:"Formats a number as currency specific to your spreadsheet locale.",m:[1,2],p:[{name:"number",detail:"The value to be formatted.",example:"1.2351",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_places",detail:"The number of decimal places to display.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DOLLARDE",t:8,d:"Converts a price quotation given as a decimal fraction into a decimal value.",a:"Converts a decimal fraction to decimal value.",m:[2,2],p:[{name:"fractional_price",detail:"The price quotation given using fractional decimal conventions.",example:"100.10",require:"m",repeat:"n",type:"rangenumber"},{name:"unit",detail:"The units of the fraction, e.g. `8` for 1/8ths or `32` for 1/32nds.",example:"32",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DOLLARFR",t:8,d:"Converts a price quotation given as a decimal value into a decimal fraction.",a:"Converts a decimal value to decimal fraction.",m:[2,2],p:[{name:"decimal_price",detail:"The price quotation given as a decimal value.",example:"100.125",require:"m",repeat:"n",type:"rangenumber"},{name:"unit",detail:"The units of the desired fraction, e.g. `8` for 1/8ths or `32` for 1/32nds.",example:"32",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DB",t:8,d:"Calculates the depreciation of an asset for a specified period using the arithmetic declining balance method.",a:"Depreciation via declining balance method.",m:[4,5],p:[{name:"cost",detail:"The initial cost of the asset.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"The value of the asset at the end of depreciation.",example:"50",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"The number of periods over which the asset is depreciated.",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"The single period within `life` for which to calculate depreciation.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"month",detail:"The number of months in the first year of depreciation.",example:"10",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DDB",t:8,d:"Calculates the depreciation of an asset for a specified period using the double-declining balance method.",a:"Depreciation via double-declining balance method.",m:[4,5],p:[{name:"cost",detail:"The initial cost of the asset.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"The value of the asset at the end of depreciation.",example:"50",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"The number of periods over which the asset is depreciated.",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"The single period within `life` for which to calculate depreciation.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"factor",detail:"The factor by which depreciation decreases.",example:"2.25",require:"m",repeat:"n",type:"rangenumber"}]},{n:"RATE",t:8,d:"Calculates the interest rate of an annuity investment based on constant-amount periodic payments and the assumption of a constant interest rate.",a:"Interest rate of an annuity investment.",m:[3,6],p:[{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"payment_per_period",detail:"The amount per period to be paid.",example:"-100",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"400",require:"m",repeat:"n",type:"rangenumber"},{name:"future_value",detail:"The future value remaining after the final payment has been made.",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"rate_guess",detail:"An estimate for what the interest rate will be.",example:"0.1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"CUMPRINC",t:8,d:"Calculates the cumulative principal paid over a range of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",a:"Cumulative principal paid over a set of periods.",m:[6,6],p:[{name:"rate",detail:"The interest rate.",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"first_period",detail:"The number of the payment period to begin the cumulative calculation.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"last_period",detail:"The number of the payment period to end the cumulative calculation.",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUPNUM",t:8,d:"Calculates the number of coupons, or interest payments, between the settlement date and the maturity date of the investment.",a:"Number of coupons between settlement and maturity.",m:[3,4],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"02",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"SYD",t:8,d:"Calculates the depreciation of an asset for a specified period using the sum of years digits method.",a:"Depreciation via sum of years digits method.",m:[4,4],p:[{name:"cost",detail:"The initial cost of the asset.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"The value of the asset at the end of depreciation.",example:"50",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"The number of periods over which the asset is depreciated.",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"The single period within `life` for which to calculate depreciation.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TBILLEQ",t:8,d:"Calculates the equivalent annualized rate of return of a US Treasury Bill based on discount rate.",a:"Equivalent rate of return for a Treasury bill.",m:[3,3],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"discount",detail:"The discount rate of the bill at time of purchase.",example:"2)",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TBILLYIELD",t:8,d:"Calculates the yield of a US Treasury Bill based on price.",a:"The yield of a us treasury bill based on price.",m:[3,3],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"price",detail:"The price at which the security is bought per 100 face value.",example:"95",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TBILLPRICE",t:8,d:"Calculates the price of a US Treasury Bill based on discount rate.",a:"Price of US treasury bill.",m:[3,3],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"discount",detail:"The discount rate of the bill at time of purchase.",example:"0.09",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PV",t:8,d:"Calculates the present value of an annuity investment based on constant-amount periodic payments and a constant interest rate.",a:"Present value of an annuity investment.",m:[3,5],p:[{name:"rate",detail:"The interest rate.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"payment_amount",detail:"The amount per period to be paid.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"future_value",detail:"The future value remaining after the final payment has been made.",example:"D2",require:"o",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"ACCRINT",t:8,d:"Calculates the accrued interest of a security that has periodic payments.",a:"Accrued interest of security with periodic payments.",m:[6,8],p:[{name:"issue",detail:"The date the security was initially issued.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"first_payment",detail:"The first date interest will be paid.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"10000",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"calc_method",detail:"[Optional-defaults to TRUE()] - A logical value that specifies the method used to calculate the total accrued interest when the settlement date is later than the first interest accrual date. \n\nIf the value is TRUE, the total accrued interest from the issue date to the settlement date is returned. \n\nIf the value is FALSE, return the accrued interest from the first interest accrual date to the settlement date.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"ACCRINTM",t:8,d:"Calculates the accrued interest of a security that pays interest at maturity.",a:"Accrued interest of security paying at maturity.",m:[4,5],p:[{name:"issue",detail:"The date the security was initially issued.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity date of the security.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"1000",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUPDAYBS",t:8,d:"Calculates the number of days from the first coupon, or interest payment, until settlement.",a:"Number of days from first coupon to settlement.",m:[3,4],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPDAYS",t:8,d:"Calculates the number of days in the coupon, or interest payment, period that contains the specified settlement date.",a:"Days in coupon period containing settlement date.",m:[3,4],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPDAYSNC",t:8,d:"Calculates the number of days from the settlement date until the next coupon, or interest payment.",a:"Days from settlement until next coupon.",m:[3,4],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPNCD",t:8,d:"Calculates next coupon, or interest payment, date after the settlement date.",a:"Next coupon date after the settlement date.",m:[3,4],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"01)",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"DATE(2019",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPPCD",t:8,d:"Calculates last coupon, or interest payment, date before the settlement date.",a:"Last coupon date before settlement date.",m:[3,4],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"01)",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"DATE(2019",require:"o",repeat:"n",type:"rangenumber"}]},{n:"FV",t:8,d:"Calculates the future value of an annuity investment based on constant-amount periodic payments and a constant interest rate.",a:"Future value of an annuity investment.",m:[3,5],p:[{name:"rate",detail:"The interest rate.",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"payment_amount",detail:"The amount per period to be paid.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"400",require:"m",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FVSCHEDULE",t:8,d:"Calculates the future value of some principal based on a specified series of potentially varying interest rates.",a:"Future value of principal from series of rates.",m:[2,2],p:[{name:"principal",detail:"The amount of initial capital or value to compound against.",example:"10000",require:"m",repeat:"n",type:"rangenumber"},{name:"rate_schedule",detail:"A series of interest rates to compound against the `principal`.",example:"A2:A100",require:"m",repeat:"n",type:"range"}]},{n:"YIELD",t:8,d:"Calculates the annual yield of a security paying periodic interest, such as a US Treasury Bond, based on price.",a:"Annual yield of a security paying periodic interest.",m:[6,7],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.057",require:"m",repeat:"n",type:"rangenumber"},{name:"price",detail:"The price at which the security is bought per 100 face value.",example:"95",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"YIELDDISC",t:8,d:"Calculates the annual yield of a discount (non-interest-bearing) security, based on price.",a:"Annual yield of a discount security.",m:[4,5],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"price",detail:"The price at which the security is bought per 100 face value.",example:"95",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NOMINAL",t:8,d:"Calculates the annual nominal interest rate given the effective rate and number of compounding periods per year.",a:"Annual nominal interest rate.",m:[2,2],p:[{name:"effective_rate",detail:"The effective interest rate per year.",example:"0.85",require:"m",repeat:"n",type:"rangenumber"},{name:"periods_per_year",detail:"The number of compounding periods per year.",example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"XIRR",t:8,d:"Calculates the internal rate of return of an investment based on a specified series of potentially irregularly spaced cash flows.",a:"Internal rate of return given non-periodic cashflows.",m:[2,3],p:[{name:"cashflow_amounts",detail:"An array or range containing the income or payments associated with the investment.",example:"B2:B25",require:"m",repeat:"n",type:"range"},{name:"cashflow_dates",detail:"An array or range with dates corresponding to the cash flows in `cashflow_amounts`.",example:"C2:C25",require:"m",repeat:"n",type:"range"},{name:"rate_guess",detail:"An estimate for what the internal rate of return will be.",example:"250",require:"o",repeat:"n",type:"rangenumber"}]},{n:"MIRR",t:8,d:"Calculates the modified internal rate of return on an investment based on a series of periodic cash flows and the difference between the interest rate paid on financing versus the return received on reinvested income.",a:"Modified internal rate of return.",m:[3,3],p:[{name:"cashflow_amounts",detail:"An array or range containing the income or payments associated with the investment.",example:"A2:A25",require:"m",repeat:"n",type:"range"},{name:"financing_rate",detail:"The interest rate paid on funds invested.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"reinvestment_return_rate",detail:"The return (as a percentage) earned on reinvestment of income received from the investment.",example:"0.12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"IRR",t:8,d:"Calculates the internal rate of return on an investment based on a series of periodic cash flows.",a:"Internal rate of return given periodic cashflows.",m:[1,2],p:[{name:"cashflow_amounts",detail:"An array or range containing the income or payments associated with the investment.",example:"A2:A25",require:"m",repeat:"n",type:"range"},{name:"rate_guess",detail:"An estimate for what the internal rate of return will be.",example:"200",require:"o",repeat:"n",type:"rangenumber"}]},{n:"NPV",t:8,d:"Calculates the net present value of an investment based on a series of periodic cash flows and a discount rate.",a:"The net present value of an investment based on a series of periodic cash flows and a discount rate.",m:[2,255],p:[{name:"discount",detail:"The discount rate of the investment over one period.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"cashflow1",detail:"The first future cash flow.",example:"200",require:"m",repeat:"n",type:"rangeall"},{name:"cashflow2",detail:"Additional future cash flows.",example:"250",require:"o",repeat:"y",type:"rangeall"}]},{n:"XNPV",t:8,d:"Calculates the net present value of an investment based on a specified series of potentially irregularly spaced cash flows and a discount rate.",a:"Net present value given non-periodic cashflows.",m:[3,3],p:[{name:"discount",detail:"The discount rate of the investment over one period.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"cashflow_amounts",detail:"A range of cells containing the income or payments associated with the investment.",example:"B2:B25",require:"m",repeat:"n",type:"range"},{name:"cashflow_dates",detail:"A range of cells with dates corresponding to the cash flows in `cashflow_amounts`.",example:"C2:C25",require:"m",repeat:"n",type:"range"}]},{n:"CUMIPMT",t:8,d:"Calculates the cumulative interest over a range of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",a:"Cumulative interest paid over a set of periods.",m:[6,6],p:[{name:"rate",detail:"The interest rate.",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"first_period",detail:"The number of the payment period to begin the cumulative calculation.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"last_period",detail:"The number of the payment period to end the cumulative calculation.",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PMT",t:8,d:"Calculates the periodic payment for an annuity investment based on constant-amount periodic payments and a constant interest rate.",a:"Periodic payment for an annuity investment.",m:[3,5],p:[{name:"rate",detail:"The interest rate.",example:"0.08",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:" 100000",require:"m",repeat:"n",type:"rangenumber"},{name:"future_value",detail:"The future value remaining after the final payment has been made.",example:"D2",require:"m",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"IPMT",t:8,d:"Calculates the payment on interest for an investment based on constant-amount periodic payments and a constant interest rate.",a:"Payment on interest for an investment.",m:[4,6],p:[{name:"rate",detail:"The interest rate.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"The amortization period, in terms of number of periods.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"80000",require:"m",repeat:"n",type:"rangenumber"},{name:"future_value",detail:"The future value remaining after the final payment has been made.",example:"E2",require:"m",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PPMT",t:8,d:"Calculates the payment on the principal of an investment based on constant-amount periodic payments and a constant interest rate.",a:"Payment on the principal of an investment.",m:[4,6],p:[{name:"rate",detail:"The interest rate.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"The amortization period, in terms of number of periods.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"3*12",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"100000",require:"m",repeat:"n",type:"rangenumber"},{name:"future_value",detail:"The future value remaining after the final payment has been made.",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"INTRATE",t:8,d:"Calculates the effective interest rate generated when an investment is purchased at one price and sold at another with no interest or dividends generated by the investment itself.",a:"Calculates effective interest rate.",m:[4,5],p:[{name:"buy_date",detail:"The date of purchase of the investment.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"sell_date",detail:"The date of sale of the investment.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"buy_price",detail:"The price at which the investment was purchased.",example:"100000",require:"m",repeat:"n",type:"rangenumber"},{name:"sell_price",detail:"The price at which the investment was sold.",example:"101200",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PRICE",t:8,d:"Calculates the price of a security paying periodic interest, such as a US Treasury Bond, based on expected yield.",a:"Price of a security paying periodic interest.",m:[6,7],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.057",require:"m",repeat:"n",type:"rangenumber"},{name:"yield",detail:"The expected annual yield of the security.",example:"0.065",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PRICEDISC",t:8,d:"Calculates the price of a discount (non-interest-bearing) security, based on expected yield.",a:"Price of a discount security.",m:[4,5],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"discount",detail:"The discount rate of the security at time of purchase.",example:"0.0525",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PRICEMAT",t:8,d:"Calculates the price of a security paying interest at maturity, based on expected yield.",a:"Price of security paying interest at maturity.",m:[5,6],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"issue",detail:"The date the security was initially issued.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.061",require:"m",repeat:"n",type:"rangenumber"},{name:"yield",detail:"The expected annual yield of the security.",example:"0.061",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"RECEIVED",t:8,d:"Calculates the amount received at maturity for an investment in fixed-income securities purchased on a given date.",a:"Amount received at maturity for a security.",m:[4,5],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"investment",detail:"The amount invested (irrespective of face value of each security).",example:"10000000",require:"m",repeat:"n",type:"rangenumber"},{name:"discount",detail:"The discount rate of the security invested in.",example:"0.0575",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"12",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DISC",t:8,d:"Calculates the discount rate of a security based on price.",a:"The discount rate of a security based on price.",m:[4,5],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"price",detail:"The price at which the security is bought per 100 face value.",example:"97.975",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"12",require:"o",repeat:"n",type:"rangenumber"}]},{n:"NPER",t:8,d:"Calculates the number of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",a:"Number of payment periods for an investment.",m:[3,5],p:[{name:"rate",detail:"The interest rate.",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"payment_amount",detail:"The amount of each payment made.",example:"500",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"40000",require:"m",repeat:"n",type:"rangenumber"},{name:"future_value",detail:"The future value remaining after the final payment has been made.",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"SLN",t:8,d:"Calculates the depreciation of an asset for one period using the straight-line method.",a:"Depreciation of asset using the straight-line method.",m:[3,3],p:[{name:"cost",detail:"The initial cost of the asset.",example:"300000",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"The value of the asset at the end of depreciation.",example:"75000",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"The number of periods over which the asset is depreciated.",example:"10",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DURATION",t:8,d:"Calculates the number of compounding periods required for an investment of a specified present value appreciating at a given rate to reach a target value.",a:"Number of periods for an investment to reach a value.",m:[5,6],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.08",require:"m",repeat:"n",type:"rangenumber"},{name:"yield",detail:"The expected annual yield of the security.",example:"0.09",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"MDURATION",t:8,d:"Calculates the modified Macaulay duration of a security paying periodic interest, such as a US Treasury Bond, based on expected yield.",a:"Modified Macaulay duration.",m:[5,6],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.08",require:"m",repeat:"n",type:"rangenumber"},{name:"yield",detail:"The expected annual yield of the security.",example:"0.09",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"BIN2DEC",t:9,d:"Converts a signed binary number to decimal format.",a:"Converts a signed binary number to decimal format.",m:[1,1],p:[{name:"signed_binary_number",detail:"The signed 10-bit binary value to be converted to decimal, provided as a string.",example:"101",require:"m",repeat:"n",type:"rangeall"}]},{n:"BIN2HEX",t:9,d:"Converts a signed binary number to signed hexadecimal format.",a:"Converts a binary number to hexadecimal.",m:[1,2],p:[{name:"signed_binary_number",detail:"The signed 10-bit binary value to be converted to signed hexademical, provided as a string.",example:"101",require:"m",repeat:"n",type:"rangeall"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"BIN2OCT",t:9,d:"Converts a signed binary number to signed octal format.",a:"Converts a binary number to octal.",m:[1,2],p:[{name:"signed_binary_number",detail:"The signed 10-bit binary value to be converted to signed octal, provided as a string.",example:"101",require:"m",repeat:"n",type:"rangeall"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DEC2BIN",t:9,d:"Converts a decimal number to signed binary format.",a:"Converts a decimal number to signed binary format.",m:[1,2],p:[{name:"decimal_number",detail:"The decimal value to be converted to signed binary, provided as a string.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DEC2HEX",t:9,d:"Converts a decimal number to signed hexadecimal format.",a:"Converts a decimal number to hexadecimal.",m:[1,2],p:[{name:"decimal_number",detail:"The decimal value to be converted to signed hexadecimal, provided as a string.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DEC2OCT",t:9,d:"Converts a decimal number to signed octal format.",a:"Converts a decimal number to signed octal format.",m:[1,2],p:[{name:"decimal_number",detail:"The decimal value to be converted to signed octal, provided as a string.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"HEX2BIN",t:9,d:"Converts a signed hexadecimal number to signed binary format.",a:"Converts a hexadecimal number to binary.",m:[1,2],p:[{name:"signed_hexadecimal_number",detail:"The signed 40-bit hexadecimal value to be converted to signed binary, provided as a string.",example:'"f3"',require:"m",repeat:"n",type:"rangeall"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"HEX2DEC",t:9,d:"Converts a signed hexadecimal number to decimal format.",a:"Converts a hexadecimal number to decimal.",m:[1,1],p:[{name:"signed_hexadecimal_number",detail:"The signed 40-bit hexadecimal value to be converted to decimal, provided as a string.",example:'"f3"',require:"m",repeat:"n",type:"rangeall"}]},{n:"HEX2OCT",t:9,d:"Converts a signed hexadecimal number to signed octal format.",a:"Converts a hexadecimal number to octal.",m:[1,2],p:[{name:"signed_hexadecimal_number",detail:"The signed 40-bit hexadecimal value to be converted to signed octal, provided as a string.",example:'"f3"',require:"m",repeat:"n",type:"rangeall"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"OCT2BIN",t:9,d:"Converts a signed octal number to signed binary format.",a:"Converts an octal number to binary.",m:[1,2],p:[{name:"signed_octal_number",detail:"The signed 30-bit octal value to be converted to signed binary, provided as a string.",example:"37",require:"m",repeat:"n",type:"rangeall"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"OCT2DEC",t:9,d:"Converts a signed octal number to decimal format.",a:"Converts a signed octal number to decimal format.",m:[1,1],p:[{name:"signed_octal_number",detail:"The signed 30-bit octal value to be converted to decimal, provided as a string.",example:"37",require:"m",repeat:"n",type:"rangeall"}]},{n:"OCT2HEX",t:9,d:"Converts a signed octal number to signed hexadecimal format.",a:"Converts an octal number to hexadecimal.",m:[1,2],p:[{name:"signed_octal_number",detail:"The signed 30-bit octal value to be converted to signed hexadecimal, provided as a string.",example:"37",require:"m",repeat:"n",type:"rangeall"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COMPLEX",t:9,d:"Creates a complex number given real and imaginary coefficients.",a:"Creates a complex number.",m:[2,3],p:[{name:"real_part",detail:"The real coefficient.",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"imaginary_part",detail:"The imaginary coefficient.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"suffix",detail:"The suffix for the imaginary coefficient, can only be 'i' or 'j'. If omitted, 'i' will be used.",example:'"j"',require:"o",repeat:"n",type:"rangestring"}]},{n:"IMREAL",t:9,d:"Returns the real coefficient of a complex number.",a:"The real coefficient of a complex number.",m:[1,1],p:[{name:"complex_number",detail:"The complex number, in the a+bi or a+bj format.",example:'"4+5i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMAGINARY",t:9,d:"Returns the imaginary coefficient of a complex number.",a:"The imaginary coefficient of a complex number.",m:[1,1],p:[{name:"complex_number",detail:"The complex number, in the a+bi or a+bj format.",example:'"4+5i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMCONJUGATE",t:9,d:"Returns the complex conjugate of a number.",a:"The complex conjugate of a number.",m:[1,1],p:[{name:"number",detail:"The complex number to calculate the conjugate for.",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMABS",t:9,d:"Returns absolute value (or modulus) of a complex number.",a:"The absolute value of a complex number.",m:[1,1],p:[{name:"number",detail:"The complex number to calculate the absolute value of.",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"DELTA",t:9,d:"Compare two numeric values, returning 1 if they're equal.",a:"Compare two numeric values.",m:[1,2],p:[{name:"number1",detail:"The first number to compare.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"number2",detail:"The second number to compare.",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"IMSUM",t:9,d:"Returns the sum of a series of complex numbers.",a:"Sum of a series of complex numbers.",m:[1,255],p:[{name:"value1",detail:"The first complex number or range to add together.",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional complex numbers or ranges to add to `value1`.",example:'"5-3i"',require:"o",repeat:"y",type:"rangeall"}]},{n:"IMSUB",t:9,d:"Returns the difference between two complex numbers.",a:"The difference between two complex numbers.",m:[2,2],p:[{name:"first_number",detail:"The complex number to subtract second_number from.",example:'"6+5i"',require:"m",repeat:"n",type:"rangeall"},{name:"second_number",detail:"The complex number to subtract from first_number.",example:'"2+3i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMPRODUCT",t:9,d:"Returns the result of multiplying a series of complex numbers together.",a:"Result of multiplying a series of complex numbers together.",m:[1,255],p:[{name:"factor1",detail:"The first number or range to calculate for the product.",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"},{name:"factor2",detail:"Additional complex numbers or ranges to calculate for the product.",example:'"5-3i"',require:"o",repeat:"y",type:"rangeall"}]},{n:"IMDIV",t:9,d:"Returns one complex number divided by another.",a:"One complex number divided by another.",m:[2,2],p:[{name:"dividend",detail:"The complex number to be divided.",example:'"11+16i"',require:"m",repeat:"n",type:"rangeall"},{name:"divisor",detail:"The complex number to divide by.",example:'"3+2i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"NOT",t:10,d:"Returns the opposite of a logical value - `NOT(TRUE)` returns `FALSE`; `NOT(FALSE)` returns `TRUE`.",a:"Returns opposite of provided logical value.",m:[1,1],p:[{name:"logical_expression",detail:"An expression or reference to a cell holding an expression that represents some logical value.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"TRUE",t:10,d:"Returns the logical value `TRUE`.",a:"Logical value `true`.",m:[0,0],p:[]},{n:"FALSE",t:10,d:"Returns the logical value `FALSE`.",a:"Logical value `false`.",m:[0,0],p:[]},{n:"AND",t:10,d:"Returns true if all of the provided arguments are logically true, and false if any of the provided arguments are logically false.",a:"Logical `and` operator.",m:[1,255],p:[{name:"logical_expression1",detail:"An expression or reference to a cell containing an expression that represents some logical value, i.e. `TRUE` or `FALSE`, or an expression that can be coerced to a logical value.",example:'A2 = "foo"',require:"m",repeat:"n",type:"rangeall"},{name:"logical_expression2",detail:"More expressions that represent logical values.",example:'A3 = "bar"',require:"o",repeat:"y",type:"rangeall"}]},{n:"IFERROR",t:10,d:"Returns the first argument if it is not an error value, otherwise returns the second argument if present, or a blank if the second argument is absent.",a:"Value if it is not an error, otherwise 2nd argument.",m:[2,2],p:[{name:"value",detail:"The value to return if `value` itself is not an error.",example:"A1",require:"m",repeat:"n",type:"rangeall"},{name:"value_if_error",detail:"The value the function returns if `value` is an error.",example:'"Error in cell A1"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IF",t:10,d:"Returns one value if a logical expression is `TRUE` and another if it is `FALSE`.",a:"Returns value depending on logical expression.",m:[2,3],p:[{name:"logical_expression",detail:"An expression or reference to a cell containing an expression that represents some logical value, i.e. `TRUE` or `FALSE`.",example:'A2 = "foo"',require:"m",repeat:"n",type:"rangeall"},{name:"value_if_true",detail:"The value the function returns if `logical_expression` is `TRUE`.",example:'"A2 is foo"',require:"m",repeat:"n",type:"rangeall"},{name:"value_if_false",detail:"The value the function returns if `logical_expression` is `FALSE`.",example:'"A2 was false"',require:"o",repeat:"n",type:"rangeall"}]},{n:"OR",t:10,d:"Returns true if any of the provided arguments are logically true, and false if all of the provided arguments are logically false.",a:"Logical `or` operator.",m:[1,255],p:[{name:"logical_expression1",detail:"An expression or reference to a cell containing an expression that represents some logical value, i.e. `TRUE` or `FALSE`, or an expression that can be coerced to a logical value.",example:'A2 = "foo"',require:"m",repeat:"n",type:"rangeall"},{name:"logical_expression2",detail:"More expressions that evaluate to logical values.",example:' A3 = "bar"',require:"m",repeat:"n",type:"rangeall"}]},{n:"NE",t:11,d:"Returns `TRUE` if two specified values are not equal and `FALSE` otherwise. Equivalent to the `!=` operator.",a:"Not equal.",m:[2,2],p:[{name:"value1",detail:"The first value.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The value to test against `value1` for inequality.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"EQ",t:11,d:"Returns `TRUE` if two specified values are equal and `FALSE` otherwise. Equivalent to the `==` operator.",a:"Equal.",m:[2,2],p:[{name:"value1",detail:"The first value.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The value to test against `value1` for equality.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"GT",t:11,d:"Returns `TRUE` if the first argument is strictly greater than the second, and `FALSE` otherwise. Equivalent to the `>` operator.",a:"Strictly greater than.",m:[2,2],p:[{name:"value1",detail:"The value to test as being greater than `value2`.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The second value.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"GTE",t:11,d:"Returns `TRUE` if the first argument is greater than or equal to the second, and `FALSE` otherwise. Equivalent to the `>=` operator.",a:"Greater than or equal to.",m:[2,2],p:[{name:"value1",detail:"The value to test as being greater than or equal to `value2`.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The second value.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"LT",t:11,d:"Returns `TRUE` if the first argument is strictly less than the second, and `FALSE` otherwise. Equivalent to the `<` operator.",a:"Less than.",m:[2,2],p:[{name:"value1",detail:"The value to test as being less than `value2`.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The second value.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"LTE",t:11,d:"Returns `TRUE` if the first argument is less than or equal to the second, and `FALSE` otherwise. Equivalent to the `<=` operator.",a:"Less than or equal to.",m:[2,2],p:[{name:"value1",detail:"The value to test as being less than or equal to `value2`.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The second value.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"ADD",t:11,d:"Returns the sum of two numbers. Equivalent to the `+` operator.",a:"Sum of two numbers",m:[2,2],p:[{name:"value1",detail:"The first addend.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"The second addend.",example:"A3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MINUS",t:11,d:"Returns the difference of two numbers. Equivalent to the `-` operator.",a:"Difference of two numbers",m:[2,2],p:[{name:"value1",detail:"The minuend, or number to be subtracted from.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"The subtrahend, or number to subtract from `value1`.",example:"A3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MULTIPLY",t:11,d:"Returns the product of two numbers. Equivalent to the `*` operator.",a:"Product of two numbers",m:[2,2],p:[{name:"factor1",detail:"The first multiplicand.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"factor2",detail:"The second multiplicand.",example:"B2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DIVIDE",t:11,d:"Returns one number divided by another. Equivalent to the `/` operator.",a:"One number divided by another",m:[2,2],p:[{name:"dividend",detail:"The number to be divided.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"divisor",detail:"The number to divide by.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CONCAT",t:11,d:"Returns the concatenation of two values. Equivalent to the `&` operator.",a:"Concatenation of two values",m:[2,2],p:[{name:"value1",detail:"The value to which `value2` will be appended.",example:'"de"',require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The value to append to `value1`.",example:'"mystify"',require:"m",repeat:"n",type:"rangeall"}]},{n:"UNARY_PERCENT",t:11,d:"Returns a value interpreted as a percentage; that is, `UNARY_PERCENT(100)` equals `1`.",a:"Value interpreted as a percentage.",m:[1,1],p:[{name:"percentage",detail:"The value to interpret as a percentage.",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CONCATENATE",t:12,d:"Appends strings to one another.",a:"Appends strings to one another.",m:[1,255],p:[{name:"string1",detail:"The initial string.",example:'"Super"',require:"m",repeat:"n",type:"rangeall"},{name:"string2",detail:"More strings to append in sequence.",example:'"calla"',require:"o",repeat:"y",type:"rangeall"}]},{n:"CODE",t:12,d:"Returns the numeric Unicode map value of the first character in the string provided.",a:"Numeric unicode map value of character.",m:[1,1],p:[{name:"string",detail:"The string whose first character's Unicode map value will be returned.",example:'"a"',require:"m",repeat:"n",type:"rangeall"}]},{n:"CHAR",t:12,d:"Convert a number into a character according to the current Unicode table.",a:"Gets character associated with number.",m:[1,1],p:[{name:"table_number",detail:"The number of the character to look up from the current Unicode table in decimal format.",example:"97",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ARABIC",t:12,d:"Computes the value of a Roman numeral.",a:"Computes the value of a roman numeral.",m:[1,1],p:[{name:"roman_numeral",detail:"The Roman numeral to format, whose value must be between 1 and 3999, inclusive.",example:'"XIV"',require:"m",repeat:"n",type:"rangeall"}]},{n:"ROMAN",t:12,d:"Formats a number in Roman numerals.",a:"Formats a number in Roman numerals.",m:[1,1],p:[{name:"number",detail:"The number to format, between 1 and 3999, inclusive.",example:"499",require:"m",repeat:"n",type:"rangenumber"}]},{n:"REGEXEXTRACT",t:12,d:"Extracts matching substrings according to a regular expression.",a:"Extracts matching substrings with regular expression.",m:[2,2],p:[{name:"text",detail:"The input text.",example:'"Needle in a haystack"',require:"m",repeat:"n",type:"rangeall"},{name:"regular_expression",detail:"The first part of `text` that matches this expression will be returned.",example:'".e{2}dle"',require:"m",repeat:"n",type:"rangeall"}]},{n:"REGEXMATCH",t:12,d:"Whether a piece of text matches a regular expression.",a:"Whether a piece of text matches regular expression.",m:[2,2],p:[{name:"text",detail:"The text to be tested against the regular expression.",example:'"Spreadsheets"',require:"m",repeat:"n",type:"rangeall"},{name:"regular_expression",detail:"The regular expression to test the text against.",example:'"S.r"',require:"m",repeat:"n",type:"rangeall"}]},{n:"REGEXREPLACE",t:12,d:"Replaces part of a text string with a different text string using regular expressions.",a:"Replaces text with regular expressions.",m:[3,3],p:[{name:"text",detail:"The text, a part of which will be replaced.",example:'"Spreadsheets"',require:"m",repeat:"n",type:"rangeall"},{name:"regular_expression",detail:"The regular expression.  All matching instances in `text` will be replaced.",example:'"S.*d"',require:"m",repeat:"n",type:"rangeall"},{name:"replacement",detail:"The text which will be inserted into the original text.",example:'"Bed"',require:"m",repeat:"n",type:"rangeall"}]},{n:"T",t:12,d:"Returns string arguments as text, or the empty string if the value is not text.",a:"String arguments as text.",m:[1,1],p:[{name:"value",detail:"The argument to be converted to text.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"FIXED",t:12,d:"Formats a number with a fixed number of decimal places.",a:"Formats number with fixed number of decimal places.",m:[1,3],p:[{name:"number",detail:"The number to format.",example:"3.141592653",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_places",detail:"The number of decimal places to display in the result.",example:"2",require:"o",repeat:"n",type:"rangenumber"},{name:"suppress_separator",detail:"Whether or not to suppress the thousands separator used in some locales (e.g. `1,000` becomes `1000`). Separators will be present if this value is 0 or omitted, and absent otherwise.",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"FIND",t:12,d:"Returns the position at which a string is first found within text where the capitalization of letters matters. Returns `#VALUE!` if the string is not found.",a:"First position of string found in text, case-sensitive.",m:[2,3],p:[{name:"search_for",detail:"The string to look for within `text_to_search`.",example:'"n"',require:"m",repeat:"n",type:"rangeall"},{name:"text_to_search",detail:"The text to search for the first occurrence of `search_for`.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"starting_at",detail:"The character within `text_to_search` at which to start the search.",example:"14",require:"o",repeat:"n",type:"rangenumber"}]},{n:"FINDB",t:12,d:"Returns the position at which a string is first found within text counting each double-character as 2.",a:"Position at which a string is first found within text (binary).",m:[2,3],p:[{name:"search_for",detail:"The string to look for within `text_to_search`.",example:'"new"',require:"m",repeat:"n",type:"rangeall"},{name:"text_to_search",detail:"The text to search for the first occurrence of `search_for`.",example:'"new year"',require:"m",repeat:"n",type:"rangeall"},{name:"starting_at",detail:"The character within `text_to_search` at which to start the search.",example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"JOIN",t:12,d:"Concatenates the elements of one or more one-dimensional arrays using a specified delimiter.",a:"Concatenates elements of arrays with delimiter.",m:[2,255],p:[{name:"delimiter",detail:"The character or string to place between each concatenated value.",example:'" and-a "',require:"m",repeat:"n",type:"rangeall"},{name:"value_or_array1",detail:"The value or values to be appended using `delimiter`.",example:"{1",require:"m",repeat:"n",type:"rangeall"},{name:"value_or_array2",detail:"More values to be appended using `delimiter`.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"LEFT",t:12,d:"Returns a substring from the beginning of a specified string.",a:"Substring from beginning of specified string.",m:[1,2],p:[{name:"string",detail:"The string from which the left portion will be returned.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"number_of_characters",detail:"The number of characters to return from the left side of `string`.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"RIGHT",t:12,d:"Returns a substring from the end of a specified string.",a:"A substring from the end of a specified string.",m:[1,2],p:[{name:"string",detail:"The string from which the right portion will be returned.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"number_of_characters",detail:"The number of characters to return from the right side of `string`.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MID",t:12,d:"Returns a segment of a string.",a:"A segment of a string.",m:[3,3],p:[{name:"string",detail:"The string to extract a segment from.",example:'"get this"',require:"m",repeat:"n",type:"rangeall"},{name:"starting_at",detail:"The index from the left of `string` from which to begin extracting. The first character in `string` has the index 1.",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"extract_length",detail:"The length of the segment to extract.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LEN",t:12,d:"Returns the length of a string.",a:"Length of a string.",m:[1,1],p:[{name:"text",detail:"The string whose length will be returned.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"LENB",t:12,d:"Returns the length of a string in bytes.",a:"Length of a string in bytes.",m:[1,1],p:[{name:"text",detail:"The string whose length will be returned.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"LOWER",t:12,d:"Converts a specified string to lowercase.",a:"Converts a specified string to lowercase.",m:[1,1],p:[{name:"text",detail:"The string to convert to lowercase.",example:'"LOREM IPSUM"',require:"m",repeat:"n",type:"rangeall"}]},{n:"UPPER",t:12,d:"Converts a specified string to uppercase.",a:"Converts a specified string to uppercase.",m:[1,1],p:[{name:"text",detail:"The string to convert to uppercase.",example:'"lorem ipsum"',require:"m",repeat:"n",type:"rangeall"}]},{n:"EXACT",t:12,d:"Tests whether two strings are identical.",a:"Tests whether two strings are identical.",m:[2,2],p:[{name:"string1",detail:"The first string to compare",example:"A1",require:"m",repeat:"n",type:"rangeall"},{name:"string2",detail:"The second string to compare",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"REPLACE",t:12,d:"Replaces part of a text string with a different text string.",a:"Replaces part of a text string with different text.",m:[4,4],p:[{name:"text",detail:"The text, a part of which will be replaced.",example:'"Spreadsheets"',require:"m",repeat:"n",type:"rangeall"},{name:"position",detail:"The position where the replacement will begin (starting from 1).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"length",detail:"The number of characters in the text to be replaced.",example:"6",require:"m",repeat:"n",type:"rangenumber"},{name:"new_text",detail:"The text which will be inserted into the original text.",example:'"Bed"',require:"m",repeat:"n",type:"rangeall"}]},{n:"REPT",t:12,d:"Returns specified text repeated a number of times.",a:"Specified text repeated a number of times.",m:[2,2],p:[{name:"text_to_repeat",detail:"The character or string to repeat.",example:'"ha"',require:"m",repeat:"n",type:"rangeall"},{name:"number_of_repetitions",detail:"The number of times `text_to_repeat` should appear in the value returned.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SEARCH",t:12,d:"Returns the position at which a string is first found within text and ignores capitalization of letters. Returns `#VALUE!` if the string is not found.",a:"First position of string found in text, ignoring case.",m:[2,3],p:[{name:"search_for",detail:"The string to look for within `text_to_search`.",example:'"n"',require:"m",repeat:"n",type:"rangeall"},{name:"text_to_search",detail:"The text to search for the first occurrence of `search_for`.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"starting_at",detail:"The character within `text_to_search` at which to start the search.",example:"14",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUBSTITUTE",t:12,d:"Replaces existing text with new text in a string.",a:"Replaces existing text with new text in a string.",m:[3,4],p:[{name:"text_to_search",detail:"The text within which to search and replace.",example:'"search for it"',require:"m",repeat:"n",type:"rangeall"},{name:"search_for",detail:"The string to search for within `text_to_search`.",example:'"search for"',require:"m",repeat:"n",type:"rangeall"},{name:"replace_with",detail:"The string that will replace `search_for`.",example:'"Google"',require:"m",repeat:"n",type:"rangeall"},{name:"occurrence_number",detail:"The instance of `search_for` within `text_to_search` to replace with `replace_with`. By default, all occurrences of `search_for` are replaced; however, if `occurrence_number` is specified, only the indicated instance of `search_for` is replaced.",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CLEAN",t:12,d:"Returns the text with the non-printable ASCII characters removed.",a:"Removes non-printable characters from a piece of text.",m:[1,1],p:[{name:"text",detail:"The text whose non-printable characters are to be removed.",example:'"AF"&CHAR(31)',require:"m",repeat:"n",type:"rangeall"}]},{n:"TEXT",t:12,d:"Converts a number into text according to a specified format.",a:"Formats a number into text.",m:[2,2],p:[{name:"number",detail:"The number, date, or time to format.",example:"1.23",require:"m",repeat:"n",type:"rangenumber"},{name:"format",detail:"The pattern by which to format the number, enclosed in quotation marks.",example:'"$0.00"',require:"m",repeat:"n",type:"rangeall"}]},{n:"TRIM",t:12,d:"Removes leading, trailing, and repeated spaces in text.",a:"Removes space characters.",m:[1,1],p:[{name:"text",detail:"The text or reference to a cell containing text to be trimmed.",example:'" lorem ipsum"',require:"m",repeat:"n",type:"rangeall"}]},{n:"VALUE",t:12,d:"Converts a string in any of the date, time or number formats that Google Sheets understands into a number.",a:"Converts a date/time/number string into a number.",m:[1,1],p:[{name:"text",detail:"The string containing the value to be converted.",example:'"123"',require:"m",repeat:"n",type:"rangeall"}]},{n:"PROPER",t:12,d:"Capitalizes each word in a specified string.",a:"Capitalizes each word in a specified string.",m:[1,1],p:[{name:"text_to_capitalize",detail:"The text which will be returned with the first letter of each word in uppercase and all other letters in lowercase.",example:'"united states"',require:"m",repeat:"n",type:"rangeall"}]},{n:"CONVERT",t:13,d:"Converts a numeric value to a different unit of measure.",a:"Unit conversion for numbers.",m:[3,3],p:[{name:"value",detail:"The numeric value in `start_unit` to convert to `end_unit`.",example:"5.1",require:"m",repeat:"n",type:"rangenumber"},{name:"start_unit",detail:"The starting unit, the unit currently assigned to `value`.",example:'"g"',require:"m",repeat:"n",type:"rangeall"},{name:"end_unit",detail:"The unit of measure into which to convert the argument, `value`.",example:'"kg"',require:"m",repeat:"n",type:"rangeall"}]},{n:"SUMX2MY2",t:14,d:"Calculates the sum of the differences of the squares of values in two arrays.",a:"Sum of the differences of squares.",m:[2,2],p:[{name:"array_x",detail:"The array or range of values whose squares will be reduced by the squares of corresponding entries in `array_y` and added together.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"array_y",detail:"The array or range of values whose squares will be subtracted from the squares of corresponding entries in `array_x` and added together.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMX2PY2",t:14,d:"Calculates the sum of the sums of the squares of values in two arrays.",a:"Sum of the sums of squares.",m:[2,2],p:[{name:"array_x",detail:"The array or range of values whose squares will be added to the squares of corresponding entries in `array_y` and added together.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"array_y",detail:"The array or range of values whose squares will be added to the squares of corresponding entries in `array_x` and added together.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMXMY2",t:14,d:"Calculates the sum of the squares of differences of values in two arrays.",a:"Sum of the squares of differences.",m:[2,2],p:[{name:"array_x",detail:"The array or range of values that will be reduced by corresponding entries in `array_y`, squared, and added together.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"array_y",detail:"The array or range of values that will be subtracted from corresponding entries in `array_x`, the result squared, and all such results added together.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TRANSPOSE",t:14,d:"Transposes the rows and columns of an array or range of cells.",a:"Transposes the rows and columns of an array.",m:[1,1],p:[{name:"array_or_range",detail:"The array or range whose rows and columns will be swapped.",example:"{1,2}",require:"m",repeat:"n",type:"range"}]},{n:"TREND",t:14,d:"Given partial data about a linear trend, fits an ideal linear trend using the least squares method and/or predicts further values.",a:"Fits points to linear trend derived via least-squares.",m:[1,4],p:[{name:"known_data_y",detail:"The array or range containing dependent (y) values that are already known, used to curve fit an ideal linear trend.",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_data_x",detail:"The values of the independent variable(s) corresponding with `known_data_y`.",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"new_data_x",detail:"The data points to return the `y` values for on the ideal curve fit.",example:"A11:A13",require:"o",repeat:"n",type:"rangenumber"},{name:"b",detail:"Given a general linear form of `y = m*x+b` for a curve fit, calculates `b` if `TRUE` or forces `b` to be `0` and only calculates the `m` values if `FALSE`, i.e. forces the curve fit to pass through the origin.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"FREQUENCY",t:14,d:"Calculates the frequency distribution of a one-column array into specified classes.",a:"The frequency distribution of array.",m:[2,2],p:[{name:"data",detail:"The array or range containing the values to be counted.",example:"A2:A40",require:"m",repeat:"n",type:"rangenumber"},{name:"classes",detail:"The array or range containing the set of classes.",example:"B2:B5",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GROWTH",t:14,d:"Given partial data about an exponential growth trend, fits an ideal exponential growth trend and/or predicts further values.",a:"Fits points to exponential growth trend.",m:[1,4],p:[{name:"known_data_y",detail:"The array or range containing dependent (y) values that are already known, used to curve fit an ideal exponential growth curve.",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_data_x",detail:"The values of the independent variable(s) corresponding with `known_data_y`.",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"new_data_x",detail:"The data points to return the `y` values for on the ideal curve fit.",example:"A11:A13",require:"o",repeat:"n",type:"rangenumber"},{name:"b",detail:"Given a general exponential form of `y = b*m^x` for a curve fit, calculates `b` if `TRUE` or forces `b` to be `1` and only calculates the `m` values if `FALSE`.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"LINEST",t:14,d:"Given partial data about a linear trend, calculates various parameters about the ideal linear trend using the least-squares method.",a:"Best-fit linear trend via least-squares.",m:[1,4],p:[{name:"known_data_y",detail:"The array or range containing dependent (y) values that are already known, used to curve fit an ideal linear trend.",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_data_x",detail:"The values of the independent variable(s) corresponding with `known_data_y`.",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"calculate_b",detail:"Given a linear form of `y = m*x+b`, calculates the y-intercept (`b`) if `TRUE`. Otherwise, forces `b` to be `0` and only calculates the `m` values if `FALSE`, i.e. forces the curve fit to pass through the origin.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"},{name:"verbose",detail:"A flag specifying whether to return additional regression statistics or only the linear coefficients and the y-intercept (default).",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"LOGEST",t:14,d:"Given partial data about an exponential growth curve, calculates various parameters about the best fit ideal exponential growth curve.",a:"Best-fit exponential growth curve.",m:[1,4],p:[{name:"known_data_y",detail:"The array or range containing dependent (y) values that are already known, used to curve fit an ideal exponential growth curve.",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_data_x",detail:"The values of the independent variable(s) corresponding with `known_data_y`.",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"b",detail:"Given a general exponential form of `y = b*m^x` for a curve fit, calculates `b` if `TRUE` or forces `b` to be `1` and only calculates the `m` values if `FALSE`.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"},{name:"verbose",detail:"A flag specifying whether to return additional regression statistics or only the calculated coefficient and exponents.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"MDETERM",t:14,d:"Returns the matrix determinant of a square matrix specified as an array or range.",a:"Matrix determinant of a square matrix.",m:[1,1],p:[{name:"square_matrix",detail:"An array or range with an equal number of rows and columns representing a matrix whose determinant will be calculated.",example:"A1:D4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MINVERSE",t:14,d:"Returns the multiplicative inverse of a square matrix specified as an array or range.",a:"Multiplicative inverse of square matrix.",m:[1,1],p:[{name:"square_matrix",detail:"An array or range with an equal number of rows and columns representing a matrix whose multiplicative inverse will be calculated.",example:"A1:D4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MMULT",t:14,d:"Calculates the matrix product of two matrices specified as arrays or ranges.",a:"The matrix product of two matrices.",m:[2,2],p:[{name:"matrix1",detail:"The first matrix in the matrix multiplication operation, represented as an array or range.",example:"A1:B3",require:"m",repeat:"n",type:"rangenumber"},{name:"matrix2",detail:"The second matrix in the matrix multiplication operation, represented as an array or range.",example:"C1:F2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMPRODUCT",t:14,d:"Calculates the sum of the products of corresponding entries in two equal-sized arrays or ranges.",a:"Sum of products of elements in two arrays.",m:[1,255],p:[{name:"array1",detail:"The first array or range whose entries will be multiplied with corresponding entries in the second such array or range.",example:"A2:C5",require:"m",repeat:"n",type:"rangenumber"},{name:"array2",detail:"The second array or range whose entries will be multiplied with corresponding entries in the first such array or range.",example:"D2:F5",require:"o",repeat:"y",type:"rangenumber"}]},{n:"ISFORMULA",t:15,d:"Checks whether a value is a formula.",a:"Whether a value is a formula.",m:[1,1],p:[{name:"cell",detail:"The cell to be verified as containing a formula.",example:"A2",require:"m",repeat:"n",type:"range"}]},{n:"CELL",t:15,d:"Returns the requested information about the specified cell.",a:"Gets information about a cell.",m:[2,2],p:[{name:"info_type",detail:"The type of information requested (see article for available types)",example:'"type"',require:"m",repeat:"n",type:"rangeall"},{name:"reference",detail:"The reference to the cell.",example:"C2",require:"m",repeat:"n",type:"range"}]},{n:"NA",t:15,d:'Returns the "value not available" error, `#N/A`.',a:"The `#N/A` error.",m:[0,0],p:[]},{n:"ERROR_TYPE",t:15,d:"Returns a number corresponding to the error value in a different cell.",a:"Error value of cell (as number).",m:[1,1],p:[{name:"reference",detail:"The cell to find the error number for although you can also provide the error value directly.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISBLANK",t:15,d:"Checks whether the referenced cell is empty.",a:"Whether the referenced cell is empty.",m:[1,1],p:[{name:"value",detail:"Reference to the cell that will be checked for emptiness.",example:"A2",require:"m",repeat:"n",type:"range"}]},{n:"ISERR",t:15,d:"Checks whether a value is an error other than `#N/A`.",a:"Whether a value is an error other than `#n/a`.",m:[1,1],p:[{name:"value",detail:"The value to be verified as an error type other than `#N/A`.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISERROR",t:15,d:"Checks whether a value is an error.",a:"Whether a value is an error.",m:[1,1],p:[{name:"value",detail:"The value to be verified as an error type.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISLOGICAL",t:15,d:"Checks whether a value is `TRUE` or `FALSE`.",a:"Whether a value is `true` or `false`.",m:[1,1],p:[{name:"value",detail:"The value to be verified as a logical `TRUE` or `FALSE`.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISNA",t:15,d:"Checks whether a value is the error `#N/A`.",a:"Whether a value is the error `#n/a`.",m:[1,1],p:[{name:"value",detail:"The value to be compared with the error value `#N/A`.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISNONTEXT",t:15,d:"Checks whether a value is non-textual.",a:"Whether a value is non-textual.",m:[1,1],p:[{name:"value",detail:"The value to be checked.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISNUMBER",t:15,d:"Checks whether a value is a number.",a:"Whether a value is a number.",m:[1,1],p:[{name:"value",detail:"The value to be verified as a number.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISREF",t:15,d:"Checks whether a value is a valid cell reference.",a:"Whether a value is a valid cell reference.",m:[1,1],p:[{name:"value",detail:"The value to be verified as a cell reference.",example:"A2",require:"m",repeat:"n",type:"range"}]},{n:"ISTEXT",t:15,d:"Checks whether a value is text.",a:"Whether a value is text.",m:[1,1],p:[{name:"value",detail:"The value to be verified as text.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"TYPE",t:15,d:"Returns a number associated with the type of data passed into the function.",a:"Get the type of a value.",m:[1,1],p:[{name:"value",detail:"The value whose type is to be determined.",example:"C4",require:"m",repeat:"n",type:"rangeall"}]},{n:"N",t:15,d:"Returns the argument provided as a number. Text is converted to 0 and errors are returned as-is.",a:"Argument provided as a number.",m:[1,1],p:[{name:"value",detail:"The argument to be converted to a number.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"TO_DATE",t:16,d:"Converts a provided number to a date.",a:"Converts a provided number to a date.",m:[1,1],p:[{name:"value",detail:"The argument or reference to a cell to be converted to a date.",example:"25405",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TO_PURE_NUMBER",t:16,d:"Converts a provided date/time, percentage, currency or other formatted numeric value to a pure number without formatting.",a:"Converts any numeric value to a pure number.",m:[1,1],p:[{name:"value",detail:"The argument or reference to a cell to be converted to a pure number.",example:"50%",require:"m",repeat:"n",type:"rangeall"}]},{n:"TO_TEXT",t:16,d:"Converts a provided numeric value to a text value.",a:"Converts a provided numeric value to a text value.",m:[1,1],p:[{name:"value",detail:"The argument or reference to a cell to be converted to text.",example:"24",require:"m",repeat:"n",type:"rangeall"}]},{n:"TO_DOLLARS",t:16,d:"Converts a provided number to a dollar value.",a:"Converts a provided number to a dollar value.",m:[1,1],p:[{name:"value",detail:"The argument or reference to a cell to be converted to a dollar value.",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TO_PERCENT",t:16,d:"Converts a provided number to a percentage.",a:"Converts a provided number to a percentage.",m:[1,1],p:[{name:"value",detail:"The argument or reference to a cell to be converted to a percentage.",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DGET",t:17,d:"Returns a single value from a database table-like array or range using a SQL-like query.",a:"Single value from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DMAX",t:17,d:"Returns the maximum value selected from a database table-like array or range using a SQL-like query.",a:"Maximum of values from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DMIN",t:17,d:"Returns the minimum value selected from a database table-like array or range using a SQL-like query.",a:"Minimum of values from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DAVERAGE",t:17,d:"Returns the average of a set of values selected from a database table-like array or range using a SQL-like query.",a:"Average of a set of values from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DCOUNT",t:17,d:"Counts numeric values selected from a database table-like array or range using a SQL-like query.",a:"Counts values from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DCOUNTA",t:17,d:"Counts values, including text, selected from a database table-like array or range using a SQL-like query.",a:"Counts values and text from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DPRODUCT",t:17,d:"Returns the product of values selected from a database table-like array or range using a SQL-like query.",a:"Product of values from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DSTDEV",t:17,d:"Returns the standard deviation of a population sample selected from a database table-like array or range using a SQL-like query.",a:"Standard deviation of population sample from table.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DSTDEVP",t:17,d:"Returns the standard deviation of an entire population selected from a database table-like array or range using a SQL-like query.",a:"Standard deviation of entire population from table.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DSUM",t:17,d:"Returns the sum of values selected from a database table-like array or range using a SQL-like query.",a:"Sum of values from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DVAR",t:17,d:"Returns the variance of a population sample selected from a database table-like array or range using a SQL-like query.",a:"Variance of population sample from table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DVARP",t:17,d:"Returns the variance of an entire population selected from a database table-like array or range using a SQL-like query.",a:"Variance of a population from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"AGE_BY_IDCARD",t:"3",d:"Calculate the age based on the Chinese ID number. Support 15 or 18",a:"Get age based on ID number.",m:[1,2],p:[{name:"ID number",example:"A1",detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"},{name:"Deadline",example:'"2017-10-01"',detail:"The deadline or range of age calculation. The default is the current day.",require:"o",repeat:"n",type:"rangedatetime"}]},{n:"SEX_BY_IDCARD",t:"3",d:"Calculate gender based on Chinese ID number. Support 15 or 18",a:"Get gender based on ID number.",m:[1,1],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"}]},{n:"BIRTHDAY_BY_IDCARD",t:"3",d:"Calculate the birthday based on the Chinese ID number. Support 15 or 18",a:"Get the birthday based on the ID number.",m:[1,2],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"},{name:"Birthday format",example:"0",detail:"Date type, default:0:[1900/01/01], 1:[1900-01-01], 2:[1900年1月1日]",require:"o",repeat:"n",type:"rangeall"}]},{n:"PROVINCE_BY_IDCARD",t:"3",d:"Calculate the province of birthplace based on the Chinese ID number. Support 15 or 18",a:"Get the province of birthplace based on the ID number.",m:[1,1],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"}]},{n:"CITY_BY_IDCARD",t:"3",d:"Calculate the city of birthplace based on the Chinese ID number. Support 15 or 18",a:"Get the city of birthplace based on the ID number.",m:[1,1],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"}]},{n:"STAR_BY_IDCARD",t:"3",d:"Calculate the constellation based on the Chinese ID number. Support 15 or 18",a:"Get the constellation based on the ID number.",m:[1,1],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"}]},{n:"ANIMAL_BY_IDCARD",t:"3",d:"Calculate the zodiac (rat, ox, tiger, rabbit...) based on the Chinese ID number. Support 15 or 18",a:"Get the zodiac according to the ID number.",m:[1,1],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISIDCARD",t:"3",d:"Verify that the format of the ID card is correct. Support 15 or 18",a:"Verify the correctness of the ID card format.",m:[1,1],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"}]},{n:"DM_TEXT_CUTWORD",t:"4",d:"Text segmentation. Split a series of words into a series of individual words",a:"Chinese text segmentation.",m:[1,2],p:[{name:"Text",example:'"I came to Beijing Tsinghua University"',detail:"Any text that needs word segmentation.",require:"m",repeat:"n",type:"rangeall"},{name:"Word segmentation mode",example:"0",detail:"The default is 0[precision mode], 1[full mode], 2[search engine mode].",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DM_TEXT_TFIDF",t:"4",d:"Use tf-idf algorithm for keyword extraction. Identify keywords from a series of text",a:"tf-idf keyword recognition.",m:[1,3],p:[{name:"Text",example:'"I came to Beijing Tsinghua University"',detail:"Any text that needs word segmentation.",require:"m",repeat:"n",type:"rangeall"},{name:"Number of keywords",example:"20",detail:"The number of keywords returned by the algorithm, the default is 20",require:"o",repeat:"n",type:"rangenumber"},{name:"Corpus",example:"1",detail:"Select a corpus in a specific field, the default is 0[General], 1[Finance], 2[Medical]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DM_TEXT_TEXTRANK",t:"4",d:"Use TextRank algorithm to extract keywords. Identify keywords from a series of text",a:"TextRank keyword recognition.",m:[1,3],p:[{name:"Text",example:'"I came to Beijing Tsinghua University"',detail:"Any text that needs word segmentation.",require:"m",repeat:"n",type:"rangeall"},{name:"Number of keywords",example:"20",detail:"The number of keywords returned by the algorithm, the default is 20",require:"o",repeat:"n",type:"rangenumber"},{name:"Corpus",example:"1",detail:"Select a corpus in a specific field, the default is 0[General], 1[Finance], 2[Medical]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_CLOSE",t:"5",d:"According to the stock code and date, return the corresponding stock closing price of A shares.",a:"Returns the closing price of stock.",m:[1,3],p:[{name:"Stock code",example:'"000001"',detail:"6-digit stock code, required.",require:"m",repeat:"n",type:"rangeall"},{name:"Date",example:"2015-01-08",detail:"The trading day of the stock, the default is the latest trading day",require:"o",repeat:"n",type:"rangedate"},{name:"Reversion and exclusion",example:"0",detail:"Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_OPEN",t:"5",d:"According to the stock code and date, return the opening price of stock.",a:"Return the opening price of a shares.",m:[1,3],p:[{name:"Stock code",example:'"000001"',detail:"6-digit stock code, required.",require:"m",repeat:"n",type:"rangeall"},{name:"Date",example:"2015-01-08",detail:"The trading day of the stock, the default is the latest trading day",require:"o",repeat:"n",type:"rangedate"},{name:"Reversion and exclusion",example:"0",detail:"Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_MAX",t:"5",d:"According to the stock code and date, return the highest price of stock.",a:"Return the highest price of stock.",m:[1,3],p:[{name:"Stock code",example:'"000001"',detail:"6-digit stock code, required.",require:"m",repeat:"n",type:"rangeall"},{name:"Date",example:"2015-01-08",detail:"The trading day of the stock, the default is the latest trading day",require:"o",repeat:"n",type:"rangedate"},{name:"Reversion and exclusion",example:"0",detail:"Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_MIN",t:"5",d:"According to the stock code and date, return the lowest price of stock.",a:"Returns the lowest price of stock.",m:[1,3],p:[{name:"Stock code",example:'"000001"',detail:"6-digit stock code, required.",require:"m",repeat:"n",type:"rangeall"},{name:"Date",example:"2015-01-08",detail:"The trading day of the stock, the default is the latest trading day",require:"o",repeat:"n",type:"rangedate"},{name:"Reversion and exclusion",example:"0",detail:"Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_VOLUMN",t:"5",d:"According to the stock code and date, return the corresponding stock trading volume of A shares.",a:"Returns the corresponding stock trading volume of A shares.",m:[1,3],p:[{name:"Stock code",example:'"000001"',detail:"6-digit stock code, required.",require:"m",repeat:"n",type:"rangeall"},{name:"Date",example:"2015-01-08",detail:"The trading day of the stock, the default is the latest trading day",require:"o",repeat:"n",type:"rangedate"},{name:"Reversion and exclusion",example:"0",detail:"Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_AMOUNT",t:"5",d:"According to the stock code and date, return the corresponding stock turnover of A shares.",a:"Returns the corresponding stock turnover of A shares.",m:[1,3],p:[{name:"Stock code",example:'"000001"',detail:"6-digit stock code, required.",require:"m",repeat:"n",type:"rangeall"},{name:"Date",example:"2015-01-08",detail:"The trading day of the stock, the default is the latest trading day",require:"o",repeat:"n",type:"rangedate"},{name:"Reversion and exclusion",example:"0",detail:"Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"ISDATE",t:"6",d:"Returns whether a value is a date.",a:"Whether a value is a date.",m:[1,1],p:[{name:"value",example:'"1990-01-01"',detail:"The value to be verified as a date.",require:"m",repeat:"n",type:"rangeall"}]},{n:"LINESPLINES",t:"3",d:"Generate sparklines embedded in the cell to describe the continuous trend of data",a:"Generate sparklines line chart",m:[1,8],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Line color",example:"#2ec7c9",detail:"The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #2ec7c9",require:"o",repeat:"n",type:"rangeall"},{name:"Line thickness",example:"1",detail:"Line thickness of the line graph, the default is 1px",require:"o",repeat:"n",type:"rangeall"},{name:"Auxiliary line",example:"avg",detail:"A horizontal line, which can be min, max, avg, median, range or custom value, default 0 none",require:"o",repeat:"n",type:"rangeall"},{name:"Auxiliary line color",example:"#000",detail:"Color setting of auxiliary line, same as line color configuration, default #000",require:"o",repeat:"n",type:"rangeall"},{name:"Maximum mark",example:"#fc5c5c",detail:"Identifies the maximum value of the line graph, the same line color configuration, default 0 does not display",require:"o",repeat:"n",type:"rangeall"},{name:"Minimum mark",example:"#fc5c5c",detail:"Identify the minimum value of the line graph, the same line color configuration, default 0 does not display",require:"o",repeat:"n",type:"rangeall"},{name:"Mark size",example:"1.5",detail:"The maximum and minimum mark size settings, the default is 1.5",require:"o",repeat:"n",type:"rangeall"}]},{n:"AREASPLINES",t:"3",d:"Generate sparklines embedded in the cell area chart, generally used to describe the continuous cumulative value trend of the data",a:"Generate sparklines area chart",m:[1,5],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Line color",example:"#2ec7c9",detail:"The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #2ec7c9",require:"o",repeat:"n",type:"rangeall"},{name:"Fill color",example:"#CCF3F4",detail:"Form an area chart, the same line color configuration, default 0 does not display",require:"o",repeat:"n",type:"rangeall"},{name:"Line thickness",example:"1",detail:"Line thickness of the line graph, the default is 1px",require:"o",repeat:"n",type:"rangeall"},{name:"Auxiliary line",example:"avg",detail:"A horizontal line, which can be min, max, avg, median, range or custom value, default 0 none",require:"o",repeat:"n",type:"rangeall"},{name:"Auxiliary line color",example:"#000",detail:"Color setting of auxiliary line, same as line color configuration, default #000",require:"o",repeat:"n",type:"rangeall"}]},{n:"COLUMNSPLINES",t:"3",d:"Generate sparklines embedded in the vertical histogram of cells, generally used to describe the size of discrete data",a:"Generate sparklines vertical histogram",m:[1,6],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Bar interval",example:"1",detail:"The distance between bars, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Bar color",example:"#fc5c5c",detail:"The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #fc5c5c",require:"o",repeat:"n",type:"rangeall"},{name:"Negative bar color",example:"#97b552",detail:"Negative bar color setting, representing the color of negative value, same as the bar color configuration, default #97b552",require:"o",repeat:"n",type:"rangeall"},{name:"Max",example:"100",detail:"The maximum value of the bar chart, used to standardize the length of the bar chart, the default is to automatically calculate false, auto, null",require:"o",repeat:"n",type:"rangeall"},{name:"Color palette",example:"#97b552",detail:"The color palette can set the color of each bar individually, multiple settings can be set, and two formats are supported: 1 color such as #000, which means that the color of the first bar is black; 2 value range: color, such as -2:# 000 indicates that the bar with a value of -2 is black, 0:5:#000 indicates that the bar with a value of 0-5 is black, and the default is empty",require:"o",repeat:"y",type:"rangeall"}]},{n:"STACKCOLUMNSPLINES",t:"3",d:"Generate sparklines, a cumulative vertical histogram embedded in a cell, generally used to describe the numerical size of multiple dimensions of discrete data",a:"Generate sparklines cumulative vertical histogram",m:[1,5],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Stack by column",example:"1",detail:"If you need to stack by row, set this item to false or 0, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Bar interval",example:"1",detail:"The distance between bars, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Max",example:"100",detail:"The maximum value of the cumulative bar, used to regulate the length of the bar, the default is to automatically calculate false, auto, null",require:"o",repeat:"n",type:"rangeall"},{name:"Color palette",example:"#97b552",detail:"The color palette can individually set the bar color of each dimension, which can be set to the range of A1:A10, etc. The default is #2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",require:"o",repeat:"y",type:"rangeall"}]},{n:"BARSPLINES",t:"3",d:"Generate sparklines embedded in the cell, generally used to describe the size of discrete data",a:"Generate sparklines horizontal bar graph",m:[1,6],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Bar interval",example:"1",detail:"The distance between bars, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Bar color",example:"#fc5c5c",detail:"The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #fc5c5c",require:"o",repeat:"n",type:"rangeall"},{name:"Negative bar color",example:"#97b552",detail:"Negative bar color setting, representing the color of negative value, same as the bar color configuration, default #97b552",require:"o",repeat:"n",type:"rangeall"},{name:"Max",example:"100",detail:"The maximum value of the bar chart, used to standardize the length of the bar chart, the default is to automatically calculate false, auto, null",require:"o",repeat:"n",type:"rangeall"},{name:"Color palette",example:"#97b552",detail:"The color palette can set the color of each bar individually, multiple settings can be set, and two formats are supported: 1 color such as #000, which means that the color of the first bar is black; 2 value range: color, such as -2:# 000 indicates that the bar with a value of -2 is black, 0:5:#000 indicates that the bar with a value of 0-5 is black, and the default is empty",require:"o",repeat:"y",type:"rangeall"}]},{n:"STACKBARSPLINES",t:"3",d:"Generate sparklines, a cumulative horizontal bar graph embedded in a cell, which is generally used to describe the numerical size of multiple dimensions of discrete data",a:"Generate sparklines cumulative horizontal bar graph",m:[1,5],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Stack by column",example:"1",detail:"If you need to stack by row, set this item to false or 0, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Bar interval",example:"1",detail:"The distance between bars, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Max",example:"100",detail:"The maximum value of the cumulative bar, used to regulate the length of the bar, the default is to automatically calculate false, auto, null",require:"o",repeat:"n",type:"rangeall"},{name:"Color palette",example:"#97b552",detail:"The color palette can individually set the bar color of each dimension, which can be set to the range of A1:A10, etc. The default is #2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",require:"o",repeat:"y",type:"rangeall"}]},{n:"DISCRETESPLINES",t:"3",d:"Generate sparklines embedded in the cell, generally used to describe the trend of discrete data",a:"Generate sparklines discrete graph",m:[1,4],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Segmentation threshold",example:"1",detail:"Discrete graph column color distinction, for example: if the value is 0, blue is greater than 0, red is less than 0, and the default is 0",require:"o",repeat:"n",type:"rangeall"},{name:"Above threshold color",example:"#2ec7c9",detail:"The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #2ec7c9",require:"o",repeat:"n",type:"rangeall"},{name:"Below threshold color",example:"#fc5c5c",detail:"The color setting of the bar below the threshold, the same as the color above the threshold, default #fc5c5c",require:"o",repeat:"n",type:"rangeall"}]},{n:"TRISTATESPLINES",t:"3",d:"Generate sparklines, a three-state graph embedded in the cell, which is generally used to describe the trend of three situations, such as winning, losing, or drawing.",a:"Generate sparklines three-state graph",m:[1,6],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Bar interval",example:"1",detail:"The distance between bars, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Bar color",example:"#fc5c5c",detail:"The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #fc5c5c",require:"o",repeat:"n",type:"rangeall"},{name:"Negative bar color",example:"#97b552",detail:"Negative bar color setting, representing the color of negative value, same as the bar color configuration, default #97b552",require:"o",repeat:"n",type:"rangeall"},{name:"Zero value bar color",example:"#999",detail:"Zero value bar color setting, representing 0 value color, the same color configuration of the bar, default #999",require:"o",repeat:"n",type:"rangeall"},{name:"Color palette",example:"#97b552",detail:"The color palette can set the color of each bar individually, multiple settings can be set, and two formats are supported: 1 color such as #000, which means that the color of the first bar is black; 2 value range: color, such as -2:# 000 indicates that the bar with a value of -2 is black, 0:5:#000 indicates that the bar with a value of 0-5 is black, and the default is empty",require:"o",repeat:"y",type:"rangeall"}]},{n:"PIESPLINES",t:"3",d:"Generate sparklines pie chart embedded in the cell, generally used to describe the proportion of data",a:"Generate sparklines pie chart",m:[1,5],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Rotation angle",example:"0",detail:"The rotation angle of the pie chart, the default is 0",require:"o",repeat:"n",type:"rangeall"},{name:"border",example:"0",detail:"Pie chart border size, default is none 0",require:"o",repeat:"n",type:"rangeall"},{name:"Border color",example:"#000",detail:"The border color of the pie chart, the default is #000",require:"o",repeat:"n",type:"rangeall"},{name:"Color palette",example:"#97b552",detail:"The color of the slice can be set in the palette, which can be set to the range of A1:A10, etc. The default is #2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",require:"o",repeat:"y",type:"rangeall"}]},{n:"BOXSPLINES",t:"3",d:"Generate sparklines embedded in the cell box plot, generally used to describe the statistical distribution of the data set",a:"Generate sparklines box plot",m:[1,4],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Outlier ratio",example:"1.5",detail:"The threshold range of outliers, if it is 0 or false, it will not be displayed, the default is 1.5 times",require:"o",repeat:"n",type:"rangeall"},{name:"Target value",example:"10",detail:"The target value setting on the box plot, the default is false and does not display",require:"o",repeat:"n",type:"rangeall"},{name:"Point size",example:"1.5",detail:"The radius of the target point and outlier is set, the default is 1.5",require:"o",repeat:"n",type:"rangeall"}]},{n:"BULLETSPLINES",t:"3",d:"Generate sparklines embedded in the cell, generally used to describe the task achievement rate",a:"Generating sparklines bullets",m:[2,3],p:[{name:"Target",example:"10",detail:"The numerical value can be calculated effectively for the achieved target value, such as A1, 100, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"achieved",example:"8",detail:"Only when the value is completed can the value be calculated effectively, such as A1, 100, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Contrast",example:"12",detail:"Comparative values, such as excess, minimum, and bottom line for awards, can be effectively calculated, such as A1, 100, etc. You can set up to 9 comparison values",require:"o",repeat:"y",type:"rangeall"}]},{n:"COMPOSESPLINES",t:"3",d:"Support multiple types of pictures in the same cell, each parameter represents a sparklines diagram",a:"Combine sparklines graphs into one cell",m:[1,1],p:[{name:"config",example:"PIESPLINES(A1:A20)",detail:"Sparklines chart settings, such as A1:A20, a completed pie chart, line chart settings, etc.",require:"m",repeat:"y",type:"rangeall"}]},{n:"SORT",t:"14",d:"Sorts the rows of a given array or range by the values in one or more columns.",a:"Sorts rows of range by specified column.",m:[1,4],p:[{name:"range",detail:"The data to be sorted.",example:"A2:A17",require:"m",repeat:"n",type:"rangenumber"},{name:"sort_column",detail:"The index of the column in `range` or a range outside of `range` containing the values by which to sort.",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"is_ascending",detail:"`TRUE` or `FALSE` indicating whether to sort `sort_column` in ascending order. `FALSE` sorts in descending order.",example:"-1",require:"o",repeat:"n",type:"rangenumber"},{name:"sort_column2",detail:"Additional columns.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"FILTER",t:"14",d:"Returns a filtered version of the source range, returning only rows or columns which meet the specified conditions.",a:"Filters a range based off provided conditions.",m:[2,3],p:[{name:"range",detail:"The data to be filtered.",example:"A5:D20",require:"m",repeat:"n",type:"range"},{name:"condition1",detail:"A column or row containing true or false values corresponding to the first column or row of `range`, or an array formula evaluating to true or false.",example:"1",require:"m",repeat:"n",type:"range"},{name:"condition2",detail:"Additional rows or columns containing boolean values `TRUE` or `FALSE` indicating whether the corresponding row or column in `range` should pass through `FILTER`. Can also contain array formula expressions which evaluate to such rows or columns. All conditions must be of the same type (row or column). Mixing row conditions and column conditions is not permitted.",example:'""',require:"o",repeat:"n",type:"rangeall"}]},{n:"UNIQUE",t:"14",d:"Returns unique rows in the provided source range, discarding duplicates. Rows are returned in the order in which they first appear in the source range.",a:"Unique rows in the provided source range.",m:[1,3],p:[{name:"range",detail:"The data to filter by unique entries.",example:"A2:B26",require:"m",repeat:"n",type:"rangenumber"},{name:"by_col",detail:"[Option] - Logical value, indicating how to compare; by row = FALSE() or omitted; by column = TRUE().",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"},{name:"occurs_once",detail:"[Option] - Logical value, only one occurrence in the unique value is returned = TRUE(); including all unique values = FALSE() or omitted.",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"RANDARRAY",t:"14",d:"Returns a grid of random numbers between 0 inclusive and 1 exclusive. The grid size will match the provided rows and columns arguments. If neither rows nor columns are provided, then the grid will be size 1 x 1.",a:"Returns a grid of random numbers.",m:[0,2],p:[{name:"rows",detail:"The number of rows to populate with a random number.",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"columns",detail:"The number of columns to populate with a random number.",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"SEQUENCE",t:"14",d:"Returns a grid of sequential numbers starting at a specified start value and  increasing by a specified step size. By default, the sequence starts at and  increases by 1.",a:"Returns a grid of sequential numbers.",m:[1,4],p:[{name:"rows",detail:"The number of rows in the function's resulting grid.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"columns",detail:"The number of columns in the function's resulting grid. If omitted, the result grid will have 1 column.",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"start",detail:"The number, at which to start the sequence. If omitted, the sequence will start at 1.",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"step",detail:"The amount each value in the sequence will differ by. If omitted, each value will differ by 1.",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"EVALUATE",t:"3",d:"Evaluate a formula or expression expressed in words and return the result",a:"Evaluate according to literal formula or expression.",m:[1,1],p:[{name:"expression",example:'"A1+5*2^2"',detail:"Formula or expression",require:"m",repeat:"n",type:"rangeall"}]}],toolbar:{toolbar:"Barra de herramientas",undo:"Deshacer",redo:"Rehacer",paintFormat:"Clonar formato",currencyFormat:"Formato de moneda",percentageFormat:"Formato de porcentaje",numberDecrease:"Menos decimales",numberIncrease:"Más decimales",moreFormats:"Más formatos",font:"Fuente","font-size":"Tamaño Fuente",bold:"Negrita (Ctrl+B)",italic:"Itálica (Ctrl+I)",strikethrough:"Tachar (Alt+Shift+5)",underline:"Guion bajo","font-color":"Color texto",chooseColor:"elegir color",resetColor:"Reinicializar",customColor:"PERSONALIZADO",alternatingColors:"Colores alternos",confirmColor:"Vale",cancelColor:"Cancelar",collapse:"Recoger",background:"Color de relleno",border:"Borde",borderStyle:"Estilo Borde","merge-cell":"Juntar celdas",chooseMergeType:"Elegir tipo de unión",horizontalAlign:"Alineación Horizontal",verticalAlign:"Alineación Vertical",alignment:"Alineación",textWrap:"Ajuste de texto",textWrapMode:"Modo de ajuste de texto",textRotate:"Rotar texto",textRotateMode:"Modo de rotar texto",freeze:"Fijar fila superior",sort:"Ordenar",filter:"Filtrar",findAndReplace:"Buscar y reemplazar","formula-sum":"SUMA",autoSum:"SUMA automática",moreFunction:"Más funciones",conditionalFormat:"Formato condicional",comment:"Comentario",pivotTable:"Tabla Dinámica",chart:"Gráfica",screenshot:"Captura de pantalla",splitColumn:"Separar texto",insertImage:"Insertar imagen",dataVerification:"Verificación de datos",protection:"Proteger la hoja",clearText:"Limpiar color",noColorSelectedText:"Ningún color seleccionado",toolMore:"Más",toolLess:"Menos",toolClose:"Cerrar",toolMoreTip:"Más funcionalidades",moreOptions:"Más opciones",cellFormat:"Configuración formato de celda",print:"Imprimir"},alternatingColors:{applyRange:"Aplicar a rango",selectRange:"Seleccionar un rango de datos",header:"Cabecera",footer:"Pie",errorInfo:"No se puede realizar esta operación en varias áreas de selección, selecciona una sola área y vuelve a intentarlo",textTitle:"Estilo Formato",custom:"PERSONALIZADO",close:"cerrar",selectionTextColor:"Haz clic para seleccionar el color del texto",selectionCellColor:"Haz clic para seleccionar el color de la celda",removeColor:"Eliminar colores alternos",colorShow:"color",currentColor:"Actual",tipSelectRange:"Selecciona la gama de colores alternos",errorNoRange:"No hay ningún rango seleccionado",errorExistColors:"Los colores alternos ya existen y no se pueden editar"},button:{confirm:"Vale",cancel:"Cancelar",close:"Cerrar",update:"Actualizar",delete:"Eliminar",insert:"Insertar",prevPage:"Previous",nextPage:"Next",total:"total:"},paint:{start:"Inicio clonar formato",end:"ESC",tipSelectRange:"Selecciona el rango que quieres copiar",tipNotMulti:"No se puede realizar esta operación en un rango de selección múltiple"},format:{moreCurrency:"Más formatos de moneda",moreDateTime:"Más formatos de fecha y hora",moreNumber:"Más formatos de número",titleCurrency:"Formatos de moneda",decimalPlaces:"Decimales",titleDateTime:"Formatos de fecha y hora",titleNumber:"Formatos de números"},info:{detailUpdate:"Nuevo abierto",detailSave:"Cache local restaurado",row:"",column:"",loading:"Cargando...",copy:"Copiar",return:"Salir",rename:"Renombrar",tips:"Renombrar Libro",noName:"Hoja sin título",wait:"esperando actualización",add:"Añadir",addLast:"más filas al final",backTop:"Volver arriba",pageInfo:"Total ${total}，página ${totalPage}，actual ${currentPage}",nextPage:"Siguiente",tipInputNumber:"Introduce el número",tipInputNumberLimit:"El rango de aumento está limitado a 1-100",tipRowHeightLimit:"La altura de la fila debe estar entre 0 ~ 545",tipColumnWidthLimit:"El ancho de la columna debe estar entre 0 ~ 2038",pageInfoFull:"Total ${total}，página ${totalPage}，Se muestran todos los datos"},currencyDetail:{RMB:"RMB",USdollar:"Dólar US",EUR:"EUR",GBP:"GBP",HK:"HK",JPY:"JPY",AlbanianLek:"Albanian Lek",AlgerianDinar:"Algerian Dinar",Afghani:"Afghani",ArgentinePeso:"Argentine Peso",UnitedArabEmiratesDirham:"United Arab Emirates Dirham",ArubanFlorin:"Aruban Florin",OmaniRial:"Omani Rial",Azerbaijanimanat:"Azerbaijani manat",EgyptianPound:"Egyptian Pound",EthiopianBirr:"Ethiopian Birr",AngolaKwanza:"Angola Kwanza",AustralianDollar:"Australian Dollar",Patacas:"Patacas",BarbadosDollar:"Barbados Dollar",PapuaNewGuineaKina:"Papua New Guinea Kina",BahamianDollar:"Bahamian Dollar",PakistanRupee:"Pakistan Rupee",ParaguayanGuarani:"Paraguayan Guarani",BahrainiDinar:"Bahraini Dinar",PanamanianBalboa:"Panamanian Balboa",Brazilianreal:"Brazilian real",Belarusianruble:"Belarusian ruble",BermudianDollar:"Bermudian Dollar",BulgarianLev:"Bulgarian Lev",IcelandKrona:"Iceland Krona",BosniaHerzegovinaConvertibleMark:"Bosnia-Herzegovina Convertible Mark",PolishZloty:"Polish Zloty",Boliviano:"Boliviano",BelizeDollar:"Belize Dollar",BotswanaPula:"Botswana Pula",NotDannuzhamu:"Not Dannuzhamu",BurundiFranc:"Burundi Franc",NorthKoreanWon:"North Korean Won",DanishKrone:"Danish Krone",EastCaribbeanDollar:"East Caribbean Dollar",DominicaPeso:"Dominica Peso",RussianRuble:"Russian Ruble",EritreanNakfa:"Eritrean Nakfa",CFAfranc:"CFA franc",PhilippinePeso:"Philippine Peso",FijiDollar:"Fiji Dollar",CapeVerdeEscudo:"Cape Verde Escudo",FalklandIslandsPound:"Falkland Islands Pound",GambianDalasi:"Gambian Dalasi",Congolesefranc:"Congolese franc",ColombianPeso:"Colombian Peso",CostaRicanColon:"Costa Rican Colon",CubanPeso:"Cuban Peso",Cubanconvertiblepeso:"Cuban convertible peso",GuyanaDollar:"Guyana Dollar",KazakhstanTenge:"Kazakhstan Tenge",Haitiangourde:"Haitian gourde",won:"won",NetherlandsAntillesGuilder:"Netherlands Antilles Guilder",Honduraslempiras:"Honduras lempiras",DjiboutiFranc:"Djibouti Franc",KyrgyzstanSom:"Kyrgyzstan Som",GuineaFranc:"Guinea Franc",CanadianDollar:"Canadian Dollar",GhanaianCedi:"Ghanaian Cedi",Cambodianriel:"Cambodian riel",CzechKoruna:"Czech Koruna",ZimbabweDollar:"Zimbabwe Dollar",QatariRiyal:"Qatari Riyal",CaymanIslandsDollar:"Cayman Islands Dollar",Comorianfranc:"Comorian franc",KuwaitiDinar:"Kuwaiti Dinar",CroatianKuna:"Croatian Kuna",KenyanShilling:"Kenyan Shilling",LesothoLoti:"Lesotho Loti",LaoKip:"Lao Kip",LebanesePound:"Lebanese Pound",Lithuanianlitas:"Lithuanian litas",LibyanDinar:"Libyan Dinar",LiberianDollar:"Liberian Dollar",RwandaFranc:"Rwanda Franc",RomanianLeu:"Romanian Leu",MalagasyAriary:"Malagasy Ariary",MaldivianRufiyaa:"Maldivian Rufiyaa",MalawiKwacha:"Malawi Kwacha",MalaysianRinggit:"Malaysian Ringgit",MacedoniawearingDinar:"Macedonia wearing Dinar",MauritiusRupee:"Mauritius Rupee",MauritanianOuguiya:"Mauritanian Ouguiya",MongolianTugrik:"Mongolian Tugrik",BangladeshiTaka:"Bangladeshi Taka",PeruvianNuevoSol:"Peruvian Nuevo Sol",MyanmarKyat:"Myanmar Kyat",MoldovanLeu:"Moldovan Leu",MoroccanDirham:"Moroccan Dirham",MozambiqueMetical:"Mozambique Metical",MexicanPeso:"Mexican Peso",NamibianDollar:"Namibian Dollar",SouthAfricanRand:"South African Rand",SouthSudanesePound:"South Sudanese Pound",NicaraguaCordoba:"Nicaragua Cordoba",NepaleseRupee:"Nepalese Rupee",NigerianNaira:"Nigerian Naira",NorwegianKrone:"Norwegian Krone",GeorgianLari:"Georgian Lari",RMBOffshore:"RMB (Offshore)",SwedishKrona:"Swedish Krona",SwissFranc:"Swiss Franc",SerbianDinar:"Serbian Dinar",SierraLeone:"Sierra Leone",SeychellesRupee:"Seychelles Rupee",SaudiRiyal:"Saudi Riyal",SaoTomeDobra:"Sao Tome Dobra",SaintHelenapound:"Saint Helena pound",SriLankaRupee:"Sri Lanka Rupee",SwazilandLilangeni:"Swaziland Lilangeni",SudanesePound:"Sudanese Pound",Surinamesedollar:"Surinamese dollar",SolomonIslandsDollar:"Solomon Islands Dollar",SomaliShilling:"Somali Shilling",TajikistanSomoni:"Tajikistan Somoni",PacificFranc:"Pacific Franc",ThaiBaht:"Thai Baht",TanzanianShilling:"Tanzanian Shilling",TonganPaanga:"Tongan Pa'anga",TrinidadandTobagoDollar:"Trinidad and Tobago Dollar",TunisianDinar:"Tunisian Dinar",TurkishLira:"Turkish Lira",VanuatuVatu:"Vanuatu Vatu",GuatemalanQuetzal:"Guatemalan Quetzal",CommissionBolivar:"Commission Bolivar",BruneiDollar:"Brunei Dollar",UgandanShilling:"Ugandan Shilling",UkrainianHryvnia:"Ukrainian Hryvnia",UruguayanPeso:"Uruguayan Peso",Uzbekistansom:"Uzbekistan som",WesternSamoaTala:"Western Samoa Tala",SingaporeDollar:"Singapore Dollar",NT:"NT",NewZealandDollar:"New Zealand Dollar",HungarianForint:"Hungarian Forint",SyrianPound:"Syrian Pound",JamaicanDollar:"Jamaican Dollar",ArmenianDram:"Armenian Dram",YemeniRial:"Yemeni Rial",IraqiDinar:"Iraqi Dinar",IranianRial:"Iranian Rial",NewIsraeliShekel:"New Israeli Shekel",IndianRupee:"Indian Rupee",IndonesianRupiah:"Indonesian Rupiah",JordanianDinar:"Jordanian Dinar",VND:"VND",ZambianKwacha:"Zambian Kwacha",GibraltarPound:"Gibraltar Pound",ChileanPeso:"Chilean Peso",CFAFrancBEAC:"CFA Franc BEAC"},defaultFmt:function defaultFmt(currency){return[{text:"Automático",value:"General",example:""},{text:"Texto",value:"@",example:""},{text:"",value:"split",example:""},{text:"Número",value:"##0.00",example:"1000.12"},{text:"Porcentaje",value:"#0.00%",example:"12.21%"},{text:"Científico",value:"0.00E+00",example:"1.01E+5"},{text:"",value:"split",example:""},{text:"Contabilidad",value:"".concat(currency,"(0.00)"),example:"".concat(currency,"(1200.09)")},{text:"Moneda",value:"".concat(currency,"0.00"),example:"".concat(currency,"1200.09")},{text:"",value:"split",example:""},{text:"Fecha",value:"yyyy-MM-dd",example:"2017-11-29"},{text:"Hora",value:"hh:mm AM/PM",example:"3:00 PM"},{text:"Hora 24H",value:"hh:mm",example:"15:00"},{text:"Fecha Hora",value:"yyyy-MM-dd hh:mm AM/PM",example:"2017-11-29 3:00 PM"},{text:"Fecha Hora 24 H",value:"yyyy-MM-dd hh:mm",example:"2017-11-29 15:00"},{text:"",value:"split",example:""},{text:"Formatos personalizados",value:"fmtOtherSelf",example:"más"}];},dateFmtList:[{name:"1930-08-05",value:"yyyy-MM-dd"},{name:"1930/8/5",value:"yyyy/MM/dd"},{name:"08-05",value:"MM-dd"},{name:"8-5",value:"M-d"},{name:"13:30:30",value:"h:mm:ss"},{name:"13:30",value:"h:mm"},{name:"PM 01:30",value:"AM/PM hh:mm"},{name:"PM 1:30",value:"AM/PM h:mm"},{name:"PM 1:30:30",value:"AM/PM h:mm:ss"},{name:"08-05 PM 01:30",value:"MM-dd AM/PM hh:mm"}],fontFamily:{MicrosoftYaHei:"YaHei"},fontarray:["Times New Roman","Arial","Tahoma","Verdana"],fontjson:{"times new roman":0,arial:1,tahoma:2,verdana:3},border:{borderTop:"borderTop",borderBottom:"borderBottom",borderLeft:"borderLeft",borderRight:"borderRight",borderNone:"borderNone",borderAll:"borderAll",borderOutside:"borderOutside",borderInside:"borderInside",borderHorizontal:"borderHorizontal",borderVertical:"borderVertical",borderColor:"borderColor",borderSize:"borderSize",borderSlash:"borderSlash"},merge:{mergeAll:"Unir todo",mergeV:"Verticalmente",mergeH:"Horizontalmente",mergeCancel:"Separar",overlappingError:"No se pueden fusionar áreas superpuestas",partiallyError:"No se puede realizar esta operación en celdas parcialmente unidas"},align:{left:"izquierda",center:"centro",right:"derecha",top:"Arriba",middle:"Centro",bottom:"Abajo"},textWrap:{overflow:"Desbordar",wrap:"Ajustar",clip:"Cortar"},rotation:{none:"Ninguno",angleup:"Ladear Arriba",angledown:"Ladear Abajo",vertical:"Apilar Verticalmente",rotationUp:"Rotar Arriba",rotationDown:"Rotar Abajo"},freezen:{default:"Fijar",freezenRow:"Primera Fila",freezenColumn:"Primera Columna",freezenRC:"Ambas",freezenRowRange:"Fijar rango filas",freezenColumnRange:"Fijar rango columnas",freezenRCRange:"Fijar ambos rangos",freezenCancel:"Cancelar",noSeletionError:"No hay rango para seleccionar",rangeRCOverErrorTitle:"Recordatorio de congelación",rangeRCOverError:"El panel de congelación excede el rango visible y puede causar que no funcione correctamente. Reinicie el área de congelación."},sort:{asc:"Ascendente ",desc:"Descendente ",custom:"Ordenación personalizada",hasTitle:"Los datos tienen una fila de encabezado",sortBy:"Ordenar por",addOthers:"Añadir otra columna de ordenación",close:"cerrar",confirm:"ordenar",columnOperation:"Columna",secondaryTitle:"y después por",sortTitle:"Ordenar rango",sortRangeTitle:"Ordenar rango de",sortRangeTitleTo:"a",noRangeError:"No se puede realizar esta operación en múltiples áreas de selección, selecciona un solo rango e intenta nuevamente",mergeError:"Hay celdas combinadas en la selección, ¡esta operación no se puede realizar!"},filter:{filter:"crear filtro",sortByAsc:"Ordenar A-Z",sortByDesc:"Ordenar Z-A",filterByColor:"Filtrar por color",filterByCondition:"Filtrar por condición",filterByValues:"Filtrar por valores",filiterInputNone:"Ninguno",filiterInputTip:"Introduce valor de filtro",filiterRangeStartTip:"Valor para fórmula",filiterRangeEndTip:"Valor para fórmula",filterValueByAllBtn:"Seleccionar todos",filterValueByClearBtn:"Limpiar",filterValueByInverseBtn:"Invertir",filterValueByTip:"filtrar por valores",filterConform:"Confirmar",filterCancel:"Cancelar",clearFilter:"Quitar filtro",conditionNone:"Ninguno",conditionCellIsNull:"Está vacío",conditionCellNotNull:"No está vacío",conditionCellTextContain:"El texto contiene",conditionCellTextNotContain:"El texto no contiene",conditionCellTextStart:"El texto empieza con",conditionCellTextEnd:"El texto termina con",conditionCellTextEqual:"El texto es exactamente",conditionCellDateEqual:"La fecha es",conditionCellDateBefore:"La fecha es anterior",conditionCellDateAfter:"La fecha es posterior",conditionCellGreater:"Mayor que",conditionCellGreaterEqual:"Mayor o igual que",conditionCellLess:"Menor que",conditionCellLessEqual:"Menor o igual que",conditionCellEqual:"Es igual a",conditionCellNotEqual:"No es igual a",conditionCellBetween:"Está entre",conditionCellNotBetween:"No está entre",filiterMoreDataTip:"¡Gran cantidad de datos! por favor espera",filiterMonthText:"Mes",filiterYearText:"Año",filiterByColorTip:"Filtrar por color de celda",filiterByTextColorTip:"Filtrar por color de fuente",filterContainerOneColorTip:"Esta columna contiene solo un color",filterDateFormatTip:"Format fecha",valueBlank:"(Nulo)",mergeError:"Hay celdas combinadas en la selección del filtro, ¡esta operación no se puede realizar!"},rightclick:{copy:"Copiar",copyAs:"Copiar como",paste:"Pegar",insert:"Insertar",image:"Insertar imágenes",link:"Insertar enlace",delete:"Eliminar",deleteCell:"Eliminar celda",deleteSelected:"Eliminar seleccionado ",hide:"Esconder",hideSelected:"Esconder seleccionado ",showHide:"Mostrar ocultos ",to:"Hacia",left:"Izquierda",right:"Derecha",top:"Arriba",bottom:"Abajo",moveLeft:"Mover izquierda",moveUp:"Mover arriba",add:"Añadir",row:"Fila",column:"Columna",width:"Ancho",height:"Alto",number:"Número",confirm:"Confirmar",orderAZ:"Ordenar A-Z",orderZA:"Ordenar Z-A",clearContent:"Limpiar contenido",matrix:"Operación de Matriz",sortSelection:"Ordenar",filterSelection:"Filtrar",chartGeneration:"Crear gráfico",firstLineTitle:"título primera línea",untitled:"sin título",array1:"Matriz unidimensional",array2:"Matriz bidimensional",array3:"Matrices multidimensionales",diagonal:"Diagonal",antiDiagonal:"Anti-diagonal",diagonalOffset:"Desplazamiento Diagonal",offset:"Desplazamiento",boolean:"Booleana",flip:"Voltear",upAndDown:"Arriba y abajo",leftAndRight:"Izquierda y derecha",clockwise:"Sentido horario",counterclockwise:"Sentido anti-horario",transpose:"Transponer",matrixCalculation:"Cálculo de matrices",plus:"Suma",minus:"Resta",multiply:"Multiplicación",divided:"División",power:"Exponenciación",root:"Raíz Cuadrada",log:"Logaritmo",delete0:"Eliminar valores nulos en ambos extremos",removeDuplicate:"Eliminar valores duplicados",byRow:"Por fila",byCol:"Por columna",generateNewMatrix:"Generar nueva matriz",noMulti:"No se puede realizar esta operación en varias áreas de selección, selecciona una sola área",cannotDeleteAllRow:"No se pueden eliminar todas las filas",cannotDeleteAllColumn:"No se pueden eliminar todas las columnas",cannotDeleteRowReadOnly:"No se puede eliminar la fila de solo lectura",cannotDeleteColumnReadOnly:"No se puede eliminar la columna de solo lectura",cannotInsertOnRowReadOnly:"No se puede insertar en una fila de solo lectura",cannotInsertOnColumnReadOnly:"No se puede insertar en la columna de solo lectura",rowOverLimit:"Límite de 10000 filas excedido",columnOverLimit:"Límite de 1000 columnas excedido"},comment:{insert:"Insertar",edit:"Editar",delete:"Elimiar",showOne:"Mostrar/Ocular",showAll:"Mostrar/Ocular Todo"},screenshot:{screenshotTipNoSelection:"Selecciona el alcance de la captura de pantalla",screenshotTipTitle:"¡Advertencia!",screenshotTipHasMerge:"Esta operación no se puede realizar en celdas combinadas",screenshotTipHasMulti:"Esta operación no se puede realizar en varios rangos de selección",screenshotTipSuccess:"Exitoso",screenshotImageName:"Captura de pantalla",downLoadClose:"Cerrar",downLoadCopy:"Copiar al portapapeles",downLoadBtn:"Descargar",browserNotTip:"no es compatible con el navegador IE.",rightclickTip:'Haz clic con el botón derecho en la imagen y selecciona "copiar"',successTip:'Con éxito (si falla el pegado, haz clic con el botón derecho en la imagen para "copiar imagen")'},splitText:{splitDelimiters:"Delimitadores",splitOther:"Otros",splitContinueSymbol:"Los separadores consecutivos se tratan como uno solo",splitDataPreview:"Previsualizar",splitTextTitle:"Partir texto",splitConfirmToExe:"Ya hay datos aquí, ¿quieres reemplazarlos?",tipNoMulti:"No se puede realizar esta operación en varias áreas de selección, selecciona una única área y vuelve a intentarlo",tipNoMultiColumn:"Solo se puede convertir una columna de datos a la vez. El área seleccionado puede tener varias filas, pero no varias columnas. Vuelve a intentarlo después de seleccionar un solo rango de columnas"},imageText:{imageSetting:"Configuración de imagen",close:"Cerrar",conventional:"Convencional",moveCell1:"Mover y cambiar el tamaño de las celdas",moveCell2:"Mover y no cambiar el tamaño de la celda",moveCell3:"No mover ni cambiar el tamaño de la celda",fixedPos:"Posición fija",border:"Borde",width:"Ancho",radius:"Radio",style:"Estilo",solid:"Sólido",dashed:"Discontinua",dotted:"Punteado",double:"Doble",color:"Color"},punctuation:{tab:"Tabulación",semicolon:"punto y coma",comma:"coma",space:"espacio"},findAndReplace:{find:"Encontrar",replace:"Reemplazar",goto:"Ir a",location:"Ubicación",formula:"Fórmula",date:"Fecha",number:"Número",string:"Texto",error:"Error",condition:"Condición",rowSpan:"Intervalo de filas",columnSpan:"Intervalo de columnas",locationExample:"Ubicación",lessTwoRowTip:"Selecciona al menos dos filas",lessTwoColumnTip:"Selecciona al menos dos columnas",findTextbox:"Encontrar Contenido",replaceTextbox:"Reemplazar Contenido",regexTextbox:"Expresión Regular",wholeTextbox:"Palabra entera",distinguishTextbox:"Distingue mayúsculas y minúsculas",allReplaceBtn:"Reemplazar Todo",replaceBtn:"Reemplazar",allFindBtn:"Encontrar Todo",findBtn:"Encontrar siguiente",noFindTip:"No se encontró el contenido",modeTip:"Esta operación no está disponible en este modo",searchTargetSheet:"Hoja",searchTargetCell:"Celda",searchTargetValue:"Valor",searchInputTip:"Introduce el contenido de la búsqueda",noReplceTip:"No hay nada que reemplazar",noMatchTip:"No se encontraron coincidencias",successTip:"${xlength} elementos encontrados",locationConstant:"Constante",locationFormula:"Fórmula",locationDate:"Fecha",locationDigital:"Número",locationString:"Texto",locationBool:"Lógicos",locationError:"Error",locationNull:"Nulo",locationCondition:"Formato condicional",locationRowSpan:"Intervalo fila",locationColumnSpan:"Intervalo columna",locationTiplessTwoRow:"Selecciona al menos dos filas",locationTiplessTwoColumn:"Selecciona al menos dos columnas",locationTipNotFindCell:"Celda no encontrada"},sheetconfig:{delete:"Eliminar",copy:"Copiar",rename:"Renombrar",changeColor:"Cambiar color",hide:"Ocultar",unhide:"Mostrar",moveLeft:"Mover izquierda",moveRight:"Mover derecja",resetColor:"Reiniciar color",cancelText:"Cancelar",chooseText:"Confirmar color",focus:"Enfocar",tipNameRepeat:"¡El nombre de la página de la pestaña no se puede repetir! Revísalo",noMoreSheet:"El libro de trabajo contiene al menos una hoja de trabajo visual. Para eliminar la hoja de trabajo seleccionada, inserta una nueva hoja de trabajo o muestra una hoja de trabajo oculta",confirmDelete:"¿Estás seguro de eliminar",redoDelete:"Se puede deshacer con Ctrl+Z",noHide:"No se puede ocultar, al menos conserva una etiqueta de hoja",chartEditNoOpt:"¡Esta operación no está permitida en el modo de edición de gráficos!",sheetNameSpecCharError:"El nombre no puede contener:[ ] :  ? * / ' \"",sheetNamecannotIsEmptyError:"El nombre de la hoja no puede estar vacío"},conditionformat:{conditionformat_greaterThan:"Conditionformat-GreaterThan",conditionformat_greaterThan_title:"Dar formato a celdas mayores que",conditionformat_lessThan:"Conditionformat-LessThan",conditionformat_lessThan_title:"Dar formato a celdas más pequeñas que",conditionformat_between:"Conditionformat-Betweenness",conditionformat_between_title:"Dar formato a celdas con valores entre",conditionformat_equal:"Conditionformat-Equal",conditionformat_equal_title:"Dar formato a celdas iguales a",conditionformat_textContains:"Conditionformat-TextContains",conditionformat_textContains_title:"Dar formato a las celdas que contienen el siguiente texto",conditionformat_occurrenceDate:"Conditionformat-OccurrenceDate",conditionformat_occurrenceDate_title:"Dar formato a celdas que contienen las siguientes fechas",conditionformat_duplicateValue:"Conditionformat-DuplicateValue",conditionformat_duplicateValue_title:"Dar formato a celdas que contienen los siguientes tipos de valores",conditionformat_top10:"Conditionformat-Top10",conditionformat_top10_percent:"Conditionformat-Top10%",conditionformat_top10_title:"Formatea las celdas con el valor más alto",conditionformat_last10:"Conditionformat-Last10",conditionformat_last10_percent:"Conditionformat-Last10%",conditionformat_last10_title:"Formatea las celdas con el valor más pequeño",conditionformat_aboveAverage:"Conditionformat-AboveAverage",conditionformat_aboveAverage_title:"Dar formato a celdas por encima del promedio",conditionformat_belowAverage:"Conditionformat-SubAverage",conditionformat_belowAverage_title:"Dar formato a celdas por debajo del promedio",rule:"Regla",newRule:"Nueva regla",editRule:"Editar regla",deleteRule:"Eliminar regla",deleteCellRule:"Eliminar regla de celda",deleteSheetRule:"Eliminar regla de hoja",manageRules:"Reglas administración",showRules:"Muestra sus reglas de formato",highlightCellRules:"Resaltar reglas de celda",itemSelectionRules:"Reglas de selección de elementos",conditionformatManageRules:"Administrador de reglas de formato condicional",format:"Formatear",setFormat:"Establecer formato",setAs:"Establecer como",setAsByArea:"Para el área seleccionada, establecer",applyRange:"Aplicar rango",selectRange:"Seleccionar rango de aplicación",selectRange_percent:"Porcentaje del rango seleccionado",selectRange_average:"Valor promedio del rango seleccionado",selectRange_value:"Valor en el rango seleccionado",pleaseSelectRange:"Selecciona el rango de aplicación",selectDataRange:"Seleccionar rango de datos",selectCell:"seleccionar celda",pleaseSelectCell:"Selecciona una celda",pleaseSelectADate:"Selecciona una fecha",pleaseEnterInteger:"Introduzca un número entero entre 1 y 1000",onlySingleCell:"Solo se puede hacer referencia a una sola celda",conditionValueCanOnly:"El valor de la condición solo puede ser un número o una sola celda",ruleTypeItem1:"Aplicar formato a todas las celdas según sus valores respectivos",ruleTypeItem2:"Solo formatear celdas que contengan",ruleTypeItem2_title:"Solo para celdas que cumplan las siguientes condiciones",ruleTypeItem3:"Aplicar formato solo a los números superiores o inferiores",ruleTypeItem3_title:"Es el valor en la siguiente clasificación",ruleTypeItem4:"Aplicar formato solo a los valores superiores o inferiores al promedio",ruleTypeItem4_title:"Es un valor que cumple las siguientes condiciones",ruleTypeItem5:"Aplicar formato solo a valores únicos o repetidos",ruleTypeItem6:"Use fórmulas para determinar qué celdas formatear",formula:"fórmula",textColor:"Color Texto",cellColor:"Color Celda",confirm:"Confirma",confirmColor:"Confirma color",cancel:"Cancela",close:"Cierra",clearColorSelect:"Limpiar selección de color",sheet:"Hoja",currentSheet:"Hoja actual",dataBar:"Barra de datos",dataBarColor:"Color barra de datos",gradientDataBar_1:"Barra de datos de degradado azul-blanco",gradientDataBar_2:"Barra de datos de degradado verde-blanco",gradientDataBar_3:"Barra de datos de degradado rojo-blanco",gradientDataBar_4:"Rayas de degradado de color naranja-blanco",gradientDataBar_5:"Rayas de degradado azul claro-blancas",gradientDataBar_6:"Barra de datos de degradado púrpura-blanco",solidColorDataBar_1:"Barra de datos azul",solidColorDataBar_2:"Barra de datos verde",solidColorDataBar_3:"Barra de datos roja",solidColorDataBar_4:"Barra de datos naranja",solidColorDataBar_5:"Barra de datos azul claro",solidColorDataBar_6:"Barra de datos púrpura",colorGradation:"Degradado de color",colorGradation_1:"Gradación de color verde-amarillo-rojo",colorGradation_2:"Gradación de color rojo-amarillo-verde",colorGradation_3:"Gradación de color verde-blanco-rojo",colorGradation_4:"Gradación de color rojo-blanco-verde",colorGradation_5:"Gradación de color azul-blanco-rojo",colorGradation_6:"Gradación de color rojo-blanco-azul",colorGradation_7:"Gradación de color blanco-rojo",colorGradation_8:"Gradación de color rojo-blanco",colorGradation_9:"Gradación de color verde-blanco",colorGradation_10:"Gradación de color blanco-verde",colorGradation_11:"Gradación de color verde-amarillo",colorGradation_12:"Gradación de color amarillo-verde",icons:"iconos",pleaseSelectIcon:"Haz clic para seleccionar un grupo de iconos:",cellValue:"Valor de celda",specificText:"Texto específico",occurrenceDate:"Fecha",greaterThan:"Mayor que",lessThan:"Menor que",between:"Entre",equal:"Igual",in:"En",between2:"",contain:"Contiene",textContains:"Texto contiene",duplicateValue:"Valor duplicado",uniqueValue:"Valor Unico",top:"Mejor",top10:"10 mejores",top10_percent:"10% mejores",last:"Ultimo",last10:"Ultimos 10",last10_percent:"Ultimos 10%",oneself:"",above:"Encima",aboveAverage:"Encima media",below:"Debajo",belowAverage:"Debajo media",all:"Todos",yesterday:"Año a fecha",today:"Hoy",tomorrow:"Mañana",lastWeek:"Ultima semana",thisWeek:"Esta semana",lastMonth:"Ultimo mes",thisMonth:"Este mes",lastYear:"Ultimo año",thisYear:"Este año",last7days:"Ultimos 7 días",last30days:"Ultimos 30 días",next7days:"Siguientes 7 días",next30days:"Siguientes 30 días",next60days:"Siguientes 60 días",chooseRuleType:"Elige el tipo de regla",editRuleDescription:"Editar descripción de regla",newFormatRule:"Nueva regla de formato",editFormatRule:"Editar regla de formato",formatStyle:"Estilo",fillType:"Rellenar",color:"Color",twocolor:"Dos colores",tricolor:"Tricolor",multicolor:"Multi color",grayColor:"Color gris",gradient:"Gradiente",solid:"Sólido",maxValue:"Valor máximo",medianValue:"Valor mediano",minValue:"Valor mínimo",direction:"Dirección",threeWayArrow:"Flecha de tres direcciones",fourWayArrow:"Flecha de cuatro direcciones",fiveWayArrow:"Flecha de cinco direcciones",threeTriangles:"Tres triángulos",shape:"Forma",threeColorTrafficLight:"Semáforo de tres colores",fourColorTrafficLight:"Semáforo de cuatro colores",threeSigns:"Tres signos",greenRedBlackGradient:"Gradiente verde-rojo-negro",rimless:"Sin aros",bordered:"Bordeado",mark:"Marcar",threeSymbols:"Tres símbolos",tricolorFlag:"Bandera tricolor",circled:"Rodeado",noCircle:"Sin círculo",grade:"Grado",grade4:"4 Grado",grade5:"5 Grado",threeStars:"3 Estrellas",fiveQuadrantDiagram:"Diagrama de cinco cuadrantes",fiveBoxes:"5 Cajas"},dataVerification:{cellRange:"Rango celdas",selectCellRange:"Haz clic para seleccionar un rango de celdas",selectCellRange2:"Selecciona un rango de celdas",verificationCondition:"Condición de verificación",allowMultiSelect:"Permitir selección múltiple",dropdown:"lista desplegable",checkbox:"Casilla de verificación",number:"Número",number_integer:"Número entero",number_decimal:"Número decimal",text_content:"Contenido texto",text_length:"Longitud texto",date:"Fecha",validity:"Eficacia",placeholder1:"Introduce las opciones, separadas por comas, como 1,2,3,4,5",placeholder2:"Introduce contenido",placeholder3:"Valor numérico, como 10",placeholder4:"Introduce el texto especificado",placeholder5:"Introduce el mensaje que se muestra cuando se selecciona la celda",selected:"Seleccionado",notSelected:"No seleccionado",between:"Entre",notBetween:"No entre",equal:"Iqual",notEqualTo:"No iqual a",moreThanThe:"Más que el",lessThan:"Menos que",greaterOrEqualTo:"Mayor o igual a",lessThanOrEqualTo:"Menor o igual a",include:"Incluir",exclude:"Excluir",earlierThan:"Antes de",noEarlierThan:"No antes de",laterThan:"Después de",noLaterThan:"No después de",identificationNumber:"Número de identificación",phoneNumber:"Número de teléfono",remote:"Opción de adquisición remota automática",prohibitInput:"Prohibir la entrada cuando los datos de entrada no son válidos",hintShow:"Mostrar mensaje cuando se selecciona la celda",deleteVerification:"Eliminar verificación",tooltipInfo1:"La opción de la lista desplegable no puede estar vacía",tooltipInfo2:"El contenido de la casilla de verificación no puede estar vacío",tooltipInfo3:"El valor ingresado no es un tipo numérico",tooltipInfo4:"El segundo valor no puede ser menor que el primero",tooltipInfo5:"El contenido del texto no puede estar vacío",tooltipInfo6:"El valor ingresado no es una fecha",tooltipInfo7:"La segunda fecha no puede ser menor que la primera",textlengthInteger:"La longitud del texto debe ser un entero mayor o igual a 0"},formula:{sum:"Suma",average:"Media",count:"Contar",max:"Máx",min:"Mín",ifGenerate:"Generador de fórmula SI",find:"Aprender más",tipNotBelongToIf:"¡Esta función de celda no pertenece a la fórmula SI!",tipSelectCell:"Selecciona la celda para insertar la función",ifGenCompareValueTitle:"Valor de comparación",ifGenSelectCellTitle:"Haz click para seleccionar una celda",ifGenRangeTitle:"Rango",ifGenRangeTo:"a",ifGenRangeEvaluate:"Evaluar rango",ifGenSelectRangeTitle:"Haz click para seleccionar rango",ifGenCutWay:"Forma particionado",ifGenCutSame:"Mismo valor de particionado",ifGenCutNpiece:"Particionar por N",ifGenCutCustom:"Personalizado",ifGenCutConfirm:"Confirma",ifGenTipSelectCell:"Selecciona celdas",ifGenTipSelectCellPlace:"Por favor selecciona celdas",ifGenTipSelectRange:"Selecciona rango",ifGenTipSelectRangePlace:"Por favor selecciona rango",ifGenTipNotNullValue:"El valor de comparación no puede ser vacío!",ifGenTipLableTitile:"Etiqueta",ifGenTipRangeNotforNull:"El rango no puede quedar vacío!",ifGenTipCutValueNotforNull:"El valor de partición no puede ser vacío!",ifGenTipNotGenCondition:"No hay condiciones disponibles para la generación!"},formulaMore:{valueTitle:"Valor",tipSelectDataRange:"Selecciona rango de datos",tipDataRangeTile:"Rango de datos",findFunctionTitle:"Función de búsqueda",tipInputFunctionName:"Nombre o breve descripción de la función",Array:"Vector",Database:"Base de datos",Date:"Fecha",Engineering:"Ingeniería",Filter:"Filtro",Financial:"Financiero",luckysheet:"Luckysheet",other:"Otro",Logical:"Lógica",Lookup:"Búsqueda",Math:"Matemático",Operator:"Operadores",Parser:"Compilador",Statistical:"Estadístico",Text:"Texto",dataMining:"Minería de datos",selectFunctionTitle:"Selecciona una función",calculationResult:"Resultado",tipSuccessText:"Exito",tipParamErrorText:"Parámetro erróneo",helpClose:"Cerrar",helpCollapse:"Recoger",helpExample:"Ejemplo",helpAbstract:"Resumen",execfunctionError:"Error en la fórmula",execfunctionSelfError:"La fórmula no puede hacer referencia a su propia celda",execfunctionSelfErrorResult:"La fórmula no puede hacer referencia a su propia celda, lo que dará lugar a resultados de cálculo inexactos",allowRepeatText:"Repetir",allowOptionText:"Opción",selectCategory:"O selecciona una categoría"},drag:{noMerge:"No se puede realizar esta operación en celdas combinadas",afectarPivot:"¡Este cambio no se puede realizar en la celda seleccionada porque afectará a la tabla dinámica!",noMulti:"No se puede realizar esta operación en varias áreas de selección, selecciona una sola área",noPaste:"No se puede pegar este contenido aquí, selecciona una celda en el área de pegado e intenta pegar nuevamente",noPartMerge:"No se puede realizar esta operación en celdas parcialmente fusionadas",inputCorrect:"Introduce el valor correcto",notLessOne:"El número de filas y columnas no puede ser inferior a 1",offsetColumnLessZero:"¡La columna de desplazamiento no puede ser negativa!",pasteMustKeybordAlert:"在表格中进行复制粘贴: Ctrl + C 进行复制, Ctrl + V 进行粘贴, Ctrl + X 进行剪切",pasteMustKeybordAlertHTMLTitle:"在表格中进行复制粘贴",pasteMustKeybordAlertHTML:"<span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + C</span>&nbsp;&nbsp;进行复制<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + V</span>&nbsp;&nbsp;进行粘贴<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + X</span>&nbsp;&nbsp;进行剪切"},pivotTable:{title:"Tabla Dinámica",closePannel:"Cerrar",editRange:"Rango",tipPivotFieldSelected:"Selecciona los campos",tipClearSelectedField:"Limpiar todos los campos",btnClearSelectedField:"Limpiar",btnFilter:"Filtrar",titleRow:"Fila",titleColumn:"Columna",titleValue:"Valor",tipShowColumn:"Los campos de estadísticas se muestran como columnas",tipShowRow:"Los campos de estadísticas se muestran como filas",titleSelectionDataRange:"Selecciona rango",titleDataRange:"Rango de datos",valueSum:"SUMA",valueStatisticsSUM:"Suma",valueStatisticsCOUNT:"Contar",valueStatisticsCOUNTA:"Contar A",valueStatisticsCOUNTUNIQUE:"Contar Distintos",valueStatisticsAVERAGE:"Media",valueStatisticsMAX:"Máx",valueStatisticsMIN:"Mín",valueStatisticsMEDIAN:"Mediana",valueStatisticsPRODUCT:"Producto",valueStatisticsSTDEV:"Desviación Estándar",valueStatisticsSTDEVP:"Stdevp",valueStatisticslet:"Varianza",valueStatisticsVARP:"VarP",errorNotAllowEdit:"¡Esta operación está prohibida en el modo sin edición!",errorNotAllowMulti:"No se puede realizar esta operación en varias áreas de selección, selecciona un solo rango y vuelve a intentarlo",errorSelectRange:"Seleccione el rango de la nueva tabla dinámica",errorIsDamage:"¡Los datos de origen de esta tabla dinámica están dañados!",errorNotAllowPivotData:"¡No se puede seleccionar la tabla dinámica como datos de origen!",errorSelectionRange:"¡La selección falló, rango de entrada incorrecto!",errorIncreaseRange:"¡Por favor, expande el rango seleccionado!",titleAddColumn:"Añadir columna a la tabla dinámica",titleMoveColumn:"Muever la columna a la celda en blanco de abajo",titleClearColumnFilter:"Quitar el filtro de esta columna",titleFilterColumn:"Filtro",titleSort:"Ordenar",titleNoSort:"No Ordenar",titleSortAsc:"ASC",titleSortDesc:"DESC",titleSortBy:"Ordenar por",titleShowSum:"Mostrar total",titleStasticTrue:"Sí",titleStasticFalse:"No"},dropCell:{copyCell:"Copiar",sequence:"Secuencia",onlyFormat:"Solo formato",noFormat:"Sin formato",day:"Día",workDay:"Día Laborable",month:"Mes",year:"Año",chineseNumber:"Números Chinos"},imageCtrl:{borderTile:"Color de borde de imagen",borderCur:"Color"},protection:{protectiontTitle:"Protección",enterPassword:"Introduce una contraseña (opcional)",enterHintTitle:"Preguntar cuando la edición está prohibida (opcional)",enterHint:"La celda o el gráfico que estás intentando cambiar se encuentra en una hoja de trabajo protegida. Si quieres cambiarlo, desprotege la hoja de trabajo. Es posible que tengas que ingresar una contraseña",swichProtectionTip:"Protege la hoja y el contenido de las celdas bloqueadas",authorityTitle:"Permitir a los usuarios de esta hoja:",selectLockedCells:"Selecciona celdas bloqueadas",selectunLockedCells:"Selecciona celdas desbloqueadas",formatCells:"Formatear celdas",formatColumns:"Formatear columnas",formatRows:"Formatear filas",insertColumns:"Insertar columnas",insertRows:"Insertar filas",insertHyperlinks:"Insertar enlaces",deleteColumns:"Eliminar columnas",deleteRows:"Eliminar filas",sort:"Ordenar",filter:"Filtrar",usePivotTablereports:"Usar informes de tabla dinámica",editObjects:"Editar objetos",editScenarios:"Editar escenarios",allowRangeTitle:"Permitir a los usuarios del rango:",allowRangeAdd:"Nuevo...",allowRangeAddTitle:"Título",allowRangeAddSqrf:"Referencia",selectCellRange:"Haz clic para seleccionar un rango de celdas",selectCellRangeHolder:"Rango de celdas",allowRangeAddTitlePassword:"Contraseña",allowRangeAddTitleHint:"Pregunta",allowRangeAddTitleHintTitle:"Preguntar cuando hay una contraseña (opcional)",allowRangeAddtitleDefault:"Nombre del rango de entrada",rangeItemDblclick:"Haz doble clic para editar",rangeItemHasPassword:"Tiene contraseña",rangeItemErrorTitleNull:"El título es nulo",rangeItemErrorRangeNull:"La referencia es nula",rangeItemErrorRange:"La reference tiene un error",validationTitle:"Validación de contraseña",validationTips:"Hay que ingresar una contraseña para desbloquear la protección de la hoja de trabajo",validationInputHint:"Introduce una contraseña",checkPasswordNullalert:"Contraseña requerida!",checkPasswordWrongalert:"¡Contraseña incorrecta. Por favor, prueba de nuevo!",checkPasswordSucceedalert:"Desbloqueo conseguido!",defaultRangeHintText:"La celda está protegida con contraseña.",defaultSheetHintText:"La celda o el gráfico están en una hoja de trabajo protegida. Para realizar cambios, desprotege la hoja de trabajo. Es posible que tengas que ingresar una contraseña"},cellFormat:{cellFormatTitle:"Formatear celdas",protection:"Protección",locked:"Bloqueado",hidden:"Escondido",protectionTips:"Para bloquear celdas u ocultar fórmulas, protege la hoja de trabajo. En la barra de herramientas, haz clic en el botón Proteger hoja",tipsPart:"Comprobado parcial",tipsAll:"Todo seleccionado",selectionIsNullAlert:"Se requiere una selección!",sheetDataIsNullAlert:"error, no hay datos!"},print:{normalBtn:"Normal",layoutBtn:"Disposición de página",pageBtn:"Previsualización de saltos de página",menuItemPrint:"Imprimir (Ctrl+P)",menuItemAreas:"Imprimir áreas",menuItemRows:"Imprimir títulos de filas",menuItemColumns:"Imprimir títulos de columnas"},edit:{typing:"mecanografía"},websocket:{success:"Éxito de la conexión de WebSocket",refresh:"Se produjo un error en la conexión de WebSocket, ¡actualice la página!",wait:"Se produjo un error en la conexión de WebSocket, ¡tenga paciencia!",close:"Conexión WebSocket cerrada",contact:"Ocurrió un error de comunicación con el servidor, actualice la página y vuelva a intentarlo; de lo contrario, comuníquese con el administrador.",support:"El navegador actual no es compatible con WebSocket"}};var hi={generalDialog:{partiallyError:"आंशिक रूप से विलय किए गए सेल पर यह कार्य नहीं किया जा सकता",readOnlyError:"पठन मोड में यह कार्य नहीं किया जा सकता",dataNullError:"डेटा जो मौजूद नहीं है उस पर यह कार्य नहीं किया जा सकता",noSeletionError:"चयन कार्य अभी तक नहीं किया गया है",cannotSelectMultiple:"एकाधिक चयन नहीं किया जा सकता"},functionlist:[{n:"SUMIF",t:0,d:"Returns a conditional sum across a range.",a:"A conditional sum across a range.",m:[2,3],p:[{name:"range",detail:"The range which is tested against `criterion`.",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"criterion",detail:"The pattern or test to apply to `range`.",example:'">20"',require:"m",repeat:"n",type:"rangeall"},{name:"sum_range",detail:"The range to be summed, if different from `range`.",example:"B1:B10",require:"o",repeat:"n",type:"range"}]},{n:"TAN",t:0,d:"Returns the tangent of an angle provided in radians.",a:"Tangent of an angle provided in radians.",m:[1,1],p:[{name:"angle",detail:"The angle to find the tangent of, in radians.",example:"45*PI()/180",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TANH",t:0,d:"Returns the hyperbolic tangent of any real number.",a:"Hyperbolic tangent of any real number.",m:[1,1],p:[{name:"value",detail:"Any real value to calculate the hyperbolic tangent of.",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CEILING",t:0,d:"Rounds a number up to the nearest integer multiple of specified significance `factor`.",a:"Rounds number up to nearest multiple of a factor.",m:[2,2],p:[{name:"value",detail:"The value to round up to the nearest integer multiple of `factor`.",example:"23.25",require:"m",repeat:"n",type:"rangenumber"},{name:"factor",detail:"The number to whose multiples `value` will be rounded.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ATAN",t:0,d:"Returns the inverse tangent of a value, in radians.",a:"Inverse tangent of a value, in radians.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse tangent.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ASINH",t:0,d:"Returns the inverse hyperbolic sine of a number.",a:"Inverse hyperbolic sine of a number.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse hyperbolic sine.",example:"0.9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ABS",t:0,d:"Returns the absolute value of a number.",a:"Absolute value of a number.",m:[1,1],p:[{name:"value",detail:"The number of which to return the absolute value.",example:"-2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ACOS",t:0,d:"Returns the inverse cosine of a value, in radians.",a:"Inverse cosine of a value, in radians.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse cosine. Must be between `-1` and `1`, inclusive.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ACOSH",t:0,d:"Returns the inverse hyperbolic cosine of a number.",a:"Inverse hyperbolic cosine of a number.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse hyperbolic cosine. Must be greater than or equal to `1`.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MULTINOMIAL",t:0,d:"Returns the factorial of the sum of values divided by the product of the values' factorials.",a:"Multinomial distribution function.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider.",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to consider.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"ATANH",t:0,d:"Returns the inverse hyperbolic tangent of a number.",a:"Inverse hyperbolic tangent of a number.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse hyperbolic tangent. Must be between -1 and 1, exclusive.",example:"0.9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ATAN2",t:0,d:"Returns the angle between the x-axis and a line segment from the origin (0,0) to specified coordinate pair (`x`,`y`), in radians.",a:"Arctangent of a value.",m:[2,2],p:[{name:"x",detail:"The x coordinate of the endpoint of the line segment for which to calculate the angle from the x-axis.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"y",detail:"The y coordinate of the endpoint of the line segment for which to calculate the angle from the x-axis.",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUNTBLANK",t:1,d:"Returns the number of empty values in a list of values and ranges.",a:"Number of empty values.",m:[1,1],p:[{name:"value1",detail:"The first value or range in which to count the number of blanks.",example:"A2:C100",require:"m",repeat:"n",type:"range"}]},{n:"COSH",t:0,d:"Returns the hyperbolic cosine of any real number.",a:"Hyperbolic cosine of any real number.",m:[1,1],p:[{name:"value",detail:"Any real value to calculate the hyperbolic cosine of.",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"INT",t:0,d:"Rounds a number down to the nearest integer that is less than or equal to it.",a:"Rounds number down to nearest integer.",m:[1,1],p:[{name:"value",detail:"The value to round down to the nearest integer.",example:"99.44",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ISEVEN",t:0,d:"Checks whether the provided value is even.",a:"Whether the provided value is even.",m:[1,1],p:[{name:"value",detail:"The value to be verified as even.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ISODD",t:0,d:"Checks whether the provided value is odd.",a:"Whether the provided value is odd.",m:[1,1],p:[{name:"value",detail:"The value to be verified as odd.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LCM",t:0,d:"Returns the least common multiple of one or more integers.",a:"Least common multiple of one or more integers.",m:[1,255],p:[{name:"value1",detail:"The first value or range whose factors to consider in a calculation to find the least common multiple.",example:"A2:A5",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges whose factors to consider to find the least common multiple.",example:"3",require:"o",repeat:"y",type:"rangeall"}]},{n:"LN",t:0,d:"Returns the logarithm of a number, base e (Euler's number).",a:"The logarithm of a number, base e (euler's number).",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the logarithm, base e.",example:"100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LOG",t:0,d:"Returns the logarithm of a number with respect to a base.",a:"The logarithm of a number with respect to a base.",m:[1,2],p:[{name:"value",detail:"The value for which to calculate the logarithm.",example:"128",require:"m",repeat:"n",type:"rangenumber"},{name:"base",detail:"The base to use for calculation of the logarithm.",example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"LOG10",t:0,d:"Returns the logarithm of a number, base 10.",a:"The logarithm of a number, base 10.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the logarithm, base 10.",example:"100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MOD",t:0,d:"Returns the result of the modulo operator, the remainder after a division operation.",a:"Modulo (remainder) operator.",m:[2,2],p:[{name:"dividend",detail:"The number to be divided to find the remainder.",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"divisor",detail:"The number to divide by.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MROUND",t:0,d:"Rounds one number to the nearest integer multiple of another.",a:"Rounds a number to the nearest integer multiple.",m:[2,2],p:[{name:"value",detail:"The number to round to the nearest integer multiple of another.",example:"21",require:"m",repeat:"n",type:"rangenumber"},{name:"factor",detail:"The number to whose multiples `value` will be rounded.",example:"14",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ODD",t:0,d:"Rounds a number up to the nearest odd integer.",a:"Rounds a number up to the nearest odd integer.",m:[1,1],p:[{name:"value",detail:"The value to round to the next greatest odd number.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMSQ",t:0,d:"Returns the sum of the squares of a series of numbers and/or cells.",a:"Sum of squares.",m:[1,255],p:[{name:"value1",detail:"The first number or range whose squares to add together.",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional numbers or ranges whose squares to add to the square(s) of `value1`.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"COMBIN",t:0,d:"Returns the number of ways to choose some number of objects from a pool of a given size of objects.",a:"Number of combinations from a set of objects.",m:[2,2],p:[{name:"n",detail:"The size of the pool of objects to choose from.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"k",detail:"The number of objects to choose.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUM",t:0,d:"Returns the sum of a series of numbers and/or cells.",a:"Sum of a series of numbers and/or cells.",m:[1,255],p:[{name:"value1",detail:"The first number or range to add together.",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional numbers or ranges to add to `value1`.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"SUBTOTAL",t:0,d:"Returns a subtotal for a vertical range of cells using a specified aggregation function.",a:"Subtotal for a range using a specific function.",m:[2,256],p:[{name:"function_code",detail:"The function to use in subtotal aggregation.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"range1",detail:"The first range over which to calculate a subtotal.",example:"A2:A5",require:"m",repeat:"n",type:"range"},{name:"range2",detail:"Additional ranges over which to calculate subtotals.",example:"B2:B8",require:"o",repeat:"y",type:"range"}]},{n:"ASIN",t:0,d:"Returns the inverse sine of a value, in radians.",a:"Inverse sine of a value, in radians.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse sine. Must be between `-1` and `1`, inclusive.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUNTIF",t:1,d:"Returns a conditional count across a range.",a:"A conditional count across a range.",m:[2,2],p:[{name:"range",detail:"The range that is tested against `criterion`.",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"criterion",detail:"The pattern or test to apply to `range`.",example:'">20"',require:"m",repeat:"n",type:"rangeall"}]},{n:"RADIANS",t:0,d:"Converts an angle value in degrees to radians.",a:"Converts an angle value in degrees to radians.",m:[1,1],p:[{name:"angle",detail:"The angle to convert from degrees to radians.",example:"180",require:"m",repeat:"n",type:"rangenumber"}]},{n:"RAND",t:0,d:"Returns a random number between 0 inclusive and 1 exclusive.",a:"A random number between 0 inclusive and 1 exclusive.",m:[0,0],p:[]},{n:"COUNTUNIQUE",t:0,d:"Counts the number of unique values in a list of specified values and ranges.",a:"Counts number of unique values in a range.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider for uniqueness.",example:"A1:C100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to consider for uniqueness.",example:"1",require:"o",repeat:"n",type:"rangeall"}]},{n:"DEGREES",t:0,d:"Converts an angle value in radians to degrees.",a:"Converts an angle value in radians to degrees.",m:[1,1],p:[{name:"angle",detail:"The angle to convert from radians to degrees.",example:"PI()",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ERFC",t:9,d:"Returns the complementary Gauss error function of a value.",a:"Complementary gauss error function of a value.",m:[1,1],p:[{name:"z",detail:"The number for which to calculate the complementary Gauss error function.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"EVEN",t:0,d:"Rounds a number up to the nearest even integer.",a:"Rounds a number up to the nearest even integer.",m:[1,1],p:[{name:"value",detail:"The value to round to the next greatest even number.",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"EXP",t:0,d:"Returns Euler's number, e (~2.718) raised to a power.",a:"Euler's number, e (~2.718) raised to a power.",m:[1,1],p:[{name:"exponent",detail:"The exponent to raise e to.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FACT",t:0,d:"Returns the factorial of a number.",a:"Factorial of a number.",m:[1,1],p:[{name:"value",detail:"The number or reference to a number whose factorial will be calculated and returned.",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FACTDOUBLE",t:0,d:'Returns the "double factorial" of a number.',a:'"double factorial" of a number.',m:[1,1],p:[{name:"value",detail:"The number or reference to a number whose double factorial will be calculated and returned.",example:"6",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PI",t:0,d:"Returns the value of Pi to 14 decimal places.",a:"The number pi.",m:[0,0],p:[]},{n:"FLOOR",t:0,d:"Rounds a number down to the nearest integer multiple of specified significance `factor`.",a:"Rounds number down to nearest multiple of a factor.",m:[2,2],p:[{name:"value",detail:"The value to round down to the nearest integer multiple of `factor`.",example:"23.25",require:"m",repeat:"n",type:"rangenumber"},{name:"factor",detail:"The number to whose multiples `value` will be rounded.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GCD",t:0,d:"Returns the greatest common divisor of one or more integers.",a:"Greatest common divisor of one or more integers.",m:[1,255],p:[{name:"value1",detail:"The first value or range whose factors to consider in a calculation to find the greatest common divisor.",example:"A2:A5",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges whose factors to consider to find the greatest common divisor.",example:"96",require:"o",repeat:"y",type:"rangeall"}]},{n:"RANDBETWEEN",t:0,d:"Returns a uniformly random integer between two values, inclusive.",a:"Random integer between two values, inclusive.",m:[2,2],p:[{name:"low",detail:"The low end of the random range.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"high",detail:"The high end of the random range.",example:"10",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ROUND",t:0,d:"Rounds a number to a certain number of decimal places according to standard rules.",a:"Rounds a number according to standard rules.",m:[2,2],p:[{name:"value",detail:"The value to round to `places` number of places.",example:"99.44",require:"m",repeat:"n",type:"rangenumber"},{name:"places",detail:"The number of decimal places to which to round.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ROUNDDOWN",t:0,d:"Rounds a number to a certain number of decimal places, always rounding down to the next valid increment.",a:"Rounds down a number.",m:[2,2],p:[{name:"value",detail:"The value to round to `places` number of places, always rounding down.",example:"99.44",require:"m",repeat:"n",type:"rangenumber"},{name:"places",detail:"The number of decimal places to which to round.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ROUNDUP",t:0,d:"Rounds a number to a certain number of decimal places, always rounding up to the next valid increment.",a:"Rounds up a number.",m:[2,2],p:[{name:"value",detail:"The value to round to `places` number of places, always rounding up.",example:"99.44",require:"m",repeat:"n",type:"rangenumber"},{name:"places",detail:"The number of decimal places to which to round.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SERIESSUM",t:0,d:"Given parameters `x`, `n`, `m`, and `a`, returns the power series sum a",a:"Sum of a power series.",m:[4,4],p:[{name:"x",detail:"The input to the power series. Varies depending on the type of approximation, may be angle, exponent, or some other value.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"n",detail:"The initial power to which to raise `x` in the power series.",example:"0",require:"m",repeat:"n",type:"rangenumber"},{name:"m",detail:"The additive increment by which to increase `x`.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"a",detail:"The array or range containing the coefficients of the power series.",example:"{FACT(0)",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SIGN",t:0,d:"Given an input number, returns `-1` if it is negative, `1` if positive, and `0` if it is zero.",a:"Sign of a provided number (+/-/0).",m:[1,1],p:[{name:"value",detail:"The value whose sign will be evaluated.",example:"-42",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SIN",t:0,d:"Returns the sine of an angle provided in radians.",a:"Sine of an angle provided in radians.",m:[1,1],p:[{name:"angle",detail:"The angle to find the sine of, in radians.",example:"PI()",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SINH",t:0,d:"Returns the hyperbolic sine of any real number.",a:"Hyperbolic sine of any real number.",m:[1,1],p:[{name:"value",detail:"Any real value to calculate the hyperbolic sine of.",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SQRT",t:0,d:"Returns the positive square root of a positive number.",a:"Positive square root of a positive number.",m:[1,1],p:[{name:"value",detail:"The number for which to calculate the positive square root.",example:"9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SQRTPI",t:0,d:"Returns the positive square root of the product of Pi and the given positive number.",a:"Square root of the product of pi and number.",m:[1,1],p:[{name:"value",detail:"The number which will be multiplied by Pi and have the product's square root returned",example:"9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GAMMALN",t:1,d:"Returns the logarithm of a specified Gamma function, base e (Euler's number).",a:"Logarithm of gamma function.",m:[1,1],p:[{name:"value",detail:"The input to the Gamma function. The natural logarithm of Gamma(`value`) will be returned.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COS",t:0,d:"Returns the cosine of an angle provided in radians.",a:"Cosine of an angle provided in radians.",m:[1,1],p:[{name:"angle",detail:"The angle to find the cosine of, in radians.",example:"PI()",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TRUNC",t:0,d:"Truncates a number to a certain number of significant digits by omitting less significant digits.",a:"Truncates a number.",m:[1,2],p:[{name:"value",detail:"The value to be truncated.",example:"3.141592654",require:"m",repeat:"n",type:"rangenumber"},{name:"places",detail:"The number of significant digits to the right of the decimal point to retain.",example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"QUOTIENT",t:0,d:"Returns one number divided by another.",a:"One number divided by another.",m:[2,2],p:[{name:"dividend",detail:"The number to be divided.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"divisor",detail:"The number to divide by.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"POWER",t:0,d:"Returns a number raised to a power.",a:"A number raised to a power.",m:[2,2],p:[{name:"base",detail:"The number to raise to the `exponent` power.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"exponent",detail:"The exponent to raise `base` to.",example:"0.5",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMIFS",t:0,d:"Returns the sum of a range depending on multiple criteria.",a:"Sums a range depending on multiple criteria.",m:[3,257],p:[{name:"sum_range",detail:"The range to sum.",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"criteria_range1",detail:"The range to check against criterion1.",example:" B1:B10",require:"m",repeat:"n",type:"range"},{name:"criterion1",detail:"The pattern or test to apply to criteria_range1.",example:' ">20"',require:"m",repeat:"n",type:"rangeall"},{name:"criteria_range2",detail:"Additional ranges to check.",example:" C1:C10",require:"o",repeat:"y",type:"rangeall"}]},{n:"COUNTIFS",t:1,d:"Returns the count of a range depending on multiple criteria.",a:"Count values depending on multiple criteria.",m:[2,256],p:[{name:"criteria_range1",detail:"The range to check against `criterion1`.",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"criterion1",detail:"The pattern or test to apply to `criteria_range1`.",example:' ">20"',require:"m",repeat:"n",type:"rangeall"},{name:"criteria_range2",detail:"Additional ranges to check.",example:" B1:B10",require:"o",repeat:"y",type:"rangeall"}]},{n:"PRODUCT",t:0,d:"Returns the result of multiplying a series of numbers together.",a:"Result of multiplying a series of numbers together.",m:[1,255],p:[{name:"factor1",detail:"The first number or range to calculate for the product.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"factor2",detail:"More numbers or ranges to calculate for the product.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"HARMEAN",t:1,d:"Calculates the harmonic mean of a dataset.",a:"The harmonic mean of a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the population.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the population.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"HYPGEOMDIST",t:1,d:"Calculates the probability of drawing a certain number of successes in a certain number of tries given a population of a certain size containing a certain number of successes, without replacement of draws.",a:"Hypergeometric distribution probability.",m:[5,5],p:[{name:"num_successes",detail:"The desired number of successes.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"num_draws",detail:"The number of permitted draws.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"successes_in_pop",detail:"The total number of successes in the population.",example:"20",require:"m",repeat:"n",type:"rangenumber"},{name:"pop_size",detail:"The total size of the population",example:"40",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Determine the logical value of the function form. \n\nIf cumulative is TRUE(), HYPGEOM.DIST returns the cumulative distribution function;\n\nif FALSE(), it returns the probability density function.",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"INTERCEPT",t:1,d:"Calculates the y-value at which the line resulting from linear regression of a dataset will intersect the y-axis (x=0).",a:"Y-intercept of line derived via linear regression.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"KURT",t:1,d:'Calculates the kurtosis of a dataset, which describes the shape, and in particular the "peakedness" of that dataset.',a:"Kurtosis of a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the dataset.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the dataset.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"LARGE",t:1,d:"Returns the nth largest element from a data set, where n is user-defined.",a:"Nth largest element from a data set.",m:[2,2],p:[{name:"data",detail:"Array or range containing the dataset to consider.",example:"A2:B100",require:"m",repeat:"n",type:"rangenumber"},{name:"n",detail:"The rank from largest to smallest of the element to return.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"STDEVA",t:1,d:"Calculates the standard deviation based on a sample, setting text to the value `0`.",a:"Standard deviation of sample (text as 0).",m:[1,255],p:[{name:"value1",detail:"The first value or range of the sample.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the sample.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"STDEVP",t:1,d:"Calculates the standard deviation based on an entire population.",a:"Standard deviation of an entire population.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the population.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the population.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"GEOMEAN",t:1,d:"Calculates the geometric mean of a dataset.",a:"The geometric mean of a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the population.",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to include in the population.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"RANK_EQ",t:1,d:"Returns the rank of a specified value in a dataset. If there is more than one entry of the same value in the dataset, the top rank of the entries will be returned.",a:"Top rank of a specified value in a dataset.",m:[2,3],p:[{name:"value",detail:"The value whose rank will be determined.",example:"A10",require:"m",repeat:"n",type:"rangenumber"},{name:"data",detail:"The array or range containing the dataset to consider.",example:"A1:A100",require:"m",repeat:"n",type:"range"},{name:"is_ascending",detail:"Whether to consider the values in `data` in descending or ascending order. If omitted, the default is descending (FALSE).",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"RANK_AVG",t:1,d:"Returns the rank of a specified value in a dataset. If there is more than one entry of the same value in the dataset, the average rank of the entries will be returned.",a:"Average rank of a specified value in a dataset.",m:[2,3],p:[{name:"value",detail:"The value whose rank will be determined.",example:"A10",require:"m",repeat:"n",type:"rangenumber"},{name:"data",detail:"The array or range containing the dataset to consider.",example:"A1:A100",require:"m",repeat:"n",type:"range"},{name:"is_ascending",detail:"Whether to consider the values in `data` in descending or ascending order. If omitted, the default is descending (FALSE).",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"PERCENTRANK_EXC",t:1,d:"Returns the percentage rank (percentile) from 0 to 1 exclusive of a specified value in a dataset.",a:"Percentage rank (percentile) from 0 to 1 exclusive.",m:[2,3],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A1:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value",detail:"The value whose percentage rank will be determined.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"significant_digits",detail:"The number of significant figures to use in the calculation. Default is 3.",example:"4",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PERCENTRANK_INC",t:1,d:"Returns the percentage rank (percentile) from 0 to 1 inclusive of a specified value in a dataset.",a:"Percentage rank (percentile) from 0 to 1 inclusive.",m:[2,3],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A1:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value",detail:"The value whose percentage rank will be determined.",example:" A2",require:"m",repeat:"n",type:"rangenumber"},{name:"significant_digits",detail:"The number of significant figures to use in the calculation. Default is 3.",example:"4",require:"o",repeat:"n",type:"rangenumber"}]},{n:"FORECAST",t:1,d:"Calculates the expected y-value for a specified x based on a linear regression of a dataset.",a:"Expected y-value based of linear regression.",m:[3,3],p:[{name:"x",detail:"The value on the x-axis to forecast.",example:"A1",require:"m",repeat:"n",type:"rangenumber"},{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FISHERINV",t:1,d:"Returns the inverse Fisher transformation of a specified value.",a:"Inverse fisher transformation of a specified value.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the inverse Fisher transformation.",example:"0.962",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FISHER",t:1,d:"Returns the Fisher transformation of a specified value.",a:"Fisher transformation of a specified value.",m:[1,1],p:[{name:"value",detail:"The value for which to calculate the Fisher transformation.",example:"0.962",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MODE_SNGL",t:1,d:"Returns the most commonly occurring value in a dataset.",a:"Most commonly occurring value in a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating mode.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to consider when calculating mode.",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"WEIBULL_DIST",t:1,d:"Returns the value of the Weibull distribution function (or Weibull cumulative distribution function) for a specified shape and scale.",a:"Weibull distribution function.",m:[4,4],p:[{name:"x",detail:"The input to the Weibull distribution function.",example:"2.4",require:"m",repeat:"n",type:"rangenumber"},{name:"shape",detail:"The shape parameter of the Weibull distribution function.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"scale",detail:"The scale parameter of the Weibull distribution function.",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Whether to use the cumulative distribution function.",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"COUNT",t:1,d:"Returns the number of numeric values in a dataset.",a:"The number of numeric values in dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when counting.",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to consider when counting.",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"COUNTA",t:1,d:"Returns the number of values in a dataset.",a:"The number of values in a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when counting.",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to consider when counting.",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"AVEDEV",t:1,d:"Calculates the average of the magnitudes of deviations of data from a dataset's mean.",a:"Average magnitude of deviations from mean.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the sample.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the sample.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"AVERAGE",t:1,d:"Returns the numerical average value in a dataset, ignoring text.",a:"Numerical average value in a dataset, ignoring text.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the average value.",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to consider when calculating the average value.",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"AVERAGEA",t:1,d:"Returns the numerical average value in a dataset.",a:"Numerical average value in a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the average value.",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to consider when calculating the average value.",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"BINOM_DIST",t:1,d:"Calculates the probability of drawing a certain number of successes (or a maximum number of successes) in a certain number of tries given a population of a certain size containing a certain number of successes, with replacement of draws.",a:"Binomial distribution probability.",m:[4,4],p:[{name:"num_successes",detail:"The number of successes for which to calculate the probability in `num_trials` trials.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"num_trials",detail:"The number of independent trials.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"prob_success",detail:"The probability of success in any given trial.",example:"0.005",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Whether to use the binomial cumulative distribution.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"BINOM_INV",t:1,d:"Calculates the smallest value for which the cumulative binomial distribution is greater than or equal to a specified criteria.",a:"Inverse cumulative binomial distribution function.",m:[3,3],p:[{name:"num_trials",detail:"The number of independent trials.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"prob_success",detail:"The probability of success in any given trial.",example:"0.005",require:"m",repeat:"n",type:"rangenumber"},{name:"target_prob",detail:"The desired threshold probability.",example:"0.8",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CONFIDENCE_NORM",t:1,d:"Calculates the width of half the confidence interval for a normal distribution.",a:"Confidence interval for a normal distribution.",m:[3,3],p:[{name:"alpha",detail:"One minus the desired confidence level. E.g. `0.1` for `0.9`, or 90%, confidence.",example:"0.05",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation of the population.",example:"1.6",require:"m",repeat:"n",type:"rangenumber"},{name:"pop_size",detail:"The size of the population.",example:"250",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CORREL",t:1,d:"Calculates r, the Pearson product-moment correlation coefficient of a dataset.",a:"Pearson Product-Moment Correlation Coefficient.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COVARIANCE_P",t:1,d:"Calculates the covariance of a dataset.",a:"The covariance of a dataset.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COVARIANCE_S",t:1,d:"Calculates the sample covariance of a dataset.",a:"The sample covariance of a dataset.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DEVSQ",t:1,d:"Calculates the sum of squares of deviations based on a sample.",a:"The sum of squares of deviations based on a sample.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the sample.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the sample.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"EXPON_DIST",t:1,d:"Returns the value of the exponential distribution function with a specified lambda at a specified value.",a:"Exponential distribution function.",m:[3,3],p:[{name:"x",detail:"The input to the exponential distribution function.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"lambda",detail:"The lambda to specify the exponential distribution function.",example:"0.5",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Whether to use the exponential cumulative distribution.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"AVERAGEIF",t:1,d:"Returns the average of a range depending on criteria.",a:"Average of values depending on criteria.",m:[2,3],p:[{name:"criteria_range",detail:"The range to check against `criterion`.",example:"A1:A10",require:"m",repeat:"n",type:"rangeall"},{name:"criterion",detail:"The pattern or test to apply to `criteria_range`.",example:'">20"',require:"m",repeat:"n",type:"rangeall"},{name:"average_range",detail:"The range to average. If not included, `criteria_range` is used for the average instead.",example:"B1:B10",require:"o",repeat:"n",type:"rangeall"}]},{n:"AVERAGEIFS",t:1,d:"Returns the average of a range depending on multiple criteria.",a:"Average of values depending on multiple criteria.",m:[2,255],p:[{name:"average_range",detail:"The range to average.",example:"A1:A10",require:"m",repeat:"n",type:"rangeall"},{name:"criteria_range1",detail:"The range to check against `criterion1`.",example:" B1:B10",require:"m",repeat:"n",type:"rangeall"},{name:"criterion1",detail:"The pattern or test to apply to `criteria_range1`.",example:' ">20"',require:"m",repeat:"n",type:"rangeall"},{name:"criteria_range2",detail:"Additional ranges to check.",example:" C1:C10",require:"m",repeat:"n",type:"rangeall"}]},{n:"PERMUT",t:1,d:"Returns the number of ways to choose some number of objects from a pool of a given size of objects, considering order.",a:"Number of permutations from a number of objects.",m:[2,2],p:[{name:"n",detail:"The size of the pool of objects to choose from.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"k",detail:"The number of objects to choose.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TRIMMEAN",t:1,d:"Calculates the mean of a dataset excluding some proportion of data from the high and low ends of the dataset.",a:"Mean of a dataset excluding high/low ends.",m:[2,2],p:[{name:"data",detail:"Array or range containing the dataset to consider.",example:"A2:A100",require:"m",repeat:"n",type:"range"},{name:"exclude_proportion",detail:"The proportion of the dataset to exclude, from the extremities of the set.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PERCENTILE_EXC",t:1,d:"Returns the value at a given percentile of a dataset exclusive of 0 and 1.",a:"Value at a given percentile of a dataset exclusive of 0 and 1.",m:[2,2],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"percentile",detail:"The percentile, exclusive of 0 and 1, whose value within 'data' will be calculated and returned.",example:"0.25",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PERCENTILE_INC",t:1,d:"Returns the value at a given percentile of a dataset.",a:"Value at a given percentile of a dataset.",m:[2,2],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"percentile",detail:"The percentile whose value within `data` will be calculated and returned.`",example:"0.25",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PEARSON",t:1,d:"Calculates r, the Pearson product-moment correlation coefficient of a dataset.",a:"Pearson Product-Moment Correlation Coefficient.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NORM_S_INV",t:1,d:"Returns the value of the inverse standard normal distribution function for a specified value.",a:"Inverse standard normal distribution function.",m:[1,1],p:[{name:"x",detail:"The input to the inverse standard normal distribution function.",example:"0.75",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NORM_S_DIST",t:1,d:"Returns the value of the standard normal cumulative distribution function for a specified value.",a:"Standard normal cumulative distribution function.",m:[2,2],p:[{name:"x",detail:"The input to the standard normal cumulative distribution function.",example:"2.4",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Determine the logical value of the function form. \n\nIf TRUE(), it returns the cumulative distribution function;\n\nIf it is FALSE(), it returns the probability density function.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"NORM_INV",t:1,d:"Returns the value of the inverse normal distribution function for a specified value, mean, and standard deviation.",a:"Inverse normal distribution function.",m:[3,3],p:[{name:"x",detail:"The input to the inverse normal distribution function.",example:"0.75",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"The mean (mu) of the normal distribution function.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation (sigma) of the normal distribution function.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NORM_DIST",t:1,d:"Returns the value of the normal distribution function (or normal cumulative distribution function) for a specified value, mean, and standard deviation.",a:"Normal distribution function.",m:[4,4],p:[{name:"x",detail:"The input to the normal distribution function.",example:"2.4",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"The mean (mu) of the normal distribution function.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation (sigma) of the normal distribution function.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Whether to use the normal cumulative distribution function rather than the distribution function.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"NEGBINOM_DIST",t:1,d:"Calculates the probability of drawing a certain number of failures before a certain number of successes given a probability of success in independent trials.",a:"Negative binomial distribution probability.",m:[4,4],p:[{name:"num_failures",detail:"The number of failures to model.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"num_successes",detail:"The number of successes to model.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"prob_success",detail:"The probability of success in any given trial.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Determine the logical value of the function form. \n\nIf TRUE(), it returns the cumulative distribution function;\n\nIf it is FALSE(), it returns the probability density function.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"MINA",t:1,d:"Returns the minimum numeric value in a dataset.",a:"Minimum numeric value in a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the minimum value.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to consider when calculating the minimum value.",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MIN",t:1,d:"Returns the minimum value in a numeric dataset.",a:"Minimum value in a numeric dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the minimum value.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to consider when calculating the minimum value.",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MEDIAN",t:1,d:"Returns the median value in a numeric dataset.",a:"Median value in a numeric dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the median value.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to consider when calculating the median value.",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MAXA",t:1,d:"Returns the maximum numeric value in a dataset.",a:"Maximum numeric value in a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the maximum value.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to consider when calculating the maximum value.",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MAX",t:1,d:"Returns the maximum value in a numeric dataset.",a:"Maximum value in a numeric dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range to consider when calculating the maximum value.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to consider when calculating the maximum value.",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"LOGNORM_INV",t:1,d:"Returns the value of the inverse log-normal cumulative distribution with given mean and standard deviation at a specified value.",a:"Inverse log-normal cumulative distribution function.",m:[3,3],p:[{name:"x",detail:"The input to the inverse log-normal cumulative distribution function.",example:"0.4",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"The mean (mu) of the inverse log-normal cumulative distribution function.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation (sigma) of the inverse log-normal cumulative distribution function.",example:"6",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LOGNORM_DIST",t:1,d:"Returns the value of the log-normal cumulative distribution with given mean and standard deviation at a specified value.",a:"Log-normal cumulative distribution probability.",m:[4,4],p:[{name:"x",detail:"The input to the log-normal cumulative distribution function.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"The mean (mu) of the log-normal cumulative distribution function.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation (sigma) of the log-normal cumulative distribution function.",example:"6",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Determine the logical value of the function form. \n\nIf TRUE(), it returns the cumulative distribution function;\n\nIf it is FALSE(), it returns the probability density function.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"Z_TEST",t:1,d:"Returns the one-tailed p-value of a Z-test with standard distribution.",a:"One-tailed p-value of a z-test.",m:[2,3],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A2:A100",require:"m",repeat:"n",type:"range"},{name:"value",detail:"The test statistic to use in the Z-test.",example:"B2",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation to assume for the Z-test. If this is not provided, the standard deviation of the data will be used.",example:"3",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PROB",t:1,d:"Given a set of values and corresponding probabilities, calculates the probability that a value chosen at random falls between two limits.",a:"Probability values lie in a range.",m:[3,4],p:[{name:"data",detail:"Array or range containing the dataset to consider.",example:"A3:A6",require:"m",repeat:"n",type:"range"},{name:"probabilities",detail:"Array or range containing probabilities corresponding to `data`.",example:"2",require:"m",repeat:"n",type:"range"},{name:"low_limit",detail:"The lower bound on the value range for which to calculate the probability.",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"high_limit",detail:"The upper bound on the value range for which to calculate the probability.",example:"4",require:"o",repeat:"n",type:"rangenumber"}]},{n:"QUARTILE_EXC",t:1,d:"Returns a value nearest to a specified quartile of a dataset exclusive of 0 and 4.",a:"Value nearest to a specific quartile of a dataset exclusive of 0 and 4.",m:[2,2],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"quartile_number",detail:"Which quartile to return.",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"QUARTILE_INC",t:1,d:"Returns a value nearest to a specified quartile of a dataset.",a:"Value nearest to a specific quartile of a dataset.",m:[2,2],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"quartile_number",detail:"Which quartile value to return.",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"POISSON_DIST",t:1,d:"Returns the value of the Poisson distribution function (or Poisson cumulative distribution function) for a specified value and mean.",a:"Poisson distribution function.",m:[3,3],p:[{name:"x",detail:"The input to the Poisson distribution function.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"The mean (mu) of the Poisson distribution function.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Whether to use the Poisson cumulative distribution function rather than the distribution function.",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"RSQ",t:1,d:"Calculates the square of r, the Pearson product-moment correlation coefficient of a dataset.",a:"Square of the correlation coefficient.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_DIST",t:1,d:"Calculates the left tail probability for a Student's t-distribution with a given input (x).",a:"The left-tailed Student's t-distribution",m:[3,3],p:[{name:"x",detail:"The input to the t-distribution function.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"The number of degrees of freedom.",example:"30",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"If cumulative is TRUE, T.DIST returns the cumulative distribution function; if FALSE, it returns the probability density function.",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"T_DIST_2T",t:1,d:"Calculates the probability for two tailed Student's t-distribution with a given input (x).",a:"The two tailed Student's t-distribution",m:[2,2],p:[{name:"x",detail:"The input to the t-distribution function.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"The number of degrees of freedom.",example:"30",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_DIST_RT",t:1,d:"Calculates the right tail probability for a Student's t-distribution with a given input (x).",a:"The right-tailed Student's t-distribution",m:[2,2],p:[{name:"x",detail:"The input to the t-distribution function.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"The number of degrees of freedom.",example:"30",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_INV",t:1,d:"Calculates the negative inverse of the one-tailed TDIST function.",a:"T.INV",m:[2,2],p:[{name:"probability",detail:"The probability associated with the two-tailed t-distribution.",example:"0.35",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"The number of degrees of freedom.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_INV_2T",t:1,d:"Calculates the inverse of the two-tailed TDIST function.",a:"T.INV.2T",m:[2,2],p:[{name:"probability",detail:"The probability associated with the two-tailed t-distribution.",example:"0.35",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"The number of degrees of freedom.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_TEST",t:1,d:"t-test. Returns the probability associated with Student's t-test. Determines whether two samples are likely to have come from the same two underlying populations that have the same mean.",a:"Returns the probability associated with t-test.",m:[4,4],p:[{name:"range1",detail:"The first sample of data or group of cells to consider for the t-test.",example:"A1:A4",require:"m",repeat:"n",type:"rangenumber"},{name:"range2",detail:"The second sample of data or group of cells to consider for the t-test.",example:"B1:B4",require:"m",repeat:"n",type:"rangenumber"},{name:"tails",detail:"Specifies the number of distribution tails.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"type",detail:"Specifies the type of t-test.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"F_DIST",t:1,d:"Calculates the left-tailed F probability distribution (degree of diversity) for two data sets with given input x. Alternately called Fisher-Snedecor distribution or Snedecor's F distribution.",a:"F probability distribution (left-tailed).",m:[4,4],p:[{name:"x",detail:"The input to the F probability distribution function. The value at which to evaluate the function.",example:"15.35",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom1",detail:"The numerator of the number of degrees of freedom.",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom2",detail:"The denominator of the number of degrees of freedom.",example:"6",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"Logical value that determines the form of the function.",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"F_DIST_RT",t:1,d:"Calculates the right-tailed F probability distribution (degree of diversity) for two data sets with given input x. Alternately called Fisher-Snedecor distribution or Snedecor's F distribution.",a:"F probability distribution.",m:[3,3],p:[{name:"x",detail:"The input to the F probability distribution function. The value at which to evaluate the function.",example:"15.35",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom1",detail:"The numerator of the number of degrees of freedom.",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom2",detail:"The denominator of the number of degrees of freedom.",example:"6",require:"m",repeat:"n",type:"rangenumber"}]},{n:"VAR_P",t:1,d:"Calculates the variance based on an entire population.",a:"Variance of entire population.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the population.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the population.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"VAR_S",t:1,d:"Calculates the variance based on a sample.",a:"Variance.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the sample.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the sample.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"VARA",t:1,d:"Calculates the variance based on a sample, setting text to the value `0`.",a:"Variance of sample (text as 0).",m:[1,255],p:[{name:"value1",detail:"The first value or range of the sample.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the sample.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"VARPA",t:1,d:"Calculates the variance based on an entire population, setting text to the value `0`.",a:"Variance of entire population (text as 0).",m:[1,255],p:[{name:"value1",detail:"The first value or range of the population.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"Additional values or ranges to include in the population.",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"STEYX",t:1,d:"Calculates the standard error of the predicted y-value for each x in the regression of a dataset.",a:"Standard error of predicted y-values in regression.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"STANDARDIZE",t:1,d:"Calculates the normalized equivalent of a random variable given mean and standard deviation of the distribution.",a:"Normalized equivalent of a random variable.",m:[3,3],p:[{name:"value",detail:"The value of the random variable to normalize.",example:"96",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"The mean of the distribution.",example:"80",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_deviation",detail:"The standard deviation of the distribution.",example:"6.7",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SMALL",t:1,d:"Returns the nth smallest element from a data set, where n is user-defined.",a:"Nth smallest element in a data set.",m:[2,2],p:[{name:"data",detail:"The array or range containing the dataset to consider.",example:"A2:B100",require:"m",repeat:"n",type:"range"},{name:"n",detail:"The rank from smallest to largest of the element to return.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SLOPE",t:1,d:"Calculates the slope of the line resulting from linear regression of a dataset.",a:"Slope of line from linear regression of data.",m:[2,2],p:[{name:"data_y",detail:"The range representing the array or matrix of dependent data.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"data_x",detail:"The range representing the array or matrix of independent data.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SKEW",t:1,d:"Calculates the skewness of a dataset, which describes the symmetry of that dataset about the mean.",a:"Skewness of a dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the dataset.",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to include in the dataset.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"SKEW_P",t:1,d:"Calculates the skewness of a dataset, which describes the symmetry of that dataset about the mean. This assumes the dataset is for the population.",a:"Skewness of a population's dataset.",m:[1,255],p:[{name:"value1",detail:"The first value or range of the dataset.",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional values or ranges to include in the dataset.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"VLOOKUP",t:2,d:"Vertical lookup. Searches down the first column of a range for a key and returns the value of a specified cell in the row found.",a:"Vertical lookup.",m:[3,4],p:[{name:"search_key",detail:'The value to search for. For example, `42`, `"Cats"`, or `I24`.',example:"10003",require:"m",repeat:"n",type:"rangeall"},{name:"range",detail:"The range to consider for the search. The first column in the range is searched for the key specified in `search_key`.",example:"A2:B26",require:"m",repeat:"n",type:"rangeall"},{name:"index",detail:"The column index of the value to be returned, where the first column in `range` is numbered 1.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"is_sorted",detail:"Indicates whether the column to be searched (the first column of the specified range) is sorted, in which case the closest match for `search_key` will be returned.",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"HLOOKUP",t:2,d:"Horizontal lookup. Searches across the first row of a range for a key and returns the value of a specified cell in the column found.",a:"Horizontal lookup",m:[3,4],p:[{name:"search_key",detail:'The value to search for. For example, `42`, `"Cats"`, or `I24`.',example:"10003",require:"m",repeat:"n",type:"rangeall"},{name:"range",detail:"The range to consider for the search. The first row in the range is searched for the key specified in `search_key`.",example:"A2:Z6",require:"m",repeat:"n",type:"rangeall"},{name:"index",detail:"The row index of the value to be returned, where the first row in `range` is numbered 1.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"is_sorted",detail:"Indicates whether the row to be searched (the first row of the specified range) is sorted.",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"LOOKUP",t:2,d:"Looks through a sorted row or column for a key and returns the value of the cell in a result range located in the same position as the search row or column.",a:"Look up a value.",m:[2,3],p:[{name:"search_key",detail:'The value to search for in the row or column. For example, `42`, `"Cats"`, or `I24`.',example:"10003",require:"m",repeat:"n",type:"rangeall"},{name:"search_range|search_result_array",detail:"One method of using this function is to provide a single sorted row or column `search_range` to look through for the `search_key` with a second argument `result_range`. The other way is to combine these two arguments into one `search_result_array` where the first row or column is searched and a value is returned from the last row or column in the array. If `search_key` is not found, a non-exact match may be returned.",example:"A1:A100",require:"m",repeat:"n",type:"rangeall"},{name:"result_range",detail:"The range from which to return a result. The value returned corresponds to the location where `search_key` is found in `search_range`. This range must be only a single row or column and should not be used if using the `search_result_array` method.",example:"B1:B100",require:"o",repeat:"n",type:"rangeall"}]},{n:"ADDRESS",t:2,d:"Returns a cell reference as a string.",a:"Cell reference as a string.",m:[2,5],p:[{name:"row",detail:"The row number of the cell reference",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"column",detail:"The column number (not name) of the cell reference. `A` is column number `1`.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"absolute_relative_mode",detail:"An indicator of whether the reference is row/column absolute. `1` is row and column absolute (e.g. $A$1), `2` is row absolute and column relative (e.g. A$1), `3` is row relative and column absolute (e.g. $A1), and `4` is row and column relative (e.g. A1).",example:"4",require:"o",repeat:"n",type:"rangenumber"},{name:"use_a1_notation",detail:"A boolean indicating whether to use `A1` style notation (TRUE) or `R1C1` style notation (FALSE).",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"},{name:"sheet",detail:"Text indicating the name of the sheet into which the address points.",example:'"Sheet2"',require:"o",repeat:"n",type:"rangeall"}]},{n:"INDIRECT",t:2,d:"Returns a cell reference specified by a string.",a:"A cell reference specified by a string.",m:[1,2],p:[{name:"cell_reference_as_string",detail:"A cell reference, written as a string with surrounding quotation marks.",example:'"Sheet2!"&B10',require:"m",repeat:"n",type:"rangeall"},{name:"is_A1_notation",detail:"Indicates if the cell reference is in A1 notation (TRUE) or R1C1 notation (FALSE).",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"ROW",t:2,d:"Returns the row number of a specified cell.",a:"Row number of a specified cell.",m:[0,1],p:[{name:"cell_reference",detail:"The cell whose row number will be returned.",example:"A9",require:"o",repeat:"n",type:"rangeall"}]},{n:"ROWS",t:2,d:"Returns the number of rows in a specified array or range.",a:"Number of rows in a specified array or range.",m:[1,1],p:[{name:"range",detail:"The range whose row count will be returned.",example:"A9:A62",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COLUMN",t:2,d:"Returns the column number of a specified cell, with `A=1`.",a:"Column number of a specified cell.",m:[0,1],p:[{name:"cell_reference",detail:"The cell whose column number will be returned. Column `A` corresponds to `1`.",example:"A9",require:"o",repeat:"n",type:"rangeall"}]},{n:"COLUMNS",t:2,d:"Returns the number of columns in a specified array or range.",a:"Number of columns in a specified array or range.",m:[1,1],p:[{name:"range",detail:"The range whose column count will be returned.",example:"A9:W62",require:"m",repeat:"n",type:"rangenumber"}]},{n:"OFFSET",t:2,d:"Returns a range reference shifted a specified number of rows and columns from a starting cell reference.",a:"A range reference offset relative to a cell.",m:[3,5],p:[{name:"cell_reference",detail:"The starting point from which to count the offset rows and columns.",example:"A2",require:"m",repeat:"n",type:"range"},{name:"offset_rows",detail:"The number of rows to offset by.",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"offset_columns",detail:"The number of columns to offset by.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"height",detail:"The height of the range to return starting at the offset target.",example:"2",require:"o",repeat:"n",type:"rangenumber"},{name:"width",detail:"The width of the range to return starting at the offset target.",example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"MATCH",t:2,d:"Returns the relative position of an item in a range that matches a specified value.",a:"Position of item in range that matches value.",m:[2,3],p:[{name:"search_key",detail:'The value to search for. For example, `42`, `"Cats"`, or `I24`.',example:'"Sunday"',require:"m",repeat:"n",type:"rangeall"},{name:"range",detail:"The one-dimensional array to be searched.",example:"A2:A9",require:"m",repeat:"n",type:"range"},{name:"search_type",detail:"The search method. `1` (default) finds the largest value less than or equal to `search_key` when `range` is sorted in ascending order. `0` finds the exact value when `range` is unsorted. `-1` finds the smallest value greater than or equal to `search_key` when `range` is sorted in descending order.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"INDEX",t:2,d:"Returns the content of a cell, specified by row and column offset.",a:"Content of cell specified by row and column offset.",m:[2,3],p:[{name:"reference",detail:"The array of cells to be offset into.",example:"A1:C20",require:"m",repeat:"n",type:"range"},{name:"row",detail:"The number of offset rows.",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"column",detail:"The number of offset columns.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GETPIVOTDATA",t:2,d:"Extracts an aggregated value from a pivot table that corresponds to the specified row and column headings.",a:"Extracts an aggregated value from a pivot table that corresponds to the specified row and column headings.",m:[2,254],p:[{name:"value_name",detail:"The name of the value in the pivot table for which you want to get data.",example:'"SUM of number of units"',require:"m",repeat:"n",type:"rangeall"},{name:"any_pivot_table_cell",detail:"Any reference to a cell in the desired pivot table (top corner recommended).",example:"'Pivot table'!A1",require:"m",repeat:"n",type:"rangeall"},{name:"original_column",detail:"The name of the column in the original data set (not the pivot table).",example:'"division"',require:"o",repeat:"y",type:"rangeall"},{name:"pivot_item",detail:"The name of the row or column shown in the pivot table corresponding to *original_column* that you want to retrieve.",example:'"east"',require:"o",repeat:"y",type:"rangeall"}]},{n:"CHOOSE",t:2,d:"Returns an element from a list of choices based on index.",a:"An element from a list of choices based on index.",m:[2,255],p:[{name:"index",detail:"Which choice (of the up to 30 provided) to return.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"choice1",detail:"A potential value to return. Required. May be a reference to a cell or an individual value.",example:'"A"',require:"m",repeat:"n",type:"rangeall"},{name:"choice2",detail:"Additional values among which to choose.",example:'"B"',require:"o",repeat:"y",type:"rangeall"}]},{n:"HYPERLINK",t:2,d:"Creates a hyperlink inside a cell.",a:"Creates a hyperlink inside a cell.",p:[{name:"url",detail:"The full URL of the link location enclosed in quotation marks, or a reference to a cell containing such a URL.",example:'"http://www.luckysheet.com/"',require:"m",repeat:"n",type:"rangeall"},{name:"link_label",detail:"The text to display in the cell as the link, enclosed in quotation marks, or a reference to a cell containing such a label.",example:'"luckysheet"',require:"m",repeat:"n",type:"rangeall"}]},{n:"TIME",t:6,d:"Converts a provided hour, minute, and second into a time.",a:"Converts hour/minute/second into a time.",m:[3,3],p:[{name:"hour",detail:"The hour component of the time.",example:"11",require:"m",repeat:"n",type:"rangenumber"},{name:"minute",detail:"The minute component of the time.",example:"40",require:"m",repeat:"n",type:"rangenumber"},{name:"second",detail:"The second component of the time.",example:"59",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TIMEVALUE",t:6,d:"Returns the fraction of a 24-hour day the time represents.",a:"Converts a time string into its serial number representation.",m:[1,1],p:[{name:"time_string",detail:"The string that holds the time representation.",example:'"2:15 PM"',require:"m",repeat:"n",type:"rangeall"}]},{n:"EOMONTH",t:6,d:"Returns a date on the last day of a month that falls a specified number of months before or after another date.",a:"Last day of a month before or after a date.",m:[2,2],p:[{name:"start_date",detail:"The date from which to calculate the result.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"months",detail:"The number of months before (negative) or after (positive) 'start_date' to consider.",example:"7",require:"m",repeat:"n",type:"rangenumber"}]},{n:"EDATE",t:6,d:"Returns a date a specified number of months before or after another date.",a:"Date a number of months before/after another date.",m:[2,2],p:[{name:"start_date",detail:"The date from which to calculate the result.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"months",detail:"The number of months before (negative) or after (positive) 'start_date' to calculate.",example:"7",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SECOND",t:6,d:"Returns the second component of a specific time, in numeric format.",a:"Second component of a specific time.",m:[1,1],p:[{name:"time",detail:"The time from which to calculate the second component",example:"TIME(11",require:"m",repeat:"n",type:"rangeall"}]},{n:"MINUTE",t:6,d:"Returns the minute component of a specific time, in numeric format.",a:"Minute component of a specific time.",m:[1,1],p:[{name:"time",detail:"The time from which to calculate the minute component.",example:"TIME(11",require:"m",repeat:"n",type:"rangeall"}]},{n:"HOUR",t:6,d:"Returns the hour component of a specific time, in numeric format.",a:"Hour component of a specific time.",m:[1,1],p:[{name:"time",detail:"The time from which to calculate the hour component.",example:"TIME(11",require:"m",repeat:"n",type:"rangeall"}]},{n:"NOW",t:6,d:"Returns the current date and time as a date value.",a:"Current date and time as a date value.",m:[0,0],p:[]},{n:"NETWORKDAYS",t:6,d:"Returns the number of net working days between two provided days.",a:"Net working days between two provided days.",m:[2,3],p:[{name:"start_date",detail:"The start date of the period from which to calculate the number of net working days.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"The end date of the period from which to calculate the number of net working days.",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"holidays",detail:"A range or array constant containing the date serial numbers to consider holidays.",example:"16)",require:"o",repeat:"n",type:"rangeall"}]},{n:"NETWORKDAYS_INTL",t:6,d:"Returns the number of net working days between two provided days excluding specified weekend days and holidays.",a:"Net working days between two dates (specifying weekends).",m:[2,4],p:[{name:"start_date",detail:"The start date of the period from which to calculate the number of net working days.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"The end date of the period from which to calculate the number of net working days.",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"weekend",detail:"A number or string representing which days of the week are considered weekends.",example:"16)",require:"o",repeat:"n",type:"rangeall"},{name:"holidays",detail:"A range or array constant containing the dates to consider as holidays.",example:"DATE(1969",require:"o",repeat:"n",type:"rangeall"}]},{n:"ISOWEEKNUM",t:6,d:"Returns a number representing the ISO week of the year where the provided date falls.",a:"ISO week number of the year.",m:[1,1],p:[{name:"date",detail:"The date for which to determine the ISO week number. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"WEEKNUM",t:6,d:"Returns a number representing the week of the year where the provided date falls.",a:"Week number of the year.",m:[1,2],p:[{name:"date",detail:"The date for which to determine the week number. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"type",detail:"A number representing the day that a week starts on. Sunday = 1.",example:"7",require:"o",repeat:"n",type:"rangenumber"}]},{n:"WEEKDAY",t:6,d:"Returns a number representing the day of the week of the date provided.",a:"Day of the week of the date provided (as number).",m:[1,2],p:[{name:"date",detail:"The date for which to determine the day of the week. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"type",detail:"A number indicating which numbering system to use to represent weekdays. By default, counts starting with Sunday = 1.",example:"7",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DAY",t:6,d:"Returns the day of the month that a specific date falls on, in numeric format.",a:"Day of the month that a specific date falls on.",m:[1,1],p:[{name:"date",detail:"The date from which to extract the day.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"DAYS",t:6,d:"Returns the number of days between two dates.",a:"Number of days between two dates.",m:[2,2],p:[{name:"end_date",detail:"The end of the date range.",example:"2011-3-15",require:"m",repeat:"n",type:"rangeall"},{name:"start_date",detail:"The start of the date range.",example:"2011-2-1",require:"m",repeat:"n",type:"rangeall"}]},{n:"DAYS360",t:6,d:"Returns the difference between two days based on the 360 day year used in some financial interest calculations.",a:"Days between two dates on a 360-day year.",m:[2,3],p:[{name:"start_date",detail:"The start date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"The end date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"method",detail:"An indicator of what day count method to use.",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"DATE",t:6,d:"Converts a provided year, month, and day into a date.",a:"Converts year/month/day into a date.",m:[3,3],p:[{name:"year",detail:"The year component of the date.",example:"1969",require:"m",repeat:"n",type:"rangenumber"},{name:"month",detail:"The month component of the date.",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"day",detail:"The day component of the date.",example:"20",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DATEVALUE",t:6,d:"Converts a provided date string in a known format to a date value.",a:"Converts a date string to a date value.",m:[1,1],p:[{name:"date_string",detail:"The string representing the date.",example:'"1969-7-20"',require:"m",repeat:"n",type:"rangeall"}]},{n:"DATEDIF",t:6,d:"Calculates the number of days, months, or years between two dates.",a:"Date Difference.",m:[3,3],p:[{name:"start_date",detail:"The start date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"The end date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"unit",detail:'A string abbreviation for unit of time. For example, "M" for month. Accepted values are "Y","M","D","MD","YM","YD".',example:"16)",require:"m",repeat:"n",type:"rangeall"}]},{n:"WORKDAY",t:6,d:"Calculates the date after a number of working days from a specified start date.",a:"Number of working days from start date.",m:[2,3],p:[{name:"start_date",detail:"The date from which to begin counting.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"num_days",detail:"The number of working days to advance from `start_date`. If negative, counts backwards.",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"holidays",detail:"A range or array constant containing the dates to consider holidays.",example:"16)",require:"o",repeat:"n",type:"rangeall"}]},{n:"WORKDAY_INTL",t:6,d:"Calculates the date after a specified number of workdays excluding specified weekend days and holidays.",a:"Date after a number of workdays (specifying weekends).",m:[2,4],p:[{name:"start_date",detail:"The date from which to begin counting.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"num_days",detail:"The number of working days to advance from `start_date`. If negative, counts backwards.",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"weekend",detail:"A number or string representing which days of the week are considered weekends.",example:"16)",require:"o",repeat:"n",type:"rangeall"},{name:"holidays",detail:"A range or array constant containing the dates to consider holidays.",example:"DATE(1969",require:"o",repeat:"n",type:"rangeall"}]},{n:"YEAR",t:6,d:"Returns the year specified by a given date.",a:"Year specified by a given date.",m:[1,1],p:[{name:"date",detail:"The date from which to extract the year.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"YEARFRAC",t:6,d:"Returns the number of years, including fractional years, between two dates using a specified day count convention.",a:"Exact number of years between two dates.",m:[2,3],p:[{name:"start_date",detail:"The start date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"The end date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"16)",require:"o",repeat:"n",type:"rangenumber"}]},{n:"TODAY",t:6,d:"Returns the current date as a date value.",a:"Current date as a date value.",m:[0,0],p:[]},{n:"MONTH",t:6,d:"Returns the month of the year a specific date falls in, in numeric format.",a:"Month of the year a specific date falls in.",m:[1,1],p:[{name:"date",detail:"The date from which to extract the month.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"EFFECT",t:8,d:"Calculates the annual effective interest rate given the nominal rate and number of compounding periods per year.",a:"Annual effective interest rate.",m:[2,2],p:[{name:"nominal_rate",detail:"The nominal interest rate per year.",example:"0.99",require:"m",repeat:"n",type:"rangenumber"},{name:"periods_per_year",detail:"The number of compounding periods per year.",example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DOLLAR",t:12,d:"Formats a number into the currency specific to your spreadsheet locale.",a:"Formats a number as currency specific to your spreadsheet locale.",m:[1,2],p:[{name:"number",detail:"The value to be formatted.",example:"1.2351",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_places",detail:"The number of decimal places to display.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DOLLARDE",t:8,d:"Converts a price quotation given as a decimal fraction into a decimal value.",a:"Converts a decimal fraction to decimal value.",m:[2,2],p:[{name:"fractional_price",detail:"The price quotation given using fractional decimal conventions.",example:"100.10",require:"m",repeat:"n",type:"rangenumber"},{name:"unit",detail:"The units of the fraction, e.g. `8` for 1/8ths or `32` for 1/32nds.",example:"32",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DOLLARFR",t:8,d:"Converts a price quotation given as a decimal value into a decimal fraction.",a:"Converts a decimal value to decimal fraction.",m:[2,2],p:[{name:"decimal_price",detail:"The price quotation given as a decimal value.",example:"100.125",require:"m",repeat:"n",type:"rangenumber"},{name:"unit",detail:"The units of the desired fraction, e.g. `8` for 1/8ths or `32` for 1/32nds.",example:"32",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DB",t:8,d:"Calculates the depreciation of an asset for a specified period using the arithmetic declining balance method.",a:"Depreciation via declining balance method.",m:[4,5],p:[{name:"cost",detail:"The initial cost of the asset.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"The value of the asset at the end of depreciation.",example:"50",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"The number of periods over which the asset is depreciated.",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"The single period within `life` for which to calculate depreciation.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"month",detail:"The number of months in the first year of depreciation.",example:"10",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DDB",t:8,d:"Calculates the depreciation of an asset for a specified period using the double-declining balance method.",a:"Depreciation via double-declining balance method.",m:[4,5],p:[{name:"cost",detail:"The initial cost of the asset.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"The value of the asset at the end of depreciation.",example:"50",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"The number of periods over which the asset is depreciated.",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"The single period within `life` for which to calculate depreciation.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"factor",detail:"The factor by which depreciation decreases.",example:"2.25",require:"m",repeat:"n",type:"rangenumber"}]},{n:"RATE",t:8,d:"Calculates the interest rate of an annuity investment based on constant-amount periodic payments and the assumption of a constant interest rate.",a:"Interest rate of an annuity investment.",m:[3,6],p:[{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"payment_per_period",detail:"The amount per period to be paid.",example:"-100",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"400",require:"m",repeat:"n",type:"rangenumber"},{name:"future_value",detail:"The future value remaining after the final payment has been made.",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"rate_guess",detail:"An estimate for what the interest rate will be.",example:"0.1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"CUMPRINC",t:8,d:"Calculates the cumulative principal paid over a range of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",a:"Cumulative principal paid over a set of periods.",m:[6,6],p:[{name:"rate",detail:"The interest rate.",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"first_period",detail:"The number of the payment period to begin the cumulative calculation.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"last_period",detail:"The number of the payment period to end the cumulative calculation.",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUPNUM",t:8,d:"Calculates the number of coupons, or interest payments, between the settlement date and the maturity date of the investment.",a:"Number of coupons between settlement and maturity.",m:[3,4],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"02",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"SYD",t:8,d:"Calculates the depreciation of an asset for a specified period using the sum of years digits method.",a:"Depreciation via sum of years digits method.",m:[4,4],p:[{name:"cost",detail:"The initial cost of the asset.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"The value of the asset at the end of depreciation.",example:"50",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"The number of periods over which the asset is depreciated.",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"The single period within `life` for which to calculate depreciation.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TBILLEQ",t:8,d:"Calculates the equivalent annualized rate of return of a US Treasury Bill based on discount rate.",a:"Equivalent rate of return for a Treasury bill.",m:[3,3],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"discount",detail:"The discount rate of the bill at time of purchase.",example:"2)",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TBILLYIELD",t:8,d:"Calculates the yield of a US Treasury Bill based on price.",a:"The yield of a us treasury bill based on price.",m:[3,3],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"price",detail:"The price at which the security is bought per 100 face value.",example:"95",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TBILLPRICE",t:8,d:"Calculates the price of a US Treasury Bill based on discount rate.",a:"Price of US treasury bill.",m:[3,3],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"discount",detail:"The discount rate of the bill at time of purchase.",example:"0.09",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PV",t:8,d:"Calculates the present value of an annuity investment based on constant-amount periodic payments and a constant interest rate.",a:"Present value of an annuity investment.",m:[3,5],p:[{name:"rate",detail:"The interest rate.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"payment_amount",detail:"The amount per period to be paid.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"future_value",detail:"The future value remaining after the final payment has been made.",example:"D2",require:"o",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"ACCRINT",t:8,d:"Calculates the accrued interest of a security that has periodic payments.",a:"Accrued interest of security with periodic payments.",m:[6,8],p:[{name:"issue",detail:"The date the security was initially issued.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"first_payment",detail:"The first date interest will be paid.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"10000",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"calc_method",detail:"[Optional-defaults to TRUE()] - A logical value that specifies the method used to calculate the total accrued interest when the settlement date is later than the first interest accrual date. \n\nIf the value is TRUE, the total accrued interest from the issue date to the settlement date is returned. \n\nIf the value is FALSE, return the accrued interest from the first interest accrual date to the settlement date.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"ACCRINTM",t:8,d:"Calculates the accrued interest of a security that pays interest at maturity.",a:"Accrued interest of security paying at maturity.",m:[4,5],p:[{name:"issue",detail:"The date the security was initially issued.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity date of the security.",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"1000",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUPDAYBS",t:8,d:"Calculates the number of days from the first coupon, or interest payment, until settlement.",a:"Number of days from first coupon to settlement.",m:[3,4],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPDAYS",t:8,d:"Calculates the number of days in the coupon, or interest payment, period that contains the specified settlement date.",a:"Days in coupon period containing settlement date.",m:[3,4],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPDAYSNC",t:8,d:"Calculates the number of days from the settlement date until the next coupon, or interest payment.",a:"Days from settlement until next coupon.",m:[3,4],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPNCD",t:8,d:"Calculates next coupon, or interest payment, date after the settlement date.",a:"Next coupon date after the settlement date.",m:[3,4],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"01)",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"DATE(2019",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPPCD",t:8,d:"Calculates last coupon, or interest payment, date before the settlement date.",a:"Last coupon date before settlement date.",m:[3,4],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"01)",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"DATE(2019",require:"o",repeat:"n",type:"rangenumber"}]},{n:"FV",t:8,d:"Calculates the future value of an annuity investment based on constant-amount periodic payments and a constant interest rate.",a:"Future value of an annuity investment.",m:[3,5],p:[{name:"rate",detail:"The interest rate.",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"payment_amount",detail:"The amount per period to be paid.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"400",require:"m",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FVSCHEDULE",t:8,d:"Calculates the future value of some principal based on a specified series of potentially varying interest rates.",a:"Future value of principal from series of rates.",m:[2,2],p:[{name:"principal",detail:"The amount of initial capital or value to compound against.",example:"10000",require:"m",repeat:"n",type:"rangenumber"},{name:"rate_schedule",detail:"A series of interest rates to compound against the `principal`.",example:"A2:A100",require:"m",repeat:"n",type:"range"}]},{n:"YIELD",t:8,d:"Calculates the annual yield of a security paying periodic interest, such as a US Treasury Bond, based on price.",a:"Annual yield of a security paying periodic interest.",m:[6,7],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.057",require:"m",repeat:"n",type:"rangenumber"},{name:"price",detail:"The price at which the security is bought per 100 face value.",example:"95",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"YIELDDISC",t:8,d:"Calculates the annual yield of a discount (non-interest-bearing) security, based on price.",a:"Annual yield of a discount security.",m:[4,5],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"price",detail:"The price at which the security is bought per 100 face value.",example:"95",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NOMINAL",t:8,d:"Calculates the annual nominal interest rate given the effective rate and number of compounding periods per year.",a:"Annual nominal interest rate.",m:[2,2],p:[{name:"effective_rate",detail:"The effective interest rate per year.",example:"0.85",require:"m",repeat:"n",type:"rangenumber"},{name:"periods_per_year",detail:"The number of compounding periods per year.",example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"XIRR",t:8,d:"Calculates the internal rate of return of an investment based on a specified series of potentially irregularly spaced cash flows.",a:"Internal rate of return given non-periodic cashflows.",m:[2,3],p:[{name:"cashflow_amounts",detail:"An array or range containing the income or payments associated with the investment.",example:"B2:B25",require:"m",repeat:"n",type:"range"},{name:"cashflow_dates",detail:"An array or range with dates corresponding to the cash flows in `cashflow_amounts`.",example:"C2:C25",require:"m",repeat:"n",type:"range"},{name:"rate_guess",detail:"An estimate for what the internal rate of return will be.",example:"250",require:"o",repeat:"n",type:"rangenumber"}]},{n:"MIRR",t:8,d:"Calculates the modified internal rate of return on an investment based on a series of periodic cash flows and the difference between the interest rate paid on financing versus the return received on reinvested income.",a:"Modified internal rate of return.",m:[3,3],p:[{name:"cashflow_amounts",detail:"An array or range containing the income or payments associated with the investment.",example:"A2:A25",require:"m",repeat:"n",type:"range"},{name:"financing_rate",detail:"The interest rate paid on funds invested.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"reinvestment_return_rate",detail:"The return (as a percentage) earned on reinvestment of income received from the investment.",example:"0.12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"IRR",t:8,d:"Calculates the internal rate of return on an investment based on a series of periodic cash flows.",a:"Internal rate of return given periodic cashflows.",m:[1,2],p:[{name:"cashflow_amounts",detail:"An array or range containing the income or payments associated with the investment.",example:"A2:A25",require:"m",repeat:"n",type:"range"},{name:"rate_guess",detail:"An estimate for what the internal rate of return will be.",example:"200",require:"o",repeat:"n",type:"rangenumber"}]},{n:"NPV",t:8,d:"Calculates the net present value of an investment based on a series of periodic cash flows and a discount rate.",a:"The net present value of an investment based on a series of periodic cash flows and a discount rate.",m:[2,255],p:[{name:"discount",detail:"The discount rate of the investment over one period.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"cashflow1",detail:"The first future cash flow.",example:"200",require:"m",repeat:"n",type:"rangeall"},{name:"cashflow2",detail:"Additional future cash flows.",example:"250",require:"o",repeat:"y",type:"rangeall"}]},{n:"XNPV",t:8,d:"Calculates the net present value of an investment based on a specified series of potentially irregularly spaced cash flows and a discount rate.",a:"Net present value given non-periodic cashflows.",m:[3,3],p:[{name:"discount",detail:"The discount rate of the investment over one period.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"cashflow_amounts",detail:"A range of cells containing the income or payments associated with the investment.",example:"B2:B25",require:"m",repeat:"n",type:"range"},{name:"cashflow_dates",detail:"A range of cells with dates corresponding to the cash flows in `cashflow_amounts`.",example:"C2:C25",require:"m",repeat:"n",type:"range"}]},{n:"CUMIPMT",t:8,d:"Calculates the cumulative interest over a range of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",a:"Cumulative interest paid over a set of periods.",m:[6,6],p:[{name:"rate",detail:"The interest rate.",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"first_period",detail:"The number of the payment period to begin the cumulative calculation.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"last_period",detail:"The number of the payment period to end the cumulative calculation.",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PMT",t:8,d:"Calculates the periodic payment for an annuity investment based on constant-amount periodic payments and a constant interest rate.",a:"Periodic payment for an annuity investment.",m:[3,5],p:[{name:"rate",detail:"The interest rate.",example:"0.08",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:" 100000",require:"m",repeat:"n",type:"rangenumber"},{name:"future_value",detail:"The future value remaining after the final payment has been made.",example:"D2",require:"m",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"IPMT",t:8,d:"Calculates the payment on interest for an investment based on constant-amount periodic payments and a constant interest rate.",a:"Payment on interest for an investment.",m:[4,6],p:[{name:"rate",detail:"The interest rate.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"The amortization period, in terms of number of periods.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"80000",require:"m",repeat:"n",type:"rangenumber"},{name:"future_value",detail:"The future value remaining after the final payment has been made.",example:"E2",require:"m",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PPMT",t:8,d:"Calculates the payment on the principal of an investment based on constant-amount periodic payments and a constant interest rate.",a:"Payment on the principal of an investment.",m:[4,6],p:[{name:"rate",detail:"The interest rate.",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"The amortization period, in terms of number of periods.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_periods",detail:"The number of payments to be made.",example:"3*12",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"100000",require:"m",repeat:"n",type:"rangenumber"},{name:"future_value",detail:"The future value remaining after the final payment has been made.",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"INTRATE",t:8,d:"Calculates the effective interest rate generated when an investment is purchased at one price and sold at another with no interest or dividends generated by the investment itself.",a:"Calculates effective interest rate.",m:[4,5],p:[{name:"buy_date",detail:"The date of purchase of the investment.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"sell_date",detail:"The date of sale of the investment.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"buy_price",detail:"The price at which the investment was purchased.",example:"100000",require:"m",repeat:"n",type:"rangenumber"},{name:"sell_price",detail:"The price at which the investment was sold.",example:"101200",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PRICE",t:8,d:"Calculates the price of a security paying periodic interest, such as a US Treasury Bond, based on expected yield.",a:"Price of a security paying periodic interest.",m:[6,7],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.057",require:"m",repeat:"n",type:"rangenumber"},{name:"yield",detail:"The expected annual yield of the security.",example:"0.065",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PRICEDISC",t:8,d:"Calculates the price of a discount (non-interest-bearing) security, based on expected yield.",a:"Price of a discount security.",m:[4,5],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"discount",detail:"The discount rate of the security at time of purchase.",example:"0.0525",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PRICEMAT",t:8,d:"Calculates the price of a security paying interest at maturity, based on expected yield.",a:"Price of security paying interest at maturity.",m:[5,6],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"issue",detail:"The date the security was initially issued.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.061",require:"m",repeat:"n",type:"rangenumber"},{name:"yield",detail:"The expected annual yield of the security.",example:"0.061",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"RECEIVED",t:8,d:"Calculates the amount received at maturity for an investment in fixed-income securities purchased on a given date.",a:"Amount received at maturity for a security.",m:[4,5],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"investment",detail:"The amount invested (irrespective of face value of each security).",example:"10000000",require:"m",repeat:"n",type:"rangenumber"},{name:"discount",detail:"The discount rate of the security invested in.",example:"0.0575",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"12",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DISC",t:8,d:"Calculates the discount rate of a security based on price.",a:"The discount rate of a security based on price.",m:[4,5],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"price",detail:"The price at which the security is bought per 100 face value.",example:"97.975",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"The redemption amount per 100 face value, or par.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"12",require:"o",repeat:"n",type:"rangenumber"}]},{n:"NPER",t:8,d:"Calculates the number of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",a:"Number of payment periods for an investment.",m:[3,5],p:[{name:"rate",detail:"The interest rate.",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"payment_amount",detail:"The amount of each payment made.",example:"500",require:"m",repeat:"n",type:"rangenumber"},{name:"present_value",detail:"The current value of the annuity.",example:"40000",require:"m",repeat:"n",type:"rangenumber"},{name:"future_value",detail:"The future value remaining after the final payment has been made.",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"end_or_beginning",detail:"Whether payments are due at the end (`0`) or beginning (`1`) of each period.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"SLN",t:8,d:"Calculates the depreciation of an asset for one period using the straight-line method.",a:"Depreciation of asset using the straight-line method.",m:[3,3],p:[{name:"cost",detail:"The initial cost of the asset.",example:"300000",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"The value of the asset at the end of depreciation.",example:"75000",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"The number of periods over which the asset is depreciated.",example:"10",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DURATION",t:8,d:"Calculates the number of compounding periods required for an investment of a specified present value appreciating at a given rate to reach a target value.",a:"Number of periods for an investment to reach a value.",m:[5,6],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.08",require:"m",repeat:"n",type:"rangenumber"},{name:"yield",detail:"The expected annual yield of the security.",example:"0.09",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"MDURATION",t:8,d:"Calculates the modified Macaulay duration of a security paying periodic interest, such as a US Treasury Bond, based on expected yield.",a:"Modified Macaulay duration.",m:[5,6],p:[{name:"settlement",detail:"The settlement date of the security, the date after issuance when the security is delivered to the buyer.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"The maturity or end date of the security, when it can be redeemed at face, or par value.",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"The annualized rate of interest.",example:"0.08",require:"m",repeat:"n",type:"rangenumber"},{name:"yield",detail:"The expected annual yield of the security.",example:"0.09",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"The number of interest or coupon payments per year (1, 2, or 4).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"day_count_convention",detail:"An indicator of what day count method to use.",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"BIN2DEC",t:9,d:"Converts a signed binary number to decimal format.",a:"Converts a signed binary number to decimal format.",m:[1,1],p:[{name:"signed_binary_number",detail:"The signed 10-bit binary value to be converted to decimal, provided as a string.",example:"101",require:"m",repeat:"n",type:"rangeall"}]},{n:"BIN2HEX",t:9,d:"Converts a signed binary number to signed hexadecimal format.",a:"Converts a binary number to hexadecimal.",m:[1,2],p:[{name:"signed_binary_number",detail:"The signed 10-bit binary value to be converted to signed hexademical, provided as a string.",example:"101",require:"m",repeat:"n",type:"rangeall"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"BIN2OCT",t:9,d:"Converts a signed binary number to signed octal format.",a:"Converts a binary number to octal.",m:[1,2],p:[{name:"signed_binary_number",detail:"The signed 10-bit binary value to be converted to signed octal, provided as a string.",example:"101",require:"m",repeat:"n",type:"rangeall"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DEC2BIN",t:9,d:"Converts a decimal number to signed binary format.",a:"Converts a decimal number to signed binary format.",m:[1,2],p:[{name:"decimal_number",detail:"The decimal value to be converted to signed binary, provided as a string.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DEC2HEX",t:9,d:"Converts a decimal number to signed hexadecimal format.",a:"Converts a decimal number to hexadecimal.",m:[1,2],p:[{name:"decimal_number",detail:"The decimal value to be converted to signed hexadecimal, provided as a string.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DEC2OCT",t:9,d:"Converts a decimal number to signed octal format.",a:"Converts a decimal number to signed octal format.",m:[1,2],p:[{name:"decimal_number",detail:"The decimal value to be converted to signed octal, provided as a string.",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"HEX2BIN",t:9,d:"Converts a signed hexadecimal number to signed binary format.",a:"Converts a hexadecimal number to binary.",m:[1,2],p:[{name:"signed_hexadecimal_number",detail:"The signed 40-bit hexadecimal value to be converted to signed binary, provided as a string.",example:'"f3"',require:"m",repeat:"n",type:"rangeall"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"HEX2DEC",t:9,d:"Converts a signed hexadecimal number to decimal format.",a:"Converts a hexadecimal number to decimal.",m:[1,1],p:[{name:"signed_hexadecimal_number",detail:"The signed 40-bit hexadecimal value to be converted to decimal, provided as a string.",example:'"f3"',require:"m",repeat:"n",type:"rangeall"}]},{n:"HEX2OCT",t:9,d:"Converts a signed hexadecimal number to signed octal format.",a:"Converts a hexadecimal number to octal.",m:[1,2],p:[{name:"signed_hexadecimal_number",detail:"The signed 40-bit hexadecimal value to be converted to signed octal, provided as a string.",example:'"f3"',require:"m",repeat:"n",type:"rangeall"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"OCT2BIN",t:9,d:"Converts a signed octal number to signed binary format.",a:"Converts an octal number to binary.",m:[1,2],p:[{name:"signed_octal_number",detail:"The signed 30-bit octal value to be converted to signed binary, provided as a string.",example:"37",require:"m",repeat:"n",type:"rangeall"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"OCT2DEC",t:9,d:"Converts a signed octal number to decimal format.",a:"Converts a signed octal number to decimal format.",m:[1,1],p:[{name:"signed_octal_number",detail:"The signed 30-bit octal value to be converted to decimal, provided as a string.",example:"37",require:"m",repeat:"n",type:"rangeall"}]},{n:"OCT2HEX",t:9,d:"Converts a signed octal number to signed hexadecimal format.",a:"Converts an octal number to hexadecimal.",m:[1,2],p:[{name:"signed_octal_number",detail:"The signed 30-bit octal value to be converted to signed hexadecimal, provided as a string.",example:"37",require:"m",repeat:"n",type:"rangeall"},{name:"significant_digits",detail:"The number of significant digits to ensure in the result.",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COMPLEX",t:9,d:"Creates a complex number given real and imaginary coefficients.",a:"Creates a complex number.",m:[2,3],p:[{name:"real_part",detail:"The real coefficient.",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"imaginary_part",detail:"The imaginary coefficient.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"suffix",detail:"The suffix for the imaginary coefficient, can only be 'i' or 'j'. If omitted, 'i' will be used.",example:'"j"',require:"o",repeat:"n",type:"rangestring"}]},{n:"IMREAL",t:9,d:"Returns the real coefficient of a complex number.",a:"The real coefficient of a complex number.",m:[1,1],p:[{name:"complex_number",detail:"The complex number, in the a+bi or a+bj format.",example:'"4+5i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMAGINARY",t:9,d:"Returns the imaginary coefficient of a complex number.",a:"The imaginary coefficient of a complex number.",m:[1,1],p:[{name:"complex_number",detail:"The complex number, in the a+bi or a+bj format.",example:'"4+5i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMCONJUGATE",t:9,d:"Returns the complex conjugate of a number.",a:"The complex conjugate of a number.",m:[1,1],p:[{name:"number",detail:"The complex number to calculate the conjugate for.",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMABS",t:9,d:"Returns absolute value (or modulus) of a complex number.",a:"The absolute value of a complex number.",m:[1,1],p:[{name:"number",detail:"The complex number to calculate the absolute value of.",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"DELTA",t:9,d:"Compare two numeric values, returning 1 if they're equal.",a:"Compare two numeric values.",m:[1,2],p:[{name:"number1",detail:"The first number to compare.",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"number2",detail:"The second number to compare.",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"IMSUM",t:9,d:"Returns the sum of a series of complex numbers.",a:"Sum of a series of complex numbers.",m:[1,255],p:[{name:"value1",detail:"The first complex number or range to add together.",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"Additional complex numbers or ranges to add to `value1`.",example:'"5-3i"',require:"o",repeat:"y",type:"rangeall"}]},{n:"IMSUB",t:9,d:"Returns the difference between two complex numbers.",a:"The difference between two complex numbers.",m:[2,2],p:[{name:"first_number",detail:"The complex number to subtract second_number from.",example:'"6+5i"',require:"m",repeat:"n",type:"rangeall"},{name:"second_number",detail:"The complex number to subtract from first_number.",example:'"2+3i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMPRODUCT",t:9,d:"Returns the result of multiplying a series of complex numbers together.",a:"Result of multiplying a series of complex numbers together.",m:[1,255],p:[{name:"factor1",detail:"The first number or range to calculate for the product.",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"},{name:"factor2",detail:"Additional complex numbers or ranges to calculate for the product.",example:'"5-3i"',require:"o",repeat:"y",type:"rangeall"}]},{n:"IMDIV",t:9,d:"Returns one complex number divided by another.",a:"One complex number divided by another.",m:[2,2],p:[{name:"dividend",detail:"The complex number to be divided.",example:'"11+16i"',require:"m",repeat:"n",type:"rangeall"},{name:"divisor",detail:"The complex number to divide by.",example:'"3+2i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"NOT",t:10,d:"Returns the opposite of a logical value - `NOT(TRUE)` returns `FALSE`; `NOT(FALSE)` returns `TRUE`.",a:"Returns opposite of provided logical value.",m:[1,1],p:[{name:"logical_expression",detail:"An expression or reference to a cell holding an expression that represents some logical value.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"TRUE",t:10,d:"Returns the logical value `TRUE`.",a:"Logical value `true`.",m:[0,0],p:[]},{n:"FALSE",t:10,d:"Returns the logical value `FALSE`.",a:"Logical value `false`.",m:[0,0],p:[]},{n:"AND",t:10,d:"Returns true if all of the provided arguments are logically true, and false if any of the provided arguments are logically false.",a:"Logical `and` operator.",m:[1,255],p:[{name:"logical_expression1",detail:"An expression or reference to a cell containing an expression that represents some logical value, i.e. `TRUE` or `FALSE`, or an expression that can be coerced to a logical value.",example:'A2 = "foo"',require:"m",repeat:"n",type:"rangeall"},{name:"logical_expression2",detail:"More expressions that represent logical values.",example:'A3 = "bar"',require:"o",repeat:"y",type:"rangeall"}]},{n:"IFERROR",t:10,d:"Returns the first argument if it is not an error value, otherwise returns the second argument if present, or a blank if the second argument is absent.",a:"Value if it is not an error, otherwise 2nd argument.",m:[2,2],p:[{name:"value",detail:"The value to return if `value` itself is not an error.",example:"A1",require:"m",repeat:"n",type:"rangeall"},{name:"value_if_error",detail:"The value the function returns if `value` is an error.",example:'"Error in cell A1"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IF",t:10,d:"Returns one value if a logical expression is `TRUE` and another if it is `FALSE`.",a:"Returns value depending on logical expression.",m:[2,3],p:[{name:"logical_expression",detail:"An expression or reference to a cell containing an expression that represents some logical value, i.e. `TRUE` or `FALSE`.",example:'A2 = "foo"',require:"m",repeat:"n",type:"rangeall"},{name:"value_if_true",detail:"The value the function returns if `logical_expression` is `TRUE`.",example:'"A2 is foo"',require:"m",repeat:"n",type:"rangeall"},{name:"value_if_false",detail:"The value the function returns if `logical_expression` is `FALSE`.",example:'"A2 was false"',require:"o",repeat:"n",type:"rangeall"}]},{n:"OR",t:10,d:"Returns true if any of the provided arguments are logically true, and false if all of the provided arguments are logically false.",a:"Logical `or` operator.",m:[1,255],p:[{name:"logical_expression1",detail:"An expression or reference to a cell containing an expression that represents some logical value, i.e. `TRUE` or `FALSE`, or an expression that can be coerced to a logical value.",example:'A2 = "foo"',require:"m",repeat:"n",type:"rangeall"},{name:"logical_expression2",detail:"More expressions that evaluate to logical values.",example:' A3 = "bar"',require:"m",repeat:"n",type:"rangeall"}]},{n:"NE",t:11,d:"Returns `TRUE` if two specified values are not equal and `FALSE` otherwise. Equivalent to the `!=` operator.",a:"Not equal.",m:[2,2],p:[{name:"value1",detail:"The first value.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The value to test against `value1` for inequality.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"EQ",t:11,d:"Returns `TRUE` if two specified values are equal and `FALSE` otherwise. Equivalent to the `==` operator.",a:"Equal.",m:[2,2],p:[{name:"value1",detail:"The first value.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The value to test against `value1` for equality.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"GT",t:11,d:"Returns `TRUE` if the first argument is strictly greater than the second, and `FALSE` otherwise. Equivalent to the `>` operator.",a:"Strictly greater than.",m:[2,2],p:[{name:"value1",detail:"The value to test as being greater than `value2`.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The second value.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"GTE",t:11,d:"Returns `TRUE` if the first argument is greater than or equal to the second, and `FALSE` otherwise. Equivalent to the `>=` operator.",a:"Greater than or equal to.",m:[2,2],p:[{name:"value1",detail:"The value to test as being greater than or equal to `value2`.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The second value.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"LT",t:11,d:"Returns `TRUE` if the first argument is strictly less than the second, and `FALSE` otherwise. Equivalent to the `<` operator.",a:"Less than.",m:[2,2],p:[{name:"value1",detail:"The value to test as being less than `value2`.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The second value.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"LTE",t:11,d:"Returns `TRUE` if the first argument is less than or equal to the second, and `FALSE` otherwise. Equivalent to the `<=` operator.",a:"Less than or equal to.",m:[2,2],p:[{name:"value1",detail:"The value to test as being less than or equal to `value2`.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The second value.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"ADD",t:11,d:"Returns the sum of two numbers. Equivalent to the `+` operator.",a:"Sum of two numbers",m:[2,2],p:[{name:"value1",detail:"The first addend.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"The second addend.",example:"A3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MINUS",t:11,d:"Returns the difference of two numbers. Equivalent to the `-` operator.",a:"Difference of two numbers",m:[2,2],p:[{name:"value1",detail:"The minuend, or number to be subtracted from.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"The subtrahend, or number to subtract from `value1`.",example:"A3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MULTIPLY",t:11,d:"Returns the product of two numbers. Equivalent to the `*` operator.",a:"Product of two numbers",m:[2,2],p:[{name:"factor1",detail:"The first multiplicand.",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"factor2",detail:"The second multiplicand.",example:"B2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DIVIDE",t:11,d:"Returns one number divided by another. Equivalent to the `/` operator.",a:"One number divided by another",m:[2,2],p:[{name:"dividend",detail:"The number to be divided.",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"divisor",detail:"The number to divide by.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CONCAT",t:11,d:"Returns the concatenation of two values. Equivalent to the `&` operator.",a:"Concatenation of two values",m:[2,2],p:[{name:"value1",detail:"The value to which `value2` will be appended.",example:'"de"',require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"The value to append to `value1`.",example:'"mystify"',require:"m",repeat:"n",type:"rangeall"}]},{n:"UNARY_PERCENT",t:11,d:"Returns a value interpreted as a percentage; that is, `UNARY_PERCENT(100)` equals `1`.",a:"Value interpreted as a percentage.",m:[1,1],p:[{name:"percentage",detail:"The value to interpret as a percentage.",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CONCATENATE",t:12,d:"Appends strings to one another.",a:"Appends strings to one another.",m:[1,255],p:[{name:"string1",detail:"The initial string.",example:'"Super"',require:"m",repeat:"n",type:"rangeall"},{name:"string2",detail:"More strings to append in sequence.",example:'"calla"',require:"o",repeat:"y",type:"rangeall"}]},{n:"CODE",t:12,d:"Returns the numeric Unicode map value of the first character in the string provided.",a:"Numeric unicode map value of character.",m:[1,1],p:[{name:"string",detail:"The string whose first character's Unicode map value will be returned.",example:'"a"',require:"m",repeat:"n",type:"rangeall"}]},{n:"CHAR",t:12,d:"Convert a number into a character according to the current Unicode table.",a:"Gets character associated with number.",m:[1,1],p:[{name:"table_number",detail:"The number of the character to look up from the current Unicode table in decimal format.",example:"97",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ARABIC",t:12,d:"Computes the value of a Roman numeral.",a:"Computes the value of a roman numeral.",m:[1,1],p:[{name:"roman_numeral",detail:"The Roman numeral to format, whose value must be between 1 and 3999, inclusive.",example:'"XIV"',require:"m",repeat:"n",type:"rangeall"}]},{n:"ROMAN",t:12,d:"Formats a number in Roman numerals.",a:"Formats a number in Roman numerals.",m:[1,1],p:[{name:"number",detail:"The number to format, between 1 and 3999, inclusive.",example:"499",require:"m",repeat:"n",type:"rangenumber"}]},{n:"REGEXEXTRACT",t:12,d:"Extracts matching substrings according to a regular expression.",a:"Extracts matching substrings with regular expression.",m:[2,2],p:[{name:"text",detail:"The input text.",example:'"Needle in a haystack"',require:"m",repeat:"n",type:"rangeall"},{name:"regular_expression",detail:"The first part of `text` that matches this expression will be returned.",example:'".e{2}dle"',require:"m",repeat:"n",type:"rangeall"}]},{n:"REGEXMATCH",t:12,d:"Whether a piece of text matches a regular expression.",a:"Whether a piece of text matches regular expression.",m:[2,2],p:[{name:"text",detail:"The text to be tested against the regular expression.",example:'"Spreadsheets"',require:"m",repeat:"n",type:"rangeall"},{name:"regular_expression",detail:"The regular expression to test the text against.",example:'"S.r"',require:"m",repeat:"n",type:"rangeall"}]},{n:"REGEXREPLACE",t:12,d:"Replaces part of a text string with a different text string using regular expressions.",a:"Replaces text with regular expressions.",m:[3,3],p:[{name:"text",detail:"The text, a part of which will be replaced.",example:'"Spreadsheets"',require:"m",repeat:"n",type:"rangeall"},{name:"regular_expression",detail:"The regular expression.  All matching instances in `text` will be replaced.",example:'"S.*d"',require:"m",repeat:"n",type:"rangeall"},{name:"replacement",detail:"The text which will be inserted into the original text.",example:'"Bed"',require:"m",repeat:"n",type:"rangeall"}]},{n:"T",t:12,d:"Returns string arguments as text, or the empty string if the value is not text.",a:"String arguments as text.",m:[1,1],p:[{name:"value",detail:"The argument to be converted to text.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"FIXED",t:12,d:"Formats a number with a fixed number of decimal places.",a:"Formats number with fixed number of decimal places.",m:[1,3],p:[{name:"number",detail:"The number to format.",example:"3.141592653",require:"m",repeat:"n",type:"rangenumber"},{name:"number_of_places",detail:"The number of decimal places to display in the result.",example:"2",require:"o",repeat:"n",type:"rangenumber"},{name:"suppress_separator",detail:"Whether or not to suppress the thousands separator used in some locales (e.g. `1,000` becomes `1000`). Separators will be present if this value is 0 or omitted, and absent otherwise.",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"FIND",t:12,d:"Returns the position at which a string is first found within text where the capitalization of letters matters. Returns `#VALUE!` if the string is not found.",a:"First position of string found in text, case-sensitive.",m:[2,3],p:[{name:"search_for",detail:"The string to look for within `text_to_search`.",example:'"n"',require:"m",repeat:"n",type:"rangeall"},{name:"text_to_search",detail:"The text to search for the first occurrence of `search_for`.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"starting_at",detail:"The character within `text_to_search` at which to start the search.",example:"14",require:"o",repeat:"n",type:"rangenumber"}]},{n:"FINDB",t:12,d:"Returns the position at which a string is first found within text counting each double-character as 2.",a:"Position at which a string is first found within text (binary).",m:[2,3],p:[{name:"search_for",detail:"The string to look for within `text_to_search`.",example:'"new"',require:"m",repeat:"n",type:"rangeall"},{name:"text_to_search",detail:"The text to search for the first occurrence of `search_for`.",example:'"new year"',require:"m",repeat:"n",type:"rangeall"},{name:"starting_at",detail:"The character within `text_to_search` at which to start the search.",example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"JOIN",t:12,d:"Concatenates the elements of one or more one-dimensional arrays using a specified delimiter.",a:"Concatenates elements of arrays with delimiter.",m:[2,255],p:[{name:"delimiter",detail:"The character or string to place between each concatenated value.",example:'" and-a "',require:"m",repeat:"n",type:"rangeall"},{name:"value_or_array1",detail:"The value or values to be appended using `delimiter`.",example:"{1",require:"m",repeat:"n",type:"rangeall"},{name:"value_or_array2",detail:"More values to be appended using `delimiter`.",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"LEFT",t:12,d:"Returns a substring from the beginning of a specified string.",a:"Substring from beginning of specified string.",m:[1,2],p:[{name:"string",detail:"The string from which the left portion will be returned.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"number_of_characters",detail:"The number of characters to return from the left side of `string`.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"RIGHT",t:12,d:"Returns a substring from the end of a specified string.",a:"A substring from the end of a specified string.",m:[1,2],p:[{name:"string",detail:"The string from which the right portion will be returned.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"number_of_characters",detail:"The number of characters to return from the right side of `string`.",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MID",t:12,d:"Returns a segment of a string.",a:"A segment of a string.",m:[3,3],p:[{name:"string",detail:"The string to extract a segment from.",example:'"get this"',require:"m",repeat:"n",type:"rangeall"},{name:"starting_at",detail:"The index from the left of `string` from which to begin extracting. The first character in `string` has the index 1.",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"extract_length",detail:"The length of the segment to extract.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LEN",t:12,d:"Returns the length of a string.",a:"Length of a string.",m:[1,1],p:[{name:"text",detail:"The string whose length will be returned.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"LENB",t:12,d:"Returns the length of a string in bytes.",a:"Length of a string in bytes.",m:[1,1],p:[{name:"text",detail:"The string whose length will be returned.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"LOWER",t:12,d:"Converts a specified string to lowercase.",a:"Converts a specified string to lowercase.",m:[1,1],p:[{name:"text",detail:"The string to convert to lowercase.",example:'"LOREM IPSUM"',require:"m",repeat:"n",type:"rangeall"}]},{n:"UPPER",t:12,d:"Converts a specified string to uppercase.",a:"Converts a specified string to uppercase.",m:[1,1],p:[{name:"text",detail:"The string to convert to uppercase.",example:'"lorem ipsum"',require:"m",repeat:"n",type:"rangeall"}]},{n:"EXACT",t:12,d:"Tests whether two strings are identical.",a:"Tests whether two strings are identical.",m:[2,2],p:[{name:"string1",detail:"The first string to compare",example:"A1",require:"m",repeat:"n",type:"rangeall"},{name:"string2",detail:"The second string to compare",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"REPLACE",t:12,d:"Replaces part of a text string with a different text string.",a:"Replaces part of a text string with different text.",m:[4,4],p:[{name:"text",detail:"The text, a part of which will be replaced.",example:'"Spreadsheets"',require:"m",repeat:"n",type:"rangeall"},{name:"position",detail:"The position where the replacement will begin (starting from 1).",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"length",detail:"The number of characters in the text to be replaced.",example:"6",require:"m",repeat:"n",type:"rangenumber"},{name:"new_text",detail:"The text which will be inserted into the original text.",example:'"Bed"',require:"m",repeat:"n",type:"rangeall"}]},{n:"REPT",t:12,d:"Returns specified text repeated a number of times.",a:"Specified text repeated a number of times.",m:[2,2],p:[{name:"text_to_repeat",detail:"The character or string to repeat.",example:'"ha"',require:"m",repeat:"n",type:"rangeall"},{name:"number_of_repetitions",detail:"The number of times `text_to_repeat` should appear in the value returned.",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SEARCH",t:12,d:"Returns the position at which a string is first found within text and ignores capitalization of letters. Returns `#VALUE!` if the string is not found.",a:"First position of string found in text, ignoring case.",m:[2,3],p:[{name:"search_for",detail:"The string to look for within `text_to_search`.",example:'"n"',require:"m",repeat:"n",type:"rangeall"},{name:"text_to_search",detail:"The text to search for the first occurrence of `search_for`.",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"starting_at",detail:"The character within `text_to_search` at which to start the search.",example:"14",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUBSTITUTE",t:12,d:"Replaces existing text with new text in a string.",a:"Replaces existing text with new text in a string.",m:[3,4],p:[{name:"text_to_search",detail:"The text within which to search and replace.",example:'"search for it"',require:"m",repeat:"n",type:"rangeall"},{name:"search_for",detail:"The string to search for within `text_to_search`.",example:'"search for"',require:"m",repeat:"n",type:"rangeall"},{name:"replace_with",detail:"The string that will replace `search_for`.",example:'"Google"',require:"m",repeat:"n",type:"rangeall"},{name:"occurrence_number",detail:"The instance of `search_for` within `text_to_search` to replace with `replace_with`. By default, all occurrences of `search_for` are replaced; however, if `occurrence_number` is specified, only the indicated instance of `search_for` is replaced.",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CLEAN",t:12,d:"Returns the text with the non-printable ASCII characters removed.",a:"Removes non-printable characters from a piece of text.",m:[1,1],p:[{name:"text",detail:"The text whose non-printable characters are to be removed.",example:'"AF"&CHAR(31)',require:"m",repeat:"n",type:"rangeall"}]},{n:"TEXT",t:12,d:"Converts a number into text according to a specified format.",a:"Formats a number into text.",m:[2,2],p:[{name:"number",detail:"The number, date, or time to format.",example:"1.23",require:"m",repeat:"n",type:"rangenumber"},{name:"format",detail:"The pattern by which to format the number, enclosed in quotation marks.",example:'"$0.00"',require:"m",repeat:"n",type:"rangeall"}]},{n:"TRIM",t:12,d:"Removes leading, trailing, and repeated spaces in text.",a:"Removes space characters.",m:[1,1],p:[{name:"text",detail:"The text or reference to a cell containing text to be trimmed.",example:'" lorem ipsum"',require:"m",repeat:"n",type:"rangeall"}]},{n:"VALUE",t:12,d:"Converts a string in any of the date, time or number formats that Google Sheets understands into a number.",a:"Converts a date/time/number string into a number.",m:[1,1],p:[{name:"text",detail:"The string containing the value to be converted.",example:'"123"',require:"m",repeat:"n",type:"rangeall"}]},{n:"PROPER",t:12,d:"Capitalizes each word in a specified string.",a:"Capitalizes each word in a specified string.",m:[1,1],p:[{name:"text_to_capitalize",detail:"The text which will be returned with the first letter of each word in uppercase and all other letters in lowercase.",example:'"united states"',require:"m",repeat:"n",type:"rangeall"}]},{n:"CONVERT",t:13,d:"Converts a numeric value to a different unit of measure.",a:"Unit conversion for numbers.",m:[3,3],p:[{name:"value",detail:"The numeric value in `start_unit` to convert to `end_unit`.",example:"5.1",require:"m",repeat:"n",type:"rangenumber"},{name:"start_unit",detail:"The starting unit, the unit currently assigned to `value`.",example:'"g"',require:"m",repeat:"n",type:"rangeall"},{name:"end_unit",detail:"The unit of measure into which to convert the argument, `value`.",example:'"kg"',require:"m",repeat:"n",type:"rangeall"}]},{n:"SUMX2MY2",t:14,d:"Calculates the sum of the differences of the squares of values in two arrays.",a:"Sum of the differences of squares.",m:[2,2],p:[{name:"array_x",detail:"The array or range of values whose squares will be reduced by the squares of corresponding entries in `array_y` and added together.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"array_y",detail:"The array or range of values whose squares will be subtracted from the squares of corresponding entries in `array_x` and added together.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMX2PY2",t:14,d:"Calculates the sum of the sums of the squares of values in two arrays.",a:"Sum of the sums of squares.",m:[2,2],p:[{name:"array_x",detail:"The array or range of values whose squares will be added to the squares of corresponding entries in `array_y` and added together.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"array_y",detail:"The array or range of values whose squares will be added to the squares of corresponding entries in `array_x` and added together.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMXMY2",t:14,d:"Calculates the sum of the squares of differences of values in two arrays.",a:"Sum of the squares of differences.",m:[2,2],p:[{name:"array_x",detail:"The array or range of values that will be reduced by corresponding entries in `array_y`, squared, and added together.",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"array_y",detail:"The array or range of values that will be subtracted from corresponding entries in `array_x`, the result squared, and all such results added together.",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TRANSPOSE",t:14,d:"Transposes the rows and columns of an array or range of cells.",a:"Transposes the rows and columns of an array.",m:[1,1],p:[{name:"array_or_range",detail:"The array or range whose rows and columns will be swapped.",example:"{1,2}",require:"m",repeat:"n",type:"range"}]},{n:"TREND",t:14,d:"Given partial data about a linear trend, fits an ideal linear trend using the least squares method and/or predicts further values.",a:"Fits points to linear trend derived via least-squares.",m:[1,4],p:[{name:"known_data_y",detail:"The array or range containing dependent (y) values that are already known, used to curve fit an ideal linear trend.",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_data_x",detail:"The values of the independent variable(s) corresponding with `known_data_y`.",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"new_data_x",detail:"The data points to return the `y` values for on the ideal curve fit.",example:"A11:A13",require:"o",repeat:"n",type:"rangenumber"},{name:"b",detail:"Given a general linear form of `y = m*x+b` for a curve fit, calculates `b` if `TRUE` or forces `b` to be `0` and only calculates the `m` values if `FALSE`, i.e. forces the curve fit to pass through the origin.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"FREQUENCY",t:14,d:"Calculates the frequency distribution of a one-column array into specified classes.",a:"The frequency distribution of array.",m:[2,2],p:[{name:"data",detail:"The array or range containing the values to be counted.",example:"A2:A40",require:"m",repeat:"n",type:"rangenumber"},{name:"classes",detail:"The array or range containing the set of classes.",example:"B2:B5",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GROWTH",t:14,d:"Given partial data about an exponential growth trend, fits an ideal exponential growth trend and/or predicts further values.",a:"Fits points to exponential growth trend.",m:[1,4],p:[{name:"known_data_y",detail:"The array or range containing dependent (y) values that are already known, used to curve fit an ideal exponential growth curve.",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_data_x",detail:"The values of the independent variable(s) corresponding with `known_data_y`.",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"new_data_x",detail:"The data points to return the `y` values for on the ideal curve fit.",example:"A11:A13",require:"o",repeat:"n",type:"rangenumber"},{name:"b",detail:"Given a general exponential form of `y = b*m^x` for a curve fit, calculates `b` if `TRUE` or forces `b` to be `1` and only calculates the `m` values if `FALSE`.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"LINEST",t:14,d:"Given partial data about a linear trend, calculates various parameters about the ideal linear trend using the least-squares method.",a:"Best-fit linear trend via least-squares.",m:[1,4],p:[{name:"known_data_y",detail:"The array or range containing dependent (y) values that are already known, used to curve fit an ideal linear trend.",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_data_x",detail:"The values of the independent variable(s) corresponding with `known_data_y`.",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"calculate_b",detail:"Given a linear form of `y = m*x+b`, calculates the y-intercept (`b`) if `TRUE`. Otherwise, forces `b` to be `0` and only calculates the `m` values if `FALSE`, i.e. forces the curve fit to pass through the origin.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"},{name:"verbose",detail:"A flag specifying whether to return additional regression statistics or only the linear coefficients and the y-intercept (default).",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"LOGEST",t:14,d:"Given partial data about an exponential growth curve, calculates various parameters about the best fit ideal exponential growth curve.",a:"Best-fit exponential growth curve.",m:[1,4],p:[{name:"known_data_y",detail:"The array or range containing dependent (y) values that are already known, used to curve fit an ideal exponential growth curve.",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_data_x",detail:"The values of the independent variable(s) corresponding with `known_data_y`.",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"b",detail:"Given a general exponential form of `y = b*m^x` for a curve fit, calculates `b` if `TRUE` or forces `b` to be `1` and only calculates the `m` values if `FALSE`.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"},{name:"verbose",detail:"A flag specifying whether to return additional regression statistics or only the calculated coefficient and exponents.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"MDETERM",t:14,d:"Returns the matrix determinant of a square matrix specified as an array or range.",a:"Matrix determinant of a square matrix.",m:[1,1],p:[{name:"square_matrix",detail:"An array or range with an equal number of rows and columns representing a matrix whose determinant will be calculated.",example:"A1:D4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MINVERSE",t:14,d:"Returns the multiplicative inverse of a square matrix specified as an array or range.",a:"Multiplicative inverse of square matrix.",m:[1,1],p:[{name:"square_matrix",detail:"An array or range with an equal number of rows and columns representing a matrix whose multiplicative inverse will be calculated.",example:"A1:D4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MMULT",t:14,d:"Calculates the matrix product of two matrices specified as arrays or ranges.",a:"The matrix product of two matrices.",m:[2,2],p:[{name:"matrix1",detail:"The first matrix in the matrix multiplication operation, represented as an array or range.",example:"A1:B3",require:"m",repeat:"n",type:"rangenumber"},{name:"matrix2",detail:"The second matrix in the matrix multiplication operation, represented as an array or range.",example:"C1:F2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMPRODUCT",t:14,d:"Calculates the sum of the products of corresponding entries in two equal-sized arrays or ranges.",a:"Sum of products of elements in two arrays.",m:[1,255],p:[{name:"array1",detail:"The first array or range whose entries will be multiplied with corresponding entries in the second such array or range.",example:"A2:C5",require:"m",repeat:"n",type:"rangenumber"},{name:"array2",detail:"The second array or range whose entries will be multiplied with corresponding entries in the first such array or range.",example:"D2:F5",require:"o",repeat:"y",type:"rangenumber"}]},{n:"ISFORMULA",t:15,d:"Checks whether a value is a formula.",a:"Whether a value is a formula.",m:[1,1],p:[{name:"cell",detail:"The cell to be verified as containing a formula.",example:"A2",require:"m",repeat:"n",type:"range"}]},{n:"CELL",t:15,d:"Returns the requested information about the specified cell.",a:"Gets information about a cell.",m:[2,2],p:[{name:"info_type",detail:"The type of information requested (see article for available types)",example:'"type"',require:"m",repeat:"n",type:"rangeall"},{name:"reference",detail:"The reference to the cell.",example:"C2",require:"m",repeat:"n",type:"range"}]},{n:"NA",t:15,d:'Returns the "value not available" error, `#N/A`.',a:"The `#N/A` error.",m:[0,0],p:[]},{n:"ERROR_TYPE",t:15,d:"Returns a number corresponding to the error value in a different cell.",a:"Error value of cell (as number).",m:[1,1],p:[{name:"reference",detail:"The cell to find the error number for although you can also provide the error value directly.",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISBLANK",t:15,d:"Checks whether the referenced cell is empty.",a:"Whether the referenced cell is empty.",m:[1,1],p:[{name:"value",detail:"Reference to the cell that will be checked for emptiness.",example:"A2",require:"m",repeat:"n",type:"range"}]},{n:"ISERR",t:15,d:"Checks whether a value is an error other than `#N/A`.",a:"Whether a value is an error other than `#n/a`.",m:[1,1],p:[{name:"value",detail:"The value to be verified as an error type other than `#N/A`.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISERROR",t:15,d:"Checks whether a value is an error.",a:"Whether a value is an error.",m:[1,1],p:[{name:"value",detail:"The value to be verified as an error type.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISLOGICAL",t:15,d:"Checks whether a value is `TRUE` or `FALSE`.",a:"Whether a value is `true` or `false`.",m:[1,1],p:[{name:"value",detail:"The value to be verified as a logical `TRUE` or `FALSE`.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISNA",t:15,d:"Checks whether a value is the error `#N/A`.",a:"Whether a value is the error `#n/a`.",m:[1,1],p:[{name:"value",detail:"The value to be compared with the error value `#N/A`.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISNONTEXT",t:15,d:"Checks whether a value is non-textual.",a:"Whether a value is non-textual.",m:[1,1],p:[{name:"value",detail:"The value to be checked.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISNUMBER",t:15,d:"Checks whether a value is a number.",a:"Whether a value is a number.",m:[1,1],p:[{name:"value",detail:"The value to be verified as a number.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISREF",t:15,d:"Checks whether a value is a valid cell reference.",a:"Whether a value is a valid cell reference.",m:[1,1],p:[{name:"value",detail:"The value to be verified as a cell reference.",example:"A2",require:"m",repeat:"n",type:"range"}]},{n:"ISTEXT",t:15,d:"Checks whether a value is text.",a:"Whether a value is text.",m:[1,1],p:[{name:"value",detail:"The value to be verified as text.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"TYPE",t:15,d:"Returns a number associated with the type of data passed into the function.",a:"Get the type of a value.",m:[1,1],p:[{name:"value",detail:"The value whose type is to be determined.",example:"C4",require:"m",repeat:"n",type:"rangeall"}]},{n:"N",t:15,d:"Returns the argument provided as a number. Text is converted to 0 and errors are returned as-is.",a:"Argument provided as a number.",m:[1,1],p:[{name:"value",detail:"The argument to be converted to a number.",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"TO_DATE",t:16,d:"Converts a provided number to a date.",a:"Converts a provided number to a date.",m:[1,1],p:[{name:"value",detail:"The argument or reference to a cell to be converted to a date.",example:"25405",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TO_PURE_NUMBER",t:16,d:"Converts a provided date/time, percentage, currency or other formatted numeric value to a pure number without formatting.",a:"Converts any numeric value to a pure number.",m:[1,1],p:[{name:"value",detail:"The argument or reference to a cell to be converted to a pure number.",example:"50%",require:"m",repeat:"n",type:"rangeall"}]},{n:"TO_TEXT",t:16,d:"Converts a provided numeric value to a text value.",a:"Converts a provided numeric value to a text value.",m:[1,1],p:[{name:"value",detail:"The argument or reference to a cell to be converted to text.",example:"24",require:"m",repeat:"n",type:"rangeall"}]},{n:"TO_DOLLARS",t:16,d:"Converts a provided number to a dollar value.",a:"Converts a provided number to a dollar value.",m:[1,1],p:[{name:"value",detail:"The argument or reference to a cell to be converted to a dollar value.",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TO_PERCENT",t:16,d:"Converts a provided number to a percentage.",a:"Converts a provided number to a percentage.",m:[1,1],p:[{name:"value",detail:"The argument or reference to a cell to be converted to a percentage.",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DGET",t:17,d:"Returns a single value from a database table-like array or range using a SQL-like query.",a:"Single value from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DMAX",t:17,d:"Returns the maximum value selected from a database table-like array or range using a SQL-like query.",a:"Maximum of values from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DMIN",t:17,d:"Returns the minimum value selected from a database table-like array or range using a SQL-like query.",a:"Minimum of values from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DAVERAGE",t:17,d:"Returns the average of a set of values selected from a database table-like array or range using a SQL-like query.",a:"Average of a set of values from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DCOUNT",t:17,d:"Counts numeric values selected from a database table-like array or range using a SQL-like query.",a:"Counts values from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DCOUNTA",t:17,d:"Counts values, including text, selected from a database table-like array or range using a SQL-like query.",a:"Counts values and text from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DPRODUCT",t:17,d:"Returns the product of values selected from a database table-like array or range using a SQL-like query.",a:"Product of values from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DSTDEV",t:17,d:"Returns the standard deviation of a population sample selected from a database table-like array or range using a SQL-like query.",a:"Standard deviation of population sample from table.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DSTDEVP",t:17,d:"Returns the standard deviation of an entire population selected from a database table-like array or range using a SQL-like query.",a:"Standard deviation of entire population from table.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DSUM",t:17,d:"Returns the sum of values selected from a database table-like array or range using a SQL-like query.",a:"Sum of values from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DVAR",t:17,d:"Returns the variance of a population sample selected from a database table-like array or range using a SQL-like query.",a:"Variance of population sample from table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DVARP",t:17,d:"Returns the variance of an entire population selected from a database table-like array or range using a SQL-like query.",a:"Variance of a population from a table-like range.",m:[3,3],p:[{name:"database",detail:"The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"Indicates which column in `database` contains the values to be extracted and operated on.",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"An array or range containing zero or more criteria to filter the `database` values by before operating.",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"AGE_BY_IDCARD",t:"3",d:"Calculate the age based on the Chinese ID number. Support 15 or 18",a:"Get age based on ID number.",m:[1,2],p:[{name:"ID number",example:"A1",detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"},{name:"Deadline",example:'"2017-10-01"',detail:"The deadline or range of age calculation. The default is the current day.",require:"o",repeat:"n",type:"rangedatetime"}]},{n:"SEX_BY_IDCARD",t:"3",d:"Calculate gender based on Chinese ID number. Support 15 or 18",a:"Get gender based on ID number.",m:[1,1],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"}]},{n:"BIRTHDAY_BY_IDCARD",t:"3",d:"Calculate the birthday based on the Chinese ID number. Support 15 or 18",a:"Get the birthday based on the ID number.",m:[1,2],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"},{name:"Birthday format",example:"0",detail:"Date type, default:0:[1900/01/01], 1:[1900-01-01], 2:[1900年1月1日]",require:"o",repeat:"n",type:"rangeall"}]},{n:"PROVINCE_BY_IDCARD",t:"3",d:"Calculate the province of birthplace based on the Chinese ID number. Support 15 or 18",a:"Get the province of birthplace based on the ID number.",m:[1,1],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"}]},{n:"CITY_BY_IDCARD",t:"3",d:"Calculate the city of birthplace based on the Chinese ID number. Support 15 or 18",a:"Get the city of birthplace based on the ID number.",m:[1,1],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"}]},{n:"STAR_BY_IDCARD",t:"3",d:"Calculate the constellation based on the Chinese ID number. Support 15 or 18",a:"Get the constellation based on the ID number.",m:[1,1],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"}]},{n:"ANIMAL_BY_IDCARD",t:"3",d:"Calculate the zodiac (rat, ox, tiger, rabbit...) based on the Chinese ID number. Support 15 or 18",a:"Get the zodiac according to the ID number.",m:[1,1],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISIDCARD",t:"3",d:"Verify that the format of the ID card is correct. Support 15 or 18",a:"Verify the correctness of the ID card format.",m:[1,1],p:[{name:"ID number",example:'"31033519900101XXXX"',detail:"15-digit or 18-digit ID number or range.",require:"m",repeat:"n",type:"rangeall"}]},{n:"DM_TEXT_CUTWORD",t:"4",d:"Text segmentation. Split a series of words into a series of individual words",a:"Chinese text segmentation.",m:[1,2],p:[{name:"Text",example:'"I came to Beijing Tsinghua University"',detail:"Any text that needs word segmentation.",require:"m",repeat:"n",type:"rangeall"},{name:"Word segmentation mode",example:"0",detail:"The default is 0[precision mode], 1[full mode], 2[search engine mode].",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DM_TEXT_TFIDF",t:"4",d:"Use tf-idf algorithm for keyword extraction. Identify keywords from a series of text",a:"tf-idf keyword recognition.",m:[1,3],p:[{name:"Text",example:'"I came to Beijing Tsinghua University"',detail:"Any text that needs word segmentation.",require:"m",repeat:"n",type:"rangeall"},{name:"Number of keywords",example:"20",detail:"The number of keywords returned by the algorithm, the default is 20",require:"o",repeat:"n",type:"rangenumber"},{name:"Corpus",example:"1",detail:"Select a corpus in a specific field, the default is 0[General], 1[Finance], 2[Medical]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DM_TEXT_TEXTRANK",t:"4",d:"Use TextRank algorithm to extract keywords. Identify keywords from a series of text",a:"TextRank keyword recognition.",m:[1,3],p:[{name:"Text",example:'"I came to Beijing Tsinghua University"',detail:"Any text that needs word segmentation.",require:"m",repeat:"n",type:"rangeall"},{name:"Number of keywords",example:"20",detail:"The number of keywords returned by the algorithm, the default is 20",require:"o",repeat:"n",type:"rangenumber"},{name:"Corpus",example:"1",detail:"Select a corpus in a specific field, the default is 0[General], 1[Finance], 2[Medical]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_CLOSE",t:"5",d:"According to the stock code and date, return the corresponding stock closing price of A shares.",a:"Returns the closing price of stock.",m:[1,3],p:[{name:"Stock code",example:'"000001"',detail:"6-digit stock code, required.",require:"m",repeat:"n",type:"rangeall"},{name:"Date",example:"2015-01-08",detail:"The trading day of the stock, the default is the latest trading day",require:"o",repeat:"n",type:"rangedate"},{name:"Reversion and exclusion",example:"0",detail:"Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_OPEN",t:"5",d:"According to the stock code and date, return the opening price of stock.",a:"Return the opening price of a shares.",m:[1,3],p:[{name:"Stock code",example:'"000001"',detail:"6-digit stock code, required.",require:"m",repeat:"n",type:"rangeall"},{name:"Date",example:"2015-01-08",detail:"The trading day of the stock, the default is the latest trading day",require:"o",repeat:"n",type:"rangedate"},{name:"Reversion and exclusion",example:"0",detail:"Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_MAX",t:"5",d:"According to the stock code and date, return the highest price of stock.",a:"Return the highest price of stock.",m:[1,3],p:[{name:"Stock code",example:'"000001"',detail:"6-digit stock code, required.",require:"m",repeat:"n",type:"rangeall"},{name:"Date",example:"2015-01-08",detail:"The trading day of the stock, the default is the latest trading day",require:"o",repeat:"n",type:"rangedate"},{name:"Reversion and exclusion",example:"0",detail:"Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_MIN",t:"5",d:"According to the stock code and date, return the lowest price of stock.",a:"Returns the lowest price of stock.",m:[1,3],p:[{name:"Stock code",example:'"000001"',detail:"6-digit stock code, required.",require:"m",repeat:"n",type:"rangeall"},{name:"Date",example:"2015-01-08",detail:"The trading day of the stock, the default is the latest trading day",require:"o",repeat:"n",type:"rangedate"},{name:"Reversion and exclusion",example:"0",detail:"Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_VOLUMN",t:"5",d:"According to the stock code and date, return the corresponding stock trading volume of A shares.",a:"Returns the corresponding stock trading volume of A shares.",m:[1,3],p:[{name:"Stock code",example:'"000001"',detail:"6-digit stock code, required.",require:"m",repeat:"n",type:"rangeall"},{name:"Date",example:"2015-01-08",detail:"The trading day of the stock, the default is the latest trading day",require:"o",repeat:"n",type:"rangedate"},{name:"Reversion and exclusion",example:"0",detail:"Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_AMOUNT",t:"5",d:"According to the stock code and date, return the corresponding stock turnover of A shares.",a:"Returns the corresponding stock turnover of A shares.",m:[1,3],p:[{name:"Stock code",example:'"000001"',detail:"6-digit stock code, required.",require:"m",repeat:"n",type:"rangeall"},{name:"Date",example:"2015-01-08",detail:"The trading day of the stock, the default is the latest trading day",require:"o",repeat:"n",type:"rangedate"},{name:"Reversion and exclusion",example:"0",detail:"Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"ISDATE",t:"6",d:"Returns whether a value is a date.",a:"Whether a value is a date.",m:[1,1],p:[{name:"value",example:'"1990-01-01"',detail:"The value to be verified as a date.",require:"m",repeat:"n",type:"rangeall"}]},{n:"LINESPLINES",t:"3",d:"Generate sparklines embedded in the cell to describe the continuous trend of data",a:"Generate sparklines line chart",m:[1,8],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Line color",example:"#2ec7c9",detail:"The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #2ec7c9",require:"o",repeat:"n",type:"rangeall"},{name:"Line thickness",example:"1",detail:"Line thickness of the line graph, the default is 1px",require:"o",repeat:"n",type:"rangeall"},{name:"Auxiliary line",example:"avg",detail:"A horizontal line, which can be min, max, avg, median, range or custom value, default 0 none",require:"o",repeat:"n",type:"rangeall"},{name:"Auxiliary line color",example:"#000",detail:"Color setting of auxiliary line, same as line color configuration, default #000",require:"o",repeat:"n",type:"rangeall"},{name:"Maximum mark",example:"#fc5c5c",detail:"Identifies the maximum value of the line graph, the same line color configuration, default 0 does not display",require:"o",repeat:"n",type:"rangeall"},{name:"Minimum mark",example:"#fc5c5c",detail:"Identify the minimum value of the line graph, the same line color configuration, default 0 does not display",require:"o",repeat:"n",type:"rangeall"},{name:"Mark size",example:"1.5",detail:"The maximum and minimum mark size settings, the default is 1.5",require:"o",repeat:"n",type:"rangeall"}]},{n:"AREASPLINES",t:"3",d:"Generate sparklines embedded in the cell area chart, generally used to describe the continuous cumulative value trend of the data",a:"Generate sparklines area chart",m:[1,5],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Line color",example:"#2ec7c9",detail:"The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #2ec7c9",require:"o",repeat:"n",type:"rangeall"},{name:"Fill color",example:"#CCF3F4",detail:"Form an area chart, the same line color configuration, default 0 does not display",require:"o",repeat:"n",type:"rangeall"},{name:"Line thickness",example:"1",detail:"Line thickness of the line graph, the default is 1px",require:"o",repeat:"n",type:"rangeall"},{name:"Auxiliary line",example:"avg",detail:"A horizontal line, which can be min, max, avg, median, range or custom value, default 0 none",require:"o",repeat:"n",type:"rangeall"},{name:"Auxiliary line color",example:"#000",detail:"Color setting of auxiliary line, same as line color configuration, default #000",require:"o",repeat:"n",type:"rangeall"}]},{n:"COLUMNSPLINES",t:"3",d:"Generate sparklines embedded in the vertical histogram of cells, generally used to describe the size of discrete data",a:"Generate sparklines vertical histogram",m:[1,6],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Bar interval",example:"1",detail:"The distance between bars, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Bar color",example:"#fc5c5c",detail:"The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #fc5c5c",require:"o",repeat:"n",type:"rangeall"},{name:"Negative bar color",example:"#97b552",detail:"Negative bar color setting, representing the color of negative value, same as the bar color configuration, default #97b552",require:"o",repeat:"n",type:"rangeall"},{name:"Max",example:"100",detail:"The maximum value of the bar chart, used to standardize the length of the bar chart, the default is to automatically calculate false, auto, null",require:"o",repeat:"n",type:"rangeall"},{name:"Color palette",example:"#97b552",detail:"The color palette can set the color of each bar individually, multiple settings can be set, and two formats are supported: 1 color such as #000, which means that the color of the first bar is black; 2 value range: color, such as -2:# 000 indicates that the bar with a value of -2 is black, 0:5:#000 indicates that the bar with a value of 0-5 is black, and the default is empty",require:"o",repeat:"y",type:"rangeall"}]},{n:"STACKCOLUMNSPLINES",t:"3",d:"Generate sparklines, a cumulative vertical histogram embedded in a cell, generally used to describe the numerical size of multiple dimensions of discrete data",a:"Generate sparklines cumulative vertical histogram",m:[1,5],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Stack by column",example:"1",detail:"If you need to stack by row, set this item to false or 0, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Bar interval",example:"1",detail:"The distance between bars, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Max",example:"100",detail:"The maximum value of the cumulative bar, used to regulate the length of the bar, the default is to automatically calculate false, auto, null",require:"o",repeat:"n",type:"rangeall"},{name:"Color palette",example:"#97b552",detail:"The color palette can individually set the bar color of each dimension, which can be set to the range of A1:A10, etc. The default is #2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",require:"o",repeat:"y",type:"rangeall"}]},{n:"BARSPLINES",t:"3",d:"Generate sparklines embedded in the cell, generally used to describe the size of discrete data",a:"Generate sparklines horizontal bar graph",m:[1,6],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Bar interval",example:"1",detail:"The distance between bars, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Bar color",example:"#fc5c5c",detail:"The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #fc5c5c",require:"o",repeat:"n",type:"rangeall"},{name:"Negative bar color",example:"#97b552",detail:"Negative bar color setting, representing the color of negative value, same as the bar color configuration, default #97b552",require:"o",repeat:"n",type:"rangeall"},{name:"Max",example:"100",detail:"The maximum value of the bar chart, used to standardize the length of the bar chart, the default is to automatically calculate false, auto, null",require:"o",repeat:"n",type:"rangeall"},{name:"Color palette",example:"#97b552",detail:"The color palette can set the color of each bar individually, multiple settings can be set, and two formats are supported: 1 color such as #000, which means that the color of the first bar is black; 2 value range: color, such as -2:# 000 indicates that the bar with a value of -2 is black, 0:5:#000 indicates that the bar with a value of 0-5 is black, and the default is empty",require:"o",repeat:"y",type:"rangeall"}]},{n:"STACKBARSPLINES",t:"3",d:"Generate sparklines, a cumulative horizontal bar graph embedded in a cell, which is generally used to describe the numerical size of multiple dimensions of discrete data",a:"Generate sparklines cumulative horizontal bar graph",m:[1,5],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Stack by column",example:"1",detail:"If you need to stack by row, set this item to false or 0, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Bar interval",example:"1",detail:"The distance between bars, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Max",example:"100",detail:"The maximum value of the cumulative bar, used to regulate the length of the bar, the default is to automatically calculate false, auto, null",require:"o",repeat:"n",type:"rangeall"},{name:"Color palette",example:"#97b552",detail:"The color palette can individually set the bar color of each dimension, which can be set to the range of A1:A10, etc. The default is #2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",require:"o",repeat:"y",type:"rangeall"}]},{n:"DISCRETESPLINES",t:"3",d:"Generate sparklines embedded in the cell, generally used to describe the trend of discrete data",a:"Generate sparklines discrete graph",m:[1,4],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Segmentation threshold",example:"1",detail:"Discrete graph column color distinction, for example: if the value is 0, blue is greater than 0, red is less than 0, and the default is 0",require:"o",repeat:"n",type:"rangeall"},{name:"Above threshold color",example:"#2ec7c9",detail:"The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #2ec7c9",require:"o",repeat:"n",type:"rangeall"},{name:"Below threshold color",example:"#fc5c5c",detail:"The color setting of the bar below the threshold, the same as the color above the threshold, default #fc5c5c",require:"o",repeat:"n",type:"rangeall"}]},{n:"TRISTATESPLINES",t:"3",d:"Generate sparklines, a three-state graph embedded in the cell, which is generally used to describe the trend of three situations, such as winning, losing, or drawing.",a:"Generate sparklines three-state graph",m:[1,6],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Bar interval",example:"1",detail:"The distance between bars, the default is 1",require:"o",repeat:"n",type:"rangeall"},{name:"Bar color",example:"#fc5c5c",detail:"The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #fc5c5c",require:"o",repeat:"n",type:"rangeall"},{name:"Negative bar color",example:"#97b552",detail:"Negative bar color setting, representing the color of negative value, same as the bar color configuration, default #97b552",require:"o",repeat:"n",type:"rangeall"},{name:"Zero value bar color",example:"#999",detail:"Zero value bar color setting, representing 0 value color, the same color configuration of the bar, default #999",require:"o",repeat:"n",type:"rangeall"},{name:"Color palette",example:"#97b552",detail:"The color palette can set the color of each bar individually, multiple settings can be set, and two formats are supported: 1 color such as #000, which means that the color of the first bar is black; 2 value range: color, such as -2:# 000 indicates that the bar with a value of -2 is black, 0:5:#000 indicates that the bar with a value of 0-5 is black, and the default is empty",require:"o",repeat:"y",type:"rangeall"}]},{n:"PIESPLINES",t:"3",d:"Generate sparklines pie chart embedded in the cell, generally used to describe the proportion of data",a:"Generate sparklines pie chart",m:[1,5],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Rotation angle",example:"0",detail:"The rotation angle of the pie chart, the default is 0",require:"o",repeat:"n",type:"rangeall"},{name:"border",example:"0",detail:"Pie chart border size, default is none 0",require:"o",repeat:"n",type:"rangeall"},{name:"Border color",example:"#000",detail:"The border color of the pie chart, the default is #000",require:"o",repeat:"n",type:"rangeall"},{name:"Color palette",example:"#97b552",detail:"The color of the slice can be set in the palette, which can be set to the range of A1:A10, etc. The default is #2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",require:"o",repeat:"y",type:"rangeall"}]},{n:"BOXSPLINES",t:"3",d:"Generate sparklines embedded in the cell box plot, generally used to describe the statistical distribution of the data set",a:"Generate sparklines box plot",m:[1,4],p:[{name:"Range",example:"A1:A20",detail:"Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Outlier ratio",example:"1.5",detail:"The threshold range of outliers, if it is 0 or false, it will not be displayed, the default is 1.5 times",require:"o",repeat:"n",type:"rangeall"},{name:"Target value",example:"10",detail:"The target value setting on the box plot, the default is false and does not display",require:"o",repeat:"n",type:"rangeall"},{name:"Point size",example:"1.5",detail:"The radius of the target point and outlier is set, the default is 1.5",require:"o",repeat:"n",type:"rangeall"}]},{n:"BULLETSPLINES",t:"3",d:"Generate sparklines embedded in the cell, generally used to describe the task achievement rate",a:"Generating sparklines bullets",m:[2,3],p:[{name:"Target",example:"10",detail:"The numerical value can be calculated effectively for the achieved target value, such as A1, 100, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"achieved",example:"8",detail:"Only when the value is completed can the value be calculated effectively, such as A1, 100, etc.",require:"m",repeat:"n",type:"rangeall"},{name:"Contrast",example:"12",detail:"Comparative values, such as excess, minimum, and bottom line for awards, can be effectively calculated, such as A1, 100, etc. You can set up to 9 comparison values",require:"o",repeat:"y",type:"rangeall"}]},{n:"COMPOSESPLINES",t:"3",d:"Support multiple types of pictures in the same cell, each parameter represents a sparklines diagram",a:"Combine sparklines graphs into one cell",m:[1,1],p:[{name:"config",example:"PIESPLINES(A1:A20)",detail:"Sparklines chart settings, such as A1:A20, a completed pie chart, line chart settings, etc.",require:"m",repeat:"y",type:"rangeall"}]},{n:"SORT",t:"14",d:"Sorts the rows of a given array or range by the values in one or more columns.",a:"Sorts rows of range by specified column.",m:[1,4],p:[{name:"range",detail:"The data to be sorted.",example:"A2:A17",require:"m",repeat:"n",type:"rangenumber"},{name:"sort_column",detail:"The index of the column in `range` or a range outside of `range` containing the values by which to sort.",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"is_ascending",detail:"`TRUE` or `FALSE` indicating whether to sort `sort_column` in ascending order. `FALSE` sorts in descending order.",example:"-1",require:"o",repeat:"n",type:"rangenumber"},{name:"sort_column2",detail:"Additional columns.",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"FILTER",t:"14",d:"Returns a filtered version of the source range, returning only rows or columns which meet the specified conditions.",a:"Filters a range based off provided conditions.",m:[2,3],p:[{name:"range",detail:"The data to be filtered.",example:"A5:D20",require:"m",repeat:"n",type:"range"},{name:"condition1",detail:"A column or row containing true or false values corresponding to the first column or row of `range`, or an array formula evaluating to true or false.",example:"1",require:"m",repeat:"n",type:"range"},{name:"condition2",detail:"Additional rows or columns containing boolean values `TRUE` or `FALSE` indicating whether the corresponding row or column in `range` should pass through `FILTER`. Can also contain array formula expressions which evaluate to such rows or columns. All conditions must be of the same type (row or column). Mixing row conditions and column conditions is not permitted.",example:'""',require:"o",repeat:"n",type:"rangeall"}]},{n:"UNIQUE",t:"14",d:"Returns unique rows in the provided source range, discarding duplicates. Rows are returned in the order in which they first appear in the source range.",a:"Unique rows in the provided source range.",m:[1,3],p:[{name:"range",detail:"The data to filter by unique entries.",example:"A2:B26",require:"m",repeat:"n",type:"rangenumber"},{name:"by_col",detail:"[Option] - Logical value, indicating how to compare; by row = FALSE() or omitted; by column = TRUE().",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"},{name:"occurs_once",detail:"[Option] - Logical value, only one occurrence in the unique value is returned = TRUE(); including all unique values = FALSE() or omitted.",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"RANDARRAY",t:"14",d:"Returns a grid of random numbers between 0 inclusive and 1 exclusive. The grid size will match the provided rows and columns arguments. If neither rows nor columns are provided, then the grid will be size 1 x 1.",a:"Returns a grid of random numbers.",m:[0,2],p:[{name:"rows",detail:"The number of rows to populate with a random number.",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"columns",detail:"The number of columns to populate with a random number.",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"SEQUENCE",t:"14",d:"Returns a grid of sequential numbers starting at a specified start value and  increasing by a specified step size. By default, the sequence starts at and  increases by 1.",a:"Returns a grid of sequential numbers.",m:[1,4],p:[{name:"rows",detail:"The number of rows in the function's resulting grid.",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"columns",detail:"The number of columns in the function's resulting grid. If omitted, the result grid will have 1 column.",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"start",detail:"The number, at which to start the sequence. If omitted, the sequence will start at 1.",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"step",detail:"The amount each value in the sequence will differ by. If omitted, each value will differ by 1.",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"EVALUATE",t:"3",d:"Evaluate a formula or expression expressed in words and return the result",a:"Evaluate according to literal formula or expression.",m:[1,1],p:[{name:"expression",example:'"A1+5*2^2"',detail:"Formula or expression",require:"m",repeat:"n",type:"rangeall"}]},{n:"REMOTE",t:"5",d:"Calls a function on a remote server",a:"Calls a function on a remote back end server/API.",m:[1,1],p:[{name:"remote_expression",example:"SUM(A1:A10000000)",detail:"Formula",require:"m",repeat:"n",type:"string"}]}],toolbar:{toolbar:"उपकरण पट्टी",undo:"पूर्ववत करें",redo:"फिर से करें","clear-format":"फॉर्मेट साफ़ करें","format-painter":"फॉर्मेट पेंटर",paintFormat:"फॉर्मेट पेंट करें","currency-format":"मुद्रा के रूप में फॉर्मेट करें","percentage-format":"प्रतिशत के रूप में फॉर्मेट करें","number-decrease":"दशमलव स्थान घटाएँ","number-increase":"दशमलव स्थान बढ़ाएँ",moreFormats:"अधिक फॉर्मेट","border-all":"सभी सीमाएँ","merge-all":"सभी सेल मिलाएँ",font:"फ़ॉन्ट","font-size":"फ़ॉन्ट साइज़",bold:"बोल्ड (Ctrl+B)",italic:"इटैलिक (Ctrl+I)","strike-through":"स्ट्राइकथ्रू (Alt+Shift+5)",underline:"अंडरलाइन","font-color":"फ़ॉन्ट रंग","align-left":"बाएँ अलाइन","align-center":"क्षैतिज सेंटर","align-right":"दाएँ अलाइन","align-top":"ऊपर अलाइन","align-mid":"लंबवत सेंटर","align-bottom":"नीचे अलाइन",chooseColor:"रंग चुनें",resetColor:"रीसेट करें",customColor:"कस्टम",alternatingColors:"वैकल्पिक रंग",confirmColor:"ठीक है",cancelColor:"रद्द करें",collapse:"संकुचित करें",background:"बैकग्राउंड",border:"सीमा",borderStyle:"सीमा शैली","merge-cell":"सेल मिलाएँ",chooseMergeType:"मिलाने का प्रकार चुनें",horizontalAlign:"क्षैतिज अलाइनमेंट",verticalAlign:"लंबवत अलाइनमेंट",alignment:"अलाइनमेंट",textWrap:"टेक्स्ट रैप",textWrapMode:"टेक्स्ट रैप मोड",textRotate:"टेक्स्ट घुमाएँ",textRotateMode:"टेक्स्ट घुमाने का मोड",freeze:"फ्रीज़ करें",sort:"छाँटें",filter:"फ़िल्टर करें",sortAndFilter:"छाँटें और फ़िल्टर करें",findAndReplace:"खोजें और बदलें","formula-sum":"फॉर्मूला-सम",autoSum:"स्वचालित-सम",moreFunction:"अधिक फ़ंक्शन",conditionalFormat:"सशर्त फॉर्मेट",comment:"टिप्पणी",pivotTable:"पिवट तालिका",chart:"चार्ट",screenshot:"स्क्रीनशॉट",splitColumn:"टेक्स्ट विभाजित करें",insertImage:"छवि डालें",insertLink:"लिंक डालें",dataVerification:"डेटा वेरिफिकेशन",protection:"प्रोटेक्शन",clearText:"रंग साफ़ करें",noColorSelectedText:"कोई रंग चयनित नहीं है",toolMore:"अधिक",toolLess:"कम",toolClose:"बंद करें",toolMoreTip:"अधिक सुविधाएँ",moreOptions:"अधिक विकल्प",cellFormat:"सेल फॉर्मेट कॉन्फ़िगरेशन",print:"प्रिंट करें"},alternatingColors:{applyRange:"रेंज पर लागू करें",selectRange:"डेटा रेंज चुनें",header:"हेडर",footer:"फुटर",errorInfo:"एकाधिक चयन क्षेत्रों पर यह कार्य नहीं किया जा सकता, कृपया एक क्षेत्र चुनें और फिर से प्रयास करें",textTitle:"फॉर्मेट स्टाइल",custom:"कस्टम",close:"बंद करें",selectionTextColor:"टेक्स्ट रंग चुनने के लिए क्लिक करें",selectionCellColor:"सेल रंग चुनने के लिए क्लिक करें",removeColor:"वैकल्पिक रंग हटाएँ",colorShow:"रंग",currentColor:"वर्तमान",tipSelectRange:"कृपया वैकल्पिक रंगों की रेंज चुनें",errorNoRange:"कोई रेंज चयनित नहीं है",errorExistColors:"वैकल्पिक रंग पहले से मौजूद हैं और संपादित नहीं किए जा सकते"},button:{confirm:"ठीक है",cancel:"रद्द करें",close:"बंद करें",update:"अपडेट करें",delete:"हटाएँ",insert:"डालें",prevPage:"पिछला",nextPage:"अगला",total:"कुल:"},paint:{start:"फॉर्मेट पेंट शुरू",end:"ESC",tipSelectRange:"कृपया कॉपी किए जाने वाले रेंज का चयन करें",tipNotMulti:"एकाधिक चयन रेंज पर यह कार्य नहीं किया जा सकता"},format:{moreCurrency:"अधिक मुद्रा फॉर्मेट",moreDateTime:"अधिक दिनांक और समय फॉर्मेट",moreNumber:"अधिक संख्या फॉर्मेट",titleCurrency:"मुद्रा फॉर्मेट",decimalPlaces:"दशमलव स्थान",titleDateTime:"दिनांक और समय फॉर्मेट",titleNumber:"संख्या फॉर्मेट",tipDecimalPlaces:"दशमलव स्थान 0-9 के बीच होना चाहिए!",select:"चुनें",format:"फॉर्मेट",currency:"मुद्रा"},info:{detailUpdate:"नया खुला",detailSave:"स्थानीय कैश पुनर्स्थापित",row:"",column:"",loading:"लोड हो रहा है...",copy:"कॉपी करें",return:"बाहर निकलें",rename:"नाम बदलें",tips:"वर्कबुक का नाम बदलें",noName:"अनाम स्प्रेडशीट",wait:"अपडेट की प्रतीक्षा में",add:"जोड़ें",addLast:"नीचे और पंक्तियाँ",backTop:"शीर्ष पर वापस जाएँ",pageInfo:"कुल ${total}，${totalPage} पृष्ठ，वर्तमान ${currentPage}",nextPage:"अगला",tipInputNumber:"कृपया संख्या दर्ज करें",tipInputNumberLimit:"वृद्धि सीमा 1-100 तक सीमित है",tipRowHeightLimit:"पंक्ति की ऊँचाई 0 ~ 545 के बीच होनी चाहिए",tipColumnWidthLimit:"कॉलम की चौड़ाई 0 ~ 2038 के बीच होनी चाहिए",pageInfoFull:"कुल ${total}，${totalPage} पृष्ठ，सभी डेटा प्रदर्शित"},currencyDetail:[{name:"चीनी युआन",pos:"before",value:"¥"},{name:"अमेरिकी डॉलर",pos:"before",value:"$"},{name:"यूरो",pos:"before",value:"€"},{name:"ब्रिटिश पाउंड",pos:"before",value:"￡"},{name:"हांगकांग डॉलर",pos:"before",value:"$"},{name:"जापानी येन",pos:"before",value:"￥"},{name:"अल्बानियाई लेक",pos:"before",value:"Lek"},{name:"अल्जीरियाई दिनार",pos:"before",value:"din"},{name:"अफगानी",pos:"after",value:"Af"},{name:"अर्जेंटीना पेसो",pos:"before",value:"$"},{name:"संयुक्त अरब अमीरात दिरहम",pos:"before",value:"dh"},{name:"अरूबियन फ्लोरिन",pos:"before",value:"Afl"},{name:"ओमानी रियाल",pos:"before",value:"Rial"},{name:"अज़रबैजानी मनात",pos:"before",value:"?"},{name:"मिस्र पाउंड",pos:"before",value:"￡"},{name:"इथियोपियाई बिर",pos:"before",value:"Birr"},{name:"अंगोलन क्वांज़ा",pos:"before",value:"Kz"},{name:"ऑस्ट्रेलियाई डॉलर",pos:"before",value:"$"},{name:"पाटाका",pos:"before",value:"MOP"},{name:"बारबाडोस डॉलर",pos:"before",value:"$"},{name:"पापुआ न्यू गिनी किना",pos:"before",value:"PGK"},{name:"बहामी डॉलर",pos:"before",value:"$"},{name:"पाकिस्तानी रुपया",pos:"before",value:"Rs"},{name:"परागुआयन गुआरानी",pos:"after",value:"Gs"},{name:"बहरीनी दिनार",pos:"before",value:"din"},{name:"पनामियन बाल्बोआ",pos:"before",value:"B/"},{name:"ब्राज़ीली रियल",pos:"before",value:"R$"},{name:"बेलारूसी रूबल",pos:"after",value:"р"},{name:"बरमूडा डॉलर",pos:"before",value:"$"},{name:"बुल्गारियाई लेव",pos:"before",value:"lev"},{name:"आइसलैंड क्रोना",pos:"before",value:"kr"},{name:"बोस्निया-हर्जेगोविना परिवर्तनीय मार्क",pos:"before",value:"KM"},{name:"पोलिश ज़्लॉटी",pos:"after",value:"z?"},{name:"बोलिवियानो",pos:"before",value:"Bs"},{name:"बेलीज़ डॉलर",pos:"before",value:"$"},{name:"बोत्सवाना पुला",pos:"before",value:"P"},{name:"नॉट डान्नुज़्हामू",pos:"before",value:"Nu"},{name:"बुरुंडी फ्रैंक",pos:"before",value:"FBu"},{name:"उत्तर कोरियाई वॉन",pos:"before",value:"?KP"},{name:"डेनिश क्रोन",pos:"after",value:"kr"},{name:"पूर्व कैरेबियन डॉलर",pos:"before",value:"$"},{name:"डोमिनिका पेसो",pos:"before",value:"RD$"},{name:"रूसी रूबल",pos:"after",value:"?"},{name:"एरिट्रियन नाक्फा",pos:"before",value:"Nfk"},{name:"सीएफए फ्रैंक",pos:"before",value:"CFA"},{name:"फिलिपिनो पेसो",pos:"before",value:"?"},{name:"फिजी डॉलर",pos:"before",value:"$"},{name:"केप वर्ड एस्कूडो",pos:"before",value:"CVE"},{name:"फ़ॉकलैंड द्वीप पाउंड",pos:"before",value:"￡"},{name:"गैंबियन डालासी",pos:"before",value:"GMD"},{name:"कांगोलीज फ्रैंक",pos:"before",value:"FrCD"},{name:"कोलम्बियाई पेसो",pos:"before",value:"$"},{name:"कोस्टा रिकी कोलोन",pos:"before",value:"?"},{name:"क्यूबा पेसो",pos:"before",value:"$"},{name:"क्यूबा परिवर्तनीय पेसो",pos:"before",value:"$"},{name:"गयाना डॉलर",pos:"before",value:"$"},{name:"कजाखस्तानी टेंगे",pos:"before",value:"?"},{name:"हैती गॉर्ड",pos:"before",value:"HTG"},{name:"वॉन",pos:"before",value:"?"},{name:"नीदरलैंड एंटीलिज गिल्डर",pos:"before",value:"NAf."},{name:"होंडुरास लेम्पिरास",pos:"before",value:"L"},{name:"जिबूती फ्रैंक",pos:"before",value:"Fdj"},{name:"किर्गिस्तान सोम",pos:"before",value:"KGS"},{name:"गिनी फ्रैंक",pos:"before",value:"FG"},{name:"कनाडाई डॉलर",pos:"before",value:"$"},{name:"घनियन सेडी",pos:"before",value:"GHS"},{name:"कंबोडियन रील",pos:"before",value:"Riel"},{name:"चेक कोरुना",pos:"after",value:"K?"},{name:"जिम्बाब्वे डॉलर",pos:"before",value:"$"},{name:"कतर रियाल",pos:"before",value:"Rial"},{name:"केमैन द्वीप डॉलर",pos:"before",value:"$"},{name:"कोमोरियन फ्रैंक",pos:"before",value:"CF"},{name:"कुवैती दिनार",pos:"before",value:"din"},{name:"क्रोएशियाई कुना",pos:"before",value:"kn"},{name:"केन्याई शिलिंग",pos:"before",value:"Ksh"},{name:"लेसोथो लोटी",pos:"before",value:"LSL"},{name:"लाओ किप",pos:"before",value:"?"},{name:"लेबनानी पाउंड",pos:"before",value:"L￡"},{name:"लिथुआनियाई लितास",pos:"before",value:"Lt"},{name:"लिबियाई दिनार",pos:"before",value:"din"},{name:"लाइबेरियाई डॉलर",pos:"before",value:"$"},{name:"रवांडा फ्रैंक",pos:"before",value:"RF"},{name:"रोमानियाई ल्यू",pos:"before",value:"RON"},{name:"मेडागास्कर अरियारी",pos:"before",value:"Ar"},{name:"मालदीवियन रूफिया",pos:"before",value:"Rf"},{name:"मलावी क्वाचा",pos:"before",value:"MWK"},{name:"मलेशियाई रिंगित",pos:"before",value:"RM"},{name:"मैसिडोनिया पहनने वाला दिनार",pos:"before",value:"din"},{name:"मॉरीशस रुपया",pos:"before",value:"MURs"},{name:"मॉरीतानियाई औगुइया",pos:"before",value:"MRO"},{name:"मंगोलियाई टुग्रिक",pos:"before",value:"?"},{name:"बांग्लादेशी टाका",pos:"before",value:"?"},{name:"पेरूवियन न्यूवो सोल",pos:"before",value:"S/"},{name:"म्यांमार क्यात",pos:"before",value:"K"},{name:"मोल्दोवान लेउ",pos:"before",value:"MDL"},{name:"मोरक्को दिरहम",pos:"before",value:"dh"},{name:"मोज़ाम्बिक मेटिकल",pos:"before",value:"MTn"},{name:"मेक्सिकन पेसो",pos:"before",value:"$"},{name:"नामीबियाई डॉलर",pos:"before",value:"$"},{name:"दक्षिण अफ्रीकी रैंड",pos:"before",value:"R"},{name:"दक्षिण सूडानी पाउंड",pos:"before",value:"￡"},{name:"निकारागुआ कोरडोबा",pos:"before",value:"C$"},{name:"नेपाली रुपया",pos:"before",value:"Rs"},{name:"नाइजीरियाई नैरा",pos:"before",value:"?"},{name:"नॉर्वेजियन क्रोन",pos:"after",value:"kr"},{name:"जॉर्जियन लारी",pos:"before",value:"GEL"},{name:"स्वीडिश क्रोना",pos:"after",value:"kr"},{name:"स्विस फ्रैंक",pos:"before",value:"CHF"},{name:"सर्बियाई दिनार",pos:"before",value:"din"},{name:"सिएरा लियोन",pos:"before",value:"SLL"},{name:"सेशेल्स रुपया",pos:"before",value:"SCR"},{name:"सऊदी रियाल",pos:"before",value:"Rial"},{name:"साओ टोम डोबरा",pos:"before",value:"Db"},{name:"सेंट हेलेना पाउंड",pos:"before",value:"￡"},{name:"श्रीलंकाई रुपया",pos:"before",value:"Rs"},{name:"स्वाज़ीलैंड लिलांगेनी",pos:"before",value:"SZL"},{name:"सूडानी पाउंड",pos:"before",value:"SDG"},{name:"सूरीनामी डॉलर",pos:"before",value:"$"},{name:"सोलोमन द्वीप डॉलर",pos:"before",value:"$"},{name:"सोमाली शिलिंग",pos:"before",value:"SOS"},{name:"ताजिकिस्तान सोमोनी",pos:"before",value:"Som"},{name:"प्रशांत फ्रैंक",pos:"after",value:"FCFP"},{name:"थाई बहत",pos:"before",value:"?"},{name:"तंजानियाई शिलिंग",pos:"before",value:"TSh"},{name:"टोंगन पाआंगा",pos:"before",value:"T$"},{name:"त्रिनिदाद और टोबैगो डॉलर",pos:"before",value:"$"},{name:"ट्यूनीशियाई दिनार",pos:"before",value:"din"},{name:"तुर्की लिरा",pos:"before",value:"?"},{name:"वानुअतु वतू",pos:"before",value:"VUV"},{name:"ग्वाटेमाला क्वेत्ज़ल",pos:"before",value:"Q"},{name:"कमीशन बोलिवर",pos:"before",value:"Bs"},{name:"ब्रुनेई डॉलर",pos:"before",value:"$"},{name:"युगांडा शिलिंग",pos:"before",value:"UGX"},{name:"यूक्रेनी रिव्निया",pos:"before",value:"грн."},{name:"उरुग्वियन पेसो",pos:"before",value:"$"},{name:"उज़्बेकिस्तान सोम",pos:"before",value:"so?m"},{name:"पश्चिमी समोआ ताला",pos:"before",value:"WST"},{name:"सिंगापुर डॉलर",pos:"before",value:"$"},{name:"एनटी",pos:"before",value:"NT$"},{name:"न्यूजीलैंड डॉलर",pos:"before",value:"$"},{name:"हंगेरियन फोरिंट",pos:"before",value:"Ft"},{name:"सीरियाई पाउंड",pos:"before",value:"￡"},{name:"जमैका डॉलर",pos:"before",value:"$"},{name:"आर्मेनियाई द्राम",pos:"before",value:"Dram"},{name:"येमनी रियाल",pos:"before",value:"Rial"},{name:"इराकी दिनार",pos:"before",value:"din"},{name:"ईरानी रियाल",pos:"before",value:"Rial"},{name:"नया इज़राइली शेकेल",pos:"before",value:"?"},{name:"भारतीय रुपया",pos:"before",value:"₹"},{name:"इंडोनेशियाई रुपिया",pos:"before",value:"Rp"},{name:"जॉर्डनियन दिनार",pos:"before",value:"din"},{name:"वीएनडी",pos:"after",value:"?"},{name:"ज़ाम्बियन क्वाचा",pos:"before",value:"ZMW"},{name:"जिब्राल्टर पाउंड",pos:"before",value:"￡"},{name:"चिली पेसो",pos:"before",value:"$"},{name:"सीएफए फ्रैंक बीईएसी",pos:"before",value:"FCFA"}],defaultFmt:function defaultFmt(currency){return[{text:"स्वचालित",value:"General",example:""},{text:"सादा टेक्स्ट",value:"@",example:""},{text:"",value:"split",example:""},{text:"संख्या",value:"##0.00",example:"1000.12"},{text:"प्रतिशत",value:"#0.00%",example:"12.21%"},{text:"वैज्ञानिक",value:"0.00E+00",example:"1.01E+5"},{text:"",value:"split",example:""},{text:"लेखांकन",value:"".concat(currency,"(0.00)"),example:"".concat(currency,"(1200.09)")},{text:"मुद्रा",value:"".concat(currency,"0.00"),example:"".concat(currency,"1200.09")},{text:"",value:"split",example:""},{text:"दिनांक",value:"yyyy-MM-dd",example:"2017-11-29"},{text:"समय",value:"hh:mm AM/PM",example:"3:00 PM"},{text:"24 घंटे का समय",value:"hh:mm",example:"15:00"},{text:"दिनांक समय",value:"yyyy-MM-dd hh:mm AM/PM",example:"2017-11-29 3:00 PM"},{text:"दिनांक समय 24 घंटे",value:"yyyy-MM-dd hh:mm",example:"2017-11-29 15:00"},{text:"",value:"split",example:""},{text:"कस्टम फॉर्मेट",value:"fmtOtherSelf",example:"",icon:"rightArrow"}];},dateFmtList:[{name:"1930-08-05",value:"yyyy-MM-dd"},{name:"1930/8/5",value:"yyyy/MM/dd"},{name:"08-05",value:"MM-dd"},{name:"8-5",value:"M-d"},{name:"13:30:30",value:"h:mm:ss"},{name:"13:30",value:"h:mm"},{name:"PM 01:30",value:"AM/PM hh:mm"},{name:"PM 1:30",value:"AM/PM h:mm"},{name:"PM 1:30:30",value:"AM/PM h:mm:ss"},{name:"08-05 PM 01:30",value:"MM-dd AM/PM hh:mm"}],fontFamily:{MicrosoftYaHei:"YaHei"},fontarray:["Times New Roman","Arial","Tahoma","Verdana"],fontjson:{"times new roman":0,arial:1,tahoma:2,verdana:3},border:{borderTop:"ऊपरी सीमा",borderBottom:"निचली सीमा",borderLeft:"बाईं सीमा",borderRight:"दाईं सीमा",borderNone:"कोई सीमा नहीं",borderAll:"सभी सीमाएँ",borderOutside:"बाहरी सीमा",borderInside:"भीतरी सीमा",borderHorizontal:"क्षैतिज सीमाएँ",borderVertical:"लंबवत सीमाएँ",borderColor:"सीमा का रंग",borderSize:"सीमा का आकार",borderSlash:"तिरछी सीमा",borderDefault:"डिफ़ॉल्ट",borderStyle:"सीमा की शैली"},merge:{mergeAll:"सभी को मिलाएँ",mergeV:"लंबवत मिलाएँ",mergeH:"क्षैतिज मिलाएँ",mergeCancel:"मिलाना रद्द करें",overlappingError:"ओवरलैपिंग क्षेत्रों को मिला नहीं सकते",partiallyError:"आंशिक रूप से मिले हुए सेल पर यह कार्य नहीं किया जा सकता"},align:{left:"बाएँ",center:"मध्य",right:"दाएँ",top:"ऊपर",middle:"मध्य",bottom:"नीचे"},textWrap:{overflow:"ओवरफ्लो",wrap:"रैप",clip:"क्लिप"},rotation:{none:"कोई नहीं",angleup:"ऊपर की ओर झुकाएँ",angledown:"नीचे की ओर झुकाएँ",vertical:"लंबवत स्टैक करें",rotationUp:"ऊपर की ओर घुमाएँ",rotationDown:"नीचे की ओर घुमाएँ"},freezen:{default:"फ्रीज़ करें",freezenRow:"पहली पंक्ति",freezenColumn:"पहला कॉलम",freezenRC:"दोनों",freezenRowRange:"वर्तमान पंक्ति तक फ्रीज़ करें",freezenColumnRange:"वर्तमान कॉलम तक फ्रीज़ करें",freezenRCRange:"वर्तमान सेल तक फ्रीज़ करें",freezenCancel:"फ्रीज़िंग रद्द करें",noSeletionError:"कोई रेंज चयनित नहीं है",rangeRCOverErrorTitle:"फ्रीज़ अनुस्मारक",rangeRCOverError:"फ्रोज़न पेन दृश्यमान सीमा से परे है, जो असामान्य संचालन का कारण बनेगा। कृपया फ्रोज़न क्षेत्र को रीसेट करें।"},sort:{asc:"आरोही क्रम ",desc:"अवरोही क्रम ",custom:"कस्टम सॉर्ट",hasTitle:"डेटा में शीर्षक पंक्ति है",sortBy:"इसके अनुसार सॉर्ट करें",addOthers:"एक और सॉर्ट कॉलम जोड़ें",close:"बंद करें",confirm:"सॉर्ट करें",columnOperation:"कॉलम",secondaryTitle:"फिर इसके अनुसार",sortTitle:"रेंज सॉर्ट करें",sortRangeTitle:"इससे रेंज सॉर्ट करें",sortRangeTitleTo:"इस तक",noRangeError:"एकाधिक चयन क्षेत्रों पर यह कार्य नहीं किया जा सकता, कृपया एक रेंज चुनें और फिर से प्रयास करें",mergeError:"चयन में मर्ज किए गए सेल हैं, यह कार्य नहीं किया जा सकता!"},filter:{filter:"फ़िल्टर बनाएँ",sortByAsc:"आरोही क्रम में छाँटें",sortByDesc:"अवरोही क्रम में छाँटें",filterByColor:"रंग के आधार पर फ़िल्टर करें",filterByCondition:"शर्त के आधार पर फ़िल्टर करें",filterByValues:"मान के आधार पर फ़िल्टर करें",filiterInputNone:"कोई नहीं",filiterInputTip:"फ़िल्टर मान दर्ज करें",filiterRangeStartTip:"सूत्र के लिए मान",filiterRangeEndTip:"सूत्र के लिए मान",filterValueByAllBtn:"सभी को चुनें",filterValueByClearBtn:"साफ़ करें",filterValueByInverseBtn:"विपरीत",filterValueByTip:"मान के आधार पर फ़िल्टर करें",filterConform:"पुष्टि करें",filterCancel:"रद्द करें",clearFilter:"फ़िल्टर साफ़ करें",conditionNone:"कोई नहीं",conditionCellIsNull:"खाली है",conditionCellNotNull:"खाली नहीं है",conditionCellTextContain:"टेक्स्ट में शामिल है",conditionCellTextNotContain:"टेक्स्ट में शामिल नहीं है",conditionCellTextStart:"टेक्स्ट इससे शुरू होता है",conditionCellTextEnd:"टेक्स्ट इस पर समाप्त होता है",conditionCellTextEqual:"टेक्स्ट बिल्कुल यही है",conditionCellDateEqual:"तिथि है",conditionCellDateBefore:"तिथि इससे पहले है",conditionCellDateAfter:"तिथि इसके बाद है",conditionCellGreater:"इससे बड़ा",conditionCellGreaterEqual:"इससे बड़ा या बराबर",conditionCellLess:"इससे छोटा",conditionCellLessEqual:"इससे छोटा या बराबर",conditionCellEqual:"इसके बराबर है",conditionCellNotEqual:"इसके बराबर नहीं है",conditionCellBetween:"इसके बीच में है",conditionCellNotBetween:"इसके बीच में नहीं है",filiterMoreDataTip:"बड़ी मात्रा में डेटा! कृपया प्रतीक्षा करें",filiterMonthText:"महीना",filiterYearText:"वर्ष",filiterByColorTip:"सेल के रंग के आधार पर फ़िल्टर करें",filiterByTextColorTip:"फ़ॉन्ट के रंग के आधार पर फ़िल्टर करें",filterContainerOneColorTip:"इस कॉलम में केवल एक रंग है",filterDateFormatTip:"दिनांक प्रारूप",valueBlank:"(रिक्त)",mergeError:"फ़िल्टर चयन में मर्ज किए गए सेल हैं, यह कार्य नहीं किया जा सकता!"},rightclick:{copy:"कॉपी",copyAs:"के रूप में कॉपी करें",paste:"पेस्ट",insert:"डालें",image:"चित्र डालें",link:"लिंक डालें",delete:"हटाएं",deleteCell:"सेल हटाएं",deleteSelected:"चयनित हटाएं",hide:"छुपाएं",hideSelected:"चयनित छुपाएं",showHide:"छुपाए हुए दिखाएं",to:"की ओर",left:"बाएं",right:"दाएं",top:"ऊपर",bottom:"नीचे",moveLeft:"बाएं जाएं",moveUp:"ऊपर जाएं",add:"जोड़ें",row:"पंक्ति",column:"स्तंभ",width:"चौड़ाई",height:"ऊंचाई",number:"संख्या",confirm:"पुष्टि करें",orderAZ:"आरोही क्रम में",orderZA:"अवरोही क्रम में",clearContent:"कॉन्टेंट साफ करें",matrix:"मैट्रिक्स ऑपरेशन",sortSelection:"सॉर्ट करें",filterSelection:"फिल्टर करें",chartGeneration:"चार्ट बनाएं",firstLineTitle:"पहली पंक्ति शीर्षक",untitled:"शीर्षक रहित",array1:"एक आयामी ऐरे",array2:"दो आयामी ऐरे",array3:"बहुआयामी ऐरे",diagonal:"तिरछा",antiDiagonal:"विपरीत तिरछा",diagonalOffset:"तिरछा ऑफसेट",offset:"ऑफसेट",boolean:"बूलियन",flip:"फ्लिप करें",upAndDown:"ऊपर और नीचे",leftAndRight:"बाएं और दाएं",clockwise:"घड़ी की दिशा में",counterclockwise:"घड़ी की विपरीत दिशा में",transpose:"ट्रांसपोज़ करें",matrixCalculation:"मैट्रिक्स गणना",plus:"जोड़ें",minus:"घटाएं",multiply:"गुणा",divided:"विभाजित",power:"पावर",root:"रूट",log:"लॉग",delete0:"दोनों सिरों पर 0 मान हटाएं",removeDuplicate:"डुप्लिकेट मान हटाएं",byRow:"पंक्ति द्वारा",byCol:"स्तंभ द्वारा",generateNewMatrix:"नया मैट्रिक्स बनाएं",noMulti:"कई चयन क्षेत्रों पर यह ऑपरेशन नहीं कर सकते, कृपया एकल क्षेत्र का चयन करें",cannotDeleteAllRow:"सभी पंक्तियाँ नहीं हटा सकते",cannotDeleteAllColumn:"सभी स्तंभ नहीं हटा सकते",cannotDeleteRowReadOnly:"पंक्ति केवल-पढ़ने के लिए हटाई नहीं जा सकती",cannotDeleteColumnReadOnly:"स्तंभ केवल-पढ़ने के लिए हटाई नहीं जा सकती",cannotInsertOnRowReadOnly:"केवल-पढ़ने की पंक्ति पर सम्मिलित नहीं कर सकते",cannotInsertOnColumnReadOnly:"केवल-पढ़ने के स्तंभ पर सम्मिलित नहीं कर सकते",rowOverLimit:"10000 पंक्ति सीमा पार हो गई",columnOverLimit:"1000 स्तंभ सीमा पार हो गई"},comment:{insert:"डालें",edit:"संपादित करें",delete:"हटाएं",showOne:"दिखाएं/छुपाएं",showAll:"सभी दिखाएं/छुपाएं"},screenshot:{screenshotTipNoSelection:"कृपया स्क्रीनशॉट का दायरा चुनें",screenshotTipTitle:"चेतावनी!",screenshotTipHasMerge:"यह ऑपरेशन मर्ज किए गए सेल्स पर नहीं किया जा सकता",screenshotTipHasMulti:"यह ऑपरेशन कई चयन क्षेत्रों पर नहीं किया जा सकता",screenshotTipSuccess:"सफल",screenshotImageName:"स्क्रीनशॉट",downLoadClose:"बंद करें",downLoadCopy:"क्लिपबोर्ड पर कॉपी करें",downLoadBtn:"डाउनलोड",browserNotTip:"IE ब्राउज़र द्वारा समर्थित नहीं!",rightclickTip:'कृपया चित्र पर राइट-क्लिक "कॉपी" करें',successTip:'सफलतापूर्वक (यदि पेस्ट करना विफल हो जाए, तो कृपया चित्र पर राइट-क्लिक करें और "कॉपी इमेज" चुनें)'},splitText:{splitDelimiters:"डिलिमिटर्स",splitOther:"अन्य",splitContinueSymbol:"लगातार विभाजक एकल के रूप में माने जाते हैं",splitDataPreview:"पूर्वावलोकन",splitTextTitle:"पाठ विभाजित करें",splitConfirmToExe:"यहां पहले से डेटा है, क्या आप इसे बदलना चाहते हैं?",splitSymbols:[{name:"टैब",value:"Tab"},{name:"अर्धविराम",value:"semicolon"},{name:"अल्पविराम",value:"comma"},{name:"स्थान",value:"space"}],tipNoMulti:"कई चयन क्षेत्रों पर यह ऑपरेशन नहीं किया जा सकता, कृपया एकल क्षेत्र का चयन करें और पुनः प्रयास करें",tipNoMultiColumn:"एक समय में केवल एक ही कॉलम के डेटा को परिवर्तित किया जा सकता है। चयनित क्षेत्र में कई पंक्तियाँ हो सकती हैं लेकिन कई कॉलम नहीं। कृपया एकल कॉलम सीमा का चयन करने के बाद पुनः प्रयास करें",tipNoSelect:"चयन किए बिना आप एक सेल को अलग नहीं कर सकते"},imageText:{imageSetting:"छवि सेटिंग",close:"बंद करें",conventional:"पारंपरिक",moveCell1:"सेल्स को स्थानांतरित और आकार बदलें",moveCell2:"सेल्स को स्थानांतरित करें और आकार न बदलें",moveCell3:"सेल्स को न स्थानांतरित करें और आकार बदलें",fixedPos:"स्थिर स्थिति",border:"सीमा",width:"चौड़ाई",radius:"त्रिज्या",style:"शैली",solid:"ठोस",dashed:"डैश्ड",dotted:"डॉटेड",double:"डबल",color:"रंग"},punctuation:{tab:"टैब",semicolon:"अर्धविराम",comma:"अल्पविराम",space:"स्थान"},findAndReplace:{find:"खोजें",replace:"बदलें",goto:"जाएं",location:"स्थान",formula:"सूत्र",date:"तिथि",number:"संख्या",string:"स्ट्रिंग",error:"त्रुटि",condition:"शर्त",rowSpan:"पंक्ति विस्तार",columnSpan:"स्तंभ विस्तार",locationExample:"स्थान",lessTwoRowTip:"कृपया कम से कम दो पंक्तियाँ चुनें",lessTwoColumnTip:"कृपया कम से कम दो स्तंभ चुनें",findTextbox:"खोज सामग्री",replaceTextbox:"सामग्री बदलें",regexTextbox:"नियमित अभिव्यक्ति",wholeTextbox:"पूरा शब्द",distinguishTextbox:"केस संवेदनशील",allReplaceBtn:"सभी बदलें",replaceBtn:"बदलें",allFindBtn:"सभी खोजें",findBtn:"अगला खोजें",noFindTip:"सामग्री नहीं मिली",modeTip:"यह ऑपरेशन इस मोड में उपलब्ध नहीं है",searchTargetSheet:"शीट",searchTargetCell:"सेल",searchTargetValue:"मूल्य",searchInputTip:"कृपया खोज सामग्री दर्ज करें",noReplceTip:"बदलने के लिए कुछ नहीं है",noMatchTip:"कोई मेल नहीं मिला",successTip:"${xlength} आइटम मिले",locationConstant:"स्थिरांक",locationFormula:"सूत्र",locationDate:"तिथि",locationDigital:"संख्या",locationString:"स्ट्रिंग",locationBool:"लॉजिकल",locationError:"त्रुटि",locationNull:"शून्य",locationCondition:"शर्तीय प्रारूप",locationRowSpan:"पंक्ति विस्तार",locationColumnSpan:"स्तंभ विस्तार",locationTiplessTwoRow:"कृपया कम से कम दो पंक्तियाँ चुनें",locationTiplessTwoColumn:"कृपया कम से कम दो स्तंभ चुनें",locationTipNotFindCell:"सेल नहीं मिला"},sheetconfig:{delete:"हटाएं",copy:"कॉपी करें",rename:"नाम बदलें",changeColor:"रंग बदलें",hide:"छुपाएं",unhide:"छुपा हुआ दिखाएं",moveLeft:"बाएं जाएं",moveRight:"दाएं जाएं",resetColor:"रंग रीसेट करें",cancelText:"रद्द करें",chooseText:"रंग की पुष्टि करें",focus:"फोकस करें",tipNameRepeat:"टैब पृष्ठ का नाम दोहराया नहीं जा सकता! कृपया संशोधित करें",noMoreSheet:"वर्कबुक में कम से कम एक दृश्य वर्कशीट होनी चाहिए। चयनित वर्कशीट को हटाने के लिए, कृपया एक नई वर्कशीट जोड़ें या एक छुपी हुई वर्कशीट दिखाएं।",confirmDelete:"क्या आप वाकई हटाना चाहते हैं",redoDelete:"Ctrl+Z द्वारा पूर्ववत किया जा सकता है",noHide:"छुपा नहीं सकते, कम से कम एक शीट टैग रखना आवश्यक है",chartEditNoOpt:"चार्ट संपादन मोड में यह ऑपरेशन अनुमत नहीं है!",sheetNameSpecCharError:"नाम में यह नहीं हो सकता: [ ] :  ? * / ' \"",sheetNamecannotIsEmptyError:"शीट का नाम खाली नहीं हो सकता"},conditionformat:{conditionformat_greaterThan:"Conditionformat-GreaterThan",conditionformat_greaterThan_title:"से बड़ी कोशिकाओं को प्रारूपित करें",conditionformat_lessThan:"Conditionformat-LessThan",conditionformat_lessThan_title:"से छोटी कोशिकाओं को प्रारूपित करें",conditionformat_between:"Conditionformat-Betweenness",conditionformat_between_title:"के बीच में मान वाली कोशिकाओं को प्रारूपित करें",conditionformat_equal:"Conditionformat-Equal",conditionformat_equal_title:"के बराबर कोशिकाओं को प्रारूपित करें",conditionformat_textContains:"Conditionformat-TextContains",conditionformat_textContains_title:"निम्नलिखित पाठ वाली कोशिकाओं को प्रारूपित करें",conditionformat_occurrenceDate:"Conditionformat-OccurrenceDate",conditionformat_occurrenceDate_title:"निम्नलिखित तिथियों वाली कोशिकाओं को प्रारूपित करें",conditionformat_duplicateValue:"Conditionformat-DuplicateValue",conditionformat_duplicateValue_title:"निम्नलिखित प्रकार के मान वाली कोशिकाओं को प्रारूपित करें",conditionformat_top10:"Conditionformat-Top10",conditionformat_top10_percent:"Conditionformat-Top10%",conditionformat_top10_title:"सबसे ऊंचे मान वाली कोशिकाओं को प्रारूपित करें",conditionformat_last10:"Conditionformat-Last10",conditionformat_last10_percent:"Conditionformat-Last10%",conditionformat_last10_title:"सबसे छोटे मान वाली कोशिकाओं को प्रारूपित करें",conditionformat_aboveAverage:"Conditionformat-AboveAverage",conditionformat_aboveAverage_title:"औसत से ऊपर वाली कोशिकाओं को प्रारूपित करें",conditionformat_belowAverage:"Conditionformat-SubAverage",conditionformat_belowAverage_title:"औसत से नीचे वाली कोशिकाओं को प्रारूपित करें",rule:"नियम",newRule:"नया नियम",editRule:"नियम संपादित करें",deleteRule:"नियम हटाएं",deleteCellRule:"कोशिका का नियम हटाएं",deleteSheetRule:"शीट का नियम हटाएं",manageRules:"प्रबंधन नियम",showRules:"इसके प्रारूपण नियम दिखाएं",highlightCellRules:"कोशिका नियम हाइलाइट करें",itemSelectionRules:"आइटम चयन नियम",conditionformatManageRules:"शर्तीय प्रारूपण नियम प्रबंधक",format:"प्रारूप",setFormat:"प्रारूप सेट करें",setAs:"के रूप में सेट करें",setAsByArea:"चयनित क्षेत्र के लिए, सेट करें",applyRange:"लागू सीमा",selectRange:"आवेदन सीमा का चयन करें",selectRange_percent:"चयनित सीमा का प्रतिशत",selectRange_average:"चयनित सीमा का औसत मान",selectRange_value:"चयनित सीमा में मान",pleaseSelectRange:"कृपया आवेदन सीमा का चयन करें",selectDataRange:"डेटा सीमा का चयन करें",selectCell:"कोशिका का चयन करें",pleaseSelectCell:"कृपया कोशिका का चयन करें",pleaseSelectADate:"कृपया एक तिथि चुनें",pleaseEnterInteger:"कृपया 1 और 1000 के बीच एक पूर्णांक दर्ज करें",onlySingleCell:"केवल एकल कोशिका संदर्भित की जा सकती है",conditionValueCanOnly:"शर्त मान केवल एक संख्या या एकल कोशिका हो सकता है",ruleTypeItem1:"उनके संबंधित मूल्यों के आधार पर सभी कोशिकाओं को प्रारूपित करें",ruleTypeItem2:"केवल उन कोशिकाओं को प्रारूपित करें जिनमें",ruleTypeItem2_title:"केवल उन कोशिकाओं के लिए जो निम्नलिखित शर्तों को पूरा करती हैं",ruleTypeItem3:"केवल शीर्ष या निचले नंबरों को प्रारूपित करें",ruleTypeItem3_title:"निम्न रैंकिंग में मान है",ruleTypeItem4:"केवल औसत से ऊपर या नीचे के मानों को प्रारूपित करें",ruleTypeItem4_title:"एक मान है जो निम्नलिखित शर्तों को पूरा करता है",ruleTypeItem5:"केवल अद्वितीय या दोहराए गए मानों को प्रारूपित करें",ruleTypeItem6:"उन कोशिकाओं को प्रारूपित करने के लिए सूत्रों का उपयोग करें जो प्रारूपित की जानी चाहिए",formula:"सूत्र",textColor:"पाठ का रंग",cellColor:"कोशिका का रंग",confirm:"पुष्टि करें",confirmColor:"रंग की पुष्टि करें",cancel:"रद्द करें",close:"बंद करें",clearColorSelect:"रंग चयन साफ करें",sheet:"शीट",currentSheet:"वर्तमान शीट",dataBar:"डेटा बार",dataBarColor:"डेटा बार का रंग",gradientDataBar_1:"नीला-सफेद ग्रेडिएंट डेटा बार",gradientDataBar_2:"हरा-सफेद ग्रेडिएंट डेटा बार",gradientDataBar_3:"लाल-सफेद ग्रेडिएंट डेटा बार",gradientDataBar_4:"नारंगी-सफेद ग्रेडिएंट स्ट्राइप्स",gradientDataBar_5:"हल्का नीला-सफेद ग्रेडिएंट स्ट्राइप्स",gradientDataBar_6:"बैंगनी-सफेद ग्रेडिएंट डेटा बार",solidColorDataBar_1:"नीला डेटा बार",solidColorDataBar_2:"हरा डेटा बार",solidColorDataBar_3:"लाल डेटा बार",solidColorDataBar_4:"नारंगी डेटा बार",solidColorDataBar_5:"हल्का नीला डेटा बार",solidColorDataBar_6:"बैंगनी डेटा बार",colorGradation:"रंग ग्रेडिएशन",colorGradation_1:"हरा-पीला-लाल रंग ग्रेडिएशन",colorGradation_2:"लाल-पीला-हरा रंग ग्रेडिएशन",colorGradation_3:"हरा-सफेद-लाल रंग ग्रेडिएशन",colorGradation_4:"लाल-सफेद-हरा रंग ग्रेडिएशन",colorGradation_5:"नीला-सफेद-लाल रंग ग्रेडिएशन",colorGradation_6:"लाल-सफेद-नीला रंग ग्रेडिएशन",colorGradation_7:"सफेद-लाल रंग ग्रेडिएशन",colorGradation_8:"लाल-सफेद रंग ग्रेडिएशन",colorGradation_9:"हरा-सफेद रंग ग्रेडिएशन",colorGradation_10:"सफेद-हरा रंग ग्रेडिएशन",colorGradation_11:"हरा-पीला रंग ग्रेडिएशन",colorGradation_12:"पीला-हरा रंग ग्रेडिएशन",icons:"आइकन",pleaseSelectIcon:"कृपया आइकनों के एक समूह का चयन करने के लिए क्लिक करें:",cellValue:"कोशिका मान",specificText:"विशिष्ट पाठ",occurrenceDate:"तिथि",greaterThan:"से बड़ा",lessThan:"से छोटा",between:"के बीच",equal:"बराबर",in:"में",between2:"",contain:"शामिल",textContains:"पाठ शामिल है",duplicateValue:"डुप्लिकेट मान",uniqueValue:"अद्वितीय मान",top:"शीर्ष",top10:"शीर्ष 10",top10_percent:"शीर्ष 10%",last:"अंतिम",last10:"अंतिम 10",last10_percent:"अंतिम 10%",oneself:"",above:"ऊपर",aboveAverage:"औसत से ऊपर",below:"नीचे",belowAverage:"औसत से नीचे",all:"सभी",yesterday:"YTD",today:"आज",tomorrow:"कल",lastWeek:"पिछला सप्ताह",thisWeek:"इस सप्ताह",lastMonth:"पिछला महीना",thisMonth:"इस महीने",lastYear:"पिछले साल",thisYear:"इस साल",last7days:"पिछले 7 दिन",last30days:"पिछले 30 दिन",next7days:"अगले 7 दिन",next30days:"अगले 30 दिन",next60days:"अगले 60 दिन",chooseRuleType:"नियम प्रकार चुनें",editRuleDescription:"नियम विवरण संपादित करें",newFormatRule:"नया प्रारूप नियम",editFormatRule:"प्रारूप नियम संपादित करें",formatStyle:"शैली",fillType:"भरें",color:"रंग",twocolor:"दो रंग",tricolor:"तीन रंग",multicolor:"अनेक रंग",grayColor:"धूसर रंग",gradient:"ग्रेडिएंट",solid:"ठोस",maxValue:"अधिकतम मान",medianValue:"मध्य मान",minValue:"न्यूनतम मान",direction:"दिशा",threeWayArrow:"तीन-तरफा तीर",fourWayArrow:"चार-तरफा तीर",fiveWayArrow:"पांच-तरफा तीर",threeTriangles:"तीन त्रिकोण",shape:"आकार",threeColorTrafficLight:"तीन-रंग ट्रैफिक लाइट",fourColorTrafficLight:"चार-रंग ट्रैफिक लाइट",threeSigns:"तीन संकेत",greenRedBlackGradient:"हरा-लाल-काला ग्रेडिएंट",rimless:"बिना किनारे वाला",bordered:"किनारे वाला",mark:"चिह्न",threeSymbols:"तीन प्रतीक",tricolorFlag:"तीन-रंग का ध्वज",circled:"वृत्ताकार",noCircle:"कोई वृत्त नहीं",grade:"ग्रेड",grade4:"4 ग्रेड",grade5:"5 ग्रेड",threeStars:"3 सितारे",fiveQuadrantDiagram:"पांच-खंड आरेख",fiveBoxes:"5 बॉक्स"},insertLink:{linkText:"प्रदर्शित पाठ",linkType:"लिंक प्रकार",linkAddress:"लिंक पता",linkSheet:"वर्कशीट",linkCell:"सेल रेंज",linkTooltip:"टूलटिप",selectCellRange:"सेल रेंज चुनें",cellRangePlaceholder:"कर्सर का उपयोग करके या सीधे दर्ज करके कोशिकाएँ चुनें",placeholder1:"कृपया वेब लिंक पता दर्ज करें",placeholder2:"कृपया उद्धृत करने के लिए सेल दर्ज करें, उदाहरण A1",placeholder3:"कृपया संकेत सामग्री दर्ज करें",tooltipInfo1:"कृपया एक मान्य लिंक दर्ज करें",invalidCellRangeTip:"कृपया सही सेल रेंज दर्ज करें, जैसे Sheet1!A1:C8",openLink:"लिंक खोलें",goTo:"${linkAddress} पर जाएं"},linkTypeList:[{text:"वेबसाइट",value:"webpage"},{text:"सेल रेंज",value:"cellrange"},{text:"शीट",value:"sheet"}],dataVerification:{cellRange:"सेल रेंज",selectCellRange:"सेल रेंज चुनने के लिए क्लिक करें",selectCellRange2:"कृपया सेल की रेंज चुनें",verificationCondition:"सत्यापन शर्त",allowMultiSelect:"कई चयन की अनुमति दें",dropdown:"ड्रॉप-डाउन सूची",checkbox:"चेकबॉक्स",number:"संख्या",number_integer:"संख्या-पूर्णांक",number_decimal:"संख्या-दशमलव",text_content:"पाठ-सामग्री",text_length:"पाठ-लंबाई",date:"तिथि",validity:"प्रभावशीलता",placeholder1:"कृपया विकल्प दर्ज करें, अल्पविराम से अलग करें, जैसे 1,2,3,4,5",placeholder2:"कृपया सामग्री दर्ज करें",placeholder3:"संख्यात्मक मान, जैसे 10",placeholder4:"कृपया निर्दिष्ट पाठ दर्ज करें",placeholder5:"कृपया वह संकेत दर्ज करें जो सेल चुने जाने पर प्रदर्शित होता है",selected:"चयनित",notSelected:"चयनित नहीं",between:"के बीच",notBetween:"के बीच नहीं",equal:"बराबर",notEqualTo:"के बराबर नहीं",moreThanThe:"से अधिक",lessThan:"से कम",greaterOrEqualTo:"के बराबर या अधिक",lessThanOrEqualTo:"के बराबर या कम",include:"शामिल",exclude:"बहिष्कृत",earlierThan:"से पहले",noEarlierThan:"से पहले नहीं",laterThan:"के बाद",noLaterThan:"के बाद नहीं",identificationNumber:"पहचान संख्या",phoneNumber:"फोन नंबर",remote:"स्वचालित दूरस्थ अधिग्रहण विकल्प",prohibitInput:"डेटा अमान्य होने पर इनपुट निषिद्ध करें",hintShow:"सेल चुने जाने पर संकेत दिखाएं",deleteVerification:"सत्यापन हटाएं",tooltipInfo1:"ड्रॉप-डाउन सूची विकल्प खाली नहीं हो सकता",tooltipInfo2:"चेकबॉक्स सामग्री खाली नहीं हो सकती",tooltipInfo3:"दर्ज किया गया मान संख्यात्मक प्रकार का नहीं है",tooltipInfo4:"मान 2 मान 1 से कम नहीं हो सकता",tooltipInfo5:"पाठ सामग्री खाली नहीं हो सकती",tooltipInfo6:"दर्ज किया गया मान तिथि प्रकार का नहीं है",tooltipInfo7:"तिथि 2 तिथि 1 से कम नहीं हो सकती",textlengthInteger:"पाठ की लंबाई 0 या उससे अधिक का पूर्णांक होना चाहिए"},formula:{sum:"योग",average:"औसत",count:"गिनती",max:"अधिकतम",min:"न्यूनतम",ifGenerate:"If सूत्र जेनरेटर",find:"और जानें",tipNotBelongToIf:"यह सेल फंक्शन If सूत्र से संबंधित नहीं है!",tipSelectCell:"कृपया फंक्शन डालने के लिए सेल का चयन करें",ifGenCompareValueTitle:"तुलना मूल्य",ifGenSelectCellTitle:"सेल का चयन करने के लिए क्लिक करें",ifGenRangeTitle:"रेंज",ifGenRangeTo:"से",ifGenRangeEvaluate:"रेंज का मूल्यांकन करें",ifGenSelectRangeTitle:"रेंज का चयन करने के लिए क्लिक करें",ifGenCutWay:"विभाजन का तरीका",ifGenCutSame:"समान विभाजन मूल्य",ifGenCutNpiece:"N द्वारा विभाजन",ifGenCutCustom:"कस्टम",ifGenCutConfirm:"पुष्टि करें",ifGenTipSelectCell:"सेल चुनें",ifGenTipSelectCellPlace:"कृपया सेल चुनें",ifGenTipSelectRange:"रेंज चुनें",ifGenTipSelectRangePlace:"कृपया रेंज चुनें",ifGenTipNotNullValue:"तुलना मूल्य खाली नहीं हो सकता!",ifGenTipLableTitile:"लेबल",ifGenTipRangeNotforNull:"रेंज खाली नहीं हो सकती!",ifGenTipCutValueNotforNull:"विभाजन मूल्य खाली नहीं हो सकता!",ifGenTipNotGenCondition:"उत्पादन के लिए कोई शर्तें उपलब्ध नहीं हैं!"},formulaMore:{valueTitle:"मान",tipSelectDataRange:"डेटा रेंज चुनें",tipDataRangeTile:"डेटा रेंज",findFunctionTitle:"फंक्शन खोजें",tipInputFunctionName:"फंक्शन का नाम या फंक्शन का संक्षिप्त विवरण",Array:"ऐरे",Database:"डेटाबेस",Date:"तिथि",Engineering:"इंजीनियरिंग",Filter:"फिल्टर",Financial:"वित्तीय",luckysheet:"लकीशीट",other:"अन्य",Logical:"लॉजिकल",Lookup:"लुकअप",Math:"गणित",Operator:"ऑपरेटर",Parser:"पार्सर",Statistical:"सांख्यिकीय",Text:"पाठ",dataMining:"डेटा माइनिंग",selectFunctionTitle:"फंक्शन का चयन करें",calculationResult:"परिणाम",tipSuccessText:"सफल",tipParamErrorText:"पैरामीटर प्रकार त्रुटि",helpClose:"बंद करें",helpCollapse:"संक्षिप्त करें",helpExample:"उदाहरण",helpAbstract:"सारांश",execfunctionError:"सूत्र में त्रुटि",execfunctionSelfError:"सूत्र अपने ही सेल को संदर्भित नहीं कर सकता",execfunctionSelfErrorResult:"सूत्र अपने ही सेल को संदर्भित नहीं कर सकता, जो सटीक गणना परिणाम की ओर ले जाएगा",allowRepeatText:"पुनरावृत्ति की अनुमति",allowOptionText:"विकल्प",selectCategory:"या श्रेणी चुनें"},drag:{noMerge:"मर्ज किए गए सेल्स पर यह ऑपरेशन नहीं किया जा सकता",affectPivot:"इस चयनित सेल पर यह परिवर्तन नहीं किया जा सकता क्योंकि यह पिवट तालिका को प्रभावित करेगा!",noMulti:"कई चयन क्षेत्रों पर यह ऑपरेशन नहीं किया जा सकता, कृपया एकल क्षेत्र चुनें",noPaste:"यह सामग्री यहाँ चिपकाई नहीं जा सकती, कृपया पेस्ट क्षेत्र में एक सेल चुनें और पुनः प्रयास करें",noPartMerge:"आंशिक रूप से मर्ज किए गए सेल्स पर यह ऑपरेशन नहीं किया जा सकता",inputCorrect:"कृपया सही मान दर्ज करें",notLessOne:"पंक्तियों और स्तंभों की संख्या 1 से कम नहीं हो सकती",offsetColumnLessZero:"ऑफसेट कॉलम नकारात्मक नहीं हो सकता!",pasteMustKeybordAlert:"टेबल में कॉपी पेस्ट करने के लिए: Ctrl + C कॉपी करने के लिए, Ctrl + V पेस्ट करने के लिए, Ctrl + X कट करने के लिए",pasteMustKeybordAlertHTMLTitle:"टेबल में कॉपी पेस्ट",pasteMustKeybordAlertHTML:"<span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + C</span>&nbsp;&nbsp;कॉपी करें<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + V</span>&nbsp;&nbsp;पेस्ट करें<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + X</span>&nbsp;&nbsp;कट करें"},pivotTable:{title:"पिवट टेबल",closePannel:"बंद करें",editRange:"रेंज",tipPivotFieldSelected:"फ़ील्ड का चयन करें",tipClearSelectedField:"सभी फ़ील्ड साफ करें",btnClearSelectedField:"साफ करें",btnFilter:"फिल्टर",titleRow:"पंक्ति",titleColumn:"स्तंभ",titleValue:"मान",tipShowColumn:"सांख्यिकीय फ़ील्ड कॉलम के रूप में प्रदर्शित होते हैं",tipShowRow:"सांख्यिकीय फ़ील्ड पंक्तियों के रूप में प्रदर्शित होते हैं",titleSelectionDataRange:"रेंज का चयन करें",titleDataRange:"डेटा रेंज",valueSum:"योग",valueStatisticsSUM:"योग",valueStatisticsCOUNT:"गिनती",valueStatisticsCOUNTA:"गिनती A",valueStatisticsCOUNTUNIQUE:"अद्वितीय गिनती",valueStatisticsAVERAGE:"औसत",valueStatisticsMAX:"अधिकतम",valueStatisticsMIN:"न्यूनतम",valueStatisticsMEDIAN:"मध्य",valueStatisticsPRODUCT:"गुणनफल",valueStatisticsSTDEV:"सांख्यिकीय विचलन",valueStatisticsSTDEVP:"सांख्यिकीय विचलन P",valueStatisticslet:"वैर",valueStatisticsVARP:"वैर P",errorNotAllowEdit:"गैर-संपादन मोड में यह ऑपरेशन निषिद्ध है!",errorNotAllowMulti:"कई चयन क्षेत्रों पर यह ऑपरेशन नहीं किया जा सकता, कृपया एकल रेंज चुनें और पुनः प्रयास करें",errorSelectRange:"कृपया नई पिवट टेबल की रेंज का चयन करें",errorIsDamage:"इस पिवट टेबल का स्रोत डेटा क्षतिग्रस्त है!",errorNotAllowPivotData:"स्रोत डेटा के रूप में पिवट टेबल का चयन नहीं कर सकते!",errorSelectionRange:"चयन विफल, गलत इनपुट रेंज!",errorIncreaseRange:"कृपया चयनित रेंज का विस्तार करें!",titleAddColumn:"पिवट टेबल में स्तंभ जोड़ें",titleMoveColumn:"स्तंभ को नीचे के सफेद बॉक्स में ले जाएं",titleClearColumnFilter:"इस स्तंभ का फिल्टर साफ करें",titleFilterColumn:"फिल्टर",titleSort:"सॉर्ट",titleNoSort:"कोई सॉर्ट नहीं",titleSortAsc:"ASC",titleSortDesc:"DESC",titleSortBy:"के अनुसार सॉर्ट करें",titleShowSum:"कुल दिखाएं",titleStasticTrue:"हाँ",titleStasticFalse:"नहीं"},dropCell:{copyCell:"कॉपी",sequence:"अनुक्रम",onlyFormat:"केवल प्रारूप",noFormat:"कोई प्रारूप नहीं",day:"दिन",workDay:"काम का दिन",month:"महीना",year:"साल",chineseNumber:"चीनी नंबर"},imageCtrl:{borderTile:"चित्र सीमा का रंग",borderCur:"रंग"},protection:{protectiontTitle:"संरक्षण",enterPassword:"पासवर्ड दर्ज करें (वैकल्पिक)",enterHintTitle:"संपादन निषिद्ध होने पर संकेत (वैकल्पिक)",enterHint:"जिस सेल या चार्ट को आप बदलने की कोशिश कर रहे हैं वह संरक्षित वर्कशीट में है। यदि आप इसे बदलना चाहते हैं, तो कृपया वर्कशीट को अनप्रोटेक्ट करें। आपको पासवर्ड दर्ज करने की आवश्यकता हो सकती है",swichProtectionTip:"शीट और लॉक किए गए सेल्स की सामग्री की सुरक्षा करें",authorityTitle:"इस शीट के उपयोगकर्ताओं को अनुमति दें:",selectLockedCells:"लॉक किए गए सेल्स का चयन करें",selectunLockedCells:"अनलॉक किए गए सेल्स का चयन करें",formatCells:"सेल्स को प्रारूपित करें",formatColumns:"स्तंभों को प्रारूपित करें",formatRows:"पंक्तियों को प्रारूपित करें",insertColumns:"स्तंभ जोड़ें",insertRows:"पंक्तियाँ जोड़ें",insertHyperlinks:"हाइपरलिंक्स जोड़ें",deleteColumns:"स्तंभ हटाएं",deleteRows:"पंक्तियाँ हटाएं",sort:"सॉर्ट",filter:"फिल्टर",usePivotTablereports:"पिवट टेबल रिपोर्ट का उपयोग करें",editObjects:"ऑब्जेक्ट्स संपादित करें",editScenarios:"परिदृश्य संपादित करें",allowRangeTitle:"रेंज के उपयोगकर्ताओं को अनुमति दें:",allowRangeAdd:"नया...",allowRangeAddTitle:"शीर्षक",allowRangeAddSqrf:"संदर्भ",selectCellRange:"सेल रेंज चुनने के लिए क्लिक करें",selectCellRangeHolder:"सेल रेंज",allowRangeAddTitlePassword:"पासवर्ड",allowRangeAddTitleHint:"संकेत",allowRangeAddTitleHintTitle:"पासवर्ड सेट होने पर संकेत (वैकल्पिक)",allowRangeAddtitleDefault:"इनपुट रेंज का नाम",rangeItemDblclick:"संपादित करने के लिए डबल क्लिक करें",rangeItemHasPassword:"पासवर्ड है",rangeItemErrorTitleNull:"शीर्षक रिक्त है",rangeItemErrorRangeNull:"संदर्भ रिक्त है",rangeItemErrorRange:"संदर्भ त्रुटिपूर्ण है",validationTitle:"पासवर्ड सत्यापन",validationTips:"वर्कशीट की सुरक्षा को अनलॉक करने के लिए पासवर्ड दर्ज करना आवश्यक है",validationInputHint:"पासवर्ड दर्ज करें",checkPasswordNullalert:"पासवर्ड आवश्यक है!",checkPasswordWrongalert:"गलत पासवर्ड, कृपया पुनः प्रयास करें!",checkPasswordSucceedalert:"अनलॉक सफल!",defaultRangeHintText:"सेल पासवर्ड द्वारा संरक्षित किया जा रहा है।",defaultSheetHintText:"सेल या चार्ट एक संरक्षित वर्कशीट में है। परिवर्तन करने के लिए, कृपया वर्कशीट को अनप्रोटेक्ट करें। आपको पासवर्ड दर्ज करने की आवश्यकता हो सकती है"},cellFormat:{cellFormatTitle:"सेल्स प्रारूपित करें",protection:"संरक्षण",locked:"लॉक किया हुआ",hidden:"छुपा हुआ",protectionTips:"सेल्स को लॉक करने या सूत्रों को छुपाने के लिए, वर्कशीट की सुरक्षा करें। टूलबार पर, शीट सुरक्षा बटन पर क्लिक करें",tipsPart:"आंशिक जाँच",tipsAll:"सभी जाँच",selectionIsNullAlert:"चयन आवश्यक है!",sheetDataIsNullAlert:"त्रुटि, डेटा नहीं है!"},print:{normalBtn:"सामान्य",layoutBtn:"पृष्ठ लेआउट",pageBtn:"पृष्ठ विराम पूर्वावलोकन",menuItemPrint:"प्रिंट करें (Ctrl+P)",menuItemAreas:"प्रिंट क्षेत्र",menuItemRows:"शीर्षक पंक्तियाँ प्रिंट करें",menuItemColumns:"शीर्षक स्तंभ प्रिंट करें"},edit:{typing:"टाइपिंग"},websocket:{success:"WebSocket कनेक्शन सफल",refresh:"WebSocket कनेक्शन में त्रुटि हुई, कृपया पृष्ठ को रीफ्रेश करें!",wait:"WebSocket कनेक्शन में त्रुटि हुई, कृपया प्रतीक्षा करें!",close:"WebSocket कनेक्शन बंद",contact:"सर्वर संचार त्रुटि हुई, कृपया पृष्ठ को रीफ्रेश करें और पुनः प्रयास करें, यदि नहीं, तो कृपया व्यवस्थापक से संपर्क करें!",support:"वर्तमान ब्राउज़र WebSocket का समर्थन नहीं करता"}};var zh_tw={generalDialog:{partiallyError:"無法對部分合併儲存格執行此操作",readOnlyError:"無法對只讀模式執行此操作",dataNullError:"無法對不存在的數據執行此操作",noSeletionError:"還未進行選區操作",cannotSelectMultiple:"無法選擇多選區"},functionlist:[{n:"SUMIF",t:0,d:"對範圍中符合指定條件的值求和。",a:"對範圍中符合指定條件的值求和。",m:[2,3],p:[{name:"範圍",detail:"要根據條件進行檢測的範圍。",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"條件",detail:"要應用於範圍的模式或測試條件。\n\n如果範圍包含的是要檢測的文字,則條件必須為字串。條件可以包含萬用字元,包括用於匹配單個字元的？或用於匹配零個或連續多個字元的*。要匹配問號星號本身,請在該字元前面加上波浪號（~）首碼（即~？和~*）。字串條件必須用引號括起來。函數會檢查範圍中的每個儲存格與條件是否相等或匹配（如果使用了萬用字元）。\n\n如果範圍包含的是要檢測的數位,則條件可以是字串也可以是數位。如果給定的條件是一個數位,則檢查範圍中的每個儲存格是否等於條件。另外,條件也可能是包含數位的字串（也將對其進行相等檢測）,或者帶有以下首碼的數位:=（檢查是否相等）、>（檢查範圍儲存格的值是否大於條件值）或<（檢查範圍儲存格的值是否小於條件值）",example:'">20"',require:"m",repeat:"n",type:"rangeall"},{name:"求和範圍",detail:"要求和的範圍（如果與範圍不同）。",example:"B1:B10",require:"o",repeat:"n",type:"range"}]},{n:"TAN",t:0,d:"返回已知角度的正切值。",a:"返回已知角度的正切值。",m:[1,1],p:[{name:"角度",detail:"要求其正切值的角度,以弧度表示。",example:"45*PI()/180",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TANH",t:0,d:"返回給定實數的雙曲正切值。",a:"返回給定實數的雙曲正切值。",m:[1,1],p:[{name:"值",detail:"要計算其雙曲正切值的實數。",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CEILING",t:0,d:"將數值向上取整為最接近的指定因數的倍數。",a:"將數值向上取整為最接近的指定因數的倍數。",m:[2,2],p:[{name:"值",detail:"要向上舍入的數值。",example:"23.25",require:"m",repeat:"n",type:"rangenumber"},{name:"因數",detail:"要將值舍入到此數的整數倍。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ATAN",t:0,d:"返回數值的反正切值,以弧度表示。",a:"返回數值的反正切值",m:[1,1],p:[{name:"值",detail:"要計算其反正切值的數值。",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ASINH",t:0,d:"返回數值的反雙曲正弦值。",a:"返回數值的反雙曲正弦值。",m:[1,1],p:[{name:"值",detail:"要計算其反雙曲正弦值的數值。",example:"0.9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ABS",t:0,d:"返回數值的絕對值。",a:"返回數值的絕對值。",m:[1,1],p:[{name:"value",detail:"要返回其絕對值的數。",example:"-2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ACOS",t:0,d:"返回數值的反余弦值,以弧度表示。",a:"返回數值的反余弦值",m:[1,1],p:[{name:"值",detail:"要計算其反余弦值的數值。必須介於-1和1之間,包括兩端值。",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ACOSH",t:0,d:"返回數值的反雙曲余弦值。",a:"返回數值的反雙曲余弦值。",m:[1,1],p:[{name:"值",detail:"要計算其反雙曲余弦值的數值。必須大於等於1。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MULTINOMIAL",t:0,d:"返回參數和的階乘除以各參數階乘的乘積後得到的值。",a:"返回參數和的階乘除以各參數階乘的乘積後得到的值。",m:[1,255],p:[{name:"值1",detail:"用於計算的第一項數值或範圍。",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"值2",detail:"用於計算的其他數值或範圍。",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"ATANH",t:0,d:"返回數值的反雙曲正切值。",a:"返回數值的反雙曲正切值。",m:[1,1],p:[{name:"值",detail:"要計算其反雙曲正切值的數值。必須介於-1和1之間（不包括-1和1）。",example:"0.9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ATAN2",t:0,d:"以弧度為組織返回x軸與從原點（0,0）到指定座標點（`x`,`y`）之間連線的夾角。",a:"以弧度為組織返回x軸與從原點（0,0）到指定座標點（`x`,`y`）之間連線的夾角。",m:[2,2],p:[{name:"x",detail:"要計算其與x軸夾角大小的線段的終點x座標。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"y",detail:"要計算其與x軸夾角大小的線段的終點y座標。",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUNTBLANK",t:1,d:"返回給定範圍內的空儲存格數。",a:"返回給定範圍內的空儲存格數。",m:[1,1],p:[{name:"範圍",detail:"要統計空白儲存格數量的範圍。",example:"A2:C100",require:"m",repeat:"n",type:"range"}]},{n:"COSH",t:0,d:"返回給定實數的雙曲余弦值。",a:"返回給定實數的雙曲余弦值。",m:[1,1],p:[{name:"值",detail:"要計算其雙曲余弦值的實數值。",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"INT",t:0,d:"數值向下取整為小於或等於該數的最接近的整數。",a:"數值向下取整為小於或等於該數的最接近的整數。",m:[1,1],p:[{name:"值",detail:"要向下取整為最接近的整數的數值。",example:"99.44",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ISEVEN",t:0,d:"檢查所提供的數值是否為偶數。",a:"檢查所提供的數值是否為偶數。",m:[1,1],p:[{name:"值",detail:"要驗證其是否為偶數的數值。\n\n如果值為偶數或指向包含偶數的儲存格的引用,ISEVEN將返回TRUE,否則返回FALSE。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ISODD",t:0,d:"檢查所提供的數值是否為奇數。",a:"檢查所提供的數值是否為奇數。",m:[1,1],p:[{name:"值",detail:"要驗證其是否為奇數的數值。\n\n如果值為奇數或指向包含奇數的儲存格,ISODD將返回TRUE,否則返回FALSE。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LCM",t:0,d:"返回一個或多個整數的最小公倍數。",a:"返回一個或多個整數的最小公倍數。",m:[1,255],p:[{name:"值1",detail:"要在求最小公倍數數的計算中檢查其因數的第一項數值或範圍。",example:"A2:A5",require:"m",repeat:"n",type:"rangeall"},{name:"值2",detail:"[可選] - 在求最小公倍數時要考慮其因數的其他數值或範圍。",example:"3",require:"o",repeat:"y",type:"rangeall"}]},{n:"LN",t:0,d:"返回數值以e（歐拉數）為底的對數。",a:"返回數值以e（歐拉數）為底的對數。",m:[1,1],p:[{name:"值",detail:"要以e為底數計算其對數的值。\n\n值必須為正數。",example:"100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LOG",t:0,d:"根據指定底數返回數位的對數。",a:"根據指定底數返回數位的對數。",m:[1,2],p:[{name:"值",detail:"想要計算其對數的正實數。",example:"128",require:"m",repeat:"n",type:"rangenumber"},{name:"底數",detail:"[可選] - 對數的底數。",example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"LOG10",t:0,d:"返回數值以10為底的對數。",a:"返回數值以10為底的對數。",m:[1,1],p:[{name:"值",detail:"要計算其以10為底的對數的數值。\n\n值必須為正值。",example:"100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MOD",t:0,d:"返回兩數相除的餘數,結果的符號與除數相同。",a:"返回兩數相除的餘數。",m:[2,2],p:[{name:"被除數",detail:"要將其相除以得到餘數的數值。",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"除數",detail:"用於除其他數的數值。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MROUND",t:0,d:"將數值取整為另一整數最接近的整數倍。",a:"將數值取整為另一整數最接近的整數倍。",m:[2,2],p:[{name:"值",detail:"要取整為另一整數最接近的整數倍的數值。",example:"21",require:"m",repeat:"n",type:"rangenumber"},{name:"因數",detail:"值將取此因數的整數倍。",example:"14",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ODD",t:0,d:"將數值向上取整為最接近的奇整數。",a:"將數值向上取整為最接近的奇整數。",m:[1,1],p:[{name:"值",detail:"要向上取整的數值,取整值為大於此值的最接近的奇數。\n\n如果值為負數,則將其取整為絕對值大於該值的相鄰負奇數",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMSQ",t:0,d:"返回一組數值和/或儲存格的平方總和。",a:"返回一組數值和/或儲存格的平方總和。",m:[1,255],p:[{name:"值1",detail:"要將其平方相加的第一個數值或範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"值2, ...",detail:"[可選] - 要將其平方與值1的平方相加的其他數值或範圍。",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"COMBIN",t:0,d:"給定集合中的對象總數和要選擇的對象數量,返回共有多少種不同選擇管道。",a:"給定集合中的對象總數和要選擇的對象數量",m:[2,2],p:[{name:"n",detail:"要從中進行選擇的對象集合的大小。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"k",detail:"要選擇的對象數量。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUM",t:0,d:"返回一組數值和/或儲存格的總和。",a:"返回一組數值和/或儲存格的總和。",m:[1,255],p:[{name:"值1",detail:"要相加的第一個數值或範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"值2",detail:"[可選] - 要相加的其他數值或範圍。",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"SUBTOTAL",t:0,d:"使用指定的匯總函數,返回一系列縱向儲存格的分類匯總。",a:"使用指定的匯總函數",m:[2,256],p:[{name:"函數程式碼",detail:"用於計算分類匯總的函數。\n\n1代表AVERAGE\n\n2代表COUNT\n\n3代表COUNTA\n\n4代表MAX\n\n5代表MIN\n\n6代表PRODUCT\n\n7代表STDEV\n\n8代表STDEVP\n\n9代表SUM\n\n10代表VAR\n\n11代表VARP\n\n通過在這些2位程式碼前附加10（對於1位程式碼）或1（對於2位程式碼）,可以將隱藏值忽略。例如,102代表忽略隱藏儲存格的COUNT,而110則代表忽略隱藏值的VAR。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"範圍1",detail:"要計算分類匯總的第一個範圍。",example:"A2:A5",require:"m",repeat:"n",type:"range"},{name:"範圍2",detail:"[可選] - 要計算分類匯總的其他範圍。",example:"B2:B8",require:"o",repeat:"y",type:"range"}]},{n:"ASIN",t:0,d:"返回數值的反正弦值,以弧度表示。",a:"返回數值的反正弦值",m:[1,1],p:[{name:"值",detail:"要計算其反正弦值的數值。必須介於-1和1之間,包括兩端值。",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUNTIF",t:1,d:"返回範圍內滿足某個條件的儲存格的數量。",a:"返回範圍內滿足某個條件的儲存格的數量。",m:[2,2],p:[{name:"範圍",detail:"要根據條件進行檢測的範圍。",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"條件",detail:"要應用於範圍的模式或測試條件。\n\n如果範圍包含的是要檢測的文字,則條件必須為字串。條件可以包含萬用字元,包括用於匹配單個字元的？或用於匹配零個或連續多個字元的*。要匹配問號星號本身,請在該字元前面加上波浪號（~）首碼（即~？和~*）。字串條件必須用引號括起來。函數會檢查範圍中的每個儲存格與條件是否相等或匹配（如果使用了萬用字元）。\n\n如果範圍包含的是要檢測的數位,則條件可以是字串也可以是數位。如果給定的條件是一個數位,則檢查範圍中的每個儲存格是否等於條件。另外,條件也可能是包含數位的字串（也將對其進行相等檢測）,或者帶有以下首碼的數位:=、>、>=、<或<=,這些條件將分別用於檢查範圍中的儲存格是否等於、大於、大於等於、小於、小於等於條件值。",example:'">20"',require:"m",repeat:"n",type:"rangeall"}]},{n:"RADIANS",t:0,d:"將以度表示的角度值轉換為弧度。",a:"將以度表示的角度值轉換為弧度。",m:[1,1],p:[{name:"角度",detail:"要從度轉換為弧度的角度。",example:"180",require:"m",repeat:"n",type:"rangenumber"}]},{n:"RAND",t:0,d:"返回一個介於0和1之間（包括0但不包括1）的亂數。",a:"返回一個介於0和1之間（包括0但不包括1）的亂數。",m:[0,0],p:[]},{n:"COUNTUNIQUE",t:0,d:"計算一列指定值和範圍中不重複數值的個數。",a:"計算一列指定值和範圍中不重複數值的個數。",m:[1,255],p:[{name:"值1",detail:"要檢查其是否唯一的第一個值或範圍。",example:"A1:C100",require:"m",repeat:"n",type:"rangeall"},{name:"值2",detail:"[可選] - 要檢查是否唯一的其他值或範圍。",example:"1",require:"o",repeat:"n",type:"rangeall"}]},{n:"DEGREES",t:0,d:"將以弧度表示的角度值轉換為度。",a:"將以弧度表示的角度值轉換為度。",m:[1,1],p:[{name:"角度",detail:"要從弧度轉換為度的角度。",example:"PI()",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ERFC",t:9,d:"返回數值的互補高斯誤差函數。",a:"返回數值的互補高斯誤差函數。",m:[1,1],p:[{name:"z",detail:"要為其計算互補高斯誤差函數的數值。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"EVEN",t:0,d:"將數值向上取整為最接近的偶整數。",a:"將數值向上取整為最接近的偶整數。",m:[1,1],p:[{name:"值",detail:"要向上取整的數值,取整值為大於此值的最接近的偶數。\n\n如果值為負數,則將其取整為絕對值大於該值的相鄰負偶數。",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"EXP",t:0,d:"返回歐拉數e（~2.718）的指定次幂。",a:"返回歐拉數e（~2.718）的指定次幂。",m:[1,1],p:[{name:"指數",detail:"指定e的自乘幂次值。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FACT",t:0,d:"返回數值的階乘。",a:"返回數值的階乘。",m:[1,1],p:[{name:"值",detail:"要計算並返回其階乘的數位或對數位（所在儲存格）的引用。",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FACTDOUBLE",t:0,d:'返回數值的"雙階乘"。',a:'返回數值的"雙階乘"。',m:[1,1],p:[{name:"值",detail:"要計算並返回其雙階乘的數位或對數位（所在儲存格）的引用。",example:"6",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PI",t:0,d:"返回帶有14位小數的PI值。",a:"返回帶有14位小數的PI值。",m:[0,0],p:[]},{n:"FLOOR",t:0,d:"將數值向下取整為指定因數的最接近的整數倍。",a:"將數值向下取整為指定因數的最接近的整數倍。",m:[2,2],p:[{name:"值",detail:"要向下舍入為因數的最接近整數倍的數值。",example:"23.25",require:"m",repeat:"n",type:"rangenumber"},{name:"因數",detail:"要將值舍入到此數的整數倍。\n\n因數不得為0。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GCD",t:0,d:"返回一個或多個整數的最大公約數。",a:"返回一個或多個整數的最大公約數。",m:[1,255],p:[{name:"值1",detail:"要在查找最大公約數的計算中檢查其因數的第一項數值或範圍。",example:"A2:A5",require:"m",repeat:"n",type:"rangeall"},{name:"值2",detail:"[可選] - 在求最大公約數時要考慮其因數的其他數值或範圍。",example:"96",require:"o",repeat:"y",type:"rangeall"}]},{n:"RANDBETWEEN",t:0,d:"返回介於兩個整數之間（包括這兩個整數）的亂數。",a:"返回介於兩個整數之間（包括這兩個整數）的亂數。",m:[2,2],p:[{name:"下界",detail:"隨機值範圍的下界。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"上界",detail:"隨機值範圍的上界。",example:"10",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ROUND",t:0,d:"將數位四捨五入到指定的位數。",a:"將數位四捨五入到指定的位數。",m:[2,2],p:[{name:"值",detail:"要四捨五入的數位。",example:"99.44",require:"m",repeat:"n",type:"rangenumber"},{name:"位數",detail:"要進行四捨五入運算的位數。\n\n位數可以取負值,在這種情況下會將值的小數點左側部分舍入到指定的位數。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ROUNDDOWN",t:0,d:"朝著零的方向將數位進行向下舍入。",a:"朝著零的方向將數位進行向下舍入。",m:[2,2],p:[{name:"值",detail:"需要向下舍入的任意實數。",example:"99.44",require:"m",repeat:"n",type:"rangenumber"},{name:"位數",detail:"要通過舍入達到的小數位數。\n\n位數可以取負值,在這種情況下會將值的小數點左側部分舍入到指定的位數。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ROUNDUP",t:0,d:"朝著遠離0（零）的方向將數位進行向上舍入。",a:"朝著遠離0（零）的方向將數位進行向上舍入。",m:[2,2],p:[{name:"值",detail:"要將其舍入為位數位數位的值,始終向上舍入。",example:"99.44",require:"m",repeat:"n",type:"rangenumber"},{name:"位數",detail:"要通過舍入達到的小數位數。\n\n位數可以取負值,在這種情況下會將值的小數點左側部分舍入到指定的位數。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SERIESSUM",t:0,d:"給定參數x、n、m和a,返回幂級數的和a1xn + a2x（n+m）+…+ aix（n+（i-1）m）,其中i為範圍a中的項數。",a:"給定參數x、n、m和a",m:[4,4],p:[{name:"x",detail:"幂級數的輸入值。隨相應的近似類型而變,有可能為角度、指數或其他一些值。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"n",detail:"在幂級數中x的初始自乘幂次。",example:"0",require:"m",repeat:"n",type:"rangenumber"},{name:"m",detail:"x的幂次中的附加增量。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"a",detail:"包含幂級數係數的數組或範圍。",example:"{FACT(0)",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SIGN",t:0,d:"給定輸入數值,如果為負返回-1；如果為正返回1；如果為零則返回0。",a:"給定輸入數值",m:[1,1],p:[{name:"值",detail:"要返回其符號的數值。",example:"-42",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SIN",t:0,d:"給定角度（以弧度表示）,返回其正弦值。",a:"給定角度（以弧度表示）",m:[1,1],p:[{name:"角度",detail:"要返回其正弦值的角度,以弧度表示。",example:"PI()",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SINH",t:0,d:"返回給定實數的雙曲正弦值。",a:"返回給定實數的雙曲正弦值。",m:[1,1],p:[{name:"值",detail:"要計算其雙曲正弦值的實數值。",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SQRT",t:0,d:"返回一個正數的正平方根。",a:"返回一個正數的正平方根。",m:[1,1],p:[{name:"值",detail:"要計算其正平方根的數值。\n\n值必須為正數；如果為負,SQRT將返回#NUM！錯誤。",example:"9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SQRTPI",t:0,d:"返回PI與給定正數乘積的正平方根。",a:"返回PI與給定正數乘積的正平方根。",m:[1,1],p:[{name:"值",detail:"要將其與PI相乘並返回該乘積的平方根的數值\n\n值必須為正數；如果為負數,SQRTPI將返回#NUM！錯誤。",example:"9",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GAMMALN",t:1,d:"返回指定伽瑪函數的以e（歐拉數）為底的對數。",a:"返回指定伽瑪函數的以e（歐拉數）為底的對數。",m:[1,1],p:[{name:"值",detail:"伽瑪函數的輸入值。返回的將是伽瑪（值）的自然對數。\n\n值必須為正數。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COS",t:0,d:"返回給定角度的余弦值（角度以弧度表示）。",a:"返回給定角度的余弦值（角度以弧度表示）。",m:[1,1],p:[{name:"角度",detail:"要取其余弦值的角度,以弧度表示。",example:"PI()",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TRUNC",t:0,d:"除指定有效位之外的部分,取數據的指定有效位。",a:"除指定有效位之外的部分",m:[1,2],p:[{name:"值",detail:"要截取的數據。",example:"3.141592654",require:"m",repeat:"n",type:"rangenumber"},{name:"位數",detail:'[可選 - 預設值為0] - 小數點右側要保留的有效位數。\n\n如果位數大於值中的有效位數,則將"值"原樣返回。\n\n位數可以取負值,在這種情況下會將小數點左側指定位數的值更改為零。小數點右側的所有位數都會被捨棄。如果值的所有位都被更改為零,則TRUNC會返回0。',example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"QUOTIENT",t:0,d:"返回以一個數除以另一個數所得的結果,不包含餘數。",a:"返回以一個數除以另一個數所得的結果",m:[2,2],p:[{name:"被除數",detail:"要被除的數值。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"除數",detail:"用於除其他數的數值。\n\n除數不得為0",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"POWER",t:0,d:"返回數值的指定次幂。",a:"返回數值的指定次幂。",m:[2,2],p:[{name:"底數",detail:"要計算其指數次幂的數值。\n\n如果底數為負,則指數必須為整數。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"指數",detail:"指定底數的自乘幂次值。",example:"0.5",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMIFS",t:0,d:"根據多項條件返回範圍之和。",a:"根據多項條件返回範圍之和。",m:[3,257],p:[{name:"求和範圍",detail:"要對其求和的範圍。",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"條件範圍1",detail:"要在哪個範圍內檢查條件1。",example:" B1:B10",require:"m",repeat:"n",type:"range"},{name:"條件1",detail:"要應用於條件範圍1的模式或測試條件。",example:' ">20"',require:"m",repeat:"n",type:"rangeall"},{name:"條件範圍2,條件2…",detail:"[ 可選 ] - 要檢查的其他範圍和條件。",example:" C1:C10",require:"o",repeat:"y",type:"rangeall"}]},{n:"COUNTIFS",t:1,d:"根據多項條件返回範圍中的儲存格數量。",a:"根據多項條件返回範圍中的儲存格數量。",m:[2,256],p:[{name:"條件範圍1",detail:"要在哪個範圍內檢查條件1。",example:"A1:A10",require:"m",repeat:"n",type:"range"},{name:"條件1",detail:"要應用於條件範圍1的模式或測試條件。",example:' ">20"',require:"m",repeat:"n",type:"rangeall"},{name:"條件範圍2,條件2…",detail:"[ 可選 ] - 要檢查的其他範圍和條件,可重複。",example:" B1:B10",require:"o",repeat:"y",type:"rangeall"}]},{n:"PRODUCT",t:0,d:"返回將一組數相乘所得的結果。",a:"返回將一組數相乘所得的結果。",m:[1,255],p:[{name:"乘數1",detail:"用於計算乘積的第一個數值或範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"乘數2 ... 乘數30",detail:"[可選] - 要相乘的其他數值",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"HARMEAN",t:1,d:"計算數據集的調和平均值。",a:"計算數據集的調和平均值。",m:[1,255],p:[{name:"值1",detail:"樣本中的第一項值或範圍。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, ...",detail:"[可選] - 數據集中包含的其他數值或範圍。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"HYPGEOMDIST",t:1,d:"返回超幾何分佈。如果已知樣本量、總體成功次數和總體大小,則 HYPGEOM.DIST 返回樣本取得已知成功次數的概率。",a:"返回超幾何分佈。",m:[5,5],p:[{name:"Sample_s",detail:"樣本中成功的次數。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"Number_sample",detail:"樣本量。",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"Population_s",detail:"總體中成功的次數。",example:"20",require:"m",repeat:"n",type:"rangenumber"},{name:"Number_pop",detail:"總體大小。",example:"40",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"决定函數形式的邏輯值。\n\n如果cumulative為TRUE（）,則HYPGEOM.DIST返回累積分佈函數；\n\n如果為FALSE（）,則返回概率密度函數。",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"INTERCEPT",t:1,d:"計算數據集的線性回歸方程直線與 Y 軸的相交點（x=0）的y值。",a:"計算數據集的線性回歸方程直線與 Y 軸的相交點（x=0）的y值。",m:[2,2],p:[{name:"數據_y",detail:"代表因變數數據數組或矩陣的範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"數據_x",detail:"代表引數數據數組或矩陣的範圍。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"KURT",t:1,d:"計算數據集的峭度,該名額訓示數據集（分佈）的形態,尤其是該形態的陡峭程度。",a:"計算數據集的峭度",m:[1,255],p:[{name:"值1",detail:"數據集中的第一個值或範圍。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, ...",detail:"[可選] - 數據集中包含的其他值或範圍。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"LARGE",t:1,d:"返回數據集中第 n 個最大元素,n 由用戶指定。",a:"返回數據集中第 n 個最大元素",m:[2,2],p:[{name:"數據",detail:"包含相關數據集的數組或範圍。",example:"A2:B100",require:"m",repeat:"n",type:"rangenumber"},{name:"n",detail:"要返回的元素的排行位置（從大到小順序）。\n\n例如,將n設為4將使LARGE返回數據中排名第4的最大元素。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"STDEVA",t:1,d:"基於樣本計算標準差,將文字取值為0。",a:"基於樣本計算標準差",m:[1,255],p:[{name:"值1",detail:"樣本中的第一項值或範圍。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"值2,…",detail:"[可選] - 樣本中包含的其他值或範圍。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"STDEVP",t:1,d:"基於樣本總體計算標準差。",a:"基於樣本總體計算標準差。",m:[1,255],p:[{name:"值1",detail:"數據集中的第一個值或範圍。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, ...",detail:"[可選] - 數據集中包含的其他值或範圍。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"GEOMEAN",t:1,d:"計算數據集的幾何平均值。",a:"計算數據集的幾何平均值。",m:[1,255],p:[{name:"值1",detail:"樣本中的第一項值或範圍。",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"值2, ...",detail:"[可選] - 數據集中包含的其他數值或範圍。",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"RANK_EQ",t:1,d:"返回指定值在數據集中的排名。如果相同的值在數據集中存在多項,則返回其中的最高排名。",a:"返回指定值在數據集中的排名。如果相同的值在數據集中存在多項,則返回其中的最高排名。",m:[2,3],p:[{name:"number",detail:"要確定其排名的值。",example:"A10",require:"m",repeat:"n",type:"rangenumber"},{name:"ref",detail:"包含相關數據集的數組或範圍。",example:"A1:A100",require:"m",repeat:"n",type:"range"},{name:"order",detail:'[可選-默認為按降序（FALSE（））] - 要按昇冪還是按降序考慮"data"中的值。',example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"RANK_AVG",t:1,d:"返回指定值在數據集中的排名。如果相同的值在數據集中存在多項,則返回這些項排名的平均值。",a:"返回指定值在數據集中的排名。如果相同的值在數據集中存在多項,則返回這些項排名的平均值。",m:[2,3],p:[{name:"number",detail:"要確定其排名的值。",example:"A10",require:"m",repeat:"n",type:"rangenumber"},{name:"ref",detail:"包含相關數據集的數組或範圍。",example:"A1:A100",require:"m",repeat:"n",type:"range"},{name:"order",detail:'[可選-默認為按降序（FALSE（））] - 要按昇冪還是按降序考慮"data"中的值。',example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"PERCENTRANK_EXC",t:1,d:"以百分數形式返回指定值在給定數據集中的百分比排名（介於0和1之間,不包括兩端值）。",a:"以百分數形式返回指定值在給定數據集中的百分比排名（介於0和1之間,不包括兩端值）。",m:[2,3],p:[{name:"data",detail:"包含相關數據集的數組或範圍。",example:"A1:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"x",detail:"要確定其百分比排位的值。",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"significance",detail:"[可選-預設值為3] - 要在計算中使用的有效位數。",example:"4",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PERCENTRANK_INC",t:1,d:"以百分比形式返回指定值在給定數據集中的百分比排名（介於0和1之間,包括兩端值）。",a:"以百分比形式返回指定值在給定數據集中的百分比排名（介於0和1之間,包括兩端值）。",m:[2,3],p:[{name:"data",detail:"包含相關數據集的數組或範圍。",example:"A1:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"x",detail:"要確定其百分比排位的值。",example:" A2",require:"m",repeat:"n",type:"rangenumber"},{name:"significance",detail:"[可選-預設值為3] - 要在計算中使用的有效位數。",example:"4",require:"o",repeat:"n",type:"rangenumber"}]},{n:"FORECAST",t:1,d:"基於數據集的線性回歸,計算指定 x 的預期 y 值。",a:"基於數據集的線性回歸",m:[3,3],p:[{name:"x",detail:"x軸上用於預測的值。",example:"A1",require:"m",repeat:"n",type:"rangenumber"},{name:"數據_y",detail:"代表因變數數據數組或矩陣的範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"數據_x",detail:"代表引數數據數組或矩陣的範圍。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FISHERINV",t:1,d:"返回指定數值的 Fisher 逆變換。",a:"返回指定數值的 Fisher 逆變換。",m:[1,1],p:[{name:"y",detail:"要計算其Fisher逆變換的數值。",example:"0.962",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FISHER",t:1,d:"返回指定數值的 Fisher 變換。",a:"返回指定數值的 Fisher 變換。",m:[1,1],p:[{name:"x",detail:"要計算其Fisher變換的數值。",example:"0.962",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MODE_SNGL",t:1,d:"返回數據集中出現次數最多的值。",a:"返回數據集中出現次數最多的值。",m:[1,255],p:[{name:"值1",detail:"計算模式時要檢查的第一個值或範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, ...",detail:"[可選] - 在計算模式時要考慮的其他數值或範圍。",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"WEIBULL_DIST",t:1,d:"給定形狀和尺度,返回韋伯分佈函數（或韋伯累積分佈函數）的值。",a:"給定形狀和尺度",m:[4,4],p:[{name:"x",detail:"WEIBULL 分佈函數的輸入值。",example:"2.4",require:"m",repeat:"n",type:"rangenumber"},{name:"alpha",detail:"Weibull 分佈函數的形狀參數。\n\n alpha值必須大於0。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"beta",detail:"Weibull 分佈函數的尺度參數。\n\n beta值必須大於0。",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"TRUE（）表示使用累積分佈函數,FALSE（）則表示使用概率密度函數。",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"COUNT",t:1,d:"返回數據集中數值的個數。",a:"返回數據集中數值的個數。",m:[1,255],p:[{name:"值1",detail:"計數時要檢查的第一個值或範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"值2, ...",detail:"[可選] - 在計數時要檢查的其他值或範圍。",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"COUNTA",t:1,d:"返回數據集中值的數量。",a:"返回數據集中值的數量。",m:[1,255],p:[{name:"值1",detail:"計數時要檢查的第一個值或範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"值2, ...",detail:"[可選] - 在計數時要檢查的其他值或範圍。",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"AVEDEV",t:1,d:"計算數據與數據集平均值之間的偏差大小的平均值。",a:"計算數據與數據集平均值之間的偏差大小的平均值。",m:[1,255],p:[{name:"值1",detail:"樣本中的第一項值或範圍。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, ...",detail:"[可選] - 樣本中包含的其他值或範圍。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"AVERAGE",t:1,d:"返回數據集的算術平均值,對文字忽略不計。",a:"返回數據集的算術平均值",m:[1,255],p:[{name:"值1",detail:"計算平均值時用到的第一個數值或範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"值2, ...",detail:"[可選] - 在計算平均值時要考慮的其他數值或範圍。",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"AVERAGEA",t:1,d:"返回數據集的算術平均值。",a:"返回數據集的算術平均值。",m:[1,255],p:[{name:"值1",detail:"計算平均值時用到的第一個數值或範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangeall"},{name:"值2, ...",detail:"[可選] - 在計算平均值時要考慮的其他數值或範圍。",example:"B2:B100",require:"o",repeat:"y",type:"rangeall"}]},{n:"BINOM_DIST",t:1,d:"返回一元二項式分佈的概率。",a:"返回一元二項式分佈的概率。",m:[4,4],p:[{name:"number_s",detail:"試驗的成功次數。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"trials",detail:"獨立檢驗的次數。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"probability_s",detail:"任一給定檢驗的成功概率。",example:"0.005",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"是否使用二項式累積分佈。",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"BINOM_INV",t:1,d:"計算累積二項式分佈大於或等於指定條件的最小值。",a:"計算累積二項式分佈大於或等於指定條件的最小值。",m:[3,3],p:[{name:"trials",detail:"貝努利試驗次數。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"probability_s",detail:"任一次給定檢驗的成功概率。",example:"0.005",require:"m",repeat:"n",type:"rangenumber"},{name:"alpha",detail:"期望的臨界概率。",example:"0.8",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CONFIDENCE_NORM",t:1,d:"計算常态分配的置信區間的一半寬度。",a:"計算常态分配的置信區間的一半寬度。",m:[3,3],p:[{name:"alpha",detail:"用來計算置信水准的顯著性水准。\n\n置信水准等於100*（1 - alpha）%,亦即,如果 alpha 為0.05,則置信水准為 95%。",example:"0.05",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_dev",detail:"數據區域的總體標準差。",example:"1.6",require:"m",repeat:"n",type:"rangenumber"},{name:"size",detail:"樣本總量的大小。",example:"250",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CORREL",t:1,d:"計算給定數據集的皮爾遜積矩相關係數 r。",a:"計算給定數據集的皮爾遜積矩相關係數 r。",m:[2,2],p:[{name:"數據_y",detail:"代表因變數數據數組或矩陣的範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"數據_x",detail:"代表引數數據數組或矩陣的範圍。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COVARIANCE_P",t:1,d:"計算數據集的總體協方差。",a:"計算數據集的總體協方差。",m:[2,2],p:[{name:"數據_x",detail:"代表引數數據數組或矩陣的範圍。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"},{name:"數據_y",detail:"代表因變數數據數組或矩陣的範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COVARIANCE_S",t:1,d:"計算數據集的樣本協方差。",a:"計算數據集的樣本協方差。",m:[2,2],p:[{name:"數據_x",detail:"代表引數數據數組或矩陣的範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"數據_y",detail:"代表因變數數據數組或矩陣的範圍。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DEVSQ",t:1,d:"基於樣本計算其偏差的平方和。",a:"基於樣本計算其偏差的平方和。",m:[1,255],p:[{name:"值1",detail:"樣本中的第一項值或範圍。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, ...",detail:"[可選] - 樣本中包含的其他值或範圍。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"EXPON_DIST",t:1,d:"返回帶有指定 Lambda 和指定值的指數分佈函數的值。",a:"返回帶有指定 Lambda 和指定值的指數分佈函數的值。",m:[3,3],p:[{name:"x",detail:"指數分佈函數的輸入值。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"lambda",detail:"用於指定指數分佈函數的 lambda 值。",example:"0.5",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"是否使用指數累積分佈。",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"AVERAGEIF",t:1,d:"根據條件返回範圍的平均值。",a:"根據條件返回範圍的平均值。",m:[2,3],p:[{name:"criteria_range",detail:"要對其檢查 criterion 的範圍。",example:"A1:A10",require:"m",repeat:"n",type:"rangeall"},{name:"criterion",detail:'要應用於criteria_range的模式或測試條件。\n\n等於:"文字" 或 1 或 "=文字" 或 "=1"\n\n大於:">1"\n\n大於等於:">=1"\n\n小於:"<1"\n\n小於等於:"<=1"\n\n不等於:"<>1"或"<>文字"',example:'">20"',require:"m",repeat:"n",type:"rangeall"},{name:"average_range",detail:"[可選] - 要計算平均值的範圍。如果未提供此參數,則改用criteria_range來計算平均值。",example:"B1:B10",require:"o",repeat:"n",type:"rangeall"}]},{n:"AVERAGEIFS",t:1,d:"根據多項條件返回範圍的平均值。",a:"根據多項條件返回範圍的平均值。",m:[2,255],p:[{name:"average_range",detail:"要計算平均值的範圍。",example:"A1:A10",require:"m",repeat:"n",type:"rangeall"},{name:"criteria_range1",detail:"要對其檢查 criterion1 的範圍。",example:" B1:B10",require:"m",repeat:"n",type:"rangeall"},{name:"criterion1",detail:"要應用於criteria_range1的模式或測試條件。",example:' ">20"',require:"m",repeat:"n",type:"rangeall"},{name:"criteria_range2, criterion2, ...",detail:"[可選] - 要檢查的其他範圍和條件。",example:" C1:C10",require:"m",repeat:"n",type:"rangeall"}]},{n:"PERMUT",t:1,d:"返回可從數位對象中選擇的給定數目對象的排列數。",a:"返回可從數位對象中選擇的給定數目對象的排列數。",m:[2,2],p:[{name:"number",detail:"表示對象個數的整數。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"number_chosen",detail:"表示每個排列中對象個數的整數。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TRIMMEAN",t:1,d:"在排除數據集高低兩端的部分數據之後計算所得的平均值。",a:"在排除數據集高低兩端的部分數據之後計算所得的平均值。",m:[2,2],p:[{name:"數據",detail:"包含相關數據集的數組或範圍。",example:"A2:A100",require:"m",repeat:"n",type:"range"},{name:"排除比例",detail:"要從數據集的極值部分排除的數據占數據集的比例。\n\n排除比例必須大於等於0且小於1。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PERCENTILE_EXC",t:1,d:"返回數組的 K 百分點值,K 介於0到1之間,不含0與1。",a:"返回數組的 K 百分點值,K 介於0到1之間,不含0與1。",m:[2,2],p:[{name:"array",detail:"定義相對位置的數組或數據區域。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"k",detail:"0 到 1 之間的百分點值,不包含 0 和 1。",example:"0.25",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PERCENTILE_INC",t:1,d:"返回數組的 K 百分點值,K 介於 0 到 1 之間,包含 0 與 1。",a:"返回數組的 K 百分點值,K 介於 0 到 1 之間,包含 0 與 1。",m:[2,2],p:[{name:"array",detail:"定義相對位置的數組或數據區域。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"k",detail:"0 到 1 之間的百分點值,包含 0 和 1。",example:"0.25",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PEARSON",t:1,d:"回皮爾生（Pearson）乘積矩相關係數 r。",a:"回皮爾生（Pearson）乘積矩相關係數 r。",m:[2,2],p:[{name:"數據_x",detail:"代表引數數據數組或矩陣的範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"數據_y",detail:"代表因變數數據數組或矩陣的範圍。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NORM_S_INV",t:1,d:"返回標準正態累積分佈函數的反函數值。該分佈的平均值為0,標準差為1。",a:"返回標準正態累積分佈函數的反函數值。該分佈的平均值為0,標準差為1。",m:[1,1],p:[{name:"probability",detail:"對應於常态分配的概率。",example:"0.75",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NORM_S_DIST",t:1,d:"返回標準常态分配函數（該分佈的平均值為0,標準差為1）。",a:"返回標準常态分配函數（該分佈的平均值為0,標準差為1）。",m:[2,2],p:[{name:"z",detail:"需要計算其分佈的數值。",example:"2.4",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"决定函數形式的邏輯值。\n\n如果為TRUE（）,則返回累積分佈函數；\n\n如果為FALSE（）,則返回概率密度函數。",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"NORM_INV",t:1,d:"返回指定平均值和標準差的正態累積分佈函數的反函數值。",a:"返回指定平均值和標準差的正態累積分佈函數的反函數值。",m:[3,3],p:[{name:"probability",detail:"對應於常态分配的概率。",example:"0.75",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"分佈的算術平均值。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_dev",detail:"分佈的標準差。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NORM_DIST",t:1,d:"返回指定平均值和標準差的常态分配函數。",a:"返回指定平均值和標準差的常态分配函數。",m:[4,4],p:[{name:"x",detail:"需要計算其分佈的數值。",example:"2.4",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"分佈的算術平均值。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_dev",detail:"分佈的標準差。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"决定函數形式的邏輯值。\n\n如果為TRUE（）,則返回累積分佈函數；\n\n如果為FALSE（）,則返回概率密度函數。",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"NEGBINOM_DIST",t:1,d:"返回負二項式分佈。",a:"返回負二項式分佈。",m:[4,4],p:[{name:"number_f",detail:"要類比的失敗次數。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"number_s",detail:"要類比的成功次數。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"probability_s",detail:"任一次給定檢驗的成功概率。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"决定函數形式的邏輯值。\n\n如果為TRUE（）,則返回累積分佈函數；\n\n如果為FALSE（）,則返回概率密度函數。",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"MINA",t:1,d:"返回數據集中的最小數值。",a:"返回數據集中的最小數值。",m:[1,255],p:[{name:"值1",detail:"計算最小值時所用的第一個值或範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"值2",detail:"[可選] - 在計算最小值時要考慮的其他數值或範圍。",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MIN",t:1,d:"返回數值數據集中的最小值。",a:"返回數值數據集中的最小值。",m:[1,255],p:[{name:"值1",detail:"計算最小值時所用的第一個值或範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"值2",detail:"[可選] - 在計算最小值時要考慮的其他數值或範圍。",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MEDIAN",t:1,d:"返回數值數據集中的中值。",a:"返回數值數據集中的中值。",m:[1,255],p:[{name:"值1",detail:"計算中值時所用的第一個數值或範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"值2",detail:"[可選] - 在計算中值時要考慮的其他數值或範圍。",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MAXA",t:1,d:"返回數據集中的最大數值。",a:"返回數據集中的最大數值。",m:[1,255],p:[{name:"值1",detail:"計算最大值時所用的第一個值或範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, ...",detail:"[可選] - 在計算最大值時要考慮的其他數值或範圍。",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"MAX",t:1,d:"返回數值數據集中的最大值。",a:"返回數值數據集中的最大值。",m:[1,255],p:[{name:"值1",detail:"計算最大值時所用的第一個值或範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"值2",detail:"[可選] - 在計算最大值時要考慮的其他數值或範圍。",example:"B2:B100",require:"o",repeat:"y",type:"rangenumber"}]},{n:"LOGNORM_INV",t:1,d:"返回 x 的對數累積分佈函數的反函數值。",a:"返回 x 的對數累積分佈函數的反函數值。",m:[3,3],p:[{name:"probability",detail:"與對數分佈相關的概率,介於0與1之間（不含0與1）。",example:"0.4",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"ln(x) 的平均值。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_dev",detail:"ln(x) 的標準差,正數。",example:"6",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LOGNORM_DIST",t:1,d:"返回 x 的對數分佈函數。",a:"返回 x 的對數分佈函數。",m:[4,4],p:[{name:"x",detail:"用來計算函數的值。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"ln(x) 的平均值。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_dev",detail:"ln(x) 的標準差,正數。",example:"6",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"决定函數形式的邏輯值。\n\n如果為TRUE（）,則返回累積分佈函數；\n\n如果為FALSE（）,則返回概率密度函數。",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"Z_TEST",t:1,d:"返回 z 檢驗的單尾 P 值。",a:"返回 z 檢驗的單尾 P 值。",m:[2,3],p:[{name:"array",detail:"用來檢驗 x 的數組或數據區域。",example:"A2:A100",require:"m",repeat:"n",type:"range"},{name:"x",detail:"要測試的值。",example:"B2",require:"m",repeat:"n",type:"rangenumber"},{name:"sigma",detail:"[可選] - 總體（已知）標準差。如果省略,則使用樣本標準差。",example:"3",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PROB",t:1,d:"返回區域中的數值落在指定區間內的概率。",a:"返回區域中的數值落在指定區間內的概率。",m:[3,4],p:[{name:"x_range",detail:"具有各自相應概率值的 x 數值區域。",example:"A3:A6",require:"m",repeat:"n",type:"range"},{name:"prob_range",detail:"與 x_range 中的值相關聯的一組概率值。",example:"2",require:"m",repeat:"n",type:"range"},{name:"lower_limit",detail:"要計算其概率的數值下界。",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"upper_limit",detail:"[可選 - 預設值為下界] - 要計算其概率的可選數值上界。\n\n如果省略上界,PROB則計算隨機選取相應值的次數恰好等於下界的概率。",example:"4",require:"o",repeat:"n",type:"rangenumber"}]},{n:"QUARTILE_EXC",t:1,d:"基於 0 到 1 之間（不包括 0 和 1）的百分點值返回數據集的四分位數。",a:"基於 0 到 1 之間（不包括 0 和 1）的百分點值返回數據集的四分位數。",m:[2,2],p:[{name:"array",detail:"要求得四分位數值的數組或數字型儲存格區域。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"quart",detail:"要返回第幾個四分位值。\n\n1返回數據中最靠近第一個四分位值的值（25%標記）。\n\n2返回數據中最接近中值的值（50%標記）。\n\n3返回數據中最接近第三個四分位值的值（75%標記）。",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"QUARTILE_INC",t:1,d:"根據 0 到 1 之間的百分點值（包含 0 和 1）返回數據集的四分位數。",a:"根據 0 到 1 之間的百分點值（包含 0 和 1）返回數據集的四分位數。",m:[2,2],p:[{name:"array",detail:"要求得四分位數值的數組或數字型儲存格區域。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"quart",detail:"要返回第幾個四分位值。\n\n0返回數據中的最小值（0%標記）。\n\n1返回數據中最靠近第一個四分位值的值（25%標記）。\n\n2返回數據中最接近中值的值（50%標記）。\n\n3返回數據中最接近第三個四分位值的值（75%標記）。\n\n4返回數據中的最大值（100%標記）。",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"POISSON_DIST",t:1,d:"返回泊松分布。",a:"返回泊松分布。",m:[3,3],p:[{name:"x",detail:"事件數。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"期望值。非負數",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"一 邏輯值,確定所返回的概率分佈的形式。\n\n如果為TRUE（）,則返回發生的隨機事件數在零（含零）和x（含x）之間的累積泊松概率；\n\n如果為FALSE（）,則返回發生的事件數正好是x的泊松概率密度函數。",example:"FALSE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"RSQ",t:1,d:"返回皮爾生(Pearson)乘積矩相關係數r的平方。",a:"返回皮爾生(Pearson)乘積矩相關係數r的平方。",m:[2,2],p:[{name:"數據_y",detail:"代表因變數數據數組或矩陣的範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"數據_x",detail:"代表引數數據數組或矩陣的範圍。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_DIST",t:1,d:"返回學生的左尾 t 分佈。",a:"返回學生的左尾 t 分佈。",m:[3,3],p:[{name:"x",detail:"T-分佈函數的輸入。",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"自由度數值。",example:"30",require:"m",repeat:"n",type:"rangenumber"},{name:"tails",detail:"决定函數形式的邏輯值。\n\n如果cumulative為TRUE（）,則HYPGEOM.DIST返回累積分佈函數；\n\n如果為FALSE（）,則返回概率密度函數。",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"T_DIST_2T",t:1,d:"返回學生的雙尾 t 分佈。",a:"返回學生的雙尾 t 分佈。",m:[2,2],p:[{name:"x",detail:"T-分佈函數的輸入。",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"自由度數值。",example:"30",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_DIST_RT",t:1,d:"返回學生的右尾 t 分佈。",a:"返回學生的右尾 t 分佈。",m:[2,2],p:[{name:"x",detail:"T-分佈函數的輸入。",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom",detail:"自由度數值。",example:"30",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_INV",t:1,d:"返回學生的 t 分佈的左尾反函數。",a:"返回學生的 t 分佈的左尾反函數。",m:[2,2],p:[{name:"probability",detail:"與學生的 t 分佈相關的概率。\n\n必須大於 0 且小於 1。",example:"0.35",require:"m",repeat:"n",type:"rangenumber"},{name:"deg_freedom",detail:"自由度數值。\n\n如果所提供的參數不是整數,將截取其整數部分。\n\n必須大於等於1。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_INV_2T",t:1,d:"返回學生 t 分佈的雙尾反函數。",a:"返回學生 t 分佈的雙尾反函數。",m:[2,2],p:[{name:"probability",detail:"與學生的t分佈相關的概率。\n\n必須大於 0 且小於 1。",example:"0.35",require:"m",repeat:"n",type:"rangenumber"},{name:"deg_freedom",detail:"自由度數值。\n\n如果所提供的參數不是整數,將截取其整數部分。\n\n必須大於等於1。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"T_TEST",t:1,d:"返回與t-檢驗相關的概率。用於判斷兩個樣本是否可能是出自平均值相同的兩個樣本總體。",a:"返回與t-檢驗相關的概率。用於判斷兩個樣本是否可能是出自平均值相同的兩個樣本總體。",m:[4,4],p:[{name:"array1",detail:"將用於t檢驗的第一個數據樣本或第一組儲存格。",example:"A1:A4",require:"m",repeat:"n",type:"rangenumber"},{name:"array2",detail:"將用於t檢驗的第二個數據樣本或第二組儲存格。",example:"B1:B4",require:"m",repeat:"n",type:"rangenumber"},{name:"tails",detail:"指定分佈的尾數。\n\n如果為 1:使用單尾分佈。\n\n如果為 2:使用雙尾分佈。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"type",detail:"指定t檢驗的類型。\n\n如果為 1:執行配對檢驗。\n\n如果為 2:執行雙樣本等方差（同方差）檢驗。\n\n如果為 3:執行雙樣本不等方差（异方差）檢驗。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"F_DIST",t:1,d:"給定輸入值 x,計算兩個數據集的左尾 F 概率分佈（差异程度）。此分佈也稱為 Fisher-Snedecor 分佈或Snedecor F 分佈。",a:"給定輸入值 x",m:[4,4],p:[{name:"x",detail:"用來計算函數的值。",example:"15.35",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom1",detail:"分子自由度。",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom2",detail:"分母自由度。",example:"6",require:"m",repeat:"n",type:"rangenumber"},{name:"cumulative",detail:"用於確定函數形式的邏輯值。預設值為 FALSE。\n\n如果為 TRUE（）:F.DIST將返回累積分佈函數值。\n\n如果為FALSE（）:F.DIST將返回概率密度函數值。",example:"TRUE()",require:"m",repeat:"n",type:"rangeall"}]},{n:"F_DIST_RT",t:1,d:"給定輸入x,計算兩個數據集的右尾F概率分佈（差异程度）。此分佈也稱為Fisher-Snedecor分佈或Snedecor F分佈。",a:"給定輸入 x",m:[3,3],p:[{name:"x",detail:"用來計算函數的值。",example:"15.35",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom1",detail:"分子自由度。",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"degrees_freedom2",detail:"分母自由度。",example:"6",require:"m",repeat:"n",type:"rangenumber"}]},{n:"VAR_P",t:1,d:"基於樣本總體計算方差。",a:"基於樣本總體計算方差。",m:[1,255],p:[{name:"值1",detail:"數據集中的第一個值或範圍。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, …",detail:"[可選] - 數據集中包含的其他值或範圍。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"VAR_S",t:1,d:"基於樣本計算方差。",a:"基於樣本計算方差。",m:[1,255],p:[{name:"值1",detail:"樣本中的第一項值或範圍。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, …",detail:"[可選] - 樣本中包含的其他值或範圍。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"VARA",t:1,d:"基于样本计算方差,将文本取值为0。",a:"基于样本计算方差",m:[1,255],p:[{name:"value1",detail:"樣本中的第一項值或範圍。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"value2, ...",detail:"[可選] - 樣本中包含的其他值或範圍。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"VARPA",t:1,d:"基於樣本總體計算方差,將文字取值為0。",a:"基於樣本總體計算方差",m:[1,255],p:[{name:"值1",detail:"樣本中的第一項值或範圍。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"值2, ...",detail:"[可選] - 數據集中包含的其他數值或範圍。",example:"2",require:"o",repeat:"y",type:"rangenumber"}]},{n:"STEYX",t:1,d:"返回通過線性回歸法預測每個 x 的 y 值時所產生的標準誤差。",a:"返回通過線性回歸法預測每個 x 的 y 值時所產生的標準誤差。",m:[2,2],p:[{name:"數據_y",detail:"代表因變數數據數組或矩陣的範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"數據_x",detail:"代表引數數據數組或矩陣的範圍。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"STANDARDIZE",t:1,d:"給定分佈的平均值和標準差,計算一個隨機變數正態化的相應值。",a:"給定分佈的平均值和標準差,計算一個隨機變數正態化的相應值。",m:[3,3],p:[{name:"x",detail:"要正態化的隨機變數值。",example:"96",require:"m",repeat:"n",type:"rangenumber"},{name:"mean",detail:"分佈的平均值。",example:"80",require:"m",repeat:"n",type:"rangenumber"},{name:"standard_dev",detail:"分佈的標準差。",example:"6.7",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SMALL",t:1,d:"返回數據集中的第k個最小值。",a:"返回數據集中的第k個最小值。",m:[2,2],p:[{name:"array",detail:"需要找到第k個最小值的數組或數值數據區域。",example:"A2:B100",require:"m",repeat:"n",type:"range"},{name:"k",detail:"要返回的數據在數組或數據區域裏的位置（從小到大）。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SLOPE",t:1,d:"計算通過數據集的線性回歸得到的直線的斜率。",a:"計算通過數據集的線性回歸得到的直線的斜率。",m:[2,2],p:[{name:"數據_y",detail:"代表因變數數據數組或矩陣的範圍。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"數據_x",detail:"代表引數數據數組或矩陣的範圍。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SKEW",t:1,d:"返回分佈的偏斜度。偏斜度表明分佈相對於平均值的不對稱程度。正偏斜度表明分佈的不對稱尾部趨向於更多正值。負偏斜度表明分佈的不對稱尾部趨向於更多負值。",a:"返回分佈的偏斜度。",m:[1,255],p:[{name:"值1",detail:"數據集中的第一個值或範圍。",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"值2, ...",detail:"[可選] - 數據集中包含的其他值或範圍。",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"SKEW_P",t:1,d:"返回基於樣本總體的分佈不對稱度:表明分佈相對於平均值的不對稱程度。",a:"返回基於樣本總體的分佈不對稱度:表明分佈相對於平均值的不對稱程度。",m:[1,255],p:[{name:"值1",detail:"數據集中的第一個值或範圍。",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"值2, ...",detail:"[可選] - 數據集中包含的其他值或範圍。",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"VLOOKUP",t:2,d:"縱向查找。在範圍的第一列中自上而下蒐索某個鍵值,並返回所找到的行中指定儲存格的值。",a:"縱向查找。在範圍的第一列中自上而下蒐索某個鍵值",m:[3,4],p:[{name:"蒐索鍵值",detail:'要蒐索的值,如 42、"Cats" 或 I24。',example:"10003",require:"m",repeat:"n",type:"rangeall"},{name:"範圍",detail:"要進行蒐索的範圍。VLOOKUP 將在該範圍的第一列中蒐索蒐索鍵值中指定的鍵值。",example:"A2:B26",require:"m",repeat:"n",type:"rangeall"},{name:"索引",detail:"要返回的值的列索引,範圍中的第一列編號為1。\n\n如果索引不是介於1和範圍中的列數之間,將返回#VALUE！。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"已排序",detail:"[預設值為TRUE()] -訓示要蒐索的列（指定範圍的第一列）是否已排序。大多數情况下,建議設為FALSE（）。\n\n建議將已排序設為FALSE。如果設為FALSE,將返回完全匹配項。如果存在多個匹配值,將返回找到的第一個值對應的儲存格的內容,如果找不到匹配值,則返回#N/A。\n\n如果將已排序設為TRUE或省略,將返回（小於或等於蒐索鍵值的）最接近的匹配項。如果蒐索的列中所有的值均大於蒐索鍵值,則返回#N/A。",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"HLOOKUP",t:2,d:"橫向查找。在範圍的第一行中蒐索某個鍵值,並返回所找到的列中指定儲存格的值。",a:"橫向查找。在範圍的第一行中蒐索某個鍵值",m:[3,4],p:[{name:"蒐索鍵值",detail:'要蒐索的值。例如,42、"Cats"或I24。',example:"10003",require:"m",repeat:"n",type:"rangeall"},{name:"範圍",detail:"要進行蒐索的範圍。將在該範圍的第一行中蒐索在蒐索鍵值中指定的鍵值。",example:"A2:Z6",require:"m",repeat:"n",type:"rangeall"},{name:"索引",detail:"要返回的值的行索引,範圍中的第一行編號為1。\n\n如果索引不是介於1和範圍中的行數之間,將返回#VALUE！。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"已排序",detail:"[可選 - 預設值為TRUE()] - 訓示要蒐索的行（指定範圍的第一行）是否已排序。\n\n如果將已排序設為TRUE或省略,將返回最接近的匹配值（小於或等於蒐索鍵值）。如果在蒐索的行中所有的值均大於蒐索鍵值,則返回#N/A。\n\n如果將已排序設為TRUE或將其省略,而範圍的首行並非處於已排序狀態,則返回值可能會是錯誤的。\n\n如果將已排序設為FALSE,則僅返回完全匹配。如果存在多個匹配值,將返回與找到的第一個值對應的儲存格的內容,如果找不到匹配值則返回#N/A。",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"LOOKUP",t:2,d:"在行或列中查找相應鍵,並將相應儲存格的值返回到與蒐索行或列所在位置相同的結果範圍中。",a:"在行或列中查找相應鍵",m:[2,3],p:[{name:"蒐索鍵值",detail:'要在行或列中蒐索的值。例如,42、"Cats" 或 I24。',example:"10003",require:"m",repeat:"n",type:"rangeall"},{name:"搜索範圍 | 搜索結果數組",detail:"使用LOOKUP的一種方法是給定單行或單列形式的搜索範圍進行蒐索查找,這種管道要用到另一個參數結果範圍。另一種管道是將這兩個參數合併為一個搜索結果數組,其中第一行或第一列用於蒐索,並將返回值放在該數組的最後一行或最後一列中。",example:"A1:A100",require:"m",repeat:"n",type:"rangeall"},{name:"結果範圍",detail:"[ 可選 ] - 用於存放返回結果的範圍。返回值對應於在搜索範圍中找到蒐索鍵值的位置。此範圍必須僅為單行或單列,而如果您使用的是搜索結果數組管道,則不應提供此參數。",example:"B1:B100",require:"o",repeat:"n",type:"rangeall"}]},{n:"ADDRESS",t:2,d:"返回字串形式的儲存格引用。",a:"返回字串形式的儲存格引用。",m:[2,5],p:[{name:"row_num",detail:"一個數值,指定要在儲存格引用中使用的行號。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"column_num",detail:"一個數值,指定要在儲存格引用中使用的列號（而非名稱）。A列的編號為1。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"abs_num",detail:"[可選 - 預設值為1] - 一個數值,指定要返回的參考類型。\n\n1表示行列均採用絕對值（例如$A$1）；\n\n2表示採用絕對行號,相對列標（例如A$1）；\n\n3表示採用相對行號,絕對列標（例如$A1）；\n\n4表示行列均採用相對值（例如A1）。",example:"4",require:"o",repeat:"n",type:"rangenumber"},{name:"A1",detail:"[可選 - 預設值為TRUE（）] - 一個布林值,訓示採用A1標記形式（TRUE）還是R1C1標記形式（FALSE）。",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"},{name:"sheet_text",detail:"[可選 - 默認預設] - 用於指定地址所指向的工作表名稱。",example:'"Sheet2"',require:"o",repeat:"n",type:"rangeall"}]},{n:"INDIRECT",t:2,d:"返回以字串指定的儲存格引用。",a:"返回以字串指定的儲存格引用。",m:[1,2],p:[{name:"ref_text",detail:"以帶引號的字串形式提供的儲存格引用。",example:'"Sheet2!"&B10',require:"m",repeat:"n",type:"rangeall"},{name:"A1",detail:"[可選 - 預設值為TRUE（）] - 一個布林值,訓示採用A1標記形式（TRUE）還是R1C1標記形式（FALSE）。",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"ROW",t:2,d:"返回指定儲存格的行號",a:"返回指定儲存格的行號",m:[0,1],p:[{name:"reference",detail:"[可選 - 默認為此公式所在的儲存格] - 要返回其行號的儲存格。\n\n如果儲存格引用指向的範圍其寬度大於一個儲存格,而此公式不是用作數組公式的,這時會僅返回儲存格引用中首行的編號值。",example:"A9",require:"o",repeat:"n",type:"rangeall"}]},{n:"ROWS",t:2,d:"返回指定數組或範圍中的行數。",a:"返回指定數組或範圍中的行數。",m:[1,1],p:[{name:"array",detail:"要返回其行數的範圍。",example:"A9:A62",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COLUMN",t:2,d:"按照 `A=1` 的規則返回指定儲存格的列號。",a:"按照 `A=1` 的規則返回指定儲存格的列號。",m:[0,1],p:[{name:"reference",detail:"[可選 - 默認為包含此公式的儲存格] - 要返回其列號的儲存格。A列對應的編號為1。\n\n如果儲存格引用是寬度超過一個儲存格的範圍,而此公式不是作為數組公式來使用的,囙此將返回儲存格引用中的第一列的位置。",example:"A9",require:"o",repeat:"n",type:"rangeall"}]},{n:"COLUMNS",t:2,d:"返回指定數組或範圍中的列數。",a:"返回指定數組或範圍中的列數。",m:[1,1],p:[{name:"array",detail:"要返回其列數的範圍。",example:"A9:W62",require:"m",repeat:"n",type:"rangenumber"}]},{n:"OFFSET",t:2,d:"給定某範圍的起始儲存格引用以及該範圍涵蓋的行列數量,返回該範圍的引用。",a:"給定某範圍的起始儲存格引用以及該範圍涵蓋的行列數量,返回該範圍的引用。",m:[3,5],p:[{name:"reference",detail:"用於計算行列偏移量的起點。",example:"A2",require:"m",repeat:"n",type:"range"},{name:"rows",detail:"要偏移的行數。\n\n行偏移量必須是整數,但也可以是負數。如果提供的參數帶有小數,小數部分將被截去。",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"cols",detail:"要偏移的列數。\n\n列偏移量必須是整數,但也可以是負數。如果提供的參數帶有小數,小數部分將被截去。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"height",detail:"[可選] - 要從偏移目標開始返回的範圍的高度。",example:"2",require:"o",repeat:"n",type:"rangenumber"},{name:"width",detail:"[可選] - 要從偏移目標開始返回的範圍的寬度。",example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"MATCH",t:2,d:"在儲存格中蒐索指定項,然後返回該項在儲存格區域中的相對位置。",a:"在儲存格中蒐索指定項,然後返回該項在儲存格區域中的相對位置。",m:[2,3],p:[{name:"lookup_value",detail:"要在 lookup_array 中匹配的值。",example:'"Sunday"',require:"m",repeat:"n",type:"rangeall"},{name:"lookup_array",detail:"要蒐索的儲存格區域。\n\n如果所用的範圍的高度和寬度均大於1,MATCH將返回#N/A！。",example:"A2:A9",require:"m",repeat:"n",type:"range"},{name:"match_type",detail:"[可選 - 預設值為1] - 要採用的蒐索管道。\n\n1為默認類型,此時MATCH會假設範圍已按昇冪排序,並返回小於等於蒐索鍵值的最大值。\n\n0表示完全匹配,在範圍未排序的情况下需要使用此管道。\n\n-1讓MATCH假設範圍是按降序排序的,並返回大於等於蒐索鍵值的最小值。",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"INDEX",t:2,d:"返回表格或中的元素值,此元素由行號和列號的索引值給定。",a:"返回表格或中的元素值,此元素由行號和列號的索引值給定。",m:[2,3],p:[{name:"array",detail:"儲存格區域或數組常數。",example:"A1:C20",require:"m",repeat:"n",type:"range"},{name:"row_num",detail:"選擇數組中的某行,函數從該行返回數值。",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"column_num",detail:"選擇數組中的某列,函數從該列返回數值。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GETPIVOTDATA",t:2,d:"從與指定行和列標題對應的數據透視錶中選取匯總值。",a:"從與指定行和列標題對應的數據透視錶中選取匯總值。",m:[2,254],p:[{name:"data_field",detail:'您想從數據透視錶中獲取其數據的值名稱。\n值名稱必須括在引號中或是指向包含相關文字的任何儲存格的引用。\n如果有多個值欄位,則必須使用數據透視錶中顯示的確切名稱（如"銷售總額"）。',example:'"SUM of number of units"',require:"m",repeat:"n",type:"rangeall"},{name:"pivot_table",detail:"目標數據透視錶中的任何儲存格的引用（推薦位於頂角的儲存格）。",example:"'Pivot table'!A1",require:"m",repeat:"n",type:"rangeall"},{name:"field1",detail:"[可選] - 源數據集（不是數據透視錶）中列的名稱。",example:'"division"',require:"o",repeat:"y",type:"rangeall"},{name:"item1",detail:"[可選] - 數據透視錶中顯示的與您要檢索的欄位名稱1相對應的行或列的名稱。",example:'"east"',require:"o",repeat:"y",type:"rangeall"}]},{n:"CHOOSE",t:2,d:"基於索引返回選項清單中的元素。",a:"基於索引返回選項清單中的元素。",m:[2,255],p:[{name:"index_num",detail:"指定要返回哪一項。\n\n如果索引為零、負值或大於提供的選擇數量,將返回#VALUE！錯誤。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"value1",detail:"一項可能的返回值。必須提供。可以是儲存格引用或單獨的值。",example:'"A"',require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"[可選] - 其他可以選擇的值。選擇",example:'"B"',require:"o",repeat:"y",type:"rangeall"}]},{n:"HYPERLINK",t:2,d:"在儲存格內創建一個超連結。",a:"在儲存格內創建一個超連結。",p:[{name:"網址",detail:"以引號括住的連結位置的完整網址,或對包含這種網址的儲存格的引用。\n\n僅允許某些連結類型。其中包括:http://、https://、mailto:、aim:、ftp://、gopher://、telnet://和news://,明確禁用使用其他協定。如果指定的是其他協定,將會在儲存格中顯示連結標籤,但該標籤不會以連結形式呈現。\n\n如果未指定協定,則假設使用http://,並將其作為網址的首碼。",example:'"http://www.google.com/"',require:"m",repeat:"n",type:"rangeall"},{name:"連結標籤",detail:'[可選-默認為網址] - 要在儲存格中作為連結顯示的文字（用引號括起來的）,或者指向包含這種標籤的儲存格的引用。\n\n如果連結標籤是指向某個空儲存格的引用,如果網址有效,就將其作為連結顯示,否則作為純文字顯示。\n\n如果連結標籤為空字串常數（""）,所在儲存格顯示的內容將為空白,但通過點擊該儲存格或轉入該儲存格仍然可以訪問連結。',example:'"Google"',require:"m",repeat:"n",type:"rangeall"}]},{n:"TIME",t:6,d:"將給定的小時、分鐘和秒轉換為時間。",a:"將給定的小時、分鐘和秒轉換為時間。",m:[3,3],p:[{name:"小時",detail:"0（零）到 32767 之間的數位,代表小時。\n\n任何大於 23 的值都會除以24,餘數將作為小時值。",example:"11",require:"m",repeat:"n",type:"rangenumber"},{name:"分鐘",detail:"0（零）到 32767 之間的數位,代表分鐘。\n\n任何大於 59 的值將轉換為小時和分鐘。",example:"40",require:"m",repeat:"n",type:"rangenumber"},{name:"秒",detail:"0（零）到 32767 之間的數位,代表秒。\n\n任何大於 59 的值將轉換為小時、分鐘和秒。",example:"59",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TIMEVALUE",t:6,d:"按一天24小時返回該時間的分數表示。",a:"按一天24小時返回該時間的分數表示。",m:[1,1],p:[{name:"time_text",detail:"用於表示時間的字串。",example:'"2:15 PM"',require:"m",repeat:"n",type:"rangeall"}]},{n:"EOMONTH",t:6,d:"返回某個月份最後一天的序號,該月份在另一個日期之前或之後的數個月（月數由參數指定）。",a:"返回某個月份最後一天的序號",m:[2,2],p:[{name:"start_date",detail:"用於計算結果的參照日期。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"months",detail:"用於計算的起始日期之前（負）或之後（正）的月數。返回的是計算所得月份的最後那天。",example:"7",require:"m",repeat:"n",type:"rangenumber"}]},{n:"EDATE",t:6,d:"返回表示某個日期的序號,該日期在另一個日期的數月之前/之後。",a:"返回表示某個日期的序號",m:[2,2],p:[{name:"start_date",detail:"用於計算結果的參照日期。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"months",detail:"用於計算的起始日期之前（負）或之後（正）的月數。",example:"7",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SECOND",t:6,d:"返回時間值的秒數。秒數是0（零）到59範圍內的整數。",a:"返回時間值的秒數。秒數是0（零）到59範圍內的整數。",m:[1,1],p:[{name:"時間",detail:"用於計算秒鐘部分的時間。必須為以下值之一:指向包含日期/時間值的儲存格的引用、返回日期/時間的函數或者數位。",example:"TIME(11",require:"m",repeat:"n",type:"rangeall"}]},{n:"MINUTE",t:6,d:"以數位格式返回特定時間的分鐘部分。",a:"以數位格式返回特定時間的分鐘部分。",m:[1,1],p:[{name:"時間",detail:"用於計算分鐘部分的時間。必須為以下值之一:指向包含日期/時間值的儲存格的引用、返回日期/時間的函數或者數位。",example:"TIME(11",require:"m",repeat:"n",type:"rangeall"}]},{n:"HOUR",t:6,d:"以數位格式返回特定時間的小時部分。",a:"以數位格式返回特定時間的小時部分。",m:[1,1],p:[{name:"時間",detail:"用於計算小時部分的時間。必須為以下值之一:指向包含日期/時間值的儲存格的引用、返回日期/時間的函數或者數位。",example:"TIME(11",require:"m",repeat:"n",type:"rangeall"}]},{n:"NOW",t:6,d:"以日期值格式返回當前日期和時間。",a:"以日期值格式返回當前日期和時間。",m:[0,0],p:[]},{n:"NETWORKDAYS",t:6,d:"返回所提供的兩個日期之間的淨工作日天數。",a:"返回所提供的兩個日期之間的淨工作日天數。",m:[2,3],p:[{name:"start_date",detail:"用於計算淨工作日天數的時間段開始日期。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"用於計算淨工作日天數的時間段結束日期。",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"holidays",detail:"[可選] - 一個範圍或數組常數,其中包含作為節假日的日期序號。\n\n在節假日數組中提供的值必須是日期序號值（例如由N所返回的值）或日期值（例如由DATE、DATEVALUE或TO_DATE返回的值）。由範圍指定的值應該是標準的日期值或日期序數值。",example:"16)",require:"o",repeat:"n",type:"rangeall"}]},{n:"NETWORKDAYS_INTL",t:6,d:"返回給定的兩個日期之間的淨工作日天數（排除指定的週末和節假日）。",a:"返回給定的兩個日期之間的淨工作日天數（排除指定的週末和節假日）。",m:[2,4],p:[{name:"start_date",detail:"用於計算淨工作日天數的時間段開始日期。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"用於計算淨工作日天數的時間段結束日期。",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"weekend",detail:'[可選-預設值為1] - 用於表示哪些天為週末的數位或字串。\n字串管道:可以使用由0和1組成的字串來指定週末,串中的第一個數位字元代表週一,最後一個則代表周日。零表示這一天是工作日,1 表示這一天為週末。例如,"0000011"表示將週六和周日作為週末。\n數位管道:這種管道不使用上述字串形式,而是使用一個數位。1 =週六/周日為週末,2 =周日/週一為週末,依此類推則7 =週五/週六。11 =周日為唯一週末,12 =週一為唯一週末,依此類推則17 =週六為唯一週末。',example:"16)",require:"o",repeat:"n",type:"rangeall"},{name:"holidays",detail:"[可選] - 這是一個範圍或數組常數,其中包含作為節假日的日期。\n在節假日數組內提供的值必須為日期序數值（例如N的返回值）或日期值（例如DATE、DATEVALUE或TO_DATE的返回值）。由範圍指定的值應該是標準的日期值或日期序數值。",example:"DATE(1969",require:"o",repeat:"n",type:"rangeall"}]},{n:"ISOWEEKNUM",t:6,d:"返回給定日期在全年中的 ISO 周數。",a:"返回給定日期在全年中的 ISO 周數。",m:[1,1],p:[{name:"date",detail:"用於日期和時間計算的日期-時間程式碼。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"WEEKNUM",t:6,d:"返回特定日期的周數。",a:"返回特定日期的周數。",m:[1,2],p:[{name:"serial_number",detail:"要確定其位於第幾周的日期,必須是對包含日期的儲存格的引用、返回日期類型的函數或者數位。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"return_type",detail:"[可選-預設值為1 ] - 代表一周起始日的數位,系統也使用該數位來確定一年的第一周（1=周日,2=週一）。",example:"7",require:"o",repeat:"n",type:"rangenumber"}]},{n:"WEEKDAY",t:6,d:"返回一個數位,對應於給定日期所在的星期幾。",a:"返回一個數位,對應於給定日期所在的星期幾。",m:[1,2],p:[{name:"serial_number",detail:"要為其確定星期幾的日期。必須是對包含日期的儲存格的引用、返回日期類型的函數或者數位。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"return_type",detail:"[可選-預設值為1] -以數位訓示使用哪種編號順序來表示星期幾。默認情况下,按星期日（= 1）開始計算。\n\n如果類型為1,則星期值將從星期日開始算起,並且星期日的值為1,囙此星期六的值就是7。\n\n如果類型為2,則星期值將從星期一開始算起,並且星期一的值為1,囙此星期日的值就是7。\n\n如果類型為3,則星期值將從星期一算起,並且星期一的值為0,囙此星期日的值就是6。",example:"7",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DAY",t:6,d:"以數位格式返回特定日期所在的當月幾號。",a:"以數位格式返回特定日期所在的當月幾號。",m:[1,1],p:[{name:"serial_number",detail:"要從中選取具體幾號的日期。必須是以下一種:對包含日期的儲存格的引用、返回日期類型的函數或者數位。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"DAYS",t:6,d:"返回兩個日期之間的天數。",a:"返回兩個日期之間的天數。",m:[2,2],p:[{name:"end_date",detail:"計算中要使用的結束日期。必須是以下一種:對包含日期的儲存格的引用、返回日期類型的函數或者數位。",example:"2011-3-15",require:"m",repeat:"n",type:"rangeall"},{name:"start_date",detail:"計算中要使用的開始日期。必須是以下一種:對包含日期的儲存格的引用、返回日期類型的函數或者數位。",example:"2011-2-1",require:"m",repeat:"n",type:"rangeall"}]},{n:"DAYS360",t:6,d:"按照每年360天,返回兩個日期之間的差（用於計算利息）。",a:"按照每年360天,返回兩個日期之間的差（用於計算利息）。",m:[2,3],p:[{name:"start_date",detail:"計算中要使用的開始日期。必須是以下一種:對包含日期的儲存格的引用、返回日期類型的函數或者數位。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"計算中要使用的結束日期。必須是以下一種:對包含日期的儲存格的引用、返回日期類型的函數或者數位。",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"method",detail:"[可選 - 默認為FALSE（）] - 訓示要使用哪種天數計算方法。\n\nFALSE -採用美國（NASD）方法時,如果起始日期為某月的最後一天,為便於計算,會將起始日期的當月幾號更改為30。此外,如果結束日期是所在月份的最後一天,而且起始日期在其所在月的30號之前,則將結束日期更改為結束日期之後那個月的第一天,否則將結束日期更改為該月的30號。\n\nTRUE -採用歐洲方法時,會將所有日期在31號的起始日期或結束日期更改為當月的30號。",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"DATE",t:6,d:"將提供的年、月、日轉換為日期。",a:"將提供的年、月、日轉換為日期。",m:[3,3],p:[{name:"year",detail:"日期的年份部分,包含一到四位數位。\n\n介於0（零）到 1899 之間,會將該值與 1900 相加來計算年份；\n\n介於 1900 到 9999 之間,將使用該數值作為年份；\n\n小於0或大於等於 10000,返回錯誤值#NUM！。",example:"1969",require:"m",repeat:"n",type:"rangenumber"},{name:"month",detail:"日期的月份部分,一個正整數或負整數。\n\n如果 month 大於 12,則 month 會將該月份數與指定年中的第一個月相加。\n\n如果 month 小於 1,month 則從指定年份的一月份開始遞減該月份數,然後再加上 1 個月。",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"day",detail:"日期的日部分,一個正整數或負整數。\n\n如果 day 大於月中指定的天數,則 day 會將天數與該月中的第一天相加。\n\n如果 day 小於1,則 day 從指定月份的第一天開始遞減該天數,然後再加上 1 天。",example:"20",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DATEVALUE",t:6,d:"將提供的日期字串轉換為日期的序號。",a:"將提供的日期字串轉換為日期的序號。",m:[1,1],p:[{name:"date_text",detail:"表示日期的字串。",example:'"1969-7-20"',require:"m",repeat:"n",type:"rangeall"}]},{n:"DATEDIF",t:6,d:"計算兩個日期之間的天數、月數或年數。",a:"計算兩個日期之間的天數、月數或年數。",m:[3,3],p:[{name:"起始日期",detail:"計算中要使用的開始日期。必須是對包含DATE值的儲存格的引用、返回DATE類型的函數或數位。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"結束日期",detail:"計算中要使用的結束日期。必須是對包含DATE值的儲存格的引用、返回DATE類型的函數或數位。",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"組織",detail:'時間組織的縮寫文字。例如"M"代表月。有效值包括:"Y"、"M"、"D"、"MD"、"YM"和"YD"。\n\n"Y":返回起始日期和結束日期之間的整年數。\n\n"M":返回起始日期和結束日期之間的整月數。\n\n"D":返回起始日期和結束日期之間的天數。\n\n"MD":返回起始日期和結束日期之間的天數（不計整月數）。\n\n"YM":返回起始日期和結束日期之間的整月數（不計整年數）。\n\n"YD":返回起始日期和結束日期之間的天數（假設起始日期和結束日期的間隔不超過一年）。',example:"16)",require:"m",repeat:"n",type:"rangeall"}]},{n:"WORKDAY",t:6,d:"指定工作日天數,計算結束日期。",a:"指定工作日天數,計算結束日期。",m:[2,3],p:[{name:"start_date",detail:"計算的開始日期。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"days",detail:"start_date之前或之後不含週末及節假日的天數。\n\n為正值將生成未來日期；\n\n為負值生成過去日期。",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"holidays",detail:"[可選] - 一個範圍或數組常數,其中包含作為節假日的日期序號。\n\n在節假日數組中提供的值必須是日期序號值（例如由N所返回的值）或日期值（例如由DATE、DATEVALUE或TO_DATE返回的值）。由範圍指定的值應該是標準的日期值或日期序數值。",example:"16)",require:"o",repeat:"n",type:"rangeall"}]},{n:"WORKDAY_INTL",t:6,d:"返回指定的若干個工作日之前或之後的日期的序號（使用自定義週末參數）。 ",a:"返回指定的若干個工作日之前或之後的日期的序號（使用自定義週末參數）。 ",m:[2,4],p:[{name:"start_date",detail:"開始日期（將被截尾取整）。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"days",detail:"start_date之前或之後的工作日的天數。\n\n正值表示未來日期；\n\n負值表示過去日期；\n\n零值表示開始日期。",example:"7",require:"m",repeat:"n",type:"rangenumber"},{name:"weekend",detail:'[可選 - 預設值為1] - 用於表示哪些天為週末的數位或字串。\n字串管道:可以使用由0和1組成的字串來指定週末,串中的第一個數位字元代表週一,最後一個則代表周日。零表示這一天是工作日,1表示這一天為週末。例如,"0000011"表示將週六和周日作為週末。\n數位管道:這種管道不使用上述字串形式,而是使用一個數位。1 =週六/周日為週末,2 =周日/週一為週末,依此類推則7 =週五/週六。11 =周日為唯一週末,12 =週一為唯一週末,依此類推則17 =週六為唯一週末。',example:"16)",require:"o",repeat:"n",type:"rangeall"},{name:"holidays",detail:"[可選] - 這是一個範圍或數組常數,其中包含作為節假日的日期。\n在節假日數組內提供的值必須為日期序數值（例如N的返回值）或日期值（例如DATE、DATEVALUE或TO_DATE的返回值）。由範圍指定的值應該是標準的日期值或日期序數值。",example:"DATE(1969",require:"o",repeat:"n",type:"rangeall"}]},{n:"YEAR",t:6,d:"返回對應於某個日期的年份。Year作為 1900 - 9999 之間的整數返回。",a:"返回對應於某個日期的年份。Year作為 1900 - 9999 之間的整數返回。",m:[1,1],p:[{name:"serial_number",detail:"用於計算年份的日期。必須是以下一種:對包含日期的儲存格的引用、返回日期類型的函數或者數位。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"YEARFRAC",t:6,d:"返回 start_date 和 end_date 之間的天數占全年天數的百分比。",a:"返回 start_date 和 end_date 之間的天數占全年天數的百分比。",m:[2,3],p:[{name:"start_date",detail:"計算中要使用的開始日期。必須是以下一種:對包含日期的儲存格的引用、返回日期類型的函數或者數位。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"end_date",detail:"計算中要使用的結束日期。必須是以下一種:對包含日期的儲存格的引用、返回日期類型的函數或者數位。",example:"7",require:"m",repeat:"n",type:"rangeall"},{name:"basis",detail:'[可選 - 默認為0] - 要使用的日計數基準類型。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',example:"16)",require:"o",repeat:"n",type:"rangenumber"}]},{n:"TODAY",t:6,d:"以日期值格式返回當前日期。",a:"以日期值格式返回當前日期。",m:[0,0],p:[]},{n:"MONTH",t:6,d:"返回日期（以序列數表示）中的月份。月份是介於1（一月）到12（十二月）之間的整數。",a:"返回日期（以序列數表示）中的月份。月份是介於1（一月）到12（十二月）之間的整數。",m:[1,1],p:[{name:"serial_number",detail:"要從中選取月份的日期。必須是以下一種:對包含日期的儲存格的引用、返回日期類型的函數或者數位。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"}]},{n:"EFFECT",t:8,d:"根據名義利率及每年的複利計息期數來計算實際年利率。",a:"根據名義利率及每年的複利計息期數來計算實際年利率。",m:[2,2],p:[{name:"nominal_rate",detail:"每年的名義利率。",example:"0.99",require:"m",repeat:"n",type:"rangenumber"},{name:"npery",detail:"每年的複利計算期數。",example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DOLLAR",t:12,d:"將數位格式設定為與語言區域相對應的貨幣格式。",a:"將數位格式設定為與語言區域相對應的貨幣格式。",m:[1,2],p:[{name:"number",detail:"要設定格式的值。",example:"1.2351",require:"m",repeat:"n",type:"rangenumber"},{name:"decimals",detail:"[可選 - 預設值為2] - 要顯示的小數位數。\n\n如果這是負數,則將數位四捨五入到小數點左側。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DOLLARDE",t:8,d:"將以整數部分和分數部分轉換為以小數部分表示的金額數位",a:"將以整數部分和分數部分轉換為以小數部分表示的金額數位",m:[2,2],p:[{name:"fractional_dollar",detail:"以整數部份和分數部分表示的數位,用小數點隔開。",example:"100.10",require:"m",repeat:"n",type:"rangenumber"},{name:"fraction",detail:"用作分數中的分母的整數。",example:"32",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DOLLARFR",t:8,d:"將小數轉換為分數表示的金額數位。",a:"將小數轉換為分數表示的金額數位。",m:[2,2],p:[{name:"decimal_dollar",detail:"小數。",example:"100.125",require:"m",repeat:"n",type:"rangenumber"},{name:"fraction",detail:"用作分數中的分母的整數。",example:"32",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DB",t:8,d:"使用固定餘額遞減法,返回指定期間內某項固定資產的折舊值。",a:"使用固定餘額遞減法,返回指定期間內某項固定資產的折舊值。",m:[4,5],p:[{name:"cost",detail:"資產原值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"折舊末尾時的值（有時也稱為資產殘值）。",example:"50",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"資產的折舊期數（有時也稱作資產的使用壽命）。",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"在使用期限內要計算折舊的折舊期。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"month",detail:"[可選 - 預設值為12] - 折舊第一年中的月數。",example:"10",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DDB",t:8,d:"用雙倍餘額遞減法,返回指定期間內某項固定資產的折舊值。",a:"用雙倍餘額遞減法,返回指定期間內某項固定資產的折舊值。",m:[4,5],p:[{name:"cost",detail:"资产原值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"折舊末尾時的值（有時也稱為資產殘值）。",example:"50",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"資產的折舊期數（有時也稱作資產的使用壽命）。",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"在使用期限內要計算折舊的折舊期。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"factor",detail:"[可選 - 預設值為2] - 折舊的遞減係數。",example:"2.25",require:"m",repeat:"n",type:"rangenumber"}]},{n:"RATE",t:8,d:"返回年金每期的利率。",a:"返回年金每期的利率。",m:[3,6],p:[{name:"nper",detail:"年金的付款總期數。",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"pmt",detail:"每期的付款金額,在年金週期內不能更改。",example:"-100",require:"m",repeat:"n",type:"rangenumber"},{name:"pv",detail:"現值即一系列未來付款當前值的總和。",example:"400",require:"m",repeat:"n",type:"rangenumber"},{name:"fv",detail:"[可選 - 預設值為0] - 未來值,或在最後一次付款後希望得到的現金餘額。",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"type",detail:"[可選 - 預設值為0] - 指定各期的付款時間是在期初還是期末。\n\n0表示期末；\n\n1表示期初。",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"guess",detail:"[可選 - 預設值為0.1] - 預期利率。",example:"0.1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"CUMPRINC",t:8,d:"基於等額分期付款和固定利率,計算投資在多個付款期內的累計本金償還額。",a:"基於等額分期付款和固定利率,計算投資在多個付款期內的累計本金償還額。",m:[6,6],p:[{name:"rate",detail:"利率。",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"nper",detail:"總付款期數。",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"pv",detail:"年金的現值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"start_period",detail:"開始累計計算的付款期序號。\n\n首期必須大於等於1。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"end_period",detail:"結束累計計算的付款期序號。\n\n末期必須大於首期。",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"type",detail:"指定各期的付款時間是在期初還是期末。\n\n0表示期末；\n\n1表示期初。",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUPNUM",t:8,d:"返回在結算日和到期日之間的付息次數，向上舍入到最近的整數",a:"返回在結算日和到期日之間的付息次數，向上舍入到最近的整數",m:[3,4],p:[{name:"settlement",detail:"有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有價證券的到期日。到期日是有價證券有效期截止時的日期。",example:"02",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:'[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"SYD",t:8,d:"返回在指定期間內資產按年限總和折舊法計算的折舊。",a:"返回在指定期間內資產按年限總和折舊法計算的折舊。",m:[4,4],p:[{name:"cost",detail:"資產原值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"折舊末尾時的值（有時也稱為資產殘值）。",example:"50",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"資產的折舊期數（有時也稱作資產的使用壽命）。",example:"10",require:"m",repeat:"n",type:"rangenumber"},{name:"period",detail:"在使用期限內要計算折舊的折舊期。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TBILLEQ",t:8,d:"基於貼現率計算美國政府短期債券的等效年化收益率。",a:"基於貼現率計算美國政府短期債券的等效年化收益率。",m:[3,3],p:[{name:"settlement",detail:"債券的結算日期,此日期為債券發行後交付給買家的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"債券的到期或結束日期,届時可將其以面值或票面價值贖回。",example:"1",require:"m",repeat:"n",type:"rangeall"},{name:"discount",detail:"債券購買時的貼現率。",example:"2)",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TBILLYIELD",t:8,d:"基於價格計算美國政府短期債券的收益率。",a:"基於價格計算美國政府短期債券的收益率。",m:[3,3],p:[{name:"settlement",detail:"債券的結算日期,此日期為債券發行後交付給買家的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"債券的到期或結束日期,届時可將其以面值或票面價值贖回。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"pr",detail:"債券的購買價格。",example:"95",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TBILLPRICE",t:8,d:"基於貼現率計算美國政府短期債券的價格。",a:"基於貼現率計算美國政府短期債券的價格。",m:[3,3],p:[{name:"settlement",detail:"債券的結算日期,此日期為債券發行後交付給買家的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"債券的到期或結束日期,届時可將其以面值或票面價值贖回。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"discount",detail:"債券購買時的貼現率。",example:"0.09",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PV",t:8,d:"基於等額分期付款和固定利率,計算年金投資的現值。",a:"基於等額分期付款和固定利率,計算年金投資的現值。",m:[3,5],p:[{name:"rate",detail:"各期利率。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"nper",detail:"年金的付款總期數。",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"pmt",detail:"每期的付款金額,在年金週期內不能更改。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"fv",detail:"[可選] - 未來值,或在最後一次付款後希望得到的現金餘額。",example:"D2",require:"o",repeat:"n",type:"rangenumber"},{name:"type",detail:"[可選 - 預設值為0] - 指定各期的付款時間是在期初還是期末。\n\n0表示期末；\n\n1表示期初。",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"ACCRINT",t:8,d:"返回定期付息證券的應計利息。",a:"返回定期付息證券的應計利息。",m:[6,8],p:[{name:"issue",detail:"有價證券的發行日。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"first_interest",detail:"有價證券的首次計息日。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"settlement",detail:"有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"有價證券的年息票利率。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"par",detail:"證券的票面值。",example:"10000",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:'[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示""歐洲30/360"方法"-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"calc_method",detail:"[可選 - 默認為TRUE（）] - 一個邏輯值,指定當結算日期晚於首次計息日期時用於計算總應計利息的方法。\n\n如果值為TRUE,則返回從發行日到結算日的總應計利息。\n\n如果值為FALSE,則返回從首次計息日到結算日的應計利息。",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"ACCRINTM",t:8,d:"返回在到期日支付利息的有價證券的應計利息。",a:"返回在到期日支付利息的有價證券的應計利息。",m:[4,5],p:[{name:"issue",detail:"有價證券的發行日。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"settlement",detail:"有價證券的到期日。",example:"DATE(1969",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"有價證券的年息票利率。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"par",detail:"證券的票面值。",example:"1000",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:'[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"COUPDAYBS",t:8,d:"返回從付息期開始到結算日的天數。",a:"返回從付息期開始到結算日的天數。",m:[3,4],p:[{name:"settlement",detail:"有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有價證券的到期日。到期日是有價證券有效期截止時的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:'[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPDAYS",t:8,d:"返回結算日所在的付息期的天數。",a:"返回結算日所在的付息期的天數。",m:[3,4],p:[{name:"settlement",detail:"有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有價證券的到期日。到期日是有價證券有效期截止時的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:'[可選 - 默認為0] -訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPDAYSNC",t:8,d:"返回從結算日到下一票息支付日之間的天數。",a:"返回從結算日到下一票息支付日之間的天數。",m:[3,4],p:[{name:"settlement",detail:"有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有價證券的到期日。到期日是有價證券有效期截止時的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:'[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法  - 此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPNCD",t:8,d:"計算結算日之後的下一票息或利息派發日期。",a:"計算結算日之後的下一票息或利息派發日期。",m:[3,4],p:[{name:"settlement",detail:"有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有價證券的到期日。到期日是有價證券有效期截止時的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",example:"01)",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:'[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',example:"DATE(2019",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COUPPCD",t:8,d:"計算結算日之前的最後一個票息或利息支付日。",a:"計算結算日之前的最後一個票息或利息支付日。",m:[3,4],p:[{name:"settlement",detail:"有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有價證券的到期日。到期日是有價證券有效期截止時的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"frequency",detail:"年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4 。",example:"01)",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:'[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',example:"DATE(2019",require:"o",repeat:"n",type:"rangenumber"}]},{n:"FV",t:8,d:"基於等額分期付款和固定利率,計算年金投資的未來價值。",a:"基於等額分期付款和固定利率,計算年金投資的未來價值。",m:[3,5],p:[{name:"rate",detail:"各期利率。",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"nper",detail:"年金的付款總期數。",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"pmt",detail:"各期所應支付的金額,在整個年金期間保持不變。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"pv",detail:"[可選 - 預設值為0 ] - 現值,或一系列未來付款的當前值的累積和。",example:"400",require:"m",repeat:"n",type:"rangenumber"},{name:"type",detail:"[可選 - 預設值為0 ] - 指定各期的付款時間是在期初還是期末。\n\n0表示期末；\n\n1表示期初。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"FVSCHEDULE",t:8,d:"返回應用一系列複利率計算的初始本金的未來值。",a:"返回應用一系列複利率計算的初始本金的未來值。",m:[2,2],p:[{name:"principal",detail:"現值。",example:"10000",require:"m",repeat:"n",type:"rangenumber"},{name:"schedule",detail:"用於計算本金複利的一組利率。\n\n利率錶必須是範圍或數組,其中包含要用於計算複利的一組利率。這些利率值應該以十進位小數形式表示,或者使用UNARY_PERCENT以百分比形式表示,即表示為0.09或UNARY_PERCENT（9）,而不要表示為9。",example:"A2:A100",require:"m",repeat:"n",type:"range"}]},{n:"YIELD",t:8,d:"返回定期支付利息的債券的收益率。",a:"返回定期支付利息的債券的收益率。",m:[6,7],p:[{name:"settlement",detail:"有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有價證券的到期日。到期日是有價證券有效期截止時的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"有價證券的年息票利率。",example:"0.057",require:"m",repeat:"n",type:"rangenumber"},{name:"pr",detail:"有價證券的價格。",example:"95",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"有價證券的清償價值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:'[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法 - 此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"YIELDDISC",t:8,d:"基於價格計算折價發行的（不帶息）債券的年收益率。",a:"基於價格計算折價發行的（不帶息）債券的年收益率。",m:[4,5],p:[{name:"settlement",detail:"有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有價證券的到期日。到期日是有價證券有效期截止時的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"pr",detail:"有價證券的價格。",example:"95",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"有價證券的清償價值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:'[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法 - 此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"NOMINAL",t:8,d:"基於給定的實際利率和年複利期數,返回名義年利率。",a:"基於給定的實際利率和年複利期數,返回名義年利率。",m:[2,2],p:[{name:"effect_rate",detail:"每年的實際利率。",example:"0.85",require:"m",repeat:"n",type:"rangenumber"},{name:"npery",detail:"每年的複利期數。",example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"XIRR",t:8,d:"返回一組不一定定期發生的現金流的內部收益率。",a:"返回一組不一定定期發生的現金流的內部收益率。",m:[2,3],p:[{name:"values",detail:"其中含有投資相關收益或支出的數組或範圍。\n\n現金流數額中必須至少包含一項負的和一項正的現金流金額才能計算回報率。",example:"B2:B25",require:"m",repeat:"n",type:"range"},{name:"dates",detail:"與現金流數額參數中的現金流對應的日期數組或範圍。",example:"C2:C25",require:"m",repeat:"n",type:"range"},{name:"guess",detail:"[可選 - 預設值為0.1] - 對內部回報率的估算值。",example:"250",require:"o",repeat:"n",type:"rangenumber"}]},{n:"MIRR",t:8,d:"返回一系列定期現金流的修改後內部收益率。",a:"返回一系列定期現金流的修改後內部收益率。",m:[3,3],p:[{name:"values",detail:"其中含有投資相關收益或支出的數組或範圍。\n\n現金流數額中必須至少包含一項負的和一項正的現金流金額才能計算回報率。",example:"A2:A25",require:"m",repeat:"n",type:"range"},{name:"finance_rate",detail:"現金流中使用的資金支付的利率。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"reinvest_rate",detail:"將現金流再投資的收益率。",example:"0.12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"IRR",t:8,d:"返回由值中的數位表示的一系列現金流的內部收益率。 ",a:"返回由值中的數位表示的一系列現金流的內部收益率。 ",m:[1,2],p:[{name:"values",detail:"其中含有投資相關收益或支出的數組或範圍。\n\n現金流數額中必須至少包含一項負的和一項正的現金流金額才能計算回報率。",example:"A2:A25",require:"m",repeat:"n",type:"range"},{name:"guess",detail:"[可選 - 默認為0.1] - 內部收益率的估值。",example:"200",require:"o",repeat:"n",type:"rangenumber"}]},{n:"NPV",t:8,d:"使用貼現率和一系列未來支出（負值）和收益（正值）來計算一項投資的淨現值。",a:"使用貼現率和一系列未來支出（負值）和收益（正值）來計算一項投資的淨現值。",m:[2,255],p:[{name:"rate",detail:"某一期間的貼現率。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"value1",detail:"第一筆支出（負值）和收益（正值）。",example:"200",require:"m",repeat:"n",type:"rangeall"},{name:"value2, ...",detail:"[可選] - 其他支出（負值）和收益（正值）。",example:"250",require:"o",repeat:"y",type:"rangeall"}]},{n:"XNPV",t:8,d:"返回一組現金流的淨現值,這些現金流不一定定期發生。",a:"返回一組現金流的淨現值,這些現金流不一定定期發生。",m:[3,3],p:[{name:"rate",detail:"應用於現金流的貼現率。",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"values",detail:"與dates中的支付時間相對應的一系列現金流。",example:"B2:B25",require:"m",repeat:"n",type:"range"},{name:"dates",detail:"與現金流支付相對應的支付日期錶。",example:"C2:C25",require:"m",repeat:"n",type:"range"}]},{n:"CUMIPMT",t:8,d:"基於等額分期付款和固定利率,計算投資在一系列付款期內的累計利息。",a:"基於等額分期付款和固定利率,計算投資在一系列付款期內的累計利息。",m:[6,6],p:[{name:"rate",detail:"利息率。",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"nper",detail:"總付款期數。",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"pv",detail:"現值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"start_period",detail:"開始累計計算的付款期序號。\n\n首期必須大於等於1。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"end_period",detail:"結束累計計算的付款期序號。\n\n末期必須大於首期。",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"type",detail:"指定各期的付款時間是在期初還是期末。\n\n0表示期末；\n\n1表示期初。",example:"0",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PMT",t:8,d:"用於根據固定付款額和固定利率計算貸款的付款額。",a:"用於根據固定付款額和固定利率計算貸款的付款額。",m:[3,5],p:[{name:"rate",detail:"貸款利率。",example:"0.08",require:"m",repeat:"n",type:"rangenumber"},{name:"nper",detail:"該項貸款的付款總數。",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"pv",detail:"現值,或一系列未來付款額現在所值的總額,也叫本金。",example:" 100000",require:"m",repeat:"n",type:"rangenumber"},{name:"fv",detail:"[可選 - 預設值為0] - 未來值,或在最後一次付款後希望得到的現金餘額。",example:"D2",require:"m",repeat:"n",type:"rangenumber"},{name:"type",detail:"[可選 - 預設值為0] - 指定各期的付款時間是在期初還是期末。\n\n0表示期末；\n\n1表示期初。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"IPMT",t:8,d:"基於固定利率及等額分期付款管道,返回給定期數內對投資的利息償還額。",a:"基於固定利率及等額分期付款管道,返回給定期數內對投資的利息償還額。",m:[4,6],p:[{name:"rate",detail:"各期利率。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"per",detail:"用於計算其利息數額的期數,必須在1到nper之間。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"nper",detail:"年金的付款總期數。",example:"12",require:"m",repeat:"n",type:"rangenumber"},{name:"pv",detail:"現值,或一系列未來付款的當前值的累積和。",example:"80000",require:"m",repeat:"n",type:"rangenumber"},{name:"fv",detail:"[可選 - 預設值為0] - 未來值,或在最後一次付款後希望得到的現金餘額。",example:"E2",require:"m",repeat:"n",type:"rangenumber"},{name:"type",detail:"[可選 - 預設值為0] - 指定各期的付款時間是在期初還是期末。\n\n0表示期末；\n\n1表示期初。",example:"1",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PPMT",t:8,d:"返回根據定期固定付款和固定利率而定的投資在已知期間內的本金償付額。",a:"返回根據定期固定付款和固定利率而定的投資在已知期間內的本金償付額。",m:[4,6],p:[{name:"rate",detail:"各期利率。",example:"0.1",require:"m",repeat:"n",type:"rangenumber"},{name:"per",detail:"指定期數,該值必須在 1 到 nper 範圍內。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"nper",detail:"年金的付款總期數。",example:"3*12",require:"m",repeat:"n",type:"rangenumber"},{name:"pv",detail:"現值即一系列未來付款當前值的總和。",example:"100000",require:"m",repeat:"n",type:"rangenumber"},{name:"fv",detail:"[可選 - 預設值為0] - 未來值,或在最後一次付款後希望得到的現金餘額。",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"type",detail:"[可選 - 預設值為0] - 指定各期的付款時間是在期初還是期末。\n\n0表示期末；\n\n1表示期初。",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"INTRATE",t:8,d:"返回完全投資型證券的利率。",a:"返回完全投資型證券的利率。",m:[4,5],p:[{name:"settlement",detail:"有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有價證券的到期日。到期日是有價證券有效期截止時的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"investment",detail:"有價證券的投資額。",example:"100000",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"有價證券到期時的兌換值。",example:"101200",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:'[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法 - 此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',example:"12",require:"m",repeat:"n",type:"rangenumber"}]},{n:"PRICE",t:8,d:"返回定期付息的面值￥100的有價證券的價格。",a:"返回定期付息的面值￥100的有價證券的價格。",m:[6,7],p:[{name:"settlement",detail:"有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有價證券的到期日。到期日是有價證券有效期截止時的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"有價證券的年息票利率。",example:"0.057",require:"m",repeat:"n",type:"rangenumber"},{name:"yld",detail:"有價證券的年收益率。",example:"0.065",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"面值￥100的有價證券的清償價值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:'[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法 - 此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法 - 此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PRICEDISC",t:8,d:"返回折價發行的面值￥100的有價證券的價格。",a:"返回折價發行的面值￥100的有價證券的價格。",m:[4,5],p:[{name:"settlement",detail:"有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有價證券的到期日。到期日是有價證券有效期截止時的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"discount",detail:"有价证券的贴现率。",example:"0.0525",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"面值￥100的有價證券的清償價值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:'[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法 - 此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法 - 此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"PRICEMAT",t:8,d:"返回到期付息的面值￥100的有價證券的價格。",a:"返回到期付息的面值￥100的有價證券的價格。",m:[5,6],p:[{name:"settlement",detail:"有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有價證券的到期日。到期日是有價證券有效期截止時的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"issue",detail:"有價證券的發行日。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"rate",detail:"有價證券在發行日的利率。",example:"0.061",require:"m",repeat:"n",type:"rangenumber"},{name:"yld",detail:"有價證券的年收益率。",example:"0.061",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:'[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法 - 此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法 - 此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"RECEIVED",t:8,d:"返回一次性付息的有價證券到期收回的金額。",a:"返回一次性付息的有價證券到期收回的金額。",m:[4,5],p:[{name:"settlement",detail:"有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有價證券的到期日。到期日是有價證券有效期截止時的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"investment",detail:"有價證券的投資額。",example:"10000000",require:"m",repeat:"n",type:"rangenumber"},{name:"discount",detail:"有價證券的貼現率。",example:"0.0575",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:'[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法 - 此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法 - 此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',example:"12",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DISC",t:8,d:"返回有價證券的貼現率。",a:"返回有價證券的貼現率。",m:[4,5],p:[{name:"settlement",detail:"有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有價證券的到期日。到期日是有價證券有效期截止時的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"pr",detail:"有價證券的價格（按面值為￥100計算）。",example:"97.975",require:"m",repeat:"n",type:"rangenumber"},{name:"redemption",detail:"面值￥100的有價證券的清償價值。",example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:'[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法 - 此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法 - 此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',example:"12",require:"o",repeat:"n",type:"rangenumber"}]},{n:"NPER",t:8,d:"基於固定利率及等額分期付款管道,返回某項投資的總期數。",a:"基於固定利率及等額分期付款管道,返回某項投資的總期數。",m:[3,5],p:[{name:"rate",detail:"各期利率。",example:"0.12",require:"m",repeat:"n",type:"rangenumber"},{name:"pmt",detail:"各期所應支付的金額,在整個年金期間保持不變。",example:"500",require:"m",repeat:"n",type:"rangenumber"},{name:"pv",detail:"現值,或一系列未來付款的當前值的累積和。",example:"40000",require:"m",repeat:"n",type:"rangenumber"},{name:"fv",detail:"[可選 - 預設值為0] - 未來值,或在最後一次付款後希望得到的現金餘額。",example:"0",require:"o",repeat:"n",type:"rangenumber"},{name:"type",detail:"[可選 - 預設值為0] - 指定各期的付款時間是在期初還是期末。\n\n0表示期末；\n\n1表示期初。",example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"SLN",t:8,d:"返回一個期間內的資產的直線折舊。",a:"返回一個期間內的資產的直線折舊。",m:[3,3],p:[{name:"cost",detail:"資產原值。",example:"300000",require:"m",repeat:"n",type:"rangenumber"},{name:"salvage",detail:"折舊末尾時的值（有時也稱為資產殘值）。",example:"75000",require:"m",repeat:"n",type:"rangenumber"},{name:"life",detail:"資產的折舊期數（有時也稱作資產的使用壽命）。",example:"10",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DURATION",t:8,d:"返回假設面值￥100的定期付息有價證券的修正期限。",a:"返回假設面值￥100的定期付息有價證券的修正期限。",m:[5,6],p:[{name:"settlement",detail:"有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有價證券的到期日。到期日是有價證券有效期截止時的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"coupon",detail:"有價證券的年息票利率。",example:"0.08",require:"m",repeat:"n",type:"rangenumber"},{name:"yld",detail:"有價證券的年收益率。",example:"0.09",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:'[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法 - 此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法 - 此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"MDURATION",t:8,d:"返回假設面值￥100的有價證券的Macauley修正期限。",a:"返回假設面值￥100的有價證券的Macauley修正期限。",m:[5,6],p:[{name:"settlement",detail:"有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"maturity",detail:"有價證券的到期日。到期日是有價證券有效期截止時的日期。",example:"DATE(2010",require:"m",repeat:"n",type:"rangeall"},{name:"coupon",detail:"有價證券的年息票利率。",example:"0.08",require:"m",repeat:"n",type:"rangenumber"},{name:"yld",detail:"有價證券的年收益率。",example:"0.09",require:"m",repeat:"n",type:"rangenumber"},{name:"frequency",detail:"年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"basis",detail:'[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法 - 此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法 - 此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',example:"0",require:"o",repeat:"n",type:"rangenumber"}]},{n:"BIN2DEC",t:9,d:"將二進位數轉換為十進位數。",a:"將二進位數轉換為十進位數。",m:[1,1],p:[{name:"number",detail:'要轉換為十進位數的帶符號的10位二進位數值（以字串形式提供）。\n\n帶符號的二進位數的最高位是符號位；也就是說,負數是以二的補數形式表示的。\n\n對於此函數,最大的正數輸入值為0111111111,最小的負數輸入值為1000000000。\n\n如果所提供的帶符號的二進位數是有效的二進位數,會自動將其轉換為相應的字串輸入。例如,BIN2DEC（100）和BIN2DEC（"100"）得出的結果相同,均為4。',example:"101",require:"m",repeat:"n",type:"rangeall"}]},{n:"BIN2HEX",t:9,d:"將二進位數轉換為十六進位數。",a:"將二進位數轉換為十六進位數。",m:[1,2],p:[{name:"number",detail:'要轉換為帶符號的十六進位數的帶符號的10位二進位數值（以字串形式提供）。\n\n帶符號的二進位數的最高位是符號位；也就是說,負數是以二的補數形式表示的。\n\n對於此函數,最大的正數輸入值為0111111111,最小的負數輸入值為1000000000。\n\n如果所提供的帶符號的二進位數是有效的二進位數,會自動將其轉換為相應的字串輸入。例如,BIN2HEX（11111）和BIN2HEX（"11111"）得出的結果相同,均為1F。',example:"101",require:"m",repeat:"n",type:"rangeall"},{name:"places",detail:'[ 可選 ] -結果中要確保的有效位數。\n\n如果設定的有效位數大於結果中的有效位數,則在結果的左側填充0,使總有效位數達到有效位數。例如,BIN2HEX（"11111",8）所得的結果值為0000001F。\n\n如果帶符號的二進位數的最高位為1,則忽略此值；即當提供的帶符號的二進位數大於等於1000000000時忽略此值。',example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"BIN2OCT",t:9,d:"二進位數轉換為八進制數。",a:"二進位數轉換為八進制數。",m:[1,2],p:[{name:"number",detail:'要轉換為帶符號的八進制數的帶符號的10位二進位數值（以字串形式提供）。\n\n帶符號的二進位數的最高位是符號位；也就是說,負數是以二的補數形式表示的。\n\n對於此函數,最大的正數輸入值為0111111111,最小的負數輸入值為1000000000。\n\n如果所提供的帶符號的二進位數是有效的二進位數,會自動將其轉換為相應的字串輸入。例如,BIN2OCT（11111）和BIN2OCT（"11111"）得出的結果相同,均為37。',example:"101",require:"m",repeat:"n",type:"rangeall"},{name:"places",detail:'[ 可選 ] - 結果中要確保的有效位數。\n\n如果設定的有效位數大於結果中的有效位數,則在結果的左側填充0,使總有效位數達到有效位數。例如,BIN2OCT（"11111"）得到的結果值為00000037。\n\n如果帶符號的二進位數的最高位為1,則忽略此值；即當提供的帶符號的二進位數大於等於1000000000時忽略此值。',example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DEC2BIN",t:9,d:"將十進位數轉換為二進位數。",a:"將十進位數轉換為二進位數。",m:[1,2],p:[{name:"number",detail:'要轉換為帶符號的二進位數的十進位數值（以字串形式提供）。\n\n對於此函數,最大的正數輸入值為511,最小的負數輸入值為-512。\n\n如果所提供的十進位數是有效的十進位數,會自動將其轉換為相應的字串輸入。例如,DEC2BIN（199）和DEC2BIN（"199"）得出的結果相同,均為11000111。',example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"places",detail:"[ 可選 ] - 結果中要確保的有效位數。\n\n如果設定的有效位數大於結果中的有效位數,則在結果的左側填充0,使總有效位數達到有效位數。\n\n如果十進位數為負數,則忽略此值。",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DEC2HEX",t:9,d:"將十進位數轉換為十六進位數。",a:"將十進位數轉換為十六進位數。",m:[1,2],p:[{name:"number",detail:'要轉換為帶符號的十六進位數的十進位數值（以字串形式提供）。\n\n此函數可接受的最大正數值為549755813887,最小負數值為-549755814888。\n\n如果所提供的十進位數是有效的十進位數,會自動將其轉換為相應的字串輸入。例如,DEC2HEX（100）和DEC2HEX（"100"）得出的結果相同,均為64。',example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"places",detail:"[ 可選 ] - 結果中要確保的有效位數。\n\n如果設定的有效位數大於結果中的有效位數,則在結果的左側填充0,使總有效位數達到有效位數。\n\n如果十進位數為負數,則忽略此值。",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DEC2OCT",t:9,d:"將十進位數轉換為八進制數。",a:"將十進位數轉換為八進制數。",m:[1,2],p:[{name:"number",detail:'要轉換為帶符號的八進制數的十進位數值（以字串形式提供）。\n\n此函數可接受的最大正數值為536870911,最小負數值為-53687092。\n\n如果所提供的十進位數是有效的十進位數,會自動將其轉換為相應的字串輸入。例如,DEC2OCT（199）和DEC2OCT（"199"）得出的結果相同,均為307。',example:"100",require:"m",repeat:"n",type:"rangenumber"},{name:"places",detail:"[ 可選 ] -結果中要確保的有效位數。\n\n如果設定的有效位數大於結果中的有效位數,則在結果的左側填充0,使總有效位數達到有效位數。\n\n如果十進位數為負數,則忽略此值 。",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"HEX2BIN",t:9,d:"將十六進位數轉換為二進位數。",a:"將十六進位數轉換為二進位數。",m:[1,2],p:[{name:"number",detail:'要轉換為帶符號的二進位數的帶符號的40位十六進位數值（以字串形式提供）。\n\n帶符號的十六進位數的最高位是符號位；也就是說,負數是以二的補數形式表示的。\n\n此函數可接受的最大正數值為1FF,最小負數值為FFFFFFFE00。\n\n如果所提供的帶符號的十六進位數是有效的十六進位數,函數會自動將其轉換為相應的字串輸入。例如,HEX2BIN（199）和HEX2BIN（"199"）得出的結果相同,均為110011001。',example:'"f3"',require:"m",repeat:"n",type:"rangeall"},{name:"places",detail:"[ 可選 ] - 結果中要確保的有效位數。\n\n如果設定的有效位數大於結果中的有效位數,則在結果的左側填充0,使總有效位數達到有效位數。\n\n如果帶符號的十六進位數的最高位為1,則忽略此值；即當提供的帶符號的十六進位數大於等於8000000000時忽略此值。",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"HEX2DEC",t:9,d:"將十六進位數轉換為十進位數。",a:"將十六進位數轉換為十進位數。",m:[1,1],p:[{name:"number",detail:'要轉換為十進位數的帶符號的40位十六進位數值（以字串形式提供）。\n\n帶符號的十六進位數的最高位是符號位；也就是說,負數是以二的補數形式表示的。\n\n此函數可接受的最大正數值為7fffffffff,最小負數值為8000000000。\n\n如果所提供的帶符號的十六進位數是有效的十六進位數,函數會自動將其轉換為相應的字串輸入。例如,HEX2DEC（199）和HEX2DEC（"199"）得出的結果相同,均為409 。',example:'"f3"',require:"m",repeat:"n",type:"rangeall"}]},{n:"HEX2OCT",t:9,d:"將十六進位數轉換為八進制數。",a:"將十六進位數轉換為八進制數。",m:[1,2],p:[{name:"number",detail:'要轉換為帶符號的八進制數的帶符號的40位十六進位數值（以字串形式提供）。\n\n帶符號的十六進位數的最高位是符號位；也就是說,負數是以二的補數形式表示的。\n\n此函數可接受的最大正數值為1FFFFFFF,最小負數值為FFE0000000。\n\n如果所提供的帶符號的十六進位數是有效的十六進位數,函數會自動將其轉換為相應的字串輸入。例如,HEX2OCT（199）和HEX2OCT（"199"）得出的結果相同,均為631。',example:'"f3"',require:"m",repeat:"n",type:"rangeall"},{name:"places",detail:"[ 可選 ] - 結果中要確保的有效位數。\n\n如果設定的有效位數大於結果中的有效位數,則在結果的左側填充0,使總有效位數達到有效位數。\n\n如果帶符號的十六進位數的最高位為1,則忽略此值；即當給定的帶符號的十六進位數大於等於8000000000時忽略此值。",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"OCT2BIN",t:9,d:"將八進制數轉換為二進位數。",a:"將八進制數轉換為二進位數。",m:[1,2],p:[{name:"number",detail:'要轉換為帶符號的二進位數的帶符號的30位八進制數值（以字串形式提供）。\n\n帶符號的八進制數的最高位是符號位；也就是說,負數是以二的補數形式表示的。\n\n此函數可接受的最大正數值為777,最小負數值為7777777000。\n\n如果所提供的帶符號的八進制數是有效的八進制數,函數會自動將其轉換為相應的字串輸入。例如,OCT2BIN（177）和OCT2BIN（"177"）得出的結果相同,均為1111111。',example:"37",require:"m",repeat:"n",type:"rangeall"},{name:"places",detail:"[ 可選 ] - 結果中要確保的有效位數。\n\n如果設定的有效位數大於結果中的有效位數,則在結果的左側填充0,使總有效位數達到有效位數。\n\n如果帶符號的八進制數的最高位為1,則忽略此值；即當給定的帶符號的八進制數大於等於4000000000時忽略此值。",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"OCT2DEC",t:9,d:"將八進制數轉換為十進位數。",a:"將八進制數轉換為十進位數。",m:[1,1],p:[{name:"number",detail:'要轉換為十進位數的帶符號的30位八進制數值（以字串形式提供）。\n\n帶符號的ba進制數的最高位是符號位；也就是說,負數是以二的補數形式表示的。\n\n此函數可接受的最大正數值為3777777777,最小負數值為4000000000。\n\n如果所提供的帶符號的八進制數是有效的八進制數,函數會自動將其轉換為相應的字串輸入。例如,OCT2DEC（177）和OCT2DEC（"177"）得出的結果相同,均為127。',example:"37",require:"m",repeat:"n",type:"rangeall"}]},{n:"OCT2HEX",t:9,d:"將八進制數轉換為十六進位數。",a:"將八進制數轉換為十六進位數。",m:[1,2],p:[{name:"number",detail:'要轉換為帶符號的十六進位數的帶符號的30位八進制數值（以字串形式提供）。\n\n帶符號的ba進制數的最高位是符號位；也就是說,負數是以二的補數形式表示的。\n\n此函數可接受的最大正數值為3777777777,最小負數值為4000000000。\n\n如果所提供的帶符號的八進制數是有效的八進制數,函數會自動將其轉換為相應的字串輸入。例如,OCT2HEX（177）和OCT2HEX（"177"）得出的結果相同,均為7F。',example:"37",require:"m",repeat:"n",type:"rangeall"},{name:"places",detail:"[ 可選 ] - 結果中要確保的有效位數。\n\n如果設定的有效位數大於結果中的有效位數,則在結果的左側填充0,使總有效位數達到有效位數。\n\n如果帶符號的八進制數的最高位為1,則忽略此值；即當給定的帶符號的八進制數大於等於4000000000時忽略此值。",example:"8",require:"o",repeat:"n",type:"rangenumber"}]},{n:"COMPLEX",t:9,d:"將實係數及虛係數轉換為 x+yi 或 x+yj 形式的複數。",a:"將實係數及虛係數轉換為 x+yi 或 x+yj 形式的複數。",m:[2,3],p:[{name:"real_num",detail:"複數的實係數。",example:"3",require:"m",repeat:"n",type:"rangenumber"},{name:"i_num",detail:"複數的虛係數。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"suffix",detail:'[可選 - 默認為"i"] - 複數中虛係數的尾碼。',example:'"j"',require:"o",repeat:"n",type:"rangestring"}]},{n:"IMREAL",t:9,d:"返回以 x+yi 或 x+yj 文本格式表示的複數的實係數。",a:"返回以 x+yi 或 x+yj 文本格式表示的複數的實係數。",m:[1,1],p:[{name:"inumber",detail:"需要計算其實係數的複數。",example:'"4+5i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMAGINARY",t:9,d:"返回以 x+yi 或 x+yj 文本格式表示的複數的虛係數。",a:"返回以 x+yi 或 x+yj 文本格式表示的複數的虛係數。",m:[1,1],p:[{name:"inumber",detail:"需要計算其虛係數的複數。",example:'"4+5i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMCONJUGATE",t:9,d:"返回以 x+yi 或 x+yj 文本格式表示的複數的共軛複數。",a:"返回以 x+yi 或 x+yj 文本格式表示的複數的共軛複數。",m:[1,1],p:[{name:"inumber",detail:"需要計算其共軛數的複數。",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMABS",t:9,d:"返回以 x+yi 或 x+yj 文本格式表示的複數的絕對值（模）。",a:"返回以 x+yi 或 x+yj 文本格式表示的複數的絕對值（模）。",m:[1,1],p:[{name:"inumber",detail:"要計算其絕對值的複數。",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"DELTA",t:9,d:"檢驗兩個值是否相等。如果 number1=number2,則返回1；否則返回0。",a:"檢驗兩個值是否相等。如果 number1=number2,則返回1；否則返回0。",m:[1,2],p:[{name:"number1",detail:"第一個數位。",example:"2",require:"m",repeat:"n",type:"rangenumber"},{name:"number2",detail:"[可選 - 默認為0] - 第二個數位。",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"IMSUM",t:9,d:"返回以 x+yi 或 x+yj 文本格式表示的 1 至 255 個複數的和。",a:"返回以 x+yi 或 x+yj 文本格式表示的 1 至 255 個複數的和。",m:[1,255],p:[{name:"inumber1",detail:"要相加的第一個複數",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"},{name:"inumber2, …",detail:"[可選] -要與值1相加的其他複數",example:'"5-3i"',require:"o",repeat:"y",type:"rangeall"}]},{n:"IMSUB",t:9,d:"返回以 x+yi 或 x+yj 文本格式表示的兩個複數的差。",a:"返回以 x+yi 或 x+yj 文本格式表示的兩個複數的差。",m:[2,2],p:[{name:"inumber1",detail:"從（複）數中减去 inumber2。",example:'"6+5i"',require:"m",repeat:"n",type:"rangeall"},{name:"inumber2",detail:"從 inumber1 中减（複）數。",example:'"2+3i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IMPRODUCT",t:9,d:"返回以 x+yi 或 x+yj 文本格式表示的 1 至 255 個複數的乘積。",a:"返回以 x+yi 或 x+yj 文本格式表示的 1 至 255 個複數的乘積。",m:[1,255],p:[{name:"inumber1",detail:"用於計算乘積的第一個複數",example:'"3+4i"',require:"m",repeat:"n",type:"rangeall"},{name:"inumber2, …",detail:"[可選] -要相乘的其他複數。",example:'"5-3i"',require:"o",repeat:"y",type:"rangeall"}]},{n:"IMDIV",t:9,d:"返回以 x+yi 或 x+yj 文本格式表示的兩個複數的商。",a:"返回以 x+yi 或 x+yj 文本格式表示的兩個複數的商。",m:[2,2],p:[{name:"inumber1",detail:"複數分子或被除數。",example:'"11+16i"',require:"m",repeat:"n",type:"rangeall"},{name:"inumber2",detail:"複數分母或除數。",example:'"3+2i"',require:"m",repeat:"n",type:"rangeall"}]},{n:"NOT",t:10,d:'返回某個邏輯值的相反值-"NOT（TRUE（））"將返回FALSE；"NOT（FALSE（））"將返回TRUE。',a:'返回某個邏輯值的相反值-"NOT（TRUE（））"將返回FALSE；"NOT（FALSE（））"將返回TRUE。',m:[1,1],p:[{name:"logical",detail:"計算結果為TRUE或FALSE的任何值或運算式。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"TRUE",t:10,d:"返回邏輯值 TRUE。",a:"返回邏輯值 TRUE。",m:[0,0],p:[]},{n:"FALSE",t:10,d:"返回邏輯值 FALSE。",a:"返回邏輯值 FALSE。",m:[0,0],p:[]},{n:"AND",t:10,d:"所有參數的計算結果為TRUE時,返回TRUE；只要有一個參數的計算結果為FALSE,即返回FALSE。",a:"所有參數的計算結果為TRUE時,返回TRUE；只要有一個參數的計算結果為FALSE,即返回FALSE。",m:[1,255],p:[{name:"logical1",detail:"要測試的第一個條件,其計算結果可以為TRUE或FALSE。",example:'A2 = "foo"',require:"m",repeat:"n",type:"rangeall"},{name:"logical2,...",detail:"[可選] - 要測試的其他條件,其計算結果可以為TRUE或FALSE,最多可包含255個條件。",example:'A3 = "bar"',require:"o",repeat:"y",type:"rangeall"}]},{n:"IFERROR",t:10,d:"如果第一個參數不是錯誤值,就返回第一個參數；否則,返回第二個參數。",a:"如果第一個參數不是錯誤值",m:[2,2],p:[{name:"value",detail:"檢查是否存在錯誤的參數。",example:"A1",require:"m",repeat:"n",type:"rangeall"},{name:"value_if_error",detail:"公式的計算結果錯誤時返回的值。計算以下錯誤類型:#N/A、#VALUE！、#REF！、#DIV/0！、#NUM！、#NAME？或#NULL！。",example:'"Error in cell A1"',require:"m",repeat:"n",type:"rangeall"}]},{n:"IF",t:10,d:"當邏輯運算式的值為TRUE時返回一個值,而當其為FALSE時返回另一個值。",a:"當邏輯運算式的值為TRUE時返回一個值,而當其為FALSE時返回另一個值。",m:[2,3],p:[{name:"logical_test",detail:"一個運算式或對包含運算式的儲存格的引用,該運算式代表某種邏輯值（即TRUE或FALSE）。",example:'A2 = "foo"',require:"m",repeat:"n",type:"rangeall"},{name:"value_if_true",detail:"當邏輯運算式為TRUE時的返回值。",example:'"A2 is foo"',require:"m",repeat:"n",type:"rangeall"},{name:"value_if_false",detail:"[可選 - 默認為空白] - 當邏輯運算式等於FALSE時的函數返回值。",example:'"A2 was false"',require:"o",repeat:"n",type:"rangeall"}]},{n:"OR",t:10,d:"只要有一個參數的計算結果為TRUE時,返回TRUE；所有參數的計算結果為FALSE,即返回FALSE。",a:"只要有一個參數的計算結果為TRUE時,返回TRUE；所有參數的計算結果為FALSE,即返回FALSE。",m:[1,255],p:[{name:"logical1",detail:"要測試的第一個條件,其計算結果可以為TRUE或FALSE。",example:'A2 = "foo"',require:"m",repeat:"n",type:"rangeall"},{name:"邏輯運算式2",detail:"[可選] - 其他運算式或對包含運算式的儲存格的引用,這些運算式代表某種邏輯值（即TRUE或FALSE）或者可以強制轉換為邏輯值。",example:' A3 = "bar"',require:"m",repeat:"n",type:"rangeall"}]},{n:"NE",t:11,d:'如果指定的值不相等,則返回"TRUE"；否則返回"FALSE"。相當於"<>"運算子。',a:'如果指定的值不相等,則返回"TRUE"；否則返回"FALSE"。相當於"<>"運算子。',m:[2,2],p:[{name:"value1",detail:"第一個值。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"要檢查是否與 value1 不相等的值。",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"EQ",t:11,d:'如果指定的值相等,則返回"TRUE"；否則返回"FALSE"。相當於"="運算子。',a:'如果指定的值相等,則返回"TRUE"；否則返回"FALSE"。相當於"="運算子。',m:[2,2],p:[{name:"value1",detail:"第一個值。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"要檢查是否與value1相等的值。",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"GT",t:11,d:"如果第一個參數嚴格大於第二個，則返回TRUE；否則返回FALSE。相當於">"運算子。",a:"如果第一個參數嚴格大於第二個，則返回TRUE；否則返回FALSE。相當於">"運算子。",m:[2,2],p:[{name:"value1",detail:"要測試其是否大於 value2 的值。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"第二個值。",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"GTE",t:11,d:'如果第一個參數大於或等於第二個，則返回TRUE；否則返回FALSE。相當於">="運算子。',a:'如果第一個參數大於或等於第二個，則返回TRUE；否則返回FALSE。相當於">="運算子。',m:[2,2],p:[{name:"value1",detail:"要测试其是否大于等于 value2 的值。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"第二個值。",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"LT",t:11,d:'如果第一個參數嚴格小於第二個，則返回TRUE；否則返回FALSE。相當於"<"運算子。',a:'如果第一個參數嚴格小於第二個，則返回TRUE；否則返回FALSE。相當於"<"運算子。',m:[2,2],p:[{name:"value1",detail:"要测试其是否小于 value2 的值。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"第二個值。",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"LTE",t:11,d:'如果第一個參數小於或等於第二個，則返回TRUE；否則返回FALSE。相當於"<="運算子。',a:'如果第一個參數小於或等於第二個，則返回TRUE；否則返回FALSE。相當於"<="運算子。',m:[2,2],p:[{name:"value1",detail:"要测试其是否小于等于 value2 的值。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"第二個值。",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"ADD",t:11,d:'返回兩個數值之和。相當於"+"運算子。',a:'返回兩個數值之和。相當於"+"運算子。',m:[2,2],p:[{name:"value1",detail:"第一個加數。",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"第二個加數。",example:"A3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MINUS",t:11,d:'返回兩個數值之差。相當於"-"運算子。',a:'返回兩個數值之差。相當於"-"運算子。',m:[2,2],p:[{name:"value1",detail:"被減數,即要對其計减的數值。",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"減數,即要從value1中减除的數值。",example:"A3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MULTIPLY",t:11,d:'返回兩個數的乘積。相當於"*"運算子。',a:'返回兩個數的乘積。相當於"*"運算子。',m:[2,2],p:[{name:"value1",detail:"第一個乘數。",example:"A2",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"第二個乘數。",example:"B2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DIVIDE",t:11,d:"返回兩個參數相除所得的結果。相當於`/`運算子。",a:"返回兩個參數相除所得的結果。相當於`/`運算子。",m:[2,2],p:[{name:"value1",detail:"要被除的數值。",example:"4",require:"m",repeat:"n",type:"rangenumber"},{name:"value2",detail:"用於除其他數的數值。\n\n除數不得為0。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CONCAT",t:11,d:"返回兩個值的串聯。相當於`&`運算子。",a:"返回兩個值的串聯。相當於`&`運算子。",m:[2,2],p:[{name:"value1",detail:"value2 將附於其後的值。",example:'"de"',require:"m",repeat:"n",type:"rangeall"},{name:"value2",detail:"要附於 value1 之後的值。",example:'"mystify"',require:"m",repeat:"n",type:"rangeall"}]},{n:"UNARY_PERCENT",t:11,d:'返回按百分比解釋的數值。例如,"UNARY_PERCENT（100）"等於1。',a:'返回按百分比解釋的數值。例如,"UNARY_PERCENT（100）"等於1。',m:[1,1],p:[{name:"number",detail:"要作為百分比解釋的數值。",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CONCATENATE",t:12,d:"將兩個或多個文字字串聯接為一個字串。",a:"將兩個或多個文字字串聯接為一個字串。",m:[1,255],p:[{name:"text1",detail:"初始字串。",example:'"Super"',require:"m",repeat:"n",type:"rangeall"},{name:"text2…",detail:"[可選] - 要按順序連接在一起的其他字串。",example:'"calla"',require:"o",repeat:"y",type:"rangeall"}]},{n:"CODE",t:12,d:"返回所提供的字串中首字元的Unicode映射值。",a:"返回所提供的字串中首字元的Unicode映射值。",m:[1,1],p:[{name:"text",detail:"要返回其首字元的Unicode映射值的字串。",example:'"a"',require:"m",repeat:"n",type:"rangeall"}]},{n:"CHAR",t:12,d:"按照當前Unicode編碼表,將數位轉換為對應的字元。",a:"按照當前Unicode編碼表,將數位轉換為對應的字元。",m:[1,1],p:[{name:"number",detail:"介於1到255之間的數位。",example:"97",require:"m",repeat:"n",type:"rangenumber"}]},{n:"ARABIC",t:12,d:"將羅馬數字轉換為阿拉伯數字。",a:"將羅馬數字轉換為阿拉伯數字。",m:[1,1],p:[{name:"text",detail:"要轉換格式的羅馬數字",example:'"XIV"',require:"m",repeat:"n",type:"rangeall"}]},{n:"ROMAN",t:12,d:"將數位格式設定為羅馬數字形式。",a:"將數位格式設定為羅馬數字形式。",m:[1,1],p:[{name:"number",detail:"要設定格式的數位,介於1到3999之間（包括這兩個數位）。",example:"499",require:"m",repeat:"n",type:"rangenumber"}]},{n:"REGEXEXTRACT",t:12,d:"按照規則運算式選取匹配的子串。",a:"按照規則運算式選取匹配的子串。",m:[2,2],p:[{name:"text",detail:"輸入文字。",example:'"Needle in a haystack"',require:"m",repeat:"n",type:"rangeall"},{name:"regular_expression",detail:"此函數將返回文字中符合此運算式的第一個子串。",example:'".e{2}dle"',require:"m",repeat:"n",type:"rangeall"}]},{n:"REGEXMATCH",t:12,d:"判斷一段文字是否與規則運算式相匹配。",a:"判斷一段文字是否與規則運算式相匹配。",m:[2,2],p:[{name:"text",detail:"要用規則運算式測試的文字。",example:'"Spreadsheets"',require:"m",repeat:"n",type:"rangeall"},{name:"regular_expression",detail:"用來測試文字的規則運算式。",example:'"S.r"',require:"m",repeat:"n",type:"rangeall"}]},{n:"REGEXREPLACE",t:12,d:"使用規則運算式將文字字串中的一部分替換為其他文字字串。",a:"使用規則運算式將文字字串中的一部分替換為其他文字字串。",m:[3,3],p:[{name:"text",detail:"要對其局部進行替換操作的文字。",example:'"Spreadsheets"',require:"m",repeat:"n",type:"rangeall"},{name:"regular_expression",detail:"規則運算式。text中所有匹配的實例都將被替換。",example:'"S.*d"',require:"m",repeat:"n",type:"rangeall"},{name:"replacement",detail:"要插入到原有文字中的文字。",example:'"Bed"',require:"m",repeat:"n",type:"rangeall"}]},{n:"T",t:12,d:"返回文本格式的字串參數。",a:"返回文本格式的字串參數。",m:[1,1],p:[{name:"value",detail:"要轉換為文字的參數。\n\n如果值為文字,T將返回值本身。\n\n如果值為指向包含文字的儲存格的引用,T將返回值中的內容。\n\n如果值為錯誤值或包含錯誤值的儲存格,T將返回該錯誤值。\n\n對於所有其他情况,T將返回空串。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"FIXED",t:12,d:"以固定的小數位數設定數位的格式。",a:"以固定的小數位數設定數位的格式。",m:[1,3],p:[{name:"number",detail:"要進行舍入並轉換為文字的數位。",example:"3.141592653",require:"m",repeat:"n",type:"rangenumber"},{name:"decimals",detail:"[可選-預設值為2] - 結果中要顯示的小數位數。\n\n如果數值的有效位數小於小數位數,將以零填充。如果數值的有效位數大於小數位數,則將其舍入到所需的小數位數而不是將其截斷。",example:"2",require:"o",repeat:"n",type:"rangenumber"},{name:"no_commas",detail:"[可選-預設值為FALSE（）] - 一個邏輯值,如果為TRUE（）,則會禁止FIXED在返回的文字中包含逗號。",example:"FALSE（）",require:"o",repeat:"n",type:"rangeall"}]},{n:"FIND",t:12,d:"返回字串在文字中首次出現的位置（區分大小寫）。",a:"返回字串在文字中首次出現的位置（區分大小寫）。",m:[2,3],p:[{name:"find_text",detail:"要在要蒐索的文字中查找的字串。",example:'"n"',require:"m",repeat:"n",type:"rangeall"},{name:"within_text",detail:"要在其中蒐索蒐索字串的首次出現位置的文字。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"start_num",detail:"[可選-預設值為1] - 要在要蒐索的文字中開始蒐索的字元位置。",example:"14",require:"o",repeat:"n",type:"rangenumber"}]},{n:"FINDB",t:12,d:"返回某個字串在文字中首次出現的位置（每個雙位元組字元占兩個位置）。",a:"返回某個字串在文字中首次出現的位置（每個雙位元組字元占兩個位置）。",m:[2,3],p:[{name:"find_text",detail:"要在要蒐索的文字中查找的字串。",example:'"新"',require:"m",repeat:"n",type:"rangeall"},{name:"within_text",detail:"要在其中蒐索蒐索字串的首次出現位置的文字。",example:'"農曆新年"',require:"m",repeat:"n",type:"rangeall"},{name:"start_num",detail:"[可選-預設值為1] - 要在要蒐索的文字中開始蒐索的字元位置。",example:"2",require:"o",repeat:"n",type:"rangenumber"}]},{n:"JOIN",t:12,d:"將一個或多個使用指定定界符的一維數組的元素連接到一起。",a:"將一個或多個使用指定定界符的一維數組的元素連接到一起。",m:[2,255],p:[{name:"separator",detail:"置於相互連接的值之間的字元或字串。\n\n定界符可以為空,例如JOIN（,{1,2,3}）。",example:'"and-a"',require:"m",repeat:"n",type:"rangeall"},{name:"array1",detail:"要使用定界符連接的一個或多個值。",example:"{1",require:"m",repeat:"n",type:"rangeall"},{name:"array2,…",detail:"[可選] - 要使用定界符連接的其他值或數組。",example:"2",require:"o",repeat:"y",type:"rangeall"}]},{n:"LEFT",t:12,d:"從文字字串的第一個字元開始返回指定個數的字元。",a:"從文字字串的第一個字元開始返回指定個數的字元。",m:[1,2],p:[{name:"text",detail:"包含要選取的字元的文字字串。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"num_chars",detail:"[可選-預設值為1] - 指定要由LEFT選取的字元的數量。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"RIGHT",t:12,d:"根據所指定的字元數返回文字字串中最後一個或多個字元。",a:"根據所指定的字元數返回文字字串中最後一個或多個字元。",m:[1,2],p:[{name:"text",detail:"包含要選取的字元的文字字串。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"num_chars",detail:"[可選-預設值為1] - 指定要由RIGHT選取的字元的數量。",example:"2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MID",t:12,d:"返回文字字串中從指定位置開始的特定數目的字元。",a:"返回文字字串中從指定位置開始的特定數目的字元。",m:[3,3],p:[{name:"text",detail:"包含要選取的字元的文字字串。",example:'"get this"',require:"m",repeat:"n",type:"rangeall"},{name:"start_num",detail:"要從字串中開始選取的位置。字串中第一個字元的索引為1。",example:"5",require:"m",repeat:"n",type:"rangenumber"},{name:"num_chars",detail:"指定要由MID選取的字元的數量。\n\n如果選取的字元數尚不足選取長度個字元時就到達了字串尾部,則MID返回從開始位置到字串尾部的字元。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"LEN",t:12,d:"返回給定字串的長度。",a:"返回給定字串的長度。",m:[1,1],p:[{name:"text",detail:"要返回其長度的字串。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"LENB",t:12,d:"返回文字中所包含的字元數。與雙位元組字元集（DBCS）一起使用。",a:"返回文字中所包含的字元數。與雙位元組字元集（DBCS）一起使用。",m:[1,1],p:[{name:"text",detail:"要返回其位元組數的字串。（一個漢字為兩個位元組數）",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"LOWER",t:12,d:"將指定字串中的字母轉換為小寫。",a:"將指定字串中的字母轉換為小寫。",m:[1,1],p:[{name:"text",detail:"要轉換為小寫的字串。",example:'"LOREM IPSUM"',require:"m",repeat:"n",type:"rangeall"}]},{n:"UPPER",t:12,d:"將指定字串中的字母轉換為大寫。",a:"將指定字串中的字母轉換為大寫。",m:[1,1],p:[{name:"text",detail:"要轉換為大寫的字串。",example:'"lorem ipsum"',require:"m",repeat:"n",type:"rangeall"}]},{n:"EXACT",t:12,d:"比較兩個字串是否相同。",a:"比較兩個字串是否相同。",m:[2,2],p:[{name:"text1",detail:"要比較的第一個字串。",example:"A1",require:"m",repeat:"n",type:"rangeall"},{name:"text2",detail:"要比較的第二個字串。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"REPLACE",t:12,d:"將文字字串的一部分替換為其他文字字串。",a:"將文字字串的一部分替換為其他文字字串。",m:[4,4],p:[{name:"old_text",detail:"要對其局部進行替換操作的文字。",example:'"Spreadsheets"',require:"m",repeat:"n",type:"rangeall"},{name:"start_num",detail:"開始進行替換操作的位置（文字開頭位置為1）。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"num_chars",detail:"要在文字中替換的字元個數。",example:"6",require:"m",repeat:"n",type:"rangenumber"},{name:"new_text",detail:"要插入到原有文字中的文字。",example:'"Bed"',require:"m",repeat:"n",type:"rangeall"}]},{n:"REPT",t:12,d:"返回指定文字的多次重複。",a:"返回指定文字的多次重複。",m:[2,2],p:[{name:"text",detail:"要重複的字元或字串。",example:'"ha"',require:"m",repeat:"n",type:"rangeall"},{name:"number_times",detail:"要重複的文字要在返回值中出現的次數。\n\n最大重複次數為100。即使重複次數大於100,REPT也僅將相應文字重複100次。",example:"4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SEARCH",t:12,d:"返回字串在文字中首次出現的位置（不區分大小寫）。",a:"返回字串在文字中首次出現的位置（不區分大小寫）。",m:[2,3],p:[{name:"find_text",detail:"要在要蒐索的文字中查找的字串。",example:'"n"',require:"m",repeat:"n",type:"rangeall"},{name:"within_text",detail:"要在其中蒐索蒐索字串的首次出現位置的文字。",example:"A2",require:"m",repeat:"n",type:"rangeall"},{name:"start_num",detail:"[可選-預設值為1 ] - 要在要蒐索的文字中開始蒐索的字元位置。",example:"14",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUBSTITUTE",t:12,d:"在文字字串中用new_text替換old_text。",a:"在文字字串中用new_text替換old_text。",m:[3,4],p:[{name:"text",detail:"需要替換其中字元的文字,或對含有文字（需要替換其中字元）的儲存格的引用。",example:'"search for it"',require:"m",repeat:"n",type:"rangeall"},{name:"old_text",detail:"需要替換的文字。",example:'"search for"',require:"m",repeat:"n",type:"rangeall"},{name:"new_text",detail:"用於替換old_text的文字。",example:'"Google"',require:"m",repeat:"n",type:"rangeall"},{name:"instance_num",detail:"[可選] - 指定要用new_text替換old_text的事件。如果指定了instance_num,則只有滿足要求的old_text被替換。否則,文字中出現的所有old_text都會更改為new_text。",example:"3",require:"m",repeat:"n",type:"rangenumber"}]},{n:"CLEAN",t:12,d:"移除文字中的不可列印ASCII字元後將其返回。",a:"移除文字中的不可列印ASCII字元後將其返回。",m:[1,1],p:[{name:"text",detail:"要移除其中不可列印字元的文字。",example:'"AF"&amp;CHAR（31）',require:"m",repeat:"n",type:"rangeall"}]},{n:"TEXT",t:12,d:"按照指定格式將數位轉換為文字。",a:"按照指定格式將數位轉換為文字。",m:[2,2],p:[{name:"value",detail:"要設定格式的數位、日期或時間。",example:"1.23",require:"m",repeat:"n",type:"rangenumber"},{name:"format_text",detail:'以括弧括起來的模式串,將按該模式設定數位的格式。\n\n0表示在數值位數少於格式指定的位數時必定以零填充。例如,TEXT（12.3,“000.00"）將返回012.30。當數值的小數位數超過模式指定的小數位數時,四捨五入為指定的小數位數。例如,TEXT（12.305,“00.00"）將返回12.31。\n\n#類似於0,但並不是在小數點的兩側都以零填充。例如,TEXT（12.3,“###.##"）將返回12.3。',example:'"$0.00"',require:"m",repeat:"n",type:"rangeall"}]},{n:"TRIM",t:12,d:"删除指定字串前後的空格。",a:"删除指定字串前後的空格。",m:[1,1],p:[{name:"text",detail:"要修剪的字串或指向包含該字串的儲存格的引用。",example:'"lorem ipsum"',require:"m",repeat:"n",type:"rangeall"}]},{n:"VALUE",t:12,d:"將可識別的任何日期、時間或數位格式的字串轉換為數位。",a:"將可識別的任何日期、時間或數位格式的字串轉換為數位。",m:[1,1],p:[{name:"text",detail:"包含要轉換的值的字串。",example:'"123"',require:"m",repeat:"n",type:"rangeall"}]},{n:"PROPER",t:12,d:"將指定字串中每個單詞的首字母轉為大寫。",a:"將指定字串中每個單詞的首字母轉為大寫。",m:[1,1],p:[{name:"text",detail:"要轉換的文字,其中每個單詞的首字母都將轉為大寫,所有其他字母則轉為小寫。",example:'"united states"',require:"m",repeat:"n",type:"rangeall"}]},{n:"CONVERT",t:13,d:"將數位從一種度量系統轉換為另一種度量系統。",a:"將數位從一種度量系統轉換為另一種度量系統。",m:[3,3],p:[{name:"number",detail:"是以from_unit為組織的需要進行轉換的數值。",example:"5.1",require:"m",repeat:"n",type:"rangenumber"},{name:"from_unit",detail:"是數值的組織。",example:'"g"',require:"m",repeat:"n",type:"rangeall"},{name:"to_unit",detail:"是結果的組織。",example:'"kg"',require:"m",repeat:"n",type:"rangeall"}]},{n:"SUMX2MY2",t:14,d:"返回兩數組中對應數值的平方差之和。",a:"返回兩數組中對應數值的平方差之和。",m:[2,2],p:[{name:"array_x",detail:"第一個數組或數值區域。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"array_y",detail:"第二個數組或數值區域。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMX2PY2",t:14,d:"返回兩數組中對應數值的平方和之和。",a:"返回兩數組中對應數值的平方和之和。",m:[2,2],p:[{name:"array_x",detail:"第一個數組或數值區域。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"array_y",detail:"第二個數組或數值區域。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMXMY2",t:14,d:"返回兩數組中對應數值之差的平方和。",a:"返回兩數組中對應數值之差的平方和。",m:[2,2],p:[{name:"array_x",detail:"第一個數組或數值區域。",example:"A2:A100",require:"m",repeat:"n",type:"rangenumber"},{name:"array_y",detail:"第二個數組或數值區域。",example:"B2:B100",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TRANSPOSE",t:14,d:"將數組或儲存格範圍的行列轉置。",a:"將數組或儲存格範圍的行列轉置。",m:[1,1],p:[{name:"array",detail:"要將其行列互換的數組或範圍。",example:"{1,2}",require:"m",repeat:"n",type:"range"}]},{n:"TREND",t:14,d:"返回線性趨勢值。",a:"返回線性趨勢值。",m:[1,4],p:[{name:"known_y",detail:"關係運算式y = mx + b 中已知的y值集合。\n\n如果known_y為二維陣列或範圍,則known_x的維數必須與之相同,或者省略此參數。\n\n如果known_y為一維數組或範圍,known_x則可代表二維陣列或範圍中的多個引數。也就是說,如果known_y為單行,則將known_x中的每行解釋為各自獨立的值,類似情况也適用於known_y為單列的情况。",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_x",detail:"[可選-默認該數組為{1,2,3,…},其大小與known_y相同] -關係運算式y = mx + b 中已知的可選x值集合。\n\n如果known_y為一維數組或範圍,known_x則可代表二維陣列或範圍中的多個引數。也就是說,如果known_y為單行,則將known_x中的每行解釋為各自獨立的值,類似情况也適用於known_y為單列的情况。",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"new_x",detail:"[可選 - 默認與known_x相同] - 需要函數TREND返回對應y值的新x值。",example:"A11:A13",require:"o",repeat:"n",type:"rangenumber"},{name:"const",detail:"[可選 - 預設值為TRUE（）] - 一個邏輯值,用於指定是否將常數b強制設為0。\n\nTRUE（）表示b將按正常計算；\n\nFALSE（）表示b將被設為0（零）,m 將被調整以使y = mx。",example:"TRUE（）",require:"o",repeat:"n",type:"rangeall"}]},{n:"FREQUENCY",t:14,d:"計算數值在某個區域內的出現頻率,然後返回一個垂直數組。",a:"計算數值在某個區域內的出現頻率,然後返回一個垂直數組。",m:[2,2],p:[{name:"data_array",detail:"要對其頻率進行計數的一組數值或對這組數值的引用。",example:"A2:A40",require:"m",repeat:"n",type:"rangenumber"},{name:"bins_array",detail:"要將data_array中的值插入到的間隔數組或對間隔的引用。\n\n為清晰起見,應將類別排序,但如果未排序,FREQUENCY會在內部對這些指定的值進行排序並返回正確結果。",example:"B2:B5",require:"m",repeat:"n",type:"rangenumber"}]},{n:"GROWTH",t:14,d:"使用現有數據計算預測的指數等比。",a:"使用現有數據計算預測的指數等比。",m:[1,4],p:[{name:"known_y",detail:"關係運算式y = b*m^x 中已知的y值集合。\n\n如果已知數據_y為二維陣列或範圍,則已知數據_x的維數必須與之相同,或者省略此參數。\n\n如果已知數據_y為一維數組或範圍,已知數據_x則可代表二維陣列或範圍中的多個引數。也就是說,如果已知數據_y為單行,則將已知數據_x中的每行解釋為各自獨立的值,類似情况也適用於已知數據_y為單列的情况。",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_x",detail:"[可選 - 默認該數組為{1,2,3,…},其大小與known_y相同] - 關係運算式y = b*m^x 中已知的可選x值集合。\n\n如果已知數據_y為一維數組或範圍,已知數據_x則可代表二維陣列或範圍中的多個引數。也就是說,如果已知數據_y為單行,則將已知數據_x中的每行解釋為各自獨立的值,類似情况也適用於已知數據_y為單列的情况。",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"new_x",detail:"[可選 - 默認與known_x相同] - 需要函數GROWTH返回對應y值的新x值。",example:"A11:A13",require:"o",repeat:"n",type:"rangenumber"},{name:"const",detail:"[可選 - 預設值為TRUE（）] - 一個邏輯值,用於指定是否將常數b強制設為1。\n\nTRUE（）表示b將按正常計算；\n\nFALSE（）表示b將被設為1,m將被調整以使y = m^x。",example:"TRUE（）",require:"o",repeat:"n",type:"rangeall"}]},{n:"LINEST",t:14,d:"可通過使用最小二乘法計算與現有數據最佳擬合的直線,來計算某直線的統計值,然後返回描述此直線的數組。",a:"可通過使用最小二乘法計算與現有數據最佳擬合的直線,來計算某直線的統計值,然後返回描述此直線的數組。",m:[1,4],p:[{name:"known_y",detail:"關係運算式y = mx + b 中已知的y值集合。\n\n如果known_y為二維陣列或範圍,則known_x的維數必須與之相同,或者省略此參數。\n\n如果known_y為一維數組或範圍,known_x則可代表二維陣列或範圍中的多個引數。也就是說,如果known_y為單行,則將known_x中的每行解釋為各自獨立的值,類似情况也適用於known_y為單列的情况。",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_x",detail:"[可選 - 默認該數組為{1,2,3,…},其大小與known_y相同] - 關係運算式y = mx + b中已知的可選x值集合。\n\n如果known_y為一維數組或範圍,known_x則可代表二維陣列或範圍中的多個引數。也就是說,如果known_y為單行,則將known_x中的每行解釋為各自獨立的值,類似情况也適用於known_y為單列的情况。",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"const",detail:"[可選 - 預設值為TRUE（）] - 一個邏輯值,用於指定是否將常數b強制設為0。\n\nTRUE（）表示b將按正常計算；\n\nFALSE（）表示b將被設為0（零）,m將被調整以使y = mx。",example:"TRUE（）",require:"o",repeat:"n",type:"rangeall"},{name:"stats",detail:"[可選 - 預設值為FALSE（）] - 一個邏輯值,用於指定是否返回附加回歸統計值。\n\n如果詳細為TRUE,除了對應於每個引數的一組線性係數和y截距之外,LINEST還返回以下資訊:\n\n每項係數和截距的標準誤差、\n\n限定係數（介於0和1之間,1表示完全相關）、\n\n因變數值的標准誤差、\n\nF統計或F觀測值,訓示所觀測到的因變數和引數變數之間的關係是隨機的還是線性的、\n\n自由度,用於在參照錶中查找F統計值以估算可信度、\n\n回歸平方和,以及\n\n殘差平方和。",example:"TRUE（）",require:"o",repeat:"n",type:"rangeall"}]},{n:"LOGEST",t:14,d:"在回歸分析中,計算最符合數據的指數回歸擬合曲線,並返回描述該曲線的數值數組。",a:"在回歸分析中,計算最符合數據的指數回歸擬合曲線,並返回描述該曲線的數值數組。",m:[1,4],p:[{name:"known_y",detail:"關係運算式y = mx + b 中已知的y值集合。\n\n如果known_y為二維陣列或範圍,則known_x的維數必須與之相同,或者省略此參數。\n\n如果known_y為一維數組或範圍,known_x則可代表二維陣列或範圍中的多個引數。也就是說,如果known_y為單行,則將known_x中的每行解釋為各自獨立的值,類似情况也適用於known_y為單列的情况。",example:"B2:B10",require:"m",repeat:"n",type:"rangenumber"},{name:"known_x",detail:"[可選 - 默認該數組為{1,2,3,…},其大小與known_y相同] - 關係運算式y = mx + b中已知的可選x值集合。\n\n如果known_y為一維數組或範圍,known_x則可代表二維陣列或範圍中的多個引數。也就是說,如果known_y為單行,則將known_x中的每行解釋為各自獨立的值,類似情况也適用於known_y為單列的情况。",example:"A2:A10",require:"o",repeat:"n",type:"rangenumber"},{name:"const",detail:"[可選 - 預設值為TRUE（）] - 一個邏輯值,用於指定是否將常數b強制設為0。\n\nTRUE（）表示b將按正常計算；\n\nFALSE（）表示b將被設為0（零）,m將被調整以使y = mx。",example:"TRUE（）",require:"o",repeat:"n",type:"rangeall"},{name:"stats",detail:"[可選 - 預設值為FALSE（）] - 一個邏輯值,用於指定是否返回附加回歸統計值。\n\n如果詳細為TRUE,則除了為每個引數和係數b返回一組指數值之外,LOGEST還將返回以下數據:\n\n每項指數和係數的標準誤差、\n\n限定係數（介於0和1之間,1表示完全相關）、\n\n因變數值的標准誤差、\n\nF統計或F觀測值,訓示所觀測到的因變數和引數之間的關係是隨機的還是指數的、\n\n自由度-用於在參照錶中查找F統計值以估算可信度、\n\n回歸平方和,以及\n\n殘差平方和。",example:"TRUE（）",require:"o",repeat:"n",type:"rangeall"}]},{n:"MDETERM",t:14,d:"返回一個數組的矩陣行列式的值。",a:"返回一個數組的矩陣行列式的值。",m:[1,1],p:[{name:"array",detail:"行數和列數相等的數值數組。",example:"A1:D4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MINVERSE",t:14,d:"返回數組中存儲的矩陣的逆矩陣。",a:"返回數組中存儲的矩陣的逆矩陣。",m:[1,1],p:[{name:"array",detail:"行數和列數相等的數值數組。",example:"A1:D4",require:"m",repeat:"n",type:"rangenumber"}]},{n:"MMULT",t:14,d:"返回兩個數組的矩陣乘積。結果矩陣的行數與array1的行數相同,矩陣的列數與array2的列數相同。",a:"返回兩個數組的矩陣乘積。結果矩陣的行數與array1的行數相同,矩陣的列數與array2的列數相同。",m:[2,2],p:[{name:"array1",detail:"要進行矩陣乘法運算的第一個矩陣數組。\n\narray1列數必須與array2的行數相同",example:"A1:B3",require:"m",repeat:"n",type:"rangenumber"},{name:"array2",detail:"要進行矩陣乘法運算的第二個矩陣數組。\n\narray2的行數必須與array1列數相同",example:"C1:F2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"SUMPRODUCT",t:14,d:"在給定的幾組數組中,將數組間對應的元素相乘,並返回乘積之和。",a:"在給定的幾組數組中,將數組間對應的元素相乘,並返回乘積之和。",m:[1,255],p:[{name:"array1",detail:"其相應元素需要進行相乘並求和的第一個數組參數。",example:"A2:C5",require:"m",repeat:"n",type:"rangenumber"},{name:"array2",detail:"[可選] - 其相應元素需要進行相乘並求和的其它數組參數。",example:"D2:F5",require:"o",repeat:"y",type:"rangenumber"}]},{n:"ISFORMULA",t:15,d:"檢查公式是否位於引用的儲存格中。",a:"檢查公式是否位於引用的儲存格中。",m:[1,1],p:[{name:"cell",detail:"要檢查是否存在公式的儲存格。\n\n如果 cell 為包含公式的儲存格,則 ISFORMULA 將返回TRUE。如果 cell 為相應儲存格範圍,則當該範圍內的首個儲存格包含公式時,系統會返回TRUE。如果是任何其他值,系統都將返回FALSE。",example:"A2",require:"m",repeat:"n",type:"range"}]},{n:"CELL",t:15,d:"返回有關儲存格的格式、位置或內容的資訊。",a:"返回有關儲存格的格式、位置或內容的資訊。",m:[2,2],p:[{name:"info_type",detail:"一個文字值,指定要返回的儲存格資訊的類型。",example:'"type"',require:"m",repeat:"n",type:"rangeall"},{name:"reference",detail:"需要其相關資訊的儲存格。",example:"C2",require:"m",repeat:"n",type:"range"}]},{n:"NA",t:15,d:"返回錯誤值#N/A。",a:"返回錯誤值#N/A。",m:[0,0],p:[]},{n:"ERROR_TYPE",t:15,d:"返回與其他儲存格中的錯誤值相對應的數位。",a:"返回與其他儲存格中的錯誤值相對應的數位。",m:[1,1],p:[{name:"error_val",detail:"用於查找錯誤號的儲存格,雖然您也可以直接提供錯誤值。",example:"A3",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISBLANK",t:15,d:"檢查所引用的儲存格是否為空。",a:"檢查所引用的儲存格是否為空。",m:[1,1],p:[{name:"value",detail:"對要檢查其是否為空的儲存格的引用。\n\n如果是空儲存格,則TRUE；否則返回FALSE。",example:"A2",require:"m",repeat:"n",type:"range"}]},{n:"ISERR",t:15,d:"檢查某個值是否為#N/A以外的錯誤值。",a:"檢查某個值是否為#N/A以外的錯誤值。",m:[1,1],p:[{name:"value",detail:"要驗證其是否為#N/A以外的錯誤類型的值。\n\n如果值是除#N/A之外的任何錯誤（包括#DIV/0！、#NAME？、#NULL！、#NUM！、#VALUE！和#REF！）,ISERR將返回TRUE。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISERROR",t:15,d:"檢查某個值是否為錯誤值。",a:"檢查某個值是否為錯誤值。",m:[1,1],p:[{name:"value",detail:"要驗證其是否為錯誤類型的值。\n\n只要值是某種錯誤值（包括#DIV/0！、#N/A、#NAME？、#NULL！、#NUM！、#VALUE！和#REF！）,ISERROR就會返回TRUE。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISLOGICAL",t:15,d:"檢查某個值是TRUE還是FALSE。",a:"檢查某個值是TRUE還是FALSE。",m:[1,1],p:[{name:"value",detail:"要驗證其為邏輯 TRUE 還是邏輯 FALSE 的值。\n\n*如果值為TRUE或FALSE,或為指向值為TRUE或FALSE的儲存格的引用,ISLOGICAL將返回TRUE。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISNA",t:15,d:"檢查某個值是否為錯誤值#N/A。",a:"檢查某個值是否為錯誤值#N/A。",m:[1,1],p:[{name:"value",detail:"要與錯誤值#N/A進行比較的值。\n\n*如果值為#N/A或指向包含#N/A的儲存格的引用,則ISNA將返回TRUE,否則返回FALSE。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISNONTEXT",t:15,d:"檢查某個值是否為非文字。",a:"檢查某個值是否為非文字。",m:[1,1],p:[{name:"value",detail:"要檢查的文字。\n\n*如果參數為文字值或指向包含文字的儲存格的引用,ISNONTEXT將返回FALSE,否則返回TRUE。\n\n當值為指向空儲存格的引用時,ISNONTEXT會返回TRUE。\n\n當值為空字串時,ISNONTEXT將返回FALSE,因為空串被視作文字。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISNUMBER",t:15,d:"檢查某個值是否為數位。",a:"檢查某個值是否為數位。",m:[1,1],p:[{name:"value",detail:"要驗證其是否為數位的值。\n\n*如果參數為數位或指向內容為數位值的儲存格的引用,ISNUMBER將返回TRUE,否則返回FALSE。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISREF",t:15,d:"檢查某個值是否為有效的儲存格引用。",a:"檢查某個值是否為有效的儲存格引用。",m:[1,1],p:[{name:"value",detail:"要驗證其是否為儲存格引用的值。\n\n*如果參數是有效的儲存格引用,ISREF將返回TRUE,否則返回FALSE。",example:"A2",require:"m",repeat:"n",type:"range"}]},{n:"ISTEXT",t:15,d:"檢查某個值是否為文字。",a:"檢查某個值是否為文字。",m:[1,1],p:[{name:"value",detail:"要驗證其是否為文字的值。\n\n如果參數為文字值或指向包含文字值的儲存格的引用,ISTEXT將返回TRUE,否則返回FALSE。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"TYPE",t:15,d:"返回數值的類型。",a:"返回數值的類型。",m:[1,1],p:[{name:"value",detail:"要確定其類型的數據。\n\n數位返回1；\n\n文字返回2；\n\n邏輯值返回4；\n\n錯誤值返回16；\n\n數組返回64；",example:"C4",require:"m",repeat:"n",type:"rangeall"}]},{n:"N",t:15,d:"返回轉化為數值後的值。",a:"返回轉化為數值後的值。",m:[1,1],p:[{name:"value",detail:"要轉換為數位的參數。\n\n如果值為數位,則返回該數位。\n\n如果值為日期,則返回該日期的序號。\n\n如果值為TRUE,則返回1。\n\n如果值為FALSE,則返回0。\n\n如果值為錯誤值,則返回錯誤值。\n\n如果值為其他值,則返回0。",example:"A2",require:"m",repeat:"n",type:"rangeall"}]},{n:"TO_DATE",t:16,d:"將指定的數位轉換為日期。",a:"將指定的數位轉換為日期。",m:[1,1],p:[{name:"value",detail:"要轉換為日期的參數或其儲存格引用。\n\n如果值為數位或指向內容為數值的儲存格的引用,TO_DATE會將值轉換為相應的日期並返回,值代表從十二月30日到對應的日期之間的天數,\n\n負值表示對應的日期在十二月30日之前,而小數值則代表一天中從午夜算起的時間。\n如果值不是數位或指向內容為數值的儲存格的引用,則TO_DATE將在不做任何修改的情况下返回值。",example:"25405",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TO_PURE_NUMBER",t:16,d:"將給定的日期/時間、百分比、貨幣金額或其他格式的數值轉換為不帶格式的純數位。",a:"將給定的日期/時間、百分比、貨幣金額或其他格式的數值轉換為不帶格式的純數位。",m:[1,1],p:[{name:"value",detail:"要轉換為純數位的參數或其儲存格引用。\n\n如果值為數位或指向包含數值的儲存格的引用,TO_PURE_NUMBER將以不帶任何格式與解釋的形式返回值。\n\n如果值不是數位或指向內容為數值的儲存格的引用,則TO_PERCENT將在不做任何修改的情况下返回值。",example:"50%",require:"m",repeat:"n",type:"rangeall"}]},{n:"TO_TEXT",t:16,d:"將給定的數位值轉換為文本格式。",a:"將給定的數位值轉換為文本格式。",m:[1,1],p:[{name:"value",detail:"要轉換為文字的參數或其儲存格引用。\n\n如果值為數位或指向包含數值的儲存格的引用,TO_TEXT將返回字串形式的值,並保持現有格式。即原為貨幣的仍為貨幣,原為十進位數的仍為十進位數,原為百分比的仍為百分比,原為日期的仍為日期。\n\n如果值不是數位或指向內容為數值的儲存格的引用,則TO_TEXT將在不做任何修改的情况下返回值。",example:"24",require:"m",repeat:"n",type:"rangeall"}]},{n:"TO_DOLLARS",t:16,d:"將指定的數位轉換為美元金額。",a:"將指定的數位轉換為美元金額。",m:[1,1],p:[{name:"value",detail:"要轉換為美元金額的參數或其儲存格引用。\n\n如果值不是數位或指向內容為數值的儲存格的引用,則TO_DOLLARS將在不做任何修改的情况下返回值。",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"TO_PERCENT",t:16,d:"將指定的數位轉換為百分比。",a:"將指定的數位轉換為百分比。",m:[1,1],p:[{name:"value",detail:"要轉換為百分比的參數或其儲存格引用。\n\n如果值為數位或指向包含數值的儲存格的引用,TO_PERCENT會以1 = 100%為標準,將值轉換為百分比。\n\n如果值不是數位或指向內容為數值的儲存格的引用,則TO_PERCENT將在不做任何修改的情况下返回值。",example:"A2",require:"m",repeat:"n",type:"rangenumber"}]},{n:"DGET",t:17,d:"使用SQL式査詢,從清單或資料庫的列中選取符合指定條件的單個值。",a:"使用SQL式査詢,從清單或資料庫的列中選取符合指定條件的單個值。",m:[3,3],p:[{name:"database",detail:"構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DMAX",t:17,d:"使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的最大數位。",a:"使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的最大數位。",m:[3,3],p:[{name:"database",detail:"構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DMIN",t:17,d:"使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的最小數位。",a:"使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的最小數位。",m:[3,3],p:[{name:"database",detail:"構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DAVERAGE",t:17,d:"使用SQL式査詢,對清單或資料庫中滿足指定條件的記錄欄位（列）中的數值求平均值。",a:"使用SQL式査詢,對清單或資料庫中滿足指定條件的記錄欄位（列）中的數值求平均值。",m:[3,3],p:[{name:"database",detail:"構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DCOUNT",t:17,d:"使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中包含數位的儲存格的個數。",a:"使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中包含數位的儲存格的個數。",m:[3,3],p:[{name:"database",detail:"構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DCOUNTA",t:17,d:"使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的非空儲存格的個數。",a:"使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的非空儲存格的個數。",m:[3,3],p:[{name:"database",detail:"構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DPRODUCT",t:17,d:"使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的數值的乘積。",a:"使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的數值的乘積。",m:[3,3],p:[{name:"database",detail:"構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DSTDEV",t:17,d:"使用SQL式査詢,返回利用清單或資料庫中滿足指定條件的記錄欄位（列）中的數位作為一個樣本估算出的總體標準差。",a:"使用SQL式査詢,返回利用清單或資料庫中滿足指定條件的記錄欄位（列）中的數位作為一個樣本估算出的總體標準差。",m:[3,3],p:[{name:"database",detail:"構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DSTDEVP",t:17,d:"使用SQL式査詢,返回利用清單或資料庫中滿足指定條件的記錄欄位（列）中的數位作為樣本總體計算出的總體標準差。",a:"使用SQL式査詢,返回利用清單或資料庫中滿足指定條件的記錄欄位（列）中的數位作為樣本總體計算出的總體標準差。",m:[3,3],p:[{name:"database",detail:"構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DSUM",t:17,d:"使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的數位之和。",a:"使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的數位之和。",m:[3,3],p:[{name:"database",detail:"構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DVAR",t:17,d:"使用SQL式査詢,返回利用清單或資料庫中滿足指定條件的記錄欄位（列）中的數位作為一個樣本估算出的總體方差。",a:"使用SQL式査詢,返回利用清單或資料庫中滿足指定條件的記錄欄位（列）中的數位作為一個樣本估算出的總體方差。",m:[3,3],p:[{name:"database",detail:"構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"DVARP",t:17,d:"使用SQL式査詢,通過使用清單或資料庫中滿足指定條件的記錄欄位（列）中的數位計算樣本總體的樣本總體方差。",a:"使用SQL式査詢,通過使用清單或資料庫中滿足指定條件的記錄欄位（列）中的數位計算樣本總體的樣本總體方差。",m:[3,3],p:[{name:"database",detail:"構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",example:"A2:F20",require:"m",repeat:"n",type:"range"},{name:"field",detail:"指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",example:"G2",require:"m",repeat:"n",type:"rangeall"},{name:"criteria",detail:"包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",example:"A22:D23",require:"m",repeat:"n",type:"range"}]},{n:"AGE_BY_IDCARD",t:"3",d:"據中國身份證號計算出年齡。支持15位或18位身份證",a:"據中國身份證號計算出年齡",m:[1,2],p:[{name:"身份證號",example:"A1",detail:"15位或者18位的身份證號或範圍。",require:"m",repeat:"n",type:"rangeall"},{name:"截止日期",example:'"2017-10-01"',detail:"年齡計算的截止日期或範圍,默認為當日。",require:"o",repeat:"n",type:"rangedatetime"}]},{n:"SEX_BY_IDCARD",t:"3",d:"根據中國身份證號計算出性別。支持15位或18位身份證",a:"根據身份證號得到性別。",m:[1,1],p:[{name:"身份證號",example:'"31033519900101XXXX"',detail:"15位或者18位的身份證號或範圍。",require:"m",repeat:"n",type:"rangeall"}]},{n:"BIRTHDAY_BY_IDCARD",t:"3",d:"根據中國身份證號計算出生日。支持15位或18位身份證",a:"根據身份證號得到生日。",m:[1,2],p:[{name:"身份證號",example:'"31033519900101XXXX"',detail:"15位或者18位的身份證號或範圍。",require:"m",repeat:"n",type:"rangeall"},{name:"生日格式",example:"0",detail:"日期類型,默認0:[1900/01/01],1:[1900-01-01],2:[1900年1月1日]",require:"o",repeat:"n",type:"rangeall"}]},{n:"PROVINCE_BY_IDCARD",t:"3",d:"根據中國身份證號計算出籍貫的省份。支持15位或18位身份證",a:"根據身份證號得到籍貫的省份。",m:[1,1],p:[{name:"身份證號",example:'"31033519900101XXXX"',detail:"15位或者18位的身份證號或範圍。",require:"m",repeat:"n",type:"rangeall"}]},{n:"CITY_BY_IDCARD",t:"3",d:"根據中國身份證號計算出籍貫的都市。支持15位或18位身份證",a:"根據身份證號得到籍貫的都市。",m:[1,1],p:[{name:"身份證號",example:'"31033519900101XXXX"',detail:"15位或者18位的身份證號或範圍。",require:"m",repeat:"n",type:"rangeall"}]},{n:"STAR_BY_IDCARD",t:"3",d:"根據中國身份證號計算出星座。支持15位或18位身份證",a:"根據身份證號得到星座。",m:[1,1],p:[{name:"身份證號",example:'"31033519900101XXXX"',detail:"15位或者18位的身份證號或範圍。",require:"m",repeat:"n",type:"rangeall"}]},{n:"ANIMAL_BY_IDCARD",t:"3",d:"根據中國身份證號計算出生肖（鼠、牛、虎、兔…）。支持15位或18位身份證",a:"根據身份證號得到生肖。",m:[1,1],p:[{name:"身份證號",example:'"31033519900101XXXX"',detail:"15位或者18位的身份證號或範圍。",require:"m",repeat:"n",type:"rangeall"}]},{n:"ISIDCARD",t:"3",d:"驗證身份證的格式是否正確。支持15位或18位身份證",a:"驗證身份證格式正確性。",m:[1,1],p:[{name:"身份證號",example:'"31033519900101XXXX"',detail:"15位或者18位的身份證號或範圍。",require:"m",repeat:"n",type:"rangeall"}]},{n:"DM_TEXT_CUTWORD",t:"4",d:"文字分詞。把一連串文字折開為一系列單獨詞語",a:"中文文字分詞。",m:[1,2],p:[{name:"文字",example:'"我來到北京清華大學"',detail:"任意需要分詞的文字。",require:"m",repeat:"n",type:"rangeall"},{name:"分詞模式",example:"0",detail:"默認為0[精確模式]，1[全模式]，2[搜尋引擎模式]。",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DM_TEXT_TFIDF",t:"4",d:"採用tf-idf算灋進行關鍵字選取。從一連串文字中識別關鍵字",a:"tf-idf關鍵字識別。",m:[1,3],p:[{name:"文字",example:'"我來到北京清華大學"',detail:"任意需要分詞的文字。",require:"m",repeat:"n",type:"rangeall"},{name:"關鍵字個數",example:"20",detail:"算灋返回的關鍵字個數，默認20",require:"o",repeat:"n",type:"rangenumber"},{name:"語料庫",example:"1",detail:"選擇特定領域的語料庫，默認0[通用]，1[金融]，2[醫療]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DM_TEXT_TEXTRANK",t:"4",d:"採用TextRank算灋進行關鍵字選取。從一連串文字中識別關鍵字",a:"TextRank關鍵字識別。",m:[1,3],p:[{name:"文字",example:'"我來到北京清華大學"',detail:"任意需要分詞的文字。",require:"m",repeat:"n",type:"rangeall"},{name:"關鍵字個數",example:"20",detail:"算灋返回的關鍵字個數，默認20",require:"o",repeat:"n",type:"rangenumber"},{name:"語料庫",example:"1",detail:"選擇特定領域的語料庫，默認0[通用]，1[金融]，2[醫療]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_CLOSE",t:"5",d:"根據股票代碼和日期，返回A股對應股票收盤價。",a:"返回A股對應股票收盤價。",m:[1,3],p:[{name:"股票代碼",example:'"000001"',detail:"6位股票代碼，必填項。",require:"m",repeat:"n",type:"rangeall"},{name:"日期",example:"2015-01-08",detail:"股票的交易日，默認為最新交易日",require:"o",repeat:"n",type:"rangedate"},{name:"複權除權",example:"0",detail:"選擇股票的除權複權類型，默認0[前複權]，1[原始價格]，2[後複權]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_OPEN",t:"5",d:"根據股票代碼和日期，返回A股對應股票開盤價。",a:"返回A股對應股票開盤價。",m:[1,3],p:[{name:"股票代碼",example:'"000001"',detail:"6位股票代碼，必填項。",require:"m",repeat:"n",type:"rangeall"},{name:"日期",example:"2015-01-08",detail:"股票的交易日，默認為最新交易日",require:"o",repeat:"n",type:"rangedate"},{name:"複權除權",example:"0",detail:"選擇股票的除權複權類型，默認0[前複權]，1[原始價格]，2[後複權]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_MAX",t:"5",d:"根據股票代碼和日期，返回A股對應股票最高價。",a:"返回A股對應股票最高價。",m:[1,3],p:[{name:"股票代碼",example:'"000001"',detail:"6位股票代碼，必填項。",require:"m",repeat:"n",type:"rangeall"},{name:"日期",example:"2015-01-08",detail:"股票的交易日，默認為最新交易日",require:"o",repeat:"n",type:"rangedate"},{name:"複權除權",example:"0",detail:"選擇股票的除權複權類型，默認0[前複權]，1[原始價格]，2[後複權]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_MIN",t:"5",d:"根據股票代碼和日期，返回A股對應股票最低價。",a:"返回A股對應股票最低價。",m:[1,3],p:[{name:"股票代碼",example:'"000001"',detail:"6位股票代碼，必填項。",require:"m",repeat:"n",type:"rangeall"},{name:"日期",example:"2015-01-08",detail:"股票的交易日,默认为最新交易日",require:"o",repeat:"n",type:"rangedate"},{name:"複權除權",example:"0",detail:"選擇股票的除權複權類型，默認0[前複權]，1[原始價格]，2[後複權]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_VOLUMN",t:"5",d:"根據股票代碼和日期，返回A股對應股票成交量。",a:"返回A股對應股票成交量。",m:[1,3],p:[{name:"股票代碼",example:'"000001"',detail:"6位股票代碼，必填項。",require:"m",repeat:"n",type:"rangeall"},{name:"日期",example:"2015-01-08",detail:"股票的交易日，默認為最新交易日",require:"o",repeat:"n",type:"rangedate"},{name:"複權除權",example:"0",detail:"選擇股票的除權複權類型，默認0[前複權]，1[原始價格]，2[後複權]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"DATA_CN_STOCK_AMOUNT",t:"5",d:"根據股票代碼和日期，返回A股對應股票成交額。",a:"返回A股對應股票成交額。",m:[1,3],p:[{name:"股票代碼",example:'"000001"',detail:"6位股票代碼，必填項。",require:"m",repeat:"n",type:"rangeall"},{name:"日期",example:"2015-01-08",detail:"股票的交易日，默認為最新交易日",require:"o",repeat:"n",type:"rangedate"},{name:"複權除權",example:"0",detail:"選擇股票的除權複權類型，默認0[前複權]，1[原始價格]，2[後複權]",require:"o",repeat:"n",type:"rangenumber"}]},{n:"ISDATE",t:"6",d:"驗證日期的格式是否正確。支持多種日期格式",a:"驗證日期格式正確性。",m:[1,1],p:[{name:"日期",example:'"1990-01-01"',detail:"日期值,例如1990/01/01, 1990年1月1日等。",require:"m",repeat:"n",type:"rangeall"}]},{n:"LINESPLINES",t:"3",d:"生成嵌入在儲存格內的折線圖sparklines，用於描述數據的連續走勢",a:"生成儲存格折線圖",m:[1,8],p:[{name:"數據範圍",example:"A1:A20",detail:"數據範圍，數值才能被有效計算，例如A1:A20，{1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"線條顏色",example:"#2ec7c9",detail:"線圖的線條顏色，可以是否個範圍A1、色錶索引數值或者具體顏色值，設定為0或false則不顯示，支持regx、rgb、rgba等。默認#2ec7c9",require:"o",repeat:"n",type:"rangeall"},{name:"線條粗細",example:"1",detail:"折線圖線段粗細，默認為1px",require:"o",repeat:"n",type:"rangeall"},{name:"輔助線",example:"avg",detail:"一條橫線，可以是min、max、avg、median、範圍或自定義數值，默認0無",require:"o",repeat:"n",type:"rangeall"},{name:"輔助線顏色",example:"#000",detail:"輔助線的顏色設定，同線條顏色配寘，默認#000",require:"o",repeat:"n",type:"rangeall"},{name:"最大值標識",example:"#fc5c5c",detail:"標識線圖最大值，同線條顏色配寘，默認0不顯示",require:"o",repeat:"n",type:"rangeall"},{name:"最小值標識",example:"#fc5c5c",detail:"標識線圖最小值，同線條顏色配寘，默認0不顯示",require:"o",repeat:"n",type:"rangeall"},{name:"標識大小",example:"1.5",detail:"最大值和最小值的標識大小設定，默認為1.5",require:"o",repeat:"n",type:"rangeall"}]},{n:"AREASPLINES",t:"3",d:"生成嵌入在儲存格內的面積圖sparklines，一般用於描述數據的連續累積值走勢",a:"生成儲存格面積圖",m:[1,5],p:[{name:"數據範圍",example:"A1:A20",detail:"數據範圍，數值才能被有效計算，例如A1:A20，{1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"線條顏色",example:"#2ec7c9",detail:"線圖的線條顏色，可以是否個範圍A1、色錶索引數值或者具體顏色值，設定為0或false則不顯示，支持regx、rgb、rgba等。默認#2ec7c9",require:"o",repeat:"n",type:"rangeall"},{name:"填充顏色",example:"#CCF3F4",detail:"形成面積圖，同線條顏色配寘，默認0不顯示",require:"o",repeat:"n",type:"rangeall"},{name:"線條粗細",example:"1",detail:"折線圖線段粗細，默認為1px",require:"o",repeat:"n",type:"rangeall"},{name:"輔助線",example:"avg",detail:"一條橫線，可以是min、max、avg、median、範圍或自定義數值，默認0無",require:"o",repeat:"n",type:"rangeall"},{name:"輔助線顏色",example:"#000",detail:"輔助線的顏色設定，同線條顏色配寘，默認#000",require:"o",repeat:"n",type:"rangeall"}]},{n:"COLUMNSPLINES",t:"3",d:"生成嵌入在儲存格內的垂直柱狀圖sparklines，一般用於描述離散數據之間的大小情况",a:"生成儲存格垂直柱狀圖",m:[1,6],p:[{name:"數據範圍",example:"A1:A20",detail:"數據範圍，數值才能被有效計算，例如A1:A20，{1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"柱條間隔",example:"1",detail:"柱條之間的間隔距離，默認為1",require:"o",repeat:"n",type:"rangeall"},{name:"柱條顏色",example:"#fc5c5c",detail:"線圖的線條顏色，可以是否個範圍A1、色錶索引數值或者具體顏色值，設定為0或false則不顯示，支持regx、rgb、rgba等。默認#fc5c5c",require:"o",repeat:"n",type:"rangeall"},{name:"負向柱條顏色",example:"#97b552",detail:"負向柱條顏色設定，代表負值的顏色，同柱條顏色配寘，默認#97b552",require:"o",repeat:"n",type:"rangeall"},{name:"最大值",example:"100",detail:"柱圖最大值，用於規範柱圖長度，默認為自動計算false、auto、null",require:"o",repeat:"n",type:"rangeall"},{name:"色板",example:"#97b552",detail:"調色板可以單獨設定每個柱條的顏色，可設定多個，支持兩種格式:1顏色例如#000，代表第一個柱的顏色是黑色；2數值範圍:顏色，例如-2:#000表示數值為-2的柱為黑色，0:5:#000表示數值0-5的柱為黑色，默認為空",require:"o",repeat:"y",type:"rangeall"}]},{n:"STACKCOLUMNSPLINES",t:"3",d:"生成嵌入在儲存格內的累積垂直柱狀圖sparklines，一般用於描述離散數據多個維度的數值大小",a:"生成儲存格累積垂直柱狀圖",m:[1,5],p:[{name:"數據範圍",example:"A1:A20",detail:"數據範圍，數值才能被有效計算，例如A1:A20，{1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"按列堆積",example:"1",detail:"如果需要按行堆積則本項設為false或0，默認為是1",require:"o",repeat:"n",type:"rangeall"},{name:"柱條間隔",example:"1",detail:"柱條之間的間隔距離，默認為1",require:"o",repeat:"n",type:"rangeall"},{name:"最大值",example:"100",detail:"累積柱圖最大值，用於規範柱圖長度，默認為自動計算false、auto、null",require:"o",repeat:"n",type:"rangeall"},{name:"累積色板",example:"#97b552",detail:"調色板可以單獨設定每個維度的柱條顏色，可設定為A1:A10等範圍，默認為#2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",require:"o",repeat:"y",type:"rangeall"}]},{n:"BARSPLINES",t:"3",d:"生成嵌入在儲存格內的橫向條形圖sparklines，一般用於描述離散數據之間的大小情况",a:"生成儲存格橫向條形圖",m:[1,6],p:[{name:"數據範圍",example:"A1:A20",detail:"數據範圍,數值才能被有效計算，例如A1:A20, {1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"柱條間隔",example:"1",detail:"柱條之間的間隔距離，默認為1",require:"o",repeat:"n",type:"rangeall"},{name:"柱條顏色",example:"#fc5c5c",detail:"線圖的線條顏色，可以是否個範圍A1、色錶索引數值或者具體顏色值，設定為0或false則不顯示，支持regx、rgb、rgba等。默認#fc5c5c",require:"o",repeat:"n",type:"rangeall"},{name:"負向柱條顏色",example:"#97b552",detail:"負向柱條顏色設定，代表負值的顏色，同柱條顏色配寘，默認#97b552",require:"o",repeat:"n",type:"rangeall"},{name:"最大值",example:"100",detail:"柱圖最大值，用於規範柱圖長度，默認為自動計算false、auto、null",require:"o",repeat:"n",type:"rangeall"},{name:"色板",example:"#97b552",detail:"調色板可以單獨設定每個柱條的顏色，可設定多個，支持兩種格式:1顏色例如#000，代表第一個柱的顏色是黑色；2數值範圍:顏色，例如-2:#000表示數值為-2的柱為黑色，0:5:#000表示數值0-5的柱為黑色，默認為空",require:"o",repeat:"y",type:"rangeall"}]},{n:"STACKBARSPLINES",t:"3",d:"生成嵌入在儲存格內的累積橫向條形圖sparklines，一般用於描述離散數據多個維度的數值大小",a:"生成儲存格累積橫向條形圖",m:[1,5],p:[{name:"數據範圍",example:"A1:A20",detail:"數據範圍,數值才能被有效計算，例如A1:A20, {1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"按列堆積",example:"1",detail:"如果需要按行堆積則本項設為false或0，默認為是1",require:"o",repeat:"n",type:"rangeall"},{name:"柱條間隔",example:"1",detail:"柱條之間的間隔距離，默認為1",require:"o",repeat:"n",type:"rangeall"},{name:"最大值",example:"100",detail:"累積柱圖最大值，用於規範柱圖長度，默認為自動計算false、auto、null",require:"o",repeat:"n",type:"rangeall"},{name:"累積色板",example:"#97b552",detail:"調色板可以單獨設定每個維度的柱條顏色，可設定為A1:A10等範圍，默認為#2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",require:"o",repeat:"y",type:"rangeall"}]},{n:"DISCRETESPLINES",t:"3",d:"生成嵌入在儲存格內的離散圖sparklines，一般用於描述離散數據走勢",a:"生成儲存格離散圖",m:[1,4],p:[{name:"數據範圍",example:"A1:A20",detail:"數據範圍,數值才能被有效計算，例如A1:A20, {1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"分割閾值",example:"1",detail:"離散圖柱形顏色的區分，例如:該值為0，則大於0為藍色，小於0為紅色，默認為0",require:"o",repeat:"n",type:"rangeall"},{name:"閾值以上顏色",example:"#2ec7c9",detail:"線圖的線條顏色，可以是否個範圍A1、色錶索引數值或者具體顏色值，設定為0或false則不顯示，支持regx、rgb、rgba等。默認#2ec7c9",require:"o",repeat:"n",type:"rangeall"},{name:"閾值以下顏色",example:"#fc5c5c",detail:"閾值以下柱條顏色設定，同閾值以上顏色，默認#fc5c5c",require:"o",repeat:"n",type:"rangeall"}]},{n:"TRISTATESPLINES",t:"3",d:"生成嵌入在儲存格內的三態圖sparklines，一般用於描述三種態勢的走勢例如勝負平",a:"生成儲存格三態圖",m:[1,6],p:[{name:"數據範圍",example:"A1:A20",detail:"數據範圍,數值才能被有效計算，例如A1:A20, {1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"柱條間隔",example:"1",detail:"柱條之間的間隔距離，默認為1",require:"o",repeat:"n",type:"rangeall"},{name:"柱條顏色",example:"#fc5c5c",detail:"線圖的線條顏色，可以是否個範圍A1、色錶索引數值或者具體顏色值，設定為0或false則不顯示，支持regx、rgb、rgba等。默認#fc5c5c",require:"o",repeat:"n",type:"rangeall"},{name:"负向柱條顏色",example:"#97b552",detail:"負向柱條顏色設定，代表負值的顏色，同柱條顏色配寘，默認#97b552",require:"o",repeat:"n",type:"rangeall"},{name:"零值柱條顏色",example:"#999",detail:"零值柱條顏色設定，代表0值顏色，同柱條顏色配寘，默認#999",require:"o",repeat:"n",type:"rangeall"},{name:"色板",example:"#97b552",detail:"調色板可以單獨設定每個柱條的顏色，可設定多個，支持兩種格式:1顏色例如#000，代表第一個柱的顏色是黑色；2數值範圍:顏色，例如-2:#000表示數值為-2的柱為黑色，0-5:#000表示數值0-5的柱為黑色，默認為空",require:"o",repeat:"y",type:"rangeall"}]},{n:"PIESPLINES",t:"3",d:"生成嵌入在儲存格內的餅圖sparklines，一般用於描述數據占比",a:"生成儲存格餅圖",m:[1,5],p:[{name:"數據範圍",example:"A1:A20",detail:"數據範圍,數值才能被有效計算，例如A1:A20, {1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"旋轉角度",example:"0",detail:"餅圖的旋轉角度，默認為0",require:"o",repeat:"n",type:"rangeall"},{name:"餅圖邊框",example:"0",detail:"餅圖邊框大小，默認為無0",require:"o",repeat:"n",type:"rangeall"},{name:"邊框顏色",example:"#000",detail:"餅圖邊框顏色，默認為#000",require:"o",repeat:"n",type:"rangeall"},{name:"餅圖色板",example:"#97b552",detail:"調色板可以設定切片的顏色，可設定為A1:A10等範圍，默認為#2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",require:"o",repeat:"y",type:"rangeall"}]},{n:"BOXSPLINES",t:"3",d:"生成嵌入在儲存格內的箱線圖sparklines，一般用於描述數據集的統計分佈",a:"生成儲存格箱線圖",m:[1,4],p:[{name:"數據範圍",example:"A1:A20",detail:"數據範圍,數值才能被有效計算，例如A1:A20, {1,2,3,4,5}等。",require:"m",repeat:"n",type:"rangeall"},{name:"離群點比例",example:"1.5",detail:"離群點的閾值範圍，如果為0或false則不顯示，默認為1.5倍",require:"o",repeat:"n",type:"rangeall"},{name:"目標點值",example:"10",detail:"箱線圖上的目標值設定，默認為false不顯示",require:"o",repeat:"n",type:"rangeall"},{name:"數據點大小",example:"1.5",detail:"目標點和離群點的半徑大小設定，默認為1.5",require:"o",repeat:"n",type:"rangeall"}]},{n:"BULLETSPLINES",t:"3",d:"生成嵌入在儲存格內的子彈圖sparklines，一般用於描述任務達成率",a:"生成儲存格子彈圖",m:[2,3],p:[{name:"目標",example:"10",detail:"達成的目標值，數值才能被有效計算，例如A1，100等。",require:"m",repeat:"n",type:"rangeall"},{name:"實際完成",example:"8",detail:"現時完成值，數值才能被有效計算，例如A1，100等。",require:"m",repeat:"n",type:"rangeall"},{name:"對比值",example:"12",detail:"對比值，例如超額、最低、獲獎底線等，數值才能被有效計算，例如A1，100等。可以設定最多9個對比值",require:"o",repeat:"y",type:"rangeall"}]},{n:"COMPOSESPLINES",t:"3",d:"支持多個類型的圖畫在同一個儲存格，每個參數代表一個sparklines圖",a:"組合sparklines圖到一個儲存格",m:[1,1],p:[{name:"圖設定",example:"PIESPLINES(A1:A20)",detail:"sparklines圖設定，例如A1:A20，一個完成的餅圖、線圖設定等。",require:"m",repeat:"y",type:"rangeall"}]},{n:"SORT",t:"14",d:"返回數組中元素的排序數組。返回的數組與提供的數組參數形狀相同。",a:"返回數組中元素的排序數組。返回的數組與提供的數組參數形狀相同。",m:[1,4],p:[{name:"array",detail:"要排序的範圍或數組。",example:"A2:A17",require:"m",repeat:"n",type:"rangenumber"},{name:"sort_index",detail:"[可選] - 表示要排序的行或列的數位。（默認row1/col1）",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"sort_order",detail:"[可選] - 表示所需排序順序的數位；1表示昇冪（默認），-1表示降序。",example:"-1",require:"o",repeat:"n",type:"rangenumber"},{name:"by_col",detail:"[可選] - 表示所需排序方向的邏輯值；按行排序為FALSE（）（默認），按列排序為TRUE（）。",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"FILTER",t:"14",d:"基於一個布林（真/假）數組過濾一個數組。",a:"基於一個布林（真/假）數組過濾一個數組。",m:[2,3],p:[{name:"array",detail:"要篩選的數組或範圍。",example:"A5:D20",require:"m",repeat:"n",type:"range"},{name:"include",detail:"布林數組，其高度或寬度與數組相同",example:"1",require:"m",repeat:"n",type:"range"},{name:"if_empty",detail:"[可選] - 如果包含數組中的所有值都為空（filter不返回任何值），則返回的值。",example:'""',require:"o",repeat:"n",type:"rangeall"}]},{n:"UNIQUE",t:"14",d:"返回列表或區域中的唯一值的清單。",a:"返回列表或區域中的唯一值的清單。",m:[1,3],p:[{name:"array",detail:"從其返回唯一值的數組或區域。",example:"A2:B26",require:"m",repeat:"n",type:"rangenumber"},{name:"by_col",detail:"[可選] - 邏輯值，訓示如何比較；按行= FALSE（）或省略；按列= TRUE（）。",example:"TRUE()",require:"o",repeat:"n",type:"rangeall"},{name:"occurs_once",detail:"[可選] - 邏輯值，僅返回唯一值中出現一次= TRUE（）；包括所有唯一值= FALSE（）或省略。",example:"FALSE()",require:"o",repeat:"n",type:"rangeall"}]},{n:"RANDARRAY",t:"14",d:"返回0到1之間的隨機數位數組。",a:"返回0到1之間的隨機數位數組",m:[0,2],p:[{name:"rows",detail:"[可選] - 要返回的行數。",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"cols",detail:"[可選] - 要返回的列數。",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"SEQUENCE",t:"14",d:"生成數位序列的清單。",a:"生成數位序列的清單。",m:[1,4],p:[{name:"rows",detail:"要返回的行數。",example:"1",require:"m",repeat:"n",type:"rangenumber"},{name:"cols",detail:"[可選] - 要返回的列數。",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"start",detail:"[可選] - 序列中的第一個數位。",example:"1",require:"o",repeat:"n",type:"rangenumber"},{name:"step",detail:"[可選] -序列中每個序列值的增量。",example:"1",require:"o",repeat:"n",type:"rangenumber"}]},{n:"EVALUATE",t:"3",d:"對以文字表示的公式或者表達式求值，並返回結果。",a:"根據文字公式或者表達式求值。",m:[1,1],p:[{name:"公式",example:'"A1+5*2^2"',detail:"公式或表達式",require:"m",repeat:"n",type:"rangeall"}]}],toolbar:{toolbar:"工具栏",undo:"撤銷",redo:"重做",paintFormat:"格式刷",currencyFormat:"貨幣格式",percentageFormat:"百分比格式",numberDecrease:"减少小數位數",numberIncrease:"新增小數位數",moreFormats:"更多格式",font:"字體","font-size":"字型大小",bold:"粗體（Ctrl+B）",italic:"斜體（Ctrl+I）",strikethrough:"删除線（Alt+Shift+5）",underline:"底線","font-color":"文字顏色",chooseColor:"顏色選擇",resetColor:"重置顏色",customColor:"自定義",alternatingColors:"交替顏色",confirmColor:"確定顏色",cancelColor:"取消",collapse:"收起",background:"儲存格顏色",border:"邊框",borderStyle:"邊框類型","merge-cell":"合併儲存格",chooseMergeType:"選擇合併類型",horizontalAlign:"水准對齊",verticalAlign:"垂直對齊",alignment:"對齊管道",textWrap:"文字換行",textWrapMode:"換行管道",textRotate:"文字旋轉",textRotateMode:"旋轉管道",freeze:"凍結",sort:"排序",filter:"篩選",findAndReplace:"查找替換","formula-sum":"求和",autoSum:"自動求和",moreFunction:"更多函數",conditionalFormat:"條件格式",comment:"批註",pivotTable:"數據透視錶",chart:"圖表",screenshot:"截圖",splitColumn:"分列",insertImage:"插入圖片",insertLink:"插入連結",dataVerification:"數據驗證",protection:"保護工作表內容",clearText:"清除顏色選擇",noColorSelectedText:"沒有顏色被選擇",toolMore:"更多",toolLess:"少於",toolClose:"收起",toolMoreTip:"更多功能",moreOptions:"更多選項",cellFormat:"設定儲存格格式",print:"列印"},alternatingColors:{applyRange:"應用範圍",selectRange:"選擇應用範圍",header:"頁眉",footer:"頁腳",errorInfo:"不能對多重選擇區域執行此操作,請選擇單個區域,然後再試",textTitle:"格式樣式",custom:"自定義",close:"關閉",selectionTextColor:"選擇文字顏色",selectionCellColor:"選擇儲存格顏色",removeColor:"移除交替顏色",colorShow:"顏色",currentColor:"當前顏色",tipSelectRange:"請選擇交替顏色應用範圍",errorNoRange:"您選擇的應用範圍不是選區！",errorExistColors:"您選擇的應用範圍已存在交替顏色且不屬於你要編輯的應用範圍！"},button:{confirm:"確定",cancel:"取消",close:"關閉",update:"Update",delete:"Delete",insert:"新建",prevPage:"上一頁",nextPage:"下一頁",total:"總共："},paint:{start:"格式刷開啟",end:"ESC鍵退出",tipSelectRange:"請選擇需要複製格式的區域",tipNotMulti:"無法對多重選擇區域執行此操作"},format:{moreCurrency:"更多貨幣格式",moreDateTime:"更多日期與時間格式",moreNumber:"更多數位格式",titleCurrency:"貨幣格式",decimalPlaces:"小數位數",titleDateTime:"日期與時間格式",titleNumber:"數位格式"},info:{detailUpdate:"新打開",detailSave:"已恢復本地緩存",row:"行",column:"列",loading:"加载中···",copy:"副本",return:"返回",rename:"重命名",tips:"表格重命名",noName:"無標題的試算表",wait:"待更新",add:"添加",addLast:"在底部添加",backTop:"回到頂部",pageInfo:"共${total}條,${totalPage}頁,當前已顯示${currentPage}頁",nextPage:"下一頁",tipInputNumber:"請輸入數位",tipInputNumberLimit:"新增範圍限制在1-100",tipRowHeightLimit:"行高必須在0 ~ 545之間",tipColumnWidthLimit:"列寬必須在0 ~ 2038之間",pageInfoFull:"共${total}條,${totalPage}頁,已顯示全部數據"},currencyDetail:{RMB:"人民幣",USdollar:"美元",EUR:"歐元",GBP:"英鎊",HK:"港元",JPY:"日元",AlbanianLek:"阿爾巴尼亞列克",AlgerianDinar:"阿爾及利亞第納爾",Afghani:"阿富汗尼",ArgentinePeso:"阿根廷比索",UnitedArabEmiratesDirham:"阿拉伯聯合大公國迪拉姆",ArubanFlorin:"阿魯巴弗羅林",OmaniRial:"阿曼裡亞爾",Azerbaijanimanat:"阿塞拜疆馬納特",EgyptianPound:"埃及鎊",EthiopianBirr:"衣索比亞比爾",AngolaKwanza:"安哥拉寬紮",AustralianDollar:"澳大利亞元",Patacas:"澳門元",BarbadosDollar:"巴巴多斯元",PapuaNewGuineaKina:"巴布亞新幾內亞基那",BahamianDollar:"巴哈馬元",PakistanRupee:"巴基斯坦盧比",ParaguayanGuarani:"巴拉圭瓜拉尼",BahrainiDinar:"巴林第納爾",PanamanianBalboa:"巴拿馬巴波亞",Brazilianreal:"巴西裏亞伊",Belarusianruble:"白俄羅斯盧布",BermudianDollar:"百慕大元",BulgarianLev:"保加利亞列弗",IcelandKrona:"冰島克朗",BosniaHerzegovinaConvertibleMark:"波黑可兌換馬克",PolishZloty:"波蘭茲羅提",Boliviano:"玻利維亞諾",BelizeDollar:"貝裡斯元",BotswanaPula:"波劄那普拉",NotDannuzhamu:"不丹努紮姆",BurundiFranc:"布隆迪法郎",NorthKoreanWon:"朝鮮圓",DanishKrone:"丹麥克朗",EastCaribbeanDollar:"東加勒比元",DominicaPeso:"多明尼加比索",RussianRuble:"俄國盧布",EritreanNakfa:"厄利垂亞納克法",CFAfranc:"非洲金融共同體法郎",PhilippinePeso:"菲律賓比索",FijiDollar:"斐濟元",CapeVerdeEscudo:"佛得角埃斯庫多",FalklandIslandsPound:"福克蘭群島鎊",GambianDalasi:"岡比亞達拉西",Congolesefranc:"剛果法郎",ColombianPeso:"哥倫比亞比索",CostaRicanColon:"哥斯大黎加科朗",CubanPeso:"古巴比索",Cubanconvertiblepeso:"古巴可兌換比索",GuyanaDollar:"蓋亞那元",KazakhstanTenge:"哈薩克共和國堅戈",Haitiangourde:"海地古德",won:"韓元",NetherlandsAntillesGuilder:"荷屬安的列斯盾",Honduraslempiras:"洪都拉斯拉倫皮拉",DjiboutiFranc:"吉布提法郎",KyrgyzstanSom:"吉爾吉斯斯坦索姆",GuineaFranc:"幾內亞法郎",CanadianDollar:"加拿大元",GhanaianCedi:"加納塞地",Cambodianriel:"高棉瑞爾",CzechKoruna:"捷克克朗",ZimbabweDollar:"辛巴威元",QatariRiyal:"卡塔爾裡亞爾",CaymanIslandsDollar:"開曼群島元",Comorianfranc:"科摩羅法郎",KuwaitiDinar:"科威特第納爾",CroatianKuna:"克羅地亞庫納",KenyanShilling:"肯雅先令",LesothoLoti:"萊索托洛蒂",LaoKip:"老撾基普",LebanesePound:"黎巴嫩鎊",Lithuanianlitas:"立陶宛立特",LibyanDinar:"利比亞第納爾",LiberianDollar:"利比亞元",RwandaFranc:"盧安達法郎",RomanianLeu:"羅馬尼亞列伊",MalagasyAriary:"馬拉加西阿裏亞裏",MaldivianRufiyaa:"瑪律地夫拉菲亞",MalawiKwacha:"馬拉威克瓦查",MalaysianRinggit:"馬來西亞林吉特",MacedoniawearingDinar:"馬其頓戴第納爾",MauritiusRupee:"模裡西斯盧比",MauritanianOuguiya:"茅利塔尼亞烏吉亞",MongolianTugrik:"蒙古圖格裡克",BangladeshiTaka:"孟加拉塔卡",PeruvianNuevoSol:"秘魯新索爾",MyanmarKyat:"緬甸開亞特",MoldovanLeu:"莫爾達瓦列伊",MoroccanDirham:"摩洛哥迪拉姆",MozambiqueMetical:"莫三比克梅蒂卡爾",MexicanPeso:"墨西哥比索",NamibianDollar:"納米比亞元",SouthAfricanRand:"南非蘭特",SouthSudanesePound:"南蘇丹鎊",NicaraguaCordoba:"尼加拉瓜科多巴",NepaleseRupee:"尼泊爾盧比",NigerianNaira:"奈及利亞奈拉",NorwegianKrone:"挪威克朗",GeorgianLari:"喬治亞拉瑞",RMBOffshore:"人民幣（離岸）",SwedishKrona:"瑞典克朗",SwissFranc:"瑞士法郎",SerbianDinar:"塞爾維亞第納爾",SierraLeone:"塞拉里昂利昂",SeychellesRupee:"塞舌耳盧比",SaudiRiyal:"沙特裡亞爾",SaoTomeDobra:"聖多美多布拉",SaintHelenapound:"聖赫倫那群島磅",SriLankaRupee:"斯里蘭卡盧比",SwazilandLilangeni:"史瓦濟蘭裏蘭吉尼",SudanesePound:"蘇丹鎊",Surinamesedollar:"蘇利南元",SolomonIslandsDollar:"所羅門群島元",SomaliShilling:"索馬利亞先令",TajikistanSomoni:"塔吉克共和國索莫尼",PacificFranc:"太平洋法郎",ThaiBaht:"泰國銖",TanzanianShilling:"坦尚尼亞先令",TonganPaanga:"東加潘加",TrinidadandTobagoDollar:"千裡達托貝哥元",TunisianDinar:"突尼斯第納爾",TurkishLira:"土耳其里拉",VanuatuVatu:"瓦努阿圖瓦圖",GuatemalanQuetzal:"瓜地馬拉格查爾",CommissionBolivar:"委內瑞拉博利瓦",BruneiDollar:"汶萊元",UgandanShilling:"烏干達先令",UkrainianHryvnia:"烏克蘭格裡夫尼亞",UruguayanPeso:"烏拉圭比索",Uzbekistansom:"烏茲別克蘇姆",WesternSamoaTala:"薩摩亞塔拉",SingaporeDollar:"新加坡元",NT:"新臺幣",NewZealandDollar:"新西蘭元",HungarianForint:"匈牙利福林",SyrianPound:"敘利亞鎊",JamaicanDollar:"牙買加元",ArmenianDram:"亞美尼亞德拉姆",YemeniRial:"葉門裡亞爾",IraqiDinar:"伊拉克第納爾",IranianRial:"伊朗裡亞爾",NewIsraeliShekel:"以色列新謝克爾",IndianRupee:"印度盧比",IndonesianRupiah:"印尼盧比",JordanianDinar:"約旦第納爾",VND:"越南盾",ZambianKwacha:"尚比亞克瓦查",GibraltarPound:"直布羅陀鎊",ChileanPeso:"智利比索",CFAFrancBEAC:"中非金融合作法郎"},defaultFmt:function defaultFmt(currency){return[{text:"自動",value:"General",example:""},{text:"純文字",value:"@",example:""},{text:"",value:"split",example:""},{text:"數位",value:"##0.00",example:"1000.12"},{text:"百分比",value:"#0.00%",example:"12.21%"},{text:"科學計數",value:"0.00E+00",example:"1.01E+5"},{text:"",value:"split",example:""},{text:"會計",value:"".concat(currency,"(0.00)"),example:"".concat(currency,"(1200.09)")},{text:"萬元",value:"w",example:"1亿2000万2500"},{text:"貨幣",value:"".concat(currency,"0.00"),example:"".concat(currency,"1200.09")},{text:"萬元2位小數",value:"w0.00",example:"2万2500.55"},{text:"",value:"split",example:""},{text:"日期",value:"yyyy-MM-dd",example:"2017-11-29"},{text:"時間",value:"hh:mm AM/PM",example:"3:00 PM"},{text:"時間24H",value:"hh:mm",example:"15:00"},{text:"日期時間",value:"yyyy-MM-dd hh:mm AM/PM",example:"2017-11-29 3:00 PM"},{text:"日期時間24H",value:"yyyy-MM-dd hh:mm",example:"2017-11-29 15:00"},{text:"",value:"split",example:""},{text:"自定義格式",value:"fmtOtherSelf",example:"more"}];},dateFmtList:[{name:"1930-08-05",value:"yyyy-MM-dd"},{name:"1930/8/5",value:"yyyy/MM/dd"},{name:"1930年8月5日",value:'yyyy"年"M"月"d"日"'},{name:"08-05",value:"MM-dd"},{name:"8-5",value:"M-d"},{name:"8月5日",value:'M"月"d"日"'},{name:"13:30:30",value:"h:mm:ss"},{name:"13:30",value:"h:mm"},{name:"下午01:30",value:"上午/下午 hh:mm"},{name:"下午1:30",value:"上午/下午 h:mm"},{name:"下午1:30:30",value:"上午/下午 h:mm:ss"},{name:"08-05 下午01:30",value:"MM-dd 上午/下午 hh:mm"}],fontFamily:{MicrosoftYaHei:"Microsoft YaHei"},fontarray:["Times New Roman","Arial","Tahoma","Verdana","微軟雅黑","宋體","黑體","楷體","仿宋","新宋體","華文新魏","華文行楷","華文隸書"],fontjson:{"times new roman":0,arial:1,tahoma:2,verdana:3,微軟雅黑:4,"microsoft yahei":4,宋體:5,simsun:5,黑體:6,simhei:6,楷體:7,kaiti:7,仿宋:8,fangsong:8,新宋體:9,nsimsun:9,華文新魏:10,stxinwei:10,華文行楷:11,stxingkai:11,華文隸書:12,stliti:12},border:{borderTop:"上框線",borderBottom:"下框線",borderLeft:"左框線",borderRight:"右框線",borderNone:"無",borderAll:"所有",borderOutside:"外側",borderInside:"內側",borderHorizontal:"內側橫線",borderVertical:"內側分隔號",borderColor:"邊框顏色",borderSize:"邊框粗細",borderSlash:"邊框斜線"},merge:{mergeAll:"全部合併",mergeV:"垂直合併",mergeH:"水平合併",mergeCancel:"取消合併",overlappingError:"不能合併重疊區域",partiallyError:"無法對部分合併儲存格執行此操作"},align:{left:"左對齊",center:"中間對齊",right:"右對齊",top:"頂部對齊",middle:"居中對齊",bottom:"底部對齊"},textWrap:{overflow:"溢出",wrap:"自動換行",clip:"截斷"},rotation:{none:"無旋轉",angleup:"向上傾斜",angledown:"向下傾斜",vertical:"豎排文字",rotationUp:"向上90°",rotationDown:"向下90°"},freezen:{default:"凍結第一行",freezenRow:"凍結第一行",freezenColumn:"凍結第A列",freezenRC:"凍結行列",freezenRowRange:"凍結至當前行",freezenColumnRange:"凍結至當前列",freezenRCRange:"凍結至當前行列",freezenCancel:"取消凍結",noSeletionError:"没有選區",rangeRCOverErrorTitle:"凍結提醒",rangeRCOverError:"凍結窗格超過可見範圍，會導致無法正常操作，請重新設定凍結區域。"},sort:{asc:"昇冪",desc:"降序",custom:"自定義排序",hasTitle:"數據具有標題行",sortBy:"排序依據",addOthers:"添加其他排序列",close:"關閉",confirm:"排序",columnOperation:"列",secondaryTitle:"次要排序",sortTitle:"排序範圍",sortRangeTitle:"排序範圍從",sortRangeTitleTo:"到",noRangeError:"不能對多重選擇區域執行此操作,請選擇單個區域,然後再試",mergeError:"選區有合併儲存格,無法執行此操作！"},filter:{filter:"篩選",clearFilter:"清除篩選",sortByAsc:"升序排列",sortByDesc:"降序排列",filterByColor:"按顏色篩選",filterByCondition:"按條件過濾",filterByValues:"按值過濾",filiterInputNone:"無",filiterInputTip:"輸入篩選值",filiterRangeStartTip:"範圍開始",filiterRangeEndTip:"範圍结束",filterValueByAllBtn:"全選",filterValueByClearBtn:"清除",filterValueByInverseBtn:"反選",filterValueByTip:"按照值進行篩選",filterConform:"確 認",filterCancel:"取 消",conditionNone:"無",conditionCellIsNull:"儲存格為空",conditionCellNotNull:"儲存格有數據",conditionCellTextContain:"文字包含",conditionCellTextNotContain:"文字不包含",conditionCellTextStart:"文字開頭為",conditionCellTextEnd:"文字結尾為",conditionCellTextEqual:"文字等於",conditionCellDateEqual:"日期等於",conditionCellDateBefore:"日期早於",conditionCellDateAfter:"日期晚於",conditionCellGreater:"大於",conditionCellGreaterEqual:"大於等於",conditionCellLess:"小於",conditionCellLessEqual:"小于等於",conditionCellEqual:"等於",conditionCellNotEqual:"不等於",conditionCellBetween:"介於",conditionCellNotBetween:"不在其中",filiterMoreDataTip:"數據量大！請稍後",filiterMonthText:"月",filiterYearText:"年",filiterByColorTip:"按儲存格顏色篩選",filiterByTextColorTip:"按儲存格字體顏色篩選",filterContainerOneColorTip:"本列僅包含一種顏色",filterDateFormatTip:"日期格式",valueBlank:"(空白)",mergeError:"篩選選區有合併儲存格,無法執行此操作！"},rightclick:{copy:"複製",copyAs:"複製為",paste:"粘貼",insert:"插入",image:"插入圖片",link:"插入連結",delete:"删除",deleteCell:"删除儲存格",deleteSelected:"删除選中",hide:"隱藏",hideSelected:"隱藏選中",showHide:"顯示隱藏",to:"向",left:"左",right:"右",top:"上",bottom:"下",moveLeft:"左移",moveUp:"上移",add:"新增",row:"行",column:"列",width:"寬",height:"高",number:"數位",confirm:"確認",orderAZ:"升序排列",orderZA:"降序排列",clearContent:"清除內容",matrix:"矩陣操作選區",sortSelection:"排序選區",filterSelection:"篩選選區",chartGeneration:"圖表生成",firstLineTitle:"首行為標題",untitled:"無標題",array1:"一維數組",array2:"二維陣列",array3:"多元數組",diagonal:"對角線",antiDiagonal:"反對角線",diagonalOffset:"對角偏移",offset:"偏移量",boolean:"布林值",flip:"翻轉",upAndDown:"上下",leftAndRight:"左右",clockwise:"順時針",counterclockwise:"逆時針",transpose:"轉置",matrixCalculation:"矩陣計算",plus:"加",minus:"减",multiply:"乘",divided:"除",power:"次方",root:"次方根",log:"log",delete0:"删除兩端0值",removeDuplicate:"删除重複值",byRow:"按行",byCol:"按列",generateNewMatrix:"生成新矩陣",noMulti:"無法對多重選擇區域執行此操作,請選擇單個區域",cannotDeleteAllRow:"無法刪除所有行",cannotDeleteAllColumn:"無法刪除所有列",cannotDeleteRowReadOnly:"無法刪除只讀行",cannotDeleteColumnReadOnly:"無法刪除只讀列",cannotInsertOnRowReadOnly:"無法對只讀行插入",cannotInsertOnColumnReadOnly:"無法對只讀列插入",rowOverLimit:"超出10000行限制",columnOverLimit:"超出1000列限制"},comment:{insert:"新建批註",edit:"編輯批註",delete:"删除",showOne:"顯示/隱藏批註",showAll:"顯示/隱藏所有批註"},screenshot:{screenshotTipNoSelection:"請框選需要截圖的範圍",screenshotTipTitle:"提示！",screenshotTipHasMerge:"無法對合併儲存格執行此操作",screenshotTipHasMulti:"無法對多重選擇區域執行此操作",screenshotTipSuccess:"截取成功",screenshotImageName:"截圖",downLoadClose:"關閉",downLoadCopy:"複製到剪切板",downLoadBtn:"下載",browserNotTip:"下載功能IE瀏覽器不支持！",rightclickTip:"請在圖片上右鍵點擊'複製'",successTip:"已成功複製（如果粘貼失敗,請在圖片上右鍵點擊'複製圖片'）"},splitText:{splitDelimiters:"分割符號",splitOther:"其它",splitContinueSymbol:"連續分隔符號視為單個處理",splitDataPreview:"數據預覽",splitTextTitle:"文字分列",splitConfirmToExe:"此處已有數據,是否替換它？",splitSymbols:[{name:"Tab鍵",value:"Tab"},{name:"分號",value:"semicolon"},{name:"逗號",value:"comma"},{name:"空格",value:"space"}],tipNoMulti:"能對多重選擇區域執行此操作,請選擇單個區域,然後再試",tipNoMultiColumn:"一次只能轉換一列數據,選定區域可以有多行,但不能有多列,請在選定單列區域以後再試",tipNoSelect:"沒有選擇儲存格不能進行分列"},imageText:{imageSetting:"圖片設定",close:"關閉",conventional:"常規",moveCell1:"移動並調整儲存格大小",moveCell2:"移動並且不調整儲存格的大小",moveCell3:"不要移動儲存格並調整其大小",fixedPos:"固定位置",border:"邊框",width:"寬度",radius:"半徑",style:"樣式",solid:"實線",dashed:"虛線",dotted:"點狀",double:"雙線",color:"顏色"},punctuation:{tab:"Tab 鍵",semicolon:"分號",comma:"逗號",space:"空格"},findAndReplace:{find:"查找",replace:"替換",goto:"轉到",location:"定位條件",formula:"公式",date:"日期",number:"數位",string:"字元",error:"錯誤",condition:"條件格式",rowSpan:"間隔行",columnSpan:"間隔列",locationExample:"定位",lessTwoRowTip:"請選擇最少兩行",lessTwoColumnTip:"請選擇最少兩行",findTextbox:"查找内容",replaceTextbox:"替換內容",regexTextbox:"規則運算式匹配",wholeTextbox:"整詞匹配",distinguishTextbox:"區分大小寫匹配",allReplaceBtn:"全部替換",replaceBtn:"替換",allFindBtn:"查找全部",findBtn:"查找下一個",noFindTip:"沒有查找到該內容",modeTip:"該模式下不可進行此操作",searchTargetSheet:"工作表",searchTargetCell:"儲存格",searchTargetValue:"值",searchInputTip:"請輸入查找內容",noReplceTip:"沒有可替換的內容",noMatchTip:"找不到匹配項",successTip:"已經幫您蒐索並進行了${xlength}處替換",locationConstant:"常數",locationFormula:"公式",locationDate:"日期",locationDigital:"數位",locationString:"字元",locationBool:"邏輯值",locationError:"錯誤",locationNull:"空值",locationCondition:"條件格式",locationRowSpan:"間隔行",locationColumnSpan:"間隔列",locationTiplessTwoRow:"請選擇最少兩行",locationTiplessTwoColumn:"請選擇最少兩列",locationTipNotFindCell:"未找到儲存格"},sheetconfig:{delete:"删除",copy:"複製",rename:"重命名",changeColor:"更改顏色",hide:"隱藏",unhide:"取消隱藏",moveLeft:"向左移",moveRight:"向右移",resetColor:"重置顏色",cancelText:"取消",chooseText:"確定顏色",focus:"聚焦",tipNameRepeat:"籤頁的名稱不能重複！請重新修改",noMoreSheet:"工作薄內至少含有一張可視工作表。若需删除選定的工作表,請先插入一張新工作表或顯示一張隱藏的工作表。。",confirmDelete:"是否删除",redoDelete:"可以通過Ctrl+Z撤銷删除",noHide:"不能隱藏,至少保留一個sheet標籤",chartEditNoOpt:"圖表編輯模式下不允許該操作！",sheetNameSpecCharError:"名稱不能包含:[ ] :  ? * / ' \"",sheetNamecannotIsEmptyError:"名稱不能為空"},conditionformat:{conditionformat_greaterThan:"條件格式——大於",conditionformat_greaterThan_title:"為大於以下值的儲存格設定格式",conditionformat_lessThan:"條件格式——小於",conditionformat_lessThan_title:"為小於以下值的儲存格設定格式",conditionformat_between:"條件格式——介於",conditionformat_between_title:"為介於以下值的儲存格設定格式",conditionformat_equal:"條件格式——等於",conditionformat_equal_title:"為等於以下值的儲存格設定格式",conditionformat_textContains:"條件格式——文字包含",conditionformat_textContains_title:"為包含以下文字的儲存格設定格式",conditionformat_occurrenceDate:"條件格式——發生日期",conditionformat_occurrenceDate_title:"為包含以下日期的儲存格設定格式",conditionformat_duplicateValue:"條件格式——重複值",conditionformat_duplicateValue_title:"為包含以下類型值的儲存格設定格式",conditionformat_top10:"條件格式——前10項",conditionformat_top10_percent:"條件格式——前10%",conditionformat_top10_title:"為值最大的那些儲存格設定格式",conditionformat_last10:"條件格式——最後10項",conditionformat_last10_percent:"條件格式——最後10%",conditionformat_last10_title:"為值最小的那些儲存格設定格式",conditionformat_aboveAverage:"條件格式——高於平均值",conditionformat_aboveAverage_title:"為高於平均值的儲存格設定格式",conditionformat_belowAverage:"條件格式——低於平均值",conditionformat_belowAverage_title:"為低於平均值的儲存格設定格式",rule:"規則",newRule:"新建規則",editRule:"編輯規則",deleteRule:"删除規則",deleteCellRule:"清除所選儲存格的規則",deleteSheetRule:"清除整個工作表的規則",manageRules:"管理規則",showRules:"顯示其格式規則",highlightCellRules:"突出顯示儲存格規則",itemSelectionRules:"項目選取規則",conditionformatManageRules:"條件格式規則管理器",format:"格式",setFormat:"設定格式",setAs:"設定為",setAsByArea:"針對選定區域,設定為",applyRange:"應用範圍",selectRange:"點擊選擇應用範圍",selectRange_percent:"所選範圍的百分比",selectRange_average:"選定範圍的平均值",selectRange_value:"選定範圍中的數值",pleaseSelectRange:"請選擇應用範圍",selectDataRange:"點擊選擇數據範圍",selectCell:"選擇儲存格",pleaseSelectCell:"請選擇儲存格",pleaseSelectADate:"請選擇日期",pleaseEnterInteger:"請輸入一個介於1和1000之間的整數",onlySingleCell:"只能對單個儲存格進行引用",conditionValueCanOnly:"條件值只能是數位或者單個儲存格",ruleTypeItem1:"基於各自值設定所有儲存格的格式",ruleTypeItem2:"只為包含以下內容的儲存格設定格式",ruleTypeItem2_title:"只為滿足以下條件的儲存格",ruleTypeItem3:"僅對排名靠前或靠後的數值設定格式",ruleTypeItem3_title:"為以下排名內的值",ruleTypeItem4:"僅對高於或低於平均值的數值設定格式",ruleTypeItem4_title:"為滿足以下條件的值",ruleTypeItem5:"僅對唯一值或重複值設定格式",ruleTypeItem6:"使用公式確定要設置格式的單元格",formula:"公式",textColor:"文字顏色",cellColor:"儲存格顏色",confirm:"確定",confirmColor:"確定顏色",cancel:"取消",close:"關閉",clearColorSelect:"清除顏色選擇",sheet:"錶",currentSheet:"當前工作表",dataBar:"數據條",dataBarColor:"數據條顏色",gradientDataBar_1:"藍-白漸變數據條",gradientDataBar_2:"綠-白漸變數據條",gradientDataBar_3:"紅-白漸變數據條",gradientDataBar_4:"柳丁-白漸變數據條",gradientDataBar_5:"淺藍-白漸變數據條",gradientDataBar_6:"紫-白漸變數據條",solidColorDataBar_1:"藍色數據條",solidColorDataBar_2:"綠色數據條",solidColorDataBar_3:"紅色數據條",solidColorDataBar_4:"橙色數據條",solidColorDataBar_5:"淺藍色數據條",solidColorDataBar_6:"紫色數據條",colorGradation:"色階",colorGradation_1:"綠-黃-紅色階",colorGradation_2:"紅-黃-綠色階",colorGradation_3:"綠-白-紅色階",colorGradation_4:"紅-白-綠色階",colorGradation_5:"藍-白-紅色階",colorGradation_6:"紅-白-藍色階",colorGradation_7:"白-紅色階",colorGradation_8:"紅-白色階",colorGradation_9:"綠-白色階",colorGradation_10:"白-綠色階",colorGradation_11:"綠-黃色階",colorGradation_12:"黃-綠色階",icons:"圖標集",pleaseSelectIcon:"請點擊選擇一組圖標:",cellValue:"儲存格值",specificText:"特定文字",occurrenceDate:"發生日期",greaterThan:"大於",lessThan:"小於",between:"介於",equal:"等於",in:"和",to:"到",between2:"之間",contain:"包含",textContains:"文字包含",duplicateValue:"重複值",uniqueValue:"唯一值",top:"前",top10:"前10項",top10_percent:"前10%",last:"後",last10:"後10項",last10_percent:"後10%",oneself:"個",above:"高於",aboveAverage:"高於平均值",below:"低於",belowAverage:"低於平均值",all:"全部",yesterday:"昨天",today:"今天",tomorrow:"明天",lastWeek:"上周",thisWeek:"本周",lastMonth:"上月",thisMonth:"本月",lastYear:"去年",thisYear:"本年",last7days:"最近7天",last30days:"最近30天",next7days:"未來7天",next30days:"未來30天",next60days:"未來60天",chooseRuleType:"選擇規則類型",editRuleDescription:"編輯規則說明",newFormatRule:"新建格式規則",editFormatRule:"編輯格式規則",formatStyle:"格式樣式",fillType:"填充類型",color:"顏色",twocolor:"雙色",tricolor:"三色",multicolor:"彩色",grayColor:"灰色",gradient:"漸變",solid:"實心",maxValue:"最大值",medianValue:"中間值",minValue:"最小值",direction:"方向",threeWayArrow:"三向箭頭",fourWayArrow:"四向箭頭",fiveWayArrow:"五向箭頭",threeTriangles:"3個三角形",shape:"形狀",threeColorTrafficLight:"三色交通燈",fourColorTrafficLight:"四色交通燈",threeSigns:"三標誌",greenRedBlackGradient:"綠-紅-黑漸變",rimless:"無邊框",bordered:"有邊框",mark:"標記",threeSymbols:"三個符號",tricolorFlag:"三色旗",circled:"有圓圈",noCircle:"無圓圈",grade:"等級",grade4:"四等級",grade5:"五等級",threeStars:"3個星形",fiveQuadrantDiagram:"五象限圖",fiveBoxes:"5個框"},insertLink:{linkText:"文字",linkType:"連結類型",external:"外部連結",internal:"内部連結",linkAddress:"連結地址",linkSheet:"工作表",linkCell:"儲存格引用",linkTooltip:"提示",placeholder1:"請輸入網頁連結位址",placeholder2:"請輸入要引用的儲存格,例A1",placeholder3:"請輸入提示內容",tooltipInfo1:"請輸入有效的連結",tooltipInfo2:"請輸入正確的儲存格引用"},dataVerification:{cellRange:"儲存格範圍",selectCellRange:"點擊選擇儲存格範圍",selectCellRange2:"請選擇儲存格範圍",verificationCondition:"驗證條件",allowMultiSelect:"是否允許多選",dropdown:"下拉清單",checkbox:"核取方塊",number:"數位",number_integer:"數位-整數",number_decimal:"數位-小數",text_content:"文字-內容",text_length:"文字-長度",date:"日期",validity:"有效性",placeholder1:"請輸入選項,以英文逗號分隔,如1,2,3,4,5",placeholder2:"請輸入內容",placeholder3:"數值,如10",placeholder4:"請輸入指定的文字",placeholder5:"請輸入選中儲存格時顯示的提示語",selected:"選擇時",notSelected:"未選擇",between:"介於",notBetween:"不介於",equal:"等於",notEqualTo:"不等於",moreThanThe:"大於",lessThan:"小於",greaterOrEqualTo:"大於等於",lessThanOrEqualTo:"小於等於",include:"包括",exclude:"不包括",earlierThan:"早於",noEarlierThan:"不早於",laterThan:"晚於",noLaterThan:"不晚於",identificationNumber:"身份證號碼",phoneNumber:"手機號",remote:"自動遠程獲取選項",prohibitInput:"輸入數據無效時禁止輸入",hintShow:"選中儲存格時顯示提示語",deleteVerification:"删除驗證",tooltipInfo1:"下拉清單選項不可為空",tooltipInfo2:"核取方塊內容不可為空",tooltipInfo3:"輸入的值不是數值類型",tooltipInfo4:"數值2不能小於數值1",tooltipInfo5:"文字內容不能為空",tooltipInfo6:"輸入的值不是日期類型",tooltipInfo7:"日期2不能小於日期1",textlengthInteger:"文字長度必須是大於等於0的整數"},formula:{sum:"求和",average:"平均值",count:"計數",max:"最大值",min:"最小值",ifGenerate:"if公式生成器",find:"更多函數",tipNotBelongToIf:"該儲存格函數不屬於if公式!",tipSelectCell:"請選擇儲存格插入函數",ifGenCompareValueTitle:"比较值",ifGenSelectCellTitle:"點擊選擇儲存格",ifGenRangeTitle:"範圍",ifGenRangeTo:"至",ifGenRangeEvaluate:"範圍評估",ifGenSelectRangeTitle:"點擊選擇範圍",ifGenCutWay:"劃分管道",ifGenCutSame:"劃分值相同",ifGenCutNpiece:"劃分为N份",ifGenCutCustom:"自定義輸入",ifGenCutConfirm:"生成",ifGenTipSelectCell:"選擇儲存格",ifGenTipSelectCellPlace:"請選擇儲存格",ifGenTipSelectRange:"選擇單範圍",ifGenTipSelectRangePlace:"請選擇範圍",ifGenTipNotNullValue:"比較值不能為空!",ifGenTipLableTitile:"標籤",ifGenTipRangeNotforNull:"範圍不能為空!",ifGenTipCutValueNotforNull:"劃分值不能為空！",ifGenTipNotGenCondition:"沒有生成可用的條件！"},formulaMore:{valueTitle:"值",tipSelectDataRange:"選取數據範圍",tipDataRangeTile:"數據範圍",findFunctionTitle:"查找函數",tipInputFunctionName:"請輸入您要查找的函數名稱或函數功能的簡要描述",Array:"數組",Database:"資料來源",Date:"日期",Engineering:"工程計算",Filter:"篩檢程式",Financial:"財務",luckysheet:"Luckysheet內寘",other:"其它",Logical:"邏輯",Lookup:"查找",Math:"數學",Operator:"運算子",Parser:"轉換工具",Statistical:"統計",Text:"文字",dataMining:"資料挖掘",selectFunctionTitle:"選擇函數",calculationResult:"計算結果",tipSuccessText:"成功",tipParamErrorText:"參數類型錯誤",helpClose:"關閉",helpCollapse:"收起",helpExample:"示例",helpAbstract:"摘要",execfunctionError:'提示", "公式存在錯誤',execfunctionSelfError:"公式不可引用其本身的儲存格",execfunctionSelfErrorResult:"公式不可引用其本身的儲存格,會導致計算結果不準確",allowRepeatText:"可重複",allowOptionText:"可選",selectCategory:"或選擇類別"},drag:{noMerge:"無法對合併儲存格執行此操作",affectPivot:"無法對所選儲存格進行此更改,因為它會影響數據透視錶！",noMulti:"無法對多重選擇區域執行此操作,請選擇單個區域",noPaste:"無法在此處粘貼此內容,請選擇粘貼區域的一個儲存格,然後再次嘗試粘貼",noPartMerge:"無法對部分合併儲存格執行此操作",inputCorrect:"請輸入正確的數值",notLessOne:"行列數不能小於1",offsetColumnLessZero:"偏移列不能為負數！",pasteMustKeybordAlert:"Copy and paste in the Sheet: Ctrl + C to copy, Ctrl + V to paste, Ctrl + X to cut",pasteMustKeybordAlertHTMLTitle:"Copy and paste in the Sheet",pasteMustKeybordAlertHTML:"<span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + C</span>&nbsp;&nbsp;to copy<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + V</span>&nbsp;&nbsp;to paste<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + X</span>&nbsp;&nbsp;to cut"},pivotTable:{title:"數據透視錶",closePannel:"關閉",editRange:"編輯範圍",tipPivotFieldSelected:"選擇需要添加到數據透視錶的欄位",tipClearSelectedField:"清除所有已選欄位",btnClearSelectedField:"清除",btnFilter:"篩選",titleRow:"行",titleColumn:"列",titleValue:"數值",tipShowColumn:"統計欄位顯示為列",tipShowRow:"統計欄位顯示為行",titleSelectionDataRange:"選取數據範圍",titleDataRange:"數據範圍",valueSum:"總計",valueStatisticsSUM:"求和",valueStatisticsCOUNT:"數值計數",valueStatisticsCOUNTA:"計數",valueStatisticsCOUNTUNIQUE:"去重計數",valueStatisticsAVERAGE:"平均值",valueStatisticsMAX:"最大值",valueStatisticsMIN:"最小值",valueStatisticsMEDIAN:"中位數",valueStatisticsPRODUCT:"乘積",valueStatisticsSTDEV:"標準差",valueStatisticsSTDEVP:"整體標準差",valueStatisticslet:"方差",valueStatisticsVARP:"整體方差",errorNotAllowEdit:"非編輯模式下禁止該操作!",errorNotAllowMulti:"不能對多重選擇區域執行此操作,請選擇單個區域,然後再試",errorSelectRange:"請選擇新建透視錶的區域",errorIsDamage:"此數據透視錶的源數據已損壞！",errorNotAllowPivotData:"不可選擇數據透視錶為源數據!",errorSelectionRange:"選擇失敗,輸入範圍錯誤！",errorIncreaseRange:"請擴大選擇的數據範圍!",titleAddColumn:"添加列到數據透視錶",titleMoveColumn:"移動該列到下方白框",titleClearColumnFilter:"清除該列的篩選條件",titleFilterColumn:"篩選該列",titleSort:"排序",titleNoSort:"無排序",titleSortAsc:"昇冪",titleSortDesc:"降序",titleSortBy:"排序依據",titleShowSum:"顯示總計",titleStasticTrue:"是",titleStasticFalse:"否"},dropCell:{copyCell:"複製儲存格",sequence:"填充序列",onlyFormat:"僅填充格式",noFormat:"不帶格式填充",day:"以天數填充",workDay:"以工作日填充",month:"以月填充",year:"以年填充",chineseNumber:"以中文小寫數位填充"},imageCtrl:{borderTile:"圖片邊框顏色選擇",borderCur:"當前顏色"},protection:{protectiontTitle:"保護工作表",enterPassword:"請輸入密碼（可留空）",enterHint:"您試圖更改的儲存格或圖表位於受保護的工作表中。若要更改,請取消工作表保護。您可能需要輸入密碼",swichProtectionTip:"保護工作表及鎖定的儲存格內容",authorityTitle:"允許此工作表的用戶進行:",selectLockedCells:"定鎖定儲存格",selectunLockedCells:"選定解除鎖定的儲存格",formatCells:"設定儲存格格式",formatColumns:"設定列格式",formatRows:"設定行格式",insertColumns:"插入列",insertRows:"插入行",insertHyperlinks:"插入超連結",deleteColumns:"删除列",deleteRows:"删除行",sort:"排序",filter:"使用自動篩選",usePivotTablereports:"使用數據透視錶和報表",editObjects:"編輯對象",editScenarios:"編輯方案",allowRangeTitle:"允許用戶編輯區域",allowRangeAdd:"新建...",allowRangeAddTitle:"標題",allowRangeAddSqrf:"引用儲存格",selectCellRange:"點擊選擇儲存格範圍",selectCellRangeHolder:"請輸入儲存格範圍",allowRangeAddTitlePassword:"密碼",allowRangeAddTitleHint:"提示",allowRangeAddTitleHintTitle:"設置密碼後,提示用戶輸入密碼（可留空）",allowRangeAddtitleDefault:"請輸入區域名稱",rangeItemDblclick:"按兩下進行編輯",rangeItemHasPassword:"已設置密碼",rangeItemErrorTitleNull:"標題不能為空",rangeItemErrorRangeNull:"儲存格範圍不能為空",rangeItemErrorRange:"儲存格範圍格式錯誤",validationTitle:"驗證提示",validationTips:"需要輸入密碼來撤銷工作表的保護",validationInputHint:"請輸入密碼",checkPasswordNullalert:"密碼不能為空!",checkPasswordWrongalert:"密碼錯誤,請重試！",checkPasswordSucceedalert:"解鎖成功,可以編輯該區域!",defaultRangeHintText:"該儲存格正在受密碼保護",defaultSheetHintText:"該儲存格或圖表位於受保護的工作表中,若要進行更改,請取消工作表保護,您可能需要輸入密碼。"},cellFormat:{cellFormatTitle:"設定儲存格格式",protection:"保護",locked:"鎖定儲存格",hidden:"隱藏公式",protectionTips:"只有保護工作表功能（在功能表列點擊保護工作表按鈕進行設定）開啟後,鎖定儲存格或隱藏公式才能生效",tipsPart:"部分選中",tipsAll:"全部選中",selectionIsNullAlert:"請選擇一個範圍！",sheetDataIsNullAlert:"數據為空無法設定！"},print:{normalBtn:"常規視圖",layoutBtn:"頁面佈局",pageBtn:"分頁預覽",menuItemPrint:"列印(Ctrl+P)",menuItemAreas:"列印區域",menuItemRows:"列印標題行",menuItemColumns:"列印標題列"},edit:{typing:"正在輸入"},websocket:{success:"WebSocket連接成功",refresh:"WebSocket連接發生錯誤,請刷新頁面！",wait:"WebSocket連接發生錯誤,請耐心等待！",close:"WebSocket連接關閉",contact:"服務器通信發生錯誤,請刷新頁面後再試,如若不行請聯系管理員！",support:"當前瀏覽器不支持WebSocket"}};var localeObj={en:en,zh:zh,es:es,"zh-TW":zh_tw,hi:hi};function locale(ctx){var _ctx$lang;var langsToTry=[ctx.lang||"",((_ctx$lang=ctx.lang)===null||_ctx$lang===void 0?void 0:_ctx$lang.split("-")[0])||""];for(var i=0;i<langsToTry.length;i+=1){if(langsToTry[i]in localeObj){return localeObj[langsToTry[i]];}}return localeObj.en;}function moveToEnd(obj){if(document.createRange){if(obj.innerHTML!==obj.innerText||obj.innerHTML===""){obj.focus();var range=window.getSelection();range===null||range===void 0?void 0:range.selectAllChildren(obj);range===null||range===void 0?void 0:range.collapseToEnd();}else{var len=obj.innerText.length;var _range=document.createRange();_range.selectNodeContents(obj);_range.setStart(obj.childNodes[0],len);_range.collapse(true);var selection=window.getSelection();selection===null||selection===void 0?void 0:selection.removeAllRanges();selection===null||selection===void 0?void 0:selection.addRange(_range);}}else if(document.selection){var _range2=document.body.createTextRange();_range2.moveToElementText(obj);_range2.collapse(false);_range2.select();}}function isInPage(node){return node===document.body?false:document.body.contains(node);}function selectTextContent(ele){if(window.getSelection){var range=document.createRange();var content=ele.firstChild;if(content){range.setStart(content,0);range.setEnd(content,content.length);if(range.startContainer&&isInPage(range.startContainer)){var _window$getSelection,_window$getSelection2;(_window$getSelection=window.getSelection())===null||_window$getSelection===void 0?void 0:_window$getSelection.removeAllRanges();(_window$getSelection2=window.getSelection())===null||_window$getSelection2===void 0?void 0:_window$getSelection2.addRange(range);}}}else if(document.selection){var _range3=document.body.createTextRange();_range3.moveToElementText(ele);_range3.select();}}function selectTextContentCross(sEle,eEle){if(window.getSelection){var range=document.createRange();var sContent=sEle.firstChild;var eContent=eEle.firstChild;if(sContent&&eContent){range.setStart(sContent,0);range.setEnd(eContent,eContent.length);if(range.startContainer&&isInPage(range.startContainer)){var _window$getSelection3,_window$getSelection4;(_window$getSelection3=window.getSelection())===null||_window$getSelection3===void 0?void 0:_window$getSelection3.removeAllRanges();(_window$getSelection4=window.getSelection())===null||_window$getSelection4===void 0?void 0:_window$getSelection4.addRange(range);}}}}var attrToCssName={bl:"font-weight",it:"font-style",ff:"font-family",fs:"font-size",fc:"color",cl:"text-decoration",un:"border-bottom"};var inlineStyleAffectAttribute={bl:1,it:1,ff:1,cl:1,un:1,fs:1,fc:1};var inlineStyleAffectCssName={"font-weight":1,"font-style":1,"font-family":1,"text-decoration":1,"border-bottom":1,"font-size":1,color:1};function isInlineStringCell(cell){var _cell$ct,_cell$ct$s$length,_cell$ct2,_cell$ct2$s;return(cell===null||cell===void 0?void 0:(_cell$ct=cell.ct)===null||_cell$ct===void 0?void 0:_cell$ct.t)==="inlineStr"&&((_cell$ct$s$length=cell===null||cell===void 0?void 0:(_cell$ct2=cell.ct)===null||_cell$ct2===void 0?void 0:(_cell$ct2$s=_cell$ct2.s)===null||_cell$ct2$s===void 0?void 0:_cell$ct2$s.length)!==null&&_cell$ct$s$length!==void 0?_cell$ct$s$length:0)>0;}function isInlineStringCT(ct){var _ct$s$length,_ct$s;return(ct===null||ct===void 0?void 0:ct.t)==="inlineStr"&&((_ct$s$length=ct===null||ct===void 0?void 0:(_ct$s=ct.s)===null||_ct$s===void 0?void 0:_ct$s.length)!==null&&_ct$s$length!==void 0?_ct$s$length:0)>0;}function getInlineStringNoStyle(r,c,data){var ct=getCellValue(r,c,data,"ct");if(isInlineStringCT(ct)){var strings=ct.s;var value="";for(var i=0;i<strings.length;i+=1){var strObj=strings[i];if(strObj.v){value+=strObj.v;}}return value;}return"";}function convertCssToStyleList(cssText,originCell){if(lodash_default().isEmpty(cssText)){return{};}var cssTextArray=cssText.split(";");var styleList={fc:originCell.fc||"#000000",fs:originCell.fs||10,cl:originCell.cl||0,un:originCell.un||0,bl:originCell.bl||0,it:originCell.it||0,ff:originCell.ff||0};cssTextArray.forEach(function(s){s=s.toLowerCase();var key=lodash_default().trim(s.substring(0,s.indexOf(":")));var value=lodash_default().trim(s.substring(s.indexOf(":")+1));if(key==="font-weight"){if(value==="bold"){styleList.bl=1;}}if(key==="font-style"){if(value==="italic"){styleList.it=1;}}if(key==="font-size"){styleList.fs=parseInt(value,10);}if(key==="color"){styleList.fc=value;}if(key==="text-decoration"){styleList.cl=1;}if(key==="border-bottom"){styleList.un=1;}if(key==="lucky-strike"){styleList.cl=Number(value);}if(key==="lucky-underline"){styleList.un=Number(value);}});return styleList;}function convertSpanToShareString($dom,originCell){var styles=[];var preStyleList;var preStyleListString=null;for(var i=0;i<$dom.length;i+=1){var span=$dom[i];var styleList=convertCssToStyleList(span.style.cssText,originCell);var curStyleListString=JSON.stringify(styleList);var v=span.innerText;v=v.replace(/\n/g,"\r\n");if(i===$dom.length-1){if(v.endsWith("\r\n")&&!v.endsWith("\r\n\r\n")){v=v.slice(0,v.length-2);}}if(curStyleListString===preStyleListString){preStyleList.v+=v;}else{styleList.v=v;styles.push(styleList);preStyleListString=curStyleListString;preStyleList=styleList;}}return styles;}function updateInlineStringFormatOutside(cell,key,value){if(lodash_default().isNil(cell.ct)){return;}var s=cell.ct.s;if(lodash_default().isNil(s)){return;}for(var i=0;i<s.length;i+=1){var item=s[i];item[key]=value;}}function getClassWithcss(cssText,ukey){var cssTextArray=cssText.split(";");if(ukey==null||ukey.length===0){return cssText;}if(cssText.indexOf(ukey)>-1){for(var i=0;i<cssTextArray.length;i+=1){var s=cssTextArray[i];s=s.toLowerCase();var key=lodash_default().trim(s.substring(0,s.indexOf(":")));var value=lodash_default().trim(s.substring(s.indexOf(":")+1));if(key===ukey){return value;}}}return"";}function upsetClassWithCss(cssText,ukey,uvalue){var cssTextArray=cssText.split(";");var newCss="";if(ukey==null||ukey.length===0){return cssText;}if(cssText.indexOf(ukey)>-1){for(var i=0;i<cssTextArray.length;i+=1){var s=cssTextArray[i];s=s.toLowerCase();var key=lodash_default().trim(s.substring(0,s.indexOf(":")));var value=lodash_default().trim(s.substring(s.indexOf(":")+1));if(key===ukey){newCss+="".concat(key,":").concat(uvalue,";");}else if(key.length>0){newCss+="".concat(key,":").concat(value,";");}}}else if(ukey.length>0){cssText+="".concat(ukey,":").concat(uvalue,";");newCss=cssText;}return newCss;}function removeClassWidthCss(cssText,ukey){var cssTextArray=cssText.split(";");var newCss="";var oUkey=ukey;if(ukey==null||ukey.length===0){return cssText;}if(ukey in attrToCssName){ukey=attrToCssName[ukey];}if(cssText.indexOf(ukey)>-1){for(var i=0;i<cssTextArray.length;i+=1){var s=cssTextArray[i];s=s.toLowerCase();var key=lodash_default().trim(s.substring(0,s.indexOf(":")));var value=lodash_default().trim(s.substring(s.indexOf(":")+1));if(key===ukey||oUkey==="cl"&&key==="lucky-strike"||oUkey==="un"&&key==="lucky-underline"){continue;}else if(key.length>0){newCss+="".concat(key,":").concat(value,";");}}}else{newCss=cssText;}return newCss;}function getCssText(cssText,attr,value){var styleObj={};styleObj[attr]=value;if(attr==="un"){var fontColor=getClassWithcss(cssText,"color");if(fontColor===""){fontColor="#000000";}var fs=getClassWithcss(cssText,"font-size");if(fs===""){fs="11";}styleObj._fontSize=Number(fs);styleObj._color=fontColor;}var s=getFontStyleByCell(styleObj,undefined,undefined,false);var ukey=lodash_default().kebabCase(Object.keys(s)[0]);var uvalue=Object.values(s)[0];cssText=removeClassWidthCss(cssText,attr);cssText=upsetClassWithCss(cssText,ukey,uvalue);return cssText;}function extendCssText(origin,cover){var isLimit=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var originArray=origin.split(";");var coverArray=cover.split(";");var newCss="";var addKeyList={};for(var i=0;i<originArray.length;i+=1){var so=originArray[i];var isAdd=true;so=so.toLowerCase();var okey=lodash_default().trim(so.substring(0,so.indexOf(":")));if(okey==="font-size"){continue;}var ovalue=lodash_default().trim(so.substring(so.indexOf(":")+1));if(isLimit){if(!(okey in inlineStyleAffectCssName)){continue;}}for(var a=0;a<coverArray.length;a+=1){var sc=coverArray[a];sc=sc.toLowerCase();var ckey=lodash_default().trim(sc.substring(0,sc.indexOf(":")));var cvalue=lodash_default().trim(sc.substring(sc.indexOf(":")+1));if(okey===ckey){newCss+="".concat(ckey,":").concat(cvalue,";");isAdd=false;continue;}}if(isAdd){newCss+="".concat(okey,":").concat(ovalue,";");}addKeyList[okey]=1;}for(var _a=0;_a<coverArray.length;_a+=1){var _sc=coverArray[_a];_sc=_sc.toLowerCase();var _ckey=lodash_default().trim(_sc.substring(0,_sc.indexOf(":")));var _cvalue=lodash_default().trim(_sc.substring(_sc.indexOf(":")+1));if(isLimit){if(!(_ckey in inlineStyleAffectCssName)){continue;}}if(!(_ckey in addKeyList)){newCss+="".concat(_ckey,":").concat(_cvalue,";");}}return newCss;}function updateInlineStringFormat(ctx,cell,attr,value,cellInput){var w=window.getSelection();if(!w)return;if(w.rangeCount===0)return;var range=w.getRangeAt(0);var $textEditor=cellInput;if(range.collapsed===true){return;}var endContainer=range.endContainer;var startContainer=range.startContainer;var endOffset=range.endOffset;var startOffset=range.startOffset;if($textEditor){if(startContainer===endContainer){var span=startContainer.parentNode;var spanIndex;var inherit=false;var content=(span===null||span===void 0?void 0:span.innerHTML)||"";var fullContent=$textEditor.innerHTML;if(fullContent.substring(0,5)!=="<span"){inherit=true;}if(span){var _startContainer$paren;var left="";var mid="";var right="";var s1=0;var s2=startOffset;var s3=endOffset;var s4=content.length;left=content.substring(s1,s2);mid=content.substring(s2,s3);right=content.substring(s3,s4);var cont="";if(left!==""){var cssText=span.style.cssText;if(inherit){var box=span.closest("#luckysheet-input-box");if(box!=null){cssText=extendCssText(box.style.cssText,cssText);}}cont+="<span style='".concat(cssText,"'>").concat(left,"</span>");}if(mid!==""){var _cssText=getCssText(span.style.cssText,attr,value);if(inherit){var _box=span.closest("#luckysheet-input-box");if(_box!=null){_cssText=extendCssText(_box.style.cssText,_cssText);}}cont+="<span style='".concat(_cssText,"'>").concat(mid,"</span>");}if(right!==""){var _cssText2=span.style.cssText;if(inherit){var _box2=span.closest("#luckysheet-input-box");if(_box2!=null){_cssText2=extendCssText(_box2.style.cssText,_cssText2);}}cont+="<span style='".concat(_cssText2,"'>").concat(right,"</span>");}if(((_startContainer$paren=startContainer.parentElement)===null||_startContainer$paren===void 0?void 0:_startContainer$paren.tagName)==="SPAN"){spanIndex=lodash_default().indexOf($textEditor.querySelectorAll("span"),span);span.outerHTML=cont;}else{spanIndex=0;span.innerHTML=cont;}var seletedNodeIndex=0;if(s1===s2){seletedNodeIndex=spanIndex;}else{seletedNodeIndex=spanIndex+1;}selectTextContent($textEditor.querySelectorAll("span")[seletedNodeIndex]);}}else{var _startContainer$paren2,_endContainer$parentE;if(((_startContainer$paren2=startContainer.parentElement)===null||_startContainer$paren2===void 0?void 0:_startContainer$paren2.tagName)==="SPAN"&&((_endContainer$parentE=endContainer.parentElement)===null||_endContainer$parentE===void 0?void 0:_endContainer$parentE.tagName)==="SPAN"){var startSpan=startContainer.parentNode;var endSpan=endContainer.parentNode;var allSpans=$textEditor.querySelectorAll("span");var startSpanIndex=lodash_default().indexOf(allSpans,startSpan);var endSpanIndex=lodash_default().indexOf(allSpans,endSpan);var startContent=(startSpan===null||startSpan===void 0?void 0:startSpan.innerHTML)||"";var endContent=(endSpan===null||endSpan===void 0?void 0:endSpan.innerHTML)||"";var sleft="";var sright="";var eleft="";var eright="";var _s=0;var _s2=startOffset;var _s3=endOffset;var _s4=endContent.length;sleft=startContent.substring(_s,_s2);sright=startContent.substring(_s2,startContent.length);eleft=endContent.substring(0,_s3);eright=endContent.substring(_s3,_s4);var spans=$textEditor.querySelectorAll("span");var _cont="";for(var i=0;i<startSpanIndex;i+=1){var _span=spans[i];var _content=_span.innerHTML;_cont+="<span style='".concat(_span.style.cssText,"'>").concat(_content,"</span>");}if(sleft!==""){_cont+="<span style='".concat(startSpan.style.cssText,"'>").concat(sleft,"</span>");}if(sright!==""){var _cssText3=getCssText(startSpan.style.cssText,attr,value);_cont+="<span style='".concat(_cssText3,"'>").concat(sright,"</span>");}if(startSpanIndex<endSpanIndex){for(var _i=startSpanIndex+1;_i<endSpanIndex;_i+=1){var _span2=spans[_i];var _content2=_span2.innerHTML;_cont+="<span style='".concat(_span2.style.cssText,"'>").concat(_content2,"</span>");}}if(eleft!==""){var _cssText4=getCssText(endSpan.style.cssText,attr,value);_cont+="<span style='".concat(_cssText4,"'>").concat(eleft,"</span>");}if(eright!==""){_cont+="<span style='".concat(endSpan.style.cssText,"'>").concat(eright,"</span>");}for(var _i2=endSpanIndex+1;_i2<spans.length;_i2+=1){var _span3=spans[_i2];var _content3=_span3.innerHTML;_cont+="<span style='".concat(_span3.style.cssText,"'>").concat(_content3,"</span>");}$textEditor.innerHTML=_cont;var startSeletedNodeIndex;var endSeletedNodeIndex;if(_s===_s2){startSeletedNodeIndex=startSpanIndex;endSeletedNodeIndex=endSpanIndex;}else{startSeletedNodeIndex=startSpanIndex+1;endSeletedNodeIndex=endSpanIndex+1;}spans=$textEditor.querySelectorAll("span");selectTextContentCross(spans[startSeletedNodeIndex],spans[endSeletedNodeIndex]);}}}}function checkWordByteLength(value){return Math.ceil(value.charCodeAt(0).toString(2).length/8);}function hasChinaword(s){var patrn=/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;if(!patrn.exec(s)){return false;}return true;}var textHeightCache={};var measureTextCache={};var measureTextCellInfoCache={};function clearMeasureTextCache(){measureTextCache={};measureTextCellInfoCache={};}function getTextSize(text,font){if(font in textHeightCache){return textHeightCache[font];}var ele=document.createElement("span");ele.style.float="left";ele.style.whiteSpace="nowrap";ele.style.visibility="hidden";ele.style.margin="0";ele.style.padding="0";ele.innerHTML=text;document.body.append(ele);var w=Math.max(ele.scrollWidth,ele.offsetWidth,ele.clientWidth);var h=Math.max(ele.scrollHeight,ele.offsetHeight,ele.clientHeight);textHeightCache[font]=[w,h];ele.remove();return[w,h];}function defaultFont(defaultFontSize){return"normal normal normal ".concat(defaultFontSize,"pt \"Helvetica Neue\", Helvetica, Arial, \"PingFang SC\", \"Hiragino Sans GB\", \"Heiti SC\",  \"WenQuanYi Micro Hei\", sans-serif");}function getFontSet(format,defaultFontSize,ctx){if(lodash_default().isPlainObject(format)){var fontAttr=[];if(format.it==="0"||format.it===0||lodash_default().isNil(format.it)){fontAttr.push("normal");}else{fontAttr.push("italic");}fontAttr.push("normal");if(format.bl==="0"||format.bl===0||lodash_default().isNil(format.bl)){fontAttr.push("normal");}else{fontAttr.push("bold");}if(!format.fs){fontAttr.push("".concat(defaultFontSize,"pt"));}else{fontAttr.push("".concat(Math.ceil(format.fs),"pt"));}var fontSet="\"Helvetica Neue\", Helvetica, Arial, \"PingFang SC\", \"Hiragino Sans GB\", \"Heiti SC\", \"Microsoft YaHei\", \"WenQuanYi Micro Hei\", sans-serif";if(ctx){var _locale=locale(ctx),fontarray=_locale.fontarray;if(!format.ff){fontSet="".concat(fontarray[0],",").concat(fontSet);}else{var fontfamily=null;if(ctx){if(isdatatypemulti(format.ff).num){fontfamily=fontarray[parseInt(format.ff,10)];}else{fontfamily=format.ff;fontfamily=fontfamily.replace(/"/g,"").replace(/'/g,"");if(fontfamily.indexOf(" ")>-1){fontfamily="\"".concat(fontfamily,"\"");}}}fontSet="".concat(fontfamily,",").concat(fontSet);}}return"".concat(fontAttr.join(" ")," ").concat(fontSet);}return defaultFont(defaultFontSize);}function getMeasureText(value,renderCtx,sheetCtx,fontset){var mtc=measureTextCache["".concat(value,"_").concat(renderCtx.font)];if(fontset){mtc=measureTextCache["".concat(value,"_").concat(fontset)];}if(mtc!=null){return mtc;}if(fontset){renderCtx.font=fontset;}var measureText=renderCtx.measureText(value);var cache={};cache.width=measureText.width;if(fontset){renderCtx.font=fontset;}cache.actualBoundingBoxDescent=measureText.actualBoundingBoxDescent;cache.actualBoundingBoxAscent=measureText.actualBoundingBoxAscent;if(cache.actualBoundingBoxDescent==null||cache.actualBoundingBoxAscent==null||Number.isNaN(cache.actualBoundingBoxDescent)||Number.isNaN(cache.actualBoundingBoxAscent)){var commonWord="M";if(hasChinaword(value)){commonWord="田";}var oneLineTextHeight=getTextSize(commonWord,renderCtx.font)[1]*0.8;if(renderCtx.textBaseline==="top"){cache.actualBoundingBoxDescent=oneLineTextHeight;cache.actualBoundingBoxAscent=0;}else if(renderCtx.textBaseline==="middle"){cache.actualBoundingBoxDescent=oneLineTextHeight/2;cache.actualBoundingBoxAscent=oneLineTextHeight/2;}else{cache.actualBoundingBoxDescent=0;cache.actualBoundingBoxAscent=oneLineTextHeight;}}if(renderCtx.textBaseline==="alphabetic"){var descText="gjpqy";var matchText="abcdABCD";var descTextMeasure=measureTextCache["".concat(descText,"_").concat(renderCtx.font)];if(fontset){descTextMeasure=measureTextCache["".concat(descText,"_").concat(fontset)];}var matchTextMeasure=measureTextCache["".concat(matchText,"_").concat(renderCtx.font)];if(fontset){matchTextMeasure=measureTextCache["".concat(matchText,"_").concat(fontset)];}if(descTextMeasure==null){descTextMeasure=renderCtx.measureText(descText);}if(matchTextMeasure==null){matchTextMeasure=renderCtx.measureText(matchText);}if(cache.actualBoundingBoxDescent<=matchTextMeasure.actualBoundingBoxDescent){cache.actualBoundingBoxDescent=descTextMeasure.actualBoundingBoxDescent;if(!cache.actualBoundingBoxDescent){cache.actualBoundingBoxDescent=0;}}}cache.width*=sheetCtx.zoomRatio;cache.actualBoundingBoxDescent*=sheetCtx.zoomRatio;cache.actualBoundingBoxAscent*=sheetCtx.zoomRatio;measureTextCache["".concat(value,"_").concat(sheetCtx.zoomRatio,"_").concat(renderCtx.font)]=cache;return cache;}function isSupportBoundingBox(ctx){var measureText=ctx.measureText("田");if(lodash_default().isNil(measureText.actualBoundingBoxAscent)){return false;}return true;}function drawLineInfo(wordGroup,cancelLine,underLine,option){var left=option.left;var top=option.top;var width=option.width;var asc=option.asc;var desc=option.desc;var fs=option.fs;if(wordGroup.wrap===true){return;}if(wordGroup.inline===true&&!lodash_default().isNil(wordGroup.style)){cancelLine=wordGroup.style.cl;underLine=wordGroup.style.un;}if(Number(cancelLine)!==0){wordGroup.cancelLine={};wordGroup.cancelLine.startX=left;wordGroup.cancelLine.startY=top-asc/2+1;wordGroup.cancelLine.endX=left+width;wordGroup.cancelLine.endY=top-asc/2+1;wordGroup.cancelLine.fs=fs;}var nUnderline=Number(underLine);if(nUnderline!==0){wordGroup.underLine=[];if(nUnderline===1||nUnderline===2){var item={};item.startX=left;item.startY=top+3;item.endX=left+width;item.endY=top+3;item.fs=fs;wordGroup.underLine.push(item);}if(nUnderline===2){var _item={};_item.startX=left;_item.startY=top+desc;_item.endX=left+width;_item.endY=top+desc;_item.fs=fs;wordGroup.underLine.push(_item);}if(nUnderline===3||nUnderline===4){var _item2={};_item2.startX=left;_item2.startY=top+desc;_item2.endX=left+width;_item2.endY=top+desc;_item2.fs=fs;wordGroup.underLine.push(_item2);}if(nUnderline===4){var _item3={};_item3.startX=left;_item3.startY=top+desc+2;_item3.endX=left+width;_item3.endY=top+desc+2;_item3.fs=fs;wordGroup.underLine.push(_item3);}}}function getCellTextInfo(cell,renderCtx,sheetCtx,option,ctx){var cellWidth=option.cellWidth;var cellHeight=option.cellHeight;var isMode="";var isModeSplit="";if(cellWidth==null){isMode="onlyWidth";isModeSplit="_";}var textInfo=measureTextCellInfoCache["".concat(option.r,"_").concat(option.c).concat(isModeSplit).concat(isMode)];if(textInfo){return textInfo;}var space_width=option.space_width;var space_height=option.space_height;if(space_width===undefined){space_width=2;}if(space_height===undefined){space_height=2;}var horizonAlign=normalizedCellAttr(cell,"ht");var verticalAlign=normalizedCellAttr(cell,"vt");var tb=normalizedCellAttr(cell,"tb");var tr=normalizedCellAttr(cell,"tr");var rt=normalizedCellAttr(cell,"rt");var isRotateUp=1;if(lodash_default().isNil(rt)){if(tr==="0"){rt=0;}else if(tr==="1"){rt=45;}else if(tr==="4"){rt=90;}else if(tr==="2"){rt=135;}else if(tr==="5"){rt=180;}if(lodash_default().isNil(rt)){rt=0;}}if(rt>180||rt<0){rt=0;}rt=parseInt(rt,10);if(rt>90){rt=90-rt;isRotateUp=0;}renderCtx.textAlign="start";var textContent={};textContent.values=[];var fontset;var cancelLine="0";var underLine="0";var fontSize=11;var isInline=false;var value;var inlineStringArr=[];if(isInlineStringCell(cell)){var sharedStrings=cell.ct.s;var similarIndex=0;for(var i=0;i<sharedStrings.length;i+=1){var shareCell=sharedStrings[i];var scfontset=getFontSet(shareCell,sheetCtx.defaultFontSize,ctx);var fc=shareCell.fc;var cl=shareCell.cl;var un=shareCell.un;var v=shareCell.v;var fs=shareCell.fs;v=v.replace(/\r\n/g,"_x000D_").replace(/&#13;&#10;/g,"_x000D_").replace(/\r/g,"_x000D_").replace(/\n/g,"_x000D_");var splitArr=v.split("_x000D_");for(var x=0;x<splitArr.length;x+=1){var newValue=splitArr[x];if(newValue===""&&x!==splitArr.length-1){inlineStringArr.push({fontset:scfontset,fc:!fc?"#000":fc,cl:!cl?0:cl,un:!un?0:un,wrap:true,fs:!fs?11:fs});similarIndex+=1;}else{inlineStringArr.push({fontset:scfontset,fc:!fc?"#000":fc,cl:!cl?0:cl,un:!un?0:un,v:newValue,si:similarIndex,fs:!fs?11:fs});if(x!==splitArr.length-1){inlineStringArr.push({fontset:scfontset,fc:!fc?"#000":fc,cl:!cl?0:cl,un:!un?0:un,wrap:true,fs:!fs?11:fs});similarIndex+=1;}}}similarIndex+=1;}isInline=true;}else{fontset=getFontSet(cell,sheetCtx.defaultFontSize,ctx);renderCtx.font=fontset;cancelLine=normalizedCellAttr(cell,"cl");underLine=normalizedCellAttr(cell,"un");fontSize=normalizedCellAttr(cell,"fs");if(cell instanceof Object){value=cell.m;if(lodash_default().isNil(value)){value=cell.v;}}else{value=cell;}if(lodash_default().isEmpty(value)){return null;}}if(tr==="3"){renderCtx.textBaseline="top";var textW_all=0;var textH_all=0;var colIndex=0;var textH_all_cache=0;var textH_all_Column={};var textH_all_ColumnHeight=[];if(isInline){var preShareCell=null;for(var _i=0;_i<inlineStringArr.length;_i+=1){var _shareCell=inlineStringArr[_i];var value1=_shareCell.v;var showValue=_shareCell.v;if(_shareCell.wrap===true){value1="M";showValue="";if(!lodash_default().isNil(preShareCell)&&preShareCell.wrap!==true&&_i<inlineStringArr.length-1){textH_all_ColumnHeight.push(textH_all_cache);textH_all_cache=0;colIndex+=1;preShareCell=_shareCell;continue;}}var measureText=getMeasureText(value1,renderCtx,sheetCtx,_shareCell.fontset);var textW=measureText.width+space_width;var textH=measureText.actualBoundingBoxAscent+measureText.actualBoundingBoxDescent+space_height;textH_all_cache+=textH;if(tb==="2"&&!_shareCell.wrap){if(textH_all_cache>cellHeight&&!lodash_default().isNil(textH_all_Column[colIndex])){textH_all_ColumnHeight.push(textH_all_cache-textH);textH_all_cache=textH;colIndex+=1;}}if(_i===inlineStringArr.length-1){textH_all_ColumnHeight.push(textH_all_cache);}if(lodash_default().isNil(textH_all_Column[colIndex])){textH_all_Column[colIndex]=[];}var item={content:showValue,style:_shareCell,width:textW,height:textH,left:0,top:0,colIndex:colIndex,asc:measureText.actualBoundingBoxAscent,desc:measureText.actualBoundingBoxDescent,inline:true,wrap:false};if(_shareCell.wrap===true){item.wrap=true;}textH_all_Column[colIndex].push(item);preShareCell=_shareCell;}}else{var _measureText=getMeasureText(value,renderCtx,sheetCtx);var textHeight=_measureText.actualBoundingBoxDescent+_measureText.actualBoundingBoxAscent;value=value.toString();var vArr=[];if(value.length>1){vArr=value.split("");}else{vArr.push(value);}var oneWordWidth=getMeasureText(vArr[0],renderCtx,sheetCtx).width;for(var _i2=0;_i2<vArr.length;_i2+=1){var _textW=oneWordWidth+space_width;var _textH=textHeight+space_height;textH_all_cache+=_textH;if(tb==="2"){if(textH_all_cache>cellHeight&&!lodash_default().isNil(textH_all_Column[colIndex])){textH_all_ColumnHeight.push(textH_all_cache-_textH);textH_all_cache=_textH;colIndex+=1;}}if(_i2===vArr.length-1){textH_all_ColumnHeight.push(textH_all_cache);}if(lodash_default().isNil(textH_all_Column[colIndex])){textH_all_Column[colIndex]=[];}textH_all_Column[colIndex].push({content:vArr[_i2],style:fontset,width:_textW,height:_textH,left:0,top:0,colIndex:colIndex,asc:_measureText.actualBoundingBoxAscent,desc:_measureText.actualBoundingBoxDescent});}}var textH_all_ColumWidth=[];for(var _i3=0;_i3<textH_all_ColumnHeight.length;_i3+=1){var columnHeight=textH_all_ColumnHeight[_i3];var col=textH_all_Column[_i3];var colMaxW=0;for(var c=0;c<col.length;c+=1){var word=col[c];colMaxW=Math.max(colMaxW,word.width);}textH_all_ColumWidth.push(colMaxW);textW_all+=colMaxW;textH_all=Math.max(textH_all,columnHeight);}textContent.type="verticalWrap";textContent.textWidthAll=textW_all;textContent.textHeightAll=textH_all;if(isMode==="onlyWidth"){return textContent;}var cumColumnWidth=0;for(var _i4=0;_i4<textH_all_ColumnHeight.length;_i4+=1){var _columnHeight=textH_all_ColumnHeight[_i4];var columnWidth=textH_all_ColumWidth[_i4];var _col=textH_all_Column[_i4];var cumWordHeight=0;for(var _c=0;_c<_col.length;_c+=1){var _word=_col[_c];var left=space_width+cumColumnWidth;if(horizonAlign==="0"){left=cellWidth/2+cumColumnWidth-textW_all/2+space_width*textH_all_ColumnHeight.length;}else if(horizonAlign==="2"){left=cellWidth+cumColumnWidth-textW_all+space_width;}var top=cellHeight-space_height+cumWordHeight-_columnHeight;if(verticalAlign==="0"){top=cellHeight/2+cumWordHeight-_columnHeight/2;}else if(verticalAlign==="1"){top=space_height+cumWordHeight;}cumWordHeight+=_word.height;_word.left=left;_word.top=top;drawLineInfo(_word,cancelLine,underLine,{width:columnWidth,height:_word.height,left:left,top:top+_word.height-space_height,asc:_word.height,desc:0,fs:fontSize});textContent.values.push(_word);}cumColumnWidth+=columnWidth;}}else{var supportBoundBox=isSupportBoundingBox(renderCtx);if(supportBoundBox){renderCtx.textBaseline="alphabetic";}else{renderCtx.textBaseline="bottom";}if(tb==="2"||isInline){var _textW_all=0;var _textH_all=0;var textW_all_inner=0;var splitIndex=0;var text_all_split={};textContent.rotate=rt;rt=Math.abs(rt);var anchor=0;var preStr;var preTextHeight;var preTextWidth;var preMeasureText;var _i5=1;var spaceOrTwoByte=null;var spaceOrTwoByteIndex=null;if(isInline){while(_i5<=inlineStringArr.length){var shareCells=inlineStringArr.slice(anchor,_i5);if(shareCells[shareCells.length-1].wrap===true){anchor=_i5;if(shareCells.length>1){for(var s=0;s<shareCells.length-1;s+=1){var sc=shareCells[s];var _item4={content:sc.v,style:sc,width:sc.measureText.width,height:sc.measureText.actualBoundingBoxAscent+sc.measureText.actualBoundingBoxDescent,left:0,top:0,splitIndex:splitIndex,asc:sc.measureText.actualBoundingBoxAscent,desc:sc.measureText.actualBoundingBoxDescent,inline:true,fs:sc.fs};text_all_split[splitIndex].push(_item4);}}if(shareCells.length===1){var _sc=shareCells[0];var _measureText2=getMeasureText("M",renderCtx,sheetCtx,_sc.fontset);if(lodash_default().isNil(text_all_split[splitIndex])){text_all_split[splitIndex]=[];}text_all_split[splitIndex].push({content:"",style:_sc,width:_measureText2.width,height:_measureText2.actualBoundingBoxAscent+_measureText2.actualBoundingBoxDescent,left:0,top:0,splitIndex:splitIndex,asc:_measureText2.actualBoundingBoxAscent,desc:_measureText2.actualBoundingBoxDescent,inline:true,wrap:true,fs:_sc.fs});}splitIndex+=1;_i5+=1;continue;}var textWidth=0;var _textHeight=0;for(var _s=0;_s<shareCells.length;_s+=1){var _sc2=shareCells[_s];if(lodash_default().isNil(_sc2.measureText)){_sc2.measureText=getMeasureText(_sc2.v,renderCtx,sheetCtx,_sc2.fontset);}textWidth+=_sc2.measureText.width;_textHeight=Math.max(_sc2.measureText.actualBoundingBoxAscent+_sc2.measureText.actualBoundingBoxDescent);}var width=textWidth*Math.cos(rt*Math.PI/180)+_textHeight*Math.sin(rt*Math.PI/180);var height=textWidth*Math.sin(rt*Math.PI/180)+_textHeight*Math.cos(rt*Math.PI/180);var lastWord=shareCells[shareCells.length-1];if(lastWord.v===" "||checkWordByteLength(lastWord.v)===2){spaceOrTwoByteIndex=_i5;}if(rt!==0){if(height+space_height>cellHeight&&!lodash_default().isNil(text_all_split[splitIndex])&&tb==="2"){if(!lodash_default().isNil(spaceOrTwoByteIndex)&&spaceOrTwoByteIndex<_i5){for(var _s2=0;_s2<spaceOrTwoByteIndex-anchor;_s2+=1){var _sc3=shareCells[_s2];text_all_split[splitIndex].push({content:_sc3.v,style:_sc3,width:_sc3.measureText.width,height:_sc3.measureText.actualBoundingBoxAscent+_sc3.measureText.actualBoundingBoxDescent,left:0,top:0,splitIndex:splitIndex,asc:_sc3.measureText.actualBoundingBoxAscent,desc:_sc3.measureText.actualBoundingBoxDescent,inline:true,fs:_sc3.fs});}anchor=spaceOrTwoByteIndex;_i5=spaceOrTwoByteIndex+1;splitIndex+=1;spaceOrTwoByteIndex=null;}else{anchor=_i5-1;for(var _s3=0;_s3<shareCells.length-1;_s3+=1){var _sc4=shareCells[_s3];text_all_split[splitIndex].push({content:_sc4.v,style:_sc4,width:_sc4.measureText.width,height:_sc4.measureText.actualBoundingBoxAscent+_sc4.measureText.actualBoundingBoxDescent,left:0,top:0,splitIndex:splitIndex,asc:_sc4.measureText.actualBoundingBoxAscent,desc:_sc4.measureText.actualBoundingBoxDescent,inline:true,fs:_sc4.fs});}splitIndex+=1;}}else if(_i5===inlineStringArr.length){if(lodash_default().isNil(text_all_split[splitIndex])){text_all_split[splitIndex]=[];}for(var _s4=0;_s4<shareCells.length;_s4+=1){var _sc5=shareCells[_s4];text_all_split[splitIndex].push({content:_sc5.v,style:_sc5,width:_sc5.measureText.width,height:_sc5.measureText.actualBoundingBoxAscent+_sc5.measureText.actualBoundingBoxDescent,left:0,top:0,splitIndex:splitIndex,asc:_sc5.measureText.actualBoundingBoxAscent,desc:_sc5.measureText.actualBoundingBoxDescent,inline:true,fs:_sc5.fs});}break;}else{if(lodash_default().isNil(text_all_split[splitIndex])){text_all_split[splitIndex]=[];}_i5+=1;}}else{if(width+space_width>cellWidth&&!lodash_default().isNil(text_all_split[splitIndex])&&tb==="2"){if(!lodash_default().isNil(spaceOrTwoByteIndex)&&spaceOrTwoByteIndex<_i5){for(var _s5=0;_s5<spaceOrTwoByteIndex-anchor;_s5+=1){var _sc6=shareCells[_s5];text_all_split[splitIndex].push({content:_sc6.v,style:_sc6,width:_sc6.measureText.width,height:_sc6.measureText.actualBoundingBoxAscent+_sc6.measureText.actualBoundingBoxDescent,left:0,top:0,splitIndex:splitIndex,asc:_sc6.measureText.actualBoundingBoxAscent,desc:_sc6.measureText.actualBoundingBoxDescent,inline:true,fs:_sc6.fs});}anchor=spaceOrTwoByteIndex;_i5=spaceOrTwoByteIndex+1;splitIndex+=1;spaceOrTwoByteIndex=null;}else{anchor=_i5-1;for(var _s6=0;_s6<shareCells.length-1;_s6+=1){var _sc7=shareCells[_s6];text_all_split[splitIndex].push({content:_sc7.v,style:_sc7,width:_sc7.measureText.width,height:_sc7.measureText.actualBoundingBoxAscent+_sc7.measureText.actualBoundingBoxDescent,left:0,top:0,splitIndex:splitIndex,asc:_sc7.measureText.actualBoundingBoxAscent,desc:_sc7.measureText.actualBoundingBoxDescent,inline:true,fs:_sc7.fs});}splitIndex+=1;}}else if(_i5===inlineStringArr.length){if(lodash_default().isNil(text_all_split[splitIndex])){text_all_split[splitIndex]=[];}for(var _s7=0;_s7<shareCells.length;_s7+=1){var _sc8=shareCells[_s7];text_all_split[splitIndex].push({content:_sc8.v,style:_sc8,width:_sc8.measureText.width,height:_sc8.measureText.actualBoundingBoxAscent+_sc8.measureText.actualBoundingBoxDescent,left:0,top:0,splitIndex:splitIndex,asc:_sc8.measureText.actualBoundingBoxAscent,desc:_sc8.measureText.actualBoundingBoxDescent,inline:true,fs:_sc8.fs});}break;}else{if(lodash_default().isNil(text_all_split[splitIndex])){text_all_split[splitIndex]=[];}_i5+=1;}}}}else{value=value.toString();while(_i5<=value.length){var str=value.substring(anchor,_i5);var _measureText3=getMeasureText(str,renderCtx,sheetCtx);var _textWidth=_measureText3.width;var _textHeight2=_measureText3.actualBoundingBoxAscent+_measureText3.actualBoundingBoxDescent;var _width=_textWidth*Math.cos(rt*Math.PI/180)+_textHeight2*Math.sin(rt*Math.PI/180);var _height=_textWidth*Math.sin(rt*Math.PI/180)+_textHeight2*Math.cos(rt*Math.PI/180);var _lastWord=str.substr(str.length-1,1);if(_lastWord===" "||checkWordByteLength(_lastWord)===2){spaceOrTwoByte={index:_i5,str:str,width:_width,height:_height,asc:_measureText3.actualBoundingBoxAscent,desc:_measureText3.actualBoundingBoxDescent};}if(rt!==0){if(_height+space_height>cellHeight&&!lodash_default().isNil(text_all_split[splitIndex])){if(!lodash_default().isNil(spaceOrTwoByte)&&spaceOrTwoByte.index<_i5){anchor=spaceOrTwoByte.index;_i5=spaceOrTwoByte.index+1;text_all_split[splitIndex].push({content:spaceOrTwoByte.str,style:fontset,width:spaceOrTwoByte.width,height:spaceOrTwoByte.height,left:0,top:0,splitIndex:splitIndex,asc:spaceOrTwoByte.asc,desc:spaceOrTwoByte.desc,fs:fontSize});splitIndex+=1;spaceOrTwoByte=null;}else{anchor=_i5-1;text_all_split[splitIndex].push({content:preStr,style:fontset,left:0,top:0,splitIndex:splitIndex,height:preTextHeight,width:preTextWidth,asc:_measureText3.actualBoundingBoxAscent,desc:_measureText3.actualBoundingBoxDescent,fs:fontSize});splitIndex+=1;}}else if(_i5===value.length){if(lodash_default().isNil(text_all_split[splitIndex])){text_all_split[splitIndex]=[];}text_all_split[splitIndex].push({content:str,style:fontset,left:0,top:0,splitIndex:splitIndex,height:_textHeight2,width:_textWidth,asc:_measureText3.actualBoundingBoxAscent,desc:_measureText3.actualBoundingBoxDescent,fs:fontSize});break;}else{if(lodash_default().isNil(text_all_split[splitIndex])){text_all_split[splitIndex]=[];}_i5+=1;}}else{if(_width+space_width>cellWidth&&!lodash_default().isNil(text_all_split[splitIndex])){if(!lodash_default().isNil(spaceOrTwoByte)&&spaceOrTwoByte.index<_i5){anchor=spaceOrTwoByte.index;_i5=spaceOrTwoByte.index+1;text_all_split[splitIndex].push({content:spaceOrTwoByte.str,style:fontset,width:spaceOrTwoByte.width,height:spaceOrTwoByte.height,left:0,top:0,splitIndex:splitIndex,asc:spaceOrTwoByte.asc,desc:spaceOrTwoByte.desc,fs:fontSize});splitIndex+=1;spaceOrTwoByte=null;}else{spaceOrTwoByte=null;anchor=_i5-1;text_all_split[splitIndex].push({content:preStr,style:fontset,width:preTextWidth,height:preTextHeight,left:0,top:0,splitIndex:splitIndex,asc:preMeasureText.actualBoundingBoxAscent,desc:preMeasureText.actualBoundingBoxDescent,fs:fontSize});splitIndex+=1;}}else if(_i5===value.length){if(lodash_default().isNil(text_all_split[splitIndex])){text_all_split[splitIndex]=[];}text_all_split[splitIndex].push({content:str,style:fontset,width:_textWidth,height:_textHeight2,left:0,top:0,splitIndex:splitIndex,asc:_measureText3.actualBoundingBoxAscent,desc:_measureText3.actualBoundingBoxDescent,fs:fontSize});break;}else{if(lodash_default().isNil(text_all_split[splitIndex])){text_all_split[splitIndex]=[];}_i5+=1;}}preStr=str;preTextHeight=_textHeight2;preTextWidth=_textWidth;preMeasureText=_measureText3;}}var split_all_size=[];var splitLen=Object.keys(text_all_split).length;if(splitLen===0)return textContent;for(var j=0;j<splitLen;j+=1){var splitLists=text_all_split[j];if(lodash_default().isNil(splitLists)){continue;}var sWidth=0;var sHeight=0;var maxDesc=0;var maxAsc=0;var lineHeight=0;var maxWordCount=0;for(var _s8=0;_s8<splitLists.length;_s8+=1){var sp=splitLists[_s8];if(rt!==0){sWidth+=sp.width;sHeight=Math.max(sHeight,sp.height-(supportBoundBox?sp.desc:0));}else{sWidth+=sp.width;sHeight=Math.max(sHeight,sp.height-(supportBoundBox?sp.desc:0));}maxDesc=Math.max(maxDesc,supportBoundBox?sp.desc:0);maxAsc=Math.max(maxAsc,sp.asc);maxWordCount+=1;}lineHeight=sHeight/2;if(rt!==0){sHeight+=lineHeight;textW_all_inner=Math.max(textW_all_inner,sWidth);_textH_all+=sHeight;}else{sHeight+=lineHeight;_textW_all=Math.max(_textW_all,sWidth);_textH_all+=sHeight;}split_all_size.push({width:sWidth,height:sHeight,desc:maxDesc,asc:maxAsc,lineHeight:lineHeight,wordCount:maxWordCount});}var _cumWordHeight=0;var _cumColumnWidth=0;var rtPI=rt*Math.PI/180;var lastLine=split_all_size[splitLen-1];var lastLineSpaceHeight=lastLine.lineHeight;_textH_all=_textH_all-lastLineSpaceHeight+lastLine.desc;var rw=_textH_all/Math.sin(rtPI)+textW_all_inner*Math.cos(rtPI);var rh=textW_all_inner*Math.sin(rtPI);var fixOneLineLeft=0;if(rt!==0){if(splitLen===1){_textW_all=textW_all_inner+2*(_textH_all/Math.tan(rtPI));fixOneLineLeft=_textH_all/Math.tan(rtPI);}else{_textW_all=textW_all_inner+_textH_all/Math.tan(rtPI);}textContent.textWidthAll=rw;textContent.textHeightAll=rh;}else{textContent.textWidthAll=_textW_all;textContent.textHeightAll=_textH_all;}if(isMode==="onlyWidth"){return textContent;}if(rt!==0&&Number(isRotateUp)===1){renderCtx.textAlign="end";for(var _j=0;_j<splitLen;_j+=1){var _splitLists=text_all_split[_j];if(lodash_default().isNil(_splitLists)){continue;}var size=split_all_size[_j];_cumColumnWidth=0;for(var _c2=_splitLists.length-1;_c2>=0;_c2-=1){var wordGroup=_splitLists[_c2];var _left=void 0;var _top=void 0;if(rt!==0){var y=_cumWordHeight+size.asc;var _x=_cumWordHeight/Math.tan(rtPI)-_cumColumnWidth+textW_all_inner;if(horizonAlign==="0"){if(verticalAlign==="0"){_left=_x+cellWidth/2-_textW_all/2+lastLineSpaceHeight*Math.cos(rtPI)/2;_top=y+cellHeight/2-_textH_all/2-lastLineSpaceHeight*Math.cos(rtPI)/2;}else if(verticalAlign==="1"){_left=_x+cellWidth/2-_textW_all/2;_top=y-(_textH_all/2-rh/2);}else if(verticalAlign==="2"){_left=_x+cellWidth/2-_textW_all/2+lastLineSpaceHeight*Math.cos(rtPI);_top=y+cellHeight-rh/2-_textH_all/2-lastLineSpaceHeight*Math.cos(rtPI);}}else if(horizonAlign==="1"){if(verticalAlign==="0"){_left=_x-rh*Math.sin(rtPI)/2+lastLineSpaceHeight*Math.cos(rtPI)/2;_top=y+cellHeight/2+rh*Math.cos(rtPI)/2-lastLineSpaceHeight*Math.cos(rtPI)/2;}else if(verticalAlign==="1"){_left=_x-rh*Math.sin(rtPI);_top=y+rh*Math.cos(rtPI);}else if(verticalAlign==="2"){_left=_x+lastLineSpaceHeight*Math.cos(rtPI);_top=y+cellHeight-lastLineSpaceHeight*Math.cos(rtPI);}}else if(horizonAlign==="2"){if(verticalAlign==="0"){_left=_x+cellWidth-rw/2-(textW_all_inner/2+_textH_all/2/Math.tan(rtPI))+lastLineSpaceHeight*Math.cos(rtPI)/2;_top=y+cellHeight/2-_textH_all/2-lastLineSpaceHeight*Math.cos(rtPI)/2;}else if(verticalAlign==="1"){_left=_x+cellWidth-_textW_all+fixOneLineLeft;_top=y-_textH_all;}else if(verticalAlign==="2"){_left=_x+cellWidth-rw*Math.cos(rtPI)+lastLineSpaceHeight*Math.cos(rtPI);_top=y+cellHeight-rw*Math.sin(rtPI)-lastLineSpaceHeight*Math.cos(rtPI);}}}wordGroup.left=_left;wordGroup.top=_top;drawLineInfo(wordGroup,cancelLine,underLine,{width:wordGroup.width,height:wordGroup.height,left:(_left||0)-wordGroup.width,top:_top,asc:size.asc,desc:size.desc,fs:wordGroup.fs});textContent.values.push(wordGroup);_cumColumnWidth+=wordGroup.width;}_cumWordHeight+=size.height;}}else{for(var _j2=0;_j2<splitLen;_j2+=1){var _splitLists2=text_all_split[_j2];if(lodash_default().isNil(_splitLists2)){continue;}var _size=split_all_size[_j2];_cumColumnWidth=0;for(var _c3=0;_c3<_splitLists2.length;_c3+=1){var _wordGroup=_splitLists2[_c3];var _left2=void 0;var _top2=void 0;if(rt!==0){var _y=_cumWordHeight+_size.asc;var _x2=(_textH_all-_cumWordHeight)/Math.tan(rtPI)+_cumColumnWidth;if(horizonAlign==="0"){if(verticalAlign==="0"){_left2=_x2+cellWidth/2-_textW_all/2-lastLineSpaceHeight*Math.cos(rtPI)/2;_top2=_y+cellHeight/2-_textH_all/2+lastLineSpaceHeight*Math.cos(rtPI)/2;}else if(verticalAlign==="1"){_left2=_x2+cellWidth/2-_textW_all/2-lastLineSpaceHeight*Math.cos(rtPI)/2;_top2=_y-(_textH_all/2-rh/2)+lastLineSpaceHeight*Math.cos(rtPI)/2;}else if(verticalAlign==="2"){_left2=_x2+cellWidth/2-_textW_all/2-lastLineSpaceHeight*Math.cos(rtPI);_top2=_y+cellHeight-rh/2-_textH_all/2-lastLineSpaceHeight*Math.cos(rtPI);}}else if(horizonAlign==="1"){if(verticalAlign==="0"){_left2=_x2-rh*Math.sin(rtPI)/2-lastLineSpaceHeight*Math.cos(rtPI)/2;_top2=_y-_textH_all+cellHeight/2-rh*Math.cos(rtPI)/2-lastLineSpaceHeight*Math.cos(rtPI)/2;}else if(verticalAlign==="1"){_left2=_x2;_top2=_y-_textH_all;}else if(verticalAlign==="2"){_left2=_x2-rh*Math.sin(rtPI)-lastLineSpaceHeight*Math.cos(rtPI);_top2=_y-_textH_all+cellHeight-rh*Math.cos(rtPI)-lastLineSpaceHeight*Math.cos(rtPI);}}else if(horizonAlign==="2"){if(verticalAlign==="0"){_left2=_x2+cellWidth-rw/2-_textW_all/2-lastLineSpaceHeight*Math.cos(rtPI)/2;_top2=_y+cellHeight/2-_textH_all/2-lastLineSpaceHeight*Math.cos(rtPI)/2;}else if(verticalAlign==="1"){_left2=_x2+cellWidth-rw*Math.cos(rtPI);_top2=_y+rh*Math.cos(rtPI);}else if(verticalAlign==="2"){_left2=_x2+cellWidth-_textW_all-lastLineSpaceHeight*Math.cos(rtPI)+fixOneLineLeft;_top2=_y+cellHeight-lastLineSpaceHeight*Math.cos(rtPI);}}drawLineInfo(_wordGroup,cancelLine,underLine,{width:_wordGroup.width,height:_wordGroup.height,left:_left2,top:_top2,asc:_size.asc,desc:_size.desc,fs:_wordGroup.fs});}else{_left2=space_width+_cumColumnWidth;if(horizonAlign==="0"){_left2=cellWidth/2+_cumColumnWidth-_size.width/2;}else if(horizonAlign==="2"){_left2=cellWidth+_cumColumnWidth-_size.width;}_top2=cellHeight-space_height+_cumWordHeight+_size.asc-_textH_all;if(verticalAlign==="0"){_top2=cellHeight/2+_cumWordHeight-_textH_all/2+_size.asc;}else if(verticalAlign==="1"){_top2=space_height+_cumWordHeight+_size.asc;}drawLineInfo(_wordGroup,cancelLine,underLine,{width:_wordGroup.width,height:_wordGroup.height,left:_left2,top:_top2,asc:_size.asc,desc:_size.desc,fs:_wordGroup.fs});}_wordGroup.left=_left2;_wordGroup.top=_top2;textContent.values.push(_wordGroup);_cumColumnWidth+=_wordGroup.width;}_cumWordHeight+=_size.height;}}textContent.type="plainWrap";if(rt!==0){if(horizonAlign==="0"){textContent.textLeftAll=cellWidth/2;if(verticalAlign==="0"){textContent.textTopAll=cellHeight/2;}else if(verticalAlign==="1"){textContent.textTopAll=rh/2;}else if(verticalAlign==="2"){textContent.textTopAll=cellHeight-rh/2;}}else if(horizonAlign==="1"){if(verticalAlign==="0"){textContent.textLeftAll=0;textContent.textTopAll=cellHeight/2;}else if(verticalAlign==="1"){textContent.textLeftAll=0;textContent.textTopAll=0;}else if(verticalAlign==="2"){textContent.textLeftAll=0;textContent.textTopAll=cellHeight;}}else if(horizonAlign==="2"){if(verticalAlign==="0"){textContent.textLeftAll=cellWidth-rw/2;textContent.textTopAll=cellHeight/2;}else if(verticalAlign==="1"){textContent.textLeftAll=cellWidth;textContent.textTopAll=0;}else if(verticalAlign==="2"){textContent.textLeftAll=cellWidth;textContent.textTopAll=cellHeight;}}}}else{var _measureText4=getMeasureText(value,renderCtx,sheetCtx);var _textWidth2=_measureText4.width;var _textHeight3=_measureText4.actualBoundingBoxDescent+_measureText4.actualBoundingBoxAscent;textContent.rotate=rt;rt=Math.abs(rt);var _rtPI=rt*Math.PI/180;var textWidthAll=_textWidth2*Math.cos(_rtPI)+_textHeight3*Math.sin(_rtPI);var textHeightAll=_textWidth2*Math.sin(_rtPI)+_textHeight3*Math.cos(_rtPI);if(rt!==0){textContent.textHeightAll=textHeightAll;}else{textContent.textHeightAll=textHeightAll+_textHeight3/2-_measureText4.actualBoundingBoxDescent-space_height;}textContent.textWidthAll=textWidthAll;if(isMode==="onlyWidth"){return textContent;}var _width2=textWidthAll;var _height2=textHeightAll;var _left3=space_width+_textHeight3*Math.sin(_rtPI)*isRotateUp;if(horizonAlign==="0"){_left3=cellWidth/2-_width2/2+_textHeight3*Math.sin(_rtPI)*isRotateUp;}else if(horizonAlign==="2"){_left3=cellWidth-space_width-_width2+_textHeight3*Math.sin(_rtPI)*isRotateUp;}var _top3=cellHeight-space_height-_height2+_measureText4.actualBoundingBoxAscent*Math.cos(_rtPI)+_textWidth2*Math.sin(_rtPI)*isRotateUp;if(verticalAlign==="0"){_top3=cellHeight/2-_height2/2+_measureText4.actualBoundingBoxAscent*Math.cos(_rtPI)+_textWidth2*Math.sin(_rtPI)*isRotateUp;}else if(verticalAlign==="1"){_top3=space_height+_measureText4.actualBoundingBoxAscent*Math.cos(_rtPI)+_textWidth2*Math.sin(_rtPI)*isRotateUp;}textContent.type="plain";var _wordGroup2={content:value,style:fontset,width:_width2,height:_height2,left:_left3,top:_top3};drawLineInfo(_wordGroup2,cancelLine,underLine,{width:_textWidth2,height:_textHeight3,left:_left3,top:_top3,asc:_measureText4.actualBoundingBoxAscent,desc:_measureText4.actualBoundingBoxDescent,fs:fontSize});textContent.values.push(_wordGroup2);textContent.textLeftAll=_left3;textContent.textTopAll=_top3;textContent.asc=_measureText4.actualBoundingBoxAscent;textContent.desc=_measureText4.actualBoundingBoxDescent;}}return textContent;}var error={v:"#VALUE!",n:"#NAME?",na:"#N/A",r:"#REF!",d:"#DIV/0!",nm:"#NUM!",nl:"#NULL!",sp:"#SPILL!"};var errorValues=Object.values(error);function valueIsError(value){return errorValues.includes(value);}function isRealNull(val){return lodash_default().isNil(val)||val.toString().replace(/\s/g,"")==="";}function isRealNum(val){if(lodash_default().isNil(val)||val.toString().replace(/\s/g,"")===""){return false;}if(typeof val==="boolean"){return false;}return!Number.isNaN(Number(val));}function checkDateTime(str){var reg1=/^(\d{4})-(\d{1,2})-(\d{1,2})(\s(\d{1,2}):(\d{1,2})(:(\d{1,2}))?)?$/;var reg2=/^(\d{4})\/(\d{1,2})\/(\d{1,2})(\s(\d{1,2}):(\d{1,2})(:(\d{1,2}))?)?$/;if(!reg1.test(str)&&!reg2.test(str)){return false;}var year=Number(RegExp.$1);var month=Number(RegExp.$2);var day=Number(RegExp.$3);if(year<1900){return false;}if(month>12){return false;}if(day>31){return false;}if(month===2){if(new Date(year,1,29).getDate()===29&&day>29){return false;}if(new Date(year,1,29).getDate()!==29&&day>28){return false;}}return true;}function isdatetime(s){if(s===null||s.toString().length<5){return false;}if(checkDateTime(s)){return true;}return false;}function diff(now,then){return dayjs_min_default()(now).diff(dayjs_min_default()(then));}function isdatatypemulti(s){var type={};if(isdatetime(s)){type.date=true;}if(!Number.isNaN(parseFloat(s))&&!hasChinaword(s)){type.num=true;}return type;}function isdatatype(s){var type="string";if(isdatetime(s)){type="date";}else if(!Number.isNaN(parseFloat(s))&&!hasChinaword(s)){type="num";}return type;}function hasPartMC(ctx,cfg,r1,r2,c1,c2){var ret=false;lodash_default().forEach(ctx.config.merge,function(mc){if(r1<mc.r){if(r2>=mc.r&&r2<mc.r+mc.rs-1){if(c1>=mc.c&&c1<=mc.c+mc.cs-1){ret=true;return false;}if(c2>=mc.c&&c2<=mc.c+mc.cs-1){ret=true;return false;}if(c1<mc.c&&c2>mc.c+mc.cs-1){ret=true;return false;}}else if(r2>=mc.r&&r2===mc.r+mc.rs-1){if(c1>mc.c&&c1<mc.c+mc.cs-1){ret=true;return false;}if(c2>mc.c&&c2<mc.c+mc.cs-1){ret=true;return false;}if(c1===mc.c&&c2<mc.c+mc.cs-1){ret=true;return false;}if(c1>mc.c&&c2===mc.c+mc.cs-1){ret=true;return false;}}else if(r2>mc.r+mc.rs-1){if(c1>mc.c&&c1<=mc.c+mc.cs-1){ret=true;return false;}if(c2>=mc.c&&c2<mc.c+mc.cs-1){ret=true;return false;}if(c1===mc.c&&c2<mc.c+mc.cs-1){ret=true;return false;}if(c1>mc.c&&c2===mc.c+mc.cs-1){ret=true;return false;}}}else if(r1===mc.r){if(r2<mc.r+mc.rs-1){if(c1>=mc.c&&c1<=mc.c+mc.cs-1){ret=true;return false;}if(c2>=mc.c&&c2<=mc.c+mc.cs-1){ret=true;return false;}if(c1<mc.c&&c2>mc.c+mc.cs-1){ret=true;return false;}}else if(r2>=mc.r+mc.rs-1){if(c1>mc.c&&c1<=mc.c+mc.cs-1){ret=true;return false;}if(c2>=mc.c&&c2<mc.c+mc.cs-1){ret=true;return false;}if(c1===mc.c&&c2<mc.c+mc.cs-1){ret=true;return false;}if(c1>mc.c&&c2===mc.c+mc.cs-1){ret=true;return false;}}}else if(r1<=mc.r+mc.rs-1){if(c1>=mc.c&&c1<=mc.c+mc.cs-1){ret=true;return false;}if(c2>=mc.c&&c2<=mc.c+mc.cs-1){ret=true;return false;}if(c1<mc.c&&c2>mc.c+mc.cs-1){ret=true;return false;}}return true;});return ret;}var SSF={};var make_ssf=function make_ssf(SSF){SSF.version="0.11.2";function _strrev(x){var o="",i=x.length-1;while(i>=0){o+=x.charAt(i--);}return o;}function fill(c,l){var o="";while(o.length<l){o+=c;}return o;}function pad0(v,d){var t=""+v;return t.length>=d?t:fill("0",d-t.length)+t;}function pad_(v,d){var t=""+v;return t.length>=d?t:fill(" ",d-t.length)+t;}function rpad_(v,d){var t=""+v;return t.length>=d?t:t+fill(" ",d-t.length);}function pad0r1(v,d){var t=""+Math.round(v);return t.length>=d?t:fill("0",d-t.length)+t;}function pad0r2(v,d){var t=""+v;return t.length>=d?t:fill("0",d-t.length)+t;}var p2_32=Math.pow(2,32);function pad0r(v,d){if(v>p2_32||v<-p2_32)return pad0r1(v,d);var i=Math.round(v);return pad0r2(i,d);}function isgeneral(s,i){i=i||0;return s.length>=7+i&&(s.charCodeAt(i)|32)===103&&(s.charCodeAt(i+1)|32)===101&&(s.charCodeAt(i+2)|32)===110&&(s.charCodeAt(i+3)|32)===101&&(s.charCodeAt(i+4)|32)===114&&(s.charCodeAt(i+5)|32)===97&&(s.charCodeAt(i+6)|32)===108;}var days=[["Sun","Sunday"],["Mon","Monday"],["Tue","Tuesday"],["Wed","Wednesday"],["Thu","Thursday"],["Fri","Friday"],["Sat","Saturday"]];var months=[["J","Jan","January"],["F","Feb","February"],["M","Mar","March"],["A","Apr","April"],["M","May","May"],["J","Jun","June"],["J","Jul","July"],["A","Aug","August"],["S","Sep","September"],["O","Oct","October"],["N","Nov","November"],["D","Dec","December"]];function init_table(t){t[0]="General";t[1]="0";t[2]="0.00";t[3]="#,##0";t[4]="#,##0.00";t[9]="0%";t[10]="0.00%";t[11]="0.00E+00";t[12]="# ?/?";t[13]="# ??/??";t[14]="m/d/yy";t[15]="d-mmm-yy";t[16]="d-mmm";t[17]="mmm-yy";t[18]="h:mm AM/PM";t[19]="h:mm:ss AM/PM";t[20]="h:mm";t[21]="h:mm:ss";t[22]="m/d/yy h:mm";t[37]="#,##0 ;(#,##0)";t[38]="#,##0 ;[Red](#,##0)";t[39]="#,##0.00;(#,##0.00)";t[40]="#,##0.00;[Red](#,##0.00)";t[45]="mm:ss";t[46]="[h]:mm:ss";t[47]="mmss.0";t[48]="##0.0E+0";t[49]="@";t[56]='"上午/下午 "hh"時"mm"分"ss"秒 "';t[65535]="General";}var table_fmt={};init_table(table_fmt);/* Defaults determined by systematically testing in Excel 2019 *//* These formats appear to default to other formats in the table */var default_map=[];var defi=0;//  5 -> 37 ...  8 -> 40
for(defi=5;defi<=8;++defi){default_map[defi]=32+defi;}// 23 ->  0 ... 26 ->  0
for(defi=23;defi<=26;++defi){default_map[defi]=0;}// 27 -> 14 ... 31 -> 14
for(defi=27;defi<=31;++defi){default_map[defi]=14;}// 50 -> 14 ... 58 -> 14
for(defi=50;defi<=58;++defi){default_map[defi]=14;}// 59 ->  1 ... 62 ->  4
for(defi=59;defi<=62;++defi){default_map[defi]=defi-58;}// 67 ->  9 ... 68 -> 10
for(defi=67;defi<=68;++defi){default_map[defi]=defi-58;}// 72 -> 14 ... 75 -> 17
for(defi=72;defi<=75;++defi){default_map[defi]=defi-58;}// 69 -> 12 ... 71 -> 14
for(defi=67;defi<=68;++defi){default_map[defi]=defi-57;}// 76 -> 20 ... 78 -> 22
for(defi=76;defi<=78;++defi){default_map[defi]=defi-56;}// 79 -> 45 ... 81 -> 47
for(defi=79;defi<=81;++defi){default_map[defi]=defi-34;}// 82 ->  0 ... 65536 -> 0 (omitted)
/* These formats technically refer to Accounting formats with no equivalent */var default_str=[];//  5 -- Currency,   0 decimal, black negative
default_str[5]=default_str[63]='"$"#,##0_);\\("$"#,##0\\)';//  6 -- Currency,   0 decimal, red   negative
default_str[6]=default_str[64]='"$"#,##0_);[Red]\\("$"#,##0\\)';//  7 -- Currency,   2 decimal, black negative
default_str[7]=default_str[65]='"$"#,##0.00_);\\("$"#,##0.00\\)';//  8 -- Currency,   2 decimal, red   negative
default_str[8]=default_str[66]='"$"#,##0.00_);[Red]\\("$"#,##0.00\\)';// 41 -- Accounting, 0 decimal, No Symbol
default_str[41]='_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)';// 42 -- Accounting, 0 decimal, $  Symbol
default_str[42]='_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)';// 43 -- Accounting, 2 decimal, No Symbol
default_str[43]='_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)';// 44 -- Accounting, 2 decimal, $  Symbol
default_str[44]='_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)';function frac(x,D,mixed){var sgn=x<0?-1:1;var B=x*sgn;var P_2=0,P_1=1,P=0;var Q_2=1,Q_1=0,Q=0;var A=Math.floor(B);while(Q_1<D){A=Math.floor(B);P=A*P_1+P_2;Q=A*Q_1+Q_2;if(B-A<0.00000005)break;B=1/(B-A);P_2=P_1;P_1=P;Q_2=Q_1;Q_1=Q;}if(Q>D){if(Q_1>D){Q=Q_2;P=P_2;}else{Q=Q_1;P=P_1;}}if(!mixed)return[0,sgn*P,Q];var q=Math.floor(sgn*P/Q);return[q,sgn*P-q*Q,Q];}function parse_date_code(v,opts,b2){if(v>2958465||v<0)return null;var date=v|0,time=Math.floor(86400*(v-date)),dow=0;var dout=[];var out={D:date,T:time,u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};if(Math.abs(out.u)<1e-6)out.u=0;if(opts&&opts.date1904)date+=1462;if(out.u>0.9999){out.u=0;if(++time==86400){out.T=time=0;++date;++out.D;}}if(date===60){dout=b2?[1317,10,29]:[1900,2,29];dow=3;}else if(date===0){dout=b2?[1317,8,29]:[1900,1,0];dow=6;}else{if(date>60)--date;/* 1 = Jan 1 1900 in Gregorian */var d=new Date(1900,0,1);d.setDate(d.getDate()+date-1);dout=[d.getFullYear(),d.getMonth()+1,d.getDate()];dow=d.getDay();if(date<60)dow=(dow+6)%7;if(b2)dow=fix_hijri(d,dout);}out.y=dout[0];out.m=dout[1];out.d=dout[2];out.S=time%60;time=Math.floor(time/60);out.M=time%60;time=Math.floor(time/60);out.H=time;out.q=dow;return out;}SSF.parse_date_code=parse_date_code;var basedate=new Date(1899,11,31,0,0,0);var dnthresh=basedate.getTime();var base1904=new Date(1900,2,1,0,0,0);function datenum_local(v,date1904){var epoch=v.getTime();if(date1904)epoch-=1461*24*60*60*1000;else if(v>=base1904)epoch+=24*60*60*1000;return(epoch-(dnthresh+(v.getTimezoneOffset()-basedate.getTimezoneOffset())*60000))/(24*60*60*1000);}/* The longest 32-bit integer text is "-4294967296", exactly 11 chars */function general_fmt_int(v){return v.toString(10);}SSF._general_int=general_fmt_int;/* ECMA-376 18.8.30 numFmt*//* Note: `toPrecision` uses standard form when prec > E and E >= -6 */var general_fmt_num=function make_general_fmt_num(){var trailing_zeroes_and_decimal=/(?:\.0*|(\.\d*[1-9])0+)$/;function strip_decimal(o){return o.indexOf(".")==-1?o:o.replace(trailing_zeroes_and_decimal,"$1");}/* General Exponential always shows 2 digits exp and trims the mantissa */var mantissa_zeroes_and_decimal=/(?:\.0*|(\.\d*[1-9])0+)[Ee]/;var exp_with_single_digit=/(E[+-])(\d)$/;function normalize_exp(o){if(o.indexOf("E")==-1)return o;return o.replace(mantissa_zeroes_and_decimal,"$1E").replace(exp_with_single_digit,"$10$2");}/* exponent >= -9 and <= 9 */function small_exp(v){var w=v<0?12:11;var o=strip_decimal(v.toFixed(12));if(o.length<=w)return o;o=v.toPrecision(10);if(o.length<=w)return o;return Number(v).toExponential(5);}/* exponent >= 11 or <= -10 likely exponential */function large_exp(v){var o=strip_decimal(v.toFixed(11));return o.length>(v<0?12:11)||o==="0"||o==="-0"?v.toPrecision(6):o;}function general_fmt_num_base(v){var V=Math.floor(Math.log(Math.abs(v))*Math.LOG10E),o;if(V>=-4&&V<=-1)o=v.toPrecision(10+V);else if(Math.abs(V)<=9)o=small_exp(v);else if(V===10)o=v.toFixed(10).substr(0,12);else o=large_exp(v);return strip_decimal(normalize_exp(o.toUpperCase()));}return general_fmt_num_base;}();SSF._general_num=general_fmt_num;/*
        "General" rules:
        - text is passed through ("@")
        - booleans are rendered as TRUE/FALSE
        - "up to 11 characters" displayed for numbers
        - Default date format (code 14) used for Dates
        TODO: technically the display depends on the width of the cell
    */function general_fmt(v,opts){switch(index_esm_typeof(v)){case"string":return v;case"boolean":return v?"TRUE":"FALSE";case"number":return(v|0)===v?v.toString(10):general_fmt_num(v);case"undefined":return"";case"object":if(v==null)return"";if(v instanceof Date)return format(14,datenum_local(v,opts&&opts.date1904),opts);}throw new Error("unsupported value in General format: "+v);}SSF._general=general_fmt;function fix_hijri(date,o){/* TODO: properly adjust y/m/d and  */o[0]-=581;var dow=date.getDay();if(date<60)dow=(dow+6)%7;return dow;}/*jshint -W086 */function write_date(type,fmt,val,ss0){var o="",ss=0,tt=0,y=val.y,out,outl=0;switch(type){case 98:/* 'b' buddhist year */y=val.y+543;/* falls through */case 121:/* 'y' year */switch(fmt.length){case 1:case 2:out=y%100;outl=2;break;default:out=y%10000;outl=4;break;}break;case 109:/* 'm' month */switch(fmt.length){case 1:case 2:out=val.m;outl=fmt.length;break;case 3:return months[val.m-1][1];case 5:return months[val.m-1][0];default:return months[val.m-1][2];}break;case 100:/* 'd' day */switch(fmt.length){case 1:case 2:out=val.d;outl=fmt.length;break;case 3:return days[val.q][0];default:return days[val.q][1];}break;case 104:/* 'h' 12-hour */switch(fmt.length){case 1:case 2:out=1+(val.H+11)%12;outl=fmt.length;break;default:throw"bad hour format: "+fmt;}break;case 72:/* 'H' 24-hour */switch(fmt.length){case 1:case 2:out=val.H;outl=fmt.length;break;default:throw"bad hour format: "+fmt;}break;case 77:/* 'M' minutes */switch(fmt.length){case 1:case 2:out=val.M;outl=fmt.length;break;default:throw"bad minute format: "+fmt;}break;case 115:/* 's' seconds */if(fmt!="s"&&fmt!="ss"&&fmt!=".0"&&fmt!=".00"&&fmt!=".000")throw"bad second format: "+fmt;if(val.u===0&&(fmt=="s"||fmt=="ss"))return pad0(val.S,fmt.length);if(ss0>=2)tt=ss0===3?1000:100;else tt=ss0===1?10:1;ss=Math.round(tt*(val.S+val.u));if(ss>=60*tt)ss=0;if(fmt==="s")return ss===0?"0":""+ss/tt;o=pad0(ss,2+ss0);if(fmt==="ss")return o.substr(0,2);return"."+o.substr(2,fmt.length-1);case 90:/* 'Z' absolute time */switch(fmt){case"[h]":case"[hh]":out=val.D*24+val.H;break;case"[m]":case"[mm]":out=(val.D*24+val.H)*60+val.M;break;case"[s]":case"[ss]":out=((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u);break;default:throw"bad abstime format: "+fmt;}outl=fmt.length===3?1:2;break;case 101:/* 'e' era */out=y;outl=1;break;}var outstr=outl>0?pad0(out,outl):"";return outstr;}/*jshint +W086 */function commaify(s){var w=3;if(s.length<=w)return s;var j=s.length%w,o=s.substr(0,j);for(;j!=s.length;j+=w){o+=(o.length>0?",":"")+s.substr(j,w);}return o;}var write_num=function make_write_num(){var pct1=/%/g;function write_num_pct(type,fmt,val){var sfmt=fmt.replace(pct1,""),mul=fmt.length-sfmt.length;return write_num(type,sfmt,val*Math.pow(10,2*mul))+fill("%",mul);}function write_num_cm(type,fmt,val){var idx=fmt.length-1;while(fmt.charCodeAt(idx-1)===44){--idx;}return write_num(type,fmt.substr(0,idx),val/Math.pow(10,3*(fmt.length-idx)));}function write_num_exp(fmt,val){var o;var idx=fmt.indexOf("E")-fmt.indexOf(".")-1;if(fmt.match(/^#+0.0E\+0$/)){if(val==0)return"0.0E+0";else if(val<0)return"-"+write_num_exp(fmt,-val);var period=fmt.indexOf(".");if(period===-1)period=fmt.indexOf("E");var ee=Math.floor(Math.log(val)*Math.LOG10E)%period;if(ee<0)ee+=period;o=(val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);if(o.indexOf("e")===-1){var fakee=Math.floor(Math.log(val)*Math.LOG10E);if(o.indexOf(".")===-1)o=o.charAt(0)+"."+o.substr(1)+"E+"+(fakee-o.length+ee);else o+="E+"+(fakee-ee);while(o.substr(0,2)==="0."){o=o.charAt(0)+o.substr(2,period)+"."+o.substr(2+period);o=o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");}o=o.replace(/\+-/,"-");}o=o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3){return $1+$2+$3.substr(0,(period+ee)%period)+"."+$3.substr(ee)+"E";});}else o=Number(val).toExponential(idx);if(fmt.match(/E\+00$/)&&o.match(/e[+-]\d$/))o=o.substr(0,o.length-1)+"0"+o.charAt(o.length-1);if(fmt.match(/E\-/)&&o.match(/e\+/))o=o.replace(/e\+/,"e");return o.replace("e","E");}var frac1=/# (\?+)( ?)\/( ?)(\d+)/;function write_num_f1(r,aval,sign){var den=parseInt(r[4],10),rr=Math.round(aval*den),base=Math.floor(rr/den);var myn=rr-base*den,myd=den;return sign+(base===0?"":""+base)+" "+(myn===0?fill(" ",r[1].length+1+r[4].length):pad_(myn,r[1].length)+r[2]+"/"+r[3]+pad0(myd,r[4].length));}function write_num_f2(r,aval,sign){return sign+(aval===0?"":""+aval)+fill(" ",r[1].length+2+r[4].length);}var dec1=/^#*0*\.([0#]+)/;var closeparen=/\).*[0#]/;var phone=/\(###\) ###\\?-####/;function hashq(str){var o="",cc;for(var i=0;i!=str.length;++i){switch(cc=str.charCodeAt(i)){case 35:break;case 63:o+=" ";break;case 48:o+="0";break;default:o+=String.fromCharCode(cc);}}return o;}function rnd(val,d){var dd=Math.pow(10,d);return""+Math.round(val*dd)/dd;}function dec(val,d){var _frac=val-Math.floor(val),dd=Math.pow(10,d);if(d<(""+Math.round(_frac*dd)).length)return 0;return Math.round(_frac*dd);}function carry(val,d){if(d<(""+Math.round((val-Math.floor(val))*Math.pow(10,d))).length){return 1;}return 0;}function flr(val){if(val<2147483647&&val>-2147483648)return""+(val>=0?val|0:val-1|0);return""+Math.floor(val);}function write_num_flt(type,fmt,val){if(type.charCodeAt(0)===40&&!fmt.match(closeparen)){var ffmt=fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(val>=0)return write_num_flt("n",ffmt,val);return"("+write_num_flt("n",ffmt,-val)+")";}if(fmt.charCodeAt(fmt.length-1)===44)return write_num_cm(type,fmt,val);if(fmt.indexOf("%")!==-1)return write_num_pct(type,fmt,val);if(fmt.indexOf("E")!==-1)return write_num_exp(fmt,val);if(fmt.charCodeAt(0)===36)return"$"+write_num_flt(type,fmt.substr(fmt.charAt(1)==" "?2:1),val);var o;var r,ri,ff,aval=Math.abs(val),sign=val<0?"-":"";if(fmt.match(/^00+$/))return sign+pad0r(aval,fmt.length);if(fmt.match(/^[#?]+$/)){o=pad0r(val,0);if(o==="0")o="";return o.length>fmt.length?o:hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(frac1))return write_num_f1(r,aval,sign);if(fmt.match(/^#+0+$/))return sign+pad0r(aval,fmt.length-fmt.indexOf("0"));if(r=fmt.match(dec1)){o=rnd(val,r[1].length).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1])).replace(/\.(\d*)$/,function($$,$1){return"."+$1+fill("0",hashq(r[1]).length-$1.length);});return fmt.indexOf("0.")!==-1?o:o.replace(/^0\./,".");}fmt=fmt.replace(/^#+([0.])/,"$1");if(r=fmt.match(/^(0*)\.(#*)$/)){return sign+rnd(aval,r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");}if(r=fmt.match(/^#{1,3},##0(\.?)$/))return sign+commaify(pad0r(aval,0));if(r=fmt.match(/^#,##0\.([#0]*0)$/)){return val<0?"-"+write_num_flt(type,fmt,-val):commaify(""+(Math.floor(val)+carry(val,r[1].length)))+"."+pad0(dec(val,r[1].length),r[1].length);}if(r=fmt.match(/^#,#*,#0/))return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);if(r=fmt.match(/^([0#]+)(\\?-([0#]+))+$/)){o=_strrev(write_num_flt(type,fmt.replace(/[\\-]/g,""),val));ri=0;return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==="0"?"0":"";}));}if(fmt.match(phone)){o=write_num_flt(type,"##########",val);return"("+o.substr(0,3)+") "+o.substr(3,3)+"-"+o.substr(6);}var oa="";if(r=fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(r[4].length,7);ff=frac(aval,Math.pow(10,ri)-1,false);o=""+sign;oa=write_num("n",r[1],ff[1]);if(oa.charAt(oa.length-1)==" ")oa=oa.substr(0,oa.length-1)+"0";o+=oa+r[2]+"/"+r[3];oa=rpad_(ff[2],ri);if(oa.length<r[4].length)oa=hashq(r[4].substr(r[4].length-oa.length))+oa;o+=oa;return o;}if(r=fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(Math.max(r[1].length,r[4].length),7);ff=frac(aval,Math.pow(10,ri)-1,true);return sign+(ff[0]||(ff[1]?"":"0"))+" "+(ff[1]?pad_(ff[1],ri)+r[2]+"/"+r[3]+rpad_(ff[2],ri):fill(" ",2*ri+1+r[2].length+r[3].length));}if(r=fmt.match(/^[#0?]+$/)){o=pad0r(val,0);if(fmt.length<=o.length)return o;return hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(/^([#0?]+)\.([#0]+)$/)){o=""+val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");ri=o.indexOf(".");var lres=fmt.indexOf(".")-ri,rres=fmt.length-o.length-lres;return hashq(fmt.substr(0,lres)+o+fmt.substr(fmt.length-rres));}if(r=fmt.match(/^00,000\.([#0]*0)$/)){ri=dec(val,r[1].length);return val<0?"-"+write_num_flt(type,fmt,-val):commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$){return"00,"+($$.length<3?pad0(0,3-$$.length):"")+$$;})+"."+pad0(ri,r[1].length);}switch(fmt){case"###,##0.00":return write_num_flt(type,"#,##0.00",val);case"###,###":case"##,###":case"#,###":var x=commaify(pad0r(aval,0));return x!=="0"?sign+x:"";case"###,###.00":return write_num_flt(type,"###,##0.00",val).replace(/^0\./,".");case"#,###.00":return write_num_flt(type,"#,##0.00",val).replace(/^0\./,".");}throw new Error("unsupported format |"+fmt+"|");}function write_num_cm2(type,fmt,val){var idx=fmt.length-1;while(fmt.charCodeAt(idx-1)===44){--idx;}return write_num(type,fmt.substr(0,idx),val/Math.pow(10,3*(fmt.length-idx)));}function write_num_pct2(type,fmt,val){var sfmt=fmt.replace(pct1,""),mul=fmt.length-sfmt.length;return write_num(type,sfmt,val*Math.pow(10,2*mul))+fill("%",mul);}function write_num_exp2(fmt,val){var o;var idx=fmt.indexOf("E")-fmt.indexOf(".")-1;if(fmt.match(/^#+0.0E\+0$/)){if(val==0)return"0.0E+0";else if(val<0)return"-"+write_num_exp2(fmt,-val);var period=fmt.indexOf(".");if(period===-1)period=fmt.indexOf("E");var ee=Math.floor(Math.log(val)*Math.LOG10E)%period;if(ee<0)ee+=period;o=(val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);if(!o.match(/[Ee]/)){var fakee=Math.floor(Math.log(val)*Math.LOG10E);if(o.indexOf(".")===-1)o=o.charAt(0)+"."+o.substr(1)+"E+"+(fakee-o.length+ee);else o+="E+"+(fakee-ee);o=o.replace(/\+-/,"-");}o=o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3){return $1+$2+$3.substr(0,(period+ee)%period)+"."+$3.substr(ee)+"E";});}else o=Number(val).toExponential(idx);if(fmt.match(/E\+00$/)&&o.match(/e[+-]\d$/))o=o.substr(0,o.length-1)+"0"+o.charAt(o.length-1);if(fmt.match(/E\-/)&&o.match(/e\+/))o=o.replace(/e\+/,"e");return o.replace("e","E");}function write_num_int(type,fmt,val){if(type.charCodeAt(0)===40&&!fmt.match(closeparen)){var ffmt=fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(val>=0)return write_num_int("n",ffmt,val);return"("+write_num_int("n",ffmt,-val)+")";}if(fmt.charCodeAt(fmt.length-1)===44)return write_num_cm2(type,fmt,val);if(fmt.indexOf("%")!==-1)return write_num_pct2(type,fmt,val);if(fmt.indexOf("E")!==-1)return write_num_exp2(fmt,val);if(fmt.charCodeAt(0)===36)return"$"+write_num_int(type,fmt.substr(fmt.charAt(1)==" "?2:1),val);var o;var r,ri,ff,aval=Math.abs(val),sign=val<0?"-":"";if(fmt.match(/^00+$/))return sign+pad0(aval,fmt.length);if(fmt.match(/^[#?]+$/)){o=""+val;if(val===0)o="";return o.length>fmt.length?o:hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(frac1))return write_num_f2(r,aval,sign);if(fmt.match(/^#+0+$/))return sign+pad0(aval,fmt.length-fmt.indexOf("0"));if(r=fmt.match(dec1)){o=(""+val).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1]));o=o.replace(/\.(\d*)$/,function($$,$1){return"."+$1+fill("0",hashq(r[1]).length-$1.length);});return fmt.indexOf("0.")!==-1?o:o.replace(/^0\./,".");}fmt=fmt.replace(/^#+([0.])/,"$1");if(r=fmt.match(/^(0*)\.(#*)$/)){return sign+(""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");}if(r=fmt.match(/^#{1,3},##0(\.?)$/))return sign+commaify(""+aval);if(r=fmt.match(/^#,##0\.([#0]*0)$/)){return val<0?"-"+write_num_int(type,fmt,-val):commaify(""+val)+"."+fill("0",r[1].length);}if(r=fmt.match(/^#,#*,#0/))return write_num_int(type,fmt.replace(/^#,#*,/,""),val);if(r=fmt.match(/^([0#]+)(\\?-([0#]+))+$/)){o=_strrev(write_num_int(type,fmt.replace(/[\\-]/g,""),val));ri=0;return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==="0"?"0":"";}));}if(fmt.match(phone)){o=write_num_int(type,"##########",val);return"("+o.substr(0,3)+") "+o.substr(3,3)+"-"+o.substr(6);}var oa="";if(r=fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(r[4].length,7);ff=frac(aval,Math.pow(10,ri)-1,false);o=""+sign;oa=write_num("n",r[1],ff[1]);if(oa.charAt(oa.length-1)==" ")oa=oa.substr(0,oa.length-1)+"0";o+=oa+r[2]+"/"+r[3];oa=rpad_(ff[2],ri);if(oa.length<r[4].length)oa=hashq(r[4].substr(r[4].length-oa.length))+oa;o+=oa;return o;}if(r=fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(Math.max(r[1].length,r[4].length),7);ff=frac(aval,Math.pow(10,ri)-1,true);return sign+(ff[0]||(ff[1]?"":"0"))+" "+(ff[1]?pad_(ff[1],ri)+r[2]+"/"+r[3]+rpad_(ff[2],ri):fill(" ",2*ri+1+r[2].length+r[3].length));}if(r=fmt.match(/^[#0?]+$/)){o=""+val;if(fmt.length<=o.length)return o;return hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(/^([#0]+)\.([#0]+)$/)){o=""+val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");ri=o.indexOf(".");var lres=fmt.indexOf(".")-ri,rres=fmt.length-o.length-lres;return hashq(fmt.substr(0,lres)+o+fmt.substr(fmt.length-rres));}if(r=fmt.match(/^00,000\.([#0]*0)$/)){return val<0?"-"+write_num_int(type,fmt,-val):commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$){return"00,"+($$.length<3?pad0(0,3-$$.length):"")+$$;})+"."+pad0(0,r[1].length);}switch(fmt){case"###,###":case"##,###":case"#,###":var x=commaify(""+aval);return x!=="0"?sign+x:"";default:if(fmt.match(/\.[0#?]*$/))return write_num_int(type,fmt.slice(0,fmt.lastIndexOf(".")),val)+hashq(fmt.slice(fmt.lastIndexOf(".")));}throw new Error("unsupported format |"+fmt+"|");}return function write_num(type,fmt,val){return(val|0)===val?write_num_int(type,fmt,val):write_num_flt(type,fmt,val);};}();function split_fmt(fmt){var out=[];var in_str=false;/*, cc*/for(var i=0,j=0;i<fmt.length;++i){switch(/*cc=*/fmt.charCodeAt(i)){case 34:/* '"' */in_str=!in_str;break;case 95:case 42:case 92:/* '_' '*' '\\' */++i;break;case 59:/* ';' */out[out.length]=fmt.substr(j,i-j);j=i+1;}}out[out.length]=fmt.substr(j);if(in_str===true)throw new Error("Format |"+fmt+"| unterminated string ");return out;}SSF._split=split_fmt;var abstime=/\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;function fmt_is_date(fmt){var i=0,/*cc = 0,*/c="",o="";while(i<fmt.length){switch(c=fmt.charAt(i)){case"G":if(isgeneral(fmt,i))i+=6;i++;break;case'"':for(;/*cc=*/fmt.charCodeAt(++i)!==34&&i<fmt.length;){/*empty*/}++i;break;case"\\":i+=2;break;case"_":i+=2;break;case"@":++i;break;case"B":case"b":if(fmt.charAt(i+1)==="1"||fmt.charAt(i+1)==="2")return true;/* falls through */case"M":case"D":case"Y":case"H":case"S":case"E":/* falls through */case"m":case"d":case"y":case"h":case"s":case"e":case"g":return true;case"A":case"a":case"上":if(fmt.substr(i,3).toUpperCase()==="A/P")return true;if(fmt.substr(i,5).toUpperCase()==="AM/PM")return true;if(fmt.substr(i,5).toUpperCase()==="上午/下午")return true;++i;break;case"[":o=c;while(fmt.charAt(i++)!=="]"&&i<fmt.length){o+=fmt.charAt(i);}if(o.match(abstime))return true;break;case".":/* falls through */case"0":case"#":while(i<fmt.length&&("0#?.,E+-%".indexOf(c=fmt.charAt(++i))>-1||c=="\\"&&fmt.charAt(i+1)=="-"&&"0#".indexOf(fmt.charAt(i+2))>-1)){/* empty */}break;case"?":while(fmt.charAt(++i)===c){/* empty */}break;case"*":++i;if(fmt.charAt(i)==" "||fmt.charAt(i)=="*")++i;break;case"(":case")":++i;break;case"1":case"2":case"3":case"4":case"5":case"6":case"7":case"8":case"9":while(i<fmt.length&&"0123456789".indexOf(fmt.charAt(++i))>-1){/* empty */}break;case" ":++i;break;default:++i;break;}}return false;}SSF.is_date=fmt_is_date;function eval_fmt(fmt,v,opts,flen){var out=[],o="",i=0,c="",lst="t",dt,j,cc;var hr="H";/* Tokenize */while(i<fmt.length){switch(c=fmt.charAt(i)){case"G":/* General */if(!isgeneral(fmt,i))throw new Error("unrecognized character "+c+" in "+fmt);out[out.length]={t:"G",v:"General"};i+=7;break;case'"':/* Literal text */for(o="";(cc=fmt.charCodeAt(++i))!==34&&i<fmt.length;){o+=String.fromCharCode(cc);}out[out.length]={t:"t",v:o};++i;break;case"\\":var w=fmt.charAt(++i),t=w==="("||w===")"?w:"t";out[out.length]={t:t,v:w};++i;break;case"_":out[out.length]={t:"t",v:" "};i+=2;break;case"@":/* Text Placeholder */out[out.length]={t:"T",v:v};++i;break;case"B":case"b":if(fmt.charAt(i+1)==="1"||fmt.charAt(i+1)==="2"){if(dt==null){dt=parse_date_code(v,opts,fmt.charAt(i+1)==="2");if(dt==null)return"";}out[out.length]={t:"X",v:fmt.substr(i,2)};lst=c;i+=2;break;}/* falls through */case"M":case"D":case"Y":case"H":case"S":case"E":c=c.toLowerCase();/* falls through */case"m":case"d":case"y":case"h":case"s":case"e":case"g":if(v<0)return"";if(dt==null){dt=parse_date_code(v,opts);if(dt==null)return"#####";}o=c;while(++i<fmt.length&&fmt.charAt(i).toLowerCase()===c){o+=c;}if(c==="m"&&lst.toLowerCase()==="h")c="M";if(c==="h")c=hr;out[out.length]={t:c,v:o};lst=c;break;case"A":case"a":case"上":var q={t:c,v:c};if(dt==null)dt=parse_date_code(v,opts);if(fmt.substr(i,3).toUpperCase()==="A/P"){if(dt!=null)q.v=dt.H>=12?"P":"A";q.t="T";hr="h";i+=3;}else if(fmt.substr(i,5).toUpperCase()==="AM/PM"){if(dt!=null)q.v=dt.H>=12?"PM":"AM";q.t="T";i+=5;hr="h";}else if(fmt.substr(i,5).toUpperCase()==="上午/下午"){if(dt!=null)q.v=dt.H>=12?"下午":"上午";q.t="T";i+=5;hr="h";}else{q.t="t";++i;}if(dt==null&&q.t==="T")return"";out[out.length]=q;lst=c;break;case"[":o=c;while(fmt.charAt(i++)!=="]"&&i<fmt.length){o+=fmt.charAt(i);}if(o.slice(-1)!=="]")throw'unterminated "[" block: |'+o+"|";if(o.match(abstime)){if(dt==null){dt=parse_date_code(v,opts);if(dt==null)return"";}out[out.length]={t:"Z",v:o.toLowerCase()};lst=o.charAt(1);}else if(o.indexOf("$")>-1){o=(o.match(/\$([^-\[\]]*)/)||[])[1]||"$";if(!fmt_is_date(fmt))out[out.length]={t:"t",v:o};}break;/* Numbers */case".":if(dt!=null){o=c;while(++i<fmt.length&&(c=fmt.charAt(i))==="0"){o+=c;}out[out.length]={t:"s",v:o};break;}/* falls through */case"0":case"#":o=c;while(++i<fmt.length&&"0#?.,E+-%".indexOf(c=fmt.charAt(i))>-1){o+=c;}out[out.length]={t:"n",v:o};break;case"?":o=c;while(fmt.charAt(++i)===c){o+=c;}out[out.length]={t:c,v:o};lst=c;break;case"*":++i;if(fmt.charAt(i)==" "||fmt.charAt(i)=="*")++i;break;// **
case"(":case")":out[out.length]={t:flen===1?"t":c,v:c};++i;break;case"1":case"2":case"3":case"4":case"5":case"6":case"7":case"8":case"9":o=c;while(i<fmt.length&&"0123456789".indexOf(fmt.charAt(++i))>-1){o+=fmt.charAt(i);}out[out.length]={t:"D",v:o};break;case" ":out[out.length]={t:c,v:c};++i;break;case"$":out[out.length]={t:"t",v:"$"};++i;break;default:// if ("¤฿BsBr₵₡₫ƒFtRs.₭kr£₤Lm₥₦₱PQRSkRp৲৳R$S/.〒₮₩¥NT￥zł₴₪៛руб€＄,$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
if("¤฿BsBr₵₡₫ƒFtRs.₭kr£₤Lm₥₦₱PQRSkRp৲৳R$S/.〒₮₩¥NT￥zł₴₪៛руб€₹＄,$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP$￥LekdinAf$dhAflRial?￡BirrKzMOPPGKRsGsB/R$ррlevkrKMzBsPNuFBuKPkrRD$NfkCFA?CVEGMDFrCDHTGNAfLFdjKGSFGGHSRielKCFknKshLSLL￡LtRFRONArRfMWKRMMURsMROS/KMDLMTnRC$kr€GELCHFSLLSCRDbSZLSDGSOSSomFCFPTShT$VUVQUGXгрнsomWSTNT$FtDramRpZMWFCFA".indexOf(c)===-1)throw new Error("unrecognized character "+c+" in "+fmt);out[out.length]={t:"t",v:c};++i;break;}}/* Scan for date/time parts */var bt=0,ss0=0,ssm;for(i=out.length-1,lst="t";i>=0;--i){switch(out[i].t){case"h":case"H":out[i].t=hr;lst="h";if(bt<1)bt=1;break;case"s":if(ssm=out[i].v.match(/\.0+$/))ss0=Math.max(ss0,ssm[0].length-1);if(bt<3)bt=3;/* falls through */case"d":case"y":case"M":case"e":lst=out[i].t;break;case"m":if(lst==="s"){out[i].t="M";if(bt<2)bt=2;}break;case"X":/*if(out[i].v === "B2");*/break;case"Z":if(bt<1&&out[i].v.match(/[Hh]/))bt=1;if(bt<2&&out[i].v.match(/[Mm]/))bt=2;if(bt<3&&out[i].v.match(/[Ss]/))bt=3;}}/* time rounding depends on presence of minute / second / usec fields */switch(bt){case 0:break;case 1:if(dt.u>=0.5){dt.u=0;++dt.S;}if(dt.S>=60){dt.S=0;++dt.M;}if(dt.M>=60){dt.M=0;++dt.H;}break;case 2:if(dt.u>=0.5){dt.u=0;++dt.S;}if(dt.S>=60){dt.S=0;++dt.M;}break;}/* replace fields */var nstr="",jj;for(i=0;i<out.length;++i){switch(out[i].t){case"t":case"T":case" ":case"D":break;case"X":out[i].v="";out[i].t=";";break;case"d":case"m":case"y":case"h":case"H":case"M":case"s":case"e":case"b":case"Z":out[i].v=write_date(out[i].t.charCodeAt(0),out[i].v,dt,ss0);out[i].t="t";break;case"n":case"?":jj=i+1;while(out[jj]!=null&&((c=out[jj].t)==="?"||c==="D"||(c===" "||c==="t")&&out[jj+1]!=null&&(out[jj+1].t==="?"||out[jj+1].t==="t"&&out[jj+1].v==="/")||out[i].t==="("&&(c===" "||c==="n"||c===")")||c==="t"&&(out[jj].v==="/"||out[jj].v===" "&&out[jj+1]!=null&&out[jj+1].t=="?"))){out[i].v+=out[jj].v;out[jj]={v:"",t:";"};++jj;}nstr+=out[i].v;i=jj-1;break;case"G":out[i].t="t";out[i].v=general_fmt(v,opts);break;}}var vv="",myv,ostr;if(nstr.length>0){if(nstr.charCodeAt(0)==40){/* '(' */myv=v<0&&nstr.charCodeAt(0)===45?-v:v;ostr=write_num("n",nstr,myv);}else{myv=v<0&&flen>1?-v:v;ostr=write_num("n",nstr,myv);if(myv<0&&out[0]&&out[0].t=="t"){ostr=ostr.substr(1);out[0].v="-"+out[0].v;}}jj=ostr.length-1;var decpt=out.length;for(i=0;i<out.length;++i){if(out[i]!=null&&out[i].t!="t"&&out[i].v.indexOf(".")>-1){decpt=i;break;}}var lasti=out.length;if(decpt===out.length&&ostr.indexOf("E")===-1){for(i=out.length-1;i>=0;--i){if(out[i]==null||"n?".indexOf(out[i].t)===-1)continue;if(jj>=out[i].v.length-1){jj-=out[i].v.length;out[i].v=ostr.substr(jj+1,out[i].v.length);}else if(jj<0)out[i].v="";else{out[i].v=ostr.substr(0,jj+1);jj=-1;}out[i].t="t";lasti=i;}if(jj>=0&&lasti<out.length)out[lasti].v=ostr.substr(0,jj+1)+out[lasti].v;}else if(decpt!==out.length&&ostr.indexOf("E")===-1){jj=ostr.indexOf(".")-1;for(i=decpt;i>=0;--i){if(out[i]==null||"n?".indexOf(out[i].t)===-1)continue;j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;vv=out[i].v.substr(j+1);for(;j>=0;--j){if(jj>=0&&(out[i].v.charAt(j)==="0"||out[i].v.charAt(j)==="#"))vv=ostr.charAt(jj--)+vv;}out[i].v=vv;out[i].t="t";lasti=i;}if(jj>=0&&lasti<out.length)out[lasti].v=ostr.substr(0,jj+1)+out[lasti].v;jj=ostr.indexOf(".")+1;for(i=decpt;i<out.length;++i){if(out[i]==null||"n?(".indexOf(out[i].t)===-1&&i!==decpt)continue;j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;vv=out[i].v.substr(0,j);for(;j<out[i].v.length;++j){if(jj<ostr.length)vv+=ostr.charAt(jj++);}out[i].v=vv;out[i].t="t";lasti=i;}}}for(i=0;i<out.length;++i){if(out[i]!=null&&"n?".indexOf(out[i].t)>-1){myv=flen>1&&v<0&&i>0&&out[i-1].v==="-"?-v:v;out[i].v=write_num(out[i].t,out[i].v,myv);out[i].t="t";}}var retval="";for(i=0;i!==out.length;++i){if(out[i]!=null)retval+=out[i].v;}return retval;}SSF._eval=eval_fmt;var cfregex=/\[[=<>]/;var cfregex2=/\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;function chkcond(v,rr){if(rr==null)return false;var thresh=parseFloat(rr[2]);switch(rr[1]){case"=":if(v==thresh)return true;break;case">":if(v>thresh)return true;break;case"<":if(v<thresh)return true;break;case"<>":if(v!=thresh)return true;break;case">=":if(v>=thresh)return true;break;case"<=":if(v<=thresh)return true;break;}return false;}function choose_fmt(f,v){var fmt=split_fmt(f);var l=fmt.length,lat=fmt[l-1].indexOf("@");if(l<4&&lat>-1)--l;if(fmt.length>4)throw new Error("cannot find right format for |"+fmt.join("|")+"|");// 这行代码弃用，有可能v会有"1"的情况出现，并且需要排查true，false，‘ ’这些值所以需要使用parseFloat(v).toString()去判断是不是Number类型
// if (typeof v !== "number")
if(parseFloat(v).toString()=="NaN")return[4,fmt.length===4||lat>-1?fmt[fmt.length-1]:"@"];switch(fmt.length){case 1:fmt=lat>-1?["General","General","General",fmt[0]]:[fmt[0],fmt[0],fmt[0],"@"];break;case 2:fmt=lat>-1?[fmt[0],fmt[0],fmt[0],fmt[1]]:[fmt[0],fmt[1],fmt[0],"@"];break;case 3:fmt=lat>-1?[fmt[0],fmt[1],fmt[0],fmt[2]]:[fmt[0],fmt[1],fmt[2],"@"];break;}var ff=v>0?fmt[0]:v<0?fmt[1]:fmt[2];if(fmt[0].indexOf("[")===-1&&fmt[1].indexOf("[")===-1)return[l,ff];if(fmt[0].match(cfregex)!=null||fmt[1].match(cfregex)!=null){var m1=fmt[0].match(cfregex2);var m2=fmt[1].match(cfregex2);return chkcond(v,m1)?[l,fmt[0]]:chkcond(v,m2)?[l,fmt[1]]:[l,fmt[m1!=null&&m2!=null?2:1]];}return[l,ff];}function format(fmt,v,o){if(o==null)o={};var sfmt="";switch(index_esm_typeof(fmt)){case"string":if(fmt=="m/d/yy"&&o.dateNF)sfmt=o.dateNF;else sfmt=fmt;break;case"number":if(fmt==14&&o.dateNF)sfmt=o.dateNF;else sfmt=(o.table!=null?o.table:table_fmt)[fmt];if(sfmt==null)sfmt=o.table&&o.table[default_map[fmt]]||table_fmt[default_map[fmt]];if(sfmt==null)sfmt=default_str[fmt]||"General";break;}//new runze 增加万 亿 格式
//注："w":2万2500  "w0":2万2500  "w0.0":2万2500.2  "w0.00":2万2500.23......自定义精确度
var reg=/^(w|W)((0?)|(0\.0+))$/;if(!!sfmt.match(reg)){if(isNaN(v)){return v;}//var v =300101886.436;
var acc=sfmt.slice(1);//取得0/0.0/0.00
var isNegative=false;if(!isNaN(v)&&Number(v)<0){isNegative=true;v=Math.abs(v);}var vInt=parseInt(v);var vlength=vInt.toString().length;if(vlength>4){if(vlength>8){var y=parseInt(v/100000000);//亿
var w=parseInt(parseFloat(v)-y*100000000/10000);//万
var q=parseFloat(v)-(y*100000000+w*10000);//千以后
if(acc!=""){q=numeral_default()(q).format(acc);//处理精确度
}v=y+"亿"+w+"万"+q;}else{var w=parseInt(v/10000);//万
var q=parseFloat(v)-w*10000;//千以后
if(acc!=""){q=numeral_default()(q).format(acc);//处理精确度
}v=w+"万"+q;}if(v.indexOf("亿0万0")!=-1){v=v.replace("0万0","");}else if(v.indexOf("亿0万")!=-1){v=v.replace("0万","");}else if(v.indexOf("万0")!=-1){v=v.replace("万0","万");}//舍弃正则后顾断言写法，旧浏览器不识别（360 V9）
if(v.indexOf("亿")!=-1&&v.indexOf("万")==-1){//1亿/1亿111 => 1亿/1亿0111
var afterYi=v.substring(v.indexOf("亿")+1);if(afterYi.substring(0,1)!=="."&&afterYi!=""){switch((parseInt(afterYi)+"").length){case 1:afterYi="000"+afterYi;break;case 2:afterYi="00"+afterYi;break;case 3:afterYi="0"+afterYi;break;}v=v.substring(0,v.indexOf("亿")+1)+afterYi;}}else if(v.indexOf("亿")==-1&&v.indexOf("万")!=-1){//3万0011
var afterWan=v.substring(v.indexOf("万")+1);if(afterWan.substring(0,1)!=="."&&afterWan!=""){switch((parseInt(afterWan)+"").length){case 1:afterWan="000"+afterWan;break;case 2:afterWan="00"+afterWan;break;case 3:afterWan="0"+afterWan;break;}v=v.substring(0,v.indexOf("万")+1)+afterWan;}}else if(v.indexOf("亿")!=-1&&v.indexOf("万")!=-1){//1亿0053万0611
var afterYi=v.substring(v.indexOf("亿")+1,v.indexOf("万")),afterWan=v.substring(v.indexOf("万")+1);switch((parseInt(afterYi)+"").length){case 1:afterYi="000"+afterYi;break;case 2:afterYi="00"+afterYi;break;case 3:afterYi="0"+afterYi;break;}v=v.substring(0,v.indexOf("亿")+1)+afterYi+v.substring(v.indexOf("万"));if(afterWan.substring(0,1)!=="."&&afterWan!=""){switch((parseInt(afterWan)+"").length){case 1:afterWan="000"+afterWan;break;case 2:afterWan="00"+afterWan;break;case 3:afterWan="0"+afterWan;break;}v=v.substring(0,v.indexOf("万")+1)+afterWan;}}}else{if(acc!=""){v=numeral_default()(v).format(acc);//处理精确度
}}if(isNegative){return"-"+v;}else{return v;}}if(isgeneral(sfmt,0))return general_fmt(v,o);if(v instanceof Date)v=datenum_local(v,o.date1904);var f=choose_fmt(sfmt,v);if(isgeneral(f[1]))return general_fmt(v,o);if(v===true)v="TRUE";else if(v===false)v="FALSE";else if(v===""||v==null)return"";return eval_fmt(f[1],v,o,f[0]);}function load_entry(fmt,idx){if(typeof idx!="number"){idx=+idx||-1;for(var i=0;i<0x0188;++i){if(table_fmt[i]==undefined){if(idx<0)idx=i;continue;}if(table_fmt[i]==fmt){idx=i;break;}}if(idx<0)idx=0x187;}table_fmt[idx]=fmt;return idx;}SSF.load=load_entry;SSF._table=table_fmt;SSF.get_table=function get_table(){return table_fmt;};SSF.load_table=function load_table(tbl){for(var i=0;i!=0x0188;++i){if(tbl[i]!==undefined)load_entry(tbl[i],i);}};SSF.init_table=init_table;SSF.format=format;};make_ssf(SSF);var base1904=new Date(1900,2,1,0,0,0);function datenum_local(v,date1904){var epoch=Date.UTC(v.getFullYear(),v.getMonth(),v.getDate(),v.getHours(),v.getMinutes(),v.getSeconds());var dnthresh_utc=Date.UTC(1899,11,31,0,0,0);if(date1904)epoch-=1461*24*60*60*1000;else if(v>=base1904)epoch+=24*60*60*1000;return(epoch-dnthresh_utc)/(24*60*60*1000);}var good_pd_date=new Date("2017-02-19T19:06:09.000Z");if(Number.isNaN(good_pd_date.getFullYear()))good_pd_date=new Date("2/19/17");var good_pd=good_pd_date.getFullYear()===2017;function parseDate(str,fixdate){var d=new Date(str);if(good_pd){if(!lodash_default().isNil(fixdate)){if(fixdate>0)d.setTime(d.getTime()+d.getTimezoneOffset()*60*1000);else if(fixdate<0)d.setTime(d.getTime()-d.getTimezoneOffset()*60*1000);}return d;}if(str instanceof Date)return str;if(good_pd_date.getFullYear()===1917&&!Number.isNaN(d.getFullYear())){var s=d.getFullYear();if(str.indexOf("".concat(s))>-1)return d;d.setFullYear(d.getFullYear()+100);return d;}var n=str.match(/\d+/g)||["2017","2","19","0","0","0"];var out=new Date(+n[0],+n[1]-1,+n[2],+n[3]||0,+n[4]||0,+n[5]||0);if(str.indexOf("Z")>-1)out=new Date(out.getTime()-out.getTimezoneOffset()*60*1000);return out;}function genarate(value){var m=null;var ct={};var v=value;if(lodash_default().isNil(value)){return null;}if(/^-?[0-9]{1,}[,][0-9]{3}(.[0-9]{1,2})?$/.test(value)){value=value;m=value;v=Number(value.split(".")[0].replace(",",""));var fa="#,##0";if(value.split(".")[1]){fa="#,##0.";for(var i=0;i<value.split(".")[1].length;i+=1){fa+=0;}}ct={fa:fa,t:"n"};}else if(value.toString().substring(0,1)==="'"){m=value.toString().substring(1);ct={fa:"@",t:"s"};}else if(value.toString().toUpperCase()==="TRUE"){m="TRUE";ct={fa:"General",t:"b"};v=true;}else if(value.toString().toUpperCase()==="FALSE"){m="FALSE";ct={fa:"General",t:"b"};v=false;}else if(valueIsError(value.toString())){m=value.toString();ct={fa:"General",t:"e"};}else if(/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(value)){m=value.toString();ct={fa:"@",t:"s"};}else if(isRealNum(value)&&Math.abs(parseFloat(value))>0&&(Math.abs(parseFloat(value))>=1e11||Math.abs(parseFloat(value))<1e-9)){v=parseFloat(value);var str=v.toExponential();if(str.indexOf(".")>-1){var strlen=str.split(".")[1].split("e")[0].length;if(strlen>5){strlen=5;}ct={fa:"#0.".concat(new Array(strlen+1).join("0"),"E+00"),t:"n"};}else{ct={fa:"#0.E+00",t:"n"};}m=SSF.format(ct.fa,v);}else if(value.toString().indexOf("%")>-1){var index=value.toString().indexOf("%");var value2=value.toString().substring(0,index);var value3=value2.replace(/,/g,"");if(index===value.toString().length-1&&isRealNum(value3)){if(value2.indexOf(".")>-1){if(value2.indexOf(".")===value2.lastIndexOf(".")){var value4=value2.split(".")[0];var value5=value2.split(".")[1];var len=value5.length;if(len>9){len=9;}if(value4.indexOf(",")>-1){var isThousands=true;var ThousandsArr=value4.split(",");for(var _i=1;_i<ThousandsArr.length;_i+=1){if(ThousandsArr[_i].length<3){isThousands=false;break;}}if(isThousands){ct={fa:"#,##0.".concat(new Array(len+1).join("0"),"%"),t:"n"};v=numeral_default()(value).value();m=SSF.format(ct.fa,v);}else{m=value.toString();ct={fa:"@",t:"s"};}}else{ct={fa:"0.".concat(new Array(len+1).join("0"),"%"),t:"n"};v=numeral_default()(value).value();m=SSF.format(ct.fa,v);}}else{m=value.toString();ct={fa:"@",t:"s"};}}else if(value2.indexOf(",")>-1){var _isThousands=true;var _ThousandsArr=value2.split(",");for(var _i2=1;_i2<_ThousandsArr.length;_i2+=1){if(_ThousandsArr[_i2].length<3){_isThousands=false;break;}}if(_isThousands){ct={fa:"#,##0%",t:"n"};v=numeral_default()(value).value();m=SSF.format(ct.fa,v);}else{m=value.toString();ct={fa:"@",t:"s"};}}else{ct={fa:"0%",t:"n"};v=numeral_default()(value).value();m=SSF.format(ct.fa,v);}}else{m=value.toString();ct={fa:"@",t:"s"};}}else if(value.toString().indexOf(".")>-1){if(value.toString().indexOf(".")===value.toString().lastIndexOf(".")){var value1=value.toString().split(".")[0];var _value=value.toString().split(".")[1];var _len=_value.length;if(_len>9){_len=9;}if(value1.indexOf(",")>-1){var _isThousands2=true;var _ThousandsArr2=value1.split(",");for(var _i3=1;_i3<_ThousandsArr2.length;_i3+=1){if(!isRealNum(_ThousandsArr2[_i3])||_ThousandsArr2[_i3].length<3){_isThousands2=false;break;}}if(_isThousands2){ct={fa:"#,##0.".concat(new Array(_len+1).join("0")),t:"n"};v=numeral_default()(value).value();m=SSF.format(ct.fa,v);}else{m=value.toString();ct={fa:"@",t:"s"};}}else{if(isRealNum(value1)&&isRealNum(_value)){ct={fa:"0.".concat(new Array(_len+1).join("0")),t:"n"};v=numeral_default()(value).value();m=SSF.format(ct.fa,v);}else{m=value.toString();ct={fa:"@",t:"s"};}}}else{m=value.toString();ct={fa:"@",t:"s"};}}else if(isRealNum(value)){m=parseFloat(value).toString();ct={fa:"General",t:"n"};v=parseFloat(value);}else if(isdatetime(value)&&(value.toString().indexOf(".")>-1||value.toString().indexOf(":")>-1||value.toString().length<16)){v=datenum_local(parseDate(value.toString().replace(/-/g,"/")));if(v.toString().indexOf(".")>-1){if(value.toString().length>18){ct.fa="yyyy-MM-dd hh:mm:ss";}else if(value.toString().length>11){ct.fa="yyyy-MM-dd hh:mm";}else{ct.fa="yyyy-MM-dd";}}else{ct.fa="yyyy-MM-dd";}ct.t="d";m=SSF.format(ct.fa,v);}else{m=value;ct.fa="General";ct.t="g";}return[m,ct,v];}function update(fmt,v){return SSF.format(fmt,v);}function is_date(fmt,v){return SSF.is_date(fmt,v);}function fuzzynum(s){var v=Number(s);if(typeof s==="number"){return s;}if(!Number.isNaN(v))return v;var wt=1;var ss=s.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g,function(){wt*=100;return"";});v=Number(ss);if(!Number.isNaN(v))return v/wt;ss=ss.replace(/[(](.*)[)]/,function($$,$1){wt=-wt;return $1;});v=Number(ss);if(!Number.isNaN(v))return v/wt;return v;}function valueShowEs(r,c,d){var value=getCellValue(r,c,d,"m");if(value==null){value=getCellValue(r,c,d,"v");}else{var _d$r,_d$r$c,_d$r$c$ct,_d$r2,_d$r2$c,_d$r2$c$ct;if(!Number.isNaN(fuzzynum(value))){if(lodash_default().isString(value)&&value.indexOf("%")>-1);else{value=getCellValue(r,c,d,"v");}}else if(((_d$r=d[r])===null||_d$r===void 0?void 0:(_d$r$c=_d$r[c])===null||_d$r$c===void 0?void 0:(_d$r$c$ct=_d$r$c.ct)===null||_d$r$c$ct===void 0?void 0:_d$r$c$ct.t)==="d");else if(((_d$r2=d[r])===null||_d$r2===void 0?void 0:(_d$r2$c=_d$r2[c])===null||_d$r2$c===void 0?void 0:(_d$r2$c$ct=_d$r2$c.ct)===null||_d$r2$c$ct===void 0?void 0:_d$r2$c$ct.t)==="b");else{value=getCellValue(r,c,d,"v");}}return value;}var colors=["#c1232b","#27727b","#fcce10","#e87c25","#b5c334","#fe8463","#9bca63","#fad860","#f3a43b","#60c0dd","#d7504b","#c6e579","#f4e001","#f0805a","#26c0c0","#c12e34","#e6b600","#0098d9","#2b821d","#005eaa","#339ca8","#cda819","#32a487","#3fb1e3","#6be6c1","#626c91","#a0a7e6","#c4ebad","#96dee8"];function mousePosition(x,y,ctx){var newX=x-ctx.rowHeaderWidth;var newY=y-ctx.toolbarHeight-ctx.calculatebarHeight-ctx.columnHeaderHeight;return[newX,newY];}function rowLocationByIndex(row_index,visibleRow){var row=0;var row_pre=0;row=visibleRow[row_index];if(row_index===0){row_pre=0;}else{row_pre=visibleRow[row_index-1];}return[row_pre,row,row_index];}function rowLocation(y,visibleRow){var row_index=lodash_default().sortedIndex(visibleRow,y);if(row_index>=visibleRow.length&&y>0){row_index=visibleRow.length-1;}else if(row_index===-1&&y<=0){row_index=0;}return rowLocationByIndex(row_index,visibleRow);}function colLocationByIndex(col_index,visibleCol){var col=0;var col_pre=0;col=visibleCol[col_index];if(col_index===0){col_pre=0;}else{col_pre=visibleCol[col_index-1];}return[col_pre,col,col_index];}function colLocation(x,visibleCol){var col_index=lodash_default().sortedIndex(visibleCol,x);if(col_index>=visibleCol.length&&x>0){col_index=visibleCol.length-1;}else if(col_index===-1&&x<=0){col_index=0;}return colLocationByIndex(col_index,visibleCol);}var functionHTMLIndex=0;var rangeIndexes=[];var operatorPriority={"^":0,"%":1,"*":1,"/":1,"+":2,"-":2};var operatorArr="==|!=|<>|<=|>=|=|+|-|>|<|/|*|%|&|^".split("|");var operatorjson={};for(var i=0;i<operatorArr.length;i+=1){operatorjson[operatorArr[i].toString()]=1;}var index_esm_simpleSheetName="[A-Za-z0-9_\xC0-\u02AF]+";var index_esm_quotedSheetName="'(?:(?!').|'')*'";var index_esm_sheetNameRegexp="(".concat(index_esm_simpleSheetName,"|").concat(index_esm_quotedSheetName,")!");var rowColumnRegexp="[$]?[A-Za-z]+[$]?[0-9]+";var rowColumnWithSheetName="(?:".concat(index_esm_sheetNameRegexp,")?(").concat(rowColumnRegexp,")");var index_esm_LABEL_EXTRACT_REGEXP=new RegExp("^".concat(rowColumnWithSheetName,"(?:[:]").concat(rowColumnWithSheetName,")?$"));var FormulaCache=/*#__PURE__*/function(){function FormulaCache(){index_esm_classCallCheck(this,FormulaCache);this.parser=void 0;this.func_selectedrange=void 0;this.data_parm_index=void 0;this.cellTextToIndexList=void 0;this.rangechangeindex=void 0;this.selectingRangeIndex=void 0;this.rangeResizeObj=void 0;this.rangeResize=void 0;this.rangeResizeIndex=void 0;this.rangeResizexy=void 0;this.rangeResizeWinH=void 0;this.rangeResizeWinW=void 0;this.rangeResizeTo=void 0;this.rangeSetValueTo=void 0;this.rangeIndex=void 0;this.rangestart=void 0;this.rangetosheet=void 0;this.rangedrag_column_start=void 0;this.rangedrag_row_start=void 0;this.functionRangeIndex=void 0;this.functionlistMap=void 0;this.execFunctionExist=void 0;this.execFunctionGlobalData=void 0;var that=this;this.data_parm_index=0;this.selectingRangeIndex=-1;this.functionlistMap={};this.execFunctionGlobalData={};this.cellTextToIndexList={};this.parser=new es_parser();this.parser.on("callCellValue",function(cellCoord,options,done){var _context$formulaCache,_flowdata$cellCoord$r;var context=that.parser.context;var id=cellCoord.sheetName==null?options.sheetId:getSheetIdByName(context,cellCoord.sheetName);if(id==null)throw Error(ERROR_REF);var flowdata=getFlowdata(context,id);var cell=(context===null||context===void 0?void 0:(_context$formulaCache=context.formulaCache.execFunctionGlobalData)===null||_context$formulaCache===void 0?void 0:_context$formulaCache["".concat(cellCoord.row.index,"_").concat(cellCoord.column.index,"_").concat(id)])||(flowdata===null||flowdata===void 0?void 0:(_flowdata$cellCoord$r=flowdata[cellCoord.row.index])===null||_flowdata$cellCoord$r===void 0?void 0:_flowdata$cellCoord$r[cellCoord.column.index]);var v=that.tryGetCellAsNumber(cell);done(v);});this.parser.on("callRangeValue",function(startCellCoord,endCellCoord,options,done){var context=that.parser.context;var id=startCellCoord.sheetName==null?options.sheetId:getSheetIdByName(context,startCellCoord.sheetName);if(id==null)throw Error(ERROR_REF);var flowdata=getFlowdata(context,id);var fragment=[];var startRow=startCellCoord.row.index;var endRow=endCellCoord.row.index;var startCol=startCellCoord.column.index;var endCol=endCellCoord.column.index;var emptyRow=startRow===-1||endRow===-1;var emptyCol=startCol===-1||endCol===-1;if(emptyRow){var _flowdata$length;startRow=0;endRow=(_flowdata$length=flowdata===null||flowdata===void 0?void 0:flowdata.length)!==null&&_flowdata$length!==void 0?_flowdata$length:0;}if(emptyCol){var _flowdata$0$length;startCol=0;endCol=(_flowdata$0$length=flowdata===null||flowdata===void 0?void 0:flowdata[0].length)!==null&&_flowdata$0$length!==void 0?_flowdata$0$length:0;}if(emptyRow&&emptyCol)throw Error(ERROR_REF);for(var row=startRow;row<=endRow;row+=1){var colFragment=[];for(var col=startCol;col<=endCol;col+=1){var _context$formulaCache2,_flowdata$row;var cell=(context===null||context===void 0?void 0:(_context$formulaCache2=context.formulaCache.execFunctionGlobalData)===null||_context$formulaCache2===void 0?void 0:_context$formulaCache2["".concat(row,"_").concat(col,"_").concat(id)])||(flowdata===null||flowdata===void 0?void 0:(_flowdata$row=flowdata[row])===null||_flowdata$row===void 0?void 0:_flowdata$row[col]);var v=that.tryGetCellAsNumber(cell);colFragment.push(v);}fragment.push(colFragment);}if(fragment){done(fragment);}});}index_esm_createClass(FormulaCache,[{key:"tryGetCellAsNumber",value:function tryGetCellAsNumber(cell){var _cell$ct;if((cell===null||cell===void 0?void 0:(_cell$ct=cell.ct)===null||_cell$ct===void 0?void 0:_cell$ct.t)==="n"){var n=Number(cell===null||cell===void 0?void 0:cell.v);return Number.isNaN(n)?cell.v:n;}return cell===null||cell===void 0?void 0:cell.v;}}]);return FormulaCache;}();function parseElement(eleString){return new DOMParser().parseFromString(eleString,"text/html").body.childNodes[0];}function iscelldata(txt){var val=txt.split("!");var rangetxt;if(val.length>1){var _val=index_esm_slicedToArray(val,2);rangetxt=_val[1];}else{var _val2=index_esm_slicedToArray(val,1);rangetxt=_val2[0];}var reg_cell=/^(([a-zA-Z]+)|([$][a-zA-Z]+))(([0-9]+)|([$][0-9]+))$/g;var reg_cellRange=/^(((([a-zA-Z]+)|([$][a-zA-Z]+))(([0-9]+)|([$][0-9]+)))|((([a-zA-Z]+)|([$][a-zA-Z]+))))$/g;if(rangetxt.indexOf(":")===-1){var _row=parseInt(rangetxt.replace(/[^0-9]/g,""),10)-1;var _col=columnCharToIndex(rangetxt.replace(/[^A-Za-z]/g,""));if(!Number.isNaN(_row)&&!Number.isNaN(_col)&&rangetxt.toString().match(reg_cell)){return true;}if(!Number.isNaN(_row)){return false;}if(!Number.isNaN(_col)){return false;}return false;}reg_cellRange=/^(((([a-zA-Z]+)|([$][a-zA-Z]+))(([0-9]+)|([$][0-9]+)))|((([a-zA-Z]+)|([$][a-zA-Z]+)))|((([0-9]+)|([$][0-9]+s))))$/g;var rangetxtArr=rangetxt.split(":");var row=[];var col=[];row[0]=parseInt(rangetxtArr[0].replace(/[^0-9]/g,""),10)-1;row[1]=parseInt(rangetxtArr[1].replace(/[^0-9]/g,""),10)-1;if(row[0]>row[1]){return false;}col[0]=columnCharToIndex(rangetxtArr[0].replace(/[^A-Za-z]/g,""));col[1]=columnCharToIndex(rangetxtArr[1].replace(/[^A-Za-z]/g,""));if(col[0]>col[1]){return false;}if(rangetxtArr[0].toString().match(reg_cellRange)&&rangetxtArr[1].toString().match(reg_cellRange)){return true;}return false;}function addToCellIndexList(ctx,txt,infoObj){if(lodash_default().isNil(txt)||txt.length===0||lodash_default().isNil(infoObj)){return;}if(lodash_default().isNil(ctx.formulaCache.cellTextToIndexList)){ctx.formulaCache.cellTextToIndexList={};}if(txt.indexOf("!")>-1){txt=txt.replace(/\\'/g,"'").replace(/''/g,"'");ctx.formulaCache.cellTextToIndexList[txt]=infoObj;}else{ctx.formulaCache.cellTextToIndexList["".concat(txt,"_").concat(infoObj.sheetId)]=infoObj;}}function getcellrange(ctx,txt,formulaId){if(lodash_default().isNil(txt)||txt.length===0){return null;}var flowdata=getFlowdata(ctx,formulaId);var sheettxt="";var rangetxt="";var sheetId=null;var sheetdata=null;var luckysheetfile=ctx.luckysheetfile;if(txt.indexOf("!")>-1){if(txt in ctx.formulaCache.cellTextToIndexList){return ctx.formulaCache.cellTextToIndexList[txt];}var matchRes=txt.match(index_esm_LABEL_EXTRACT_REGEXP);if(matchRes==null){return null;}var _matchRes=index_esm_slicedToArray(matchRes,5),sheettxt1=_matchRes[1],starttxt1=_matchRes[2],sheettxt2=_matchRes[3],starttxt2=_matchRes[4];if(sheettxt2!=null&&sheettxt1!==sheettxt2){return null;}rangetxt=starttxt2?"".concat(starttxt1,":").concat(starttxt2):starttxt1;sheettxt=sheettxt1.replace(/^'|'$/g,"").replace(/\\'/g,"'").replace(/''/g,"'");lodash_default().forEach(luckysheetfile,function(f){if(sheettxt===f.name){sheetId=f.id;sheetdata=f.data;return false;}return true;});}else{var _i=formulaId;if(lodash_default().isNil(_i)){_i=ctx.currentSheetId;}if("".concat(txt,"_").concat(_i)in ctx.formulaCache.cellTextToIndexList){return ctx.formulaCache.cellTextToIndexList["".concat(txt,"_").concat(_i)];}var index=getSheetIndex(ctx,_i);if(lodash_default().isNil(index)){return null;}sheettxt=luckysheetfile[index].name;sheetId=luckysheetfile[index].id;sheetdata=flowdata;rangetxt=txt;}if(lodash_default().isNil(sheetdata)){return null;}if(rangetxt.indexOf(":")===-1){var _row2=parseInt(rangetxt.replace(/[^0-9]/g,""),10)-1;var _col2=columnCharToIndex(rangetxt.replace(/[^A-Za-z]/g,""));if(!Number.isNaN(_row2)&&!Number.isNaN(_col2)){var _item={row:[_row2,_row2],column:[_col2,_col2],sheetId:sheetId};addToCellIndexList(ctx,txt,_item);return _item;}return null;}var rangetxtArr=rangetxt.split(":");var row=[];var col=[];row[0]=parseInt(rangetxtArr[0].replace(/[^0-9]/g,""),10)-1;row[1]=parseInt(rangetxtArr[1].replace(/[^0-9]/g,""),10)-1;if(Number.isNaN(row[0])){row[0]=0;}if(Number.isNaN(row[1])){row[1]=sheetdata.length-1;}if(row[0]>row[1]){return null;}col[0]=columnCharToIndex(rangetxtArr[0].replace(/[^A-Za-z]/g,""));col[1]=columnCharToIndex(rangetxtArr[1].replace(/[^A-Za-z]/g,""));if(Number.isNaN(col[0])){col[0]=0;}if(Number.isNaN(col[1])){col[1]=sheetdata[0].length-1;}if(col[0]>col[1]){return null;}var item={row:row,column:col,sheetId:sheetId};addToCellIndexList(ctx,txt,item);return item;}function calPostfixExpression(cal){if(cal.length===0){return"";}var stack=[];for(var _i2=cal.length-1;_i2>=0;_i2-=1){var c=cal[_i2];if(c in operatorjson){var s2=stack.pop();var s1=stack.pop();var str="luckysheet_compareWith(".concat(s1,",'").concat(c,"', ").concat(s2,")");stack.push(str);}else{stack.push(c);}}if(stack.length>0){return stack[0];}return"";}function checkSpecialFunctionRange(ctx,function_str,r,c,id,dynamicArray_compute,cellRangeFunction){if(function_str.substring(0,30)==="luckysheet_getSpecialReference"||function_str.substring(0,20)==="luckysheet_function."){if(function_str.substring(0,20)==="luckysheet_function."){var funcName=function_str.split(".")[1];if(!lodash_default().isNil(funcName)){funcName=funcName.toUpperCase();if(funcName!=="INDIRECT"&&funcName!=="OFFSET"&&funcName!=="INDEX"){return;}}}try{ctx.calculateSheetId=id;var str=function_str.split(",")[function_str.split(",").length-1].split("'")[1].split("'")[0];var str_nb=lodash_default().trim(str);if(iscelldata(str_nb)){if(typeof cellRangeFunction==="function"){cellRangeFunction(str_nb);}}}catch(_unused){}}}function isFunctionRange(ctx,txt,r,c,id,dynamicArray_compute,cellRangeFunction){if(txt.substring(0,1)==="="){txt=txt.substring(1);}var funcstack=txt.split("");var i=0;var str="";var function_str="";var matchConfig={bracket:0,comma:0,squote:0,dquote:0,compare:0,braces:0};var cal1=[];var cal2=[];var bracket=[];while(i<funcstack.length){var s=funcstack[i];if(s==="("&&matchConfig.squote===0&&matchConfig.dquote===0&&matchConfig.braces===0){if(str.length>0&&bracket.length===0){str=str.toUpperCase();if(str.indexOf(":")>-1){var funcArray=str.split(":");function_str+="luckysheet_getSpecialReference(true,'".concat(lodash_default().trim(funcArray[0]).replace(/'/g,"\\'"),"', luckysheet_function.").concat(funcArray[1],".f(#lucky#");}else{function_str+="luckysheet_function.".concat(str,".f(");}bracket.push(1);str="";}else if(bracket.length===0){function_str+="(";bracket.push(0);str="";}else{bracket.push(0);str+=s;}}else if(s===")"&&matchConfig.squote===0&&matchConfig.dquote===0&&matchConfig.braces===0){bracket.pop();if(bracket.length===0){var functionS=isFunctionRange(ctx,str,r,c,id,dynamicArray_compute,cellRangeFunction);if(functionS.indexOf("#lucky#")>-1){functionS="".concat(functionS.replace(/#lucky#/g,""),")");}function_str+="".concat(functionS,")");str="";}else{str+=s;}}else if(s==="{"&&matchConfig.squote===0&&matchConfig.dquote===0){str+="{";matchConfig.braces+=1;}else if(s==="}"&&matchConfig.squote===0&&matchConfig.dquote===0){str+="}";matchConfig.braces-=1;}else if(s==='"'&&matchConfig.squote===0){if(matchConfig.dquote>0){if(i<funcstack.length-1&&funcstack[i+1]==='"'){i+=1;str+="\x7F";}else{matchConfig.dquote-=1;str+='"';}}else{matchConfig.dquote+=1;str+='"';}}else if(s==="'"&&matchConfig.dquote===0){str+="'";if(matchConfig.squote>0){if(i<funcstack.length-1&&funcstack[i+1]==="'"){i+=1;str+="'";}else{matchConfig.squote-=1;}}else{matchConfig.squote+=1;}}else if(s===","&&matchConfig.squote===0&&matchConfig.dquote===0&&matchConfig.braces===0){if(bracket.length<=1){var _functionS=isFunctionRange(ctx,str,r,c,id,dynamicArray_compute,cellRangeFunction);if(_functionS.indexOf("#lucky#")>-1){_functionS="".concat(_functionS.replace(/#lucky#/g,""),")");}function_str+="".concat(_functionS,",");str="";}else{str+=",";}}else if(s in operatorjson&&matchConfig.squote===0&&matchConfig.dquote===0&&matchConfig.braces===0){var s_next="";var op=operatorPriority;if(i+1<funcstack.length){s_next=funcstack[i+1];}if(s+s_next in operatorjson){if(bracket.length===0){if(lodash_default().trim(str).length>0){cal2.unshift(isFunctionRange(ctx,lodash_default().trim(str),r,c,id,dynamicArray_compute,cellRangeFunction));}else if(lodash_default().trim(function_str).length>0){cal2.unshift(lodash_default().trim(function_str));}if(cal1[0]in operatorjson){var stackCeilPri=op[cal1[0]];while(cal1.length>0&&!lodash_default().isNil(stackCeilPri)){cal2.unshift(cal1.shift());stackCeilPri=op[cal1[0]];}}cal1.unshift(s+s_next);function_str="";str="";}else{str+=s+s_next;}i+=1;}else{if(bracket.length===0){if(lodash_default().trim(str).length>0){cal2.unshift(isFunctionRange(ctx,lodash_default().trim(str),r,c,id,dynamicArray_compute,cellRangeFunction));}else if(lodash_default().trim(function_str).length>0){cal2.unshift(lodash_default().trim(function_str));}if(cal1[0]in operatorjson){var _stackCeilPri=op[cal1[0]];_stackCeilPri=lodash_default().isNil(_stackCeilPri)?1000:_stackCeilPri;var sPri=op[s];sPri=lodash_default().isNil(sPri)?1000:sPri;while(cal1.length>0&&sPri>=_stackCeilPri){cal2.unshift(cal1.shift());_stackCeilPri=op[cal1[0]];_stackCeilPri=lodash_default().isNil(_stackCeilPri)?1000:_stackCeilPri;}}cal1.unshift(s);function_str="";str="";}else{str+=s;}}}else{if(matchConfig.dquote===0&&matchConfig.squote===0){str+=lodash_default().trim(s);}else{str+=s;}}if(i===funcstack.length-1){var endstr="";var str_nb=lodash_default().trim(str).replace(/'/g,"\\'");if(iscelldata(str_nb)&&str_nb.substring(0,1)!==":"){endstr="luckysheet_getcelldata('".concat(str_nb,"')");}else if(str_nb.substring(0,1)===":"){str_nb=str_nb.substring(1);if(iscelldata(str_nb)){endstr="luckysheet_getSpecialReference(false,".concat(function_str,",'").concat(str_nb,"')");}}else{str=lodash_default().trim(str);var regx=/{.*?}/;if(regx.test(str)&&str.substring(0,1)!=='"'&&str.substring(str.length-1,1)!=='"'){var _regx$exec;var arraytxt=(_regx$exec=regx.exec(str))===null||_regx$exec===void 0?void 0:_regx$exec[0];var arraystart=str.search(regx);if(arraystart>0){endstr+=str.substring(0,arraystart);}endstr+="luckysheet_getarraydata('".concat(arraytxt,"')");if(arraystart+arraytxt.length<str.length){endstr+=str.substring(arraystart+arraytxt.length,str.length);}}else{endstr=str;}}if(endstr.length>0){cal2.unshift(endstr);}if(cal1.length>0){if(function_str.length>0){cal2.unshift(function_str);function_str="";}while(cal1.length>0){cal2.unshift(cal1.shift());}}if(cal2.length>0){function_str=calPostfixExpression(cal2);}else{function_str+=endstr;}}i+=1;}checkSpecialFunctionRange(ctx,function_str,r,c,id,dynamicArray_compute,cellRangeFunction);return function_str;}function getAllFunctionGroup(ctx){var luckysheetfile=ctx.luckysheetfile;var ret=[];for(var _i3=0;_i3<luckysheetfile.length;_i3+=1){var file=luckysheetfile[_i3];var calcChain=file.calcChain;var dynamicArray_compute=file.dynamicArray_compute;if(lodash_default().isNil(calcChain)){calcChain=[];}if(lodash_default().isNil(dynamicArray_compute)){dynamicArray_compute=[];}ret=ret.concat(calcChain);for(var j=0;j<dynamicArray_compute.length;j+=1){var d=dynamicArray_compute[0];ret.push({r:d.r,c:d.c,id:d.id});}}return ret;}function delFunctionGroup(ctx,r,c,id){if(lodash_default().isNil(id)){id=ctx.currentSheetId;}var file=ctx.luckysheetfile[getSheetIndex(ctx,id)];var calcChain=file.calcChain;if(!lodash_default().isNil(calcChain)){var modified=false;var calcChainClone=lodash_default().cloneDeep(calcChain);for(var _i4=0;_i4<calcChainClone.length;_i4+=1){var calc=calcChainClone[_i4];if(calc.r===r&&calc.c===c&&calc.id===id){calcChainClone.splice(_i4,1);modified=true;break;}}if(modified){file.calcChain=calcChainClone;}}var dynamicArray=file.dynamicArray;if(!lodash_default().isNil(dynamicArray)){var _modified=false;var dynamicArrayClone=lodash_default().cloneDeep(dynamicArray);for(var _i5=0;_i5<dynamicArrayClone.length;_i5+=1){var _calc=dynamicArrayClone[_i5];if(_calc.r===r&&_calc.c===c&&(lodash_default().isNil(_calc.id)||_calc.id===id)){dynamicArrayClone.splice(_i5,1);_modified=true;break;}}if(_modified){file.dynamicArray=dynamicArrayClone;}}}function checkBracketNum(fp){var bra_l=fp.match(/\(/g);var bra_r=fp.match(/\)/g);var bra_tl_txt=fp.match(/(['"])(?:(?!\1).)*?\1/g);var bra_tr_txt=fp.match(/(['"])(?:(?!\1).)*?\1/g);var bra_l_len=0;var bra_r_len=0;if(!lodash_default().isNil(bra_l)){bra_l_len+=bra_l.length;}if(!lodash_default().isNil(bra_r)){bra_r_len+=bra_r.length;}var bra_tl_len=0;var bra_tr_len=0;if(!lodash_default().isNil(bra_tl_txt)){for(var _i6=0;_i6<bra_tl_txt.length;_i6+=1){var bra_tl=bra_tl_txt[_i6].match(/\(/g);if(!lodash_default().isNil(bra_tl)){bra_tl_len+=bra_tl.length;}}}if(!lodash_default().isNil(bra_tr_txt)){for(var _i7=0;_i7<bra_tr_txt.length;_i7+=1){var bra_tr=bra_tr_txt[_i7].match(/\)/g);if(!lodash_default().isNil(bra_tr)){bra_tr_len+=bra_tr.length;}}}bra_l_len-=bra_tl_len;bra_r_len-=bra_tr_len;if(bra_l_len!==bra_r_len){return false;}return true;}function insertUpdateFunctionGroup(ctx,r,c,id,calcChainSet){if(lodash_default().isNil(id)){id=ctx.currentSheetId;}var luckysheetfile=ctx.luckysheetfile;var idx=getSheetIndex(ctx,id);if(lodash_default().isNil(idx)){return;}var file=luckysheetfile[idx];var calcChain=file.calcChain;if(lodash_default().isNil(calcChain)){calcChain=[];}if(calcChainSet){if(calcChainSet.has("".concat(r,"_").concat(c,"_").concat(id)))return;}else{for(var _i8=0;_i8<calcChain.length;_i8+=1){var calc=calcChain[_i8];if(calc.r===r&&calc.c===c&&calc.id===id){return;}}}var cc={r:r,c:c,id:id};calcChain.push(cc);file.calcChain=calcChain;ctx.luckysheetfile=luckysheetfile;}function execfunction(ctx,txt,r,c,id,calcChainSet,isrefresh,notInsertFunc){if(txt.indexOf(error.r)>-1){return[false,error.r,txt];}if(!checkBracketNum(txt)){txt+=")";}if(lodash_default().isNil(id)){id=ctx.currentSheetId;}ctx.calculateSheetId=id;ctx.formulaCache.parser.context=ctx;var parsedResponse=ctx.formulaCache.parser.parse(txt.substring(1),{sheetId:id||ctx.currentSheetId});var formulaError=parsedResponse.error;var result=parsedResponse.result;if(Object.prototype.toString.call(result)==="[object Date]"&&!lodash_default().isNil(result)){result=result.toString();}if(!lodash_default().isNil(r)&&!lodash_default().isNil(c)){if(isrefresh){execFunctionGroup(ctx,r,c,lodash_default().isNil(formulaError)?result:formulaError,id);}if(!notInsertFunc){insertUpdateFunctionGroup(ctx,r,c,id,calcChainSet);}}return[true,lodash_default().isNil(formulaError)?result:formulaError,txt];}function insertUpdateDynamicArray(ctx,dynamicArrayItem){var r=dynamicArrayItem.r,c=dynamicArrayItem.c;var id=dynamicArrayItem.id;if(lodash_default().isNil(id)){id=ctx.currentSheetId;}var luckysheetfile=ctx.luckysheetfile;var idx=getSheetIndex(ctx,id);if(idx==null)return[];var file=luckysheetfile[idx];var dynamicArray=file.dynamicArray;if(lodash_default().isNil(dynamicArray)){dynamicArray=[];}for(var _i9=0;_i9<dynamicArray.length;_i9+=1){var calc=dynamicArray[_i9];if(calc.r===r&&calc.c===c&&calc.id===id){calc.data=dynamicArrayItem.data;calc.f=dynamicArrayItem.f;return dynamicArray;}}dynamicArray.push(dynamicArrayItem);return dynamicArray;}function groupValuesRefresh(ctx){var luckysheetfile=ctx.luckysheetfile;if(ctx.groupValuesRefreshData.length>0){for(var _i10=0;_i10<ctx.groupValuesRefreshData.length;_i10+=1){var item=ctx.groupValuesRefreshData[_i10];var idx=getSheetIndex(ctx,item.id);if(idx==null)continue;var file=luckysheetfile[idx];var data=file.data;if(lodash_default().isNil(data)){continue;}var updateValue={};if(!lodash_default().isNil(item.spe)){if(item.spe.type==="sparklines"){updateValue.spl=item.spe.data;}else if(item.spe.type==="dynamicArrayItem"){file.dynamicArray=insertUpdateDynamicArray(ctx,item.spe.data);}}updateValue.v=item.v;updateValue.f=item.f;setCellValue(ctx,item.r,item.c,data,updateValue);}ctx.groupValuesRefreshData=[];}}function execFunctionGroup(ctx,origin_r,origin_c,value,id,data){var isForce=arguments.length>6&&arguments[6]!==undefined?arguments[6]:false;if(lodash_default().isNil(data)){data=getFlowdata(ctx);}if(lodash_default().isNil(ctx.formulaCache.execFunctionGlobalData)){ctx.formulaCache.execFunctionGlobalData={};}if(lodash_default().isNil(id)){id=ctx.currentSheetId;}if(!lodash_default().isNil(value)){var cellCache=[[{v:undefined}]];setCellValue(ctx,0,0,cellCache,value);var _cellCache$=index_esm_slicedToArray(cellCache[0],1);ctx.formulaCache.execFunctionGlobalData["".concat(origin_r,"_").concat(origin_c,"_").concat(id)]=_cellCache$[0];}var calcChains=getAllFunctionGroup(ctx);var formulaObjects={};var sheets=ctx.luckysheetfile;var sheetData={};for(var _i11=0;_i11<sheets.length;_i11+=1){var sheet=sheets[_i11];sheetData[sheet.id]=sheet.data;}var updateValueOjects={};var updateValueArray=[];if(lodash_default().isNil(ctx.formulaCache.execFunctionExist)){var key="r".concat(origin_r,"c").concat(origin_c,"i").concat(id);updateValueOjects[key]=1;}else{for(var x=0;x<ctx.formulaCache.execFunctionExist.length;x+=1){var cell=ctx.formulaCache.execFunctionExist[x];var _key="r".concat(cell.r,"c").concat(cell.c,"i").concat(cell.i);updateValueOjects[_key]=1;}}var arrayMatchCache={};var arrayMatch=function arrayMatch(formulaArray,_formulaObjects,_updateValueOjects,func){for(var a=0;a<formulaArray.length;a+=1){var range=formulaArray[a];var cacheKey="r".concat(range.row[0]).concat(range.row[1],"c").concat(range.column[0]).concat(range.column[1],"id").concat(range.sheetId);if(cacheKey in arrayMatchCache){var amc=arrayMatchCache[cacheKey];amc.forEach(function(item){func(item.key,item.r,item.c,item.sheetId);});}else{var functionArr=[];for(var r=range.row[0];r<=range.row[1];r+=1){for(var c=range.column[0];c<=range.column[1];c+=1){var _key2="r".concat(r,"c").concat(c,"i").concat(range.sheetId);func(_key2,r,c,range.sheetId);if(_formulaObjects&&_key2 in _formulaObjects||_updateValueOjects&&_key2 in _updateValueOjects){functionArr.push({key:_key2,r:r,c:c,sheetId:range.sheetId});}}}if(_formulaObjects||_updateValueOjects){arrayMatchCache[cacheKey]=functionArr;}}}};var _loop=function _loop(_i12){var formulaCell=calcChains[_i12];var key="r".concat(formulaCell.r,"c").concat(formulaCell.c,"i").concat(formulaCell.id);var calc_funcStr=getcellFormula(ctx,formulaCell.r,formulaCell.c,formulaCell.id);if(lodash_default().isNil(calc_funcStr)){return"continue";}var txt1=calc_funcStr.toUpperCase();var isOffsetFunc=txt1.indexOf("INDIRECT(")>-1||txt1.indexOf("OFFSET(")>-1||txt1.indexOf("INDEX(")>-1;var formulaArray=[];if(isOffsetFunc){isFunctionRange(ctx,calc_funcStr,null,null,formulaCell.id,null,function(str_nb){var range=getcellrange(ctx,lodash_default().trim(str_nb),formulaCell.id);if(!lodash_default().isNil(range)){formulaArray.push(range);}});}else if(!(calc_funcStr.substring(0,2)==='="'&&calc_funcStr.substring(calc_funcStr.length-1,1)==='"')){var point=0;var squote=-1;var dquote=-1;var formulaTextArray=[];var sq_end_array=[];var calc_funcStr_length=calc_funcStr.length;for(var j=0;j<calc_funcStr_length;j+=1){var char=calc_funcStr.charAt(j);if(char==="'"&&dquote===-1){if(squote===-1){if(point!==j){formulaTextArray.push.apply(formulaTextArray,index_esm_toConsumableArray(calc_funcStr.substring(point,j).split(/==|!=|<>|<=|>=|[,()=+-/*%&^><]/)));}squote=j;point=j;}else{if(j<calc_funcStr_length-1&&calc_funcStr.charAt(j+1)==="'"){j+=1;}else{point=j+1;formulaTextArray.push(calc_funcStr.substring(squote,point));sq_end_array.push(formulaTextArray.length-1);squote=-1;}}}if(char==='"'&&squote===-1){if(dquote===-1){if(point!==j){formulaTextArray.push.apply(formulaTextArray,index_esm_toConsumableArray(calc_funcStr.substring(point,j).split(/==|!=|<>|<=|>=|[,()=+-/*%&^><]/)));}dquote=j;point=j;}else{if(j<calc_funcStr_length-1&&calc_funcStr.charAt(j+1)==='"'){j+=1;}else{point=j+1;formulaTextArray.push(calc_funcStr.substring(dquote,point));dquote=-1;}}}}if(point!==calc_funcStr_length){formulaTextArray.push.apply(formulaTextArray,index_esm_toConsumableArray(calc_funcStr.substring(point,calc_funcStr_length).split(/==|!=|<>|<=|>=|[,()=+-/*%&^><]/)));}for(var _j=sq_end_array.length-1;_j>=0;_j-=1){if(sq_end_array[_j]!==formulaTextArray.length-1){formulaTextArray[sq_end_array[_j]]+=formulaTextArray[sq_end_array[_j]+1];formulaTextArray.splice(sq_end_array[_j]+1,1);}}for(var _j2=0;_j2<formulaTextArray.length;_j2+=1){var t=formulaTextArray[_j2];if(t.length<=1){continue;}if(t.substring(0,1)==='"'&&t.substring(t.length-1,1)==='"'||!iscelldata(t)){continue;}var range=getcellrange(ctx,lodash_default().trim(t),formulaCell.id);if(lodash_default().isNil(range)){continue;}formulaArray.push(range);}}var item={formulaArray:formulaArray,calc_funcStr:calc_funcStr,key:key,r:formulaCell.r,c:formulaCell.c,id:formulaCell.id,parents:{},chidren:{},color:"w"};formulaObjects[key]=item;};for(var _i12=0;_i12<calcChains.length;_i12+=1){var _ret=_loop(_i12);if(_ret==="continue")continue;}Object.keys(formulaObjects).forEach(function(key){var formulaObject=formulaObjects[key];arrayMatch(formulaObject.formulaArray,formulaObjects,updateValueOjects,function(childKey){if(childKey in formulaObjects){var childFormulaObject=formulaObjects[childKey];formulaObject.chidren[childKey]=1;childFormulaObject.parents[key]=1;}if(!isForce&&childKey in updateValueOjects){updateValueArray.push(formulaObject);}});if(isForce){updateValueArray.push(formulaObject);}});var formulaRunList=[];var stack=updateValueArray;var existsFormulaRunList={};var _loop2=function _loop2(){var formulaObject=stack.pop();if(lodash_default().isNil(formulaObject)||formulaObject.key in existsFormulaRunList){return"continue";}if(formulaObject.color==="b"){formulaRunList.push(formulaObject);existsFormulaRunList[formulaObject.key]=1;return"continue";}var cacheStack=[];Object.keys(formulaObject.parents).forEach(function(parentKey){var parentFormulaObject=formulaObjects[parentKey];if(!lodash_default().isNil(parentFormulaObject)){cacheStack.push(parentFormulaObject);}});if(cacheStack.length===0){formulaRunList.push(formulaObject);existsFormulaRunList[formulaObject.key]=1;}else{formulaObject.color="b";stack.push(formulaObject);stack=stack.concat(cacheStack);}};while(stack.length>0){var _ret2=_loop2();if(_ret2==="continue")continue;}formulaRunList.reverse();var calcChainSet=new Set();calcChains.forEach(function(item){calcChainSet.add("".concat(item.r,"_").concat(item.c,"_").concat(item.id));});for(var _i13=0;_i13<formulaRunList.length;_i13+=1){var formulaCell=formulaRunList[_i13];if(formulaCell.level===Math.max){continue;}var calc_funcStr=formulaCell.calc_funcStr;var v=execfunction(ctx,calc_funcStr,formulaCell.r,formulaCell.c,formulaCell.id,calcChainSet);ctx.groupValuesRefreshData.push({r:formulaCell.r,c:formulaCell.c,v:v[1],f:v[2],spe:v[3],id:formulaCell.id});ctx.formulaCache.execFunctionGlobalData["".concat(formulaCell.r,"_").concat(formulaCell.c,"_").concat(formulaCell.id)]={v:v[1],f:v[2]};}ctx.formulaCache.execFunctionExist=undefined;}function findrangeindex(ctx,v,vp){var re=/<span.*?>/g;var v_a=v.replace(re,"").split("</span>");var vp_a=vp.replace(re,"").split("</span>");v_a.pop();if(vp_a[vp_a.length-1]==="")vp_a.pop();var pfri=ctx.formulaCache.functionRangeIndex;if(pfri==null)return[];var vplen=vp_a.length;var vlen=v_a.length;if(vplen===vlen){var _i14=pfri[0];var p=vp_a[_i14];var n=v_a[_i14];if(lodash_default().isNil(p)){if(vp_a.length<=_i14){pfri=[vp_a.length-1,vp_a.length-1];}else if(v_a.length<=_i14){pfri=[v_a.length-1,v_a.length-1];}return pfri;}if(p.length===n.length){if(!lodash_default().isNil(vp_a[_i14+1])&&!lodash_default().isNil(v_a[_i14+1])&&vp_a[_i14+1].length<v_a[_i14+1].length){pfri[0]+=1;pfri[1]=1;}return pfri;}if(p.length>n.length){if(!lodash_default().isNil(p)&&!lodash_default().isNil(v_a[_i14+1])&&v_a[_i14+1].substring(0,1)==='"'&&(p.indexOf("{")>-1||p.indexOf("}")>-1)){pfri[0]+=1;pfri[1]=1;}return pfri;}if(p.length<n.length){if(pfri[1]>n.length){pfri[1]=n.length;}return pfri;}}else if(vplen>vlen){var _i15=pfri[0];var _p=vp_a[_i15];var _n=v_a[_i15];if(lodash_default().isNil(_n)){if(v_a[_i15-1].indexOf("{")>-1){pfri[0]-=1;var start=v_a[_i15-1].search("{");pfri[1]+=start;}else{pfri[0]=0;pfri[1]=0;}}else if(_p.length===_n.length){if(!lodash_default().isNil(v_a[_i15+1])&&(v_a[_i15+1].substring(0,1)==='"'||v_a[_i15+1].substring(0,1)==="{"||v_a[_i15+1].substring(0,1)==="}")){pfri[0]+=1;pfri[1]=1;}else if(!lodash_default().isNil(_p)&&_p.length>2&&_p.substring(0,1)==='"'&&_p.substring(_p.length-1,1)==='"');else if(!lodash_default().isNil(v_a[_i15])&&v_a[_i15]==='")'){pfri[1]=1;}else if(!lodash_default().isNil(v_a[_i15])&&v_a[_i15]==='"}'){pfri[1]=1;}else if(!lodash_default().isNil(v_a[_i15])&&v_a[_i15]==="{)"){pfri[1]=1;}else{pfri[1]=_n.length;}return pfri;}else if(_p.length>_n.length){if(!lodash_default().isNil(v_a[_i15+1])&&(v_a[_i15+1].substring(0,1)==='"'||v_a[_i15+1].substring(0,1)==="{"||v_a[_i15+1].substring(0,1)==="}")){pfri[0]+=1;pfri[1]=1;}return pfri;}else if(_p.length<_n.length){return pfri;}return pfri;}else if(vplen<vlen){var _i16=pfri[0];var _p2=vp_a[_i16];var _n2=v_a[_i16];if(lodash_default().isNil(_p2)){pfri[0]=v_a.length-1;if(!lodash_default().isNil(_n2)){pfri[1]=_n2.length;}else{pfri[1]=1;}}else if(_p2.length===_n2.length){if(vp_a[_i16+1]!=null&&(vp_a[_i16+1].substring(0,1)==='"'||vp_a[_i16+1].substring(0,1)==="{"||vp_a[_i16+1].substring(0,1)==="}")){pfri[1]=_n2.length;}else if(!lodash_default().isNil(v_a[_i16+1])&&v_a[_i16+1].substring(0,1)==='"'&&(v_a[_i16+1].substring(0,1)==="{"||v_a[_i16+1].substring(0,1)==="}")){pfri[0]+=1;pfri[1]=1;}else if(!lodash_default().isNil(_n2)&&_n2.substring(0,1)==='"'&&_n2.substring(_n2.length-1,1)==='"'&&_p2.substring(0,1)==='"'&&_p2.substring(_p2.length-1,1)===")"){pfri[1]=_n2.length;}else if(!lodash_default().isNil(_n2)&&_n2.substring(0,1)==="{"&&_n2.substring(_n2.length-1,1)==="}"&&_p2.substring(0,1)==="{"&&_p2.substring(_p2.length-1,1)===")"){pfri[1]=_n2.length;}else{pfri[0]=pfri[0]+vlen-vplen;if(v_a.length>vp_a.length){pfri[1]=v_a[_i16+1].length;}else{pfri[1]=1;}}return pfri;}else if(_p2.length>_n2.length){if(!lodash_default().isNil(_p2)&&_p2.substring(0,1)==='"'){pfri[1]=_n2.length;}else if(lodash_default().isNil(v_a[_i16+1])&&/{.*?}/.test(v_a[_i16+1])){pfri[0]+=1;pfri[1]=v_a[_i16+1].length;}else if(!lodash_default().isNil(_p2)&&v_a[_i16+1].substring(0,1)==='"'&&(_p2.indexOf("{")>-1||_p2.indexOf("}")>-1)){pfri[0]+=1;pfri[1]=1;}else if(!lodash_default().isNil(_p2)&&(_p2.indexOf("{")>-1||_p2.indexOf("}")>-1));else if(!lodash_default().isNil(_p2)&&!lodash_default().startsWith(_p2[0],"=")&&lodash_default().startsWith(_n2,"=")){return[vlen-1,v_a[vlen-1].length];}else{pfri[0]=pfri[0]+vlen-vplen-1;pfri[1]=v_a[(_i16||1)-1].length;}return pfri;}else if(_p2.length<_n2.length){return pfri;}return pfri;}return null;}function createFormulaRangeSelect(ctx,select){ctx.formulaRangeSelect=select;}function createRangeHightlight(ctx,inputInnerHtmlStr){var ignoreRangeIndex=arguments.length>2&&arguments[2]!==undefined?arguments[2]:-1;var $span=parseElement("<div>".concat(inputInnerHtmlStr,"</div>"));var formulaRanges=[];$span.querySelectorAll("span.fortune-formula-functionrange-cell").forEach(function(ele){var rangeIndex=parseInt(ele.getAttribute("rangeindex")||"0",10);if(rangeIndex===ignoreRangeIndex)return;var cellrange=getcellrange(ctx,ele.textContent||"");if(rangeIndex===ctx.formulaCache.selectingRangeIndex||cellrange==null)return;if(cellrange.sheetId===ctx.currentSheetId||cellrange.sheetId===-1&&ctx.formulaCache.rangetosheet===ctx.currentSheetId){var rect=seletedHighlistByindex(ctx,cellrange.row[0],cellrange.row[1],cellrange.column[0],cellrange.column[1]);if(rect){formulaRanges.push(_objectSpread2(_objectSpread2({rangeIndex:rangeIndex},rect),{},{backgroundColor:colors[rangeIndex]}));}}});ctx.formulaRangeHighlight=formulaRanges;}function setCaretPosition(ctx,textDom,children,pos){try{var el=textDom;var range=document.createRange();var sel=window.getSelection();range.setStart(el.childNodes[children],pos);range.collapse(true);sel===null||sel===void 0?void 0:sel.removeAllRanges();sel===null||sel===void 0?void 0:sel.addRange(range);el.focus();}catch(err){console.error(err);moveToEnd(ctx.formulaCache.rangeResizeTo[0]);}}function functionRange(ctx,obj,v,vp){if(window.getSelection){var currSelection=window.getSelection();if(!currSelection)return;var fri=findrangeindex(ctx,v,vp);if(lodash_default().isNil(fri)){currSelection.selectAllChildren(obj);currSelection.collapseToEnd();}else{setCaretPosition(ctx,obj.querySelectorAll("span")[fri[0]],0,fri[1]);}}else if(document.selection){ctx.formulaCache.functionRangeIndex.moveToElementText(obj);ctx.formulaCache.functionRangeIndex.collapse(false);ctx.formulaCache.functionRangeIndex.select();}}function searchFunction(ctx,searchtxt){var _locale=locale(ctx),functionlist=_locale.functionlist;var f=[];var s=[];var t=[];var result_i=0;for(var _i17=0;_i17<functionlist.length;_i17+=1){var item=functionlist[_i17];var n=item.n;if(n===searchtxt){f.unshift(item);result_i+=1;}else if(lodash_default().startsWith(n,searchtxt)){s.unshift(item);result_i+=1;}else if(n.indexOf(searchtxt)>-1){t.unshift(item);result_i+=1;}if(result_i>=10){break;}}var list=[].concat(f,s,t);if(list.length<=0){return;}ctx.functionCandidates=list;}function getrangeseleciton(){var _anchorNode$parentNod,_anchorNode$parentNod2,_anchorNode$parentEle,_anchorNode$parentEle2;var currSelection=window.getSelection();if(!currSelection)return null;var anchorNode=currSelection.anchorNode,anchorOffset=currSelection.anchorOffset;if(!anchorNode)return null;if(((_anchorNode$parentNod=anchorNode.parentNode)===null||_anchorNode$parentNod===void 0?void 0:(_anchorNode$parentNod2=_anchorNode$parentNod.nodeName)===null||_anchorNode$parentNod2===void 0?void 0:_anchorNode$parentNod2.toLowerCase())==="span"&&anchorOffset!==0){var txt=lodash_default().trim(anchorNode.textContent||"");if(txt.length===0&&anchorNode.parentNode.previousSibling){var ahr=anchorNode.parentNode.previousSibling;txt=lodash_default().trim(ahr.textContent||"");return ahr;}return anchorNode.parentNode;}var anchorElement=anchorNode;if(anchorElement.id==="luckysheet-rich-text-editor"||anchorElement.id==="luckysheet-functionbox-cell"){var _$last;var _txt=lodash_default().trim((_$last=lodash_default().last(anchorElement.querySelectorAll("span")))===null||_$last===void 0?void 0:_$last.innerText);if(_txt.length===0&&anchorElement.querySelectorAll("span").length>1){var _ahr=anchorElement.querySelectorAll("span");_txt=lodash_default().trim(_ahr[_ahr.length-2].innerText);return _ahr===null||_ahr===void 0?void 0:_ahr[0];}return lodash_default().last(anchorElement.querySelectorAll("span"));}if((anchorNode===null||anchorNode===void 0?void 0:(_anchorNode$parentEle=anchorNode.parentElement)===null||_anchorNode$parentEle===void 0?void 0:_anchorNode$parentEle.id)==="luckysheet-rich-text-editor"||(anchorNode===null||anchorNode===void 0?void 0:(_anchorNode$parentEle2=anchorNode.parentElement)===null||_anchorNode$parentEle2===void 0?void 0:_anchorNode$parentEle2.id)==="luckysheet-functionbox-cell"||anchorOffset===0){var newAnchorNode=anchorOffset===0?anchorNode===null||anchorNode===void 0?void 0:anchorNode.parentNode:anchorNode;if(newAnchorNode===null||newAnchorNode===void 0?void 0:newAnchorNode.previousSibling){return newAnchorNode===null||newAnchorNode===void 0?void 0:newAnchorNode.previousSibling;}}return null;}function helpFunctionExe($editer,currSelection,ctx){var _currSelection$parent;var _locale2=locale(ctx),functionlist=_locale2.functionlist;if(lodash_default().isEmpty(ctx.formulaCache.functionlistMap)){for(var _i18=0;_i18<functionlist.length;_i18+=1){ctx.formulaCache.functionlistMap[functionlist[_i18].n]=functionlist[_i18];}}if(!currSelection){return null;}var $prev=currSelection;var $span=$editer.querySelectorAll("span");var currentIndex=lodash_default().indexOf((_currSelection$parent=currSelection.parentNode)===null||_currSelection$parent===void 0?void 0:_currSelection$parent.childNodes,currSelection);var i=currentIndex;if($prev==null){return null;}var funcName=null;if($span[i].classList.contains("luckysheet-formula-text-func")){funcName=$span[i].textContent;}else{var $cur=null;var exceptIndex=[-1,-1];while(--i>0){$cur=$span[i];if($cur.classList.contains("luckysheet-formula-text-func")||lodash_default().trim($cur.textContent||"").toUpperCase()in ctx.formulaCache.functionlistMap){funcName=$cur.textContent;var endstate=true;for(var a=i;a<=currentIndex;a+=1){if(a>=exceptIndex[0]&&a<=exceptIndex[1]){continue;}$cur=$span[a];if($cur.classList.contains("luckysheet-formula-text-rpar")){exceptIndex=[i,a];funcName=null;endstate=false;break;}if($cur.classList.contains("luckysheet-formula-text-comma"));}if(endstate){break;}}}}return funcName;}function rangeHightlightselected(ctx,$editor){var currSelection=getrangeseleciton();if(!currSelection)return;var currText=lodash_default().trim(currSelection.textContent||"");if(currText===null||currText===void 0?void 0:currText.match(/^[a-zA-Z_]+$/)){searchFunction(ctx,currText.toUpperCase());ctx.functionHint=null;}else{var funcName=helpFunctionExe($editor,currSelection,ctx);ctx.functionHint=funcName===null||funcName===void 0?void 0:funcName.toUpperCase();ctx.functionCandidates=[];}}function functionHTML(txt){if(txt.substr(0,1)==="="){txt=txt.substr(1);}var funcstack=txt.split("");var i=0;var str="";var function_str="";var matchConfig={bracket:0,comma:0,squote:0,dquote:0,braces:0};while(i<funcstack.length){var s=funcstack[i];if(s==="("&&matchConfig.squote===0&&matchConfig.dquote===0&&matchConfig.braces===0){matchConfig.bracket+=1;if(str.length>0){function_str+="<span dir=\"auto\" class=\"luckysheet-formula-text-func\">".concat(str,"</span><span dir=\"auto\" class=\"luckysheet-formula-text-lpar\">(</span>");}else{function_str+='<span dir="auto" class="luckysheet-formula-text-lpar">(</span>';}str="";}else if(s===")"&&matchConfig.squote===0&&matchConfig.dquote===0&&matchConfig.braces===0){matchConfig.bracket-=1;function_str+="".concat(functionHTML(str),"<span dir=\"auto\" class=\"luckysheet-formula-text-rpar\">)</span>");str="";}else if(s==="{"&&matchConfig.squote===0&&matchConfig.dquote===0){str+="{";matchConfig.braces+=1;}else if(s==="}"&&matchConfig.squote===0&&matchConfig.dquote===0){str+="}";matchConfig.braces-=1;}else if(s==='"'&&matchConfig.squote===0){if(matchConfig.dquote>0){if(str.length>0){function_str+="".concat(str,"\"</span>");}else{function_str+='"</span>';}matchConfig.dquote-=1;str="";}else{matchConfig.dquote+=1;if(str.length>0){function_str+="".concat(functionHTML(str),"<span dir=\"auto\" class=\"luckysheet-formula-text-string\">\"");}else{function_str+='<span dir="auto" class="luckysheet-formula-text-string">"';}str="";}}else if(s==="'"&&matchConfig.dquote===0){str+="'";matchConfig.squote=matchConfig.squote===0?1:0;}else if(s===","&&matchConfig.squote===0&&matchConfig.dquote===0&&matchConfig.braces===0){function_str+="".concat(functionHTML(str),"<span dir=\"auto\" class=\"luckysheet-formula-text-comma\">,</span>");str="";}else if(s==="&"&&matchConfig.squote===0&&matchConfig.dquote===0&&matchConfig.braces===0){if(str.length>0){function_str+="".concat(functionHTML(str),"<span dir=\"auto\" class=\"luckysheet-formula-text-calc\">")+"&"+"</span>";str="";}else{function_str+='<span dir="auto" class="luckysheet-formula-text-calc">'+"&"+"</span>";}}else if(s in operatorjson&&matchConfig.squote===0&&matchConfig.dquote===0&&matchConfig.braces===0){var s_next="";if(i+1<funcstack.length){s_next=funcstack[i+1];}var p=i-1;var s_pre=null;if(p>=0){do{s_pre=funcstack[p];p-=1;}while(p>=0&&s_pre===" ");}if(s+s_next in operatorjson){if(str.length>0){function_str+="".concat(functionHTML(str),"<span dir=\"auto\" class=\"luckysheet-formula-text-calc\">").concat(s).concat(s_next,"</span>");str="";}else{function_str+="<span dir=\"auto\" class=\"luckysheet-formula-text-calc\">".concat(s).concat(s_next,"</span>");}i+=1;}else if(!/[^0-9]/.test(s_next)&&s==="-"&&(s_pre==="("||lodash_default().isNil(s_pre)||s_pre===","||s_pre===" "||s_pre in operatorjson)){str+=s;}else{if(str.length>0){function_str+="".concat(functionHTML(str),"<span dir=\"auto\" class=\"luckysheet-formula-text-calc\">").concat(s,"</span>");str="";}else{function_str+="<span dir=\"auto\" class=\"luckysheet-formula-text-calc\">".concat(s,"</span>");}}}else{str+=s;}if(i===funcstack.length-1){if(iscelldata(lodash_default().trim(str))){var rangeIndex=rangeIndexes.length>functionHTMLIndex?rangeIndexes[functionHTMLIndex]:functionHTMLIndex;function_str+="<span class=\"fortune-formula-functionrange-cell\" rangeindex=\"".concat(rangeIndex,"\" dir=\"auto\" style=\"color:").concat(colors[rangeIndex],";\">").concat(str,"</span>");functionHTMLIndex+=1;}else if(matchConfig.dquote>0){function_str+="".concat(str,"</span>");}else if(str.indexOf("</span>")===-1&&str.length>0){var regx=/{.*?}/;if(regx.test(lodash_default().trim(str))){var arraytxt=regx.exec(str)[0];var arraystart=str.search(regx);var alltxt="";if(arraystart>0){alltxt+="<span dir=\"auto\" class=\"luckysheet-formula-text-color\">".concat(str.substr(0,arraystart),"</span>");}alltxt+="<span dir=\"auto\" style=\"color:#959a05\" class=\"luckysheet-formula-text-array\">".concat(arraytxt,"</span>");if(arraystart+arraytxt.length<str.length){alltxt+="<span dir=\"auto\" class=\"luckysheet-formula-text-color\">".concat(str.substr(arraystart+arraytxt.length,str.length),"</span>");}function_str+=alltxt;}else{function_str+="<span dir=\"auto\" class=\"luckysheet-formula-text-color\">".concat(str,"</span>");}}}i+=1;}return function_str;}function functionHTMLGenerate(txt){if(txt.length===0||txt.substring(0,1)!=="="){return txt;}functionHTMLIndex=0;return"<span dir=\"auto\" class=\"luckysheet-formula-text-color\">=</span>".concat(functionHTML(txt));}function getRangeIndexes($editor){var res=[];$editor.querySelectorAll("span.fortune-formula-functionrange-cell").forEach(function(ele){var indexStr=ele.getAttribute("rangeindex");if(indexStr){var rangeIndex=parseInt(indexStr,10);res.push(rangeIndex);}});return res;}function handleFormulaInput(ctx,$copyTo,$editor,kcode,preText){var refreshRangeSelect=arguments.length>5&&arguments[5]!==undefined?arguments[5]:true;var value1;var value1txt=preText!==null&&preText!==void 0?preText:$editor.innerText;var value=$editor.innerText;value=escapeScriptTag(value);if(value.length>0&&value.substring(0,1)==="="&&(kcode!==229||value.length===1)){if(!refreshRangeSelect)rangeIndexes=getRangeIndexes($editor);value=functionHTMLGenerate(value);if(!refreshRangeSelect&&functionHTMLIndex<rangeIndexes.length)refreshRangeSelect=true;value1=functionHTMLGenerate(value1txt);rangeIndexes=[];if(window.getSelection){var _currSelection$anchor;var currSelection=window.getSelection();if(!currSelection)return;if(((_currSelection$anchor=currSelection.anchorNode)===null||_currSelection$anchor===void 0?void 0:_currSelection$anchor.nodeName.toLowerCase())==="div"){var _$editor$querySelecto;var editorlen=$editor.querySelectorAll("span").length;if(editorlen>0)ctx.formulaCache.functionRangeIndex=[editorlen-1,(_$editor$querySelecto=$editor.querySelectorAll("span").item(editorlen-1).textContent)===null||_$editor$querySelecto===void 0?void 0:_$editor$querySelecto.length];}else{var _currSelection$anchor2,_currSelection$anchor3,_currSelection$anchor4,_currSelection$anchor5;ctx.formulaCache.functionRangeIndex=[lodash_default().indexOf((_currSelection$anchor2=currSelection.anchorNode)===null||_currSelection$anchor2===void 0?void 0:(_currSelection$anchor3=_currSelection$anchor2.parentNode)===null||_currSelection$anchor3===void 0?void 0:(_currSelection$anchor4=_currSelection$anchor3.parentNode)===null||_currSelection$anchor4===void 0?void 0:_currSelection$anchor4.childNodes,(_currSelection$anchor5=currSelection.anchorNode)===null||_currSelection$anchor5===void 0?void 0:_currSelection$anchor5.parentNode),currSelection.anchorOffset];}}else{var textRange=document.selection.createRange();ctx.formulaCache.functionRangeIndex=textRange;}$editor.innerHTML=value;if($copyTo)$copyTo.innerHTML=value;functionRange(ctx,$editor,value,value1);if(refreshRangeSelect){cancelFunctionrangeSelected(ctx);if(kcode!==46){createRangeHightlight(ctx,value);}ctx.formulaCache.rangestart=false;ctx.formulaCache.rangedrag_column_start=false;ctx.formulaCache.rangedrag_row_start=false;rangeHightlightselected(ctx,$editor);}}else if(lodash_default().startsWith(value1txt,"=")&&!lodash_default().startsWith(value,"=")){if($copyTo)$copyTo.innerHTML=value;$editor.innerHTML=escapeHTMLTag(value);}else if(!lodash_default().startsWith(value1txt,"=")){if(!$copyTo)return;if($copyTo.id==="luckysheet-rich-text-editor"){if(!lodash_default().startsWith($copyTo.innerHTML,"<span")){$copyTo.innerHTML=escapeHTMLTag(value);}}else{$copyTo.innerHTML=escapeHTMLTag(value);}}}function isfreezonFuc(txt){var row=txt.replace(/[^0-9]/g,"");var col=txt.replace(/[^A-Za-z]/g,"");var row$=txt.substr(txt.indexOf(row)-1,1);var col$=txt.substr(txt.indexOf(col)-1,1);var ret=[false,false];if(row$==="$"){ret[0]=true;}if(col$==="$"){ret[1]=true;}return ret;}function functionStrChange_range(txt,type,rc,orient,stindex,step){var val=txt.split("!");var rangetxt;var prefix="";if(val.length>1){var _val3=index_esm_slicedToArray(val,2);rangetxt=_val3[1];prefix="".concat(val[0],"!");}else{var _val4=index_esm_slicedToArray(val,1);rangetxt=_val4[0];}var r1;var r2;var c1;var c2;var $row0;var $row1;var $col0;var $col1;if(rangetxt.indexOf(":")===-1){r1=parseInt(rangetxt.replace(/[^0-9]/g,""),10)-1;r2=r1;c1=columnCharToIndex(rangetxt.replace(/[^A-Za-z]/g,""));c2=c1;var freezonFuc=isfreezonFuc(rangetxt);$row0=freezonFuc[0]?"$":"";$row1=$row0;$col0=freezonFuc[1]?"$":"";$col1=$col0;}else{rangetxt=rangetxt.split(":");r1=parseInt(rangetxt[0].replace(/[^0-9]/g,""),10)-1;r2=parseInt(rangetxt[1].replace(/[^0-9]/g,""),10)-1;if(r1>r2){return txt;}c1=columnCharToIndex(rangetxt[0].replace(/[^A-Za-z]/g,""));c2=columnCharToIndex(rangetxt[1].replace(/[^A-Za-z]/g,""));if(c1>c2){return txt;}var freezonFuc0=isfreezonFuc(rangetxt[0]);$row0=freezonFuc0[0]?"$":"";$col0=freezonFuc0[1]?"$":"";var freezonFuc1=isfreezonFuc(rangetxt[1]);$row1=freezonFuc1[0]?"$":"";$col1=freezonFuc1[1]?"$":"";}if(type==="del"){if(rc==="row"){if(r1>=stindex&&r2<=stindex+step-1){return error.r;}if(r1>stindex+step-1){r1-=step;}else if(r1>=stindex){r1=stindex;}if(r2>stindex+step-1){r2-=step;}else if(r2>=stindex){r2=stindex-1;}if(r1<0){r1=0;}if(r2<r1){r2=r1;}}else if(rc==="col"){if(c1>=stindex&&c2<=stindex+step-1){return error.r;}if(c1>stindex+step-1){c1-=step;}else if(c1>=stindex){c1=stindex;}if(c2>stindex+step-1){c2-=step;}else if(c2>=stindex){c2=stindex-1;}if(c1<0){c1=0;}if(c2<c1){c2=c1;}}if(r1===r2&&c1===c2){if(!Number.isNaN(r1)&&!Number.isNaN(c1)){return prefix+$col0+indexToColumnChar(c1)+$row0+(r1+1);}if(!Number.isNaN(r1)){return prefix+$row0+(r1+1);}if(!Number.isNaN(c1)){return prefix+$col0+indexToColumnChar(c1);}return txt;}if(Number.isNaN(c1)&&Number.isNaN(c2)){return"".concat(prefix+$row0+(r1+1),":").concat($row1).concat(r2+1);}if(Number.isNaN(r1)&&Number.isNaN(r2)){return"".concat(prefix+$col0+indexToColumnChar(c1),":").concat($col1).concat(indexToColumnChar(c2));}return"".concat(prefix+$col0+indexToColumnChar(c1)+$row0+(r1+1),":").concat($col1).concat(indexToColumnChar(c2)).concat($row1).concat(r2+1);}if(type==="add"){if(rc==="row"){if(orient==="lefttop"){if(r1>=stindex){r1+=step;}if(r2>=stindex){r2+=step;}}else if(orient==="rightbottom"){if(r1>stindex){r1+=step;}if(r2>stindex){r2+=step;}}}else if(rc==="col"){if(orient==="lefttop"){if(c1>=stindex){c1+=step;}if(c2>=stindex){c2+=step;}}else if(orient==="rightbottom"){if(c1>stindex){c1+=step;}if(c2>stindex){c2+=step;}}}if(r1===r2&&c1===c2){if(!Number.isNaN(r1)&&!Number.isNaN(c1)){return prefix+$col0+indexToColumnChar(c1)+$row0+(r1+1);}if(!Number.isNaN(r1)){return prefix+$row0+(r1+1);}if(!Number.isNaN(c1)){return prefix+$col0+indexToColumnChar(c1);}return txt;}if(Number.isNaN(c1)&&Number.isNaN(c2)){return"".concat(prefix+$row0+(r1+1),":").concat($row1).concat(r2+1);}if(Number.isNaN(r1)&&Number.isNaN(r2)){return"".concat(prefix+$col0+indexToColumnChar(c1),":").concat($col1).concat(indexToColumnChar(c2));}return"".concat(prefix+$col0+indexToColumnChar(c1)+$row0+(r1+1),":").concat($col1).concat(indexToColumnChar(c2)).concat($row1).concat(r2+1);}return"";}function israngeseleciton(ctx,istooltip){var _anchor,_anchor2,_anchor2$parentNode;if(istooltip==null){istooltip=false;}var currSelection=window.getSelection();if(currSelection==null)return false;var anchor=currSelection.anchorNode;if(!((_anchor=anchor)===null||_anchor===void 0?void 0:_anchor.textContent))return false;var anchorOffset=currSelection.anchorOffset;var anchorElement=anchor;var parentElement=anchor.parentNode;if(((_anchor2=anchor)===null||_anchor2===void 0?void 0:(_anchor2$parentNode=_anchor2.parentNode)===null||_anchor2$parentNode===void 0?void 0:_anchor2$parentNode.nodeName.toLowerCase())==="span"&&anchorOffset!==0){var txt=lodash_default().trim(anchor.textContent);var lasttxt="";if(txt.length===0&&anchor.parentNode.previousSibling){var ahr=anchor.parentNode.previousSibling;txt=lodash_default().trim(ahr.textContent||"");lasttxt=txt.substring(txt.length-1,1);ctx.formulaCache.rangeSetValueTo=anchor.parentNode;}else{lasttxt=txt.substring(anchorOffset-1,1);ctx.formulaCache.rangeSetValueTo=anchor.parentNode;}if(istooltip&&(lasttxt==="("||lasttxt===",")||!istooltip&&(lasttxt==="("||lasttxt===","||lasttxt==="="||lasttxt in operatorjson||lasttxt==="&")){return true;}}else if(anchorElement.id==="luckysheet-rich-text-editor"||anchorElement.id==="luckysheet-functionbox-cell"){var _$last2;var _txt2=lodash_default().trim((_$last2=lodash_default().last(anchorElement.querySelectorAll("span")))===null||_$last2===void 0?void 0:_$last2.innerText);ctx.formulaCache.rangeSetValueTo=lodash_default().last(anchorElement.querySelectorAll("span"));if(_txt2.length===0&&anchorElement.querySelectorAll("span").length>1){var _ahr2=anchorElement.querySelectorAll("span");_txt2=lodash_default().trim(_ahr2[_ahr2.length-2].innerText);_txt2=lodash_default().trim(_ahr2[_ahr2.length-2].innerText);ctx.formulaCache.rangeSetValueTo=_ahr2;}var _lasttxt=_txt2.substring(_txt2.length-1,1);if(istooltip&&(_lasttxt==="("||_lasttxt===",")||!istooltip&&(_lasttxt==="("||_lasttxt===","||_lasttxt==="="||_lasttxt in operatorjson||_lasttxt==="&")){return true;}}else if(parentElement.id==="luckysheet-rich-text-editor"||parentElement.id==="luckysheet-functionbox-cell"||anchorOffset===0){var _anchor$previousSibli;if(anchorOffset===0){anchor=anchor.parentNode;}if(!anchor)return false;if(((_anchor$previousSibli=anchor.previousSibling)===null||_anchor$previousSibli===void 0?void 0:_anchor$previousSibli.textContent)==null)return false;if(anchor.previousSibling){var _txt3=lodash_default().trim(anchor.previousSibling.textContent);var _lasttxt2=_txt3.substring(_txt3.length-1,1);ctx.formulaCache.rangeSetValueTo=anchor.previousSibling;if(istooltip&&(_lasttxt2==="("||_lasttxt2===",")||!istooltip&&(_lasttxt2==="("||_lasttxt2===","||_lasttxt2==="="||_lasttxt2 in operatorjson||_lasttxt2==="&")){return true;}}}return false;}function functionStrChange(txt,type,rc,orient,stindex,step){if(!txt){return"";}if(txt.substring(0,1)==="="){txt=txt.substring(1);}var funcstack=txt.split("");var i=0;var str="";var function_str="";var matchConfig={bracket:0,comma:0,squote:0,dquote:0};while(i<funcstack.length){var s=funcstack[i];if(s==="("&&matchConfig.dquote===0){matchConfig.bracket+=1;if(str.length>0){function_str+="".concat(str,"(");}else{function_str+="(";}str="";}else if(s===")"&&matchConfig.dquote===0){matchConfig.bracket-=1;function_str+="".concat(functionStrChange(str,type,rc,orient,stindex,step),")");str="";}else if(s==='"'&&matchConfig.squote===0){if(matchConfig.dquote>0){function_str+="".concat(str,"\"");matchConfig.dquote-=1;str="";}else{matchConfig.dquote+=1;str+='"';}}else if(s===","&&matchConfig.dquote===0){function_str+="".concat(functionStrChange(str,type,rc,orient,stindex,step),",");str="";}else if(s==="&"&&matchConfig.dquote===0){if(str.length>0){function_str+="".concat(functionStrChange(str,type,rc,orient,stindex,step),"&");str="";}else{function_str+="&";}}else if(s in operatorjson&&matchConfig.dquote===0){var s_next="";if(i+1<funcstack.length){s_next=funcstack[i+1];}var p=i-1;var s_pre=null;if(p>=0){do{s_pre=funcstack[p-=1];}while(p>=0&&s_pre===" ");}if(s+s_next in operatorjson){if(str.length>0){function_str+=functionStrChange(str,type,rc,orient,stindex,step)+s+s_next;str="";}else{function_str+=s+s_next;}i+=1;}else if(!/[^0-9]/.test(s_next)&&s==="-"&&(s_pre==="("||s_pre==null||s_pre===","||s_pre===" "||s_pre in operatorjson)){str+=s;}else{if(str.length>0){function_str+=functionStrChange(str,type,rc,orient,stindex,step)+s;str="";}else{function_str+=s;}}}else{str+=s;}if(i===funcstack.length-1){if(iscelldata(lodash_default().trim(str))){function_str+=functionStrChange_range(lodash_default().trim(str),type,rc,orient,stindex,step);}else{function_str+=lodash_default().trim(str);}}i+=1;}return function_str;}function rangeSetValue(ctx,cellInput,selected,fxInput){var _document$activeEleme;var $editor=cellInput;var $copyTo=fxInput;if(((_document$activeEleme=document.activeElement)===null||_document$activeEleme===void 0?void 0:_document$activeEleme.id)==="luckysheet-functionbox-cell"){$editor=fxInput;$copyTo=cellInput;}var range="";var rf=selected.row[0];var cf=selected.column[0];if(ctx.config.merge!=null&&"".concat(rf,"_").concat(cf)in ctx.config.merge){range=getRangetxt(ctx,ctx.currentSheetId,{column:[cf,cf],row:[rf,rf]},ctx.formulaCache.rangetosheet);}else{range=getRangetxt(ctx,ctx.currentSheetId,selected,ctx.formulaCache.rangetosheet);}if(!israngeseleciton(ctx)&&(ctx.formulaCache.rangestart||ctx.formulaCache.rangedrag_column_start||ctx.formulaCache.rangedrag_row_start)){var span=$editor.querySelector("span[rangeindex='".concat(ctx.formulaCache.rangechangeindex,"']"));if(span){span.innerHTML=range;setCaretPosition(ctx,span,0,range.length);}}else{var function_str="<span class=\"fortune-formula-functionrange-cell\" rangeindex=\"".concat(functionHTMLIndex,"\" dir=\"auto\" style=\"color:").concat(colors[functionHTMLIndex],";\">").concat(range,"</span>");var newEle=parseElement(function_str);var refEle=ctx.formulaCache.rangeSetValueTo;if(refEle&&refEle.parentNode){var _document$getElements,_leftPar$parentElemen;var leftPar=(_document$getElements=document.getElementsByClassName("luckysheet-formula-text-lpar"))===null||_document$getElements===void 0?void 0:_document$getElements[0];if(leftPar===null||leftPar===void 0?void 0:(_leftPar$parentElemen=leftPar.parentElement)===null||_leftPar$parentElemen===void 0?void 0:_leftPar$parentElemen.classList.contains("luckysheet-formula-text-color")){var _document$getElements2,_document$getElements3;(_document$getElements2=document.getElementsByClassName("luckysheet-formula-text-lpar"))===null||_document$getElements2===void 0?void 0:(_document$getElements3=_document$getElements2[0].parentNode)===null||_document$getElements3===void 0?void 0:_document$getElements3.appendChild(newEle);}else{refEle.parentNode.insertBefore(newEle,refEle.nextSibling);}}else{$editor.appendChild(newEle);}ctx.formulaCache.rangechangeindex=functionHTMLIndex;var _span=$editor.querySelector("span[rangeindex='".concat(ctx.formulaCache.rangechangeindex,"']"));setCaretPosition(ctx,_span,0,range.length);functionHTMLIndex+=1;}if($copyTo)$copyTo.innerHTML=$editor.innerHTML;}function onFormulaRangeDragEnd(ctx){if(ctx.formulaCache.func_selectedrange){var _ctx$formulaCache$fun=ctx.formulaCache.func_selectedrange,left=_ctx$formulaCache$fun.left_move,top=_ctx$formulaCache$fun.top_move,width=_ctx$formulaCache$fun.width_move,height=_ctx$formulaCache$fun.height_move;if(left!=null&&top!=null&&width!=null&&height!=null&&(ctx.formulaCache.rangestart||ctx.formulaCache.rangedrag_column_start||ctx.formulaCache.rangedrag_row_start))ctx.formulaRangeSelect={rangeIndex:ctx.formulaCache.rangeIndex||0,left:left,top:top,width:width,height:height};}ctx.formulaCache.selectingRangeIndex=-1;}function setRangeSelect(container,left,top,height,width){var rangeElement=container.querySelector(".fortune-formula-functionrange-select");if(rangeElement==null)return;rangeElement.style.left="".concat(left,"px");rangeElement.style.top="".concat(top,"px");rangeElement.style.height="".concat(height,"px");rangeElement.style.width="".concat(width,"px");}function rangeDrag(ctx,e,cellInput,scrollLeft,scrollTop,container,fxInput){var func_selectedrange=ctx.formulaCache.func_selectedrange;if(!func_selectedrange||func_selectedrange.left==null||func_selectedrange.height==null||func_selectedrange.top==null||func_selectedrange.width==null)return;var rect=container.getBoundingClientRect();var x=e.pageX-rect.left-ctx.rowHeaderWidth+scrollLeft;var y=e.pageY-rect.top-ctx.columnHeaderHeight+scrollTop;var _rowLocation=rowLocation(y,ctx.visibledatarow),_rowLocation2=index_esm_slicedToArray(_rowLocation,3),row_pre=_rowLocation2[0],row=_rowLocation2[1],row_index=_rowLocation2[2];var _colLocation=colLocation(x,ctx.visibledatacolumn),_colLocation2=index_esm_slicedToArray(_colLocation,3),col_pre=_colLocation2[0],col=_colLocation2[1],col_index=_colLocation2[2];var top=0;var height=0;var rowseleted=[];if(func_selectedrange.top>row_pre){top=row_pre;height=func_selectedrange.top+func_selectedrange.height-row_pre;rowseleted=[row_index,func_selectedrange.row[1]];}else if(func_selectedrange.top===row_pre){top=row_pre;height=func_selectedrange.top+func_selectedrange.height-row_pre;rowseleted=[row_index,func_selectedrange.row[0]];}else{top=func_selectedrange.top;height=row-func_selectedrange.top-1;rowseleted=[func_selectedrange.row[0],row_index];}var left=0;var width=0;var columnseleted=[];if(func_selectedrange.left>col_pre){left=col_pre;width=func_selectedrange.left+func_selectedrange.width-col_pre;columnseleted=[col_index,func_selectedrange.column[1]];}else if(func_selectedrange.left===col_pre){left=col_pre;width=func_selectedrange.left+func_selectedrange.width-col_pre;columnseleted=[col_index,func_selectedrange.column[0]];}else{left=func_selectedrange.left;width=col-func_selectedrange.left-1;columnseleted=[func_selectedrange.column[0],col_index];}var changeparam=mergeMoveMain(ctx,columnseleted,rowseleted,func_selectedrange,top,height,left,width);if(changeparam!=null){var _changeparam=index_esm_slicedToArray(changeparam,6);columnseleted=_changeparam[0];rowseleted=_changeparam[1];top=_changeparam[2];height=_changeparam[3];left=_changeparam[4];width=_changeparam[5];}func_selectedrange.row=rowseleted;func_selectedrange.column=columnseleted;func_selectedrange.left_move=left;func_selectedrange.width_move=width;func_selectedrange.top_move=top;func_selectedrange.height_move=height;rangeSetValue(ctx,cellInput,{row:rowseleted,column:columnseleted},fxInput);setRangeSelect(container,left,top,height,width);e.preventDefault();}function rangeDragColumn(ctx,e,cellInput,scrollLeft,scrollTop,container,fxInput){var func_selectedrange=ctx.formulaCache.func_selectedrange;if(!func_selectedrange||func_selectedrange.left==null||func_selectedrange.height==null||func_selectedrange.top==null||func_selectedrange.width==null)return;var mouse=mousePosition(e.pageX,e.pageY,ctx);var x=mouse[0]+scrollLeft;var visibledatarow=ctx.visibledatarow;var row_index=visibledatarow.length-1;var row=visibledatarow[row_index];var row_pre=0;var _colLocation3=colLocation(x,ctx.visibledatacolumn),_colLocation4=index_esm_slicedToArray(_colLocation3,3),col_pre=_colLocation4[0],col=_colLocation4[1],col_index=_colLocation4[2];var left=0;var width=0;var columnseleted=[];if(func_selectedrange.left>col_pre){left=col_pre;width=func_selectedrange.left+func_selectedrange.width-col_pre;columnseleted=[col_index,func_selectedrange.column[1]];}else if(func_selectedrange.left===col_pre){left=col_pre;width=func_selectedrange.left+func_selectedrange.width-col_pre;columnseleted=[col_index,func_selectedrange.column[0]];}else{left=func_selectedrange.left;width=col-func_selectedrange.left-1;columnseleted=[func_selectedrange.column[0],col_index];}var changeparam=mergeMoveMain(ctx,columnseleted,[0,row_index],func_selectedrange,row_pre,row-row_pre-1,left,width);if(changeparam!=null){var _changeparam2=index_esm_slicedToArray(changeparam,6);columnseleted=_changeparam2[0];left=_changeparam2[4];width=_changeparam2[5];}func_selectedrange.column=columnseleted;func_selectedrange.left_move=left;func_selectedrange.width_move=width;rangeSetValue(ctx,cellInput,{row:[null,null],column:columnseleted},fxInput);setRangeSelect(container,left,row_pre,row-row_pre-1,width);}function rangeDragRow(ctx,e,cellInput,scrollLeft,scrollTop,container,fxInput){var func_selectedrange=ctx.formulaCache.func_selectedrange;if(!func_selectedrange||func_selectedrange.left==null||func_selectedrange.height==null||func_selectedrange.top==null||func_selectedrange.width==null)return;var mouse=mousePosition(e.pageX,e.pageY,ctx);var y=mouse[1]+scrollTop;var _rowLocation3=rowLocation(y,ctx.visibledatarow),_rowLocation4=index_esm_slicedToArray(_rowLocation3,3),row_pre=_rowLocation4[0],row=_rowLocation4[1],row_index=_rowLocation4[2];var visibledatacolumn=ctx.visibledatacolumn;var col_index=visibledatacolumn.length-1;var col=visibledatacolumn[col_index];var col_pre=0;var top=0;var height=0;var rowseleted=[];if(func_selectedrange.top>row_pre){top=row_pre;height=func_selectedrange.top+func_selectedrange.height-row_pre;rowseleted=[row_index,func_selectedrange.row[1]];}else if(func_selectedrange.top===row_pre){top=row_pre;height=func_selectedrange.top+func_selectedrange.height-row_pre;rowseleted=[row_index,func_selectedrange.row[0]];}else{top=func_selectedrange.top;height=row-func_selectedrange.top-1;rowseleted=[func_selectedrange.row[0],row_index];}var changeparam=mergeMoveMain(ctx,[0,col_index],rowseleted,func_selectedrange,top,height,col_pre,col-col_pre-1);if(changeparam!=null){var _changeparam3=index_esm_slicedToArray(changeparam,4);rowseleted=_changeparam3[1];top=_changeparam3[2];height=_changeparam3[3];}func_selectedrange.row=rowseleted;func_selectedrange.top_move=top;func_selectedrange.height_move=height;rangeSetValue(ctx,cellInput,{row:rowseleted,column:[null,null]},fxInput);setRangeSelect(container,col_pre,top,height,col-col_pre-1);}function updateparam(orient,txt,step){var val=txt.split("!");var rangetxt;var prefix="";if(val.length>1){var _val5=index_esm_slicedToArray(val,2);rangetxt=_val5[1];prefix="".concat(val[0],"!");}else{var _val6=index_esm_slicedToArray(val,1);rangetxt=_val6[0];}if(rangetxt.indexOf(":")===-1){var _row3=parseInt(rangetxt.replace(/[^0-9]/g,""),10);var _col3=columnCharToIndex(rangetxt.replace(/[^A-Za-z]/g,""));var freezonFuc=isfreezonFuc(rangetxt);var $row=freezonFuc[0]?"$":"";var $col=freezonFuc[1]?"$":"";if(orient==="u"&&!freezonFuc[0]){_row3-=step;}else if(orient==="r"&&!freezonFuc[1]){_col3+=step;}else if(orient==="l"&&!freezonFuc[1]){_col3-=step;}else if(orient==="d"&&!freezonFuc[0]){_row3+=step;}if(!Number.isNaN(_row3)&&!Number.isNaN(_col3)){return prefix+$col+indexToColumnChar(_col3)+$row+_row3;}if(!Number.isNaN(_row3)){return prefix+$row+_row3;}if(!Number.isNaN(_col3)){return prefix+$col+indexToColumnChar(_col3);}return txt;}rangetxt=rangetxt.split(":");var row=[];var col=[];row[0]=parseInt(rangetxt[0].replace(/[^0-9]/g,""),10);row[1]=parseInt(rangetxt[1].replace(/[^0-9]/g,""),10);if(row[0]>row[1]){return txt;}col[0]=columnCharToIndex(rangetxt[0].replace(/[^A-Za-z]/g,""));col[1]=columnCharToIndex(rangetxt[1].replace(/[^A-Za-z]/g,""));if(col[0]>col[1]){return txt;}var freezonFuc0=isfreezonFuc(rangetxt[0]);var freezonFuc1=isfreezonFuc(rangetxt[1]);var $row0=freezonFuc0[0]?"$":"";var $col0=freezonFuc0[1]?"$":"";var $row1=freezonFuc1[0]?"$":"";var $col1=freezonFuc1[1]?"$":"";if(orient==="u"){if(!freezonFuc0[0]){row[0]-=step;}if(!freezonFuc1[0]){row[1]-=step;}}else if(orient==="r"){if(!freezonFuc0[1]){col[0]+=step;}if(!freezonFuc1[1]){col[1]+=step;}}else if(orient==="l"){if(!freezonFuc0[1]){col[0]-=step;}if(!freezonFuc1[1]){col[1]-=step;}}else if(orient==="d"){if(!freezonFuc0[0]){row[0]+=step;}if(!freezonFuc1[0]){row[1]+=step;}}if(row[0]<0||col[0]<0){return error.r;}if(Number.isNaN(col[0])&&Number.isNaN(col[1])){return"".concat(prefix+$row0+row[0],":").concat($row1).concat(row[1]);}if(Number.isNaN(row[0])&&Number.isNaN(row[1])){return"".concat(prefix+$col0+indexToColumnChar(col[0]),":").concat($col1).concat(indexToColumnChar(col[1]));}return"".concat(prefix+$col0+indexToColumnChar(col[0])+$row0+row[0],":").concat($col1).concat(indexToColumnChar(col[1])).concat($row1).concat(row[1]);}function downparam(txt,step){return updateparam("d",txt,step);}function upparam(txt,step){return updateparam("u",txt,step);}function leftparam(txt,step){return updateparam("l",txt,step);}function rightparam(txt,step){return updateparam("r",txt,step);}function functionCopy(ctx,txt,mode,step){if(mode==null){mode="down";}if(step==null){step=1;}if(txt.substring(0,1)==="="){txt=txt.substring(1);}var funcstack=txt.split("");var i=0;var str="";var function_str="";var matchConfig={bracket:0,comma:0,squote:0,dquote:0};while(i<funcstack.length){var s=funcstack[i];if(s==="("&&matchConfig.dquote===0){matchConfig.bracket+=1;if(str.length>0){function_str+="".concat(str,"(");}else{function_str+="(";}str="";}else if(s===")"&&matchConfig.dquote===0){matchConfig.bracket-=1;function_str+="".concat(functionCopy(ctx,str,mode,step),")");str="";}else if(s==='"'&&matchConfig.squote===0){if(matchConfig.dquote>0){function_str+="".concat(str,"\"");matchConfig.dquote-=1;str="";}else{matchConfig.dquote+=1;str+='"';}}else if(s===","&&matchConfig.dquote===0){function_str+="".concat(functionCopy(ctx,str,mode,step),",");str="";}else if(s==="&"&&matchConfig.dquote===0){if(str.length>0){function_str+="".concat(functionCopy(ctx,str,mode,step),"&");str="";}else{function_str+="&";}}else if(s in operatorjson&&matchConfig.dquote===0){var s_next="";if(i+1<funcstack.length){s_next=funcstack[i+1];}var p=i-1;var s_pre=null;if(p>=0){do{s_pre=funcstack[p];p-=1;}while(p>=0&&s_pre===" ");}if(s+s_next in operatorjson){if(str.length>0){function_str+=functionCopy(ctx,str,mode,step)+s+s_next;str="";}else{function_str+=s+s_next;}i+=1;}else if(!/[^0-9]/.test(s_next)&&s==="-"&&(s_pre==="("||s_pre==null||s_pre===","||s_pre===" "||s_pre in operatorjson)){str+=s;}else{if(str.length>0){function_str+=functionCopy(ctx,str,mode,step)+s;str="";}else{function_str+=s;}}}else{str+=s;}if(i===funcstack.length-1){if(iscelldata(lodash_default().trim(str))){if(mode==="down"){function_str+=downparam(lodash_default().trim(str),step);}else if(mode==="up"){function_str+=upparam(lodash_default().trim(str),step);}else if(mode==="left"){function_str+=leftparam(lodash_default().trim(str),step);}else if(mode==="right"){function_str+=rightparam(lodash_default().trim(str),step);}}else{function_str+=lodash_default().trim(str);}}i+=1;}return function_str;}function checkCellIsLocked(ctx,r,c,sheetId){var _data$r,_sheetFile$config;var sheetFile=getSheetByIndex(ctx,sheetId);if(lodash_default().isNil(sheetFile)){return false;}var data=sheetFile.data;var cell=data===null||data===void 0?void 0:(_data$r=data[r])===null||_data$r===void 0?void 0:_data$r[c];if(!lodash_default().isNil(cell===null||cell===void 0?void 0:cell.lo)){return!!(cell===null||cell===void 0?void 0:cell.lo);}var aut=(_sheetFile$config=sheetFile.config)===null||_sheetFile$config===void 0?void 0:_sheetFile$config.authority;var sheetInEditable=lodash_default().isNil(aut)||lodash_default().isNil(aut.sheet)||aut.sheet===0;return!sheetInEditable;}function checkProtectionSelectLockedOrUnLockedCells(ctx,r,c,sheetId){var _data$r2;var sheetFile=getSheetByIndex(ctx,sheetId);if(lodash_default().isNil(sheetFile)){return true;}if(lodash_default().isNil(sheetFile.config)||lodash_default().isNil(sheetFile.config.authority)){return true;}var aut=sheetFile.config.authority;if(lodash_default().isNil(aut)||lodash_default().isNil(aut.sheet)||aut.sheet===0){return true;}var data=sheetFile.data;var cell=data===null||data===void 0?void 0:(_data$r2=data[r])===null||_data$r2===void 0?void 0:_data$r2[c];if(cell&&cell.lo===0){if(aut.selectunLockedCells===1||lodash_default().isNil(aut.selectunLockedCells)){return true;}return false;}if(aut.selectLockedCells===1||lodash_default().isNil(aut.selectLockedCells)){return true;}return false;}function checkProtectionAllSelected(ctx,sheetId){var sheetFile=getSheetByIndex(ctx,sheetId);if(lodash_default().isNil(sheetFile)){return true;}if(lodash_default().isNil(sheetFile.config)||lodash_default().isNil(sheetFile.config.authority)){return true;}var aut=sheetFile.config.authority;if(lodash_default().isNil(aut)||lodash_default().isNil(aut.sheet)||aut.sheet===0){return true;}var selectunLockedCells=false;if(aut.selectunLockedCells===1||lodash_default().isNil(aut.selectunLockedCells)){selectunLockedCells=true;}var selectLockedCells=false;if(aut.selectLockedCells===1||lodash_default().isNil(aut.selectLockedCells)){selectLockedCells=true;}if(selectunLockedCells&&selectLockedCells){return true;}return false;}function checkProtectionFormatCells(ctx){var sheetFile=getSheetByIndex(ctx,ctx.currentSheetId);if(lodash_default().isNil(sheetFile)){return true;}if(lodash_default().isNil(sheetFile.config)||lodash_default().isNil(sheetFile.config.authority)){return true;}var aut=sheetFile.config.authority;if(lodash_default().isNil(aut)||lodash_default().isNil(aut.sheet)||aut.sheet===0){return true;}var ht="";if(!lodash_default().isNil(aut.hintText)&&aut.hintText.length>0){ht=aut.hintText;}else{ht=aut.defaultSheetHintText;}ctx.warnDialog=ht;return false;}function getHistoryRules(fileH){var historyRules=[];for(var h=0;h<fileH.length;h+=1){historyRules.push({sheetIndex:h,luckysheet_conditionformat_save:fileH[h].luckysheet_conditionformat_save});}return historyRules;}function getCurrentRules(fileC){var currentRules=[];for(var c=0;c<fileC.length;c+=1){currentRules.push({sheetIndex:c,luckysheet_conditionformat_save:fileC[c].luckysheet_conditionformat_save});}return currentRules;}function setConditionRules(ctx,protection,generalDialog,conditionformat,rules){var _ctx$luckysheet_selec,_ctx$luckysheetfile$i;if(!checkProtectionFormatCells(ctx)){return;}var conditionName=rules.rulesType;var conditionRange=[];var conditionValue=[];if(conditionName==="greaterThan"||conditionName==="lessThan"||conditionName==="equal"||conditionName==="textContains"){var v=rules.rulesValue;var rangeArr=getRangeByTxt(ctx,v);if(rangeArr.length>1){var r1=rangeArr[0].row[0];var r2=rangeArr[0].row[1];var c1=rangeArr[0].column[0];var c2=rangeArr[0].column[1];if(r1===r2&&c1===c2){var d=getFlowdata(ctx);if(!d)return;v=getCellValue(r1,c1,d);conditionRange.push({row:rangeArr[0].row,column:rangeArr[0].column});conditionValue.push(v);}else{ctx.warnDialog=conditionformat.onlySingleCell;}}else if(rangeArr.length===0){if(lodash_default().isNaN(v)||v===""){ctx.warnDialog=conditionformat.conditionValueCanOnly;return;}conditionValue.push(v);}}else if(conditionName==="between"){var v1=rules.betweenValue.value1;var v2=rules.betweenValue.value2;var rangeArr1=getRangeByTxt(ctx,v1);if(rangeArr1.length>1){ctx.warnDialog=conditionformat.onlySingleCell;return;}if(rangeArr1.length===1){var _r=rangeArr1[0].row[0];var _r2=rangeArr1[0].row[1];var _c=rangeArr1[0].column[0];var _c2=rangeArr1[0].column[1];if(_r===_r2&&_c===_c2){var _d=getFlowdata(ctx);if(!_d)return;v1=getCellValue(_r,_c,_d);conditionRange.push({row:rangeArr1[0].row,column:rangeArr1[0].column});conditionValue.push(v1);}else{ctx.warnDialog=conditionformat.onlySingleCell;return;}}else if(rangeArr1.length===0){if(lodash_default().isNaN(v1)||v1===""){ctx.warnDialog=conditionformat.conditionValueCanOnly;return;}conditionValue.push(v1);}var rangeArr2=getRangeByTxt(ctx,v2);if(rangeArr2.length>1){ctx.warnDialog=conditionformat.onlySingleCell;return;}if(rangeArr2.length===1){var _r3=rangeArr2[0].row[0];var _r4=rangeArr2[0].row[1];var _c3=rangeArr2[0].column[0];var _c4=rangeArr2[0].column[1];if(_r3===_r4&&_c3===_c4){var _d2=getFlowdata(ctx);if(!_d2)return;v2=getCellValue(_r3,_c3,_d2);conditionRange.push({row:rangeArr2[0].row,column:rangeArr2[0].column});}else{ctx.warnDialog=conditionformat.onlySingleCell;return;}}else if(rangeArr2.length===0){if(lodash_default().isNaN(v2)||v2===""){ctx.warnDialog=conditionformat.conditionValueCanOnly;}else{conditionValue.push(v2);}}}else if(conditionName==="occurrenceDate"){var _v=rules.dateValue;if(!_v){ctx.warnDialog=conditionformat.pleaseSelectADate;return;}conditionValue.push(_v);}else if(conditionName==="duplicateValue"){conditionValue.push(rules.repeatValue);}else if(conditionName==="top10"||conditionName==="top10_percent"||conditionName==="last10"||conditionName==="last10_percent"){var _v2=rules.projectValue;if(parseInt(_v2,10).toString()!==_v2||parseInt(_v2,10)<1||parseInt(_v2,10)>1000){ctx.warnDialog=conditionformat.pleaseEnterInteger;return;}conditionValue.push(_v2);}else{conditionValue.push(conditionName);}var textColor=null;if(rules.textColor.check){textColor=rules.textColor.color;}var cellColor=null;if(rules.cellColor.check){cellColor=rules.cellColor.color;}var rule={type:"default",cellrange:(_ctx$luckysheet_selec=ctx.luckysheet_select_save)!==null&&_ctx$luckysheet_selec!==void 0?_ctx$luckysheet_selec:[],format:{textColor:textColor,cellColor:cellColor},conditionName:conditionName,conditionRange:conditionRange,conditionValue:conditionValue};var index=getSheetIndex(ctx,ctx.currentSheetId);var ruleArr=(_ctx$luckysheetfile$i=ctx.luckysheetfile[index].luckysheet_conditionformat_save)!==null&&_ctx$luckysheetfile$i!==void 0?_ctx$luckysheetfile$i:[];ruleArr===null||ruleArr===void 0?void 0:ruleArr.push(rule);ctx.luckysheetfile[index].luckysheet_conditionformat_save=ruleArr;}function getColorGradation(color1,color2,value1,value2,value){var rgb1=color1.split(",");var r1=parseInt(rgb1[0].split("(")[1],10);var g1=parseInt(rgb1[1],10);var b1=parseInt(rgb1[2].split(")")[0],10);var rgb2=color2.split(",");var r2=parseInt(rgb2[0].split("(")[1],10);var g2=parseInt(rgb2[1],10);var b2=parseInt(rgb2[2].split(")")[0],10);var v12=value1-value2;var v10=value1-value;var r=Math.round(r1-(r1-r2)/v12*v10);var g=Math.round(g1-(g1-g2)/v12*v10);var b=Math.round(b1-(b1-b2)/v12*v10);return"rgb(".concat(r,", ").concat(g,", ").concat(b,")");}function compute(ctx,ruleArr,d){if(lodash_default().isNil(ruleArr)){ruleArr=[];}var computeMap={};if(ruleArr.length>0){for(var i=0;i<ruleArr.length;i+=1){var _ruleArr$i=ruleArr[i],type=_ruleArr$i.type,cellrange=_ruleArr$i.cellrange,format=_ruleArr$i.format;if(type==="dataBar"){var max=null;var min=null;for(var s=0;s<cellrange.length;s+=1){for(var r=cellrange[s].row[0];r<=cellrange[s].row[1];r+=1){for(var c=cellrange[s].column[0];c<=cellrange[s].column[1];c+=1){if(lodash_default().isNil(d[r])||lodash_default().isNil(d[r][c])){continue;}var cell=d[r][c];if(!lodash_default().isNil(cell)&&!lodash_default().isNil(cell.ct)&&cell.ct.t==="n"&&lodash_default().isNil(cell.v)){if(lodash_default().isNil(max)||parseInt("".concat(cell.v),10)>max){max=parseInt("".concat(cell.v),10);}if(lodash_default().isNil(min)||parseInt("".concat(cell.v),10)<min){min=parseInt("".concat(cell.v),10);}}}}}if(!lodash_default().isNil(max)&&!lodash_default().isNil(min)){if(min<0){var plusLen=Math.round(max/(max-min)*10)/10;var minusLen=Math.round(Math.abs(min)/(max-min)*10)/10;for(var _s=0;_s<cellrange.length;_s+=1){for(var _r5=cellrange[_s].row[0];_r5<=cellrange[_s].row[1];_r5+=1){for(var _c5=cellrange[_s].column[0];_c5<=cellrange[_s].column[1];_c5+=1){if(lodash_default().isNil(d[_r5])||lodash_default().isNil(d[_r5][_c5])){continue;}var _cell=d[_r5][_c5];if(!lodash_default().isNil(_cell)&&!lodash_default().isNil(_cell.ct)&&_cell.ct.t==="n"&&!lodash_default().isNil(_cell.v)){if(parseInt("".concat(_cell.v),10)<0){var valueLen=Math.round(Math.abs(parseInt("".concat(_cell.v),10))/Math.abs(min)*100)/100;if("".concat(_r5,"_").concat(_c5)in computeMap){computeMap["".concat(_r5,"_").concat(_c5)].dataBar={valueType:"minus",minusLen:minusLen,valueLen:valueLen,format:format};}else{computeMap["".concat(_r5,"_").concat(_c5)]={dataBar:{valueType:"minus",minusLen:minusLen,valueLen:valueLen,format:format}};}}if(parseInt("".concat(_cell.v),10)>0){var _valueLen=Math.round(parseInt("".concat(_cell.v),10)/max*100)/100;if("".concat(_r5,"_").concat(_c5)in computeMap){computeMap["".concat(_r5,"_").concat(_c5)].dataBar={valueType:"plus",plusLen:plusLen,minusLen:minusLen,valueLen:_valueLen,format:format};}else{computeMap["".concat(_r5,"_").concat(_c5)]={dataBar:{valueType:"plus",plusLen:plusLen,minusLen:minusLen,valueLen:_valueLen,format:format}};}}}}}}}else{var _plusLen=1;for(var _s2=0;_s2<cellrange.length;_s2+=1){for(var _r6=cellrange[_s2].row[0];_r6<=cellrange[_s2].row[1];_r6+=1){for(var _c6=cellrange[_s2].column[0];_c6<=cellrange[_s2].column[1];_c6+=1){if(lodash_default().isNil(d[_r6])||lodash_default().isNil(d[_r6][_c6])){continue;}var _cell2=d[_r6][_c6];if(!lodash_default().isNil(_cell2)&&!lodash_default().isNil(_cell2.ct)&&_cell2.ct.t==="n"&&!lodash_default().isNil(_cell2.v)){var _valueLen2=void 0;if(max===0){_valueLen2=1;}else{_valueLen2=Math.round(parseInt("".concat(_cell2.v),10)/max*100)/100;}if("".concat(_r6,"_").concat(_c6)in computeMap){computeMap["".concat(_r6,"_").concat(_c6)].dataBar={valueType:"plus",plusLen:_plusLen,valueLen:_valueLen2,format:format};}else{computeMap["".concat(_r6,"_").concat(_c6)]={dataBar:{valueType:"plus",plusLen:_plusLen,valueLen:_valueLen2,format:format}};}}}}}}}}else if(type==="colorGradation"){var _max=null;var _min=null;var sum=0;var count=0;for(var _s3=0;_s3<cellrange.length;_s3+=1){for(var _r7=cellrange[_s3].row[0];_r7<=cellrange[_s3].row[1];_r7+=1){for(var _c7=cellrange[_s3].column[0];_c7<=cellrange[_s3].column[1];_c7+=1){if(lodash_default().isNil(d[_r7])||lodash_default().isNil(d[_r7][_c7])){continue;}var _cell3=d[_r7][_c7];if(!lodash_default().isNil(_cell3)&&!lodash_default().isNil(_cell3.ct)&&_cell3.ct.t==="n"&&!lodash_default().isNil(_cell3.v)){count+=1;sum+=parseInt("".concat(_cell3.v),10);if(lodash_default().isNil(_max)||parseInt("".concat(_cell3.v),10)>_max){_max=parseInt("".concat(_cell3.v),10);}if(lodash_default().isNil(_min)||parseInt("".concat(_cell3.v),10)<_min){_min=parseInt("".concat(_cell3.v),10);}}}}}if(!lodash_default().isNil(_max)&&!lodash_default().isNil(_min)){if(format.length===3){var avg=Math.floor(sum/count);for(var _s4=0;_s4<cellrange.length;_s4+=1){for(var _r8=cellrange[_s4].row[0];_r8<=cellrange[_s4].row[1];_r8+=1){for(var _c8=cellrange[_s4].column[0];_c8<=cellrange[_s4].column[1];_c8+=1){if(lodash_default().isNil(d[_r8])||lodash_default().isNil(d[_r8][_c8])){continue;}var _cell4=d[_r8][_c8];if(!lodash_default().isNil(_cell4)&&!lodash_default().isNil(_cell4.ct)&&_cell4.ct.t==="n"&&!lodash_default().isNil(_cell4.v)){if(parseInt("".concat(_cell4.v),10)===_min){if("".concat(_r8,"_").concat(_c8)in computeMap){computeMap["".concat(_r8,"_").concat(_c8)].cellColor=format.cellColor;}else{computeMap["".concat(_r8,"_").concat(_c8)]={cellColor:format.cellColor};}}else if(parseInt("".concat(_cell4.v),10)>_min&&parseInt("".concat(_cell4.v),10)<avg){if("".concat(_r8,"_").concat(_c8)in computeMap){computeMap["".concat(_r8,"_").concat(_c8)].cellColor=getColorGradation(format.cellColor,format.textColor,_min,avg,parseInt("".concat(_cell4.v),10));}else{computeMap["".concat(_r8,"_").concat(_c8)]={cellColor:getColorGradation(format[2],format[1],_min,avg,parseInt("".concat(_cell4.v),10))};}}else if(parseInt("".concat(_cell4.v),10)===avg){if("".concat(_r8,"_").concat(_c8)in computeMap){computeMap["".concat(_r8,"_").concat(_c8)].cellColor=format.cellColor;}else{computeMap["".concat(_r8,"_").concat(_c8)]={cellColor:format[1]};}}else if(parseInt("".concat(_cell4.v),10)>avg&&parseInt("".concat(_cell4.v),10)<_max){if("".concat(_r8,"_").concat(_c8)in computeMap){computeMap["".concat(_r8,"_").concat(_c8)].cellColor=getColorGradation(format[1],format[0],avg,_max,parseInt("".concat(_cell4.v),10));}else{computeMap["".concat(_r8,"_").concat(_c8)]={cellColor:getColorGradation(format[1],format[0],avg,_max,parseInt("".concat(_cell4.v),10))};}}else if(parseInt("".concat(_cell4.v),10)===_max){if("".concat(_r8,"_").concat(_c8)in computeMap){computeMap["".concat(_r8,"_").concat(_c8)].cellColor=format.cellColor;}else{computeMap["".concat(_r8,"_").concat(_c8)]={cellColor:format[0]};}}}}}}}else if(format.length===2){for(var _s5=0;_s5<cellrange.length;_s5+=1){for(var _r9=cellrange[_s5].row[0];_r9<=cellrange[_s5].row[1];_r9+=1){for(var _c9=cellrange[_s5].column[0];_c9<=cellrange[_s5].column[1];_c9+=1){if(lodash_default().isNil(d[_r9])||lodash_default().isNil(d[_r9][_c9])){continue;}var _cell5=d[_r9][_c9];if(!lodash_default().isNil(_cell5)&&!lodash_default().isNil(_cell5.ct)&&_cell5.ct.t==="n"&&!lodash_default().isNil(_cell5.v)){if(parseInt("".concat(_cell5.v),10)===_min){if("".concat(_r9,"_").concat(_c9)in computeMap){computeMap["".concat(_r9,"_").concat(_c9)].cellColor=format.cellColor;}else{computeMap["".concat(_r9,"_").concat(_c9)]={cellColor:format[1]};}}else if(parseInt("".concat(_cell5.v),10)>_min&&parseInt("".concat(_cell5.v),10)<_max){if("".concat(_r9,"_").concat(_c9)in computeMap){computeMap["".concat(_r9,"_").concat(_c9)].cellColor=getColorGradation(format[1],format[0],_min,_max,parseInt("".concat(_cell5.v),10));}else{computeMap["".concat(_r9,"_").concat(_c9)]={cellColor:getColorGradation(format[1],format[0],_min,_max,parseInt("".concat(_cell5.v),10))};}}else if(parseInt("".concat(_cell5.v),10)===_max){if("".concat(_r9,"_").concat(_c9)in computeMap){computeMap["".concat(_r9,"_").concat(_c9)].cellColor=format.textColor;}else{computeMap["".concat(_r9,"_").concat(_c9)]={cellColor:format[0]};}}}}}}}}}else if(type==="icons");else{(function(){var conditionName=ruleArr[i].conditionName;var conditionValue0=ruleArr[i].conditionValue[0];var conditionValue1=ruleArr[i].conditionValue[1];var textColor=format.textColor,cellColor=format.cellColor;for(var _s6=0;_s6<cellrange.length;_s6+=1){if(conditionName==="greaterThan"||conditionName==="lessThan"||conditionName==="equal"||conditionName==="textContains"){for(var _r10=cellrange[_s6].row[0];_r10<=cellrange[_s6].row[1];_r10+=1){for(var _c10=cellrange[_s6].column[0];_c10<=cellrange[_s6].column[1];_c10+=1){if(lodash_default().isNil(d[_r10])||lodash_default().isNil(d[_r10][_c10])){continue;}var _cell6=d[_r10][_c10];if(lodash_default().isNil(_cell6)||lodash_default().isNil(_cell6.v)||isRealNull(_cell6.v)){continue;}if(conditionName==="greaterThan"&&_cell6.v>conditionValue0){if("".concat(_r10,"_").concat(_c10)in computeMap){computeMap["".concat(_r10,"_").concat(_c10)].textColor=textColor;computeMap["".concat(_r10,"_").concat(_c10)].cellColor=cellColor;}else{computeMap["".concat(_r10,"_").concat(_c10)]={textColor:textColor,cellColor:cellColor};}}else if(conditionName==="lessThan"&&_cell6.v<conditionValue0){if("".concat(_r10,"_").concat(_c10)in computeMap){computeMap["".concat(_r10,"_").concat(_c10)].textColor=textColor;computeMap["".concat(_r10,"_").concat(_c10)].cellColor=cellColor;}else{computeMap["".concat(_r10,"_").concat(_c10)]={textColor:textColor,cellColor:cellColor};}}else if(conditionName==="equal"&&_cell6.v.toString()===conditionValue0){if("".concat(_r10,"_").concat(_c10)in computeMap){computeMap["".concat(_r10,"_").concat(_c10)].textColor=textColor;computeMap["".concat(_r10,"_").concat(_c10)].cellColor=cellColor;}else{computeMap["".concat(_r10,"_").concat(_c10)]={textColor:textColor,cellColor:cellColor};}}else if(conditionName==="textContains"&&_cell6.v.toString().indexOf(conditionValue0)!==-1){if("".concat(_r10,"_").concat(_c10)in computeMap){computeMap["".concat(_r10,"_").concat(_c10)].textColor=textColor;computeMap["".concat(_r10,"_").concat(_c10)].cellColor=cellColor;}else{computeMap["".concat(_r10,"_").concat(_c10)]={textColor:textColor,cellColor:cellColor};}}}}}else if(conditionName==="between"){var vBig=0;var vSmall=0;if(conditionValue0>conditionValue1){vBig=conditionValue0;vSmall=conditionValue1;}else{vBig=conditionValue1;vSmall=conditionValue0;}for(var _r11=cellrange[_s6].row[0];_r11<=cellrange[_s6].row[1];_r11+=1){for(var _c11=cellrange[_s6].column[0];_c11<=cellrange[_s6].column[1];_c11+=1){if(lodash_default().isNil(d[_r11])||lodash_default().isNil(d[_r11][_c11])){continue;}var _cell7=d[_r11][_c11];if(lodash_default().isNil(_cell7)||lodash_default().isNil(_cell7.v)||isRealNull(_cell7.v)){continue;}if(_cell7.v>=vSmall&&_cell7.v<=vBig){if("".concat(_r11,"_").concat(_c11)in computeMap){computeMap["".concat(_r11,"_").concat(_c11)].textColor=textColor;computeMap["".concat(_r11,"_").concat(_c11)].cellColor=cellColor;}else{computeMap["".concat(_r11,"_").concat(_c11)]={textColor:textColor,cellColor:cellColor};}}}}}else if(conditionName==="occurrenceDate"){var dBig=void 0;var dSmall=void 0;if(conditionValue0.toString().indexOf("-")===-1){dBig=genarate(conditionValue0)[2].toString();dSmall=genarate(conditionValue0)[2].toString();}else{var str=conditionValue0.toString().split("-");dBig=genarate(str[1].trim())[2].toString();dSmall=genarate(str[0].trim()[2].toString());}for(var _r12=cellrange[_s6].row[0];_r12<=cellrange[_s6].row[1];_r12+=1){for(var _c12=cellrange[_s6].column[0];_c12<=cellrange[_s6].column[1];_c12+=1){if(lodash_default().isNil(d[_r12])||lodash_default().isNil(d[_r12][_c12])){continue;}if(!lodash_default().isNil(d[_r12][_c12])&&!lodash_default().isNil(d[_r12][_c12].ct)&&d[_r12][_c12].ct.t==="d"){var cellVal=getCellValue(_r12,_c12,d);if(cellVal>=dSmall&&cellVal<=dBig){if("".concat(_r12,"_").concat(_c12)in computeMap){computeMap["".concat(_r12,"_").concat(_c12)].textColor=textColor;computeMap["".concat(_r12,"_").concat(_c12)].cellColor=cellColor;}else{computeMap["".concat(_r12,"_").concat(_c12)]={textColor:textColor,cellColor:cellColor};}}}}}}else if(conditionName==="duplicateValue"){var dmap={};for(var _r13=cellrange[_s6].row[0];_r13<=cellrange[_s6].row[1];_r13+=1){for(var _c13=cellrange[_s6].column[0];_c13<=cellrange[_s6].column[1];_c13+=1){var item=getCellValue(_r13,_c13,d);if(!(item in dmap)){dmap[item]=[];}dmap[item].push({r:_r13,c:_c13});}}if(conditionValue0==="0"){lodash_default().forEach(dmap,function(x){if(x.length>1){for(var j=0;j<x.length;j+=1){if("".concat(x[j].r,"_").concat(x[j].c)in computeMap){computeMap["".concat(x[j].r,"_").concat(x[j].c)].textColor=textColor;computeMap["".concat(x[j].r,"_").concat(x[j].c)].cellColor=cellColor;}else{computeMap["".concat(x[j].r,"_").concat(x[j].c)]={textColor:textColor,cellColor:cellColor};}}}});}else if(conditionValue0==="1"){lodash_default().forEach(dmap,function(x){if(x.length===1){if("".concat(x[0].r,"_").concat(x[0].c)in computeMap){computeMap["".concat(x[0].r,"_").concat(x[0].c)].textColor=textColor;computeMap["".concat(x[0].r,"_").concat(x[0].c)].cellColor=cellColor;}else{computeMap["".concat(x[0].r,"_").concat(x[0].c)]={textColor:textColor,cellColor:cellColor};}}});}}else if(conditionName==="top10"||conditionName==="top10_percent"||conditionName==="last10"||conditionName==="last10_percent"||conditionName==="aboveAverage"||conditionName==="belowAverage"){var dArr=[];for(var _r14=cellrange[_s6].row[0];_r14<=cellrange[_s6].row[1];_r14+=1){for(var _c14=cellrange[_s6].column[0];_c14<=cellrange[_s6].column[1];_c14+=1){if(lodash_default().isNil(d[_r14])||lodash_default().isNil(d[_r14][_c14])){continue;}if(!lodash_default().isNil(d[_r14][_c14])&&!lodash_default().isNil(d[_r14][_c14].ct)&&d[_r14][_c14].ct.t==="n"){dArr.push(getCellValue(_r14,_c14,d));}}}if(conditionName==="top10"||conditionName==="top10_percent"||conditionName==="last10"||conditionName==="last10_percent"){for(var j=0;j<dArr.length;j+=1){for(var k=0;k<dArr.length-1-j;k+=1){if(dArr[k]<dArr[k+1]){var temp=dArr[k];dArr[k]=dArr[k+1];dArr[k+1]=temp;}}}var cArr=void 0;if(conditionName==="top10"){cArr=dArr.slice(0,conditionValue0);}else if(conditionName==="top10_percent"){cArr=dArr.slice(0,Math.floor(conditionValue0*dArr.length/100));}else if(conditionName==="last10"){cArr=dArr.slice(dArr.length-conditionValue0,dArr.length);}else if(conditionName==="last10_percent"){cArr=dArr.slice(dArr.length-Math.floor(conditionValue0*dArr.length/100),dArr.length);}for(var _r15=cellrange[_s6].row[0];_r15<=cellrange[_s6].row[1];_r15+=1){for(var _c15=cellrange[_s6].column[0];_c15<=cellrange[_s6].column[1];_c15+=1){if(lodash_default().isNil(d[_r15])||lodash_default().isNil(d[_r15][_c15])){continue;}var _cellVal=getCellValue(_r15,_c15,d);if(!lodash_default().isNil(cArr)&&cArr.indexOf(_cellVal)!==-1){if("".concat(_r15,"_").concat(_c15)in computeMap){computeMap["".concat(_r15,"_").concat(_c15)].textColor=textColor;computeMap["".concat(_r15,"_").concat(_c15)].cellColor=cellColor;}else{computeMap["".concat(_r15,"_").concat(_c15)]={textColor:textColor,cellColor:cellColor};}}}}}else if(conditionName==="aboveAverage"||conditionName==="belowAverage"){var _sum=0;for(var _j=0;_j<dArr.length;_j+=1){_sum+=dArr[_j];}var averageNum=_sum/dArr.length;if(conditionName==="aboveAverage"){for(var _r16=cellrange[_s6].row[0];_r16<=cellrange[_s6].row[1];_r16+=1){for(var _c16=cellrange[_s6].column[0];_c16<=cellrange[_s6].column[1];_c16+=1){if(lodash_default().isNil(d[_r16])||lodash_default().isNil(d[_r16][_c16])){continue;}var _cellVal2=getCellValue(_r16,_c16,d);if(_cellVal2>averageNum){if("".concat(_r16,"_").concat(_c16)in computeMap){computeMap["".concat(_r16,"_").concat(_c16)].textColor=textColor;computeMap["".concat(_r16,"_").concat(_c16)].cellColor=cellColor;}else{computeMap["".concat(_r16,"_").concat(_c16)]={textColor:textColor,cellColor:cellColor};}}}}}else if(conditionName==="belowAverage"){for(var _r17=cellrange[_s6].row[0];_r17<=cellrange[_s6].row[1];_r17+=1){for(var _c17=cellrange[_s6].column[0];_c17<=cellrange[_s6].column[1];_c17+=1){if(lodash_default().isNil(d[_r17])||lodash_default().isNil(d[_r17][_c17])){continue;}var _cellVal3=getCellValue(_r17,_c17,d);if(_cellVal3<averageNum){if("".concat(_r17,"_").concat(_c17)in computeMap){computeMap["".concat(_r17,"_").concat(_c17)].textColor=textColor;computeMap["".concat(_r17,"_").concat(_c17)].cellColor=cellColor;}else{computeMap["".concat(_r17,"_").concat(_c17)]={textColor:textColor,cellColor:cellColor};}}}}}}}else if(conditionName==="formula"){var _str=cellrange[_s6].row[0];var edr=cellrange[_s6].row[1];var stc=cellrange[_s6].column[0];var edc=cellrange[_s6].column[1];var formulaTxt=conditionValue0;if(conditionValue0.toString().slice(0,1)!=="="){formulaTxt="=".concat(conditionValue0);}for(var _r18=_str;_r18<=edr;_r18+=1){for(var _c18=stc;_c18<=edc;_c18+=1){var func=formulaTxt;var offsetRow=_r18-_str;var offsetCol=_c18-stc;if(offsetRow>0){func="=".concat(functionCopy(ctx,func,"down",offsetRow));}if(offsetCol>0){func="=".concat(functionCopy(ctx,func,"right",offsetCol));}var funcV=execfunction(ctx,func,_r18,_c18);var v=funcV[1];if(typeof v!=="boolean"){v=!!Number(v);}if(!v){continue;}if("".concat(_r18,"_").concat(_c18)in computeMap){computeMap["".concat(_r18,"_").concat(_c18)].textColor=textColor;computeMap["".concat(_r18,"_").concat(_c18)].cellColor=cellColor;}else{computeMap["".concat(_r18,"_").concat(_c18)]={textColor:textColor,cellColor:cellColor};}}}}}})();}}}return computeMap;}function getComputeMap(ctx){var index=getSheetIndex(ctx,ctx.currentSheetId);var ruleArr=ctx.luckysheetfile[index].luckysheet_conditionformat_save;var data=ctx.luckysheetfile[index].data;if(lodash_default().isNil(data))return null;var computeMap=compute(ctx,ruleArr,data);return computeMap;}function checkCF(r,c,computeMap){if(!lodash_default().isNil(computeMap)&&"".concat(r,"_").concat(c)in computeMap){return computeMap["".concat(r,"_").concat(c)];}return null;}function updateItem(ctx,type){if(!checkProtectionFormatCells(ctx)){return;}var index=getSheetIndex(ctx,ctx.currentSheetId);var ruleArr=[];if(type==="delSheet"){ruleArr=[];}else{var _ctx$luckysheet_selec2,_ctx$luckysheetfile$i2;var rule={type:type,cellrange:(_ctx$luckysheet_selec2=ctx.luckysheet_select_save)!==null&&_ctx$luckysheet_selec2!==void 0?_ctx$luckysheet_selec2:[],format:{textColor:ctx.conditionRules.textColor,cellColor:ctx.conditionRules.cellColor}};ruleArr=(_ctx$luckysheetfile$i2=ctx.luckysheetfile[index].luckysheet_conditionformat_save)!==null&&_ctx$luckysheetfile$i2!==void 0?_ctx$luckysheetfile$i2:[];ruleArr.push(rule);}ctx.luckysheetfile[index].luckysheet_conditionformat_save=ruleArr;}function CFSplitRange(range1,range2,range3,type){var range=[];var offset_r=range3.row[0]-range2.row[0];var offset_c=range3.column[0]-range2.column[0];var r1=range1.row[0];var r2=range1.row[1];var c1=range1.column[0];var c2=range1.column[1];if(r1>=range2.row[0]&&r2<=range2.row[1]&&c1>=range2.column[0]&&c2<=range2.column[1]){if(type==="allPart"){range=[{row:[r1+offset_r,r2+offset_r],column:[c1+offset_c,c2+offset_c]}];}else if(type==="restPart"){range=[];}else if(type==="operatePart"){range=[{row:[r1+offset_r,r2+offset_r],column:[c1+offset_c,c2+offset_c]}];}}else if(r1>=range2.row[0]&&r1<=range2.row[1]&&c1>=range2.column[0]&&c2<=range2.column[1]){if(type==="allPart"){range=[{row:[range2.row[1]+1,r2],column:[c1,c2]},{row:[r1+offset_r,range2.row[1]+offset_r],column:[c1+offset_c,c2+offset_c]}];}else if(type==="restPart"){range=[{row:[range2.row[1]+1,r2],column:[c1,c2]}];}else if(type==="operatePart"){range=[{row:[r1+offset_r,range2.row[1]+offset_r],column:[c1+offset_c,c2+offset_c]}];}}else if(r2>=range2.row[0]&&r2<=range2.row[1]&&c1>=range2.column[0]&&c2<=range2.column[1]){if(type==="allPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0]+offset_r,r2+offset_r],column:[c1+offset_c,c2+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]}];}else if(type==="operatePart"){range=[{row:[range2.row[0]+offset_r,r2+offset_r],column:[c1+offset_c,c2+offset_c]}];}}else if(r1<range2.row[0]&&r2>range2.row[1]&&c1>=range2.column[0]&&c2<=range2.column[1]){if(type==="allPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]},{row:[range2.row[0]+offset_r,range2.row[1]+offset_r],column:[c1+offset_c,c2+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]}];}else if(type==="operatePart"){range=[{row:[range2.row[0]+offset_r,range2.row[1]+offset_r],column:[c1+offset_c,c2+offset_c]}];}}else if(c1>=range2.column[0]&&c1<=range2.column[1]&&r1>=range2.row[0]&&r2<=range2.row[1]){if(type==="allPart"){range=[{row:[r1,r2],column:[range2.column[1]+1,c2]},{row:[r1+offset_r,r2+offset_r],column:[c1+offset_c,range2.column[1]+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,r2],column:[range2.column[1]+1,c2]}];}else if(type==="operatePart"){range=[{row:[r1+offset_r,r2+offset_r],column:[c1+offset_c,range2.column[1]+offset_c]}];}}else if(c2>=range2.column[0]&&c2<=range2.column[1]&&r1>=range2.row[0]&&r2<=range2.row[1]){if(type==="allPart"){range=[{row:[r1,r2],column:[c1,range2.column[0]-1]},{row:[r1+offset_r,r2+offset_r],column:[range2.column[0]+offset_c,c2+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,r2],column:[c1,range2.column[0]-1]}];}else if(type==="operatePart"){range=[{row:[r1+offset_r,r2+offset_r],column:[range2.column[0]+offset_c,c2+offset_c]}];}}else if(c1<range2.column[0]&&c2>range2.column[1]&&r1>=range2.row[0]&&r2<=range2.row[1]){if(type==="allPart"){range=[{row:[r1,r2],column:[c1,range2.column[0]-1]},{row:[r1,r2],column:[range2.column[1]+1,c2]},{row:[r1+offset_r,r2+offset_r],column:[range2.column[0]+offset_c,range2.column[1]+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,r2],column:[c1,range2.column[0]-1]},{row:[r1,r2],column:[range2.column[1]+1,c2]}];}else if(type==="operatePart"){range=[{row:[r1+offset_r,r2+offset_r],column:[range2.column[0]+offset_c,range2.column[1]+offset_c]}];}}else if(r1>=range2.row[0]&&r1<=range2.row[1]&&c1>=range2.column[0]&&c1<=range2.column[1]){if(type==="allPart"){range=[{row:[r1,range2.row[1]],column:[range2.column[1]+1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]},{row:[r1+offset_r,range2.row[1]+offset_r],column:[c1+offset_c,range2.column[1]+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[1]],column:[range2.column[1]+1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]}];}else if(type==="operatePart"){range=[{row:[r1+offset_r,range2.row[1]+offset_r],column:[c1+offset_c,range2.column[1]+offset_c]}];}}else if(r1>=range2.row[0]&&r1<=range2.row[1]&&c2>=range2.column[0]&&c2<=range2.column[1]){if(type==="allPart"){range=[{row:[r1,range2.row[1]],column:[c1,range2.column[0]-1]},{row:[range2.row[1]+1,r2],column:[c1,c2]},{row:[r1+offset_r,range2.row[1]+offset_r],column:[range2.column[0]+offset_c,c2+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[1]],column:[c1,range2.column[0]-1]},{row:[range2.row[1]+1,r2],column:[c1,c2]}];}else if(type==="operatePart"){range=[{row:[r1+offset_r,range2.row[1]+offset_r],column:[range2.column[0]+offset_c,c2+offset_c]}];}}else if(r2>=range2.row[0]&&r2<=range2.row[1]&&c1>=range2.column[0]&&c1<=range2.column[1]){if(type==="allPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],r2],column:[range2.column[1]+1,c2]},{row:[range2.row[0]+offset_r,r2+offset_r],column:[c1+offset_c,range2.column[1]+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],r2],column:[range2.column[1]+1,c2]}];}else if(type==="operatePart"){range=[{row:[range2.row[0]+offset_r,r2+offset_r],column:[c1+offset_c,range2.column[1]+offset_c]}];}}else if(r2>=range2.row[0]&&r2<=range2.row[1]&&c2>=range2.column[0]&&c2<=range2.column[1]){if(type==="allPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],r2],column:[c1,range2.column[0]-1]},{row:[range2.row[0]+offset_r,r2+offset_r],column:[range2.column[0]+offset_c,c2+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],r2],column:[c1,range2.column[0]-1]}];}else if(type==="operatePart"){range=[{row:[range2.row[0]+offset_r,r2+offset_r],column:[range2.column[0]+offset_c,c2+offset_c]}];}}else if(r1<range2.row[0]&&r2>range2.row[1]&&c1>=range2.column[0]&&c1<=range2.column[1]){if(type==="allPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],range2.row[1]],column:[range2.column[1]+1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]},{row:[range2.row[0]+offset_r,range2.row[1]+offset_r],column:[c1+offset_c,range2.column[1]+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],range2.row[1]],column:[range2.column[1]+1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]}];}else if(type==="operatePart"){range=[{row:[range2.row[0]+offset_r,range2.row[1]+offset_r],column:[c1+offset_c,range2.column[1]+offset_c]}];}}else if(r1<range2.row[0]&&r2>range2.row[1]&&c2>=range2.column[0]&&c2<=range2.column[1]){if(type==="allPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],range2.row[1]],column:[c1,range2.column[0]-1]},{row:[range2.row[1]+1,r2],column:[c1,c2]},{row:[range2.row[0]+offset_r,range2.row[1]+offset_r],column:[range2.column[0]+offset_c,c2+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],range2.row[1]],column:[c1,range2.column[0]-1]},{row:[range2.row[1]+1,r2],column:[c1,c2]}];}else if(type==="operatePart"){range=[{row:[range2.row[0]+offset_r,range2.row[1]+offset_r],column:[range2.column[0]+offset_c,c2+offset_c]}];}}else if(c1<range2.column[0]&&c2>range2.column[1]&&r1>=range2.row[0]&&r1<=range2.row[1]){if(type==="allPart"){range=[{row:[r1,range2.row[1]],column:[c1,range2.column[0]-1]},{row:[r1,range2.row[1]],column:[range2.column[1]+1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]},{row:[r1+offset_r,range2.row[1]+offset_r],column:[range2.column[0]+offset_c,range2.column[1]+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[1]],column:[c1,range2.column[0]-1]},{row:[r1,range2.row[1]],column:[range2.column[1]+1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]}];}else if(type==="operatePart"){range=[{row:[r1+offset_r,range2.row[1]+offset_r],column:[range2.column[0]+offset_c,range2.column[1]+offset_c]}];}}else if(c1<range2.column[0]&&c2>range2.column[1]&&r2>=range2.row[0]&&r2<=range2.row[1]){if(type==="allPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],r2],column:[c1,range2.column[0]-1]},{row:[range2.row[0],r2],column:[range2.column[1]+1,c2]},{row:[range2.row[0]+offset_r,r2+offset_r],column:[range2.column[0]+offset_c,range2.column[1]+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],r2],column:[c1,range2.column[0]-1]},{row:[range2.row[0],r2],column:[range2.column[1]+1,c2]}];}else if(type==="operatePart"){range=[{row:[range2.row[0]+offset_r,r2+offset_r],column:[range2.column[0]+offset_c,range2.column[1]+offset_c]}];}}else if(r1<range2.row[0]&&r2>range2.row[1]&&c1<range2.column[0]&&c2>range2.column[1]){if(type==="allPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],range2.row[1]],column:[c1,range2.column[0]-1]},{row:[range2.row[0],range2.row[1]],column:[range2.column[1]+1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]},{row:[range2.row[0]+offset_r,range2.row[1]+offset_r],column:[range2.column[0]+offset_c,range2.column[1]+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],range2.row[1]],column:[c1,range2.column[0]-1]},{row:[range2.row[0],range2.row[1]],column:[range2.column[1]+1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]}];}else if(type==="operatePart"){range=[{row:[range2.row[0]+offset_r,range2.row[1]+offset_r],column:[range2.column[0]+offset_c,range2.column[1]+offset_c]}];}}else{if(type==="allPart"){range=[{row:[r1,r2],column:[c1,c2]}];}else if(type==="restPart"){range=[{row:[r1,r2],column:[c1,c2]}];}else if(type==="operatePart"){range=[];}}return range;}function dataRangeSelection(ctx,cache,rangT,type,value){ctx.rangeDialog.show=true;ctx.rangeDialog.type=type;ctx.rangeDialog.rangeTxt=value;if(ctx.luckysheet_select_save&&!!rangT){var _ctx$formulaRangeSele,_ctx$formulaRangeSele2;var last=ctx.luckysheet_select_save[ctx.luckysheet_select_save.length-1];var row_index=last.row_focus;var col_index=last.column_focus;ctx.luckysheetCellUpdate=[row_index,col_index];var range=getRangeByTxt(ctx,rangT);var r=range[0].row;var c=range[0].column;var row_pre=rowLocationByIndex(r[0],ctx.visibledatarow)[0];var row=rowLocationByIndex(r[1],ctx.visibledatarow)[1];var col_pre=colLocationByIndex(c[0],ctx.visibledatacolumn)[0];var col=colLocationByIndex(c[1],ctx.visibledatacolumn)[1];ctx.formulaRangeSelect={height:row-row_pre-1,left:col_pre,rangeIndex:(_ctx$formulaRangeSele=(_ctx$formulaRangeSele2=ctx.formulaRangeSelect)===null||_ctx$formulaRangeSele2===void 0?void 0:_ctx$formulaRangeSele2.rangeIndex)!==null&&_ctx$formulaRangeSele!==void 0?_ctx$formulaRangeSele:0,top:row_pre,width:col-col_pre-1};}else{ctx.luckysheetCellUpdate=[0,0];}}function getDropdownList(ctx,txt){var list=[];if(iscelldata(txt)){var range=getcellrange(ctx,txt);var index=getSheetIndex(ctx,range.sheetId);var d=ctx.luckysheetfile[index].data;if(!d)return[];for(var r=range.row[0];r<=range.row[1];r+=1){for(var c=range.column[0];c<=range.column[1];c+=1){if(!d[r]){continue;}var cell=d[r][c];if(!cell||!cell.v){continue;}var v=cell.m||cell.v;if(!list.includes(v)){list.push(v);}}}}else{var arr=txt.split(",");for(var i=0;i<arr.length;i+=1){var _v=arr[i];if(_v.length===0){continue;}if(!list.includes(_v)){list.push(_v);}}}return list;}function validateIdCard(ctx,idCard){var regIdCard=/^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;if(regIdCard.test(idCard)){if(idCard.length===18){var idCardWi=[7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2];var idCardY=[1,0,10,9,8,7,6,5,4,3,2];var idCardWiSum=0;for(var i=0;i<17;i+=1){idCardWiSum+=Number(idCard.substring(i,i+1))*idCardWi[i];}var idCardMod=idCardWiSum%11;var idCardLast=idCard.substring(17);if(idCardMod===2){if(idCardLast==="X"||idCardLast==="x"){return true;}return false;}if(idCardLast===idCardY[idCardMod].toString()){return true;}return false;}}else{return false;}return false;}function validateCellData(ctx,item,cellValue){var value1=item.value1,value2=item.value2;var type=item.type,type2=item.type2;if(type==="dropdown"){var list=getDropdownList(ctx,value1);if(type2&&cellValue){return cellValue.toString().split(",").every(function(i){return list.indexOf(i)!==-1;});}var result=false;for(var i=0;i<list.length;i+=1){if(list[i]===cellValue){result=true;break;}}return result;}if(type==="checkbox");else if(type==="number"||type==="number_integer"||type==="number_decimal"){if(!isRealNum(cellValue)){return false;}cellValue=Number(cellValue);if(type==="number_integer"&&cellValue%1!==0){return false;}if(type==="number_decimal"&&cellValue%1===0){return false;}value1=Number(value1);value2=Number(value2);if(type2==="between"&&(cellValue<value1||cellValue>value2)){return false;}if(type2==="notBetween"&&cellValue>=value1&&cellValue<=value2){return false;}if(type2==="equal"&&cellValue!==value1){return false;}if(type2==="notEqualTo"&&cellValue===value1){return false;}if(type2==="moreThanThe"&&cellValue<=value1){return false;}if(type2==="lessThan"&&cellValue>=value1){return false;}if(type2==="greaterOrEqualTo"&&cellValue<value1){return false;}if(type2==="lessThanOrEqualTo"&&cellValue>value1){return false;}}else if(type==="text_content"){cellValue=cellValue.toString();value1=value1.toString();if(type2==="include"&&cellValue.indexOf(value1)===-1){return false;}if(type2==="exclude"&&cellValue.indexOf(value1)>-1){return false;}if(type2==="equal"&&cellValue!==value1){return false;}}else if(type==="text_length"){cellValue=cellValue.toString().length;value1=Number(value1);value2=Number(value2);if(type2==="between"&&(cellValue<value1||cellValue>value2)){return false;}if(type2==="notBetween"&&cellValue>=value1&&cellValue<=value2){return false;}if(type2==="equal"&&cellValue!==value1){return false;}if(type2==="notEqualTo"&&cellValue===value1){return false;}if(type2==="moreThanThe"&&cellValue<=value1){return false;}if(type2==="lessThan"&&cellValue>=value1){return false;}if(type2==="greaterOrEqualTo"&&cellValue<value1){return false;}if(type2==="lessThanOrEqualTo"&&cellValue>value1){return false;}}else if(type==="date"){if(!isdatetime(cellValue)){return false;}if(type2==="between"&&(diff(cellValue,value1)<0||diff(cellValue,value2)>0)){return false;}if(type2==="notBetween"&&diff(cellValue,value1)>=0&&diff(cellValue,value2)<=0){return false;}if(type2==="equal"&&diff(cellValue,value1)!==0){return false;}if(type2==="notEqualTo"&&diff(cellValue,value1)===0){return false;}if(type2==="earlierThan"&&diff(cellValue,value1)>=0){return false;}if(type2==="noEarlierThan"&&diff(cellValue,value1)<0){return false;}if(type2==="laterThan"&&diff(cellValue,value1)<=0){return false;}if(type2==="noLaterThan"&&diff(cellValue,value1)>0){return false;}}else if(type==="validity"){if(type2==="identificationNumber"&&!validateIdCard(ctx,cellValue)){return false;}if(type2==="phoneNumber"&&!/^1[3456789]\d{9}$/.test(cellValue)){return false;}}return true;}function checkboxChange(ctx,r,c){var _ctx$luckysheetfile$i;var index=getSheetIndex(ctx,ctx.currentSheetId);var currentDataVerification=(_ctx$luckysheetfile$i=ctx.luckysheetfile[index].dataVerification)!==null&&_ctx$luckysheetfile$i!==void 0?_ctx$luckysheetfile$i:{};var item=currentDataVerification["".concat(r,"_").concat(c)];item.checked=!item.checked;var value=item.value2;if(item.checked){value=item.value1;}var d=getFlowdata(ctx);setCellValue(ctx,r,c,d,value);}function getFailureText(ctx,item){var failureText="";var lang=ctx.lang;var type=item.type,type2=item.type2,value1=item.value1,value2=item.value2;if(lang==="zh"||lang==="zh-CN"){var _ctx$dataVerification;var optionLabel_zh=(_ctx$dataVerification=ctx.dataVerification)===null||_ctx$dataVerification===void 0?void 0:_ctx$dataVerification.optionLabel_zh;if(type==="dropdown"){failureText+="你选择的不是下拉列表中的选项";}else if(type==="checkbox");else if(type==="number"||type==="number_integer"||type==="number_decimal"){failureText+="\u4F60\u8F93\u5165\u7684\u4E0D\u662F".concat(optionLabel_zh[type2]).concat(value1);if(type2==="between"||type2==="notBetween"){failureText+="\u548C".concat(value2,"\u4E4B\u95F4");}failureText+="\u7684".concat(optionLabel_zh[type]);}else if(type==="text_content"){failureText+="\u4F60\u8F93\u5165\u7684\u4E0D\u662F\u5185\u5BB9".concat(optionLabel_zh[type2]).concat(value1,"\u7684\u6587\u672C");}else if(type==="text_length"){failureText+="\u4F60\u8F93\u5165\u7684\u4E0D\u662F\u957F\u5EA6".concat(optionLabel_zh[type2]).concat(value1);if(type2==="between"||type2==="notBetween"){failureText+="\u548C".concat(value2,"\u4E4B\u95F4");}failureText+="的文本";}else if(type==="date"){failureText+="\u4F60\u8F93\u5165\u7684\u4E0D\u662F".concat(optionLabel_zh[type2]).concat(value1);if(type2==="between"||type2==="notBetween"){failureText+="\u548C".concat(value2,"\u4E4B\u95F4");}failureText+="的日期";}else if(type==="validity"){failureText+="\u4F60\u8F93\u5165\u7684\u4E0D\u662F\u4E00\u4E2A\u6B63\u786E\u7684".concat(optionLabel_zh[type2]);}}else if(lang==="zh-TW"){var _ctx$dataVerification2;var optionLabel_zh_tw=(_ctx$dataVerification2=ctx.dataVerification)===null||_ctx$dataVerification2===void 0?void 0:_ctx$dataVerification2.optionLabel_zh_tw;if(type==="dropdown"){failureText+="你選擇的不是下拉清單中的選項";}else if(type==="checkbox");else if(type==="number"||type==="number_integer"||type==="number_decimal"){failureText+="\u4F60\u8F38\u5165\u7684\u4E0D\u662F".concat(optionLabel_zh_tw[type2]).concat(value1);if(type2==="between"||type2==="notBetween"){failureText+="\u548C".concat(value2,"\u4E4B\u9593");}failureText+="\u7684".concat(optionLabel_zh_tw[type]);}else if(type==="text_content"){failureText+="\u4F60\u8F38\u5165\u7684\u4E0D\u662F\u5167\u5BB9".concat(optionLabel_zh_tw[type2]).concat(value1,"\u7684\u6587\u672C");}else if(type==="text_length"){failureText+="\u4F60\u8F38\u5165\u7684\u4E0D\u662F\u9577\u5EA6".concat(optionLabel_zh_tw[type2]).concat(value1);if(type2==="between"||type2==="notBetween"){failureText+="\u548C".concat(value2,"\u4E4B\u95F4");}failureText+="的文本";}else if(type==="date"){failureText+="\u4F60\u8F38\u5165\u7684\u4E0D\u662F".concat(optionLabel_zh_tw[type2]).concat(value1);if(type2==="between"||type2==="notBetween"){failureText+="\u548C".concat(value2,"\u4E4B\u95F4");}failureText+="的日期";}else if(type==="validity"){failureText+="\u4F60\u8F38\u5165\u7684\u4E0D\u662F\u4E00\u500B\u6B63\u78BA\u7684".concat(optionLabel_zh_tw[type2]);}}else if(lang==="es"){var _ctx$dataVerification3;var optionLabel_es=(_ctx$dataVerification3=ctx.dataVerification)===null||_ctx$dataVerification3===void 0?void 0:_ctx$dataVerification3.optionLabel_es;if(type==="dropdown"){failureText+="No elegiste una opción en la lista desplegable";}else if(type==="checkbox");else if(type==="number"||type==="number_integer"||type==="number_decimal"){failureText+="Lo que introduciste no es".concat(optionLabel_es[type2]).concat(value1);if(type2==="between"||type2==="notBetween"){failureText+="Y".concat(value2,"Entre");}failureText+="De".concat(optionLabel_es[type]);}else if(type==="text_content"){failureText+="Lo que introduciste no fue contenido".concat(optionLabel_es[type2]).concat(value1,"Texto");}else if(type==="text_length"){failureText+="No introduciste la longitud".concat(optionLabel_es[type2]).concat(value1);if(type2==="between"||type2==="notBetween"){failureText+="Y".concat(value2,"Entre");}failureText+="Texto";}else if(type==="date"){failureText+="Lo que introduciste no es".concat(optionLabel_es[type2]).concat(value1);if(type2==="between"||type2==="notBetween"){failureText+="Y".concat(value2,"Entre");}failureText+="Fecha";}else if(type==="validity"){failureText+="Lo que ingresas no es correcto".concat(optionLabel_es[type2]);}}else if(lang==="hi"){var _ctx$dataVerification4;var optionLabel_hi=(_ctx$dataVerification4=ctx.dataVerification)===null||_ctx$dataVerification4===void 0?void 0:_ctx$dataVerification4.optionLabel_hi;if(type==="dropdown"){failureText+="आपने जो चयन किया है वह ड्रॉप-डाउन सूची में एक विकल्प नहीं है";}else if(type==="checkbox");else if(type==="number"||type==="number_integer"||type==="number_decimal"){failureText+="\u0906\u092A\u0928\u0947 \u091C\u094B \u0926\u0930\u094D\u091C \u0915\u093F\u092F\u093E \u0939\u0948 \u0935\u0939 ".concat(optionLabel_hi[item.type]," ").concat(optionLabel_hi[item.type2]," ").concat(item.value1," \u0928\u0939\u0940\u0902 \u0939\u0948");if(item.type2==="between"||item.type2==="notBetween"){failureText+=" and ".concat(item.value2);}}else if(type==="text_content"){failureText+="\u0906\u092A\u0928\u0947 \u091C\u094B \u0926\u0930\u094D\u091C \u0915\u093F\u092F\u093E \u0939\u0948 \u0935\u0939 \u092A\u093E\u0920 \u0928\u0939\u0940\u0902 \u0939\u0948 \u091C\u094B ".concat(optionLabel_hi[item.type2]," ").concat(item.value1," \u0939\u0948");}else if(type==="text_length"){failureText+="\u0906\u092A\u0915\u0947 \u0926\u094D\u0935\u093E\u0930\u093E \u0926\u0930\u094D\u091C \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u092A\u093E\u0920 \u0915\u0940 \u0932\u0902\u092C\u093E\u0908 ".concat(optionLabel_hi[item.type2]," ").concat(item.value1," \u0928\u0939\u0940\u0902 \u0939\u0948");if(item.type2==="between"||item.type2==="notBetween"){failureText+=" \u0914\u0930 ".concat(item.value2);}}else if(type==="date"){failureText+="\u0906\u092A\u0915\u0947 \u0926\u094D\u0935\u093E\u0930\u093E \u0926\u0930\u094D\u091C \u0915\u0940 \u0917\u0908 \u0924\u093F\u0925\u093F ".concat(optionLabel_hi[item.type2]," ").concat(item.value1," \u0928\u0939\u0940\u0902 \u0939\u0948\u0964");if(type2==="between"||type2==="notBetween"){failureText+=" \u0914\u0930 ".concat(item.value2);}}else if(type==="validity"){failureText+="\u0906\u092A\u0928\u0947 \u091C\u094B \u0926\u0930\u094D\u091C \u0915\u093F\u092F\u093E \u0939\u0948 \u0935\u0939 \u0938\u0939\u0940 ".concat(optionLabel_hi[item.type2]," \u0928\u0939\u0940\u0902 \u0939\u0948\u0964");}}else{var _ctx$dataVerification5;var optionLabel_en=(_ctx$dataVerification5=ctx.dataVerification)===null||_ctx$dataVerification5===void 0?void 0:_ctx$dataVerification5.optionLabel_en;if(type==="dropdown"){failureText+="what you selected is not an option in the drop-down list";}else if(type==="checkbox");else if(type==="number"||type==="number_integer"||type==="number_decimal"){failureText+="what you entered is not a ".concat(optionLabel_en[item.type]," ").concat(optionLabel_en[item.type2]," ").concat(item.value1);if(item.type2==="between"||item.type2==="notBetween"){failureText+=" and ".concat(item.value2);}}else if(type==="text_content"){failureText+="what you entered is not text that ".concat(optionLabel_en[item.type2]," ").concat(item.value1);}else if(type==="text_length"){failureText+="the text you entered is not length ".concat(optionLabel_en[item.type2]," ").concat(item.value1);if(item.type2==="between"||item.type2==="notBetween"){failureText+=" and ".concat(item.value2);}}else if(type==="date"){failureText+="the date you entered is not ".concat(optionLabel_en[item.type2]," ").concat(item.value1);if(type2==="between"||type2==="notBetween"){failureText+=" and ".concat(item.value2);}}else if(type==="validity"){failureText+="what you entered is not a correct ".concat(optionLabel_en[item.type2]);}}return failureText;}function getHintText(ctx,item){var hintValue=item.hintValue||"";var type=item.type,type2=item.type2,value1=item.value1,value2=item.value2;var lang=ctx.lang;if(!hintValue){if(lang==="en"){var _ctx$dataVerification6;var optionLabel_en=(_ctx$dataVerification6=ctx.dataVerification)===null||_ctx$dataVerification6===void 0?void 0:_ctx$dataVerification6.optionLabel_en;if(type==="dropdown"){hintValue+="please select an option in the drop-down list";}else if(type==="checkbox");else if(type==="number"||type==="number_integer"||type==="number_decimal"){hintValue+="please enter a ".concat(optionLabel_en[type]," ").concat(optionLabel_en[type2]," ").concat(item.value1);if(type2==="between"||type2==="notBetween"){hintValue+=" and ".concat(value2);}}else if(type==="text_content"){hintValue+="please enter text ".concat(optionLabel_en[type2]," ").concat(value1);}else if(type==="date"){hintValue+="please enter a date ".concat(optionLabel_en[type2]," ").concat(value1);if(type2==="between"||type2==="notBetween"){hintValue+=" and ".concat(value2);}}else if(type==="validity"){hintValue+="please enter the correct ".concat(optionLabel_en[type2]);}}else if(lang==="zh"||lang==="zh-CN"){var _ctx$dataVerification7;var optionLabel_zh=(_ctx$dataVerification7=ctx.dataVerification)===null||_ctx$dataVerification7===void 0?void 0:_ctx$dataVerification7.optionLabel_zh;if(type==="dropdown"){hintValue+="请选择下拉列表中的选项";}else if(type==="checkbox");else if(type==="number"||type==="number_integer"||type==="number_decimal"){hintValue+="\u8BF7\u8F93\u5165".concat(optionLabel_zh[type2]).concat(value1);if(type2==="between"||type2==="notBetween"){hintValue+="\u548C".concat(value2,"\u4E4B\u95F4");}hintValue+="\u7684".concat(optionLabel_zh[type]);}else if(type==="text_content"){hintValue+="\u8BF7\u8F93\u5165\u5185\u5BB9".concat(optionLabel_zh[type2]).concat(value1,"\u7684\u6587\u672C");}else if(type==="text_length"){hintValue+="\u8BF7\u8F93\u5165\u957F\u5EA6".concat(optionLabel_zh[type2]).concat(value1);if(type2==="between"||type2==="notBetween"){hintValue+="\u548C".concat(value2,"\u4E4B\u95F4");}hintValue+="的文本";}else if(type==="date"){hintValue+="\u8BF7\u8F93\u5165".concat(optionLabel_zh[type2]).concat(value1);if(type2==="between"||type2==="notBetween"){hintValue+="\u548C".concat(value2,"\u4E4B\u95F4");}hintValue+="的日期";}else if(type==="validity"){hintValue+="\u8BF7\u8F93\u5165\u6B63\u786E\u7684".concat(optionLabel_zh[type2]);}}else if(lang==="zh-TW"){var _ctx$dataVerification8;var optionLabel_zh_tw=(_ctx$dataVerification8=ctx.dataVerification)===null||_ctx$dataVerification8===void 0?void 0:_ctx$dataVerification8.optionLabel_zh_tw;if(type==="dropdown"){hintValue+="請選擇下拉清單中的選項";}else if(type==="checkbox");else if(type==="number"||type==="number_integer"||type==="number_decimal"){hintValue+="\u8ACB\u8F38\u5165".concat(optionLabel_zh_tw[type2]).concat(value1);if(type2==="between"||type2==="notBetween"){hintValue+="\u548C".concat(value2,"\u4E4B\u9593");}hintValue+="\u7684".concat(optionLabel_zh_tw[type]);}else if(type==="text_content"){hintValue+="\u8ACB\u8F38\u5165\u5167\u5BB9".concat(optionLabel_zh_tw[type2]).concat(value1,"\u7684\u6587\u672C");}else if(type==="text_length"){hintValue+="\u8ACB\u8F38\u5165\u9577\u5EA6".concat(optionLabel_zh_tw[type2]).concat(value1);if(type2==="between"||type2==="notBetween"){hintValue+="\u548C".concat(value2,"\u4E4B\u9593");}hintValue+="的文本";}else if(type==="date"){hintValue+="\u8ACB\u8F38\u5165".concat(optionLabel_zh_tw[type2]).concat(value1);if(type2==="between"||type2==="notBetween"){hintValue+="\u548C".concat(value2,"\u4E4B\u9593");}hintValue+="的日期";}else if(type==="validity"){hintValue+="\u8ACB\u8F38\u5165\u6B63\u78BA\u7684".concat(optionLabel_zh_tw[type2]);}}else if(lang==="es"){var _ctx$dataVerification9;var optionLabel_es=(_ctx$dataVerification9=ctx.dataVerification)===null||_ctx$dataVerification9===void 0?void 0:_ctx$dataVerification9.optionLabel_es;if(type==="dropdown"){hintValue+="Por favor, elija una opción en la lista desplegable";}else if(type==="checkbox");else if(type==="number"||type==="number_integer"||type==="number_decimal"){hintValue+="Por favor, introduzca".concat(optionLabel_es[type2]).concat(value1);if(type2==="between"||type2==="notBetween"){hintValue+="Y".concat(value2,"Entre");}hintValue+="De".concat(optionLabel_es[type]);}else if(type==="text_content"){hintValue+="Por favor, introduzca el contenido".concat(optionLabel_es[type2]).concat(value1,"Texto");}else if(type==="text_length"){hintValue+="Por favor, introduzca la longitud".concat(optionLabel_es[type2]).concat(value1);if(type2==="between"||type2==="notBetween"){hintValue+="Y".concat(value2,"Entre");}hintValue+="Texto";}else if(type==="date"){hintValue+="Por favor, introduzca".concat(optionLabel_es[type2]).concat(value1);if(type2==="between"||type2==="notBetween"){hintValue+="Y".concat(value2,"Entre");}hintValue+="Fecha";}else if(type==="validity"){hintValue+="Por favor, introduzca lo correcto.".concat(optionLabel_es[type2]);}}}return hintValue;}function cellFocus(ctx,r,c,clickMode){var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;var showHintBox=document.getElementById("luckysheet-dataVerification-showHintBox");var dropDownBtn=document.getElementById("luckysheet-dataVerification-dropdown-btn");ctx.dataVerificationDropDownList=false;if(!showHintBox||!dropDownBtn)return;showHintBox.style.display="none";dropDownBtn.style.display="none";var index=getSheetIndex(ctx,ctx.currentSheetId);var dataVerification=ctx.luckysheetfile[index].dataVerification;ctx.dataVerificationDropDownList=false;if(!dataVerification)return;var row=ctx.visibledatarow[r];var row_pre=r===0?0:ctx.visibledatarow[r-1];var col=ctx.visibledatacolumn[c];var col_pre=c===0?0:ctx.visibledatacolumn[c-1];var d=getFlowdata(ctx);if(!d)return;var margeSet=mergeBorder(ctx,d,r,c);if(margeSet){var _margeSet$row=index_esm_slicedToArray(margeSet.row,2);row_pre=_margeSet$row[0];row=_margeSet$row[1];var _margeSet$column=index_esm_slicedToArray(margeSet.column,2);col_pre=_margeSet$column[0];col=_margeSet$column[1];}var item=dataVerification["".concat(r,"_").concat(c)];if(!item)return;if(clickMode&&item.type==="checkbox"){checkboxChange(ctx,r,c);}if(item.type==="dropdown"){dropDownBtn.style.display="block";dropDownBtn.style.maxWidth="".concat(col-col_pre,"px");dropDownBtn.style.maxHeight="".concat(row-row_pre,"px");dropDownBtn.style.left="".concat(col-20,"px");dropDownBtn.style.top="".concat(row_pre+(row-row_pre-20)/2-2,"px");}if(item.hintShow){var hintText="";var lang=ctx.lang;if(lang==="en"){hintText='<span style="color:#f5a623;">Hint: </span>';}else if(lang==="zh"||lang==="zh-CN"){hintText='<span style="color:#f5a623;">提示：</span>';}else if(lang==="zh-TW"){hintText='<span style="color:#f5a623;">提示：</span>';}else if(lang==="es"){hintText='<span style="color:#f5a623;">Consejos：</span>';}else if(lang==="hi"){hintText='<span style="color:#f5a623;">सुझाव: </span>';}hintText+=getHintText(ctx,item);showHintBox.innerHTML=hintText;showHintBox.style.display="block";showHintBox.style.left="".concat(col_pre,"px");showHintBox.style.top="".concat(row,"px");}var cellValue=getCellValue(r,c,d);if(isRealNull(cellValue)){return;}var validate=validateCellData(ctx,item,cellValue);if(!validate){var failureText="";var _lang=ctx.lang;if(_lang==="en"){failureText='<span style="color:#f72626;">Failure: </span>';}else if(_lang==="zh"||_lang==="zh-CN"){failureText='<span style="color:#f72626;">失效：</span>';}else if(_lang==="zh-TW"){failureText='<span style="color:#f72626;">失效：</span>';}else if(_lang==="es"){failureText='<span style="color:#f72626;">Caducidad: </span>';}else if(_lang==="hi"){failureText='<span style="color:#f72626;">असफलता: </span>';}failureText+=getFailureText(ctx,item);showHintBox.innerHTML=failureText;showHintBox.style.display="block";showHintBox.style.left="".concat(col_pre,"px");showHintBox.style.top="".concat(row,"px");}}function setDropcownValue(ctx,value,arr){if(!ctx.luckysheet_select_save)return;var d=getFlowdata(ctx);if(!d)return;var last=ctx.luckysheet_select_save[ctx.luckysheet_select_save.length-1];var rowIndex=last.row_focus;var colIndex=last.column_focus;if(rowIndex==null||colIndex==null)return;var index=getSheetIndex(ctx,ctx.currentSheetId);var item=ctx.luckysheetfile[index].dataVerification["".concat(rowIndex,"_").concat(colIndex)];if(item.type2==="true"){value=item.value1.split(",").filter(function(v){return arr.indexOf(v)>=0;}).join(",");}else{ctx.dataVerificationDropDownList=false;}setCellValue(ctx,rowIndex,colIndex,d,value);jfrefreshgrid(ctx,null,undefined);}function confirmMessage(ctx,generalDialog,dataVerification){var _ctx$dataVerification10,_ctx$dataVerification11;var range=getRangeByTxt(ctx,(_ctx$dataVerification10=ctx.dataVerification)===null||_ctx$dataVerification10===void 0?void 0:(_ctx$dataVerification11=_ctx$dataVerification10.dataRegulation)===null||_ctx$dataVerification11===void 0?void 0:_ctx$dataVerification11.rangeTxt);if(range.length===0){ctx.warnDialog=generalDialog.noSeletionError;return false;}var str=range[range.length-1].row[0];var edr=range[range.length-1].row[1];var stc=range[range.length-1].column[0];var edc=range[range.length-1].column[1];var d=getFlowdata(ctx);if(!d)return false;if(str<0){str=0;}if(edr>d.length-1){edr=d.length-1;}if(stc<0){stc=0;}if(edc>d[0].length-1){edc=d[0].length-1;}var regulation=ctx.dataVerification.dataRegulation;var verifacationT=regulation===null||regulation===void 0?void 0:regulation.type;var value1=regulation.value1,value2=regulation.value2,type2=regulation.type2;var v1=parseFloat(value1).toString()!=="NaN";var v2=parseFloat(value2).toString()!=="NaN";if(verifacationT==="dropdown"){if(!value1){ctx.warnDialog=dataVerification.tooltipInfo1;}}else if(verifacationT==="checkbox"){if(!value1||!value2){ctx.warnDialog=dataVerification.tooltipInfo2;}}else if(verifacationT==="number"||verifacationT==="number_integer"||verifacationT==="number_decimal"){if(!v1){ctx.warnDialog=dataVerification.tooltipInfo3;return false;}if(type2==="between"||type2==="notBetween"){if(!v2){ctx.warnDialog=dataVerification.tooltipInfo3;return false;}if(Number(value2)<Number(value1)){ctx.warnDialog=dataVerification.tooltipInfo4;return false;}}}else if(verifacationT==="text_content"){if(!value1){ctx.warnDialog=dataVerification.tooltipInfo5;return false;}}else if(verifacationT==="text_length"){if(!v1){ctx.warnDialog=dataVerification.tooltipInfo3;return false;}if(!Number.isInteger(Number(value1))||Number(value1)<0){ctx.warnDialog=dataVerification.textlengthInteger;return false;}if(type2==="between"||type2==="notBetween"){if(!v2){ctx.warnDialog=dataVerification.tooltipInfo3;return false;}if(!Number.isInteger(Number(value2))||Number(value2)<0){ctx.warnDialog=dataVerification.textlengthInteger;return false;}if(Number(value2)<Number(value1)){ctx.warnDialog=dataVerification.tooltipInfo4;return false;}}}else if(verifacationT==="date"){if(!isdatetime(value1)){ctx.warnDialog=dataVerification.tooltipInfo6;return false;}if(type2==="between"||type2==="notBetween"){if(!isdatetime(value2)){ctx.warnDialog=dataVerification.tooltipInfo6;return false;}if(diff(value1,value2)>0){ctx.warnDialog=dataVerification.tooltipInfo7;return false;}}}return true;}function normalizedCellAttr(cell,attr){var defaultFontSize=arguments.length>2&&arguments[2]!==undefined?arguments[2]:10;var tf={bl:1,it:1,ff:1,cl:1,un:1};var value=cell===null||cell===void 0?void 0:cell[attr];if(attr in tf||attr==="fs"&&isInlineStringCell(cell)){value||(value="0");}else if(["fc","bg","bc"].includes(attr)){var _value;if(["fc","bc"].includes(attr)){value||(value="#000000");}if(((_value=value)===null||_value===void 0?void 0:_value.indexOf("rgba"))>-1){value=rgbToHex(value);}}else if(attr.substring(0,2)==="bs"){value||(value="none");}else if(attr==="ht"||attr==="vt"){var defaultValue=attr==="ht"?"1":"0";value=!lodash_default().isNil(value)?value.toString():defaultValue;if(["0","1","2"].indexOf(value.toString())===-1){value=defaultValue;}}else if(attr==="fs"){value||(value=defaultFontSize.toString());}else if(attr==="tb"||attr==="tr"){value||(value="0");}return value;}function normalizedAttr(data,r,c,attr){if(!data||!data[r]){console.warn("cell (%d, %d) is null",r,c);return null;}var cell=data[r][c];if(!cell)return undefined;return normalizedCellAttr(cell,attr);}function getCellValue(r,c,data,attr){if(!attr){attr="v";}var d_value;if(!lodash_default().isNil(r)&&!lodash_default().isNil(c)){d_value=data[r][c];}else if(!lodash_default().isNil(r)){d_value=data[r];}else if(!lodash_default().isNil(c)){var newData=data[0].map(function(col,i){return data.map(function(row){return row[i];});});d_value=newData[c];}else{return data;}var retv=d_value;if(lodash_default().isPlainObject(d_value)){var d=d_value;retv=d[attr];if(attr==="f"&&!lodash_default().isNil(retv)){retv=functionHTMLGenerate(retv);}else if(attr==="f"){retv=d.v;}else if(d&&d.ct&&d.ct.t==="d"){retv=d.m;}}if(retv===undefined){retv=null;}return retv;}function setCellValue(ctx,r,c,d,v){var _cell$ct,_cell$ct2,_cell$ct3,_cell$ct4,_cell$ct5,_cell$ct6;if(lodash_default().isNil(d)){d=getFlowdata(ctx);}if(!d)return;var cell=d[r][c];var vupdate;if(lodash_default().isPlainObject(v)){if(lodash_default().isNil(cell)){cell=v;}else{if(!lodash_default().isNil(v.f)){cell.f=v.f;}else if("f"in cell){delete cell.f;}if(!lodash_default().isNil(v.ct)){cell.ct=v.ct;}}if(lodash_default().isPlainObject(v.v)){vupdate=v.v.v;}else{vupdate=v.v;}}else{vupdate=v;}if(isRealNull(vupdate)){if(lodash_default().isPlainObject(cell)){delete cell.m;delete cell.v;}else{cell=null;}d[r][c]=cell;return;}if(isRealNull(cell)||(lodash_default().isString(cell)||lodash_default().isNumber(cell))&&cell===v){cell={};}if(!cell)return;var vupdateStr=vupdate.toString();if(vupdateStr.substr(0,1)==="'"){cell.m=vupdateStr.substr(1);cell.ct={fa:"@",t:"s"};cell.v=vupdateStr.substr(1);cell.qp=1;}else if(cell.qp===1){cell.m=vupdateStr;cell.ct={fa:"@",t:"s"};cell.v=vupdateStr;}else if(vupdateStr.toUpperCase()==="TRUE"&&(lodash_default().isNil((_cell$ct=cell.ct)===null||_cell$ct===void 0?void 0:_cell$ct.fa)||((_cell$ct2=cell.ct)===null||_cell$ct2===void 0?void 0:_cell$ct2.fa)!=="@")){cell.m="TRUE";cell.ct={fa:"General",t:"b"};cell.v=true;}else if(vupdateStr.toUpperCase()==="FALSE"&&(lodash_default().isNil((_cell$ct3=cell.ct)===null||_cell$ct3===void 0?void 0:_cell$ct3.fa)||((_cell$ct4=cell.ct)===null||_cell$ct4===void 0?void 0:_cell$ct4.fa)!=="@")){cell.m="FALSE";cell.ct={fa:"General",t:"b"};cell.v=false;}else if(vupdateStr.substr(-1)==="%"&&isRealNum(vupdateStr.substring(0,vupdateStr.length-1))&&(lodash_default().isNil((_cell$ct5=cell.ct)===null||_cell$ct5===void 0?void 0:_cell$ct5.fa)||((_cell$ct6=cell.ct)===null||_cell$ct6===void 0?void 0:_cell$ct6.fa)!=="@")){cell.ct={fa:"0%",t:"n"};cell.v=vupdateStr.substring(0,vupdateStr.length-1)/100;cell.m=vupdate;}else if(valueIsError(vupdate)){cell.m=vupdateStr;if(!lodash_default().isNil(cell.ct)){cell.ct.t="e";}else{cell.ct={fa:"General",t:"e"};}cell.v=vupdate;}else{if(!lodash_default().isNil(cell.f)&&isRealNum(vupdate)&&!/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(vupdate)){cell.v=parseFloat(vupdate);if(lodash_default().isNil(cell.ct)){cell.ct={fa:"General",t:"n"};}if(cell.v===Infinity||cell.v===-Infinity){cell.m=cell.v.toString();}else{if(cell.v.toString().indexOf("e")>-1){var len;if(cell.v.toString().split(".").length===1){len=0;}else{len=cell.v.toString().split(".")[1].split("e")[0].length;}if(len>5){len=5;}cell.m=cell.v.toExponential(len).toString();}else{var v_p=Math.round(cell.v*1000000000)/1000000000;if(lodash_default().isNil(cell.ct)){var mask=genarate(v_p);if(mask!=null){cell.m=mask[0].toString();}}else{var _mask=update(cell.ct.fa,v_p);cell.m=_mask.toString();}}}}else if(!lodash_default().isNil(cell.ct)&&cell.ct.fa==="@"){cell.m=vupdateStr;cell.v=vupdate;}else if(cell.ct!=null&&cell.ct.t==="d"&&lodash_default().isString(vupdate)){var _mask2=genarate(vupdate);if(_mask2[1].t!=="d"||_mask2[1].fa===cell.ct.fa){var _mask3=index_esm_slicedToArray(_mask2,3);cell.m=_mask3[0];cell.ct=_mask3[1];cell.v=_mask3[2];}else{var _mask4=index_esm_slicedToArray(_mask2,3);cell.v=_mask4[2];cell.m=update(cell.ct.fa,cell.v);}}else if(!lodash_default().isNil(cell.ct)&&!lodash_default().isNil(cell.ct.fa)&&cell.ct.fa!=="General"){if(isRealNum(vupdate)){vupdate=parseFloat(vupdate);}var _mask5=update(cell.ct.fa,vupdate);if(_mask5===vupdate){_mask5=genarate(vupdate);cell.m=_mask5[0].toString();var _mask6=_mask5;var _mask7=index_esm_slicedToArray(_mask6,3);cell.ct=_mask7[1];cell.v=_mask7[2];}else{cell.m=_mask5.toString();cell.v=vupdate;}}else{if(isRealNum(vupdate)&&!/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(vupdate)){if(typeof vupdate==="string"){var flag=vupdate.split("").every(function(ele){return ele==="0"||ele===".";});if(flag){vupdate=parseFloat(vupdate);}}cell.v=vupdate;cell.ct={fa:"General",t:"n"};if(cell.v===Infinity||cell.v===-Infinity){cell.m=cell.v.toString();}else if(cell.v!=null){var _mask8=genarate(cell.v);if(_mask8){cell.m=_mask8[0].toString();}}}else{var _mask9=genarate(vupdate);if(_mask9){cell.m=_mask9[0].toString();var _mask10=index_esm_slicedToArray(_mask9,3);cell.ct=_mask10[1];cell.v=_mask10[2];}}}}d[r][c]=cell;}function getRealCellValue(r,c,data,attr){var value=getCellValue(r,c,data,"m");if(lodash_default().isNil(value)){value=getCellValue(r,c,data,attr);if(lodash_default().isNil(value)){var ct=getCellValue(r,c,data,"ct");if(isInlineStringCT(ct)){value=ct.s;}}}return value;}function mergeBorder(ctx,d,row_index,col_index){if(!d||!d[row_index]){console.warn("Merge info is null",row_index,col_index);return null;}var value=d[row_index][col_index];if(!value)return null;if(value===null||value===void 0?void 0:value.mc){var _d$row_index,_d$row_index2,_d$row_index2$col_ind,_d$row_index2$col_ind2,_d$row_index3,_d$row_index3$col_ind,_d$row_index3$col_ind2,_d$row_index4,_d$row_index4$col_ind;var margeMaindata=value.mc;if(!margeMaindata){console.warn("Merge info is null",row_index,col_index);return null;}col_index=margeMaindata.c;row_index=margeMaindata.r;if(lodash_default().isNil(d===null||d===void 0?void 0:(_d$row_index=d[row_index])===null||_d$row_index===void 0?void 0:_d$row_index[col_index])){console.warn("Main merge Cell info is null",row_index,col_index);return null;}var col_rs=(_d$row_index2=d[row_index])===null||_d$row_index2===void 0?void 0:(_d$row_index2$col_ind=_d$row_index2[col_index])===null||_d$row_index2$col_ind===void 0?void 0:(_d$row_index2$col_ind2=_d$row_index2$col_ind.mc)===null||_d$row_index2$col_ind2===void 0?void 0:_d$row_index2$col_ind2.cs;var row_rs=(_d$row_index3=d[row_index])===null||_d$row_index3===void 0?void 0:(_d$row_index3$col_ind=_d$row_index3[col_index])===null||_d$row_index3$col_ind===void 0?void 0:(_d$row_index3$col_ind2=_d$row_index3$col_ind.mc)===null||_d$row_index3$col_ind2===void 0?void 0:_d$row_index3$col_ind2.rs;var mergeMain=(_d$row_index4=d[row_index])===null||_d$row_index4===void 0?void 0:(_d$row_index4$col_ind=_d$row_index4[col_index])===null||_d$row_index4$col_ind===void 0?void 0:_d$row_index4$col_ind.mc;if(!mergeMain||lodash_default().isNil(mergeMain===null||mergeMain===void 0?void 0:mergeMain.rs)||lodash_default().isNil(mergeMain===null||mergeMain===void 0?void 0:mergeMain.cs)||lodash_default().isNil(col_rs)||lodash_default().isNil(row_rs)){console.warn("Main merge info is null",mergeMain);return null;}var start_r;var end_r;var row;var row_pre;for(var r=row_index;r<mergeMain.rs+row_index;r+=1){if(r===0){start_r=-1;}else{start_r=ctx.visibledatarow[r-1]-1;}end_r=ctx.visibledatarow[r];if(row_pre===undefined){row_pre=start_r;row=end_r;}else if(row!==undefined){row+=end_r-start_r-1;}}var start_c;var end_c;var col;var col_pre;for(var c=col_index;c<mergeMain.cs+col_index;c+=1){if(c===0){start_c=0;}else{start_c=ctx.visibledatacolumn[c-1];}end_c=ctx.visibledatacolumn[c];if(col_pre===undefined){col_pre=start_c;col=end_c;}else if(col!==undefined){col+=end_c-start_c;}}if(lodash_default().isNil(row_pre)||lodash_default().isNil(col_pre)||lodash_default().isNil(row)||lodash_default().isNil(col)){console.warn("Main merge info row_pre or col_pre or row or col is null",mergeMain);return null;}return{row:[row_pre,row,row_index,row_index+row_rs-1],column:[col_pre,col,col_index,col_index+col_rs-1]};}return null;}function mergeMove(ctx,mc,columnseleted,rowseleted,s,top,height,left,width){var row_st=mc.r;var row_ed=mc.r+mc.rs-1;var col_st=mc.c;var col_ed=mc.c+mc.cs-1;var ismatch=false;columnseleted[0]=Math.min(columnseleted[0],columnseleted[1]);rowseleted[0]=Math.min(rowseleted[0],rowseleted[1]);if(columnseleted[0]<=col_st&&columnseleted[1]>=col_ed&&rowseleted[0]<=row_st&&rowseleted[1]>=row_ed||!(columnseleted[1]<col_st||columnseleted[0]>col_ed)&&!(rowseleted[1]<row_st||rowseleted[0]>row_ed)){var flowdata=getFlowdata(ctx);if(!flowdata)return null;var margeset=mergeBorder(ctx,flowdata,mc.r,mc.c);if(margeset){var row=margeset.row[1];var row_pre=margeset.row[0];var col=margeset.column[1];var col_pre=margeset.column[0];if(!(columnseleted[1]<col_st||columnseleted[0]>col_ed)){if(rowseleted[0]<=row_ed&&rowseleted[0]>=row_st){height+=top-row_pre;top=row_pre;rowseleted[0]=row_st;}if(rowseleted[1]>=row_st&&rowseleted[1]<=row_ed){if(s.row_focus>=row_st&&s.row_focus<=row_ed){height=row-top;}else{height=row-top;}rowseleted[1]=row_ed;}}if(!(rowseleted[1]<row_st||rowseleted[0]>row_ed)){if(columnseleted[0]<=col_ed&&columnseleted[0]>=col_st){width+=left-col_pre;left=col_pre;columnseleted[0]=col_st;}if(columnseleted[1]>=col_st&&columnseleted[1]<=col_ed){if(s.column_focus>=col_st&&s.column_focus<=col_ed){width=col-left;}else{width=col-left;}columnseleted[1]=col_ed;}}ismatch=true;}}if(ismatch){return[columnseleted,rowseleted,top,height,left,width];}return null;}function mergeMoveMain(ctx,columnseleted,rowseleted,s,top,height,left,width){var mergesetting=ctx.config.merge;if(!mergesetting){return null;}var mcset=Object.keys(mergesetting);rowseleted[1]=Math.max(rowseleted[0],rowseleted[1]);columnseleted[1]=Math.max(columnseleted[0],columnseleted[1]);var offloop=true;var mergeMoveData={};while(offloop){offloop=false;for(var i=0;i<mcset.length;i+=1){var key=mcset[i];var mc=mergesetting[key];if(key in mergeMoveData){continue;}var changeparam=mergeMove(ctx,mc,columnseleted,rowseleted,s,top,height,left,width);if(changeparam!=null){mergeMoveData[key]=mc;var _changeparam=index_esm_slicedToArray(changeparam,6);columnseleted=_changeparam[0];rowseleted=_changeparam[1];top=_changeparam[2];height=_changeparam[3];left=_changeparam[4];width=_changeparam[5];offloop=true;}else{delete mergeMoveData[key];}}}return[columnseleted,rowseleted,top,height,left,width];}function cancelFunctionrangeSelected(ctx){if(ctx.formulaCache.selectingRangeIndex===-1){ctx.formulaRangeSelect=undefined;}}function cancelNormalSelected(ctx){cancelFunctionrangeSelected(ctx);ctx.luckysheetCellUpdate=[];ctx.formulaRangeHighlight=[];ctx.functionHint=null;ctx.formulaCache.rangestart=false;ctx.formulaCache.rangedrag_column_start=false;ctx.formulaCache.rangedrag_row_start=false;}function updateCell(ctx,r,c,$input,value,canvas){var _inputText,_curv,_ctx$hooks$beforeUpda,_ctx$hooks,_curv2;var inputText=$input===null||$input===void 0?void 0:$input.innerText;var inputHtml=$input===null||$input===void 0?void 0:$input.innerHTML;var flowdata=getFlowdata(ctx);if(!flowdata)return;var index=getSheetIndex(ctx,ctx.currentSheetId);var dataVerification=ctx.luckysheetfile[index].dataVerification;if(!lodash_default().isNil(dataVerification)){var dvItem=dataVerification["".concat(r,"_").concat(c)];if(!lodash_default().isNil(dvItem)&&dvItem.prohibitInput&&!validateCellData(ctx,dvItem,inputText)){var failureText=getFailureText(ctx,dvItem);cancelNormalSelected(ctx);ctx.warnDialog=failureText;return;}}var curv=flowdata[r][c];var oldValue=lodash_default().cloneDeep(curv);var isPrevInline=isInlineStringCell(curv);var isCurInline=((_inputText=inputText)===null||_inputText===void 0?void 0:_inputText.slice(0,1))!=="="&&(inputHtml===null||inputHtml===void 0?void 0:inputHtml.substring(0,5))==="<span";var isCopyVal=false;if(!isCurInline&&inputText&&inputText.length>0){var splitArr=inputText.replace(/\r\n/g,"_x000D_").replace(/&#13;&#10;/g,"_x000D_").replace(/\r/g,"_x000D_").replace(/\n/g,"_x000D_").split("_x000D_");if(splitArr.length>1&&inputHtml!=="<br>"){isCopyVal=true;isCurInline=true;inputText=splitArr.join("\r\n");}}if(((_curv=curv)===null||_curv===void 0?void 0:_curv.ct)&&!value&&!isCurInline&&isPrevInline){delete curv.ct.s;curv.ct.t="g";curv.ct.fa="General";value="";}else if(isCurInline){if(!lodash_default().isPlainObject(curv)){curv={};}curv||(curv={});var fontSize=curv.fs||10;if(!curv.ct){curv.ct={};curv.ct.fa="General";}curv.ct.t="inlineStr";curv.ct.s=convertSpanToShareString($input.querySelectorAll("span"),curv);delete curv.fs;delete curv.f;delete curv.v;delete curv.m;curv.fs=fontSize;if(isCopyVal){curv.ct.s=[{v:inputText,fs:fontSize}];}}value=value||($input===null||$input===void 0?void 0:$input.innerText);if(((_ctx$hooks$beforeUpda=(_ctx$hooks=ctx.hooks).beforeUpdateCell)===null||_ctx$hooks$beforeUpda===void 0?void 0:_ctx$hooks$beforeUpda.call(_ctx$hooks,r,c,value))===false){cancelNormalSelected(ctx);return;}if(!isCurInline){if(isRealNull(value)&&!isPrevInline){if(!curv||isRealNull(curv.v)&&!curv.spl&&!curv.f){cancelNormalSelected(ctx);return;}}else if(curv&&curv.qp!==1){if(lodash_default().isPlainObject(curv)&&(value===curv.f||value===curv.v||value===curv.m)){cancelNormalSelected(ctx);return;}if(value===curv){cancelNormalSelected(ctx);return;}}if(lodash_default().isString(value)&&value.slice(0,1)==="="&&value.length>1);else if(lodash_default().isPlainObject(curv)&&curv&&curv.ct&&curv.ct.fa&&curv.ct.fa!=="@"&&!isRealNull(value)){delete curv.m;if(curv.f){delete curv.f;delete curv.spl;}}}var d=flowdata;var dynamicArrayItem=null;if(lodash_default().isPlainObject(curv)){if(!isCurInline){if(lodash_default().isString(value)&&value.slice(0,1)==="="&&value.length>1){var _d$r;var v=execfunction(ctx,value,r,c,undefined,undefined,true);curv=lodash_default().cloneDeep((d===null||d===void 0?void 0:(_d$r=d[r])===null||_d$r===void 0?void 0:_d$r[c])||{});var _v=index_esm_slicedToArray(v,3);curv.v=_v[1];curv.f=_v[2];if(v.length===4&&v[3].type==="sparklines"){delete curv.m;delete curv.v;var curCalv=v[3].data;if(lodash_default().isArray(curCalv)&&!lodash_default().isPlainObject(curCalv[0])){var _curCalv=index_esm_slicedToArray(curCalv,1);curv.v=_curCalv[0];}else{curv.spl=v[3].data;}}else if(v.length===4&&v[3].type==="dynamicArrayItem"){dynamicArrayItem=v[3].data;}}else if(lodash_default().isPlainObject(value)){var valueFunction=value.f;if(lodash_default().isString(valueFunction)&&valueFunction.slice(0,1)==="="&&valueFunction.length>1){var _d$r2;var _v2=execfunction(ctx,valueFunction,r,c,undefined,undefined,true);curv=lodash_default().cloneDeep((d===null||d===void 0?void 0:(_d$r2=d[r])===null||_d$r2===void 0?void 0:_d$r2[c])||{});var _v3=index_esm_slicedToArray(_v2,3);curv.v=_v3[1];curv.f=_v3[2];if(_v2.length===4&&_v2[3].type==="sparklines"){delete curv.m;delete curv.v;var _curCalv2=_v2[3].data;if(lodash_default().isArray(_curCalv2)&&!lodash_default().isPlainObject(_curCalv2[0])){var _curCalv3=index_esm_slicedToArray(_curCalv2,1);curv.v=_curCalv3[0];}else{curv.spl=_v2[3].data;}}else if(_v2.length===4&&_v2[3].type==="dynamicArrayItem"){dynamicArrayItem=_v2[3].data;}}else{Object.keys(value).forEach(function(attr){curv[attr]=value[attr];});}}else{var _d$r3;delFunctionGroup(ctx,r,c);execFunctionGroup(ctx,r,c,value);curv=lodash_default().cloneDeep((d===null||d===void 0?void 0:(_d$r3=d[r])===null||_d$r3===void 0?void 0:_d$r3[c])||{});curv.v=value;delete curv.f;delete curv.spl;if(curv.qp===1&&"".concat(value).substring(0,1)!=="'"){curv.qp=0;if(curv.ct){curv.ct.fa="General";curv.ct.t="n";}}}}value=curv;}else{if(lodash_default().isString(value)&&value.slice(0,1)==="="&&value.length>1){var _v4=execfunction(ctx,value,r,c,undefined,undefined,true);value={v:_v4[1],f:_v4[2]};if(_v4.length===4&&_v4[3].type==="sparklines"){var _curCalv4=_v4[3].data;if(lodash_default().isArray(_curCalv4)&&!lodash_default().isPlainObject(_curCalv4[0])){var _curCalv5=index_esm_slicedToArray(_curCalv4,1);value.v=_curCalv5[0];}else{value.spl=_v4[3].data;}}else if(_v4.length===4&&_v4[3].type==="dynamicArrayItem"){dynamicArrayItem=_v4[3].data;}}else if(lodash_default().isPlainObject(value)){var _valueFunction=value.f;if(lodash_default().isString(_valueFunction)&&_valueFunction.slice(0,1)==="="&&_valueFunction.length>1){var _v5=execfunction(ctx,_valueFunction,r,c,undefined,undefined,true);var _v6=index_esm_slicedToArray(_v5,3);value.v=_v6[1];value.f=_v6[2];if(_v5.length===4&&_v5[3].type==="sparklines"){var _curCalv6=_v5[3].data;if(lodash_default().isArray(_curCalv6)&&!lodash_default().isPlainObject(_curCalv6[0])){var _curCalv7=index_esm_slicedToArray(_curCalv6,1);value.v=_curCalv7[0];}else{value.spl=_v5[3].data;}}else if(_v5.length===4&&_v5[3].type==="dynamicArrayItem"){dynamicArrayItem=_v5[3].data;}}else{var _v7=curv;if(lodash_default().isNil(value.v)){value.v=_v7;}}}else{delFunctionGroup(ctx,r,c);execFunctionGroup(ctx,r,c,value);}}setCellValue(ctx,r,c,d,value);cancelNormalSelected(ctx);if(((_curv2=curv)===null||_curv2===void 0?void 0:_curv2.tb)==="2"&&curv.v||isInlineStringCell(d[r][c])){var _cfg$columnlen,_cfg$rowlen;var defaultrowlen=ctx.defaultrowlen;var cfg=ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)].config||{};if(!(((_cfg$columnlen=cfg.columnlen)===null||_cfg$columnlen===void 0?void 0:_cfg$columnlen[c])&&((_cfg$rowlen=cfg.rowlen)===null||_cfg$rowlen===void 0?void 0:_cfg$rowlen[r]))){var _cfg$columnlen2,_cfg$customHeight;var cellWidth=((_cfg$columnlen2=cfg.columnlen)===null||_cfg$columnlen2===void 0?void 0:_cfg$columnlen2[c])||ctx.defaultcollen;var textInfo=canvas?getCellTextInfo(d[r][c],canvas,ctx,{r:r,c:c,cellWidth:cellWidth}):null;var currentRowLen=defaultrowlen;if(textInfo){currentRowLen=textInfo.textHeightAll+2;}if(currentRowLen>defaultrowlen&&!((_cfg$customHeight=cfg.customHeight)===null||_cfg$customHeight===void 0?void 0:_cfg$customHeight[r])){if(lodash_default().isNil(cfg.rowlen))cfg.rowlen={};cfg.rowlen[r]=currentRowLen;}}}if(ctx.hooks.afterUpdateCell){var newValue=lodash_default().cloneDeep(flowdata[r][c]);var afterUpdateCell=ctx.hooks.afterUpdateCell;setTimeout(function(){afterUpdateCell===null||afterUpdateCell===void 0?void 0:afterUpdateCell(r,c,oldValue,newValue);});}ctx.formulaCache.execFunctionGlobalData=null;}function getOrigincell(ctx,r,c,i){var data=getFlowdata(ctx,i);if(lodash_default().isNil(r)||lodash_default().isNil(c)){return null;}if(!data||!data[r]||!data[r][c]){return null;}return data[r][c];}function getcellFormula(ctx,r,c,i,data){var cell;if(lodash_default().isNil(data)){cell=getOrigincell(ctx,r,c,i);}else{cell=data[r][c];}if(lodash_default().isNil(cell)){return null;}return cell.f;}function getRange(ctx){var rangeArr=lodash_default().cloneDeep(ctx.luckysheet_select_save);var result=[];if(!rangeArr)return result;for(var i=0;i<rangeArr.length;i+=1){var rangeItem=rangeArr[i];var temp={row:rangeItem.row,column:rangeItem.column};result.push(temp);}return result;}function getFlattenedRange(ctx,range){range=range||getRange(ctx);var result=[];range.forEach(function(ele){var rs=ele.row;var cs=ele.column;for(var r=rs[0];r<=rs[1];r+=1){for(var c=cs[0];c<=cs[1];c+=1){result.push({r:r,c:c});}}});return result;}function getRangetxt(ctx,sheetId,range,currentId){var sheettxt="";if(currentId==null){currentId=ctx.currentSheetId;}if(sheetId!==currentId){var index=getSheetIndex(ctx,sheetId);if(index==null)return"";sheettxt=ctx.luckysheetfile[index].name.replace(/'/g,"''");if(/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/.test(sheettxt)){sheettxt+="!";}else{sheettxt="'".concat(sheettxt,"'!");}}var row0=range.row[0];var row1=range.row[1];var column0=range.column[0];var column1=range.column[1];if(row0==null&&row1==null){return"".concat(sheettxt+indexToColumnChar(column0),":").concat(indexToColumnChar(column1));}if(column0==null&&column1==null){return"".concat(sheettxt+(row0+1),":").concat(row1+1);}if(column0===column1&&row0===row1){return sheettxt+indexToColumnChar(column0)+(row0+1);}return"".concat(sheettxt+indexToColumnChar(column0)+(row0+1),":").concat(indexToColumnChar(column1)).concat(row1+1);}function getRangeByTxt(ctx,txt){var range=[];if(txt.indexOf(",")!==-1){var arr=txt.split(",");for(var i=0;i<arr.length;i+=1){if(iscelldata(arr[i])){range.push(getcellrange(ctx,arr[i]));}else{range=[];break;}}}else{if(iscelldata(txt)){range.push(getcellrange(ctx,txt));}}return range;}function isAllSelectedCellsInStatus(ctx,attr,status){if(!lodash_default().isEmpty(ctx.luckysheetCellUpdate)){var _startContainer$paren2,_endContainer$parentE;var w=window.getSelection();if(!w)return false;if(w.rangeCount===0)return false;var range=w.getRangeAt(0);if(range.collapsed===true){return false;}var endContainer=range.endContainer;var startContainer=range.startContainer;var cssField=lodash_default().camelCase(attrToCssName[attr]);if(startContainer===endContainer){var _startContainer$paren;return!lodash_default().isEmpty((_startContainer$paren=startContainer.parentElement)===null||_startContainer$paren===void 0?void 0:_startContainer$paren.style[cssField]);}if(((_startContainer$paren2=startContainer.parentElement)===null||_startContainer$paren2===void 0?void 0:_startContainer$paren2.tagName)==="SPAN"&&((_endContainer$parentE=endContainer.parentElement)===null||_endContainer$parentE===void 0?void 0:_endContainer$parentE.tagName)==="SPAN"){var _startSpan$parentNode;var startSpan=startContainer.parentNode;var endSpan=endContainer.parentNode;var allSpans=startSpan===null||startSpan===void 0?void 0:(_startSpan$parentNode=startSpan.parentNode)===null||_startSpan$parentNode===void 0?void 0:_startSpan$parentNode.querySelectorAll("span");if(allSpans){var startSpanIndex=lodash_default().indexOf(allSpans,startSpan);var endSpanIndex=lodash_default().indexOf(allSpans,endSpan);var rangeSpans=[];for(var i=startSpanIndex;i<=endSpanIndex;i+=1){rangeSpans.push(allSpans[i]);}return lodash_default().every(rangeSpans,function(s){return!lodash_default().isEmpty(s.style[cssField]);});}}}var cells=getFlattenedRange(ctx);var flowdata=getFlowdata(ctx);return cells.every(function(_ref){var _flowdata$r;var r=_ref.r,c=_ref.c;var cell=flowdata===null||flowdata===void 0?void 0:(_flowdata$r=flowdata[r])===null||_flowdata$r===void 0?void 0:_flowdata$r[c];if(lodash_default().isNil(cell)){return false;}return cell[attr]===status;});}function getFontStyleByCell(cell,checksAF,checksCF){var isCheck=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;var style={};if(!cell){return style;}lodash_default().forEach(cell,function(v,key){var _checksAF$length;var value=cell[key];if(isCheck){value=normalizedCellAttr(cell,key);}var valueNum=Number(value);if(key==="bl"&&valueNum!==0){style.fontWeight="bold";}if(key==="it"&&valueNum!==0){style.fontStyle="italic";}if(key==="fs"&&valueNum!==10){style.fontSize="".concat(valueNum,"pt");}if(key==="fc"&&value!=="#000000"||((_checksAF$length=checksAF===null||checksAF===void 0?void 0:checksAF.length)!==null&&_checksAF$length!==void 0?_checksAF$length:0)>0||(checksCF===null||checksCF===void 0?void 0:checksCF.textColor)){var _checksAF$length2;if(checksCF===null||checksCF===void 0?void 0:checksCF.textColor){style.color=checksCF.textColor;}else if(((_checksAF$length2=checksAF===null||checksAF===void 0?void 0:checksAF.length)!==null&&_checksAF$length2!==void 0?_checksAF$length2:0)>0){var _checksAF=index_esm_slicedToArray(checksAF,1);style.color=_checksAF[0];}else{style.color=value;}}if(key==="cl"&&valueNum!==0){style.textDecoration="line-through";}if(key==="un"&&(valueNum===1||valueNum===3)){var _cell$_color,_cell$_fontSize;var color=(_cell$_color=cell._color)!==null&&_cell$_color!==void 0?_cell$_color:cell.fc;var fs=(_cell$_fontSize=cell._fontSize)!==null&&_cell$_fontSize!==void 0?_cell$_fontSize:cell.fs;style.borderBottom="".concat(Math.floor(fs/9),"px solid ").concat(color);}});return style;}function getStyleByCell(ctx,d,r,c){var _d$r4;var style={};var checksAF=[];var cf_compute=getComputeMap(ctx);var checksCF=checkCF(r,c,cf_compute);var cell=d===null||d===void 0?void 0:(_d$r4=d[r])===null||_d$r4===void 0?void 0:_d$r4[c];if(!cell)return{};var isInline=isInlineStringCell(cell);if("bg"in cell){var value=normalizedCellAttr(cell,"bg");if(checksCF===null||checksCF===void 0?void 0:checksCF.cellColor){if(checksCF===null||checksCF===void 0?void 0:checksCF.cellColor){style.background="".concat(checksCF.cellColor);}else if(checksAF.length>1){style.background="".concat(checksAF[1]);}else{style.background="".concat(value);}}}if("ht"in cell){var _value2=normalizedCellAttr(cell,"ht");if(Number(_value2)===0){style.textAlign="center";}else if(Number(_value2)===2){style.textAlign="right";}}if("vt"in cell){var _value3=normalizedCellAttr(cell,"vt");if(Number(_value3)===0){style.alignItems="center";}else if(Number(_value3)===2){style.alignItems="flex-end";}}if(!isInline){style=lodash_default().assign(style,getFontStyleByCell(cell,checksAF,checksCF));}return style;}function getInlineStringHTML(r,c,data){var ct=getCellValue(r,c,data,"ct");if(isInlineStringCT(ct)){var strings=ct.s;var value="";for(var i=0;i<strings.length;i+=1){var strObj=strings[i];if(strObj.v){var style=getFontStyleByCell(strObj);var styleStr=lodash_default().map(style,function(v,key){return"".concat(lodash_default().kebabCase(key),":").concat(lodash_default().isNumber(v)?"".concat(v,"px"):v,";");}).join("");value+="<span class=\"luckysheet-input-span\" index='".concat(i,"' style='").concat(styleStr,"'>").concat(strObj.v,"</span>");}}return value;}return"";}function getQKBorder(width,type,color){var bordertype="";if(width.toString().indexOf("pt")>-1){var nWidth=parseFloat(width);if(nWidth<1);else if(nWidth<1.5){bordertype="Medium";}else{bordertype="Thick";}}else{var _nWidth=parseFloat(width);if(_nWidth<2);else if(_nWidth<3){bordertype="Medium";}else{bordertype="Thick";}}var style=0;type=type.toLowerCase();if(type==="double"){style=2;}else if(type==="dotted"){if(bordertype==="Medium"||bordertype==="Thick"){style=3;}else{style=10;}}else if(type==="dashed"){if(bordertype==="Medium"||bordertype==="Thick"){style=4;}else{style=9;}}else if(type==="solid"){if(bordertype==="Medium"){style=8;}else if(bordertype==="Thick"){style=13;}else{style=1;}}return[style,color];}function getdatabyselection(ctx,range,sheetId){if(range==null&&ctx.luckysheet_select_save){var _ctx$luckysheet_selec=index_esm_slicedToArray(ctx.luckysheet_select_save,1);range=_ctx$luckysheet_selec[0];}if(!range)return[];if(range.row==null||range.row.length===0){return[];}var d;var cfg;if(sheetId!=null&&sheetId!==ctx.currentSheetId){d=ctx.luckysheetfile[getSheetIndex(ctx,sheetId)].data;cfg=ctx.luckysheetfile[getSheetIndex(ctx,sheetId)].config;}else{d=getFlowdata(ctx);cfg=ctx.config;}var data=[];for(var r=range.row[0];r<=range.row[1];r+=1){var _d,_cfg;if(((_d=d)===null||_d===void 0?void 0:_d[r])==null){continue;}if(((_cfg=cfg)===null||_cfg===void 0?void 0:_cfg.rowhidden)!=null&&cfg.rowhidden[r]!=null){continue;}var row=[];for(var c=range.column[0];c<=range.column[1];c+=1){var _cfg2;if(((_cfg2=cfg)===null||_cfg2===void 0?void 0:_cfg2.colhidden)!=null&&cfg.colhidden[c]!=null){continue;}row.push(d[r][c]);}data.push(row);}return data;}function luckysheetUpdateCell(ctx,row_index,col_index){ctx.luckysheetCellUpdate=[row_index,col_index];}function getDataBySelectionNoCopy(ctx,range){if(!range||!range.row||range.row.length===0)return[];var data=[];var flowData=getFlowdata(ctx);if(!flowData)return[];for(var r=range.row[0];r<=range.row[1];r+=1){var row=[];if(ctx.config.rowhidden!=null&&ctx.config.rowhidden[r]!=null){continue;}for(var c=range.column[0];c<=range.column[1];c+=1){var value=null;if(ctx.config.colhidden!=null&&ctx.config.colhidden[c]!=null){continue;}if(flowData[r]!=null&&flowData[r][c]!=null){value=flowData[r][c];}row.push(value);}data.push(row);}return data;}var clipboard=/*#__PURE__*/function(){function clipboard(){index_esm_classCallCheck(this,clipboard);}index_esm_createClass(clipboard,null,[{key:"writeHtml",value:function writeHtml(str){try{var ele=document.getElementById("fortune-copy-content");if(!ele){var _document$querySelect;ele=document.createElement("div");ele.setAttribute("contentEditable","true");ele.id="fortune-copy-content";ele.style.position="fixed";ele.style.height="0";ele.style.width="0";ele.style.left="-10000px";(_document$querySelect=document.querySelector(".fortune-container"))===null||_document$querySelect===void 0?void 0:_document$querySelect.append(ele);}var previouslyFocusedElement=document.activeElement;ele.style.display="block";ele.innerHTML=str;ele.focus({preventScroll:true});document.execCommand("selectAll");document.execCommand("copy");setTimeout(function(){var _ele,_previouslyFocusedEle;(_ele=ele)===null||_ele===void 0?void 0:_ele.blur();previouslyFocusedElement===null||previouslyFocusedElement===void 0?void 0:(_previouslyFocusedEle=previouslyFocusedElement.focus)===null||_previouslyFocusedEle===void 0?void 0:_previouslyFocusedEle.call(previouslyFocusedElement);},10);}catch(e){console.error(e);}}}]);return clipboard;}();var selectionCache={isPasteAction:false};function scrollToHighlightCell(ctx,r,c){var scrollLeft=ctx.scrollLeft,scrollTop=ctx.scrollTop;var winH=ctx.cellmainHeight;var winW=ctx.cellmainWidth;var sheetIndex=getSheetIndex(ctx,ctx.currentSheetId);var sheet=sheetIndex==null?null:ctx.luckysheetfile[sheetIndex];if(!sheet)return;var frozen=sheet===null||sheet===void 0?void 0:sheet.frozen;if(r>=0){var _sheet$frozen,_sheet$frozen$range;var row_focus=(sheet===null||sheet===void 0?void 0:(_sheet$frozen=sheet.frozen)===null||_sheet$frozen===void 0?void 0:(_sheet$frozen$range=_sheet$frozen.range)===null||_sheet$frozen$range===void 0?void 0:_sheet$frozen$range.row_focus)||0;var freezeH=frozen&&r>row_focus?ctx.visibledatarow[row_focus]:0;var row=ctx.visibledatarow[r];var row_pre=r-1===-1?0:ctx.visibledatarow[r-1];if(row-scrollTop-winH+20>0){ctx.scrollTop=row-winH+20;}else if(row_pre-scrollTop-freezeH<0){var scrollAmount=Math.max(20,freezeH);ctx.scrollTop=row_pre-scrollAmount;}}if(c>=0){var _sheet$frozen2,_sheet$frozen2$range;var column_focus=(sheet===null||sheet===void 0?void 0:(_sheet$frozen2=sheet.frozen)===null||_sheet$frozen2===void 0?void 0:(_sheet$frozen2$range=_sheet$frozen2.range)===null||_sheet$frozen2$range===void 0?void 0:_sheet$frozen2$range.column_focus)||0;var freezeW=frozen&&c>column_focus?ctx.visibledatacolumn[column_focus]:0;var col=ctx.visibledatacolumn[c];var col_pre=c-1===-1?0:ctx.visibledatacolumn[c-1];if(col-scrollLeft-winW+20>0){ctx.scrollLeft=col-winW+20;}else if(col_pre-scrollLeft-freezeW<0){var _scrollAmount=Math.max(20,freezeW);ctx.scrollLeft=col_pre-_scrollAmount;}}}function seletedHighlistByindex(ctx,r1,r2,c1,c2){var row=ctx.visibledatarow[r2];var row_pre=r1-1===-1?0:ctx.visibledatarow[r1-1];var col=ctx.visibledatacolumn[c2];var col_pre=c1-1===-1?0:ctx.visibledatacolumn[c1-1];if(lodash_default().isNumber(row)&&lodash_default().isNumber(row_pre)&&lodash_default().isNumber(col)&&lodash_default().isNumber(col_pre)){return{left:col_pre,width:col-col_pre-1,top:row_pre,height:row-row_pre-1};}return null;}function normalizeSelection(ctx,selection){if(!selection)return selection;var flowdata=getFlowdata(ctx);if(!flowdata)return selection;for(var i=0;i<selection.length;i+=1){var r1=selection[i].row[0];var r2=selection[i].row[1];var c1=selection[i].column[0];var c2=selection[i].column[1];var rf=void 0;var cf=void 0;if(lodash_default().isNil(selection[i].row_focus)){rf=r1;}else{rf=selection[i].row_focus;}if(lodash_default().isNil(selection[i].column_focus)){cf=c1;}else{cf=selection[i].column_focus;}if(lodash_default().isNil(rf)||lodash_default().isNil(cf)){console.error("normalizeSelection: rf and cf is nil");return selection;}var row=ctx.visibledatarow[r2];var row_pre=r1-1===-1?0:ctx.visibledatarow[r1-1];var col=ctx.visibledatacolumn[c2];var col_pre=c1-1===-1?0:ctx.visibledatacolumn[c1-1];var row_f=ctx.visibledatarow[rf];var row_pre_f=rf-1===-1?0:ctx.visibledatarow[rf-1];var col_f=ctx.visibledatacolumn[cf];var col_pre_f=cf-1===-1?0:ctx.visibledatacolumn[cf-1];var margeset=mergeBorder(ctx,flowdata,rf,cf);if(margeset){var _margeset$row=index_esm_slicedToArray(margeset.row,2);row_pre_f=_margeset$row[0];row_f=_margeset$row[1];var _margeset$column=index_esm_slicedToArray(margeset.column,2);col_pre_f=_margeset$column[0];col_f=_margeset$column[1];}selection[i].row=[r1,r2];selection[i].column=[c1,c2];selection[i].row_focus=rf;selection[i].column_focus=cf;selection[i].left=col_pre_f;selection[i].width=col_f-col_pre_f<=0?0:col_f-col_pre_f-1;selection[i].top=row_pre_f;selection[i].height=row_f-row_pre_f<=0?0:row_f-row_pre_f-1;selection[i].left_move=col_pre;selection[i].width_move=col-col_pre<=0?0:col-col_pre-1;selection[i].top_move=row_pre;selection[i].height_move=row-row_pre<=0?0:row-row_pre-1;}return selection;}function selectTitlesMap(rangeMap,range1,range2){var map=rangeMap||{};for(var i=range1;i<=range2;i+=1){if(i in map){continue;}map[i]=0;}return map;}function selectTitlesRange(map){var mapArr=Object.keys(map).map(Number);mapArr.sort(function(a,b){return a-b;});var rangeArr;var item=[];if(mapArr.length>1){rangeArr=[];for(var j=1;j<mapArr.length;j+=1){if(mapArr[j]-mapArr[j-1]===1){item.push(mapArr[j-1]);if(j===mapArr.length-1){item.push(mapArr[j]);rangeArr.push(item);}}else{if(j===1){if(j===mapArr.length-1){item.push(mapArr[j-1]);rangeArr.push(item);rangeArr.push([mapArr[j]]);}else{rangeArr.push([mapArr[0]]);}}else if(j===mapArr.length-1){item.push(mapArr[j-1]);rangeArr.push(item);rangeArr.push([mapArr[j]]);}else{item.push(mapArr[j-1]);rangeArr.push(item);item=[];}}}}else{rangeArr=[];rangeArr.push([mapArr[0]]);}return rangeArr;}function pasteHandlerOfPaintModel(ctx,copyRange){var cfg=ctx.config;if(cfg.merge==null){cfg.merge={};}if(!copyRange)return;var copyHasMC=copyRange.HasMC;var copySheetIndex=copyRange.dataSheetId;var c_r1=copyRange.copyRange[0].row[0];var c_r2=copyRange.copyRange[0].row[1];var c_c1=copyRange.copyRange[0].column[0];var c_c2=copyRange.copyRange[0].column[1];var copyData=lodash_default().cloneDeep(getdatabyselection(ctx,{row:[c_r1,c_r2],column:[c_c1,c_c2]},copySheetIndex));if(!ctx.luckysheet_select_save)return;var last=ctx.luckysheet_select_save[ctx.luckysheet_select_save.length-1];var minh=last.row[0];var maxh=last.row[1];var minc=last.column[0];var maxc=last.column[1];var copyh=copyData.length;var copyc=copyData[0].length;if(minh===maxh&&minc===maxc){var has_PartMC=false;if(cfg.merge!=null){has_PartMC=hasPartMC(ctx,cfg,minh,minh+copyh-1,minc,minc+copyc-1);}if(has_PartMC){return;}maxh=minh+copyh-1;maxc=minc+copyc-1;}var timesH=Math.ceil((maxh-minh+1)/copyh);var timesC=Math.ceil((maxc-minc+1)/copyc);var flowdata=getFlowdata(ctx);if(flowdata==null)return;var cellMaxLength=flowdata[0].length;var rowMaxLength=flowdata.length;var borderInfoCompute=getBorderInfoCompute(ctx,copySheetIndex);var c_dataVerification=lodash_default().cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx,copySheetIndex)].dataVerification)||{};var dataVerification=null;var mth=0;var mtc=0;var maxcellCahe=0;var maxrowCache=0;for(var th=1;th<=timesH;th+=1){for(var tc=1;tc<=timesC;tc+=1){mth=minh+(th-1)*copyh;mtc=minc+(tc-1)*copyc;maxrowCache=minh+th*copyh>rowMaxLength?rowMaxLength:minh+th*copyh;if(maxrowCache>maxh+1){maxrowCache=maxh+1;}maxcellCahe=minc+tc*copyc>cellMaxLength?cellMaxLength:minc+tc*copyc;if(maxcellCahe>maxc+1){maxcellCahe=maxc+1;}var offsetMC={};var _loop=function _loop(h){if(h==null)return{v:void 0};if(flowdata[h]==null)return{v:void 0};var x=[];x=flowdata[h];var _loop2=function _loop2(c){if(borderInfoCompute["".concat(c_r1+h-mth,"_").concat(c_c1+c-mtc)]){var bd_obj={rangeType:"cell",value:{row_index:h,col_index:c,l:borderInfoCompute["".concat(c_r1+h-mth,"_").concat(c_c1+c-mtc)].l,r:borderInfoCompute["".concat(c_r1+h-mth,"_").concat(c_c1+c-mtc)].r,t:borderInfoCompute["".concat(c_r1+h-mth,"_").concat(c_c1+c-mtc)].t,b:borderInfoCompute["".concat(c_r1+h-mth,"_").concat(c_c1+c-mtc)].b}};if(cfg.borderInfo==null){cfg.borderInfo=[];}cfg.borderInfo.push(bd_obj);}else if(borderInfoCompute["".concat(h,"_").concat(c)]){var _bd_obj={rangeType:"cell",value:{row_index:h,col_index:c,l:null,r:null,t:null,b:null}};if(cfg.borderInfo==null){cfg.borderInfo=[];}cfg.borderInfo.push(_bd_obj);}if(c_dataVerification["".concat(c_r1+h-mth,"_").concat(c_c1+c-mtc)]){if(dataVerification==null){dataVerification=lodash_default().cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)].dataVerification);}dataVerification["".concat(h,"_").concat(c)]=c_dataVerification["".concat(c_r1+h-mth,"_").concat(c_c1+c-mtc)];}if((0,lodash.isPlainObject)(x[c])&&x[c].mc){if(x[c].mc.rs){delete cfg.merge["".concat(x[c].mc.r,"_").concat(x[c].mc.c)];}delete x[c].mc;}var value=null;if(copyData[h-mth]!=null&&copyData[h-mth][c-mtc]!=null){value=copyData[h-mth][c-mtc];}if((0,lodash.isPlainObject)(x[c])){if(x[c].ct&&x[c].ct.t==="inlineStr"&&value){delete value.ct;}else{var format=["bg","fc","ct","ht","vt","bl","it","cl","un","fs","ff","tb"];format.forEach(function(item){Reflect.deleteProperty(x[c],item);});}}else{x[c]={v:x[c]};}if(value!=null){delete value.v;delete value.m;delete value.f;delete value.spl;if(value.ct&&value.ct.t==="inlineStr"){delete value.ct;}x[c]=lodash_default().assign(x[c],lodash_default().cloneDeep(value));if(x[c].ct&&x[c].ct.t==="inlineStr"){x[c].ct.s.forEach(function(item){return lodash_default().assign(item,value);});}if(copyHasMC&&x[c].mc){if(x[c].mc.rs!=null){x[c].mc.r=h;if(x[c].mc.rs+h>=maxrowCache){x[c].mc.rs=maxrowCache-h;}x[c].mc.c=c;if(x[c].mc.cs+c>=maxcellCahe){x[c].mc.cs=maxcellCahe-c;}cfg.merge["".concat(x[c].mc.r,"_").concat(x[c].mc.c)]=x[c].mc;offsetMC["".concat(value.mc.r,"_").concat(value.mc.c)]=[x[c].mc.r,x[c].mc.c];}else{x[c]={mc:{r:offsetMC["".concat(value.mc.r,"_").concat(value.mc.c)][0],c:offsetMC["".concat(value.mc.r,"_").concat(value.mc.c)][1]}};}}if(x[c].v!=null){if(value.ct!=null&&value.ct.fa!=null){var mask=update(value.ct.fa,x[c].v);x[c].m=mask;}}}};for(var c=mtc;c<maxcellCahe;c+=1){_loop2(c);}flowdata[h]=x;};for(var h=mth;h<maxrowCache;h+=1){var _ret=_loop(h);if(index_esm_typeof(_ret)==="object")return _ret.v;}}}var currFile=ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)];currFile.config=cfg;currFile.dataVerification=dataVerification;var cdformat=null;var copyIndex=getSheetIndex(ctx,copySheetIndex);if(!copyIndex)return;var ruleArr=lodash_default().cloneDeep(ctx.luckysheetfile[copyIndex].luckysheet_conditionformat_save);if(!lodash_default().isNil(ruleArr)&&ruleArr.length>0){var currentIndex=getSheetIndex(ctx,ctx.currentSheetId);cdformat=lodash_default().cloneDeep(ctx.luckysheetfile[currentIndex].luckysheet_conditionformat_save);for(var i=0;i<ruleArr.length;i+=1){var cdformat_cellrange=ruleArr[i].cellrange;var emptyRange=[];for(var j=0;j<cdformat_cellrange.length;j+=1){var range=CFSplitRange(cdformat_cellrange[j],{row:[c_r1,c_r2],column:[c_c1,c_c2]},{row:[minh,maxh],column:[minc,maxc]},"operatePart");if(range.length>0){emptyRange=emptyRange.concat(range);}}if(emptyRange.length>0){ruleArr[i].cellrange=[{row:[minh,maxh],column:[minc,maxc]}];cdformat.push(ruleArr[i]);}}}}function selectionCopyShow(range,ctx){if(range==null){range=ctx.luckysheet_selection_range;}range=JSON.parse(JSON.stringify(range));}function rowHasMerged(ctx,r,c1,c2){var hasMerged=false;var flowData=getFlowdata(ctx);if(lodash_default().isNil(flowData)||lodash_default().isNil(flowData[r]))return false;for(var c=c1;c<=c2;c+=1){var cell=flowData[r][c];if(!lodash_default().isNil(cell)&&"mc"in cell){hasMerged=true;break;}}return hasMerged;}function colHasMerged(ctx,c,r1,r2){var hasMerged=false;var flowData=getFlowdata(ctx);if(lodash_default().isNil(flowData))return false;for(var r=r1;r<=r2;r+=1){var _flowData$r;var cell=(_flowData$r=flowData[r])===null||_flowData$r===void 0?void 0:_flowData$r[c];if(!lodash_default().isNil(ctx.config.merge)&&!lodash_default().isNil(cell)&&"mc"in cell&&!lodash_default().isNil(cell.mc)){hasMerged=true;break;}}return hasMerged;}function getRowMerge(ctx,rIndex,c1,c2){var flowData=getFlowdata(ctx);if(lodash_default().isNil(flowData))return[null,null];var r2=flowData.length-1;var str=null;if(rIndex>0){for(var r=rIndex;r>=0;r-=1){for(var c=c1;c<=c2;c+=1){var cell=flowData[r][c];if(!lodash_default().isNil(cell)&&!lodash_default().isNil(cell.mc)&&"mc"in cell&&!lodash_default().isNil(ctx.config.merge)){var mc=ctx.config.merge["".concat(cell.mc.r,"_").concat(cell.mc.c)];if(lodash_default().isNil(str)||mc.r<str){str=mc.r;}}}if(!lodash_default().isNil(str)&&rowHasMerged(ctx,str-1,c1,c2)&&str>0){r=str;}else{break;}}}else{str=0;}var end=null;if(rIndex<r2){for(var _r=rIndex;_r<=r2;_r+=1){for(var _c=c1;_c<=c2;_c+=1){var _cell=flowData[_r][_c];if(!lodash_default().isNil(_cell)&&!lodash_default().isNil(_cell.mc)&&"mc"in _cell&&!lodash_default().isNil(ctx.config.merge)){var _mc=ctx.config.merge["".concat(_cell.mc.r,"_").concat(_cell.mc.c)];if(lodash_default().isNil(end)||_mc.r+_mc.rs-1>end){end=_mc.r+_mc.rs-1;}}}if(!lodash_default().isNil(end)&&rowHasMerged(ctx,end+1,c1,c2)&&end<r2){_r=end;}else{break;}}}else{end=r2;}return[str,end];}function getColMerge(ctx,cIndex,r1,r2){var flowData=getFlowdata(ctx);if(lodash_default().isNil(flowData)){return[null,null];}var c2=flowData[0].length-1;var str=null;if(cIndex>0){for(var c=cIndex;c>=0;c-=1){for(var r=r1;r<=r2;r+=1){var cell=flowData[r][c];if(!lodash_default().isNil(ctx.config.merge)&&!lodash_default().isNil(cell)&&"mc"in cell&&!lodash_default().isNil(cell.mc)){var mc=ctx.config.merge["".concat(cell.mc.r,"_").concat(cell.mc.c)];if(lodash_default().isNil(str)||mc.c<str){str=mc.c;}}}if(!lodash_default().isNil(str)&&colHasMerged(ctx,str-1,r1,r2)&&str>0){c=str;}else{break;}}}else{str=0;}var end=null;if(cIndex<c2){for(var _c2=cIndex;_c2<=c2;_c2+=1){for(var _r2=r1;_r2<=r2;_r2+=1){var _cell2=flowData[_r2][_c2];if(!lodash_default().isNil(ctx.config.merge)&&!lodash_default().isNil(_cell2)&&"mc"in _cell2&&!lodash_default().isNil(_cell2.mc)){var _mc2=ctx.config.merge["".concat(_cell2.mc.r,"_").concat(_cell2.mc.c)];if(lodash_default().isNil(end)||_mc2.c+_mc2.cs-1>end){end=_mc2.c+_mc2.cs-1;}}}if(!lodash_default().isNil(end)&&colHasMerged(ctx,end+1,r1,r2)&&end<c2){_c2=end;}else{break;}}}else{end=c2;}return[str,end];}function moveHighlightCell(ctx,postion,index,type){var flowdata=getFlowdata(ctx);if(!flowdata)return;var datarowlen=flowdata.length;var datacolumnlen=flowdata[0].length;var row;var row_pre;var row_index;var row_index_ed;var col;var col_pre;var col_index;var col_index_ed;if(type==="rangeOfSelect"){var _ctx$luckysheet_selec;var last=(_ctx$luckysheet_selec=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec===void 0?void 0:_ctx$luckysheet_selec[ctx.luckysheet_select_save.length-1];if(!last){console.error("moveHighlightCell: no selection found");return;}var curR;if(lodash_default().isNil(last.row_focus)){var _last$row=index_esm_slicedToArray(last.row,1);curR=_last$row[0];}else{curR=last.row_focus;}var curC;if(lodash_default().isNil(last.column_focus)){var _last$column=index_esm_slicedToArray(last.column,1);curC=_last$column[0];}else{curC=last.column_focus;}var margeset=mergeBorder(ctx,flowdata,curR,curC);if(margeset){var str_r=margeset.row[2];var end_r=margeset.row[3];var str_c=margeset.column[2];var end_c=margeset.column[3];if(index>0){if(postion==="down"){curR=end_r;curC=str_c;}else if(postion==="right"){curR=str_r;curC=end_c;}}else{curR=str_r;curC=str_c;}}if(lodash_default().isNil(curR)||lodash_default().isNil(curC)){console.error("moveHighlightCell: curR or curC is nil");return;}var moveX=lodash_default().isNil(last.moveXY)?curR:last.moveXY.x;var moveY=lodash_default().isNil(last.moveXY)?curC:last.moveXY.y;if(postion==="down"){curR+=index;moveX=curR;}else if(postion==="right"){curC+=index;moveY=curC;}if(curR>=datarowlen){curR=datarowlen-1;moveX=curR;}if(curR<0){curR=0;moveX=curR;}if(curC>=datacolumnlen){curC=datacolumnlen-1;moveY=curC;}if(curC<0){curC=0;moveY=curC;}var margeset2=mergeBorder(ctx,flowdata,curR,curC);if(margeset2){var _margeset2$row=index_esm_slicedToArray(margeset2.row,4);row_pre=_margeset2$row[0];row=_margeset2$row[1];row_index=_margeset2$row[2];row_index_ed=_margeset2$row[3];var _margeset2$column=index_esm_slicedToArray(margeset2.column,4);col_pre=_margeset2$column[0];col=_margeset2$column[1];col_index=_margeset2$column[2];col_index_ed=_margeset2$column[3];}else{row=ctx.visibledatarow[moveX];row_pre=moveX-1===-1?0:ctx.visibledatarow[moveX-1];col=ctx.visibledatacolumn[moveY];col_pre=moveY-1===-1?0:ctx.visibledatacolumn[moveY-1];row_index=curR;row_index_ed=curR;col_index=curC;col_index_ed=curC;}if(lodash_default().isNil(row_index)||lodash_default().isNil(row_index_ed)||lodash_default().isNil(col_index)||lodash_default().isNil(col_index_ed)){console.error("moveHighlightCell: row_index or row_index_ed or col_index or col_index_ed is nil");return;}last.row=[row_index,row_index_ed];last.column=[col_index,col_index_ed];last.row_focus=row_index;last.column_focus=col_index;last.moveXY={x:moveX,y:moveY};normalizeSelection(ctx,ctx.luckysheet_select_save);scrollToHighlightCell(ctx,row_index,col_index);}else if(type==="rangeOfFormula"){var _last=ctx.formulaCache.func_selectedrange;if(!_last)return;var _curR;if(lodash_default().isNil(_last.row_focus)){var _last$row2=index_esm_slicedToArray(_last.row,1);_curR=_last$row2[0];}else{_curR=_last.row_focus;}var _curC;if(lodash_default().isNil(_last.column_focus)){var _last$column2=index_esm_slicedToArray(_last.column,1);_curC=_last$column2[0];}else{_curC=_last.column_focus;}var _margeset=mergeBorder(ctx,flowdata,_curR,_curC);if(_margeset){var _str_r=_margeset.row[2];var _end_r=_margeset.row[3];var _str_c=_margeset.column[2];var _end_c=_margeset.column[3];if(index>0){if(postion==="down"){_curR=_end_r;_curC=_str_c;}else if(postion==="right"){_curR=_str_r;_curC=_end_c;}}else{_curR=_str_r;_curC=_str_c;}}if(lodash_default().isNil(_curR)||lodash_default().isNil(_curC)){console.error("moveHighlightCell: curR or curC is nil");return;}var _moveX=lodash_default().isNil(_last.moveXY)?_curR:_last.moveXY.x;var _moveY=lodash_default().isNil(_last.moveXY)?_curC:_last.moveXY.y;if(postion==="down"){_curR+=index;_moveX=_curR;}else if(postion==="right"){_curC+=index;_moveY=_curC;}if(_curR>=datarowlen){_curR=datarowlen-1;_moveX=_curR;}if(_curR<0){_curR=0;_moveX=_curR;}if(_curC>=datacolumnlen){_curC=datacolumnlen-1;_moveY=_curC;}if(_curC<0){_curC=0;_moveY=_curC;}var _margeset2=mergeBorder(ctx,flowdata,_curR,_curC);if(_margeset2){var _margeset2$row2=index_esm_slicedToArray(_margeset2.row,4);row_pre=_margeset2$row2[0];row=_margeset2$row2[1];row_index=_margeset2$row2[2];row_index_ed=_margeset2$row2[3];var _margeset2$column2=index_esm_slicedToArray(_margeset2.column,4);col_pre=_margeset2$column2[0];col=_margeset2$column2[1];col_index=_margeset2$column2[2];col_index_ed=_margeset2$column2[3];}else{row=ctx.visibledatarow[_moveX];row_pre=_moveX-1===-1?0:ctx.visibledatarow[_moveX-1];row_index=_moveX;row_index_ed=_moveX;col=ctx.visibledatacolumn[_moveY];col_pre=_moveY-1===-1?0:ctx.visibledatacolumn[_moveY-1];col_index=_moveY;col_index_ed=_moveY;}if(lodash_default().isNil(col)||lodash_default().isNil(col_pre)||lodash_default().isNil(row)||lodash_default().isNil(row_pre)||lodash_default().isNil(row_index)||lodash_default().isNil(row_index_ed)||lodash_default().isNil(col_index)||lodash_default().isNil(col_index_ed)){console.error("moveHighlightCell: some values of func_selectedrange is nil");return;}ctx.formulaCache.func_selectedrange={left:col_pre,width:col-col_pre-1,top:row_pre,height:row-row_pre-1,left_move:col_pre,width_move:col-col_pre-1,top_move:row_pre,height_move:row-row_pre-1,row:[row_index,row_index_ed],column:[col_index,col_index_ed],row_focus:row_index,column_focus:col_index,moveXY:{x:_moveX,y:_moveY}};}}function moveHighlightRange(ctx,postion,index,type){var row;var row_pre;var col;var col_pre;var flowData=getFlowdata(ctx);if(lodash_default().isNil(flowData))return;if(lodash_default().isNil(ctx.luckysheet_select_save))return;if(type==="rangeOfSelect"){var last=ctx.luckysheet_select_save[ctx.luckysheet_select_save.length-1];var curR=last.row[0];var endR=last.row[1];var curC=last.column[0];var endC=last.column[1];var rf=last.row_focus;var cf=last.column_focus;if(lodash_default().isNil(rf)||lodash_default().isNil(cf))return;var datarowlen=flowData.length;var datacolumnlen=flowData[0].length;if(postion==="down"){if(rowHasMerged(ctx,rf,curC,endC)){var rfMerge=getRowMerge(ctx,rf,curC,endC);var rf_str=rfMerge[0];var rf_end=rfMerge[1];if(!lodash_default().isNil(rf_str)&&rf_str>curR&&rf_end===endR){if(index>0&&rowHasMerged(ctx,curR,curC,endC)){var v=getRowMerge(ctx,curR,curC,endC)[1];if(!lodash_default().isNil(v)){curR=v;}}curR+=index;}else if(!lodash_default().isNil(rf_end)&&rf_end<endR&&rf_str===curR){if(index<0&&rowHasMerged(ctx,endR,curC,endC)){var _v=getRowMerge(ctx,curR,curC,endC)[0];if(!lodash_default().isNil(_v)){endR=_v;}}endR+=index;}else{if(index>0){endR+=index;}else{curR+=index;}}}else{if(rf>curR&&rf===endR){if(index>0&&rowHasMerged(ctx,curR,curC,endC)){var _v2=getRowMerge(ctx,curR,curC,endC)[1];if(!lodash_default().isNil(_v2)){curR=_v2;}}curR+=index;}else if(rf<endR&&rf===curR){if(index<0&&rowHasMerged(ctx,endR,curC,endC)){var _v3=getRowMerge(ctx,endR,curC,endC)[0];if(!lodash_default().isNil(_v3)){endR=_v3;}}endR+=index;}else if(rf===curR&&rf===endR){if(index>0){endR+=index;}else{curR+=index;}}}if(endR>=datarowlen){endR=datarowlen-1;}if(endR<0){endR=0;}if(curR>=datarowlen){curR=datarowlen-1;}if(curR<0){curR=0;}}else{if(colHasMerged(ctx,cf,curR,endR)){var cfMerge=getColMerge(ctx,cf,curR,endR);var cf_str=cfMerge[0];var cf_end=cfMerge[1];if(!lodash_default().isNil(cf_str)&&cf_str>curC&&cf_end===endC){if(index>0&&colHasMerged(ctx,curC,curR,endR)){var _v4=getColMerge(ctx,curC,curR,endR)[1];if(!lodash_default().isNil(_v4)){curC=_v4;}curC+=index;}curC+=index;}else if(!lodash_default().isNil(cf_end)&&cf_end<endC&&cf_str===curC){if(index<0&&colHasMerged(ctx,endC,curR,endR)){var _v5=getColMerge(ctx,endC,curR,endR)[0];if(!lodash_default().isNil(_v5)){endC=_v5;}}endC+=index;}else{if(index>0){endC+=index;}else{curC+=index;}}}else{if(cf>curC&&cf===endC){if(index>0&&colHasMerged(ctx,curC,curR,endR)){var _v6=getColMerge(ctx,curC,curR,endR)[1];if(!lodash_default().isNil(_v6)){curC=_v6;}curC+=index;}curC+=index;}else if(cf<endC&&cf===curC){if(index<0&&colHasMerged(ctx,endC,curR,endR)){var _v7=getColMerge(ctx,endC,curR,endR)[0];if(!lodash_default().isNil(_v7)){endC=_v7;}}endC+=index;}else if(cf===curC&&cf===endC){if(index>0){endC+=index;}else{curC+=index;}}}if(endC>=datacolumnlen){endC=datacolumnlen-1;}if(endC<0){endC=0;}if(curC>=datacolumnlen){curC=datacolumnlen-1;}if(curC<0){curC=0;}}var rowseleted=[curR,endR];var columnseleted=[curC,endC];row=ctx.visibledatarow[endR];row_pre=curR-1===-1?0:ctx.visibledatarow[curR-1];col=ctx.visibledatacolumn[endC];col_pre=curC-1===-1?0:ctx.visibledatacolumn[curC-1];var changeparam=mergeMoveMain(ctx,columnseleted,rowseleted,last,row_pre,row-row_pre-1,col_pre,col-col_pre-1);if(!lodash_default().isNil(changeparam)){var _changeparam=index_esm_slicedToArray(changeparam,2);columnseleted=_changeparam[0];rowseleted=_changeparam[1];}last.row=rowseleted;last.column=columnseleted;normalizeSelection(ctx,ctx.luckysheet_select_save);if(postion==="down"){var rowToScroll=last.row_focus===last.row[0]?last.row[1]:last.row[0];scrollToHighlightCell(ctx,rowToScroll,-1);}else{var columnToScroll=last.column_focus===last.column[0]?last.column[1]:last.column[0];scrollToHighlightCell(ctx,-1,columnToScroll);}}else if(type==="rangeOfFormula"){var _last2=ctx.formulaCache.func_selectedrange;if(lodash_default().isNil(_last2))return;var _curR2=_last2.row[0];var _endR=_last2.row[1];var _curC2=_last2.column[0];var _endC=_last2.column[1];var _rf=_last2.row_focus;var _cf=_last2.column_focus;var _datarowlen=flowData.length;var _datacolumnlen=flowData[0].length;if(postion==="down"){if(!lodash_default().isNil(_rf)&&rowHasMerged(ctx,_rf,_curC2,_endC)){var _rfMerge=getRowMerge(ctx,_rf,_curC2,_endC);var _rf_str=_rfMerge[0];var _rf_end=_rfMerge[1];if(!lodash_default().isNil(_rf_str)&&_rf_str>_curR2&&_rf_end===_endR){if(index>0&&rowHasMerged(ctx,_curR2,_curC2,_endC)){var _v8=getRowMerge(ctx,_curR2,_curC2,_endC)[1];if(!lodash_default().isNil(_v8)){_curR2=_v8;}}_curR2+=index;}else if(!lodash_default().isNil(_rf_end)&&_rf_end<_endR&&_rf_str===_curR2){if(index<0&&rowHasMerged(ctx,_endR,_curC2,_endC)){var _v9=getRowMerge(ctx,_endR,_curC2,_endC)[0];if(!lodash_default().isNil(_v9)){_endR=_v9;}_endR+=index;}}else{if(index>0){_endR+=index;}else{_curR2+=index;}}}else{if(!lodash_default().isNil(_rf)&&_rf>_curR2&&_rf===_endR){if(index>0&&rowHasMerged(ctx,_curR2,_curC2,_endC)){var _v10=getRowMerge(ctx,_curR2,_curC2,_endC)[1];if(!lodash_default().isNil(_v10)){_curR2=_v10;}}_curR2+=index;}else if(!lodash_default().isNil(_rf)&&_rf<_endR&&_rf===_curR2){if(index<0&&rowHasMerged(ctx,_endR,_curC2,_endC)){var _v11=getRowMerge(ctx,_endR,_curC2,_endC)[0];if(!lodash_default().isNil(_v11)){_endR=_v11;}}_endR+=index;}else if(_rf===_curR2&&_rf===_endR){if(index>0){_endR+=index;}else{_curR2+=index;}}}if(_endR>=_datarowlen){_endR=_datarowlen-1;}if(_endR<0){_endR=0;}if(_curR2>=_datarowlen){_curR2=_datarowlen-1;}if(_curR2<0){_curR2=0;}}else{if(!lodash_default().isNil(_cf)&&colHasMerged(ctx,_cf,_curR2,_endR)){var _cfMerge=getColMerge(ctx,_cf,_curR2,_endR);var _cf_str=_cfMerge[0];var _cf_end=_cfMerge[1];if(!lodash_default().isNil(_cf_str)&&_cf_str>_curC2&&_cf_end===_endC){if(index>0&&colHasMerged(ctx,_curC2,_curR2,_endR)){var _v12=getColMerge(ctx,_curC2,_curR2,_endR)[1];if(!lodash_default().isNil(_v12)){_curC2=_v12;}}_curC2+=index;}else if(!lodash_default().isNil(_cf_end)&&_cf_end<_endC&&_cf_str===_curC2){if(index<0&&colHasMerged(ctx,_endC,_curR2,_endR)){var _v13=getColMerge(ctx,_endC,_curR2,_endR)[0];if(!lodash_default().isNil(_v13)){_endC=_v13;}}_endC+=index;}else{if(index>0){_endC+=index;}else{_curC2+=index;}}}else{if(!lodash_default().isNil(_cf)&&_cf>_curC2&&_cf===_endC){if(index>0&&colHasMerged(ctx,_curC2,_curR2,_endR)){var _v14=getColMerge(ctx,_curC2,_curR2,_endR)[1];if(!lodash_default().isNil(_v14)){_curC2=_v14;}}_curC2+=index;}else if(!lodash_default().isNil(_cf)&&_cf<_endC&&_cf===_curC2){if(index<0&&colHasMerged(ctx,_endC,_curR2,_endR)){var _v15=getColMerge(ctx,_endC,_curR2,_endR)[0];if(!lodash_default().isNil(_v15)){_endC=_v15;}}_endC+=index;}else if(_cf===_curC2&&_cf===_endC){if(index>0){_endC+=index;}else{_curC2+=index;}}}if(_endC>=_datacolumnlen){_endC=_datacolumnlen-1;}if(_endC<0){_endC=0;}if(_curC2>=_datacolumnlen){_curC2=_datacolumnlen-1;}if(_curC2<0){_curC2=0;}}var _rowseleted=[_curR2,_endR];var _columnseleted=[_curC2,_endC];row=ctx.visibledatarow[_endR];row_pre=_curR2-1===-1?0:ctx.visibledatarow[_curR2-1];col=ctx.visibledatacolumn[_endC];col_pre=_curC2-1===-1?0:ctx.visibledatacolumn[_curC2-1];var top=row_pre;var height=row-row_pre-1;var left=col_pre;var width=col-col_pre-1;var _changeparam2=mergeMoveMain(ctx,_columnseleted,_rowseleted,_last2,top,height,left,width);if(!lodash_default().isNil(_changeparam2)){var _changeparam3=index_esm_slicedToArray(_changeparam2,6);_columnseleted=_changeparam3[0];_rowseleted=_changeparam3[1];top=_changeparam3[2];height=_changeparam3[3];left=_changeparam3[4];width=_changeparam3[5];}ctx.formulaCache.func_selectedrange={left:left,width:width,top:top,height:height,left_move:left,width_move:width,top_move:top,height_move:height,row:_rowseleted,column:_columnseleted,row_focus:_rf,column_focus:_cf};}}function getHtmlBorderStyle(type,color){var style="";var borderType={"0":"none","1":"Thin","2":"Hair","3":"Dotted","4":"Dashed","5":"DashDot","6":"DashDotDot","7":"Double","8":"Medium","9":"MediumDashed","10":"MediumDashDot","11":"MediumDashDotDot","12":"SlantedDashDot","13":"Thick"};type=borderType[type.toString()];if(type.indexOf("Medium")>-1){style+="1pt ";}else if(type==="Thick"){style+="1.5pt ";}else{style+="0.5pt ";}if(type==="Hair"){style+="double ";}else if(type.indexOf("DashDotDot")>-1){style+="dotted ";}else if(type.indexOf("DashDot")>-1){style+="dashed ";}else if(type.indexOf("Dotted")>-1){style+="dotted ";}else if(type.indexOf("Dashed")>-1){style+="dashed ";}else{style+="solid ";}return"".concat(style+color,";");}function rangeValueToHtml(ctx,sheetId,ranges){var _sheet$config;var idx=getSheetIndex(ctx,sheetId);if(idx==null)return"";var sheet=ctx.luckysheetfile[idx];var rowIndexArr=[];var colIndexArr=[];for(var s=0;s<((_ranges$length=ranges===null||ranges===void 0?void 0:ranges.length)!==null&&_ranges$length!==void 0?_ranges$length:0);s+=1){var _ranges$length;var range=ranges[s];var r1=range.row[0];var r2=range.row[1];var c1=range.column[0];var c2=range.column[1];for(var copyR=r1;copyR<=r2;copyR+=1){if(!rowIndexArr.includes(copyR)){rowIndexArr.push(copyR);}for(var copyC=c1;copyC<=c2;copyC+=1){if(!colIndexArr.includes(copyC)){colIndexArr.push(copyC);}}}}var borderInfoCompute;if(((_sheet$config=sheet.config)===null||_sheet$config===void 0?void 0:_sheet$config.borderInfo)&&sheet.config.borderInfo.length>0){borderInfoCompute=getBorderInfoCompute(ctx,sheetId);}var cpdata="";var d=sheet.data;if(!d)return null;var colgroup="";for(var i=0;i<rowIndexArr.length;i+=1){var r=rowIndexArr[i];cpdata+="<tr>";for(var j=0;j<colIndexArr.length;j+=1){var _d$r;var c=colIndexArr[j];var column='<td ${span} style="${style}">';var cell=(_d$r=d[r])===null||_d$r===void 0?void 0:_d$r[c];if(cell!=null){var style="";var span="";if(r===rowIndexArr[0]){if(lodash_default().isNil(sheet.config)||lodash_default().isNil(sheet.config.columnlen)||lodash_default().isNil(sheet.config.columnlen[c.toString()])){colgroup+='<colgroup width="72px"></colgroup>';}else{colgroup+="<colgroup width=\"".concat(sheet.config.columnlen[c.toString()],"px\"></colgroup>");}}if(c===colIndexArr[0]){if(lodash_default().isNil(sheet.config)||lodash_default().isNil(sheet.config.rowlen)||lodash_default().isNil(sheet.config.rowlen[r.toString()])){style+="height:19px;";}else{style+="height:".concat(sheet.config.rowlen[r.toString()],"px;");}}var reg=/^(w|W)((0?)|(0\.0+))$/;var c_value=void 0;if(!lodash_default().isNil(cell.ct)&&!lodash_default().isNil(cell.ct.fa)&&cell.ct.fa.match(reg)){c_value=getCellValue(r,c,d);}else{c_value=getCellValue(r,c,d,"m");}var styleObj=getStyleByCell(ctx,d,r,c);style+=lodash_default().map(styleObj,function(v,key){return"".concat(lodash_default().kebabCase(key),":").concat(lodash_default().isNumber(v)?"".concat(v,"px"):v,";");}).join("");if(cell.mc){if("rs"in cell.mc){span="rowspan=\"".concat(cell.mc.rs,"\" colspan=\"").concat(cell.mc.cs,"\"");if(borderInfoCompute&&borderInfoCompute["".concat(r,"_").concat(c)]){(function(){var bl_obj={color:{},style:{}};var br_obj={color:{},style:{}};var bt_obj={color:{},style:{}};var bb_obj={color:{},style:{}};for(var bd_r=r;bd_r<r+cell.mc.rs;bd_r+=1){for(var bd_c=c;bd_c<c+cell.mc.cs;bd_c+=1){if(bd_r===r&&borderInfoCompute["".concat(bd_r,"_").concat(bd_c)]&&borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].t){var linetype=borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].t.style;var bcolor=borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].t.color;if(lodash_default().isNil(bt_obj.style[linetype])){bt_obj.style[linetype]=1;}else{bt_obj.style[linetype]+=1;}if(lodash_default().isNil(bt_obj.color[bcolor])){bt_obj.color[bcolor]=1;}else{bt_obj.color[bcolor]+=1;}}if(bd_r===r+cell.mc.rs-1&&borderInfoCompute["".concat(bd_r,"_").concat(bd_c)]&&borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].b){var _linetype=borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].b.style;var _bcolor=borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].b.color;if(lodash_default().isNil(bb_obj.style[_linetype])){bb_obj.style[_linetype]=1;}else{bb_obj.style[_linetype]+=1;}if(lodash_default().isNil(bb_obj.color[_bcolor])){bb_obj.color[_bcolor]=1;}else{bb_obj.color[_bcolor]+=1;}}if(bd_c===c&&borderInfoCompute["".concat(bd_r,"_").concat(bd_c)]&&borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].l){var _linetype2=borderInfoCompute["".concat(r,"_").concat(c)].l.style;var _bcolor2=borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].l.color;if(lodash_default().isNil(bl_obj.style[_linetype2])){bl_obj.style[_linetype2]=1;}else{bl_obj.style[_linetype2]+=1;}if(lodash_default().isNil(bl_obj.color[_bcolor2])){bl_obj.color[_bcolor2]=1;}else{bl_obj.color[_bcolor2]+=1;}}if(bd_c===c+cell.mc.cs-1&&borderInfoCompute["".concat(bd_r,"_").concat(bd_c)]&&borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].r){var _linetype3=borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].r.style;var _bcolor3=borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].r.color;if(lodash_default().isNil(br_obj.style[_linetype3])){br_obj.style[_linetype3]=1;}else{br_obj.style[_linetype3]+=1;}if(lodash_default().isNil(br_obj.color[_bcolor3])){br_obj.color[_bcolor3]=1;}else{br_obj.color[_bcolor3]+=1;}}}}var rowlen=cell.mc.rs;var collen=cell.mc.cs;if(JSON.stringify(bl_obj).length>23){var bl_color=null;var bl_style=null;Object.keys(bl_obj.color).forEach(function(x){if(bl_obj.color[x]>=rowlen/2){bl_color=x;}});Object.keys(bl_obj.style).forEach(function(x){if(bl_obj.style[x]>=rowlen/2){bl_style=x;}});if(!lodash_default().isNil(bl_color)&&!lodash_default().isNil(bl_style)){style+="border-left:".concat(getHtmlBorderStyle(bl_style,bl_color));}}if(JSON.stringify(br_obj).length>23){var br_color=null;var br_style=null;Object.keys(br_obj.color).forEach(function(x){if(br_obj.color[x]>=rowlen/2){br_color=x;}});Object.keys(br_obj.style).forEach(function(x){if(br_obj.style[x]>=rowlen/2){br_style=x;}});if(!lodash_default().isNil(br_color)&&!lodash_default().isNil(br_style)){style+="border-right:".concat(getHtmlBorderStyle(br_style,br_color));}}if(JSON.stringify(bt_obj).length>23){var bt_color=null;var bt_style=null;Object.keys(bt_obj.color).forEach(function(x){if(bt_obj.color[x]>=collen/2){bt_color=x;}});Object.keys(bt_obj.style).forEach(function(x){if(bt_obj.style[x]>=collen/2){bt_style=x;}});if(!lodash_default().isNil(bt_color)&&!lodash_default().isNil(bt_style)){style+="border-top:".concat(getHtmlBorderStyle(bt_style,bt_color));}}if(JSON.stringify(bb_obj).length>23){var bb_color=null;var bb_style=null;Object.keys(bb_obj.color).forEach(function(x){if(bb_obj.color[x]>=collen/2){bb_color=x;}});Object.keys(bb_obj.style).forEach(function(x){if(bb_obj.style[x]>=collen/2){bb_style=x;}});if(!lodash_default().isNil(bb_color)&&!lodash_default().isNil(bb_style)){style+="border-bottom:".concat(getHtmlBorderStyle(bb_style,bb_color));}}})();}}else{continue;}}else{if(borderInfoCompute&&borderInfoCompute["".concat(r,"_").concat(c)]){if(borderInfoCompute["".concat(r,"_").concat(c)].l){var linetype=borderInfoCompute["".concat(r,"_").concat(c)].l.style;var bcolor=borderInfoCompute["".concat(r,"_").concat(c)].l.color;style+="border-left:".concat(getHtmlBorderStyle(linetype,bcolor));}if(borderInfoCompute["".concat(r,"_").concat(c)].r){var _linetype4=borderInfoCompute["".concat(r,"_").concat(c)].r.style;var _bcolor4=borderInfoCompute["".concat(r,"_").concat(c)].r.color;style+="border-right:".concat(getHtmlBorderStyle(_linetype4,_bcolor4));}if(borderInfoCompute["".concat(r,"_").concat(c)].b){var _linetype5=borderInfoCompute["".concat(r,"_").concat(c)].b.style;var _bcolor5=borderInfoCompute["".concat(r,"_").concat(c)].b.color;style+="border-bottom:".concat(getHtmlBorderStyle(_linetype5,_bcolor5));}if(borderInfoCompute["".concat(r,"_").concat(c)].t){var _linetype6=borderInfoCompute["".concat(r,"_").concat(c)].t.style;var _bcolor6=borderInfoCompute["".concat(r,"_").concat(c)].t.color;style+="border-top:".concat(getHtmlBorderStyle(_linetype6,_bcolor6));}}}column=replaceHtml(column,{style:style,span:span});if(lodash_default().isNil(c_value)){c_value=getCellValue(r,c,d);}if(lodash_default().isNil(c_value)){c_value="";}column+=escapeHTMLTag(c_value);}else{var _style="";if(borderInfoCompute&&borderInfoCompute["".concat(r,"_").concat(c)]){if(borderInfoCompute["".concat(r,"_").concat(c)].l){var _linetype7=borderInfoCompute["".concat(r,"_").concat(c)].l.style;var _bcolor7=borderInfoCompute["".concat(r,"_").concat(c)].l.color;_style+="border-left:".concat(getHtmlBorderStyle(_linetype7,_bcolor7));}if(borderInfoCompute["".concat(r,"_").concat(c)].r){var _linetype8=borderInfoCompute["".concat(r,"_").concat(c)].r.style;var _bcolor8=borderInfoCompute["".concat(r,"_").concat(c)].r.color;_style+="border-right:".concat(getHtmlBorderStyle(_linetype8,_bcolor8));}if(borderInfoCompute["".concat(r,"_").concat(c)].b){var _linetype9=borderInfoCompute["".concat(r,"_").concat(c)].b.style;var _bcolor9=borderInfoCompute["".concat(r,"_").concat(c)].b.color;_style+="border-bottom:".concat(getHtmlBorderStyle(_linetype9,_bcolor9));}if(borderInfoCompute["".concat(r,"_").concat(c)].t){var _linetype10=borderInfoCompute["".concat(r,"_").concat(c)].t.style;var _bcolor10=borderInfoCompute["".concat(r,"_").concat(c)].t.color;_style+="border-top:".concat(getHtmlBorderStyle(_linetype10,_bcolor10));}}column+="";if(r===rowIndexArr[0]){if(lodash_default().isNil(sheet.config)||lodash_default().isNil(sheet.config.columnlen)||lodash_default().isNil(sheet.config.columnlen[c.toString()])){colgroup+='<colgroup width="72px"></colgroup>';}else{colgroup+="<colgroup width=\"".concat(sheet.config.columnlen[c.toString()],"px\"></colgroup>");}}if(c===colIndexArr[0]){if(lodash_default().isNil(sheet.config)||lodash_default().isNil(sheet.config.rowlen)||lodash_default().isNil(sheet.config.rowlen[r.toString()])){_style+="height:19px;";}else{_style+="height:".concat(sheet.config.rowlen[r.toString()],"px;");}}column=replaceHtml(column,{style:_style,span:""});column+="";}column+="</td>";cpdata+=column;}cpdata+="</tr>";}return"<table data-type=\"fortune-copy-action-table\">".concat(colgroup).concat(cpdata,"</table>");}function copy(ctx){var flowdata=getFlowdata(ctx);ctx.luckysheet_selection_range=[];var copyRange=[];var RowlChange=false;var HasMC=false;for(var s=0;s<((_ctx$luckysheet_selec2=(_ctx$luckysheet_selec3=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec3===void 0?void 0:_ctx$luckysheet_selec3.length)!==null&&_ctx$luckysheet_selec2!==void 0?_ctx$luckysheet_selec2:0);s+=1){var _ctx$luckysheet_selec2,_ctx$luckysheet_selec3;var range=ctx.luckysheet_select_save[s];var r1=range.row[0];var r2=range.row[1];var c1=range.column[0];var c2=range.column[1];for(var copyR=r1;copyR<=r2;copyR+=1){if(!lodash_default().isNil(ctx.config.rowhidden)&&!lodash_default().isNil(ctx.config.rowhidden[copyR])){continue;}if(!lodash_default().isNil(ctx.config.rowlen)&&copyR in ctx.config.rowlen){RowlChange=true;}for(var copyC=c1;copyC<=c2;copyC+=1){var _flowdata$copyR,_cell$mc;if(!lodash_default().isNil(ctx.config.colhidden)&&!lodash_default().isNil(ctx.config.colhidden[copyC])){continue;}var cell=flowdata===null||flowdata===void 0?void 0:(_flowdata$copyR=flowdata[copyR])===null||_flowdata$copyR===void 0?void 0:_flowdata$copyR[copyC];if(!lodash_default().isNil(cell===null||cell===void 0?void 0:(_cell$mc=cell.mc)===null||_cell$mc===void 0?void 0:_cell$mc.rs)){HasMC=true;}}}ctx.luckysheet_selection_range.push({row:range.row,column:range.column});copyRange.push({row:range.row,column:range.column});}ctx.luckysheet_copy_save={dataSheetId:ctx.currentSheetId,copyRange:copyRange,RowlChange:RowlChange,HasMC:HasMC};var cpdata=rangeValueToHtml(ctx,ctx.currentSheetId,ctx.luckysheet_select_save);if(cpdata){ctx.iscopyself=true;clipboard.writeHtml(cpdata);}}function deleteSelectedCellText(ctx){var allowEdit=isAllowEdit(ctx);if(allowEdit===false){return"allowEdit";}var selection=ctx.luckysheet_select_save;if(selection&&!lodash_default().isEmpty(selection)){var d=getFlowdata(ctx);if(!d)return"dataNullError";var has_PartMC=false;for(var s=0;s<selection.length;s+=1){var r1=selection[s].row[0];var r2=selection[s].row[1];var c1=selection[s].column[0];var c2=selection[s].column[1];if(hasPartMC(ctx,ctx.config,r1,r2,c1,c2)){has_PartMC=true;break;}}if(has_PartMC){return"partMC";}var hyperlinkMap=ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)].hyperlink;for(var _s=0;_s<selection.length;_s+=1){var _r3=selection[_s].row[0];var _r4=selection[_s].row[1];var _c3=selection[_s].column[0];var _c4=selection[_s].column[1];for(var r=_r3;r<=_r4;r+=1){for(var c=_c3;c<=_c4;c+=1){if(lodash_default().isPlainObject(d[r][c])){var cell=d[r][c];delete cell.m;delete cell.v;if(cell.f!=null){delete cell.f;delFunctionGroup(ctx,r,c,ctx.currentSheetId);delete cell.spl;}if(cell.ct!=null&&cell.ct.t==="inlineStr"){delete cell.ct;}}else{d[r][c]=null;}if(hyperlinkMap&&hyperlinkMap["".concat(r,"_").concat(c)]){delete hyperlinkMap["".concat(r,"_").concat(c)];}}}}}return"success";}function selectIsOverlap(ctx,range){if(range==null){range=ctx.luckysheet_select_save;}range=lodash_default().cloneDeep(range);var overlap=false;var map={};for(var s=0;s<range.length;s+=1){var str_r=range[s].row[0];var end_r=range[s].row[1];var str_c=range[s].column[0];var end_c=range[s].column[1];for(var r=str_r;r<=end_r;r+=1){for(var c=str_c;c<=end_c;c+=1){if("".concat(r,"_").concat(c)in map){overlap=true;break;}else{map["".concat(r,"_").concat(c)]=0;}}}}return overlap;}function selectAll(ctx){var flowdata=getFlowdata(ctx);if(!flowdata)return;ctx.luckysheet_select_status=false;ctx.luckysheet_select_save=[{row:[0,flowdata.length-1],column:[0,flowdata[0].length-1],row_focus:0,column_focus:0,row_select:true,column_select:true}];normalizeSelection(ctx,ctx.luckysheet_select_save);}function fixRowStyleOverflowInFreeze(ctx,r1,r2,freeze){var _freeze$horizontal;if(!freeze)return{};var ret={};var scrollTop=ctx.scrollTop;var freezenhorizontaldata=(_freeze$horizontal=freeze.horizontal)===null||_freeze$horizontal===void 0?void 0:_freeze$horizontal.freezenhorizontaldata;var rangeshow=true;if(freezenhorizontaldata!=null){var freezenTop=freezenhorizontaldata[0];var freezen_rowindex=freezenhorizontaldata[1];var offTop=scrollTop-freezenhorizontaldata[2];var row=ctx.visibledatarow[r2];var row_pre=r1-1===-1?0:ctx.visibledatarow[r1-1];var top_move=row_pre;var height_move=row-row_pre-1;if(r1>=freezen_rowindex){if(top_move+height_move<freezenTop+offTop){rangeshow=false;}else if(top_move<freezenTop+offTop){ret.top=freezenTop+offTop;ret.height=height_move-(freezenTop+offTop-top_move);}else;}else if(r2>=freezen_rowindex){if(top_move+height_move<freezenTop+offTop){ret.top=top_move+offTop;ret.height=freezenTop-top_move;}else{ret.top=top_move+offTop;ret.height=height_move-offTop;}}else{ret.top=top_move+offTop;}}if(!rangeshow){ret.display="none";}return ret;}function fixColumnStyleOverflowInFreeze(ctx,c1,c2,freeze){var _freeze$vertical;if(!freeze)return{};var ret={};var scrollLeft=ctx.scrollLeft;var freezenverticaldata=(_freeze$vertical=freeze.vertical)===null||_freeze$vertical===void 0?void 0:_freeze$vertical.freezenverticaldata;var rangeshow=true;if(freezenverticaldata!=null){var freezenLeft=freezenverticaldata[0];var freezen_colindex=freezenverticaldata[1];var offLeft=scrollLeft-freezenverticaldata[2];var col=ctx.visibledatacolumn[c2];var col_pre=c1-1===-1?0:ctx.visibledatacolumn[c1-1];var left_move=col_pre;var width_move=col-col_pre-1;if(c1>=freezen_colindex){if(left_move+width_move<freezenLeft+offLeft){rangeshow=false;}else if(left_move<freezenLeft+offLeft){ret.left=freezenLeft+offLeft;ret.width=width_move-(freezenLeft+offLeft-left_move);}else;}else if(c2>=freezen_colindex){if(left_move+width_move<freezenLeft+offLeft){ret.left=left_move+offLeft;ret.width=freezenLeft-left_move;}else{ret.left=left_move+offLeft;ret.width=width_move-offLeft;}}else{ret.left=left_move+offLeft;}}if(!rangeshow){ret.display="none";}return ret;}function calcSelectionInfo(ctx,lang){var selection=ctx.luckysheet_select_save;var numberC=0;var count=0;var sum=0;var max=-Infinity;var min=Infinity;for(var s=0;s<selection.length;s+=1){var data=getDataBySelectionNoCopy(ctx,selection[s]);for(var r=0;r<data.length;r+=1){for(var c=0;c<data[0].length;c+=1){var _data$r$c,_data$r$c$ct,_data$r$c2;if(r>=data.length||c>=data[0].length)break;var ct=(_data$r$c=data[r][c])===null||_data$r$c===void 0?void 0:(_data$r$c$ct=_data$r$c.ct)===null||_data$r$c$ct===void 0?void 0:_data$r$c$ct.t;var value=(_data$r$c2=data[r][c])===null||_data$r$c2===void 0?void 0:_data$r$c2.m;if(ct==="n"||ct==="g"&&parseFloat(value).toString()!=="NaN"){var valueNumber=parseFloat(value);count+=1;sum+=valueNumber;max=Math.max(valueNumber,max);min=Math.min(valueNumber,min);numberC+=1;}else if(value!=null){count+=1;}}}}var formatString=lang&&!["zh","zh_tw"].includes(lang)?"0.00":"w0.00";var average=SSF.format(formatString,sum/numberC);sum=SSF.format(formatString,sum);max=SSF.format(formatString,max);min=SSF.format(formatString,min);return{numberC:numberC,count:count,sum:sum,max:max,min:min,average:average};}function defaultContext(refs){return{luckysheetfile:[],defaultcolumnNum:60,defaultrowNum:84,addDefaultRows:50,fullscreenmode:true,devicePixelRatio:(globalThis||window).devicePixelRatio,contextMenu:{},sheetTabContextMenu:{},currentSheetId:"",calculateSheetId:"",config:{},warnDialog:undefined,currency:"¥",rangeDialog:{show:false,rangeTxt:"",type:"",singleSelect:false},dataVerification:{selectStatus:false,selectRange:[],optionLabel_en:{number:"numeric",number_integer:"integer",number_decimal:"decimal",between:"between",notBetween:"not between",equal:"equal to",notEqualTo:"not equal to",moreThanThe:"greater",lessThan:"less than",greaterOrEqualTo:"greater or equal to",lessThanOrEqualTo:"less than or equal to",include:"include",exclude:"not include",earlierThan:"earlier than",noEarlierThan:"not earlier than",laterThan:"later than",noLaterThan:"not later than",identificationNumber:"identification number",phoneNumber:"phone number"},optionLabel_hi:{number:"संख्यात्मक",number_integer:"पूर्णांक",number_decimal:"दशमलव",between:"के बीच",notBetween:"के बीच नहीं",equal:"के बराबर",notEqualTo:"के बराबर नहीं",moreThanThe:"से अधिक",lessThan:"से कम",greaterOrEqualTo:"के बराबर या अधिक",lessThanOrEqualTo:"के बराबर या कम",include:"शामिल",exclude:"शामिल नहीं",earlierThan:"से पहले",noEarlierThan:"से पहले नहीं",laterThan:"के बाद",noLaterThan:"के बाद नहीं",identificationNumber:"पहचान संख्या",phoneNumber:"फोन नंबर"},optionLabel_zh:{number:"数值",number_integer:"整数",number_decimal:"小数",between:"介于",notBetween:"不介于",equal:"等于",notEqualTo:"不等于",moreThanThe:"大于",lessThan:"小于",greaterOrEqualTo:"大于等于",lessThanOrEqualTo:"小于等于",include:"包括",exclude:"不包括",earlierThan:"早于",noEarlierThan:"不早于",laterThan:"晚于",noLaterThan:"不晚于",identificationNumber:"身份证号码",phoneNumber:"手机号"},optionLabel_zh_tw:{number:"數位",number_integer:"數位-整數",number_decimal:"數位-小數",between:"介於",notBetween:"不介於",equal:"等於",notEqualTo:"不等於",moreThanThe:"大於",lessThan:"小於",greaterOrEqualTo:"大於等於",lessThanOrEqualTo:"小於等於",include:"包括",exclude:"不包括",earlierThan:"早於",noEarlierThan:"不早於",laterThan:"晚於",noLaterThan:"不晚於",identificationNumber:"身份證號碼",phoneNumber:"手機號"},optionLabel_es:{number:"Número",number_integer:"Número entero",number_decimal:"Número decimal",between:"Entre",notBetween:"No entre",equal:"Iqual",notEqualTo:"No iqual a",moreThanThe:"Más que el",lessThan:"Menos que",greaterOrEqualTo:"Mayor o igual a",lessThanOrEqualTo:"Menor o igual a",include:"Incluir",exclude:"Excluir",earlierThan:"Antes de",noEarlierThan:"No antes de",laterThan:"Después de",noLaterThan:"No después de",identificationNumber:"Número de identificación",phoneNumber:"Número de teléfono"},dataRegulation:{type:"",type2:"",rangeTxt:"",value1:"",value2:"",validity:"",remote:false,prohibitInput:false,hintShow:false,hintValue:""}},dataVerificationDropDownList:false,conditionRules:{rulesType:"",rulesValue:"",textColor:{check:true,color:"#000000"},cellColor:{check:true,color:"#000000"},betweenValue:{value1:"",value2:""},dateValue:"",repeatValue:"0",projectValue:"10"},visibledatarow:[],visibledatacolumn:[],ch_width:0,rh_height:0,cellmainWidth:0,cellmainHeight:0,toolbarHeight:41,infobarHeight:57,calculatebarHeight:29,rowHeaderWidth:46,columnHeaderHeight:20,cellMainSrollBarSize:12,sheetBarHeight:31,statisticBarHeight:23,luckysheetTableContentHW:[0,0],defaultcollen:73,defaultrowlen:19,scrollLeft:0,scrollTop:0,sheetScrollRecord:{},luckysheet_select_status:false,luckysheet_select_save:undefined,luckysheet_selection_range:[],formulaRangeHighlight:[],formulaRangeSelect:undefined,functionCandidates:[],functionHint:null,luckysheet_copy_save:undefined,luckysheet_paste_iscut:false,filterchage:true,filter:{},luckysheet_sheet_move_status:false,luckysheet_sheet_move_data:[],luckysheet_scroll_status:false,luckysheetcurrentisPivotTable:false,luckysheet_rows_selected_status:false,luckysheet_cols_selected_status:false,luckysheet_rows_change_size:false,luckysheet_rows_change_size_start:[],luckysheet_cols_change_size:false,luckysheet_cols_change_size_start:[],luckysheet_cols_freeze_drag:false,luckysheet_rows_freeze_drag:false,luckysheetCellUpdate:[],luckysheet_shiftkeydown:false,luckysheet_shiftpositon:undefined,iscopyself:true,activeImg:undefined,orderbyindex:0,luckysheet_model_move_state:false,luckysheet_model_xy:[0,0],luckysheet_model_move_obj:null,luckysheet_cell_selected_move:false,luckysheet_cell_selected_move_index:[],luckysheet_cell_selected_extend:false,luckysheet_cell_selected_extend_index:[],lang:null,chart_selection:{},zoomRatio:1,showGridLines:true,allowEdit:true,fontList:[],defaultFontSize:10,luckysheetPaintModelOn:false,luckysheetPaintSingle:false,defaultCell:{bl:0,ct:{fa:"General",t:"n"},fc:"rgb(51, 51, 51)",ff:0,fs:11,ht:1,it:0,vt:1,m:"",v:""},groupValuesRefreshData:[],formulaCache:new FormulaCache(),hooks:{},getRefs:function getRefs(){return refs;}};}function getFlowdata(ctx,id){var _ctx$luckysheetfile,_ctx$luckysheetfile$i;if(!ctx)return null;var i=getSheetIndex(ctx,id||ctx.currentSheetId);if(lodash_default().isNil(i)){return null;}return(_ctx$luckysheetfile=ctx.luckysheetfile)===null||_ctx$luckysheetfile===void 0?void 0:(_ctx$luckysheetfile$i=_ctx$luckysheetfile[i])===null||_ctx$luckysheetfile$i===void 0?void 0:_ctx$luckysheetfile$i.data;}function calcRowColSize(ctx,rowCount,colCount){ctx.visibledatarow=[];ctx.rh_height=0;for(var r=0;r<rowCount;r+=1){var _ctx$config$rowlen,_ctx$config2,_ctx$config2$rowhidde;var rowlen=ctx.defaultrowlen;if((_ctx$config$rowlen=ctx.config.rowlen)===null||_ctx$config$rowlen===void 0?void 0:_ctx$config$rowlen[r]){var _ctx$config,_ctx$config$rowlen2;rowlen=(_ctx$config=ctx.config)===null||_ctx$config===void 0?void 0:(_ctx$config$rowlen2=_ctx$config.rowlen)===null||_ctx$config$rowlen2===void 0?void 0:_ctx$config$rowlen2[r];}if(((_ctx$config2=ctx.config)===null||_ctx$config2===void 0?void 0:(_ctx$config2$rowhidde=_ctx$config2.rowhidden)===null||_ctx$config2$rowhidde===void 0?void 0:_ctx$config2$rowhidde[r])!=null){ctx.visibledatarow.push(ctx.rh_height);continue;}ctx.rh_height+=Math.round((rowlen+1)*ctx.zoomRatio);ctx.visibledatarow.push(ctx.rh_height);}ctx.rh_height+=80;ctx.visibledatacolumn=[];ctx.ch_width=0;var maxColumnlen=120;var flowdata=getFlowdata(ctx);for(var c=0;c<colCount;c+=1){var _ctx$config3,_ctx$config3$columnle,_ctx$config5,_ctx$config5$colhidde;var firstcolumnlen=ctx.defaultcollen;if((_ctx$config3=ctx.config)===null||_ctx$config3===void 0?void 0:(_ctx$config3$columnle=_ctx$config3.columnlen)===null||_ctx$config3$columnle===void 0?void 0:_ctx$config3$columnle[c]){firstcolumnlen=ctx.config.columnlen[c];}else{var _flowdata$;if(flowdata===null||flowdata===void 0?void 0:(_flowdata$=flowdata[0])===null||_flowdata$===void 0?void 0:_flowdata$[c]){if(firstcolumnlen>300){firstcolumnlen=300;}else if(firstcolumnlen<ctx.defaultcollen){firstcolumnlen=ctx.defaultcollen;}if(firstcolumnlen!==ctx.defaultcollen){var _ctx$config4;if(!((_ctx$config4=ctx.config)===null||_ctx$config4===void 0?void 0:_ctx$config4.columnlen)){ctx.config.columnlen={};}ctx.config.columnlen[c]=firstcolumnlen;}}}if(((_ctx$config5=ctx.config)===null||_ctx$config5===void 0?void 0:(_ctx$config5$colhidde=_ctx$config5.colhidden)===null||_ctx$config5$colhidde===void 0?void 0:_ctx$config5$colhidde[c])!=null){ctx.visibledatacolumn.push(ctx.ch_width);continue;}ctx.ch_width+=Math.round((firstcolumnlen+1)*ctx.zoomRatio);ctx.visibledatacolumn.push(ctx.ch_width);}ctx.ch_width+=maxColumnlen;}function ensureSheetIndex(data,generateSheetId){if((data===null||data===void 0?void 0:data.length)>0){var hasActive=false;var indexs=[];data.forEach(function(item){if(item.id==null){item.id=generateSheetId();}if(indexs.includes(item.id)){item.id=generateSheetId();}else{indexs.push(item.id);}if(item.status==null){item.status=0;}if(item.status===1){if(hasActive){item.status=0;}else{hasActive=true;}}});if(!hasActive){data[0].status=1;}}}function initSheetIndex(ctx){var shownSheets=ctx.luckysheetfile.filter(function(singleSheet){return lodash_default().isUndefined(singleSheet.hide)||singleSheet.hide!==1;});ctx.currentSheetId=lodash_default().sortBy(shownSheets,function(sheet){return sheet.order;})[0].id;for(var i=0;i<ctx.luckysheetfile.length;i+=1){if(ctx.luckysheetfile[i].status===1&&ctx.luckysheetfile[i].hide!==1){ctx.currentSheetId=ctx.luckysheetfile[i].id;break;}}}function updateContextWithSheetData(ctx,data){var rowCount=data.length;var colCount=rowCount===0?0:data[0].length;calcRowColSize(ctx,rowCount,colCount);normalizeSelection(ctx,ctx.luckysheet_select_save);}function updateContextWithCanvas(ctx,canvas,placeholder){ctx.luckysheetTableContentHW=[placeholder.clientWidth,placeholder.clientHeight];ctx.cellmainHeight=placeholder.clientHeight-ctx.columnHeaderHeight;ctx.cellmainWidth=placeholder.clientWidth-ctx.rowHeaderWidth;canvas.style.width="".concat(ctx.luckysheetTableContentHW[0],"px");canvas.style.height="".concat(ctx.luckysheetTableContentHW[1],"px");canvas.width=Math.ceil(ctx.luckysheetTableContentHW[0]*ctx.devicePixelRatio);canvas.height=Math.ceil(ctx.luckysheetTableContentHW[1]*ctx.devicePixelRatio);}function getBorderInfoComputeRange(ctx,dataset_row_st,dataset_row_ed,dataset_col_st,dataset_col_ed,sheetId){var borderInfoCompute={};var flowdata=getFlowdata(ctx);var cfg;var data;if(!sheetId){cfg=ctx.config;data=flowdata;}else{var index=getSheetIndex(ctx,sheetId);if(!lodash_default().isNil(index)){cfg=ctx.luckysheetfile[index].config;data=ctx.luckysheetfile[index].data;}else{return borderInfoCompute;}}if(!data||!cfg)return borderInfoCompute;var _cfg=cfg,borderInfo=_cfg.borderInfo;if(!borderInfo||lodash_default().isEmpty(borderInfo))return borderInfoCompute;for(var i=0;i<borderInfo.length;i+=1){var rangeType=borderInfo[i].rangeType;if(rangeType==="range"){var borderType=borderInfo[i].borderType;var borderColor=borderInfo[i].color;var borderStyle=borderInfo[i].style;var borderRange=borderInfo[i].range;var _loop=function _loop(j){var bd_r1=borderRange[j].row[0];var bd_r2=borderRange[j].row[1];var bd_c1=borderRange[j].column[0];var bd_c2=borderRange[j].column[1];if(bd_r1<dataset_row_st){bd_r1=dataset_row_st;}if(bd_r2>dataset_row_ed){bd_r2=dataset_row_ed;}if(bd_c1<dataset_col_st){bd_c1=dataset_col_st;}if(bd_c2>dataset_col_ed){bd_c2=dataset_col_ed;}if(borderType==="border-slash"){var bd_r=borderRange[0].row_focus;var bd_c=borderRange[0].column_focus;if(!lodash_default().isNil(cfg.rowhidden)&&!lodash_default().isNil(cfg.rowhidden[bd_r])){return"continue";}if(bd_c<dataset_col_st||bd_c>dataset_col_ed)return"continue";if(bd_r<dataset_row_st||bd_r>dataset_row_ed)return"continue";if(borderInfoCompute["".concat(bd_r,"_").concat(bd_c)]===undefined){borderInfoCompute["".concat(bd_r,"_").concat(bd_c)]={};}borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].s={color:borderColor,style:borderStyle};}if(borderType==="border-left"){var _loop2=function _loop2(_bd_r){if(!lodash_default().isNil(cfg.rowhidden)&&!lodash_default().isNil(cfg.rowhidden[_bd_r])){return"continue";}if(borderInfoCompute["".concat(_bd_r,"_").concat(bd_c1)]===undefined){borderInfoCompute["".concat(_bd_r,"_").concat(bd_c1)]={};}borderInfoCompute["".concat(_bd_r,"_").concat(bd_c1)].l={color:borderColor,style:borderStyle};var bd_c_left=bd_c1-1;if(bd_c_left>=0&&borderInfoCompute["".concat(_bd_r,"_").concat(bd_c_left)]){var _data$_bd_r,_data$_bd_r$bd_c_left;if(!lodash_default().isNil((_data$_bd_r=data[_bd_r])===null||_data$_bd_r===void 0?void 0:(_data$_bd_r$bd_c_left=_data$_bd_r[bd_c_left])===null||_data$_bd_r$bd_c_left===void 0?void 0:_data$_bd_r$bd_c_left.mc)){var _cfg$merge,_cell_left$mc,_cell_left$mc2;var cell_left=data[_bd_r][bd_c_left];var _mc=(_cfg$merge=cfg.merge)===null||_cfg$merge===void 0?void 0:_cfg$merge["".concat(cell_left===null||cell_left===void 0?void 0:(_cell_left$mc=cell_left.mc)===null||_cell_left$mc===void 0?void 0:_cell_left$mc.r,"_").concat(cell_left===null||cell_left===void 0?void 0:(_cell_left$mc2=cell_left.mc)===null||_cell_left$mc2===void 0?void 0:_cell_left$mc2.c)];if(_mc&&_mc.c+_mc.cs-1===bd_c_left){borderInfoCompute["".concat(_bd_r,"_").concat(bd_c_left)].r={color:borderColor,style:borderStyle};}}else{borderInfoCompute["".concat(_bd_r,"_").concat(bd_c_left)].r={color:borderColor,style:borderStyle};}}var mc=cfg.merge||{};Object.keys(mc).forEach(function(key){var _mc$key=mc[key],c=_mc$key.c,r=_mc$key.r,cs=_mc$key.cs,rs=_mc$key.rs;if(bd_c1<=c+cs-1&&bd_c1>c&&_bd_r>=r&&_bd_r<=r+rs-1){borderInfoCompute["".concat(_bd_r,"_").concat(bd_c1)].l=null;}});};for(var _bd_r=bd_r1;_bd_r<=bd_r2;_bd_r+=1){var _ret2=_loop2(_bd_r);if(_ret2==="continue")continue;}}else if(borderType==="border-right"){var _loop3=function _loop3(_bd_r2){if(!lodash_default().isNil(cfg.rowhidden)&&!lodash_default().isNil(cfg.rowhidden[_bd_r2])){return"continue";}if(borderInfoCompute["".concat(_bd_r2,"_").concat(bd_c2)]===undefined){borderInfoCompute["".concat(_bd_r2,"_").concat(bd_c2)]={};}borderInfoCompute["".concat(_bd_r2,"_").concat(bd_c2)].r={color:borderColor,style:borderStyle};var bd_c_right=bd_c2+1;if(bd_c_right<data[0].length&&borderInfoCompute["".concat(_bd_r2,"_").concat(bd_c_right)]){var _data$_bd_r2,_data$_bd_r2$bd_c_rig;if(!lodash_default().isNil((_data$_bd_r2=data[_bd_r2])===null||_data$_bd_r2===void 0?void 0:(_data$_bd_r2$bd_c_rig=_data$_bd_r2[bd_c_right])===null||_data$_bd_r2$bd_c_rig===void 0?void 0:_data$_bd_r2$bd_c_rig.mc)){var _cfg$merge2,_cell_right$mc,_cell_right$mc2;var cell_right=data[_bd_r2][bd_c_right];var _mc2=(_cfg$merge2=cfg.merge)===null||_cfg$merge2===void 0?void 0:_cfg$merge2["".concat(cell_right===null||cell_right===void 0?void 0:(_cell_right$mc=cell_right.mc)===null||_cell_right$mc===void 0?void 0:_cell_right$mc.r,"_").concat(cell_right===null||cell_right===void 0?void 0:(_cell_right$mc2=cell_right.mc)===null||_cell_right$mc2===void 0?void 0:_cell_right$mc2.c)];if(_mc2&&_mc2.c===bd_c_right){borderInfoCompute["".concat(_bd_r2,"_").concat(bd_c_right)].l={color:borderColor,style:borderStyle};}}else{borderInfoCompute["".concat(_bd_r2,"_").concat(bd_c_right)].l={color:borderColor,style:borderStyle};}}var mc=cfg.merge||{};Object.keys(mc).forEach(function(key){var _mc$key2=mc[key],c=_mc$key2.c,r=_mc$key2.r,cs=_mc$key2.cs,rs=_mc$key2.rs;if(bd_c2<c+cs-1&&bd_c2>=c&&_bd_r2>=r&&_bd_r2<=r+rs-1){borderInfoCompute["".concat(_bd_r2,"_").concat(bd_c2)].r=null;}});};for(var _bd_r2=bd_r1;_bd_r2<=bd_r2;_bd_r2+=1){var _ret3=_loop3(_bd_r2);if(_ret3==="continue")continue;}}else if(borderType==="border-top"){if(!lodash_default().isNil(cfg.rowhidden)&&!lodash_default().isNil(cfg.rowhidden[bd_r1])){return"continue";}var _loop4=function _loop4(_bd_c){if(borderInfoCompute["".concat(bd_r1,"_").concat(_bd_c)]===undefined){borderInfoCompute["".concat(bd_r1,"_").concat(_bd_c)]={};}borderInfoCompute["".concat(bd_r1,"_").concat(_bd_c)].t={color:borderColor,style:borderStyle};var bd_r_top=bd_r1-1;if(bd_r_top>=0&&borderInfoCompute["".concat(bd_r_top,"_").concat(_bd_c)]){var _data$bd_r_top,_data$bd_r_top$_bd_c;if(!lodash_default().isNil((_data$bd_r_top=data[bd_r_top])===null||_data$bd_r_top===void 0?void 0:(_data$bd_r_top$_bd_c=_data$bd_r_top[_bd_c])===null||_data$bd_r_top$_bd_c===void 0?void 0:_data$bd_r_top$_bd_c.mc)){var _cfg$merge3,_cell_top$mc,_cell_top$mc2;var cell_top=data[bd_r_top][_bd_c];var _mc3=(_cfg$merge3=cfg.merge)===null||_cfg$merge3===void 0?void 0:_cfg$merge3["".concat(cell_top===null||cell_top===void 0?void 0:(_cell_top$mc=cell_top.mc)===null||_cell_top$mc===void 0?void 0:_cell_top$mc.r,"_").concat(cell_top===null||cell_top===void 0?void 0:(_cell_top$mc2=cell_top.mc)===null||_cell_top$mc2===void 0?void 0:_cell_top$mc2.c)];if(_mc3&&_mc3.r+_mc3.rs-1===bd_r_top){borderInfoCompute["".concat(bd_r_top,"_").concat(_bd_c)].b={color:borderColor,style:borderStyle};}}else{borderInfoCompute["".concat(bd_r_top,"_").concat(_bd_c)].b={color:borderColor,style:borderStyle};}}var mc=cfg.merge||{};Object.keys(mc).forEach(function(key){var _mc$key3=mc[key],c=_mc$key3.c,r=_mc$key3.r,cs=_mc$key3.cs,rs=_mc$key3.rs;if(bd_r1<=r+rs-1&&bd_r1>r&&_bd_c>=c&&_bd_c<=c+cs-1){borderInfoCompute["".concat(bd_r1,"_").concat(_bd_c)].t=null;}});};for(var _bd_c=bd_c1;_bd_c<=bd_c2;_bd_c+=1){_loop4(_bd_c);}}else if(borderType==="border-bottom"){if(!lodash_default().isNil(cfg.rowhidden)&&!lodash_default().isNil(cfg.rowhidden[bd_r2])){return"continue";}var _loop5=function _loop5(_bd_c2){if(borderInfoCompute["".concat(bd_r2,"_").concat(_bd_c2)]===undefined){borderInfoCompute["".concat(bd_r2,"_").concat(_bd_c2)]={};}borderInfoCompute["".concat(bd_r2,"_").concat(_bd_c2)].b={color:borderColor,style:borderStyle};var bd_r_bottom=bd_r2+1;if(bd_r_bottom<data.length&&borderInfoCompute["".concat(bd_r_bottom,"_").concat(_bd_c2)]){var _data$bd_r_bottom,_data$bd_r_bottom$_bd;if(!lodash_default().isNil((_data$bd_r_bottom=data[bd_r_bottom])===null||_data$bd_r_bottom===void 0?void 0:(_data$bd_r_bottom$_bd=_data$bd_r_bottom[_bd_c2])===null||_data$bd_r_bottom$_bd===void 0?void 0:_data$bd_r_bottom$_bd.mc)){var _cfg$merge4,_cell_bottom$mc,_cell_bottom$mc2;var cell_bottom=data[bd_r_bottom][_bd_c2];var _mc4=(_cfg$merge4=cfg.merge)===null||_cfg$merge4===void 0?void 0:_cfg$merge4["".concat(cell_bottom===null||cell_bottom===void 0?void 0:(_cell_bottom$mc=cell_bottom.mc)===null||_cell_bottom$mc===void 0?void 0:_cell_bottom$mc.r,"_").concat(cell_bottom===null||cell_bottom===void 0?void 0:(_cell_bottom$mc2=cell_bottom.mc)===null||_cell_bottom$mc2===void 0?void 0:_cell_bottom$mc2.c)];if((_mc4===null||_mc4===void 0?void 0:_mc4.r)===bd_r_bottom){borderInfoCompute["".concat(bd_r_bottom,"_").concat(_bd_c2)].t={color:borderColor,style:borderStyle};}}else{borderInfoCompute["".concat(bd_r_bottom,"_").concat(_bd_c2)].t={color:borderColor,style:borderStyle};}}var mc=cfg.merge||{};Object.keys(mc).forEach(function(key){var _mc$key4=mc[key],c=_mc$key4.c,r=_mc$key4.r,cs=_mc$key4.cs,rs=_mc$key4.rs;if(bd_r2<r+rs-1&&bd_r2>=r&&_bd_c2>=c&&_bd_c2<=c+cs-1){borderInfoCompute["".concat(bd_r2,"_").concat(_bd_c2)].b=null;}});};for(var _bd_c2=bd_c1;_bd_c2<=bd_c2;_bd_c2+=1){_loop5(_bd_c2);}}else if(borderType==="border-all"){for(var _bd_r3=bd_r1;_bd_r3<=bd_r2;_bd_r3+=1){if(!lodash_default().isNil(cfg.rowhidden)&&!lodash_default().isNil(cfg.rowhidden[_bd_r3])){continue;}for(var _bd_c3=bd_c1;_bd_c3<=bd_c2;_bd_c3+=1){var _data$_bd_r3,_data$_bd_r3$_bd_c;if(!lodash_default().isNil((_data$_bd_r3=data[_bd_r3])===null||_data$_bd_r3===void 0?void 0:(_data$_bd_r3$_bd_c=_data$_bd_r3[_bd_c3])===null||_data$_bd_r3$_bd_c===void 0?void 0:_data$_bd_r3$_bd_c.mc)){var _cfg$merge5,_cell$mc,_cell$mc2;var cell=data[_bd_r3][_bd_c3];var mc=(_cfg$merge5=cfg.merge)===null||_cfg$merge5===void 0?void 0:_cfg$merge5["".concat(cell===null||cell===void 0?void 0:(_cell$mc=cell.mc)===null||_cell$mc===void 0?void 0:_cell$mc.r,"_").concat(cell===null||cell===void 0?void 0:(_cell$mc2=cell.mc)===null||_cell$mc2===void 0?void 0:_cell$mc2.c)];if((mc===null||mc===void 0?void 0:mc.r)===_bd_r3){if(borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)]===undefined){borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)]={};}borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)].t={color:borderColor,style:borderStyle};}if(mc&&mc.r+mc.rs-1===_bd_r3){if(borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)]===undefined){borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)]={};}borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)].b={color:borderColor,style:borderStyle};}if((mc===null||mc===void 0?void 0:mc.c)===_bd_c3){if(borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)]===undefined){borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)]={};}borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)].l={color:borderColor,style:borderStyle};}if(mc&&mc.c+mc.cs-1===_bd_c3){if(borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)]===undefined){borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)]={};}borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)].r={color:borderColor,style:borderStyle};}}else{if(borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)]===undefined){borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)]={};}borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)].l={color:borderColor,style:borderStyle};borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)].r={color:borderColor,style:borderStyle};borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)].t={color:borderColor,style:borderStyle};borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)].b={color:borderColor,style:borderStyle};}if(_bd_r3===bd_r1){var bd_r_top=bd_r1-1;if(bd_r_top>=0&&borderInfoCompute["".concat(bd_r_top,"_").concat(_bd_c3)]){var _data$bd_r_top2,_data$bd_r_top2$_bd_c;if(!lodash_default().isNil((_data$bd_r_top2=data[bd_r_top])===null||_data$bd_r_top2===void 0?void 0:(_data$bd_r_top2$_bd_c=_data$bd_r_top2[_bd_c3])===null||_data$bd_r_top2$_bd_c===void 0?void 0:_data$bd_r_top2$_bd_c.mc)){var _cfg$merge6,_cell_top$mc3,_cell_top$mc4;var cell_top=data[bd_r_top][_bd_c3];var _mc5=(_cfg$merge6=cfg.merge)===null||_cfg$merge6===void 0?void 0:_cfg$merge6["".concat(cell_top===null||cell_top===void 0?void 0:(_cell_top$mc3=cell_top.mc)===null||_cell_top$mc3===void 0?void 0:_cell_top$mc3.r,"_").concat(cell_top===null||cell_top===void 0?void 0:(_cell_top$mc4=cell_top.mc)===null||_cell_top$mc4===void 0?void 0:_cell_top$mc4.c)];if(_mc5&&_mc5.r+_mc5.rs-1===bd_r_top){borderInfoCompute["".concat(bd_r_top,"_").concat(_bd_c3)].b={color:borderColor,style:borderStyle};}}else{borderInfoCompute["".concat(bd_r_top,"_").concat(_bd_c3)].b={color:borderColor,style:borderStyle};}}}if(_bd_r3===bd_r2){var bd_r_bottom=bd_r2+1;if(bd_r_bottom<data.length&&borderInfoCompute["".concat(bd_r_bottom,"_").concat(_bd_c3)]){var _data$bd_r_bottom2,_data$bd_r_bottom2$_b;if(!lodash_default().isNil((_data$bd_r_bottom2=data[bd_r_bottom])===null||_data$bd_r_bottom2===void 0?void 0:(_data$bd_r_bottom2$_b=_data$bd_r_bottom2[_bd_c3])===null||_data$bd_r_bottom2$_b===void 0?void 0:_data$bd_r_bottom2$_b.mc)){var _cfg$merge7,_cell_bottom$mc3,_cell_bottom$mc4;var cell_bottom=data[bd_r_bottom][_bd_c3];var _mc6=(_cfg$merge7=cfg.merge)===null||_cfg$merge7===void 0?void 0:_cfg$merge7["".concat(cell_bottom===null||cell_bottom===void 0?void 0:(_cell_bottom$mc3=cell_bottom.mc)===null||_cell_bottom$mc3===void 0?void 0:_cell_bottom$mc3.r,"_").concat(cell_bottom===null||cell_bottom===void 0?void 0:(_cell_bottom$mc4=cell_bottom.mc)===null||_cell_bottom$mc4===void 0?void 0:_cell_bottom$mc4.c)];if((_mc6===null||_mc6===void 0?void 0:_mc6.r)===bd_r_bottom){borderInfoCompute["".concat(bd_r_bottom,"_").concat(_bd_c3)].t={color:borderColor,style:borderStyle};}}else{borderInfoCompute["".concat(bd_r_bottom,"_").concat(_bd_c3)].t={color:borderColor,style:borderStyle};}}}if(_bd_c3===bd_c1){var bd_c_left=bd_c1-1;if(bd_c_left>=0&&borderInfoCompute["".concat(_bd_r3,"_").concat(bd_c_left)]){var _data$_bd_r4,_data$_bd_r4$bd_c_lef;if(!lodash_default().isNil((_data$_bd_r4=data[_bd_r3])===null||_data$_bd_r4===void 0?void 0:(_data$_bd_r4$bd_c_lef=_data$_bd_r4[bd_c_left])===null||_data$_bd_r4$bd_c_lef===void 0?void 0:_data$_bd_r4$bd_c_lef.mc)){var _cfg$merge8,_cell_left$mc3,_cell_left$mc4;var cell_left=data[_bd_r3][bd_c_left];var _mc7=(_cfg$merge8=cfg.merge)===null||_cfg$merge8===void 0?void 0:_cfg$merge8["".concat(cell_left===null||cell_left===void 0?void 0:(_cell_left$mc3=cell_left.mc)===null||_cell_left$mc3===void 0?void 0:_cell_left$mc3.r,"_").concat(cell_left===null||cell_left===void 0?void 0:(_cell_left$mc4=cell_left.mc)===null||_cell_left$mc4===void 0?void 0:_cell_left$mc4.c)];if(_mc7&&_mc7.c+_mc7.cs-1===bd_c_left){borderInfoCompute["".concat(_bd_r3,"_").concat(bd_c_left)].r={color:borderColor,style:borderStyle};}}else{borderInfoCompute["".concat(_bd_r3,"_").concat(bd_c_left)].r={color:borderColor,style:borderStyle};}}}if(_bd_c3===bd_c2){var bd_c_right=bd_c2+1;if(bd_c_right<data[0].length&&borderInfoCompute["".concat(_bd_r3,"_").concat(bd_c_right)]){var _data$_bd_r5,_data$_bd_r5$bd_c_rig;if(!lodash_default().isNil((_data$_bd_r5=data[_bd_r3])===null||_data$_bd_r5===void 0?void 0:(_data$_bd_r5$bd_c_rig=_data$_bd_r5[bd_c_right])===null||_data$_bd_r5$bd_c_rig===void 0?void 0:_data$_bd_r5$bd_c_rig.mc)){var _cfg$merge9,_cell_right$mc3,_cell_right$mc4;var cell_right=data[_bd_r3][bd_c_right];var _mc8=(_cfg$merge9=cfg.merge)===null||_cfg$merge9===void 0?void 0:_cfg$merge9["".concat(cell_right===null||cell_right===void 0?void 0:(_cell_right$mc3=cell_right.mc)===null||_cell_right$mc3===void 0?void 0:_cell_right$mc3.r,"_").concat(cell_right===null||cell_right===void 0?void 0:(_cell_right$mc4=cell_right.mc)===null||_cell_right$mc4===void 0?void 0:_cell_right$mc4.c)];if((_mc8===null||_mc8===void 0?void 0:_mc8.c)===bd_c_right){borderInfoCompute["".concat(_bd_r3,"_").concat(bd_c_right)].l={color:borderColor,style:borderStyle};}}else{borderInfoCompute["".concat(_bd_r3,"_").concat(bd_c_right)].l={color:borderColor,style:borderStyle};}}}}}}else if(borderType==="border-outside"){for(var _bd_r4=bd_r1;_bd_r4<=bd_r2;_bd_r4+=1){if(!lodash_default().isNil(cfg.rowhidden)&&!lodash_default().isNil(cfg.rowhidden[_bd_r4])){continue;}for(var _bd_c4=bd_c1;_bd_c4<=bd_c2;_bd_c4+=1){if(!(_bd_r4===bd_r1||_bd_r4===bd_r2||_bd_c4===bd_c1||_bd_c4===bd_c2)){continue;}if(_bd_r4===bd_r1){if(borderInfoCompute["".concat(_bd_r4,"_").concat(_bd_c4)]===undefined){borderInfoCompute["".concat(_bd_r4,"_").concat(_bd_c4)]={};}borderInfoCompute["".concat(_bd_r4,"_").concat(_bd_c4)].t={color:borderColor,style:borderStyle};var _bd_r_top=bd_r1-1;if(_bd_r_top>=0&&borderInfoCompute["".concat(_bd_r_top,"_").concat(_bd_c4)]){var _data$_bd_r_top,_data$_bd_r_top$_bd_c;if(!lodash_default().isNil((_data$_bd_r_top=data[_bd_r_top])===null||_data$_bd_r_top===void 0?void 0:(_data$_bd_r_top$_bd_c=_data$_bd_r_top[_bd_c4])===null||_data$_bd_r_top$_bd_c===void 0?void 0:_data$_bd_r_top$_bd_c.mc)){var _cfg$merge10,_cell_top$mc5,_cell_top$mc6;var _cell_top=data[_bd_r_top][_bd_c4];var _mc9=(_cfg$merge10=cfg.merge)===null||_cfg$merge10===void 0?void 0:_cfg$merge10["".concat(_cell_top===null||_cell_top===void 0?void 0:(_cell_top$mc5=_cell_top.mc)===null||_cell_top$mc5===void 0?void 0:_cell_top$mc5.r,"_").concat(_cell_top===null||_cell_top===void 0?void 0:(_cell_top$mc6=_cell_top.mc)===null||_cell_top$mc6===void 0?void 0:_cell_top$mc6.c)];if(_mc9&&_mc9.r+_mc9.rs-1===_bd_r_top){borderInfoCompute["".concat(_bd_r_top,"_").concat(_bd_c4)].b={color:borderColor,style:borderStyle};}}else{borderInfoCompute["".concat(_bd_r_top,"_").concat(_bd_c4)].b={color:borderColor,style:borderStyle};}}}if(_bd_r4===bd_r2){if(borderInfoCompute["".concat(_bd_r4,"_").concat(_bd_c4)]===undefined){borderInfoCompute["".concat(_bd_r4,"_").concat(_bd_c4)]={};}borderInfoCompute["".concat(_bd_r4,"_").concat(_bd_c4)].b={color:borderColor,style:borderStyle};var _bd_r_bottom=bd_r2+1;if(_bd_r_bottom<data.length&&borderInfoCompute["".concat(_bd_r_bottom,"_").concat(_bd_c4)]){var _data$_bd_r_bottom,_data$_bd_r_bottom$_b;if(!lodash_default().isNil((_data$_bd_r_bottom=data[_bd_r_bottom])===null||_data$_bd_r_bottom===void 0?void 0:(_data$_bd_r_bottom$_b=_data$_bd_r_bottom[_bd_c4])===null||_data$_bd_r_bottom$_b===void 0?void 0:_data$_bd_r_bottom$_b.mc)){var _cfg$merge11,_cell_bottom$mc5,_cell_bottom$mc6;var _cell_bottom=data[_bd_r_bottom][_bd_c4];var _mc10=(_cfg$merge11=cfg.merge)===null||_cfg$merge11===void 0?void 0:_cfg$merge11["".concat(_cell_bottom===null||_cell_bottom===void 0?void 0:(_cell_bottom$mc5=_cell_bottom.mc)===null||_cell_bottom$mc5===void 0?void 0:_cell_bottom$mc5.r,"_").concat(_cell_bottom===null||_cell_bottom===void 0?void 0:(_cell_bottom$mc6=_cell_bottom.mc)===null||_cell_bottom$mc6===void 0?void 0:_cell_bottom$mc6.c)];if((_mc10===null||_mc10===void 0?void 0:_mc10.r)===_bd_r_bottom){borderInfoCompute["".concat(_bd_r_bottom,"_").concat(_bd_c4)].t={color:borderColor,style:borderStyle};}}else{borderInfoCompute["".concat(_bd_r_bottom,"_").concat(_bd_c4)].t={color:borderColor,style:borderStyle};}}}if(_bd_c4===bd_c1){if(borderInfoCompute["".concat(_bd_r4,"_").concat(_bd_c4)]===undefined){borderInfoCompute["".concat(_bd_r4,"_").concat(_bd_c4)]={};}borderInfoCompute["".concat(_bd_r4,"_").concat(_bd_c4)].l={color:borderColor,style:borderStyle};var _bd_c_left=bd_c1-1;if(_bd_c_left>=0&&borderInfoCompute["".concat(_bd_r4,"_").concat(_bd_c_left)]){var _data$_bd_r6,_data$_bd_r6$_bd_c_le;if(!lodash_default().isNil((_data$_bd_r6=data[_bd_r4])===null||_data$_bd_r6===void 0?void 0:(_data$_bd_r6$_bd_c_le=_data$_bd_r6[_bd_c_left])===null||_data$_bd_r6$_bd_c_le===void 0?void 0:_data$_bd_r6$_bd_c_le.mc)){var _cfg$merge12,_cell_left$mc5,_cell_left$mc6;var _cell_left=data[_bd_r4][_bd_c_left];var _mc11=(_cfg$merge12=cfg.merge)===null||_cfg$merge12===void 0?void 0:_cfg$merge12["".concat(_cell_left===null||_cell_left===void 0?void 0:(_cell_left$mc5=_cell_left.mc)===null||_cell_left$mc5===void 0?void 0:_cell_left$mc5.r,"_").concat(_cell_left===null||_cell_left===void 0?void 0:(_cell_left$mc6=_cell_left.mc)===null||_cell_left$mc6===void 0?void 0:_cell_left$mc6.c)];if(_mc11&&_mc11.c+_mc11.cs-1===_bd_c_left){borderInfoCompute["".concat(_bd_r4,"_").concat(_bd_c_left)].r={color:borderColor,style:borderStyle};}}else{borderInfoCompute["".concat(_bd_r4,"_").concat(_bd_c_left)].r={color:borderColor,style:borderStyle};}}}if(_bd_c4===bd_c2){if(borderInfoCompute["".concat(_bd_r4,"_").concat(_bd_c4)]===undefined){borderInfoCompute["".concat(_bd_r4,"_").concat(_bd_c4)]={};}borderInfoCompute["".concat(_bd_r4,"_").concat(_bd_c4)].r={color:borderColor,style:borderStyle};var _bd_c_right=bd_c2+1;if(_bd_c_right<data[0].length&&borderInfoCompute["".concat(_bd_r4,"_").concat(_bd_c_right)]){var _data$_bd_r7,_data$_bd_r7$_bd_c_ri;if(!lodash_default().isNil((_data$_bd_r7=data[_bd_r4])===null||_data$_bd_r7===void 0?void 0:(_data$_bd_r7$_bd_c_ri=_data$_bd_r7[_bd_c_right])===null||_data$_bd_r7$_bd_c_ri===void 0?void 0:_data$_bd_r7$_bd_c_ri.mc)){var _cfg$merge13,_cell_right$mc5,_cell_right$mc6;var _cell_right=data[_bd_r4][_bd_c_right];var _mc12=(_cfg$merge13=cfg.merge)===null||_cfg$merge13===void 0?void 0:_cfg$merge13["".concat(_cell_right===null||_cell_right===void 0?void 0:(_cell_right$mc5=_cell_right.mc)===null||_cell_right$mc5===void 0?void 0:_cell_right$mc5.r,"_").concat(_cell_right===null||_cell_right===void 0?void 0:(_cell_right$mc6=_cell_right.mc)===null||_cell_right$mc6===void 0?void 0:_cell_right$mc6.c)];if((_mc12===null||_mc12===void 0?void 0:_mc12.c)===_bd_c_right){borderInfoCompute["".concat(_bd_r4,"_").concat(_bd_c_right)].l={color:borderColor,style:borderStyle};}}else{borderInfoCompute["".concat(_bd_r4,"_").concat(_bd_c_right)].l={color:borderColor,style:borderStyle};}}}}}}else if(borderType==="border-inside"){for(var _bd_r5=bd_r1;_bd_r5<=bd_r2;_bd_r5+=1){if(!lodash_default().isNil(cfg.rowhidden)&&!lodash_default().isNil(cfg.rowhidden[_bd_r5])){continue;}for(var _bd_c5=bd_c1;_bd_c5<=bd_c2;_bd_c5+=1){if(_bd_r5===bd_r1&&_bd_c5===bd_c1){var _data$_bd_r8,_data$_bd_r8$_bd_c;if(!lodash_default().isNil((_data$_bd_r8=data[_bd_r5])===null||_data$_bd_r8===void 0?void 0:(_data$_bd_r8$_bd_c=_data$_bd_r8[_bd_c5])===null||_data$_bd_r8$_bd_c===void 0?void 0:_data$_bd_r8$_bd_c.mc));else{if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}if(!_bd_r5===bd_r2){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].r={color:borderColor,style:borderStyle};}if(!_bd_c5===bd_c2){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].b={color:borderColor,style:borderStyle};}}}else if(_bd_r5===bd_r2&&_bd_c5===bd_c1){var _data$_bd_r9,_data$_bd_r9$_bd_c;if(!lodash_default().isNil((_data$_bd_r9=data[_bd_r5])===null||_data$_bd_r9===void 0?void 0:(_data$_bd_r9$_bd_c=_data$_bd_r9[_bd_c5])===null||_data$_bd_r9$_bd_c===void 0?void 0:_data$_bd_r9$_bd_c.mc));else{if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}if(!_bd_r5===bd_r2){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].r={color:borderColor,style:borderStyle};}borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].t={color:borderColor,style:borderStyle};}}else if(_bd_r5===bd_r1&&_bd_c5===bd_c2){var _data$_bd_r10,_data$_bd_r10$_bd_c;if(!lodash_default().isNil((_data$_bd_r10=data[_bd_r5])===null||_data$_bd_r10===void 0?void 0:(_data$_bd_r10$_bd_c=_data$_bd_r10[_bd_c5])===null||_data$_bd_r10$_bd_c===void 0?void 0:_data$_bd_r10$_bd_c.mc));else{if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].l={color:borderColor,style:borderStyle};if(!_bd_c5===bd_c2){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].b={color:borderColor,style:borderStyle};}}}else if(_bd_r5===bd_r2&&_bd_c5===bd_c2){var _data$_bd_r11,_data$_bd_r11$_bd_c;if(!lodash_default().isNil((_data$_bd_r11=data[_bd_r5])===null||_data$_bd_r11===void 0?void 0:(_data$_bd_r11$_bd_c=_data$_bd_r11[_bd_c5])===null||_data$_bd_r11$_bd_c===void 0?void 0:_data$_bd_r11$_bd_c.mc));else{if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].l={color:borderColor,style:borderStyle};borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].t={color:borderColor,style:borderStyle};}}else if(_bd_r5===bd_r1){var _data$_bd_r12,_data$_bd_r12$_bd_c;if(!lodash_default().isNil((_data$_bd_r12=data[_bd_r5])===null||_data$_bd_r12===void 0?void 0:(_data$_bd_r12$_bd_c=_data$_bd_r12[_bd_c5])===null||_data$_bd_r12$_bd_c===void 0?void 0:_data$_bd_r12$_bd_c.mc)){var _cfg$merge14,_cell$mc3,_cell$mc4;var _cell=data[_bd_r5][_bd_c5];var _mc13=(_cfg$merge14=cfg.merge)===null||_cfg$merge14===void 0?void 0:_cfg$merge14["".concat(_cell===null||_cell===void 0?void 0:(_cell$mc3=_cell.mc)===null||_cell$mc3===void 0?void 0:_cell$mc3.r,"_").concat(_cell===null||_cell===void 0?void 0:(_cell$mc4=_cell.mc)===null||_cell$mc4===void 0?void 0:_cell$mc4.c)];if((_mc13===null||_mc13===void 0?void 0:_mc13.c)===_bd_c5){if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].l={color:borderColor,style:borderStyle};}else if(_mc13&&_mc13.c+_mc13.cs-1===_bd_c5){if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}if(!_bd_r5===bd_r2){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].r={color:borderColor,style:borderStyle};}}}else{if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].l={color:borderColor,style:borderStyle};if(!_bd_r5===bd_r2){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].r={color:borderColor,style:borderStyle};}if(!_bd_c5===bd_c2){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].b={color:borderColor,style:borderStyle};}}}else if(_bd_r5===bd_r2){var _data$_bd_r13,_data$_bd_r13$_bd_c;if(!lodash_default().isNil((_data$_bd_r13=data[_bd_r5])===null||_data$_bd_r13===void 0?void 0:(_data$_bd_r13$_bd_c=_data$_bd_r13[_bd_c5])===null||_data$_bd_r13$_bd_c===void 0?void 0:_data$_bd_r13$_bd_c.mc)){var _cfg$merge15,_cell2$mc,_cell2$mc2;var _cell2=data[_bd_r5][_bd_c5];var _mc14=(_cfg$merge15=cfg.merge)===null||_cfg$merge15===void 0?void 0:_cfg$merge15["".concat(_cell2===null||_cell2===void 0?void 0:(_cell2$mc=_cell2.mc)===null||_cell2$mc===void 0?void 0:_cell2$mc.r,"_").concat(_cell2===null||_cell2===void 0?void 0:(_cell2$mc2=_cell2.mc)===null||_cell2$mc2===void 0?void 0:_cell2$mc2.c)];if((_mc14===null||_mc14===void 0?void 0:_mc14.c)===_bd_c5){if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].l={color:borderColor,style:borderStyle};}else if(_mc14&&_mc14.c+_mc14.cs-1===_bd_c5){if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}if(!_bd_r5===bd_r2){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].r={color:borderColor,style:borderStyle};}}}else{if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].l={color:borderColor,style:borderStyle};if(!_bd_r5===bd_r2){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].r={color:borderColor,style:borderStyle};}borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].t={color:borderColor,style:borderStyle};}}else if(_bd_c5===bd_c1){var _data$_bd_r14,_data$_bd_r14$_bd_c;if(!lodash_default().isNil((_data$_bd_r14=data[_bd_r5])===null||_data$_bd_r14===void 0?void 0:(_data$_bd_r14$_bd_c=_data$_bd_r14[_bd_c5])===null||_data$_bd_r14$_bd_c===void 0?void 0:_data$_bd_r14$_bd_c.mc)){var _cfg$merge16,_cell3$mc,_cell3$mc2;var _cell3=data[_bd_r5][_bd_c5];var _mc15=(_cfg$merge16=cfg.merge)===null||_cfg$merge16===void 0?void 0:_cfg$merge16["".concat(_cell3===null||_cell3===void 0?void 0:(_cell3$mc=_cell3.mc)===null||_cell3$mc===void 0?void 0:_cell3$mc.r,"_").concat(_cell3===null||_cell3===void 0?void 0:(_cell3$mc2=_cell3.mc)===null||_cell3$mc2===void 0?void 0:_cell3$mc2.c)];if((_mc15===null||_mc15===void 0?void 0:_mc15.r)===_bd_r5){if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].t={color:borderColor,style:borderStyle};}else if(_mc15&&_mc15.r+_mc15.rs-1===_bd_r5){if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}if(!_bd_c5===bd_c2){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].b={color:borderColor,style:borderStyle};}}}else{if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}if(!_bd_r5===bd_r2){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].r={color:borderColor,style:borderStyle};}borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].t={color:borderColor,style:borderStyle};if(!_bd_c5===bd_c2){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].b={color:borderColor,style:borderStyle};}}}else if(_bd_c5===bd_c2){var _data$_bd_r15,_data$_bd_r15$_bd_c;if(!lodash_default().isNil((_data$_bd_r15=data[_bd_r5])===null||_data$_bd_r15===void 0?void 0:(_data$_bd_r15$_bd_c=_data$_bd_r15[_bd_c5])===null||_data$_bd_r15$_bd_c===void 0?void 0:_data$_bd_r15$_bd_c.mc)){var _cfg$merge17,_cell4$mc,_cell4$mc2;var _cell4=data[_bd_r5][_bd_c5];var _mc16=(_cfg$merge17=cfg.merge)===null||_cfg$merge17===void 0?void 0:_cfg$merge17["".concat(_cell4===null||_cell4===void 0?void 0:(_cell4$mc=_cell4.mc)===null||_cell4$mc===void 0?void 0:_cell4$mc.r,"_").concat(_cell4===null||_cell4===void 0?void 0:(_cell4$mc2=_cell4.mc)===null||_cell4$mc2===void 0?void 0:_cell4$mc2.c)];if((_mc16===null||_mc16===void 0?void 0:_mc16.r)===_bd_r5){if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].t={color:borderColor,style:borderStyle};}else if(_mc16&&_mc16.r+_mc16.rs-1===_bd_r5){if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}if(!_bd_c5===bd_c2){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].b={color:borderColor,style:borderStyle};}}}else{if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].l={color:borderColor,style:borderStyle};borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].t={color:borderColor,style:borderStyle};if(!_bd_c5===bd_c2){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].b={color:borderColor,style:borderStyle};}}}else{var _data$_bd_r16,_data$_bd_r16$_bd_c;if(!lodash_default().isNil((_data$_bd_r16=data[_bd_r5])===null||_data$_bd_r16===void 0?void 0:(_data$_bd_r16$_bd_c=_data$_bd_r16[_bd_c5])===null||_data$_bd_r16$_bd_c===void 0?void 0:_data$_bd_r16$_bd_c.mc)){var _cfg$merge18,_cell5$mc,_cell5$mc2;var _cell5=data[_bd_r5][_bd_c5];var _mc17=(_cfg$merge18=cfg.merge)===null||_cfg$merge18===void 0?void 0:_cfg$merge18["".concat(_cell5===null||_cell5===void 0?void 0:(_cell5$mc=_cell5.mc)===null||_cell5$mc===void 0?void 0:_cell5$mc.r,"_").concat(_cell5===null||_cell5===void 0?void 0:(_cell5$mc2=_cell5.mc)===null||_cell5$mc2===void 0?void 0:_cell5$mc2.c)];if((_mc17===null||_mc17===void 0?void 0:_mc17.r)===_bd_r5){if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].t={color:borderColor,style:borderStyle};}else if(_mc17&&_mc17.r+_mc17.rs-1===_bd_r5){if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}if(!_bd_c5===bd_c2){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].b={color:borderColor,style:borderStyle};}}if((_mc17===null||_mc17===void 0?void 0:_mc17.c)===_bd_c5){if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].l={color:borderColor,style:borderStyle};}else if(_mc17&&_mc17.c+_mc17.cs-1===_bd_c5){if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}if(!_bd_r5===bd_r2){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].r={color:borderColor,style:borderStyle};}}}else{if(borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]===undefined){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)]={};}borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].l={color:borderColor,style:borderStyle};if(!_bd_r5===bd_r2){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].r={color:borderColor,style:borderStyle};}borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].t={color:borderColor,style:borderStyle};if(!_bd_c5===bd_c2){borderInfoCompute["".concat(_bd_r5,"_").concat(_bd_c5)].b={color:borderColor,style:borderStyle};}}}}}}else if(borderType==="border-horizontal"){for(var _bd_r6=bd_r1;_bd_r6<=bd_r2;_bd_r6+=1){if(!lodash_default().isNil(cfg.rowhidden)&&!lodash_default().isNil(cfg.rowhidden[_bd_r6])){continue;}for(var _bd_c6=bd_c1;_bd_c6<=bd_c2;_bd_c6+=1){if(_bd_r6===bd_r1){var _data$_bd_r17,_data$_bd_r17$_bd_c;if(!lodash_default().isNil((_data$_bd_r17=data[_bd_r6])===null||_data$_bd_r17===void 0?void 0:(_data$_bd_r17$_bd_c=_data$_bd_r17[_bd_c6])===null||_data$_bd_r17$_bd_c===void 0?void 0:_data$_bd_r17$_bd_c.mc));else{if(borderInfoCompute["".concat(_bd_r6,"_").concat(_bd_c6)]===undefined){borderInfoCompute["".concat(_bd_r6,"_").concat(_bd_c6)]={};}borderInfoCompute["".concat(_bd_r6,"_").concat(_bd_c6)].b={color:borderColor,style:borderStyle};}}else if(_bd_r6===bd_r2){var _data$_bd_r18,_data$_bd_r18$_bd_c;if(!lodash_default().isNil((_data$_bd_r18=data[_bd_r6])===null||_data$_bd_r18===void 0?void 0:(_data$_bd_r18$_bd_c=_data$_bd_r18[_bd_c6])===null||_data$_bd_r18$_bd_c===void 0?void 0:_data$_bd_r18$_bd_c.mc));else{if(borderInfoCompute["".concat(_bd_r6,"_").concat(_bd_c6)]===undefined){borderInfoCompute["".concat(_bd_r6,"_").concat(_bd_c6)]={};}borderInfoCompute["".concat(_bd_r6,"_").concat(_bd_c6)].t={color:borderColor,style:borderStyle};}}else{var _data$_bd_r19,_data$_bd_r19$_bd_c;if(!lodash_default().isNil((_data$_bd_r19=data[_bd_r6])===null||_data$_bd_r19===void 0?void 0:(_data$_bd_r19$_bd_c=_data$_bd_r19[_bd_c6])===null||_data$_bd_r19$_bd_c===void 0?void 0:_data$_bd_r19$_bd_c.mc)){var _cfg$merge19,_cell6$mc,_cell6$mc2;var _cell6=data[_bd_r6][_bd_c6];var _mc18=(_cfg$merge19=cfg.merge)===null||_cfg$merge19===void 0?void 0:_cfg$merge19["".concat(_cell6===null||_cell6===void 0?void 0:(_cell6$mc=_cell6.mc)===null||_cell6$mc===void 0?void 0:_cell6$mc.r,"_").concat(_cell6===null||_cell6===void 0?void 0:(_cell6$mc2=_cell6.mc)===null||_cell6$mc2===void 0?void 0:_cell6$mc2.c)];if((_mc18===null||_mc18===void 0?void 0:_mc18.r)===_bd_r6){if(borderInfoCompute["".concat(_bd_r6,"_").concat(_bd_c6)]===undefined){borderInfoCompute["".concat(_bd_r6,"_").concat(_bd_c6)]={};}borderInfoCompute["".concat(_bd_r6,"_").concat(_bd_c6)].t={color:borderColor,style:borderStyle};}else if(_mc18&&_mc18.r+_mc18.rs-1===_bd_r6){if(borderInfoCompute["".concat(_bd_r6,"_").concat(_bd_c6)]===undefined){borderInfoCompute["".concat(_bd_r6,"_").concat(_bd_c6)]={};}borderInfoCompute["".concat(_bd_r6,"_").concat(_bd_c6)].b={color:borderColor,style:borderStyle};}}else{if(borderInfoCompute["".concat(_bd_r6,"_").concat(_bd_c6)]===undefined){borderInfoCompute["".concat(_bd_r6,"_").concat(_bd_c6)]={};}borderInfoCompute["".concat(_bd_r6,"_").concat(_bd_c6)].t={color:borderColor,style:borderStyle};borderInfoCompute["".concat(_bd_r6,"_").concat(_bd_c6)].b={color:borderColor,style:borderStyle};}}}}}else if(borderType==="border-vertical"){for(var _bd_r7=bd_r1;_bd_r7<=bd_r2;_bd_r7+=1){if(!lodash_default().isNil(cfg.rowhidden)&&!lodash_default().isNil(cfg.rowhidden[_bd_r7])){continue;}for(var _bd_c7=bd_c1;_bd_c7<=bd_c2;_bd_c7+=1){if(_bd_c7===bd_c1){var _data$_bd_r20,_data$_bd_r20$_bd_c;if(!lodash_default().isNil((_data$_bd_r20=data[_bd_r7])===null||_data$_bd_r20===void 0?void 0:(_data$_bd_r20$_bd_c=_data$_bd_r20[_bd_c7])===null||_data$_bd_r20$_bd_c===void 0?void 0:_data$_bd_r20$_bd_c.mc));else{if(borderInfoCompute["".concat(_bd_r7,"_").concat(_bd_c7)]===undefined){borderInfoCompute["".concat(_bd_r7,"_").concat(_bd_c7)]={};}borderInfoCompute["".concat(_bd_r7,"_").concat(_bd_c7)].r={color:borderColor,style:borderStyle};}}else if(_bd_c7===bd_c2){var _data$_bd_r21,_data$_bd_r21$_bd_c;if(!lodash_default().isNil((_data$_bd_r21=data[_bd_r7])===null||_data$_bd_r21===void 0?void 0:(_data$_bd_r21$_bd_c=_data$_bd_r21[_bd_c7])===null||_data$_bd_r21$_bd_c===void 0?void 0:_data$_bd_r21$_bd_c.mc));else{if(borderInfoCompute["".concat(_bd_r7,"_").concat(_bd_c7)]===undefined){borderInfoCompute["".concat(_bd_r7,"_").concat(_bd_c7)]={};}borderInfoCompute["".concat(_bd_r7,"_").concat(_bd_c7)].l={color:borderColor,style:borderStyle};}}else{var _data$_bd_r22,_data$_bd_r22$_bd_c;if(!lodash_default().isNil((_data$_bd_r22=data[_bd_r7])===null||_data$_bd_r22===void 0?void 0:(_data$_bd_r22$_bd_c=_data$_bd_r22[_bd_c7])===null||_data$_bd_r22$_bd_c===void 0?void 0:_data$_bd_r22$_bd_c.mc)){var _cfg$merge20,_cell7$mc,_cell7$mc2;var _cell7=data[_bd_r7][_bd_c7];var _mc19=(_cfg$merge20=cfg.merge)===null||_cfg$merge20===void 0?void 0:_cfg$merge20["".concat(_cell7===null||_cell7===void 0?void 0:(_cell7$mc=_cell7.mc)===null||_cell7$mc===void 0?void 0:_cell7$mc.r,"_").concat(_cell7===null||_cell7===void 0?void 0:(_cell7$mc2=_cell7.mc)===null||_cell7$mc2===void 0?void 0:_cell7$mc2.c)];if((_mc19===null||_mc19===void 0?void 0:_mc19.c)===_bd_c7){if(borderInfoCompute["".concat(_bd_r7,"_").concat(_bd_c7)]===undefined){borderInfoCompute["".concat(_bd_r7,"_").concat(_bd_c7)]={};}borderInfoCompute["".concat(_bd_r7,"_").concat(_bd_c7)].l={color:borderColor,style:borderStyle};}else if(_mc19&&_mc19.c+_mc19.cs-1===_bd_c7){if(borderInfoCompute["".concat(_bd_r7,"_").concat(_bd_c7)]===undefined){borderInfoCompute["".concat(_bd_r7,"_").concat(_bd_c7)]={};}borderInfoCompute["".concat(_bd_r7,"_").concat(_bd_c7)].r={color:borderColor,style:borderStyle};}}else{if(borderInfoCompute["".concat(_bd_r7,"_").concat(_bd_c7)]===undefined){borderInfoCompute["".concat(_bd_r7,"_").concat(_bd_c7)]={};}borderInfoCompute["".concat(_bd_r7,"_").concat(_bd_c7)].l={color:borderColor,style:borderStyle};borderInfoCompute["".concat(_bd_r7,"_").concat(_bd_c7)].r={color:borderColor,style:borderStyle};}}}}}else if(borderType==="border-none"){for(var _bd_r8=bd_r1;_bd_r8<=bd_r2;_bd_r8+=1){if(!lodash_default().isNil(cfg.rowhidden)&&!lodash_default().isNil(cfg.rowhidden[_bd_r8])){continue;}for(var _bd_c8=bd_c1;_bd_c8<=bd_c2;_bd_c8+=1){if(!lodash_default().isNil(borderInfoCompute["".concat(_bd_r8,"_").concat(_bd_c8)])){delete borderInfoCompute["".concat(_bd_r8,"_").concat(_bd_c8)];}if(_bd_r8===bd_r1){var _bd_r_top2=bd_r1-1;if(_bd_r_top2>=0&&borderInfoCompute["".concat(_bd_r_top2,"_").concat(_bd_c8)]){delete borderInfoCompute["".concat(_bd_r_top2,"_").concat(_bd_c8)].b;}}if(_bd_r8===bd_r2){var _bd_r_bottom2=bd_r2+1;if(_bd_r_bottom2<data.length&&borderInfoCompute["".concat(_bd_r_bottom2,"_").concat(_bd_c8)]){delete borderInfoCompute["".concat(_bd_r_bottom2,"_").concat(_bd_c8)].t;}}if(_bd_c8===bd_c1){var _bd_c_left2=bd_c1-1;if(_bd_c_left2>=0&&borderInfoCompute["".concat(_bd_r8,"_").concat(_bd_c_left2)]){delete borderInfoCompute["".concat(_bd_r8,"_").concat(_bd_c_left2)].r;}}if(_bd_c8===bd_c2){var _bd_c_right2=bd_c2+1;if(_bd_c_right2<data[0].length&&borderInfoCompute["".concat(_bd_r8,"_").concat(_bd_c_right2)]){delete borderInfoCompute["".concat(_bd_r8,"_").concat(_bd_c_right2)].l;}}}}}};for(var j=0;j<borderRange.length;j+=1){var _ret=_loop(j);if(_ret==="continue")continue;}}else if(rangeType==="cell"){var value=borderInfo[i].value;var bd_r=value.row_index;var bd_c=value.col_index;if(bd_r<dataset_row_st||bd_r>dataset_row_ed||bd_c<dataset_col_st||bd_c>dataset_col_ed){continue;}if(!lodash_default().isNil(cfg.rowhidden)&&!lodash_default().isNil(cfg.rowhidden[bd_r])){continue;}if(!lodash_default().isNil(value.l)||!lodash_default().isNil(value.r)||!lodash_default().isNil(value.t)||!lodash_default().isNil(value.b)){var _data$bd_r,_data$bd_r$bd_c;if(borderInfoCompute["".concat(bd_r,"_").concat(bd_c)]===undefined){borderInfoCompute["".concat(bd_r,"_").concat(bd_c)]={};}if(!lodash_default().isNil((_data$bd_r=data[bd_r])===null||_data$bd_r===void 0?void 0:(_data$bd_r$bd_c=_data$bd_r[bd_c])===null||_data$bd_r$bd_c===void 0?void 0:_data$bd_r$bd_c.mc)){var _cfg$merge21,_cell$mc5,_cell$mc6;var cell=data[bd_r][bd_c];var mc=(_cfg$merge21=cfg.merge)===null||_cfg$merge21===void 0?void 0:_cfg$merge21["".concat(cell===null||cell===void 0?void 0:(_cell$mc5=cell.mc)===null||_cell$mc5===void 0?void 0:_cell$mc5.r,"_").concat(cell===null||cell===void 0?void 0:(_cell$mc6=cell.mc)===null||_cell$mc6===void 0?void 0:_cell$mc6.c)];if(!lodash_default().isNil(value.l)&&bd_c===(mc===null||mc===void 0?void 0:mc.c)){borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].l={color:value.l.color,style:value.l.style};var bd_c_left=bd_c-1;if(bd_c_left>=0&&borderInfoCompute["".concat(bd_r,"_").concat(bd_c_left)]){var _data$bd_r2,_data$bd_r2$bd_c_left;if(!lodash_default().isNil((_data$bd_r2=data[bd_r])===null||_data$bd_r2===void 0?void 0:(_data$bd_r2$bd_c_left=_data$bd_r2[bd_c_left])===null||_data$bd_r2$bd_c_left===void 0?void 0:_data$bd_r2$bd_c_left.mc)){var _cfg$merge22,_cell_left$mc7,_cell_left$mc8;var cell_left=data[bd_r][bd_c_left];var mc_l=(_cfg$merge22=cfg.merge)===null||_cfg$merge22===void 0?void 0:_cfg$merge22["".concat(cell_left===null||cell_left===void 0?void 0:(_cell_left$mc7=cell_left.mc)===null||_cell_left$mc7===void 0?void 0:_cell_left$mc7.r,"_").concat(cell_left===null||cell_left===void 0?void 0:(_cell_left$mc8=cell_left.mc)===null||_cell_left$mc8===void 0?void 0:_cell_left$mc8.c)];if(mc_l&&mc_l.c+mc_l.cs-1===bd_c_left){borderInfoCompute["".concat(bd_r,"_").concat(bd_c_left)].r={color:value.l.color,style:value.l.style};}}else{borderInfoCompute["".concat(bd_r,"_").concat(bd_c_left)].r={color:value.l.color,style:value.l.style};}}}else{borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].l=null;}if(!lodash_default().isNil(value.r)&&mc&&bd_c===mc.c+mc.cs-1){borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].r={color:value.r.color,style:value.r.style};var bd_c_right=bd_c+1;if(bd_c_right<data[0].length&&borderInfoCompute["".concat(bd_r,"_").concat(bd_c_right)]){var _data$bd_r3,_data$bd_r3$bd_c_righ;if(!lodash_default().isNil((_data$bd_r3=data[bd_r])===null||_data$bd_r3===void 0?void 0:(_data$bd_r3$bd_c_righ=_data$bd_r3[bd_c_right])===null||_data$bd_r3$bd_c_righ===void 0?void 0:_data$bd_r3$bd_c_righ.mc)){var _cfg$merge23,_cell_right$mc7,_cell_right$mc8;var cell_right=data[bd_r][bd_c_right];var mc_r=(_cfg$merge23=cfg.merge)===null||_cfg$merge23===void 0?void 0:_cfg$merge23["".concat(cell_right===null||cell_right===void 0?void 0:(_cell_right$mc7=cell_right.mc)===null||_cell_right$mc7===void 0?void 0:_cell_right$mc7.r,"_").concat(cell_right===null||cell_right===void 0?void 0:(_cell_right$mc8=cell_right.mc)===null||_cell_right$mc8===void 0?void 0:_cell_right$mc8.c)];if((mc_r===null||mc_r===void 0?void 0:mc_r.c)===bd_c_right){borderInfoCompute["".concat(bd_r,"_").concat(bd_c_right)].l={color:value.r.color,style:value.r.style};}}else{borderInfoCompute["".concat(bd_r,"_").concat(bd_c_right)].l={color:value.r.color,style:value.r.style};}}}else{borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].r=null;}if(!lodash_default().isNil(value.t)&&bd_r===(mc===null||mc===void 0?void 0:mc.r)){borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].t={color:value.t.color,style:value.t.style};var bd_r_top=bd_r-1;if(bd_r_top>=0&&borderInfoCompute["".concat(bd_r_top,"_").concat(bd_c)]){var _data$bd_r_top3,_data$bd_r_top3$bd_c;if(!lodash_default().isNil((_data$bd_r_top3=data[bd_r_top])===null||_data$bd_r_top3===void 0?void 0:(_data$bd_r_top3$bd_c=_data$bd_r_top3[bd_c])===null||_data$bd_r_top3$bd_c===void 0?void 0:_data$bd_r_top3$bd_c.mc)){var _cfg$merge24,_cell_top$mc7,_cell_top$mc8;var cell_top=data[bd_r_top][bd_c];var mc_t=(_cfg$merge24=cfg.merge)===null||_cfg$merge24===void 0?void 0:_cfg$merge24["".concat(cell_top===null||cell_top===void 0?void 0:(_cell_top$mc7=cell_top.mc)===null||_cell_top$mc7===void 0?void 0:_cell_top$mc7.r,"_").concat(cell_top===null||cell_top===void 0?void 0:(_cell_top$mc8=cell_top.mc)===null||_cell_top$mc8===void 0?void 0:_cell_top$mc8.c)];if(mc_t&&mc_t.r+mc_t.rs-1===bd_r_top){borderInfoCompute["".concat(bd_r_top,"_").concat(bd_c)].b={color:value.t.color,style:value.t.style};}}else{borderInfoCompute["".concat(bd_r_top,"_").concat(bd_c)].b={color:value.t.color,style:value.t.style};}}}else{borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].t=null;}if(!lodash_default().isNil(value.b)&&mc&&bd_r===mc.r+mc.rs-1){borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].b={color:value.b.color,style:value.b.style};var bd_r_bottom=bd_r+1;if(bd_r_bottom<data.length&&borderInfoCompute["".concat(bd_r_bottom,"_").concat(bd_c)]){var _data$bd_r_bottom3,_data$bd_r_bottom3$bd;if(!lodash_default().isNil((_data$bd_r_bottom3=data[bd_r_bottom])===null||_data$bd_r_bottom3===void 0?void 0:(_data$bd_r_bottom3$bd=_data$bd_r_bottom3[bd_c])===null||_data$bd_r_bottom3$bd===void 0?void 0:_data$bd_r_bottom3$bd.mc)){var _cfg$merge25,_cell_bottom$mc7,_cell_bottom$mc8;var cell_bottom=data[bd_r_bottom][bd_c];var mc_b=(_cfg$merge25=cfg.merge)===null||_cfg$merge25===void 0?void 0:_cfg$merge25["".concat(cell_bottom===null||cell_bottom===void 0?void 0:(_cell_bottom$mc7=cell_bottom.mc)===null||_cell_bottom$mc7===void 0?void 0:_cell_bottom$mc7.r,"_").concat(cell_bottom===null||cell_bottom===void 0?void 0:(_cell_bottom$mc8=cell_bottom.mc)===null||_cell_bottom$mc8===void 0?void 0:_cell_bottom$mc8.c)];if((mc_b===null||mc_b===void 0?void 0:mc_b.r)===bd_r_bottom){borderInfoCompute["".concat(bd_r_bottom,"_").concat(bd_c)].t={color:value.b.color,style:value.b.style};}}else{borderInfoCompute["".concat(bd_r_bottom,"_").concat(bd_c)].t={color:value.b.color,style:value.b.style};}}}else{borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].b=null;}}else{if(!lodash_default().isNil(value.l)){borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].l={color:value.l.color,style:value.l.style};var _bd_c_left3=bd_c-1;if(_bd_c_left3>=0&&borderInfoCompute["".concat(bd_r,"_").concat(_bd_c_left3)]){var _data$bd_r4,_data$bd_r4$_bd_c_lef;if(!lodash_default().isNil((_data$bd_r4=data[bd_r])===null||_data$bd_r4===void 0?void 0:(_data$bd_r4$_bd_c_lef=_data$bd_r4[_bd_c_left3])===null||_data$bd_r4$_bd_c_lef===void 0?void 0:_data$bd_r4$_bd_c_lef.mc)){var _cfg$merge26,_cell_left2$mc,_cell_left2$mc2;var _cell_left2=data[bd_r][_bd_c_left3];var _mc_l=(_cfg$merge26=cfg.merge)===null||_cfg$merge26===void 0?void 0:_cfg$merge26["".concat(_cell_left2===null||_cell_left2===void 0?void 0:(_cell_left2$mc=_cell_left2.mc)===null||_cell_left2$mc===void 0?void 0:_cell_left2$mc.r,"_").concat(_cell_left2===null||_cell_left2===void 0?void 0:(_cell_left2$mc2=_cell_left2.mc)===null||_cell_left2$mc2===void 0?void 0:_cell_left2$mc2.c)];if(_mc_l&&_mc_l.c+_mc_l.cs-1===_bd_c_left3){borderInfoCompute["".concat(bd_r,"_").concat(_bd_c_left3)].r={color:value.l.color,style:value.l.style};}}else{borderInfoCompute["".concat(bd_r,"_").concat(_bd_c_left3)].r={color:value.l.color,style:value.l.style};}}}else{borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].l=null;}if(!lodash_default().isNil(value.r)){borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].r={color:value.r.color,style:value.r.style};var _bd_c_right3=bd_c+1;if(_bd_c_right3<data[0].length&&borderInfoCompute["".concat(bd_r,"_").concat(_bd_c_right3)]){var _data$bd_r5,_data$bd_r5$_bd_c_rig;if(!lodash_default().isNil(data[bd_r])&&lodash_default().isPlainObject(data[bd_r][_bd_c_right3])&&!lodash_default().isNil((_data$bd_r5=data[bd_r])===null||_data$bd_r5===void 0?void 0:(_data$bd_r5$_bd_c_rig=_data$bd_r5[_bd_c_right3])===null||_data$bd_r5$_bd_c_rig===void 0?void 0:_data$bd_r5$_bd_c_rig.mc)){var _cfg$merge27,_cell_right2$mc,_cell_right2$mc2;var _cell_right2=data[bd_r][_bd_c_right3];var _mc_r=(_cfg$merge27=cfg.merge)===null||_cfg$merge27===void 0?void 0:_cfg$merge27["".concat(_cell_right2===null||_cell_right2===void 0?void 0:(_cell_right2$mc=_cell_right2.mc)===null||_cell_right2$mc===void 0?void 0:_cell_right2$mc.r,"_").concat(_cell_right2===null||_cell_right2===void 0?void 0:(_cell_right2$mc2=_cell_right2.mc)===null||_cell_right2$mc2===void 0?void 0:_cell_right2$mc2.c)];if((_mc_r===null||_mc_r===void 0?void 0:_mc_r.c)===_bd_c_right3){borderInfoCompute["".concat(bd_r,"_").concat(_bd_c_right3)].l={color:value.r.color,style:value.r.style};}}else{borderInfoCompute["".concat(bd_r,"_").concat(_bd_c_right3)].l={color:value.r.color,style:value.r.style};}}}else{borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].r=null;}if(!lodash_default().isNil(value.t)){borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].t={color:value.t.color,style:value.t.style};var _bd_r_top3=bd_r-1;if(_bd_r_top3>=0&&borderInfoCompute["".concat(_bd_r_top3,"_").concat(bd_c)]){var _data$_bd_r_top2,_data$_bd_r_top2$bd_c;if(!lodash_default().isNil((_data$_bd_r_top2=data[_bd_r_top3])===null||_data$_bd_r_top2===void 0?void 0:(_data$_bd_r_top2$bd_c=_data$_bd_r_top2[bd_c])===null||_data$_bd_r_top2$bd_c===void 0?void 0:_data$_bd_r_top2$bd_c.mc)){var _cfg$merge28,_cell_top2$mc,_cell_top2$mc2;var _cell_top2=data[_bd_r_top3][bd_c];var _mc_t=(_cfg$merge28=cfg.merge)===null||_cfg$merge28===void 0?void 0:_cfg$merge28["".concat(_cell_top2===null||_cell_top2===void 0?void 0:(_cell_top2$mc=_cell_top2.mc)===null||_cell_top2$mc===void 0?void 0:_cell_top2$mc.r,"_").concat(_cell_top2===null||_cell_top2===void 0?void 0:(_cell_top2$mc2=_cell_top2.mc)===null||_cell_top2$mc2===void 0?void 0:_cell_top2$mc2.c)];if(_mc_t&&_mc_t.r+_mc_t.rs-1===_bd_r_top3){borderInfoCompute["".concat(_bd_r_top3,"_").concat(bd_c)].b={color:value.t.color,style:value.t.style};}}else{borderInfoCompute["".concat(_bd_r_top3,"_").concat(bd_c)].b={color:value.t.color,style:value.t.style};}}}else{borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].t=null;}if(!lodash_default().isNil(value.b)){borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].b={color:value.b.color,style:value.b.style};var _bd_r_bottom3=bd_r+1;if(_bd_r_bottom3<data.length&&borderInfoCompute["".concat(_bd_r_bottom3,"_").concat(bd_c)]){var _data$_bd_r_bottom2,_data$_bd_r_bottom2$b;if(!lodash_default().isNil((_data$_bd_r_bottom2=data[_bd_r_bottom3])===null||_data$_bd_r_bottom2===void 0?void 0:(_data$_bd_r_bottom2$b=_data$_bd_r_bottom2[bd_c])===null||_data$_bd_r_bottom2$b===void 0?void 0:_data$_bd_r_bottom2$b.mc)){var _cfg$merge29,_cell_bottom2$mc,_cell_bottom2$mc2;var _cell_bottom2=data[_bd_r_bottom3][bd_c];var _mc_b=(_cfg$merge29=cfg.merge)===null||_cfg$merge29===void 0?void 0:_cfg$merge29["".concat(_cell_bottom2===null||_cell_bottom2===void 0?void 0:(_cell_bottom2$mc=_cell_bottom2.mc)===null||_cell_bottom2$mc===void 0?void 0:_cell_bottom2$mc.r,"_").concat(_cell_bottom2===null||_cell_bottom2===void 0?void 0:(_cell_bottom2$mc2=_cell_bottom2.mc)===null||_cell_bottom2$mc2===void 0?void 0:_cell_bottom2$mc2.c)];if((_mc_b===null||_mc_b===void 0?void 0:_mc_b.r)===_bd_r_bottom3){borderInfoCompute["".concat(_bd_r_bottom3,"_").concat(bd_c)].t={color:value.b.color,style:value.b.style};}}else{borderInfoCompute["".concat(_bd_r_bottom3,"_").concat(bd_c)].t={color:value.b.color,style:value.b.style};}}}else{borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].b=null;}}}else{delete borderInfoCompute["".concat(bd_r,"_").concat(bd_c)];}}}return borderInfoCompute;}function getBorderInfoCompute(ctx,sheetId){var borderInfoCompute={};var flowdata=getFlowdata(ctx);var data={};if(sheetId===undefined){data=flowdata;}else{var index=getSheetIndex(ctx,sheetId);if(!lodash_default().isNil(index)){data=ctx.luckysheetfile[index].data;}else{return borderInfoCompute;}}borderInfoCompute=getBorderInfoComputeRange(ctx,0,data.length,0,data[0].length,sheetId);return borderInfoCompute;}function cutVolumn(arr,cutindex){if(cutindex<=0){return arr;}var ret=arr.slice(cutindex);return ret;}function frozenTofreezen(ctx,cache,sheetId){var file=ctx.luckysheetfile[getSheetIndex(ctx,sheetId)];var frozen=file.frozen;if(frozen==null){delete cache.freezen;return;}var freezen={};var range=frozen.range;if(!range){range={row_focus:0,column_focus:0};}var type=frozen.type;if(type==="row"){type="rangeRow";}else if(type==="column"){type="rangeColumn";}else if(type==="both"){type="rangeBoth";}if(type==="rangeRow"||type==="rangeBoth"){var scrollTop=0;var row_st=lodash_default().sortedIndex(ctx.visibledatarow,scrollTop);var _range=range,row_focus=_range.row_focus;if(row_focus>row_st){row_st=row_focus;}if(row_st===-1){row_st=0;}var top=ctx.visibledatarow[row_st]-2-scrollTop+ctx.columnHeaderHeight;var freezenhorizontaldata=[ctx.visibledatarow[row_st],row_st+1,scrollTop,cutVolumn(ctx.visibledatarow,row_st+1),top];freezen.horizontal={freezenhorizontaldata:freezenhorizontaldata,top:top};}if(type==="rangeColumn"||type==="rangeBoth"){var scrollLeft=0;var col_st=lodash_default().sortedIndex(ctx.visibledatacolumn,scrollLeft);var _range2=range,column_focus=_range2.column_focus;if(column_focus>col_st){col_st=column_focus;}if(col_st===-1){col_st=0;}var left=ctx.visibledatacolumn[col_st]-2-scrollLeft+ctx.rowHeaderWidth;var freezenverticaldata=[ctx.visibledatacolumn[col_st],col_st+1,scrollLeft,cutVolumn(ctx.visibledatacolumn,col_st+1),left];freezen.vertical={freezenverticaldata:freezenverticaldata,left:left};}cache.freezen||(cache.freezen={});cache.freezen[ctx.currentSheetId]=freezen;}function initFreeze(ctx,cache,sheetId){frozenTofreezen(ctx,cache,sheetId);}function scrollToFrozenRowCol(ctx,freeze){var _freeze$vertical,_freeze$horizontal;var select_save=ctx.luckysheet_select_save;if(!select_save)return;var row;var row_focus=select_save[0].row_focus;if(row_focus===select_save[0].row[0]){var _select_save$0$row=index_esm_slicedToArray(select_save[0].row,2);row=_select_save$0$row[1];}else if(row_focus===select_save[0].row[1]){var _select_save$0$row2=index_esm_slicedToArray(select_save[0].row,1);row=_select_save$0$row2[0];}var column;var column_focus=select_save[0].column_focus;if(column_focus===select_save[0].column[0]){var _select_save$0$column=index_esm_slicedToArray(select_save[0].column,2);column=_select_save$0$column[1];}else if(column_focus===select_save[0].column[1]){var _select_save$0$column2=index_esm_slicedToArray(select_save[0].column,1);column=_select_save$0$column2[0];}var freezenverticaldata=freeze===null||freeze===void 0?void 0:(_freeze$vertical=freeze.vertical)===null||_freeze$vertical===void 0?void 0:_freeze$vertical.freezenverticaldata;var freezenhorizontaldata=freeze===null||freeze===void 0?void 0:(_freeze$horizontal=freeze.horizontal)===null||_freeze$horizontal===void 0?void 0:_freeze$horizontal.freezenhorizontaldata;if(freezenverticaldata!=null&&column!=null){var freezen_colindex=freezenverticaldata[1];var offset=lodash_default().sortedIndex(freezenverticaldata[3],ctx.scrollLeft);var top=freezenverticaldata[4];freezen_colindex+=offset;if(column>=ctx.visibledatacolumn.length){column=ctx.visibledatacolumn.length-1;}if(freezen_colindex>=ctx.visibledatacolumn.length){freezen_colindex=ctx.visibledatacolumn.length-1;}var column_px=ctx.visibledatacolumn[column];var freezen_px=ctx.visibledatacolumn[freezen_colindex];if(column_px<=freezen_px+top){ctx.scrollLeft=0;}}if(freezenhorizontaldata!=null&&row!=null){var freezen_rowindex=freezenhorizontaldata[1];var _offset=lodash_default().sortedIndex(freezenhorizontaldata[3],ctx.scrollTop);var left=freezenhorizontaldata[4];freezen_rowindex+=_offset;if(row>=ctx.visibledatarow.length){row=ctx.visibledatarow.length-1;}if(freezen_rowindex>=ctx.visibledatarow.length){freezen_rowindex=ctx.visibledatarow.length-1;}var row_px=ctx.visibledatarow[row];var _freezen_px=ctx.visibledatarow[freezen_rowindex];if(row_px<=_freezen_px+left){ctx.scrollTop=0;}}}function getFrozenHandleTop(ctx){var _sheet$frozen,_sheet$frozen2,_sheet$frozen3,_sheet$frozen4;var idx=getSheetIndex(ctx,ctx.currentSheetId);if(idx==null)return ctx.scrollTop;var sheet=ctx.luckysheetfile[idx];if((sheet===null||sheet===void 0?void 0:(_sheet$frozen=sheet.frozen)===null||_sheet$frozen===void 0?void 0:_sheet$frozen.type)==="row"||(sheet===null||sheet===void 0?void 0:(_sheet$frozen2=sheet.frozen)===null||_sheet$frozen2===void 0?void 0:_sheet$frozen2.type)==="rangeRow"||(sheet===null||sheet===void 0?void 0:(_sheet$frozen3=sheet.frozen)===null||_sheet$frozen3===void 0?void 0:_sheet$frozen3.type)==="rangeBoth"||(sheet===null||sheet===void 0?void 0:(_sheet$frozen4=sheet.frozen)===null||_sheet$frozen4===void 0?void 0:_sheet$frozen4.type)==="both"){var _sheet$frozen5,_sheet$frozen5$range;return rowLocationByIndex((sheet===null||sheet===void 0?void 0:(_sheet$frozen5=sheet.frozen)===null||_sheet$frozen5===void 0?void 0:(_sheet$frozen5$range=_sheet$frozen5.range)===null||_sheet$frozen5$range===void 0?void 0:_sheet$frozen5$range.row_focus)||0,ctx.visibledatarow)[1]+ctx.scrollTop;}return ctx.scrollTop;}function getFrozenHandleLeft(ctx){var _sheet$frozen6,_sheet$frozen7,_sheet$frozen8,_sheet$frozen9;var idx=getSheetIndex(ctx,ctx.currentSheetId);if(idx==null)return ctx.scrollLeft;var sheet=ctx.luckysheetfile[idx];if((sheet===null||sheet===void 0?void 0:(_sheet$frozen6=sheet.frozen)===null||_sheet$frozen6===void 0?void 0:_sheet$frozen6.type)==="column"||(sheet===null||sheet===void 0?void 0:(_sheet$frozen7=sheet.frozen)===null||_sheet$frozen7===void 0?void 0:_sheet$frozen7.type)==="rangeColumn"||(sheet===null||sheet===void 0?void 0:(_sheet$frozen8=sheet.frozen)===null||_sheet$frozen8===void 0?void 0:_sheet$frozen8.type)==="rangeBoth"||(sheet===null||sheet===void 0?void 0:(_sheet$frozen9=sheet.frozen)===null||_sheet$frozen9===void 0?void 0:_sheet$frozen9.type)==="both"){var _sheet$frozen10,_sheet$frozen10$range;return colLocationByIndex((sheet===null||sheet===void 0?void 0:(_sheet$frozen10=sheet.frozen)===null||_sheet$frozen10===void 0?void 0:(_sheet$frozen10$range=_sheet$frozen10.range)===null||_sheet$frozen10$range===void 0?void 0:_sheet$frozen10$range.column_focus)||0,ctx.visibledatacolumn)[1]-2+ctx.scrollLeft;}return ctx.scrollLeft;}var refreshLocalMergeData=function refreshLocalMergeData(merge_new,file){Object.entries(merge_new).forEach(function(_ref){var _file$data2,_file$data2$r;var _ref2=index_esm_slicedToArray(_ref,2),v=_ref2[1];var r=v.r,c=v.c,rs=v.rs,cs=v.cs;for(var i=r;i<r+rs;i+=1){for(var j=c;j<c+cs;j+=1){var _file$data,_file$data$i;if(file===null||file===void 0?void 0:(_file$data=file.data)===null||_file$data===void 0?void 0:(_file$data$i=_file$data[i])===null||_file$data$i===void 0?void 0:_file$data$i[j]){file.data[i][j]=_objectSpread2(_objectSpread2({},file.data[i][j]),{},{mc:{r:r,c:c}});}}}if(file===null||file===void 0?void 0:(_file$data2=file.data)===null||_file$data2===void 0?void 0:(_file$data2$r=_file$data2[r])===null||_file$data2$r===void 0?void 0:_file$data2$r[c]){file.data[r][c]=_objectSpread2(_objectSpread2({},file.data[r][c]),{},{mc:{r:r,c:c,rs:rs,cs:cs}});}});};function insertRowCol(ctx,op){var changeSelection=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var count=op.count,id=op.id;var type=op.type,index=op.index,direction=op.direction;id=id||ctx.currentSheetId;var curOrder=getSheetIndex(ctx,id);if(curOrder==null)return;var file=ctx.luckysheetfile[curOrder];if(!file)return;var d=file.data;if(!d)return;var cfg=file.config||{};if(changeSelection){if(type==="row"){var _cfg$rowReadOnly;if((_cfg$rowReadOnly=cfg.rowReadOnly)===null||_cfg$rowReadOnly===void 0?void 0:_cfg$rowReadOnly[index]){throw new Error("readOnly");}}else{var _cfg$colReadOnly;if((_cfg$colReadOnly=cfg.colReadOnly)===null||_cfg$colReadOnly===void 0?void 0:_cfg$colReadOnly[index]){throw new Error("readOnly");}}}if(type==="row"&&d.length+count>=10000){throw new Error("maxExceeded");}if(type==="column"&&d[0]&&d[0].length+count>=1000){throw new Error("maxExceeded");}count=Math.floor(count);if(cfg.merge==null){cfg.merge={};}var merge_new={};lodash_default().forEach(cfg.merge,function(mc){var r=mc.r,c=mc.c,rs=mc.rs,cs=mc.cs;if(type==="row"){if(index<r){merge_new["".concat(r+count,"_").concat(c)]={r:r+count,c:c,rs:rs,cs:cs};}else if(index===r){if(direction==="lefttop"){merge_new["".concat(r+count,"_").concat(c)]={r:r+count,c:c,rs:rs,cs:cs};}else{merge_new["".concat(r,"_").concat(c)]={r:r,c:c,rs:rs+count,cs:cs};}}else if(index<r+rs-1){merge_new["".concat(r,"_").concat(c)]={r:r,c:c,rs:rs+count,cs:cs};}else if(index===r+rs-1){if(direction==="lefttop"){merge_new["".concat(r,"_").concat(c)]={r:r,c:c,rs:rs+count,cs:cs};}else{merge_new["".concat(r,"_").concat(c)]={r:r,c:c,rs:rs,cs:cs};}}else{merge_new["".concat(r,"_").concat(c)]={r:r,c:c,rs:rs,cs:cs};}}else if(type==="column"){if(index<c){merge_new["".concat(r,"_").concat(c+count)]={r:r,c:c+count,rs:rs,cs:cs};}else if(index===c){if(direction==="lefttop"){merge_new["".concat(r,"_").concat(c+count)]={r:r,c:c+count,rs:rs,cs:cs};}else{merge_new["".concat(r,"_").concat(c)]={r:r,c:c,rs:rs,cs:cs+count};}}else if(index<c+cs-1){merge_new["".concat(r,"_").concat(c)]={r:r,c:c,rs:rs,cs:cs+count};}else if(index===c+cs-1){if(direction==="lefttop"){merge_new["".concat(r,"_").concat(c)]={r:r,c:c,rs:rs,cs:cs+count};}else{merge_new["".concat(r,"_").concat(c)]={r:r,c:c,rs:rs,cs:cs};}}else{merge_new["".concat(r,"_").concat(c)]={r:r,c:c,rs:rs,cs:cs};}}});cfg.merge=merge_new;var newCalcChain=[];for(var SheetIndex=0;SheetIndex<ctx.luckysheetfile.length;SheetIndex+=1){if(lodash_default().isNil(ctx.luckysheetfile[SheetIndex].calcChain)||ctx.luckysheetfile.length===0){continue;}var calcChain=ctx.luckysheetfile[SheetIndex].calcChain;var data=ctx.luckysheetfile[SheetIndex].data;for(var i=0;i<calcChain.length;i+=1){var calc=lodash_default().cloneDeep(calcChain[i]);var calc_r=calc.r;var calc_c=calc.c;var calc_i=calc.id;var calc_funcStr=getcellFormula(ctx,calc_r,calc_c,calc_i);if(type==="row"&&SheetIndex===curOrder){var _d$calc_r,_d$calc_r$calc_c;var functionStr="=".concat(functionStrChange(calc_funcStr,"add","row",direction,index,count));if(((_d$calc_r=d[calc_r])===null||_d$calc_r===void 0?void 0:(_d$calc_r$calc_c=_d$calc_r[calc_c])===null||_d$calc_r$calc_c===void 0?void 0:_d$calc_r$calc_c.f)===calc_funcStr){d[calc_r][calc_c].f=functionStr;}if(direction==="lefttop"){if(calc_r>=index){calc.r+=count;}}else if(direction==="rightbottom"){if(calc_r>index){calc.r+=count;}}newCalcChain.push(calc);}else if(type==="row"){var _data$calc_r,_data$calc_r$calc_c;var _functionStr="=".concat(functionStrChange(calc_funcStr,"add","row",direction,index,count));if(((_data$calc_r=data[calc_r])===null||_data$calc_r===void 0?void 0:(_data$calc_r$calc_c=_data$calc_r[calc_c])===null||_data$calc_r$calc_c===void 0?void 0:_data$calc_r$calc_c.f)===calc_funcStr){data[calc_r][calc_c].f=_functionStr;}}else if(type==="column"&&SheetIndex===curOrder){var _d$calc_r2,_d$calc_r2$calc_c;var _functionStr2="=".concat(functionStrChange(calc_funcStr,"add","col",direction,index,count));if(((_d$calc_r2=d[calc_r])===null||_d$calc_r2===void 0?void 0:(_d$calc_r2$calc_c=_d$calc_r2[calc_c])===null||_d$calc_r2$calc_c===void 0?void 0:_d$calc_r2$calc_c.f)===calc_funcStr){d[calc_r][calc_c].f=_functionStr2;}if(direction==="lefttop"){if(calc_c>=index){calc.c+=count;}}else if(direction==="rightbottom"){if(calc_c>index){calc.c+=count;}}newCalcChain.push(calc);}else if(type==="column"){var _data$calc_r2,_data$calc_r2$calc_c;var _functionStr3="=".concat(functionStrChange(calc_funcStr,"add","col",direction,index,count));if(((_data$calc_r2=data[calc_r])===null||_data$calc_r2===void 0?void 0:(_data$calc_r2$calc_c=_data$calc_r2[calc_c])===null||_data$calc_r2$calc_c===void 0?void 0:_data$calc_r2$calc_c.f)===calc_funcStr){data[calc_r][calc_c].f=_functionStr3;}}}}var filter_select=file.filter_select;var filter=file.filter;var newFilterObj=null;if(!lodash_default().isEmpty(filter_select)&&filter_select!=null){newFilterObj={filter_select:null,filter:null};var f_r1=filter_select.row[0];var f_r2=filter_select.row[1];var f_c1=filter_select.column[0];var f_c2=filter_select.column[1];if(type==="row"){if(f_r1<index){if(f_r2===index&&direction==="lefttop"){f_r2+=count;}else if(f_r2>index){f_r2+=count;}}else if(f_r1===index){if(direction==="lefttop"){f_r1+=count;f_r2+=count;}else if(direction==="rightbottom"&&f_r2>index){f_r2+=count;}}else{f_r1+=count;f_r2+=count;}if(filter!=null){newFilterObj.filter={};lodash_default().forEach(filter,function(v,k){var f_rowhidden=filter[k].rowhidden;var f_rowhidden_new={};lodash_default().forEach(f_rowhidden,function(v1,nstr){var n=parseFloat(nstr);if(n<index){f_rowhidden_new[n]=0;}else if(n===index){if(direction==="lefttop"){f_rowhidden_new[n+count]=0;}else if(direction==="rightbottom"){f_rowhidden_new[n]=0;}}else{f_rowhidden_new[n+count]=0;}});newFilterObj.filter[k]=lodash_default().cloneDeep(filter[k]);newFilterObj.filter[k].rowhidden=f_rowhidden_new;newFilterObj.filter[k].str=f_r1;newFilterObj.filter[k].edr=f_r2;});}}else if(type==="column"){if(f_c1<index){if(f_c2===index&&direction==="lefttop"){f_c2+=count;}else if(f_c2>index){f_c2+=count;}}else if(f_c1===index){if(direction==="lefttop"){f_c1+=count;f_c2+=count;}else if(direction==="rightbottom"&&f_c2>index){f_c2+=count;}}else{f_c1+=count;f_c2+=count;}if(filter!=null){newFilterObj.filter={};lodash_default().forEach(filter,function(v,k){var f_cindex=filter[k].cindex;if(f_cindex===index&&direction==="lefttop"){f_cindex+=count;}else if(f_cindex>index){f_cindex+=count;}newFilterObj.filter[f_cindex-f_c1]=lodash_default().cloneDeep(filter[k]);newFilterObj.filter[f_cindex-f_c1].cindex=f_cindex;newFilterObj.filter[f_cindex-f_c1].stc=f_c1;newFilterObj.filter[f_cindex-f_c1].edc=f_c2;});}}newFilterObj.filter_select={row:[f_r1,f_r2],column:[f_c1,f_c2]};}if(newFilterObj!=null&&newFilterObj.filter!=null){if(cfg.rowhidden==null){cfg.rowhidden={};}lodash_default().forEach(newFilterObj.filter,function(v,k){var f_rowhidden=newFilterObj.filter[k].rowhidden;lodash_default().forEach(f_rowhidden,function(v1,n){cfg.rowhidden[n]=0;});});}var CFarr=file.luckysheet_conditionformat_save;var newCFarr=[];if(CFarr!=null&&CFarr.length>0){for(var _i=0;_i<CFarr.length;_i+=1){var cf_range=CFarr[_i].cellrange;var cf_new_range=[];for(var j=0;j<cf_range.length;j+=1){var CFr1=cf_range[j].row[0];var CFr2=cf_range[j].row[1];var CFc1=cf_range[j].column[0];var CFc2=cf_range[j].column[1];if(type==="row"){if(CFr1<index){if(CFr2===index&&direction==="lefttop"){CFr2+=count;}else if(CFr2>index){CFr2+=count;}}else if(CFr1===index){if(direction==="lefttop"){CFr1+=count;CFr2+=count;}else if(direction==="rightbottom"&&CFr2>index){CFr2+=count;}}else{CFr1+=count;CFr2+=count;}}else if(type==="column"){if(CFc1<index){if(CFc2===index&&direction==="lefttop"){CFc2+=count;}else if(CFc2>index){CFc2+=count;}}else if(CFc1===index){if(direction==="lefttop"){CFc1+=count;CFc2+=count;}else if(direction==="rightbottom"&&CFc2>index){CFc2+=count;}}else{CFc1+=count;CFc2+=count;}}cf_new_range.push({row:[CFr1,CFr2],column:[CFc1,CFc2]});}var cf=lodash_default().clone(CFarr[_i]);cf.cellrange=cf_new_range;newCFarr.push(cf);}}var AFarr=file.luckysheet_alternateformat_save;var newAFarr=[];if(AFarr!=null&&AFarr.length>0){for(var _i2=0;_i2<AFarr.length;_i2+=1){var AFr1=AFarr[_i2].cellrange.row[0];var AFr2=AFarr[_i2].cellrange.row[1];var AFc1=AFarr[_i2].cellrange.column[0];var AFc2=AFarr[_i2].cellrange.column[1];var af=lodash_default().clone(AFarr[_i2]);if(type==="row"){if(AFr1<index){if(AFr2===index&&direction==="lefttop"){AFr2+=count;}else if(AFr2>index){AFr2+=count;}}else if(AFr1===index){if(direction==="lefttop"){AFr1+=count;AFr2+=count;}else if(direction==="rightbottom"&&AFr2>index){AFr2+=count;}}else{AFr1+=count;AFr2+=count;}}else if(type==="column"){if(AFc1<index){if(AFc2===index&&direction==="lefttop"){AFc2+=count;}else if(AFc2>index){AFc2+=count;}}else if(AFc1===index){if(direction==="lefttop"){AFc1+=count;AFc2+=count;}else if(direction==="rightbottom"&&AFc2>index){AFc2+=count;}}else{AFc1+=count;AFc2+=count;}}af.cellrange={row:[AFr1,AFr2],column:[AFc1,AFc2]};newAFarr.push(af);}}var frozen=file.frozen;if(frozen){var normalizedIndex=direction==="lefttop"?index-1:index;if(type==="row"&&(frozen.type==="rangeRow"||frozen.type==="rangeBoth")){var _frozen$range$row_foc,_frozen$range;if(((_frozen$range$row_foc=(_frozen$range=frozen.range)===null||_frozen$range===void 0?void 0:_frozen$range.row_focus)!==null&&_frozen$range$row_foc!==void 0?_frozen$range$row_foc:-1)>normalizedIndex){frozen.range.row_focus+=count;}}if(type==="column"&&(frozen.type==="rangeColumn"||frozen.type==="rangeBoth")){var _frozen$range$column_,_frozen$range2;if(((_frozen$range$column_=(_frozen$range2=frozen.range)===null||_frozen$range2===void 0?void 0:_frozen$range2.column_focus)!==null&&_frozen$range$column_!==void 0?_frozen$range$column_:-1)>normalizedIndex){frozen.range.column_focus+=count;}}}var dataVerification=file.dataVerification;var newDataVerification={};if(dataVerification!=null){lodash_default().forEach(dataVerification,function(v,key){var r=Number(key.split("_")[0]);var c=Number(key.split("_")[1]);var item=dataVerification[key];if(type==="row"){if(index<r){newDataVerification["".concat(r+count,"_").concat(c)]=item;}else if(index===r){if(direction==="lefttop"){newDataVerification["".concat(r+count,"_").concat(c)]=item;for(var _i3=0;_i3<count;_i3+=1){newDataVerification["".concat(r+_i3,"_").concat(c)]=item;}}else{newDataVerification["".concat(r,"_").concat(c)]=item;for(var _i4=0;_i4<count;_i4+=1){newDataVerification["".concat(r+_i4+1,"_").concat(c)]=item;}}}else{newDataVerification["".concat(r,"_").concat(c)]=item;}}else if(type==="column"){if(index<c){newDataVerification["".concat(r,"_").concat(c+count)]=item;}else if(index===c){if(direction==="lefttop"){newDataVerification["".concat(r,"_").concat(c+count)]=item;for(var _i5=0;_i5<count;_i5+=1){newDataVerification["".concat(r,"_").concat(c+_i5)]=item;}}else{newDataVerification["".concat(r,"_").concat(c)]=item;for(var _i6=0;_i6<count;_i6+=1){newDataVerification["".concat(r,"_").concat(c+_i6+1)]=item;}}}else{newDataVerification["".concat(r,"_").concat(c)]=item;}}});}var hyperlink=file.hyperlink;var newHyperlink={};if(hyperlink!=null){lodash_default().forEach(hyperlink,function(v,key){var r=Number(key.split("_")[0]);var c=Number(key.split("_")[1]);var item=hyperlink[key];if(type==="row"){if(index<r){newHyperlink["".concat(r+count,"_").concat(c)]=item;}else if(index===r){if(direction==="lefttop"){newHyperlink["".concat(r+count,"_").concat(c)]=item;}else{newHyperlink["".concat(r,"_").concat(c)]=item;}}else{newHyperlink["".concat(r,"_").concat(c)]=item;}}else if(type==="column"){if(index<c){newHyperlink["".concat(r,"_").concat(c+count)]=item;}else if(index===c){if(direction==="lefttop"){newHyperlink["".concat(r,"_").concat(c+count)]=item;}else{newHyperlink["".concat(r,"_").concat(c)]=item;}}else{newHyperlink["".concat(r,"_").concat(c)]=item;}}});}if(type==="row"){if(cfg.rowlen!=null){var rowlen_new={};var rowReadOnly_new={};lodash_default().forEach(cfg.rowlen,function(v,rstr){var r=parseFloat(rstr);if(r<index){rowlen_new[r]=cfg.rowlen[r];}else if(r===index){if(direction==="lefttop"){rowlen_new[r+count]=cfg.rowlen[r];}else if(direction==="rightbottom"){rowlen_new[r]=cfg.rowlen[r];}}else{rowlen_new[r+count]=cfg.rowlen[r];}});lodash_default().forEach(cfg.rowReadOnly,function(v,rstr){var r=parseFloat(rstr);if(r<index){rowReadOnly_new[r]=cfg.rowReadOnly[r];}else if(r>index){rowReadOnly_new[r+count]=cfg.rowReadOnly[r];}});cfg.rowlen=rowlen_new;cfg.rowReadOnly=rowReadOnly_new;}if(cfg.customHeight!=null){var customHeight_new={};lodash_default().forEach(cfg.customHeight,function(v,rstr){var r=parseFloat(rstr);if(r<index){customHeight_new[r]=cfg.customHeight[r];}else if(r===index){if(direction==="lefttop"){customHeight_new[r+count]=cfg.customHeight[r];}else if(direction==="rightbottom"){customHeight_new[r]=cfg.customHeight[r];}}else{customHeight_new[r+count]=cfg.customHeight[r];}});cfg.customHeight=customHeight_new;}if(cfg.customHeight!=null){var _customHeight_new={};lodash_default().forEach(cfg.customHeight,function(v,rstr){var r=parseFloat(rstr);if(r<index){_customHeight_new[r]=cfg.customHeight[r];}else if(r===index){if(direction==="lefttop"){_customHeight_new[r+count]=cfg.customHeight[r];}else if(direction==="rightbottom"){_customHeight_new[r]=cfg.customHeight[r];}}else{_customHeight_new[r+count]=cfg.customHeight[r];}});cfg.customHeight=_customHeight_new;}if(cfg.rowhidden!=null){var rowhidden_new={};lodash_default().forEach(cfg.rowhidden,function(v,rstr){var r=parseFloat(rstr);if(r<index){rowhidden_new[r]=cfg.rowhidden[r];}else if(r===index){if(direction==="lefttop"){rowhidden_new[r+count]=cfg.rowhidden[r];}else if(direction==="rightbottom"){rowhidden_new[r]=cfg.rowhidden[r];}}else{rowhidden_new[r+count]=cfg.rowhidden[r];}});cfg.rowhidden=rowhidden_new;}var row=[];var curRow=index_esm_toConsumableArray(d)[index];for(var c=0;c<d[0].length;c+=1){var cell=curRow[c];var templateCell=null;if((cell===null||cell===void 0?void 0:cell.mc)&&(direction==="rightbottom"||index!==cell.mc.r)){var _d,_d$c;if(cell.mc.rs){cell.mc.rs+=count;}templateCell=_objectSpread2({},cell);if(!(d===null||d===void 0?void 0:(_d=d[index+1])===null||_d===void 0?void 0:(_d$c=_d[c])===null||_d$c===void 0?void 0:_d$c.mc)){templateCell.mc=undefined;}delete templateCell.v;delete templateCell.m;delete templateCell.ps;delete templateCell.f;}row.push(templateCell);}var cellBorderConfig=[];if(cfg.borderInfo&&cfg.borderInfo.length>0){var borderInfo=[];for(var _i7=0;_i7<cfg.borderInfo.length;_i7+=1){var rangeType=cfg.borderInfo[_i7].rangeType;if(rangeType==="range"){var borderRange=cfg.borderInfo[_i7].range;var emptyRange=[];for(var _j=0;_j<borderRange.length;_j+=1){var bd_r1=borderRange[_j].row[0];var bd_r2=borderRange[_j].row[1];if(direction==="lefttop"){if(index<=bd_r1){bd_r1+=count;bd_r2+=count;}else if(index<=bd_r2){bd_r2+=count;}}else{if(index<bd_r1){bd_r1+=count;bd_r2+=count;}else if(index<bd_r2){bd_r2+=count;}}if(bd_r2>=bd_r1){emptyRange.push({row:[bd_r1,bd_r2],column:borderRange[_j].column});}}if(emptyRange.length>0){var bd_obj={rangeType:"range",borderType:cfg.borderInfo[_i7].borderType,style:cfg.borderInfo[_i7].style,color:cfg.borderInfo[_i7].color,range:emptyRange};borderInfo.push(bd_obj);}}else if(rangeType==="cell"){var row_index=cfg.borderInfo[_i7].value.row_index;if(row_index===index){cellBorderConfig.push(JSON.parse(JSON.stringify(cfg.borderInfo[_i7])));}if(direction==="lefttop"){if(index<=row_index){row_index+=count;}}else{if(index<row_index){row_index+=count;}}cfg.borderInfo[_i7].value.row_index=row_index;borderInfo.push(cfg.borderInfo[_i7]);}}cfg.borderInfo=borderInfo;}var arr=[];var _loop=function _loop(r){arr.push(JSON.stringify(row));if(cellBorderConfig.length){var _cfg$borderInfo;var cellBorderConfigCopy=lodash_default().cloneDeep(cellBorderConfig);cellBorderConfigCopy.forEach(function(item){if(direction==="rightbottom"){item.value.row_index+=r+1;}else if(direction==="lefttop"){item.value.row_index+=r;}});(_cfg$borderInfo=cfg.borderInfo)===null||_cfg$borderInfo===void 0?void 0:_cfg$borderInfo.push.apply(_cfg$borderInfo,index_esm_toConsumableArray(cellBorderConfigCopy));}};for(var r=0;r<count;r+=1){_loop(r);}if(direction==="lefttop"){if(index===0){new Function("d","return d.unshift(".concat(arr.join(","),")"))(d);}else{new Function("d","return d.splice(".concat(index,", 0, ").concat(arr.join(","),")"))(d);}}else{new Function("d","return d.splice(".concat(index+1,", 0, ").concat(arr.join(","),")"))(d);}}else{if(cfg.columnlen!=null){var columnlen_new={};var columnReadOnly_new={};lodash_default().forEach(cfg.columnlen,function(v,cstr){var c=parseFloat(cstr);if(c<index){columnlen_new[c]=cfg.columnlen[c];}else if(c===index){if(direction==="lefttop"){columnlen_new[c+count]=cfg.columnlen[c];}else if(direction==="rightbottom"){columnlen_new[c]=cfg.columnlen[c];}}else{columnlen_new[c+count]=cfg.columnlen[c];}});lodash_default().forEach(cfg.colReadOnly,function(v,cstr){var c=parseFloat(cstr);if(c<index){columnReadOnly_new[c]=cfg.colReadOnly[c];}else if(c>index){columnReadOnly_new[c+count]=cfg.colReadOnly[c];}});cfg.columnlen=columnlen_new;cfg.colReadOnly=columnReadOnly_new;}if(cfg.customWidth!=null){var customWidth_new={};lodash_default().forEach(cfg.customWidth,function(v,cstr){var c=parseFloat(cstr);if(c<index){customWidth_new[c]=cfg.customWidth[c];}else if(c===index){if(direction==="lefttop"){customWidth_new[c+count]=cfg.customWidth[c];}else if(direction==="rightbottom"){customWidth_new[c]=cfg.customWidth[c];}}else{customWidth_new[c+count]=cfg.customWidth[c];}});cfg.customWidth=customWidth_new;}if(cfg.customWidth!=null){var _customWidth_new={};lodash_default().forEach(cfg.customWidth,function(v,cstr){var c=parseFloat(cstr);if(c<index){_customWidth_new[c]=cfg.customWidth[c];}else if(c===index){if(direction==="lefttop"){_customWidth_new[c+count]=cfg.customWidth[c];}else if(direction==="rightbottom"){_customWidth_new[c]=cfg.customWidth[c];}}else{_customWidth_new[c+count]=cfg.customWidth[c];}});cfg.customWidth=_customWidth_new;}if(cfg.colhidden!=null){var colhidden_new={};lodash_default().forEach(cfg.colhidden,function(v,cstr){var c=parseFloat(cstr);if(c<index){colhidden_new[c]=cfg.colhidden[c];}else if(c===index){if(direction==="lefttop"){colhidden_new[c+count]=cfg.colhidden[c];}else if(direction==="rightbottom"){colhidden_new[c]=cfg.colhidden[c];}}else{colhidden_new[c+count]=cfg.colhidden[c];}});cfg.colhidden=colhidden_new;}var col=[];var curd=index_esm_toConsumableArray(d);for(var _r=0;_r<d.length;_r+=1){var _cell=curd[_r][index];var _templateCell=null;if((_cell===null||_cell===void 0?void 0:_cell.mc)&&(direction==="rightbottom"||index!==_cell.mc.c)){var _curd$_r,_curd$_r2;if(_cell.mc.cs){_cell.mc.cs+=count;}_templateCell=_objectSpread2({},_cell);if(!(curd===null||curd===void 0?void 0:(_curd$_r=curd[_r])===null||_curd$_r===void 0?void 0:(_curd$_r2=_curd$_r[index+1])===null||_curd$_r2===void 0?void 0:_curd$_r2.mc)){_templateCell.mc=undefined;}delete _templateCell.v;delete _templateCell.m;delete _templateCell.ps;delete _templateCell.f;}col.push(_templateCell);}var _cellBorderConfig=[];if(cfg.borderInfo&&cfg.borderInfo.length>0){var _borderInfo=[];for(var _i8=0;_i8<cfg.borderInfo.length;_i8+=1){var _rangeType=cfg.borderInfo[_i8].rangeType;if(_rangeType==="range"){var _borderRange=cfg.borderInfo[_i8].range;var _emptyRange=[];for(var _j2=0;_j2<_borderRange.length;_j2+=1){var bd_c1=_borderRange[_j2].column[0];var bd_c2=_borderRange[_j2].column[1];if(direction==="lefttop"){if(index<=bd_c1){bd_c1+=count;bd_c2+=count;}else if(index<=bd_c2){bd_c2+=count;}}else{if(index<bd_c1){bd_c1+=count;bd_c2+=count;}else if(index<bd_c2){bd_c2+=count;}}if(bd_c2>=bd_c1){_emptyRange.push({row:_borderRange[_j2].row,column:[bd_c1,bd_c2]});}}if(_emptyRange.length>0){var _bd_obj={rangeType:"range",borderType:cfg.borderInfo[_i8].borderType,style:cfg.borderInfo[_i8].style,color:cfg.borderInfo[_i8].color,range:_emptyRange};_borderInfo.push(_bd_obj);}}else if(_rangeType==="cell"){var col_index=cfg.borderInfo[_i8].value.col_index;if(col_index===index){_cellBorderConfig.push(JSON.parse(JSON.stringify(cfg.borderInfo[_i8])));}if(direction==="lefttop"){if(index<=col_index){col_index+=count;}}else{if(index<col_index){col_index+=count;}}cfg.borderInfo[_i8].value.col_index=col_index;_borderInfo.push(cfg.borderInfo[_i8]);}}cfg.borderInfo=_borderInfo;}if(_cellBorderConfig.length){var _loop2=function _loop2(_i9){var _cfg$borderInfo2;var cellBorderConfigCopy=lodash_default().cloneDeep(_cellBorderConfig);cellBorderConfigCopy.forEach(function(item){if(direction==="rightbottom"){item.value.col_index+=_i9+1;}else if(direction==="lefttop"){item.value.col_index+=_i9;}});(_cfg$borderInfo2=cfg.borderInfo)===null||_cfg$borderInfo2===void 0?void 0:_cfg$borderInfo2.push.apply(_cfg$borderInfo2,index_esm_toConsumableArray(cellBorderConfigCopy));};for(var _i9=0;_i9<count;_i9+=1){_loop2(_i9);}}for(var _r2=0;_r2<d.length;_r2+=1){var _row=d[_r2];for(var _i10=0;_i10<count;_i10+=1){if(direction==="lefttop"){if(index===0){_row.unshift(col[_r2]);}else{_row.splice(index,0,col[_r2]);}}else{_row.splice(index+1,0,col[_r2]);}}}}file.data=d;file.config=cfg;file.calcChain=newCalcChain;if(newFilterObj!=null){file.filter=newFilterObj.filter;file.filter_select=newFilterObj.filter_select;}file.luckysheet_conditionformat_save=newCFarr;file.luckysheet_alternateformat_save=newAFarr;file.dataVerification=newDataVerification;file.hyperlink=newHyperlink;if(file.id===ctx.currentSheetId){ctx.config=cfg;}var range=null;if(type==="row"){if(direction==="lefttop"){range=[{row:[index,index+count-1],column:[0,d[0].length-1]}];}else{range=[{row:[index+1,index+count],column:[0,d[0].length-1]}];}file.row=file.data.length;}else{var _file$data$;if(direction==="lefttop"){range=[{row:[0,d.length-1],column:[index,index+count-1]}];}else{range=[{row:[0,d.length-1],column:[index+1,index+count]}];}file.column=(_file$data$=file.data[0])===null||_file$data$===void 0?void 0:_file$data$.length;}if(changeSelection){file.luckysheet_select_save=range;if(file.id===ctx.currentSheetId){ctx.luckysheet_select_save=range;}}refreshLocalMergeData(merge_new,file);}function deleteRowCol(ctx,op){var type=op.type;var start=op.start,end=op.end,id=op.id;id=id||ctx.currentSheetId;var curOrder=getSheetIndex(ctx,id);if(curOrder==null)return;var file=ctx.luckysheetfile[curOrder];if(!file)return;var cfg=file.config||{};if(type==="row"){for(var r=start;r<=end;r+=1){var _cfg$rowReadOnly2;if((_cfg$rowReadOnly2=cfg.rowReadOnly)===null||_cfg$rowReadOnly2===void 0?void 0:_cfg$rowReadOnly2[r]){throw new Error("readOnly");}}}else{for(var c=start;c<=end;c+=1){var _cfg$colReadOnly2;if((_cfg$colReadOnly2=cfg.colReadOnly)===null||_cfg$colReadOnly2===void 0?void 0:_cfg$colReadOnly2[c]){throw new Error("readOnly");}}}var d=file.data;if(!d)return;if(start<0){start=0;}if(end<0){end=0;}if(type==="row"){if(start>d.length-1){start=d.length-1;}if(end>d.length-1){end=d.length-1;}}else{if(start>d[0].length-1){start=d[0].length-1;}if(end>d[0].length-1){end=d[0].length-1;}}if(start>end){return;}var slen=end-start+1;if(cfg.merge==null){cfg.merge={};}var merge_new={};lodash_default().forEach(cfg.merge,function(mc){var r=mc.r;var c=mc.c;var rs=mc.rs;var cs=mc.cs;if(type==="row"){if(r<start){if(r+rs-1<start){merge_new["".concat(r,"_").concat(c)]={r:r,c:c,rs:rs,cs:cs};}else if(r+rs-1>=start&&r+rs-1<end){merge_new["".concat(r,"_").concat(c)]={r:r,c:c,rs:start-r,cs:cs};}else if(r+rs-1>=end){merge_new["".concat(r,"_").concat(c)]={r:r,c:c,rs:rs-slen,cs:cs};}}else if(r>=start&&r<=end){if(r+rs-1>end){merge_new["".concat(start,"_").concat(c)]={r:start,c:c,rs:r+rs-1-end,cs:cs};}}else if(r>end){merge_new["".concat(r-slen,"_").concat(c)]={r:r-slen,c:c,rs:rs,cs:cs};}}else if(type==="column"){if(c<start){if(c+cs-1<start){merge_new["".concat(r,"_").concat(c)]={r:r,c:c,rs:rs,cs:cs};}else if(c+cs-1>=start&&c+cs-1<end){merge_new["".concat(r,"_").concat(c)]={r:r,c:c,rs:rs,cs:start-c};}else if(c+cs-1>=end){merge_new["".concat(r,"_").concat(c)]={r:r,c:c,rs:rs,cs:cs-slen};}}else if(c>=start&&c<=end){if(c+cs-1>end){merge_new["".concat(r,"_").concat(start)]={r:r,c:start,rs:rs,cs:c+cs-1-end};}}else if(c>end){merge_new["".concat(r,"_").concat(c-slen)]={r:r,c:c-slen,rs:rs,cs:cs};}}});cfg.merge=merge_new;var newCalcChain=[];for(var SheetIndex=0;SheetIndex<ctx.luckysheetfile.length;SheetIndex+=1){if(lodash_default().isNil(ctx.luckysheetfile[SheetIndex].calcChain)||ctx.luckysheetfile.length===0){continue;}var calcChain=ctx.luckysheetfile[SheetIndex].calcChain;var data=ctx.luckysheetfile[SheetIndex].data;for(var i=0;i<calcChain.length;i+=1){var calc=lodash_default().cloneDeep(calcChain[i]);var calc_r=calc.r;var calc_c=calc.c;var calc_i=calc.id;var calc_funcStr=getcellFormula(ctx,calc_r,calc_c,calc_i);if(type==="row"&&SheetIndex===curOrder){if(calc_r<start||calc_r>end){var _data$calc_r3,_data$calc_r3$calc_c;var functionStr="=".concat(functionStrChange(calc_funcStr,"del","row",null,start,slen));if(((_data$calc_r3=data[calc_r])===null||_data$calc_r3===void 0?void 0:(_data$calc_r3$calc_c=_data$calc_r3[calc_c])===null||_data$calc_r3$calc_c===void 0?void 0:_data$calc_r3$calc_c.f)===calc_funcStr){data[calc_r][calc_c].f=functionStr;}if(calc_r>end){calc.r=calc_r-slen;}newCalcChain.push(calc);}}else if(type==="row"){var _data$calc_r4,_data$calc_r4$calc_c;var _functionStr4="=".concat(functionStrChange(calc_funcStr,"del","row",null,start,slen));if(((_data$calc_r4=data[calc_r])===null||_data$calc_r4===void 0?void 0:(_data$calc_r4$calc_c=_data$calc_r4[calc_c])===null||_data$calc_r4$calc_c===void 0?void 0:_data$calc_r4$calc_c.f)===calc_funcStr){data[calc_r][calc_c].f=_functionStr4;}}else if(type==="column"&&SheetIndex===curOrder){if(calc_c<start||calc_c>end){var _data$calc_r5,_data$calc_r5$calc_c;var _functionStr5="=".concat(functionStrChange(calc_funcStr,"del","col",null,start,slen));if(((_data$calc_r5=data[calc_r])===null||_data$calc_r5===void 0?void 0:(_data$calc_r5$calc_c=_data$calc_r5[calc_c])===null||_data$calc_r5$calc_c===void 0?void 0:_data$calc_r5$calc_c.f)===calc_funcStr){data[calc_r][calc_c].f=_functionStr5;}if(calc_c>end){calc.c=calc_c-slen;}newCalcChain.push(calc);}}else if(type==="column"){var _data$calc_r6,_data$calc_r6$calc_c;var _functionStr6="=".concat(functionStrChange(calc_funcStr,"del","col",null,start,slen));if(((_data$calc_r6=data[calc_r])===null||_data$calc_r6===void 0?void 0:(_data$calc_r6$calc_c=_data$calc_r6[calc_c])===null||_data$calc_r6$calc_c===void 0?void 0:_data$calc_r6$calc_c.f)===calc_funcStr){data[calc_r][calc_c].f=_functionStr6;}}}}var filter_select=file.filter_select;var filter=file.filter;var newFilterObj=null;if(!lodash_default().isEmpty(filter_select)&&filter_select!=null){newFilterObj={filter_select:null,filter:null};var f_r1=filter_select.row[0];var f_r2=filter_select.row[1];var f_c1=filter_select.column[0];var f_c2=filter_select.column[1];if(type==="row"){if(f_r1>end){f_r1-=slen;f_r2-=slen;newFilterObj.filter_select={row:[f_r1,f_r2],column:[f_c1,f_c2]};}else if(f_r1<start){if(f_r2<start);else if(f_r2<=end){f_r2=start-1;}else{f_r2-=slen;}newFilterObj.filter_select={row:[f_r1,f_r2],column:[f_c1,f_c2]};}if(newFilterObj.filter_select!=null&&filter!=null){lodash_default().forEach(filter,function(v,k){var f_rowhidden=filter[k].rowhidden;var f_rowhidden_new={};lodash_default().forEach(f_rowhidden,function(v1,nstr){var n=parseFloat(nstr);if(n<start){f_rowhidden_new[n]=0;}else if(n>end){f_rowhidden_new[n-slen]=0;}});if(!lodash_default().isEmpty(f_rowhidden_new)){if(newFilterObj.filter==null){newFilterObj.filter={};}newFilterObj.filter[k]=lodash_default().cloneDeep(filter[k]);newFilterObj.filter[k].rowhidden=f_rowhidden_new;newFilterObj.filter[k].str=f_r1;newFilterObj.filter[k].edr=f_r2;}});}}else if(type==="column"){if(f_c1>end){f_c1-=slen;f_c2-=slen;newFilterObj.filter_select={row:[f_r1,f_r2],column:[f_c1,f_c2]};}else if(f_c1<start){if(f_c2<start);else if(f_c2<=end){f_c2=start-1;}else{f_c2-=slen;}newFilterObj.filter_select={row:[f_r1,f_r2],column:[f_c1,f_c2]};}else{if(f_c2>end){f_c1=start;f_c2-=slen;newFilterObj.filter_select={row:[f_r1,f_r2],column:[f_c1,f_c2]};}}if(newFilterObj.filter_select!=null&&filter!=null){lodash_default().forEach(filter,function(v,k){var f_cindex=filter[k].cindex;if(f_cindex<start){if(newFilterObj.filter==null){newFilterObj.filter={};}newFilterObj.filter[f_cindex-f_c1]=lodash_default().cloneDeep(filter[k]);newFilterObj.filter[f_cindex-f_c1].edc=f_c2;}else if(f_cindex>end){f_cindex-=slen;if(newFilterObj.filter==null){newFilterObj.filter={};}newFilterObj.filter[f_cindex-f_c1]=lodash_default().cloneDeep(filter[k]);newFilterObj.filter[f_cindex-f_c1].cindex=f_cindex;newFilterObj.filter[f_cindex-f_c1].stc=f_c1;newFilterObj.filter[f_cindex-f_c1].edc=f_c2;}});}}}if(newFilterObj!=null&&newFilterObj.filter!=null){if(cfg.rowhidden==null){cfg.rowhidden={};}lodash_default().forEach(newFilterObj.filter,function(v,k){var f_rowhidden=newFilterObj.filter[k].rowhidden;lodash_default().forEach(f_rowhidden,function(v1,n){cfg.rowhidden[n]=0;});});}var CFarr=file.luckysheet_conditionformat_save;var newCFarr=[];if(CFarr!=null&&CFarr.length>0){for(var _i11=0;_i11<CFarr.length;_i11+=1){var cf_range=CFarr[_i11].cellrange;var cf_new_range=[];for(var j=0;j<cf_range.length;j+=1){var CFr1=cf_range[j].row[0];var CFr2=cf_range[j].row[1];var CFc1=cf_range[j].column[0];var CFc2=cf_range[j].column[1];if(type==="row"){if(!(CFr1>=start&&CFr2<=end)){if(CFr1>end){CFr1-=slen;CFr2-=slen;}else if(CFr1<start){if(CFr2<start);else if(CFr2<=end){CFr2=start-1;}else{CFr2-=slen;}}else{if(CFr2>end){CFr1=start;CFr2-=slen;}}cf_new_range.push({row:[CFr1,CFr2],column:[CFc1,CFc2]});}}else if(type==="column"){if(!(CFc1>=start&&CFc2<=end)){if(CFc1>end){CFc1-=slen;CFc2-=slen;}else if(CFc1<start){if(CFc2<start);else if(CFc2<=end){CFc2=start-1;}else{CFc2-=slen;}}else{if(CFc2>end){CFc1=start;CFc2-=slen;}}cf_new_range.push({row:[CFr1,CFr2],column:[CFc1,CFc2]});}}}if(cf_new_range.length>0){var cf=lodash_default().clone(CFarr[_i11]);cf.cellrange=cf_new_range;newCFarr.push(cf);}}}var AFarr=file.luckysheet_alternateformat_save;var newAFarr=[];if(AFarr!=null&&AFarr.length>0){for(var _i12=0;_i12<AFarr.length;_i12+=1){var AFr1=AFarr[_i12].cellrange.row[0];var AFr2=AFarr[_i12].cellrange.row[1];var AFc1=AFarr[_i12].cellrange.column[0];var AFc2=AFarr[_i12].cellrange.column[1];if(type==="row"){if(!(AFr1>=start&&AFr2<=end)){var af=lodash_default().clone(AFarr[_i12]);if(AFr1>end){AFr1-=slen;AFr2-=slen;}else if(AFr1<start){if(AFr2<start);else if(AFr2<=end){AFr2=start-1;}else{AFr2-=slen;}}else{if(AFr2>end){AFr1=start;AFr2-=slen;}}af.cellrange={row:[AFr1,AFr2],column:[AFc1,AFc2]};newAFarr.push(af);}}else if(type==="column"){if(!(AFc1>=start&&AFc2<=end)){var _af=lodash_default().clone(AFarr[_i12]);if(AFc1>end){AFc1-=slen;AFc2-=slen;}else if(AFc1<start){if(AFc2<start);else if(AFc2<=end){AFc2=start-1;}else{AFc2-=slen;}}else{if(AFc2>end){AFc1=start;AFc2-=slen;}}_af.cellrange={row:[AFr1,AFr2],column:[AFc1,AFc2]};newAFarr.push(_af);}}}}var frozen=file.frozen;if(frozen){if(type==="row"&&(frozen.type==="rangeRow"||frozen.type==="rangeBoth")){var _frozen$range$row_foc2,_frozen$range3;if(((_frozen$range$row_foc2=(_frozen$range3=frozen.range)===null||_frozen$range3===void 0?void 0:_frozen$range3.row_focus)!==null&&_frozen$range$row_foc2!==void 0?_frozen$range$row_foc2:-1)>=start){frozen.range.row_focus-=Math.min(end,frozen.range.row_focus)-start+1;}}if(type==="column"&&(frozen.type==="rangeColumn"||frozen.type==="rangeBoth")){var _frozen$range$column_2,_frozen$range4;if(((_frozen$range$column_2=(_frozen$range4=frozen.range)===null||_frozen$range4===void 0?void 0:_frozen$range4.column_focus)!==null&&_frozen$range$column_2!==void 0?_frozen$range$column_2:-1)>=start){frozen.range.column_focus-=Math.min(end,frozen.range.column_focus)-start+1;}}}var dataVerification=file.dataVerification;var newDataVerification={};if(dataVerification!=null){lodash_default().forEach(dataVerification,function(v,key){var r=Number(key.split("_")[0]);var c=Number(key.split("_")[1]);var item=dataVerification[key];if(type==="row"){if(r<start){newDataVerification["".concat(r,"_").concat(c)]=item;}else if(r>end){newDataVerification["".concat(r-slen,"_").concat(c)]=item;}}else if(type==="column"){if(c<start){newDataVerification["".concat(r,"_").concat(c)]=item;}else if(c>end){newDataVerification["".concat(r,"_").concat(c-slen)]=item;}}});}var hyperlink=file.hyperlink;var newHyperlink={};if(hyperlink!=null){lodash_default().forEach(hyperlink,function(v,key){var r=Number(key.split("_")[0]);var c=Number(key.split("_")[1]);var item=hyperlink[key];if(type==="row"){if(r<start){newHyperlink["".concat(r,"_").concat(c)]=item;}else if(r>end){newHyperlink["".concat(r-slen,"_").concat(c)]=item;}}else if(type==="column"){if(c<start){newHyperlink["".concat(r,"_").concat(c)]=item;}else if(c>end){newHyperlink["".concat(r,"_").concat(c-slen)]=item;}}});}if(type==="row"){if(cfg.rowlen==null){cfg.rowlen={};}var rowlen_new={};var rowReadOnly_new={};lodash_default().forEach(cfg.rowlen,function(v,rstr){var r=parseFloat(rstr);if(r<start){rowlen_new[r]=cfg.rowlen[r];}else if(r>end){rowlen_new[r-slen]=cfg.rowlen[r];}});lodash_default().forEach(cfg.rowReadOnly,function(v,rstr){var r=parseFloat(rstr);if(r<start){rowReadOnly_new[r]=cfg.rowReadOnly[r];}else if(r>end){rowReadOnly_new[r-slen]=cfg.rowReadOnly[r];}});cfg.rowlen=rowlen_new;cfg.rowReadOnly=rowReadOnly_new;if(cfg.rowhidden==null){cfg.rowhidden={};}var rowhidden_new={};lodash_default().forEach(cfg.rowhidden,function(v,rstr){var r=parseFloat(rstr);if(r<start){rowhidden_new[r]=cfg.rowhidden[r];}else if(r>end){rowhidden_new[r-slen]=cfg.rowhidden[r];}});if(cfg.customHeight==null){cfg.customHeight={};var customHeight_new={};lodash_default().forEach(cfg.customHeight,function(v,rstr){var r=parseFloat(rstr);if(r<start){customHeight_new[r]=cfg.customHeight[r];}else if(r>end){customHeight_new[r-slen]=cfg.customHeight[r];}});cfg.customHeight=customHeight_new;}if(cfg.customHeight==null){cfg.customHeight={};var _customHeight_new2={};lodash_default().forEach(cfg.customHeight,function(v,rstr){var r=parseFloat(rstr);if(r<start){_customHeight_new2[r]=cfg.customHeight[r];}else if(r>end){_customHeight_new2[r-slen]=cfg.customHeight[r];}});cfg.customHeight=_customHeight_new2;}cfg.rowhidden=rowhidden_new;if(cfg.borderInfo&&cfg.borderInfo.length>0){var borderInfo=[];for(var _i13=0;_i13<cfg.borderInfo.length;_i13+=1){var rangeType=cfg.borderInfo[_i13].rangeType;if(rangeType==="range"){var borderRange=cfg.borderInfo[_i13].range;var emptyRange=[];for(var _j3=0;_j3<borderRange.length;_j3+=1){var bd_r1=borderRange[_j3].row[0];var bd_r2=borderRange[_j3].row[1];for(var _r3=start;_r3<=end;_r3+=1){if(_r3<borderRange[_j3].row[0]){bd_r1-=1;bd_r2-=1;}else if(_r3<=borderRange[_j3].row[1]){bd_r2-=1;}}if(bd_r2>=bd_r1){emptyRange.push({row:[bd_r1,bd_r2],column:borderRange[_j3].column});}}if(emptyRange.length>0){var bd_obj={rangeType:"range",borderType:cfg.borderInfo[_i13].borderType,style:cfg.borderInfo[_i13].style,color:cfg.borderInfo[_i13].color,range:emptyRange};borderInfo.push(bd_obj);}}else if(rangeType==="cell"){var row_index=cfg.borderInfo[_i13].value.row_index;if(row_index<start){borderInfo.push(cfg.borderInfo[_i13]);}else if(row_index>end){cfg.borderInfo[_i13].value.row_index=row_index-(end-start+1);borderInfo.push(cfg.borderInfo[_i13]);}}}cfg.borderInfo=borderInfo;}d.splice(start,slen);file.row=d.length;}else{var _d$;if(cfg.columnlen==null){cfg.columnlen={};}var columnlen_new={};var columnReadOnly_new={};lodash_default().forEach(cfg.columnlen,function(v,cstr){var c=parseFloat(cstr);if(c<start){columnlen_new[c]=cfg.columnlen[c];}else if(c>end){columnlen_new[c-slen]=cfg.columnlen[c];}});lodash_default().forEach(cfg.colReadOnly,function(v,cstr){var c=parseFloat(cstr);if(c<start){columnReadOnly_new[c]=cfg.colReadOnly[c];}else if(c>end){columnReadOnly_new[c-slen]=cfg.colReadOnly[c];}});cfg.columnlen=columnlen_new;cfg.colReadOnly=columnReadOnly_new;if(cfg.customWidth==null){cfg.customWidth={};var customWidth_new={};lodash_default().forEach(cfg.customWidth,function(v,rstr){var r=parseFloat(rstr);if(r<start){customWidth_new[r]=cfg.customWidth[r];}else if(r>end){customWidth_new[r-slen]=cfg.customWidth[r];}});cfg.customWidth=customWidth_new;}cfg.colReadOnly=columnReadOnly_new;if(cfg.colhidden==null){cfg.colhidden={};}var colhidden_new={};lodash_default().forEach(cfg.colhidden,function(v,cstr){var c=parseFloat(cstr);if(c<start){colhidden_new[c]=cfg.colhidden[c];}else if(c>end){colhidden_new[c-slen]=cfg.colhidden[c];}});cfg.colhidden=colhidden_new;if(cfg.borderInfo&&cfg.borderInfo.length>0){var _borderInfo2=[];for(var _i14=0;_i14<cfg.borderInfo.length;_i14+=1){var _rangeType2=cfg.borderInfo[_i14].rangeType;if(_rangeType2==="range"){var _borderRange2=cfg.borderInfo[_i14].range;var _emptyRange2=[];for(var _j4=0;_j4<_borderRange2.length;_j4+=1){var bd_c1=_borderRange2[_j4].column[0];var bd_c2=_borderRange2[_j4].column[1];for(var _c=start;_c<=end;_c+=1){if(_c<_borderRange2[_j4].column[0]){bd_c1-=1;bd_c2-=1;}else if(_c<=_borderRange2[_j4].column[1]){bd_c2-=1;}}if(bd_c2>=bd_c1){_emptyRange2.push({row:_borderRange2[_j4].row,column:[bd_c1,bd_c2]});}}if(_emptyRange2.length>0){var _bd_obj2={rangeType:"range",borderType:cfg.borderInfo[_i14].borderType,style:cfg.borderInfo[_i14].style,color:cfg.borderInfo[_i14].color,range:_emptyRange2};_borderInfo2.push(_bd_obj2);}}else if(_rangeType2==="cell"){var col_index=cfg.borderInfo[_i14].value.col_index;if(col_index<start){_borderInfo2.push(cfg.borderInfo[_i14]);}else if(col_index>end){cfg.borderInfo[_i14].value.col_index=col_index-(end-start+1);_borderInfo2.push(cfg.borderInfo[_i14]);}}}cfg.borderInfo=_borderInfo2;}for(var _r4=0;_r4<d.length;_r4+=1){d[_r4].splice(start,slen);}file.column=(_d$=d[0])===null||_d$===void 0?void 0:_d$.length;}ctx.luckysheet_select_save=undefined;file.data=d;file.config=cfg;file.calcChain=newCalcChain;if(newFilterObj!=null){file.filter=newFilterObj.filter;file.filter_select=newFilterObj.filter_select;}file.luckysheet_conditionformat_save=newCFarr;file.luckysheet_alternateformat_save=newAFarr;file.dataVerification=newDataVerification;file.hyperlink=newHyperlink;refreshLocalMergeData(merge_new,file);if(file.id===ctx.currentSheetId){ctx.config=cfg;}}function computeRowlenArr(ctx,rowHeight,cfg){var rowlenArr=[];var rh_height=0;for(var i=0;i<rowHeight;i+=1){var rowlen=ctx.defaultrowlen;if(cfg.rowlen!=null&&cfg.rowlen[i]!=null){rowlen=cfg.rowlen[i];}if(cfg.rowhidden!=null&&cfg.rowhidden[i]!=null){rowlen=cfg.rowhidden[i];rowlenArr.push(rh_height);continue;}else{rh_height+=rowlen+1;}rowlenArr.push(rh_height);}return rowlenArr;}function hideSelected(ctx,type){if(!ctx.luckysheet_select_save||ctx.luckysheet_select_save.length>1)return"noMulti";var index=getSheetIndex(ctx,ctx.currentSheetId);if(type==="row"){var _ctx$config$rowhidden;var rowhidden=(_ctx$config$rowhidden=ctx.config.rowhidden)!==null&&_ctx$config$rowhidden!==void 0?_ctx$config$rowhidden:{};var r1=ctx.luckysheet_select_save[0].row[0];var r2=ctx.luckysheet_select_save[0].row[1];var rowhiddenNumber=r2;for(var r=r1;r<=r2;r+=1){rowhidden[r]=0;}ctx.config.rowhidden=rowhidden;var rowLen=ctx.luckysheetfile[index].data.length;var isEndRow=rowLen-1===rowhiddenNumber||Object.keys(rowhidden).findIndex(function(o){return parseInt(o,10)-1===rowhiddenNumber;})>=0;if(isEndRow){ctx.luckysheet_select_save[0].row[0]-=1;ctx.luckysheet_select_save[0].row[1]-=1;}else{ctx.luckysheet_select_save[0].row[0]+=1;ctx.luckysheet_select_save[0].row[1]+=1;}}else if(type==="column"){var _ctx$config$colhidden;var colhidden=(_ctx$config$colhidden=ctx.config.colhidden)!==null&&_ctx$config$colhidden!==void 0?_ctx$config$colhidden:{};var c1=ctx.luckysheet_select_save[0].column[0];var c2=ctx.luckysheet_select_save[0].column[1];var colhiddenNumber=c2;for(var c=c1;c<=c2;c+=1){colhidden[c]=0;}ctx.config.colhidden=colhidden;var columnLen=ctx.luckysheetfile[index].data[0].length;var isEndColumn=columnLen-1===colhiddenNumber||Object.keys(colhidden).findIndex(function(o){return parseInt(o,10)-1===colhiddenNumber;})>=0;if(isEndColumn){ctx.luckysheet_select_save[0].column[0]-=1;ctx.luckysheet_select_save[0].column[1]-=1;}else{ctx.luckysheet_select_save[0].column[0]+=1;ctx.luckysheet_select_save[0].column[1]+=1;}}ctx.luckysheetfile[index].config=ctx.config;return"";}function showSelected(ctx,type){if(!ctx.luckysheet_select_save||ctx.luckysheet_select_save.length>1)return"noMulti";var index=getSheetIndex(ctx,ctx.currentSheetId);if(type==="row"){var _ctx$config$rowhidden2;var rowhidden=(_ctx$config$rowhidden2=ctx.config.rowhidden)!==null&&_ctx$config$rowhidden2!==void 0?_ctx$config$rowhidden2:{};var r1=ctx.luckysheet_select_save[0].row[0];var r2=ctx.luckysheet_select_save[0].row[1];for(var r=r1;r<=r2;r+=1){delete rowhidden[r];}ctx.config.rowhidden=rowhidden;}else if(type==="column"){var _ctx$config$colhidden2;var colhidden=(_ctx$config$colhidden2=ctx.config.colhidden)!==null&&_ctx$config$colhidden2!==void 0?_ctx$config$colhidden2:{};var c1=ctx.luckysheet_select_save[0].column[0];var c2=ctx.luckysheet_select_save[0].column[1];for(var c=c1;c<=c2;c+=1){delete colhidden[c];}ctx.config.colhidden=colhidden;}ctx.luckysheetfile[index].config=ctx.config;return"";}function isShowHidenCR(ctx){if(!ctx.luckysheet_select_save||!ctx.config.colhidden&&!ctx.config.rowhidden)return false;if(!!ctx.config.colhidden&&lodash_default().size(ctx.config.colhidden)>=1){var _ctx$luckysheet_selec,_ctx$luckysheet_selec2;var ctxColumn=(_ctx$luckysheet_selec=ctx.luckysheet_select_save[0])===null||_ctx$luckysheet_selec===void 0?void 0:(_ctx$luckysheet_selec2=_ctx$luckysheet_selec.column)===null||_ctx$luckysheet_selec2===void 0?void 0:_ctx$luckysheet_selec2[0];var isHidenColumn=Object.keys(ctx.config.colhidden).findIndex(function(o){return ctxColumn===parseInt(o,10);})>=0;if(isHidenColumn){return true;}}if(!!ctx.config.rowhidden&&lodash_default().size(ctx.config.rowhidden)>=1){var _ctx$luckysheet_selec3,_ctx$luckysheet_selec4;var ctxRow=(_ctx$luckysheet_selec3=ctx.luckysheet_select_save[0])===null||_ctx$luckysheet_selec3===void 0?void 0:(_ctx$luckysheet_selec4=_ctx$luckysheet_selec3.row)===null||_ctx$luckysheet_selec4===void 0?void 0:_ctx$luckysheet_selec4[0];var isHidenRow=Object.keys(ctx.config.rowhidden).findIndex(function(o){return ctxRow===parseInt(o,10);})>=0;if(isHidenRow){return true;}}return false;}function hideCRCount(ctx,type){var _ctx$config$rowhidden3,_ctx$config$colhidden3;var count=1;if(!ctx.luckysheet_select_save)return 0;var section=ctx.luckysheet_select_save[0];var rowhidden=(_ctx$config$rowhidden3=ctx.config.rowhidden)!==null&&_ctx$config$rowhidden3!==void 0?_ctx$config$rowhidden3:{};var colhidden=(_ctx$config$colhidden3=ctx.config.colhidden)!==null&&_ctx$config$colhidden3!==void 0?_ctx$config$colhidden3:{};if(type==="ArrowUp"||type==="ArrowDown"){var rowArr=Object.keys(rowhidden);if(type==="ArrowUp"){var row=section.row[0]-1;var rowIndex=rowArr.indexOf(row.toString());for(var i=rowIndex;i>=0;i-=1){if(parseInt(rowArr[i],10)===row){count+=1;row-=1;}else{return count;}}}else{var _row2=section.row[0]+1;var _rowIndex=rowArr.indexOf("".concat(_row2));for(var _i15=_rowIndex;_i15<rowArr.length;_i15+=1){if(parseInt(rowArr[_i15],10)===_row2){count+=1;_row2+=1;}else{return count;}}}}else if(type==="ArrowLeft"||type==="ArrowRight"){var columnArr=Object.keys(colhidden);if(type==="ArrowLeft"){var column=section.column[0]-1;var columnIndex=columnArr.indexOf(column.toString());for(var _i16=columnIndex;_i16>=0;_i16-=1){if(parseInt(columnArr[_i16],10)===column){count+=1;column-=1;}else{return count;}}}else{var _column=section.column[0]+1;var _columnIndex=columnArr.indexOf("".concat(_column));for(var _i17=_columnIndex;_i17<columnArr.length;_i17+=1){if(parseInt(columnArr[_i17],10)===_column){count+=1;_column+=1;}else{return count;}}}}return count;}function getAllSheets(ctx){return ctx.luckysheetfile;}function initSheetData(draftCtx,index,newData){var _lastRow$r,_lastCol$c;var celldata=newData.celldata,row=newData.row,column=newData.column;var lastRow=lodash_default().maxBy(celldata,"r");var lastCol=lodash_default().maxBy(celldata,"c");var lastRowNum=((_lastRow$r=lastRow===null||lastRow===void 0?void 0:lastRow.r)!==null&&_lastRow$r!==void 0?_lastRow$r:0)+1;var lastColNum=((_lastCol$c=lastCol===null||lastCol===void 0?void 0:lastCol.c)!==null&&_lastCol$c!==void 0?_lastCol$c:0)+1;if(row!=null&&column!=null&&row>0&&column>0){lastRowNum=Math.max(lastRowNum,row);lastColNum=Math.max(lastColNum,column);}else{lastRowNum=Math.max(lastRowNum,draftCtx.defaultrowNum);lastColNum=Math.max(lastColNum,draftCtx.defaultcolumnNum);}if(lastRowNum&&lastColNum){var expandedData=lodash_default().times(lastRowNum,function(){return lodash_default().times(lastColNum,function(){return null;});});celldata===null||celldata===void 0?void 0:celldata.forEach(function(d){expandedData[d.r][d.c]=d.v;});if(draftCtx.luckysheetfile[index]==null){newData.data=expandedData;delete newData.celldata;draftCtx.luckysheetfile.push(newData);}else{draftCtx.luckysheetfile[index].data=expandedData;delete draftCtx.luckysheetfile[index].celldata;}return expandedData;}return null;}function hideSheet(ctx,sheetId){var index=getSheetIndex(ctx,sheetId);ctx.luckysheetfile[index].hide=1;ctx.luckysheetfile[index].status=0;var shownSheets=ctx.luckysheetfile.filter(function(sheet){return lodash_default().isUndefined(sheet.hide)||(sheet===null||sheet===void 0?void 0:sheet.hide)!==1;});ctx.currentSheetId=shownSheets[0].id;}function showSheet(ctx,sheetId){var index=getSheetIndex(ctx,sheetId);ctx.luckysheetfile[index].hide=undefined;}function generateCopySheetName(ctx,sheetId){var _locale=locale(ctx),info=_locale.info;var copyWord="(".concat(info.copy);var SheetIndex=getSheetIndex(ctx,sheetId);var sheetName=ctx.luckysheetfile[SheetIndex].name;var copy_i=sheetName.indexOf(copyWord);var index=0;if(copy_i!==-1){sheetName=sheetName.toString().substring(0,copy_i);}var nameCopy=sheetName+copyWord;var sheetNames=[];for(var i=0;i<ctx.luckysheetfile.length;i+=1){var fileName=ctx.luckysheetfile[i].name;sheetNames.push(fileName);var st_i=fileName.indexOf(nameCopy);if(st_i===0){index=index||2;var ed_i=fileName.indexOf(")",st_i+nameCopy.length);var num=fileName.substring(st_i+nameCopy.length,ed_i);if(lodash_default().isNumber(num)){if(Number.parseInt(num,10)>=index){index=Number.parseInt(num,10)+1;}}}}var sheetCopyName;do{var postfix="".concat(copyWord+(index||""),")");var lengthLimit=31-postfix.length;sheetCopyName=sheetName;if(sheetCopyName.length>lengthLimit){sheetCopyName="".concat(sheetCopyName.slice(0,lengthLimit-1),"\u2026");}sheetCopyName+=postfix;index=(index||1)+1;}while(sheetNames.indexOf(sheetCopyName)!==-1);return sheetCopyName;}function copySheet(ctx,sheetId){var index$1=getSheetIndex(ctx,sheetId);var order=ctx.luckysheetfile[index$1].order+1;var sheetName=generateCopySheetName(ctx,sheetId);var sheetData=lodash_default().cloneDeep(ctx.luckysheetfile[index$1]);delete sheetData.id;delete sheetData.status;sheetData.celldata=dataToCelldata(sheetData.data);delete sheetData.data;addSheet$1(ctx,undefined,(0,v4/* default */.Z)(),ctx.luckysheetfile[index$1].isPivotTable,sheetName,sheetData);var sheetOrderList={};sheetOrderList[ctx.luckysheetfile[ctx.luckysheetfile.length-1].id]=order;setSheetOrder(ctx,sheetOrderList);}function calculateSheetFromula(ctx,id){var index$1=getSheetIndex(ctx,id);if(!ctx.luckysheetfile[index$1].data)return;for(var r=0;r<ctx.luckysheetfile[index$1].data.length;r+=1){for(var c=0;c<ctx.luckysheetfile[index$1].data[r].length;c+=1){var _ctx$luckysheetfile$i,_ctx$luckysheetfile$i2;if(!((_ctx$luckysheetfile$i=ctx.luckysheetfile[index$1].data[r][c])===null||_ctx$luckysheetfile$i===void 0?void 0:_ctx$luckysheetfile$i.f)){continue;}var result=execfunction(ctx,(_ctx$luckysheetfile$i2=ctx.luckysheetfile[index$1].data[r][c])===null||_ctx$luckysheetfile$i2===void 0?void 0:_ctx$luckysheetfile$i2.f,r,c,id);setCellValue$1(ctx,r,c,result[1],null);insertUpdateFunctionGroup(ctx,r,c,id);}}}function storeSheetParam(ctx){var index=getSheetIndex(ctx,ctx.currentSheetId);if(index==null)return;var file=ctx.luckysheetfile[index];file.config=ctx.config;file.luckysheet_select_save=ctx.luckysheet_select_save;file.luckysheet_selection_range=ctx.luckysheet_selection_range;file.zoomRatio=ctx.zoomRatio;}function storeSheetParamALL(ctx){storeSheetParam(ctx);var index=getSheetIndex(ctx,ctx.currentSheetId);if(index==null)return;ctx.luckysheetfile[index].config=ctx.config;}function changeSheet(ctx,id,isPivotInitial,isNewSheet,isCopySheet){var _ctx$hooks$beforeActi,_ctx$hooks;if(id===ctx.currentSheetId){return;}var file=ctx.luckysheetfile[getSheetIndex(ctx,id)];if(((_ctx$hooks$beforeActi=(_ctx$hooks=ctx.hooks).beforeActivateSheet)===null||_ctx$hooks$beforeActi===void 0?void 0:_ctx$hooks$beforeActi.call(_ctx$hooks,id))===false){return;}storeSheetParamALL(ctx);ctx.currentSheetId=id;if(file.isPivotTable){ctx.luckysheetcurrentisPivotTable=true;}else{ctx.luckysheetcurrentisPivotTable=false;}if(ctx.hooks.afterActivateSheet){setTimeout(function(){var _ctx$hooks$afterActiv,_ctx$hooks2;(_ctx$hooks$afterActiv=(_ctx$hooks2=ctx.hooks).afterActivateSheet)===null||_ctx$hooks$afterActiv===void 0?void 0:_ctx$hooks$afterActiv.call(_ctx$hooks2,id);});}}function addSheet(ctx,settings){var _ctx$hooks$beforeAddS,_ctx$hooks3;var newSheetID=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var isPivotTable=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var sheetName=arguments.length>4&&arguments[4]!==undefined?arguments[4]:undefined;var sheetData=arguments.length>5&&arguments[5]!==undefined?arguments[5]:undefined;if(ctx.allowEdit===false){return;}var order=ctx.luckysheetfile.length;var id=newSheetID!==null&&newSheetID!==void 0?newSheetID:settings===null||settings===void 0?void 0:settings.generateSheetId();var sheetname=sheetName||generateRandomSheetName(ctx.luckysheetfile,isPivotTable,ctx);if(!lodash_default().isNil(sheetData)){delete sheetData.data;ctx.luckysheetfile.forEach(function(sheet){sheet.order=sheet.order<sheetData.order?sheet.order:sheet.order+1;return sheet;});}var sheetconfig=lodash_default().isNil(sheetData)?{name:sheetName===undefined?sheetname:sheetName,status:0,order:order,id:id,row:ctx.defaultrowNum,column:ctx.defaultcolumnNum,config:{},pivotTable:null,isPivotTable:!!isPivotTable,zoomRatio:1}:sheetData;if(sheetName!==undefined)sheetconfig.name=sheetName;if(sheetconfig.id===undefined)sheetconfig.id=(0,v4/* default */.Z)();if(((_ctx$hooks$beforeAddS=(_ctx$hooks3=ctx.hooks).beforeAddSheet)===null||_ctx$hooks$beforeAddS===void 0?void 0:_ctx$hooks$beforeAddS.call(_ctx$hooks3,sheetconfig))===false){return;}ctx.luckysheetfile.push(sheetconfig);if(!newSheetID){changeSheet(ctx,id);}if(ctx.hooks.afterAddSheet){setTimeout(function(){var _ctx$hooks$afterAddSh,_ctx$hooks4;(_ctx$hooks$afterAddSh=(_ctx$hooks4=ctx.hooks).afterAddSheet)===null||_ctx$hooks$afterAddSh===void 0?void 0:_ctx$hooks$afterAddSh.call(_ctx$hooks4,sheetconfig);});}}function deleteSheet(ctx,id){var _ctx$hooks$beforeDele,_ctx$hooks5;if(ctx.allowEdit===false){return;}var arrIndex=getSheetIndex(ctx,id);if(arrIndex==null){return;}if(((_ctx$hooks$beforeDele=(_ctx$hooks5=ctx.hooks).beforeDeleteSheet)===null||_ctx$hooks$beforeDele===void 0?void 0:_ctx$hooks$beforeDele.call(_ctx$hooks5,id))===false){return;}ctx.luckysheetfile=ctx.luckysheetfile.map(function(sheet){sheet.order=sheet.order<ctx.luckysheetfile[arrIndex].order?sheet.order:sheet.order-1;return sheet;});ctx.luckysheetfile.splice(arrIndex,1);if(id===ctx.currentSheetId){var _orderSheets$;var shownSheets=lodash_default().cloneDeep(ctx.luckysheetfile).filter(function(singleSheet){return lodash_default().isUndefined(singleSheet.hide)||singleSheet.hide!==1;});var orderSheets=lodash_default().sortBy(shownSheets,function(sheet){return sheet.order;});ctx.currentSheetId=orderSheets===null||orderSheets===void 0?void 0:(_orderSheets$=orderSheets[0])===null||_orderSheets$===void 0?void 0:_orderSheets$.id;}if(ctx.hooks.afterDeleteSheet){setTimeout(function(){var _ctx$hooks$afterDelet,_ctx$hooks6;(_ctx$hooks$afterDelet=(_ctx$hooks6=ctx.hooks).afterDeleteSheet)===null||_ctx$hooks$afterDelet===void 0?void 0:_ctx$hooks$afterDelet.call(_ctx$hooks6,id);});}}function updateSheet(ctx,newData){newData.forEach(function(newDatum){var data=newDatum.data,row=newDatum.row,column=newDatum.column;var index=getSheetIndex(ctx,newDatum.id);if(data!=null){var lastRowNum=data.length;var lastColNum=data[0].length;if(row!=null&&column!=null&&row>0&&column>0){lastRowNum=Math.max(lastRowNum,row);lastColNum=Math.max(lastColNum,column);}else{lastRowNum=Math.max(lastRowNum,ctx.defaultrowNum);lastColNum=Math.max(lastColNum,ctx.defaultcolumnNum);}var expandedData=lodash_default().times(lastRowNum,function(){return lodash_default().times(lastColNum,function(){return null;});});for(var i=0;i<data.length;i+=1){for(var j=0;j<data[i].length;j+=1){expandedData[i][j]=data[i][j];}}newDatum.data=expandedData;if(ctx.luckysheetfile[index]==null){ctx.luckysheetfile.push(newDatum);}else{ctx.luckysheetfile[index]=newDatum;}}else if(newDatum.celldata!=null){initSheetData(ctx,index,newDatum);}});}function editSheetName(ctx,editable){var _ctx$hooks$beforeUpda,_ctx$hooks7;var index=getSheetIndex(ctx,ctx.currentSheetId);if(ctx.allowEdit===false){if(index==null)return;editable.innerText=ctx.luckysheetfile[index].name;return;}var _locale=locale(ctx),sheetconfig=_locale.sheetconfig;var oldtxt=editable.dataset.oldText||"";var txt=editable.innerText;if(((_ctx$hooks$beforeUpda=(_ctx$hooks7=ctx.hooks).beforeUpdateSheetName)===null||_ctx$hooks$beforeUpda===void 0?void 0:_ctx$hooks$beforeUpda.call(_ctx$hooks7,ctx.currentSheetId,oldtxt,txt))===false){return;}if(txt.length===0){editable.innerText=oldtxt;throw new Error(sheetconfig.sheetNamecannotIsEmptyError);}if(txt.length>31||txt.charAt(0)==="'"||txt.charAt(txt.length-1)==="'"||/[：:\\/？?*[\]]+/.test(txt)){editable.innerText=oldtxt;throw new Error(sheetconfig.sheetNameSpecCharError);}if(index==null)return;for(var i=0;i<ctx.luckysheetfile.length;i+=1){if(index!==i&&ctx.luckysheetfile[i].name===txt){editable.innerText=oldtxt;return;}}ctx.luckysheetfile[index].name=txt;if(ctx.hooks.afterUpdateSheetName){setTimeout(function(){var _ctx$hooks$afterUpdat,_ctx$hooks8;(_ctx$hooks$afterUpdat=(_ctx$hooks8=ctx.hooks).afterUpdateSheetName)===null||_ctx$hooks$afterUpdat===void 0?void 0:_ctx$hooks$afterUpdat.call(_ctx$hooks8,ctx.currentSheetId,oldtxt,txt);});}}function expandRowsAndColumns(data,rowsToAdd,columnsToAdd){if(rowsToAdd<=0&&columnsToAdd<=0){return data;}if(data.length+rowsToAdd>=10000){throw new Error("This action would increase the number of rows in the workbook above the limit of 10000.");}if(data[0].length+columnsToAdd>=1000){throw new Error("This action would increase the number of columns in the workbook above the limit of 1000.");}if(rowsToAdd<=0){rowsToAdd=0;}if(columnsToAdd<=0){columnsToAdd=0;}var currentColLen=0;if(data.length>0){currentColLen=data[0].length;}for(var r=0;r<data.length;r+=1){for(var i=0;i<columnsToAdd;i+=1){data[r].push(null);}}for(var _r=0;_r<rowsToAdd;_r+=1){data.push(lodash_default().times(currentColLen+columnsToAdd,function(){return null;}));}return data;}function mergeCells(ctx,sheetId,ranges,type){var idx=getSheetIndex(ctx,sheetId);if(idx==null)return;var sheet=ctx.luckysheetfile[idx];var cfg=sheet.config||{};if(cfg.merge==null){cfg.merge={};}var d=sheet.data;if(type==="merge-cancel"){for(var i=0;i<ranges.length;i+=1){var range=ranges[i];var r1=range.row[0];var r2=range.row[1];var c1=range.column[0];var c2=range.column[1];if(r1===r2&&c1===c2){continue;}var fv={};for(var r=r1;r<=r2;r+=1){for(var c=c1;c<=c2;c+=1){var cell=d[r][c];if(cell!=null&&cell.mc!=null){var mc_r=cell.mc.r;var mc_c=cell.mc.c;if("rs"in cell.mc){delete cell.mc;delete cfg.merge["".concat(mc_r,"_").concat(mc_c)];fv["".concat(mc_r,"_").concat(mc_c)]=lodash_default().cloneDeep(cell)||{};}else{var cell_clone=lodash_default().cloneDeep(fv["".concat(mc_r,"_").concat(mc_c)]);delete cell_clone.v;delete cell_clone.m;delete cell_clone.ct;delete cell_clone.f;delete cell_clone.spl;d[r][c]=cell_clone;}}}}}}else{var isHasMc=false;for(var _i=0;_i<ranges.length;_i+=1){var _range=ranges[_i];var _r=_range.row[0];var _r2=_range.row[1];var _c=_range.column[0];var _c2=_range.column[1];for(var _r3=_r;_r3<=_r2;_r3+=1){for(var _c3=_c;_c3<=_c2;_c3+=1){var _cell=d[_r3][_c3];if(_cell===null||_cell===void 0?void 0:_cell.mc){isHasMc=true;break;}}}}if(isHasMc){for(var _i2=0;_i2<ranges.length;_i2+=1){var _range2=ranges[_i2];var _r4=_range2.row[0];var _r5=_range2.row[1];var _c4=_range2.column[0];var _c5=_range2.column[1];if(_r4===_r5&&_c4===_c5){continue;}var _fv={};for(var _r6=_r4;_r6<=_r5;_r6+=1){for(var _c6=_c4;_c6<=_c5;_c6+=1){var _cell2=d[_r6][_c6];if(_cell2!=null&&_cell2.mc!=null){var _mc_r=_cell2.mc.r;var _mc_c=_cell2.mc.c;if("rs"in _cell2.mc){delete _cell2.mc;delete cfg.merge["".concat(_mc_r,"_").concat(_mc_c)];_fv["".concat(_mc_r,"_").concat(_mc_c)]=lodash_default().cloneDeep(_cell2)||{};}else{var _cell_clone=lodash_default().cloneDeep(_fv["".concat(_mc_r,"_").concat(_mc_c)]);delete _cell_clone.v;delete _cell_clone.m;delete _cell_clone.ct;delete _cell_clone.f;delete _cell_clone.spl;d[_r6][_c6]=_cell_clone;}}}}}}else{for(var _i3=0;_i3<ranges.length;_i3+=1){var _range3=ranges[_i3];var _r7=_range3.row[0];var _r8=_range3.row[1];var _c7=_range3.column[0];var _c8=_range3.column[1];if(_r7===_r8&&_c7===_c8){continue;}if(type==="merge-all"){var _fv2={};var isfirst=false;for(var _r9=_r7;_r9<=_r8;_r9+=1){for(var _c9=_c7;_c9<=_c8;_c9+=1){var _cell3=d[_r9][_c9];if(_cell3!=null&&(isInlineStringCT(_cell3.ct)||!lodash_default().isEmpty(_cell3.v)||_cell3.f!=null)&&!isfirst){_fv2=lodash_default().cloneDeep(_cell3)||{};isfirst=true;}d[_r9][_c9]={mc:{r:_r7,c:_c7}};}}d[_r7][_c7]=_fv2;var a=d[_r7][_c7];if(!a)return;a.mc={r:_r7,c:_c7,rs:_r8-_r7+1,cs:_c8-_c7+1};cfg.merge["".concat(_r7,"_").concat(_c7)]={r:_r7,c:_c7,rs:_r8-_r7+1,cs:_c8-_c7+1};}else if(type==="merge-vertical"){for(var _c10=_c7;_c10<=_c8;_c10+=1){var _fv3={};var _isfirst=false;for(var _r10=_r7;_r10<=_r8;_r10+=1){var _cell4=d[_r10][_c10];if(_cell4!=null&&(!lodash_default().isEmpty(_cell4.v)||_cell4.f!=null)&&!_isfirst){_fv3=lodash_default().cloneDeep(_cell4)||{};_isfirst=true;}d[_r10][_c10]={mc:{r:_r7,c:_c10}};}d[_r7][_c10]=_fv3;var _a=d[_r7][_c10];if(!_a)return;_a.mc={r:_r7,c:_c10,rs:_r8-_r7+1,cs:1};cfg.merge["".concat(_r7,"_").concat(_c10)]={r:_r7,c:_c10,rs:_r8-_r7+1,cs:1};}}else if(type==="merge-horizontal"){for(var _r11=_r7;_r11<=_r8;_r11+=1){var _fv4={};var _isfirst2=false;for(var _c11=_c7;_c11<=_c8;_c11+=1){var _cell5=d[_r11][_c11];if(_cell5!=null&&(!lodash_default().isEmpty(_cell5.v)||_cell5.f!=null)&&!_isfirst2){_fv4=lodash_default().cloneDeep(_cell5)||{};_isfirst2=true;}d[_r11][_c11]={mc:{r:_r11,c:_c7}};}d[_r11][_c7]=_fv4;var _a2=d[_r11][_c7];if(!_a2)return;_a2.mc={r:_r11,c:_c7,rs:1,cs:_c8-_c7+1};cfg.merge["".concat(_r11,"_").concat(_c7)]={r:_r11,c:_c7,rs:1,cs:_c8-_c7+1};}}}}}sheet.config=cfg;if(sheet.id===ctx.currentSheetId){ctx.config=cfg;}}function runExecFunction(ctx,range,index,data){ctx.formulaCache.execFunctionExist=[];for(var s=0;s<range.length;s+=1){for(var r=range[s].row[0];r<=range[s].row[1];r+=1){for(var c=range[s].column[0];c<=range[s].column[1];c+=1){ctx.formulaCache.execFunctionExist.push({r:r,c:c,i:index});}}}ctx.formulaCache.execFunctionExist.reverse();execFunctionGroup(ctx,null,null,null,null,data);ctx.formulaCache.execFunctionGlobalData=null;}function jfrefreshgrid(ctx,data,range){var isRunExecFunction=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;if(data==null){data=getFlowdata(ctx);}if(range==null){range=ctx.luckysheet_select_save;if(range==null)return;}if(isRunExecFunction){runExecFunction(ctx,range,ctx.currentSheetId,data);}}function orderbydata(isAsc,index,data){if(isAsc==null){isAsc=true;}var a=function a(x,y){var x1=x[index];var y1=y[index];if(x[index]!=null){x1=x[index].v;}if(y[index]!=null){y1=y[index].v;}if(isRealNull(x1)){return isAsc?1:-1;}if(isRealNull(y1)){return isAsc?-1:1;}if(isdatetime(x1)&&isdatetime(y1)){return diff(x1,y1);}if(isRealNum(x1)&&isRealNum(y1)){var y1Value=numeral_default()(y1).value();var x1Value=numeral_default()(x1).value();if(y1Value==null||x1Value==null)return null;return x1Value-y1Value;}if(!isRealNum(x1)&&!isRealNum(y1)){return x1.localeCompare(y1,"zh");}if(!isRealNum(x1)){return 1;}if(!isRealNum(y1)){return-1;}return 0;};var d=function d(x,y){return a(y,x);};var sortedData=lodash_default().clone(data);sortedData.sort(isAsc?a:d);var rowOffsets=sortedData.map(function(r,i){var origIndex=lodash_default().findIndex(data,function(origR){return origR===r;});return i-origIndex;});return{sortedData:sortedData,rowOffsets:rowOffsets};}function sortDataRange(ctx,sheetData,dataRange,index,isAsc,str,edr,stc,edc){var _orderbydata=orderbydata(isAsc,index,dataRange),sortedData=_orderbydata.sortedData,rowOffsets=_orderbydata.rowOffsets;for(var r=str;r<=edr;r+=1){for(var c=stc;c<=edc;c+=1){var cell=sortedData[r-str][c-stc];if(cell===null||cell===void 0?void 0:cell.f){var _cell$ct;var moveOffset=rowOffsets[r-str];var func=cell===null||cell===void 0?void 0:cell.f;if(moveOffset>0){func="=".concat(functionCopy(ctx,func,"down",moveOffset));}else if(moveOffset<0){func="=".concat(functionCopy(ctx,func,"up",-moveOffset));}var funcV=execfunction(ctx,func,r,c,undefined,undefined,true);var _funcV=index_esm_slicedToArray(funcV,3);cell.v=_funcV[1];cell.f=_funcV[2];cell.m=update(((_cell$ct=cell.ct)===null||_cell$ct===void 0?void 0:_cell$ct.fa)||"General",cell.v);}sheetData[r][c]=cell;}}jfrefreshgrid(ctx,sheetData,[{row:[str,edr],column:[stc,edc]}]);}function sortSelection(ctx,isAsc){var colIndex=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;if(ctx.allowEdit===false)return;if(ctx.luckysheet_select_save==null)return;if(ctx.luckysheet_select_save.length>1){return;}if(isAsc==null){isAsc=true;}var flowdata=getFlowdata(ctx);var d=flowdata;if(d==null)return;var r1=ctx.luckysheet_select_save[0].row[0];var r2=ctx.luckysheet_select_save[0].row[1];var c1=ctx.luckysheet_select_save[0].column[0];var c2=ctx.luckysheet_select_save[0].column[1];var str=null;var edr;for(var r=r1;r<=r2;r+=1){if(d[r]!=null&&d[r][c1]!=null){var cell=d[r][c1];if(cell==null)return;if(cell.mc!=null||isRealNull(cell.v)){continue;}if(str==null&&/[\u4e00-\u9fa5]+/g.test("".concat(cell.v))){str=r+1;edr=r+1;continue;}if(str==null){str=r;}edr=r;}}if(str==null||str>r2){return;}var hasMc=false;var data=[];if(edr==null)return;for(var _r=str;_r<=edr;_r+=1){var data_row=[];for(var c=c1;c<=c2;c+=1){var _d$_r$c;if(d[_r][c]!=null&&((_d$_r$c=d[_r][c])===null||_d$_r$c===void 0?void 0:_d$_r$c.mc)!=null){hasMc=true;break;}data_row.push(d[_r][c]);}data.push(data_row);}if(hasMc){return;}sortDataRange(ctx,d,data,colIndex,isAsc,str,edr,c1,c2);}function getCellRowColumn(ctx,e,container,scrollX,scrollY){var flowdata=getFlowdata(ctx);if(flowdata==null)return undefined;var scrollLeft=scrollX.scrollLeft;var scrollTop=scrollY.scrollTop;var rect=container.getBoundingClientRect();var x=e.pageX-rect.left-ctx.rowHeaderWidth;var y=e.pageY-rect.top-ctx.columnHeaderHeight;x+=scrollLeft;y+=scrollTop;var r=rowLocation(y,ctx.visibledatarow)[2];var c=colLocation(x,ctx.visibledatacolumn)[2];var margeset=mergeBorder(ctx,flowdata,r,c);if(margeset){var _margeset$row=index_esm_slicedToArray(margeset.row,3);r=_margeset$row[2];var _margeset$column=index_esm_slicedToArray(margeset.column,3);c=_margeset$column[2];}return{r:r,c:c};}function getCellHyperlink(ctx,r,c){var sheetIndex=getSheetIndex(ctx,ctx.currentSheetId);if(sheetIndex!=null){var _ctx$luckysheetfile$s;return(_ctx$luckysheetfile$s=ctx.luckysheetfile[sheetIndex].hyperlink)===null||_ctx$luckysheetfile$s===void 0?void 0:_ctx$luckysheetfile$s["".concat(r,"_").concat(c)];}return undefined;}function saveHyperlink(ctx,r,c,linkText,linkType,linkAddress){var sheetIndex=getSheetIndex(ctx,ctx.currentSheetId);var flowdata=getFlowdata(ctx);if(sheetIndex!=null&&flowdata!=null&&linkType&&linkAddress){var cell=flowdata[r][c];if(cell==null)cell={};lodash_default().set(ctx.luckysheetfile[sheetIndex],["hyperlink","".concat(r,"_").concat(c)],{linkType:linkType,linkAddress:linkAddress});cell.fc="rgb(0, 0, 255)";cell.un=1;cell.v=linkText||linkAddress;cell.m=linkText||linkAddress;cell.hl={r:r,c:c,id:ctx.currentSheetId};flowdata[r][c]=cell;ctx.linkCard=undefined;}}function removeHyperlink(ctx,r,c){var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;var sheetIndex=getSheetIndex(ctx,ctx.currentSheetId);var flowdata=getFlowdata(ctx);if(flowdata!=null&&sheetIndex!=null){var hyperlink=lodash_default().omit(ctx.luckysheetfile[sheetIndex].hyperlink,"".concat(r,"_").concat(c));lodash_default().set(ctx.luckysheetfile[sheetIndex],"hyperlink",hyperlink);var cell=flowdata[r][c];if(cell!=null){flowdata[r][c]={v:cell.v,m:cell.m};}}ctx.linkCard=undefined;}function showLinkCard(ctx,r,c){var _ctx$linkCard,_ctx$linkCard2,_getFlowdata,_getFlowdata$r,_ctx$linkCard3,_ctx$linkCard4,_ctx$linkCard5;var isEditing=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var isMouseDown=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;if((_ctx$linkCard=ctx.linkCard)===null||_ctx$linkCard===void 0?void 0:_ctx$linkCard.selectingCellRange)return;if("".concat(r,"_").concat(c)===((_ctx$linkCard2=ctx.linkCard)===null||_ctx$linkCard2===void 0?void 0:_ctx$linkCard2.rc))return;var link=getCellHyperlink(ctx,r,c);var cell=(_getFlowdata=getFlowdata(ctx))===null||_getFlowdata===void 0?void 0:(_getFlowdata$r=_getFlowdata[r])===null||_getFlowdata$r===void 0?void 0:_getFlowdata$r[c];if(!isEditing&&link==null&&(isMouseDown||!((_ctx$linkCard3=ctx.linkCard)===null||_ctx$linkCard3===void 0?void 0:_ctx$linkCard3.isEditing)||ctx.linkCard.sheetId!==ctx.currentSheetId)){ctx.linkCard=undefined;return;}if(isEditing||link!=null&&(!((_ctx$linkCard4=ctx.linkCard)===null||_ctx$linkCard4===void 0?void 0:_ctx$linkCard4.isEditing)||isMouseDown)||((_ctx$linkCard5=ctx.linkCard)===null||_ctx$linkCard5===void 0?void 0:_ctx$linkCard5.sheetId)!==ctx.currentSheetId){var col_pre=c-1===-1?0:ctx.visibledatacolumn[c-1];var row=ctx.visibledatarow[r];ctx.linkCard={sheetId:ctx.currentSheetId,r:r,c:c,rc:"".concat(r,"_").concat(c),originText:(cell===null||cell===void 0?void 0:cell.v)==null?"":"".concat(cell.v),originType:(link===null||link===void 0?void 0:link.linkType)||"webpage",originAddress:(link===null||link===void 0?void 0:link.linkAddress)||"",position:{cellLeft:col_pre,cellBottom:row},isEditing:isEditing};}}function goToLink(ctx,r,c,linkType,linkAddress,scrollbarX,scrollbarY){var _ctx$luckysheetfile$c;var currSheetIndex=getSheetIndex(ctx,ctx.currentSheetId);if(currSheetIndex==null)return;if(((_ctx$luckysheetfile$c=ctx.luckysheetfile[currSheetIndex].hyperlink)===null||_ctx$luckysheetfile$c===void 0?void 0:_ctx$luckysheetfile$c["".concat(r,"_").concat(c)])==null){return;}if(linkType==="webpage"){if(!/^http[s]?:\/\//.test(linkAddress)){linkAddress="https://".concat(linkAddress);}window.open(linkAddress);}else if(linkType==="sheet"){var sheetId;lodash_default().forEach(ctx.luckysheetfile,function(f){if(linkAddress===f.name){sheetId=f.id;}});if(sheetId!=null)changeSheet(ctx,sheetId);}else{var range=lodash_default().cloneDeep(getcellrange(ctx,linkAddress));if(range==null)return;var row_pre=range.row[0]-1===-1?0:ctx.visibledatarow[range.row[0]-1];var col_pre=range.column[0]-1===-1?0:ctx.visibledatacolumn[range.column[0]-1];scrollbarX.scrollLeft=col_pre;scrollbarY.scrollLeft=row_pre;ctx.luckysheet_select_save=normalizeSelection(ctx,[range]);changeSheet(ctx,range.sheetId);}ctx.linkCard=undefined;}function isLinkValid(ctx,linkType,linkAddress){if(!linkAddress)return{isValid:false,tooltip:""};var _locale=locale(ctx),insertLink=_locale.insertLink;if(linkType==="webpage"){if(!/^http[s]?:\/\//.test(linkAddress)){linkAddress="https://".concat(linkAddress);}if(!/^http[s]?:\/\/([\w\-\.]+)+[\w-]*([\w\-\.\/\?%&=]+)?$/gi.test(linkAddress))return{isValid:false,tooltip:insertLink.tooltipInfo1};}if(linkType==="cellrange"&&!iscelldata(linkAddress)){return{isValid:false,tooltip:insertLink.invalidCellRangeTip};}return{isValid:true,tooltip:""};}function onRangeSelectionModalMoveStart(ctx,globalCache,e){var box=document.querySelector("div.fortune-link-modify-modal.range-selection-modal");if(!box)return;var _box$getBoundingClien=box.getBoundingClientRect(),width=_box$getBoundingClien.width,height=_box$getBoundingClien.height;var left=box.offsetLeft;var top=box.offsetTop;var initialPosition={left:left,top:top,width:width,height:height};lodash_default().set(globalCache,"linkCard.rangeSelectionModal",{cursorMoveStartPosition:{x:e.pageX,y:e.pageY},initialPosition:initialPosition});}function onRangeSelectionModalMove(globalCache,e){var _globalCache$linkCard;var moveProps=(_globalCache$linkCard=globalCache.linkCard)===null||_globalCache$linkCard===void 0?void 0:_globalCache$linkCard.rangeSelectionModal;if(moveProps==null)return;var modal=document.querySelector("div.fortune-link-modify-modal.range-selection-modal");var _moveProps$cursorMove=moveProps.cursorMoveStartPosition,startX=_moveProps$cursorMove.x,startY=_moveProps$cursorMove.y;var _moveProps$initialPos=moveProps.initialPosition,top=_moveProps$initialPos.top,left=_moveProps$initialPos.left;left+=e.pageX-startX;top+=e.pageY-startY;if(top<0)top=0;modal.style.left="".concat(left,"px");modal.style.top="".concat(top,"px");}function onRangeSelectionModalMoveEnd(globalCache){lodash_default().set(globalCache,"linkCard.rangeSelectionModal",undefined);}function cfSplitRange(range1,range2,range3,type){var range=[];var offset_r=range3.row[0]-range2.row[0];var offset_c=range3.column[0]-range2.column[0];var r1=range1.row[0];var r2=range1.row[1];var c1=range1.column[0];var c2=range1.column[1];if(r1>=range2.row[0]&&r2<=range2.row[1]&&c1>=range2.column[0]&&c2<=range2.column[1]){if(type==="allPart"){range=[{row:[r1+offset_r,r2+offset_r],column:[c1+offset_c,c2+offset_c]}];}else if(type==="restPart"){range=[];}else if(type==="operatePart"){range=[{row:[r1+offset_r,r2+offset_r],column:[c1+offset_c,c2+offset_c]}];}}else if(r1>=range2.row[0]&&r1<=range2.row[1]&&c1>=range2.column[0]&&c2<=range2.column[1]){if(type==="allPart"){range=[{row:[range2.row[1]+1,r2],column:[c1,c2]},{row:[r1+offset_r,range2.row[1]+offset_r],column:[c1+offset_c,c2+offset_c]}];}else if(type==="restPart"){range=[{row:[range2.row[1]+1,r2],column:[c1,c2]}];}else if(type==="operatePart"){range=[{row:[r1+offset_r,range2.row[1]+offset_r],column:[c1+offset_c,c2+offset_c]}];}}else if(r2>=range2.row[0]&&r2<=range2.row[1]&&c1>=range2.column[0]&&c2<=range2.column[1]){if(type==="allPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0]+offset_r,r2+offset_r],column:[c1+offset_c,c2+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]}];}else if(type==="operatePart"){range=[{row:[range2.row[0]+offset_r,r2+offset_r],column:[c1+offset_c,c2+offset_c]}];}}else if(r1<range2.row[0]&&r2>range2.row[1]&&c1>=range2.column[0]&&c2<=range2.column[1]){if(type==="allPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]},{row:[range2.row[0]+offset_r,range2.row[1]+offset_r],column:[c1+offset_c,c2+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]}];}else if(type==="operatePart"){range=[{row:[range2.row[0]+offset_r,range2.row[1]+offset_r],column:[c1+offset_c,c2+offset_c]}];}}else if(c1>=range2.column[0]&&c1<=range2.column[1]&&r1>=range2.row[0]&&r2<=range2.row[1]){if(type==="allPart"){range=[{row:[r1,r2],column:[range2.column[1]+1,c2]},{row:[r1+offset_r,r2+offset_r],column:[c1+offset_c,range2.column[1]+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,r2],column:[range2.column[1]+1,c2]}];}else if(type==="operatePart"){range=[{row:[r1+offset_r,r2+offset_r],column:[c1+offset_c,range2.column[1]+offset_c]}];}}else if(c2>=range2.column[0]&&c2<=range2.column[1]&&r1>=range2.row[0]&&r2<=range2.row[1]){if(type==="allPart"){range=[{row:[r1,r2],column:[c1,range2.column[0]-1]},{row:[r1+offset_r,r2+offset_r],column:[range2.column[0]+offset_c,c2+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,r2],column:[c1,range2.column[0]-1]}];}else if(type==="operatePart"){range=[{row:[r1+offset_r,r2+offset_r],column:[range2.column[0]+offset_c,c2+offset_c]}];}}else if(c1<range2.column[0]&&c2>range2.column[1]&&r1>=range2.row[0]&&r2<=range2.row[1]){if(type==="allPart"){range=[{row:[r1,r2],column:[c1,range2.column[0]-1]},{row:[r1,r2],column:[range2.column[1]+1,c2]},{row:[r1+offset_r,r2+offset_r],column:[range2.column[0]+offset_c,range2.column[1]+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,r2],column:[c1,range2.column[0]-1]},{row:[r1,r2],column:[range2.column[1]+1,c2]}];}else if(type==="operatePart"){range=[{row:[r1+offset_r,r2+offset_r],column:[range2.column[0]+offset_c,range2.column[1]+offset_c]}];}}else if(r1>=range2.row[0]&&r1<=range2.row[1]&&c1>=range2.column[0]&&c1<=range2.column[1]){if(type==="allPart"){range=[{row:[r1,range2.row[1]],column:[range2.column[1]+1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]},{row:[r1+offset_r,range2.row[1]+offset_r],column:[c1+offset_c,range2.column[1]+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[1]],column:[range2.column[1]+1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]}];}else if(type==="operatePart"){range=[{row:[r1+offset_r,range2.row[1]+offset_r],column:[c1+offset_c,range2.column[1]+offset_c]}];}}else if(r1>=range2.row[0]&&r1<=range2.row[1]&&c2>=range2.column[0]&&c2<=range2.column[1]){if(type==="allPart"){range=[{row:[r1,range2.row[1]],column:[c1,range2.column[0]-1]},{row:[range2.row[1]+1,r2],column:[c1,c2]},{row:[r1+offset_r,range2.row[1]+offset_r],column:[range2.column[0]+offset_c,c2+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[1]],column:[c1,range2.column[0]-1]},{row:[range2.row[1]+1,r2],column:[c1,c2]}];}else if(type==="operatePart"){range=[{row:[r1+offset_r,range2.row[1]+offset_r],column:[range2.column[0]+offset_c,c2+offset_c]}];}}else if(r2>=range2.row[0]&&r2<=range2.row[1]&&c1>=range2.column[0]&&c1<=range2.column[1]){if(type==="allPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],r2],column:[range2.column[1]+1,c2]},{row:[range2.row[0]+offset_r,r2+offset_r],column:[c1+offset_c,range2.column[1]+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],r2],column:[range2.column[1]+1,c2]}];}else if(type==="operatePart"){range=[{row:[range2.row[0]+offset_r,r2+offset_r],column:[c1+offset_c,range2.column[1]+offset_c]}];}}else if(r2>=range2.row[0]&&r2<=range2.row[1]&&c2>=range2.column[0]&&c2<=range2.column[1]){if(type==="allPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],r2],column:[c1,range2.column[0]-1]},{row:[range2.row[0]+offset_r,r2+offset_r],column:[range2.column[0]+offset_c,c2+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],r2],column:[c1,range2.column[0]-1]}];}else if(type==="operatePart"){range=[{row:[range2.row[0]+offset_r,r2+offset_r],column:[range2.column[0]+offset_c,c2+offset_c]}];}}else if(r1<range2.row[0]&&r2>range2.row[1]&&c1>=range2.column[0]&&c1<=range2.column[1]){if(type==="allPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],range2.row[1]],column:[range2.column[1]+1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]},{row:[range2.row[0]+offset_r,range2.row[1]+offset_r],column:[c1+offset_c,range2.column[1]+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],range2.row[1]],column:[range2.column[1]+1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]}];}else if(type==="operatePart"){range=[{row:[range2.row[0]+offset_r,range2.row[1]+offset_r],column:[c1+offset_c,range2.column[1]+offset_c]}];}}else if(r1<range2.row[0]&&r2>range2.row[1]&&c2>=range2.column[0]&&c2<=range2.column[1]){if(type==="allPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],range2.row[1]],column:[c1,range2.column[0]-1]},{row:[range2.row[1]+1,r2],column:[c1,c2]},{row:[range2.row[0]+offset_r,range2.row[1]+offset_r],column:[range2.column[0]+offset_c,c2+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],range2.row[1]],column:[c1,range2.column[0]-1]},{row:[range2.row[1]+1,r2],column:[c1,c2]}];}else if(type==="operatePart"){range=[{row:[range2.row[0]+offset_r,range2.row[1]+offset_r],column:[range2.column[0]+offset_c,c2+offset_c]}];}}else if(c1<range2.column[0]&&c2>range2.column[1]&&r1>=range2.row[0]&&r1<=range2.row[1]){if(type==="allPart"){range=[{row:[r1,range2.row[1]],column:[c1,range2.column[0]-1]},{row:[r1,range2.row[1]],column:[range2.column[1]+1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]},{row:[r1+offset_r,range2.row[1]+offset_r],column:[range2.column[0]+offset_c,range2.column[1]+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[1]],column:[c1,range2.column[0]-1]},{row:[r1,range2.row[1]],column:[range2.column[1]+1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]}];}else if(type==="operatePart"){range=[{row:[r1+offset_r,range2.row[1]+offset_r],column:[range2.column[0]+offset_c,range2.column[1]+offset_c]}];}}else if(c1<range2.column[0]&&c2>range2.column[1]&&r2>=range2.row[0]&&r2<=range2.row[1]){if(type==="allPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],r2],column:[c1,range2.column[0]-1]},{row:[range2.row[0],r2],column:[range2.column[1]+1,c2]},{row:[range2.row[0]+offset_r,r2+offset_r],column:[range2.column[0]+offset_c,range2.column[1]+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],r2],column:[c1,range2.column[0]-1]},{row:[range2.row[0],r2],column:[range2.column[1]+1,c2]}];}else if(type==="operatePart"){range=[{row:[range2.row[0]+offset_r,r2+offset_r],column:[range2.column[0]+offset_c,range2.column[1]+offset_c]}];}}else if(r1<range2.row[0]&&r2>range2.row[1]&&c1<range2.column[0]&&c2>range2.column[1]){if(type==="allPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],range2.row[1]],column:[c1,range2.column[0]-1]},{row:[range2.row[0],range2.row[1]],column:[range2.column[1]+1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]},{row:[range2.row[0]+offset_r,range2.row[1]+offset_r],column:[range2.column[0]+offset_c,range2.column[1]+offset_c]}];}else if(type==="restPart"){range=[{row:[r1,range2.row[0]-1],column:[c1,c2]},{row:[range2.row[0],range2.row[1]],column:[c1,range2.column[0]-1]},{row:[range2.row[0],range2.row[1]],column:[range2.column[1]+1,c2]},{row:[range2.row[1]+1,r2],column:[c1,c2]}];}else if(type==="operatePart"){range=[{row:[range2.row[0]+offset_r,range2.row[1]+offset_r],column:[range2.column[0]+offset_c,range2.column[1]+offset_c]}];}}else{if(type==="allPart"){range=[{row:[r1,r2],column:[c1,c2]}];}else if(type==="restPart"){range=[{row:[r1,r2],column:[c1,c2]}];}else if(type==="operatePart"){range=[];}}return range;}function updateFormatCell(ctx,d,attr,foucsStatus,row_st,row_ed,col_st,col_ed,canvas){if(lodash_default().isNil(d)||lodash_default().isNil(attr)){return;}if(attr==="ct"){for(var r=row_st;r<=row_ed;r+=1){if(!lodash_default().isNil(ctx.config.rowhidden)&&!lodash_default().isNil(ctx.config.rowhidden[r])){continue;}for(var c=col_st;c<=col_ed;c+=1){var cell=d[r][c];var value=void 0;if(lodash_default().isPlainObject(cell)){value=cell===null||cell===void 0?void 0:cell.v;}else{value=cell;}if(foucsStatus!=="@"&&isRealNum(value)){value=Number(value);}var mask=update(foucsStatus,value);var type="n";if(is_date(foucsStatus)||foucsStatus===14||foucsStatus===15||foucsStatus===16||foucsStatus===17||foucsStatus===18||foucsStatus===19||foucsStatus===20||foucsStatus===21||foucsStatus===22||foucsStatus===45||foucsStatus===46||foucsStatus===47){type="d";}else if(foucsStatus==="@"||foucsStatus===49){type="s";}else if(foucsStatus==="General"||foucsStatus===0){type=isRealNum(value)?"n":"g";}if(cell&&lodash_default().isPlainObject(cell)){cell.m="".concat(mask);if(lodash_default().isNil(cell.ct)){cell.ct={};}cell.ct.fa=foucsStatus;cell.ct.t=type;}else{d[r][c]={ct:{fa:foucsStatus,t:type},v:value,m:mask};}}}}else{if(attr==="ht"){if(foucsStatus==="left"){foucsStatus="1";}else if(foucsStatus==="center"){foucsStatus="0";}else if(foucsStatus==="right"){foucsStatus="2";}}else if(attr==="vt"){if(foucsStatus==="top"){foucsStatus="1";}else if(foucsStatus==="middle"){foucsStatus="0";}else if(foucsStatus==="bottom"){foucsStatus="2";}}else if(attr==="tb"){if(foucsStatus==="overflow"){foucsStatus="1";}else if(foucsStatus==="clip"){foucsStatus="0";}else if(foucsStatus==="wrap"){foucsStatus="2";}}else if(attr==="tr"){if(foucsStatus==="none"){foucsStatus="0";}else if(foucsStatus==="angleup"){foucsStatus="1";}else if(foucsStatus==="angledown"){foucsStatus="2";}else if(foucsStatus==="vertical"){foucsStatus="3";}else if(foucsStatus==="rotation-up"){foucsStatus="4";}else if(foucsStatus==="rotation-down"){foucsStatus="5";}}var sheetIndex=getSheetIndex(ctx,ctx.currentSheetId);if(sheetIndex==null){return;}for(var _r=row_st;_r<=row_ed;_r+=1){if(!lodash_default().isNil(ctx.config.rowhidden)&&!lodash_default().isNil(ctx.config.rowhidden[_r])){continue;}for(var _c=col_st;_c<=col_ed;_c+=1){var _value=d[_r][_c];if(_value&&lodash_default().isPlainObject(_value)){var _ctx$luckysheetfile$s,_cfg$columnlen;updateInlineStringFormatOutside(_value,attr,foucsStatus);_value[attr]=foucsStatus;(_ctx$luckysheetfile$s=ctx.luckysheetfile[sheetIndex]).config||(_ctx$luckysheetfile$s.config={});var cfg=ctx.luckysheetfile[sheetIndex].config;var cellWidth=((_cfg$columnlen=cfg.columnlen)===null||_cfg$columnlen===void 0?void 0:_cfg$columnlen[_c])||ctx.luckysheetfile[sheetIndex].defaultColWidth;if(attr==="fs"&&canvas){var _cfg$rowlen;var textInfo=getCellTextInfo(d[_r][_c],canvas,ctx,{r:_r,c:_c,cellWidth:cellWidth});if(!textInfo)continue;var rowHeight=lodash_default().round(textInfo.textHeightAll);var currentRowHeight=((_cfg$rowlen=cfg.rowlen)===null||_cfg$rowlen===void 0?void 0:_cfg$rowlen[_r])||ctx.luckysheetfile[sheetIndex].defaultRowHeight||19;if(!lodash_default().isUndefined(rowHeight)&&rowHeight>currentRowHeight&&(!cfg.customHeight||cfg.customHeight[_r]!==1)){if(lodash_default().isUndefined(cfg.rowlen))cfg.rowlen={};lodash_default().set(cfg,"rowlen.".concat(_r),rowHeight);}}}else{d[_r][_c]={v:_value};d[_r][_c][attr]=foucsStatus;}}}}}function updateFormat(ctx,$input,d,attr,foucsStatus,canvas){var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;if(attr in inlineStyleAffectAttribute){if(ctx.luckysheetCellUpdate.length>0){var value=$input.innerText;if(value.substring(0,1)!=="="){var cell=d[ctx.luckysheetCellUpdate[0]][ctx.luckysheetCellUpdate[1]];if(cell){updateInlineStringFormat(ctx,cell,attr,foucsStatus,$input);}return;}}}var cfg=lodash_default().cloneDeep(ctx.config);if(lodash_default().isNil(cfg.rowlen)){cfg.rowlen={};}lodash_default().forEach(ctx.luckysheet_select_save,function(selection){var _selection$row=index_esm_slicedToArray(selection.row,2),row_st=_selection$row[0],row_ed=_selection$row[1];var _selection$column=index_esm_slicedToArray(selection.column,2),col_st=_selection$column[0],col_ed=_selection$column[1];updateFormatCell(ctx,d,attr,foucsStatus,row_st,row_ed,col_st,col_ed,canvas);});}function toggleAttr(ctx,cellInput,attr){var flowdata=getFlowdata(ctx);if(!flowdata)return;var flag=isAllSelectedCellsInStatus(ctx,attr,1);var foucsStatus=flag?0:1;updateFormat(ctx,cellInput,flowdata,attr,foucsStatus);}function setAttr(ctx,cellInput,attr,value,canvas){var flowdata=getFlowdata(ctx);if(!flowdata)return;updateFormat(ctx,cellInput,flowdata,attr,value,canvas);}function checkNoNullValue(cell){var v=cell;if(lodash_default().isPlainObject(v)){v=v.v;}if(!isRealNull(v)&&isdatatypemulti(v).num&&(cell.ct==null||cell.ct.t==null||cell.ct.t==="n"||cell.ct.t==="g")){return true;}return false;}function checkNoNullValueAll(cell){var v=cell;if(lodash_default().isPlainObject(v)){v=v.v;}if(!isRealNull(v)){return true;}return false;}function getNoNullValue(d,st_x,ed,type){var hasValueStart=null;var nullNum=0;var nullTime=0;for(var r=ed-1;r>=0;r-=1){var cell=void 0;if(type==="c"){cell=d[st_x][r];}else{cell=d[r][st_x];}if(checkNoNullValue(cell)){hasValueStart=r;}else if(cell==null||cell.v==null||cell.v===""){nullNum+=1;if(nullNum>=40){if(nullTime<=0){nullTime=1;}else{break;}}}else{break;}}return hasValueStart;}function activeFormulaInput(cellInput,fxInput,ctx,row_index,col_index,rowh,columnh,formula,cache,isnull){if(isnull==null){isnull=false;}ctx.luckysheetCellUpdate=[row_index,col_index];cache.doNotUpdateCell=true;if(isnull){var _formulaTxt="<span dir=\"auto\" class=\"luckysheet-formula-text-color\">=</span><span dir=\"auto\" class=\"luckysheet-formula-text-color\">".concat(formula.toUpperCase(),"</span><span dir=\"auto\" class=\"luckysheet-formula-text-color\">(</span><span dir=\"auto\" class=\"luckysheet-formula-text-color\">)</span>");cellInput.innerHTML=_formulaTxt;var spanList=cellInput.querySelectorAll("span");setCaretPosition(ctx,spanList[spanList.length-2],0,1);return;}var row_pre=rowLocationByIndex(rowh[0],ctx.visibledatarow)[0];var row=rowLocationByIndex(rowh[1],ctx.visibledatarow)[1];var col_pre=colLocationByIndex(columnh[0],ctx.visibledatacolumn)[0];var col=colLocationByIndex(columnh[1],ctx.visibledatacolumn)[1];var formulaTxt="<span dir=\"auto\" class=\"luckysheet-formula-text-color\">=</span><span dir=\"auto\" class=\"luckysheet-formula-text-color\">".concat(formula.toUpperCase(),"</span><span dir=\"auto\" class=\"luckysheet-formula-text-color\">(</span><span class=\"fortune-formula-functionrange-cell\" rangeindex=\"0\" dir=\"auto\" style=\"color:").concat(colors[0],";\">").concat(getRangetxt(ctx,ctx.currentSheetId,{row:rowh,column:columnh},ctx.currentSheetId),"</span><span dir=\"auto\" class=\"luckysheet-formula-text-color\">)</span>");cellInput.innerHTML=formulaTxt;israngeseleciton(ctx);ctx.formulaCache.rangestart=true;ctx.formulaCache.rangedrag_column_start=false;ctx.formulaCache.rangedrag_row_start=false;ctx.formulaCache.rangechangeindex=0;rangeSetValue(ctx,cellInput,{row:rowh,column:columnh},fxInput);ctx.formulaCache.func_selectedrange={left:col_pre,width:col-col_pre-1,top:row_pre,height:row-row_pre-1,left_move:col_pre,width_move:col-col_pre-1,top_move:row_pre,height_move:row-row_pre-1,row:[row_index,row_index],column:[col_index,col_index]};createFormulaRangeSelect(ctx,{rangeIndex:ctx.formulaCache.rangeIndex||0,left:col_pre,width:col-col_pre-1,top:row_pre,height:row-row_pre-1});}function backFormulaInput(d,r,c,rowh,columnh,formula,ctx){var _ctx$formulaCache;var f="=".concat(formula.toUpperCase(),"(").concat(getRangetxt(ctx,ctx.currentSheetId,{row:rowh,column:columnh},ctx.currentSheetId),")");var v=execfunction(ctx,f,r,c);var value={v:v[1],f:v[2]};setCellValue(ctx,r,c,d,value);(_ctx$formulaCache=ctx.formulaCache).execFunctionExist||(_ctx$formulaCache.execFunctionExist=[]);ctx.formulaCache.execFunctionExist.push({r:r,c:c,i:ctx.currentSheetId});}function singleFormulaInput(cellInput,fxInput,ctx,d,_index,fix,st_m,ed_m,formula,type,cache,noNum,noNull){if(type==null){type="r";}if(noNum==null){noNum=true;}if(noNull==null){noNull=true;}var isNull=true;var isNum=false;for(var c=st_m;c<=ed_m;c+=1){var cell=null;if(type==="c"){cell=d[c][fix];}else{cell=d[fix][c];}if(checkNoNullValue(cell)){isNull=false;isNum=true;}else if(checkNoNullValueAll(cell)){isNull=false;}}if(isNull&&noNull){var st_r_r=getNoNullValue(d,_index,fix,type);if(st_r_r==null){if(type==="c"){activeFormulaInput(cellInput,fxInput,ctx,_index,fix,null,null,formula,cache,true);}else{activeFormulaInput(cellInput,fxInput,ctx,fix,_index,null,null,formula,cache,true);}}else{if(_index===st_m){for(var _c2=st_m;_c2<=ed_m;_c2+=1){st_r_r=getNoNullValue(d,_c2,fix,type);if(st_r_r==null){break;}if(type==="c"){backFormulaInput(d,_c2,fix,[_c2,_c2],[st_r_r,fix-1],formula,ctx);}else{backFormulaInput(d,fix,_c2,[st_r_r,fix-1],[_c2,_c2],formula,ctx);}}}else{for(var _c3=ed_m;_c3>=st_m;_c3-=1){st_r_r=getNoNullValue(d,_c3,fix,type);if(st_r_r==null){break;}if(type==="c"){backFormulaInput(d,_c3,fix,[_c3,_c3],[st_r_r,fix-1],formula,ctx);}else{backFormulaInput(d,fix,_c3,[st_r_r,fix-1],[_c3,_c3],formula,ctx);}}}}return false;}if(isNum&&noNum){var _cell=null;if(type==="c"){_cell=d[ed_m+1][fix];}else{_cell=d[fix][ed_m+1];}if(_cell!=null&&_cell.v!=null&&_cell.v.toString().length>0){var _c4=ed_m+1;if(type==="c"){_cell=d[ed_m+1][fix];}else{_cell=d[fix][ed_m+1];}while(_cell!=null&&_cell.v!=null&&_cell.v.toString().length>0){_c4+=1;var len=null;if(type==="c"){len=d.length;}else{len=d[0].length;}if(_c4>=len){return false;}if(type==="c"){_cell=d[_c4][fix];}else{_cell=d[fix][_c4];}}if(type==="c"){backFormulaInput(d,_c4,fix,[st_m,ed_m],[fix,fix],formula,ctx);}else{backFormulaInput(d,fix,_c4,[fix,fix],[st_m,ed_m],formula,ctx);}}else{if(type==="c"){backFormulaInput(d,ed_m+1,fix,[st_m,ed_m],[fix,fix],formula,ctx);}else{backFormulaInput(d,fix,ed_m+1,[fix,fix],[st_m,ed_m],formula,ctx);}}return false;}return true;}function autoSelectionFormula(ctx,cellInput,fxInput,formula,cache){var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;var flowdata=getFlowdata(ctx);if(flowdata==null)return;var isfalse=true;ctx.formulaCache.execFunctionExist=[];function execFormulaInput_c(d,st_r,ed_r,st_c,ed_c,_formula){var st_c_c=getNoNullValue(d,st_r,ed_c,"c");if(st_c_c==null){activeFormulaInput(cellInput,fxInput,ctx,st_r,st_c,null,null,_formula,cache,true);}else{activeFormulaInput(cellInput,fxInput,ctx,st_r,st_c,[st_r,ed_r],[st_c_c,ed_c-1],_formula,cache);}}function execFormulaInput(d,st_r,ed_r,st_c,ed_c,_formula){var st_r_c=getNoNullValue(d,st_c,ed_r,"r");if(st_r_c==null){execFormulaInput_c(d,st_r,ed_r,st_c,ed_c,_formula);}else{activeFormulaInput(cellInput,fxInput,ctx,st_r,st_c,[st_r_c,ed_r-1],[st_c,ed_c],_formula,cache);}}if(!ctx.luckysheet_select_save)return;lodash_default().forEach(ctx.luckysheet_select_save,function(selection){var _selection$row2=index_esm_slicedToArray(selection.row,2),st_r=_selection$row2[0],ed_r=_selection$row2[1];var _selection$column2=index_esm_slicedToArray(selection.column,2),st_c=_selection$column2[0],ed_c=_selection$column2[1];var row_index=selection.row_focus;var col_index=selection.column_focus;if(st_r===ed_r&&st_c===ed_c){if(ed_r-1<0&&ed_c-1<0){activeFormulaInput(cellInput,fxInput,ctx,st_r,st_c,null,null,formula,cache,true);return;}if(ed_r-1>=0&&checkNoNullValue(flowdata[ed_r-1][st_c])){execFormulaInput(flowdata,st_r,ed_r,st_c,ed_c,formula);}else if(ed_c-1>=0&&checkNoNullValue(flowdata[st_r][ed_c-1])){execFormulaInput_c(flowdata,st_r,ed_r,st_c,ed_c,formula);}else{execFormulaInput(flowdata,st_r,ed_r,st_c,ed_c,formula);}}else if(st_r===ed_r){isfalse=singleFormulaInput(cellInput,fxInput,ctx,flowdata,col_index,st_r,st_c,ed_c,formula,"r",cache);}else if(st_c===ed_c){isfalse=singleFormulaInput(cellInput,fxInput,ctx,flowdata,row_index,st_c,st_r,ed_r,formula,"c",cache);}else{var r_false=true;for(var r=st_r;r<=ed_r;r+=1){r_false=singleFormulaInput(cellInput,fxInput,ctx,flowdata,col_index,r,st_c,ed_c,formula,"r",cache,true,false)&&r_false;}var c_false=true;for(var c=st_c;c<=ed_c;c+=1){c_false=singleFormulaInput(cellInput,fxInput,ctx,flowdata,row_index,c,st_r,ed_r,formula,"c",cache,true,false)&&c_false;}isfalse=!!r_false&&!!c_false;}isfalse=isfalse&&isfalse;});if(!isfalse){ctx.formulaCache.execFunctionExist.reverse();execFunctionGroup(ctx,null,null,null,null,flowdata);ctx.formulaCache.execFunctionGlobalData=null;}}function cancelPaintModel(ctx){var _ctx$luckysheet_copy_;if(ctx.luckysheet_copy_save===null)return;if(((_ctx$luckysheet_copy_=ctx.luckysheet_copy_save)===null||_ctx$luckysheet_copy_===void 0?void 0:_ctx$luckysheet_copy_.dataSheetId)===ctx.currentSheetId){ctx.luckysheet_selection_range=[];selectionCopyShow(ctx.luckysheet_selection_range,ctx);}else{if(!ctx.luckysheet_copy_save)return;var index=getSheetIndex(ctx,ctx.luckysheet_copy_save.dataSheetId);if(!index)return;ctx.luckysheetfile[index].luckysheet_selection_range=[];}ctx.luckysheet_copy_save={dataSheetId:"",copyRange:[{row:[0],column:[0]}],RowlChange:false,HasMC:false};ctx.luckysheetPaintModelOn=false;}function handleCurrencyFormat(ctx,cellInput){var flowdata=getFlowdata(ctx);if(!flowdata)return;var currency=ctx.currency||"¥";updateFormat(ctx,cellInput,flowdata,"ct","".concat(currency," #.00"));}function handlePercentageFormat(ctx,cellInput){var flowdata=getFlowdata(ctx);if(!flowdata)return;updateFormat(ctx,cellInput,flowdata,"ct","0.00%");}function handleNumberDecrease(ctx,cellInput){var flowdata=getFlowdata(ctx);if(!flowdata||!ctx.luckysheet_select_save)return;var row_index=ctx.luckysheet_select_save[0].row_focus;var col_index=ctx.luckysheet_select_save[0].column_focus;if(row_index===undefined||col_index===undefined)return;var foucsStatus=normalizedAttr(flowdata,row_index,col_index,"ct");var cell=flowdata[row_index][col_index];if(foucsStatus==null||foucsStatus.t!=="n"){return;}if(foucsStatus.fa==="General"){if(!cell||!cell.v)return;var mask=genarate(cell.v);if(!mask||mask.length<2)return;var _mask=index_esm_slicedToArray(mask,2);foucsStatus=_mask[1];}var reg=/^(w|W)((0?)|(0\.0+))$/;if(reg.test(foucsStatus.fa)){if(foucsStatus.fa.indexOf(".")>-1){if(foucsStatus.fa.substr(-2)===".0"){updateFormat(ctx,cellInput,flowdata,"ct",foucsStatus.fa.split(".")[0]);}else{updateFormat(ctx,cellInput,flowdata,"ct",foucsStatus.fa.substr(0,foucsStatus.fa.length-1));}}else{updateFormat(ctx,cellInput,flowdata,"ct",foucsStatus.fa);}return;}var prefix="";var main="";var fa=[];if(foucsStatus.fa.indexOf(".")>-1){fa=foucsStatus.fa.split(".");var _fa=fa;var _fa2=index_esm_slicedToArray(_fa,2);prefix=_fa2[0];main=_fa2[1];}else{return;}fa=main.split("");var tail="";for(var i=fa.length-1;i>=0;i-=1){var c=fa[i];if(c!=="#"&&c!=="0"&&c!==","&&Number.isNaN(parseInt(c,10))){tail=c+tail;}else{break;}}var fmt="";if(foucsStatus.fa.indexOf(".")>-1){var suffix=main;if(tail.length>0){suffix=main.replace(tail,"");}var pos=suffix.replace(/#/g,"0");pos=pos.substr(0,pos.length-1);if(pos===""){fmt=prefix+tail;}else{fmt="".concat(prefix,".").concat(pos).concat(tail);}}updateFormat(ctx,cellInput,flowdata,"ct",fmt);}function handleNumberIncrease(ctx,cellInput){var flowdata=getFlowdata(ctx);if(!flowdata)return;if(!ctx.luckysheet_select_save)return;var row_index=ctx.luckysheet_select_save[0].row_focus;var col_index=ctx.luckysheet_select_save[0].column_focus;if(row_index===undefined||col_index===undefined)return;var foucsStatus=normalizedAttr(flowdata,row_index,col_index,"ct");var cell=flowdata[row_index][col_index];if(foucsStatus==null||foucsStatus.t!=="n"){return;}if(foucsStatus.fa==="General"){if(!cell||!cell.v)return;var mask=genarate(cell.v);if(!mask||mask.length<2)return;var _mask2=index_esm_slicedToArray(mask,2);foucsStatus=_mask2[1];}if(foucsStatus.fa==="General"){updateFormat(ctx,cellInput,flowdata,"ct","#.0");return;}var reg=/^(w|W)((0?)|(0\.0+))$/;if(reg.test(foucsStatus.fa)){if(foucsStatus.fa.indexOf(".")>-1){updateFormat(ctx,cellInput,flowdata,"ct","".concat(foucsStatus.fa,"0"));}else{if(foucsStatus.fa.substr(-1)==="0"){updateFormat(ctx,cellInput,flowdata,"ct","".concat(foucsStatus.fa,".0"));}else{updateFormat(ctx,cellInput,flowdata,"ct","".concat(foucsStatus.fa,"0.0"));}}return;}var prefix="";var main="";var fa=[];if(foucsStatus.fa.indexOf(".")>-1){fa=foucsStatus.fa.split(".");var _fa3=fa;var _fa4=index_esm_slicedToArray(_fa3,2);prefix=_fa4[0];main=_fa4[1];}else{main=foucsStatus.fa;}fa=main.split("");var tail="";for(var i=fa.length-1;i>=0;i-=1){var c=fa[i];if(c!=="#"&&c!=="0"&&c!==","&&Number.isNaN(parseInt(c,10))){tail=c+tail;}else{break;}}var fmt="";if(foucsStatus.fa.indexOf(".")>-1){var suffix=main;if(tail.length>0){suffix=main.replace(tail,"");}var pos=suffix.replace(/#/g,"0");pos+="0";fmt="".concat(prefix,".").concat(pos).concat(tail);}else{if(tail.length>0){fmt="".concat(main.replace(tail,""),".0").concat(tail);}else{fmt="".concat(main,".0").concat(tail);}}updateFormat(ctx,cellInput,flowdata,"ct",fmt);}function handleBold(ctx,cellInput){toggleAttr(ctx,cellInput,"bl");}function handleItalic(ctx,cellInput){toggleAttr(ctx,cellInput,"it");}function handleStrikeThrough(ctx,cellInput){toggleAttr(ctx,cellInput,"cl");}function handleUnderline(ctx,cellInput){toggleAttr(ctx,cellInput,"un");}function handleHorizontalAlign(ctx,cellInput,value){setAttr(ctx,cellInput,"ht",value);}function handleVerticalAlign(ctx,cellInput,value){setAttr(ctx,cellInput,"vt",value);}function handleFormatPainter(ctx){var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;if(ctx.luckysheet_select_save==null||ctx.luckysheet_select_save.length===0){return;}if(ctx.luckysheet_select_save.length>1){return;}var has_PartMC=false;var r1=ctx.luckysheet_select_save[0].row[0];var r2=ctx.luckysheet_select_save[0].row[1];var c1=ctx.luckysheet_select_save[0].column[0];var c2=ctx.luckysheet_select_save[0].column[1];has_PartMC=hasPartMC(ctx,ctx.config,r1,r2,c1,c2);if(has_PartMC){return;}cancelPaintModel(ctx);ctx.luckysheet_selection_range=[{row:ctx.luckysheet_select_save[0].row,column:ctx.luckysheet_select_save[0].column}];selectionCopyShow(ctx.luckysheet_selection_range,ctx);var RowlChange=false;var HasMC=false;for(var r=ctx.luckysheet_select_save[0].row[0];r<=ctx.luckysheet_select_save[0].row[1];r+=1){if(ctx.config.rowhidden!=null&&ctx.config.rowhidden[r]!=null){continue;}if(ctx.config.rowlen!=null&&r in ctx.config.rowlen){RowlChange=true;}for(var c=ctx.luckysheet_select_save[0].column[0];c<=ctx.luckysheet_select_save[0].column[1];c+=1){var flowdata=getFlowdata(ctx);if(!flowdata)return;var cell=flowdata[r][c];if(cell!=null&&cell.mc!=null&&cell.mc.rs!=null){HasMC=true;}}}ctx.luckysheet_copy_save={dataSheetId:ctx.currentSheetId,copyRange:[{row:ctx.luckysheet_select_save[0].row,column:ctx.luckysheet_select_save[0].column}],RowlChange:RowlChange,HasMC:HasMC};ctx.luckysheetPaintModelOn=true;ctx.luckysheetPaintSingle=true;}function handleClearFormat(ctx){var _ctx$luckysheet_selec;if(ctx.allowEdit===false)return;var flowdata=getFlowdata(ctx);if(!flowdata)return;(_ctx$luckysheet_selec=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec===void 0?void 0:_ctx$luckysheet_selec.every(function(selection){var _selection$row3=index_esm_slicedToArray(selection.row,2),rowSt=_selection$row3[0],rowEd=_selection$row3[1];var _selection$column3=index_esm_slicedToArray(selection.column,2),colSt=_selection$column3[0],colEd=_selection$column3[1];for(var r=rowSt;r<=rowEd;r+=1){if(!lodash_default().isNil(ctx.config.rowhidden)&&!lodash_default().isNil(ctx.config.rowhidden[r])){continue;}for(var c=colSt;c<=colEd;c+=1){var cell=flowdata[r][c];if(!cell)continue;flowdata[r][c]=lodash_default().pick(cell,"v","m","mc","f","ct");}}var index=getSheetIndex(ctx,ctx.currentSheetId);if(index==null)return false;if(ctx.config.borderInfo==null)return false;var cfg=ctx.config||{};if(cfg.borderInfo&&cfg.borderInfo.length>0){var source_borderInfo=[];for(var i=0;i<cfg.borderInfo.length;i+=1){var bd_rangeType=cfg.borderInfo[i].rangeType;if(bd_rangeType==="range"&&cfg.borderInfo[i].borderType!=="border-slash"){var bd_range=cfg.borderInfo[i].range;var bd_emptyRange=[];for(var j=0;j<bd_range.length;j+=1){bd_emptyRange=bd_emptyRange.concat(cfSplitRange(bd_range[j],{row:[rowSt,rowEd],column:[colSt,colEd]},{row:[rowSt,rowEd],column:[colSt,colEd]},"restPart"));}cfg.borderInfo[i].range=bd_emptyRange;source_borderInfo.push(cfg.borderInfo[i]);}else if(bd_rangeType==="cell"){var bd_r=cfg.borderInfo[i].value.row_index;var bd_c=cfg.borderInfo[i].value.col_index;if(!(bd_r>=rowSt&&bd_r<=rowEd&&bd_c>=colSt&&bd_c<=colEd)){source_borderInfo.push(cfg.borderInfo[i]);}}else if(bd_rangeType==="range"&&cfg.borderInfo[i].borderType==="border-slash"&&!(cfg.borderInfo[i].range[0].row[0]>=rowSt&&cfg.borderInfo[i].range[0].row[0]<=rowEd&&cfg.borderInfo[i].range[0].column[0]>=colSt&&cfg.borderInfo[i].range[0].column[0]<=colEd)){source_borderInfo.push(cfg.borderInfo[i]);}}ctx.luckysheetfile[index].config.borderInfo=source_borderInfo;}return true;});}function handleTextColor(ctx,cellInput,color){setAttr(ctx,cellInput,"fc",color);}function handleTextBackground(ctx,cellInput,color){setAttr(ctx,cellInput,"bg",color);}function handleBorder(ctx,type,borderColor,borderStyle){var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;if(type==null){type="border-all";}var color=borderColor;var style=borderStyle;if(color==null||color===""){color="#000";}if(style==null||style===""){style="1";}var cfg=ctx.config;if(cfg.borderInfo==null){cfg.borderInfo=[];}if(type!=="border-slash"){var borderInfo={rangeType:"range",borderType:type,color:color,style:style,range:lodash_default().cloneDeep(ctx.luckysheet_select_save)||[]};cfg.borderInfo.push(borderInfo);}else{var rangeList=[];lodash_default().forEach(ctx.luckysheet_select_save,function(selection){for(var r=selection.row[0];r<=selection.row[1];r+=1){for(var c=selection.column[0];c<=selection.column[1];c+=1){var range="".concat(r,"_").concat(c);if(lodash_default().includes(rangeList,range))continue;var _borderInfo={rangeType:"range",borderType:type,color:color,style:style,range:normalizeSelection(ctx,[{row:[r,r],column:[c,c]}])};cfg.borderInfo.push(_borderInfo);rangeList.push(range);}}});}var index=getSheetIndex(ctx,ctx.currentSheetId);if(index==null)return;ctx.luckysheetfile[index].config=ctx.config;}function handleMerge(ctx,type){var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;if(selectIsOverlap(ctx)){return;}if(ctx.config.merge!=null){var has_PartMC=false;if(!ctx.luckysheet_select_save)return;for(var s=0;s<ctx.luckysheet_select_save.length;s+=1){var r1=ctx.luckysheet_select_save[s].row[0];var r2=ctx.luckysheet_select_save[s].row[1];var c1=ctx.luckysheet_select_save[s].column[0];var c2=ctx.luckysheet_select_save[s].column[1];has_PartMC=hasPartMC(ctx,ctx.config,r1,r2,c1,c2);if(has_PartMC){break;}}if(has_PartMC){return;}}var flowdata=getFlowdata(ctx);if(!flowdata)return;if(!ctx.luckysheet_select_save)return;mergeCells(ctx,ctx.currentSheetId,ctx.luckysheet_select_save,type);}function handleSort(ctx,isAsc){sortSelection(ctx,isAsc);}function handleFreeze(ctx,type){var _ctx$luckysheet_selec2,_ctx$config$merge;var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;var file=ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)];if(!file)return;if(type==="freeze-cancel"){delete file.frozen;return;}var firstSelection=(_ctx$luckysheet_selec2=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec2===void 0?void 0:_ctx$luckysheet_selec2[0];if(!firstSelection)return;var row_focus=firstSelection.row_focus,column_focus=firstSelection.column_focus;if(row_focus==null||column_focus==null)return;var m=(_ctx$config$merge=ctx.config.merge)===null||_ctx$config$merge===void 0?void 0:_ctx$config$merge["".concat(row_focus,"_").concat(column_focus)];if(m){row_focus=m.r+m.rs-1;column_focus=m.c+m.cs-1;}file.frozen={type:"both",range:{row_focus:row_focus,column_focus:column_focus}};if(type==="freeze-row"){file.frozen.type="rangeRow";}else if(type==="freeze-col"){file.frozen.type="rangeColumn";}}function handleTextSize(ctx,cellInput,size,canvas){setAttr(ctx,cellInput,"fs",size,canvas);}function handleSum(ctx,cellInput,fxInput,cache){autoSelectionFormula(ctx,cellInput,fxInput,"SUM",cache);}function handleLink(ctx){var _ctx$luckysheet_selec3;var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;var selection=(_ctx$luckysheet_selec3=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec3===void 0?void 0:_ctx$luckysheet_selec3[0];var flowdata=getFlowdata(ctx);if(flowdata!=null&&selection!=null){showLinkCard(ctx,selection.row[0],selection.column[0],true);}}var handlerMap={"currency-format":handleCurrencyFormat,"percentage-format":handlePercentageFormat,"number-decrease":handleNumberDecrease,"number-increase":handleNumberIncrease,"sort-cell":function sortCell(ctx){return handleSort(ctx,true);},"merge-all":function mergeAll(ctx){return handleMerge(ctx,"mergeAll");},"border-all":function borderAll(ctx){return handleBorder(ctx,"border-all");},bold:handleBold,italic:handleItalic,"strike-through":handleStrikeThrough,underline:handleUnderline,"clear-format":handleClearFormat,"format-painter":handleFormatPainter,search:function search(ctx){ctx.showSearch=true;},link:handleLink};var selectedMap={bold:function bold(cell){return(cell===null||cell===void 0?void 0:cell.bl)===1;},italic:function italic(cell){return(cell===null||cell===void 0?void 0:cell.it)===1;},"strike-through":function strikeThrough(cell){return(cell===null||cell===void 0?void 0:cell.cl)===1;},underline:function underline(cell){return(cell===null||cell===void 0?void 0:cell.un)===1;}};function toolbarItemClickHandler(name){return handlerMap[name];}function toolbarItemSelectedFunc(name){return selectedMap[name];}function getArrowCanvasSize(fromX,fromY,toX,toY){var left=toX-5;if(fromX<toX){left=fromX-5;}var top=toY-5;if(fromY<toY){top=fromY-5;}var width=Math.abs(fromX-toX)+10;var height=Math.abs(fromY-toY)+10;var x1=width-5;var x2=5;if(fromX<toX){x1=5;x2=width-5;}var y1=height-5;var y2=5;if(fromY<toY){y1=5;y2=height-5;}return{left:left,top:top,width:width,height:height,fromX:x1,fromY:y1,toX:x2,toY:y2};}function drawArrow(rc,_ref,color,theta,headlen){var left=_ref.left,top=_ref.top,width=_ref.width,height=_ref.height,fromX=_ref.fromX,fromY=_ref.fromY,toX=_ref.toX,toY=_ref.toY;var canvas=document.getElementById("arrowCanvas-".concat(rc));var ctx=canvas.getContext("2d");if(!canvas||!ctx)return;canvas.style.width="".concat(width,"px");canvas.style.height="".concat(height,"px");canvas.width=width;canvas.height=height;canvas.style.left="".concat(left,"px");canvas.style.top="".concat(top,"px");var _canvas$getBoundingCl=canvas.getBoundingClientRect(),canvasWidth=_canvas$getBoundingCl.width,canvasHeight=_canvas$getBoundingCl.height;ctx.clearRect(0,0,canvasWidth,canvasHeight);theta=theta||30;headlen=headlen||6;var arrowWidth=1;color=color||"#000";var angle=Math.atan2(fromY-toY,fromX-toX)*180/Math.PI;var angle1=(angle+theta)*Math.PI/180;var angle2=(angle-theta)*Math.PI/180;var topX=headlen*Math.cos(angle1);var topY=headlen*Math.sin(angle1);var botX=headlen*Math.cos(angle2);var botY=headlen*Math.sin(angle2);ctx.save();ctx.beginPath();var arrowX=fromX-topX;var arrowY=fromY-topY;ctx.moveTo(arrowX,arrowY);ctx.moveTo(fromX,fromY);ctx.lineTo(toX,toY);ctx.lineWidth=arrowWidth;ctx.strokeStyle=color;ctx.stroke();arrowX=toX+topX;arrowY=toY+topY;ctx.moveTo(arrowX,arrowY);ctx.lineTo(toX,toY);arrowX=toX+botX;arrowY=toY+botY;ctx.lineTo(arrowX,arrowY);ctx.fillStyle=color;ctx.fill();ctx.restore();}var commentBoxProps={defaultWidth:144,defaultHeight:84,currentObj:null,currentWinW:null,currentWinH:null,resize:null,resizeXY:null,move:false,moveXY:null,cursorStartPosition:null};function getCellTopRightPostion(ctx,flowdata,r,c){var row_pre=r-1===-1?0:ctx.visibledatarow[r-1];var col=ctx.visibledatacolumn[c];var margeset=mergeBorder(ctx,flowdata,r,c);if(margeset){var _margeset$row=index_esm_slicedToArray(margeset.row,1);row_pre=_margeset$row[0];var _margeset$column=index_esm_slicedToArray(margeset.column,2);col=_margeset$column[1];}var toX=col;var toY=row_pre;return{toX:toX,toY:toY};}function getCommentBoxByRC(ctx,flowdata,r,c){var _flowdata$r$c;var comment=(_flowdata$r$c=flowdata[r][c])===null||_flowdata$r$c===void 0?void 0:_flowdata$r$c.ps;var _getCellTopRightPosti=getCellTopRightPostion(ctx,flowdata,r,c),toX=_getCellTopRightPosti.toX,toY=_getCellTopRightPosti.toY;var left=(comment===null||comment===void 0?void 0:comment.left)==null?toX+18*ctx.zoomRatio:comment.left*ctx.zoomRatio;var top=(comment===null||comment===void 0?void 0:comment.top)==null?toY-18*ctx.zoomRatio:comment.top*ctx.zoomRatio;var width=(comment===null||comment===void 0?void 0:comment.width)==null?commentBoxProps.defaultWidth*ctx.zoomRatio:comment.width*ctx.zoomRatio;var height=(comment===null||comment===void 0?void 0:comment.height)==null?commentBoxProps.defaultHeight*ctx.zoomRatio:comment.height*ctx.zoomRatio;var value=(comment===null||comment===void 0?void 0:comment.value)==null?"":comment.value;if(top<0){top=2;}var size=getArrowCanvasSize(left,top,toX,toY);var rc="".concat(r,"_").concat(c);return{r:r,c:c,rc:rc,left:left,top:top,width:width,height:height,value:value,size:size,autoFocus:false};}function setEditingComment(ctx,flowdata,r,c){ctx.editingCommentBox=getCommentBoxByRC(ctx,flowdata,r,c);}function removeEditingComment(ctx,globalCache){var _ctx$hooks$beforeUpda,_ctx$hooks;var editingCommentBoxEle=globalCache.editingCommentBoxEle;ctx.editingCommentBox=undefined;var r=editingCommentBoxEle===null||editingCommentBoxEle===void 0?void 0:editingCommentBoxEle.dataset.r;var c=editingCommentBoxEle===null||editingCommentBoxEle===void 0?void 0:editingCommentBoxEle.dataset.c;if(!r||!c||!editingCommentBoxEle)return;r=parseInt(r,10);c=parseInt(c,10);var value=editingCommentBoxEle.innerHTML||"";var flowdata=getFlowdata(ctx);globalCache.editingCommentBoxEle=undefined;if(!flowdata)return;if(((_ctx$hooks$beforeUpda=(_ctx$hooks=ctx.hooks).beforeUpdateComment)===null||_ctx$hooks$beforeUpda===void 0?void 0:_ctx$hooks$beforeUpda.call(_ctx$hooks,r,c,value))===false){return;}var cell=flowdata===null||flowdata===void 0?void 0:flowdata[r][c];if(!(cell===null||cell===void 0?void 0:cell.ps))return;var oldValue=cell.ps.value;cell.ps.value=value;if(!cell.ps.isShow){ctx.commentBoxes=lodash_default().filter(ctx.commentBoxes,function(v){return v.rc!=="".concat(r,"_").concat(c);});}if(ctx.hooks.afterUpdateComment){setTimeout(function(){var _ctx$hooks$afterUpdat,_ctx$hooks2;(_ctx$hooks$afterUpdat=(_ctx$hooks2=ctx.hooks).afterUpdateComment)===null||_ctx$hooks$afterUpdat===void 0?void 0:_ctx$hooks$afterUpdat.call(_ctx$hooks2,r,c,oldValue,value);});}}function newComment(ctx,globalCache,r,c){var _ctx$hooks$beforeInse,_ctx$hooks3;var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;if(((_ctx$hooks$beforeInse=(_ctx$hooks3=ctx.hooks).beforeInsertComment)===null||_ctx$hooks$beforeInse===void 0?void 0:_ctx$hooks$beforeInse.call(_ctx$hooks3,r,c))===false){return;}removeEditingComment(ctx,globalCache);var flowdata=getFlowdata(ctx);if(!flowdata)return;var cell=flowdata[r][c];if(cell==null){cell={};flowdata[r][c]=cell;}cell.ps={left:null,top:null,width:null,height:null,value:"",isShow:false};ctx.editingCommentBox=_objectSpread2(_objectSpread2({},getCommentBoxByRC(ctx,flowdata,r,c)),{},{autoFocus:true});if(ctx.hooks.afterInsertComment){setTimeout(function(){var _ctx$hooks$afterInser,_ctx$hooks4;(_ctx$hooks$afterInser=(_ctx$hooks4=ctx.hooks).afterInsertComment)===null||_ctx$hooks$afterInser===void 0?void 0:_ctx$hooks$afterInser.call(_ctx$hooks4,r,c);});}}function editComment(ctx,globalCache,r,c){var _flowdata$r$c2;var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;var flowdata=getFlowdata(ctx);removeEditingComment(ctx,globalCache);var comment=flowdata===null||flowdata===void 0?void 0:(_flowdata$r$c2=flowdata[r][c])===null||_flowdata$r$c2===void 0?void 0:_flowdata$r$c2.ps;var commentBoxes=lodash_default().concat(ctx.commentBoxes,ctx.editingCommentBox);if(lodash_default().findIndex(commentBoxes,function(v){return(v===null||v===void 0?void 0:v.rc)==="".concat(r,"_").concat(c);})!==-1){var editCommentBox=document.getElementById("comment-editor-".concat(r,"_").concat(c));editCommentBox===null||editCommentBox===void 0?void 0:editCommentBox.focus();}if(comment){ctx.editingCommentBox=_objectSpread2(_objectSpread2({},getCommentBoxByRC(ctx,flowdata,r,c)),{},{autoFocus:true});}}function deleteComment(ctx,globalCache,r,c){var _ctx$hooks$beforeDele,_ctx$hooks5;var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;if(((_ctx$hooks$beforeDele=(_ctx$hooks5=ctx.hooks).beforeDeleteComment)===null||_ctx$hooks$beforeDele===void 0?void 0:_ctx$hooks$beforeDele.call(_ctx$hooks5,r,c))===false){return;}var flowdata=getFlowdata(ctx);if(!flowdata)return;var cell=flowdata[r][c];if(!cell)return;cell.ps=undefined;if(ctx.hooks.afterDeleteComment){setTimeout(function(){var _ctx$hooks$afterDelet,_ctx$hooks6;(_ctx$hooks$afterDelet=(_ctx$hooks6=ctx.hooks).afterDeleteComment)===null||_ctx$hooks$afterDelet===void 0?void 0:_ctx$hooks$afterDelet.call(_ctx$hooks6,r,c);});}}function showComments(ctx,commentShowCells){var flowdata=getFlowdata(ctx);if(flowdata){var commentBoxes=commentShowCells.map(function(_ref2){var r=_ref2.r,c=_ref2.c;return getCommentBoxByRC(ctx,flowdata,r,c);});ctx.commentBoxes=commentBoxes;}}function showHideComment(ctx,globalCache,r,c){var _flowdata$r$c3;var flowdata=getFlowdata(ctx);var comment=flowdata===null||flowdata===void 0?void 0:(_flowdata$r$c3=flowdata[r][c])===null||_flowdata$r$c3===void 0?void 0:_flowdata$r$c3.ps;if(!comment)return;var isShow=comment.isShow;var rc="".concat(r,"_").concat(c);if(isShow){comment.isShow=false;ctx.commentBoxes=lodash_default().filter(ctx.commentBoxes,function(v){return v.rc!==rc;});}else{comment.isShow=true;}}function showHideAllComments(ctx){var flowdata=getFlowdata(ctx);if(!flowdata)return;var isAllShow=true;var allComments=[];for(var r=0;r<flowdata.length;r+=1){for(var c=0;c<flowdata[0].length;c+=1){var cell=flowdata[r][c];if(cell===null||cell===void 0?void 0:cell.ps){allComments.push({r:r,c:c});if(!cell.ps.isShow){isAllShow=false;}}}}if(allComments.length>0){if(isAllShow){for(var i=0;i<allComments.length;i+=1){var _flowdata$_r$_c;var _allComments$i=allComments[i],_r=_allComments$i.r,_c=_allComments$i.c;var comment=(_flowdata$_r$_c=flowdata[_r][_c])===null||_flowdata$_r$_c===void 0?void 0:_flowdata$_r$_c.ps;if(comment===null||comment===void 0?void 0:comment.isShow){comment.isShow=false;}}ctx.commentBoxes=[];}else{for(var _i=0;_i<allComments.length;_i+=1){var _flowdata$_r2$_c;var _allComments$_i=allComments[_i],_r2=_allComments$_i.r,_c2=_allComments$_i.c;var _comment=(_flowdata$_r2$_c=flowdata[_r2][_c2])===null||_flowdata$_r2$_c===void 0?void 0:_flowdata$_r2$_c.ps;if(_comment&&!_comment.isShow){_comment.isShow=true;}}}}}function overShowComment(ctx,e,scrollX,scrollY,container){var _flowdata$r,_flowdata$r$c4,_ctx$editingCommentBo,_ctx$hoveredCommentBo;var flowdata=getFlowdata(ctx);if(!flowdata)return;var scrollLeft=scrollX.scrollLeft;var scrollTop=scrollY.scrollTop;var rect=container.getBoundingClientRect();var x=e.pageX-rect.left-ctx.rowHeaderWidth;var y=e.pageY-rect.top-ctx.columnHeaderHeight;var offsetX=0;var offsetY=0;x+=scrollLeft;y+=scrollTop;var r=rowLocation(y,ctx.visibledatarow)[2];var c=colLocation(x,ctx.visibledatacolumn)[2];var margeset=mergeBorder(ctx,flowdata,r,c);if(margeset){var _margeset$row2=index_esm_slicedToArray(margeset.row,3);r=_margeset$row2[2];var _margeset$column2=index_esm_slicedToArray(margeset.column,3);c=_margeset$column2[2];}var rc="".concat(r,"_").concat(c);var comment=(_flowdata$r=flowdata[r])===null||_flowdata$r===void 0?void 0:(_flowdata$r$c4=_flowdata$r[c])===null||_flowdata$r$c4===void 0?void 0:_flowdata$r$c4.ps;if(comment==null||comment.isShow||lodash_default().findIndex(ctx.commentBoxes,function(v){return v.rc===rc;})!==-1||((_ctx$editingCommentBo=ctx.editingCommentBox)===null||_ctx$editingCommentBo===void 0?void 0:_ctx$editingCommentBo.rc)===rc){ctx.hoveredCommentBox=undefined;return;}if(((_ctx$hoveredCommentBo=ctx.hoveredCommentBox)===null||_ctx$hoveredCommentBo===void 0?void 0:_ctx$hoveredCommentBo.rc)===rc)return;var row_pre=r-1===-1?0:ctx.visibledatarow[r-1];var col=ctx.visibledatacolumn[c];if(margeset){var _margeset$row3=index_esm_slicedToArray(margeset.row,1);row_pre=_margeset$row3[0];var _margeset$column3=index_esm_slicedToArray(margeset.column,2);col=_margeset$column3[1];}var toX=col+offsetX;var toY=row_pre+offsetY;var left=comment.left==null?toX+18*ctx.zoomRatio:comment.left*ctx.zoomRatio;var top=comment.top==null?toY-18*ctx.zoomRatio:comment.top*ctx.zoomRatio;if(top<0){top=2;}var width=comment.width==null?commentBoxProps.defaultWidth*ctx.zoomRatio:comment.width*ctx.zoomRatio;var height=comment.height==null?commentBoxProps.defaultHeight*ctx.zoomRatio:comment.height*ctx.zoomRatio;var size=getArrowCanvasSize(left,top,toX,toY);var value=comment.value==null?"":comment.value;ctx.hoveredCommentBox={r:r,c:c,rc:rc,left:left,top:top,width:width,height:height,size:size,value:value,autoFocus:false};}function getCommentBoxPosition(commentId){var box=document.getElementById(commentId);if(!box)return undefined;var _box$getBoundingClien=box.getBoundingClientRect(),width=_box$getBoundingClien.width,height=_box$getBoundingClien.height;var left=box.offsetLeft;var top=box.offsetTop;return{left:left,top:top,width:width,height:height};}function onCommentBoxResizeStart(ctx,globalCache,e,_ref3,resizingId,resizingSide){var r=_ref3.r,c=_ref3.c,rc=_ref3.rc;var position=getCommentBoxPosition(resizingId);if(position){lodash_default().set(globalCache,"commentBox",{cursorMoveStartPosition:{x:e.pageX,y:e.pageY},resizingId:resizingId,resizingSide:resizingSide,commentRC:{r:r,c:c,rc:rc},boxInitialPosition:position});}}function onCommentBoxResize(ctx,globalCache,e){if(ctx.allowEdit===false)return false;var commentBox=globalCache===null||globalCache===void 0?void 0:globalCache.commentBox;if((commentBox===null||commentBox===void 0?void 0:commentBox.resizingId)&&commentBox.resizingSide){var box=document.getElementById(commentBox.resizingId);var _commentBox$cursorMov=commentBox.cursorMoveStartPosition,startX=_commentBox$cursorMov.x,startY=_commentBox$cursorMov.y;var _commentBox$boxInitia=commentBox.boxInitialPosition,top=_commentBox$boxInitia.top,left=_commentBox$boxInitia.left,width=_commentBox$boxInitia.width,height=_commentBox$boxInitia.height;var dx=e.pageX-startX;var dy=e.pageY-startY;var minHeight=60*ctx.zoomRatio;var minWidth=1.5*60*ctx.zoomRatio;if(["lm","lt","lb"].includes(commentBox.resizingSide)){if(width-dx<minWidth){left+=width-minWidth;width=minWidth;}else{left+=dx;width-=dx;}if(left<0)left=0;box.style.left="".concat(left,"px");}if(["rm","rt","rb"].includes(commentBox.resizingSide)){width=width+dx<minWidth?minWidth:width+dx;}if(["mt","lt","rt"].includes(commentBox.resizingSide)){if(height-dy<minHeight){top+=height-minHeight;height=minHeight;}else{top+=dy;height-=dy;}if(top<0)top=0;box.style.top="".concat(top,"px");}if(["mb","lb","rb"].includes(commentBox.resizingSide)){height=height+dy<minHeight?minHeight:height+dy;}box.style.width="".concat(width,"px");box.style.height="".concat(height,"px");return true;}return false;}function onCommentBoxResizeEnd(ctx,globalCache){var _globalCache$commentB;if((_globalCache$commentB=globalCache.commentBox)===null||_globalCache$commentB===void 0?void 0:_globalCache$commentB.resizingId){var _globalCache$commentB2=globalCache.commentBox,resizingId=_globalCache$commentB2.resizingId,_globalCache$commentB3=_globalCache$commentB2.commentRC,r=_globalCache$commentB3.r,c=_globalCache$commentB3.c;globalCache.commentBox.resizingId=undefined;var position=getCommentBoxPosition(resizingId);if(position){var top=position.top,left=position.left,width=position.width,height=position.height;var flowdata=getFlowdata(ctx);var cell=flowdata===null||flowdata===void 0?void 0:flowdata[r][c];if(!flowdata||!(cell===null||cell===void 0?void 0:cell.ps))return;cell.ps.left=left/ctx.zoomRatio;cell.ps.top=top/ctx.zoomRatio;cell.ps.width=width/ctx.zoomRatio;cell.ps.height=height/ctx.zoomRatio;setEditingComment(ctx,flowdata,r,c);}}}function onCommentBoxMoveStart(ctx,globalCache,e,_ref4,movingId){var r=_ref4.r,c=_ref4.c,rc=_ref4.rc;var position=getCommentBoxPosition(movingId);if(position){var top=position.top,left=position.left;lodash_default().set(globalCache,"commentBox",{cursorMoveStartPosition:{x:e.pageX,y:e.pageY},movingId:movingId,commentRC:{r:r,c:c,rc:rc},boxInitialPosition:{left:left,top:top}});}}function onCommentBoxMove(ctx,globalCache,e){var allowEdit=isAllowEdit(ctx);if(!allowEdit)return false;var commentBox=globalCache===null||globalCache===void 0?void 0:globalCache.commentBox;if(commentBox===null||commentBox===void 0?void 0:commentBox.movingId){var box=document.getElementById(commentBox.movingId);var _commentBox$cursorMov2=commentBox.cursorMoveStartPosition,startX=_commentBox$cursorMov2.x,startY=_commentBox$cursorMov2.y;var _commentBox$boxInitia2=commentBox.boxInitialPosition,top=_commentBox$boxInitia2.top,left=_commentBox$boxInitia2.left;left+=e.pageX-startX;top+=e.pageY-startY;if(top<0)top=0;box.style.left="".concat(left,"px");box.style.top="".concat(top,"px");return true;}return false;}function onCommentBoxMoveEnd(ctx,globalCache){var _globalCache$commentB4;if((_globalCache$commentB4=globalCache.commentBox)===null||_globalCache$commentB4===void 0?void 0:_globalCache$commentB4.movingId){var _globalCache$commentB5=globalCache.commentBox,movingId=_globalCache$commentB5.movingId,_globalCache$commentB6=_globalCache$commentB5.commentRC,r=_globalCache$commentB6.r,c=_globalCache$commentB6.c;globalCache.commentBox.movingId=undefined;var position=getCommentBoxPosition(movingId);if(position){var top=position.top,left=position.left;var flowdata=getFlowdata(ctx);var cell=flowdata===null||flowdata===void 0?void 0:flowdata[r][c];if(!flowdata||!(cell===null||cell===void 0?void 0:cell.ps))return;cell.ps.left=left/ctx.zoomRatio;cell.ps.top=top/ctx.zoomRatio;setEditingComment(ctx,flowdata,r,c);}}}var imageProps={defaultWidth:144,defaultHeight:84,currentObj:null,currentWinW:null,currentWinH:null,resize:null,resizeXY:null,move:false,moveXY:null,cursorStartPosition:null};function generateRandomId(prefix){if(prefix==null){prefix="img";}var userAgent=window.navigator.userAgent.replace(/[^a-zA-Z0-9]/g,"").split("");var mid="";for(var i=0;i<12;i+=1){mid+=userAgent[Math.round(Math.random()*(userAgent.length-1))];}var time=new Date().getTime();return"".concat(prefix,"_").concat(mid,"_").concat(time);}function showImgChooser(){var chooser=document.getElementById("fortune-img-upload");if(chooser)chooser.click();}function saveImage(ctx){var index=getSheetIndex(ctx,ctx.currentSheetId);if(index==null)return;var file=ctx.luckysheetfile[index];file.images=ctx.insertedImgs;}function removeActiveImage(ctx){ctx.insertedImgs=lodash_default().filter(ctx.insertedImgs,function(image){return image.id!==ctx.activeImg;});ctx.activeImg=undefined;saveImage(ctx);}function insertImage(ctx,image){try{var _ctx$luckysheet_selec;var last=(_ctx$luckysheet_selec=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec===void 0?void 0:_ctx$luckysheet_selec[ctx.luckysheet_select_save.length-1];var rowIndex=last===null||last===void 0?void 0:last.row_focus;var colIndex=last===null||last===void 0?void 0:last.column_focus;if(!last){rowIndex=0;colIndex=0;}else{if(rowIndex==null){var _last$row=index_esm_slicedToArray(last.row,1);rowIndex=_last$row[0];}if(colIndex==null){var _last$column=index_esm_slicedToArray(last.column,1);colIndex=_last$column[0];}}var flowdata=getFlowdata(ctx);var left=colIndex===0?0:ctx.visibledatacolumn[colIndex-1];var top=rowIndex===0?0:ctx.visibledatarow[rowIndex-1];if(flowdata){var margeset=mergeBorder(ctx,flowdata,rowIndex,colIndex);if(margeset){var _margeset$row=index_esm_slicedToArray(margeset.row,1);top=_margeset$row[0];var _margeset$column=index_esm_slicedToArray(margeset.column,1);left=_margeset$column[0];}}var width=image.width;var height=image.height;var img={id:generateRandomId("img"),src:image.src,left:left,top:top,width:width*0.5,height:height*0.5,originWidth:width,originHeight:height};ctx.insertedImgs=(ctx.insertedImgs||[]).concat(img);saveImage(ctx);}catch(err){console.info(err);}}function getImagePosition(){var box=document.getElementById("luckysheet-modal-dialog-activeImage");if(!box)return undefined;var _box$getBoundingClien=box.getBoundingClientRect(),width=_box$getBoundingClien.width,height=_box$getBoundingClien.height;var left=box.offsetLeft;var top=box.offsetTop;return{left:left,top:top,width:width,height:height};}function cancelActiveImgItem(ctx,globalCache){ctx.activeImg=undefined;globalCache.image=undefined;}function onImageMoveStart(ctx,globalCache,e){var position=getImagePosition();if(position){var top=position.top,left=position.left;lodash_default().set(globalCache,"image",{cursorMoveStartPosition:{x:e.pageX,y:e.pageY},imgInitialPosition:{left:left,top:top}});}}function onImageMove(ctx,globalCache,e){if(ctx.allowEdit===false)return false;var image=globalCache===null||globalCache===void 0?void 0:globalCache.image;var img=document.getElementById("luckysheet-modal-dialog-activeImage");if(img&&image&&!image.resizingSide){var _image$cursorMoveStar=image.cursorMoveStartPosition,startX=_image$cursorMoveStar.x,startY=_image$cursorMoveStar.y;var _image$imgInitialPosi=image.imgInitialPosition,top=_image$imgInitialPosi.top,left=_image$imgInitialPosi.left;left+=e.pageX-startX;top+=e.pageY-startY;if(top<0)top=0;img.style.left="".concat(left,"px");img.style.top="".concat(top,"px");return true;}return false;}function onImageMoveEnd(ctx,globalCache){var _globalCache$image;var position=getImagePosition();if(!((_globalCache$image=globalCache.image)===null||_globalCache$image===void 0?void 0:_globalCache$image.resizingSide)){globalCache.image=undefined;if(position){var img=lodash_default().find(ctx.insertedImgs,function(v){return v.id===ctx.activeImg;});if(img){img.left=position.left/ctx.zoomRatio;img.top=position.top/ctx.zoomRatio;saveImage(ctx);}}}}function onImageResizeStart(globalCache,e,resizingSide){var position=getImagePosition();if(position){lodash_default().set(globalCache,"image",{cursorMoveStartPosition:{x:e.pageX,y:e.pageY},resizingSide:resizingSide,imgInitialPosition:position});}}function onImageResize(ctx,globalCache,e){if(ctx.allowEdit===false)return false;var image=globalCache===null||globalCache===void 0?void 0:globalCache.image;if(image===null||image===void 0?void 0:image.resizingSide){var imgContainer=document.getElementById("luckysheet-modal-dialog-activeImage");var img=imgContainer===null||imgContainer===void 0?void 0:imgContainer.querySelector(".luckysheet-modal-dialog-content");if(img==null)return false;var _image$cursorMoveStar2=image.cursorMoveStartPosition,startX=_image$cursorMoveStar2.x,startY=_image$cursorMoveStar2.y;var _image$imgInitialPosi2=image.imgInitialPosition,top=_image$imgInitialPosi2.top,left=_image$imgInitialPosi2.left,width=_image$imgInitialPosi2.width,height=_image$imgInitialPosi2.height;var dx=e.pageX-startX;var dy=e.pageY-startY;var minHeight=60*ctx.zoomRatio;var minWidth=1.5*60*ctx.zoomRatio;if(["lm","lt","lb"].includes(image.resizingSide)){if(width-dx<minWidth){left+=width-minWidth;width=minWidth;}else{left+=dx;width-=dx;}if(left<0)left=0;img.style.left="".concat(left,"px");imgContainer.style.left="".concat(left,"px");}if(["rm","rt","rb"].includes(image.resizingSide)){width=width+dx<minWidth?minWidth:width+dx;}if(["mt","lt","rt"].includes(image.resizingSide)){if(height-dy<minHeight){top+=height-minHeight;height=minHeight;}else{top+=dy;height-=dy;}if(top<0)top=0;img.style.top="".concat(top,"px");imgContainer.style.top="".concat(top,"px");}if(["mb","lb","rb"].includes(image.resizingSide)){height=height+dy<minHeight?minHeight:height+dy;}img.style.width="".concat(width,"px");imgContainer.style.width="".concat(width,"px");img.style.height="".concat(height,"px");imgContainer.style.height="".concat(height,"px");img.style.backgroundSize="".concat(width,"px ").concat(height,"px");return true;}return false;}function onImageResizeEnd(ctx,globalCache){var _globalCache$image2;if((_globalCache$image2=globalCache.image)===null||_globalCache$image2===void 0?void 0:_globalCache$image2.resizingSide){globalCache.image=undefined;var position=getImagePosition();if(position){var img=lodash_default().find(ctx.insertedImgs,function(v){return v.id===ctx.activeImg;});if(img){img.left=position.left/ctx.zoomRatio;img.top=position.top/ctx.zoomRatio;img.width=position.width/ctx.zoomRatio;img.height=position.height/ctx.zoomRatio;saveImage(ctx);}}}}function handleOverlayTouchStart(ctx,e,globalCache){globalCache.touchMoveStatus=true;var touch=e.targetTouches[0];globalCache.touchMoveStartPos={x:touch.pageX,y:touch.pageY,vy:0,moveType:"y"};}function handleOverlayTouchMove(ctx,e,globalCache,scrollbarX,scrollbarY){if(e.targetTouches.length>1)return;var touch=e.targetTouches[0];if(globalCache.touchMoveStatus){if(!globalCache.touchMoveStartPos)return;var slideX=touch.pageX-globalCache.touchMoveStartPos.x;var slideY=touch.pageY-globalCache.touchMoveStartPos.y;var scrollLeft=ctx.scrollLeft;var scrollTop=ctx.scrollTop;scrollLeft-=slideX;scrollTop-=slideY;scrollbarY.scrollTop=scrollTop;globalCache.touchMoveStartPos.vy_y=slideY;globalCache.touchMoveStartPos.scrollTop=scrollTop;scrollbarX.scrollLeft=scrollLeft;globalCache.touchMoveStartPos.vy_x=slideX;globalCache.touchMoveStartPos.scrollLeft=scrollLeft;}}function handleOverlayTouchEnd(globalCache){globalCache.touchMoveStatus=false;globalCache.touchHandleStatus=false;}function toPx(v){return"".concat(v,"px");}var dropCellCache={copyRange:{},applyRange:{},applyType:null,direction:null,chnNumChar:{零:0,一:1,二:2,三:3,四:4,五:5,六:6,七:7,八:8,九:9},chnNameValue:{十:{value:10,secUnit:false},百:{value:100,secUnit:false},千:{value:1000,secUnit:false},万:{value:10000,secUnit:true},亿:{value:100000000,secUnit:true}},chnNumChar2:["零","一","二","三","四","五","六","七","八","九"],chnUnitSection:["","万","亿","万亿","亿亿"],chnUnitChar:["","十","百","千"]};function chineseToNumber(chnStr){var rtn=0;var section=0;var number=0;var secUnit=false;var str=chnStr.split("");for(var i=0;i<str.length;i+=1){var num=dropCellCache.chnNumChar[str[i]];if(typeof num!=="undefined"){number=num;if(i===str.length-1){section+=number;}}else{var unit=dropCellCache.chnNameValue[str[i]].value;secUnit=dropCellCache.chnNameValue[str[i]].secUnit;if(secUnit){section=(section+number)*unit;rtn+=section;section=0;}else{section+=number*unit;}number=0;}}return rtn+section;}function sectionToChinese(section){var strIns="";var chnStr="";var unitPos=0;var zero=true;while(section>0){var v=section%10;if(v===0){if(!zero){zero=true;chnStr=dropCellCache.chnNumChar2[v]+chnStr;}}else{zero=false;strIns=dropCellCache.chnNumChar2[v];strIns+=dropCellCache.chnUnitChar[unitPos];chnStr=strIns+chnStr;}unitPos+=1;section=Math.floor(section/10);}return chnStr;}function numberToChinese(num){var strIns="";var chnStr="";var unitPos=0;var needZero=false;if(num===0){return dropCellCache.chnNumChar2[0];}while(num>0){var section=num%10000;if(needZero){chnStr=dropCellCache.chnNumChar2[0]+chnStr;}strIns=sectionToChinese(section);strIns+=section!==0?dropCellCache.chnUnitSection[unitPos]:dropCellCache.chnUnitSection[0];chnStr=strIns+chnStr;needZero=section<1000&&section>0;num=Math.floor(num/10000);unitPos+=1;}return chnStr;}function isChnNumber(txt){if(typeof txt==="number"){txt="".concat(txt);}var result=true;if(txt==null){result=false;}else if(txt.length===1){if(txt==="日"||txt in dropCellCache.chnNumChar){result=true;}else{result=false;}}else{var str=txt.split("");for(var i=0;i<str.length;i+=1){if(!(str[i]in dropCellCache.chnNumChar||str[i]in dropCellCache.chnNameValue)){result=false;break;}}}return result;}function isExtendNumber(txt){if(txt==null)return[false];if(typeof txt==="number"){txt="".concat(txt);}var reg=/0|([1-9]+[0-9]*)/g;var result=reg.test(txt);if(result){var match=txt.match(reg);if(match){var matchTxt=match[match.length-1];var matchIndex=txt.lastIndexOf(matchTxt);var beforeTxt=txt.slice(0,matchIndex);var afterTxt=txt.slice(matchIndex+matchTxt.length);return[result,Number(matchTxt),beforeTxt,afterTxt];}}return[result];}function isChnWeek2(txt){var result=false;if(typeof txt==="number"){txt="".concat(txt);}if(txt!==undefined&&txt.length===2){if(txt==="周一"||txt==="周二"||txt==="周三"||txt==="周四"||txt==="周五"||txt==="周六"||txt==="周日"){result=true;}}return result;}function isChnWeek3(txt){if(typeof txt==="number"){txt="".concat(txt);}var result=false;if(txt!==undefined&&txt.length===3){if(txt==="星期一"||txt==="星期二"||txt==="星期三"||txt==="星期四"||txt==="星期五"||txt==="星期六"||txt==="星期日"){result=true;}}return result;}function isEqualDiff(arr){var diff=true;var step=arr[1]-arr[0];for(var i=1;i<arr.length;i+=1){if(arr[i]-arr[i-1]!==step){diff=false;break;}}return diff;}function isEqualRatio(arr){var ratio=true;var step=arr[1]/arr[0];for(var i=1;i<arr.length;i+=1){if(arr[i]/arr[i-1]!==step){ratio=false;break;}}return ratio;}function getXArr(len){var xArr=[];for(var i=1;i<=len;i+=1){xArr.push(i);}return xArr;}function forecast(x,yArr,xArr){function getAverage(arr){var sum=0;for(var i=0;i<arr.length;i+=1){sum+=arr[i];}return sum/arr.length;}var ax=getAverage(xArr);var ay=getAverage(yArr);var sum_d=0;var sum_n=0;for(var j=0;j<xArr.length;j+=1){sum_d+=(xArr[j]-ax)*(yArr[j]-ay);sum_n+=(xArr[j]-ax)*(xArr[j]-ax);}var b;if(sum_n===0){b=1;}else{b=sum_d/sum_n;}var a=ay-b*ax;return Math.round((a+b*x)*100000)/100000;}function judgeDate(data){var isSameDay=true;var isSameMonth=true;var isEqualDiffDays=true;var isEqualDiffMonths=true;var isEqualDiffYears=true;if(data[0]==null||data[1]==null)return[false,false,false,false,false];var sameDay=dayjs_min_default()(data[0].m).date();var sameMonth=dayjs_min_default()(data[0].m).month();var equalDiffDays=dayjs_min_default()(data[1].m).diff(dayjs_min_default()(data[0].m),"days");var equalDiffMonths=dayjs_min_default()(data[1].m).diff(dayjs_min_default()(data[0].m),"months");var equalDiffYears=dayjs_min_default()(data[1].m).diff(dayjs_min_default()(data[0].m),"years");for(var i=1;i<data.length;i+=1){var _data$i,_data$i2,_data$i3,_data,_data$i4,_data2,_data$i5,_data3;if(dayjs_min_default()((_data$i=data[i])===null||_data$i===void 0?void 0:_data$i.m).date()!==sameDay){isSameDay=false;}if(dayjs_min_default()((_data$i2=data[i])===null||_data$i2===void 0?void 0:_data$i2.m).month()!==sameMonth){isSameMonth=false;}if(dayjs_min_default()((_data$i3=data[i])===null||_data$i3===void 0?void 0:_data$i3.m).diff(dayjs_min_default()((_data=data[i-1])===null||_data===void 0?void 0:_data.m),"days")!==equalDiffDays){isEqualDiffDays=false;}if(dayjs_min_default()((_data$i4=data[i])===null||_data$i4===void 0?void 0:_data$i4.m).diff(dayjs_min_default()((_data2=data[i-1])===null||_data2===void 0?void 0:_data2.m),"months")!==equalDiffMonths){isEqualDiffMonths=false;}if(dayjs_min_default()((_data$i5=data[i])===null||_data$i5===void 0?void 0:_data$i5.m).diff(dayjs_min_default()((_data3=data[i-1])===null||_data3===void 0?void 0:_data3.m),"years")!==equalDiffYears){isEqualDiffYears=false;}}if(equalDiffDays===0){isEqualDiffDays=false;}if(equalDiffMonths===0){isEqualDiffMonths=false;}if(equalDiffYears===0){isEqualDiffYears=false;}return[isSameDay,isSameMonth,isEqualDiffDays,isEqualDiffMonths,isEqualDiffYears];}function showDropCellSelection(_ref,container){var width=_ref.width,height=_ref.height,top=_ref.top,left=_ref.left;var selectedExtend=container.querySelector(".fortune-cell-selected-extend");if(selectedExtend){selectedExtend.style.left=toPx(left);selectedExtend.style.width=toPx(width);selectedExtend.style.top=toPx(top);selectedExtend.style.height=toPx(height);selectedExtend.style.display="block";}}function hideDropCellSelection(container){var selectedExtend=container.querySelector(".fortune-cell-selected-extend");if(selectedExtend){selectedExtend.style.display="none";}}function createDropCellRange(ctx,e,container){ctx.luckysheet_cell_selected_extend=true;ctx.luckysheet_scroll_status=true;var scrollLeft=ctx.scrollLeft,scrollTop=ctx.scrollTop;var rect=container.getBoundingClientRect();var x=e.pageX-rect.left-ctx.rowHeaderWidth+scrollLeft;var y=e.pageY-rect.top-ctx.columnHeaderHeight+scrollTop;var row_location=rowLocation(y,ctx.visibledatarow);var row_pre=row_location[0];var row=row_location[1];var row_index=row_location[2];var col_location=colLocation(x,ctx.visibledatacolumn);var col_pre=col_location[0];var col=col_location[1];var col_index=col_location[2];ctx.luckysheet_cell_selected_extend_index=[row_index,col_index];showDropCellSelection({left:col_pre,width:col-col_pre-1,top:row_pre,height:row-row_pre-1},container);}function onDropCellSelect(ctx,e,scrollX,scrollY,container){var scrollLeft=scrollX.scrollLeft;var scrollTop=scrollY.scrollTop;var rect=container.getBoundingClientRect();var x=e.pageX-rect.left-ctx.rowHeaderWidth+scrollLeft;var y=e.pageY-rect.top-ctx.columnHeaderHeight+scrollTop;var row_location=rowLocation(y,ctx.visibledatarow);var row=row_location[1];var row_pre=row_location[0];var row_index=row_location[2];var col_location=colLocation(x,ctx.visibledatacolumn);var col=col_location[1];var col_pre=col_location[0];var col_index=col_location[2];var row_index_original=ctx.luckysheet_cell_selected_extend_index[0];var col_index_original=ctx.luckysheet_cell_selected_extend_index[1];if(!ctx.luckysheet_select_save)return;var row_s=ctx.luckysheet_select_save[0].row[0];var row_e=ctx.luckysheet_select_save[0].row[1];var col_s=ctx.luckysheet_select_save[0].column[0];var col_e=ctx.luckysheet_select_save[0].column[1];var top=ctx.luckysheet_select_save[0].top_move;var height=ctx.luckysheet_select_save[0].height_move;var left=ctx.luckysheet_select_save[0].left_move;var width=ctx.luckysheet_select_save[0].width_move;if(top==null||height==null||left==null||width==null)return;if(Math.abs(row_index_original-row_index)>Math.abs(col_index_original-col_index)){if(!(row_index>=row_s&&row_index<=row_e)){if(top>=row_pre){height+=top-row_pre;top=row_pre;}else{height=row-top-1;}}}else{if(!(col_index>=col_s&&col_index<=col_e)){if(left>=col_pre){width+=left-col_pre;left=col_pre;}else{width=col-left-1;}}}if(y<0){row_s=0;var _ctx$luckysheet_selec=index_esm_slicedToArray(ctx.luckysheet_select_save[0].row,1);row_e=_ctx$luckysheet_selec[0];}if(x<0){col_s=0;var _ctx$luckysheet_selec2=index_esm_slicedToArray(ctx.luckysheet_select_save[0].column,1);col_e=_ctx$luckysheet_selec2[0];}showDropCellSelection({left:left,width:width,top:top,height:height},container);}function fillCopy(data,len){var applyData=[];for(var i=1;i<=len;i+=1){var index=(i-1)%data.length;var d=lodash_default().cloneDeep(data[index]);if(!lodash_default().isUndefined(d)){applyData.push(d);}}return applyData;}function fillSeries(data,len,direction){var applyData=[];var dataNumArr=[];for(var j=0;j<data.length;j+=1){var d=lodash_default().cloneDeep(data[j]);if(d!=null){dataNumArr.push(Number(d.v));}}if(data.length>2&&isEqualRatio(dataNumArr)&&data[0]!=null&&data[1]!=null){for(var i=1;i<=len;i+=1){var index=(i-1)%data.length;var _d=lodash_default().cloneDeep(data[index]);if(_d!=null){var num=void 0;if(direction==="down"||direction==="right"){num=Number(data[data.length-1].v)*Math.pow(Number(data[1].v)/Number(data[0].v),i);}else{num=Number(data[0].v)/Math.pow(Number(data[1].v)/Number(data[0].v),i);}_d.v=num;if(_d.ct!=null&&_d.ct.fa!=null){_d.m=update(_d.ct.fa,num);}applyData.push(_d);}}}else{var xArr=getXArr(data.length);for(var _i=1;_i<=len;_i+=1){var _index=(_i-1)%data.length;var _d2=lodash_default().cloneDeep(data[_index]);if(_d2!=null){var y=void 0;if(direction==="down"||direction==="right"){y=forecast(data.length+_i,dataNumArr,xArr);}else if(direction==="up"||direction==="left"){y=forecast(1-_i,dataNumArr,xArr);}_d2.v=y;if(_d2.ct!=null&&_d2.ct.fa!=null){_d2.m=update(_d2.ct.fa,y);}applyData.push(_d2);}}}return applyData;}function fillExtendNumber(data,len,step){var applyData=[];var reg=/0|([1-9]+[0-9]*)/g;for(var i=1;i<=len;i+=1){var _data4;var index=(i-1)%data.length;var d=lodash_default().cloneDeep(data[index]);var last=(_data4=data[data.length-1])===null||_data4===void 0?void 0:_data4.m;if(d!=null&&last!=null){last="".concat(last);var match=last.match(reg)||"";var lastTxt=match[match.length-1];var num=Math.abs(Number(lastTxt)+step*i);var lastIndex=last.lastIndexOf(lastTxt);var valueTxt=last.slice(0,lastIndex)+num.toString()+last.slice(lastIndex+lastTxt.length);d.v=valueTxt;d.m=valueTxt;applyData.push(d);}}return applyData;}function fillDays(data,len,step){var applyData=[];for(var i=1;i<=len;i+=1){var d=lodash_default().cloneDeep(data[data.length-1]);if(d!=null){var _genarate;var date=update("yyyy-MM-dd",d.v);date=dayjs_min_default()(date).add(step*i,"days").format("YYYY-MM-DD");d.v=(_genarate=genarate(date))===null||_genarate===void 0?void 0:_genarate[2];if(d.ct!=null&&d.ct.fa!=null){d.m=update(d.ct.fa,d.v);}applyData.push(d);}}return applyData;}function fillMonths(data,len,step){var applyData=[];for(var i=1;i<=len;i+=1){var d=lodash_default().cloneDeep(data[data.length-1]);if(d!=null){var _genarate2;var date=update("yyyy-MM-dd",d.v);date=dayjs_min_default()(date).add(step*i,"months").format("YYYY-MM-DD");d.v=(_genarate2=genarate(date))===null||_genarate2===void 0?void 0:_genarate2[2];if(d.ct!=null&&d.ct.fa!=null){d.m=update(d.ct.fa,d.v);}applyData.push(d);}}return applyData;}function fillYears(data,len,step){var applyData=[];for(var i=1;i<=len;i+=1){var d=lodash_default().cloneDeep(data[data.length-1]);if(d!=null){var _genarate3;var date=update("yyyy-MM-dd",d.v);date=dayjs_min_default()(date).add(step*i,"years").format("YYYY-MM-DD");d.v=(_genarate3=genarate(date))===null||_genarate3===void 0?void 0:_genarate3[2];if(d.ct!=null&&d.ct.fa!=null){d.m=update(d.ct.fa,d.v);}}applyData.push(d);}return applyData;}function fillChnWeek(data,len,step){var applyData=[];for(var i=1;i<=len;i+=1){var _data5;var index=(i-1)%data.length;var d=lodash_default().cloneDeep(data[index]);var num=void 0;var m=(_data5=data[data.length-1])===null||_data5===void 0?void 0:_data5.m;if(m!=null&&d!=null){if(m==="日"){num=7+step*i;}else{num=chineseToNumber("".concat(m))+step*i;}if(num<0){num=Math.ceil(Math.abs(num)/7)*7+num;}var rsd=num%7;if(rsd===0){d.m="日";d.v="日";}else if(rsd===1){d.m="一";d.v="一";}else if(rsd===2){d.m="二";d.v="二";}else if(rsd===3){d.m="三";d.v="三";}else if(rsd===4){d.m="四";d.v="四";}else if(rsd===5){d.m="五";d.v="五";}else if(rsd===6){d.m="六";d.v="六";}applyData.push(d);}}return applyData;}function fillChnWeek2(data,len,step){var applyData=[];for(var i=1;i<=len;i+=1){var _data6;var index=(i-1)%data.length;var d=lodash_default().cloneDeep(data[index]);var num=void 0;var m=(_data6=data[data.length-1])===null||_data6===void 0?void 0:_data6.m;if(m!=null&&d!=null){if(m==="周日"){num=7+step*i;}else{var last="".concat(m);var txt=last.slice(last.length-1,1);num=chineseToNumber(txt)+step*i;}if(num<0){num=Math.ceil(Math.abs(num)/7)*7+num;}var rsd=num%7;if(rsd===0){d.m="周日";d.v="周日";}else if(rsd===1){d.m="周一";d.v="周一";}else if(rsd===2){d.m="周二";d.v="周二";}else if(rsd===3){d.m="周三";d.v="周三";}else if(rsd===4){d.m="周四";d.v="周四";}else if(rsd===5){d.m="周五";d.v="周五";}else if(rsd===6){d.m="周六";d.v="周六";}}applyData.push(d);}return applyData;}function fillChnWeek3(data,len,step){var applyData=[];for(var i=1;i<=len;i+=1){var _data7;var index=(i-1)%data.length;var d=lodash_default().cloneDeep(data[index]);var num=void 0;var m=(_data7=data[data.length-1])===null||_data7===void 0?void 0:_data7.m;if(m!=null&&d!=null){if(m==="星期日"){num=7+step*i;}else{var last="".concat(m);var txt=last.slice(last.length-1,1);num=chineseToNumber(txt)+step*i;}if(num<0){num=Math.ceil(Math.abs(num)/7)*7+num;}var rsd=num%7;if(rsd===0){d.m="星期日";d.v="星期日";}else if(rsd===1){d.m="星期一";d.v="星期一";}else if(rsd===2){d.m="星期二";d.v="星期二";}else if(rsd===3){d.m="星期三";d.v="星期三";}else if(rsd===4){d.m="星期四";d.v="星期四";}else if(rsd===5){d.m="星期五";d.v="星期五";}else if(rsd===6){d.m="星期六";d.v="星期六";}}applyData.push(d);}return applyData;}function fillChnNumber(data,len,step){var applyData=[];for(var i=1;i<=len;i+=1){var _data8;var index=(i-1)%data.length;var d=lodash_default().cloneDeep(data[index]);var m=(_data8=data[data.length-1])===null||_data8===void 0?void 0:_data8.m;if(m!=null&&d!=null){var num=chineseToNumber("".concat(m))+step*i;var txt=void 0;if(num<=0){txt="零";}else{txt=numberToChinese(num);}d.v=txt;d.m=txt.toString();applyData.push(d);}}return applyData;}function getTypeItemHide(ctx){var copyRange=dropCellCache.copyRange;var str_r=copyRange.row[0];var end_r=copyRange.row[1];var str_c=copyRange.column[0];var end_c=copyRange.column[1];var hasNumber=false;var hasExtendNumber=false;var hasDate=false;var hasChn=false;var hasChnWeek1=false;var hasChnWeek2=false;var hasChnWeek3=false;var flowdata=getFlowdata(ctx);if(flowdata==null)return[];for(var r=str_r;r<=end_r;r+=1){for(var c=str_c;c<=end_c;c+=1){if(flowdata[r][c]){var cell=flowdata[r][c];if(cell!==null&&cell.v!=null&&cell.f==null){if(cell.ct!=null&&cell.ct.t==="n"){hasNumber=true;}else if(cell.ct!=null&&cell.ct.t==="d"){hasDate=true;}else if(isExtendNumber(cell.m)[0]){hasExtendNumber=true;}else if(isChnNumber(cell.m)&&cell.m!=="日"){hasChn=true;}else if(cell.m!=null&&cell.m==="日"){hasChnWeek1=true;}else if(isChnWeek2(cell.m)){hasChnWeek2=true;}else if(isChnWeek3(cell.m)){hasChnWeek3=true;}}}}}return[hasNumber,hasExtendNumber,hasDate,hasChn,hasChnWeek1,hasChnWeek2,hasChnWeek3];}function getLenS(indexArr,rsd){var s=0;for(var j=0;j<indexArr.length;j+=1){if(indexArr[j]<=rsd){s+=1;}else{break;}}return s;}function getDataIndex(csLen,asLen,indexArr){var obj={};var num=Math.floor(asLen/csLen);var rsd=asLen%csLen;var sum=0;if(num>0){for(var i=1;i<=num;i+=1){for(var j=0;j<indexArr.length;j+=1){obj[indexArr[j]+(i-1)*csLen]=sum;sum+=1;}}for(var a=0;a<indexArr.length;a+=1){if(indexArr[a]<=rsd){obj[indexArr[a]+csLen*num]=sum;sum+=1;}else{break;}}}else{for(var _a=0;_a<indexArr.length;_a+=1){if(indexArr[_a]<=rsd){obj[indexArr[_a]]=sum;sum+=1;}else{break;}}}return obj;}function getDataByType(data,len,direction,type,dataType){data=lodash_default().cloneDeep(data);var applyData=[];if(type==="0"||data.length===1){if(direction==="up"||direction==="left"){data.reverse();}applyData=fillCopy(data,len);}else if(type==="1"){var _data$5;if(dataType==="number"){applyData=fillSeries(data,len,direction);}else if(dataType==="extendNumber"){var dataNumArr=[];for(var i=0;i<data.length;i+=1){var _data$i6;var txt=(_data$i6=data[i])===null||_data$i6===void 0?void 0:_data$i6.m;var _isExtendNumber=isExtendNumber(txt);if(_isExtendNumber[0]){dataNumArr.push(_isExtendNumber[1]);}}if(direction==="up"||direction==="left"){data.reverse();dataNumArr.reverse();}if(isEqualDiff(dataNumArr)){var step=dataNumArr[1]-dataNumArr[0];applyData=fillExtendNumber(data,len,step);}else{applyData=fillCopy(data,len);}}else if(dataType==="date"){if(direction==="up"||direction==="left"){data.reverse();}var _judgeDate=judgeDate(data);if(_judgeDate[0]&&_judgeDate[3]){var _data$,_data$2;var _step=dayjs_min_default()((_data$=data[1])===null||_data$===void 0?void 0:_data$.m).diff(dayjs_min_default()((_data$2=data[0])===null||_data$2===void 0?void 0:_data$2.m),"months");applyData=fillMonths(data,len,_step);}else if(!_judgeDate[0]&&_judgeDate[2]){var _data$3,_data$4;var _step2=dayjs_min_default()((_data$3=data[1])===null||_data$3===void 0?void 0:_data$3.m).diff(dayjs_min_default()((_data$4=data[0])===null||_data$4===void 0?void 0:_data$4.m),"days");applyData=fillDays(data,len,_step2);}else{applyData=fillCopy(data,len);}}else if(dataType==="chnNumber"&&((_data$5=data[0])===null||_data$5===void 0?void 0:_data$5.m)!=null){var hasweek=false;for(var _i2=0;_i2<data.length;_i2+=1){var _data$_i;if(((_data$_i=data[_i2])===null||_data$_i===void 0?void 0:_data$_i.m)==="日"){hasweek=true;break;}}var _dataNumArr=[];var weekIndex=0;for(var _i3=0;_i3<data.length;_i3+=1){var _data$_i2;var m=(_data$_i2=data[_i3])===null||_data$_i2===void 0?void 0:_data$_i2.m;if(m!=null){m="".concat(m);if(m==="日"){if(_i3===0){_dataNumArr.push(0);}else{weekIndex+=1;_dataNumArr.push(weekIndex*7);}}else if(hasweek&&chineseToNumber(m)>0&&chineseToNumber(m)<7){_dataNumArr.push(chineseToNumber(m)+weekIndex*7);}else{_dataNumArr.push(chineseToNumber(m));}}}if(direction==="up"||direction==="left"){data.reverse();_dataNumArr.reverse();}if(isEqualDiff(_dataNumArr)){if(hasweek||_dataNumArr[_dataNumArr.length-1]<6&&_dataNumArr[0]>0||_dataNumArr[0]<6&&_dataNumArr[_dataNumArr.length-1]>0){var _step3=_dataNumArr[1]-_dataNumArr[0];applyData=fillChnWeek(data,len,_step3);}else{var _step4=_dataNumArr[1]-_dataNumArr[0];applyData=fillChnNumber(data,len,_step4);}}else{applyData=fillCopy(data,len);}}else if(dataType==="chnWeek2"){var _dataNumArr2=[];var _weekIndex=0;for(var _i4=0;_i4<data.length;_i4+=1){var _data$_i3;var _m=(_data$_i3=data[_i4])===null||_data$_i3===void 0?void 0:_data$_i3.m;if(_m!=null){_m="".concat(_m);var lastTxt=_m.slice(_m.length-1,1);if(_m==="周日"){if(_i4===0){_dataNumArr2.push(0);}else{_weekIndex+=1;_dataNumArr2.push(_weekIndex*7);}}else{_dataNumArr2.push(chineseToNumber(lastTxt)+_weekIndex*7);}}}if(direction==="up"||direction==="left"){data.reverse();_dataNumArr2.reverse();}if(isEqualDiff(_dataNumArr2)){var _step5=_dataNumArr2[1]-_dataNumArr2[0];applyData=fillChnWeek2(data,len,_step5);}else{applyData=fillCopy(data,len);}}else if(dataType==="chnWeek3"){var _dataNumArr3=[];var _weekIndex2=0;for(var _i5=0;_i5<data.length;_i5+=1){var _data$_i4;var _m2=(_data$_i4=data[_i5])===null||_data$_i4===void 0?void 0:_data$_i4.m;if(_m2!=null){_m2="".concat(_m2);var _lastTxt=_m2.slice(_m2.length-1,1);if(_m2==="星期日"){if(_i5===0){_dataNumArr3.push(0);}else{_weekIndex2+=1;_dataNumArr3.push(_weekIndex2*7);}}else{_dataNumArr3.push(chineseToNumber(_lastTxt)+_weekIndex2*7);}}}if(direction==="up"||direction==="left"){data.reverse();_dataNumArr3.reverse();}if(isEqualDiff(_dataNumArr3)){var _step6=_dataNumArr3[1]-_dataNumArr3[0];applyData=fillChnWeek3(data,len,_step6);}else{applyData=fillCopy(data,len);}}else{if(direction==="up"||direction==="left"){data.reverse();}applyData=fillCopy(data,len);}}else if(type==="4"){if(data.length===2){var _data$6,_data$7;if(direction==="up"||direction==="left"){data.reverse();}var _step7=dayjs_min_default()((_data$6=data[1])===null||_data$6===void 0?void 0:_data$6.m).diff(dayjs_min_default()((_data$7=data[0])===null||_data$7===void 0?void 0:_data$7.m),"days");applyData=fillDays(data,len,_step7);}else{if(direction==="up"||direction==="left"){data.reverse();}var _judgeDate2=judgeDate(data);if(_judgeDate2[0]&&_judgeDate2[3]){var _data$8,_data$9;var _step8=dayjs_min_default()((_data$8=data[1])===null||_data$8===void 0?void 0:_data$8.m).diff(dayjs_min_default()((_data$9=data[0])===null||_data$9===void 0?void 0:_data$9.m),"months");applyData=fillMonths(data,len,_step8);}else if(!_judgeDate2[0]&&_judgeDate2[2]){var _data$10,_data$11;var _step9=dayjs_min_default()((_data$10=data[1])===null||_data$10===void 0?void 0:_data$10.m).diff(dayjs_min_default()((_data$11=data[0])===null||_data$11===void 0?void 0:_data$11.m),"days");applyData=fillDays(data,len,_step9);}else{applyData=fillCopy(data,len);}}}else if(type==="5"){if(data.length===2){var _data$12,_data$13,_data$14,_data$15;if(dayjs_min_default()((_data$12=data[1])===null||_data$12===void 0?void 0:_data$12.m).date()===dayjs_min_default()((_data$13=data[0])===null||_data$13===void 0?void 0:_data$13.m).date()&&dayjs_min_default()((_data$14=data[1])===null||_data$14===void 0?void 0:_data$14.m).diff(dayjs_min_default()((_data$15=data[0])===null||_data$15===void 0?void 0:_data$15.m),"months")!==0){var _data$16,_data$17;if(direction==="up"||direction==="left"){data.reverse();}var _step10=dayjs_min_default()((_data$16=data[1])===null||_data$16===void 0?void 0:_data$16.m).diff(dayjs_min_default()((_data$17=data[0])===null||_data$17===void 0?void 0:_data$17.m),"months");for(var _i6=1;_i6<=len;_i6+=1){var _data9;var index=(_i6-1)%data.length;var d=lodash_default().cloneDeep(data[index]);var last=(_data9=data[data.length-1])===null||_data9===void 0?void 0:_data9.m;if(d!=null&&last!=null){var _genarate4;var day=dayjs_min_default()(last).add(_step10*_i6,"months").day();var date=void 0;if(day===0){date=dayjs_min_default()(last).add(_step10*_i6,"months").subtract(2,"days").format("YYYY-MM-DD");}else if(day===6){date=dayjs_min_default()(last).add(_step10*_i6,"months").subtract(1,"days").format("YYYY-MM-DD");}else{date=dayjs_min_default()(last).add(_step10*_i6,"months").format("YYYY-MM-DD");}d.m=date;d.v=(_genarate4=genarate(date))===null||_genarate4===void 0?void 0:_genarate4[2];applyData.push(d);}}}else{var _data$18,_data$19;if(Math.abs(dayjs_min_default()((_data$18=data[1])===null||_data$18===void 0?void 0:_data$18.m).diff(dayjs_min_default()((_data$19=data[0])===null||_data$19===void 0?void 0:_data$19.m)))>7){var step_month;if(direction==="down"||direction==="right"){step_month=1;}else{step_month=-1;data.reverse();}var _step11;for(var _i7=1;_i7<=len;_i7+=1){var _index2=(_i7-1)%data.length;var _d3=lodash_default().cloneDeep(data[_index2]);if(_d3!=null){var _genarate5;var num=Math.ceil(_i7/data.length);if(_index2===0){_step11=dayjs_min_default()(_d3.m).add(step_month*num,"months").diff(dayjs_min_default()(_d3.m),"days");}var _day=dayjs_min_default()(_d3.m).add(_step11,"days").day();var _date=void 0;if(_day===0){_date=dayjs_min_default()(_d3.m).add(_step11,"days").subtract(2,"days").format("YYYY-MM-DD");}else if(_day===6){_date=dayjs_min_default()(_d3.m).add(_step11,"days").subtract(1,"days").format("YYYY-MM-DD");}else{_date=dayjs_min_default()(_d3.m).add(_step11,"days").format("YYYY-MM-DD");}_d3.m=_date;_d3.v=(_genarate5=genarate(_date))===null||_genarate5===void 0?void 0:_genarate5[2];applyData.push(_d3);}}}else{var step_day;if(direction==="down"||direction==="right"){step_day=7;}else{step_day=-7;data.reverse();}var _step12;for(var _i8=1;_i8<=len;_i8+=1){var _index3=(_i8-1)%data.length;var _d4=lodash_default().cloneDeep(data[_index3]);if(_d4!=null){var _genarate6;var _num=Math.ceil(_i8/data.length);if(_index3===0){_step12=dayjs_min_default()(_d4.m).add(step_day*_num,"days").diff(dayjs_min_default()(_d4.m),"days");}var _day2=dayjs_min_default()(_d4.m).add(_step12,"days").day();var _date2=void 0;if(_day2===0){_date2=dayjs_min_default()(_d4.m).add(_step12,"days").subtract(2,"days").format("YYYY-MM-DD");}else if(_day2===6){_date2=dayjs_min_default()(_d4.m).add(_step12,"days").subtract(1,"days").format("YYYY-MM-DD");}else{_date2=dayjs_min_default()(_d4.m).add(_step12,"days").format("YYYY-MM-DD");}_d4.m=_date2;_d4.v=(_genarate6=genarate(_date2))===null||_genarate6===void 0?void 0:_genarate6[2];applyData.push(_d4);}}}}}else{var _judgeDate3=judgeDate(data);if(_judgeDate3[0]&&_judgeDate3[3]){var _data$20,_data$21;if(direction==="up"||direction==="left"){data.reverse();}var _step13=dayjs_min_default()((_data$20=data[1])===null||_data$20===void 0?void 0:_data$20.m).diff(dayjs_min_default()((_data$21=data[0])===null||_data$21===void 0?void 0:_data$21.m),"months");for(var _i9=1;_i9<=len;_i9+=1){var _data10;var _index4=(_i9-1)%data.length;var _d5=lodash_default().cloneDeep(data[_index4]);var _last=(_data10=data[data.length-1])===null||_data10===void 0?void 0:_data10.m;if(_d5!=null){var _genarate7;var _day3=dayjs_min_default()(_last).add(_step13*_i9,"months").day();var _date3=void 0;if(_day3===0){_date3=dayjs_min_default()(_last).add(_step13*_i9,"months").subtract(2,"days").format("YYYY-MM-DD");}else if(_day3===6){_date3=dayjs_min_default()(_last).add(_step13*_i9,"months").subtract(1,"days").format("YYYY-MM-DD");}else{_date3=dayjs_min_default()(_last).add(_step13*_i9,"months").format("YYYY-MM-DD");}_d5.m=_date3;_d5.v=(_genarate7=genarate(_date3))===null||_genarate7===void 0?void 0:_genarate7[2];applyData.push(_d5);}}}else if(!_judgeDate3[0]&&_judgeDate3[2]){var _data$22,_data$23;if(Math.abs(dayjs_min_default()((_data$22=data[1])===null||_data$22===void 0?void 0:_data$22.m).diff(dayjs_min_default()((_data$23=data[0])===null||_data$23===void 0?void 0:_data$23.m)))>7){var _step_month;if(direction==="down"||direction==="right"){_step_month=1;}else{_step_month=-1;data.reverse();}var _step14;for(var _i10=1;_i10<=len;_i10+=1){var _index5=(_i10-1)%data.length;var _d6=lodash_default().cloneDeep(data[_index5]);if(_d6!=null){var _genarate8;var _num2=Math.ceil(_i10/data.length);if(_index5===0){_step14=dayjs_min_default()(_d6.m).add(_step_month*_num2,"months").diff(dayjs_min_default()(_d6.m),"days");}var _day4=dayjs_min_default()(_d6.m).add(_step14,"days").day();var _date4=void 0;if(_day4===0){_date4=dayjs_min_default()(_d6.m).add(_step14,"days").subtract(2,"days").format("YYYY-MM-DD");}else if(_day4===6){_date4=dayjs_min_default()(_d6.m).add(_step14,"days").subtract(1,"days").format("YYYY-MM-DD");}else{_date4=dayjs_min_default()(_d6.m).add(_step14,"days").format("YYYY-MM-DD");}_d6.m=_date4;_d6.v=(_genarate8=genarate(_date4))===null||_genarate8===void 0?void 0:_genarate8[2];applyData.push(_d6);}}}else{var _step_day;if(direction==="down"||direction==="right"){_step_day=7;}else{_step_day=-7;data.reverse();}var _step15;for(var _i11=1;_i11<=len;_i11+=1){var _index6=(_i11-1)%data.length;var _d7=lodash_default().cloneDeep(data[_index6]);if(_d7!=null){var _genarate9;var _num3=Math.ceil(_i11/data.length);if(_index6===0){_step15=dayjs_min_default()(_d7.m).add(_step_day*_num3,"days").diff(dayjs_min_default()(_d7.m),"days");}var _day5=dayjs_min_default()(_d7.m).add(_step15,"days").day();var _date5=void 0;if(_day5===0){_date5=dayjs_min_default()(_d7.m).add(_step15,"days").subtract(2,"days").format("YYYY-MM-DD");}else if(_day5===6){_date5=dayjs_min_default()(_d7.m).add(_step15,"days").subtract(1,"days").format("YYYY-MM-DD");}else{_date5=dayjs_min_default()(_d7.m).add(_step15,"days").format("YYYY-MM-DD");}_d7.m=_date5;_d7.v=(_genarate9=genarate(_date5))===null||_genarate9===void 0?void 0:_genarate9[2];applyData.push(_d7);}}}}else{if(direction==="up"||direction==="left"){data.reverse();}applyData=fillCopy(data,len);}}}else if(type==="6"){if(data.length===2){var _data$24,_data$25,_data$26,_data$27;if(dayjs_min_default()((_data$24=data[1])===null||_data$24===void 0?void 0:_data$24.m).date()===dayjs_min_default()((_data$25=data[0])===null||_data$25===void 0?void 0:_data$25.m).date()&&dayjs_min_default()((_data$26=data[1])===null||_data$26===void 0?void 0:_data$26.m).diff(dayjs_min_default()((_data$27=data[0])===null||_data$27===void 0?void 0:_data$27.m),"months")!==0){var _data$28,_data$29;if(direction==="up"||direction==="left"){data.reverse();}var _step16=dayjs_min_default()((_data$28=data[1])===null||_data$28===void 0?void 0:_data$28.m).diff(dayjs_min_default()((_data$29=data[0])===null||_data$29===void 0?void 0:_data$29.m),"months");applyData=fillMonths(data,len,_step16);}else{var _step_month2;if(direction==="down"||direction==="right"){_step_month2=1;}else{_step_month2=-1;data.reverse();}var _step17;for(var _i12=1;_i12<=len;_i12+=1){var _index7=(_i12-1)%data.length;var _d8=lodash_default().cloneDeep(data[_index7]);if(_d8!=null){var _genarate10;var _num4=Math.ceil(_i12/data.length);if(_index7===0){_step17=dayjs_min_default()(_d8.m).add(_step_month2*_num4,"months").diff(dayjs_min_default()(_d8.m),"days");}var _date6=dayjs_min_default()(_d8.m).add(_step17,"days").format("YYYY-MM-DD");_d8.m=_date6;_d8.v=(_genarate10=genarate(_date6))===null||_genarate10===void 0?void 0:_genarate10[2];applyData.push(_d8);}}}}else{var _judgeDate4=judgeDate(data);if(_judgeDate4[0]&&_judgeDate4[3]){var _data$30,_data$31;if(direction==="up"||direction==="left"){data.reverse();}var _step18=dayjs_min_default()((_data$30=data[1])===null||_data$30===void 0?void 0:_data$30.m).diff(dayjs_min_default()((_data$31=data[0])===null||_data$31===void 0?void 0:_data$31.m),"months");applyData=fillMonths(data,len,_step18);}else if(!_judgeDate4[0]&&_judgeDate4[2]){var _step_month3;if(direction==="down"||direction==="right"){_step_month3=1;}else{_step_month3=-1;data.reverse();}var _step19;for(var _i13=1;_i13<=len;_i13+=1){var _index8=(_i13-1)%data.length;var _d9=lodash_default().cloneDeep(data[_index8]);if(_d9!=null){var _genarate11;var _num5=Math.ceil(_i13/data.length);if(_index8===0){_step19=dayjs_min_default()(_d9.m).add(_step_month3*_num5,"months").diff(dayjs_min_default()(_d9.m),"days");}var _date7=dayjs_min_default()(_d9.m).add(_step19,"days").format("YYYY-MM-DD");_d9.m=_date7;_d9.v=(_genarate11=genarate(_date7))===null||_genarate11===void 0?void 0:_genarate11[2];applyData.push(_d9);}}}else{if(direction==="up"||direction==="left"){data.reverse();}applyData=fillCopy(data,len);}}}else if(type==="7"){if(data.length===2){var _data$32,_data$33,_data$34,_data$35,_data$36,_data$37;if(dayjs_min_default()((_data$32=data[1])===null||_data$32===void 0?void 0:_data$32.m).date()===dayjs_min_default()((_data$33=data[0])===null||_data$33===void 0?void 0:_data$33.m).date()&&dayjs_min_default()((_data$34=data[1])===null||_data$34===void 0?void 0:_data$34.m).month()===dayjs_min_default()((_data$35=data[0])===null||_data$35===void 0?void 0:_data$35.m).month()&&dayjs_min_default()((_data$36=data[1])===null||_data$36===void 0?void 0:_data$36.m).diff(dayjs_min_default()((_data$37=data[0])===null||_data$37===void 0?void 0:_data$37.m),"years")!==0){var _data$38,_data$39;if(direction==="up"||direction==="left"){data.reverse();}var _step20=dayjs_min_default()((_data$38=data[1])===null||_data$38===void 0?void 0:_data$38.m).diff(dayjs_min_default()((_data$39=data[0])===null||_data$39===void 0?void 0:_data$39.m),"years");applyData=fillYears(data,len,_step20);}else{var step_year;if(direction==="down"||direction==="right"){step_year=1;}else{step_year=-1;data.reverse();}var _step21;for(var _i14=1;_i14<=len;_i14+=1){var _index9=(_i14-1)%data.length;var _d10=lodash_default().cloneDeep(data[_index9]);if(_d10!=null){var _genarate12;var _num6=Math.ceil(_i14/data.length);if(_index9===0){_step21=dayjs_min_default()(_d10.m).add(step_year*_num6,"years").diff(dayjs_min_default()(_d10.m),"days");}var _date8=dayjs_min_default()(_d10.m).add(_step21,"days").format("YYYY-MM-DD");_d10.m=_date8;_d10.v=(_genarate12=genarate(_date8))===null||_genarate12===void 0?void 0:_genarate12[2];applyData.push(_d10);}}}}else{var _judgeDate5=judgeDate(data);if(_judgeDate5[0]&&_judgeDate5[1]&&_judgeDate5[4]){var _data$40,_data$41;if(direction==="up"||direction==="left"){data.reverse();}var _step22=dayjs_min_default()((_data$40=data[1])===null||_data$40===void 0?void 0:_data$40.m).diff(dayjs_min_default()((_data$41=data[0])===null||_data$41===void 0?void 0:_data$41.m),"years");applyData=fillYears(data,len,_step22);}else if(_judgeDate5[0]&&_judgeDate5[3]||_judgeDate5[2]){var _step_year;if(direction==="down"||direction==="right"){_step_year=1;}else{_step_year=-1;data.reverse();}var _step23;for(var _i15=1;_i15<=len;_i15+=1){var _index10=(_i15-1)%data.length;var _d11=lodash_default().cloneDeep(data[_index10]);var _num7=Math.ceil(_i15/data.length);if(_d11!=null){var _genarate13;if(_index10===0){_step23=dayjs_min_default()(_d11.m).add(_step_year*_num7,"years").diff(dayjs_min_default()(_d11.m),"days");}var _date9=dayjs_min_default()(_d11.m).add(_step23,"days").format("YYYY-MM-DD");_d11.m=_date9;_d11.v=(_genarate13=genarate(_date9))===null||_genarate13===void 0?void 0:_genarate13[2];applyData.push(_d11);}}}else{if(direction==="up"||direction==="left"){data.reverse();}applyData=fillCopy(data,len);}}}else if(type==="8"){var _dataNumArr4=[];for(var _i16=0;_i16<data.length;_i16+=1){var _data$_i5;var _m3=(_data$_i5=data[_i16])===null||_data$_i5===void 0?void 0:_data$_i5.m;if(_m3!=null){_m3="".concat(_m3);_dataNumArr4.push(chineseToNumber(_m3));}}if(direction==="up"||direction==="left"){data.reverse();_dataNumArr4.reverse();}if(isEqualDiff(_dataNumArr4)){var _step24=_dataNumArr4[1]-_dataNumArr4[0];applyData=fillChnNumber(data,len,_step24);}else{applyData=fillCopy(data,len);}}return applyData;}function getCopyData(d,r1,r2,c1,c2,direction){var copyData=[];var a1;var a2;var b1;var b2;if(direction==="down"||direction==="up"){a1=c1;a2=c2;b1=r1;b2=r2;}else{a1=r1;a2=r2;b1=c1;b2=c2;}for(var a=a1;a<=a2;a+=1){var obj={};var arrData=[];var arrIndex=[];var text="";var extendNumberBeforeStr=null;var extendNumberAfterStr=null;var isSameStr=true;for(var b=b1;b<=b2;b+=1){var _data11;var data=void 0;if(direction==="down"||direction==="up"){data=d[b][a];}else if(direction==="right"||direction==="left"){data=d[a][b];}var str=void 0;if(((_data11=data)===null||_data11===void 0?void 0:_data11.v)!=null&&data.f==null){if(!!data.ct&&data.ct.t==="n"){str="number";extendNumberBeforeStr=null;extendNumberAfterStr=null;}else if(!!data.ct&&data.ct.t==="d"){str="date";extendNumberBeforeStr=null;extendNumberAfterStr=null;}else if(isExtendNumber(data.m)[0]){str="extendNumber";var _isExtendNumber=isExtendNumber(data.m);if(extendNumberBeforeStr==null||extendNumberAfterStr==null){isSameStr=true;var _isExtendNumber2=index_esm_slicedToArray(_isExtendNumber,4);extendNumberBeforeStr=_isExtendNumber2[2];extendNumberAfterStr=_isExtendNumber2[3];}else{if(_isExtendNumber[2]!==extendNumberBeforeStr||_isExtendNumber[3]!==extendNumberAfterStr){isSameStr=false;var _isExtendNumber3=index_esm_slicedToArray(_isExtendNumber,4);extendNumberBeforeStr=_isExtendNumber3[2];extendNumberAfterStr=_isExtendNumber3[3];}else{isSameStr=true;}}}else if(isChnNumber(data.m)){str="chnNumber";extendNumberBeforeStr=null;extendNumberAfterStr=null;}else if(isChnWeek2(data.m)){str="chnWeek2";extendNumberBeforeStr=null;extendNumberAfterStr=null;}else if(isChnWeek3(data.m)){str="chnWeek3";extendNumberBeforeStr=null;extendNumberAfterStr=null;}else{str="other";extendNumberBeforeStr=null;extendNumberAfterStr=null;}}else{str="other";extendNumberBeforeStr=null;extendNumberAfterStr=null;}if(str==="extendNumber"){if(b===b1){if(b1===b2){text=str;arrData.push(data);arrIndex.push(b-b1+1);obj[text]=[];obj[text].push({data:arrData,index:arrIndex});}else{text=str;arrData.push(data);arrIndex.push(b-b1+1);}}else if(b===b2){if(text===str&&isSameStr){arrData.push(data);arrIndex.push(b-b1+1);if(text in obj){obj[text].push({data:arrData,index:arrIndex});}else{obj[text]=[];obj[text].push({data:arrData,index:arrIndex});}}else{if(text in obj){obj[text].push({data:arrData,index:arrIndex});}else{obj[text]=[];obj[text].push({data:arrData,index:arrIndex});}text=str;arrData=[];arrData.push(data);arrIndex=[];arrIndex.push(b-b1+1);if(text in obj){obj[text].push({data:arrData,index:arrIndex});}else{obj[text]=[];obj[text].push({data:arrData,index:arrIndex});}}}else{if(text===str&&isSameStr){arrData.push(data);arrIndex.push(b-b1+1);}else{if(text in obj){obj[text].push({data:arrData,index:arrIndex});}else{obj[text]=[];obj[text].push({data:arrData,index:arrIndex});}text=str;arrData=[];arrData.push(data);arrIndex=[];arrIndex.push(b-b1+1);}}}else{if(b===b1){if(b1===b2){text=str;arrData.push(data);arrIndex.push(b-b1+1);obj[text]=[];obj[text].push({data:arrData,index:arrIndex});}else{text=str;arrData.push(data);arrIndex.push(b-b1+1);}}else if(b===b2){if(text===str){arrData.push(data);arrIndex.push(b-b1+1);if(text in obj){obj[text].push({data:arrData,index:arrIndex});}else{obj[text]=[];obj[text].push({data:arrData,index:arrIndex});}}else{if(text in obj){obj[text].push({data:arrData,index:arrIndex});}else{obj[text]=[];obj[text].push({data:arrData,index:arrIndex});}text=str;arrData=[];arrData.push(data);arrIndex=[];arrIndex.push(b-b1+1);if(text in obj){obj[text].push({data:arrData,index:arrIndex});}else{obj[text]=[];obj[text].push({data:arrData,index:arrIndex});}}}else{if(text===str){arrData.push(data);arrIndex.push(b-b1+1);}else{if(text in obj){obj[text].push({data:arrData,index:arrIndex});}else{obj[text]=[];obj[text].push({data:arrData,index:arrIndex});}text=str;arrData=[];arrData.push(data);arrIndex=[];arrIndex.push(b-b1+1);}}}}copyData.push(obj);}return copyData;}function getApplyData(copyD,csLen,asLen){var applyData=[];var direction=dropCellCache.direction;var type=dropCellCache.applyType;var num=Math.floor(asLen/csLen);var rsd=asLen%csLen;var copyD_number=copyD.number;var applyD_number=[];if(copyD_number){for(var i=0;i<copyD_number.length;i+=1){var s=getLenS(copyD_number[i].index,rsd);var len=copyD_number[i].index.length*num+s;var arrData=void 0;if(type==="1"||type==="3"){arrData=getDataByType(copyD_number[i].data,len,direction,type,"number");}else if(type==="2"){arrData=getDataByType(copyD_number[i].data,len,direction,type);}else{arrData=getDataByType(copyD_number[i].data,len,direction,"0");}var arrIndex=getDataIndex(csLen,asLen,copyD_number[i].index);applyD_number.push({data:arrData,index:arrIndex});}}var copyD_extendNumber=copyD.extendNumber;var applyD_extendNumber=[];if(copyD_extendNumber){for(var _i17=0;_i17<copyD_extendNumber.length;_i17+=1){var _s=getLenS(copyD_extendNumber[_i17].index,rsd);var _len=copyD_extendNumber[_i17].index.length*num+_s;var _arrData=void 0;if(type==="1"||type==="3"){_arrData=getDataByType(copyD_extendNumber[_i17].data,_len,direction,type,"extendNumber");}else if(type==="2"){_arrData=getDataByType(copyD_extendNumber[_i17].data,_len,direction,type);}else{_arrData=getDataByType(copyD_extendNumber[_i17].data,_len,direction,"0");}var _arrIndex=getDataIndex(csLen,asLen,copyD_extendNumber[_i17].index);applyD_extendNumber.push({data:_arrData,index:_arrIndex});}}var copyD_date=copyD.date;var applyD_date=[];if(copyD_date){for(var _i18=0;_i18<copyD_date.length;_i18+=1){var _s2=getLenS(copyD_date[_i18].index,rsd);var _len2=copyD_date[_i18].index.length*num+_s2;var _arrData2=void 0;if(type==="1"||type==="3"){_arrData2=getDataByType(copyD_date[_i18].data,_len2,direction,type,"date");}else if(type==="8"){_arrData2=getDataByType(copyD_date[_i18].data,_len2,direction,"0");}else{_arrData2=getDataByType(copyD_date[_i18].data,_len2,direction,type);}var _arrIndex2=getDataIndex(csLen,asLen,copyD_date[_i18].index);applyD_date.push({data:_arrData2,index:_arrIndex2});}}var copyD_chnNumber=copyD.chnNumber;var applyD_chnNumber=[];if(copyD_chnNumber){for(var _i19=0;_i19<copyD_chnNumber.length;_i19+=1){var _s3=getLenS(copyD_chnNumber[_i19].index,rsd);var _len3=copyD_chnNumber[_i19].index.length*num+_s3;var _arrData3=void 0;if(type==="1"||type==="3"){_arrData3=getDataByType(copyD_chnNumber[_i19].data,_len3,direction,type,"chnNumber");}else if(type==="2"||type==="8"){_arrData3=getDataByType(copyD_chnNumber[_i19].data,_len3,direction,type);}else{_arrData3=getDataByType(copyD_chnNumber[_i19].data,_len3,direction,"0");}var _arrIndex3=getDataIndex(csLen,asLen,copyD_chnNumber[_i19].index);applyD_chnNumber.push({data:_arrData3,index:_arrIndex3});}}var copyD_chnWeek2=copyD.chnWeek2;var applyD_chnWeek2=[];if(copyD_chnWeek2){for(var _i20=0;_i20<copyD_chnWeek2.length;_i20+=1){var _s4=getLenS(copyD_chnWeek2[_i20].index,rsd);var _len4=copyD_chnWeek2[_i20].index.length*num+_s4;var _arrData4=void 0;if(type==="1"||type==="3"){_arrData4=getDataByType(copyD_chnWeek2[_i20].data,_len4,direction,type,"chnWeek2");}else if(type==="2"){_arrData4=getDataByType(copyD_chnWeek2[_i20].data,_len4,direction,type);}else{_arrData4=getDataByType(copyD_chnWeek2[_i20].data,_len4,direction,"0");}var _arrIndex4=getDataIndex(csLen,asLen,copyD_chnWeek2[_i20].index);applyD_chnWeek2.push({data:_arrData4,index:_arrIndex4});}}var copyD_chnWeek3=copyD.chnWeek3;var applyD_chnWeek3=[];if(copyD_chnWeek3){for(var _i21=0;_i21<copyD_chnWeek3.length;_i21+=1){var _s5=getLenS(copyD_chnWeek3[_i21].index,rsd);var _len5=copyD_chnWeek3[_i21].index.length*num+_s5;var _arrData5=void 0;if(type==="1"||type==="3"){_arrData5=getDataByType(copyD_chnWeek3[_i21].data,_len5,direction,type,"chnWeek3");}else if(type==="2"){_arrData5=getDataByType(copyD_chnWeek3[_i21].data,_len5,direction,type);}else{_arrData5=getDataByType(copyD_chnWeek3[_i21].data,_len5,direction,"0");}var _arrIndex5=getDataIndex(csLen,asLen,copyD_chnWeek3[_i21].index);applyD_chnWeek3.push({data:_arrData5,index:_arrIndex5});}}var copyD_other=copyD.other;var applyD_other=[];if(copyD_other){for(var _i22=0;_i22<copyD_other.length;_i22+=1){var _s6=getLenS(copyD_other[_i22].index,rsd);var _len6=copyD_other[_i22].index.length*num+_s6;var _arrData6=void 0;if(type==="2"||type==="3"){_arrData6=getDataByType(copyD_other[_i22].data,_len6,direction,type);}else{_arrData6=getDataByType(copyD_other[_i22].data,_len6,direction,"0");}var _arrIndex6=getDataIndex(csLen,asLen,copyD_other[_i22].index);applyD_other.push({data:_arrData6,index:_arrIndex6});}}for(var x=1;x<=asLen;x+=1){if(applyD_number.length>0){for(var y=0;y<applyD_number.length;y+=1){if(x in applyD_number[y].index){applyData.push(applyD_number[y].data[applyD_number[y].index[x]]);}}}if(applyD_extendNumber.length>0){for(var _y=0;_y<applyD_extendNumber.length;_y+=1){if(x in applyD_extendNumber[_y].index){applyData.push(applyD_extendNumber[_y].data[applyD_extendNumber[_y].index[x]]);}}}if(applyD_date.length>0){for(var _y2=0;_y2<applyD_date.length;_y2+=1){if(x in applyD_date[_y2].index){applyData.push(applyD_date[_y2].data[applyD_date[_y2].index[x]]);}}}if(applyD_chnNumber.length>0){for(var _y3=0;_y3<applyD_chnNumber.length;_y3+=1){if(x in applyD_chnNumber[_y3].index){applyData.push(applyD_chnNumber[_y3].data[applyD_chnNumber[_y3].index[x]]);}}}if(applyD_chnWeek2.length>0){for(var _y4=0;_y4<applyD_chnWeek2.length;_y4+=1){if(x in applyD_chnWeek2[_y4].index){applyData.push(applyD_chnWeek2[_y4].data[applyD_chnWeek2[_y4].index[x]]);}}}if(applyD_chnWeek3.length>0){for(var _y5=0;_y5<applyD_chnWeek3.length;_y5+=1){if(x in applyD_chnWeek3[_y5].index){applyData.push(applyD_chnWeek3[_y5].data[applyD_chnWeek3[_y5].index[x]]);}}}if(applyD_other.length>0){for(var _y6=0;_y6<applyD_other.length;_y6+=1){if(x in applyD_other[_y6].index){applyData.push(applyD_other[_y6].data[applyD_other[_y6].index[x]]);}}}}return applyData;}function updateDropCell(ctx){var _file$config,_file$config2;var d=getFlowdata(ctx);var allowEdit=isAllowEdit(ctx);if(allowEdit===false||d==null){return;}var index=getSheetIndex(ctx,ctx.currentSheetId);if(index==null)return;var file=ctx.luckysheetfile[index];var hiddenRows=new Set(Object.keys(((_file$config=file.config)===null||_file$config===void 0?void 0:_file$config.rowhidden)||{}));var hiddenCols=new Set(Object.keys(((_file$config2=file.config)===null||_file$config2===void 0?void 0:_file$config2.colhidden)||{}));var cfg=lodash_default().cloneDeep(ctx.config);if(cfg.borderInfo==null){cfg.borderInfo=[];}var borderInfoCompute=getBorderInfoCompute(ctx,ctx.currentSheetId);var dataVerification=lodash_default().cloneDeep(file.dataVerification);var direction=dropCellCache.direction;var copyRange=dropCellCache.copyRange;var copy_str_r=copyRange.row[0];var copy_end_r=copyRange.row[1];var copy_str_c=copyRange.column[0];var copy_end_c=copyRange.column[1];var copyData=getCopyData(d,copy_str_r,copy_end_r,copy_str_c,copy_end_c,direction);var csLen;if(direction==="down"||direction==="up"){csLen=copy_end_r-copy_str_r+1;}else{csLen=copy_end_c-copy_str_c+1;}var applyRange=dropCellCache.applyRange;var apply_str_r=applyRange.row[0];var apply_end_r=applyRange.row[1];var apply_str_c=applyRange.column[0];var apply_end_c=applyRange.column[1];if(direction==="down"||direction==="up"){var asLen=apply_end_r-apply_str_r+1;for(var i=apply_str_c;i<=apply_end_c;i+=1){if(hiddenCols.has("".concat(i)))continue;var copyD=copyData[i-apply_str_c];var applyData=getApplyData(copyD,csLen,asLen);if(direction==="down"){for(var j=apply_str_r;j<=apply_end_r;j+=1){if(hiddenRows.has("".concat(j)))continue;var cell=applyData[j-apply_str_r];if((cell===null||cell===void 0?void 0:cell.f)!=null){var f="=".concat(functionCopy(ctx,cell.f,"down",j-apply_str_r+1));var v=execfunction(ctx,f,j,i);execFunctionGroup(ctx,j,i,v[1],undefined,d);var _v=index_esm_slicedToArray(v,3);cell.v=_v[1];cell.f=_v[2];if(cell.spl!=null){cell.spl=v[3].data;}else if(cell.v!=null){if(isRealNum(cell.v)&&!/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test("".concat(cell.v))){if(cell.v===Infinity||cell.v===-Infinity){cell.m=cell.v.toString();}else{if(cell.v.toString().indexOf("e")>-1){var len=cell.v.toString().split(".")[1].split("e")[0].length;if(len>5){len=5;}cell.m=cell.v.toExponential(len).toString();}else{var _cell$ct;var mask=void 0;if(((_cell$ct=cell.ct)===null||_cell$ct===void 0?void 0:_cell$ct.fa)==="##0.00"){mask=genarate("".concat(Math.round(cell.v*1000000000)/1000000000,".00"));cell.m=mask[0].toString();}else{mask=genarate(Math.round(cell.v*1000000000)/1000000000);cell.m=mask[0].toString();}}}cell.ct=cell.ct||{fa:"General",t:"n"};}else{var _mask=genarate(cell.v);cell.m=_mask[0].toString();var _mask2=index_esm_slicedToArray(_mask,2);cell.ct=_mask2[1];}}}d[j][i]=cell||null;var bd_r=copy_str_r+(j-apply_str_r)%csLen;var bd_c=i;if(borderInfoCompute["".concat(bd_r,"_").concat(bd_c)]){var bd_obj={rangeType:"cell",value:{row_index:j,col_index:i,l:borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].l,r:borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].r,t:borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].t,b:borderInfoCompute["".concat(bd_r,"_").concat(bd_c)].b}};cfg.borderInfo.push(bd_obj);}else if(borderInfoCompute["".concat(j,"_").concat(i)]){var _bd_obj={rangeType:"cell",value:{row_index:j,col_index:i,l:null,r:null,t:null,b:null}};cfg.borderInfo.push(_bd_obj);}if(dataVerification!=null&&dataVerification["".concat(bd_r,"_").concat(bd_c)]){dataVerification["".concat(j,"_").concat(i)]=dataVerification["".concat(bd_r,"_").concat(bd_c)];}}}if(direction==="up"){for(var _j=apply_end_r;_j>=apply_str_r;_j-=1){if(hiddenRows.has("".concat(_j)))continue;var _cell=applyData[apply_end_r-_j];if((_cell===null||_cell===void 0?void 0:_cell.f)!=null){var _f="=".concat(functionCopy(ctx,_cell.f,"up",apply_end_r-_j+1));var _v2=execfunction(ctx,_f,_j,i);execFunctionGroup(ctx,_j,i,_v2[1],undefined,d);var _v3=index_esm_slicedToArray(_v2,3);_cell.v=_v3[1];_cell.f=_v3[2];if(_cell.spl!=null){_cell.spl=_v2[3].data;}else if(_cell.v!=null){if(isRealNum(_cell.v)&&!/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test("".concat(_cell.v))){if(_cell.v===Infinity||_cell.v===-Infinity){_cell.m=_cell.v.toString();}else{if(_cell.v.toString().indexOf("e")>-1){var _len7=_cell.v.toString().split(".")[1].split("e")[0].length;if(_len7>5){_len7=5;}_cell.m=_cell.v.toExponential(_len7).toString();}else{var _mask3=genarate(Math.round(_cell.v*1000000000)/1000000000);_cell.m=_mask3[0].toString();}}_cell.ct={fa:"General",t:"n"};}else{var _mask4=genarate(_cell.v);_cell.m=_mask4[0].toString();var _mask5=index_esm_slicedToArray(_mask4,2);_cell.ct=_mask5[1];}}}d[_j][i]=_cell||null;var _bd_r=copy_end_r-(apply_end_r-_j)%csLen;var _bd_c=i;if(borderInfoCompute["".concat(_bd_r,"_").concat(_bd_c)]){var _bd_obj2={rangeType:"cell",value:{row_index:_j,col_index:i,l:borderInfoCompute["".concat(_bd_r,"_").concat(_bd_c)].l,r:borderInfoCompute["".concat(_bd_r,"_").concat(_bd_c)].r,t:borderInfoCompute["".concat(_bd_r,"_").concat(_bd_c)].t,b:borderInfoCompute["".concat(_bd_r,"_").concat(_bd_c)].b}};cfg.borderInfo.push(_bd_obj2);}else if(borderInfoCompute["".concat(_j,"_").concat(i)]){var _bd_obj3={rangeType:"cell",value:{row_index:_j,col_index:i,l:null,r:null,t:null,b:null}};cfg.borderInfo.push(_bd_obj3);}if(dataVerification!=null&&dataVerification["".concat(_bd_r,"_").concat(_bd_c)]){dataVerification["".concat(_j,"_").concat(i)]=dataVerification["".concat(_bd_r,"_").concat(_bd_c)];}}}}}else if(direction==="right"||direction==="left"){var _asLen=apply_end_c-apply_str_c+1;for(var _i23=apply_str_r;_i23<=apply_end_r;_i23+=1){if(hiddenRows.has("".concat(_i23)))continue;var _copyD=copyData[_i23-apply_str_r];var _applyData=getApplyData(_copyD,csLen,_asLen);if(direction==="right"){for(var _j2=apply_str_c;_j2<=apply_end_c;_j2+=1){if(hiddenCols.has("".concat(_j2)))continue;var _cell2=_applyData[_j2-apply_str_c];if((_cell2===null||_cell2===void 0?void 0:_cell2.f)!=null){var _f2="=".concat(functionCopy(ctx,_cell2.f,"right",_j2-apply_str_c+1));var _v4=execfunction(ctx,_f2,_i23,_j2);execFunctionGroup(ctx,_j2,_i23,_v4[1],undefined,d);var _v5=index_esm_slicedToArray(_v4,3);_cell2.v=_v5[1];_cell2.f=_v5[2];if(_cell2.spl!=null){_cell2.spl=_v4[3].data;}else if(_cell2.v!=null){if(isRealNum(_cell2.v)&&!/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test("".concat(_cell2.v))){if(_cell2.v===Infinity||_cell2.v===-Infinity){_cell2.m=_cell2.v.toString();}else{if(_cell2.v.toString().indexOf("e")>-1){var _len8=_cell2.v.toString().split(".")[1].split("e")[0].length;if(_len8>5){_len8=5;}_cell2.m=_cell2.v.toExponential(_len8).toString();}else{var _mask6=genarate(Math.round(_cell2.v*1000000000)/1000000000);_cell2.m=_mask6[0].toString();}}_cell2.ct={fa:"General",t:"n"};}else{var _mask7=genarate(_cell2.v);_cell2.m=_mask7[0].toString();var _mask8=index_esm_slicedToArray(_mask7,2);_cell2.ct=_mask8[1];}}}d[_i23][_j2]=_cell2||null;var _bd_r2=_i23;var _bd_c2=copy_str_c+(_j2-apply_str_c)%csLen;if(borderInfoCompute["".concat(_bd_r2,"_").concat(_bd_c2)]){var _bd_obj4={rangeType:"cell",value:{row_index:_i23,col_index:_j2,l:borderInfoCompute["".concat(_bd_r2,"_").concat(_bd_c2)].l,r:borderInfoCompute["".concat(_bd_r2,"_").concat(_bd_c2)].r,t:borderInfoCompute["".concat(_bd_r2,"_").concat(_bd_c2)].t,b:borderInfoCompute["".concat(_bd_r2,"_").concat(_bd_c2)].b}};cfg.borderInfo.push(_bd_obj4);}else if(borderInfoCompute["".concat(_i23,"_").concat(_j2)]){var _bd_obj5={rangeType:"cell",value:{row_index:_i23,col_index:_j2,l:null,r:null,t:null,b:null}};cfg.borderInfo.push(_bd_obj5);}if(dataVerification!=null&&dataVerification["".concat(_bd_r2,"_").concat(_bd_c2)]){dataVerification["".concat(_i23,"_").concat(_j2)]=dataVerification["".concat(_bd_r2,"_").concat(_bd_c2)];}}}if(direction==="left"){for(var _j3=apply_end_c;_j3>=apply_str_c;_j3-=1){if(hiddenCols.has("".concat(_j3)))continue;var _cell3=_applyData[apply_end_c-_j3];if((_cell3===null||_cell3===void 0?void 0:_cell3.f)!=null){var _f3="=".concat(functionCopy(ctx,_cell3.f,"left",apply_end_c-_j3+1));var _v6=execfunction(ctx,_f3,_i23,_j3);execFunctionGroup(ctx,_j3,_i23,_v6[1],undefined,d);var _v7=index_esm_slicedToArray(_v6,3);_cell3.v=_v7[1];_cell3.f=_v7[2];if(_cell3.spl!=null){_cell3.spl=_v6[3].data;}else if(_cell3.v!=null){if(isRealNum(_cell3.v)&&!/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test("".concat(_cell3.v))){if(_cell3.v===Infinity||_cell3.v===-Infinity){_cell3.m=_cell3.v.toString();}else{if(_cell3.v.toString().indexOf("e")>-1){var _len9=_cell3.v.toString().split(".")[1].split("e")[0].length;if(_len9>5){_len9=5;}_cell3.m=_cell3.v.toExponential(_len9).toString();}else{var _mask9=genarate(Math.round(_cell3.v*1000000000)/1000000000);_cell3.m=_mask9[0].toString();}}_cell3.ct={fa:"General",t:"n"};}else{var _mask10=genarate(_cell3.v);_cell3.m=_mask10[0].toString();var _mask11=index_esm_slicedToArray(_mask10,2);_cell3.ct=_mask11[1];}}}d[_i23][_j3]=_cell3||null;var _bd_r3=_i23;var _bd_c3=copy_end_c-(apply_end_c-_j3)%csLen;if(borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)]){var _bd_obj6={rangeType:"cell",value:{row_index:_i23,col_index:_j3,l:borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)].l,r:borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)].r,t:borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)].t,b:borderInfoCompute["".concat(_bd_r3,"_").concat(_bd_c3)].b}};cfg.borderInfo.push(_bd_obj6);}else if(borderInfoCompute["".concat(_i23,"_").concat(_j3)]){var _bd_obj7={rangeType:"cell",value:{row_index:_i23,col_index:_j3,l:null,r:null,t:null,b:null}};cfg.borderInfo.push(_bd_obj7);}if(dataVerification!=null&&dataVerification["".concat(_bd_r3,"_").concat(_bd_c3)]){dataVerification["".concat(_i23,"_").concat(_j3)]=dataVerification["".concat(_bd_r3,"_").concat(_bd_c3)];}}}}}var cdformat=file.luckysheet_conditionformat_save;if(cdformat!=null&&cdformat.length>0){for(var _i24=0;_i24<cdformat.length;_i24+=1){var cdformat_cellrange=cdformat[_i24].cellrange;var emptyRange=[];for(var _j4=0;_j4<cdformat_cellrange.length;_j4+=1){var range=CFSplitRange(cdformat_cellrange[_j4],{row:copyRange.row,column:copyRange.column},{row:applyRange.row,column:applyRange.column},"operatePart");if(range.length>0){emptyRange=emptyRange.concat(range);}}if(emptyRange.length>0){cdformat[_i24].cellrange.push(applyRange);}}}jfrefreshgrid(ctx,d,ctx.luckysheet_select_save);}function onDropCellSelectEnd(ctx,e,container){var _ctx$luckysheet_selec3;ctx.luckysheet_cell_selected_extend=false;hideDropCellSelection(container);var scrollLeft=ctx.scrollLeft,scrollTop=ctx.scrollTop;var rect=container.getBoundingClientRect();var x=e.pageX-rect.left-ctx.rowHeaderWidth+scrollLeft;var y=e.pageY-rect.top-ctx.columnHeaderHeight+scrollTop;var row_location=rowLocation(y,ctx.visibledatarow);var row_pre=row_location[0];var row_index=row_location[2];var col_location=colLocation(x,ctx.visibledatacolumn);var col_pre=col_location[0];var col_index=col_location[2];var row_index_original=ctx.luckysheet_cell_selected_extend_index[0];var col_index_original=ctx.luckysheet_cell_selected_extend_index[1];var last=(_ctx$luckysheet_selec3=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec3===void 0?void 0:_ctx$luckysheet_selec3[ctx.luckysheet_select_save.length-1];if(last&&last.top!=null&&last.left!=null&&last.height!=null&&last.width!=null&&last.row_focus!=null&&last.column_focus!=null){var row_s=last.row[0];var row_e=last.row[1];var col_s=last.column[0];var col_e=last.column[1];dropCellCache.copyRange=lodash_default().cloneDeep(lodash_default().pick(last,["row","column"]));var typeItemHide=getTypeItemHide(ctx);if(!typeItemHide[0]&&!typeItemHide[1]&&!typeItemHide[2]&&!typeItemHide[3]&&!typeItemHide[4]&&!typeItemHide[5]&&!typeItemHide[6]){dropCellCache.applyType="0";}else{dropCellCache.applyType="1";}if(ctx.luckysheet_select_save==null)return;var _ctx$luckysheet_selec4=ctx.luckysheet_select_save[0],top_move=_ctx$luckysheet_selec4.top_move,left_move=_ctx$luckysheet_selec4.left_move;if(Math.abs(row_index_original-row_index)>Math.abs(col_index_original-col_index)){if(!(row_index>=row_s&&row_index<=row_e)){if(top_move!=null&&top_move>=row_pre){dropCellCache.applyRange={row:[row_index,last.row[0]-1],column:last.column};dropCellCache.direction="up";row_s-=last.row[0]-row_index;}else{dropCellCache.applyRange={row:[last.row[1]+1,row_index],column:last.column};dropCellCache.direction="down";row_e+=row_index-last.row[1];}}else{return;}}else{if(!(col_index>=col_s&&col_index<=col_e)){if(left_move!=null&&left_move>=col_pre){dropCellCache.applyRange={row:last.row,column:[col_index,last.column[0]-1]};dropCellCache.direction="left";col_s-=last.column[0]-col_index;}else{dropCellCache.applyRange={row:last.row,column:[last.column[1]+1,col_index]};dropCellCache.direction="right";col_e+=col_index-last.column[1];}}else{return;}}if(y<0){row_s=0;var _last$row=index_esm_slicedToArray(last.row,1);row_e=_last$row[0];}if(x<0){col_s=0;var _last$column=index_esm_slicedToArray(last.column,1);col_e=_last$column[0];}var flowdata=getFlowdata(ctx);if(flowdata==null)return;if(ctx.config.merge!=null){var HasMC=false;for(var r=last.row[0];r<=last.row[1];r+=1){for(var c=last.column[0];c<=last.column[1];c+=1){var _flowdata$r;var cell=(_flowdata$r=flowdata[r])===null||_flowdata$r===void 0?void 0:_flowdata$r[c];if(cell!=null&&cell.mc!=null){HasMC=true;break;}}}if(HasMC){return;}for(var _r=row_s;_r<=row_e;_r+=1){for(var _c=col_s;_c<=col_e;_c+=1){var _flowdata$_r;var _cell4=(_flowdata$_r=flowdata[_r])===null||_flowdata$_r===void 0?void 0:_flowdata$_r[_c];if(_cell4!=null&&_cell4.mc!=null){HasMC=true;break;}}}if(HasMC){return;}}last.row=[row_s,row_e];last.column=[col_s,col_e];ctx.luckysheet_select_save=normalizeSelection(ctx,[{row:[row_s,row_e],column:[col_s,col_e]}]);try{updateDropCell(ctx);}catch(err){console.error(err);}var selectedMoveEle=container.querySelector(".fortune-cell-selected-move");if(selectedMoveEle){selectedMoveEle.style.display="none";}}}var defaultStyle={fillStyle:"#000000",textBaseline:"middle",strokeStyle:"#dfdfdf",rowFillStyle:"#5e5e5e",textAlign:"center"};function isRealNum$1(val){return!Number.isNaN(Number(val));}var cfIconsImg;function getCfIconsImg(){if(cfIconsImg)return cfIconsImg;cfIconsImg=new Image();cfIconsImg.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZoAAAGACAYAAACUS6SeAAAACXBIWXMAAC4jAAAuIwF4pT92AAAKTWlDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVN3WJP3Fj7f92UPVkLY8LGXbIEAIiOsCMgQWaIQkgBhhBASQMWFiApWFBURnEhVxILVCkidiOKgKLhnQYqIWotVXDjuH9yntX167+3t+9f7vOec5/zOec8PgBESJpHmomoAOVKFPDrYH49PSMTJvYACFUjgBCAQ5svCZwXFAADwA3l4fnSwP/wBr28AAgBw1S4kEsfh/4O6UCZXACCRAOAiEucLAZBSAMguVMgUAMgYALBTs2QKAJQAAGx5fEIiAKoNAOz0ST4FANipk9wXANiiHKkIAI0BAJkoRyQCQLsAYFWBUiwCwMIAoKxAIi4EwK4BgFm2MkcCgL0FAHaOWJAPQGAAgJlCLMwAIDgCAEMeE80DIEwDoDDSv+CpX3CFuEgBAMDLlc2XS9IzFLiV0Bp38vDg4iHiwmyxQmEXKRBmCeQinJebIxNI5wNMzgwAABr50cH+OD+Q5+bk4eZm52zv9MWi/mvwbyI+IfHf/ryMAgQAEE7P79pf5eXWA3DHAbB1v2upWwDaVgBo3/ldM9sJoFoK0Hr5i3k4/EAenqFQyDwdHAoLC+0lYqG9MOOLPv8z4W/gi372/EAe/tt68ABxmkCZrcCjg/1xYW52rlKO58sEQjFu9+cj/seFf/2OKdHiNLFcLBWK8ViJuFAiTcd5uVKRRCHJleIS6X8y8R+W/QmTdw0ArIZPwE62B7XLbMB+7gECiw5Y0nYAQH7zLYwaC5EAEGc0Mnn3AACTv/mPQCsBAM2XpOMAALzoGFyolBdMxggAAESggSqwQQcMwRSswA6cwR28wBcCYQZEQAwkwDwQQgbkgBwKoRiWQRlUwDrYBLWwAxqgEZrhELTBMTgN5+ASXIHrcBcGYBiewhi8hgkEQcgIE2EhOogRYo7YIs4IF5mOBCJhSDSSgKQg6YgUUSLFyHKkAqlCapFdSCPyLXIUOY1cQPqQ28ggMor8irxHMZSBslED1AJ1QLmoHxqKxqBz0XQ0D12AlqJr0Rq0Hj2AtqKn0UvodXQAfYqOY4DRMQ5mjNlhXIyHRWCJWBomxxZj5Vg1Vo81Yx1YN3YVG8CeYe8IJAKLgBPsCF6EEMJsgpCQR1hMWEOoJewjtBK6CFcJg4Qxwicik6hPtCV6EvnEeGI6sZBYRqwm7iEeIZ4lXicOE1+TSCQOyZLkTgohJZAySQtJa0jbSC2kU6Q+0hBpnEwm65Btyd7kCLKArCCXkbeQD5BPkvvJw+S3FDrFiOJMCaIkUqSUEko1ZT/lBKWfMkKZoKpRzame1AiqiDqfWkltoHZQL1OHqRM0dZolzZsWQ8ukLaPV0JppZ2n3aC/pdLoJ3YMeRZfQl9Jr6Afp5+mD9HcMDYYNg8dIYigZaxl7GacYtxkvmUymBdOXmchUMNcyG5lnmA+Yb1VYKvYqfBWRyhKVOpVWlX6V56pUVXNVP9V5qgtUq1UPq15WfaZGVbNQ46kJ1Bar1akdVbupNq7OUndSj1DPUV+jvl/9gvpjDbKGhUaghkijVGO3xhmNIRbGMmXxWELWclYD6yxrmE1iW7L57Ex2Bfsbdi97TFNDc6pmrGaRZp3mcc0BDsax4PA52ZxKziHODc57LQMtPy2x1mqtZq1+rTfaetq+2mLtcu0W7eva73VwnUCdLJ31Om0693UJuja6UbqFutt1z+o+02PreekJ9cr1Dund0Uf1bfSj9Rfq79bv0R83MDQINpAZbDE4Y/DMkGPoa5hpuNHwhOGoEctoupHEaKPRSaMnuCbuh2fjNXgXPmasbxxirDTeZdxrPGFiaTLbpMSkxeS+Kc2Ua5pmutG003TMzMgs3KzYrMnsjjnVnGueYb7ZvNv8jYWlRZzFSos2i8eW2pZ8ywWWTZb3rJhWPlZ5VvVW16xJ1lzrLOtt1ldsUBtXmwybOpvLtqitm63Edptt3xTiFI8p0in1U27aMez87ArsmuwG7Tn2YfYl9m32zx3MHBId1jt0O3xydHXMdmxwvOuk4TTDqcSpw+lXZxtnoXOd8zUXpkuQyxKXdpcXU22niqdun3rLleUa7rrStdP1o5u7m9yt2W3U3cw9xX2r+00umxvJXcM970H08PdY4nHM452nm6fC85DnL152Xlle+70eT7OcJp7WMG3I28Rb4L3Le2A6Pj1l+s7pAz7GPgKfep+Hvqa+It89viN+1n6Zfgf8nvs7+sv9j/i/4XnyFvFOBWABwQHlAb2BGoGzA2sDHwSZBKUHNQWNBbsGLww+FUIMCQ1ZH3KTb8AX8hv5YzPcZyya0RXKCJ0VWhv6MMwmTB7WEY6GzwjfEH5vpvlM6cy2CIjgR2yIuB9pGZkX+X0UKSoyqi7qUbRTdHF09yzWrORZ+2e9jvGPqYy5O9tqtnJ2Z6xqbFJsY+ybuIC4qriBeIf4RfGXEnQTJAntieTE2MQ9ieNzAudsmjOc5JpUlnRjruXcorkX5unOy553PFk1WZB8OIWYEpeyP+WDIEJQLxhP5aduTR0T8oSbhU9FvqKNolGxt7hKPJLmnVaV9jjdO31D+miGT0Z1xjMJT1IreZEZkrkj801WRNberM/ZcdktOZSclJyjUg1plrQr1zC3KLdPZisrkw3keeZtyhuTh8r35CP5c/PbFWyFTNGjtFKuUA4WTC+oK3hbGFt4uEi9SFrUM99m/ur5IwuCFny9kLBQuLCz2Lh4WfHgIr9FuxYji1MXdy4xXVK6ZHhp8NJ9y2jLspb9UOJYUlXyannc8o5Sg9KlpUMrglc0lamUycturvRauWMVYZVkVe9ql9VbVn8qF5VfrHCsqK74sEa45uJXTl/VfPV5bdra3kq3yu3rSOuk626s91m/r0q9akHV0IbwDa0b8Y3lG19tSt50oXpq9Y7NtM3KzQM1YTXtW8y2rNvyoTaj9nqdf13LVv2tq7e+2Sba1r/dd3vzDoMdFTve75TsvLUreFdrvUV99W7S7oLdjxpiG7q/5n7duEd3T8Wej3ulewf2Re/ranRvbNyvv7+yCW1SNo0eSDpw5ZuAb9qb7Zp3tXBaKg7CQeXBJ9+mfHvjUOihzsPcw83fmX+39QjrSHkr0jq/dawto22gPaG97+iMo50dXh1Hvrf/fu8x42N1xzWPV56gnSg98fnkgpPjp2Snnp1OPz3Umdx590z8mWtdUV29Z0PPnj8XdO5Mt1/3yfPe549d8Lxw9CL3Ytslt0utPa49R35w/eFIr1tv62X3y+1XPK509E3rO9Hv03/6asDVc9f41y5dn3m978bsG7duJt0cuCW69fh29u0XdwruTNxdeo94r/y+2v3qB/oP6n+0/rFlwG3g+GDAYM/DWQ/vDgmHnv6U/9OH4dJHzEfVI0YjjY+dHx8bDRq98mTOk+GnsqcTz8p+Vv9563Or59/94vtLz1j82PAL+YvPv655qfNy76uprzrHI8cfvM55PfGm/K3O233vuO+638e9H5ko/ED+UPPR+mPHp9BP9z7nfP78L/eE8/sl0p8zAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAHBbSURBVHja7J13mFxV+cc/M7OzLbvpjZBKQhISUgAhgAlVkADSRcDyky4iYAAhAmpQQtMIiqigYkV6FRHphgBBKSGBkB5IIb1sdrO72dmZ+f3xniGTzZR755a5s/t+nmefTGbuPec7Z8497ynveU9on5m3YJMuwNnAt4B9gA3A48CPgY0UyPxJUzN/MLMShxwDXAMcAmwGbgD+UlBKhzVn/+yqqwrVFwIuBL7tZnkyYwaK98yaNb/QW6uBk4DLgfHAduDfwI+ApYUmOnHiKC+0AowAfgh8EYgAvwF+AMTd1OlQ40nAtcB+QIMpzx8Cy70oT8U6YZvXn2x+tN8A44ByYE/gMmA18B9g7wB9v58AzwNfADoBA4A/m4c5KPwWuCdDef4X6KVVtF1yGPAx8IDpAFUBPYGvAguBucCRAdJ7CvAecA7QA+gKfB94DKgMiMargaeAQ0159gK+BrwNqLUoIUNzFPAw0C3L5+XmAXoZ6B+A7/ZNM3rJxDTgl2Y0UUwmAxdl+WwI8HOtou2OzwFP5+hERIAxwDPAhADoHQvcbxrvTB3PZ4HaImscDmSbmukO/F6rXWkYmgnAP4wxyUd/U/m6FPF7lQO35bnmMuCvQLSIOs/J8/npQIVW03bDPjaejWrgn8boFJPpRks2jgReKfLo+yygLMfnhwCDtPoF29CMMUam2ka6Y8wDVV2k73Uw0NvCdV9F1kOqiqQzX+WvQqfP2gsDkWlcO79nD/McFWuGoAJZk8nHAcBM8x2LwRAL1+ytVTC4hmawqeiFNHaHInPQkSJ8rxob156ILBp2LYLOkAu/kRJ8egEvFWgw+iPT0cXocJTnGSmkMxJ4zfxbDJ1WjKYSQEPTC3jBYW/qJODX+L8WMhuos3H9JDP876NVQnGZLsbIDHOQxt5mVqGTz9rrgTdtjtpmmhGOouQ1NF2MkRnmQh4XATf7/L02GyO3zcY944FZZhSnKG5QDfwLd9ZZJiBOBOU+f4evAAtsjt5eIVhec0oADU21qdDjXMxnKnCJz99tJuIpt97GPcOA14HRWjUUh5QDTyAL0W5xFPAn/J2OXoV4k75j455aZMr9ZK0GSiZDE0XWVQ7zIK+7kI2efvKO+S6f2LinnzFSB2v1UAokAvwNONaDtM82z5KfbDBG7lUb91Qi+2z+T6uDkm5oQsAfkSknrx6+P5kK6ycLkTWYj2zc0x14EYkqoCh2CCGbcL/sYR6XIDve/WQbsu/rKZvP/B+BKVotOjbpHiW/RNx9vZ5OeByZv32vwDQmG51DsOdJYne/TCdk09xXgUcdfN9DkE2urwGbXCjDLsDvEG+5rcCTSASENVqdA8HtwAU+5HOjGWn8psD7RxmDNRZ7TgZ2p+1CyMbjzkZzoR3izyGOSf8DVrrUFv0S2cvWgqyl3Qgs0SrsnaH5IfAdn/LsgrgTH2rzR031FC/ysXzKzSjsBex5sQGci2wa7ZXWIzzZ5vRDW6oR76NJ5v9VprE4wxie/2qVLirXIaFQ/OIu03l52OZ93wTuxd/NytOQdZv/2bzvGMRzNeWY1Aqch2y2djLqvK9Nx/prSKidc8wzprhI2PxoN/qcby/Tg7CzN+BbPhuZ9JHNWTbvmW4qcvr362xGH/sXqCOCrJ9NylKezwB9tUoXjfPM7+4nEdPg2pmOHoXE1itGRIyLbV7/VdNODGvTOXY6xf8rMs/e1AAPoc5Anhia64uU9zDsxSD6VhHL6ds2e2DX5RjNPYd9t/GQeThOymO8r9cqXTSKVfblyNRuZ4vXX4D/LtLpowarcdGGmPYhksXAPkhh671T8zzPVfi/HaNDGJo9LF77EWAlhvetNvK342s/oojlZGe387UWRnN2A4/ebNHQnqpVumhYfY5WIfu18vFzZO3ACt2QfWBW2KeIZVSB9ZhjV5A7MnQVst5rZ3PoNy0akckUL3xWuzU0b1h8OI5FNkLm4zc2jI2dDZUbi1hOG2xce6iFawYg61TdLVx7iemFWaGzVumi8YbFenQcsMLCtS8jrsxWz3tpKIHnCGCLxeusRK7ugkytWYl1dpIZIVmJUhLFXhgrxYKhud3Cw3GUMTZWuQ5ZuM/HEzbSfLqI5fSkjWuten+Nwto5GVNt5P2KVumike8EwTrEYeNDG2k+jkQZz8cyrHtxPlHEMnoLObfKTYPUC2ubYi/Cusfc+9jb6K1YMDTP5xhO1plh5GKb6SYRL7an8/Ss7Cye/gg5LMpvmhCPGatML9JvuQR/3GqVzLyU47dvBE6jMK/A35B9zS/1rH3X/GvV0DxVpDK6zsa1P8H61KHbsxdnaHV239CALGSex65TRNsQd793Ckw7bob+r2X5MU8E1tqsABOQHdfNPpbRbJvTDffZNExuPRyTsTfFp7jPDchO+LVtjMyZyFSYk9HS3VmesSuw546bRDaT3oi/02hbsrQF2XgT2SIQ91FjI/AldC+N66Rv2PwjcpLeoUjI/FkuVMTUD/d7Y1i24GyD4Xrg66bn3gfrIcwxUxDftZnfJxTmUn2jGdJf6sNvmBp16sMRDP6CuKEfjBzP/KbNDlWu+rsNcQqJIGGSbkKmo+wSM52hn5jnyM5xzIcj0+J2PNe2m05nzKbOvyPrML/24XdrQQKIvqVV2FtDkyrsVz1oCN0Ox7EDawuqIIt/PynAyHyALNyudtAwdMXbaAstZkrmHa3KgSJms/dudSRyHfamn6zMOnxq4/pTTaNvx8hsAk5w0ID/BnGaucnD3yuJzOg8o1XXG9r7oVoRJFyL3T0Os5BgnKtdqLxeOTHETfovazVWfOAi4BGbo5+V5jlyOkqYDvzCw+92HTKbo6ihsU3Kz/58m/c9jbhyb3FBQwvZ16mccpk+HIpP/BCJJmAnztl84PNY23tnhSke1fefYW/vn6KG5jO6IN50dsNU/AGZimpyUUtqnWqei2neSuHBFBXFKiHECcFuiKo3kVBJK13UkkQ2XLo5Q3A/cI3+zGpoCuVeYGIBw/ML8cbLpQ44GncW7H+Hu/P0ipKNb2Mv/BLIOscXsLa52y6tZobgPy6k9SIy9ZzUn1kNTaF80ca1CeByxDXVy0q3AZmSW+UgjaeRSAH6cCh+MNnm9X9CHAYaPdTUiERBn+sgjbdMGi36EwfT0Fhp4BIB+F5Wp75akLDgfp1YuBw4nsLOpXkDeyFJFMUp221ce5sZIbT6oKvOjJoKmSFYgkxlN+rPG1xDk8+luIlgbBq0Emaj3jT6D/msbR7i7tlo857j9eFoN6x04VnzAysRBJLIQv1Un0fahcwQrEK2LOjG5oAbmnxeH48he1yKzfQ8lWkdEjn6pSLpewtxVGix+HAcj/2D15Tg8mCekf/7uOs84kTnm3lmBL4G3FkkfXZmCOrMtUu1+vlPmc3r/4UsRl+Y5Ue/MiDfa7UZNfyT3Q9XW4as4RR7J/1LyE7k+5Aw722JmYf8Apyt6yjBYw4Su+8nGT7bioSxCQIJJAzVv9j9wL4G4HTEu7OYzEPWkv6BRDloS9xcc4mbxnvWrPmB+IEmThxVEhW+EGeAi82PNtf0aFYju4UPCtiQ9H/AOGT9ZRUyrfcY4tsflHAtTyIhzi/NUJ79kHAfi1HaIzchMdBmI7H7NpsRxEFmRBMU1iMenFORM6l2GM2HB8DIpD/rQ0x5vmnKcxMyA7M3sJ/RrJTIiAZkHva3WDsGoNisQTzKLg+wxjpjWH6t1bFDUY1sgEyav4TpfScCqLUJWey/LcDl2YRELnikBH77k5EDEsebkeG/KF50en8MzfxJU/WRd4MZM7QMFKschhy/nD6tW4XExTsL2U1/BR3wfKHUVFCxp6Y8nJK6po3BrgK+gawfTQIW6IimKI9kM4rSjvgcsh+qS5bPI8AYZOPjUbgYTXjixFFWGvAIsmbY3fzb9nWuz3Yga7h3k8VrzmEDPhwYbUYBb2L9VNFUg/4dY8hHmbZvCTKd/jNkbcxrRpL97K+eSJifw9XQKIrihH2AZ3MYmXSqEWeWI/HOA60PEl7mc0APYzScHAdebXrs1yBrjlchO/Cd0h/4K3BE2nv1yHTTneR3q+6OBJ8dl6Hhv96MJCfhvdPN2eSOF3cYMJBguLa7a2hGvVb8eHLtYvruqquCo0Wn8YLIQGTxvJeNe3oYw3SIB41gZyRK+TCPvu9Y4DkkUsA/HKTTAwlKO7jN+7XAz5HF/kvzGJvpGYxMOoMR54xvelwHBlu4ZkB7NDRhff4VxXN6Ie7s/Qvszb9s00BZ4bseGpkUEeTQw04O0rg+TwN9CRIMN9dIYYKFfD7nR8fewjWh9vgAhB1WgM3m73qUFF8CPkRCcSR9+ms1eZ6kxR84uhgj46RR39uMCjq5qOsMn75/byQieqGcbuGac5GTTbMZGysLvT20qgbP0HzJDDVTi4A3aSP3GX9GFhsjPuYZMXn+RYs/UFQjrqtjXEhrAuJEUO6StmE+lsP3HdxrdRR4DvBwlvKxEkm6m1bXYBma/mTe8zHDg+F9KfJQB81b2ZVyJObeIS6meRQSIdmNToyf+3VGOrjXztrUaYgXWUUBhqYC8UxTAmBouiCLk/2z9JAecrHHVapcgr1z2N3ieiRqg1J8IsDfkKCPbnM27kQb93OjipN1h6dsXn8iMs1Ynfae1dNydVTjEWU2H57780wDHImc7X2JawpnVgantKzv6TkTWcD1y+g+CNyi1TkQhJCoGV/2uDOzFvixgzQeBg70qUycbIb7MbKTfqCNe44xHeITkb02dgzNp1qFizuiuQsJVJmPb2H/VL72xuv4d3rf28D56GFoQeF2JBCq19zosEP3K5wdHmYHJxHdNxrDYfdY6FQsti42DI1Th4Awspb2JSRWoRuUIxs5601Z/AUY2l4NzVSblfpOZD7ZbWqR8A2fIHPMXnlxJUwet5k8C+F+vD9y+VO8P9FQsc51wNU+5neXGT0XOso4GtnJPx8JTPk8Mv39G2QH+/eQTZfFrl+LjOH42OZ9hyAef1an7pxMnU0GFiLBO59Gotmf5fB7p6ZgLwJqjCH8OhL9e3IpPRhWps5OQjY82SFqKuwhuBcpuRqYiQSi82P6YyCyw/lYJOJzIQ/brchu8G94NB1xGnqEQFA4r4DnxCkRZMf8RmSqtpDRwkU5Pu9sjE91AMp3ObJz/kUkFI1VDjDPoJeG5qtmpBFuMxL5i2k3nnbQkcg0BVuDxMo7gBKJjZZvRDMBeIDCvNN6Il43XVzSer1PRqYt43G2T+jCAhsBK+m+hRIUirWXrNw0Op1dTrcaibc2IUBlvBIJQ/NRAd/FK0OzN7JhNJylw/2AMZB2yTeLVF2Ejo0nhmYvdvfesMu+Zujnhjvm2UUsJyd5t5iRh5vxqm435aoEhz0sXrcKCf2Sj59j7QTWVAPpZiesCvH2mhTAcl6DTKPN8SDtQgzNVezuTt3WIDyNhOSxyiVkD76ZzomzZs0vD8ohbIUYmi7IoVxu7Is50WKh5WPPIpaT07zrkLUUNw6Gewbv134U+7xh4ZoNyJn1VmJZvWw6OHGL+Te49D1SI6QvBLisNyDrS28HwNAcYOGaLsiU3xAL156ETJmFLP5WnUrh4QhnEf847uxmTnENcra4E1YXsZzcyHsp4o3iZGH1Q1OOcZSgkc+9vM50uj60kebjwGUWrlsGvOfCdyhDXOWPd7ls6jwo783GGL7uYprdC7hnq8XremFt8+73sD4D9DbWPeoCZ2juxRuPsd/hbL73gSKWk1t5v2V6qYW4Im9Czm+vQwkiL5F9zrwRmT79bwHp/ibPCDaJBMh06t6e8nA6tYTKvM6MEP9TREPzQ6xPcbo9qju7VH6otoZmKvB/HuVVaXpo/Qu8fzrezMvmYw7uLro9jf2pr1bEjXUJSpC5wTw/a9sYmdQGXiejpbszvB9HTuL8h0PdISTK8lds3vc84tJbTBrMCOzfLqRVyNTZm/i3Zy69Tn2plNqDdEPzVdxZS8lFP2Nsqgss3MOQmGp+nNewAlmQPQz39xHcanqqVvku3niuKe7zF8Q1/jAzihmKHGDmlMuMwdkCbEPW6j6P83A0IVMXv2nzvv+Y0Y9fvfnO5rvOR6ahlwLvINNHM3FnDbdQ9+b7kdM7/aDFzGyUlMdpah/NocB9+HMWwoGIO+A5BfQC6pENcVdT+lyGnLORb+PVPVl6s0pwiSGHdblJ0oyE3XYE+Tn2Y+S9ifP1Rrsd4ieREFde4mTD5q+RdZhpHupLmtHTC6X2QKQMzSP4GwzzLMTdN/8I6rBm2ilxZI71NbI7XrwCXK7ttuIRl5vRsh3eMZ2jeh91nuaDkXFqaEDCAvVCTvz0gmvN6KnkCJthc78i5D0dCT7YkalD5pcz7e5fisyZt6Ao7lNlGkY7zAO+yK4OKVY2czvtLZ7uU5m40au9zCNjcCvw01KtbGG8jTJrZWTT0VlF5iCkV+LOvhtFycQEoKuN6z9C9q5savO+lViAOxxqHe5TmfzZhTRS01vPuKjLj7iJnhua85EFNj/3ZsRNnv+nzzsgXkM3ID75683rp7VYFA+xEyx2CRJBeUOBowCnbUvYpzL5lUvptJjZCDf2+PwT/73aXKcMCTXxlD53RWc6JRS7SCl5rG4c/QTZV5dt0/LLFkYcTj2kluB9nMMluOuq3Ygcq5JrDRYL5XYm7WD6vEyfN5eYMUPLQCklliFhUXKFmlllPs91FsxU05B+PsvnryOL2E54AjjDw7JIIjvy3R411CHR319DTiC2a/j89Ozz1tDMnzRVHzlF8Rcrh3j5sVfsXNMIDs6i8RjybwqsQ/YMnYl4h40w7y9FTvF8GDnfyQkPIftUDvGgDLYi3ndPelTGaxEvvVexvtdnFeJl127WaHVEoyj+86DpQWdbe3gfd6N952rQPocccfBlJGrHKmRT9XRkvdAKCfOdHvRIZxyZhrrNGLVo2mchcjs1VJM5uvJyxJPrYazHKyuUJcbYvEb+Y1NyeaKWrqEZ9dqtgRCiIyufuOqqYOnpmFOOc4AfAT/J0sP200lmE+LheGVQCidL2Pst5D6kzRMNEyeOcivJecg02jNkjorfYurFFW52MoJyhEDpjGhmVhY3//a7cVQpDjchi89XIgvdjUjssB8Ci7V42iX/RaYpT0M2dY4HtgP/An6A/aOqS2dEU8A9XZAd7d9CjkjdYIbaP0aOhu3YtF+DGEJO9fy2/u6uUI1ETE6avwQyRZTQonHEPsZYH2PK91dIWJigHK3RiETJLoWDC7+JbEAdbUa+T5myXG83IbuG5mTgj+waqmFPI+ZiYDZwgY89sj2Rk0ArkXnaKvOXel1ptKa/rmxzTRVyBvd7wJ3I/pXt+rzuxm/bTF2kfvcTkc1/urnUOocjYZ/Sp1CqkMC2ZyF7zK5AQhAp1jkN2dyY3tu7ARiFxFbc4VZGqSm1Yk9NuTi115Y7TR1M0Q85+fN4YCI215DsGJqjkIWzbDHRypGFupcR7xAvF7MipuE7H/cCgR4E/N00mBfizt6iEOLZc4Xpae1AFgSnYf9skqh5YHoCnwKLfOylTSb7/PgQJDDj17Wds8SBpm51yVG3xyBz+UfhfZTersjR4HYX2TtlaQuWIlGmH0GiTPvFOPP8VmQxQM8iUY/9iNE2wjyrDUgAUjunn1aZ9uJMk0YYcSZ4xDxnfpxHdVgbI5POIKPjTDsJWt1xOwHZvW4l8GZ/86N28bAgrjYjJy+iTfcCHjOF7dTI3IdEqh5rHuIa02i/bvRboQb4mTGAc5C9D/ONsbkO66fxOeGcPJ+fTu5z05Wd0zr/tPhsVJtrx3ioJ2Ke1QtN47hX2t8QMwOQ7S9bWzAUOdtmKd7ufWnLLXnq4FHI4XQ9PNTQ34xCFyDTys+b5/S7Fu/vaTqgtwD7me8TZed04DvAHj6UZb4D1U7B5hHSVgzNGGNk7JwhM8ZU4GqPHg6vPWQipnF32jh/M8dI8l5knSsX5UhI8KsyNE69ERfUe32oeIMs9MJ6qR3JW4bP2yynHuY56u+Rpq/gzd6UVKP5EOJp5TVVFvM50MwoeFGePUzaR7R5vxa4A1krytcxvhnYN8fnQ43B8ZoBFmZXbJVhPkMz2FT0QhqRQ5EjkN3uce9jGlk/pjic9B7yGZEQcoZFrgOTTgUOzpPOuRYqhlNCLtSljkxvMxItpIHrj0xHe2HIvT62OYwcVOg1lTbamX2AWbgfqPN6Mm98TXEpcrZUrufkIAv5HBSQOl1utyJko5fpTTux/ieZxtTNKa4ePhbmjx0aRCsN+C/JfubMEItpDEIJKl2MkRnmII29zaxCJ5e1DfXh++9rsR47YQty0qad0eVMZHrKLawcZXAhEiE6m1GMWUijWyk+BOEcD8cLDh+OFBfh7hHRW30sHyfHGFhdAAwBvyDzdGCTxTRqUYJINbJHwo11lgmIR6SbBxT6FRH4Uh/yOANxkLFKHyQszOEu5W+1Q/41xGkhmsVg5qN7ezE01aZCj3Mxn6mIa5wbzMe/0/2cjMRetHn9DHY/otpqQL1qlKBRjgSDdHMN5CjgT7g3Hb3Ip7I414c8PkEceN61cU9n0xH4kgv52/GyPZPMpxpbMTRd8McByFNDE0XWVQ7zIK+7yO/NYIUY8DufysdJ5NRbsO+K+FNjlFNY3c+jhiZYRJD9HF4shJ9tniU3eMyn8vBrF/M6JBjlf2zcU4V4iH3NYd52t0OcbO6psmlooASnz8Jteu9/RNZVvHr4/mR6ZU6ZhvinB9nQLEWm3pps3ncLO0/Ts7oPoUbb9sAQQhZ9vXTtvQR3vI8eR6aPvGaLj+W/DdlC8A8b95QBfyH7WqkVfoz9vYPHsatH76b2amjSN2z+EtmZ7PV0wuOm1/Geg3TqETfCVMTZHcYo1JmGvRHx5jrZhUrrhOcQn/MnbI46ppvfZpbF62td+F0OMRX4NRsVPt8Q/3dI5ICtSBj2nwBr2rmhuR3ZSOw1NyJ7q37jII2EeUamI8c0p/ah1LEzFE4lEoLECZsd3LsvEnVkLPacIexGPUmtldZQ2JryRuTsHrvehUcD/0aiU/s1ooki3qw9gTfMSNApnZGtFieZ+vOPdOOb+jF+SG43WzfpYgr2UPKfdZGLFjM9kYkfuWBkwJ1QNM+bwn/aprG5EXEtt4KTqbNzkfDrvdKM68kOe7rVpqJNSpueuMT08k/EflSEUuE6dl9n85K7TKfgYYedqcty/I5PFtHQnGdGh34G//0JslH2/QLuXcjO6CiDbdw30bQTj/hgaL6C7Ozvl9bGnWmjrcnWUX2CnbNVVYiH3anGgP43bH7MG31+IHshi3Be7A24HplacwO3Trd7yRS43fSO99jQTEeiF/Rq0zN5Eti/wDQjyDrfpCy/+zNA33ZoZM7D/6O4I8BfcWc6ui01pvE5xoW0Cpk6G10EIwOynODEcWk54slmtxM9AevbKQo1NNcgZwb1S3uvkzFwBzuog/dnqYM9U8972DTMxWAYEqrCTaYi4dfdws1jVF9F5o4bPGoU7HIMO9eCMo06n8O+e3sI2QF9Up5ORrHqnJcU6zuVA4+aDoKbsw7P457rbyGG5iKKd4zJN3G2Z2mFKbuPCpgJsEIhLs4HI+u/2fJ9jsLc8O8i93pkL+AHYazvfv8IcS3Oh52T1I50sXJcnaMgnUwruMlMY2zcds8uZI0m3znuvcwUgJ355pvJHxEBvN+RXgysPkersLb29nNkethqD3e8S9+juxmBu+mWXYih2aeIv2UFzjdBf4qsI8/1QF8hI5qryb1Bv5DOpdVtKyeHkcUgKw/HsViba/2NDWPjVkM+BXENdhsvjguYZYyNm1FYC5k6O9TCNQOQ9TQrPahL2NU1OxedaX9YeY42IJ5GKyxc+zLiymw1QrcbI+XeJt8DXC6bQgzNpiL/nm7kvx6ZUnrXZW3dPHre+yFLGr0tPu9WO/a9w4iXTL6H4yjsue5dh4Txz8cTLhT6Fab3ZwerD2+jR5X4ddPguGVsCjE0Vr2/Rpk/K70bq7THc1byPXR1iCPEhzbSfJzsC/XpLMOZF2dqRPYq7m7UdmJonijib/km7nhipQzWUbi7HaMQQ7PW4nXDkDiPVgyNVf4RRuZib87xcEzG/kFmScSL7ekc12zE+eLpZUhkVDvUYX0+vdHDyjzbjBK3upBWIWs004v0EC/B+hEJpcRLOcq0ETkTpRBvu9+QfS0t9ax9F2fhZAYaI2N3usrq81HI6OARZCG5GHzf5fTqgC8iWweKZWhuxr+QQ+ksBS5Pzdldj3jNpJ+SuA3ZA/JOgRnEzdD/tSyjpBNtWNlsFvUX2AsTU4csgltdpHM6tRdBDgSbgUwnXofENLsI2czZz7zvtAIUskZzH+5551llg+m4tNfTOG8A/q9NvW5E3EdfdjhaujvLM3YF9jYntmUIspPebjTj/2F902ghI5qkMc434e802mbTCXSbejOL8aILaRViaB5Fjhvx+3k/Dlid7tXxR8RN7VDkZL1ZOD8LvhGJI/R7Y1i24M7GvQvMg2fXyBxnHpBzLN7jZI0mjIT4ONmHH7RQ9+YbkUV/P4IepkbHS2jf/AVx705tiHvTYYcqffS+DXG2iCCOJTfh7ATO4abhs3vMxCzzPFsdmRY6ao8BPzAdoj7YC2VzpBkNRm3csx3nRz53ZvcNsFvTOpNuhOMp1L35DvO8f9+H5yDV9i+B3d0HW3A/JEUdsoPfLQ4yFciOkalH9qTMtjkCcDJ19nWfjIwTQ5NqwLribVSIFtM7fYeOQczFaZL0Hv515J5Gs0NPJEK7XSPzimlAttto8JyGoIkjXlxWOcN0RO0YmU3IXjcnhjuMxC87wuP65eSolOvM836Jx8/7yellWYqHVV2PPf/6BmNk3iigYXZiaM7zsUycxDpLGq1Pe6QtbtJ/GSVI/ABZm7HDv81IJjXSt7qfw89YZ99GNiXaOVr8E2R3/lsO8z7NByPjZEST3rl80CNtqfbkxbYWuNSws/em0fRSZhU4AnCyRrOfj2VS5UIP5GwPeuGpSn2/tuuB4xSb1z+NbMRN73wFzdDcaEYydsLofwB8HljgQv6n+/Q9dzi8P46sJb7ggbZrMz3vpWhorM5xNpqRzEwHIwAnazRVPpbJHBfSSM2pznNR1604C/qoeEc/G9c+ikx/txTQs64HWj3+LqmI2XYjWs9CYpOtdknHCJ9+u/tcSKPFdDbecvl5z7ifsRQNjZWGsNH0vv7j0Ag4MTQrfSwTt85lr0MWMd1YsP8d7q0nKO5jdc3jfsRDMlOUAiuGxg+PscsRT067I7RjXR5thXz67e52KZ1UZ9yNzuX9uZ73UjQ0v87zeZOx1C/luMbK5rbN2Ntc15YXfSqPjTiLvNqWDeYBXOUgjaeRxcYkSlCxcujZH5AplmwbnK0cK+3HtJndEzL/gKynNLmsww+Pyg+Aj11Mb7MxNssdpPFPZF0m6ZahsdJwJHwYNv4xxzD9FPLPPf6N3HsPms0D5sQZ4Kd4u+ET0wCcj/uBOpebyldIb/QN7IVOUYrD9DwN1m+QUO+5fkcr0y7/8+G71Nn83hd6VD+9jmaQwJu9MKkQY4Xsb3sL2SeWMy6fXUOTL0ZTE95vxkuaxvUbSCiXTUbXn5AF+OctNtCnGGPyH2Og4ubBuxeJYup0V/Ji0+Bu9qgc3jaVwytvsXnYP9pgnjFQjSi5WOnCs+aUTchRDq9m6KxdieytytexvN70sLOxDH+OILHSwCeQKbYbPBxpP4Q3mz1TMxdnWmzfCh2NfcGm0V5iRpN5n3e7YbjvJ/d+i8dw7hFh1dj81fw56R38xfx5xdPIPoXhyL6FSmR9qFva667m39TrSsQrLv11F/N5Ajnk6gfY21dQKG8ha13PWpgmWWWMTB1KPh4Evpejo/c+7jpl5PrNjjT1c7QZGb9pY4S8EdnXdoVpBEchHl9LTFvwM9wJsZSPBxC35mwRp1tMx/QhH2YYjkcOEjyMXffxhMwznY1OWZ6xpUhkiEdwP5p8W+aa5/1f5PfMTdUdSwMLu4bmX8gi74VZpluu7LBNx8ysznCNuOMVZl3HYc1upvgScirffWRe/I2ZxukCnK3r7MpVVwXr950xw83U5iCnwP4kw2dbzUjbTxaZv0JoQryNbi3irxNHNmlmOlOlHjmW4iWftGzBvmNCoFoyxMPw76aDm+l5fxuZVbL8vBdysNDFSNjrS4CRxqI9ZR6cjZ59fXcbT8UeTyI7wr9qfn//fvf2y03I0b9XImfJNJppkR9iP4itIiP8CWZ09Q1gr7R26n0tHls8i5xDdZYZKY5GplqfMbMptiNbF2JoUmeJJNv0KIo1YvAH7w3dMchRq4cg6zo34O20nl3qEI+/Xwf8IQmZEfe3kWjEG5Bw+z8OoEF8BOvnxLvCxImjaMf4Prpqx+XZgMSodOUUZLuG5mTE4yt9CmVPZPf3xchC2AXaI7PNT4xhSdEJ+DMSWdfdxdTUFFD7Ndy/bTN1kaqfJ5oer6vOKu284VZKnKDUTzuG5ihkITrbonA5sgD2sumVr/JB/56mMU5fVK80hjD9db5F+Bpkb82diNtzg4+/wTfbGJl0piEB9K7A2z0pIeBck88+iEPHayZ/u2eoRJFF4Z5mOmMR/rk6Tyb7/PgQ5IC8r2vzo42jEkxDM8E0wFY2aPVH5vgm4Z0HUgj4pZkecWvT6UHIAthGMyp7yofyL0c8VHJxGRJT6lxkIc6LsrzPGLx0YzEZmc67xOLwucYYpgvYdRFxPXJu0G0+GJx8xz+cbvTt0EdfUfzDSiM9xhgZO6HoxxhjU+2R7suREzy9iGzQE3HNPMyH8j8Ya+dzfxVZZ/Aifto5bYxM247IvcgZKPkM5gvIZrK2niq9kU1y9/pQnoPyfF6FnMehKEqADM1gYzAKeTgPRfzbIy5rDgFXe1wuEWQPgNfYCe9/IhKmvavLGr5lobx/bQx7Nk41RjMX52L/7JNC6oYbnStFUXwyNL1ML7W/g/RPMo2Um8HmhjrUZJUDgT08zmM29qYXJyFuxn1c1GDlnPjUVOXlWT4fYjGNQfrIKYoamhRdjJEZ5kIeFwE3u6i5t4/l82OP099sjLGdHb/jkfDmg13SYNXxIYSstWTalGs1OGGtPnKKooYGZF3laWCci/lMxb2jQ/3cC3GWD3nMRDz61tu4ZxgS5220C/nbjTI9g92nLq3GNqvWR05R1NBEkXUVLxbC70KCTDplCf6ccZHqxfvBO6bMP7FxTz9jpA52mPct2PcO/KnpPKSwem6PGhpF6eCGJoRsxjzJo7wiSITloxymk0A25fmBn1GIFyJrMB/ZuKe7GZEc4yDfpWbkZvdsjlvYedCR1am/Gn3kFKXjkb6P5pfkjszsBuWIm+6RWDt8LBs3mxHApAAbmsmmPIcAFTbui9rMpxMSg+iryJG7hfAccmzCEzZHHdNNHZpl8fpaF+rPIcjG29dcGtl2QQLFnogEtHwSidSwRpsHRXHX0PyQ3O6rbtIFcdM9lMJPpGtEjhz+MuIyu8O8V4ccWrYdWRM6zaHWQsJyh9g9DIrXlJvR4gsUvkn2eTOafdqmsbkR6yd8Opk6OxfZ9Nkr7bc5md3PU7FDNbJHLNVhqTL15gxjeP6rTYSiuGNozsOfw4nS6YUcOXAohceeiiE7+TPxfReMDFhfe0jnWxQnTHgnZArsHgdpvIQcdvZPm0bheI8NzXR2P4+8sxl9HIVE6bVLBFmPnJSlfj4DjAXWajOhKM4II6fkFYNhuBQZtA3fwz136kKmzr5VxN/z2y6k8Soy7edFvLdC1miOyWBk0kfHz2HfDT8E/Irc65G9ivhsKEq7MzRWNyV+BMy3cJ2dEN1Huvx9pgC3u5heIYZmRBF/z5EupTPTGJt6l/UVskYz1cLo+GXsbeK92WKH4FRtIhTFHUPzhoXrViHn02+2cO1vbBgbN48mvQKJzusmhegr5pknbobAn2WMjZuBUQuZOjvEwjUDkHW/7hauvcSC8UrRWZsIRXHH0OQbAWxA5sHthP2/DmsuyE+49D2+A9zhQfkUskbzdBF/zyddTu914DgXjU0hhsaq99co8+d0hJTOK9pEKIo7huZ5sq9p1Jlerd2DzJKm8X86T89/ugvf4RLENTtkU58VCpk6+xHwcRF+yyYkTL/bzDaj2a0upFXIGs30Ij0bS5AjBRRFcUjKvfl682C1dR89Bdm1XghxJBLAc+zu2bMB+BLOPXouBO62aWTqTONlZS2nEEOzATm/ZwbiJuvXUZazKXzaLoIcFzAe8ebbhriJN6S9vhXZpOkkWkIhazT3IVNj03x8LjaYDtYGbSIUxT1DAxIV4H7E5bgrMkfvdL2h0RiU3yP7Erbg3oa48xBXXrtGZjLW5vJTxrYQ1iMnOV6ARFq2c5LpZcB3beb3CYW7VIeR83dO9qG+FerefKPpAF3qg8ZUHVmizYOiuG9oAFpwtgEu24P7ZZfT/Bqym9uOkalH9nu8ifWYa9sd6twBrLB4bcgYYLtG5gNkHWV1gRq/7pORcWJoUga4K95Gr2hB9l+9o02DonhnaEqB/YE/YO8Aq+3GyLxhs8HzK9ZZxIzOzrd53yxkL8gWhyNDv3AS6yxptNbiTTy+uEn/ZW0WFMVdSvG0weuQkCtWaTRGZlYBPWs/DE0VEv/NrpF5Glmk3+Iw//18/O2cHkXdYkajr3mg7TJk6lhRFDU0tgJpNiJrQzPbvN/J4v3bPP4uXdgZY8wOf0CmeJpc0FDl4283x4U0Uut+81zUdSuy/0tRFDU0toxEI+I1l2kvhNWNeNs9/i73AhNt3jMd8baLu6RhpY+/3QyX0qlDgqq6sWD/O7KHuFEUpYMamrkWrmk2Pf4XsnxudW3Ka0PzRRvXJoDLgRuwvg/ICi/69LttxHqUZytsQKYOVzlI42lkH1ZSmwJFCY6hsfJAJjzWfFeez1uQGFX/znGNlbNwNgMfevxdrE59tSD7XO7yQMNP8X4tKo6sQbkdqHM5sv5WyLk0byDrPXFtBhQlWIYmn6tuE95vcnsAme7IRIMxMs/lSeNhcoe/aQb+z4cG2EoInpRb9kMeaVhsGtzNHqX/thl5eBWaZx5ytEGjzXuOx98TVBWlw2LXvfl+cu9jeAzZO+I1FyFuqJcAo02D8Qqyc32BxR72Gch+nHMRl+lOyHrF86aX78eGvelGR68sn68zjajX+zqeRnbfDwd6ItEMqpCTLFOvu5p/U68rEe+99NddzOcJY8x/AHzqQzm+hThUPEt+j8RVxsjU6eOvKME0NP8yo4kLs0xjXOm6wplZI7g8aP4KJQH8xfxZ03FYc/bPnypo0/pqTr47ddBYW2OzDPgiT11q3+AdVlB5NOKOV1ixeAn4ChKypluGz2PIZt0LcLauo3jMxRdfHBgt99xzj/4gRTA0ABcjJxpegpx/sgF4CgkmuVGL1CZPXfo/Tr57HHIq6KlAD9Mz/w5PXaqnO9rjSTOy/aqpp57Xz1JpFLXxVkrF0NQg0zhHIsEX+yLOAT2R6Z8DTI/4FdNDbyjSd2qrcwgypQMyXbI8cDqfurStzkmm0fROZ67RWWlTB/za/BWDPZCp3QPwbo9SEzKdei+FxwwsFZ19kaC/JyKH25UhzjG5PEIbzAg2E0l2j0QeQyKuP4Ksm6oXYhEMzTDgWmTBONselt7mb4LpSW5HFu1vw8Jax/xJU934Lp7rdIlS0VlcZswoRdWnIFOxtT7k9SXgKiRW3VPtVOcYxP2+d5v3y8m9FtetAJ0HA2eZTt2ZqKOIq+TyOqtEdkx/iMxrd7KRbidzz4emcfQyVL7qVILAvsiaYa2PedYi3oj7tkOd5WZ00dvn3/EE3NtYrOQxNEORhdNrsRdXLFNlucakNcwD/apTCQo/ACqKkG+Fybu96TzJPDfF4EJkmk7x0NDsjxzhO97FfMYjQS33dzFN1emuTsUZRxUx7yPboc4Di6gzQqG+m0pG2q7RDEM2O/byIK8+Ju1Dcb7OoDrd1ak4p6edi+NlYbb0q6KuTyVNtVGSYQgloKo+Rpd1zXT7tIlIq+UgG7280llR1srofqsZ0WctvWrqiYQTxBNhNjTUsnBdXz78dE92tJZ5odPW1F6nUIgxkQj7lpWxRzhMp1CIeDJJXTLJikSCD1pbmR+P2wlb0kWrtDeGpgp41KNGMb2iPYYsvBUaeVh1uqtT8ZGWqggrxnRl3dBaEpHdz+3bQhWfjuhMOJ6kz9J6Bs7bSnmT/1FyOlc1ccK+7/P5oUuIRjLnf8TwBcTiEV5fOox/fjCObU1VvuvsFApxXHk5R0ajRNt+GArRExgaiXBkNMrmZJJnW1qYFYupW5nPpE+dTQPG+ZDnWJyd/6463dWp+MSGwZ14++T+rBneOaORSScRCbFmeGfePrk/GwZ38lXngYOWc9NJj3PE8IVZjUyKaCTOEcMXctNJj3PgoOW+6hwdiXBjdTXHZjIyGegeCvG1igqmVFXRORTSClkEQzMUmOJjvlMobDFbdbqrU/GJT8Z1Y8HE3sTL7IUXjJeFWTCxN5+M6+aLzi+NncP5E2dSUdZq676KslbOnziTk8bO8ccYlpXxnaoqagswGCMiEa6tqqKbGhvfDc1UsNQpcIuoydMuqtNdnYoPrN6nCyvGdHWUxooxXVm9j7fLBl8YOZ8Tx7xPoc1vCDhhzPt8YeR8N+RkXfjZOxLhm5WVjs446RkOc1lVVS4XUJ1dc9nQ1CKbB/3mLOwt+KlOd3UqPrC9WznL93NnNLJ8v25s71buic7+3TZz6n7uxG49db93GNDNcTDwjPOFFaEQ51VWFhQ7qy17hsOcWpHV03ub1l53Dc3x2Ns86BadTN5WUZ3u6lR8YNkB3UmG3ZmiSYZDLDuguyc6v7z/25SF3TlKqiyc4Iz93/ZE59HRKN1dnPI6IhqldzisFdUHQ3N0EfM/2qNrVadSdBq6l7O1r7ueWFv7VtHQ3d1RzYBumxnZd42raY7su8aNUc1ujdWR0Wjg01Qyl/PYIuY/1qNrVadSdDYMqimJdA8c7I23mNvpDotEPPEW26+sTCurD4ZmaBHzH+rRtapTKTp1fSpLIt29e6/zRKfb6Q6NRDzR2S0Uood6oHluaDoXMf/OHl2rOpWi01xbVhLp9q71Zt3b7XR7e2gMdJ3Ge0OjKIoHxMq96YHHKtxNt1N5iyc6O1U4OtV9t8WtMg8NTYa0m7UGu2toiunGt82ja1WnUnQicW+2YkRa3U23Je6NQWxpdTTy2s3jwctAPK3J3cp0h9Zgdw3N0iLmv9Sja1WnUnQqtreWRLqbt3vjje92uhsTCc9+q01J3Z/ptaGZW8T853p0repUik7N5h0lke6KzT080el2usvj3oxp6pNJNnhoxBQxNC8VMf+XPLpWdSpFp8dKb04D7rHK3XTnrBroic73Vw1wNb2F8TjbPRh5zGlt1XgzPhiaZ5Ez6f2m0eRtFdXprk7Fa0OzqtH1EP/lTXHXDdjcVQPY2lTtappbm6p532UD1grMisVcTTMJvOpymkpmQ1OPnCHuNw+YvC2PcFWnqzoVjwklkgx6f4uraQ56fwuhhLv979ZEmGfmunuixTNzx9GacN+p9d+xGPUujmr+29rKKp0288XQANwK+GnWY8BtBdynOt3VqXhM3yX1dPvUnTPpun3aRN+l3vQlZi0Zzodr+rmS1odr+jFr6d5Ok8kYIHZ7Mslfd+xwZaprUzLJQzuyrnepB6cHhmYJcIeP+d4JLC7gPtXprk7FB0a+tp5OW5ztVem0pYWRr633LHh9Evjda4ezaquzSNOrtnbjd68dTjLpeM9L1uHQ+62tPObQ2NQnk/yqqSnXmo8u23hgaEBOafTDa2kuzk+uVJ3u6VQ8piyWYOwLa+i6rrA9gF3XNTP2hTWUxbyd4mmKlfPzF77IwnV9C7p/4bq+/PyFL9IUK/e8TF+IxfhTczOFmO9PEwlub2riU50yK4qhaQJOBzZ4mN8Gk4eT1UzV6a5OxQ9j05Jg3xfXsNc7mylrSVi+Z693NrPvi2ss3+OU7S0V3PnSsTzyzoE0tlgzGI0t5TzyzoHc+dKxbG+p8K1MZ7e2cmNjI/+z6DXWnEzyj5YWbm5sZL0aGX/rf5v/LwGOQ7yX+ric1zrkvJQlLqSlOt3VqTinGcgZ7TKUhD0/qqPvknrW7VXDpv7V1PesIB7d2d+LxBLUbtxBj1WN9FnWQMTaKKbZTZ2JZIgXF4xi1tK9OXjIUsYPWMGQHhupjO5cdmyORVm+qSdzVg5k9vKhNMeibuu0tEayMZHg983NPB0Os19ZGaMjEXqGQnQxscu2JhKsTCT4MB7n7dZWmqw7EmzXKu2doQF4F5gIPIZ7Yefnmp63m42i6lQjEyTmAAdbuTASS9Bv4Tb6LZS2NFYZIV4WItKaJNocLzRv13U2x6K8umgkry4aCUBtZTMVZTF2tEapb670Wucb2DjIb30iwb9bWvi3O79lE7BQq7R7hHP0xCcAt+PMeypm0pjgUaOoOpWgcG+hN0ab41Q2tBZqZOzmXbDO+uZKNjbUFmpk7OZ9D7C5SL/lfeh0tC+GJjXMvRYYDfzeZsE3AX8w916Lt5FQVWdbrrpKa7b//Am4vwj53m/ybm86NwKnAVt91vkOMFWrs7tYCa+6GLgQmAKcCBwJjAeGAF3NNVuB5WZo/ArwDNDghsBRoWlWL10MXDg/Oc2WzlGhaZZ1znenzItanopnJIFvAP8Fvmt+Ty9ZjrjQ3409V9xg69y1k/QfYIx5Vo5G9tZUA7k8DroChfhWrzYjmVutdAJnzZofmIo3ceKodmFo2lbS9L9ElveLhjEcD1Kc3fl2SNc5wlTwY035zQKuBpZp+11SJIBfmr8eQJe2F8Sj4fDy/bqNbexafmhrNDwyGQ7tmQzJdaEkdaFEcnVZLLGgemvszSHvbX4/EsvoHlUHbPJSZ2U0Fj51/Dtj9+y69dDKaGxkWTixZziU7AKQSIbqWhPh1c2x6II1dV3ffOy9A95vjkW90AmwCsg6RL+npiYMHGgM0ThgEJDaDLQF+AR4H3j5rqam9z6IxzPF2on50JGzrNN0AtqVW5wVQzPMTNecDWSL+93b/E0ALkY8Nh5AdqsXey3hOGTaqRm4FHguYL/B54Dn0yodwKnAJOAY7C2gKsFhU3oj+9rXhnQz9e9CIFcQsPHACXW9K1kzvHYF8Dvg7kl/W77FD533fPXPtnTu3Xsdh+298DOdF9//f1v8KNx7amqs6pwAnAlwWVXVTp0NDVt8qge2dQKf6TRGqOQJ7TPzlmyfVSIbAaeQ4RAii7Qgu9Z/RI51hfmTsk+JjnrtViffr4cZFaSOON5mpgoKWmTMpbPAdZHPAS+wc8qsLRsLNjYzZmhT78cIOn/9DAHfBm7K8TvnYyvwA+DXuXq6OevnzMrA6OSwZifPkX86czxDFqbOfNNZClNn2ZwBhgJvmpGMk22+5cA1Jq1hRfh+J6UZGczrEwM0knkhTyXsaa4Zr016SVIDPAH8ykFjg7n3LuBxk6bqVJ0lRSZDsz/wusuN23hk3WF/H79b1Bi5tlxOYYuFfhsZNTalzWDTwTrZxTRPNmkOVp2qs5QNzTBkDaOPB3n1MWn7NbK5FBiZ4f0DgHNKxMiosSlNepnfa18P0t7XpN1LdarOUjQ0VcCjHn+RXsgO+SqPv1dPZF0oG9PJ7SIZJCOjxqa0iJg67mWHahgynVKmOlVnqRmaaYjbndeMxftowz/O05gPAr5TQkZGjU3pcC3iMeg1E8k8Naw6VWdgDc1QxLvML6Z4aPn3RVwJ83E90L2EjIwam+DT39Qrv7je5Kk6VWdJGJqpyOK5X0TxLszDnRaHlt2AG0rMyKixCTZXIzvX/aLa5Kk6VWfgDU0tshnTb84iy3GtDjgF2XlrlW/jrSeHF0ZGjU0wqQTOLUK+52JvzVN1dkydRTc0x5N9x7+XdMJGGHALVCCRje3ec3MJGhk1NsFjMrvu2fKLziZv1ak6A21oji5i/m7mfRmwd4EjqwNL0MiosQkWXyiR50h1dkydRTc0Y4uYv1t590FCNRRCqICRUC729tHIpBub54G9tL0vGsU09ONUp+oMuqEZWsT83cr7JofD1yNwLzTNz3w2Mil6IRGgleKwdxHzHq46VWfQDU3nIubvRt7jgfNcSOc23NkIVcyh9LHa3pd0XfYjb9XZMXUW3dCUOne69D1GuWSwikkcpSM+S2HVqTqD/nBsK2L+TvP+MnC4i3puxLkH3vNFLM8Xtb0v2brsV96qs2PqLLqhWVrE/J3kXYlMd7lJX5xvhLoa2FCEstxACYamaEcsL2Ley1Sn6gy6oZlbxPyd5H0l3px3frUxOE6M57E4P8LWrpE5EjkOVim9uuxn3qqzY+osuqF5qYj5F5r3HsD3PdJUg0yhOWEO4hTgh7FJGZkPta0vKi8XMe9XVKfqDLqheRbYXoS8G03ehXAL3p44dx6wTwkYGzUyweEfQFMR8m0GnlGdqjPohqYeeLAIeT9g8rbL54BveKytDHf2pHhpbNTIBIttwMNFyPchoE51qs6gGxpMoxrzMd8YhS3kh4Bf4M9RzCfhjkebF8ZGjUwwuQVo9TG/1gI7RKqzY+osuqFZAtzhY753AosLuO8s4FAfdf7UJaPmprFRIxNcFgJ3+ZjfXcAC1ak6S8XQgJx66YcXw1wKP2Fzms/lcyBwpktpuWFs1MgEnxuA+T7kMx9n5ympzo6ps+iGpgk4HW/3gGwweTQWcO9eFCe2z624F6zSibFRI1MaNAIn+/AcnVzgc6Q6O7bOohsakCm044B1HuS1zqS9pMD77y1SGQ0G7nMxvUKMzXo1MiXFEuSsEC8anQ0m7SWqU3WWqqEBeBeYiLvTaHNNmu86SGNCEcvpEJfTs2Ns1gNHqZEpOd4BPg984GKaH5g031GdqrPUDU3KMk9Azmlx4o0WM2lMcMES/7eI5TTbgzStGBs1MqXNYlP3Z+DMK6kV+LlJa7HqVJ2lRq6w+M3AtcDvkRha5wDVFtNtAv6OuDC7VUAXAn82lj3kU/kkgdfx7kzwlLF5EejR5rN1yAl6rhqZiy++ODCV75577ukIxqYRCWt0DzAVOBvrZ703IfvNbvWhoVGdHVNn0Q1NunW+EJiCHA52JHIGzBB2HvC1FQkuNwcJi/AM0OCy1mXApHbYEM0BDjIjv6ONcXsOuA74WAcF7Wp0cz7wXeAEM1Idl+U5eh8JbfIs/kfoVZ0dU2fRDU3bHn76XyLL+0Vj/pMbaswPmm4Qu5iP69oYxH+OOqVXQzF0zjr1/Ew6Uz2eo5FoDZ/pnPjEHxqKVKS2ytODDkZ7IxWJ40HVqTo7CqF9Zt6S75phyBTa2Vg/q2W7GfrdhoW1mfmTpmb/8KqrrH4Xz3UyY4ZjnbNOPd+RzolP/MHaWlcWrTamzjwvzw4ydaYoHZ5cI5pKZIPkFKDcZrqdgAuQmGR3Aj9C1ny8IBA6Z516vi86Z516fl6dEyeOKvnyVBSl/ZDN62wo8Kbp0ZY7SL8ccSR40/SQ3UZ1dkydiqKUuKHZH/G0Gu9iPuOBWSZtt1CdHVOnoiglbmiGIR5PfTzIq49J240erursmDoVRSlxQ1MFPAr08jC/XsBjWPcnz4Tq7Jg6FUVpB4ZmGuLf7TVjcRaFWXV2TJ2KopS4oRmKeBn5xRQKm0pRnR1Tp6Io7cDQTAWiPuYbNXnaRXV2TJ2KopS4oalFNuX5zVkmb6uozo6pU1GUdmBojsf6zm836WTytorq7Jg6FUVpB4bm6CLmf7RH16rO9qNTUZR2YGjGFjH/sR5dqzrbj05FUdqBoRlaxPyHenSt6mw/OhVFaQeGpnMR8+/s0bWqs/3oVBSlHRgaRVEURfHU0BTzJLdtHl2rOtuPTkVR2oGhWVrE/Jd6dK3qbD86FUVpB4ZmbhHzn+vRtaqz/ehUFKUdGJqXipj/Sx5dqzrbj05FUdqBoXkWOevdbxpN3lZRnR1Tp6Io7cDQ1AMPFiHvB0zeVlGdHVOnoijtwNAA3ArEfMw3BtxWwH2qs2PqVBSlHRiaJcAdPuZ7J7C4gPtUZ8fUqShKOzA0IKcf+uENNBfnJ0Kqzo6nU1GUdmBomoDTgQ0e5rfB5NHoIA3V2TF1KorSDgwNyFTKccA6D/JaZ9Je4kJaqrNj6lQUpR0YGoB3gYm4O50y16T5rotpqs6OqVNRlHZgaFI93AnA7TjzSoqZNCZ41KNVnR1Tp6IoJURon5m35Ltmb+Aa4Byg2mK6TcDfEVdWS15G8ydNzfzBzEprOT51qTOdJ99tzRvqsObM7191laXbZ516viOdE5/4gzWdM2ZkfPviiy+2Wjc8/93vuecefQKVgp4j38jyHCn2KLNwzWLgQmAKcCJwJDAeGAJ0NddsBZYDc4BXgGeABl+/iRiKC3nqUns6T77bV53GUFw469Tzbemc+MQfGnyuG6XxuyveYLWDZ7UjpqihaVecfHdJyJz4xB9KpUQbkAgCD+rj0mEZCnwPmAz0BdYD/7YzY1EghwJTgdHARuBfyF6srS6lvwdwHXAS0AP4ELgBeEF/cv8NzTDgWnJPofQyfwcBFyFTKPcj8/R+bdBTnRbQ6SrFJieYTkZN2nv9gfNNHf4G8KgH+U5Cgq9Gzf/3Ms/DhcBpwFsO0z8GeDhtdI5J/1/A4cDr+tP7Y2gqgRuB7wLl5r1VSEDE2cBCYLN5vzswAjgYON5UxAtMJbwT+BHg1Zi6ves8AdjTR52KDUa9dmug9GRd6yyM4aYxztYhqjIdoI/MaMBNbkwzMun0A140z+9rBaZ9LPCk0d+WiOkInqS123tDMwx4DBhr/j8LuNkMlxNZ7nkD+CPiyfZFMySdiCwoH4ds2HPbAymfzu7AZaaHAvAf4K4A6gxKeSpKOt8nvyNIOXC9Gd24ybgcn9WYkcfxwEyb6X4BeCKLkUmxj/707pLJvXl/0xCOReZCv2aGsf/K0SimkzDXHmbu3WrSmmXSdot8Oochi9TTkIXsI83rOeazoOgMSnkqweeL5ndvMqPfv5hRuVcca6Pxdpu6PJ93Ms/FUTbSPBJ4yoLx3KRVzVtDMwx4DugDLAIOMEPjQkiaew8w00J9TNrDXBoh5NP5B2BAhnsHmM+CorOQ8lzksk4l+HwbmWb9PDIN2w34OvBfZGrVC/aweF0vD/J+0cI11cA/LBq6wxGvSCuu+s9rdfPO0FQhi3q9zJTMJGCZC3ksM73xJSbtx/IMW/NhRedgk2c2DkPcdIuhM4TsUdnHvM5HCBiFeN6ETRqTXNSpBJ9LgV9lmYHYA++OXggV8Tv/FGixaGyeMqO9XM/7sxaNzFZkel3xyNBMQ+ZF65A1gPUu5rPeVIStyLTPNAdpWdFppZc/tAg6RyELp4uA+UholiE50hgCvI0stH5g/kaZtCabtJ3qVILNd0zDl6vRP6Edfu/FwHlmJG/F2DxpnrO2TLJhZFqBr+JtgNkObWiGIhvzUhV7qYt5VCOLd8uQhXlMXoVM+VjVWWEhrYocIzAvdIaQRcgRadeNRxYzh2ZJYya7rsPsY0ZJITOi+Y5DnUqwuRz4pYWRRXU7/f73I1OGVoxNpTE2x6e9N9EYmU4W7o8jDg16zLiHhmYq4ko4i8LXENrSHXgE2Gb+/o3sHp9l8irED/P7HujMVsHd1jkMcRdtS39TLkPbGJlXybzQu0+aUXGqUwkuVyCu7Famr95qx+XwW+Bii8amwnTmvoSsZT3Lrvt/8hmZR7TaeWdoaoGzzf9vtviDWjEyLwBnIH7pIcSD5QkgFVztbJO3VbzQmY2kyQPgLJd0xnPcMyDN2Aw1r/vneTDa6rRbnkpw+S5y8qkVIxNH9py0Z36H7COz4qVZbkb9z1p8HuKIN+fDWu28NTTHm6HlajPqcMvIZHK9PRBYaf6qkRhaVjnB3OOWznz82+js1GY4XqjOZYhrdT5j8wqZveVSvMeuzg//LrA8Fe/oCQwke3T0XEyxYWSSprf/Ugco0/uQNZu4RWPT2aKR+QYaXskXQ3O0ef2MxR5DoUYmvRKk5kGPtJH2US7qtEIiTefRLuk8A4kGkMvY5DIyq4Azc+g8Uqt0UdkfeBNZTP4EWMPOdTQrXAn83Eb9vIBdXfXbO38GzrVobKwYmW8i0cYVHwxNarf6bB+MzErkMKw3zf/H2UjfLZ12eLNN3k51LgWOyGNschmZI8gcDaCQ8lTcZTQSEuXgtPd6Ix5j+bzGAK4GrMakTxmZ+zpgOf/VjEKcGJu4GR39Tautf4YmtQi9oM1nZWSONVSokakHvowcirXIvLeXDa3ZdBaKlTWeRW3ydkNnIcYmZWSW5tG5l1bponET2b2/voPsg8lmbL6H7Bux2khegIQn8ppkQMv674gbciHGJlV+f9Eq66+hSc1lpkI+9EHcBOuQEPF/IfeimhUjsw3Z95Hyjtli/u1sQ2tbnblYa+EaK/uEvNJpx9iszGNkCtWpuEu+UCjfBu7OYGyuQaJyW20kz/fJyIBM/VmhGPtOHkIcYOycBJtAoj//Saur/4amLY8CJ5veWTkS5uJ5oIsDI3M8/obdnpun8m8E3g9A+Sddvk4JNpcAv04zNlOxvqs/Nd3zZx/1Wg3F8mKRynMJsN3m85bQalgcQ7PNvO6C7DqfmOG6g5G4Wl1cMjLd0j63SrrOfMTIva/kWos9Ia90plyYB1hIbwCyp2Yvl3Uq7vKyxeu+hewNuY6drv5WjMy5+D/dcyv5j6NoYaeLvZ+MN+1PVxv3RBDniXO1uvpvaFJTMiPIvYM23dg4Hcnsbf61E0stXacV7jOjsfTpqVXmPauLqHu3ydsNnanNmANspJkyNkPz6FymVbpoXA80Wrz2ImC6DSPzf8giuN8sRDYyZhs1NCFrJR/4rGucaX96FHBvythcoFXWX0Mz17w+BJlOWm3B2DidLjvU/DvXhtZ0nVb5GzDINPojzGs7niZu6xxG9h3/VozNK1mMTSE6FXeZj+yhanQxzdQ+j/uL+L2eMKOHe5H1wphpI+4z7z/qs56xpv3p6SCNkPk+F2m19c/QpDZ7ncjOoHKNeYyNEyOT2iRqZ7oB08imdFrdCNcJ8fi5xfx9B2txj9rqfMklnY/kMTIryb/P5mGXylNxn1fNb+GGsYmb0XcQ9nksQTaGDkTWbVNHOS/yWce+yHqQG8cShJApzG9rtfXH0DxrhsZ7IpGL/2MayUIeFisL/8eaBrMR2dRolWfMPSmd+egPvAP8Ajlj/DTz+h2LI4p0nc+6oHMv0wPMZWRSB7TlMjb7s+t6TaHlqXjDfxAPy+0O0oibDt8DAflOIeTMl5+ZGYGfI5GS/TxGYLTpSFkxMklgh8Xv9SvsbapVCjQ09ewMwXBdWq/c7jSAVe+y682/D5i8rVKf9uBdZ+H635N5nWSE+QyfdUZy3LPKGJilpveYz9hEXNCpeMdMY2waCjQyZyPuu0FgD2M8XwCuMgZwCnK65evYW2sslFE2jcwUJLCmlfYrhETIvkKrrbeGBsS7JIZ4nH0tbRrAqrGxamS+avKIUdhhTZl0ZhvN5Br1fDHPA+KFziXI4momI3MEuzocLCH7PpuF7IwO4FSn4h2vmWfCjrFpNUYmKFGEOyGx9CZl+fwQYwC83L+1j8mjt8XrrzQzFy/YNDZ3mnsVDw3NEiSQH0i4jCE2jI1VIzPEDFMxP+riAvRm05kpr3wM8llnEpm++yjtuneR0/8yebUtRY6fndPGyJxm0trLBZ2K98ZmssWRZixgRgYkivSYPNcMQyIbeMEAY2T62DAyd6b9/2XTflmdxpyB7HVSPDI0IKc0zkX80p9P60HkMjapHf/5jExv0zPqavKY5kBzNp3prLSQzuoi6JyPzDUPN9MBnwOW50hjGbImsy8y5TfKpOGmTsVbZplnZJsFI/NowLSfbfG6r3iQdwiZ0u9r8fqr0zp36byKvWnMu9CYgZ4amibgdGRH/TAkKOS+aT/W8ey62z517PEbefLYFwn6uLe5/3SceeXk0pniY9ObzPXwLy+SzqQZfXyEtR3/SeQo50XIruYxJq1hLulUvOd18/xkCku0wzTojwVQt9VTW4d4kPcX2Om2n49ryB2Q1M7IMoIcXKh4ZGhSUz7HAetM5XkDWQcAWRAchoSnOdZ8ni+S8tdMGnuZNI8jc/Rhu+TSmeK8LCObley+M7iYOu3wNdNoDXFZp+KPsZmA7EupM9M5LyDrH48FVPMmi9dt8SDvYy1eNxVrAUlnmefFSqzEL2h19dbQgKwbTDRTMrWIO2O6F83T5gFpzJHmZHPPX00ac02a77qoPZfOsGmA90OmlV41f9PMe0sCpNPKb+SHTsV7UmtsXZEjho8F/hdgvcWMdWZlQ+Z12HOCecOisemiVdVdynL0xCcgR8ROMb2uScAKJDLAG2b6J9Xj6Y6sOxxiGsWB5v0YMm/6I/LHTCp0xJBP5wvsdN/ujuwRCqLOTOV5qNE5wCedipLOrchR5pU5rvEq1tlHeT6/Aeux4tKZDRxjjGjXLNdohA2XCe0zM+9vtTcyB3oO2c/baEsTsqP5Nix6Q82flCUG5sxKq9/FF50clqV9v+qqYOmcMUNrt1I4O5+7U81IulOWevkN0p0YDnPY/9n5HPVAYqi1dQZIkH9NxgrjgKfY3fs0DpxEapO2PkeejmjSWYyc4TDFjAaORHa4D0nrEWxFFtfnIJs9n6GwzWpOUJ2K4j6pWGffQ6ad+iKOQM+bjo9XYWg2Ia7/M8wz0oJMH9+GO6fsvo8451yBeNX2Mc/mT7EXckqxYWgms/Ps8fORXb9nmh+5GtkA9QQyBfVgEfWqTkXxn1SsM79ZbEYXXtGARNGerj+xt6Smzj5FQk2AnKrXD9jMznNOUryKrDO86rYQi1NnRddpceqs+Dp1yK+UItanoP1BnyNXDU3b/Rwhcu/xmGkaSMfRgrMamMzGpmg6Lc0973xIiqdTHwxFUQJGuMD7DkPmMV9DPDiCiupUFEUpUUOTYiKyKPg6slAYVFSnoihKiRqaFIciC96z2XkIVxBRnYqiKCVqaFJMAP4J/Bdx3Q0F9HurTkVRlBI1NCkOBP6BhNc4KcANpOpUFEUpUUOT4gBk9+07wCkBbiBVp6IoSokamhT7IRsU30PC2tcEtDxUp6IoSokamhTjkLhI64BLA1wuqlNRFMUHQxP3MN9qJAKxG6hOd3UqiqL4Zmi8DOIYY9ezvZ2gOt3VqSiK4iplPuc3F7gdOSNmfYDLRXUqiqKUmKF5Azmk6J/kjvlVbFSnoihKiRma55BT+v4T8HJQnYqiKCVkaBLA48jxru8F+LurTkVRlBIzNC3A3/D21D3VqSiK0gENzXbg98jpkSsD/F1Vp6IoSokZmi3A3cixxBsD/B1Vp6IoSokZmrXAz4HfAvUB/m6qU1EUJeCGZivQJe3/y4CfAn8CmgP0HVSnoihKgMkVGeAyZI2gHnGpHWF63UFrFFWnoihKiY5o/mH+go7qVBRFKdERjaIoiqKooVEURVHU0CiKoihqaBRFURRFDY2iKIqihkZRFEVRdiWU/E8Fo0LTPgX2MO+tnZ+ctofvSg7Lsp1kZmX6/3bRmfY6WDqfunRXnSffHRydiqIoRRrRXGAa7tXA+QHWqzoVRVFKcUTjwEg9D4SAY5BzU7we0ahOHdEEkilXrPUzu0OQI7yHAzOBKXf8ou+qYuls2B5mwIAYx03eSjwO8Xgo9VE34FFgLHLc+LkTJ47a4YXObdsijB7dxJFHb6OxMUzS3rmzruls2RGiulOCE760lepOCVp2hNws6oJ1Fhsn0ZvPAI42r78MPBTQ76g6lfZEGXAHMMH8/xRgA/DtYgmKhGFHc4jWVohEIB7/7KOngEnm9dmmE3V2AMtUdXqME2eAi7O8DhqqU2lP7JVmZFKGp6iNTUV5gk2byti4sYyqqs8G4kPTGsUUpwWwPFVngA1NH+DwtP8fZt4LGqpTaW/0zvBe16I2ImXQ3BxmyeJKQjtblJ4ZLo0HsDxVZ4ANzalABJgPLDCvTw3g91OdSqnRBTgPuBQYk+HzUIC0HgGcQhKqq+OsXFHBpo0RKisTIEeRt6XVSzGhUB6dmfFdZ97yDL5O3wzNmebfR4CHzesvB/D7qU6llKgBbgamAz8BbkMW/NNJBkTrr4FXgCeAuRUVyZ5btkRYtqySikr/JaYW/8Ph3DqzjAwCV54B1umboRmITO2AeEA8Yl4fDgwI0HdTnUqpMQlZ1O+LeBhNBs4NoM7jgEvS/j8GmBEOw7o1UVpjoVyjC08oiyTZVh8mFttlZJNRZ6mUZ0c3NNciUztzgA/N33vmvakB+m5tdX5QAjo/CLBOxXsOyfDeoQHUeUSG9yaEw5BIiNeZ34amsirBmk/LWbMmSk1NPDXCyaizVMqzIxuak4Bvmdc/Ar5o/m40733LXFNsMumkBHQSUJ2Ku0SyvF9u49piEsvw3g6QqatQEVaRysqguSnM4oVVhMPJlIasOkulPDuiobkQmdYJA38GnjY97qmIf/efzGePmGuLRTadlIBOAqhTcdfA7Ad8BTgggxHJtLhRrDWZPoj77OAMn8UtvuebzmSSwTU1cZYvq2Dt2ijV1Ymi6QyF5C9ZmuVZFENTARwPvAzca3pczyD7PA5B1hEON68vNp+Vm2tfNvdW+PA9rOhMEVSdbSmmTsUbJpvf9PfIsd4nBlTnocBi4DHz7wmloLO8InnCtvoIixdWEo0W32ciVHrl6d2I01T+84D+QNS838181jdtOB8DbjXTOnF2XT+4FnHLO8VMAU0FjjR/LUjcr1ZgS1paq4A/As/aeEid6sToCaJOfNapeDNiCZtRSCbX0+lAP/O6CvEqeyZgvdcw8CBQm9ZGPAp0B5qCrDOZ5NFoWbL7+g3RpuYdIVJrRr5WgDLYvj3M9u0hunZN0LIjUirl6bmheRhxq8zGZuBxxAtigXlvFPCltGtOMu/NB34I/B24ygwVuyOeVZk4Lu0HyEchOke30Zk+LA2Szmx4qVNxl1rgeuBgYDnwY/Nvih5IjKp0RiBurOt81noVEu5oBXA5u+7R6Mfu3o6VwEjESSXQOiPh5MhkkvcS8RChUBKfth19pjMSSV5eXx9p+eTjCgYMaAlaeRbV0PwWuNr8f7lp2NaZXtla4CPT4NUi88rDgYva/IIh4G4zxbPI/F2ILGbvY3ryIWSe8sfAEHPfvTa02tH5OaPzwjw1bUERddrBC52Ku0xBNlnWABOR3fqnszM4aqcs91X6rPNaM5JOsTc7Y+xBZoeE1Ggt8DqTEPHZIWE3nRXlyaM/Xl7JmLFNRKPJ8lgsFITyLLqhuQbxcLjONFiXmQdklRkRPG96XnvmSesIdnXTWw0sND2RF41Vv8nkkUQ2pv3AhlYrOkemTU3YIc5O12IvdTrFTZ2Ku1ycNpKNINOeg9JGNdmaPr8XE65r8/+jzEhrblody1b3VKcFndHy5NimpvDchoYwvXu3xrMYmnhHejhS88k3INGD64GDgHeRRfQPjZHYs4C09wReMmkcArxj0q43ed1g8yGzorOfw/LwWqdbuKFTcZd+ed4Lym9TleG9/gEsz5LVmUzSPxIRF+ukPpGfGZoUjyObhBYAvUzDvR9wCzCtgLSnmV7255CzE3qZEc4Ek1ehuK0zhV86neK2TsWf5ysoZNqf0aI63dcZCukDkO1B+Mj0lucA1ciZKFWIZ9R0G+nebO6pBh5A5qffRxZKP3JBdyad1QXoTO+V/N3onOODTie9Jy90Kt6QLBFNqrP96wxcj2srspN+PbIAd5l5/wbgLgtp/grxvsHcO8ykdaxJ2y3a6vyOTZ3pXG7SWG/S9ENnIXipU1EUxdeh/Xp2hkH5Ttp1cyyk+V5a2pea1zeaNN3GiU4CoJOA6VQURfHN0AD8BdlQNAA40Ly3j4U0U9ccaO5tMml5RaE6CYBOAqhTURTFN0PTAMw2rw8y/46ykOaoNvfMNml5RaE6CYBOAqhTURTFN0MD8LH5d2CGBnwJslP9NPO6raEZ2CYNL7GiMxupe5YXQacd/NSpKIrim6HZbv6NIJ5Og4CNyCL/aOQ0uCfM68vMZ4PMtZG0nrzXWNGZjUibNPzSaRc/dSqKovhmaIaaf9eYxvs2xOvpV+zq095i3tsbuN30vteYz/by4XtY1ZmJlM5hPuu0i586FUVRXKMsx2flyNGyAP9FAmZ+HwmzcQayZtDHfL7OXPMcO6Ml9zb/TkSiGMc8+g6F6mxIuweThp86U9QgwTCDolNRFMU3Q/N50wjWAW8gmwW/j+zl6JLlnjrgl8gu/TfM/7sYY/OKR99BdSqKopSooUkdzvM8srj+ADvdhj9FwqCkFqaHAMcgsZ1+YEYSZ5l7v2zS8qphVJ1KUAlleY2F93HpekUpCUPTF3GprUQW2K8G/sbu0UcjwNeAn5kG9C12TvecwM7Q+V414KpTCRrpoUiyRetNtPnN8z2jTsObRPO8V2bhvvJsn6fF94rabG981Zknn/aos6hkcwYYhITcB1kTqDQ96PHI+fbZzrj+s7nmFXPPYeazkSZNt1GdSlCoy/DehrTX29oYlZTRSPfKzHQA2uY2/88UEWKrDZ2ZjFlDG52ZSH8/li3dROKziMV1DhtGT3Xm+d3ao87ijmhmhd/d7c2Jif3T96G0IscJ3zor/K6Vg1FXT0zs/wVk/WFaWmGMmhV+95MMeTnRn1Fnhgc6o04go07gE5fLuVR0lhyzZs13dP/EiaPckvIAcEHa7/MWsLRNw/I0cDI7p7+eZedx3CDHaqxjp1PIduDJNvksM2lPSKtPD9jQ+ZAZKadYC/yvjXF8AZm6TfEBu54G+whyoF86fw2FksQTIRKJEKFQciGE5rLrqaIvBkFnm/8vRM64ae86AzmiWWJ6Uq8Ch84Kv3uzRSMjD3/43cSs8LvTgUNNGpvZdVOnW+yiE4kabeeU8AQS7Vl1Kk6ZbozCemAWcKUxAulch6yzrTdG5Zo2n8811yw0HYzfAfe3uaYVOc1zlknnSVOfrHIBsq9ss8nvKHYPdf8Vo3OzyWdym88/AM5BNiBvRE7XvSUUgkQilH4Gy5dMo7sZ+HebBrloOjPk1RF0FndEk8VQLEbOOP+MjRsX1SBrA0ea6Zwh7PSWqkMWsueYaZ5/9uw5vGFW+N3/mesd8+TmBzO9vYvOUChEMpm0pdMMc/PqPKX7Wa7pNNjSGQ6HGxKJhHs6n3wy62emHAmHwyQSiULKMy+nnHKKqxW5kPrp8rO0CnHUyMVHiCt7rg7FfebPK3aQO1IGZpT1RQsjuAcAGraHGTAgxtlf3UQ8DmknStabv4RpHLd7pXPbtgijRzdx5NHbaGwM09IS2k1nDlzT2bIjRHWnBCd8aSvVnRI0NYVtl6cXOp2O/G1yCLKfcjgwE5hSZuEBHgZcC6Gzy8urO0WjnYhGKwmHo4RCMiBKJhO9E4lY71iseUIstv3ilpbG7Rs3LnoAuK1nz+F+9byHAddWVFSe06NH7+q+ffegS5daKisriETCvPnmgow6IfkAssHTV53ZyvOQQ0YSjyd6Nzfv6F1XVz9h/fp1F69fv6axtTX2oOnl+Knz+2Vl0bN69uxd3bt3b7p160KnTtU0NcVYtmwd9fXbfSnPjz7aeeROeXk54XCY1tZWamtr2bhx0bBIJPL9aLT8rJ49U797Z6qrqygrk/rZ2pro3djY1LuubtuEtWvXXLxx4/rGLVuWPhiPx29Zu7b7kvr6esrKykgkErS07Nzfu88++xBAyoA70qbOTjHTM98ulqBIGHY0h2hthUgE4jtXHJ9i596xs82U4dkBLFPV6XH9LMthYCqBaaFQeEpVVbfyysquhMORLD3gCOFwhLKySqqqupJIxDs1N2+9oKlpyzc2blx0J/Cjnj2HN2e8+bDm3LJTn2fvgVcC02pqaq8cOHCv6MCB/ams3NVBI5lMEgqFcupMJhN3ImsnnurMV56RSJiysggVFVG6dKlh4MA9iMX2rV6x4tPzPv54ydfr67fd4UhnfiqBH1dVVX934MDB0UGD+lNdvetZbS0tccLhEOGwg/J0yIcfflgJTKuu7nTlgAGDo4MGDaCyspxQKLzbyYbl5WHKy2vp0qWWAQP2oLm5pfqTT1aet3Llx1+fPXv2HcCPxo0b10xpsFfaQ5x6sM8upqGpKE+waVMZGzeWMXhwC7FYBCQKxqQ2l54WwPJUnT7Uz7IsRmYo8GhFRe34Tp16EQ7bc24IhyNUV/egsrJL+fbtG67ZsaP+2I0bF33Zg9HN0HA4/NigQUPHDR8+jKqqCsc6zfTHEg8qScHlGY2WMXToQAYO7BddtGjpNR9/vGRyLBY7zQud4XD48X79BowdOXI4NTWdAlme77///tBQKPTYnnsOHDdy5AiqqysJh/Mf8RMKQSgUprq6khEjhjJgwJ7RBQsWXrN69Yovvv/++2eMGTOmFNa9emd4r2sxBYXLoHlbmCWLKxmy12cjwp4ZLo0HsDxVpw/1M5zByOwPvF5T03t8be0ethvFXRueMmpr96Cmpvd4YJZJ2y32j0ajb4wf/7lx48aNtm1kcukEXNXpVnlGo2WMHj2C/fc/aExlZeUbbuuMRqNvjho1Zuz48WNsGxm/ynPevHn7R6PRN0ePHjduzJjR1NRUWzIyu2sMU1NTzZgxoxk9ety4aDT6xrx58/YPwIPaBTgPOeRuTCZ7GaBG5QjgFJJQXR1n5YoKNm2MUFmZgMwxBlu9FBMK5dGZGd915i3PYOssqH6G2xiZYcBztbV79KmsdK+TVFnZldraPfoAz5k8nDIsGo3+e7/9Duo9cGA/T3TiTvBKT8pzjz16cdBBh/SqrKx83i2d0Wj0hX33HddryJBBlJWVBbI8Fy5cOCwajT6/777jew0e3J+KinLn0z4V5Qwe3J999x3fKxqNPr9w4cJiBi2tQTzIpgM/Qda6hre5Jijn0f8acax4AphbUZHsuWVLhGXLKqmo9F9iytMtQ59jF51ZRgaBK8+A6iy4fobTjEwV8GhNTe9eFRW1riusqKilpqZ3L+Axk1ehVIXD4cf23Xe/nv369fJUJxKPrGCdXpZn9+5dOOCAg3qUlZU94VRnOBx+bMSIUd3799+DSCQcyPJcuHBhFfDoyJH79thzzz6uGUOAsrIy9tyzLyNH7tsDeMzkVQwmIWstfYFuiBvsuQFscI4DLkn7/xhgRjgM69ZEaY2Fco0uPKEskmRbfZhYbJeRTUadpVKeAdRZcP1Mb1WmVVTUjnOz552ph1tRUTsW2XhYKNMGDRo6duDAPQKv0+vy7NWrO3vvPXLfcDj848KnG0I37rnnwLEDB/YnEokEsjzLy8sBpvXvP2jcgAH9XDUyO41NhAED+tG//6CxwDSTp98ckuG9QwPY4ByR4b0J4bBEBojH8d3QVFYlWPNpOWvWRKmpiadGOBl1lkp5BlBnwfUzbEYzQ0Oh8JROnXp5rrRTp96EQuEpBU6hDa2pqb1y+PBhhDyuySmdBU75+Faew4btRW1t5+8WqrOysmrKiBF7U14eDWx5zps3b2hVVdWVw4cP91RneXmU4cOHU1VVfeW8efO8nELLZtHLbVxbTDKFTNkBMnUVKsIqUlkZNDeFWbywinA4mdKQVWeplGeRcL1+pkY0U6uqukWdLFRbJRyOUFXVLcrOc2vs9L6nDhy4V5mThX8/dPpZnpFImOHD9ymLRCLX2f+O4esHDBhUVlVVGfTf/bqBA/cqq6mp9lxnTU01AwcOKQuFQtd59ADvh+wUPyDDQ5ppfrtYazJ9EPfZwRk+i1t8zzedySSDa2riLF9Wwdq1UaqrE0XTKd6Nu/1wpVCentXP8MaNi2ohdLaXUzyZplIgdJbkbZna8vKKcwYO3NN3nYAtnX6X5x579Ka8vOIrdnVGImVfGTx4oGdTZm6U55NPPlkbiZSdNXjwQMJh77vK4XAIKZOyrzz55JNuL65NBp4Bfg/8AziRYHIoEs3iMfPvCaWgs7wiecK2+giLF1YSjRbfZyJUeuXpWf0MA8eXl1d3yrYZ06vebXl5dSfgeBu3Hd+zZ+/qysrywOv0vzxD9OvXv9quzl69eldXVlYEvjx79epT7ccodqdBrKBXrz52yzPVI4ySParudOSMoSpgD8RrJ2hTY2HgwbTOQBnwKM4cTnzRmUzyaLQsWbV+Q5TmHSHCYf9FRcpg+/Yw27eHqChPBK08i1Y/w8DR0Wgn37+xyfNoG7cc3afPHiWhsxjl2atXb9s6e/fu7flalxvl2bdvX397oiEwedrRWWse1BeQYJhD2nzeg10j7wKMoDhurFchkaN/y+7z7v2AAW1tLzuPuQi0zkg4OTKZhEQ8RCiU9F1nJJIsb2wM88nHFYTDySCVZ1HrZxkwtqyswvcaZPIca+OWsZ0715aEzmKUZ21tp3Zbnl27dvFdp8nTjs4pyCa2GuSo7a7A6eyM0p2t91Hp81e7FjmiIsXebQxqeY7ecOB1JiHis0PCbjorypNHf7y8kjFjm4hGk+VpQUaLWZ5FrZ9hYGgk4r8rp8lzqI1bhlZXV5SEzmKUp9m8aLM8q30f0RRSnlVV/s8ymDzt6LzYPMSpRuQUdj2cLltB+72Y0NbJ4ag2BjXbInRcdVrTGS1Pjm1qCtPQECYaTQZFZ1HrZxjoHC7CZKbJs7ONWzqHw2GSyaTtv0Qi6bvOUijPaLRwr7iUgZJgpdb/jOOBLZ2pKMz+jrxsl2e/PO8FZUd/Jqvdn+BRsjqTSfpHIuJinUwGRmdR62fJHAUKMHv2AoIV6ik4JBIJ3/KqqalizJjCTpKOx+M888yijvKzhAOoaQe7nz/fojrd1xkKaf1Mz2ibn41Um4Zxm41bVGcOWlpitnXGYoXH5LM7kkn9tbbGbetsbfW/PE2e2xwmkwxg45JUnR1SZ1HrZxhYGo/731EweS61cYvqzEF9faNtnY2NjSR9HNsnk0kaG+3rbGpq8r08TZ5LURTFFUMzt7XV/2gH8fgOkCilVlGdOdi8eYttndu21fuu0+RpS+fWrXW+6zR5ztUmQlHcMTQvxWLbfc+4pWU7wEs2blGdWUgkkqxZ86ltnevXr/d9RLN+/XrbOteuXevromoyCWvXrrWrU1GUHIbm2ZaWxu2JhH/edolEnJaWxkZkk5NVVGcW1q/fSkPDVts6N2xY39jc7N/oq7l5Bxs2rG+yr3NdEXSus6tTUZRshqZnz+H1kHywuXmrjw/yViD5gORtmaLplLyDqTMeT7Bs2XISibhtnfF468OffLKSeDzug844klfrQ3Z0nnLKKfXxeOtDH3+8wpGbup3R4ccfryAeb33wlFNOqdcmQlHcGdEA3NrUtCXmRy88kYjT1LQlhsTRsYvqbMOKFevZuHF1QToTicT0FSs+bm1qavZcZ1NTMytXftyaSCRutntvMpm8ecWK5a0NDY2e69y+vZEVK5a3JpPJW7R5UBQXDU3PnsOXJJOJO7ZvX+/Dg7yeZDJxZ8+ewxcXcLvvOpFoq4HUuWlTPYsXLyCRiBess7m56Y6FCxen3KM9oaUlxsKFi2lsbLyjEJ1jxoxZ0tTU+PNFixb5orOpqfGOMWPGLNbmQVHcHdEATNuxo36ul1M+zc1b2bGjfi4OT65UnbB163bmz19IY+NWRzqTyeSPVq9eMW/FilWeTKHF43FWrFjF6tUr5hWqs6WlBWDaqlWfzF258tPUXhxXaW1tZeXKT1m9+pN5wDSTp6Iobhqanj2HNwGnNzSs37Bjh/tT0zt21NPQsH4DcHrPnsOdzIH4phMIpM716+v44IOFbNq0yhWdiUTitIUL529etWoN8bh7myPj8QSrVq1h4cL5mxOJxGlOdI4YMaIJOH3Bgg82rV691lVj09oaZ/XqdSxY8MGmZDJ52ogRIxq1aVAUb0Y09Ow5fAlwXH39mnVu9sSbm7dSX79mHXCcycMpnus0eQRKZyzWytKla5g/fwEbN65wVWcsFjvmgw/e37h8+Se0trY6TrC1tZXlyz/hgw/e3xiLxY5xQ+eIESOWxGKxYz/4YM6Gjz9eyY4dzkcdO3a08PHHK/nggzkbYrHYsSNGjFji4vMVyvIaC+/j0vWKUvT6uVusm549h78LTGxoWD+3vn4NiUThjU4iEae+fg0NDevnAhNN2m7hmU6TdmB0xmJxVqzYwJw5y1i0aD5bt67xRGcsFjtk/vx5H8yZM4+GhsL3AjU0bGfOnHnMnz/vg1gsdoibOseMGfNuLBY7dP78ufPmzfuQhobGguK8JRIJGhoamTfvQ+bPnzsvFosdOmbMmHddfpDT3eSyDcHSxWcKHV+WI81CiOZ5r8zCfeXZPk+L7xW18F2KpjNPPu1RZ1HrZ8agambUMWHHjvrbt2z5ONbYuAk7HlSJRJzGxk1s2bI8tmNH/e3ABJdGMplGDK7qdGmEULDOeDxJS0sr27Y18umnm5k/fyVvv72QhQsX8umnCzzXmUgkDly9esXPXn/99daPPlqUChljicbGRj76aBGvv/566+rVK36WSCQO9ELnuHHjliQSiYNWrfrk9jfeeL114cKlNDY2k0gkcm7sTCbFwDQ2NrNw4VLeeOP11lWrPrk9kUgcNG7cOKc6M4Uv2JD2elubhzb1UDak/X9dhjQ2t/l/Jg8TO8PlTI1FQxudmUh/P5Yt3UTis4jFdQ4bRk915vnd2qPOotbPrEJ79hzeDFy7ceOi3zc2brqmsXHzOeXl1dXRaCei0UrC4WgqND2JRIJEIkYs1kwstp2WlsYmSP4duK1A7zJbM17AtclkwpFOCvPacl3n7NkfBUHn95qaGu9dvHjB1KVLF5/ds2fvqt69e9OtWxeqq6soKyv7bHqssbGJLVvqWL9+PRs3rm9OJOIPJBKJW0KhkKc6R48e3VxbW3vt7Nmzf79kyYKpy5aJzr59+9K1axeqqqooK4sYnXGamprYurWOtWvXfqYzHo/fcvDBBy+ur3dlDe0B4IK0h/8tdo2Vtg14Gjg5bXrhWWBL2jUvmYe5j/n/duDJNvksM2lPSM1Smryt8hDwtbT/rwX+16bxeQE4Ju29D4AFaf9/BPhhm3T/GgoliSdCJBIhQqHkQgjNZdczZF4Mgs42/1+IhBpq7zqLWj9Dr732oSWVGzcuqgFOBI4ExiNHgXZN61EtB+YArwDP9Ow5vMFKuo890p07fpH9qN4pV6wF4PAjZ1stUFs621js7K1vUwVnnT056+cPPvAvACqrdpS8zlAoRDKZJBwOk0gkbOkMh8MNiUTiszSc6sxH/wGDHNXPVSs/yZtHLp1p9bQ/cAdwGLAIOXnxjTaX7WOu2Q+YB1wOzG8zw/BN4BpTPx4Brmd3J4pDgNuB4cBMYModv+i7ykp5TblibYVpdA4HVgFnAR+1uawbcs7954y+s8216ZwN3Gx0PgR8Z/v2MHv2j3Hc5K0kEhCPhwYCjyIHyP0POGfixFGbvdS5vSG8qv/AFo6bXEc8DvF4aDedGbJzVWcsFvooGk0y+YSt9OjRSlNTuKDydFPnrFnzi1o/Q9+9fE034H7gWKwdL9oCPAycf/qXN7cYY1GJnEP9lSxziW1pNVb+bKDOiqExlaognUDLhIPfAzmWtGCdFhtGRzrNe6rTBZ39BwxqMcbEM52KouQnDPwCmIz1M6zLzVDx+sce6c5jj3QH+IF5L2oxjTKT5502tBasM+091dmBdK5a+UlqxOKHTkVRchiaQrtr6fcd50Iabl6rOlWn3zoVRclhaHoWeG+ftNdupJEP1ak6g6xTUZQchkZRlCzo+oyiqKFRFEVR1NAoiqIoamgURVEURQ2NoiiKooZGURRFUdTQKIqiKGpoFEVRlHZlaOoKvDc9mJsbaeRDdarOIOtUFCWHoXm0wHsfS3vtRhr5UJ2qM8g6FUXJQhlwFVALfAFrx3a2mgfw9rT3bgX6IefXWwl+mEDOUvieDa2qU3UGWaeiKDkMTR0SPt0JLcC3zJ9XqE7VGWSdiqLkMDQdgrdm7+c4jbPO9jZ9t/BDpznfR1EUxZKh6QLci/WpiTgyNXE5Ow/AKgfuAk6zODWRRA6WuhjrC7WqU3UGWaeiKDkMzQzgTJv3XYwcRXqT+f9U4CKbaXwFOafa6n2qU3UGWaeiKFkIA2cUeO/paa/dSCMfqlN1Blmnoig5DE2XAu/t3mZ6w2ka+VCdqjPIOhVFyWFoFEVRFEUNjaIoiqKGRlEURVHU0CiKoihqaBRFURQ1NIqiKIqihkZRFEVRQ6MoiqJ0BEOzscB716W9diONfKhO1RlknYqi5DA0/yrw3mfTXj/nQhr5UJ2qM8g6FUXJYWguNw9zq8V7WoC/Ajenvfdj4G/sjJabj1bzEE+xoVV1qs4g61QUJQv/PwAlukJhy2ScjQAAAABJRU5ErkJggg==";return cfIconsImg;}function getBorderFix(){return[-1,0,0,-1];}function setLineDash(canvasborder,type,hv,moveX,moveY,toX,toY){var borderType={"0":"none","1":"Thin","2":"Hair","3":"Dotted","4":"Dashed","5":"DashDot","6":"DashDotDot","7":"Double","8":"Medium","9":"MediumDashed","10":"MediumDashDot","11":"MediumDashDotDot","12":"SlantedDashDot","13":"Thick"};type=borderType[type.toString()];try{if(type==="Hair"){canvasborder.setLineDash([1,2]);}else if(type.indexOf("DashDotDot")>-1){canvasborder.setLineDash([2,2,5,2,2]);}else if(type.indexOf("DashDot")>-1){canvasborder.setLineDash([2,5,2]);}else if(type.indexOf("Dotted")>-1){canvasborder.setLineDash([2]);}else if(type.indexOf("Dashed")>-1){canvasborder.setLineDash([3]);}else{canvasborder.setLineDash([0]);}}catch(e){console.error(e);}canvasborder.beginPath();if(type.indexOf("Medium")>-1){if(hv==="h"){canvasborder.moveTo(moveX,moveY-0.5);canvasborder.lineTo(toX,toY-0.5);}else{canvasborder.moveTo(moveX-0.5,moveY);canvasborder.lineTo(toX-0.5,toY);}canvasborder.lineWidth=2;}else if(type==="Thick"){canvasborder.moveTo(moveX,moveY);canvasborder.lineTo(toX,toY);canvasborder.lineWidth=3;}else{canvasborder.moveTo(moveX,moveY);canvasborder.lineTo(toX,toY);canvasborder.lineWidth=1;}}var Canvas=/*#__PURE__*/function(){function Canvas(canvasElement,ctx){index_esm_classCallCheck(this,Canvas);this.canvasElement=void 0;this.sheetCtx=void 0;this.measureTextCacheTimeOut=void 0;this.cellOverflowMapCache=void 0;this.canvasElement=canvasElement;this.sheetCtx=ctx;this.cellOverflowMapCache={};}index_esm_createClass(Canvas,[{key:"drawRowHeader",value:function drawRowHeader(scrollHeight,drawHeight,offsetTop){if(lodash_default().isNil(drawHeight)){var _this$sheetCtx$luckys=index_esm_slicedToArray(this.sheetCtx.luckysheetTableContentHW,2);drawHeight=_this$sheetCtx$luckys[1];}if(lodash_default().isNil(offsetTop)){offsetTop=this.sheetCtx.columnHeaderHeight;}var renderCtx=this.canvasElement.getContext("2d");if(!renderCtx)return;renderCtx.save();renderCtx.scale(this.sheetCtx.devicePixelRatio,this.sheetCtx.devicePixelRatio);renderCtx.clearRect(0,offsetTop,this.sheetCtx.rowHeaderWidth-1,drawHeight);renderCtx.font=defaultFont(this.sheetCtx.defaultFontSize);renderCtx.textBaseline=defaultStyle.textBaseline;renderCtx.fillStyle=defaultStyle.fillStyle;var dataset_row_st;var dataset_row_ed;dataset_row_st=lodash_default().sortedIndex(this.sheetCtx.visibledatarow,scrollHeight);dataset_row_ed=lodash_default().sortedIndex(this.sheetCtx.visibledatarow,scrollHeight+drawHeight);if(dataset_row_st===-1){dataset_row_st=0;}if(dataset_row_ed===-1){dataset_row_ed=this.sheetCtx.visibledatarow.length-1;}renderCtx.save();renderCtx.beginPath();renderCtx.rect(0,offsetTop-1,this.sheetCtx.rowHeaderWidth-1,drawHeight-2);renderCtx.clip();var end_r;var start_r;var bodrder05=0.5;var preEndR;for(var r=dataset_row_st;r<=dataset_row_ed;r+=1){var _this$sheetCtx$hooks$,_this$sheetCtx$hooks,_this$sheetCtx$config,_this$sheetCtx$config2,_this$sheetCtx$config3,_this$sheetCtx$config4,_this$sheetCtx$hooks$2,_this$sheetCtx$hooks2;if(r===0){start_r=-scrollHeight-1;}else{start_r=this.sheetCtx.visibledatarow[r-1]-scrollHeight-1;}end_r=this.sheetCtx.visibledatarow[r]-scrollHeight;var firstOffset=dataset_row_st===r?-2:0;var lastOffset=dataset_row_ed===r?-2:0;if(((_this$sheetCtx$hooks$=(_this$sheetCtx$hooks=this.sheetCtx.hooks).beforeRenderRowHeaderCell)===null||_this$sheetCtx$hooks$===void 0?void 0:_this$sheetCtx$hooks$.call(_this$sheetCtx$hooks,"".concat(r+1),r,start_r+offsetTop+firstOffset,this.sheetCtx.rowHeaderWidth-1,end_r-start_r+1+lastOffset-firstOffset,renderCtx))===false){continue;}if(((_this$sheetCtx$config=this.sheetCtx.config)===null||_this$sheetCtx$config===void 0?void 0:(_this$sheetCtx$config2=_this$sheetCtx$config.rowhidden)===null||_this$sheetCtx$config2===void 0?void 0:_this$sheetCtx$config2[r])==null){renderCtx.fillStyle="#ffffff";renderCtx.fillRect(0,start_r+offsetTop+firstOffset,this.sheetCtx.rowHeaderWidth-1,end_r-start_r+1+lastOffset-firstOffset);renderCtx.fillStyle="#000000";renderCtx.save();renderCtx.scale(this.sheetCtx.zoomRatio,this.sheetCtx.zoomRatio);var textMetrics=getMeasureText(r+1,renderCtx,this.sheetCtx);var horizonAlignPos=(this.sheetCtx.rowHeaderWidth-textMetrics.width)/2;var verticalAlignPos=start_r+(end_r-start_r)/2+offsetTop;renderCtx.fillText("".concat(r+1),horizonAlignPos/this.sheetCtx.zoomRatio,verticalAlignPos/this.sheetCtx.zoomRatio);renderCtx.restore();}renderCtx.beginPath();renderCtx.moveTo(this.sheetCtx.rowHeaderWidth-2+bodrder05,start_r+offsetTop-2);renderCtx.lineTo(this.sheetCtx.rowHeaderWidth-2+bodrder05,end_r+offsetTop-2);renderCtx.lineWidth=1;renderCtx.strokeStyle=defaultStyle.strokeStyle;renderCtx.stroke();renderCtx.closePath();if(this.sheetCtx.config.rowhidden&&this.sheetCtx.config.rowhidden[r]==null&&this.sheetCtx.config.rowhidden[r+1]!=null){renderCtx.beginPath();renderCtx.moveTo(-1,end_r+offsetTop-4+bodrder05);renderCtx.lineTo(this.sheetCtx.rowHeaderWidth-1,end_r+offsetTop-4+bodrder05);renderCtx.closePath();renderCtx.stroke();}else if(this.sheetCtx.config.rowhidden==null||this.sheetCtx.config.rowhidden[r]==null){renderCtx.beginPath();renderCtx.moveTo(-1,end_r+offsetTop-2+bodrder05);renderCtx.lineTo(this.sheetCtx.rowHeaderWidth-1,end_r+offsetTop-2+bodrder05);renderCtx.closePath();renderCtx.stroke();}if(((_this$sheetCtx$config3=this.sheetCtx.config)===null||_this$sheetCtx$config3===void 0?void 0:(_this$sheetCtx$config4=_this$sheetCtx$config3.rowhidden)===null||_this$sheetCtx$config4===void 0?void 0:_this$sheetCtx$config4[r-1])!=null&&preEndR!==undefined){renderCtx.beginPath();renderCtx.moveTo(-1,preEndR+offsetTop+bodrder05);renderCtx.lineTo(this.sheetCtx.rowHeaderWidth-1,preEndR+offsetTop+bodrder05);renderCtx.closePath();renderCtx.stroke();}preEndR=end_r;(_this$sheetCtx$hooks$2=(_this$sheetCtx$hooks2=this.sheetCtx.hooks).afterRenderRowHeaderCell)===null||_this$sheetCtx$hooks$2===void 0?void 0:_this$sheetCtx$hooks$2.call(_this$sheetCtx$hooks2,"".concat(r+1),r,start_r+offsetTop+firstOffset,this.sheetCtx.rowHeaderWidth-1,end_r-start_r+1+lastOffset-firstOffset,renderCtx);}renderCtx.restore();renderCtx.restore();}},{key:"drawColumnHeader",value:function drawColumnHeader(scrollWidth,drawWidth,offsetLeft){if(drawWidth===undefined){var _this$sheetCtx$luckys2=index_esm_slicedToArray(this.sheetCtx.luckysheetTableContentHW,1);drawWidth=_this$sheetCtx$luckys2[0];}if(offsetLeft===undefined){offsetLeft=this.sheetCtx.rowHeaderWidth;}var renderCtx=this.canvasElement.getContext("2d");if(!renderCtx)return;renderCtx.save();renderCtx.scale(this.sheetCtx.devicePixelRatio,this.sheetCtx.devicePixelRatio);renderCtx.clearRect(offsetLeft,0,drawWidth,this.sheetCtx.columnHeaderHeight-1);renderCtx.font=defaultFont(this.sheetCtx.defaultFontSize);renderCtx.textBaseline=defaultStyle.textBaseline;renderCtx.fillStyle=defaultStyle.fillStyle;var dataset_col_st;var dataset_col_ed;dataset_col_st=lodash_default().sortedIndex(this.sheetCtx.visibledatacolumn,scrollWidth);dataset_col_ed=lodash_default().sortedIndex(this.sheetCtx.visibledatacolumn,scrollWidth+drawWidth);if(dataset_col_st===-1){dataset_col_st=0;}if(dataset_col_ed===-1){dataset_col_ed=this.sheetCtx.visibledatacolumn.length-1;}renderCtx.save();renderCtx.beginPath();renderCtx.rect(offsetLeft-1,0,drawWidth,this.sheetCtx.columnHeaderHeight-1);renderCtx.clip();var end_c;var start_c;var bodrder05=0.5;var preEndC;for(var c=dataset_col_st;c<=dataset_col_ed;c+=1){var _this$sheetCtx$hooks$3,_this$sheetCtx$hooks3,_this$sheetCtx$config5,_this$sheetCtx$config6,_this$sheetCtx$config7,_this$sheetCtx$config8,_this$sheetCtx$hooks$4,_this$sheetCtx$hooks4;if(c===0){start_c=-scrollWidth;}else{start_c=this.sheetCtx.visibledatacolumn[c-1]-scrollWidth;}end_c=this.sheetCtx.visibledatacolumn[c]-scrollWidth;var abc=indexToColumnChar(c);if(((_this$sheetCtx$hooks$3=(_this$sheetCtx$hooks3=this.sheetCtx.hooks).beforeRenderColumnHeaderCell)===null||_this$sheetCtx$hooks$3===void 0?void 0:_this$sheetCtx$hooks$3.call(_this$sheetCtx$hooks3,abc,c,start_c+offsetLeft-1,end_c-start_c,this.sheetCtx.columnHeaderHeight-1,renderCtx))===false){continue;}if(((_this$sheetCtx$config5=this.sheetCtx.config)===null||_this$sheetCtx$config5===void 0?void 0:(_this$sheetCtx$config6=_this$sheetCtx$config5.colhidden)===null||_this$sheetCtx$config6===void 0?void 0:_this$sheetCtx$config6[c])==null){renderCtx.fillStyle="#ffffff";renderCtx.fillRect(start_c+offsetLeft-1,0,end_c-start_c,this.sheetCtx.columnHeaderHeight-1);renderCtx.fillStyle="#000000";renderCtx.save();renderCtx.scale(this.sheetCtx.zoomRatio,this.sheetCtx.zoomRatio);var textMetrics=getMeasureText(abc,renderCtx,this.sheetCtx);var horizonAlignPos=Math.round(start_c+(end_c-start_c)/2+offsetLeft-textMetrics.width/2);var verticalAlignPos=Math.round(this.sheetCtx.columnHeaderHeight/2);renderCtx.fillText(abc,horizonAlignPos/this.sheetCtx.zoomRatio,verticalAlignPos/this.sheetCtx.zoomRatio);renderCtx.restore();}if(this.sheetCtx.config.colhidden&&this.sheetCtx.config.colhidden[c]!=null&&this.sheetCtx.config.colhidden[c+1]!=null){renderCtx.beginPath();renderCtx.moveTo(end_c+offsetLeft-4+bodrder05,0);renderCtx.lineTo(end_c+offsetLeft-4+bodrder05,this.sheetCtx.columnHeaderHeight-2);renderCtx.lineWidth=1;renderCtx.strokeStyle=defaultStyle.strokeStyle;renderCtx.closePath();renderCtx.stroke();}else if(this.sheetCtx.config.colhidden==null||this.sheetCtx.config.colhidden[c]==null){renderCtx.beginPath();renderCtx.moveTo(end_c+offsetLeft-2+bodrder05,0);renderCtx.lineTo(end_c+offsetLeft-2+bodrder05,this.sheetCtx.columnHeaderHeight-2);renderCtx.lineWidth=1;renderCtx.strokeStyle=defaultStyle.strokeStyle;renderCtx.closePath();renderCtx.stroke();}if(((_this$sheetCtx$config7=this.sheetCtx.config)===null||_this$sheetCtx$config7===void 0?void 0:(_this$sheetCtx$config8=_this$sheetCtx$config7.colhidden)===null||_this$sheetCtx$config8===void 0?void 0:_this$sheetCtx$config8[c-1])!=null&&preEndC!==undefined){renderCtx.beginPath();renderCtx.moveTo(preEndC+offsetLeft+bodrder05,0);renderCtx.lineTo(preEndC+offsetLeft+bodrder05,this.sheetCtx.columnHeaderHeight-2);renderCtx.closePath();renderCtx.stroke();}renderCtx.beginPath();renderCtx.moveTo(start_c+offsetLeft-1,this.sheetCtx.columnHeaderHeight-2+bodrder05);renderCtx.lineTo(end_c+offsetLeft-1,this.sheetCtx.columnHeaderHeight-2+bodrder05);renderCtx.stroke();renderCtx.closePath();preEndC=end_c;(_this$sheetCtx$hooks$4=(_this$sheetCtx$hooks4=this.sheetCtx.hooks).afterRenderColumnHeaderCell)===null||_this$sheetCtx$hooks$4===void 0?void 0:_this$sheetCtx$hooks$4.call(_this$sheetCtx$hooks4,abc,c,start_c+offsetLeft-1,end_c-start_c,this.sheetCtx.columnHeaderHeight-1,renderCtx);}renderCtx.restore();renderCtx.restore();}},{key:"drawMain",value:function drawMain(_ref){var _this$sheetCtx$hooks$5,_this$sheetCtx$hooks5,_this$sheetCtx$config15,_this$sheetCtx$config16,_this$sheetCtx$config17,_this=this;var scrollWidth=_ref.scrollWidth,scrollHeight=_ref.scrollHeight,drawWidth=_ref.drawWidth,drawHeight=_ref.drawHeight,offsetLeft=_ref.offsetLeft,offsetTop=_ref.offsetTop,columnOffsetCell=_ref.columnOffsetCell,rowOffsetCell=_ref.rowOffsetCell,clear=_ref.clear;var flowdata=getFlowdata(this.sheetCtx);if(lodash_default().isNil(flowdata)){return;}clearTimeout(this.measureTextCacheTimeOut);if(drawWidth===undefined){var _this$sheetCtx$luckys3=index_esm_slicedToArray(this.sheetCtx.luckysheetTableContentHW,1);drawWidth=_this$sheetCtx$luckys3[0];}if(drawHeight===undefined){var _this$sheetCtx$luckys4=index_esm_slicedToArray(this.sheetCtx.luckysheetTableContentHW,2);drawHeight=_this$sheetCtx$luckys4[1];}if(offsetLeft===undefined){offsetLeft=this.sheetCtx.rowHeaderWidth;}if(offsetTop===undefined){offsetTop=this.sheetCtx.columnHeaderHeight;}if(columnOffsetCell===undefined){columnOffsetCell=0;}if(rowOffsetCell===undefined){rowOffsetCell=0;}var renderCtx=this.canvasElement.getContext("2d");if(!renderCtx)return;renderCtx.save();renderCtx.scale(this.sheetCtx.devicePixelRatio,this.sheetCtx.devicePixelRatio);if(clear){renderCtx.clearRect(0,0,this.sheetCtx.luckysheetTableContentHW[0],this.sheetCtx.luckysheetTableContentHW[1]);}var rowStart;var rowEnd;var colStart;var colEnd;rowStart=lodash_default().sortedIndex(this.sheetCtx.visibledatarow,scrollHeight);rowEnd=lodash_default().sortedIndex(this.sheetCtx.visibledatarow,scrollHeight+drawHeight);if(rowStart===-1){rowStart=0;}rowStart+=rowOffsetCell;if(rowEnd===-1){rowEnd=this.sheetCtx.visibledatarow.length-1;}rowEnd+=rowOffsetCell;if(rowEnd>=this.sheetCtx.visibledatarow.length){rowEnd=this.sheetCtx.visibledatarow.length-1;}colStart=lodash_default().sortedIndex(this.sheetCtx.visibledatacolumn,scrollWidth);colEnd=lodash_default().sortedIndex(this.sheetCtx.visibledatacolumn,scrollWidth+drawWidth);if(colStart===-1){colStart=0;}colStart+=columnOffsetCell;if(colEnd===-1){colEnd=this.sheetCtx.visibledatacolumn.length-1;}colEnd+=columnOffsetCell;if(colEnd>=this.sheetCtx.visibledatacolumn.length){colEnd=this.sheetCtx.visibledatacolumn.length-1;}var rowEndY=this.sheetCtx.visibledatarow[rowEnd];var colEndX=this.sheetCtx.visibledatacolumn[colEnd];renderCtx.fillStyle="#ffffff";renderCtx.fillRect(offsetLeft-1,offsetTop-1,colEndX-scrollWidth,rowEndY-scrollHeight);renderCtx.font=defaultFont(this.sheetCtx.defaultFontSize);renderCtx.fillStyle=defaultStyle.fillStyle;var cellupdate=[];var mergeCache={};var borderOffset={};var bodrder05=0.5;(_this$sheetCtx$hooks$5=(_this$sheetCtx$hooks5=this.sheetCtx.hooks).beforeRenderCellArea)===null||_this$sheetCtx$hooks$5===void 0?void 0:_this$sheetCtx$hooks$5.call(_this$sheetCtx$hooks5,flowdata,renderCtx);for(var r=rowStart;r<=rowEnd;r+=1){var _this$sheetCtx$config9,_this$sheetCtx$config10;var startY=void 0;if(r===0){startY=-scrollHeight-1;}else{startY=this.sheetCtx.visibledatarow[r-1]-scrollHeight-1;}var endY=this.sheetCtx.visibledatarow[r]-scrollHeight;if(((_this$sheetCtx$config9=this.sheetCtx.config)===null||_this$sheetCtx$config9===void 0?void 0:(_this$sheetCtx$config10=_this$sheetCtx$config9.rowhidden)===null||_this$sheetCtx$config10===void 0?void 0:_this$sheetCtx$config10[r])!=null){continue;}for(var c=colStart;c<=colEnd;c+=1){var _this$sheetCtx$config11,_this$sheetCtx$config12,_this$sheetCtx$config13,_this$sheetCtx$config14,_flowdata$r;var startX=void 0;if(c===0){startX=-scrollWidth;}else{startX=this.sheetCtx.visibledatacolumn[c-1]-scrollWidth;}var endX=this.sheetCtx.visibledatacolumn[c]-scrollWidth;if(((_this$sheetCtx$config11=this.sheetCtx.config)===null||_this$sheetCtx$config11===void 0?void 0:(_this$sheetCtx$config12=_this$sheetCtx$config11.colhidden)===null||_this$sheetCtx$config12===void 0?void 0:_this$sheetCtx$config12[c])!=null){continue;}var firstcolumnlen=this.sheetCtx.defaultcollen;if((_this$sheetCtx$config13=this.sheetCtx.config)===null||_this$sheetCtx$config13===void 0?void 0:(_this$sheetCtx$config14=_this$sheetCtx$config13.columnlen)===null||_this$sheetCtx$config14===void 0?void 0:_this$sheetCtx$config14[c]){firstcolumnlen=this.sheetCtx.config.columnlen[c];}if(flowdata===null||flowdata===void 0?void 0:(_flowdata$r=flowdata[r])===null||_flowdata$r===void 0?void 0:_flowdata$r[c]){var value=flowdata[r][c];if(value===null||value===void 0?void 0:value.mc){borderOffset["".concat(r,"_").concat(c)]={startY:startY,startX:startX,endY:endY,endX:endX};if("rs"in value.mc){var key="r".concat(r,"c").concat(c);mergeCache[key]=cellupdate.length;}else{var _key="r".concat(value.mc.r,"c").concat(value.mc.c);var margeMain=cellupdate[mergeCache[_key]];if(lodash_default().isNil(margeMain)){mergeCache[_key]=cellupdate.length;cellupdate.push({r:r,c:c,startX:startX,startY:startY,endY:endY,endX:endX,firstcolumnlen:firstcolumnlen});}else{if(margeMain.c===c){margeMain.endY+=endY-startY-1;}if(margeMain.r===r){margeMain.endX+=endX-startX;margeMain.firstcolumnlen+=firstcolumnlen;}}continue;}}}cellupdate.push({r:r,c:c,startY:startY,startX:startX,endY:endY,endX:endX,firstcolumnlen:firstcolumnlen});borderOffset["".concat(r,"_").concat(c)]={startY:startY,startX:startX,endY:endY,endX:endX};}}var dynamicArrayCompute={};var afCompute={};var cfCompute=getComputeMap(this.sheetCtx);var cellOverflowMap=this.getCellOverflowMap(renderCtx,colStart,colEnd,rowStart,rowEnd);var mcArr=[];for(var cud=0;cud<cellupdate.length;cud+=1){var item=cellupdate[cud];var _r=item.r;var _c=item.c;var _startY=item.startY;var _startX=item.startX;var _endY=item.endY;var _endX=item.endX;if(lodash_default().isNil(flowdata[_r])){continue;}if(lodash_default().isNil(flowdata[_r][_c])){this.nullCellRender(_r,_c,_startY,_startX,_endY,_endX,renderCtx,afCompute,cfCompute,offsetLeft,offsetTop,dynamicArrayCompute,cellOverflowMap,colStart,colEnd,scrollHeight,scrollWidth,bodrder05);}else{var cell=flowdata[_r][_c];var _value2=null;if(cell===null||cell===void 0?void 0:cell.mc){mcArr.push(cellupdate[cud]);}else{_value2=getRealCellValue(_r,_c,flowdata);}if(lodash_default().isNil(_value2)||_value2.toString().length===0){this.nullCellRender(_r,_c,_startY,_startX,_endY,_endX,renderCtx,afCompute,cfCompute,offsetLeft,offsetTop,dynamicArrayCompute,cellOverflowMap,colStart,colEnd,scrollHeight,scrollWidth,bodrder05);}else{if("".concat(_r,"_").concat(_c)in dynamicArrayCompute){_value2=dynamicArrayCompute["".concat(_r,"_").concat(_c)].v;}this.cellRender(_r,_c,_startY,_startX,_endY,_endX,_value2,renderCtx,afCompute,cfCompute,offsetLeft,offsetTop,dynamicArrayCompute,cellOverflowMap,colStart,colEnd,scrollHeight,scrollWidth,bodrder05);}}}for(var m=0;m<mcArr.length;m+=1){var _mainCell$mc,_mainCell$mc2;var _item=mcArr[m];var _r2=_item.r;var _c2=_item.c;var _startY2=_item.startY;var _startX2=_item.startX;var _endY2=_item.endY-1;var _endX2=_item.endX-1;var _cell=flowdata[_r2][_c2];if(!_cell)continue;var _value3=null;var mergeMaindata=_cell.mc;if(!mergeMaindata)continue;_value3=getRealCellValue(mergeMaindata.r,mergeMaindata.c,flowdata);_r2=mergeMaindata.r;_c2=mergeMaindata.c;var mainCell=flowdata[_r2][_c2];if(!(mainCell===null||mainCell===void 0?void 0:(_mainCell$mc=mainCell.mc)===null||_mainCell$mc===void 0?void 0:_mainCell$mc.rs)||!((_mainCell$mc2=mainCell.mc)===null||_mainCell$mc2===void 0?void 0:_mainCell$mc2.cs)){continue;}if(_c2===0){_startX2=-scrollWidth;}else{_startX2=this.sheetCtx.visibledatacolumn[_c2-1]-scrollWidth;}if(_r2===0){_startY2=-scrollHeight-1;}else{_startY2=this.sheetCtx.visibledatarow[_r2-1]-scrollHeight-1;}_endY2=this.sheetCtx.visibledatarow[_r2+mainCell.mc.rs-1]-scrollHeight;_endX2=this.sheetCtx.visibledatacolumn[_c2+mainCell.mc.cs-1]-scrollWidth;if(lodash_default().isNil(_value3)||_value3.toString().length===0){this.nullCellRender(_r2,_c2,_startY2,_startX2,_endY2,_endX2,renderCtx,afCompute,cfCompute,offsetLeft,offsetTop,dynamicArrayCompute,cellOverflowMap,colStart,colEnd,scrollHeight,scrollWidth,bodrder05,true);}else{if("".concat(_r2,"_").concat(_c2)in dynamicArrayCompute){_value3=dynamicArrayCompute["".concat(_r2,"_").concat(_c2)].v;}this.cellRender(_r2,_c2,_startY2,_startX2,_endY2,_endX2,_value3,renderCtx,afCompute,cfCompute,offsetLeft,offsetTop,dynamicArrayCompute,cellOverflowMap,colStart,colEnd,scrollHeight,scrollWidth,bodrder05,true);}}if(((_this$sheetCtx$config15=(_this$sheetCtx$config16=this.sheetCtx.config)===null||_this$sheetCtx$config16===void 0?void 0:(_this$sheetCtx$config17=_this$sheetCtx$config16.borderInfo)===null||_this$sheetCtx$config17===void 0?void 0:_this$sheetCtx$config17.length)!==null&&_this$sheetCtx$config15!==void 0?_this$sheetCtx$config15:0)>0){var borderSlashRender=function borderSlashRender(style,color,startY,startX,endY,endX,_offsetLeft,_offsetTop,canvas){var linetype=style;var moveX=startX-2+bodrder05+_offsetLeft;var moveY=startY+_offsetTop;var toX=endX-2+bodrder05+_offsetLeft;var toY=endY-2+bodrder05+_offsetTop;canvas.save();setLineDash(canvas,linetype,"v",moveX,moveY,toX,toY);canvas.strokeStyle=color;canvas.stroke();canvas.closePath();canvas.restore();};var borderLeftRender=function borderLeftRender(style,color,startY,startX,endY,endX,_offsetLeft,_offsetTop,canvas){var linetype=style;var moveX=startX-2+bodrder05+_offsetLeft;var moveY=startY+_offsetTop-1;var toX=startX-2+bodrder05+_offsetLeft;var toY=endY-2+bodrder05+_offsetTop;canvas.save();setLineDash(canvas,linetype,"v",moveX,moveY,toX,toY);canvas.strokeStyle=color;canvas.stroke();canvas.closePath();canvas.restore();};var borderRightRender=function borderRightRender(style,color,startY,startX,endY,endX,_offsetLeft,_offsetTop,canvas){var linetype=style;var moveX=endX-2+bodrder05+_offsetLeft;var moveY=startY+_offsetTop-1;var toX=endX-2+bodrder05+_offsetLeft;var toY=endY-2+bodrder05+_offsetTop;canvas.save();setLineDash(canvas,linetype,"v",moveX,moveY,toX,toY);canvas.strokeStyle=color;canvas.stroke();canvas.closePath();canvas.restore();};var borderBottomRender=function borderBottomRender(style,color,startY,startX,endY,endX,_offsetLeft,_offsetTop,canvas){var linetype=style;var moveX=startX-2+bodrder05+_offsetLeft;var moveY=endY-2+bodrder05+_offsetTop;var toX=endX-2+bodrder05+_offsetLeft;var toY=endY-2+bodrder05+_offsetTop;canvas.save();setLineDash(canvas,linetype,"h",moveX,moveY,toX,toY);canvas.strokeStyle=color;canvas.stroke();canvas.closePath();canvas.restore();};var borderTopRender=function borderTopRender(style,color,startY,startX,endY,endX,_offsetLeft,_offsetTop,canvas){var linetype=style;var moveX=startX-2+bodrder05+_offsetLeft;var moveY=startY-1+bodrder05+_offsetTop;var toX=endX-2+bodrder05+_offsetLeft;var toY=startY-1+bodrder05+_offsetTop;canvas.save();setLineDash(canvas,linetype,"h",moveX,moveY,toX,toY);canvas.strokeStyle=color;canvas.stroke();canvas.closePath();canvas.restore();};var borderInfoCompute=getBorderInfoComputeRange(this.sheetCtx,rowStart,rowEnd,colStart,colEnd);Object.keys(borderInfoCompute).forEach(function(x){var bdRow=Number(x.substring(0,x.indexOf("_")));var bdCol=Number(x.substring(x.indexOf("_")+1));if(borderOffset["".concat(bdRow,"_").concat(bdCol)]){var _startY3=borderOffset["".concat(bdRow,"_").concat(bdCol)].startY;var _startX3=borderOffset["".concat(bdRow,"_").concat(bdCol)].startX;var _endY3=borderOffset["".concat(bdRow,"_").concat(bdCol)].endY;var _endX3=borderOffset["".concat(bdRow,"_").concat(bdCol)].endX;var cellOverflow_colInObj=_this.cellOverflow_colIn(cellOverflowMap,bdRow,bdCol,colStart,colEnd);var borderSlash=borderInfoCompute[x].s;if(borderSlash&&(!cellOverflow_colInObj.colIn||cellOverflow_colInObj.stc===bdCol)){var _mergeCellEndY,_mergeCellEndX;var mergeMap=_this.sheetCtx.config.merge;var mergeCell=mergeMap===null||mergeMap===void 0?void 0:mergeMap["".concat(bdRow,"_").concat(bdCol)];var mergeCellEndX;var mergeCellEndY;if(mergeCell){var mergeCellOffset=borderOffset["".concat(bdRow+mergeCell.rs-1,"_").concat(bdCol+mergeCell.cs-1)];mergeCellEndX=mergeCellOffset.endX;mergeCellEndY=mergeCellOffset.endY;}borderSlashRender(borderSlash.style,borderSlash.color,_startY3,_startX3,(_mergeCellEndY=mergeCellEndY)!==null&&_mergeCellEndY!==void 0?_mergeCellEndY:_endY3,(_mergeCellEndX=mergeCellEndX)!==null&&_mergeCellEndX!==void 0?_mergeCellEndX:_endX3,offsetLeft,offsetTop,renderCtx);}var borderLeft=borderInfoCompute[x].l;if(borderLeft&&(!cellOverflow_colInObj.colIn||cellOverflow_colInObj.stc===bdCol)){borderLeftRender(borderLeft.style,borderLeft.color,_startY3,_startX3,_endY3,_endX3,offsetLeft,offsetTop,renderCtx);}var borderRight=borderInfoCompute[x].r;if(borderRight&&(!cellOverflow_colInObj.colIn||cellOverflow_colInObj.colLast)){borderRightRender(borderRight.style,borderRight.color,_startY3,_startX3,_endY3,_endX3,offsetLeft,offsetTop,renderCtx);}var borderTop=borderInfoCompute[x].t;if(borderTop){borderTopRender(borderTop.style,borderTop.color,_startY3,_startX3,_endY3,_endX3,offsetLeft,offsetTop,renderCtx);}var borderBottom=borderInfoCompute[x].b;if(borderBottom){borderBottomRender(borderBottom.style,borderBottom.color,_startY3,_startX3,_endY3,_endX3,offsetLeft,offsetTop,renderCtx);}}});}if(colEnd===this.sheetCtx.visibledatacolumn.length-1){renderCtx.clearRect(colEndX-scrollWidth+offsetLeft-1,offsetTop-1,this.sheetCtx.ch_width-this.sheetCtx.visibledatacolumn[colEnd],rowEndY-scrollHeight);}renderCtx.restore();this.measureTextCacheTimeOut=setTimeout(function(){clearMeasureTextCache();_this.cellOverflowMapCache={};},100);}},{key:"getCellOverflowMap",value:function getCellOverflowMap(canvas,colStart,colEnd,rowStart,rowEnd){var flowdata=getFlowdata(this.sheetCtx);var map={};var data=flowdata;if(!data){return map;}for(var r=rowStart;r<=rowEnd;r+=1){if(lodash_default().isNil(data[r])){continue;}if(this.cellOverflowMapCache[r]){map[r]=this.cellOverflowMapCache[r];continue;}var hasCellOver=false;for(var c=0;c<data[r].length;c+=1){var _this$sheetCtx$config18,_this$sheetCtx$config19;var cell=data[r][c];if(((_this$sheetCtx$config18=this.sheetCtx.config)===null||_this$sheetCtx$config18===void 0?void 0:(_this$sheetCtx$config19=_this$sheetCtx$config18.colhidden)===null||_this$sheetCtx$config19===void 0?void 0:_this$sheetCtx$config19[c])!=null){continue;}if(cell&&(!lodash_default().isEmpty(cell.v)||isInlineStringCell(cell))&&lodash_default().isNil(cell.mc)&&cell.tb==="1"){var horizonAlign=normalizedAttr(data,r,c,"ht");var textMetricsObj=getCellTextInfo(cell,canvas,this.sheetCtx,{r:r,c:c});var textMetrics=0;if(textMetricsObj){textMetrics=textMetricsObj.textWidthAll;}var startX=c-1<0?0:this.sheetCtx.visibledatacolumn[c-1];var endX=this.sheetCtx.visibledatacolumn[c];var stc=void 0;var edc=void 0;if(endX-startX<textMetrics){if(horizonAlign==="0"){var trace_forward=this.cellOverflow_trace(r,c,c-1,"forward",horizonAlign,textMetrics);var trace_backward=this.cellOverflow_trace(r,c,c+1,"backward",horizonAlign,textMetrics);if(trace_forward.success){stc=trace_forward.c;}else{stc=trace_forward.c+1;}if(trace_backward.success){edc=trace_backward.c;}else{edc=trace_backward.c-1;}}else if(horizonAlign==="1"){var trace=this.cellOverflow_trace(r,c,c+1,"backward",horizonAlign,textMetrics);stc=c;if(trace.success){edc=trace.c;}else{edc=trace.c-1;}}else if(horizonAlign==="2"){var _trace=this.cellOverflow_trace(r,c,c-1,"forward",horizonAlign,textMetrics);edc=c;if(_trace.success){stc=_trace.c;}else{stc=_trace.c+1;}}}else{stc=c;edc=c;}if((stc<=colEnd||edc>=colStart)&&stc<edc){var item={r:r,stc:stc,edc:edc};if(lodash_default().isNil(map[r])){map[r]={};}map[r][c]=item;hasCellOver=true;}}}if(hasCellOver){this.cellOverflowMapCache[r]=map[r];}}return map;}},{key:"nullCellRender",value:function nullCellRender(r,c,startY,startX,endY,endX,renderCtx,afCompute,cfCompute,offsetLeft,offsetTop,dynamicArrayCompute,cellOverflowMap,colStart,colEnd,scrollHeight,scrollWidth,bodrder05){var _this$sheetCtx$hooks$6,_this$sheetCtx$hooks6,_flowdata$r2,_flowdata$r2$c,_this$sheetCtx$hooks$7,_this$sheetCtx$hooks7;var isMerge=arguments.length>18&&arguments[18]!==undefined?arguments[18]:false;var checksCF=checkCF(r,c,cfCompute);var flowdata=getFlowdata(this.sheetCtx);if(!flowdata)return;var borderfix=getBorderFix();var fillStyle=normalizedAttr(flowdata,r,c,"bg");if(!lodash_default().isNil(checksCF)&&!lodash_default().isNil(checksCF.cellColor)){fillStyle=checksCF.cellColor;}if(!fillStyle){renderCtx.fillStyle="#FFFFFF";}else{renderCtx.fillStyle=fillStyle;}var cellsize=[startX+offsetLeft+borderfix[0],startY+offsetTop+borderfix[1],endX-startX+borderfix[2]-(isMerge?1:0),endY-startY+borderfix[3]];if(((_this$sheetCtx$hooks$6=(_this$sheetCtx$hooks6=this.sheetCtx.hooks).beforeRenderCell)===null||_this$sheetCtx$hooks$6===void 0?void 0:_this$sheetCtx$hooks$6.call(_this$sheetCtx$hooks6,flowdata[r][c],{row:r,column:c,startX:cellsize[0],startY:cellsize[1],endX:cellsize[2]+cellsize[0],endY:cellsize[3]+cellsize[1]},renderCtx))===false){return;}renderCtx.fillRect(cellsize[0],cellsize[1],cellsize[2],cellsize[3]);if("".concat(r,"_").concat(c)in dynamicArrayCompute){var value=dynamicArrayCompute["".concat(r,"_").concat(c)].v;renderCtx.fillStyle="#000000";var fontset=defaultFont(this.sheetCtx.defaultFontSize);renderCtx.font=fontset;var horizonAlignPos=startX+4+offsetLeft;var verticalAlignPos=endY+offsetTop-2;renderCtx.textBaseline="bottom";renderCtx.fillText(lodash_default().isNil(value)?"":value,horizonAlignPos,verticalAlignPos);}if(flowdata===null||flowdata===void 0?void 0:(_flowdata$r2=flowdata[r])===null||_flowdata$r2===void 0?void 0:(_flowdata$r2$c=_flowdata$r2[c])===null||_flowdata$r2$c===void 0?void 0:_flowdata$r2$c.ps){var ps_w=8*this.sheetCtx.zoomRatio;var ps_h=8*this.sheetCtx.zoomRatio;renderCtx.beginPath();renderCtx.moveTo(endX+offsetLeft-1-ps_w,startY+offsetTop);renderCtx.lineTo(endX+offsetLeft-1,startY+offsetTop);renderCtx.lineTo(endX+offsetLeft-1,startY+offsetTop+ps_h);renderCtx.fillStyle="#FC6666";renderCtx.fill();renderCtx.closePath();}var cellOverflow_colInObj=this.cellOverflow_colIn(cellOverflowMap,r,c,colStart,colEnd);if(cellOverflow_colInObj.colLast&&!lodash_default().isNil(cellOverflow_colInObj.rowIndex)&&!lodash_default().isNil(cellOverflow_colInObj.colIndex)&&!lodash_default().isNil(cellOverflow_colInObj.stc)&&!lodash_default().isNil(cellOverflow_colInObj.edc)){this.cellOverflowRender(cellOverflow_colInObj.rowIndex,cellOverflow_colInObj.colIndex,cellOverflow_colInObj.stc,cellOverflow_colInObj.edc,renderCtx,scrollHeight,scrollWidth,offsetLeft,offsetTop,afCompute,cfCompute);}if(!cellOverflow_colInObj.colIn||cellOverflow_colInObj.colLast){if(!this.sheetCtx.luckysheetcurrentisPivotTable&&this.sheetCtx.showGridLines){renderCtx.beginPath();renderCtx.moveTo(endX+offsetLeft-2+bodrder05,startY+offsetTop);renderCtx.lineTo(endX+offsetLeft-2+bodrder05,endY+offsetTop);renderCtx.lineWidth=1;renderCtx.strokeStyle=defaultStyle.strokeStyle;renderCtx.stroke();renderCtx.closePath();}}if(!this.sheetCtx.luckysheetcurrentisPivotTable&&this.sheetCtx.showGridLines){renderCtx.beginPath();renderCtx.moveTo(startX+offsetLeft-1,endY+offsetTop-2+bodrder05);renderCtx.lineTo(endX+offsetLeft-1,endY+offsetTop-2+bodrder05);renderCtx.lineWidth=1;renderCtx.strokeStyle=defaultStyle.strokeStyle;renderCtx.stroke();renderCtx.closePath();}(_this$sheetCtx$hooks$7=(_this$sheetCtx$hooks7=this.sheetCtx.hooks).afterRenderCell)===null||_this$sheetCtx$hooks$7===void 0?void 0:_this$sheetCtx$hooks$7.call(_this$sheetCtx$hooks7,flowdata[r][c],{row:r,column:c,startY:cellsize[1],startX:cellsize[0],endY:cellsize[3]+cellsize[1],endX:cellsize[2]+cellsize[0]},renderCtx);}},{key:"cellRender",value:function cellRender(r,c,startY,startX,endY,endX,value,renderCtx,afCompute,cfCompute,offsetLeft,offsetTop,dynamicArrayCompute,cellOverflowMap,colStart,colEnd,scrollHeight,scrollWidth,bodrder05){var _this$sheetCtx$hooks$8,_this$sheetCtx$hooks8,_dataVerification$,_this$sheetCtx$hooks$9,_this$sheetCtx$hooks9,_flowdata$r3;var isMerge=arguments.length>19&&arguments[19]!==undefined?arguments[19]:false;var flowdata=getFlowdata(this.sheetCtx);if(!flowdata){return;}var cell=flowdata[r][c];var cellWidth=endX-startX-2;var cellHeight=endY-startY-2;var space_width=2;var space_height=2;var horizonAlign=Number(normalizedAttr(flowdata,r,c,"ht"));var verticalAlign=Number(normalizedAttr(flowdata,r,c,"vt"));var checksAF={};var checksCF=checkCF(r,c,cfCompute);var fillStyle=normalizedAttr(flowdata,r,c,"bg");if(!lodash_default().isNil(checksCF)&&!lodash_default().isNil(checksCF.cellColor)){fillStyle=checksCF.cellColor;}if(!fillStyle){renderCtx.fillStyle="#FFFFFF";}else{renderCtx.fillStyle=fillStyle;}var borderfix=getBorderFix();var cellsize=[startX+offsetLeft+borderfix[0],startY+offsetTop+borderfix[1],endX-startX+borderfix[2]-(isMerge?1:0),endY-startY+borderfix[3]];if(((_this$sheetCtx$hooks$8=(_this$sheetCtx$hooks8=this.sheetCtx.hooks).beforeRenderCell)===null||_this$sheetCtx$hooks$8===void 0?void 0:_this$sheetCtx$hooks$8.call(_this$sheetCtx$hooks8,flowdata[r][c],{row:r,column:c,startY:cellsize[1],startX:cellsize[0],endY:cellsize[3]+cellsize[1],endX:cellsize[2]+cellsize[0]},renderCtx))===false){return;}renderCtx.fillRect(cellsize[0],cellsize[1],cellsize[2],cellsize[3]);var index=getSheetIndex(this.sheetCtx,this.sheetCtx.currentSheetId);var dataVerification=this.sheetCtx.luckysheetfile[index].dataVerification;if((dataVerification===null||dataVerification===void 0?void 0:dataVerification["".concat(r,"_").concat(c)])&&!validateCellData(this.sheetCtx,dataVerification["".concat(r,"_").concat(c)],value)){var dv_w=5*this.sheetCtx.zoomRatio;var dv_h=5*this.sheetCtx.zoomRatio;renderCtx.beginPath();renderCtx.moveTo(startX+offsetLeft,startY+offsetTop);renderCtx.lineTo(startX+offsetLeft+dv_w,startY+offsetTop);renderCtx.lineTo(startX+offsetLeft,startY+offsetTop+dv_h);renderCtx.fillStyle="#FC6666";renderCtx.fill();renderCtx.closePath();}if(cell===null||cell===void 0?void 0:cell.ps){var ps_w=8*this.sheetCtx.zoomRatio;var ps_h=8*this.sheetCtx.zoomRatio;renderCtx.beginPath();renderCtx.moveTo(endX+offsetLeft-ps_w,startY+offsetTop);renderCtx.lineTo(endX+offsetLeft,startY+offsetTop);renderCtx.lineTo(endX+offsetLeft,startY+offsetTop+ps_h);renderCtx.fillStyle="#FC6666";renderCtx.fill();renderCtx.closePath();}if((cell===null||cell===void 0?void 0:cell.qp)===1&&isRealNum$1(cell===null||cell===void 0?void 0:cell.v)){var _ps_w=6*this.sheetCtx.zoomRatio;var _ps_h=6*this.sheetCtx.zoomRatio;renderCtx.beginPath();renderCtx.moveTo(startX+offsetLeft+_ps_w-1,startY+offsetTop);renderCtx.lineTo(startX+offsetLeft-1,startY+offsetTop);renderCtx.lineTo(startX+offsetLeft-1,startY+offsetTop+_ps_h);renderCtx.fillStyle="#487f1e";renderCtx.fill();renderCtx.closePath();}var cellOverflow_bd_r_render=true;var cellOverflow_colInObj=this.cellOverflow_colIn(cellOverflowMap,r,c,colStart,colEnd);if((cell===null||cell===void 0?void 0:cell.tb)==="1"&&cellOverflow_colInObj.colIn){if(cellOverflow_colInObj.colLast&&!lodash_default().isNil(cellOverflow_colInObj.rowIndex)&&!lodash_default().isNil(cellOverflow_colInObj.colIndex)&&!lodash_default().isNil(cellOverflow_colInObj.stc)&&!lodash_default().isNil(cellOverflow_colInObj.edc)){this.cellOverflowRender(cellOverflow_colInObj.rowIndex,cellOverflow_colInObj.colIndex,cellOverflow_colInObj.stc,cellOverflow_colInObj.edc,renderCtx,scrollHeight,scrollWidth,offsetLeft,offsetTop,afCompute,cfCompute);}else{cellOverflow_bd_r_render=false;}}else if((dataVerification===null||dataVerification===void 0?void 0:(_dataVerification$=dataVerification["".concat(r,"_").concat(c)])===null||_dataVerification$===void 0?void 0:_dataVerification$.type)==="checkbox"){var pos_x=startX+offsetLeft;var pos_y=startY+offsetTop+1;renderCtx.save();renderCtx.beginPath();renderCtx.rect(pos_x,pos_y,cellWidth,cellHeight);renderCtx.clip();renderCtx.scale(this.sheetCtx.zoomRatio,this.sheetCtx.zoomRatio);var measureText=getMeasureText(value,renderCtx,this.sheetCtx);var textMetrics=measureText.width+14;var oneLineTextHeight=measureText.actualBoundingBoxDescent+measureText.actualBoundingBoxAscent;var horizonAlignPos=pos_x+space_width;if(horizonAlign===0){horizonAlignPos=pos_x+cellWidth/2-textMetrics/2;}else if(horizonAlign===2){horizonAlignPos=pos_x+cellWidth-space_width-textMetrics;}var verticalCellHeight=cellHeight>oneLineTextHeight?cellHeight:oneLineTextHeight;var verticalAlignPos_text=pos_y+verticalCellHeight-space_height;renderCtx.textBaseline="bottom";var verticalAlignPos_checkbox=verticalAlignPos_text-13*this.sheetCtx.zoomRatio;if(verticalAlign===0){verticalAlignPos_text=pos_y+verticalCellHeight/2;renderCtx.textBaseline="middle";verticalAlignPos_checkbox=verticalAlignPos_text-6*this.sheetCtx.zoomRatio;}else if(verticalAlign===1){verticalAlignPos_text=pos_y+space_height;renderCtx.textBaseline="top";verticalAlignPos_checkbox=verticalAlignPos_text+1*this.sheetCtx.zoomRatio;}horizonAlignPos/=this.sheetCtx.zoomRatio;verticalAlignPos_text/=this.sheetCtx.zoomRatio;verticalAlignPos_checkbox/=this.sheetCtx.zoomRatio;renderCtx.lineWidth=1;renderCtx.strokeStyle="#000";renderCtx.strokeRect(horizonAlignPos,verticalAlignPos_checkbox,10,10);if(dataVerification["".concat(r,"_").concat(c)].checked){renderCtx.beginPath();renderCtx.lineTo(horizonAlignPos+1,verticalAlignPos_checkbox+6);renderCtx.lineTo(horizonAlignPos+4,verticalAlignPos_checkbox+9);renderCtx.lineTo(horizonAlignPos+9,verticalAlignPos_checkbox+2);renderCtx.stroke();renderCtx.closePath();}renderCtx.fillStyle=normalizedAttr(flowdata,r,c,"fc");renderCtx.fillText(lodash_default().isNil(value)?"":value,horizonAlignPos+14,verticalAlignPos_text);renderCtx.restore();}else{var _checksCF$dataBar,_checksCF$dataBar2,_checksCF$dataBar2$va,_cell$ct$fa$indexOf,_cell$ct,_cell$ct$fa,_cell$ct2;if((checksCF===null||checksCF===void 0?void 0:(_checksCF$dataBar=checksCF.dataBar)===null||_checksCF$dataBar===void 0?void 0:_checksCF$dataBar.valueLen)&&(checksCF===null||checksCF===void 0?void 0:(_checksCF$dataBar2=checksCF.dataBar)===null||_checksCF$dataBar2===void 0?void 0:(_checksCF$dataBar2$va=_checksCF$dataBar2.valueLen)===null||_checksCF$dataBar2$va===void 0?void 0:_checksCF$dataBar2$va.toString())!=="NaN"){var x=startX+offsetLeft+space_width;var y=startY+offsetTop+space_height;var w=cellWidth-space_width*2;var h=cellHeight-space_height*2;var valueType=checksCF.dataBar.valueType;var valueLen=checksCF.dataBar.valueLen;var format=checksCF.dataBar.format;if(valueType==="minus"){var minusLen=checksCF.dataBar.minusLen;if(format.length>1){var my_gradient=renderCtx.createLinearGradient(x+w*minusLen*(1-valueLen),y,x+w*minusLen,y);my_gradient.addColorStop(0,"#ffffff");my_gradient.addColorStop(1,"#ff0000");renderCtx.fillStyle=my_gradient;}else{renderCtx.fillStyle="#ff0000";}renderCtx.fillRect(x+w*minusLen*(1-valueLen),y,w*minusLen*valueLen,h);renderCtx.beginPath();renderCtx.moveTo(x+w*minusLen*(1-valueLen),y);renderCtx.lineTo(x+w*minusLen*(1-valueLen),y+h);renderCtx.lineTo(x+w*minusLen,y+h);renderCtx.lineTo(x+w*minusLen,y);renderCtx.lineTo(x+w*minusLen*(1-valueLen),y);renderCtx.lineWidth=1;renderCtx.strokeStyle="#ff0000";renderCtx.stroke();renderCtx.closePath();}else if(valueType==="plus"){var plusLen=checksCF.dataBar.plusLen;if(plusLen===1){if(format.length>1){var _my_gradient=renderCtx.createLinearGradient(x,y,x+w*valueLen,y);_my_gradient.addColorStop(0,format[0]);_my_gradient.addColorStop(1,format[1]);renderCtx.fillStyle=_my_gradient;}else{var _format=index_esm_slicedToArray(format,1);renderCtx.fillStyle=_format[0];}renderCtx.fillRect(x,y,w*valueLen,h);renderCtx.beginPath();renderCtx.moveTo(x,y);renderCtx.lineTo(x,y+h);renderCtx.lineTo(x+w*valueLen,y+h);renderCtx.lineTo(x+w*valueLen,y);renderCtx.lineTo(x,y);renderCtx.lineWidth=1;var _format2=index_esm_slicedToArray(format,1);renderCtx.strokeStyle=_format2[0];renderCtx.stroke();renderCtx.closePath();}else{var _minusLen=checksCF.dataBar.minusLen;if(format.length>1){var _my_gradient2=renderCtx.createLinearGradient(x+w*_minusLen,y,x+w*_minusLen+w*plusLen*valueLen,y);_my_gradient2.addColorStop(0,format[0]);_my_gradient2.addColorStop(1,format[1]);renderCtx.fillStyle=_my_gradient2;}else{var _format3=index_esm_slicedToArray(format,1);renderCtx.fillStyle=_format3[0];}renderCtx.fillRect(x+w*_minusLen,y,w*plusLen*valueLen,h);renderCtx.beginPath();renderCtx.moveTo(x+w*_minusLen,y);renderCtx.lineTo(x+w*_minusLen,y+h);renderCtx.lineTo(x+w*_minusLen+w*plusLen*valueLen,y+h);renderCtx.lineTo(x+w*_minusLen+w*plusLen*valueLen,y);renderCtx.lineTo(x+w*_minusLen,y);renderCtx.lineWidth=1;var _format4=index_esm_slicedToArray(format,1);renderCtx.strokeStyle=_format4[0];renderCtx.stroke();renderCtx.closePath();}}}var _pos_x=startX+offsetLeft;var _pos_y=startY+offsetTop+1;renderCtx.save();renderCtx.beginPath();renderCtx.rect(_pos_x,_pos_y,cellWidth,cellHeight);renderCtx.clip();renderCtx.scale(this.sheetCtx.zoomRatio,this.sheetCtx.zoomRatio);var textInfo=cell?getCellTextInfo(cell,renderCtx,this.sheetCtx,{cellWidth:cellWidth,cellHeight:cellHeight,space_width:space_width,space_height:space_height,r:r,c:c},this.sheetCtx):undefined;if((checksCF===null||checksCF===void 0?void 0:checksCF.icons)&&textInfo.type==="plain"){var l=checksCF.icons.left;var t=checksCF.icons.top;var _value=textInfo.values[0];var verticalAlignPos=_pos_y+_value.top-textInfo.textHeightAll;if(verticalAlign===0){verticalAlignPos=_pos_y+cellHeight/2-textInfo.textHeightAll/2;}else if(verticalAlign===1){verticalAlignPos=_pos_y;}else if(verticalAlign===2){verticalAlignPos-=textInfo.desc;}verticalAlignPos/=this.sheetCtx.zoomRatio;renderCtx.drawImage(getCfIconsImg(),l*42,t*32,32,32,_pos_x/this.sheetCtx.zoomRatio,verticalAlignPos,textInfo.textHeightAll/this.sheetCtx.zoomRatio,textInfo.textHeightAll/this.sheetCtx.zoomRatio);}renderCtx.fillStyle=normalizedAttr(flowdata,r,c,"fc");if(checksAF===null||checksAF===void 0?void 0:checksAF[0]){var _checksAF=index_esm_slicedToArray(checksAF,1);renderCtx.fillStyle=_checksAF[0];}if(checksCF===null||checksCF===void 0?void 0:checksCF.textColor){renderCtx.fillStyle=checksCF.textColor;}if(((_cell$ct$fa$indexOf=cell===null||cell===void 0?void 0:(_cell$ct=cell.ct)===null||_cell$ct===void 0?void 0:(_cell$ct$fa=_cell$ct.fa)===null||_cell$ct$fa===void 0?void 0:_cell$ct$fa.indexOf("[Red]"))!==null&&_cell$ct$fa$indexOf!==void 0?_cell$ct$fa$indexOf:-1)>-1&&(cell===null||cell===void 0?void 0:(_cell$ct2=cell.ct)===null||_cell$ct2===void 0?void 0:_cell$ct2.t)==="n"&&(cell===null||cell===void 0?void 0:cell.v)<0){renderCtx.fillStyle="#ff0000";}this.cellTextRender(textInfo,renderCtx,{pos_x:_pos_x,pos_y:_pos_y});renderCtx.restore();}if(cellOverflow_bd_r_render){if(!this.sheetCtx.luckysheetcurrentisPivotTable&&this.sheetCtx.showGridLines){renderCtx.beginPath();renderCtx.moveTo(endX+offsetLeft-2+bodrder05,startY+offsetTop);renderCtx.lineTo(endX+offsetLeft-2+bodrder05,endY+offsetTop);renderCtx.lineWidth=1;renderCtx.strokeStyle=defaultStyle.strokeStyle;renderCtx.stroke();renderCtx.closePath();}}if(!this.sheetCtx.luckysheetcurrentisPivotTable&&this.sheetCtx.showGridLines){renderCtx.beginPath();renderCtx.moveTo(startX+offsetLeft-1,endY+offsetTop-2+bodrder05);renderCtx.lineTo(endX+offsetLeft-1,endY+offsetTop-2+bodrder05);renderCtx.lineWidth=1;renderCtx.strokeStyle=defaultStyle.strokeStyle;renderCtx.stroke();renderCtx.closePath();}(_this$sheetCtx$hooks$9=(_this$sheetCtx$hooks9=this.sheetCtx.hooks).afterRenderCell)===null||_this$sheetCtx$hooks$9===void 0?void 0:_this$sheetCtx$hooks$9.call(_this$sheetCtx$hooks9,(_flowdata$r3=flowdata[r])===null||_flowdata$r3===void 0?void 0:_flowdata$r3[c],{row:r,column:c,startX:cellsize[0],startY:cellsize[1],endX:cellsize[2]+cellsize[0],endY:cellsize[3]+cellsize[1]},renderCtx);}},{key:"cellOverflowRender",value:function cellOverflowRender(r,c,stc,edc,renderCtx,scrollHeight,scrollWidth,offsetLeft,offsetTop,afCompute,cfCompute){var startY;if(r===0){startY=-scrollHeight-1;}else{startY=this.sheetCtx.visibledatarow[r-1]-scrollHeight-1;}var endY=this.sheetCtx.visibledatarow[r]-scrollHeight;var startX;if(stc===0){startX=-scrollWidth;}else{startX=this.sheetCtx.visibledatacolumn[stc-1]-scrollWidth;}var endX=this.sheetCtx.visibledatacolumn[edc]-scrollWidth;var flowdata=getFlowdata(this.sheetCtx);if(!flowdata){return;}var cell=flowdata[r][c];var cellWidth=endX-startX-2;var cellHeight=endY-startY-2;var space_width=2;var space_height=2;var pos_x=startX+offsetLeft;var pos_y=startY+offsetTop+1;var fontset=getFontSet(cell,this.sheetCtx.defaultFontSize,this.sheetCtx);renderCtx.font=fontset;renderCtx.save();renderCtx.beginPath();renderCtx.rect(pos_x,pos_y,cellWidth,cellHeight);renderCtx.clip();renderCtx.scale(this.sheetCtx.zoomRatio,this.sheetCtx.zoomRatio);var textInfo=cell?getCellTextInfo(cell,renderCtx,this.sheetCtx,{cellWidth:cellWidth,cellHeight:cellHeight,space_width:space_width,space_height:space_height,r:r,c:c},this.sheetCtx):undefined;var checksAF={};var checksCF=checkCF(r,c,cfCompute);renderCtx.fillStyle=normalizedAttr(flowdata,r,c,"fc");if(checksAF===null||checksAF===void 0?void 0:checksAF[0]){var _checksAF2=index_esm_slicedToArray(checksAF,1);renderCtx.fillStyle=_checksAF2[0];}if(checksCF===null||checksCF===void 0?void 0:checksCF.textColor){renderCtx.fillStyle=checksCF.textColor;}this.cellTextRender(textInfo,renderCtx,{pos_x:pos_x,pos_y:pos_y});renderCtx.restore();}},{key:"cellOverflow_trace",value:function cellOverflow_trace(r,curC,traceC,traceDir,horizonAlign,textMetrics){var flowdata=getFlowdata(this.sheetCtx);if(!flowdata)return{};var data=flowdata;if(traceDir==="forward"&&traceC<0){return{success:false,r:r,c:traceC};}if(traceDir==="backward"&&traceC>data[r].length-1){return{success:false,r:r,c:traceC};}var cell=data[r][traceC];if(cell&&(!lodash_default().isEmpty(cell.v)||cell.mc)){return{success:false,r:r,c:traceC};}var start_curC=curC-1<0?0:this.sheetCtx.visibledatacolumn[curC-1];var end_curC=this.sheetCtx.visibledatacolumn[curC];var w=textMetrics-(end_curC-start_curC);if(horizonAlign==="0"){start_curC-=w/2;end_curC+=w/2;}else if(horizonAlign==="1"){end_curC+=w;}else if(horizonAlign==="2"){start_curC-=w;}var start_traceC=traceC-1<0?0:this.sheetCtx.visibledatacolumn[traceC-1];var end_traceC=this.sheetCtx.visibledatacolumn[traceC];if(traceDir==="forward"){if(start_curC<start_traceC){return this.cellOverflow_trace(r,curC,traceC-1,traceDir,horizonAlign,textMetrics);}if(start_curC<end_traceC){return{success:true,r:r,c:traceC};}return{success:false,r:r,c:traceC};}if(traceDir==="backward"){if(end_curC>end_traceC){return this.cellOverflow_trace(r,curC,traceC+1,traceDir,horizonAlign,textMetrics);}if(end_curC>start_traceC){return{success:true,r:r,c:traceC};}return{success:false,r:r,c:traceC};}return null;}},{key:"cellOverflow_colIn",value:function cellOverflow_colIn(map,r,c,col_st,col_ed){var colIn=false;var colLast=false;var rowIndex;var colIndex;var stc;var edc;lodash_default().forEach(map,function(row,rkey){lodash_default().forEach(row,function(mapItem,ckey){rowIndex=Number(rkey);colIndex=Number(ckey);stc=mapItem.stc;edc=mapItem.edc;if(rowIndex===r){if(c>=stc&&c<=edc){colIn=true;if(c===edc||c===col_ed){colLast=true;return false;}}}return true;});return!colLast;});return{colIn:colIn,colLast:colLast,rowIndex:rowIndex,colIndex:colIndex,stc:stc,edc:edc};}},{key:"cellTextRender",value:function cellTextRender(textInfo,ctx,option){if(!textInfo){return;}var values=textInfo.values;var pos_x=option.pos_x;var pos_y=option.pos_y;if(!values){return;}if(textInfo.rotate!==0&&textInfo.type!=="verticalWrap"){ctx.save();ctx.translate((pos_x+textInfo.textLeftAll)/this.sheetCtx.zoomRatio,(pos_y+textInfo.textTopAll)/this.sheetCtx.zoomRatio);ctx.rotate(-textInfo.rotate*Math.PI/180);ctx.translate(-(textInfo.textLeftAll+pos_x)/this.sheetCtx.zoomRatio,-(pos_y+textInfo.textTopAll)/this.sheetCtx.zoomRatio);}for(var i=0;i<values.length;i+=1){var word=values[i];if(word.inline===true&&word.style){ctx.font=word.style.fontset;ctx.fillStyle=word.style.fc;}else{ctx.font=word.style;}var txt=lodash_default().isPlainObject(word.content)?word.content.m:word.content;ctx.fillText(txt,(pos_x+word.left)/this.sheetCtx.zoomRatio,(pos_y+word.top)/this.sheetCtx.zoomRatio);if(word.cancelLine){var c=word.cancelLine;ctx.beginPath();ctx.moveTo(Math.floor((pos_x+c.startX)/this.sheetCtx.zoomRatio)+0.5,Math.floor((pos_y+c.startY)/this.sheetCtx.zoomRatio)+0.5);ctx.lineTo(Math.floor((pos_x+c.endX)/this.sheetCtx.zoomRatio)+0.5,Math.floor((pos_y+c.endY)/this.sheetCtx.zoomRatio)+0.5);ctx.lineWidth=Math.floor(c.fs/9);ctx.strokeStyle=ctx.fillStyle;ctx.stroke();ctx.closePath();}if(word.underLine){var underLines=word.underLine;for(var a=0;a<underLines.length;a+=1){var item=underLines[a];ctx.beginPath();ctx.moveTo(Math.floor((pos_x+item.startX)/this.sheetCtx.zoomRatio)+0.5,Math.floor((pos_y+item.startY)/this.sheetCtx.zoomRatio));ctx.lineTo(Math.floor((pos_x+item.endX)/this.sheetCtx.zoomRatio)+0.5,Math.floor((pos_y+item.endY)/this.sheetCtx.zoomRatio)+0.5);ctx.lineWidth=Math.floor(item.fs/9);ctx.strokeStyle=ctx.fillStyle;ctx.stroke();ctx.closePath();}}}if(textInfo.rotate!==0&&textInfo.type!=="verticalWrap"){ctx.restore();}}},{key:"drawFreezeLine",value:function drawFreezeLine(_ref2){var horizontalTop=_ref2.horizontalTop,verticalLeft=_ref2.verticalLeft;var renderCtx=this.canvasElement.getContext("2d");if(!renderCtx)return;renderCtx.save();renderCtx.scale(this.sheetCtx.devicePixelRatio,this.sheetCtx.devicePixelRatio);renderCtx.strokeStyle="#ccc";renderCtx.lineWidth=2;if(horizontalTop){renderCtx.beginPath();renderCtx.moveTo(0,horizontalTop);renderCtx.lineTo(this.canvasElement.width,horizontalTop);renderCtx.stroke();renderCtx.closePath();}if(verticalLeft){renderCtx.beginPath();renderCtx.moveTo(verticalLeft,0);renderCtx.lineTo(verticalLeft,this.canvasElement.height);renderCtx.stroke();renderCtx.closePath();}renderCtx.restore();}}]);return Canvas;}();function handleScreenShot(ctx){if(ctx.luckysheet_select_save==null)return undefined;if(ctx.luckysheet_select_save.length===0){return undefined;}if(ctx.luckysheet_select_save.length>1){return undefined;}if(ctx.config.merge!=null){var has_PartMC=false;for(var s=0;s<ctx.luckysheet_select_save.length;s+=1){var r1=ctx.luckysheet_select_save[s].row[0];var r2=ctx.luckysheet_select_save[s].row[1];var c1=ctx.luckysheet_select_save[s].column[0];var c2=ctx.luckysheet_select_save[s].column[1];has_PartMC=hasPartMC(ctx,ctx.config,r1,r2,c1,c2);if(has_PartMC){break;}}if(has_PartMC){return undefined;}}var st_r=ctx.luckysheet_select_save[0].row[0];var ed_r=ctx.luckysheet_select_save[0].row[1];var st_c=ctx.luckysheet_select_save[0].column[0];var ed_c=ctx.luckysheet_select_save[0].column[1];var scrollHeight;var rh_height;if(st_r-1<0){scrollHeight=0;rh_height=ctx.visibledatarow[ed_r];}else{scrollHeight=ctx.visibledatarow[st_r-1];rh_height=ctx.visibledatarow[ed_r]-ctx.visibledatarow[st_r-1];}var scrollWidth;var ch_width;if(st_c-1<0){scrollWidth=0;ch_width=ctx.visibledatacolumn[ed_c];}else{scrollWidth=ctx.visibledatacolumn[st_c-1];ch_width=ctx.visibledatacolumn[ed_c]-ctx.visibledatacolumn[st_c-1];}var newCanvasElement=document.createElement("canvas");newCanvasElement.width=Math.ceil(ch_width*devicePixelRatio);newCanvasElement.height=Math.ceil(rh_height*devicePixelRatio);newCanvasElement.style.width="".concat(ch_width,"px");newCanvasElement.style.height="".concat(rh_height,"px");var newCanvas=new Canvas(newCanvasElement,ctx);newCanvas.drawMain({scrollWidth:scrollWidth,scrollHeight:scrollHeight,drawWidth:ch_width,drawHeight:rh_height,offsetLeft:1,offsetTop:1,clear:true});var ctx_newCanvas=newCanvasElement.getContext("2d");if(ctx_newCanvas==null)return undefined;ctx_newCanvas.beginPath();ctx_newCanvas.moveTo(0,0);ctx_newCanvas.lineTo(0,ctx.devicePixelRatio*rh_height);ctx_newCanvas.lineWidth=ctx.devicePixelRatio*2;ctx_newCanvas.strokeStyle=defaultStyle.strokeStyle;ctx_newCanvas.stroke();ctx_newCanvas.closePath();ctx_newCanvas.beginPath();ctx_newCanvas.moveTo(0,0);ctx_newCanvas.lineTo(ctx.devicePixelRatio*ch_width,0);ctx_newCanvas.lineWidth=ctx.devicePixelRatio*2;ctx_newCanvas.strokeStyle=defaultStyle.strokeStyle;ctx_newCanvas.stroke();ctx_newCanvas.closePath();var image=new Image();var url=newCanvasElement.toDataURL("image/png");image.src=url;if(ch_width>rh_height){image.style.width="100%";}else{image.style.height="100%";}newCanvasElement.remove();return image.src;}function getSearchIndexArr(searchText,range,flowdata){var _ref=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{regCheck:false,wordCheck:false,caseCheck:false},regCheck=_ref.regCheck,wordCheck=_ref.wordCheck,caseCheck=_ref.caseCheck;var arr=[];var obj={};for(var s=0;s<range.length;s+=1){var r1=range[s].row[0];var r2=range[s].row[1];var c1=range[s].column[0];var c2=range[s].column[1];for(var r=r1;r<=r2;r+=1){for(var c=c1;c<=c2;c+=1){var cell=flowdata[r][c];if(cell!=null){var value=valueShowEs(r,c,flowdata);if(value===0){value=value.toString();}if(value!=null&&value!==""){value=value.toString();if(wordCheck){if(caseCheck){if(searchText===value){if(!("".concat(r,"_").concat(c)in obj)){lodash_default().set(obj,"".concat(r,"_").concat(c),0);arr.push({r:r,c:c});}}}else{var txt=searchText.toLowerCase();if(txt===value.toLowerCase()){if(!("".concat(r,"_").concat(c)in obj)){lodash_default().set(obj,"".concat(r,"_").concat(c),0);arr.push({r:r,c:c});}}}}else if(regCheck){var reg=void 0;if(caseCheck){reg=new RegExp(getRegExpStr(searchText),"g");}else{reg=new RegExp(getRegExpStr(searchText),"ig");}if(reg.test(value)){if(!("".concat(r,"_").concat(c)in obj)){lodash_default().set(obj,"".concat(r,"_").concat(c),0);arr.push({r:r,c:c});}}}else{if(caseCheck){if(~value.indexOf(searchText)){if(!("".concat(r,"_").concat(c)in obj)){lodash_default().set(obj,"".concat(r,"_").concat(c),0);arr.push({r:r,c:c});}}}else{if(~value.toLowerCase().indexOf(searchText.toLowerCase())){if(!("".concat(r,"_").concat(c)in obj)){lodash_default().set(obj,"".concat(r,"_").concat(c),0);arr.push({r:r,c:c});}}}}}}}}}return arr;}function searchNext(ctx,searchText,checkModes){var _ctx$luckysheet_selec,_ctx$luckysheet_selec2;var _locale=locale(ctx),findAndReplace=_locale.findAndReplace;var flowdata=getFlowdata(ctx);if(searchText===""||searchText==null||flowdata==null){return findAndReplace.searchInputTip;}var range;if(lodash_default().size(ctx.luckysheet_select_save)===0||((_ctx$luckysheet_selec=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec===void 0?void 0:_ctx$luckysheet_selec.length)===1&&ctx.luckysheet_select_save[0].row[0]===ctx.luckysheet_select_save[0].row[1]&&ctx.luckysheet_select_save[0].column[0]===ctx.luckysheet_select_save[0].column[1]){range=[{row:[0,flowdata.length-1],column:[0,flowdata[0].length-1],row_focus:0,column_focus:0}];}else{range=lodash_default().assign([],ctx.luckysheet_select_save);}var searchIndexArr=getSearchIndexArr(searchText,range,flowdata,checkModes);if(searchIndexArr.length===0){return findAndReplace.noFindTip;}var count=0;if(lodash_default().size(ctx.luckysheet_select_save)===0||((_ctx$luckysheet_selec2=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec2===void 0?void 0:_ctx$luckysheet_selec2.length)===1&&ctx.luckysheet_select_save[0].row[0]===ctx.luckysheet_select_save[0].row[1]&&ctx.luckysheet_select_save[0].column[0]===ctx.luckysheet_select_save[0].column[1]){if(lodash_default().size(ctx.luckysheet_select_save)===0){count=0;}else{for(var i=0;i<searchIndexArr.length;i+=1){if(searchIndexArr[i].r===ctx.luckysheet_select_save[0].row[0]&&searchIndexArr[i].c===ctx.luckysheet_select_save[0].column[0]){if(i===searchIndexArr.length-1){count=0;}else{count=i+1;}break;}}}ctx.luckysheet_select_save=normalizeSelection(ctx,[{row:[searchIndexArr[count].r,searchIndexArr[count].r],column:[searchIndexArr[count].c,searchIndexArr[count].c]}]);}else{var rf=range[range.length-1].row_focus;var cf=range[range.length-1].column_focus;for(var _i=0;_i<searchIndexArr.length;_i+=1){if(searchIndexArr[_i].r===rf&&searchIndexArr[_i].c===cf){if(_i===searchIndexArr.length-1){count=0;}else{count=_i+1;}break;}}for(var s=0;s<range.length;s+=1){var r1=range[s].row[0];var r2=range[s].row[1];var c1=range[s].column[0];var c2=range[s].column[1];if(searchIndexArr[count].r>=r1&&searchIndexArr[count].r<=r2&&searchIndexArr[count].c>=c1&&searchIndexArr[count].c<=c2){var obj=range[s];obj.row_focus=searchIndexArr[count].r;obj.column_focus=searchIndexArr[count].c;range.splice(s,1);range.push(obj);break;}}ctx.luckysheet_select_save=range;}scrollToHighlightCell(ctx,searchIndexArr[count].r,searchIndexArr[count].c);return null;}function searchAll(ctx,searchText,checkModes){var _ctx$luckysheet_selec3;var flowdata=getFlowdata(ctx);var searchResult=[];if(searchText===""||searchText==null||flowdata==null){return searchResult;}var range;if(lodash_default().size(ctx.luckysheet_select_save)===0||((_ctx$luckysheet_selec3=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec3===void 0?void 0:_ctx$luckysheet_selec3.length)===1&&ctx.luckysheet_select_save[0].row[0]===ctx.luckysheet_select_save[0].row[1]&&ctx.luckysheet_select_save[0].column[0]===ctx.luckysheet_select_save[0].column[1]){range=[{row:[0,flowdata.length-1],column:[0,flowdata[0].length-1]}];}else{range=lodash_default().assign([],ctx.luckysheet_select_save);}var searchIndexArr=getSearchIndexArr(searchText,range,flowdata,checkModes);if(searchIndexArr.length===0){return searchResult;}for(var i=0;i<searchIndexArr.length;i+=1){var _ctx$luckysheetfile;var value_ShowEs=valueShowEs(searchIndexArr[i].r,searchIndexArr[i].c,flowdata).toString();searchResult.push({r:searchIndexArr[i].r,c:searchIndexArr[i].c,sheetName:(_ctx$luckysheetfile=ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)||0])===null||_ctx$luckysheetfile===void 0?void 0:_ctx$luckysheetfile.name,sheetId:ctx.currentSheetId,cellPosition:"".concat(chatatABC(searchIndexArr[i].c)).concat(searchIndexArr[i].r+1),value:value_ShowEs});}ctx.luckysheet_select_save=normalizeSelection(ctx,[{row:[searchIndexArr[0].r,searchIndexArr[0].r],column:[searchIndexArr[0].c,searchIndexArr[0].c]}]);return searchResult;}function onSearchDialogMoveStart(globalCache,e,container){var box=document.getElementById("fortune-search-replace");if(!box)return;var _box$getBoundingClien=box.getBoundingClientRect(),top=_box$getBoundingClien.top,left=_box$getBoundingClien.left,width=_box$getBoundingClien.width,height=_box$getBoundingClien.height;var rect=container.getBoundingClientRect();left-=rect.left;top-=rect.top;var initialPosition={left:left,top:top,width:width,height:height};lodash_default().set(globalCache,"searchDialog.moveProps",{cursorMoveStartPosition:{x:e.pageX,y:e.pageY},initialPosition:initialPosition});}function onSearchDialogMove(globalCache,e){var searchDialog=globalCache===null||globalCache===void 0?void 0:globalCache.searchDialog;var moveProps=searchDialog===null||searchDialog===void 0?void 0:searchDialog.moveProps;if(moveProps==null)return;var dialog=document.getElementById("fortune-search-replace");var _moveProps$cursorMove=moveProps.cursorMoveStartPosition,startX=_moveProps$cursorMove.x,startY=_moveProps$cursorMove.y;var _moveProps$initialPos=moveProps.initialPosition,top=_moveProps$initialPos.top,left=_moveProps$initialPos.left;left+=e.pageX-startX;top+=e.pageY-startY;if(top<0)top=0;dialog.style.left="".concat(left,"px");dialog.style.top="".concat(top,"px");}function onSearchDialogMoveEnd(globalCache){lodash_default().set(globalCache,"searchDialog.moveProps",undefined);}function replace(ctx,searchText,replaceText,checkModes){var _ctx$luckysheet_selec4,_ctx$luckysheet_selec5;var _locale2=locale(ctx),findAndReplace=_locale2.findAndReplace;var allowEdit=isAllowEdit(ctx);if(!allowEdit){return findAndReplace.modeTip;}var flowdata=getFlowdata(ctx);if(searchText===""||searchText==null||flowdata==null){return findAndReplace.searchInputTip;}var range;if(lodash_default().size(ctx.luckysheet_select_save)===0||((_ctx$luckysheet_selec4=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec4===void 0?void 0:_ctx$luckysheet_selec4.length)===1&&ctx.luckysheet_select_save[0].row[0]===ctx.luckysheet_select_save[0].row[1]&&ctx.luckysheet_select_save[0].column[0]===ctx.luckysheet_select_save[0].column[1]){range=[{row:[0,flowdata.length-1],column:[0,flowdata[0].length-1]}];}else{range=lodash_default().assign([],ctx.luckysheet_select_save);}var searchIndexArr=getSearchIndexArr(searchText,range,flowdata,checkModes);if(searchIndexArr.length===0){return findAndReplace.noReplceTip;}var count=null;var last=(_ctx$luckysheet_selec5=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec5===void 0?void 0:_ctx$luckysheet_selec5[ctx.luckysheet_select_save.length-1];var rf=last===null||last===void 0?void 0:last.row_focus;var cf=last===null||last===void 0?void 0:last.column_focus;for(var i=0;i<searchIndexArr.length;i+=1){if(searchIndexArr[i].r===rf&&searchIndexArr[i].c===cf){count=i;break;}}if(count==null){if(searchIndexArr.length===0){return findAndReplace.noMatchTip;}count=0;}var d=flowdata;var r;var c;if(checkModes.wordCheck){r=searchIndexArr[count].r;c=searchIndexArr[count].c;var v=replaceText;setCellValue(ctx,r,c,d,v);}else{var reg;if(checkModes.caseCheck){reg=new RegExp(getRegExpStr(searchText),"g");}else{reg=new RegExp(getRegExpStr(searchText),"ig");}r=searchIndexArr[count].r;c=searchIndexArr[count].c;var _v=valueShowEs(r,c,d).toString().replace(reg,replaceText);setCellValue(ctx,r,c,d,_v);}ctx.luckysheet_select_save=normalizeSelection(ctx,[{row:[r,r],column:[c,c]}]);scrollToHighlightCell(ctx,r,c);return null;}function replaceAll(ctx,searchText,replaceText,checkModes){var _ctx$luckysheet_selec6;var _locale3=locale(ctx),findAndReplace=_locale3.findAndReplace;var allowEdit=isAllowEdit(ctx);if(!allowEdit){return findAndReplace.modeTip;}var flowdata=getFlowdata(ctx);if(searchText===""||searchText==null||flowdata==null){return findAndReplace.searchInputTip;}var range;if(lodash_default().size(ctx.luckysheet_select_save)===0||((_ctx$luckysheet_selec6=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec6===void 0?void 0:_ctx$luckysheet_selec6.length)===1&&ctx.luckysheet_select_save[0].row[0]===ctx.luckysheet_select_save[0].row[1]&&ctx.luckysheet_select_save[0].column[0]===ctx.luckysheet_select_save[0].column[1]){range=[{row:[0,flowdata.length-1],column:[0,flowdata[0].length-1]}];}else{range=lodash_default().assign([],ctx.luckysheet_select_save);}var searchIndexArr=getSearchIndexArr(searchText,range,flowdata,checkModes);if(searchIndexArr.length===0){return findAndReplace.noReplceTip;}var d=flowdata;var replaceCount=0;if(checkModes.wordCheck){for(var i=0;i<searchIndexArr.length;i+=1){var r=searchIndexArr[i].r;var c=searchIndexArr[i].c;var v=replaceText;setCellValue(ctx,r,c,d,v);range.push({row:[r,r],column:[c,c]});replaceCount+=1;}}else{var reg;if(checkModes.caseCheck){reg=new RegExp(getRegExpStr(searchText),"g");}else{reg=new RegExp(getRegExpStr(searchText),"ig");}for(var _i2=0;_i2<searchIndexArr.length;_i2+=1){var _r=searchIndexArr[_i2].r;var _c=searchIndexArr[_i2].c;var _v2=valueShowEs(_r,_c,d).toString().replace(reg,replaceText);setCellValue(ctx,_r,_c,d,_v2);range.push({row:[_r,_r],column:[_c,_c]});replaceCount+=1;}}ctx.luckysheet_select_save=normalizeSelection(ctx,range);var succeedInfo=replaceHtml(findAndReplace.successTip,{xlength:replaceCount});return succeedInfo;}function labelFilterOptionState(ctx,optionstate,rowhidden,caljs,str,edr,cindex,stc,edc,saveData){var param={caljs:caljs,rowhidden:rowhidden,optionstate:optionstate,str:str,edr:edr,cindex:cindex,stc:stc,edc:edc};if(optionstate){ctx.filter[cindex-stc]=param;}else{delete ctx.filter[cindex-stc];}if(saveData){var sheetIndex=getSheetIndex(ctx,ctx.currentSheetId);if(sheetIndex==null)return;var file=ctx.luckysheetfile[sheetIndex];if(file.filter==null){file.filter={};}if(optionstate){file.filter[cindex-stc]=param;}else{delete file.filter[cindex-stc];}}}function orderbydatafiler(ctx,str,stc,edr,edc,curr,asc){var d=getFlowdata(ctx);if(d==null){return null;}str+=1;var hasMc=false;var data=[];for(var r=str;r<=edr;r+=1){var data_row=[];for(var c=stc;c<=edc;c+=1){var _d$r$c;if(d[r][c]!=null&&((_d$r$c=d[r][c])===null||_d$r$c===void 0?void 0:_d$r$c.mc)!=null){hasMc=true;break;}data_row.push(d[r][c]);}data.push(data_row);}if(hasMc){var _locale=locale(ctx),filter=_locale.filter;return filter.mergeError;}sortDataRange(ctx,d,data,curr-stc,asc,str,edr,stc,edc);return null;}function createFilterOptions(ctx,luckysheet_filter_save,sheetId,filterObj,saveData){var _ctx$visibledatarow$r,_ctx$visibledatarow,_ctx$visibledatacolum,_ctx$visibledatacolum2;var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;if(sheetId!=null&&sheetId!==ctx.currentSheetId)return;var sheetIndex=getSheetIndex(ctx,ctx.currentSheetId);if(sheetIndex==null)return;if(luckysheet_filter_save==null||lodash_default().size(luckysheet_filter_save)===0){delete ctx.filterOptions;return;}var r1=luckysheet_filter_save.row[0];var r2=luckysheet_filter_save.row[1];var c1=luckysheet_filter_save.column[0];var c2=luckysheet_filter_save.column[1];var row=(_ctx$visibledatarow$r=ctx.visibledatarow[r2])!==null&&_ctx$visibledatarow$r!==void 0?_ctx$visibledatarow$r:0;var row_pre=r1-1===-1?0:(_ctx$visibledatarow=ctx.visibledatarow[r1-1])!==null&&_ctx$visibledatarow!==void 0?_ctx$visibledatarow:0;var col=(_ctx$visibledatacolum=ctx.visibledatacolumn[c2])!==null&&_ctx$visibledatacolum!==void 0?_ctx$visibledatacolum:0;var col_pre=c1-1===-1?0:(_ctx$visibledatacolum2=ctx.visibledatacolumn[c1-1])!==null&&_ctx$visibledatacolum2!==void 0?_ctx$visibledatacolum2:0;var options={startRow:r1,endRow:r2,startCol:c1,endCol:c2,left:col_pre,top:row_pre,width:col-col_pre-1,height:row-row_pre-1,items:[]};for(var c=c1;c<=c2;c+=1){if(filterObj==null||(filterObj===null||filterObj===void 0?void 0:filterObj[c-c1])==null);var left=0;if(ctx.visibledatacolumn[c]){left=ctx.visibledatacolumn[c]-20;}options.items.push({col:c,left:left,top:row_pre});}if(saveData){var file=ctx.luckysheetfile[sheetIndex];file.filter_select=luckysheet_filter_save;}ctx.filterOptions=options;}function clearFilter(ctx){var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;var sheetIndex=getSheetIndex(ctx,ctx.currentSheetId);var hiddenRows=lodash_default().reduce(ctx.filter,function(pre,curr){return lodash_default().assign(pre,(curr===null||curr===void 0?void 0:curr.rowhidden)||{});},{});ctx.config.rowhidden=lodash_default().omit(ctx.config.rowhidden,lodash_default().keys(hiddenRows));ctx.luckysheet_filter_save=undefined;ctx.filterOptions=undefined;ctx.filterContextMenu=undefined;ctx.filter={};if(sheetIndex!=null){ctx.luckysheetfile[sheetIndex].filter=undefined;ctx.luckysheetfile[sheetIndex].filter_select=undefined;ctx.luckysheetfile[sheetIndex].config=lodash_default().assign({},ctx.config);}}function createFilter(ctx){var _ctx$luckysheet_selec,_filterSave,_ctx$luckysheet_selec2;if(lodash_default().size(ctx.luckysheet_select_save)>1){return;}if(lodash_default().size(ctx.luckysheet_filter_save)>0){clearFilter(ctx);return;}var sheetIndex=getSheetIndex(ctx,ctx.currentSheetId);if(sheetIndex==null||ctx.luckysheetfile[sheetIndex].isPivotTable){return;}var last=(_ctx$luckysheet_selec=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec===void 0?void 0:_ctx$luckysheet_selec[0];var flowdata=getFlowdata(ctx);var filterSave;if(last==null||flowdata==null)return;if(last.row[0]===last.row[1]&&last.column[0]===last.column[1]){var st_c;var ed_c;var curR=last.row[1];for(var c=0;c<flowdata[curR].length;c+=1){var cell=flowdata[curR][c];if(cell!=null&&!isRealNull(cell.v)){if(st_c==null){st_c=c;}}else if(st_c!=null){ed_c=c-1;break;}}if(ed_c==null){ed_c=flowdata[curR].length-1;}filterSave=normalizeSelection(ctx,[{row:[curR,curR],column:[st_c||0,ed_c]}]);ctx.luckysheet_select_save=filterSave;ctx.luckysheet_shiftpositon=lodash_default().assign({},last);}else if(last.row[1]-last.row[0]<2){ctx.luckysheet_shiftpositon=lodash_default().assign({},last);}ctx.luckysheet_filter_save=lodash_default().assign({},((_filterSave=filterSave)===null||_filterSave===void 0?void 0:_filterSave[0])||((_ctx$luckysheet_selec2=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec2===void 0?void 0:_ctx$luckysheet_selec2[0]));createFilterOptions(ctx,ctx.luckysheet_filter_save,undefined,{},true);}function getFilterHiddenRows(ctx,col,startCol){var _ctx$filter;var otherHiddenRows=lodash_default().reduce(ctx.filter,function(pre,curr){return lodash_default().assign(pre,(curr===null||curr===void 0?void 0:curr.cindex)!==col&&(curr===null||curr===void 0?void 0:curr.rowhidden)||{});},{});var hiddenRows=((_ctx$filter=ctx.filter[col-startCol])===null||_ctx$filter===void 0?void 0:_ctx$filter.rowhidden)||{};return{otherHiddenRows:otherHiddenRows,hiddenRows:hiddenRows};}function getFilterColumnValues(ctx,col,startRow,endRow,startCol){var _getFilterHiddenRows=getFilterHiddenRows(ctx,col,startCol),otherHiddenRows=_getFilterHiddenRows.otherHiddenRows,hiddenRows=_getFilterHiddenRows.hiddenRows;var visibleRows=[];var flattenValues=[];var dates=[];var datesUncheck=[];var dateRowMap={};var valuesMap=new Map();var valuesUncheck=[];var valueRowMap={};var flowdata=getFlowdata(ctx);if(flowdata==null)return{dates:dates,datesUncheck:datesUncheck,dateRowMap:dateRowMap,values:[],valuesUncheck:valuesUncheck,valueRowMap:valueRowMap,visibleRows:visibleRows,flattenValues:flattenValues};var cell;var _locale2=locale(ctx),filter=_locale2.filter;for(var r=startRow+1;r<=endRow;r+=1){if(r in otherHiddenRows){continue;}visibleRows.push(r);cell=flowdata[r][col];if(cell!=null&&!isRealNull(cell.v)&&cell.ct!=null&&cell.ct.t==="d"){(function(){var dateStr=update("YYYY-MM-DD",cell.v);var y=dateStr.split("-")[0];var m=dateStr.split("-")[1];var d=dateStr.split("-")[2];var yearValue=lodash_default().find(dates,function(v){return v.value===y;});if(yearValue==null){yearValue={key:y,type:"year",value:y,text:y+filter.filiterYearText,children:[],rows:[],dateValues:[]};dates.push(yearValue);flattenValues.push(dateStr);}var monthValue=lodash_default().find(yearValue.children,function(v){return v.value===m;});if(monthValue==null){monthValue={key:"".concat(y,"-").concat(m),type:"month",value:m,text:m+filter.filiterMonthText,children:[],rows:[],dateValues:[]};yearValue.children.push(monthValue);}var dayValue=lodash_default().find(monthValue.children,function(v){return v.value===d;});if(dayValue==null){dayValue={key:dateStr,type:"day",value:d,text:d,children:[],rows:[],dateValues:[]};monthValue.children.push(dayValue);}yearValue.rows.push(r);yearValue.dateValues.push(dateStr);monthValue.rows.push(r);monthValue.dateValues.push(dateStr);dayValue.rows.push(r);dayValue.dateValues.push(dateStr);dateRowMap[dateStr]=(dateRowMap[dateStr]||[]).concat(r);if(r in hiddenRows){datesUncheck=lodash_default().union(datesUncheck,[dateStr]);}})();}else{(function(){var v=void 0;var m=void 0;if(cell==null||isRealNull(cell.v)){v=null;m=null;}else{v=cell.v;m=cell.m;}var data=valuesMap.get("".concat(v));var text=m==null?filter.valueBlank:"".concat(m);var key="".concat(v,"#$$$#").concat(m);if(data!=null){var maskValue=lodash_default().find(data,function(value){return value.mask===m;});if(maskValue==null){maskValue={key:key,value:v,text:text,mask:m,rows:[]};data.push(maskValue);flattenValues.push(text);}maskValue.rows.push(r);}else{valuesMap.set("".concat(v),[{key:key,value:v,text:text,mask:m,rows:[r]}]);flattenValues.push(text);}if(r in hiddenRows){valuesUncheck=lodash_default().union(valuesUncheck,[key]);}valueRowMap[key]=(valueRowMap[key]||[]).concat(r);})();}}return{dates:dates,datesUncheck:datesUncheck,dateRowMap:dateRowMap,values:lodash_default().flatten(Array.from(valuesMap.values())),valuesUncheck:valuesUncheck,valueRowMap:valueRowMap,visibleRows:visibleRows,flattenValues:flattenValues};}function getFilterColumnColors(ctx,col,startRow,endRow){var bgMap=new Map();var fcMap=new Map();var cf_compute=getComputeMap(ctx);var flowdata=getFlowdata(ctx);if(flowdata==null)return{bgColors:[],fcColors:[]};for(var r=startRow+1;r<=endRow;r+=1){var _ctx$config;var cell=flowdata[r][col];var bg=normalizedAttr(flowdata,r,col,"bg");if(bg==null){bg="#ffffff";}var checksAF=[];if(checksAF.length>1){bg=checksAF[1];}var checksCF=checkCF(r,col,cf_compute);if(checksCF!=null&&checksCF.cellColor!=null){bg=checksCF.cellColor;}if(bg.indexOf("rgb")>-1){bg=rgbToHex(bg);}if(bg.length===4){bg=bg.substr(0,1)+bg.substr(1,1).repeat(2)+bg.substr(2,1).repeat(2)+bg.substr(3,1).repeat(2);}var fc=normalizedAttr(flowdata,r,col,"fc");if(checksAF.length>0){fc=checksAF[0];}if(checksCF!=null&&checksCF.textColor!=null){fc=checksCF.textColor;}if(fc!=null){if(fc.indexOf("rgb")>-1){fc=rgbToHex(fc);}if(fc.length===4){fc=fc.substr(0,1)+fc.substr(1,1).repeat(2)+fc.substr(2,1).repeat(2)+fc.substr(3,1).repeat(2);}}var isRowHidden=r in(((_ctx$config=ctx.config)===null||_ctx$config===void 0?void 0:_ctx$config.rowhidden)||{});var bgData=bgMap.get(bg);if(bgData!=null){bgData.rows.push(r);if(isRowHidden)bgData.checked=false;}else{bgMap.set(bg,{color:bg,checked:!isRowHidden,rows:[r]});}if(fc!=null){var fcData=fcMap.get(fc);if(fcData!=null&&cell!=null&&!isRealNull(cell.v)){fcData.rows.push(r);if(isRowHidden)fcData.checked=false;}else if(cell!=null&&!isRealNull(cell.v)){fcMap.set(fc,{color:fc,checked:!isRowHidden,rows:[r]});}}}var bgColors=lodash_default().flatten(Array.from(bgMap.values()));var fcColors=lodash_default().flatten(Array.from(fcMap.values()));return{bgColors:bgColors.length<2?[]:bgColors,fcColors:fcColors.length<2?[]:fcColors};}function saveFilter(ctx,optionState,hiddenRows,caljs,st_r,ed_r,cindex,st_c,ed_c){var _getFilterHiddenRows2=getFilterHiddenRows(ctx,cindex,st_c),otherHiddenRows=_getFilterHiddenRows2.otherHiddenRows;var rowHiddenAll=lodash_default().assign(otherHiddenRows,hiddenRows);labelFilterOptionState(ctx,optionState,hiddenRows,caljs,st_r,ed_r,cindex,st_c,ed_c,true);var cfg=lodash_default().assign({},ctx.config);cfg.rowhidden=rowHiddenAll;ctx.config=cfg;var sheetIndex=getSheetIndex(ctx,ctx.currentSheetId);if(sheetIndex==null){return;}ctx.luckysheetfile[sheetIndex].config=cfg;}var dragCellThreshold=8;function getCellLocationByMouse(ctx,e,scrollbarX,scrollbarY,container){var rect=container.getBoundingClientRect();var x=e.pageX-rect.left-ctx.rowHeaderWidth+scrollbarX.scrollLeft;var y=e.pageY-rect.top-ctx.columnHeaderHeight+scrollbarY.scrollTop;return{row:rowLocation(y,ctx.visibledatarow),column:colLocation(x,ctx.visibledatacolumn)};}function onCellsMoveStart(ctx,globalCache,e,scrollbarX,scrollbarY,container){var allowEdit=isAllowEdit(ctx);if(allowEdit===false){return;}globalCache.dragCellStartPos={x:e.pageX,y:e.pageY};ctx.luckysheet_cell_selected_move=true;ctx.luckysheet_scroll_status=true;var _getCellLocationByMou=getCellLocationByMouse(ctx,e,scrollbarX,scrollbarY,container),_getCellLocationByMou2=index_esm_slicedToArray(_getCellLocationByMou.row,3),row_pre=_getCellLocationByMou2[0],row=_getCellLocationByMou2[1],row_index=_getCellLocationByMou2[2],_getCellLocationByMou3=index_esm_slicedToArray(_getCellLocationByMou.column,3),col_pre=_getCellLocationByMou3[0],col=_getCellLocationByMou3[1],col_index=_getCellLocationByMou3[2];var range=lodash_default().last(ctx.luckysheet_select_save);if(range==null)return;if(row_index<range.row[0]){var _range$row=index_esm_slicedToArray(range.row,1);row_index=_range$row[0];}else if(row_index>range.row[1]){var _range$row2=index_esm_slicedToArray(range.row,2);row_index=_range$row2[1];}if(col_index<range.column[0]){var _range$column=index_esm_slicedToArray(range.column,1);col_index=_range$column[0];}else if(col_index>range.column[1]){var _range$column2=index_esm_slicedToArray(range.column,2);col_index=_range$column2[1];}var _rowLocationByIndex=rowLocationByIndex(row_index,ctx.visibledatarow);var _rowLocationByIndex2=index_esm_slicedToArray(_rowLocationByIndex,2);row_pre=_rowLocationByIndex2[0];row=_rowLocationByIndex2[1];var _colLocationByIndex=colLocationByIndex(col_index,ctx.visibledatacolumn);var _colLocationByIndex2=index_esm_slicedToArray(_colLocationByIndex,2);col_pre=_colLocationByIndex2[0];col=_colLocationByIndex2[1];ctx.luckysheet_cell_selected_move_index=[row_index,col_index];var ele=document.getElementById("fortune-cell-selected-move");if(ele==null)return;ele.style.left="".concat(col_pre,"px");ele.style.top="".concat(row_pre,"px");ele.style.width="".concat(col-col_pre-1,"px");ele.style.height="".concat(row-row_pre-1,"px");ele.style.display="block";e.stopPropagation();}function onCellsMove(ctx,globalCache,e,scrollbarX,scrollbarY,container){if(!ctx.luckysheet_cell_selected_move)return;if(globalCache.dragCellStartPos!=null){var deltaX=Math.abs(globalCache.dragCellStartPos.x-e.pageX);var deltaY=Math.abs(globalCache.dragCellStartPos.y-e.pageY);if(deltaX<dragCellThreshold&&deltaY<dragCellThreshold){return;}globalCache.dragCellStartPos=undefined;}var _mousePosition=mousePosition(e.pageX,e.pageY,ctx),_mousePosition2=index_esm_slicedToArray(_mousePosition,2),x=_mousePosition2[0],y=_mousePosition2[1];var rect=container.getBoundingClientRect();var winH=rect.height-20*ctx.zoomRatio;var winW=rect.width-60*ctx.zoomRatio;var _getCellLocationByMou4=getCellLocationByMouse(ctx,e,scrollbarX,scrollbarY,container),rowL=_getCellLocationByMou4.row,column=_getCellLocationByMou4.column;var _rowL=index_esm_slicedToArray(rowL,2),row_pre=_rowL[0],row=_rowL[1];var _column=index_esm_slicedToArray(column,2),col_pre=_column[0],col=_column[1];var row_index=rowL[2];var col_index=column[2];var row_index_original=ctx.luckysheet_cell_selected_move_index[0];var col_index_original=ctx.luckysheet_cell_selected_move_index[1];if(ctx.luckysheet_select_save==null)return;var row_s=ctx.luckysheet_select_save[0].row[0]-row_index_original+row_index;var row_e=ctx.luckysheet_select_save[0].row[1]-row_index_original+row_index;var col_s=ctx.luckysheet_select_save[0].column[0]-col_index_original+col_index;var col_e=ctx.luckysheet_select_save[0].column[1]-col_index_original+col_index;if(row_s<0||y<0){row_s=0;row_e=ctx.luckysheet_select_save[0].row[1]-ctx.luckysheet_select_save[0].row[0];}if(col_s<0||x<0){col_s=0;col_e=ctx.luckysheet_select_save[0].column[1]-ctx.luckysheet_select_save[0].column[0];}if(row_e>=ctx.visibledatarow.length-1||y>winH){row_s=ctx.visibledatarow.length-1-ctx.luckysheet_select_save[0].row[1]+ctx.luckysheet_select_save[0].row[0];row_e=ctx.visibledatarow.length-1;}if(col_e>=ctx.visibledatacolumn.length-1||x>winW){col_s=ctx.visibledatacolumn.length-1-ctx.luckysheet_select_save[0].column[1]+ctx.luckysheet_select_save[0].column[0];col_e=ctx.visibledatacolumn.length-1;}col_pre=col_s-1===-1?0:ctx.visibledatacolumn[col_s-1];col=ctx.visibledatacolumn[col_e];row_pre=row_s-1===-1?0:ctx.visibledatarow[row_s-1];row=ctx.visibledatarow[row_e];var ele=document.getElementById("fortune-cell-selected-move");if(ele==null)return;ele.style.left="".concat(col_pre,"px");ele.style.top="".concat(row_pre,"px");ele.style.width="".concat(col-col_pre-2,"px");ele.style.height="".concat(row-row_pre-2,"px");ele.style.display="block";}function onCellsMoveEnd(ctx,globalCache,e,scrollbarX,scrollbarY,container){var _ctx$luckysheetfile$g2;if(!ctx.luckysheet_cell_selected_move)return;ctx.luckysheet_cell_selected_move=false;var ele=document.getElementById("fortune-cell-selected-move");if(ele!=null)ele.style.display="none";if(globalCache.dragCellStartPos!=null){globalCache.dragCellStartPos=undefined;return;}var _mousePosition3=mousePosition(e.pageX,e.pageY,ctx),_mousePosition4=index_esm_slicedToArray(_mousePosition3,2),x=_mousePosition4[0],y=_mousePosition4[1];var rect=container.getBoundingClientRect();var winH=rect.height-20*ctx.zoomRatio;var winW=rect.width-60*ctx.zoomRatio;var _getCellLocationByMou5=getCellLocationByMouse(ctx,e,scrollbarX,scrollbarY,container),_getCellLocationByMou6=index_esm_slicedToArray(_getCellLocationByMou5.row,3),row_index=_getCellLocationByMou6[2],_getCellLocationByMou7=index_esm_slicedToArray(_getCellLocationByMou5.column,3),col_index=_getCellLocationByMou7[2];var allowEdit=isAllowEdit(ctx,[{row:[row_index,row_index],column:[col_index,col_index]}]);if(!allowEdit)return;var row_index_original=ctx.luckysheet_cell_selected_move_index[0];var col_index_original=ctx.luckysheet_cell_selected_move_index[1];if(row_index===row_index_original&&col_index===col_index_original){return;}var d=getFlowdata(ctx);if(d==null||ctx.luckysheet_select_save==null)return;var last=ctx.luckysheet_select_save[ctx.luckysheet_select_save.length-1];var data=lodash_default().cloneDeep(getdatabyselection(ctx,last,ctx.currentSheetId));var cfg=ctx.config;if(cfg.merge==null){cfg.merge={};}if(cfg.rowlen==null){cfg.rowlen={};}var _locale=locale(ctx),locale_drag=_locale.drag;if(hasPartMC(ctx,cfg,last.row[0],last.row[1],last.column[0],last.column[1])){throw new Error(locale_drag.noMerge);}var row_s=last.row[0]-row_index_original+row_index;var row_e=last.row[1]-row_index_original+row_index;var col_s=last.column[0]-col_index_original+col_index;var col_e=last.column[1]-col_index_original+col_index;if(row_s<0||y<0){row_s=0;row_e=last.row[1]-last.row[0];}if(col_s<0||x<0){col_s=0;col_e=last.column[1]-last.column[0];}if(row_e>=ctx.visibledatarow.length-1||y>winH){row_s=ctx.visibledatarow.length-1-last.row[1]+last.row[0];row_e=ctx.visibledatarow.length-1;}if(col_e>=ctx.visibledatacolumn.length-1||x>winW){col_s=ctx.visibledatacolumn.length-1-last.column[1]+last.column[0];col_e=ctx.visibledatacolumn.length-1;}if(hasPartMC(ctx,cfg,row_s,row_e,col_s,col_e)){throw new Error(locale_drag.noMerge);}var borderInfoCompute=getBorderInfoCompute(ctx,ctx.currentSheetId);var hyperLinkList={};var index=getSheetIndex(ctx,ctx.currentSheetId);for(var r=last.row[0];r<=last.row[1];r+=1){for(var c=last.column[0];c<=last.column[1];c+=1){var _ctx$luckysheetfile$i;var cellData=d[r][c];if((cellData===null||cellData===void 0?void 0:cellData.mc)!=null){var mergeKey="".concat(cellData.mc.r,"_").concat(c);if(cfg.merge[mergeKey]!=null){delete cfg.merge[mergeKey];}}d[r][c]=null;if((_ctx$luckysheetfile$i=ctx.luckysheetfile[index].hyperlink)===null||_ctx$luckysheetfile$i===void 0?void 0:_ctx$luckysheetfile$i["".concat(r,"_").concat(c)]){var _ctx$luckysheetfile$i2,_ctx$luckysheetfile$g;hyperLinkList["".concat(r,"_").concat(c)]=(_ctx$luckysheetfile$i2=ctx.luckysheetfile[index].hyperlink)===null||_ctx$luckysheetfile$i2===void 0?void 0:_ctx$luckysheetfile$i2["".concat(r,"_").concat(c)];(_ctx$luckysheetfile$g=ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)].hyperlink)===null||_ctx$luckysheetfile$g===void 0?true:delete _ctx$luckysheetfile$g["".concat(r,"_").concat(c)];}}}if(cfg.borderInfo&&cfg.borderInfo.length>0){var borderInfo=[];for(var i=0;i<cfg.borderInfo.length;i+=1){var bd_rangeType=cfg.borderInfo[i].rangeType;if(bd_rangeType==="range"&&cfg.borderInfo[i].borderType!=="border-slash"){var bd_range=cfg.borderInfo[i].range;var bd_emptyRange=[];for(var j=0;j<bd_range.length;j+=1){bd_emptyRange=bd_emptyRange.concat(cfSplitRange(bd_range[j],{row:last.row,column:last.column},{row:[row_s,row_e],column:[col_s,col_e]},"restPart"));}cfg.borderInfo[i].range=bd_emptyRange;borderInfo.push(cfg.borderInfo[i]);}else if(bd_rangeType==="cell"){var bd_r=cfg.borderInfo[i].value.row_index;var bd_c=cfg.borderInfo[i].value.col_index;if(!(bd_r>=last.row[0]&&bd_r<=last.row[1]&&bd_c>=last.column[0]&&bd_c<=last.column[1])){borderInfo.push(cfg.borderInfo[i]);}}else if(bd_rangeType==="range"&&cfg.borderInfo[i].borderType==="border-slash"&&!(cfg.borderInfo[i].range[0].row[0]>=last.row[0]&&cfg.borderInfo[i].range[0].row[0]<=last.row[1]&&cfg.borderInfo[i].range[0].column[0]>=last.column[0]&&cfg.borderInfo[i].range[0].column[0]<=last.column[1])){borderInfo.push(cfg.borderInfo[i]);}}cfg.borderInfo=borderInfo;}var offsetMC={};for(var _r=0;_r<data.length;_r+=1){for(var _c=0;_c<data[0].length;_c+=1){var _value;if(borderInfoCompute["".concat(_r+last.row[0],"_").concat(_c+last.column[0])]&&!borderInfoCompute["".concat(_r+last.row[0],"_").concat(_c+last.column[0])].s){var bd_obj={rangeType:"cell",value:{row_index:_r+row_s,col_index:_c+col_s,l:borderInfoCompute["".concat(_r+last.row[0],"_").concat(_c+last.column[0])].l,r:borderInfoCompute["".concat(_r+last.row[0],"_").concat(_c+last.column[0])].r,t:borderInfoCompute["".concat(_r+last.row[0],"_").concat(_c+last.column[0])].t,b:borderInfoCompute["".concat(_r+last.row[0],"_").concat(_c+last.column[0])].b}};if(cfg.borderInfo==null){cfg.borderInfo=[];}cfg.borderInfo.push(bd_obj);}else if(borderInfoCompute["".concat(_r+last.row[0],"_").concat(_c+last.column[0])]){var _bd_obj={rangeType:"range",borderType:"border-slash",color:borderInfoCompute["".concat(_r+last.row[0],"_").concat(_c+last.column[0])].s.color,style:borderInfoCompute["".concat(_r+last.row[0],"_").concat(_c+last.column[0])].s.style,range:normalizeSelection(ctx,[{row:[_r+row_s,_r+row_s],column:[_c+col_s,_c+col_s]}])};if(cfg.borderInfo==null){cfg.borderInfo=[];}cfg.borderInfo.push(_bd_obj);}var value=null;if(data[_r]!=null&&data[_r][_c]!=null){value=data[_r][_c];}if(((_value=value)===null||_value===void 0?void 0:_value.mc)!=null){var mc=lodash_default().assign({},value.mc);if("rs"in value.mc){lodash_default().set(offsetMC,"".concat(mc.r,"_").concat(mc.c),[_r+row_s,_c+col_s]);value.mc.r=_r+row_s;value.mc.c=_c+col_s;lodash_default().set(cfg.merge,"".concat(_r+row_s,"_").concat(_c+col_s),value.mc);}else{lodash_default().set(value.mc,"r",offsetMC["".concat(mc.r,"_").concat(mc.c)][0]);lodash_default().set(value.mc,"c",offsetMC["".concat(mc.r,"_").concat(mc.c)][1]);}}d[_r+row_s][_c+col_s]=value;if(hyperLinkList===null||hyperLinkList===void 0?void 0:hyperLinkList["".concat(_r+last.row[0],"_").concat(_c+last.column[0])]){ctx.luckysheetfile[index].hyperlink["".concat(_r+row_s,"_").concat(_c+col_s)]=hyperLinkList===null||hyperLinkList===void 0?void 0:hyperLinkList["".concat(_r+last.row[0],"_").concat(_c+last.column[0])];}}}var cdformat=(_ctx$luckysheetfile$g2=ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)].luckysheet_conditionformat_save)!==null&&_ctx$luckysheetfile$g2!==void 0?_ctx$luckysheetfile$g2:[];if(cdformat!=null&&cdformat.length>0){for(var _i=0;_i<cdformat.length;_i+=1){var cdformat_cellrange=cdformat[_i].cellrange;var emptyRange=[];for(var _j=0;_j<cdformat_cellrange.length;_j+=1){var _range=CFSplitRange(cdformat_cellrange[_j],{row:last.row,column:last.column},{row:[row_s,row_e],column:[col_s,col_e]},"allPart");emptyRange=emptyRange.concat(_range);}cdformat[_i].cellrange=emptyRange;}}var rf;if(ctx.luckysheet_select_save[0].row_focus===ctx.luckysheet_select_save[0].row[0]){rf=row_s;}else{rf=row_e;}var cf;if(ctx.luckysheet_select_save[0].column_focus===ctx.luckysheet_select_save[0].column[0]){cf=col_s;}else{cf=col_e;}var range=[];range.push({row:last.row,column:last.column});range.push({row:[row_s,row_e],column:[col_s,col_e]});last.row=[row_s,row_e];last.column=[col_s,col_e];last.row_focus=rf;last.column_focus=cf;ctx.luckysheet_select_save=normalizeSelection(ctx,[last]);var sheetIndex=getSheetIndex(ctx,ctx.currentSheetId);if(sheetIndex!=null){ctx.luckysheetfile[sheetIndex].config=lodash_default().assign({},cfg);}jfrefreshgrid(ctx,d,range);}function getNullData(rlen,clen){var arr=[];for(var r=0;r<rlen;r+=1){var rowArr=[];for(var c=0;c<clen;c+=1){rowArr.push("");}arr.push(rowArr);}return arr;}function updateMoreCell(r,c,dataMatrix,ctx){if(ctx.allowEdit===false)return;var flowdata=getFlowdata(ctx);dataMatrix.forEach(function(datas,i){datas.forEach(function(data,j){var v=dataMatrix[i][j];setCellValue(ctx,r+i,c+j,flowdata,v);});});}function getRegStr(regStr,splitSymbols){regStr="";var mark=0;for(var i=0;i<splitSymbols.length;i+=1){var split=splitSymbols[i];var inputNode=split.childNodes[0];if(inputNode.checked){var id=inputNode.id;if(id==="Tab"){regStr+="\\t";mark+=1;}else if(id==="semicolon"){if(mark>0){regStr+="|";}regStr+=";";mark=1;}else if(id==="comma"){if(mark>0){regStr+="|";}regStr+=",";mark+=1;}else if(id==="space"){if(mark>0){regStr+="|";}regStr+="\\s";mark+=1;}else if(id==="splitsimple"){regStr="[".concat(regStr,"]+");}else if(id==="other"){var txt=split.childNodes[2].value;if(txt!==""){if(mark>0){regStr+="|";}regStr+=txt;}}}}return regStr;}function getDataArr(regStr,ctx){var arr=[];var r1=ctx.luckysheet_select_save[0].row[0];var r2=ctx.luckysheet_select_save[0].row[1];var c=ctx.luckysheet_select_save[0].column[0];var data=getFlowdata(ctx);if(!lodash_default().isNull(regStr)&&regStr!==""){var reg=new RegExp(regStr,"g");var dataArr=[];for(var r=r1;r<=r2;r+=1){var rowArr=[];var cell=data[r][c];var value=void 0;if(!lodash_default().isNull(cell)&&!lodash_default().isNull(cell.m)){value=cell.m;}else{value=getCellValue(r,c,data);}if(lodash_default().isNull(value)||lodash_default().isUndefined(value)){value="";}rowArr=value.toString().split(reg);dataArr.push(rowArr);}var rlen=dataArr.length;var clen=0;for(var i=0;i<rlen;i+=1){if(dataArr[i].length>clen){clen=dataArr[i].length;}}arr=getNullData(rlen,clen);for(var _i=0;_i<arr.length;_i+=1){for(var j=0;j<arr[0].length;j+=1){if(dataArr[_i][j]!=null){arr[_i][j]=dataArr[_i][j];}}}}else{for(var _r=r1;_r<=r2;_r+=1){var _rowArr=[];var _cell=data[_r][c];var _value=void 0;if(!lodash_default().isNull(_cell)&&!lodash_default().isNull(_cell.m)){_value=_cell.m;}else{_value=getCellValue(_r,c,data);}if(lodash_default().isNull(_value)){_value="";}_rowArr.push(_value);arr.push(_rowArr);}}return arr;}function deleteCellInSave(cellSave,range){for(var r=range.row[0];r<=range.row[1];r+=1){for(var c=range.column[0];c<=range.column[1];c+=1){delete cellSave["".concat(r,"_").concat(c)];}}return cellSave;}function getRangeArr(minR,maxR,minC,maxC,cellSave,rangeArr,ctx){if(Object.keys(cellSave).length===0){return rangeArr;}var stack_str=null;var stack_edr=null;var stack_stc=null;var stack_edc=null;var flowData=getFlowdata(ctx,ctx.currentSheetId);for(var r=minR;r<=maxR;r+=1){for(var c=minC;c<=maxC;c+=1){if(lodash_default().isNil(flowData))break;var cell=flowData[r][c];if("".concat(r,"_").concat(c)in cellSave){var _cell$mc,_cell$mc2,_cell$mc3;if(!!(cell===null||cell===void 0?void 0:(_cell$mc=cell.mc)===null||_cell$mc===void 0?void 0:_cell$mc.cs)&&!!(cell===null||cell===void 0?void 0:(_cell$mc2=cell.mc)===null||_cell$mc2===void 0?void 0:_cell$mc2.rs)&&!!(cell===null||cell===void 0?void 0:(_cell$mc3=cell.mc)===null||_cell$mc3===void 0?void 0:_cell$mc3.r)){if(stack_stc===null){var range={row:[cell.mc.r,cell.mc.r+cell.mc.rs-1],column:[cell.mc.c,cell.mc.c+cell.mc.cs-1]};rangeArr.push(range);cellSave=deleteCellInSave(cellSave,range);return getRangeArr(minR,maxR,minC,maxC,cellSave,rangeArr,ctx);}if(stack_edc!==null&&c<stack_edc){var _range={row:[stack_str,stack_edr],column:[stack_stc,stack_edc]};rangeArr.push(_range);cellSave=deleteCellInSave(cellSave,_range);return getRangeArr(minR,maxR,minC,maxC,cellSave,rangeArr,ctx);}break;}else if(stack_stc===null){stack_stc=c;stack_edc=c;stack_str=r;stack_edr=r;}else if(stack_edc!==null&&c>stack_edc){stack_edc=c;}}else if(stack_stc!==null){if(cell!==null&&cell.mc!==null){break;}else if(c<stack_stc);else if(stack_edc!==null&&c<=stack_edc){var _range2={row:[stack_str,stack_edr],column:[stack_stc,stack_edc]};rangeArr.push(_range2);cellSave=deleteCellInSave(cellSave,_range2);return getRangeArr(minR,maxR,minC,maxC,cellSave,rangeArr,ctx);}else{stack_edr=r;}}}}if(stack_stc!==null){var _range3={row:[stack_str,stack_edr],column:[stack_stc,stack_edc]};rangeArr.push(_range3);cellSave=deleteCellInSave(cellSave,_range3);return getRangeArr(minR,maxR,minC,maxC,cellSave,rangeArr,ctx);}return rangeArr;}function getOptionValue(constants){var tempConstans=lodash_default().cloneDeep(constants);var len=lodash_default().filter(tempConstans,function(o){return o;}).length;var value;if(len===0){value="";}else if(len===5){value="all";}else{var arr=[];lodash_default().toPairs(constants).forEach(function(entry){var _entry=index_esm_slicedToArray(entry,2),k=_entry[0],v=_entry[1];if(v){if(k==="locationDate"){arr.push("d");}else if(k==="locationDigital"){arr.push("n");}else if(k==="locationString"){arr.push("s,g");}else if(k==="locationBool"){arr.push("b");}else if(k==="locationError"){arr.push("e");}}});value=arr.join(",");}return value;}function getSelectRange(ctx){var _ctx$luckysheet_selec,_ctx$luckysheet_selec2;var range;if(((_ctx$luckysheet_selec=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec===void 0?void 0:_ctx$luckysheet_selec.length)===0||((_ctx$luckysheet_selec2=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec2===void 0?void 0:_ctx$luckysheet_selec2.length)===1&&ctx.luckysheet_select_save[0].row[0]===ctx.luckysheet_select_save[0].row[1]&&ctx.luckysheet_select_save[0].column[0]===ctx.luckysheet_select_save[0].column[1]){var flowdata=getFlowdata(ctx,ctx.currentSheetId);if(lodash_default().isNil(flowdata))return[];range=[{row:[0,flowdata.length-1],column:[0,flowdata[0].length-1]}];}else{range=lodash_default().assignIn([],ctx.luckysheet_select_save);}return range;}function applyLocation(range,type,value,ctx){var rangeArr=[];if(type==="locationFormula"||type==="locationConstant"||type==="locationNull"){var minR=null;var maxR=null;var minC=null;var maxC=null;var cellSave={};var flowData=getFlowdata(ctx,ctx.currentSheetId);if(lodash_default().isNil(flowData))return[];for(var s=0;s<range.length;s+=1){var st_r=range[s].row[0];var ed_r=range[s].row[1];var st_c=range[s].column[0];var ed_c=range[s].column[1];if(minR===null||minR<st_r){minR=st_r;}if(maxR===null||maxR>ed_r){maxR=ed_r;}if(minC===null||minC<st_c){minC=st_c;}if(maxC===null||maxC>ed_c){maxC=ed_c;}for(var r=st_r;r<=ed_r;r+=1){for(var c=st_c;c<=ed_c;c+=1){var _cell,_cell2,_cell3,_cell3$ct;var cell=flowData[r][c];if((_cell=cell)===null||_cell===void 0?void 0:_cell.mc){cell=flowData[cell.mc.r][cell.mc.c];}if(type==="locationFormula"&&!!cell&&cell.v!==null&&!!cell.f&&(value==="all"||!!cell.ct&&!!value&&!!cell.ct.t&&value.indexOf(cell.ct.t)>-1)){cellSave["".concat(r,"_").concat(c)]=0;}else if(type==="locationConstant"&&((_cell2=cell)===null||_cell2===void 0?void 0:_cell2.v)&&(value==="all"||((_cell3=cell)===null||_cell3===void 0?void 0:(_cell3$ct=_cell3.ct)===null||_cell3$ct===void 0?void 0:_cell3$ct.t)&&value.indexOf(cell.ct.t)>-1)){cellSave["".concat(r,"_").concat(c)]=0;}else if(type==="locationNull"&&(cell===null||cell.v===null)){cellSave["".concat(r,"_").concat(c)]=0;}}}}rangeArr=getRangeArr(minR,maxR,minC,maxC,cellSave,rangeArr,ctx);}else if(type==="locationCF");else if(type==="locationRowSpan"){for(var _s=0;_s<range.length;_s+=1){if(range[_s].row[0]===range[_s].row[1]){continue;}var _st_r=range[_s].row[0];var _ed_r=range[_s].row[1];var _st_c=range[_s].column[0];var _ed_c=range[_s].column[1];for(var _r=_st_r;_r<=_ed_r;_r+=1){if((_r-_st_r)%2===0){rangeArr.push({row:[_r,_r],column:[_st_c,_ed_c]});}}}}else if(type==="locationColumnSpan"){for(var _s2=0;_s2<range.length;_s2+=1){if(range[_s2].column[0]===range[_s2].column[1]){continue;}var _st_r2=range[_s2].row[0];var _ed_r2=range[_s2].row[1];var _st_c2=range[_s2].column[0];var _ed_c2=range[_s2].column[1];for(var _c=_st_c2;_c<=_ed_c2;_c+=1){if((_c-_st_c2)%2===0){rangeArr.push({row:[_st_r2,_ed_r2],column:[_c,_c]});}}}}if(rangeArr.length===0){return rangeArr;}ctx.luckysheet_select_save=normalizeSelection(ctx,rangeArr);return rangeArr;}var ZOOM_STEP=0.1;var MAX_ZOOM_RATIO=4;var MIN_ZOOM_RATIO=0.1;function handleKeydownForZoom(ev,currentZoom){if(!ev.ctrlKey){return currentZoom;}var handled=false;var zoom=currentZoom||1;if(ev.key==="-"||ev.which===189){zoom-=ZOOM_STEP;handled=true;}else if(ev.key==="+"||ev.which===187){zoom+=ZOOM_STEP;handled=true;}else if(ev.key==="0"||ev.which===48){zoom=1;handled=true;}if(handled){ev.preventDefault();if(zoom>=MAX_ZOOM_RATIO){zoom=MAX_ZOOM_RATIO;}else if(zoom<MIN_ZOOM_RATIO){zoom=MIN_ZOOM_RATIO;}}return parseFloat(zoom.toFixed(1));}var addtionalMergeOps=function addtionalMergeOps(ops,id){var merge_new={};ops.some(function(op){if(op.op==="replace"&&op.path[0]==="config"&&op.path[1]==="merge"){merge_new=op.value;return true;}return false;});var new_ops=[];Object.entries(merge_new).forEach(function(_ref){var _ref2=index_esm_slicedToArray(_ref,2),v=_ref2[1];var r=v.r,c=v.c,rs=v.rs,cs=v.cs;var headerOp={op:"replace",path:["data",r,c,"mc"],id:id,value:v};for(var i=r;i<r+rs;i+=1){for(var j=c;j<c+cs;j+=1){new_ops.push({op:"replace",path:["data",i,j,"mc"],id:id,value:{r:r,c:c}});}}new_ops.push(headerOp);});return new_ops;};function additionalCellOps(ctx,insertRowColOp){var id=insertRowColOp.id,index=insertRowColOp.index,direction=insertRowColOp.direction,count=insertRowColOp.count,type=insertRowColOp.type;var d=getFlowdata(ctx,id);var startIndex=index+(direction==="rightbottom"?1:0);if(d==null){return[];}var cellOps=[];if(type==="row"){for(var i=0;i<d[startIndex].length;i+=1){var cell=d[startIndex][i];if(cell!=null){for(var j=0;j<count;j+=1){cellOps.push({op:"replace",id:id,path:["data",startIndex+j,i],value:cell});}}}}else{for(var _i=0;_i<d.length;_i+=1){var _cell=d[_i][startIndex];if(_cell!=null){for(var _j=0;_j<count;_j+=1){cellOps.push({op:"replace",id:id,path:["data",_i,startIndex+_j],value:_cell});}}}}return cellOps;}function filterPatch(patches){return lodash_default().filter(patches,function(p){return p.path[0]==="luckysheetfile"&&p.path[2]!=="luckysheet_select_save";});}function extractFormulaCellOps(ops){var formulaOps=[];ops.forEach(function(op){var _op$value;if(op.op==="remove")return;if(op.path.length===2&&Array.isArray(op.value)){for(var i=0;i<op.value.length;i+=1){var _op$value$i;if((_op$value$i=op.value[i])===null||_op$value$i===void 0?void 0:_op$value$i.f){formulaOps.push({op:"replace",id:op.id,path:[].concat(index_esm_toConsumableArray(op.path),[i]),value:op.value[i]});}}}else if(op.path.length===3&&((_op$value=op.value)===null||_op$value===void 0?void 0:_op$value.f)){formulaOps.push(op);}else if(op.path.length===4&&op.path[3]==="f"){formulaOps.push(op);}});return formulaOps;}function patchToOp(ctx,patches,options){var undo=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var ops=patches.map(function(p){var op={op:p.op,value:p.value,path:p.path};if(p.path[0]==="luckysheetfile"&&lodash_default().isNumber(p.path[1])){var id=ctx.luckysheetfile[p.path[1]].id;op.id=id;op.path=p.path.slice(2);if(lodash_default().isEqual(op.path,["calcChain","length"])){op.path=["calcChain"];op.value=ctx.luckysheetfile[p.path[1]].calcChain;}}return op;});lodash_default().every(ops,function(p){var _p$value;if(p.op==="replace"&&!lodash_default().isNil((_p$value=p.value)===null||_p$value===void 0?void 0:_p$value.hl)&&p.path.length===3&&p.path[0]==="data"){var index=getSheetIndex(ctx,p.id);ops.push({id:p.id,op:"replace",path:["hyperlink","".concat(p.path[1],"_").concat(p.path[2])],value:ctx.luckysheetfile[index].hyperlink["".concat(p.value.hl.r,"_").concat(p.value.hl.c)]});}});if(options===null||options===void 0?void 0:options.insertRowColOp){var _$partition=lodash_default().partition(ops,function(p){return p.path[0]!=="data";}),_$partition2=index_esm_slicedToArray(_$partition,2),nonDataOps=_$partition2[0],dataOps=_$partition2[1];var formulaOps=extractFormulaCellOps(dataOps);ops=nonDataOps;ops.push({op:"insertRowCol",id:options.insertRowColOp.id,path:[],value:options.insertRowColOp});ops=[].concat(index_esm_toConsumableArray(ops),index_esm_toConsumableArray(formulaOps));var mergeOps=addtionalMergeOps(ops,ctx.currentSheetId);ops=[].concat(index_esm_toConsumableArray(ops),index_esm_toConsumableArray(mergeOps));if(options===null||options===void 0?void 0:options.restoreDeletedCells){var restoreCellsOps=[];var flowdata=getFlowdata(ctx);if(flowdata){var rowlen=flowdata.length;var collen=flowdata[0].length;for(var i=0;i<rowlen;i+=1){for(var j=0;j<collen;j+=1){var cell=flowdata[i][j];if(!cell)continue;if(options.insertRowColOp.type==="row"&&i>=options.insertRowColOp.index&&i<options.insertRowColOp.index+options.insertRowColOp.count||options.insertRowColOp.type==="column"&&j>=options.insertRowColOp.index&&j<options.insertRowColOp.index+options.insertRowColOp.count){restoreCellsOps.push({op:"replace",path:["data",i,j],id:ctx.currentSheetId,value:cell});}}}}ops=[].concat(index_esm_toConsumableArray(ops),restoreCellsOps);}else{var cellOps=additionalCellOps(ctx,options.insertRowColOp);ops=[].concat(index_esm_toConsumableArray(ops),index_esm_toConsumableArray(cellOps));}}else if(options===null||options===void 0?void 0:options.deleteRowColOp){var _$partition3=lodash_default().partition(ops,function(p){return p.path[0]!=="data";}),_$partition4=index_esm_slicedToArray(_$partition3,2),_nonDataOps=_$partition4[0],_dataOps=_$partition4[1];var _formulaOps=extractFormulaCellOps(_dataOps);ops=_nonDataOps;ops.push({op:"deleteRowCol",id:options.deleteRowColOp.id,path:[],value:options.deleteRowColOp});ops=[].concat(index_esm_toConsumableArray(ops),index_esm_toConsumableArray(_formulaOps));var _mergeOps=addtionalMergeOps(ops,ctx.currentSheetId);ops=[].concat(index_esm_toConsumableArray(ops),index_esm_toConsumableArray(_mergeOps));}else if(options===null||options===void 0?void 0:options.addSheetOp){var _$partition5=lodash_default().partition(ops,function(op){return op.path.length===0&&op.op==="add";}),_$partition6=index_esm_slicedToArray(_$partition5,2),addSheetOps=_$partition6[0],otherOps=_$partition6[1];options.id=options.addSheet.id;if(undo){var _options$addSheet,_options$addSheet$val,_options$addSheet2;var index=getSheetIndex(ctx,options.addSheet.id);var order=(_options$addSheet=options.addSheet)===null||_options$addSheet===void 0?void 0:(_options$addSheet$val=_options$addSheet.value)===null||_options$addSheet$val===void 0?void 0:_options$addSheet$val.order;ops=otherOps;ops.push({op:"deleteSheet",id:(_options$addSheet2=options.addSheet)===null||_options$addSheet2===void 0?void 0:_options$addSheet2.id,path:[],value:options.addSheet});if(index!==ctx.luckysheetfile.length){var sheetsRight=ctx.luckysheetfile.filter(function(sheet){return(sheet===null||sheet===void 0?void 0:sheet.order)>=order;});lodash_default().forEach(sheetsRight,function(sheet){ops.push({id:sheet.id,op:"replace",path:["order"],value:(sheet===null||sheet===void 0?void 0:sheet.order)-1});});}}else{var _options$addSheet3,_addSheetOps$;ops=otherOps;ops.push({op:"addSheet",id:(_options$addSheet3=options.addSheet)===null||_options$addSheet3===void 0?void 0:_options$addSheet3.id,path:[],value:(_addSheetOps$=addSheetOps[0])===null||_addSheetOps$===void 0?void 0:_addSheetOps$.value});}}else if(options===null||options===void 0?void 0:options.deleteSheetOp){options.id=options.deleteSheetOp.id;if(undo){var _options$deletedSheet,_options$deletedSheet2,_options$deletedSheet3,_options$deletedSheet4,_options$deletedSheet5;ops=[{op:"addSheet",id:options.deleteSheetOp.id,path:[],value:(_options$deletedSheet=options.deletedSheet)===null||_options$deletedSheet===void 0?void 0:_options$deletedSheet.value},{id:options.deleteSheetOp.id,op:"replace",path:["name"],value:(_options$deletedSheet2=options.deletedSheet)===null||_options$deletedSheet2===void 0?void 0:(_options$deletedSheet3=_options$deletedSheet2.value)===null||_options$deletedSheet3===void 0?void 0:_options$deletedSheet3.name}];var _order=(_options$deletedSheet4=options.deletedSheet)===null||_options$deletedSheet4===void 0?void 0:(_options$deletedSheet5=_options$deletedSheet4.value)===null||_options$deletedSheet5===void 0?void 0:_options$deletedSheet5.order;var _sheetsRight=ctx.luckysheetfile.filter(function(sheet){var _options$deleteSheetO;return(sheet===null||sheet===void 0?void 0:sheet.order)>=_order&&sheet.id!==((_options$deleteSheetO=options.deleteSheetOp)===null||_options$deleteSheetO===void 0?void 0:_options$deleteSheetO.id);});lodash_default().forEach(_sheetsRight,function(sheet){ops.push({id:sheet.id,op:"replace",path:["order"],value:sheet===null||sheet===void 0?void 0:sheet.order});});}else{var _options$deletedSheet6,_options$deletedSheet7,_options$deletedSheet8;ops=[{op:"deleteSheet",id:options.deleteSheetOp.id,path:[],value:options.deletedSheet}];var _order2=(_options$deletedSheet6=options.deletedSheet)===null||_options$deletedSheet6===void 0?void 0:(_options$deletedSheet7=_options$deletedSheet6.value)===null||_options$deletedSheet7===void 0?void 0:_options$deletedSheet7.order;if(((_options$deletedSheet8=options.deletedSheet)===null||_options$deletedSheet8===void 0?void 0:_options$deletedSheet8.order)!==ctx.luckysheetfile.length){var _sheetsRight2=ctx.luckysheetfile.filter(function(sheet){return(sheet===null||sheet===void 0?void 0:sheet.order)>=_order2;});lodash_default().forEach(_sheetsRight2,function(sheet){ops.push({id:sheet.id,op:"replace",path:["order"],value:sheet===null||sheet===void 0?void 0:sheet.order});});}}}return ops;}function opToPatch(ctx,ops){var _$partition7=lodash_default().partition(ops,function(op){return op.op==="add"||op.op==="remove"||op.op==="replace";}),_$partition8=index_esm_slicedToArray(_$partition7,2),normalOps=_$partition8[0],specialOps=_$partition8[1];var additionalPatches=[];var patches=normalOps.map(function(op){var patch={op:op.op,value:op.value,path:op.path};if(op.id){var i=getSheetIndex(ctx,op.id);if(i!=null){patch.path=["luckysheetfile",i].concat(index_esm_toConsumableArray(op.path));}if(op.path[0]==="images"&&op.id===ctx.currentSheetId){additionalPatches.push(_objectSpread2(_objectSpread2({},patch),{},{path:["insertedImgs"]}));}}return patch;});return[patches.concat(additionalPatches),specialOps];}function inverseRowColOptions(options){if(!options)return options;if(options.insertRowColOp){var index=options.insertRowColOp.index;if(options.insertRowColOp.direction==="rightbottom"){index+=1;}return{deleteRowColOp:{type:options.insertRowColOp.type,id:options.insertRowColOp.id,start:index,end:index+options.insertRowColOp.count-1}};}if(options.deleteRowColOp){return{insertRowColOp:{type:options.deleteRowColOp.type,id:options.deleteRowColOp.id,index:options.deleteRowColOp.start,count:options.deleteRowColOp.end-options.deleteRowColOp.start+1,direction:"lefttop"}};}return options;}function generateRandomSheetName(file,isPivotTable,ctx){var index=file.length;var locale_pivotTable=locale(ctx).pivotTable;var title=locale_pivotTable.title;for(var i=0;i<file.length;i+=1){if(file[i].name.indexOf("Sheet")>-1||file[i].name.indexOf(title)>-1){var suffix=parseFloat(file[i].name.replace("Sheet","").replace(title,""));if(!Number.isNaN(suffix)&&Math.ceil(suffix)>index){index=Math.ceil(suffix);}}}if(isPivotTable){return title+(index+1);}return"Sheet".concat(index+1);}function rgbToHex(color){var rgb;if(color.indexOf("rgba")>-1){rgb=color.replace("rgba(","").replace(")","").split(",");}else{rgb=color.replace("rgb(","").replace(")","").split(",");}var r=Number(rgb[0]);var g=Number(rgb[1]);var b=Number(rgb[2]);return"#".concat(((1<<24)+(r<<16)+(g<<8)+b).toString(16).slice(1));}function indexToColumnChar(n){var orda="a".charCodeAt(0);var ordz="z".charCodeAt(0);var len=ordz-orda+1;var s="";while(n>=0){s=String.fromCharCode(n%len+orda)+s;n=Math.floor(n/len)-1;}return s.toUpperCase();}function columnCharToIndex(a){if(a==null||a.length===0){return NaN;}var str=a.toLowerCase().split("");var al=str.length;var getCharNumber=function getCharNumber(charx){return charx.charCodeAt(0)-96;};var numout=0;var charnum=0;for(var i=0;i<al;i+=1){charnum=getCharNumber(str[i]);numout+=charnum*Math.pow(26,al-i-1);}if(numout===0){return NaN;}return numout-1;}function escapeScriptTag(str){if(typeof str!=="string")return str;return str.replace(/<script>/g,"&lt;script&gt;").replace(/<\/script>/,"&lt;/script&gt;");}function escapeHTMLTag(str){if(typeof str!=="string")return str;if(str.substr(0,5)==="<span"||lodash_default().startsWith(str,"=")){return str;}return str.replace(/</g,"&lt;").replace(/>/g,"&gt;");}function getSheetIndex(ctx,id){for(var i=0;i<ctx.luckysheetfile.length;i+=1){var _ctx$luckysheetfile$i;if(((_ctx$luckysheetfile$i=ctx.luckysheetfile[i])===null||_ctx$luckysheetfile$i===void 0?void 0:_ctx$luckysheetfile$i.id)===id){return i;}}return null;}function getSheetIdByName(ctx,name){for(var i=0;i<ctx.luckysheetfile.length;i+=1){if(ctx.luckysheetfile[i].name===name){return ctx.luckysheetfile[i].id;}}return null;}function getSheetByIndex(ctx,id){if(lodash_default().isNil(id)){id=ctx.currentSheetId;}var i=getSheetIndex(ctx,id);if(lodash_default().isNil(i)){return null;}return ctx.luckysheetfile[i];}function getNowDateTime(format){var now=new Date();var year=now.getFullYear();var month=now.getMonth();var date=now.getDate();var hour=now.getHours();var minu=now.getMinutes();var sec=now.getSeconds();month+=1;if(month<10)month="0".concat(month);if(date<10)date="0".concat(date);if(hour<10)hour="0".concat(hour);if(minu<10)minu="0".concat(minu);if(sec<10)sec="0".concat(sec);var time="";if(format===1){time="".concat(year,"-").concat(month,"-").concat(date);}else if(format===2){time="".concat(year,"-").concat(month,"-").concat(date," ").concat(hour,":").concat(minu,":").concat(sec);}return time;}function replaceHtml(temp,dataarry){return temp.replace(/\$\{([\w]+)\}/g,function(s1,s2){var s=dataarry[s2];if(typeof s!=="undefined"){return s;}return s1;});}function getRegExpStr(str){return str.replace("~*","\\*").replace("~?","\\?").replace(".","\\.").replace("*",".*").replace("?",".");}function chatatABC(n){var orda="a".charCodeAt(0);var ordz="z".charCodeAt(0);var len=ordz-orda+1;var s="";while(n>=0){s=String.fromCharCode(n%len+orda)+s;n=Math.floor(n/len)-1;}return s.toUpperCase();}function isAllowEdit(ctx,range){var cfg=ctx.config;var judgeRange=lodash_default().isUndefined(range)?ctx.luckysheet_select_save:range;return lodash_default().every(judgeRange,function(selection){for(var r=selection.row[0];r<=selection.row[1];r+=1){var _cfg$rowReadOnly;if((_cfg$rowReadOnly=cfg.rowReadOnly)===null||_cfg$rowReadOnly===void 0?void 0:_cfg$rowReadOnly[r]){return false;}}for(var c=selection.column[0];c<=selection.column[1];c+=1){var _cfg$colReadOnly;if((_cfg$colReadOnly=cfg.colReadOnly)===null||_cfg$colReadOnly===void 0?void 0:_cfg$colReadOnly[c]){return false;}}for(var _r=selection.row[0];_r<=selection.row[1];_r+=1){for(var _c=selection.column[0];_c<=selection.column[1];_c+=1){if(checkCellIsLocked(ctx,_r,_c,ctx.currentSheetId)){return false;}}}return true;})&&(lodash_default().isUndefined(ctx.allowEdit)?true:ctx.allowEdit);}var INVALID_PARAMS=new Error("invalid params");var SHEET_NOT_FOUND=new Error("sheet not found");var dataToCelldata=function dataToCelldata(data){var celldata=[];if(data==null){return celldata;}for(var r=0;r<data.length;r+=1){for(var c=0;c<data[r].length;c+=1){var v=data[r][c];if(v!=null){celldata.push({r:r,c:c,v:v});}}}return celldata;};var celldataToData=function celldataToData(celldata,rowCount,colCount){var _lastRow$r,_lastCol$c;var lastRow=lodash_default().maxBy(celldata,"r");var lastCol=lodash_default().maxBy(celldata,"c");var lastRowNum=((_lastRow$r=lastRow===null||lastRow===void 0?void 0:lastRow.r)!==null&&_lastRow$r!==void 0?_lastRow$r:0)+1;var lastColNum=((_lastCol$c=lastCol===null||lastCol===void 0?void 0:lastCol.c)!==null&&_lastCol$c!==void 0?_lastCol$c:0)+1;if(rowCount!=null&&colCount!=null&&rowCount>0&&colCount>0){lastRowNum=Math.max(lastRowNum,rowCount);lastColNum=Math.max(lastColNum,colCount);}if(lastRowNum&&lastColNum){var expandedData=lodash_default().times(lastRowNum,function(){return lodash_default().times(lastColNum,function(){return null;});});celldata===null||celldata===void 0?void 0:celldata.forEach(function(d){expandedData[d.r][d.c]=d.v;});return expandedData;}return null;};function getSheet(ctx){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var _options$index=options.index,index=_options$index===void 0?getSheetIndex(ctx,options.id||ctx.currentSheetId):_options$index;if(index==null){throw SHEET_NOT_FOUND;}var sheet=ctx.luckysheetfile[index];if(sheet==null){throw SHEET_NOT_FOUND;}return sheet;}function getSheetWithLatestCelldata(ctx){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var sheet=getSheet(ctx,options);return _objectSpread2(_objectSpread2({},sheet),{},{celldata:dataToCelldata(sheet.data)});}function getCellValue$1(ctx,row,column){var options=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};if(!lodash_default().isNumber(row)||!lodash_default().isNumber(column)){throw new Error("row or column cannot be null or undefined");}var sheet=getSheet(ctx,options);var _options$type=options.type,type=_options$type===void 0?"v":_options$type;var targetSheetData=sheet.data;if(!targetSheetData){throw SHEET_NOT_FOUND;}var cellData=targetSheetData[row][column];var ret;if(cellData&&lodash_default().isPlainObject(cellData)){var _cellData$ct;ret=cellData[type];if(type==="f"&&ret!=null){ret=functionHTMLGenerate(ret);}else if(type==="f"){ret=cellData.v;}else if(cellData&&cellData.ct&&cellData.ct.fa==="yyyy-MM-dd"){ret=cellData.m;}else if(((_cellData$ct=cellData.ct)===null||_cellData$ct===void 0?void 0:_cellData$ct.t)==="inlineStr"){ret=cellData.ct.s.reduce(function(prev,cur){var _cur$v;return prev+((_cur$v=cur.v)!==null&&_cur$v!==void 0?_cur$v:"");},"");}}if(ret===undefined){ret=null;}return ret;}function setCellValue$1(ctx,row,column,value,cellInput){var options=arguments.length>5&&arguments[5]!==undefined?arguments[5]:{};if(!lodash_default().isNumber(row)||!lodash_default().isNumber(column)){throw new Error("row or column cannot be null or undefined");}var sheet=getSheet(ctx,options);var data=sheet.data;var formatList={bg:1,ff:1,fc:1,bl:1,it:1,fs:1,cl:1,un:1,vt:1,ht:1,mc:1,tr:1,tb:1,rt:1,qp:1};if(value==null||value.toString().length===0){delFunctionGroup(ctx,row,column);setCellValue(ctx,row,column,data,value);}else if(value instanceof Object){var _data$row;var curv={};if((data===null||data===void 0?void 0:(_data$row=data[row])===null||_data$row===void 0?void 0:_data$row[column])==null){data[row][column]={};}var cell=data[row][column];if(value.f!=null&&value.v==null){curv.f=value.f;if(value.ct!=null){curv.ct=value.ct;}updateCell(ctx,row,column,cellInput,curv);}else{if(value.ct!=null){curv.ct=value.ct;}if(value.f!=null){curv.f=value.f;}if(value.v!=null){curv.v=value.v;}else{curv.v=cell.v;}if(value.m!=null){curv.m=value.m;}delFunctionGroup(ctx,row,column);setCellValue(ctx,row,column,data,curv);}lodash_default().forEach(value,function(v,attr){if(attr in formatList){updateFormatCell(ctx,data,attr,v,row,row,column,column);}else{cell[attr]=v;}});data[row][column]=cell;}else{if(value.toString().substr(0,1)==="="||value.toString().substr(0,5)==="<span"){updateCell(ctx,row,column,cellInput,value);}else{delFunctionGroup(ctx,row,column);setCellValue(ctx,row,column,data,value);}}}function clearCell(ctx,row,column){var _sheet$data,_sheet$data$row;var options=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};if(!lodash_default().isNumber(row)||!lodash_default().isNumber(column)){throw new Error("row or column cannot be null or undefined");}var sheet=getSheet(ctx,options);var cell=(_sheet$data=sheet.data)===null||_sheet$data===void 0?void 0:(_sheet$data$row=_sheet$data[row])===null||_sheet$data$row===void 0?void 0:_sheet$data$row[column];if(cell&&lodash_default().isPlainObject(cell)){delete cell.m;delete cell.v;if(cell.f!=null){delete cell.f;delFunctionGroup(ctx,row,column,sheet.id);delete cell.spl;}}}function setCellFormat(ctx,row,column,attr,value){var _targetSheetData$row;var options=arguments.length>5&&arguments[5]!==undefined?arguments[5]:{};if(!lodash_default().isNumber(row)||!lodash_default().isNumber(column)){throw new Error("row or column cannot be null or undefined");}if(!attr){throw new Error("attr cannot be null or undefined");}var sheet=getSheet(ctx,options);var targetSheetData=sheet.data;var cellData=(targetSheetData===null||targetSheetData===void 0?void 0:(_targetSheetData$row=targetSheetData[row])===null||_targetSheetData$row===void 0?void 0:_targetSheetData$row[column])||{};var cfg=sheet.config||{};if(attr==="ct"&&(!value||value.fa==null||value.t==null)){throw new Error("'fa' and 't' should be present in value when attr is 'ct'");}else if(attr==="ct"&&!lodash_default().isNil(cellData.v)){cellData.m=SSF.format(value.fa,cellData.v);}if(attr==="bd"){if(cfg.borderInfo==null){cfg.borderInfo=[];}var borderInfo=_objectSpread2({rangeType:"range",borderType:"border-all",color:"#000",style:"1",range:[{column:[column,column],row:[row,row]}]},value);cfg.borderInfo.push(borderInfo);}else{cellData[attr]=value;}targetSheetData[row][column]=cellData;sheet.config=cfg;ctx.config=cfg;}function autoFillCell(ctx,copyRange,applyRange,direction){dropCellCache.copyRange=copyRange;dropCellCache.applyRange=applyRange;dropCellCache.direction=direction;var typeItemHide=getTypeItemHide(ctx);if(!typeItemHide[0]&&!typeItemHide[1]&&!typeItemHide[2]&&!typeItemHide[3]&&!typeItemHide[4]&&!typeItemHide[5]&&!typeItemHide[6]){dropCellCache.applyType="0";}else{dropCellCache.applyType="1";}updateDropCell(ctx);}function freeze(ctx,type,range){var options=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};var sheet=getSheet(ctx,options);var typeMap={row:"rangeRow",column:"rangeColumn",both:"rangeBoth"};var innerType=typeMap[type];sheet.frozen={type:innerType,range:{column_focus:range.column,row_focus:range.row}};}function insertRowOrColumn(ctx,type,index,count,direction){var options=arguments.length>5&&arguments[5]!==undefined?arguments[5]:{};if(!["row","column"].includes(type)||!lodash_default().isNumber(index)||!lodash_default().isNumber(count)||!["lefttop","rightbottom"].includes(direction)){throw INVALID_PARAMS;}var sheet=getSheet(ctx,options);try{insertRowCol(ctx,{type:type,index:index,count:count,direction:direction,id:sheet.id});}catch(e){console.error(e);}}function deleteRowOrColumn(ctx,type,start,end){var options=arguments.length>4&&arguments[4]!==undefined?arguments[4]:{};if(!["row","column"].includes(type)||!lodash_default().isNumber(start)||!lodash_default().isNumber(end)){throw INVALID_PARAMS;}var sheet=getSheet(ctx,options);deleteRowCol(ctx,{type:type,start:start,end:end,id:sheet.id});}function hideRowOrColumn(ctx,rowColInfo,type){if(!["row","column"].includes(type)){throw INVALID_PARAMS;}if(!ctx||!ctx.config)return;var index=getSheetIndex(ctx,ctx.currentSheetId);if(type==="row"){var _ctx$config$rowhidden;var rowhidden=(_ctx$config$rowhidden=ctx.config.rowhidden)!==null&&_ctx$config$rowhidden!==void 0?_ctx$config$rowhidden:{};rowColInfo.forEach(function(r){rowhidden[r]=0;});ctx.config.rowhidden=rowhidden;}else if(type==="column"){var _ctx$config$colhidden;var colhidden=(_ctx$config$colhidden=ctx.config.colhidden)!==null&&_ctx$config$colhidden!==void 0?_ctx$config$colhidden:{};rowColInfo.forEach(function(r){colhidden[r]=0;});ctx.config.colhidden=colhidden;}ctx.luckysheetfile[index].config=ctx.config;}function showRowOrColumn(ctx,rowColInfo,type){if(!["row","column"].includes(type)){throw INVALID_PARAMS;}if(!ctx||!ctx.config)return;var index=getSheetIndex(ctx,ctx.currentSheetId);if(type==="row"){var _ctx$config$rowhidden2;var rowhidden=(_ctx$config$rowhidden2=ctx.config.rowhidden)!==null&&_ctx$config$rowhidden2!==void 0?_ctx$config$rowhidden2:{};rowColInfo.forEach(function(r){delete rowhidden[r];});ctx.config.rowhidden=rowhidden;}else if(type==="column"){var _ctx$config$colhidden2;var colhidden=(_ctx$config$colhidden2=ctx.config.colhidden)!==null&&_ctx$config$colhidden2!==void 0?_ctx$config$colhidden2:{};rowColInfo.forEach(function(r){delete colhidden[r];});ctx.config.colhidden=colhidden;}ctx.luckysheetfile[index].config=ctx.config;}function setRowHeight(ctx,rowInfo){var options=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var custom=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;if(!lodash_default().isPlainObject(rowInfo)){throw INVALID_PARAMS;}var sheet=getSheet(ctx,options);var cfg=sheet.config||{};if(cfg.rowlen==null){cfg.rowlen={};}lodash_default().forEach(rowInfo,function(len,r){if(Number(r)>=0){if(Number(len)>=0){cfg.rowlen[Number(r)]=Number(len);if(custom&&lodash_default().isUndefined(cfg.customHeight)){cfg.customHeight=index_esm_defineProperty({},r,1);}else if(custom){cfg.customHeight[r]=1;}}}});sheet.config=cfg;if(ctx.currentSheetId===sheet.id){ctx.config=cfg;}}function setColumnWidth(ctx,columnInfo){var options=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var custom=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;if(!lodash_default().isPlainObject(columnInfo)){throw INVALID_PARAMS;}var sheet=getSheet(ctx,options);var cfg=sheet.config||{};if(cfg.columnlen==null){cfg.columnlen={};}lodash_default().forEach(columnInfo,function(len,c){if(Number(c)>=0){if(Number(len)>=0){cfg.columnlen[Number(c)]=Number(len);if(custom&&lodash_default().isUndefined(cfg.customWidth)){cfg.customWidth=index_esm_defineProperty({},c,1);}else if(custom){cfg.customWidth[c]=1;}}}});sheet.config=cfg;if(ctx.currentSheetId===sheet.id){ctx.config=cfg;}}function getRowHeight(ctx,rows){var options=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};if(!lodash_default().isArray(rows)||rows.length===0){throw INVALID_PARAMS;}var sheet=getSheet(ctx,options);var cfg=sheet.config||{};var rowlen=cfg.rowlen||{};var rowlenObj={};rows.forEach(function(item){if(Number(item)>=0){var size=rowlen[Number(item)]||ctx.defaultrowlen;rowlenObj[Number(item)]=size;}});return rowlenObj;}function getColumnWidth(ctx,columns){var options=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};if(!lodash_default().isArray(columns)||columns.length===0){throw INVALID_PARAMS;}var sheet=getSheet(ctx,options);var cfg=sheet.config||{};var columnlen=cfg.columnlen||{};var columnlenObj={};columns.forEach(function(item){if(Number(item)>=0){var size=columnlen[Number(item)]||ctx.defaultcollen;columnlenObj[Number(item)]=size;}});return columnlenObj;}function getSelection(ctx){var _ctx$luckysheet_selec;return(_ctx$luckysheet_selec=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec===void 0?void 0:_ctx$luckysheet_selec.map(function(selection){return{row:selection.row,column:selection.column};});}function getFlattenRange(ctx,range){var _range;range=range||getSelection(ctx);var result=[];(_range=range)===null||_range===void 0?void 0:_range.forEach(function(ele){var rs=ele.row;var cs=ele.column;for(var r=rs[0];r<=rs[1];r+=1){for(var c=cs[0];c<=cs[1];c+=1){result.push({r:r,c:c});}}});return result;}function getCellsByFlattenRange(ctx,range){range=range||getFlattenRange(ctx);var flowdata=getFlowdata(ctx);if(!flowdata)return[];return range.map(function(item){var _flowdata$item$r;return(_flowdata$item$r=flowdata[item.r])===null||_flowdata$item$r===void 0?void 0:_flowdata$item$r[item.c];});}function getSelectionCoordinates(ctx){var result=[];var rangeArr=lodash_default().cloneDeep(ctx.luckysheet_select_save);var sheetId=ctx.currentSheetId;rangeArr===null||rangeArr===void 0?void 0:rangeArr.forEach(function(ele){var rangeText=getRangetxt(ctx,sheetId,{column:ele.column,row:ele.row});result.push(rangeText);});return result;}function getCellsByRange(ctx,range){var options=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var sheet=getSheet(ctx,options);if(!range||index_esm_typeof(range)==="object"){return getdatabyselection(ctx,range,sheet.id);}throw INVALID_PARAMS;}function getHtmlByRange(ctx,range){var options=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var sheet=getSheet(ctx,options);return rangeValueToHtml(ctx,sheet.id,range);}function setSelection(ctx,range,options){var sheet=getSheet(ctx,options);sheet.luckysheet_select_save=normalizeSelection(ctx,range);if(ctx.currentSheetId===sheet.id){ctx.luckysheet_select_save=sheet.luckysheet_select_save;}}function setCellValuesByRange(ctx,data,range,cellInput){var options=arguments.length>4&&arguments[4]!==undefined?arguments[4]:{};if(data==null){throw INVALID_PARAMS;}if(range instanceof Array){throw new Error("setCellValuesByRange does not support multiple ranges");}if(!lodash_default().isPlainObject(range)){throw INVALID_PARAMS;}var rowCount=range.row[1]-range.row[0]+1;var columnCount=range.column[1]-range.column[0]+1;if(data.length!==rowCount||data[0].length!==columnCount){throw new Error("data size does not match range");}for(var i=0;i<rowCount;i+=1){for(var j=0;j<columnCount;j+=1){var row=range.row[0]+i;var column=range.column[0]+j;setCellValue$1(ctx,row,column,data[i][j],cellInput,options);}}}function setCellFormatByRange(ctx,attr,value,range){var options=arguments.length>4&&arguments[4]!==undefined?arguments[4]:{};if(lodash_default().isPlainObject(range)){range=[range];}if(!lodash_default().isArray(range)){throw INVALID_PARAMS;}range.forEach(function(singleRange){for(var r=singleRange.row[0];r<=singleRange.row[1];r+=1){for(var c=singleRange.column[0];c<=singleRange.column[1];c+=1){setCellFormat(ctx,r,c,attr,value,options);}}});}function mergeCells$1(ctx,ranges,type){var options=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};var sheet=getSheet(ctx,options);mergeCells(ctx,sheet.id,ranges,type);}function cancelMerge(ctx,ranges){var options=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};mergeCells$1(ctx,ranges,"merge-cancel",options);}function addSheet$1(ctx,settings,newSheetID){var isPivotTable=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var sheetname=arguments.length>4&&arguments[4]!==undefined?arguments[4]:undefined;var sheetData=arguments.length>5&&arguments[5]!==undefined?arguments[5]:undefined;addSheet(ctx,settings,newSheetID,isPivotTable,sheetname,sheetData);}function deleteSheet$1(ctx){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var sheet=getSheet(ctx,options);deleteSheet(ctx,sheet.id);}function updateSheet$1(ctx,data){updateSheet(ctx,data);}function activateSheet(ctx){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var sheet=getSheet(ctx,options);ctx.currentSheetId=sheet.id;}function setSheetName(ctx,name){var options=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var sheet=getSheet(ctx,options);sheet.name=name;}function setSheetOrder(ctx,orderList){var _ctx$luckysheetfile;(_ctx$luckysheetfile=ctx.luckysheetfile)===null||_ctx$luckysheetfile===void 0?void 0:_ctx$luckysheetfile.forEach(function(sheet){if(sheet.id in orderList){sheet.order=orderList[sheet.id];}});lodash_default().sortBy(ctx.luckysheetfile,["order"]).forEach(function(sheet,i){sheet.order=i;});}function index_esm_scroll(ctx,scrollbarX,scrollbarY,options){if(options.scrollLeft!=null){if(!lodash_default().isNumber(options.scrollLeft)){throw INVALID_PARAMS;}if(scrollbarX){scrollbarX.scrollLeft=options.scrollLeft;}}else if(options.targetColumn!=null){if(!lodash_default().isNumber(options.targetColumn)){throw INVALID_PARAMS;}var col_pre=options.targetColumn<=0?0:ctx.visibledatacolumn[options.targetColumn-1];if(scrollbarX){scrollbarX.scrollLeft=col_pre;}}if(options.scrollTop!=null){if(!lodash_default().isNumber(options.scrollTop)){throw INVALID_PARAMS;}if(scrollbarY){scrollbarY.scrollTop=options.scrollTop;}}else if(options.targetRow!=null){if(!lodash_default().isNumber(options.targetRow)){throw INVALID_PARAMS;}var row_pre=options.targetRow<=0?0:ctx.visibledatarow[options.targetRow-1];if(scrollbarY){scrollbarY.scrollTop=row_pre;}}}var index_esm_index=/*#__PURE__*/Object.freeze({__proto__:null,getSheetWithLatestCelldata:getSheetWithLatestCelldata,dataToCelldata:dataToCelldata,celldataToData:celldataToData,getCellValue:getCellValue$1,setCellValue:setCellValue$1,clearCell:clearCell,setCellFormat:setCellFormat,autoFillCell:autoFillCell,freeze:freeze,insertRowOrColumn:insertRowOrColumn,deleteRowOrColumn:deleteRowOrColumn,hideRowOrColumn:hideRowOrColumn,showRowOrColumn:showRowOrColumn,setRowHeight:setRowHeight,setColumnWidth:setColumnWidth,getRowHeight:getRowHeight,getColumnWidth:getColumnWidth,getSelection:getSelection,getFlattenRange:getFlattenRange,getCellsByFlattenRange:getCellsByFlattenRange,getSelectionCoordinates:getSelectionCoordinates,getCellsByRange:getCellsByRange,getHtmlByRange:getHtmlByRange,setSelection:setSelection,setCellValuesByRange:setCellValuesByRange,setCellFormatByRange:setCellFormatByRange,mergeCells:mergeCells$1,cancelMerge:cancelMerge,getAllSheets:getAllSheets,getSheet:getSheet,initSheetData:initSheetData,hideSheet:hideSheet,showSheet:showSheet,copySheet:copySheet,calculateSheetFromula:calculateSheetFromula,addSheet:addSheet$1,deleteSheet:deleteSheet$1,updateSheet:updateSheet$1,activateSheet:activateSheet,setSheetName:setSheetName,setSheetOrder:setSheetOrder,scroll:index_esm_scroll});var defaultSettings={column:60,row:84,addRows:50,showToolbar:true,showFormulaBar:true,showSheetTabs:true,data:[],config:{},devicePixelRatio:0,allowEdit:true,lang:null,forceCalculation:false,rowHeaderWidth:46,columnHeaderHeight:20,defaultColWidth:73,defaultRowHeight:19,defaultFontSize:10,toolbarItems:["undo","redo","format-painter","clear-format","|","currency-format","percentage-format","number-decrease","number-increase","format","|","font","|","font-size","|","bold","italic","strike-through","underline","|","font-color","background","border","merge-cell","|","horizontal-align","vertical-align","text-wrap","text-rotation","|","freeze","conditionFormat","filter","link","image","comment","quick-formula","dataVerification","splitColumn","locationCondition","screenshot","search"],cellContextMenu:["copy","paste","|","insert-row","insert-column","delete-row","delete-column","delete-cell","hide-row","hide-column","set-row-height","set-column-width","|","clear","sort","orderAZ","orderZA","filter","chart","image","link","data","cell-format"],headerContextMenu:["copy","paste","|","insert-row","insert-column","delete-row","delete-column","delete-cell","hide-row","hide-column","set-row-height","set-column-width","|","clear","sort","orderAZ","orderZA"],sheetTabContextMenu:["delete","copy","rename","color","hide","|","move"],filterContextMenu:["sort-by-asc","sort-by-desc","|","filter-by-color","|","filter-by-value"],generateSheetId:function generateSheetId(){return (0,v4/* default */.Z)();},hooks:{},customToolbarItems:[],currency:"¥"};function handleCopy(ctx){if(ctx.luckysheetPaintModelOn){cancelPaintModel(ctx);}var selection=ctx.luckysheet_select_save;if(!selection||lodash_default().isEmpty(selection)){return;}if(ctx.config.merge!=null){var has_PartMC=false;for(var s=0;s<selection.length;s+=1){var r1=selection[s].row[0];var r2=selection[s].row[1];var c1=selection[s].column[0];var c2=selection[s].column[1];has_PartMC=hasPartMC(ctx,ctx.config,r1,r2,c1,c2);if(has_PartMC){break;}}if(has_PartMC){return;}}var cdformat=ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)].luckysheet_conditionformat_save;if(!lodash_default().isNil(ctx.luckysheet_select_save)&&ctx.luckysheet_select_save.length>1&&!lodash_default().isNil(cdformat)&&cdformat.length>0){var hasCF=false;var cf_compute=getComputeMap(ctx);for(var _s=0;_s<ctx.luckysheet_select_save.length;_s+=1){if(hasCF){break;}var _r=ctx.luckysheet_select_save[_s].row[0];var _r2=ctx.luckysheet_select_save[_s].row[1];var _c=ctx.luckysheet_select_save[_s].column[0];var _c2=ctx.luckysheet_select_save[_s].column[1];for(var r=_r;r<=_r2;r+=1){if(hasCF){break;}for(var c=_c;c<=_c2;c+=1){if(!lodash_default().isNil(checkCF(r,c,cf_compute))){hasCF=true;break;}}}}if(hasCF){return;}}if(selection.length>1){var isSameRow=true;var str_r=selection[0].row[0];var end_r=selection[0].row[1];var isSameCol=true;var str_c=selection[0].column[0];var end_c=selection[0].column[1];for(var _s2=1;_s2<selection.length;_s2+=1){if(selection[_s2].row[0]!==str_r||selection[_s2].row[1]!==end_r){isSameRow=false;}if(selection[_s2].column[0]!==str_c||selection[_s2].column[1]!==end_c){isSameCol=false;}}if(!isSameRow&&!isSameCol||selectIsOverlap(ctx)){return;}}copy(ctx);ctx.luckysheet_paste_iscut=false;}function handleGlobalEnter(ctx,cellInput,e,canvas){if((e.altKey||e.metaKey)&&ctx.luckysheetCellUpdate.length>0){var _ctx$luckysheet_selec;var last=(_ctx$luckysheet_selec=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec===void 0?void 0:_ctx$luckysheet_selec[ctx.luckysheet_select_save.length-1];if(last&&!lodash_default().isNil(last.row_focus)&&!lodash_default().isNil(last.column_focus));e.preventDefault();}else if(ctx.luckysheetCellUpdate.length>0){var lastCellUpdate=lodash_default().clone(ctx.luckysheetCellUpdate);updateCell(ctx,ctx.luckysheetCellUpdate[0],ctx.luckysheetCellUpdate[1],cellInput,undefined,canvas);ctx.luckysheet_select_save=[{row:[lastCellUpdate[0],lastCellUpdate[0]],column:[lastCellUpdate[1],lastCellUpdate[1]],row_focus:lastCellUpdate[0],column_focus:lastCellUpdate[1]}];moveHighlightCell(ctx,"down",1,"rangeOfSelect");e.preventDefault();}else{var _ctx$luckysheet_selec2,_ctx$luckysheet_selec3;if(((_ctx$luckysheet_selec2=(_ctx$luckysheet_selec3=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec3===void 0?void 0:_ctx$luckysheet_selec3.length)!==null&&_ctx$luckysheet_selec2!==void 0?_ctx$luckysheet_selec2:0)>0){var _last=ctx.luckysheet_select_save[ctx.luckysheet_select_save.length-1];var row_index=_last.row_focus;var col_index=_last.column_focus;ctx.luckysheetCellUpdate=[row_index,col_index];e.preventDefault();}}}function moveToEdge(sheetData,key,curr,rowDelta,colDelta,startR,endR,startC,endC,maxRow,maxCol){var selectedLimit=-1;if(key==="ArrowUp")selectedLimit=startR-1;else if(key==="ArrowDown")selectedLimit=endR+1;else if(key==="ArrowLeft")selectedLimit=startC-1;else if(key==="ArrowRight")selectedLimit=endC+1;var maxRowCol=colDelta===0?maxRow:maxCol;var r=colDelta===0?selectedLimit:curr;var c=colDelta===0?curr:selectedLimit;while(r>=0&&c>=0&&(colDelta===0?r:c)<maxRowCol-1){var _sheetData$r,_sheetData$r$c,_sheetData,_sheetData2,_sheetData3,_sheetData4;if(!lodash_default().isNil(sheetData===null||sheetData===void 0?void 0:(_sheetData$r=sheetData[r])===null||_sheetData$r===void 0?void 0:(_sheetData$r$c=_sheetData$r[c])===null||_sheetData$r$c===void 0?void 0:_sheetData$r$c.v)&&(lodash_default().isNil(sheetData===null||sheetData===void 0?void 0:(_sheetData=sheetData[r-rowDelta])===null||_sheetData===void 0?void 0:(_sheetData2=_sheetData[c-colDelta])===null||_sheetData2===void 0?void 0:_sheetData2.v)||lodash_default().isNil(sheetData===null||sheetData===void 0?void 0:(_sheetData3=sheetData[r+rowDelta])===null||_sheetData3===void 0?void 0:(_sheetData4=_sheetData3[c+colDelta])===null||_sheetData4===void 0?void 0:_sheetData4.v))){break;}else{r+=1*rowDelta;c+=1*colDelta;}}return colDelta===0?r:c;}function handleControlPlusArrowKey(ctx,e,shiftPressed){if(ctx.luckysheetCellUpdate.length>0)return;var idx=getSheetIndex(ctx,ctx.currentSheetId);if(lodash_default().isNil(idx))return;var file=ctx.luckysheetfile[idx];if(!file||!file.row||!file.column)return;var maxRow=file.row;var maxCol=file.column;var last;if(ctx.luckysheet_select_save&&ctx.luckysheet_select_save.length>0)last=ctx.luckysheet_select_save[ctx.luckysheet_select_save.length-1];if(!last)return;var currR=last.row_focus;var currC=last.column_focus;if(lodash_default().isNil(currR)||lodash_default().isNil(currC))return;var startR=last.row[0];var endR=last.row[1];var startC=last.column[0];var endC=last.column[1];var horizontalOffset=currC-endC!==0?currC-endC:currC-startC;var verticalOffset=currR-endR!==0?currR-endR:currR-startR;var sheetData=file.data;if(!sheetData)return;var selectedLimit;switch(e.key){case"ArrowUp":selectedLimit=moveToEdge(sheetData,e.key,currC,-1,0,startR,endR,startC,endC,maxRow,maxCol);if(shiftPressed){moveHighlightRange(ctx,"down",verticalOffset,"rangeOfSelect");moveHighlightRange(ctx,"down",selectedLimit-currR,"rangeOfSelect");}else{moveHighlightCell(ctx,"down",selectedLimit-currR,"rangeOfSelect");}break;case"ArrowDown":selectedLimit=moveToEdge(sheetData,e.key,currC,1,0,startR,endR,startC,endC,maxRow,maxCol);if(shiftPressed){moveHighlightRange(ctx,"down",verticalOffset,"rangeOfSelect");moveHighlightRange(ctx,"down",selectedLimit-currR,"rangeOfSelect");}else{moveHighlightCell(ctx,"down",selectedLimit-currR,"rangeOfSelect");}break;case"ArrowLeft":selectedLimit=moveToEdge(sheetData,e.key,currR,0,-1,startR,endR,startC,endC,maxRow,maxCol);if(shiftPressed){moveHighlightRange(ctx,"right",horizontalOffset,"rangeOfSelect");moveHighlightRange(ctx,"right",selectedLimit-currC,"rangeOfSelect");}else{moveHighlightCell(ctx,"right",selectedLimit-currC,"rangeOfSelect");}break;case"ArrowRight":selectedLimit=moveToEdge(sheetData,e.key,currR,0,1,startR,endR,startC,endC,maxRow,maxCol);if(shiftPressed){moveHighlightRange(ctx,"right",horizontalOffset,"rangeOfSelect");moveHighlightRange(ctx,"right",selectedLimit-currC,"rangeOfSelect");}else{moveHighlightCell(ctx,"right",selectedLimit-currC,"rangeOfSelect");}break;}}function handleWithCtrlOrMetaKey(ctx,cache,e,cellInput,fxInput,handleUndo,handleRedo){var flowdata=getFlowdata(ctx);if(!flowdata)return;if(e.shiftKey){var _ctx$luckysheet_selec4;ctx.luckysheet_shiftpositon=lodash_default().cloneDeep((_ctx$luckysheet_selec4=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec4===void 0?void 0:_ctx$luckysheet_selec4[ctx.luckysheet_select_save.length-1]);ctx.luckysheet_shiftkeydown=true;if(["ArrowUp","ArrowDown","ArrowLeft","ArrowRight"].includes(e.key)){handleControlPlusArrowKey(ctx,e,true);}else if(lodash_default().includes([";",'"',":","'"],e.key)){var _ctx$luckysheet_selec5;var last=(_ctx$luckysheet_selec5=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec5===void 0?void 0:_ctx$luckysheet_selec5[ctx.luckysheet_select_save.length-1];if(!last)return;var row_index=last.row_focus;var col_index=last.column_focus;updateCell(ctx,row_index,col_index,cellInput);ctx.luckysheetCellUpdate=[row_index,col_index];cache.ignoreWriteCell=true;var value=getNowDateTime(2);cellInput.innerText=value;handleFormulaInput(ctx,fxInput,cellInput,e.keyCode);}else if(e.code==="KeyZ"){handleRedo();e.stopPropagation();return;}}else if(["ArrowUp","ArrowDown","ArrowLeft","ArrowRight"].includes(e.key)){handleControlPlusArrowKey(ctx,e,false);}else if(e.code==="KeyB"){handleBold(ctx,cellInput);}else if(e.code==="KeyC"){handleCopy(ctx);e.stopPropagation();return;}else if(e.code==="KeyF"){ctx.showSearch=true;}else if(e.code==="KeyH"){ctx.showReplace=true;}else if(e.code==="KeyV"){var _ctx$luckysheet_selec6,_ctx$luckysheet_selec7;if(((_ctx$luckysheet_selec6=(_ctx$luckysheet_selec7=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec7===void 0?void 0:_ctx$luckysheet_selec7.length)!==null&&_ctx$luckysheet_selec6!==void 0?_ctx$luckysheet_selec6:0)>1){return;}selectionCache.isPasteAction=true;e.stopPropagation();return;}else if(e.code==="KeyX"){if(ctx.luckysheetPaintModelOn){cancelPaintModel(ctx);}var selection=ctx.luckysheet_select_save;if(!selection||lodash_default().isEmpty(selection)){return;}if(ctx.config.merge!=null){var has_PartMC=false;for(var s=0;s<selection.length;s+=1){var r1=selection[s].row[0];var r2=selection[s].row[1];var c1=selection[s].column[0];var c2=selection[s].column[1];has_PartMC=hasPartMC(ctx,ctx.config,r1,r2,c1,c2);if(has_PartMC){break;}}if(has_PartMC){return;}}if(selection.length>1){return;}copy(ctx);ctx.luckysheet_paste_iscut=true;e.stopPropagation();return;}else if(e.code==="KeyZ"){handleUndo();e.stopPropagation();return;}else if(e.code==="KeyA"){selectAll(ctx);}e.preventDefault();}function handleShiftWithArrowKey(ctx,e){var _ctx$luckysheet_selec8;if(ctx.luckysheetCellUpdate.length>0){return;}ctx.luckysheet_shiftpositon=lodash_default().cloneDeep((_ctx$luckysheet_selec8=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec8===void 0?void 0:_ctx$luckysheet_selec8[ctx.luckysheet_select_save.length-1]);ctx.luckysheet_shiftkeydown=true;switch(e.key){case"ArrowUp":moveHighlightRange(ctx,"down",-1,"rangeOfSelect");break;case"ArrowDown":moveHighlightRange(ctx,"down",1,"rangeOfSelect");break;case"ArrowLeft":moveHighlightRange(ctx,"right",-1,"rangeOfSelect");break;case"ArrowRight":moveHighlightRange(ctx,"right",1,"rangeOfSelect");break;}e.preventDefault();}function handleArrowKey(ctx,e){if(ctx.luckysheetCellUpdate.length>0||ctx.luckysheet_cell_selected_move||ctx.luckysheet_cell_selected_extend){return;}var moveCount=hideCRCount(ctx,e.key);switch(e.key){case"ArrowUp":moveHighlightCell(ctx,"down",-moveCount,"rangeOfSelect");break;case"ArrowDown":moveHighlightCell(ctx,"down",moveCount,"rangeOfSelect");break;case"ArrowLeft":moveHighlightCell(ctx,"right",-moveCount,"rangeOfSelect");break;case"ArrowRight":moveHighlightCell(ctx,"right",moveCount,"rangeOfSelect");break;}}function handleGlobalKeyDown(ctx,cellInput,fxInput,e,cache,handleUndo,handleRedo,canvas){ctx.luckysheet_select_status=false;var kcode=e.keyCode;var kstr=e.key;if(!lodash_default().isEmpty(ctx.contextMenu)||ctx.filterContextMenu){return;}if(kstr==="Escape"&&!!ctx.luckysheet_selection_range){ctx.luckysheet_selection_range=[];}var allowEdit=isAllowEdit(ctx);if(ctx.luckysheetCellUpdate.length>0&&kstr!=="Enter"&&kstr!=="Tab"&&kstr!=="ArrowUp"&&kstr!=="ArrowDown"&&kstr!=="ArrowLeft"&&kstr!=="ArrowRight"){return;}if(kstr==="Enter"){if(!allowEdit)return;handleGlobalEnter(ctx,cellInput,e,canvas);}else if(kstr==="Tab"){if(ctx.luckysheetCellUpdate.length>0){return;}if(e.shiftKey){moveHighlightCell(ctx,"right",-1,"rangeOfSelect");}else{moveHighlightCell(ctx,"right",1,"rangeOfSelect");}e.preventDefault();}else if(kstr==="F2"){var _ctx$luckysheet_selec9;if(!allowEdit)return;if(ctx.luckysheetCellUpdate.length>0){return;}var last=(_ctx$luckysheet_selec9=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec9===void 0?void 0:_ctx$luckysheet_selec9[ctx.luckysheet_select_save.length-1];if(!last)return;var row_index=last.row_focus;var col_index=last.column_focus;ctx.luckysheetCellUpdate=[row_index,col_index];e.preventDefault();}else if(kstr==="F4"&&ctx.luckysheetCellUpdate.length>0){e.preventDefault();}else if(kstr==="Escape"&&ctx.luckysheetCellUpdate.length>0){cancelNormalSelected(ctx);moveHighlightCell(ctx,"down",0,"rangeOfSelect");e.preventDefault();}else{if(e.ctrlKey||e.metaKey){handleWithCtrlOrMetaKey(ctx,cache,e,cellInput,fxInput,handleUndo,handleRedo);return;}if(e.shiftKey&&(kstr==="ArrowUp"||kstr==="ArrowDown"||kstr==="ArrowLeft"||kstr==="ArrowRight")){handleShiftWithArrowKey(ctx,e);}else if(kstr==="Escape"){ctx.contextMenu={};}else if(kstr==="Delete"||kstr==="Backspace"){if(!allowEdit)return;if(ctx.activeImg!=null){removeActiveImage(ctx);}else{deleteSelectedCellText(ctx);}jfrefreshgrid(ctx,null,undefined);e.preventDefault();}else if(kstr==="ArrowUp"||kstr==="ArrowDown"||kstr==="ArrowLeft"||kstr==="ArrowRight"){handleArrowKey(ctx,e);}else if(!(kcode>=112&&kcode<=123||kcode<=46||kcode===144||kcode===108||e.ctrlKey||e.altKey||e.shiftKey&&(kcode===37||kcode===38||kcode===39||kcode===40))||kcode===8||kcode===32||kcode===46||kcode===0||e.ctrlKey&&kcode===86){if(!allowEdit)return;if(String.fromCharCode(kcode)!=null&&!lodash_default().isEmpty(ctx.luckysheet_select_save)&&kstr!=="CapsLock"&&kstr!=="Win"&&kcode!==18){var _last2=ctx.luckysheet_select_save[ctx.luckysheet_select_save.length-1];var _row_index=_last2.row_focus;var _col_index=_last2.column_focus;ctx.luckysheetCellUpdate=[_row_index,_col_index];cache.overwriteCell=true;handleFormulaInput(ctx,fxInput,cellInput,kcode);}}}if(cellInput!==document.activeElement){cellInput===null||cellInput===void 0?void 0:cellInput.focus();}e.stopPropagation();}var mouseWheelUniqueTimeout;var scrollLockTimeout;function handleGlobalWheel(ctx,e,cache,scrollbarX,scrollbarY){var _cache$searchDialog;if(((_cache$searchDialog=cache.searchDialog)===null||_cache$searchDialog===void 0?void 0:_cache$searchDialog.mouseEnter)&&ctx.showSearch&&ctx.showReplace)return;if(ctx.filterContextMenu!=null)return;var scrollLeft=scrollbarX.scrollLeft;var scrollTop=scrollbarY.scrollTop;var visibledatacolumn_c=ctx.visibledatacolumn;var visibledatarow_c=ctx.visibledatarow;clearTimeout(mouseWheelUniqueTimeout);clearTimeout(scrollLockTimeout);if(cache.visibleColumnsUnique!=null){visibledatacolumn_c=cache.visibleColumnsUnique;}else{visibledatacolumn_c=lodash_default().uniq(visibledatacolumn_c);cache.visibleColumnsUnique=visibledatacolumn_c;}if(cache.visibleRowsUnique!=null){visibledatarow_c=cache.visibleRowsUnique;}else{visibledatarow_c=lodash_default().uniq(visibledatarow_c);cache.visibleRowsUnique=visibledatarow_c;}var row_st=lodash_default().sortedIndex(visibledatarow_c,scrollTop)+1;var rowscroll=0;var scrollNum=1;if(e.deltaY!==0&&!cache.verticalScrollLock){cache.horizontalScrollLock=true;var row_ed;var step=Math.round(scrollNum/ctx.zoomRatio);step=step<1?1:step;if(e.deltaY>0){row_ed=row_st+step;if(row_ed>=visibledatarow_c.length){row_ed=visibledatarow_c.length-1;}}else{row_ed=row_st-step;if(row_ed<0){row_ed=0;}}rowscroll=row_ed===0?0:visibledatarow_c[row_ed-1];scrollbarY.scrollTop=rowscroll;}else if(e.deltaX!==0&&!cache.horizontalScrollLock){cache.verticalScrollLock=true;if(e.deltaX>0){scrollLeft+=20*ctx.zoomRatio;}else{scrollLeft-=20*ctx.zoomRatio;}scrollbarX.scrollLeft=scrollLeft;}mouseWheelUniqueTimeout=setTimeout(function(){delete cache.visibleColumnsUnique;delete cache.visibleRowsUnique;},500);scrollLockTimeout=setTimeout(function(){delete cache.verticalScrollLock;delete cache.horizontalScrollLock;},50);e.preventDefault();}function fixPositionOnFrozenCells(freeze,x,y,mouseX,mouseY){var _freeze$vertical,_freeze$horizontal;var inHorizontalFreeze=false;var inVerticalFreeze=false;if(!freeze)return{x:x,y:y,inHorizontalFreeze:inHorizontalFreeze,inVerticalFreeze:inVerticalFreeze};var freezenverticaldata=freeze===null||freeze===void 0?void 0:(_freeze$vertical=freeze.vertical)===null||_freeze$vertical===void 0?void 0:_freeze$vertical.freezenverticaldata;var freezenhorizontaldata=freeze===null||freeze===void 0?void 0:(_freeze$horizontal=freeze.horizontal)===null||_freeze$horizontal===void 0?void 0:_freeze$horizontal.freezenhorizontaldata;if(freezenverticaldata!=null&&mouseX<freezenverticaldata[0]-freezenverticaldata[2]){x=mouseX+freezenverticaldata[2];inVerticalFreeze=true;}if(freezenhorizontaldata!=null&&mouseY<freezenhorizontaldata[0]-freezenhorizontaldata[2]){y=mouseY+freezenhorizontaldata[2];inHorizontalFreeze=true;}return{x:x,y:y,inHorizontalFreeze:inHorizontalFreeze,inVerticalFreeze:inVerticalFreeze};}function handleCellAreaMouseDown(ctx,globalCache,e,cellInput,container,fxInput,canvas){var _globalCache$freezen,_ctx$hooks$beforeCell,_ctx$hooks,_flowdata$row_index;ctx.contextMenu={};ctx.filterContextMenu=undefined;var flowdata=getFlowdata(ctx);if(!flowdata)return;removeEditingComment(ctx,globalCache);cancelActiveImgItem(ctx,globalCache);var rect=container.getBoundingClientRect();var mouseX=e.pageX-rect.left-window.scrollX;var mouseY=e.pageY-rect.top-window.scrollY;var _x=mouseX+ctx.scrollLeft;var _y=mouseY+ctx.scrollTop;if(_x>=rect.width+ctx.scrollLeft||_y>=rect.height+ctx.scrollTop){return;}var freeze=(_globalCache$freezen=globalCache.freezen)===null||_globalCache$freezen===void 0?void 0:_globalCache$freezen[ctx.currentSheetId];var _fixPositionOnFrozenC=fixPositionOnFrozenCells(freeze,_x,_y,mouseX,mouseY),x=_fixPositionOnFrozenC.x,y=_fixPositionOnFrozenC.y,inHorizontalFreeze=_fixPositionOnFrozenC.inHorizontalFreeze,inVerticalFreeze=_fixPositionOnFrozenC.inVerticalFreeze;var row_location=rowLocation(y,ctx.visibledatarow);var row=row_location[1];var row_pre=row_location[0];var row_index=row_location[2];var col_location=colLocation(x,ctx.visibledatacolumn);var col=col_location[1];var col_pre=col_location[0];var col_index=col_location[2];var row_index_ed=row_index;var col_index_ed=col_index;var margeset=mergeBorder(ctx,flowdata,row_index,col_index);if(margeset){var _margeset$row=index_esm_slicedToArray(margeset.row,4);row_pre=_margeset$row[0];row=_margeset$row[1];row_index=_margeset$row[2];row_index_ed=_margeset$row[3];var _margeset$column=index_esm_slicedToArray(margeset.column,4);col_pre=_margeset$column[0];col=_margeset$column[1];col_index=_margeset$column[2];col_index_ed=_margeset$column[3];}showLinkCard(ctx,row_index,col_index,false,true);if(((_ctx$hooks$beforeCell=(_ctx$hooks=ctx.hooks).beforeCellMouseDown)===null||_ctx$hooks$beforeCell===void 0?void 0:_ctx$hooks$beforeCell.call(_ctx$hooks,(_flowdata$row_index=flowdata[row_index])===null||_flowdata$row_index===void 0?void 0:_flowdata$row_index[col_index],{row:row_index,column:col_index,startRow:row_pre,startColumn:col_pre,endRow:row,endColumn:col}))===false){return;}cellFocus(ctx,row_index,col_index,true);if(!inHorizontalFreeze&&!inVerticalFreeze){if(col_pre<ctx.scrollLeft){ctx.scrollLeft=col_pre;}if(row_pre<ctx.scrollTop){ctx.scrollTop=row_pre;}}if(e.button===2){var isInSelection=lodash_default().some(ctx.luckysheet_select_save,function(obj_s){return obj_s.row!=null&&row_index>=obj_s.row[0]&&row_index<=obj_s.row[1]&&col_index>=obj_s.column[0]&&col_index<=obj_s.column[1];});if(isInSelection)return;}ctx.luckysheet_scroll_status=true;if(ctx.luckysheetCellUpdate.length>0){if(ctx.formulaCache.rangestart||ctx.formulaCache.rangedrag_column_start||ctx.formulaCache.rangedrag_row_start||israngeseleciton(ctx)){var _$last;var rowseleted=[row_index,row_index_ed];var columnseleted=[col_index,col_index_ed];var left=col_pre;var width=col-col_pre-1;var top=row_pre;var height=row-row_pre-1;if(e.shiftKey){var last=ctx.formulaCache.func_selectedrange;top=0;height=0;rowseleted=[];if(last==null||last.top==null||last.height==null||last.row_focus==null||last.left==null||last.width==null)return;if(last.top>row_pre){top=row_pre;height=last.top+last.height-row_pre;if(last.row[1]>last.row_focus){last.row[1]=last.row_focus;}rowseleted=[row_index,last.row[1]];}else if(last.top===row_pre){top=row_pre;height=last.top+last.height-row_pre;rowseleted=[row_index,last.row[0]];}else{top=last.top;height=row-last.top-1;if(last.row[0]<last.row_focus){last.row[0]=last.row_focus;}rowseleted=[last.row[0],row_index];}left=0;width=0;columnseleted=[];if(last.left>col_pre){left=col_pre;width=last.left+last.width-col_pre;if(last.column==null||last.column_focus==null)return;if(last.column[1]>last.column_focus){last.column[1]=last.column_focus;}columnseleted=[col_index,last.column[1]];}else if(last.left===col_pre){left=col_pre;width=last.left+last.width-col_pre;columnseleted=[col_index,last.column[0]];}else{left=last.left;width=col-last.left-1;if(last.column==null||last.column_focus==null)return;if(last.column[0]<last.column_focus){last.column[0]=last.column_focus;}columnseleted=[last.column[0],col_index];}var changeparam=mergeMoveMain(ctx,columnseleted,rowseleted,last,top,height,left,width);if(changeparam!=null){var _changeparam=index_esm_slicedToArray(changeparam,6);columnseleted=_changeparam[0];rowseleted=_changeparam[1];top=_changeparam[2];height=_changeparam[3];left=_changeparam[4];width=_changeparam[5];}last.row=rowseleted;last.column=columnseleted;last.left_move=left;last.width_move=width;last.top_move=top;last.height_move=height;ctx.formulaCache.func_selectedrange=last;}else if(e.ctrlKey&&((_$last=lodash_default().last(cellInput.querySelectorAll("span")))===null||_$last===void 0?void 0:_$last.innerText)!==","){var vText=cellInput.innerText;if(vText[vText.length-1]===")"){vText=vText.substring(0,vText.length-1);}if(vText.length>0){var lastWord=vText.substring(vText.length-1,1);if(lastWord!==","&&lastWord!=="="&&lastWord!=="("){vText+=",";}}if(vText.length>0&&vText.substring(0,1)==="="){vText=functionHTMLGenerate(vText);if(window.getSelection){var _currSelection$anchor,_currSelection$anchor2,_currSelection$anchor3,_currSelection$anchor4;var currSelection=window.getSelection();if(currSelection==null)return;ctx.formulaCache.functionRangeIndex=[lodash_default().indexOf((_currSelection$anchor=currSelection.anchorNode)===null||_currSelection$anchor===void 0?void 0:(_currSelection$anchor2=_currSelection$anchor.parentNode)===null||_currSelection$anchor2===void 0?void 0:(_currSelection$anchor3=_currSelection$anchor2.parentNode)===null||_currSelection$anchor3===void 0?void 0:_currSelection$anchor3.childNodes,(_currSelection$anchor4=currSelection.anchorNode)===null||_currSelection$anchor4===void 0?void 0:_currSelection$anchor4.parentNode),currSelection.anchorOffset];}else{var textRange=document.selection.createRange();ctx.formulaCache.functionRangeIndex=textRange;}cellInput.innerHTML=vText;cancelFunctionrangeSelected(ctx);createRangeHightlight(ctx,vText);}ctx.formulaCache.rangestart=false;ctx.formulaCache.rangedrag_column_start=false;ctx.formulaCache.rangedrag_row_start=false;if(fxInput)fxInput.innerHTML=vText;rangeHightlightselected(ctx,cellInput);israngeseleciton(ctx);ctx.formulaCache.func_selectedrange={left:left,width:width,top:top,height:height,left_move:left,width_move:width,top_move:top,height_move:height,row:rowseleted,column:columnseleted,row_focus:row_index,column_focus:col_index};}else{ctx.formulaCache.func_selectedrange={left:left,width:width,top:top,height:height,left_move:left,width_move:width,top_move:top,height_move:height,row:rowseleted,column:columnseleted,row_focus:row_index,column_focus:col_index};}rangeSetValue(ctx,cellInput,{row:rowseleted,column:columnseleted},fxInput);ctx.formulaCache.rangestart=true;ctx.formulaCache.rangedrag_column_start=false;ctx.formulaCache.rangedrag_row_start=false;ctx.formulaCache.selectingRangeIndex=ctx.formulaCache.rangechangeindex;if(ctx.formulaCache.rangechangeindex>ctx.formulaRangeHighlight.length){createRangeHightlight(ctx,cellInput.innerHTML,ctx.formulaCache.rangechangeindex);}createFormulaRangeSelect(ctx,{rangeIndex:ctx.formulaCache.rangechangeindex||0,left:left,top:top,width:width,height:height});e.preventDefault();return;}updateCell(ctx,ctx.luckysheetCellUpdate[0],ctx.luckysheetCellUpdate[1],cellInput,undefined,canvas);ctx.luckysheet_select_status=true;}if(checkProtectionSelectLockedOrUnLockedCells(ctx,row_index,col_index,ctx.currentSheetId)){ctx.luckysheet_select_status=true;}if(ctx.luckysheet_select_status){if(e.shiftKey){var _ctx$luckysheet_selec;var _last=(_ctx$luckysheet_selec=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec===void 0?void 0:_ctx$luckysheet_selec[ctx.luckysheet_select_save.length-1];if(_last&&_last.top!=null&&_last.left!=null&&_last.height!=null&&_last.width!=null&&_last.row_focus!=null&&_last.column_focus!=null){var _top2=0;var _height2=0;var _rowseleted2=[];if(_last.top>row_pre){_top2=row_pre;_height2=_last.top+_last.height-row_pre;if(_last.row[1]>_last.row_focus){_last.row[1]=_last.row_focus;}_rowseleted2=[row_index,_last.row[1]];}else if(_last.top===row_pre){_top2=row_pre;_height2=_last.top+_last.height-row_pre;_rowseleted2=[row_index,_last.row[0]];}else{_top2=_last.top;_height2=row-_last.top-1;if(_last.row[0]<_last.row_focus){_last.row[0]=_last.row_focus;}_rowseleted2=[_last.row[0],row_index];}var _left2=0;var _width2=0;var _columnseleted2=[];if(_last.left>col_pre){_left2=col_pre;_width2=_last.left+_last.width-col_pre;if(_last.column[1]>_last.column_focus){_last.column[1]=_last.column_focus;}_columnseleted2=[col_index,_last.column[1]];}else if(_last.left===col_pre){_left2=col_pre;_width2=_last.left+_last.width-col_pre;_columnseleted2=[col_index,_last.column[0]];}else{_left2=_last.left;_width2=col-_last.left-1;if(_last.column[0]<_last.column_focus){_last.column[0]=_last.column_focus;}_columnseleted2=[_last.column[0],col_index];}var _changeparam2=mergeMoveMain(ctx,_columnseleted2,_rowseleted2,_last,_top2,_height2,_left2,_width2);if(_changeparam2!=null){var _changeparam3=index_esm_slicedToArray(_changeparam2,6);_columnseleted2=_changeparam3[0];_rowseleted2=_changeparam3[1];_top2=_changeparam3[2];_height2=_changeparam3[3];_left2=_changeparam3[4];_width2=_changeparam3[5];}_last.row=_rowseleted2;_last.column=_columnseleted2;_last.left_move=_left2;_last.width_move=_width2;_last.top_move=_top2;_last.height_move=_height2;ctx.luckysheet_select_save[ctx.luckysheet_select_save.length-1]=_last;}}else if(e.ctrlKey||e.metaKey){var _ctx$luckysheet_selec2;(_ctx$luckysheet_selec2=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec2===void 0?void 0:_ctx$luckysheet_selec2.push({left:col_pre,width:col-col_pre-1,top:row_pre,height:row-row_pre-1,left_move:col_pre,width_move:col-col_pre-1,top_move:row_pre,height_move:row-row_pre-1,row:[row_index,row_index_ed],column:[col_index,col_index_ed],row_focus:row_index,column_focus:col_index});}else{ctx.luckysheet_select_save=[{left:col_pre,width:col-col_pre-1,top:row_pre,height:row-row_pre-1,left_move:col_pre,width_move:col-col_pre-1,top_move:row_pre,height_move:row-row_pre-1,row:[row_index,row_index_ed],column:[col_index,col_index_ed],row_focus:row_index,column_focus:col_index}];}}ctx.luckysheet_select_save=normalizeSelection(ctx,ctx.luckysheet_select_save);if(ctx.hooks.afterCellMouseDown){setTimeout(function(){var _ctx$hooks$afterCellM,_ctx$hooks2,_flowdata$row_index2;(_ctx$hooks$afterCellM=(_ctx$hooks2=ctx.hooks).afterCellMouseDown)===null||_ctx$hooks$afterCellM===void 0?void 0:_ctx$hooks$afterCellM.call(_ctx$hooks2,(_flowdata$row_index2=flowdata[row_index])===null||_flowdata$row_index2===void 0?void 0:_flowdata$row_index2[col_index],{row:row_index,column:col_index,startRow:row_pre,startColumn:col_pre,endRow:row,endColumn:col});});}}function handleCellAreaDoubleClick(ctx,globalCache,settings,e,container){var _globalCache$freezen2;var flowdata=getFlowdata(ctx);if(!flowdata)return;if(ctx.luckysheetCellUpdate.length>0&&ctx.formulaCache.rangestart||ctx.formulaCache.rangedrag_column_start||ctx.formulaCache.rangedrag_row_start||israngeseleciton(ctx)){return;}var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;var rect=container.getBoundingClientRect();var mouseX=e.pageX-rect.left;var mouseY=e.pageY-rect.top;var _x=mouseX+ctx.scrollLeft;var _y=mouseY+ctx.scrollTop;var freeze=(_globalCache$freezen2=globalCache.freezen)===null||_globalCache$freezen2===void 0?void 0:_globalCache$freezen2[ctx.currentSheetId];var _fixPositionOnFrozenC2=fixPositionOnFrozenCells(freeze,_x,_y,mouseX,mouseY),x=_fixPositionOnFrozenC2.x,y=_fixPositionOnFrozenC2.y;var row_location=rowLocation(y,ctx.visibledatarow);var row_index=row_location[2];var col_location=colLocation(x,ctx.visibledatacolumn);var col_index=col_location[2];var index=getSheetIndex(ctx,ctx.currentSheetId);var dataVerification=ctx.luckysheetfile[index].dataVerification;if(dataVerification){var item=dataVerification["".concat(row_index,"_").concat(col_index)];if(item&&item.type==="checkbox")return;}var margeset=mergeBorder(ctx,flowdata,row_index,col_index);if(margeset){var _margeset$row2=index_esm_slicedToArray(margeset.row,3);row_index=_margeset$row2[2];var _margeset$column2=index_esm_slicedToArray(margeset.column,3);col_index=_margeset$column2[2];}var _ctx$luckysheet_selec3=ctx.luckysheet_select_save[0],column_focus=_ctx$luckysheet_selec3.column_focus,row_focus=_ctx$luckysheet_selec3.row_focus;if(!lodash_default().isNil(column_focus)&&!lodash_default().isNil(row_focus)&&(column_focus!==col_index||row_focus!==row_index)){row_index=row_focus;col_index=column_focus;}luckysheetUpdateCell(ctx,row_index,col_index);}function handleContextMenu(ctx,settings,e,workbookContainer,container,area){if(!ctx.allowEdit){return;}var flowdata=getFlowdata(ctx);if(!flowdata)return;var workbookRect=workbookContainer.getBoundingClientRect();var cellContextMenu=settings.cellContextMenu;if(lodash_default().isEmpty(cellContextMenu)){return;}var x=e.pageX-workbookRect.left;var y=e.pageY-workbookRect.top;ctx.contextMenu={x:x,y:y,pageX:e.pageX,pageY:e.pageY};e.preventDefault();if(area==="cell"){var _ctx$getRefs$globalCa,_flowdata$row_index$c2;lodash_default().set(ctx.contextMenu,"headerMenu",undefined);var rect=container.getBoundingClientRect();var mouseX=e.pageX-rect.left-window.scrollX;var mouseY=e.pageY-rect.top-window.scrollY;var _selected_x=mouseX+ctx.scrollLeft;var _selected_y=mouseY+ctx.scrollTop;var _fixPositionOnFrozenC3=fixPositionOnFrozenCells((_ctx$getRefs$globalCa=ctx.getRefs().globalCache.freezen)===null||_ctx$getRefs$globalCa===void 0?void 0:_ctx$getRefs$globalCa[ctx.currentSheetId],_selected_x,_selected_y,mouseX,mouseY),selected_x=_fixPositionOnFrozenC3.x,selected_y=_fixPositionOnFrozenC3.y;var row_location=rowLocation(selected_y,ctx.visibledatarow);var row=row_location[1];var row_pre=row_location[0];var row_index=row_location[2];var col_location=colLocation(selected_x,ctx.visibledatacolumn);var col=col_location[1];var col_pre=col_location[0];var col_index=col_location[2];var isInSelection=lodash_default().some(ctx.luckysheet_select_save,function(obj_s){return obj_s.row!=null&&row_index>=obj_s.row[0]&&row_index<=obj_s.row[1]&&col_index>=obj_s.column[0]&&col_index<=obj_s.column[1];});if(!isInSelection&&(e.metaKey||e.ctrlKey)){var _flowdata$row_index$c,_ctx$luckysheet_selec5;if((_flowdata$row_index$c=flowdata[row_index][col_index])===null||_flowdata$row_index$c===void 0?void 0:_flowdata$row_index$c.mc){var changeparam=mergeMoveMain(ctx,[col_index,col_index],[row_index,row_index],{row_focus:row_index,column_focus:col_index},row_pre,row,col_pre,col);if(changeparam!=null){var _ctx$luckysheet_selec4;var _changeparam4=index_esm_slicedToArray(changeparam,6),columnseleted=_changeparam4[0],rowseleted=_changeparam4[1],top=_changeparam4[2],height=_changeparam4[3],left=_changeparam4[4],width=_changeparam4[5];(_ctx$luckysheet_selec4=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec4===void 0?void 0:_ctx$luckysheet_selec4.push({left:left,width:width-1,top:top,height:height-1,left_move:left,width_move:width,top_move:top,height_move:height,row:rowseleted,column:columnseleted,row_focus:rowseleted[0],column_focus:columnseleted[0]});return;}}(_ctx$luckysheet_selec5=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec5===void 0?void 0:_ctx$luckysheet_selec5.push({left:col_pre,width:col-col_pre-1,top:row_pre,height:row-row_pre-1,left_move:col_pre,width_move:col-col_pre-1,top_move:row_pre,height_move:row-row_pre-1,row:[row_index,row_index],column:[col_index,col_index],row_focus:row_index,column_focus:col_index});return;}if(isInSelection)return;var row_index_ed=row_index;var col_index_ed=col_index;if((_flowdata$row_index$c2=flowdata[row_index][col_index])===null||_flowdata$row_index$c2===void 0?void 0:_flowdata$row_index$c2.mc){var _changeparam5=mergeMoveMain(ctx,[col_index,col_index],[row_index,row_index],{row_focus:row_index,column_focus:col_index},row_pre,row,col_pre,col);if(_changeparam5!=null){var _changeparam6=index_esm_slicedToArray(_changeparam5,6),_columnseleted3=_changeparam6[0],_rowseleted3=_changeparam6[1],_top3=_changeparam6[2],_height3=_changeparam6[3],_left3=_changeparam6[4],_width3=_changeparam6[5];ctx.luckysheet_select_save=[{left:_left3,width:_width3-1,top:_top3,height:_height3-1,left_move:_left3,width_move:_width3,top_move:_top3,height_move:_height3,row:_rowseleted3,column:_columnseleted3,row_focus:_rowseleted3[0],column_focus:_columnseleted3[0]}];return;}}ctx.luckysheet_select_save=[{left:col_pre,width:col-col_pre-1,top:row_pre,height:row-row_pre-1,left_move:col_pre,width_move:col-col_pre-1,top_move:row_pre,height_move:row-row_pre-1,row:[row_index,row_index_ed],column:[col_index,col_index_ed],row_focus:row_index,column_focus:col_index}];}else if(area==="rowHeader"){var _ctx$getRefs$globalCa2;lodash_default().set(ctx.contextMenu,"headerMenu","row");var _rect=container.getBoundingClientRect();var _mouseY=e.pageY-_rect.top-window.scrollY;var _selected_y2=_mouseY+ctx.scrollTop;var _fixPositionOnFrozenC4=fixPositionOnFrozenCells((_ctx$getRefs$globalCa2=ctx.getRefs().globalCache.freezen)===null||_ctx$getRefs$globalCa2===void 0?void 0:_ctx$getRefs$globalCa2[ctx.currentSheetId],0,_selected_y2,0,_mouseY),_selected_y3=_fixPositionOnFrozenC4.y;var _row_location=rowLocation(_selected_y3,ctx.visibledatarow);var _row=_row_location[1];var _row_pre=_row_location[0];var _row_index=_row_location[2];var _isInSelection=lodash_default().some(ctx.luckysheet_select_save,function(obj_s){return obj_s.row!=null&&_row_index>=obj_s.row[0]&&_row_index<=obj_s.row[1]&&!obj_s.column_select;});if(_isInSelection)return;var _col_index=ctx.visibledatacolumn.length-1;var _col=ctx.visibledatacolumn[_col_index];var _col_pre=0;var _top4=_row_pre;var _height4=_row-_row_pre-1;var _rowseleted4=[_row_index,_row_index];ctx.luckysheet_select_save=[];ctx.luckysheet_select_save.push({left:colLocationByIndex(0,ctx.visibledatacolumn)[0],width:colLocationByIndex(0,ctx.visibledatacolumn)[1]-colLocationByIndex(0,ctx.visibledatacolumn)[0]-1,top:_top4,height:_height4,left_move:_col_pre,width_move:_col-_col_pre-1,top_move:_top4,height_move:_height4,row:_rowseleted4,column:[0,_col_index],row_focus:_row_index,column_focus:0,row_select:true});}else if(area==="columnHeader"){var _ctx$getRefs$globalCa3;lodash_default().set(ctx.contextMenu,"headerMenu","column");var _rect2=container.getBoundingClientRect();var _mouseX=e.pageX-_rect2.left-window.scrollX;var _selected_x2=_mouseX+ctx.scrollLeft;var _fixPositionOnFrozenC5=fixPositionOnFrozenCells((_ctx$getRefs$globalCa3=ctx.getRefs().globalCache.freezen)===null||_ctx$getRefs$globalCa3===void 0?void 0:_ctx$getRefs$globalCa3[ctx.currentSheetId],_selected_x2,0,_mouseX,0),_selected_x3=_fixPositionOnFrozenC5.x;var _row_index2=ctx.visibledatarow.length-1;var _row2=ctx.visibledatarow[_row_index2];var _row_pre2=0;var _col_location=colLocation(_selected_x3,ctx.visibledatacolumn);var _col2=_col_location[1];var _col_pre2=_col_location[0];var _col_index2=_col_location[2];var _isInSelection2=lodash_default().some(ctx.luckysheet_select_save,function(obj_s){return obj_s.row!=null&&_col_index2>=obj_s.column[0]&&_col_index2<=obj_s.column[1]&&!obj_s.row_select;});if(_isInSelection2)return;var _left4=_col_pre2;var _width4=_col2-_col_pre2-1;var _columnseleted4=[_col_index2,_col_index2];ctx.luckysheet_select_save=[];ctx.luckysheet_select_save.push({left:_left4,width:_width4,top:rowLocationByIndex(0,ctx.visibledatarow)[0],height:rowLocationByIndex(0,ctx.visibledatarow)[1]-rowLocationByIndex(0,ctx.visibledatarow)[0]-1,left_move:_left4,width_move:_width4,top_move:_row_pre2,height_move:_row2-_row_pre2-1,row:[0,_row_index2],column:_columnseleted4,row_focus:0,column_focus:_col_index2,column_select:true});}}function mouseRender(ctx,globalCache,e,cellInput,scrollX,scrollY,container,fxInput){var _ctx$rangeDialog;var rect=container.getBoundingClientRect();if(ctx.luckysheet_scroll_status&&!ctx.luckysheet_cols_change_size&&!ctx.luckysheet_rows_change_size){var left=ctx.scrollLeft;var top=ctx.scrollTop;var x=e.pageX-rect.left-window.scrollX;var y=e.pageY-rect.top-window.scrollY;var winH=rect.height-20*ctx.zoomRatio;var winW=rect.width-60*ctx.zoomRatio;if(y<0||y>winH){var stop;if(y<0){stop=top+y/2;}else{stop=top+(y-winH)/2;}scrollY.scrollTop=stop;}if(x<0||x>winW){var sleft;if(x<0){sleft=left+x/2;}else{sleft=left+(x-winW)/2;}scrollX.scrollLeft=sleft;}}if((_ctx$rangeDialog=ctx.rangeDialog)===null||_ctx$rangeDialog===void 0?void 0:_ctx$rangeDialog.singleSelect){return;}if(ctx.luckysheet_select_status){var _globalCache$freezen3,_ctx$luckysheet_selec6,_globalCache$freezen4;var mouseX=e.pageX-rect.left-window.scrollX;var mouseY=e.pageY-rect.top-window.scrollY;var _x=mouseX-ctx.rowHeaderWidth+ctx.scrollLeft;var _y=mouseY-ctx.columnHeaderHeight+ctx.scrollTop;var freeze=(_globalCache$freezen3=globalCache.freezen)===null||_globalCache$freezen3===void 0?void 0:_globalCache$freezen3[ctx.currentSheetId];var _fixPositionOnFrozenC6=fixPositionOnFrozenCells(freeze,_x,_y,mouseX-ctx.rowHeaderWidth,mouseY-ctx.columnHeaderHeight),_x2=_fixPositionOnFrozenC6.x,_y2=_fixPositionOnFrozenC6.y;var row_location=rowLocation(_y2,ctx.visibledatarow);var row=row_location[1];var row_pre=row_location[0];var row_index=row_location[2];var col_location=colLocation(_x2,ctx.visibledatacolumn);var col=col_location[1];var col_pre=col_location[0];var col_index=col_location[2];if(!checkProtectionSelectLockedOrUnLockedCells(ctx,row_index,col_index,ctx.currentSheetId)){ctx.luckysheet_select_status=false;return;}var last=lodash_default().cloneDeep((_ctx$luckysheet_selec6=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec6===void 0?void 0:_ctx$luckysheet_selec6[ctx.luckysheet_select_save.length-1]);if(!last||lodash_default().isNil(last.left)||lodash_default().isNil(last.top)||lodash_default().isNil(last.height)||lodash_default().isNil(last.width)||lodash_default().isNil(last.row_focus)||lodash_default().isNil(last.column_focus)){return;}var _top5=0;var height=0;var rowseleted=[];if(last.top>row_pre){_top5=row_pre;height=last.top+last.height-row_pre;if(last.row[1]>last.row_focus){last.row[1]=last.row_focus;}rowseleted=[row_index,last.row[1]];}else if(last.top===row_pre){_top5=row_pre;height=last.top+last.height-row_pre;rowseleted=[row_index,last.row[0]];}else{_top5=last.top;height=row-last.top-1;if(last.row[0]<last.row_focus){last.row[0]=last.row_focus;}rowseleted=[last.row[0],row_index];}var _left5=0;var width=0;var columnseleted=[];if(last.left>col_pre){_left5=col_pre;width=last.left+last.width-col_pre;if(last.column[1]>last.column_focus){last.column[1]=last.column_focus;}columnseleted=[col_index,last.column[1]];}else if(last.left===col_pre){_left5=col_pre;width=last.left+last.width-col_pre;columnseleted=[col_index,last.column[0]];}else{_left5=last.left;width=col-last.left-1;if(last.column[0]<last.column_focus){last.column[0]=last.column_focus;}columnseleted=[last.column[0],col_index];}var changeparam=mergeMoveMain(ctx,columnseleted,rowseleted,last,_top5,height,_left5,width);if(changeparam!=null){var _changeparam7=index_esm_slicedToArray(changeparam,6);columnseleted=_changeparam7[0];rowseleted=_changeparam7[1];_top5=_changeparam7[2];height=_changeparam7[3];_left5=_changeparam7[4];width=_changeparam7[5];}last.row=rowseleted;last.column=columnseleted;last.left_move=_left5;last.width_move=width;last.top_move=_top5;last.height_move=height;var isMaxColumn=ctx.luckysheet_select_save[ctx.luckysheet_select_save.length-1].column;var colMax=ctx.visibledatacolumn.length-1;if(isMaxColumn[0]===0&&isMaxColumn[1]===colMax){last.column[1]=colMax;last.width_move=ctx.visibledatacolumn[colMax]-1;}var isMaxRow=ctx.luckysheet_select_save[ctx.luckysheet_select_save.length-1].row;var rowMax=ctx.visibledatarow.length-1;if(isMaxRow[0]===0&&isMaxRow[1]===rowMax){last.row[1]=rowMax;last.height_move=ctx.visibledatarow[rowMax]-1;}ctx.luckysheet_select_save[ctx.luckysheet_select_save.length-1]=last;scrollToFrozenRowCol(ctx,(_globalCache$freezen4=globalCache.freezen)===null||_globalCache$freezen4===void 0?void 0:_globalCache$freezen4[ctx.currentSheetId]);}else if(ctx.formulaCache.rangestart){rangeDrag(ctx,e,cellInput,scrollX.scrollLeft,scrollY.scrollTop,container,fxInput);}else if(ctx.formulaCache.rangedrag_row_start){rangeDragRow(ctx,e,cellInput,scrollX.scrollLeft,scrollY.scrollTop,container,fxInput);}else if(ctx.formulaCache.rangedrag_column_start){rangeDragColumn(ctx,e,cellInput,scrollX.scrollLeft,scrollY.scrollTop,container,fxInput);}else if(ctx.luckysheet_rows_selected_status);else if(ctx.luckysheet_cols_selected_status);else if(ctx.luckysheet_cell_selected_move);else if(ctx.luckysheet_cell_selected_extend){onDropCellSelect(ctx,e,scrollX,scrollY,container);}else if(ctx.luckysheet_cols_change_size){var _x3=e.pageX-rect.left-ctx.rowHeaderWidth+scrollX.scrollLeft-window.scrollX;if(_x3<rect.width+ctx.scrollLeft-100){var changeSizeLine=container.querySelector(".fortune-change-size-line");if(changeSizeLine){changeSizeLine.style.left="".concat(_x3,"px");}var changeSizeCol=container.querySelector(".fortune-cols-change-size");if(changeSizeCol){changeSizeCol.style.left="".concat(_x3-2,"px");}}}else if(ctx.luckysheet_rows_change_size){var _y3=e.pageY-rect.top-ctx.columnHeaderHeight+scrollY.scrollTop-window.scrollY;if(_y3<rect.height+ctx.scrollTop-20){var _changeSizeLine=container.querySelector(".fortune-change-size-line");if(_changeSizeLine){_changeSizeLine.style.top="".concat(_y3,"px");}var changeSizeRow=container.querySelector(".fortune-rows-change-size");if(changeSizeRow){changeSizeRow.style.top="".concat(_y3,"px");}}}else if(ctx.luckysheet_cols_freeze_drag){var _x4=e.pageX-rect.left-ctx.rowHeaderWidth+ctx.scrollLeft-window.scrollX;var _colLocation=colLocation(_x4,ctx.visibledatacolumn),_colLocation2=index_esm_slicedToArray(_colLocation,2),_col_pre3=_colLocation2[0],col_curr=_colLocation2[1];var _col3=_x4>(_col_pre3+col_curr)/2?col_curr:_col_pre3;if(_x4<rect.width+ctx.scrollLeft-100){var freezeLine=container.querySelector(".fortune-freeze-drag-line");if(freezeLine){freezeLine.style.left="".concat(Math.max(0,_col3-2),"px");}var freezeHandle=container.querySelector(".fortune-cols-freeze-handle");if(freezeHandle){freezeHandle.style.left="".concat(_x4,"px");}var _changeSizeLine2=container.querySelector(".fortune-change-size-line");if(_changeSizeLine2){_changeSizeLine2.style.left="".concat(_x4,"px");}}}else if(ctx.luckysheet_rows_freeze_drag){var _y4=e.pageY-rect.top-ctx.columnHeaderHeight+ctx.scrollTop-window.scrollY;var _rowLocation=rowLocation(_y4,ctx.visibledatarow),_rowLocation2=index_esm_slicedToArray(_rowLocation,2),_row_pre3=_rowLocation2[0],row_curr=_rowLocation2[1];var _row3=_y4>(row_curr+_row_pre3)/2?row_curr:_row_pre3;if(_y4<rect.height+ctx.scrollTop-20){var _freezeLine=container.querySelector(".fortune-freeze-drag-line");if(_freezeLine){_freezeLine.style.top="".concat(Math.max(0,_row3-2),"px");}var _freezeHandle=container.querySelector(".fortune-rows-freeze-handle");if(_freezeHandle){_freezeHandle.style.top="".concat(_y4,"px");}var _changeSizeLine3=container.querySelector(".fortune-change-size-line");if(_changeSizeLine3){_changeSizeLine3.style.top="".concat(_y4,"px");}}}}function handleOverlayMouseMove(ctx,globalCache,e,cellInput,scrollX,scrollY,container,fxInput){if(onCommentBoxResize(ctx,globalCache,e))return;if(onCommentBoxMove(ctx,globalCache,e))return;if(onImageMove(ctx,globalCache,e))return;if(onImageResize(ctx,globalCache,e))return;onCellsMove(ctx,globalCache,e,scrollX,scrollY,container);overShowComment(ctx,e,scrollX,scrollY,container);onSearchDialogMove(globalCache,e);onRangeSelectionModalMove(globalCache,e);if(!!ctx.luckysheet_scroll_status||!!ctx.luckysheet_select_status||!!ctx.luckysheet_rows_selected_status||!!ctx.luckysheet_cols_selected_status||!!ctx.luckysheet_cell_selected_move||!!ctx.luckysheet_cell_selected_extend||!!ctx.luckysheet_cols_change_size||!!ctx.luckysheet_rows_change_size){mouseRender(ctx,globalCache,e,cellInput,scrollX,scrollY,container,fxInput);}}function handleOverlayMouseUp(ctx,globalCache,settings,e,scrollbarX,scrollbarY,container,cellInput,fxInput){var rect=container.getBoundingClientRect();onImageMoveEnd(ctx,globalCache);onImageResizeEnd(ctx,globalCache);onCommentBoxMoveEnd(ctx,globalCache);onCommentBoxResizeEnd(ctx,globalCache);onFormulaRangeDragEnd(ctx);onSearchDialogMoveEnd(globalCache);onRangeSelectionModalMoveEnd(globalCache);onCellsMoveEnd(ctx,globalCache,e,scrollbarX,scrollbarY,container);if(ctx.formulaCache.rangestart||ctx.formulaCache.rangedrag_column_start||ctx.formulaCache.rangedrag_row_start){var _document$activeEleme;if(((_document$activeEleme=document.activeElement)===null||_document$activeEleme===void 0?void 0:_document$activeEleme.id)==="luckysheet-functionbox-cell"){handleFormulaInput(ctx,cellInput,fxInput,0,undefined,false);}else{handleFormulaInput(ctx,fxInput,cellInput,0,undefined,false);}}if(ctx.luckysheet_select_status){if(ctx.luckysheetPaintModelOn){pasteHandlerOfPaintModel(ctx,ctx.luckysheet_copy_save);if(ctx.luckysheetPaintSingle){cancelPaintModel(ctx);}}}ctx.luckysheet_select_status=false;ctx.luckysheet_scroll_status=false;ctx.luckysheet_rows_selected_status=false;ctx.luckysheet_cols_selected_status=false;ctx.luckysheet_model_move_state=false;if(ctx.luckysheet_rows_change_size){var _ctx$luckysheet_selec7,_ctx$luckysheet_selec8;ctx.luckysheet_rows_change_size=false;var scrollTop=ctx.scrollTop;var y=e.pageY-rect.top-ctx.columnHeaderHeight+scrollTop-window.scrollY;var winH=rect.height;var delta=y+3-ctx.luckysheet_rows_change_size_start[0];if(y>=winH-20+scrollTop){delta=winH-20-ctx.luckysheet_rows_change_size_start[0]+scrollTop;}var cfg=ctx.config;if(cfg.rowlen==null){cfg.rowlen={};}if(cfg.customHeight==null){cfg.customHeight={};}var size=ctx.defaultrowlen;if(ctx.visibledatarow[ctx.luckysheet_rows_change_size_start[1]]!=null){size=ctx.visibledatarow[ctx.luckysheet_rows_change_size_start[1]]-(ctx.visibledatarow[ctx.luckysheet_rows_change_size_start[1]-1]||0);}size+=delta;if(size<10){size=10;}cfg.customHeight[ctx.luckysheet_rows_change_size_start[1]]=1;var changeRowIndex=ctx.luckysheet_rows_change_size_start[1];var changeRowSelected=false;if(((_ctx$luckysheet_selec7=(_ctx$luckysheet_selec8=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec8===void 0?void 0:_ctx$luckysheet_selec8.length)!==null&&_ctx$luckysheet_selec7!==void 0?_ctx$luckysheet_selec7:0)>0){var _ctx$luckysheet_selec9,_ctx$luckysheet_selec10;(_ctx$luckysheet_selec9=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec9===void 0?void 0:(_ctx$luckysheet_selec10=_ctx$luckysheet_selec9.filter(function(select){return select.row_select;}))===null||_ctx$luckysheet_selec10===void 0?void 0:_ctx$luckysheet_selec10.some(function(select){if(changeRowIndex>=select.row[0]&&changeRowIndex<=select.row[1]){changeRowSelected=true;}return changeRowSelected;});}if(changeRowSelected){var _ctx$luckysheet_selec11,_ctx$luckysheet_selec12;cfg.rowlen||(cfg.rowlen={});(_ctx$luckysheet_selec11=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec11===void 0?void 0:(_ctx$luckysheet_selec12=_ctx$luckysheet_selec11.filter(function(select){return select.row_select;}))===null||_ctx$luckysheet_selec12===void 0?void 0:_ctx$luckysheet_selec12.forEach(function(select){for(var r=select.row[0];r<=select.row[1];r+=1){cfg.rowlen[r]=Math.ceil(size/ctx.zoomRatio);}});}else{cfg.rowlen[ctx.luckysheet_rows_change_size_start[1]]=Math.ceil(size/ctx.zoomRatio);}ctx.config=cfg;var idx=getSheetIndex(ctx,ctx.currentSheetId);if(idx==null)return;ctx.luckysheetfile[idx].config=ctx.config;}if(ctx.luckysheet_cols_change_size){var _ctx$luckysheet_selec13,_ctx$luckysheet_selec14;ctx.luckysheet_cols_change_size=false;var scrollLeft=ctx.scrollLeft;var x=e.pageX-rect.left-ctx.rowHeaderWidth+scrollLeft-window.scrollX;var winW=rect.width;var _delta=x+3-ctx.luckysheet_cols_change_size_start[0];if(x>=winW-100+scrollLeft){_delta=winW-100-ctx.luckysheet_cols_change_size_start[0]+scrollLeft;}_delta/=ctx.zoomRatio;var _cfg=ctx.config;if(_cfg.columnlen==null){_cfg.columnlen={};}if(_cfg.customWidth==null){_cfg.customWidth={};}var firstcolumnlen=ctx.defaultcollen;if(ctx.config.columnlen!=null&&ctx.config.columnlen[ctx.luckysheet_cols_change_size_start[1]]!=null){firstcolumnlen=ctx.config.columnlen[ctx.luckysheet_cols_change_size_start[1]];}var _size=(_cfg.columnlen[ctx.luckysheet_cols_change_size_start[1]]||ctx.defaultcollen)+_delta;if(Math.abs(_size-firstcolumnlen)<3){return;}if(_size<10){_size=10;}_cfg.customWidth[ctx.luckysheet_cols_change_size_start[1]]=1;var changeColumnIndex=ctx.luckysheet_cols_change_size_start[1];var changeColumnSelected=false;if(((_ctx$luckysheet_selec13=(_ctx$luckysheet_selec14=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec14===void 0?void 0:_ctx$luckysheet_selec14.length)!==null&&_ctx$luckysheet_selec13!==void 0?_ctx$luckysheet_selec13:0)>0){var _ctx$luckysheet_selec15,_ctx$luckysheet_selec16;(_ctx$luckysheet_selec15=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec15===void 0?void 0:(_ctx$luckysheet_selec16=_ctx$luckysheet_selec15.filter(function(select){return select.column_select;}))===null||_ctx$luckysheet_selec16===void 0?void 0:_ctx$luckysheet_selec16.some(function(select){if(changeColumnIndex>=select.column[0]&&changeColumnIndex<=select.column[1]){changeColumnSelected=true;}return changeColumnSelected;});}if(changeColumnSelected){var _ctx$luckysheet_selec17,_ctx$luckysheet_selec18;_cfg.columnlen||(_cfg.columnlen={});(_ctx$luckysheet_selec17=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec17===void 0?void 0:(_ctx$luckysheet_selec18=_ctx$luckysheet_selec17.filter(function(select){return select.column_select;}))===null||_ctx$luckysheet_selec18===void 0?void 0:_ctx$luckysheet_selec18.forEach(function(select){for(var r=select.column[0];r<=select.column[1];r+=1){_cfg.columnlen[r]=Math.ceil(_size/ctx.zoomRatio);}});}else{_cfg.columnlen[ctx.luckysheet_cols_change_size_start[1]]=Math.ceil(_size/ctx.zoomRatio);}ctx.config=_cfg;var _idx=getSheetIndex(ctx,ctx.currentSheetId);if(_idx==null)return;ctx.luckysheetfile[_idx].config=ctx.config;}if(ctx.luckysheet_cols_freeze_drag){ctx.luckysheet_cols_freeze_drag=false;var _scrollLeft=ctx.scrollLeft;var _x5=e.pageX-rect.left-ctx.rowHeaderWidth+_scrollLeft-window.scrollX;var _colLocation3=colLocation(_x5,ctx.visibledatacolumn),_colLocation4=index_esm_slicedToArray(_colLocation3,3),col_pre=_colLocation4[0],col_curr=_colLocation4[1],col_index_curr=_colLocation4[2];var col_index=_x5>(col_curr+col_pre)/2?col_index_curr:col_index_curr-1;var _idx2=getSheetIndex(ctx,ctx.currentSheetId);if(_idx2==null)return;if(col_index<0){var frozen=ctx.luckysheetfile[_idx2].frozen;if(frozen){if(frozen.type==="rangeBoth"||frozen.type==="both"){frozen.type="rangeRow";}else if(frozen.type==="column"||frozen.type==="rangeColumn"){delete ctx.luckysheetfile[_idx2].frozen;}}var _freezeHandle2=container.querySelector(".fortune-cols-freeze-handle");if(_freezeHandle2){_freezeHandle2.style.left="".concat(ctx.scrollLeft,"px");}}else if(!ctx.luckysheetfile[_idx2].frozen){ctx.luckysheetfile[_idx2].frozen={type:"rangeColumn",range:{column_focus:col_index,row_focus:0}};}else{var _frozen=ctx.luckysheetfile[_idx2].frozen;if(!_frozen.range){_frozen.range={column_focus:col_index,row_focus:0};}else{_frozen.range.column_focus=col_index;}if((_frozen===null||_frozen===void 0?void 0:_frozen.type)==="rangeRow"||(_frozen===null||_frozen===void 0?void 0:_frozen.type)==="row"){_frozen.type="rangeBoth";}}var freezeHandle=container.querySelector(".fortune-cols-freeze-handle");if(freezeHandle){freezeHandle.style.left="".concat(getFrozenHandleLeft(ctx),"px");}}if(ctx.luckysheet_rows_freeze_drag){ctx.luckysheet_rows_freeze_drag=false;var _scrollTop=ctx.scrollTop;var _y5=e.pageY-rect.top-ctx.columnHeaderHeight+_scrollTop-window.scrollY;var _rowLocation3=rowLocation(_y5,ctx.visibledatarow),_rowLocation4=index_esm_slicedToArray(_rowLocation3,3),row_pre=_rowLocation4[0],row_curr=_rowLocation4[1],row_index_curr=_rowLocation4[2];var row_index=_y5>(row_curr+row_pre)/2?row_index_curr:row_index_curr-1;var _idx3=getSheetIndex(ctx,ctx.currentSheetId);if(_idx3==null)return;if(row_index<0){var _frozen2=ctx.luckysheetfile[_idx3].frozen;if(_frozen2){if(_frozen2.type==="rangeBoth"||_frozen2.type==="both"){_frozen2.type="rangeColumn";}else if(_frozen2.type==="row"||_frozen2.type==="rangeRow"){delete ctx.luckysheetfile[_idx3].frozen;}}}else if(!ctx.luckysheetfile[_idx3].frozen){ctx.luckysheetfile[_idx3].frozen={type:"rangeRow",range:{column_focus:0,row_focus:row_index}};}else{var _frozen3=ctx.luckysheetfile[_idx3].frozen;if(!_frozen3.range){_frozen3.range={column_focus:0,row_focus:row_index};}else{_frozen3.range.row_focus=row_index;}if((_frozen3===null||_frozen3===void 0?void 0:_frozen3.type)==="rangeColumn"||(_frozen3===null||_frozen3===void 0?void 0:_frozen3.type)==="column"){_frozen3.type="rangeBoth";}}var _freezeHandle3=container.querySelector(".fortune-rows-freeze-handle");if(_freezeHandle3){_freezeHandle3.style.top="".concat(getFrozenHandleTop(ctx),"px");}}if(ctx.luckysheet_cell_selected_extend){onDropCellSelectEnd(ctx,e,container);}}function handleRowHeaderMouseDown(ctx,globalCache,e,container,cellInput,fxInput){var _globalCache$freezen5;if(!checkProtectionAllSelected(ctx,ctx.currentSheetId)){return;}removeEditingComment(ctx,globalCache);cancelActiveImgItem(ctx,globalCache);var rect=container.getBoundingClientRect();var mouseY=e.pageY-rect.top-window.scrollY;var _y=mouseY+ctx.scrollTop;var freeze=(_globalCache$freezen5=globalCache.freezen)===null||_globalCache$freezen5===void 0?void 0:_globalCache$freezen5[ctx.currentSheetId];var _fixPositionOnFrozenC7=fixPositionOnFrozenCells(freeze,0,_y,0,mouseY),y=_fixPositionOnFrozenC7.y;var row_location=rowLocation(y,ctx.visibledatarow);var row=row_location[1];var row_pre=row_location[0];var row_index=row_location[2];var col_index=ctx.visibledatacolumn.length-1;var col=ctx.visibledatacolumn[col_index];var col_pre=0;if(e.button===2){var flowdata=getFlowdata(ctx);var isInSelection=lodash_default().some(ctx.luckysheet_select_save,function(obj_s){var _flowdata$0$length,_flowdata$;return obj_s.row!=null&&row_index>=obj_s.row[0]&&row_index<=obj_s.row[1]&&obj_s.column[0]===0&&obj_s.column[1]===((_flowdata$0$length=flowdata===null||flowdata===void 0?void 0:(_flowdata$=flowdata[0])===null||_flowdata$===void 0?void 0:_flowdata$.length)!==null&&_flowdata$0$length!==void 0?_flowdata$0$length:0)-1;});if(isInSelection)return;}var top=row_pre;var height=row-row_pre-1;var rowseleted=[row_index,row_index];ctx.luckysheet_scroll_status=true;if(!lodash_default().isEmpty(ctx.luckysheetCellUpdate)){if(ctx.formulaCache.rangestart||ctx.formulaCache.rangedrag_column_start||ctx.formulaCache.rangedrag_row_start||israngeseleciton(ctx)){var _$last2;var changeparam=mergeMoveMain(ctx,[0,col_index],rowseleted,{row_focus:row_index,column_focus:0},top,height,col_pre,col);if(changeparam!=null){var _ref=[changeparam[1],changeparam[2],changeparam[3]];rowseleted=_ref[0];top=_ref[1];height=_ref[2];}if(e.shiftKey){var last=ctx.formulaCache.func_selectedrange;top=0;height=0;rowseleted=[];if(last==null||last.top==null||last.height==null||last.row==null||last.row_focus==null)return;if(last.top>row_pre){top=row_pre;height=last.top+last.height-row_pre;if(last.row[1]>last.row_focus){last.row[1]=last.row_focus;}rowseleted=[row_index,last.row[1]];}else if(last.top===row_pre){top=row_pre;height=last.top+last.height-row_pre;rowseleted=[row_index,last.row[0]];}else{top=last.top;height=row-last.top-1;if(last.row[0]<last.row_focus){last.row[0]=last.row_focus;}rowseleted=[last.row[0],row_index];}changeparam=mergeMoveMain(ctx,[0,col_index],rowseleted,{row_focus:row_index,column_focus:0},top,height,col_pre,col);if(changeparam!=null){var _ref2=[changeparam[1],changeparam[2],changeparam[3]];rowseleted=_ref2[0];top=_ref2[1];height=_ref2[2];}last.row=rowseleted;last.top_move=top;last.height_move=height;ctx.formulaCache.func_selectedrange=last;}else if(e.ctrlKey&&((_$last2=lodash_default().last(cellInput.querySelectorAll("span")))===null||_$last2===void 0?void 0:_$last2.innerText)!==","){var vText="".concat(cellInput.innerText,",");if(vText.length>0&&vText.substring(0,1)==="="){vText=functionHTMLGenerate(vText);if(window.getSelection){var _currSelection$anchor5,_currSelection$anchor6,_currSelection$anchor7,_currSelection$anchor8;var currSelection=window.getSelection();if(currSelection==null)return;ctx.formulaCache.functionRangeIndex=[lodash_default().indexOf((_currSelection$anchor5=currSelection.anchorNode)===null||_currSelection$anchor5===void 0?void 0:(_currSelection$anchor6=_currSelection$anchor5.parentNode)===null||_currSelection$anchor6===void 0?void 0:(_currSelection$anchor7=_currSelection$anchor6.parentNode)===null||_currSelection$anchor7===void 0?void 0:_currSelection$anchor7.childNodes,(_currSelection$anchor8=currSelection.anchorNode)===null||_currSelection$anchor8===void 0?void 0:_currSelection$anchor8.parentNode),currSelection.anchorOffset];}else{var textRange=document.selection.createRange();ctx.formulaCache.functionRangeIndex=textRange;}cellInput.innerHTML=vText;cancelFunctionrangeSelected(ctx);createRangeHightlight(ctx,vText);}ctx.formulaCache.rangestart=false;ctx.formulaCache.rangedrag_column_start=false;ctx.formulaCache.rangedrag_row_start=false;if(fxInput)fxInput.innerHTML=vText;rangeHightlightselected(ctx,cellInput);israngeseleciton(ctx);ctx.formulaCache.func_selectedrange={left:colLocationByIndex(0,ctx.visibledatacolumn)[0],width:colLocationByIndex(0,ctx.visibledatacolumn)[1]-colLocationByIndex(0,ctx.visibledatacolumn)[0]-1,top:top,height:height,left_move:col_pre,width_move:col-col_pre-1,top_move:top,height_move:height,row:rowseleted,column:[0,col_index],row_focus:row_index,column_focus:0};}else{ctx.formulaCache.func_selectedrange={left:colLocationByIndex(0,ctx.visibledatacolumn)[0],width:colLocationByIndex(0,ctx.visibledatacolumn)[1]-colLocationByIndex(0,ctx.visibledatacolumn)[0]-1,top:top,height:height,left_move:col_pre,width_move:col-col_pre-1,top_move:top,height_move:height,row:rowseleted,column:[0,col_index],row_focus:row_index,column_focus:0};}if(ctx.formulaCache.rangestart||ctx.formulaCache.rangedrag_column_start||ctx.formulaCache.rangedrag_row_start||israngeseleciton(ctx)){rangeSetValue(ctx,cellInput,{row:rowseleted,column:[null,null]},fxInput);}ctx.formulaCache.rangedrag_row_start=true;ctx.formulaCache.rangestart=false;ctx.formulaCache.rangedrag_column_start=false;ctx.formulaCache.selectingRangeIndex=ctx.formulaCache.rangechangeindex;if(ctx.formulaCache.rangechangeindex>ctx.formulaRangeHighlight.length){createRangeHightlight(ctx,cellInput.innerHTML,ctx.formulaCache.rangechangeindex);}createFormulaRangeSelect(ctx,{rangeIndex:ctx.formulaCache.rangechangeindex||0,left:col_pre,top:top,width:col-col_pre-1,height:height});e.preventDefault();return;}updateCell(ctx,ctx.luckysheetCellUpdate[0],ctx.luckysheetCellUpdate[1],cellInput);ctx.luckysheet_rows_selected_status=true;}else{ctx.luckysheet_rows_selected_status=true;}if(ctx.luckysheet_rows_selected_status){if(e.shiftKey){var _ctx$luckysheet_selec19;var _last2=lodash_default().cloneDeep((_ctx$luckysheet_selec19=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec19===void 0?void 0:_ctx$luckysheet_selec19[ctx.luckysheet_select_save.length-1]);if(!_last2||lodash_default().isNil(_last2.top)||lodash_default().isNil(_last2.height)||lodash_default().isNil(_last2.row_focus)){return;}var _top=0;var _height=0;var _rowseleted=[];if(_last2.top>row_pre){_top=row_pre;_height=_last2.top+_last2.height-row_pre;if(_last2.row[1]>_last2.row_focus){_last2.row[1]=_last2.row_focus;}_rowseleted=[row_index,_last2.row[1]];}else if(_last2.top===row_pre){_top=row_pre;_height=_last2.top+_last2.height-row_pre;_rowseleted=[row_index,_last2.row[0]];}else{_top=_last2.top;_height=row-_last2.top-1;if(_last2.row[0]<_last2.row_focus){_last2.row[0]=_last2.row_focus;}_rowseleted=[_last2.row[0],row_index];}_last2.row=_rowseleted;_last2.top_move=_top;_last2.height_move=_height;ctx.luckysheet_select_save[ctx.luckysheet_select_save.length-1]=_last2;}else if(e.ctrlKey||e.metaKey){var _ctx$luckysheet_selec20;(_ctx$luckysheet_selec20=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec20===void 0?void 0:_ctx$luckysheet_selec20.push({left:colLocationByIndex(0,ctx.visibledatacolumn)[0],width:colLocationByIndex(0,ctx.visibledatacolumn)[1]-colLocationByIndex(0,ctx.visibledatacolumn)[0]-1,top:top,height:height,left_move:col_pre,width_move:col-col_pre-1,top_move:top,height_move:height,row:rowseleted,column:[0,col_index],row_focus:row_index,column_focus:0,row_select:true});}else{ctx.luckysheet_select_save=[];ctx.luckysheet_select_save.push({left:colLocationByIndex(0,ctx.visibledatacolumn)[0],width:colLocationByIndex(0,ctx.visibledatacolumn)[1]-colLocationByIndex(0,ctx.visibledatacolumn)[0]-1,top:top,height:height,left_move:col_pre,width_move:col-col_pre-1,top_move:top,height_move:height,row:rowseleted,column:[0,col_index],row_focus:row_index,column_focus:0,row_select:true});ctx.luckysheet_select_status=true;ctx.luckysheet_scroll_status=true;}}}function handleColumnHeaderMouseDown(ctx,globalCache,e,container,cellInput,fxInput){var _globalCache$freezen6;if(!checkProtectionAllSelected(ctx,ctx.currentSheetId)){return;}removeEditingComment(ctx,globalCache);cancelActiveImgItem(ctx,globalCache);var rect=container.getBoundingClientRect();var mouseX=e.pageX-rect.left-window.scrollX;var _x=mouseX+ctx.scrollLeft;var freeze=(_globalCache$freezen6=globalCache.freezen)===null||_globalCache$freezen6===void 0?void 0:_globalCache$freezen6[ctx.currentSheetId];var _fixPositionOnFrozenC8=fixPositionOnFrozenCells(freeze,_x,0,mouseX,0),x=_fixPositionOnFrozenC8.x;var row_index=ctx.visibledatarow.length-1;var row=ctx.visibledatarow[row_index];var row_pre=0;var col_location=colLocation(x,ctx.visibledatacolumn);var col=col_location[1];var col_pre=col_location[0];var col_index=col_location[2];ctx.orderbyindex=col_index;if(e.button===2){var flowdata=getFlowdata(ctx);var isInSelection=lodash_default().some(ctx.luckysheet_select_save,function(obj_s){var _flowdata$length;return obj_s.column!=null&&col_index>=obj_s.column[0]&&col_index<=obj_s.column[1]&&obj_s.row[0]===0&&obj_s.row[1]===((_flowdata$length=flowdata===null||flowdata===void 0?void 0:flowdata.length)!==null&&_flowdata$length!==void 0?_flowdata$length:0)-1;});if(isInSelection)return;}var left=col_pre;var width=col-col_pre-1;var columnseleted=[col_index,col_index];ctx.luckysheet_scroll_status=true;if(!lodash_default().isEmpty(ctx.luckysheetCellUpdate)){if(ctx.formulaCache.rangestart||ctx.formulaCache.rangedrag_column_start||ctx.formulaCache.rangedrag_row_start||israngeseleciton(ctx)){var _$last3;var changeparam=mergeMoveMain(ctx,columnseleted,[0,row_index],{row_focus:0,column_focus:col_index},row_pre,row,left,width);if(changeparam!=null){var _ref3=[changeparam[0],changeparam[4],changeparam[5]];columnseleted=_ref3[0];left=_ref3[1];width=_ref3[2];}if(e.shiftKey){var last=ctx.formulaCache.func_selectedrange;left=0;width=0;columnseleted=[];if(last==null||last.width==null||last.height==null||last.left==null||last.column_focus==null)return;if(last.left>col_pre){left=col_pre;width=last.left+last.width-col_pre;if(last.column[1]>last.column_focus){last.column[1]=last.column_focus;}columnseleted=[col_index,last.column[1]];}else if(last.left===col_pre){left=col_pre;width=last.left+last.width-col_pre;columnseleted=[col_index,last.column[0]];}else{left=last.left;width=col-last.left-1;if(last.column[0]<last.column_focus){last.column[0]=last.column_focus;}columnseleted=[last.column[0],col_index];}changeparam=mergeMoveMain(ctx,columnseleted,[0,row_index],{row_focus:0,column_focus:col_index},row_pre,row,left,width);if(changeparam!=null){var _ref4=[changeparam[0],changeparam[4],changeparam[5]];columnseleted=_ref4[0];left=_ref4[1];width=_ref4[2];}last.column=columnseleted;last.left_move=left;last.width_move=width;ctx.formulaCache.func_selectedrange=last;}else if(e.ctrlKey&&((_$last3=lodash_default().last(cellInput.querySelectorAll("span")))===null||_$last3===void 0?void 0:_$last3.innerText)!==","){var vText="".concat(cellInput.innerText,",");if(vText.length>0&&vText.substring(0,1)==="="){vText=functionHTMLGenerate(vText);if(window.getSelection){var _currSelection$anchor9,_currSelection$anchor10,_currSelection$anchor11,_currSelection$anchor12;var currSelection=window.getSelection();if(currSelection==null)return;ctx.formulaCache.functionRangeIndex=[lodash_default().indexOf((_currSelection$anchor9=currSelection.anchorNode)===null||_currSelection$anchor9===void 0?void 0:(_currSelection$anchor10=_currSelection$anchor9.parentNode)===null||_currSelection$anchor10===void 0?void 0:(_currSelection$anchor11=_currSelection$anchor10.parentNode)===null||_currSelection$anchor11===void 0?void 0:_currSelection$anchor11.childNodes,(_currSelection$anchor12=currSelection.anchorNode)===null||_currSelection$anchor12===void 0?void 0:_currSelection$anchor12.parentNode),currSelection.anchorOffset];}else{var textRange=document.selection.createRange();ctx.formulaCache.functionRangeIndex=textRange;}cellInput.innerHTML=vText;cancelFunctionrangeSelected(ctx);createRangeHightlight(ctx,vText);}ctx.formulaCache.rangestart=false;ctx.formulaCache.rangedrag_column_start=false;ctx.formulaCache.rangedrag_row_start=false;if(fxInput){fxInput.innerHTML=vText;}rangeHightlightselected(ctx,cellInput);israngeseleciton(ctx);ctx.formulaCache.func_selectedrange={left:left,width:width,top:rowLocationByIndex(0,ctx.visibledatarow)[0],height:rowLocationByIndex(0,ctx.visibledatarow)[1]-rowLocationByIndex(0,ctx.visibledatarow)[0]-1,left_move:left,width_move:width,top_move:row_pre,height_move:row-row_pre-1,row:[0,row_index],column:columnseleted,row_focus:0,column_focus:col_index};}else{ctx.formulaCache.func_selectedrange={left:left,width:width,top:rowLocationByIndex(0,ctx.visibledatarow)[0],height:rowLocationByIndex(0,ctx.visibledatarow)[1]-rowLocationByIndex(0,ctx.visibledatarow)[0]-1,left_move:left,width_move:width,top_move:row_pre,height_move:row-row_pre-1,row:[0,row_index],column:columnseleted,row_focus:0,column_focus:col_index};}if(ctx.formulaCache.rangestart||ctx.formulaCache.rangedrag_column_start||ctx.formulaCache.rangedrag_row_start||israngeseleciton(ctx)){rangeSetValue(ctx,cellInput,{row:[null,null],column:columnseleted},fxInput);}ctx.formulaCache.rangedrag_column_start=true;ctx.formulaCache.rangestart=false;ctx.formulaCache.rangedrag_row_start=false;ctx.formulaCache.selectingRangeIndex=ctx.formulaCache.rangechangeindex;if(ctx.formulaCache.rangechangeindex>ctx.formulaRangeHighlight.length){createRangeHightlight(ctx,cellInput.innerHTML,ctx.formulaCache.rangechangeindex);}createFormulaRangeSelect(ctx,{rangeIndex:ctx.formulaCache.rangechangeindex||0,left:left,top:row_pre,width:width,height:row-row_pre-1});e.preventDefault();return;}updateCell(ctx,ctx.luckysheetCellUpdate[0],ctx.luckysheetCellUpdate[1],cellInput);ctx.luckysheet_cols_selected_status=true;}else{ctx.luckysheet_cols_selected_status=true;}if(ctx.luckysheet_cols_selected_status){if(e.shiftKey){var _ctx$luckysheet_selec21;var _last3=lodash_default().cloneDeep((_ctx$luckysheet_selec21=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec21===void 0?void 0:_ctx$luckysheet_selec21[ctx.luckysheet_select_save.length-1]);var _left=0;var _width=0;var _columnseleted=[];if(!_last3||lodash_default().isNil(_last3.left)||lodash_default().isNil(_last3.width)||lodash_default().isNil(_last3.column_focus)){return;}if(_last3.left>col_pre){_left=col_pre;_width=_last3.left+_last3.width-col_pre;if(_last3.column[1]>_last3.column_focus){_last3.column[1]=_last3.column_focus;}_columnseleted=[col_index,_last3.column[1]];}else if(_last3.left===col_pre){_left=col_pre;_width=_last3.left+_last3.width-col_pre;_columnseleted=[col_index,_last3.column[0]];}else{_left=_last3.left;_width=col-_last3.left-1;if(_last3.column[0]<_last3.column_focus){_last3.column[0]=_last3.column_focus;}_columnseleted=[_last3.column[0],col_index];}_last3.column=_columnseleted;_last3.left_move=_left;_last3.width_move=_width;ctx.luckysheet_select_save[ctx.luckysheet_select_save.length-1]=_last3;}else if(e.ctrlKey||e.metaKey){var _ctx$luckysheet_selec22;(_ctx$luckysheet_selec22=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec22===void 0?void 0:_ctx$luckysheet_selec22.push({left:left,width:width,top:rowLocationByIndex(0,ctx.visibledatarow)[0],height:rowLocationByIndex(0,ctx.visibledatarow)[1]-rowLocationByIndex(0,ctx.visibledatarow)[0]-1,left_move:left,width_move:width,top_move:row_pre,height_move:row-row_pre-1,row:[0,row_index],column:columnseleted,row_focus:0,column_focus:col_index,column_select:true});}else{ctx.luckysheet_select_save=[];ctx.luckysheet_select_save.push({left:left,width:width,top:rowLocationByIndex(0,ctx.visibledatarow)[0],height:rowLocationByIndex(0,ctx.visibledatarow)[1]-rowLocationByIndex(0,ctx.visibledatarow)[0]-1,left_move:left,width_move:width,top_move:row_pre,height_move:row-row_pre-1,row:[0,row_index],column:columnseleted,row_focus:0,column_focus:col_index,column_select:true});ctx.luckysheet_select_status=true;ctx.luckysheet_scroll_status=true;}}}function handleColSizeHandleMouseDown(ctx,globalCache,e,headerContainer,workbookContainer,cellArea){var _globalCache$freezen7;removeEditingComment(ctx,globalCache);cancelActiveImgItem(ctx,globalCache);ctx.luckysheetCellUpdate=[];var scrollLeft=ctx.scrollLeft;var scrollTop=ctx.scrollTop;var mouseX=e.pageX-headerContainer.getBoundingClientRect().left-window.scrollX;var _x=mouseX+scrollLeft;var freeze=(_globalCache$freezen7=globalCache.freezen)===null||_globalCache$freezen7===void 0?void 0:_globalCache$freezen7[ctx.currentSheetId];var _fixPositionOnFrozenC9=fixPositionOnFrozenCells(freeze,_x,0,mouseX,0),x=_fixPositionOnFrozenC9.x;var col_location=colLocation(x,ctx.visibledatacolumn);var col=col_location[1];var col_index=col_location[2];ctx.luckysheet_cols_change_size=true;ctx.luckysheet_scroll_status=true;var changeSizeLine=workbookContainer.querySelector(".fortune-change-size-line");if(changeSizeLine){var ele=changeSizeLine;ele.style.height="".concat(cellArea.getBoundingClientRect().height+scrollTop,"px");ele.style.borderWidth="0 1px 0 0";ele.style.top="0";ele.style.left="".concat(col-3,"px");ele.style.width="1px";}ctx.luckysheet_cols_change_size_start=[_x,col_index];e.stopPropagation();}function handleRowSizeHandleMouseDown(ctx,globalCache,e,headerContainer,workbookContainer,cellArea){var _globalCache$freezen8;removeEditingComment(ctx,globalCache);cancelActiveImgItem(ctx,globalCache);if(ctx.formulaCache.rangestart||ctx.formulaCache.rangedrag_column_start||ctx.formulaCache.rangedrag_row_start||israngeseleciton(ctx))return;ctx.luckysheetCellUpdate=[];var scrollLeft=ctx.scrollLeft;var scrollTop=ctx.scrollTop;var mouseY=e.pageY-headerContainer.getBoundingClientRect().top-window.scrollY;var _y=mouseY+scrollTop;var freeze=(_globalCache$freezen8=globalCache.freezen)===null||_globalCache$freezen8===void 0?void 0:_globalCache$freezen8[ctx.currentSheetId];var _fixPositionOnFrozenC10=fixPositionOnFrozenCells(freeze,0,_y,0,mouseY),y=_fixPositionOnFrozenC10.y;var row_location=rowLocation(y,ctx.visibledatarow);var row=row_location[1];var row_index=row_location[2];ctx.luckysheet_rows_change_size=true;ctx.luckysheet_scroll_status=true;var changeSizeLine=workbookContainer.querySelector(".fortune-change-size-line");if(changeSizeLine){var ele=changeSizeLine;ele.style.width="".concat(cellArea.getBoundingClientRect().width+scrollLeft,"px");ele.style.borderWidth="0 0 1px 0";ele.style.top="".concat(row-3,"px");ele.style.left="0";ele.style.height="1px";}ctx.luckysheet_rows_change_size_start=[_y,row_index];e.stopPropagation();}function handleColFreezeHandleMouseDown(ctx,globalCache,e,headerContainer,workbookContainer,cellArea){removeEditingComment(ctx,globalCache);cancelActiveImgItem(ctx,globalCache);ctx.luckysheetCellUpdate=[];var scrollLeft=ctx.scrollLeft;var scrollTop=ctx.scrollTop;var x=e.pageX-headerContainer.getBoundingClientRect().left+scrollLeft;var col_location=colLocation(x,ctx.visibledatacolumn);var col=col_location[1];ctx.luckysheet_cols_freeze_drag=true;ctx.luckysheet_scroll_status=true;var freezeDragLine=workbookContainer.querySelector(".fortune-freeze-drag-line");if(freezeDragLine){var ele=freezeDragLine;ele.style.height="".concat(cellArea.getBoundingClientRect().height+scrollTop,"px");ele.style.borderWidth="0 3px 0 0";ele.style.top="0";ele.style.left="".concat(col-3,"px");ele.style.width="1px";}var changeSizeLine=workbookContainer.querySelector(".fortune-change-size-line");if(changeSizeLine){var _ele=changeSizeLine;_ele.style.height="".concat(cellArea.getBoundingClientRect().height+scrollTop,"px");_ele.style.borderWidth="0 1px 0 0";_ele.style.top="0";_ele.style.left="".concat(col-3,"px");_ele.style.width="1px";}e.stopPropagation();}function handleRowFreezeHandleMouseDown(ctx,globalCache,e,headerContainer,workbookContainer,cellArea){removeEditingComment(ctx,globalCache);cancelActiveImgItem(ctx,globalCache);ctx.luckysheetCellUpdate=[];var scrollLeft=ctx.scrollLeft;var scrollTop=ctx.scrollTop;var y=e.pageY-headerContainer.getBoundingClientRect().top+scrollTop;var row_location=rowLocation(y,ctx.visibledatarow);var row=row_location[1];ctx.luckysheet_rows_freeze_drag=true;ctx.luckysheet_scroll_status=true;var freezeDragLine=workbookContainer.querySelector(".fortune-freeze-drag-line");if(freezeDragLine){var ele=freezeDragLine;ele.style.width="".concat(cellArea.getBoundingClientRect().width+scrollLeft,"px");ele.style.borderWidth="0 0 3px 0";ele.style.top="".concat(row-3,"px");ele.style.left="0";ele.style.height="1px";}var changeSizeLine=workbookContainer.querySelector(".fortune-change-size-line");if(changeSizeLine){var _ele2=changeSizeLine;_ele2.style.width="".concat(cellArea.getBoundingClientRect().width+scrollLeft,"px");_ele2.style.borderWidth="0 0 1px 0";_ele2.style.top="".concat(row-3,"px");_ele2.style.left="0";_ele2.style.height="1px";}e.stopPropagation();}function postPasteCut(ctx,source,target,RowlChange){var execF_rc={};ctx.formulaCache.execFunctionExist=[];for(var r=source.range.row[0];r<=source.range.row[1];r+=1){for(var c=source.range.column[0];c<=source.range.column[1];c+=1){if("".concat(r,"_").concat(c,"_").concat(source.sheetId)in execF_rc){continue;}execF_rc["".concat(r,"_").concat(c,"_").concat(source.sheetId)]=0;ctx.formulaCache.execFunctionExist.push({r:r,c:c,i:source.sheetId});}}for(var _r=target.range.row[0];_r<=target.range.row[1];_r+=1){for(var _c=target.range.column[0];_c<=target.range.column[1];_c+=1){if("".concat(_r,"_").concat(_c,"_").concat(target.sheetId)in execF_rc){continue;}execF_rc["".concat(_r,"_").concat(_c,"_").concat(target.sheetId)]=0;ctx.formulaCache.execFunctionExist.push({r:_r,c:_c,i:target.sheetId});}}var rowHeight;if(ctx.currentSheetId===source.sheetId){ctx.config=source.curConfig;rowHeight=source.curData.length;ctx.luckysheetfile[getSheetIndex(ctx,target.sheetId)].config=target.curConfig;}else if(ctx.currentSheetId===target.sheetId){ctx.config=target.curConfig;rowHeight=target.curData.length;ctx.luckysheetfile[getSheetIndex(ctx,source.sheetId)].config=source.curConfig;}if(RowlChange){ctx.visibledatarow=[];ctx.rh_height=0;for(var i=0;i<rowHeight;i+=1){var rowlen=ctx.defaultrowlen;if(ctx.config.rowlen!=null&&ctx.config.rowlen[i]!=null){rowlen=ctx.config.rowlen[i];}if(ctx.config.rowhidden!=null&&ctx.config.rowhidden[i]!=null){rowlen=ctx.config.rowhidden[i];ctx.visibledatarow.push(ctx.rh_height);continue;}else{ctx.rh_height+=rowlen+1;}ctx.visibledatarow.push(ctx.rh_height);}ctx.rh_height+=80;if(ctx.currentSheetId===source.sheetId);else if(ctx.currentSheetId===target.sheetId);}if(ctx.currentSheetId===source.sheetId){ctx.luckysheetfile[getSheetIndex(ctx,target.sheetId)].data=target.curData;}else if(ctx.currentSheetId===target.sheetId){ctx.luckysheetfile[getSheetIndex(ctx,source.sheetId)].data=source.curData;}if(ctx.currentSheetId===target.sheetId){ctx.luckysheet_select_save=[{row:target.range.row,column:target.range.column}];}else{ctx.luckysheet_select_save=[{row:source.range.row,column:source.range.column}];}if(ctx.luckysheet_select_save.length>0);ctx.luckysheetfile[getSheetIndex(ctx,source.sheetId)].luckysheet_conditionformat_save=source.curCdformat;ctx.luckysheetfile[getSheetIndex(ctx,target.sheetId)].luckysheet_conditionformat_save=target.curCdformat;ctx.luckysheetfile[getSheetIndex(ctx,source.sheetId)].dataVerification=source.curDataVerification;ctx.luckysheetfile[getSheetIndex(ctx,target.sheetId)].dataVerification=target.curDataVerification;ctx.formulaCache.execFunctionExist.reverse();execFunctionGroup(ctx,null,null,null,null,target.curData);ctx.formulaCache.execFunctionGlobalData=null;storeSheetParamALL(ctx);}function pasteHandler(ctx,data,borderInfo){var _ctx$luckysheet_selec,_ctx$luckysheet_selec2;var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;if(((_ctx$luckysheet_selec=(_ctx$luckysheet_selec2=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec2===void 0?void 0:_ctx$luckysheet_selec2.length)!==null&&_ctx$luckysheet_selec!==void 0?_ctx$luckysheet_selec:0)!==1){return;}if(index_esm_typeof(data)==="object"){if(data.length===0){return;}var cfg=ctx.config||{};if(cfg.merge==null){cfg.merge={};}if(JSON.stringify(borderInfo).length>2&&cfg.borderInfo==null){cfg.borderInfo=[];}var copyh=data.length;var copyc=data[0].length;var minh=ctx.luckysheet_select_save[0].row[0];var maxh=minh+copyh-1;var minc=ctx.luckysheet_select_save[0].column[0];var maxc=minc+copyc-1;var has_PartMC=false;if(cfg.merge!=null){has_PartMC=hasPartMC(ctx,cfg,minh,maxh,minc,maxc);}if(has_PartMC){return;}var d=getFlowdata(ctx);if(!d)return;var rowMaxLength=d.length;var cellMaxLength=d[0].length;var addr=maxh-rowMaxLength+1;var addc=maxc-cellMaxLength+1;if(addr>0||addc>0){expandRowsAndColumns(d,addr,addc);}if(!d)return;if(cfg.rowlen==null){cfg.rowlen={};}var RowlChange=false;var offsetMC={};for(var h=minh;h<=maxh;h+=1){var x=d[h];var currentRowLen=ctx.defaultrowlen;if(cfg.rowlen[h]!=null){currentRowLen=cfg.rowlen[h];}for(var c=minc;c<=maxc;c+=1){var _x$c,_x$c2;if(x===null||x===void 0?void 0:(_x$c=x[c])===null||_x$c===void 0?void 0:_x$c.mc){if("rs"in x[c].mc){delete cfg.merge["".concat(x[c].mc.r,"_").concat(x[c].mc.c)];}delete x[c].mc;}var value=null;if(data[h-minh]!=null&&data[h-minh][c-minc]!=null){value=data[h-minh][c-minc];}x[c]=value;if(value!=null&&(x===null||x===void 0?void 0:(_x$c2=x[c])===null||_x$c2===void 0?void 0:_x$c2.mc)){if(x[c].mc.rs!=null){x[c].mc.r=h;x[c].mc.c=c;cfg.merge["".concat(x[c].mc.r,"_").concat(x[c].mc.c)]=x[c].mc;offsetMC["".concat(value.mc.r,"_").concat(value.mc.c)]=[x[c].mc.r,x[c].mc.c];}else{x[c]={mc:{r:offsetMC["".concat(value.mc.r,"_").concat(value.mc.c)][0],c:offsetMC["".concat(value.mc.r,"_").concat(value.mc.c)][1]}};}}if(borderInfo["".concat(h-minh,"_").concat(c-minc)]){var _cfg$borderInfo;var bd_obj={rangeType:"cell",value:{row_index:h,col_index:c,l:borderInfo["".concat(h-minh,"_").concat(c-minc)].l,r:borderInfo["".concat(h-minh,"_").concat(c-minc)].r,t:borderInfo["".concat(h-minh,"_").concat(c-minc)].t,b:borderInfo["".concat(h-minh,"_").concat(c-minc)].b}};(_cfg$borderInfo=cfg.borderInfo)===null||_cfg$borderInfo===void 0?void 0:_cfg$borderInfo.push(bd_obj);}}d[h]=x;if(currentRowLen!==ctx.defaultrowlen){cfg.rowlen[h]=currentRowLen;}}ctx.luckysheet_select_save=[{row:[minh,maxh],column:[minc,maxc]}];if(addr>0||addc>0||RowlChange){ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)].config=cfg;}else{ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)].config=cfg;}jfrefreshgrid(ctx,null,undefined);}else{var _ctx$luckysheet_selec3;data=data.replace(/\r/g,"");var dataChe=[];var che=data.split("\n");var colchelen=che[0].split("\t").length;for(var i=0;i<che.length;i+=1){if(che[i].split("\t").length<colchelen){continue;}dataChe.push(che[i].split("\t"));}var _d=getFlowdata(ctx);if(!_d)return;var last=(_ctx$luckysheet_selec3=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec3===void 0?void 0:_ctx$luckysheet_selec3[ctx.luckysheet_select_save.length-1];if(!last)return;var curR=last.row==null?0:last.row[0];var curC=last.column==null?0:last.column[0];var rlen=dataChe.length;var clen=dataChe[0].length;var _has_PartMC=false;if(ctx.config.merge!=null){_has_PartMC=hasPartMC(ctx,ctx.config,curR,curR+rlen-1,curC,curC+clen-1);}if(_has_PartMC){return;}var _addr=curR+rlen-_d.length;var _addc=curC+clen-_d[0].length;if(_addr>0||_addc>0){expandRowsAndColumns(_d,_addr,_addc);}if(!_d)return;for(var r=0;r<rlen;r+=1){var _x=_d[r+curR];for(var _c2=0;_c2<clen;_c2+=1){var originCell=_x[_c2+curC];var _value=dataChe[r][_c2];if(isRealNum(_value)){if(originCell&&originCell.ct&&originCell.ct.fa==="@"){_value=String(_value);}else{_value=parseFloat(_value);}}if(originCell){originCell.v=_value;if(originCell.ct!=null&&originCell.ct.fa!=null){originCell.m=update(originCell.ct.fa,_value);}else{originCell.m=_value;}if(originCell.f!=null&&originCell.f.length>0){originCell.f="";delFunctionGroup(ctx,r+curR,_c2+curC,ctx.currentSheetId);}}else{var cell={};var mask=genarate(_value);var _mask=index_esm_slicedToArray(mask,3);cell.m=_mask[0];cell.ct=_mask[1];cell.v=_mask[2];_x[_c2+curC]=cell;}}_d[r+curR]=_x;}last.row=[curR,curR+rlen-1];last.column=[curC,curC+clen-1];jfrefreshgrid(ctx,null,undefined);}}function setCellHyperlink(ctx,id,r,c,link){var index=getSheetIndex(ctx,id);if(!ctx.luckysheetfile[index].hyperlink){ctx.luckysheetfile[index].hyperlink={};}ctx.luckysheetfile[index].hyperlink["".concat(r,"_").concat(c)]=link;}function pasteHandlerOfCutPaste(ctx,copyRange){var _ctx$luckysheet_selec4,_ctx$luckysheet_selec5,_ctx$luckysheet_copy_;var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;if(!copyRange)return;var cfg=ctx.config||{};if(cfg.merge==null){cfg.merge={};}var copyHasMC=copyRange.HasMC;var copyRowlChange=copyRange.RowlChange;var copySheetId=copyRange.dataSheetId;var c_r1=copyRange.copyRange[0].row[0];var c_r2=copyRange.copyRange[0].row[1];var c_c1=copyRange.copyRange[0].column[0];var c_c2=copyRange.copyRange[0].column[1];var copyData=lodash_default().cloneDeep(getdatabyselection(ctx,{row:[c_r1,c_r2],column:[c_c1,c_c2]},copySheetId));var copyh=copyData.length;var copyc=copyData[0].length;var last=(_ctx$luckysheet_selec4=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec4===void 0?void 0:_ctx$luckysheet_selec4[ctx.luckysheet_select_save.length-1];if(!last||last.row_focus==null||last.column_focus==null)return;var minh=last.row_focus;var maxh=minh+copyh-1;var minc=last.column_focus;var maxc=minc+copyc-1;var has_PartMC=false;if(cfg.merge!=null){has_PartMC=hasPartMC(ctx,cfg,minh,maxh,minc,maxc);}if(has_PartMC){return;}var d=getFlowdata(ctx);if(!d)return;var rowMaxLength=d.length;var cellMaxLength=d[0].length;var addr=copyh+minh-rowMaxLength;var addc=copyc+minc-cellMaxLength;if(addr>0||addc>0){expandRowsAndColumns(d,addr,addc);}var borderInfoCompute=getBorderInfoCompute(ctx,copySheetId);var c_dataVerification=lodash_default().cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx,copySheetId)].dataVerification)||{};var dataVerification=lodash_default().cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)].dataVerification)||{};if(((_ctx$luckysheet_selec5=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec5===void 0?void 0:_ctx$luckysheet_selec5.length)===1&&((_ctx$luckysheet_copy_=ctx.luckysheet_copy_save)===null||_ctx$luckysheet_copy_===void 0?void 0:_ctx$luckysheet_copy_.copyRange.length)===1){var _ctx$luckysheet_copy_2;lodash_default().forEach((_ctx$luckysheet_copy_2=ctx.luckysheet_copy_save)===null||_ctx$luckysheet_copy_2===void 0?void 0:_ctx$luckysheet_copy_2.copyRange,function(range){for(var r=0;r<=range.row[1]-range.row[0];r+=1){for(var c=0;c<=range.column[1]-range.column[0];c+=1){var _ctx$luckysheet_copy_3,_ctx$luckysheetfile$i;var index=getSheetIndex(ctx,(_ctx$luckysheet_copy_3=ctx.luckysheet_copy_save)===null||_ctx$luckysheet_copy_3===void 0?void 0:_ctx$luckysheet_copy_3.dataSheetId);if(((_ctx$luckysheetfile$i=ctx.luckysheetfile[index].data[r+range.row[0]][c+range.column[0]])===null||_ctx$luckysheetfile$i===void 0?void 0:_ctx$luckysheetfile$i.hl)&&ctx.luckysheetfile[index].hyperlink["".concat(r,"_").concat(c)]){var _ctx$luckysheet_copy_4;setCellHyperlink(ctx,(_ctx$luckysheet_copy_4=ctx.luckysheet_copy_save)===null||_ctx$luckysheet_copy_4===void 0?void 0:_ctx$luckysheet_copy_4.dataSheetId,r+ctx.luckysheet_select_save[0].row[0],c+ctx.luckysheet_select_save[0].column[0],ctx.luckysheetfile[index].hyperlink["".concat(r,"_").concat(c)]);}}}});}if(ctx.currentSheetId===copySheetId){for(var i=c_r1;i<=c_r2;i+=1){for(var j=c_c1;j<=c_c2;j+=1){var _ctx$luckysheetfile$g;var cell=d[i][j];if(cell&&lodash_default().isPlainObject(cell)&&"mc"in cell){var _cell$mc;if(((_cell$mc=cell.mc)===null||_cell$mc===void 0?void 0:_cell$mc.rs)!=null){delete cfg.merge["".concat(cell.mc.r,"_").concat(cell.mc.c)];}delete cell.mc;}d[i][j]=null;delete dataVerification["".concat(i,"_").concat(j)];(_ctx$luckysheetfile$g=ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)].hyperlink)===null||_ctx$luckysheetfile$g===void 0?true:delete _ctx$luckysheetfile$g["".concat(i,"_").concat(j)];}}if(cfg.borderInfo&&cfg.borderInfo.length>0){var source_borderInfo=[];for(var _i=0;_i<cfg.borderInfo.length;_i+=1){var bd_rangeType=cfg.borderInfo[_i].rangeType;if(bd_rangeType==="range"){var bd_range=cfg.borderInfo[_i].range;var bd_emptyRange=[];for(var _j=0;_j<bd_range.length;_j+=1){bd_emptyRange=bd_emptyRange.concat(CFSplitRange(bd_range[_j],{row:[c_r1,c_r2],column:[c_c1,c_c2]},{row:[minh,maxh],column:[minc,maxc]},"restPart"));}cfg.borderInfo[_i].range=bd_emptyRange;source_borderInfo.push(cfg.borderInfo[_i]);}else if(bd_rangeType==="cell"){var bd_r=cfg.borderInfo[_i].value.row_index;var bd_c=cfg.borderInfo[_i].value.col_index;if(!(bd_r>=c_r1&&bd_r<=c_r2&&bd_c>=c_c1&&bd_c<=c_c2)){source_borderInfo.push(cfg.borderInfo[_i]);}}}cfg.borderInfo=source_borderInfo;}}var offsetMC={};for(var h=minh;h<=maxh;h+=1){var x=d[h];for(var c=minc;c<=maxc;c+=1){var _x$c3,_x$c5;if(borderInfoCompute["".concat(c_r1+h-minh,"_").concat(c_c1+c-minc)]&&!borderInfoCompute["".concat(c_r1+h-minh,"_").concat(c_c1+c-minc)].s){var bd_obj={rangeType:"cell",value:{row_index:h,col_index:c,l:borderInfoCompute["".concat(c_r1+h-minh,"_").concat(c_c1+c-minc)].l,r:borderInfoCompute["".concat(c_r1+h-minh,"_").concat(c_c1+c-minc)].r,t:borderInfoCompute["".concat(c_r1+h-minh,"_").concat(c_c1+c-minc)].t,b:borderInfoCompute["".concat(c_r1+h-minh,"_").concat(c_c1+c-minc)].b}};if(cfg.borderInfo==null){cfg.borderInfo=[];}cfg.borderInfo.push(bd_obj);}else if(borderInfoCompute["".concat(h,"_").concat(c)]){var _bd_obj={rangeType:"cell",value:{row_index:h,col_index:c,l:null,r:null,t:null,b:null}};if(cfg.borderInfo==null){cfg.borderInfo=[];}cfg.borderInfo.push(_bd_obj);}else if(borderInfoCompute["".concat(c_r1+h-minh,"_").concat(c_c1+c-minc)]){var _bd_obj2={rangeType:"range",borderType:"border-slash",color:borderInfoCompute["".concat(c_r1+h-minh,"_").concat(c_c1+c-minc)].s.color,style:borderInfoCompute["".concat(c_r1+h-minh,"_").concat(c_c1+c-minc)].s.style,range:normalizeSelection(ctx,[{row:[h,h],column:[c,c]}])};if(cfg.borderInfo==null){cfg.borderInfo=[];}cfg.borderInfo.push(_bd_obj2);}if(c_dataVerification["".concat(c_r1+h-minh,"_").concat(c_c1+c-minc)]){dataVerification["".concat(h,"_").concat(c)]=c_dataVerification["".concat(c_r1+h-minh,"_").concat(c_c1+c-minc)];}if((_x$c3=x[c])===null||_x$c3===void 0?void 0:_x$c3.mc){var _x$c4,_x$c4$mc;if(((_x$c4=x[c])===null||_x$c4===void 0?void 0:(_x$c4$mc=_x$c4.mc)===null||_x$c4$mc===void 0?void 0:_x$c4$mc.rs)!=null){delete cfg.merge["".concat(x[c].mc.r,"_").concat(x[c].mc.c)];}delete x[c].mc;}var value=null;if(copyData[h-minh]!=null&&copyData[h-minh][c-minc]!=null){value=copyData[h-minh][c-minc];}x[c]=lodash_default().cloneDeep(value);if(value!=null&&copyHasMC&&((_x$c5=x[c])===null||_x$c5===void 0?void 0:_x$c5.mc)){if(x[c].mc.rs!=null){x[c].mc.r=h;x[c].mc.c=c;cfg.merge["".concat(x[c].mc.r,"_").concat(x[c].mc.c)]=x[c].mc;offsetMC["".concat(value.mc.r,"_").concat(value.mc.c)]=[x[c].mc.r,x[c].mc.c];}else{x[c]={mc:{r:offsetMC["".concat(value.mc.r,"_").concat(value.mc.c)][0],c:offsetMC["".concat(value.mc.r,"_").concat(value.mc.c)][1]}};}}}d[h]=x;}last.row=[minh,maxh];last.column=[minc,maxc];var source;var target;if(ctx.currentSheetId!==copySheetId){var sourceData=lodash_default().cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx,copySheetId)].data);var sourceConfig=lodash_default().cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx,copySheetId)].config);var sourceCurData=lodash_default().cloneDeep(sourceData);var sourceCurConfig=lodash_default().cloneDeep(sourceConfig)||{};if(sourceCurConfig.merge==null){sourceCurConfig.merge={};}for(var source_r=c_r1;source_r<=c_r2;source_r+=1){for(var source_c=c_c1;source_c<=c_c2;source_c+=1){var _cell=sourceCurData[source_r][source_c];if(_cell===null||_cell===void 0?void 0:_cell.mc){if("rs"in _cell.mc){delete sourceCurConfig.merge["".concat(_cell.mc.r,"_").concat(_cell.mc.c)];}delete _cell.mc;}sourceCurData[source_r][source_c]=null;}}if(sourceCurConfig.borderInfo&&sourceCurConfig.borderInfo.length>0){var _source_borderInfo=[];for(var _i2=0;_i2<sourceCurConfig.borderInfo.length;_i2+=1){var _bd_rangeType=sourceCurConfig.borderInfo[_i2].rangeType;if(_bd_rangeType==="range"){var _bd_range=sourceCurConfig.borderInfo[_i2].range;var _bd_emptyRange=[];for(var _j2=0;_j2<_bd_range.length;_j2+=1){_bd_emptyRange=_bd_emptyRange.concat(CFSplitRange(_bd_range[_j2],{row:[c_r1,c_r2],column:[c_c1,c_c2]},{row:[minh,maxh],column:[minc,maxc]},"restPart"));}sourceCurConfig.borderInfo[_i2].range=_bd_emptyRange;_source_borderInfo.push(sourceCurConfig.borderInfo[_i2]);}else if(_bd_rangeType==="cell"){var _bd_r=sourceCurConfig.borderInfo[_i2].value.row_index;var _bd_c=sourceCurConfig.borderInfo[_i2].value.col_index;if(!(_bd_r>=c_r1&&_bd_r<=c_r2&&_bd_c>=c_c1&&_bd_c<=c_c2)){_source_borderInfo.push(sourceCurConfig.borderInfo[_i2]);}}}sourceCurConfig.borderInfo=_source_borderInfo;}var source_cdformat=lodash_default().cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx,copySheetId)].luckysheet_conditionformat_save);var source_curCdformat=lodash_default().cloneDeep(source_cdformat);var ruleArr=[];if(source_curCdformat!=null&&source_curCdformat.length>0){for(var _i3=0;_i3<source_curCdformat.length;_i3+=1){var source_curCdformat_cellrange=source_curCdformat[_i3].cellrange;var emptyRange=[];var emptyRange2=[];for(var _j3=0;_j3<source_curCdformat_cellrange.length;_j3+=1){var range=CFSplitRange(source_curCdformat_cellrange[_j3],{row:[c_r1,c_r2],column:[c_c1,c_c2]},{row:[minh,maxh],column:[minc,maxc]},"restPart");emptyRange=emptyRange.concat(range);var range2=CFSplitRange(source_curCdformat_cellrange[_j3],{row:[c_r1,c_r2],column:[c_c1,c_c2]},{row:[minh,maxh],column:[minc,maxc]},"operatePart");if(range2.length>0){emptyRange2=emptyRange2.concat(range2);}}source_curCdformat[_i3].cellrange=emptyRange;if(emptyRange2.length>0){var _source_curCdformat$_;var ruleObj=(_source_curCdformat$_=source_curCdformat[_i3])!==null&&_source_curCdformat$_!==void 0?_source_curCdformat$_:{};ruleObj.cellrange=emptyRange2;ruleArr.push(ruleObj);}}}var target_cdformat=lodash_default().cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)].luckysheet_conditionformat_save);var target_curCdformat=lodash_default().cloneDeep(target_cdformat);if(ruleArr.length>0){var _target_curCdformat;target_curCdformat=(_target_curCdformat=target_curCdformat)===null||_target_curCdformat===void 0?void 0:_target_curCdformat.concat(ruleArr);}for(var _i4=c_r1;_i4<=c_r2;_i4+=1){for(var _j4=c_c1;_j4<=c_c2;_j4+=1){delete c_dataVerification["".concat(_i4,"_").concat(_j4)];}}source={sheetId:copySheetId,data:sourceData,curData:sourceCurData,config:sourceConfig,curConfig:sourceCurConfig,cdformat:source_cdformat,curCdformat:source_curCdformat,dataVerification:lodash_default().cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx,copySheetId)].dataVerification),curDataVerification:c_dataVerification,range:{row:[c_r1,c_r2],column:[c_c1,c_c2]}};target={sheetId:ctx.currentSheetId,data:getFlowdata(ctx),curData:d,config:lodash_default().cloneDeep(ctx.config),curConfig:cfg,cdformat:target_cdformat,curCdformat:target_curCdformat,dataVerification:lodash_default().cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)].dataVerification),curDataVerification:dataVerification,range:{row:[minh,maxh],column:[minc,maxc]}};}else{var cdformat=lodash_default().cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)].luckysheet_conditionformat_save);var curCdformat=lodash_default().cloneDeep(cdformat);if(curCdformat!=null&&curCdformat.length>0){for(var _i5=0;_i5<curCdformat.length;_i5+=1){var cellrange=curCdformat[_i5].cellrange;var _emptyRange=[];for(var _j5=0;_j5<cellrange.length;_j5+=1){var _range=CFSplitRange(cellrange[_j5],{row:[c_r1,c_r2],column:[c_c1,c_c2]},{row:[minh,maxh],column:[minc,maxc]},"allPart");_emptyRange=_emptyRange.concat(_range);}curCdformat[_i5].cellrange=_emptyRange;}}source={sheetId:ctx.currentSheetId,data:getFlowdata(ctx),curData:d,config:lodash_default().cloneDeep(ctx.config),curConfig:cfg,cdformat:cdformat,curCdformat:curCdformat,dataVerification:lodash_default().cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)].dataVerification),curDataVerification:dataVerification,range:{row:[c_r1,c_r2],column:[c_c1,c_c2]}};target={sheetId:ctx.currentSheetId,data:getFlowdata(ctx),curData:d,config:lodash_default().cloneDeep(ctx.config),curConfig:cfg,cdformat:cdformat,curCdformat:curCdformat,dataVerification:lodash_default().cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)].dataVerification),curDataVerification:dataVerification,range:{row:[minh,maxh],column:[minc,maxc]}};}if(addr>0||addc>0){postPasteCut(ctx,source,target,true);}else{postPasteCut(ctx,source,target,copyRowlChange);}}function pasteHandlerOfCopyPaste(ctx,copyRange){var _ctx$luckysheet_selec6,_file$config,_file$config2,_ctx$luckysheet_selec7,_ctx$luckysheet_copy_5;var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;if(!copyRange)return;var cfg=ctx.config;if(lodash_default().isNil(cfg.merge)){cfg.merge={};}var copyHasMC=copyRange.HasMC;var copyRowlChange=copyRange.RowlChange;var copySheetIndex=copyRange.dataSheetId;var c_r1=copyRange.copyRange[0].row[0];var c_r2=copyRange.copyRange[0].row[1];var c_c1=copyRange.copyRange[0].column[0];var c_c2=copyRange.copyRange[0].column[1];var arr=[];var isSameRow=false;var _loop=function _loop(i){var arrData=getdatabyselection(ctx,{row:copyRange.copyRange[i].row,column:copyRange.copyRange[i].column},copySheetIndex);if(copyRange.copyRange.length>1){if(c_r1===copyRange.copyRange[1].row[0]&&c_r2===copyRange.copyRange[1].row[1]){arrData=arrData[0].map(function(col,a){return arrData.map(function(row){return row[a];});});arr=arr.concat(arrData);isSameRow=true;}else if(c_c1===copyRange.copyRange[1].column[0]&&c_c2===copyRange.copyRange[1].column[1]){arr=arr.concat(arrData);}}else{arr=arrData;}};for(var i=0;i<copyRange.copyRange.length;i+=1){_loop(i);}if(isSameRow){arr=arr[0].map(function(col,b){return arr.map(function(row){return row[b];});});}var copyData=lodash_default().cloneDeep(arr);if(copyRange.copyRange.length>1){for(var _i6=0;_i6<copyData.length;_i6+=1){for(var j=0;j<copyData[_i6].length;j+=1){if(copyData[_i6][j]!=null&&copyData[_i6][j].f!=null){delete copyData[_i6][j].f;delete copyData[_i6][j].spl;}}}}var copyh=copyData.length;var copyc=copyData[0].length;var last=(_ctx$luckysheet_selec6=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec6===void 0?void 0:_ctx$luckysheet_selec6[ctx.luckysheet_select_save.length-1];if(!last)return;var minh=last.row[0];var maxh=last.row[1];var minc=last.column[0];var maxc=last.column[1];var mh=(maxh-minh+1)%copyh;var mc=(maxc-minc+1)%copyc;if(mh!==0||mc!==0){maxh=minh+copyh-1;maxc=minc+copyc-1;}var has_PartMC=false;if(!lodash_default().isNil(cfg.merge)){has_PartMC=hasPartMC(ctx,cfg,minh,maxh,minc,maxc);}if(has_PartMC){return;}var timesH=(maxh-minh+1)/copyh;var timesC=(maxc-minc+1)/copyc;var d=getFlowdata(ctx);if(!d)return;var rowMaxLength=d.length;var cellMaxLength=d[0].length;var addr=copyh+minh-rowMaxLength;var addc=copyc+minc-cellMaxLength;if(addr>0||addc>0){expandRowsAndColumns(d,addr,addc);}var borderInfoCompute=getBorderInfoCompute(ctx,copySheetIndex);var c_dataVerification=lodash_default().cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx,copySheetIndex)].dataVerification)||{};var dataVerification=null;var mth=0;var mtc=0;var maxcellCahe=0;var maxrowCache=0;var file=ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)];var hiddenRows=new Set(Object.keys(((_file$config=file.config)===null||_file$config===void 0?void 0:_file$config.rowhidden)||{}));var hiddenCols=new Set(Object.keys(((_file$config2=file.config)===null||_file$config2===void 0?void 0:_file$config2.colhidden)||{}));for(var th=1;th<=timesH;th+=1){for(var tc=1;tc<=timesC;tc+=1){mth=minh+(th-1)*copyh;mtc=minc+(tc-1)*copyc;maxrowCache=minh+th*copyh;maxcellCahe=minc+tc*copyc;var offsetRow=mth-c_r1;var offsetCol=mtc-c_c1;var offsetMC={};for(var h=mth;h<maxrowCache;h+=1){if(hiddenRows===null||hiddenRows===void 0?void 0:hiddenRows.has(h.toString()))continue;var x=d[h];for(var c=mtc;c<maxcellCahe;c+=1){var _x$c6,_copyData,_x$c7;if(hiddenCols===null||hiddenCols===void 0?void 0:hiddenCols.has(c.toString()))continue;if(borderInfoCompute["".concat(c_r1+h-mth,"_").concat(c_c1+c-mtc)]&&!borderInfoCompute["".concat(c_r1+h-mth,"_").concat(c_c1+c-mtc)].s){var bd_obj={rangeType:"cell",value:{row_index:h,col_index:c,l:borderInfoCompute["".concat(c_r1+h-mth,"_").concat(c_c1+c-mtc)].l,r:borderInfoCompute["".concat(c_r1+h-mth,"_").concat(c_c1+c-mtc)].r,t:borderInfoCompute["".concat(c_r1+h-mth,"_").concat(c_c1+c-mtc)].t,b:borderInfoCompute["".concat(c_r1+h-mth,"_").concat(c_c1+c-mtc)].b}};if(lodash_default().isNil(cfg.borderInfo)){cfg.borderInfo=[];}cfg.borderInfo.push(bd_obj);}else if(borderInfoCompute["".concat(h,"_").concat(c)]){var _bd_obj3={rangeType:"cell",value:{row_index:h,col_index:c,l:null,r:null,t:null,b:null}};if(lodash_default().isNil(cfg.borderInfo)){cfg.borderInfo=[];}cfg.borderInfo.push(_bd_obj3);}else if(borderInfoCompute["".concat(c_r1+h-mth,"_").concat(c_c1+c-mtc)]){var _bd_obj4={rangeType:"range",borderType:"border-slash",color:borderInfoCompute["".concat(c_r1+h-minh,"_").concat(c_c1+c-minc)].s.color,style:borderInfoCompute["".concat(c_r1+h-minh,"_").concat(c_c1+c-minc)].s.style,range:normalizeSelection(ctx,[{row:[h,h],column:[c,c]}])};if(cfg.borderInfo==null){cfg.borderInfo=[];}cfg.borderInfo.push(_bd_obj4);}if(c_dataVerification["".concat(c_r1+h-mth,"_").concat(c_c1+c-mtc)]){if(lodash_default().isNil(dataVerification)){var _ctx$luckysheetfile$g2;dataVerification=lodash_default().cloneDeep(((_ctx$luckysheetfile$g2=ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)])===null||_ctx$luckysheetfile$g2===void 0?void 0:_ctx$luckysheetfile$g2.dataVerification)||{});}dataVerification["".concat(h,"_").concat(c)]=c_dataVerification["".concat(c_r1+h-mth,"_").concat(c_c1+c-mtc)];}if(((_x$c6=x[c])===null||_x$c6===void 0?void 0:_x$c6.mc)!=null){if("rs"in x[c].mc){delete cfg.merge["".concat(x[c].mc.r,"_").concat(x[c].mc.c)];}delete x[c].mc;}var value=null;if((_copyData=copyData[h-mth])===null||_copyData===void 0?void 0:_copyData[c-mtc]){value=lodash_default().cloneDeep(copyData[h-mth][c-mtc]);}if(!lodash_default().isNil(value)&&!lodash_default().isNil(value.f)){var func=value.f;if(offsetRow>0){func="=".concat(functionCopy(ctx,func,"down",offsetRow));}if(offsetRow<0){func="=".concat(functionCopy(ctx,func,"up",Math.abs(offsetRow)));}if(offsetCol>0){func="=".concat(functionCopy(ctx,func,"right",offsetCol));}if(offsetCol<0){func="=".concat(functionCopy(ctx,func,"left",Math.abs(offsetCol)));}var funcV=execfunction(ctx,func,h,c,undefined,undefined,true);if(!lodash_default().isNil(value.spl));else{var _funcV=index_esm_slicedToArray(funcV,3);value.v=_funcV[1];value.f=_funcV[2];if(!lodash_default().isNil(value.ct)&&!lodash_default().isNil(value.ct.fa)){value.m=update(value.ct.fa,funcV[1]);}else{value.m=update("General",funcV[1]);}}}x[c]=lodash_default().cloneDeep(value);if(value!=null&&copyHasMC&&(x===null||x===void 0?void 0:(_x$c7=x[c])===null||_x$c7===void 0?void 0:_x$c7.mc)){var _x$c8,_x$c8$mc;if((x===null||x===void 0?void 0:(_x$c8=x[c])===null||_x$c8===void 0?void 0:(_x$c8$mc=_x$c8.mc)===null||_x$c8$mc===void 0?void 0:_x$c8$mc.rs)!=null){x[c].mc.r=h;x[c].mc.c=c;cfg.merge["".concat(h,"_").concat(c)]=x[c].mc;offsetMC["".concat(value.mc.r,"_").concat(value.mc.c)]=[x[c].mc.r,x[c].mc.c];}else{x[c]={mc:{r:offsetMC["".concat(value.mc.r,"_").concat(value.mc.c)][0],c:offsetMC["".concat(value.mc.r,"_").concat(value.mc.c)][1]}};}}}d[h]=x;}}}var cdformat=null;if(copyRange.copyRange.length===1){var c_file=ctx.luckysheetfile[getSheetIndex(ctx,copySheetIndex)];var a_file=ctx.luckysheetfile[getSheetIndex(ctx,ctx.currentSheetId)];var ruleArr_cf=lodash_default().cloneDeep(c_file.luckysheet_conditionformat_save);if(!lodash_default().isNil(ruleArr_cf)&&ruleArr_cf.length>0){var _$cloneDeep;cdformat=(_$cloneDeep=lodash_default().cloneDeep(a_file.luckysheet_conditionformat_save))!==null&&_$cloneDeep!==void 0?_$cloneDeep:[];for(var _i7=0;_i7<ruleArr_cf.length;_i7+=1){var cf_range=ruleArr_cf[_i7].cellrange;var emptyRange=[];for(var _th=1;_th<=timesH;_th+=1){for(var _tc=1;_tc<=timesC;_tc+=1){mth=minh+(_th-1)*copyh;mtc=minc+(_tc-1)*copyc;maxrowCache=minh+_th*copyh;maxcellCahe=minc+_tc*copyc;for(var _j6=0;_j6<cf_range.length;_j6+=1){var range=CFSplitRange(cf_range[_j6],{row:[c_r1,c_r2],column:[c_c1,c_c2]},{row:[mth,maxrowCache-1],column:[mtc,maxcellCahe-1]},"operatePart");if(range.length>0){emptyRange=emptyRange.concat(range);}}}}if(emptyRange.length>0){ruleArr_cf[_i7].cellrange=emptyRange;cdformat.push(ruleArr_cf[_i7]);}}}}last.row=[minh,maxh];last.column=[minc,maxc];file.config=cfg;file.luckysheet_conditionformat_save=cdformat;file.dataVerification=_objectSpread2(_objectSpread2({},file.dataVerification),dataVerification);if(((_ctx$luckysheet_selec7=ctx.luckysheet_select_save)===null||_ctx$luckysheet_selec7===void 0?void 0:_ctx$luckysheet_selec7.length)===1&&((_ctx$luckysheet_copy_5=ctx.luckysheet_copy_save)===null||_ctx$luckysheet_copy_5===void 0?void 0:_ctx$luckysheet_copy_5.copyRange.length)===1){var _ctx$luckysheet_copy_6;lodash_default().forEach((_ctx$luckysheet_copy_6=ctx.luckysheet_copy_save)===null||_ctx$luckysheet_copy_6===void 0?void 0:_ctx$luckysheet_copy_6.copyRange,function(range){for(var r=0;r<=range.row[1]-range.row[0];r+=1){for(var _c3=0;_c3<=range.column[1]-range.column[0];_c3+=1){var _ctx$luckysheet_copy_7,_ctx$luckysheetfile$i2;var index=getSheetIndex(ctx,(_ctx$luckysheet_copy_7=ctx.luckysheet_copy_save)===null||_ctx$luckysheet_copy_7===void 0?void 0:_ctx$luckysheet_copy_7.dataSheetId);if(((_ctx$luckysheetfile$i2=ctx.luckysheetfile[index].data[r+range.row[0]][_c3+range.column[0]])===null||_ctx$luckysheetfile$i2===void 0?void 0:_ctx$luckysheetfile$i2.hl)&&ctx.luckysheetfile[index].hyperlink["".concat(r,"_").concat(_c3)]){var _ctx$luckysheet_copy_8;setCellHyperlink(ctx,(_ctx$luckysheet_copy_8=ctx.luckysheet_copy_save)===null||_ctx$luckysheet_copy_8===void 0?void 0:_ctx$luckysheet_copy_8.dataSheetId,r+ctx.luckysheet_select_save[0].row[0],_c3+ctx.luckysheet_select_save[0].column[0],ctx.luckysheetfile[index].hyperlink["".concat(r,"_").concat(_c3)]);}}}});}if(copyRowlChange||addr>0||addc>0){jfrefreshgrid(ctx,d,ctx.luckysheet_select_save);}else{jfrefreshgrid(ctx,d,ctx.luckysheet_select_save);}}function handleFormulaStringPaste(ctx,formulaStr){var r=ctx.luckysheet_select_save[0].row[0];var c=ctx.luckysheet_select_save[0].column[0];var funcV=execfunction(ctx,formulaStr,r,c,undefined,undefined,true);var val=funcV[1];var d=getFlowdata(ctx);if(!d)return;if(!d[r][c])d[r][c]={};d[r][c].m=val.toString();d[r][c].v=val;d[r][c].f=formulaStr;}function handlePaste(ctx,e){var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;if(selectionCache.isPasteAction){var _ctx$luckysheet_copy_9,_ctx$hooks$beforePast,_ctx$hooks,_ctx$luckysheet_copy_10;ctx.luckysheetCellUpdate=[];selectionCache.isPasteAction=false;var clipboardData=e.clipboardData;if(!clipboardData){clipboardData=window.clipboardData;}if(!clipboardData)return;var txtdata=clipboardData.getData("text/html")||clipboardData.getData("text/plain");var isEqual=true;if(txtdata.indexOf("fortune-copy-action-table")>-1&&((_ctx$luckysheet_copy_9=ctx.luckysheet_copy_save)===null||_ctx$luckysheet_copy_9===void 0?void 0:_ctx$luckysheet_copy_9.copyRange)!=null&&ctx.luckysheet_copy_save.copyRange.length>0){var cpDataArr=[];var reg=/<tr.*?>(.*?)<\/tr>/g;var reg2=/<td.*?>(.*?)<\/td>/g;var regArr=txtdata.match(reg)||[];for(var i=0;i<regArr.length;i+=1){var cpRowArr=[];var reg2Arr=regArr[i].match(reg2);if(!lodash_default().isNil(reg2Arr)){for(var j=0;j<reg2Arr.length;j+=1){var cpValue=reg2Arr[j].replace(/<td.*?>/g,"").replace(/<\/td>/g,"");cpRowArr.push(cpValue);}}cpDataArr.push(cpRowArr);}var copy_r1=ctx.luckysheet_copy_save.copyRange[0].row[0];var copy_r2=ctx.luckysheet_copy_save.copyRange[0].row[1];var copy_c1=ctx.luckysheet_copy_save.copyRange[0].column[0];var copy_c2=ctx.luckysheet_copy_save.copyRange[0].column[1];var copy_index=ctx.luckysheet_copy_save.dataSheetId;var d;if(copy_index===ctx.currentSheetId){d=getFlowdata(ctx);}else{var index=getSheetIndex(ctx,copy_index);if(lodash_default().isNil(index))return;d=ctx.luckysheetfile[index].data;}if(!d)return;for(var r=copy_r1;r<=copy_r2;r+=1){if(r-copy_r1>cpDataArr.length-1){break;}for(var c=copy_c1;c<=copy_c2;c+=1){var _d$r3,_d$r3$c,_d$r3$c$ct;var cell=d[r][c];var isInlineStr=false;if(!lodash_default().isNil(cell)&&!lodash_default().isNil(cell.mc)&&lodash_default().isNil(cell.mc.rs)){continue;}var v=void 0;if(!lodash_default().isNil(cell)){var _cell$ct$fa$indexOf,_cell$ct,_cell$ct$fa;if(((_cell$ct$fa$indexOf=(_cell$ct=cell.ct)===null||_cell$ct===void 0?void 0:(_cell$ct$fa=_cell$ct.fa)===null||_cell$ct$fa===void 0?void 0:_cell$ct$fa.indexOf("w"))!==null&&_cell$ct$fa$indexOf!==void 0?_cell$ct$fa$indexOf:-1)>-1){var _d$r,_d$r$c;v=(_d$r=d[r])===null||_d$r===void 0?void 0:(_d$r$c=_d$r[c])===null||_d$r$c===void 0?void 0:_d$r$c.v;}else{var _d$r2,_d$r2$c;v=(_d$r2=d[r])===null||_d$r2===void 0?void 0:(_d$r2$c=_d$r2[c])===null||_d$r2$c===void 0?void 0:_d$r2$c.m;}}else{v="";}if(lodash_default().isNil(v)&&((_d$r3=d[r])===null||_d$r3===void 0?void 0:(_d$r3$c=_d$r3[c])===null||_d$r3$c===void 0?void 0:(_d$r3$c$ct=_d$r3$c.ct)===null||_d$r3$c$ct===void 0?void 0:_d$r3$c$ct.t)==="inlineStr"){v=d[r][c].ct.s.map(function(val){return val.v;}).join("");isInlineStr=true;}if(lodash_default().isNil(v)){v="";}if(isInlineStr);else{if(lodash_default().trim(cpDataArr[r-copy_r1][c-copy_c1])!==lodash_default().trim(v)){isEqual=false;break;}}}}}var locale_fontjson=locale(ctx).fontjson;if(((_ctx$hooks$beforePast=(_ctx$hooks=ctx.hooks).beforePaste)===null||_ctx$hooks$beforePast===void 0?void 0:_ctx$hooks$beforePast.call(_ctx$hooks,ctx.luckysheet_select_save,txtdata))===false){return;}if(txtdata.indexOf("fortune-copy-action-table")>-1&&((_ctx$luckysheet_copy_10=ctx.luckysheet_copy_save)===null||_ctx$luckysheet_copy_10===void 0?void 0:_ctx$luckysheet_copy_10.copyRange)!=null&&ctx.luckysheet_copy_save.copyRange.length>0&&isEqual){if(ctx.luckysheet_paste_iscut){ctx.luckysheet_paste_iscut=false;pasteHandlerOfCutPaste(ctx,ctx.luckysheet_copy_save);ctx.luckysheet_selection_range=[];}else{pasteHandlerOfCopyPaste(ctx,ctx.luckysheet_copy_save);}}else if(txtdata.indexOf("fortune-copy-action-image")>-1);else{if(txtdata.indexOf("table")>-1){var _ele$querySelectorAll;var ele=document.createElement("div");ele.innerHTML=txtdata;var trList=ele.querySelectorAll("table tr");if(trList.length===0){ele.remove();return;}var data=new Array(trList.length);var colLen=0;lodash_default().forEach(trList[0].querySelectorAll("td"),function(td){var colspan=td.colSpan;if(Number.isNaN(colspan)){colspan=1;}colLen+=colspan;});for(var _i8=0;_i8<data.length;_i8+=1){data[_i8]=new Array(colLen);}var _r2=0;var borderInfo={};var styleInner=((_ele$querySelectorAll=ele.querySelectorAll("style")[0])===null||_ele$querySelectorAll===void 0?void 0:_ele$querySelectorAll.innerHTML)||"";var patternReg=/{([^}]*)}/g;var patternStyle=styleInner.match(patternReg);var nameReg=/^[^\t].*/gm;var patternName=lodash_default().initial(styleInner.match(nameReg));var allStyleList=patternName.length===(patternStyle===null||patternStyle===void 0?void 0:patternStyle.length)&&index_esm_typeof(patternName)===index_esm_typeof(patternStyle)?lodash_default().fromPairs(lodash_default().zip(patternName,patternStyle)):{};var _index=getSheetIndex(ctx,ctx.currentSheetId);if(!lodash_default().isNil(_index)){if(lodash_default().isNil(ctx.luckysheetfile[_index].config)){ctx.luckysheetfile[_index].config={};}if(lodash_default().isNil(ctx.luckysheetfile[_index].config.rowlen)){ctx.luckysheetfile[_index].config.rowlen={};}var rowHeightList=ctx.luckysheetfile[_index].config.rowlen;lodash_default().forEach(trList,function(tr){var c=0;var targetR=ctx.luckysheet_select_save[0].row[0]+_r2;var targetRowHeight=!lodash_default().isNil(tr.getAttribute("height"))?parseInt(tr.getAttribute("height"),10):null;if(lodash_default().has(ctx.luckysheetfile[_index].config.rowlen,targetR)&&ctx.luckysheetfile[_index].config.rowlen[targetR]!==targetRowHeight||!lodash_default().has(ctx.luckysheetfile[_index].config.rowlen,targetR)&&ctx.luckysheetfile[_index].defaultRowHeight!==targetRowHeight){rowHeightList[targetR]=targetRowHeight;}lodash_default().forEach(tr.querySelectorAll("td"),function(td){var className=td.className;var cell={};var txt=td.innerText||td.innerHTML;if(lodash_default().trim(txt).length===0){cell.v=undefined;cell.m="";}else{var mask=genarate(txt);var _mask2=index_esm_slicedToArray(mask,3);cell.m=_mask2[0];cell.ct=_mask2[1];cell.v=_mask2[2];}var styleString=typeof allStyleList[".".concat(className)]==="string"?allStyleList[".".concat(className)].substring(1,allStyleList[".".concat(className)].length-1).split("\n\t"):[];var styles={};lodash_default().forEach(styleString,function(s){var styleList=s.split(":");styles[styleList[0]]=styleList===null||styleList===void 0?void 0:styleList[1].replace(";","");});if(!lodash_default().isNil(styles.border))td.style.border=styles.border;var bg=td.style.backgroundColor||styles.background;if(bg==="rgba(0, 0, 0, 0)"||lodash_default().isEmpty(bg)){bg=undefined;}cell.bg=bg;var fontWight=td.style.fontWeight;cell.bl=(fontWight.toString()==="400"||fontWight==="normal"||lodash_default().isEmpty(fontWight))&&!lodash_default().includes(styles["font-style"],"bold")&&(!styles["font-weight"]||styles["font-weight"]==="400")?0:1;cell.it=(td.style.fontStyle==="normal"||lodash_default().isEmpty(td.style.fontStyle))&&!lodash_default().includes(styles["font-style"],"italic")?0:1;cell.un=!lodash_default().includes(styles["text-decoration"],"underline")?undefined:1;cell.cl=!lodash_default().includes(td.innerHTML,"<s>")?undefined:1;var ff=td.style.fontFamily||styles["font-family"]||"";var ffs=ff.split(",");for(var _i9=0;_i9<ffs.length;_i9+=1){var fa=lodash_default().trim(ffs[_i9].toLowerCase());fa=locale_fontjson[fa];if(lodash_default().isNil(fa)){cell.ff=0;}else{cell.ff=fa;break;}}var fs=Math.round(styles["font-size"]?parseInt(styles["font-size"].replace("pt",""),10):parseInt(td.style.fontSize||"13",10)*72/96);cell.fs=fs;cell.fc=td.style.color||styles.color;var ht=td.style.textAlign||styles["text-align"]||"left";if(ht==="center"){cell.ht=0;}else if(ht==="right"){cell.ht=2;}else{cell.ht=1;}var regex=/vertical-align:\s*(.*?);/;var vt=td.style.verticalAlign||styles["vertical-align"]||!lodash_default().isNil(allStyleList.td)&&allStyleList.td.match(regex).length>0&&allStyleList.td.match(regex)[1]||"top";if(vt==="middle"){cell.vt=0;}else if(vt==="top"||vt==="text-top"){cell.vt=1;}else{cell.vt=2;}if("mso-rotate"in styles){var rt=styles["mso-rotate"];cell.rt=parseFloat(rt);}while(c<colLen&&!lodash_default().isNil(data[_r2][c])){c+=1;}if(c===colLen){return true;}if(lodash_default().isNil(data[_r2][c])){data[_r2][c]=cell;var rowspan=parseInt(td.getAttribute("rowspan"),10);var colspan=parseInt(td.getAttribute("colspan"),10);if(Number.isNaN(rowspan)){rowspan=1;}if(Number.isNaN(colspan)){colspan=1;}var r_ab=ctx.luckysheet_select_save[0].row[0]+_r2;var c_ab=ctx.luckysheet_select_save[0].column[0]+c;for(var rp=0;rp<rowspan;rp+=1){for(var cp=0;cp<colspan;cp+=1){if(rp===0){var bt=td.style.borderTop;if(!lodash_default().isEmpty(bt)&&bt.substring(0,3).toLowerCase()!=="0px"){var width=td.style.borderTopWidth;var type=td.style.borderTopStyle;var color=td.style.borderTopColor;var borderconfig=getQKBorder(width,type,color);if(!borderInfo["".concat(_r2+rp,"_").concat(c+cp)]){borderInfo["".concat(_r2+rp,"_").concat(c+cp)]={};}borderInfo["".concat(_r2+rp,"_").concat(c+cp)].t={style:borderconfig[0],color:borderconfig[1]};}}if(rp===rowspan-1){var bb=td.style.borderBottom;if(!lodash_default().isEmpty(bb)&&bb.substring(0,3).toLowerCase()!=="0px"){var _width=td.style.borderBottomWidth;var _type=td.style.borderBottomStyle;var _color=td.style.borderBottomColor;var _borderconfig=getQKBorder(_width,_type,_color);if(!borderInfo["".concat(_r2+rp,"_").concat(c+cp)]){borderInfo["".concat(_r2+rp,"_").concat(c+cp)]={};}borderInfo["".concat(_r2+rp,"_").concat(c+cp)].b={style:_borderconfig[0],color:_borderconfig[1]};}}if(cp===0){var bl=td.style.borderLeft;if(!lodash_default().isEmpty(bl)&&bl.substring(0,3).toLowerCase()!=="0px"){var _width2=td.style.borderLeftWidth;var _type2=td.style.borderLeftStyle;var _color2=td.style.borderLeftColor;var _borderconfig2=getQKBorder(_width2,_type2,_color2);if(!borderInfo["".concat(_r2+rp,"_").concat(c+cp)]){borderInfo["".concat(_r2+rp,"_").concat(c+cp)]={};}borderInfo["".concat(_r2+rp,"_").concat(c+cp)].l={style:_borderconfig2[0],color:_borderconfig2[1]};}}if(cp===colspan-1){var br=td.style.borderLeft;if(!lodash_default().isEmpty(br)&&br.substring(0,3).toLowerCase()!=="0px"){var _width3=td.style.borderRightWidth;var _type3=td.style.borderRightStyle;var _color3=td.style.borderRightColor;var _borderconfig3=getQKBorder(_width3,_type3,_color3);if(!borderInfo["".concat(_r2+rp,"_").concat(c+cp)]){borderInfo["".concat(_r2+rp,"_").concat(c+cp)]={};}borderInfo["".concat(_r2+rp,"_").concat(c+cp)].r={style:_borderconfig3[0],color:_borderconfig3[1]};}}if(rp===0&&cp===0){continue;}data[_r2+rp][c+cp]={mc:{r:r_ab,c:c_ab}};}}if(rowspan>1||colspan>1){var first={rs:rowspan,cs:colspan,r:r_ab,c:c_ab};data[_r2][c].mc=first;}}c+=1;if(c===colLen){return true;}return true;});_r2+=1;});setRowHeight(ctx,rowHeightList);}ctx.luckysheet_selection_range=[];pasteHandler(ctx,data,borderInfo);ele.remove();}else if(clipboardData.files.length===1&&clipboardData.files[0].type.indexOf("image")>-1);else{txtdata=clipboardData.getData("text/plain");var isExcelFormula=txtdata.startsWith("=");if(isExcelFormula){handleFormulaStringPaste(ctx,txtdata);}else{pasteHandler(ctx,txtdata);}}}}else if(ctx.luckysheetCellUpdate.length>0){var _clipboardData2;e.preventDefault();var _clipboardData=e.clipboardData;if(!_clipboardData){_clipboardData=window.clipboardData;}var text=(_clipboardData2=_clipboardData)===null||_clipboardData2===void 0?void 0:_clipboardData2.getData("text/plain");if(text){document.execCommand("insertText",false,text);}}}function handlePasteByClick(ctx,clipboardData,triggerType){var _ctx$hooks$beforePast2,_ctx$hooks2,_ctx$luckysheet_copy_11;var allowEdit=isAllowEdit(ctx);if(!allowEdit)return;if(clipboardData)clipboard.writeHtml(clipboardData);var textarea=document.querySelector("#fortune-copy-content");var data=(textarea===null||textarea===void 0?void 0:textarea.innerHTML)||(textarea===null||textarea===void 0?void 0:textarea.textContent);if(!data)return;if(((_ctx$hooks$beforePast2=(_ctx$hooks2=ctx.hooks).beforePaste)===null||_ctx$hooks$beforePast2===void 0?void 0:_ctx$hooks$beforePast2.call(_ctx$hooks2,ctx.luckysheet_select_save,data))===false){return;}if(data.indexOf("fortune-copy-action-table")>-1&&((_ctx$luckysheet_copy_11=ctx.luckysheet_copy_save)===null||_ctx$luckysheet_copy_11===void 0?void 0:_ctx$luckysheet_copy_11.copyRange)!=null&&ctx.luckysheet_copy_save.copyRange.length>0){if(ctx.luckysheet_paste_iscut){ctx.luckysheet_paste_iscut=false;pasteHandlerOfCutPaste(ctx,ctx.luckysheet_copy_save);}else{pasteHandlerOfCopyPaste(ctx,ctx.luckysheet_copy_save);}}else if(data.indexOf("fortune-copy-action-image")>-1);else if(triggerType!=="btn"){var isExcelFormula=clipboardData.startsWith("=");if(isExcelFormula){handleFormulaStringPaste(ctx,clipboardData);}else{pasteHandler(ctx,clipboardData);}}else;}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(30606);
// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(42236);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./node_modules/@fortune-sheet/react/dist/index.esm.js





function index_esm_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function index_esm_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? index_esm_ownKeys(Object(source), !0).forEach(function (key) {
      dist_index_esm_defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : index_esm_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function dist_index_esm_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function dist_index_esm_slicedToArray(arr, i) {
  return dist_index_esm_arrayWithHoles(arr) || dist_index_esm_iterableToArrayLimit(arr, i) || dist_index_esm_unsupportedIterableToArray(arr, i) || dist_index_esm_nonIterableRest();
}
function dist_index_esm_toConsumableArray(arr) {
  return dist_index_esm_arrayWithoutHoles(arr) || dist_index_esm_iterableToArray(arr) || dist_index_esm_unsupportedIterableToArray(arr) || dist_index_esm_nonIterableSpread();
}
function dist_index_esm_arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return dist_index_esm_arrayLikeToArray(arr);
}
function dist_index_esm_arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function dist_index_esm_iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function dist_index_esm_iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function dist_index_esm_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return dist_index_esm_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return dist_index_esm_arrayLikeToArray(o, minLen);
}
function dist_index_esm_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function dist_index_esm_nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function dist_index_esm_nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var defaultRefs = {
  globalCache: {
    undoList: [],
    redoList: []
  },
  cellInput: /*#__PURE__*/react.createRef(),
  fxInput: /*#__PURE__*/react.createRef(),
  canvas: /*#__PURE__*/react.createRef(),
  cellArea: /*#__PURE__*/react.createRef(),
  workbookContainer: /*#__PURE__*/react.createRef()
};
var WorkbookContext = /*#__PURE__*/react.createContext({
  context: defaultContext(defaultRefs),
  setContext: function setContext() {},
  settings: defaultSettings,
  handleUndo: function handleUndo() {},
  handleRedo: function handleRedo() {},
  refs: {
    globalCache: {
      undoList: [],
      redoList: []
    },
    cellInput: /*#__PURE__*/react.createRef(),
    fxInput: /*#__PURE__*/react.createRef(),
    canvas: /*#__PURE__*/react.createRef(),
    scrollbarX: /*#__PURE__*/react.createRef(),
    scrollbarY: /*#__PURE__*/react.createRef(),
    cellArea: /*#__PURE__*/react.createRef(),
    workbookContainer: /*#__PURE__*/react.createRef()
  }
});
var SVGIcon = function SVGIcon(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 24 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 24 : _ref$height,
    name = _ref.name,
    style = _ref.style;
  return /*#__PURE__*/react.createElement("svg", {
    width: width,
    height: height,
    style: style,
    "aria-hidden": "true"
  }, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#".concat(name)
  }));
};
var ColumnHeader = function ColumnHeader() {
  var _refs$globalCache$fre2;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    settings = _useContext.settings,
    refs = _useContext.refs;
  var containerRef = (0,react.useRef)(null);
  var colChangeSizeRef = (0,react.useRef)(null);
  var _useState = (0,react.useState)({
      col: -1,
      col_pre: -1,
      col_index: -1
    }),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    hoverLocation = _useState2[0],
    setHoverLocation = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    hoverInFreeze = _useState4[0],
    setHoverInFreeze = _useState4[1];
  var _useState5 = (0,react.useState)([]),
    _useState6 = dist_index_esm_slicedToArray(_useState5, 2),
    selectedLocation = _useState6[0],
    setSelectedLocation = _useState6[1];
  var allowEditRef = (0,react.useRef)(true);
  var sheetIndex = getSheetIndex(context, context.currentSheetId);
  var sheet = sheetIndex == null ? null : context.luckysheetfile[sheetIndex];
  var freezeHandleLeft = (0,react.useMemo)(function () {
    var _sheet$frozen, _sheet$frozen2, _sheet$frozen3, _sheet$frozen4;
    if ((sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen = sheet.frozen) === null || _sheet$frozen === void 0 ? void 0 : _sheet$frozen.type) === "column" || (sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen2 = sheet.frozen) === null || _sheet$frozen2 === void 0 ? void 0 : _sheet$frozen2.type) === "rangeColumn" || (sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen3 = sheet.frozen) === null || _sheet$frozen3 === void 0 ? void 0 : _sheet$frozen3.type) === "rangeBoth" || (sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen4 = sheet.frozen) === null || _sheet$frozen4 === void 0 ? void 0 : _sheet$frozen4.type) === "both") {
      var _sheet$frozen5, _sheet$frozen5$range;
      return colLocationByIndex((sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen5 = sheet.frozen) === null || _sheet$frozen5 === void 0 ? void 0 : (_sheet$frozen5$range = _sheet$frozen5.range) === null || _sheet$frozen5$range === void 0 ? void 0 : _sheet$frozen5$range.column_focus) || 0, context.visibledatacolumn)[1] - 2 + context.scrollLeft;
    }
    return context.scrollLeft;
  }, [context.visibledatacolumn, sheet === null || sheet === void 0 ? void 0 : sheet.frozen, context.scrollLeft]);
  var onMouseMove = (0,react.useCallback)(function (e) {
    var _refs$globalCache$fre;
    if (context.luckysheet_cols_change_size) {
      return;
    }
    var mouseX = e.pageX - containerRef.current.getBoundingClientRect().left - window.scrollX;
    var _x = mouseX + containerRef.current.scrollLeft;
    var freeze = (_refs$globalCache$fre = refs.globalCache.freezen) === null || _refs$globalCache$fre === void 0 ? void 0 : _refs$globalCache$fre[context.currentSheetId];
    var _fixPositionOnFrozenC = fixPositionOnFrozenCells(freeze, _x, 0, mouseX, 0),
      x = _fixPositionOnFrozenC.x,
      inVerticalFreeze = _fixPositionOnFrozenC.inVerticalFreeze;
    var col_location = colLocation(x, context.visibledatacolumn);
    var _col_location = dist_index_esm_slicedToArray(col_location, 3),
      col_pre = _col_location[0],
      col = _col_location[1],
      col_index = _col_location[2];
    if (col_index !== hoverLocation.col_index) {
      setHoverLocation({
        col_pre: col_pre,
        col: col,
        col_index: col_index
      });
      setHoverInFreeze(inVerticalFreeze);
    }
    var flowdata = getFlowdata(context);
    if (!lodash_default().isNil(flowdata)) allowEditRef.current = isAllowEdit(context) && isAllowEdit(context, [{
      row: [0, flowdata.length - 1],
      column: col_location
    }]);
  }, [context, hoverLocation.col_index, refs.globalCache.freezen]);
  var onMouseDown = (0,react.useCallback)(function (e) {
    var nativeEvent = e.nativeEvent;
    setContext(function (draftCtx) {
      handleColumnHeaderMouseDown(draftCtx, refs.globalCache, nativeEvent, containerRef.current, refs.cellInput.current, refs.fxInput.current);
    });
  }, [refs.globalCache, refs.cellInput, refs.fxInput, setContext]);
  var onMouseLeave = (0,react.useCallback)(function () {
    if (context.luckysheet_cols_change_size) {
      return;
    }
    setHoverLocation({
      col: -1,
      col_pre: -1,
      col_index: -1
    });
  }, [context.luckysheet_cols_change_size]);
  var onColSizeHandleMouseDown = (0,react.useCallback)(function (e) {
    var nativeEvent = e.nativeEvent;
    setContext(function (draftCtx) {
      handleColSizeHandleMouseDown(draftCtx, refs.globalCache, nativeEvent, containerRef.current, refs.workbookContainer.current, refs.cellArea.current);
    });
    e.stopPropagation();
  }, [refs.cellArea, refs.globalCache, refs.workbookContainer, setContext]);
  var onColFreezeHandleMouseDown = (0,react.useCallback)(function (e) {
    var nativeEvent = e.nativeEvent;
    setContext(function (draftCtx) {
      handleColFreezeHandleMouseDown(draftCtx, refs.globalCache, nativeEvent, containerRef.current, refs.workbookContainer.current, refs.cellArea.current);
    });
    e.stopPropagation();
  }, [refs.cellArea, refs.globalCache, refs.workbookContainer, setContext]);
  var onContextMenu = (0,react.useCallback)(function (e) {
    var nativeEvent = e.nativeEvent;
    setContext(function (draftCtx) {
      handleContextMenu(draftCtx, settings, nativeEvent, refs.workbookContainer.current, refs.cellArea.current, "columnHeader");
    });
  }, [refs.workbookContainer, setContext, settings, refs.cellArea]);
  (0,react.useEffect)(function () {
    var s = context.luckysheet_select_save;
    if (lodash_default().isNil(s)) return;
    var columnTitleMap = {};
    for (var i = 0; i < s.length; i += 1) {
      var c1 = s[i].column[0];
      var c2 = s[i].column[1];
      columnTitleMap = selectTitlesMap(columnTitleMap, c1, c2);
    }
    var columnTitleRange = selectTitlesRange(columnTitleMap);
    var selects = [];
    for (var j = 0; j < columnTitleRange.length; j += 1) {
      var _c = columnTitleRange[j][0];
      var _c2 = columnTitleRange[j][columnTitleRange[j].length - 1];
      var col = colLocationByIndex(_c2, context.visibledatacolumn)[1];
      var col_pre = colLocationByIndex(_c, context.visibledatacolumn)[0];
      if (lodash_default().isNumber(col) && lodash_default().isNumber(col_pre)) {
        selects.push({
          col: col,
          col_pre: col_pre,
          c1: _c,
          c2: _c2
        });
      }
    }
    setSelectedLocation(selects);
  }, [context.luckysheet_select_save, context.visibledatacolumn]);
  (0,react.useEffect)(function () {
    containerRef.current.scrollLeft = context.scrollLeft;
  }, [context.scrollLeft]);
  return /*#__PURE__*/react.createElement("div", {
    ref: containerRef,
    className: "fortune-col-header",
    style: {
      height: context.columnHeaderHeight - 1.5
    },
    onMouseMove: onMouseMove,
    onMouseDown: onMouseDown,
    onMouseLeave: onMouseLeave,
    onContextMenu: onContextMenu
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-cols-freeze-handle",
    onMouseDown: onColFreezeHandleMouseDown,
    style: {
      left: freezeHandleLeft
    }
  }), /*#__PURE__*/react.createElement("div", {
    className: "fortune-cols-change-size",
    ref: colChangeSizeRef,
    id: "fortune-cols-change-size",
    onMouseDown: onColSizeHandleMouseDown,
    style: {
      left: hoverLocation.col - 5 + (hoverInFreeze ? context.scrollLeft : 0),
      opacity: context.luckysheet_cols_change_size ? 1 : 0
    }
  }), !context.luckysheet_cols_change_size && hoverLocation.col_index >= 0 ? /*#__PURE__*/react.createElement("div", {
    className: "fortune-col-header-hover",
    style: lodash_default().assign({
      left: hoverLocation.col_pre,
      width: hoverLocation.col - hoverLocation.col_pre - 1,
      display: "block"
    }, fixColumnStyleOverflowInFreeze(context, hoverLocation.col_index, hoverLocation.col_index, (_refs$globalCache$fre2 = refs.globalCache.freezen) === null || _refs$globalCache$fre2 === void 0 ? void 0 : _refs$globalCache$fre2[context.currentSheetId]))
  }, allowEditRef.current && /*#__PURE__*/react.createElement("span", {
    className: "header-arrow",
    onClick: function onClick(e) {
      setContext(function (ctx) {
        ctx.contextMenu = {
          x: e.pageX,
          y: 90,
          headerMenu: true
        };
      });
    },
    tabIndex: 0
  }, /*#__PURE__*/react.createElement(SVGIcon, {
    name: "headDownArrow",
    width: 12
  }))) : null, selectedLocation.map(function (_ref, i) {
    var _refs$globalCache$fre3;
    var col = _ref.col,
      col_pre = _ref.col_pre,
      c1 = _ref.c1,
      c2 = _ref.c2;
    return /*#__PURE__*/react.createElement("div", {
      className: "fortune-col-header-selected",
      key: i,
      style: lodash_default().assign({
        left: col_pre,
        width: col - col_pre - 1,
        display: "block",
        backgroundColor: "rgba(76, 76, 76, 0.1)"
      }, fixColumnStyleOverflowInFreeze(context, c1, c2, (_refs$globalCache$fre3 = refs.globalCache.freezen) === null || _refs$globalCache$fre3 === void 0 ? void 0 : _refs$globalCache$fre3[context.currentSheetId]))
    });
  }), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-cols-h-cells luckysheetsheetchange",
    id: "luckysheet-cols-h-cells_0",
    style: {
      width: context.ch_width,
      height: 1
    }
  }, /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-cols-h-cells-c"
  }, /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-grdblkpush"
  }))));
};
var RowHeader = function RowHeader() {
  var _refs$globalCache$fre2;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    settings = _useContext.settings,
    refs = _useContext.refs;
  var rowChangeSizeRef = (0,react.useRef)(null);
  var containerRef = (0,react.useRef)(null);
  var _useState = (0,react.useState)({
      row: -1,
      row_pre: -1,
      row_index: -1
    }),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    hoverLocation = _useState2[0],
    setHoverLocation = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    hoverInFreeze = _useState4[0],
    setHoverInFreeze = _useState4[1];
  var _useState5 = (0,react.useState)([]),
    _useState6 = dist_index_esm_slicedToArray(_useState5, 2),
    selectedLocation = _useState6[0],
    setSelectedLocation = _useState6[1];
  var sheetIndex = getSheetIndex(context, context.currentSheetId);
  var sheet = sheetIndex == null ? null : context.luckysheetfile[sheetIndex];
  var freezeHandleTop = (0,react.useMemo)(function () {
    var _sheet$frozen, _sheet$frozen2, _sheet$frozen3, _sheet$frozen4;
    if ((sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen = sheet.frozen) === null || _sheet$frozen === void 0 ? void 0 : _sheet$frozen.type) === "row" || (sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen2 = sheet.frozen) === null || _sheet$frozen2 === void 0 ? void 0 : _sheet$frozen2.type) === "rangeRow" || (sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen3 = sheet.frozen) === null || _sheet$frozen3 === void 0 ? void 0 : _sheet$frozen3.type) === "rangeBoth" || (sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen4 = sheet.frozen) === null || _sheet$frozen4 === void 0 ? void 0 : _sheet$frozen4.type) === "both") {
      var _sheet$frozen5, _sheet$frozen5$range;
      return rowLocationByIndex((sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen5 = sheet.frozen) === null || _sheet$frozen5 === void 0 ? void 0 : (_sheet$frozen5$range = _sheet$frozen5.range) === null || _sheet$frozen5$range === void 0 ? void 0 : _sheet$frozen5$range.row_focus) || 0, context.visibledatarow)[1] + context.scrollTop;
    }
    return context.scrollTop;
  }, [context.visibledatarow, sheet === null || sheet === void 0 ? void 0 : sheet.frozen, context.scrollTop]);
  var onMouseMove = (0,react.useCallback)(function (e) {
    var _refs$globalCache$fre;
    if (context.luckysheet_rows_change_size) {
      return;
    }
    var mouseY = e.pageY - containerRef.current.getBoundingClientRect().top - window.scrollY;
    var _y = mouseY + containerRef.current.scrollTop;
    var freeze = (_refs$globalCache$fre = refs.globalCache.freezen) === null || _refs$globalCache$fre === void 0 ? void 0 : _refs$globalCache$fre[context.currentSheetId];
    var _fixPositionOnFrozenC = fixPositionOnFrozenCells(freeze, 0, _y, 0, mouseY),
      y = _fixPositionOnFrozenC.y,
      inHorizontalFreeze = _fixPositionOnFrozenC.inHorizontalFreeze;
    var row_location = rowLocation(y, context.visibledatarow);
    var _row_location = dist_index_esm_slicedToArray(row_location, 3),
      row_pre = _row_location[0],
      row = _row_location[1],
      row_index = _row_location[2];
    if (row_pre !== hoverLocation.row_pre || row !== hoverLocation.row) {
      setHoverLocation({
        row_pre: row_pre,
        row: row,
        row_index: row_index
      });
      setHoverInFreeze(inHorizontalFreeze);
    }
  }, [context.luckysheet_rows_change_size, context.visibledatarow, hoverLocation.row, hoverLocation.row_pre, refs.globalCache.freezen, context.currentSheetId]);
  var onMouseDown = (0,react.useCallback)(function (e) {
    var nativeEvent = e.nativeEvent;
    setContext(function (draftCtx) {
      handleRowHeaderMouseDown(draftCtx, refs.globalCache, nativeEvent, containerRef.current, refs.cellInput.current, refs.fxInput.current);
    });
  }, [refs.globalCache, refs.cellInput, refs.fxInput, setContext]);
  var onMouseLeave = (0,react.useCallback)(function () {
    if (context.luckysheet_rows_change_size) {
      return;
    }
    setHoverLocation({
      row: -1,
      row_pre: -1,
      row_index: -1
    });
  }, [context.luckysheet_rows_change_size]);
  var onRowSizeHandleMouseDown = (0,react.useCallback)(function (e) {
    var nativeEvent = e.nativeEvent;
    setContext(function (draftCtx) {
      handleRowSizeHandleMouseDown(draftCtx, refs.globalCache, nativeEvent, containerRef.current, refs.workbookContainer.current, refs.cellArea.current);
    });
    e.stopPropagation();
  }, [refs.cellArea, refs.globalCache, refs.workbookContainer, setContext]);
  var onRowFreezeHandleMouseDown = (0,react.useCallback)(function (e) {
    var nativeEvent = e.nativeEvent;
    setContext(function (draftCtx) {
      handleRowFreezeHandleMouseDown(draftCtx, refs.globalCache, nativeEvent, containerRef.current, refs.workbookContainer.current, refs.cellArea.current);
    });
    e.stopPropagation();
  }, [refs.cellArea, refs.globalCache, refs.workbookContainer, setContext]);
  var onContextMenu = (0,react.useCallback)(function (e) {
    var nativeEvent = e.nativeEvent;
    setContext(function (draftCtx) {
      handleContextMenu(draftCtx, settings, nativeEvent, refs.workbookContainer.current, refs.cellArea.current, "rowHeader");
    });
  }, [refs.workbookContainer, setContext, settings, refs.cellArea]);
  (0,react.useEffect)(function () {
    var s = context.luckysheet_select_save || [];
    var rowTitleMap = {};
    for (var i = 0; i < s.length; i += 1) {
      var r1 = s[i].row[0];
      var r2 = s[i].row[1];
      rowTitleMap = selectTitlesMap(rowTitleMap, r1, r2);
    }
    var rowTitleRange = selectTitlesRange(rowTitleMap);
    var selects = [];
    for (var _i = 0; _i < rowTitleRange.length; _i += 1) {
      var _r = rowTitleRange[_i][0];
      var _r2 = rowTitleRange[_i][rowTitleRange[_i].length - 1];
      var row = rowLocationByIndex(_r2, context.visibledatarow)[1];
      var row_pre = rowLocationByIndex(_r, context.visibledatarow)[0];
      if (lodash_default().isNumber(row_pre) && lodash_default().isNumber(row)) {
        selects.push({
          row: row,
          row_pre: row_pre,
          r1: _r,
          r2: _r2
        });
      }
    }
    setSelectedLocation(selects);
  }, [context.luckysheet_select_save, context.visibledatarow]);
  (0,react.useEffect)(function () {
    containerRef.current.scrollTop = context.scrollTop;
  }, [context.scrollTop]);
  return /*#__PURE__*/react.createElement("div", {
    ref: containerRef,
    className: "fortune-row-header",
    style: {
      width: context.rowHeaderWidth - 1.5,
      height: context.cellmainHeight
    },
    onMouseMove: onMouseMove,
    onMouseDown: onMouseDown,
    onMouseLeave: onMouseLeave,
    onContextMenu: onContextMenu
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-rows-freeze-handle",
    onMouseDown: onRowFreezeHandleMouseDown,
    style: {
      top: freezeHandleTop
    }
  }), /*#__PURE__*/react.createElement("div", {
    className: "fortune-rows-change-size",
    ref: rowChangeSizeRef,
    onMouseDown: onRowSizeHandleMouseDown,
    style: {
      top: hoverLocation.row - 3 + (hoverInFreeze ? context.scrollTop : 0),
      opacity: context.luckysheet_rows_change_size ? 1 : 0
    }
  }), !context.luckysheet_rows_change_size && hoverLocation.row_index >= 0 ? /*#__PURE__*/react.createElement("div", {
    className: "fortune-row-header-hover",
    style: lodash_default().assign({
      top: hoverLocation.row_pre,
      height: hoverLocation.row - hoverLocation.row_pre - 1,
      display: "block"
    }, fixRowStyleOverflowInFreeze(context, hoverLocation.row_index, hoverLocation.row_index, (_refs$globalCache$fre2 = refs.globalCache.freezen) === null || _refs$globalCache$fre2 === void 0 ? void 0 : _refs$globalCache$fre2[context.currentSheetId]))
  }) : null, selectedLocation.map(function (_ref, i) {
    var _refs$globalCache$fre3;
    var row = _ref.row,
      row_pre = _ref.row_pre,
      r1 = _ref.r1,
      r2 = _ref.r2;
    return /*#__PURE__*/react.createElement("div", {
      className: "fortune-row-header-selected",
      key: i,
      style: lodash_default().assign({
        top: row_pre,
        height: row - row_pre - 1,
        display: "block",
        backgroundColor: "rgba(76, 76, 76, 0.1)"
      }, fixRowStyleOverflowInFreeze(context, r1, r2, (_refs$globalCache$fre3 = refs.globalCache.freezen) === null || _refs$globalCache$fre3 === void 0 ? void 0 : _refs$globalCache$fre3[context.currentSheetId]))
    });
  }), /*#__PURE__*/react.createElement("div", {
    style: {
      height: context.rh_height,
      width: 1
    },
    id: "luckysheetrowHeader_0",
    className: "luckysheetsheetchange"
  }));
};
var ContentEditable = function ContentEditable(_ref) {
  var props = _extends({}, _ref);
  var lastHtml = (0,react.useRef)("");
  var root = (0,react.useRef)(null);
  var autoFocus = props.autoFocus,
    initialContent = props.initialContent,
    onChange = props.onChange;
  (0,react.useEffect)(function () {
    if (autoFocus) {
      var _root$current;
      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.focus();
    }
  }, [autoFocus]);
  (0,react.useEffect)(function () {
    if (initialContent && root.current != null) {
      root.current.innerHTML = initialContent;
    }
  }, [initialContent]);
  var fnEmitChange = (0,react.useCallback)(function (__, isBlur) {
    var html;
    if (root.current != null) {
      html = root.current.innerHTML;
    }
    if (onChange && html !== lastHtml.current) {
      onChange(html || "", isBlur);
    }
    lastHtml.current = html || "";
  }, [root, onChange]);
  var innerRef = props.innerRef,
    _onBlur = props.onBlur;
  var allowEdit = props.allowEdit;
  if (lodash_default().isNil(allowEdit)) allowEdit = true;
  return /*#__PURE__*/react.createElement("div", index_esm_objectSpread2(index_esm_objectSpread2({
    onDoubleClick: function onDoubleClick(e) {
      return e.stopPropagation();
    },
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, lodash_default().omit(props, "innerRef", "onChange", "html", "onBlur", "autoFocus", "allowEdit", "initialContent")), {}, {
    ref: function ref(e) {
      root.current = e;
      innerRef === null || innerRef === void 0 ? void 0 : innerRef(e);
    },
    tabIndex: 0,
    onInput: fnEmitChange,
    onBlur: function onBlur(e) {
      fnEmitChange(null, true);
      _onBlur === null || _onBlur === void 0 ? void 0 : _onBlur(e);
    },
    contentEditable: allowEdit
  }));
};
var FormulaSearch = function FormulaSearch(props) {
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context;
  if (lodash_default().isEmpty(context.functionCandidates)) return null;
  return /*#__PURE__*/react.createElement("div", index_esm_objectSpread2(index_esm_objectSpread2({}, props), {}, {
    id: "luckysheet-formula-search-c",
    className: "luckysheet-formula-search-c"
  }), context.functionCandidates.map(function (v, index) {
    return /*#__PURE__*/react.createElement("div", {
      key: v.n,
      "data-func": v.n,
      className: "luckysheet-formula-search-item ".concat(index === 0 ? "luckysheet-formula-search-item-active" : "")
    }, /*#__PURE__*/react.createElement("div", {
      className: "luckysheet-formula-search-func"
    }, v.n), /*#__PURE__*/react.createElement("div", {
      className: "luckysheet-formula-search-detail"
    }, v.d));
  }));
};
var FormulaHint = function FormulaHint(props) {
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context;
  var _locale = locale(context),
    formulaMore = _locale.formulaMore;
  if (!context.functionHint) return null;
  var fn = context.formulaCache.functionlistMap[context.functionHint];
  if (!fn) return null;
  return /*#__PURE__*/react.createElement("div", index_esm_objectSpread2(index_esm_objectSpread2({}, props), {}, {
    id: "luckysheet-formula-help-c",
    className: "luckysheet-formula-help-c"
  }), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-formula-help-close",
    title: "\u5173\u95ED"
  }, /*#__PURE__*/react.createElement("i", {
    className: "fa fa-times",
    "aria-hidden": "true"
  })), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-formula-help-collapse",
    title: "\u6536\u8D77"
  }, /*#__PURE__*/react.createElement("i", {
    className: "fa fa-angle-up",
    "aria-hidden": "true"
  })), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-formula-help-title"
  }, /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-formula-help-title-formula"
  }, /*#__PURE__*/react.createElement("span", {
    className: "luckysheet-arguments-help-function-name"
  }, fn.n), /*#__PURE__*/react.createElement("span", {
    className: "luckysheet-arguments-paren"
  }, "("), /*#__PURE__*/react.createElement("span", {
    className: "luckysheet-arguments-parameter-holder"
  }, fn.p.map(function (param, i) {
    var name = param.name;
    if (param.repeat === "y") {
      name += ", ...";
    }
    if (param.require === "o") {
      name = "[".concat(name, "]");
    }
    return /*#__PURE__*/react.createElement("span", {
      className: "luckysheet-arguments-help-parameter",
      dir: "auto",
      key: name
    }, name, i !== fn.p.length - 1 && ", ");
  })), /*#__PURE__*/react.createElement("span", {
    className: "luckysheet-arguments-paren"
  }, ")"))), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-formula-help-content"
  }, /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-formula-help-content-example"
  }, /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-arguments-help-section-title"
  }, formulaMore.helpExample), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-arguments-help-formula"
  }, /*#__PURE__*/react.createElement("span", {
    className: "luckysheet-arguments-help-function-name"
  }, fn.n), /*#__PURE__*/react.createElement("span", {
    className: "luckysheet-arguments-paren"
  }, "("), /*#__PURE__*/react.createElement("span", {
    className: "luckysheet-arguments-parameter-holder"
  }, fn.p.map(function (param, i) {
    return /*#__PURE__*/react.createElement("span", {
      key: param.name,
      className: "luckysheet-arguments-help-parameter",
      dir: "auto"
    }, param.example, i !== fn.p.length - 1 && ", ");
  })), /*#__PURE__*/react.createElement("span", {
    className: "luckysheet-arguments-paren"
  }, ")"))), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-formula-help-content-detail"
  }, /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-arguments-help-section"
  }, /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-arguments-help-section-title luckysheet-arguments-help-parameter-name"
  }, formulaMore.helpAbstract), /*#__PURE__*/react.createElement("span", {
    className: "luckysheet-arguments-help-parameter-content"
  }, fn.d))), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-formula-help-content-param"
  }, fn.p.map(function (param) {
    return /*#__PURE__*/react.createElement("div", {
      className: "luckysheet-arguments-help-section",
      key: param.name
    }, /*#__PURE__*/react.createElement("div", {
      className: "luckysheet-arguments-help-section-title"
    }, param.name, param.repeat === "y" && /*#__PURE__*/react.createElement("span", {
      className: "luckysheet-arguments-help-argument-info"
    }, "...-", formulaMore.allowRepeatText), param.require === "o" && /*#__PURE__*/react.createElement("span", {
      className: "luckysheet-arguments-help-argument-info"
    }, "-[", formulaMore.allowOptionText, "]")), /*#__PURE__*/react.createElement("span", {
      className: "luckysheet-arguments-help-parameter-content"
    }, param.detail));
  }))), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-formula-help-foot"
  }));
};
function usePrevious(value) {
  var ref = (0,react.useRef)();
  (0,react.useEffect)(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
}
var InputBox = function InputBox() {
  var _context$luckysheet_s, _context$rangeDialog;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    refs = _useContext.refs;
  var inputRef = (0,react.useRef)(null);
  var lastKeyDownEventRef = (0,react.useRef)();
  var prevCellUpdate = usePrevious(context.luckysheetCellUpdate);
  var prevSheetId = usePrevious(context.currentSheetId);
  var _useState = (0,react.useState)(false),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    isHidenRC = _useState2[0],
    setIsHidenRC = _useState2[1];
  var firstSelection = (_context$luckysheet_s = context.luckysheet_select_save) === null || _context$luckysheet_s === void 0 ? void 0 : _context$luckysheet_s[0];
  var row_index = firstSelection === null || firstSelection === void 0 ? void 0 : firstSelection.row_focus;
  var col_index = firstSelection === null || firstSelection === void 0 ? void 0 : firstSelection.column_focus;
  var preText = (0,react.useRef)("");
  var inputBoxStyle = (0,react.useMemo)(function () {
    if (firstSelection && context.luckysheetCellUpdate.length > 0) {
      var flowdata = getFlowdata(context);
      if (!flowdata) return {};
      return getStyleByCell(context, flowdata, firstSelection.row_focus, firstSelection.column_focus);
    }
    return {};
  }, [context.luckysheetfile, context.currentSheetId, context.luckysheetCellUpdate, firstSelection]);
  (0,react.useLayoutEffect)(function () {
    if (!context.allowEdit) {
      setContext(function (ctx) {
        var flowdata = getFlowdata(ctx);
        if (!lodash_default().isNil(flowdata) && ctx.forceFormulaRef) {
          var value = getCellValue(row_index, col_index, flowdata, "f");
          createRangeHightlight(ctx, value);
        }
      });
    }
    if (firstSelection && context.luckysheetCellUpdate.length > 0) {
      var _flowdata$row_index;
      if (refs.globalCache.doNotUpdateCell) {
        delete refs.globalCache.doNotUpdateCell;
        return;
      }
      if (lodash_default().isEqual(prevCellUpdate, context.luckysheetCellUpdate) && prevSheetId === context.currentSheetId) {
        return;
      }
      var flowdata = getFlowdata(context);
      var cell = flowdata === null || flowdata === void 0 ? void 0 : (_flowdata$row_index = flowdata[row_index]) === null || _flowdata$row_index === void 0 ? void 0 : _flowdata$row_index[col_index];
      var value = "";
      if (cell && !refs.globalCache.overwriteCell) {
        if (isInlineStringCell(cell)) {
          value = getInlineStringHTML(row_index, col_index, flowdata);
        } else if (cell.f) {
          value = getCellValue(row_index, col_index, flowdata, "f");
          setContext(function (ctx) {
            createRangeHightlight(ctx, value);
          });
        } else {
          value = valueShowEs(row_index, col_index, flowdata);
          if (Number(cell.qp) === 1) {
            value = value ? "".concat(value) : value;
          }
        }
      }
      refs.globalCache.overwriteCell = false;
      if (!refs.globalCache.ignoreWriteCell) inputRef.current.innerHTML = escapeHTMLTag(escapeScriptTag(value));
      refs.globalCache.ignoreWriteCell = false;
      if (!refs.globalCache.doNotFocus) {
        setTimeout(function () {
          moveToEnd(inputRef.current);
        });
      }
      delete refs.globalCache.doNotFocus;
    }
  }, [context.luckysheetCellUpdate, context.luckysheetfile, context.currentSheetId, firstSelection]);
  (0,react.useEffect)(function () {
    if (lodash_default().isEmpty(context.luckysheetCellUpdate)) {
      if (inputRef.current) {
        inputRef.current.innerHTML = "";
      }
    }
  }, [context.luckysheetCellUpdate]);
  (0,react.useEffect)(function () {
    setIsHidenRC(isShowHidenCR(context));
  }, [context.luckysheet_select_save]);
  var getActiveFormula = (0,react.useCallback)(function () {
    return document.querySelector(".luckysheet-formula-search-item-active");
  }, []);
  var clearSearchItemActiveClass = (0,react.useCallback)(function () {
    var activeFormula = getActiveFormula();
    if (activeFormula) {
      activeFormula.classList.remove("luckysheet-formula-search-item-active");
    }
  }, [getActiveFormula]);
  var selectActiveFormula = (0,react.useCallback)(function (e) {
    var activeFormula = getActiveFormula();
    var formulaNameDiv = activeFormula === null || activeFormula === void 0 ? void 0 : activeFormula.querySelector(".luckysheet-formula-search-func");
    if (formulaNameDiv) {
      var formulaName = formulaNameDiv.textContent;
      var textEditor = document.getElementById("luckysheet-rich-text-editor");
      if (textEditor) {
        var _getrangeseleciton;
        var searchTxt = ((_getrangeseleciton = getrangeseleciton()) === null || _getrangeseleciton === void 0 ? void 0 : _getrangeseleciton.textContent) || "";
        var deleteCount = searchTxt.length;
        textEditor.focus();
        var selection = window.getSelection();
        if ((selection === null || selection === void 0 ? void 0 : selection.rangeCount) === 0) return;
        var range = selection === null || selection === void 0 ? void 0 : selection.getRangeAt(0);
        if (deleteCount !== 0 && range) {
          var startOffset = Math.max(range.startOffset - deleteCount, 0);
          var endOffset = range.startOffset;
          range.setStart(range.startContainer, startOffset);
          range.setEnd(range.startContainer, endOffset);
          range.deleteContents();
        }
        var functionStr = "<span dir=\"auto\" class=\"luckysheet-formula-text-func\">".concat(formulaName, "</span>");
        var lParStr = "<span dir=\"auto\" class=\"luckysheet-formula-text-lpar\">(</span>";
        var functionNode = new DOMParser().parseFromString(functionStr, "text/html").body.childNodes[0];
        var lParNode = new DOMParser().parseFromString(lParStr, "text/html").body.childNodes[0];
        if (range === null || range === void 0 ? void 0 : range.startContainer.parentNode) {
          range === null || range === void 0 ? void 0 : range.setStart(range.startContainer.parentNode, 1);
        }
        range === null || range === void 0 ? void 0 : range.insertNode(lParNode);
        range === null || range === void 0 ? void 0 : range.insertNode(functionNode);
        range === null || range === void 0 ? void 0 : range.collapse();
        selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
        if (range) selection === null || selection === void 0 ? void 0 : selection.addRange(range);
        setContext(function (draftCtx) {
          draftCtx.functionCandidates = [];
          draftCtx.functionHint = formulaName;
        });
      }
      e.preventDefault();
      e.stopPropagation();
    }
  }, [getActiveFormula, setContext]);
  var onKeyDown = (0,react.useCallback)(function (e) {
    lastKeyDownEventRef.current = new KeyboardEvent(e.type, e.nativeEvent);
    preText.current = inputRef.current.innerText;
    if (e.key === "Escape" && context.luckysheetCellUpdate.length > 0) {
      setContext(function (draftCtx) {
        cancelNormalSelected(draftCtx);
        moveHighlightCell(draftCtx, "down", 0, "rangeOfSelect");
      });
      e.preventDefault();
    } else if (e.key === "Enter" && context.luckysheetCellUpdate.length > 0) {
      if (e.altKey || e.metaKey) {
        document.execCommand("insertHTML", false, "\n ");
        document.execCommand("delete", false);
        e.stopPropagation();
      } else selectActiveFormula(e);
    } else if (e.key === "Tab" && context.luckysheetCellUpdate.length > 0) {
      selectActiveFormula(e);
      e.preventDefault();
    } else if (e.key === "F4" && context.luckysheetCellUpdate.length > 0) {
      e.preventDefault();
    } else if (e.key === "ArrowUp" && context.luckysheetCellUpdate.length > 0) {
      if (document.getElementById("luckysheet-formula-search-c")) {
        var formulaSearchContainer = document.getElementById("luckysheet-formula-search-c");
        var activeItem = formulaSearchContainer === null || formulaSearchContainer === void 0 ? void 0 : formulaSearchContainer.querySelector(".luckysheet-formula-search-item-active");
        var previousItem = activeItem ? activeItem.previousElementSibling : null;
        if (!previousItem) {
          previousItem = (formulaSearchContainer === null || formulaSearchContainer === void 0 ? void 0 : formulaSearchContainer.querySelector(".luckysheet-formula-search-item:last-child")) || null;
        }
        clearSearchItemActiveClass();
        if (previousItem) {
          previousItem.classList.add("luckysheet-formula-search-item-active");
        }
      }
      e.preventDefault();
    } else if (e.key === "ArrowDown" && context.luckysheetCellUpdate.length > 0) {
      if (document.getElementById("luckysheet-formula-search-c")) {
        var _formulaSearchContainer = document.getElementById("luckysheet-formula-search-c");
        var _activeItem = _formulaSearchContainer === null || _formulaSearchContainer === void 0 ? void 0 : _formulaSearchContainer.querySelector(".luckysheet-formula-search-item-active");
        var nextItem = _activeItem ? _activeItem.nextElementSibling : null;
        if (!nextItem) {
          nextItem = (_formulaSearchContainer === null || _formulaSearchContainer === void 0 ? void 0 : _formulaSearchContainer.querySelector(".luckysheet-formula-search-item:first-child")) || null;
        }
        clearSearchItemActiveClass();
        if (nextItem) {
          nextItem.classList.add("luckysheet-formula-search-item-active");
        }
      }
      e.preventDefault();
    }
  }, [clearSearchItemActiveClass, context.luckysheetCellUpdate.length, selectActiveFormula, setContext]);
  var onChange = (0,react.useCallback)(function (__, isBlur) {
    var e = lastKeyDownEventRef.current;
    if (!e) return;
    var kcode = e.keyCode;
    if (!kcode) return;
    if (!(kcode >= 112 && kcode <= 123 || kcode <= 46 || kcode === 144 || kcode === 108 || e.ctrlKey || e.altKey || e.shiftKey && (kcode === 37 || kcode === 38 || kcode === 39 || kcode === 40)) || kcode === 8 || kcode === 32 || kcode === 46 || e.ctrlKey && kcode === 86) {
      setContext(function (draftCtx) {
        if ((draftCtx.formulaCache.rangestart || draftCtx.formulaCache.rangedrag_column_start || draftCtx.formulaCache.rangedrag_row_start || israngeseleciton(draftCtx)) && isBlur) return;
        if (!isAllowEdit(draftCtx, draftCtx.luckysheet_select_save)) {
          return;
        }
        handleFormulaInput(draftCtx, refs.fxInput.current, refs.cellInput.current, kcode, preText.current);
      });
    }
  }, [refs.cellInput, refs.fxInput, setContext]);
  var onPaste = (0,react.useCallback)(function (e) {
    if (lodash_default().isEmpty(context.luckysheetCellUpdate)) {
      e.preventDefault();
    }
  }, [context.luckysheetCellUpdate]);
  var cfg = context.config || {};
  var rowReadOnly = cfg.rowReadOnly || {};
  var colReadOnly = cfg.colReadOnly || {};
  var edit = !((colReadOnly[col_index] || rowReadOnly[row_index]) && context.allowEdit === true);
  return /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-input-box",
    style: firstSelection && !((_context$rangeDialog = context.rangeDialog) === null || _context$rangeDialog === void 0 ? void 0 : _context$rangeDialog.show) ? {
      left: firstSelection.left,
      top: firstSelection.top,
      zIndex: lodash_default().isEmpty(context.luckysheetCellUpdate) ? -1 : 19,
      display: "block"
    } : {
      left: -10000,
      top: -10000,
      display: "block"
    },
    onMouseDown: function onMouseDown(e) {
      return e.stopPropagation();
    },
    onMouseUp: function onMouseUp(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-input-box-inner",
    style: firstSelection ? index_esm_objectSpread2({
      minWidth: firstSelection.width,
      minHeight: firstSelection.height
    }, inputBoxStyle) : {}
  }, /*#__PURE__*/react.createElement(ContentEditable, {
    innerRef: function innerRef(e) {
      inputRef.current = e;
      refs.cellInput.current = e;
    },
    className: "luckysheet-cell-input",
    id: "luckysheet-rich-text-editor",
    style: {
      transform: "scale(".concat(context.zoomRatio, ")"),
      transformOrigin: "left top",
      width: "".concat(100 / context.zoomRatio, "%"),
      height: "".concat(100 / context.zoomRatio, "%")
    },
    "aria-autocomplete": "list",
    onChange: onChange,
    onKeyDown: onKeyDown,
    onPaste: onPaste,
    allowEdit: edit ? !isHidenRC : edit
  })), document.activeElement === inputRef.current && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(FormulaSearch, {
    style: {
      top: ((firstSelection === null || firstSelection === void 0 ? void 0 : firstSelection.height_move) || 0) + 4
    }
  }), /*#__PURE__*/react.createElement(FormulaHint, {
    style: {
      top: ((firstSelection === null || firstSelection === void 0 ? void 0 : firstSelection.height_move) || 0) + 4
    }
  })));
};
var ScrollBar = function ScrollBar(_ref) {
  var axis = _ref.axis;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    refs = _useContext.refs,
    setContext = _useContext.setContext;
  (0,react.useEffect)(function () {
    if (axis === "x") {
      refs.scrollbarX.current.scrollLeft = context.scrollLeft;
    } else {
      refs.scrollbarY.current.scrollTop = context.scrollTop;
    }
  }, [axis === "x" ? context.scrollLeft : context.scrollTop]);
  return /*#__PURE__*/react.createElement("div", {
    ref: axis === "x" ? refs.scrollbarX : refs.scrollbarY,
    style: axis === "x" ? {
      left: context.rowHeaderWidth,
      width: "calc(100% - ".concat(context.rowHeaderWidth, "px)")
    } : {
      height: "100%"
    },
    className: "luckysheet-scrollbars luckysheet-scrollbar-ltr luckysheet-scrollbar-".concat(axis),
    onScroll: function onScroll() {
      if (axis === "x") {
        setContext(function (draftCtx) {
          draftCtx.scrollLeft = refs.scrollbarX.current.scrollLeft;
        });
      } else {
        setContext(function (draftCtx) {
          draftCtx.scrollTop = refs.scrollbarY.current.scrollTop;
        });
      }
    }
  }, /*#__PURE__*/react.createElement("div", {
    style: axis === "x" ? {
      width: context.ch_width,
      height: 10
    } : {
      width: 10,
      height: context.rh_height
    }
  }));
};
var Dialog = function Dialog(_ref) {
  var type = _ref.type,
    onOk = _ref.onOk,
    onCancel = _ref.onCancel,
    children = _ref.children,
    containerStyle = _ref.containerStyle,
    contentStyle = _ref.contentStyle;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context;
  var _locale = locale(context),
    button = _locale.button;
  return /*#__PURE__*/react.createElement("div", {
    className: "fortune-dialog",
    style: containerStyle
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-modal-dialog-header"
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-modal-dialog-icon-close",
    onClick: onCancel,
    tabIndex: 0
  }, /*#__PURE__*/react.createElement(SVGIcon, {
    name: "close",
    style: {
      padding: 7,
      cursor: "pointer"
    }
  }))), /*#__PURE__*/react.createElement("div", {
    className: "fortune-dialog-box-content",
    style: contentStyle
  }, children), type != null && /*#__PURE__*/react.createElement("div", {
    className: "fortune-dialog-box-button-container"
  }, type === "ok" ? /*#__PURE__*/react.createElement("div", {
    className: "fortune-message-box-button button-default",
    onClick: onOk,
    tabIndex: 0
  }, button.confirm) : /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    className: "fortune-message-box-button button-primary",
    onClick: onOk,
    tabIndex: 0
  }, button.confirm), /*#__PURE__*/react.createElement("div", {
    className: "fortune-message-box-button button-default",
    onClick: onCancel,
    tabIndex: 0
  }, button.cancel))));
};
var MessageBox = function MessageBox(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? "yesno" : _ref$type,
    onOk = _ref.onOk,
    onCancel = _ref.onCancel,
    children = _ref.children;
  return /*#__PURE__*/react.createElement(Dialog, {
    type: type,
    onOk: onOk,
    onCancel: onCancel,
    contentStyle: {
      width: 300,
      paddingTop: 20,
      paddingBottom: 30,
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, children);
};
var ModalContext = /*#__PURE__*/react.createContext({
  component: null,
  showModal: function showModal() {},
  hideModal: function hideModal() {}
});
var ModalProvider = function ModalProvider(_ref) {
  var children = _ref.children;
  var _useState = (0,react.useState)(null),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    component = _useState2[0],
    setComponent = _useState2[1];
  var showModal = (0,react.useCallback)(function (c) {
    setComponent(c);
  }, []);
  var hideModal = (0,react.useCallback)(function () {
    setComponent(null);
  }, []);
  var providerValue = (0,react.useMemo)(function () {
    return {
      component: null,
      showModal: showModal,
      hideModal: hideModal
    };
  }, [hideModal, showModal]);
  return /*#__PURE__*/react.createElement(ModalContext.Provider, {
    value: providerValue
  }, children, component && /*#__PURE__*/react.createElement("div", {
    onMouseDown: function onMouseDown(e) {
      return e.stopPropagation();
    },
    onMouseMove: function onMouseMove(e) {
      return e.stopPropagation();
    },
    onMouseUp: function onMouseUp(e) {
      return e.stopPropagation();
    },
    onContextMenu: function onContextMenu(e) {
      return e.stopPropagation();
    },
    className: "fortune-popover-backdrop fortune-modal-container"
  }, component));
};
function useAlert() {
  var _useContext = (0,react.useContext)(ModalContext),
    showModal = _useContext.showModal,
    hideModal = _useContext.hideModal;
  var showAlert = (0,react.useCallback)(function (message) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ok";
    var onOk = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : hideModal;
    var onCancel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : hideModal;
    showModal(/*#__PURE__*/react.createElement(MessageBox, {
      type: type,
      onOk: onOk,
      onCancel: onCancel
    }, message));
  }, [hideModal, showModal]);
  return {
    showAlert: showAlert,
    hideAlert: hideModal
  };
}
var SearchReplace = function SearchReplace(_ref) {
  var getContainer = _ref.getContainer;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    refs = _useContext.refs;
  var _locale = locale(context),
    findAndReplace = _locale.findAndReplace,
    button = _locale.button;
  var _useState = (0,react.useState)(""),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    searchText = _useState2[0],
    setSearchText = _useState2[1];
  var _useState3 = (0,react.useState)(""),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    replaceText = _useState4[0],
    setReplaceText = _useState4[1];
  var _useState5 = (0,react.useState)(context.showReplace),
    _useState6 = dist_index_esm_slicedToArray(_useState5, 2),
    showReplace = _useState6[0],
    setShowReplace = _useState6[1];
  var _useState7 = (0,react.useState)([]),
    _useState8 = dist_index_esm_slicedToArray(_useState7, 2),
    searchResult = _useState8[0],
    setSearchResult = _useState8[1];
  var _useState9 = (0,react.useState)(),
    _useState10 = dist_index_esm_slicedToArray(_useState9, 2),
    selectedCell = _useState10[0],
    setSelectedCell = _useState10[1];
  var _useAlert = useAlert(),
    showAlert = _useAlert.showAlert;
  var _useState11 = (0,react.useState)({
      regCheck: false,
      wordCheck: false,
      caseCheck: false
    }),
    _useState12 = dist_index_esm_slicedToArray(_useState11, 2),
    checkMode = _useState12[0],
    checkModeReplace = _useState12[1];
  var closeDialog = (0,react.useCallback)(function () {
    lodash_default().set(refs.globalCache, "searchDialog.mouseEnter", false);
    setContext(function (draftCtx) {
      draftCtx.showSearch = false;
      draftCtx.showReplace = false;
    });
  }, [refs.globalCache, setContext]);
  var setCheckMode = (0,react.useCallback)(function (mode, value) {
    return checkModeReplace((0,immer_esm/* default */.ZP)(function (draft) {
      lodash_default().set(draft, mode, value);
    }));
  }, []);
  var getInitialPosition = (0,react.useCallback)(function (container) {
    var rect = container.getBoundingClientRect();
    return {
      left: (rect.width - 500) / 2,
      top: (rect.height - 200) / 3
    };
  }, []);
  return /*#__PURE__*/react.createElement("div", {
    id: "fortune-search-replace",
    className: "fortune-search-replace fortune-dialog",
    style: getInitialPosition(getContainer()),
    onMouseEnter: function onMouseEnter() {
      lodash_default().set(refs.globalCache, "searchDialog.mouseEnter", true);
    },
    onMouseLeave: function onMouseLeave() {
      lodash_default().set(refs.globalCache, "searchDialog.mouseEnter", false);
    },
    onMouseDown: function onMouseDown(e) {
      var nativeEvent = e.nativeEvent;
      onSearchDialogMoveStart(refs.globalCache, nativeEvent, getContainer());
      e.stopPropagation();
    }
  }, /*#__PURE__*/react.createElement("div", {
    className: "container",
    onMouseDown: function onMouseDown(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/react.createElement("div", {
    className: "icon-close fortune-modal-dialog-icon-close",
    onClick: closeDialog,
    tabIndex: 0
  }, /*#__PURE__*/react.createElement(SVGIcon, {
    name: "close",
    style: {
      padding: 7,
      cursor: "pointer"
    }
  })), /*#__PURE__*/react.createElement("div", {
    className: "tabBox"
  }, /*#__PURE__*/react.createElement("span", {
    id: "searchTab",
    className: showReplace ? "" : "on",
    onClick: function onClick() {
      return setShowReplace(false);
    },
    tabIndex: 0
  }, findAndReplace.find), /*#__PURE__*/react.createElement("span", {
    id: "replaceTab",
    className: showReplace ? "on" : "",
    onClick: function onClick() {
      return setShowReplace(true);
    },
    tabIndex: 0
  }, findAndReplace.replace)), /*#__PURE__*/react.createElement("div", {
    className: "ctBox"
  }, /*#__PURE__*/react.createElement("div", {
    className: "row"
  }, /*#__PURE__*/react.createElement("div", {
    className: "inputBox"
  }, /*#__PURE__*/react.createElement("div", {
    className: "textboxs",
    id: "searchInput"
  }, findAndReplace.findTextbox, "\uFF1A", /*#__PURE__*/react.createElement("input", {
    className: "formulaInputFocus",
    autoFocus: true,
    spellCheck: "false",
    onKeyDown: function onKeyDown(e) {
      return e.stopPropagation();
    },
    value: searchText,
    onChange: function onChange(e) {
      return setSearchText(e.target.value);
    }
  })), showReplace && /*#__PURE__*/react.createElement("div", {
    className: "textboxs",
    id: "replaceInput"
  }, findAndReplace.replaceTextbox, "\uFF1A", /*#__PURE__*/react.createElement("input", {
    className: "formulaInputFocus",
    spellCheck: "false",
    onKeyDown: function onKeyDown(e) {
      return e.stopPropagation();
    },
    value: replaceText,
    onChange: function onChange(e) {
      return setReplaceText(e.target.value);
    }
  }))), /*#__PURE__*/react.createElement("div", {
    className: "checkboxs"
  }, /*#__PURE__*/react.createElement("div", {
    id: "regCheck"
  }, /*#__PURE__*/react.createElement("input", {
    type: "checkbox",
    onChange: function onChange(e) {
      return setCheckMode("regCheck", e.target.checked);
    }
  }), /*#__PURE__*/react.createElement("span", null, findAndReplace.regexTextbox)), /*#__PURE__*/react.createElement("div", {
    id: "wordCheck"
  }, /*#__PURE__*/react.createElement("input", {
    type: "checkbox",
    onChange: function onChange(e) {
      return setCheckMode("wordCheck", e.target.checked);
    }
  }), /*#__PURE__*/react.createElement("span", null, findAndReplace.wholeTextbox)), /*#__PURE__*/react.createElement("div", {
    id: "caseCheck"
  }, /*#__PURE__*/react.createElement("input", {
    type: "checkbox",
    onChange: function onChange(e) {
      return setCheckMode("caseCheck", e.target.checked);
    }
  }), /*#__PURE__*/react.createElement("span", null, findAndReplace.distinguishTextbox)))), /*#__PURE__*/react.createElement("div", {
    className: "btnBox"
  }, showReplace && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    id: "replaceAllBtn",
    className: "fortune-message-box-button button-default",
    onClick: function onClick() {
      setContext(function (draftCtx) {
        setSelectedCell(undefined);
        var alertMsg = replaceAll(draftCtx, searchText, replaceText, checkMode);
        showAlert(alertMsg);
      });
    },
    tabIndex: 0
  }, findAndReplace.allReplaceBtn), /*#__PURE__*/react.createElement("div", {
    id: "replaceBtn",
    className: "fortune-message-box-button button-default",
    onClick: function onClick() {
      return setContext(function (draftCtx) {
        setSelectedCell(undefined);
        var alertMsg = replace(draftCtx, searchText, replaceText, checkMode);
        if (alertMsg != null) {
          showAlert(alertMsg);
        }
      });
    },
    tabIndex: 0
  }, findAndReplace.replaceBtn)), /*#__PURE__*/react.createElement("div", {
    id: "searchAllBtn",
    className: "fortune-message-box-button button-default",
    onClick: function onClick() {
      return setContext(function (draftCtx) {
        setSelectedCell(undefined);
        if (!searchText) return;
        var res = searchAll(draftCtx, searchText, checkMode);
        setSearchResult(res);
        if (lodash_default().isEmpty(res)) showAlert(findAndReplace.noFindTip);
      });
    },
    tabIndex: 0
  }, findAndReplace.allFindBtn), /*#__PURE__*/react.createElement("div", {
    id: "searchNextBtn",
    className: "fortune-message-box-button button-default",
    onClick: function onClick() {
      return setContext(function (draftCtx) {
        setSearchResult([]);
        var alertMsg = searchNext(draftCtx, searchText, checkMode);
        if (alertMsg != null) showAlert(alertMsg);
      });
    },
    tabIndex: 0
  }, findAndReplace.findBtn))), /*#__PURE__*/react.createElement("div", {
    className: "close-button fortune-message-box-button button-default",
    onClick: closeDialog,
    tabIndex: 0
  }, button.close), searchResult.length > 0 && /*#__PURE__*/react.createElement("div", {
    id: "searchAllbox"
  }, /*#__PURE__*/react.createElement("div", {
    className: "boxTitle"
  }, /*#__PURE__*/react.createElement("span", null, findAndReplace.searchTargetSheet), /*#__PURE__*/react.createElement("span", null, findAndReplace.searchTargetCell), /*#__PURE__*/react.createElement("span", null, findAndReplace.searchTargetValue)), /*#__PURE__*/react.createElement("div", {
    className: "boxMain"
  }, searchResult.map(function (v) {
    return /*#__PURE__*/react.createElement("div", {
      className: "boxItem ".concat(lodash_default().isEqual(selectedCell, {
        r: v.r,
        c: v.c
      }) ? "on" : ""),
      key: v.cellPosition,
      onClick: function onClick() {
        setContext(function (draftCtx) {
          draftCtx.luckysheet_select_save = normalizeSelection(draftCtx, [{
            row: [v.r, v.r],
            column: [v.c, v.c]
          }]);
          scrollToHighlightCell(draftCtx, v.r, v.c);
        });
        setSelectedCell({
          r: v.r,
          c: v.c
        });
      },
      tabIndex: 0
    }, /*#__PURE__*/react.createElement("span", null, v.sheetName), /*#__PURE__*/react.createElement("span", null, v.cellPosition), /*#__PURE__*/react.createElement("span", null, v.value));
  })))));
};
var LinkEditCard = function LinkEditCard(_ref) {
  var r = _ref.r,
    c = _ref.c,
    rc = _ref.rc,
    originText = _ref.originText,
    originType = _ref.originType,
    originAddress = _ref.originAddress,
    isEditing = _ref.isEditing,
    position = _ref.position,
    selectingCellRange = _ref.selectingCellRange;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    refs = _useContext.refs;
  var _useState = (0,react.useState)(originText),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    linkText = _useState2[0],
    setLinkText = _useState2[1];
  var _useState3 = (0,react.useState)(originAddress),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    linkAddress = _useState4[0],
    setLinkAddress = _useState4[1];
  var _useState5 = (0,react.useState)(originType),
    _useState6 = dist_index_esm_slicedToArray(_useState5, 2),
    linkType = _useState6[0],
    setLinkType = _useState6[1];
  var _locale = locale(context),
    insertLink = _locale.insertLink,
    linkTypeList = _locale.linkTypeList,
    button = _locale.button;
  var lastCell = (0,react.useRef)(normalizeSelection(context, [{
    row: [r, r],
    column: [c, c]
  }]));
  var skipCellRangeSet = (0,react.useRef)(true);
  var isLinkAddressValid = isLinkValid(context, linkType, linkAddress);
  var tooltip = /*#__PURE__*/react.createElement("div", {
    className: "validation-input-tip"
  }, isLinkAddressValid.tooltip);
  var hideLinkCard = (0,react.useCallback)(function () {
    lodash_default().set(refs.globalCache, "linkCard.mouseEnter", false);
    setContext(function (draftCtx) {
      draftCtx.linkCard = undefined;
    });
  }, [refs.globalCache, setContext]);
  var setRangeModalVisible = (0,react.useCallback)(function (visible) {
    return setContext(function (draftCtx) {
      draftCtx.luckysheet_select_save = lastCell.current;
      if (draftCtx.linkCard != null) draftCtx.linkCard.selectingCellRange = visible;
    });
  }, [setContext]);
  var containerEvent = (0,react.useMemo)(function () {
    return {
      onMouseEnter: function onMouseEnter() {
        return lodash_default().set(refs.globalCache, "linkCard.mouseEnter", true);
      },
      onMouseLeave: function onMouseLeave() {
        return lodash_default().set(refs.globalCache, "linkCard.mouseEnter", false);
      },
      onMouseDown: function onMouseDown(e) {
        return e.stopPropagation();
      },
      onMouseMove: function onMouseMove(e) {
        return e.stopPropagation();
      },
      onMouseUp: function onMouseUp(e) {
        return e.stopPropagation();
      },
      onKeyDown: function onKeyDown(e) {
        return e.stopPropagation();
      },
      onDoubleClick: function onDoubleClick(e) {
        return e.stopPropagation();
      }
    };
  }, [refs.globalCache]);
  var renderBottomButton = (0,react.useCallback)(function (onOk, onCancel) {
    return /*#__PURE__*/react.createElement("div", {
      className: "button-group"
    }, /*#__PURE__*/react.createElement("div", {
      className: "button-basic button-default",
      onClick: onCancel,
      tabIndex: 0
    }, button.cancel), /*#__PURE__*/react.createElement("div", {
      className: "button-basic button-primary",
      onClick: onOk,
      tabIndex: 0
    }, button.confirm));
  }, [button]);
  var renderToolbarButton = (0,react.useCallback)(function (iconId, onClick) {
    return /*#__PURE__*/react.createElement("div", {
      className: "fortune-toolbar-button",
      onClick: onClick,
      tabIndex: 0
    }, /*#__PURE__*/react.createElement(SVGIcon, {
      name: iconId,
      style: {
        width: 18,
        height: 18
      }
    }));
  }, []);
  (0,react.useLayoutEffect)(function () {
    setLinkAddress(originAddress);
    setLinkText(originText);
    setLinkType(originType);
  }, [rc, originAddress, originText, originType]);
  (0,react.useLayoutEffect)(function () {
    if (selectingCellRange) {
      skipCellRangeSet.current = true;
    }
  }, [selectingCellRange]);
  (0,react.useLayoutEffect)(function () {
    if (skipCellRangeSet.current) {
      skipCellRangeSet.current = false;
      return;
    }
    if (selectingCellRange) {
      var len = lodash_default().size(context.luckysheet_select_save);
      if (len > 0) {
        setLinkAddress(getRangetxt(context, context.currentSheetId, context.luckysheet_select_save[len - 1], ""));
      }
    }
  }, [context, selectingCellRange]);
  if (!isEditing) {
    return /*#__PURE__*/react.createElement("div", index_esm_objectSpread2(index_esm_objectSpread2({}, containerEvent), {}, {
      onKeyDown: function onKeyDown(e) {
        e.stopPropagation();
      },
      className: "fortune-link-modify-modal link-toolbar",
      style: {
        left: position.cellLeft + 20,
        top: position.cellBottom
      }
    }), /*#__PURE__*/react.createElement("div", {
      className: "link-content",
      onClick: function onClick() {
        setContext(function (draftCtx) {
          return goToLink(draftCtx, r, c, linkType, linkAddress, refs.scrollbarX.current, refs.scrollbarY.current);
        });
      },
      tabIndex: 0
    }, linkType === "webpage" ? insertLink.openLink : replaceHtml(insertLink.goTo, {
      linkAddress: linkAddress
    })), context.allowEdit === true && /*#__PURE__*/react.createElement("div", {
      className: "divider"
    }), context.allowEdit === true && linkType === "webpage" && renderToolbarButton("copy", function () {
      navigator.clipboard.writeText(originAddress);
      hideLinkCard();
    }), context.allowEdit === true && renderToolbarButton("pencil", function () {
      return setContext(function (draftCtx) {
        if (draftCtx.linkCard != null && draftCtx.allowEdit) {
          draftCtx.linkCard.isEditing = true;
        }
      });
    }), context.allowEdit === true && /*#__PURE__*/react.createElement("div", {
      className: "divider"
    }), context.allowEdit === true && renderToolbarButton("unlink", function () {
      return setContext(function (draftCtx) {
        lodash_default().set(refs.globalCache, "linkCard.mouseEnter", false);
        removeHyperlink(draftCtx, r, c);
      });
    }));
  }
  return selectingCellRange ? /*#__PURE__*/react.createElement("div", index_esm_objectSpread2(index_esm_objectSpread2({
    className: "fortune-link-modify-modal range-selection-modal",
    style: {
      left: position.cellLeft,
      top: position.cellBottom + 5
    }
  }, lodash_default().omit(containerEvent, ["onMouseDown", "onMouseMove", "onMouseUp"])), {}, {
    onMouseDown: function onMouseDown(e) {
      var nativeEvent = e.nativeEvent;
      onRangeSelectionModalMoveStart(context, refs.globalCache, nativeEvent);
      e.stopPropagation();
    }
  }), /*#__PURE__*/react.createElement("div", {
    className: "modal-icon-close",
    onClick: function onClick() {
      return setRangeModalVisible(false);
    },
    tabIndex: 0
  }, /*#__PURE__*/react.createElement(SVGIcon, {
    name: "close"
  })), /*#__PURE__*/react.createElement("div", {
    className: "modal-title"
  }, insertLink.selectCellRange), /*#__PURE__*/react.createElement("input", index_esm_objectSpread2(index_esm_objectSpread2({}, containerEvent), {}, {
    className: "range-selection-input ".concat(!linkAddress || isLinkAddressValid.isValid ? "" : "error-input"),
    placeholder: insertLink.cellRangePlaceholder,
    onChange: function onChange(e) {
      return setLinkAddress(e.target.value);
    },
    value: linkAddress
  })), tooltip, /*#__PURE__*/react.createElement("div", {
    className: "modal-footer"
  }, renderBottomButton(function () {
    if (isLinkAddressValid.isValid) setRangeModalVisible(false);
  }, function () {
    setLinkAddress(originAddress);
    setRangeModalVisible(false);
  }))) : /*#__PURE__*/react.createElement("div", index_esm_objectSpread2({
    className: "fortune-link-modify-modal",
    style: {
      left: position.cellLeft + 20,
      top: position.cellBottom
    }
  }, containerEvent), /*#__PURE__*/react.createElement("div", {
    className: "fortune-link-modify-line"
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-link-modify-title"
  }, insertLink.linkText), /*#__PURE__*/react.createElement("input", {
    className: "fortune-link-modify-input",
    spellCheck: "false",
    autoFocus: true,
    value: linkText,
    onChange: function onChange(e) {
      return setLinkText(e.target.value);
    }
  })), /*#__PURE__*/react.createElement("div", {
    className: "fortune-link-modify-line"
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-link-modify-title"
  }, insertLink.linkType), /*#__PURE__*/react.createElement("select", {
    className: "fortune-link-modify-select",
    value: linkType,
    onChange: function onChange(e) {
      if (e.target.value === "sheet") {
        if (!linkText) {
          setLinkText(context.luckysheetfile[0].name);
        }
        setLinkAddress(context.luckysheetfile[0].name);
      } else {
        setLinkAddress("");
      }
      if (e.target.value === "cellrange") setRangeModalVisible(true);
      setLinkType(e.target.value);
    }
  }, linkTypeList.map(function (type) {
    return /*#__PURE__*/react.createElement("option", {
      key: type.value,
      value: type.value
    }, type.text);
  }))), /*#__PURE__*/react.createElement("div", {
    className: "fortune-link-modify-line"
  }, linkType === "webpage" && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    className: "fortune-link-modify-title"
  }, insertLink.linkAddress), /*#__PURE__*/react.createElement("input", {
    className: "fortune-link-modify-input ".concat(!linkAddress || isLinkAddressValid.isValid ? "" : "error-input"),
    spellCheck: "false",
    value: linkAddress,
    onChange: function onChange(e) {
      return setLinkAddress(e.target.value);
    }
  }), tooltip), linkType === "cellrange" && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    className: "fortune-link-modify-title"
  }, insertLink.linkCell), /*#__PURE__*/react.createElement("input", {
    className: "fortune-link-modify-input ".concat(!linkAddress || isLinkAddressValid.isValid ? "" : "error-input"),
    spellCheck: "false",
    value: linkAddress,
    onChange: function onChange(e) {
      return setLinkAddress(e.target.value);
    }
  }), /*#__PURE__*/react.createElement("div", {
    className: "fortune-link-modify-cell-selector",
    onClick: function onClick() {
      return setRangeModalVisible(true);
    },
    tabIndex: 0
  }, /*#__PURE__*/react.createElement(SVGIcon, {
    name: "border-all"
  })), tooltip), linkType === "sheet" && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    className: "fortune-link-modify-title"
  }, insertLink.linkSheet), /*#__PURE__*/react.createElement("select", {
    className: "fortune-link-modify-select",
    onChange: function onChange(e) {
      if (!linkText) setLinkText(e.target.value);
      setLinkAddress(e.target.value);
    },
    value: linkAddress
  }, context.luckysheetfile.map(function (sheet) {
    return /*#__PURE__*/react.createElement("option", {
      key: sheet.id,
      value: sheet.name
    }, sheet.name);
  })), tooltip)), /*#__PURE__*/react.createElement("div", {
    className: "modal-footer"
  }, renderBottomButton(function () {
    if (!isLinkAddressValid.isValid) return;
    lodash_default().set(refs.globalCache, "linkCard.mouseEnter", false);
    setContext(function (draftCtx) {
      return saveHyperlink(draftCtx, r, c, linkText, linkType, linkAddress);
    });
  }, hideLinkCard)));
};
var FilterOptions = function FilterOptions(_ref) {
  var _refs$globalCache$fre, _refs$globalCache$fre2;
  var getContainer = _ref.getContainer;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    refs = _useContext.refs;
  var filterOptions = context.filterOptions,
    currentSheetId = context.currentSheetId,
    filter = context.filter,
    visibledatarow = context.visibledatarow,
    visibledatacolumn = context.visibledatacolumn;
  var sheetIndex = getSheetIndex(context, context.currentSheetId);
  var _context$luckysheetfi = context.luckysheetfile[sheetIndex],
    filter_select = _context$luckysheetfi.filter_select,
    frozen = _context$luckysheetfi.frozen;
  (0,react.useEffect)(function () {
    setContext(function (draftCtx) {
      var sheetIdx = getSheetIndex(draftCtx, draftCtx.currentSheetId);
      if (sheetIdx == null) return;
      draftCtx.luckysheet_filter_save = draftCtx.luckysheetfile[sheetIdx].filter_select;
      draftCtx.filter = draftCtx.luckysheetfile[sheetIdx].filter || {};
      createFilterOptions(draftCtx, draftCtx.luckysheet_filter_save, undefined);
    });
  }, [visibledatarow, visibledatacolumn, setContext, currentSheetId, filter_select]);
  var showFilterContextMenu = (0,react.useCallback)(function (v, i) {
    if (filterOptions == null) return;
    setContext(function (draftCtx) {
      var _draftCtx$filterConte, _draftCtx$filter$i;
      if (((_draftCtx$filterConte = draftCtx.filterContextMenu) === null || _draftCtx$filterConte === void 0 ? void 0 : _draftCtx$filterConte.col) === filterOptions.startCol + i) return;
      draftCtx.filterContextMenu = {
        x: v.left + draftCtx.rowHeaderWidth - refs.scrollbarX.current.scrollLeft,
        y: v.top + 23 + draftCtx.toolbarHeight + draftCtx.calculatebarHeight + draftCtx.columnHeaderHeight - refs.scrollbarY.current.scrollTop,
        col: filterOptions.startCol + i,
        startRow: filterOptions.startRow,
        endRow: filterOptions.endRow,
        startCol: filterOptions.startCol,
        endCol: filterOptions.endCol,
        hiddenRows: lodash_default().keys((_draftCtx$filter$i = draftCtx.filter[i]) === null || _draftCtx$filter$i === void 0 ? void 0 : _draftCtx$filter$i.rowhidden).map(function (r) {
          return parseInt(r, 10);
        }),
        listBoxMaxHeight: 400
      };
    });
  }, [filterOptions, getContainer, refs.scrollbarX, refs.scrollbarY, setContext]);
  var freezeType = frozen === null || frozen === void 0 ? void 0 : frozen.type;
  var frozenColumns = -1;
  var frozenRows = -1;
  if (freezeType === "row") frozenRows = 0;else if (freezeType === "column") frozenColumns = 0;else if (freezeType === "both") {
    frozenColumns = 0;
    frozenRows = 0;
  } else {
    var _frozen$range, _frozen$range2;
    frozenColumns = (frozen === null || frozen === void 0 ? void 0 : (_frozen$range = frozen.range) === null || _frozen$range === void 0 ? void 0 : _frozen$range.column_focus) || -1;
    frozenRows = (frozen === null || frozen === void 0 ? void 0 : (_frozen$range2 = frozen.range) === null || _frozen$range2 === void 0 ? void 0 : _frozen$range2.row_focus) || -1;
  }
  return filterOptions == null ? /*#__PURE__*/react.createElement("div", null) : /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    id: "luckysheet-filter-selected-sheet",
    className: "luckysheet-cell-selected luckysheet-filter-selected",
    style: lodash_default().assign({
      left: filterOptions.left,
      width: filterOptions.width,
      top: filterOptions.top,
      height: filterOptions.height,
      display: "block"
    }, fixRowStyleOverflowInFreeze(context, filterOptions.startRow, filterOptions.endRow, (_refs$globalCache$fre = refs.globalCache.freezen) === null || _refs$globalCache$fre === void 0 ? void 0 : _refs$globalCache$fre[context.currentSheetId]), fixColumnStyleOverflowInFreeze(context, filterOptions.startCol, filterOptions.endCol, (_refs$globalCache$fre2 = refs.globalCache.freezen) === null || _refs$globalCache$fre2 === void 0 ? void 0 : _refs$globalCache$fre2[context.currentSheetId]))
  }), filterOptions.items.map(function (v, i) {
    var _refs$globalCache$fre3, _refs$globalCache$fre4;
    var filterParam = filter[i];
    var columnOverflowFreezeStyle = fixColumnStyleOverflowInFreeze(context, i + filterOptions.startCol, i + filterOptions.startCol, (_refs$globalCache$fre3 = refs.globalCache.freezen) === null || _refs$globalCache$fre3 === void 0 ? void 0 : _refs$globalCache$fre3[context.currentSheetId]);
    var rowOverflowFreezeStyle = fixRowStyleOverflowInFreeze(context, filterOptions.startRow, filterOptions.startRow, (_refs$globalCache$fre4 = refs.globalCache.freezen) === null || _refs$globalCache$fre4 === void 0 ? void 0 : _refs$globalCache$fre4[context.currentSheetId]);
    var col = visibledatacolumn[v.col];
    var col_pre = v.col > 0 ? visibledatacolumn[v.col - 1] : 0;
    var left = v.col <= frozenColumns && columnOverflowFreezeStyle.left ? columnOverflowFreezeStyle.left + col - col_pre - 20 : v.left;
    var top = filterOptions.startRow <= frozenRows && rowOverflowFreezeStyle.top ? rowOverflowFreezeStyle.top : v.top;
    var v_adjusted = index_esm_objectSpread2(index_esm_objectSpread2({}, v), {}, {
      left: left,
      top: top
    });
    return /*#__PURE__*/react.createElement("div", {
      onMouseDown: function onMouseDown(e) {
        return e.stopPropagation();
      },
      onClick: function onClick(e) {
        e.stopPropagation();
        showFilterContextMenu(v_adjusted, i);
      },
      onDoubleClick: function onDoubleClick(e) {
        return e.stopPropagation();
      },
      tabIndex: 0,
      key: i,
      style: lodash_default().assign(rowOverflowFreezeStyle, columnOverflowFreezeStyle, {
        left: left,
        top: top,
        height: undefined,
        width: undefined
      }),
      className: "luckysheet-filter-options ".concat(filterParam == null ? "" : "luckysheet-filter-options-active")
    }, filterParam == null ? /*#__PURE__*/react.createElement("div", {
      className: "caret down"
    }) : /*#__PURE__*/react.createElement(SVGIcon, {
      name: "filter-fill-white",
      style: {
        width: 15,
        height: 15
      }
    }));
  }));
};
var ImgBoxs = function ImgBoxs() {
  var _context$insertedImgs;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    refs = _useContext.refs;
  var activeImg = (0,react.useMemo)(function () {
    return lodash_default().find(context.insertedImgs, {
      id: context.activeImg
    });
  }, [context.activeImg, context.insertedImgs]);
  return /*#__PURE__*/react.createElement("div", {
    id: "luckysheet-image-showBoxs"
  }, activeImg && /*#__PURE__*/react.createElement("div", {
    id: "luckysheet-modal-dialog-activeImage",
    className: "luckysheet-modal-dialog",
    style: {
      padding: 0,
      position: "absolute",
      zIndex: 300,
      width: activeImg.width * context.zoomRatio,
      height: activeImg.height * context.zoomRatio,
      left: activeImg.left * context.zoomRatio,
      top: activeImg.top * context.zoomRatio
    }
  }, /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-modal-dialog-border",
    style: {
      position: "absolute"
    }
  }), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-modal-dialog-content",
    style: {
      width: activeImg.width * context.zoomRatio,
      height: activeImg.height * context.zoomRatio,
      backgroundImage: "url(".concat(activeImg.src, ")"),
      backgroundSize: "".concat(activeImg.width * context.zoomRatio, "px ").concat(activeImg.height * context.zoomRatio, "px"),
      backgroundRepeat: "no-repeat"
    },
    onMouseDown: function onMouseDown(e) {
      var nativeEvent = e.nativeEvent;
      onImageMoveStart(context, refs.globalCache, nativeEvent);
      e.stopPropagation();
    }
  }), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-modal-dialog-resize"
  }, ["lt", "mt", "lm", "rm", "rt", "lb", "mb", "rb"].map(function (v) {
    return /*#__PURE__*/react.createElement("div", {
      key: v,
      className: "luckysheet-modal-dialog-resize-item luckysheet-modal-dialog-resize-item-".concat(v),
      "data-type": v,
      onMouseDown: function onMouseDown(e) {
        var nativeEvent = e.nativeEvent;
        onImageResizeStart(refs.globalCache, nativeEvent, v);
        e.stopPropagation();
      }
    });
  })), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-modal-dialog-controll"
  }, /*#__PURE__*/react.createElement("span", {
    className: "luckysheet-modal-controll-btn luckysheet-modal-controll-crop",
    role: "button",
    tabIndex: 0,
    "aria-label": "\u88C1\u526A",
    title: "\u88C1\u526A"
  }, /*#__PURE__*/react.createElement("i", {
    className: "fa fa-pencil",
    "aria-hidden": "true"
  })), /*#__PURE__*/react.createElement("span", {
    className: "luckysheet-modal-controll-btn luckysheet-modal-controll-restore",
    role: "button",
    tabIndex: 0,
    "aria-label": "\u6062\u590D\u539F\u56FE",
    title: "\u6062\u590D\u539F\u56FE"
  }, /*#__PURE__*/react.createElement("i", {
    className: "fa fa-window-maximize",
    "aria-hidden": "true"
  })), /*#__PURE__*/react.createElement("span", {
    className: "luckysheet-modal-controll-btn luckysheet-modal-controll-del",
    role: "button",
    tabIndex: 0,
    "aria-label": "\u5220\u9664",
    title: "\u5220\u9664"
  }, /*#__PURE__*/react.createElement("i", {
    className: "fa fa-trash",
    "aria-hidden": "true"
  })))), /*#__PURE__*/react.createElement("div", {
    className: "img-list"
  }, (_context$insertedImgs = context.insertedImgs) === null || _context$insertedImgs === void 0 ? void 0 : _context$insertedImgs.map(function (v) {
    var id = v.id,
      left = v.left,
      top = v.top,
      width = v.width,
      height = v.height,
      src = v.src;
    if (v.id === context.activeImg) return null;
    return /*#__PURE__*/react.createElement("div", {
      id: id,
      key: id,
      className: "luckysheet-modal-dialog luckysheet-modal-dialog-image",
      style: {
        width: width * context.zoomRatio,
        height: height * context.zoomRatio,
        padding: 0,
        position: "absolute",
        left: left * context.zoomRatio,
        top: top * context.zoomRatio,
        zIndex: 200
      },
      onMouseDown: function onMouseDown(e) {
        return e.stopPropagation();
      },
      onClick: function onClick(e) {
        setContext(function (ctx) {
          ctx.activeImg = id;
        });
        e.stopPropagation();
      },
      tabIndex: 0
    }, /*#__PURE__*/react.createElement("div", {
      className: "luckysheet-modal-dialog-content",
      style: {
        width: "100%",
        height: "100%",
        overflow: "hidden",
        position: "relative"
      }
    }, /*#__PURE__*/react.createElement("img", {
      src: src,
      alt: "",
      style: {
        width: width * context.zoomRatio,
        height: height * context.zoomRatio
      }
    })), /*#__PURE__*/react.createElement("div", {
      className: "luckysheet-modal-dialog-border"
    }));
  })), /*#__PURE__*/react.createElement("div", {
    id: "luckysheet-modal-dialog-cropping",
    className: "luckysheet-modal-dialog",
    style: {
      display: "none",
      padding: 0,
      position: "absolute",
      zIndex: 300
    }
  }, /*#__PURE__*/react.createElement("div", {
    className: "cropping-mask"
  }), /*#__PURE__*/react.createElement("div", {
    className: "cropping-content"
  }), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-modal-dialog-border",
    style: {
      position: "absolute"
    }
  }), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-modal-dialog-resize"
  }, /*#__PURE__*/react.createElement("div", {
    className: "resize-item lt",
    "data-type": "lt"
  }), /*#__PURE__*/react.createElement("div", {
    className: "resize-item mt",
    "data-type": "mt"
  }), /*#__PURE__*/react.createElement("div", {
    className: "resize-item lm",
    "data-type": "lm"
  }), /*#__PURE__*/react.createElement("div", {
    className: "resize-item rm",
    "data-type": "rm"
  }), /*#__PURE__*/react.createElement("div", {
    className: "resize-item rt",
    "data-type": "rt"
  }), /*#__PURE__*/react.createElement("div", {
    className: "resize-item lb",
    "data-type": "lb"
  }), /*#__PURE__*/react.createElement("div", {
    className: "resize-item mb",
    "data-type": "mb"
  }), /*#__PURE__*/react.createElement("div", {
    className: "resize-item rb",
    "data-type": "rb"
  })), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-modal-dialog-controll"
  }, /*#__PURE__*/react.createElement("span", {
    className: "luckysheet-modal-controll-btn luckysheet-modal-controll-crop",
    role: "button",
    tabIndex: 0,
    "aria-label": "\u88C1\u526A",
    title: "\u88C1\u526A"
  }, /*#__PURE__*/react.createElement("i", {
    className: "fa fa-pencil",
    "aria-hidden": "true"
  })), /*#__PURE__*/react.createElement("span", {
    className: "luckysheet-modal-controll-btn luckysheet-modal-controll-restore",
    role: "button",
    tabIndex: 0,
    "aria-label": "\u6062\u590D\u539F\u56FE",
    title: "\u6062\u590D\u539F\u56FE"
  }, /*#__PURE__*/react.createElement("i", {
    className: "fa fa-window-maximize",
    "aria-hidden": "true"
  })), /*#__PURE__*/react.createElement("span", {
    className: "luckysheet-modal-controll-btn luckysheet-modal-controll-del",
    role: "button",
    tabIndex: 0,
    "aria-label": "\u5220\u9664",
    title: "\u5220\u9664"
  }, /*#__PURE__*/react.createElement("i", {
    className: "fa fa-trash",
    "aria-hidden": "true"
  })))), /*#__PURE__*/react.createElement("div", {
    className: "cell-date-picker"
  }));
};
var NotationBoxes = function NotationBoxes() {
  var _context$commentBoxes;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    refs = _useContext.refs;
  var flowdata = getFlowdata(context);
  (0,react.useEffect)(function () {
    if (flowdata) {
      var psShownCells = [];
      for (var i = 0; i < flowdata.length; i += 1) {
        for (var j = 0; j < flowdata[i].length; j += 1) {
          var _cell$ps;
          var cell = flowdata[i][j];
          if (!cell) continue;
          if ((_cell$ps = cell.ps) === null || _cell$ps === void 0 ? void 0 : _cell$ps.isShow) {
            psShownCells.push({
              r: i,
              c: j
            });
          }
        }
      }
      setContext(function (ctx) {
        return showComments(ctx, psShownCells);
      });
    }
  }, [flowdata, setContext]);
  return /*#__PURE__*/react.createElement("div", {
    id: "luckysheet-postil-showBoxs"
  }, lodash_default().concat((_context$commentBoxes = context.commentBoxes) === null || _context$commentBoxes === void 0 ? void 0 : _context$commentBoxes.filter(function (v) {
    var _context$editingComme;
    return (v === null || v === void 0 ? void 0 : v.rc) !== ((_context$editingComme = context.editingCommentBox) === null || _context$editingComme === void 0 ? void 0 : _context$editingComme.rc);
  }), [context.editingCommentBox, context.hoveredCommentBox]).map(function (commentBox) {
    var _context$editingComme2;
    if (!commentBox) return null;
    var r = commentBox.r,
      c = commentBox.c,
      rc = commentBox.rc,
      left = commentBox.left,
      top = commentBox.top,
      width = commentBox.width,
      height = commentBox.height,
      value = commentBox.value,
      autoFocus = commentBox.autoFocus,
      size = commentBox.size;
    var isEditing = ((_context$editingComme2 = context.editingCommentBox) === null || _context$editingComme2 === void 0 ? void 0 : _context$editingComme2.rc) === rc;
    var commentId = "comment-box-".concat(rc);
    return /*#__PURE__*/react.createElement("div", {
      key: rc
    }, /*#__PURE__*/react.createElement("canvas", {
      id: "arrowCanvas-".concat(rc),
      className: "arrowCanvas",
      width: size.width,
      height: size.height,
      style: {
        position: "absolute",
        left: size.left,
        top: size.top,
        zIndex: 100,
        pointerEvents: "none"
      }
    }), /*#__PURE__*/react.createElement("div", {
      id: commentId,
      className: "luckysheet-postil-show-main",
      style: {
        width: width,
        height: height,
        color: "#000",
        padding: 5,
        border: "1px solid #000",
        backgroundColor: "rgb(255,255,225)",
        position: "absolute",
        left: left,
        top: top,
        boxSizing: "border-box",
        zIndex: isEditing ? 200 : 100
      },
      onMouseDown: function onMouseDown(e) {
        var nativeEvent = e.nativeEvent;
        setContext(function (draftContext) {
          if (flowdata) {
            setEditingComment(draftContext, flowdata, r, c);
          }
        });
        onCommentBoxMoveStart(context, refs.globalCache, nativeEvent, {
          r: r,
          c: c,
          rc: rc
        }, commentId);
        e.stopPropagation();
      }
    }, /*#__PURE__*/react.createElement("div", {
      className: "luckysheet-postil-dialog-move"
    }, ["t", "r", "b", "l"].map(function (v) {
      return /*#__PURE__*/react.createElement("div", {
        key: v,
        className: "luckysheet-postil-dialog-move-item luckysheet-postil-dialog-move-item-".concat(v),
        "data-type": v
      });
    })), isEditing && /*#__PURE__*/react.createElement("div", {
      className: "luckysheet-postil-dialog-resize"
    }, ["lt", "mt", "lm", "rm", "rt", "lb", "mb", "rb"].map(function (v) {
      return /*#__PURE__*/react.createElement("div", {
        key: v,
        className: "luckysheet-postil-dialog-resize-item luckysheet-postil-dialog-resize-item-".concat(v),
        "data-type": v,
        onMouseDown: function onMouseDown(e) {
          var nativeEvent = e.nativeEvent;
          onCommentBoxResizeStart(context, refs.globalCache, nativeEvent, {
            r: r,
            c: c,
            rc: rc
          }, commentId, v);
          e.stopPropagation();
        }
      });
    })), /*#__PURE__*/react.createElement("div", {
      style: {
        width: "100%",
        height: "100%",
        overflow: "hidden"
      }
    }, /*#__PURE__*/react.createElement(ContentEditable, {
      id: "comment-editor-".concat(rc),
      autoFocus: autoFocus,
      style: {
        width: "100%",
        height: "100%",
        lineHeight: "20px",
        boxSizing: "border-box",
        textAlign: "center",
        wordBreak: "break-all",
        outline: "none"
      },
      allowEdit: context.allowEdit,
      spellCheck: false,
      "data-r": r,
      "data-c": c,
      onKeyDown: function onKeyDown(e) {
        return e.stopPropagation();
      },
      onFocus: function onFocus(e) {
        if (context.allowEdit === false) return;
        refs.globalCache.editingCommentBoxEle = e.target;
      },
      onMouseDown: function onMouseDown(e) {
        setContext(function (draftContext) {
          if (flowdata) {
            setEditingComment(draftContext, flowdata, r, c);
          }
        });
        e.stopPropagation();
      },
      onDoubleClick: function onDoubleClick(e) {
        e.stopPropagation();
      },
      initialContent: value
    }))));
  }));
};
function useDialog() {
  var _useContext = (0,react.useContext)(ModalContext),
    showModal = _useContext.showModal,
    hideModal = _useContext.hideModal;
  var showDialog = (0,react.useCallback)(function (content, type) {
    var onOk = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : hideModal;
    var onCancel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : hideModal;
    showModal(/*#__PURE__*/react.createElement(Dialog, {
      type: type,
      onOk: onOk,
      onCancel: onCancel
    }, content));
  }, [hideModal, showModal]);
  return {
    showDialog: showDialog,
    hideDialog: hideModal
  };
}
var DataVerification = function DataVerification() {
  var _context$dataVerifica, _context$dataVerifica2, _context$dataVerifica3, _context$dataVerifica4, _context$dataVerifica5, _context$dataVerifica6, _context$dataVerifica7, _context$dataVerifica8, _context$dataVerifica9, _context$dataVerifica10, _context$dataVerifica11, _context$dataVerifica12, _context$dataVerifica13, _context$dataVerifica14, _context$dataVerifica15, _context$dataVerifica16, _context$dataVerifica17, _context$dataVerifica18, _context$dataVerifica19, _context$dataVerifica20, _context$dataVerifica21, _context$dataVerifica22, _context$dataVerifica23, _context$dataVerifica24, _context$dataVerifica25;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext;
  var _useDialog = useDialog(),
    showDialog = _useDialog.showDialog,
    hideDialog = _useDialog.hideDialog;
  var _locale = locale(context),
    dataVerification = _locale.dataVerification,
    toolbar = _locale.toolbar,
    button = _locale.button,
    generalDialog = _locale.generalDialog;
  var _useState = (0,react.useState)(["between", "notBetween", "equal", "notEqualTo", "moreThanThe", "lessThan", "greaterOrEqualTo", "lessThanOrEqualTo"]),
    _useState2 = dist_index_esm_slicedToArray(_useState, 1),
    numberCondition = _useState2[0];
  var _useState3 = (0,react.useState)(["between", "notBetween", "equal", "notEqualTo", "earlierThan", "noEarlierThan", "laterThan", "noLaterThan"]),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 1),
    dateCondition = _useState4[0];
  var dataSelectRange = (0,react.useCallback)(function (type, value) {
    hideDialog();
    setContext(function (ctx) {
      ctx.rangeDialog.show = true;
      ctx.rangeDialog.type = type;
      ctx.rangeDialog.rangeTxt = value;
    });
  }, [hideDialog, setContext]);
  var btn = (0,react.useCallback)(function (type) {
    if (type === "confirm") {
      setContext(function (ctx) {
        var isPass = confirmMessage(ctx, generalDialog, dataVerification);
        if (isPass) {
          var _ctx$dataVerification, _ctx$dataVerification2, _ctx$luckysheetfile$g;
          var range = getRangeByTxt(ctx, (_ctx$dataVerification = ctx.dataVerification) === null || _ctx$dataVerification === void 0 ? void 0 : (_ctx$dataVerification2 = _ctx$dataVerification.dataRegulation) === null || _ctx$dataVerification2 === void 0 ? void 0 : _ctx$dataVerification2.rangeTxt);
          if (range.length === 0) {
            return;
          }
          var regulation = ctx.dataVerification.dataRegulation;
          var verifacationT = regulation === null || regulation === void 0 ? void 0 : regulation.type;
          var value1 = regulation.value1;
          var item = index_esm_objectSpread2(index_esm_objectSpread2({}, regulation), {}, {
            checked: false
          });
          if (verifacationT === "dropdown") {
            var list = getDropdownList(ctx, value1);
            item.value1 = list.join(",");
          }
          var currentDataVerification = (_ctx$luckysheetfile$g = ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)].dataVerification) !== null && _ctx$luckysheetfile$g !== void 0 ? _ctx$luckysheetfile$g : {};
          var str = range[range.length - 1].row[0];
          var edr = range[range.length - 1].row[1];
          var stc = range[range.length - 1].column[0];
          var edc = range[range.length - 1].column[1];
          var d = getFlowdata(ctx);
          if (!d) return;
          for (var r = str; r <= edr; r += 1) {
            for (var c = stc; c <= edc; c += 1) {
              var key = "".concat(r, "_").concat(c);
              currentDataVerification[key] = item;
              if (regulation.type === "checkbox") {
                setCellValue(ctx, r, c, d, item.value2);
              }
            }
          }
          ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)].dataVerification = currentDataVerification;
        }
      });
    } else if (type === "delete") {
      setContext(function (ctx) {
        var _ctx$dataVerification3, _ctx$dataVerification4, _ctx$luckysheetfile$g2;
        var range = getRangeByTxt(ctx, (_ctx$dataVerification3 = ctx.dataVerification) === null || _ctx$dataVerification3 === void 0 ? void 0 : (_ctx$dataVerification4 = _ctx$dataVerification3.dataRegulation) === null || _ctx$dataVerification4 === void 0 ? void 0 : _ctx$dataVerification4.rangeTxt);
        if (range.length === 0) {
          showDialog(generalDialog.noSeletionError, "ok");
          return;
        }
        var currentDataVerification = (_ctx$luckysheetfile$g2 = ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)].dataVerification) !== null && _ctx$luckysheetfile$g2 !== void 0 ? _ctx$luckysheetfile$g2 : {};
        var str = range[range.length - 1].row[0];
        var edr = range[range.length - 1].row[1];
        var stc = range[range.length - 1].column[0];
        var edc = range[range.length - 1].column[1];
        for (var r = str; r <= edr; r += 1) {
          for (var c = stc; c <= edc; c += 1) {
            delete currentDataVerification["".concat(r, "_").concat(c)];
          }
        }
      });
    }
    hideDialog();
  }, [dataVerification, generalDialog, hideDialog, setContext, showDialog]);
  (0,react.useEffect)(function () {
    setContext(function (ctx) {
      var rangeT = "";
      if (ctx.luckysheet_select_save) {
        var range = ctx.luckysheet_select_save[ctx.luckysheet_select_save.length - 1];
        rangeT = getRangetxt(context, context.currentSheetId, range, context.currentSheetId);
      }
      var index = getSheetIndex(ctx, ctx.currentSheetId);
      var ctxDataVerification = ctx.luckysheetfile[index].dataVerification;
      if (ctxDataVerification) {
        var _defaultItem$value, _ctx$rangeDialog, _ctx$rangeDialog2;
        if (!ctx.luckysheet_select_save) return;
        var last = ctx.luckysheet_select_save[ctx.luckysheet_select_save.length - 1];
        var rowIndex = last.row_focus;
        var colIndex = last.column_focus;
        if (rowIndex == null || colIndex == null) return;
        var item = ctxDataVerification["".concat(rowIndex, "_").concat(colIndex)];
        var defaultItem = item !== null && item !== void 0 ? item : {};
        var rangValue = (_defaultItem$value = defaultItem.value1) !== null && _defaultItem$value !== void 0 ? _defaultItem$value : "";
        if (((_ctx$rangeDialog = ctx.rangeDialog) === null || _ctx$rangeDialog === void 0 ? void 0 : _ctx$rangeDialog.type) === "dropDown" && ctx.dataVerification && ctx.dataVerification.dataRegulation && ctx.dataVerification.dataRegulation.rangeTxt) {
          rangeT = ctx.dataVerification.dataRegulation.rangeTxt;
          rangValue = ctx.rangeDialog.rangeTxt;
        } else if (((_ctx$rangeDialog2 = ctx.rangeDialog) === null || _ctx$rangeDialog2 === void 0 ? void 0 : _ctx$rangeDialog2.type) === "rangeTxt" && ctx.dataVerification && ctx.dataVerification.dataRegulation && ctx.dataVerification.dataRegulation.value1) {
          rangValue = ctx.dataVerification.dataRegulation.value1;
          rangeT = ctx.rangeDialog.rangeTxt;
        }
        ctx.rangeDialog.type = "";
        if (item) {
          ctx.dataVerification.dataRegulation = index_esm_objectSpread2(index_esm_objectSpread2({}, item), {}, {
            value1: rangValue,
            rangeTxt: rangeT
          });
        } else {
          ctx.dataVerification.dataRegulation = {
            type: "dropdown",
            type2: "",
            rangeTxt: rangeT,
            value1: rangValue,
            value2: "",
            validity: "",
            remote: false,
            prohibitInput: false,
            hintShow: false,
            hintValue: ""
          };
        }
      } else {
        ctx.dataVerification.dataRegulation = {
          type: "dropdown",
          type2: "",
          rangeTxt: rangeT,
          value1: "",
          value2: "",
          validity: "",
          remote: false,
          prohibitInput: false,
          hintShow: false,
          hintValue: ""
        };
      }
    });
  }, []);
  return /*#__PURE__*/react.createElement("div", {
    id: "fortune-data-verification"
  }, /*#__PURE__*/react.createElement("div", {
    className: "title"
  }, toolbar.dataVerification), /*#__PURE__*/react.createElement("div", {
    className: "box"
  }, /*#__PURE__*/react.createElement("div", {
    className: "box-item",
    style: {
      borderTop: "1px solid #E1E4E8"
    }
  }, /*#__PURE__*/react.createElement("div", {
    className: "box-item-title"
  }, dataVerification.cellRange), /*#__PURE__*/react.createElement("div", {
    className: "data-verification-range"
  }, /*#__PURE__*/react.createElement("input", {
    className: "formulaInputFocus",
    spellCheck: "false",
    value: (_context$dataVerifica = context.dataVerification.dataRegulation) === null || _context$dataVerifica === void 0 ? void 0 : _context$dataVerifica.rangeTxt,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.dataVerification.dataRegulation.rangeTxt = value;
      });
    }
  }), /*#__PURE__*/react.createElement("i", {
    className: "icon",
    "aria-hidden": "true",
    onClick: function onClick() {
      hideDialog();
      dataSelectRange("rangeTxt", context.dataVerification.dataRegulation.value1);
    },
    tabIndex: 0
  }, /*#__PURE__*/react.createElement(SVGIcon, {
    name: "tab",
    width: 18
  })))), /*#__PURE__*/react.createElement("div", {
    className: "box-item"
  }, /*#__PURE__*/react.createElement("div", {
    className: "box-item-title"
  }, dataVerification.verificationCondition), /*#__PURE__*/react.createElement("select", {
    className: "data-verification-type-select",
    value: context.dataVerification.dataRegulation.type,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.dataVerification.dataRegulation.type = value;
        if (value === "dropdown" || value === "checkbox") {
          ctx.dataVerification.dataRegulation.type2 = "";
        } else if (value === "number" || value === "number_integer" || value === "number_decimal" || value === "text_length" || value === "date") {
          ctx.dataVerification.dataRegulation.type2 = "between";
        } else if (value === "text_content") {
          ctx.dataVerification.dataRegulation.type2 = "include";
        } else if (value === "validity") {
          ctx.dataVerification.dataRegulation.type2 = "identificationNumber";
        }
        ctx.dataVerification.dataRegulation.value1 = "";
        ctx.dataVerification.dataRegulation.value2 = "";
      });
    }
  }, ["dropdown", "checkbox", "number", "number_integer", "number_decimal", "text_content", "text_length", "date", "validity"].map(function (v) {
    return /*#__PURE__*/react.createElement("option", {
      value: v,
      key: v
    }, dataVerification[v]);
  })), ((_context$dataVerifica2 = context.dataVerification) === null || _context$dataVerifica2 === void 0 ? void 0 : (_context$dataVerifica3 = _context$dataVerifica2.dataRegulation) === null || _context$dataVerifica3 === void 0 ? void 0 : _context$dataVerifica3.type) === "dropdown" && /*#__PURE__*/react.createElement("div", {
    className: "show-box-item"
  }, /*#__PURE__*/react.createElement("div", {
    className: "data-verification-range"
  }, /*#__PURE__*/react.createElement("input", {
    className: "formulaInputFocus",
    spellCheck: "false",
    value: context.dataVerification.dataRegulation.value1,
    placeholder: dataVerification.placeholder1,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.dataVerification.dataRegulation.value1 = value;
      });
    }
  }), /*#__PURE__*/react.createElement("i", {
    className: "icon",
    "aria-hidden": "true",
    onClick: function onClick() {
      return dataSelectRange("dropDown", context.dataVerification.dataRegulation.value1);
    },
    tabIndex: 0
  }, /*#__PURE__*/react.createElement(SVGIcon, {
    name: "tab",
    width: 18
  }))), /*#__PURE__*/react.createElement("div", {
    className: "check"
  }, /*#__PURE__*/react.createElement("input", {
    type: "checkbox",
    checked: context.dataVerification.dataRegulation.type2 === "true",
    id: "mul",
    onChange: function onChange(e) {
      var checked = e.target.checked;
      setContext(function (ctx) {
        ctx.dataVerification.dataRegulation.type2 = "".concat(checked);
      });
    }
  }), /*#__PURE__*/react.createElement("label", {
    htmlFor: "mul"
  }, dataVerification.allowMultiSelect))), ((_context$dataVerifica4 = context.dataVerification) === null || _context$dataVerifica4 === void 0 ? void 0 : (_context$dataVerifica5 = _context$dataVerifica4.dataRegulation) === null || _context$dataVerifica5 === void 0 ? void 0 : _context$dataVerifica5.type) === "checkbox" && /*#__PURE__*/react.createElement("div", {
    className: "show-box-item"
  }, /*#__PURE__*/react.createElement("div", {
    className: "check-box"
  }, /*#__PURE__*/react.createElement("span", null, dataVerification.selected, " \u2014\u2014 "), /*#__PURE__*/react.createElement("input", {
    type: "text",
    className: "data-verification-value1",
    placeholder: dataVerification.placeholder2,
    value: (_context$dataVerifica6 = context.dataVerification) === null || _context$dataVerifica6 === void 0 ? void 0 : (_context$dataVerifica7 = _context$dataVerifica6.dataRegulation) === null || _context$dataVerifica7 === void 0 ? void 0 : _context$dataVerifica7.value1,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.dataVerification.dataRegulation.value1 = value;
      });
    }
  })), /*#__PURE__*/react.createElement("div", {
    className: "check-box"
  }, /*#__PURE__*/react.createElement("span", null, dataVerification.notSelected, " \u2014\u2014 "), /*#__PURE__*/react.createElement("input", {
    type: "text",
    className: "data-verification-value2",
    placeholder: dataVerification.placeholder2,
    value: (_context$dataVerifica8 = context.dataVerification) === null || _context$dataVerifica8 === void 0 ? void 0 : (_context$dataVerifica9 = _context$dataVerifica8.dataRegulation) === null || _context$dataVerifica9 === void 0 ? void 0 : _context$dataVerifica9.value2,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.dataVerification.dataRegulation.value2 = value;
      });
    }
  }))), (((_context$dataVerifica10 = context.dataVerification) === null || _context$dataVerifica10 === void 0 ? void 0 : (_context$dataVerifica11 = _context$dataVerifica10.dataRegulation) === null || _context$dataVerifica11 === void 0 ? void 0 : _context$dataVerifica11.type) === "number" || ((_context$dataVerifica12 = context.dataVerification) === null || _context$dataVerifica12 === void 0 ? void 0 : (_context$dataVerifica13 = _context$dataVerifica12.dataRegulation) === null || _context$dataVerifica13 === void 0 ? void 0 : _context$dataVerifica13.type) === "number_integer" || ((_context$dataVerifica14 = context.dataVerification) === null || _context$dataVerifica14 === void 0 ? void 0 : (_context$dataVerifica15 = _context$dataVerifica14.dataRegulation) === null || _context$dataVerifica15 === void 0 ? void 0 : _context$dataVerifica15.type) === "number_decimal" || ((_context$dataVerifica16 = context.dataVerification) === null || _context$dataVerifica16 === void 0 ? void 0 : (_context$dataVerifica17 = _context$dataVerifica16.dataRegulation) === null || _context$dataVerifica17 === void 0 ? void 0 : _context$dataVerifica17.type) === "text_length") && /*#__PURE__*/react.createElement("div", {
    className: "show-box-item"
  }, /*#__PURE__*/react.createElement("select", {
    className: "data-verification-type-select",
    value: context.dataVerification.dataRegulation.type2,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.dataVerification.dataRegulation.type2 = value;
        ctx.dataVerification.dataRegulation.value1 = "";
        ctx.dataVerification.dataRegulation.value2 = "";
      });
    }
  }, numberCondition.map(function (v) {
    return /*#__PURE__*/react.createElement("option", {
      value: v,
      key: v
    }, dataVerification[v]);
  })), context.dataVerification.dataRegulation.type2 === "between" || context.dataVerification.dataRegulation.type2 === "notBetween" ? /*#__PURE__*/react.createElement("div", {
    className: "input-box"
  }, /*#__PURE__*/react.createElement("input", {
    type: "number",
    placeholder: "1",
    value: context.dataVerification.dataRegulation.value1,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.dataVerification.dataRegulation.value1 = value;
      });
    }
  }), /*#__PURE__*/react.createElement("span", null, "-"), /*#__PURE__*/react.createElement("input", {
    type: "number",
    placeholder: "100",
    value: context.dataVerification.dataRegulation.value2,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.dataVerification.dataRegulation.value2 = value;
      });
    }
  })) : /*#__PURE__*/react.createElement("div", {
    className: "input-box"
  }, /*#__PURE__*/react.createElement("input", {
    type: "number",
    style: {
      width: "100%"
    },
    placeholder: dataVerification.placeholder3,
    value: context.dataVerification.dataRegulation.value1,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.dataVerification.dataRegulation.value1 = value;
      });
    }
  }))), ((_context$dataVerifica18 = context.dataVerification) === null || _context$dataVerifica18 === void 0 ? void 0 : (_context$dataVerifica19 = _context$dataVerifica18.dataRegulation) === null || _context$dataVerifica19 === void 0 ? void 0 : _context$dataVerifica19.type) === "text_content" && /*#__PURE__*/react.createElement("div", {
    className: "show-box-item"
  }, /*#__PURE__*/react.createElement("select", {
    className: "data-verification-type-select",
    value: context.dataVerification.dataRegulation.type2,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.dataVerification.dataRegulation.type2 = value;
        ctx.dataVerification.dataRegulation.value1 = "";
        ctx.dataVerification.dataRegulation.value2 = "";
      });
    }
  }, ["include", "exclude", "equal"].map(function (v) {
    return /*#__PURE__*/react.createElement("option", {
      value: v,
      key: v
    }, dataVerification[v]);
  })), /*#__PURE__*/react.createElement("div", {
    className: "input-box"
  }, /*#__PURE__*/react.createElement("input", {
    type: "text",
    style: {
      width: "100%"
    },
    placeholder: dataVerification.placeholder4,
    value: context.dataVerification.dataRegulation.value1,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.dataVerification.dataRegulation.value1 = value;
      });
    }
  }))), ((_context$dataVerifica20 = context.dataVerification) === null || _context$dataVerifica20 === void 0 ? void 0 : (_context$dataVerifica21 = _context$dataVerifica20.dataRegulation) === null || _context$dataVerifica21 === void 0 ? void 0 : _context$dataVerifica21.type) === "date" && /*#__PURE__*/react.createElement("div", {
    className: "show-box-item"
  }, /*#__PURE__*/react.createElement("select", {
    className: "data-verification-type-select",
    value: context.dataVerification.dataRegulation.type2,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.dataVerification.dataRegulation.type2 = value;
        ctx.dataVerification.dataRegulation.value1 = "";
        ctx.dataVerification.dataRegulation.value2 = "";
      });
    }
  }, dateCondition.map(function (v) {
    return /*#__PURE__*/react.createElement("option", {
      value: v,
      key: v
    }, dataVerification[v]);
  })), context.dataVerification.dataRegulation.type2 === "between" || context.dataVerification.dataRegulation.type2 === "notBetween" ? /*#__PURE__*/react.createElement("div", {
    className: "input-box"
  }, /*#__PURE__*/react.createElement("input", {
    type: "date",
    placeholder: "1",
    value: context.dataVerification.dataRegulation.value1,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.dataVerification.dataRegulation.value1 = value;
      });
    }
  }), /*#__PURE__*/react.createElement("span", null, "-"), /*#__PURE__*/react.createElement("input", {
    type: "date",
    placeholder: "100",
    value: context.dataVerification.dataRegulation.value2,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.dataVerification.dataRegulation.value2 = value;
      });
    }
  })) : /*#__PURE__*/react.createElement("div", {
    className: "input-box"
  }, /*#__PURE__*/react.createElement("input", {
    type: "date",
    style: {
      width: "100%"
    },
    placeholder: dataVerification.placeholder3,
    value: context.dataVerification.dataRegulation.value1,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.dataVerification.dataRegulation.value1 = value;
      });
    }
  }))), ((_context$dataVerifica22 = context.dataVerification) === null || _context$dataVerifica22 === void 0 ? void 0 : (_context$dataVerifica23 = _context$dataVerifica22.dataRegulation) === null || _context$dataVerifica23 === void 0 ? void 0 : _context$dataVerifica23.type) === "validity" && /*#__PURE__*/react.createElement("div", {
    className: "show-box-item"
  }, /*#__PURE__*/react.createElement("select", {
    className: "data-verification-type-select",
    value: context.dataVerification.dataRegulation.type2,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.dataVerification.dataRegulation.type2 = value;
        ctx.dataVerification.dataRegulation.value1 = "";
        ctx.dataVerification.dataRegulation.value2 = "";
      });
    }
  }, ["identificationNumber", "phoneNumber"].map(function (v) {
    return /*#__PURE__*/react.createElement("option", {
      value: v,
      key: v
    }, dataVerification[v]);
  })))), /*#__PURE__*/react.createElement("div", {
    className: "box-item"
  }, ["prohibitInput", "hintShow"].map(function (v) {
    return /*#__PURE__*/react.createElement("div", {
      className: "check",
      key: "div".concat(v)
    }, /*#__PURE__*/react.createElement("input", {
      type: "checkbox",
      id: v,
      key: "input".concat(v),
      checked: context.dataVerification.dataRegulation[v],
      onChange: function onChange() {
        setContext(function (ctx) {
          var _ctx$dataVerification5;
          var dataRegulation = (_ctx$dataVerification5 = ctx.dataVerification) === null || _ctx$dataVerification5 === void 0 ? void 0 : _ctx$dataVerification5.dataRegulation;
          if (v === "prohibitInput") {
            dataRegulation.prohibitInput = !dataRegulation.prohibitInput;
          } else if (v === "hintShow") {
            dataRegulation.hintShow = !dataRegulation.hintShow;
          }
        });
      }
    }), /*#__PURE__*/react.createElement("label", {
      htmlFor: v,
      key: "label".concat(v)
    }, dataVerification[v]));
  }), ((_context$dataVerifica24 = context.dataVerification) === null || _context$dataVerifica24 === void 0 ? void 0 : (_context$dataVerifica25 = _context$dataVerifica24.dataRegulation) === null || _context$dataVerifica25 === void 0 ? void 0 : _context$dataVerifica25.hintShow) && /*#__PURE__*/react.createElement("div", {
    className: "input-box"
  }, /*#__PURE__*/react.createElement("input", {
    type: "text",
    style: {
      width: "100%"
    },
    placeholder: dataVerification.placeholder5,
    value: context.dataVerification.dataRegulation.hintValue,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.dataVerification.dataRegulation.hintValue = value;
      });
    }
  })))), /*#__PURE__*/react.createElement("div", {
    className: "button-basic button-primary",
    onClick: function onClick() {
      btn("confirm");
    },
    tabIndex: 0
  }, button.confirm), /*#__PURE__*/react.createElement("div", {
    className: "button-basic button-close",
    onClick: function onClick() {
      btn("delete");
    },
    tabIndex: 0
  }, dataVerification.deleteVerification), /*#__PURE__*/react.createElement("div", {
    className: "button-basic button-close",
    onClick: function onClick() {
      btn("close");
    },
    tabIndex: 0
  }, button.cancel));
};
var ConditionRules = function ConditionRules(_ref) {
  var type = _ref.type;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext;
  var _useDialog = useDialog(),
    hideDialog = _useDialog.hideDialog;
  var _locale = locale(context),
    conditionformat = _locale.conditionformat,
    button = _locale.button,
    protection = _locale.protection,
    generalDialog = _locale.generalDialog;
  var _useState = (0,react.useState)({
      textColor: "#000000",
      cellColor: "#000000"
    }),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    colorRules = _useState2[0],
    setColorRules = _useState2[1];
  var close = (0,react.useCallback)(function (closeType) {
    if (closeType === "confirm") {
      setContext(function (ctx) {
        ctx.conditionRules.textColor.color = colorRules.textColor;
        ctx.conditionRules.cellColor.color = colorRules.cellColor;
        setConditionRules(ctx, protection, generalDialog, conditionformat, ctx.conditionRules);
      });
    }
    setContext(function (ctx) {
      ctx.conditionRules = {
        rulesType: "",
        rulesValue: "",
        textColor: {
          check: true,
          color: "#000000"
        },
        cellColor: {
          check: true,
          color: "#000000"
        },
        betweenValue: {
          value1: "",
          value2: ""
        },
        dateValue: "",
        repeatValue: "0",
        projectValue: "10"
      };
    });
    hideDialog();
  }, [colorRules, conditionformat, generalDialog, hideDialog, protection, setContext]);
  (0,react.useEffect)(function () {
    setContext(function (ctx) {
      ctx.conditionRules.rulesType = type;
      if (!ctx.rangeDialog) return;
      var rangeDialogType = ctx.rangeDialog.type;
      var rangeT = ctx.rangeDialog.rangeTxt;
      if (rangeDialogType === "conditionRulesbetween1") {
        ctx.conditionRules.betweenValue.value1 = rangeT;
      } else if (rangeDialogType === "conditionRulesbetween2") {
        ctx.conditionRules.betweenValue.value2 = rangeT;
      } else if (rangeDialogType.indexOf("conditionRules") >= 0) {
        ctx.conditionRules.rulesValue = rangeT;
      } else if (rangeDialogType === "") {
        ctx.conditionRules = {
          rulesType: type,
          rulesValue: "",
          textColor: {
            check: true,
            color: "#000000"
          },
          cellColor: {
            check: true,
            color: "#000000"
          },
          betweenValue: {
            value1: "",
            value2: ""
          },
          dateValue: "",
          repeatValue: "0",
          projectValue: "10"
        };
      }
      ctx.rangeDialog.type = "";
      ctx.rangeDialog.rangeTxt = "";
    });
  }, []);
  return /*#__PURE__*/react.createElement("div", {
    className: "condition-rules"
  }, /*#__PURE__*/react.createElement("div", {
    className: "condition-rules-title"
  }, conditionformat["conditionformat_".concat(type)]), /*#__PURE__*/react.createElement("div", {
    className: "conditin-rules-value"
  }, conditionformat["conditionformat_".concat(type, "_title")]), (type === "greaterThan" || type === "lessThan" || type === "equal" || type === "textContains") && /*#__PURE__*/react.createElement("div", {
    className: "condition-rules-inpbox"
  }, /*#__PURE__*/react.createElement("input", {
    className: "condition-rules-input",
    type: "text",
    value: context.conditionRules.rulesValue,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.conditionRules.rulesValue = value;
      });
    }
  })), type === "between" && /*#__PURE__*/react.createElement("div", {
    className: "condition-rules-between-box"
  }, /*#__PURE__*/react.createElement("div", {
    className: "condition-rules-between-inpbox"
  }, /*#__PURE__*/react.createElement("input", {
    className: "condition-rules-between-input",
    type: "text",
    value: context.conditionRules.betweenValue.value1,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.conditionRules.betweenValue.value1 = value;
      });
    }
  })), /*#__PURE__*/react.createElement("span", {
    style: {
      margin: "0px 4px"
    }
  }, conditionformat.to), /*#__PURE__*/react.createElement("div", {
    className: "condition-rules-between-inpbox"
  }, /*#__PURE__*/react.createElement("input", {
    className: "condition-rules-between-input",
    type: "text",
    value: context.conditionRules.betweenValue.value2,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.conditionRules.betweenValue.value2 = value;
      });
    }
  }))), type === "occurrenceDate" && /*#__PURE__*/react.createElement("div", {
    className: "condition-rules-inpbox"
  }, /*#__PURE__*/react.createElement("input", {
    type: "date",
    className: "condition-rules-date",
    value: context.conditionRules.dateValue,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.conditionRules.dateValue = value;
      });
    }
  })), type === "duplicateValue" && /*#__PURE__*/react.createElement("select", {
    className: "condition-rules-select",
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.conditionRules.repeatValue = value;
      });
    }
  }, /*#__PURE__*/react.createElement("option", {
    value: "0"
  }, conditionformat.duplicateValue), /*#__PURE__*/react.createElement("option", {
    value: "1"
  }, conditionformat.uniqueValue)), (type === "top10" || type === "top10_percent" || type === "last10" || type === "last10_percent") && /*#__PURE__*/react.createElement("div", {
    className: "condition-rules-project-box"
  }, type === "top10" || type === "top10_percent" ? conditionformat.top : conditionformat.last, /*#__PURE__*/react.createElement("input", {
    className: "condition-rules-project-input",
    type: "number",
    value: context.conditionRules.projectValue,
    onChange: function onChange(e) {
      var value = e.target.value;
      setContext(function (ctx) {
        ctx.conditionRules.projectValue = value;
      });
    }
  }), type === "top10" || type === "last10" ? conditionformat.oneself : "%"), /*#__PURE__*/react.createElement("div", {
    className: "condition-rules-set-title"
  }, "".concat(conditionformat.setAs, "\uFF1A")), /*#__PURE__*/react.createElement("div", {
    className: "condition-rules-setbox"
  }, /*#__PURE__*/react.createElement("div", {
    className: "condition-rules-set"
  }, /*#__PURE__*/react.createElement("div", {
    className: "condition-rules-color"
  }, /*#__PURE__*/react.createElement("input", {
    id: "checkTextColor",
    type: "checkbox",
    className: "condition-rules-check",
    checked: context.conditionRules.textColor.check,
    onChange: function onChange(e) {
      var checked = e.target.checked;
      setContext(function (ctx) {
        ctx.conditionRules.textColor.check = checked;
      });
    }
  }), /*#__PURE__*/react.createElement("label", {
    htmlFor: "checkTextColor",
    className: "condition-rules-label"
  }, conditionformat.textColor), /*#__PURE__*/react.createElement("input", {
    type: "color",
    className: "condition-rules-select-color",
    value: colorRules.textColor,
    onChange: function onChange(e) {
      var value = e.target.value;
      setColorRules((0,immer_esm/* default */.ZP)(function (draft) {
        draft.textColor = value;
      }));
    }
  }))), /*#__PURE__*/react.createElement("div", {
    className: "condition-rules-set"
  }, /*#__PURE__*/react.createElement("div", {
    className: "condition-rules-color"
  }, /*#__PURE__*/react.createElement("input", {
    id: "checkCellColor",
    type: "checkbox",
    className: "condition-rules-check",
    checked: context.conditionRules.cellColor.check,
    onChange: function onChange(e) {
      var checked = e.target.checked;
      setContext(function (ctx) {
        ctx.conditionRules.cellColor.check = checked;
      });
    }
  }), /*#__PURE__*/react.createElement("label", {
    htmlFor: "checkCellColor",
    className: "condition-rules-label"
  }, conditionformat.cellColor), /*#__PURE__*/react.createElement("input", {
    type: "color",
    className: "condition-rules-select-color",
    value: colorRules.cellColor,
    onChange: function onChange(e) {
      var value = e.target.value;
      setColorRules((0,immer_esm/* default */.ZP)(function (draft) {
        draft.cellColor = value;
      }));
    }
  })))), /*#__PURE__*/react.createElement("div", {
    className: "button-basic button-primary",
    onClick: function onClick() {
      close("confirm");
    },
    tabIndex: 0
  }, button.confirm), /*#__PURE__*/react.createElement("div", {
    className: "button-basic button-close",
    onClick: function onClick() {
      close("close");
    },
    tabIndex: 0
  }, button.cancel));
};
var RangeDialog = function RangeDialog() {
  var _context$rangeDialog$, _context$rangeDialog;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext;
  var _useDialog = useDialog(),
    showDialog = _useDialog.showDialog;
  var _locale = locale(context),
    dataVerification = _locale.dataVerification,
    button = _locale.button;
  var _useState = (0,react.useState)((_context$rangeDialog$ = (_context$rangeDialog = context.rangeDialog) === null || _context$rangeDialog === void 0 ? void 0 : _context$rangeDialog.rangeTxt) !== null && _context$rangeDialog$ !== void 0 ? _context$rangeDialog$ : ""),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    rangeTxt2 = _useState2[0],
    setRangeTxt2 = _useState2[1];
  var close = (0,react.useCallback)(function () {
    setContext(function (ctx) {
      ctx.rangeDialog.show = false;
      ctx.rangeDialog.singleSelect = false;
    });
    if (!context.rangeDialog) return;
    var rangeDialogType = context.rangeDialog.type;
    if (rangeDialogType.indexOf("between") >= 0) {
      showDialog(/*#__PURE__*/react.createElement(ConditionRules, {
        type: "between"
      }));
      return;
    }
    if (rangeDialogType.indexOf("conditionRules") >= 0) {
      var rulesType = rangeDialogType.substring("conditionRules".length, rangeDialogType.length);
      showDialog(/*#__PURE__*/react.createElement(ConditionRules, {
        type: rulesType
      }));
      return;
    }
    showDialog(/*#__PURE__*/react.createElement(DataVerification, null));
  }, [context.rangeDialog, setContext, showDialog]);
  (0,react.useEffect)(function () {
    setRangeTxt2(function (r) {
      if (context.luckysheet_select_save) {
        var range = context.luckysheet_select_save[context.luckysheet_select_save.length - 1];
        r = getRangetxt(context, context.currentSheetId, range, context.currentSheetId);
        return r;
      }
      return "";
    });
  }, [context, context.luckysheet_select_save]);
  return /*#__PURE__*/react.createElement("div", {
    id: "range-dialog",
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onChange: function onChange(e) {
      return e.stopPropagation();
    },
    onKeyDown: function onKeyDown(e) {
      return e.stopPropagation();
    },
    onMouseDown: function onMouseDown(e) {
      return e.stopPropagation();
    },
    onMouseUp: function onMouseUp(e) {
      return e.stopPropagation();
    },
    tabIndex: 0
  }, /*#__PURE__*/react.createElement("div", {
    className: "dialog-title"
  }, dataVerification.selectCellRange), /*#__PURE__*/react.createElement("input", {
    readOnly: true,
    placeholder: dataVerification.selectCellRange2,
    value: rangeTxt2
  }), /*#__PURE__*/react.createElement("div", {
    className: "button-basic button-primary",
    style: {
      marginLeft: "6px"
    },
    onClick: function onClick() {
      setContext(function (ctx) {
        ctx.rangeDialog.rangeTxt = rangeTxt2;
      });
      close();
    },
    tabIndex: 0
  }, button.confirm), /*#__PURE__*/react.createElement("div", {
    className: "button-basic button-close",
    onClick: function onClick() {
      close();
    },
    tabIndex: 0
  }, button.close));
};
function useOutsideClick(containerRef, handler, deps) {
  (0,react.useEffect)(function () {
    function handleClickOutside(e) {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        handler();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, deps);
}
var DropDownList = function DropDownList() {
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext;
  var containerRef = (0,react.useRef)(null);
  var _useState = (0,react.useState)([]),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    list = _useState2[0],
    setList = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    isMul = _useState4[0],
    setIsMul = _useState4[1];
  var _useState5 = (0,react.useState)(),
    _useState6 = dist_index_esm_slicedToArray(_useState5, 2),
    position = _useState6[0],
    setPosition = _useState6[1];
  var _useState7 = (0,react.useState)([]),
    _useState8 = dist_index_esm_slicedToArray(_useState7, 2),
    selected = _useState8[0],
    setSelected = _useState8[1];
  var close = (0,react.useCallback)(function () {
    setContext(function (ctx) {
      ctx.dataVerificationDropDownList = false;
    });
  }, [setContext]);
  useOutsideClick(containerRef, close, [close]);
  (0,react.useEffect)(function () {
    if (!context.luckysheet_select_save) return;
    var last = context.luckysheet_select_save[context.luckysheet_select_save.length - 1];
    var rowIndex = last.row_focus;
    var colIndex = last.column_focus;
    if (rowIndex == null || colIndex == null) return;
    var row = context.visibledatarow[rowIndex];
    var col_pre = colIndex === 0 ? 0 : context.visibledatacolumn[colIndex - 1];
    var d = getFlowdata(context);
    if (!d) return;
    var margeSet = mergeBorder(context, d, rowIndex, colIndex);
    if (margeSet) {
      var _margeSet$row = dist_index_esm_slicedToArray(margeSet.row, 2);
      row = _margeSet$row[1];
      var _margeSet$column = dist_index_esm_slicedToArray(margeSet.column, 2);
      col_pre = _margeSet$column[0];
    }
    var index = getSheetIndex(context, context.currentSheetId);
    var dataVerification = context.luckysheetfile[index].dataVerification;
    var item = dataVerification["".concat(rowIndex, "_").concat(colIndex)];
    var dropdownList = getDropdownList(context, item.value1);
    var cellValue = getCellValue(rowIndex, colIndex, d);
    if (cellValue) {
      setSelected(cellValue.toString().split(","));
    }
    setList(dropdownList);
    setPosition({
      left: col_pre,
      top: row
    });
    setIsMul(item.type2 === "true");
  }, []);
  (0,react.useEffect)(function () {
    if (!context.luckysheet_select_save) return;
    var last = context.luckysheet_select_save[context.luckysheet_select_save.length - 1];
    var rowIndex = last.row_focus;
    var colIndex = last.column_focus;
    if (rowIndex == null || colIndex == null) return;
    var index = getSheetIndex(context, context.currentSheetId);
    var dataVerification = context.luckysheetfile[index].dataVerification;
    var item = dataVerification["".concat(rowIndex, "_").concat(colIndex)];
    if (item.type2 !== "true") return;
    var d = getFlowdata(context);
    if (!d) return;
    var cellValue = getCellValue(rowIndex, colIndex, d);
    if (cellValue) {
      setSelected(cellValue.toString().split(","));
    }
  }, [context.luckysheetfile]);
  return /*#__PURE__*/react.createElement("div", {
    id: "luckysheet-dataVerification-dropdown-List",
    style: position,
    ref: containerRef,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onChange: function onChange(e) {
      return e.stopPropagation();
    },
    onKeyDown: function onKeyDown(e) {
      return e.stopPropagation();
    },
    onMouseDown: function onMouseDown(e) {
      return e.stopPropagation();
    },
    onMouseUp: function onMouseUp(e) {
      return e.stopPropagation();
    },
    tabIndex: 0
  }, list.map(function (v, i) {
    return /*#__PURE__*/react.createElement("div", {
      className: "dropdown-List-item",
      key: i,
      onClick: function onClick() {
        setContext(function (ctx) {
          var arr = selected;
          var index = arr.indexOf(v);
          if (index < 0) {
            arr.push(v);
          } else {
            arr.splice(index, 1);
          }
          setSelected(arr);
          setDropcownValue(ctx, v, arr);
        });
      },
      tabIndex: 0
    }, /*#__PURE__*/react.createElement(SVGIcon, {
      name: "check",
      width: 12,
      style: {
        verticalAlign: "middle",
        display: isMul && selected.indexOf(v) >= 0 ? "inline" : "none"
      }
    }), v);
  }));
};
var SheetOverlay = function SheetOverlay() {
  var _refs$cellArea$curren, _refs$cellArea$curren2, _context$luckysheet_s, _context$luckysheet_s2, _context$luckysheet_s3, _context$luckysheet_s4, _context$luckysheet_s5, _context$luckysheet_s6, _context$presences$le, _context$presences, _context$linkCard, _context$rangeDialog;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    settings = _useContext.settings,
    refs = _useContext.refs;
  var _locale = locale(context),
    info = _locale.info,
    rightclick = _locale.rightclick;
  var _useDialog = useDialog(),
    showDialog = _useDialog.showDialog;
  var containerRef = (0,react.useRef)(null);
  var bottomAddRowInputRef = (0,react.useRef)(null);
  var dataVerificationHintBoxRef = (0,react.useRef)(null);
  var _useAlert = useAlert(),
    showAlert = _useAlert.showAlert;
  var cellAreaMouseDown = (0,react.useCallback)(function (e) {
    var nativeEvent = e.nativeEvent;
    if (e.button !== 2) {
      setContext(function (draftCtx) {
        var _draftCtx$luckysheet_;
        handleCellAreaMouseDown(draftCtx, refs.globalCache, nativeEvent, refs.cellInput.current, refs.cellArea.current, refs.fxInput.current, refs.canvas.current.getContext("2d"));
        if (!lodash_default().isEmpty((_draftCtx$luckysheet_ = draftCtx.luckysheet_select_save) === null || _draftCtx$luckysheet_ === void 0 ? void 0 : _draftCtx$luckysheet_[0]) && refs.cellInput.current) {
          setTimeout(function () {
            var _refs$cellInput$curre;
            (_refs$cellInput$curre = refs.cellInput.current) === null || _refs$cellInput$curre === void 0 ? void 0 : _refs$cellInput$curre.focus();
          });
        }
      });
    }
  }, [setContext, refs.globalCache, refs.cellInput, refs.cellArea, refs.fxInput, refs.canvas]);
  var cellAreaContextMenu = (0,react.useCallback)(function (e) {
    var nativeEvent = e.nativeEvent;
    setContext(function (draftCtx) {
      handleContextMenu(draftCtx, settings, nativeEvent, refs.workbookContainer.current, refs.cellArea.current, "cell");
    });
  }, [refs.workbookContainer, setContext, settings, refs.cellArea]);
  var cellAreaDoubleClick = (0,react.useCallback)(function (e) {
    var nativeEvent = e.nativeEvent;
    setContext(function (draftCtx) {
      handleCellAreaDoubleClick(draftCtx, refs.globalCache, settings, nativeEvent, refs.cellArea.current);
    });
  }, [refs.cellArea, refs.globalCache, setContext, settings]);
  var onLeftTopClick = (0,react.useCallback)(function () {
    setContext(function (draftCtx) {
      selectAll(draftCtx);
    });
  }, [setContext]);
  var debouncedShowLinkCard = (0,react.useMemo)(function () {
    return lodash_default().debounce(function (globalCache, r, c, isEditing) {
      var _globalCache$linkCard;
      var skip = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      if (skip || ((_globalCache$linkCard = globalCache.linkCard) === null || _globalCache$linkCard === void 0 ? void 0 : _globalCache$linkCard.mouseEnter)) return;
      setContext(function (draftCtx) {
        showLinkCard(draftCtx, r, c, isEditing);
      });
    }, 800);
  }, [setContext]);
  var overShowLinkCard = (0,react.useCallback)(function (ctx, globalCache, e, container, scrollX, scrollY) {
    var rc = getCellRowColumn(ctx, e, container, scrollX, scrollY);
    if (rc == null) return;
    var link = getCellHyperlink(ctx, rc.r, rc.c);
    if (link == null) {
      debouncedShowLinkCard(globalCache, rc.r, rc.c, false);
    } else {
      showLinkCard(ctx, rc.r, rc.c, false);
      debouncedShowLinkCard(globalCache, rc.r, rc.c, false, true);
    }
  }, [debouncedShowLinkCard]);
  var onMouseMove = (0,react.useCallback)(function (nativeEvent) {
    setContext(function (draftCtx) {
      overShowLinkCard(draftCtx, refs.globalCache, nativeEvent, containerRef.current, refs.scrollbarX.current, refs.scrollbarY.current);
      handleOverlayMouseMove(draftCtx, refs.globalCache, nativeEvent, refs.cellInput.current, refs.scrollbarX.current, refs.scrollbarY.current, containerRef.current, refs.fxInput.current);
    });
  }, [overShowLinkCard, refs.cellInput, refs.fxInput, refs.globalCache, refs.scrollbarX, refs.scrollbarY, setContext]);
  var onMouseUp = (0,react.useCallback)(function (nativeEvent) {
    setContext(function (draftCtx) {
      try {
        handleOverlayMouseUp(draftCtx, refs.globalCache, settings, nativeEvent, refs.scrollbarX.current, refs.scrollbarY.current, containerRef.current, refs.cellInput.current, refs.fxInput.current);
      } catch (e) {
        showAlert(e.message);
      }
    });
  }, [refs.cellInput, refs.fxInput, refs.globalCache, refs.scrollbarX, refs.scrollbarY, setContext, settings, showAlert]);
  var onKeyDownForZoom = (0,react.useCallback)(function (ev) {
    var newZoom = handleKeydownForZoom(ev, context.zoomRatio);
    if (newZoom !== context.zoomRatio) {
      setContext(function (ctx) {
        ctx.zoomRatio = newZoom;
        ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)].zoomRatio = newZoom;
      });
    }
  }, [context.zoomRatio, setContext]);
  var onTouchStart = (0,react.useCallback)(function (e) {
    var nativeEvent = e.nativeEvent;
    setContext(function (draftContext) {
      handleOverlayTouchStart(draftContext, nativeEvent, refs.globalCache);
    });
    e.stopPropagation();
  }, [refs.globalCache, setContext]);
  var onTouchMove = (0,react.useCallback)(function (e) {
    var nativeEvent = e.nativeEvent;
    setContext(function (draftCtx) {
      handleOverlayTouchMove(draftCtx, nativeEvent, refs.globalCache, refs.scrollbarX.current, refs.scrollbarY.current);
    });
  }, [refs.globalCache, refs.scrollbarX, refs.scrollbarY, setContext]);
  var onTouchEnd = (0,react.useCallback)(function () {
    handleOverlayTouchEnd(refs.globalCache);
  }, [refs.globalCache]);
  var handleBottomAddRow = (0,react.useCallback)(function () {
    var _bottomAddRowInputRef;
    var valueStr = ((_bottomAddRowInputRef = bottomAddRowInputRef.current) === null || _bottomAddRowInputRef === void 0 ? void 0 : _bottomAddRowInputRef.value) || context.addDefaultRows.toString();
    var value = parseInt(valueStr, 10);
    if (Number.isNaN(value)) {
      return;
    }
    if (value < 1) {
      return;
    }
    var insertRowColOp = {
      type: "row",
      index: context.luckysheetfile[getSheetIndex(context, context.currentSheetId)].data.length - 1,
      count: value,
      direction: "rightbottom",
      id: context.currentSheetId
    };
    setContext(function (draftCtx) {
      try {
        insertRowCol(draftCtx, insertRowColOp, false);
      } catch (err) {
        if (err.message === "maxExceeded") showAlert(rightclick.rowOverLimit);
      }
    }, {
      insertRowColOp: insertRowColOp
    });
  }, [context, rightclick.rowOverLimit, setContext, showAlert]);
  (0,react.useEffect)(function () {
    if (context.warnDialog) {
      setTimeout(function () {
        showDialog(context.warnDialog, "ok");
      }, 240);
    }
  }, [context.warnDialog]);
  (0,react.useEffect)(function () {
    refs.cellArea.current.scrollLeft = context.scrollLeft;
    refs.cellArea.current.scrollTop = context.scrollTop;
  }, [context.scrollLeft, context.scrollTop, refs.cellArea, (_refs$cellArea$curren = refs.cellArea.current) === null || _refs$cellArea$curren === void 0 ? void 0 : _refs$cellArea$curren.scrollLeft, (_refs$cellArea$curren2 = refs.cellArea.current) === null || _refs$cellArea$curren2 === void 0 ? void 0 : _refs$cellArea$curren2.scrollTop]);
  (0,react.useLayoutEffect)(function () {
    if (context.commentBoxes || context.hoveredCommentBox || context.editingCommentBox) {
      var _context$commentBoxes;
      lodash_default().concat((_context$commentBoxes = context.commentBoxes) === null || _context$commentBoxes === void 0 ? void 0 : _context$commentBoxes.filter(function (v) {
        var _context$editingComme;
        return v.rc !== ((_context$editingComme = context.editingCommentBox) === null || _context$editingComme === void 0 ? void 0 : _context$editingComme.rc);
      }), [context.hoveredCommentBox, context.editingCommentBox]).forEach(function (box) {
        if (box) {
          drawArrow(box.rc, box.size);
        }
      });
    }
  }, [context.commentBoxes, context.hoveredCommentBox, context.editingCommentBox]);
  (0,react.useEffect)(function () {
    document.addEventListener("mousemove", onMouseMove);
    return function () {
      document.removeEventListener("mousemove", onMouseMove);
    };
  }, [onMouseMove]);
  (0,react.useEffect)(function () {
    document.addEventListener("mouseup", onMouseUp);
    return function () {
      document.removeEventListener("mouseup", onMouseUp);
    };
  }, [onMouseUp]);
  (0,react.useEffect)(function () {
    document.addEventListener("keydown", onKeyDownForZoom);
    return function () {
      document.removeEventListener("keydown", onKeyDownForZoom);
    };
  }, [onKeyDownForZoom]);
  return /*#__PURE__*/react.createElement("div", {
    className: "fortune-sheet-overlay",
    ref: containerRef,
    onTouchStart: onTouchStart,
    onTouchMove: onTouchMove,
    onTouchEnd: onTouchEnd,
    tabIndex: -1,
    style: {
      width: context.luckysheetTableContentHW[0],
      height: context.luckysheetTableContentHW[1]
    }
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-col-header-wrap"
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-left-top",
    onClick: onLeftTopClick,
    tabIndex: 0,
    style: {
      width: context.rowHeaderWidth - 1.5,
      height: context.columnHeaderHeight - 1.5
    }
  }), /*#__PURE__*/react.createElement(ColumnHeader, null)), (context.showSearch || context.showReplace) && /*#__PURE__*/react.createElement(SearchReplace, {
    getContainer: function getContainer() {
      return containerRef.current;
    }
  }), /*#__PURE__*/react.createElement("div", {
    className: "fortune-row-body"
  }, /*#__PURE__*/react.createElement(RowHeader, null), /*#__PURE__*/react.createElement(ScrollBar, {
    axis: "x"
  }), /*#__PURE__*/react.createElement(ScrollBar, {
    axis: "y"
  }), /*#__PURE__*/react.createElement("div", {
    ref: refs.cellArea,
    className: "fortune-cell-area",
    onMouseDown: cellAreaMouseDown,
    onDoubleClick: cellAreaDoubleClick,
    onContextMenu: cellAreaContextMenu,
    style: {
      width: context.cellmainWidth,
      height: context.cellmainHeight,
      cursor: context.luckysheet_cell_selected_extend ? "crosshair" : "default"
    }
  }, /*#__PURE__*/react.createElement("div", {
    id: "fortune-formula-functionrange"
  }), context.formulaRangeSelect && /*#__PURE__*/react.createElement("div", {
    className: "fortune-selection-copy fortune-formula-functionrange-select",
    style: context.formulaRangeSelect
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-selection-copy-top fortune-copy"
  }), /*#__PURE__*/react.createElement("div", {
    className: "fortune-selection-copy-right fortune-copy"
  }), /*#__PURE__*/react.createElement("div", {
    className: "fortune-selection-copy-bottom fortune-copy"
  }), /*#__PURE__*/react.createElement("div", {
    className: "fortune-selection-copy-left fortune-copy"
  }), /*#__PURE__*/react.createElement("div", {
    className: "fortune-selection-copy-hc"
  })), context.formulaRangeHighlight.map(function (v) {
    var rangeIndex = v.rangeIndex,
      backgroundColor = v.backgroundColor;
    return /*#__PURE__*/react.createElement("div", {
      key: rangeIndex,
      id: "fortune-formula-functionrange-highlight",
      className: "fortune-selection-highlight fortune-formula-functionrange-highlight",
      style: lodash_default().omit(v, "backgroundColor")
    }, ["top", "right", "bottom", "left"].map(function (d) {
      return /*#__PURE__*/react.createElement("div", {
        key: d,
        "data-type": d,
        className: "fortune-selection-copy-".concat(d, " fortune-copy"),
        style: {
          backgroundColor: backgroundColor
        }
      });
    }), /*#__PURE__*/react.createElement("div", {
      className: "fortune-selection-copy-hc",
      style: {
        backgroundColor: backgroundColor
      }
    }), ["lt", "rt", "lb", "rb"].map(function (d) {
      return /*#__PURE__*/react.createElement("div", {
        key: d,
        "data-type": d,
        className: "fortune-selection-highlight-".concat(d, " luckysheet-highlight"),
        style: {
          backgroundColor: backgroundColor
        }
      });
    }));
  }), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-row-count-show luckysheet-count-show",
    id: "luckysheet-row-count-show"
  }), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-column-count-show luckysheet-count-show",
    id: "luckysheet-column-count-show"
  }), /*#__PURE__*/react.createElement("div", {
    className: "fortune-change-size-line",
    hidden: !context.luckysheet_cols_change_size && !context.luckysheet_rows_change_size && !context.luckysheet_cols_freeze_drag && !context.luckysheet_rows_freeze_drag
  }), /*#__PURE__*/react.createElement("div", {
    className: "fortune-freeze-drag-line",
    hidden: !context.luckysheet_cols_freeze_drag && !context.luckysheet_rows_freeze_drag
  }), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-cell-selected-focus",
    style: ((_context$luckysheet_s = (_context$luckysheet_s2 = context.luckysheet_select_save) === null || _context$luckysheet_s2 === void 0 ? void 0 : _context$luckysheet_s2.length) !== null && _context$luckysheet_s !== void 0 ? _context$luckysheet_s : 0) > 0 ? function () {
      var _refs$globalCache$fre, _refs$globalCache$fre2;
      var selection = lodash_default().last(context.luckysheet_select_save);
      return lodash_default().assign({
        left: selection.left,
        top: selection.top,
        width: selection.width,
        height: selection.height,
        display: "block"
      }, fixRowStyleOverflowInFreeze(context, selection.row_focus || 0, selection.row_focus || 0, (_refs$globalCache$fre = refs.globalCache.freezen) === null || _refs$globalCache$fre === void 0 ? void 0 : _refs$globalCache$fre[context.currentSheetId]), fixColumnStyleOverflowInFreeze(context, selection.column_focus || 0, selection.column_focus || 0, (_refs$globalCache$fre2 = refs.globalCache.freezen) === null || _refs$globalCache$fre2 === void 0 ? void 0 : _refs$globalCache$fre2[context.currentSheetId]));
    }() : {},
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    }
  }), ((_context$luckysheet_s3 = (_context$luckysheet_s4 = context.luckysheet_selection_range) === null || _context$luckysheet_s4 === void 0 ? void 0 : _context$luckysheet_s4.length) !== null && _context$luckysheet_s3 !== void 0 ? _context$luckysheet_s3 : 0) > 0 && /*#__PURE__*/react.createElement("div", {
    id: "fortune-selection-copy"
  }, context.luckysheet_selection_range.map(function (range) {
    var r1 = range.row[0];
    var r2 = range.row[1];
    var c1 = range.column[0];
    var c2 = range.column[1];
    var row = context.visibledatarow[r2];
    var row_pre = r1 - 1 === -1 ? 0 : context.visibledatarow[r1 - 1];
    var col = context.visibledatacolumn[c2];
    var col_pre = c1 - 1 === -1 ? 0 : context.visibledatacolumn[c1 - 1];
    return /*#__PURE__*/react.createElement("div", {
      className: "fortune-selection-copy",
      key: "".concat(r1, "-").concat(r2, "-").concat(c1, "-").concat(c2),
      style: {
        left: col_pre,
        width: col - col_pre - 1,
        top: row_pre,
        height: row - row_pre - 1
      }
    }, /*#__PURE__*/react.createElement("div", {
      className: "fortune-selection-copy-top fortune-copy"
    }), /*#__PURE__*/react.createElement("div", {
      className: "fortune-selection-copy-right fortune-copy"
    }), /*#__PURE__*/react.createElement("div", {
      className: "fortune-selection-copy-bottom fortune-copy"
    }), /*#__PURE__*/react.createElement("div", {
      className: "fortune-selection-copy-left fortune-copy"
    }), /*#__PURE__*/react.createElement("div", {
      className: "fortune-selection-copy-hc"
    }));
  })), /*#__PURE__*/react.createElement("div", {
    id: "luckysheet-chart-rangeShow"
  }), /*#__PURE__*/react.createElement("div", {
    className: "fortune-cell-selected-extend"
  }), /*#__PURE__*/react.createElement("div", {
    className: "fortune-cell-selected-move",
    id: "fortune-cell-selected-move",
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    }
  }), ((_context$luckysheet_s5 = (_context$luckysheet_s6 = context.luckysheet_select_save) === null || _context$luckysheet_s6 === void 0 ? void 0 : _context$luckysheet_s6.length) !== null && _context$luckysheet_s5 !== void 0 ? _context$luckysheet_s5 : 0) > 0 && /*#__PURE__*/react.createElement("div", {
    id: "luckysheet-cell-selected-boxs"
  }, context.luckysheet_select_save.map(function (selection, index) {
    var _refs$globalCache$fre3, _refs$globalCache$fre4;
    return /*#__PURE__*/react.createElement("div", {
      key: index,
      id: "luckysheet-cell-selected",
      className: "luckysheet-cell-selected",
      style: lodash_default().assign({
        left: selection.left_move,
        top: selection.top_move,
        width: selection.width_move,
        height: selection.height_move,
        display: "block"
      }, fixRowStyleOverflowInFreeze(context, selection.row[0], selection.row[1], (_refs$globalCache$fre3 = refs.globalCache.freezen) === null || _refs$globalCache$fre3 === void 0 ? void 0 : _refs$globalCache$fre3[context.currentSheetId]), fixColumnStyleOverflowInFreeze(context, selection.column[0], selection.column[1], (_refs$globalCache$fre4 = refs.globalCache.freezen) === null || _refs$globalCache$fre4 === void 0 ? void 0 : _refs$globalCache$fre4[context.currentSheetId])),
      onMouseDown: function onMouseDown(e) {
        e.stopPropagation();
        var nativeEvent = e.nativeEvent;
        setContext(function (draftCtx) {
          onCellsMoveStart(draftCtx, refs.globalCache, nativeEvent, refs.scrollbarX.current, refs.scrollbarY.current, containerRef.current);
        });
      }
    }, /*#__PURE__*/react.createElement("div", {
      className: "luckysheet-cs-inner-border"
    }), /*#__PURE__*/react.createElement("div", {
      className: "luckysheet-cs-fillhandle",
      onMouseDown: function onMouseDown(e) {
        var nativeEvent = e.nativeEvent;
        setContext(function (draftContext) {
          createDropCellRange(draftContext, nativeEvent, containerRef.current);
        });
        e.stopPropagation();
      }
    }), /*#__PURE__*/react.createElement("div", {
      className: "luckysheet-cs-inner-border"
    }), /*#__PURE__*/react.createElement("div", {
      className: "luckysheet-cs-draghandle-top luckysheet-cs-draghandle",
      onMouseDown: function onMouseDown(e) {
        return e.preventDefault();
      }
    }), /*#__PURE__*/react.createElement("div", {
      className: "luckysheet-cs-draghandle-bottom luckysheet-cs-draghandle",
      onMouseDown: function onMouseDown(e) {
        return e.preventDefault();
      }
    }), /*#__PURE__*/react.createElement("div", {
      className: "luckysheet-cs-draghandle-left luckysheet-cs-draghandle",
      onMouseDown: function onMouseDown(e) {
        return e.preventDefault();
      }
    }), /*#__PURE__*/react.createElement("div", {
      className: "luckysheet-cs-draghandle-right luckysheet-cs-draghandle",
      onMouseDown: function onMouseDown(e) {
        return e.preventDefault();
      }
    }), /*#__PURE__*/react.createElement("div", {
      className: "luckysheet-cs-touchhandle luckysheet-cs-touchhandle-lt"
    }, /*#__PURE__*/react.createElement("div", {
      className: "luckysheet-cs-touchhandle-btn"
    })), /*#__PURE__*/react.createElement("div", {
      className: "luckysheet-cs-touchhandle luckysheet-cs-touchhandle-rb"
    }, /*#__PURE__*/react.createElement("div", {
      className: "luckysheet-cs-touchhandle-btn"
    })));
  })), ((_context$presences$le = (_context$presences = context.presences) === null || _context$presences === void 0 ? void 0 : _context$presences.length) !== null && _context$presences$le !== void 0 ? _context$presences$le : 0) > 0 && context.presences.map(function (presence, index) {
    if (presence.sheetId !== context.currentSheetId) {
      return null;
    }
    var _presence$selection = presence.selection,
      r = _presence$selection.r,
      c = _presence$selection.c,
      color = presence.color;
    var row_pre = r - 1 === -1 ? 0 : context.visibledatarow[r - 1];
    var col_pre = c - 1 === -1 ? 0 : context.visibledatacolumn[c - 1];
    var row = context.visibledatarow[r];
    var col = context.visibledatacolumn[c];
    var width = col - col_pre - 1;
    var height = row - row_pre - 1;
    var usernameStyle = {
      maxWidth: width + 1,
      backgroundColor: color
    };
    lodash_default().set(usernameStyle, r === 0 ? "top" : "bottom", height);
    return /*#__PURE__*/react.createElement("div", {
      key: (presence === null || presence === void 0 ? void 0 : presence.userId) || index,
      className: "fortune-presence-selection",
      style: {
        left: col_pre,
        top: row_pre - 2,
        width: width,
        height: height,
        borderColor: color,
        borderWidth: 1
      }
    }, /*#__PURE__*/react.createElement("div", {
      className: "fortune-presence-username",
      style: usernameStyle
    }, presence.username));
  }), ((_context$linkCard = context.linkCard) === null || _context$linkCard === void 0 ? void 0 : _context$linkCard.sheetId) === context.currentSheetId && /*#__PURE__*/react.createElement(LinkEditCard, index_esm_objectSpread2({}, context.linkCard)), ((_context$rangeDialog = context.rangeDialog) === null || _context$rangeDialog === void 0 ? void 0 : _context$rangeDialog.show) && /*#__PURE__*/react.createElement(RangeDialog, null), /*#__PURE__*/react.createElement(FilterOptions, {
    getContainer: function getContainer() {
      return containerRef.current;
    }
  }), /*#__PURE__*/react.createElement(InputBox, null), /*#__PURE__*/react.createElement(NotationBoxes, null), /*#__PURE__*/react.createElement("div", {
    id: "luckysheet-multipleRange-show"
  }), /*#__PURE__*/react.createElement("div", {
    id: "luckysheet-dynamicArray-hightShow"
  }), /*#__PURE__*/react.createElement(ImgBoxs, null), /*#__PURE__*/react.createElement("div", {
    id: "luckysheet-dataVerification-dropdown-btn",
    onClick: function onClick() {
      setContext(function (ctx) {
        ctx.dataVerificationDropDownList = true;
        dataVerificationHintBoxRef.current.style.display = "none";
      });
    },
    tabIndex: 0,
    style: {
      display: "none"
    }
  }, /*#__PURE__*/react.createElement(SVGIcon, {
    name: "combo-arrow",
    width: 16
  })), context.dataVerificationDropDownList && /*#__PURE__*/react.createElement(DropDownList, null), /*#__PURE__*/react.createElement("div", {
    id: "luckysheet-dataVerification-showHintBox",
    className: "luckysheet-mousedown-cancel",
    ref: dataVerificationHintBoxRef
  }), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-cell-copy"
  }), /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-grdblkflowpush"
  }), /*#__PURE__*/react.createElement("div", {
    id: "luckysheet-cell-flow_0",
    className: "luckysheet-cell-flow luckysheetsheetchange"
  }, /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-cell-flow-clip"
  }, /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-grdblkpush"
  }), /*#__PURE__*/react.createElement("div", {
    id: "luckysheetcoltable_0",
    className: "luckysheet-cell-flow-col"
  }, /*#__PURE__*/react.createElement("div", {
    id: "luckysheet-sheettable_0",
    className: "luckysheet-cell-sheettable",
    style: {
      height: context.rh_height,
      width: context.ch_width
    }
  }), /*#__PURE__*/react.createElement("div", {
    id: "luckysheet-bottom-controll-row",
    className: "luckysheet-bottom-controll-row",
    onMouseDown: function onMouseDown(e) {
      return e.stopPropagation();
    },
    onMouseUp: function onMouseUp(e) {
      return e.stopPropagation();
    },
    onKeyDown: function onKeyDown(e) {
      return e.stopPropagation();
    },
    onKeyUp: function onKeyUp(e) {
      return e.stopPropagation();
    },
    onKeyPress: function onKeyPress(e) {
      return e.stopPropagation();
    },
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onDoubleClick: function onDoubleClick(e) {
      return e.stopPropagation();
    },
    tabIndex: 0,
    style: {
      left: context.scrollLeft,
      display: context.allowEdit ? "block" : "none"
    }
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-add-row-button",
    onClick: function onClick() {
      handleBottomAddRow();
    },
    tabIndex: 0
  }, info.add), /*#__PURE__*/react.createElement("input", {
    ref: bottomAddRowInputRef,
    type: "text",
    style: {
      width: 50
    },
    placeholder: context.addDefaultRows.toString()
  }), " ", /*#__PURE__*/react.createElement("span", {
    style: {
      fontSize: 14
    }
  }, info.row), " ", /*#__PURE__*/react.createElement("span", {
    style: {
      fontSize: 14,
      color: "#9c9c9c"
    }
  }, "(", info.addLast, ")"), /*#__PURE__*/react.createElement("span", {
    className: "fortune-add-row-button",
    onClick: function onClick() {
      setContext(function (ctx) {
        ctx.scrollTop = 0;
      });
    },
    tabIndex: 0
  }, info.backTop))))))));
};
var Sheet = function Sheet(_ref) {
  var _context$config, _context$config2, _context$config3;
  var sheet = _ref.sheet;
  var data = sheet.data;
  var containerRef = (0,react.useRef)(null);
  var placeholderRef = (0,react.useRef)(null);
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    refs = _useContext.refs,
    settings = _useContext.settings;
  (0,react.useEffect)(function () {
    function resize() {
      if (!data) return;
      setContext(function (draftCtx) {
        if (settings.devicePixelRatio === 0) {
          draftCtx.devicePixelRatio = (globalThis || window).devicePixelRatio;
        }
        updateContextWithSheetData(draftCtx, data);
        updateContextWithCanvas(draftCtx, refs.canvas.current, placeholderRef.current);
      });
    }
    window.addEventListener("resize", resize);
    return function () {
      window.removeEventListener("resize", resize);
    };
  }, [data, refs.canvas, setContext, settings.devicePixelRatio]);
  (0,react.useEffect)(function () {
    if (!data) return;
    setContext(function (draftCtx) {
      return updateContextWithSheetData(draftCtx, data);
    });
  }, [(_context$config = context.config) === null || _context$config === void 0 ? void 0 : _context$config.rowlen, (_context$config2 = context.config) === null || _context$config2 === void 0 ? void 0 : _context$config2.columnlen, (_context$config3 = context.config) === null || _context$config3 === void 0 ? void 0 : _context$config3.rowhidden, context.config.colhidden, data, context.zoomRatio, setContext]);
  (0,react.useEffect)(function () {
    setContext(function (draftCtx) {
      return updateContextWithCanvas(draftCtx, refs.canvas.current, placeholderRef.current);
    });
  }, [refs.canvas, setContext, context.rowHeaderWidth, context.columnHeaderHeight, context.devicePixelRatio]);
  (0,react.useEffect)(function () {
    initFreeze(context, refs.globalCache, context.currentSheetId);
  }, [refs.globalCache, sheet.frozen, context.currentSheetId, context.visibledatacolumn, context.visibledatarow]);
  (0,react.useEffect)(function () {
    var _refs$globalCache$fre, _freeze$horizontal, _freeze$vertical;
    if (context.groupValuesRefreshData.length > 0) {
      return;
    }
    var tableCanvas = new Canvas(refs.canvas.current, context);
    if (tableCanvas == null) return;
    var freeze = (_refs$globalCache$fre = refs.globalCache.freezen) === null || _refs$globalCache$fre === void 0 ? void 0 : _refs$globalCache$fre[sheet.id];
    if ((freeze === null || freeze === void 0 ? void 0 : (_freeze$horizontal = freeze.horizontal) === null || _freeze$horizontal === void 0 ? void 0 : _freeze$horizontal.freezenhorizontaldata) || (freeze === null || freeze === void 0 ? void 0 : (_freeze$vertical = freeze.vertical) === null || _freeze$vertical === void 0 ? void 0 : _freeze$vertical.freezenverticaldata)) {
      var _freeze$horizontal2, _freeze$vertical2;
      var horizontalData = freeze === null || freeze === void 0 ? void 0 : (_freeze$horizontal2 = freeze.horizontal) === null || _freeze$horizontal2 === void 0 ? void 0 : _freeze$horizontal2.freezenhorizontaldata;
      var verticallData = freeze === null || freeze === void 0 ? void 0 : (_freeze$vertical2 = freeze.vertical) === null || _freeze$vertical2 === void 0 ? void 0 : _freeze$vertical2.freezenverticaldata;
      if (horizontalData && verticallData) {
        var _horizontalData = dist_index_esm_slicedToArray(horizontalData, 3),
          horizontalPx = _horizontalData[0],
          horizontalScrollTop = _horizontalData[2];
        var _verticallData = dist_index_esm_slicedToArray(verticallData, 3),
          verticalPx = _verticallData[0],
          verticalScrollWidth = _verticallData[2];
        tableCanvas.drawMain({
          scrollWidth: context.scrollLeft + verticalPx - verticalScrollWidth,
          scrollHeight: context.scrollTop + horizontalPx - horizontalScrollTop,
          offsetLeft: verticalPx - verticalScrollWidth + context.rowHeaderWidth,
          offsetTop: horizontalPx - horizontalScrollTop + context.columnHeaderHeight,
          clear: true
        });
        tableCanvas.drawMain({
          scrollWidth: context.scrollLeft + verticalPx - verticalScrollWidth,
          scrollHeight: horizontalScrollTop,
          drawHeight: horizontalPx,
          offsetLeft: verticalPx - verticalScrollWidth + context.rowHeaderWidth
        });
        tableCanvas.drawMain({
          scrollWidth: verticalScrollWidth,
          scrollHeight: context.scrollTop + horizontalPx - horizontalScrollTop,
          drawWidth: verticalPx,
          offsetTop: horizontalPx - horizontalScrollTop + context.columnHeaderHeight
        });
        tableCanvas.drawMain({
          scrollWidth: verticalScrollWidth,
          scrollHeight: horizontalScrollTop,
          drawWidth: verticalPx,
          drawHeight: horizontalPx
        });
        tableCanvas.drawColumnHeader(context.scrollLeft + verticalPx - verticalScrollWidth, undefined, verticalPx - verticalScrollWidth + context.rowHeaderWidth);
        tableCanvas.drawColumnHeader(verticalScrollWidth, verticalPx);
        tableCanvas.drawRowHeader(context.scrollTop + horizontalPx - horizontalScrollTop, undefined, horizontalPx - horizontalScrollTop + context.columnHeaderHeight);
        tableCanvas.drawRowHeader(horizontalScrollTop, horizontalPx);
        tableCanvas.drawFreezeLine({
          horizontalTop: horizontalPx - horizontalScrollTop + context.columnHeaderHeight - 2,
          verticalLeft: verticalPx - verticalScrollWidth + context.rowHeaderWidth - 2
        });
      } else if (horizontalData) {
        var _horizontalData2 = dist_index_esm_slicedToArray(horizontalData, 3),
          _horizontalPx = _horizontalData2[0],
          _horizontalScrollTop = _horizontalData2[2];
        tableCanvas.drawMain({
          scrollWidth: context.scrollLeft,
          scrollHeight: context.scrollTop + _horizontalPx - _horizontalScrollTop,
          offsetTop: _horizontalPx - _horizontalScrollTop + context.columnHeaderHeight,
          clear: true
        });
        tableCanvas.drawMain({
          scrollWidth: context.scrollLeft,
          scrollHeight: _horizontalScrollTop,
          drawHeight: _horizontalPx
        });
        tableCanvas.drawColumnHeader(context.scrollLeft);
        tableCanvas.drawRowHeader(context.scrollTop + _horizontalPx - _horizontalScrollTop, undefined, _horizontalPx - _horizontalScrollTop + context.columnHeaderHeight);
        tableCanvas.drawRowHeader(_horizontalScrollTop, _horizontalPx);
        tableCanvas.drawFreezeLine({
          horizontalTop: _horizontalPx - _horizontalScrollTop + context.columnHeaderHeight - 2
        });
      } else if (verticallData) {
        var _verticallData2 = dist_index_esm_slicedToArray(verticallData, 3),
          _verticalPx = _verticallData2[0],
          _verticalScrollWidth = _verticallData2[2];
        tableCanvas.drawMain({
          scrollWidth: context.scrollLeft + _verticalPx - _verticalScrollWidth,
          scrollHeight: context.scrollTop,
          offsetLeft: _verticalPx - _verticalScrollWidth + context.rowHeaderWidth
        });
        tableCanvas.drawMain({
          scrollWidth: _verticalScrollWidth,
          scrollHeight: context.scrollTop,
          drawWidth: _verticalPx
        });
        tableCanvas.drawRowHeader(context.scrollTop);
        tableCanvas.drawColumnHeader(context.scrollLeft + _verticalPx - _verticalScrollWidth, undefined, _verticalPx - _verticalScrollWidth + context.rowHeaderWidth);
        tableCanvas.drawColumnHeader(_verticalScrollWidth, _verticalPx);
        tableCanvas.drawFreezeLine({
          verticalLeft: _verticalPx - _verticalScrollWidth + context.rowHeaderWidth - 2
        });
      }
    } else {
      tableCanvas.drawMain({
        scrollWidth: context.scrollLeft,
        scrollHeight: context.scrollTop,
        clear: true
      });
      tableCanvas.drawColumnHeader(context.scrollLeft);
      tableCanvas.drawRowHeader(context.scrollTop);
    }
  }, [context, refs.canvas, refs.globalCache.freezen, setContext, sheet.id]);
  var onWheel = (0,react.useCallback)(function (e) {
    setContext(function (draftCtx) {
      handleGlobalWheel(draftCtx, e, refs.globalCache, refs.scrollbarX.current, refs.scrollbarY.current);
    });
    e.preventDefault();
  }, [refs.globalCache, refs.scrollbarX, refs.scrollbarY, setContext]);
  (0,react.useEffect)(function () {
    var container = containerRef.current;
    container === null || container === void 0 ? void 0 : container.addEventListener("wheel", onWheel);
    return function () {
      container === null || container === void 0 ? void 0 : container.removeEventListener("wheel", onWheel);
    };
  }, [onWheel]);
  return /*#__PURE__*/react.createElement("div", {
    ref: containerRef,
    className: "fortune-sheet-container"
  }, /*#__PURE__*/react.createElement("div", {
    ref: placeholderRef,
    className: "fortune-sheet-canvas-placeholder"
  }), /*#__PURE__*/react.createElement("canvas", {
    className: "fortune-sheet-canvas",
    ref: refs.canvas
  }), /*#__PURE__*/react.createElement(SheetOverlay, null));
};
var Button = function Button(_ref) {
  var tooltip = _ref.tooltip,
    onClick = _ref.onClick,
    iconId = _ref.iconId,
    disabled = _ref.disabled,
    selected = _ref.selected,
    children = _ref.children;
  return /*#__PURE__*/react.createElement("div", {
    className: "fortune-toolbar-button fortune-toolbar-item",
    onClick: onClick,
    tabIndex: 0,
    "data-tips": tooltip,
    role: "button",
    "aria-label": tooltip,
    style: selected ? {
      backgroundColor: "#E7E5EB"
    } : {}
  }, /*#__PURE__*/react.createElement(SVGIcon, {
    name: iconId,
    style: disabled ? {
      opacity: 0.3
    } : {}
  }), tooltip && /*#__PURE__*/react.createElement("div", {
    className: "fortune-tooltip"
  }, tooltip), children);
};
var Divider = function Divider() {
  return /*#__PURE__*/react.createElement("div", {
    className: "fortune-toolbar-divider fortune-toolbar-item"
  });
};
var MenuDivider = function MenuDivider() {
  return /*#__PURE__*/react.createElement("div", {
    className: "fortune-toolbar-menu-divider"
  });
};
var Combo = function Combo(_ref) {
  var tooltip = _ref.tooltip,
    _onClick = _ref.onClick,
    text = _ref.text,
    iconId = _ref.iconId,
    children = _ref.children;
  var style = {
    userSelect: "none"
  };
  var _useState = (0,react.useState)(false),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0,react.useState)({
      left: 0
    }),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    popupPosition = _useState4[0],
    setPopupPosition = _useState4[1];
  var popupRef = (0,react.useRef)(null);
  var buttonRef = (0,react.useRef)(null);
  useOutsideClick(popupRef, function () {
    setOpen(false);
  });
  (0,react.useLayoutEffect)(function () {
    if (!popupRef.current) {
      return;
    }
    if (!open) {
      setPopupPosition({
        left: 0
      });
    }
    var winW = window.innerWidth;
    var rect = popupRef.current.getBoundingClientRect();
    var menuW = rect.width;
    var left = rect.left;
    if (left + menuW > winW) {
      setPopupPosition({
        left: -rect.width + buttonRef.current.clientWidth
      });
    }
  }, [open]);
  return /*#__PURE__*/react.createElement("div", {
    className: "fortune-toobar-combo-container fortune-toolbar-item"
  }, /*#__PURE__*/react.createElement("div", {
    ref: buttonRef,
    className: "fortune-toolbar-combo"
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-toolbar-combo-button",
    onClick: function onClick(e) {
      if (_onClick) _onClick(e);else setOpen(!open);
    },
    tabIndex: 0,
    "data-tips": tooltip,
    role: "button",
    "aria-label": tooltip,
    style: style
  }, iconId ? /*#__PURE__*/react.createElement(SVGIcon, {
    name: iconId
  }) : /*#__PURE__*/react.createElement("span", {
    className: "fortune-toolbar-combo-text"
  }, text)), /*#__PURE__*/react.createElement("div", {
    className: "fortune-toolbar-combo-arrow",
    onClick: function onClick() {
      return setOpen(!open);
    },
    tabIndex: 0,
    "data-tips": tooltip,
    role: "button",
    "aria-label": tooltip,
    style: style
  }, /*#__PURE__*/react.createElement(SVGIcon, {
    name: "combo-arrow",
    width: 10
  })), tooltip && /*#__PURE__*/react.createElement("div", {
    className: "fortune-tooltip"
  }, tooltip)), open && /*#__PURE__*/react.createElement("div", {
    ref: popupRef,
    className: "fortune-toolbar-combo-popup",
    style: popupPosition
  }, children === null || children === void 0 ? void 0 : children(setOpen)));
};
var Select = function Select(_ref) {
  var children = _ref.children,
    style = _ref.style;
  return /*#__PURE__*/react.createElement("div", {
    className: "fortune-toolbar-select",
    style: style
  }, children);
};
var Option = function Option(_ref2) {
  var iconId = _ref2.iconId,
    onClick = _ref2.onClick,
    children = _ref2.children,
    _onMouseLeave = _ref2.onMouseLeave,
    _onMouseEnter = _ref2.onMouseEnter;
  return /*#__PURE__*/react.createElement("div", {
    onClick: onClick,
    tabIndex: 0,
    className: "fortune-toolbar-select-option",
    onMouseLeave: function onMouseLeave(e) {
      return _onMouseLeave === null || _onMouseLeave === void 0 ? void 0 : _onMouseLeave(e);
    },
    onMouseEnter: function onMouseEnter(e) {
      return _onMouseEnter === null || _onMouseEnter === void 0 ? void 0 : _onMouseEnter(e);
    }
  }, iconId && /*#__PURE__*/react.createElement(SVGIcon, {
    name: iconId
  }), /*#__PURE__*/react.createElement("div", {
    className: "fortuen-toolbar-text"
  }, children));
};
var FormulaSearch$1 = function FormulaSearch(_ref) {
  var _onCancel = _ref.onCancel;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    _useContext$refs = _useContext.refs,
    cellInput = _useContext$refs.cellInput,
    globalCache = _useContext$refs.globalCache;
  var _useState = (0,react.useState)(0),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    selectedType = _useState2[0],
    setSelectedType = _useState2[1];
  var _useState3 = (0,react.useState)(0),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    selectedFuncIndex = _useState4[0],
    setSelectedFuncIndex = _useState4[1];
  var _useState5 = (0,react.useState)(""),
    _useState6 = dist_index_esm_slicedToArray(_useState5, 2),
    searchText = _useState6[0],
    setSearchText = _useState6[1];
  var _locale = locale(context),
    formulaMore = _locale.formulaMore,
    functionlist = _locale.functionlist,
    button = _locale.button;
  var typeList = (0,react.useMemo)(function () {
    return [{
      t: 0,
      n: formulaMore.Math
    }, {
      t: 1,
      n: formulaMore.Statistical
    }, {
      t: 2,
      n: formulaMore.Lookup
    }, {
      t: 3,
      n: formulaMore.luckysheet
    }, {
      t: 4,
      n: formulaMore.dataMining
    }, {
      t: 5,
      n: formulaMore.Database
    }, {
      t: 6,
      n: formulaMore.Date
    }, {
      t: 7,
      n: formulaMore.Filter
    }, {
      t: 8,
      n: formulaMore.Financial
    }, {
      t: 9,
      n: formulaMore.Engineering
    }, {
      t: 10,
      n: formulaMore.Logical
    }, {
      t: 11,
      n: formulaMore.Operator
    }, {
      t: 12,
      n: formulaMore.Text
    }, {
      t: 13,
      n: formulaMore.Parser
    }, {
      t: 14,
      n: formulaMore.Array
    }, {
      t: -1,
      n: formulaMore.other
    }];
  }, [formulaMore]);
  var filteredFunctionList = (0,react.useMemo)(function () {
    if (searchText) {
      var list = [];
      var text = lodash_default().cloneDeep(searchText.toUpperCase());
      for (var i = 0; i < functionlist.length; i += 1) {
        if (/^[a-zA-Z]+$/.test(text)) {
          if (functionlist[i].n.indexOf(text) !== -1) {
            list.push(functionlist[i]);
          }
        } else if (functionlist[i].a.indexOf(text) !== -1) {
          list.push(functionlist[i]);
        }
      }
      return list;
    }
    return lodash_default().filter(functionlist, function (v) {
      return v.t === selectedType;
    });
  }, [functionlist, selectedType, searchText]);
  var onConfirm = (0,react.useCallback)(function () {
    var _context$luckysheet_s;
    var last = (_context$luckysheet_s = context.luckysheet_select_save) === null || _context$luckysheet_s === void 0 ? void 0 : _context$luckysheet_s[context.luckysheet_select_save.length - 1];
    var row_index = last === null || last === void 0 ? void 0 : last.row_focus;
    var col_index = last === null || last === void 0 ? void 0 : last.column_focus;
    if (!last) {
      row_index = 0;
      col_index = 0;
    } else {
      if (row_index == null) {
        var _last$row = dist_index_esm_slicedToArray(last.row, 1);
        row_index = _last$row[0];
      }
      if (col_index == null) {
        var _last$column = dist_index_esm_slicedToArray(last.column, 1);
        col_index = _last$column[0];
      }
    }
    var formulaTxt = "<span dir=\"auto\" class=\"luckysheet-formula-text-color\">=</span><span dir=\"auto\" class=\"luckysheet-formula-text-color\">".concat(filteredFunctionList[selectedFuncIndex].n.toUpperCase(), "</span><span dir=\"auto\" class=\"luckysheet-formula-text-color\">(</span>");
    setContext(function (ctx) {
      if (cellInput.current != null) {
        ctx.luckysheetCellUpdate = [row_index, col_index];
        globalCache.doNotUpdateCell = true;
        cellInput.current.innerHTML = formulaTxt;
        var spans = cellInput.current.childNodes;
        if (!lodash_default().isEmpty(spans)) {
          setCaretPosition(ctx, spans[spans.length - 1], 0, 1);
        }
        ctx.functionHint = filteredFunctionList[selectedFuncIndex].n.toUpperCase();
        ctx.functionCandidates = [];
        if (lodash_default().isEmpty(ctx.formulaCache.functionlistMap)) {
          for (var i = 0; i < functionlist.length; i += 1) {
            ctx.formulaCache.functionlistMap[functionlist[i].n] = functionlist[i];
          }
        }
        _onCancel();
      }
    });
  }, [cellInput, context.luckysheet_select_save, filteredFunctionList, globalCache, selectedFuncIndex, setContext, _onCancel, functionlist]);
  var onCancel = (0,react.useCallback)(function () {
    setContext(function (ctx) {
      cancelNormalSelected(ctx);
      if (cellInput.current) {
        cellInput.current.innerHTML = "";
      }
    });
    _onCancel();
  }, [_onCancel, cellInput, setContext]);
  return /*#__PURE__*/react.createElement("div", {
    id: "luckysheet-search-formula"
  }, /*#__PURE__*/react.createElement("div", {
    className: "inpbox"
  }, /*#__PURE__*/react.createElement("div", null, formulaMore.findFunctionTitle, "\uFF1A"), /*#__PURE__*/react.createElement("input", {
    className: "formulaInputFocus",
    id: "searchFormulaListInput",
    placeholder: formulaMore.tipInputFunctionName,
    spellCheck: "false",
    onChange: function onChange(e) {
      return setSearchText(e.target.value);
    }
  })), /*#__PURE__*/react.createElement("div", {
    className: "selbox"
  }, /*#__PURE__*/react.createElement("span", null, formulaMore.selectCategory, "\uFF1A"), /*#__PURE__*/react.createElement("select", {
    id: "formulaTypeSelect",
    onChange: function onChange(e) {
      setSelectedType(parseInt(e.target.value, 10));
      setSelectedFuncIndex(0);
    }
  }, typeList.map(function (v) {
    return /*#__PURE__*/react.createElement("option", {
      key: v.t,
      value: v.t
    }, v.n);
  }))), /*#__PURE__*/react.createElement("div", {
    className: "listbox",
    style: {
      height: 200
    }
  }, /*#__PURE__*/react.createElement("div", null, formulaMore.selectFunctionTitle, "\uFF1A"), /*#__PURE__*/react.createElement("div", {
    className: "formulaList"
  }, filteredFunctionList.map(function (v, index) {
    return /*#__PURE__*/react.createElement("div", {
      className: "listBox".concat(index === selectedFuncIndex ? " on" : ""),
      key: v.n,
      onClick: function onClick() {
        return setSelectedFuncIndex(index);
      },
      tabIndex: 0
    }, /*#__PURE__*/react.createElement("div", null, v.n), /*#__PURE__*/react.createElement("div", null, v.a));
  }))), /*#__PURE__*/react.createElement("div", {
    className: "fortune-dialog-box-button-container"
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-message-box-button button-primary",
    onClick: onConfirm,
    tabIndex: 0
  }, button.confirm), /*#__PURE__*/react.createElement("div", {
    className: "fortune-message-box-button button-default",
    onClick: onCancel,
    tabIndex: 0
  }, button.cancel)));
};
var SplitColumn = function SplitColumn() {
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext;
  var _locale = locale(context),
    splitText = _locale.splitText,
    button = _locale.button;
  var _useState = (0,react.useState)(""),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    splitOperate = _useState2[0],
    setSplitOperate = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    otherFlag = _useState4[0],
    setOtherFlag = _useState4[1];
  var _useState5 = (0,react.useState)([]),
    _useState6 = dist_index_esm_slicedToArray(_useState5, 2),
    tableData = _useState6[0],
    setTableData = _useState6[1];
  var splitSymbols = (0,react.useRef)(null);
  var _useDialog = useDialog(),
    showDialog = _useDialog.showDialog,
    hideDialog = _useDialog.hideDialog;
  var certainBtn = (0,react.useCallback)(function () {
    hideDialog();
    var dataArr = getDataArr(splitOperate, context);
    var r = context.luckysheet_select_save[0].row[0];
    var c = context.luckysheet_select_save[0].column[0];
    if (dataArr[0].length === 1) {
      return;
    }
    var dataCover = false;
    var data = getFlowdata(context);
    for (var i = 0; i < dataArr.length; i += 1) {
      for (var j = 1; j < dataArr[0].length; j += 1) {
        var cell = data[r + i][c + j];
        if (!lodash_default().isNull(cell) && !lodash_default().isNull(cell.v)) {
          dataCover = true;
          break;
        }
      }
    }
    if (dataCover) {
      showDialog(splitText.splitConfirmToExe, "yesno", function () {
        hideDialog();
        setContext(function (ctx) {
          updateMoreCell(r, c, dataArr, ctx);
        });
      });
    } else {
      setContext(function (ctx) {
        updateMoreCell(r, c, dataArr, ctx);
      });
    }
  }, [context, hideDialog, setContext, showDialog, splitOperate, splitText.splitConfirmToExe]);
  (0,react.useEffect)(function () {
    setTableData(function (table) {
      table = getDataArr(splitOperate, context);
      return table;
    });
  }, [context, splitOperate]);
  return /*#__PURE__*/react.createElement("div", {
    id: "fortune-split-column"
  }, /*#__PURE__*/react.createElement("div", {
    className: "title"
  }, splitText.splitTextTitle), /*#__PURE__*/react.createElement("div", {
    className: "splitDelimiters"
  }, splitText.splitDelimiters), /*#__PURE__*/react.createElement("div", {
    className: "splitSymbols",
    ref: splitSymbols
  }, splitText.splitSymbols.map(function (o) {
    return /*#__PURE__*/react.createElement("div", {
      key: o.value,
      className: "splitSymbol"
    }, /*#__PURE__*/react.createElement("input", {
      id: o.value,
      name: o.value,
      type: "checkbox",
      onClick: function onClick() {
        return setSplitOperate(function (regStr) {
          var _splitSymbols$current;
          return getRegStr(regStr, (_splitSymbols$current = splitSymbols.current) === null || _splitSymbols$current === void 0 ? void 0 : _splitSymbols$current.childNodes);
        });
      },
      tabIndex: 0
    }), /*#__PURE__*/react.createElement("label", {
      htmlFor: o.value
    }, o.name));
  }), /*#__PURE__*/react.createElement("div", {
    className: "splitSymbol"
  }, /*#__PURE__*/react.createElement("input", {
    id: "other",
    name: "other",
    type: "checkbox",
    onClick: function onClick() {
      setOtherFlag(!otherFlag);
      setSplitOperate(function (regStr) {
        var _splitSymbols$current2;
        return getRegStr(regStr, (_splitSymbols$current2 = splitSymbols.current) === null || _splitSymbols$current2 === void 0 ? void 0 : _splitSymbols$current2.childNodes);
      });
    },
    tabIndex: 0
  }), /*#__PURE__*/react.createElement("label", {
    htmlFor: "other"
  }, splitText.splitOther), /*#__PURE__*/react.createElement("input", {
    id: "otherValue",
    name: "otherValue",
    type: "text",
    onBlur: function onBlur() {
      if (otherFlag) {
        setSplitOperate(function (regStr) {
          var _splitSymbols$current3;
          return getRegStr(regStr, (_splitSymbols$current3 = splitSymbols.current) === null || _splitSymbols$current3 === void 0 ? void 0 : _splitSymbols$current3.childNodes);
        });
      }
    }
  })), /*#__PURE__*/react.createElement("div", {
    className: "splitSymbol splitSimple"
  }, /*#__PURE__*/react.createElement("input", {
    id: "splitsimple",
    name: "splitsimple",
    type: "checkbox",
    onClick: function onClick() {
      setSplitOperate(function (regStr) {
        var _splitSymbols$current4;
        return getRegStr(regStr, (_splitSymbols$current4 = splitSymbols.current) === null || _splitSymbols$current4 === void 0 ? void 0 : _splitSymbols$current4.childNodes);
      });
    },
    tabIndex: 0
  }), /*#__PURE__*/react.createElement("label", {
    htmlFor: "splitsimple"
  }, splitText.splitContinueSymbol))), /*#__PURE__*/react.createElement("div", {
    className: "splitDataPreview"
  }, splitText.splitDataPreview), /*#__PURE__*/react.createElement("div", {
    className: "splitColumnData"
  }, /*#__PURE__*/react.createElement("table", null, /*#__PURE__*/react.createElement("tbody", null, tableData.map(function (o, index) {
    if (o.length >= 1) {
      return /*#__PURE__*/react.createElement("tr", {
        key: index
      }, o.map(function (o1) {
        return /*#__PURE__*/react.createElement("td", {
          key: o + o1
        }, o1);
      }));
    }
    return /*#__PURE__*/react.createElement("tr", null, /*#__PURE__*/react.createElement("td", null));
  })))), /*#__PURE__*/react.createElement("div", {
    className: "button-basic button-primary",
    onClick: function onClick() {
      certainBtn();
    },
    tabIndex: 0
  }, button.confirm), /*#__PURE__*/react.createElement("div", {
    className: "button-basic button-close",
    onClick: function onClick() {
      hideDialog();
    },
    tabIndex: 0
  }, button.cancel));
};
var LocationCondition = function LocationCondition() {
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext;
  var _useDialog = useDialog(),
    showDialog = _useDialog.showDialog,
    hideDialog = _useDialog.hideDialog;
  var _locale = locale(context),
    findAndReplace = _locale.findAndReplace,
    button = _locale.button;
  var _useState = (0,react.useState)("locationConstant"),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    conditionType = _useState2[0],
    setConditionType = _useState2[1];
  var _useState3 = (0,react.useState)({
      locationDate: true,
      locationDigital: true,
      locationString: true,
      locationBool: true,
      locationError: true
    }),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    constants = _useState4[0],
    setConstants = _useState4[1];
  var _useState5 = (0,react.useState)({
      locationDate: true,
      locationDigital: true,
      locationString: true,
      locationBool: true,
      locationError: true
    }),
    _useState6 = dist_index_esm_slicedToArray(_useState5, 2),
    formulas = _useState6[0],
    setFormulas = _useState6[1];
  var onConfirm = (0,react.useCallback)(function () {
    if (conditionType === "locationConstant") {
      var value = getOptionValue(constants);
      var selectRange = getSelectRange(context);
      setContext(function (ctx) {
        var rangeArr = applyLocation(selectRange, conditionType, value, ctx);
        if (rangeArr.length === 0) showDialog(findAndReplace.locationTipNotFindCell, "ok");
      });
    } else if (conditionType === "locationFormula") {
      var _value = getOptionValue(formulas);
      var _selectRange = getSelectRange(context);
      setContext(function (ctx) {
        var rangeArr = applyLocation(_selectRange, conditionType, _value, ctx);
        if (rangeArr.length === 0) showDialog(findAndReplace.locationTipNotFindCell, "ok");
      });
    } else if (conditionType === "locationRowSpan") {
      var _context$luckysheet_s, _context$luckysheet_s2;
      if (((_context$luckysheet_s = context.luckysheet_select_save) === null || _context$luckysheet_s === void 0 ? void 0 : _context$luckysheet_s.length) === 0 || ((_context$luckysheet_s2 = context.luckysheet_select_save) === null || _context$luckysheet_s2 === void 0 ? void 0 : _context$luckysheet_s2.length) === 1 && context.luckysheet_select_save[0].row[0] === context.luckysheet_select_save[0].row[1]) {
        showDialog(findAndReplace.locationTiplessTwoRow, "ok");
        return;
      }
      var _selectRange2 = lodash_default().assignIn([], context.luckysheet_select_save);
      setContext(function (ctx) {
        var rangeArr = applyLocation(_selectRange2, conditionType, undefined, ctx);
        if (rangeArr.length === 0) showDialog(findAndReplace.locationTipNotFindCell, "ok");
      });
    } else if (conditionType === "locationColumnSpan") {
      var _context$luckysheet_s3, _context$luckysheet_s4;
      if (((_context$luckysheet_s3 = context.luckysheet_select_save) === null || _context$luckysheet_s3 === void 0 ? void 0 : _context$luckysheet_s3.length) === 0 || ((_context$luckysheet_s4 = context.luckysheet_select_save) === null || _context$luckysheet_s4 === void 0 ? void 0 : _context$luckysheet_s4.length) === 1 && context.luckysheet_select_save[0].column[0] === context.luckysheet_select_save[0].column[1]) {
        showDialog(findAndReplace.locationTiplessTwoColumn, "ok");
        return;
      }
      var _selectRange3 = lodash_default().assignIn([], context.luckysheet_select_save);
      setContext(function (ctx) {
        var rangeArr = applyLocation(_selectRange3, conditionType, undefined, ctx);
        if (rangeArr.length === 0) showDialog(findAndReplace.locationTipNotFindCell, "ok");
      });
    } else {
      var _context$luckysheet_s5, _context$luckysheet_s6;
      var _selectRange4;
      if (((_context$luckysheet_s5 = context.luckysheet_select_save) === null || _context$luckysheet_s5 === void 0 ? void 0 : _context$luckysheet_s5.length) === 0 || ((_context$luckysheet_s6 = context.luckysheet_select_save) === null || _context$luckysheet_s6 === void 0 ? void 0 : _context$luckysheet_s6.length) === 1 && context.luckysheet_select_save[0].row[0] === context.luckysheet_select_save[0].row[1] && context.luckysheet_select_save[0].column[0] === context.luckysheet_select_save[0].column[1]) {
        var flowdata = getFlowdata(context, context.currentSheetId);
        _selectRange4 = [{
          row: [0, flowdata.length - 1],
          column: [0, flowdata[0].length - 1]
        }];
      } else {
        _selectRange4 = lodash_default().assignIn([], context.luckysheet_select_save);
      }
      setContext(function (ctx) {
        var rangeArr = applyLocation(_selectRange4, conditionType, undefined, ctx);
        if (rangeArr.length === 0) showDialog(findAndReplace.locationTipNotFindCell, "ok");
      });
    }
  }, [conditionType, constants, context, findAndReplace.locationTipNotFindCell, findAndReplace.locationTiplessTwoColumn, findAndReplace.locationTiplessTwoRow, formulas, setContext, showDialog]);
  var isSelect = (0,react.useCallback)(function (currentType) {
    return conditionType === currentType;
  }, [conditionType]);
  return /*#__PURE__*/react.createElement("div", {
    id: "fortune-location-condition"
  }, /*#__PURE__*/react.createElement("div", {
    className: "title"
  }, findAndReplace.location), /*#__PURE__*/react.createElement("div", {
    className: "listbox"
  }, /*#__PURE__*/react.createElement("div", {
    className: "listItem"
  }, /*#__PURE__*/react.createElement("input", {
    type: "radio",
    name: "locationType",
    id: "locationConstant",
    checked: isSelect("locationConstant"),
    onChange: function onChange() {
      setConditionType("locationConstant");
    }
  }), /*#__PURE__*/react.createElement("label", {
    htmlFor: "locationConstant"
  }, findAndReplace.locationConstant), /*#__PURE__*/react.createElement("div", {
    className: "subbox"
  }, ["locationDate", "locationDigital", "locationString", "locationBool", "locationError"].map(function (v) {
    return /*#__PURE__*/react.createElement("div", {
      className: "subItem",
      key: v
    }, /*#__PURE__*/react.createElement("input", {
      type: "checkbox",
      disabled: !isSelect("locationConstant"),
      checked: constants[v],
      onChange: function onChange() {
        setConstants((0,immer_esm/* default */.ZP)(function (draft) {
          lodash_default().set(draft, v, !draft[v]);
        }));
      }
    }), /*#__PURE__*/react.createElement("label", {
      htmlFor: v,
      style: {
        color: isSelect("locationConstant") ? "#000" : "#666"
      }
    }, findAndReplace[v]));
  }))), /*#__PURE__*/react.createElement("div", {
    className: "listItem"
  }, /*#__PURE__*/react.createElement("input", {
    type: "radio",
    name: "locationType",
    id: "locationFormula",
    checked: isSelect("locationFormula"),
    onChange: function onChange() {
      setConditionType("locationFormula");
    }
  }), /*#__PURE__*/react.createElement("label", {
    htmlFor: "locationFormula"
  }, findAndReplace.locationFormula), /*#__PURE__*/react.createElement("div", {
    className: "subbox"
  }, ["locationDate", "locationDigital", "locationString", "locationBool", "locationError"].map(function (v) {
    return /*#__PURE__*/react.createElement("div", {
      className: "subItem",
      key: v
    }, /*#__PURE__*/react.createElement("input", {
      type: "checkbox",
      disabled: !isSelect("locationFormula"),
      checked: formulas[v],
      onChange: function onChange() {
        setFormulas((0,immer_esm/* default */.ZP)(function (draft) {
          lodash_default().set(draft, v, !draft[v]);
        }));
      }
    }), /*#__PURE__*/react.createElement("label", {
      htmlFor: v,
      style: {
        color: isSelect("locationFormula") ? "#000" : "#666"
      }
    }, findAndReplace[v]));
  }))), ["locationNull", "locationRowSpan", "locationColumnSpan"].map(function (v) {
    return /*#__PURE__*/react.createElement("div", {
      className: "listItem",
      key: v
    }, /*#__PURE__*/react.createElement("input", {
      type: "radio",
      name: v,
      checked: isSelect(v),
      onChange: function onChange() {
        setConditionType(v);
      }
    }), /*#__PURE__*/react.createElement("label", {
      htmlFor: v
    }, findAndReplace[v]));
  })), /*#__PURE__*/react.createElement("div", {
    className: "button-basic button-primary",
    onClick: function onClick() {
      hideDialog();
      onConfirm();
    },
    tabIndex: 0
  }, button.confirm), /*#__PURE__*/react.createElement("div", {
    className: "button-basic button-close",
    onClick: function onClick() {
      hideDialog();
    },
    tabIndex: 0
  }, button.cancel));
};
var ConditionalFormat = function ConditionalFormat(_ref) {
  var items = _ref.items,
    setOpen = _ref.setOpen;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    refs = _useContext.refs;
  var _useDialog = useDialog(),
    showDialog = _useDialog.showDialog;
  var _locale = locale(context),
    conditionformat = _locale.conditionformat;
  var showSubMenu = (0,react.useCallback)(function (e) {
    var target = e.target;
    var menuItem = target.className === "fortune-toolbar-menu-line" ? target.parentElement : target;
    var menuItemRect = menuItem.getBoundingClientRect();
    var workbookContainerRect = refs.workbookContainer.current.getBoundingClientRect();
    var subMenu = menuItem.querySelector(".condition-format-sub-menu");
    if (lodash_default().isNil(subMenu)) return;
    var menuItemStyle = window.getComputedStyle(menuItem);
    var menuItemPaddingRight = parseFloat(menuItemStyle.getPropertyValue("padding-right").replace("px", ""));
    if (workbookContainerRect.right - menuItemRect.right < parseFloat(subMenu.style.width.replace("px", ""))) {
      subMenu.style.display = "block";
      subMenu.style.right = "".concat(menuItemRect.width - menuItemPaddingRight, "px");
    } else {
      subMenu.style.display = "block";
      subMenu.style.right = "".concat(-(parseFloat(subMenu.style.width.replace("px", "")) + menuItemPaddingRight), "px");
    }
  }, [refs.workbookContainer]);
  var hideSubMenu = (0,react.useCallback)(function (e) {
    var target = e.target;
    if (target.className === "condition-format-sub-menu") {
      target.style.display = "none";
      return;
    }
    var subMenu = target.className === "condition-format-item" ? target.parentElement : target.querySelector(".condition-format-sub-menu");
    if (lodash_default().isNil(subMenu)) return;
    subMenu.style.display = "none";
  }, []);
  var getConditionFormatItem = (0,react.useCallback)(function (name) {
    if (name === "-") {
      return /*#__PURE__*/react.createElement(MenuDivider, {
        key: name
      });
    }
    if (name === "highlightCellRules") {
      return /*#__PURE__*/react.createElement(Option, {
        key: name,
        onMouseEnter: showSubMenu,
        onMouseLeave: hideSubMenu
      }, /*#__PURE__*/react.createElement("div", {
        className: "fortune-toolbar-menu-line",
        key: "div".concat(name)
      }, conditionformat[name], /*#__PURE__*/react.createElement(SVGIcon, {
        name: "rightArrow",
        width: 18
      }), /*#__PURE__*/react.createElement("div", {
        className: "condition-format-sub-menu",
        style: {
          display: "none",
          width: 150
        }
      }, [{
        text: "greaterThan",
        value: ">"
      }, {
        text: "lessThan",
        value: "<"
      }, {
        text: "between",
        value: "[]"
      }, {
        text: "equal",
        value: "="
      }, {
        text: "textContains",
        value: "()"
      }, {
        text: "occurrenceDate",
        value: conditionformat.yesterday
      }, {
        text: "duplicateValue",
        value: "##"
      }].map(function (v) {
        return /*#__PURE__*/react.createElement("div", {
          className: "condition-format-item",
          key: v.text,
          onClick: function onClick() {
            setOpen(false);
            showDialog(/*#__PURE__*/react.createElement(ConditionRules, {
              type: v.text
            }));
          },
          tabIndex: 0
        }, conditionformat[v.text], /*#__PURE__*/react.createElement("span", null, v.value));
      }))));
    }
    if (name === "itemSelectionRules") {
      return /*#__PURE__*/react.createElement(Option, {
        key: name,
        onMouseEnter: showSubMenu,
        onMouseLeave: hideSubMenu
      }, /*#__PURE__*/react.createElement("div", {
        className: "fortune-toolbar-menu-line"
      }, conditionformat[name], /*#__PURE__*/react.createElement(SVGIcon, {
        name: "rightArrow",
        width: 18
      }), /*#__PURE__*/react.createElement("div", {
        className: "condition-format-sub-menu",
        style: {
          display: "none",
          width: 180
        }
      }, [{
        text: "top10",
        value: conditionformat.top10
      }, {
        text: "top10_percent",
        value: conditionformat.top10_percent
      }, {
        text: "last10",
        value: conditionformat.last10
      }, {
        text: "last10_percent",
        value: conditionformat.last10_percent
      }, {
        text: "aboveAverage",
        value: conditionformat.above
      }, {
        text: "belowAverage",
        value: conditionformat.below
      }].map(function (v) {
        return /*#__PURE__*/react.createElement("div", {
          className: "condition-format-item",
          key: v.text,
          onClick: function onClick() {
            setOpen(false);
            showDialog(/*#__PURE__*/react.createElement(ConditionRules, {
              type: v.text
            }));
          },
          tabIndex: 0
        }, conditionformat[v.text], /*#__PURE__*/react.createElement("span", null, v.value));
      }))));
    }
    if (name === "dataBar") {
      return /*#__PURE__*/react.createElement("div", {
        className: "fortune-toolbar-menu-line",
        key: "div".concat(name)
      }, conditionformat[name], /*#__PURE__*/react.createElement(SVGIcon, {
        name: "rightArrow",
        width: 18
      }));
    }
    if (name === "colorGradation") {
      return /*#__PURE__*/react.createElement("div", {
        className: "fortune-toolbar-menu-line",
        key: "div".concat(name)
      }, conditionformat[name], /*#__PURE__*/react.createElement(SVGIcon, {
        name: "rightArrow",
        width: 18
      }));
    }
    if (name === "icons") {
      return /*#__PURE__*/react.createElement("div", {
        className: "fortune-toolbar-menu-line",
        key: "div".concat(name)
      }, conditionformat[name]);
    }
    if (name === "newFormatRule") {
      return /*#__PURE__*/react.createElement("div", {
        className: "fortune-toolbar-menu-line",
        key: "div".concat(name)
      }, conditionformat[name]);
    }
    if (name === "deleteRule") {
      return /*#__PURE__*/react.createElement(Option, {
        key: name,
        onMouseEnter: showSubMenu,
        onMouseLeave: hideSubMenu
      }, /*#__PURE__*/react.createElement("div", {
        className: "fortune-toolbar-menu-line"
      }, conditionformat[name], /*#__PURE__*/react.createElement(SVGIcon, {
        name: "rightArrow",
        width: 18
      }), /*#__PURE__*/react.createElement("div", {
        className: "condition-format-sub-menu",
        style: {
          display: "none",
          width: 150
        }
      }, ["deleteSheetRule"].map(function (v) {
        return /*#__PURE__*/react.createElement("div", {
          className: "condition-format-item",
          key: v,
          style: {
            padding: "6px 10px"
          },
          onClick: function onClick() {
            setContext(function (ctx) {
              updateItem(ctx, "delSheet");
            });
          },
          tabIndex: 0
        }, conditionformat[v]);
      }))));
    }
    if (name === "manageRules") {
      return /*#__PURE__*/react.createElement("div", {
        className: "fortune-toolbar-menu-line",
        key: "div".concat(name)
      }, conditionformat[name]);
    }
    return /*#__PURE__*/react.createElement("div", null);
  }, [conditionformat, hideSubMenu, setContext, setOpen, showDialog, showSubMenu]);
  return /*#__PURE__*/react.createElement("div", {
    className: "condition-format"
  }, /*#__PURE__*/react.createElement(Select, {
    style: {
      overflow: "visible"
    }
  }, items.map(function (v) {
    return /*#__PURE__*/react.createElement("div", {
      key: "option".concat(v)
    }, getConditionFormatItem(v));
  })));
};
var CustomIcon = function CustomIcon(_ref) {
  var iconName = _ref.iconName,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 24 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 24 : _ref$height,
    content = _ref.content;
  var innrContent = (0,react.useMemo)(function () {
    if (iconName) {
      return /*#__PURE__*/react.createElement("svg", {
        width: width,
        height: height
      }, /*#__PURE__*/react.createElement("use", {
        xlinkHref: "#".concat(iconName)
      }));
    }
    if (content) {
      return content;
    }
    return /*#__PURE__*/react.createElement("svg", {
      width: width,
      height: width
    }, /*#__PURE__*/react.createElement("use", {
      xlinkHref: "#default"
    }));
  }, [content, height, iconName, width]);
  return /*#__PURE__*/react.createElement("div", {
    style: {
      width: width,
      height: height,
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, innrContent);
};
var CustomButton = function CustomButton(_ref) {
  var tooltip = _ref.tooltip,
    onClick = _ref.onClick,
    selected = _ref.selected,
    children = _ref.children,
    iconName = _ref.iconName,
    icon = _ref.icon;
  return /*#__PURE__*/react.createElement("div", {
    className: "fortune-toolbar-button fortune-toolbar-item",
    onClick: onClick,
    tabIndex: 0,
    "data-tips": tooltip,
    role: "button",
    style: selected ? {
      backgroundColor: "#E7E5EB"
    } : {}
  }, /*#__PURE__*/react.createElement(CustomIcon, {
    iconName: iconName,
    content: icon
  }), tooltip && /*#__PURE__*/react.createElement("div", {
    className: "fortune-tooltip"
  }, tooltip), children);
};
var palette = [["#000000", "#444444", "#666666", "#999999", "#cccccc", "#eeeeee", "#f3f3f3", "#ffffff"], ["#f00f00", "#f90f90", "#ff0ff0", "#0f00f0", "#0ff0ff", "#00f00f", "#90f90f", "#f0ff0f"], ["#f4cccc", "#fce5cd", "#fff2cc", "#d9ead3", "#d0e0e3", "#cfe2f3", "#d9d2e9", "#ead1dc"], ["#ea9999", "#f9cb9c", "#ffe599", "#b6d7a8", "#a2c4c9", "#9fc5e8", "#b4a7d6", "#d5a6bd"], ["#e06666", "#f6b26b", "#ffd966", "#93c47d", "#76a5af", "#6fa8dc", "#8e7cc3", "#c27ba0"], ["#c00c00", "#e69138", "#f1c232", "#6aa84f", "#45818e", "#3d85c6", "#674ea7", "#a64d79"], ["#900900", "#b45f06", "#bf9000", "#38761d", "#134f5c", "#0b5394", "#351c75", "#741b47"], ["#600600", "#783f04", "#7f6000", "#274e13", "#0c343d", "#073763", "#20124d", "#4c1130"]];
var ColorPicker = function ColorPicker(_ref) {
  var onPick = _ref.onPick;
  return /*#__PURE__*/react.createElement("div", {
    className: "fortune-toolbar-color-picker"
  }, palette.map(function (rows, i) {
    return /*#__PURE__*/react.createElement("div", {
      key: i,
      className: "fortune-toolbar-color-picker-row"
    }, rows.map(function (c) {
      return /*#__PURE__*/react.createElement("div", {
        key: c,
        className: "fortune-toolbar-color-picker-item",
        onClick: function onClick() {
          return onPick(c);
        },
        tabIndex: 0,
        style: {
          backgroundColor: c
        }
      });
    }));
  }));
};
var CustomColor = function CustomColor(_ref) {
  var onCustomPick = _ref.onCustomPick,
    onColorPick = _ref.onColorPick;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context;
  var _locale = locale(context),
    toolbar = _locale.toolbar,
    sheetconfig = _locale.sheetconfig,
    button = _locale.button;
  var _useState = (0,react.useState)("#000000"),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    inputColor = _useState2[0],
    setInputColor = _useState2[1];
  return /*#__PURE__*/react.createElement("div", {
    id: "fortune-custom-color"
  }, /*#__PURE__*/react.createElement("div", {
    className: "color-reset",
    onClick: function onClick() {
      return onCustomPick(undefined);
    },
    tabIndex: 0
  }, sheetconfig.resetColor), /*#__PURE__*/react.createElement("div", {
    className: "custom-color"
  }, /*#__PURE__*/react.createElement("div", null, toolbar.customColor, ":"), /*#__PURE__*/react.createElement("input", {
    type: "color",
    value: inputColor,
    onChange: function onChange(e) {
      return setInputColor(e.target.value);
    }
  }), /*#__PURE__*/react.createElement("div", {
    className: "button-basic button-primary",
    onClick: function onClick() {
      onCustomPick(inputColor);
    },
    tabIndex: 0
  }, button.confirm)), /*#__PURE__*/react.createElement(ColorPicker, {
    onPick: function onPick(color) {
      onColorPick(color);
    }
  }));
};
var size = [{
  Text: "1",
  value: "Thin",
  strokeDasharray: "1,0",
  strokeWidth: "1"
}, {
  Text: "2",
  value: "Hair",
  strokeDasharray: "1,5",
  strokeWidth: "1"
}, {
  Text: "3",
  value: "Dotted",
  strokeDasharray: "2,5",
  strokeWidth: "2"
}, {
  Text: "4",
  value: "Dashed",
  strokeDasharray: "5,5",
  strokeWidth: "2"
}, {
  Text: "5",
  value: "DashDot",
  strokeDasharray: "20,5,5,10,5,5",
  strokeWidth: "2"
}, {
  Text: "6",
  value: "DashDotDot",
  strokeDasharray: "20,5,5,5,5,10,5,5,5,5",
  strokeWidth: "2"
}, {
  Text: "8",
  value: "Medium",
  strokeDasharray: "2,0",
  strokeWidth: "2"
}, {
  Text: "9",
  value: "MediumDashed",
  strokeDasharray: "3,5",
  strokeWidth: "3"
}, {
  Text: "10",
  value: "MediumDashDot",
  strokeDasharray: "20,5,5,10,5,5",
  strokeWidth: "3"
}, {
  Text: "11",
  value: "MediumDashDotDot",
  strokeDasharray: "5,5,5,5,20,5,5,5,5,10",
  strokeWidth: "3"
}, {
  Text: "13",
  value: "Thick",
  strokeDasharray: "2,0",
  strokeWidth: "3"
}];
var CustomBorder = function CustomBorder(_ref) {
  var onPick = _ref.onPick;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    refs = _useContext.refs;
  var _locale = locale(context),
    border = _locale.border;
  var _useState = (0,react.useState)("#000000"),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    changeColor = _useState2[0],
    setchangeColor = _useState2[1];
  var _useState3 = (0,react.useState)("1"),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    changeStyle = _useState4[0],
    setchangeStyle = _useState4[1];
  var colorRef = (0,react.useRef)(null);
  var styleRef = (0,react.useRef)(null);
  var colorPreviewRef = (0,react.useRef)(null);
  var _useState5 = (0,react.useState)(""),
    _useState6 = dist_index_esm_slicedToArray(_useState5, 2),
    previewWith = _useState6[0],
    setPreviewWith = _useState6[1];
  var _useState7 = (0,react.useState)(""),
    _useState8 = dist_index_esm_slicedToArray(_useState7, 2),
    previewdasharry = _useState8[0],
    setPreviewdasharray = _useState8[1];
  var showBorderSubMenu = (0,react.useCallback)(function (e) {
    var target = e.target;
    var menuItemRect = target.getBoundingClientRect();
    var subMenuItem = target.querySelector(".fortune-border-select-menu");
    if (lodash_default().isNil(subMenuItem)) return;
    subMenuItem.style.display = "block";
    var workbookContainerRect = refs.workbookContainer.current.getBoundingClientRect();
    if (workbookContainerRect.width - menuItemRect.right > parseFloat(subMenuItem.style.width.replace("px", ""))) {
      subMenuItem.style.left = "".concat(menuItemRect === null || menuItemRect === void 0 ? void 0 : menuItemRect.width, "px");
    } else {
      subMenuItem.style.left = "-".concat(subMenuItem.style.width);
    }
  }, [refs.workbookContainer]);
  var hideBorderSubMenu = (0,react.useCallback)(function () {
    styleRef.current.style.display = "none";
    colorRef.current.style.display = "none";
  }, []);
  var changePreviewStyle = (0,react.useCallback)(function (width, dasharray) {
    setPreviewWith(width);
    setPreviewdasharray(dasharray);
  }, []);
  return /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "fortune-border-select-option",
    key: "borderColor",
    onMouseEnter: function onMouseEnter(e) {
      showBorderSubMenu(e);
    },
    onMouseLeave: function onMouseLeave() {
      hideBorderSubMenu();
    }
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-toolbar-menu-line"
  }, border.borderColor, /*#__PURE__*/react.createElement(SVGIcon, {
    name: "rightArrow",
    style: {
      width: "14px"
    }
  })), /*#__PURE__*/react.createElement("div", {
    ref: colorPreviewRef,
    className: "fortune-border-color-preview",
    style: {
      backgroundColor: changeColor
    }
  }), /*#__PURE__*/react.createElement("div", {
    ref: colorRef,
    className: "fortune-border-select-menu",
    style: {
      display: "none",
      width: "166px"
    }
  }, /*#__PURE__*/react.createElement(CustomColor, {
    onCustomPick: function onCustomPick(color) {
      onPick(color, changeStyle);
      colorPreviewRef.current.style.backgroundColor = changeColor;
      setchangeColor(color);
    },
    onColorPick: function onColorPick(color) {
      onPick(color, changeStyle);
      setchangeColor(color);
    }
  }))), /*#__PURE__*/react.createElement("div", {
    className: "fortune-border-select-option",
    key: "borderStyle",
    onMouseEnter: function onMouseEnter(e) {
      showBorderSubMenu(e);
    },
    onMouseLeave: function onMouseLeave() {
      hideBorderSubMenu();
    }
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-toolbar-menu-line"
  }, border.borderStyle, /*#__PURE__*/react.createElement(SVGIcon, {
    name: "rightArrow",
    style: {
      width: "14px"
    }
  })), /*#__PURE__*/react.createElement("div", {
    className: "fortune-border-style-preview"
  }, /*#__PURE__*/react.createElement("svg", {
    width: "90"
  }, /*#__PURE__*/react.createElement("g", {
    fill: "none",
    stroke: "black",
    strokeWidth: previewWith
  }, /*#__PURE__*/react.createElement("path", {
    strokeDasharray: previewdasharry,
    d: "M0 0 l90 0"
  })))), /*#__PURE__*/react.createElement("div", {
    ref: styleRef,
    className: "fortune-border-select-menu fortune-toolbar-select",
    style: {
      display: "none",
      width: "110px"
    }
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-border-style-picker-menu fortune-border-style-reset",
    onClick: function onClick() {
      onPick(changeColor, "1");
      changePreviewStyle("1", "1,0");
    },
    tabIndex: 0
  }, border.borderDefault), /*#__PURE__*/react.createElement("div", {
    className: "fortune-boder-style-picker"
  }, size.map(function (items, i) {
    return /*#__PURE__*/react.createElement("div", {
      key: i,
      className: "fortune-border-style-picker-menu",
      onClick: function onClick() {
        onPick(changeColor, items.Text);
        setchangeStyle(items.Text);
        changePreviewStyle(items.strokeWidth, items.strokeDasharray);
      },
      tabIndex: 0
    }, /*#__PURE__*/react.createElement("svg", {
      height: "10",
      width: "90"
    }, /*#__PURE__*/react.createElement("g", {
      fill: "none",
      stroke: "black",
      strokeWidth: items.strokeWidth
    }, /*#__PURE__*/react.createElement("path", {
      strokeDasharray: items.strokeDasharray,
      d: "M0 5 l85 0"
    }))));
  })))));
};
var FormatSearch = function FormatSearch(_ref) {
  var type = _ref.type,
    _onCancel = _ref.onCancel;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    cellInput = _useContext.refs.cellInput;
  var _useState = (0,react.useState)(2),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    decimalPlace = _useState2[0],
    setDecimalPlace = _useState2[1];
  var _useState3 = (0,react.useState)(0),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    selectedFormatIndex = _useState4[0],
    setSelectedFormatIndex = _useState4[1];
  var _locale = locale(context),
    button = _locale.button,
    format = _locale.format,
    currencyDetail = _locale.currencyDetail,
    dateFmtList = _locale.dateFmtList;
  var _useDialog = useDialog(),
    showDialog = _useDialog.showDialog;
  var toolbarFormatAll = (0,react.useMemo)(function () {
    return {
      currency: currencyDetail,
      date: dateFmtList,
      number: []
    };
  }, [currencyDetail, dateFmtList]);
  var toolbarFormat = (0,react.useMemo)(function () {
    return toolbarFormatAll[type];
  }, [toolbarFormatAll, type]);
  var tips = lodash_default().get(format, type);
  var onConfirm = (0,react.useCallback)(function () {
    if (decimalPlace < 0 || decimalPlace > 9) {
      _onCancel();
      showDialog(format.tipDecimalPlaces, "ok");
      return;
    }
    setContext(function (ctx) {
      var index = getSheetIndex(ctx, ctx.currentSheetId);
      if (lodash_default().isNil(index)) return;
      var selectedFormat = toolbarFormat[selectedFormatIndex].value;
      lodash_default().forEach(ctx.luckysheet_select_save, function (selection) {
        for (var r = selection.row[0]; r <= selection.row[1]; r += 1) {
          for (var c = selection.column[0]; c <= selection.column[1]; c += 1) {
            var _ctx$luckysheetfile$i, _ctx$luckysheetfile$i2, _ctx$luckysheetfile$i3, _ctx$luckysheetfile$i4;
            if (((_ctx$luckysheetfile$i = ctx.luckysheetfile[index].data) === null || _ctx$luckysheetfile$i === void 0 ? void 0 : _ctx$luckysheetfile$i[r][c]) && ((_ctx$luckysheetfile$i2 = ctx.luckysheetfile[index].data) === null || _ctx$luckysheetfile$i2 === void 0 ? void 0 : (_ctx$luckysheetfile$i3 = _ctx$luckysheetfile$i2[r][c]) === null || _ctx$luckysheetfile$i3 === void 0 ? void 0 : (_ctx$luckysheetfile$i4 = _ctx$luckysheetfile$i3.ct) === null || _ctx$luckysheetfile$i4 === void 0 ? void 0 : _ctx$luckysheetfile$i4.t) === "n") {
              var zero = 0;
              ctx.luckysheetfile[index].data[r][c].ct.fa = "".concat(selectedFormat).concat(zero.toFixed(decimalPlace));
              ctx.luckysheetfile[index].data[r][c].m = update("".concat(selectedFormat).concat(zero.toFixed(decimalPlace)), ctx.luckysheetfile[index].data[r][c].v);
            }
          }
        }
      });
      _onCancel();
    });
  }, [_onCancel, decimalPlace, format.tipDecimalPlaces, selectedFormatIndex, setContext, showDialog, toolbarFormat]);
  var onCancel = (0,react.useCallback)(function () {
    setContext(function (ctx) {
      cancelNormalSelected(ctx);
      if (cellInput.current) {
        cellInput.current.innerHTML = "";
      }
    });
    _onCancel();
  }, [_onCancel, cellInput, setContext]);
  return /*#__PURE__*/react.createElement("div", {
    id: "luckysheet-search-format"
  }, /*#__PURE__*/react.createElement("div", {
    className: "listbox",
    style: {
      height: 200
    }
  }, /*#__PURE__*/react.createElement("div", {
    style: {
      marginBottom: 16
    }
  }, tips, format.format, "\uFF1A"), /*#__PURE__*/react.createElement("div", {
    className: "inpbox",
    style: type === "currency" ? {
      display: "block"
    } : {
      display: "none"
    }
  }, format.decimalPlaces, "\uFF1A", /*#__PURE__*/react.createElement("input", {
    className: "decimal-places-input",
    id: "decimal-places-input",
    min: 0,
    max: 9,
    defaultValue: 2,
    type: "number",
    onChange: function onChange(e) {
      setDecimalPlace(parseInt(e.target.value, 10));
    }
  })), /*#__PURE__*/react.createElement("div", {
    className: "format-list"
  }, toolbarFormat.map(function (v, index) {
    return /*#__PURE__*/react.createElement("div", {
      className: "listBox".concat(index === selectedFormatIndex ? " on" : ""),
      key: v.name,
      onClick: function onClick() {
        setSelectedFormatIndex(index);
      },
      tabIndex: 0
    }, /*#__PURE__*/react.createElement("div", null, v.name), /*#__PURE__*/react.createElement("div", null, v.value));
  }))), /*#__PURE__*/react.createElement("div", {
    className: "fortune-dialog-box-button-container",
    style: type === "currency" ? {
      marginTop: 40
    } : {
      marginTop: 30
    }
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-message-box-button button-primary",
    onClick: onConfirm,
    tabIndex: 0
  }, button.confirm), /*#__PURE__*/react.createElement("div", {
    className: "fortune-message-box-button button-default",
    onClick: onCancel,
    tabIndex: 0
  }, button.cancel)));
};
var Toolbar = function Toolbar(_ref) {
  var _context$luckysheet_s, _flowdata$row, _settings$customToolb;
  var setMoreItems = _ref.setMoreItems,
    moreItemsOpen = _ref.moreItemsOpen;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    refs = _useContext.refs,
    settings = _useContext.settings,
    handleUndo = _useContext.handleUndo,
    handleRedo = _useContext.handleRedo;
  var contextRef = (0,react.useRef)(context);
  var containerRef = (0,react.useRef)(null);
  var _useState = (0,react.useState)(-1),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    toolbarWrapIndex = _useState2[0],
    setToolbarWrapIndex = _useState2[1];
  var _useState3 = (0,react.useState)([]),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    itemLocations = _useState4[0],
    setItemLocations = _useState4[1];
  var _useDialog = useDialog(),
    showDialog = _useDialog.showDialog,
    hideDialog = _useDialog.hideDialog;
  var firstSelection = (_context$luckysheet_s = context.luckysheet_select_save) === null || _context$luckysheet_s === void 0 ? void 0 : _context$luckysheet_s[0];
  var flowdata = getFlowdata(context);
  contextRef.current = context;
  var row = firstSelection === null || firstSelection === void 0 ? void 0 : firstSelection.row_focus;
  var col = firstSelection === null || firstSelection === void 0 ? void 0 : firstSelection.column_focus;
  var cell = flowdata && row != null && col != null ? flowdata === null || flowdata === void 0 ? void 0 : (_flowdata$row = flowdata[row]) === null || _flowdata$row === void 0 ? void 0 : _flowdata$row[col] : undefined;
  var _locale = locale(context),
    toolbar = _locale.toolbar,
    merge = _locale.merge,
    border = _locale.border,
    freezen = _locale.freezen,
    defaultFmt = _locale.defaultFmt,
    formula = _locale.formula,
    sort = _locale.sort,
    align = _locale.align,
    textWrap = _locale.textWrap,
    rotation = _locale.rotation,
    screenshot = _locale.screenshot,
    filter = _locale.filter,
    splitText = _locale.splitText,
    findAndReplace = _locale.findAndReplace,
    comment = _locale.comment,
    fontarray = _locale.fontarray;
  var toolbarFormat = locale(context).format;
  var sheetWidth = context.luckysheetTableContentHW[0];
  var currency = settings.currency;
  var defaultFormat = defaultFmt(currency);
  var _useState5 = (0,react.useState)("#000000"),
    _useState6 = dist_index_esm_slicedToArray(_useState5, 2),
    customColor = _useState6[0],
    setcustomColor = _useState6[1];
  var _useState7 = (0,react.useState)("1"),
    _useState8 = dist_index_esm_slicedToArray(_useState7, 2),
    customStyle = _useState8[0],
    setcustomStyle = _useState8[1];
  var showSubMenu = (0,react.useCallback)(function (e, className) {
    var target = e.target;
    var menuItem = target.className === "fortune-toolbar-menu-line" ? target.parentElement : target;
    var menuItemRect = menuItem.getBoundingClientRect();
    var workbookContainerRect = refs.workbookContainer.current.getBoundingClientRect();
    var subMenu = menuItem.querySelector(".".concat(className));
    if (lodash_default().isNil(subMenu)) return;
    var menuItemStyle = window.getComputedStyle(menuItem);
    var menuItemPaddingRight = parseFloat(menuItemStyle.getPropertyValue("padding-right").replace("px", ""));
    if (workbookContainerRect.right - menuItemRect.right < parseFloat(subMenu.style.width.replace("px", ""))) {
      subMenu.style.display = "block";
      subMenu.style.right = "".concat(menuItemRect.width - menuItemPaddingRight, "px");
    } else {
      subMenu.style.display = "block";
      subMenu.style.right = className === "more-format" ? "".concat(-(parseFloat(subMenu.style.width.replace("px", "")) + 0), "px") : "".concat(-(parseFloat(subMenu.style.width.replace("px", "")) + menuItemPaddingRight), "px");
    }
  }, [refs.workbookContainer]);
  var hideSubMenu = (0,react.useCallback)(function (e, className) {
    var target = e.target;
    if (target.className === "".concat(className)) {
      target.style.display = "none";
      return;
    }
    var subMenu = target.className === "condition-format-item" ? target.parentElement : target.querySelector(".".concat(className));
    if (lodash_default().isNil(subMenu)) return;
    subMenu.style.display = "none";
  }, []);
  (0,react.useEffect)(function () {
    setToolbarWrapIndex(-1);
  }, [settings.toolbarItems, settings.customToolbarItems]);
  (0,react.useEffect)(function () {
    if (toolbarWrapIndex === -1) {
      var container = containerRef.current;
      if (!container) return;
      var items = container.querySelectorAll(".fortune-toolbar-item");
      if (!items) return;
      var locations = [];
      var containerRect = container.getBoundingClientRect();
      for (var i = 0; i < items.length; i += 1) {
        var item = items[i];
        var itemRect = item.getBoundingClientRect();
        locations.push(itemRect.left - containerRect.left + itemRect.width);
      }
      setItemLocations(locations);
    }
  }, [toolbarWrapIndex, sheetWidth]);
  (0,react.useEffect)(function () {
    if (itemLocations.length === 0) return;
    var container = containerRef.current;
    if (!container) return;
    var moreButtonWidth = 50;
    for (var i = itemLocations.length - 1; i >= 0; i -= 1) {
      var loc = itemLocations[i];
      if (loc + moreButtonWidth < container.clientWidth) {
        setToolbarWrapIndex(i - itemLocations.length + settings.toolbarItems.length);
        if (i === itemLocations.length - 1) {
          setMoreItems(null);
        }
        break;
      }
    }
  }, [itemLocations, setMoreItems, settings.toolbarItems.length, sheetWidth]);
  var getToolbarItem = (0,react.useCallback)(function (name, i) {
    var _toolbarItemSelectedF;
    var tooltip = toolbar[name];
    if (name === "|") {
      return /*#__PURE__*/react.createElement(Divider, {
        key: i
      });
    }
    if (["font-color", "background"].includes(name)) {
      var pick = function pick(color) {
        setContext(function (draftCtx) {
          return (name === "font-color" ? handleTextColor : handleTextBackground)(draftCtx, refs.cellInput.current, color);
        });
        if (name === "font-color") {
          refs.globalCache.recentTextColor = color;
        } else {
          refs.globalCache.recentBackgroundColor = color;
        }
      };
      return /*#__PURE__*/react.createElement("div", {
        style: {
          position: "relative"
        },
        key: name
      }, /*#__PURE__*/react.createElement("div", {
        style: {
          width: 17,
          height: 2,
          backgroundColor: name === "font-color" ? refs.globalCache.recentTextColor : refs.globalCache.recentBackgroundColor,
          position: "absolute",
          bottom: 8,
          left: 9,
          zIndex: 100
        }
      }), /*#__PURE__*/react.createElement(Combo, {
        iconId: name,
        tooltip: tooltip,
        onClick: function onClick() {
          var color = name === "font-color" ? refs.globalCache.recentTextColor : refs.globalCache.recentBackgroundColor;
          if (color) pick(color);
        }
      }, function (setOpen) {
        return /*#__PURE__*/react.createElement(CustomColor, {
          onCustomPick: function onCustomPick(color) {
            pick(color);
            setOpen(false);
          },
          onColorPick: pick
        });
      }));
    }
    if (name === "format") {
      var currentFmt = defaultFormat[0].text;
      if (cell) {
        var curr = normalizedCellAttr(cell, "ct");
        var format = lodash_default().find(defaultFormat, function (v) {
          return v.value === (curr === null || curr === void 0 ? void 0 : curr.fa);
        });
        if ((curr === null || curr === void 0 ? void 0 : curr.fa) != null) {
          if (format != null) {
            currentFmt = format.text;
          } else {
            currentFmt = defaultFormat[defaultFormat.length - 1].text;
          }
        }
      }
      return /*#__PURE__*/react.createElement(Combo, {
        text: currentFmt,
        key: name,
        tooltip: tooltip
      }, function (setOpen) {
        return /*#__PURE__*/react.createElement(Select, null, defaultFormat.map(function (_ref2, ii) {
          var text = _ref2.text,
            value = _ref2.value,
            example = _ref2.example;
          if (value === "split") {
            return /*#__PURE__*/react.createElement(MenuDivider, {
              key: ii
            });
          }
          if (value === "fmtOtherSelf") {
            return /*#__PURE__*/react.createElement(Option, {
              key: value,
              onMouseEnter: function onMouseEnter(e) {
                return showSubMenu(e, "more-format");
              },
              onMouseLeave: function onMouseLeave(e) {
                return hideSubMenu(e, "more-format");
              }
            }, /*#__PURE__*/react.createElement("div", {
              className: "fortune-toolbar-menu-line"
            }, /*#__PURE__*/react.createElement("div", null, text), /*#__PURE__*/react.createElement(SVGIcon, {
              name: "rightArrow",
              width: 14
            })), /*#__PURE__*/react.createElement("div", {
              className: "more-format toolbar-item-sub-menu fortune-toolbar-select",
              style: {
                display: "none",
                width: 150,
                bottom: 10,
                top: undefined
              }
            }, [{
              text: toolbarFormat.moreCurrency,
              onclick: function onclick() {
                showDialog(/*#__PURE__*/react.createElement(FormatSearch, {
                  onCancel: hideDialog,
                  type: "currency"
                }));
                setOpen(false);
              }
            }].map(function (v) {
              return /*#__PURE__*/react.createElement("div", {
                className: "set-background-item fortune-toolbar-select-option",
                key: v.text,
                onClick: function onClick() {
                  v.onclick();
                  setOpen(false);
                },
                tabIndex: 0
              }, v.text);
            })));
          }
          return /*#__PURE__*/react.createElement(Option, {
            key: value,
            onClick: function onClick() {
              setOpen(false);
              setContext(function (ctx) {
                var d = getFlowdata(ctx);
                if (d == null) return;
                updateFormat(ctx, refs.cellInput.current, d, "ct", value);
              });
            }
          }, /*#__PURE__*/react.createElement("div", {
            className: "fortune-toolbar-menu-line"
          }, /*#__PURE__*/react.createElement("div", null, text), /*#__PURE__*/react.createElement("div", {
            className: "fortune-toolbar-subtext"
          }, example)));
        }));
      });
    }
    if (name === "font") {
      var current = fontarray[0];
      if ((cell === null || cell === void 0 ? void 0 : cell.ff) != null) {
        if (lodash_default().isNumber(cell.ff)) {
          current = fontarray[cell.ff];
        } else {
          current = cell.ff;
        }
      }
      return /*#__PURE__*/react.createElement(Combo, {
        text: current,
        key: name,
        tooltip: tooltip
      }, function (setOpen) {
        return /*#__PURE__*/react.createElement(Select, null, fontarray.map(function (o) {
          return /*#__PURE__*/react.createElement(Option, {
            key: o,
            onClick: function onClick() {
              setContext(function (ctx) {
                current = o;
                var d = getFlowdata(ctx);
                if (!d) return;
                updateFormat(ctx, refs.cellInput.current, d, "ff", o);
              });
              setOpen(false);
            }
          }, o);
        }));
      });
    }
    if (name === "font-size") {
      return /*#__PURE__*/react.createElement(Combo, {
        text: cell ? normalizedCellAttr(cell, "fs", context.defaultFontSize) : context.defaultFontSize.toString(),
        key: name,
        tooltip: tooltip
      }, function (setOpen) {
        return /*#__PURE__*/react.createElement(Select, null, [9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72].map(function (num) {
          return /*#__PURE__*/react.createElement(Option, {
            key: num,
            onClick: function onClick() {
              setContext(function (draftContext) {
                return handleTextSize(draftContext, refs.cellInput.current, num, refs.canvas.current.getContext("2d"));
              });
              setOpen(false);
            }
          }, num);
        }));
      });
    }
    if (name === "horizontal-align") {
      var _$find;
      var items = [{
        title: "align-left",
        text: align.left,
        value: 1
      }, {
        title: "align-center",
        text: align.center,
        value: 0
      }, {
        title: "align-right",
        text: align.right,
        value: 2
      }];
      return /*#__PURE__*/react.createElement(Combo, {
        iconId: ((_$find = lodash_default().find(items, function (item) {
          return "".concat(item.value) === "".concat(cell === null || cell === void 0 ? void 0 : cell.ht);
        })) === null || _$find === void 0 ? void 0 : _$find.title) || "align-left",
        key: name,
        tooltip: toolbar.horizontalAlign
      }, function (setOpen) {
        return /*#__PURE__*/react.createElement(Select, null, items.map(function (_ref3) {
          var text = _ref3.text,
            title = _ref3.title;
          return /*#__PURE__*/react.createElement(Option, {
            key: title,
            onClick: function onClick() {
              setContext(function (ctx) {
                handleHorizontalAlign(ctx, refs.cellInput.current, title.replace("align-", ""));
              });
              setOpen(false);
            }
          }, /*#__PURE__*/react.createElement("div", {
            className: "fortune-toolbar-menu-line"
          }, text, /*#__PURE__*/react.createElement(SVGIcon, {
            name: title
          })));
        }));
      });
    }
    if (name === "vertical-align") {
      var _$find2;
      var _items = [{
        title: "align-top",
        text: align.top,
        value: 1
      }, {
        title: "align-middle",
        text: align.middle,
        value: 0
      }, {
        title: "align-bottom",
        text: align.bottom,
        value: 2
      }];
      return /*#__PURE__*/react.createElement(Combo, {
        iconId: ((_$find2 = lodash_default().find(_items, function (item) {
          return "".concat(item.value) === "".concat(cell === null || cell === void 0 ? void 0 : cell.vt);
        })) === null || _$find2 === void 0 ? void 0 : _$find2.title) || "align-top",
        key: name,
        tooltip: toolbar.verticalAlign
      }, function (setOpen) {
        return /*#__PURE__*/react.createElement(Select, null, _items.map(function (_ref4) {
          var text = _ref4.text,
            title = _ref4.title;
          return /*#__PURE__*/react.createElement(Option, {
            key: title,
            onClick: function onClick() {
              setContext(function (ctx) {
                handleVerticalAlign(ctx, refs.cellInput.current, title.replace("align-", ""));
              });
              setOpen(false);
            }
          }, /*#__PURE__*/react.createElement("div", {
            className: "fortune-toolbar-menu-line"
          }, text, /*#__PURE__*/react.createElement(SVGIcon, {
            name: title
          })));
        }));
      });
    }
    if (name === "undo") {
      return /*#__PURE__*/react.createElement(Button, {
        iconId: name,
        tooltip: tooltip,
        key: name,
        disabled: refs.globalCache.undoList.length === 0,
        onClick: function onClick() {
          return handleUndo();
        }
      });
    }
    if (name === "redo") {
      return /*#__PURE__*/react.createElement(Button, {
        iconId: name,
        tooltip: tooltip,
        key: name,
        disabled: refs.globalCache.redoList.length === 0,
        onClick: function onClick() {
          return handleRedo();
        }
      });
    }
    if (name === "screenshot") {
      return /*#__PURE__*/react.createElement(Button, {
        iconId: name,
        tooltip: tooltip,
        key: name,
        onClick: function onClick() {
          var imgsrc = handleScreenShot(contextRef.current);
          if (imgsrc) {
            showDialog(/*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, screenshot.screenshotTipSuccess), /*#__PURE__*/react.createElement("img", {
              src: imgsrc,
              alt: "",
              style: {
                maxWidth: "100%",
                maxHeight: "100%"
              }
            })));
          }
        }
      });
    }
    if (name === "splitColumn") {
      return /*#__PURE__*/react.createElement(Button, {
        iconId: name,
        tooltip: tooltip,
        key: name,
        onClick: function onClick() {
          if (context.allowEdit === false) return;
          if (lodash_default().isUndefined(context.luckysheet_select_save)) {
            showDialog(splitText.tipNoSelect, "ok");
          } else {
            var currentColumn = context.luckysheet_select_save[context.luckysheet_select_save.length - 1].column;
            if (context.luckysheet_select_save.length > 1) {
              showDialog(splitText.tipNoMulti, "ok");
            } else if (currentColumn[0] !== currentColumn[1]) {
              showDialog(splitText.tipNoMultiColumn, "ok");
            } else {
              showDialog(/*#__PURE__*/react.createElement(SplitColumn, null));
            }
          }
        }
      });
    }
    if (name === "dataVerification") {
      return /*#__PURE__*/react.createElement(Button, {
        iconId: name,
        tooltip: tooltip,
        key: name,
        onClick: function onClick() {
          if (context.allowEdit === false) return;
          showDialog(/*#__PURE__*/react.createElement(DataVerification, null));
        }
      });
    }
    if (name === "locationCondition") {
      var _items2 = [{
        text: findAndReplace.location,
        value: "location"
      }, {
        text: findAndReplace.locationFormula,
        value: "locationFormula"
      }, {
        text: findAndReplace.locationDate,
        value: "locationDate"
      }, {
        text: findAndReplace.locationDigital,
        value: "locationDigital"
      }, {
        text: findAndReplace.locationString,
        value: "locationString"
      }, {
        text: findAndReplace.locationError,
        value: "locationError"
      }, {
        text: findAndReplace.locationRowSpan,
        value: "locationRowSpan"
      }, {
        text: findAndReplace.columnSpan,
        value: "locationColumnSpan"
      }];
      return /*#__PURE__*/react.createElement(Combo, {
        iconId: "locationCondition",
        key: name,
        tooltip: findAndReplace.location
      }, function (setOpen) {
        return /*#__PURE__*/react.createElement(Select, null, _items2.map(function (_ref5) {
          var text = _ref5.text,
            value = _ref5.value;
          return /*#__PURE__*/react.createElement(Option, {
            key: value,
            onClick: function onClick() {
              var _context$luckysheet_s2, _context$luckysheet_s3;
              if (context.luckysheet_select_save == null) {
                showDialog(freezen.noSeletionError, "ok");
                return;
              }
              var last = context.luckysheet_select_save[0];
              var range;
              var rangeArr = [];
              if (((_context$luckysheet_s2 = context.luckysheet_select_save) === null || _context$luckysheet_s2 === void 0 ? void 0 : _context$luckysheet_s2.length) === 0 || ((_context$luckysheet_s3 = context.luckysheet_select_save) === null || _context$luckysheet_s3 === void 0 ? void 0 : _context$luckysheet_s3.length) === 1 && last.row[0] === last.row[1] && last.column[0] === last.column[1]) {
                range = [{
                  row: [0, flowdata.length - 1],
                  column: [0, flowdata[0].length - 1]
                }];
              } else {
                range = lodash_default().assignIn([], context.luckysheet_select_save);
              }
              if (value === "location") {
                showDialog(/*#__PURE__*/react.createElement(LocationCondition, null));
              } else if (value === "locationFormula") {
                setContext(function (ctx) {
                  rangeArr = applyLocation(range, "locationFormula", "all", ctx);
                });
              } else if (value === "locationDate") {
                setContext(function (ctx) {
                  rangeArr = applyLocation(range, "locationConstant", "d", ctx);
                });
              } else if (value === "locationDigital") {
                setContext(function (ctx) {
                  rangeArr = applyLocation(range, "locationConstant", "n", ctx);
                });
              } else if (value === "locationString") {
                setContext(function (ctx) {
                  rangeArr = applyLocation(range, "locationConstant", "s,g", ctx);
                });
              } else if (value === "locationError") {
                setContext(function (ctx) {
                  rangeArr = applyLocation(range, "locationConstant", "e", ctx);
                });
              } else if (value === "locationCondition") {
                setContext(function (ctx) {
                  rangeArr = applyLocation(range, "locationCF", undefined, ctx);
                });
              } else if (value === "locationRowSpan") {
                var _context$luckysheet_s4, _context$luckysheet_s5;
                if (((_context$luckysheet_s4 = context.luckysheet_select_save) === null || _context$luckysheet_s4 === void 0 ? void 0 : _context$luckysheet_s4.length) === 0 || ((_context$luckysheet_s5 = context.luckysheet_select_save) === null || _context$luckysheet_s5 === void 0 ? void 0 : _context$luckysheet_s5.length) === 1 && context.luckysheet_select_save[0].row[0] === context.luckysheet_select_save[0].row[1]) {
                  showDialog(findAndReplace.locationTiplessTwoRow, "ok");
                  return;
                }
                range = lodash_default().assignIn([], context.luckysheet_select_save);
                setContext(function (ctx) {
                  rangeArr = applyLocation(range, "locationRowSpan", undefined, ctx);
                });
              } else if (value === "locationColumnSpan") {
                var _context$luckysheet_s6, _context$luckysheet_s7;
                if (((_context$luckysheet_s6 = context.luckysheet_select_save) === null || _context$luckysheet_s6 === void 0 ? void 0 : _context$luckysheet_s6.length) === 0 || ((_context$luckysheet_s7 = context.luckysheet_select_save) === null || _context$luckysheet_s7 === void 0 ? void 0 : _context$luckysheet_s7.length) === 1 && context.luckysheet_select_save[0].column[0] === context.luckysheet_select_save[0].column[1]) {
                  showDialog(findAndReplace.locationTiplessTwoColumn, "ok");
                  return;
                }
                range = lodash_default().assignIn([], context.luckysheet_select_save);
                setContext(function (ctx) {
                  rangeArr = applyLocation(range, "locationColumnSpan", undefined, ctx);
                });
              }
              if (rangeArr.length === 0 && value !== "location") showDialog(findAndReplace.locationTipNotFindCell, "ok");
              setOpen(false);
            }
          }, /*#__PURE__*/react.createElement("div", {
            className: "fortune-toolbar-menu-line"
          }, text));
        }));
      });
    }
    if (name === "conditionFormat") {
      var _items3 = ["highlightCellRules", "itemSelectionRules", "-", "deleteRule"];
      return /*#__PURE__*/react.createElement(Combo, {
        iconId: "conditionFormat",
        key: name,
        tooltip: toolbar.conditionalFormat
      }, function (setOpen) {
        return /*#__PURE__*/react.createElement(ConditionalFormat, {
          items: _items3,
          setOpen: setOpen
        });
      });
    }
    if (name === "image") {
      return /*#__PURE__*/react.createElement(Button, {
        iconId: name,
        tooltip: toolbar.insertImage,
        key: name,
        onClick: function onClick() {
          if (context.allowEdit === false) return;
          showImgChooser();
        }
      }, /*#__PURE__*/react.createElement("input", {
        id: "fortune-img-upload",
        type: "file",
        accept: "image/*",
        style: {
          display: "none"
        },
        onChange: function onChange(e) {
          var _e$currentTarget$file;
          var file = (_e$currentTarget$file = e.currentTarget.files) === null || _e$currentTarget$file === void 0 ? void 0 : _e$currentTarget$file[0];
          if (!file) return;
          var render = new FileReader();
          render.readAsDataURL(file);
          render.onload = function (event) {
            var _event$target;
            if (event.target == null) return;
            var src = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.result;
            var image = new Image();
            image.onload = function () {
              setContext(function (draftCtx) {
                insertImage(draftCtx, image);
              });
            };
            image.src = src;
          };
          e.currentTarget.value = "";
        }
      }));
    }
    if (name === "comment") {
      var _context$luckysheet_s8, _flowdata$row_index, _flowdata$row_index$c;
      var last = (_context$luckysheet_s8 = context.luckysheet_select_save) === null || _context$luckysheet_s8 === void 0 ? void 0 : _context$luckysheet_s8[context.luckysheet_select_save.length - 1];
      var row_index = last === null || last === void 0 ? void 0 : last.row_focus;
      var col_index = last === null || last === void 0 ? void 0 : last.column_focus;
      if (!last) {
        row_index = 0;
        col_index = 0;
      } else {
        if (row_index == null) {
          var _last$row = dist_index_esm_slicedToArray(last.row, 1);
          row_index = _last$row[0];
        }
        if (col_index == null) {
          var _last$column = dist_index_esm_slicedToArray(last.column, 1);
          col_index = _last$column[0];
        }
      }
      var itemData;
      if ((flowdata === null || flowdata === void 0 ? void 0 : (_flowdata$row_index = flowdata[row_index]) === null || _flowdata$row_index === void 0 ? void 0 : (_flowdata$row_index$c = _flowdata$row_index[col_index]) === null || _flowdata$row_index$c === void 0 ? void 0 : _flowdata$row_index$c.ps) != null) {
        itemData = [{
          key: "edit",
          text: comment.edit,
          onClick: editComment
        }, {
          key: "delete",
          text: comment.delete,
          onClick: deleteComment
        }, {
          key: "showOrHide",
          text: comment.showOne,
          onClick: showHideComment
        }, {
          key: "showOrHideAll",
          text: comment.showAll,
          onClick: showHideAllComments
        }];
      } else {
        itemData = [{
          key: "new",
          text: comment.insert,
          onClick: newComment
        }, {
          key: "showOrHideAll",
          text: comment.showAll,
          onClick: showHideAllComments
        }];
      }
      return /*#__PURE__*/react.createElement(Combo, {
        iconId: name,
        key: name,
        tooltip: tooltip
      }, function (setOpen) {
        return /*#__PURE__*/react.createElement(Select, null, itemData.map(function (_ref6) {
          var key = _ref6.key,
            text = _ref6.text,
            _onClick = _ref6.onClick;
          return /*#__PURE__*/react.createElement(Option, {
            key: key,
            onClick: function onClick() {
              setContext(function (draftContext) {
                return _onClick(draftContext, refs.globalCache, row_index, col_index);
              });
              setOpen(false);
            }
          }, text);
        }));
      });
    }
    if (name === "quick-formula") {
      var _itemData = [{
        text: formula.sum,
        value: "SUM"
      }, {
        text: formula.average,
        value: "AVERAGE"
      }, {
        text: formula.count,
        value: "COUNT"
      }, {
        text: formula.max,
        value: "MAX"
      }, {
        text: formula.min,
        value: "MIN"
      }];
      return /*#__PURE__*/react.createElement(Combo, {
        iconId: "formula-sum",
        key: name,
        tooltip: toolbar.autoSum,
        onClick: function onClick() {
          return setContext(function (ctx) {
            handleSum(ctx, refs.cellInput.current, refs.fxInput.current, refs.globalCache);
          });
        }
      }, function (setOpen) {
        return /*#__PURE__*/react.createElement(Select, null, _itemData.map(function (_ref7) {
          var value = _ref7.value,
            text = _ref7.text;
          return /*#__PURE__*/react.createElement(Option, {
            key: value,
            onClick: function onClick() {
              setContext(function (ctx) {
                autoSelectionFormula(ctx, refs.cellInput.current, refs.fxInput.current, value, refs.globalCache);
              });
              setOpen(false);
            }
          }, /*#__PURE__*/react.createElement("div", {
            className: "fortune-toolbar-menu-line"
          }, /*#__PURE__*/react.createElement("div", null, text), /*#__PURE__*/react.createElement("div", {
            className: "fortune-toolbar-subtext"
          }, value)));
        }), /*#__PURE__*/react.createElement(MenuDivider, null), /*#__PURE__*/react.createElement(Option, {
          key: "formula",
          onClick: function onClick() {
            showDialog(/*#__PURE__*/react.createElement(FormulaSearch$1, {
              onCancel: hideDialog
            }));
            setOpen(false);
          }
        }, "".concat(formula.find, "...")));
      });
    }
    if (name === "merge-cell") {
      var itemdata = [{
        text: merge.mergeAll,
        value: "merge-all"
      }, {
        text: merge.mergeV,
        value: "merge-vertical"
      }, {
        text: merge.mergeH,
        value: "merge-horizontal"
      }, {
        text: merge.mergeCancel,
        value: "merge-cancel"
      }];
      return /*#__PURE__*/react.createElement(Combo, {
        iconId: "merge-all",
        key: name,
        tooltip: tooltip,
        text: "\u5408\u5E76\u5355\u5143\u683C",
        onClick: function onClick() {
          return setContext(function (ctx) {
            handleMerge(ctx, "merge-all");
          });
        }
      }, function (setOpen) {
        return /*#__PURE__*/react.createElement(Select, null, itemdata.map(function (_ref8) {
          var text = _ref8.text,
            value = _ref8.value;
          return /*#__PURE__*/react.createElement(Option, {
            key: value,
            onClick: function onClick() {
              setContext(function (ctx) {
                handleMerge(ctx, value);
              });
              setOpen(false);
            }
          }, /*#__PURE__*/react.createElement("div", {
            className: "fortune-toolbar-menu-line"
          }, /*#__PURE__*/react.createElement(SVGIcon, {
            name: value,
            style: {
              marginRight: 4
            }
          }), text));
        }));
      });
    }
    if (name === "border") {
      var _items4 = [{
        text: border.borderTop,
        value: "border-top"
      }, {
        text: border.borderBottom,
        value: "border-bottom"
      }, {
        text: border.borderLeft,
        value: "border-left"
      }, {
        text: border.borderRight,
        value: "border-right"
      }, {
        text: "",
        value: "divider"
      }, {
        text: border.borderNone,
        value: "border-none"
      }, {
        text: border.borderAll,
        value: "border-all"
      }, {
        text: border.borderOutside,
        value: "border-outside"
      }, {
        text: "",
        value: "divider"
      }, {
        text: border.borderInside,
        value: "border-inside"
      }, {
        text: border.borderHorizontal,
        value: "border-horizontal"
      }, {
        text: border.borderVertical,
        value: "border-vertical"
      }, {
        text: border.borderSlash,
        value: "border-slash"
      }, {
        text: "",
        value: "divider"
      }];
      return /*#__PURE__*/react.createElement(Combo, {
        iconId: "border-all",
        key: name,
        tooltip: tooltip,
        text: "\u8FB9\u6846\u8BBE\u7F6E",
        onClick: function onClick() {
          return setContext(function (ctx) {
            handleBorder(ctx, "border-all", customColor, customStyle);
          });
        }
      }, function (setOpen) {
        return /*#__PURE__*/react.createElement(Select, null, _items4.map(function (_ref9, ii) {
          var text = _ref9.text,
            value = _ref9.value;
          return value !== "divider" ? /*#__PURE__*/react.createElement(Option, {
            key: value,
            onClick: function onClick() {
              setContext(function (ctx) {
                handleBorder(ctx, value, customColor, customStyle);
              });
              setOpen(false);
            }
          }, /*#__PURE__*/react.createElement("div", {
            className: "fortune-toolbar-menu-line"
          }, text, /*#__PURE__*/react.createElement(SVGIcon, {
            name: value
          }))) : /*#__PURE__*/react.createElement(MenuDivider, {
            key: ii
          });
        }), /*#__PURE__*/react.createElement(CustomBorder, {
          onPick: function onPick(color, style) {
            setcustomColor(color);
            setcustomStyle(style);
          }
        }));
      });
    }
    if (name === "freeze") {
      var _items5 = [{
        text: freezen.freezenRowRange,
        value: "freeze-row"
      }, {
        text: freezen.freezenColumnRange,
        value: "freeze-col"
      }, {
        text: freezen.freezenRCRange,
        value: "freeze-row-col"
      }, {
        text: freezen.freezenCancel,
        value: "freeze-cancel"
      }];
      return /*#__PURE__*/react.createElement(Combo, {
        iconId: "freeze-row-col",
        key: name,
        tooltip: tooltip,
        onClick: function onClick() {
          return setContext(function (ctx) {
            handleFreeze(ctx, "freeze-row-col");
          });
        }
      }, function (setOpen) {
        return /*#__PURE__*/react.createElement(Select, null, _items5.map(function (_ref10) {
          var text = _ref10.text,
            value = _ref10.value;
          return /*#__PURE__*/react.createElement(Option, {
            key: value,
            onClick: function onClick() {
              setContext(function (ctx) {
                handleFreeze(ctx, value);
              });
              setOpen(false);
            }
          }, /*#__PURE__*/react.createElement("div", {
            className: "fortune-toolbar-menu-line"
          }, text, /*#__PURE__*/react.createElement(SVGIcon, {
            name: value
          })));
        }));
      });
    }
    if (name === "text-wrap") {
      var _items6 = [{
        text: textWrap.clip,
        iconId: "text-clip",
        value: "clip"
      }, {
        text: textWrap.overflow,
        iconId: "text-overflow",
        value: "overflow"
      }, {
        text: textWrap.wrap,
        iconId: "text-wrap",
        value: "wrap"
      }];
      var _curr = _items6[0];
      if ((cell === null || cell === void 0 ? void 0 : cell.tb) != null) {
        _curr = lodash_default().get(_items6, cell.tb);
      }
      return /*#__PURE__*/react.createElement(Combo, {
        iconId: _curr.iconId,
        key: name,
        tooltip: toolbar.textWrap
      }, function (setOpen) {
        return /*#__PURE__*/react.createElement(Select, null, _items6.map(function (_ref11) {
          var text = _ref11.text,
            iconId = _ref11.iconId,
            value = _ref11.value;
          return /*#__PURE__*/react.createElement(Option, {
            key: value,
            onClick: function onClick() {
              setContext(function (ctx) {
                var d = getFlowdata(ctx);
                if (d == null) return;
                updateFormat(ctx, refs.cellInput.current, d, "tb", value);
              });
              setOpen(false);
            }
          }, /*#__PURE__*/react.createElement("div", {
            className: "fortune-toolbar-menu-line"
          }, text, /*#__PURE__*/react.createElement(SVGIcon, {
            name: iconId
          })));
        }));
      });
    }
    if (name === "text-rotation") {
      var _items7 = [{
        text: rotation.none,
        iconId: "text-rotation-none",
        value: "none"
      }, {
        text: rotation.angleup,
        iconId: "text-rotation-angleup",
        value: "angleup"
      }, {
        text: rotation.angledown,
        iconId: "text-rotation-angledown",
        value: "angledown"
      }, {
        text: rotation.vertical,
        iconId: "text-rotation-vertical",
        value: "vertical"
      }, {
        text: rotation.rotationUp,
        iconId: "text-rotation-up",
        value: "rotation-up"
      }, {
        text: rotation.rotationDown,
        iconId: "text-rotation-down",
        value: "rotation-down"
      }];
      var _curr2 = _items7[0];
      if ((cell === null || cell === void 0 ? void 0 : cell.tr) != null) {
        _curr2 = lodash_default().get(_items7, cell.tr);
      }
      return /*#__PURE__*/react.createElement(Combo, {
        iconId: _curr2.iconId,
        key: name,
        tooltip: toolbar.textRotate
      }, function (setOpen) {
        return /*#__PURE__*/react.createElement(Select, null, _items7.map(function (_ref12) {
          var text = _ref12.text,
            iconId = _ref12.iconId,
            value = _ref12.value;
          return /*#__PURE__*/react.createElement(Option, {
            key: value,
            onClick: function onClick() {
              setContext(function (ctx) {
                var d = getFlowdata(ctx);
                if (d == null) return;
                updateFormat(ctx, refs.cellInput.current, d, "tr", value);
              });
              setOpen(false);
            }
          }, /*#__PURE__*/react.createElement("div", {
            className: "fortune-toolbar-menu-line"
          }, text, /*#__PURE__*/react.createElement(SVGIcon, {
            name: iconId
          })));
        }));
      });
    }
    if (name === "filter") {
      var _items8 = [{
        iconId: "sort-asc",
        value: "sort-asc",
        text: sort.asc,
        onClick: function onClick() {
          setContext(function (ctx) {
            handleSort(ctx, true);
          });
        }
      }, {
        iconId: "sort-desc",
        value: "sort-desc",
        text: sort.desc,
        onClick: function onClick() {
          setContext(function (ctx) {
            handleSort(ctx, false);
          });
        }
      }, {
        iconId: "",
        value: "divider"
      }, {
        iconId: "filter1",
        value: "filter",
        text: filter.filter,
        onClick: function onClick() {
          return setContext(function (draftCtx) {
            createFilter(draftCtx);
          });
        }
      }, {
        iconId: "eraser",
        value: "eraser",
        text: filter.clearFilter,
        onClick: function onClick() {
          return setContext(function (draftCtx) {
            clearFilter(draftCtx);
          });
        }
      }];
      return /*#__PURE__*/react.createElement(Combo, {
        iconId: "filter",
        key: name,
        tooltip: toolbar.sortAndFilter
      }, function (setOpen) {
        return /*#__PURE__*/react.createElement(Select, null, _items8.map(function (_ref13, index) {
          var text = _ref13.text,
            iconId = _ref13.iconId,
            value = _ref13.value,
            _onClick2 = _ref13.onClick;
          return value !== "divider" ? /*#__PURE__*/react.createElement(Option, {
            key: value,
            onClick: function onClick() {
              _onClick2 === null || _onClick2 === void 0 ? void 0 : _onClick2();
              setOpen(false);
            }
          }, /*#__PURE__*/react.createElement("div", {
            className: "fortune-toolbar-menu-line"
          }, text, /*#__PURE__*/react.createElement(SVGIcon, {
            name: iconId
          }))) : /*#__PURE__*/react.createElement(MenuDivider, {
            key: "divider-".concat(index)
          });
        }));
      });
    }
    return /*#__PURE__*/react.createElement(Button, {
      iconId: name,
      tooltip: tooltip,
      key: name,
      selected: (_toolbarItemSelectedF = toolbarItemSelectedFunc(name)) === null || _toolbarItemSelectedF === void 0 ? void 0 : _toolbarItemSelectedF(cell),
      onClick: function onClick() {
        return setContext(function (draftCtx) {
          var _toolbarItemClickHand;
          (_toolbarItemClickHand = toolbarItemClickHandler(name)) === null || _toolbarItemClickHand === void 0 ? void 0 : _toolbarItemClickHand(draftCtx, refs.cellInput.current, refs.globalCache);
        });
      }
    });
  }, [toolbar, cell, setContext, refs.cellInput, refs.fxInput, refs.globalCache, defaultFormat, align, handleUndo, handleRedo, flowdata, formula, showDialog, hideDialog, merge, border, freezen, screenshot, sort, textWrap, rotation, filter, splitText, findAndReplace, context.luckysheet_select_save, context.defaultFontSize, context.allowEdit, comment, fontarray, hideSubMenu, showSubMenu, refs.canvas, customColor, customStyle, toolbarFormat.moreCurrency]);
  return /*#__PURE__*/react.createElement("div", {
    ref: containerRef,
    className: "fortune-toolbar",
    "aria-label": toolbar.toolbar
  }, settings.customToolbarItems.map(function (n) {
    return /*#__PURE__*/react.createElement(CustomButton, {
      tooltip: n.tooltip,
      onClick: n.onClick,
      key: n.key,
      icon: n.icon,
      iconName: n.iconName
    }, n.children);
  }), ((_settings$customToolb = settings.customToolbarItems) === null || _settings$customToolb === void 0 ? void 0 : _settings$customToolb.length) > 0 ? /*#__PURE__*/react.createElement(Divider, {
    key: "customDivider"
  }) : null, (toolbarWrapIndex === -1 ? settings.toolbarItems : settings.toolbarItems.slice(0, toolbarWrapIndex + 1)).map(function (name, i) {
    return getToolbarItem(name, i);
  }), toolbarWrapIndex !== -1 && toolbarWrapIndex < settings.toolbarItems.length - 1 ? /*#__PURE__*/react.createElement(Button, {
    iconId: "more",
    tooltip: toolbar.toolMore,
    onClick: function onClick() {
      if (moreItemsOpen) {
        setMoreItems(null);
      } else {
        setMoreItems(settings.toolbarItems.slice(toolbarWrapIndex + 1).map(function (name, i) {
          return getToolbarItem(name, i);
        }));
      }
    }
  }) : null);
};
var LocationBox = function LocationBox() {
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context;
  var rangeText = (0,react.useMemo)(function () {
    var lastSelection = lodash_default().last(context.luckysheet_select_save);
    if (!(lastSelection && lastSelection.row_focus != null && lastSelection.column_focus != null)) return "";
    var rf = lastSelection.row_focus;
    var cf = lastSelection.column_focus;
    if (context.config.merge != null && "".concat(rf, "_").concat(cf) in context.config.merge) {
      return getRangetxt(context, context.currentSheetId, {
        column: [cf, cf],
        row: [rf, rf]
      });
    }
    return getRangetxt(context, context.currentSheetId, lastSelection);
  }, [context.currentSheetId, context.luckysheet_select_save]);
  return /*#__PURE__*/react.createElement("div", {
    className: "fortune-name-box-container"
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-name-box",
    tabIndex: 0,
    dir: "ltr",
    "aria-autocomplete": "list"
  }, rangeText));
};
var FxEditor = function FxEditor() {
  var _context$luckysheet_s;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    refs = _useContext.refs;
  var _useState = (0,react.useState)(false),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    focused = _useState2[0],
    setFocused = _useState2[1];
  var lastKeyDownEventRef = (0,react.useRef)();
  var inputContainerRef = (0,react.useRef)(null);
  var _useState3 = (0,react.useState)(false),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    isHidenRC = _useState4[0],
    setIsHidenRC = _useState4[1];
  var firstSelection = (_context$luckysheet_s = context.luckysheet_select_save) === null || _context$luckysheet_s === void 0 ? void 0 : _context$luckysheet_s[0];
  var prevFirstSelection = usePrevious(firstSelection);
  var prevSheetId = usePrevious(context.currentSheetId);
  var recentText = (0,react.useRef)("");
  (0,react.useEffect)(function () {
    setIsHidenRC(isShowHidenCR(context));
    if (lodash_default().isEqual(prevFirstSelection, firstSelection) && context.currentSheetId === prevSheetId) {
      return;
    }
    var d = getFlowdata(context);
    var value = "";
    if (firstSelection) {
      var _d$r;
      var r = firstSelection.row_focus;
      var c = firstSelection.column_focus;
      if (lodash_default().isNil(r) || lodash_default().isNil(c)) return;
      var cell = d === null || d === void 0 ? void 0 : (_d$r = d[r]) === null || _d$r === void 0 ? void 0 : _d$r[c];
      if (cell) {
        if (isInlineStringCell(cell)) {
          value = getInlineStringNoStyle(r, c, d);
        } else if (cell.f) {
          value = getCellValue(r, c, d, "f");
        } else {
          value = valueShowEs(r, c, d);
        }
      }
      refs.fxInput.current.innerHTML = escapeHTMLTag(escapeScriptTag(value));
    } else {
      refs.fxInput.current.innerHTML = "";
    }
  }, [context.luckysheetfile, context.currentSheetId, context.luckysheet_select_save]);
  var onFocus = (0,react.useCallback)(function () {
    var _context$luckysheet_s2, _context$luckysheet_s3;
    if (context.allowEdit === false) {
      return;
    }
    if (((_context$luckysheet_s2 = (_context$luckysheet_s3 = context.luckysheet_select_save) === null || _context$luckysheet_s3 === void 0 ? void 0 : _context$luckysheet_s3.length) !== null && _context$luckysheet_s2 !== void 0 ? _context$luckysheet_s2 : 0) > 0 && !context.luckysheet_cell_selected_move && isAllowEdit(context, context.luckysheet_select_save)) {
      setFocused(true);
      setContext(function (draftCtx) {
        var last = draftCtx.luckysheet_select_save[draftCtx.luckysheet_select_save.length - 1];
        var row_index = last.row_focus;
        var col_index = last.column_focus;
        draftCtx.luckysheetCellUpdate = [row_index, col_index];
        refs.globalCache.doNotFocus = true;
      });
    }
  }, [context.config, context.luckysheet_select_save, context.luckysheetfile, context.currentSheetId, refs.globalCache, setContext]);
  var onKeyDown = (0,react.useCallback)(function (e) {
    if (context.allowEdit === false) {
      return;
    }
    lastKeyDownEventRef.current = new KeyboardEvent(e.type, e.nativeEvent);
    var key = e.key;
    recentText.current = refs.fxInput.current.innerText;
    if (key === "ArrowLeft" || key === "ArrowRight") {
      e.stopPropagation();
    }
    setContext(function (draftCtx) {
      if (context.luckysheetCellUpdate.length > 0) {
        switch (key) {
          case "Enter":
            {
              var lastCellUpdate = lodash_default().clone(draftCtx.luckysheetCellUpdate);
              updateCell(draftCtx, draftCtx.luckysheetCellUpdate[0], draftCtx.luckysheetCellUpdate[1], refs.fxInput.current);
              draftCtx.luckysheet_select_save = [{
                row: [lastCellUpdate[0], lastCellUpdate[0]],
                column: [lastCellUpdate[1], lastCellUpdate[1]],
                row_focus: lastCellUpdate[0],
                column_focus: lastCellUpdate[1]
              }];
              moveHighlightCell(draftCtx, "down", 1, "rangeOfSelect");
              e.preventDefault();
              e.stopPropagation();
              break;
            }
          case "Escape":
            {
              cancelNormalSelected(draftCtx);
              moveHighlightCell(draftCtx, "down", 0, "rangeOfSelect");
              e.preventDefault();
              e.stopPropagation();
              break;
            }
          case "ArrowLeft":
            {
              rangeHightlightselected(draftCtx, refs.fxInput.current);
              break;
            }
          case "ArrowRight":
            {
              rangeHightlightselected(draftCtx, refs.fxInput.current);
              break;
            }
        }
      }
    });
  }, [context.allowEdit, context.luckysheetCellUpdate.length, refs.fxInput, setContext]);
  var onChange = (0,react.useCallback)(function () {
    var e = lastKeyDownEventRef.current;
    if (!e) return;
    var kcode = e.keyCode;
    if (!kcode) return;
    if (!(kcode >= 112 && kcode <= 123 || kcode <= 46 || kcode === 144 || kcode === 108 || e.ctrlKey || e.altKey || e.shiftKey && (kcode === 37 || kcode === 38 || kcode === 39 || kcode === 40)) || kcode === 8 || kcode === 32 || kcode === 46 || e.ctrlKey && kcode === 86) {
      setContext(function (draftCtx) {
        handleFormulaInput(draftCtx, refs.cellInput.current, refs.fxInput.current, kcode, recentText.current);
      });
    }
  }, [refs.cellInput, refs.fxInput, setContext]);
  var allowEdit = (0,react.useMemo)(function () {
    if (context.allowEdit === false) {
      return false;
    }
    if (isHidenRC) {
      return false;
    }
    if (!isAllowEdit(context, context.luckysheet_select_save)) {
      return false;
    }
    return true;
  }, [context.config, context.luckysheet_select_save, context.luckysheetfile, context.currentSheetId, isHidenRC]);
  return /*#__PURE__*/react.createElement("div", {
    className: "fortune-fx-editor"
  }, /*#__PURE__*/react.createElement(LocationBox, null), /*#__PURE__*/react.createElement("div", {
    className: "fortune-fx-icon"
  }, /*#__PURE__*/react.createElement(SVGIcon, {
    name: "fx",
    width: 18,
    height: 18
  })), /*#__PURE__*/react.createElement("div", {
    ref: inputContainerRef,
    className: "fortune-fx-input-container"
  }, /*#__PURE__*/react.createElement(ContentEditable, {
    innerRef: function innerRef(e) {
      refs.fxInput.current = e;
    },
    className: "fortune-fx-input",
    id: "luckysheet-functionbox-cell",
    "aria-autocomplete": "list",
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onChange: onChange,
    onBlur: function onBlur() {
      return setFocused(false);
    },
    tabIndex: 0,
    allowEdit: allowEdit
  }), focused && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(FormulaSearch, {
    style: {
      top: inputContainerRef.current.clientHeight
    }
  }), /*#__PURE__*/react.createElement(FormulaHint, {
    style: {
      top: inputContainerRef.current.clientHeight
    }
  }))));
};
var SheetItem = function SheetItem(_ref) {
  var sheet = _ref.sheet,
    isDropPlaceholder = _ref.isDropPlaceholder;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    refs = _useContext.refs;
  var _useState = (0,react.useState)(false),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    editing = _useState2[0],
    setEditing = _useState2[1];
  var containerRef = (0,react.useRef)(null);
  var editable = (0,react.useRef)(null);
  var _useState3 = (0,react.useState)(false),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    dragOver = _useState4[0],
    setDragOver = _useState4[1];
  var _useState5 = (0,react.useState)("#c3c3c3"),
    _useState6 = dist_index_esm_slicedToArray(_useState5, 2),
    svgColor = _useState6[0],
    setSvgColor = _useState6[1];
  var _useAlert = useAlert(),
    showAlert = _useAlert.showAlert;
  (0,react.useEffect)(function () {
    setContext(function (draftCtx) {
      var r = context.sheetScrollRecord[draftCtx === null || draftCtx === void 0 ? void 0 : draftCtx.currentSheetId];
      if (r) {
        var _r$scrollLeft, _r$scrollTop, _r$luckysheet_select_, _r$luckysheet_select_2;
        draftCtx.scrollLeft = (_r$scrollLeft = r.scrollLeft) !== null && _r$scrollLeft !== void 0 ? _r$scrollLeft : 0;
        draftCtx.scrollTop = (_r$scrollTop = r.scrollTop) !== null && _r$scrollTop !== void 0 ? _r$scrollTop : 0;
        draftCtx.luckysheet_select_status = (_r$luckysheet_select_ = r.luckysheet_select_status) !== null && _r$luckysheet_select_ !== void 0 ? _r$luckysheet_select_ : false;
        draftCtx.luckysheet_select_save = (_r$luckysheet_select_2 = r.luckysheet_select_save) !== null && _r$luckysheet_select_2 !== void 0 ? _r$luckysheet_select_2 : undefined;
      } else {
        draftCtx.scrollLeft = 0;
        draftCtx.scrollTop = 0;
        draftCtx.luckysheet_select_status = false;
        draftCtx.luckysheet_select_save = undefined;
      }
      draftCtx.luckysheet_selection_range = [];
    });
  }, [context.currentSheetId, context.sheetScrollRecord, setContext]);
  (0,react.useEffect)(function () {
    if (!editable.current) return;
    if (editing) {
      if (window.getSelection) {
        var range = document.createRange();
        range.selectNodeContents(editable.current);
        if (range.startContainer && document.body.contains(range.startContainer)) {
          var selection = window.getSelection();
          selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
          selection === null || selection === void 0 ? void 0 : selection.addRange(range);
        }
      } else if (document.selection) {
        var _range = document.body.createTextRange();
        _range.moveToElementText(editable.current);
        _range.select();
      }
    }
    editable.current.dataset.oldText = editable.current.innerText;
  }, [editing]);
  var onBlur = (0,react.useCallback)(function () {
    setContext(function (draftCtx) {
      try {
        editSheetName(draftCtx, editable.current);
      } catch (e) {
        showAlert(e.message);
      }
    });
    setEditing(false);
  }, [setContext, showAlert]);
  var onKeyDown = (0,react.useCallback)(function (e) {
    if (e.key === "Enter") {
      var _editable$current;
      (_editable$current = editable.current) === null || _editable$current === void 0 ? void 0 : _editable$current.blur();
    }
    e.stopPropagation();
  }, []);
  var onDragStart = (0,react.useCallback)(function (e) {
    if (context.allowEdit === true) e.dataTransfer.setData("sheetId", "".concat(sheet.id));
    e.stopPropagation();
  }, [context.allowEdit, sheet.id]);
  var onDrop = (0,react.useCallback)(function (e) {
    if (context.allowEdit === false) return;
    var draggingId = e.dataTransfer.getData("sheetId");
    setContext(function (draftCtx) {
      var droppingId = sheet.id;
      var draggingSheet;
      var droppingSheet;
      lodash_default().sortBy(draftCtx.luckysheetfile, ["order"]).forEach(function (f, i) {
        f.order = i;
        if (f.id === draggingId) {
          draggingSheet = f;
        } else if (f.id === droppingId) {
          droppingSheet = f;
        }
      });
      if (draggingSheet && droppingSheet) {
        draggingSheet.order = droppingSheet.order - 0.1;
        lodash_default().sortBy(draftCtx.luckysheetfile, ["order"]).forEach(function (f, i) {
          f.order = i;
        });
      } else if (draggingSheet && isDropPlaceholder) {
        draggingSheet.order = draftCtx.luckysheetfile.length;
      }
    });
    setDragOver(false);
    e.stopPropagation();
  }, [context.allowEdit, isDropPlaceholder, setContext, sheet.id]);
  return /*#__PURE__*/react.createElement("div", {
    onDragOver: function onDragOver(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    onDragEnter: function onDragEnter(e) {
      setDragOver(true);
      e.stopPropagation();
    },
    onDragLeave: function onDragLeave(e) {
      setDragOver(false);
      e.stopPropagation();
    },
    onDragEnd: function onDragEnd(e) {
      setDragOver(false);
      e.stopPropagation();
    },
    onDrop: onDrop,
    onDragStart: onDragStart,
    draggable: context.allowEdit && !editing,
    key: sheet.id,
    ref: containerRef,
    className: isDropPlaceholder ? "fortune-sheettab-placeholder" : "luckysheet-sheets-item".concat(context.currentSheetId === sheet.id ? " luckysheet-sheets-item-active" : ""),
    onClick: function onClick() {
      if (isDropPlaceholder) return;
      setContext(function (draftCtx) {
        draftCtx.sheetScrollRecord[draftCtx.currentSheetId] = {
          scrollLeft: draftCtx.scrollLeft,
          scrollTop: draftCtx.scrollTop,
          luckysheet_select_status: draftCtx.luckysheet_select_status,
          luckysheet_select_save: draftCtx.luckysheet_select_save,
          luckysheet_selection_range: draftCtx.luckysheet_selection_range
        };
        draftCtx.dataVerificationDropDownList = false;
        draftCtx.currentSheetId = sheet.id;
        draftCtx.zoomRatio = sheet.zoomRatio || 1;
        cancelActiveImgItem(draftCtx, refs.globalCache);
        cancelNormalSelected(draftCtx);
      });
    },
    tabIndex: 0,
    onContextMenu: function onContextMenu(e) {
      if (isDropPlaceholder) return;
      var rect = refs.workbookContainer.current.getBoundingClientRect();
      var pageX = e.pageX,
        pageY = e.pageY;
      setContext(function (ctx) {
        ctx.dataVerificationDropDownList = false;
        ctx.currentSheetId = sheet.id;
        ctx.zoomRatio = sheet.zoomRatio || 1;
        ctx.sheetTabContextMenu = {
          x: pageX - rect.left - window.scrollX,
          y: pageY - rect.top - window.scrollY,
          sheet: sheet,
          onRename: function onRename() {
            return setEditing(true);
          }
        };
      });
    },
    style: {
      borderLeft: dragOver ? "2px solid #0188fb" : "",
      display: sheet.hide === 1 ? "none" : ""
    }
  }, /*#__PURE__*/react.createElement("span", {
    className: "luckysheet-sheets-item-name",
    spellCheck: "false",
    suppressContentEditableWarning: true,
    contentEditable: isDropPlaceholder ? false : editing,
    onDoubleClick: function onDoubleClick() {
      return setEditing(true);
    },
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    ref: editable,
    style: dragOver ? {
      pointerEvents: "none"
    } : {}
  }, sheet.name), /*#__PURE__*/react.createElement("span", {
    className: "luckysheet-sheets-item-function",
    onMouseEnter: function onMouseEnter() {
      return setSvgColor("#5c5c5c");
    },
    onMouseLeave: function onMouseLeave() {
      return setSvgColor("#c3c3c3");
    },
    onClick: function onClick(e) {
      if (isDropPlaceholder || context.allowEdit === false) return;
      var rect = refs.workbookContainer.current.getBoundingClientRect();
      var pageX = e.pageX,
        pageY = e.pageY;
      setContext(function (ctx) {
        ctx.currentSheetId = sheet.id;
        ctx.sheetTabContextMenu = {
          x: pageX - rect.left - window.scrollX,
          y: pageY - rect.top - window.scrollY,
          sheet: sheet,
          onRename: function onRename() {
            return setEditing(true);
          }
        };
      });
    },
    tabIndex: 0
  }, /*#__PURE__*/react.createElement(SVGIcon, {
    name: "downArrow",
    width: 12,
    style: {
      fill: svgColor
    }
  })), !!sheet.color && /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-sheets-item-color",
    style: {
      background: sheet.color
    }
  }));
};
var presets = [{
  text: "10%",
  value: 0.1
}, {
  text: "30%",
  value: 0.3
}, {
  text: "50%",
  value: 0.5
}, {
  text: "70%",
  value: 0.7
}, {
  text: "100%",
  value: 1
}, {
  text: "150%",
  value: 1.5
}, {
  text: "200%",
  value: 2
}, {
  text: "300%",
  value: 3
}, {
  text: "400%",
  value: 4
}];
var ZoomControl = function ZoomControl() {
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext;
  var menuRef = (0,react.useRef)(null);
  var _useState = (0,react.useState)(false),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    radioMenuOpen = _useState2[0],
    setRadioMenuOpen = _useState2[1];
  useOutsideClick(menuRef, function () {
    setRadioMenuOpen(false);
  }, []);
  var zoomTo = (0,react.useCallback)(function (val) {
    val = parseFloat(val.toFixed(1));
    if (val > MAX_ZOOM_RATIO || val < MIN_ZOOM_RATIO) {
      return;
    }
    setContext(function (ctx) {
      var index = getSheetIndex(ctx, ctx.currentSheetId);
      if (index == null) {
        return;
      }
      ctx.luckysheetfile[index].zoomRatio = val;
      ctx.zoomRatio = val;
    }, {
      noHistory: true
    });
  }, [setContext]);
  return /*#__PURE__*/react.createElement("div", {
    className: "fortune-zoom-container"
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-zoom-button",
    onClick: function onClick(e) {
      zoomTo(context.zoomRatio - 0.1);
      e.stopPropagation();
    },
    tabIndex: 0
  }, /*#__PURE__*/react.createElement(SVGIcon, {
    name: "minus",
    width: 16,
    height: 16
  })), /*#__PURE__*/react.createElement("div", {
    className: "fortune-zoom-ratio"
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-zoom-ratio-current fortune-zoom-button",
    onClick: function onClick() {
      return setRadioMenuOpen(true);
    },
    tabIndex: 0
  }, (context.zoomRatio * 100).toFixed(0), "%"), radioMenuOpen && /*#__PURE__*/react.createElement("div", {
    className: "fortune-zoom-ratio-menu",
    ref: menuRef
  }, presets.map(function (v) {
    return /*#__PURE__*/react.createElement("div", {
      className: "fortune-zoom-ratio-item",
      key: v.text,
      onClick: function onClick(e) {
        zoomTo(v.value);
        e.preventDefault();
      },
      tabIndex: 0
    }, /*#__PURE__*/react.createElement("div", {
      className: "fortune-zoom-ratio-text"
    }, v.text));
  }))), /*#__PURE__*/react.createElement("div", {
    className: "fortune-zoom-button",
    onClick: function onClick(e) {
      zoomTo(context.zoomRatio + 0.1);
      e.stopPropagation();
    },
    tabIndex: 0
  }, /*#__PURE__*/react.createElement(SVGIcon, {
    name: "plus",
    width: 16,
    height: 16
  })));
};
var SheetTab = function SheetTab() {
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    settings = _useContext.settings,
    refs = _useContext.refs;
  var tabContainerRef = (0,react.useRef)(null);
  var leftScrollRef = (0,react.useRef)(null);
  var rightScrollRef = (0,react.useRef)(null);
  var _useState = (0,react.useState)(false),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    isShowScrollBtn = _useState2[0],
    setIsShowScrollBtn = _useState2[1];
  var _useState3 = (0,react.useState)(true),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    isShowBoundary = _useState4[0],
    setIsShowBoundary = _useState4[1];
  var scrollDelta = 150;
  var scrollBy = (0,react.useCallback)(function (amount) {
    var _tabContainerRef$curr;
    if (tabContainerRef.current == null || tabContainerRef.current.scrollLeft == null) {
      return;
    }
    var scrollLeft = tabContainerRef.current.scrollLeft;
    if (scrollLeft + amount <= 0) setIsShowBoundary(true);else if (scrollLeft > 0) setIsShowBoundary(false);
    (_tabContainerRef$curr = tabContainerRef.current) === null || _tabContainerRef$curr === void 0 ? void 0 : _tabContainerRef$curr.scrollBy({
      left: amount,
      behavior: "smooth"
    });
  }, []);
  (0,react.useEffect)(function () {
    var tabCurrent = tabContainerRef.current;
    if (!tabCurrent) return;
    setIsShowScrollBtn(tabCurrent.scrollWidth - 2 > tabCurrent.clientWidth);
  }, [context.luckysheetfile]);
  var onAddSheetClick = (0,react.useCallback)(function () {
    return setTimeout(function () {
      setContext(function (draftCtx) {
        if (draftCtx.luckysheetCellUpdate.length > 0) {
          updateCell(draftCtx, draftCtx.luckysheetCellUpdate[0], draftCtx.luckysheetCellUpdate[1], refs.cellInput.current);
        }
        addSheet(draftCtx, settings);
      }, {
        addSheetOp: true
      });
      var tabCurrent = tabContainerRef.current;
      setIsShowScrollBtn(tabCurrent.scrollWidth > tabCurrent.clientWidth);
    });
  }, [refs.cellInput, setContext, settings]);
  return /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-sheet-area luckysheet-noselected-text",
    onContextMenu: function onContextMenu(e) {
      return e.preventDefault();
    },
    id: "luckysheet-sheet-area"
  }, /*#__PURE__*/react.createElement("div", {
    id: "luckysheet-sheet-content"
  }, context.allowEdit && /*#__PURE__*/react.createElement("div", {
    className: "fortune-sheettab-button",
    onClick: onAddSheetClick
  }, /*#__PURE__*/react.createElement(SVGIcon, {
    name: "plus",
    width: 16,
    height: 16
  })), context.allowEdit && /*#__PURE__*/react.createElement("div", {
    className: "sheet-list-container"
  }, /*#__PURE__*/react.createElement("div", {
    id: "all-sheets",
    className: "fortune-sheettab-button",
    ref: tabContainerRef,
    onMouseDown: function onMouseDown(e) {
      e.stopPropagation();
      setContext(function (ctx) {
        ctx.showSheetList = lodash_default().isUndefined(ctx.showSheetList) ? true : !ctx.showSheetList;
        ctx.sheetTabContextMenu = {};
      });
    }
  }, /*#__PURE__*/react.createElement(SVGIcon, {
    name: "all-sheets",
    width: 16,
    height: 16
  }))), /*#__PURE__*/react.createElement("div", {
    id: "luckysheet-sheets-m",
    className: "luckysheet-sheets-m lucky-button-custom"
  }, /*#__PURE__*/react.createElement("i", {
    className: "iconfont luckysheet-iconfont-caidan2"
  })), /*#__PURE__*/react.createElement("div", {
    className: "fortune-sheettab-container",
    id: "fortune-sheettab-container"
  }, !isShowBoundary && /*#__PURE__*/react.createElement("div", {
    className: "boundary boundary-left"
  }), /*#__PURE__*/react.createElement("div", {
    className: "fortune-sheettab-container-c",
    id: "fortune-sheettab-container-c",
    ref: tabContainerRef
  }, lodash_default().sortBy(context.luckysheetfile, function (s) {
    return Number(s.order);
  }).map(function (sheet) {
    return /*#__PURE__*/react.createElement(SheetItem, {
      key: sheet.id,
      sheet: sheet
    });
  })), isShowBoundary && isShowScrollBtn && /*#__PURE__*/react.createElement("div", {
    className: "boundary boundary-right"
  })), isShowScrollBtn && /*#__PURE__*/react.createElement("div", {
    id: "fortune-sheettab-leftscroll",
    className: "fortune-sheettab-scroll",
    ref: leftScrollRef,
    onClick: function onClick() {
      scrollBy(-scrollDelta);
    },
    tabIndex: 0
  }, /*#__PURE__*/react.createElement(SVGIcon, {
    name: "arrow-doubleleft",
    width: 12,
    height: 12
  })), isShowScrollBtn && /*#__PURE__*/react.createElement("div", {
    id: "fortune-sheettab-rightscroll",
    className: "fortune-sheettab-scroll",
    ref: rightScrollRef,
    onClick: function onClick() {
      scrollBy(scrollDelta);
    },
    tabIndex: 0
  }, /*#__PURE__*/react.createElement(SVGIcon, {
    name: "arrow-doubleright",
    width: 12,
    height: 12
  }))), /*#__PURE__*/react.createElement("div", {
    className: "fortune-sheet-area-right"
  }, /*#__PURE__*/react.createElement(ZoomControl, null)));
};
var Divider$1 = function Divider() {
  return /*#__PURE__*/react.createElement("div", {
    className: "fortune-context-menu-divider"
  });
};
var Menu = function Menu(_ref) {
  var _onClick = _ref.onClick,
    _onMouseLeave = _ref.onMouseLeave,
    _onMouseEnter = _ref.onMouseEnter,
    children = _ref.children;
  var containerRef = (0,react.useRef)(null);
  return /*#__PURE__*/react.createElement("div", {
    ref: containerRef,
    className: "luckysheet-cols-menuitem luckysheet-mousedown-cancel",
    onClick: function onClick(e) {
      return _onClick === null || _onClick === void 0 ? void 0 : _onClick(e, containerRef.current);
    },
    onMouseLeave: function onMouseLeave(e) {
      return _onMouseLeave === null || _onMouseLeave === void 0 ? void 0 : _onMouseLeave(e, containerRef.current);
    },
    onMouseEnter: function onMouseEnter(e) {
      return _onMouseEnter === null || _onMouseEnter === void 0 ? void 0 : _onMouseEnter(e, containerRef.current);
    },
    tabIndex: 0
  }, /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-cols-menuitem-content luckysheet-mousedown-cancel"
  }, children));
};
var CustomSort = function CustomSort() {
  var _useState = (0,react.useState)([]),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    rangeColChar = _useState2[0],
    setRangeColChar = _useState2[1];
  var _useState3 = (0,react.useState)(true),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    ascOrDesc = _useState4[0],
    setAscOrDesc = _useState4[1];
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext;
  var _useState5 = (0,react.useState)("0"),
    _useState6 = dist_index_esm_slicedToArray(_useState5, 2),
    selectedValue = _useState6[0],
    setSelectedValue = _useState6[1];
  var _useState7 = (0,react.useState)(false),
    _useState8 = dist_index_esm_slicedToArray(_useState7, 2),
    isTitleChange = _useState8[0],
    setIstitleChange = _useState8[1];
  var _locale = locale(context),
    sort = _locale.sort;
  var _useDialog = useDialog(),
    hideDialog = _useDialog.hideDialog;
  var col_start = context.luckysheet_select_save[0].column[0];
  var col_end = context.luckysheet_select_save[0].column[1];
  var row_start = context.luckysheet_select_save[0].row[0];
  var row_end = context.luckysheet_select_save[0].row[1];
  var sheetIndex = getSheetIndex(context, context.currentSheetId);
  var handleSelectChange = function handleSelectChange(event) {
    setSelectedValue(event.target.value);
  };
  var handleRadioChange = (0,react.useCallback)(function (e) {
    var sortValue = e.target.value;
    setAscOrDesc(sortValue === "asc");
  }, []);
  var handleTitleChange = (0,react.useCallback)(function (e) {
    var value = e.target.checked;
    setIstitleChange(value);
  }, []);
  (0,react.useEffect)(function () {
    var list = [];
    if (isTitleChange) {
      for (var i = col_start; i <= col_end; i += 1) {
        var _context$luckysheetfi, _context$luckysheetfi2;
        var cell = (_context$luckysheetfi = context.luckysheetfile[sheetIndex].data) === null || _context$luckysheetfi === void 0 ? void 0 : (_context$luckysheetfi2 = _context$luckysheetfi[row_start]) === null || _context$luckysheetfi2 === void 0 ? void 0 : _context$luckysheetfi2[i];
        var colHeaderValue = (cell === null || cell === void 0 ? void 0 : cell.m) || (cell === null || cell === void 0 ? void 0 : cell.v);
        if (colHeaderValue) {
          list.push(colHeaderValue);
        } else {
          var ColumnChar = indexToColumnChar(i);
          list.push("".concat(sort.columnOperation, " ").concat(ColumnChar));
        }
      }
    } else {
      for (var _i = col_start; _i <= col_end; _i += 1) {
        var _ColumnChar = indexToColumnChar(_i);
        list.push(_ColumnChar);
      }
    }
    setRangeColChar(list);
  }, [col_end, col_start, context.luckysheetfile, isTitleChange, row_start, sheetIndex, sort.columnOperation]);
  return /*#__PURE__*/react.createElement("div", {
    className: "fortune-sort"
  }, /*#__PURE__*/react.createElement("div", {
    className: "fortune-sort-title"
  }, /*#__PURE__*/react.createElement("span", null, /*#__PURE__*/react.createElement("span", null, sort.sortRangeTitle), indexToColumnChar(col_start), row_start + 1, /*#__PURE__*/react.createElement("span", null, sort.sortRangeTitleTo), indexToColumnChar(col_end), row_end + 1)), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "fortune-sort-modal"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("input", {
    type: "checkbox",
    id: "fortune-sort-haveheader",
    onChange: handleTitleChange
  }), /*#__PURE__*/react.createElement("span", null, sort.hasTitle)), /*#__PURE__*/react.createElement("div", {
    className: "fortune-sort-tablec"
  }, /*#__PURE__*/react.createElement("table", {
    cellSpacing: "0"
  }, /*#__PURE__*/react.createElement("tbody", null, /*#__PURE__*/react.createElement("tr", null, /*#__PURE__*/react.createElement("td", {
    style: {
      width: "190px"
    }
  }, sort.sortBy, /*#__PURE__*/react.createElement("select", {
    name: "sort_0",
    onChange: handleSelectChange
  }, rangeColChar.map(function (col, index) {
    return /*#__PURE__*/react.createElement("option", {
      value: index,
      key: index
    }, col);
  }))), /*#__PURE__*/react.createElement("td", null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("input", {
    type: "radio",
    value: "asc",
    defaultChecked: true,
    name: "sort_0",
    onChange: handleRadioChange
  }), /*#__PURE__*/react.createElement("span", null, sort.asc)), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("input", {
    type: "radio",
    value: "desc",
    name: "sort_0",
    onChange: handleRadioChange
  }), /*#__PURE__*/react.createElement("span", null, sort.desc))))))))), /*#__PURE__*/react.createElement("div", {
    className: "fortune-sort-button"
  }, /*#__PURE__*/react.createElement("div", {
    className: "button-basic button-primary",
    onClick: function onClick() {
      setContext(function (draftCtx) {
        sortSelection(draftCtx, ascOrDesc, parseInt(selectedValue, 10));
        draftCtx.contextMenu = {};
      });
      hideDialog();
    },
    tabIndex: 0
  }, sort.confirm)));
};
var ContextMenu = function ContextMenu() {
  var _useDialog = useDialog(),
    showDialog = _useDialog.showDialog;
  var containerRef = (0,react.useRef)(null);
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    settings = _useContext.settings,
    refs = _useContext.refs;
  var contextMenu = context.contextMenu;
  var _useAlert = useAlert(),
    showAlert = _useAlert.showAlert;
  var _locale = locale(context),
    rightclick = _locale.rightclick,
    drag = _locale.drag,
    generalDialog = _locale.generalDialog,
    info = _locale.info;
  var getMenuElement = (0,react.useCallback)(function (name, i) {
    var _context$luckysheet_s;
    var selection = (_context$luckysheet_s = context.luckysheet_select_save) === null || _context$luckysheet_s === void 0 ? void 0 : _context$luckysheet_s[0];
    if (name === "|") {
      return /*#__PURE__*/react.createElement(Divider$1, {
        key: "divider-".concat(i)
      });
    }
    if (name === "copy") {
      return /*#__PURE__*/react.createElement(Menu, {
        key: name,
        onClick: function onClick() {
          setContext(function (draftCtx) {
            var _draftCtx$luckysheet_;
            if (((_draftCtx$luckysheet_ = draftCtx.luckysheet_select_save) === null || _draftCtx$luckysheet_ === void 0 ? void 0 : _draftCtx$luckysheet_.length) > 1) {
              showAlert(rightclick.noMulti, "ok");
              draftCtx.contextMenu = {};
              return;
            }
            handleCopy(draftCtx);
            draftCtx.contextMenu = {};
          });
        }
      }, rightclick.copy);
    }
    if (name === "paste" && (runtime_default())) {
      return /*#__PURE__*/react.createElement(Menu, {
        key: name,
        onClick: function () {
          var _onClick = _asyncToGenerator(/*#__PURE__*/runtime_default().mark(function _callee() {
            var clipboardText;
            return runtime_default().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return navigator.clipboard.readText();
                  case 2:
                    clipboardText = _context.sent;
                    setContext(function (draftCtx) {
                      handlePasteByClick(draftCtx, clipboardText);
                      draftCtx.contextMenu = {};
                    });
                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
          function onClick() {
            return _onClick.apply(this, arguments);
          }
          return onClick;
        }()
      }, rightclick.paste);
    }
    if (name === "insert-column") {
      return (selection === null || selection === void 0 ? void 0 : selection.row_select) ? null : ["left", "right"].map(function (dir) {
        var _context$lang, _context$lang2;
        return /*#__PURE__*/react.createElement(Menu, {
          key: "add-col-".concat(dir),
          onClick: function onClick(e) {
            var _context$luckysheet_s2, _context$luckysheet_s3, _context$luckysheet_s4, _e$target$querySelect;
            var position = (_context$luckysheet_s2 = context.luckysheet_select_save) === null || _context$luckysheet_s2 === void 0 ? void 0 : (_context$luckysheet_s3 = _context$luckysheet_s2[0]) === null || _context$luckysheet_s3 === void 0 ? void 0 : (_context$luckysheet_s4 = _context$luckysheet_s3.column) === null || _context$luckysheet_s4 === void 0 ? void 0 : _context$luckysheet_s4[0];
            if (position == null) return;
            var countStr = (_e$target$querySelect = e.target.querySelector("input")) === null || _e$target$querySelect === void 0 ? void 0 : _e$target$querySelect.value;
            if (countStr == null) return;
            var count = parseInt(countStr, 10);
            if (count < 1) return;
            var direction = dir === "left" ? "lefttop" : "rightbottom";
            var insertRowColOp = {
              type: "column",
              index: position,
              count: count,
              direction: direction,
              id: context.currentSheetId
            };
            setContext(function (draftCtx) {
              try {
                insertRowCol(draftCtx, insertRowColOp);
                draftCtx.contextMenu = {};
              } catch (err) {
                if (err.message === "maxExceeded") showAlert(rightclick.columnOverLimit, "ok");else if (err.message === "readOnly") showAlert(rightclick.cannotInsertOnColumnReadOnly, "ok");
                draftCtx.contextMenu = {};
              }
            }, {
              insertRowColOp: insertRowColOp
            });
          }
        }, /*#__PURE__*/react.createElement(react.Fragment, null, lodash_default().startsWith((_context$lang = context.lang) !== null && _context$lang !== void 0 ? _context$lang : "", "zh") && /*#__PURE__*/react.createElement(react.Fragment, null, rightclick.to, /*#__PURE__*/react.createElement("span", {
          className: "luckysheet-cols-rows-shift-".concat(dir)
        }, rightclick[dir])), "".concat(rightclick.insert, "  "), /*#__PURE__*/react.createElement("input", {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          onKeyDown: function onKeyDown(e) {
            return e.stopPropagation();
          },
          tabIndex: 0,
          type: "text",
          className: "luckysheet-mousedown-cancel",
          placeholder: rightclick.number,
          defaultValue: "1"
        }), /*#__PURE__*/react.createElement("span", {
          className: "luckysheet-cols-rows-shift-word luckysheet-mousedown-cancel"
        }, "".concat(rightclick.column, "  ")), !lodash_default().startsWith((_context$lang2 = context.lang) !== null && _context$lang2 !== void 0 ? _context$lang2 : "", "zh") && /*#__PURE__*/react.createElement("span", {
          className: "luckysheet-cols-rows-shift-".concat(dir)
        }, rightclick[dir])));
      });
    }
    if (name === "insert-row") {
      return (selection === null || selection === void 0 ? void 0 : selection.column_select) ? null : ["top", "bottom"].map(function (dir) {
        var _context$lang3, _context$lang4;
        return /*#__PURE__*/react.createElement(Menu, {
          key: "add-row-".concat(dir),
          onClick: function onClick(e, container) {
            var _context$luckysheet_s5, _context$luckysheet_s6, _context$luckysheet_s7, _container$querySelec;
            var position = (_context$luckysheet_s5 = context.luckysheet_select_save) === null || _context$luckysheet_s5 === void 0 ? void 0 : (_context$luckysheet_s6 = _context$luckysheet_s5[0]) === null || _context$luckysheet_s6 === void 0 ? void 0 : (_context$luckysheet_s7 = _context$luckysheet_s6.row) === null || _context$luckysheet_s7 === void 0 ? void 0 : _context$luckysheet_s7[0];
            if (position == null) return;
            var countStr = (_container$querySelec = container.querySelector("input")) === null || _container$querySelec === void 0 ? void 0 : _container$querySelec.value;
            if (countStr == null) return;
            var count = parseInt(countStr, 10);
            if (count < 1) return;
            var direction = dir === "top" ? "lefttop" : "rightbottom";
            var insertRowColOp = {
              type: "row",
              index: position,
              count: count,
              direction: direction,
              id: context.currentSheetId
            };
            setContext(function (draftCtx) {
              try {
                insertRowCol(draftCtx, insertRowColOp);
                draftCtx.contextMenu = {};
              } catch (err) {
                if (err.message === "maxExceeded") showAlert(rightclick.rowOverLimit, "ok");else if (err.message === "readOnly") showAlert(rightclick.cannotInsertOnRowReadOnly, "ok");
                draftCtx.contextMenu = {};
              }
            }, {
              insertRowColOp: insertRowColOp
            });
          }
        }, /*#__PURE__*/react.createElement(react.Fragment, null, lodash_default().startsWith((_context$lang3 = context.lang) !== null && _context$lang3 !== void 0 ? _context$lang3 : "", "zh") && /*#__PURE__*/react.createElement(react.Fragment, null, rightclick.to, /*#__PURE__*/react.createElement("span", {
          className: "luckysheet-cols-rows-shift-".concat(dir)
        }, rightclick[dir])), "".concat(rightclick.insert, "  "), /*#__PURE__*/react.createElement("input", {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          onKeyDown: function onKeyDown(e) {
            return e.stopPropagation();
          },
          tabIndex: 0,
          type: "text",
          className: "luckysheet-mousedown-cancel",
          placeholder: rightclick.number,
          defaultValue: "1"
        }), /*#__PURE__*/react.createElement("span", {
          className: "luckysheet-cols-rows-shift-word luckysheet-mousedown-cancel"
        }, "".concat(rightclick.row, "  ")), !lodash_default().startsWith((_context$lang4 = context.lang) !== null && _context$lang4 !== void 0 ? _context$lang4 : "", "zh") && /*#__PURE__*/react.createElement("span", {
          className: "luckysheet-cols-rows-shift-".concat(dir)
        }, rightclick[dir])));
      });
    }
    if (name === "delete-column") {
      return (selection === null || selection === void 0 ? void 0 : selection.column_select) && /*#__PURE__*/react.createElement(Menu, {
        key: "delete-col",
        onClick: function onClick() {
          if (!selection) return;
          var _selection$column = dist_index_esm_slicedToArray(selection.column, 2),
            st_index = _selection$column[0],
            ed_index = _selection$column[1];
          var deleteRowColOp = {
            type: "column",
            start: st_index,
            end: ed_index,
            id: context.currentSheetId
          };
          setContext(function (draftCtx) {
            var _draftCtx$luckysheet_2, _draftCtx$luckysheetf, _draftCtx$luckysheetf2;
            if (((_draftCtx$luckysheet_2 = draftCtx.luckysheet_select_save) === null || _draftCtx$luckysheet_2 === void 0 ? void 0 : _draftCtx$luckysheet_2.length) > 1) {
              showAlert(rightclick.noMulti, "ok");
              draftCtx.contextMenu = {};
              draftCtx.dataVerificationDropDownList = false;
              return;
            }
            var slen = ed_index - st_index + 1;
            var index = getSheetIndex(draftCtx, context.currentSheetId);
            if (((_draftCtx$luckysheetf = draftCtx.luckysheetfile[index].data) === null || _draftCtx$luckysheetf === void 0 ? void 0 : (_draftCtx$luckysheetf2 = _draftCtx$luckysheetf[0]) === null || _draftCtx$luckysheetf2 === void 0 ? void 0 : _draftCtx$luckysheetf2.length) <= slen) {
              showAlert(rightclick.cannotDeleteAllColumn, "ok");
              draftCtx.contextMenu = {};
              return;
            }
            try {
              deleteRowCol(draftCtx, deleteRowColOp);
            } catch (e) {
              if (e.message === "readOnly") {
                showAlert(rightclick.cannotDeleteColumnReadOnly, "ok");
              }
            }
            draftCtx.contextMenu = {};
          }, {
            deleteRowColOp: deleteRowColOp
          });
        }
      }, rightclick.deleteSelected, rightclick.column);
    }
    if (name === "delete-row") {
      return (selection === null || selection === void 0 ? void 0 : selection.row_select) && /*#__PURE__*/react.createElement(Menu, {
        key: "delete-row",
        onClick: function onClick() {
          if (!selection) return;
          var _selection$row = dist_index_esm_slicedToArray(selection.row, 2),
            st_index = _selection$row[0],
            ed_index = _selection$row[1];
          var deleteRowColOp = {
            type: "row",
            start: st_index,
            end: ed_index,
            id: context.currentSheetId
          };
          setContext(function (draftCtx) {
            var _draftCtx$luckysheet_3, _draftCtx$luckysheetf3;
            if (((_draftCtx$luckysheet_3 = draftCtx.luckysheet_select_save) === null || _draftCtx$luckysheet_3 === void 0 ? void 0 : _draftCtx$luckysheet_3.length) > 1) {
              showAlert(rightclick.noMulti, "ok");
              draftCtx.contextMenu = {};
              return;
            }
            var slen = ed_index - st_index + 1;
            var index = getSheetIndex(draftCtx, context.currentSheetId);
            if (((_draftCtx$luckysheetf3 = draftCtx.luckysheetfile[index].data) === null || _draftCtx$luckysheetf3 === void 0 ? void 0 : _draftCtx$luckysheetf3.length) <= slen) {
              showAlert(rightclick.cannotDeleteAllRow, "ok");
              draftCtx.contextMenu = {};
              return;
            }
            try {
              deleteRowCol(draftCtx, deleteRowColOp);
            } catch (e) {
              if (e.message === "readOnly") {
                showAlert(rightclick.cannotDeleteRowReadOnly, "ok");
              }
            }
            draftCtx.contextMenu = {};
          }, {
            deleteRowColOp: deleteRowColOp
          });
        }
      }, rightclick.deleteSelected, rightclick.row);
    }
    if (name === "hide-row") {
      return (selection === null || selection === void 0 ? void 0 : selection.row_select) === true && ["hideSelected", "showHide"].map(function (item) {
        return /*#__PURE__*/react.createElement(Menu, {
          key: item,
          onClick: function onClick() {
            setContext(function (draftCtx) {
              var msg = "";
              if (item === "hideSelected") {
                msg = hideSelected(draftCtx, "row");
              } else if (item === "showHide") {
                showSelected(draftCtx, "row");
              }
              if (msg === "noMulti") {
                showDialog(drag.noMulti);
              }
              draftCtx.contextMenu = {};
            });
          }
        }, rightclick[item] + rightclick.row);
      });
    }
    if (name === "hide-column") {
      return (selection === null || selection === void 0 ? void 0 : selection.column_select) === true && ["hideSelected", "showHide"].map(function (item) {
        return /*#__PURE__*/react.createElement(Menu, {
          key: item,
          onClick: function onClick() {
            setContext(function (draftCtx) {
              var msg = "";
              if (item === "hideSelected") {
                msg = hideSelected(draftCtx, "column");
              } else if (item === "showHide") {
                showSelected(draftCtx, "column");
              }
              if (msg === "noMulti") {
                showDialog(drag.noMulti);
              }
              draftCtx.contextMenu = {};
            });
          }
        }, rightclick[item] + rightclick.column);
      });
    }
    if (name === "set-row-height") {
      var _context$luckysheet_s8, _context$luckysheet_s9;
      var rowHeight = (selection === null || selection === void 0 ? void 0 : selection.height) || context.defaultrowlen;
      var shownRowHeight = ((_context$luckysheet_s8 = context.luckysheet_select_save) === null || _context$luckysheet_s8 === void 0 ? void 0 : _context$luckysheet_s8.some(function (section) {
        return section.height_move !== (rowHeight + 1) * (section.row[1] - section.row[0] + 1) - 1;
      })) ? "" : rowHeight;
      return ((_context$luckysheet_s9 = context.luckysheet_select_save) === null || _context$luckysheet_s9 === void 0 ? void 0 : _context$luckysheet_s9.some(function (section) {
        return section.row_select;
      })) ? /*#__PURE__*/react.createElement(Menu, {
        key: "set-row-height",
        onClick: function onClick(e, container) {
          var _container$querySelec2;
          var targetRowHeight = (_container$querySelec2 = container.querySelector("input")) === null || _container$querySelec2 === void 0 ? void 0 : _container$querySelec2.value;
          setContext(function (draftCtx) {
            if (lodash_default().isUndefined(targetRowHeight) || targetRowHeight === "" || parseInt(targetRowHeight, 10) <= 0 || parseInt(targetRowHeight, 10) > 545) {
              showAlert(info.tipRowHeightLimit, "ok");
              draftCtx.contextMenu = {};
              return;
            }
            var numRowHeight = parseInt(targetRowHeight, 10);
            var rowHeightList = {};
            lodash_default().forEach(draftCtx.luckysheet_select_save, function (section) {
              for (var rowNum = section.row[0]; rowNum <= section.row[1]; rowNum += 1) {
                rowHeightList[rowNum] = numRowHeight;
              }
            });
            index_esm_index.setRowHeight(draftCtx, rowHeightList, {}, true);
            draftCtx.contextMenu = {};
          });
        }
      }, rightclick.row, rightclick.height, /*#__PURE__*/react.createElement("input", {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        onKeyDown: function onKeyDown(e) {
          return e.stopPropagation();
        },
        tabIndex: 0,
        type: "number",
        min: 1,
        max: 545,
        className: "luckysheet-mousedown-cancel",
        placeholder: rightclick.number,
        defaultValue: shownRowHeight,
        style: {
          width: "40px"
        }
      }), "px") : null;
    }
    if (name === "set-column-width") {
      var _context$luckysheet_s10, _context$luckysheet_s11;
      var colWidth = (selection === null || selection === void 0 ? void 0 : selection.width) || context.defaultcollen;
      var shownColWidth = ((_context$luckysheet_s10 = context.luckysheet_select_save) === null || _context$luckysheet_s10 === void 0 ? void 0 : _context$luckysheet_s10.some(function (section) {
        return section.width_move !== (colWidth + 1) * (section.column[1] - section.column[0] + 1) - 1;
      })) ? "" : colWidth;
      return ((_context$luckysheet_s11 = context.luckysheet_select_save) === null || _context$luckysheet_s11 === void 0 ? void 0 : _context$luckysheet_s11.some(function (section) {
        return section.column_select;
      })) ? /*#__PURE__*/react.createElement(Menu, {
        key: "set-column-width",
        onClick: function onClick(e, container) {
          var _container$querySelec3;
          var targetColWidth = (_container$querySelec3 = container.querySelector("input")) === null || _container$querySelec3 === void 0 ? void 0 : _container$querySelec3.value;
          setContext(function (draftCtx) {
            if (lodash_default().isUndefined(targetColWidth) || targetColWidth === "" || parseInt(targetColWidth, 10) <= 0 || parseInt(targetColWidth, 10) > 2038) {
              showAlert(info.tipColumnWidthLimit, "ok");
              draftCtx.contextMenu = {};
              return;
            }
            var numColWidth = parseInt(targetColWidth, 10);
            var colWidthList = {};
            lodash_default().forEach(draftCtx.luckysheet_select_save, function (section) {
              for (var colNum = section.column[0]; colNum <= section.column[1]; colNum += 1) {
                colWidthList[colNum] = numColWidth;
              }
            });
            index_esm_index.setColumnWidth(draftCtx, colWidthList, {}, true);
            draftCtx.contextMenu = {};
          });
        }
      }, rightclick.column, rightclick.width, /*#__PURE__*/react.createElement("input", {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        onKeyDown: function onKeyDown(e) {
          return e.stopPropagation();
        },
        tabIndex: 0,
        type: "number",
        min: 1,
        max: 545,
        className: "luckysheet-mousedown-cancel",
        placeholder: rightclick.number,
        defaultValue: shownColWidth,
        style: {
          width: "40px"
        }
      }), "px") : null;
    }
    if (name === "clear") {
      return /*#__PURE__*/react.createElement(Menu, {
        key: name,
        onClick: function onClick() {
          setContext(function (draftCtx) {
            var allowEdit = isAllowEdit(draftCtx);
            if (!allowEdit) return;
            if (draftCtx.activeImg != null) {
              removeActiveImage(draftCtx);
            } else {
              var msg = deleteSelectedCellText(draftCtx);
              if (msg === "partMC") {
                showDialog(generalDialog.partiallyError, "ok");
              } else if (msg === "allowEdit") {
                showDialog(generalDialog.readOnlyError, "ok");
              } else if (msg === "dataNullError") {
                showDialog(generalDialog.dataNullError, "ok");
              }
            }
            draftCtx.contextMenu = {};
            jfrefreshgrid(draftCtx, null, undefined);
          });
        }
      }, rightclick.clearContent);
    }
    if (name === "orderAZ") {
      return /*#__PURE__*/react.createElement(Menu, {
        key: name,
        onClick: function onClick() {
          setContext(function (draftCtx) {
            sortSelection(draftCtx, true);
            draftCtx.contextMenu = {};
          });
        }
      }, rightclick.orderAZ);
    }
    if (name === "orderZA") {
      return /*#__PURE__*/react.createElement(Menu, {
        key: name,
        onClick: function onClick() {
          setContext(function (draftCtx) {
            sortSelection(draftCtx, false);
            draftCtx.contextMenu = {};
          });
        }
      }, rightclick.orderZA);
    }
    if (name === "sort") {
      return /*#__PURE__*/react.createElement(Menu, {
        key: name,
        onClick: function onClick() {
          setContext(function (draftCtx) {
            showDialog(/*#__PURE__*/react.createElement(CustomSort, null));
            draftCtx.contextMenu = {};
          });
        }
      }, rightclick.sortSelection);
    }
    if (name === "filter") {
      return /*#__PURE__*/react.createElement(Menu, {
        key: name,
        onClick: function onClick() {
          setContext(function (draftCtx) {
            createFilter(draftCtx);
            draftCtx.contextMenu = {};
          });
        }
      }, rightclick.filterSelection);
    }
    if (name === "image") {
      return /*#__PURE__*/react.createElement(Menu, {
        key: name,
        onClick: function onClick() {
          setContext(function (draftCtx) {
            showImgChooser();
            draftCtx.contextMenu = {};
          });
        }
      }, rightclick.image);
    }
    if (name === "link") {
      return /*#__PURE__*/react.createElement(Menu, {
        key: name,
        onClick: function onClick() {
          setContext(function (draftCtx) {
            handleLink(draftCtx);
            draftCtx.contextMenu = {};
          });
        }
      }, rightclick.link);
    }
    return null;
  }, [context.currentSheetId, context.lang, context.luckysheet_select_save, context.defaultrowlen, context.defaultcollen, rightclick, info, setContext, showAlert, showDialog, drag, generalDialog]);
  (0,react.useLayoutEffect)(function () {
    var _refs$workbookContain;
    if (!containerRef.current) {
      return;
    }
    var winH = window.innerHeight;
    var winW = window.innerWidth;
    var rect = containerRef.current.getBoundingClientRect();
    var workbookRect = (_refs$workbookContain = refs.workbookContainer.current) === null || _refs$workbookContain === void 0 ? void 0 : _refs$workbookContain.getBoundingClientRect();
    if (!workbookRect) {
      return;
    }
    var menuW = rect.width;
    var menuH = rect.height;
    var top = contextMenu.y || 0;
    var left = contextMenu.x || 0;
    var hasOverflow = false;
    if (workbookRect.left + left + menuW > winW) {
      left -= menuW;
      hasOverflow = true;
    }
    if (workbookRect.top + top + menuH > winH) {
      top -= menuH;
      hasOverflow = true;
    }
    if (top < 0) {
      top = 0;
      hasOverflow = true;
    }
    if (hasOverflow) {
      setContext(function (draftCtx) {
        draftCtx.contextMenu.x = left;
        draftCtx.contextMenu.y = top;
      });
    }
  }, [contextMenu.x, contextMenu.y, refs.workbookContainer, setContext]);
  if (lodash_default().isEmpty(context.contextMenu)) return null;
  return /*#__PURE__*/react.createElement("div", {
    className: "fortune-context-menu luckysheet-cols-menu",
    ref: containerRef,
    onContextMenu: function onContextMenu(e) {
      return e.stopPropagation();
    },
    style: {
      left: contextMenu.x,
      top: contextMenu.y
    }
  }, context.contextMenu.headerMenu === true ? settings.headerContextMenu.map(function (menu, i) {
    return getMenuElement(menu, i);
  }) : settings.cellContextMenu.map(function (menu, i) {
    return getMenuElement(menu, i);
  }));
};
var getPath = function getPath(currency) {
  switch (currency) {
    case "$":
      return "M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718H4zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73l.348.086z";
    case "€":
      return "M4 9.42h1.063C5.4 12.323 7.317 14 10.34 14c.622 0 1.167-.068 1.659-.185v-1.3c-.484.119-1.045.17-1.659.17-2.1 0-3.455-1.198-3.775-3.264h4.017v-.928H6.497v-.936c0-.11 0-.219.008-.329h4.078v-.927H6.618c.388-1.898 1.719-2.985 3.723-2.985.614 0 1.175.05 1.659.177V2.194A6.617 6.617 0 0010.341 2c-2.928 0-4.82 1.569-5.244 4.3H4v.928h1.01v1.265H4v.928z";
    case "£":
      return "M4 8.585h1.969c.115.465.186.939.186 1.43 0 1.385-.736 2.496-2.075 2.771V14H12v-1.24H6.492v-.129c.825-.525 1.135-1.446 1.135-2.694 0-.465-.07-.913-.168-1.352h3.29v-.972H7.22c-.186-.723-.372-1.455-.372-2.247 0-1.274 1.047-2.066 2.58-2.066a5.32 5.32 0 012.103.465V2.456A5.629 5.629 0 009.348 2C6.865 2 5.322 3.291 5.322 5.366c0 .775.195 1.515.399 2.247H4v.972z";
    case "₹":
      return "M4 3.06h2.726c1.22 0 2.12.575 2.325 1.724H4v1.051h5.051C8.855 7.001 8 7.558 6.788 7.558H4v1.317L8.437 14h2.11L6.095 8.884h.855c2.316-.018 3.465-1.476 3.688-3.049H12V4.784h-1.345c-.08-.778-.357-1.335-.793-1.732H12V2H4v1.06z";
    default:
      return "M8.75 14v-2.629h2.446v-.967H8.75v-1.31h2.445v-.967H9.128L12.5 2h-1.699L8.047 7.327h-.086L5.207 2H3.5l3.363 6.127H4.778v.968H7.25v1.31H4.78v.966h2.47V14h1.502z";
  }
};
var SVGDefines = function SVGDefines(_ref) {
  var currency = _ref.currency;
  return /*#__PURE__*/react.createElement("svg", {
    style: {
      position: "absolute",
      width: 0,
      height: 0
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "add"
  }, /*#__PURE__*/react.createElement("rect", {
    x: "4.75",
    y: "4.75",
    width: "14.5",
    height: "14.5",
    rx: "0.75",
    stroke: "#424A59",
    strokeOpacity: "0.9",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "11.25",
    y: "8.5",
    width: "1.5",
    height: "7",
    fill: "#535B68"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "15.5",
    y: "11.25",
    width: "1.5",
    height: "7",
    transform: "rotate(90 15.5 11.25)",
    fill: "#535B68"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "align-bottom"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M9.25 12.5L12.0002 15.5L14.75 12.5H9.25Z",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "5.5",
    y: "16.5",
    width: "13",
    height: "1.5",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "11.25",
    y: "5.5",
    width: "1.5",
    height: "7.5",
    fill: "#525C6F"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "align-center"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M5 6.75H19",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M8 12H16",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M5 17.25L19 17.25",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "align-justify"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M19.5 6.5H4.5",
    stroke: "#525C6F",
    strokeWidth: "1.5",
    strokeLinejoin: "round"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.5 12L4.5 12",
    stroke: "#525C6F",
    strokeWidth: "1.5",
    strokeLinejoin: "round"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.5 17.5H4.5",
    stroke: "#525C6F",
    strokeWidth: "1.5",
    strokeLinejoin: "round"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "align-left"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M5 6.75H19",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M5 12H13",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M5 17.25L19 17.25",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "align-middle"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M9.25 16.5L12.0002 13.5L14.75 16.5H9.25Z",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M9.25 7L12.0002 10L14.75 7L9.25 7Z",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "5.5",
    y: "11",
    width: "13",
    height: "1.5",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "11.25",
    y: "16",
    width: "1.5",
    height: "3.5",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "11.25",
    y: "4",
    width: "1.5",
    height: "3.5",
    fill: "#525C6F"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "align-right"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M5 6.75H19",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M11 12H19",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M5 17.25L19 17.25",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "align-top"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M9.25 11L12.0002 8L14.75 11H9.25Z",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "5.5",
    y: "5.5",
    width: "13",
    height: "1.5",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "11.25",
    y: "10.5",
    width: "1.5",
    height: "7.5",
    fill: "#525C6F"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "bold"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M6.30566 5.07617V18.9992H12.4872C13.9107 18.9992 15.0417 18.7067 15.8607 18.1607C16.8162 17.4977 17.3037 16.4837 17.3037 15.1187C17.3037 14.1827 17.0307 13.4417 16.5237 12.8567C16.0167 12.2717 15.3147 11.8817 14.3982 11.7257C15.1002 11.4917 15.6657 11.1212 16.0947 10.6142C16.5042 10.0487 16.7187 9.36617 16.7187 8.58617C16.7187 7.49417 16.3482 6.63617 15.6072 6.01217C14.8467 5.38817 13.8132 5.07617 12.5262 5.07617H6.30566ZM7.90466 6.42167H12.1557C13.1307 6.42167 13.8717 6.59717 14.3787 6.98717C14.8857 7.37717 15.1392 7.96217 15.1392 8.74217C15.1392 9.54167 14.8662 10.1462 14.3592 10.5557C13.8522 10.9457 13.1112 11.1602 12.1362 11.1602H7.90466V6.42167ZM7.90466 12.4862H12.3507C13.4232 12.4862 14.2422 12.6812 14.8077 13.1102C15.3927 13.5392 15.7047 14.2022 15.7047 15.0992C15.7047 15.9962 15.3537 16.6787 14.6712 17.1077C14.0862 17.4587 13.3257 17.6537 12.3507 17.6537H7.90466V12.4862Z",
    fill: "#394259"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "border"
  }, /*#__PURE__*/react.createElement("rect", {
    x: "5.75",
    y: "5.75",
    width: "12.5",
    height: "12.5",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "6.5",
    y1: "12",
    x2: "17.5",
    y2: "12",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "12",
    y1: "17.5",
    x2: "12",
    y2: "6.5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "border-all"
  }, /*#__PURE__*/react.createElement("rect", {
    x: "5.75",
    y: "5.75",
    width: "12.5",
    height: "12.5",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "6.5",
    y1: "12",
    x2: "17.5",
    y2: "12",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "12",
    y1: "17.5",
    x2: "12",
    y2: "6.5",
    stroke: "#535A68",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "border-bottom"
  }, /*#__PURE__*/react.createElement("rect", {
    x: "5.75",
    y: "5.75",
    width: "12.5",
    height: "12.5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "6.5",
    y1: "12",
    x2: "17.5",
    y2: "12",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "12",
    y1: "17.5",
    x2: "12",
    y2: "6.5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "5",
    y1: "18.25",
    x2: "19",
    y2: "18.25",
    stroke: "#535A68",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "border-color"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M16 10.9106L18.9511 13.8617L14.5431 18.2697H11.592V15.3186L16 10.9106Z",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 6.5H17.5V9.84613H19V6.5V5H17.5H6.5H5V6.5V17.5V19H6.5H9.84616V17.5H6.5V6.5Z",
    fill: "#535A68"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "border-horizontal"
  }, /*#__PURE__*/react.createElement("rect", {
    x: "5.75",
    y: "5.75",
    width: "12.5",
    height: "12.5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "12",
    y1: "17.5",
    x2: "12",
    y2: "6.5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "5",
    y1: "18.25",
    x2: "19",
    y2: "18.25",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "6.5",
    y1: "12",
    x2: "17.5",
    y2: "12",
    stroke: "#535A68",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "border_diagonal_down"
  }, /*#__PURE__*/react.createElement("line", {
    x1: "17.9697",
    y1: "18.0303",
    x2: "5.96967",
    y2: "6.03033",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "5.75",
    y: "5.75",
    width: "12.5",
    height: "12.5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "border_diagonal_up"
  }, /*#__PURE__*/react.createElement("line", {
    y1: "-0.75",
    x2: "16.9706",
    y2: "-0.75",
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 5.5 17.5)",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "5.75",
    y: "5.75",
    width: "12.5",
    height: "12.5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "border-inside"
  }, /*#__PURE__*/react.createElement("rect", {
    x: "5.75",
    y: "5.75",
    width: "12.5",
    height: "12.5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "6.5",
    y1: "12",
    x2: "17.5",
    y2: "12",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "12",
    y1: "17.5",
    x2: "12",
    y2: "6.5",
    stroke: "#535A68",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "border-left"
  }, /*#__PURE__*/react.createElement("line", {
    x1: "6.5",
    y1: "12",
    x2: "17.5",
    y2: "12",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "12",
    y1: "17.5",
    x2: "12",
    y2: "6.5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "5.75",
    y: "5.75",
    width: "12.5",
    height: "12.5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "5.75",
    y1: "19",
    x2: "5.75",
    y2: "5",
    stroke: "#535A68",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "border-none"
  }, /*#__PURE__*/react.createElement("rect", {
    x: "5.75",
    y: "5.75",
    width: "12.5",
    height: "12.5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "6.5",
    y1: "12",
    x2: "17.5",
    y2: "12",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "12",
    y1: "17.5",
    x2: "12",
    y2: "6.5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "border-outside"
  }, /*#__PURE__*/react.createElement("rect", {
    x: "5.75",
    y: "5.75",
    width: "12.5",
    height: "12.5",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "6.5",
    y1: "12",
    x2: "17.5",
    y2: "12",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "12",
    y1: "17.5",
    x2: "12",
    y2: "6.5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "border-right"
  }, /*#__PURE__*/react.createElement("line", {
    x1: "6.5",
    y1: "12",
    x2: "17.5",
    y2: "12",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "12",
    y1: "17.5",
    x2: "12",
    y2: "6.5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "5.75",
    y: "5.75",
    width: "12.5",
    height: "12.5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "18.25",
    y1: "19",
    x2: "18.25",
    y2: "5",
    stroke: "#535A68",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "border-vertical"
  }, /*#__PURE__*/react.createElement("line", {
    x1: "6.5",
    y1: "12",
    x2: "17.5",
    y2: "12",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "12",
    y1: "17.5",
    x2: "12",
    y2: "6.5",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "5.75",
    y: "5.75",
    width: "12.5",
    height: "12.5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "18.25",
    y1: "19",
    x2: "18.25",
    y2: "5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "border-slash"
  }, /*#__PURE__*/react.createElement("line", {
    x1: "5.75",
    y1: "5.75",
    x2: "17.95",
    y2: "17.95",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "5.75",
    y: "5.75",
    width: "12.5",
    height: "12.5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "border-style"
  }, /*#__PURE__*/react.createElement("line", {
    x1: "5",
    y1: "5.75",
    x2: "19",
    y2: "5.75",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "5",
    y1: "12.25",
    x2: "7.5",
    y2: "12.25",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "8.8252",
    y1: "12.25",
    x2: "11.3252",
    y2: "12.25",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "12.6504",
    y1: "12.25",
    x2: "15.1504",
    y2: "12.25",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "16.4746",
    y1: "12.25",
    x2: "18.9746",
    y2: "12.25",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "5",
    y1: "18.25",
    x2: "6.5",
    y2: "18.25",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "7.08008",
    y1: "18.25",
    x2: "8.58008",
    y2: "18.25",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "9.16016",
    y1: "18.25",
    x2: "10.6602",
    y2: "18.25",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "11.2402",
    y1: "18.25",
    x2: "12.7402",
    y2: "18.25",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "13.3203",
    y1: "18.25",
    x2: "14.8203",
    y2: "18.25",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "15.4004",
    y1: "18.25",
    x2: "16.9004",
    y2: "18.25",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "17.4805",
    y1: "18.25",
    x2: "18.9805",
    y2: "18.25",
    stroke: "#535A68",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "border-top"
  }, /*#__PURE__*/react.createElement("rect", {
    x: "5.75",
    y: "5.75",
    width: "12.5",
    height: "12.5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "6.5",
    y1: "12",
    x2: "17.5",
    y2: "12",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "12",
    y1: "17.5",
    x2: "12",
    y2: "6.5",
    stroke: "#CCCED2",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "5",
    y1: "5.75",
    x2: "19",
    y2: "5.75",
    stroke: "#535A68",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 18 18",
    fill: "none",
    id: "close"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M13.9255 5L5.00091 13.9246",
    stroke: "#262A33",
    strokeOpacity: "0.9",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M13.9255 13.9238L5.00091 4.9992",
    stroke: "#262A33",
    strokeOpacity: "0.9",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 10 24",
    fill: "none",
    id: "combo-arrow"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M8 10H2L5 14L8 10Z",
    fill: "#A6A6A6"
  })), /*#__PURE__*/react.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "comment"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.968 15.7L12 17.956l2.032-2.258H18.5v-10h-13v10h4.468zm1.289 3.673L9.3 17.2H5.5A1.5 1.5 0 014 15.7v-10a1.5 1.5 0 011.5-1.5h13A1.5 1.5 0 0120 5.7v10a1.5 1.5 0 01-1.5 1.5h-3.8l-1.957 2.174a1 1 0 01-1.486 0z",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M7 8.2h10v1.5H7V8.2zM7 11.699h6v1.5H7z",
    fill: "#525C6F"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "strike-through"
  }, /*#__PURE__*/react.createElement("rect", {
    x: "6",
    y: "11.5",
    width: "13",
    height: "1.5",
    fill: "#394259"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M9.00344 11.5C9.69342 11.9717 10.6431 12.3814 11.8525 12.729C13.071 13.0815 13.9121 13.4403 14.376 13.8052C14.8398 14.1639 15.0718 14.6742 15.0718 15.3359C15.0718 15.9977 14.8213 16.5203 14.3203 16.9038C13.8193 17.2873 13.0988 17.479 12.1587 17.479C11.1506 17.479 10.3434 17.244 9.7373 16.7739C9.13737 16.2977 8.8374 15.6514 8.8374 14.835H7.04688C7.04688 15.6204 7.26335 16.3224 7.69629 16.9409C8.13542 17.5594 8.757 18.048 9.56104 18.4067C10.3651 18.7593 11.231 18.9355 12.1587 18.9355C13.5874 18.9355 14.7285 18.6077 15.582 17.9521C16.4355 17.2904 16.8623 16.4121 16.8623 15.3174C16.8623 14.6309 16.7077 14.034 16.3984 13.5269C16.0954 13.0197 15.6253 12.5775 14.9883 12.2002C14.581 11.9526 14.0705 11.7192 13.457 11.5H9.00344Z",
    fill: "#394259"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M7.71685 10C7.5547 9.61466 7.47363 9.19458 7.47363 8.73975C7.47363 7.67594 7.8973 6.79769 8.74463 6.10498C9.59814 5.40609 10.7052 5.05664 12.0659 5.05664C12.9937 5.05664 13.8193 5.236 14.543 5.59473C15.2728 5.95345 15.8356 6.44824 16.2314 7.0791C16.6335 7.70996 16.8345 8.39958 16.8345 9.14795H15.0439C15.0439 8.33154 14.7842 7.69141 14.2646 7.22754C13.7451 6.75749 13.0122 6.52246 12.0659 6.52246C11.1877 6.52246 10.5011 6.71729 10.0063 7.10693C9.51774 7.4904 9.27344 8.02539 9.27344 8.71191C9.27344 9.2095 9.46296 9.63887 9.84201 10H7.71685Z",
    fill: "#394259"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "clear-format"
  }, /*#__PURE__*/react.createElement("line", {
    x1: "8",
    y1: "18.25",
    x2: "20",
    y2: "18.25",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7.12132L17.8787 11L10 18.8787L6.12132 15L14 7.12132ZM14 5L15.0607 6.06066L18.9393 9.93934L20 11L18.9393 12.0607L12 19L8 19L5.06066 16.0607L4 15L5.06066 13.9393L12.9393 6.06066L14 5Z",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "13.9375",
    y: "6.12316",
    width: "6.98528",
    height: "5.7265",
    transform: "rotate(45 13.9375 6.12316)",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "image"
  }, /*#__PURE__*/react.createElement("circle", {
    cx: "8.75",
    cy: "8.75",
    r: "1.25",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "4.75",
    y: "5.25",
    width: "14.5",
    height: "13.5",
    rx: "0.75",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M7 19L12.984 11.8949C13.1659 11.6789 13.4905 11.6563 13.7006 11.845L19.5 17.0556",
    stroke: "#525C6F",
    strokeWidth: "1.5",
    strokeLinejoin: "round"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "italic"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M11 5H16V6.5H11V5Z",
    fill: "#394259"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M9 17.5H14V19H9V17.5Z",
    fill: "#394259"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7598 17.877L12.7598 5.87695L14.2394 6.12355L12.2394 18.1236L10.7598 17.877Z",
    fill: "#394259"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "merge-cancel"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M13 14.9998L16.5 11.9996L13 8.99982V14.9998Z",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M11 14.9998L7.5 11.9996L11 8.99982L11 14.9998Z",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "10",
    y: "11.2498",
    width: "4.5",
    height: "1.5",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 6.49982H6.5L6.5 17.4998H9.5V15.4999H11V17.4998V18.9998H9.5H6.5H5V17.4998L5 6.49982V4.99982H6.5H9.5L11 4.99982V6.49982V8.49988H9.5V6.49982ZM13 15.4999V15.9998V17.4998V18.9998H14.5H17.5H19V17.4998V6.49982V4.99982H17.5H14.5H13V6.49982V7.99982V8.49988H14.5V7.99982V6.49982H17.5V17.4998H14.5L14.5 15.9998V15.4999H13Z",
    fill: "#525C6F"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "merge-horizontal"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M11 15L14.5 11.9998L11 9V15Z",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "5",
    y: "11.25",
    width: "8.5",
    height: "1.5",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 6.5H7.5H9.5H11V5H9.5H6.5H5V6.5V17.5V19H6.5H9.5H11V17.5H9.5H7.5H6.5V6.5ZM13 16V15.5H14.5V16V17.5H17.5V6.5H14.5V8V8.5H13V8V6.5V5H14.5H17.5H19V6.5V17.5V19H17.5H14.5H13V17.5V16Z",
    fill: "#525C6F"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "merge-vertical"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M9 10.9998L12.0002 14.4998L15 10.9998L9 10.9998Z",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "12.75",
    y: "4.99982",
    width: "8.5",
    height: "1.5",
    transform: "rotate(90 12.75 4.99982)",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 6.49982L17.5 7L17.5 10.9998H19V9.49982V6.49982V4.99982H17.5L6.5 4.99982H5V6.49982L5 9.49982V10.9998H6.5V9.49982L6.5 7L6.5 6.49982L17.5 6.49982ZM8 12.9998L8.5 12.9998V14.4998H8H6.5V17.4998H17.5V14.4998H16H15.5V12.9998H16H17.5H19L19 14.4998V17.4998V18.9998H17.5H6.5L5 18.9998L5 17.4998V14.4998V12.9998H6.5H8Z",
    fill: "#525C6F"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "merge-all"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M15.5 14.9998L12 11.9996L15.5 8.99982V14.9998Z",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M8.5 14.9998L12 11.9996L8.5 8.99982L8.5 14.9998Z",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "7",
    y: "11.2498",
    width: "2.5",
    height: "1.5",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "14.5",
    y: "11.2498",
    width: "2.5",
    height: "1.5",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 6.49982H6.5L6.5 17.4998H9.5V15.4999H11V17.4998V18.9998H9.5H6.5H5V17.4998L5 6.49982V4.99982H6.5H9.5L11 4.99982V6.49982V8.49988H9.5V6.49982ZM13 15.4999V15.9998V17.4998V18.9998H14.5H17.5H19V17.4998V6.49982V4.99982H17.5H14.5H13V6.49982V7.99982V8.49988H14.5V7.99982V6.49982H17.5V17.4998H14.5L14.5 15.9998V15.4999H13Z",
    fill: "#525C6F"
  })), /*#__PURE__*/react.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "plus"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M8 1.715v12.571M1.714 8h12.572",
    stroke: "#666",
    strokeWidth: "1.714"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    version: "1.1",
    "p-id": "4116",
    id: "minus"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M801.895 542.105h-579.79C205.479 542.105 192 528.627 192 512c0-16.627 13.479-30.105 30.105-30.105h579.789C818.521 481.895 832 495.373 832 512c0 16.627-13.479 30.105-30.105 30.105z",
    "p-id": "4117"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "-100 -100 1224 1224",
    fill: "#525C6F",
    id: "background"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M766.4 744.3c43.7 0 79.4-36.2 79.4-80.5 0-53.5-79.4-140.8-79.4-140.8S687 610.3 687 663.8c0 44.3 35.7 80.5 79.4 80.5zM389.3 700.2c7.1 7.1 18.6 7.1 25.6 0l256.1-256c7.1-7.1 7.1-18.6 0-25.6l-256-256c-0.6-0.6-1.3-1.2-2-1.7l-78.2-78.2c-3.5-3.5-9.3-3.5-12.8 0l-48 48c-3.5 3.5-3.5 9.3 0 12.8l67.2 67.2-207.8 207.9c-7.1 7.1-7.1 18.6 0 25.6l255.9 256z m12.9-448.6l178.9 178.9H223.4l178.8-178.9zM904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "-100 -100 1224 1224",
    fill: "#525C6F",
    id: "font-color"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zM253.7 736h85c4.2 0 8-2.7 9.3-6.8l53.7-166h219.2l53.2 166c1.3 4 5 6.8 9.3 6.8h89.1c1.1 0 2.2-0.2 3.2-0.5 5.1-1.8 7.8-7.3 6-12.4L573.6 118.6c-1.4-3.9-5.1-6.6-9.2-6.6H462.1c-4.2 0-7.9 2.6-9.2 6.6L244.5 723.1c-0.4 1-0.5 2.1-0.5 3.2-0.1 5.3 4.3 9.7 9.7 9.7z m255.9-516.1h4.1l83.8 263.8H424.9l84.7-263.8z"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "text-overflow"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M16.5 15L20 11.9998L16.5 9V15Z",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("rect", {
    x: "7",
    y: "11.25",
    width: "9.5",
    height: "1.5",
    fill: "#525C6F"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "4.75",
    y1: "5",
    x2: "4.75",
    y2: "19",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "12.25",
    y1: "5",
    x2: "12.25",
    y2: "9.5",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "12.25",
    y1: "14.5",
    x2: "12.25",
    y2: "19",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "text-wrap"
  }, /*#__PURE__*/react.createElement("line", {
    x1: "4.75",
    y1: "5",
    x2: "4.75",
    y2: "19",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "19.25",
    y1: "5",
    x2: "19.25",
    y2: "19",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00001 16.2502L9.99 13.5V15.5H12.0005C13.9335 15.5 15.5005 13.933 15.5005 12C15.5005 10.067 13.9335 8.5 12.0005 8.5H7V7H12.0005C14.7619 7 17.0005 9.23857 17.0005 12C17.0005 14.7614 14.7619 17 12.0005 17H9.99V19L7.00001 16.2502Z",
    fill: "#525C6F"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "underline"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 19H7V17.5H17V19Z",
    fill: "#394259"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 5V12.25C9.25 13.7688 10.4812 15 12 15C13.5188 15 14.75 13.7688 14.75 12.25V5H16.25V12.25C16.25 14.5972 14.3472 16.5 12 16.5C9.65278 16.5 7.75 14.5972 7.75 12.25V5H9.25Z",
    fill: "#394259"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "undo"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 7.75001L7.2019 10.835V8.5H13.25C15.4591 8.5 17.25 10.2909 17.25 12.5C17.25 14.7091 15.4591 16.5 13.25 16.5H7V18H13.25C16.2876 18 18.75 15.5376 18.75 12.5C18.75 9.46244 16.2876 7 13.25 7H7.2019V4.66547L3.5 7.75001Z",
    fill: "#525C6F"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "redo"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 7.75001L16.7981 10.835V8.5H10.75C8.54086 8.5 6.75 10.2909 6.75 12.5C6.75 14.7091 8.54086 16.5 10.75 16.5H17V18H10.75C7.71243 18 5.25 15.5376 5.25 12.5C5.25 9.46244 7.71243 7 10.75 7H16.7981V4.66547L20.5 7.75001Z",
    fill: "#525C6F"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    id: "fx"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M841 370c3-3.3 2.7-8.3-0.6-11.3-1.5-1.3-3.4-2.1-5.3-2.1h-72.6c-2.4 0-4.6 1-6.1 2.8L633.5 504.6c-2.9 3.4-7.9 3.8-11.3 0.9-0.9-0.8-1.6-1.7-2.1-2.8l-63.5-141.3c-1.3-2.9-4.1-4.7-7.3-4.7H380.7l0.9-4.7 8-42.3c10.5-55.4 38-81.4 85.8-81.4 18.6 0 35.5 1.7 48.8 4.7l14.1-66.8c-22.6-4.7-35.2-6.1-54.9-6.1-103.3 0-156.4 44.3-175.9 147.3l-9.4 49.4h-97.6c-3.8 0-7.1 2.7-7.8 6.4L181.9 415c-0.9 4.3 1.9 8.6 6.2 9.5 0.5 0.1 1.1 0.2 1.6 0.2H284l-89 429.9c-0.9 4.3 1.9 8.6 6.2 9.5 0.5 0.1 1.1 0.2 1.6 0.2H269c3.8 0 7.1-2.7 7.8-6.4l89.7-433.1h135.8l68.2 139.1c1.4 2.9 1 6.4-1.2 8.8l-180.6 203c-2.9 3.3-2.6 8.4 0.7 11.3 1.5 1.3 3.4 2 5.3 2h72.7c2.4 0 4.6-1 6.1-2.8l123.7-146.7c2.8-3.4 7.9-3.8 11.3-1 0.9 0.8 1.6 1.7 2.1 2.8L676.4 784c1.3 2.8 4.1 4.7 7.3 4.7h64.6c4.4 0 8-3.6 8-8 0-1.2-0.3-2.4-0.8-3.5l-95.2-198.9c-1.4-2.9-0.9-6.4 1.3-8.8L841 370z"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "currency-format"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#525C6F",
    d: getPath(currency),
    "p-id": "5490"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    id: "percentage-format"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#525C6F",
    d: "M855.7 210.8l-42.4-42.4c-3.1-3.1-8.2-3.1-11.3 0L168.3 801.9c-3.1 3.1-3.1 8.2 0 11.3l42.4 42.4c3.1 3.1 8.2 3.1 11.3 0L855.6 222c3.2-3 3.2-8.1 0.1-11.2zM304 448c79.4 0 144-64.6 144-144s-64.6-144-144-144-144 64.6-144 144 64.6 144 144 144z m0-216c39.7 0 72 32.3 72 72s-32.3 72-72 72-72-32.3-72-72 32.3-72 72-72zM720 576c-79.4 0-144 64.6-144 144s64.6 144 144 144 144-64.6 144-144-64.6-144-144-144z m0 216c-39.7 0-72-32.3-72-72s32.3-72 72-72 72 32.3 72 72-32.3 72-72 72z",
    "p-id": "5920"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    id: "number-decrease"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#525C6F",
    d: "M132.266667 597.333333h76.8a4.266667 4.266667 0 0 0 4.266666-4.266666v-76.8a4.266667 4.266667 0 0 0-4.266666-4.266667H132.266667a4.266667 4.266667 0 0 0-4.266667 4.266667v76.8a4.266667 4.266667 0 0 0 4.266667 4.266666z m367.616-403.925333a94.72 94.72 0 0 0-27.306667-17.322667c-25.514667-10.496-54.954667-11.392-81.706667-5.632-36.778667 7.936-66.56 31.872-84.906666 64.256-19.797333 34.816-28.16 77.397333-28.16 139.178667 0 61.184 8.405333 102.4 28.16 137.941333a125.866667 125.866667 0 0 0 112.768 67.797334c48.64 0 90.581333-25.6 113.365333-67.84 19.2-34.773333 28.16-77.354667 28.16-135.552 0-50.432-5.888-104.106667-32.768-148.394667a148.906667 148.906667 0 0 0-27.562667-34.474667z m-81.066667 314.197333c-38.954667 0-59.306667-45.568-59.306667-134.4 0-88.149333 20.394667-133.76 58.794667-133.76 39.594667 0 59.306667 45.653333 59.306667 135.552 0 87.04-20.394667 132.565333-58.794667 132.565334z m289.024 212.394667a4.266667 4.266667 0 0 1-4.266667-4.266667V640l-103.68 103.68a4.266667 4.266667 0 0 0 0 6.016L704 853.333333v-75.733333a4.266667 4.266667 0 0 1 4.266667-4.266667H896v-53.333333h-187.733333z",
    "p-id": "6524"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    id: "number-increase"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#525C6F",
    d: "M132.266667 597.333333h76.8a4.266667 4.266667 0 0 0 4.266666-4.266666v-76.8a4.266667 4.266667 0 0 0-4.266666-4.266667H132.266667a4.266667 4.266667 0 0 0-4.266667 4.266667v76.8a4.266667 4.266667 0 0 0 4.266667 4.266666z m366.848-402.944a111.530667 111.530667 0 0 0-45.226667-21.76 142.933333 142.933333 0 0 0-71.253333 1.152A130.56 130.56 0 0 0 305.92 234.666667c-19.797333 34.816-28.16 77.397333-28.16 139.178666 0 61.184 8.405333 102.4 28.16 137.941334a125.866667 125.866667 0 0 0 112.768 67.797333c48.64 0 90.581333-25.6 113.365333-67.84 19.2-34.773333 28.16-77.354667 28.16-135.552 0-61.696-11.178667-141.653333-61.098666-181.888z m-79.872 313.173334c-38.954667 0-59.306667-45.568-59.306667-134.4 0-88.149333 20.394667-133.76 58.794667-133.76 39.594667 0 59.306667 45.653333 59.306666 135.552 0 87.04-20.394667 132.565333-58.794666 132.565333z m335.232 71.978666c48.64 0 90.581333-25.6 113.365333-67.84 19.2-34.730667 28.16-77.312 28.16-135.509333 0-47.786667-3.84-99.114667-27.093333-141.909333-27.178667-50.176-82.944-75.392-139.093334-64.554667l-12.8 3.157333A128.64 128.64 0 0 0 641.706667 234.666667c-19.797333 34.773333-28.16 77.354667-28.16 139.093333 0 61.184 8.405333 102.4 28.16 137.941333a125.866667 125.866667 0 0 0 112.768 67.754667z m0-340.053333c39.594667 0 59.306667 45.653333 59.306666 135.552 0 86.954667-20.394667 132.565333-58.794666 132.565333-38.954667 0-59.306667-45.568-59.306667-134.4 0-88.192 20.394667-133.76 58.794667-133.76z m34.858666 476.16a4.266667 4.266667 0 0 1-4.266666 4.266667H597.333333v53.333333h187.733334a4.266667 4.266667 0 0 1 4.266666 4.266667V853.333333l103.68-103.68a4.266667 4.266667 0 0 0 0-6.016L789.333333 640v75.733333z",
    "p-id": "6702"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "format-painter"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#525C6F",
    d: "M15.1004 6.5L6.90039 6.5V9.8L15.1004 9.8L15.1004 6.5ZM15.1004 5C15.9288 5 16.6004 5.67157 16.6004 6.5V9.8C16.6004 10.6284 15.9288 11.3 15.1004 11.3H6.90039C6.07196 11.3 5.40039 10.6284 5.40039 9.8V6.5C5.40039 5.67157 6.07196 5 6.90039 5H15.1004Z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#525C6F",
    d: "M17.7174 8.90039H15.3262V7.40039H18.4674C18.8816 7.40039 19.2174 7.73618 19.2174 8.15039V13.7859C19.2174 14.163 18.9374 14.4814 18.5634 14.5297L10.8174 15.5299V19.0004H9.31738V14.8705C9.31738 14.4934 9.59736 14.175 9.97134 14.1267L17.7174 13.1265V8.90039Z"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1096 1096",
    id: "formula-sum"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#525C6F",
    d: "M725.333333 853.333333H256c-17.066667 0-29.866667-8.533333-38.4-25.6-8.533333-17.066667-4.266667-34.133333 4.266667-46.933333l230.4-268.8-230.4-268.8c-8.533333-12.8-12.8-34.133333-4.266667-46.933333 8.533333-17.066667 21.333333-25.6 38.4-25.6h469.333333c46.933333 0 85.333333 38.4 85.333334 85.333333v85.333333c0 25.6-17.066667 42.666667-42.666667 42.666667s-42.666667-17.066667-42.666667-42.666667V256H349.866667l196.266666 226.133333c12.8 17.066667 12.8 38.4 0 55.466667L349.866667 768H725.333333v-85.333333c0-25.6 17.066667-42.666667 42.666667-42.666667s42.666667 17.066667 42.666667 42.666667v85.333333c0 46.933333-38.4 85.333333-85.333334 85.333333z"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    id: "arrow-doubleleft"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M272.9 512l265.4-339.1c4.1-5.2 0.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3c-9.1 11.6-9.1 27.9 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M576.9 512l265.4-339.1c4.1-5.2 0.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3c-9.1 11.6-9.1 27.9 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    id: "arrow-doubleright"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1c-4.1 5.2-0.4 12.9 6.3 12.9h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M837.2 492.3L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1c-4.1 5.2-0.4 12.9 6.3 12.9h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "freeze-col"
  }, /*#__PURE__*/react.createElement("rect", {
    x: "5.75",
    y: "5.75",
    width: "12.5",
    height: "12.5",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M5.75 12H18.25M12 5.5V18.5",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M12 12L5.5 17.75",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M11.25 6L5.75 11.5",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "freeze-row"
  }, /*#__PURE__*/react.createElement("rect", {
    x: "5.75",
    y: "5.75",
    width: "12.5",
    height: "12.5",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M5.75 12H18.25M12 5.5V18.5",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M18 6.5L11.5 12.25",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M11.25 6L5.75 11.5",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "freeze-row-col"
  }, /*#__PURE__*/react.createElement("rect", {
    x: "5.75",
    y: "5.75",
    width: "12.5",
    height: "12.5",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M5.75 12H18.25M12 5.5V18.5",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M18 6L5.75 18.25",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M11.25 6L5.75 11.5",
    stroke: "#525C6F",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "freeze-cancel"
  }, /*#__PURE__*/react.createElement("rect", {
    x: "5.75",
    y: "5.75",
    width: "12.5",
    height: "12.5",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "6.5",
    y1: "12",
    x2: "17.5",
    y2: "12",
    stroke: "#535A68",
    strokeWidth: "1.5"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "12",
    y1: "17.5",
    x2: "12",
    y2: "6.5",
    stroke: "#535A68",
    strokeWidth: "1.5"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "sort-desc"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M839.6 433.8L749 150.5c-1.2-3.9-4.8-6.5-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-0.3 0.9-0.5 1.9-0.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-0.1 2.8-0.4 2.4-0.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7 0.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2z",
    "p-id": "2016"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M806.8 818.4H677.2v-0.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v0.4L587.7 828.9c-1.1 1.6-1.7 3.4-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43c0.1-5.1-4.1-9.3-9.2-9.3z",
    "p-id": "2017"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M416 702h-76V172c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v530h-76c-6.7 0-10.5 7.8-6.3 13l112 141.9c3.2 4.1 9.4 4.1 12.6 0l112-141.9c4.1-5.2 0.4-13-6.3-13z",
    "p-id": "2018"
  })), /*#__PURE__*/react.createElement("svg", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "sort-asc"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M839.6 433.8L749 150.5c-1.2-3.9-4.8-6.5-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-0.3 0.9-0.5 1.9-0.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-0.1 2.8-0.4 2.4-0.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7 0.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2z",
    "p-id": "2263"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M806.8 818.4H677.2v-0.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v0.4L587.7 828.9c-1.1 1.6-1.7 3.4-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43c0.1-5.1-4.1-9.3-9.2-9.3z",
    "p-id": "2264"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M310.3 167.1c-3.2-4.1-9.4-4.1-12.6 0L185.7 309c-4.2 5.3-0.4 13 6.3 13h76v530c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V322h76c6.7 0 10.5-7.8 6.3-13l-112-141.9z",
    "p-id": "2265"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "more"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M224 597.333333C183.466667 597.333333 149.333333 563.2 149.333333 522.666667S183.466667 448 224 448s74.666667 34.133333 74.666667 74.666667-32 74.666667-74.666667 74.666666zM512 597.333333c-40.533333 0-74.666667-34.133333-74.666667-74.666666S471.466667 448 512 448s74.666667 34.133333 74.666667 74.666667S554.666667 597.333333 512 597.333333zM800 597.333333c-40.533333 0-74.666667-34.133333-74.666667-74.666666s34.133333-74.666667 74.666667-74.666667 74.666667 34.133333 74.666667 74.666667-32 74.666667-74.666667 74.666666z"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    width: "24",
    height: "24",
    id: "text-clip"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M217.6 810.666667h76.8a4.266667 4.266667 0 0 0 4.266667-4.266667V217.6a4.266667 4.266667 0 0 0-4.266667-4.266667H217.6a4.266667 4.266667 0 0 0-4.266667 4.266667v588.8a4.266667 4.266667 0 0 0 4.266667 4.266667zM725.333333 217.6v247.466667a4.266667 4.266667 0 0 1-4.266666 4.266666H388.266667a4.266667 4.266667 0 0 0-4.266667 4.266667v76.8a4.266667 4.266667 0 0 0 4.266667 4.266667h332.8a4.266667 4.266667 0 0 1 4.266666 4.266666v247.466667a4.266667 4.266667 0 0 0 4.266667 4.266667h76.8a4.266667 4.266667 0 0 0 4.266667-4.266667V217.6a4.266667 4.266667 0 0 0-4.266667-4.266667h-76.8a4.266667 4.266667 0 0 0-4.266667 4.266667z",
    "p-id": "13371",
    fill: "#525C6F"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "text-rotation-none"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M657.066667 620.088889c24.177778 0 39.822222-24.177778 31.288889-46.933333L509.155556 150.755556c-14.222222-34.133333-64-34.133333-78.222223 0L250.311111 573.155556c-9.955556 22.755556 7.111111 46.933333 31.288889 46.933333 14.222222 0 25.6-8.533333 31.288889-21.333333l36.977778-92.444445h240.355555l36.977778 92.444445c4.266667 12.8 17.066667 21.333333 29.866667 21.333333z m-285.866667-170.666667L469.333333 203.377778l98.133334 246.044444H371.2zM704 662.755556c-11.377778 11.377778-11.377778 28.444444 0 39.822222l45.511111 45.511111H204.8c-15.644444 0-28.444444 12.8-28.444444 28.444444s12.8 28.444444 28.444444 28.444445h544.711111l-45.511111 45.511111c-11.377778 11.377778-11.377778 28.444444 0 39.822222 11.377778 11.377778 28.444444 11.377778 39.822222 0L839.111111 796.444444c11.377778-11.377778 11.377778-28.444444 0-39.822222l-93.866667-93.866666c-11.377778-11.377778-29.866667-11.377778-41.244444 0z",
    "p-id": "17165"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "text-rotation-angleup"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M634.311111 398.222222c17.066667-17.066667 11.377778-45.511111-11.377778-54.044444L196.266667 170.666667c-35.555556-14.222222-69.688889 21.333333-55.466667 55.466666l172.088889 426.666667c8.533333 22.755556 38.4 28.444444 54.044444 11.377778 9.955556-9.955556 12.8-24.177778 7.111111-36.977778l-39.822222-91.022222 170.666667-170.666667 91.022222 39.822222c12.8 4.266667 28.444444 2.844444 38.4-7.111111z m-322.844444 81.066667l-105.244445-243.2L449.422222 341.333333l-137.955555 137.955556zM696.888889 393.955556c0 15.644444 12.8 28.444444 28.444444 28.444444h64L403.911111 807.822222c-11.377778 11.377778-11.377778 28.444444 0 39.822222 11.377778 11.377778 28.444444 11.377778 39.822222 0l385.422223-385.422222V526.222222c0 15.644444 12.8 28.444444 28.444444 28.444445s28.444444-12.8 28.444444-28.444445v-133.688889c0-15.644444-12.8-28.444444-28.444444-28.444444h-133.688889c-14.222222 1.422222-27.022222 14.222222-27.022222 29.866667z",
    "p-id": "17929"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "text-rotation-angledown"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M625.777778 634.311111c17.066667 17.066667 45.511111 11.377778 54.044444-11.377778l172.088889-426.666666c14.222222-35.555556-21.333333-69.688889-55.466667-55.466667L371.2 312.888889c-22.755556 8.533333-28.444444 38.4-11.377778 54.044444 9.955556 9.955556 24.177778 12.8 36.977778 7.111111l91.022222-39.822222 170.666667 170.666667-39.822222 92.444444c-4.266667 11.377778-2.844444 27.022222 7.111111 36.977778z m-81.066667-322.844444l243.2-105.244445L682.666667 449.422222l-137.955556-137.955555zM630.044444 696.888889c-15.644444 0-28.444444 12.8-28.444444 28.444444v64L216.177778 403.911111c-11.377778-11.377778-28.444444-11.377778-39.822222 0-11.377778 11.377778-11.377778 28.444444 0 39.822222l385.422222 385.422223H497.777778c-15.644444 0-28.444444 12.8-28.444445 28.444444s12.8 28.444444 28.444445 28.444444h133.688889c15.644444 0 28.444444-12.8 28.444444-28.444444v-133.688889c-1.422222-14.222222-14.222222-27.022222-29.866667-27.022222z",
    "p-id": "18084"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "text-rotation-vertical"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M465.066667 672.711111c-24.177778 0-39.822222-24.177778-31.288889-46.933333l179.2-423.822222c14.222222-34.133333 64-34.133333 78.222222 0L871.822222 625.777778c9.955556 22.755556-7.111111 46.933333-31.288889 46.933333-14.222222 0-25.6-8.533333-31.288889-21.333333l-36.977777-92.444445H531.911111l-36.977778 92.444445c-4.266667 12.8-17.066667 21.333333-29.866666 21.333333z m285.866666-170.666667L652.8 256 554.666667 502.044444h196.266666zM157.866667 704c11.377778-11.377778 28.444444-11.377778 39.822222 0l45.511111 45.511111V204.8c0-15.644444 12.8-28.444444 28.444444-28.444444s28.444444 12.8 28.444445 28.444444v544.711111l45.511111-45.511111c11.377778-11.377778 28.444444-11.377778 39.822222 0 11.377778 11.377778 11.377778 28.444444 0 39.822222L292.977778 839.111111c-11.377778 11.377778-28.444444 11.377778-39.822222 0l-93.866667-93.866667c-12.8-11.377778-12.8-29.866667-1.422222-41.244444z",
    "p-id": "18239"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "text-rotation-up"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M620.088889 366.933333c0-24.177778-24.177778-39.822222-46.933333-31.288889L150.755556 514.844444c-34.133333 14.222222-34.133333 64 0 78.222223l423.822222 179.2c22.755556 9.955556 46.933333-7.111111 46.933333-31.288889 0-14.222222-8.533333-25.6-21.333333-31.288889l-92.444445-36.977778V433.777778l92.444445-36.977778c11.377778-4.266667 19.911111-17.066667 19.911111-29.866667z m-170.666667 285.866667L203.377778 554.666667l246.044444-98.133334v196.266667zM662.755556 320c11.377778 11.377778 28.444444 11.377778 39.822222 0l45.511111-45.511111v544.711111c0 15.644444 12.8 28.444444 28.444444 28.444444s28.444444-12.8 28.444445-28.444444V274.488889l45.511111 45.511111c11.377778 11.377778 28.444444 11.377778 39.822222 0 11.377778-11.377778 11.377778-28.444444 0-39.822222L796.444444 184.888889c-11.377778-11.377778-28.444444-11.377778-39.822222 0l-93.866666 93.866667c-11.377778 11.377778-11.377778 29.866667 0 41.244444z",
    "p-id": "18394"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "screenshot"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M320 704V128H256v128H128v64h128v448h448v128h64v-128h128v-64H320z m384-64h64V256H384v64h320v320z",
    "p-id": "3788"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "conditionFormat",
    width: "20"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M128 128h768v768H128V128z m64 512v128h128v-128H192z m256 0v128h192v-128H448zM192 448v128h128V448H192z m0-192v128h128V256H192z m192 0v128h192V256H384z m320 384v128h128v-128h-128z m0-192v128h128V448h-128z m0-192v128h128V256h-128z",
    "p-id": "1955"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "splitColumn"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M143.36 184.32v163.84h737.28v-163.84h-737.28z m-40.96-40.96h819.2v245.76h-819.2v-245.76z m342.016 333.824l67.584 67.584 67.584-67.584c8.192-8.192 20.48-8.192 28.672 0 8.192 8.192 8.192 20.48 0 28.672l-96.256 96.256-96.256-96.256c-8.192-8.192-8.192-20.48 0-28.672 8.192-8.192 20.48-8.192 28.672 0z m-342.016 157.696h368.64v245.76h-368.64v-245.76z m450.56 0h368.64v245.76h-368.64v-245.76z m-409.6 204.8h286.72v-163.84h-286.72v163.84z m450.56 0h286.72v-163.84h-286.72v163.84z",
    "p-id": "1984"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "locationCondition"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M938.666667 388.266667H584.533333V247.466667a21.333333 21.333333 0 0 0-21.333333-21.333334H85.333333A21.333333 21.333333 0 0 0 64 247.466667v324.266666a21.333333 21.333333 0 0 0 21.333333 21.333334h277.333334V785.066667a21.333333 21.333333 0 0 0 21.333333 21.333333h554.666667a21.333333 21.333333 0 0 0 21.333333-21.333333V409.6a21.333333 21.333333 0 0 0-21.333333-21.333333z m-832 162.133333v-281.6h435.2v119.466667H384a21.333333 21.333333 0 0 0-21.333333 21.333333v140.8h-256z",
    "p-id": "9672"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "dataVerification"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M510.9 921.6l-107.8-66.2c-124.6-76.5-202-214.8-202-361.1V243.9h21.7c205.1 0 262-115.5 267.8-128.6l5.7-13 28.7-0.3 6.2 13.1c5.9 13.3 62.8 128.8 267.8 128.8h21.7v250.4c0 146.3-77.4 284.6-202 361.1l-107.8 66.2zM244.5 287v207.3c0 131.2 69.5 255.4 181.3 324.1l85.1 52.2 85.1-52.2c111.8-68.6 181.3-192.8 181.3-324.1V287c-157.7-6.1-234.1-77.8-266.4-121.7-32.2 43.8-108.6 115.6-266.4 121.7z",
    "p-id": "5514"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M502.2 617.3c-5.6 0-11.1-2.1-15.4-6.4L410 534.1c-8.5-8.5-8.5-22.2 0-30.7s22.2-8.5 30.7 0l61.4 61.4 108.7-108.7c8.5-8.5 22.2-8.5 30.7 0s8.5 22.2 0 30.7l-124 124.1c-4.2 4.2-9.8 6.4-15.3 6.4z",
    "p-id": "5515"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "text-rotation-down"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M403.911111 657.066667c0 24.177778 24.177778 39.822222 46.933333 31.288889L873.244444 509.155556c34.133333-14.222222 34.13333299-64 0-78.222223L450.844444 250.311111c-22.755556-9.955556-46.933333 7.111111-46.933333 31.288889 0 14.222222 8.533333 25.6 21.333333 31.288889l92.444445 36.977778-1e-8 240.355555-92.44444499 36.977778c-12.8 4.266667-21.333333 17.066667-21.333333 29.866667z m170.666667-285.86666701L820.622222 469.33333299l-246.044444 98.13333401L574.577778 371.19999999zM361.244444 704c-11.377778-11.377778-28.444444-11.377778-39.822222 0l-45.511111 45.511111L275.911111 204.79999999c0-15.644444-12.8-28.444444-28.44444399-28.44444399s-28.444444 12.8-28.44444501 28.444444l-1e-8 544.711111-45.51111099-45.511111c-11.377778-11.377778-28.444444-11.377778-39.822222 0-11.377778 11.377778-11.377778 28.444444 0 39.822222L227.555556 839.111111c11.377778 11.377778 28.444444 11.377778 39.822222-1e-8l93.866666-93.86666699c11.377778-11.377778 11.377778-29.866667 0-41.244444z",
    "p-id": "10914"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "search"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M469.333 192c153.174 0 277.334 124.16 277.334 277.333 0 68.054-24.534 130.411-65.216 178.688L846.336 818.24l-48.341 49.877L630.4 695.125a276.053 276.053 0 0 1-161.067 51.542C316.16 746.667 192 622.507 192 469.333S316.16 192 469.333 192z m0 64C351.51 256 256 351.51 256 469.333s95.51 213.334 213.333 213.334 213.334-95.51 213.334-213.334S587.157 256 469.333 256z",
    "p-id": "11202"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "link"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M577.155781 655.619241L431.54903 801.139578a119.509873 119.509873 0 0 1-169.111224 0l-26.442532-25.924051a119.6827 119.6827 0 0 1 0-169.111223L366.393249 475.274262a21.344135 21.344135 0 0 1 30.417553 0 21.516962 21.516962 0 0 1 0 30.503966L266.585654 636.176203a76.389536 76.389536 0 0 0 0 108.016877l26.442532 26.442532a76.389536 76.389536 0 0 0 108.016877 0l145.520338-145.606751a76.389536 76.389536 0 0 0 0-108.016878L535.763713 505.864641A21.516962 21.516962 0 0 1 535.763713 475.274262a21.344135 21.344135 0 0 1 30.417553 0l11.233755 11.147341a119.6827 119.6827 0 0 1-0.25924 169.197638z",
    "p-id": "28239"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M546.565401 517.011983L535.763713 505.864641A21.516962 21.516962 0 0 1 535.763713 475.274262a21.344135 21.344135 0 0 1 30.417553 0l11.233755 11.147341",
    "p-id": "28240"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M446.844219 368.380759l145.606751-145.520337a119.509873 119.509873 0 0 1 169.111224 0l26.442532 26.356118a119.6827 119.6827 0 0 1 0 169.111224L657.606751 548.639325a21.344135 21.344135 0 0 1-30.417553 0 21.516962 21.516962 0 0 1 0-30.503966l130.225148-130.311562a76.389536 76.389536 0 0 0 0-108.016877l-26.442532-26.442532a76.389536 76.389536 0 0 0-108.016877 0L477.434599 398.971139a76.389536 76.389536 0 0 0 0 108.016878L488.581941 518.481013a21.516962 21.516962 0 0 1 0 30.503966 21.344135 21.344135 0 0 1-30.417553 0l-11.233755-11.147342a119.6827 119.6827 0 0 1-0.086414-169.456878z",
    "p-id": "28241"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M477.434599 506.988017L488.581941 518.481013a21.516962 21.516962 0 0 1 0 30.503966 21.344135 21.344135 0 0 1-30.417553 0l-11.233755-11.147342",
    "p-id": "28242"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "copy"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M832 128c-12.8-76.8-76.8-128-160-128h-448C102.4 0 0 102.4 0 224v448c0 76.8 57.6 140.8 128 160 12.8 76.8 76.8 128 160 128h512c89.6 0 160-70.4 160-160v-512c0-76.8-57.6-140.8-128-160zM64 672v-448C64 134.4 134.4 64 224 64h448c44.8 0 76.8 25.6 89.6 64H288C198.4 128 128 198.4 128 288v473.6c-38.4-12.8-64-44.8-64-89.6z m832 128c0 51.2-44.8 96-96 96h-512c-51.2 0-96-44.8-96-96v-512C192 236.8 236.8 192 288 192h512c51.2 0 96 44.8 96 96v512z",
    "p-id": "28791"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "pencil"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M966.283012 57.28336A194.600516 194.600516 0 0 0 828.144425 0.000203c-49.932663 0-100.118792 19.009897-138.138586 57.283157l-667.12066 667.12066-22.811877 276.784103c-1.013861 12.166334 8.61782 22.304946 20.530689 22.304946h1.774257l276.784104-22.811876 667.12066-667.12066c76.293054-76.293054 76.293054-199.984119 0-276.277173zM271.534635 941.116848l-205.813821 16.72871L82.702989 751.778272l547.231575-547.231575 189.085111 189.085111-547.48504 547.48504zM922.686981 289.964502l-60.071275 60.071275-189.085111-189.085111 60.071275-60.071275c25.34653-25.34653 58.803949-39.033656 94.542555-39.033656 35.738607 0 69.196026 13.940591 94.542556 39.033656 52.213851 52.213851 52.213851 136.87126 0 189.085111z",
    "p-id": "40167"
  })), /*#__PURE__*/react.createElement("symbol", {
    fill: "#535A68",
    id: "unlink",
    viewBox: "0 0 1024 1024"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M240.469333 240.469333l241.194667 241.194667 90.965333-90.965333a42.88 42.88 0 0 1 60.672 60.672L542.293333 542.293333l241.237334 241.237334a42.666667 42.666667 0 0 1-60.330667 60.330666l-119.936-119.893333-151.893333 151.893333a214.4 214.4 0 0 1-309.674667-296.533333l6.4-6.698667 151.936-151.893333-119.893333-119.893333a42.666667 42.666667 0 0 1 60.330666-60.373334z m120.192 240.896l-151.893333 151.893334a128.64 128.64 0 0 0 176.426667 187.136l5.546666-5.162667 151.850667-151.936-60.629333-60.629333-30.592 30.634666a42.88 42.88 0 1 1-60.672-60.672l30.634666-30.592-60.672-60.672z m515.2-333.226666a214.4 214.4 0 0 1 0 303.232l-121.301333 121.258666A42.88 42.88 0 1 1 693.973333 512l121.258667-121.301333a128.64 128.64 0 0 0-181.930667-181.930667L512 330.069333a42.88 42.88 0 1 1-60.629333-60.629333l121.258666-121.301333a214.4 214.4 0 0 1 303.232 0z m-333.653333 273.365333l-60.373333 60.330667 60.330666 60.330666 60.330667-60.330666-60.330667-60.330667z",
    "p-id": "39251"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "filter"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M872.533333 134.4c-12.8-10.666667-29.866667-17.066667-49.066666-17.066667H198.4C157.866667 117.333333 123.733333 151.466667 123.733333 192c0 17.066667 6.4 34.133333 17.066667 49.066667l256 302.933333v251.733333c0 12.8 6.4 23.466667 17.066667 27.733334l162.133333 81.066666c4.266667 2.133333 8.533333 4.266667 14.933333 4.266667 6.4 0 10.666667-2.133333 17.066667-4.266667 8.533333-6.4 14.933333-17.066667 14.933333-27.733333V541.866667l256-302.933334c12.8-14.933333 19.2-34.133333 17.066667-53.333333 2.133333-19.2-6.4-38.4-23.466667-51.2z m-38.4 64L569.6 509.866667c-4.266667 6.4-8.533333 12.8-8.533333 21.333333v292.266667l-98.133334-49.066667V531.2c0-8.533333-2.133333-14.933333-8.533333-21.333333L189.866667 198.4c0-2.133333-2.133333-4.266667-2.133334-6.4 0-6.4 4.266667-10.666667 10.666667-10.666667h625.066667c2.133333 0 4.266667 0 6.4 2.133334 2.133333 2.133333 4.266667 6.4 4.266666 6.4 2.133333 2.133333 2.133333 6.4 0 8.533333z",
    "p-id": "43580"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "filter1"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M608 864C588.8 864 576 851.2 576 832L576 448c0-6.4 6.4-19.2 12.8-25.6L787.2 256c6.4-6.4 6.4-19.2 0-19.2 0-6.4-6.4-12.8-19.2-12.8L256 224c-12.8 0-19.2 6.4-19.2 12.8 0 6.4-6.4 12.8 6.4 19.2l198.4 166.4C441.6 428.8 448 441.6 448 448l0 256c0 19.2-12.8 32-32 32S384 723.2 384 704L384 460.8 198.4 307.2c-25.6-25.6-32-64-19.2-96C185.6 179.2 217.6 160 256 160L768 160c32 0 64 19.2 76.8 51.2 12.8 32 6.4 70.4-19.2 89.6l-192 160L633.6 832C640 851.2 627.2 864 608 864z",
    "p-id": "43727"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "eraser"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M596.437333 85.333333a42.837333 42.837333 0 0 0-30.549333 13.824l-469.333333 512a42.666667 42.666667 0 0 0 1.28 59.008l170.666666 170.666667A42.496 42.496 0 0 0 298.666667 853.333333h512v-85.333333h-195.669334l311.168-311.168a42.538667 42.538667 0 0 0 0-60.330667l-298.666666-298.666666A43.221333 43.221333 0 0 0 596.437333 85.333333z m-102.144 682.666667H316.330667l-129.28-129.28 268.8-293.205333 230.485333 230.485333-192.042667 192z m252.373334-252.330667l-233.130667-233.130666 85.12-92.842667L835.669333 426.666667 746.666667 515.669333z",
    "p-id": "50819"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1057 1024",
    fill: "#535A68",
    id: "sort"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M438.634667 192v644.202667l-0.810667 5.781333c-1.152 7.210667-2.304 8.704-8.64 17.002667l-7.168 3.925333c-15.914667 8.490667-18.282667 7.168-38.4-3.925333L149.333333 624.533333l45.269334-45.226666 180.032 180.138666V192h64z m216.96 10.005333l231.04 231.146667-45.269334 45.248L661.333333 298.261333V865.706667h-64V226.133333a34.133333 34.133333 0 0 1 58.282667-24.128z",
    "p-id": "52781"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "filter-fill"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M776.341333 170.666667a64 64 0 0 1 49.557334 104.512L627.541333 517.76v273.386667L398.293333 687.018667v-169.237334l-192.469333-243.413333A64 64 0 0 1 256 170.666667h520.341333z",
    "p-id": "18344"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#ffffff",
    id: "filter-fill-white"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M776.341333 170.666667a64 64 0 0 1 49.557334 104.512L627.541333 517.76v273.386667L398.293333 687.018667v-169.237334l-192.469333-243.413333A64 64 0 0 1 256 170.666667h520.341333z",
    "p-id": "18344"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "all-sheets"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M849.427 1000.999h-157.9c-73.785 0-132.809-59.029-132.809-132.809v-258.243c0-14.759 10.33-26.562 25.088-29.513 4.427-1.472 8.853-2.953 13.278-2.953h252.337c73.785 0 132.809 59.029 132.809 132.809v157.9c-1.472 72.309-60.5 132.809-132.809 132.809zM616.268 636.505v231.684c0 39.844 32.468 73.785 73.785 73.785h157.9c39.844 0 73.785-32.468 73.785-73.785v-157.9c0-39.844-32.468-73.785-73.785-73.785h-231.684z",
    "p-id": "4941"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M315.23 1000.999h-147.571c-76.736 0-137.241-61.981-137.241-137.241v-147.571c0-76.736 61.981-137.241 137.241-137.241h247.911c4.427 0 8.853 1.472 13.278 2.953 14.759 1.472 25.088 14.759 25.088 29.513v253.814c0 73.785-61.981 135.764-138.711 135.764zM167.657 636.505c-42.796 0-78.211 35.418-78.211 78.211v147.571c0 44.269 35.418 78.211 78.211 78.211h147.571c42.796 0 78.211-35.418 78.211-78.211v-225.779h-225.779z",
    "p-id": "4942"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M415.576 471.232h-255.291c-72.309 0-129.859-57.549-129.859-129.859v-163.801c0-72.309 57.549-129.859 129.859-129.859h163.801c72.309 0 129.859 57.549 129.859 129.859v261.199c0 14.759-10.33 26.562-25.088 29.513-4.427 1.472-8.853 2.953-13.278 2.953zM158.805 105.259c-38.369 0-70.836 32.468-70.836 70.836v165.279c0 38.369 32.468 70.836 70.836 70.836h234.634v-234.634c0-38.369-32.468-70.836-70.836-70.836h-163.801z",
    "p-id": "4943"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M847.948 471.232h-252.337c-4.427 0-8.853-1.472-13.278-2.953-14.759-1.472-25.088-14.759-25.088-29.513v-258.243c0-73.785 60.5-134.287 134.287-134.287h156.423c73.785 0 134.287 60.5 134.287 134.287v156.423c-1.472 73.785-60.5 134.287-134.287 134.287zM616.268 412.199h230.207c41.318 0 75.263-33.941 75.263-75.263v-156.423c0-41.318-33.941-75.263-75.263-75.263h-156.423c-41.318 0-75.263 33.941-75.263 75.263v231.684z",
    "p-id": "4944"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "hidden"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M849.152 665.429333c62.762667-69.674667 86.826667-138.538667 87.296-139.904a42.410667 42.410667 0 0 0 0-27.008C935.552 495.658667 837.674667 213.333333 512 213.333333c-37.802667 0-72.192 4.138667-104.064 10.837334l75.776 75.776c9.301333-0.554667 18.517333-1.28 28.288-1.28 228.309333 0 316.757333 164.096 338.176 213.333333a369.365333 369.365333 0 0 1-60.544 93.866667l59.52 59.562666zM512 810.666667c78.293333 0 143.146667-16.597333 196.906667-41.429334l156.928 156.928 60.330666-60.330666-768-768-60.330666 60.330666 141.610666 141.610667c-111.530667 83.285333-151.338667 196.906667-151.936 198.698667a42.410667 42.410667 0 0 0 0 27.008C88.448 528.341333 186.325333 810.666667 512 810.666667zM299.989333 360.32l96.938667 96.938667c-22.229333 47.488-14.378667 106.282667 24.533333 145.194666s97.706667 46.805333 145.194667 24.533334l76.842667 76.842666A394.325333 394.325333 0 0 1 512 725.333333c-228.309333 0-316.757333-164.096-338.176-213.333333a366.933333 366.933333 0 0 1 126.165333-151.68z",
    "p-id": "19355"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "check"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M439.439404 776.947278a32.717146 32.717146 0 0 1-21.343097-7.892761L185.810916 570.228169c-13.779841-11.795651-15.389502-32.527834-3.593851-46.308698 11.795651-13.778818 32.528857-15.390525 46.308699-3.593852L435.957093 697.877431l349.863273-405.566946c11.846816-13.736862 32.588209-15.265682 46.323025-3.415796 13.733792 11.847839 15.263635 32.587186 3.414773 46.322002l-371.235023 430.340165c-6.492878 7.52744-15.661701 11.390421-24.883737 11.390422z",
    fill: "",
    "p-id": "5612"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#A8ABB0",
    id: "rightArrow"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M781.963636 495.709091l-418.909091-323.490909c-20.945455-16.290909-37.236364-9.309091-37.236363 16.290909v646.981818c0 25.6 16.290909 32.581818 37.236363 16.290909l418.909091-323.490909c11.636364-9.309091 11.636364-23.272727 0-32.581818z",
    "p-id": "5380"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    id: "downArrow"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M163.396608 289.168384c-40.577024 0-66.526208 54.183936-35.44064 85.25824L477.217792 723.704832c20.031488 20.031488 49.82272 20.031488 69.853184 0l349.274112-349.278208c30.30528-30.294016 6.677504-85.25824-34.927616-85.25824L163.396608 289.168384z",
    "p-id": "2683"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#272636",
    id: "headDownArrow"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M0 511.976727C0 229.678545 229.725091 0 511.976727 0s511.976727 229.632 511.976727 511.976727c0 282.391273-229.725091 511.976727-511.976727 511.976727C229.725091 1024 0 794.368 0 511.976727M955.717818 511.976727c0-244.898909-199.121455-444.206545-443.741091-444.206545-244.666182 0-443.694545 199.307636-443.694545 444.206545 0 244.945455 199.121455 444.253091 443.694545 444.253091C756.642909 956.276364 955.717818 756.968727 955.717818 511.976727M230.027636 419.025455c0-6.562909 2.420364-13.102545 7.563636-18.059636 9.914182-9.960727 26.042182-9.960727 36.096 0l238.289455 236.916364L750.312727 401.105455c9.960727-9.914182 26.135273-9.914182 36.305455 0 9.914182 9.960727 9.914182 26.042182 0 35.956364L511.976727 709.678545 237.474909 436.922182C232.424727 432.104727 230.027636 425.588364 230.027636 419.025455",
    "p-id": "5142"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    id: "tab"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M960 591.424V368.96c0-0.288 0.16-0.512 0.16-0.768S960 367.68 960 367.424V192a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v175.424c0 0.288-0.16 0.512-0.16 0.768s0.16 0.48 0.16 0.768v222.464c0 0.288-0.16 0.512-0.16 0.768s0.16 0.48 0.16 0.768V864a32 32 0 0 0 32 32h832a32 32 0 0 0 32-32v-271.04c0-0.288 0.16-0.512 0.16-0.768S960 591.68 960 591.424z m-560-31.232v-160H608v160h-208z m208 64V832h-208v-207.808H608z m-480-224h208v160H128v-160z m544 0h224v160h-224v-160zM896 224v112.192H128V224h768zM128 624.192h208V832H128v-207.808zM672 832v-207.808h224V832h-224z",
    "p-id": "3023"
  })), /*#__PURE__*/react.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    fill: "#535A68",
    id: "default"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M844.8 896c25.6 0 51.2-19.2 51.2-51.2v-185.6h-51.2c-44.8 0-83.2-38.4-83.2-83.2s38.4-83.2 83.2-83.2h51.2V313.6c0-25.6-19.2-51.2-51.2-51.2h-134.4c0-70.4-57.6-128-128-128S448 185.6 448 256H313.6c-25.6 0-51.2 19.2-51.2 51.2V448C185.6 448 128 505.6 128 576s57.6 128 128 128v134.4c0 25.6 19.2 51.2 51.2 51.2h185.6v-51.2c0-44.8 38.4-83.2 83.2-83.2 44.8 0 83.2 38.4 83.2 83.2v57.6h185.6zM576 710.4c-70.4 0-128 57.6-128 128H307.2v-185.6H256c-44.8 0-83.2-38.4-83.2-83.2S211.2 492.8 256 492.8h51.2V307.2h185.6V256c0-44.8 38.4-83.2 83.2-83.2 44.8 0 83.2 38.4 83.2 83.2v51.2h185.6V448c-70.4 0-128 57.6-128 128s57.6 128 128 128v140.8H704c6.4-70.4-51.2-134.4-128-134.4z",
    fill: "",
    "p-id": "36983"
  }))));
};
var ChangeColor = function ChangeColor(_ref) {
  var triggerParentUpdate = _ref.triggerParentUpdate;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext;
  var _locale = locale(context),
    toolbar = _locale.toolbar,
    sheetconfig = _locale.sheetconfig,
    button = _locale.button;
  var _useState = (0,react.useState)("#000000"),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    inputColor = _useState2[0],
    setInputColor = _useState2[1];
  var _useState3 = (0,react.useState)(context.luckysheetfile[getSheetIndex(context, context.currentSheetId)].color),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    selectColor = _useState4[0],
    setSelectColor = _useState4[1];
  var certainBtn = (0,react.useCallback)(function () {
    setSelectColor(inputColor);
  }, [inputColor]);
  (0,react.useEffect)(function () {
    setContext(function (ctx) {
      if (ctx.allowEdit === false) return;
      var index = getSheetIndex(ctx, ctx.currentSheetId);
      ctx.luckysheetfile[index].color = selectColor;
    });
  }, [selectColor, setContext]);
  return /*#__PURE__*/react.createElement("div", {
    id: "fortune-change-color"
  }, /*#__PURE__*/react.createElement("div", {
    className: "color-reset",
    onClick: function onClick() {
      return setSelectColor(undefined);
    },
    tabIndex: 0
  }, sheetconfig.resetColor), /*#__PURE__*/react.createElement("div", {
    className: "custom-color"
  }, /*#__PURE__*/react.createElement("div", null, toolbar.customColor, ":"), /*#__PURE__*/react.createElement("input", {
    type: "color",
    value: inputColor,
    onChange: function onChange(e) {
      return setInputColor(e.target.value);
    },
    onFocus: function onFocus() {
      triggerParentUpdate(true);
    },
    onBlur: function onBlur() {
      triggerParentUpdate(false);
    }
  }), /*#__PURE__*/react.createElement("div", {
    className: "button-basic button-primary",
    onClick: function onClick() {
      certainBtn();
    },
    tabIndex: 0
  }, button.confirm)), /*#__PURE__*/react.createElement(ColorPicker, {
    onPick: function onPick(color) {
      setInputColor(color);
      setSelectColor(color);
    }
  }));
};
var SheetTabContextMenu = function SheetTabContextMenu() {
  var _settings$sheetTabCon;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    settings = _useContext.settings;
  var _context$sheetTabCont = context.sheetTabContextMenu,
    x = _context$sheetTabCont.x,
    y = _context$sheetTabCont.y,
    sheet = _context$sheetTabCont.sheet,
    onRename = _context$sheetTabCont.onRename;
  var _locale = locale(context),
    sheetconfig = _locale.sheetconfig;
  var _useState = (0,react.useState)({
      x: -1,
      y: -1
    }),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    position = _useState2[0],
    setPosition = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    isShowChangeColor = _useState4[0],
    setIsShowChangeColor = _useState4[1];
  var _useState5 = (0,react.useState)(false),
    _useState6 = dist_index_esm_slicedToArray(_useState5, 2),
    isShowInputColor = _useState6[0],
    setIsShowInputColor = _useState6[1];
  var _useAlert = useAlert(),
    showAlert = _useAlert.showAlert,
    hideAlert = _useAlert.hideAlert;
  var containerRef = (0,react.useRef)(null);
  var close = (0,react.useCallback)(function () {
    setContext(function (ctx) {
      ctx.sheetTabContextMenu = {};
    });
  }, [setContext]);
  (0,react.useLayoutEffect)(function () {
    var _containerRef$current;
    var rect = (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.getBoundingClientRect();
    if (rect && x != null && y != null) {
      setPosition({
        x: x,
        y: y - rect.height
      });
    }
  }, [x, y]);
  useOutsideClick(containerRef, close, [close]);
  var moveSheet = (0,react.useCallback)(function (delta) {
    if (context.allowEdit === false) return;
    if (!sheet) return;
    setContext(function (ctx) {
      var currentOrder = -1;
      lodash_default().sortBy(ctx.luckysheetfile, ["order"]).forEach(function (_sheet, i) {
        _sheet.order = i;
        if (_sheet.id === sheet.id) {
          currentOrder = i;
        }
      });
      index_esm_index.setSheetOrder(ctx, dist_index_esm_defineProperty({}, sheet.id, currentOrder + delta));
    });
  }, [context.allowEdit, setContext, sheet]);
  var hideSheet = (0,react.useCallback)(function () {
    if (context.allowEdit === false) return;
    if (!sheet) return;
    setContext(function (ctx) {
      var shownSheets = ctx.luckysheetfile.filter(function (oneSheet) {
        return lodash_default().isUndefined(oneSheet.hide) || (oneSheet === null || oneSheet === void 0 ? void 0 : oneSheet.hide) !== 1;
      });
      if (shownSheets.length > 1) {
        index_esm_index.hideSheet(ctx, sheet.id);
      } else {
        showAlert(sheetconfig.noMoreSheet, "ok");
      }
    });
  }, [context.allowEdit, setContext, sheet, showAlert, sheetconfig]);
  var copySheet = (0,react.useCallback)(function () {
    if (context.allowEdit === false) return;
    if (!(sheet === null || sheet === void 0 ? void 0 : sheet.id)) return;
    setContext(function (ctx) {
      index_esm_index.copySheet(ctx, sheet.id);
    }, {
      addSheetOp: true
    });
  }, [context.allowEdit, setContext, sheet === null || sheet === void 0 ? void 0 : sheet.id]);
  var updateShowInputColor = (0,react.useCallback)(function (state) {
    setIsShowInputColor(state);
  }, []);
  var focusSheet = (0,react.useCallback)(function () {
    if (context.allowEdit === false) return;
    if (!(sheet === null || sheet === void 0 ? void 0 : sheet.id)) return;
    setContext(function (ctx) {
      lodash_default().forEach(ctx.luckysheetfile, function (sheetfile) {
        sheetfile.status = sheet.id === sheetfile.id ? 1 : 0;
      });
    });
  }, [context.allowEdit, setContext, sheet === null || sheet === void 0 ? void 0 : sheet.id]);
  if (!sheet || x == null || y == null) return null;
  return /*#__PURE__*/react.createElement("div", {
    className: "fortune-context-menu luckysheet-cols-menu",
    onContextMenu: function onContextMenu(e) {
      return e.stopPropagation();
    },
    style: {
      left: position.x,
      top: position.y,
      overflow: "visible"
    },
    ref: containerRef
  }, (_settings$sheetTabCon = settings.sheetTabContextMenu) === null || _settings$sheetTabCon === void 0 ? void 0 : _settings$sheetTabCon.map(function (name, i) {
    if (name === "delete") {
      return /*#__PURE__*/react.createElement(Menu, {
        key: name,
        onClick: function onClick() {
          var shownSheets = context.luckysheetfile.filter(function (singleSheet) {
            return lodash_default().isUndefined(singleSheet.hide) || singleSheet.hide !== 1;
          });
          if (context.luckysheetfile.length > 1 && shownSheets.length > 1) {
            showAlert(sheetconfig.confirmDelete, "yesno", function () {
              setContext(function (ctx) {
                deleteSheet(ctx, sheet.id);
              }, {
                deleteSheetOp: {
                  id: sheet.id
                }
              });
              hideAlert();
            });
          } else {
            showAlert(sheetconfig.noMoreSheet, "ok");
          }
          close();
        }
      }, sheetconfig.delete);
    }
    if (name === "rename") {
      return /*#__PURE__*/react.createElement(Menu, {
        key: name,
        onClick: function onClick() {
          onRename === null || onRename === void 0 ? void 0 : onRename();
          close();
        }
      }, sheetconfig.rename);
    }
    if (name === "move") {
      return /*#__PURE__*/react.createElement(react.Fragment, {
        key: name
      }, /*#__PURE__*/react.createElement(Menu, {
        onClick: function onClick() {
          moveSheet(-1.5);
          close();
        }
      }, sheetconfig.moveLeft), /*#__PURE__*/react.createElement(Menu, {
        onClick: function onClick() {
          moveSheet(1.5);
          close();
        }
      }, sheetconfig.moveRight));
    }
    if (name === "hide") {
      return /*#__PURE__*/react.createElement(Menu, {
        key: name,
        onClick: function onClick() {
          hideSheet();
          close();
        }
      }, sheetconfig.hide);
    }
    if (name === "copy") {
      return /*#__PURE__*/react.createElement(Menu, {
        key: name,
        onClick: function onClick() {
          copySheet();
          close();
        }
      }, sheetconfig.copy);
    }
    if (name === "color") {
      return /*#__PURE__*/react.createElement(Menu, {
        key: name,
        onMouseEnter: function onMouseEnter() {
          setIsShowChangeColor(true);
        },
        onMouseLeave: function onMouseLeave() {
          if (!isShowInputColor) {
            setIsShowChangeColor(false);
          }
        }
      }, sheetconfig.changeColor, /*#__PURE__*/react.createElement("span", {
        className: "change-color-triangle"
      }, /*#__PURE__*/react.createElement(SVGIcon, {
        name: "rightArrow",
        width: 18
      })), isShowChangeColor && context.allowEdit && /*#__PURE__*/react.createElement(ChangeColor, {
        triggerParentUpdate: updateShowInputColor
      }));
    }
    if (name === "focus") {
      return /*#__PURE__*/react.createElement(Menu, {
        key: name,
        onClick: function onClick() {
          focusSheet();
          close();
        }
      }, sheetconfig.focus);
    }
    if (name === "|") {
      return /*#__PURE__*/react.createElement(Divider$1, {
        key: "divide-".concat(i)
      });
    }
    return null;
  }));
};
var MoreItemsContaier = function MoreItemsContaier(_ref) {
  var onClose = _ref.onClose,
    children = _ref.children;
  var containerRef = (0,react.useRef)(null);
  useOutsideClick(containerRef, function () {
    onClose === null || onClose === void 0 ? void 0 : onClose();
  }, [containerRef, onClose]);
  return /*#__PURE__*/react.createElement("div", {
    ref: containerRef,
    className: "fortune-toolbar-more-container"
  }, children);
};
function generateAPIs(context, setContext, handleUndo, handleRedo, settings, cellInput, scrollbarX, scrollbarY) {
  return {
    applyOp: function applyOp(ops) {
      setContext(function (ctx_) {
        var _ops$, _ops$$path, _ops$2, _ops$2$path, _ops$3;
        var _opToPatch = opToPatch(ctx_, ops),
          _opToPatch2 = dist_index_esm_slicedToArray(_opToPatch, 2),
          patches = _opToPatch2[0],
          specialOps = _opToPatch2[1];
        if (specialOps.length > 0) {
          var _specialOps = dist_index_esm_slicedToArray(specialOps, 1),
            specialOp = _specialOps[0];
          if (specialOp.op === "insertRowCol") {
            try {
              insertRowCol(ctx_, specialOp.value, false);
            } catch (e) {
              console.error(e);
            }
          } else if (specialOp.op === "deleteRowCol") {
            deleteRowCol(ctx_, specialOp.value);
          } else if (specialOp.op === "addSheet") {
            var _patches$filter, _patches$filter$, _specialOp$value;
            var name = (_patches$filter = patches.filter(function (path) {
              return path.path[0] === "name";
            })) === null || _patches$filter === void 0 ? void 0 : (_patches$filter$ = _patches$filter[0]) === null || _patches$filter$ === void 0 ? void 0 : _patches$filter$.value;
            if ((_specialOp$value = specialOp.value) === null || _specialOp$value === void 0 ? void 0 : _specialOp$value.id) {
              addSheet(ctx_, settings, specialOp.value.id, false, name, specialOp.value);
            }
            var fileIndex = getSheetIndex(ctx_, specialOp.value.id);
            index_esm_index.initSheetData(ctx_, fileIndex, specialOp.value);
          } else if (specialOp.op === "deleteSheet") {
            deleteSheet(ctx_, specialOp.value.id);
            patches.length = 0;
          }
        }
        if (((_ops$ = ops[0]) === null || _ops$ === void 0 ? void 0 : (_ops$$path = _ops$.path) === null || _ops$$path === void 0 ? void 0 : _ops$$path[0]) === "filter_select") ctx_.luckysheet_filter_save = ops[0].value;else if (((_ops$2 = ops[0]) === null || _ops$2 === void 0 ? void 0 : (_ops$2$path = _ops$2.path) === null || _ops$2$path === void 0 ? void 0 : _ops$2$path[0]) === "hide") {
          if (ctx_.currentSheetId === ops[0].id) {
            var shownSheets = ctx_.luckysheetfile.filter(function (sheet) {
              return (lodash_default().isUndefined(sheet.hide) || (sheet === null || sheet === void 0 ? void 0 : sheet.hide) !== 1) && sheet.id !== ops[0].id;
            });
            ctx_.currentSheetId = lodash_default().sortBy(shownSheets, function (sheet) {
              return sheet.order;
            })[0].id;
          }
        }
        createFilterOptions(ctx_, ctx_.luckysheet_filter_save, (_ops$3 = ops[0]) === null || _ops$3 === void 0 ? void 0 : _ops$3.id);
        if (patches.length === 0) return;
        try {
          (0,immer_esm/* applyPatches */.QE)(ctx_, patches);
        } catch (e) {
          console.error(e);
        }
      }, {
        noHistory: true
      });
    },
    getCellValue: function getCellValue(row, column) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return index_esm_index.getCellValue(context, row, column, options);
    },
    setCellValue: function setCellValue(row, column, value) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      return setContext(function (draftCtx) {
        return index_esm_index.setCellValue(draftCtx, row, column, value, cellInput, options);
      });
    },
    clearCell: function clearCell(row, column) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return setContext(function (draftCtx) {
        return index_esm_index.clearCell(draftCtx, row, column, options);
      });
    },
    setCellFormat: function setCellFormat(row, column, attr, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      return setContext(function (draftCtx) {
        return index_esm_index.setCellFormat(draftCtx, row, column, attr, value, options);
      });
    },
    autoFillCell: function autoFillCell(copyRange, applyRange, direction) {
      return setContext(function (draftCtx) {
        return index_esm_index.autoFillCell(draftCtx, copyRange, applyRange, direction);
      });
    },
    freeze: function freeze(type, range) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return setContext(function (draftCtx) {
        return index_esm_index.freeze(draftCtx, type, range, options);
      });
    },
    insertRowOrColumn: function insertRowOrColumn(type, index, count) {
      var direction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "rightbottom";
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      return setContext(function (draftCtx) {
        return index_esm_index.insertRowOrColumn(draftCtx, type, index, count, direction, options);
      });
    },
    deleteRowOrColumn: function deleteRowOrColumn(type, start, end) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      return setContext(function (draftCtx) {
        return index_esm_index.deleteRowOrColumn(draftCtx, type, start, end, options);
      });
    },
    hideRowOrColumn: function hideRowOrColumn(rowOrColInfo, type) {
      return setContext(function (draftCtx) {
        return index_esm_index.hideRowOrColumn(draftCtx, rowOrColInfo, type);
      });
    },
    showRowOrColumn: function showRowOrColumn(rowOrColInfo, type) {
      return setContext(function (draftCtx) {
        return index_esm_index.showRowOrColumn(draftCtx, rowOrColInfo, type);
      });
    },
    setRowHeight: function setRowHeight(rowInfo) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var custom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return setContext(function (draftCtx) {
        return index_esm_index.setRowHeight(draftCtx, rowInfo, options, custom);
      });
    },
    setColumnWidth: function setColumnWidth(columnInfo) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var custom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return setContext(function (draftCtx) {
        return index_esm_index.setColumnWidth(draftCtx, columnInfo, options, custom);
      });
    },
    getRowHeight: function getRowHeight(rows) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return index_esm_index.getRowHeight(context, rows, options);
    },
    getColumnWidth: function getColumnWidth(columns) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return index_esm_index.getColumnWidth(context, columns, options);
    },
    getSelection: function getSelection() {
      return index_esm_index.getSelection(context);
    },
    getFlattenRange: function getFlattenRange(range) {
      return index_esm_index.getFlattenRange(context, range);
    },
    getCellsByFlattenRange: function getCellsByFlattenRange(range) {
      return index_esm_index.getCellsByFlattenRange(context, range);
    },
    getSelectionCoordinates: function getSelectionCoordinates() {
      return index_esm_index.getSelectionCoordinates(context);
    },
    getCellsByRange: function getCellsByRange(range) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return index_esm_index.getCellsByRange(context, range, options);
    },
    getHtmlByRange: function getHtmlByRange(range) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return index_esm_index.getHtmlByRange(context, range, options);
    },
    setSelection: function setSelection(range) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return setContext(function (draftCtx) {
        return index_esm_index.setSelection(draftCtx, range, options);
      });
    },
    setCellValuesByRange: function setCellValuesByRange(data, range) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return setContext(function (draftCtx) {
        return index_esm_index.setCellValuesByRange(draftCtx, data, range, cellInput, options);
      });
    },
    setCellFormatByRange: function setCellFormatByRange(attr, value, range) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      return setContext(function (draftCtx) {
        return index_esm_index.setCellFormatByRange(draftCtx, attr, value, range, options);
      });
    },
    mergeCells: function mergeCells(ranges, type) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return setContext(function (draftCtx) {
        return index_esm_index.mergeCells(draftCtx, ranges, type, options);
      });
    },
    cancelMerge: function cancelMerge(ranges) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return setContext(function (draftCtx) {
        return index_esm_index.cancelMerge(draftCtx, ranges, options);
      });
    },
    getAllSheets: function getAllSheets() {
      return index_esm_index.getAllSheets(context);
    },
    getSheet: function getSheet() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return index_esm_index.getSheetWithLatestCelldata(context, options);
    },
    addSheet: function addSheet() {
      return setContext(function (draftCtx) {
        return index_esm_index.addSheet(draftCtx, settings);
      });
    },
    deleteSheet: function deleteSheet() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return setContext(function (draftCtx) {
        return index_esm_index.deleteSheet(draftCtx, options);
      });
    },
    updateSheet: function updateSheet(data) {
      return setContext(function (draftCtx) {
        return index_esm_index.updateSheet(draftCtx, data);
      });
    },
    activateSheet: function activateSheet() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return setContext(function (draftCtx) {
        return index_esm_index.activateSheet(draftCtx, options);
      });
    },
    setSheetName: function setSheetName(name) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return setContext(function (draftCtx) {
        return index_esm_index.setSheetName(draftCtx, name, options);
      });
    },
    setSheetOrder: function setSheetOrder(orderList) {
      return setContext(function (draftCtx) {
        return index_esm_index.setSheetOrder(draftCtx, orderList);
      });
    },
    scroll: function scroll(options) {
      return index_esm_index.scroll(context, scrollbarX, scrollbarY, options);
    },
    addPresences: function addPresences(newPresences) {
      setContext(function (draftCtx) {
        draftCtx.presences = lodash_default().differenceBy(draftCtx.presences || [], newPresences, function (v) {
          return v.userId == null ? v.username : v.userId;
        }).concat(newPresences);
      });
    },
    removePresences: function removePresences(arr) {
      setContext(function (draftCtx) {
        if (draftCtx.presences != null) {
          draftCtx.presences = lodash_default().differenceBy(draftCtx.presences, arr, function (v) {
            return v.userId == null ? v.username : v.userId;
          });
        }
      });
    },
    handleUndo: handleUndo,
    handleRedo: handleRedo,
    calculateFormula: function calculateFormula() {
      setContext(function (draftCtx) {
        lodash_default().forEach(draftCtx.luckysheetfile, function (sheet_obj) {
          index_esm_index.calculateSheetFromula(draftCtx, sheet_obj.id);
        });
      });
    },
    dataToCelldata: function dataToCelldata(data) {
      return index_esm_index.dataToCelldata(data);
    },
    celldataToData: function celldataToData(celldata, rowCount, colCount) {
      return index_esm_index.celldataToData(celldata, rowCount, colCount);
    }
  };
}
var SelectItem = function SelectItem(_ref) {
  var item = _ref.item,
    isChecked = _ref.isChecked,
    _onChange = _ref.onChange,
    isItemVisible = _ref.isItemVisible;
  var checked = (0,react.useMemo)(function () {
    return isChecked(item.key);
  }, [isChecked, item.key]);
  return isItemVisible(item) ? /*#__PURE__*/react.createElement("div", {
    className: "select-item"
  }, /*#__PURE__*/react.createElement("input", {
    className: "filter-checkbox",
    type: "checkbox",
    checked: checked,
    onChange: function onChange() {
      _onChange(item, !checked);
    }
  }), /*#__PURE__*/react.createElement("div", null, item.text), /*#__PURE__*/react.createElement("span", {
    className: "count"
  }, "( ".concat(item.rows.length, " )"))) : null;
};
var DateSelectTreeItem = function DateSelectTreeItem(_ref2) {
  var item = _ref2.item,
    _ref2$depth = _ref2.depth,
    depth = _ref2$depth === void 0 ? 0 : _ref2$depth,
    initialExpand = _ref2.initialExpand,
    onExpand = _ref2.onExpand,
    isChecked = _ref2.isChecked,
    _onChange2 = _ref2.onChange,
    isItemVisible = _ref2.isItemVisible;
  var _useState = (0,react.useState)(initialExpand(item.key)),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    expand = _useState2[0],
    setExpand = _useState2[1];
  var checked = (0,react.useMemo)(function () {
    return isChecked(item.key);
  }, [isChecked, item.key]);
  return isItemVisible(item) ? /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "select-item",
    style: {
      marginLeft: -2 + depth * 20
    },
    onClick: function onClick() {
      onExpand === null || onExpand === void 0 ? void 0 : onExpand(item.key, !expand);
      setExpand(!expand);
    },
    tabIndex: 0
  }, lodash_default().isEmpty(item.children) ? /*#__PURE__*/react.createElement("div", {
    style: {
      width: 10
    }
  }) : /*#__PURE__*/react.createElement("div", {
    className: "filter-caret ".concat(expand ? "down" : "right"),
    style: {
      cursor: "pointer"
    }
  }), /*#__PURE__*/react.createElement("input", {
    className: "filter-checkbox",
    type: "checkbox",
    checked: checked,
    onChange: function onChange() {
      _onChange2(item, !checked);
    },
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    tabIndex: 0
  }), /*#__PURE__*/react.createElement("div", null, item.text), /*#__PURE__*/react.createElement("span", {
    className: "count"
  }, "( ".concat(item.rows.length, " )"))), expand && item.children.map(function (v) {
    return /*#__PURE__*/react.createElement(DateSelectTreeItem, index_esm_objectSpread2({
      key: v.key,
      item: v,
      depth: depth + 1
    }, {
      initialExpand: initialExpand,
      onExpand: onExpand,
      isChecked: isChecked,
      onChange: _onChange2,
      isItemVisible: isItemVisible
    }));
  })) : null;
};
var DateSelectTree = function DateSelectTree(_ref3) {
  var dates = _ref3.dates,
    initialExpand = _ref3.initialExpand,
    onExpand = _ref3.onExpand,
    isChecked = _ref3.isChecked,
    onChange = _ref3.onChange,
    isItemVisible = _ref3.isItemVisible;
  return /*#__PURE__*/react.createElement(react.Fragment, null, dates.map(function (v) {
    return /*#__PURE__*/react.createElement(DateSelectTreeItem, index_esm_objectSpread2({
      key: v.key,
      item: v
    }, {
      initialExpand: initialExpand,
      onExpand: onExpand,
      isChecked: isChecked,
      onChange: onChange,
      isItemVisible: isItemVisible
    }));
  }));
};
var FilterMenu = function FilterMenu() {
  var _settings$filterConte;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    settings = _useContext.settings,
    refs = _useContext.refs;
  var containerRef = (0,react.useRef)(null);
  var contextRef = (0,react.useRef)(context);
  var byColorMenuRef = (0,react.useRef)(null);
  var subMenuRef = (0,react.useRef)(null);
  var filterContextMenu = context.filterContextMenu;
  var _ref4 = filterContextMenu || {
      startRow: null,
      startCol: null,
      endRow: null,
      endCol: null,
      col: null,
      listBoxMaxHeight: 400
    },
    startRow = _ref4.startRow,
    startCol = _ref4.startCol,
    endRow = _ref4.endRow,
    endCol = _ref4.endCol,
    col = _ref4.col,
    listBoxMaxHeight = _ref4.listBoxMaxHeight;
  var _locale = locale(context),
    filter = _locale.filter;
  var _useState3 = (0,react.useState)({
      dates: [],
      dateRowMap: {},
      values: [],
      valueRowMap: {},
      visibleRows: [],
      flattenValues: []
    }),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    data = _useState4[0],
    setData = _useState4[1];
  var _useState5 = (0,react.useState)([]),
    _useState6 = dist_index_esm_slicedToArray(_useState5, 2),
    datesUncheck = _useState6[0],
    setDatesUncheck = _useState6[1];
  var _useState7 = (0,react.useState)([]),
    _useState8 = dist_index_esm_slicedToArray(_useState7, 2),
    valuesUncheck = _useState8[0],
    setValuesUncheck = _useState8[1];
  var dateTreeExpandState = (0,react.useRef)({});
  var hiddenRows = (0,react.useRef)([]);
  var _useState9 = (0,react.useState)([]),
    _useState10 = dist_index_esm_slicedToArray(_useState9, 2),
    showValues = _useState10[0],
    setShowValues = _useState10[1];
  var _useState11 = (0,react.useState)(""),
    _useState12 = dist_index_esm_slicedToArray(_useState11, 2),
    searchText = _useState12[0],
    setSearchText = _useState12[1];
  var _useState13 = (0,react.useState)(),
    _useState14 = dist_index_esm_slicedToArray(_useState13, 2),
    subMenuPos = _useState14[0],
    setSubMenuPos = _useState14[1];
  var _useState15 = (0,react.useState)({
      bgColors: [],
      fcColors: []
    }),
    _useState16 = dist_index_esm_slicedToArray(_useState15, 2),
    filterColors = _useState16[0],
    setFilterColors = _useState16[1];
  var _useState17 = (0,react.useState)(false),
    _useState18 = dist_index_esm_slicedToArray(_useState17, 2),
    showSubMenu = _useState18[0],
    setShowSubMenu = _useState18[1];
  var _useAlert = useAlert(),
    showAlert = _useAlert.showAlert;
  var mouseHoverSubMenu = (0,react.useRef)(false);
  contextRef.current = context;
  var close = (0,react.useCallback)(function () {
    setContext(function (ctx) {
      ctx.filterContextMenu = undefined;
    });
  }, [setContext]);
  useOutsideClick(containerRef, close, [close]);
  var initialExpand = (0,react.useCallback)(function (key) {
    var expand = dateTreeExpandState.current[key];
    if (expand == null) {
      dateTreeExpandState.current[key] = true;
      return true;
    }
    return expand;
  }, []);
  var onExpand = (0,react.useCallback)(function (key, expand) {
    dateTreeExpandState.current[key] = expand;
  }, []);
  var searchValues = (0,react.useMemo)(function () {
    return lodash_default().debounce(function (text) {
      setShowValues(lodash_default().filter(data.flattenValues, function (v) {
        return v.toLowerCase().indexOf(text.toLowerCase()) > -1;
      }));
    }, 300);
  }, [data.flattenValues]);
  var selectAll = (0,react.useCallback)(function () {
    setDatesUncheck([]);
    setValuesUncheck([]);
    hiddenRows.current = [];
  }, []);
  var clearAll = (0,react.useCallback)(function () {
    setDatesUncheck(lodash_default().keys(data.dateRowMap));
    setValuesUncheck(lodash_default().keys(data.valueRowMap));
    hiddenRows.current = data.visibleRows;
  }, [data.dateRowMap, data.valueRowMap, data.visibleRows]);
  var inverseSelect = (0,react.useCallback)(function () {
    setDatesUncheck((0,immer_esm/* default */.ZP)(function (draft) {
      return lodash_default().xor(draft, lodash_default().keys(data.dateRowMap));
    }));
    setValuesUncheck((0,immer_esm/* default */.ZP)(function (draft) {
      return lodash_default().xor(draft, lodash_default().keys(data.valueRowMap));
    }));
    hiddenRows.current = lodash_default().xor(hiddenRows.current, data.visibleRows);
  }, [data.dateRowMap, data.valueRowMap, data.visibleRows]);
  var onColorSelectChange = (0,react.useCallback)(function (key, color, checked) {
    setFilterColors((0,immer_esm/* default */.ZP)(function (draft) {
      var colorData = lodash_default().find(lodash_default().get(draft, key), function (v) {
        return v.color === color;
      });
      colorData.checked = checked;
    }));
  }, []);
  var delayHideSubMenu = (0,react.useMemo)(function () {
    return lodash_default().debounce(function () {
      if (mouseHoverSubMenu.current) return;
      setShowSubMenu(false);
    }, 200);
  }, []);
  var sortData = (0,react.useCallback)(function (asc) {
    if (col == null) return;
    setContext(function (draftCtx) {
      var errMsg = orderbydatafiler(draftCtx, startRow, startCol, endRow, endCol, col, asc);
      if (errMsg != null) showAlert(errMsg);
    });
  }, [col, setContext, startRow, startCol, endRow, endCol, showAlert]);
  var renderColorList = (0,react.useCallback)(function (key, title, colors, onSelectChange) {
    return colors.length > 1 ? /*#__PURE__*/react.createElement("div", {
      key: key
    }, /*#__PURE__*/react.createElement("div", {
      className: "title"
    }, title), /*#__PURE__*/react.createElement("div", {
      className: "color-list"
    }, colors.map(function (v) {
      return /*#__PURE__*/react.createElement("div", {
        key: v.color,
        className: "item",
        onClick: function onClick() {
          return onSelectChange(key, v.color, !v.checked);
        },
        tabIndex: 0
      }, /*#__PURE__*/react.createElement("div", {
        className: "color-label",
        style: {
          backgroundColor: v.color
        }
      }), /*#__PURE__*/react.createElement("input", {
        className: "luckysheet-mousedown-cancel",
        type: "checkbox",
        checked: v.checked,
        onChange: function onChange() {}
      }));
    }))) : null;
  }, []);
  (0,react.useLayoutEffect)(function () {
    var _refs$workbookContain;
    if (!containerRef.current || !filterContextMenu) {
      return;
    }
    var winH = window.innerHeight;
    var winW = window.innerWidth;
    var rect = containerRef.current.getBoundingClientRect();
    var workbookRect = (_refs$workbookContain = refs.workbookContainer.current) === null || _refs$workbookContain === void 0 ? void 0 : _refs$workbookContain.getBoundingClientRect();
    if (!workbookRect) {
      return;
    }
    var menuW = rect.width;
    var menuH = 350;
    var top = filterContextMenu.y;
    var left = filterContextMenu.x;
    var hasOverflow = false;
    if (workbookRect.left + left + menuW > winW) {
      left -= menuW;
      hasOverflow = true;
    }
    if (workbookRect.top + top + menuH > winH) {
      top -= menuH;
      hasOverflow = true;
    }
    if (top < 0) {
      top = 0;
      hasOverflow = true;
    }
    var containerH = winH - rect.top - 350;
    if (containerH < 0) {
      containerH = 100;
    }
    if (filterContextMenu.x === left && filterContextMenu.y === top && filterContextMenu.listBoxMaxHeight === containerH) {
      return;
    }
    setContext(function (draftCtx) {
      if (hasOverflow) {
        lodash_default().set(draftCtx, "filterContextMenu.x", left);
        lodash_default().set(draftCtx, "filterContextMenu.y", top);
      }
      lodash_default().set(draftCtx, "filterContextMenu.listBoxMaxHeight", containerH);
    });
  }, [filterContextMenu, refs.workbookContainer, setContext]);
  (0,react.useLayoutEffect)(function () {
    var _byColorMenuRef$curre, _subMenuRef$current;
    if (!subMenuPos) return;
    var rect = (_byColorMenuRef$curre = byColorMenuRef.current) === null || _byColorMenuRef$curre === void 0 ? void 0 : _byColorMenuRef$curre.getBoundingClientRect();
    var subMenuRect = (_subMenuRef$current = subMenuRef.current) === null || _subMenuRef$current === void 0 ? void 0 : _subMenuRef$current.getBoundingClientRect();
    if (rect == null || subMenuRect == null) return;
    var winW = window.innerWidth;
    var pos = lodash_default().cloneDeep(subMenuPos);
    if (subMenuRect.left + subMenuRect.width > winW) {
      pos.left -= subMenuRect.width;
      setSubMenuPos(pos);
    }
  }, [subMenuPos]);
  (0,react.useEffect)(function () {
    if (col == null) return;
    setSearchText("");
    setShowSubMenu(false);
    dateTreeExpandState.current = {};
    hiddenRows.current = (filterContextMenu === null || filterContextMenu === void 0 ? void 0 : filterContextMenu.hiddenRows) || [];
    var res = getFilterColumnValues(contextRef.current, col, startRow, endRow, startCol);
    setData(lodash_default().omit(res, ["datesUncheck", "valuesUncheck"]));
    setDatesUncheck(res.datesUncheck);
    setValuesUncheck(res.valuesUncheck);
    setShowValues(res.flattenValues);
  }, [col, endRow, startRow, startCol, hiddenRows, filterContextMenu === null || filterContextMenu === void 0 ? void 0 : filterContextMenu.hiddenRows]);
  (0,react.useEffect)(function () {
    if (col == null) return;
    setFilterColors(getFilterColumnColors(contextRef.current, col, startRow, endRow));
  }, [col, endRow, startRow]);
  if (filterContextMenu == null) return null;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    className: "fortune-context-menu luckysheet-cols-menu fortune-filter-menu",
    id: "luckysheet-\\${menuid}-menu",
    ref: containerRef,
    style: {
      left: filterContextMenu.x,
      top: filterContextMenu.y
    }
  }, (_settings$filterConte = settings.filterContextMenu) === null || _settings$filterConte === void 0 ? void 0 : _settings$filterConte.map(function (name, i) {
    if (name === "|") {
      return /*#__PURE__*/react.createElement(Divider$1, {
        key: "divider-".concat(i)
      });
    }
    if (name === "sort-by-asc") {
      return /*#__PURE__*/react.createElement(Menu, {
        key: name,
        onClick: function onClick() {
          return sortData(true);
        }
      }, filter.sortByAsc);
    }
    if (name === "sort-by-desc") {
      return /*#__PURE__*/react.createElement(Menu, {
        key: name,
        onClick: function onClick() {
          return sortData(false);
        }
      }, filter.sortByDesc);
    }
    if (name === "filter-by-color") {
      return /*#__PURE__*/react.createElement("div", {
        key: name,
        ref: byColorMenuRef,
        onMouseEnter: function onMouseEnter() {
          var _byColorMenuRef$curre2;
          if (!containerRef.current || !filterContextMenu) {
            return;
          }
          setShowSubMenu(true);
          var rect = (_byColorMenuRef$curre2 = byColorMenuRef.current) === null || _byColorMenuRef$curre2 === void 0 ? void 0 : _byColorMenuRef$curre2.getBoundingClientRect();
          if (rect == null) return;
          setSubMenuPos({
            top: rect.top - 5,
            left: rect.right
          });
        },
        onMouseLeave: delayHideSubMenu
      }, /*#__PURE__*/react.createElement(Menu, {
        onClick: function onClick() {}
      }, /*#__PURE__*/react.createElement("div", {
        className: "filter-bycolor-container"
      }, filter.filterByColor, /*#__PURE__*/react.createElement("div", {
        className: "filter-caret right"
      }))));
    }
    if (name === "filter-by-condition") {
      return /*#__PURE__*/react.createElement("div", {
        key: "name"
      }, /*#__PURE__*/react.createElement(Menu, {
        onClick: function onClick() {}
      }, /*#__PURE__*/react.createElement("div", {
        className: "filter-caret right"
      }), filter.filterByCondition), /*#__PURE__*/react.createElement("div", {
        className: "luckysheet-\\${menuid}-bycondition",
        style: {
          display: "none"
        }
      }, /*#__PURE__*/react.createElement("div", {
        className: "luckysheet-flat-menu-button luckysheet-mousedown-cancel",
        id: "luckysheet-\\${menuid}-selected"
      }, /*#__PURE__*/react.createElement("span", {
        className: "luckysheet-mousedown-cancel",
        "data-value": "null",
        "data-type": "0"
      }, filter.filiterInputNone), /*#__PURE__*/react.createElement("div", {
        className: "luckysheet-mousedown-cancel"
      }, /*#__PURE__*/react.createElement("i", {
        className: "fa fa-sort",
        "aria-hidden": "true"
      })))));
    }
    if (name === "filter-by-value") {
      return /*#__PURE__*/react.createElement("div", {
        key: name
      }, /*#__PURE__*/react.createElement(Menu, {
        onClick: function onClick() {}
      }, /*#__PURE__*/react.createElement("div", {
        className: "filter-caret right"
      }), filter.filterByValues), /*#__PURE__*/react.createElement("div", {
        className: "luckysheet-filter-byvalue"
      }, /*#__PURE__*/react.createElement("div", {
        className: "fortune-menuitem-row byvalue-btn-row"
      }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("span", {
        className: "fortune-byvalue-btn",
        onClick: selectAll,
        tabIndex: 0
      }, filter.filterValueByAllBtn), " - ", /*#__PURE__*/react.createElement("span", {
        className: "fortune-byvalue-btn",
        onClick: clearAll,
        tabIndex: 0
      }, filter.filterValueByClearBtn), " - ", /*#__PURE__*/react.createElement("span", {
        className: "fortune-byvalue-btn",
        onClick: inverseSelect,
        tabIndex: 0
      }, filter.filterValueByInverseBtn)), /*#__PURE__*/react.createElement("div", {
        className: "byvalue-filter-icon"
      }, /*#__PURE__*/react.createElement(SVGIcon, {
        name: "filter-fill",
        style: {
          width: 20,
          height: 20
        }
      }))), /*#__PURE__*/react.createElement("div", {
        className: "filtermenu-input-container"
      }, /*#__PURE__*/react.createElement("input", {
        type: "text",
        onKeyDown: function onKeyDown(e) {
          return e.stopPropagation();
        },
        placeholder: filter.filterValueByTip,
        className: "luckysheet-mousedown-cancel",
        id: "luckysheet-\\${menuid}-byvalue-input",
        value: searchText,
        onChange: function onChange(e) {
          setSearchText(e.target.value);
          searchValues(e.target.value);
        }
      })), /*#__PURE__*/react.createElement("div", {
        id: "luckysheet-filter-byvalue-select",
        style: {
          maxHeight: listBoxMaxHeight
        }
      }, /*#__PURE__*/react.createElement(DateSelectTree, {
        dates: data.dates,
        onExpand: onExpand,
        initialExpand: initialExpand,
        isChecked: function isChecked(key) {
          return lodash_default().find(datesUncheck, function (v) {
            return v.match(key) != null;
          }) == null;
        },
        onChange: function onChange(item, checked) {
          var rows = hiddenRows.current;
          hiddenRows.current = checked ? lodash_default().without.apply((lodash_default()), [rows].concat(dist_index_esm_toConsumableArray(item.rows))) : lodash_default().union(rows, item.rows);
          setDatesUncheck((0,immer_esm/* default */.ZP)(function (draft) {
            return checked ? lodash_default().without.apply((lodash_default()), [draft].concat(dist_index_esm_toConsumableArray(item.dateValues))) : lodash_default().union(draft, item.dateValues);
          }));
        },
        isItemVisible: function isItemVisible(item) {
          return showValues.length === data.flattenValues.length ? true : lodash_default().findIndex(showValues, function (v) {
            return v.match(item.key) != null;
          }) > -1;
        }
      }), data.values.map(function (v) {
        return /*#__PURE__*/react.createElement(SelectItem, {
          key: v.key,
          item: v,
          isChecked: function isChecked(key) {
            return !lodash_default().includes(valuesUncheck, key);
          },
          onChange: function onChange(item, checked) {
            var rows = hiddenRows.current;
            hiddenRows.current = checked ? lodash_default().without.apply((lodash_default()), [rows].concat(dist_index_esm_toConsumableArray(item.rows))) : lodash_default().concat(rows, item.rows);
            setValuesUncheck((0,immer_esm/* default */.ZP)(function (draft) {
              if (checked) {
                lodash_default().pull(draft, item.key);
              } else {
                draft.push(item.key);
              }
            }));
          },
          isItemVisible: function isItemVisible(item) {
            return showValues.length === data.flattenValues.length ? true : lodash_default().includes(showValues, item.text);
          }
        });
      }))));
    }
    return null;
  }), /*#__PURE__*/react.createElement(Divider$1, null), /*#__PURE__*/react.createElement("div", {
    className: "fortune-menuitem-row"
  }, /*#__PURE__*/react.createElement("div", {
    className: "button-basic button-primary",
    onClick: function onClick() {
      if (col == null) return;
      setContext(function (draftCtx) {
        var rowHidden = lodash_default().reduce(hiddenRows.current, function (pre, curr) {
          pre[curr] = 0;
          return pre;
        }, {});
        saveFilter(draftCtx, hiddenRows.current.length > 0, rowHidden, {}, startRow, endRow, col, startCol, endCol);
        hiddenRows.current = [];
        draftCtx.filterContextMenu = undefined;
      });
    },
    tabIndex: 0
  }, filter.filterConform), /*#__PURE__*/react.createElement("div", {
    className: "button-basic button-default",
    onClick: function onClick() {
      setContext(function (draftCtx) {
        draftCtx.filterContextMenu = undefined;
      });
    },
    tabIndex: 0
  }, filter.filterCancel), /*#__PURE__*/react.createElement("div", {
    className: "button-basic button-danger",
    onClick: function onClick() {
      setContext(function (draftCtx) {
        clearFilter(draftCtx);
      });
    },
    tabIndex: 0
  }, filter.clearFilter))), showSubMenu && /*#__PURE__*/react.createElement("div", {
    ref: subMenuRef,
    className: "luckysheet-filter-bycolor-submenu",
    style: subMenuPos,
    onMouseEnter: function onMouseEnter() {
      mouseHoverSubMenu.current = true;
    },
    onMouseLeave: function onMouseLeave() {
      mouseHoverSubMenu.current = false;
      setShowSubMenu(false);
    }
  }, filterColors.bgColors.length < 2 && filterColors.fcColors.length < 2 ? /*#__PURE__*/react.createElement("div", {
    className: "one-color-tip"
  }, filter.filterContainerOneColorTip) : /*#__PURE__*/react.createElement(react.Fragment, null, [{
    key: "bgColors",
    title: filter.filiterByColorTip,
    colors: filterColors.bgColors
  }, {
    key: "fcColors",
    title: filter.filiterByTextColorTip,
    colors: filterColors.fcColors
  }].map(function (v) {
    return renderColorList(v.key, v.title, v.colors, onColorSelectChange);
  }), /*#__PURE__*/react.createElement("div", {
    className: "button-basic button-primary",
    onClick: function onClick() {
      if (col == null) return;
      setContext(function (draftCtx) {
        var rowHidden = lodash_default().reduce(lodash_default()(filterColors).values().flatten().map(function (v) {
          return v.checked ? [] : v.rows;
        }).flatten().valueOf(), function (pre, curr) {
          pre[curr] = 0;
          return pre;
        }, {});
        saveFilter(draftCtx, !lodash_default().isEmpty(rowHidden), rowHidden, {}, startRow, endRow, col, startCol, endCol);
        hiddenRows.current = [];
        draftCtx.filterContextMenu = undefined;
      });
    },
    tabIndex: 0
  }, filter.filterConform))));
};
var SheetHiddenButton = function SheetHiddenButton(_ref) {
  var style = _ref.style,
    sheet = _ref.sheet;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext;
  var showSheet = (0,react.useCallback)(function () {
    if (context.allowEdit === false) return;
    if (!sheet) return;
    setContext(function (ctx) {
      index_esm_index.showSheet(ctx, sheet.id);
    });
  }, [context.allowEdit, setContext, sheet]);
  return /*#__PURE__*/react.createElement("div", {
    style: style,
    onClick: function onClick(e) {
      e.stopPropagation();
      showSheet();
    },
    tabIndex: 0,
    className: "fortune-sheet-hidden-button"
  }, (sheet === null || sheet === void 0 ? void 0 : sheet.hide) === 1 ? /*#__PURE__*/react.createElement(SVGIcon, {
    name: "hidden",
    width: 16,
    height: 16,
    style: {
      marginTop: "7px"
    }
  }) : "");
};
var SheetListItem = function SheetListItem(_ref) {
  var sheet = _ref.sheet,
    isDropPlaceholder = _ref.isDropPlaceholder;
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext,
    refs = _useContext.refs;
  var containerRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    setContext(function (draftCtx) {
      var r = context.sheetScrollRecord[draftCtx === null || draftCtx === void 0 ? void 0 : draftCtx.currentSheetId];
      if (r) {
        var _r$scrollLeft, _r$scrollTop, _r$luckysheet_select_, _r$luckysheet_select_2;
        draftCtx.scrollLeft = (_r$scrollLeft = r.scrollLeft) !== null && _r$scrollLeft !== void 0 ? _r$scrollLeft : 0;
        draftCtx.scrollTop = (_r$scrollTop = r.scrollTop) !== null && _r$scrollTop !== void 0 ? _r$scrollTop : 0;
        draftCtx.luckysheet_select_status = (_r$luckysheet_select_ = r.luckysheet_select_status) !== null && _r$luckysheet_select_ !== void 0 ? _r$luckysheet_select_ : false;
        draftCtx.luckysheet_select_save = (_r$luckysheet_select_2 = r.luckysheet_select_save) !== null && _r$luckysheet_select_2 !== void 0 ? _r$luckysheet_select_2 : undefined;
      } else {
        draftCtx.scrollLeft = 0;
        draftCtx.scrollTop = 0;
        draftCtx.luckysheet_select_status = false;
        draftCtx.luckysheet_select_save = undefined;
      }
      draftCtx.luckysheet_selection_range = [];
    });
  }, [context.currentSheetId, context.sheetScrollRecord, setContext]);
  return /*#__PURE__*/react.createElement("div", {
    className: "fortune-sheet-list-item",
    key: sheet.id,
    ref: containerRef,
    onClick: function onClick() {
      if (isDropPlaceholder) return;
      setContext(function (draftCtx) {
        draftCtx.sheetScrollRecord[draftCtx.currentSheetId] = {
          scrollLeft: draftCtx.scrollLeft,
          scrollTop: draftCtx.scrollTop,
          luckysheet_select_status: draftCtx.luckysheet_select_status,
          luckysheet_select_save: draftCtx.luckysheet_select_save,
          luckysheet_selection_range: draftCtx.luckysheet_selection_range
        };
        draftCtx.currentSheetId = sheet.id;
        draftCtx.zoomRatio = sheet.zoomRatio || 1;
        cancelActiveImgItem(draftCtx, refs.globalCache);
        cancelNormalSelected(draftCtx);
      });
    },
    tabIndex: 0
  }, /*#__PURE__*/react.createElement("span", {
    className: "fortune-sheet-selected-check-sapce"
  }, sheet.id === context.currentSheetId && /*#__PURE__*/react.createElement(SVGIcon, {
    name: "check",
    width: 16,
    height: 16,
    style: {
      lineHeight: 30,
      verticalAlign: "middle"
    }
  })), /*#__PURE__*/react.createElement("span", {
    className: "luckysheet-sheets-item-name fortune-sheet-list-item-name",
    spellCheck: "false"
  }, !!sheet.color && /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-sheets-list-item-color",
    style: {
      background: sheet.color
    }
  }), sheet.name), sheet.hide && /*#__PURE__*/react.createElement(SheetHiddenButton, {
    sheet: sheet
  }));
};
var SheetList = function SheetList() {
  var _useContext = (0,react.useContext)(WorkbookContext),
    context = _useContext.context,
    setContext = _useContext.setContext;
  var containerRef = (0,react.useRef)(null);
  var close = (0,react.useCallback)(function () {
    setContext(function (ctx) {
      ctx.showSheetList = false;
    });
  }, [setContext]);
  useOutsideClick(containerRef, close, [close]);
  return /*#__PURE__*/react.createElement("div", {
    className: "fortune-context-menu luckysheet-cols-menu fortune-sheet-list",
    ref: containerRef
  }, lodash_default().sortBy(context.luckysheetfile, function (s) {
    return Number(s.order);
  }).map(function (singleSheet) {
    return /*#__PURE__*/react.createElement(SheetListItem, {
      sheet: singleSheet,
      key: singleSheet.id
    });
  }));
};
var _excluded = ["onChange", "onOp", "data"];
(0,immer_esm/* enablePatches */.vI)();
var triggerGroupValuesRefresh = function triggerGroupValuesRefresh(ctx) {
  if (ctx.groupValuesRefreshData.length > 0) {
    groupValuesRefresh(ctx);
  }
};
var concatProducer = function concatProducer() {
  for (var _len = arguments.length, producers = new Array(_len), _key = 0; _key < _len; _key++) {
    producers[_key] = arguments[_key];
  }
  return function (ctx) {
    producers.forEach(function (producer) {
      producer(ctx);
    });
  };
};
var Workbook = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var _context$luckysheetfi;
  var onChange = _ref.onChange,
    onOp = _ref.onOp,
    originalData = _ref.data,
    props = _objectWithoutProperties(_ref, _excluded);
  var globalCache = (0,react.useRef)({
    undoList: [],
    redoList: []
  });
  var cellInput = (0,react.useRef)(null);
  var fxInput = (0,react.useRef)(null);
  var canvas = (0,react.useRef)(null);
  var scrollbarX = (0,react.useRef)(null);
  var scrollbarY = (0,react.useRef)(null);
  var cellArea = (0,react.useRef)(null);
  var workbookContainer = (0,react.useRef)(null);
  var refs = (0,react.useMemo)(function () {
    return {
      globalCache: globalCache.current,
      cellInput: cellInput,
      fxInput: fxInput,
      canvas: canvas,
      scrollbarX: scrollbarX,
      scrollbarY: scrollbarY,
      cellArea: cellArea,
      workbookContainer: workbookContainer
    };
  }, []);
  var _useState = (0,react.useState)(defaultContext(refs)),
    _useState2 = dist_index_esm_slicedToArray(_useState, 2),
    context = _useState2[0],
    setContext = _useState2[1];
  var _locale = locale(context),
    formula = _locale.formula;
  var _useState3 = (0,react.useState)(null),
    _useState4 = dist_index_esm_slicedToArray(_useState3, 2),
    moreToolbarItems = _useState4[0],
    setMoreToolbarItems = _useState4[1];
  var _useState5 = (0,react.useState)({
      numberC: 0,
      count: 0,
      sum: 0,
      max: 0,
      min: 0,
      average: ""
    }),
    _useState6 = dist_index_esm_slicedToArray(_useState5, 2),
    calInfo = _useState6[0],
    setCalInfo = _useState6[1];
  var mergedSettings = (0,react.useMemo)(function () {
    return lodash_default().assign(lodash_default().cloneDeep(defaultSettings), props);
  }, dist_index_esm_toConsumableArray(lodash_default().values(props)));
  (0,react.useEffect)(function () {
    var selection = context.luckysheet_select_save;
    var lang = props.lang;
    if (selection) {
      var re = calcSelectionInfo(context, lang);
      setCalInfo(re);
    }
  }, [context.luckysheet_select_save]);
  var initSheetData = (0,react.useCallback)(function (draftCtx, newData, index) {
    var _lastRow$r, _lastCol$c;
    var celldata = newData.celldata,
      row = newData.row,
      column = newData.column;
    var lastRow = lodash_default().maxBy(celldata, "r");
    var lastCol = lodash_default().maxBy(celldata, "c");
    var lastRowNum = ((_lastRow$r = lastRow === null || lastRow === void 0 ? void 0 : lastRow.r) !== null && _lastRow$r !== void 0 ? _lastRow$r : 0) + 1;
    var lastColNum = ((_lastCol$c = lastCol === null || lastCol === void 0 ? void 0 : lastCol.c) !== null && _lastCol$c !== void 0 ? _lastCol$c : 0) + 1;
    if (row != null && column != null && row > 0 && column > 0) {
      lastRowNum = Math.max(lastRowNum, row);
      lastColNum = Math.max(lastColNum, column);
    } else {
      lastRowNum = Math.max(lastRowNum, draftCtx.defaultrowNum);
      lastColNum = Math.max(lastColNum, draftCtx.defaultcolumnNum);
    }
    if (lastRowNum && lastColNum) {
      var expandedData = lodash_default().times(lastRowNum, function () {
        return lodash_default().times(lastColNum, function () {
          return null;
        });
      });
      celldata === null || celldata === void 0 ? void 0 : celldata.forEach(function (d) {
        expandedData[d.r][d.c] = d.v;
      });
      draftCtx.luckysheetfile = (0,immer_esm/* default */.ZP)(draftCtx.luckysheetfile, function (d) {
        d[index].data = expandedData;
        delete d[index].celldata;
        return d;
      });
      return expandedData;
    }
    return null;
  }, []);
  var emitOp = (0,react.useCallback)(function (ctx, patches, options) {
    var undo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (onOp) {
      onOp(patchToOp(ctx, patches, options, undo));
    }
  }, [onOp]);
  function reduceUndoList(ctx, ctxBefore) {
    var sheetsId = ctx.luckysheetfile.map(function (sheet) {
      return sheet.id;
    });
    var sheetDeletedByMe = globalCache.current.undoList.filter(function (undo) {
      var _undo$options;
      return (_undo$options = undo.options) === null || _undo$options === void 0 ? void 0 : _undo$options.deleteSheetOp;
    }).map(function (item) {
      var _item$options, _item$options$deleteS;
      return (_item$options = item.options) === null || _item$options === void 0 ? void 0 : (_item$options$deleteS = _item$options.deleteSheetOp) === null || _item$options$deleteS === void 0 ? void 0 : _item$options$deleteS.id;
    });
    globalCache.current.undoList = globalCache.current.undoList.filter(function (undo) {
      var _undo$options2, _undo$options3, _undo$options4, _undo$options5;
      return ((_undo$options2 = undo.options) === null || _undo$options2 === void 0 ? void 0 : _undo$options2.deleteSheetOp) || ((_undo$options3 = undo.options) === null || _undo$options3 === void 0 ? void 0 : _undo$options3.id) === undefined || lodash_default().indexOf(sheetsId, (_undo$options4 = undo.options) === null || _undo$options4 === void 0 ? void 0 : _undo$options4.id) !== -1 || lodash_default().indexOf(sheetDeletedByMe, (_undo$options5 = undo.options) === null || _undo$options5 === void 0 ? void 0 : _undo$options5.id) !== -1;
    });
    if (ctxBefore.luckysheetfile.length > ctx.luckysheetfile.length) {
      var sheetDeleted = ctxBefore.luckysheetfile.filter(function (oneSheet) {
        return lodash_default().indexOf(ctx.luckysheetfile.map(function (item) {
          return item.id;
        }), oneSheet.id) === -1;
      }).map(function (item) {
        return getSheetIndex(ctxBefore, item.id);
      });
      var deletedIndex = sheetDeleted[0];
      globalCache.current.undoList = globalCache.current.undoList.map(function (oneStep) {
        oneStep.patches = oneStep.patches.map(function (onePatch) {
          if (typeof onePatch.path[1] === "number" && onePatch.path[1] > deletedIndex) {
            onePatch.path[1] -= 1;
          }
          return onePatch;
        });
        oneStep.inversePatches = oneStep.inversePatches.map(function (onePatch) {
          if (typeof onePatch.path[1] === "number" && onePatch.path[1] > deletedIndex) {
            onePatch.path[1] -= 1;
          }
          return onePatch;
        });
        return oneStep;
      });
    }
  }
  function dataToCelldata(data) {
    var cellData = [];
    for (var row = 0; row < (data === null || data === void 0 ? void 0 : data.length); row += 1) {
      for (var col = 0; col < ((_data$row = data[row]) === null || _data$row === void 0 ? void 0 : _data$row.length); col += 1) {
        var _data$row;
        if (data[row][col] !== null) {
          cellData.push({
            r: row,
            c: col,
            v: data[row][col]
          });
        }
      }
    }
    return cellData;
  }
  var setContextWithProduce = (0,react.useCallback)(function (recipe) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setContext(function (ctx_) {
      var _produceWithPatches = (0,immer_esm/* produceWithPatches */.aS)(ctx_, concatProducer(recipe, triggerGroupValuesRefresh)),
        _produceWithPatches2 = dist_index_esm_slicedToArray(_produceWithPatches, 3),
        result = _produceWithPatches2[0],
        patches = _produceWithPatches2[1],
        inversePatches = _produceWithPatches2[2];
      if (patches.length > 0 && !options.noHistory) {
        if (options.logPatch) {
          console.info("patch", patches);
        }
        var filteredPatches = filterPatch(patches);
        var filteredInversePatches = filterPatch(inversePatches);
        if (filteredInversePatches.length > 0) {
          options.id = ctx_.currentSheetId;
          if (options.deleteSheetOp) {
            var target = ctx_.luckysheetfile.filter(function (sheet) {
              var _options$deleteSheetO;
              return sheet.id === ((_options$deleteSheetO = options.deleteSheetOp) === null || _options$deleteSheetO === void 0 ? void 0 : _options$deleteSheetO.id);
            });
            if (target) {
              var index = getSheetIndex(ctx_, options.deleteSheetOp.id);
              options.deletedSheet = {
                id: options.deleteSheetOp.id,
                index: index,
                value: lodash_default().cloneDeep(ctx_.luckysheetfile[index])
              };
              options.deletedSheet.value.celldata = dataToCelldata(options.deletedSheet.value.data);
              delete options.deletedSheet.value.data;
              options.deletedSheet.value.status = 0;
              filteredInversePatches = [{
                op: "add",
                path: ["luckysheetfile", 0],
                value: options.deletedSheet.value
              }];
            }
          } else if (options.addSheetOp) {
            options.addSheet = {};
            options.addSheet.id = result.luckysheetfile[result.luckysheetfile.length - 1].id;
          }
          globalCache.current.undoList.push({
            patches: filteredPatches,
            inversePatches: filteredInversePatches,
            options: options
          });
          globalCache.current.redoList = [];
          emitOp(result, filteredPatches, options);
        }
      } else {
        var _patches$, _patches$$value, _ctx_$luckysheetfile;
        if ((patches === null || patches === void 0 ? void 0 : (_patches$ = patches[0]) === null || _patches$ === void 0 ? void 0 : (_patches$$value = _patches$.value) === null || _patches$$value === void 0 ? void 0 : _patches$$value.length) < (ctx_ === null || ctx_ === void 0 ? void 0 : (_ctx_$luckysheetfile = ctx_.luckysheetfile) === null || _ctx_$luckysheetfile === void 0 ? void 0 : _ctx_$luckysheetfile.length)) {
          reduceUndoList(result, ctx_);
        }
      }
      return result;
    });
  }, [emitOp]);
  var handleUndo = (0,react.useCallback)(function () {
    var history = globalCache.current.undoList.pop();
    if (history) {
      setContext(function (ctx_) {
        var _history$options, _history$options3;
        if ((_history$options = history.options) === null || _history$options === void 0 ? void 0 : _history$options.deleteSheetOp) {
          var _history$options$dele, _history$options$dele2;
          history.inversePatches[0].path[1] = ctx_.luckysheetfile.length;
          var order = (_history$options$dele = history.options.deletedSheet) === null || _history$options$dele === void 0 ? void 0 : (_history$options$dele2 = _history$options$dele.value) === null || _history$options$dele2 === void 0 ? void 0 : _history$options$dele2.order;
          var sheetsRight = ctx_.luckysheetfile.filter(function (sheet) {
            var _history$options2, _history$options2$del;
            return (sheet === null || sheet === void 0 ? void 0 : sheet.order) >= order && sheet.id !== (history === null || history === void 0 ? void 0 : (_history$options2 = history.options) === null || _history$options2 === void 0 ? void 0 : (_history$options2$del = _history$options2.deleteSheetOp) === null || _history$options2$del === void 0 ? void 0 : _history$options2$del.id);
          });
          lodash_default().forEach(sheetsRight, function (sheet) {
            history.inversePatches.push({
              op: "replace",
              path: ["luckysheetfile", getSheetIndex(ctx_, sheet.id), "order"],
              value: (sheet === null || sheet === void 0 ? void 0 : sheet.order) + 1
            });
          });
        }
        var newContext = (0,immer_esm/* applyPatches */.QE)(ctx_, history.inversePatches);
        globalCache.current.redoList.push(history);
        var inversedOptions = inverseRowColOptions(history.options);
        if (inversedOptions === null || inversedOptions === void 0 ? void 0 : inversedOptions.insertRowColOp) {
          inversedOptions.restoreDeletedCells = true;
        }
        if ((_history$options3 = history.options) === null || _history$options3 === void 0 ? void 0 : _history$options3.addSheetOp) {
          var _inversedOptions$addS;
          var index = getSheetIndex(ctx_, history.options.addSheet.id);
          inversedOptions.addSheet = {
            id: history.options.addSheet.id,
            index: index,
            value: lodash_default().cloneDeep(ctx_.luckysheetfile[index])
          };
          inversedOptions.addSheet.value.celldata = dataToCelldata((_inversedOptions$addS = inversedOptions.addSheet.value) === null || _inversedOptions$addS === void 0 ? void 0 : _inversedOptions$addS.data);
          delete inversedOptions.addSheet.value.data;
        }
        emitOp(newContext, history.inversePatches, inversedOptions, true);
        return newContext;
      });
    }
  }, [emitOp]);
  var handleRedo = (0,react.useCallback)(function () {
    var history = globalCache.current.redoList.pop();
    if (history) {
      setContext(function (ctx_) {
        var newContext = (0,immer_esm/* applyPatches */.QE)(ctx_, history.patches);
        globalCache.current.undoList.push(history);
        emitOp(newContext, history.patches, history.options);
        return newContext;
      });
    }
  }, [emitOp]);
  (0,react.useEffect)(function () {
    if (context.luckysheet_select_save != null) {
      var _mergedSettings$hooks, _mergedSettings$hooks2;
      (_mergedSettings$hooks = mergedSettings.hooks) === null || _mergedSettings$hooks === void 0 ? void 0 : (_mergedSettings$hooks2 = _mergedSettings$hooks.afterSelectionChange) === null || _mergedSettings$hooks2 === void 0 ? void 0 : _mergedSettings$hooks2.call(_mergedSettings$hooks, context.currentSheetId, context.luckysheet_select_save[0]);
    }
  }, [context.currentSheetId, context.luckysheet_select_save, mergedSettings.hooks]);
  var providerValue = (0,react.useMemo)(function () {
    return {
      context: context,
      setContext: setContextWithProduce,
      settings: mergedSettings,
      handleUndo: handleUndo,
      handleRedo: handleRedo,
      refs: refs
    };
  }, [context, handleRedo, handleUndo, mergedSettings, refs, setContextWithProduce]);
  (0,react.useEffect)(function () {
    if (!lodash_default().isEmpty(context.luckysheetfile)) {
      onChange === null || onChange === void 0 ? void 0 : onChange(context.luckysheetfile);
    }
  }, [context.luckysheetfile, onChange]);
  (0,react.useEffect)(function () {
    setContextWithProduce(function (draftCtx) {
      var _draftCtx$luckysheetf4, _draftCtx$luckysheet_;
      draftCtx.defaultcolumnNum = mergedSettings.column;
      draftCtx.defaultrowNum = mergedSettings.row;
      draftCtx.defaultFontSize = mergedSettings.defaultFontSize;
      if (lodash_default().isEmpty(draftCtx.luckysheetfile)) {
        var newData = (0,immer_esm/* default */.ZP)(originalData, function (draftData) {
          ensureSheetIndex(draftData, mergedSettings.generateSheetId);
        });
        draftCtx.luckysheetfile = newData;
        newData.forEach(function (newDatum) {
          var _draftCtx$luckysheetf;
          var index = getSheetIndex(draftCtx, newDatum.id);
          var sheet = (_draftCtx$luckysheetf = draftCtx.luckysheetfile) === null || _draftCtx$luckysheetf === void 0 ? void 0 : _draftCtx$luckysheetf[index];
          initSheetData(draftCtx, sheet, index);
        });
      }
      if (mergedSettings.devicePixelRatio > 0) {
        draftCtx.devicePixelRatio = mergedSettings.devicePixelRatio;
      }
      draftCtx.lang = mergedSettings.lang;
      draftCtx.allowEdit = mergedSettings.allowEdit;
      draftCtx.hooks = mergedSettings.hooks;
      if (lodash_default().isEmpty(draftCtx.currentSheetId)) {
        initSheetIndex(draftCtx);
      }
      var sheetIdx = getSheetIndex(draftCtx, draftCtx.currentSheetId);
      if (sheetIdx == null) {
        var _draftCtx$luckysheetf2, _draftCtx$luckysheetf3;
        if (((_draftCtx$luckysheetf2 = (_draftCtx$luckysheetf3 = draftCtx.luckysheetfile) === null || _draftCtx$luckysheetf3 === void 0 ? void 0 : _draftCtx$luckysheetf3.length) !== null && _draftCtx$luckysheetf2 !== void 0 ? _draftCtx$luckysheetf2 : 0) > 0) {
          sheetIdx = 0;
          draftCtx.currentSheetId = draftCtx.luckysheetfile[0].id;
        }
      }
      if (sheetIdx == null) return;
      var sheet = (_draftCtx$luckysheetf4 = draftCtx.luckysheetfile) === null || _draftCtx$luckysheetf4 === void 0 ? void 0 : _draftCtx$luckysheetf4[sheetIdx];
      if (!sheet) return;
      var data = sheet.data;
      if (lodash_default().isEmpty(data)) {
        var temp = initSheetData(draftCtx, sheet, sheetIdx);
        if (!lodash_default().isNull(temp)) {
          data = temp;
        }
      }
      if (lodash_default().isEmpty(draftCtx.luckysheet_select_save) && !lodash_default().isEmpty(sheet.luckysheet_select_save)) {
        draftCtx.luckysheet_select_save = sheet.luckysheet_select_save;
      }
      if (((_draftCtx$luckysheet_ = draftCtx.luckysheet_select_save) === null || _draftCtx$luckysheet_ === void 0 ? void 0 : _draftCtx$luckysheet_.length) === 0) {
        var _data, _data$, _data$$, _data2, _data2$, _data2$$, _data2$$$mc, _data3, _data3$, _data3$$, _data3$$$mc;
        if (((_data = data) === null || _data === void 0 ? void 0 : (_data$ = _data[0]) === null || _data$ === void 0 ? void 0 : (_data$$ = _data$[0]) === null || _data$$ === void 0 ? void 0 : _data$$.mc) && !lodash_default().isNil((_data2 = data) === null || _data2 === void 0 ? void 0 : (_data2$ = _data2[0]) === null || _data2$ === void 0 ? void 0 : (_data2$$ = _data2$[0]) === null || _data2$$ === void 0 ? void 0 : (_data2$$$mc = _data2$$.mc) === null || _data2$$$mc === void 0 ? void 0 : _data2$$$mc.rs) && !lodash_default().isNil((_data3 = data) === null || _data3 === void 0 ? void 0 : (_data3$ = _data3[0]) === null || _data3$ === void 0 ? void 0 : (_data3$$ = _data3$[0]) === null || _data3$$ === void 0 ? void 0 : (_data3$$$mc = _data3$$.mc) === null || _data3$$$mc === void 0 ? void 0 : _data3$$$mc.cs)) {
          draftCtx.luckysheet_select_save = [{
            row: [0, data[0][0].mc.rs - 1],
            column: [0, data[0][0].mc.cs - 1]
          }];
        } else {
          draftCtx.luckysheet_select_save = [{
            row: [0, 0],
            column: [0, 0]
          }];
        }
      }
      draftCtx.config = lodash_default().isNil(sheet.config) ? {} : sheet.config;
      draftCtx.insertedImgs = sheet.images;
      draftCtx.currency = mergedSettings.currency || "¥";
      draftCtx.zoomRatio = lodash_default().isNil(sheet.zoomRatio) ? 1 : sheet.zoomRatio;
      draftCtx.rowHeaderWidth = mergedSettings.rowHeaderWidth * draftCtx.zoomRatio;
      draftCtx.columnHeaderHeight = mergedSettings.columnHeaderHeight * draftCtx.zoomRatio;
      if (!lodash_default().isNil(sheet.defaultRowHeight)) {
        draftCtx.defaultrowlen = Number(sheet.defaultRowHeight);
      } else {
        draftCtx.defaultrowlen = mergedSettings.defaultRowHeight;
      }
      if (!lodash_default().isNil(sheet.addRows)) {
        draftCtx.addDefaultRows = Number(sheet.addRows);
      } else {
        draftCtx.addDefaultRows = mergedSettings.addRows;
      }
      if (!lodash_default().isNil(sheet.defaultColWidth)) {
        draftCtx.defaultcollen = Number(sheet.defaultColWidth);
      } else {
        draftCtx.defaultcollen = mergedSettings.defaultColWidth;
      }
      if (!lodash_default().isNil(sheet.showGridLines)) {
        var showGridLines = sheet.showGridLines;
        if (showGridLines === 0 || showGridLines === false) {
          draftCtx.showGridLines = false;
        } else {
          draftCtx.showGridLines = true;
        }
      } else {
        draftCtx.showGridLines = true;
      }
      if (lodash_default().isNil(mergedSettings.lang)) {
        var lang = navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage;
        draftCtx.lang = lang;
      }
    }, {
      noHistory: true
    });
  }, [context.currentSheetId, context.luckysheetfile.length, originalData, mergedSettings.defaultRowHeight, mergedSettings.defaultColWidth, mergedSettings.column, mergedSettings.row, mergedSettings.defaultFontSize, mergedSettings.devicePixelRatio, mergedSettings.lang, mergedSettings.allowEdit, mergedSettings.hooks, mergedSettings.generateSheetId, setContextWithProduce, initSheetData, mergedSettings.rowHeaderWidth, mergedSettings.columnHeaderHeight, mergedSettings.addRows, mergedSettings.currency]);
  var onKeyDown = (0,react.useCallback)(function (e) {
    var nativeEvent = e.nativeEvent;
    if ((e.ctrlKey || e.metaKey) && e.code === "KeyZ") {
      if (e.shiftKey) {
        handleRedo();
      } else {
        handleUndo();
      }
      e.stopPropagation();
      return;
    }
    if ((e.ctrlKey || e.metaKey) && e.code === "KeyY") {
      handleRedo();
      e.stopPropagation();
      e.preventDefault();
      return;
    }
    setContextWithProduce(function (draftCtx) {
      handleGlobalKeyDown(draftCtx, cellInput.current, fxInput.current, nativeEvent, globalCache.current, handleUndo, handleRedo, canvas.current.getContext("2d"));
    });
  }, [handleRedo, handleUndo, setContextWithProduce]);
  var onPaste = (0,react.useCallback)(function (e) {
    var _document$activeEleme;
    if (cellInput.current === document.activeElement || ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.className) === "fortune-sheet-overlay") {
      var clipboardData = e.clipboardData;
      if (!clipboardData) {
        clipboardData = window.clipboardData;
      }
      var txtdata = clipboardData.getData("text/html") || clipboardData.getData("text/plain");
      var ele = document.createElement("div");
      ele.innerHTML = txtdata;
      var trList = ele.querySelectorAll("table tr");
      var maxRow = trList.length + context.luckysheet_select_save[0].row[0];
      var rowToBeAdded = maxRow - context.luckysheetfile[getSheetIndex(context, context.currentSheetId)].data.length;
      var range = context.luckysheet_select_save;
      if (rowToBeAdded > 0) {
        var insertRowColOp = {
          type: "row",
          index: context.luckysheetfile[getSheetIndex(context, context.currentSheetId)].data.length - 1,
          count: rowToBeAdded,
          direction: "rightbottom",
          id: context.currentSheetId
        };
        setContextWithProduce(function (draftCtx) {
          insertRowCol(draftCtx, insertRowColOp);
          draftCtx.luckysheet_select_save = range;
        }, {
          insertRowColOp: insertRowColOp
        });
      }
      setContextWithProduce(function (draftCtx) {
        try {
          handlePaste(draftCtx, e);
        } catch (err) {
          console.error(err);
        }
      });
    }
  }, [context, setContextWithProduce]);
  var onMoreToolbarItemsClose = (0,react.useCallback)(function () {
    setMoreToolbarItems(null);
  }, []);
  (0,react.useEffect)(function () {
    document.addEventListener("paste", onPaste);
    return function () {
      document.removeEventListener("paste", onPaste);
    };
  }, [onPaste]);
  (0,react.useImperativeHandle)(ref, function () {
    return generateAPIs(context, setContextWithProduce, handleUndo, handleRedo, mergedSettings, cellInput.current, scrollbarX.current, scrollbarY.current);
  }, [context, setContextWithProduce, handleUndo, handleRedo, mergedSettings]);
  var i = getSheetIndex(context, context.currentSheetId);
  if (i == null) {
    return null;
  }
  var sheet = (_context$luckysheetfi = context.luckysheetfile) === null || _context$luckysheetfi === void 0 ? void 0 : _context$luckysheetfi[i];
  if (!sheet) {
    return null;
  }
  return /*#__PURE__*/react.createElement(WorkbookContext.Provider, {
    value: providerValue
  }, /*#__PURE__*/react.createElement(ModalProvider, null, /*#__PURE__*/react.createElement("div", {
    className: "fortune-container",
    ref: workbookContainer,
    onKeyDown: onKeyDown
  }, /*#__PURE__*/react.createElement(SVGDefines, {
    currency: mergedSettings.currency
  }), /*#__PURE__*/react.createElement("div", {
    className: "fortune-workarea"
  }, mergedSettings.showToolbar && /*#__PURE__*/react.createElement(Toolbar, {
    moreItemsOpen: moreToolbarItems !== null,
    setMoreItems: setMoreToolbarItems
  }), mergedSettings.showFormulaBar && /*#__PURE__*/react.createElement(FxEditor, null)), /*#__PURE__*/react.createElement(Sheet, {
    sheet: sheet
  }), mergedSettings.showSheetTabs && /*#__PURE__*/react.createElement(SheetTab, null), /*#__PURE__*/react.createElement(ContextMenu, null), /*#__PURE__*/react.createElement(FilterMenu, null), /*#__PURE__*/react.createElement(SheetTabContextMenu, null), context.showSheetList && /*#__PURE__*/react.createElement(SheetList, null), moreToolbarItems && /*#__PURE__*/react.createElement(MoreItemsContaier, {
    onClose: onMoreToolbarItemsClose
  }, moreToolbarItems), !lodash_default().isEmpty(context.contextMenu) && /*#__PURE__*/react.createElement("div", {
    onMouseDown: function onMouseDown() {
      setContextWithProduce(function (draftCtx) {
        draftCtx.contextMenu = {};
        draftCtx.filterContextMenu = undefined;
        draftCtx.showSheetList = undefined;
      });
    },
    onMouseMove: function onMouseMove(e) {
      return e.stopPropagation();
    },
    onMouseUp: function onMouseUp(e) {
      return e.stopPropagation();
    },
    onContextMenu: function onContextMenu(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    className: "fortune-popover-backdrop"
  }), /*#__PURE__*/react.createElement("div", {
    className: "fortune-stat-area"
  }, /*#__PURE__*/react.createElement("div", {
    className: "luckysheet-sheet-selection-calInfo"
  }, !!calInfo.count && /*#__PURE__*/react.createElement("div", {
    style: {
      width: "60px"
    }
  }, formula.count, ": ", calInfo.count), !!calInfo.numberC && !!calInfo.sum && /*#__PURE__*/react.createElement("div", null, formula.sum, ": ", calInfo.sum), !!calInfo.numberC && !!calInfo.average && /*#__PURE__*/react.createElement("div", null, formula.average, ": ", calInfo.average), !!calInfo.numberC && !!calInfo.max && /*#__PURE__*/react.createElement("div", null, formula.max, ": ", calInfo.max), !!calInfo.numberC && !!calInfo.min && /*#__PURE__*/react.createElement("div", null, formula.min, ": ", calInfo.min))))));
});


/***/ }),

/***/ 66031:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.highlightRange = exports.createWrapper = exports.removeHighlights = exports.serializeHighlights = exports.deserializeHighlights = exports.doHighlight = exports.getHighlights = exports.find = exports.normalizeHighlights = exports.mergeSiblingHighlights = exports.flattenNestedHighlights = void 0;
// TextHighLighterv2 library
// Port by: lastlink <https://github.com/lastlink/>
var types_1 = __webpack_require__(97063);
var Utils_1 = __webpack_require__(86228);
/**
 * Creates wrapper for highlights.
 * TextHighlighter instance calls this method each time it needs to create highlights and pass options retrieved
 * in constructor.
 * @param {object} options - the same object as in TextHighlighter constructor.
 * @returns {HTMLElement}
 * @memberof TextHighlighter
 * @static
 */
function createWrapper(options) {
  var span = document.createElement("span");
  if (options.color) {
    span.style.backgroundColor = options.color;
    span.setAttribute("data-backgroundcolor", options.color);
  }
  if (options.highlightedClass) span.className = options.highlightedClass;
  return span;
}
exports.createWrapper = createWrapper;
/**
 * Highlights range.
 * Wraps text of given range object in wrapper element.
 * @param {Range} range
 * @param {HTMLElement} wrapper
 * @returns {Array} - array of created highlights.
 * @memberof TextHighlighter
 */
var highlightRange = function (el, range, wrapper) {
  if (!range || range.collapsed) {
    return [];
  }
  var result = Utils_1.refineRangeBoundaries(range);
  var startContainer = result.startContainer,
    endContainer = result.endContainer,
    highlights = [];
  var goDeeper = result.goDeeper,
    done = false,
    node = startContainer,
    highlight,
    wrapperClone,
    nodeParent;
  do {
    if (node && goDeeper && node.nodeType === Utils_1.NODE_TYPE.TEXT_NODE) {
      if (node.parentNode instanceof HTMLElement && node.parentNode.tagName && node.nodeValue && Utils_1.IGNORE_TAGS.indexOf(node.parentNode.tagName) === -1 && node.nodeValue.trim() !== "") {
        wrapperClone = wrapper.cloneNode(true);
        wrapperClone.setAttribute(Utils_1.DATA_ATTR, true);
        nodeParent = node.parentNode;
        // highlight if a node is inside the el
        if (Utils_1.dom(el).contains(nodeParent) || nodeParent === el) {
          highlight = Utils_1.dom(node).wrap(wrapperClone);
          highlights.push(highlight);
        }
      }
      goDeeper = false;
    }
    if (node === endContainer && endContainer && !(endContainer.hasChildNodes() && goDeeper)) {
      done = true;
    }
    if (node instanceof HTMLElement && node.tagName && Utils_1.IGNORE_TAGS.indexOf(node.tagName) > -1) {
      if (endContainer instanceof HTMLElement && endContainer.parentNode === node) {
        done = true;
      }
      goDeeper = false;
    }
    if (goDeeper && (node instanceof Text || node instanceof HTMLElement) && node.hasChildNodes()) {
      node = node.firstChild;
    } else if (node && node.nextSibling) {
      node = node.nextSibling;
      goDeeper = true;
    } else if (node) {
      node = node.parentNode;
      goDeeper = false;
    }
  } while (!done);
  return highlights;
};
exports.highlightRange = highlightRange;
// : {
//     nodeType: number;
//     hasAttribute: (arg0: string) => any;
// }
/**
 * Returns true if element is a highlight.
 * All highlights have 'data-highlighted' attribute.
 * @param el - element to check.
 * @returns {boolean}
 * @memberof TextHighlighter
 */
var isHighlight = function (el) {
  return el && el.nodeType === Utils_1.NODE_TYPE.ELEMENT_NODE && el.hasAttribute(Utils_1.DATA_ATTR);
};
/**
 * Flattens highlights structure.
 * Note: this method changes input highlights - their order and number after calling this method may change.
 * @param {Array} highlights - highlights to flatten.
 * @memberof TextHighlighter
 */
var flattenNestedHighlights = function (highlights) {
  var again;
  // self = this;
  Utils_1.sortByDepth(highlights, true);
  var flattenOnce = function () {
    var again = false;
    highlights.forEach(function (hl, i) {
      var parent = hl.parentElement;
      if (parent) {
        var parentPrev = parent.previousSibling,
          parentNext = parent.nextSibling;
        if (isHighlight(parent)) {
          if (!Utils_1.haveSameColor(parent, hl)) {
            if (!hl.nextSibling && parentNext) {
              var newLocal = parentNext || parent;
              if (newLocal) {
                Utils_1.dom(hl).insertBefore(newLocal);
                again = true;
              }
            }
            if (!hl.previousSibling && parentPrev) {
              var newLocal = parentPrev || parent;
              if (newLocal) {
                Utils_1.dom(hl).insertAfter(newLocal);
                again = true;
              }
            }
            if (!parent.hasChildNodes()) {
              Utils_1.dom(parent).remove();
            }
          } else {
            if (hl && hl.firstChild) parent.replaceChild(hl.firstChild, hl);
            highlights[i] = parent;
            again = true;
          }
        }
      }
    });
    return again;
  };
  do {
    again = flattenOnce();
  } while (again);
};
exports.flattenNestedHighlights = flattenNestedHighlights;
/**
 * Merges sibling highlights and normalizes descendant text nodes.
 * Note: this method changes input highlights - their order and number after calling this method may change.
 * @param highlights
 * @memberof TextHighlighter
 */
var mergeSiblingHighlights = function (highlights) {
  //   const self = this;
  var shouldMerge = function (current, node) {
    return node && node.nodeType === Utils_1.NODE_TYPE.ELEMENT_NODE && Utils_1.haveSameColor(current, node) && isHighlight(node);
  };
  //   : {
  //     previousSibling: any;
  //     nextSibling: any;
  //   }
  highlights.forEach(function (highlight) {
    var prev = highlight.previousSibling,
      next = highlight.nextSibling;
    if (shouldMerge(highlight, prev)) {
      Utils_1.dom(highlight).prepend(prev.childNodes);
      Utils_1.dom(prev).remove();
    }
    if (shouldMerge(highlight, next)) {
      Utils_1.dom(highlight).append(next.childNodes);
      Utils_1.dom(next).remove();
    }
    Utils_1.dom(highlight).normalizeTextNodes();
  });
};
exports.mergeSiblingHighlights = mergeSiblingHighlights;
/**
 * Normalizes highlights. Ensures that highlighting is done with use of the smallest possible number of
 * wrapping HTML elements.
 * Flattens highlights structure and merges sibling highlights. Normalizes text nodes within highlights.
 * @param {Array} highlights - highlights to normalize.
 * @returns {Array} - array of normalized highlights. Order and number of returned highlights may be different than
 * input highlights.
 * @memberof TextHighlighter
 */
var normalizeHighlights = function (highlights) {
  var normalizedHighlights;
  exports.flattenNestedHighlights(highlights);
  exports.mergeSiblingHighlights(highlights);
  // omit removed nodes
  normalizedHighlights = highlights.filter(function (hl) {
    return hl.parentElement ? hl : null;
  });
  normalizedHighlights = Utils_1.unique(normalizedHighlights);
  normalizedHighlights.sort(function (a, b) {
    return a.offsetTop - b.offsetTop || a.offsetLeft - b.offsetLeft;
  });
  return normalizedHighlights;
};
exports.normalizeHighlights = normalizeHighlights;
/**
 * highlight selected element
 * @param el
 * @param options
 * @param keepRange
 */
var doHighlight = function (el, keepRange, options) {
  var range = Utils_1.dom(el).getRange();
  var wrapper, createdHighlights, normalizedHighlights, timestamp;
  if (!options) options = new types_1.optionsImpl();
  options = Utils_1.defaults(options, {
    color: "#ffff7b",
    highlightedClass: "highlighted",
    contextClass: "highlighter-context",
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onRemoveHighlight: function () {
      var e = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        e[_i] = arguments[_i];
      }
      return true;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onBeforeHighlight: function () {
      var e = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        e[_i] = arguments[_i];
      }
      return true;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onAfterHighlight: function () {
      var e = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        e[_i] = arguments[_i];
      }
      return true;
    }
  });
  if (!range || range.collapsed) {
    return false;
  }
  var highlightMade = false;
  if (options.onBeforeHighlight && options.onBeforeHighlight(range) === true) {
    timestamp = (+new Date()).toString();
    wrapper = createWrapper(options);
    wrapper.setAttribute(Utils_1.TIMESTAMP_ATTR, timestamp);
    createdHighlights = highlightRange(el, range, wrapper);
    if (createdHighlights.length > 0) highlightMade = true;
    normalizedHighlights = exports.normalizeHighlights(createdHighlights);
    if (options.onAfterHighlight) options.onAfterHighlight(range, normalizedHighlights, timestamp);
  }
  if (!keepRange) {
    Utils_1.dom(el).removeAllRanges();
  }
  return highlightMade;
};
exports.doHighlight = doHighlight;
/**
 * Deserializes highlights.
 * @throws exception when can't parse JSON or JSON has invalid structure.
 * @param {object} json - JSON object with highlights definition.
 * @returns {Array} - array of deserialized highlights.
 * @memberof TextHighlighter
 */
var deserializeHighlights = function (el, json) {
  var hlDescriptors;
  var highlights = [];
  //    const self = this;
  if (!json) {
    return highlights;
  }
  try {
    // const r = String.raw`${json}`;
    hlDescriptors = JSON.parse(json);
  } catch (e) {
    throw "Can't parse JSON: " + e;
  }
  function deserializationFn(hlDescriptor) {
    var hl = hlDescriptor;
    hl.hlpaths = hl.path.split(":").map(Number);
    if (!hl.hlpaths || hl.hlpaths.length == 0) return;
    //  {
    //   wrapper: hlDescriptor[0],
    //   text: hlDescriptor[1],
    //   path: hlDescriptor[2].split(":"),
    //   offset: hlDescriptor[3],
    //   length: hlDescriptor[4]
    // };
    var elIndex = hl.hlpaths.pop(),
      node = el,
      highlight,
      idx;
    // should have a value and not be 0 (false is = to 0)
    if (elIndex != 0 && !elIndex) return;
    while (hl.hlpaths.length > 0) {
      idx = hl.hlpaths.shift();
      if (idx || idx == 0) node = node.childNodes[idx];
    }
    if (node.childNodes[elIndex - 1] && node.childNodes[elIndex - 1].nodeType === Utils_1.NODE_TYPE.TEXT_NODE) {
      elIndex -= 1;
    }
    node = node.childNodes[elIndex];
    if (node instanceof Text) {
      var hlNode = node.splitText(hl.offset);
      hlNode.splitText(hl.length);
      if (hlNode.nextSibling && !hlNode.nextSibling.nodeValue) {
        Utils_1.dom(hlNode.nextSibling).remove();
      }
      if (hlNode.previousSibling && !hlNode.previousSibling.nodeValue) {
        Utils_1.dom(hlNode.previousSibling).remove();
      }
      if (hl && hl.wrapper) {
        var tmpHtml = Utils_1.dom(hlNode).fromHTML(hl.wrapper)[0];
        if (tmpHtml) {
          highlight = Utils_1.dom(hlNode).wrap(tmpHtml);
          highlights.push(highlight);
        }
      }
    }
  }
  hlDescriptors.forEach(function (hlDescriptor) {
    try {
      deserializationFn(hlDescriptor);
    } catch (e) {
      if (console && console.warn) {
        console.warn("Can't deserialize highlight descriptor. Cause: " + e);
      }
    }
  });
  return highlights;
};
exports.deserializeHighlights = deserializeHighlights;
var find = function (el, text, caseSensitive, options) {
  var wnd = Utils_1.dom(el).getWindow();
  if (wnd) {
    var scrollX_1 = wnd.scrollX,
      scrollY_1 = wnd.scrollY,
      caseSens = typeof caseSensitive === "undefined" ? true : caseSensitive;
    // dom(el).removeAllRanges();
    // const test = wnd.innerh
    if ("find" in wnd) {
      while (wnd.find(text, caseSens)) {
        doHighlight(el, true, options);
      }
    } else if (wnd.document.body.createTextRange) {
      var textRange = wnd.document.body.createTextRange();
      textRange.moveToElementText(el);
      while (textRange.findText(text, 1, caseSens ? 4 : 0)) {
        if (!Utils_1.dom(el).contains(textRange.parentElement()) && textRange.parentElement() !== el) {
          break;
        }
        textRange.select();
        doHighlight(el, true, options);
        textRange.collapse(false);
      }
    }
    Utils_1.dom(el).removeAllRanges();
    wnd.scrollTo(scrollX_1, scrollY_1);
  }
};
exports.find = find;
/**
 * Returns highlights from given container.
 * @param params
 * @param {HTMLElement} [params.container] - return highlights from this element. Default: the element the
 * highlighter is applied to.
 * @param {boolean} [params.andSelf] - if set to true and container is a highlight itself, add container to
 * returned results. Default: true.
 * @param {boolean} [params.grouped] - if set to true, highlights are grouped in logical groups of highlights added
 * in the same moment. Each group is an object which has got array of highlights, 'toString' method and 'timestamp'
 * property. Default: false.
 * @returns {Array} - array of highlights.
 * @memberof TextHighlighter
 */
var getHighlights = function (el, params) {
  if (!params) params = new types_1.paramsImp();
  params = Utils_1.defaults(params, {
    container: el,
    andSelf: true,
    grouped: false
  });
  if (params.container) {
    var nodeList = params.container.querySelectorAll("[" + Utils_1.DATA_ATTR + "]");
    var highlights = Array.prototype.slice.call(nodeList);
    if (params.andSelf === true && params.container.hasAttribute(Utils_1.DATA_ATTR)) {
      highlights.push(params.container);
    }
    if (params.grouped) {
      highlights = Utils_1.groupHighlights(highlights);
    }
    return highlights;
  }
};
exports.getHighlights = getHighlights;
/**
 * Serializes all highlights in the element the highlighter is applied to.
 * @returns {string} - stringified JSON with highlights definition
 * @memberof TextHighlighter
 */
var serializeHighlights = function (el) {
  if (!el) return;
  var highlights = exports.getHighlights(el),
    refEl = el,
    hlDescriptors = [];
  if (!highlights) return;
  function getElementPath(el, refElement) {
    var path = [];
    var childNodes;
    if (el) do {
      if (el instanceof HTMLElement && el.parentNode) {
        childNodes = Array.prototype.slice.call(el.parentNode.childNodes);
        path.unshift(childNodes.indexOf(el));
        el = el.parentNode;
      }
    } while (el !== refElement || !el);
    return path;
  }
  Utils_1.sortByDepth(highlights, false);
  //   {
  //     textContent: string | any[];
  //     cloneNode: (arg0: boolean) => any;
  //     previousSibling: { nodeType: number; length: number };
  //   }
  highlights.forEach(function (highlight) {
    if (highlight && highlight.textContent) {
      var offset = 0,
        // Hl offset from previous sibling within parent node.
        wrapper = highlight.cloneNode(true);
      var length_1 = highlight.textContent.length,
        hlPath = getElementPath(highlight, refEl);
      var color = "";
      if (wrapper instanceof HTMLElement) {
        var c = wrapper.getAttribute("data-backgroundcolor");
        if (c) color = c.trim();
        wrapper.innerHTML = "";
        wrapper = wrapper.outerHTML;
      }
      if (highlight.previousSibling && highlight.previousSibling.nodeType === Utils_1.NODE_TYPE.TEXT_NODE && highlight.previousSibling instanceof Text) {
        offset = highlight.previousSibling.length;
      }
      var hl = {
        wrapper: wrapper,
        textContent: highlight.textContent,
        path: hlPath.join(":"),
        color: color,
        offset: offset,
        length: length_1
      };
      hlDescriptors.push(hl);
    }
  });
  return JSON.stringify(hlDescriptors);
};
exports.serializeHighlights = serializeHighlights;
var removeHighlights = function (element, options) {
  var container = element,
    highlights = exports.getHighlights(element, {
      container: container
    });
  // self = this;
  if (!highlights) return;
  if (!options) options = new types_1.optionsImpl();
  options = Utils_1.defaults(options, {
    color: "#ffff7b",
    highlightedClass: "highlighted",
    contextClass: "highlighter-context",
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onRemoveHighlight: function () {
      var e = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        e[_i] = arguments[_i];
      }
      return true;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onBeforeHighlight: function () {
      var e = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        e[_i] = arguments[_i];
      }
      return true;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onAfterHighlight: function () {
      var e = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        e[_i] = arguments[_i];
      }
      return true;
    }
  });
  function mergeSiblingTextNodes(textNode) {
    var prev = textNode.previousSibling,
      next = textNode.nextSibling;
    if (prev && prev.nodeType === Utils_1.NODE_TYPE.TEXT_NODE) {
      textNode.nodeValue = prev.nodeValue + textNode.nodeValue;
      Utils_1.dom(prev).remove();
    }
    if (next && next.nodeType === Utils_1.NODE_TYPE.TEXT_NODE) {
      textNode.nodeValue = textNode.nodeValue + next.nodeValue;
      Utils_1.dom(next).remove();
    }
  }
  function removeHighlight(highlight) {
    if (!highlight) return;
    var textNodes = Utils_1.dom(highlight).unwrap();
    if (textNodes) textNodes.forEach(function (node) {
      mergeSiblingTextNodes(node);
    });
  }
  Utils_1.sortByDepth(highlights, true);
  highlights.forEach(function (hl) {
    if (options && options.onRemoveHighlight && options.onRemoveHighlight(hl) === true) {
      removeHighlight(hl);
    }
  });
};
exports.removeHighlights = removeHighlights;

/***/ }),

/***/ 89875:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TextHighlighter = void 0;
var Library_1 = __webpack_require__(66031);
var Utils_1 = __webpack_require__(86228);
var TextHighlighter = function (element, options) {
  if (!element) {
    throw "Missing anchor element";
  }
  this.el = element;
  this.options = Utils_1.defaults(options, {
    color: "#ffff7b",
    highlightedClass: "highlighted",
    contextClass: "highlighter-context",
    onRemoveHighlight: function () {
      return true;
    },
    onBeforeHighlight: function () {
      return true;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onAfterHighlight: function () {
      var e = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        e[_i] = arguments[_i];
      }
      return true;
    }
  });
  if (this.options && this.options.contextClass) Utils_1.dom(this.el).addClass(this.options.contextClass);
  Utils_1.bindEvents(this.el, this);
  return this;
};
exports.TextHighlighter = TextHighlighter;
/**
 * Permanently disables highlighting.
 * Unbinds events and remove context element class.
 * @memberof TextHighlighter
 */
TextHighlighter.prototype.destroy = function () {
  Utils_1.unbindEvents(this.el, this);
  Utils_1.dom(this.el).removeClass(this.options.contextClass);
};
TextHighlighter.prototype.highlightHandler = function () {
  this.doHighlight();
};
TextHighlighter.prototype.doHighlight = function (keepRange) {
  Library_1.doHighlight(this.el, keepRange, this.options);
};
TextHighlighter.prototype.highlightRange = function (range, wrapper) {
  Library_1.highlightRange(this.el, range, wrapper);
};
TextHighlighter.prototype.normalizeHighlights = function (highlights) {
  Library_1.normalizeHighlights(highlights);
};
TextHighlighter.prototype.flattenNestedHighlights = function (highlights) {
  Library_1.flattenNestedHighlights(highlights);
};
TextHighlighter.prototype.mergeSiblingHighlights = function (highlights) {
  Library_1.mergeSiblingHighlights(highlights);
};
TextHighlighter.prototype.setColor = function (color) {
  this.options.color = color;
};
TextHighlighter.prototype.getColor = function () {
  return this.options.color;
};
TextHighlighter.prototype.removeHighlights = function (element) {
  var container = element || this.el;
  Library_1.removeHighlights(container, this.options);
};
TextHighlighter.prototype.getHighlights = function (params) {
  Library_1.getHighlights(this.el, params);
};
TextHighlighter.prototype.isHighlight = function (el) {
  return el && el.nodeType === Utils_1.NODE_TYPE.ELEMENT_NODE && el.hasAttribute(Utils_1.DATA_ATTR);
};
TextHighlighter.prototype.serializeHighlights = function () {
  return Library_1.serializeHighlights(this.el);
};
TextHighlighter.prototype.deserializeHighlights = function (json) {
  Library_1.deserializeHighlights(this.el, json);
};
TextHighlighter.prototype.find = function (text, caseSensitive) {
  Library_1.find(this.el, text, caseSensitive);
};
TextHighlighter.createWrapper = function (options) {
  Library_1.createWrapper(options);
};

/***/ }),

/***/ 86228:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


// highlight extensions
// eslint-disable-next-line @typescript-eslint/class-name-casing,@typescript-eslint/camelcase
// type H_HTMLElement = HTMLElement;
// eslint-disable-next-line @typescript-eslint/class-name-casing,@typescript-eslint/camelcase
// interface ie_HTMLElement extends HTMLElement {
//   createTextRange(): TextRange;
// }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.activator = exports.groupHighlights = exports.defaults = exports.haveSameColor = exports.unique = exports.sortByDepth = exports.refineRangeBoundaries = exports.dom = exports.IGNORE_TAGS = exports.NODE_TYPE = exports.TIMESTAMP_ATTR = exports.DATA_ATTR = exports.unbindEvents = exports.bindEvents = void 0;
// eslint-disable-next-line @typescript-eslint/class-name-casing
// interface H_Node extends Node {
//   splitText(endOffset: number): any;
// }
// eslint-disable-next-line @typescript-eslint/class-name-casing,@typescript-eslint/camelcase
// interface H_Window extends Window {
//   find(text: any, caseSens: any): boolean;
// }
var
  /**
  * Attribute added by default to every highlight.
  * @type {string}
  */
  DATA_ATTR = "data-highlighted",
  /**
   * Attribute used to group highlight wrappers.
   * @type {string}
   */
  TIMESTAMP_ATTR = "data-timestamp",
  NODE_TYPE = {
    ELEMENT_NODE: 1,
    TEXT_NODE: 3
  },
  /**
   * Don't highlight content of these tags.
   * @type {string[]}
   */
  IGNORE_TAGS = ["SCRIPT", "STYLE", "SELECT", "OPTION", "BUTTON", "OBJECT", "APPLET", "VIDEO", "AUDIO", "CANVAS", "EMBED", "PARAM", "METER", "PROGRESS"];
exports.DATA_ATTR = DATA_ATTR;
exports.TIMESTAMP_ATTR = TIMESTAMP_ATTR;
exports.NODE_TYPE = NODE_TYPE;
exports.IGNORE_TAGS = IGNORE_TAGS;
function activator(type) {
  return new type();
}
exports.activator = activator;
/**
 * Groups given highlights by timestamp.
 * @param {Array} highlights
 * @returns {Array} Grouped highlights.
 */
function groupHighlights(highlights) {
  var order = [],
    chunks = {},
    grouped = [];
  highlights.forEach(function (hl) {
    var timestamp = hl.getAttribute(TIMESTAMP_ATTR);
    if (typeof chunks[timestamp] === "undefined") {
      chunks[timestamp] = [];
      order.push(timestamp);
    }
    chunks[timestamp].push(hl);
  });
  order.forEach(function (timestamp) {
    var group = chunks[timestamp];
    grouped.push({
      chunks: group,
      timestamp: timestamp,
      toString: function () {
        return group.map(function (h) {
          return h.textContent;
        }).join("");
      }
    });
  });
  return grouped;
}
exports.groupHighlights = groupHighlights;
/**
 * Fills undefined values in obj with default properties with the same name from source object.
 * @param {object} obj - target object, can't be null, must be initialized first
 * @param {object} source - source object with default values
 * @returns {object}
 */
function defaults(obj, source) {
  if (obj == null) obj = {};
  for (var prop in source) {
    if (Object.prototype.hasOwnProperty.call(source, prop) && obj[prop] === void 0) {
      obj[prop] = source[prop];
    }
  }
  return obj;
}
exports.defaults = defaults;
/**
 * Returns array without duplicated values.
 * @param {Array} arr
 * @returns {Array}
 */
function unique(arr) {
  return arr.filter(function (value, idx, self) {
    return self.indexOf(value) === idx;
  });
}
exports.unique = unique;
/**
 * Takes range object as parameter and refines it boundaries
 * @param range
 * @returns {object} refined boundaries and initial state of highlighting algorithm.
 */
function refineRangeBoundaries(range) {
  var startContainer = range.startContainer,
    endContainer = range.endContainer,
    goDeeper = true;
  var ancestor = range.commonAncestorContainer;
  if (range.endOffset === 0) {
    while (endContainer && !endContainer.previousSibling && endContainer.parentNode !== ancestor) {
      endContainer = endContainer.parentNode;
    }
    if (endContainer) endContainer = endContainer.previousSibling;
  } else if (endContainer.nodeType === NODE_TYPE.TEXT_NODE) {
    if (endContainer && endContainer.nodeValue && range.endOffset < endContainer.nodeValue.length) {
      var t = endContainer;
      t.splitText(range.endOffset);
    }
  } else if (range.endOffset > 0) {
    endContainer = endContainer.childNodes.item(range.endOffset - 1);
  }
  if (startContainer.nodeType === NODE_TYPE.TEXT_NODE) {
    if (startContainer && startContainer.nodeValue && range.startOffset === startContainer.nodeValue.length) {
      goDeeper = false;
    } else if (startContainer instanceof Node && range.startOffset > 0) {
      var t = startContainer;
      startContainer = t.splitText(range.startOffset);
      if (startContainer && endContainer === startContainer.previousSibling) {
        endContainer = startContainer;
      }
    }
  } else if (range.startOffset < startContainer.childNodes.length) {
    startContainer = startContainer.childNodes.item(range.startOffset);
  } else {
    startContainer = startContainer.nextSibling;
  }
  return {
    startContainer: startContainer,
    endContainer: endContainer,
    goDeeper: goDeeper
  };
}
exports.refineRangeBoundaries = refineRangeBoundaries;
function bindEvents(el, scope) {
  el.addEventListener("mouseup", scope.highlightHandler.bind(scope));
  el.addEventListener("touchend", scope.highlightHandler.bind(scope));
}
exports.bindEvents = bindEvents;
function unbindEvents(el, scope) {
  el.removeEventListener("mouseup", scope.highlightHandler.bind(scope));
  el.removeEventListener("touchend", scope.highlightHandler.bind(scope));
}
exports.unbindEvents = unbindEvents;
/**
 * Utility functions to make DOM manipulation easier.
 * @param {Node|HTMLElement} [el] - base DOM element to manipulate
 * @returns {object}
 */
var dom = function (el) {
  return /** @lends dom **/{
    /**
     * Adds class to element.
     * @param {string} className
     */
    addClass: function (className) {
      if (el instanceof HTMLElement) if (el.classList) {
        el.classList.add(className);
      } else {
        el.className += " " + className;
      }
    },
    /**
     * Removes class from element.
     * @param {string} className
     */
    removeClass: function (className) {
      if (el instanceof HTMLElement) {
        if (el.classList) {
          el.classList.remove(className);
        } else {
          el.className = el.className.replace(new RegExp("(^|\\b)" + className + "(\\b|$)", "gi"), " ");
        }
      }
    },
    /**
     * Prepends child nodes to base element.
     * @param {Node[]} nodesToPrepend
     */
    prepend: function (nodesToPrepend) {
      var nodes = Array.prototype.slice.call(nodesToPrepend);
      var i = nodes.length;
      if (el) while (i--) {
        el.insertBefore(nodes[i], el.firstChild);
      }
    },
    /**
     * Appends child nodes to base element.
     * @param {Node[]} nodesToAppend
     */
    append: function (nodesToAppend) {
      if (el) {
        var nodes = Array.prototype.slice.call(nodesToAppend);
        for (var i = 0, len = nodes.length; i < len; ++i) {
          el.appendChild(nodes[i]);
        }
      }
    },
    /**
     * Inserts base element after refEl.
     * @param {Node} refEl - node after which base element will be inserted
     * @returns {Node} - inserted element
     */
    insertAfter: function (refEl) {
      return refEl.parentNode.insertBefore(el, refEl.nextSibling);
    },
    /**
     * Inserts base element before refEl.
     * @param {Node} refEl - node before which base element will be inserted
     * @returns {Node} - inserted element
     */
    insertBefore: function (refEl) {
      return refEl.parentNode ? refEl.parentNode.insertBefore(el, refEl) : refEl;
    },
    /**
     * Removes base element from DOM.
     */
    remove: function () {
      if (el && el.parentNode) {
        el.parentNode.removeChild(el);
        el = null;
      }
    },
    /**
     * Returns true if base element contains given child.
     * @param {Node|HTMLElement} child
     * @returns {boolean}
     */
    contains: function (child) {
      return el && el !== child && el.contains(child);
    },
    /**
     * Wraps base element in wrapper element.
     * @param {HTMLElement} wrapper
     * @returns {HTMLElement} wrapper element
     */
    wrap: function (wrapper) {
      if (el) {
        if (el.parentNode) {
          el.parentNode.insertBefore(wrapper, el);
        }
        wrapper.appendChild(el);
      }
      return wrapper;
    },
    /**
     * Unwraps base element.
     * @returns {Node[]} - child nodes of unwrapped element.
     */
    unwrap: function () {
      if (el) {
        var nodes = Array.prototype.slice.call(el.childNodes);
        var wrapper_1;
        // debugger;
        nodes.forEach(function (node) {
          wrapper_1 = node.parentNode;
          var d = dom(node);
          if (d && node.parentNode) d.insertBefore(node.parentNode);
          dom(wrapper_1).remove();
        });
        return nodes;
      }
    },
    /**
     * Returns array of base element parents.
     * @returns {HTMLElement[]}
     */
    parents: function () {
      var parent;
      var path = [];
      if (el) {
        while (parent = el.parentNode) {
          path.push(parent);
          el = parent;
        }
      }
      return path;
    },
    /**
     * Normalizes text nodes within base element, ie. merges sibling text nodes and assures that every
     * element node has only one text node.
     * It should does the same as standard element.normalize, but IE implements it incorrectly.
     */
    normalizeTextNodes: function () {
      if (!el) {
        return;
      }
      if (el.nodeType === NODE_TYPE.TEXT_NODE && el.nodeValue && el.parentNode) {
        while (el.nextSibling && el.nextSibling.nodeType === NODE_TYPE.TEXT_NODE) {
          el.nodeValue += el.nextSibling.nodeValue;
          el.parentNode.removeChild(el.nextSibling);
        }
      } else {
        dom(el.firstChild).normalizeTextNodes();
      }
      dom(el.nextSibling).normalizeTextNodes();
    },
    /**
     * Returns element background color.
     * @returns {CSSStyleDeclaration.backgroundColor}
     */
    color: function () {
      return el instanceof HTMLElement && el.style ? el.style.backgroundColor : null;
    },
    /**
     * Creates dom element from given html string.
     * @param {string} html
     * @returns {NodeList}
     */
    fromHTML: function (html) {
      var div = document.createElement("div");
      div.innerHTML = html;
      return div.childNodes;
    },
    /**
     * Returns first range of the window of base element.
     * @returns {Range}
     */
    getRange: function () {
      var selection = dom(el).getSelection();
      var range;
      if (selection && selection.rangeCount > 0) {
        range = selection.getRangeAt(0);
      }
      return range;
    },
    /**
     * Removes all ranges of the window of base element.
     */
    removeAllRanges: function () {
      var selection = dom(el).getSelection();
      if (selection) selection.removeAllRanges();
    },
    /**
     * Returns selection object of the window of base element.
     * @returns {Selection}
     */
    getSelection: function () {
      var win = dom(el).getWindow();
      return win ? win.getSelection() : null;
    },
    /**
     * Returns window of the base element.
     * @returns {Window}
     */
    getWindow: function () {
      var doc = dom(el).getDocument();
      return doc instanceof Document ? doc.defaultView : null;
    },
    /**
     * Returns document of the base element.
     * @returns {HTMLDocument}
     */
    getDocument: function () {
      // if ownerDocument is null then el is the document itself.
      if (el) return el.ownerDocument || el;
    }
  };
};
exports.dom = dom;
/**
 * Returns true if elements a i b have the same color.
 * @param {Node} a
 * @param {Node} b
 * @returns {boolean}
 */
function haveSameColor(a, b) {
  return dom(a).color() === dom(b).color();
}
exports.haveSameColor = haveSameColor;
/**
 * Sorts array of DOM elements by its depth in DOM tree.
 * @param {HTMLElement[]} arr - array to sort.
 * @param {boolean} descending - order of sort.
 */
function sortByDepth(arr, descending) {
  arr.sort(function (a, b) {
    return dom(descending ? b : a).parents().length - dom(descending ? a : b).parents().length;
  });
}
exports.sortByDepth = sortByDepth;

/***/ }),

/***/ 45898:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = exports.Au = exports.IT = exports.pt = exports.Zp = void 0;
var Library_1 = __webpack_require__(66031);
Object.defineProperty(exports, "Zp", ({
  enumerable: true,
  get: function () {
    return Library_1.doHighlight;
  }
}));
Object.defineProperty(exports, "pt", ({
  enumerable: true,
  get: function () {
    return Library_1.deserializeHighlights;
  }
}));
Object.defineProperty(exports, "IT", ({
  enumerable: true,
  get: function () {
    return Library_1.serializeHighlights;
  }
}));
Object.defineProperty(exports, "Au", ({
  enumerable: true,
  get: function () {
    return Library_1.removeHighlights;
  }
}));
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return Library_1.createWrapper;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return Library_1.highlightRange;
  }
});
var TextHighlighter_1 = __webpack_require__(89875);
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return TextHighlighter_1.TextHighlighter;
  }
});
var types_1 = __webpack_require__(97063);
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return types_1.optionsImpl;
  }
});

/***/ }),

/***/ 97063:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.paramsImp = exports.optionsImpl = exports.highlightI = void 0;
// eslint-disable-next-line @typescript-eslint/class-name-casing
var highlightI = /** @class */function () {
  function highlightI() {}
  return highlightI;
}();
exports.highlightI = highlightI;
// eslint-disable-next-line @typescript-eslint/class-name-casing
var optionsImpl = /** @class */function () {
  function optionsImpl() {}
  return optionsImpl;
}();
exports.optionsImpl = optionsImpl;
// class containerI{
//     querySelectorAll: (arg0: string): any;
//     hasAttribute: (arg0: string) => any;
// }
// eslint-disable-next-line @typescript-eslint/class-name-casing
var paramsImp = /** @class */function () {
  function paramsImp() {}
  return paramsImp;
}();
exports.paramsImp = paramsImp;

/***/ }),

/***/ 3434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Il": function() { return /* reexport */ Color; },
  "G5": function() { return /* reexport */ components_ColorBlock; },
  "ZP": function() { return /* binding */ color_picker_es; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6223);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(79427);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(34766);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js
var createSuper = __webpack_require__(56302);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/@ant-design/fast-color/es/index.js + 1 modules
var es = __webpack_require__(99620);
;// CONCATENATED MODULE: ./node_modules/@rc-component/color-picker/es/color.js







var _excluded = ["b"],
  _excluded2 = ["v"];

var getRoundNumber = function getRoundNumber(value) {
  return Math.round(Number(value || 0));
};
var convertHsb2Hsv = function convertHsb2Hsv(color) {
  if (color instanceof es/* FastColor */.t) {
    return color;
  }
  if (color && (0,esm_typeof/* default */.Z)(color) === 'object' && 'h' in color && 'b' in color) {
    var _ref = color,
      b = _ref.b,
      resets = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, resets), {}, {
      v: b
    });
  }
  if (typeof color === 'string' && /hsb/.test(color)) {
    return color.replace(/hsb/, 'hsv');
  }
  return color;
};
var Color = /*#__PURE__*/function (_FastColor) {
  (0,inherits/* default */.Z)(Color, _FastColor);
  var _super = (0,createSuper/* default */.Z)(Color);
  function Color(color) {
    (0,classCallCheck/* default */.Z)(this, Color);
    return _super.call(this, convertHsb2Hsv(color));
  }
  (0,createClass/* default */.Z)(Color, [{
    key: "toHsbString",
    value: function toHsbString() {
      var hsb = this.toHsb();
      var saturation = getRoundNumber(hsb.s * 100);
      var lightness = getRoundNumber(hsb.b * 100);
      var hue = getRoundNumber(hsb.h);
      var alpha = hsb.a;
      var hsbString = "hsb(".concat(hue, ", ").concat(saturation, "%, ").concat(lightness, "%)");
      var hsbaString = "hsba(".concat(hue, ", ").concat(saturation, "%, ").concat(lightness, "%, ").concat(alpha.toFixed(alpha === 0 ? 0 : 2), ")");
      return alpha === 1 ? hsbString : hsbaString;
    }
  }, {
    key: "toHsb",
    value: function toHsb() {
      var _this$toHsv = this.toHsv(),
        v = _this$toHsv.v,
        resets = (0,objectWithoutProperties/* default */.Z)(_this$toHsv, _excluded2);
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, resets), {}, {
        b: v,
        a: this.a
      });
    }
  }]);
  return Color;
}(es/* FastColor */.t);
;// CONCATENATED MODULE: ./node_modules/@rc-component/color-picker/es/util.js


var ColorPickerPrefixCls = 'rc-color-picker';
var generateColor = function generateColor(color) {
  if (color instanceof Color) {
    return color;
  }
  return new Color(color);
};
var defaultColor = generateColor('#1677ff');
var calculateColor = function calculateColor(props) {
  var offset = props.offset,
    targetRef = props.targetRef,
    containerRef = props.containerRef,
    color = props.color,
    type = props.type;
  var _containerRef$current = containerRef.current.getBoundingClientRect(),
    width = _containerRef$current.width,
    height = _containerRef$current.height;
  var _targetRef$current$ge = targetRef.current.getBoundingClientRect(),
    targetWidth = _targetRef$current$ge.width,
    targetHeight = _targetRef$current$ge.height;
  var centerOffsetX = targetWidth / 2;
  var centerOffsetY = targetHeight / 2;
  var saturation = (offset.x + centerOffsetX) / width;
  var bright = 1 - (offset.y + centerOffsetY) / height;
  var hsb = color.toHsb();
  var alphaOffset = saturation;
  var hueOffset = (offset.x + centerOffsetX) / width * 360;
  if (type) {
    switch (type) {
      case 'hue':
        return generateColor((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, hsb), {}, {
          h: hueOffset <= 0 ? 0 : hueOffset
        }));
      case 'alpha':
        return generateColor((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, hsb), {}, {
          a: alphaOffset <= 0 ? 0 : alphaOffset
        }));
    }
  }
  return generateColor({
    h: hsb.h,
    s: saturation <= 0 ? 0 : saturation,
    b: bright >= 1 ? 1 : bright,
    a: hsb.a
  });
};
var calcOffset = function calcOffset(color, type) {
  var hsb = color.toHsb();
  switch (type) {
    case 'hue':
      return {
        x: hsb.h / 360 * 100,
        y: 50
      };
    case 'alpha':
      return {
        x: color.a * 100,
        y: 50
      };

    // Picker panel
    default:
      return {
        x: hsb.s * 100,
        y: (1 - hsb.b) * 100
      };
  }
};
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/@rc-component/color-picker/es/components/ColorBlock.js


var ColorBlock = function ColorBlock(_ref) {
  var color = _ref.color,
    prefixCls = _ref.prefixCls,
    className = _ref.className,
    style = _ref.style,
    onClick = _ref.onClick;
  var colorBlockCls = "".concat(prefixCls, "-color-block");
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(colorBlockCls, className),
    style: style,
    onClick: onClick
  }, /*#__PURE__*/react.createElement("div", {
    className: "".concat(colorBlockCls, "-inner"),
    style: {
      background: color
    }
  }));
};
/* harmony default export */ var components_ColorBlock = (ColorBlock);
;// CONCATENATED MODULE: ./node_modules/@rc-component/color-picker/es/hooks/useColorDrag.js


function getPosition(e) {
  var obj = 'touches' in e ? e.touches[0] : e;
  var scrollXOffset = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset;
  var scrollYOffset = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
  return {
    pageX: obj.pageX - scrollXOffset,
    pageY: obj.pageY - scrollYOffset
  };
}
function useColorDrag(props) {
  var targetRef = props.targetRef,
    containerRef = props.containerRef,
    direction = props.direction,
    onDragChange = props.onDragChange,
    onDragChangeComplete = props.onDragChangeComplete,
    calculate = props.calculate,
    color = props.color,
    disabledDrag = props.disabledDrag;
  var _useState = (0,react.useState)({
      x: 0,
      y: 0
    }),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    offsetValue = _useState2[0],
    setOffsetValue = _useState2[1];
  var mouseMoveRef = (0,react.useRef)(null);
  var mouseUpRef = (0,react.useRef)(null);

  // Always get position from `color`
  (0,react.useEffect)(function () {
    setOffsetValue(calculate());
  }, [color]);
  (0,react.useEffect)(function () {
    return function () {
      document.removeEventListener('mousemove', mouseMoveRef.current);
      document.removeEventListener('mouseup', mouseUpRef.current);
      document.removeEventListener('touchmove', mouseMoveRef.current);
      document.removeEventListener('touchend', mouseUpRef.current);
      mouseMoveRef.current = null;
      mouseUpRef.current = null;
    };
  }, []);
  var updateOffset = function updateOffset(e) {
    var _getPosition = getPosition(e),
      pageX = _getPosition.pageX,
      pageY = _getPosition.pageY;
    var _containerRef$current = containerRef.current.getBoundingClientRect(),
      rectX = _containerRef$current.x,
      rectY = _containerRef$current.y,
      width = _containerRef$current.width,
      height = _containerRef$current.height;
    var _targetRef$current$ge = targetRef.current.getBoundingClientRect(),
      targetWidth = _targetRef$current$ge.width,
      targetHeight = _targetRef$current$ge.height;
    var centerOffsetX = targetWidth / 2;
    var centerOffsetY = targetHeight / 2;
    var offsetX = Math.max(0, Math.min(pageX - rectX, width)) - centerOffsetX;
    var offsetY = Math.max(0, Math.min(pageY - rectY, height)) - centerOffsetY;
    var calcOffset = {
      x: offsetX,
      y: direction === 'x' ? offsetValue.y : offsetY
    };

    // Exclusion of boundary cases
    if (targetWidth === 0 && targetHeight === 0 || targetWidth !== targetHeight) {
      return false;
    }
    onDragChange === null || onDragChange === void 0 || onDragChange(calcOffset);
  };
  var onDragMove = function onDragMove(e) {
    e.preventDefault();
    updateOffset(e);
  };
  var onDragStop = function onDragStop(e) {
    e.preventDefault();
    document.removeEventListener('mousemove', mouseMoveRef.current);
    document.removeEventListener('mouseup', mouseUpRef.current);
    document.removeEventListener('touchmove', mouseMoveRef.current);
    document.removeEventListener('touchend', mouseUpRef.current);
    mouseMoveRef.current = null;
    mouseUpRef.current = null;
    onDragChangeComplete === null || onDragChangeComplete === void 0 || onDragChangeComplete();
  };
  var onDragStart = function onDragStart(e) {
    // https://github.com/ant-design/ant-design/issues/43529
    document.removeEventListener('mousemove', mouseMoveRef.current);
    document.removeEventListener('mouseup', mouseUpRef.current);
    if (disabledDrag) {
      return;
    }
    updateOffset(e);
    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('mouseup', onDragStop);
    document.addEventListener('touchmove', onDragMove);
    document.addEventListener('touchend', onDragStop);
    mouseMoveRef.current = onDragMove;
    mouseUpRef.current = onDragStop;
  };
  return [offsetValue, onDragStart];
}
/* harmony default export */ var hooks_useColorDrag = (useColorDrag);
// EXTERNAL MODULE: ./node_modules/rc-util/es/index.js
var rc_util_es = __webpack_require__(57433);
;// CONCATENATED MODULE: ./node_modules/@rc-component/color-picker/es/components/Handler.js



var Handler = function Handler(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    color = _ref.color,
    prefixCls = _ref.prefixCls;
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(prefixCls, "-handler"), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-handler-sm"), size === 'small')),
    style: {
      backgroundColor: color
    }
  });
};
/* harmony default export */ var components_Handler = (Handler);
;// CONCATENATED MODULE: ./node_modules/@rc-component/color-picker/es/components/Palette.js


var Palette = function Palette(_ref) {
  var children = _ref.children,
    style = _ref.style,
    prefixCls = _ref.prefixCls;
  return /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-palette"),
    style: (0,objectSpread2/* default */.Z)({
      position: 'relative'
    }, style)
  }, children);
};
/* harmony default export */ var components_Palette = (Palette);
;// CONCATENATED MODULE: ./node_modules/@rc-component/color-picker/es/components/Transform.js

var Transform = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var children = props.children,
    x = props.x,
    y = props.y;
  return /*#__PURE__*/react.createElement("div", {
    ref: ref,
    style: {
      position: 'absolute',
      left: "".concat(x, "%"),
      top: "".concat(y, "%"),
      zIndex: 1,
      transform: 'translate(-50%, -50%)'
    }
  }, children);
});
/* harmony default export */ var components_Transform = (Transform);
;// CONCATENATED MODULE: ./node_modules/@rc-component/color-picker/es/components/Picker.js








var Picker = function Picker(_ref) {
  var color = _ref.color,
    onChange = _ref.onChange,
    prefixCls = _ref.prefixCls,
    onChangeComplete = _ref.onChangeComplete,
    disabled = _ref.disabled;
  var pickerRef = (0,react.useRef)();
  var transformRef = (0,react.useRef)();
  var colorRef = (0,react.useRef)(color);
  var onDragChange = (0,rc_util_es/* useEvent */.zX)(function (offsetValue) {
    var calcColor = calculateColor({
      offset: offsetValue,
      targetRef: transformRef,
      containerRef: pickerRef,
      color: color
    });
    colorRef.current = calcColor;
    onChange(calcColor);
  });
  var _useColorDrag = hooks_useColorDrag({
      color: color,
      containerRef: pickerRef,
      targetRef: transformRef,
      calculate: function calculate() {
        return calcOffset(color);
      },
      onDragChange: onDragChange,
      onDragChangeComplete: function onDragChangeComplete() {
        return onChangeComplete === null || onChangeComplete === void 0 ? void 0 : onChangeComplete(colorRef.current);
      },
      disabledDrag: disabled
    }),
    _useColorDrag2 = (0,slicedToArray/* default */.Z)(_useColorDrag, 2),
    offset = _useColorDrag2[0],
    dragStartHandle = _useColorDrag2[1];
  return /*#__PURE__*/react.createElement("div", {
    ref: pickerRef,
    className: "".concat(prefixCls, "-select"),
    onMouseDown: dragStartHandle,
    onTouchStart: dragStartHandle
  }, /*#__PURE__*/react.createElement(components_Palette, {
    prefixCls: prefixCls
  }, /*#__PURE__*/react.createElement(components_Transform, {
    x: offset.x,
    y: offset.y,
    ref: transformRef
  }, /*#__PURE__*/react.createElement(components_Handler, {
    color: color.toRgbString(),
    prefixCls: prefixCls
  })), /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-saturation"),
    style: {
      backgroundColor: "hsl(".concat(color.toHsb().h, ",100%, 50%)"),
      backgroundImage: 'linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))'
    }
  })));
};
/* harmony default export */ var components_Picker = (Picker);
;// CONCATENATED MODULE: ./node_modules/@rc-component/color-picker/es/hooks/useColorState.js




var useColorState = function useColorState(defaultValue, value) {
  var _useMergedState = (0,rc_util_es/* useMergedState */.C8)(defaultValue, {
      value: value
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    mergedValue = _useMergedState2[0],
    setValue = _useMergedState2[1];
  var color = (0,react.useMemo)(function () {
    return generateColor(mergedValue);
  }, [mergedValue]);
  return [color, setValue];
};
/* harmony default export */ var hooks_useColorState = (useColorState);
;// CONCATENATED MODULE: ./node_modules/@rc-component/color-picker/es/components/Gradient.js



var Gradient = function Gradient(_ref) {
  var colors = _ref.colors,
    children = _ref.children,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'to right' : _ref$direction,
    type = _ref.type,
    prefixCls = _ref.prefixCls;
  var gradientColors = (0,react.useMemo)(function () {
    return colors.map(function (color, idx) {
      var result = generateColor(color);
      if (type === 'alpha' && idx === colors.length - 1) {
        result = new Color(result.setA(1));
      }
      return result.toRgbString();
    }).join(',');
  }, [colors, type]);
  return /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-gradient"),
    style: {
      position: 'absolute',
      inset: 0,
      background: "linear-gradient(".concat(direction, ", ").concat(gradientColors, ")")
    }
  }, children);
};
/* harmony default export */ var components_Gradient = (Gradient);
;// CONCATENATED MODULE: ./node_modules/@rc-component/color-picker/es/components/Slider.js











var Slider = function Slider(props) {
  var prefixCls = props.prefixCls,
    colors = props.colors,
    disabled = props.disabled,
    onChange = props.onChange,
    onChangeComplete = props.onChangeComplete,
    color = props.color,
    type = props.type;
  var sliderRef = (0,react.useRef)();
  var transformRef = (0,react.useRef)();
  var colorRef = (0,react.useRef)(color);
  var getValue = function getValue(c) {
    return type === 'hue' ? c.getHue() : c.a * 100;
  };
  var onDragChange = (0,rc_util_es/* useEvent */.zX)(function (offsetValue) {
    var calcColor = calculateColor({
      offset: offsetValue,
      targetRef: transformRef,
      containerRef: sliderRef,
      color: color,
      type: type
    });
    colorRef.current = calcColor;
    onChange(getValue(calcColor));
  });
  var _useColorDrag = hooks_useColorDrag({
      color: color,
      targetRef: transformRef,
      containerRef: sliderRef,
      calculate: function calculate() {
        return calcOffset(color, type);
      },
      onDragChange: onDragChange,
      onDragChangeComplete: function onDragChangeComplete() {
        onChangeComplete(getValue(colorRef.current));
      },
      direction: 'x',
      disabledDrag: disabled
    }),
    _useColorDrag2 = (0,slicedToArray/* default */.Z)(_useColorDrag, 2),
    offset = _useColorDrag2[0],
    dragStartHandle = _useColorDrag2[1];
  var handleColor = react.useMemo(function () {
    if (type === 'hue') {
      var hsb = color.toHsb();
      hsb.s = 1;
      hsb.b = 1;
      hsb.a = 1;
      var lightColor = new Color(hsb);
      return lightColor;
    }
    return color;
  }, [color, type]);

  // ========================= Gradient =========================
  var gradientList = react.useMemo(function () {
    return colors.map(function (info) {
      return "".concat(info.color, " ").concat(info.percent, "%");
    });
  }, [colors]);

  // ========================== Render ==========================
  return /*#__PURE__*/react.createElement("div", {
    ref: sliderRef,
    className: classnames_default()("".concat(prefixCls, "-slider"), "".concat(prefixCls, "-slider-").concat(type)),
    onMouseDown: dragStartHandle,
    onTouchStart: dragStartHandle
  }, /*#__PURE__*/react.createElement(components_Palette, {
    prefixCls: prefixCls
  }, /*#__PURE__*/react.createElement(components_Transform, {
    x: offset.x,
    y: offset.y,
    ref: transformRef
  }, /*#__PURE__*/react.createElement(components_Handler, {
    size: "small",
    color: handleColor.toHexString(),
    prefixCls: prefixCls
  })), /*#__PURE__*/react.createElement(components_Gradient, {
    colors: gradientList,
    type: type,
    prefixCls: prefixCls
  })));
};
/* harmony default export */ var components_Slider = (Slider);
;// CONCATENATED MODULE: ./node_modules/@rc-component/color-picker/es/hooks/useComponent.js


function useComponent(components) {
  return react.useMemo(function () {
    var _ref = components || {},
      slider = _ref.slider;
    return [slider || components_Slider];
  }, [components]);
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/color-picker/es/ColorPicker.js











var HUE_COLORS = [{
  color: 'rgb(255, 0, 0)',
  percent: 0
}, {
  color: 'rgb(255, 255, 0)',
  percent: 17
}, {
  color: 'rgb(0, 255, 0)',
  percent: 33
}, {
  color: 'rgb(0, 255, 255)',
  percent: 50
}, {
  color: 'rgb(0, 0, 255)',
  percent: 67
}, {
  color: 'rgb(255, 0, 255)',
  percent: 83
}, {
  color: 'rgb(255, 0, 0)',
  percent: 100
}];
var ColorPicker = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var value = props.value,
    defaultValue = props.defaultValue,
    _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? ColorPickerPrefixCls : _props$prefixCls,
    onChange = props.onChange,
    onChangeComplete = props.onChangeComplete,
    className = props.className,
    style = props.style,
    panelRender = props.panelRender,
    _props$disabledAlpha = props.disabledAlpha,
    disabledAlpha = _props$disabledAlpha === void 0 ? false : _props$disabledAlpha,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    components = props.components;

  // ========================== Components ==========================
  var _useComponent = useComponent(components),
    _useComponent2 = (0,slicedToArray/* default */.Z)(_useComponent, 1),
    Slider = _useComponent2[0];

  // ============================ Color =============================
  var _useColorState = hooks_useColorState(defaultValue || defaultColor, value),
    _useColorState2 = (0,slicedToArray/* default */.Z)(_useColorState, 2),
    colorValue = _useColorState2[0],
    setColorValue = _useColorState2[1];
  var alphaColor = (0,react.useMemo)(function () {
    return colorValue.setA(1).toRgbString();
  }, [colorValue]);

  // ============================ Events ============================
  var handleChange = function handleChange(data, type) {
    if (!value) {
      setColorValue(data);
    }
    onChange === null || onChange === void 0 || onChange(data, type);
  };

  // Convert
  var getHueColor = function getHueColor(hue) {
    return new Color(colorValue.setHue(hue));
  };
  var getAlphaColor = function getAlphaColor(alpha) {
    return new Color(colorValue.setA(alpha / 100));
  };

  // Slider change
  var onHueChange = function onHueChange(hue) {
    handleChange(getHueColor(hue), {
      type: 'hue',
      value: hue
    });
  };
  var onAlphaChange = function onAlphaChange(alpha) {
    handleChange(getAlphaColor(alpha), {
      type: 'alpha',
      value: alpha
    });
  };

  // Complete
  var onHueChangeComplete = function onHueChangeComplete(hue) {
    if (onChangeComplete) {
      onChangeComplete(getHueColor(hue));
    }
  };
  var onAlphaChangeComplete = function onAlphaChangeComplete(alpha) {
    if (onChangeComplete) {
      onChangeComplete(getAlphaColor(alpha));
    }
  };

  // ============================ Render ============================
  var mergeCls = classnames_default()("".concat(prefixCls, "-panel"), className, (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-panel-disabled"), disabled));
  var sharedSliderProps = {
    prefixCls: prefixCls,
    disabled: disabled,
    color: colorValue
  };
  var defaultPanel = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(components_Picker, (0,esm_extends/* default */.Z)({
    onChange: handleChange
  }, sharedSliderProps, {
    onChangeComplete: onChangeComplete
  })), /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-slider-container")
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(prefixCls, "-slider-group"), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-slider-group-disabled-alpha"), disabledAlpha))
  }, /*#__PURE__*/react.createElement(Slider, (0,esm_extends/* default */.Z)({}, sharedSliderProps, {
    type: "hue",
    colors: HUE_COLORS,
    min: 0,
    max: 359,
    value: colorValue.getHue(),
    onChange: onHueChange,
    onChangeComplete: onHueChangeComplete
  })), !disabledAlpha && /*#__PURE__*/react.createElement(Slider, (0,esm_extends/* default */.Z)({}, sharedSliderProps, {
    type: "alpha",
    colors: [{
      percent: 0,
      color: 'rgba(255, 0, 4, 0)'
    }, {
      percent: 100,
      color: alphaColor
    }],
    min: 0,
    max: 100,
    value: colorValue.a * 100,
    onChange: onAlphaChange,
    onChangeComplete: onAlphaChangeComplete
  }))), /*#__PURE__*/react.createElement(components_ColorBlock, {
    color: colorValue.toRgbString(),
    prefixCls: prefixCls
  })));
  return /*#__PURE__*/react.createElement("div", {
    className: mergeCls,
    style: style,
    ref: ref
  }, typeof panelRender === 'function' ? panelRender(defaultPanel) : defaultPanel);
});
if (false) {}
/* harmony default export */ var es_ColorPicker = (ColorPicker);
;// CONCATENATED MODULE: ./node_modules/@rc-component/color-picker/es/index.js




/* harmony default export */ var color_picker_es = (es_ColorPicker);

/***/ }),

/***/ 90604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es; }
});

// UNUSED EXPORTS: inlineMock

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(85202);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/canUseDom.js
var canUseDom = __webpack_require__(55304);
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(13764);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(99195);
;// CONCATENATED MODULE: ./node_modules/@rc-component/portal/es/Context.js

var OrderContext = /*#__PURE__*/react.createContext(null);
/* harmony default export */ var Context = (OrderContext);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useLayoutEffect.js
var useLayoutEffect = __webpack_require__(76963);
;// CONCATENATED MODULE: ./node_modules/@rc-component/portal/es/useDom.js






var EMPTY_LIST = [];

/**
 * Will add `div` to document. Nest call will keep order
 * @param render Render DOM in document
 */
function useDom(render, debug) {
  var _React$useState = react.useState(function () {
      if (!(0,canUseDom/* default */.Z)()) {
        return null;
      }
      var defaultEle = document.createElement('div');
      if (false) {}
      return defaultEle;
    }),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 1),
    ele = _React$useState2[0];

  // ========================== Order ==========================
  var appendedRef = react.useRef(false);
  var queueCreate = react.useContext(Context);
  var _React$useState3 = react.useState(EMPTY_LIST),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    queue = _React$useState4[0],
    setQueue = _React$useState4[1];
  var mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : function (appendFn) {
    setQueue(function (origin) {
      var newQueue = [appendFn].concat((0,toConsumableArray/* default */.Z)(origin));
      return newQueue;
    });
  });

  // =========================== DOM ===========================
  function append() {
    if (!ele.parentElement) {
      document.body.appendChild(ele);
    }
    appendedRef.current = true;
  }
  function cleanup() {
    var _ele$parentElement;
    (_ele$parentElement = ele.parentElement) === null || _ele$parentElement === void 0 ? void 0 : _ele$parentElement.removeChild(ele);
    appendedRef.current = false;
  }
  (0,useLayoutEffect/* default */.Z)(function () {
    if (render) {
      if (queueCreate) {
        queueCreate(append);
      } else {
        append();
      }
    } else {
      cleanup();
    }
    return cleanup;
  }, [render]);
  (0,useLayoutEffect/* default */.Z)(function () {
    if (queue.length) {
      queue.forEach(function (appendFn) {
        return appendFn();
      });
      setQueue(EMPTY_LIST);
    }
  }, [queue]);
  return [ele, mergedQueueCreate];
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/dynamicCSS.js
var dynamicCSS = __webpack_require__(6779);
// EXTERNAL MODULE: ./node_modules/rc-util/es/getScrollBarSize.js
var getScrollBarSize = __webpack_require__(59339);
;// CONCATENATED MODULE: ./node_modules/@rc-component/portal/es/util.js
/**
 * Test usage export. Do not use in your production
 */
function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/portal/es/useScrollLocker.js






var UNIQUE_ID = "rc-util-locker-".concat(Date.now());
var uuid = 0;
function useScrollLocker(lock) {
  var mergedLock = !!lock;
  var _React$useState = react.useState(function () {
      uuid += 1;
      return "".concat(UNIQUE_ID, "_").concat(uuid);
    }),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 1),
    id = _React$useState2[0];
  (0,useLayoutEffect/* default */.Z)(function () {
    if (mergedLock) {
      var scrollbarSize = (0,getScrollBarSize/* getTargetScrollBarSize */.o)(document.body).width;
      var isOverflow = isBodyOverflowing();
      (0,dynamicCSS/* updateCSS */.hq)("\nhtml body {\n  overflow-y: hidden;\n  ".concat(isOverflow ? "width: calc(100% - ".concat(scrollbarSize, "px);") : '', "\n}"), id);
    } else {
      (0,dynamicCSS/* removeCSS */.jL)(id);
    }
    return function () {
      (0,dynamicCSS/* removeCSS */.jL)(id);
    };
  }, [mergedLock, id]);
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/portal/es/mock.js
var inline = false;
function inlineMock(nextInline) {
  if (typeof nextInline === 'boolean') {
    inline = nextInline;
  }
  return inline;
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/portal/es/Portal.js










var getPortalContainer = function getPortalContainer(getContainer) {
  if (getContainer === false) {
    return false;
  }
  if (!(0,canUseDom/* default */.Z)() || !getContainer) {
    return null;
  }
  if (typeof getContainer === 'string') {
    return document.querySelector(getContainer);
  }
  if (typeof getContainer === 'function') {
    return getContainer();
  }
  return getContainer;
};
var Portal = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var open = props.open,
    autoLock = props.autoLock,
    getContainer = props.getContainer,
    debug = props.debug,
    _props$autoDestroy = props.autoDestroy,
    autoDestroy = _props$autoDestroy === void 0 ? true : _props$autoDestroy,
    children = props.children;
  var _React$useState = react.useState(open),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    shouldRender = _React$useState2[0],
    setShouldRender = _React$useState2[1];
  var mergedRender = shouldRender || open;

  // ========================= Warning =========================
  if (false) {}

  // ====================== Should Render ======================
  react.useEffect(function () {
    if (autoDestroy || open) {
      setShouldRender(open);
    }
  }, [open, autoDestroy]);

  // ======================== Container ========================
  var _React$useState3 = react.useState(function () {
      return getPortalContainer(getContainer);
    }),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    innerContainer = _React$useState4[0],
    setInnerContainer = _React$useState4[1];
  react.useEffect(function () {
    var customizeContainer = getPortalContainer(getContainer);

    // Tell component that we check this in effect which is safe to be `null`
    setInnerContainer(customizeContainer !== null && customizeContainer !== void 0 ? customizeContainer : null);
  });
  var _useDom = useDom(mergedRender && !innerContainer, debug),
    _useDom2 = (0,slicedToArray/* default */.Z)(_useDom, 2),
    defaultContainer = _useDom2[0],
    queueCreate = _useDom2[1];
  var mergedContainer = innerContainer !== null && innerContainer !== void 0 ? innerContainer : defaultContainer;

  // ========================= Locker ==========================
  useScrollLocker(autoLock && open && (0,canUseDom/* default */.Z)() && (mergedContainer === defaultContainer || mergedContainer === document.body));

  // =========================== Ref ===========================
  var childRef = null;
  if (children && (0,es_ref/* supportRef */.Yr)(children) && ref) {
    var _ref = children;
    childRef = _ref.ref;
  }
  var mergedRef = (0,es_ref/* useComposeRef */.x1)(childRef, ref);

  // ========================= Render ==========================
  // Do not render when nothing need render
  // When innerContainer is `undefined`, it may not ready since user use ref in the same render
  if (!mergedRender || !(0,canUseDom/* default */.Z)() || innerContainer === undefined) {
    return null;
  }

  // Render inline
  var renderInline = mergedContainer === false || inlineMock();
  var reffedChildren = children;
  if (ref) {
    reffedChildren = /*#__PURE__*/react.cloneElement(children, {
      ref: mergedRef
    });
  }
  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: queueCreate
  }, renderInline ? reffedChildren : /*#__PURE__*/(0,react_dom.createPortal)(reffedChildren, mergedContainer));
});
if (false) {}
/* harmony default export */ var es_Portal = (Portal);
;// CONCATENATED MODULE: ./node_modules/@rc-component/portal/es/index.js



/* harmony default export */ var es = (es_Portal);

/***/ }),

/***/ 91831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ trigger_es; }
});

// UNUSED EXPORTS: generateTrigger

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/@rc-component/portal/es/index.js + 6 modules
var es = __webpack_require__(90604);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-resize-observer/es/index.js + 4 modules
var rc_resize_observer_es = __webpack_require__(49938);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/findDOMNode.js
var findDOMNode = __webpack_require__(33970);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/shadow.js
var shadow = __webpack_require__(96585);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useEvent.js
var useEvent = __webpack_require__(47789);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useId.js
var useId = __webpack_require__(73208);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useLayoutEffect.js
var useLayoutEffect = __webpack_require__(76963);
// EXTERNAL MODULE: ./node_modules/rc-util/es/isMobile.js
var isMobile = __webpack_require__(87122);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/rc-motion/es/index.js + 13 modules
var rc_motion_es = __webpack_require__(26981);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(99195);
;// CONCATENATED MODULE: ./node_modules/@rc-component/trigger/es/Popup/Arrow.js


function Arrow(props) {
  var prefixCls = props.prefixCls,
    align = props.align,
    arrow = props.arrow,
    arrowPos = props.arrowPos;
  var _ref = arrow || {},
    className = _ref.className,
    content = _ref.content;
  var _arrowPos$x = arrowPos.x,
    x = _arrowPos$x === void 0 ? 0 : _arrowPos$x,
    _arrowPos$y = arrowPos.y,
    y = _arrowPos$y === void 0 ? 0 : _arrowPos$y;
  var arrowRef = react.useRef();

  // Skip if no align
  if (!align || !align.points) {
    return null;
  }
  var alignStyle = {
    position: 'absolute'
  };

  // Skip if no need to align
  if (align.autoArrow !== false) {
    var popupPoints = align.points[0];
    var targetPoints = align.points[1];
    var popupTB = popupPoints[0];
    var popupLR = popupPoints[1];
    var targetTB = targetPoints[0];
    var targetLR = targetPoints[1];

    // Top & Bottom
    if (popupTB === targetTB || !['t', 'b'].includes(popupTB)) {
      alignStyle.top = y;
    } else if (popupTB === 't') {
      alignStyle.top = 0;
    } else {
      alignStyle.bottom = 0;
    }

    // Left & Right
    if (popupLR === targetLR || !['l', 'r'].includes(popupLR)) {
      alignStyle.left = x;
    } else if (popupLR === 'l') {
      alignStyle.left = 0;
    } else {
      alignStyle.right = 0;
    }
  }
  return /*#__PURE__*/react.createElement("div", {
    ref: arrowRef,
    className: classnames_default()("".concat(prefixCls, "-arrow"), className),
    style: alignStyle
  }, content);
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/trigger/es/Popup/Mask.js




function Mask(props) {
  var prefixCls = props.prefixCls,
    open = props.open,
    zIndex = props.zIndex,
    mask = props.mask,
    motion = props.motion;
  if (!mask) {
    return null;
  }
  return /*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, (0,esm_extends/* default */.Z)({}, motion, {
    motionAppear: true,
    visible: open,
    removeOnLeave: true
  }), function (_ref) {
    var className = _ref.className;
    return /*#__PURE__*/react.createElement("div", {
      style: {
        zIndex: zIndex
      },
      className: classnames_default()("".concat(prefixCls, "-mask"), className)
    });
  });
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/trigger/es/Popup/PopupContent.js

var PopupContent = /*#__PURE__*/react.memo(function (_ref) {
  var children = _ref.children;
  return children;
}, function (_, next) {
  return next.cache;
});
if (false) {}
/* harmony default export */ var Popup_PopupContent = (PopupContent);
;// CONCATENATED MODULE: ./node_modules/@rc-component/trigger/es/Popup/index.js












var Popup = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var popup = props.popup,
    className = props.className,
    prefixCls = props.prefixCls,
    style = props.style,
    target = props.target,
    _onVisibleChanged = props.onVisibleChanged,
    open = props.open,
    keepDom = props.keepDom,
    fresh = props.fresh,
    onClick = props.onClick,
    mask = props.mask,
    arrow = props.arrow,
    arrowPos = props.arrowPos,
    align = props.align,
    motion = props.motion,
    maskMotion = props.maskMotion,
    forceRender = props.forceRender,
    getPopupContainer = props.getPopupContainer,
    autoDestroy = props.autoDestroy,
    Portal = props.portal,
    zIndex = props.zIndex,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    onPointerEnter = props.onPointerEnter,
    onPointerDownCapture = props.onPointerDownCapture,
    ready = props.ready,
    offsetX = props.offsetX,
    offsetY = props.offsetY,
    offsetR = props.offsetR,
    offsetB = props.offsetB,
    onAlign = props.onAlign,
    onPrepare = props.onPrepare,
    stretch = props.stretch,
    targetWidth = props.targetWidth,
    targetHeight = props.targetHeight;
  var childNode = typeof popup === 'function' ? popup() : popup;

  // We can not remove holder only when motion finished.
  var isNodeVisible = open || keepDom;

  // ======================= Container ========================
  var getPopupContainerNeedParams = (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer.length) > 0;
  var _React$useState = react.useState(!getPopupContainer || !getPopupContainerNeedParams),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    show = _React$useState2[0],
    setShow = _React$useState2[1];

  // Delay to show since `getPopupContainer` need target element
  (0,useLayoutEffect/* default */.Z)(function () {
    if (!show && getPopupContainerNeedParams && target) {
      setShow(true);
    }
  }, [show, getPopupContainerNeedParams, target]);

  // ========================= Render =========================
  if (!show) {
    return null;
  }

  // >>>>> Offset
  var AUTO = 'auto';
  var offsetStyle = {
    left: '-1000vw',
    top: '-1000vh',
    right: AUTO,
    bottom: AUTO
  };

  // Set align style
  if (ready || !open) {
    var _experimental;
    var points = align.points;
    var dynamicInset = align.dynamicInset || ((_experimental = align._experimental) === null || _experimental === void 0 ? void 0 : _experimental.dynamicInset);
    var alignRight = dynamicInset && points[0][1] === 'r';
    var alignBottom = dynamicInset && points[0][0] === 'b';
    if (alignRight) {
      offsetStyle.right = offsetR;
      offsetStyle.left = AUTO;
    } else {
      offsetStyle.left = offsetX;
      offsetStyle.right = AUTO;
    }
    if (alignBottom) {
      offsetStyle.bottom = offsetB;
      offsetStyle.top = AUTO;
    } else {
      offsetStyle.top = offsetY;
      offsetStyle.bottom = AUTO;
    }
  }

  // >>>>> Misc
  var miscStyle = {};
  if (stretch) {
    if (stretch.includes('height') && targetHeight) {
      miscStyle.height = targetHeight;
    } else if (stretch.includes('minHeight') && targetHeight) {
      miscStyle.minHeight = targetHeight;
    }
    if (stretch.includes('width') && targetWidth) {
      miscStyle.width = targetWidth;
    } else if (stretch.includes('minWidth') && targetWidth) {
      miscStyle.minWidth = targetWidth;
    }
  }
  if (!open) {
    miscStyle.pointerEvents = 'none';
  }
  return /*#__PURE__*/react.createElement(Portal, {
    open: forceRender || isNodeVisible,
    getContainer: getPopupContainer && function () {
      return getPopupContainer(target);
    },
    autoDestroy: autoDestroy
  }, /*#__PURE__*/react.createElement(Mask, {
    prefixCls: prefixCls,
    open: open,
    zIndex: zIndex,
    mask: mask,
    motion: maskMotion
  }), /*#__PURE__*/react.createElement(rc_resize_observer_es/* default */.Z, {
    onResize: onAlign,
    disabled: !open
  }, function (resizeObserverRef) {
    return /*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, (0,esm_extends/* default */.Z)({
      motionAppear: true,
      motionEnter: true,
      motionLeave: true,
      removeOnLeave: false,
      forceRender: forceRender,
      leavedClassName: "".concat(prefixCls, "-hidden")
    }, motion, {
      onAppearPrepare: onPrepare,
      onEnterPrepare: onPrepare,
      visible: open,
      onVisibleChanged: function onVisibleChanged(nextVisible) {
        var _motion$onVisibleChan;
        motion === null || motion === void 0 || (_motion$onVisibleChan = motion.onVisibleChanged) === null || _motion$onVisibleChan === void 0 || _motion$onVisibleChan.call(motion, nextVisible);
        _onVisibleChanged(nextVisible);
      }
    }), function (_ref, motionRef) {
      var motionClassName = _ref.className,
        motionStyle = _ref.style;
      var cls = classnames_default()(prefixCls, motionClassName, className);
      return /*#__PURE__*/react.createElement("div", {
        ref: (0,es_ref/* composeRef */.sQ)(resizeObserverRef, ref, motionRef),
        className: cls,
        style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
          '--arrow-x': "".concat(arrowPos.x || 0, "px"),
          '--arrow-y': "".concat(arrowPos.y || 0, "px")
        }, offsetStyle), miscStyle), motionStyle), {}, {
          boxSizing: 'border-box',
          zIndex: zIndex
        }, style),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onPointerEnter: onPointerEnter,
        onClick: onClick,
        onPointerDownCapture: onPointerDownCapture
      }, arrow && /*#__PURE__*/react.createElement(Arrow, {
        prefixCls: prefixCls,
        arrow: arrow,
        arrowPos: arrowPos,
        align: align
      }), /*#__PURE__*/react.createElement(Popup_PopupContent, {
        cache: !open && !fresh
      }, childNode));
    });
  }));
});
if (false) {}
/* harmony default export */ var es_Popup = (Popup);
;// CONCATENATED MODULE: ./node_modules/@rc-component/trigger/es/TriggerWrapper.js


var TriggerWrapper = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var children = props.children,
    getTriggerDOMNode = props.getTriggerDOMNode;
  var canUseRef = (0,es_ref/* supportRef */.Yr)(children);

  // When use `getTriggerDOMNode`, we should do additional work to get the real dom
  var setRef = react.useCallback(function (node) {
    (0,es_ref/* fillRef */.mH)(ref, getTriggerDOMNode ? getTriggerDOMNode(node) : node);
  }, [getTriggerDOMNode]);
  var mergedRef = (0,es_ref/* useComposeRef */.x1)(setRef, (0,es_ref/* getNodeRef */.C4)(children));
  return canUseRef ? /*#__PURE__*/react.cloneElement(children, {
    ref: mergedRef
  }) : children;
});
if (false) {}
/* harmony default export */ var es_TriggerWrapper = (TriggerWrapper);
;// CONCATENATED MODULE: ./node_modules/@rc-component/trigger/es/context.js

var TriggerContext = /*#__PURE__*/react.createContext(null);
/* harmony default export */ var es_context = (TriggerContext);
;// CONCATENATED MODULE: ./node_modules/@rc-component/trigger/es/hooks/useAction.js

function toArray(val) {
  return val ? Array.isArray(val) ? val : [val] : [];
}
function useAction(mobile, action, showAction, hideAction) {
  return react.useMemo(function () {
    var mergedShowAction = toArray(showAction !== null && showAction !== void 0 ? showAction : action);
    var mergedHideAction = toArray(hideAction !== null && hideAction !== void 0 ? hideAction : action);
    var showActionSet = new Set(mergedShowAction);
    var hideActionSet = new Set(mergedHideAction);
    if (mobile) {
      if (showActionSet.has('hover')) {
        showActionSet.delete('hover');
        showActionSet.add('click');
      }
      if (hideActionSet.has('hover')) {
        hideActionSet.delete('hover');
        hideActionSet.add('click');
      }
    }
    return [showActionSet, hideActionSet];
  }, [mobile, action, showAction, hideAction]);
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/isVisible.js
var isVisible = __webpack_require__(29504);
;// CONCATENATED MODULE: ./node_modules/@rc-component/trigger/es/util.js

function isPointsEq() {
  var a1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var a2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var isAlignPoint = arguments.length > 2 ? arguments[2] : undefined;
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}
function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  var placements = Object.keys(builtinPlacements);
  for (var i = 0; i < placements.length; i += 1) {
    var _builtinPlacements$pl;
    var placement = placements[i];
    if (isPointsEq((_builtinPlacements$pl = builtinPlacements[placement]) === null || _builtinPlacements$pl === void 0 ? void 0 : _builtinPlacements$pl.points, points, isAlignPoint)) {
      return "".concat(prefixCls, "-placement-").concat(placement);
    }
  }
  return '';
}

/** @deprecated We should not use this if we can refactor all deps */
function getMotion(prefixCls, motion, animation, transitionName) {
  if (motion) {
    return motion;
  }
  if (animation) {
    return {
      motionName: "".concat(prefixCls, "-").concat(animation)
    };
  }
  if (transitionName) {
    return {
      motionName: transitionName
    };
  }
  return null;
}
function getWin(ele) {
  return ele.ownerDocument.defaultView;
}

/**
 * Get all the scrollable parent elements of the element
 * @param ele       The element to be detected
 * @param areaOnly  Only return the parent which will cut visible area
 */
function collectScroller(ele) {
  var scrollerList = [];
  var current = ele === null || ele === void 0 ? void 0 : ele.parentElement;
  var scrollStyle = ['hidden', 'scroll', 'clip', 'auto'];
  while (current) {
    var _getWin$getComputedSt = getWin(current).getComputedStyle(current),
      overflowX = _getWin$getComputedSt.overflowX,
      overflowY = _getWin$getComputedSt.overflowY,
      overflow = _getWin$getComputedSt.overflow;
    if ([overflowX, overflowY, overflow].some(function (o) {
      return scrollStyle.includes(o);
    })) {
      scrollerList.push(current);
    }
    current = current.parentElement;
  }
  return scrollerList;
}
function toNum(num) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return Number.isNaN(num) ? defaultValue : num;
}
function getPxValue(val) {
  return toNum(parseFloat(val), 0);
}
/**
 *
 *
 *  **************************************
 *  *              Border                *
 *  *     **************************     *
 *  *     *                  *     *     *
 *  *  B  *                  *  S  *  B  *
 *  *  o  *                  *  c  *  o  *
 *  *  r  *      Content     *  r  *  r  *
 *  *  d  *                  *  o  *  d  *
 *  *  e  *                  *  l  *  e  *
 *  *  r  ********************  l  *  r  *
 *  *     *        Scroll          *     *
 *  *     **************************     *
 *  *              Border                *
 *  **************************************
 *
 */
/**
 * Get visible area of element
 */
function getVisibleArea(initArea, scrollerList) {
  var visibleArea = (0,objectSpread2/* default */.Z)({}, initArea);
  (scrollerList || []).forEach(function (ele) {
    if (ele instanceof HTMLBodyElement || ele instanceof HTMLHtmlElement) {
      return;
    }

    // Skip if static position which will not affect visible area
    var _getWin$getComputedSt2 = getWin(ele).getComputedStyle(ele),
      overflow = _getWin$getComputedSt2.overflow,
      overflowClipMargin = _getWin$getComputedSt2.overflowClipMargin,
      borderTopWidth = _getWin$getComputedSt2.borderTopWidth,
      borderBottomWidth = _getWin$getComputedSt2.borderBottomWidth,
      borderLeftWidth = _getWin$getComputedSt2.borderLeftWidth,
      borderRightWidth = _getWin$getComputedSt2.borderRightWidth;
    var eleRect = ele.getBoundingClientRect();
    var eleOutHeight = ele.offsetHeight,
      eleInnerHeight = ele.clientHeight,
      eleOutWidth = ele.offsetWidth,
      eleInnerWidth = ele.clientWidth;
    var borderTopNum = getPxValue(borderTopWidth);
    var borderBottomNum = getPxValue(borderBottomWidth);
    var borderLeftNum = getPxValue(borderLeftWidth);
    var borderRightNum = getPxValue(borderRightWidth);
    var scaleX = toNum(Math.round(eleRect.width / eleOutWidth * 1000) / 1000);
    var scaleY = toNum(Math.round(eleRect.height / eleOutHeight * 1000) / 1000);

    // Original visible area
    var eleScrollWidth = (eleOutWidth - eleInnerWidth - borderLeftNum - borderRightNum) * scaleX;
    var eleScrollHeight = (eleOutHeight - eleInnerHeight - borderTopNum - borderBottomNum) * scaleY;

    // Cut border size
    var scaledBorderTopWidth = borderTopNum * scaleY;
    var scaledBorderBottomWidth = borderBottomNum * scaleY;
    var scaledBorderLeftWidth = borderLeftNum * scaleX;
    var scaledBorderRightWidth = borderRightNum * scaleX;

    // Clip margin
    var clipMarginWidth = 0;
    var clipMarginHeight = 0;
    if (overflow === 'clip') {
      var clipNum = getPxValue(overflowClipMargin);
      clipMarginWidth = clipNum * scaleX;
      clipMarginHeight = clipNum * scaleY;
    }

    // Region
    var eleLeft = eleRect.x + scaledBorderLeftWidth - clipMarginWidth;
    var eleTop = eleRect.y + scaledBorderTopWidth - clipMarginHeight;
    var eleRight = eleLeft + eleRect.width + 2 * clipMarginWidth - scaledBorderLeftWidth - scaledBorderRightWidth - eleScrollWidth;
    var eleBottom = eleTop + eleRect.height + 2 * clipMarginHeight - scaledBorderTopWidth - scaledBorderBottomWidth - eleScrollHeight;
    visibleArea.left = Math.max(visibleArea.left, eleLeft);
    visibleArea.top = Math.max(visibleArea.top, eleTop);
    visibleArea.right = Math.min(visibleArea.right, eleRight);
    visibleArea.bottom = Math.min(visibleArea.bottom, eleBottom);
  });
  return visibleArea;
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/trigger/es/hooks/useAlign.js








function getUnitOffset(size) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var offsetStr = "".concat(offset);
  var cells = offsetStr.match(/^(.*)\%$/);
  if (cells) {
    return size * (parseFloat(cells[1]) / 100);
  }
  return parseFloat(offsetStr);
}
function getNumberOffset(rect, offset) {
  var _ref = offset || [],
    _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
    offsetX = _ref2[0],
    offsetY = _ref2[1];
  return [getUnitOffset(rect.width, offsetX), getUnitOffset(rect.height, offsetY)];
}
function splitPoints() {
  var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [points[0], points[1]];
}
function getAlignPoint(rect, points) {
  var topBottom = points[0];
  var leftRight = points[1];
  var x;
  var y;

  // Top & Bottom
  if (topBottom === 't') {
    y = rect.y;
  } else if (topBottom === 'b') {
    y = rect.y + rect.height;
  } else {
    y = rect.y + rect.height / 2;
  }

  // Left & Right
  if (leftRight === 'l') {
    x = rect.x;
  } else if (leftRight === 'r') {
    x = rect.x + rect.width;
  } else {
    x = rect.x + rect.width / 2;
  }
  return {
    x: x,
    y: y
  };
}
function reversePoints(points, index) {
  var reverseMap = {
    t: 'b',
    b: 't',
    l: 'r',
    r: 'l'
  };
  return points.map(function (point, i) {
    if (i === index) {
      return reverseMap[point] || 'c';
    }
    return point;
  }).join('');
}
function useAlign(open, popupEle, target, placement, builtinPlacements, popupAlign, onPopupAlign) {
  var _React$useState = react.useState({
      ready: false,
      offsetX: 0,
      offsetY: 0,
      offsetR: 0,
      offsetB: 0,
      arrowX: 0,
      arrowY: 0,
      scaleX: 1,
      scaleY: 1,
      align: builtinPlacements[placement] || {}
    }),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    offsetInfo = _React$useState2[0],
    setOffsetInfo = _React$useState2[1];
  var alignCountRef = react.useRef(0);
  var scrollerList = react.useMemo(function () {
    if (!popupEle) {
      return [];
    }
    return collectScroller(popupEle);
  }, [popupEle]);

  // ========================= Flip ==========================
  // We will memo flip info.
  // If size change to make flip, it will memo the flip info and use it in next align.
  var prevFlipRef = react.useRef({});
  var resetFlipCache = function resetFlipCache() {
    prevFlipRef.current = {};
  };
  if (!open) {
    resetFlipCache();
  }

  // ========================= Align =========================
  var onAlign = (0,useEvent/* default */.Z)(function () {
    if (popupEle && target && open) {
      var _popupElement$parentE, _popupRect$x, _popupRect$y, _popupElement$parentE2;
      var popupElement = popupEle;
      var doc = popupElement.ownerDocument;
      var win = getWin(popupElement);
      var _win$getComputedStyle = win.getComputedStyle(popupElement),
        popupPosition = _win$getComputedStyle.position;
      var originLeft = popupElement.style.left;
      var originTop = popupElement.style.top;
      var originRight = popupElement.style.right;
      var originBottom = popupElement.style.bottom;
      var originOverflow = popupElement.style.overflow;

      // Placement
      var placementInfo = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, builtinPlacements[placement]), popupAlign);

      // placeholder element
      var placeholderElement = doc.createElement('div');
      (_popupElement$parentE = popupElement.parentElement) === null || _popupElement$parentE === void 0 || _popupElement$parentE.appendChild(placeholderElement);
      placeholderElement.style.left = "".concat(popupElement.offsetLeft, "px");
      placeholderElement.style.top = "".concat(popupElement.offsetTop, "px");
      placeholderElement.style.position = popupPosition;
      placeholderElement.style.height = "".concat(popupElement.offsetHeight, "px");
      placeholderElement.style.width = "".concat(popupElement.offsetWidth, "px");

      // Reset first
      popupElement.style.left = '0';
      popupElement.style.top = '0';
      popupElement.style.right = 'auto';
      popupElement.style.bottom = 'auto';
      popupElement.style.overflow = 'hidden';

      // Calculate align style, we should consider `transform` case
      var targetRect;
      if (Array.isArray(target)) {
        targetRect = {
          x: target[0],
          y: target[1],
          width: 0,
          height: 0
        };
      } else {
        var _rect$x, _rect$y;
        var rect = target.getBoundingClientRect();
        rect.x = (_rect$x = rect.x) !== null && _rect$x !== void 0 ? _rect$x : rect.left;
        rect.y = (_rect$y = rect.y) !== null && _rect$y !== void 0 ? _rect$y : rect.top;
        targetRect = {
          x: rect.x,
          y: rect.y,
          width: rect.width,
          height: rect.height
        };
      }
      var popupRect = popupElement.getBoundingClientRect();
      var _win$getComputedStyle2 = win.getComputedStyle(popupElement),
        height = _win$getComputedStyle2.height,
        width = _win$getComputedStyle2.width;
      popupRect.x = (_popupRect$x = popupRect.x) !== null && _popupRect$x !== void 0 ? _popupRect$x : popupRect.left;
      popupRect.y = (_popupRect$y = popupRect.y) !== null && _popupRect$y !== void 0 ? _popupRect$y : popupRect.top;
      var _doc$documentElement = doc.documentElement,
        clientWidth = _doc$documentElement.clientWidth,
        clientHeight = _doc$documentElement.clientHeight,
        scrollWidth = _doc$documentElement.scrollWidth,
        scrollHeight = _doc$documentElement.scrollHeight,
        scrollTop = _doc$documentElement.scrollTop,
        scrollLeft = _doc$documentElement.scrollLeft;
      var popupHeight = popupRect.height;
      var popupWidth = popupRect.width;
      var targetHeight = targetRect.height;
      var targetWidth = targetRect.width;

      // Get bounding of visible area
      var visibleRegion = {
        left: 0,
        top: 0,
        right: clientWidth,
        bottom: clientHeight
      };
      var scrollRegion = {
        left: -scrollLeft,
        top: -scrollTop,
        right: scrollWidth - scrollLeft,
        bottom: scrollHeight - scrollTop
      };
      var htmlRegion = placementInfo.htmlRegion;
      var VISIBLE = 'visible';
      var VISIBLE_FIRST = 'visibleFirst';
      if (htmlRegion !== 'scroll' && htmlRegion !== VISIBLE_FIRST) {
        htmlRegion = VISIBLE;
      }
      var isVisibleFirst = htmlRegion === VISIBLE_FIRST;
      var scrollRegionArea = getVisibleArea(scrollRegion, scrollerList);
      var visibleRegionArea = getVisibleArea(visibleRegion, scrollerList);
      var visibleArea = htmlRegion === VISIBLE ? visibleRegionArea : scrollRegionArea;

      // When set to `visibleFirst`,
      // the check `adjust` logic will use `visibleRegion` for check first.
      var adjustCheckVisibleArea = isVisibleFirst ? visibleRegionArea : visibleArea;

      // Record right & bottom align data
      popupElement.style.left = 'auto';
      popupElement.style.top = 'auto';
      popupElement.style.right = '0';
      popupElement.style.bottom = '0';
      var popupMirrorRect = popupElement.getBoundingClientRect();

      // Reset back
      popupElement.style.left = originLeft;
      popupElement.style.top = originTop;
      popupElement.style.right = originRight;
      popupElement.style.bottom = originBottom;
      popupElement.style.overflow = originOverflow;
      (_popupElement$parentE2 = popupElement.parentElement) === null || _popupElement$parentE2 === void 0 || _popupElement$parentE2.removeChild(placeholderElement);

      // Calculate scale
      var _scaleX = toNum(Math.round(popupWidth / parseFloat(width) * 1000) / 1000);
      var _scaleY = toNum(Math.round(popupHeight / parseFloat(height) * 1000) / 1000);

      // No need to align since it's not visible in view
      if (_scaleX === 0 || _scaleY === 0 || (0,findDOMNode/* isDOM */.Sh)(target) && !(0,isVisible/* default */.Z)(target)) {
        return;
      }

      // Offset
      var offset = placementInfo.offset,
        targetOffset = placementInfo.targetOffset;
      var _getNumberOffset = getNumberOffset(popupRect, offset),
        _getNumberOffset2 = (0,slicedToArray/* default */.Z)(_getNumberOffset, 2),
        popupOffsetX = _getNumberOffset2[0],
        popupOffsetY = _getNumberOffset2[1];
      var _getNumberOffset3 = getNumberOffset(targetRect, targetOffset),
        _getNumberOffset4 = (0,slicedToArray/* default */.Z)(_getNumberOffset3, 2),
        targetOffsetX = _getNumberOffset4[0],
        targetOffsetY = _getNumberOffset4[1];
      targetRect.x -= targetOffsetX;
      targetRect.y -= targetOffsetY;

      // Points
      var _ref3 = placementInfo.points || [],
        _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
        popupPoint = _ref4[0],
        targetPoint = _ref4[1];
      var targetPoints = splitPoints(targetPoint);
      var popupPoints = splitPoints(popupPoint);
      var targetAlignPoint = getAlignPoint(targetRect, targetPoints);
      var popupAlignPoint = getAlignPoint(popupRect, popupPoints);

      // Real align info may not same as origin one
      var nextAlignInfo = (0,objectSpread2/* default */.Z)({}, placementInfo);

      // Next Offset
      var nextOffsetX = targetAlignPoint.x - popupAlignPoint.x + popupOffsetX;
      var nextOffsetY = targetAlignPoint.y - popupAlignPoint.y + popupOffsetY;

      // ============== Intersection ===============
      // Get area by position. Used for check if flip area is better
      function getIntersectionVisibleArea(offsetX, offsetY) {
        var area = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : visibleArea;
        var l = popupRect.x + offsetX;
        var t = popupRect.y + offsetY;
        var r = l + popupWidth;
        var b = t + popupHeight;
        var visibleL = Math.max(l, area.left);
        var visibleT = Math.max(t, area.top);
        var visibleR = Math.min(r, area.right);
        var visibleB = Math.min(b, area.bottom);
        return Math.max(0, (visibleR - visibleL) * (visibleB - visibleT));
      }
      var originIntersectionVisibleArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY);

      // As `visibleFirst`, we prepare this for check
      var originIntersectionRecommendArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY, visibleRegionArea);

      // ========================== Overflow ===========================
      var targetAlignPointTL = getAlignPoint(targetRect, ['t', 'l']);
      var popupAlignPointTL = getAlignPoint(popupRect, ['t', 'l']);
      var targetAlignPointBR = getAlignPoint(targetRect, ['b', 'r']);
      var popupAlignPointBR = getAlignPoint(popupRect, ['b', 'r']);
      var overflow = placementInfo.overflow || {};
      var adjustX = overflow.adjustX,
        adjustY = overflow.adjustY,
        shiftX = overflow.shiftX,
        shiftY = overflow.shiftY;
      var supportAdjust = function supportAdjust(val) {
        if (typeof val === 'boolean') {
          return val;
        }
        return val >= 0;
      };

      // Prepare position
      var nextPopupY;
      var nextPopupBottom;
      var nextPopupX;
      var nextPopupRight;
      function syncNextPopupPosition() {
        nextPopupY = popupRect.y + nextOffsetY;
        nextPopupBottom = nextPopupY + popupHeight;
        nextPopupX = popupRect.x + nextOffsetX;
        nextPopupRight = nextPopupX + popupWidth;
      }
      syncNextPopupPosition();

      // >>>>>>>>>> Top & Bottom
      var needAdjustY = supportAdjust(adjustY);
      var sameTB = popupPoints[0] === targetPoints[0];

      // Bottom to Top
      if (needAdjustY && popupPoints[0] === 't' && (nextPopupBottom > adjustCheckVisibleArea.bottom || prevFlipRef.current.bt)) {
        var tmpNextOffsetY = nextOffsetY;
        if (sameTB) {
          tmpNextOffsetY -= popupHeight - targetHeight;
        } else {
          tmpNextOffsetY = targetAlignPointTL.y - popupAlignPointBR.y - popupOffsetY;
        }
        var newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
        var newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
        if (
        // Of course use larger one
        newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst ||
        // Choose recommend one
        newVisibleRecommendArea >= originIntersectionRecommendArea)) {
          prevFlipRef.current.bt = true;
          nextOffsetY = tmpNextOffsetY;
          popupOffsetY = -popupOffsetY;
          nextAlignInfo.points = [reversePoints(popupPoints, 0), reversePoints(targetPoints, 0)];
        } else {
          prevFlipRef.current.bt = false;
        }
      }

      // Top to Bottom
      if (needAdjustY && popupPoints[0] === 'b' && (nextPopupY < adjustCheckVisibleArea.top || prevFlipRef.current.tb)) {
        var _tmpNextOffsetY = nextOffsetY;
        if (sameTB) {
          _tmpNextOffsetY += popupHeight - targetHeight;
        } else {
          _tmpNextOffsetY = targetAlignPointBR.y - popupAlignPointTL.y - popupOffsetY;
        }
        var _newVisibleArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY);
        var _newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY, visibleRegionArea);
        if (
        // Of course use larger one
        _newVisibleArea > originIntersectionVisibleArea || _newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst ||
        // Choose recommend one
        _newVisibleRecommendArea >= originIntersectionRecommendArea)) {
          prevFlipRef.current.tb = true;
          nextOffsetY = _tmpNextOffsetY;
          popupOffsetY = -popupOffsetY;
          nextAlignInfo.points = [reversePoints(popupPoints, 0), reversePoints(targetPoints, 0)];
        } else {
          prevFlipRef.current.tb = false;
        }
      }

      // >>>>>>>>>> Left & Right
      var needAdjustX = supportAdjust(adjustX);

      // >>>>> Flip
      var sameLR = popupPoints[1] === targetPoints[1];

      // Right to Left
      if (needAdjustX && popupPoints[1] === 'l' && (nextPopupRight > adjustCheckVisibleArea.right || prevFlipRef.current.rl)) {
        var tmpNextOffsetX = nextOffsetX;
        if (sameLR) {
          tmpNextOffsetX -= popupWidth - targetWidth;
        } else {
          tmpNextOffsetX = targetAlignPointTL.x - popupAlignPointBR.x - popupOffsetX;
        }
        var _newVisibleArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
        var _newVisibleRecommendArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
        if (
        // Of course use larger one
        _newVisibleArea2 > originIntersectionVisibleArea || _newVisibleArea2 === originIntersectionVisibleArea && (!isVisibleFirst ||
        // Choose recommend one
        _newVisibleRecommendArea2 >= originIntersectionRecommendArea)) {
          prevFlipRef.current.rl = true;
          nextOffsetX = tmpNextOffsetX;
          popupOffsetX = -popupOffsetX;
          nextAlignInfo.points = [reversePoints(popupPoints, 1), reversePoints(targetPoints, 1)];
        } else {
          prevFlipRef.current.rl = false;
        }
      }

      // Left to Right
      if (needAdjustX && popupPoints[1] === 'r' && (nextPopupX < adjustCheckVisibleArea.left || prevFlipRef.current.lr)) {
        var _tmpNextOffsetX = nextOffsetX;
        if (sameLR) {
          _tmpNextOffsetX += popupWidth - targetWidth;
        } else {
          _tmpNextOffsetX = targetAlignPointBR.x - popupAlignPointTL.x - popupOffsetX;
        }
        var _newVisibleArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY);
        var _newVisibleRecommendArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY, visibleRegionArea);
        if (
        // Of course use larger one
        _newVisibleArea3 > originIntersectionVisibleArea || _newVisibleArea3 === originIntersectionVisibleArea && (!isVisibleFirst ||
        // Choose recommend one
        _newVisibleRecommendArea3 >= originIntersectionRecommendArea)) {
          prevFlipRef.current.lr = true;
          nextOffsetX = _tmpNextOffsetX;
          popupOffsetX = -popupOffsetX;
          nextAlignInfo.points = [reversePoints(popupPoints, 1), reversePoints(targetPoints, 1)];
        } else {
          prevFlipRef.current.lr = false;
        }
      }

      // ============================ Shift ============================
      syncNextPopupPosition();
      var numShiftX = shiftX === true ? 0 : shiftX;
      if (typeof numShiftX === 'number') {
        // Left
        if (nextPopupX < visibleRegionArea.left) {
          nextOffsetX -= nextPopupX - visibleRegionArea.left - popupOffsetX;
          if (targetRect.x + targetWidth < visibleRegionArea.left + numShiftX) {
            nextOffsetX += targetRect.x - visibleRegionArea.left + targetWidth - numShiftX;
          }
        }

        // Right
        if (nextPopupRight > visibleRegionArea.right) {
          nextOffsetX -= nextPopupRight - visibleRegionArea.right - popupOffsetX;
          if (targetRect.x > visibleRegionArea.right - numShiftX) {
            nextOffsetX += targetRect.x - visibleRegionArea.right + numShiftX;
          }
        }
      }
      var numShiftY = shiftY === true ? 0 : shiftY;
      if (typeof numShiftY === 'number') {
        // Top
        if (nextPopupY < visibleRegionArea.top) {
          nextOffsetY -= nextPopupY - visibleRegionArea.top - popupOffsetY;

          // When target if far away from visible area
          // Stop shift
          if (targetRect.y + targetHeight < visibleRegionArea.top + numShiftY) {
            nextOffsetY += targetRect.y - visibleRegionArea.top + targetHeight - numShiftY;
          }
        }

        // Bottom
        if (nextPopupBottom > visibleRegionArea.bottom) {
          nextOffsetY -= nextPopupBottom - visibleRegionArea.bottom - popupOffsetY;
          if (targetRect.y > visibleRegionArea.bottom - numShiftY) {
            nextOffsetY += targetRect.y - visibleRegionArea.bottom + numShiftY;
          }
        }
      }

      // ============================ Arrow ============================
      // Arrow center align
      var popupLeft = popupRect.x + nextOffsetX;
      var popupRight = popupLeft + popupWidth;
      var popupTop = popupRect.y + nextOffsetY;
      var popupBottom = popupTop + popupHeight;
      var targetLeft = targetRect.x;
      var targetRight = targetLeft + targetWidth;
      var targetTop = targetRect.y;
      var targetBottom = targetTop + targetHeight;
      var maxLeft = Math.max(popupLeft, targetLeft);
      var minRight = Math.min(popupRight, targetRight);
      var xCenter = (maxLeft + minRight) / 2;
      var nextArrowX = xCenter - popupLeft;
      var maxTop = Math.max(popupTop, targetTop);
      var minBottom = Math.min(popupBottom, targetBottom);
      var yCenter = (maxTop + minBottom) / 2;
      var nextArrowY = yCenter - popupTop;
      onPopupAlign === null || onPopupAlign === void 0 || onPopupAlign(popupEle, nextAlignInfo);

      // Additional calculate right & bottom position
      var offsetX4Right = popupMirrorRect.right - popupRect.x - (nextOffsetX + popupRect.width);
      var offsetY4Bottom = popupMirrorRect.bottom - popupRect.y - (nextOffsetY + popupRect.height);
      if (_scaleX === 1) {
        nextOffsetX = Math.round(nextOffsetX);
        offsetX4Right = Math.round(offsetX4Right);
      }
      if (_scaleY === 1) {
        nextOffsetY = Math.round(nextOffsetY);
        offsetY4Bottom = Math.round(offsetY4Bottom);
      }
      var nextOffsetInfo = {
        ready: true,
        offsetX: nextOffsetX / _scaleX,
        offsetY: nextOffsetY / _scaleY,
        offsetR: offsetX4Right / _scaleX,
        offsetB: offsetY4Bottom / _scaleY,
        arrowX: nextArrowX / _scaleX,
        arrowY: nextArrowY / _scaleY,
        scaleX: _scaleX,
        scaleY: _scaleY,
        align: nextAlignInfo
      };
      setOffsetInfo(nextOffsetInfo);
    }
  });
  var triggerAlign = function triggerAlign() {
    alignCountRef.current += 1;
    var id = alignCountRef.current;

    // Merge all align requirement into one frame
    Promise.resolve().then(function () {
      if (alignCountRef.current === id) {
        onAlign();
      }
    });
  };

  // Reset ready status when placement & open changed
  var resetReady = function resetReady() {
    setOffsetInfo(function (ori) {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, ori), {}, {
        ready: false
      });
    });
  };
  (0,useLayoutEffect/* default */.Z)(resetReady, [placement]);
  (0,useLayoutEffect/* default */.Z)(function () {
    if (!open) {
      resetReady();
    }
  }, [open]);
  return [offsetInfo.ready, offsetInfo.offsetX, offsetInfo.offsetY, offsetInfo.offsetR, offsetInfo.offsetB, offsetInfo.arrowX, offsetInfo.arrowY, offsetInfo.scaleX, offsetInfo.scaleY, offsetInfo.align, triggerAlign];
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
;// CONCATENATED MODULE: ./node_modules/@rc-component/trigger/es/hooks/useWatch.js



function useWatch(open, target, popup, onAlign, onScroll) {
  (0,useLayoutEffect/* default */.Z)(function () {
    if (open && target && popup) {
      var targetElement = target;
      var popupElement = popup;
      var targetScrollList = collectScroller(targetElement);
      var popupScrollList = collectScroller(popupElement);
      var win = getWin(popupElement);
      var mergedList = new Set([win].concat((0,toConsumableArray/* default */.Z)(targetScrollList), (0,toConsumableArray/* default */.Z)(popupScrollList)));
      function notifyScroll() {
        onAlign();
        onScroll();
      }
      mergedList.forEach(function (scroller) {
        scroller.addEventListener('scroll', notifyScroll, {
          passive: true
        });
      });
      win.addEventListener('resize', notifyScroll, {
        passive: true
      });

      // First time always do align
      onAlign();
      return function () {
        mergedList.forEach(function (scroller) {
          scroller.removeEventListener('scroll', notifyScroll);
          win.removeEventListener('resize', notifyScroll);
        });
      };
    }
  }, [open, target, popup]);
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(13764);
;// CONCATENATED MODULE: ./node_modules/@rc-component/trigger/es/hooks/useWinClick.js




function useWinClick(open, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen) {
  var openRef = react.useRef(open);
  openRef.current = open;
  var popupPointerDownRef = react.useRef(false);

  // Click to hide is special action since click popup element should not hide
  react.useEffect(function () {
    if (clickToHide && popupEle && (!mask || maskClosable)) {
      var onPointerDown = function onPointerDown() {
        popupPointerDownRef.current = false;
      };
      var onTriggerClose = function onTriggerClose(e) {
        var _e$composedPath;
        if (openRef.current && !inPopupOrChild(((_e$composedPath = e.composedPath) === null || _e$composedPath === void 0 || (_e$composedPath = _e$composedPath.call(e)) === null || _e$composedPath === void 0 ? void 0 : _e$composedPath[0]) || e.target) && !popupPointerDownRef.current) {
          triggerOpen(false);
        }
      };
      var win = getWin(popupEle);
      win.addEventListener('pointerdown', onPointerDown, true);
      win.addEventListener('mousedown', onTriggerClose, true);
      win.addEventListener('contextmenu', onTriggerClose, true);

      // shadow root
      var targetShadowRoot = (0,shadow/* getShadowRoot */.A)(targetEle);
      if (targetShadowRoot) {
        targetShadowRoot.addEventListener('mousedown', onTriggerClose, true);
        targetShadowRoot.addEventListener('contextmenu', onTriggerClose, true);
      }

      // Warning if target and popup not in same root
      if (false) { var popupRoot, targetRoot, _targetEle$getRootNod, _popupEle$getRootNode; }
      return function () {
        win.removeEventListener('pointerdown', onPointerDown, true);
        win.removeEventListener('mousedown', onTriggerClose, true);
        win.removeEventListener('contextmenu', onTriggerClose, true);
        if (targetShadowRoot) {
          targetShadowRoot.removeEventListener('mousedown', onTriggerClose, true);
          targetShadowRoot.removeEventListener('contextmenu', onTriggerClose, true);
        }
      };
    }
  }, [clickToHide, targetEle, popupEle, mask, maskClosable]);
  function onPopupPointerDown() {
    popupPointerDownRef.current = true;
  }
  return onPopupPointerDown;
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/trigger/es/index.js



var _excluded = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];



















// Removed Props List
// Seems this can be auto
// getDocument?: (element?: HTMLElement) => Document;

// New version will not wrap popup with `rc-trigger-popup-content` when multiple children

function generateTrigger() {
  var PortalComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : es/* default */.Z;
  var Trigger = /*#__PURE__*/react.forwardRef(function (props, ref) {
    var _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? 'rc-trigger-popup' : _props$prefixCls,
      children = props.children,
      _props$action = props.action,
      action = _props$action === void 0 ? 'hover' : _props$action,
      showAction = props.showAction,
      hideAction = props.hideAction,
      popupVisible = props.popupVisible,
      defaultPopupVisible = props.defaultPopupVisible,
      onPopupVisibleChange = props.onPopupVisibleChange,
      afterPopupVisibleChange = props.afterPopupVisibleChange,
      mouseEnterDelay = props.mouseEnterDelay,
      _props$mouseLeaveDela = props.mouseLeaveDelay,
      mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela,
      focusDelay = props.focusDelay,
      blurDelay = props.blurDelay,
      mask = props.mask,
      _props$maskClosable = props.maskClosable,
      maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable,
      getPopupContainer = props.getPopupContainer,
      forceRender = props.forceRender,
      autoDestroy = props.autoDestroy,
      destroyPopupOnHide = props.destroyPopupOnHide,
      popup = props.popup,
      popupClassName = props.popupClassName,
      popupStyle = props.popupStyle,
      popupPlacement = props.popupPlacement,
      _props$builtinPlaceme = props.builtinPlacements,
      builtinPlacements = _props$builtinPlaceme === void 0 ? {} : _props$builtinPlaceme,
      popupAlign = props.popupAlign,
      zIndex = props.zIndex,
      stretch = props.stretch,
      getPopupClassNameFromAlign = props.getPopupClassNameFromAlign,
      fresh = props.fresh,
      alignPoint = props.alignPoint,
      onPopupClick = props.onPopupClick,
      onPopupAlign = props.onPopupAlign,
      arrow = props.arrow,
      popupMotion = props.popupMotion,
      maskMotion = props.maskMotion,
      popupTransitionName = props.popupTransitionName,
      popupAnimation = props.popupAnimation,
      maskTransitionName = props.maskTransitionName,
      maskAnimation = props.maskAnimation,
      className = props.className,
      getTriggerDOMNode = props.getTriggerDOMNode,
      restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded);
    var mergedAutoDestroy = autoDestroy || destroyPopupOnHide || false;

    // =========================== Mobile ===========================
    var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      mobile = _React$useState2[0],
      setMobile = _React$useState2[1];
    (0,useLayoutEffect/* default */.Z)(function () {
      setMobile((0,isMobile/* default */.Z)());
    }, []);

    // ========================== Context ===========================
    var subPopupElements = react.useRef({});
    var parentContext = react.useContext(es_context);
    var context = react.useMemo(function () {
      return {
        registerSubPopup: function registerSubPopup(id, subPopupEle) {
          subPopupElements.current[id] = subPopupEle;
          parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, subPopupEle);
        }
      };
    }, [parentContext]);

    // =========================== Popup ============================
    var id = (0,useId/* default */.Z)();
    var _React$useState3 = react.useState(null),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      popupEle = _React$useState4[0],
      setPopupEle = _React$useState4[1];

    // Used for forwardRef popup. Not use internal
    var externalPopupRef = react.useRef(null);
    var setPopupRef = (0,useEvent/* default */.Z)(function (node) {
      externalPopupRef.current = node;
      if ((0,findDOMNode/* isDOM */.Sh)(node) && popupEle !== node) {
        setPopupEle(node);
      }
      parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, node);
    });

    // =========================== Target ===========================
    // Use state to control here since `useRef` update not trigger render
    var _React$useState5 = react.useState(null),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      targetEle = _React$useState6[0],
      setTargetEle = _React$useState6[1];

    // Used for forwardRef target. Not use internal
    var externalForwardRef = react.useRef(null);
    var setTargetRef = (0,useEvent/* default */.Z)(function (node) {
      if ((0,findDOMNode/* isDOM */.Sh)(node) && targetEle !== node) {
        setTargetEle(node);
        externalForwardRef.current = node;
      }
    });

    // ========================== Children ==========================
    var child = react.Children.only(children);
    var originChildProps = (child === null || child === void 0 ? void 0 : child.props) || {};
    var cloneProps = {};
    var inPopupOrChild = (0,useEvent/* default */.Z)(function (ele) {
      var _getShadowRoot, _getShadowRoot2;
      var childDOM = targetEle;
      return (childDOM === null || childDOM === void 0 ? void 0 : childDOM.contains(ele)) || ((_getShadowRoot = (0,shadow/* getShadowRoot */.A)(childDOM)) === null || _getShadowRoot === void 0 ? void 0 : _getShadowRoot.host) === ele || ele === childDOM || (popupEle === null || popupEle === void 0 ? void 0 : popupEle.contains(ele)) || ((_getShadowRoot2 = (0,shadow/* getShadowRoot */.A)(popupEle)) === null || _getShadowRoot2 === void 0 ? void 0 : _getShadowRoot2.host) === ele || ele === popupEle || Object.values(subPopupElements.current).some(function (subPopupEle) {
        return (subPopupEle === null || subPopupEle === void 0 ? void 0 : subPopupEle.contains(ele)) || ele === subPopupEle;
      });
    });

    // =========================== Motion ===========================
    var mergePopupMotion = getMotion(prefixCls, popupMotion, popupAnimation, popupTransitionName);
    var mergeMaskMotion = getMotion(prefixCls, maskMotion, maskAnimation, maskTransitionName);

    // ============================ Open ============================
    var _React$useState7 = react.useState(defaultPopupVisible || false),
      _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
      internalOpen = _React$useState8[0],
      setInternalOpen = _React$useState8[1];

    // Render still use props as first priority
    var mergedOpen = popupVisible !== null && popupVisible !== void 0 ? popupVisible : internalOpen;

    // We use effect sync here in case `popupVisible` back to `undefined`
    var setMergedOpen = (0,useEvent/* default */.Z)(function (nextOpen) {
      if (popupVisible === undefined) {
        setInternalOpen(nextOpen);
      }
    });
    (0,useLayoutEffect/* default */.Z)(function () {
      setInternalOpen(popupVisible || false);
    }, [popupVisible]);
    var openRef = react.useRef(mergedOpen);
    openRef.current = mergedOpen;
    var lastTriggerRef = react.useRef([]);
    lastTriggerRef.current = [];
    var internalTriggerOpen = (0,useEvent/* default */.Z)(function (nextOpen) {
      var _lastTriggerRef$curre;
      setMergedOpen(nextOpen);

      // Enter or Pointer will both trigger open state change
      // We only need take one to avoid duplicated change event trigger
      // Use `lastTriggerRef` to record last open type
      if (((_lastTriggerRef$curre = lastTriggerRef.current[lastTriggerRef.current.length - 1]) !== null && _lastTriggerRef$curre !== void 0 ? _lastTriggerRef$curre : mergedOpen) !== nextOpen) {
        lastTriggerRef.current.push(nextOpen);
        onPopupVisibleChange === null || onPopupVisibleChange === void 0 || onPopupVisibleChange(nextOpen);
      }
    });

    // Trigger for delay
    var delayRef = react.useRef();
    var clearDelay = function clearDelay() {
      clearTimeout(delayRef.current);
    };
    var triggerOpen = function triggerOpen(nextOpen) {
      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      clearDelay();
      if (delay === 0) {
        internalTriggerOpen(nextOpen);
      } else {
        delayRef.current = setTimeout(function () {
          internalTriggerOpen(nextOpen);
        }, delay * 1000);
      }
    };
    react.useEffect(function () {
      return clearDelay;
    }, []);

    // ========================== Motion ============================
    var _React$useState9 = react.useState(false),
      _React$useState10 = (0,slicedToArray/* default */.Z)(_React$useState9, 2),
      inMotion = _React$useState10[0],
      setInMotion = _React$useState10[1];
    (0,useLayoutEffect/* default */.Z)(function (firstMount) {
      if (!firstMount || mergedOpen) {
        setInMotion(true);
      }
    }, [mergedOpen]);
    var _React$useState11 = react.useState(null),
      _React$useState12 = (0,slicedToArray/* default */.Z)(_React$useState11, 2),
      motionPrepareResolve = _React$useState12[0],
      setMotionPrepareResolve = _React$useState12[1];

    // =========================== Align ============================
    var _React$useState13 = react.useState(null),
      _React$useState14 = (0,slicedToArray/* default */.Z)(_React$useState13, 2),
      mousePos = _React$useState14[0],
      setMousePos = _React$useState14[1];
    var setMousePosByEvent = function setMousePosByEvent(event) {
      setMousePos([event.clientX, event.clientY]);
    };
    var _useAlign = useAlign(mergedOpen, popupEle, alignPoint && mousePos !== null ? mousePos : targetEle, popupPlacement, builtinPlacements, popupAlign, onPopupAlign),
      _useAlign2 = (0,slicedToArray/* default */.Z)(_useAlign, 11),
      ready = _useAlign2[0],
      offsetX = _useAlign2[1],
      offsetY = _useAlign2[2],
      offsetR = _useAlign2[3],
      offsetB = _useAlign2[4],
      arrowX = _useAlign2[5],
      arrowY = _useAlign2[6],
      scaleX = _useAlign2[7],
      scaleY = _useAlign2[8],
      alignInfo = _useAlign2[9],
      onAlign = _useAlign2[10];
    var _useAction = useAction(mobile, action, showAction, hideAction),
      _useAction2 = (0,slicedToArray/* default */.Z)(_useAction, 2),
      showActions = _useAction2[0],
      hideActions = _useAction2[1];
    var clickToShow = showActions.has('click');
    var clickToHide = hideActions.has('click') || hideActions.has('contextMenu');
    var triggerAlign = (0,useEvent/* default */.Z)(function () {
      if (!inMotion) {
        onAlign();
      }
    });
    var onScroll = function onScroll() {
      if (openRef.current && alignPoint && clickToHide) {
        triggerOpen(false);
      }
    };
    useWatch(mergedOpen, targetEle, popupEle, triggerAlign, onScroll);
    (0,useLayoutEffect/* default */.Z)(function () {
      triggerAlign();
    }, [mousePos, popupPlacement]);

    // When no builtinPlacements and popupAlign changed
    (0,useLayoutEffect/* default */.Z)(function () {
      if (mergedOpen && !(builtinPlacements !== null && builtinPlacements !== void 0 && builtinPlacements[popupPlacement])) {
        triggerAlign();
      }
    }, [JSON.stringify(popupAlign)]);
    var alignedClassName = react.useMemo(function () {
      var baseClassName = getAlignPopupClassName(builtinPlacements, prefixCls, alignInfo, alignPoint);
      return classnames_default()(baseClassName, getPopupClassNameFromAlign === null || getPopupClassNameFromAlign === void 0 ? void 0 : getPopupClassNameFromAlign(alignInfo));
    }, [alignInfo, getPopupClassNameFromAlign, builtinPlacements, prefixCls, alignPoint]);

    // ============================ Refs ============================
    react.useImperativeHandle(ref, function () {
      return {
        nativeElement: externalForwardRef.current,
        popupElement: externalPopupRef.current,
        forceAlign: triggerAlign
      };
    });

    // ========================== Stretch ===========================
    var _React$useState15 = react.useState(0),
      _React$useState16 = (0,slicedToArray/* default */.Z)(_React$useState15, 2),
      targetWidth = _React$useState16[0],
      setTargetWidth = _React$useState16[1];
    var _React$useState17 = react.useState(0),
      _React$useState18 = (0,slicedToArray/* default */.Z)(_React$useState17, 2),
      targetHeight = _React$useState18[0],
      setTargetHeight = _React$useState18[1];
    var syncTargetSize = function syncTargetSize() {
      if (stretch && targetEle) {
        var rect = targetEle.getBoundingClientRect();
        setTargetWidth(rect.width);
        setTargetHeight(rect.height);
      }
    };
    var onTargetResize = function onTargetResize() {
      syncTargetSize();
      triggerAlign();
    };

    // ========================== Motion ============================
    var onVisibleChanged = function onVisibleChanged(visible) {
      setInMotion(false);
      onAlign();
      afterPopupVisibleChange === null || afterPopupVisibleChange === void 0 || afterPopupVisibleChange(visible);
    };

    // We will trigger align when motion is in prepare
    var onPrepare = function onPrepare() {
      return new Promise(function (resolve) {
        syncTargetSize();
        setMotionPrepareResolve(function () {
          return resolve;
        });
      });
    };
    (0,useLayoutEffect/* default */.Z)(function () {
      if (motionPrepareResolve) {
        onAlign();
        motionPrepareResolve();
        setMotionPrepareResolve(null);
      }
    }, [motionPrepareResolve]);

    // =========================== Action ===========================
    /**
     * Util wrapper for trigger action
     */
    function wrapperAction(eventName, nextOpen, delay, preEvent) {
      cloneProps[eventName] = function (event) {
        var _originChildProps$eve;
        preEvent === null || preEvent === void 0 || preEvent(event);
        triggerOpen(nextOpen, delay);

        // Pass to origin
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        (_originChildProps$eve = originChildProps[eventName]) === null || _originChildProps$eve === void 0 || _originChildProps$eve.call.apply(_originChildProps$eve, [originChildProps, event].concat(args));
      };
    }

    // ======================= Action: Click ========================
    if (clickToShow || clickToHide) {
      cloneProps.onClick = function (event) {
        var _originChildProps$onC;
        if (openRef.current && clickToHide) {
          triggerOpen(false);
        } else if (!openRef.current && clickToShow) {
          setMousePosByEvent(event);
          triggerOpen(true);
        }

        // Pass to origin
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        (_originChildProps$onC = originChildProps.onClick) === null || _originChildProps$onC === void 0 || _originChildProps$onC.call.apply(_originChildProps$onC, [originChildProps, event].concat(args));
      };
    }

    // Click to hide is special action since click popup element should not hide
    var onPopupPointerDown = useWinClick(mergedOpen, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen);

    // ======================= Action: Hover ========================
    var hoverToShow = showActions.has('hover');
    var hoverToHide = hideActions.has('hover');
    var onPopupMouseEnter;
    var onPopupMouseLeave;
    if (hoverToShow) {
      // Compatible with old browser which not support pointer event
      wrapperAction('onMouseEnter', true, mouseEnterDelay, function (event) {
        setMousePosByEvent(event);
      });
      wrapperAction('onPointerEnter', true, mouseEnterDelay, function (event) {
        setMousePosByEvent(event);
      });
      onPopupMouseEnter = function onPopupMouseEnter(event) {
        // Only trigger re-open when popup is visible
        if ((mergedOpen || inMotion) && popupEle !== null && popupEle !== void 0 && popupEle.contains(event.target)) {
          triggerOpen(true, mouseEnterDelay);
        }
      };

      // Align Point
      if (alignPoint) {
        cloneProps.onMouseMove = function (event) {
          var _originChildProps$onM;
          // setMousePosByEvent(event);
          (_originChildProps$onM = originChildProps.onMouseMove) === null || _originChildProps$onM === void 0 || _originChildProps$onM.call(originChildProps, event);
        };
      }
    }
    if (hoverToHide) {
      wrapperAction('onMouseLeave', false, mouseLeaveDelay);
      wrapperAction('onPointerLeave', false, mouseLeaveDelay);
      onPopupMouseLeave = function onPopupMouseLeave() {
        triggerOpen(false, mouseLeaveDelay);
      };
    }

    // ======================= Action: Focus ========================
    if (showActions.has('focus')) {
      wrapperAction('onFocus', true, focusDelay);
    }
    if (hideActions.has('focus')) {
      wrapperAction('onBlur', false, blurDelay);
    }

    // ==================== Action: ContextMenu =====================
    if (showActions.has('contextMenu')) {
      cloneProps.onContextMenu = function (event) {
        var _originChildProps$onC2;
        if (openRef.current && hideActions.has('contextMenu')) {
          triggerOpen(false);
        } else {
          setMousePosByEvent(event);
          triggerOpen(true);
        }
        event.preventDefault();

        // Pass to origin
        for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }
        (_originChildProps$onC2 = originChildProps.onContextMenu) === null || _originChildProps$onC2 === void 0 || _originChildProps$onC2.call.apply(_originChildProps$onC2, [originChildProps, event].concat(args));
      };
    }

    // ========================= ClassName ==========================
    if (className) {
      cloneProps.className = classnames_default()(originChildProps.className, className);
    }

    // ============================ Perf ============================
    var renderedRef = react.useRef(false);
    renderedRef.current || (renderedRef.current = forceRender || mergedOpen || inMotion);

    // =========================== Render ===========================
    var mergedChildrenProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, originChildProps), cloneProps);

    // Pass props into cloneProps for nest usage
    var passedProps = {};
    var passedEventList = ['onContextMenu', 'onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur'];
    passedEventList.forEach(function (eventName) {
      if (restProps[eventName]) {
        passedProps[eventName] = function () {
          var _mergedChildrenProps$;
          for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
          }
          (_mergedChildrenProps$ = mergedChildrenProps[eventName]) === null || _mergedChildrenProps$ === void 0 || _mergedChildrenProps$.call.apply(_mergedChildrenProps$, [mergedChildrenProps].concat(args));
          restProps[eventName].apply(restProps, args);
        };
      }
    });

    // Child Node
    var triggerNode = /*#__PURE__*/react.cloneElement(child, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, mergedChildrenProps), passedProps));
    var arrowPos = {
      x: arrowX,
      y: arrowY
    };
    var innerArrow = arrow ? (0,objectSpread2/* default */.Z)({}, arrow !== true ? arrow : {}) : null;

    // Render
    return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(rc_resize_observer_es/* default */.Z, {
      disabled: !mergedOpen,
      ref: setTargetRef,
      onResize: onTargetResize
    }, /*#__PURE__*/react.createElement(es_TriggerWrapper, {
      getTriggerDOMNode: getTriggerDOMNode
    }, triggerNode)), renderedRef.current && /*#__PURE__*/react.createElement(es_context.Provider, {
      value: context
    }, /*#__PURE__*/react.createElement(es_Popup, {
      portal: PortalComponent,
      ref: setPopupRef,
      prefixCls: prefixCls,
      popup: popup,
      className: classnames_default()(popupClassName, alignedClassName),
      style: popupStyle,
      target: targetEle,
      onMouseEnter: onPopupMouseEnter,
      onMouseLeave: onPopupMouseLeave
      // https://github.com/ant-design/ant-design/issues/43924
      ,

      onPointerEnter: onPopupMouseEnter,
      zIndex: zIndex
      // Open
      ,

      open: mergedOpen,
      keepDom: inMotion,
      fresh: fresh
      // Click
      ,

      onClick: onPopupClick,
      onPointerDownCapture: onPopupPointerDown
      // Mask
      ,

      mask: mask
      // Motion
      ,

      motion: mergePopupMotion,
      maskMotion: mergeMaskMotion,
      onVisibleChanged: onVisibleChanged,
      onPrepare: onPrepare
      // Portal
      ,

      forceRender: forceRender,
      autoDestroy: mergedAutoDestroy,
      getPopupContainer: getPopupContainer
      // Arrow
      ,

      align: alignInfo,
      arrow: innerArrow,
      arrowPos: arrowPos
      // Align
      ,

      ready: ready,
      offsetX: offsetX,
      offsetY: offsetY,
      offsetR: offsetR,
      offsetB: offsetB,
      onAlign: triggerAlign
      // Stretch
      ,

      stretch: stretch,
      targetWidth: targetWidth / scaleX,
      targetHeight: targetHeight / scaleY
    })));
  });
  if (false) {}
  return Trigger;
}
/* harmony default export */ var trigger_es = (generateTrigger(es/* default */.Z));

/***/ }),

/***/ 2249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xC": function() { return /* binding */ configureStore; },
  "hg": function() { return /* binding */ createAsyncThunk; },
  "oM": function() { return /* binding */ createSlice; }
});

// UNUSED EXPORTS: EnhancerArray, MiddlewareArray, SHOULD_AUTOBATCH, TaskAbortError, __DO_NOT_USE__ActionTypes, addListener, applyMiddleware, autoBatchEnhancer, bindActionCreators, clearAllListeners, combineReducers, compose, createAction, createActionCreatorInvariantMiddleware, createDraftSafeSelector, createEntityAdapter, createImmutableStateInvariantMiddleware, createListenerMiddleware, createNextState, createReducer, createSelector, createSerializableStateInvariantMiddleware, createStore, current, findNonSerializableValue, freeze, getDefaultMiddleware, getType, isAction, isActionCreator, isAllOf, isAnyOf, isAsyncThunkAction, isDraft, isFluxStandardAction, isFulfilled, isImmutableDefault, isPending, isPlain, isPlainObject, isRejected, isRejectedWithValue, legacy_createStore, miniSerializeError, nanoid, original, prepareAutoBatched, removeListener, unwrapResult

// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(30606);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
;// CONCATENATED MODULE: ./node_modules/redux/es/redux.js


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};
var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;
  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }
  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);
  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other

  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function kindOf(val) {
  var typeOfVal = typeof val;
  if (false) {}
  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;
  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }
  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }
  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }
    return enhancer(createStore)(reducer, preloadedState);
  }
  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }
  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */

  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }
    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */

  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }
    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }
      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */

  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }
    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }
    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }
    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }
    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */

  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }
    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */

  function observable() {
    var _ref;
    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }
        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }
        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.

  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = (/* unused pure expression or super */ null && (createStore));

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */

  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }
  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }
  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;
  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}
function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });
    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }
    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */

function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];
    if (false) {}
    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;
  if (false) {}
  var shapeAssertionError;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }
  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }
    if (shapeAssertionError) {
      throw shapeAssertionError;
    }
    if (false) { var warningMessage; }
    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */

function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }
  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }
  var boundActionCreators = {};
  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }
  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }
  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);
      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };
      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

;// CONCATENATED MODULE: ./node_modules/redux-thunk/es/index.js
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
      getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual

        return next(action);
      };
    };
  };
  return middleware;
}
var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ var es = (thunk);
;// CONCATENATED MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js
/* provided dependency */ var process = __webpack_require__(554);
var __extends = undefined && undefined.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = undefined && undefined.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
  return to;
};
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function (obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function (a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var _i = 0, _c = __getOwnPropSymbols(b); _i < _c.length; _i++) {
    var prop = _c[_i];
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = function (a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __async = function (__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function (value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = function (value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = function (x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
// src/index.ts




// src/createDraftSafeSelector.ts


var createDraftSafeSelector = function () {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  var selector = createSelector.apply(void 0, args);
  var wrappedSelector = function (value) {
    var rest = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      rest[_i - 1] = arguments[_i];
    }
    return selector.apply(void 0, __spreadArray([isDraft(value) ? current(value) : value], rest));
  };
  return wrappedSelector;
};
// src/configureStore.ts

// src/devtoolsExtension.ts

var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
  if (arguments.length === 0) return void 0;
  if (typeof arguments[0] === "object") return compose;
  return compose.apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function () {
  return function (noop2) {
    return noop2;
  };
};
// src/isPlainObject.ts
function redux_toolkit_esm_isPlainObject(value) {
  if (typeof value !== "object" || value === null) return false;
  var proto = Object.getPrototypeOf(value);
  if (proto === null) return true;
  var baseProto = proto;
  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }
  return proto === baseProto;
}
// src/getDefaultMiddleware.ts

// src/tsHelpers.ts
var hasMatchFunction = function (v) {
  return v && typeof v.match === "function";
};
// src/createAction.ts
function createAction(type, prepareAction) {
  function actionCreator() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (prepareAction) {
      var prepared = prepareAction.apply(void 0, args);
      if (!prepared) {
        throw new Error("prepareAction did not return an object");
      }
      return __spreadValues(__spreadValues({
        type: type,
        payload: prepared.payload
      }, "meta" in prepared && {
        meta: prepared.meta
      }), "error" in prepared && {
        error: prepared.error
      });
    }
    return {
      type: type,
      payload: args[0]
    };
  }
  actionCreator.toString = function () {
    return "" + type;
  };
  actionCreator.type = type;
  actionCreator.match = function (action) {
    return action.type === type;
  };
  return actionCreator;
}
function isAction(action) {
  return redux_toolkit_esm_isPlainObject(action) && "type" in action;
}
function isActionCreator(action) {
  return typeof action === "function" && "type" in action && hasMatchFunction(action);
}
function isFSA(action) {
  return isAction(action) && typeof action.type === "string" && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
  return ["type", "payload", "error", "meta"].indexOf(key) > -1;
}
function getType(actionCreator) {
  return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function getMessage(type) {
  var splitType = type ? ("" + type).split("/") : [];
  var actionName = splitType[splitType.length - 1] || "actionCreator";
  return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function createActionCreatorInvariantMiddleware(options) {
  if (options === void 0) {
    options = {};
  }
  if (true) {
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }
  var _c = options.isActionCreator,
    isActionCreator2 = _c === void 0 ? isActionCreator : _c;
  return function () {
    return function (next) {
      return function (action) {
        if (isActionCreator2(action)) {
          console.warn(getMessage(action.type));
        }
        return next(action);
      };
    };
  };
}
// src/utils.ts

function getTimeMeasureUtils(maxDelay, fnName) {
  var elapsed = 0;
  return {
    measureTime: function (fn) {
      var started = Date.now();
      try {
        return fn();
      } finally {
        var finished = Date.now();
        elapsed += finished - started;
      }
    },
    warnIfExceeded: function () {
      if (elapsed > maxDelay) {
        console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
      }
    }
  };
}
var MiddlewareArray = /** @class */function (_super) {
  __extends(MiddlewareArray, _super);
  function MiddlewareArray() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var _this = _super.apply(this, args) || this;
    Object.setPrototypeOf(_this, MiddlewareArray.prototype);
    return _this;
  }
  Object.defineProperty(MiddlewareArray, Symbol.species, {
    get: function () {
      return MiddlewareArray;
    },
    enumerable: false,
    configurable: true
  });
  MiddlewareArray.prototype.concat = function () {
    var arr = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      arr[_i] = arguments[_i];
    }
    return _super.prototype.concat.apply(this, arr);
  };
  MiddlewareArray.prototype.prepend = function () {
    var arr = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      arr[_i] = arguments[_i];
    }
    if (arr.length === 1 && Array.isArray(arr[0])) {
      return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr[0].concat(this))))();
    }
    return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr.concat(this))))();
  };
  return MiddlewareArray;
}(Array);
var EnhancerArray = /** @class */function (_super) {
  __extends(EnhancerArray, _super);
  function EnhancerArray() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var _this = _super.apply(this, args) || this;
    Object.setPrototypeOf(_this, EnhancerArray.prototype);
    return _this;
  }
  Object.defineProperty(EnhancerArray, Symbol.species, {
    get: function () {
      return EnhancerArray;
    },
    enumerable: false,
    configurable: true
  });
  EnhancerArray.prototype.concat = function () {
    var arr = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      arr[_i] = arguments[_i];
    }
    return _super.prototype.concat.apply(this, arr);
  };
  EnhancerArray.prototype.prepend = function () {
    var arr = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      arr[_i] = arguments[_i];
    }
    if (arr.length === 1 && Array.isArray(arr[0])) {
      return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([void 0], arr[0].concat(this))))();
    }
    return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([void 0], arr.concat(this))))();
  };
  return EnhancerArray;
}(Array);
function freezeDraftable(val) {
  return (0,immer_esm/* isDraftable */.o$)(val) ? (0,immer_esm/* default */.ZP)(val, function () {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var isProduction = (/* unused pure expression or super */ null && ("production" === "production"));
var prefix = "Invariant failed";
function invariant(condition, message) {
  if (condition) {
    return;
  }
  if (isProduction) {
    throw new Error(prefix);
  }
  throw new Error(prefix + ": " + (message || ""));
}
function stringify(obj, serializer, indent, decycler) {
  return JSON.stringify(obj, getSerialize(serializer, decycler), indent);
}
function getSerialize(serializer, decycler) {
  var stack = [],
    keys = [];
  if (!decycler) decycler = function (_, value) {
    if (stack[0] === value) return "[Circular ~]";
    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
  };
  return function (key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
      if (~stack.indexOf(value)) value = decycler.call(this, key, value);
    } else stack.push(value);
    return serializer == null ? value : serializer.call(this, key, value);
  };
}
function isImmutableDefault(value) {
  return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
  var trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
  return {
    detectMutations: function () {
      return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
    }
  };
}
function trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
  if (ignorePaths === void 0) {
    ignorePaths = [];
  }
  if (path === void 0) {
    path = "";
  }
  if (checkedObjects === void 0) {
    checkedObjects = new Set();
  }
  var tracked = {
    value: obj
  };
  if (!isImmutable(obj) && !checkedObjects.has(obj)) {
    checkedObjects.add(obj);
    tracked.children = {};
    for (var key in obj) {
      var childPath = path ? path + "." + key : key;
      if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
        continue;
      }
      tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
    }
  }
  return tracked;
}
function detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
  if (ignoredPaths === void 0) {
    ignoredPaths = [];
  }
  if (sameParentRef === void 0) {
    sameParentRef = false;
  }
  if (path === void 0) {
    path = "";
  }
  var prevObj = trackedProperty ? trackedProperty.value : void 0;
  var sameRef = prevObj === obj;
  if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
    return {
      wasMutated: true,
      path: path
    };
  }
  if (isImmutable(prevObj) || isImmutable(obj)) {
    return {
      wasMutated: false
    };
  }
  var keysToDetect = {};
  for (var key in trackedProperty.children) {
    keysToDetect[key] = true;
  }
  for (var key in obj) {
    keysToDetect[key] = true;
  }
  var hasIgnoredPaths = ignoredPaths.length > 0;
  var _loop_1 = function (key) {
    var nestedPath = path ? path + "." + key : key;
    if (hasIgnoredPaths) {
      var hasMatches = ignoredPaths.some(function (ignored) {
        if (ignored instanceof RegExp) {
          return ignored.test(nestedPath);
        }
        return nestedPath === ignored;
      });
      if (hasMatches) {
        return "continue";
      }
    }
    var result = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
    if (result.wasMutated) {
      return {
        value: result
      };
    }
  };
  for (var key in keysToDetect) {
    var state_1 = _loop_1(key);
    if (typeof state_1 === "object") return state_1.value;
  }
  return {
    wasMutated: false
  };
}
function createImmutableStateInvariantMiddleware(options) {
  if (options === void 0) {
    options = {};
  }
  if (true) {
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }
  var _c = options.isImmutable,
    isImmutable = _c === void 0 ? isImmutableDefault : _c,
    ignoredPaths = options.ignoredPaths,
    _d = options.warnAfter,
    warnAfter = _d === void 0 ? 32 : _d,
    ignore = options.ignore;
  ignoredPaths = ignoredPaths || ignore;
  var track = trackForMutations.bind(null, isImmutable, ignoredPaths);
  return function (_c) {
    var getState = _c.getState;
    var state = getState();
    var tracker = track(state);
    var result;
    return function (next) {
      return function (action) {
        var measureUtils = getTimeMeasureUtils(warnAfter, "ImmutableStateInvariantMiddleware");
        measureUtils.measureTime(function () {
          state = getState();
          result = tracker.detectMutations();
          tracker = track(state);
          invariant(!result.wasMutated, "A state mutation was detected between dispatches, in the path '" + (result.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        });
        var dispatchedAction = next(action);
        measureUtils.measureTime(function () {
          state = getState();
          result = tracker.detectMutations();
          tracker = track(state);
          result.wasMutated && invariant(!result.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (result.path || "") + ". Take a look at the reducer(s) handling the action " + stringify(action) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        });
        measureUtils.warnIfExceeded();
        return dispatchedAction;
      };
    };
  };
}
// src/serializableStateInvariantMiddleware.ts
function isPlain(val) {
  var type = typeof val;
  return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || redux_toolkit_esm_isPlainObject(val);
}
function findNonSerializableValue(value, path, isSerializable, getEntries, ignoredPaths, cache) {
  if (path === void 0) {
    path = "";
  }
  if (isSerializable === void 0) {
    isSerializable = isPlain;
  }
  if (ignoredPaths === void 0) {
    ignoredPaths = [];
  }
  var foundNestedSerializable;
  if (!isSerializable(value)) {
    return {
      keyPath: path || "<root>",
      value: value
    };
  }
  if (typeof value !== "object" || value === null) {
    return false;
  }
  if (cache == null ? void 0 : cache.has(value)) return false;
  var entries = getEntries != null ? getEntries(value) : Object.entries(value);
  var hasIgnoredPaths = ignoredPaths.length > 0;
  var _loop_2 = function (key, nestedValue) {
    var nestedPath = path ? path + "." + key : key;
    if (hasIgnoredPaths) {
      var hasMatches = ignoredPaths.some(function (ignored) {
        if (ignored instanceof RegExp) {
          return ignored.test(nestedPath);
        }
        return nestedPath === ignored;
      });
      if (hasMatches) {
        return "continue";
      }
    }
    if (!isSerializable(nestedValue)) {
      return {
        value: {
          keyPath: nestedPath,
          value: nestedValue
        }
      };
    }
    if (typeof nestedValue === "object") {
      foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
      if (foundNestedSerializable) {
        return {
          value: foundNestedSerializable
        };
      }
    }
  };
  for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
    var _c = entries_1[_i],
      key = _c[0],
      nestedValue = _c[1];
    var state_2 = _loop_2(key, nestedValue);
    if (typeof state_2 === "object") return state_2.value;
  }
  if (cache && isNestedFrozen(value)) cache.add(value);
  return false;
}
function isNestedFrozen(value) {
  if (!Object.isFrozen(value)) return false;
  for (var _i = 0, _c = Object.values(value); _i < _c.length; _i++) {
    var nestedValue = _c[_i];
    if (typeof nestedValue !== "object" || nestedValue === null) continue;
    if (!isNestedFrozen(nestedValue)) return false;
  }
  return true;
}
function createSerializableStateInvariantMiddleware(options) {
  if (options === void 0) {
    options = {};
  }
  if (true) {
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }
  var _c = options.isSerializable,
    isSerializable = _c === void 0 ? isPlain : _c,
    getEntries = options.getEntries,
    _d = options.ignoredActions,
    ignoredActions = _d === void 0 ? [] : _d,
    _e = options.ignoredActionPaths,
    ignoredActionPaths = _e === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : _e,
    _f = options.ignoredPaths,
    ignoredPaths = _f === void 0 ? [] : _f,
    _g = options.warnAfter,
    warnAfter = _g === void 0 ? 32 : _g,
    _h = options.ignoreState,
    ignoreState = _h === void 0 ? false : _h,
    _j = options.ignoreActions,
    ignoreActions = _j === void 0 ? false : _j,
    _k = options.disableCache,
    disableCache = _k === void 0 ? false : _k;
  var cache = !disableCache && WeakSet ? new WeakSet() : void 0;
  return function (storeAPI) {
    return function (next) {
      return function (action) {
        var result = next(action);
        var measureUtils = getTimeMeasureUtils(warnAfter, "SerializableStateInvariantMiddleware");
        if (!ignoreActions && !(ignoredActions.length && ignoredActions.indexOf(action.type) !== -1)) {
          measureUtils.measureTime(function () {
            var foundActionNonSerializableValue = findNonSerializableValue(action, "", isSerializable, getEntries, ignoredActionPaths, cache);
            if (foundActionNonSerializableValue) {
              var keyPath = foundActionNonSerializableValue.keyPath,
                value = foundActionNonSerializableValue.value;
              console.error("A non-serializable value was detected in an action, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the logic that dispatched this action: ", action, "\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)", "\n(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)");
            }
          });
        }
        if (!ignoreState) {
          measureUtils.measureTime(function () {
            var state = storeAPI.getState();
            var foundStateNonSerializableValue = findNonSerializableValue(state, "", isSerializable, getEntries, ignoredPaths, cache);
            if (foundStateNonSerializableValue) {
              var keyPath = foundStateNonSerializableValue.keyPath,
                value = foundStateNonSerializableValue.value;
              console.error("A non-serializable value was detected in the state, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the reducer(s) handling this action type: " + action.type + ".\n(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)");
            }
          });
          measureUtils.warnIfExceeded();
        }
        return result;
      };
    };
  };
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
  return typeof x === "boolean";
}
function curryGetDefaultMiddleware() {
  return function curriedGetDefaultMiddleware(options) {
    return getDefaultMiddleware(options);
  };
}
function getDefaultMiddleware(options) {
  if (options === void 0) {
    options = {};
  }
  var _c = options.thunk,
    thunk = _c === void 0 ? true : _c,
    _d = options.immutableCheck,
    immutableCheck = _d === void 0 ? true : _d,
    _e = options.serializableCheck,
    serializableCheck = _e === void 0 ? true : _e,
    _f = options.actionCreatorCheck,
    actionCreatorCheck = _f === void 0 ? true : _f;
  var middlewareArray = new MiddlewareArray();
  if (thunk) {
    if (isBoolean(thunk)) {
      middlewareArray.push(es);
    } else {
      middlewareArray.push(es.withExtraArgument(thunk.extraArgument));
    }
  }
  if (false) { var actionCreatorOptions, serializableOptions, immutableOptions; }
  return middlewareArray;
}
// src/configureStore.ts
var IS_PRODUCTION = "production" === "production";
function configureStore(options) {
  var curriedGetDefaultMiddleware = curryGetDefaultMiddleware();
  var _c = options || {},
    _d = _c.reducer,
    reducer = _d === void 0 ? void 0 : _d,
    _e = _c.middleware,
    middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e,
    _f = _c.devTools,
    devTools = _f === void 0 ? true : _f,
    _g = _c.preloadedState,
    preloadedState = _g === void 0 ? void 0 : _g,
    _h = _c.enhancers,
    enhancers = _h === void 0 ? void 0 : _h;
  var rootReducer;
  if (typeof reducer === "function") {
    rootReducer = reducer;
  } else if (redux_toolkit_esm_isPlainObject(reducer)) {
    rootReducer = combineReducers(reducer);
  } else {
    throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
  }
  var finalMiddleware = middleware;
  if (typeof finalMiddleware === "function") {
    finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
    if (!IS_PRODUCTION && !Array.isArray(finalMiddleware)) {
      throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
  }
  if (!IS_PRODUCTION && finalMiddleware.some(function (item) {
    return typeof item !== "function";
  })) {
    throw new Error("each middleware provided to configureStore must be a function");
  }
  var middlewareEnhancer = applyMiddleware.apply(void 0, finalMiddleware);
  var finalCompose = compose;
  if (devTools) {
    finalCompose = composeWithDevTools(__spreadValues({
      trace: !IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
  }
  var defaultEnhancers = new EnhancerArray(middlewareEnhancer);
  var storeEnhancers = defaultEnhancers;
  if (Array.isArray(enhancers)) {
    storeEnhancers = __spreadArray([middlewareEnhancer], enhancers);
  } else if (typeof enhancers === "function") {
    storeEnhancers = enhancers(defaultEnhancers);
  }
  var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
  return createStore(rootReducer, preloadedState, composedEnhancer);
}
// src/createReducer.ts

// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
  var actionsMap = {};
  var actionMatchers = [];
  var defaultCaseReducer;
  var builder = {
    addCase: function (typeOrActionCreator, reducer) {
      if (false) {}
      var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
      if (!type) {
        throw new Error("`builder.addCase` cannot be called with an empty action type");
      }
      if (type in actionsMap) {
        throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
      }
      actionsMap[type] = reducer;
      return builder;
    },
    addMatcher: function (matcher, reducer) {
      if (false) {}
      actionMatchers.push({
        matcher: matcher,
        reducer: reducer
      });
      return builder;
    },
    addDefaultCase: function (reducer) {
      if (false) {}
      defaultCaseReducer = reducer;
      return builder;
    }
  };
  builderCallback(builder);
  return [actionsMap, actionMatchers, defaultCaseReducer];
}
// src/createReducer.ts
function isStateFunction(x) {
  return typeof x === "function";
}
var hasWarnedAboutObjectNotation = false;
function createReducer(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
  if (actionMatchers === void 0) {
    actionMatchers = [];
  }
  if (false) {}
  var _c = typeof mapOrBuilderCallback === "function" ? executeReducerBuilderCallback(mapOrBuilderCallback) : [mapOrBuilderCallback, actionMatchers, defaultCaseReducer],
    actionsMap = _c[0],
    finalActionMatchers = _c[1],
    finalDefaultCaseReducer = _c[2];
  var getInitialState;
  if (isStateFunction(initialState)) {
    getInitialState = function () {
      return freezeDraftable(initialState());
    };
  } else {
    var frozenInitialState_1 = freezeDraftable(initialState);
    getInitialState = function () {
      return frozenInitialState_1;
    };
  }
  function reducer(state, action) {
    if (state === void 0) {
      state = getInitialState();
    }
    var caseReducers = __spreadArray([actionsMap[action.type]], finalActionMatchers.filter(function (_c) {
      var matcher = _c.matcher;
      return matcher(action);
    }).map(function (_c) {
      var reducer2 = _c.reducer;
      return reducer2;
    }));
    if (caseReducers.filter(function (cr) {
      return !!cr;
    }).length === 0) {
      caseReducers = [finalDefaultCaseReducer];
    }
    return caseReducers.reduce(function (previousState, caseReducer) {
      if (caseReducer) {
        if ((0,immer_esm/* isDraft */.mv)(previousState)) {
          var draft = previousState;
          var result = caseReducer(draft, action);
          if (result === void 0) {
            return previousState;
          }
          return result;
        } else if (!(0,immer_esm/* isDraftable */.o$)(previousState)) {
          var result = caseReducer(previousState, action);
          if (result === void 0) {
            if (previousState === null) {
              return previousState;
            }
            throw Error("A case reducer on a non-draftable value must not return undefined");
          }
          return result;
        } else {
          return (0,immer_esm/* default */.ZP)(previousState, function (draft) {
            return caseReducer(draft, action);
          });
        }
      }
      return previousState;
    }, state);
  }
  reducer.getInitialState = getInitialState;
  return reducer;
}
// src/createSlice.ts
var hasWarnedAboutObjectNotation2 = false;
function getType2(slice, actionKey) {
  return slice + "/" + actionKey;
}
function createSlice(options) {
  var name = options.name;
  if (!name) {
    throw new Error("`name` is a required option for createSlice");
  }
  if (typeof process !== "undefined" && "production" === "development") {}
  var initialState = typeof options.initialState == "function" ? options.initialState : freezeDraftable(options.initialState);
  var reducers = options.reducers || {};
  var reducerNames = Object.keys(reducers);
  var sliceCaseReducersByName = {};
  var sliceCaseReducersByType = {};
  var actionCreators = {};
  reducerNames.forEach(function (reducerName) {
    var maybeReducerWithPrepare = reducers[reducerName];
    var type = getType2(name, reducerName);
    var caseReducer;
    var prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
      caseReducer = maybeReducerWithPrepare.reducer;
      prepareCallback = maybeReducerWithPrepare.prepare;
    } else {
      caseReducer = maybeReducerWithPrepare;
    }
    sliceCaseReducersByName[reducerName] = caseReducer;
    sliceCaseReducersByType[type] = caseReducer;
    actionCreators[reducerName] = prepareCallback ? createAction(type, prepareCallback) : createAction(type);
  });
  function buildReducer() {
    if (false) {}
    var _c = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers],
      _d = _c[0],
      extraReducers = _d === void 0 ? {} : _d,
      _e = _c[1],
      actionMatchers = _e === void 0 ? [] : _e,
      _f = _c[2],
      defaultCaseReducer = _f === void 0 ? void 0 : _f;
    var finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), sliceCaseReducersByType);
    return createReducer(initialState, function (builder) {
      for (var key in finalCaseReducers) {
        builder.addCase(key, finalCaseReducers[key]);
      }
      for (var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++) {
        var m = actionMatchers_1[_i];
        builder.addMatcher(m.matcher, m.reducer);
      }
      if (defaultCaseReducer) {
        builder.addDefaultCase(defaultCaseReducer);
      }
    });
  }
  var _reducer;
  return {
    name: name,
    reducer: function (state, action) {
      if (!_reducer) _reducer = buildReducer();
      return _reducer(state, action);
    },
    actions: actionCreators,
    caseReducers: sliceCaseReducersByName,
    getInitialState: function () {
      if (!_reducer) _reducer = buildReducer();
      return _reducer.getInitialState();
    }
  };
}
// src/entities/entity_state.ts
function getInitialEntityState() {
  return {
    ids: [],
    entities: {}
  };
}
function createInitialStateFactory() {
  function getInitialState(additionalState) {
    if (additionalState === void 0) {
      additionalState = {};
    }
    return Object.assign(getInitialEntityState(), additionalState);
  }
  return {
    getInitialState: getInitialState
  };
}
// src/entities/state_selectors.ts
function createSelectorsFactory() {
  function getSelectors(selectState) {
    var selectIds = function (state) {
      return state.ids;
    };
    var selectEntities = function (state) {
      return state.entities;
    };
    var selectAll = createDraftSafeSelector(selectIds, selectEntities, function (ids, entities) {
      return ids.map(function (id) {
        return entities[id];
      });
    });
    var selectId = function (_, id) {
      return id;
    };
    var selectById = function (entities, id) {
      return entities[id];
    };
    var selectTotal = createDraftSafeSelector(selectIds, function (ids) {
      return ids.length;
    });
    if (!selectState) {
      return {
        selectIds: selectIds,
        selectEntities: selectEntities,
        selectAll: selectAll,
        selectTotal: selectTotal,
        selectById: createDraftSafeSelector(selectEntities, selectId, selectById)
      };
    }
    var selectGlobalizedEntities = createDraftSafeSelector(selectState, selectEntities);
    return {
      selectIds: createDraftSafeSelector(selectState, selectIds),
      selectEntities: selectGlobalizedEntities,
      selectAll: createDraftSafeSelector(selectState, selectAll),
      selectTotal: createDraftSafeSelector(selectState, selectTotal),
      selectById: createDraftSafeSelector(selectGlobalizedEntities, selectId, selectById)
    };
  }
  return {
    getSelectors: getSelectors
  };
}
// src/entities/state_adapter.ts

function createSingleArgumentStateOperator(mutator) {
  var operator = createStateOperator(function (_, state) {
    return mutator(state);
  });
  return function operation(state) {
    return operator(state, void 0);
  };
}
function createStateOperator(mutator) {
  return function operation(state, arg) {
    function isPayloadActionArgument(arg2) {
      return isFSA(arg2);
    }
    var runMutator = function (draft) {
      if (isPayloadActionArgument(arg)) {
        mutator(arg.payload, draft);
      } else {
        mutator(arg, draft);
      }
    };
    if (isDraft3(state)) {
      runMutator(state);
      return state;
    } else {
      return createNextState3(state, runMutator);
    }
  };
}
// src/entities/utils.ts
function selectIdValue(entity, selectId) {
  var key = selectId(entity);
  if (false) {}
  return key;
}
function ensureEntitiesArray(entities) {
  if (!Array.isArray(entities)) {
    entities = Object.values(entities);
  }
  return entities;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
  newEntities = ensureEntitiesArray(newEntities);
  var added = [];
  var updated = [];
  for (var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++) {
    var entity = newEntities_1[_i];
    var id = selectIdValue(entity, selectId);
    if (id in state.entities) {
      updated.push({
        id: id,
        changes: entity
      });
    } else {
      added.push(entity);
    }
  }
  return [added, updated];
}
// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
  function addOneMutably(entity, state) {
    var key = selectIdValue(entity, selectId);
    if (key in state.entities) {
      return;
    }
    state.ids.push(key);
    state.entities[key] = entity;
  }
  function addManyMutably(newEntities, state) {
    newEntities = ensureEntitiesArray(newEntities);
    for (var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++) {
      var entity = newEntities_2[_i];
      addOneMutably(entity, state);
    }
  }
  function setOneMutably(entity, state) {
    var key = selectIdValue(entity, selectId);
    if (!(key in state.entities)) {
      state.ids.push(key);
    }
    state.entities[key] = entity;
  }
  function setManyMutably(newEntities, state) {
    newEntities = ensureEntitiesArray(newEntities);
    for (var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++) {
      var entity = newEntities_3[_i];
      setOneMutably(entity, state);
    }
  }
  function setAllMutably(newEntities, state) {
    newEntities = ensureEntitiesArray(newEntities);
    state.ids = [];
    state.entities = {};
    addManyMutably(newEntities, state);
  }
  function removeOneMutably(key, state) {
    return removeManyMutably([key], state);
  }
  function removeManyMutably(keys, state) {
    var didMutate = false;
    keys.forEach(function (key) {
      if (key in state.entities) {
        delete state.entities[key];
        didMutate = true;
      }
    });
    if (didMutate) {
      state.ids = state.ids.filter(function (id) {
        return id in state.entities;
      });
    }
  }
  function removeAllMutably(state) {
    Object.assign(state, {
      ids: [],
      entities: {}
    });
  }
  function takeNewKey(keys, update, state) {
    var original2 = state.entities[update.id];
    var updated = Object.assign({}, original2, update.changes);
    var newKey = selectIdValue(updated, selectId);
    var hasNewKey = newKey !== update.id;
    if (hasNewKey) {
      keys[update.id] = newKey;
      delete state.entities[update.id];
    }
    state.entities[newKey] = updated;
    return hasNewKey;
  }
  function updateOneMutably(update, state) {
    return updateManyMutably([update], state);
  }
  function updateManyMutably(updates, state) {
    var newKeys = {};
    var updatesPerEntity = {};
    updates.forEach(function (update) {
      if (update.id in state.entities) {
        updatesPerEntity[update.id] = {
          id: update.id,
          changes: __spreadValues(__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
        };
      }
    });
    updates = Object.values(updatesPerEntity);
    var didMutateEntities = updates.length > 0;
    if (didMutateEntities) {
      var didMutateIds = updates.filter(function (update) {
        return takeNewKey(newKeys, update, state);
      }).length > 0;
      if (didMutateIds) {
        state.ids = Object.keys(state.entities);
      }
    }
  }
  function upsertOneMutably(entity, state) {
    return upsertManyMutably([entity], state);
  }
  function upsertManyMutably(newEntities, state) {
    var _c = splitAddedUpdatedEntities(newEntities, selectId, state),
      added = _c[0],
      updated = _c[1];
    updateManyMutably(updated, state);
    addManyMutably(added, state);
  }
  return {
    removeAll: createSingleArgumentStateOperator(removeAllMutably),
    addOne: createStateOperator(addOneMutably),
    addMany: createStateOperator(addManyMutably),
    setOne: createStateOperator(setOneMutably),
    setMany: createStateOperator(setManyMutably),
    setAll: createStateOperator(setAllMutably),
    updateOne: createStateOperator(updateOneMutably),
    updateMany: createStateOperator(updateManyMutably),
    upsertOne: createStateOperator(upsertOneMutably),
    upsertMany: createStateOperator(upsertManyMutably),
    removeOne: createStateOperator(removeOneMutably),
    removeMany: createStateOperator(removeManyMutably)
  };
}
// src/entities/sorted_state_adapter.ts
function createSortedStateAdapter(selectId, sort) {
  var _c = createUnsortedStateAdapter(selectId),
    removeOne = _c.removeOne,
    removeMany = _c.removeMany,
    removeAll = _c.removeAll;
  function addOneMutably(entity, state) {
    return addManyMutably([entity], state);
  }
  function addManyMutably(newEntities, state) {
    newEntities = ensureEntitiesArray(newEntities);
    var models = newEntities.filter(function (model) {
      return !(selectIdValue(model, selectId) in state.entities);
    });
    if (models.length !== 0) {
      merge(models, state);
    }
  }
  function setOneMutably(entity, state) {
    return setManyMutably([entity], state);
  }
  function setManyMutably(newEntities, state) {
    newEntities = ensureEntitiesArray(newEntities);
    if (newEntities.length !== 0) {
      merge(newEntities, state);
    }
  }
  function setAllMutably(newEntities, state) {
    newEntities = ensureEntitiesArray(newEntities);
    state.entities = {};
    state.ids = [];
    addManyMutably(newEntities, state);
  }
  function updateOneMutably(update, state) {
    return updateManyMutably([update], state);
  }
  function updateManyMutably(updates, state) {
    var appliedUpdates = false;
    for (var _i = 0, updates_1 = updates; _i < updates_1.length; _i++) {
      var update = updates_1[_i];
      var entity = state.entities[update.id];
      if (!entity) {
        continue;
      }
      appliedUpdates = true;
      Object.assign(entity, update.changes);
      var newId = selectId(entity);
      if (update.id !== newId) {
        delete state.entities[update.id];
        state.entities[newId] = entity;
      }
    }
    if (appliedUpdates) {
      resortEntities(state);
    }
  }
  function upsertOneMutably(entity, state) {
    return upsertManyMutably([entity], state);
  }
  function upsertManyMutably(newEntities, state) {
    var _c = splitAddedUpdatedEntities(newEntities, selectId, state),
      added = _c[0],
      updated = _c[1];
    updateManyMutably(updated, state);
    addManyMutably(added, state);
  }
  function areArraysEqual(a, b) {
    if (a.length !== b.length) {
      return false;
    }
    for (var i = 0; i < a.length && i < b.length; i++) {
      if (a[i] === b[i]) {
        continue;
      }
      return false;
    }
    return true;
  }
  function merge(models, state) {
    models.forEach(function (model) {
      state.entities[selectId(model)] = model;
    });
    resortEntities(state);
  }
  function resortEntities(state) {
    var allEntities = Object.values(state.entities);
    allEntities.sort(sort);
    var newSortedIds = allEntities.map(selectId);
    var ids = state.ids;
    if (!areArraysEqual(ids, newSortedIds)) {
      state.ids = newSortedIds;
    }
  }
  return {
    removeOne: removeOne,
    removeMany: removeMany,
    removeAll: removeAll,
    addOne: createStateOperator(addOneMutably),
    updateOne: createStateOperator(updateOneMutably),
    upsertOne: createStateOperator(upsertOneMutably),
    setOne: createStateOperator(setOneMutably),
    setMany: createStateOperator(setManyMutably),
    setAll: createStateOperator(setAllMutably),
    addMany: createStateOperator(addManyMutably),
    updateMany: createStateOperator(updateManyMutably),
    upsertMany: createStateOperator(upsertManyMutably)
  };
}
// src/entities/create_adapter.ts
function createEntityAdapter(options) {
  if (options === void 0) {
    options = {};
  }
  var _c = __spreadValues({
      sortComparer: false,
      selectId: function (instance) {
        return instance.id;
      }
    }, options),
    selectId = _c.selectId,
    sortComparer = _c.sortComparer;
  var stateFactory = createInitialStateFactory();
  var selectorsFactory = createSelectorsFactory();
  var stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
  return __spreadValues(__spreadValues(__spreadValues({
    selectId: selectId,
    sortComparer: sortComparer
  }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = function (size) {
  if (size === void 0) {
    size = 21;
  }
  var id = "";
  var i = size;
  while (i--) {
    id += urlAlphabet[Math.random() * 64 | 0];
  }
  return id;
};
// src/createAsyncThunk.ts
var commonProperties = ["name", "message", "stack", "code"];
var RejectWithValue = /** @class */function () {
  function RejectWithValue(payload, meta) {
    this.payload = payload;
    this.meta = meta;
  }
  return RejectWithValue;
}();
var FulfillWithMeta = /** @class */function () {
  function FulfillWithMeta(payload, meta) {
    this.payload = payload;
    this.meta = meta;
  }
  return FulfillWithMeta;
}();
var miniSerializeError = function (value) {
  if (typeof value === "object" && value !== null) {
    var simpleError = {};
    for (var _i = 0, commonProperties_1 = commonProperties; _i < commonProperties_1.length; _i++) {
      var property = commonProperties_1[_i];
      if (typeof value[property] === "string") {
        simpleError[property] = value[property];
      }
    }
    return simpleError;
  }
  return {
    message: String(value)
  };
};
var createAsyncThunk = function () {
  function createAsyncThunk2(typePrefix, payloadCreator, options) {
    var fulfilled = createAction(typePrefix + "/fulfilled", function (payload, requestId, arg, meta) {
      return {
        payload: payload,
        meta: __spreadProps(__spreadValues({}, meta || {}), {
          arg: arg,
          requestId: requestId,
          requestStatus: "fulfilled"
        })
      };
    });
    var pending = createAction(typePrefix + "/pending", function (requestId, arg, meta) {
      return {
        payload: void 0,
        meta: __spreadProps(__spreadValues({}, meta || {}), {
          arg: arg,
          requestId: requestId,
          requestStatus: "pending"
        })
      };
    });
    var rejected = createAction(typePrefix + "/rejected", function (error, requestId, arg, payload, meta) {
      return {
        payload: payload,
        error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
        meta: __spreadProps(__spreadValues({}, meta || {}), {
          arg: arg,
          requestId: requestId,
          rejectedWithValue: !!payload,
          requestStatus: "rejected",
          aborted: (error == null ? void 0 : error.name) === "AbortError",
          condition: (error == null ? void 0 : error.name) === "ConditionError"
        })
      };
    });
    var displayedWarning = false;
    var AC = typeof AbortController !== "undefined" ? AbortController : (/** @class */function () {
      function class_1() {
        this.signal = {
          aborted: false,
          addEventListener: function () {},
          dispatchEvent: function () {
            return false;
          },
          onabort: function () {},
          removeEventListener: function () {},
          reason: void 0,
          throwIfAborted: function () {}
        };
      }
      class_1.prototype.abort = function () {
        if (false) {}
      };
      return class_1;
    }());
    function actionCreator(arg) {
      return function (dispatch, getState, extra) {
        var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
        var abortController = new AC();
        var abortReason;
        var started = false;
        function abort(reason) {
          abortReason = reason;
          abortController.abort();
        }
        var promise2 = function () {
          return __async(this, null, function () {
            var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
            return __generator(this, function (_c) {
              switch (_c.label) {
                case 0:
                  _c.trys.push([0, 4,, 5]);
                  conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                    getState: getState,
                    extra: extra
                  });
                  if (!isThenable(conditionResult)) return [3 /*break*/, 2];
                  return [4 /*yield*/, conditionResult];
                case 1:
                  conditionResult = _c.sent();
                  _c.label = 2;
                case 2:
                  if (conditionResult === false || abortController.signal.aborted) {
                    throw {
                      name: "ConditionError",
                      message: "Aborted due to condition callback returning false."
                    };
                  }
                  started = true;
                  abortedPromise = new Promise(function (_, reject) {
                    return abortController.signal.addEventListener("abort", function () {
                      return reject({
                        name: "AbortError",
                        message: abortReason || "Aborted"
                      });
                    });
                  });
                  dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                    requestId: requestId,
                    arg: arg
                  }, {
                    getState: getState,
                    extra: extra
                  })));
                  return [4 /*yield*/, Promise.race([abortedPromise, Promise.resolve(payloadCreator(arg, {
                    dispatch: dispatch,
                    getState: getState,
                    extra: extra,
                    requestId: requestId,
                    signal: abortController.signal,
                    abort: abort,
                    rejectWithValue: function (value, meta) {
                      return new RejectWithValue(value, meta);
                    },
                    fulfillWithValue: function (value, meta) {
                      return new FulfillWithMeta(value, meta);
                    }
                  })).then(function (result) {
                    if (result instanceof RejectWithValue) {
                      throw result;
                    }
                    if (result instanceof FulfillWithMeta) {
                      return fulfilled(result.payload, requestId, arg, result.meta);
                    }
                    return fulfilled(result, requestId, arg);
                  })])];
                case 3:
                  finalAction = _c.sent();
                  return [3 /*break*/, 5];
                case 4:
                  err_1 = _c.sent();
                  finalAction = err_1 instanceof RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                  return [3 /*break*/, 5];
                case 5:
                  skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                  if (!skipDispatch) {
                    dispatch(finalAction);
                  }
                  return [2 /*return*/, finalAction];
              }
            });
          });
        }();
        return Object.assign(promise2, {
          abort: abort,
          requestId: requestId,
          arg: arg,
          unwrap: function () {
            return promise2.then(unwrapResult);
          }
        });
      };
    }
    return Object.assign(actionCreator, {
      pending: pending,
      rejected: rejected,
      fulfilled: fulfilled,
      typePrefix: typePrefix
    });
  }
  createAsyncThunk2.withTypes = function () {
    return createAsyncThunk2;
  };
  return createAsyncThunk2;
}();
function unwrapResult(action) {
  if (action.meta && action.meta.rejectedWithValue) {
    throw action.payload;
  }
  if (action.error) {
    throw action.error;
  }
  return action.payload;
}
function isThenable(value) {
  return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var matches = function (matcher, action) {
  if (hasMatchFunction(matcher)) {
    return matcher.match(action);
  } else {
    return matcher(action);
  }
};
function isAnyOf() {
  var matchers = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    matchers[_i] = arguments[_i];
  }
  return function (action) {
    return matchers.some(function (matcher) {
      return matches(matcher, action);
    });
  };
}
function isAllOf() {
  var matchers = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    matchers[_i] = arguments[_i];
  }
  return function (action) {
    return matchers.every(function (matcher) {
      return matches(matcher, action);
    });
  };
}
function hasExpectedRequestMetadata(action, validStatus) {
  if (!action || !action.meta) return false;
  var hasValidRequestId = typeof action.meta.requestId === "string";
  var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
  return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
  return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending() {
  var asyncThunks = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    asyncThunks[_i] = arguments[_i];
  }
  if (asyncThunks.length === 0) {
    return function (action) {
      return hasExpectedRequestMetadata(action, ["pending"]);
    };
  }
  if (!isAsyncThunkArray(asyncThunks)) {
    return isPending()(asyncThunks[0]);
  }
  return function (action) {
    var matchers = asyncThunks.map(function (asyncThunk) {
      return asyncThunk.pending;
    });
    var combinedMatcher = isAnyOf.apply(void 0, matchers);
    return combinedMatcher(action);
  };
}
function isRejected() {
  var asyncThunks = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    asyncThunks[_i] = arguments[_i];
  }
  if (asyncThunks.length === 0) {
    return function (action) {
      return hasExpectedRequestMetadata(action, ["rejected"]);
    };
  }
  if (!isAsyncThunkArray(asyncThunks)) {
    return isRejected()(asyncThunks[0]);
  }
  return function (action) {
    var matchers = asyncThunks.map(function (asyncThunk) {
      return asyncThunk.rejected;
    });
    var combinedMatcher = isAnyOf.apply(void 0, matchers);
    return combinedMatcher(action);
  };
}
function isRejectedWithValue() {
  var asyncThunks = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    asyncThunks[_i] = arguments[_i];
  }
  var hasFlag = function (action) {
    return action && action.meta && action.meta.rejectedWithValue;
  };
  if (asyncThunks.length === 0) {
    return function (action) {
      var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
      return combinedMatcher(action);
    };
  }
  if (!isAsyncThunkArray(asyncThunks)) {
    return isRejectedWithValue()(asyncThunks[0]);
  }
  return function (action) {
    var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
    return combinedMatcher(action);
  };
}
function isFulfilled() {
  var asyncThunks = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    asyncThunks[_i] = arguments[_i];
  }
  if (asyncThunks.length === 0) {
    return function (action) {
      return hasExpectedRequestMetadata(action, ["fulfilled"]);
    };
  }
  if (!isAsyncThunkArray(asyncThunks)) {
    return isFulfilled()(asyncThunks[0]);
  }
  return function (action) {
    var matchers = asyncThunks.map(function (asyncThunk) {
      return asyncThunk.fulfilled;
    });
    var combinedMatcher = isAnyOf.apply(void 0, matchers);
    return combinedMatcher(action);
  };
}
function isAsyncThunkAction() {
  var asyncThunks = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    asyncThunks[_i] = arguments[_i];
  }
  if (asyncThunks.length === 0) {
    return function (action) {
      return hasExpectedRequestMetadata(action, ["pending", "fulfilled", "rejected"]);
    };
  }
  if (!isAsyncThunkArray(asyncThunks)) {
    return isAsyncThunkAction()(asyncThunks[0]);
  }
  return function (action) {
    var matchers = [];
    for (var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++) {
      var asyncThunk = asyncThunks_1[_i];
      matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
    }
    var combinedMatcher = isAnyOf.apply(void 0, matchers);
    return combinedMatcher(action);
  };
}
// src/listenerMiddleware/utils.ts
var assertFunction = function (func, expected) {
  if (typeof func !== "function") {
    throw new TypeError(expected + " is not a function");
  }
};
var noop = function () {};
var catchRejection = function (promise2, onError) {
  if (onError === void 0) {
    onError = noop;
  }
  promise2.catch(onError);
  return promise2;
};
var addAbortSignalListener = function (abortSignal, callback) {
  abortSignal.addEventListener("abort", callback, {
    once: true
  });
  return function () {
    return abortSignal.removeEventListener("abort", callback);
  };
};
var abortControllerWithReason = function (abortController, reason) {
  var signal = abortController.signal;
  if (signal.aborted) {
    return;
  }
  if (!("reason" in signal)) {
    Object.defineProperty(signal, "reason", {
      enumerable: true,
      value: reason,
      configurable: true,
      writable: true
    });
  }
  ;
  abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = "task-" + cancelled;
var taskCompleted = "task-" + completed;
var listenerCancelled = listener + "-" + cancelled;
var listenerCompleted = listener + "-" + completed;
var TaskAbortError = /** @class */function () {
  function TaskAbortError(code) {
    this.code = code;
    this.name = "TaskAbortError";
    this.message = task + " " + cancelled + " (reason: " + code + ")";
  }
  return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var validateActive = function (signal) {
  if (signal.aborted) {
    throw new TaskAbortError(signal.reason);
  }
};
function raceWithSignal(signal, promise2) {
  var cleanup = noop;
  return new Promise(function (resolve, reject) {
    var notifyRejection = function () {
      return reject(new TaskAbortError(signal.reason));
    };
    if (signal.aborted) {
      notifyRejection();
      return;
    }
    cleanup = addAbortSignalListener(signal, notifyRejection);
    promise2.finally(function () {
      return cleanup();
    }).then(resolve, reject);
  }).finally(function () {
    cleanup = noop;
  });
}
var runTask = function (task2, cleanUp) {
  return __async(void 0, null, function () {
    var value, error_1;
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _c.trys.push([0, 3, 4, 5]);
          return [4 /*yield*/, Promise.resolve()];
        case 1:
          _c.sent();
          return [4 /*yield*/, task2()];
        case 2:
          value = _c.sent();
          return [2 /*return*/, {
            status: "ok",
            value: value
          }];
        case 3:
          error_1 = _c.sent();
          return [2 /*return*/, {
            status: error_1 instanceof TaskAbortError ? "cancelled" : "rejected",
            error: error_1
          }];
        case 4:
          cleanUp == null ? void 0 : cleanUp();
          return [7 /*endfinally*/];
        case 5:
          return [2 /*return*/];
      }
    });
  });
};
var createPause = function (signal) {
  return function (promise2) {
    return catchRejection(raceWithSignal(signal, promise2).then(function (output) {
      validateActive(signal);
      return output;
    }));
  };
};
var createDelay = function (signal) {
  var pause = createPause(signal);
  return function (timeoutMs) {
    return pause(new Promise(function (resolve) {
      return setTimeout(resolve, timeoutMs);
    }));
  };
};
// src/listenerMiddleware/index.ts
var redux_toolkit_esm_assign = Object.assign;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = function (parentAbortSignal, parentBlockingPromises) {
  var linkControllers = function (controller) {
    return addAbortSignalListener(parentAbortSignal, function () {
      return abortControllerWithReason(controller, parentAbortSignal.reason);
    });
  };
  return function (taskExecutor, opts) {
    assertFunction(taskExecutor, "taskExecutor");
    var childAbortController = new AbortController();
    linkControllers(childAbortController);
    var result = runTask(function () {
      return __async(void 0, null, function () {
        var result2;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              validateActive(parentAbortSignal);
              validateActive(childAbortController.signal);
              return [4 /*yield*/, taskExecutor({
                pause: createPause(childAbortController.signal),
                delay: createDelay(childAbortController.signal),
                signal: childAbortController.signal
              })];
            case 1:
              result2 = _c.sent();
              validateActive(childAbortController.signal);
              return [2 /*return*/, result2];
          }
        });
      });
    }, function () {
      return abortControllerWithReason(childAbortController, taskCompleted);
    });
    if (opts == null ? void 0 : opts.autoJoin) {
      parentBlockingPromises.push(result);
    }
    return {
      result: createPause(parentAbortSignal)(result),
      cancel: function () {
        abortControllerWithReason(childAbortController, taskCancelled);
      }
    };
  };
};
var createTakePattern = function (startListening, signal) {
  var take = function (predicate, timeout) {
    return __async(void 0, null, function () {
      var unsubscribe, tuplePromise, promises, output;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            validateActive(signal);
            unsubscribe = function () {};
            tuplePromise = new Promise(function (resolve, reject) {
              var stopListening = startListening({
                predicate: predicate,
                effect: function (action, listenerApi) {
                  listenerApi.unsubscribe();
                  resolve([action, listenerApi.getState(), listenerApi.getOriginalState()]);
                }
              });
              unsubscribe = function () {
                stopListening();
                reject();
              };
            });
            promises = [tuplePromise];
            if (timeout != null) {
              promises.push(new Promise(function (resolve) {
                return setTimeout(resolve, timeout, null);
              }));
            }
            _c.label = 1;
          case 1:
            _c.trys.push([1,, 3, 4]);
            return [4 /*yield*/, raceWithSignal(signal, Promise.race(promises))];
          case 2:
            output = _c.sent();
            validateActive(signal);
            return [2 /*return*/, output];
          case 3:
            unsubscribe();
            return [7 /*endfinally*/];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  return function (predicate, timeout) {
    return catchRejection(take(predicate, timeout));
  };
};
var getListenerEntryPropsFrom = function (options) {
  var type = options.type,
    actionCreator = options.actionCreator,
    matcher = options.matcher,
    predicate = options.predicate,
    effect = options.effect;
  if (type) {
    predicate = createAction(type).match;
  } else if (actionCreator) {
    type = actionCreator.type;
    predicate = actionCreator.match;
  } else if (matcher) {
    predicate = matcher;
  } else if (predicate) {} else {
    throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
  }
  assertFunction(effect, "options.listener");
  return {
    predicate: predicate,
    type: type,
    effect: effect
  };
};
var createListenerEntry = function (options) {
  var _c = getListenerEntryPropsFrom(options),
    type = _c.type,
    predicate = _c.predicate,
    effect = _c.effect;
  var id = nanoid();
  var entry = {
    id: id,
    effect: effect,
    type: type,
    predicate: predicate,
    pending: new Set(),
    unsubscribe: function () {
      throw new Error("Unsubscribe not initialized");
    }
  };
  return entry;
};
var cancelActiveListeners = function (entry) {
  entry.pending.forEach(function (controller) {
    abortControllerWithReason(controller, listenerCancelled);
  });
};
var createClearListenerMiddleware = function (listenerMap) {
  return function () {
    listenerMap.forEach(cancelActiveListeners);
    listenerMap.clear();
  };
};
var safelyNotifyError = function (errorHandler, errorToNotify, errorInfo) {
  try {
    errorHandler(errorToNotify, errorInfo);
  } catch (errorHandlerError) {
    setTimeout(function () {
      throw errorHandlerError;
    }, 0);
  }
};
var addListener = createAction(alm + "/add");
var clearAllListeners = createAction(alm + "/removeAll");
var removeListener = createAction(alm + "/remove");
var defaultErrorHandler = function () {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  console.error.apply(console, __spreadArray([alm + "/error"], args));
};
function createListenerMiddleware(middlewareOptions) {
  var _this = this;
  if (middlewareOptions === void 0) {
    middlewareOptions = {};
  }
  var listenerMap = new Map();
  var extra = middlewareOptions.extra,
    _c = middlewareOptions.onError,
    onError = _c === void 0 ? defaultErrorHandler : _c;
  assertFunction(onError, "onError");
  var insertEntry = function (entry) {
    entry.unsubscribe = function () {
      return listenerMap.delete(entry.id);
    };
    listenerMap.set(entry.id, entry);
    return function (cancelOptions) {
      entry.unsubscribe();
      if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) {
        cancelActiveListeners(entry);
      }
    };
  };
  var findListenerEntry = function (comparator) {
    for (var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++) {
      var entry = _c[_i];
      if (comparator(entry)) {
        return entry;
      }
    }
    return void 0;
  };
  var startListening = function (options) {
    var entry = findListenerEntry(function (existingEntry) {
      return existingEntry.effect === options.effect;
    });
    if (!entry) {
      entry = createListenerEntry(options);
    }
    return insertEntry(entry);
  };
  var stopListening = function (options) {
    var _c = getListenerEntryPropsFrom(options),
      type = _c.type,
      effect = _c.effect,
      predicate = _c.predicate;
    var entry = findListenerEntry(function (entry2) {
      var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
      return matchPredicateOrType && entry2.effect === effect;
    });
    if (entry) {
      entry.unsubscribe();
      if (options.cancelActive) {
        cancelActiveListeners(entry);
      }
    }
    return !!entry;
  };
  var notifyListener = function (entry, action, api, getOriginalState) {
    return __async(_this, null, function () {
      var internalTaskController, take, autoJoinPromises, listenerError_1;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            internalTaskController = new AbortController();
            take = createTakePattern(startListening, internalTaskController.signal);
            autoJoinPromises = [];
            _c.label = 1;
          case 1:
            _c.trys.push([1, 3, 4, 6]);
            entry.pending.add(internalTaskController);
            return [4 /*yield*/, Promise.resolve(entry.effect(action, redux_toolkit_esm_assign({}, api, {
              getOriginalState: getOriginalState,
              condition: function (predicate, timeout) {
                return take(predicate, timeout).then(Boolean);
              },
              take: take,
              delay: createDelay(internalTaskController.signal),
              pause: createPause(internalTaskController.signal),
              extra: extra,
              signal: internalTaskController.signal,
              fork: createFork(internalTaskController.signal, autoJoinPromises),
              unsubscribe: entry.unsubscribe,
              subscribe: function () {
                listenerMap.set(entry.id, entry);
              },
              cancelActiveListeners: function () {
                entry.pending.forEach(function (controller, _, set) {
                  if (controller !== internalTaskController) {
                    abortControllerWithReason(controller, listenerCancelled);
                    set.delete(controller);
                  }
                });
              }
            })))];
          case 2:
            _c.sent();
            return [3 /*break*/, 6];
          case 3:
            listenerError_1 = _c.sent();
            if (!(listenerError_1 instanceof TaskAbortError)) {
              safelyNotifyError(onError, listenerError_1, {
                raisedBy: "effect"
              });
            }
            return [3 /*break*/, 6];
          case 4:
            return [4 /*yield*/, Promise.allSettled(autoJoinPromises)];
          case 5:
            _c.sent();
            abortControllerWithReason(internalTaskController, listenerCompleted);
            entry.pending.delete(internalTaskController);
            return [7 /*endfinally*/];
          case 6:
            return [2 /*return*/];
        }
      });
    });
  };
  var clearListenerMiddleware = createClearListenerMiddleware(listenerMap);
  var middleware = function (api) {
    return function (next) {
      return function (action) {
        if (!isAction(action)) {
          return next(action);
        }
        if (addListener.match(action)) {
          return startListening(action.payload);
        }
        if (clearAllListeners.match(action)) {
          clearListenerMiddleware();
          return;
        }
        if (removeListener.match(action)) {
          return stopListening(action.payload);
        }
        var originalState = api.getState();
        var getOriginalState = function () {
          if (originalState === INTERNAL_NIL_TOKEN) {
            throw new Error(alm + ": getOriginalState can only be called synchronously");
          }
          return originalState;
        };
        var result;
        try {
          result = next(action);
          if (listenerMap.size > 0) {
            var currentState = api.getState();
            var listenerEntries = Array.from(listenerMap.values());
            for (var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++) {
              var entry = listenerEntries_1[_i];
              var runListener = false;
              try {
                runListener = entry.predicate(action, currentState, originalState);
              } catch (predicateError) {
                runListener = false;
                safelyNotifyError(onError, predicateError, {
                  raisedBy: "predicate"
                });
              }
              if (!runListener) {
                continue;
              }
              notifyListener(entry, action, api, getOriginalState);
            }
          }
        } finally {
          originalState = INTERNAL_NIL_TOKEN;
        }
        return result;
      };
    };
  };
  return {
    middleware: middleware,
    startListening: startListening,
    stopListening: stopListening,
    clearListeners: clearListenerMiddleware
  };
}
// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var prepareAutoBatched = function () {
  return function (payload) {
    var _c;
    return {
      payload: payload,
      meta: (_c = {}, _c[SHOULD_AUTOBATCH] = true, _c)
    };
  };
};
var promise;
var queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof __webpack_require__.g !== "undefined" ? __webpack_require__.g : globalThis) : function (cb) {
  return (promise || (promise = Promise.resolve())).then(cb).catch(function (err) {
    return setTimeout(function () {
      throw err;
    }, 0);
  });
};
var createQueueWithTimer = function (timeout) {
  return function (notify) {
    setTimeout(notify, timeout);
  };
};
var rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10);
var autoBatchEnhancer = function (options) {
  if (options === void 0) {
    options = {
      type: "raf"
    };
  }
  return function (next) {
    return function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var store = next.apply(void 0, args);
      var notifying = true;
      var shouldNotifyAtEndOfTick = false;
      var notificationQueued = false;
      var listeners = new Set();
      var queueCallback = options.type === "tick" ? queueMicrotaskShim : options.type === "raf" ? rAF : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
      var notifyListeners = function () {
        notificationQueued = false;
        if (shouldNotifyAtEndOfTick) {
          shouldNotifyAtEndOfTick = false;
          listeners.forEach(function (l) {
            return l();
          });
        }
      };
      return Object.assign({}, store, {
        subscribe: function (listener2) {
          var wrappedListener = function () {
            return notifying && listener2();
          };
          var unsubscribe = store.subscribe(wrappedListener);
          listeners.add(listener2);
          return function () {
            unsubscribe();
            listeners.delete(listener2);
          };
        },
        dispatch: function (action) {
          var _a;
          try {
            notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[SHOULD_AUTOBATCH]);
            shouldNotifyAtEndOfTick = !notifying;
            if (shouldNotifyAtEndOfTick) {
              if (!notificationQueued) {
                notificationQueued = true;
                queueCallback(notifyListeners);
              }
            }
            return store.dispatch(action);
          } finally {
            notifying = true;
          }
        }
      });
    };
  };
};
// src/index.ts
(0,immer_esm/* enableES5 */.pV)();


/***/ }),

/***/ 51677:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),

/***/ 32973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var _form_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9234);
/* harmony import */ var _space_Compact__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38625);
"use client";




const ContextIsolator = props => {
  const {
    space,
    form,
    children
  } = props;
  if (children === undefined || children === null) {
    return null;
  }
  let result = children;
  if (form) {
    result = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_form_context__WEBPACK_IMPORTED_MODULE_1__/* .NoFormStyle */ .Ux, {
      override: true,
      status: true
    }, result);
  }
  if (space) {
    result = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_space_Compact__WEBPACK_IMPORTED_MODULE_2__/* .NoCompactStyle */ .BR, null, result);
  }
  return result;
};
/* harmony default export */ __webpack_exports__["Z"] = (ContextIsolator);

/***/ }),

/***/ 68083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ withPureRenderTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var rc_util_es_hooks_useMergedState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78877);
/* harmony import */ var _config_provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73898);
/* harmony import */ var _config_provider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94980);
"use client";




function withPureRenderTheme(Component) {
  return props => (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_config_provider__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    theme: {
      token: {
        motion: false,
        zIndexPopupBase: 0
      }
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, Object.assign({}, props))));
}
/* istanbul ignore next */
const genPurePanel = (Component, alignPropName, postProps, defaultPrefixCls, getDropdownCls) => {
  const PurePanel = props => {
    const {
      prefixCls: customizePrefixCls,
      style
    } = props;
    const holderRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
    const [popupHeight, setPopupHeight] = react__WEBPACK_IMPORTED_MODULE_0__.useState(0);
    const [popupWidth, setPopupWidth] = react__WEBPACK_IMPORTED_MODULE_0__.useState(0);
    const [open, setOpen] = (0,rc_util_es_hooks_useMergedState__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(false, {
      value: props.open
    });
    const {
      getPrefixCls
    } = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_config_provider__WEBPACK_IMPORTED_MODULE_3__/* .ConfigContext */ .E_);
    const prefixCls = getPrefixCls(defaultPrefixCls || 'select', customizePrefixCls);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
      // We do not care about ssr
      setOpen(true);
      if (typeof ResizeObserver !== 'undefined') {
        const resizeObserver = new ResizeObserver(entries => {
          const element = entries[0].target;
          setPopupHeight(element.offsetHeight + 8);
          setPopupWidth(element.offsetWidth);
        });
        const interval = setInterval(() => {
          var _a;
          const dropdownCls = getDropdownCls ? `.${getDropdownCls(prefixCls)}` : `.${prefixCls}-dropdown`;
          const popup = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(dropdownCls);
          if (popup) {
            clearInterval(interval);
            resizeObserver.observe(popup);
          }
        }, 10);
        return () => {
          clearInterval(interval);
          resizeObserver.disconnect();
        };
      }
    }, []);
    let mergedProps = Object.assign(Object.assign({}, props), {
      style: Object.assign(Object.assign({}, style), {
        margin: 0
      }),
      open,
      visible: open,
      getPopupContainer: () => holderRef.current
    });
    if (postProps) {
      mergedProps = postProps(mergedProps);
    }
    if (alignPropName) {
      Object.assign(mergedProps, {
        [alignPropName]: {
          overflow: {
            adjustX: false,
            adjustY: false
          }
        }
      });
    }
    const mergedStyle = {
      paddingBottom: popupHeight,
      position: 'relative',
      minWidth: popupWidth
    };
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      ref: holderRef,
      style: mergedStyle
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, Object.assign({}, mergedProps)));
  };
  return withPureRenderTheme(PurePanel);
};
/* harmony default export */ __webpack_exports__["Z"] = (genPurePanel);

/***/ }),

/***/ 708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o2": function() { return /* binding */ isPresetColor; },
/* harmony export */   "yT": function() { return /* binding */ isPresetStatusColor; }
/* harmony export */ });
/* unused harmony export PresetStatusColorTypes */
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83889);
/* harmony import */ var _theme_interface__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26822);


const inverseColors = _theme_interface__WEBPACK_IMPORTED_MODULE_0__/* .PresetColors.map */ .i.map(color => `${color}-inverse`);
const PresetStatusColorTypes = ['success', 'processing', 'error', 'default', 'warning'];
/**
 * determine if the color keyword belongs to the `Ant Design` {@link PresetColors}.
 * @param color color to be judged
 * @param includeInverse whether to include reversed colors
 */
function isPresetColor(color, includeInverse = true) {
  if (includeInverse) {
    return [].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(inverseColors), (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_theme_interface__WEBPACK_IMPORTED_MODULE_0__/* .PresetColors */ .i)).includes(color);
  }
  return _theme_interface__WEBPACK_IMPORTED_MODULE_0__/* .PresetColors.includes */ .i.includes(color);
}
function isPresetStatusColor(color) {
  return PresetStatusColorTypes.includes(color);
}

/***/ }),

/***/ 66932:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function mergeProps(...items) {
  const ret = {};
  items.forEach(item => {
    if (item) {
      Object.keys(item).forEach(key => {
        if (item[key] !== undefined) {
          ret[key] = item[key];
        }
      });
    }
  });
  return ret;
}
/* harmony default export */ __webpack_exports__["Z"] = (mergeProps);

/***/ }),

/***/ 59111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useClosable; },
/* harmony export */   "w": function() { return /* binding */ pickClosable; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var _ant_design_icons_es_icons_CloseOutlined__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27289);
/* harmony import */ var rc_util_es_pickAttrs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75844);
/* harmony import */ var _locale__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69999);
/* harmony import */ var _locale_en_US__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72380);
/* harmony import */ var _extendsObject__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66932);
"use client";







function pickClosable(context) {
  if (!context) {
    return undefined;
  }
  const {
    closable,
    closeIcon
  } = context;
  return {
    closable,
    closeIcon
  };
}
/** Convert `closable` and `closeIcon` to config object */
function useClosableConfig(closableCollection) {
  const {
    closable,
    closeIcon
  } = closableCollection || {};
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (
    // If `closable`, whatever rest be should be true
    !closable && (closable === false || closeIcon === false || closeIcon === null)) {
      return false;
    }
    if (closable === undefined && closeIcon === undefined) {
      return null;
    }
    let closableConfig = {
      closeIcon: typeof closeIcon !== 'boolean' && closeIcon !== null ? closeIcon : undefined
    };
    if (closable && typeof closable === 'object') {
      closableConfig = Object.assign(Object.assign({}, closableConfig), closable);
    }
    return closableConfig;
  }, [closable, closeIcon]);
}
/** Use same object to support `useMemo` optimization */
const EmptyFallbackCloseCollection = {};
function useClosable(propCloseCollection, contextCloseCollection, fallbackCloseCollection = EmptyFallbackCloseCollection) {
  // Align the `props`, `context` `fallback` to config object first
  const propCloseConfig = useClosableConfig(propCloseCollection);
  const contextCloseConfig = useClosableConfig(contextCloseCollection);
  const [contextLocale] = (0,_locale__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)('global', _locale_en_US__WEBPACK_IMPORTED_MODULE_3__/* ["default"].global */ .Z.global);
  const closeBtnIsDisabled = typeof propCloseConfig !== 'boolean' ? !!(propCloseConfig === null || propCloseConfig === void 0 ? void 0 : propCloseConfig.disabled) : false;
  const mergedFallbackCloseCollection = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => Object.assign({
    closeIcon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ant_design_icons_es_icons_CloseOutlined__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, null)
  }, fallbackCloseCollection), [fallbackCloseCollection]);
  // Use fallback logic to fill the config
  const mergedClosableConfig = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    // ================ Props First ================
    // Skip if prop is disabled
    if (propCloseConfig === false) {
      return false;
    }
    if (propCloseConfig) {
      return (0,_extendsObject__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(mergedFallbackCloseCollection, contextCloseConfig, propCloseConfig);
    }
    // =============== Context Second ==============
    // Skip if context is disabled
    if (contextCloseConfig === false) {
      return false;
    }
    if (contextCloseConfig) {
      return (0,_extendsObject__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(mergedFallbackCloseCollection, contextCloseConfig);
    }
    // ============= Fallback Default ==============
    return !mergedFallbackCloseCollection.closable ? false : mergedFallbackCloseCollection;
  }, [propCloseConfig, contextCloseConfig, mergedFallbackCloseCollection]);
  // Calculate the final closeIcon
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    var _a, _b;
    if (mergedClosableConfig === false) {
      return [false, null, closeBtnIsDisabled, {}];
    }
    const {
      closeIconRender
    } = mergedFallbackCloseCollection;
    const {
      closeIcon
    } = mergedClosableConfig;
    let mergedCloseIcon = closeIcon;
    // Wrap the closeIcon with aria props
    const ariaOrDataProps = (0,rc_util_es_pickAttrs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(mergedClosableConfig, true);
    if (mergedCloseIcon !== null && mergedCloseIcon !== undefined) {
      // Wrap the closeIcon if needed
      if (closeIconRender) {
        mergedCloseIcon = closeIconRender(closeIcon);
      }
      mergedCloseIcon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(mergedCloseIcon) ? (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(mergedCloseIcon, Object.assign(Object.assign(Object.assign({}, mergedCloseIcon.props), {
        'aria-label': (_b = (_a = mergedCloseIcon.props) === null || _a === void 0 ? void 0 : _a['aria-label']) !== null && _b !== void 0 ? _b : contextLocale.close
      }), ariaOrDataProps))) : (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", Object.assign({
        "aria-label": contextLocale.close
      }, ariaOrDataProps), mergedCloseIcon));
    }
    return [true, mergedCloseIcon, closeBtnIsDisabled, ariaOrDataProps];
  }, [mergedClosableConfig, mergedFallbackCloseCollection]);
}

/***/ }),

/***/ 74215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useForceUpdate; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);

function useForceUpdate() {
  const [, forceUpdate] = react__WEBPACK_IMPORTED_MODULE_0__.useReducer(x => x + 1, 0);
  return forceUpdate;
}

/***/ }),

/***/ 5884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cn": function() { return /* binding */ useZIndex; },
/* harmony export */   "u6": function() { return /* binding */ CONTAINER_MAX_OFFSET; }
/* harmony export */ });
/* unused harmony exports containerBaseZIndexOffset, consumerBaseZIndexOffset */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var _theme_useToken__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39779);
/* harmony import */ var _zindexContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85720);




// Z-Index control range
// Container: 1000 + offset 100 (max base + 10 * offset = 2000)
// Popover: offset 50
// Notification: Container Max zIndex + componentOffset
const CONTAINER_OFFSET = 100;
const CONTAINER_OFFSET_MAX_COUNT = 10;
const CONTAINER_MAX_OFFSET = CONTAINER_OFFSET * CONTAINER_OFFSET_MAX_COUNT;
/**
 * Static function will default be the `CONTAINER_MAX_OFFSET`.
 * But it still may have children component like Select, Dropdown.
 * So the warning zIndex should exceed the `CONTAINER_MAX_OFFSET`.
 */
const CONTAINER_MAX_OFFSET_WITH_CHILDREN = CONTAINER_MAX_OFFSET + CONTAINER_OFFSET;
const containerBaseZIndexOffset = {
  Modal: CONTAINER_OFFSET,
  Drawer: CONTAINER_OFFSET,
  Popover: CONTAINER_OFFSET,
  Popconfirm: CONTAINER_OFFSET,
  Tooltip: CONTAINER_OFFSET,
  Tour: CONTAINER_OFFSET,
  FloatButton: CONTAINER_OFFSET
};
const consumerBaseZIndexOffset = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function isContainerType(type) {
  return type in containerBaseZIndexOffset;
}
const useZIndex = (componentType, customZIndex) => {
  const [, token] = (0,_theme_useToken__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)();
  const parentZIndex = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_zindexContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
  const isContainer = isContainerType(componentType);
  let result;
  if (customZIndex !== undefined) {
    result = [customZIndex, customZIndex];
  } else {
    let zIndex = parentZIndex !== null && parentZIndex !== void 0 ? parentZIndex : 0;
    if (isContainer) {
      zIndex +=
      // Use preset token zIndex by default but not stack when has parent container
      (parentZIndex ? 0 : token.zIndexPopupBase) +
      // Container offset
      containerBaseZIndexOffset[componentType];
    } else {
      zIndex += consumerBaseZIndexOffset[componentType];
    }
    result = [parentZIndex === undefined ? customZIndex : zIndex, zIndex];
  }
  if (false) {}
  return result;
};

/***/ }),

/***/ 2608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ removeMediaQueryListener; },
/* harmony export */   "x": function() { return /* binding */ addMediaQueryListener; }
/* harmony export */ });
const addMediaQueryListener = (mql, handler) => {
  // Don't delete here, please keep the code compatible
  if (typeof (mql === null || mql === void 0 ? void 0 : mql.addEventListener) !== 'undefined') {
    mql.addEventListener('change', handler);
  } else if (typeof (mql === null || mql === void 0 ? void 0 : mql.addListener) !== 'undefined') {
    mql.addListener(handler);
  }
};
const removeMediaQueryListener = (mql, handler) => {
  // Don't delete here, please keep the code compatible
  if (typeof (mql === null || mql === void 0 ? void 0 : mql.removeEventListener) !== 'undefined') {
    mql.removeEventListener('change', handler);
  } else if (typeof (mql === null || mql === void 0 ? void 0 : mql.removeListener) !== 'undefined') {
    mql.removeListener(handler);
  }
};

/***/ }),

/***/ 19405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ getTransitionName; }
/* harmony export */ });
/* harmony import */ var _config_provider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94980);

// ================== Collapse Motion ==================
const getCollapsedHeight = () => ({
  height: 0,
  opacity: 0
});
const getRealHeight = node => {
  const {
    scrollHeight
  } = node;
  return {
    height: scrollHeight,
    opacity: 1
  };
};
const getCurrentHeight = node => ({
  height: node ? node.offsetHeight : 0
});
const skipOpacityTransition = (_, event) => (event === null || event === void 0 ? void 0 : event.deadline) === true || event.propertyName === 'height';
const initCollapseMotion = (rootCls = _config_provider__WEBPACK_IMPORTED_MODULE_0__/* .defaultPrefixCls */ .Rf) => ({
  motionName: `${rootCls}-motion-collapse`,
  onAppearStart: getCollapsedHeight,
  onEnterStart: getCollapsedHeight,
  onAppearActive: getRealHeight,
  onEnterActive: getRealHeight,
  onLeaveStart: getCurrentHeight,
  onLeaveActive: getCollapsedHeight,
  onAppearEnd: skipOpacityTransition,
  onEnterEnd: skipOpacityTransition,
  onLeaveEnd: skipOpacityTransition,
  motionDeadline: 500
});
const _SelectPlacements = (/* unused pure expression or super */ null && (['bottomLeft', 'bottomRight', 'topLeft', 'topRight']));
const getTransitionName = (rootPrefixCls, motion, transitionName) => {
  if (transitionName !== undefined) {
    return transitionName;
  }
  return `${rootPrefixCls}-${motion}`;
};

/* harmony default export */ __webpack_exports__["Z"] = (initCollapseMotion);

/***/ }),

/***/ 78130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getPlacements; }
/* harmony export */ });
/* unused harmony export getOverflowOptions */
/* harmony import */ var _style_placementArrow__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33294);

function getOverflowOptions(placement, arrowOffset, arrowWidth, autoAdjustOverflow) {
  if (autoAdjustOverflow === false) {
    return {
      adjustX: false,
      adjustY: false
    };
  }
  const overflow = autoAdjustOverflow && typeof autoAdjustOverflow === 'object' ? autoAdjustOverflow : {};
  const baseOverflow = {};
  switch (placement) {
    case 'top':
    case 'bottom':
      baseOverflow.shiftX = arrowOffset.arrowOffsetHorizontal * 2 + arrowWidth;
      baseOverflow.shiftY = true;
      baseOverflow.adjustY = true;
      break;
    case 'left':
    case 'right':
      baseOverflow.shiftY = arrowOffset.arrowOffsetVertical * 2 + arrowWidth;
      baseOverflow.shiftX = true;
      baseOverflow.adjustX = true;
      break;
  }
  const mergedOverflow = Object.assign(Object.assign({}, baseOverflow), overflow);
  // Support auto shift
  if (!mergedOverflow.shiftX) {
    mergedOverflow.adjustX = true;
  }
  if (!mergedOverflow.shiftY) {
    mergedOverflow.adjustY = true;
  }
  return mergedOverflow;
}
const PlacementAlignMap = {
  left: {
    points: ['cr', 'cl']
  },
  right: {
    points: ['cl', 'cr']
  },
  top: {
    points: ['bc', 'tc']
  },
  bottom: {
    points: ['tc', 'bc']
  },
  topLeft: {
    points: ['bl', 'tl']
  },
  leftTop: {
    points: ['tr', 'tl']
  },
  topRight: {
    points: ['br', 'tr']
  },
  rightTop: {
    points: ['tl', 'tr']
  },
  bottomRight: {
    points: ['tr', 'br']
  },
  rightBottom: {
    points: ['bl', 'br']
  },
  bottomLeft: {
    points: ['tl', 'bl']
  },
  leftBottom: {
    points: ['br', 'bl']
  }
};
const ArrowCenterPlacementAlignMap = {
  topLeft: {
    points: ['bl', 'tc']
  },
  leftTop: {
    points: ['tr', 'cl']
  },
  topRight: {
    points: ['br', 'tc']
  },
  rightTop: {
    points: ['tl', 'cr']
  },
  bottomRight: {
    points: ['tr', 'bc']
  },
  rightBottom: {
    points: ['bl', 'cr']
  },
  bottomLeft: {
    points: ['tl', 'bc']
  },
  leftBottom: {
    points: ['br', 'cl']
  }
};
const DisableAutoArrowList = new Set(['topLeft', 'topRight', 'bottomLeft', 'bottomRight', 'leftTop', 'leftBottom', 'rightTop', 'rightBottom']);
function getPlacements(config) {
  const {
    arrowWidth,
    autoAdjustOverflow,
    arrowPointAtCenter,
    offset,
    borderRadius,
    visibleFirst
  } = config;
  const halfArrowWidth = arrowWidth / 2;
  const placementMap = {};
  // Dynamic offset
  const arrowOffset = (0,_style_placementArrow__WEBPACK_IMPORTED_MODULE_0__/* .getArrowOffsetToken */ .wZ)({
    contentRadius: borderRadius,
    limitVerticalRadius: true
  });
  Object.keys(PlacementAlignMap).forEach(key => {
    const template = arrowPointAtCenter && ArrowCenterPlacementAlignMap[key] || PlacementAlignMap[key];
    const placementInfo = Object.assign(Object.assign({}, template), {
      offset: [0, 0],
      dynamicInset: true
    });
    placementMap[key] = placementInfo;
    // Disable autoArrow since design is fixed position
    if (DisableAutoArrowList.has(key)) {
      placementInfo.autoArrow = false;
    }
    // Static offset
    switch (key) {
      case 'top':
      case 'topLeft':
      case 'topRight':
        placementInfo.offset[1] = -halfArrowWidth - offset;
        break;
      case 'bottom':
      case 'bottomLeft':
      case 'bottomRight':
        placementInfo.offset[1] = halfArrowWidth + offset;
        break;
      case 'left':
      case 'leftTop':
      case 'leftBottom':
        placementInfo.offset[0] = -halfArrowWidth - offset;
        break;
      case 'right':
      case 'rightTop':
      case 'rightBottom':
        placementInfo.offset[0] = halfArrowWidth + offset;
        break;
    }
    if (arrowPointAtCenter) {
      switch (key) {
        case 'topLeft':
        case 'bottomLeft':
          placementInfo.offset[0] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
          break;
        case 'topRight':
        case 'bottomRight':
          placementInfo.offset[0] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
          break;
        case 'leftTop':
        case 'rightTop':
          placementInfo.offset[1] = -arrowOffset.arrowOffsetHorizontal * 2 + halfArrowWidth;
          break;
        case 'leftBottom':
        case 'rightBottom':
          placementInfo.offset[1] = arrowOffset.arrowOffsetHorizontal * 2 - halfArrowWidth;
          break;
      }
    }
    // Overflow
    placementInfo.overflow = getOverflowOptions(key, arrowOffset, arrowWidth, autoAdjustOverflow);
    // VisibleFirst
    if (visibleFirst) {
      placementInfo.htmlRegion = 'visibleFirst';
    }
  });
  return placementMap;
}

/***/ }),

/***/ 81730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M2": function() { return /* binding */ isFragment; },
/* harmony export */   "Tm": function() { return /* binding */ cloneElement; },
/* harmony export */   "wm": function() { return /* binding */ replaceElement; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);

function isFragment(child) {
  return child && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child) && child.type === react__WEBPACK_IMPORTED_MODULE_0__.Fragment;
}
const replaceElement = (element, replacement, props) => {
  if (! /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(element)) {
    return replacement;
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(element, typeof props === 'function' ? props(element.props || {}) : props);
};
function cloneElement(element, props) {
  return replaceElement(element, element, props);
}

/***/ }),

/***/ 81840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c4": function() { return /* binding */ responsiveArray; }
/* harmony export */ });
/* unused harmony export matchScreen */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var _theme_internal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39779);
/* harmony import */ var _mediaQueryUtil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2608);



const responsiveArray = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
const getResponsiveMap = token => ({
  xs: `(max-width: ${token.screenXSMax}px)`,
  sm: `(min-width: ${token.screenSM}px)`,
  md: `(min-width: ${token.screenMD}px)`,
  lg: `(min-width: ${token.screenLG}px)`,
  xl: `(min-width: ${token.screenXL}px)`,
  xxl: `(min-width: ${token.screenXXL}px)`
});
/**
 * Ensures that the breakpoints token are valid, in good order
 * For each breakpoint : screenMin <= screen <= screenMax and screenMax <= nextScreenMin
 */
const validateBreakpoints = token => {
  const indexableToken = token;
  const revBreakpoints = [].concat(responsiveArray).reverse();
  revBreakpoints.forEach((breakpoint, i) => {
    const breakpointUpper = breakpoint.toUpperCase();
    const screenMin = `screen${breakpointUpper}Min`;
    const screen = `screen${breakpointUpper}`;
    if (!(indexableToken[screenMin] <= indexableToken[screen])) {
      throw new Error(`${screenMin}<=${screen} fails : !(${indexableToken[screenMin]}<=${indexableToken[screen]})`);
    }
    if (i < revBreakpoints.length - 1) {
      const screenMax = `screen${breakpointUpper}Max`;
      if (!(indexableToken[screen] <= indexableToken[screenMax])) {
        throw new Error(`${screen}<=${screenMax} fails : !(${indexableToken[screen]}<=${indexableToken[screenMax]})`);
      }
      const nextBreakpointUpperMin = revBreakpoints[i + 1].toUpperCase();
      const nextScreenMin = `screen${nextBreakpointUpperMin}Min`;
      if (!(indexableToken[screenMax] <= indexableToken[nextScreenMin])) {
        throw new Error(`${screenMax}<=${nextScreenMin} fails : !(${indexableToken[screenMax]}<=${indexableToken[nextScreenMin]})`);
      }
    }
  });
  return token;
};
const matchScreen = (screens, screenSizes) => {
  if (!screenSizes) {
    return;
  }
  for (const breakpoint of responsiveArray) {
    if (screens[breakpoint] && (screenSizes === null || screenSizes === void 0 ? void 0 : screenSizes[breakpoint]) !== undefined) {
      return screenSizes[breakpoint];
    }
  }
};
const useResponsiveObserver = () => {
  const [, token] = (0,_theme_internal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)();
  const responsiveMap = getResponsiveMap(validateBreakpoints(token));
  // To avoid repeat create instance, we add `useMemo` here.
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    const subscribers = new Map();
    let subUid = -1;
    let screens = {};
    return {
      responsiveMap,
      matchHandlers: {},
      dispatch(pointMap) {
        screens = pointMap;
        subscribers.forEach(func => func(screens));
        return subscribers.size >= 1;
      },
      subscribe(func) {
        if (!subscribers.size) {
          this.register();
        }
        subUid += 1;
        subscribers.set(subUid, func);
        func(screens);
        return subUid;
      },
      unsubscribe(paramToken) {
        subscribers.delete(paramToken);
        if (!subscribers.size) {
          this.unregister();
        }
      },
      register() {
        Object.entries(responsiveMap).forEach(([screen, mediaQuery]) => {
          const listener = ({
            matches
          }) => {
            this.dispatch(Object.assign(Object.assign({}, screens), {
              [screen]: matches
            }));
          };
          const mql = window.matchMedia(mediaQuery);
          (0,_mediaQueryUtil__WEBPACK_IMPORTED_MODULE_2__/* .addMediaQueryListener */ .x)(mql, listener);
          this.matchHandlers[mediaQuery] = {
            mql,
            listener
          };
          listener(mql);
        });
      },
      unregister() {
        Object.values(responsiveMap).forEach(mediaQuery => {
          const handler = this.matchHandlers[mediaQuery];
          (0,_mediaQueryUtil__WEBPACK_IMPORTED_MODULE_2__/* .removeMediaQueryListener */ .h)(handler === null || handler === void 0 ? void 0 : handler.mql, handler === null || handler === void 0 ? void 0 : handler.listener);
        });
        subscribers.clear();
      }
    };
  }, [token]);
};
/* harmony default export */ __webpack_exports__["ZP"] = (useResponsiveObserver);

/***/ }),

/***/ 85251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G8": function() { return /* binding */ WarningContext; },
/* harmony export */   "ln": function() { return /* binding */ devUseWarning; }
/* harmony export */ });
/* unused harmony exports noop, resetWarned */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var rc_util_es_warning__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13764);


function noop() {}
let deprecatedWarnList = null;
function resetWarned() {
  deprecatedWarnList = null;
  rcResetWarned();
}
let _warning = (/* unused pure expression or super */ null && (noop));
if (false) {}
const warning = (/* unused pure expression or super */ null && (_warning));
const WarningContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
/**
 * This is a hook but we not named as `useWarning`
 * since this is only used in development.
 * We should always wrap this in `if (process.env.NODE_ENV !== 'production')` condition
 */
const devUseWarning =  false ? 0 : () => {
  const noopWarning = () => {};
  noopWarning.deprecated = noop;
  return noopWarning;
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (warning)));

/***/ }),

/***/ 14742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ wave; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/isVisible.js
var isVisible = __webpack_require__(29504);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(99195);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js
var context = __webpack_require__(94980);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/reactNode.js
var reactNode = __webpack_require__(81730);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/util/genStyleUtils.js
var genStyleUtils = __webpack_require__(18511);
;// CONCATENATED MODULE: ./node_modules/antd/es/_util/wave/style.js

const genWaveStyle = token => {
  const {
    componentCls,
    colorPrimary
  } = token;
  return {
    [componentCls]: {
      position: 'absolute',
      background: 'transparent',
      pointerEvents: 'none',
      boxSizing: 'border-box',
      color: `var(--wave-color, ${colorPrimary})`,
      boxShadow: `0 0 0 0 currentcolor`,
      opacity: 0.2,
      // =================== Motion ===================
      '&.wave-motion-appear': {
        transition: [`box-shadow 0.4s ${token.motionEaseOutCirc}`, `opacity 2s ${token.motionEaseOutCirc}`].join(','),
        '&-active': {
          boxShadow: `0 0 0 6px currentcolor`,
          opacity: 0
        },
        '&.wave-quick': {
          transition: [`box-shadow ${token.motionDurationSlow} ${token.motionEaseInOut}`, `opacity ${token.motionDurationSlow} ${token.motionEaseInOut}`].join(',')
        }
      }
    }
  };
};
/* harmony default export */ var style = ((0,genStyleUtils/* genComponentStyleHook */.A1)('Wave', genWaveStyle));
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useEvent.js
var useEvent = __webpack_require__(47789);
// EXTERNAL MODULE: ./node_modules/rc-util/es/raf.js
var raf = __webpack_require__(13157);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/useToken.js + 3 modules
var useToken = __webpack_require__(39779);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/wave/interface.js
var wave_interface = __webpack_require__(82306);
// EXTERNAL MODULE: ./node_modules/rc-motion/es/index.js + 13 modules
var es = __webpack_require__(26981);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/UnstableContext.js
var UnstableContext = __webpack_require__(96093);
;// CONCATENATED MODULE: ./node_modules/antd/es/_util/wave/util.js
function isValidWaveColor(color) {
  return color && color !== '#fff' && color !== '#ffffff' && color !== 'rgb(255, 255, 255)' && color !== 'rgba(255, 255, 255, 1)' && !/rgba\((?:\d*, ){3}0\)/.test(color) &&
  // any transparent rgba color
  color !== 'transparent' && color !== 'canvastext';
}
function getTargetWaveColor(node) {
  const {
    borderTopColor,
    borderColor,
    backgroundColor
  } = getComputedStyle(node);
  if (isValidWaveColor(borderTopColor)) {
    return borderTopColor;
  }
  if (isValidWaveColor(borderColor)) {
    return borderColor;
  }
  if (isValidWaveColor(backgroundColor)) {
    return backgroundColor;
  }
  return null;
}
;// CONCATENATED MODULE: ./node_modules/antd/es/_util/wave/WaveEffect.js
"use client";









function validateNum(value) {
  return Number.isNaN(value) ? 0 : value;
}
const WaveEffect = props => {
  const {
    className,
    target,
    component,
    registerUnmount
  } = props;
  const divRef = react.useRef(null);
  // ====================== Refs ======================
  const unmountRef = react.useRef(null);
  react.useEffect(() => {
    unmountRef.current = registerUnmount();
  }, []);
  // ===================== Effect =====================
  const [color, setWaveColor] = react.useState(null);
  const [borderRadius, setBorderRadius] = react.useState([]);
  const [left, setLeft] = react.useState(0);
  const [top, setTop] = react.useState(0);
  const [width, setWidth] = react.useState(0);
  const [height, setHeight] = react.useState(0);
  const [enabled, setEnabled] = react.useState(false);
  const waveStyle = {
    left,
    top,
    width,
    height,
    borderRadius: borderRadius.map(radius => `${radius}px`).join(' ')
  };
  if (color) {
    waveStyle['--wave-color'] = color;
  }
  function syncPos() {
    const nodeStyle = getComputedStyle(target);
    // Get wave color from target
    setWaveColor(getTargetWaveColor(target));
    const isStatic = nodeStyle.position === 'static';
    // Rect
    const {
      borderLeftWidth,
      borderTopWidth
    } = nodeStyle;
    setLeft(isStatic ? target.offsetLeft : validateNum(-parseFloat(borderLeftWidth)));
    setTop(isStatic ? target.offsetTop : validateNum(-parseFloat(borderTopWidth)));
    setWidth(target.offsetWidth);
    setHeight(target.offsetHeight);
    // Get border radius
    const {
      borderTopLeftRadius,
      borderTopRightRadius,
      borderBottomLeftRadius,
      borderBottomRightRadius
    } = nodeStyle;
    setBorderRadius([borderTopLeftRadius, borderTopRightRadius, borderBottomRightRadius, borderBottomLeftRadius].map(radius => validateNum(parseFloat(radius))));
  }
  react.useEffect(() => {
    if (target) {
      // We need delay to check position here
      // since UI may change after click
      const id = (0,raf/* default */.Z)(() => {
        syncPos();
        setEnabled(true);
      });
      // Add resize observer to follow size
      let resizeObserver;
      if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(syncPos);
        resizeObserver.observe(target);
      }
      return () => {
        raf/* default.cancel */.Z.cancel(id);
        resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.disconnect();
      };
    }
  }, []);
  if (!enabled) {
    return null;
  }
  const isSmallComponent = (component === 'Checkbox' || component === 'Radio') && (target === null || target === void 0 ? void 0 : target.classList.contains(wave_interface/* TARGET_CLS */.A));
  return /*#__PURE__*/react.createElement(es/* default */.ZP, {
    visible: true,
    motionAppear: true,
    motionName: "wave-motion",
    motionDeadline: 5000,
    onAppearEnd: (_, event) => {
      var _a, _b;
      if (event.deadline || event.propertyName === 'opacity') {
        const holder = (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
        (_b = unmountRef.current) === null || _b === void 0 ? void 0 : _b.call(unmountRef).then(() => {
          holder === null || holder === void 0 ? void 0 : holder.remove();
        });
      }
      return false;
    }
  }, ({
    className: motionClassName
  }, ref) => (/*#__PURE__*/react.createElement("div", {
    ref: (0,es_ref/* composeRef */.sQ)(divRef, ref),
    className: classnames_default()(className, motionClassName, {
      'wave-quick': isSmallComponent
    }),
    style: waveStyle
  })));
};
const showWaveEffect = (target, info) => {
  var _a;
  const {
    component
  } = info;
  // Skip for unchecked checkbox
  if (component === 'Checkbox' && !((_a = target.querySelector('input')) === null || _a === void 0 ? void 0 : _a.checked)) {
    return;
  }
  // Create holder
  const holder = document.createElement('div');
  holder.style.position = 'absolute';
  holder.style.left = '0px';
  holder.style.top = '0px';
  target === null || target === void 0 ? void 0 : target.insertBefore(holder, target === null || target === void 0 ? void 0 : target.firstChild);
  const reactRender = (0,UnstableContext/* unstableSetRender */.q)();
  let unmountCallback = null;
  function registerUnmount() {
    return unmountCallback;
  }
  unmountCallback = reactRender(/*#__PURE__*/react.createElement(WaveEffect, Object.assign({}, info, {
    target: target,
    registerUnmount: registerUnmount
  })), holder);
};
/* harmony default export */ var wave_WaveEffect = (showWaveEffect);
;// CONCATENATED MODULE: ./node_modules/antd/es/_util/wave/useWave.js







const useWave = (nodeRef, className, component) => {
  const {
    wave
  } = react.useContext(context/* ConfigContext */.E_);
  const [, token, hashId] = (0,useToken/* default */.ZP)();
  const showWave = (0,useEvent/* default */.Z)(event => {
    const node = nodeRef.current;
    if ((wave === null || wave === void 0 ? void 0 : wave.disabled) || !node) {
      return;
    }
    const targetNode = node.querySelector(`.${wave_interface/* TARGET_CLS */.A}`) || node;
    const {
      showEffect
    } = wave || {};
    // Customize wave effect
    (showEffect || wave_WaveEffect)(targetNode, {
      className,
      token,
      component,
      event,
      hashId
    });
  });
  const rafId = react.useRef(null);
  // Merge trigger event into one for each frame
  const showDebounceWave = event => {
    raf/* default.cancel */.Z.cancel(rafId.current);
    rafId.current = (0,raf/* default */.Z)(() => {
      showWave(event);
    });
  };
  return showDebounceWave;
};
/* harmony default export */ var wave_useWave = (useWave);
;// CONCATENATED MODULE: ./node_modules/antd/es/_util/wave/index.js








const Wave = props => {
  const {
    children,
    disabled,
    component
  } = props;
  const {
    getPrefixCls
  } = (0,react.useContext)(context/* ConfigContext */.E_);
  const containerRef = (0,react.useRef)(null);
  // ============================== Style ===============================
  const prefixCls = getPrefixCls('wave');
  const [, hashId] = style(prefixCls);
  // =============================== Wave ===============================
  const showWave = wave_useWave(containerRef, classnames_default()(prefixCls, hashId), component);
  // ============================== Effect ==============================
  react.useEffect(() => {
    const node = containerRef.current;
    if (!node || node.nodeType !== 1 || disabled) {
      return;
    }
    // Click handler
    const onClick = e => {
      // Fix radio button click twice
      if (!(0,isVisible/* default */.Z)(e.target) ||
      // No need wave
      !node.getAttribute || node.getAttribute('disabled') || node.disabled || node.className.includes('disabled') || node.className.includes('-leave')) {
        return;
      }
      showWave(e);
    };
    // Bind events
    node.addEventListener('click', onClick, true);
    return () => {
      node.removeEventListener('click', onClick, true);
    };
  }, [disabled]);
  // ============================== Render ==============================
  if (! /*#__PURE__*/react.isValidElement(children)) {
    return children !== null && children !== void 0 ? children : null;
  }
  const ref = (0,es_ref/* supportRef */.Yr)(children) ? (0,es_ref/* composeRef */.sQ)((0,es_ref/* getNodeRef */.C4)(children), containerRef) : containerRef;
  return (0,reactNode/* cloneElement */.Tm)(children, {
    ref
  });
};
if (false) {}
/* harmony default export */ var wave = (Wave);

/***/ }),

/***/ 82306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TARGET_CLS; }
/* harmony export */ });
/* harmony import */ var _config_provider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94980);

const TARGET_CLS = `${_config_provider__WEBPACK_IMPORTED_MODULE_0__/* .defaultPrefixCls */ .Rf}-wave-target`;

/***/ }),

/***/ 85720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);

const zIndexContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);
if (false) {}
/* harmony default export */ __webpack_exports__["Z"] = (zIndexContext);

/***/ }),

/***/ 54179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dn": function() { return /* binding */ isUnBorderedButtonVariant; },
/* harmony export */   "aG": function() { return /* binding */ isTwoCNChar; },
/* harmony export */   "hU": function() { return /* binding */ spaceChildren; },
/* harmony export */   "nx": function() { return /* binding */ convertLegacyProps; }
/* harmony export */ });
/* unused harmony exports isString, _ButtonVariantTypes, _ButtonColorTypes */
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83889);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var _util_reactNode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81730);
/* harmony import */ var _theme_interface__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26822);
"use client";





const rxTwoCNChar = /^[\u4E00-\u9FA5]{2}$/;
const isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function convertLegacyProps(type) {
  if (type === 'danger') {
    return {
      danger: true
    };
  }
  return {
    type
  };
}
function isString(str) {
  return typeof str === 'string';
}
function isUnBorderedButtonVariant(type) {
  return type === 'text' || type === 'link';
}
function splitCNCharsBySpace(child, needInserted) {
  if (child === null || child === undefined) {
    return;
  }
  const SPACE = needInserted ? ' ' : '';
  if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
    return (0,_util_reactNode__WEBPACK_IMPORTED_MODULE_1__/* .cloneElement */ .Tm)(child, {
      children: child.props.children.split('').join(SPACE)
    });
  }
  if (isString(child)) {
    return isTwoCNChar(child) ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, child.split('').join(SPACE)) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, child);
  }
  if ((0,_util_reactNode__WEBPACK_IMPORTED_MODULE_1__/* .isFragment */ .M2)(child)) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, child);
  }
  return child;
}
function spaceChildren(children, needInserted) {
  let isPrevChildPure = false;
  const childList = [];
  react__WEBPACK_IMPORTED_MODULE_0__.Children.forEach(children, child => {
    const type = typeof child;
    const isCurrentChildPure = type === 'string' || type === 'number';
    if (isPrevChildPure && isCurrentChildPure) {
      const lastIndex = childList.length - 1;
      const lastChild = childList[lastIndex];
      childList[lastIndex] = `${lastChild}${child}`;
    } else {
      childList.push(child);
    }
    isPrevChildPure = isCurrentChildPure;
  });
  return react__WEBPACK_IMPORTED_MODULE_0__.Children.map(childList, child => splitCNCharsBySpace(child, needInserted));
}
const _ButtonTypes = (/* unused pure expression or super */ null && (['default', 'primary', 'dashed', 'link', 'text']));
const _ButtonShapes = (/* unused pure expression or super */ null && (['default', 'circle', 'round']));
const _ButtonHTMLTypes = (/* unused pure expression or super */ null && (['submit', 'button', 'reset']));
const _ButtonVariantTypes = (/* unused pure expression or super */ null && (['outlined', 'dashed', 'solid', 'filled', 'text', 'link']));
const _ButtonColorTypes = ['default', 'primary', 'danger'].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_theme_interface__WEBPACK_IMPORTED_MODULE_3__/* .PresetColors */ .i));

/***/ }),

/***/ 45972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ es_button; }
});

// UNUSED EXPORTS: _ButtonColorTypes, _ButtonVariantTypes, convertLegacyProps, isString, isTwoCNChar, isUnBorderedButtonVariant, spaceChildren

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/omit.js
var omit = __webpack_require__(85401);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(99195);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useLayoutEffect.js
var useLayoutEffect = __webpack_require__(76963);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/wave/index.js + 4 modules
var wave = __webpack_require__(14742);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js
var context = __webpack_require__(94980);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/DisabledContext.js
var DisabledContext = __webpack_require__(85508);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/hooks/useSize.js
var useSize = __webpack_require__(27011);
// EXTERNAL MODULE: ./node_modules/antd/es/space/Compact.js
var Compact = __webpack_require__(38625);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/useToken.js + 3 modules
var theme_useToken = __webpack_require__(39779);
;// CONCATENATED MODULE: ./node_modules/antd/es/button/button-group.js
"use client";

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





const GroupSizeContext = /*#__PURE__*/react.createContext(undefined);
const ButtonGroup = props => {
  const {
    getPrefixCls,
    direction
  } = react.useContext(context/* ConfigContext */.E_);
  const {
      prefixCls: customizePrefixCls,
      size,
      className
    } = props,
    others = __rest(props, ["prefixCls", "size", "className"]);
  const prefixCls = getPrefixCls('btn-group', customizePrefixCls);
  const [,, hashId] = (0,theme_useToken/* default */.ZP)();
  const sizeCls = react.useMemo(() => {
    switch (size) {
      case 'large':
        return 'lg';
      case 'small':
        return 'sm';
      default:
        return '';
    }
  }, [size]);
  if (false) {}
  const classes = classnames_default()(prefixCls, {
    [`${prefixCls}-${sizeCls}`]: sizeCls,
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, className, hashId);
  return /*#__PURE__*/react.createElement(GroupSizeContext.Provider, {
    value: size
  }, /*#__PURE__*/react.createElement("div", Object.assign({}, others, {
    className: classes
  })));
};
/* harmony default export */ var button_group = (ButtonGroup);
// EXTERNAL MODULE: ./node_modules/antd/es/button/buttonHelpers.js
var buttonHelpers = __webpack_require__(54179);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/LoadingOutlined.js + 1 modules
var LoadingOutlined = __webpack_require__(50733);
// EXTERNAL MODULE: ./node_modules/rc-motion/es/index.js + 13 modules
var es = __webpack_require__(26981);
;// CONCATENATED MODULE: ./node_modules/antd/es/button/IconWrapper.js
"use client";



const IconWrapper = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  const {
    className,
    style,
    children,
    prefixCls
  } = props;
  const iconWrapperCls = classnames_default()(`${prefixCls}-icon`, className);
  return /*#__PURE__*/react.createElement("span", {
    ref: ref,
    className: iconWrapperCls,
    style: style
  }, children);
});
/* harmony default export */ var button_IconWrapper = (IconWrapper);
;// CONCATENATED MODULE: ./node_modules/antd/es/button/DefaultLoadingIcon.js
"use client";






const InnerLoadingIcon = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  const {
    prefixCls,
    className,
    style,
    iconClassName
  } = props;
  const mergedIconCls = classnames_default()(`${prefixCls}-loading-icon`, className);
  return /*#__PURE__*/react.createElement(button_IconWrapper, {
    prefixCls: prefixCls,
    className: mergedIconCls,
    style: style,
    ref: ref
  }, /*#__PURE__*/react.createElement(LoadingOutlined/* default */.Z, {
    className: iconClassName
  }));
});
const getCollapsedWidth = () => ({
  width: 0,
  opacity: 0,
  transform: 'scale(0)'
});
const getRealWidth = node => ({
  width: node.scrollWidth,
  opacity: 1,
  transform: 'scale(1)'
});
const DefaultLoadingIcon = props => {
  const {
    prefixCls,
    loading,
    existIcon,
    className,
    style,
    mount
  } = props;
  const visible = !!loading;
  if (existIcon) {
    return /*#__PURE__*/react.createElement(InnerLoadingIcon, {
      prefixCls: prefixCls,
      className: className,
      style: style
    });
  }
  return /*#__PURE__*/react.createElement(es/* default */.ZP, {
    visible: visible,
    // Used for minus flex gap style only
    motionName: `${prefixCls}-loading-icon-motion`,
    motionAppear: !mount,
    motionEnter: !mount,
    motionLeave: !mount,
    removeOnLeave: true,
    onAppearStart: getCollapsedWidth,
    onAppearActive: getRealWidth,
    onEnterStart: getCollapsedWidth,
    onEnterActive: getRealWidth,
    onLeaveStart: getRealWidth,
    onLeaveActive: getCollapsedWidth
  }, ({
    className: motionCls,
    style: motionStyle
  }, ref) => {
    const mergedStyle = Object.assign(Object.assign({}, style), motionStyle);
    return /*#__PURE__*/react.createElement(InnerLoadingIcon, {
      prefixCls: prefixCls,
      className: classnames_default()(className, motionCls),
      style: mergedStyle,
      ref: ref
    });
  });
};
/* harmony default export */ var button_DefaultLoadingIcon = (DefaultLoadingIcon);
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs/es/index.js + 37 modules
var cssinjs_es = __webpack_require__(68946);
// EXTERNAL MODULE: ./node_modules/antd/es/style/index.js
var style = __webpack_require__(31875);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/interface/presetColors.js
var presetColors = __webpack_require__(26822);
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs-utils/es/index.js + 12 modules
var cssinjs_utils_es = __webpack_require__(89158);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/util/genStyleUtils.js
var genStyleUtils = __webpack_require__(18511);
;// CONCATENATED MODULE: ./node_modules/antd/es/button/style/group.js
const genButtonBorderStyle = (buttonTypeCls, borderColor) => ({
  // Border
  [`> span, > ${buttonTypeCls}`]: {
    '&:not(:last-child)': {
      [`&, & > ${buttonTypeCls}`]: {
        '&:not(:disabled)': {
          borderInlineEndColor: borderColor
        }
      }
    },
    '&:not(:first-child)': {
      [`&, & > ${buttonTypeCls}`]: {
        '&:not(:disabled)': {
          borderInlineStartColor: borderColor
        }
      }
    }
  }
});
const genGroupStyle = token => {
  const {
    componentCls,
    fontSize,
    lineWidth,
    groupBorderColor,
    colorErrorHover
  } = token;
  return {
    [`${componentCls}-group`]: [{
      position: 'relative',
      display: 'inline-flex',
      // Border
      [`> span, > ${componentCls}`]: {
        '&:not(:last-child)': {
          [`&, & > ${componentCls}`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        '&:not(:first-child)': {
          marginInlineStart: token.calc(lineWidth).mul(-1).equal(),
          [`&, & > ${componentCls}`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        }
      },
      [componentCls]: {
        position: 'relative',
        zIndex: 1,
        '&:hover, &:focus, &:active': {
          zIndex: 2
        },
        '&[disabled]': {
          zIndex: 0
        }
      },
      [`${componentCls}-icon-only`]: {
        fontSize
      }
    },
    // Border Color
    genButtonBorderStyle(`${componentCls}-primary`, groupBorderColor), genButtonBorderStyle(`${componentCls}-danger`, colorErrorHover)]
  };
};
/* harmony default export */ var group = (genGroupStyle);
// EXTERNAL MODULE: ./node_modules/antd/es/color-picker/color.js
var color = __webpack_require__(65606);
// EXTERNAL MODULE: ./node_modules/@rc-component/color-picker/es/index.js + 13 modules
var color_picker_es = __webpack_require__(3434);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMergedState.js
var hooks_useMergedState = __webpack_require__(78877);
;// CONCATENATED MODULE: ./node_modules/antd/es/color-picker/components/ColorPresets.js
"use client";









const genPresetColor = list => list.map(value => {
  value.colors = value.colors.map(generateColor);
  return value;
});
const isBright = (value, bgColorToken) => {
  const {
    r,
    g,
    b,
    a
  } = value.toRgb();
  const hsv = new color_picker_es/* Color */.Il(value.toRgbString()).onBackground(bgColorToken).toHsv();
  if (a <= 0.5) {
    // Adapted to dark mode
    return hsv.v > 0.5;
  }
  return r * 0.299 + g * 0.587 + b * 0.114 > 192;
};
const genCollapsePanelKey = (preset, index) => {
  var _a;
  const mergedKey = (_a = preset.key) !== null && _a !== void 0 ? _a : index;
  return `panel-${mergedKey}`;
};
const ColorPresets = ({
  prefixCls,
  presets,
  value: color,
  onChange
}) => {
  const [locale] = useLocale('ColorPicker');
  const [, token] = useToken();
  const [presetsValue] = useMergedState(genPresetColor(presets), {
    value: genPresetColor(presets),
    postState: genPresetColor
  });
  const colorPresetsPrefixCls = `${prefixCls}-presets`;
  const activeKeys = useMemo(() => presetsValue.reduce((acc, preset, index) => {
    const {
      defaultOpen = true
    } = preset;
    if (defaultOpen) {
      acc.push(genCollapsePanelKey(preset, index));
    }
    return acc;
  }, []), [presetsValue]);
  const handleClick = colorValue => {
    onChange === null || onChange === void 0 ? void 0 : onChange(colorValue);
  };
  const items = presetsValue.map((preset, index) => {
    var _a;
    return {
      key: genCollapsePanelKey(preset, index),
      label: /*#__PURE__*/React.createElement("div", {
        className: `${colorPresetsPrefixCls}-label`
      }, preset === null || preset === void 0 ? void 0 : preset.label),
      children: (/*#__PURE__*/React.createElement("div", {
        className: `${colorPresetsPrefixCls}-items`
      }, Array.isArray(preset === null || preset === void 0 ? void 0 : preset.colors) && ((_a = preset.colors) === null || _a === void 0 ? void 0 : _a.length) > 0 ? preset.colors.map((presetColor, index) => (/*#__PURE__*/React.createElement(ColorBlock
      // eslint-disable-next-line react/no-array-index-key
      , {
        // eslint-disable-next-line react/no-array-index-key
        key: `preset-${index}-${presetColor.toHexString()}`,
        color: generateColor(presetColor).toRgbString(),
        prefixCls: prefixCls,
        className: classNames(`${colorPresetsPrefixCls}-color`, {
          [`${colorPresetsPrefixCls}-color-checked`]: presetColor.toHexString() === (color === null || color === void 0 ? void 0 : color.toHexString()),
          [`${colorPresetsPrefixCls}-color-bright`]: isBright(presetColor, token.colorBgElevated)
        }),
        onClick: () => handleClick(presetColor)
      }))) : (/*#__PURE__*/React.createElement("span", {
        className: `${colorPresetsPrefixCls}-empty`
      }, locale.presetEmpty))))
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: colorPresetsPrefixCls
  }, /*#__PURE__*/React.createElement(Collapse, {
    defaultActiveKey: activeKeys,
    ghost: true,
    items: items
  }));
};
/* harmony default export */ var components_ColorPresets = ((/* unused pure expression or super */ null && (ColorPresets)));
// EXTERNAL MODULE: ./node_modules/antd/es/theme/themes/shared/genFontSizes.js
var genFontSizes = __webpack_require__(85362);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/util/getAlphaColor.js
var getAlphaColor = __webpack_require__(12402);
;// CONCATENATED MODULE: ./node_modules/antd/es/button/style/token.js






const prepareToken = token => {
  const {
    paddingInline,
    onlyIconSize
  } = token;
  const buttonToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    buttonPaddingHorizontal: paddingInline,
    buttonPaddingVertical: 0,
    buttonIconOnlyFontSize: onlyIconSize
  });
  return buttonToken;
};
const prepareComponentToken = token => {
  var _a, _b, _c, _d, _e, _f;
  const contentFontSize = (_a = token.contentFontSize) !== null && _a !== void 0 ? _a : token.fontSize;
  const contentFontSizeSM = (_b = token.contentFontSizeSM) !== null && _b !== void 0 ? _b : token.fontSize;
  const contentFontSizeLG = (_c = token.contentFontSizeLG) !== null && _c !== void 0 ? _c : token.fontSizeLG;
  const contentLineHeight = (_d = token.contentLineHeight) !== null && _d !== void 0 ? _d : (0,genFontSizes/* getLineHeight */.D)(contentFontSize);
  const contentLineHeightSM = (_e = token.contentLineHeightSM) !== null && _e !== void 0 ? _e : (0,genFontSizes/* getLineHeight */.D)(contentFontSizeSM);
  const contentLineHeightLG = (_f = token.contentLineHeightLG) !== null && _f !== void 0 ? _f : (0,genFontSizes/* getLineHeight */.D)(contentFontSizeLG);
  const solidTextColor = isBright(new color/* AggregationColor */.y9(token.colorBgSolid), '#fff') ? '#000' : '#fff';
  const shadowColorTokens = presetColors/* PresetColors.reduce */.i.reduce((prev, colorKey) => Object.assign(Object.assign({}, prev), {
    [`${colorKey}ShadowColor`]: `0 ${(0,cssinjs_es/* unit */.bf)(token.controlOutlineWidth)} 0 ${(0,getAlphaColor/* default */.Z)(token[`${colorKey}1`], token.colorBgContainer)}`
  }), {});
  return Object.assign(Object.assign({}, shadowColorTokens), {
    fontWeight: 400,
    iconGap: token.marginXS,
    defaultShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlTmpOutline}`,
    primaryShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlOutline}`,
    dangerShadow: `0 ${token.controlOutlineWidth}px 0 ${token.colorErrorOutline}`,
    primaryColor: token.colorTextLightSolid,
    dangerColor: token.colorTextLightSolid,
    borderColorDisabled: token.colorBorder,
    defaultGhostColor: token.colorBgContainer,
    ghostBg: 'transparent',
    defaultGhostBorderColor: token.colorBgContainer,
    paddingInline: token.paddingContentHorizontal - token.lineWidth,
    paddingInlineLG: token.paddingContentHorizontal - token.lineWidth,
    paddingInlineSM: 8 - token.lineWidth,
    onlyIconSize: 'inherit',
    onlyIconSizeSM: 'inherit',
    onlyIconSizeLG: 'inherit',
    groupBorderColor: token.colorPrimaryHover,
    linkHoverBg: 'transparent',
    textTextColor: token.colorText,
    textTextHoverColor: token.colorText,
    textTextActiveColor: token.colorText,
    textHoverBg: token.colorFillTertiary,
    defaultColor: token.colorText,
    defaultBg: token.colorBgContainer,
    defaultBorderColor: token.colorBorder,
    defaultBorderColorDisabled: token.colorBorder,
    defaultHoverBg: token.colorBgContainer,
    defaultHoverColor: token.colorPrimaryHover,
    defaultHoverBorderColor: token.colorPrimaryHover,
    defaultActiveBg: token.colorBgContainer,
    defaultActiveColor: token.colorPrimaryActive,
    defaultActiveBorderColor: token.colorPrimaryActive,
    solidTextColor,
    contentFontSize,
    contentFontSizeSM,
    contentFontSizeLG,
    contentLineHeight,
    contentLineHeightSM,
    contentLineHeightLG,
    paddingBlock: Math.max((token.controlHeight - contentFontSize * contentLineHeight) / 2 - token.lineWidth, 0),
    paddingBlockSM: Math.max((token.controlHeightSM - contentFontSizeSM * contentLineHeightSM) / 2 - token.lineWidth, 0),
    paddingBlockLG: Math.max((token.controlHeightLG - contentFontSizeLG * contentLineHeightLG) / 2 - token.lineWidth, 0)
  });
};
;// CONCATENATED MODULE: ./node_modules/antd/es/button/style/index.js






// ============================== Shared ==============================
const genSharedButtonStyle = token => {
  const {
    componentCls,
    iconCls,
    fontWeight,
    opacityLoading,
    motionDurationSlow,
    motionEaseInOut,
    iconGap,
    calc
  } = token;
  return {
    [componentCls]: {
      outline: 'none',
      position: 'relative',
      display: 'inline-flex',
      gap: iconGap,
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight,
      whiteSpace: 'nowrap',
      textAlign: 'center',
      backgroundImage: 'none',
      background: 'transparent',
      border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} transparent`,
      cursor: 'pointer',
      transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
      userSelect: 'none',
      touchAction: 'manipulation',
      color: token.colorText,
      '&:disabled > *': {
        pointerEvents: 'none'
      },
      // https://github.com/ant-design/ant-design/issues/51380
      [`${componentCls}-icon > svg`]: (0,style/* resetIcon */.Ro)(),
      '> a': {
        color: 'currentColor'
      },
      '&:not(:disabled)': (0,style/* genFocusStyle */.Qy)(token),
      [`&${componentCls}-two-chinese-chars::first-letter`]: {
        letterSpacing: '0.34em'
      },
      [`&${componentCls}-two-chinese-chars > *:not(${iconCls})`]: {
        marginInlineEnd: '-0.34em',
        letterSpacing: '0.34em'
      },
      [`&${componentCls}-icon-only`]: {
        paddingInline: 0,
        // make `btn-icon-only` not too narrow
        [`&${componentCls}-compact-item`]: {
          flex: 'none'
        },
        [`&${componentCls}-round`]: {
          width: 'auto'
        }
      },
      // Loading
      [`&${componentCls}-loading`]: {
        opacity: opacityLoading,
        cursor: 'default'
      },
      [`${componentCls}-loading-icon`]: {
        transition: ['width', 'opacity', 'margin'].map(transition => `${transition} ${motionDurationSlow} ${motionEaseInOut}`).join(',')
      },
      // iconPosition
      [`&:not(${componentCls}-icon-end)`]: {
        [`${componentCls}-loading-icon-motion`]: {
          '&-appear-start, &-enter-start': {
            marginInlineEnd: calc(iconGap).mul(-1).equal()
          },
          '&-appear-active, &-enter-active': {
            marginInlineEnd: 0
          },
          '&-leave-start': {
            marginInlineEnd: 0
          },
          '&-leave-active': {
            marginInlineEnd: calc(iconGap).mul(-1).equal()
          }
        }
      },
      '&-icon-end': {
        flexDirection: 'row-reverse',
        [`${componentCls}-loading-icon-motion`]: {
          '&-appear-start, &-enter-start': {
            marginInlineStart: calc(iconGap).mul(-1).equal()
          },
          '&-appear-active, &-enter-active': {
            marginInlineStart: 0
          },
          '&-leave-start': {
            marginInlineStart: 0
          },
          '&-leave-active': {
            marginInlineStart: calc(iconGap).mul(-1).equal()
          }
        }
      }
    }
  };
};
const genHoverActiveButtonStyle = (btnCls, hoverStyle, activeStyle) => ({
  [`&:not(:disabled):not(${btnCls}-disabled)`]: {
    '&:hover': hoverStyle,
    '&:active': activeStyle
  }
});
// ============================== Shape ===============================
const genCircleButtonStyle = token => ({
  minWidth: token.controlHeight,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  borderRadius: '50%'
});
const genRoundButtonStyle = token => ({
  borderRadius: token.controlHeight,
  paddingInlineStart: token.calc(token.controlHeight).div(2).equal(),
  paddingInlineEnd: token.calc(token.controlHeight).div(2).equal()
});
const genDisabledStyle = token => ({
  cursor: 'not-allowed',
  borderColor: token.borderColorDisabled,
  color: token.colorTextDisabled,
  background: token.colorBgContainerDisabled,
  boxShadow: 'none'
});
const genGhostButtonStyle = (btnCls, background, textColor, borderColor, textColorDisabled, borderColorDisabled, hoverStyle, activeStyle) => ({
  [`&${btnCls}-background-ghost`]: Object.assign(Object.assign({
    color: textColor || undefined,
    background,
    borderColor: borderColor || undefined,
    boxShadow: 'none'
  }, genHoverActiveButtonStyle(btnCls, Object.assign({
    background
  }, hoverStyle), Object.assign({
    background
  }, activeStyle))), {
    '&:disabled': {
      cursor: 'not-allowed',
      color: textColorDisabled || undefined,
      borderColor: borderColorDisabled || undefined
    }
  })
});
const genSolidDisabledButtonStyle = token => ({
  [`&:disabled, &${token.componentCls}-disabled`]: Object.assign({}, genDisabledStyle(token))
});
const genPureDisabledButtonStyle = token => ({
  [`&:disabled, &${token.componentCls}-disabled`]: {
    cursor: 'not-allowed',
    color: token.colorTextDisabled
  }
});
// ============================== Variant =============================
const genVariantButtonStyle = (token, hoverStyle, activeStyle, variant) => {
  const isPureDisabled = variant && ['link', 'text'].includes(variant);
  const genDisabledButtonStyle = isPureDisabled ? genPureDisabledButtonStyle : genSolidDisabledButtonStyle;
  return Object.assign(Object.assign({}, genDisabledButtonStyle(token)), genHoverActiveButtonStyle(token.componentCls, hoverStyle, activeStyle));
};
const genSolidButtonStyle = (token, textColor, background, hoverStyle, activeStyle) => ({
  [`&${token.componentCls}-variant-solid`]: Object.assign({
    color: textColor,
    background
  }, genVariantButtonStyle(token, hoverStyle, activeStyle))
});
const genOutlinedDashedButtonStyle = (token, borderColor, background, hoverStyle, activeStyle) => ({
  [`&${token.componentCls}-variant-outlined, &${token.componentCls}-variant-dashed`]: Object.assign({
    borderColor,
    background
  }, genVariantButtonStyle(token, hoverStyle, activeStyle))
});
const genDashedButtonStyle = token => ({
  [`&${token.componentCls}-variant-dashed`]: {
    borderStyle: 'dashed'
  }
});
const genFilledButtonStyle = (token, background, hoverStyle, activeStyle) => ({
  [`&${token.componentCls}-variant-filled`]: Object.assign({
    boxShadow: 'none',
    background
  }, genVariantButtonStyle(token, hoverStyle, activeStyle))
});
const genTextLinkButtonStyle = (token, textColor, variant, hoverStyle, activeStyle) => ({
  [`&${token.componentCls}-variant-${variant}`]: Object.assign({
    color: textColor,
    boxShadow: 'none'
  }, genVariantButtonStyle(token, hoverStyle, activeStyle, variant))
});
// =============================== Color ==============================
const genPresetColorStyle = token => {
  const {
    componentCls
  } = token;
  return presetColors/* PresetColors.reduce */.i.reduce((prev, colorKey) => {
    const darkColor = token[`${colorKey}6`];
    const lightColor = token[`${colorKey}1`];
    const hoverColor = token[`${colorKey}5`];
    const lightHoverColor = token[`${colorKey}2`];
    const lightBorderColor = token[`${colorKey}3`];
    const activeColor = token[`${colorKey}7`];
    return Object.assign(Object.assign({}, prev), {
      [`&${componentCls}-color-${colorKey}`]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: darkColor,
        boxShadow: token[`${colorKey}ShadowColor`]
      }, genSolidButtonStyle(token, token.colorTextLightSolid, darkColor, {
        background: hoverColor
      }, {
        background: activeColor
      })), genOutlinedDashedButtonStyle(token, darkColor, token.colorBgContainer, {
        color: hoverColor,
        borderColor: hoverColor,
        background: token.colorBgContainer
      }, {
        color: activeColor,
        borderColor: activeColor,
        background: token.colorBgContainer
      })), genDashedButtonStyle(token)), genFilledButtonStyle(token, lightColor, {
        color: darkColor,
        background: lightHoverColor
      }, {
        color: darkColor,
        background: lightBorderColor
      })), genTextLinkButtonStyle(token, darkColor, 'link', {
        color: hoverColor
      }, {
        color: activeColor
      })), genTextLinkButtonStyle(token, darkColor, 'text', {
        color: hoverColor,
        background: lightColor
      }, {
        color: activeColor,
        background: lightBorderColor
      }))
    });
  }, {});
};
const genDefaultButtonStyle = token => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: token.defaultColor,
  boxShadow: token.defaultShadow
}, genSolidButtonStyle(token, token.solidTextColor, token.colorBgSolid, {
  color: token.solidTextColor,
  background: token.colorBgSolidHover
}, {
  color: token.solidTextColor,
  background: token.colorBgSolidActive
})), genDashedButtonStyle(token)), genFilledButtonStyle(token, token.colorFillTertiary, {
  color: token.defaultColor,
  background: token.colorFillSecondary
}, {
  color: token.defaultColor,
  background: token.colorFill
})), genGhostButtonStyle(token.componentCls, token.ghostBg, token.defaultGhostColor, token.defaultGhostBorderColor, token.colorTextDisabled, token.colorBorder)), genTextLinkButtonStyle(token, token.textTextColor, 'link', {
  color: token.colorLinkHover,
  background: token.linkHoverBg
}, {
  color: token.colorLinkActive
}));
const genPrimaryButtonStyle = token => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: token.colorPrimary,
  boxShadow: token.primaryShadow
}, genOutlinedDashedButtonStyle(token, token.colorPrimary, token.colorBgContainer, {
  color: token.colorPrimaryTextHover,
  borderColor: token.colorPrimaryHover,
  background: token.colorBgContainer
}, {
  color: token.colorPrimaryTextActive,
  borderColor: token.colorPrimaryActive,
  background: token.colorBgContainer
})), genDashedButtonStyle(token)), genFilledButtonStyle(token, token.colorPrimaryBg, {
  color: token.colorPrimary,
  background: token.colorPrimaryBgHover
}, {
  color: token.colorPrimary,
  background: token.colorPrimaryBorder
})), genTextLinkButtonStyle(token, token.colorPrimaryText, 'text', {
  color: token.colorPrimaryTextHover,
  background: token.colorPrimaryBg
}, {
  color: token.colorPrimaryTextActive,
  background: token.colorPrimaryBorder
})), genTextLinkButtonStyle(token, token.colorPrimaryText, 'link', {
  color: token.colorPrimaryTextHover,
  background: token.linkHoverBg
}, {
  color: token.colorPrimaryTextActive
})), genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorPrimary, token.colorPrimary, token.colorTextDisabled, token.colorBorder, {
  color: token.colorPrimaryHover,
  borderColor: token.colorPrimaryHover
}, {
  color: token.colorPrimaryActive,
  borderColor: token.colorPrimaryActive
}));
const genDangerousStyle = token => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: token.colorError,
  boxShadow: token.dangerShadow
}, genSolidButtonStyle(token, token.dangerColor, token.colorError, {
  background: token.colorErrorHover
}, {
  background: token.colorErrorActive
})), genOutlinedDashedButtonStyle(token, token.colorError, token.colorBgContainer, {
  color: token.colorErrorHover,
  borderColor: token.colorErrorBorderHover
}, {
  color: token.colorErrorActive,
  borderColor: token.colorErrorActive
})), genDashedButtonStyle(token)), genFilledButtonStyle(token, token.colorErrorBg, {
  color: token.colorError,
  background: token.colorErrorBgFilledHover
}, {
  color: token.colorError,
  background: token.colorErrorBgActive
})), genTextLinkButtonStyle(token, token.colorError, 'text', {
  color: token.colorErrorHover,
  background: token.colorErrorBg
}, {
  color: token.colorErrorHover,
  background: token.colorErrorBgActive
})), genTextLinkButtonStyle(token, token.colorError, 'link', {
  color: token.colorErrorHover
}, {
  color: token.colorErrorActive
})), genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorError, token.colorError, token.colorTextDisabled, token.colorBorder, {
  color: token.colorErrorHover,
  borderColor: token.colorErrorHover
}, {
  color: token.colorErrorActive,
  borderColor: token.colorErrorActive
}));
const genLinkStyle = token => Object.assign(Object.assign({}, genTextLinkButtonStyle(token, token.colorLink, 'link', {
  color: token.colorLinkHover
}, {
  color: token.colorLinkActive
})), genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorInfo, token.colorInfo, token.colorTextDisabled, token.colorBorder, {
  color: token.colorInfoHover,
  borderColor: token.colorInfoHover
}, {
  color: token.colorInfoActive,
  borderColor: token.colorInfoActive
}));
const genColorButtonStyle = token => {
  const {
    componentCls
  } = token;
  return Object.assign({
    [`${componentCls}-color-default`]: genDefaultButtonStyle(token),
    [`${componentCls}-color-primary`]: genPrimaryButtonStyle(token),
    [`${componentCls}-color-dangerous`]: genDangerousStyle(token),
    [`${componentCls}-color-link`]: genLinkStyle(token)
  }, genPresetColorStyle(token));
};
// =========== Compatible with versions earlier than 5.21.0 ===========
const genCompatibleButtonStyle = token => Object.assign(Object.assign(Object.assign(Object.assign({}, genOutlinedDashedButtonStyle(token, token.defaultBorderColor, token.defaultBg, {
  color: token.defaultHoverColor,
  borderColor: token.defaultHoverBorderColor,
  background: token.defaultHoverBg
}, {
  color: token.defaultActiveColor,
  borderColor: token.defaultActiveBorderColor,
  background: token.defaultActiveBg
})), genTextLinkButtonStyle(token, token.textTextColor, 'text', {
  color: token.textTextHoverColor,
  background: token.textHoverBg
}, {
  color: token.textTextActiveColor,
  background: token.colorBgTextActive
})), genSolidButtonStyle(token, token.primaryColor, token.colorPrimary, {
  background: token.colorPrimaryHover,
  color: token.primaryColor
}, {
  background: token.colorPrimaryActive,
  color: token.primaryColor
})), genTextLinkButtonStyle(token, token.colorLink, 'link', {
  color: token.colorLinkHover,
  background: token.linkHoverBg
}, {
  color: token.colorLinkActive
}));
// =============================== Size ===============================
const genButtonStyle = (token, prefixCls = '') => {
  const {
    componentCls,
    controlHeight,
    fontSize,
    borderRadius,
    buttonPaddingHorizontal,
    iconCls,
    buttonPaddingVertical,
    buttonIconOnlyFontSize
  } = token;
  return [{
    [prefixCls]: {
      fontSize,
      height: controlHeight,
      padding: `${(0,cssinjs_es/* unit */.bf)(buttonPaddingVertical)} ${(0,cssinjs_es/* unit */.bf)(buttonPaddingHorizontal)}`,
      borderRadius,
      [`&${componentCls}-icon-only`]: {
        width: controlHeight,
        [iconCls]: {
          fontSize: buttonIconOnlyFontSize
        }
      }
    }
  },
  // Shape - patch prefixCls again to override solid border radius style
  {
    [`${componentCls}${componentCls}-circle${prefixCls}`]: genCircleButtonStyle(token)
  }, {
    [`${componentCls}${componentCls}-round${prefixCls}`]: genRoundButtonStyle(token)
  }];
};
const genSizeBaseButtonStyle = token => {
  const baseToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    fontSize: token.contentFontSize
  });
  return genButtonStyle(baseToken, token.componentCls);
};
const genSizeSmallButtonStyle = token => {
  const smallToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    controlHeight: token.controlHeightSM,
    fontSize: token.contentFontSizeSM,
    padding: token.paddingXS,
    buttonPaddingHorizontal: token.paddingInlineSM,
    buttonPaddingVertical: 0,
    borderRadius: token.borderRadiusSM,
    buttonIconOnlyFontSize: token.onlyIconSizeSM
  });
  return genButtonStyle(smallToken, `${token.componentCls}-sm`);
};
const genSizeLargeButtonStyle = token => {
  const largeToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    controlHeight: token.controlHeightLG,
    fontSize: token.contentFontSizeLG,
    buttonPaddingHorizontal: token.paddingInlineLG,
    buttonPaddingVertical: 0,
    borderRadius: token.borderRadiusLG,
    buttonIconOnlyFontSize: token.onlyIconSizeLG
  });
  return genButtonStyle(largeToken, `${token.componentCls}-lg`);
};
const genBlockButtonStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [componentCls]: {
      [`&${componentCls}-block`]: {
        width: '100%'
      }
    }
  };
};
// ============================== Export ==============================
/* harmony default export */ var button_style = ((0,genStyleUtils/* genStyleHooks */.I$)('Button', token => {
  const buttonToken = prepareToken(token);
  return [
  // Shared
  genSharedButtonStyle(buttonToken),
  // Size
  genSizeBaseButtonStyle(buttonToken), genSizeSmallButtonStyle(buttonToken), genSizeLargeButtonStyle(buttonToken),
  // Block
  genBlockButtonStyle(buttonToken),
  // Color
  genColorButtonStyle(buttonToken),
  // https://github.com/ant-design/ant-design/issues/50969
  genCompatibleButtonStyle(buttonToken),
  // Button Group
  group(buttonToken)];
}, prepareComponentToken, {
  unitless: {
    fontWeight: true,
    contentLineHeight: true,
    contentLineHeightSM: true,
    contentLineHeightLG: true
  }
}));
// EXTERNAL MODULE: ./node_modules/antd/es/style/compact-item.js
var compact_item = __webpack_require__(99978);
;// CONCATENATED MODULE: ./node_modules/antd/es/style/compact-item-vertical.js
function compactItemVerticalBorder(token, parentCls, prefixCls) {
  return {
    // border collapse
    [`&-item:not(${parentCls}-last-item)`]: {
      marginBottom: token.calc(token.lineWidth).mul(-1).equal()
    },
    [`&-item:not(${prefixCls}-status-success)`]: {
      zIndex: 2
    },
    '&-item': {
      '&:hover,&:focus,&:active': {
        zIndex: 3
      },
      '&[disabled]': {
        zIndex: 0
      }
    }
  };
}
function compactItemBorderVerticalRadius(prefixCls, parentCls) {
  return {
    [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${parentCls}-first-item:not(${parentCls}-last-item)`]: {
      [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${parentCls}-last-item:not(${parentCls}-first-item)`]: {
      [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function genCompactItemVerticalStyle(token) {
  const compactCls = `${token.componentCls}-compact-vertical`;
  return {
    [compactCls]: Object.assign(Object.assign({}, compactItemVerticalBorder(token, compactCls, token.componentCls)), compactItemBorderVerticalRadius(token.componentCls, compactCls))
  };
}
;// CONCATENATED MODULE: ./node_modules/antd/es/button/style/compact.js




const genButtonCompactStyle = token => {
  const {
    componentCls,
    colorPrimaryHover,
    lineWidth,
    calc
  } = token;
  const insetOffset = calc(lineWidth).mul(-1).equal();
  const getCompactBorderStyle = vertical => {
    const selector = `${componentCls}-compact${vertical ? '-vertical' : ''}-item${componentCls}-primary:not([disabled])`;
    return {
      [`${selector} + ${selector}::before`]: {
        position: 'absolute',
        top: vertical ? insetOffset : 0,
        insetInlineStart: vertical ? 0 : insetOffset,
        backgroundColor: colorPrimaryHover,
        content: '""',
        width: vertical ? '100%' : lineWidth,
        height: vertical ? lineWidth : '100%'
      }
    };
  };
  // Special styles for Primary Button
  return Object.assign(Object.assign({}, getCompactBorderStyle()), getCompactBorderStyle(true));
};
// ============================== Export ==============================
/* harmony default export */ var compact = ((0,genStyleUtils/* genSubStyleComponent */.bk)(['Button', 'compact'], token => {
  const buttonToken = prepareToken(token);
  return [
  // Space Compact
  (0,compact_item/* genCompactItemStyle */.c)(buttonToken), genCompactItemVerticalStyle(buttonToken), genButtonCompactStyle(buttonToken)];
}, prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/antd/es/button/button.js
"use client";

var button_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

















function getLoadingConfig(loading) {
  if (typeof loading === 'object' && loading) {
    let delay = loading === null || loading === void 0 ? void 0 : loading.delay;
    delay = !Number.isNaN(delay) && typeof delay === 'number' ? delay : 0;
    return {
      loading: delay <= 0,
      delay
    };
  }
  return {
    loading: !!loading,
    delay: 0
  };
}
const ButtonTypeMap = {
  default: ['default', 'outlined'],
  primary: ['primary', 'solid'],
  dashed: ['default', 'dashed'],
  // `link` is not a real color but we should compatible with it
  link: ['link', 'link'],
  text: ['default', 'text']
};
const InternalCompoundedButton = /*#__PURE__*/react.forwardRef((props, ref) => {
  var _a, _b;
  const {
      loading = false,
      prefixCls: customizePrefixCls,
      color,
      variant,
      type,
      danger = false,
      shape: customizeShape,
      size: customizeSize,
      styles,
      disabled: customDisabled,
      className,
      rootClassName,
      children,
      icon,
      iconPosition = 'start',
      ghost = false,
      block = false,
      // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
      htmlType = 'button',
      classNames: customClassNames,
      style: customStyle = {},
      autoInsertSpace,
      autoFocus
    } = props,
    rest = button_rest(props, ["loading", "prefixCls", "color", "variant", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "iconPosition", "ghost", "block", "htmlType", "classNames", "style", "autoInsertSpace", "autoFocus"]);
  // https://github.com/ant-design/ant-design/issues/47605
  // Compatible with original `type` behavior
  const mergedType = type || 'default';
  const {
    button
  } = react.useContext(context/* ConfigContext */.E_);
  const shape = customizeShape || (button === null || button === void 0 ? void 0 : button.shape) || 'default';
  const [mergedColor, mergedVariant] = (0,react.useMemo)(() => {
    // >>>>> Local
    // Color & Variant
    if (color && variant) {
      return [color, variant];
    }
    // Sugar syntax
    if (type || danger) {
      const colorVariantPair = ButtonTypeMap[mergedType] || [];
      if (danger) {
        return ['danger', colorVariantPair[1]];
      }
      return colorVariantPair;
    }
    // >>> Context fallback
    if ((button === null || button === void 0 ? void 0 : button.color) && (button === null || button === void 0 ? void 0 : button.variant)) {
      return [button.color, button.variant];
    }
    return ['default', 'outlined'];
  }, [type, color, variant, danger, button === null || button === void 0 ? void 0 : button.variant, button === null || button === void 0 ? void 0 : button.color]);
  const isDanger = mergedColor === 'danger';
  const mergedColorText = isDanger ? 'dangerous' : mergedColor;
  const {
    getPrefixCls,
    direction,
    autoInsertSpace: contextAutoInsertSpace,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = (0,context/* useComponentConfig */.dj)('button');
  const mergedInsertSpace = (_a = autoInsertSpace !== null && autoInsertSpace !== void 0 ? autoInsertSpace : contextAutoInsertSpace) !== null && _a !== void 0 ? _a : true;
  const prefixCls = getPrefixCls('btn', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = button_style(prefixCls);
  const disabled = (0,react.useContext)(DisabledContext/* default */.Z);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  const groupSize = (0,react.useContext)(GroupSizeContext);
  const loadingOrDelay = (0,react.useMemo)(() => getLoadingConfig(loading), [loading]);
  const [innerLoading, setLoading] = (0,react.useState)(loadingOrDelay.loading);
  const [hasTwoCNChar, setHasTwoCNChar] = (0,react.useState)(false);
  const buttonRef = (0,react.useRef)(null);
  const mergedRef = (0,es_ref/* useComposeRef */.x1)(ref, buttonRef);
  const needInserted = react.Children.count(children) === 1 && !icon && !(0,buttonHelpers/* isUnBorderedButtonVariant */.Dn)(mergedVariant);
  // ========================= Mount ==========================
  // Record for mount status.
  // This will help to no to show the animation of loading on the first mount.
  const isMountRef = (0,react.useRef)(true);
  react.useEffect(() => {
    isMountRef.current = false;
    return () => {
      isMountRef.current = true;
    };
  }, []);
  // ========================= Effect =========================
  // Loading. Should use `useLayoutEffect` to avoid low perf multiple click issue.
  // https://github.com/ant-design/ant-design/issues/51325
  (0,useLayoutEffect/* default */.Z)(() => {
    let delayTimer = null;
    if (loadingOrDelay.delay > 0) {
      delayTimer = setTimeout(() => {
        delayTimer = null;
        setLoading(true);
      }, loadingOrDelay.delay);
    } else {
      setLoading(loadingOrDelay.loading);
    }
    function cleanupTimer() {
      if (delayTimer) {
        clearTimeout(delayTimer);
        delayTimer = null;
      }
    }
    return cleanupTimer;
  }, [loadingOrDelay.delay, loadingOrDelay.loading]);
  // Two chinese characters check
  (0,react.useEffect)(() => {
    // FIXME: for HOC usage like <FormatMessage />
    if (!buttonRef.current || !mergedInsertSpace) {
      return;
    }
    const buttonText = buttonRef.current.textContent || '';
    if (needInserted && (0,buttonHelpers/* isTwoCNChar */.aG)(buttonText)) {
      if (!hasTwoCNChar) {
        setHasTwoCNChar(true);
      }
    } else if (hasTwoCNChar) {
      setHasTwoCNChar(false);
    }
  });
  // Auto focus
  (0,react.useEffect)(() => {
    if (autoFocus && buttonRef.current) {
      buttonRef.current.focus();
    }
  }, []);
  // ========================= Events =========================
  const handleClick = react.useCallback(e => {
    var _a;
    // FIXME: https://github.com/ant-design/ant-design/issues/30207
    if (innerLoading || mergedDisabled) {
      e.preventDefault();
      return;
    }
    (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, 'href' in props ? e : e);
  }, [props.onClick, innerLoading, mergedDisabled]);
  // ========================== Warn ==========================
  if (false) {}
  // ========================== Size ==========================
  const {
    compactSize,
    compactItemClassnames
  } = (0,Compact/* useCompactItemContext */.ri)(prefixCls, direction);
  const sizeClassNameMap = {
    large: 'lg',
    small: 'sm',
    middle: undefined
  };
  const sizeFullName = (0,useSize/* default */.Z)(ctxSize => {
    var _a, _b;
    return (_b = (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : groupSize) !== null && _b !== void 0 ? _b : ctxSize;
  });
  const sizeCls = sizeFullName ? (_b = sizeClassNameMap[sizeFullName]) !== null && _b !== void 0 ? _b : '' : '';
  const iconType = innerLoading ? 'loading' : icon;
  const linkButtonRestProps = (0,omit/* default */.Z)(rest, ['navigate']);
  // ========================= Render =========================
  const classes = classnames_default()(prefixCls, hashId, cssVarCls, {
    [`${prefixCls}-${shape}`]: shape !== 'default' && shape,
    // Compatible with versions earlier than 5.21.0
    [`${prefixCls}-${mergedType}`]: mergedType,
    [`${prefixCls}-dangerous`]: danger,
    [`${prefixCls}-color-${mergedColorText}`]: mergedColorText,
    [`${prefixCls}-variant-${mergedVariant}`]: mergedVariant,
    [`${prefixCls}-${sizeCls}`]: sizeCls,
    [`${prefixCls}-icon-only`]: !children && children !== 0 && !!iconType,
    [`${prefixCls}-background-ghost`]: ghost && !(0,buttonHelpers/* isUnBorderedButtonVariant */.Dn)(mergedVariant),
    [`${prefixCls}-loading`]: innerLoading,
    [`${prefixCls}-two-chinese-chars`]: hasTwoCNChar && mergedInsertSpace && !innerLoading,
    [`${prefixCls}-block`]: block,
    [`${prefixCls}-rtl`]: direction === 'rtl',
    [`${prefixCls}-icon-end`]: iconPosition === 'end'
  }, compactItemClassnames, className, rootClassName, contextClassName);
  const fullStyle = Object.assign(Object.assign({}, contextStyle), customStyle);
  const iconClasses = classnames_default()(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.icon, contextClassNames.icon);
  const iconStyle = Object.assign(Object.assign({}, (styles === null || styles === void 0 ? void 0 : styles.icon) || {}), contextStyles.icon || {});
  const iconNode = icon && !innerLoading ? (/*#__PURE__*/react.createElement(button_IconWrapper, {
    prefixCls: prefixCls,
    className: iconClasses,
    style: iconStyle
  }, icon)) : loading && typeof loading === 'object' && loading.icon ? (/*#__PURE__*/react.createElement(button_IconWrapper, {
    prefixCls: prefixCls,
    className: iconClasses,
    style: iconStyle
  }, loading.icon)) : (/*#__PURE__*/react.createElement(button_DefaultLoadingIcon, {
    existIcon: !!icon,
    prefixCls: prefixCls,
    loading: innerLoading,
    mount: isMountRef.current
  }));
  const kids = children || children === 0 ? (0,buttonHelpers/* spaceChildren */.hU)(children, needInserted && mergedInsertSpace) : null;
  if (linkButtonRestProps.href !== undefined) {
    return wrapCSSVar(/*#__PURE__*/react.createElement("a", Object.assign({}, linkButtonRestProps, {
      className: classnames_default()(classes, {
        [`${prefixCls}-disabled`]: mergedDisabled
      }),
      href: mergedDisabled ? undefined : linkButtonRestProps.href,
      style: fullStyle,
      onClick: handleClick,
      ref: mergedRef,
      tabIndex: mergedDisabled ? -1 : 0
    }), iconNode, kids));
  }
  let buttonNode = /*#__PURE__*/react.createElement("button", Object.assign({}, rest, {
    type: htmlType,
    className: classes,
    style: fullStyle,
    onClick: handleClick,
    disabled: mergedDisabled,
    ref: mergedRef
  }), iconNode, kids, compactItemClassnames && /*#__PURE__*/react.createElement(compact, {
    prefixCls: prefixCls
  }));
  if (!(0,buttonHelpers/* isUnBorderedButtonVariant */.Dn)(mergedVariant)) {
    buttonNode = /*#__PURE__*/react.createElement(wave/* default */.Z, {
      component: "Button",
      disabled: innerLoading
    }, buttonNode);
  }
  return wrapCSSVar(buttonNode);
});
const Button = InternalCompoundedButton;
Button.Group = button_group;
Button.__ANT_BUTTON = true;
if (false) {}
/* harmony default export */ var button_button = (Button);
;// CONCATENATED MODULE: ./node_modules/antd/es/button/index.js
"use client";



/* harmony default export */ var es_button = (button_button);

/***/ }),

/***/ 96519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_col; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js
var context = __webpack_require__(94980);
// EXTERNAL MODULE: ./node_modules/antd/es/grid/RowContext.js
var RowContext = __webpack_require__(40531);
// EXTERNAL MODULE: ./node_modules/antd/es/grid/style/index.js
var grid_style = __webpack_require__(92630);
;// CONCATENATED MODULE: ./node_modules/antd/es/grid/col.js
"use client";

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





function parseFlex(flex) {
  if (typeof flex === 'number') {
    return `${flex} ${flex} auto`;
  }
  if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) {
    return `0 0 ${flex}`;
  }
  return flex;
}
const sizes = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
const Col = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    getPrefixCls,
    direction
  } = react.useContext(context/* ConfigContext */.E_);
  const {
    gutter,
    wrap
  } = react.useContext(RowContext/* default */.Z);
  const {
      prefixCls: customizePrefixCls,
      span,
      order,
      offset,
      push,
      pull,
      className,
      children,
      flex,
      style
    } = props,
    others = __rest(props, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children", "flex", "style"]);
  const prefixCls = getPrefixCls('col', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = (0,grid_style/* useColStyle */.cG)(prefixCls);
  // ===================== Size ======================
  const sizeStyle = {};
  let sizeClassObj = {};
  sizes.forEach(size => {
    let sizeProps = {};
    const propSize = props[size];
    if (typeof propSize === 'number') {
      sizeProps.span = propSize;
    } else if (typeof propSize === 'object') {
      sizeProps = propSize || {};
    }
    delete others[size];
    sizeClassObj = Object.assign(Object.assign({}, sizeClassObj), {
      [`${prefixCls}-${size}-${sizeProps.span}`]: sizeProps.span !== undefined,
      [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0,
      [`${prefixCls}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0,
      [`${prefixCls}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0,
      [`${prefixCls}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0,
      [`${prefixCls}-rtl`]: direction === 'rtl'
    });
    // Responsive flex layout
    if (sizeProps.flex) {
      sizeClassObj[`${prefixCls}-${size}-flex`] = true;
      sizeStyle[`--${prefixCls}-${size}-flex`] = parseFlex(sizeProps.flex);
    }
  });
  // ==================== Normal =====================
  const classes = classnames_default()(prefixCls, {
    [`${prefixCls}-${span}`]: span !== undefined,
    [`${prefixCls}-order-${order}`]: order,
    [`${prefixCls}-offset-${offset}`]: offset,
    [`${prefixCls}-push-${push}`]: push,
    [`${prefixCls}-pull-${pull}`]: pull
  }, className, sizeClassObj, hashId, cssVarCls);
  const mergedStyle = {};
  // Horizontal gutter use padding
  if (gutter && gutter[0] > 0) {
    const horizontalGutter = gutter[0] / 2;
    mergedStyle.paddingLeft = horizontalGutter;
    mergedStyle.paddingRight = horizontalGutter;
  }
  if (flex) {
    mergedStyle.flex = parseFlex(flex);
    // Hack for Firefox to avoid size issue
    // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
    if (wrap === false && !mergedStyle.minWidth) {
      mergedStyle.minWidth = 0;
    }
  }
  // ==================== Render =====================
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", Object.assign({}, others, {
    style: Object.assign(Object.assign(Object.assign({}, mergedStyle), style), sizeStyle),
    className: classes,
    ref: ref
  }), children));
});
if (false) {}
/* harmony default export */ var col = (Col);
;// CONCATENATED MODULE: ./node_modules/antd/es/col/index.js
"use client";


/* harmony default export */ var es_col = (col);

/***/ }),

/***/ 65606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y9": function() { return /* binding */ AggregationColor; }
/* harmony export */ });
/* unused harmony exports toHexFormat, getHex */
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6223);
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79427);
/* harmony import */ var _rc_component_color_picker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3434);



const toHexFormat = (value, alpha) => (value === null || value === void 0 ? void 0 : value.replace(/[^\w/]/g, '').slice(0, alpha ? 8 : 6)) || '';
const getHex = (value, alpha) => value ? toHexFormat(value, alpha) : '';
let AggregationColor = /*#__PURE__*/function () {
  function AggregationColor(color) {
    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, AggregationColor);
    var _a;
    this.cleared = false;
    // Clone from another AggregationColor
    if (color instanceof AggregationColor) {
      this.metaColor = color.metaColor.clone();
      this.colors = (_a = color.colors) === null || _a === void 0 ? void 0 : _a.map(info => ({
        color: new AggregationColor(info.color),
        percent: info.percent
      }));
      this.cleared = color.cleared;
      return;
    }
    const isArray = Array.isArray(color);
    if (isArray && color.length) {
      this.colors = color.map(({
        color: c,
        percent
      }) => ({
        color: new AggregationColor(c),
        percent
      }));
      this.metaColor = new _rc_component_color_picker__WEBPACK_IMPORTED_MODULE_0__/* .Color */ .Il(this.colors[0].color.metaColor);
    } else {
      this.metaColor = new _rc_component_color_picker__WEBPACK_IMPORTED_MODULE_0__/* .Color */ .Il(isArray ? '' : color);
    }
    if (!color || isArray && !this.colors) {
      this.metaColor = this.metaColor.setA(0);
      this.cleared = true;
    }
  }
  return (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(AggregationColor, [{
    key: "toHsb",
    value: function toHsb() {
      return this.metaColor.toHsb();
    }
  }, {
    key: "toHsbString",
    value: function toHsbString() {
      return this.metaColor.toHsbString();
    }
  }, {
    key: "toHex",
    value: function toHex() {
      return getHex(this.toHexString(), this.metaColor.a < 1);
    }
  }, {
    key: "toHexString",
    value: function toHexString() {
      return this.metaColor.toHexString();
    }
  }, {
    key: "toRgb",
    value: function toRgb() {
      return this.metaColor.toRgb();
    }
  }, {
    key: "toRgbString",
    value: function toRgbString() {
      return this.metaColor.toRgbString();
    }
  }, {
    key: "isGradient",
    value: function isGradient() {
      return !!this.colors && !this.cleared;
    }
  }, {
    key: "getColors",
    value: function getColors() {
      return this.colors || [{
        color: this,
        percent: 0
      }];
    }
  }, {
    key: "toCssString",
    value: function toCssString() {
      const {
        colors
      } = this;
      // CSS line-gradient
      if (colors) {
        const colorsStr = colors.map(c => `${c.color.toRgbString()} ${c.percent}%`).join(', ');
        return `linear-gradient(90deg, ${colorsStr})`;
      }
      return this.metaColor.toRgbString();
    }
  }, {
    key: "equals",
    value: function equals(color) {
      if (!color || this.isGradient() !== color.isGradient()) {
        return false;
      }
      if (!this.isGradient()) {
        return this.toHexString() === color.toHexString();
      }
      return this.colors.length === color.colors.length && this.colors.every((c, i) => {
        const target = color.colors[i];
        return c.percent === target.percent && c.color.equals(target.color);
      });
    }
  }]);
}();

/***/ }),

/***/ 85508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ DisabledContextProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
"use client";


const DisabledContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(false);
const DisabledContextProvider = ({
  children,
  disabled
}) => {
  const originDisabled = react__WEBPACK_IMPORTED_MODULE_0__.useContext(DisabledContext);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DisabledContext.Provider, {
    value: disabled !== null && disabled !== void 0 ? disabled : originDisabled
  }, children);
};
/* harmony default export */ __webpack_exports__["Z"] = (DisabledContext);

/***/ }),

/***/ 41208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ SizeContextProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
"use client";


const SizeContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);
const SizeContextProvider = ({
  children,
  size
}) => {
  const originSize = react__WEBPACK_IMPORTED_MODULE_0__.useContext(SizeContext);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(SizeContext.Provider, {
    value: size || originSize
  }, children);
};
/* harmony default export */ __webpack_exports__["Z"] = (SizeContext);

/***/ }),

/***/ 96093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ unstableSetRender; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85202);
/* harmony import */ var rc_util_es_React_render__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52010);
"use client";





const defaultReactRender = (node, container) => {
  // TODO: Remove in v6
  // Warning for React 19
  if (false) {}
  (0,rc_util_es_React_render__WEBPACK_IMPORTED_MODULE_2__/* .render */ .s)(node, container);
  return () => {
    return (0,rc_util_es_React_render__WEBPACK_IMPORTED_MODULE_2__/* .unmount */ .v)(container);
  };
};
let unstableRender = defaultReactRender;
/**
 * @deprecated Set React render function for compatible usage.
 * This is internal usage only compatible with React 19.
 * And will be removed in next major version.
 */
function unstableSetRender(render) {
  if (render) {
    unstableRender = render;
  }
  return unstableRender;
}

/***/ }),

/***/ 94980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E_": function() { return /* binding */ ConfigContext; },
/* harmony export */   "Rf": function() { return /* binding */ defaultPrefixCls; },
/* harmony export */   "dj": function() { return /* binding */ useComponentConfig; },
/* harmony export */   "oR": function() { return /* binding */ defaultIconPrefixCls; },
/* harmony export */   "tr": function() { return /* binding */ Variants; }
/* harmony export */ });
/* unused harmony export ConfigConsumer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);

const defaultPrefixCls = 'ant';
const defaultIconPrefixCls = 'anticon';
const Variants = ['outlined', 'borderless', 'filled', 'underlined'];
const defaultGetPrefixCls = (suffixCls, customizePrefixCls) => {
  if (customizePrefixCls) {
    return customizePrefixCls;
  }
  return suffixCls ? `${defaultPrefixCls}-${suffixCls}` : defaultPrefixCls;
};
// zombieJ: 🚨 Do not pass `defaultRenderEmpty` here since it will cause circular dependency.
const ConfigContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: defaultGetPrefixCls,
  iconPrefixCls: defaultIconPrefixCls
});
const {
  Consumer: ConfigConsumer
} = ConfigContext;
const EMPTY_OBJECT = {};
/**
 * Get ConfigProvider configured component props.
 * This help to reduce bundle size for saving `?.` operator.
 * Do not use as `useMemo` deps since we do not cache the object here.
 *
 * NOTE: not refactor this with `useMemo` since memo will cost another memory space,
 * which will waste both compare calculation & memory.
 */
function useComponentConfig(propName) {
  const context = react__WEBPACK_IMPORTED_MODULE_0__.useContext(ConfigContext);
  const {
    getPrefixCls,
    direction,
    getPopupContainer
  } = context;
  const propValue = context[propName];
  return Object.assign(Object.assign({
    classNames: EMPTY_OBJECT,
    styles: EMPTY_OBJECT
  }, propValue), {
    getPrefixCls,
    direction,
    getPopupContainer
  });
}

/***/ }),

/***/ 5869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _theme_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39779);

/**
 * This hook is only for cssVar to add root className for components.
 * If root ClassName is needed, this hook could be refactored with `-root`
 * @param prefixCls
 */
const useCSSVarCls = prefixCls => {
  const [,,,, cssVar] = (0,_theme_internal__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)();
  return cssVar ? `${prefixCls}-css-var` : '';
};
/* harmony default export */ __webpack_exports__["Z"] = (useCSSVarCls);

/***/ }),

/***/ 27011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var _SizeContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41208);


const useSize = customSize => {
  const size = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_SizeContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
  const mergedSize = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (!customSize) {
      return size;
    }
    if (typeof customSize === 'string') {
      return customSize !== null && customSize !== void 0 ? customSize : size;
    }
    if (typeof customSize === 'function') {
      return customSize(size);
    }
    return size;
  }, [customSize, size]);
  return mergedSize;
};
/* harmony default export */ __webpack_exports__["Z"] = (useSize);

/***/ }),

/***/ 73898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ config_provider; },
  "w6": function() { return /* binding */ globalConfig; }
});

// UNUSED EXPORTS: ConfigConsumer, ConfigContext, Variants, configConsumerProps, defaultIconPrefixCls, defaultPrefixCls, warnContext

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs/es/index.js + 37 modules
var es = __webpack_require__(68946);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Context.js
var Context = __webpack_require__(15479);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMemo.js
var useMemo = __webpack_require__(99834);
// EXTERNAL MODULE: ./node_modules/rc-util/es/utils/set.js
var set = __webpack_require__(57935);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/warning.js
var _util_warning = __webpack_require__(85251);
;// CONCATENATED MODULE: ./node_modules/antd/es/form/validateMessagesContext.js
"use client";


// ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-field-form`
/* harmony default export */ var validateMessagesContext = (/*#__PURE__*/(0,react.createContext)(undefined));
// EXTERNAL MODULE: ./node_modules/antd/es/modal/locale.js
var modal_locale = __webpack_require__(4803);
// EXTERNAL MODULE: ./node_modules/antd/es/locale/context.js
var locale_context = __webpack_require__(87303);
;// CONCATENATED MODULE: ./node_modules/antd/es/locale/index.js
"use client";






const ANT_MARK = 'internalMark';
const LocaleProvider = props => {
  const {
    locale = {},
    children,
    _ANT_MARK__
  } = props;
  if (false) {}
  react.useEffect(() => {
    const clearLocale = (0,modal_locale/* changeConfirmLocale */.f)(locale === null || locale === void 0 ? void 0 : locale.Modal);
    return clearLocale;
  }, [locale]);
  const getMemoizedContextValue = react.useMemo(() => Object.assign(Object.assign({}, locale), {
    exist: true
  }), [locale]);
  return /*#__PURE__*/react.createElement(locale_context/* default.Provider */.Z.Provider, {
    value: getMemoizedContextValue
  }, children);
};
if (false) {}
/* harmony default export */ var es_locale = (LocaleProvider);
// EXTERNAL MODULE: ./node_modules/antd/es/locale/en_US.js + 1 modules
var en_US = __webpack_require__(72380);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/themes/default/theme.js + 9 modules
var default_theme = __webpack_require__(17869);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/context.js
var context = __webpack_require__(93897);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/themes/seed.js
var seed = __webpack_require__(77177);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js
var config_provider_context = __webpack_require__(94980);
// EXTERNAL MODULE: ./node_modules/@ant-design/colors/es/index.js + 2 modules
var colors_es = __webpack_require__(61835);
// EXTERNAL MODULE: ./node_modules/@ant-design/fast-color/es/index.js + 1 modules
var fast_color_es = __webpack_require__(99620);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/canUseDom.js
var canUseDom = __webpack_require__(55304);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/dynamicCSS.js
var dynamicCSS = __webpack_require__(6779);
;// CONCATENATED MODULE: ./node_modules/antd/es/config-provider/cssVariables.js





const dynamicStyleMark = `-ant-${Date.now()}-${Math.random()}`;
function getStyle(globalPrefixCls, theme) {
  const variables = {};
  const formatColor = (color, updater) => {
    let clone = color.clone();
    clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
    return clone.toRgbString();
  };
  const fillColor = (colorVal, type) => {
    const baseColor = new fast_color_es/* FastColor */.t(colorVal);
    const colorPalettes = (0,colors_es/* generate */.R_)(baseColor.toRgbString());
    variables[`${type}-color`] = formatColor(baseColor);
    variables[`${type}-color-disabled`] = colorPalettes[1];
    variables[`${type}-color-hover`] = colorPalettes[4];
    variables[`${type}-color-active`] = colorPalettes[6];
    variables[`${type}-color-outline`] = baseColor.clone().setA(0.2).toRgbString();
    variables[`${type}-color-deprecated-bg`] = colorPalettes[0];
    variables[`${type}-color-deprecated-border`] = colorPalettes[2];
  };
  // ================ Primary Color ================
  if (theme.primaryColor) {
    fillColor(theme.primaryColor, 'primary');
    const primaryColor = new fast_color_es/* FastColor */.t(theme.primaryColor);
    const primaryColors = (0,colors_es/* generate */.R_)(primaryColor.toRgbString());
    // Legacy - We should use semantic naming standard
    primaryColors.forEach((color, index) => {
      variables[`primary-${index + 1}`] = color;
    });
    // Deprecated
    variables['primary-color-deprecated-l-35'] = formatColor(primaryColor, c => c.lighten(35));
    variables['primary-color-deprecated-l-20'] = formatColor(primaryColor, c => c.lighten(20));
    variables['primary-color-deprecated-t-20'] = formatColor(primaryColor, c => c.tint(20));
    variables['primary-color-deprecated-t-50'] = formatColor(primaryColor, c => c.tint(50));
    variables['primary-color-deprecated-f-12'] = formatColor(primaryColor, c => c.setA(c.a * 0.12));
    const primaryActiveColor = new fast_color_es/* FastColor */.t(primaryColors[0]);
    variables['primary-color-active-deprecated-f-30'] = formatColor(primaryActiveColor, c => c.setA(c.a * 0.3));
    variables['primary-color-active-deprecated-d-02'] = formatColor(primaryActiveColor, c => c.darken(2));
  }
  // ================ Success Color ================
  if (theme.successColor) {
    fillColor(theme.successColor, 'success');
  }
  // ================ Warning Color ================
  if (theme.warningColor) {
    fillColor(theme.warningColor, 'warning');
  }
  // ================= Error Color =================
  if (theme.errorColor) {
    fillColor(theme.errorColor, 'error');
  }
  // ================= Info Color ==================
  if (theme.infoColor) {
    fillColor(theme.infoColor, 'info');
  }
  // Convert to css variables
  const cssList = Object.keys(variables).map(key => `--${globalPrefixCls}-${key}: ${variables[key]};`);
  return `
  :root {
    ${cssList.join('\n')}
  }
  `.trim();
}
function registerTheme(globalPrefixCls, theme) {
  const style = getStyle(globalPrefixCls, theme);
  if ((0,canUseDom/* default */.Z)()) {
    (0,dynamicCSS/* updateCSS */.hq)(style, `${dynamicStyleMark}-dynamic-theme`);
  } else {
     false ? 0 : void 0;
  }
}
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/DisabledContext.js
var DisabledContext = __webpack_require__(85508);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/SizeContext.js
var SizeContext = __webpack_require__(41208);
;// CONCATENATED MODULE: ./node_modules/antd/es/config-provider/hooks/useConfig.js



function useConfig() {
  const componentDisabled = (0,react.useContext)(DisabledContext/* default */.Z);
  const componentSize = (0,react.useContext)(SizeContext/* default */.Z);
  return {
    componentDisabled,
    componentSize
  };
}
/* harmony default export */ var hooks_useConfig = (useConfig);
// EXTERNAL MODULE: ./node_modules/rc-util/es/isEqual.js
var isEqual = __webpack_require__(55159);
;// CONCATENATED MODULE: ./node_modules/antd/es/config-provider/hooks/useThemeKey.js

const fullClone = Object.assign({}, react_namespaceObject);
const {
  useId
} = fullClone;
const useEmptyId = () => '';
const useThemeKey = typeof useId === 'undefined' ? useEmptyId : useId;
/* harmony default export */ var hooks_useThemeKey = (useThemeKey);
;// CONCATENATED MODULE: ./node_modules/antd/es/config-provider/hooks/useTheme.js





function useTheme(theme, parentTheme, config) {
  var _a, _b;
  const warning = (0,_util_warning/* devUseWarning */.ln)('ConfigProvider');
  const themeConfig = theme || {};
  const parentThemeConfig = themeConfig.inherit === false || !parentTheme ? Object.assign(Object.assign({}, context/* defaultConfig */.u_), {
    hashed: (_a = parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.hashed) !== null && _a !== void 0 ? _a : context/* defaultConfig.hashed */.u_.hashed,
    cssVar: parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.cssVar
  }) : parentTheme;
  const themeKey = hooks_useThemeKey();
  if (false) {}
  return (0,useMemo/* default */.Z)(() => {
    var _a, _b;
    if (!theme) {
      return parentTheme;
    }
    // Override
    const mergedComponents = Object.assign({}, parentThemeConfig.components);
    Object.keys(theme.components || {}).forEach(componentName => {
      mergedComponents[componentName] = Object.assign(Object.assign({}, mergedComponents[componentName]), theme.components[componentName]);
    });
    const cssVarKey = `css-var-${themeKey.replace(/:/g, '')}`;
    const mergedCssVar = ((_a = themeConfig.cssVar) !== null && _a !== void 0 ? _a : parentThemeConfig.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: config === null || config === void 0 ? void 0 : config.prefixCls
    }, typeof parentThemeConfig.cssVar === 'object' ? parentThemeConfig.cssVar : {}), typeof themeConfig.cssVar === 'object' ? themeConfig.cssVar : {}), {
      key: typeof themeConfig.cssVar === 'object' && ((_b = themeConfig.cssVar) === null || _b === void 0 ? void 0 : _b.key) || cssVarKey
    });
    // Base token
    return Object.assign(Object.assign(Object.assign({}, parentThemeConfig), themeConfig), {
      token: Object.assign(Object.assign({}, parentThemeConfig.token), themeConfig.token),
      components: mergedComponents,
      cssVar: mergedCssVar
    });
  }, [themeConfig, parentThemeConfig], (prev, next) => prev.some((prevTheme, index) => {
    const nextTheme = next[index];
    return !(0,isEqual/* default */.Z)(prevTheme, nextTheme, true);
  }));
}
// EXTERNAL MODULE: ./node_modules/rc-motion/es/index.js + 13 modules
var rc_motion_es = __webpack_require__(26981);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/useToken.js + 3 modules
var useToken = __webpack_require__(39779);
;// CONCATENATED MODULE: ./node_modules/antd/es/config-provider/MotionWrapper.js
"use client";




const MotionCacheContext = /*#__PURE__*/react.createContext(true);
if (false) {}
function MotionWrapper(props) {
  const parentMotion = react.useContext(MotionCacheContext);
  const {
    children
  } = props;
  const [, token] = (0,useToken/* default */.ZP)();
  const {
    motion
  } = token;
  const needWrapMotionProviderRef = react.useRef(false);
  needWrapMotionProviderRef.current || (needWrapMotionProviderRef.current = parentMotion !== motion);
  if (needWrapMotionProviderRef.current) {
    return /*#__PURE__*/react.createElement(MotionCacheContext.Provider, {
      value: motion
    }, /*#__PURE__*/react.createElement(rc_motion_es/* Provider */.zt, {
      motion: motion
    }, children));
  }
  return children;
}
;// CONCATENATED MODULE: ./node_modules/antd/es/config-provider/PropWarning.js
"use client";



/**
 * Warning for ConfigProviderProps.
 * This will be empty function in production.
 */
const PropWarning = /*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(({
  dropdownMatchSelectWidth
}) => {
  const warning = devUseWarning('ConfigProvider');
  warning.deprecated(dropdownMatchSelectWidth === undefined, 'dropdownMatchSelectWidth', 'popupMatchSelectWidth');
  return null;
})));
if (false) {}
/* harmony default export */ var config_provider_PropWarning = ( false ? 0 : () => null);
// EXTERNAL MODULE: ./node_modules/antd/es/style/index.js
var style = __webpack_require__(31875);
;// CONCATENATED MODULE: ./node_modules/antd/es/theme/util/useResetIconStyle.js



const useResetIconStyle = (iconPrefixCls, csp) => {
  const [theme, token] = (0,useToken/* default */.ZP)();
  // Generate style for icons
  return (0,es/* useStyleRegister */.xy)({
    theme,
    token,
    hashId: '',
    path: ['ant-design-icons', iconPrefixCls],
    nonce: () => csp === null || csp === void 0 ? void 0 : csp.nonce,
    layer: {
      name: 'antd'
    }
  }, () => (0,style/* genIconStyle */.JT)(iconPrefixCls));
};
/* harmony default export */ var util_useResetIconStyle = (useResetIconStyle);
;// CONCATENATED MODULE: ./node_modules/antd/es/config-provider/index.js
"use client";

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






















/**
 * Since too many feedback using static method like `Modal.confirm` not getting theme, we record the
 * theme register info here to help developer get warning info.
 */
let existThemeConfig = false;
const warnContext = (/* unused pure expression or super */ null && ( false ? 0 : /* istanbul ignore next */
null));

const configConsumerProps = (/* unused pure expression or super */ null && (['getTargetContainer', 'getPopupContainer', 'rootPrefixCls', 'getPrefixCls', 'renderEmpty', 'csp', 'autoInsertSpaceInButton', 'locale']));
// These props is used by `useContext` directly in sub component
const PASSED_PROPS = ['getTargetContainer', 'getPopupContainer', 'renderEmpty', 'input', 'pagination', 'form', 'select', 'button'];
let globalPrefixCls;
let globalIconPrefixCls;
let globalTheme;
let globalHolderRender;
function getGlobalPrefixCls() {
  return globalPrefixCls || config_provider_context/* defaultPrefixCls */.Rf;
}
function getGlobalIconPrefixCls() {
  return globalIconPrefixCls || config_provider_context/* defaultIconPrefixCls */.oR;
}
function isLegacyTheme(theme) {
  return Object.keys(theme).some(key => key.endsWith('Color'));
}
const setGlobalConfig = props => {
  const {
    prefixCls,
    iconPrefixCls,
    theme,
    holderRender
  } = props;
  if (prefixCls !== undefined) {
    globalPrefixCls = prefixCls;
  }
  if (iconPrefixCls !== undefined) {
    globalIconPrefixCls = iconPrefixCls;
  }
  if ('holderRender' in props) {
    globalHolderRender = holderRender;
  }
  if (theme) {
    if (isLegacyTheme(theme)) {
       false ? 0 : void 0;
      registerTheme(getGlobalPrefixCls(), theme);
    } else {
      globalTheme = theme;
    }
  }
};
const globalConfig = () => ({
  getPrefixCls: (suffixCls, customizePrefixCls) => {
    if (customizePrefixCls) {
      return customizePrefixCls;
    }
    return suffixCls ? `${getGlobalPrefixCls()}-${suffixCls}` : getGlobalPrefixCls();
  },
  getIconPrefixCls: getGlobalIconPrefixCls,
  getRootPrefixCls: () => {
    // If Global prefixCls provided, use this
    if (globalPrefixCls) {
      return globalPrefixCls;
    }
    // Fallback to default prefixCls
    return getGlobalPrefixCls();
  },
  getTheme: () => globalTheme,
  holderRender: globalHolderRender
});
const ProviderChildren = props => {
  const {
    children,
    csp: customCsp,
    autoInsertSpaceInButton,
    alert,
    anchor,
    form,
    locale,
    componentSize,
    direction,
    space,
    splitter,
    virtual,
    dropdownMatchSelectWidth,
    popupMatchSelectWidth,
    popupOverflow,
    legacyLocale,
    parentContext,
    iconPrefixCls: customIconPrefixCls,
    theme,
    componentDisabled,
    segmented,
    statistic,
    spin,
    calendar,
    carousel,
    cascader,
    collapse,
    typography,
    checkbox,
    descriptions,
    divider,
    drawer,
    skeleton,
    steps,
    image,
    layout,
    list,
    mentions,
    modal,
    progress,
    result,
    slider,
    breadcrumb,
    menu,
    pagination,
    input,
    textArea,
    empty,
    badge,
    radio,
    rate,
    switch: SWITCH,
    transfer,
    avatar,
    message,
    tag,
    table,
    card,
    tabs,
    timeline,
    timePicker,
    upload,
    notification,
    tree,
    colorPicker,
    datePicker,
    rangePicker,
    flex,
    wave,
    dropdown,
    warning: warningConfig,
    tour,
    tooltip,
    popover,
    popconfirm,
    floatButton,
    floatButtonGroup,
    variant,
    inputNumber,
    treeSelect
  } = props;
  // =================================== Context ===================================
  const getPrefixCls = react.useCallback((suffixCls, customizePrefixCls) => {
    const {
      prefixCls
    } = props;
    if (customizePrefixCls) {
      return customizePrefixCls;
    }
    const mergedPrefixCls = prefixCls || parentContext.getPrefixCls('');
    return suffixCls ? `${mergedPrefixCls}-${suffixCls}` : mergedPrefixCls;
  }, [parentContext.getPrefixCls, props.prefixCls]);
  const iconPrefixCls = customIconPrefixCls || parentContext.iconPrefixCls || config_provider_context/* defaultIconPrefixCls */.oR;
  const csp = customCsp || parentContext.csp;
  util_useResetIconStyle(iconPrefixCls, csp);
  const mergedTheme = useTheme(theme, parentContext.theme, {
    prefixCls: getPrefixCls('')
  });
  if (false) {}
  const baseConfig = {
    csp,
    autoInsertSpaceInButton,
    alert,
    anchor,
    locale: locale || legacyLocale,
    direction,
    space,
    splitter,
    virtual,
    popupMatchSelectWidth: popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth,
    popupOverflow,
    getPrefixCls,
    iconPrefixCls,
    theme: mergedTheme,
    segmented,
    statistic,
    spin,
    calendar,
    carousel,
    cascader,
    collapse,
    typography,
    checkbox,
    descriptions,
    divider,
    drawer,
    skeleton,
    steps,
    image,
    input,
    textArea,
    layout,
    list,
    mentions,
    modal,
    progress,
    result,
    slider,
    breadcrumb,
    menu,
    pagination,
    empty,
    badge,
    radio,
    rate,
    switch: SWITCH,
    transfer,
    avatar,
    message,
    tag,
    table,
    card,
    tabs,
    timeline,
    timePicker,
    upload,
    notification,
    tree,
    colorPicker,
    datePicker,
    rangePicker,
    flex,
    wave,
    dropdown,
    warning: warningConfig,
    tour,
    tooltip,
    popover,
    popconfirm,
    floatButton,
    floatButtonGroup,
    variant,
    inputNumber,
    treeSelect
  };
  if (false) {}
  const config = Object.assign({}, parentContext);
  Object.keys(baseConfig).forEach(key => {
    if (baseConfig[key] !== undefined) {
      config[key] = baseConfig[key];
    }
  });
  // Pass the props used by `useContext` directly with child component.
  // These props should merged into `config`.
  PASSED_PROPS.forEach(propName => {
    const propValue = props[propName];
    if (propValue) {
      config[propName] = propValue;
    }
  });
  if (typeof autoInsertSpaceInButton !== 'undefined') {
    // merge deprecated api
    config.button = Object.assign({
      autoInsertSpace: autoInsertSpaceInButton
    }, config.button);
  }
  // https://github.com/ant-design/ant-design/issues/27617
  const memoedConfig = (0,useMemo/* default */.Z)(() => config, config, (prevConfig, currentConfig) => {
    const prevKeys = Object.keys(prevConfig);
    const currentKeys = Object.keys(currentConfig);
    return prevKeys.length !== currentKeys.length || prevKeys.some(key => prevConfig[key] !== currentConfig[key]);
  });
  const {
    layer
  } = react.useContext(es/* StyleContext */.uP);
  const memoIconContextValue = react.useMemo(() => ({
    prefixCls: iconPrefixCls,
    csp,
    layer: layer ? 'antd' : undefined
  }), [iconPrefixCls, csp, layer]);
  let childNode = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(config_provider_PropWarning, {
    dropdownMatchSelectWidth: dropdownMatchSelectWidth
  }), children);
  const validateMessages = react.useMemo(() => {
    var _a, _b, _c, _d;
    return (0,set/* merge */.T)(((_a = en_US/* default.Form */.Z.Form) === null || _a === void 0 ? void 0 : _a.defaultValidateMessages) || {}, ((_c = (_b = memoedConfig.locale) === null || _b === void 0 ? void 0 : _b.Form) === null || _c === void 0 ? void 0 : _c.defaultValidateMessages) || {}, ((_d = memoedConfig.form) === null || _d === void 0 ? void 0 : _d.validateMessages) || {}, (form === null || form === void 0 ? void 0 : form.validateMessages) || {});
  }, [memoedConfig, form === null || form === void 0 ? void 0 : form.validateMessages]);
  if (Object.keys(validateMessages).length > 0) {
    childNode = /*#__PURE__*/react.createElement(validateMessagesContext.Provider, {
      value: validateMessages
    }, childNode);
  }
  if (locale) {
    childNode = /*#__PURE__*/react.createElement(es_locale, {
      locale: locale,
      _ANT_MARK__: ANT_MARK
    }, childNode);
  }
  if (iconPrefixCls || csp) {
    childNode = /*#__PURE__*/react.createElement(Context/* default.Provider */.Z.Provider, {
      value: memoIconContextValue
    }, childNode);
  }
  if (componentSize) {
    childNode = /*#__PURE__*/react.createElement(SizeContext/* SizeContextProvider */.q, {
      size: componentSize
    }, childNode);
  }
  // =================================== Motion ===================================
  childNode = /*#__PURE__*/react.createElement(MotionWrapper, null, childNode);
  // ================================ Dynamic theme ================================
  const memoTheme = react.useMemo(() => {
    const _a = mergedTheme || {},
      {
        algorithm,
        token,
        components,
        cssVar
      } = _a,
      rest = __rest(_a, ["algorithm", "token", "components", "cssVar"]);
    const themeObj = algorithm && (!Array.isArray(algorithm) || algorithm.length > 0) ? (0,es/* createTheme */.jG)(algorithm) : default_theme/* default */.Z;
    const parsedComponents = {};
    Object.entries(components || {}).forEach(([componentName, componentToken]) => {
      const parsedToken = Object.assign({}, componentToken);
      if ('algorithm' in parsedToken) {
        if (parsedToken.algorithm === true) {
          parsedToken.theme = themeObj;
        } else if (Array.isArray(parsedToken.algorithm) || typeof parsedToken.algorithm === 'function') {
          parsedToken.theme = (0,es/* createTheme */.jG)(parsedToken.algorithm);
        }
        delete parsedToken.algorithm;
      }
      parsedComponents[componentName] = parsedToken;
    });
    const mergedToken = Object.assign(Object.assign({}, seed/* default */.Z), token);
    return Object.assign(Object.assign({}, rest), {
      theme: themeObj,
      token: mergedToken,
      components: parsedComponents,
      override: Object.assign({
        override: mergedToken
      }, parsedComponents),
      cssVar: cssVar
    });
  }, [mergedTheme]);
  if (theme) {
    childNode = /*#__PURE__*/react.createElement(context/* DesignTokenContext.Provider */.Mj.Provider, {
      value: memoTheme
    }, childNode);
  }
  // ================================== Warning ===================================
  if (memoedConfig.warning) {
    childNode = /*#__PURE__*/react.createElement(_util_warning/* WarningContext.Provider */.G8.Provider, {
      value: memoedConfig.warning
    }, childNode);
  }
  // =================================== Render ===================================
  if (componentDisabled !== undefined) {
    childNode = /*#__PURE__*/react.createElement(DisabledContext/* DisabledContextProvider */.n, {
      disabled: componentDisabled
    }, childNode);
  }
  return /*#__PURE__*/react.createElement(config_provider_context/* ConfigContext.Provider */.E_.Provider, {
    value: memoedConfig
  }, childNode);
};
const ConfigProvider = props => {
  const context = react.useContext(config_provider_context/* ConfigContext */.E_);
  const antLocale = react.useContext(locale_context/* default */.Z);
  return /*#__PURE__*/react.createElement(ProviderChildren, Object.assign({
    parentContext: context,
    legacyLocale: antLocale
  }, props));
};
ConfigProvider.ConfigContext = config_provider_context/* ConfigContext */.E_;
ConfigProvider.SizeContext = SizeContext/* default */.Z;
ConfigProvider.config = setGlobalConfig;
ConfigProvider.useConfig = hooks_useConfig;
Object.defineProperty(ConfigProvider, 'SizeContext', {
  get: () => {
     false ? 0 : void 0;
    return SizeContext/* default */.Z;
  }
});
if (false) {}
/* harmony default export */ var config_provider = (ConfigProvider);

/***/ }),

/***/ 41038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var rc_picker_es_locale_en_US__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50371);
/* harmony import */ var _time_picker_locale_en_US__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54539);


// Merge into a locale object
const locale = {
  lang: Object.assign({
    placeholder: 'Select date',
    yearPlaceholder: 'Select year',
    quarterPlaceholder: 'Select quarter',
    monthPlaceholder: 'Select month',
    weekPlaceholder: 'Select week',
    rangePlaceholder: ['Start date', 'End date'],
    rangeYearPlaceholder: ['Start year', 'End year'],
    rangeQuarterPlaceholder: ['Start quarter', 'End quarter'],
    rangeMonthPlaceholder: ['Start month', 'End month'],
    rangeWeekPlaceholder: ['Start week', 'End week']
  }, rc_picker_es_locale_en_US__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z),
  timePickerLocale: Object.assign({}, _time_picker_locale_en_US__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)
};
// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
/* harmony default export */ __webpack_exports__["Z"] = (locale);

/***/ }),

/***/ 9234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ux": function() { return /* binding */ NoFormStyle; },
/* harmony export */   "aM": function() { return /* binding */ FormItemInputContext; },
/* harmony export */   "pg": function() { return /* binding */ VariantContext; }
/* harmony export */ });
/* unused harmony exports FormContext, NoStyleItemContext, FormProvider, FormItemPrefixContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var rc_field_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54888);
"use client";




const FormContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  labelAlign: 'right',
  layout: 'horizontal',
  itemRef: () => {}
});
const NoStyleItemContext = /*#__PURE__*/(/* unused pure expression or super */ null && (React.createContext(null)));
const FormProvider = props => {
  const providerProps = omit(props, ['prefixCls']);
  return /*#__PURE__*/React.createElement(RcFormProvider, Object.assign({}, providerProps));
};
const FormItemPrefixContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  prefixCls: ''
});
const FormItemInputContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
if (false) {}
const NoFormStyle = ({
  children,
  status,
  override
}) => {
  const formItemInputContext = react__WEBPACK_IMPORTED_MODULE_0__.useContext(FormItemInputContext);
  const newFormItemInputContext = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    const newContext = Object.assign({}, formItemInputContext);
    if (override) {
      delete newContext.isFormItemInput;
    }
    if (status) {
      delete newContext.status;
      delete newContext.hasFeedback;
      delete newContext.feedbackIcon;
    }
    return newContext;
  }, [status, override, formItemInputContext]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(FormItemInputContext.Provider, {
    value: newFormItemInputContext
  }, children);
};
const VariantContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);

/***/ }),

/***/ 40531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);

const RowContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
/* harmony default export */ __webpack_exports__["Z"] = (RowContext);

/***/ }),

/***/ 90909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var rc_util_es_hooks_useLayoutEffect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76963);
/* harmony import */ var _util_hooks_useForceUpdate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74215);
/* harmony import */ var _util_responsiveObserver__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81840);
"use client";





function useBreakpoint(refreshOnChange = true, defaultScreens = {}) {
  const screensRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(defaultScreens);
  const forceUpdate = (0,_util_hooks_useForceUpdate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  const responsiveObserver = (0,_util_responsiveObserver__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)();
  (0,rc_util_es_hooks_useLayoutEffect__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(() => {
    const token = responsiveObserver.subscribe(supportScreens => {
      screensRef.current = supportScreens;
      if (refreshOnChange) {
        forceUpdate();
      }
    });
    return () => responsiveObserver.unsubscribe(token);
  }, []);
  return screensRef.current;
}
/* harmony default export */ __webpack_exports__["Z"] = (useBreakpoint);

/***/ }),

/***/ 92630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VM": function() { return /* binding */ useRowStyle; },
/* harmony export */   "cG": function() { return /* binding */ useColStyle; },
/* harmony export */   "hd": function() { return /* binding */ getMediaSize; }
/* harmony export */ });
/* unused harmony exports prepareRowComponentToken, prepareColComponentToken */
/* harmony import */ var _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68946);
/* harmony import */ var _theme_internal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18511);
/* harmony import */ var _theme_internal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89158);


// ============================== Row-Shared ==============================
const genGridRowStyle = token => {
  const {
    componentCls
  } = token;
  return {
    // Grid system
    [componentCls]: {
      display: 'flex',
      flexFlow: 'row wrap',
      minWidth: 0,
      '&::before, &::after': {
        display: 'flex'
      },
      '&-no-wrap': {
        flexWrap: 'nowrap'
      },
      // The origin of the X-axis
      '&-start': {
        justifyContent: 'flex-start'
      },
      // The center of the X-axis
      '&-center': {
        justifyContent: 'center'
      },
      // The opposite of the X-axis
      '&-end': {
        justifyContent: 'flex-end'
      },
      '&-space-between': {
        justifyContent: 'space-between'
      },
      '&-space-around': {
        justifyContent: 'space-around'
      },
      '&-space-evenly': {
        justifyContent: 'space-evenly'
      },
      // Align at the top
      '&-top': {
        alignItems: 'flex-start'
      },
      // Align at the center
      '&-middle': {
        alignItems: 'center'
      },
      '&-bottom': {
        alignItems: 'flex-end'
      }
    }
  };
};
// ============================== Col-Shared ==============================
const genGridColStyle = token => {
  const {
    componentCls
  } = token;
  return {
    // Grid system
    [componentCls]: {
      position: 'relative',
      maxWidth: '100%',
      // Prevent columns from collapsing when empty
      minHeight: 1
    }
  };
};
const genLoopGridColumnsStyle = (token, sizeCls) => {
  const {
    prefixCls,
    componentCls,
    gridColumns
  } = token;
  const gridColumnsStyle = {};
  for (let i = gridColumns; i >= 0; i--) {
    if (i === 0) {
      gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = {
        display: 'none'
      };
      gridColumnsStyle[`${componentCls}-push-${i}`] = {
        insetInlineStart: 'auto'
      };
      gridColumnsStyle[`${componentCls}-pull-${i}`] = {
        insetInlineEnd: 'auto'
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
        insetInlineStart: 'auto'
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
        insetInlineEnd: 'auto'
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
        marginInlineStart: 0
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
        order: 0
      };
    } else {
      gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = [
      // https://github.com/ant-design/ant-design/issues/44456
      // Form set `display: flex` on Col which will override `display: block`.
      // Let's get it from css variable to support override.
      {
        ['--ant-display']: 'block',
        // Fallback to display if variable not support
        display: 'block'
      }, {
        display: 'var(--ant-display)',
        flex: `0 0 ${i / gridColumns * 100}%`,
        maxWidth: `${i / gridColumns * 100}%`
      }];
      gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
        insetInlineStart: `${i / gridColumns * 100}%`
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
        insetInlineEnd: `${i / gridColumns * 100}%`
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
        marginInlineStart: `${i / gridColumns * 100}%`
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
        order: i
      };
    }
  }
  // Flex CSS Var
  gridColumnsStyle[`${componentCls}${sizeCls}-flex`] = {
    flex: `var(--${prefixCls}${sizeCls}-flex)`
  };
  return gridColumnsStyle;
};
const genGridStyle = (token, sizeCls) => genLoopGridColumnsStyle(token, sizeCls);
const genGridMediaStyle = (token, screenSize, sizeCls) => ({
  [`@media (min-width: ${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(screenSize)})`]: Object.assign({}, genGridStyle(token, sizeCls))
});
const prepareRowComponentToken = () => ({});
const prepareColComponentToken = () => ({});
// ============================== Export ==============================
const useRowStyle = (0,_theme_internal__WEBPACK_IMPORTED_MODULE_1__/* .genStyleHooks */ .I$)('Grid', genGridRowStyle, prepareRowComponentToken);
const getMediaSize = token => {
  const mediaSizesMap = {
    xs: token.screenXSMin,
    sm: token.screenSMMin,
    md: token.screenMDMin,
    lg: token.screenLGMin,
    xl: token.screenXLMin,
    xxl: token.screenXXLMin
  };
  return mediaSizesMap;
};
const useColStyle = (0,_theme_internal__WEBPACK_IMPORTED_MODULE_1__/* .genStyleHooks */ .I$)('Grid', token => {
  const gridToken = (0,_theme_internal__WEBPACK_IMPORTED_MODULE_2__/* .mergeToken */ .IX)(token, {
    gridColumns: 24 // Row is divided into 24 parts in Grid
  });
  const gridMediaSizesMap = getMediaSize(gridToken);
  delete gridMediaSizesMap.xs;
  return [genGridColStyle(gridToken), genGridStyle(gridToken, ''), genGridStyle(gridToken, '-xs'), Object.keys(gridMediaSizesMap).map(key => genGridMediaStyle(gridToken, gridMediaSizesMap[key], `-${key}`)).reduce((pre, cur) => Object.assign(Object.assign({}, pre), cur), {})];
}, prepareColComponentToken);

/***/ }),

/***/ 87303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);

const LocaleContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);
/* harmony default export */ __webpack_exports__["Z"] = (LocaleContext);

/***/ }),

/***/ 72380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_locale_en_US; }
});

// EXTERNAL MODULE: ./node_modules/rc-pagination/es/locale/en_US.js
var en_US = __webpack_require__(14603);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/locale/en_US.js
var locale_en_US = __webpack_require__(41038);
;// CONCATENATED MODULE: ./node_modules/antd/es/calendar/locale/en_US.js

/* harmony default export */ var calendar_locale_en_US = (locale_en_US/* default */.Z);
// EXTERNAL MODULE: ./node_modules/antd/es/time-picker/locale/en_US.js
var time_picker_locale_en_US = __webpack_require__(54539);
;// CONCATENATED MODULE: ./node_modules/antd/es/locale/en_US.js




const typeTemplate = '${label} is not a valid ${type}';
const localeValues = {
  locale: 'en',
  Pagination: en_US/* default */.Z,
  DatePicker: locale_en_US/* default */.Z,
  TimePicker: time_picker_locale_en_US/* default */.Z,
  Calendar: calendar_locale_en_US,
  global: {
    placeholder: 'Please select',
    close: 'Close'
  },
  Table: {
    filterTitle: 'Filter menu',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    filterEmptyText: 'No filters',
    filterCheckAll: 'Select all items',
    filterSearchPlaceholder: 'Search in filters',
    emptyText: 'No data',
    selectAll: 'Select current page',
    selectInvert: 'Invert current page',
    selectNone: 'Clear all data',
    selectionAll: 'Select all data',
    sortTitle: 'Sort',
    expand: 'Expand row',
    collapse: 'Collapse row',
    triggerDesc: 'Click to sort descending',
    triggerAsc: 'Click to sort ascending',
    cancelSort: 'Click to cancel sorting'
  },
  Tour: {
    Next: 'Next',
    Previous: 'Previous',
    Finish: 'Finish'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Cancel',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Cancel'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Search here',
    itemUnit: 'item',
    itemsUnit: 'items',
    remove: 'Remove',
    selectCurrent: 'Select current page',
    removeCurrent: 'Remove current page',
    selectAll: 'Select all data',
    deselectAll: 'Deselect all data',
    removeAll: 'Remove all data',
    selectInvert: 'Invert current page'
  },
  Upload: {
    uploading: 'Uploading...',
    removeFile: 'Remove file',
    uploadError: 'Upload error',
    previewFile: 'Preview file',
    downloadFile: 'Download file'
  },
  Empty: {
    description: 'No data'
  },
  Icon: {
    icon: 'icon'
  },
  Text: {
    edit: 'Edit',
    copy: 'Copy',
    copied: 'Copied',
    expand: 'Expand',
    collapse: 'Collapse'
  },
  Form: {
    optional: '(optional)',
    defaultValidateMessages: {
      default: 'Field validation error for ${label}',
      required: 'Please enter ${label}',
      enum: '${label} must be one of [${enum}]',
      whitespace: '${label} cannot be a blank character',
      date: {
        format: '${label} date format is invalid',
        parse: '${label} cannot be converted to a date',
        invalid: '${label} is an invalid date'
      },
      types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        boolean: typeTemplate,
        integer: typeTemplate,
        float: typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate
      },
      string: {
        len: '${label} must be ${len} characters',
        min: '${label} must be at least ${min} characters',
        max: '${label} must be up to ${max} characters',
        range: '${label} must be between ${min}-${max} characters'
      },
      number: {
        len: '${label} must be equal to ${len}',
        min: '${label} must be minimum ${min}',
        max: '${label} must be maximum ${max}',
        range: '${label} must be between ${min}-${max}'
      },
      array: {
        len: 'Must be ${len} ${label}',
        min: 'At least ${min} ${label}',
        max: 'At most ${max} ${label}',
        range: 'The amount of ${label} must be between ${min}-${max}'
      },
      pattern: {
        mismatch: '${label} does not match the pattern ${pattern}'
      }
    }
  },
  Image: {
    preview: 'Preview'
  },
  QRCode: {
    expired: 'QR code expired',
    refresh: 'Refresh',
    scanned: 'Scanned'
  },
  ColorPicker: {
    presetEmpty: 'Empty',
    transparent: 'Transparent',
    singleColor: 'Single',
    gradientColor: 'Gradient'
  }
};
/* harmony default export */ var es_locale_en_US = (localeValues);

/***/ }),

/***/ 69999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87303);
/* harmony import */ var _en_US__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72380);



const useLocale = (componentName, defaultLocale) => {
  const fullLocale = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_context__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
  const getLocale = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    var _a;
    const locale = defaultLocale || _en_US__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[componentName];
    const localeFromContext = (_a = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale[componentName]) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
  }, [componentName, defaultLocale, fullLocale]);
  const getLocaleCode = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    const localeCode = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.locale;
    // Had use LocaleProvide but didn't set locale
    if ((fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.exist) && !localeCode) {
      return _en_US__WEBPACK_IMPORTED_MODULE_2__/* ["default"].locale */ .Z.locale;
    }
    return localeCode;
  }, [fullLocale]);
  return [getLocale, getLocaleCode];
};
/* harmony default export */ __webpack_exports__["Z"] = (useLocale);

/***/ }),

/***/ 19888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ modal; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js
var context = __webpack_require__(94980);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/index.js + 9 modules
var config_provider = __webpack_require__(73898);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/UnstableContext.js
var UnstableContext = __webpack_require__(96093);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CheckCircleFilled.js + 1 modules
var CheckCircleFilled = __webpack_require__(14007);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CloseCircleFilled.js + 1 modules
var CloseCircleFilled = __webpack_require__(16088);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/ExclamationCircleFilled.js + 1 modules
var ExclamationCircleFilled = __webpack_require__(37588);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/InfoCircleFilled.js + 1 modules
var InfoCircleFilled = __webpack_require__(42178);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/hooks/useZIndex.js
var useZIndex = __webpack_require__(5884);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/motion.js
var motion = __webpack_require__(19405);
// EXTERNAL MODULE: ./node_modules/antd/es/locale/useLocale.js
var useLocale = __webpack_require__(69999);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/useToken.js + 3 modules
var useToken = __webpack_require__(39779);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useState.js
var useState = __webpack_require__(63345);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js + 10 modules
var es_button = __webpack_require__(45972);
// EXTERNAL MODULE: ./node_modules/antd/es/button/buttonHelpers.js
var buttonHelpers = __webpack_require__(54179);
;// CONCATENATED MODULE: ./node_modules/antd/es/_util/ActionButton.js
"use client";





function isThenable(thing) {
  return !!(thing === null || thing === void 0 ? void 0 : thing.then);
}
const ActionButton = props => {
  const {
    type,
    children,
    prefixCls,
    buttonProps,
    close,
    autoFocus,
    emitEvent,
    isSilent,
    quitOnNullishReturnValue,
    actionFn
  } = props;
  const clickedRef = react.useRef(false);
  const buttonRef = react.useRef(null);
  const [loading, setLoading] = (0,useState/* default */.Z)(false);
  const onInternalClose = (...args) => {
    close === null || close === void 0 ? void 0 : close.apply(void 0, args);
  };
  react.useEffect(() => {
    let timeoutId = null;
    if (autoFocus) {
      timeoutId = setTimeout(() => {
        var _a;
        (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus({
          preventScroll: true
        });
      });
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);
  const handlePromiseOnOk = returnValueOfOnOk => {
    if (!isThenable(returnValueOfOnOk)) {
      return;
    }
    setLoading(true);
    returnValueOfOnOk.then((...args) => {
      setLoading(false, true);
      onInternalClose.apply(void 0, args);
      clickedRef.current = false;
    }, e => {
      // See: https://github.com/ant-design/ant-design/issues/6183
      setLoading(false, true);
      clickedRef.current = false;
      // Do not throw if is `await` mode
      if (isSilent === null || isSilent === void 0 ? void 0 : isSilent()) {
        return;
      }
      return Promise.reject(e);
    });
  };
  const onClick = e => {
    if (clickedRef.current) {
      return;
    }
    clickedRef.current = true;
    if (!actionFn) {
      onInternalClose();
      return;
    }
    let returnValueOfOnOk;
    if (emitEvent) {
      returnValueOfOnOk = actionFn(e);
      if (quitOnNullishReturnValue && !isThenable(returnValueOfOnOk)) {
        clickedRef.current = false;
        onInternalClose(e);
        return;
      }
    } else if (actionFn.length) {
      returnValueOfOnOk = actionFn(close);
      // https://github.com/ant-design/ant-design/issues/23358
      clickedRef.current = false;
    } else {
      returnValueOfOnOk = actionFn();
      if (!isThenable(returnValueOfOnOk)) {
        onInternalClose();
        return;
      }
    }
    handlePromiseOnOk(returnValueOfOnOk);
  };
  return /*#__PURE__*/react.createElement(es_button/* default */.ZP, Object.assign({}, (0,buttonHelpers/* convertLegacyProps */.nx)(type), {
    onClick: onClick,
    loading: loading,
    prefixCls: prefixCls
  }, buttonProps, {
    ref: buttonRef
  }), children);
};
/* harmony default export */ var _util_ActionButton = (ActionButton);
;// CONCATENATED MODULE: ./node_modules/antd/es/modal/context.js

const ModalContext = /*#__PURE__*/react.createContext({});
const {
  Provider: ModalContextProvider
} = ModalContext;
;// CONCATENATED MODULE: ./node_modules/antd/es/modal/components/ConfirmCancelBtn.js
"use client";




const ConfirmCancelBtn = () => {
  const {
    autoFocusButton,
    cancelButtonProps,
    cancelTextLocale,
    isSilent,
    mergedOkCancel,
    rootPrefixCls,
    close,
    onCancel,
    onConfirm
  } = (0,react.useContext)(ModalContext);
  return mergedOkCancel ? (/*#__PURE__*/react.createElement(_util_ActionButton, {
    isSilent: isSilent,
    actionFn: onCancel,
    close: (...args) => {
      close === null || close === void 0 ? void 0 : close.apply(void 0, args);
      onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(false);
    },
    autoFocus: autoFocusButton === 'cancel',
    buttonProps: cancelButtonProps,
    prefixCls: `${rootPrefixCls}-btn`
  }, cancelTextLocale)) : null;
};
/* harmony default export */ var components_ConfirmCancelBtn = (ConfirmCancelBtn);
;// CONCATENATED MODULE: ./node_modules/antd/es/modal/components/ConfirmOkBtn.js
"use client";




const ConfirmOkBtn = () => {
  const {
    autoFocusButton,
    close,
    isSilent,
    okButtonProps,
    rootPrefixCls,
    okTextLocale,
    okType,
    onConfirm,
    onOk
  } = (0,react.useContext)(ModalContext);
  return /*#__PURE__*/react.createElement(_util_ActionButton, {
    isSilent: isSilent,
    type: okType || 'primary',
    actionFn: onOk,
    close: (...args) => {
      close === null || close === void 0 ? void 0 : close.apply(void 0, args);
      onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(true);
    },
    autoFocus: autoFocusButton === 'ok',
    buttonProps: okButtonProps,
    prefixCls: `${rootPrefixCls}-btn`
  }, okTextLocale);
};
/* harmony default export */ var components_ConfirmOkBtn = (ConfirmOkBtn);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CloseOutlined.js + 1 modules
var CloseOutlined = __webpack_require__(27289);
// EXTERNAL MODULE: ./node_modules/rc-dialog/es/index.js + 8 modules
var es = __webpack_require__(31414);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var ref = __webpack_require__(99195);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/ContextIsolator.js
var ContextIsolator = __webpack_require__(32973);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/hooks/useClosable.js
var useClosable = __webpack_require__(59111);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/canUseDom.js
var canUseDom = __webpack_require__(55304);
;// CONCATENATED MODULE: ./node_modules/antd/es/_util/styleChecker.js


const canUseDocElement = () => (0,canUseDom/* default */.Z)() && window.document.documentElement;

// EXTERNAL MODULE: ./node_modules/antd/es/_util/zindexContext.js
var zindexContext = __webpack_require__(85720);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/hooks/useCSSVarCls.js
var useCSSVarCls = __webpack_require__(5869);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 10 modules
var skeleton = __webpack_require__(44755);
// EXTERNAL MODULE: ./node_modules/antd/es/watermark/context.js
var watermark_context = __webpack_require__(78118);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/DisabledContext.js
var DisabledContext = __webpack_require__(85508);
;// CONCATENATED MODULE: ./node_modules/antd/es/modal/components/NormalCancelBtn.js
"use client";




const NormalCancelBtn = () => {
  const {
    cancelButtonProps,
    cancelTextLocale,
    onCancel
  } = (0,react.useContext)(ModalContext);
  return /*#__PURE__*/react.createElement(es_button/* default */.ZP, Object.assign({
    onClick: onCancel
  }, cancelButtonProps), cancelTextLocale);
};
/* harmony default export */ var components_NormalCancelBtn = (NormalCancelBtn);
;// CONCATENATED MODULE: ./node_modules/antd/es/modal/components/NormalOkBtn.js
"use client";





const NormalOkBtn = () => {
  const {
    confirmLoading,
    okButtonProps,
    okType,
    okTextLocale,
    onOk
  } = (0,react.useContext)(ModalContext);
  return /*#__PURE__*/react.createElement(es_button/* default */.ZP, Object.assign({}, (0,buttonHelpers/* convertLegacyProps */.nx)(okType), {
    loading: confirmLoading,
    onClick: onOk
  }, okButtonProps), okTextLocale);
};
/* harmony default export */ var components_NormalOkBtn = (NormalOkBtn);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/locale.js
var modal_locale = __webpack_require__(4803);
;// CONCATENATED MODULE: ./node_modules/antd/es/modal/shared.js
"use client";










function renderCloseIcon(prefixCls, closeIcon) {
  return /*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-close-x`
  }, closeIcon || /*#__PURE__*/react.createElement(CloseOutlined/* default */.Z, {
    className: `${prefixCls}-close-icon`
  }));
}
const Footer = props => {
  const {
    okText,
    okType = 'primary',
    cancelText,
    confirmLoading,
    onOk,
    onCancel,
    okButtonProps,
    cancelButtonProps,
    footer
  } = props;
  const [locale] = (0,useLocale/* default */.Z)('Modal', (0,modal_locale/* getConfirmLocale */.A)());
  // ================== Locale Text ==================
  const okTextLocale = okText || (locale === null || locale === void 0 ? void 0 : locale.okText);
  const cancelTextLocale = cancelText || (locale === null || locale === void 0 ? void 0 : locale.cancelText);
  // ================= Context Value =================
  const btnCtxValue = {
    confirmLoading,
    okButtonProps,
    cancelButtonProps,
    okTextLocale,
    cancelTextLocale,
    okType,
    onOk,
    onCancel
  };
  const btnCtxValueMemo = react.useMemo(() => btnCtxValue, (0,toConsumableArray/* default */.Z)(Object.values(btnCtxValue)));
  let footerNode;
  if (typeof footer === 'function' || typeof footer === 'undefined') {
    footerNode = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(components_NormalCancelBtn, null), /*#__PURE__*/react.createElement(components_NormalOkBtn, null));
    if (typeof footer === 'function') {
      footerNode = footer(footerNode, {
        OkBtn: components_NormalOkBtn,
        CancelBtn: components_NormalCancelBtn
      });
    }
    footerNode = /*#__PURE__*/react.createElement(ModalContextProvider, {
      value: btnCtxValueMemo
    }, footerNode);
  } else {
    footerNode = footer;
  }
  return /*#__PURE__*/react.createElement(DisabledContext/* DisabledContextProvider */.n, {
    disabled: false
  }, footerNode);
};
// EXTERNAL MODULE: ./node_modules/antd/es/modal/style/index.js
var modal_style = __webpack_require__(5151);
;// CONCATENATED MODULE: ./node_modules/antd/es/modal/Modal.js
"use client";

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


















let mousePosition;
// ref: https://github.com/ant-design/ant-design/issues/15795
const getClickPosition = e => {
  mousePosition = {
    x: e.pageX,
    y: e.pageY
  };
  // 100ms 内发生过点击事件，则从点击位置动画展示
  // 否则直接 zoom 展示
  // 这样可以兼容非点击方式展开
  setTimeout(() => {
    mousePosition = null;
  }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
if (canUseDocElement()) {
  document.documentElement.addEventListener('click', getClickPosition, true);
}
const Modal = props => {
  const {
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      open,
      wrapClassName,
      centered,
      getContainer,
      focusTriggerAfterClose = true,
      style,
      // Deprecated
      visible,
      width = 520,
      footer,
      classNames: modalClassNames,
      styles: modalStyles,
      children,
      loading,
      confirmLoading,
      zIndex: customizeZIndex,
      mousePosition: customizeMousePosition,
      onOk,
      onCancel,
      destroyOnHidden,
      destroyOnClose,
      panelRef = null
    } = props,
    restProps = __rest(props, ["prefixCls", "className", "rootClassName", "open", "wrapClassName", "centered", "getContainer", "focusTriggerAfterClose", "style", "visible", "width", "footer", "classNames", "styles", "children", "loading", "confirmLoading", "zIndex", "mousePosition", "onOk", "onCancel", "destroyOnHidden", "destroyOnClose", "panelRef"]);
  const {
    getPopupContainer: getContextPopupContainer,
    getPrefixCls,
    direction,
    modal: modalContext
  } = react.useContext(context/* ConfigContext */.E_);
  const handleCancel = e => {
    if (confirmLoading) {
      return;
    }
    onCancel === null || onCancel === void 0 ? void 0 : onCancel(e);
  };
  const handleOk = e => {
    onOk === null || onOk === void 0 ? void 0 : onOk(e);
  };
  if (false) {}
  const prefixCls = getPrefixCls('modal', customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  // Style
  const rootCls = (0,useCSSVarCls/* default */.Z)(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = (0,modal_style/* default */.ZP)(prefixCls, rootCls);
  const wrapClassNameExtended = classnames_default()(wrapClassName, {
    [`${prefixCls}-centered`]: centered !== null && centered !== void 0 ? centered : modalContext === null || modalContext === void 0 ? void 0 : modalContext.centered,
    [`${prefixCls}-wrap-rtl`]: direction === 'rtl'
  });
  const dialogFooter = footer !== null && !loading ? (/*#__PURE__*/react.createElement(Footer, Object.assign({}, props, {
    onOk: handleOk,
    onCancel: handleCancel
  }))) : null;
  const [mergedClosable, mergedCloseIcon, closeBtnIsDisabled, ariaProps] = (0,useClosable/* default */.Z)((0,useClosable/* pickClosable */.w)(props), (0,useClosable/* pickClosable */.w)(modalContext), {
    closable: true,
    closeIcon: /*#__PURE__*/react.createElement(CloseOutlined/* default */.Z, {
      className: `${prefixCls}-close-icon`
    }),
    closeIconRender: icon => renderCloseIcon(prefixCls, icon)
  });
  // ============================ Refs ============================
  // Select `ant-modal-content` by `panelRef`
  const innerPanelRef = (0,watermark_context/* usePanelRef */.H)(`.${prefixCls}-content`);
  const mergedPanelRef = (0,ref/* composeRef */.sQ)(panelRef, innerPanelRef);
  // ============================ zIndex ============================
  const [zIndex, contextZIndex] = (0,useZIndex/* useZIndex */.Cn)('Modal', customizeZIndex);
  // =========================== Width ============================
  const [numWidth, responsiveWidth] = react.useMemo(() => {
    if (width && typeof width === 'object') {
      return [undefined, width];
    }
    return [width, undefined];
  }, [width]);
  const responsiveWidthVars = react.useMemo(() => {
    const vars = {};
    if (responsiveWidth) {
      Object.keys(responsiveWidth).forEach(breakpoint => {
        const breakpointWidth = responsiveWidth[breakpoint];
        if (breakpointWidth !== undefined) {
          vars[`--${prefixCls}-${breakpoint}-width`] = typeof breakpointWidth === 'number' ? `${breakpointWidth}px` : breakpointWidth;
        }
      });
    }
    return vars;
  }, [responsiveWidth]);
  // =========================== Render ===========================
  return wrapCSSVar(/*#__PURE__*/react.createElement(ContextIsolator/* default */.Z, {
    form: true,
    space: true
  }, /*#__PURE__*/react.createElement(zindexContext/* default.Provider */.Z.Provider, {
    value: contextZIndex
  }, /*#__PURE__*/react.createElement(es/* default */.Z, Object.assign({
    width: numWidth
  }, restProps, {
    zIndex: zIndex,
    getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
    prefixCls: prefixCls,
    rootClassName: classnames_default()(hashId, rootClassName, cssVarCls, rootCls),
    footer: dialogFooter,
    visible: open !== null && open !== void 0 ? open : visible,
    mousePosition: customizeMousePosition !== null && customizeMousePosition !== void 0 ? customizeMousePosition : mousePosition,
    onClose: handleCancel,
    closable: mergedClosable ? Object.assign({
      disabled: closeBtnIsDisabled,
      closeIcon: mergedCloseIcon
    }, ariaProps) : mergedClosable,
    closeIcon: mergedCloseIcon,
    focusTriggerAfterClose: focusTriggerAfterClose,
    transitionName: (0,motion/* getTransitionName */.m)(rootPrefixCls, 'zoom', props.transitionName),
    maskTransitionName: (0,motion/* getTransitionName */.m)(rootPrefixCls, 'fade', props.maskTransitionName),
    className: classnames_default()(hashId, className, modalContext === null || modalContext === void 0 ? void 0 : modalContext.className),
    style: Object.assign(Object.assign(Object.assign({}, modalContext === null || modalContext === void 0 ? void 0 : modalContext.style), style), responsiveWidthVars),
    classNames: Object.assign(Object.assign(Object.assign({}, modalContext === null || modalContext === void 0 ? void 0 : modalContext.classNames), modalClassNames), {
      wrapper: classnames_default()(wrapClassNameExtended, modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.wrapper)
    }),
    styles: Object.assign(Object.assign({}, modalContext === null || modalContext === void 0 ? void 0 : modalContext.styles), modalStyles),
    panelRef: mergedPanelRef,
    // TODO: In the future, destroyOnClose in rc-dialog needs to be upgrade to destroyOnHidden
    destroyOnClose: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : destroyOnClose
  }), loading ? (/*#__PURE__*/react.createElement(skeleton/* default */.Z, {
    active: true,
    title: false,
    paragraph: {
      rows: 4
    },
    className: `${prefixCls}-body-skeleton`
  })) : children))));
};
/* harmony default export */ var modal_Modal = (Modal);
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs/es/index.js + 37 modules
var cssinjs_es = __webpack_require__(68946);
// EXTERNAL MODULE: ./node_modules/antd/es/style/index.js
var style = __webpack_require__(31875);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/util/genStyleUtils.js
var genStyleUtils = __webpack_require__(18511);
;// CONCATENATED MODULE: ./node_modules/antd/es/modal/style/confirm.js
// Style as confirm component




// ============================= Confirm ==============================
const genModalConfirmStyle = token => {
  const {
    componentCls,
    titleFontSize,
    titleLineHeight,
    modalConfirmIconSize,
    fontSize,
    lineHeight,
    modalTitleHeight,
    fontHeight,
    confirmBodyPadding
  } = token;
  const confirmComponentCls = `${componentCls}-confirm`;
  return {
    [confirmComponentCls]: {
      '&-rtl': {
        direction: 'rtl'
      },
      [`${token.antCls}-modal-header`]: {
        display: 'none'
      },
      [`${confirmComponentCls}-body-wrapper`]: Object.assign({}, (0,style/* clearFix */.dF)()),
      [`&${componentCls} ${componentCls}-body`]: {
        padding: confirmBodyPadding
      },
      // ====================== Body ======================
      [`${confirmComponentCls}-body`]: {
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'start',
        [`> ${token.iconCls}`]: {
          flex: 'none',
          fontSize: modalConfirmIconSize,
          marginInlineEnd: token.confirmIconMarginInlineEnd,
          marginTop: token.calc(token.calc(fontHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
        },
        [`&-has-title > ${token.iconCls}`]: {
          marginTop: token.calc(token.calc(modalTitleHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
        }
      },
      [`${confirmComponentCls}-paragraph`]: {
        display: 'flex',
        flexDirection: 'column',
        flex: 'auto',
        rowGap: token.marginXS,
        // https://github.com/ant-design/ant-design/issues/51912
        maxWidth: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(token.marginSM)})`
      },
      // https://github.com/ant-design/ant-design/issues/48159
      [`${token.iconCls} + ${confirmComponentCls}-paragraph`]: {
        maxWidth: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(token.calc(token.modalConfirmIconSize).add(token.marginSM).equal())})`
      },
      [`${confirmComponentCls}-title`]: {
        color: token.colorTextHeading,
        fontWeight: token.fontWeightStrong,
        fontSize: titleFontSize,
        lineHeight: titleLineHeight
      },
      [`${confirmComponentCls}-content`]: {
        color: token.colorText,
        fontSize,
        lineHeight
      },
      // ===================== Footer =====================
      [`${confirmComponentCls}-btns`]: {
        textAlign: 'end',
        marginTop: token.confirmBtnsMarginTop,
        [`${token.antCls}-btn + ${token.antCls}-btn`]: {
          marginBottom: 0,
          marginInlineStart: token.marginXS
        }
      }
    },
    [`${confirmComponentCls}-error ${confirmComponentCls}-body > ${token.iconCls}`]: {
      color: token.colorError
    },
    [`${confirmComponentCls}-warning ${confirmComponentCls}-body > ${token.iconCls},
        ${confirmComponentCls}-confirm ${confirmComponentCls}-body > ${token.iconCls}`]: {
      color: token.colorWarning
    },
    [`${confirmComponentCls}-info ${confirmComponentCls}-body > ${token.iconCls}`]: {
      color: token.colorInfo
    },
    [`${confirmComponentCls}-success ${confirmComponentCls}-body > ${token.iconCls}`]: {
      color: token.colorSuccess
    }
  };
};
// ============================== Export ==============================
/* harmony default export */ var style_confirm = ((0,genStyleUtils/* genSubStyleComponent */.bk)(['Modal', 'confirm'], token => {
  const modalToken = (0,modal_style/* prepareToken */.B4)(token);
  return genModalConfirmStyle(modalToken);
}, modal_style/* prepareComponentToken */.eh, {
  // confirm is weak than modal since no conflict here
  order: -1000
}));
;// CONCATENATED MODULE: ./node_modules/antd/es/modal/ConfirmDialog.js
"use client";


var ConfirmDialog_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

















function ConfirmContent(props) {
  const {
      prefixCls,
      icon,
      okText,
      cancelText,
      confirmPrefixCls,
      type,
      okCancel,
      footer,
      // Legacy for static function usage
      locale: staticLocale
    } = props,
    resetProps = ConfirmDialog_rest(props, ["prefixCls", "icon", "okText", "cancelText", "confirmPrefixCls", "type", "okCancel", "footer", "locale"]);
  if (false) {}
  // Icon
  let mergedIcon = icon;
  // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon
  if (!icon && icon !== null) {
    switch (type) {
      case 'info':
        mergedIcon = /*#__PURE__*/react.createElement(InfoCircleFilled/* default */.Z, null);
        break;
      case 'success':
        mergedIcon = /*#__PURE__*/react.createElement(CheckCircleFilled/* default */.Z, null);
        break;
      case 'error':
        mergedIcon = /*#__PURE__*/react.createElement(CloseCircleFilled/* default */.Z, null);
        break;
      default:
        mergedIcon = /*#__PURE__*/react.createElement(ExclamationCircleFilled/* default */.Z, null);
    }
  }
  // 默认为 true，保持向下兼容
  const mergedOkCancel = okCancel !== null && okCancel !== void 0 ? okCancel : type === 'confirm';
  const autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
  const [locale] = (0,useLocale/* default */.Z)('Modal');
  const mergedLocale = staticLocale || locale;
  // ================== Locale Text ==================
  const okTextLocale = okText || (mergedOkCancel ? mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.okText : mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.justOkText);
  const cancelTextLocale = cancelText || (mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.cancelText);
  // ================= Context Value =================
  const btnCtxValue = Object.assign({
    autoFocusButton,
    cancelTextLocale,
    okTextLocale,
    mergedOkCancel
  }, resetProps);
  const btnCtxValueMemo = react.useMemo(() => btnCtxValue, (0,toConsumableArray/* default */.Z)(Object.values(btnCtxValue)));
  // ====================== Footer Origin Node ======================
  const footerOriginNode = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(components_ConfirmCancelBtn, null), /*#__PURE__*/react.createElement(components_ConfirmOkBtn, null));
  const hasTitle = props.title !== undefined && props.title !== null;
  const bodyCls = `${confirmPrefixCls}-body`;
  return /*#__PURE__*/react.createElement("div", {
    className: `${confirmPrefixCls}-body-wrapper`
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(bodyCls, {
      [`${bodyCls}-has-title`]: hasTitle
    })
  }, mergedIcon, /*#__PURE__*/react.createElement("div", {
    className: `${confirmPrefixCls}-paragraph`
  }, hasTitle && /*#__PURE__*/react.createElement("span", {
    className: `${confirmPrefixCls}-title`
  }, props.title), /*#__PURE__*/react.createElement("div", {
    className: `${confirmPrefixCls}-content`
  }, props.content))), footer === undefined || typeof footer === 'function' ? (/*#__PURE__*/react.createElement(ModalContextProvider, {
    value: btnCtxValueMemo
  }, /*#__PURE__*/react.createElement("div", {
    className: `${confirmPrefixCls}-btns`
  }, typeof footer === 'function' ? footer(footerOriginNode, {
    OkBtn: components_ConfirmOkBtn,
    CancelBtn: components_ConfirmCancelBtn
  }) : footerOriginNode))) : footer, /*#__PURE__*/react.createElement(style_confirm, {
    prefixCls: prefixCls
  }));
}
const ConfirmDialog = props => {
  const {
    close,
    zIndex,
    maskStyle,
    direction,
    prefixCls,
    wrapClassName,
    rootPrefixCls,
    bodyStyle,
    closable = false,
    onConfirm,
    styles
  } = props;
  if (false) {}
  const confirmPrefixCls = `${prefixCls}-confirm`;
  const width = props.width || 416;
  const style = props.style || {};
  const mask = props.mask === undefined ? true : props.mask;
  // 默认为 false，保持旧版默认行为
  const maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
  const classString = classnames_default()(confirmPrefixCls, `${confirmPrefixCls}-${props.type}`, {
    [`${confirmPrefixCls}-rtl`]: direction === 'rtl'
  }, props.className);
  // ========================= zIndex =========================
  const [, token] = (0,useToken/* default */.ZP)();
  const mergedZIndex = react.useMemo(() => {
    if (zIndex !== undefined) {
      return zIndex;
    }
    // Static always use max zIndex
    return token.zIndexPopupBase + useZIndex/* CONTAINER_MAX_OFFSET */.u6;
  }, [zIndex, token]);
  // ========================= Render =========================
  return /*#__PURE__*/react.createElement(modal_Modal, Object.assign({}, props, {
    className: classString,
    wrapClassName: classnames_default()({
      [`${confirmPrefixCls}-centered`]: !!props.centered
    }, wrapClassName),
    onCancel: () => {
      close === null || close === void 0 ? void 0 : close({
        triggerCancel: true
      });
      onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(false);
    },
    title: "",
    footer: null,
    transitionName: (0,motion/* getTransitionName */.m)(rootPrefixCls || '', 'zoom', props.transitionName),
    maskTransitionName: (0,motion/* getTransitionName */.m)(rootPrefixCls || '', 'fade', props.maskTransitionName),
    mask: mask,
    maskClosable: maskClosable,
    style: style,
    styles: Object.assign({
      body: bodyStyle,
      mask: maskStyle
    }, styles),
    width: width,
    zIndex: mergedZIndex,
    closable: closable
  }), /*#__PURE__*/react.createElement(ConfirmContent, Object.assign({}, props, {
    confirmPrefixCls: confirmPrefixCls
  })));
};
const ConfirmDialogWrapper = props => {
  const {
    rootPrefixCls,
    iconPrefixCls,
    direction,
    theme
  } = props;
  return /*#__PURE__*/react.createElement(config_provider/* default */.ZP, {
    prefixCls: rootPrefixCls,
    iconPrefixCls: iconPrefixCls,
    direction: direction,
    theme: theme
  }, /*#__PURE__*/react.createElement(ConfirmDialog, Object.assign({}, props)));
};
if (false) {}
/* harmony default export */ var modal_ConfirmDialog = (ConfirmDialogWrapper);
;// CONCATENATED MODULE: ./node_modules/antd/es/modal/destroyFns.js
const destroyFns = [];
/* harmony default export */ var modal_destroyFns = (destroyFns);
;// CONCATENATED MODULE: ./node_modules/antd/es/modal/confirm.js
"use client";









let defaultRootPrefixCls = '';
function getRootPrefixCls() {
  return defaultRootPrefixCls;
}
const confirm_ConfirmDialogWrapper = props => {
  var _a, _b;
  const {
    prefixCls: customizePrefixCls,
    getContainer,
    direction
  } = props;
  const runtimeLocale = (0,modal_locale/* getConfirmLocale */.A)();
  const config = (0,react.useContext)(context/* ConfigContext */.E_);
  const rootPrefixCls = getRootPrefixCls() || config.getPrefixCls();
  // because Modal.config set rootPrefixCls, which is different from other components
  const prefixCls = customizePrefixCls || `${rootPrefixCls}-modal`;
  let mergedGetContainer = getContainer;
  if (mergedGetContainer === false) {
    mergedGetContainer = undefined;
    if (false) {}
  }
  return /*#__PURE__*/react.createElement(modal_ConfirmDialog, Object.assign({}, props, {
    rootPrefixCls: rootPrefixCls,
    prefixCls: prefixCls,
    iconPrefixCls: config.iconPrefixCls,
    theme: config.theme,
    direction: direction !== null && direction !== void 0 ? direction : config.direction,
    locale: (_b = (_a = config.locale) === null || _a === void 0 ? void 0 : _a.Modal) !== null && _b !== void 0 ? _b : runtimeLocale,
    getContainer: mergedGetContainer
  }));
};
function confirm_confirm(config) {
  const global = (0,config_provider/* globalConfig */.w6)();
  if (false) {}
  const container = document.createDocumentFragment();
  let currentConfig = Object.assign(Object.assign({}, config), {
    close,
    open: true
  });
  let timeoutId;
  let reactUnmount;
  function destroy(...args) {
    var _a;
    const triggerCancel = args.some(param => param === null || param === void 0 ? void 0 : param.triggerCancel);
    if (triggerCancel) {
      var _a2;
      (_a = config.onCancel) === null || _a === void 0 ? void 0 : (_a2 = _a).call.apply(_a2, [config, () => {}].concat((0,toConsumableArray/* default */.Z)(args.slice(1))));
    }
    for (let i = 0; i < modal_destroyFns.length; i++) {
      const fn = modal_destroyFns[i];
      if (fn === close) {
        modal_destroyFns.splice(i, 1);
        break;
      }
    }
    reactUnmount();
  }
  function render(props) {
    clearTimeout(timeoutId);
    /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */
    timeoutId = setTimeout(() => {
      const rootPrefixCls = global.getPrefixCls(undefined, getRootPrefixCls());
      const iconPrefixCls = global.getIconPrefixCls();
      const theme = global.getTheme();
      const dom = /*#__PURE__*/react.createElement(confirm_ConfirmDialogWrapper, Object.assign({}, props));
      const reactRender = (0,UnstableContext/* unstableSetRender */.q)();
      reactUnmount = reactRender(/*#__PURE__*/react.createElement(config_provider/* default */.ZP, {
        prefixCls: rootPrefixCls,
        iconPrefixCls: iconPrefixCls,
        theme: theme
      }, global.holderRender ? global.holderRender(dom) : dom), container);
    });
  }
  function close(...args) {
    currentConfig = Object.assign(Object.assign({}, currentConfig), {
      open: false,
      afterClose: () => {
        if (typeof config.afterClose === 'function') {
          config.afterClose();
        }
        // @ts-ignore
        destroy.apply(this, args);
      }
    });
    // Legacy support
    if (currentConfig.visible) {
      delete currentConfig.visible;
    }
    render(currentConfig);
  }
  function update(configUpdate) {
    if (typeof configUpdate === 'function') {
      currentConfig = configUpdate(currentConfig);
    } else {
      currentConfig = Object.assign(Object.assign({}, currentConfig), configUpdate);
    }
    render(currentConfig);
  }
  render(currentConfig);
  modal_destroyFns.push(close);
  return {
    destroy: close,
    update
  };
}
function withWarn(props) {
  return Object.assign(Object.assign({}, props), {
    type: 'warning'
  });
}
function withInfo(props) {
  return Object.assign(Object.assign({}, props), {
    type: 'info'
  });
}
function withSuccess(props) {
  return Object.assign(Object.assign({}, props), {
    type: 'success'
  });
}
function withError(props) {
  return Object.assign(Object.assign({}, props), {
    type: 'error'
  });
}
function withConfirm(props) {
  return Object.assign(Object.assign({}, props), {
    type: 'confirm'
  });
}
function modalGlobalConfig({
  rootPrefixCls
}) {
   false ? 0 : void 0;
  defaultRootPrefixCls = rootPrefixCls;
}
// EXTERNAL MODULE: ./node_modules/antd/es/_util/PurePanel.js
var PurePanel = __webpack_require__(68083);
;// CONCATENATED MODULE: ./node_modules/antd/es/modal/PurePanel.js
"use client";

var PurePanel_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};









const PurePanel_PurePanel = props => {
  const {
      prefixCls: customizePrefixCls,
      className,
      closeIcon,
      closable,
      type,
      title,
      children,
      footer
    } = props,
    restProps = PurePanel_rest(props, ["prefixCls", "className", "closeIcon", "closable", "type", "title", "children", "footer"]);
  const {
    getPrefixCls
  } = react.useContext(context/* ConfigContext */.E_);
  const rootPrefixCls = getPrefixCls();
  const prefixCls = customizePrefixCls || getPrefixCls('modal');
  const rootCls = (0,useCSSVarCls/* default */.Z)(rootPrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = (0,modal_style/* default */.ZP)(prefixCls, rootCls);
  const confirmPrefixCls = `${prefixCls}-confirm`;
  // Choose target props by confirm mark
  let additionalProps = {};
  if (type) {
    additionalProps = {
      closable: closable !== null && closable !== void 0 ? closable : false,
      title: '',
      footer: '',
      children: (/*#__PURE__*/react.createElement(ConfirmContent, Object.assign({}, props, {
        prefixCls: prefixCls,
        confirmPrefixCls: confirmPrefixCls,
        rootPrefixCls: rootPrefixCls,
        content: children
      })))
    };
  } else {
    additionalProps = {
      closable: closable !== null && closable !== void 0 ? closable : true,
      title,
      footer: footer !== null && /*#__PURE__*/react.createElement(Footer, Object.assign({}, props)),
      children
    };
  }
  return wrapCSSVar(/*#__PURE__*/react.createElement(es/* Panel */.s, Object.assign({
    prefixCls: prefixCls,
    className: classnames_default()(hashId, `${prefixCls}-pure-panel`, type && confirmPrefixCls, type && `${confirmPrefixCls}-${type}`, className, cssVarCls, rootCls)
  }, restProps, {
    closeIcon: renderCloseIcon(prefixCls, closeIcon),
    closable: closable
  }, additionalProps)));
};
/* harmony default export */ var modal_PurePanel = ((0,PurePanel/* withPureRenderTheme */.i)(PurePanel_PurePanel));
;// CONCATENATED MODULE: ./node_modules/antd/es/_util/hooks/usePatchElement.js


function usePatchElement() {
  const [elements, setElements] = react.useState([]);
  const patchElement = react.useCallback(element => {
    // append a new element to elements (and create a new ref)
    setElements(originElements => [].concat((0,toConsumableArray/* default */.Z)(originElements), [element]));
    // return a function that removes the new element out of elements (and create a new ref)
    // it works a little like useEffect
    return () => {
      setElements(originElements => originElements.filter(ele => ele !== element));
    };
  }, []);
  return [elements, patchElement];
}
// EXTERNAL MODULE: ./node_modules/antd/es/locale/en_US.js + 1 modules
var en_US = __webpack_require__(72380);
;// CONCATENATED MODULE: ./node_modules/antd/es/modal/useModal/HookModal.js
"use client";


var HookModal_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





const HookModal = (_a, ref) => {
  var _b;
  var {
      afterClose: hookAfterClose,
      config
    } = _a,
    restProps = HookModal_rest(_a, ["afterClose", "config"]);
  const [open, setOpen] = react.useState(true);
  const [innerConfig, setInnerConfig] = react.useState(config);
  const {
    direction,
    getPrefixCls
  } = react.useContext(context/* ConfigContext */.E_);
  const prefixCls = getPrefixCls('modal');
  const rootPrefixCls = getPrefixCls();
  const afterClose = () => {
    var _a;
    hookAfterClose();
    (_a = innerConfig.afterClose) === null || _a === void 0 ? void 0 : _a.call(innerConfig);
  };
  const close = (...args) => {
    var _a;
    setOpen(false);
    const triggerCancel = args.some(param => param === null || param === void 0 ? void 0 : param.triggerCancel);
    if (triggerCancel) {
      var _a2;
      (_a = innerConfig.onCancel) === null || _a === void 0 ? void 0 : (_a2 = _a).call.apply(_a2, [innerConfig, () => {}].concat((0,toConsumableArray/* default */.Z)(args.slice(1))));
    }
  };
  react.useImperativeHandle(ref, () => ({
    destroy: close,
    update: newConfig => {
      setInnerConfig(originConfig => {
        const nextConfig = typeof newConfig === 'function' ? newConfig(originConfig) : newConfig;
        return Object.assign(Object.assign({}, originConfig), nextConfig);
      });
    }
  }));
  const mergedOkCancel = (_b = innerConfig.okCancel) !== null && _b !== void 0 ? _b : innerConfig.type === 'confirm';
  const [contextLocale] = (0,useLocale/* default */.Z)('Modal', en_US/* default.Modal */.Z.Modal);
  return /*#__PURE__*/react.createElement(modal_ConfirmDialog, Object.assign({
    prefixCls: prefixCls,
    rootPrefixCls: rootPrefixCls
  }, innerConfig, {
    close: close,
    open: open,
    afterClose: afterClose,
    okText: innerConfig.okText || (mergedOkCancel ? contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.okText : contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.justOkText),
    direction: innerConfig.direction || direction,
    cancelText: innerConfig.cancelText || (contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.cancelText)
  }, restProps));
};
/* harmony default export */ var useModal_HookModal = (/*#__PURE__*/react.forwardRef(HookModal));
;// CONCATENATED MODULE: ./node_modules/antd/es/modal/useModal/index.js
"use client";







let uuid = 0;
const ElementsHolder = /*#__PURE__*/react.memo(/*#__PURE__*/react.forwardRef((_props, ref) => {
  const [elements, patchElement] = usePatchElement();
  react.useImperativeHandle(ref, () => ({
    patchElement
  }), []);
  return /*#__PURE__*/react.createElement(react.Fragment, null, elements);
}));
function useModal() {
  const holderRef = react.useRef(null);
  // ========================== Effect ==========================
  const [actionQueue, setActionQueue] = react.useState([]);
  react.useEffect(() => {
    if (actionQueue.length) {
      const cloneQueue = (0,toConsumableArray/* default */.Z)(actionQueue);
      cloneQueue.forEach(action => {
        action();
      });
      setActionQueue([]);
    }
  }, [actionQueue]);
  // =========================== Hook ===========================
  const getConfirmFunc = react.useCallback(withFunc => function hookConfirm(config) {
    var _a;
    uuid += 1;
    const modalRef = /*#__PURE__*/react.createRef();
    // Proxy to promise with `onClose`
    let resolvePromise;
    const promise = new Promise(resolve => {
      resolvePromise = resolve;
    });
    let silent = false;
    let closeFunc;
    const modal = /*#__PURE__*/react.createElement(useModal_HookModal, {
      key: `modal-${uuid}`,
      config: withFunc(config),
      ref: modalRef,
      afterClose: () => {
        closeFunc === null || closeFunc === void 0 ? void 0 : closeFunc();
      },
      isSilent: () => silent,
      onConfirm: confirmed => {
        resolvePromise(confirmed);
      }
    });
    closeFunc = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.patchElement(modal);
    if (closeFunc) {
      modal_destroyFns.push(closeFunc);
    }
    const instance = {
      destroy: () => {
        function destroyAction() {
          var _a;
          (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
        }
        if (modalRef.current) {
          destroyAction();
        } else {
          setActionQueue(prev => [].concat((0,toConsumableArray/* default */.Z)(prev), [destroyAction]));
        }
      },
      update: newConfig => {
        function updateAction() {
          var _a;
          (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.update(newConfig);
        }
        if (modalRef.current) {
          updateAction();
        } else {
          setActionQueue(prev => [].concat((0,toConsumableArray/* default */.Z)(prev), [updateAction]));
        }
      },
      then: resolve => {
        silent = true;
        return promise.then(resolve);
      }
    };
    return instance;
  }, []);
  const fns = react.useMemo(() => ({
    info: getConfirmFunc(withInfo),
    success: getConfirmFunc(withSuccess),
    error: getConfirmFunc(withError),
    warning: getConfirmFunc(withWarn),
    confirm: getConfirmFunc(withConfirm)
  }), []);
  return [fns, /*#__PURE__*/react.createElement(ElementsHolder, {
    key: "modal-holder",
    ref: holderRef
  })];
}
/* harmony default export */ var modal_useModal = (useModal);
;// CONCATENATED MODULE: ./node_modules/antd/es/modal/index.js
"use client";






function modalWarn(props) {
  return confirm_confirm(withWarn(props));
}
const es_modal_Modal = modal_Modal;
es_modal_Modal.useModal = modal_useModal;
es_modal_Modal.info = function infoFn(props) {
  return confirm_confirm(withInfo(props));
};
es_modal_Modal.success = function successFn(props) {
  return confirm_confirm(withSuccess(props));
};
es_modal_Modal.error = function errorFn(props) {
  return confirm_confirm(withError(props));
};
es_modal_Modal.warning = modalWarn;
es_modal_Modal.warn = modalWarn;
es_modal_Modal.confirm = function confirmFn(props) {
  return confirm_confirm(withConfirm(props));
};
es_modal_Modal.destroyAll = function destroyAllFn() {
  while (modal_destroyFns.length) {
    const close = modal_destroyFns.pop();
    if (close) {
      close();
    }
  }
};
es_modal_Modal.config = modalGlobalConfig;
es_modal_Modal._InternalPanelDoNotUseOrYouWillBeFired = modal_PurePanel;
if (false) {}
/* harmony default export */ var modal = (es_modal_Modal);

/***/ }),

/***/ 4803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getConfirmLocale; },
/* harmony export */   "f": function() { return /* binding */ changeConfirmLocale; }
/* harmony export */ });
/* harmony import */ var _locale_en_US__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72380);

let runtimeLocale = Object.assign({}, _locale_en_US__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Modal */ .Z.Modal);
let localeList = [];
const generateLocale = () => localeList.reduce((merged, locale) => Object.assign(Object.assign({}, merged), locale), _locale_en_US__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Modal */ .Z.Modal);
function changeConfirmLocale(newLocale) {
  if (newLocale) {
    const cloneLocale = Object.assign({}, newLocale);
    localeList.push(cloneLocale);
    runtimeLocale = generateLocale();
    return () => {
      localeList = localeList.filter(locale => locale !== cloneLocale);
      runtimeLocale = generateLocale();
    };
  }
  runtimeLocale = Object.assign({}, _locale_en_US__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Modal */ .Z.Modal);
}
function getConfirmLocale() {
  return runtimeLocale;
}

/***/ }),

/***/ 5151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B4": function() { return /* binding */ prepareToken; },
/* harmony export */   "QA": function() { return /* binding */ genModalMaskStyle; },
/* harmony export */   "eh": function() { return /* binding */ prepareComponentToken; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83889);
/* harmony import */ var _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68946);
/* harmony import */ var _grid_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92630);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31875);
/* harmony import */ var _style_motion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14470);
/* harmony import */ var _style_motion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63897);
/* harmony import */ var _theme_internal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89158);
/* harmony import */ var _theme_internal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18511);






function box(position) {
  return {
    position,
    inset: 0
  };
}
const genModalMaskStyle = token => {
  const {
    componentCls,
    antCls
  } = token;
  return [{
    [`${componentCls}-root`]: {
      [`${componentCls}${antCls}-zoom-enter, ${componentCls}${antCls}-zoom-appear`]: {
        // reset scale avoid mousePosition bug
        transform: 'none',
        opacity: 0,
        animationDuration: token.motionDurationSlow,
        // https://github.com/ant-design/ant-design/issues/11777
        userSelect: 'none'
      },
      // https://github.com/ant-design/ant-design/issues/37329
      // https://github.com/ant-design/ant-design/issues/40272
      [`${componentCls}${antCls}-zoom-leave ${componentCls}-content`]: {
        pointerEvents: 'none'
      },
      [`${componentCls}-mask`]: Object.assign(Object.assign({}, box('fixed')), {
        zIndex: token.zIndexPopupBase,
        height: '100%',
        backgroundColor: token.colorBgMask,
        pointerEvents: 'none',
        [`${componentCls}-hidden`]: {
          display: 'none'
        }
      }),
      [`${componentCls}-wrap`]: Object.assign(Object.assign({}, box('fixed')), {
        zIndex: token.zIndexPopupBase,
        overflow: 'auto',
        outline: 0,
        WebkitOverflowScrolling: 'touch'
      })
    }
  }, {
    [`${componentCls}-root`]: (0,_style_motion__WEBPACK_IMPORTED_MODULE_1__/* .initFadeMotion */ .J$)(token)
  }];
};
const genModalStyle = token => {
  const {
    componentCls
  } = token;
  return [
  // ======================== Root =========================
  {
    [`${componentCls}-root`]: {
      [`${componentCls}-wrap-rtl`]: {
        direction: 'rtl'
      },
      [`${componentCls}-centered`]: {
        textAlign: 'center',
        '&::before': {
          display: 'inline-block',
          width: 0,
          height: '100%',
          verticalAlign: 'middle',
          content: '""'
        },
        [componentCls]: {
          top: 0,
          display: 'inline-block',
          paddingBottom: 0,
          textAlign: 'start',
          verticalAlign: 'middle'
        }
      },
      [`@media (max-width: ${token.screenSMMax}px)`]: {
        [componentCls]: {
          maxWidth: 'calc(100vw - 16px)',
          margin: `${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.marginXS)} auto`
        },
        [`${componentCls}-centered`]: {
          [componentCls]: {
            flex: 1
          }
        }
      }
    }
  },
  // ======================== Modal ========================
  {
    [componentCls]: Object.assign(Object.assign({}, (0,_style__WEBPACK_IMPORTED_MODULE_2__/* .resetComponent */ .Wf)(token)), {
      pointerEvents: 'none',
      position: 'relative',
      top: 100,
      width: 'auto',
      maxWidth: `calc(100vw - ${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.calc(token.margin).mul(2).equal())})`,
      margin: '0 auto',
      paddingBottom: token.paddingLG,
      [`${componentCls}-title`]: {
        margin: 0,
        color: token.titleColor,
        fontWeight: token.fontWeightStrong,
        fontSize: token.titleFontSize,
        lineHeight: token.titleLineHeight,
        wordWrap: 'break-word'
      },
      [`${componentCls}-content`]: {
        position: 'relative',
        backgroundColor: token.contentBg,
        backgroundClip: 'padding-box',
        border: 0,
        borderRadius: token.borderRadiusLG,
        boxShadow: token.boxShadow,
        pointerEvents: 'auto',
        padding: token.contentPadding
      },
      [`${componentCls}-close`]: Object.assign({
        position: 'absolute',
        top: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
        insetInlineEnd: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
        zIndex: token.calc(token.zIndexPopupBase).add(10).equal(),
        padding: 0,
        color: token.modalCloseIconColor,
        fontWeight: token.fontWeightStrong,
        lineHeight: 1,
        textDecoration: 'none',
        background: 'transparent',
        borderRadius: token.borderRadiusSM,
        width: token.modalCloseBtnSize,
        height: token.modalCloseBtnSize,
        border: 0,
        outline: 0,
        cursor: 'pointer',
        transition: `color ${token.motionDurationMid}, background-color ${token.motionDurationMid}`,
        '&-x': {
          display: 'flex',
          fontSize: token.fontSizeLG,
          fontStyle: 'normal',
          lineHeight: (0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.modalCloseBtnSize),
          justifyContent: 'center',
          textTransform: 'none',
          textRendering: 'auto'
        },
        '&:disabled': {
          pointerEvents: 'none'
        },
        '&:hover': {
          color: token.modalCloseIconHoverColor,
          backgroundColor: token.colorBgTextHover,
          textDecoration: 'none'
        },
        '&:active': {
          backgroundColor: token.colorBgTextActive
        }
      }, (0,_style__WEBPACK_IMPORTED_MODULE_2__/* .genFocusStyle */ .Qy)(token)),
      [`${componentCls}-header`]: {
        color: token.colorText,
        background: token.headerBg,
        borderRadius: `${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.borderRadiusLG)} ${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.borderRadiusLG)} 0 0`,
        marginBottom: token.headerMarginBottom,
        padding: token.headerPadding,
        borderBottom: token.headerBorderBottom
      },
      [`${componentCls}-body`]: {
        fontSize: token.fontSize,
        lineHeight: token.lineHeight,
        wordWrap: 'break-word',
        padding: token.bodyPadding,
        [`${componentCls}-body-skeleton`]: {
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: `${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.margin)} auto`
        }
      },
      [`${componentCls}-footer`]: {
        textAlign: 'end',
        background: token.footerBg,
        marginTop: token.footerMarginTop,
        padding: token.footerPadding,
        borderTop: token.footerBorderTop,
        borderRadius: token.footerBorderRadius,
        [`> ${token.antCls}-btn + ${token.antCls}-btn`]: {
          marginInlineStart: token.marginXS
        }
      },
      [`${componentCls}-open`]: {
        overflow: 'hidden'
      }
    })
  },
  // ======================== Pure =========================
  {
    [`${componentCls}-pure-panel`]: {
      top: 'auto',
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      [`${componentCls}-content,
          ${componentCls}-body,
          ${componentCls}-confirm-body-wrapper`]: {
        display: 'flex',
        flexDirection: 'column',
        flex: 'auto'
      },
      [`${componentCls}-confirm-body`]: {
        marginBottom: 'auto'
      }
    }
  }];
};
const genRTLStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}-root`]: {
      [`${componentCls}-wrap-rtl`]: {
        direction: 'rtl',
        [`${componentCls}-confirm-body`]: {
          direction: 'rtl'
        }
      }
    }
  };
};
const genResponsiveWidthStyle = token => {
  const {
    componentCls
  } = token;
  const oriGridMediaSizesMap = (0,_grid_style__WEBPACK_IMPORTED_MODULE_3__/* .getMediaSize */ .hd)(token);
  const gridMediaSizesMap = Object.assign({}, oriGridMediaSizesMap);
  delete gridMediaSizesMap.xs;
  const cssVarPrefix = `--${componentCls.replace('.', '')}-`;
  const responsiveStyles = Object.keys(gridMediaSizesMap).map(key => ({
    [`@media (min-width: ${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(gridMediaSizesMap[key])})`]: {
      width: `var(${cssVarPrefix}${key}-width)`
    }
  }));
  return {
    [`${componentCls}-root`]: {
      [componentCls]: [].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Object.keys(oriGridMediaSizesMap).map((currentKey, index) => {
        const previousKey = Object.keys(oriGridMediaSizesMap)[index - 1];
        return previousKey ? {
          [`${cssVarPrefix}${currentKey}-width`]: `var(${cssVarPrefix}${previousKey}-width)`
        } : null;
      })), [{
        width: `var(${cssVarPrefix}xs-width)`
      }], (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(responsiveStyles))
    }
  };
};
// ============================== Export ==============================
const prepareToken = token => {
  const headerPaddingVertical = token.padding;
  const headerFontSize = token.fontSizeHeading5;
  const headerLineHeight = token.lineHeightHeading5;
  const modalToken = (0,_theme_internal__WEBPACK_IMPORTED_MODULE_5__/* .mergeToken */ .IX)(token, {
    modalHeaderHeight: token.calc(token.calc(headerLineHeight).mul(headerFontSize).equal()).add(token.calc(headerPaddingVertical).mul(2).equal()).equal(),
    modalFooterBorderColorSplit: token.colorSplit,
    modalFooterBorderStyle: token.lineType,
    modalFooterBorderWidth: token.lineWidth,
    modalCloseIconColor: token.colorIcon,
    modalCloseIconHoverColor: token.colorIconHover,
    modalCloseBtnSize: token.controlHeight,
    modalConfirmIconSize: token.fontHeight,
    modalTitleHeight: token.calc(token.titleFontSize).mul(token.titleLineHeight).equal()
  });
  return modalToken;
};
const prepareComponentToken = token => ({
  footerBg: 'transparent',
  headerBg: token.colorBgElevated,
  titleLineHeight: token.lineHeightHeading5,
  titleFontSize: token.fontSizeHeading5,
  contentBg: token.colorBgElevated,
  titleColor: token.colorTextHeading,
  // internal
  contentPadding: token.wireframe ? 0 : `${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.paddingMD)} ${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.paddingContentHorizontalLG)}`,
  headerPadding: token.wireframe ? `${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.padding)} ${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.paddingLG)}` : 0,
  headerBorderBottom: token.wireframe ? `${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : 'none',
  headerMarginBottom: token.wireframe ? 0 : token.marginXS,
  bodyPadding: token.wireframe ? token.paddingLG : 0,
  footerPadding: token.wireframe ? `${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.paddingXS)} ${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.padding)}` : 0,
  footerBorderTop: token.wireframe ? `${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : 'none',
  footerBorderRadius: token.wireframe ? `0 0 ${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.borderRadiusLG)} ${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.borderRadiusLG)}` : 0,
  footerMarginTop: token.wireframe ? 0 : token.marginSM,
  confirmBodyPadding: token.wireframe ? `${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.padding * 2)} ${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.padding * 2)} ${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.paddingLG)}` : 0,
  confirmIconMarginInlineEnd: token.wireframe ? token.margin : token.marginSM,
  confirmBtnsMarginTop: token.wireframe ? token.marginLG : token.marginSM
});
/* harmony default export */ __webpack_exports__["ZP"] = ((0,_theme_internal__WEBPACK_IMPORTED_MODULE_6__/* .genStyleHooks */ .I$)('Modal', token => {
  const modalToken = prepareToken(token);
  return [genModalStyle(modalToken), genRTLStyle(modalToken), genModalMaskStyle(modalToken), (0,_style_motion__WEBPACK_IMPORTED_MODULE_7__/* .initZoomMotion */ ._y)(modalToken, 'zoom'), genResponsiveWidthStyle(modalToken)];
}, prepareComponentToken, {
  unitless: {
    titleLineHeight: true
  }
}));

/***/ }),

/***/ 71772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ popover; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMergedState.js
var useMergedState = __webpack_require__(78877);
// EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js
var KeyCode = __webpack_require__(88035);
;// CONCATENATED MODULE: ./node_modules/antd/es/_util/getRenderPropValue.js
const getRenderPropValue = propValue => {
  if (!propValue) {
    return null;
  }
  return typeof propValue === 'function' ? propValue() : propValue;
};
// EXTERNAL MODULE: ./node_modules/antd/es/_util/motion.js
var motion = __webpack_require__(19405);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/reactNode.js
var reactNode = __webpack_require__(81730);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js
var context = __webpack_require__(94980);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 4 modules
var tooltip = __webpack_require__(93740);
// EXTERNAL MODULE: ./node_modules/rc-tooltip/es/index.js + 3 modules
var es = __webpack_require__(59052);
// EXTERNAL MODULE: ./node_modules/antd/es/style/index.js
var style = __webpack_require__(31875);
// EXTERNAL MODULE: ./node_modules/antd/es/style/motion/zoom.js
var zoom = __webpack_require__(63897);
// EXTERNAL MODULE: ./node_modules/antd/es/style/placementArrow.js
var placementArrow = __webpack_require__(33294);
// EXTERNAL MODULE: ./node_modules/antd/es/style/roundedArrow.js
var roundedArrow = __webpack_require__(20829);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/interface/presetColors.js
var presetColors = __webpack_require__(26822);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/util/genStyleUtils.js
var genStyleUtils = __webpack_require__(18511);
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs-utils/es/index.js + 12 modules
var cssinjs_utils_es = __webpack_require__(89158);
;// CONCATENATED MODULE: ./node_modules/antd/es/popover/style/index.js





const genBaseStyle = token => {
  const {
    componentCls,
    popoverColor,
    titleMinWidth,
    fontWeightStrong,
    innerPadding,
    boxShadowSecondary,
    colorTextHeading,
    borderRadiusLG,
    zIndexPopup,
    titleMarginBottom,
    colorBgElevated,
    popoverBg,
    titleBorderBottom,
    innerContentPadding,
    titlePadding
  } = token;
  return [{
    [componentCls]: Object.assign(Object.assign({}, (0,style/* resetComponent */.Wf)(token)), {
      position: 'absolute',
      top: 0,
      // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
      left: {
        _skip_check_: true,
        value: 0
      },
      zIndex: zIndexPopup,
      fontWeight: 'normal',
      whiteSpace: 'normal',
      textAlign: 'start',
      cursor: 'auto',
      userSelect: 'text',
      // When use `autoArrow`, origin will follow the arrow position
      '--valid-offset-x': 'var(--arrow-offset-horizontal, var(--arrow-x))',
      transformOrigin: [`var(--valid-offset-x, 50%)`, `var(--arrow-y, 50%)`].join(' '),
      '--antd-arrow-background-color': colorBgElevated,
      width: 'max-content',
      maxWidth: '100vw',
      '&-rtl': {
        direction: 'rtl'
      },
      '&-hidden': {
        display: 'none'
      },
      [`${componentCls}-content`]: {
        position: 'relative'
      },
      [`${componentCls}-inner`]: {
        backgroundColor: popoverBg,
        backgroundClip: 'padding-box',
        borderRadius: borderRadiusLG,
        boxShadow: boxShadowSecondary,
        padding: innerPadding
      },
      [`${componentCls}-title`]: {
        minWidth: titleMinWidth,
        marginBottom: titleMarginBottom,
        color: colorTextHeading,
        fontWeight: fontWeightStrong,
        borderBottom: titleBorderBottom,
        padding: titlePadding
      },
      [`${componentCls}-inner-content`]: {
        color: popoverColor,
        padding: innerContentPadding
      }
    })
  },
  // Arrow Style
  (0,placementArrow/* default */.ZP)(token, 'var(--antd-arrow-background-color)'),
  // Pure Render
  {
    [`${componentCls}-pure`]: {
      position: 'relative',
      maxWidth: 'none',
      margin: token.sizePopupArrow,
      display: 'inline-block',
      [`${componentCls}-content`]: {
        display: 'inline-block'
      }
    }
  }];
};
const genColorStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [componentCls]: presetColors/* PresetColors.map */.i.map(colorKey => {
      const lightColor = token[`${colorKey}6`];
      return {
        [`&${componentCls}-${colorKey}`]: {
          '--antd-arrow-background-color': lightColor,
          [`${componentCls}-inner`]: {
            backgroundColor: lightColor
          },
          [`${componentCls}-arrow`]: {
            background: 'transparent'
          }
        }
      };
    })
  };
};
const prepareComponentToken = token => {
  const {
    lineWidth,
    controlHeight,
    fontHeight,
    padding,
    wireframe,
    zIndexPopupBase,
    borderRadiusLG,
    marginXS,
    lineType,
    colorSplit,
    paddingSM
  } = token;
  const titlePaddingBlockDist = controlHeight - fontHeight;
  const popoverTitlePaddingBlockTop = titlePaddingBlockDist / 2;
  const popoverTitlePaddingBlockBottom = titlePaddingBlockDist / 2 - lineWidth;
  const popoverPaddingHorizontal = padding;
  return Object.assign(Object.assign(Object.assign({
    titleMinWidth: 177,
    zIndexPopup: zIndexPopupBase + 30
  }, (0,roundedArrow/* getArrowToken */.w)(token)), (0,placementArrow/* getArrowOffsetToken */.wZ)({
    contentRadius: borderRadiusLG,
    limitVerticalRadius: true
  })), {
    // internal
    innerPadding: wireframe ? 0 : 12,
    titleMarginBottom: wireframe ? 0 : marginXS,
    titlePadding: wireframe ? `${popoverTitlePaddingBlockTop}px ${popoverPaddingHorizontal}px ${popoverTitlePaddingBlockBottom}px` : 0,
    titleBorderBottom: wireframe ? `${lineWidth}px ${lineType} ${colorSplit}` : 'none',
    innerContentPadding: wireframe ? `${paddingSM}px ${popoverPaddingHorizontal}px` : 0
  });
};
/* harmony default export */ var popover_style = ((0,genStyleUtils/* genStyleHooks */.I$)('Popover', token => {
  const {
    colorBgElevated,
    colorText
  } = token;
  const popoverToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    popoverBg: colorBgElevated,
    popoverColor: colorText
  });
  return [genBaseStyle(popoverToken), genColorStyle(popoverToken), (0,zoom/* initZoomMotion */._y)(popoverToken, 'zoom-big')];
}, prepareComponentToken, {
  resetStyle: false,
  deprecatedTokens: [['width', 'titleMinWidth'], ['minWidth', 'titleMinWidth']]
}));
;// CONCATENATED MODULE: ./node_modules/antd/es/popover/PurePanel.js
"use client";

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






const Overlay = ({
  title,
  content,
  prefixCls
}) => {
  if (!title && !content) {
    return null;
  }
  return /*#__PURE__*/react.createElement(react.Fragment, null, title && /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-title`
  }, title), content && /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-inner-content`
  }, content));
};
const RawPurePanel = props => {
  const {
    hashId,
    prefixCls,
    className,
    style,
    placement = 'top',
    title,
    content,
    children
  } = props;
  const titleNode = getRenderPropValue(title);
  const contentNode = getRenderPropValue(content);
  const cls = classnames_default()(hashId, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className);
  return /*#__PURE__*/react.createElement("div", {
    className: cls,
    style: style
  }, /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-arrow`
  }), /*#__PURE__*/react.createElement(es/* Popup */.G, Object.assign({}, props, {
    className: hashId,
    prefixCls: prefixCls
  }), children || /*#__PURE__*/react.createElement(Overlay, {
    prefixCls: prefixCls,
    title: titleNode,
    content: contentNode
  })));
};
const PurePanel = props => {
  const {
      prefixCls: customizePrefixCls,
      className
    } = props,
    restProps = __rest(props, ["prefixCls", "className"]);
  const {
    getPrefixCls
  } = react.useContext(context/* ConfigContext */.E_);
  const prefixCls = getPrefixCls('popover', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = popover_style(prefixCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement(RawPurePanel, Object.assign({}, restProps, {
    prefixCls: prefixCls,
    hashId: hashId,
    className: classnames_default()(className, cssVarCls)
  })));
};
/* harmony default export */ var popover_PurePanel = (PurePanel);
;// CONCATENATED MODULE: ./node_modules/antd/es/popover/index.js
"use client";

var popover_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};











// CSSINJS

const InternalPopover = /*#__PURE__*/react.forwardRef((props, ref) => {
  var _a, _b;
  const {
      prefixCls: customizePrefixCls,
      title,
      content,
      overlayClassName,
      placement = 'top',
      trigger = 'hover',
      children,
      mouseEnterDelay = 0.1,
      mouseLeaveDelay = 0.1,
      onOpenChange,
      overlayStyle = {},
      styles,
      classNames: popoverClassNames
    } = props,
    otherProps = popover_rest(props, ["prefixCls", "title", "content", "overlayClassName", "placement", "trigger", "children", "mouseEnterDelay", "mouseLeaveDelay", "onOpenChange", "overlayStyle", "styles", "classNames"]);
  const {
    getPrefixCls,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = (0,context/* useComponentConfig */.dj)('popover');
  const prefixCls = getPrefixCls('popover', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = popover_style(prefixCls);
  const rootPrefixCls = getPrefixCls();
  const rootClassNames = classnames_default()(overlayClassName, hashId, cssVarCls, contextClassName, contextClassNames.root, popoverClassNames === null || popoverClassNames === void 0 ? void 0 : popoverClassNames.root);
  const bodyClassNames = classnames_default()(contextClassNames.body, popoverClassNames === null || popoverClassNames === void 0 ? void 0 : popoverClassNames.body);
  const [open, setOpen] = (0,useMergedState/* default */.Z)(false, {
    value: (_a = props.open) !== null && _a !== void 0 ? _a : props.visible,
    defaultValue: (_b = props.defaultOpen) !== null && _b !== void 0 ? _b : props.defaultVisible
  });
  const settingOpen = (value, e) => {
    setOpen(value, true);
    onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(value, e);
  };
  const onKeyDown = e => {
    if (e.keyCode === KeyCode/* default.ESC */.Z.ESC) {
      settingOpen(false, e);
    }
  };
  const onInternalOpenChange = value => {
    settingOpen(value);
  };
  const titleNode = getRenderPropValue(title);
  const contentNode = getRenderPropValue(content);
  return wrapCSSVar(/*#__PURE__*/react.createElement(tooltip/* default */.Z, Object.assign({
    placement: placement,
    trigger: trigger,
    mouseEnterDelay: mouseEnterDelay,
    mouseLeaveDelay: mouseLeaveDelay
  }, otherProps, {
    prefixCls: prefixCls,
    classNames: {
      root: rootClassNames,
      body: bodyClassNames
    },
    styles: {
      root: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.root), contextStyle), overlayStyle), styles === null || styles === void 0 ? void 0 : styles.root),
      body: Object.assign(Object.assign({}, contextStyles.body), styles === null || styles === void 0 ? void 0 : styles.body)
    },
    ref: ref,
    open: open,
    onOpenChange: onInternalOpenChange,
    overlay: titleNode || contentNode ? (/*#__PURE__*/react.createElement(Overlay, {
      prefixCls: prefixCls,
      title: titleNode,
      content: contentNode
    })) : null,
    transitionName: (0,motion/* getTransitionName */.m)(rootPrefixCls, 'zoom-big', otherProps.transitionName),
    "data-popover-inject": true
  }), (0,reactNode/* cloneElement */.Tm)(children, {
    onKeyDown: e => {
      var _a, _b;
      if (/*#__PURE__*/(0,react.isValidElement)(children)) {
        (_b = children === null || children === void 0 ? void 0 : (_a = children.props).onKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a, e);
      }
      onKeyDown(e);
    }
  })));
});
const Popover = InternalPopover;
Popover._InternalPanelDoNotUseOrYouWillBeFired = popover_PurePanel;
if (false) {}
/* harmony default export */ var popover = (Popover);

/***/ }),

/***/ 64611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_progress; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/@ant-design/fast-color/es/index.js + 1 modules
var es = __webpack_require__(99620);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CheckCircleFilled.js + 1 modules
var CheckCircleFilled = __webpack_require__(14007);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CheckOutlined.js + 1 modules
var CheckOutlined = __webpack_require__(71109);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CloseCircleFilled.js + 1 modules
var CloseCircleFilled = __webpack_require__(16088);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CloseOutlined.js + 1 modules
var CloseOutlined = __webpack_require__(27289);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/omit.js
var omit = __webpack_require__(85401);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js
var context = __webpack_require__(94980);
// EXTERNAL MODULE: ./node_modules/rc-progress/es/index.js + 6 modules
var rc_progress_es = __webpack_require__(38100);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 4 modules
var tooltip = __webpack_require__(93740);
// EXTERNAL MODULE: ./node_modules/@ant-design/colors/es/index.js + 2 modules
var colors_es = __webpack_require__(61835);
;// CONCATENATED MODULE: ./node_modules/antd/es/progress/utils.js

function validProgress(progress) {
  if (!progress || progress < 0) {
    return 0;
  }
  if (progress > 100) {
    return 100;
  }
  return progress;
}
function getSuccessPercent({
  success,
  successPercent
}) {
  let percent = successPercent;
  /** @deprecated Use `percent` instead */
  if (success && 'progress' in success) {
    percent = success.progress;
  }
  if (success && 'percent' in success) {
    percent = success.percent;
  }
  return percent;
}
const getPercentage = ({
  percent,
  success,
  successPercent
}) => {
  const realSuccessPercent = validProgress(getSuccessPercent({
    success,
    successPercent
  }));
  return [realSuccessPercent, validProgress(validProgress(percent) - realSuccessPercent)];
};
const getStrokeColor = ({
  success = {},
  strokeColor
}) => {
  const {
    strokeColor: successColor
  } = success;
  return [successColor || colors_es/* presetPrimaryColors.green */.ez.green, strokeColor || null];
};
const getSize = (size, type, extra) => {
  var _a, _b, _c, _d;
  let width = -1;
  let height = -1;
  if (type === 'step') {
    const steps = extra.steps;
    const strokeWidth = extra.strokeWidth;
    if (typeof size === 'string' || typeof size === 'undefined') {
      width = size === 'small' ? 2 : 14;
      height = strokeWidth !== null && strokeWidth !== void 0 ? strokeWidth : 8;
    } else if (typeof size === 'number') {
      [width, height] = [size, size];
    } else {
      [width = 14, height = 8] = Array.isArray(size) ? size : [size.width, size.height];
    }
    width *= steps;
  } else if (type === 'line') {
    const strokeWidth = extra === null || extra === void 0 ? void 0 : extra.strokeWidth;
    if (typeof size === 'string' || typeof size === 'undefined') {
      height = strokeWidth || (size === 'small' ? 6 : 8);
    } else if (typeof size === 'number') {
      [width, height] = [size, size];
    } else {
      [width = -1, height = 8] = Array.isArray(size) ? size : [size.width, size.height];
    }
  } else if (type === 'circle' || type === 'dashboard') {
    if (typeof size === 'string' || typeof size === 'undefined') {
      [width, height] = size === 'small' ? [60, 60] : [120, 120];
    } else if (typeof size === 'number') {
      [width, height] = [size, size];
    } else if (Array.isArray(size)) {
      width = (_b = (_a = size[0]) !== null && _a !== void 0 ? _a : size[1]) !== null && _b !== void 0 ? _b : 120;
      height = (_d = (_c = size[0]) !== null && _c !== void 0 ? _c : size[1]) !== null && _d !== void 0 ? _d : 120;
    }
  }
  return [width, height];
};
;// CONCATENATED MODULE: ./node_modules/antd/es/progress/Circle.js
"use client";






const CIRCLE_MIN_STROKE_WIDTH = 3;
const getMinPercent = width => CIRCLE_MIN_STROKE_WIDTH / width * 100;
const Circle = props => {
  const {
    prefixCls,
    trailColor = null,
    strokeLinecap = 'round',
    gapPosition,
    gapDegree,
    width: originWidth = 120,
    type,
    children,
    success,
    size = originWidth,
    steps
  } = props;
  const [width, height] = getSize(size, 'circle');
  let {
    strokeWidth
  } = props;
  if (strokeWidth === undefined) {
    strokeWidth = Math.max(getMinPercent(width), 6);
  }
  const circleStyle = {
    width,
    height,
    fontSize: width * 0.15 + 6
  };
  const realGapDegree = react.useMemo(() => {
    // Support gapDeg = 0 when type = 'dashboard'
    if (gapDegree || gapDegree === 0) {
      return gapDegree;
    }
    if (type === 'dashboard') {
      return 75;
    }
    return undefined;
  }, [gapDegree, type]);
  const percentArray = getPercentage(props);
  const gapPos = gapPosition || type === 'dashboard' && 'bottom' || undefined;
  // using className to style stroke color
  const isGradient = Object.prototype.toString.call(props.strokeColor) === '[object Object]';
  const strokeColor = getStrokeColor({
    success,
    strokeColor: props.strokeColor
  });
  const wrapperClassName = classnames_default()(`${prefixCls}-inner`, {
    [`${prefixCls}-circle-gradient`]: isGradient
  });
  const circleContent = /*#__PURE__*/react.createElement(rc_progress_es/* Circle */.Cd, {
    steps: steps,
    percent: steps ? percentArray[1] : percentArray,
    strokeWidth: strokeWidth,
    trailWidth: strokeWidth,
    strokeColor: steps ? strokeColor[1] : strokeColor,
    strokeLinecap: strokeLinecap,
    trailColor: trailColor,
    prefixCls: prefixCls,
    gapDegree: realGapDegree,
    gapPosition: gapPos
  });
  const smallCircle = width <= 20;
  const node = /*#__PURE__*/react.createElement("div", {
    className: wrapperClassName,
    style: circleStyle
  }, circleContent, !smallCircle && children);
  if (smallCircle) {
    return /*#__PURE__*/react.createElement(tooltip/* default */.Z, {
      title: children
    }, node);
  }
  return node;
};
/* harmony default export */ var progress_Circle = (Circle);
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs/es/index.js + 37 modules
var cssinjs_es = __webpack_require__(68946);
// EXTERNAL MODULE: ./node_modules/antd/es/style/index.js
var style = __webpack_require__(31875);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/util/genStyleUtils.js
var genStyleUtils = __webpack_require__(18511);
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs-utils/es/index.js + 12 modules
var cssinjs_utils_es = __webpack_require__(89158);
;// CONCATENATED MODULE: ./node_modules/antd/es/progress/style/index.js



const LineStrokeColorVar = '--progress-line-stroke-color';
const Percent = '--progress-percent';
const genAntProgressActive = isRtl => {
  const direction = isRtl ? '100%' : '-100%';
  return new cssinjs_es/* Keyframes */.E4(`antProgress${isRtl ? 'RTL' : 'LTR'}Active`, {
    '0%': {
      transform: `translateX(${direction}) scaleX(0)`,
      opacity: 0.1
    },
    '20%': {
      transform: `translateX(${direction}) scaleX(0)`,
      opacity: 0.5
    },
    to: {
      transform: 'translateX(0) scaleX(1)',
      opacity: 0
    }
  });
};
const genBaseStyle = token => {
  const {
    componentCls: progressCls,
    iconCls: iconPrefixCls
  } = token;
  return {
    [progressCls]: Object.assign(Object.assign({}, (0,style/* resetComponent */.Wf)(token)), {
      display: 'inline-block',
      '&-rtl': {
        direction: 'rtl'
      },
      '&-line': {
        position: 'relative',
        width: '100%',
        fontSize: token.fontSize
      },
      [`${progressCls}-outer`]: {
        display: 'inline-flex',
        alignItems: 'center',
        width: '100%'
      },
      [`${progressCls}-inner`]: {
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        flex: 1,
        overflow: 'hidden',
        verticalAlign: 'middle',
        backgroundColor: token.remainingColor,
        borderRadius: token.lineBorderRadius
      },
      [`${progressCls}-inner:not(${progressCls}-circle-gradient)`]: {
        [`${progressCls}-circle-path`]: {
          stroke: token.defaultColor
        }
      },
      [`${progressCls}-success-bg, ${progressCls}-bg`]: {
        position: 'relative',
        background: token.defaultColor,
        borderRadius: token.lineBorderRadius,
        transition: `all ${token.motionDurationSlow} ${token.motionEaseInOutCirc}`
      },
      [`${progressCls}-layout-bottom`]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        [`${progressCls}-text`]: {
          width: 'max-content',
          marginInlineStart: 0,
          marginTop: token.marginXXS
        }
      },
      [`${progressCls}-bg`]: {
        overflow: 'hidden',
        '&::after': {
          content: '""',
          background: {
            _multi_value_: true,
            value: ['inherit', `var(${LineStrokeColorVar})`]
          },
          height: '100%',
          width: `calc(1 / var(${Percent}) * 100%)`,
          display: 'block'
        },
        [`&${progressCls}-bg-inner`]: {
          minWidth: 'max-content',
          '&::after': {
            content: 'none'
          },
          [`${progressCls}-text-inner`]: {
            color: token.colorWhite,
            [`&${progressCls}-text-bright`]: {
              color: 'rgba(0, 0, 0, 0.45)'
            }
          }
        }
      },
      [`${progressCls}-success-bg`]: {
        position: 'absolute',
        insetBlockStart: 0,
        insetInlineStart: 0,
        backgroundColor: token.colorSuccess
      },
      [`${progressCls}-text`]: {
        display: 'inline-block',
        marginInlineStart: token.marginXS,
        color: token.colorText,
        lineHeight: 1,
        width: '2em',
        whiteSpace: 'nowrap',
        textAlign: 'start',
        verticalAlign: 'middle',
        wordBreak: 'normal',
        [iconPrefixCls]: {
          fontSize: token.fontSize
        },
        [`&${progressCls}-text-outer`]: {
          width: 'max-content'
        },
        [`&${progressCls}-text-outer${progressCls}-text-start`]: {
          width: 'max-content',
          marginInlineStart: 0,
          marginInlineEnd: token.marginXS
        }
      },
      [`${progressCls}-text-inner`]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        marginInlineStart: 0,
        padding: `0 ${(0,cssinjs_es/* unit */.bf)(token.paddingXXS)}`,
        [`&${progressCls}-text-start`]: {
          justifyContent: 'start'
        },
        [`&${progressCls}-text-end`]: {
          justifyContent: 'end'
        }
      },
      [`&${progressCls}-status-active`]: {
        [`${progressCls}-bg::before`]: {
          position: 'absolute',
          inset: 0,
          backgroundColor: token.colorBgContainer,
          borderRadius: token.lineBorderRadius,
          opacity: 0,
          animationName: genAntProgressActive(),
          animationDuration: token.progressActiveMotionDuration,
          animationTimingFunction: token.motionEaseOutQuint,
          animationIterationCount: 'infinite',
          content: '""'
        }
      },
      [`&${progressCls}-rtl${progressCls}-status-active`]: {
        [`${progressCls}-bg::before`]: {
          animationName: genAntProgressActive(true)
        }
      },
      [`&${progressCls}-status-exception`]: {
        [`${progressCls}-bg`]: {
          backgroundColor: token.colorError
        },
        [`${progressCls}-text`]: {
          color: token.colorError
        }
      },
      [`&${progressCls}-status-exception ${progressCls}-inner:not(${progressCls}-circle-gradient)`]: {
        [`${progressCls}-circle-path`]: {
          stroke: token.colorError
        }
      },
      [`&${progressCls}-status-success`]: {
        [`${progressCls}-bg`]: {
          backgroundColor: token.colorSuccess
        },
        [`${progressCls}-text`]: {
          color: token.colorSuccess
        }
      },
      [`&${progressCls}-status-success ${progressCls}-inner:not(${progressCls}-circle-gradient)`]: {
        [`${progressCls}-circle-path`]: {
          stroke: token.colorSuccess
        }
      }
    })
  };
};
const genCircleStyle = token => {
  const {
    componentCls: progressCls,
    iconCls: iconPrefixCls
  } = token;
  return {
    [progressCls]: {
      [`${progressCls}-circle-trail`]: {
        stroke: token.remainingColor
      },
      [`&${progressCls}-circle ${progressCls}-inner`]: {
        position: 'relative',
        lineHeight: 1,
        backgroundColor: 'transparent'
      },
      [`&${progressCls}-circle ${progressCls}-text`]: {
        position: 'absolute',
        insetBlockStart: '50%',
        insetInlineStart: 0,
        width: '100%',
        margin: 0,
        padding: 0,
        color: token.circleTextColor,
        fontSize: token.circleTextFontSize,
        lineHeight: 1,
        whiteSpace: 'normal',
        textAlign: 'center',
        transform: 'translateY(-50%)',
        [iconPrefixCls]: {
          fontSize: token.circleIconFontSize
        }
      },
      [`${progressCls}-circle&-status-exception`]: {
        [`${progressCls}-text`]: {
          color: token.colorError
        }
      },
      [`${progressCls}-circle&-status-success`]: {
        [`${progressCls}-text`]: {
          color: token.colorSuccess
        }
      }
    },
    [`${progressCls}-inline-circle`]: {
      lineHeight: 1,
      [`${progressCls}-inner`]: {
        verticalAlign: 'bottom'
      }
    }
  };
};
const genStepStyle = token => {
  const {
    componentCls: progressCls
  } = token;
  return {
    [progressCls]: {
      [`${progressCls}-steps`]: {
        display: 'inline-block',
        '&-outer': {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        },
        '&-item': {
          flexShrink: 0,
          minWidth: token.progressStepMinWidth,
          marginInlineEnd: token.progressStepMarginInlineEnd,
          backgroundColor: token.remainingColor,
          transition: `all ${token.motionDurationSlow}`,
          '&-active': {
            backgroundColor: token.defaultColor
          }
        }
      }
    }
  };
};
const genSmallLine = token => {
  const {
    componentCls: progressCls,
    iconCls: iconPrefixCls
  } = token;
  return {
    [progressCls]: {
      [`${progressCls}-small&-line, ${progressCls}-small&-line ${progressCls}-text ${iconPrefixCls}`]: {
        fontSize: token.fontSizeSM
      }
    }
  };
};
const prepareComponentToken = token => ({
  circleTextColor: token.colorText,
  defaultColor: token.colorInfo,
  remainingColor: token.colorFillSecondary,
  lineBorderRadius: 100,
  // magic for capsule shape, should be a very large number
  circleTextFontSize: '1em',
  circleIconFontSize: `${token.fontSize / token.fontSizeSM}em`
});
/* harmony default export */ var progress_style = ((0,genStyleUtils/* genStyleHooks */.I$)('Progress', token => {
  const progressStepMarginInlineEnd = token.calc(token.marginXXS).div(2).equal();
  const progressToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    progressStepMarginInlineEnd,
    progressStepMinWidth: progressStepMarginInlineEnd,
    progressActiveMotionDuration: '2.4s'
  });
  return [genBaseStyle(progressToken), genCircleStyle(progressToken), genStepStyle(progressToken), genSmallLine(progressToken)];
}, prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/antd/es/progress/Line.js
"use client";

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






/**
 * @example
 *   {
 *     "0%": "#afc163",
 *     "75%": "#009900",
 *     "50%": "green", // ====> '#afc163 0%, #66FF00 25%, #00CC00 50%, #009900 75%, #ffffff 100%'
 *     "25%": "#66FF00",
 *     "100%": "#ffffff"
 *   }
 */
const sortGradient = gradients => {
  let tempArr = [];
  Object.keys(gradients).forEach(key => {
    const formattedKey = parseFloat(key.replace(/%/g, ''));
    if (!Number.isNaN(formattedKey)) {
      tempArr.push({
        key: formattedKey,
        value: gradients[key]
      });
    }
  });
  tempArr = tempArr.sort((a, b) => a.key - b.key);
  return tempArr.map(({
    key,
    value
  }) => `${value} ${key}%`).join(', ');
};
/**
 * Then this man came to realize the truth: Besides six pence, there is the moon. Besides bread and
 * butter, there is the bug. And... Besides women, there is the code.
 *
 * @example
 *   {
 *     "0%": "#afc163",
 *     "25%": "#66FF00",
 *     "50%": "#00CC00", // ====>  linear-gradient(to right, #afc163 0%, #66FF00 25%,
 *     "75%": "#009900", //        #00CC00 50%, #009900 75%, #ffffff 100%)
 *     "100%": "#ffffff"
 *   }
 */
const handleGradient = (strokeColor, directionConfig) => {
  const {
      from = colors_es/* presetPrimaryColors.blue */.ez.blue,
      to = colors_es/* presetPrimaryColors.blue */.ez.blue,
      direction = directionConfig === 'rtl' ? 'to left' : 'to right'
    } = strokeColor,
    rest = __rest(strokeColor, ["from", "to", "direction"]);
  if (Object.keys(rest).length !== 0) {
    const sortedGradients = sortGradient(rest);
    const background = `linear-gradient(${direction}, ${sortedGradients})`;
    return {
      background,
      [LineStrokeColorVar]: background
    };
  }
  const background = `linear-gradient(${direction}, ${from}, ${to})`;
  return {
    background,
    [LineStrokeColorVar]: background
  };
};
const Line = props => {
  const {
    prefixCls,
    direction: directionConfig,
    percent,
    size,
    strokeWidth,
    strokeColor,
    strokeLinecap = 'round',
    children,
    trailColor = null,
    percentPosition,
    success
  } = props;
  const {
    align: infoAlign,
    type: infoPosition
  } = percentPosition;
  const backgroundProps = strokeColor && typeof strokeColor !== 'string' ? handleGradient(strokeColor, directionConfig) : {
    [LineStrokeColorVar]: strokeColor,
    background: strokeColor
  };
  const borderRadius = strokeLinecap === 'square' || strokeLinecap === 'butt' ? 0 : undefined;
  const mergedSize = size !== null && size !== void 0 ? size : [-1, strokeWidth || (size === 'small' ? 6 : 8)];
  const [width, height] = getSize(mergedSize, 'line', {
    strokeWidth
  });
  if (false) {}
  const trailStyle = {
    backgroundColor: trailColor || undefined,
    borderRadius
  };
  const percentStyle = Object.assign(Object.assign({
    width: `${validProgress(percent)}%`,
    height,
    borderRadius
  }, backgroundProps), {
    [Percent]: validProgress(percent) / 100
  });
  const successPercent = getSuccessPercent(props);
  const successPercentStyle = {
    width: `${validProgress(successPercent)}%`,
    height,
    borderRadius,
    backgroundColor: success === null || success === void 0 ? void 0 : success.strokeColor
  };
  const outerStyle = {
    width: width < 0 ? '100%' : width
  };
  const lineInner = /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-inner`,
    style: trailStyle
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${prefixCls}-bg`, `${prefixCls}-bg-${infoPosition}`),
    style: percentStyle
  }, infoPosition === 'inner' && children), successPercent !== undefined && (/*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-success-bg`,
    style: successPercentStyle
  })));
  const isOuterStart = infoPosition === 'outer' && infoAlign === 'start';
  const isOuterEnd = infoPosition === 'outer' && infoAlign === 'end';
  return infoPosition === 'outer' && infoAlign === 'center' ? (/*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-layout-bottom`
  }, lineInner, children)) : (/*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-outer`,
    style: outerStyle
  }, isOuterStart && children, lineInner, isOuterEnd && children));
};
/* harmony default export */ var progress_Line = (Line);
;// CONCATENATED MODULE: ./node_modules/antd/es/progress/Steps.js
"use client";




const Steps = props => {
  const {
    size,
    steps,
    rounding: customRounding = Math.round,
    percent = 0,
    strokeWidth = 8,
    strokeColor,
    trailColor = null,
    prefixCls,
    children
  } = props;
  const current = customRounding(steps * (percent / 100));
  const stepWidth = size === 'small' ? 2 : 14;
  const mergedSize = size !== null && size !== void 0 ? size : [stepWidth, strokeWidth];
  const [width, height] = getSize(mergedSize, 'step', {
    steps,
    strokeWidth
  });
  const unitWidth = width / steps;
  const styledSteps = Array.from({
    length: steps
  });
  for (let i = 0; i < steps; i++) {
    const color = Array.isArray(strokeColor) ? strokeColor[i] : strokeColor;
    styledSteps[i] = /*#__PURE__*/react.createElement("div", {
      key: i,
      className: classnames_default()(`${prefixCls}-steps-item`, {
        [`${prefixCls}-steps-item-active`]: i <= current - 1
      }),
      style: {
        backgroundColor: i <= current - 1 ? color : trailColor,
        width: unitWidth,
        height
      }
    });
  }
  return /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-steps-outer`
  }, styledSteps, children);
};
/* harmony default export */ var progress_Steps = (Steps);
;// CONCATENATED MODULE: ./node_modules/antd/es/progress/progress.js
"use client";

var progress_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};















const ProgressTypes = (/* unused pure expression or super */ null && (['line', 'circle', 'dashboard']));
const ProgressStatuses = ['normal', 'exception', 'active', 'success'];
const Progress = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      steps,
      strokeColor,
      percent = 0,
      size = 'default',
      showInfo = true,
      type = 'line',
      status,
      format,
      style,
      percentPosition = {}
    } = props,
    restProps = progress_rest(props, ["prefixCls", "className", "rootClassName", "steps", "strokeColor", "percent", "size", "showInfo", "type", "status", "format", "style", "percentPosition"]);
  const {
    align: infoAlign = 'end',
    type: infoPosition = 'outer'
  } = percentPosition;
  const strokeColorNotArray = Array.isArray(strokeColor) ? strokeColor[0] : strokeColor;
  const strokeColorNotGradient = typeof strokeColor === 'string' || Array.isArray(strokeColor) ? strokeColor : undefined;
  const strokeColorIsBright = react.useMemo(() => {
    if (strokeColorNotArray) {
      const color = typeof strokeColorNotArray === 'string' ? strokeColorNotArray : Object.values(strokeColorNotArray)[0];
      return new es/* FastColor */.t(color).isLight();
    }
    return false;
  }, [strokeColor]);
  const percentNumber = react.useMemo(() => {
    var _a, _b;
    const successPercent = getSuccessPercent(props);
    return parseInt(successPercent !== undefined ? (_a = successPercent !== null && successPercent !== void 0 ? successPercent : 0) === null || _a === void 0 ? void 0 : _a.toString() : (_b = percent !== null && percent !== void 0 ? percent : 0) === null || _b === void 0 ? void 0 : _b.toString(), 10);
  }, [percent, props.success, props.successPercent]);
  const progressStatus = react.useMemo(() => {
    if (!ProgressStatuses.includes(status) && percentNumber >= 100) {
      return 'success';
    }
    return status || 'normal';
  }, [status, percentNumber]);
  const {
    getPrefixCls,
    direction,
    progress: progressStyle
  } = react.useContext(context/* ConfigContext */.E_);
  const prefixCls = getPrefixCls('progress', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = progress_style(prefixCls);
  const isLineType = type === 'line';
  const isPureLineType = isLineType && !steps;
  const progressInfo = react.useMemo(() => {
    if (!showInfo) {
      return null;
    }
    const successPercent = getSuccessPercent(props);
    let text;
    const textFormatter = format || (number => `${number}%`);
    const isBrightInnerColor = isLineType && strokeColorIsBright && infoPosition === 'inner';
    if (infoPosition === 'inner' || format || progressStatus !== 'exception' && progressStatus !== 'success') {
      text = textFormatter(validProgress(percent), validProgress(successPercent));
    } else if (progressStatus === 'exception') {
      text = isLineType ? /*#__PURE__*/react.createElement(CloseCircleFilled/* default */.Z, null) : /*#__PURE__*/react.createElement(CloseOutlined/* default */.Z, null);
    } else if (progressStatus === 'success') {
      text = isLineType ? /*#__PURE__*/react.createElement(CheckCircleFilled/* default */.Z, null) : /*#__PURE__*/react.createElement(CheckOutlined/* default */.Z, null);
    }
    return /*#__PURE__*/react.createElement("span", {
      className: classnames_default()(`${prefixCls}-text`, {
        [`${prefixCls}-text-bright`]: isBrightInnerColor,
        [`${prefixCls}-text-${infoAlign}`]: isPureLineType,
        [`${prefixCls}-text-${infoPosition}`]: isPureLineType
      }),
      title: typeof text === 'string' ? text : undefined
    }, text);
  }, [showInfo, percent, percentNumber, progressStatus, type, prefixCls, format]);
  if (false) {}
  let progress;
  // Render progress shape
  if (type === 'line') {
    progress = steps ? (/*#__PURE__*/react.createElement(progress_Steps, Object.assign({}, props, {
      strokeColor: strokeColorNotGradient,
      prefixCls: prefixCls,
      steps: typeof steps === 'object' ? steps.count : steps
    }), progressInfo)) : (/*#__PURE__*/react.createElement(progress_Line, Object.assign({}, props, {
      strokeColor: strokeColorNotArray,
      prefixCls: prefixCls,
      direction: direction,
      percentPosition: {
        align: infoAlign,
        type: infoPosition
      }
    }), progressInfo));
  } else if (type === 'circle' || type === 'dashboard') {
    progress = /*#__PURE__*/react.createElement(progress_Circle, Object.assign({}, props, {
      strokeColor: strokeColorNotArray,
      prefixCls: prefixCls,
      progressStatus: progressStatus
    }), progressInfo);
  }
  const classString = classnames_default()(prefixCls, `${prefixCls}-status-${progressStatus}`, {
    [`${prefixCls}-${type === 'dashboard' && 'circle' || type}`]: type !== 'line',
    [`${prefixCls}-inline-circle`]: type === 'circle' && getSize(size, 'circle')[0] <= 20,
    [`${prefixCls}-line`]: isPureLineType,
    [`${prefixCls}-line-align-${infoAlign}`]: isPureLineType,
    [`${prefixCls}-line-position-${infoPosition}`]: isPureLineType,
    [`${prefixCls}-steps`]: steps,
    [`${prefixCls}-show-info`]: showInfo,
    [`${prefixCls}-${size}`]: typeof size === 'string',
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, progressStyle === null || progressStyle === void 0 ? void 0 : progressStyle.className, className, rootClassName, hashId, cssVarCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", Object.assign({
    ref: ref,
    style: Object.assign(Object.assign({}, progressStyle === null || progressStyle === void 0 ? void 0 : progressStyle.style), style),
    className: classString,
    role: "progressbar",
    "aria-valuenow": percentNumber,
    "aria-valuemin": 0,
    "aria-valuemax": 100
  }, (0,omit/* default */.Z)(restProps, ['trailColor', 'strokeWidth', 'width', 'gapDegree', 'gapPosition', 'strokeLinecap', 'success', 'successPercent'])), progress));
});
if (false) {}
/* harmony default export */ var progress = (Progress);
;// CONCATENATED MODULE: ./node_modules/antd/es/progress/index.js
"use client";


/* harmony default export */ var es_progress = (progress);

/***/ }),

/***/ 39996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_row; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/responsiveObserver.js
var responsiveObserver = __webpack_require__(81840);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js
var context = __webpack_require__(94980);
// EXTERNAL MODULE: ./node_modules/antd/es/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(90909);
;// CONCATENATED MODULE: ./node_modules/antd/es/grid/hooks/useGutter.js

function useGutter(gutter, screens) {
  const results = [undefined, undefined];
  const normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, undefined];
  // By default use as `xs`
  const mergedScreens = screens || {
    xs: true,
    sm: true,
    md: true,
    lg: true,
    xl: true,
    xxl: true
  };
  normalizedGutter.forEach((g, index) => {
    if (typeof g === 'object' && g !== null) {
      for (let i = 0; i < responsiveObserver/* responsiveArray.length */.c4.length; i++) {
        const breakpoint = responsiveObserver/* responsiveArray */.c4[i];
        if (mergedScreens[breakpoint] && g[breakpoint] !== undefined) {
          results[index] = g[breakpoint];
          break;
        }
      }
    } else {
      results[index] = g;
    }
  });
  return results;
}
// EXTERNAL MODULE: ./node_modules/antd/es/grid/RowContext.js
var RowContext = __webpack_require__(40531);
// EXTERNAL MODULE: ./node_modules/antd/es/grid/style/index.js
var grid_style = __webpack_require__(92630);
;// CONCATENATED MODULE: ./node_modules/antd/es/grid/row.js
"use client";

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};








const _RowAligns = (/* unused pure expression or super */ null && (['top', 'middle', 'bottom', 'stretch']));
const _RowJustify = (/* unused pure expression or super */ null && (['start', 'end', 'center', 'space-around', 'space-between', 'space-evenly']));
function useMergedPropByScreen(oriProp, screen) {
  const [prop, setProp] = react.useState(typeof oriProp === 'string' ? oriProp : '');
  const calcMergedAlignOrJustify = () => {
    if (typeof oriProp === 'string') {
      setProp(oriProp);
    }
    if (typeof oriProp !== 'object') {
      return;
    }
    for (let i = 0; i < responsiveObserver/* responsiveArray.length */.c4.length; i++) {
      const breakpoint = responsiveObserver/* responsiveArray */.c4[i];
      // if do not match, do nothing
      if (!screen || !screen[breakpoint]) {
        continue;
      }
      const curVal = oriProp[breakpoint];
      if (curVal !== undefined) {
        setProp(curVal);
        return;
      }
    }
  };
  react.useEffect(() => {
    calcMergedAlignOrJustify();
  }, [JSON.stringify(oriProp), screen]);
  return prop;
}
const Row = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      justify,
      align,
      className,
      style,
      children,
      gutter = 0,
      wrap
    } = props,
    others = __rest(props, ["prefixCls", "justify", "align", "className", "style", "children", "gutter", "wrap"]);
  const {
    getPrefixCls,
    direction
  } = react.useContext(context/* ConfigContext */.E_);
  const screens = (0,useBreakpoint/* default */.Z)(true, null);
  const mergedAlign = useMergedPropByScreen(align, screens);
  const mergedJustify = useMergedPropByScreen(justify, screens);
  const prefixCls = getPrefixCls('row', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = (0,grid_style/* useRowStyle */.VM)(prefixCls);
  const gutters = useGutter(gutter, screens);
  const classes = classnames_default()(prefixCls, {
    [`${prefixCls}-no-wrap`]: wrap === false,
    [`${prefixCls}-${mergedJustify}`]: mergedJustify,
    [`${prefixCls}-${mergedAlign}`]: mergedAlign,
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, className, hashId, cssVarCls);
  // Add gutter related style
  const rowStyle = {};
  const horizontalGutter = gutters[0] != null && gutters[0] > 0 ? gutters[0] / -2 : undefined;
  if (horizontalGutter) {
    rowStyle.marginLeft = horizontalGutter;
    rowStyle.marginRight = horizontalGutter;
  }
  // "gutters" is a new array in each rendering phase, it'll make 'React.useMemo' effectless.
  // So we deconstruct "gutters" variable here.
  const [gutterH, gutterV] = gutters;
  rowStyle.rowGap = gutterV;
  const rowContext = react.useMemo(() => ({
    gutter: [gutterH, gutterV],
    wrap
  }), [gutterH, gutterV, wrap]);
  return wrapCSSVar(/*#__PURE__*/react.createElement(RowContext/* default.Provider */.Z.Provider, {
    value: rowContext
  }, /*#__PURE__*/react.createElement("div", Object.assign({}, others, {
    className: classes,
    style: Object.assign(Object.assign({}, rowStyle), style),
    ref: ref
  }), children)));
});
if (false) {}
/* harmony default export */ var row = (Row);
;// CONCATENATED MODULE: ./node_modules/antd/es/row/index.js
"use client";


/* harmony default export */ var es_row = (row);

/***/ }),

/***/ 44755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ skeleton; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js
var context = __webpack_require__(94980);
// EXTERNAL MODULE: ./node_modules/rc-util/es/omit.js
var omit = __webpack_require__(85401);
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/Element.js
"use client";



const Element = props => {
  const {
    prefixCls,
    className,
    style,
    size,
    shape
  } = props;
  const sizeCls = classnames_default()({
    [`${prefixCls}-lg`]: size === 'large',
    [`${prefixCls}-sm`]: size === 'small'
  });
  const shapeCls = classnames_default()({
    [`${prefixCls}-circle`]: shape === 'circle',
    [`${prefixCls}-square`]: shape === 'square',
    [`${prefixCls}-round`]: shape === 'round'
  });
  const sizeStyle = react.useMemo(() => typeof size === 'number' ? {
    width: size,
    height: size,
    lineHeight: `${size}px`
  } : {}, [size]);
  return /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(prefixCls, sizeCls, shapeCls, className),
    style: Object.assign(Object.assign({}, sizeStyle), style)
  });
};
/* harmony default export */ var skeleton_Element = (Element);
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs/es/index.js + 37 modules
var es = __webpack_require__(68946);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/util/genStyleUtils.js
var genStyleUtils = __webpack_require__(18511);
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs-utils/es/index.js + 12 modules
var cssinjs_utils_es = __webpack_require__(89158);
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/style/index.js


const skeletonClsLoading = new es/* Keyframes */.E4(`ant-skeleton-loading`, {
  '0%': {
    backgroundPosition: '100% 50%'
  },
  '100%': {
    backgroundPosition: '0 50%'
  }
});
const genSkeletonElementCommonSize = size => ({
  height: size,
  lineHeight: (0,es/* unit */.bf)(size)
});
const genSkeletonElementAvatarSize = size => Object.assign({
  width: size
}, genSkeletonElementCommonSize(size));
const genSkeletonColor = token => ({
  background: token.skeletonLoadingBackground,
  backgroundSize: '400% 100%',
  animationName: skeletonClsLoading,
  animationDuration: token.skeletonLoadingMotionDuration,
  animationTimingFunction: 'ease',
  animationIterationCount: 'infinite'
});
const genSkeletonElementInputSize = (size, calc) => Object.assign({
  width: calc(size).mul(5).equal(),
  minWidth: calc(size).mul(5).equal()
}, genSkeletonElementCommonSize(size));
const genSkeletonElementAvatar = token => {
  const {
    skeletonAvatarCls,
    gradientFromColor,
    controlHeight,
    controlHeightLG,
    controlHeightSM
  } = token;
  return {
    [skeletonAvatarCls]: Object.assign({
      display: 'inline-block',
      verticalAlign: 'top',
      background: gradientFromColor
    }, genSkeletonElementAvatarSize(controlHeight)),
    [`${skeletonAvatarCls}${skeletonAvatarCls}-circle`]: {
      borderRadius: '50%'
    },
    [`${skeletonAvatarCls}${skeletonAvatarCls}-lg`]: Object.assign({}, genSkeletonElementAvatarSize(controlHeightLG)),
    [`${skeletonAvatarCls}${skeletonAvatarCls}-sm`]: Object.assign({}, genSkeletonElementAvatarSize(controlHeightSM))
  };
};
const genSkeletonElementInput = token => {
  const {
    controlHeight,
    borderRadiusSM,
    skeletonInputCls,
    controlHeightLG,
    controlHeightSM,
    gradientFromColor,
    calc
  } = token;
  return {
    [skeletonInputCls]: Object.assign({
      display: 'inline-block',
      verticalAlign: 'top',
      background: gradientFromColor,
      borderRadius: borderRadiusSM
    }, genSkeletonElementInputSize(controlHeight, calc)),
    [`${skeletonInputCls}-lg`]: Object.assign({}, genSkeletonElementInputSize(controlHeightLG, calc)),
    [`${skeletonInputCls}-sm`]: Object.assign({}, genSkeletonElementInputSize(controlHeightSM, calc))
  };
};
const genSkeletonElementImageSize = size => Object.assign({
  width: size
}, genSkeletonElementCommonSize(size));
const genSkeletonElementImage = token => {
  const {
    skeletonImageCls,
    imageSizeBase,
    gradientFromColor,
    borderRadiusSM,
    calc
  } = token;
  return {
    [skeletonImageCls]: Object.assign(Object.assign({
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      verticalAlign: 'middle',
      background: gradientFromColor,
      borderRadius: borderRadiusSM
    }, genSkeletonElementImageSize(calc(imageSizeBase).mul(2).equal())), {
      [`${skeletonImageCls}-path`]: {
        fill: '#bfbfbf'
      },
      [`${skeletonImageCls}-svg`]: Object.assign(Object.assign({}, genSkeletonElementImageSize(imageSizeBase)), {
        maxWidth: calc(imageSizeBase).mul(4).equal(),
        maxHeight: calc(imageSizeBase).mul(4).equal()
      }),
      [`${skeletonImageCls}-svg${skeletonImageCls}-svg-circle`]: {
        borderRadius: '50%'
      }
    }),
    [`${skeletonImageCls}${skeletonImageCls}-circle`]: {
      borderRadius: '50%'
    }
  };
};
const genSkeletonElementButtonShape = (token, size, buttonCls) => {
  const {
    skeletonButtonCls
  } = token;
  return {
    [`${buttonCls}${skeletonButtonCls}-circle`]: {
      width: size,
      minWidth: size,
      borderRadius: '50%'
    },
    [`${buttonCls}${skeletonButtonCls}-round`]: {
      borderRadius: size
    }
  };
};
const genSkeletonElementButtonSize = (size, calc) => Object.assign({
  width: calc(size).mul(2).equal(),
  minWidth: calc(size).mul(2).equal()
}, genSkeletonElementCommonSize(size));
const genSkeletonElementButton = token => {
  const {
    borderRadiusSM,
    skeletonButtonCls,
    controlHeight,
    controlHeightLG,
    controlHeightSM,
    gradientFromColor,
    calc
  } = token;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    [skeletonButtonCls]: Object.assign({
      display: 'inline-block',
      verticalAlign: 'top',
      background: gradientFromColor,
      borderRadius: borderRadiusSM,
      width: calc(controlHeight).mul(2).equal(),
      minWidth: calc(controlHeight).mul(2).equal()
    }, genSkeletonElementButtonSize(controlHeight, calc))
  }, genSkeletonElementButtonShape(token, controlHeight, skeletonButtonCls)), {
    [`${skeletonButtonCls}-lg`]: Object.assign({}, genSkeletonElementButtonSize(controlHeightLG, calc))
  }), genSkeletonElementButtonShape(token, controlHeightLG, `${skeletonButtonCls}-lg`)), {
    [`${skeletonButtonCls}-sm`]: Object.assign({}, genSkeletonElementButtonSize(controlHeightSM, calc))
  }), genSkeletonElementButtonShape(token, controlHeightSM, `${skeletonButtonCls}-sm`));
};
// =============================== Base ===============================
const genBaseStyle = token => {
  const {
    componentCls,
    skeletonAvatarCls,
    skeletonTitleCls,
    skeletonParagraphCls,
    skeletonButtonCls,
    skeletonInputCls,
    skeletonImageCls,
    controlHeight,
    controlHeightLG,
    controlHeightSM,
    gradientFromColor,
    padding,
    marginSM,
    borderRadius,
    titleHeight,
    blockRadius,
    paragraphLiHeight,
    controlHeightXS,
    paragraphMarginTop
  } = token;
  return {
    [componentCls]: {
      display: 'table',
      width: '100%',
      [`${componentCls}-header`]: {
        display: 'table-cell',
        paddingInlineEnd: padding,
        verticalAlign: 'top',
        // Avatar
        [skeletonAvatarCls]: Object.assign({
          display: 'inline-block',
          verticalAlign: 'top',
          background: gradientFromColor
        }, genSkeletonElementAvatarSize(controlHeight)),
        [`${skeletonAvatarCls}-circle`]: {
          borderRadius: '50%'
        },
        [`${skeletonAvatarCls}-lg`]: Object.assign({}, genSkeletonElementAvatarSize(controlHeightLG)),
        [`${skeletonAvatarCls}-sm`]: Object.assign({}, genSkeletonElementAvatarSize(controlHeightSM))
      },
      [`${componentCls}-content`]: {
        display: 'table-cell',
        width: '100%',
        verticalAlign: 'top',
        // Title
        [skeletonTitleCls]: {
          width: '100%',
          height: titleHeight,
          background: gradientFromColor,
          borderRadius: blockRadius,
          [`+ ${skeletonParagraphCls}`]: {
            marginBlockStart: controlHeightSM
          }
        },
        // paragraph
        [skeletonParagraphCls]: {
          padding: 0,
          '> li': {
            width: '100%',
            height: paragraphLiHeight,
            listStyle: 'none',
            background: gradientFromColor,
            borderRadius: blockRadius,
            '+ li': {
              marginBlockStart: controlHeightXS
            }
          }
        },
        [`${skeletonParagraphCls}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
          width: '61%'
        }
      },
      [`&-round ${componentCls}-content`]: {
        [`${skeletonTitleCls}, ${skeletonParagraphCls} > li`]: {
          borderRadius
        }
      }
    },
    [`${componentCls}-with-avatar ${componentCls}-content`]: {
      // Title
      [skeletonTitleCls]: {
        marginBlockStart: marginSM,
        [`+ ${skeletonParagraphCls}`]: {
          marginBlockStart: paragraphMarginTop
        }
      }
    },
    // Skeleton element
    [`${componentCls}${componentCls}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
      display: 'inline-block',
      width: 'auto'
    }, genSkeletonElementButton(token)), genSkeletonElementAvatar(token)), genSkeletonElementInput(token)), genSkeletonElementImage(token)),
    // Skeleton Block Button, Input
    [`${componentCls}${componentCls}-block`]: {
      width: '100%',
      [skeletonButtonCls]: {
        width: '100%'
      },
      [skeletonInputCls]: {
        width: '100%'
      }
    },
    // With active animation
    [`${componentCls}${componentCls}-active`]: {
      [`
        ${skeletonTitleCls},
        ${skeletonParagraphCls} > li,
        ${skeletonAvatarCls},
        ${skeletonButtonCls},
        ${skeletonInputCls},
        ${skeletonImageCls}
      `]: Object.assign({}, genSkeletonColor(token))
    }
  };
};
// ============================== Export ==============================
const prepareComponentToken = token => {
  const {
    colorFillContent,
    colorFill
  } = token;
  const gradientFromColor = colorFillContent;
  const gradientToColor = colorFill;
  return {
    color: gradientFromColor,
    colorGradientEnd: gradientToColor,
    gradientFromColor,
    gradientToColor,
    titleHeight: token.controlHeight / 2,
    blockRadius: token.borderRadiusSM,
    paragraphMarginTop: token.marginLG + token.marginXXS,
    paragraphLiHeight: token.controlHeight / 2
  };
};
/* harmony default export */ var skeleton_style = ((0,genStyleUtils/* genStyleHooks */.I$)('Skeleton', token => {
  const {
    componentCls,
    calc
  } = token;
  const skeletonToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    skeletonAvatarCls: `${componentCls}-avatar`,
    skeletonTitleCls: `${componentCls}-title`,
    skeletonParagraphCls: `${componentCls}-paragraph`,
    skeletonButtonCls: `${componentCls}-button`,
    skeletonInputCls: `${componentCls}-input`,
    skeletonImageCls: `${componentCls}-image`,
    imageSizeBase: calc(token.controlHeight).mul(1.5).equal(),
    borderRadius: 100,
    // Large number to make capsule shape
    skeletonLoadingBackground: `linear-gradient(90deg, ${token.gradientFromColor} 25%, ${token.gradientToColor} 37%, ${token.gradientFromColor} 63%)`,
    skeletonLoadingMotionDuration: '1.4s'
  });
  return genBaseStyle(skeletonToken);
}, prepareComponentToken, {
  deprecatedTokens: [['color', 'gradientFromColor'], ['colorGradientEnd', 'gradientToColor']]
}));
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/Avatar.js
"use client";







const SkeletonAvatar = props => {
  const {
    prefixCls: customizePrefixCls,
    className,
    rootClassName,
    active,
    shape = 'circle',
    size = 'default'
  } = props;
  const {
    getPrefixCls
  } = react.useContext(context/* ConfigContext */.E_);
  const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = skeleton_style(prefixCls);
  const otherProps = (0,omit/* default */.Z)(props, ['prefixCls', 'className']);
  const cls = classnames_default()(prefixCls, `${prefixCls}-element`, {
    [`${prefixCls}-active`]: active
  }, className, rootClassName, hashId, cssVarCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    className: cls
  }, /*#__PURE__*/react.createElement(skeleton_Element, Object.assign({
    prefixCls: `${prefixCls}-avatar`,
    shape: shape,
    size: size
  }, otherProps))));
};
/* harmony default export */ var Avatar = (SkeletonAvatar);
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/Button.js
"use client";







const SkeletonButton = props => {
  const {
    prefixCls: customizePrefixCls,
    className,
    rootClassName,
    active,
    block = false,
    size = 'default'
  } = props;
  const {
    getPrefixCls
  } = react.useContext(context/* ConfigContext */.E_);
  const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = skeleton_style(prefixCls);
  const otherProps = (0,omit/* default */.Z)(props, ['prefixCls']);
  const cls = classnames_default()(prefixCls, `${prefixCls}-element`, {
    [`${prefixCls}-active`]: active,
    [`${prefixCls}-block`]: block
  }, className, rootClassName, hashId, cssVarCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    className: cls
  }, /*#__PURE__*/react.createElement(skeleton_Element, Object.assign({
    prefixCls: `${prefixCls}-button`,
    size: size
  }, otherProps))));
};
/* harmony default export */ var Button = (SkeletonButton);
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/Image.js
"use client";





const path = 'M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z';
const SkeletonImage = props => {
  const {
    prefixCls: customizePrefixCls,
    className,
    rootClassName,
    style,
    active
  } = props;
  const {
    getPrefixCls
  } = react.useContext(context/* ConfigContext */.E_);
  const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = skeleton_style(prefixCls);
  const cls = classnames_default()(prefixCls, `${prefixCls}-element`, {
    [`${prefixCls}-active`]: active
  }, className, rootClassName, hashId, cssVarCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    className: cls
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${prefixCls}-image`, className),
    style: style
  }, /*#__PURE__*/react.createElement("svg", {
    viewBox: "0 0 1098 1024",
    xmlns: "http://www.w3.org/2000/svg",
    className: `${prefixCls}-image-svg`
  }, /*#__PURE__*/react.createElement("title", null, "Image placeholder"), /*#__PURE__*/react.createElement("path", {
    d: path,
    className: `${prefixCls}-image-path`
  })))));
};
/* harmony default export */ var Image = (SkeletonImage);
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/Input.js
"use client";







const SkeletonInput = props => {
  const {
    prefixCls: customizePrefixCls,
    className,
    rootClassName,
    active,
    block,
    size = 'default'
  } = props;
  const {
    getPrefixCls
  } = react.useContext(context/* ConfigContext */.E_);
  const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = skeleton_style(prefixCls);
  const otherProps = (0,omit/* default */.Z)(props, ['prefixCls']);
  const cls = classnames_default()(prefixCls, `${prefixCls}-element`, {
    [`${prefixCls}-active`]: active,
    [`${prefixCls}-block`]: block
  }, className, rootClassName, hashId, cssVarCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    className: cls
  }, /*#__PURE__*/react.createElement(skeleton_Element, Object.assign({
    prefixCls: `${prefixCls}-input`,
    size: size
  }, otherProps))));
};
/* harmony default export */ var Input = (SkeletonInput);
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/Node.js
"use client";





const SkeletonNode = props => {
  const {
    prefixCls: customizePrefixCls,
    className,
    rootClassName,
    style,
    active,
    children
  } = props;
  const {
    getPrefixCls
  } = react.useContext(context/* ConfigContext */.E_);
  const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = skeleton_style(prefixCls);
  const cls = classnames_default()(prefixCls, `${prefixCls}-element`, {
    [`${prefixCls}-active`]: active
  }, hashId, className, rootClassName, cssVarCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    className: cls
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${prefixCls}-image`, className),
    style: style
  }, children)));
};
/* harmony default export */ var Node = (SkeletonNode);
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/Paragraph.js
"use client";



const getWidth = (index, props) => {
  const {
    width,
    rows = 2
  } = props;
  if (Array.isArray(width)) {
    return width[index];
  }
  // last paragraph
  if (rows - 1 === index) {
    return width;
  }
  return undefined;
};
const Paragraph = props => {
  const {
    prefixCls,
    className,
    style,
    rows = 0
  } = props;
  const rowList = Array.from({
    length: rows
  }).map((_, index) => (/*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  react.createElement("li", {
    key: index,
    style: {
      width: getWidth(index, props)
    }
  })));
  return /*#__PURE__*/react.createElement("ul", {
    className: classnames_default()(prefixCls, className),
    style: style
  }, rowList);
};
/* harmony default export */ var skeleton_Paragraph = (Paragraph);
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/Title.js
"use client";

/* eslint-disable jsx-a11y/heading-has-content */


const Title = ({
  prefixCls,
  className,
  width,
  style
}) => (/*#__PURE__*/
// biome-ignore lint/a11y/useHeadingContent: HOC here
react.createElement("h3", {
  className: classnames_default()(prefixCls, className),
  style: Object.assign({
    width
  }, style)
}));
/* harmony default export */ var skeleton_Title = (Title);
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/Skeleton.js
"use client";













function getComponentProps(prop) {
  if (prop && typeof prop === 'object') {
    return prop;
  }
  return {};
}
function getAvatarBasicProps(hasTitle, hasParagraph) {
  if (hasTitle && !hasParagraph) {
    // Square avatar
    return {
      size: 'large',
      shape: 'square'
    };
  }
  return {
    size: 'large',
    shape: 'circle'
  };
}
function getTitleBasicProps(hasAvatar, hasParagraph) {
  if (!hasAvatar && hasParagraph) {
    return {
      width: '38%'
    };
  }
  if (hasAvatar && hasParagraph) {
    return {
      width: '50%'
    };
  }
  return {};
}
function getParagraphBasicProps(hasAvatar, hasTitle) {
  const basicProps = {};
  // Width
  if (!hasAvatar || !hasTitle) {
    basicProps.width = '61%';
  }
  // Rows
  if (!hasAvatar && hasTitle) {
    basicProps.rows = 3;
  } else {
    basicProps.rows = 2;
  }
  return basicProps;
}
const Skeleton = props => {
  const {
    prefixCls: customizePrefixCls,
    loading,
    className,
    rootClassName,
    style,
    children,
    avatar = false,
    title = true,
    paragraph = true,
    active,
    round
  } = props;
  const {
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle
  } = (0,context/* useComponentConfig */.dj)('skeleton');
  const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = skeleton_style(prefixCls);
  if (loading || !('loading' in props)) {
    const hasAvatar = !!avatar;
    const hasTitle = !!title;
    const hasParagraph = !!paragraph;
    // Avatar
    let avatarNode;
    if (hasAvatar) {
      const avatarProps = Object.assign(Object.assign({
        prefixCls: `${prefixCls}-avatar`
      }, getAvatarBasicProps(hasTitle, hasParagraph)), getComponentProps(avatar));
      // We direct use SkeletonElement as avatar in skeleton internal.
      avatarNode = /*#__PURE__*/react.createElement("div", {
        className: `${prefixCls}-header`
      }, /*#__PURE__*/react.createElement(skeleton_Element, Object.assign({}, avatarProps)));
    }
    let contentNode;
    if (hasTitle || hasParagraph) {
      // Title
      let $title;
      if (hasTitle) {
        const titleProps = Object.assign(Object.assign({
          prefixCls: `${prefixCls}-title`
        }, getTitleBasicProps(hasAvatar, hasParagraph)), getComponentProps(title));
        $title = /*#__PURE__*/react.createElement(skeleton_Title, Object.assign({}, titleProps));
      }
      // Paragraph
      let paragraphNode;
      if (hasParagraph) {
        const paragraphProps = Object.assign(Object.assign({
          prefixCls: `${prefixCls}-paragraph`
        }, getParagraphBasicProps(hasAvatar, hasTitle)), getComponentProps(paragraph));
        paragraphNode = /*#__PURE__*/react.createElement(skeleton_Paragraph, Object.assign({}, paragraphProps));
      }
      contentNode = /*#__PURE__*/react.createElement("div", {
        className: `${prefixCls}-content`
      }, $title, paragraphNode);
    }
    const cls = classnames_default()(prefixCls, {
      [`${prefixCls}-with-avatar`]: hasAvatar,
      [`${prefixCls}-active`]: active,
      [`${prefixCls}-rtl`]: direction === 'rtl',
      [`${prefixCls}-round`]: round
    }, contextClassName, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
      className: cls,
      style: Object.assign(Object.assign({}, contextStyle), style)
    }, avatarNode, contentNode));
  }
  return children !== null && children !== void 0 ? children : null;
};
Skeleton.Button = Button;
Skeleton.Avatar = Avatar;
Skeleton.Input = Input;
Skeleton.Image = Image;
Skeleton.Node = Node;
if (false) {}
/* harmony default export */ var skeleton_Skeleton = (Skeleton);
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/index.js
"use client";


/* harmony default export */ var skeleton = (skeleton_Skeleton);

/***/ }),

/***/ 38625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BR": function() { return /* binding */ NoCompactStyle; },
/* harmony export */   "ri": function() { return /* binding */ useCompactItemContext; }
/* harmony export */ });
/* unused harmony export SpaceCompactItemContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68925);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var rc_util_es_Children_toArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93550);
/* harmony import */ var _config_provider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94980);
/* harmony import */ var _config_provider_hooks_useSize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27011);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57983);
"use client";

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






const SpaceCompactItemContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
const useCompactItemContext = (prefixCls, direction) => {
  const compactItemContext = react__WEBPACK_IMPORTED_MODULE_0__.useContext(SpaceCompactItemContext);
  const compactItemClassnames = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (!compactItemContext) {
      return '';
    }
    const {
      compactDirection,
      isFirstItem,
      isLastItem
    } = compactItemContext;
    const separator = compactDirection === 'vertical' ? '-vertical-' : '-';
    return classnames__WEBPACK_IMPORTED_MODULE_1___default()(`${prefixCls}-compact${separator}item`, {
      [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
      [`${prefixCls}-compact${separator}last-item`]: isLastItem,
      [`${prefixCls}-compact${separator}item-rtl`]: direction === 'rtl'
    });
  }, [prefixCls, direction, compactItemContext]);
  return {
    compactSize: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactSize,
    compactDirection: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactDirection,
    compactItemClassnames
  };
};
const NoCompactStyle = props => {
  const {
    children
  } = props;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(SpaceCompactItemContext.Provider, {
    value: null
  }, children);
};
const CompactItem = props => {
  const {
      children
    } = props,
    others = __rest(props, ["children"]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(SpaceCompactItemContext.Provider, {
    value: react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => others, [others])
  }, children);
};
const Compact = props => {
  const {
    getPrefixCls,
    direction: directionConfig
  } = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_config_provider__WEBPACK_IMPORTED_MODULE_3__/* .ConfigContext */ .E_);
  const {
      size,
      direction,
      block,
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      children
    } = props,
    restProps = __rest(props, ["size", "direction", "block", "prefixCls", "className", "rootClassName", "children"]);
  const mergedSize = (0,_config_provider_hooks_useSize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ctx => size !== null && size !== void 0 ? size : ctx);
  const prefixCls = getPrefixCls('space-compact', customizePrefixCls);
  const [wrapCSSVar, hashId] = (0,_style__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(prefixCls);
  const clx = classnames__WEBPACK_IMPORTED_MODULE_1___default()(prefixCls, hashId, {
    [`${prefixCls}-rtl`]: directionConfig === 'rtl',
    [`${prefixCls}-block`]: block,
    [`${prefixCls}-vertical`]: direction === 'vertical'
  }, className, rootClassName);
  const compactItemContext = react__WEBPACK_IMPORTED_MODULE_0__.useContext(SpaceCompactItemContext);
  const childNodes = (0,rc_util_es_Children_toArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(children);
  const nodes = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => childNodes.map((child, i) => {
    const key = (child === null || child === void 0 ? void 0 : child.key) || `${prefixCls}-item-${i}`;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(CompactItem, {
      key: key,
      compactSize: mergedSize,
      compactDirection: direction,
      isFirstItem: i === 0 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isFirstItem)),
      isLastItem: i === childNodes.length - 1 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isLastItem))
    }, child);
  }), [size, childNodes, compactItemContext]);
  // =========================== Render ===========================
  if (childNodes.length === 0) {
    return null;
  }
  return wrapCSSVar(/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", Object.assign({
    className: clx
  }, restProps), nodes));
};
/* harmony default export */ __webpack_exports__["ZP"] = (Compact);

/***/ }),

/***/ 57983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ style; }
});

// UNUSED EXPORTS: prepareComponentToken

// EXTERNAL MODULE: ./node_modules/antd/es/theme/util/genStyleUtils.js
var genStyleUtils = __webpack_require__(18511);
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs-utils/es/index.js + 12 modules
var es = __webpack_require__(89158);
;// CONCATENATED MODULE: ./node_modules/antd/es/space/style/compact.js
const genSpaceCompactStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [componentCls]: {
      '&-block': {
        display: 'flex',
        width: '100%'
      },
      '&-vertical': {
        flexDirection: 'column'
      }
    }
  };
};
// ============================== Export ==============================
/* harmony default export */ var compact = (genSpaceCompactStyle);
;// CONCATENATED MODULE: ./node_modules/antd/es/space/style/index.js


const genSpaceStyle = token => {
  const {
    componentCls,
    antCls
  } = token;
  return {
    [componentCls]: {
      display: 'inline-flex',
      '&-rtl': {
        direction: 'rtl'
      },
      '&-vertical': {
        flexDirection: 'column'
      },
      '&-align': {
        flexDirection: 'column',
        '&-center': {
          alignItems: 'center'
        },
        '&-start': {
          alignItems: 'flex-start'
        },
        '&-end': {
          alignItems: 'flex-end'
        },
        '&-baseline': {
          alignItems: 'baseline'
        }
      },
      [`${componentCls}-item:empty`]: {
        display: 'none'
      },
      // https://github.com/ant-design/ant-design/issues/47875
      [`${componentCls}-item > ${antCls}-badge-not-a-wrapper:only-child`]: {
        display: 'block'
      }
    }
  };
};
const genSpaceGapStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [componentCls]: {
      '&-gap-row-small': {
        rowGap: token.spaceGapSmallSize
      },
      '&-gap-row-middle': {
        rowGap: token.spaceGapMiddleSize
      },
      '&-gap-row-large': {
        rowGap: token.spaceGapLargeSize
      },
      '&-gap-col-small': {
        columnGap: token.spaceGapSmallSize
      },
      '&-gap-col-middle': {
        columnGap: token.spaceGapMiddleSize
      },
      '&-gap-col-large': {
        columnGap: token.spaceGapLargeSize
      }
    }
  };
};
// ============================== Export ==============================
const prepareComponentToken = () => ({});
/* harmony default export */ var style = ((0,genStyleUtils/* genStyleHooks */.I$)('Space', token => {
  const spaceToken = (0,es/* mergeToken */.IX)(token, {
    spaceGapSmallSize: token.paddingXS,
    spaceGapMiddleSize: token.padding,
    spaceGapLargeSize: token.paddingLG
  });
  return [genSpaceStyle(spaceToken), genSpaceGapStyle(spaceToken), compact(spaceToken)];
}, () => ({}), {
  // Space component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/40315
  resetStyle: false
}));

/***/ }),

/***/ 42339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ spin; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/throttle-debounce/esm/index.js
var esm = __webpack_require__(99422);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js
var context = __webpack_require__(94980);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/reactNode.js
var reactNode = __webpack_require__(81730);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useLayoutEffect.js
var useLayoutEffect = __webpack_require__(76963);
;// CONCATENATED MODULE: ./node_modules/antd/es/spin/Indicator/Progress.js
"use client";




const viewSize = 100;
const borderWidth = viewSize / 5;
const radius = viewSize / 2 - borderWidth / 2;
const circumference = radius * 2 * Math.PI;
const position = 50;
const CustomCircle = props => {
  const {
    dotClassName,
    style,
    hasCircleCls
  } = props;
  return /*#__PURE__*/react.createElement("circle", {
    className: classnames_default()(`${dotClassName}-circle`, {
      [`${dotClassName}-circle-bg`]: hasCircleCls
    }),
    r: radius,
    cx: position,
    cy: position,
    strokeWidth: borderWidth,
    style: style
  });
};
const Progress = ({
  percent,
  prefixCls
}) => {
  const dotClassName = `${prefixCls}-dot`;
  const holderClassName = `${dotClassName}-holder`;
  const hideClassName = `${holderClassName}-hidden`;
  const [render, setRender] = react.useState(false);
  // ==================== Visible =====================
  (0,useLayoutEffect/* default */.Z)(() => {
    if (percent !== 0) {
      setRender(true);
    }
  }, [percent !== 0]);
  // ==================== Progress ====================
  const safePtg = Math.max(Math.min(percent, 100), 0);
  // ===================== Render =====================
  if (!render) {
    return null;
  }
  const circleStyle = {
    strokeDashoffset: `${circumference / 4}`,
    strokeDasharray: `${circumference * safePtg / 100} ${circumference * (100 - safePtg) / 100}`
  };
  return /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(holderClassName, `${dotClassName}-progress`, safePtg <= 0 && hideClassName)
  }, /*#__PURE__*/react.createElement("svg", {
    viewBox: `0 0 ${viewSize} ${viewSize}`,
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": safePtg
  }, /*#__PURE__*/react.createElement(CustomCircle, {
    dotClassName: dotClassName,
    hasCircleCls: true
  }), /*#__PURE__*/react.createElement(CustomCircle, {
    dotClassName: dotClassName,
    style: circleStyle
  })));
};
/* harmony default export */ var Indicator_Progress = (Progress);
;// CONCATENATED MODULE: ./node_modules/antd/es/spin/Indicator/Looper.js
"use client";




function Looper(props) {
  const {
    prefixCls,
    percent = 0
  } = props;
  const dotClassName = `${prefixCls}-dot`;
  const holderClassName = `${dotClassName}-holder`;
  const hideClassName = `${holderClassName}-hidden`;
  // ===================== Render =====================
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(holderClassName, percent > 0 && hideClassName)
  }, /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(dotClassName, `${prefixCls}-dot-spin`)
  }, [1, 2, 3, 4].map(i => (/*#__PURE__*/react.createElement("i", {
    className: `${prefixCls}-dot-item`,
    key: i
  }))))), /*#__PURE__*/react.createElement(Indicator_Progress, {
    prefixCls: prefixCls,
    percent: percent
  }));
}
;// CONCATENATED MODULE: ./node_modules/antd/es/spin/Indicator/index.js
"use client";





function Indicator(props) {
  var _a;
  const {
    prefixCls,
    indicator,
    percent
  } = props;
  const dotClassName = `${prefixCls}-dot`;
  if (indicator && /*#__PURE__*/react.isValidElement(indicator)) {
    return (0,reactNode/* cloneElement */.Tm)(indicator, {
      className: classnames_default()((_a = indicator.props) === null || _a === void 0 ? void 0 : _a.className, dotClassName),
      percent
    });
  }
  return /*#__PURE__*/react.createElement(Looper, {
    prefixCls: prefixCls,
    percent: percent
  });
}
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs/es/index.js + 37 modules
var es = __webpack_require__(68946);
// EXTERNAL MODULE: ./node_modules/antd/es/style/index.js
var style = __webpack_require__(31875);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/util/genStyleUtils.js
var genStyleUtils = __webpack_require__(18511);
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs-utils/es/index.js + 12 modules
var cssinjs_utils_es = __webpack_require__(89158);
;// CONCATENATED MODULE: ./node_modules/antd/es/spin/style/index.js



const antSpinMove = new es/* Keyframes */.E4('antSpinMove', {
  to: {
    opacity: 1
  }
});
const antRotate = new es/* Keyframes */.E4('antRotate', {
  to: {
    transform: 'rotate(405deg)'
  }
});
const genSpinStyle = token => {
  const {
    componentCls,
    calc
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign({}, (0,style/* resetComponent */.Wf)(token)), {
      position: 'absolute',
      display: 'none',
      color: token.colorPrimary,
      fontSize: 0,
      textAlign: 'center',
      verticalAlign: 'middle',
      opacity: 0,
      transition: `transform ${token.motionDurationSlow} ${token.motionEaseInOutCirc}`,
      '&-spinning': {
        position: 'relative',
        display: 'inline-block',
        opacity: 1
      },
      [`${componentCls}-text`]: {
        fontSize: token.fontSize,
        paddingTop: calc(calc(token.dotSize).sub(token.fontSize)).div(2).add(2).equal()
      },
      '&-fullscreen': {
        position: 'fixed',
        width: '100vw',
        height: '100vh',
        backgroundColor: token.colorBgMask,
        zIndex: token.zIndexPopupBase,
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        opacity: 0,
        visibility: 'hidden',
        transition: `all ${token.motionDurationMid}`,
        '&-show': {
          opacity: 1,
          visibility: 'visible'
        },
        [componentCls]: {
          [`${componentCls}-dot-holder`]: {
            color: token.colorWhite
          },
          [`${componentCls}-text`]: {
            color: token.colorTextLightSolid
          }
        }
      },
      '&-nested-loading': {
        position: 'relative',
        [`> div > ${componentCls}`]: {
          position: 'absolute',
          top: 0,
          insetInlineStart: 0,
          zIndex: 4,
          display: 'block',
          width: '100%',
          height: '100%',
          maxHeight: token.contentHeight,
          [`${componentCls}-dot`]: {
            position: 'absolute',
            top: '50%',
            insetInlineStart: '50%',
            margin: calc(token.dotSize).mul(-1).div(2).equal()
          },
          [`${componentCls}-text`]: {
            position: 'absolute',
            top: '50%',
            width: '100%',
            textShadow: `0 1px 2px ${token.colorBgContainer}` // FIXME: shadow
          },
          [`&${componentCls}-show-text ${componentCls}-dot`]: {
            marginTop: calc(token.dotSize).div(2).mul(-1).sub(10).equal()
          },
          '&-sm': {
            [`${componentCls}-dot`]: {
              margin: calc(token.dotSizeSM).mul(-1).div(2).equal()
            },
            [`${componentCls}-text`]: {
              paddingTop: calc(calc(token.dotSizeSM).sub(token.fontSize)).div(2).add(2).equal()
            },
            [`&${componentCls}-show-text ${componentCls}-dot`]: {
              marginTop: calc(token.dotSizeSM).div(2).mul(-1).sub(10).equal()
            }
          },
          '&-lg': {
            [`${componentCls}-dot`]: {
              margin: calc(token.dotSizeLG).mul(-1).div(2).equal()
            },
            [`${componentCls}-text`]: {
              paddingTop: calc(calc(token.dotSizeLG).sub(token.fontSize)).div(2).add(2).equal()
            },
            [`&${componentCls}-show-text ${componentCls}-dot`]: {
              marginTop: calc(token.dotSizeLG).div(2).mul(-1).sub(10).equal()
            }
          }
        },
        [`${componentCls}-container`]: {
          position: 'relative',
          transition: `opacity ${token.motionDurationSlow}`,
          '&::after': {
            position: 'absolute',
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            zIndex: 10,
            width: '100%',
            height: '100%',
            background: token.colorBgContainer,
            opacity: 0,
            transition: `all ${token.motionDurationSlow}`,
            content: '""',
            pointerEvents: 'none'
          }
        },
        [`${componentCls}-blur`]: {
          clear: 'both',
          opacity: 0.5,
          userSelect: 'none',
          pointerEvents: 'none',
          '&::after': {
            opacity: 0.4,
            pointerEvents: 'auto'
          }
        }
      },
      // tip
      // ------------------------------
      '&-tip': {
        color: token.spinDotDefault
      },
      // holder
      // ------------------------------
      [`${componentCls}-dot-holder`]: {
        width: '1em',
        height: '1em',
        fontSize: token.dotSize,
        display: 'inline-block',
        transition: `transform ${token.motionDurationSlow} ease, opacity ${token.motionDurationSlow} ease`,
        transformOrigin: '50% 50%',
        lineHeight: 1,
        color: token.colorPrimary,
        '&-hidden': {
          transform: 'scale(0.3)',
          opacity: 0
        }
      },
      // progress
      // ------------------------------
      [`${componentCls}-dot-progress`]: {
        position: 'absolute',
        inset: 0
      },
      // dots
      // ------------------------------
      [`${componentCls}-dot`]: {
        position: 'relative',
        display: 'inline-block',
        fontSize: token.dotSize,
        width: '1em',
        height: '1em',
        '&-item': {
          position: 'absolute',
          display: 'block',
          width: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
          height: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
          background: 'currentColor',
          borderRadius: '100%',
          transform: 'scale(0.75)',
          transformOrigin: '50% 50%',
          opacity: 0.3,
          animationName: antSpinMove,
          animationDuration: '1s',
          animationIterationCount: 'infinite',
          animationTimingFunction: 'linear',
          animationDirection: 'alternate',
          '&:nth-child(1)': {
            top: 0,
            insetInlineStart: 0,
            animationDelay: '0s'
          },
          '&:nth-child(2)': {
            top: 0,
            insetInlineEnd: 0,
            animationDelay: '0.4s'
          },
          '&:nth-child(3)': {
            insetInlineEnd: 0,
            bottom: 0,
            animationDelay: '0.8s'
          },
          '&:nth-child(4)': {
            bottom: 0,
            insetInlineStart: 0,
            animationDelay: '1.2s'
          }
        },
        '&-spin': {
          transform: 'rotate(45deg)',
          animationName: antRotate,
          animationDuration: '1.2s',
          animationIterationCount: 'infinite',
          animationTimingFunction: 'linear'
        },
        '&-circle': {
          strokeLinecap: 'round',
          transition: ['stroke-dashoffset', 'stroke-dasharray', 'stroke', 'stroke-width', 'opacity'].map(item => `${item} ${token.motionDurationSlow} ease`).join(','),
          fillOpacity: 0,
          stroke: 'currentcolor'
        },
        '&-circle-bg': {
          stroke: token.colorFillSecondary
        }
      },
      // small
      [`&-sm ${componentCls}-dot`]: {
        '&, &-holder': {
          fontSize: token.dotSizeSM
        }
      },
      [`&-sm ${componentCls}-dot-holder`]: {
        i: {
          width: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal(),
          height: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal()
        }
      },
      // large
      [`&-lg ${componentCls}-dot`]: {
        '&, &-holder': {
          fontSize: token.dotSizeLG
        }
      },
      [`&-lg ${componentCls}-dot-holder`]: {
        i: {
          width: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal(),
          height: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal()
        }
      },
      [`&${componentCls}-show-text ${componentCls}-text`]: {
        display: 'block'
      }
    })
  };
};
const prepareComponentToken = token => {
  const {
    controlHeightLG,
    controlHeight
  } = token;
  return {
    contentHeight: 400,
    dotSize: controlHeightLG / 2,
    dotSizeSM: controlHeightLG * 0.35,
    dotSizeLG: controlHeight
  };
};
// ============================== Export ==============================
/* harmony default export */ var spin_style = ((0,genStyleUtils/* genStyleHooks */.I$)('Spin', token => {
  const spinToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    spinDotDefault: token.colorTextDescription
  });
  return genSpinStyle(spinToken);
}, prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/antd/es/spin/usePercent.js

const AUTO_INTERVAL = 200;
const STEP_BUCKETS = [[30, 0.05], [70, 0.03], [96, 0.01]];
function usePercent(spinning, percent) {
  const [mockPercent, setMockPercent] = react.useState(0);
  const mockIntervalRef = react.useRef(null);
  const isAuto = percent === 'auto';
  react.useEffect(() => {
    if (isAuto && spinning) {
      setMockPercent(0);
      mockIntervalRef.current = setInterval(() => {
        setMockPercent(prev => {
          const restPTG = 100 - prev;
          for (let i = 0; i < STEP_BUCKETS.length; i += 1) {
            const [limit, stepPtg] = STEP_BUCKETS[i];
            if (prev <= limit) {
              return prev + restPTG * stepPtg;
            }
          }
          return prev;
        });
      }, AUTO_INTERVAL);
    }
    return () => {
      clearInterval(mockIntervalRef.current);
    };
  }, [isAuto, spinning]);
  return isAuto ? mockPercent : percent;
}
;// CONCATENATED MODULE: ./node_modules/antd/es/spin/index.js
"use client";

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};








const _SpinSizes = (/* unused pure expression or super */ null && (['small', 'default', 'large']));
// Render indicator
let defaultIndicator;
function shouldDelay(spinning, delay) {
  return !!spinning && !!delay && !Number.isNaN(Number(delay));
}
const Spin = props => {
  var _a;
  const {
      prefixCls: customizePrefixCls,
      spinning: customSpinning = true,
      delay = 0,
      className,
      rootClassName,
      size = 'default',
      tip,
      wrapperClassName,
      style,
      children,
      fullscreen = false,
      indicator,
      percent
    } = props,
    restProps = __rest(props, ["prefixCls", "spinning", "delay", "className", "rootClassName", "size", "tip", "wrapperClassName", "style", "children", "fullscreen", "indicator", "percent"]);
  const {
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle,
    indicator: contextIndicator
  } = (0,context/* useComponentConfig */.dj)('spin');
  const prefixCls = getPrefixCls('spin', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = spin_style(prefixCls);
  const [spinning, setSpinning] = react.useState(() => customSpinning && !shouldDelay(customSpinning, delay));
  const mergedPercent = usePercent(spinning, percent);
  react.useEffect(() => {
    if (customSpinning) {
      const showSpinning = (0,esm/* debounce */.D)(delay, () => {
        setSpinning(true);
      });
      showSpinning();
      return () => {
        var _a;
        (_a = showSpinning === null || showSpinning === void 0 ? void 0 : showSpinning.cancel) === null || _a === void 0 ? void 0 : _a.call(showSpinning);
      };
    }
    setSpinning(false);
  }, [delay, customSpinning]);
  const isNestedPattern = react.useMemo(() => typeof children !== 'undefined' && !fullscreen, [children, fullscreen]);
  if (false) {}
  const spinClassName = classnames_default()(prefixCls, contextClassName, {
    [`${prefixCls}-sm`]: size === 'small',
    [`${prefixCls}-lg`]: size === 'large',
    [`${prefixCls}-spinning`]: spinning,
    [`${prefixCls}-show-text`]: !!tip,
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, className, !fullscreen && rootClassName, hashId, cssVarCls);
  const containerClassName = classnames_default()(`${prefixCls}-container`, {
    [`${prefixCls}-blur`]: spinning
  });
  const mergedIndicator = (_a = indicator !== null && indicator !== void 0 ? indicator : contextIndicator) !== null && _a !== void 0 ? _a : defaultIndicator;
  const mergedStyle = Object.assign(Object.assign({}, contextStyle), style);
  const spinElement = /*#__PURE__*/react.createElement("div", Object.assign({}, restProps, {
    style: mergedStyle,
    className: spinClassName,
    "aria-live": "polite",
    "aria-busy": spinning
  }), /*#__PURE__*/react.createElement(Indicator, {
    prefixCls: prefixCls,
    indicator: mergedIndicator,
    percent: mergedPercent
  }), tip && (isNestedPattern || fullscreen) ? (/*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-text`
  }, tip)) : null);
  if (isNestedPattern) {
    return wrapCSSVar(/*#__PURE__*/react.createElement("div", Object.assign({}, restProps, {
      className: classnames_default()(`${prefixCls}-nested-loading`, wrapperClassName, hashId, cssVarCls)
    }), spinning && /*#__PURE__*/react.createElement("div", {
      key: "loading"
    }, spinElement), /*#__PURE__*/react.createElement("div", {
      className: containerClassName,
      key: "container"
    }, children)));
  }
  if (fullscreen) {
    return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
      className: classnames_default()(`${prefixCls}-fullscreen`, {
        [`${prefixCls}-fullscreen-show`]: spinning
      }, rootClassName, hashId, cssVarCls)
    }, spinElement));
  }
  return wrapCSSVar(spinElement);
};
Spin.setDefaultIndicator = indicator => {
  defaultIndicator = indicator;
};
if (false) {}
/* harmony default export */ var spin = (Spin);

/***/ }),

/***/ 99978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ genCompactItemStyle; }
/* harmony export */ });
// handle border collapse
function compactItemBorder(token, parentCls, options, prefixCls) {
  const {
    focusElCls,
    focus,
    borderElCls
  } = options;
  const childCombinator = borderElCls ? '> *' : '';
  const hoverEffects = ['hover', focus ? 'focus' : null, 'active'].filter(Boolean).map(n => `&:${n} ${childCombinator}`).join(',');
  return {
    [`&-item:not(${parentCls}-last-item)`]: {
      marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal()
    },
    [`&-item:not(${prefixCls}-status-success)`]: {
      zIndex: 2
    },
    '&-item': Object.assign(Object.assign({
      [hoverEffects]: {
        zIndex: 3
      }
    }, focusElCls ? {
      [`&${focusElCls}`]: {
        zIndex: 3
      }
    } : {}), {
      [`&[disabled] ${childCombinator}`]: {
        zIndex: 0
      }
    })
  };
}
// handle border-radius
function compactItemBorderRadius(prefixCls, parentCls, options) {
  const {
    borderElCls
  } = options;
  const childCombinator = borderElCls ? `> ${borderElCls}` : '';
  return {
    [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
      borderRadius: 0
    },
    [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
      [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
      [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function genCompactItemStyle(token, options = {
  focus: true
}) {
  const {
    componentCls
  } = token;
  const compactCls = `${componentCls}-compact`;
  return {
    [compactCls]: Object.assign(Object.assign({}, compactItemBorder(token, compactCls, options, componentCls)), compactItemBorderRadius(componentCls, compactCls, options))
  };
}

/***/ }),

/***/ 31875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JT": function() { return /* binding */ genIconStyle; },
/* harmony export */   "Lx": function() { return /* binding */ genLinkStyle; },
/* harmony export */   "Nd": function() { return /* binding */ operationUnit; },
/* harmony export */   "Qy": function() { return /* binding */ genFocusStyle; },
/* harmony export */   "Ro": function() { return /* binding */ resetIcon; },
/* harmony export */   "Wf": function() { return /* binding */ resetComponent; },
/* harmony export */   "dF": function() { return /* binding */ clearFix; },
/* harmony export */   "du": function() { return /* binding */ genCommonStyle; },
/* harmony export */   "oN": function() { return /* binding */ genFocusOutline; },
/* harmony export */   "vS": function() { return /* binding */ textEllipsis; }
/* harmony export */ });
/* harmony import */ var _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68946);
"use client";


const textEllipsis = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis'
};
const resetComponent = (token, needInheritFontFamily = false) => ({
  boxSizing: 'border-box',
  margin: 0,
  padding: 0,
  color: token.colorText,
  fontSize: token.fontSize,
  // font-variant: @font-variant-base;
  lineHeight: token.lineHeight,
  listStyle: 'none',
  // font-feature-settings: @font-feature-settings-base;
  fontFamily: needInheritFontFamily ? 'inherit' : token.fontFamily
});
const resetIcon = () => ({
  display: 'inline-flex',
  alignItems: 'center',
  color: 'inherit',
  fontStyle: 'normal',
  lineHeight: 0,
  textAlign: 'center',
  textTransform: 'none',
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: '-0.125em',
  textRendering: 'optimizeLegibility',
  '-webkit-font-smoothing': 'antialiased',
  '-moz-osx-font-smoothing': 'grayscale',
  '> *': {
    lineHeight: 1
  },
  svg: {
    display: 'inline-block'
  }
});
const clearFix = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  '&::before': {
    display: 'table',
    content: '""'
  },
  '&::after': {
    // https://github.com/ant-design/ant-design/issues/21864
    display: 'table',
    clear: 'both',
    content: '""'
  }
});
const genLinkStyle = token => ({
  a: {
    color: token.colorLink,
    textDecoration: token.linkDecoration,
    backgroundColor: 'transparent',
    // remove the gray background on active links in IE 10.
    outline: 'none',
    cursor: 'pointer',
    transition: `color ${token.motionDurationSlow}`,
    '-webkit-text-decoration-skip': 'objects',
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    '&:hover': {
      color: token.colorLinkHover
    },
    '&:active': {
      color: token.colorLinkActive
    },
    '&:active, &:hover': {
      textDecoration: token.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    '&:focus': {
      textDecoration: token.linkFocusDecoration,
      outline: 0
    },
    '&[disabled]': {
      color: token.colorTextDisabled,
      cursor: 'not-allowed'
    }
  }
});
const genCommonStyle = (token, componentPrefixCls, rootCls, resetFont) => {
  const prefixSelector = `[class^="${componentPrefixCls}"], [class*=" ${componentPrefixCls}"]`;
  const rootPrefixSelector = rootCls ? `.${rootCls}` : prefixSelector;
  const resetStyle = {
    boxSizing: 'border-box',
    '&::before, &::after': {
      boxSizing: 'border-box'
    }
  };
  let resetFontStyle = {};
  if (resetFont !== false) {
    resetFontStyle = {
      fontFamily: token.fontFamily,
      fontSize: token.fontSize
    };
  }
  return {
    [rootPrefixSelector]: Object.assign(Object.assign(Object.assign({}, resetFontStyle), resetStyle), {
      [prefixSelector]: resetStyle
    })
  };
};
const genFocusOutline = (token, offset) => ({
  outline: `${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`,
  outlineOffset: offset !== null && offset !== void 0 ? offset : 1,
  transition: 'outline-offset 0s, outline 0s'
});
const genFocusStyle = (token, offset) => ({
  '&:focus-visible': genFocusOutline(token, offset)
});
const genIconStyle = iconPrefixCls => ({
  [`.${iconPrefixCls}`]: Object.assign(Object.assign({}, resetIcon()), {
    [`.${iconPrefixCls} .${iconPrefixCls}-icon`]: {
      display: 'block'
    }
  })
});
const operationUnit = token => Object.assign(Object.assign({
  // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
  // And Typography use this to generate link style which should not do this.
  color: token.colorLink,
  textDecoration: token.linkDecoration,
  outline: 'none',
  cursor: 'pointer',
  transition: `all ${token.motionDurationSlow}`,
  border: 0,
  padding: 0,
  background: 'none',
  userSelect: 'none'
}, genFocusStyle(token)), {
  '&:focus, &:hover': {
    color: token.colorLinkHover
  },
  '&:active': {
    color: token.colorLinkActive
  }
});

/***/ }),

/***/ 14470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J$": function() { return /* binding */ initFadeMotion; }
/* harmony export */ });
/* unused harmony exports fadeIn, fadeOut */
/* harmony import */ var _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68946);
/* harmony import */ var _motion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21743);


const fadeIn = new _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .Keyframes */ .E4('antFadeIn', {
  '0%': {
    opacity: 0
  },
  '100%': {
    opacity: 1
  }
});
const fadeOut = new _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .Keyframes */ .E4('antFadeOut', {
  '0%': {
    opacity: 1
  },
  '100%': {
    opacity: 0
  }
});
const initFadeMotion = (token, sameLevel = false) => {
  const {
    antCls
  } = token;
  const motionCls = `${antCls}-fade`;
  const sameLevelPrefix = sameLevel ? '&' : '';
  return [(0,_motion__WEBPACK_IMPORTED_MODULE_1__/* .initMotion */ .R)(motionCls, fadeIn, fadeOut, token.motionDurationMid, sameLevel), {
    [`
        ${sameLevelPrefix}${motionCls}-enter,
        ${sameLevelPrefix}${motionCls}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: 'linear'
    },
    [`${sameLevelPrefix}${motionCls}-leave`]: {
      animationTimingFunction: 'linear'
    }
  }];
};

/***/ }),

/***/ 21743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ initMotion; }
/* harmony export */ });
const initMotionCommon = duration => ({
  animationDuration: duration,
  animationFillMode: 'both'
});
// FIXME: origin less code seems same as initMotionCommon. Maybe we can safe remove
const initMotionCommonLeave = duration => ({
  animationDuration: duration,
  animationFillMode: 'both'
});
const initMotion = (motionCls, inKeyframes, outKeyframes, duration, sameLevel = false) => {
  const sameLevelPrefix = sameLevel ? '&' : '';
  return {
    [`
      ${sameLevelPrefix}${motionCls}-enter,
      ${sameLevelPrefix}${motionCls}-appear
    `]: Object.assign(Object.assign({}, initMotionCommon(duration)), {
      animationPlayState: 'paused'
    }),
    [`${sameLevelPrefix}${motionCls}-leave`]: Object.assign(Object.assign({}, initMotionCommonLeave(duration)), {
      animationPlayState: 'paused'
    }),
    [`
      ${sameLevelPrefix}${motionCls}-enter${motionCls}-enter-active,
      ${sameLevelPrefix}${motionCls}-appear${motionCls}-appear-active
    `]: {
      animationName: inKeyframes,
      animationPlayState: 'running'
    },
    [`${sameLevelPrefix}${motionCls}-leave${motionCls}-leave-active`]: {
      animationName: outKeyframes,
      animationPlayState: 'running',
      pointerEvents: 'none'
    }
  };
};

/***/ }),

/***/ 63897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_y": function() { return /* binding */ initZoomMotion; }
/* harmony export */ });
/* unused harmony exports zoomIn, zoomOut, zoomBigIn, zoomBigOut, zoomUpIn, zoomUpOut, zoomLeftIn, zoomLeftOut, zoomRightIn, zoomRightOut, zoomDownIn, zoomDownOut */
/* harmony import */ var _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68946);
/* harmony import */ var _motion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21743);


const zoomIn = new _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .Keyframes */ .E4('antZoomIn', {
  '0%': {
    transform: 'scale(0.2)',
    opacity: 0
  },
  '100%': {
    transform: 'scale(1)',
    opacity: 1
  }
});
const zoomOut = new _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .Keyframes */ .E4('antZoomOut', {
  '0%': {
    transform: 'scale(1)'
  },
  '100%': {
    transform: 'scale(0.2)',
    opacity: 0
  }
});
const zoomBigIn = new _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .Keyframes */ .E4('antZoomBigIn', {
  '0%': {
    transform: 'scale(0.8)',
    opacity: 0
  },
  '100%': {
    transform: 'scale(1)',
    opacity: 1
  }
});
const zoomBigOut = new _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .Keyframes */ .E4('antZoomBigOut', {
  '0%': {
    transform: 'scale(1)'
  },
  '100%': {
    transform: 'scale(0.8)',
    opacity: 0
  }
});
const zoomUpIn = new _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .Keyframes */ .E4('antZoomUpIn', {
  '0%': {
    transform: 'scale(0.8)',
    transformOrigin: '50% 0%',
    opacity: 0
  },
  '100%': {
    transform: 'scale(1)',
    transformOrigin: '50% 0%'
  }
});
const zoomUpOut = new _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .Keyframes */ .E4('antZoomUpOut', {
  '0%': {
    transform: 'scale(1)',
    transformOrigin: '50% 0%'
  },
  '100%': {
    transform: 'scale(0.8)',
    transformOrigin: '50% 0%',
    opacity: 0
  }
});
const zoomLeftIn = new _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .Keyframes */ .E4('antZoomLeftIn', {
  '0%': {
    transform: 'scale(0.8)',
    transformOrigin: '0% 50%',
    opacity: 0
  },
  '100%': {
    transform: 'scale(1)',
    transformOrigin: '0% 50%'
  }
});
const zoomLeftOut = new _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .Keyframes */ .E4('antZoomLeftOut', {
  '0%': {
    transform: 'scale(1)',
    transformOrigin: '0% 50%'
  },
  '100%': {
    transform: 'scale(0.8)',
    transformOrigin: '0% 50%',
    opacity: 0
  }
});
const zoomRightIn = new _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .Keyframes */ .E4('antZoomRightIn', {
  '0%': {
    transform: 'scale(0.8)',
    transformOrigin: '100% 50%',
    opacity: 0
  },
  '100%': {
    transform: 'scale(1)',
    transformOrigin: '100% 50%'
  }
});
const zoomRightOut = new _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .Keyframes */ .E4('antZoomRightOut', {
  '0%': {
    transform: 'scale(1)',
    transformOrigin: '100% 50%'
  },
  '100%': {
    transform: 'scale(0.8)',
    transformOrigin: '100% 50%',
    opacity: 0
  }
});
const zoomDownIn = new _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .Keyframes */ .E4('antZoomDownIn', {
  '0%': {
    transform: 'scale(0.8)',
    transformOrigin: '50% 100%',
    opacity: 0
  },
  '100%': {
    transform: 'scale(1)',
    transformOrigin: '50% 100%'
  }
});
const zoomDownOut = new _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .Keyframes */ .E4('antZoomDownOut', {
  '0%': {
    transform: 'scale(1)',
    transformOrigin: '50% 100%'
  },
  '100%': {
    transform: 'scale(0.8)',
    transformOrigin: '50% 100%',
    opacity: 0
  }
});
const zoomMotion = {
  zoom: {
    inKeyframes: zoomIn,
    outKeyframes: zoomOut
  },
  'zoom-big': {
    inKeyframes: zoomBigIn,
    outKeyframes: zoomBigOut
  },
  'zoom-big-fast': {
    inKeyframes: zoomBigIn,
    outKeyframes: zoomBigOut
  },
  'zoom-left': {
    inKeyframes: zoomLeftIn,
    outKeyframes: zoomLeftOut
  },
  'zoom-right': {
    inKeyframes: zoomRightIn,
    outKeyframes: zoomRightOut
  },
  'zoom-up': {
    inKeyframes: zoomUpIn,
    outKeyframes: zoomUpOut
  },
  'zoom-down': {
    inKeyframes: zoomDownIn,
    outKeyframes: zoomDownOut
  }
};
const initZoomMotion = (token, motionName) => {
  const {
    antCls
  } = token;
  const motionCls = `${antCls}-${motionName}`;
  const {
    inKeyframes,
    outKeyframes
  } = zoomMotion[motionName];
  return [(0,_motion__WEBPACK_IMPORTED_MODULE_1__/* .initMotion */ .R)(motionCls, inKeyframes, outKeyframes, motionName === 'zoom-big-fast' ? token.motionDurationFast : token.motionDurationMid), {
    [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
      transform: 'scale(0)',
      opacity: 0,
      animationTimingFunction: token.motionEaseOutCirc,
      '&-prepare': {
        transform: 'none'
      }
    },
    [`${motionCls}-leave`]: {
      animationTimingFunction: token.motionEaseInOutCirc
    }
  }];
};

/***/ }),

/***/ 33294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ getArrowStyle; },
/* harmony export */   "qN": function() { return /* binding */ MAX_VERTICAL_CONTENT_RADIUS; },
/* harmony export */   "wZ": function() { return /* binding */ getArrowOffsetToken; }
/* harmony export */ });
/* harmony import */ var _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68946);
/* harmony import */ var _roundedArrow__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20829);


const MAX_VERTICAL_CONTENT_RADIUS = 8;
function getArrowOffsetToken(options) {
  const {
    contentRadius,
    limitVerticalRadius
  } = options;
  const arrowOffset = contentRadius > 12 ? contentRadius + 2 : 12;
  const arrowOffsetVertical = limitVerticalRadius ? MAX_VERTICAL_CONTENT_RADIUS : arrowOffset;
  return {
    arrowOffsetHorizontal: arrowOffset,
    arrowOffsetVertical
  };
}
function isInject(valid, code) {
  if (!valid) {
    return {};
  }
  return code;
}
function getArrowStyle(token, colorBg, options) {
  const {
    componentCls,
    boxShadowPopoverArrow,
    arrowOffsetVertical,
    arrowOffsetHorizontal
  } = token;
  const {
    arrowDistance = 0,
    arrowPlacement = {
      left: true,
      right: true,
      top: true,
      bottom: true
    }
  } = options || {};
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      [`${componentCls}-arrow`]: [Object.assign(Object.assign({
        position: 'absolute',
        zIndex: 1,
        display: 'block'
      }, (0,_roundedArrow__WEBPACK_IMPORTED_MODULE_1__/* .genRoundedArrow */ .W)(token, colorBg, boxShadowPopoverArrow)), {
        '&:before': {
          background: colorBg
        }
      })]
    }, isInject(!!arrowPlacement.top, {
      [[`&-placement-top > ${componentCls}-arrow`, `&-placement-topLeft > ${componentCls}-arrow`, `&-placement-topRight > ${componentCls}-arrow`].join(',')]: {
        bottom: arrowDistance,
        transform: 'translateY(100%) rotate(180deg)'
      },
      [`&-placement-top > ${componentCls}-arrow`]: {
        left: {
          _skip_check_: true,
          value: '50%'
        },
        transform: 'translateX(-50%) translateY(100%) rotate(180deg)'
      },
      '&-placement-topLeft': {
        '--arrow-offset-horizontal': arrowOffsetHorizontal,
        [`> ${componentCls}-arrow`]: {
          left: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
          }
        }
      },
      '&-placement-topRight': {
        '--arrow-offset-horizontal': `calc(100% - ${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(arrowOffsetHorizontal)})`,
        [`> ${componentCls}-arrow`]: {
          right: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
          }
        }
      }
    })), isInject(!!arrowPlacement.bottom, {
      [[`&-placement-bottom > ${componentCls}-arrow`, `&-placement-bottomLeft > ${componentCls}-arrow`, `&-placement-bottomRight > ${componentCls}-arrow`].join(',')]: {
        top: arrowDistance,
        transform: `translateY(-100%)`
      },
      [`&-placement-bottom > ${componentCls}-arrow`]: {
        left: {
          _skip_check_: true,
          value: '50%'
        },
        transform: `translateX(-50%) translateY(-100%)`
      },
      '&-placement-bottomLeft': {
        '--arrow-offset-horizontal': arrowOffsetHorizontal,
        [`> ${componentCls}-arrow`]: {
          left: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
          }
        }
      },
      '&-placement-bottomRight': {
        '--arrow-offset-horizontal': `calc(100% - ${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(arrowOffsetHorizontal)})`,
        [`> ${componentCls}-arrow`]: {
          right: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
          }
        }
      }
    })), isInject(!!arrowPlacement.left, {
      [[`&-placement-left > ${componentCls}-arrow`, `&-placement-leftTop > ${componentCls}-arrow`, `&-placement-leftBottom > ${componentCls}-arrow`].join(',')]: {
        right: {
          _skip_check_: true,
          value: arrowDistance
        },
        transform: 'translateX(100%) rotate(90deg)'
      },
      [`&-placement-left > ${componentCls}-arrow`]: {
        top: {
          _skip_check_: true,
          value: '50%'
        },
        transform: 'translateY(-50%) translateX(100%) rotate(90deg)'
      },
      [`&-placement-leftTop > ${componentCls}-arrow`]: {
        top: arrowOffsetVertical
      },
      [`&-placement-leftBottom > ${componentCls}-arrow`]: {
        bottom: arrowOffsetVertical
      }
    })), isInject(!!arrowPlacement.right, {
      [[`&-placement-right > ${componentCls}-arrow`, `&-placement-rightTop > ${componentCls}-arrow`, `&-placement-rightBottom > ${componentCls}-arrow`].join(',')]: {
        left: {
          _skip_check_: true,
          value: arrowDistance
        },
        transform: 'translateX(-100%) rotate(-90deg)'
      },
      [`&-placement-right > ${componentCls}-arrow`]: {
        top: {
          _skip_check_: true,
          value: '50%'
        },
        transform: 'translateY(-50%) translateX(-100%) rotate(-90deg)'
      },
      [`&-placement-rightTop > ${componentCls}-arrow`]: {
        top: arrowOffsetVertical
      },
      [`&-placement-rightBottom > ${componentCls}-arrow`]: {
        bottom: arrowOffsetVertical
      }
    }))
  };
}

/***/ }),

/***/ 20829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ genRoundedArrow; },
/* harmony export */   "w": function() { return /* binding */ getArrowToken; }
/* harmony export */ });
/* harmony import */ var _ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68946);

function getArrowToken(token) {
  const {
    sizePopupArrow,
    borderRadiusXS,
    borderRadiusOuter
  } = token;
  const unitWidth = sizePopupArrow / 2;
  const ax = 0;
  const ay = unitWidth;
  const bx = borderRadiusOuter * 1 / Math.sqrt(2);
  const by = unitWidth - borderRadiusOuter * (1 - 1 / Math.sqrt(2));
  const cx = unitWidth - borderRadiusXS * (1 / Math.sqrt(2));
  const cy = borderRadiusOuter * (Math.sqrt(2) - 1) + borderRadiusXS * (1 / Math.sqrt(2));
  const dx = 2 * unitWidth - cx;
  const dy = cy;
  const ex = 2 * unitWidth - bx;
  const ey = by;
  const fx = 2 * unitWidth - ax;
  const fy = ay;
  const shadowWidth = unitWidth * Math.sqrt(2) + borderRadiusOuter * (Math.sqrt(2) - 2);
  const polygonOffset = borderRadiusOuter * (Math.sqrt(2) - 1);
  const arrowPolygon = `polygon(${polygonOffset}px 100%, 50% ${polygonOffset}px, ${2 * unitWidth - polygonOffset}px 100%, ${polygonOffset}px 100%)`;
  const arrowPath = `path('M ${ax} ${ay} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${bx} ${by} L ${cx} ${cy} A ${borderRadiusXS} ${borderRadiusXS} 0 0 1 ${dx} ${dy} L ${ex} ${ey} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${fx} ${fy} Z')`;
  return {
    arrowShadowWidth: shadowWidth,
    arrowPath,
    arrowPolygon
  };
}
const genRoundedArrow = (token, bgColor, boxShadow) => {
  const {
    sizePopupArrow,
    arrowPolygon,
    arrowPath,
    arrowShadowWidth,
    borderRadiusXS,
    calc
  } = token;
  return {
    pointerEvents: 'none',
    width: sizePopupArrow,
    height: sizePopupArrow,
    overflow: 'hidden',
    '&::before': {
      position: 'absolute',
      bottom: 0,
      insetInlineStart: 0,
      width: sizePopupArrow,
      height: calc(sizePopupArrow).div(2).equal(),
      background: bgColor,
      clipPath: {
        _multi_value_: true,
        value: [arrowPolygon, arrowPath]
      },
      content: '""'
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      width: arrowShadowWidth,
      height: arrowShadowWidth,
      bottom: 0,
      insetInline: 0,
      margin: 'auto',
      borderRadius: {
        _skip_check_: true,
        value: `0 0 ${(0,_ant_design_cssinjs__WEBPACK_IMPORTED_MODULE_0__/* .unit */ .bf)(borderRadiusXS)} 0`
      },
      transform: 'translateY(50%) rotate(-135deg)',
      boxShadow,
      zIndex: 0,
      background: 'transparent'
    }
  };
};

/***/ }),

/***/ 93897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mj": function() { return /* binding */ DesignTokenContext; },
/* harmony export */   "u_": function() { return /* binding */ defaultConfig; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var _themes_seed__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77177);



// ================================ Context =================================
// To ensure snapshot stable. We disable hashed in test env.
const defaultConfig = {
  token: _themes_seed__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
  override: {
    override: _themes_seed__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
  },
  hashed: true
};
const DesignTokenContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(defaultConfig);

/***/ }),

/***/ 26822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ PresetColors; }
/* harmony export */ });
const PresetColors = ['blue', 'purple', 'cyan', 'green', 'magenta', 'pink', 'red', 'orange', 'yellow', 'volcano', 'geekblue', 'lime', 'gold'];

/***/ }),

/***/ 17869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ theme; }
});

// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs/es/index.js + 37 modules
var es = __webpack_require__(68946);
// EXTERNAL MODULE: ./node_modules/@ant-design/colors/es/index.js + 2 modules
var colors_es = __webpack_require__(61835);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/themes/seed.js
var seed = __webpack_require__(77177);
// EXTERNAL MODULE: ./node_modules/@ant-design/fast-color/es/index.js + 1 modules
var fast_color_es = __webpack_require__(99620);
;// CONCATENATED MODULE: ./node_modules/antd/es/theme/themes/shared/genColorMapToken.js

function genColorMapToken(seed, {
  generateColorPalettes,
  generateNeutralColorPalettes
}) {
  const {
    colorSuccess: colorSuccessBase,
    colorWarning: colorWarningBase,
    colorError: colorErrorBase,
    colorInfo: colorInfoBase,
    colorPrimary: colorPrimaryBase,
    colorBgBase,
    colorTextBase
  } = seed;
  const primaryColors = generateColorPalettes(colorPrimaryBase);
  const successColors = generateColorPalettes(colorSuccessBase);
  const warningColors = generateColorPalettes(colorWarningBase);
  const errorColors = generateColorPalettes(colorErrorBase);
  const infoColors = generateColorPalettes(colorInfoBase);
  const neutralColors = generateNeutralColorPalettes(colorBgBase, colorTextBase);
  // Color Link
  const colorLink = seed.colorLink || seed.colorInfo;
  const linkColors = generateColorPalettes(colorLink);
  const colorErrorBgFilledHover = new fast_color_es/* FastColor */.t(errorColors[1]).mix(new fast_color_es/* FastColor */.t(errorColors[3]), 50).toHexString();
  return Object.assign(Object.assign({}, neutralColors), {
    colorPrimaryBg: primaryColors[1],
    colorPrimaryBgHover: primaryColors[2],
    colorPrimaryBorder: primaryColors[3],
    colorPrimaryBorderHover: primaryColors[4],
    colorPrimaryHover: primaryColors[5],
    colorPrimary: primaryColors[6],
    colorPrimaryActive: primaryColors[7],
    colorPrimaryTextHover: primaryColors[8],
    colorPrimaryText: primaryColors[9],
    colorPrimaryTextActive: primaryColors[10],
    colorSuccessBg: successColors[1],
    colorSuccessBgHover: successColors[2],
    colorSuccessBorder: successColors[3],
    colorSuccessBorderHover: successColors[4],
    colorSuccessHover: successColors[4],
    colorSuccess: successColors[6],
    colorSuccessActive: successColors[7],
    colorSuccessTextHover: successColors[8],
    colorSuccessText: successColors[9],
    colorSuccessTextActive: successColors[10],
    colorErrorBg: errorColors[1],
    colorErrorBgHover: errorColors[2],
    colorErrorBgFilledHover,
    colorErrorBgActive: errorColors[3],
    colorErrorBorder: errorColors[3],
    colorErrorBorderHover: errorColors[4],
    colorErrorHover: errorColors[5],
    colorError: errorColors[6],
    colorErrorActive: errorColors[7],
    colorErrorTextHover: errorColors[8],
    colorErrorText: errorColors[9],
    colorErrorTextActive: errorColors[10],
    colorWarningBg: warningColors[1],
    colorWarningBgHover: warningColors[2],
    colorWarningBorder: warningColors[3],
    colorWarningBorderHover: warningColors[4],
    colorWarningHover: warningColors[4],
    colorWarning: warningColors[6],
    colorWarningActive: warningColors[7],
    colorWarningTextHover: warningColors[8],
    colorWarningText: warningColors[9],
    colorWarningTextActive: warningColors[10],
    colorInfoBg: infoColors[1],
    colorInfoBgHover: infoColors[2],
    colorInfoBorder: infoColors[3],
    colorInfoBorderHover: infoColors[4],
    colorInfoHover: infoColors[4],
    colorInfo: infoColors[6],
    colorInfoActive: infoColors[7],
    colorInfoTextHover: infoColors[8],
    colorInfoText: infoColors[9],
    colorInfoTextActive: infoColors[10],
    colorLinkHover: linkColors[4],
    colorLink: linkColors[6],
    colorLinkActive: linkColors[7],
    colorBgMask: new fast_color_es/* FastColor */.t('#000').setA(0.45).toRgbString(),
    colorWhite: '#fff'
  });
}
;// CONCATENATED MODULE: ./node_modules/antd/es/theme/themes/shared/genRadius.js
const genRadius = radiusBase => {
  let radiusLG = radiusBase;
  let radiusSM = radiusBase;
  let radiusXS = radiusBase;
  let radiusOuter = radiusBase;
  // radiusLG
  if (radiusBase < 6 && radiusBase >= 5) {
    radiusLG = radiusBase + 1;
  } else if (radiusBase < 16 && radiusBase >= 6) {
    radiusLG = radiusBase + 2;
  } else if (radiusBase >= 16) {
    radiusLG = 16;
  }
  // radiusSM
  if (radiusBase < 7 && radiusBase >= 5) {
    radiusSM = 4;
  } else if (radiusBase < 8 && radiusBase >= 7) {
    radiusSM = 5;
  } else if (radiusBase < 14 && radiusBase >= 8) {
    radiusSM = 6;
  } else if (radiusBase < 16 && radiusBase >= 14) {
    radiusSM = 7;
  } else if (radiusBase >= 16) {
    radiusSM = 8;
  }
  // radiusXS
  if (radiusBase < 6 && radiusBase >= 2) {
    radiusXS = 1;
  } else if (radiusBase >= 6) {
    radiusXS = 2;
  }
  // radiusOuter
  if (radiusBase > 4 && radiusBase < 8) {
    radiusOuter = 4;
  } else if (radiusBase >= 8) {
    radiusOuter = 6;
  }
  return {
    borderRadius: radiusBase,
    borderRadiusXS: radiusXS,
    borderRadiusSM: radiusSM,
    borderRadiusLG: radiusLG,
    borderRadiusOuter: radiusOuter
  };
};
/* harmony default export */ var shared_genRadius = (genRadius);
;// CONCATENATED MODULE: ./node_modules/antd/es/theme/themes/shared/genCommonMapToken.js

function genCommonMapToken(token) {
  const {
    motionUnit,
    motionBase,
    borderRadius,
    lineWidth
  } = token;
  return Object.assign({
    // motion
    motionDurationFast: `${(motionBase + motionUnit).toFixed(1)}s`,
    motionDurationMid: `${(motionBase + motionUnit * 2).toFixed(1)}s`,
    motionDurationSlow: `${(motionBase + motionUnit * 3).toFixed(1)}s`,
    // line
    lineWidthBold: lineWidth + 1
  }, shared_genRadius(borderRadius));
}
;// CONCATENATED MODULE: ./node_modules/antd/es/theme/themes/shared/genControlHeight.js
const genControlHeight = token => {
  const {
    controlHeight
  } = token;
  return {
    controlHeightSM: controlHeight * 0.75,
    controlHeightXS: controlHeight * 0.5,
    controlHeightLG: controlHeight * 1.25
  };
};
/* harmony default export */ var shared_genControlHeight = (genControlHeight);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/themes/shared/genFontSizes.js
var genFontSizes = __webpack_require__(85362);
;// CONCATENATED MODULE: ./node_modules/antd/es/theme/themes/shared/genFontMapToken.js

const genFontMapToken = fontSize => {
  const fontSizePairs = (0,genFontSizes/* default */.Z)(fontSize);
  const fontSizes = fontSizePairs.map(pair => pair.size);
  const lineHeights = fontSizePairs.map(pair => pair.lineHeight);
  const fontSizeMD = fontSizes[1];
  const fontSizeSM = fontSizes[0];
  const fontSizeLG = fontSizes[2];
  const lineHeight = lineHeights[1];
  const lineHeightSM = lineHeights[0];
  const lineHeightLG = lineHeights[2];
  return {
    fontSizeSM,
    fontSize: fontSizeMD,
    fontSizeLG,
    fontSizeXL: fontSizes[3],
    fontSizeHeading1: fontSizes[6],
    fontSizeHeading2: fontSizes[5],
    fontSizeHeading3: fontSizes[4],
    fontSizeHeading4: fontSizes[3],
    fontSizeHeading5: fontSizes[2],
    lineHeight,
    lineHeightLG,
    lineHeightSM,
    fontHeight: Math.round(lineHeight * fontSizeMD),
    fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
    fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
    lineHeightHeading1: lineHeights[6],
    lineHeightHeading2: lineHeights[5],
    lineHeightHeading3: lineHeights[4],
    lineHeightHeading4: lineHeights[3],
    lineHeightHeading5: lineHeights[2]
  };
};
/* harmony default export */ var shared_genFontMapToken = (genFontMapToken);
;// CONCATENATED MODULE: ./node_modules/antd/es/theme/themes/shared/genSizeMapToken.js
function genSizeMapToken(token) {
  const {
    sizeUnit,
    sizeStep
  } = token;
  return {
    sizeXXL: sizeUnit * (sizeStep + 8),
    // 48
    sizeXL: sizeUnit * (sizeStep + 4),
    // 32
    sizeLG: sizeUnit * (sizeStep + 2),
    // 24
    sizeMD: sizeUnit * (sizeStep + 1),
    // 20
    sizeMS: sizeUnit * sizeStep,
    // 16
    size: sizeUnit * sizeStep,
    // 16
    sizeSM: sizeUnit * (sizeStep - 1),
    // 12
    sizeXS: sizeUnit * (sizeStep - 2),
    // 8
    sizeXXS: sizeUnit * (sizeStep - 3) // 4
  };
}
;// CONCATENATED MODULE: ./node_modules/antd/es/theme/themes/default/colorAlgorithm.js

const getAlphaColor = (baseColor, alpha) => new fast_color_es/* FastColor */.t(baseColor).setA(alpha).toRgbString();
const getSolidColor = (baseColor, brightness) => {
  const instance = new fast_color_es/* FastColor */.t(baseColor);
  return instance.darken(brightness).toHexString();
};
;// CONCATENATED MODULE: ./node_modules/antd/es/theme/themes/default/colors.js


const generateColorPalettes = baseColor => {
  const colors = (0,colors_es/* generate */.R_)(baseColor);
  return {
    1: colors[0],
    2: colors[1],
    3: colors[2],
    4: colors[3],
    5: colors[4],
    6: colors[5],
    7: colors[6],
    8: colors[4],
    9: colors[5],
    10: colors[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
};
const generateNeutralColorPalettes = (bgBaseColor, textBaseColor) => {
  const colorBgBase = bgBaseColor || '#fff';
  const colorTextBase = textBaseColor || '#000';
  return {
    colorBgBase,
    colorTextBase,
    colorText: getAlphaColor(colorTextBase, 0.88),
    colorTextSecondary: getAlphaColor(colorTextBase, 0.65),
    colorTextTertiary: getAlphaColor(colorTextBase, 0.45),
    colorTextQuaternary: getAlphaColor(colorTextBase, 0.25),
    colorFill: getAlphaColor(colorTextBase, 0.15),
    colorFillSecondary: getAlphaColor(colorTextBase, 0.06),
    colorFillTertiary: getAlphaColor(colorTextBase, 0.04),
    colorFillQuaternary: getAlphaColor(colorTextBase, 0.02),
    colorBgSolid: getAlphaColor(colorTextBase, 1),
    colorBgSolidHover: getAlphaColor(colorTextBase, 0.75),
    colorBgSolidActive: getAlphaColor(colorTextBase, 0.95),
    colorBgLayout: getSolidColor(colorBgBase, 4),
    colorBgContainer: getSolidColor(colorBgBase, 0),
    colorBgElevated: getSolidColor(colorBgBase, 0),
    colorBgSpotlight: getAlphaColor(colorTextBase, 0.85),
    colorBgBlur: 'transparent',
    colorBorder: getSolidColor(colorBgBase, 15),
    colorBorderSecondary: getSolidColor(colorBgBase, 6)
  };
};
;// CONCATENATED MODULE: ./node_modules/antd/es/theme/themes/default/index.js








function derivative(token) {
  // pink is deprecated name of magenta, keep this for backwards compatibility
  colors_es/* presetPrimaryColors.pink */.ez.pink = colors_es/* presetPrimaryColors.magenta */.ez.magenta;
  colors_es/* presetPalettes.pink */.Ti.pink = colors_es/* presetPalettes.magenta */.Ti.magenta;
  const colorPalettes = Object.keys(seed/* defaultPresetColors */.M).map(colorKey => {
    const colors = token[colorKey] === colors_es/* presetPrimaryColors */.ez[colorKey] ? colors_es/* presetPalettes */.Ti[colorKey] : (0,colors_es/* generate */.R_)(token[colorKey]);
    return Array.from({
      length: 10
    }, () => 1).reduce((prev, _, i) => {
      prev[`${colorKey}-${i + 1}`] = colors[i];
      prev[`${colorKey}${i + 1}`] = colors[i];
      return prev;
    }, {});
  }).reduce((prev, cur) => {
    prev = Object.assign(Object.assign({}, prev), cur);
    return prev;
  }, {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, token), colorPalettes), genColorMapToken(token, {
    generateColorPalettes: generateColorPalettes,
    generateNeutralColorPalettes: generateNeutralColorPalettes
  })), shared_genFontMapToken(token.fontSize)), genSizeMapToken(token)), shared_genControlHeight(token)), genCommonMapToken(token));
}
;// CONCATENATED MODULE: ./node_modules/antd/es/theme/themes/default/theme.js


const defaultTheme = (0,es/* createTheme */.jG)(derivative);
/* harmony default export */ var theme = (defaultTheme);

/***/ }),

/***/ 77177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ defaultPresetColors; }
/* harmony export */ });
const defaultPresetColors = {
  blue: '#1677FF',
  purple: '#722ED1',
  cyan: '#13C2C2',
  green: '#52C41A',
  magenta: '#EB2F96',
  /**
   * @deprecated Use magenta instead
   */
  pink: '#EB2F96',
  red: '#F5222D',
  orange: '#FA8C16',
  yellow: '#FADB14',
  volcano: '#FA541C',
  geekblue: '#2F54EB',
  gold: '#FAAD14',
  lime: '#A0D911'
};
const seedToken = Object.assign(Object.assign({}, defaultPresetColors), {
  // Color
  colorPrimary: '#1677ff',
  colorSuccess: '#52c41a',
  colorWarning: '#faad14',
  colorError: '#ff4d4f',
  colorInfo: '#1677ff',
  colorLink: '',
  colorTextBase: '',
  colorBgBase: '',
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: `'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace`,
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: 'solid',
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: 'cubic-bezier(0.08, 0.82, 0.17, 1)',
  motionEaseInOutCirc: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
  motionEaseOut: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
  motionEaseInOut: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
  motionEaseOutBack: 'cubic-bezier(0.12, 0.4, 0.29, 1.46)',
  motionEaseInBack: 'cubic-bezier(0.71, -0.46, 0.88, 0.6)',
  motionEaseInQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
  motionEaseOutQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1000,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: false,
  // Motion
  motion: true
});
/* harmony default export */ __webpack_exports__["Z"] = (seedToken);

/***/ }),

/***/ 85362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getLineHeight; },
/* harmony export */   "Z": function() { return /* binding */ getFontSizes; }
/* harmony export */ });
function getLineHeight(fontSize) {
  return (fontSize + 8) / fontSize;
}
// https://zhuanlan.zhihu.com/p/32746810
function getFontSizes(base) {
  const fontSizes = Array.from({
    length: 10
  }).map((_, index) => {
    const i = index - 1;
    const baseSize = base * Math.pow(Math.E, i / 5);
    const intSize = index > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
    // Convert to even
    return Math.floor(intSize / 2) * 2;
  });
  fontSizes[1] = base;
  return fontSizes.map(size => ({
    size,
    lineHeight: getLineHeight(size)
  }));
}

/***/ }),

/***/ 39779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ useToken; },
  "NJ": function() { return /* binding */ unitless; }
});

// UNUSED EXPORTS: getComputedToken, ignore

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs/es/index.js + 37 modules
var es = __webpack_require__(68946);
;// CONCATENATED MODULE: ./node_modules/antd/es/version/version.js
/* harmony default export */ var version = ('5.27.0');
;// CONCATENATED MODULE: ./node_modules/antd/es/version/index.js
"use client";

// @ts-ignore

/* harmony default export */ var es_version = (version);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/context.js
var context = __webpack_require__(93897);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/themes/default/theme.js + 9 modules
var default_theme = __webpack_require__(17869);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/themes/seed.js
var seed = __webpack_require__(77177);
// EXTERNAL MODULE: ./node_modules/@ant-design/fast-color/es/index.js + 1 modules
var fast_color_es = __webpack_require__(99620);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/util/getAlphaColor.js
var getAlphaColor = __webpack_require__(12402);
;// CONCATENATED MODULE: ./node_modules/antd/es/theme/util/alias.js
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};



/**
 * Seed (designer) > Derivative (designer) > Alias (developer).
 *
 * Merge seed & derivative & override token and generate alias token for developer.
 */
function formatToken(derivativeToken) {
  const {
      override
    } = derivativeToken,
    restToken = __rest(derivativeToken, ["override"]);
  const overrideTokens = Object.assign({}, override);
  Object.keys(seed/* default */.Z).forEach(token => {
    delete overrideTokens[token];
  });
  const mergedToken = Object.assign(Object.assign({}, restToken), overrideTokens);
  const screenXS = 480;
  const screenSM = 576;
  const screenMD = 768;
  const screenLG = 992;
  const screenXL = 1200;
  const screenXXL = 1600;
  // Motion
  if (mergedToken.motion === false) {
    const fastDuration = '0s';
    mergedToken.motionDurationFast = fastDuration;
    mergedToken.motionDurationMid = fastDuration;
    mergedToken.motionDurationSlow = fastDuration;
  }
  // Generate alias token
  const aliasToken = Object.assign(Object.assign(Object.assign({}, mergedToken), {
    // ============== Background ============== //
    colorFillContent: mergedToken.colorFillSecondary,
    colorFillContentHover: mergedToken.colorFill,
    colorFillAlter: mergedToken.colorFillQuaternary,
    colorBgContainerDisabled: mergedToken.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: mergedToken.colorBgContainer,
    colorSplit: (0,getAlphaColor/* default */.Z)(mergedToken.colorBorderSecondary, mergedToken.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: mergedToken.colorTextQuaternary,
    colorTextDisabled: mergedToken.colorTextQuaternary,
    colorTextHeading: mergedToken.colorText,
    colorTextLabel: mergedToken.colorTextSecondary,
    colorTextDescription: mergedToken.colorTextTertiary,
    colorTextLightSolid: mergedToken.colorWhite,
    colorHighlight: mergedToken.colorError,
    colorBgTextHover: mergedToken.colorFillSecondary,
    colorBgTextActive: mergedToken.colorFill,
    colorIcon: mergedToken.colorTextTertiary,
    colorIconHover: mergedToken.colorText,
    colorErrorOutline: (0,getAlphaColor/* default */.Z)(mergedToken.colorErrorBg, mergedToken.colorBgContainer),
    colorWarningOutline: (0,getAlphaColor/* default */.Z)(mergedToken.colorWarningBg, mergedToken.colorBgContainer),
    // Font
    fontSizeIcon: mergedToken.fontSizeSM,
    // Line
    lineWidthFocus: mergedToken.lineWidth * 3,
    // Control
    lineWidth: mergedToken.lineWidth,
    controlOutlineWidth: mergedToken.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: mergedToken.controlHeight / 2,
    controlItemBgHover: mergedToken.colorFillTertiary,
    controlItemBgActive: mergedToken.colorPrimaryBg,
    controlItemBgActiveHover: mergedToken.colorPrimaryBgHover,
    controlItemBgActiveDisabled: mergedToken.colorFill,
    controlTmpOutline: mergedToken.colorFillQuaternary,
    controlOutline: (0,getAlphaColor/* default */.Z)(mergedToken.colorPrimaryBg, mergedToken.colorBgContainer),
    lineType: mergedToken.lineType,
    borderRadius: mergedToken.borderRadius,
    borderRadiusXS: mergedToken.borderRadiusXS,
    borderRadiusSM: mergedToken.borderRadiusSM,
    borderRadiusLG: mergedToken.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: 'none',
    linkHoverDecoration: 'none',
    linkFocusDecoration: 'none',
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: mergedToken.sizeXXS,
    paddingXS: mergedToken.sizeXS,
    paddingSM: mergedToken.sizeSM,
    padding: mergedToken.size,
    paddingMD: mergedToken.sizeMD,
    paddingLG: mergedToken.sizeLG,
    paddingXL: mergedToken.sizeXL,
    paddingContentHorizontalLG: mergedToken.sizeLG,
    paddingContentVerticalLG: mergedToken.sizeMS,
    paddingContentHorizontal: mergedToken.sizeMS,
    paddingContentVertical: mergedToken.sizeSM,
    paddingContentHorizontalSM: mergedToken.size,
    paddingContentVerticalSM: mergedToken.sizeXS,
    marginXXS: mergedToken.sizeXXS,
    marginXS: mergedToken.sizeXS,
    marginSM: mergedToken.sizeSM,
    margin: mergedToken.size,
    marginMD: mergedToken.sizeMD,
    marginLG: mergedToken.sizeLG,
    marginXL: mergedToken.sizeXL,
    marginXXL: mergedToken.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS,
    screenXSMin: screenXS,
    screenXSMax: screenSM - 1,
    screenSM,
    screenSMMin: screenSM,
    screenSMMax: screenMD - 1,
    screenMD,
    screenMDMin: screenMD,
    screenMDMax: screenLG - 1,
    screenLG,
    screenLGMin: screenLG,
    screenLGMax: screenXL - 1,
    screenXL,
    screenXLMin: screenXL,
    screenXLMax: screenXXL - 1,
    screenXXL,
    screenXXLMin: screenXXL,
    boxShadowPopoverArrow: '2px 2px 5px rgba(0, 0, 0, 0.05)',
    boxShadowCard: `
      0 1px 2px -2px ${new fast_color_es/* FastColor */.t('rgba(0, 0, 0, 0.16)').toRgbString()},
      0 3px 6px 0 ${new fast_color_es/* FastColor */.t('rgba(0, 0, 0, 0.12)').toRgbString()},
      0 5px 12px 4px ${new fast_color_es/* FastColor */.t('rgba(0, 0, 0, 0.09)').toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: 'inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)',
    boxShadowTabsOverflowRight: 'inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)',
    boxShadowTabsOverflowTop: 'inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)',
    boxShadowTabsOverflowBottom: 'inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)'
  }), overrideTokens);
  return aliasToken;
}
;// CONCATENATED MODULE: ./node_modules/antd/es/theme/useToken.js
var useToken_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






const unitless = {
  lineHeight: true,
  lineHeightSM: true,
  lineHeightLG: true,
  lineHeightHeading1: true,
  lineHeightHeading2: true,
  lineHeightHeading3: true,
  lineHeightHeading4: true,
  lineHeightHeading5: true,
  opacityLoading: true,
  fontWeightStrong: true,
  zIndexPopupBase: true,
  zIndexBase: true,
  opacityImage: true
};
const ignore = {
  motionBase: true,
  motionUnit: true
};
const preserve = {
  screenXS: true,
  screenXSMin: true,
  screenXSMax: true,
  screenSM: true,
  screenSMMin: true,
  screenSMMax: true,
  screenMD: true,
  screenMDMin: true,
  screenMDMax: true,
  screenLG: true,
  screenLGMin: true,
  screenLGMax: true,
  screenXL: true,
  screenXLMin: true,
  screenXLMax: true,
  screenXXL: true,
  screenXXLMin: true
};
const getComputedToken = (originToken, overrideToken, theme) => {
  const derivativeToken = theme.getDerivativeToken(originToken);
  const {
      override
    } = overrideToken,
    components = useToken_rest(overrideToken, ["override"]);
  // Merge with override
  let mergedDerivativeToken = Object.assign(Object.assign({}, derivativeToken), {
    override
  });
  // Format if needed
  mergedDerivativeToken = formatToken(mergedDerivativeToken);
  if (components) {
    Object.entries(components).forEach(([key, value]) => {
      const {
          theme: componentTheme
        } = value,
        componentTokens = useToken_rest(value, ["theme"]);
      let mergedComponentToken = componentTokens;
      if (componentTheme) {
        mergedComponentToken = getComputedToken(Object.assign(Object.assign({}, mergedDerivativeToken), componentTokens), {
          override: componentTokens
        }, componentTheme);
      }
      mergedDerivativeToken[key] = mergedComponentToken;
    });
  }
  return mergedDerivativeToken;
};
// ================================== Hook ==================================
function useToken() {
  const {
    token: rootDesignToken,
    hashed,
    theme,
    override,
    cssVar
  } = react.useContext(context/* DesignTokenContext */.Mj);
  const salt = `${es_version}-${hashed || ''}`;
  const mergedTheme = theme || default_theme/* default */.Z;
  const [token, hashId, realToken] = (0,es/* useCacheToken */.fp)(mergedTheme, [seed/* default */.Z, rootDesignToken], {
    salt,
    override,
    getComputedToken,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken: formatToken,
    cssVar: cssVar && {
      prefix: cssVar.prefix,
      key: cssVar.key,
      unitless,
      ignore,
      preserve
    }
  });
  return [mergedTheme, realToken, hashed ? hashId : '', token, cssVar];
}

/***/ }),

/***/ 39970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ genPresetColor; }
/* harmony export */ });
/* harmony import */ var _interface__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26822);

function genPresetColor(token, genCss) {
  return _interface__WEBPACK_IMPORTED_MODULE_0__/* .PresetColors.reduce */ .i.reduce((prev, colorKey) => {
    const lightColor = token[`${colorKey}1`];
    const lightBorderColor = token[`${colorKey}3`];
    const darkColor = token[`${colorKey}6`];
    const textColor = token[`${colorKey}7`];
    return Object.assign(Object.assign({}, prev), genCss(colorKey, {
      lightColor,
      lightBorderColor,
      darkColor,
      textColor
    }));
  }, {});
}

/***/ }),

/***/ 18511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A1": function() { return /* binding */ genComponentStyleHook; },
/* harmony export */   "I$": function() { return /* binding */ genStyleHooks; },
/* harmony export */   "bk": function() { return /* binding */ genSubStyleComponent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var _ant_design_cssinjs_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89158);
/* harmony import */ var _config_provider_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94980);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31875);
/* harmony import */ var _useToken__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39779);





const {
  genStyleHooks,
  genComponentStyleHook,
  genSubStyleComponent
} = (0,_ant_design_cssinjs_utils__WEBPACK_IMPORTED_MODULE_1__/* .genStyleUtils */ .rb)({
  usePrefix: () => {
    const {
      getPrefixCls,
      iconPrefixCls
    } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_config_provider_context__WEBPACK_IMPORTED_MODULE_2__/* .ConfigContext */ .E_);
    const rootPrefixCls = getPrefixCls();
    return {
      rootPrefixCls,
      iconPrefixCls
    };
  },
  useToken: () => {
    const [theme, realToken, hashId, token, cssVar] = (0,_useToken__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)();
    return {
      theme,
      realToken,
      hashId,
      token,
      cssVar
    };
  },
  useCSP: () => {
    const {
      csp
    } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_config_provider_context__WEBPACK_IMPORTED_MODULE_2__/* .ConfigContext */ .E_);
    return csp !== null && csp !== void 0 ? csp : {};
  },
  getResetStyles: (token, config) => {
    var _a;
    const linkStyle = (0,_style__WEBPACK_IMPORTED_MODULE_4__/* .genLinkStyle */ .Lx)(token);
    return [linkStyle, {
      '&': linkStyle
    }, (0,_style__WEBPACK_IMPORTED_MODULE_4__/* .genIconStyle */ .JT)((_a = config === null || config === void 0 ? void 0 : config.prefix.iconPrefixCls) !== null && _a !== void 0 ? _a : _config_provider_context__WEBPACK_IMPORTED_MODULE_2__/* .defaultIconPrefixCls */ .oR)];
  },
  getCommonStyle: _style__WEBPACK_IMPORTED_MODULE_4__/* .genCommonStyle */ .du,
  getCompUnitless: () => _useToken__WEBPACK_IMPORTED_MODULE_3__/* .unitless */ .NJ
});

/***/ }),

/***/ 12402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ant_design_fast_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99620);

function isStableColor(color) {
  return color >= 0 && color <= 255;
}
function getAlphaColor(frontColor, backgroundColor) {
  const {
    r: fR,
    g: fG,
    b: fB,
    a: originAlpha
  } = new _ant_design_fast_color__WEBPACK_IMPORTED_MODULE_0__/* .FastColor */ .t(frontColor).toRgb();
  if (originAlpha < 1) {
    return frontColor;
  }
  const {
    r: bR,
    g: bG,
    b: bB
  } = new _ant_design_fast_color__WEBPACK_IMPORTED_MODULE_0__/* .FastColor */ .t(backgroundColor).toRgb();
  for (let fA = 0.01; fA <= 1; fA += 0.01) {
    const r = Math.round((fR - bR * (1 - fA)) / fA);
    const g = Math.round((fG - bG * (1 - fA)) / fA);
    const b = Math.round((fB - bB * (1 - fA)) / fA);
    if (isStableColor(r) && isStableColor(g) && isStableColor(b)) {
      return new _ant_design_fast_color__WEBPACK_IMPORTED_MODULE_0__/* .FastColor */ .t({
        r,
        g,
        b,
        a: Math.round(fA * 100) / 100
      }).toRgbString();
    }
  }
  // fallback
  /* istanbul ignore next */
  return new _ant_design_fast_color__WEBPACK_IMPORTED_MODULE_0__/* .FastColor */ .t({
    r: fR,
    g: fG,
    b: fB,
    a: 1
  }).toRgbString();
}
/* harmony default export */ __webpack_exports__["Z"] = (getAlphaColor);

/***/ }),

/***/ 54539:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const locale = {
  placeholder: 'Select time',
  rangePlaceholder: ['Start time', 'End time']
};
/* harmony default export */ __webpack_exports__["Z"] = (locale);

/***/ }),

/***/ 93740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tooltip; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-tooltip/es/index.js + 3 modules
var es = __webpack_require__(59052);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMergedState.js
var useMergedState = __webpack_require__(78877);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/ContextIsolator.js
var ContextIsolator = __webpack_require__(32973);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/hooks/useZIndex.js
var useZIndex = __webpack_require__(5884);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/motion.js
var _util_motion = __webpack_require__(19405);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/placements.js
var placements = __webpack_require__(78130);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/reactNode.js
var reactNode = __webpack_require__(81730);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/warning.js
var _util_warning = __webpack_require__(85251);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/zindexContext.js
var zindexContext = __webpack_require__(85720);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js
var context = __webpack_require__(94980);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/useToken.js + 3 modules
var useToken = __webpack_require__(39779);
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs/es/index.js + 37 modules
var cssinjs_es = __webpack_require__(68946);
// EXTERNAL MODULE: ./node_modules/antd/es/style/index.js
var style = __webpack_require__(31875);
// EXTERNAL MODULE: ./node_modules/antd/es/style/motion/zoom.js
var zoom = __webpack_require__(63897);
// EXTERNAL MODULE: ./node_modules/antd/es/style/placementArrow.js
var placementArrow = __webpack_require__(33294);
// EXTERNAL MODULE: ./node_modules/antd/es/style/roundedArrow.js
var roundedArrow = __webpack_require__(20829);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/util/genPresetColor.js
var genPresetColor = __webpack_require__(39970);
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs-utils/es/index.js + 12 modules
var cssinjs_utils_es = __webpack_require__(89158);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/util/genStyleUtils.js
var genStyleUtils = __webpack_require__(18511);
;// CONCATENATED MODULE: ./node_modules/antd/es/tooltip/style/index.js






const genTooltipStyle = token => {
  const {
    calc,
    componentCls,
    // ant-tooltip
    tooltipMaxWidth,
    tooltipColor,
    tooltipBg,
    tooltipBorderRadius,
    zIndexPopup,
    controlHeight,
    boxShadowSecondary,
    paddingSM,
    paddingXS,
    arrowOffsetHorizontal,
    sizePopupArrow
  } = token;
  // arrowOffsetHorizontal + arrowWidth + borderRadius
  const edgeAlignMinWidth = calc(tooltipBorderRadius).add(sizePopupArrow).add(arrowOffsetHorizontal).equal();
  // borderRadius * 2 + arrowWidth
  const centerAlignMinWidth = calc(tooltipBorderRadius).mul(2).add(sizePopupArrow).equal();
  return [{
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, (0,style/* resetComponent */.Wf)(token)), {
      position: 'absolute',
      zIndex: zIndexPopup,
      display: 'block',
      width: 'max-content',
      maxWidth: tooltipMaxWidth,
      visibility: 'visible',
      // When use `autoArrow`, origin will follow the arrow position
      '--valid-offset-x': 'var(--arrow-offset-horizontal, var(--arrow-x))',
      transformOrigin: [`var(--valid-offset-x, 50%)`, `var(--arrow-y, 50%)`].join(' '),
      '&-hidden': {
        display: 'none'
      },
      '--antd-arrow-background-color': tooltipBg,
      // Wrapper for the tooltip content
      [`${componentCls}-inner`]: {
        minWidth: centerAlignMinWidth,
        minHeight: controlHeight,
        padding: `${(0,cssinjs_es/* unit */.bf)(token.calc(paddingSM).div(2).equal())} ${(0,cssinjs_es/* unit */.bf)(paddingXS)}`,
        color: `var(--ant-tooltip-color,${tooltipColor})`,
        textAlign: 'start',
        textDecoration: 'none',
        wordWrap: 'break-word',
        backgroundColor: tooltipBg,
        borderRadius: tooltipBorderRadius,
        boxShadow: boxShadowSecondary,
        boxSizing: 'border-box'
      },
      // Align placement should have another min width
      [[`&-placement-topLeft`, `&-placement-topRight`, `&-placement-bottomLeft`, `&-placement-bottomRight`].join(',')]: {
        minWidth: edgeAlignMinWidth
      },
      // Limit left and right placement radius
      [[`&-placement-left`, `&-placement-leftTop`, `&-placement-leftBottom`, `&-placement-right`, `&-placement-rightTop`, `&-placement-rightBottom`].join(',')]: {
        [`${componentCls}-inner`]: {
          borderRadius: token.min(tooltipBorderRadius, placementArrow/* MAX_VERTICAL_CONTENT_RADIUS */.qN)
        }
      },
      [`${componentCls}-content`]: {
        position: 'relative'
      }
    }), (0,genPresetColor/* default */.Z)(token, (colorKey, {
      darkColor
    }) => ({
      [`&${componentCls}-${colorKey}`]: {
        [`${componentCls}-inner`]: {
          backgroundColor: darkColor
        },
        [`${componentCls}-arrow`]: {
          '--antd-arrow-background-color': darkColor
        }
      }
    }))), {
      // RTL
      '&-rtl': {
        direction: 'rtl'
      }
    })
  },
  // Arrow Style
  (0,placementArrow/* default */.ZP)(token, 'var(--antd-arrow-background-color)'),
  // Pure Render
  {
    [`${componentCls}-pure`]: {
      position: 'relative',
      maxWidth: 'none',
      margin: token.sizePopupArrow
    }
  }];
};
// ============================== Export ==============================
const prepareComponentToken = token => Object.assign(Object.assign({
  zIndexPopup: token.zIndexPopupBase + 70
}, (0,placementArrow/* getArrowOffsetToken */.wZ)({
  contentRadius: token.borderRadius,
  limitVerticalRadius: true
})), (0,roundedArrow/* getArrowToken */.w)((0,cssinjs_utils_es/* mergeToken */.IX)(token, {
  borderRadiusOuter: Math.min(token.borderRadiusOuter, 4)
})));
/* harmony default export */ var tooltip_style = ((prefixCls, injectStyle = true) => {
  const useStyle = (0,genStyleUtils/* genStyleHooks */.I$)('Tooltip', token => {
    const {
      borderRadius,
      colorTextLightSolid,
      colorBgSpotlight
    } = token;
    const TooltipToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
      // default variables
      tooltipMaxWidth: 250,
      tooltipColor: colorTextLightSolid,
      tooltipBorderRadius: borderRadius,
      tooltipBg: colorBgSpotlight
    });
    return [genTooltipStyle(TooltipToken), (0,zoom/* initZoomMotion */._y)(token, 'zoom-big-fast')];
  }, prepareComponentToken, {
    resetStyle: false,
    // Popover use Tooltip as internal component. We do not need to handle this.
    injectStyle
  });
  return useStyle(prefixCls);
});
// EXTERNAL MODULE: ./node_modules/antd/es/_util/colors.js
var colors = __webpack_require__(708);
// EXTERNAL MODULE: ./node_modules/@rc-component/color-picker/es/index.js + 13 modules
var color_picker_es = __webpack_require__(3434);
// EXTERNAL MODULE: ./node_modules/antd/es/color-picker/color.js
var color_picker_color = __webpack_require__(65606);
;// CONCATENATED MODULE: ./node_modules/antd/es/color-picker/util.js



const generateColor = color => {
  if (color instanceof color_picker_color/* AggregationColor */.y9) {
    return color;
  }
  return new color_picker_color/* AggregationColor */.y9(color);
};
const getRoundNumber = value => Math.round(Number(value || 0));
const getColorAlpha = color => getRoundNumber(color.toHsb().a * 100);
/** Return the color whose `alpha` is 1 */
const genAlphaColor = (color, alpha) => {
  const rgba = color.toRgb();
  // Color from hsb input may get `rgb` is (0/0/0) when `hsb.b` is 0
  // So if rgb is empty, we should get from hsb
  if (!rgba.r && !rgba.g && !rgba.b) {
    const hsba = color.toHsb();
    hsba.a = alpha || 1;
    return generateColor(hsba);
  }
  rgba.a = alpha || 1;
  return generateColor(rgba);
};
/**
 * Get percent position color. e.g. [10%-#fff, 20%-#000], 15% => #888
 */
const getGradientPercentColor = (colors, percent) => {
  const filledColors = [{
    percent: 0,
    color: colors[0].color
  }].concat(_toConsumableArray(colors), [{
    percent: 100,
    color: colors[colors.length - 1].color
  }]);
  for (let i = 0; i < filledColors.length - 1; i += 1) {
    const startPtg = filledColors[i].percent;
    const endPtg = filledColors[i + 1].percent;
    const startColor = filledColors[i].color;
    const endColor = filledColors[i + 1].color;
    if (startPtg <= percent && percent <= endPtg) {
      const dist = endPtg - startPtg;
      if (dist === 0) {
        return startColor;
      }
      const ratio = (percent - startPtg) / dist * 100;
      const startRcColor = new RcColor(startColor);
      const endRcColor = new RcColor(endColor);
      return startRcColor.mix(endRcColor, ratio).toRgbString();
    }
  }
  // This will never reach
  /* istanbul ignore next */
  return '';
};
;// CONCATENATED MODULE: ./node_modules/antd/es/tooltip/util.js



function parseColor(prefixCls, color) {
  const isInternalColor = (0,colors/* isPresetColor */.o2)(color);
  const className = classnames_default()({
    [`${prefixCls}-${color}`]: color && isInternalColor
  });
  const overlayStyle = {};
  const arrowStyle = {};
  const rgb = generateColor(color).toRgb();
  const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
  const textColor = luminance < 0.5 ? '#FFF' : '#000';
  if (color && !isInternalColor) {
    overlayStyle.background = color;
    overlayStyle['--ant-tooltip-color'] = textColor;
    // @ts-ignore
    arrowStyle['--antd-arrow-background-color'] = color;
  }
  return {
    className,
    overlayStyle,
    arrowStyle
  };
}
;// CONCATENATED MODULE: ./node_modules/antd/es/tooltip/PurePanel.js
"use client";







/** @private Internal Component. Do not use in your production. */
const PurePanel = props => {
  const {
    prefixCls: customizePrefixCls,
    className,
    placement = 'top',
    title,
    color,
    overlayInnerStyle
  } = props;
  const {
    getPrefixCls
  } = react.useContext(context/* ConfigContext */.E_);
  const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = tooltip_style(prefixCls);
  // Color
  const colorInfo = parseColor(prefixCls, color);
  const arrowContentStyle = colorInfo.arrowStyle;
  const formattedOverlayInnerStyle = Object.assign(Object.assign({}, overlayInnerStyle), colorInfo.overlayStyle);
  const cls = classnames_default()(hashId, cssVarCls, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className, colorInfo.className);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    className: cls,
    style: arrowContentStyle
  }, /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-arrow`
  }), /*#__PURE__*/react.createElement(es/* Popup */.G, Object.assign({}, props, {
    className: hashId,
    prefixCls: prefixCls,
    overlayInnerStyle: formattedOverlayInnerStyle
  }), title)));
};
/* harmony default export */ var tooltip_PurePanel = (PurePanel);
;// CONCATENATED MODULE: ./node_modules/antd/es/tooltip/index.js
"use client";

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
















const InternalTooltip = /*#__PURE__*/react.forwardRef((props, ref) => {
  var _a, _b;
  const {
      prefixCls: customizePrefixCls,
      openClassName,
      getTooltipContainer,
      color,
      overlayInnerStyle,
      children,
      afterOpenChange,
      afterVisibleChange,
      destroyTooltipOnHide,
      destroyOnHidden,
      arrow = true,
      title,
      overlay,
      builtinPlacements,
      arrowPointAtCenter = false,
      autoAdjustOverflow = true,
      motion,
      getPopupContainer,
      placement = 'top',
      mouseEnterDelay = 0.1,
      mouseLeaveDelay = 0.1,
      overlayStyle,
      rootClassName,
      overlayClassName,
      styles,
      classNames: tooltipClassNames
    } = props,
    restProps = __rest(props, ["prefixCls", "openClassName", "getTooltipContainer", "color", "overlayInnerStyle", "children", "afterOpenChange", "afterVisibleChange", "destroyTooltipOnHide", "destroyOnHidden", "arrow", "title", "overlay", "builtinPlacements", "arrowPointAtCenter", "autoAdjustOverflow", "motion", "getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "rootClassName", "overlayClassName", "styles", "classNames"]);
  const mergedShowArrow = !!arrow;
  const [, token] = (0,useToken/* default */.ZP)();
  const {
    getPopupContainer: getContextPopupContainer,
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = (0,context/* useComponentConfig */.dj)('tooltip');
  // ============================== Ref ===============================
  const warning = (0,_util_warning/* devUseWarning */.ln)('Tooltip');
  const tooltipRef = react.useRef(null);
  const forceAlign = () => {
    var _a;
    (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.forceAlign();
  };
  react.useImperativeHandle(ref, () => {
    var _a, _b;
    return {
      forceAlign,
      forcePopupAlign: () => {
        warning.deprecated(false, 'forcePopupAlign', 'forceAlign');
        forceAlign();
      },
      nativeElement: (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.nativeElement,
      popupElement: (_b = tooltipRef.current) === null || _b === void 0 ? void 0 : _b.popupElement
    };
  });
  // ============================== Warn ==============================
  if (false) {}
  // ============================== Open ==============================
  const [open, setOpen] = (0,useMergedState/* default */.Z)(false, {
    value: (_a = props.open) !== null && _a !== void 0 ? _a : props.visible,
    defaultValue: (_b = props.defaultOpen) !== null && _b !== void 0 ? _b : props.defaultVisible
  });
  const noTitle = !title && !overlay && title !== 0; // overlay for old version compatibility
  const onOpenChange = vis => {
    var _a, _b;
    setOpen(noTitle ? false : vis);
    if (!noTitle) {
      (_a = props.onOpenChange) === null || _a === void 0 ? void 0 : _a.call(props, vis);
      (_b = props.onVisibleChange) === null || _b === void 0 ? void 0 : _b.call(props, vis);
    }
  };
  const tooltipPlacements = react.useMemo(() => {
    var _a, _b;
    let mergedArrowPointAtCenter = arrowPointAtCenter;
    if (typeof arrow === 'object') {
      mergedArrowPointAtCenter = (_b = (_a = arrow.pointAtCenter) !== null && _a !== void 0 ? _a : arrow.arrowPointAtCenter) !== null && _b !== void 0 ? _b : arrowPointAtCenter;
    }
    return builtinPlacements || (0,placements/* default */.Z)({
      arrowPointAtCenter: mergedArrowPointAtCenter,
      autoAdjustOverflow,
      arrowWidth: mergedShowArrow ? token.sizePopupArrow : 0,
      borderRadius: token.borderRadius,
      offset: token.marginXXS,
      visibleFirst: true
    });
  }, [arrowPointAtCenter, arrow, builtinPlacements, token]);
  const memoOverlay = react.useMemo(() => {
    if (title === 0) {
      return title;
    }
    return overlay || title || '';
  }, [overlay, title]);
  const memoOverlayWrapper = /*#__PURE__*/react.createElement(ContextIsolator/* default */.Z, {
    space: true
  }, typeof memoOverlay === 'function' ? memoOverlay() : memoOverlay);
  const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  const injectFromPopover = props['data-popover-inject'];
  let tempOpen = open;
  // Hide tooltip when there is no title
  if (!('open' in props) && !('visible' in props) && noTitle) {
    tempOpen = false;
  }
  // ============================= Render =============================
  const child = /*#__PURE__*/react.isValidElement(children) && !(0,reactNode/* isFragment */.M2)(children) ? children : /*#__PURE__*/react.createElement("span", null, children);
  const childProps = child.props;
  const childCls = !childProps.className || typeof childProps.className === 'string' ? classnames_default()(childProps.className, openClassName || `${prefixCls}-open`) : childProps.className;
  // Style
  const [wrapCSSVar, hashId, cssVarCls] = tooltip_style(prefixCls, !injectFromPopover);
  // Color
  const colorInfo = parseColor(prefixCls, color);
  const arrowContentStyle = colorInfo.arrowStyle;
  const rootClassNames = classnames_default()(overlayClassName, {
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, colorInfo.className, rootClassName, hashId, cssVarCls, contextClassName, contextClassNames.root, tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.root);
  const bodyClassNames = classnames_default()(contextClassNames.body, tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.body);
  // ============================ zIndex ============================
  const [zIndex, contextZIndex] = (0,useZIndex/* useZIndex */.Cn)('Tooltip', restProps.zIndex);
  const content = /*#__PURE__*/react.createElement(es/* default */.Z, Object.assign({}, restProps, {
    zIndex: zIndex,
    showArrow: mergedShowArrow,
    placement: placement,
    mouseEnterDelay: mouseEnterDelay,
    mouseLeaveDelay: mouseLeaveDelay,
    prefixCls: prefixCls,
    classNames: {
      root: rootClassNames,
      body: bodyClassNames
    },
    styles: {
      root: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, arrowContentStyle), contextStyles.root), contextStyle), overlayStyle), styles === null || styles === void 0 ? void 0 : styles.root),
      body: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.body), overlayInnerStyle), styles === null || styles === void 0 ? void 0 : styles.body), colorInfo.overlayStyle)
    },
    getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
    ref: tooltipRef,
    builtinPlacements: tooltipPlacements,
    overlay: memoOverlayWrapper,
    visible: tempOpen,
    onVisibleChange: onOpenChange,
    afterVisibleChange: afterOpenChange !== null && afterOpenChange !== void 0 ? afterOpenChange : afterVisibleChange,
    arrowContent: /*#__PURE__*/react.createElement("span", {
      className: `${prefixCls}-arrow-content`
    }),
    motion: {
      motionName: (0,_util_motion/* getTransitionName */.m)(rootPrefixCls, 'zoom-big-fast', props.transitionName),
      motionDeadline: 1000
    },
    // TODO: In the future, destroyTooltipOnHide in rc-tooltip needs to be upgrade to destroyOnHidden
    destroyTooltipOnHide: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : !!destroyTooltipOnHide
  }), tempOpen ? (0,reactNode/* cloneElement */.Tm)(child, {
    className: childCls
  }) : child);
  return wrapCSSVar(/*#__PURE__*/react.createElement(zindexContext/* default.Provider */.Z.Provider, {
    value: contextZIndex
  }, content));
});
const Tooltip = InternalTooltip;
if (false) {}
Tooltip._InternalPanelDoNotUseOrYouWillBeFired = tooltip_PurePanel;
/* harmony default export */ var tooltip = (Tooltip);

/***/ }),

/***/ 78118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ usePanelRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var rc_util_es_hooks_useEvent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47789);


function voidFunc() {}
const WatermarkContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  add: voidFunc,
  remove: voidFunc
});
function usePanelRef(panelSelector) {
  const watermark = react__WEBPACK_IMPORTED_MODULE_0__.useContext(WatermarkContext);
  const panelEleRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const panelRef = (0,rc_util_es_hooks_useEvent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ele => {
    if (ele) {
      const innerContentEle = panelSelector ? ele.querySelector(panelSelector) : ele;
      watermark.add(innerContentEle);
      panelEleRef.current = innerContentEle;
    } else {
      watermark.remove(panelEleRef.current);
    }
  });
  return panelRef;
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (WatermarkContext)));

/***/ }),

/***/ 20372:
/***/ (function(module) {

!function (e, t) {
   true ? module.exports = t() : 0;
}(this, function () {
  return function (e) {
    function t(o) {
      if (n[o]) return n[o].exports;
      var i = n[o] = {
        exports: {},
        id: o,
        loaded: !1
      };
      return e[o].call(i.exports, i, i.exports, t), i.loaded = !0, i.exports;
    }
    var n = {};
    return t.m = e, t.c = n, t.p = "dist/", t(0);
  }([function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    var i = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
        return e;
      },
      r = n(1),
      a = (o(r), n(6)),
      u = o(a),
      c = n(7),
      s = o(c),
      f = n(8),
      d = o(f),
      l = n(9),
      p = o(l),
      m = n(10),
      b = o(m),
      v = n(11),
      y = o(v),
      g = n(14),
      h = o(g),
      w = [],
      k = !1,
      x = {
        offset: 120,
        delay: 0,
        easing: "ease",
        duration: 400,
        disable: !1,
        once: !1,
        startEvent: "DOMContentLoaded",
        throttleDelay: 99,
        debounceDelay: 50,
        disableMutationObserver: !1
      },
      j = function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        if (e && (k = !0), k) return w = (0, y.default)(w, x), (0, b.default)(w, x.once), w;
      },
      O = function () {
        w = (0, h.default)(), j();
      },
      M = function () {
        w.forEach(function (e, t) {
          e.node.removeAttribute("data-aos"), e.node.removeAttribute("data-aos-easing"), e.node.removeAttribute("data-aos-duration"), e.node.removeAttribute("data-aos-delay");
        });
      },
      S = function (e) {
        return e === !0 || "mobile" === e && p.default.mobile() || "phone" === e && p.default.phone() || "tablet" === e && p.default.tablet() || "function" == typeof e && e() === !0;
      },
      _ = function (e) {
        x = i(x, e), w = (0, h.default)();
        var t = document.all && !window.atob;
        return S(x.disable) || t ? M() : (x.disableMutationObserver || d.default.isSupported() || (console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '), x.disableMutationObserver = !0), document.querySelector("body").setAttribute("data-aos-easing", x.easing), document.querySelector("body").setAttribute("data-aos-duration", x.duration), document.querySelector("body").setAttribute("data-aos-delay", x.delay), "DOMContentLoaded" === x.startEvent && ["complete", "interactive"].indexOf(document.readyState) > -1 ? j(!0) : "load" === x.startEvent ? window.addEventListener(x.startEvent, function () {
          j(!0);
        }) : document.addEventListener(x.startEvent, function () {
          j(!0);
        }), window.addEventListener("resize", (0, s.default)(j, x.debounceDelay, !0)), window.addEventListener("orientationchange", (0, s.default)(j, x.debounceDelay, !0)), window.addEventListener("scroll", (0, u.default)(function () {
          (0, b.default)(w, x.once);
        }, x.throttleDelay)), x.disableMutationObserver || d.default.ready("[data-aos]", O), w);
      };
    e.exports = {
      init: _,
      refresh: j,
      refreshHard: O
    };
  }, function (e, t) {},,,,, function (e, t) {
    (function (t) {
      "use strict";

      function n(e, t, n) {
        function o(t) {
          var n = b,
            o = v;
          return b = v = void 0, k = t, g = e.apply(o, n);
        }
        function r(e) {
          return k = e, h = setTimeout(f, t), M ? o(e) : g;
        }
        function a(e) {
          var n = e - w,
            o = e - k,
            i = t - n;
          return S ? j(i, y - o) : i;
        }
        function c(e) {
          var n = e - w,
            o = e - k;
          return void 0 === w || n >= t || n < 0 || S && o >= y;
        }
        function f() {
          var e = O();
          return c(e) ? d(e) : void (h = setTimeout(f, a(e)));
        }
        function d(e) {
          return h = void 0, _ && b ? o(e) : (b = v = void 0, g);
        }
        function l() {
          void 0 !== h && clearTimeout(h), k = 0, b = w = v = h = void 0;
        }
        function p() {
          return void 0 === h ? g : d(O());
        }
        function m() {
          var e = O(),
            n = c(e);
          if (b = arguments, v = this, w = e, n) {
            if (void 0 === h) return r(w);
            if (S) return h = setTimeout(f, t), o(w);
          }
          return void 0 === h && (h = setTimeout(f, t)), g;
        }
        var b,
          v,
          y,
          g,
          h,
          w,
          k = 0,
          M = !1,
          S = !1,
          _ = !0;
        if ("function" != typeof e) throw new TypeError(s);
        return t = u(t) || 0, i(n) && (M = !!n.leading, S = "maxWait" in n, y = S ? x(u(n.maxWait) || 0, t) : y, _ = "trailing" in n ? !!n.trailing : _), m.cancel = l, m.flush = p, m;
      }
      function o(e, t, o) {
        var r = !0,
          a = !0;
        if ("function" != typeof e) throw new TypeError(s);
        return i(o) && (r = "leading" in o ? !!o.leading : r, a = "trailing" in o ? !!o.trailing : a), n(e, t, {
          leading: r,
          maxWait: t,
          trailing: a
        });
      }
      function i(e) {
        var t = "undefined" == typeof e ? "undefined" : c(e);
        return !!e && ("object" == t || "function" == t);
      }
      function r(e) {
        return !!e && "object" == ("undefined" == typeof e ? "undefined" : c(e));
      }
      function a(e) {
        return "symbol" == ("undefined" == typeof e ? "undefined" : c(e)) || r(e) && k.call(e) == d;
      }
      function u(e) {
        if ("number" == typeof e) return e;
        if (a(e)) return f;
        if (i(e)) {
          var t = "function" == typeof e.valueOf ? e.valueOf() : e;
          e = i(t) ? t + "" : t;
        }
        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(l, "");
        var n = m.test(e);
        return n || b.test(e) ? v(e.slice(2), n ? 2 : 8) : p.test(e) ? f : +e;
      }
      var c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        },
        s = "Expected a function",
        f = NaN,
        d = "[object Symbol]",
        l = /^\s+|\s+$/g,
        p = /^[-+]0x[0-9a-f]+$/i,
        m = /^0b[01]+$/i,
        b = /^0o[0-7]+$/i,
        v = parseInt,
        y = "object" == ("undefined" == typeof t ? "undefined" : c(t)) && t && t.Object === Object && t,
        g = "object" == ("undefined" == typeof self ? "undefined" : c(self)) && self && self.Object === Object && self,
        h = y || g || Function("return this")(),
        w = Object.prototype,
        k = w.toString,
        x = Math.max,
        j = Math.min,
        O = function () {
          return h.Date.now();
        };
      e.exports = o;
    }).call(t, function () {
      return this;
    }());
  }, function (e, t) {
    (function (t) {
      "use strict";

      function n(e, t, n) {
        function i(t) {
          var n = b,
            o = v;
          return b = v = void 0, O = t, g = e.apply(o, n);
        }
        function r(e) {
          return O = e, h = setTimeout(f, t), M ? i(e) : g;
        }
        function u(e) {
          var n = e - w,
            o = e - O,
            i = t - n;
          return S ? x(i, y - o) : i;
        }
        function s(e) {
          var n = e - w,
            o = e - O;
          return void 0 === w || n >= t || n < 0 || S && o >= y;
        }
        function f() {
          var e = j();
          return s(e) ? d(e) : void (h = setTimeout(f, u(e)));
        }
        function d(e) {
          return h = void 0, _ && b ? i(e) : (b = v = void 0, g);
        }
        function l() {
          void 0 !== h && clearTimeout(h), O = 0, b = w = v = h = void 0;
        }
        function p() {
          return void 0 === h ? g : d(j());
        }
        function m() {
          var e = j(),
            n = s(e);
          if (b = arguments, v = this, w = e, n) {
            if (void 0 === h) return r(w);
            if (S) return h = setTimeout(f, t), i(w);
          }
          return void 0 === h && (h = setTimeout(f, t)), g;
        }
        var b,
          v,
          y,
          g,
          h,
          w,
          O = 0,
          M = !1,
          S = !1,
          _ = !0;
        if ("function" != typeof e) throw new TypeError(c);
        return t = a(t) || 0, o(n) && (M = !!n.leading, S = "maxWait" in n, y = S ? k(a(n.maxWait) || 0, t) : y, _ = "trailing" in n ? !!n.trailing : _), m.cancel = l, m.flush = p, m;
      }
      function o(e) {
        var t = "undefined" == typeof e ? "undefined" : u(e);
        return !!e && ("object" == t || "function" == t);
      }
      function i(e) {
        return !!e && "object" == ("undefined" == typeof e ? "undefined" : u(e));
      }
      function r(e) {
        return "symbol" == ("undefined" == typeof e ? "undefined" : u(e)) || i(e) && w.call(e) == f;
      }
      function a(e) {
        if ("number" == typeof e) return e;
        if (r(e)) return s;
        if (o(e)) {
          var t = "function" == typeof e.valueOf ? e.valueOf() : e;
          e = o(t) ? t + "" : t;
        }
        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(d, "");
        var n = p.test(e);
        return n || m.test(e) ? b(e.slice(2), n ? 2 : 8) : l.test(e) ? s : +e;
      }
      var u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        },
        c = "Expected a function",
        s = NaN,
        f = "[object Symbol]",
        d = /^\s+|\s+$/g,
        l = /^[-+]0x[0-9a-f]+$/i,
        p = /^0b[01]+$/i,
        m = /^0o[0-7]+$/i,
        b = parseInt,
        v = "object" == ("undefined" == typeof t ? "undefined" : u(t)) && t && t.Object === Object && t,
        y = "object" == ("undefined" == typeof self ? "undefined" : u(self)) && self && self.Object === Object && self,
        g = v || y || Function("return this")(),
        h = Object.prototype,
        w = h.toString,
        k = Math.max,
        x = Math.min,
        j = function () {
          return g.Date.now();
        };
      e.exports = n;
    }).call(t, function () {
      return this;
    }());
  }, function (e, t) {
    "use strict";

    function n(e) {
      var t = void 0,
        o = void 0,
        i = void 0;
      for (t = 0; t < e.length; t += 1) {
        if (o = e[t], o.dataset && o.dataset.aos) return !0;
        if (i = o.children && n(o.children)) return !0;
      }
      return !1;
    }
    function o() {
      return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    }
    function i() {
      return !!o();
    }
    function r(e, t) {
      var n = window.document,
        i = o(),
        r = new i(a);
      u = t, r.observe(n.documentElement, {
        childList: !0,
        subtree: !0,
        removedNodes: !0
      });
    }
    function a(e) {
      e && e.forEach(function (e) {
        var t = Array.prototype.slice.call(e.addedNodes),
          o = Array.prototype.slice.call(e.removedNodes),
          i = t.concat(o);
        if (n(i)) return u();
      });
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var u = function () {};
    t.default = {
      isSupported: i,
      ready: r
    };
  }, function (e, t) {
    "use strict";

    function n(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function o() {
      return navigator.userAgent || navigator.vendor || window.opera || "";
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var o = t[n];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
          }
        }
        return function (t, n, o) {
          return n && e(t.prototype, n), o && e(t, o), t;
        };
      }(),
      r = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
      a = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
      u = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,
      c = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
      s = function () {
        function e() {
          n(this, e);
        }
        return i(e, [{
          key: "phone",
          value: function () {
            var e = o();
            return !(!r.test(e) && !a.test(e.substr(0, 4)));
          }
        }, {
          key: "mobile",
          value: function () {
            var e = o();
            return !(!u.test(e) && !c.test(e.substr(0, 4)));
          }
        }, {
          key: "tablet",
          value: function () {
            return this.mobile() && !this.phone();
          }
        }]), e;
      }();
    t.default = new s();
  }, function (e, t) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = function (e, t, n) {
        var o = e.node.getAttribute("data-aos-once");
        t > e.position ? e.node.classList.add("aos-animate") : "undefined" != typeof o && ("false" === o || !n && "true" !== o) && e.node.classList.remove("aos-animate");
      },
      o = function (e, t) {
        var o = window.pageYOffset,
          i = window.innerHeight;
        e.forEach(function (e, r) {
          n(e, i + o, t);
        });
      };
    t.default = o;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(12),
      r = o(i),
      a = function (e, t) {
        return e.forEach(function (e, n) {
          e.node.classList.add("aos-init"), e.position = (0, r.default)(e.node, t.offset);
        }), e;
      };
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(13),
      r = o(i),
      a = function (e, t) {
        var n = 0,
          o = 0,
          i = window.innerHeight,
          a = {
            offset: e.getAttribute("data-aos-offset"),
            anchor: e.getAttribute("data-aos-anchor"),
            anchorPlacement: e.getAttribute("data-aos-anchor-placement")
          };
        switch (a.offset && !isNaN(a.offset) && (o = parseInt(a.offset)), a.anchor && document.querySelectorAll(a.anchor) && (e = document.querySelectorAll(a.anchor)[0]), n = (0, r.default)(e).top, a.anchorPlacement) {
          case "top-bottom":
            break;
          case "center-bottom":
            n += e.offsetHeight / 2;
            break;
          case "bottom-bottom":
            n += e.offsetHeight;
            break;
          case "top-center":
            n += i / 2;
            break;
          case "bottom-center":
            n += i / 2 + e.offsetHeight;
            break;
          case "center-center":
            n += i / 2 + e.offsetHeight / 2;
            break;
          case "top-top":
            n += i;
            break;
          case "bottom-top":
            n += e.offsetHeight + i;
            break;
          case "center-top":
            n += e.offsetHeight / 2 + i;
        }
        return a.anchorPlacement || a.offset || isNaN(t) || (o = t), n + o;
      };
    t.default = a;
  }, function (e, t) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = function (e) {
      for (var t = 0, n = 0; e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);) t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0), n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0), e = e.offsetParent;
      return {
        top: n,
        left: t
      };
    };
    t.default = n;
  }, function (e, t) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = function (e) {
      return e = e || document.querySelectorAll("[data-aos]"), Array.prototype.map.call(e, function (e) {
        return {
          node: e
        };
      });
    };
    t.default = n;
  }]);
});

/***/ }),

/***/ 47943:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i];
  revLookup[code.charCodeAt(i)] = i;
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
  var len = b64.length;
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4');
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=');
  if (validLen === -1) validLen = len;
  var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
  return [validLen, placeHoldersLen];
}

// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
  var tmp;
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
  var curByte = 0;

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
  var i;
  for (i = 0; i < len; i += 4) {
    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
    arr[curByte++] = tmp >> 16 & 0xFF;
    arr[curByte++] = tmp >> 8 & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }
  if (placeHoldersLen === 2) {
    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
    arr[curByte++] = tmp & 0xFF;
  }
  if (placeHoldersLen === 1) {
    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
    arr[curByte++] = tmp >> 8 & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }
  return arr;
}
function tripletToBase64(num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
    output.push(tripletToBase64(tmp));
  }
  return output.join('');
}
function fromByteArray(uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
  }
  return parts.join('');
}

/***/ }),

/***/ 4487:
/***/ (function(__unused_webpack_module, exports) {

/* bessel.js (C) 2013-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*exported BESSEL */
var BESSEL;
(function (factory) {
  /*jshint ignore:start */
  if (typeof DO_NOT_EXPORT_BESSEL === 'undefined') {
    if (true) {
      factory(exports);
    } else {}
  } else {
    factory(BESSEL = {});
  }
  /*jshint ignore:end */
})(function (BESSEL) {
  BESSEL.version = '1.0.2';
  var M = Math;
  function _horner(arr, v) {
    for (var i = 0, z = 0; i < arr.length; ++i) z = v * z + arr[i];
    return z;
  }
  function _bessel_iter(x, n, f0, f1, sign) {
    if (n === 0) return f0;
    if (n === 1) return f1;
    var tdx = 2 / x,
      f2 = f1;
    for (var o = 1; o < n; ++o) {
      f2 = f1 * o * tdx + sign * f0;
      f0 = f1;
      f1 = f2;
    }
    return f2;
  }
  function _bessel_wrap(bessel0, bessel1, name, nonzero, sign) {
    return function bessel(x, n) {
      if (nonzero) {
        if (x === 0) return nonzero == 1 ? -Infinity : Infinity;else if (x < 0) return NaN;
      }
      if (n === 0) return bessel0(x);
      if (n === 1) return bessel1(x);
      if (n < 0) return NaN;
      n |= 0;
      var b0 = bessel0(x),
        b1 = bessel1(x);
      return _bessel_iter(x, n, b0, b1, sign);
    };
  }
  var besselj = function () {
    var W = 0.636619772; // 2 / Math.PI

    var b0_a1a = [57568490574.0, -13362590354.0, 651619640.7, -11214424.18, 77392.33017, -184.9052456].reverse();
    var b0_a2a = [57568490411.0, 1029532985.0, 9494680.718, 59272.64853, 267.8532712, 1.0].reverse();
    var b0_a1b = [1.0, -0.1098628627e-2, 0.2734510407e-4, -0.2073370639e-5, 0.2093887211e-6].reverse();
    var b0_a2b = [-0.1562499995e-1, 0.1430488765e-3, -0.6911147651e-5, 0.7621095161e-6, -0.934935152e-7].reverse();
    function bessel0(x) {
      var a = 0,
        a1 = 0,
        a2 = 0,
        y = x * x;
      if (x < 8) {
        a1 = _horner(b0_a1a, y);
        a2 = _horner(b0_a2a, y);
        a = a1 / a2;
      } else {
        var xx = x - 0.785398164;
        y = 64 / y;
        a1 = _horner(b0_a1b, y);
        a2 = _horner(b0_a2b, y);
        a = M.sqrt(W / x) * (M.cos(xx) * a1 - M.sin(xx) * a2 * 8 / x);
      }
      return a;
    }
    var b1_a1a = [72362614232.0, -7895059235.0, 242396853.1, -2972611.439, 15704.48260, -30.16036606].reverse();
    var b1_a2a = [144725228442.0, 2300535178.0, 18583304.74, 99447.43394, 376.9991397, 1.0].reverse();
    var b1_a1b = [1.0, 0.183105e-2, -0.3516396496e-4, 0.2457520174e-5, -0.240337019e-6].reverse();
    var b1_a2b = [0.04687499995, -0.2002690873e-3, 0.8449199096e-5, -0.88228987e-6, 0.105787412e-6].reverse();
    function bessel1(x) {
      var a = 0,
        a1 = 0,
        a2 = 0,
        y = x * x,
        xx = M.abs(x) - 2.356194491;
      if (Math.abs(x) < 8) {
        a1 = x * _horner(b1_a1a, y);
        a2 = _horner(b1_a2a, y);
        a = a1 / a2;
      } else {
        y = 64 / y;
        a1 = _horner(b1_a1b, y);
        a2 = _horner(b1_a2b, y);
        a = M.sqrt(W / M.abs(x)) * (M.cos(xx) * a1 - M.sin(xx) * a2 * 8 / M.abs(x));
        if (x < 0) a = -a;
      }
      return a;
    }
    return function besselj(x, n) {
      n = Math.round(n);
      if (!isFinite(x)) return isNaN(x) ? x : 0;
      if (n < 0) return (n % 2 ? -1 : 1) * besselj(x, -n);
      if (x < 0) return (n % 2 ? -1 : 1) * besselj(-x, n);
      if (n === 0) return bessel0(x);
      if (n === 1) return bessel1(x);
      if (x === 0) return 0;
      var ret = 0.0;
      if (x > n) {
        ret = _bessel_iter(x, n, bessel0(x), bessel1(x), -1);
      } else {
        var m = 2 * M.floor((n + M.floor(M.sqrt(40 * n))) / 2);
        var jsum = false;
        var bjp = 0.0,
          sum = 0.0;
        var bj = 1.0,
          bjm = 0.0;
        var tox = 2 / x;
        for (var j = m; j > 0; j--) {
          bjm = j * tox * bj - bjp;
          bjp = bj;
          bj = bjm;
          if (M.abs(bj) > 1E10) {
            bj *= 1E-10;
            bjp *= 1E-10;
            ret *= 1E-10;
            sum *= 1E-10;
          }
          if (jsum) sum += bj;
          jsum = !jsum;
          if (j == n) ret = bjp;
        }
        sum = 2.0 * sum - bj;
        ret /= sum;
      }
      return ret;
    };
  }();
  var bessely = function () {
    var W = 0.636619772;
    var b0_a1a = [-2957821389.0, 7062834065.0, -512359803.6, 10879881.29, -86327.92757, 228.4622733].reverse();
    var b0_a2a = [40076544269.0, 745249964.8, 7189466.438, 47447.26470, 226.1030244, 1.0].reverse();
    var b0_a1b = [1.0, -0.1098628627e-2, 0.2734510407e-4, -0.2073370639e-5, 0.2093887211e-6].reverse();
    var b0_a2b = [-0.1562499995e-1, 0.1430488765e-3, -0.6911147651e-5, 0.7621095161e-6, -0.934945152e-7].reverse();
    function bessel0(x) {
      var a = 0,
        a1 = 0,
        a2 = 0,
        y = x * x,
        xx = x - 0.785398164;
      if (x < 8) {
        a1 = _horner(b0_a1a, y);
        a2 = _horner(b0_a2a, y);
        a = a1 / a2 + W * besselj(x, 0) * M.log(x);
      } else {
        y = 64 / y;
        a1 = _horner(b0_a1b, y);
        a2 = _horner(b0_a2b, y);
        a = M.sqrt(W / x) * (M.sin(xx) * a1 + M.cos(xx) * a2 * 8 / x);
      }
      return a;
    }
    var b1_a1a = [-0.4900604943e13, 0.1275274390e13, -0.5153438139e11, 0.7349264551e9, -0.4237922726e7, 0.8511937935e4].reverse();
    var b1_a2a = [0.2499580570e14, 0.4244419664e12, 0.3733650367e10, 0.2245904002e8, 0.1020426050e6, 0.3549632885e3, 1].reverse();
    var b1_a1b = [1.0, 0.183105e-2, -0.3516396496e-4, 0.2457520174e-5, -0.240337019e-6].reverse();
    var b1_a2b = [0.04687499995, -0.2002690873e-3, 0.8449199096e-5, -0.88228987e-6, 0.105787412e-6].reverse();
    function bessel1(x) {
      var a = 0,
        a1 = 0,
        a2 = 0,
        y = x * x,
        xx = x - 2.356194491;
      if (x < 8) {
        a1 = x * _horner(b1_a1a, y);
        a2 = _horner(b1_a2a, y);
        a = a1 / a2 + W * (besselj(x, 1) * M.log(x) - 1 / x);
      } else {
        y = 64 / y;
        a1 = _horner(b1_a1b, y);
        a2 = _horner(b1_a2b, y);
        a = M.sqrt(W / x) * (M.sin(xx) * a1 + M.cos(xx) * a2 * 8 / x);
      }
      return a;
    }
    return _bessel_wrap(bessel0, bessel1, 'BESSELY', 1, -1);
  }();
  var besseli = function () {
    var b0_a = [1.0, 3.5156229, 3.0899424, 1.2067492, 0.2659732, 0.360768e-1, 0.45813e-2].reverse();
    var b0_b = [0.39894228, 0.1328592e-1, 0.225319e-2, -0.157565e-2, 0.916281e-2, -0.2057706e-1, 0.2635537e-1, -0.1647633e-1, 0.392377e-2].reverse();
    function bessel0(x) {
      if (x <= 3.75) return _horner(b0_a, x * x / (3.75 * 3.75));
      return M.exp(M.abs(x)) / M.sqrt(M.abs(x)) * _horner(b0_b, 3.75 / M.abs(x));
    }
    var b1_a = [0.5, 0.87890594, 0.51498869, 0.15084934, 0.2658733e-1, 0.301532e-2, 0.32411e-3].reverse();
    var b1_b = [0.39894228, -0.3988024e-1, -0.362018e-2, 0.163801e-2, -0.1031555e-1, 0.2282967e-1, -0.2895312e-1, 0.1787654e-1, -0.420059e-2].reverse();
    function bessel1(x) {
      if (x < 3.75) return x * _horner(b1_a, x * x / (3.75 * 3.75));
      return (x < 0 ? -1 : 1) * M.exp(M.abs(x)) / M.sqrt(M.abs(x)) * _horner(b1_b, 3.75 / M.abs(x));
    }
    return function besseli(x, n) {
      n = Math.round(n);
      if (n === 0) return bessel0(x);
      if (n === 1) return bessel1(x);
      if (n < 0) return NaN;
      if (M.abs(x) === 0) return 0;
      if (x == Infinity) return Infinity;
      var ret = 0.0,
        j,
        tox = 2 / M.abs(x),
        bip = 0.0,
        bi = 1.0,
        bim = 0.0;
      var m = 2 * M.round((n + M.round(M.sqrt(40 * n))) / 2);
      for (j = m; j > 0; j--) {
        bim = j * tox * bi + bip;
        bip = bi;
        bi = bim;
        if (M.abs(bi) > 1E10) {
          bi *= 1E-10;
          bip *= 1E-10;
          ret *= 1E-10;
        }
        if (j == n) ret = bip;
      }
      ret *= besseli(x, 0) / bi;
      return x < 0 && n % 2 ? -ret : ret;
    };
  }();
  var besselk = function () {
    var b0_a = [-0.57721566, 0.42278420, 0.23069756, 0.3488590e-1, 0.262698e-2, 0.10750e-3, 0.74e-5].reverse();
    var b0_b = [1.25331414, -0.7832358e-1, 0.2189568e-1, -0.1062446e-1, 0.587872e-2, -0.251540e-2, 0.53208e-3].reverse();
    function bessel0(x) {
      if (x <= 2) return -M.log(x / 2) * besseli(x, 0) + _horner(b0_a, x * x / 4);
      return M.exp(-x) / M.sqrt(x) * _horner(b0_b, 2 / x);
    }
    var b1_a = [1.0, 0.15443144, -0.67278579, -0.18156897, -0.1919402e-1, -0.110404e-2, -0.4686e-4].reverse();
    var b1_b = [1.25331414, 0.23498619, -0.3655620e-1, 0.1504268e-1, -0.780353e-2, 0.325614e-2, -0.68245e-3].reverse();
    function bessel1(x) {
      if (x <= 2) return M.log(x / 2) * besseli(x, 1) + 1 / x * _horner(b1_a, x * x / 4);
      return M.exp(-x) / M.sqrt(x) * _horner(b1_b, 2 / x);
    }
    return _bessel_wrap(bessel0, bessel1, 'BESSELK', 2, 1);
  }();
  BESSEL.besselj = besselj;
  BESSEL.bessely = bessely;
  BESSEL.besseli = besseli;
  BESSEL.besselk = besselk;
});

/***/ }),

/***/ 80365:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(47943);
var ieee754 = __webpack_require__(48405);
var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
: null;
exports.lW = Buffer;
__webpack_unused_export__ = SlowBuffer;
exports.h2 = 50;
var K_MAX_LENGTH = 0x7fffffff;
__webpack_unused_export__ = K_MAX_LENGTH;

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') {
  console.error('This browser lacks typed array (Uint8Array) support which is required by ' + '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.');
}
function typedArraySupport() {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1);
    var proto = {
      foo: function () {
        return 42;
      }
    };
    Object.setPrototypeOf(proto, Uint8Array.prototype);
    Object.setPrototypeOf(arr, proto);
    return arr.foo() === 42;
  } catch (e) {
    return false;
  }
}
Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined;
    return this.buffer;
  }
});
Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined;
    return this.byteOffset;
  }
});
function createBuffer(length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"');
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length);
  Object.setPrototypeOf(buf, Buffer.prototype);
  return buf;
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer(arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError('The "string" argument must be of type string. Received type number');
    }
    return allocUnsafe(arg);
  }
  return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192; // not used by this implementation

function from(value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset);
  }
  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value);
  }
  if (value == null) {
    throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + typeof value);
  }
  if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
    return fromArrayBuffer(value, encodingOrOffset, length);
  }
  if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length);
  }
  if (typeof value === 'number') {
    throw new TypeError('The "value" argument must not be of type number. Received type number');
  }
  var valueOf = value.valueOf && value.valueOf();
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length);
  }
  var b = fromObject(value);
  if (b) return b;
  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
  }
  throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + typeof value);
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length);
};

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number');
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"');
  }
}
function alloc(size, fill, encoding) {
  assertSize(size);
  if (size <= 0) {
    return createBuffer(size);
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
  }
  return createBuffer(size);
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
  assertSize(size);
  return createBuffer(size < 0 ? 0 : checked(size) | 0);
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size);
};
function fromString(string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8';
  }
  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding);
  }
  var length = byteLength(string, encoding) | 0;
  var buf = createBuffer(length);
  var actual = buf.write(string, encoding);
  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
  }
  return buf;
}
function fromArrayLike(array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0;
  var buf = createBuffer(length);
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255;
  }
  return buf;
}
function fromArrayView(arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView);
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
  }
  return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds');
  }
  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds');
  }
  var buf;
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array);
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset);
  } else {
    buf = new Uint8Array(array, byteOffset, length);
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype);
  return buf;
}
function fromObject(obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0;
    var buf = createBuffer(len);
    if (buf.length === 0) {
      return buf;
    }
    obj.copy(buf, 0, 0, len);
    return buf;
  }
  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0);
    }
    return fromArrayLike(obj);
  }
  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data);
  }
}
function checked(length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes');
  }
  return length | 0;
}
function SlowBuffer(length) {
  if (+length != length) {
    // eslint-disable-line eqeqeq
    length = 0;
  }
  return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
  return b != null && b._isBuffer === true && b !== Buffer.prototype; // so Buffer.isBuffer(Buffer.prototype) will be false
};
Buffer.compare = function compare(a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
  }
  if (a === b) return 0;
  var x = a.length;
  var y = b.length;
  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }
  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true;
    default:
      return false;
  }
};
Buffer.concat = function concat(list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers');
  }
  if (list.length === 0) {
    return Buffer.alloc(0);
  }
  var i;
  if (length === undefined) {
    length = 0;
    for (i = 0; i < list.length; ++i) {
      length += list[i].length;
    }
  }
  var buffer = Buffer.allocUnsafe(length);
  var pos = 0;
  for (i = 0; i < list.length; ++i) {
    var buf = list[i];
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos);
      } else {
        Uint8Array.prototype.set.call(buffer, buf, pos);
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    } else {
      buf.copy(buffer, pos);
    }
    pos += buf.length;
  }
  return buffer;
};
function byteLength(string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length;
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength;
  }
  if (typeof string !== 'string') {
    throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' + 'Received type ' + typeof string);
  }
  var len = string.length;
  var mustMatch = arguments.length > 2 && arguments[2] === true;
  if (!mustMatch && len === 0) return 0;

  // Use a for loop to avoid recursion
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len;
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length;
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2;
      case 'hex':
        return len >>> 1;
      case 'base64':
        return base64ToBytes(string).length;
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
        }
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
  var loweredCase = false;

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0;
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return '';
  }
  if (end === undefined || end > this.length) {
    end = this.length;
  }
  if (end <= 0) {
    return '';
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0;
  start >>>= 0;
  if (end <= start) {
    return '';
  }
  if (!encoding) encoding = 'utf8';
  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end);
      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end);
      case 'ascii':
        return asciiSlice(this, start, end);
      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end);
      case 'base64':
        return base64Slice(this, start, end);
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end);
      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = (encoding + '').toLowerCase();
        loweredCase = true;
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
  var i = b[n];
  b[n] = b[m];
  b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits');
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }
  return this;
};
Buffer.prototype.swap32 = function swap32() {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits');
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }
  return this;
};
Buffer.prototype.swap64 = function swap64() {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits');
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }
  return this;
};
Buffer.prototype.toString = function toString() {
  var length = this.length;
  if (length === 0) return '';
  if (arguments.length === 0) return utf8Slice(this, 0, length);
  return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
  if (this === b) return true;
  return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
  var str = '';
  var max = exports.h2;
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
  if (this.length > max) str += ' ... ';
  return '<Buffer ' + str + '>';
};
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
}
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength);
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. ' + 'Received type ' + typeof target);
  }
  if (start === undefined) {
    start = 0;
  }
  if (end === undefined) {
    end = target ? target.length : 0;
  }
  if (thisStart === undefined) {
    thisStart = 0;
  }
  if (thisEnd === undefined) {
    thisEnd = this.length;
  }
  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index');
  }
  if (thisStart >= thisEnd && start >= end) {
    return 0;
  }
  if (thisStart >= thisEnd) {
    return -1;
  }
  if (start >= end) {
    return 1;
  }
  start >>>= 0;
  end >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;
  if (this === target) return 0;
  var x = thisEnd - thisStart;
  var y = end - start;
  var len = Math.min(x, y);
  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start, end);
  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break;
    }
  }
  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1;

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff;
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000;
  }
  byteOffset = +byteOffset; // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
  if (byteOffset >= buffer.length) {
    if (dir) return -1;else byteOffset = buffer.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;else return -1;
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding);
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1;
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
  } else if (typeof val === 'number') {
    val = val & 0xFF; // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
  }
  throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;
  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase();
    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1;
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }
  function read(buf, i) {
    if (indexSize === 1) {
      return buf[i];
    } else {
      return buf.readUInt16BE(i * indexSize);
    }
  }
  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false;
          break;
        }
      }
      if (found) return i;
    }
  }
  return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
  offset = Number(offset) || 0;
  var remaining = buf.length - offset;
  if (!length) {
    length = remaining;
  } else {
    length = Number(length);
    if (length > remaining) {
      length = remaining;
    }
  }
  var strLen = string.length;
  if (length > strLen / 2) {
    length = strLen / 2;
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16);
    if (numberIsNaN(parsed)) return i;
    buf[offset + i] = parsed;
  }
  return i;
}
function utf8Write(buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8';
    length = this.length;
    offset = 0;
    // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset;
    length = this.length;
    offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0;
    if (isFinite(length)) {
      length = length >>> 0;
      if (encoding === undefined) encoding = 'utf8';
    } else {
      encoding = length;
      length = undefined;
    }
  } else {
    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
  }
  var remaining = this.length - offset;
  if (length === undefined || length > remaining) length = remaining;
  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds');
  }
  if (!encoding) encoding = 'utf8';
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length);
      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length);
      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length);
      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length);
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length);
      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};
Buffer.prototype.toJSON = function toJSON() {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function base64Slice(buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf);
  } else {
    return base64.fromByteArray(buf.slice(start, end));
  }
}
function utf8Slice(buf, start, end) {
  end = Math.min(buf.length, end);
  var res = [];
  var i = start;
  while (i < end) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;
      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte;
          }
          break;
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint;
            }
          }
      }
    }
    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD;
      bytesPerSequence = 1;
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000;
      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }
    res.push(codePoint);
    i += bytesPerSequence;
  }
  return decodeCodePointsArray(res);
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = '';
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
  }
  return res;
}
function asciiSlice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);
  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F);
  }
  return ret;
}
function latin1Slice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);
  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret;
}
function hexSlice(buf, start, end) {
  var len = buf.length;
  if (!start || start < 0) start = 0;
  if (!end || end < 0 || end > len) end = len;
  var out = '';
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]];
  }
  return out;
}
function utf16leSlice(buf, start, end) {
  var bytes = buf.slice(start, end);
  var res = '';
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res;
}
Buffer.prototype.slice = function slice(start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;
  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }
  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }
  if (end < start) end = start;
  var newBuf = this.subarray(start, end);
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype);
  return newBuf;
};

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset(offset, ext, length) {
  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length);
  }
  var val = this[offset + --byteLength];
  var mul = 1;
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul;
  }
  return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 1, this.length);
  return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  mul *= 0x80;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
  return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var i = byteLength;
  var mul = 1;
  var val = this[offset + --i];
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul;
  }
  mul *= 0x80;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
  return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 1, this.length);
  if (!(this[offset] & 0x80)) return this[offset];
  return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset] | this[offset + 1] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset + 1] | this[offset] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }
  var mul = 1;
  var i = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }
  var i = byteLength - 1;
  var mul = 1;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
  this[offset] = value & 0xff;
  return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  this[offset] = value >>> 8;
  this[offset + 1] = value & 0xff;
  return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  this[offset + 3] = value >>> 24;
  this[offset + 2] = value >>> 16;
  this[offset + 1] = value >>> 8;
  this[offset] = value & 0xff;
  return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  this[offset] = value >>> 24;
  this[offset + 1] = value >>> 16;
  this[offset + 2] = value >>> 8;
  this[offset + 3] = value & 0xff;
  return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);
    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }
  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);
    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }
  var i = byteLength - 1;
  var mul = 1;
  var sub = 0;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
  if (value < 0) value = 0xff + value + 1;
  this[offset] = value & 0xff;
  return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  this[offset] = value >>> 8;
  this[offset + 1] = value & 0xff;
  return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  this[offset + 2] = value >>> 16;
  this[offset + 3] = value >>> 24;
  return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (value < 0) value = 0xffffffff + value + 1;
  this[offset] = value >>> 24;
  this[offset + 1] = value >>> 16;
  this[offset + 2] = value >>> 8;
  this[offset + 3] = value & 0xff;
  return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
  if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4);
  return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8);
  return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert);
};

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
  if (!start) start = 0;
  if (!end && end !== 0) end = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end > 0 && end < start) end = start;

  // Copy 0 bytes; we're done
  if (end === start) return 0;
  if (target.length === 0 || this.length === 0) return 0;

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds');
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
  if (end < 0) throw new RangeError('sourceEnd out of bounds');

  // Are we oob?
  if (end > this.length) end = this.length;
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start;
  }
  var len = end - start;
  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
  } else {
    Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
  }
  return len;
};

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start;
      start = 0;
      end = this.length;
    } else if (typeof end === 'string') {
      encoding = end;
      end = this.length;
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string');
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding);
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (encoding === 'utf8' && code < 128 || encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code;
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255;
  } else if (typeof val === 'boolean') {
    val = Number(val);
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index');
  }
  if (end <= start) {
    return this;
  }
  start = start >>> 0;
  end = end === undefined ? this.length : end >>> 0;
  if (!val) val = 0;
  var i;
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
    var len = bytes.length;
    if (len === 0) {
      throw new TypeError('The value "' + val + '" is invalid for argument "value"');
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len];
    }
  }
  return this;
};

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0];
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '');
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return '';
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '=';
  }
  return str;
}
function utf8ToBytes(string, units) {
  units = units || Infinity;
  var codePoint;
  var length = string.length;
  var leadSurrogate = null;
  var bytes = [];
  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i);

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        }

        // valid lead
        leadSurrogate = codePoint;
        continue;
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        leadSurrogate = codePoint;
        continue;
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    }
    leadSurrogate = null;

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break;
      bytes.push(codePoint);
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break;
      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break;
      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break;
      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else {
      throw new Error('Invalid code point');
    }
  }
  return bytes;
}
function asciiToBytes(str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
  }
  return byteArray;
}
function utf16leToBytes(str, units) {
  var c, hi, lo;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break;
    c = str.charCodeAt(i);
    hi = c >> 8;
    lo = c % 256;
    byteArray.push(lo);
    byteArray.push(hi);
  }
  return byteArray;
}
function base64ToBytes(str) {
  return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if (i + offset >= dst.length || i >= src.length) break;
    dst[i + offset] = src[i];
  }
  return i;
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
  return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
  // For IE11 support
  return obj !== obj; // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function () {
  var alphabet = '0123456789abcdef';
  var table = new Array(256);
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16;
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j];
    }
  }
  return table;
}();

/***/ }),

/***/ 90659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(67403);
var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
};
var defaultMessage = "Copy to clipboard: #{key}, Enter";
function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}
function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();
    range = document.createRange();
    selection = document.getSelection();
    mark = document.createElement("span");
    mark.textContent = text;
    // avoid screen readers from reading out loud the text
    mark.ariaHidden = "true";
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function (e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") {
          // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"];
          window.clipboardData.setData(format, text);
        } else {
          // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });
    document.body.appendChild(mark);
    range.selectNodeContents(mark);
    selection.addRange(range);
    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }
    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }
  return success;
}
module.exports = copy;

/***/ }),

/***/ 79555:
/***/ (function(module) {

!function (t, e) {
   true ? module.exports = e() : 0;
}(this, function () {
  "use strict";

  var t = 1e3,
    e = 6e4,
    n = 36e5,
    r = "millisecond",
    i = "second",
    s = "minute",
    u = "hour",
    a = "day",
    o = "week",
    c = "month",
    f = "quarter",
    h = "year",
    d = "date",
    l = "Invalid Date",
    $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
    y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
    M = {
      name: "en",
      weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
      ordinal: function (t) {
        var e = ["th", "st", "nd", "rd"],
          n = t % 100;
        return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
      }
    },
    m = function (t, e, n) {
      var r = String(t);
      return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    },
    v = {
      s: m,
      z: function (t) {
        var e = -t.utcOffset(),
          n = Math.abs(e),
          r = Math.floor(n / 60),
          i = n % 60;
        return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
      },
      m: function t(e, n) {
        if (e.date() < n.date()) return -t(n, e);
        var r = 12 * (n.year() - e.year()) + (n.month() - e.month()),
          i = e.clone().add(r, c),
          s = n - i < 0,
          u = e.clone().add(r + (s ? -1 : 1), c);
        return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
      },
      a: function (t) {
        return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
      },
      p: function (t) {
        return {
          M: c,
          y: h,
          w: o,
          d: a,
          D: d,
          h: u,
          m: s,
          s: i,
          ms: r,
          Q: f
        }[t] || String(t || "").toLowerCase().replace(/s$/, "");
      },
      u: function (t) {
        return void 0 === t;
      }
    },
    g = "en",
    D = {};
  D[g] = M;
  var p = "$isDayjsObject",
    S = function (t) {
      return t instanceof _ || !(!t || !t[p]);
    },
    w = function t(e, n, r) {
      var i;
      if (!e) return g;
      if ("string" == typeof e) {
        var s = e.toLowerCase();
        D[s] && (i = s), n && (D[s] = n, i = s);
        var u = e.split("-");
        if (!i && u.length > 1) return t(u[0]);
      } else {
        var a = e.name;
        D[a] = e, i = a;
      }
      return !r && i && (g = i), i || !r && g;
    },
    O = function (t, e) {
      if (S(t)) return t.clone();
      var n = "object" == typeof e ? e : {};
      return n.date = t, n.args = arguments, new _(n);
    },
    b = v;
  b.l = w, b.i = S, b.w = function (t, e) {
    return O(t, {
      locale: e.$L,
      utc: e.$u,
      x: e.$x,
      $offset: e.$offset
    });
  };
  var _ = function () {
      function M(t) {
        this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
      }
      var m = M.prototype;
      return m.parse = function (t) {
        this.$d = function (t) {
          var e = t.date,
            n = t.utc;
          if (null === e) return new Date(NaN);
          if (b.u(e)) return new Date();
          if (e instanceof Date) return new Date(e);
          if ("string" == typeof e && !/Z$/i.test(e)) {
            var r = e.match($);
            if (r) {
              var i = r[2] - 1 || 0,
                s = (r[7] || "0").substring(0, 3);
              return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
            }
          }
          return new Date(e);
        }(t), this.init();
      }, m.init = function () {
        var t = this.$d;
        this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
      }, m.$utils = function () {
        return b;
      }, m.isValid = function () {
        return !(this.$d.toString() === l);
      }, m.isSame = function (t, e) {
        var n = O(t);
        return this.startOf(e) <= n && n <= this.endOf(e);
      }, m.isAfter = function (t, e) {
        return O(t) < this.startOf(e);
      }, m.isBefore = function (t, e) {
        return this.endOf(e) < O(t);
      }, m.$g = function (t, e, n) {
        return b.u(t) ? this[e] : this.set(n, t);
      }, m.unix = function () {
        return Math.floor(this.valueOf() / 1e3);
      }, m.valueOf = function () {
        return this.$d.getTime();
      }, m.startOf = function (t, e) {
        var n = this,
          r = !!b.u(e) || e,
          f = b.p(t),
          l = function (t, e) {
            var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
            return r ? i : i.endOf(a);
          },
          $ = function (t, e) {
            return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e)), n);
          },
          y = this.$W,
          M = this.$M,
          m = this.$D,
          v = "set" + (this.$u ? "UTC" : "");
        switch (f) {
          case h:
            return r ? l(1, 0) : l(31, 11);
          case c:
            return r ? l(1, M) : l(0, M + 1);
          case o:
            var g = this.$locale().weekStart || 0,
              D = (y < g ? y + 7 : y) - g;
            return l(r ? m - D : m + (6 - D), M);
          case a:
          case d:
            return $(v + "Hours", 0);
          case u:
            return $(v + "Minutes", 1);
          case s:
            return $(v + "Seconds", 2);
          case i:
            return $(v + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, m.endOf = function (t) {
        return this.startOf(t, !1);
      }, m.$set = function (t, e) {
        var n,
          o = b.p(t),
          f = "set" + (this.$u ? "UTC" : ""),
          l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o],
          $ = o === a ? this.$D + (e - this.$W) : e;
        if (o === c || o === h) {
          var y = this.clone().set(d, 1);
          y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
        } else l && this.$d[l]($);
        return this.init(), this;
      }, m.set = function (t, e) {
        return this.clone().$set(t, e);
      }, m.get = function (t) {
        return this[b.p(t)]();
      }, m.add = function (r, f) {
        var d,
          l = this;
        r = Number(r);
        var $ = b.p(f),
          y = function (t) {
            var e = O(l);
            return b.w(e.date(e.date() + Math.round(t * r)), l);
          };
        if ($ === c) return this.set(c, this.$M + r);
        if ($ === h) return this.set(h, this.$y + r);
        if ($ === a) return y(1);
        if ($ === o) return y(7);
        var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1,
          m = this.$d.getTime() + r * M;
        return b.w(m, this);
      }, m.subtract = function (t, e) {
        return this.add(-1 * t, e);
      }, m.format = function (t) {
        var e = this,
          n = this.$locale();
        if (!this.isValid()) return n.invalidDate || l;
        var r = t || "YYYY-MM-DDTHH:mm:ssZ",
          i = b.z(this),
          s = this.$H,
          u = this.$m,
          a = this.$M,
          o = n.weekdays,
          c = n.months,
          f = n.meridiem,
          h = function (t, n, i, s) {
            return t && (t[n] || t(e, r)) || i[n].slice(0, s);
          },
          d = function (t) {
            return b.s(s % 12 || 12, t, "0");
          },
          $ = f || function (t, e, n) {
            var r = t < 12 ? "AM" : "PM";
            return n ? r.toLowerCase() : r;
          };
        return r.replace(y, function (t, r) {
          return r || function (t) {
            switch (t) {
              case "YY":
                return String(e.$y).slice(-2);
              case "YYYY":
                return b.s(e.$y, 4, "0");
              case "M":
                return a + 1;
              case "MM":
                return b.s(a + 1, 2, "0");
              case "MMM":
                return h(n.monthsShort, a, c, 3);
              case "MMMM":
                return h(c, a);
              case "D":
                return e.$D;
              case "DD":
                return b.s(e.$D, 2, "0");
              case "d":
                return String(e.$W);
              case "dd":
                return h(n.weekdaysMin, e.$W, o, 2);
              case "ddd":
                return h(n.weekdaysShort, e.$W, o, 3);
              case "dddd":
                return o[e.$W];
              case "H":
                return String(s);
              case "HH":
                return b.s(s, 2, "0");
              case "h":
                return d(1);
              case "hh":
                return d(2);
              case "a":
                return $(s, u, !0);
              case "A":
                return $(s, u, !1);
              case "m":
                return String(u);
              case "mm":
                return b.s(u, 2, "0");
              case "s":
                return String(e.$s);
              case "ss":
                return b.s(e.$s, 2, "0");
              case "SSS":
                return b.s(e.$ms, 3, "0");
              case "Z":
                return i;
            }
            return null;
          }(t) || i.replace(":", "");
        });
      }, m.utcOffset = function () {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m.diff = function (r, d, l) {
        var $,
          y = this,
          M = b.p(d),
          m = O(r),
          v = (m.utcOffset() - this.utcOffset()) * e,
          g = this - m,
          D = function () {
            return b.m(y, m);
          };
        switch (M) {
          case h:
            $ = D() / 12;
            break;
          case c:
            $ = D();
            break;
          case f:
            $ = D() / 3;
            break;
          case o:
            $ = (g - v) / 6048e5;
            break;
          case a:
            $ = (g - v) / 864e5;
            break;
          case u:
            $ = g / n;
            break;
          case s:
            $ = g / e;
            break;
          case i:
            $ = g / t;
            break;
          default:
            $ = g;
        }
        return l ? $ : b.a($);
      }, m.daysInMonth = function () {
        return this.endOf(c).$D;
      }, m.$locale = function () {
        return D[this.$L];
      }, m.locale = function (t, e) {
        if (!t) return this.$L;
        var n = this.clone(),
          r = w(t, e, !0);
        return r && (n.$L = r), n;
      }, m.clone = function () {
        return b.w(this.$d, this);
      }, m.toDate = function () {
        return new Date(this.valueOf());
      }, m.toJSON = function () {
        return this.isValid() ? this.toISOString() : null;
      }, m.toISOString = function () {
        return this.$d.toISOString();
      }, m.toString = function () {
        return this.$d.toUTCString();
      }, M;
    }(),
    k = _.prototype;
  return O.prototype = k, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", c], ["$y", h], ["$D", d]].forEach(function (t) {
    k[t[1]] = function (e) {
      return this.$g(e, t[0], t[1]);
    };
  }), O.extend = function (t, e) {
    return t.$i || (t(e, _, O), t.$i = !0), O;
  }, O.locale = w, O.isDayjs = S, O.unix = function (t) {
    return O(1e3 * t);
  }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

/***/ }),

/***/ 60524:
/***/ (function(module) {

!function (e, t) {
   true ? module.exports = t() : 0;
}(this, function () {
  "use strict";

  return function (e, t) {
    var r = t.prototype,
      n = r.format;
    r.format = function (e) {
      var t = this,
        r = this.$locale();
      if (!this.isValid()) return n.bind(this)(e);
      var s = this.$utils(),
        a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function (e) {
          switch (e) {
            case "Q":
              return Math.ceil((t.$M + 1) / 3);
            case "Do":
              return r.ordinal(t.$D);
            case "gggg":
              return t.weekYear();
            case "GGGG":
              return t.isoWeekYear();
            case "wo":
              return r.ordinal(t.week(), "W");
            case "w":
            case "ww":
              return s.s(t.week(), "w" === e ? 1 : 2, "0");
            case "W":
            case "WW":
              return s.s(t.isoWeek(), "W" === e ? 1 : 2, "0");
            case "k":
            case "kk":
              return s.s(String(0 === t.$H ? 24 : t.$H), "k" === e ? 1 : 2, "0");
            case "X":
              return Math.floor(t.$d.getTime() / 1e3);
            case "x":
              return t.$d.getTime();
            case "z":
              return "[" + t.offsetName() + "]";
            case "zzz":
              return "[" + t.offsetName("long") + "]";
            default:
              return e;
          }
        });
      return n.bind(this)(a);
    };
  };
});

/***/ }),

/***/ 25943:
/***/ (function(module) {

!function (e, t) {
   true ? module.exports = t() : 0;
}(this, function () {
  "use strict";

  var e = {
      LTS: "h:mm:ss A",
      LT: "h:mm A",
      L: "MM/DD/YYYY",
      LL: "MMMM D, YYYY",
      LLL: "MMMM D, YYYY h:mm A",
      LLLL: "dddd, MMMM D, YYYY h:mm A"
    },
    t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,
    n = /\d/,
    r = /\d\d/,
    i = /\d\d?/,
    o = /\d*[^-_:/,()\s\d]+/,
    s = {},
    a = function (e) {
      return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
  var f = function (e) {
      return function (t) {
        this[e] = +t;
      };
    },
    h = [/[+-]\d\d:?(\d\d)?|Z/, function (e) {
      (this.zone || (this.zone = {})).offset = function (e) {
        if (!e) return 0;
        if ("Z" === e) return 0;
        var t = e.match(/([+-]|\d\d)/g),
          n = 60 * t[1] + (+t[2] || 0);
        return 0 === n ? 0 : "+" === t[0] ? -n : n;
      }(e);
    }],
    u = function (e) {
      var t = s[e];
      return t && (t.indexOf ? t : t.s.concat(t.f));
    },
    d = function (e, t) {
      var n,
        r = s.meridiem;
      if (r) {
        for (var i = 1; i <= 24; i += 1) if (e.indexOf(r(i, 0, t)) > -1) {
          n = i > 12;
          break;
        }
      } else n = e === (t ? "pm" : "PM");
      return n;
    },
    c = {
      A: [o, function (e) {
        this.afternoon = d(e, !1);
      }],
      a: [o, function (e) {
        this.afternoon = d(e, !0);
      }],
      Q: [n, function (e) {
        this.month = 3 * (e - 1) + 1;
      }],
      S: [n, function (e) {
        this.milliseconds = 100 * +e;
      }],
      SS: [r, function (e) {
        this.milliseconds = 10 * +e;
      }],
      SSS: [/\d{3}/, function (e) {
        this.milliseconds = +e;
      }],
      s: [i, f("seconds")],
      ss: [i, f("seconds")],
      m: [i, f("minutes")],
      mm: [i, f("minutes")],
      H: [i, f("hours")],
      h: [i, f("hours")],
      HH: [i, f("hours")],
      hh: [i, f("hours")],
      D: [i, f("day")],
      DD: [r, f("day")],
      Do: [o, function (e) {
        var t = s.ordinal,
          n = e.match(/\d+/);
        if (this.day = n[0], t) for (var r = 1; r <= 31; r += 1) t(r).replace(/\[|\]/g, "") === e && (this.day = r);
      }],
      w: [i, f("week")],
      ww: [r, f("week")],
      M: [i, f("month")],
      MM: [r, f("month")],
      MMM: [o, function (e) {
        var t = u("months"),
          n = (u("monthsShort") || t.map(function (e) {
            return e.slice(0, 3);
          })).indexOf(e) + 1;
        if (n < 1) throw new Error();
        this.month = n % 12 || n;
      }],
      MMMM: [o, function (e) {
        var t = u("months").indexOf(e) + 1;
        if (t < 1) throw new Error();
        this.month = t % 12 || t;
      }],
      Y: [/[+-]?\d+/, f("year")],
      YY: [r, function (e) {
        this.year = a(e);
      }],
      YYYY: [/\d{4}/, f("year")],
      Z: h,
      ZZ: h
    };
  function l(n) {
    var r, i;
    r = n, i = s && s.formats;
    for (var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function (t, n, r) {
        var o = r && r.toUpperCase();
        return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function (e, t, n) {
          return t || n.slice(1);
        });
      })).match(t), a = o.length, f = 0; f < a; f += 1) {
      var h = o[f],
        u = c[h],
        d = u && u[0],
        l = u && u[1];
      o[f] = l ? {
        regex: d,
        parser: l
      } : h.replace(/^\[|\]$/g, "");
    }
    return function (e) {
      for (var t = {}, n = 0, r = 0; n < a; n += 1) {
        var i = o[n];
        if ("string" == typeof i) r += i.length;else {
          var s = i.regex,
            f = i.parser,
            h = e.slice(r),
            u = s.exec(h)[0];
          f.call(t, u), e = e.replace(u, "");
        }
      }
      return function (e) {
        var t = e.afternoon;
        if (void 0 !== t) {
          var n = e.hours;
          t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
        }
      }(t), t;
    };
  }
  return function (e, t, n) {
    n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
    var r = t.prototype,
      i = r.parse;
    r.parse = function (e) {
      var t = e.date,
        r = e.utc,
        o = e.args;
      this.$u = r;
      var a = o[1];
      if ("string" == typeof a) {
        var f = !0 === o[2],
          h = !0 === o[3],
          u = f || h,
          d = o[2];
        h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function (e, t, n, r) {
          try {
            if (["x", "X"].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
            var i = l(t)(e),
              o = i.year,
              s = i.month,
              a = i.day,
              f = i.hours,
              h = i.minutes,
              u = i.seconds,
              d = i.milliseconds,
              c = i.zone,
              m = i.week,
              M = new Date(),
              Y = a || (o || s ? 1 : M.getDate()),
              p = o || M.getFullYear(),
              v = 0;
            o && !s || (v = s > 0 ? s - 1 : M.getMonth());
            var D,
              w = f || 0,
              g = h || 0,
              y = u || 0,
              L = d || 0;
            return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
          } catch (e) {
            return new Date("");
          }
        }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
      } else if (a instanceof Array) for (var c = a.length, m = 1; m <= c; m += 1) {
        o[1] = a[m - 1];
        var M = n.apply(this, o);
        if (M.isValid()) {
          this.$d = M.$d, this.$L = M.$L, this.init();
          break;
        }
        m === c && (this.$d = new Date(""));
      } else i.call(this, e);
    };
  };
});

/***/ }),

/***/ 81807:
/***/ (function(module) {

!function (e, i) {
   true ? module.exports = i() : 0;
}(this, function () {
  "use strict";

  return function (e, i, t) {
    i.prototype.isBetween = function (e, i, s, f) {
      var n = t(e),
        o = t(i),
        r = "(" === (f = f || "()")[0],
        u = ")" === f[1];
      return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
    };
  };
});

/***/ }),

/***/ 89486:
/***/ (function(module) {

!function (e, t) {
   true ? module.exports = t() : 0;
}(this, function () {
  "use strict";

  var e = "day";
  return function (t, i, s) {
    var a = function (t) {
        return t.add(4 - t.isoWeekday(), e);
      },
      d = i.prototype;
    d.isoWeekYear = function () {
      return a(this).year();
    }, d.isoWeek = function (t) {
      if (!this.$utils().u(t)) return this.add(7 * (t - this.isoWeek()), e);
      var i,
        d,
        n,
        o,
        r = a(this),
        u = (i = this.isoWeekYear(), d = this.$u, n = (d ? s.utc : s)().year(i).startOf("year"), o = 4 - n.isoWeekday(), n.isoWeekday() > 4 && (o += 7), n.add(o, e));
      return r.diff(u, "week") + 1;
    }, d.isoWeekday = function (e) {
      return this.$utils().u(e) ? this.day() || 7 : this.day(this.day() % 7 ? e : e - 7);
    };
    var n = d.startOf;
    d.startOf = function (e, t) {
      var i = this.$utils(),
        s = !!i.u(t) || t;
      return "isoweek" === i.p(e) ? s ? this.date(this.date() - (this.isoWeekday() - 1)).startOf("day") : this.date(this.date() - 1 - (this.isoWeekday() - 1) + 7).endOf("day") : n.bind(this)(e, t);
    };
  };
});

/***/ }),

/***/ 55860:
/***/ (function(module) {

!function (n, e) {
   true ? module.exports = e() : 0;
}(this, function () {
  "use strict";

  return function (n, e, t) {
    var r = e.prototype,
      o = function (n) {
        return n && (n.indexOf ? n : n.s);
      },
      u = function (n, e, t, r, u) {
        var i = n.name ? n : n.$locale(),
          a = o(i[e]),
          s = o(i[t]),
          f = a || s.map(function (n) {
            return n.slice(0, r);
          });
        if (!u) return f;
        var d = i.weekStart;
        return f.map(function (n, e) {
          return f[(e + (d || 0)) % 7];
        });
      },
      i = function () {
        return t.Ls[t.locale()];
      },
      a = function (n, e) {
        return n.formats[e] || function (n) {
          return n.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function (n, e, t) {
            return e || t.slice(1);
          });
        }(n.formats[e.toUpperCase()]);
      },
      s = function () {
        var n = this;
        return {
          months: function (e) {
            return e ? e.format("MMMM") : u(n, "months");
          },
          monthsShort: function (e) {
            return e ? e.format("MMM") : u(n, "monthsShort", "months", 3);
          },
          firstDayOfWeek: function () {
            return n.$locale().weekStart || 0;
          },
          weekdays: function (e) {
            return e ? e.format("dddd") : u(n, "weekdays");
          },
          weekdaysMin: function (e) {
            return e ? e.format("dd") : u(n, "weekdaysMin", "weekdays", 2);
          },
          weekdaysShort: function (e) {
            return e ? e.format("ddd") : u(n, "weekdaysShort", "weekdays", 3);
          },
          longDateFormat: function (e) {
            return a(n.$locale(), e);
          },
          meridiem: this.$locale().meridiem,
          ordinal: this.$locale().ordinal
        };
      };
    r.localeData = function () {
      return s.bind(this)();
    }, t.localeData = function () {
      var n = i();
      return {
        firstDayOfWeek: function () {
          return n.weekStart || 0;
        },
        weekdays: function () {
          return t.weekdays();
        },
        weekdaysShort: function () {
          return t.weekdaysShort();
        },
        weekdaysMin: function () {
          return t.weekdaysMin();
        },
        months: function () {
          return t.months();
        },
        monthsShort: function () {
          return t.monthsShort();
        },
        longDateFormat: function (e) {
          return a(n, e);
        },
        meridiem: n.meridiem,
        ordinal: n.ordinal
      };
    }, t.months = function () {
      return u(i(), "months");
    }, t.monthsShort = function () {
      return u(i(), "monthsShort", "months", 3);
    }, t.weekdays = function (n) {
      return u(i(), "weekdays", null, null, n);
    }, t.weekdaysShort = function (n) {
      return u(i(), "weekdaysShort", "weekdays", 3, n);
    }, t.weekdaysMin = function (n) {
      return u(i(), "weekdaysMin", "weekdays", 2, n);
    };
  };
});

/***/ }),

/***/ 16510:
/***/ (function(module) {

!function (e, n) {
   true ? module.exports = n() : 0;
}(this, function () {
  "use strict";

  return function (e, n, t) {
    t.updateLocale = function (e, n) {
      var o = t.Ls[e];
      if (o) return (n ? Object.keys(n) : []).forEach(function (e) {
        o[e] = n[e];
      }), o;
    };
  };
});

/***/ }),

/***/ 62911:
/***/ (function(module) {

!function (t, i) {
   true ? module.exports = i() : 0;
}(this, function () {
  "use strict";

  var t = "minute",
    i = /[+-]\d\d(?::?\d\d)?/g,
    e = /([+-]|\d\d)/g;
  return function (s, f, n) {
    var u = f.prototype;
    n.utc = function (t) {
      var i = {
        date: t,
        utc: !0,
        args: arguments
      };
      return new f(i);
    }, u.utc = function (i) {
      var e = n(this.toDate(), {
        locale: this.$L,
        utc: !0
      });
      return i ? e.add(this.utcOffset(), t) : e;
    }, u.local = function () {
      return n(this.toDate(), {
        locale: this.$L,
        utc: !1
      });
    };
    var o = u.parse;
    u.parse = function (t) {
      t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
    };
    var r = u.init;
    u.init = function () {
      if (this.$u) {
        var t = this.$d;
        this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
      } else r.call(this);
    };
    var a = u.utcOffset;
    u.utcOffset = function (s, f) {
      var n = this.$utils().u;
      if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
      if ("string" == typeof s && (s = function (t) {
        void 0 === t && (t = "");
        var s = t.match(i);
        if (!s) return null;
        var f = ("" + s[0]).match(e) || ["-", 0, 0],
          n = f[0],
          u = 60 * +f[1] + +f[2];
        return 0 === u ? 0 : "+" === n ? u : -u;
      }(s), null === s)) return this;
      var u = Math.abs(s) <= 16 ? 60 * s : s,
        o = this;
      if (f) return o.$offset = u, o.$u = 0 === s, o;
      if (0 !== s) {
        var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
        (o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
      } else o = this.utc();
      return o;
    };
    var h = u.format;
    u.format = function (t) {
      var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
      return h.call(this, i);
    }, u.valueOf = function () {
      var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
      return this.$d.valueOf() - 6e4 * t;
    }, u.isUTC = function () {
      return !!this.$u;
    }, u.toISOString = function () {
      return this.toDate().toISOString();
    }, u.toString = function () {
      return this.toDate().toUTCString();
    };
    var l = u.toDate;
    u.toDate = function (t) {
      return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
    };
    var c = u.diff;
    u.diff = function (t, i, e) {
      if (t && this.$u === t.$u) return c.call(this, t, i, e);
      var s = this.local(),
        f = n(t).local();
      return c.call(s, f, i, e);
    };
  };
});

/***/ }),

/***/ 98242:
/***/ (function(module) {

!function (e, t) {
   true ? module.exports = t() : 0;
}(this, function () {
  "use strict";

  var e = "week",
    t = "year";
  return function (i, n, r) {
    var f = n.prototype;
    f.week = function (i) {
      if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
      var n = this.$locale().yearStart || 1;
      if (11 === this.month() && this.date() > 25) {
        var f = r(this).startOf(t).add(1, t).date(n),
          s = r(this).endOf(e);
        if (f.isBefore(s)) return 1;
      }
      var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"),
        o = this.diff(a, e, !0);
      return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
    }, f.weeks = function (e) {
      return void 0 === e && (e = null), this.week(e);
    };
  };
});

/***/ }),

/***/ 45953:
/***/ (function(module) {

!function (e, t) {
   true ? module.exports = t() : 0;
}(this, function () {
  "use strict";

  return function (e, t) {
    t.prototype.weekYear = function () {
      var e = this.month(),
        t = this.week(),
        n = this.year();
      return 1 === t && 11 === e ? n + 1 : 0 === e && t >= 52 ? n - 1 : n;
    };
  };
});

/***/ }),

/***/ 91884:
/***/ (function(module) {

!function (e, t) {
   true ? module.exports = t() : 0;
}(this, function () {
  "use strict";

  return function (e, t) {
    t.prototype.weekday = function (e) {
      var t = this.$locale().weekStart || 0,
        i = this.$W,
        n = (i < t ? i + 7 : i) - t;
      return this.$utils().u(e) ? n : this.subtract(n, "day").add(e, "day");
    };
  };
});

/***/ }),

/***/ 26124:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
/** Types of elements found in htmlparser2's DOM */
var ElementType;
(function (ElementType) {
  /** Type for the root element of a document */
  ElementType["Root"] = "root";
  /** Type for Text */
  ElementType["Text"] = "text";
  /** Type for <? ... ?> */
  ElementType["Directive"] = "directive";
  /** Type for <!-- ... --> */
  ElementType["Comment"] = "comment";
  /** Type for <script> tags */
  ElementType["Script"] = "script";
  /** Type for <style> tags */
  ElementType["Style"] = "style";
  /** Type for Any tag */
  ElementType["Tag"] = "tag";
  /** Type for <![CDATA[ ... ]]> */
  ElementType["CDATA"] = "cdata";
  /** Type for <!doctype ...> */
  ElementType["Doctype"] = "doctype";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */
function isTag(elem) {
  return elem.type === ElementType.Tag || elem.type === ElementType.Script || elem.type === ElementType.Style;
}
exports.isTag = isTag;
// Exports for backwards compatibility
/** Type for the root element of a document */
exports.Root = ElementType.Root;
/** Type for Text */
exports.Text = ElementType.Text;
/** Type for <? ... ?> */
exports.Directive = ElementType.Directive;
/** Type for <!-- ... --> */
exports.Comment = ElementType.Comment;
/** Type for <script> tags */
exports.Script = ElementType.Script;
/** Type for <style> tags */
exports.Style = ElementType.Style;
/** Type for Any tag */
exports.Tag = ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */
exports.CDATA = ElementType.CDATA;
/** Type for <!doctype ...> */
exports.Doctype = ElementType.Doctype;

/***/ }),

/***/ 41303:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.DomHandler = void 0;
var domelementtype_1 = __webpack_require__(26124);
var node_js_1 = __webpack_require__(68377);
__exportStar(__webpack_require__(68377), exports);
// Default options
var defaultOpts = {
  withStartIndices: false,
  withEndIndices: false,
  xmlMode: false
};
var DomHandler = /** @class */function () {
  /**
   * @param callback Called once parsing has completed.
   * @param options Settings for the handler.
   * @param elementCB Callback whenever a tag is closed.
   */
  function DomHandler(callback, options, elementCB) {
    /** The elements of the DOM */
    this.dom = [];
    /** The root element for the DOM */
    this.root = new node_js_1.Document(this.dom);
    /** Indicated whether parsing has been completed. */
    this.done = false;
    /** Stack of open tags. */
    this.tagStack = [this.root];
    /** A data node that is still being written to. */
    this.lastNode = null;
    /** Reference to the parser instance. Used for location information. */
    this.parser = null;
    // Make it possible to skip arguments, for backwards-compatibility
    if (typeof options === "function") {
      elementCB = options;
      options = defaultOpts;
    }
    if (typeof callback === "object") {
      options = callback;
      callback = undefined;
    }
    this.callback = callback !== null && callback !== void 0 ? callback : null;
    this.options = options !== null && options !== void 0 ? options : defaultOpts;
    this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
  }
  DomHandler.prototype.onparserinit = function (parser) {
    this.parser = parser;
  };
  // Resets the handler back to starting state
  DomHandler.prototype.onreset = function () {
    this.dom = [];
    this.root = new node_js_1.Document(this.dom);
    this.done = false;
    this.tagStack = [this.root];
    this.lastNode = null;
    this.parser = null;
  };
  // Signals the handler that parsing is done
  DomHandler.prototype.onend = function () {
    if (this.done) return;
    this.done = true;
    this.parser = null;
    this.handleCallback(null);
  };
  DomHandler.prototype.onerror = function (error) {
    this.handleCallback(error);
  };
  DomHandler.prototype.onclosetag = function () {
    this.lastNode = null;
    var elem = this.tagStack.pop();
    if (this.options.withEndIndices) {
      elem.endIndex = this.parser.endIndex;
    }
    if (this.elementCB) this.elementCB(elem);
  };
  DomHandler.prototype.onopentag = function (name, attribs) {
    var type = this.options.xmlMode ? domelementtype_1.ElementType.Tag : undefined;
    var element = new node_js_1.Element(name, attribs, undefined, type);
    this.addNode(element);
    this.tagStack.push(element);
  };
  DomHandler.prototype.ontext = function (data) {
    var lastNode = this.lastNode;
    if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
      lastNode.data += data;
      if (this.options.withEndIndices) {
        lastNode.endIndex = this.parser.endIndex;
      }
    } else {
      var node = new node_js_1.Text(data);
      this.addNode(node);
      this.lastNode = node;
    }
  };
  DomHandler.prototype.oncomment = function (data) {
    if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
      this.lastNode.data += data;
      return;
    }
    var node = new node_js_1.Comment(data);
    this.addNode(node);
    this.lastNode = node;
  };
  DomHandler.prototype.oncommentend = function () {
    this.lastNode = null;
  };
  DomHandler.prototype.oncdatastart = function () {
    var text = new node_js_1.Text("");
    var node = new node_js_1.CDATA([text]);
    this.addNode(node);
    text.parent = node;
    this.lastNode = text;
  };
  DomHandler.prototype.oncdataend = function () {
    this.lastNode = null;
  };
  DomHandler.prototype.onprocessinginstruction = function (name, data) {
    var node = new node_js_1.ProcessingInstruction(name, data);
    this.addNode(node);
  };
  DomHandler.prototype.handleCallback = function (error) {
    if (typeof this.callback === "function") {
      this.callback(error, this.dom);
    } else if (error) {
      throw error;
    }
  };
  DomHandler.prototype.addNode = function (node) {
    var parent = this.tagStack[this.tagStack.length - 1];
    var previousSibling = parent.children[parent.children.length - 1];
    if (this.options.withStartIndices) {
      node.startIndex = this.parser.startIndex;
    }
    if (this.options.withEndIndices) {
      node.endIndex = this.parser.endIndex;
    }
    parent.children.push(node);
    if (previousSibling) {
      node.prev = previousSibling;
      previousSibling.next = node;
    }
    node.parent = parent;
    this.lastNode = null;
  };
  return DomHandler;
}();
exports.DomHandler = DomHandler;
exports["default"] = DomHandler;

/***/ }),

/***/ 68377:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.cloneNode = exports.hasChildren = exports.isDocument = exports.isDirective = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = exports.Element = exports.Document = exports.CDATA = exports.NodeWithChildren = exports.ProcessingInstruction = exports.Comment = exports.Text = exports.DataNode = exports.Node = void 0;
var domelementtype_1 = __webpack_require__(26124);
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */
var Node = /** @class */function () {
  function Node() {
    /** Parent of the node */
    this.parent = null;
    /** Previous sibling */
    this.prev = null;
    /** Next sibling */
    this.next = null;
    /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
    this.startIndex = null;
    /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
    this.endIndex = null;
  }
  Object.defineProperty(Node.prototype, "parentNode", {
    // Read-write aliases for properties
    /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
    get: function () {
      return this.parent;
    },
    set: function (parent) {
      this.parent = parent;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "previousSibling", {
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
    get: function () {
      return this.prev;
    },
    set: function (prev) {
      this.prev = prev;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "nextSibling", {
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
    get: function () {
      return this.next;
    },
    set: function (next) {
      this.next = next;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Clone this node, and optionally its children.
   *
   * @param recursive Clone child nodes as well.
   * @returns A clone of the node.
   */
  Node.prototype.cloneNode = function (recursive) {
    if (recursive === void 0) {
      recursive = false;
    }
    return cloneNode(this, recursive);
  };
  return Node;
}();
exports.Node = Node;
/**
 * A node that contains some data.
 */
var DataNode = /** @class */function (_super) {
  __extends(DataNode, _super);
  /**
   * @param data The content of the data node
   */
  function DataNode(data) {
    var _this = _super.call(this) || this;
    _this.data = data;
    return _this;
  }
  Object.defineProperty(DataNode.prototype, "nodeValue", {
    /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
    get: function () {
      return this.data;
    },
    set: function (data) {
      this.data = data;
    },
    enumerable: false,
    configurable: true
  });
  return DataNode;
}(Node);
exports.DataNode = DataNode;
/**
 * Text within the document.
 */
var Text = /** @class */function (_super) {
  __extends(Text, _super);
  function Text() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.type = domelementtype_1.ElementType.Text;
    return _this;
  }
  Object.defineProperty(Text.prototype, "nodeType", {
    get: function () {
      return 3;
    },
    enumerable: false,
    configurable: true
  });
  return Text;
}(DataNode);
exports.Text = Text;
/**
 * Comments within the document.
 */
var Comment = /** @class */function (_super) {
  __extends(Comment, _super);
  function Comment() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.type = domelementtype_1.ElementType.Comment;
    return _this;
  }
  Object.defineProperty(Comment.prototype, "nodeType", {
    get: function () {
      return 8;
    },
    enumerable: false,
    configurable: true
  });
  return Comment;
}(DataNode);
exports.Comment = Comment;
/**
 * Processing instructions, including doc types.
 */
var ProcessingInstruction = /** @class */function (_super) {
  __extends(ProcessingInstruction, _super);
  function ProcessingInstruction(name, data) {
    var _this = _super.call(this, data) || this;
    _this.name = name;
    _this.type = domelementtype_1.ElementType.Directive;
    return _this;
  }
  Object.defineProperty(ProcessingInstruction.prototype, "nodeType", {
    get: function () {
      return 1;
    },
    enumerable: false,
    configurable: true
  });
  return ProcessingInstruction;
}(DataNode);
exports.ProcessingInstruction = ProcessingInstruction;
/**
 * A `Node` that can have children.
 */
var NodeWithChildren = /** @class */function (_super) {
  __extends(NodeWithChildren, _super);
  /**
   * @param children Children of the node. Only certain node types can have children.
   */
  function NodeWithChildren(children) {
    var _this = _super.call(this) || this;
    _this.children = children;
    return _this;
  }
  Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
    // Aliases
    /** First child of the node. */
    get: function () {
      var _a;
      return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
    /** Last child of the node. */
    get: function () {
      return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
    get: function () {
      return this.children;
    },
    set: function (children) {
      this.children = children;
    },
    enumerable: false,
    configurable: true
  });
  return NodeWithChildren;
}(Node);
exports.NodeWithChildren = NodeWithChildren;
var CDATA = /** @class */function (_super) {
  __extends(CDATA, _super);
  function CDATA() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.type = domelementtype_1.ElementType.CDATA;
    return _this;
  }
  Object.defineProperty(CDATA.prototype, "nodeType", {
    get: function () {
      return 4;
    },
    enumerable: false,
    configurable: true
  });
  return CDATA;
}(NodeWithChildren);
exports.CDATA = CDATA;
/**
 * The root node of the document.
 */
var Document = /** @class */function (_super) {
  __extends(Document, _super);
  function Document() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.type = domelementtype_1.ElementType.Root;
    return _this;
  }
  Object.defineProperty(Document.prototype, "nodeType", {
    get: function () {
      return 9;
    },
    enumerable: false,
    configurable: true
  });
  return Document;
}(NodeWithChildren);
exports.Document = Document;
/**
 * An element within the DOM.
 */
var Element = /** @class */function (_super) {
  __extends(Element, _super);
  /**
   * @param name Name of the tag, eg. `div`, `span`.
   * @param attribs Object mapping attribute names to attribute values.
   * @param children Children of the node.
   */
  function Element(name, attribs, children, type) {
    if (children === void 0) {
      children = [];
    }
    if (type === void 0) {
      type = name === "script" ? domelementtype_1.ElementType.Script : name === "style" ? domelementtype_1.ElementType.Style : domelementtype_1.ElementType.Tag;
    }
    var _this = _super.call(this, children) || this;
    _this.name = name;
    _this.attribs = attribs;
    _this.type = type;
    return _this;
  }
  Object.defineProperty(Element.prototype, "nodeType", {
    get: function () {
      return 1;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Element.prototype, "tagName", {
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
    get: function () {
      return this.name;
    },
    set: function (name) {
      this.name = name;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Element.prototype, "attributes", {
    get: function () {
      var _this = this;
      return Object.keys(this.attribs).map(function (name) {
        var _a, _b;
        return {
          name: name,
          value: _this.attribs[name],
          namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
          prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
        };
      });
    },
    enumerable: false,
    configurable: true
  });
  return Element;
}(NodeWithChildren);
exports.Element = Element;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */
function isTag(node) {
  return (0, domelementtype_1.isTag)(node);
}
exports.isTag = isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */
function isCDATA(node) {
  return node.type === domelementtype_1.ElementType.CDATA;
}
exports.isCDATA = isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */
function isText(node) {
  return node.type === domelementtype_1.ElementType.Text;
}
exports.isText = isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */
function isComment(node) {
  return node.type === domelementtype_1.ElementType.Comment;
}
exports.isComment = isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDirective(node) {
  return node.type === domelementtype_1.ElementType.Directive;
}
exports.isDirective = isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDocument(node) {
  return node.type === domelementtype_1.ElementType.Root;
}
exports.isDocument = isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node has children, `false` otherwise.
 */
function hasChildren(node) {
  return Object.prototype.hasOwnProperty.call(node, "children");
}
exports.hasChildren = hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */
function cloneNode(node, recursive) {
  if (recursive === void 0) {
    recursive = false;
  }
  var result;
  if (isText(node)) {
    result = new Text(node.data);
  } else if (isComment(node)) {
    result = new Comment(node.data);
  } else if (isTag(node)) {
    var children = recursive ? cloneChildren(node.children) : [];
    var clone_1 = new Element(node.name, __assign({}, node.attribs), children);
    children.forEach(function (child) {
      return child.parent = clone_1;
    });
    if (node.namespace != null) {
      clone_1.namespace = node.namespace;
    }
    if (node["x-attribsNamespace"]) {
      clone_1["x-attribsNamespace"] = __assign({}, node["x-attribsNamespace"]);
    }
    if (node["x-attribsPrefix"]) {
      clone_1["x-attribsPrefix"] = __assign({}, node["x-attribsPrefix"]);
    }
    result = clone_1;
  } else if (isCDATA(node)) {
    var children = recursive ? cloneChildren(node.children) : [];
    var clone_2 = new CDATA(children);
    children.forEach(function (child) {
      return child.parent = clone_2;
    });
    result = clone_2;
  } else if (isDocument(node)) {
    var children = recursive ? cloneChildren(node.children) : [];
    var clone_3 = new Document(children);
    children.forEach(function (child) {
      return child.parent = clone_3;
    });
    if (node["x-mode"]) {
      clone_3["x-mode"] = node["x-mode"];
    }
    result = clone_3;
  } else if (isDirective(node)) {
    var instruction = new ProcessingInstruction(node.name, node.data);
    if (node["x-name"] != null) {
      instruction["x-name"] = node["x-name"];
      instruction["x-publicId"] = node["x-publicId"];
      instruction["x-systemId"] = node["x-systemId"];
    }
    result = instruction;
  } else {
    throw new Error("Not implemented yet: ".concat(node.type));
  }
  result.startIndex = node.startIndex;
  result.endIndex = node.endIndex;
  if (node.sourceCodeLocation != null) {
    result.sourceCodeLocation = node.sourceCodeLocation;
  }
  return result;
}
exports.cloneNode = cloneNode;
function cloneChildren(childs) {
  var children = childs.map(function (child) {
    return cloneNode(child, true);
  });
  for (var i = 1; i < children.length; i++) {
    children[i].prev = children[i - 1];
    children[i - 1].next = children[i];
  }
  return children;
}

/***/ }),

/***/ 89483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(58740);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above

  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);
      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }
    var keys = getOwnPropertyNames(sourceComponent);
    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }
    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);
    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];
      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }
  return targetComponent;
}
module.exports = hoistNonReactStatics;

/***/ }),

/***/ 76949:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CARRIAGE_RETURN_PLACEHOLDER_REGEX = exports.CARRIAGE_RETURN_PLACEHOLDER = exports.CARRIAGE_RETURN_REGEX = exports.CARRIAGE_RETURN = exports.CASE_SENSITIVE_TAG_NAMES_MAP = exports.CASE_SENSITIVE_TAG_NAMES = void 0;
/**
 * SVG elements are case-sensitive.
 *
 * @see https://developer.mozilla.org/docs/Web/SVG/Element#svg_elements_a_to_z
 */
exports.CASE_SENSITIVE_TAG_NAMES = ['animateMotion', 'animateTransform', 'clipPath', 'feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDropShadow', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'foreignObject', 'linearGradient', 'radialGradient', 'textPath'];
exports.CASE_SENSITIVE_TAG_NAMES_MAP = exports.CASE_SENSITIVE_TAG_NAMES.reduce(function (accumulator, tagName) {
  accumulator[tagName.toLowerCase()] = tagName;
  return accumulator;
}, {});
exports.CARRIAGE_RETURN = '\r';
exports.CARRIAGE_RETURN_REGEX = new RegExp(exports.CARRIAGE_RETURN, 'g');
exports.CARRIAGE_RETURN_PLACEHOLDER = "__HTML_DOM_PARSER_CARRIAGE_RETURN_PLACEHOLDER_".concat(Date.now(), "__");
exports.CARRIAGE_RETURN_PLACEHOLDER_REGEX = new RegExp(exports.CARRIAGE_RETURN_PLACEHOLDER, 'g');

/***/ }),

/***/ 37028:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = domparser;
var utilities_1 = __webpack_require__(98794);
// constants
var HTML = 'html';
var HEAD = 'head';
var BODY = 'body';
var FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
// match-all-characters in case of newlines (DOTALL)
var HEAD_TAG_REGEX = /<head[^]*>/i;
var BODY_TAG_REGEX = /<body[^]*>/i;
// falls back to `parseFromString` if `createHTMLDocument` cannot be used
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var parseFromDocument = function (html, tagName) {
  /* istanbul ignore next */
  throw new Error('This browser does not support `document.implementation.createHTMLDocument`');
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var parseFromString = function (html, tagName) {
  /* istanbul ignore next */
  throw new Error('This browser does not support `DOMParser.prototype.parseFromString`');
};
var DOMParser = typeof window === 'object' && window.DOMParser;
/**
 * DOMParser (performance: slow).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
 */
if (typeof DOMParser === 'function') {
  var domParser_1 = new DOMParser();
  var mimeType_1 = 'text/html';
  /**
   * Creates an HTML document using `DOMParser.parseFromString`.
   *
   * @param html - The HTML string.
   * @param tagName - The element to render the HTML (with 'body' as fallback).
   * @returns - Document.
   */
  parseFromString = function (html, tagName) {
    if (tagName) {
      /* istanbul ignore next */
      html = "<".concat(tagName, ">").concat(html, "</").concat(tagName, ">");
    }
    return domParser_1.parseFromString(html, mimeType_1);
  };
  parseFromDocument = parseFromString;
}
/**
 * DOMImplementation (performance: fair).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
 */
if (typeof document === 'object' && document.implementation) {
  var htmlDocument_1 = document.implementation.createHTMLDocument();
  /**
   * Use HTML document created by `document.implementation.createHTMLDocument`.
   *
   * @param html - The HTML string.
   * @param tagName - The element to render the HTML (with 'body' as fallback).
   * @returns - Document
   */
  parseFromDocument = function (html, tagName) {
    if (tagName) {
      var element = htmlDocument_1.documentElement.querySelector(tagName);
      if (element) {
        element.innerHTML = html;
      }
      return htmlDocument_1;
    }
    htmlDocument_1.documentElement.innerHTML = html;
    return htmlDocument_1;
  };
}
/**
 * Template (performance: fast).
 *
 * @see https://developer.mozilla.org/docs/Web/HTML/Element/template
 */
var template = typeof document === 'object' && document.createElement('template');
var parseFromTemplate;
if (template && template.content) {
  /**
   * Uses a template element (content fragment) to parse HTML.
   *
   * @param html - HTML string.
   * @returns - Nodes.
   */
  parseFromTemplate = function (html) {
    template.innerHTML = html;
    return template.content.childNodes;
  };
}
/**
 * Parses HTML string to DOM nodes.
 *
 * @param html - HTML markup.
 * @returns - DOM nodes.
 */
function domparser(html) {
  var _a, _b;
  // Escape special characters before parsing
  html = (0, utilities_1.escapeSpecialCharacters)(html);
  var match = html.match(FIRST_TAG_REGEX);
  var firstTagName = match && match[1] ? match[1].toLowerCase() : '';
  switch (firstTagName) {
    case HTML:
      {
        var doc = parseFromString(html);
        // the created document may come with filler head/body elements,
        // so make sure to remove them if they don't actually exist
        if (!HEAD_TAG_REGEX.test(html)) {
          var element = doc.querySelector(HEAD);
          (_a = element === null || element === void 0 ? void 0 : element.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(element);
        }
        if (!BODY_TAG_REGEX.test(html)) {
          var element = doc.querySelector(BODY);
          (_b = element === null || element === void 0 ? void 0 : element.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(element);
        }
        return doc.querySelectorAll(HTML);
      }
    case HEAD:
    case BODY:
      {
        var elements = parseFromDocument(html).querySelectorAll(firstTagName);
        // if there's a sibling element, then return both elements
        if (BODY_TAG_REGEX.test(html) && HEAD_TAG_REGEX.test(html)) {
          return elements[0].parentNode.childNodes;
        }
        return elements;
      }
    // low-level tag or text
    default:
      {
        if (parseFromTemplate) {
          return parseFromTemplate(html);
        }
        var element = parseFromDocument(html, BODY).querySelector(BODY);
        return element.childNodes;
      }
  }
}

/***/ }),

/***/ 17233:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = HTMLDOMParser;
var domparser_1 = __importDefault(__webpack_require__(37028));
var utilities_1 = __webpack_require__(98794);
var DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>
/**
 * Parses HTML string to DOM nodes in browser.
 *
 * @param html - HTML markup.
 * @returns - DOM elements.
 */
function HTMLDOMParser(html) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }
  if (!html) {
    return [];
  }
  // match directive
  var match = html.match(DIRECTIVE_REGEX);
  var directive = match ? match[1] : undefined;
  return (0, utilities_1.formatDOM)((0, domparser_1.default)(html), null, directive);
}

/***/ }),

/***/ 98794:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.formatAttributes = formatAttributes;
exports.escapeSpecialCharacters = escapeSpecialCharacters;
exports.revertEscapedCharacters = revertEscapedCharacters;
exports.formatDOM = formatDOM;
var domhandler_1 = __webpack_require__(41303);
var constants_1 = __webpack_require__(76949);
/**
 * Gets case-sensitive tag name.
 *
 * @param tagName - Tag name in lowercase.
 * @returns - Case-sensitive tag name.
 */
function getCaseSensitiveTagName(tagName) {
  return constants_1.CASE_SENSITIVE_TAG_NAMES_MAP[tagName];
}
/**
 * Formats DOM attributes to a hash map.
 *
 * @param attributes - List of attributes.
 * @returns - Map of attribute name to value.
 */
function formatAttributes(attributes) {
  var map = {};
  var index = 0;
  var attributesLength = attributes.length;
  // `NamedNodeMap` is array-like
  for (; index < attributesLength; index++) {
    var attribute = attributes[index];
    map[attribute.name] = attribute.value;
  }
  return map;
}
/**
 * Corrects the tag name if it is case-sensitive (SVG).
 * Otherwise, returns the lowercase tag name (HTML).
 *
 * @param tagName - Lowercase tag name.
 * @returns - Formatted tag name.
 */
function formatTagName(tagName) {
  tagName = tagName.toLowerCase();
  var caseSensitiveTagName = getCaseSensitiveTagName(tagName);
  if (caseSensitiveTagName) {
    return caseSensitiveTagName;
  }
  return tagName;
}
/**
 * Escapes special characters before parsing.
 *
 * @param html - The HTML string.
 * @returns - HTML string with escaped special characters.
 */
function escapeSpecialCharacters(html) {
  return html.replace(constants_1.CARRIAGE_RETURN_REGEX, constants_1.CARRIAGE_RETURN_PLACEHOLDER);
}
/**
 * Reverts escaped special characters back to actual characters.
 *
 * @param text - The text with escaped characters.
 * @returns - Text with escaped characters reverted.
 */
function revertEscapedCharacters(text) {
  return text.replace(constants_1.CARRIAGE_RETURN_PLACEHOLDER_REGEX, constants_1.CARRIAGE_RETURN);
}
/**
 * Transforms DOM nodes to `domhandler` nodes.
 *
 * @param nodes - DOM nodes.
 * @param parent - Parent node.
 * @param directive - Directive.
 * @returns - Nodes.
 */
function formatDOM(nodes, parent, directive) {
  if (parent === void 0) {
    parent = null;
  }
  var domNodes = [];
  var current;
  var index = 0;
  var nodesLength = nodes.length;
  for (; index < nodesLength; index++) {
    var node = nodes[index];
    // set the node data given the type
    switch (node.nodeType) {
      case 1:
        {
          var tagName = formatTagName(node.nodeName);
          // script, style, or tag
          current = new domhandler_1.Element(tagName, formatAttributes(node.attributes));
          current.children = formatDOM(
          // template children are on content
          tagName === 'template' ? node.content.childNodes : node.childNodes, current);
          break;
        }
      case 3:
        current = new domhandler_1.Text(revertEscapedCharacters(node.nodeValue));
        break;
      case 8:
        current = new domhandler_1.Comment(node.nodeValue);
        break;
      default:
        continue;
    }
    // set previous node next
    var prev = domNodes[index - 1] || null;
    if (prev) {
      prev.next = current;
    }
    // set properties for current node
    current.parent = parent;
    current.prev = prev;
    current.next = null;
    domNodes.push(current);
  }
  if (directive) {
    current = new domhandler_1.ProcessingInstruction(directive.substring(0, directive.indexOf(' ')).toLowerCase(), directive);
    current.next = domNodes[0] || null;
    current.parent = parent;
    domNodes.unshift(current);
    if (domNodes[1]) {
      domNodes[1].prev = domNodes[0];
    }
  }
  return domNodes;
}

/***/ }),

/***/ 56414:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = attributesToProps;
var react_property_1 = __webpack_require__(74762);
var utilities_1 = __webpack_require__(27241);
// https://react.dev/learn/sharing-state-between-components#controlled-and-uncontrolled-components
// https://developer.mozilla.org/docs/Web/HTML/Attributes
var UNCONTROLLED_COMPONENT_ATTRIBUTES = ['checked', 'value'];
var UNCONTROLLED_COMPONENT_NAMES = ['input', 'select', 'textarea'];
var valueOnlyInputs = {
  reset: true,
  submit: true
};
/**
 * Converts HTML/SVG DOM attributes to React props.
 *
 * @param attributes - HTML/SVG DOM attributes.
 * @param nodeName - DOM node name.
 * @returns - React props.
 */
function attributesToProps(attributes, nodeName) {
  if (attributes === void 0) {
    attributes = {};
  }
  var props = {};
  var isInputValueOnly = Boolean(attributes.type && valueOnlyInputs[attributes.type]);
  for (var attributeName in attributes) {
    var attributeValue = attributes[attributeName];
    // ARIA (aria-*) or custom data (data-*) attribute
    if ((0, react_property_1.isCustomAttribute)(attributeName)) {
      props[attributeName] = attributeValue;
      continue;
    }
    // convert HTML/SVG attribute to React prop
    var attributeNameLowerCased = attributeName.toLowerCase();
    var propName = getPropName(attributeNameLowerCased);
    if (propName) {
      var propertyInfo = (0, react_property_1.getPropertyInfo)(propName);
      // convert attribute to uncontrolled component prop (e.g., `value` to `defaultValue`)
      if (UNCONTROLLED_COMPONENT_ATTRIBUTES.includes(propName) && UNCONTROLLED_COMPONENT_NAMES.includes(nodeName) && !isInputValueOnly) {
        propName = getPropName('default' + attributeNameLowerCased);
      }
      props[propName] = attributeValue;
      switch (propertyInfo && propertyInfo.type) {
        case react_property_1.BOOLEAN:
          props[propName] = true;
          break;
        case react_property_1.OVERLOADED_BOOLEAN:
          if (attributeValue === '') {
            props[propName] = true;
          }
          break;
      }
      continue;
    }
    // preserve custom attribute if React >=16
    if (utilities_1.PRESERVE_CUSTOM_ATTRIBUTES) {
      props[attributeName] = attributeValue;
    }
  }
  // transform inline style to object
  (0, utilities_1.setStyleProp)(attributes.style, props);
  return props;
}
/**
 * Gets prop name from lowercased attribute name.
 *
 * @param attributeName - Lowercased attribute name.
 * @returns - Prop name.
 */
function getPropName(attributeName) {
  return react_property_1.possibleStandardNames[attributeName];
}

/***/ }),

/***/ 54916:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = domToReact;
var react_1 = __webpack_require__(82684);
var attributes_to_props_1 = __importDefault(__webpack_require__(56414));
var utilities_1 = __webpack_require__(27241);
var React = {
  cloneElement: react_1.cloneElement,
  createElement: react_1.createElement,
  isValidElement: react_1.isValidElement
};
/**
 * Converts DOM nodes to JSX element(s).
 *
 * @param nodes - DOM nodes.
 * @param options - Options.
 * @returns - String or JSX element(s).
 */
function domToReact(nodes, options) {
  if (options === void 0) {
    options = {};
  }
  var reactElements = [];
  var hasReplace = typeof options.replace === 'function';
  var transform = options.transform || utilities_1.returnFirstArg;
  var _a = options.library || React,
    cloneElement = _a.cloneElement,
    createElement = _a.createElement,
    isValidElement = _a.isValidElement;
  var nodesLength = nodes.length;
  for (var index = 0; index < nodesLength; index++) {
    var node = nodes[index];
    // replace with custom React element (if present)
    if (hasReplace) {
      var replaceElement = options.replace(node, index);
      if (isValidElement(replaceElement)) {
        // set "key" prop for sibling elements
        // https://react.dev/learn/rendering-lists#rules-of-keys
        if (nodesLength > 1) {
          replaceElement = cloneElement(replaceElement, {
            key: replaceElement.key || index
          });
        }
        reactElements.push(transform(replaceElement, node, index));
        continue;
      }
    }
    if (node.type === 'text') {
      var isWhitespace = !node.data.trim().length;
      // We have a whitespace node that can't be nested in its parent
      // so skip it
      if (isWhitespace && node.parent && !(0, utilities_1.canTextBeChildOfNode)(node.parent)) {
        continue;
      }
      // Trim is enabled and we have a whitespace node
      // so skip it
      if (options.trim && isWhitespace) {
        continue;
      }
      // We have a text node that's not whitespace and it can be nested
      // in its parent so add it to the results
      reactElements.push(transform(node.data, node, index));
      continue;
    }
    var element = node;
    var props = {};
    if (skipAttributesToProps(element)) {
      (0, utilities_1.setStyleProp)(element.attribs.style, element.attribs);
      props = element.attribs;
    } else if (element.attribs) {
      props = (0, attributes_to_props_1.default)(element.attribs, element.name);
    }
    var children = void 0;
    switch (node.type) {
      case 'script':
      case 'style':
        // prevent text in <script> or <style> from being escaped
        // https://react.dev/reference/react-dom/components/common#dangerously-setting-the-inner-html
        if (node.children[0]) {
          props.dangerouslySetInnerHTML = {
            __html: node.children[0].data
          };
        }
        break;
      case 'tag':
        // setting textarea value in children is an antipattern in React
        // https://react.dev/reference/react-dom/components/textarea#caveats
        if (node.name === 'textarea' && node.children[0]) {
          props.defaultValue = node.children[0].data;
        } else if (node.children && node.children.length) {
          // continue recursion of creating React elements (if applicable)
          children = domToReact(node.children, options);
        }
        break;
      // skip all other cases (e.g., comment)
      default:
        continue;
    }
    // set "key" prop for sibling elements
    // https://react.dev/learn/rendering-lists#rules-of-keys
    if (nodesLength > 1) {
      props.key = index;
    }
    reactElements.push(transform(createElement(node.name, props, children), node, index));
  }
  return reactElements.length === 1 ? reactElements[0] : reactElements;
}
/**
 * Determines whether DOM element attributes should be transformed to props.
 * Web Components should not have their attributes transformed except for `style`.
 *
 * @param node - Element node.
 * @returns - Whether the node attributes should be converted to props.
 */
function skipAttributesToProps(node) {
  return utilities_1.PRESERVE_CUSTOM_ATTRIBUTES && node.type === 'tag' && (0, utilities_1.isCustomComponent)(node.name, node.attribs);
}

/***/ }),

/***/ 2110:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.htmlToDOM = exports.domToReact = exports.attributesToProps = exports.Text = exports.ProcessingInstruction = exports.Element = exports.Comment = void 0;
exports["default"] = HTMLReactParser;
var html_dom_parser_1 = __importDefault(__webpack_require__(17233));
exports.htmlToDOM = html_dom_parser_1.default;
var attributes_to_props_1 = __importDefault(__webpack_require__(56414));
exports.attributesToProps = attributes_to_props_1.default;
var dom_to_react_1 = __importDefault(__webpack_require__(54916));
exports.domToReact = dom_to_react_1.default;
var domhandler_1 = __webpack_require__(41303);
Object.defineProperty(exports, "Comment", ({
  enumerable: true,
  get: function () {
    return domhandler_1.Comment;
  }
}));
Object.defineProperty(exports, "Element", ({
  enumerable: true,
  get: function () {
    return domhandler_1.Element;
  }
}));
Object.defineProperty(exports, "ProcessingInstruction", ({
  enumerable: true,
  get: function () {
    return domhandler_1.ProcessingInstruction;
  }
}));
Object.defineProperty(exports, "Text", ({
  enumerable: true,
  get: function () {
    return domhandler_1.Text;
  }
}));
var domParserOptions = {
  lowerCaseAttributeNames: false
};
/**
 * Converts HTML string to React elements.
 *
 * @param html - HTML string.
 * @param options - Parser options.
 * @returns - React element(s), empty array, or string.
 */
function HTMLReactParser(html, options) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }
  if (!html) {
    return [];
  }
  return (0, dom_to_react_1.default)((0, html_dom_parser_1.default)(html, (options === null || options === void 0 ? void 0 : options.htmlparser2) || domParserOptions), options);
}

/***/ }),

/***/ 27241:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.returnFirstArg = exports.canTextBeChildOfNode = exports.ELEMENTS_WITH_NO_TEXT_CHILDREN = exports.PRESERVE_CUSTOM_ATTRIBUTES = void 0;
exports.isCustomComponent = isCustomComponent;
exports.setStyleProp = setStyleProp;
var react_1 = __webpack_require__(82684);
var style_to_js_1 = __importDefault(__webpack_require__(36764));
var RESERVED_SVG_MATHML_ELEMENTS = new Set(['annotation-xml', 'color-profile', 'font-face', 'font-face-src', 'font-face-uri', 'font-face-format', 'font-face-name', 'missing-glyph']);
/**
 * Check if a tag is a custom component.
 *
 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
 *
 * @param tagName - Tag name.
 * @param props - Props passed to the element.
 * @returns - Whether the tag is custom component.
 */
function isCustomComponent(tagName, props) {
  if (!tagName.includes('-')) {
    return Boolean(props && typeof props.is === 'string');
  }
  // These are reserved SVG and MathML elements.
  // We don't mind this whitelist too much because we expect it to never grow.
  // The alternative is to track the namespace in a few places which is convoluted.
  // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
  if (RESERVED_SVG_MATHML_ELEMENTS.has(tagName)) {
    return false;
  }
  return true;
}
var styleOptions = {
  reactCompat: true
};
/**
 * Sets style prop.
 *
 * @param style - Inline style.
 * @param props - Props object.
 */
function setStyleProp(style, props) {
  if (typeof style !== 'string') {
    return;
  }
  if (!style.trim()) {
    props.style = {};
    return;
  }
  try {
    props.style = (0, style_to_js_1.default)(style, styleOptions);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    props.style = {};
  }
}
/**
 * @see https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html
 */
exports.PRESERVE_CUSTOM_ATTRIBUTES = Number(react_1.version.split('.')[0]) >= 16;
/**
 * @see https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react-dom/src/client/validateDOMNesting.js#L213
 */
exports.ELEMENTS_WITH_NO_TEXT_CHILDREN = new Set(['tr', 'tbody', 'thead', 'tfoot', 'colgroup', 'table', 'head', 'html', 'frameset']);
/**
 * Checks if the given node can contain text nodes
 *
 * @param node - Element node.
 * @returns - Whether the node can contain text nodes.
 */
var canTextBeChildOfNode = function (node) {
  return !exports.ELEMENTS_WITH_NO_TEXT_CHILDREN.has(node.name);
};
exports.canTextBeChildOfNode = canTextBeChildOfNode;
/**
 * Returns the first argument as is.
 *
 * @param arg - The argument to be returned.
 * @returns - The input argument `arg`.
 */
var returnFirstArg = function (arg) {
  return arg;
}; // eslint-disable-line @typescript-eslint/no-explicit-any
exports.returnFirstArg = returnFirstArg;

/***/ }),

/***/ 48405:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s = buffer[offset + i];
  i += d;
  e = s & (1 << -nBits) - 1;
  s >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : (s ? -1 : 1) * Infinity;
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  value = Math.abs(value);
  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
  buffer[offset + i - d] |= s * 128;
};

/***/ }),

/***/ 8751:
/***/ (function(module) {

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;

// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;

// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';

// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';

/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */
module.exports = function (style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }
  if (!style) return [];
  options = options || {};

  /**
   * Positional.
   */
  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */
  function position() {
    var start = {
      line: lineno,
      column: column
    };
    return function (node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */
  function Position(start) {
    this.start = start;
    this.end = {
      line: lineno,
      column: column
    };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string.
   */
  Position.prototype.content = style;
  var errorsList = [];

  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */
  function error(msg) {
    var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;
    if (options.silent) {
      errorsList.push(err);
    } else {
      throw err;
    }
  }

  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */
  function whitespace() {
    match(WHITESPACE_REGEX);
  }

  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */
  function comments(rules) {
    var c;
    rules = rules || [];
    while (c = comment()) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;
    var i = 2;
    while (EMPTY_STRING != style.charAt(i) && (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))) {
      ++i;
    }
    i += 2;
    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }
    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;
    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }

  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */
  function declaration() {
    var pos = position();

    // prop
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();

    // :
    if (!match(COLON_REGEX)) return error("property missing ':'");

    // val
    var val = match(VALUE_REGEX);
    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING)) : EMPTY_STRING
    });

    // ;
    match(SEMICOLON_REGEX);
    return ret;
  }

  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */
  function declarations() {
    var decls = [];
    comments(decls);

    // declarations
    var decl;
    while (decl = declaration()) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }
    return decls;
  }
  whitespace();
  return declarations();
};

/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}

/***/ }),

/***/ 31701:
/***/ (function(module) {

"use strict";


module.exports = value => {
  if (Object.prototype.toString.call(value) !== '[object Object]') {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return prototype === null || prototype === Object.prototype;
};

/***/ }),

/***/ 47097:
/***/ (function(module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(554);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.11.1
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2025
 * @license MIT
 */
/*jslint bitwise: true */
(function () {
  'use strict';

  var ERROR = 'input is invalid type';
  var WINDOW = typeof window === 'object';
  var root = WINDOW ? window : {};
  if (root.JS_SHA256_NO_WINDOW) {
    WINDOW = false;
  }
  var WEB_WORKER = !WINDOW && typeof self === 'object';
  var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node && process.type != 'renderer';
  if (NODE_JS) {
    root = __webpack_require__.g;
  } else if (WEB_WORKER) {
    root = self;
  }
  var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && "object" === 'object' && module.exports;
  var AMD =  true && __webpack_require__.amdO;
  var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
  var HEX_CHARS = '0123456789abcdef'.split('');
  var EXTRA = [-2147483648, 8388608, 32768, 128];
  var SHIFT = [24, 16, 8, 0];
  var K = [0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2];
  var OUTPUT_TYPES = ['hex', 'array', 'digest', 'arrayBuffer'];
  var blocks = [];
  if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) {
    Array.isArray = function (obj) {
      return Object.prototype.toString.call(obj) === '[object Array]';
    };
  }
  if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
    ArrayBuffer.isView = function (obj) {
      return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
  }
  var createOutputMethod = function (outputType, is224) {
    return function (message) {
      return new Sha256(is224, true).update(message)[outputType]();
    };
  };
  var createMethod = function (is224) {
    var method = createOutputMethod('hex', is224);
    if (NODE_JS) {
      method = nodeWrap(method, is224);
    }
    method.create = function () {
      return new Sha256(is224);
    };
    method.update = function (message) {
      return method.create().update(message);
    };
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createOutputMethod(type, is224);
    }
    return method;
  };
  var nodeWrap = function (method, is224) {
    var crypto = __webpack_require__(96127);
    var Buffer = (__webpack_require__(51371).Buffer);
    var algorithm = is224 ? 'sha224' : 'sha256';
    var bufferFrom;
    if (Buffer.from && !root.JS_SHA256_NO_BUFFER_FROM) {
      bufferFrom = Buffer.from;
    } else {
      bufferFrom = function (message) {
        return new Buffer(message);
      };
    }
    var nodeMethod = function (message) {
      if (typeof message === 'string') {
        return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
      } else {
        if (message === null || message === undefined) {
          throw new Error(ERROR);
        } else if (message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        }
      }
      if (Array.isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer) {
        return crypto.createHash(algorithm).update(bufferFrom(message)).digest('hex');
      } else {
        return method(message);
      }
    };
    return nodeMethod;
  };
  var createHmacOutputMethod = function (outputType, is224) {
    return function (key, message) {
      return new HmacSha256(key, is224, true).update(message)[outputType]();
    };
  };
  var createHmacMethod = function (is224) {
    var method = createHmacOutputMethod('hex', is224);
    method.create = function (key) {
      return new HmacSha256(key, is224);
    };
    method.update = function (key, message) {
      return method.create(key).update(message);
    };
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createHmacOutputMethod(type, is224);
    }
    return method;
  };
  function Sha256(is224, sharedMemory) {
    if (sharedMemory) {
      blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      this.blocks = blocks;
    } else {
      this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    }
    if (is224) {
      this.h0 = 0xc1059ed8;
      this.h1 = 0x367cd507;
      this.h2 = 0x3070dd17;
      this.h3 = 0xf70e5939;
      this.h4 = 0xffc00b31;
      this.h5 = 0x68581511;
      this.h6 = 0x64f98fa7;
      this.h7 = 0xbefa4fa4;
    } else {
      // 256
      this.h0 = 0x6a09e667;
      this.h1 = 0xbb67ae85;
      this.h2 = 0x3c6ef372;
      this.h3 = 0xa54ff53a;
      this.h4 = 0x510e527f;
      this.h5 = 0x9b05688c;
      this.h6 = 0x1f83d9ab;
      this.h7 = 0x5be0cd19;
    }
    this.block = this.start = this.bytes = this.hBytes = 0;
    this.finalized = this.hashed = false;
    this.first = true;
    this.is224 = is224;
  }
  Sha256.prototype.update = function (message) {
    if (this.finalized) {
      return;
    }
    var notString,
      type = typeof message;
    if (type !== 'string') {
      if (type === 'object') {
        if (message === null) {
          throw new Error(ERROR);
        } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        } else if (!Array.isArray(message)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
            throw new Error(ERROR);
          }
        }
      } else {
        throw new Error(ERROR);
      }
      notString = true;
    }
    var code,
      index = 0,
      i,
      length = message.length,
      blocks = this.blocks;
    while (index < length) {
      if (this.hashed) {
        this.hashed = false;
        blocks[0] = this.block;
        this.block = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      }
      if (notString) {
        for (i = this.start; index < length && i < 64; ++index) {
          blocks[i >>> 2] |= message[index] << SHIFT[i++ & 3];
        }
      } else {
        for (i = this.start; index < length && i < 64; ++index) {
          code = message.charCodeAt(index);
          if (code < 0x80) {
            blocks[i >>> 2] |= code << SHIFT[i++ & 3];
          } else if (code < 0x800) {
            blocks[i >>> 2] |= (0xc0 | code >>> 6) << SHIFT[i++ & 3];
            blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
          } else if (code < 0xd800 || code >= 0xe000) {
            blocks[i >>> 2] |= (0xe0 | code >>> 12) << SHIFT[i++ & 3];
            blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
            blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
          } else {
            code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
            blocks[i >>> 2] |= (0xf0 | code >>> 18) << SHIFT[i++ & 3];
            blocks[i >>> 2] |= (0x80 | code >>> 12 & 0x3f) << SHIFT[i++ & 3];
            blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
            blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
          }
        }
      }
      this.lastByteIndex = i;
      this.bytes += i - this.start;
      if (i >= 64) {
        this.block = blocks[16];
        this.start = i - 64;
        this.hash();
        this.hashed = true;
      } else {
        this.start = i;
      }
    }
    if (this.bytes > 4294967295) {
      this.hBytes += this.bytes / 4294967296 << 0;
      this.bytes = this.bytes % 4294967296;
    }
    return this;
  };
  Sha256.prototype.finalize = function () {
    if (this.finalized) {
      return;
    }
    this.finalized = true;
    var blocks = this.blocks,
      i = this.lastByteIndex;
    blocks[16] = this.block;
    blocks[i >>> 2] |= EXTRA[i & 3];
    this.block = blocks[16];
    if (i >= 56) {
      if (!this.hashed) {
        this.hash();
      }
      blocks[0] = this.block;
      blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
    }
    blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
    blocks[15] = this.bytes << 3;
    this.hash();
  };
  Sha256.prototype.hash = function () {
    var a = this.h0,
      b = this.h1,
      c = this.h2,
      d = this.h3,
      e = this.h4,
      f = this.h5,
      g = this.h6,
      h = this.h7,
      blocks = this.blocks,
      j,
      s0,
      s1,
      maj,
      t1,
      t2,
      ch,
      ab,
      da,
      cd,
      bc;
    for (j = 16; j < 64; ++j) {
      // rightrotate
      t1 = blocks[j - 15];
      s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
      t1 = blocks[j - 2];
      s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
      blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
    }
    bc = b & c;
    for (j = 0; j < 64; j += 4) {
      if (this.first) {
        if (this.is224) {
          ab = 300032;
          t1 = blocks[0] - 1413257819;
          h = t1 - 150054599 << 0;
          d = t1 + 24177077 << 0;
        } else {
          ab = 704751109;
          t1 = blocks[0] - 210244248;
          h = t1 - 1521486534 << 0;
          d = t1 + 143694565 << 0;
        }
        this.first = false;
      } else {
        s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
        s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
        ab = a & b;
        maj = ab ^ a & c ^ bc;
        ch = e & f ^ ~e & g;
        t1 = h + s1 + ch + K[j] + blocks[j];
        t2 = s0 + maj;
        h = d + t1 << 0;
        d = t1 + t2 << 0;
      }
      s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
      s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
      da = d & a;
      maj = da ^ d & b ^ ab;
      ch = h & e ^ ~h & f;
      t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
      t2 = s0 + maj;
      g = c + t1 << 0;
      c = t1 + t2 << 0;
      s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
      s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
      cd = c & d;
      maj = cd ^ c & a ^ da;
      ch = g & h ^ ~g & e;
      t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
      t2 = s0 + maj;
      f = b + t1 << 0;
      b = t1 + t2 << 0;
      s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
      s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
      bc = b & c;
      maj = bc ^ b & d ^ cd;
      ch = f & g ^ ~f & h;
      t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
      t2 = s0 + maj;
      e = a + t1 << 0;
      a = t1 + t2 << 0;
      this.chromeBugWorkAround = true;
    }
    this.h0 = this.h0 + a << 0;
    this.h1 = this.h1 + b << 0;
    this.h2 = this.h2 + c << 0;
    this.h3 = this.h3 + d << 0;
    this.h4 = this.h4 + e << 0;
    this.h5 = this.h5 + f << 0;
    this.h6 = this.h6 + g << 0;
    this.h7 = this.h7 + h << 0;
  };
  Sha256.prototype.hex = function () {
    this.finalize();
    var h0 = this.h0,
      h1 = this.h1,
      h2 = this.h2,
      h3 = this.h3,
      h4 = this.h4,
      h5 = this.h5,
      h6 = this.h6,
      h7 = this.h7;
    var hex = HEX_CHARS[h0 >>> 28 & 0x0F] + HEX_CHARS[h0 >>> 24 & 0x0F] + HEX_CHARS[h0 >>> 20 & 0x0F] + HEX_CHARS[h0 >>> 16 & 0x0F] + HEX_CHARS[h0 >>> 12 & 0x0F] + HEX_CHARS[h0 >>> 8 & 0x0F] + HEX_CHARS[h0 >>> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h1 >>> 28 & 0x0F] + HEX_CHARS[h1 >>> 24 & 0x0F] + HEX_CHARS[h1 >>> 20 & 0x0F] + HEX_CHARS[h1 >>> 16 & 0x0F] + HEX_CHARS[h1 >>> 12 & 0x0F] + HEX_CHARS[h1 >>> 8 & 0x0F] + HEX_CHARS[h1 >>> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h2 >>> 28 & 0x0F] + HEX_CHARS[h2 >>> 24 & 0x0F] + HEX_CHARS[h2 >>> 20 & 0x0F] + HEX_CHARS[h2 >>> 16 & 0x0F] + HEX_CHARS[h2 >>> 12 & 0x0F] + HEX_CHARS[h2 >>> 8 & 0x0F] + HEX_CHARS[h2 >>> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h3 >>> 28 & 0x0F] + HEX_CHARS[h3 >>> 24 & 0x0F] + HEX_CHARS[h3 >>> 20 & 0x0F] + HEX_CHARS[h3 >>> 16 & 0x0F] + HEX_CHARS[h3 >>> 12 & 0x0F] + HEX_CHARS[h3 >>> 8 & 0x0F] + HEX_CHARS[h3 >>> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h4 >>> 28 & 0x0F] + HEX_CHARS[h4 >>> 24 & 0x0F] + HEX_CHARS[h4 >>> 20 & 0x0F] + HEX_CHARS[h4 >>> 16 & 0x0F] + HEX_CHARS[h4 >>> 12 & 0x0F] + HEX_CHARS[h4 >>> 8 & 0x0F] + HEX_CHARS[h4 >>> 4 & 0x0F] + HEX_CHARS[h4 & 0x0F] + HEX_CHARS[h5 >>> 28 & 0x0F] + HEX_CHARS[h5 >>> 24 & 0x0F] + HEX_CHARS[h5 >>> 20 & 0x0F] + HEX_CHARS[h5 >>> 16 & 0x0F] + HEX_CHARS[h5 >>> 12 & 0x0F] + HEX_CHARS[h5 >>> 8 & 0x0F] + HEX_CHARS[h5 >>> 4 & 0x0F] + HEX_CHARS[h5 & 0x0F] + HEX_CHARS[h6 >>> 28 & 0x0F] + HEX_CHARS[h6 >>> 24 & 0x0F] + HEX_CHARS[h6 >>> 20 & 0x0F] + HEX_CHARS[h6 >>> 16 & 0x0F] + HEX_CHARS[h6 >>> 12 & 0x0F] + HEX_CHARS[h6 >>> 8 & 0x0F] + HEX_CHARS[h6 >>> 4 & 0x0F] + HEX_CHARS[h6 & 0x0F];
    if (!this.is224) {
      hex += HEX_CHARS[h7 >>> 28 & 0x0F] + HEX_CHARS[h7 >>> 24 & 0x0F] + HEX_CHARS[h7 >>> 20 & 0x0F] + HEX_CHARS[h7 >>> 16 & 0x0F] + HEX_CHARS[h7 >>> 12 & 0x0F] + HEX_CHARS[h7 >>> 8 & 0x0F] + HEX_CHARS[h7 >>> 4 & 0x0F] + HEX_CHARS[h7 & 0x0F];
    }
    return hex;
  };
  Sha256.prototype.toString = Sha256.prototype.hex;
  Sha256.prototype.digest = function () {
    this.finalize();
    var h0 = this.h0,
      h1 = this.h1,
      h2 = this.h2,
      h3 = this.h3,
      h4 = this.h4,
      h5 = this.h5,
      h6 = this.h6,
      h7 = this.h7;
    var arr = [h0 >>> 24 & 0xFF, h0 >>> 16 & 0xFF, h0 >>> 8 & 0xFF, h0 & 0xFF, h1 >>> 24 & 0xFF, h1 >>> 16 & 0xFF, h1 >>> 8 & 0xFF, h1 & 0xFF, h2 >>> 24 & 0xFF, h2 >>> 16 & 0xFF, h2 >>> 8 & 0xFF, h2 & 0xFF, h3 >>> 24 & 0xFF, h3 >>> 16 & 0xFF, h3 >>> 8 & 0xFF, h3 & 0xFF, h4 >>> 24 & 0xFF, h4 >>> 16 & 0xFF, h4 >>> 8 & 0xFF, h4 & 0xFF, h5 >>> 24 & 0xFF, h5 >>> 16 & 0xFF, h5 >>> 8 & 0xFF, h5 & 0xFF, h6 >>> 24 & 0xFF, h6 >>> 16 & 0xFF, h6 >>> 8 & 0xFF, h6 & 0xFF];
    if (!this.is224) {
      arr.push(h7 >>> 24 & 0xFF, h7 >>> 16 & 0xFF, h7 >>> 8 & 0xFF, h7 & 0xFF);
    }
    return arr;
  };
  Sha256.prototype.array = Sha256.prototype.digest;
  Sha256.prototype.arrayBuffer = function () {
    this.finalize();
    var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
    var dataView = new DataView(buffer);
    dataView.setUint32(0, this.h0);
    dataView.setUint32(4, this.h1);
    dataView.setUint32(8, this.h2);
    dataView.setUint32(12, this.h3);
    dataView.setUint32(16, this.h4);
    dataView.setUint32(20, this.h5);
    dataView.setUint32(24, this.h6);
    if (!this.is224) {
      dataView.setUint32(28, this.h7);
    }
    return buffer;
  };
  function HmacSha256(key, is224, sharedMemory) {
    var i,
      type = typeof key;
    if (type === 'string') {
      var bytes = [],
        length = key.length,
        index = 0,
        code;
      for (i = 0; i < length; ++i) {
        code = key.charCodeAt(i);
        if (code < 0x80) {
          bytes[index++] = code;
        } else if (code < 0x800) {
          bytes[index++] = 0xc0 | code >>> 6;
          bytes[index++] = 0x80 | code & 0x3f;
        } else if (code < 0xd800 || code >= 0xe000) {
          bytes[index++] = 0xe0 | code >>> 12;
          bytes[index++] = 0x80 | code >>> 6 & 0x3f;
          bytes[index++] = 0x80 | code & 0x3f;
        } else {
          code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
          bytes[index++] = 0xf0 | code >>> 18;
          bytes[index++] = 0x80 | code >>> 12 & 0x3f;
          bytes[index++] = 0x80 | code >>> 6 & 0x3f;
          bytes[index++] = 0x80 | code & 0x3f;
        }
      }
      key = bytes;
    } else {
      if (type === 'object') {
        if (key === null) {
          throw new Error(ERROR);
        } else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) {
          key = new Uint8Array(key);
        } else if (!Array.isArray(key)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) {
            throw new Error(ERROR);
          }
        }
      } else {
        throw new Error(ERROR);
      }
    }
    if (key.length > 64) {
      key = new Sha256(is224, true).update(key).array();
    }
    var oKeyPad = [],
      iKeyPad = [];
    for (i = 0; i < 64; ++i) {
      var b = key[i] || 0;
      oKeyPad[i] = 0x5c ^ b;
      iKeyPad[i] = 0x36 ^ b;
    }
    Sha256.call(this, is224, sharedMemory);
    this.update(iKeyPad);
    this.oKeyPad = oKeyPad;
    this.inner = true;
    this.sharedMemory = sharedMemory;
  }
  HmacSha256.prototype = new Sha256();
  HmacSha256.prototype.finalize = function () {
    Sha256.prototype.finalize.call(this);
    if (this.inner) {
      this.inner = false;
      var innerHash = this.array();
      Sha256.call(this, this.is224, this.sharedMemory);
      this.update(this.oKeyPad);
      this.update(innerHash);
      Sha256.prototype.finalize.call(this);
    }
  };
  var exports = createMethod();
  exports.sha256 = exports;
  exports.sha224 = createMethod(true);
  exports.sha256.hmac = createHmacMethod();
  exports.sha224.hmac = createHmacMethod(true);
  if (COMMON_JS) {
    module.exports = exports;
  } else {
    root.sha256 = exports.sha256;
    root.sha224 = exports.sha224;
    if (AMD) {
      !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
        return exports;
      }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
  }
})();

/***/ }),

/***/ 22770:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(41190);
var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};
var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length - 1) {
      mq += ' and ';
    }
  });
  return mq;
};
var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length - 1) {
        mq += ', ';
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};
module.exports = json2mq;

/***/ }),

/***/ 24925:
/***/ (function(module) {

(function (window, factory) {
  if (true) {
    module.exports = factory();
  } else {}
})(this, function () {
  var jStat = function (Math, undefined) {
    // For quick reference.
    var concat = Array.prototype.concat;
    var slice = Array.prototype.slice;
    var toString = Object.prototype.toString;

    // Calculate correction for IEEE error
    // TODO: This calculation can be improved.
    function calcRdx(n, m) {
      var val = n > m ? n : m;
      return Math.pow(10, 17 - ~~(Math.log(val > 0 ? val : -val) * Math.LOG10E));
    }
    var isArray = Array.isArray || function isArray(arg) {
      return toString.call(arg) === '[object Array]';
    };
    function isFunction(arg) {
      return toString.call(arg) === '[object Function]';
    }
    function isNumber(num) {
      return typeof num === 'number' ? num - num === 0 : false;
    }

    // Converts the jStat matrix to vector.
    function toVector(arr) {
      return concat.apply([], arr);
    }

    // The one and only jStat constructor.
    function jStat() {
      return new jStat._init(arguments);
    }

    // TODO: Remove after all references in src files have been removed.
    jStat.fn = jStat.prototype;

    // By separating the initializer from the constructor it's easier to handle
    // always returning a new instance whether "new" was used or not.
    jStat._init = function _init(args) {
      // If first argument is an array, must be vector or matrix.
      if (isArray(args[0])) {
        // Check if matrix.
        if (isArray(args[0][0])) {
          // See if a mapping function was also passed.
          if (isFunction(args[1])) args[0] = jStat.map(args[0], args[1]);
          // Iterate over each is faster than this.push.apply(this, args[0].
          for (var i = 0; i < args[0].length; i++) this[i] = args[0][i];
          this.length = args[0].length;

          // Otherwise must be a vector.
        } else {
          this[0] = isFunction(args[1]) ? jStat.map(args[0], args[1]) : args[0];
          this.length = 1;
        }

        // If first argument is number, assume creation of sequence.
      } else if (isNumber(args[0])) {
        this[0] = jStat.seq.apply(null, args);
        this.length = 1;

        // Handle case when jStat object is passed to jStat.
      } else if (args[0] instanceof jStat) {
        // Duplicate the object and pass it back.
        return jStat(args[0].toArray());

        // Unexpected argument value, return empty jStat object.
        // TODO: This is strange behavior. Shouldn't this throw or some such to let
        // the user know they had bad arguments?
      } else {
        this[0] = [];
        this.length = 1;
      }
      return this;
    };
    jStat._init.prototype = jStat.prototype;
    jStat._init.constructor = jStat;

    // Utility functions.
    // TODO: for internal use only?
    jStat.utils = {
      calcRdx: calcRdx,
      isArray: isArray,
      isFunction: isFunction,
      isNumber: isNumber,
      toVector: toVector
    };
    jStat._random_fn = Math.random;
    jStat.setRandom = function setRandom(fn) {
      if (typeof fn !== 'function') throw new TypeError('fn is not a function');
      jStat._random_fn = fn;
    };

    // Easily extend the jStat object.
    // TODO: is this seriously necessary?
    jStat.extend = function extend(obj) {
      var i, j;
      if (arguments.length === 1) {
        for (j in obj) jStat[j] = obj[j];
        return this;
      }
      for (i = 1; i < arguments.length; i++) {
        for (j in arguments[i]) obj[j] = arguments[i][j];
      }
      return obj;
    };

    // Returns the number of rows in the matrix.
    jStat.rows = function rows(arr) {
      return arr.length || 1;
    };

    // Returns the number of columns in the matrix.
    jStat.cols = function cols(arr) {
      return arr[0].length || 1;
    };

    // Returns the dimensions of the object { rows: i, cols: j }
    jStat.dimensions = function dimensions(arr) {
      return {
        rows: jStat.rows(arr),
        cols: jStat.cols(arr)
      };
    };

    // Returns a specified row as a vector or return a sub matrix by pick some rows
    jStat.row = function row(arr, index) {
      if (isArray(index)) {
        return index.map(function (i) {
          return jStat.row(arr, i);
        });
      }
      return arr[index];
    };

    // return row as array
    // rowa([[1,2],[3,4]],0) -> [1,2]
    jStat.rowa = function rowa(arr, i) {
      return jStat.row(arr, i);
    };

    // Returns the specified column as a vector or return a sub matrix by pick some
    // columns
    jStat.col = function col(arr, index) {
      if (isArray(index)) {
        var submat = jStat.arange(arr.length).map(function () {
          return new Array(index.length);
        });
        index.forEach(function (ind, i) {
          jStat.arange(arr.length).forEach(function (j) {
            submat[j][i] = arr[j][ind];
          });
        });
        return submat;
      }
      var column = new Array(arr.length);
      for (var i = 0; i < arr.length; i++) column[i] = [arr[i][index]];
      return column;
    };

    // return column as array
    // cola([[1,2],[3,4]],0) -> [1,3]
    jStat.cola = function cola(arr, i) {
      return jStat.col(arr, i).map(function (a) {
        return a[0];
      });
    };

    // Returns the diagonal of the matrix
    jStat.diag = function diag(arr) {
      var nrow = jStat.rows(arr);
      var res = new Array(nrow);
      for (var row = 0; row < nrow; row++) res[row] = [arr[row][row]];
      return res;
    };

    // Returns the anti-diagonal of the matrix
    jStat.antidiag = function antidiag(arr) {
      var nrow = jStat.rows(arr) - 1;
      var res = new Array(nrow);
      for (var i = 0; nrow >= 0; nrow--, i++) res[i] = [arr[i][nrow]];
      return res;
    };

    // Transpose a matrix or array.
    jStat.transpose = function transpose(arr) {
      var obj = [];
      var objArr, rows, cols, j, i;

      // Make sure arr is in matrix format.
      if (!isArray(arr[0])) arr = [arr];
      rows = arr.length;
      cols = arr[0].length;
      for (i = 0; i < cols; i++) {
        objArr = new Array(rows);
        for (j = 0; j < rows; j++) objArr[j] = arr[j][i];
        obj.push(objArr);
      }

      // If obj is vector, return only single array.
      return obj.length === 1 ? obj[0] : obj;
    };

    // Map a function to an array or array of arrays.
    // "toAlter" is an internal variable.
    jStat.map = function map(arr, func, toAlter) {
      var row, nrow, ncol, res, col;
      if (!isArray(arr[0])) arr = [arr];
      nrow = arr.length;
      ncol = arr[0].length;
      res = toAlter ? arr : new Array(nrow);
      for (row = 0; row < nrow; row++) {
        // if the row doesn't exist, create it
        if (!res[row]) res[row] = new Array(ncol);
        for (col = 0; col < ncol; col++) res[row][col] = func(arr[row][col], row, col);
      }
      return res.length === 1 ? res[0] : res;
    };

    // Cumulatively combine the elements of an array or array of arrays using a function.
    jStat.cumreduce = function cumreduce(arr, func, toAlter) {
      var row, nrow, ncol, res, col;
      if (!isArray(arr[0])) arr = [arr];
      nrow = arr.length;
      ncol = arr[0].length;
      res = toAlter ? arr : new Array(nrow);
      for (row = 0; row < nrow; row++) {
        // if the row doesn't exist, create it
        if (!res[row]) res[row] = new Array(ncol);
        if (ncol > 0) res[row][0] = arr[row][0];
        for (col = 1; col < ncol; col++) res[row][col] = func(res[row][col - 1], arr[row][col]);
      }
      return res.length === 1 ? res[0] : res;
    };

    // Destructively alter an array.
    jStat.alter = function alter(arr, func) {
      return jStat.map(arr, func, true);
    };

    // Generate a rows x cols matrix according to the supplied function.
    jStat.create = function create(rows, cols, func) {
      var res = new Array(rows);
      var i, j;
      if (isFunction(cols)) {
        func = cols;
        cols = rows;
      }
      for (i = 0; i < rows; i++) {
        res[i] = new Array(cols);
        for (j = 0; j < cols; j++) res[i][j] = func(i, j);
      }
      return res;
    };
    function retZero() {
      return 0;
    }

    // Generate a rows x cols matrix of zeros.
    jStat.zeros = function zeros(rows, cols) {
      if (!isNumber(cols)) cols = rows;
      return jStat.create(rows, cols, retZero);
    };
    function retOne() {
      return 1;
    }

    // Generate a rows x cols matrix of ones.
    jStat.ones = function ones(rows, cols) {
      if (!isNumber(cols)) cols = rows;
      return jStat.create(rows, cols, retOne);
    };

    // Generate a rows x cols matrix of uniformly random numbers.
    jStat.rand = function rand(rows, cols) {
      if (!isNumber(cols)) cols = rows;
      return jStat.create(rows, cols, jStat._random_fn);
    };
    function retIdent(i, j) {
      return i === j ? 1 : 0;
    }

    // Generate an identity matrix of size row x cols.
    jStat.identity = function identity(rows, cols) {
      if (!isNumber(cols)) cols = rows;
      return jStat.create(rows, cols, retIdent);
    };

    // Tests whether a matrix is symmetric
    jStat.symmetric = function symmetric(arr) {
      var size = arr.length;
      var row, col;
      if (arr.length !== arr[0].length) return false;
      for (row = 0; row < size; row++) {
        for (col = 0; col < size; col++) if (arr[col][row] !== arr[row][col]) return false;
      }
      return true;
    };

    // Set all values to zero.
    jStat.clear = function clear(arr) {
      return jStat.alter(arr, retZero);
    };

    // Generate sequence.
    jStat.seq = function seq(min, max, length, func) {
      if (!isFunction(func)) func = false;
      var arr = [];
      var hival = calcRdx(min, max);
      var step = (max * hival - min * hival) / ((length - 1) * hival);
      var current = min;
      var cnt;

      // Current is assigned using a technique to compensate for IEEE error.
      // TODO: Needs better implementation.
      for (cnt = 0; current <= max && cnt < length; cnt++, current = (min * hival + step * hival * cnt) / hival) {
        arr.push(func ? func(current, cnt) : current);
      }
      return arr;
    };

    // arange(5) -> [0,1,2,3,4]
    // arange(1,5) -> [1,2,3,4]
    // arange(5,1,-1) -> [5,4,3,2]
    jStat.arange = function arange(start, end, step) {
      var rl = [];
      var i;
      step = step || 1;
      if (end === undefined) {
        end = start;
        start = 0;
      }
      if (start === end || step === 0) {
        return [];
      }
      if (start < end && step < 0) {
        return [];
      }
      if (start > end && step > 0) {
        return [];
      }
      if (step > 0) {
        for (i = start; i < end; i += step) {
          rl.push(i);
        }
      } else {
        for (i = start; i > end; i += step) {
          rl.push(i);
        }
      }
      return rl;
    };

    // A=[[1,2,3],[4,5,6],[7,8,9]]
    // slice(A,{row:{end:2},col:{start:1}}) -> [[2,3],[5,6]]
    // slice(A,1,{start:1}) -> [5,6]
    // as numpy code A[:2,1:]
    jStat.slice = function () {
      function _slice(list, start, end, step) {
        // note it's not equal to range.map mode it's a bug
        var i;
        var rl = [];
        var length = list.length;
        if (start === undefined && end === undefined && step === undefined) {
          return jStat.copy(list);
        }
        start = start || 0;
        end = end || list.length;
        start = start >= 0 ? start : length + start;
        end = end >= 0 ? end : length + end;
        step = step || 1;
        if (start === end || step === 0) {
          return [];
        }
        if (start < end && step < 0) {
          return [];
        }
        if (start > end && step > 0) {
          return [];
        }
        if (step > 0) {
          for (i = start; i < end; i += step) {
            rl.push(list[i]);
          }
        } else {
          for (i = start; i > end; i += step) {
            rl.push(list[i]);
          }
        }
        return rl;
      }
      function slice(list, rcSlice) {
        var colSlice, rowSlice;
        rcSlice = rcSlice || {};
        if (isNumber(rcSlice.row)) {
          if (isNumber(rcSlice.col)) return list[rcSlice.row][rcSlice.col];
          var row = jStat.rowa(list, rcSlice.row);
          colSlice = rcSlice.col || {};
          return _slice(row, colSlice.start, colSlice.end, colSlice.step);
        }
        if (isNumber(rcSlice.col)) {
          var col = jStat.cola(list, rcSlice.col);
          rowSlice = rcSlice.row || {};
          return _slice(col, rowSlice.start, rowSlice.end, rowSlice.step);
        }
        rowSlice = rcSlice.row || {};
        colSlice = rcSlice.col || {};
        var rows = _slice(list, rowSlice.start, rowSlice.end, rowSlice.step);
        return rows.map(function (row) {
          return _slice(row, colSlice.start, colSlice.end, colSlice.step);
        });
      }
      return slice;
    }();

    // A=[[1,2,3],[4,5,6],[7,8,9]]
    // sliceAssign(A,{row:{start:1},col:{start:1}},[[0,0],[0,0]])
    // A=[[1,2,3],[4,0,0],[7,0,0]]
    jStat.sliceAssign = function sliceAssign(A, rcSlice, B) {
      var nl, ml;
      if (isNumber(rcSlice.row)) {
        if (isNumber(rcSlice.col)) return A[rcSlice.row][rcSlice.col] = B;
        rcSlice.col = rcSlice.col || {};
        rcSlice.col.start = rcSlice.col.start || 0;
        rcSlice.col.end = rcSlice.col.end || A[0].length;
        rcSlice.col.step = rcSlice.col.step || 1;
        nl = jStat.arange(rcSlice.col.start, Math.min(A.length, rcSlice.col.end), rcSlice.col.step);
        var m = rcSlice.row;
        nl.forEach(function (n, i) {
          A[m][n] = B[i];
        });
        return A;
      }
      if (isNumber(rcSlice.col)) {
        rcSlice.row = rcSlice.row || {};
        rcSlice.row.start = rcSlice.row.start || 0;
        rcSlice.row.end = rcSlice.row.end || A.length;
        rcSlice.row.step = rcSlice.row.step || 1;
        ml = jStat.arange(rcSlice.row.start, Math.min(A[0].length, rcSlice.row.end), rcSlice.row.step);
        var n = rcSlice.col;
        ml.forEach(function (m, j) {
          A[m][n] = B[j];
        });
        return A;
      }
      if (B[0].length === undefined) {
        B = [B];
      }
      rcSlice.row.start = rcSlice.row.start || 0;
      rcSlice.row.end = rcSlice.row.end || A.length;
      rcSlice.row.step = rcSlice.row.step || 1;
      rcSlice.col.start = rcSlice.col.start || 0;
      rcSlice.col.end = rcSlice.col.end || A[0].length;
      rcSlice.col.step = rcSlice.col.step || 1;
      ml = jStat.arange(rcSlice.row.start, Math.min(A.length, rcSlice.row.end), rcSlice.row.step);
      nl = jStat.arange(rcSlice.col.start, Math.min(A[0].length, rcSlice.col.end), rcSlice.col.step);
      ml.forEach(function (m, i) {
        nl.forEach(function (n, j) {
          A[m][n] = B[i][j];
        });
      });
      return A;
    };

    // [1,2,3] ->
    // [[1,0,0],[0,2,0],[0,0,3]]
    jStat.diagonal = function diagonal(diagArray) {
      var mat = jStat.zeros(diagArray.length, diagArray.length);
      diagArray.forEach(function (t, i) {
        mat[i][i] = t;
      });
      return mat;
    };

    // return copy of A
    jStat.copy = function copy(A) {
      return A.map(function (row) {
        if (isNumber(row)) return row;
        return row.map(function (t) {
          return t;
        });
      });
    };

    // TODO: Go over this entire implementation. Seems a tragic waste of resources
    // doing all this work. Instead, and while ugly, use new Function() to generate
    // a custom function for each static method.

    // Quick reference.
    var jProto = jStat.prototype;

    // Default length.
    jProto.length = 0;

    // For internal use only.
    // TODO: Check if they're actually used, and if they are then rename them
    // to _*
    jProto.push = Array.prototype.push;
    jProto.sort = Array.prototype.sort;
    jProto.splice = Array.prototype.splice;
    jProto.slice = Array.prototype.slice;

    // Return a clean array.
    jProto.toArray = function toArray() {
      return this.length > 1 ? slice.call(this) : slice.call(this)[0];
    };

    // Map a function to a matrix or vector.
    jProto.map = function map(func, toAlter) {
      return jStat(jStat.map(this, func, toAlter));
    };

    // Cumulatively combine the elements of a matrix or vector using a function.
    jProto.cumreduce = function cumreduce(func, toAlter) {
      return jStat(jStat.cumreduce(this, func, toAlter));
    };

    // Destructively alter an array.
    jProto.alter = function alter(func) {
      jStat.alter(this, func);
      return this;
    };

    // Extend prototype with methods that have no argument.
    (function (funcs) {
      for (var i = 0; i < funcs.length; i++) (function (passfunc) {
        jProto[passfunc] = function (func) {
          var self = this,
            results;
          // Check for callback.
          if (func) {
            setTimeout(function () {
              func.call(self, jProto[passfunc].call(self));
            });
            return this;
          }
          results = jStat[passfunc](this);
          return isArray(results) ? jStat(results) : results;
        };
      })(funcs[i]);
    })('transpose clear symmetric rows cols dimensions diag antidiag'.split(' '));

    // Extend prototype with methods that have one argument.
    (function (funcs) {
      for (var i = 0; i < funcs.length; i++) (function (passfunc) {
        jProto[passfunc] = function (index, func) {
          var self = this;
          // check for callback
          if (func) {
            setTimeout(function () {
              func.call(self, jProto[passfunc].call(self, index));
            });
            return this;
          }
          return jStat(jStat[passfunc](this, index));
        };
      })(funcs[i]);
    })('row col'.split(' '));

    // Extend prototype with simple shortcut methods.
    (function (funcs) {
      for (var i = 0; i < funcs.length; i++) (function (passfunc) {
        jProto[passfunc] = function () {
          return jStat(jStat[passfunc].apply(null, arguments));
        };
      })(funcs[i]);
    })('create zeros ones rand identity'.split(' '));

    // Exposing jStat.
    return jStat;
  }(Math);
  (function (jStat, Math) {
    var isFunction = jStat.utils.isFunction;

    // Ascending functions for sort
    function ascNum(a, b) {
      return a - b;
    }
    function clip(arg, min, max) {
      return Math.max(min, Math.min(arg, max));
    }

    // sum of an array
    jStat.sum = function sum(arr) {
      var sum = 0;
      var i = arr.length;
      while (--i >= 0) sum += arr[i];
      return sum;
    };

    // sum squared
    jStat.sumsqrd = function sumsqrd(arr) {
      var sum = 0;
      var i = arr.length;
      while (--i >= 0) sum += arr[i] * arr[i];
      return sum;
    };

    // sum of squared errors of prediction (SSE)
    jStat.sumsqerr = function sumsqerr(arr) {
      var mean = jStat.mean(arr);
      var sum = 0;
      var i = arr.length;
      var tmp;
      while (--i >= 0) {
        tmp = arr[i] - mean;
        sum += tmp * tmp;
      }
      return sum;
    };

    // sum of an array in each row
    jStat.sumrow = function sumrow(arr) {
      var sum = 0;
      var i = arr.length;
      while (--i >= 0) sum += arr[i];
      return sum;
    };

    // product of an array
    jStat.product = function product(arr) {
      var prod = 1;
      var i = arr.length;
      while (--i >= 0) prod *= arr[i];
      return prod;
    };

    // minimum value of an array
    jStat.min = function min(arr) {
      var low = arr[0];
      var i = 0;
      while (++i < arr.length) if (arr[i] < low) low = arr[i];
      return low;
    };

    // maximum value of an array
    jStat.max = function max(arr) {
      var high = arr[0];
      var i = 0;
      while (++i < arr.length) if (arr[i] > high) high = arr[i];
      return high;
    };

    // unique values of an array
    jStat.unique = function unique(arr) {
      var hash = {},
        _arr = [];
      for (var i = 0; i < arr.length; i++) {
        if (!hash[arr[i]]) {
          hash[arr[i]] = true;
          _arr.push(arr[i]);
        }
      }
      return _arr;
    };

    // mean value of an array
    jStat.mean = function mean(arr) {
      return jStat.sum(arr) / arr.length;
    };

    // mean squared error (MSE)
    jStat.meansqerr = function meansqerr(arr) {
      return jStat.sumsqerr(arr) / arr.length;
    };

    // geometric mean of an array
    jStat.geomean = function geomean(arr) {
      var logs = arr.map(Math.log);
      var meanOfLogs = jStat.mean(logs);
      return Math.exp(meanOfLogs);
    };

    // median of an array
    jStat.median = function median(arr) {
      var arrlen = arr.length;
      var _arr = arr.slice().sort(ascNum);
      // check if array is even or odd, then return the appropriate
      return !(arrlen & 1) ? (_arr[arrlen / 2 - 1] + _arr[arrlen / 2]) / 2 : _arr[arrlen / 2 | 0];
    };

    // cumulative sum of an array
    jStat.cumsum = function cumsum(arr) {
      return jStat.cumreduce(arr, function (a, b) {
        return a + b;
      });
    };

    // cumulative product of an array
    jStat.cumprod = function cumprod(arr) {
      return jStat.cumreduce(arr, function (a, b) {
        return a * b;
      });
    };

    // successive differences of a sequence
    jStat.diff = function diff(arr) {
      var diffs = [];
      var arrLen = arr.length;
      var i;
      for (i = 1; i < arrLen; i++) diffs.push(arr[i] - arr[i - 1]);
      return diffs;
    };

    // ranks of an array
    jStat.rank = function (arr) {
      var i;
      var distinctNumbers = [];
      var numberCounts = {};
      for (i = 0; i < arr.length; i++) {
        var number = arr[i];
        if (numberCounts[number]) {
          numberCounts[number]++;
        } else {
          numberCounts[number] = 1;
          distinctNumbers.push(number);
        }
      }
      var sortedDistinctNumbers = distinctNumbers.sort(ascNum);
      var numberRanks = {};
      var currentRank = 1;
      for (i = 0; i < sortedDistinctNumbers.length; i++) {
        var number = sortedDistinctNumbers[i];
        var count = numberCounts[number];
        var first = currentRank;
        var last = currentRank + count - 1;
        var rank = (first + last) / 2;
        numberRanks[number] = rank;
        currentRank += count;
      }
      return arr.map(function (number) {
        return numberRanks[number];
      });
    };

    // mode of an array
    // if there are multiple modes of an array, return all of them
    // is this the appropriate way of handling it?
    jStat.mode = function mode(arr) {
      var arrLen = arr.length;
      var _arr = arr.slice().sort(ascNum);
      var count = 1;
      var maxCount = 0;
      var numMaxCount = 0;
      var mode_arr = [];
      var i;
      for (i = 0; i < arrLen; i++) {
        if (_arr[i] === _arr[i + 1]) {
          count++;
        } else {
          if (count > maxCount) {
            mode_arr = [_arr[i]];
            maxCount = count;
            numMaxCount = 0;
          }
          // are there multiple max counts
          else if (count === maxCount) {
            mode_arr.push(_arr[i]);
            numMaxCount++;
          }
          // resetting count for new value in array
          count = 1;
        }
      }
      return numMaxCount === 0 ? mode_arr[0] : mode_arr;
    };

    // range of an array
    jStat.range = function range(arr) {
      return jStat.max(arr) - jStat.min(arr);
    };

    // variance of an array
    // flag = true indicates sample instead of population
    jStat.variance = function variance(arr, flag) {
      return jStat.sumsqerr(arr) / (arr.length - (flag ? 1 : 0));
    };

    // pooled variance of an array of arrays
    jStat.pooledvariance = function pooledvariance(arr) {
      var sumsqerr = arr.reduce(function (a, samples) {
        return a + jStat.sumsqerr(samples);
      }, 0);
      var count = arr.reduce(function (a, samples) {
        return a + samples.length;
      }, 0);
      return sumsqerr / (count - arr.length);
    };

    // deviation of an array
    jStat.deviation = function (arr) {
      var mean = jStat.mean(arr);
      var arrlen = arr.length;
      var dev = new Array(arrlen);
      for (var i = 0; i < arrlen; i++) {
        dev[i] = arr[i] - mean;
      }
      return dev;
    };

    // standard deviation of an array
    // flag = true indicates sample instead of population
    jStat.stdev = function stdev(arr, flag) {
      return Math.sqrt(jStat.variance(arr, flag));
    };

    // pooled standard deviation of an array of arrays
    jStat.pooledstdev = function pooledstdev(arr) {
      return Math.sqrt(jStat.pooledvariance(arr));
    };

    // mean deviation (mean absolute deviation) of an array
    jStat.meandev = function meandev(arr) {
      var mean = jStat.mean(arr);
      var a = [];
      for (var i = arr.length - 1; i >= 0; i--) {
        a.push(Math.abs(arr[i] - mean));
      }
      return jStat.mean(a);
    };

    // median deviation (median absolute deviation) of an array
    jStat.meddev = function meddev(arr) {
      var median = jStat.median(arr);
      var a = [];
      for (var i = arr.length - 1; i >= 0; i--) {
        a.push(Math.abs(arr[i] - median));
      }
      return jStat.median(a);
    };

    // coefficient of variation
    jStat.coeffvar = function coeffvar(arr) {
      return jStat.stdev(arr) / jStat.mean(arr);
    };

    // quartiles of an array
    jStat.quartiles = function quartiles(arr) {
      var arrlen = arr.length;
      var _arr = arr.slice().sort(ascNum);
      return [_arr[Math.round(arrlen / 4) - 1], _arr[Math.round(arrlen / 2) - 1], _arr[Math.round(arrlen * 3 / 4) - 1]];
    };

    // Arbitary quantiles of an array. Direct port of the scipy.stats
    // implementation by Pierre GF Gerard-Marchant.
    jStat.quantiles = function quantiles(arr, quantilesArray, alphap, betap) {
      var sortedArray = arr.slice().sort(ascNum);
      var quantileVals = [quantilesArray.length];
      var n = arr.length;
      var i, p, m, aleph, k, gamma;
      if (typeof alphap === 'undefined') alphap = 3 / 8;
      if (typeof betap === 'undefined') betap = 3 / 8;
      for (i = 0; i < quantilesArray.length; i++) {
        p = quantilesArray[i];
        m = alphap + p * (1 - alphap - betap);
        aleph = n * p + m;
        k = Math.floor(clip(aleph, 1, n - 1));
        gamma = clip(aleph - k, 0, 1);
        quantileVals[i] = (1 - gamma) * sortedArray[k - 1] + gamma * sortedArray[k];
      }
      return quantileVals;
    };

    // Return the k-th percentile of values in a range, where k is in the range 0..1, inclusive.
    // Passing true for the exclusive parameter excludes both endpoints of the range.
    jStat.percentile = function percentile(arr, k, exclusive) {
      var _arr = arr.slice().sort(ascNum);
      var realIndex = k * (_arr.length + (exclusive ? 1 : -1)) + (exclusive ? 0 : 1);
      var index = parseInt(realIndex);
      var frac = realIndex - index;
      if (index + 1 < _arr.length) {
        return _arr[index - 1] + frac * (_arr[index] - _arr[index - 1]);
      } else {
        return _arr[index - 1];
      }
    };

    // The percentile rank of score in a given array. Returns the percentage
    // of all values in the input array that are less than (kind='strict') or
    // less or equal than (kind='weak') score. Default is weak.
    jStat.percentileOfScore = function percentileOfScore(arr, score, kind) {
      var counter = 0;
      var len = arr.length;
      var strict = false;
      var value, i;
      if (kind === 'strict') strict = true;
      for (i = 0; i < len; i++) {
        value = arr[i];
        if (strict && value < score || !strict && value <= score) {
          counter++;
        }
      }
      return counter / len;
    };

    // Histogram (bin count) data
    jStat.histogram = function histogram(arr, binCnt) {
      binCnt = binCnt || 4;
      var first = jStat.min(arr);
      var binWidth = (jStat.max(arr) - first) / binCnt;
      var len = arr.length;
      var bins = [];
      var i;
      for (i = 0; i < binCnt; i++) bins[i] = 0;
      for (i = 0; i < len; i++) bins[Math.min(Math.floor((arr[i] - first) / binWidth), binCnt - 1)] += 1;
      return bins;
    };

    // covariance of two arrays
    jStat.covariance = function covariance(arr1, arr2) {
      var u = jStat.mean(arr1);
      var v = jStat.mean(arr2);
      var arr1Len = arr1.length;
      var sq_dev = new Array(arr1Len);
      var i;
      for (i = 0; i < arr1Len; i++) sq_dev[i] = (arr1[i] - u) * (arr2[i] - v);
      return jStat.sum(sq_dev) / (arr1Len - 1);
    };

    // (pearson's) population correlation coefficient, rho
    jStat.corrcoeff = function corrcoeff(arr1, arr2) {
      return jStat.covariance(arr1, arr2) / jStat.stdev(arr1, 1) / jStat.stdev(arr2, 1);
    };

    // (spearman's) rank correlation coefficient, sp
    jStat.spearmancoeff = function (arr1, arr2) {
      arr1 = jStat.rank(arr1);
      arr2 = jStat.rank(arr2);
      //return pearson's correlation of the ranks:
      return jStat.corrcoeff(arr1, arr2);
    };

    // statistical standardized moments (general form of skew/kurt)
    jStat.stanMoment = function stanMoment(arr, n) {
      var mu = jStat.mean(arr);
      var sigma = jStat.stdev(arr);
      var len = arr.length;
      var skewSum = 0;
      for (var i = 0; i < len; i++) skewSum += Math.pow((arr[i] - mu) / sigma, n);
      return skewSum / arr.length;
    };

    // (pearson's) moment coefficient of skewness
    jStat.skewness = function skewness(arr) {
      return jStat.stanMoment(arr, 3);
    };

    // (pearson's) (excess) kurtosis
    jStat.kurtosis = function kurtosis(arr) {
      return jStat.stanMoment(arr, 4) - 3;
    };
    var jProto = jStat.prototype;

    // Extend jProto with method for calculating cumulative sums and products.
    // This differs from the similar extension below as cumsum and cumprod should
    // not be run again in the case fullbool === true.
    // If a matrix is passed, automatically assume operation should be done on the
    // columns.
    (function (funcs) {
      for (var i = 0; i < funcs.length; i++) (function (passfunc) {
        // If a matrix is passed, automatically assume operation should be done on
        // the columns.
        jProto[passfunc] = function (fullbool, func) {
          var arr = [];
          var i = 0;
          var tmpthis = this;
          // Assignment reassignation depending on how parameters were passed in.
          if (isFunction(fullbool)) {
            func = fullbool;
            fullbool = false;
          }
          // Check if a callback was passed with the function.
          if (func) {
            setTimeout(function () {
              func.call(tmpthis, jProto[passfunc].call(tmpthis, fullbool));
            });
            return this;
          }
          // Check if matrix and run calculations.
          if (this.length > 1) {
            tmpthis = fullbool === true ? this : this.transpose();
            for (; i < tmpthis.length; i++) arr[i] = jStat[passfunc](tmpthis[i]);
            return arr;
          }
          // Pass fullbool if only vector, not a matrix. for variance and stdev.
          return jStat[passfunc](this[0], fullbool);
        };
      })(funcs[i]);
    })('cumsum cumprod'.split(' '));

    // Extend jProto with methods which don't require arguments and work on columns.
    (function (funcs) {
      for (var i = 0; i < funcs.length; i++) (function (passfunc) {
        // If a matrix is passed, automatically assume operation should be done on
        // the columns.
        jProto[passfunc] = function (fullbool, func) {
          var arr = [];
          var i = 0;
          var tmpthis = this;
          // Assignment reassignation depending on how parameters were passed in.
          if (isFunction(fullbool)) {
            func = fullbool;
            fullbool = false;
          }
          // Check if a callback was passed with the function.
          if (func) {
            setTimeout(function () {
              func.call(tmpthis, jProto[passfunc].call(tmpthis, fullbool));
            });
            return this;
          }
          // Check if matrix and run calculations.
          if (this.length > 1) {
            if (passfunc !== 'sumrow') tmpthis = fullbool === true ? this : this.transpose();
            for (; i < tmpthis.length; i++) arr[i] = jStat[passfunc](tmpthis[i]);
            return fullbool === true ? jStat[passfunc](jStat.utils.toVector(arr)) : arr;
          }
          // Pass fullbool if only vector, not a matrix. for variance and stdev.
          return jStat[passfunc](this[0], fullbool);
        };
      })(funcs[i]);
    })(('sum sumsqrd sumsqerr sumrow product min max unique mean meansqerr ' + 'geomean median diff rank mode range variance deviation stdev meandev ' + 'meddev coeffvar quartiles histogram skewness kurtosis').split(' '));

    // Extend jProto with functions that take arguments. Operations on matrices are
    // done on columns.
    (function (funcs) {
      for (var i = 0; i < funcs.length; i++) (function (passfunc) {
        jProto[passfunc] = function () {
          var arr = [];
          var i = 0;
          var tmpthis = this;
          var args = Array.prototype.slice.call(arguments);
          var callbackFunction;

          // If the last argument is a function, we assume it's a callback; we
          // strip the callback out and call the function again.
          if (isFunction(args[args.length - 1])) {
            callbackFunction = args[args.length - 1];
            var argsToPass = args.slice(0, args.length - 1);
            setTimeout(function () {
              callbackFunction.call(tmpthis, jProto[passfunc].apply(tmpthis, argsToPass));
            });
            return this;

            // Otherwise we curry the function args and call normally.
          } else {
            callbackFunction = undefined;
            var curriedFunction = function curriedFunction(vector) {
              return jStat[passfunc].apply(tmpthis, [vector].concat(args));
            };
          }

          // If this is a matrix, run column-by-column.
          if (this.length > 1) {
            tmpthis = tmpthis.transpose();
            for (; i < tmpthis.length; i++) arr[i] = curriedFunction(tmpthis[i]);
            return arr;
          }

          // Otherwise run on the vector.
          return curriedFunction(this[0]);
        };
      })(funcs[i]);
    })('quantiles percentileOfScore'.split(' '));
  })(jStat, Math);
  // Special functions //
  (function (jStat, Math) {
    // Log-gamma function
    jStat.gammaln = function gammaln(x) {
      var j = 0;
      var cof = [76.18009172947146, -86.50532032941677, 24.01409824083091, -1.231739572450155, 0.1208650973866179e-2, -0.5395239384953e-5];
      var ser = 1.000000000190015;
      var xx, y, tmp;
      tmp = (y = xx = x) + 5.5;
      tmp -= (xx + 0.5) * Math.log(tmp);
      for (; j < 6; j++) ser += cof[j] / ++y;
      return Math.log(2.5066282746310005 * ser / xx) - tmp;
    };

    /*
     * log-gamma function to support poisson distribution sampling. The
     * algorithm comes from SPECFUN by Shanjie Zhang and Jianming Jin and their
     * book "Computation of Special Functions", 1996, John Wiley & Sons, Inc.
     */
    jStat.loggam = function loggam(x) {
      var x0, x2, xp, gl, gl0;
      var k, n;
      var a = [8.333333333333333e-02, -2.777777777777778e-03, 7.936507936507937e-04, -5.952380952380952e-04, 8.417508417508418e-04, -1.917526917526918e-03, 6.410256410256410e-03, -2.955065359477124e-02, 1.796443723688307e-01, -1.39243221690590e+00];
      x0 = x;
      n = 0;
      if (x == 1.0 || x == 2.0) {
        return 0.0;
      }
      if (x <= 7.0) {
        n = Math.floor(7 - x);
        x0 = x + n;
      }
      x2 = 1.0 / (x0 * x0);
      xp = 2 * Math.PI;
      gl0 = a[9];
      for (k = 8; k >= 0; k--) {
        gl0 *= x2;
        gl0 += a[k];
      }
      gl = gl0 / x0 + 0.5 * Math.log(xp) + (x0 - 0.5) * Math.log(x0) - x0;
      if (x <= 7.0) {
        for (k = 1; k <= n; k++) {
          gl -= Math.log(x0 - 1.0);
          x0 -= 1.0;
        }
      }
      return gl;
    };

    // gamma of x
    jStat.gammafn = function gammafn(x) {
      var p = [-1.716185138865495, 24.76565080557592, -379.80425647094563, 629.3311553128184, 866.9662027904133, -31451.272968848367, -36144.413418691176, 66456.14382024054];
      var q = [-30.8402300119739, 315.35062697960416, -1015.1563674902192, -3107.771671572311, 22538.118420980151, 4755.8462775278811, -134659.9598649693, -115132.2596755535];
      var fact = false;
      var n = 0;
      var xden = 0;
      var xnum = 0;
      var y = x;
      var i, z, yi, res;
      if (x > 171.6243769536076) {
        return Infinity;
      }
      if (y <= 0) {
        res = y % 1 + 3.6e-16;
        if (res) {
          fact = (!(y & 1) ? 1 : -1) * Math.PI / Math.sin(Math.PI * res);
          y = 1 - y;
        } else {
          return Infinity;
        }
      }
      yi = y;
      if (y < 1) {
        z = y++;
      } else {
        z = (y -= n = (y | 0) - 1) - 1;
      }
      for (i = 0; i < 8; ++i) {
        xnum = (xnum + p[i]) * z;
        xden = xden * z + q[i];
      }
      res = xnum / xden + 1;
      if (yi < y) {
        res /= yi;
      } else if (yi > y) {
        for (i = 0; i < n; ++i) {
          res *= y;
          y++;
        }
      }
      if (fact) {
        res = fact / res;
      }
      return res;
    };

    // lower incomplete gamma function, which is usually typeset with a
    // lower-case greek gamma as the function symbol
    jStat.gammap = function gammap(a, x) {
      return jStat.lowRegGamma(a, x) * jStat.gammafn(a);
    };

    // The lower regularized incomplete gamma function, usually written P(a,x)
    jStat.lowRegGamma = function lowRegGamma(a, x) {
      var aln = jStat.gammaln(a);
      var ap = a;
      var sum = 1 / a;
      var del = sum;
      var b = x + 1 - a;
      var c = 1 / 1.0e-30;
      var d = 1 / b;
      var h = d;
      var i = 1;
      // calculate maximum number of itterations required for a
      var ITMAX = -~(Math.log(a >= 1 ? a : 1 / a) * 8.5 + a * 0.4 + 17);
      var an;
      if (x < 0 || a <= 0) {
        return NaN;
      } else if (x < a + 1) {
        for (; i <= ITMAX; i++) {
          sum += del *= x / ++ap;
        }
        return sum * Math.exp(-x + a * Math.log(x) - aln);
      }
      for (; i <= ITMAX; i++) {
        an = -i * (i - a);
        b += 2;
        d = an * d + b;
        c = b + an / c;
        d = 1 / d;
        h *= d * c;
      }
      return 1 - h * Math.exp(-x + a * Math.log(x) - aln);
    };

    // natural log factorial of n
    jStat.factorialln = function factorialln(n) {
      return n < 0 ? NaN : jStat.gammaln(n + 1);
    };

    // factorial of n
    jStat.factorial = function factorial(n) {
      return n < 0 ? NaN : jStat.gammafn(n + 1);
    };

    // combinations of n, m
    jStat.combination = function combination(n, m) {
      // make sure n or m don't exceed the upper limit of usable values
      return n > 170 || m > 170 ? Math.exp(jStat.combinationln(n, m)) : jStat.factorial(n) / jStat.factorial(m) / jStat.factorial(n - m);
    };
    jStat.combinationln = function combinationln(n, m) {
      return jStat.factorialln(n) - jStat.factorialln(m) - jStat.factorialln(n - m);
    };

    // permutations of n, m
    jStat.permutation = function permutation(n, m) {
      return jStat.factorial(n) / jStat.factorial(n - m);
    };

    // beta function
    jStat.betafn = function betafn(x, y) {
      // ensure arguments are positive
      if (x <= 0 || y <= 0) return undefined;
      // make sure x + y doesn't exceed the upper limit of usable values
      return x + y > 170 ? Math.exp(jStat.betaln(x, y)) : jStat.gammafn(x) * jStat.gammafn(y) / jStat.gammafn(x + y);
    };

    // natural logarithm of beta function
    jStat.betaln = function betaln(x, y) {
      return jStat.gammaln(x) + jStat.gammaln(y) - jStat.gammaln(x + y);
    };

    // Evaluates the continued fraction for incomplete beta function by modified
    // Lentz's method.
    jStat.betacf = function betacf(x, a, b) {
      var fpmin = 1e-30;
      var m = 1;
      var qab = a + b;
      var qap = a + 1;
      var qam = a - 1;
      var c = 1;
      var d = 1 - qab * x / qap;
      var m2, aa, del, h;

      // These q's will be used in factors that occur in the coefficients
      if (Math.abs(d) < fpmin) d = fpmin;
      d = 1 / d;
      h = d;
      for (; m <= 100; m++) {
        m2 = 2 * m;
        aa = m * (b - m) * x / ((qam + m2) * (a + m2));
        // One step (the even one) of the recurrence
        d = 1 + aa * d;
        if (Math.abs(d) < fpmin) d = fpmin;
        c = 1 + aa / c;
        if (Math.abs(c) < fpmin) c = fpmin;
        d = 1 / d;
        h *= d * c;
        aa = -(a + m) * (qab + m) * x / ((a + m2) * (qap + m2));
        // Next step of the recurrence (the odd one)
        d = 1 + aa * d;
        if (Math.abs(d) < fpmin) d = fpmin;
        c = 1 + aa / c;
        if (Math.abs(c) < fpmin) c = fpmin;
        d = 1 / d;
        del = d * c;
        h *= del;
        if (Math.abs(del - 1.0) < 3e-7) break;
      }
      return h;
    };

    // Returns the inverse of the lower regularized inomplete gamma function
    jStat.gammapinv = function gammapinv(p, a) {
      var j = 0;
      var a1 = a - 1;
      var EPS = 1e-8;
      var gln = jStat.gammaln(a);
      var x, err, t, u, pp, lna1, afac;
      if (p >= 1) return Math.max(100, a + 100 * Math.sqrt(a));
      if (p <= 0) return 0;
      if (a > 1) {
        lna1 = Math.log(a1);
        afac = Math.exp(a1 * (lna1 - 1) - gln);
        pp = p < 0.5 ? p : 1 - p;
        t = Math.sqrt(-2 * Math.log(pp));
        x = (2.30753 + t * 0.27061) / (1 + t * (0.99229 + t * 0.04481)) - t;
        if (p < 0.5) x = -x;
        x = Math.max(1e-3, a * Math.pow(1 - 1 / (9 * a) - x / (3 * Math.sqrt(a)), 3));
      } else {
        t = 1 - a * (0.253 + a * 0.12);
        if (p < t) x = Math.pow(p / t, 1 / a);else x = 1 - Math.log(1 - (p - t) / (1 - t));
      }
      for (; j < 12; j++) {
        if (x <= 0) return 0;
        err = jStat.lowRegGamma(a, x) - p;
        if (a > 1) t = afac * Math.exp(-(x - a1) + a1 * (Math.log(x) - lna1));else t = Math.exp(-x + a1 * Math.log(x) - gln);
        u = err / t;
        x -= t = u / (1 - 0.5 * Math.min(1, u * ((a - 1) / x - 1)));
        if (x <= 0) x = 0.5 * (x + t);
        if (Math.abs(t) < EPS * x) break;
      }
      return x;
    };

    // Returns the error function erf(x)
    jStat.erf = function erf(x) {
      var cof = [-1.3026537197817094, 6.4196979235649026e-1, 1.9476473204185836e-2, -9.561514786808631e-3, -9.46595344482036e-4, 3.66839497852761e-4, 4.2523324806907e-5, -2.0278578112534e-5, -1.624290004647e-6, 1.303655835580e-6, 1.5626441722e-8, -8.5238095915e-8, 6.529054439e-9, 5.059343495e-9, -9.91364156e-10, -2.27365122e-10, 9.6467911e-11, 2.394038e-12, -6.886027e-12, 8.94487e-13, 3.13092e-13, -1.12708e-13, 3.81e-16, 7.106e-15, -1.523e-15, -9.4e-17, 1.21e-16, -2.8e-17];
      var j = cof.length - 1;
      var isneg = false;
      var d = 0;
      var dd = 0;
      var t, ty, tmp, res;
      if (x < 0) {
        x = -x;
        isneg = true;
      }
      t = 2 / (2 + x);
      ty = 4 * t - 2;
      for (; j > 0; j--) {
        tmp = d;
        d = ty * d - dd + cof[j];
        dd = tmp;
      }
      res = t * Math.exp(-x * x + 0.5 * (cof[0] + ty * d) - dd);
      return isneg ? res - 1 : 1 - res;
    };

    // Returns the complmentary error function erfc(x)
    jStat.erfc = function erfc(x) {
      return 1 - jStat.erf(x);
    };

    // Returns the inverse of the complementary error function
    jStat.erfcinv = function erfcinv(p) {
      var j = 0;
      var x, err, t, pp;
      if (p >= 2) return -100;
      if (p <= 0) return 100;
      pp = p < 1 ? p : 2 - p;
      t = Math.sqrt(-2 * Math.log(pp / 2));
      x = -0.70711 * ((2.30753 + t * 0.27061) / (1 + t * (0.99229 + t * 0.04481)) - t);
      for (; j < 2; j++) {
        err = jStat.erfc(x) - pp;
        x += err / (1.12837916709551257 * Math.exp(-x * x) - x * err);
      }
      return p < 1 ? x : -x;
    };

    // Returns the inverse of the incomplete beta function
    jStat.ibetainv = function ibetainv(p, a, b) {
      var EPS = 1e-8;
      var a1 = a - 1;
      var b1 = b - 1;
      var j = 0;
      var lna, lnb, pp, t, u, err, x, al, h, w, afac;
      if (p <= 0) return 0;
      if (p >= 1) return 1;
      if (a >= 1 && b >= 1) {
        pp = p < 0.5 ? p : 1 - p;
        t = Math.sqrt(-2 * Math.log(pp));
        x = (2.30753 + t * 0.27061) / (1 + t * (0.99229 + t * 0.04481)) - t;
        if (p < 0.5) x = -x;
        al = (x * x - 3) / 6;
        h = 2 / (1 / (2 * a - 1) + 1 / (2 * b - 1));
        w = x * Math.sqrt(al + h) / h - (1 / (2 * b - 1) - 1 / (2 * a - 1)) * (al + 5 / 6 - 2 / (3 * h));
        x = a / (a + b * Math.exp(2 * w));
      } else {
        lna = Math.log(a / (a + b));
        lnb = Math.log(b / (a + b));
        t = Math.exp(a * lna) / a;
        u = Math.exp(b * lnb) / b;
        w = t + u;
        if (p < t / w) x = Math.pow(a * w * p, 1 / a);else x = 1 - Math.pow(b * w * (1 - p), 1 / b);
      }
      afac = -jStat.gammaln(a) - jStat.gammaln(b) + jStat.gammaln(a + b);
      for (; j < 10; j++) {
        if (x === 0 || x === 1) return x;
        err = jStat.ibeta(x, a, b) - p;
        t = Math.exp(a1 * Math.log(x) + b1 * Math.log(1 - x) + afac);
        u = err / t;
        x -= t = u / (1 - 0.5 * Math.min(1, u * (a1 / x - b1 / (1 - x))));
        if (x <= 0) x = 0.5 * (x + t);
        if (x >= 1) x = 0.5 * (x + t + 1);
        if (Math.abs(t) < EPS * x && j > 0) break;
      }
      return x;
    };

    // Returns the incomplete beta function I_x(a,b)
    jStat.ibeta = function ibeta(x, a, b) {
      // Factors in front of the continued fraction.
      var bt = x === 0 || x === 1 ? 0 : Math.exp(jStat.gammaln(a + b) - jStat.gammaln(a) - jStat.gammaln(b) + a * Math.log(x) + b * Math.log(1 - x));
      if (x < 0 || x > 1) return false;
      if (x < (a + 1) / (a + b + 2))
        // Use continued fraction directly.
        return bt * jStat.betacf(x, a, b) / a;
      // else use continued fraction after making the symmetry transformation.
      return 1 - bt * jStat.betacf(1 - x, b, a) / b;
    };

    // Returns a normal deviate (mu=0, sigma=1).
    // If n and m are specified it returns a object of normal deviates.
    jStat.randn = function randn(n, m) {
      var u, v, x, y, q;
      if (!m) m = n;
      if (n) return jStat.create(n, m, function () {
        return jStat.randn();
      });
      do {
        u = jStat._random_fn();
        v = 1.7156 * (jStat._random_fn() - 0.5);
        x = u - 0.449871;
        y = Math.abs(v) + 0.386595;
        q = x * x + y * (0.19600 * y - 0.25472 * x);
      } while (q > 0.27597 && (q > 0.27846 || v * v > -4 * Math.log(u) * u * u));
      return v / u;
    };

    // Returns a gamma deviate by the method of Marsaglia and Tsang.
    jStat.randg = function randg(shape, n, m) {
      var oalph = shape;
      var a1, a2, u, v, x, mat;
      if (!m) m = n;
      if (!shape) shape = 1;
      if (n) {
        mat = jStat.zeros(n, m);
        mat.alter(function () {
          return jStat.randg(shape);
        });
        return mat;
      }
      if (shape < 1) shape += 1;
      a1 = shape - 1 / 3;
      a2 = 1 / Math.sqrt(9 * a1);
      do {
        do {
          x = jStat.randn();
          v = 1 + a2 * x;
        } while (v <= 0);
        v = v * v * v;
        u = jStat._random_fn();
      } while (u > 1 - 0.331 * Math.pow(x, 4) && Math.log(u) > 0.5 * x * x + a1 * (1 - v + Math.log(v)));
      // alpha > 1
      if (shape == oalph) return a1 * v;
      // alpha < 1
      do {
        u = jStat._random_fn();
      } while (u === 0);
      return Math.pow(u, 1 / oalph) * a1 * v;
    };

    // making use of static methods on the instance
    (function (funcs) {
      for (var i = 0; i < funcs.length; i++) (function (passfunc) {
        jStat.fn[passfunc] = function () {
          return jStat(jStat.map(this, function (value) {
            return jStat[passfunc](value);
          }));
        };
      })(funcs[i]);
    })('gammaln gammafn factorial factorialln'.split(' '));
    (function (funcs) {
      for (var i = 0; i < funcs.length; i++) (function (passfunc) {
        jStat.fn[passfunc] = function () {
          return jStat(jStat[passfunc].apply(null, arguments));
        };
      })(funcs[i]);
    })('randn'.split(' '));
  })(jStat, Math);
  (function (jStat, Math) {
    // generate all distribution instance methods
    (function (list) {
      for (var i = 0; i < list.length; i++) (function (func) {
        // distribution instance method
        jStat[func] = function f(a, b, c) {
          if (!(this instanceof f)) return new f(a, b, c);
          this._a = a;
          this._b = b;
          this._c = c;
          return this;
        };
        // distribution method to be used on a jStat instance
        jStat.fn[func] = function (a, b, c) {
          var newthis = jStat[func](a, b, c);
          newthis.data = this;
          return newthis;
        };
        // sample instance method
        jStat[func].prototype.sample = function (arr) {
          var a = this._a;
          var b = this._b;
          var c = this._c;
          if (arr) return jStat.alter(arr, function () {
            return jStat[func].sample(a, b, c);
          });else return jStat[func].sample(a, b, c);
        };
        // generate the pdf, cdf and inv instance methods
        (function (vals) {
          for (var i = 0; i < vals.length; i++) (function (fnfunc) {
            jStat[func].prototype[fnfunc] = function (x) {
              var a = this._a;
              var b = this._b;
              var c = this._c;
              if (!x && x !== 0) x = this.data;
              if (typeof x !== 'number') {
                return jStat.fn.map.call(x, function (x) {
                  return jStat[func][fnfunc](x, a, b, c);
                });
              }
              return jStat[func][fnfunc](x, a, b, c);
            };
          })(vals[i]);
        })('pdf cdf inv'.split(' '));
        // generate the mean, median, mode and variance instance methods
        (function (vals) {
          for (var i = 0; i < vals.length; i++) (function (fnfunc) {
            jStat[func].prototype[fnfunc] = function () {
              return jStat[func][fnfunc](this._a, this._b, this._c);
            };
          })(vals[i]);
        })('mean median mode variance'.split(' '));
      })(list[i]);
    })(('beta centralF cauchy chisquare exponential gamma invgamma kumaraswamy ' + 'laplace lognormal noncentralt normal pareto studentt weibull uniform ' + 'binomial negbin hypgeom poisson triangular tukey arcsine').split(' '));

    // extend beta function with static methods
    jStat.extend(jStat.beta, {
      pdf: function pdf(x, alpha, beta) {
        // PDF is zero outside the support
        if (x > 1 || x < 0) return 0;
        // PDF is one for the uniform case
        if (alpha == 1 && beta == 1) return 1;
        if (alpha < 512 && beta < 512) {
          return Math.pow(x, alpha - 1) * Math.pow(1 - x, beta - 1) / jStat.betafn(alpha, beta);
        } else {
          return Math.exp((alpha - 1) * Math.log(x) + (beta - 1) * Math.log(1 - x) - jStat.betaln(alpha, beta));
        }
      },
      cdf: function cdf(x, alpha, beta) {
        return x > 1 || x < 0 ? (x > 1) * 1 : jStat.ibeta(x, alpha, beta);
      },
      inv: function inv(x, alpha, beta) {
        return jStat.ibetainv(x, alpha, beta);
      },
      mean: function mean(alpha, beta) {
        return alpha / (alpha + beta);
      },
      median: function median(alpha, beta) {
        return jStat.ibetainv(0.5, alpha, beta);
      },
      mode: function mode(alpha, beta) {
        return (alpha - 1) / (alpha + beta - 2);
      },
      // return a random sample
      sample: function sample(alpha, beta) {
        var u = jStat.randg(alpha);
        return u / (u + jStat.randg(beta));
      },
      variance: function variance(alpha, beta) {
        return alpha * beta / (Math.pow(alpha + beta, 2) * (alpha + beta + 1));
      }
    });

    // extend F function with static methods
    jStat.extend(jStat.centralF, {
      // This implementation of the pdf function avoids float overflow
      // See the way that R calculates this value:
      // https://svn.r-project.org/R/trunk/src/nmath/df.c
      pdf: function pdf(x, df1, df2) {
        var p, q, f;
        if (x < 0) return 0;
        if (df1 <= 2) {
          if (x === 0 && df1 < 2) {
            return Infinity;
          }
          if (x === 0 && df1 === 2) {
            return 1;
          }
          return 1 / jStat.betafn(df1 / 2, df2 / 2) * Math.pow(df1 / df2, df1 / 2) * Math.pow(x, df1 / 2 - 1) * Math.pow(1 + df1 / df2 * x, -(df1 + df2) / 2);
        }
        p = df1 * x / (df2 + x * df1);
        q = df2 / (df2 + x * df1);
        f = df1 * q / 2.0;
        return f * jStat.binomial.pdf((df1 - 2) / 2, (df1 + df2 - 2) / 2, p);
      },
      cdf: function cdf(x, df1, df2) {
        if (x < 0) return 0;
        return jStat.ibeta(df1 * x / (df1 * x + df2), df1 / 2, df2 / 2);
      },
      inv: function inv(x, df1, df2) {
        return df2 / (df1 * (1 / jStat.ibetainv(x, df1 / 2, df2 / 2) - 1));
      },
      mean: function mean(df1, df2) {
        return df2 > 2 ? df2 / (df2 - 2) : undefined;
      },
      mode: function mode(df1, df2) {
        return df1 > 2 ? df2 * (df1 - 2) / (df1 * (df2 + 2)) : undefined;
      },
      // return a random sample
      sample: function sample(df1, df2) {
        var x1 = jStat.randg(df1 / 2) * 2;
        var x2 = jStat.randg(df2 / 2) * 2;
        return x1 / df1 / (x2 / df2);
      },
      variance: function variance(df1, df2) {
        if (df2 <= 4) return undefined;
        return 2 * df2 * df2 * (df1 + df2 - 2) / (df1 * (df2 - 2) * (df2 - 2) * (df2 - 4));
      }
    });

    // extend cauchy function with static methods
    jStat.extend(jStat.cauchy, {
      pdf: function pdf(x, local, scale) {
        if (scale < 0) {
          return 0;
        }
        return scale / (Math.pow(x - local, 2) + Math.pow(scale, 2)) / Math.PI;
      },
      cdf: function cdf(x, local, scale) {
        return Math.atan((x - local) / scale) / Math.PI + 0.5;
      },
      inv: function (p, local, scale) {
        return local + scale * Math.tan(Math.PI * (p - 0.5));
      },
      median: function median(local /*, scale*/) {
        return local;
      },
      mode: function mode(local /*, scale*/) {
        return local;
      },
      sample: function sample(local, scale) {
        return jStat.randn() * Math.sqrt(1 / (2 * jStat.randg(0.5))) * scale + local;
      }
    });

    // extend chisquare function with static methods
    jStat.extend(jStat.chisquare, {
      pdf: function pdf(x, dof) {
        if (x < 0) return 0;
        return x === 0 && dof === 2 ? 0.5 : Math.exp((dof / 2 - 1) * Math.log(x) - x / 2 - dof / 2 * Math.log(2) - jStat.gammaln(dof / 2));
      },
      cdf: function cdf(x, dof) {
        if (x < 0) return 0;
        return jStat.lowRegGamma(dof / 2, x / 2);
      },
      inv: function (p, dof) {
        return 2 * jStat.gammapinv(p, 0.5 * dof);
      },
      mean: function (dof) {
        return dof;
      },
      // TODO: this is an approximation (is there a better way?)
      median: function median(dof) {
        return dof * Math.pow(1 - 2 / (9 * dof), 3);
      },
      mode: function mode(dof) {
        return dof - 2 > 0 ? dof - 2 : 0;
      },
      sample: function sample(dof) {
        return jStat.randg(dof / 2) * 2;
      },
      variance: function variance(dof) {
        return 2 * dof;
      }
    });

    // extend exponential function with static methods
    jStat.extend(jStat.exponential, {
      pdf: function pdf(x, rate) {
        return x < 0 ? 0 : rate * Math.exp(-rate * x);
      },
      cdf: function cdf(x, rate) {
        return x < 0 ? 0 : 1 - Math.exp(-rate * x);
      },
      inv: function (p, rate) {
        return -Math.log(1 - p) / rate;
      },
      mean: function (rate) {
        return 1 / rate;
      },
      median: function (rate) {
        return 1 / rate * Math.log(2);
      },
      mode: function mode(/*rate*/
      ) {
        return 0;
      },
      sample: function sample(rate) {
        return -1 / rate * Math.log(jStat._random_fn());
      },
      variance: function (rate) {
        return Math.pow(rate, -2);
      }
    });

    // extend gamma function with static methods
    jStat.extend(jStat.gamma, {
      pdf: function pdf(x, shape, scale) {
        if (x < 0) return 0;
        return x === 0 && shape === 1 ? 1 / scale : Math.exp((shape - 1) * Math.log(x) - x / scale - jStat.gammaln(shape) - shape * Math.log(scale));
      },
      cdf: function cdf(x, shape, scale) {
        if (x < 0) return 0;
        return jStat.lowRegGamma(shape, x / scale);
      },
      inv: function (p, shape, scale) {
        return jStat.gammapinv(p, shape) * scale;
      },
      mean: function (shape, scale) {
        return shape * scale;
      },
      mode: function mode(shape, scale) {
        if (shape > 1) return (shape - 1) * scale;
        return undefined;
      },
      sample: function sample(shape, scale) {
        return jStat.randg(shape) * scale;
      },
      variance: function variance(shape, scale) {
        return shape * scale * scale;
      }
    });

    // extend inverse gamma function with static methods
    jStat.extend(jStat.invgamma, {
      pdf: function pdf(x, shape, scale) {
        if (x <= 0) return 0;
        return Math.exp(-(shape + 1) * Math.log(x) - scale / x - jStat.gammaln(shape) + shape * Math.log(scale));
      },
      cdf: function cdf(x, shape, scale) {
        if (x <= 0) return 0;
        return 1 - jStat.lowRegGamma(shape, scale / x);
      },
      inv: function (p, shape, scale) {
        return scale / jStat.gammapinv(1 - p, shape);
      },
      mean: function (shape, scale) {
        return shape > 1 ? scale / (shape - 1) : undefined;
      },
      mode: function mode(shape, scale) {
        return scale / (shape + 1);
      },
      sample: function sample(shape, scale) {
        return scale / jStat.randg(shape);
      },
      variance: function variance(shape, scale) {
        if (shape <= 2) return undefined;
        return scale * scale / ((shape - 1) * (shape - 1) * (shape - 2));
      }
    });

    // extend kumaraswamy function with static methods
    jStat.extend(jStat.kumaraswamy, {
      pdf: function pdf(x, alpha, beta) {
        if (x === 0 && alpha === 1) return beta;else if (x === 1 && beta === 1) return alpha;
        return Math.exp(Math.log(alpha) + Math.log(beta) + (alpha - 1) * Math.log(x) + (beta - 1) * Math.log(1 - Math.pow(x, alpha)));
      },
      cdf: function cdf(x, alpha, beta) {
        if (x < 0) return 0;else if (x > 1) return 1;
        return 1 - Math.pow(1 - Math.pow(x, alpha), beta);
      },
      inv: function inv(p, alpha, beta) {
        return Math.pow(1 - Math.pow(1 - p, 1 / beta), 1 / alpha);
      },
      mean: function (alpha, beta) {
        return beta * jStat.gammafn(1 + 1 / alpha) * jStat.gammafn(beta) / jStat.gammafn(1 + 1 / alpha + beta);
      },
      median: function median(alpha, beta) {
        return Math.pow(1 - Math.pow(2, -1 / beta), 1 / alpha);
      },
      mode: function mode(alpha, beta) {
        if (!(alpha >= 1 && beta >= 1 && alpha !== 1 && beta !== 1)) return undefined;
        return Math.pow((alpha - 1) / (alpha * beta - 1), 1 / alpha);
      },
      variance: function variance(/*alpha, beta*/
      ) {
        throw new Error('variance not yet implemented');
        // TODO: complete this
      }
    });

    // extend lognormal function with static methods
    jStat.extend(jStat.lognormal, {
      pdf: function pdf(x, mu, sigma) {
        if (x <= 0) return 0;
        return Math.exp(-Math.log(x) - 0.5 * Math.log(2 * Math.PI) - Math.log(sigma) - Math.pow(Math.log(x) - mu, 2) / (2 * sigma * sigma));
      },
      cdf: function cdf(x, mu, sigma) {
        if (x < 0) return 0;
        return 0.5 + 0.5 * jStat.erf((Math.log(x) - mu) / Math.sqrt(2 * sigma * sigma));
      },
      inv: function (p, mu, sigma) {
        return Math.exp(-1.41421356237309505 * sigma * jStat.erfcinv(2 * p) + mu);
      },
      mean: function mean(mu, sigma) {
        return Math.exp(mu + sigma * sigma / 2);
      },
      median: function median(mu /*, sigma*/) {
        return Math.exp(mu);
      },
      mode: function mode(mu, sigma) {
        return Math.exp(mu - sigma * sigma);
      },
      sample: function sample(mu, sigma) {
        return Math.exp(jStat.randn() * sigma + mu);
      },
      variance: function variance(mu, sigma) {
        return (Math.exp(sigma * sigma) - 1) * Math.exp(2 * mu + sigma * sigma);
      }
    });

    // extend noncentralt function with static methods
    jStat.extend(jStat.noncentralt, {
      pdf: function pdf(x, dof, ncp) {
        var tol = 1e-14;
        if (Math.abs(ncp) < tol)
          // ncp approx 0; use student-t
          return jStat.studentt.pdf(x, dof);
        if (Math.abs(x) < tol) {
          // different formula for x == 0
          return Math.exp(jStat.gammaln((dof + 1) / 2) - ncp * ncp / 2 - 0.5 * Math.log(Math.PI * dof) - jStat.gammaln(dof / 2));
        }

        // formula for x != 0
        return dof / x * (jStat.noncentralt.cdf(x * Math.sqrt(1 + 2 / dof), dof + 2, ncp) - jStat.noncentralt.cdf(x, dof, ncp));
      },
      cdf: function cdf(x, dof, ncp) {
        var tol = 1e-14;
        var min_iterations = 200;
        if (Math.abs(ncp) < tol)
          // ncp approx 0; use student-t
          return jStat.studentt.cdf(x, dof);

        // turn negative x into positive and flip result afterwards
        var flip = false;
        if (x < 0) {
          flip = true;
          ncp = -ncp;
        }
        var prob = jStat.normal.cdf(-ncp, 0, 1);
        var value = tol + 1;
        // use value at last two steps to determine convergence
        var lastvalue = value;
        var y = x * x / (x * x + dof);
        var j = 0;
        var p = Math.exp(-ncp * ncp / 2);
        var q = Math.exp(-ncp * ncp / 2 - 0.5 * Math.log(2) - jStat.gammaln(3 / 2)) * ncp;
        while (j < min_iterations || lastvalue > tol || value > tol) {
          lastvalue = value;
          if (j > 0) {
            p *= ncp * ncp / (2 * j);
            q *= ncp * ncp / (2 * (j + 1 / 2));
          }
          value = p * jStat.beta.cdf(y, j + 0.5, dof / 2) + q * jStat.beta.cdf(y, j + 1, dof / 2);
          prob += 0.5 * value;
          j++;
        }
        return flip ? 1 - prob : prob;
      }
    });

    // extend normal function with static methods
    jStat.extend(jStat.normal, {
      pdf: function pdf(x, mean, std) {
        return Math.exp(-0.5 * Math.log(2 * Math.PI) - Math.log(std) - Math.pow(x - mean, 2) / (2 * std * std));
      },
      cdf: function cdf(x, mean, std) {
        return 0.5 * (1 + jStat.erf((x - mean) / Math.sqrt(2 * std * std)));
      },
      inv: function (p, mean, std) {
        return -1.41421356237309505 * std * jStat.erfcinv(2 * p) + mean;
      },
      mean: function (mean /*, std*/) {
        return mean;
      },
      median: function median(mean /*, std*/) {
        return mean;
      },
      mode: function (mean /*, std*/) {
        return mean;
      },
      sample: function sample(mean, std) {
        return jStat.randn() * std + mean;
      },
      variance: function (mean, std) {
        return std * std;
      }
    });

    // extend pareto function with static methods
    jStat.extend(jStat.pareto, {
      pdf: function pdf(x, scale, shape) {
        if (x < scale) return 0;
        return shape * Math.pow(scale, shape) / Math.pow(x, shape + 1);
      },
      cdf: function cdf(x, scale, shape) {
        if (x < scale) return 0;
        return 1 - Math.pow(scale / x, shape);
      },
      inv: function inv(p, scale, shape) {
        return scale / Math.pow(1 - p, 1 / shape);
      },
      mean: function mean(scale, shape) {
        if (shape <= 1) return undefined;
        return shape * Math.pow(scale, shape) / (shape - 1);
      },
      median: function median(scale, shape) {
        return scale * (shape * Math.SQRT2);
      },
      mode: function mode(scale /*, shape*/) {
        return scale;
      },
      variance: function (scale, shape) {
        if (shape <= 2) return undefined;
        return scale * scale * shape / (Math.pow(shape - 1, 2) * (shape - 2));
      }
    });

    // extend studentt function with static methods
    jStat.extend(jStat.studentt, {
      pdf: function pdf(x, dof) {
        dof = dof > 1e100 ? 1e100 : dof;
        return 1 / (Math.sqrt(dof) * jStat.betafn(0.5, dof / 2)) * Math.pow(1 + x * x / dof, -((dof + 1) / 2));
      },
      cdf: function cdf(x, dof) {
        var dof2 = dof / 2;
        return jStat.ibeta((x + Math.sqrt(x * x + dof)) / (2 * Math.sqrt(x * x + dof)), dof2, dof2);
      },
      inv: function (p, dof) {
        var x = jStat.ibetainv(2 * Math.min(p, 1 - p), 0.5 * dof, 0.5);
        x = Math.sqrt(dof * (1 - x) / x);
        return p > 0.5 ? x : -x;
      },
      mean: function mean(dof) {
        return dof > 1 ? 0 : undefined;
      },
      median: function median(/*dof*/
      ) {
        return 0;
      },
      mode: function mode(/*dof*/
      ) {
        return 0;
      },
      sample: function sample(dof) {
        return jStat.randn() * Math.sqrt(dof / (2 * jStat.randg(dof / 2)));
      },
      variance: function variance(dof) {
        return dof > 2 ? dof / (dof - 2) : dof > 1 ? Infinity : undefined;
      }
    });

    // extend weibull function with static methods
    jStat.extend(jStat.weibull, {
      pdf: function pdf(x, scale, shape) {
        if (x < 0 || scale < 0 || shape < 0) return 0;
        return shape / scale * Math.pow(x / scale, shape - 1) * Math.exp(-Math.pow(x / scale, shape));
      },
      cdf: function cdf(x, scale, shape) {
        return x < 0 ? 0 : 1 - Math.exp(-Math.pow(x / scale, shape));
      },
      inv: function (p, scale, shape) {
        return scale * Math.pow(-Math.log(1 - p), 1 / shape);
      },
      mean: function (scale, shape) {
        return scale * jStat.gammafn(1 + 1 / shape);
      },
      median: function median(scale, shape) {
        return scale * Math.pow(Math.log(2), 1 / shape);
      },
      mode: function mode(scale, shape) {
        if (shape <= 1) return 0;
        return scale * Math.pow((shape - 1) / shape, 1 / shape);
      },
      sample: function sample(scale, shape) {
        return scale * Math.pow(-Math.log(jStat._random_fn()), 1 / shape);
      },
      variance: function variance(scale, shape) {
        return scale * scale * jStat.gammafn(1 + 2 / shape) - Math.pow(jStat.weibull.mean(scale, shape), 2);
      }
    });

    // extend uniform function with static methods
    jStat.extend(jStat.uniform, {
      pdf: function pdf(x, a, b) {
        return x < a || x > b ? 0 : 1 / (b - a);
      },
      cdf: function cdf(x, a, b) {
        if (x < a) return 0;else if (x < b) return (x - a) / (b - a);
        return 1;
      },
      inv: function (p, a, b) {
        return a + p * (b - a);
      },
      mean: function mean(a, b) {
        return 0.5 * (a + b);
      },
      median: function median(a, b) {
        return jStat.mean(a, b);
      },
      mode: function mode(/*a, b*/
      ) {
        throw new Error('mode is not yet implemented');
      },
      sample: function sample(a, b) {
        return a / 2 + b / 2 + (b / 2 - a / 2) * (2 * jStat._random_fn() - 1);
      },
      variance: function variance(a, b) {
        return Math.pow(b - a, 2) / 12;
      }
    });

    // Got this from http://www.math.ucla.edu/~tom/distributions/binomial.html
    function betinc(x, a, b, eps) {
      var a0 = 0;
      var b0 = 1;
      var a1 = 1;
      var b1 = 1;
      var m9 = 0;
      var a2 = 0;
      var c9;
      while (Math.abs((a1 - a2) / a1) > eps) {
        a2 = a1;
        c9 = -(a + m9) * (a + b + m9) * x / (a + 2 * m9) / (a + 2 * m9 + 1);
        a0 = a1 + c9 * a0;
        b0 = b1 + c9 * b0;
        m9 = m9 + 1;
        c9 = m9 * (b - m9) * x / (a + 2 * m9 - 1) / (a + 2 * m9);
        a1 = a0 + c9 * a1;
        b1 = b0 + c9 * b1;
        a0 = a0 / b1;
        b0 = b0 / b1;
        a1 = a1 / b1;
        b1 = 1;
      }
      return a1 / a;
    }

    // extend uniform function with static methods
    jStat.extend(jStat.binomial, {
      pdf: function pdf(k, n, p) {
        return p === 0 || p === 1 ? n * p === k ? 1 : 0 : jStat.combination(n, k) * Math.pow(p, k) * Math.pow(1 - p, n - k);
      },
      cdf: function cdf(x, n, p) {
        var betacdf;
        var eps = 1e-10;
        if (x < 0) return 0;
        if (x >= n) return 1;
        if (p < 0 || p > 1 || n <= 0) return NaN;
        x = Math.floor(x);
        var z = p;
        var a = x + 1;
        var b = n - x;
        var s = a + b;
        var bt = Math.exp(jStat.gammaln(s) - jStat.gammaln(b) - jStat.gammaln(a) + a * Math.log(z) + b * Math.log(1 - z));
        if (z < (a + 1) / (s + 2)) betacdf = bt * betinc(z, a, b, eps);else betacdf = 1 - bt * betinc(1 - z, b, a, eps);
        return Math.round((1 - betacdf) * (1 / eps)) / (1 / eps);
      }
    });

    // extend uniform function with static methods
    jStat.extend(jStat.negbin, {
      pdf: function pdf(k, r, p) {
        if (k !== k >>> 0) return false;
        if (k < 0) return 0;
        return jStat.combination(k + r - 1, r - 1) * Math.pow(1 - p, k) * Math.pow(p, r);
      },
      cdf: function cdf(x, r, p) {
        var sum = 0,
          k = 0;
        if (x < 0) return 0;
        for (; k <= x; k++) {
          sum += jStat.negbin.pdf(k, r, p);
        }
        return sum;
      }
    });

    // extend uniform function with static methods
    jStat.extend(jStat.hypgeom, {
      pdf: function pdf(k, N, m, n) {
        // Hypergeometric PDF.

        // A simplification of the CDF algorithm below.

        // k = number of successes drawn
        // N = population size
        // m = number of successes in population
        // n = number of items drawn from population

        if (k !== k | 0) {
          return false;
        } else if (k < 0 || k < m - (N - n)) {
          // It's impossible to have this few successes drawn.
          return 0;
        } else if (k > n || k > m) {
          // It's impossible to have this many successes drawn.
          return 0;
        } else if (m * 2 > N) {
          // More than half the population is successes.

          if (n * 2 > N) {
            // More than half the population is sampled.

            return jStat.hypgeom.pdf(N - m - n + k, N, N - m, N - n);
          } else {
            // Half or less of the population is sampled.

            return jStat.hypgeom.pdf(n - k, N, N - m, n);
          }
        } else if (n * 2 > N) {
          // Half or less is successes.

          return jStat.hypgeom.pdf(m - k, N, m, N - n);
        } else if (m < n) {
          // We want to have the number of things sampled to be less than the
          // successes available. So swap the definitions of successful and sampled.
          return jStat.hypgeom.pdf(k, N, n, m);
        } else {
          // If we get here, half or less of the population was sampled, half or
          // less of it was successes, and we had fewer sampled things than
          // successes. Now we can do this complicated iterative algorithm in an
          // efficient way.

          // The basic premise of the algorithm is that we partially normalize our
          // intermediate product to keep it in a numerically good region, and then
          // finish the normalization at the end.

          // This variable holds the scaled probability of the current number of
          // successes.
          var scaledPDF = 1;

          // This keeps track of how much we have normalized.
          var samplesDone = 0;
          for (var i = 0; i < k; i++) {
            // For every possible number of successes up to that observed...

            while (scaledPDF > 1 && samplesDone < n) {
              // Intermediate result is growing too big. Apply some of the
              // normalization to shrink everything.

              scaledPDF *= 1 - m / (N - samplesDone);

              // Say we've normalized by this sample already.
              samplesDone++;
            }

            // Work out the partially-normalized hypergeometric PDF for the next
            // number of successes
            scaledPDF *= (n - i) * (m - i) / ((i + 1) * (N - m - n + i + 1));
          }
          for (; samplesDone < n; samplesDone++) {
            // Apply all the rest of the normalization
            scaledPDF *= 1 - m / (N - samplesDone);
          }

          // Bound answer sanely before returning.
          return Math.min(1, Math.max(0, scaledPDF));
        }
      },
      cdf: function cdf(x, N, m, n) {
        // Hypergeometric CDF.

        // This algorithm is due to Prof. Thomas S. Ferguson, <tom@math.ucla.edu>,
        // and comes from his hypergeometric test calculator at
        // <http://www.math.ucla.edu/~tom/distributions/Hypergeometric.html>.

        // x = number of successes drawn
        // N = population size
        // m = number of successes in population
        // n = number of items drawn from population

        if (x < 0 || x < m - (N - n)) {
          // It's impossible to have this few successes drawn or fewer.
          return 0;
        } else if (x >= n || x >= m) {
          // We will always have this many successes or fewer.
          return 1;
        } else if (m * 2 > N) {
          // More than half the population is successes.

          if (n * 2 > N) {
            // More than half the population is sampled.

            return jStat.hypgeom.cdf(N - m - n + x, N, N - m, N - n);
          } else {
            // Half or less of the population is sampled.

            return 1 - jStat.hypgeom.cdf(n - x - 1, N, N - m, n);
          }
        } else if (n * 2 > N) {
          // Half or less is successes.

          return 1 - jStat.hypgeom.cdf(m - x - 1, N, m, N - n);
        } else if (m < n) {
          // We want to have the number of things sampled to be less than the
          // successes available. So swap the definitions of successful and sampled.
          return jStat.hypgeom.cdf(x, N, n, m);
        } else {
          // If we get here, half or less of the population was sampled, half or
          // less of it was successes, and we had fewer sampled things than
          // successes. Now we can do this complicated iterative algorithm in an
          // efficient way.

          // The basic premise of the algorithm is that we partially normalize our
          // intermediate sum to keep it in a numerically good region, and then
          // finish the normalization at the end.

          // Holds the intermediate, scaled total CDF.
          var scaledCDF = 1;

          // This variable holds the scaled probability of the current number of
          // successes.
          var scaledPDF = 1;

          // This keeps track of how much we have normalized.
          var samplesDone = 0;
          for (var i = 0; i < x; i++) {
            // For every possible number of successes up to that observed...

            while (scaledCDF > 1 && samplesDone < n) {
              // Intermediate result is growing too big. Apply some of the
              // normalization to shrink everything.

              var factor = 1 - m / (N - samplesDone);
              scaledPDF *= factor;
              scaledCDF *= factor;

              // Say we've normalized by this sample already.
              samplesDone++;
            }

            // Work out the partially-normalized hypergeometric PDF for the next
            // number of successes
            scaledPDF *= (n - i) * (m - i) / ((i + 1) * (N - m - n + i + 1));

            // Add to the CDF answer.
            scaledCDF += scaledPDF;
          }
          for (; samplesDone < n; samplesDone++) {
            // Apply all the rest of the normalization
            scaledCDF *= 1 - m / (N - samplesDone);
          }

          // Bound answer sanely before returning.
          return Math.min(1, Math.max(0, scaledCDF));
        }
      }
    });

    // extend uniform function with static methods
    jStat.extend(jStat.poisson, {
      pdf: function pdf(k, l) {
        if (l < 0 || k % 1 !== 0 || k < 0) {
          return 0;
        }
        return Math.pow(l, k) * Math.exp(-l) / jStat.factorial(k);
      },
      cdf: function cdf(x, l) {
        var sumarr = [],
          k = 0;
        if (x < 0) return 0;
        for (; k <= x; k++) {
          sumarr.push(jStat.poisson.pdf(k, l));
        }
        return jStat.sum(sumarr);
      },
      mean: function (l) {
        return l;
      },
      variance: function (l) {
        return l;
      },
      sampleSmall: function sampleSmall(l) {
        var p = 1,
          k = 0,
          L = Math.exp(-l);
        do {
          k++;
          p *= jStat._random_fn();
        } while (p > L);
        return k - 1;
      },
      sampleLarge: function sampleLarge(l) {
        var lam = l;
        var k;
        var U, V, slam, loglam, a, b, invalpha, vr, us;
        slam = Math.sqrt(lam);
        loglam = Math.log(lam);
        b = 0.931 + 2.53 * slam;
        a = -0.059 + 0.02483 * b;
        invalpha = 1.1239 + 1.1328 / (b - 3.4);
        vr = 0.9277 - 3.6224 / (b - 2);
        while (1) {
          U = Math.random() - 0.5;
          V = Math.random();
          us = 0.5 - Math.abs(U);
          k = Math.floor((2 * a / us + b) * U + lam + 0.43);
          if (us >= 0.07 && V <= vr) {
            return k;
          }
          if (k < 0 || us < 0.013 && V > us) {
            continue;
          }
          /* log(V) == log(0.0) ok here */
          /* if U==0.0 so that us==0.0, log is ok since always returns */
          if (Math.log(V) + Math.log(invalpha) - Math.log(a / (us * us) + b) <= -lam + k * loglam - jStat.loggam(k + 1)) {
            return k;
          }
        }
      },
      sample: function sample(l) {
        if (l < 10) return this.sampleSmall(l);else return this.sampleLarge(l);
      }
    });

    // extend triangular function with static methods
    jStat.extend(jStat.triangular, {
      pdf: function pdf(x, a, b, c) {
        if (b <= a || c < a || c > b) {
          return NaN;
        } else {
          if (x < a || x > b) {
            return 0;
          } else if (x < c) {
            return 2 * (x - a) / ((b - a) * (c - a));
          } else if (x === c) {
            return 2 / (b - a);
          } else {
            // x > c
            return 2 * (b - x) / ((b - a) * (b - c));
          }
        }
      },
      cdf: function cdf(x, a, b, c) {
        if (b <= a || c < a || c > b) return NaN;
        if (x <= a) return 0;else if (x >= b) return 1;
        if (x <= c) return Math.pow(x - a, 2) / ((b - a) * (c - a));else
          // x > c
          return 1 - Math.pow(b - x, 2) / ((b - a) * (b - c));
      },
      inv: function inv(p, a, b, c) {
        if (b <= a || c < a || c > b) {
          return NaN;
        } else {
          if (p <= (c - a) / (b - a)) {
            return a + (b - a) * Math.sqrt(p * ((c - a) / (b - a)));
          } else {
            // p > ((c - a) / (b - a))
            return a + (b - a) * (1 - Math.sqrt((1 - p) * (1 - (c - a) / (b - a))));
          }
        }
      },
      mean: function mean(a, b, c) {
        return (a + b + c) / 3;
      },
      median: function median(a, b, c) {
        if (c <= (a + b) / 2) {
          return b - Math.sqrt((b - a) * (b - c)) / Math.sqrt(2);
        } else if (c > (a + b) / 2) {
          return a + Math.sqrt((b - a) * (c - a)) / Math.sqrt(2);
        }
      },
      mode: function mode(a, b, c) {
        return c;
      },
      sample: function sample(a, b, c) {
        var u = jStat._random_fn();
        if (u < (c - a) / (b - a)) return a + Math.sqrt(u * (b - a) * (c - a));
        return b - Math.sqrt((1 - u) * (b - a) * (b - c));
      },
      variance: function variance(a, b, c) {
        return (a * a + b * b + c * c - a * b - a * c - b * c) / 18;
      }
    });

    // extend arcsine function with static methods
    jStat.extend(jStat.arcsine, {
      pdf: function pdf(x, a, b) {
        if (b <= a) return NaN;
        return x <= a || x >= b ? 0 : 2 / Math.PI * Math.pow(Math.pow(b - a, 2) - Math.pow(2 * x - a - b, 2), -0.5);
      },
      cdf: function cdf(x, a, b) {
        if (x < a) return 0;else if (x < b) return 2 / Math.PI * Math.asin(Math.sqrt((x - a) / (b - a)));
        return 1;
      },
      inv: function (p, a, b) {
        return a + (0.5 - 0.5 * Math.cos(Math.PI * p)) * (b - a);
      },
      mean: function mean(a, b) {
        if (b <= a) return NaN;
        return (a + b) / 2;
      },
      median: function median(a, b) {
        if (b <= a) return NaN;
        return (a + b) / 2;
      },
      mode: function mode(/*a, b*/
      ) {
        throw new Error('mode is not yet implemented');
      },
      sample: function sample(a, b) {
        return (a + b) / 2 + (b - a) / 2 * Math.sin(2 * Math.PI * jStat.uniform.sample(0, 1));
      },
      variance: function variance(a, b) {
        if (b <= a) return NaN;
        return Math.pow(b - a, 2) / 8;
      }
    });
    function laplaceSign(x) {
      return x / Math.abs(x);
    }
    jStat.extend(jStat.laplace, {
      pdf: function pdf(x, mu, b) {
        return b <= 0 ? 0 : Math.exp(-Math.abs(x - mu) / b) / (2 * b);
      },
      cdf: function cdf(x, mu, b) {
        if (b <= 0) {
          return 0;
        }
        if (x < mu) {
          return 0.5 * Math.exp((x - mu) / b);
        } else {
          return 1 - 0.5 * Math.exp(-(x - mu) / b);
        }
      },
      mean: function (mu /*, b*/) {
        return mu;
      },
      median: function (mu /*, b*/) {
        return mu;
      },
      mode: function (mu /*, b*/) {
        return mu;
      },
      variance: function (mu, b) {
        return 2 * b * b;
      },
      sample: function sample(mu, b) {
        var u = jStat._random_fn() - 0.5;
        return mu - b * laplaceSign(u) * Math.log(1 - 2 * Math.abs(u));
      }
    });
    function tukeyWprob(w, rr, cc) {
      var nleg = 12;
      var ihalf = 6;
      var C1 = -30;
      var C2 = -50;
      var C3 = 60;
      var bb = 8;
      var wlar = 3;
      var wincr1 = 2;
      var wincr2 = 3;
      var xleg = [0.981560634246719250690549090149, 0.904117256370474856678465866119, 0.769902674194304687036893833213, 0.587317954286617447296702418941, 0.367831498998180193752691536644, 0.125233408511468915472441369464];
      var aleg = [0.047175336386511827194615961485, 0.106939325995318430960254718194, 0.160078328543346226334652529543, 0.203167426723065921749064455810, 0.233492536538354808760849898925, 0.249147045813402785000562436043];
      var qsqz = w * 0.5;

      // if w >= 16 then the integral lower bound (occurs for c=20)
      // is 0.99999999999995 so return a value of 1.

      if (qsqz >= bb) return 1.0;

      // find (f(w/2) - 1) ^ cc
      // (first term in integral of hartley's form).

      var pr_w = 2 * jStat.normal.cdf(qsqz, 0, 1, 1, 0) - 1; // erf(qsqz / M_SQRT2)
      // if pr_w ^ cc < 2e-22 then set pr_w = 0
      if (pr_w >= Math.exp(C2 / cc)) pr_w = Math.pow(pr_w, cc);else pr_w = 0.0;

      // if w is large then the second component of the
      // integral is small, so fewer intervals are needed.

      var wincr;
      if (w > wlar) wincr = wincr1;else wincr = wincr2;

      // find the integral of second term of hartley's form
      // for the integral of the range for equal-length
      // intervals using legendre quadrature.  limits of
      // integration are from (w/2, 8).  two or three
      // equal-length intervals are used.

      // blb and bub are lower and upper limits of integration.

      var blb = qsqz;
      var binc = (bb - qsqz) / wincr;
      var bub = blb + binc;
      var einsum = 0.0;

      // integrate over each interval

      var cc1 = cc - 1.0;
      for (var wi = 1; wi <= wincr; wi++) {
        var elsum = 0.0;
        var a = 0.5 * (bub + blb);

        // legendre quadrature with order = nleg

        var b = 0.5 * (bub - blb);
        for (var jj = 1; jj <= nleg; jj++) {
          var j, xx;
          if (ihalf < jj) {
            j = nleg - jj + 1;
            xx = xleg[j - 1];
          } else {
            j = jj;
            xx = -xleg[j - 1];
          }
          var c = b * xx;
          var ac = a + c;

          // if exp(-qexpo/2) < 9e-14,
          // then doesn't contribute to integral

          var qexpo = ac * ac;
          if (qexpo > C3) break;
          var pplus = 2 * jStat.normal.cdf(ac, 0, 1, 1, 0);
          var pminus = 2 * jStat.normal.cdf(ac, w, 1, 1, 0);

          // if rinsum ^ (cc-1) < 9e-14,
          // then doesn't contribute to integral

          var rinsum = pplus * 0.5 - pminus * 0.5;
          if (rinsum >= Math.exp(C1 / cc1)) {
            rinsum = aleg[j - 1] * Math.exp(-(0.5 * qexpo)) * Math.pow(rinsum, cc1);
            elsum += rinsum;
          }
        }
        elsum *= 2.0 * b * cc / Math.sqrt(2 * Math.PI);
        einsum += elsum;
        blb = bub;
        bub += binc;
      }

      // if pr_w ^ rr < 9e-14, then return 0
      pr_w += einsum;
      if (pr_w <= Math.exp(C1 / rr)) return 0;
      pr_w = Math.pow(pr_w, rr);
      if (pr_w >= 1)
        // 1 was iMax was eps
        return 1;
      return pr_w;
    }
    function tukeyQinv(p, c, v) {
      var p0 = 0.322232421088;
      var q0 = 0.993484626060e-01;
      var p1 = -1.0;
      var q1 = 0.588581570495;
      var p2 = -0.342242088547;
      var q2 = 0.531103462366;
      var p3 = -0.204231210125;
      var q3 = 0.103537752850;
      var p4 = -0.453642210148e-04;
      var q4 = 0.38560700634e-02;
      var c1 = 0.8832;
      var c2 = 0.2368;
      var c3 = 1.214;
      var c4 = 1.208;
      var c5 = 1.4142;
      var vmax = 120.0;
      var ps = 0.5 - 0.5 * p;
      var yi = Math.sqrt(Math.log(1.0 / (ps * ps)));
      var t = yi + ((((yi * p4 + p3) * yi + p2) * yi + p1) * yi + p0) / ((((yi * q4 + q3) * yi + q2) * yi + q1) * yi + q0);
      if (v < vmax) t += (t * t * t + t) / v / 4.0;
      var q = c1 - c2 * t;
      if (v < vmax) q += -c3 / v + c4 * t / v;
      return t * (q * Math.log(c - 1.0) + c5);
    }
    jStat.extend(jStat.tukey, {
      cdf: function cdf(q, nmeans, df) {
        // Identical implementation as the R ptukey() function as of commit 68947
        var rr = 1;
        var cc = nmeans;
        var nlegq = 16;
        var ihalfq = 8;
        var eps1 = -30.0;
        var eps2 = 1.0e-14;
        var dhaf = 100.0;
        var dquar = 800.0;
        var deigh = 5000.0;
        var dlarg = 25000.0;
        var ulen1 = 1.0;
        var ulen2 = 0.5;
        var ulen3 = 0.25;
        var ulen4 = 0.125;
        var xlegq = [0.989400934991649932596154173450, 0.944575023073232576077988415535, 0.865631202387831743880467897712, 0.755404408355003033895101194847, 0.617876244402643748446671764049, 0.458016777657227386342419442984, 0.281603550779258913230460501460, 0.950125098376374401853193354250e-1];
        var alegq = [0.271524594117540948517805724560e-1, 0.622535239386478928628438369944e-1, 0.951585116824927848099251076022e-1, 0.124628971255533872052476282192, 0.149595988816576732081501730547, 0.169156519395002538189312079030, 0.182603415044923588866763667969, 0.189450610455068496285396723208];
        if (q <= 0) return 0;

        // df must be > 1
        // there must be at least two values

        if (df < 2 || rr < 1 || cc < 2) return NaN;
        if (!Number.isFinite(q)) return 1;
        if (df > dlarg) return tukeyWprob(q, rr, cc);

        // calculate leading constant

        var f2 = df * 0.5;
        var f2lf = f2 * Math.log(df) - df * Math.log(2) - jStat.gammaln(f2);
        var f21 = f2 - 1.0;

        // integral is divided into unit, half-unit, quarter-unit, or
        // eighth-unit length intervals depending on the value of the
        // degrees of freedom.

        var ff4 = df * 0.25;
        var ulen;
        if (df <= dhaf) ulen = ulen1;else if (df <= dquar) ulen = ulen2;else if (df <= deigh) ulen = ulen3;else ulen = ulen4;
        f2lf += Math.log(ulen);

        // integrate over each subinterval

        var ans = 0.0;
        for (var i = 1; i <= 50; i++) {
          var otsum = 0.0;

          // legendre quadrature with order = nlegq
          // nodes (stored in xlegq) are symmetric around zero.

          var twa1 = (2 * i - 1) * ulen;
          for (var jj = 1; jj <= nlegq; jj++) {
            var j, t1;
            if (ihalfq < jj) {
              j = jj - ihalfq - 1;
              t1 = f2lf + f21 * Math.log(twa1 + xlegq[j] * ulen) - (xlegq[j] * ulen + twa1) * ff4;
            } else {
              j = jj - 1;
              t1 = f2lf + f21 * Math.log(twa1 - xlegq[j] * ulen) + (xlegq[j] * ulen - twa1) * ff4;
            }

            // if exp(t1) < 9e-14, then doesn't contribute to integral
            var qsqz;
            if (t1 >= eps1) {
              if (ihalfq < jj) {
                qsqz = q * Math.sqrt((xlegq[j] * ulen + twa1) * 0.5);
              } else {
                qsqz = q * Math.sqrt((-(xlegq[j] * ulen) + twa1) * 0.5);
              }

              // call wprob to find integral of range portion

              var wprb = tukeyWprob(qsqz, rr, cc);
              var rotsum = wprb * alegq[j] * Math.exp(t1);
              otsum += rotsum;
            }
            // end legendre integral for interval i
            // L200:
          }

          // if integral for interval i < 1e-14, then stop.
          // However, in order to avoid small area under left tail,
          // at least  1 / ulen  intervals are calculated.
          if (i * ulen >= 1.0 && otsum <= eps2) break;

          // end of interval i
          // L330:

          ans += otsum;
        }
        if (otsum > eps2) {
          // not converged
          throw new Error('tukey.cdf failed to converge');
        }
        if (ans > 1) ans = 1;
        return ans;
      },
      inv: function (p, nmeans, df) {
        // Identical implementation as the R qtukey() function as of commit 68947
        var rr = 1;
        var cc = nmeans;
        var eps = 0.0001;
        var maxiter = 50;

        // df must be > 1 ; there must be at least two values
        if (df < 2 || rr < 1 || cc < 2) return NaN;
        if (p < 0 || p > 1) return NaN;
        if (p === 0) return 0;
        if (p === 1) return Infinity;

        // Initial value

        var x0 = tukeyQinv(p, cc, df);

        // Find prob(value < x0)

        var valx0 = jStat.tukey.cdf(x0, nmeans, df) - p;

        // Find the second iterate and prob(value < x1).
        // If the first iterate has probability value
        // exceeding p then second iterate is 1 less than
        // first iterate; otherwise it is 1 greater.

        var x1;
        if (valx0 > 0.0) x1 = Math.max(0.0, x0 - 1.0);else x1 = x0 + 1.0;
        var valx1 = jStat.tukey.cdf(x1, nmeans, df) - p;

        // Find new iterate

        var ans;
        for (var iter = 1; iter < maxiter; iter++) {
          ans = x1 - valx1 * (x1 - x0) / (valx1 - valx0);
          valx0 = valx1;

          // New iterate must be >= 0

          x0 = x1;
          if (ans < 0.0) {
            ans = 0.0;
            valx1 = -p;
          }
          // Find prob(value < new iterate)

          valx1 = jStat.tukey.cdf(ans, nmeans, df) - p;
          x1 = ans;

          // If the difference between two successive
          // iterates is less than eps, stop

          var xabs = Math.abs(x1 - x0);
          if (xabs < eps) return ans;
        }
        throw new Error('tukey.inv failed to converge');
      }
    });
  })(jStat, Math);
  /* Provides functions for the solution of linear system of equations, integration, extrapolation,
   * interpolation, eigenvalue problems, differential equations and PCA analysis. */

  (function (jStat, Math) {
    var push = Array.prototype.push;
    var isArray = jStat.utils.isArray;
    function isUsable(arg) {
      return isArray(arg) || arg instanceof jStat;
    }
    jStat.extend({
      // add a vector/matrix to a vector/matrix or scalar
      add: function add(arr, arg) {
        // check if arg is a vector or scalar
        if (isUsable(arg)) {
          if (!isUsable(arg[0])) arg = [arg];
          return jStat.map(arr, function (value, row, col) {
            return value + arg[row][col];
          });
        }
        return jStat.map(arr, function (value) {
          return value + arg;
        });
      },
      // subtract a vector or scalar from the vector
      subtract: function subtract(arr, arg) {
        // check if arg is a vector or scalar
        if (isUsable(arg)) {
          if (!isUsable(arg[0])) arg = [arg];
          return jStat.map(arr, function (value, row, col) {
            return value - arg[row][col] || 0;
          });
        }
        return jStat.map(arr, function (value) {
          return value - arg;
        });
      },
      // matrix division
      divide: function divide(arr, arg) {
        if (isUsable(arg)) {
          if (!isUsable(arg[0])) arg = [arg];
          return jStat.multiply(arr, jStat.inv(arg));
        }
        return jStat.map(arr, function (value) {
          return value / arg;
        });
      },
      // matrix multiplication
      multiply: function multiply(arr, arg) {
        var row, col, nrescols, sum, nrow, ncol, res, rescols;
        // eg: arr = 2 arg = 3 -> 6 for res[0][0] statement closure
        if (arr.length === undefined && arg.length === undefined) {
          return arr * arg;
        }
        nrow = arr.length, ncol = arr[0].length, res = jStat.zeros(nrow, nrescols = isUsable(arg) ? arg[0].length : ncol), rescols = 0;
        if (isUsable(arg)) {
          for (; rescols < nrescols; rescols++) {
            for (row = 0; row < nrow; row++) {
              sum = 0;
              for (col = 0; col < ncol; col++) sum += arr[row][col] * arg[col][rescols];
              res[row][rescols] = sum;
            }
          }
          return nrow === 1 && rescols === 1 ? res[0][0] : res;
        }
        return jStat.map(arr, function (value) {
          return value * arg;
        });
      },
      // outer([1,2,3],[4,5,6])
      // ===
      // [[1],[2],[3]] times [[4,5,6]]
      // ->
      // [[4,5,6],[8,10,12],[12,15,18]]
      outer: function outer(A, B) {
        return jStat.multiply(A.map(function (t) {
          return [t];
        }), [B]);
      },
      // Returns the dot product of two matricies
      dot: function dot(arr, arg) {
        if (!isUsable(arr[0])) arr = [arr];
        if (!isUsable(arg[0])) arg = [arg];
        // convert column to row vector
        var left = arr[0].length === 1 && arr.length !== 1 ? jStat.transpose(arr) : arr,
          right = arg[0].length === 1 && arg.length !== 1 ? jStat.transpose(arg) : arg,
          res = [],
          row = 0,
          nrow = left.length,
          ncol = left[0].length,
          sum,
          col;
        for (; row < nrow; row++) {
          res[row] = [];
          sum = 0;
          for (col = 0; col < ncol; col++) sum += left[row][col] * right[row][col];
          res[row] = sum;
        }
        return res.length === 1 ? res[0] : res;
      },
      // raise every element by a scalar
      pow: function pow(arr, arg) {
        return jStat.map(arr, function (value) {
          return Math.pow(value, arg);
        });
      },
      // exponentiate every element
      exp: function exp(arr) {
        return jStat.map(arr, function (value) {
          return Math.exp(value);
        });
      },
      // generate the natural log of every element
      log: function exp(arr) {
        return jStat.map(arr, function (value) {
          return Math.log(value);
        });
      },
      // generate the absolute values of the vector
      abs: function abs(arr) {
        return jStat.map(arr, function (value) {
          return Math.abs(value);
        });
      },
      // computes the p-norm of the vector
      // In the case that a matrix is passed, uses the first row as the vector
      norm: function norm(arr, p) {
        var nnorm = 0,
          i = 0;
        // check the p-value of the norm, and set for most common case
        if (isNaN(p)) p = 2;
        // check if multi-dimensional array, and make vector correction
        if (isUsable(arr[0])) arr = arr[0];
        // vector norm
        for (; i < arr.length; i++) {
          nnorm += Math.pow(Math.abs(arr[i]), p);
        }
        return Math.pow(nnorm, 1 / p);
      },
      // computes the angle between two vectors in rads
      // In case a matrix is passed, this uses the first row as the vector
      angle: function angle(arr, arg) {
        return Math.acos(jStat.dot(arr, arg) / (jStat.norm(arr) * jStat.norm(arg)));
      },
      // augment one matrix by another
      // Note: this function returns a matrix, not a jStat object
      aug: function aug(a, b) {
        var newarr = [];
        var i;
        for (i = 0; i < a.length; i++) {
          newarr.push(a[i].slice());
        }
        for (i = 0; i < newarr.length; i++) {
          push.apply(newarr[i], b[i]);
        }
        return newarr;
      },
      // The inv() function calculates the inverse of a matrix
      // Create the inverse by augmenting the matrix by the identity matrix of the
      // appropriate size, and then use G-J elimination on the augmented matrix.
      inv: function inv(a) {
        var rows = a.length;
        var cols = a[0].length;
        var b = jStat.identity(rows, cols);
        var c = jStat.gauss_jordan(a, b);
        var result = [];
        var i = 0;
        var j;

        //We need to copy the inverse portion to a new matrix to rid G-J artifacts
        for (; i < rows; i++) {
          result[i] = [];
          for (j = cols; j < c[0].length; j++) result[i][j - cols] = c[i][j];
        }
        return result;
      },
      // calculate the determinant of a matrix
      det: function det(a) {
        if (a.length === 2) {
          return a[0][0] * a[1][1] - a[0][1] * a[1][0];
        }
        var determinant = 0;
        for (var i = 0; i < a.length; i++) {
          // build a sub matrix without column `i`
          var submatrix = [];
          for (var row = 1; row < a.length; row++) {
            submatrix[row - 1] = [];
            for (var col = 0; col < a.length; col++) {
              if (col < i) {
                submatrix[row - 1][col] = a[row][col];
              } else if (col > i) {
                submatrix[row - 1][col - 1] = a[row][col];
              }
            }
          }

          // alternate between + and - between determinants
          var sign = i % 2 ? -1 : 1;
          determinant += det(submatrix) * a[0][i] * sign;
        }
        return determinant;
      },
      gauss_elimination: function gauss_elimination(a, b) {
        var i = 0,
          j = 0,
          n = a.length,
          m = a[0].length,
          factor = 1,
          sum = 0,
          x = [],
          maug,
          pivot,
          temp,
          k;
        a = jStat.aug(a, b);
        maug = a[0].length;
        for (i = 0; i < n; i++) {
          pivot = a[i][i];
          j = i;
          for (k = i + 1; k < m; k++) {
            if (pivot < Math.abs(a[k][i])) {
              pivot = a[k][i];
              j = k;
            }
          }
          if (j != i) {
            for (k = 0; k < maug; k++) {
              temp = a[i][k];
              a[i][k] = a[j][k];
              a[j][k] = temp;
            }
          }
          for (j = i + 1; j < n; j++) {
            factor = a[j][i] / a[i][i];
            for (k = i; k < maug; k++) {
              a[j][k] = a[j][k] - factor * a[i][k];
            }
          }
        }
        for (i = n - 1; i >= 0; i--) {
          sum = 0;
          for (j = i + 1; j <= n - 1; j++) {
            sum = sum + x[j] * a[i][j];
          }
          x[i] = (a[i][maug - 1] - sum) / a[i][i];
        }
        return x;
      },
      gauss_jordan: function gauss_jordan(a, b) {
        var m = jStat.aug(a, b);
        var h = m.length;
        var w = m[0].length;
        var c = 0;
        var x, y, y2;
        // find max pivot
        for (y = 0; y < h; y++) {
          var maxrow = y;
          for (y2 = y + 1; y2 < h; y2++) {
            if (Math.abs(m[y2][y]) > Math.abs(m[maxrow][y])) maxrow = y2;
          }
          var tmp = m[y];
          m[y] = m[maxrow];
          m[maxrow] = tmp;
          for (y2 = y + 1; y2 < h; y2++) {
            c = m[y2][y] / m[y][y];
            for (x = y; x < w; x++) {
              m[y2][x] -= m[y][x] * c;
            }
          }
        }
        // backsubstitute
        for (y = h - 1; y >= 0; y--) {
          c = m[y][y];
          for (y2 = 0; y2 < y; y2++) {
            for (x = w - 1; x > y - 1; x--) {
              m[y2][x] -= m[y][x] * m[y2][y] / c;
            }
          }
          m[y][y] /= c;
          for (x = h; x < w; x++) {
            m[y][x] /= c;
          }
        }
        return m;
      },
      // solve equation
      // Ax=b
      // A is upper triangular matrix
      // A=[[1,2,3],[0,4,5],[0,6,7]]
      // b=[1,2,3]
      // triaUpSolve(A,b) // -> [2.666,0.1666,1.666]
      // if you use matrix style
      // A=[[1,2,3],[0,4,5],[0,6,7]]
      // b=[[1],[2],[3]]
      // will return [[2.666],[0.1666],[1.666]]
      triaUpSolve: function triaUpSolve(A, b) {
        var size = A[0].length;
        var x = jStat.zeros(1, size)[0];
        var parts;
        var matrix_mode = false;
        if (b[0].length != undefined) {
          b = b.map(function (i) {
            return i[0];
          });
          matrix_mode = true;
        }
        jStat.arange(size - 1, -1, -1).forEach(function (i) {
          parts = jStat.arange(i + 1, size).map(function (j) {
            return x[j] * A[i][j];
          });
          x[i] = (b[i] - jStat.sum(parts)) / A[i][i];
        });
        if (matrix_mode) return x.map(function (i) {
          return [i];
        });
        return x;
      },
      triaLowSolve: function triaLowSolve(A, b) {
        // like to triaUpSolve but A is lower triangular matrix
        var size = A[0].length;
        var x = jStat.zeros(1, size)[0];
        var parts;
        var matrix_mode = false;
        if (b[0].length != undefined) {
          b = b.map(function (i) {
            return i[0];
          });
          matrix_mode = true;
        }
        jStat.arange(size).forEach(function (i) {
          parts = jStat.arange(i).map(function (j) {
            return A[i][j] * x[j];
          });
          x[i] = (b[i] - jStat.sum(parts)) / A[i][i];
        });
        if (matrix_mode) return x.map(function (i) {
          return [i];
        });
        return x;
      },
      // A -> [L,U]
      // A=LU
      // L is lower triangular matrix
      // U is upper triangular matrix
      lu: function lu(A) {
        var size = A.length;
        //var L=jStat.diagonal(jStat.ones(1,size)[0]);
        var L = jStat.identity(size);
        var R = jStat.zeros(A.length, A[0].length);
        var parts;
        jStat.arange(size).forEach(function (t) {
          R[0][t] = A[0][t];
        });
        jStat.arange(1, size).forEach(function (l) {
          jStat.arange(l).forEach(function (i) {
            parts = jStat.arange(i).map(function (jj) {
              return L[l][jj] * R[jj][i];
            });
            L[l][i] = (A[l][i] - jStat.sum(parts)) / R[i][i];
          });
          jStat.arange(l, size).forEach(function (j) {
            parts = jStat.arange(l).map(function (jj) {
              return L[l][jj] * R[jj][j];
            });
            R[l][j] = A[parts.length][j] - jStat.sum(parts);
          });
        });
        return [L, R];
      },
      // A -> T
      // A=TT'
      // T is lower triangular matrix
      cholesky: function cholesky(A) {
        var size = A.length;
        var T = jStat.zeros(A.length, A[0].length);
        var parts;
        jStat.arange(size).forEach(function (i) {
          parts = jStat.arange(i).map(function (t) {
            return Math.pow(T[i][t], 2);
          });
          T[i][i] = Math.sqrt(A[i][i] - jStat.sum(parts));
          jStat.arange(i + 1, size).forEach(function (j) {
            parts = jStat.arange(i).map(function (t) {
              return T[i][t] * T[j][t];
            });
            T[j][i] = (A[i][j] - jStat.sum(parts)) / T[i][i];
          });
        });
        return T;
      },
      gauss_jacobi: function gauss_jacobi(a, b, x, r) {
        var i = 0;
        var j = 0;
        var n = a.length;
        var l = [];
        var u = [];
        var d = [];
        var xv, c, h, xk;
        for (; i < n; i++) {
          l[i] = [];
          u[i] = [];
          d[i] = [];
          for (j = 0; j < n; j++) {
            if (i > j) {
              l[i][j] = a[i][j];
              u[i][j] = d[i][j] = 0;
            } else if (i < j) {
              u[i][j] = a[i][j];
              l[i][j] = d[i][j] = 0;
            } else {
              d[i][j] = a[i][j];
              l[i][j] = u[i][j] = 0;
            }
          }
        }
        h = jStat.multiply(jStat.multiply(jStat.inv(d), jStat.add(l, u)), -1);
        c = jStat.multiply(jStat.inv(d), b);
        xv = x;
        xk = jStat.add(jStat.multiply(h, x), c);
        i = 2;
        while (Math.abs(jStat.norm(jStat.subtract(xk, xv))) > r) {
          xv = xk;
          xk = jStat.add(jStat.multiply(h, xv), c);
          i++;
        }
        return xk;
      },
      gauss_seidel: function gauss_seidel(a, b, x, r) {
        var i = 0;
        var n = a.length;
        var l = [];
        var u = [];
        var d = [];
        var j, xv, c, h, xk;
        for (; i < n; i++) {
          l[i] = [];
          u[i] = [];
          d[i] = [];
          for (j = 0; j < n; j++) {
            if (i > j) {
              l[i][j] = a[i][j];
              u[i][j] = d[i][j] = 0;
            } else if (i < j) {
              u[i][j] = a[i][j];
              l[i][j] = d[i][j] = 0;
            } else {
              d[i][j] = a[i][j];
              l[i][j] = u[i][j] = 0;
            }
          }
        }
        h = jStat.multiply(jStat.multiply(jStat.inv(jStat.add(d, l)), u), -1);
        c = jStat.multiply(jStat.inv(jStat.add(d, l)), b);
        xv = x;
        xk = jStat.add(jStat.multiply(h, x), c);
        i = 2;
        while (Math.abs(jStat.norm(jStat.subtract(xk, xv))) > r) {
          xv = xk;
          xk = jStat.add(jStat.multiply(h, xv), c);
          i = i + 1;
        }
        return xk;
      },
      SOR: function SOR(a, b, x, r, w) {
        var i = 0;
        var n = a.length;
        var l = [];
        var u = [];
        var d = [];
        var j, xv, c, h, xk;
        for (; i < n; i++) {
          l[i] = [];
          u[i] = [];
          d[i] = [];
          for (j = 0; j < n; j++) {
            if (i > j) {
              l[i][j] = a[i][j];
              u[i][j] = d[i][j] = 0;
            } else if (i < j) {
              u[i][j] = a[i][j];
              l[i][j] = d[i][j] = 0;
            } else {
              d[i][j] = a[i][j];
              l[i][j] = u[i][j] = 0;
            }
          }
        }
        h = jStat.multiply(jStat.inv(jStat.add(d, jStat.multiply(l, w))), jStat.subtract(jStat.multiply(d, 1 - w), jStat.multiply(u, w)));
        c = jStat.multiply(jStat.multiply(jStat.inv(jStat.add(d, jStat.multiply(l, w))), b), w);
        xv = x;
        xk = jStat.add(jStat.multiply(h, x), c);
        i = 2;
        while (Math.abs(jStat.norm(jStat.subtract(xk, xv))) > r) {
          xv = xk;
          xk = jStat.add(jStat.multiply(h, xv), c);
          i++;
        }
        return xk;
      },
      householder: function householder(a) {
        var m = a.length;
        var n = a[0].length;
        var i = 0;
        var w = [];
        var p = [];
        var alpha, r, k, j, factor;
        for (; i < m - 1; i++) {
          alpha = 0;
          for (j = i + 1; j < n; j++) alpha += a[j][i] * a[j][i];
          factor = a[i + 1][i] > 0 ? -1 : 1;
          alpha = factor * Math.sqrt(alpha);
          r = Math.sqrt((alpha * alpha - a[i + 1][i] * alpha) / 2);
          w = jStat.zeros(m, 1);
          w[i + 1][0] = (a[i + 1][i] - alpha) / (2 * r);
          for (k = i + 2; k < m; k++) w[k][0] = a[k][i] / (2 * r);
          p = jStat.subtract(jStat.identity(m, n), jStat.multiply(jStat.multiply(w, jStat.transpose(w)), 2));
          a = jStat.multiply(p, jStat.multiply(a, p));
        }
        return a;
      },
      // A -> [Q,R]
      // Q is orthogonal matrix
      // R is upper triangular
      QR: function () {
        // x -> Q
        // find a orthogonal matrix Q st.
        // Qx=y
        // y is [||x||,0,0,...]

        // quick ref
        var sum = jStat.sum;
        var range = jStat.arange;
        function qr2(x) {
          // quick impletation
          // https://www.stat.wisc.edu/~larget/math496/qr.html

          var n = x.length;
          var p = x[0].length;
          var r = jStat.zeros(p, p);
          x = jStat.copy(x);
          var i, j, k;
          for (j = 0; j < p; j++) {
            r[j][j] = Math.sqrt(sum(range(n).map(function (i) {
              return x[i][j] * x[i][j];
            })));
            for (i = 0; i < n; i++) {
              x[i][j] = x[i][j] / r[j][j];
            }
            for (k = j + 1; k < p; k++) {
              r[j][k] = sum(range(n).map(function (i) {
                return x[i][j] * x[i][k];
              }));
              for (i = 0; i < n; i++) {
                x[i][k] = x[i][k] - x[i][j] * r[j][k];
              }
            }
          }
          return [x, r];
        }
        return qr2;
      }(),
      lstsq: function () {
        // solve least squard problem for Ax=b as QR decomposition way if b is
        // [[b1],[b2],[b3]] form will return [[x1],[x2],[x3]] array form solution
        // else b is [b1,b2,b3] form will return [x1,x2,x3] array form solution
        function R_I(A) {
          A = jStat.copy(A);
          var size = A.length;
          var I = jStat.identity(size);
          jStat.arange(size - 1, -1, -1).forEach(function (i) {
            jStat.sliceAssign(I, {
              row: i
            }, jStat.divide(jStat.slice(I, {
              row: i
            }), A[i][i]));
            jStat.sliceAssign(A, {
              row: i
            }, jStat.divide(jStat.slice(A, {
              row: i
            }), A[i][i]));
            jStat.arange(i).forEach(function (j) {
              var c = jStat.multiply(A[j][i], -1);
              var Aj = jStat.slice(A, {
                row: j
              });
              var cAi = jStat.multiply(jStat.slice(A, {
                row: i
              }), c);
              jStat.sliceAssign(A, {
                row: j
              }, jStat.add(Aj, cAi));
              var Ij = jStat.slice(I, {
                row: j
              });
              var cIi = jStat.multiply(jStat.slice(I, {
                row: i
              }), c);
              jStat.sliceAssign(I, {
                row: j
              }, jStat.add(Ij, cIi));
            });
          });
          return I;
        }
        function qr_solve(A, b) {
          var array_mode = false;
          if (b[0].length === undefined) {
            // [c1,c2,c3] mode
            b = b.map(function (x) {
              return [x];
            });
            array_mode = true;
          }
          var QR = jStat.QR(A);
          var Q = QR[0];
          var R = QR[1];
          var attrs = A[0].length;
          var Q1 = jStat.slice(Q, {
            col: {
              end: attrs
            }
          });
          var R1 = jStat.slice(R, {
            row: {
              end: attrs
            }
          });
          var RI = R_I(R1);
          var Q2 = jStat.transpose(Q1);
          if (Q2[0].length === undefined) {
            Q2 = [Q2]; // The confusing jStat.multifly implementation threat nature process again.
          }
          var x = jStat.multiply(jStat.multiply(RI, Q2), b);
          if (x.length === undefined) {
            x = [[x]]; // The confusing jStat.multifly implementation threat nature process again.
          }
          if (array_mode) return x.map(function (i) {
            return i[0];
          });
          return x;
        }
        return qr_solve;
      }(),
      jacobi: function jacobi(a) {
        var condition = 1;
        var n = a.length;
        var e = jStat.identity(n, n);
        var ev = [];
        var b, i, j, p, q, maxim, theta, s;
        // condition === 1 only if tolerance is not reached
        while (condition === 1) {
          maxim = a[0][1];
          p = 0;
          q = 1;
          for (i = 0; i < n; i++) {
            for (j = 0; j < n; j++) {
              if (i != j) {
                if (maxim < Math.abs(a[i][j])) {
                  maxim = Math.abs(a[i][j]);
                  p = i;
                  q = j;
                }
              }
            }
          }
          if (a[p][p] === a[q][q]) theta = a[p][q] > 0 ? Math.PI / 4 : -Math.PI / 4;else theta = Math.atan(2 * a[p][q] / (a[p][p] - a[q][q])) / 2;
          s = jStat.identity(n, n);
          s[p][p] = Math.cos(theta);
          s[p][q] = -Math.sin(theta);
          s[q][p] = Math.sin(theta);
          s[q][q] = Math.cos(theta);
          // eigen vector matrix
          e = jStat.multiply(e, s);
          b = jStat.multiply(jStat.multiply(jStat.inv(s), a), s);
          a = b;
          condition = 0;
          for (i = 1; i < n; i++) {
            for (j = 1; j < n; j++) {
              if (i != j && Math.abs(a[i][j]) > 0.001) {
                condition = 1;
              }
            }
          }
        }
        for (i = 0; i < n; i++) ev.push(a[i][i]);
        //returns both the eigenvalue and eigenmatrix
        return [e, ev];
      },
      rungekutta: function rungekutta(f, h, p, t_j, u_j, order) {
        var k1, k2, u_j1, k3, k4;
        if (order === 2) {
          while (t_j <= p) {
            k1 = h * f(t_j, u_j);
            k2 = h * f(t_j + h, u_j + k1);
            u_j1 = u_j + (k1 + k2) / 2;
            u_j = u_j1;
            t_j = t_j + h;
          }
        }
        if (order === 4) {
          while (t_j <= p) {
            k1 = h * f(t_j, u_j);
            k2 = h * f(t_j + h / 2, u_j + k1 / 2);
            k3 = h * f(t_j + h / 2, u_j + k2 / 2);
            k4 = h * f(t_j + h, u_j + k3);
            u_j1 = u_j + (k1 + 2 * k2 + 2 * k3 + k4) / 6;
            u_j = u_j1;
            t_j = t_j + h;
          }
        }
        return u_j;
      },
      romberg: function romberg(f, a, b, order) {
        var i = 0;
        var h = (b - a) / 2;
        var x = [];
        var h1 = [];
        var g = [];
        var m, a1, j, k, I;
        while (i < order / 2) {
          I = f(a);
          for (j = a, k = 0; j <= b; j = j + h, k++) x[k] = j;
          m = x.length;
          for (j = 1; j < m - 1; j++) {
            I += (j % 2 !== 0 ? 4 : 2) * f(x[j]);
          }
          I = h / 3 * (I + f(b));
          g[i] = I;
          h /= 2;
          i++;
        }
        a1 = g.length;
        m = 1;
        while (a1 !== 1) {
          for (j = 0; j < a1 - 1; j++) h1[j] = (Math.pow(4, m) * g[j + 1] - g[j]) / (Math.pow(4, m) - 1);
          a1 = h1.length;
          g = h1;
          h1 = [];
          m++;
        }
        return g;
      },
      richardson: function richardson(X, f, x, h) {
        function pos(X, x) {
          var i = 0;
          var n = X.length;
          var p;
          for (; i < n; i++) if (X[i] === x) p = i;
          return p;
        }
        var h_min = Math.abs(x - X[pos(X, x) + 1]);
        var i = 0;
        var g = [];
        var h1 = [];
        var y1, y2, m, a, j;
        while (h >= h_min) {
          y1 = pos(X, x + h);
          y2 = pos(X, x);
          g[i] = (f[y1] - 2 * f[y2] + f[2 * y2 - y1]) / (h * h);
          h /= 2;
          i++;
        }
        a = g.length;
        m = 1;
        while (a != 1) {
          for (j = 0; j < a - 1; j++) h1[j] = (Math.pow(4, m) * g[j + 1] - g[j]) / (Math.pow(4, m) - 1);
          a = h1.length;
          g = h1;
          h1 = [];
          m++;
        }
        return g;
      },
      simpson: function simpson(f, a, b, n) {
        var h = (b - a) / n;
        var I = f(a);
        var x = [];
        var j = a;
        var k = 0;
        var i = 1;
        var m;
        for (; j <= b; j = j + h, k++) x[k] = j;
        m = x.length;
        for (; i < m - 1; i++) {
          I += (i % 2 !== 0 ? 4 : 2) * f(x[i]);
        }
        return h / 3 * (I + f(b));
      },
      hermite: function hermite(X, F, dF, value) {
        var n = X.length;
        var p = 0;
        var i = 0;
        var l = [];
        var dl = [];
        var A = [];
        var B = [];
        var j;
        for (; i < n; i++) {
          l[i] = 1;
          for (j = 0; j < n; j++) {
            if (i != j) l[i] *= (value - X[j]) / (X[i] - X[j]);
          }
          dl[i] = 0;
          for (j = 0; j < n; j++) {
            if (i != j) dl[i] += 1 / (X[i] - X[j]);
          }
          A[i] = (1 - 2 * (value - X[i]) * dl[i]) * (l[i] * l[i]);
          B[i] = (value - X[i]) * (l[i] * l[i]);
          p += A[i] * F[i] + B[i] * dF[i];
        }
        return p;
      },
      lagrange: function lagrange(X, F, value) {
        var p = 0;
        var i = 0;
        var j, l;
        var n = X.length;
        for (; i < n; i++) {
          l = F[i];
          for (j = 0; j < n; j++) {
            // calculating the lagrange polynomial L_i
            if (i != j) l *= (value - X[j]) / (X[i] - X[j]);
          }
          // adding the lagrange polynomials found above
          p += l;
        }
        return p;
      },
      cubic_spline: function cubic_spline(X, F, value) {
        var n = X.length;
        var i = 0,
          j;
        var A = [];
        var B = [];
        var alpha = [];
        var c = [];
        var h = [];
        var b = [];
        var d = [];
        for (; i < n - 1; i++) h[i] = X[i + 1] - X[i];
        alpha[0] = 0;
        for (i = 1; i < n - 1; i++) {
          alpha[i] = 3 / h[i] * (F[i + 1] - F[i]) - 3 / h[i - 1] * (F[i] - F[i - 1]);
        }
        for (i = 1; i < n - 1; i++) {
          A[i] = [];
          B[i] = [];
          A[i][i - 1] = h[i - 1];
          A[i][i] = 2 * (h[i - 1] + h[i]);
          A[i][i + 1] = h[i];
          B[i][0] = alpha[i];
        }
        c = jStat.multiply(jStat.inv(A), B);
        for (j = 0; j < n - 1; j++) {
          b[j] = (F[j + 1] - F[j]) / h[j] - h[j] * (c[j + 1][0] + 2 * c[j][0]) / 3;
          d[j] = (c[j + 1][0] - c[j][0]) / (3 * h[j]);
        }
        for (j = 0; j < n; j++) {
          if (X[j] > value) break;
        }
        j -= 1;
        return F[j] + (value - X[j]) * b[j] + jStat.sq(value - X[j]) * c[j] + (value - X[j]) * jStat.sq(value - X[j]) * d[j];
      },
      gauss_quadrature: function gauss_quadrature() {
        throw new Error('gauss_quadrature not yet implemented');
      },
      PCA: function PCA(X) {
        var m = X.length;
        var n = X[0].length;
        var i = 0;
        var j, temp1;
        var u = [];
        var D = [];
        var result = [];
        var temp2 = [];
        var Y = [];
        var Bt = [];
        var B = [];
        var C = [];
        var V = [];
        var Vt = [];
        for (i = 0; i < m; i++) {
          u[i] = jStat.sum(X[i]) / n;
        }
        for (i = 0; i < n; i++) {
          B[i] = [];
          for (j = 0; j < m; j++) {
            B[i][j] = X[j][i] - u[j];
          }
        }
        B = jStat.transpose(B);
        for (i = 0; i < m; i++) {
          C[i] = [];
          for (j = 0; j < m; j++) {
            C[i][j] = jStat.dot([B[i]], [B[j]]) / (n - 1);
          }
        }
        result = jStat.jacobi(C);
        V = result[0];
        D = result[1];
        Vt = jStat.transpose(V);
        for (i = 0; i < D.length; i++) {
          for (j = i; j < D.length; j++) {
            if (D[i] < D[j]) {
              temp1 = D[i];
              D[i] = D[j];
              D[j] = temp1;
              temp2 = Vt[i];
              Vt[i] = Vt[j];
              Vt[j] = temp2;
            }
          }
        }
        Bt = jStat.transpose(B);
        for (i = 0; i < m; i++) {
          Y[i] = [];
          for (j = 0; j < Bt.length; j++) {
            Y[i][j] = jStat.dot([Vt[i]], [Bt[j]]);
          }
        }
        return [X, D, Vt, Y];
      }
    });

    // extend jStat.fn with methods that require one argument
    (function (funcs) {
      for (var i = 0; i < funcs.length; i++) (function (passfunc) {
        jStat.fn[passfunc] = function (arg, func) {
          var tmpthis = this;
          // check for callback
          if (func) {
            setTimeout(function () {
              func.call(tmpthis, jStat.fn[passfunc].call(tmpthis, arg));
            }, 15);
            return this;
          }
          if (typeof jStat[passfunc](this, arg) === 'number') return jStat[passfunc](this, arg);else return jStat(jStat[passfunc](this, arg));
        };
      })(funcs[i]);
    })('add divide multiply subtract dot pow exp log abs norm angle'.split(' '));
  })(jStat, Math);
  (function (jStat, Math) {
    var slice = [].slice;
    var isNumber = jStat.utils.isNumber;
    var isArray = jStat.utils.isArray;

    // flag==true denotes use of sample standard deviation
    // Z Statistics
    jStat.extend({
      // 2 different parameter lists:
      // (value, mean, sd)
      // (value, array, flag)
      zscore: function zscore() {
        var args = slice.call(arguments);
        if (isNumber(args[1])) {
          return (args[0] - args[1]) / args[2];
        }
        return (args[0] - jStat.mean(args[1])) / jStat.stdev(args[1], args[2]);
      },
      // 3 different paramter lists:
      // (value, mean, sd, sides)
      // (zscore, sides)
      // (value, array, sides, flag)
      ztest: function ztest() {
        var args = slice.call(arguments);
        var z;
        if (isArray(args[1])) {
          // (value, array, sides, flag)
          z = jStat.zscore(args[0], args[1], args[3]);
          return args[2] === 1 ? jStat.normal.cdf(-Math.abs(z), 0, 1) : jStat.normal.cdf(-Math.abs(z), 0, 1) * 2;
        } else {
          if (args.length > 2) {
            // (value, mean, sd, sides)
            z = jStat.zscore(args[0], args[1], args[2]);
            return args[3] === 1 ? jStat.normal.cdf(-Math.abs(z), 0, 1) : jStat.normal.cdf(-Math.abs(z), 0, 1) * 2;
          } else {
            // (zscore, sides)
            z = args[0];
            return args[1] === 1 ? jStat.normal.cdf(-Math.abs(z), 0, 1) : jStat.normal.cdf(-Math.abs(z), 0, 1) * 2;
          }
        }
      }
    });
    jStat.extend(jStat.fn, {
      zscore: function zscore(value, flag) {
        return (value - this.mean()) / this.stdev(flag);
      },
      ztest: function ztest(value, sides, flag) {
        var zscore = Math.abs(this.zscore(value, flag));
        return sides === 1 ? jStat.normal.cdf(-zscore, 0, 1) : jStat.normal.cdf(-zscore, 0, 1) * 2;
      }
    });

    // T Statistics
    jStat.extend({
      // 2 parameter lists
      // (value, mean, sd, n)
      // (value, array)
      tscore: function tscore() {
        var args = slice.call(arguments);
        return args.length === 4 ? (args[0] - args[1]) / (args[2] / Math.sqrt(args[3])) : (args[0] - jStat.mean(args[1])) / (jStat.stdev(args[1], true) / Math.sqrt(args[1].length));
      },
      // 3 different paramter lists:
      // (value, mean, sd, n, sides)
      // (tscore, n, sides)
      // (value, array, sides)
      ttest: function ttest() {
        var args = slice.call(arguments);
        var tscore;
        if (args.length === 5) {
          tscore = Math.abs(jStat.tscore(args[0], args[1], args[2], args[3]));
          return args[4] === 1 ? jStat.studentt.cdf(-tscore, args[3] - 1) : jStat.studentt.cdf(-tscore, args[3] - 1) * 2;
        }
        if (isNumber(args[1])) {
          tscore = Math.abs(args[0]);
          return args[2] == 1 ? jStat.studentt.cdf(-tscore, args[1] - 1) : jStat.studentt.cdf(-tscore, args[1] - 1) * 2;
        }
        tscore = Math.abs(jStat.tscore(args[0], args[1]));
        return args[2] == 1 ? jStat.studentt.cdf(-tscore, args[1].length - 1) : jStat.studentt.cdf(-tscore, args[1].length - 1) * 2;
      }
    });
    jStat.extend(jStat.fn, {
      tscore: function tscore(value) {
        return (value - this.mean()) / (this.stdev(true) / Math.sqrt(this.cols()));
      },
      ttest: function ttest(value, sides) {
        return sides === 1 ? 1 - jStat.studentt.cdf(Math.abs(this.tscore(value)), this.cols() - 1) : jStat.studentt.cdf(-Math.abs(this.tscore(value)), this.cols() - 1) * 2;
      }
    });

    // F Statistics
    jStat.extend({
      // Paramter list is as follows:
      // (array1, array2, array3, ...)
      // or it is an array of arrays
      // array of arrays conversion
      anovafscore: function anovafscore() {
        var args = slice.call(arguments),
          expVar,
          sample,
          sampMean,
          sampSampMean,
          tmpargs,
          unexpVar,
          i,
          j;
        if (args.length === 1) {
          tmpargs = new Array(args[0].length);
          for (i = 0; i < args[0].length; i++) {
            tmpargs[i] = args[0][i];
          }
          args = tmpargs;
        }
        // Builds sample array
        sample = new Array();
        for (i = 0; i < args.length; i++) {
          sample = sample.concat(args[i]);
        }
        sampMean = jStat.mean(sample);
        // Computes the explained variance
        expVar = 0;
        for (i = 0; i < args.length; i++) {
          expVar = expVar + args[i].length * Math.pow(jStat.mean(args[i]) - sampMean, 2);
        }
        expVar /= args.length - 1;
        // Computes unexplained variance
        unexpVar = 0;
        for (i = 0; i < args.length; i++) {
          sampSampMean = jStat.mean(args[i]);
          for (j = 0; j < args[i].length; j++) {
            unexpVar += Math.pow(args[i][j] - sampSampMean, 2);
          }
        }
        unexpVar /= sample.length - args.length;
        return expVar / unexpVar;
      },
      // 2 different paramter setups
      // (array1, array2, array3, ...)
      // (anovafscore, df1, df2)
      anovaftest: function anovaftest() {
        var args = slice.call(arguments),
          df1,
          df2,
          n,
          i;
        if (isNumber(args[0])) {
          return 1 - jStat.centralF.cdf(args[0], args[1], args[2]);
        }
        var anovafscore = jStat.anovafscore(args);
        df1 = args.length - 1;
        n = 0;
        for (i = 0; i < args.length; i++) {
          n = n + args[i].length;
        }
        df2 = n - df1 - 1;
        return 1 - jStat.centralF.cdf(anovafscore, df1, df2);
      },
      ftest: function ftest(fscore, df1, df2) {
        return 1 - jStat.centralF.cdf(fscore, df1, df2);
      }
    });
    jStat.extend(jStat.fn, {
      anovafscore: function anovafscore() {
        return jStat.anovafscore(this.toArray());
      },
      anovaftes: function anovaftes() {
        var n = 0;
        var i;
        for (i = 0; i < this.length; i++) {
          n = n + this[i].length;
        }
        return jStat.ftest(this.anovafscore(), this.length - 1, n - this.length);
      }
    });

    // Tukey's range test
    jStat.extend({
      // 2 parameter lists
      // (mean1, mean2, n1, n2, sd)
      // (array1, array2, sd)
      qscore: function qscore() {
        var args = slice.call(arguments);
        var mean1, mean2, n1, n2, sd;
        if (isNumber(args[0])) {
          mean1 = args[0];
          mean2 = args[1];
          n1 = args[2];
          n2 = args[3];
          sd = args[4];
        } else {
          mean1 = jStat.mean(args[0]);
          mean2 = jStat.mean(args[1]);
          n1 = args[0].length;
          n2 = args[1].length;
          sd = args[2];
        }
        return Math.abs(mean1 - mean2) / (sd * Math.sqrt((1 / n1 + 1 / n2) / 2));
      },
      // 3 different parameter lists:
      // (qscore, n, k)
      // (mean1, mean2, n1, n2, sd, n, k)
      // (array1, array2, sd, n, k)
      qtest: function qtest() {
        var args = slice.call(arguments);
        var qscore;
        if (args.length === 3) {
          qscore = args[0];
          args = args.slice(1);
        } else if (args.length === 7) {
          qscore = jStat.qscore(args[0], args[1], args[2], args[3], args[4]);
          args = args.slice(5);
        } else {
          qscore = jStat.qscore(args[0], args[1], args[2]);
          args = args.slice(3);
        }
        var n = args[0];
        var k = args[1];
        return 1 - jStat.tukey.cdf(qscore, k, n - k);
      },
      tukeyhsd: function tukeyhsd(arrays) {
        var sd = jStat.pooledstdev(arrays);
        var means = arrays.map(function (arr) {
          return jStat.mean(arr);
        });
        var n = arrays.reduce(function (n, arr) {
          return n + arr.length;
        }, 0);
        var results = [];
        for (var i = 0; i < arrays.length; ++i) {
          for (var j = i + 1; j < arrays.length; ++j) {
            var p = jStat.qtest(means[i], means[j], arrays[i].length, arrays[j].length, sd, n, arrays.length);
            results.push([[i, j], p]);
          }
        }
        return results;
      }
    });

    // Error Bounds
    jStat.extend({
      // 2 different parameter setups
      // (value, alpha, sd, n)
      // (value, alpha, array)
      normalci: function normalci() {
        var args = slice.call(arguments),
          ans = new Array(2),
          change;
        if (args.length === 4) {
          change = Math.abs(jStat.normal.inv(args[1] / 2, 0, 1) * args[2] / Math.sqrt(args[3]));
        } else {
          change = Math.abs(jStat.normal.inv(args[1] / 2, 0, 1) * jStat.stdev(args[2]) / Math.sqrt(args[2].length));
        }
        ans[0] = args[0] - change;
        ans[1] = args[0] + change;
        return ans;
      },
      // 2 different parameter setups
      // (value, alpha, sd, n)
      // (value, alpha, array)
      tci: function tci() {
        var args = slice.call(arguments),
          ans = new Array(2),
          change;
        if (args.length === 4) {
          change = Math.abs(jStat.studentt.inv(args[1] / 2, args[3] - 1) * args[2] / Math.sqrt(args[3]));
        } else {
          change = Math.abs(jStat.studentt.inv(args[1] / 2, args[2].length - 1) * jStat.stdev(args[2], true) / Math.sqrt(args[2].length));
        }
        ans[0] = args[0] - change;
        ans[1] = args[0] + change;
        return ans;
      },
      significant: function significant(pvalue, alpha) {
        return pvalue < alpha;
      }
    });
    jStat.extend(jStat.fn, {
      normalci: function normalci(value, alpha) {
        return jStat.normalci(value, alpha, this.toArray());
      },
      tci: function tci(value, alpha) {
        return jStat.tci(value, alpha, this.toArray());
      }
    });

    // internal method for calculating the z-score for a difference of proportions test
    function differenceOfProportions(p1, n1, p2, n2) {
      if (p1 > 1 || p2 > 1 || p1 <= 0 || p2 <= 0) {
        throw new Error("Proportions should be greater than 0 and less than 1");
      }
      var pooled = (p1 * n1 + p2 * n2) / (n1 + n2);
      var se = Math.sqrt(pooled * (1 - pooled) * (1 / n1 + 1 / n2));
      return (p1 - p2) / se;
    }

    // Difference of Proportions
    jStat.extend(jStat.fn, {
      oneSidedDifferenceOfProportions: function oneSidedDifferenceOfProportions(p1, n1, p2, n2) {
        var z = differenceOfProportions(p1, n1, p2, n2);
        return jStat.ztest(z, 1);
      },
      twoSidedDifferenceOfProportions: function twoSidedDifferenceOfProportions(p1, n1, p2, n2) {
        var z = differenceOfProportions(p1, n1, p2, n2);
        return jStat.ztest(z, 2);
      }
    });
  })(jStat, Math);
  jStat.models = function () {
    function sub_regress(exog) {
      var var_count = exog[0].length;
      var modelList = jStat.arange(var_count).map(function (endog_index) {
        var exog_index = jStat.arange(var_count).filter(function (i) {
          return i !== endog_index;
        });
        return ols(jStat.col(exog, endog_index).map(function (x) {
          return x[0];
        }), jStat.col(exog, exog_index));
      });
      return modelList;
    }

    // do OLS model regress
    // exog have include const columns ,it will not generate it .In fact, exog is
    // "design matrix" look at
    //https://en.wikipedia.org/wiki/Design_matrix
    function ols(endog, exog) {
      var nobs = endog.length;
      var df_model = exog[0].length - 1;
      var df_resid = nobs - df_model - 1;
      var coef = jStat.lstsq(exog, endog);
      var predict = jStat.multiply(exog, coef.map(function (x) {
        return [x];
      })).map(function (p) {
        return p[0];
      });
      var resid = jStat.subtract(endog, predict);
      var ybar = jStat.mean(endog);
      // constant cause problem
      // var SST = jStat.sum(endog.map(function(y) {
      //   return Math.pow(y-ybar,2);
      // }));
      var SSE = jStat.sum(predict.map(function (f) {
        return Math.pow(f - ybar, 2);
      }));
      var SSR = jStat.sum(endog.map(function (y, i) {
        return Math.pow(y - predict[i], 2);
      }));
      var SST = SSE + SSR;
      var R2 = SSE / SST;
      return {
        exog: exog,
        endog: endog,
        nobs: nobs,
        df_model: df_model,
        df_resid: df_resid,
        coef: coef,
        predict: predict,
        resid: resid,
        ybar: ybar,
        SST: SST,
        SSE: SSE,
        SSR: SSR,
        R2: R2
      };
    }

    // H0: b_I=0
    // H1: b_I!=0
    function t_test(model) {
      var subModelList = sub_regress(model.exog);
      //var sigmaHat=jStat.stdev(model.resid);
      var sigmaHat = Math.sqrt(model.SSR / model.df_resid);
      var seBetaHat = subModelList.map(function (mod) {
        var SST = mod.SST;
        var R2 = mod.R2;
        return sigmaHat / Math.sqrt(SST * (1 - R2));
      });
      var tStatistic = model.coef.map(function (coef, i) {
        return (coef - 0) / seBetaHat[i];
      });
      var pValue = tStatistic.map(function (t) {
        var leftppf = jStat.studentt.cdf(t, model.df_resid);
        return (leftppf > 0.5 ? 1 - leftppf : leftppf) * 2;
      });
      var c = jStat.studentt.inv(0.975, model.df_resid);
      var interval95 = model.coef.map(function (coef, i) {
        var d = c * seBetaHat[i];
        return [coef - d, coef + d];
      });
      return {
        se: seBetaHat,
        t: tStatistic,
        p: pValue,
        sigmaHat: sigmaHat,
        interval95: interval95
      };
    }
    function F_test(model) {
      var F_statistic = model.R2 / model.df_model / ((1 - model.R2) / model.df_resid);
      var fcdf = function (x, n1, n2) {
        return jStat.beta.cdf(x / (n2 / n1 + x), n1 / 2, n2 / 2);
      };
      var pvalue = 1 - fcdf(F_statistic, model.df_model, model.df_resid);
      return {
        F_statistic: F_statistic,
        pvalue: pvalue
      };
    }
    function ols_wrap(endog, exog) {
      var model = ols(endog, exog);
      var ttest = t_test(model);
      var ftest = F_test(model);
      // Provide the Wherry / Ezekiel / McNemar / Cohen Adjusted R^2
      // Which matches the 'adjusted R^2' provided by R's lm package
      var adjust_R2 = 1 - (1 - model.R2) * ((model.nobs - 1) / model.df_resid);
      model.t = ttest;
      model.f = ftest;
      model.adjust_R2 = adjust_R2;
      return model;
    }
    return {
      ols: ols_wrap
    };
  }();
  //To regress, simply build X matrix
  //(append column of 1's) using
  //buildxmatrix and build the Y
  //matrix using buildymatrix
  //(simply the transpose)
  //and run regress.

  //Regressions

  jStat.extend({
    buildxmatrix: function buildxmatrix() {
      //Parameters will be passed in as such
      //(array1,array2,array3,...)
      //as (x1,x2,x3,...)
      //needs to be (1,x1,x2,x3,...)
      var matrixRows = new Array(arguments.length);
      for (var i = 0; i < arguments.length; i++) {
        var array = [1];
        matrixRows[i] = array.concat(arguments[i]);
      }
      return jStat(matrixRows);
    },
    builddxmatrix: function builddxmatrix() {
      //Paramters will be passed in as such
      //([array1,array2,...]
      var matrixRows = new Array(arguments[0].length);
      for (var i = 0; i < arguments[0].length; i++) {
        var array = [1];
        matrixRows[i] = array.concat(arguments[0][i]);
      }
      return jStat(matrixRows);
    },
    buildjxmatrix: function buildjxmatrix(jMat) {
      //Builds from jStat Matrix
      var pass = new Array(jMat.length);
      for (var i = 0; i < jMat.length; i++) {
        pass[i] = jMat[i];
      }
      return jStat.builddxmatrix(pass);
    },
    buildymatrix: function buildymatrix(array) {
      return jStat(array).transpose();
    },
    buildjymatrix: function buildjymatrix(jMat) {
      return jMat.transpose();
    },
    matrixmult: function matrixmult(A, B) {
      var i, j, k, result, sum;
      if (A.cols() == B.rows()) {
        if (B.rows() > 1) {
          result = [];
          for (i = 0; i < A.rows(); i++) {
            result[i] = [];
            for (j = 0; j < B.cols(); j++) {
              sum = 0;
              for (k = 0; k < A.cols(); k++) {
                sum += A.toArray()[i][k] * B.toArray()[k][j];
              }
              result[i][j] = sum;
            }
          }
          return jStat(result);
        }
        result = [];
        for (i = 0; i < A.rows(); i++) {
          result[i] = [];
          for (j = 0; j < B.cols(); j++) {
            sum = 0;
            for (k = 0; k < A.cols(); k++) {
              sum += A.toArray()[i][k] * B.toArray()[j];
            }
            result[i][j] = sum;
          }
        }
        return jStat(result);
      }
    },
    //regress and regresst to be fixed

    regress: function regress(jMatX, jMatY) {
      //print("regressin!");
      //print(jMatX.toArray());
      var innerinv = jStat.xtranspxinv(jMatX);
      //print(innerinv);
      var xtransp = jMatX.transpose();
      var next = jStat.matrixmult(jStat(innerinv), xtransp);
      return jStat.matrixmult(next, jMatY);
    },
    regresst: function regresst(jMatX, jMatY, sides) {
      var beta = jStat.regress(jMatX, jMatY);
      var compile = {};
      compile.anova = {};
      var jMatYBar = jStat.jMatYBar(jMatX, beta);
      compile.yBar = jMatYBar;
      var yAverage = jMatY.mean();
      compile.anova.residuals = jStat.residuals(jMatY, jMatYBar);
      compile.anova.ssr = jStat.ssr(jMatYBar, yAverage);
      compile.anova.msr = compile.anova.ssr / (jMatX[0].length - 1);
      compile.anova.sse = jStat.sse(jMatY, jMatYBar);
      compile.anova.mse = compile.anova.sse / (jMatY.length - (jMatX[0].length - 1) - 1);
      compile.anova.sst = jStat.sst(jMatY, yAverage);
      compile.anova.mst = compile.anova.sst / (jMatY.length - 1);
      compile.anova.r2 = 1 - compile.anova.sse / compile.anova.sst;
      if (compile.anova.r2 < 0) compile.anova.r2 = 0;
      compile.anova.fratio = compile.anova.msr / compile.anova.mse;
      compile.anova.pvalue = jStat.anovaftest(compile.anova.fratio, jMatX[0].length - 1, jMatY.length - (jMatX[0].length - 1) - 1);
      compile.anova.rmse = Math.sqrt(compile.anova.mse);
      compile.anova.r2adj = 1 - compile.anova.mse / compile.anova.mst;
      if (compile.anova.r2adj < 0) compile.anova.r2adj = 0;
      compile.stats = new Array(jMatX[0].length);
      var covar = jStat.xtranspxinv(jMatX);
      var sds, ts, ps;
      for (var i = 0; i < beta.length; i++) {
        sds = Math.sqrt(compile.anova.mse * Math.abs(covar[i][i]));
        ts = Math.abs(beta[i] / sds);
        ps = jStat.ttest(ts, jMatY.length - jMatX[0].length - 1, sides);
        compile.stats[i] = [beta[i], sds, ts, ps];
      }
      compile.regress = beta;
      return compile;
    },
    xtranspx: function xtranspx(jMatX) {
      return jStat.matrixmult(jMatX.transpose(), jMatX);
    },
    xtranspxinv: function xtranspxinv(jMatX) {
      var inner = jStat.matrixmult(jMatX.transpose(), jMatX);
      var innerinv = jStat.inv(inner);
      return innerinv;
    },
    jMatYBar: function jMatYBar(jMatX, beta) {
      var yBar = jStat.matrixmult(jMatX, beta);
      return new jStat(yBar);
    },
    residuals: function residuals(jMatY, jMatYBar) {
      return jStat.matrixsubtract(jMatY, jMatYBar);
    },
    ssr: function ssr(jMatYBar, yAverage) {
      var ssr = 0;
      for (var i = 0; i < jMatYBar.length; i++) {
        ssr += Math.pow(jMatYBar[i] - yAverage, 2);
      }
      return ssr;
    },
    sse: function sse(jMatY, jMatYBar) {
      var sse = 0;
      for (var i = 0; i < jMatY.length; i++) {
        sse += Math.pow(jMatY[i] - jMatYBar[i], 2);
      }
      return sse;
    },
    sst: function sst(jMatY, yAverage) {
      var sst = 0;
      for (var i = 0; i < jMatY.length; i++) {
        sst += Math.pow(jMatY[i] - yAverage, 2);
      }
      return sst;
    },
    matrixsubtract: function matrixsubtract(A, B) {
      var ans = new Array(A.length);
      for (var i = 0; i < A.length; i++) {
        ans[i] = new Array(A[i].length);
        for (var j = 0; j < A[i].length; j++) {
          ans[i][j] = A[i][j] - B[i][j];
        }
      }
      return jStat(ans);
    }
  });
  // Make it compatible with previous version.
  jStat.jStat = jStat;
  return jStat;
});

/***/ }),

/***/ 10103:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */;(function(){/** Used as a safe reference for `undefined` in pre-ES5 environments. */var undefined;/** Used as the semantic version number. */var VERSION='4.17.21';/** Used as the size to enable large array optimizations. */var LARGE_ARRAY_SIZE=200;/** Error message constants. */var CORE_ERROR_TEXT='Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',FUNC_ERROR_TEXT='Expected a function',INVALID_TEMPL_VAR_ERROR_TEXT='Invalid `variable` option passed into `_.template`';/** Used to stand-in for `undefined` hash values. */var HASH_UNDEFINED='__lodash_hash_undefined__';/** Used as the maximum memoize cache size. */var MAX_MEMOIZE_SIZE=500;/** Used as the internal argument placeholder. */var PLACEHOLDER='__lodash_placeholder__';/** Used to compose bitmasks for cloning. */var CLONE_DEEP_FLAG=1,CLONE_FLAT_FLAG=2,CLONE_SYMBOLS_FLAG=4;/** Used to compose bitmasks for value comparisons. */var COMPARE_PARTIAL_FLAG=1,COMPARE_UNORDERED_FLAG=2;/** Used to compose bitmasks for function metadata. */var WRAP_BIND_FLAG=1,WRAP_BIND_KEY_FLAG=2,WRAP_CURRY_BOUND_FLAG=4,WRAP_CURRY_FLAG=8,WRAP_CURRY_RIGHT_FLAG=16,WRAP_PARTIAL_FLAG=32,WRAP_PARTIAL_RIGHT_FLAG=64,WRAP_ARY_FLAG=128,WRAP_REARG_FLAG=256,WRAP_FLIP_FLAG=512;/** Used as default options for `_.truncate`. */var DEFAULT_TRUNC_LENGTH=30,DEFAULT_TRUNC_OMISSION='...';/** Used to detect hot functions by number of calls within a span of milliseconds. */var HOT_COUNT=800,HOT_SPAN=16;/** Used to indicate the type of lazy iteratees. */var LAZY_FILTER_FLAG=1,LAZY_MAP_FLAG=2,LAZY_WHILE_FLAG=3;/** Used as references for various `Number` constants. */var INFINITY=1/0,MAX_SAFE_INTEGER=9007199254740991,MAX_INTEGER=1.7976931348623157e+308,NAN=0/0;/** Used as references for the maximum length and index of an array. */var MAX_ARRAY_LENGTH=4294967295,MAX_ARRAY_INDEX=MAX_ARRAY_LENGTH-1,HALF_MAX_ARRAY_LENGTH=MAX_ARRAY_LENGTH>>>1;/** Used to associate wrap methods with their bit flags. */var wrapFlags=[['ary',WRAP_ARY_FLAG],['bind',WRAP_BIND_FLAG],['bindKey',WRAP_BIND_KEY_FLAG],['curry',WRAP_CURRY_FLAG],['curryRight',WRAP_CURRY_RIGHT_FLAG],['flip',WRAP_FLIP_FLAG],['partial',WRAP_PARTIAL_FLAG],['partialRight',WRAP_PARTIAL_RIGHT_FLAG],['rearg',WRAP_REARG_FLAG]];/** `Object#toString` result references. */var argsTag='[object Arguments]',arrayTag='[object Array]',asyncTag='[object AsyncFunction]',boolTag='[object Boolean]',dateTag='[object Date]',domExcTag='[object DOMException]',errorTag='[object Error]',funcTag='[object Function]',genTag='[object GeneratorFunction]',mapTag='[object Map]',numberTag='[object Number]',nullTag='[object Null]',objectTag='[object Object]',promiseTag='[object Promise]',proxyTag='[object Proxy]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',symbolTag='[object Symbol]',undefinedTag='[object Undefined]',weakMapTag='[object WeakMap]',weakSetTag='[object WeakSet]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/** Used to match empty string literals in compiled template source. */var reEmptyStringLeading=/\b__p \+= '';/g,reEmptyStringMiddle=/\b(__p \+=) '' \+/g,reEmptyStringTrailing=/(__e\(.*?\)|\b__t\)) \+\n'';/g;/** Used to match HTML entities and HTML characters. */var reEscapedHtml=/&(?:amp|lt|gt|quot|#39);/g,reUnescapedHtml=/[&<>"']/g,reHasEscapedHtml=RegExp(reEscapedHtml.source),reHasUnescapedHtml=RegExp(reUnescapedHtml.source);/** Used to match template delimiters. */var reEscape=/<%-([\s\S]+?)%>/g,reEvaluate=/<%([\s\S]+?)%>/g,reInterpolate=/<%=([\s\S]+?)%>/g;/** Used to match property names within property paths. */var reIsDeepProp=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,reIsPlainProp=/^\w*$/,rePropName=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;/**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */var reRegExpChar=/[\\^$.*+?()[\]{}|]/g,reHasRegExpChar=RegExp(reRegExpChar.source);/** Used to match leading whitespace. */var reTrimStart=/^\s+/;/** Used to match a single whitespace character. */var reWhitespace=/\s/;/** Used to match wrap detail comments. */var reWrapComment=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,reWrapDetails=/\{\n\/\* \[wrapped with (.+)\] \*/,reSplitDetails=/,? & /;/** Used to match words composed of alphanumeric characters. */var reAsciiWord=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;/**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */var reForbiddenIdentifierChars=/[()=,{}\[\]\/\s]/;/** Used to match backslashes in property paths. */var reEscapeChar=/\\(\\)?/g;/**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */var reEsTemplate=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;/** Used to match `RegExp` flags from their coerced string values. */var reFlags=/\w*$/;/** Used to detect bad signed hexadecimal string values. */var reIsBadHex=/^[-+]0x[0-9a-f]+$/i;/** Used to detect binary string values. */var reIsBinary=/^0b[01]+$/i;/** Used to detect host constructors (Safari). */var reIsHostCtor=/^\[object .+?Constructor\]$/;/** Used to detect octal string values. */var reIsOctal=/^0o[0-7]+$/i;/** Used to detect unsigned integer values. */var reIsUint=/^(?:0|[1-9]\d*)$/;/** Used to match Latin Unicode letters (excluding mathematical operators). */var reLatin=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;/** Used to ensure capturing order of template delimiters. */var reNoMatch=/($^)/;/** Used to match unescaped characters in compiled string literals. */var reUnescapedString=/['\n\r\u2028\u2029\\]/g;/** Used to compose unicode character classes. */var rsAstralRange='\\ud800-\\udfff',rsComboMarksRange='\\u0300-\\u036f',reComboHalfMarksRange='\\ufe20-\\ufe2f',rsComboSymbolsRange='\\u20d0-\\u20ff',rsComboRange=rsComboMarksRange+reComboHalfMarksRange+rsComboSymbolsRange,rsDingbatRange='\\u2700-\\u27bf',rsLowerRange='a-z\\xdf-\\xf6\\xf8-\\xff',rsMathOpRange='\\xac\\xb1\\xd7\\xf7',rsNonCharRange='\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',rsPunctuationRange='\\u2000-\\u206f',rsSpaceRange=' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',rsUpperRange='A-Z\\xc0-\\xd6\\xd8-\\xde',rsVarRange='\\ufe0e\\ufe0f',rsBreakRange=rsMathOpRange+rsNonCharRange+rsPunctuationRange+rsSpaceRange;/** Used to compose unicode capture groups. */var rsApos="['\u2019]",rsAstral='['+rsAstralRange+']',rsBreak='['+rsBreakRange+']',rsCombo='['+rsComboRange+']',rsDigits='\\d+',rsDingbat='['+rsDingbatRange+']',rsLower='['+rsLowerRange+']',rsMisc='[^'+rsAstralRange+rsBreakRange+rsDigits+rsDingbatRange+rsLowerRange+rsUpperRange+']',rsFitz='\\ud83c[\\udffb-\\udfff]',rsModifier='(?:'+rsCombo+'|'+rsFitz+')',rsNonAstral='[^'+rsAstralRange+']',rsRegional='(?:\\ud83c[\\udde6-\\uddff]){2}',rsSurrPair='[\\ud800-\\udbff][\\udc00-\\udfff]',rsUpper='['+rsUpperRange+']',rsZWJ='\\u200d';/** Used to compose unicode regexes. */var rsMiscLower='(?:'+rsLower+'|'+rsMisc+')',rsMiscUpper='(?:'+rsUpper+'|'+rsMisc+')',rsOptContrLower='(?:'+rsApos+'(?:d|ll|m|re|s|t|ve))?',rsOptContrUpper='(?:'+rsApos+'(?:D|LL|M|RE|S|T|VE))?',reOptMod=rsModifier+'?',rsOptVar='['+rsVarRange+']?',rsOptJoin='(?:'+rsZWJ+'(?:'+[rsNonAstral,rsRegional,rsSurrPair].join('|')+')'+rsOptVar+reOptMod+')*',rsOrdLower='\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',rsOrdUpper='\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',rsSeq=rsOptVar+reOptMod+rsOptJoin,rsEmoji='(?:'+[rsDingbat,rsRegional,rsSurrPair].join('|')+')'+rsSeq,rsSymbol='(?:'+[rsNonAstral+rsCombo+'?',rsCombo,rsRegional,rsSurrPair,rsAstral].join('|')+')';/** Used to match apostrophes. */var reApos=RegExp(rsApos,'g');/**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */var reComboMark=RegExp(rsCombo,'g');/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */var reUnicode=RegExp(rsFitz+'(?='+rsFitz+')|'+rsSymbol+rsSeq,'g');/** Used to match complex or compound words. */var reUnicodeWord=RegExp([rsUpper+'?'+rsLower+'+'+rsOptContrLower+'(?='+[rsBreak,rsUpper,'$'].join('|')+')',rsMiscUpper+'+'+rsOptContrUpper+'(?='+[rsBreak,rsUpper+rsMiscLower,'$'].join('|')+')',rsUpper+'?'+rsMiscLower+'+'+rsOptContrLower,rsUpper+'+'+rsOptContrUpper,rsOrdUpper,rsOrdLower,rsDigits,rsEmoji].join('|'),'g');/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */var reHasUnicode=RegExp('['+rsZWJ+rsAstralRange+rsComboRange+rsVarRange+']');/** Used to detect strings that need a more robust regexp to match words. */var reHasUnicodeWord=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;/** Used to assign default `context` object properties. */var contextProps=['Array','Buffer','DataView','Date','Error','Float32Array','Float64Array','Function','Int8Array','Int16Array','Int32Array','Map','Math','Object','Promise','RegExp','Set','String','Symbol','TypeError','Uint8Array','Uint8ClampedArray','Uint16Array','Uint32Array','WeakMap','_','clearTimeout','isFinite','parseInt','setTimeout'];/** Used to make template sourceURLs easier to identify. */var templateCounter=-1;/** Used to identify `toStringTag` values of typed arrays. */var typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=true;typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dataViewTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=false;/** Used to identify `toStringTag` values supported by `_.clone`. */var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[dataViewTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[mapTag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[setTag]=cloneableTags[stringTag]=cloneableTags[symbolTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=true;cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[weakMapTag]=false;/** Used to map Latin Unicode letters to basic Latin letters. */var deburredLetters={// Latin-1 Supplement block.
'\xc0':'A','\xc1':'A','\xc2':'A','\xc3':'A','\xc4':'A','\xc5':'A','\xe0':'a','\xe1':'a','\xe2':'a','\xe3':'a','\xe4':'a','\xe5':'a','\xc7':'C','\xe7':'c','\xd0':'D','\xf0':'d','\xc8':'E','\xc9':'E','\xca':'E','\xcb':'E','\xe8':'e','\xe9':'e','\xea':'e','\xeb':'e','\xcc':'I','\xcd':'I','\xce':'I','\xcf':'I','\xec':'i','\xed':'i','\xee':'i','\xef':'i','\xd1':'N','\xf1':'n','\xd2':'O','\xd3':'O','\xd4':'O','\xd5':'O','\xd6':'O','\xd8':'O','\xf2':'o','\xf3':'o','\xf4':'o','\xf5':'o','\xf6':'o','\xf8':'o','\xd9':'U','\xda':'U','\xdb':'U','\xdc':'U','\xf9':'u','\xfa':'u','\xfb':'u','\xfc':'u','\xdd':'Y','\xfd':'y','\xff':'y','\xc6':'Ae','\xe6':'ae','\xde':'Th','\xfe':'th','\xdf':'ss',// Latin Extended-A block.
'\u0100':'A','\u0102':'A','\u0104':'A','\u0101':'a','\u0103':'a','\u0105':'a','\u0106':'C','\u0108':'C','\u010a':'C','\u010c':'C','\u0107':'c','\u0109':'c','\u010b':'c','\u010d':'c','\u010e':'D','\u0110':'D','\u010f':'d','\u0111':'d','\u0112':'E','\u0114':'E','\u0116':'E','\u0118':'E','\u011a':'E','\u0113':'e','\u0115':'e','\u0117':'e','\u0119':'e','\u011b':'e','\u011c':'G','\u011e':'G','\u0120':'G','\u0122':'G','\u011d':'g','\u011f':'g','\u0121':'g','\u0123':'g','\u0124':'H','\u0126':'H','\u0125':'h','\u0127':'h','\u0128':'I','\u012a':'I','\u012c':'I','\u012e':'I','\u0130':'I','\u0129':'i','\u012b':'i','\u012d':'i','\u012f':'i','\u0131':'i','\u0134':'J','\u0135':'j','\u0136':'K','\u0137':'k','\u0138':'k','\u0139':'L','\u013b':'L','\u013d':'L','\u013f':'L','\u0141':'L','\u013a':'l','\u013c':'l','\u013e':'l','\u0140':'l','\u0142':'l','\u0143':'N','\u0145':'N','\u0147':'N','\u014a':'N','\u0144':'n','\u0146':'n','\u0148':'n','\u014b':'n','\u014c':'O','\u014e':'O','\u0150':'O','\u014d':'o','\u014f':'o','\u0151':'o','\u0154':'R','\u0156':'R','\u0158':'R','\u0155':'r','\u0157':'r','\u0159':'r','\u015a':'S','\u015c':'S','\u015e':'S','\u0160':'S','\u015b':'s','\u015d':'s','\u015f':'s','\u0161':'s','\u0162':'T','\u0164':'T','\u0166':'T','\u0163':'t','\u0165':'t','\u0167':'t','\u0168':'U','\u016a':'U','\u016c':'U','\u016e':'U','\u0170':'U','\u0172':'U','\u0169':'u','\u016b':'u','\u016d':'u','\u016f':'u','\u0171':'u','\u0173':'u','\u0174':'W','\u0175':'w','\u0176':'Y','\u0177':'y','\u0178':'Y','\u0179':'Z','\u017b':'Z','\u017d':'Z','\u017a':'z','\u017c':'z','\u017e':'z','\u0132':'IJ','\u0133':'ij','\u0152':'Oe','\u0153':'oe','\u0149':"'n",'\u017f':'s'};/** Used to map characters to HTML entities. */var htmlEscapes={'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'};/** Used to map HTML entities to characters. */var htmlUnescapes={'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&#39;':"'"};/** Used to escape characters for inclusion in compiled string literals. */var stringEscapes={'\\':'\\',"'":"'",'\n':'n','\r':'r','\u2028':'u2028','\u2029':'u2029'};/** Built-in method references without a dependency on `root`. */var freeParseFloat=parseFloat,freeParseInt=parseInt;/** Detect free variable `global` from Node.js. */var freeGlobal=typeof __webpack_require__.g=='object'&&__webpack_require__.g&&__webpack_require__.g.Object===Object&&__webpack_require__.g;/** Detect free variable `self`. */var freeSelf=typeof self=='object'&&self&&self.Object===Object&&self;/** Used as a reference to the global object. */var root=freeGlobal||freeSelf||Function('return this')();/** Detect free variable `exports`. */var freeExports= true&&exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&"object"=='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Detect free variable `process` from Node.js. */var freeProcess=moduleExports&&freeGlobal.process;/** Used to access faster Node.js helpers. */var nodeUtil=function(){try{// Use `util.types` for Node.js 10+.
var types=freeModule&&freeModule.require&&freeModule.require('util').types;if(types){return types;}// Legacy `process.binding('util')` for Node.js < 10.
return freeProcess&&freeProcess.binding&&freeProcess.binding('util');}catch(e){}}();/* Node.js helper references. */var nodeIsArrayBuffer=nodeUtil&&nodeUtil.isArrayBuffer,nodeIsDate=nodeUtil&&nodeUtil.isDate,nodeIsMap=nodeUtil&&nodeUtil.isMap,nodeIsRegExp=nodeUtil&&nodeUtil.isRegExp,nodeIsSet=nodeUtil&&nodeUtil.isSet,nodeIsTypedArray=nodeUtil&&nodeUtil.isTypedArray;/*--------------------------------------------------------------------------*//**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */function apply(func,thisArg,args){switch(args.length){case 0:return func.call(thisArg);case 1:return func.call(thisArg,args[0]);case 2:return func.call(thisArg,args[0],args[1]);case 3:return func.call(thisArg,args[0],args[1],args[2]);}return func.apply(thisArg,args);}/**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */function arrayAggregator(array,setter,iteratee,accumulator){var index=-1,length=array==null?0:array.length;while(++index<length){var value=array[index];setter(accumulator,value,iteratee(value),array);}return accumulator;}/**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */function arrayEach(array,iteratee){var index=-1,length=array==null?0:array.length;while(++index<length){if(iteratee(array[index],index,array)===false){break;}}return array;}/**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */function arrayEachRight(array,iteratee){var length=array==null?0:array.length;while(length--){if(iteratee(array[length],length,array)===false){break;}}return array;}/**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */function arrayEvery(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(!predicate(array[index],index,array)){return false;}}return true;}/**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */function arrayFilter(array,predicate){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(predicate(value,index,array)){result[resIndex++]=value;}}return result;}/**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */function arrayIncludes(array,value){var length=array==null?0:array.length;return!!length&&baseIndexOf(array,value,0)>-1;}/**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */function arrayIncludesWith(array,value,comparator){var index=-1,length=array==null?0:array.length;while(++index<length){if(comparator(value,array[index])){return true;}}return false;}/**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */function arrayMap(array,iteratee){var index=-1,length=array==null?0:array.length,result=Array(length);while(++index<length){result[index]=iteratee(array[index],index,array);}return result;}/**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */function arrayPush(array,values){var index=-1,length=values.length,offset=array.length;while(++index<length){array[offset+index]=values[index];}return array;}/**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */function arrayReduce(array,iteratee,accumulator,initAccum){var index=-1,length=array==null?0:array.length;if(initAccum&&length){accumulator=array[++index];}while(++index<length){accumulator=iteratee(accumulator,array[index],index,array);}return accumulator;}/**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */function arrayReduceRight(array,iteratee,accumulator,initAccum){var length=array==null?0:array.length;if(initAccum&&length){accumulator=array[--length];}while(length--){accumulator=iteratee(accumulator,array[length],length,array);}return accumulator;}/**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */function arraySome(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(predicate(array[index],index,array)){return true;}}return false;}/**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */var asciiSize=baseProperty('length');/**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function asciiToArray(string){return string.split('');}/**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */function asciiWords(string){return string.match(reAsciiWord)||[];}/**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */function baseFindKey(collection,predicate,eachFunc){var result;eachFunc(collection,function(value,key,collection){if(predicate(value,key,collection)){result=key;return false;}});return result;}/**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseFindIndex(array,predicate,fromIndex,fromRight){var length=array.length,index=fromIndex+(fromRight?1:-1);while(fromRight?index--:++index<length){if(predicate(array[index],index,array)){return index;}}return-1;}/**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseIndexOf(array,value,fromIndex){return value===value?strictIndexOf(array,value,fromIndex):baseFindIndex(array,baseIsNaN,fromIndex);}/**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseIndexOfWith(array,value,fromIndex,comparator){var index=fromIndex-1,length=array.length;while(++index<length){if(comparator(array[index],value)){return index;}}return-1;}/**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */function baseIsNaN(value){return value!==value;}/**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */function baseMean(array,iteratee){var length=array==null?0:array.length;return length?baseSum(array,iteratee)/length:NAN;}/**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */function baseProperty(key){return function(object){return object==null?undefined:object[key];};}/**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */function basePropertyOf(object){return function(key){return object==null?undefined:object[key];};}/**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */function baseReduce(collection,iteratee,accumulator,initAccum,eachFunc){eachFunc(collection,function(value,index,collection){accumulator=initAccum?(initAccum=false,value):iteratee(accumulator,value,index,collection);});return accumulator;}/**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */function baseSortBy(array,comparer){var length=array.length;array.sort(comparer);while(length--){array[length]=array[length].value;}return array;}/**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */function baseSum(array,iteratee){var result,index=-1,length=array.length;while(++index<length){var current=iteratee(array[index]);if(current!==undefined){result=result===undefined?current:result+current;}}return result;}/**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */function baseTimes(n,iteratee){var index=-1,result=Array(n);while(++index<n){result[index]=iteratee(index);}return result;}/**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */function baseToPairs(object,props){return arrayMap(props,function(key){return[key,object[key]];});}/**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */function baseTrim(string){return string?string.slice(0,trimmedEndIndex(string)+1).replace(reTrimStart,''):string;}/**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */function baseUnary(func){return function(value){return func(value);};}/**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */function baseValues(object,props){return arrayMap(props,function(key){return object[key];});}/**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */function cacheHas(cache,key){return cache.has(key);}/**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */function charsStartIndex(strSymbols,chrSymbols){var index=-1,length=strSymbols.length;while(++index<length&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */function charsEndIndex(strSymbols,chrSymbols){var index=strSymbols.length;while(index--&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */function countHolders(array,placeholder){var length=array.length,result=0;while(length--){if(array[length]===placeholder){++result;}}return result;}/**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */var deburrLetter=basePropertyOf(deburredLetters);/**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */var escapeHtmlChar=basePropertyOf(htmlEscapes);/**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */function escapeStringChar(chr){return'\\'+stringEscapes[chr];}/**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */function getValue(object,key){return object==null?undefined:object[key];}/**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */function hasUnicode(string){return reHasUnicode.test(string);}/**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */function hasUnicodeWord(string){return reHasUnicodeWord.test(string);}/**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */function iteratorToArray(iterator){var data,result=[];while(!(data=iterator.next()).done){result.push(data.value);}return result;}/**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */function mapToArray(map){var index=-1,result=Array(map.size);map.forEach(function(value,key){result[++index]=[key,value];});return result;}/**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */function overArg(func,transform){return function(arg){return func(transform(arg));};}/**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */function replaceHolders(array,placeholder){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value===placeholder||value===PLACEHOLDER){array[index]=PLACEHOLDER;result[resIndex++]=index;}}return result;}/**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */function setToArray(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=value;});return result;}/**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */function setToPairs(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=[value,value];});return result;}/**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function strictIndexOf(array,value,fromIndex){var index=fromIndex-1,length=array.length;while(++index<length){if(array[index]===value){return index;}}return-1;}/**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function strictLastIndexOf(array,value,fromIndex){var index=fromIndex+1;while(index--){if(array[index]===value){return index;}}return index;}/**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */function stringSize(string){return hasUnicode(string)?unicodeSize(string):asciiSize(string);}/**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function stringToArray(string){return hasUnicode(string)?unicodeToArray(string):asciiToArray(string);}/**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */function trimmedEndIndex(string){var index=string.length;while(index--&&reWhitespace.test(string.charAt(index))){}return index;}/**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */var unescapeHtmlChar=basePropertyOf(htmlUnescapes);/**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */function unicodeSize(string){var result=reUnicode.lastIndex=0;while(reUnicode.test(string)){++result;}return result;}/**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function unicodeToArray(string){return string.match(reUnicode)||[];}/**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */function unicodeWords(string){return string.match(reUnicodeWord)||[];}/*--------------------------------------------------------------------------*//**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */var runInContext=function runInContext(context){context=context==null?root:_.defaults(root.Object(),context,_.pick(root,contextProps));/** Built-in constructor references. */var Array=context.Array,Date=context.Date,Error=context.Error,Function=context.Function,Math=context.Math,Object=context.Object,RegExp=context.RegExp,String=context.String,TypeError=context.TypeError;/** Used for built-in method references. */var arrayProto=Array.prototype,funcProto=Function.prototype,objectProto=Object.prototype;/** Used to detect overreaching core-js shims. */var coreJsData=context['__core-js_shared__'];/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Used to generate unique IDs. */var idCounter=0;/** Used to detect methods masquerading as native. */var maskSrcKey=function(){var uid=/[^.]+$/.exec(coreJsData&&coreJsData.keys&&coreJsData.keys.IE_PROTO||'');return uid?'Symbol(src)_1.'+uid:'';}();/**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */var nativeObjectToString=objectProto.toString;/** Used to infer the `Object` constructor. */var objectCtorString=funcToString.call(Object);/** Used to restore the original `_` reference in `_.noConflict`. */var oldDash=root._;/** Used to detect if a method is native. */var reIsNative=RegExp('^'+funcToString.call(hasOwnProperty).replace(reRegExpChar,'\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,'$1.*?')+'$');/** Built-in value references. */var Buffer=moduleExports?context.Buffer:undefined,Symbol=context.Symbol,Uint8Array=context.Uint8Array,allocUnsafe=Buffer?Buffer.allocUnsafe:undefined,getPrototype=overArg(Object.getPrototypeOf,Object),objectCreate=Object.create,propertyIsEnumerable=objectProto.propertyIsEnumerable,splice=arrayProto.splice,spreadableSymbol=Symbol?Symbol.isConcatSpreadable:undefined,symIterator=Symbol?Symbol.iterator:undefined,symToStringTag=Symbol?Symbol.toStringTag:undefined;var defineProperty=function(){try{var func=getNative(Object,'defineProperty');func({},'',{});return func;}catch(e){}}();/** Mocked built-ins. */var ctxClearTimeout=context.clearTimeout!==root.clearTimeout&&context.clearTimeout,ctxNow=Date&&Date.now!==root.Date.now&&Date.now,ctxSetTimeout=context.setTimeout!==root.setTimeout&&context.setTimeout;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeCeil=Math.ceil,nativeFloor=Math.floor,nativeGetSymbols=Object.getOwnPropertySymbols,nativeIsBuffer=Buffer?Buffer.isBuffer:undefined,nativeIsFinite=context.isFinite,nativeJoin=arrayProto.join,nativeKeys=overArg(Object.keys,Object),nativeMax=Math.max,nativeMin=Math.min,nativeNow=Date.now,nativeParseInt=context.parseInt,nativeRandom=Math.random,nativeReverse=arrayProto.reverse;/* Built-in method references that are verified to be native. */var DataView=getNative(context,'DataView'),Map=getNative(context,'Map'),Promise=getNative(context,'Promise'),Set=getNative(context,'Set'),WeakMap=getNative(context,'WeakMap'),nativeCreate=getNative(Object,'create');/** Used to store function metadata. */var metaMap=WeakMap&&new WeakMap();/** Used to lookup unminified function names. */var realNames={};/** Used to detect maps, sets, and weakmaps. */var dataViewCtorString=toSource(DataView),mapCtorString=toSource(Map),promiseCtorString=toSource(Promise),setCtorString=toSource(Set),weakMapCtorString=toSource(WeakMap);/** Used to convert symbols to primitives and strings. */var symbolProto=Symbol?Symbol.prototype:undefined,symbolValueOf=symbolProto?symbolProto.valueOf:undefined,symbolToString=symbolProto?symbolProto.toString:undefined;/*------------------------------------------------------------------------*//**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */function lodash(value){if(isObjectLike(value)&&!isArray(value)&&!(value instanceof LazyWrapper)){if(value instanceof LodashWrapper){return value;}if(hasOwnProperty.call(value,'__wrapped__')){return wrapperClone(value);}}return new LodashWrapper(value);}/**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */var baseCreate=function(){function object(){}return function(proto){if(!isObject(proto)){return{};}if(objectCreate){return objectCreate(proto);}object.prototype=proto;var result=new object();object.prototype=undefined;return result;};}();/**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */function baseLodash(){// No operation performed.
}/**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */function LodashWrapper(value,chainAll){this.__wrapped__=value;this.__actions__=[];this.__chain__=!!chainAll;this.__index__=0;this.__values__=undefined;}/**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */lodash.templateSettings={/**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'escape':reEscape,/**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'evaluate':reEvaluate,/**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'interpolate':reInterpolate,/**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */'variable':'',/**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */'imports':{/**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */'_':lodash}};// Ensure wrappers are instances of `baseLodash`.
lodash.prototype=baseLodash.prototype;lodash.prototype.constructor=lodash;LodashWrapper.prototype=baseCreate(baseLodash.prototype);LodashWrapper.prototype.constructor=LodashWrapper;/*------------------------------------------------------------------------*//**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */function LazyWrapper(value){this.__wrapped__=value;this.__actions__=[];this.__dir__=1;this.__filtered__=false;this.__iteratees__=[];this.__takeCount__=MAX_ARRAY_LENGTH;this.__views__=[];}/**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */function lazyClone(){var result=new LazyWrapper(this.__wrapped__);result.__actions__=copyArray(this.__actions__);result.__dir__=this.__dir__;result.__filtered__=this.__filtered__;result.__iteratees__=copyArray(this.__iteratees__);result.__takeCount__=this.__takeCount__;result.__views__=copyArray(this.__views__);return result;}/**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */function lazyReverse(){if(this.__filtered__){var result=new LazyWrapper(this);result.__dir__=-1;result.__filtered__=true;}else{result=this.clone();result.__dir__*=-1;}return result;}/**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */function lazyValue(){var array=this.__wrapped__.value(),dir=this.__dir__,isArr=isArray(array),isRight=dir<0,arrLength=isArr?array.length:0,view=getView(0,arrLength,this.__views__),start=view.start,end=view.end,length=end-start,index=isRight?end:start-1,iteratees=this.__iteratees__,iterLength=iteratees.length,resIndex=0,takeCount=nativeMin(length,this.__takeCount__);if(!isArr||!isRight&&arrLength==length&&takeCount==length){return baseWrapperValue(array,this.__actions__);}var result=[];outer:while(length--&&resIndex<takeCount){index+=dir;var iterIndex=-1,value=array[index];while(++iterIndex<iterLength){var data=iteratees[iterIndex],iteratee=data.iteratee,type=data.type,computed=iteratee(value);if(type==LAZY_MAP_FLAG){value=computed;}else if(!computed){if(type==LAZY_FILTER_FLAG){continue outer;}else{break outer;}}}result[resIndex++]=value;}return result;}// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype=baseCreate(baseLodash.prototype);LazyWrapper.prototype.constructor=LazyWrapper;/*------------------------------------------------------------------------*//**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function Hash(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */function hashClear(){this.__data__=nativeCreate?nativeCreate(null):{};this.size=0;}/**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function hashDelete(key){var result=this.has(key)&&delete this.__data__[key];this.size-=result?1:0;return result;}/**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function hashGet(key){var data=this.__data__;if(nativeCreate){var result=data[key];return result===HASH_UNDEFINED?undefined:result;}return hasOwnProperty.call(data,key)?data[key]:undefined;}/**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function hashHas(key){var data=this.__data__;return nativeCreate?data[key]!==undefined:hasOwnProperty.call(data,key);}/**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */function hashSet(key,value){var data=this.__data__;this.size+=this.has(key)?0:1;data[key]=nativeCreate&&value===undefined?HASH_UNDEFINED:value;return this;}// Add methods to `Hash`.
Hash.prototype.clear=hashClear;Hash.prototype['delete']=hashDelete;Hash.prototype.get=hashGet;Hash.prototype.has=hashHas;Hash.prototype.set=hashSet;/*------------------------------------------------------------------------*//**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function ListCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */function listCacheClear(){this.__data__=[];this.size=0;}/**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function listCacheDelete(key){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){return false;}var lastIndex=data.length-1;if(index==lastIndex){data.pop();}else{splice.call(data,index,1);}--this.size;return true;}/**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function listCacheGet(key){var data=this.__data__,index=assocIndexOf(data,key);return index<0?undefined:data[index][1];}/**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function listCacheHas(key){return assocIndexOf(this.__data__,key)>-1;}/**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */function listCacheSet(key,value){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){++this.size;data.push([key,value]);}else{data[index][1]=value;}return this;}// Add methods to `ListCache`.
ListCache.prototype.clear=listCacheClear;ListCache.prototype['delete']=listCacheDelete;ListCache.prototype.get=listCacheGet;ListCache.prototype.has=listCacheHas;ListCache.prototype.set=listCacheSet;/*------------------------------------------------------------------------*//**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function MapCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */function mapCacheClear(){this.size=0;this.__data__={'hash':new Hash(),'map':new(Map||ListCache)(),'string':new Hash()};}/**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function mapCacheDelete(key){var result=getMapData(this,key)['delete'](key);this.size-=result?1:0;return result;}/**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function mapCacheGet(key){return getMapData(this,key).get(key);}/**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function mapCacheHas(key){return getMapData(this,key).has(key);}/**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */function mapCacheSet(key,value){var data=getMapData(this,key),size=data.size;data.set(key,value);this.size+=data.size==size?0:1;return this;}// Add methods to `MapCache`.
MapCache.prototype.clear=mapCacheClear;MapCache.prototype['delete']=mapCacheDelete;MapCache.prototype.get=mapCacheGet;MapCache.prototype.has=mapCacheHas;MapCache.prototype.set=mapCacheSet;/*------------------------------------------------------------------------*//**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */function SetCache(values){var index=-1,length=values==null?0:values.length;this.__data__=new MapCache();while(++index<length){this.add(values[index]);}}/**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */function setCacheAdd(value){this.__data__.set(value,HASH_UNDEFINED);return this;}/**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */function setCacheHas(value){return this.__data__.has(value);}// Add methods to `SetCache`.
SetCache.prototype.add=SetCache.prototype.push=setCacheAdd;SetCache.prototype.has=setCacheHas;/*------------------------------------------------------------------------*//**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function Stack(entries){var data=this.__data__=new ListCache(entries);this.size=data.size;}/**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */function stackClear(){this.__data__=new ListCache();this.size=0;}/**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function stackDelete(key){var data=this.__data__,result=data['delete'](key);this.size=data.size;return result;}/**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function stackGet(key){return this.__data__.get(key);}/**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function stackHas(key){return this.__data__.has(key);}/**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */function stackSet(key,value){var data=this.__data__;if(data instanceof ListCache){var pairs=data.__data__;if(!Map||pairs.length<LARGE_ARRAY_SIZE-1){pairs.push([key,value]);this.size=++data.size;return this;}data=this.__data__=new MapCache(pairs);}data.set(key,value);this.size=data.size;return this;}// Add methods to `Stack`.
Stack.prototype.clear=stackClear;Stack.prototype['delete']=stackDelete;Stack.prototype.get=stackGet;Stack.prototype.has=stackHas;Stack.prototype.set=stackSet;/*------------------------------------------------------------------------*//**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */function arrayLikeKeys(value,inherited){var isArr=isArray(value),isArg=!isArr&&isArguments(value),isBuff=!isArr&&!isArg&&isBuffer(value),isType=!isArr&&!isArg&&!isBuff&&isTypedArray(value),skipIndexes=isArr||isArg||isBuff||isType,result=skipIndexes?baseTimes(value.length,String):[],length=result.length;for(var key in value){if((inherited||hasOwnProperty.call(value,key))&&!(skipIndexes&&(// Safari 9 has enumerable `arguments.length` in strict mode.
key=='length'||// Node.js 0.10 has enumerable non-index properties on buffers.
isBuff&&(key=='offset'||key=='parent')||// PhantomJS 2 has enumerable non-index properties on typed arrays.
isType&&(key=='buffer'||key=='byteLength'||key=='byteOffset')||// Skip index properties.
isIndex(key,length)))){result.push(key);}}return result;}/**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */function arraySample(array){var length=array.length;return length?array[baseRandom(0,length-1)]:undefined;}/**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */function arraySampleSize(array,n){return shuffleSelf(copyArray(array),baseClamp(n,0,array.length));}/**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */function arrayShuffle(array){return shuffleSelf(copyArray(array));}/**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function assignMergeValue(object,key,value){if(value!==undefined&&!eq(object[key],value)||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function assignValue(object,key,value){var objValue=object[key];if(!(hasOwnProperty.call(object,key)&&eq(objValue,value))||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */function assocIndexOf(array,key){var length=array.length;while(length--){if(eq(array[length][0],key)){return length;}}return-1;}/**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */function baseAggregator(collection,setter,iteratee,accumulator){baseEach(collection,function(value,key,collection){setter(accumulator,value,iteratee(value),collection);});return accumulator;}/**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */function baseAssign(object,source){return object&&copyObject(source,keys(source),object);}/**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */function baseAssignIn(object,source){return object&&copyObject(source,keysIn(source),object);}/**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function baseAssignValue(object,key,value){if(key=='__proto__'&&defineProperty){defineProperty(object,key,{'configurable':true,'enumerable':true,'value':value,'writable':true});}else{object[key]=value;}}/**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */function baseAt(object,paths){var index=-1,length=paths.length,result=Array(length),skip=object==null;while(++index<length){result[index]=skip?undefined:get(object,paths[index]);}return result;}/**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */function baseClamp(number,lower,upper){if(number===number){if(upper!==undefined){number=number<=upper?number:upper;}if(lower!==undefined){number=number>=lower?number:lower;}}return number;}/**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */function baseClone(value,bitmask,customizer,key,object,stack){var result,isDeep=bitmask&CLONE_DEEP_FLAG,isFlat=bitmask&CLONE_FLAT_FLAG,isFull=bitmask&CLONE_SYMBOLS_FLAG;if(customizer){result=object?customizer(value,key,object,stack):customizer(value);}if(result!==undefined){return result;}if(!isObject(value)){return value;}var isArr=isArray(value);if(isArr){result=initCloneArray(value);if(!isDeep){return copyArray(value,result);}}else{var tag=getTag(value),isFunc=tag==funcTag||tag==genTag;if(isBuffer(value)){return cloneBuffer(value,isDeep);}if(tag==objectTag||tag==argsTag||isFunc&&!object){result=isFlat||isFunc?{}:initCloneObject(value);if(!isDeep){return isFlat?copySymbolsIn(value,baseAssignIn(result,value)):copySymbols(value,baseAssign(result,value));}}else{if(!cloneableTags[tag]){return object?value:{};}result=initCloneByTag(value,tag,isDeep);}}// Check for circular references and return its corresponding clone.
stack||(stack=new Stack());var stacked=stack.get(value);if(stacked){return stacked;}stack.set(value,result);if(isSet(value)){value.forEach(function(subValue){result.add(baseClone(subValue,bitmask,customizer,subValue,value,stack));});}else if(isMap(value)){value.forEach(function(subValue,key){result.set(key,baseClone(subValue,bitmask,customizer,key,value,stack));});}var keysFunc=isFull?isFlat?getAllKeysIn:getAllKeys:isFlat?keysIn:keys;var props=isArr?undefined:keysFunc(value);arrayEach(props||value,function(subValue,key){if(props){key=subValue;subValue=value[key];}// Recursively populate clone (susceptible to call stack limits).
assignValue(result,key,baseClone(subValue,bitmask,customizer,key,value,stack));});return result;}/**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */function baseConforms(source){var props=keys(source);return function(object){return baseConformsTo(object,source,props);};}/**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */function baseConformsTo(object,source,props){var length=props.length;if(object==null){return!length;}object=Object(object);while(length--){var key=props[length],predicate=source[key],value=object[key];if(value===undefined&&!(key in object)||!predicate(value)){return false;}}return true;}/**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */function baseDelay(func,wait,args){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return setTimeout(function(){func.apply(undefined,args);},wait);}/**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */function baseDifference(array,values,iteratee,comparator){var index=-1,includes=arrayIncludes,isCommon=true,length=array.length,result=[],valuesLength=values.length;if(!length){return result;}if(iteratee){values=arrayMap(values,baseUnary(iteratee));}if(comparator){includes=arrayIncludesWith;isCommon=false;}else if(values.length>=LARGE_ARRAY_SIZE){includes=cacheHas;isCommon=false;values=new SetCache(values);}outer:while(++index<length){var value=array[index],computed=iteratee==null?value:iteratee(value);value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var valuesIndex=valuesLength;while(valuesIndex--){if(values[valuesIndex]===computed){continue outer;}}result.push(value);}else if(!includes(values,computed,comparator)){result.push(value);}}return result;}/**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */var baseEach=createBaseEach(baseForOwn);/**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */var baseEachRight=createBaseEach(baseForOwnRight,true);/**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */function baseEvery(collection,predicate){var result=true;baseEach(collection,function(value,index,collection){result=!!predicate(value,index,collection);return result;});return result;}/**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */function baseExtremum(array,iteratee,comparator){var index=-1,length=array.length;while(++index<length){var value=array[index],current=iteratee(value);if(current!=null&&(computed===undefined?current===current&&!isSymbol(current):comparator(current,computed))){var computed=current,result=value;}}return result;}/**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */function baseFill(array,value,start,end){var length=array.length;start=toInteger(start);if(start<0){start=-start>length?0:length+start;}end=end===undefined||end>length?length:toInteger(end);if(end<0){end+=length;}end=start>end?0:toLength(end);while(start<end){array[start++]=value;}return array;}/**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */function baseFilter(collection,predicate){var result=[];baseEach(collection,function(value,index,collection){if(predicate(value,index,collection)){result.push(value);}});return result;}/**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */function baseFlatten(array,depth,predicate,isStrict,result){var index=-1,length=array.length;predicate||(predicate=isFlattenable);result||(result=[]);while(++index<length){var value=array[index];if(depth>0&&predicate(value)){if(depth>1){// Recursively flatten arrays (susceptible to call stack limits).
baseFlatten(value,depth-1,predicate,isStrict,result);}else{arrayPush(result,value);}}else if(!isStrict){result[result.length]=value;}}return result;}/**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */var baseFor=createBaseFor();/**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */var baseForRight=createBaseFor(true);/**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */function baseForOwn(object,iteratee){return object&&baseFor(object,iteratee,keys);}/**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */function baseForOwnRight(object,iteratee){return object&&baseForRight(object,iteratee,keys);}/**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */function baseFunctions(object,props){return arrayFilter(props,function(key){return isFunction(object[key]);});}/**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */function baseGet(object,path){path=castPath(path,object);var index=0,length=path.length;while(object!=null&&index<length){object=object[toKey(path[index++])];}return index&&index==length?object:undefined;}/**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */function baseGetAllKeys(object,keysFunc,symbolsFunc){var result=keysFunc(object);return isArray(object)?result:arrayPush(result,symbolsFunc(object));}/**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */function baseGetTag(value){if(value==null){return value===undefined?undefinedTag:nullTag;}return symToStringTag&&symToStringTag in Object(value)?getRawTag(value):objectToString(value);}/**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */function baseGt(value,other){return value>other;}/**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */function baseHas(object,key){return object!=null&&hasOwnProperty.call(object,key);}/**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */function baseHasIn(object,key){return object!=null&&key in Object(object);}/**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */function baseInRange(number,start,end){return number>=nativeMin(start,end)&&number<nativeMax(start,end);}/**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */function baseIntersection(arrays,iteratee,comparator){var includes=comparator?arrayIncludesWith:arrayIncludes,length=arrays[0].length,othLength=arrays.length,othIndex=othLength,caches=Array(othLength),maxLength=Infinity,result=[];while(othIndex--){var array=arrays[othIndex];if(othIndex&&iteratee){array=arrayMap(array,baseUnary(iteratee));}maxLength=nativeMin(array.length,maxLength);caches[othIndex]=!comparator&&(iteratee||length>=120&&array.length>=120)?new SetCache(othIndex&&array):undefined;}array=arrays[0];var index=-1,seen=caches[0];outer:while(++index<length&&result.length<maxLength){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(!(seen?cacheHas(seen,computed):includes(result,computed,comparator))){othIndex=othLength;while(--othIndex){var cache=caches[othIndex];if(!(cache?cacheHas(cache,computed):includes(arrays[othIndex],computed,comparator))){continue outer;}}if(seen){seen.push(computed);}result.push(value);}}return result;}/**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */function baseInverter(object,setter,iteratee,accumulator){baseForOwn(object,function(value,key,object){setter(accumulator,iteratee(value),key,object);});return accumulator;}/**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */function baseInvoke(object,path,args){path=castPath(path,object);object=parent(object,path);var func=object==null?object:object[toKey(last(path))];return func==null?undefined:apply(func,object,args);}/**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */function baseIsArguments(value){return isObjectLike(value)&&baseGetTag(value)==argsTag;}/**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */function baseIsArrayBuffer(value){return isObjectLike(value)&&baseGetTag(value)==arrayBufferTag;}/**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */function baseIsDate(value){return isObjectLike(value)&&baseGetTag(value)==dateTag;}/**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */function baseIsEqual(value,other,bitmask,customizer,stack){if(value===other){return true;}if(value==null||other==null||!isObjectLike(value)&&!isObjectLike(other)){return value!==value&&other!==other;}return baseIsEqualDeep(value,other,bitmask,customizer,baseIsEqual,stack);}/**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function baseIsEqualDeep(object,other,bitmask,customizer,equalFunc,stack){var objIsArr=isArray(object),othIsArr=isArray(other),objTag=objIsArr?arrayTag:getTag(object),othTag=othIsArr?arrayTag:getTag(other);objTag=objTag==argsTag?objectTag:objTag;othTag=othTag==argsTag?objectTag:othTag;var objIsObj=objTag==objectTag,othIsObj=othTag==objectTag,isSameTag=objTag==othTag;if(isSameTag&&isBuffer(object)){if(!isBuffer(other)){return false;}objIsArr=true;objIsObj=false;}if(isSameTag&&!objIsObj){stack||(stack=new Stack());return objIsArr||isTypedArray(object)?equalArrays(object,other,bitmask,customizer,equalFunc,stack):equalByTag(object,other,objTag,bitmask,customizer,equalFunc,stack);}if(!(bitmask&COMPARE_PARTIAL_FLAG)){var objIsWrapped=objIsObj&&hasOwnProperty.call(object,'__wrapped__'),othIsWrapped=othIsObj&&hasOwnProperty.call(other,'__wrapped__');if(objIsWrapped||othIsWrapped){var objUnwrapped=objIsWrapped?object.value():object,othUnwrapped=othIsWrapped?other.value():other;stack||(stack=new Stack());return equalFunc(objUnwrapped,othUnwrapped,bitmask,customizer,stack);}}if(!isSameTag){return false;}stack||(stack=new Stack());return equalObjects(object,other,bitmask,customizer,equalFunc,stack);}/**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */function baseIsMap(value){return isObjectLike(value)&&getTag(value)==mapTag;}/**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */function baseIsMatch(object,source,matchData,customizer){var index=matchData.length,length=index,noCustomizer=!customizer;if(object==null){return!length;}object=Object(object);while(index--){var data=matchData[index];if(noCustomizer&&data[2]?data[1]!==object[data[0]]:!(data[0]in object)){return false;}}while(++index<length){data=matchData[index];var key=data[0],objValue=object[key],srcValue=data[1];if(noCustomizer&&data[2]){if(objValue===undefined&&!(key in object)){return false;}}else{var stack=new Stack();if(customizer){var result=customizer(objValue,srcValue,key,object,source,stack);}if(!(result===undefined?baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG,customizer,stack):result)){return false;}}}return true;}/**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */function baseIsNative(value){if(!isObject(value)||isMasked(value)){return false;}var pattern=isFunction(value)?reIsNative:reIsHostCtor;return pattern.test(toSource(value));}/**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */function baseIsRegExp(value){return isObjectLike(value)&&baseGetTag(value)==regexpTag;}/**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */function baseIsSet(value){return isObjectLike(value)&&getTag(value)==setTag;}/**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */function baseIsTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[baseGetTag(value)];}/**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */function baseIteratee(value){// Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
// See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
if(typeof value=='function'){return value;}if(value==null){return identity;}if(typeof value=='object'){return isArray(value)?baseMatchesProperty(value[0],value[1]):baseMatches(value);}return property(value);}/**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function baseKeys(object){if(!isPrototype(object)){return nativeKeys(object);}var result=[];for(var key in Object(object)){if(hasOwnProperty.call(object,key)&&key!='constructor'){result.push(key);}}return result;}/**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function baseKeysIn(object){if(!isObject(object)){return nativeKeysIn(object);}var isProto=isPrototype(object),result=[];for(var key in object){if(!(key=='constructor'&&(isProto||!hasOwnProperty.call(object,key)))){result.push(key);}}return result;}/**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */function baseLt(value,other){return value<other;}/**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */function baseMap(collection,iteratee){var index=-1,result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value,key,collection){result[++index]=iteratee(value,key,collection);});return result;}/**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */function baseMatches(source){var matchData=getMatchData(source);if(matchData.length==1&&matchData[0][2]){return matchesStrictComparable(matchData[0][0],matchData[0][1]);}return function(object){return object===source||baseIsMatch(object,source,matchData);};}/**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */function baseMatchesProperty(path,srcValue){if(isKey(path)&&isStrictComparable(srcValue)){return matchesStrictComparable(toKey(path),srcValue);}return function(object){var objValue=get(object,path);return objValue===undefined&&objValue===srcValue?hasIn(object,path):baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG);};}/**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */function baseMerge(object,source,srcIndex,customizer,stack){if(object===source){return;}baseFor(source,function(srcValue,key){stack||(stack=new Stack());if(isObject(srcValue)){baseMergeDeep(object,source,key,srcIndex,baseMerge,customizer,stack);}else{var newValue=customizer?customizer(safeGet(object,key),srcValue,key+'',object,source,stack):undefined;if(newValue===undefined){newValue=srcValue;}assignMergeValue(object,key,newValue);}},keysIn);}/**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */function baseMergeDeep(object,source,key,srcIndex,mergeFunc,customizer,stack){var objValue=safeGet(object,key),srcValue=safeGet(source,key),stacked=stack.get(srcValue);if(stacked){assignMergeValue(object,key,stacked);return;}var newValue=customizer?customizer(objValue,srcValue,key+'',object,source,stack):undefined;var isCommon=newValue===undefined;if(isCommon){var isArr=isArray(srcValue),isBuff=!isArr&&isBuffer(srcValue),isTyped=!isArr&&!isBuff&&isTypedArray(srcValue);newValue=srcValue;if(isArr||isBuff||isTyped){if(isArray(objValue)){newValue=objValue;}else if(isArrayLikeObject(objValue)){newValue=copyArray(objValue);}else if(isBuff){isCommon=false;newValue=cloneBuffer(srcValue,true);}else if(isTyped){isCommon=false;newValue=cloneTypedArray(srcValue,true);}else{newValue=[];}}else if(isPlainObject(srcValue)||isArguments(srcValue)){newValue=objValue;if(isArguments(objValue)){newValue=toPlainObject(objValue);}else if(!isObject(objValue)||isFunction(objValue)){newValue=initCloneObject(srcValue);}}else{isCommon=false;}}if(isCommon){// Recursively merge objects and arrays (susceptible to call stack limits).
stack.set(srcValue,newValue);mergeFunc(newValue,srcValue,srcIndex,customizer,stack);stack['delete'](srcValue);}assignMergeValue(object,key,newValue);}/**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */function baseNth(array,n){var length=array.length;if(!length){return;}n+=n<0?length:0;return isIndex(n,length)?array[n]:undefined;}/**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */function baseOrderBy(collection,iteratees,orders){if(iteratees.length){iteratees=arrayMap(iteratees,function(iteratee){if(isArray(iteratee)){return function(value){return baseGet(value,iteratee.length===1?iteratee[0]:iteratee);};}return iteratee;});}else{iteratees=[identity];}var index=-1;iteratees=arrayMap(iteratees,baseUnary(getIteratee()));var result=baseMap(collection,function(value,key,collection){var criteria=arrayMap(iteratees,function(iteratee){return iteratee(value);});return{'criteria':criteria,'index':++index,'value':value};});return baseSortBy(result,function(object,other){return compareMultiple(object,other,orders);});}/**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */function basePick(object,paths){return basePickBy(object,paths,function(value,path){return hasIn(object,path);});}/**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */function basePickBy(object,paths,predicate){var index=-1,length=paths.length,result={};while(++index<length){var path=paths[index],value=baseGet(object,path);if(predicate(value,path)){baseSet(result,castPath(path,object),value);}}return result;}/**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */function basePropertyDeep(path){return function(object){return baseGet(object,path);};}/**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */function basePullAll(array,values,iteratee,comparator){var indexOf=comparator?baseIndexOfWith:baseIndexOf,index=-1,length=values.length,seen=array;if(array===values){values=copyArray(values);}if(iteratee){seen=arrayMap(array,baseUnary(iteratee));}while(++index<length){var fromIndex=0,value=values[index],computed=iteratee?iteratee(value):value;while((fromIndex=indexOf(seen,computed,fromIndex,comparator))>-1){if(seen!==array){splice.call(seen,fromIndex,1);}splice.call(array,fromIndex,1);}}return array;}/**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */function basePullAt(array,indexes){var length=array?indexes.length:0,lastIndex=length-1;while(length--){var index=indexes[length];if(length==lastIndex||index!==previous){var previous=index;if(isIndex(index)){splice.call(array,index,1);}else{baseUnset(array,index);}}}return array;}/**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */function baseRandom(lower,upper){return lower+nativeFloor(nativeRandom()*(upper-lower+1));}/**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */function baseRange(start,end,step,fromRight){var index=-1,length=nativeMax(nativeCeil((end-start)/(step||1)),0),result=Array(length);while(length--){result[fromRight?length:++index]=start;start+=step;}return result;}/**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */function baseRepeat(string,n){var result='';if(!string||n<1||n>MAX_SAFE_INTEGER){return result;}// Leverage the exponentiation by squaring algorithm for a faster repeat.
// See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
do{if(n%2){result+=string;}n=nativeFloor(n/2);if(n){string+=string;}}while(n);return result;}/**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */function baseRest(func,start){return setToString(overRest(func,start,identity),func+'');}/**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */function baseSample(collection){return arraySample(values(collection));}/**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */function baseSampleSize(collection,n){var array=values(collection);return shuffleSelf(array,baseClamp(n,0,array.length));}/**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */function baseSet(object,path,value,customizer){if(!isObject(object)){return object;}path=castPath(path,object);var index=-1,length=path.length,lastIndex=length-1,nested=object;while(nested!=null&&++index<length){var key=toKey(path[index]),newValue=value;if(key==='__proto__'||key==='constructor'||key==='prototype'){return object;}if(index!=lastIndex){var objValue=nested[key];newValue=customizer?customizer(objValue,key,nested):undefined;if(newValue===undefined){newValue=isObject(objValue)?objValue:isIndex(path[index+1])?[]:{};}}assignValue(nested,key,newValue);nested=nested[key];}return object;}/**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */var baseSetData=!metaMap?identity:function(func,data){metaMap.set(func,data);return func;};/**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */var baseSetToString=!defineProperty?identity:function(func,string){return defineProperty(func,'toString',{'configurable':true,'enumerable':false,'value':constant(string),'writable':true});};/**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */function baseShuffle(collection){return shuffleSelf(values(collection));}/**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */function baseSlice(array,start,end){var index=-1,length=array.length;if(start<0){start=-start>length?0:length+start;}end=end>length?length:end;if(end<0){end+=length;}length=start>end?0:end-start>>>0;start>>>=0;var result=Array(length);while(++index<length){result[index]=array[index+start];}return result;}/**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */function baseSome(collection,predicate){var result;baseEach(collection,function(value,index,collection){result=predicate(value,index,collection);return!result;});return!!result;}/**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */function baseSortedIndex(array,value,retHighest){var low=0,high=array==null?low:array.length;if(typeof value=='number'&&value===value&&high<=HALF_MAX_ARRAY_LENGTH){while(low<high){var mid=low+high>>>1,computed=array[mid];if(computed!==null&&!isSymbol(computed)&&(retHighest?computed<=value:computed<value)){low=mid+1;}else{high=mid;}}return high;}return baseSortedIndexBy(array,value,identity,retHighest);}/**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */function baseSortedIndexBy(array,value,iteratee,retHighest){var low=0,high=array==null?0:array.length;if(high===0){return 0;}value=iteratee(value);var valIsNaN=value!==value,valIsNull=value===null,valIsSymbol=isSymbol(value),valIsUndefined=value===undefined;while(low<high){var mid=nativeFloor((low+high)/2),computed=iteratee(array[mid]),othIsDefined=computed!==undefined,othIsNull=computed===null,othIsReflexive=computed===computed,othIsSymbol=isSymbol(computed);if(valIsNaN){var setLow=retHighest||othIsReflexive;}else if(valIsUndefined){setLow=othIsReflexive&&(retHighest||othIsDefined);}else if(valIsNull){setLow=othIsReflexive&&othIsDefined&&(retHighest||!othIsNull);}else if(valIsSymbol){setLow=othIsReflexive&&othIsDefined&&!othIsNull&&(retHighest||!othIsSymbol);}else if(othIsNull||othIsSymbol){setLow=false;}else{setLow=retHighest?computed<=value:computed<value;}if(setLow){low=mid+1;}else{high=mid;}}return nativeMin(high,MAX_ARRAY_INDEX);}/**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */function baseSortedUniq(array,iteratee){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;if(!index||!eq(computed,seen)){var seen=computed;result[resIndex++]=value===0?0:value;}}return result;}/**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */function baseToNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}return+value;}/**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */function baseToString(value){// Exit early for strings to avoid a performance hit in some environments.
if(typeof value=='string'){return value;}if(isArray(value)){// Recursively convert values (susceptible to call stack limits).
return arrayMap(value,baseToString)+'';}if(isSymbol(value)){return symbolToString?symbolToString.call(value):'';}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */function baseUniq(array,iteratee,comparator){var index=-1,includes=arrayIncludes,length=array.length,isCommon=true,result=[],seen=result;if(comparator){isCommon=false;includes=arrayIncludesWith;}else if(length>=LARGE_ARRAY_SIZE){var set=iteratee?null:createSet(array);if(set){return setToArray(set);}isCommon=false;includes=cacheHas;seen=new SetCache();}else{seen=iteratee?[]:result;}outer:while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var seenIndex=seen.length;while(seenIndex--){if(seen[seenIndex]===computed){continue outer;}}if(iteratee){seen.push(computed);}result.push(value);}else if(!includes(seen,computed,comparator)){if(seen!==result){seen.push(computed);}result.push(value);}}return result;}/**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */function baseUnset(object,path){path=castPath(path,object);object=parent(object,path);return object==null||delete object[toKey(last(path))];}/**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */function baseUpdate(object,path,updater,customizer){return baseSet(object,path,updater(baseGet(object,path)),customizer);}/**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */function baseWhile(array,predicate,isDrop,fromRight){var length=array.length,index=fromRight?length:-1;while((fromRight?index--:++index<length)&&predicate(array[index],index,array)){}return isDrop?baseSlice(array,fromRight?0:index,fromRight?index+1:length):baseSlice(array,fromRight?index+1:0,fromRight?length:index);}/**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */function baseWrapperValue(value,actions){var result=value;if(result instanceof LazyWrapper){result=result.value();}return arrayReduce(actions,function(result,action){return action.func.apply(action.thisArg,arrayPush([result],action.args));},result);}/**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */function baseXor(arrays,iteratee,comparator){var length=arrays.length;if(length<2){return length?baseUniq(arrays[0]):[];}var index=-1,result=Array(length);while(++index<length){var array=arrays[index],othIndex=-1;while(++othIndex<length){if(othIndex!=index){result[index]=baseDifference(result[index]||array,arrays[othIndex],iteratee,comparator);}}}return baseUniq(baseFlatten(result,1),iteratee,comparator);}/**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */function baseZipObject(props,values,assignFunc){var index=-1,length=props.length,valsLength=values.length,result={};while(++index<length){var value=index<valsLength?values[index]:undefined;assignFunc(result,props[index],value);}return result;}/**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */function castArrayLikeObject(value){return isArrayLikeObject(value)?value:[];}/**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */function castFunction(value){return typeof value=='function'?value:identity;}/**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */function castPath(value,object){if(isArray(value)){return value;}return isKey(value,object)?[value]:stringToPath(toString(value));}/**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */var castRest=baseRest;/**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */function castSlice(array,start,end){var length=array.length;end=end===undefined?length:end;return!start&&end>=length?array:baseSlice(array,start,end);}/**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */var clearTimeout=ctxClearTimeout||function(id){return root.clearTimeout(id);};/**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */function cloneBuffer(buffer,isDeep){if(isDeep){return buffer.slice();}var length=buffer.length,result=allocUnsafe?allocUnsafe(length):new buffer.constructor(length);buffer.copy(result);return result;}/**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */function cloneArrayBuffer(arrayBuffer){var result=new arrayBuffer.constructor(arrayBuffer.byteLength);new Uint8Array(result).set(new Uint8Array(arrayBuffer));return result;}/**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */function cloneDataView(dataView,isDeep){var buffer=isDeep?cloneArrayBuffer(dataView.buffer):dataView.buffer;return new dataView.constructor(buffer,dataView.byteOffset,dataView.byteLength);}/**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */function cloneRegExp(regexp){var result=new regexp.constructor(regexp.source,reFlags.exec(regexp));result.lastIndex=regexp.lastIndex;return result;}/**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */function cloneSymbol(symbol){return symbolValueOf?Object(symbolValueOf.call(symbol)):{};}/**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */function cloneTypedArray(typedArray,isDeep){var buffer=isDeep?cloneArrayBuffer(typedArray.buffer):typedArray.buffer;return new typedArray.constructor(buffer,typedArray.byteOffset,typedArray.length);}/**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */function compareAscending(value,other){if(value!==other){var valIsDefined=value!==undefined,valIsNull=value===null,valIsReflexive=value===value,valIsSymbol=isSymbol(value);var othIsDefined=other!==undefined,othIsNull=other===null,othIsReflexive=other===other,othIsSymbol=isSymbol(other);if(!othIsNull&&!othIsSymbol&&!valIsSymbol&&value>other||valIsSymbol&&othIsDefined&&othIsReflexive&&!othIsNull&&!othIsSymbol||valIsNull&&othIsDefined&&othIsReflexive||!valIsDefined&&othIsReflexive||!valIsReflexive){return 1;}if(!valIsNull&&!valIsSymbol&&!othIsSymbol&&value<other||othIsSymbol&&valIsDefined&&valIsReflexive&&!valIsNull&&!valIsSymbol||othIsNull&&valIsDefined&&valIsReflexive||!othIsDefined&&valIsReflexive||!othIsReflexive){return-1;}}return 0;}/**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */function compareMultiple(object,other,orders){var index=-1,objCriteria=object.criteria,othCriteria=other.criteria,length=objCriteria.length,ordersLength=orders.length;while(++index<length){var result=compareAscending(objCriteria[index],othCriteria[index]);if(result){if(index>=ordersLength){return result;}var order=orders[index];return result*(order=='desc'?-1:1);}}// Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
// that causes it, under certain circumstances, to provide the same value for
// `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
// for more details.
//
// This also ensures a stable sort in V8 and other engines.
// See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
return object.index-other.index;}/**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */function composeArgs(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersLength=holders.length,leftIndex=-1,leftLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(leftLength+rangeLength),isUncurried=!isCurried;while(++leftIndex<leftLength){result[leftIndex]=partials[leftIndex];}while(++argsIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[holders[argsIndex]]=args[argsIndex];}}while(rangeLength--){result[leftIndex++]=args[argsIndex++];}return result;}/**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */function composeArgsRight(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersIndex=-1,holdersLength=holders.length,rightIndex=-1,rightLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(rangeLength+rightLength),isUncurried=!isCurried;while(++argsIndex<rangeLength){result[argsIndex]=args[argsIndex];}var offset=argsIndex;while(++rightIndex<rightLength){result[offset+rightIndex]=partials[rightIndex];}while(++holdersIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[offset+holders[holdersIndex]]=args[argsIndex++];}}return result;}/**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */function copyArray(source,array){var index=-1,length=source.length;array||(array=Array(length));while(++index<length){array[index]=source[index];}return array;}/**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */function copyObject(source,props,object,customizer){var isNew=!object;object||(object={});var index=-1,length=props.length;while(++index<length){var key=props[index];var newValue=customizer?customizer(object[key],source[key],key,object,source):undefined;if(newValue===undefined){newValue=source[key];}if(isNew){baseAssignValue(object,key,newValue);}else{assignValue(object,key,newValue);}}return object;}/**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */function copySymbols(source,object){return copyObject(source,getSymbols(source),object);}/**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */function copySymbolsIn(source,object){return copyObject(source,getSymbolsIn(source),object);}/**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */function createAggregator(setter,initializer){return function(collection,iteratee){var func=isArray(collection)?arrayAggregator:baseAggregator,accumulator=initializer?initializer():{};return func(collection,setter,getIteratee(iteratee,2),accumulator);};}/**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */function createAssigner(assigner){return baseRest(function(object,sources){var index=-1,length=sources.length,customizer=length>1?sources[length-1]:undefined,guard=length>2?sources[2]:undefined;customizer=assigner.length>3&&typeof customizer=='function'?(length--,customizer):undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){customizer=length<3?undefined:customizer;length=1;}object=Object(object);while(++index<length){var source=sources[index];if(source){assigner(object,source,index,customizer);}}return object;});}/**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */function createBaseEach(eachFunc,fromRight){return function(collection,iteratee){if(collection==null){return collection;}if(!isArrayLike(collection)){return eachFunc(collection,iteratee);}var length=collection.length,index=fromRight?length:-1,iterable=Object(collection);while(fromRight?index--:++index<length){if(iteratee(iterable[index],index,iterable)===false){break;}}return collection;};}/**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */function createBaseFor(fromRight){return function(object,iteratee,keysFunc){var index=-1,iterable=Object(object),props=keysFunc(object),length=props.length;while(length--){var key=props[fromRight?length:++index];if(iteratee(iterable[key],key,iterable)===false){break;}}return object;};}/**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createBind(func,bitmask,thisArg){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return fn.apply(isBind?thisArg:this,arguments);}return wrapper;}/**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */function createCaseFirst(methodName){return function(string){string=toString(string);var strSymbols=hasUnicode(string)?stringToArray(string):undefined;var chr=strSymbols?strSymbols[0]:string.charAt(0);var trailing=strSymbols?castSlice(strSymbols,1).join(''):string.slice(1);return chr[methodName]()+trailing;};}/**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */function createCompounder(callback){return function(string){return arrayReduce(words(deburr(string).replace(reApos,'')),callback,'');};}/**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */function createCtor(Ctor){return function(){// Use a `switch` statement to work with class constructors. See
// http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
// for more details.
var args=arguments;switch(args.length){case 0:return new Ctor();case 1:return new Ctor(args[0]);case 2:return new Ctor(args[0],args[1]);case 3:return new Ctor(args[0],args[1],args[2]);case 4:return new Ctor(args[0],args[1],args[2],args[3]);case 5:return new Ctor(args[0],args[1],args[2],args[3],args[4]);case 6:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5]);case 7:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5],args[6]);}var thisBinding=baseCreate(Ctor.prototype),result=Ctor.apply(thisBinding,args);// Mimic the constructor's `return` behavior.
// See https://es5.github.io/#x13.2.2 for more details.
return isObject(result)?result:thisBinding;};}/**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createCurry(func,bitmask,arity){var Ctor=createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length,placeholder=getHolder(wrapper);while(index--){args[index]=arguments[index];}var holders=length<3&&args[0]!==placeholder&&args[length-1]!==placeholder?[]:replaceHolders(args,placeholder);length-=holders.length;if(length<arity){return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,undefined,args,holders,undefined,undefined,arity-length);}var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return apply(fn,this,args);}return wrapper;}/**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */function createFind(findIndexFunc){return function(collection,predicate,fromIndex){var iterable=Object(collection);if(!isArrayLike(collection)){var iteratee=getIteratee(predicate,3);collection=keys(collection);predicate=function(key){return iteratee(iterable[key],key,iterable);};}var index=findIndexFunc(collection,predicate,fromIndex);return index>-1?iterable[iteratee?collection[index]:index]:undefined;};}/**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */function createFlow(fromRight){return flatRest(function(funcs){var length=funcs.length,index=length,prereq=LodashWrapper.prototype.thru;if(fromRight){funcs.reverse();}while(index--){var func=funcs[index];if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(prereq&&!wrapper&&getFuncName(func)=='wrapper'){var wrapper=new LodashWrapper([],true);}}index=wrapper?index:length;while(++index<length){func=funcs[index];var funcName=getFuncName(func),data=funcName=='wrapper'?getData(func):undefined;if(data&&isLaziable(data[0])&&data[1]==(WRAP_ARY_FLAG|WRAP_CURRY_FLAG|WRAP_PARTIAL_FLAG|WRAP_REARG_FLAG)&&!data[4].length&&data[9]==1){wrapper=wrapper[getFuncName(data[0])].apply(wrapper,data[3]);}else{wrapper=func.length==1&&isLaziable(func)?wrapper[funcName]():wrapper.thru(func);}}return function(){var args=arguments,value=args[0];if(wrapper&&args.length==1&&isArray(value)){return wrapper.plant(value).value();}var index=0,result=length?funcs[index].apply(this,args):value;while(++index<length){result=funcs[index].call(this,result);}return result;};});}/**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createHybrid(func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity){var isAry=bitmask&WRAP_ARY_FLAG,isBind=bitmask&WRAP_BIND_FLAG,isBindKey=bitmask&WRAP_BIND_KEY_FLAG,isCurried=bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG),isFlip=bitmask&WRAP_FLIP_FLAG,Ctor=isBindKey?undefined:createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length;while(index--){args[index]=arguments[index];}if(isCurried){var placeholder=getHolder(wrapper),holdersCount=countHolders(args,placeholder);}if(partials){args=composeArgs(args,partials,holders,isCurried);}if(partialsRight){args=composeArgsRight(args,partialsRight,holdersRight,isCurried);}length-=holdersCount;if(isCurried&&length<arity){var newHolders=replaceHolders(args,placeholder);return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,thisArg,args,newHolders,argPos,ary,arity-length);}var thisBinding=isBind?thisArg:this,fn=isBindKey?thisBinding[func]:func;length=args.length;if(argPos){args=reorder(args,argPos);}else if(isFlip&&length>1){args.reverse();}if(isAry&&ary<length){args.length=ary;}if(this&&this!==root&&this instanceof wrapper){fn=Ctor||createCtor(fn);}return fn.apply(thisBinding,args);}return wrapper;}/**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */function createInverter(setter,toIteratee){return function(object,iteratee){return baseInverter(object,setter,toIteratee(iteratee),{});};}/**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */function createMathOperation(operator,defaultValue){return function(value,other){var result;if(value===undefined&&other===undefined){return defaultValue;}if(value!==undefined){result=value;}if(other!==undefined){if(result===undefined){return other;}if(typeof value=='string'||typeof other=='string'){value=baseToString(value);other=baseToString(other);}else{value=baseToNumber(value);other=baseToNumber(other);}result=operator(value,other);}return result;};}/**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */function createOver(arrayFunc){return flatRest(function(iteratees){iteratees=arrayMap(iteratees,baseUnary(getIteratee()));return baseRest(function(args){var thisArg=this;return arrayFunc(iteratees,function(iteratee){return apply(iteratee,thisArg,args);});});});}/**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */function createPadding(length,chars){chars=chars===undefined?' ':baseToString(chars);var charsLength=chars.length;if(charsLength<2){return charsLength?baseRepeat(chars,length):chars;}var result=baseRepeat(chars,nativeCeil(length/stringSize(chars)));return hasUnicode(chars)?castSlice(stringToArray(result),0,length).join(''):result.slice(0,length);}/**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */function createPartial(func,bitmask,thisArg,partials){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var argsIndex=-1,argsLength=arguments.length,leftIndex=-1,leftLength=partials.length,args=Array(leftLength+argsLength),fn=this&&this!==root&&this instanceof wrapper?Ctor:func;while(++leftIndex<leftLength){args[leftIndex]=partials[leftIndex];}while(argsLength--){args[leftIndex++]=arguments[++argsIndex];}return apply(fn,isBind?thisArg:this,args);}return wrapper;}/**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */function createRange(fromRight){return function(start,end,step){if(step&&typeof step!='number'&&isIterateeCall(start,end,step)){end=step=undefined;}// Ensure the sign of `-0` is preserved.
start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}step=step===undefined?start<end?1:-1:toFinite(step);return baseRange(start,end,step,fromRight);};}/**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */function createRelationalOperation(operator){return function(value,other){if(!(typeof value=='string'&&typeof other=='string')){value=toNumber(value);other=toNumber(other);}return operator(value,other);};}/**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createRecurry(func,bitmask,wrapFunc,placeholder,thisArg,partials,holders,argPos,ary,arity){var isCurry=bitmask&WRAP_CURRY_FLAG,newHolders=isCurry?holders:undefined,newHoldersRight=isCurry?undefined:holders,newPartials=isCurry?partials:undefined,newPartialsRight=isCurry?undefined:partials;bitmask|=isCurry?WRAP_PARTIAL_FLAG:WRAP_PARTIAL_RIGHT_FLAG;bitmask&=~(isCurry?WRAP_PARTIAL_RIGHT_FLAG:WRAP_PARTIAL_FLAG);if(!(bitmask&WRAP_CURRY_BOUND_FLAG)){bitmask&=~(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG);}var newData=[func,bitmask,thisArg,newPartials,newHolders,newPartialsRight,newHoldersRight,argPos,ary,arity];var result=wrapFunc.apply(undefined,newData);if(isLaziable(func)){setData(result,newData);}result.placeholder=placeholder;return setWrapToString(result,func,bitmask);}/**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */function createRound(methodName){var func=Math[methodName];return function(number,precision){number=toNumber(number);precision=precision==null?0:nativeMin(toInteger(precision),292);if(precision&&nativeIsFinite(number)){// Shift with exponential notation to avoid floating-point issues.
// See [MDN](https://mdn.io/round#Examples) for more details.
var pair=(toString(number)+'e').split('e'),value=func(pair[0]+'e'+(+pair[1]+precision));pair=(toString(value)+'e').split('e');return+(pair[0]+'e'+(+pair[1]-precision));}return func(number);};}/**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */var createSet=!(Set&&1/setToArray(new Set([,-0]))[1]==INFINITY)?noop:function(values){return new Set(values);};/**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */function createToPairs(keysFunc){return function(object){var tag=getTag(object);if(tag==mapTag){return mapToArray(object);}if(tag==setTag){return setToPairs(object);}return baseToPairs(object,keysFunc(object));};}/**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createWrap(func,bitmask,thisArg,partials,holders,argPos,ary,arity){var isBindKey=bitmask&WRAP_BIND_KEY_FLAG;if(!isBindKey&&typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var length=partials?partials.length:0;if(!length){bitmask&=~(WRAP_PARTIAL_FLAG|WRAP_PARTIAL_RIGHT_FLAG);partials=holders=undefined;}ary=ary===undefined?ary:nativeMax(toInteger(ary),0);arity=arity===undefined?arity:toInteger(arity);length-=holders?holders.length:0;if(bitmask&WRAP_PARTIAL_RIGHT_FLAG){var partialsRight=partials,holdersRight=holders;partials=holders=undefined;}var data=isBindKey?undefined:getData(func);var newData=[func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity];if(data){mergeData(newData,data);}func=newData[0];bitmask=newData[1];thisArg=newData[2];partials=newData[3];holders=newData[4];arity=newData[9]=newData[9]===undefined?isBindKey?0:func.length:nativeMax(newData[9]-length,0);if(!arity&&bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG)){bitmask&=~(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG);}if(!bitmask||bitmask==WRAP_BIND_FLAG){var result=createBind(func,bitmask,thisArg);}else if(bitmask==WRAP_CURRY_FLAG||bitmask==WRAP_CURRY_RIGHT_FLAG){result=createCurry(func,bitmask,arity);}else if((bitmask==WRAP_PARTIAL_FLAG||bitmask==(WRAP_BIND_FLAG|WRAP_PARTIAL_FLAG))&&!holders.length){result=createPartial(func,bitmask,thisArg,partials);}else{result=createHybrid.apply(undefined,newData);}var setter=data?baseSetData:setData;return setWrapToString(setter(result,newData),func,bitmask);}/**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */function customDefaultsAssignIn(objValue,srcValue,key,object){if(objValue===undefined||eq(objValue,objectProto[key])&&!hasOwnProperty.call(object,key)){return srcValue;}return objValue;}/**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */function customDefaultsMerge(objValue,srcValue,key,object,source,stack){if(isObject(objValue)&&isObject(srcValue)){// Recursively merge objects and arrays (susceptible to call stack limits).
stack.set(srcValue,objValue);baseMerge(objValue,srcValue,undefined,customDefaultsMerge,stack);stack['delete'](srcValue);}return objValue;}/**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */function customOmitClone(value){return isPlainObject(value)?undefined:value;}/**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */function equalArrays(array,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,arrLength=array.length,othLength=other.length;if(arrLength!=othLength&&!(isPartial&&othLength>arrLength)){return false;}// Check that cyclic values are equal.
var arrStacked=stack.get(array);var othStacked=stack.get(other);if(arrStacked&&othStacked){return arrStacked==other&&othStacked==array;}var index=-1,result=true,seen=bitmask&COMPARE_UNORDERED_FLAG?new SetCache():undefined;stack.set(array,other);stack.set(other,array);// Ignore non-index properties.
while(++index<arrLength){var arrValue=array[index],othValue=other[index];if(customizer){var compared=isPartial?customizer(othValue,arrValue,index,other,array,stack):customizer(arrValue,othValue,index,array,other,stack);}if(compared!==undefined){if(compared){continue;}result=false;break;}// Recursively compare arrays (susceptible to call stack limits).
if(seen){if(!arraySome(other,function(othValue,othIndex){if(!cacheHas(seen,othIndex)&&(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){return seen.push(othIndex);}})){result=false;break;}}else if(!(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){result=false;break;}}stack['delete'](array);stack['delete'](other);return result;}/**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function equalByTag(object,other,tag,bitmask,customizer,equalFunc,stack){switch(tag){case dataViewTag:if(object.byteLength!=other.byteLength||object.byteOffset!=other.byteOffset){return false;}object=object.buffer;other=other.buffer;case arrayBufferTag:if(object.byteLength!=other.byteLength||!equalFunc(new Uint8Array(object),new Uint8Array(other))){return false;}return true;case boolTag:case dateTag:case numberTag:// Coerce booleans to `1` or `0` and dates to milliseconds.
// Invalid dates are coerced to `NaN`.
return eq(+object,+other);case errorTag:return object.name==other.name&&object.message==other.message;case regexpTag:case stringTag:// Coerce regexes to strings and treat strings, primitives and objects,
// as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
// for more details.
return object==other+'';case mapTag:var convert=mapToArray;case setTag:var isPartial=bitmask&COMPARE_PARTIAL_FLAG;convert||(convert=setToArray);if(object.size!=other.size&&!isPartial){return false;}// Assume cyclic values are equal.
var stacked=stack.get(object);if(stacked){return stacked==other;}bitmask|=COMPARE_UNORDERED_FLAG;// Recursively compare objects (susceptible to call stack limits).
stack.set(object,other);var result=equalArrays(convert(object),convert(other),bitmask,customizer,equalFunc,stack);stack['delete'](object);return result;case symbolTag:if(symbolValueOf){return symbolValueOf.call(object)==symbolValueOf.call(other);}}return false;}/**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function equalObjects(object,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,objProps=getAllKeys(object),objLength=objProps.length,othProps=getAllKeys(other),othLength=othProps.length;if(objLength!=othLength&&!isPartial){return false;}var index=objLength;while(index--){var key=objProps[index];if(!(isPartial?key in other:hasOwnProperty.call(other,key))){return false;}}// Check that cyclic values are equal.
var objStacked=stack.get(object);var othStacked=stack.get(other);if(objStacked&&othStacked){return objStacked==other&&othStacked==object;}var result=true;stack.set(object,other);stack.set(other,object);var skipCtor=isPartial;while(++index<objLength){key=objProps[index];var objValue=object[key],othValue=other[key];if(customizer){var compared=isPartial?customizer(othValue,objValue,key,other,object,stack):customizer(objValue,othValue,key,object,other,stack);}// Recursively compare objects (susceptible to call stack limits).
if(!(compared===undefined?objValue===othValue||equalFunc(objValue,othValue,bitmask,customizer,stack):compared)){result=false;break;}skipCtor||(skipCtor=key=='constructor');}if(result&&!skipCtor){var objCtor=object.constructor,othCtor=other.constructor;// Non `Object` object instances with different constructors are not equal.
if(objCtor!=othCtor&&'constructor'in object&&'constructor'in other&&!(typeof objCtor=='function'&&objCtor instanceof objCtor&&typeof othCtor=='function'&&othCtor instanceof othCtor)){result=false;}}stack['delete'](object);stack['delete'](other);return result;}/**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */function flatRest(func){return setToString(overRest(func,undefined,flatten),func+'');}/**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */function getAllKeys(object){return baseGetAllKeys(object,keys,getSymbols);}/**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */function getAllKeysIn(object){return baseGetAllKeys(object,keysIn,getSymbolsIn);}/**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */var getData=!metaMap?noop:function(func){return metaMap.get(func);};/**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */function getFuncName(func){var result=func.name+'',array=realNames[result],length=hasOwnProperty.call(realNames,result)?array.length:0;while(length--){var data=array[length],otherFunc=data.func;if(otherFunc==null||otherFunc==func){return data.name;}}return result;}/**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */function getHolder(func){var object=hasOwnProperty.call(lodash,'placeholder')?lodash:func;return object.placeholder;}/**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */function getIteratee(){var result=lodash.iteratee||iteratee;result=result===iteratee?baseIteratee:result;return arguments.length?result(arguments[0],arguments[1]):result;}/**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */function getMapData(map,key){var data=map.__data__;return isKeyable(key)?data[typeof key=='string'?'string':'hash']:data.map;}/**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */function getMatchData(object){var result=keys(object),length=result.length;while(length--){var key=result[length],value=object[key];result[length]=[key,value,isStrictComparable(value)];}return result;}/**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */function getNative(object,key){var value=getValue(object,key);return baseIsNative(value)?value:undefined;}/**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */function getRawTag(value){var isOwn=hasOwnProperty.call(value,symToStringTag),tag=value[symToStringTag];try{value[symToStringTag]=undefined;var unmasked=true;}catch(e){}var result=nativeObjectToString.call(value);if(unmasked){if(isOwn){value[symToStringTag]=tag;}else{delete value[symToStringTag];}}return result;}/**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */var getSymbols=!nativeGetSymbols?stubArray:function(object){if(object==null){return[];}object=Object(object);return arrayFilter(nativeGetSymbols(object),function(symbol){return propertyIsEnumerable.call(object,symbol);});};/**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */var getSymbolsIn=!nativeGetSymbols?stubArray:function(object){var result=[];while(object){arrayPush(result,getSymbols(object));object=getPrototype(object);}return result;};/**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */var getTag=baseGetTag;// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if(DataView&&getTag(new DataView(new ArrayBuffer(1)))!=dataViewTag||Map&&getTag(new Map())!=mapTag||Promise&&getTag(Promise.resolve())!=promiseTag||Set&&getTag(new Set())!=setTag||WeakMap&&getTag(new WeakMap())!=weakMapTag){getTag=function(value){var result=baseGetTag(value),Ctor=result==objectTag?value.constructor:undefined,ctorString=Ctor?toSource(Ctor):'';if(ctorString){switch(ctorString){case dataViewCtorString:return dataViewTag;case mapCtorString:return mapTag;case promiseCtorString:return promiseTag;case setCtorString:return setTag;case weakMapCtorString:return weakMapTag;}}return result;};}/**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */function getView(start,end,transforms){var index=-1,length=transforms.length;while(++index<length){var data=transforms[index],size=data.size;switch(data.type){case'drop':start+=size;break;case'dropRight':end-=size;break;case'take':end=nativeMin(end,start+size);break;case'takeRight':start=nativeMax(start,end-size);break;}}return{'start':start,'end':end};}/**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */function getWrapDetails(source){var match=source.match(reWrapDetails);return match?match[1].split(reSplitDetails):[];}/**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */function hasPath(object,path,hasFunc){path=castPath(path,object);var index=-1,length=path.length,result=false;while(++index<length){var key=toKey(path[index]);if(!(result=object!=null&&hasFunc(object,key))){break;}object=object[key];}if(result||++index!=length){return result;}length=object==null?0:object.length;return!!length&&isLength(length)&&isIndex(key,length)&&(isArray(object)||isArguments(object));}/**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */function initCloneArray(array){var length=array.length,result=new array.constructor(length);// Add properties assigned by `RegExp#exec`.
if(length&&typeof array[0]=='string'&&hasOwnProperty.call(array,'index')){result.index=array.index;result.input=array.input;}return result;}/**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */function initCloneObject(object){return typeof object.constructor=='function'&&!isPrototype(object)?baseCreate(getPrototype(object)):{};}/**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */function initCloneByTag(object,tag,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return cloneArrayBuffer(object);case boolTag:case dateTag:return new Ctor(+object);case dataViewTag:return cloneDataView(object,isDeep);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:return cloneTypedArray(object,isDeep);case mapTag:return new Ctor();case numberTag:case stringTag:return new Ctor(object);case regexpTag:return cloneRegExp(object);case setTag:return new Ctor();case symbolTag:return cloneSymbol(object);}}/**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */function insertWrapDetails(source,details){var length=details.length;if(!length){return source;}var lastIndex=length-1;details[lastIndex]=(length>1?'& ':'')+details[lastIndex];details=details.join(length>2?', ':' ');return source.replace(reWrapComment,'{\n/* [wrapped with '+details+'] */\n');}/**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */function isFlattenable(value){return isArray(value)||isArguments(value)||!!(spreadableSymbol&&value&&value[spreadableSymbol]);}/**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */function isIndex(value,length){var type=typeof value;length=length==null?MAX_SAFE_INTEGER:length;return!!length&&(type=='number'||type!='symbol'&&reIsUint.test(value))&&value>-1&&value%1==0&&value<length;}/**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */function isIterateeCall(value,index,object){if(!isObject(object)){return false;}var type=typeof index;if(type=='number'?isArrayLike(object)&&isIndex(index,object.length):type=='string'&&index in object){return eq(object[index],value);}return false;}/**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */function isKey(value,object){if(isArray(value)){return false;}var type=typeof value;if(type=='number'||type=='symbol'||type=='boolean'||value==null||isSymbol(value)){return true;}return reIsPlainProp.test(value)||!reIsDeepProp.test(value)||object!=null&&value in Object(object);}/**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */function isKeyable(value){var type=typeof value;return type=='string'||type=='number'||type=='symbol'||type=='boolean'?value!=='__proto__':value===null;}/**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */function isLaziable(func){var funcName=getFuncName(func),other=lodash[funcName];if(typeof other!='function'||!(funcName in LazyWrapper.prototype)){return false;}if(func===other){return true;}var data=getData(other);return!!data&&func===data[0];}/**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */function isMasked(func){return!!maskSrcKey&&maskSrcKey in func;}/**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */var isMaskable=coreJsData?isFunction:stubFalse;/**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */function isPrototype(value){var Ctor=value&&value.constructor,proto=typeof Ctor=='function'&&Ctor.prototype||objectProto;return value===proto;}/**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */function isStrictComparable(value){return value===value&&!isObject(value);}/**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */function matchesStrictComparable(key,srcValue){return function(object){if(object==null){return false;}return object[key]===srcValue&&(srcValue!==undefined||key in Object(object));};}/**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */function memoizeCapped(func){var result=memoize(func,function(key){if(cache.size===MAX_MEMOIZE_SIZE){cache.clear();}return key;});var cache=result.cache;return result;}/**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */function mergeData(data,source){var bitmask=data[1],srcBitmask=source[1],newBitmask=bitmask|srcBitmask,isCommon=newBitmask<(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG|WRAP_ARY_FLAG);var isCombo=srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_CURRY_FLAG||srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_REARG_FLAG&&data[7].length<=source[8]||srcBitmask==(WRAP_ARY_FLAG|WRAP_REARG_FLAG)&&source[7].length<=source[8]&&bitmask==WRAP_CURRY_FLAG;// Exit early if metadata can't be merged.
if(!(isCommon||isCombo)){return data;}// Use source `thisArg` if available.
if(srcBitmask&WRAP_BIND_FLAG){data[2]=source[2];// Set when currying a bound function.
newBitmask|=bitmask&WRAP_BIND_FLAG?0:WRAP_CURRY_BOUND_FLAG;}// Compose partial arguments.
var value=source[3];if(value){var partials=data[3];data[3]=partials?composeArgs(partials,value,source[4]):value;data[4]=partials?replaceHolders(data[3],PLACEHOLDER):source[4];}// Compose partial right arguments.
value=source[5];if(value){partials=data[5];data[5]=partials?composeArgsRight(partials,value,source[6]):value;data[6]=partials?replaceHolders(data[5],PLACEHOLDER):source[6];}// Use source `argPos` if available.
value=source[7];if(value){data[7]=value;}// Use source `ary` if it's smaller.
if(srcBitmask&WRAP_ARY_FLAG){data[8]=data[8]==null?source[8]:nativeMin(data[8],source[8]);}// Use source `arity` if one is not provided.
if(data[9]==null){data[9]=source[9];}// Use source `func` and merge bitmasks.
data[0]=source[0];data[1]=newBitmask;return data;}/**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function nativeKeysIn(object){var result=[];if(object!=null){for(var key in Object(object)){result.push(key);}}return result;}/**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */function objectToString(value){return nativeObjectToString.call(value);}/**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */function overRest(func,start,transform){start=nativeMax(start===undefined?func.length-1:start,0);return function(){var args=arguments,index=-1,length=nativeMax(args.length-start,0),array=Array(length);while(++index<length){array[index]=args[start+index];}index=-1;var otherArgs=Array(start+1);while(++index<start){otherArgs[index]=args[index];}otherArgs[start]=transform(array);return apply(func,this,otherArgs);};}/**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */function parent(object,path){return path.length<2?object:baseGet(object,baseSlice(path,0,-1));}/**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */function reorder(array,indexes){var arrLength=array.length,length=nativeMin(indexes.length,arrLength),oldArray=copyArray(array);while(length--){var index=indexes[length];array[length]=isIndex(index,arrLength)?oldArray[index]:undefined;}return array;}/**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */function safeGet(object,key){if(key==='constructor'&&typeof object[key]==='function'){return;}if(key=='__proto__'){return;}return object[key];}/**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */var setData=shortOut(baseSetData);/**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */var setTimeout=ctxSetTimeout||function(func,wait){return root.setTimeout(func,wait);};/**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */var setToString=shortOut(baseSetToString);/**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */function setWrapToString(wrapper,reference,bitmask){var source=reference+'';return setToString(wrapper,insertWrapDetails(source,updateWrapDetails(getWrapDetails(source),bitmask)));}/**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */function shortOut(func){var count=0,lastCalled=0;return function(){var stamp=nativeNow(),remaining=HOT_SPAN-(stamp-lastCalled);lastCalled=stamp;if(remaining>0){if(++count>=HOT_COUNT){return arguments[0];}}else{count=0;}return func.apply(undefined,arguments);};}/**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */function shuffleSelf(array,size){var index=-1,length=array.length,lastIndex=length-1;size=size===undefined?length:size;while(++index<size){var rand=baseRandom(index,lastIndex),value=array[rand];array[rand]=array[index];array[index]=value;}array.length=size;return array;}/**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */var stringToPath=memoizeCapped(function(string){var result=[];if(string.charCodeAt(0)===46/* . */){result.push('');}string.replace(rePropName,function(match,number,quote,subString){result.push(quote?subString.replace(reEscapeChar,'$1'):number||match);});return result;});/**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */function toKey(value){if(typeof value=='string'||isSymbol(value)){return value;}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */function toSource(func){if(func!=null){try{return funcToString.call(func);}catch(e){}try{return func+'';}catch(e){}}return'';}/**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */function updateWrapDetails(details,bitmask){arrayEach(wrapFlags,function(pair){var value='_.'+pair[0];if(bitmask&pair[1]&&!arrayIncludes(details,value)){details.push(value);}});return details.sort();}/**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */function wrapperClone(wrapper){if(wrapper instanceof LazyWrapper){return wrapper.clone();}var result=new LodashWrapper(wrapper.__wrapped__,wrapper.__chain__);result.__actions__=copyArray(wrapper.__actions__);result.__index__=wrapper.__index__;result.__values__=wrapper.__values__;return result;}/*------------------------------------------------------------------------*//**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */function chunk(array,size,guard){if(guard?isIterateeCall(array,size,guard):size===undefined){size=1;}else{size=nativeMax(toInteger(size),0);}var length=array==null?0:array.length;if(!length||size<1){return[];}var index=0,resIndex=0,result=Array(nativeCeil(length/size));while(index<length){result[resIndex++]=baseSlice(array,index,index+=size);}return result;}/**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */function compact(array){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value){result[resIndex++]=value;}}return result;}/**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */function concat(){var length=arguments.length;if(!length){return[];}var args=Array(length-1),array=arguments[0],index=length;while(index--){args[index-1]=arguments[index];}return arrayPush(isArray(array)?copyArray(array):[array],baseFlatten(args,1));}/**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */var difference=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true)):[];});/**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */var differenceBy=baseRest(function(array,values){var iteratee=last(values);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),getIteratee(iteratee,2)):[];});/**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */var differenceWith=baseRest(function(array,values){var comparator=last(values);if(isArrayLikeObject(comparator)){comparator=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),undefined,comparator):[];});/**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */function drop(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,n<0?0:n,length);}/**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */function dropRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,0,n<0?0:n);}/**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */function dropRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true,true):[];}/**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */function dropWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true):[];}/**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */function fill(array,value,start,end){var length=array==null?0:array.length;if(!length){return[];}if(start&&typeof start!='number'&&isIterateeCall(array,value,start)){start=0;end=length;}return baseFill(array,value,start,end);}/**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */function findIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseFindIndex(array,getIteratee(predicate,3),index);}/**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */function findLastIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length-1;if(fromIndex!==undefined){index=toInteger(fromIndex);index=fromIndex<0?nativeMax(length+index,0):nativeMin(index,length-1);}return baseFindIndex(array,getIteratee(predicate,3),index,true);}/**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */function flatten(array){var length=array==null?0:array.length;return length?baseFlatten(array,1):[];}/**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */function flattenDeep(array){var length=array==null?0:array.length;return length?baseFlatten(array,INFINITY):[];}/**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */function flattenDepth(array,depth){var length=array==null?0:array.length;if(!length){return[];}depth=depth===undefined?1:toInteger(depth);return baseFlatten(array,depth);}/**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */function fromPairs(pairs){var index=-1,length=pairs==null?0:pairs.length,result={};while(++index<length){var pair=pairs[index];result[pair[0]]=pair[1];}return result;}/**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */function head(array){return array&&array.length?array[0]:undefined;}/**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */function indexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseIndexOf(array,value,index);}/**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */function initial(array){var length=array==null?0:array.length;return length?baseSlice(array,0,-1):[];}/**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */var intersection=baseRest(function(arrays){var mapped=arrayMap(arrays,castArrayLikeObject);return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped):[];});/**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */var intersectionBy=baseRest(function(arrays){var iteratee=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);if(iteratee===last(mapped)){iteratee=undefined;}else{mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,getIteratee(iteratee,2)):[];});/**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */var intersectionWith=baseRest(function(arrays){var comparator=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);comparator=typeof comparator=='function'?comparator:undefined;if(comparator){mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,undefined,comparator):[];});/**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */function join(array,separator){return array==null?'':nativeJoin.call(array,separator);}/**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */function last(array){var length=array==null?0:array.length;return length?array[length-1]:undefined;}/**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */function lastIndexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length;if(fromIndex!==undefined){index=toInteger(fromIndex);index=index<0?nativeMax(length+index,0):nativeMin(index,length-1);}return value===value?strictLastIndexOf(array,value,index):baseFindIndex(array,baseIsNaN,index,true);}/**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */function nth(array,n){return array&&array.length?baseNth(array,toInteger(n)):undefined;}/**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */var pull=baseRest(pullAll);/**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */function pullAll(array,values){return array&&array.length&&values&&values.length?basePullAll(array,values):array;}/**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */function pullAllBy(array,values,iteratee){return array&&array.length&&values&&values.length?basePullAll(array,values,getIteratee(iteratee,2)):array;}/**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */function pullAllWith(array,values,comparator){return array&&array.length&&values&&values.length?basePullAll(array,values,undefined,comparator):array;}/**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */var pullAt=flatRest(function(array,indexes){var length=array==null?0:array.length,result=baseAt(array,indexes);basePullAt(array,arrayMap(indexes,function(index){return isIndex(index,length)?+index:index;}).sort(compareAscending));return result;});/**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */function remove(array,predicate){var result=[];if(!(array&&array.length)){return result;}var index=-1,indexes=[],length=array.length;predicate=getIteratee(predicate,3);while(++index<length){var value=array[index];if(predicate(value,index,array)){result.push(value);indexes.push(index);}}basePullAt(array,indexes);return result;}/**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */function reverse(array){return array==null?array:nativeReverse.call(array);}/**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */function slice(array,start,end){var length=array==null?0:array.length;if(!length){return[];}if(end&&typeof end!='number'&&isIterateeCall(array,start,end)){start=0;end=length;}else{start=start==null?0:toInteger(start);end=end===undefined?length:toInteger(end);}return baseSlice(array,start,end);}/**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */function sortedIndex(array,value){return baseSortedIndex(array,value);}/**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */function sortedIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2));}/**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */function sortedIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value);if(index<length&&eq(array[index],value)){return index;}}return-1;}/**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */function sortedLastIndex(array,value){return baseSortedIndex(array,value,true);}/**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */function sortedLastIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2),true);}/**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */function sortedLastIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value,true)-1;if(eq(array[index],value)){return index;}}return-1;}/**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */function sortedUniq(array){return array&&array.length?baseSortedUniq(array):[];}/**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */function sortedUniqBy(array,iteratee){return array&&array.length?baseSortedUniq(array,getIteratee(iteratee,2)):[];}/**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */function tail(array){var length=array==null?0:array.length;return length?baseSlice(array,1,length):[];}/**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */function take(array,n,guard){if(!(array&&array.length)){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,0,n<0?0:n);}/**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */function takeRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,n<0?0:n,length);}/**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */function takeRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),false,true):[];}/**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */function takeWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3)):[];}/**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */var union=baseRest(function(arrays){return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true));});/**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */var unionBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),getIteratee(iteratee,2));});/**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */var unionWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined;return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),undefined,comparator);});/**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */function uniq(array){return array&&array.length?baseUniq(array):[];}/**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */function uniqBy(array,iteratee){return array&&array.length?baseUniq(array,getIteratee(iteratee,2)):[];}/**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */function uniqWith(array,comparator){comparator=typeof comparator=='function'?comparator:undefined;return array&&array.length?baseUniq(array,undefined,comparator):[];}/**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */function unzip(array){if(!(array&&array.length)){return[];}var length=0;array=arrayFilter(array,function(group){if(isArrayLikeObject(group)){length=nativeMax(group.length,length);return true;}});return baseTimes(length,function(index){return arrayMap(array,baseProperty(index));});}/**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */function unzipWith(array,iteratee){if(!(array&&array.length)){return[];}var result=unzip(array);if(iteratee==null){return result;}return arrayMap(result,function(group){return apply(iteratee,undefined,group);});}/**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */var without=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,values):[];});/**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */var xor=baseRest(function(arrays){return baseXor(arrayFilter(arrays,isArrayLikeObject));});/**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */var xorBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseXor(arrayFilter(arrays,isArrayLikeObject),getIteratee(iteratee,2));});/**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */var xorWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined;return baseXor(arrayFilter(arrays,isArrayLikeObject),undefined,comparator);});/**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */var zip=baseRest(unzip);/**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */function zipObject(props,values){return baseZipObject(props||[],values||[],assignValue);}/**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */function zipObjectDeep(props,values){return baseZipObject(props||[],values||[],baseSet);}/**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */var zipWith=baseRest(function(arrays){var length=arrays.length,iteratee=length>1?arrays[length-1]:undefined;iteratee=typeof iteratee=='function'?(arrays.pop(),iteratee):undefined;return unzipWith(arrays,iteratee);});/*------------------------------------------------------------------------*//**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */function chain(value){var result=lodash(value);result.__chain__=true;return result;}/**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */function tap(value,interceptor){interceptor(value);return value;}/**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */function thru(value,interceptor){return interceptor(value);}/**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */var wrapperAt=flatRest(function(paths){var length=paths.length,start=length?paths[0]:0,value=this.__wrapped__,interceptor=function(object){return baseAt(object,paths);};if(length>1||this.__actions__.length||!(value instanceof LazyWrapper)||!isIndex(start)){return this.thru(interceptor);}value=value.slice(start,+start+(length?1:0));value.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(value,this.__chain__).thru(function(array){if(length&&!array.length){array.push(undefined);}return array;});});/**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */function wrapperChain(){return chain(this);}/**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */function wrapperCommit(){return new LodashWrapper(this.value(),this.__chain__);}/**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */function wrapperNext(){if(this.__values__===undefined){this.__values__=toArray(this.value());}var done=this.__index__>=this.__values__.length,value=done?undefined:this.__values__[this.__index__++];return{'done':done,'value':value};}/**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */function wrapperToIterator(){return this;}/**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */function wrapperPlant(value){var result,parent=this;while(parent instanceof baseLodash){var clone=wrapperClone(parent);clone.__index__=0;clone.__values__=undefined;if(result){previous.__wrapped__=clone;}else{result=clone;}var previous=clone;parent=parent.__wrapped__;}previous.__wrapped__=value;return result;}/**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */function wrapperReverse(){var value=this.__wrapped__;if(value instanceof LazyWrapper){var wrapped=value;if(this.__actions__.length){wrapped=new LazyWrapper(this);}wrapped=wrapped.reverse();wrapped.__actions__.push({'func':thru,'args':[reverse],'thisArg':undefined});return new LodashWrapper(wrapped,this.__chain__);}return this.thru(reverse);}/**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */function wrapperValue(){return baseWrapperValue(this.__wrapped__,this.__actions__);}/*------------------------------------------------------------------------*//**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */var countBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){++result[key];}else{baseAssignValue(result,key,1);}});/**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */function every(collection,predicate,guard){var func=isArray(collection)?arrayEvery:baseEvery;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */function filter(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,getIteratee(predicate,3));}/**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */var find=createFind(findIndex);/**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */var findLast=createFind(findLastIndex);/**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */function flatMap(collection,iteratee){return baseFlatten(map(collection,iteratee),1);}/**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */function flatMapDeep(collection,iteratee){return baseFlatten(map(collection,iteratee),INFINITY);}/**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */function flatMapDepth(collection,iteratee,depth){depth=depth===undefined?1:toInteger(depth);return baseFlatten(map(collection,iteratee),depth);}/**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */function forEach(collection,iteratee){var func=isArray(collection)?arrayEach:baseEach;return func(collection,getIteratee(iteratee,3));}/**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */function forEachRight(collection,iteratee){var func=isArray(collection)?arrayEachRight:baseEachRight;return func(collection,getIteratee(iteratee,3));}/**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */var groupBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){result[key].push(value);}else{baseAssignValue(result,key,[value]);}});/**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */function includes(collection,value,fromIndex,guard){collection=isArrayLike(collection)?collection:values(collection);fromIndex=fromIndex&&!guard?toInteger(fromIndex):0;var length=collection.length;if(fromIndex<0){fromIndex=nativeMax(length+fromIndex,0);}return isString(collection)?fromIndex<=length&&collection.indexOf(value,fromIndex)>-1:!!length&&baseIndexOf(collection,value,fromIndex)>-1;}/**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */var invokeMap=baseRest(function(collection,path,args){var index=-1,isFunc=typeof path=='function',result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value){result[++index]=isFunc?apply(path,value,args):baseInvoke(value,path,args);});return result;});/**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */var keyBy=createAggregator(function(result,value,key){baseAssignValue(result,key,value);});/**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */function map(collection,iteratee){var func=isArray(collection)?arrayMap:baseMap;return func(collection,getIteratee(iteratee,3));}/**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */function orderBy(collection,iteratees,orders,guard){if(collection==null){return[];}if(!isArray(iteratees)){iteratees=iteratees==null?[]:[iteratees];}orders=guard?undefined:orders;if(!isArray(orders)){orders=orders==null?[]:[orders];}return baseOrderBy(collection,iteratees,orders);}/**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */var partition=createAggregator(function(result,value,key){result[key?0:1].push(value);},function(){return[[],[]];});/**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */function reduce(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduce:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEach);}/**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */function reduceRight(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduceRight:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEachRight);}/**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */function reject(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,negate(getIteratee(predicate,3)));}/**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */function sample(collection){var func=isArray(collection)?arraySample:baseSample;return func(collection);}/**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */function sampleSize(collection,n,guard){if(guard?isIterateeCall(collection,n,guard):n===undefined){n=1;}else{n=toInteger(n);}var func=isArray(collection)?arraySampleSize:baseSampleSize;return func(collection,n);}/**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */function shuffle(collection){var func=isArray(collection)?arrayShuffle:baseShuffle;return func(collection);}/**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */function size(collection){if(collection==null){return 0;}if(isArrayLike(collection)){return isString(collection)?stringSize(collection):collection.length;}var tag=getTag(collection);if(tag==mapTag||tag==setTag){return collection.size;}return baseKeys(collection).length;}/**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */function some(collection,predicate,guard){var func=isArray(collection)?arraySome:baseSome;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */var sortBy=baseRest(function(collection,iteratees){if(collection==null){return[];}var length=iteratees.length;if(length>1&&isIterateeCall(collection,iteratees[0],iteratees[1])){iteratees=[];}else if(length>2&&isIterateeCall(iteratees[0],iteratees[1],iteratees[2])){iteratees=[iteratees[0]];}return baseOrderBy(collection,baseFlatten(iteratees,1),[]);});/*------------------------------------------------------------------------*//**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */var now=ctxNow||function(){return root.Date.now();};/*------------------------------------------------------------------------*//**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */function after(n,func){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n<1){return func.apply(this,arguments);}};}/**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */function ary(func,n,guard){n=guard?undefined:n;n=func&&n==null?func.length:n;return createWrap(func,WRAP_ARY_FLAG,undefined,undefined,undefined,undefined,n);}/**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */function before(n,func){var result;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n>0){result=func.apply(this,arguments);}if(n<=1){func=undefined;}return result;};}/**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */var bind=baseRest(function(func,thisArg,partials){var bitmask=WRAP_BIND_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bind));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(func,bitmask,thisArg,partials,holders);});/**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */var bindKey=baseRest(function(object,key,partials){var bitmask=WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bindKey));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(key,bitmask,object,partials,holders);});/**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */function curry(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curry.placeholder;return result;}/**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */function curryRight(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_RIGHT_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curryRight.placeholder;return result;}/**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */function debounce(func,wait,options){var lastArgs,lastThis,maxWait,result,timerId,lastCallTime,lastInvokeTime=0,leading=false,maxing=false,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}wait=toNumber(wait)||0;if(isObject(options)){leading=!!options.leading;maxing='maxWait'in options;maxWait=maxing?nativeMax(toNumber(options.maxWait)||0,wait):maxWait;trailing='trailing'in options?!!options.trailing:trailing;}function invokeFunc(time){var args=lastArgs,thisArg=lastThis;lastArgs=lastThis=undefined;lastInvokeTime=time;result=func.apply(thisArg,args);return result;}function leadingEdge(time){// Reset any `maxWait` timer.
lastInvokeTime=time;// Start the timer for the trailing edge.
timerId=setTimeout(timerExpired,wait);// Invoke the leading edge.
return leading?invokeFunc(time):result;}function remainingWait(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime,timeWaiting=wait-timeSinceLastCall;return maxing?nativeMin(timeWaiting,maxWait-timeSinceLastInvoke):timeWaiting;}function shouldInvoke(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime;// Either this is the first call, activity has stopped and we're at the
// trailing edge, the system time has gone backwards and we're treating
// it as the trailing edge, or we've hit the `maxWait` limit.
return lastCallTime===undefined||timeSinceLastCall>=wait||timeSinceLastCall<0||maxing&&timeSinceLastInvoke>=maxWait;}function timerExpired(){var time=now();if(shouldInvoke(time)){return trailingEdge(time);}// Restart the timer.
timerId=setTimeout(timerExpired,remainingWait(time));}function trailingEdge(time){timerId=undefined;// Only invoke if we have `lastArgs` which means `func` has been
// debounced at least once.
if(trailing&&lastArgs){return invokeFunc(time);}lastArgs=lastThis=undefined;return result;}function cancel(){if(timerId!==undefined){clearTimeout(timerId);}lastInvokeTime=0;lastArgs=lastCallTime=lastThis=timerId=undefined;}function flush(){return timerId===undefined?result:trailingEdge(now());}function debounced(){var time=now(),isInvoking=shouldInvoke(time);lastArgs=arguments;lastThis=this;lastCallTime=time;if(isInvoking){if(timerId===undefined){return leadingEdge(lastCallTime);}if(maxing){// Handle invocations in a tight loop.
clearTimeout(timerId);timerId=setTimeout(timerExpired,wait);return invokeFunc(lastCallTime);}}if(timerId===undefined){timerId=setTimeout(timerExpired,wait);}return result;}debounced.cancel=cancel;debounced.flush=flush;return debounced;}/**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */var defer=baseRest(function(func,args){return baseDelay(func,1,args);});/**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */var delay=baseRest(function(func,wait,args){return baseDelay(func,toNumber(wait)||0,args);});/**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */function flip(func){return createWrap(func,WRAP_FLIP_FLAG);}/**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */function memoize(func,resolver){if(typeof func!='function'||resolver!=null&&typeof resolver!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var memoized=function(){var args=arguments,key=resolver?resolver.apply(this,args):args[0],cache=memoized.cache;if(cache.has(key)){return cache.get(key);}var result=func.apply(this,args);memoized.cache=cache.set(key,result)||cache;return result;};memoized.cache=new(memoize.Cache||MapCache)();return memoized;}// Expose `MapCache`.
memoize.Cache=MapCache;/**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */function negate(predicate){if(typeof predicate!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return function(){var args=arguments;switch(args.length){case 0:return!predicate.call(this);case 1:return!predicate.call(this,args[0]);case 2:return!predicate.call(this,args[0],args[1]);case 3:return!predicate.call(this,args[0],args[1],args[2]);}return!predicate.apply(this,args);};}/**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */function once(func){return before(2,func);}/**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */var overArgs=castRest(function(func,transforms){transforms=transforms.length==1&&isArray(transforms[0])?arrayMap(transforms[0],baseUnary(getIteratee())):arrayMap(baseFlatten(transforms,1),baseUnary(getIteratee()));var funcsLength=transforms.length;return baseRest(function(args){var index=-1,length=nativeMin(args.length,funcsLength);while(++index<length){args[index]=transforms[index].call(this,args[index]);}return apply(func,this,args);});});/**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */var partial=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partial));return createWrap(func,WRAP_PARTIAL_FLAG,undefined,partials,holders);});/**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */var partialRight=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partialRight));return createWrap(func,WRAP_PARTIAL_RIGHT_FLAG,undefined,partials,holders);});/**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */var rearg=flatRest(function(func,indexes){return createWrap(func,WRAP_REARG_FLAG,undefined,undefined,undefined,indexes);});/**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */function rest(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start===undefined?start:toInteger(start);return baseRest(func,start);}/**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */function spread(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start==null?0:nativeMax(toInteger(start),0);return baseRest(function(args){var array=args[start],otherArgs=castSlice(args,0,start);if(array){arrayPush(otherArgs,array);}return apply(func,this,otherArgs);});}/**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */function throttle(func,wait,options){var leading=true,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(isObject(options)){leading='leading'in options?!!options.leading:leading;trailing='trailing'in options?!!options.trailing:trailing;}return debounce(func,wait,{'leading':leading,'maxWait':wait,'trailing':trailing});}/**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */function unary(func){return ary(func,1);}/**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */function wrap(value,wrapper){return partial(castFunction(wrapper),value);}/*------------------------------------------------------------------------*//**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */function castArray(){if(!arguments.length){return[];}var value=arguments[0];return isArray(value)?value:[value];}/**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */function clone(value){return baseClone(value,CLONE_SYMBOLS_FLAG);}/**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */function cloneWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseClone(value,CLONE_SYMBOLS_FLAG,customizer);}/**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */function cloneDeep(value){return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG);}/**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */function cloneDeepWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG,customizer);}/**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */function conformsTo(object,source){return source==null||baseConformsTo(object,source,keys(source));}/**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */function eq(value,other){return value===other||value!==value&&other!==other;}/**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */var gt=createRelationalOperation(baseGt);/**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */var gte=createRelationalOperation(function(value,other){return value>=other;});/**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */var isArguments=baseIsArguments(function(){return arguments;}())?baseIsArguments:function(value){return isObjectLike(value)&&hasOwnProperty.call(value,'callee')&&!propertyIsEnumerable.call(value,'callee');};/**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */var isArray=Array.isArray;/**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */var isArrayBuffer=nodeIsArrayBuffer?baseUnary(nodeIsArrayBuffer):baseIsArrayBuffer;/**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */function isArrayLike(value){return value!=null&&isLength(value.length)&&!isFunction(value);}/**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */function isArrayLikeObject(value){return isObjectLike(value)&&isArrayLike(value);}/**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */function isBoolean(value){return value===true||value===false||isObjectLike(value)&&baseGetTag(value)==boolTag;}/**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */var isBuffer=nativeIsBuffer||stubFalse;/**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */var isDate=nodeIsDate?baseUnary(nodeIsDate):baseIsDate;/**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */function isElement(value){return isObjectLike(value)&&value.nodeType===1&&!isPlainObject(value);}/**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */function isEmpty(value){if(value==null){return true;}if(isArrayLike(value)&&(isArray(value)||typeof value=='string'||typeof value.splice=='function'||isBuffer(value)||isTypedArray(value)||isArguments(value))){return!value.length;}var tag=getTag(value);if(tag==mapTag||tag==setTag){return!value.size;}if(isPrototype(value)){return!baseKeys(value).length;}for(var key in value){if(hasOwnProperty.call(value,key)){return false;}}return true;}/**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */function isEqual(value,other){return baseIsEqual(value,other);}/**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */function isEqualWith(value,other,customizer){customizer=typeof customizer=='function'?customizer:undefined;var result=customizer?customizer(value,other):undefined;return result===undefined?baseIsEqual(value,other,undefined,customizer):!!result;}/**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */function isError(value){if(!isObjectLike(value)){return false;}var tag=baseGetTag(value);return tag==errorTag||tag==domExcTag||typeof value.message=='string'&&typeof value.name=='string'&&!isPlainObject(value);}/**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */function isFinite(value){return typeof value=='number'&&nativeIsFinite(value);}/**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */function isFunction(value){if(!isObject(value)){return false;}// The use of `Object#toString` avoids issues with the `typeof` operator
// in Safari 9 which returns 'object' for typed arrays and other constructors.
var tag=baseGetTag(value);return tag==funcTag||tag==genTag||tag==asyncTag||tag==proxyTag;}/**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */function isInteger(value){return typeof value=='number'&&value==toInteger(value);}/**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */function isLength(value){return typeof value=='number'&&value>-1&&value%1==0&&value<=MAX_SAFE_INTEGER;}/**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */function isObject(value){var type=typeof value;return value!=null&&(type=='object'||type=='function');}/**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */function isObjectLike(value){return value!=null&&typeof value=='object';}/**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */var isMap=nodeIsMap?baseUnary(nodeIsMap):baseIsMap;/**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */function isMatch(object,source){return object===source||baseIsMatch(object,source,getMatchData(source));}/**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */function isMatchWith(object,source,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseIsMatch(object,source,getMatchData(source),customizer);}/**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */function isNaN(value){// An `NaN` primitive is the only value that is not equal to itself.
// Perform the `toStringTag` check first to avoid errors with some
// ActiveX objects in IE.
return isNumber(value)&&value!=+value;}/**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */function isNative(value){if(isMaskable(value)){throw new Error(CORE_ERROR_TEXT);}return baseIsNative(value);}/**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */function isNull(value){return value===null;}/**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */function isNil(value){return value==null;}/**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */function isNumber(value){return typeof value=='number'||isObjectLike(value)&&baseGetTag(value)==numberTag;}/**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */function isPlainObject(value){if(!isObjectLike(value)||baseGetTag(value)!=objectTag){return false;}var proto=getPrototype(value);if(proto===null){return true;}var Ctor=hasOwnProperty.call(proto,'constructor')&&proto.constructor;return typeof Ctor=='function'&&Ctor instanceof Ctor&&funcToString.call(Ctor)==objectCtorString;}/**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */var isRegExp=nodeIsRegExp?baseUnary(nodeIsRegExp):baseIsRegExp;/**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */function isSafeInteger(value){return isInteger(value)&&value>=-MAX_SAFE_INTEGER&&value<=MAX_SAFE_INTEGER;}/**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */var isSet=nodeIsSet?baseUnary(nodeIsSet):baseIsSet;/**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */function isString(value){return typeof value=='string'||!isArray(value)&&isObjectLike(value)&&baseGetTag(value)==stringTag;}/**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */function isSymbol(value){return typeof value=='symbol'||isObjectLike(value)&&baseGetTag(value)==symbolTag;}/**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */var isTypedArray=nodeIsTypedArray?baseUnary(nodeIsTypedArray):baseIsTypedArray;/**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */function isUndefined(value){return value===undefined;}/**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */function isWeakMap(value){return isObjectLike(value)&&getTag(value)==weakMapTag;}/**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */function isWeakSet(value){return isObjectLike(value)&&baseGetTag(value)==weakSetTag;}/**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */var lt=createRelationalOperation(baseLt);/**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */var lte=createRelationalOperation(function(value,other){return value<=other;});/**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */function toArray(value){if(!value){return[];}if(isArrayLike(value)){return isString(value)?stringToArray(value):copyArray(value);}if(symIterator&&value[symIterator]){return iteratorToArray(value[symIterator]());}var tag=getTag(value),func=tag==mapTag?mapToArray:tag==setTag?setToArray:values;return func(value);}/**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */function toFinite(value){if(!value){return value===0?value:0;}value=toNumber(value);if(value===INFINITY||value===-INFINITY){var sign=value<0?-1:1;return sign*MAX_INTEGER;}return value===value?value:0;}/**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */function toInteger(value){var result=toFinite(value),remainder=result%1;return result===result?remainder?result-remainder:result:0;}/**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */function toLength(value){return value?baseClamp(toInteger(value),0,MAX_ARRAY_LENGTH):0;}/**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */function toNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}if(isObject(value)){var other=typeof value.valueOf=='function'?value.valueOf():value;value=isObject(other)?other+'':other;}if(typeof value!='string'){return value===0?value:+value;}value=baseTrim(value);var isBinary=reIsBinary.test(value);return isBinary||reIsOctal.test(value)?freeParseInt(value.slice(2),isBinary?2:8):reIsBadHex.test(value)?NAN:+value;}/**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */function toPlainObject(value){return copyObject(value,keysIn(value));}/**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */function toSafeInteger(value){return value?baseClamp(toInteger(value),-MAX_SAFE_INTEGER,MAX_SAFE_INTEGER):value===0?value:0;}/**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */function toString(value){return value==null?'':baseToString(value);}/*------------------------------------------------------------------------*//**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */var assign=createAssigner(function(object,source){if(isPrototype(source)||isArrayLike(source)){copyObject(source,keys(source),object);return;}for(var key in source){if(hasOwnProperty.call(source,key)){assignValue(object,key,source[key]);}}});/**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */var assignIn=createAssigner(function(object,source){copyObject(source,keysIn(source),object);});/**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var assignInWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keysIn(source),object,customizer);});/**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var assignWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keys(source),object,customizer);});/**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */var at=flatRest(baseAt);/**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */function create(prototype,properties){var result=baseCreate(prototype);return properties==null?result:baseAssign(result,properties);}/**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var defaults=baseRest(function(object,sources){object=Object(object);var index=-1;var length=sources.length;var guard=length>2?sources[2]:undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){length=1;}while(++index<length){var source=sources[index];var props=keysIn(source);var propsIndex=-1;var propsLength=props.length;while(++propsIndex<propsLength){var key=props[propsIndex];var value=object[key];if(value===undefined||eq(value,objectProto[key])&&!hasOwnProperty.call(object,key)){object[key]=source[key];}}}return object;});/**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */var defaultsDeep=baseRest(function(args){args.push(undefined,customDefaultsMerge);return apply(mergeWith,undefined,args);});/**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */function findKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwn);}/**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */function findLastKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwnRight);}/**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */function forIn(object,iteratee){return object==null?object:baseFor(object,getIteratee(iteratee,3),keysIn);}/**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */function forInRight(object,iteratee){return object==null?object:baseForRight(object,getIteratee(iteratee,3),keysIn);}/**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */function forOwn(object,iteratee){return object&&baseForOwn(object,getIteratee(iteratee,3));}/**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */function forOwnRight(object,iteratee){return object&&baseForOwnRight(object,getIteratee(iteratee,3));}/**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */function functions(object){return object==null?[]:baseFunctions(object,keys(object));}/**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */function functionsIn(object){return object==null?[]:baseFunctions(object,keysIn(object));}/**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */function get(object,path,defaultValue){var result=object==null?undefined:baseGet(object,path);return result===undefined?defaultValue:result;}/**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */function has(object,path){return object!=null&&hasPath(object,path,baseHas);}/**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */function hasIn(object,path){return object!=null&&hasPath(object,path,baseHasIn);}/**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */var invert=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!='function'){value=nativeObjectToString.call(value);}result[value]=key;},constant(identity));/**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */var invertBy=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!='function'){value=nativeObjectToString.call(value);}if(hasOwnProperty.call(result,value)){result[value].push(key);}else{result[value]=[key];}},getIteratee);/**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */var invoke=baseRest(baseInvoke);/**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */function keys(object){return isArrayLike(object)?arrayLikeKeys(object):baseKeys(object);}/**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */function keysIn(object){return isArrayLike(object)?arrayLikeKeys(object,true):baseKeysIn(object);}/**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */function mapKeys(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,iteratee(value,key,object),value);});return result;}/**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */function mapValues(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,key,iteratee(value,key,object));});return result;}/**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */var merge=createAssigner(function(object,source,srcIndex){baseMerge(object,source,srcIndex);});/**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */var mergeWith=createAssigner(function(object,source,srcIndex,customizer){baseMerge(object,source,srcIndex,customizer);});/**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */var omit=flatRest(function(object,paths){var result={};if(object==null){return result;}var isDeep=false;paths=arrayMap(paths,function(path){path=castPath(path,object);isDeep||(isDeep=path.length>1);return path;});copyObject(object,getAllKeysIn(object),result);if(isDeep){result=baseClone(result,CLONE_DEEP_FLAG|CLONE_FLAT_FLAG|CLONE_SYMBOLS_FLAG,customOmitClone);}var length=paths.length;while(length--){baseUnset(result,paths[length]);}return result;});/**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */function omitBy(object,predicate){return pickBy(object,negate(getIteratee(predicate)));}/**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */var pick=flatRest(function(object,paths){return object==null?{}:basePick(object,paths);});/**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */function pickBy(object,predicate){if(object==null){return{};}var props=arrayMap(getAllKeysIn(object),function(prop){return[prop];});predicate=getIteratee(predicate);return basePickBy(object,props,function(value,path){return predicate(value,path[0]);});}/**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */function result(object,path,defaultValue){path=castPath(path,object);var index=-1,length=path.length;// Ensure the loop is entered when path is empty.
if(!length){length=1;object=undefined;}while(++index<length){var value=object==null?undefined:object[toKey(path[index])];if(value===undefined){index=length;value=defaultValue;}object=isFunction(value)?value.call(object):value;}return object;}/**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */function set(object,path,value){return object==null?object:baseSet(object,path,value);}/**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */function setWith(object,path,value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseSet(object,path,value,customizer);}/**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */var toPairs=createToPairs(keys);/**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */var toPairsIn=createToPairs(keysIn);/**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */function transform(object,iteratee,accumulator){var isArr=isArray(object),isArrLike=isArr||isBuffer(object)||isTypedArray(object);iteratee=getIteratee(iteratee,4);if(accumulator==null){var Ctor=object&&object.constructor;if(isArrLike){accumulator=isArr?new Ctor():[];}else if(isObject(object)){accumulator=isFunction(Ctor)?baseCreate(getPrototype(object)):{};}else{accumulator={};}}(isArrLike?arrayEach:baseForOwn)(object,function(value,index,object){return iteratee(accumulator,value,index,object);});return accumulator;}/**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */function unset(object,path){return object==null?true:baseUnset(object,path);}/**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */function update(object,path,updater){return object==null?object:baseUpdate(object,path,castFunction(updater));}/**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */function updateWith(object,path,updater,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseUpdate(object,path,castFunction(updater),customizer);}/**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */function values(object){return object==null?[]:baseValues(object,keys(object));}/**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */function valuesIn(object){return object==null?[]:baseValues(object,keysIn(object));}/*------------------------------------------------------------------------*//**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */function clamp(number,lower,upper){if(upper===undefined){upper=lower;lower=undefined;}if(upper!==undefined){upper=toNumber(upper);upper=upper===upper?upper:0;}if(lower!==undefined){lower=toNumber(lower);lower=lower===lower?lower:0;}return baseClamp(toNumber(number),lower,upper);}/**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */function inRange(number,start,end){start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}number=toNumber(number);return baseInRange(number,start,end);}/**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */function random(lower,upper,floating){if(floating&&typeof floating!='boolean'&&isIterateeCall(lower,upper,floating)){upper=floating=undefined;}if(floating===undefined){if(typeof upper=='boolean'){floating=upper;upper=undefined;}else if(typeof lower=='boolean'){floating=lower;lower=undefined;}}if(lower===undefined&&upper===undefined){lower=0;upper=1;}else{lower=toFinite(lower);if(upper===undefined){upper=lower;lower=0;}else{upper=toFinite(upper);}}if(lower>upper){var temp=lower;lower=upper;upper=temp;}if(floating||lower%1||upper%1){var rand=nativeRandom();return nativeMin(lower+rand*(upper-lower+freeParseFloat('1e-'+((rand+'').length-1))),upper);}return baseRandom(lower,upper);}/*------------------------------------------------------------------------*//**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */var camelCase=createCompounder(function(result,word,index){word=word.toLowerCase();return result+(index?capitalize(word):word);});/**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */function capitalize(string){return upperFirst(toString(string).toLowerCase());}/**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */function deburr(string){string=toString(string);return string&&string.replace(reLatin,deburrLetter).replace(reComboMark,'');}/**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */function endsWith(string,target,position){string=toString(string);target=baseToString(target);var length=string.length;position=position===undefined?length:baseClamp(toInteger(position),0,length);var end=position;position-=target.length;return position>=0&&string.slice(position,end)==target;}/**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */function escape(string){string=toString(string);return string&&reHasUnescapedHtml.test(string)?string.replace(reUnescapedHtml,escapeHtmlChar):string;}/**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */function escapeRegExp(string){string=toString(string);return string&&reHasRegExpChar.test(string)?string.replace(reRegExpChar,'\\$&'):string;}/**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */var kebabCase=createCompounder(function(result,word,index){return result+(index?'-':'')+word.toLowerCase();});/**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */var lowerCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toLowerCase();});/**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */var lowerFirst=createCaseFirst('toLowerCase');/**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */function pad(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;if(!length||strLength>=length){return string;}var mid=(length-strLength)/2;return createPadding(nativeFloor(mid),chars)+string+createPadding(nativeCeil(mid),chars);}/**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */function padEnd(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?string+createPadding(length-strLength,chars):string;}/**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */function padStart(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?createPadding(length-strLength,chars)+string:string;}/**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */function parseInt(string,radix,guard){if(guard||radix==null){radix=0;}else if(radix){radix=+radix;}return nativeParseInt(toString(string).replace(reTrimStart,''),radix||0);}/**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */function repeat(string,n,guard){if(guard?isIterateeCall(string,n,guard):n===undefined){n=1;}else{n=toInteger(n);}return baseRepeat(toString(string),n);}/**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */function replace(){var args=arguments,string=toString(args[0]);return args.length<3?string:string.replace(args[1],args[2]);}/**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */var snakeCase=createCompounder(function(result,word,index){return result+(index?'_':'')+word.toLowerCase();});/**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */function split(string,separator,limit){if(limit&&typeof limit!='number'&&isIterateeCall(string,separator,limit)){separator=limit=undefined;}limit=limit===undefined?MAX_ARRAY_LENGTH:limit>>>0;if(!limit){return[];}string=toString(string);if(string&&(typeof separator=='string'||separator!=null&&!isRegExp(separator))){separator=baseToString(separator);if(!separator&&hasUnicode(string)){return castSlice(stringToArray(string),0,limit);}}return string.split(separator,limit);}/**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */var startCase=createCompounder(function(result,word,index){return result+(index?' ':'')+upperFirst(word);});/**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */function startsWith(string,target,position){string=toString(string);position=position==null?0:baseClamp(toInteger(position),0,string.length);target=baseToString(target);return string.slice(position,position+target.length)==target;}/**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */function template(string,options,guard){// Based on John Resig's `tmpl` implementation
// (http://ejohn.org/blog/javascript-micro-templating/)
// and Laura Doktorova's doT.js (https://github.com/olado/doT).
var settings=lodash.templateSettings;if(guard&&isIterateeCall(string,options,guard)){options=undefined;}string=toString(string);options=assignInWith({},options,settings,customDefaultsAssignIn);var imports=assignInWith({},options.imports,settings.imports,customDefaultsAssignIn),importsKeys=keys(imports),importsValues=baseValues(imports,importsKeys);var isEscaping,isEvaluating,index=0,interpolate=options.interpolate||reNoMatch,source="__p += '";// Compile the regexp to match each delimiter.
var reDelimiters=RegExp((options.escape||reNoMatch).source+'|'+interpolate.source+'|'+(interpolate===reInterpolate?reEsTemplate:reNoMatch).source+'|'+(options.evaluate||reNoMatch).source+'|$','g');// Use a sourceURL for easier debugging.
// The sourceURL gets injected into the source that's eval-ed, so be careful
// to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
// and escape the comment, thus injecting code that gets evaled.
var sourceURL='//# sourceURL='+(hasOwnProperty.call(options,'sourceURL')?(options.sourceURL+'').replace(/\s/g,' '):'lodash.templateSources['+ ++templateCounter+']')+'\n';string.replace(reDelimiters,function(match,escapeValue,interpolateValue,esTemplateValue,evaluateValue,offset){interpolateValue||(interpolateValue=esTemplateValue);// Escape characters that can't be included in string literals.
source+=string.slice(index,offset).replace(reUnescapedString,escapeStringChar);// Replace delimiters with snippets.
if(escapeValue){isEscaping=true;source+="' +\n__e("+escapeValue+") +\n'";}if(evaluateValue){isEvaluating=true;source+="';\n"+evaluateValue+";\n__p += '";}if(interpolateValue){source+="' +\n((__t = ("+interpolateValue+")) == null ? '' : __t) +\n'";}index=offset+match.length;// The JS engine embedded in Adobe products needs `match` returned in
// order to produce the correct `offset` value.
return match;});source+="';\n";// If `variable` is not specified wrap a with-statement around the generated
// code to add the data object to the top of the scope chain.
var variable=hasOwnProperty.call(options,'variable')&&options.variable;if(!variable){source='with (obj) {\n'+source+'\n}\n';}// Throw an error if a forbidden character was found in `variable`, to prevent
// potential command injection attacks.
else if(reForbiddenIdentifierChars.test(variable)){throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);}// Cleanup code by stripping empty strings.
source=(isEvaluating?source.replace(reEmptyStringLeading,''):source).replace(reEmptyStringMiddle,'$1').replace(reEmptyStringTrailing,'$1;');// Frame code as the function body.
source='function('+(variable||'obj')+') {\n'+(variable?'':'obj || (obj = {});\n')+"var __t, __p = ''"+(isEscaping?', __e = _.escape':'')+(isEvaluating?', __j = Array.prototype.join;\n'+"function print() { __p += __j.call(arguments, '') }\n":';\n')+source+'return __p\n}';var result=attempt(function(){return Function(importsKeys,sourceURL+'return '+source).apply(undefined,importsValues);});// Provide the compiled function's source by its `toString` method or
// the `source` property as a convenience for inlining compiled templates.
result.source=source;if(isError(result)){throw result;}return result;}/**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */function toLower(value){return toString(value).toLowerCase();}/**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */function toUpper(value){return toString(value).toUpperCase();}/**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */function trim(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return baseTrim(string);}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),chrSymbols=stringToArray(chars),start=charsStartIndex(strSymbols,chrSymbols),end=charsEndIndex(strSymbols,chrSymbols)+1;return castSlice(strSymbols,start,end).join('');}/**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */function trimEnd(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.slice(0,trimmedEndIndex(string)+1);}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),end=charsEndIndex(strSymbols,stringToArray(chars))+1;return castSlice(strSymbols,0,end).join('');}/**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */function trimStart(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrimStart,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),start=charsStartIndex(strSymbols,stringToArray(chars));return castSlice(strSymbols,start).join('');}/**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */function truncate(string,options){var length=DEFAULT_TRUNC_LENGTH,omission=DEFAULT_TRUNC_OMISSION;if(isObject(options)){var separator='separator'in options?options.separator:separator;length='length'in options?toInteger(options.length):length;omission='omission'in options?baseToString(options.omission):omission;}string=toString(string);var strLength=string.length;if(hasUnicode(string)){var strSymbols=stringToArray(string);strLength=strSymbols.length;}if(length>=strLength){return string;}var end=length-stringSize(omission);if(end<1){return omission;}var result=strSymbols?castSlice(strSymbols,0,end).join(''):string.slice(0,end);if(separator===undefined){return result+omission;}if(strSymbols){end+=result.length-end;}if(isRegExp(separator)){if(string.slice(end).search(separator)){var match,substring=result;if(!separator.global){separator=RegExp(separator.source,toString(reFlags.exec(separator))+'g');}separator.lastIndex=0;while(match=separator.exec(substring)){var newEnd=match.index;}result=result.slice(0,newEnd===undefined?end:newEnd);}}else if(string.indexOf(baseToString(separator),end)!=end){var index=result.lastIndexOf(separator);if(index>-1){result=result.slice(0,index);}}return result+omission;}/**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */function unescape(string){string=toString(string);return string&&reHasEscapedHtml.test(string)?string.replace(reEscapedHtml,unescapeHtmlChar):string;}/**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */var upperCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toUpperCase();});/**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */var upperFirst=createCaseFirst('toUpperCase');/**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */function words(string,pattern,guard){string=toString(string);pattern=guard?undefined:pattern;if(pattern===undefined){return hasUnicodeWord(string)?unicodeWords(string):asciiWords(string);}return string.match(pattern)||[];}/*------------------------------------------------------------------------*//**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */var attempt=baseRest(function(func,args){try{return apply(func,undefined,args);}catch(e){return isError(e)?e:new Error(e);}});/**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */var bindAll=flatRest(function(object,methodNames){arrayEach(methodNames,function(key){key=toKey(key);baseAssignValue(object,key,bind(object[key],object));});return object;});/**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */function cond(pairs){var length=pairs==null?0:pairs.length,toIteratee=getIteratee();pairs=!length?[]:arrayMap(pairs,function(pair){if(typeof pair[1]!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return[toIteratee(pair[0]),pair[1]];});return baseRest(function(args){var index=-1;while(++index<length){var pair=pairs[index];if(apply(pair[0],this,args)){return apply(pair[1],this,args);}}});}/**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */function conforms(source){return baseConforms(baseClone(source,CLONE_DEEP_FLAG));}/**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */function constant(value){return function(){return value;};}/**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */function defaultTo(value,defaultValue){return value==null||value!==value?defaultValue:value;}/**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */var flow=createFlow();/**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */var flowRight=createFlow(true);/**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */function identity(value){return value;}/**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */function iteratee(func){return baseIteratee(typeof func=='function'?func:baseClone(func,CLONE_DEEP_FLAG));}/**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */function matches(source){return baseMatches(baseClone(source,CLONE_DEEP_FLAG));}/**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */function matchesProperty(path,srcValue){return baseMatchesProperty(path,baseClone(srcValue,CLONE_DEEP_FLAG));}/**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */var method=baseRest(function(path,args){return function(object){return baseInvoke(object,path,args);};});/**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */var methodOf=baseRest(function(object,args){return function(path){return baseInvoke(object,path,args);};});/**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */function mixin(object,source,options){var props=keys(source),methodNames=baseFunctions(source,props);if(options==null&&!(isObject(source)&&(methodNames.length||!props.length))){options=source;source=object;object=this;methodNames=baseFunctions(source,keys(source));}var chain=!(isObject(options)&&'chain'in options)||!!options.chain,isFunc=isFunction(object);arrayEach(methodNames,function(methodName){var func=source[methodName];object[methodName]=func;if(isFunc){object.prototype[methodName]=function(){var chainAll=this.__chain__;if(chain||chainAll){var result=object(this.__wrapped__),actions=result.__actions__=copyArray(this.__actions__);actions.push({'func':func,'args':arguments,'thisArg':object});result.__chain__=chainAll;return result;}return func.apply(object,arrayPush([this.value()],arguments));};}});return object;}/**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */function noConflict(){if(root._===this){root._=oldDash;}return this;}/**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */function noop(){// No operation performed.
}/**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */function nthArg(n){n=toInteger(n);return baseRest(function(args){return baseNth(args,n);});}/**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */var over=createOver(arrayMap);/**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */var overEvery=createOver(arrayEvery);/**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */var overSome=createOver(arraySome);/**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */function property(path){return isKey(path)?baseProperty(toKey(path)):basePropertyDeep(path);}/**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */function propertyOf(object){return function(path){return object==null?undefined:baseGet(object,path);};}/**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */var range=createRange();/**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */var rangeRight=createRange(true);/**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */function stubArray(){return[];}/**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */function stubFalse(){return false;}/**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */function stubObject(){return{};}/**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */function stubString(){return'';}/**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */function stubTrue(){return true;}/**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */function times(n,iteratee){n=toInteger(n);if(n<1||n>MAX_SAFE_INTEGER){return[];}var index=MAX_ARRAY_LENGTH,length=nativeMin(n,MAX_ARRAY_LENGTH);iteratee=getIteratee(iteratee);n-=MAX_ARRAY_LENGTH;var result=baseTimes(length,iteratee);while(++index<n){iteratee(index);}return result;}/**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */function toPath(value){if(isArray(value)){return arrayMap(value,toKey);}return isSymbol(value)?[value]:copyArray(stringToPath(toString(value)));}/**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */function uniqueId(prefix){var id=++idCounter;return toString(prefix)+id;}/*------------------------------------------------------------------------*//**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */var add=createMathOperation(function(augend,addend){return augend+addend;},0);/**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */var ceil=createRound('ceil');/**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */var divide=createMathOperation(function(dividend,divisor){return dividend/divisor;},1);/**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */var floor=createRound('floor');/**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */function max(array){return array&&array.length?baseExtremum(array,identity,baseGt):undefined;}/**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */function maxBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseGt):undefined;}/**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */function mean(array){return baseMean(array,identity);}/**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */function meanBy(array,iteratee){return baseMean(array,getIteratee(iteratee,2));}/**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */function min(array){return array&&array.length?baseExtremum(array,identity,baseLt):undefined;}/**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */function minBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseLt):undefined;}/**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */var multiply=createMathOperation(function(multiplier,multiplicand){return multiplier*multiplicand;},1);/**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */var round=createRound('round');/**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */var subtract=createMathOperation(function(minuend,subtrahend){return minuend-subtrahend;},0);/**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */function sum(array){return array&&array.length?baseSum(array,identity):0;}/**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */function sumBy(array,iteratee){return array&&array.length?baseSum(array,getIteratee(iteratee,2)):0;}/*------------------------------------------------------------------------*/// Add methods that return wrapped values in chain sequences.
lodash.after=after;lodash.ary=ary;lodash.assign=assign;lodash.assignIn=assignIn;lodash.assignInWith=assignInWith;lodash.assignWith=assignWith;lodash.at=at;lodash.before=before;lodash.bind=bind;lodash.bindAll=bindAll;lodash.bindKey=bindKey;lodash.castArray=castArray;lodash.chain=chain;lodash.chunk=chunk;lodash.compact=compact;lodash.concat=concat;lodash.cond=cond;lodash.conforms=conforms;lodash.constant=constant;lodash.countBy=countBy;lodash.create=create;lodash.curry=curry;lodash.curryRight=curryRight;lodash.debounce=debounce;lodash.defaults=defaults;lodash.defaultsDeep=defaultsDeep;lodash.defer=defer;lodash.delay=delay;lodash.difference=difference;lodash.differenceBy=differenceBy;lodash.differenceWith=differenceWith;lodash.drop=drop;lodash.dropRight=dropRight;lodash.dropRightWhile=dropRightWhile;lodash.dropWhile=dropWhile;lodash.fill=fill;lodash.filter=filter;lodash.flatMap=flatMap;lodash.flatMapDeep=flatMapDeep;lodash.flatMapDepth=flatMapDepth;lodash.flatten=flatten;lodash.flattenDeep=flattenDeep;lodash.flattenDepth=flattenDepth;lodash.flip=flip;lodash.flow=flow;lodash.flowRight=flowRight;lodash.fromPairs=fromPairs;lodash.functions=functions;lodash.functionsIn=functionsIn;lodash.groupBy=groupBy;lodash.initial=initial;lodash.intersection=intersection;lodash.intersectionBy=intersectionBy;lodash.intersectionWith=intersectionWith;lodash.invert=invert;lodash.invertBy=invertBy;lodash.invokeMap=invokeMap;lodash.iteratee=iteratee;lodash.keyBy=keyBy;lodash.keys=keys;lodash.keysIn=keysIn;lodash.map=map;lodash.mapKeys=mapKeys;lodash.mapValues=mapValues;lodash.matches=matches;lodash.matchesProperty=matchesProperty;lodash.memoize=memoize;lodash.merge=merge;lodash.mergeWith=mergeWith;lodash.method=method;lodash.methodOf=methodOf;lodash.mixin=mixin;lodash.negate=negate;lodash.nthArg=nthArg;lodash.omit=omit;lodash.omitBy=omitBy;lodash.once=once;lodash.orderBy=orderBy;lodash.over=over;lodash.overArgs=overArgs;lodash.overEvery=overEvery;lodash.overSome=overSome;lodash.partial=partial;lodash.partialRight=partialRight;lodash.partition=partition;lodash.pick=pick;lodash.pickBy=pickBy;lodash.property=property;lodash.propertyOf=propertyOf;lodash.pull=pull;lodash.pullAll=pullAll;lodash.pullAllBy=pullAllBy;lodash.pullAllWith=pullAllWith;lodash.pullAt=pullAt;lodash.range=range;lodash.rangeRight=rangeRight;lodash.rearg=rearg;lodash.reject=reject;lodash.remove=remove;lodash.rest=rest;lodash.reverse=reverse;lodash.sampleSize=sampleSize;lodash.set=set;lodash.setWith=setWith;lodash.shuffle=shuffle;lodash.slice=slice;lodash.sortBy=sortBy;lodash.sortedUniq=sortedUniq;lodash.sortedUniqBy=sortedUniqBy;lodash.split=split;lodash.spread=spread;lodash.tail=tail;lodash.take=take;lodash.takeRight=takeRight;lodash.takeRightWhile=takeRightWhile;lodash.takeWhile=takeWhile;lodash.tap=tap;lodash.throttle=throttle;lodash.thru=thru;lodash.toArray=toArray;lodash.toPairs=toPairs;lodash.toPairsIn=toPairsIn;lodash.toPath=toPath;lodash.toPlainObject=toPlainObject;lodash.transform=transform;lodash.unary=unary;lodash.union=union;lodash.unionBy=unionBy;lodash.unionWith=unionWith;lodash.uniq=uniq;lodash.uniqBy=uniqBy;lodash.uniqWith=uniqWith;lodash.unset=unset;lodash.unzip=unzip;lodash.unzipWith=unzipWith;lodash.update=update;lodash.updateWith=updateWith;lodash.values=values;lodash.valuesIn=valuesIn;lodash.without=without;lodash.words=words;lodash.wrap=wrap;lodash.xor=xor;lodash.xorBy=xorBy;lodash.xorWith=xorWith;lodash.zip=zip;lodash.zipObject=zipObject;lodash.zipObjectDeep=zipObjectDeep;lodash.zipWith=zipWith;// Add aliases.
lodash.entries=toPairs;lodash.entriesIn=toPairsIn;lodash.extend=assignIn;lodash.extendWith=assignInWith;// Add methods to `lodash.prototype`.
mixin(lodash,lodash);/*------------------------------------------------------------------------*/// Add methods that return unwrapped values in chain sequences.
lodash.add=add;lodash.attempt=attempt;lodash.camelCase=camelCase;lodash.capitalize=capitalize;lodash.ceil=ceil;lodash.clamp=clamp;lodash.clone=clone;lodash.cloneDeep=cloneDeep;lodash.cloneDeepWith=cloneDeepWith;lodash.cloneWith=cloneWith;lodash.conformsTo=conformsTo;lodash.deburr=deburr;lodash.defaultTo=defaultTo;lodash.divide=divide;lodash.endsWith=endsWith;lodash.eq=eq;lodash.escape=escape;lodash.escapeRegExp=escapeRegExp;lodash.every=every;lodash.find=find;lodash.findIndex=findIndex;lodash.findKey=findKey;lodash.findLast=findLast;lodash.findLastIndex=findLastIndex;lodash.findLastKey=findLastKey;lodash.floor=floor;lodash.forEach=forEach;lodash.forEachRight=forEachRight;lodash.forIn=forIn;lodash.forInRight=forInRight;lodash.forOwn=forOwn;lodash.forOwnRight=forOwnRight;lodash.get=get;lodash.gt=gt;lodash.gte=gte;lodash.has=has;lodash.hasIn=hasIn;lodash.head=head;lodash.identity=identity;lodash.includes=includes;lodash.indexOf=indexOf;lodash.inRange=inRange;lodash.invoke=invoke;lodash.isArguments=isArguments;lodash.isArray=isArray;lodash.isArrayBuffer=isArrayBuffer;lodash.isArrayLike=isArrayLike;lodash.isArrayLikeObject=isArrayLikeObject;lodash.isBoolean=isBoolean;lodash.isBuffer=isBuffer;lodash.isDate=isDate;lodash.isElement=isElement;lodash.isEmpty=isEmpty;lodash.isEqual=isEqual;lodash.isEqualWith=isEqualWith;lodash.isError=isError;lodash.isFinite=isFinite;lodash.isFunction=isFunction;lodash.isInteger=isInteger;lodash.isLength=isLength;lodash.isMap=isMap;lodash.isMatch=isMatch;lodash.isMatchWith=isMatchWith;lodash.isNaN=isNaN;lodash.isNative=isNative;lodash.isNil=isNil;lodash.isNull=isNull;lodash.isNumber=isNumber;lodash.isObject=isObject;lodash.isObjectLike=isObjectLike;lodash.isPlainObject=isPlainObject;lodash.isRegExp=isRegExp;lodash.isSafeInteger=isSafeInteger;lodash.isSet=isSet;lodash.isString=isString;lodash.isSymbol=isSymbol;lodash.isTypedArray=isTypedArray;lodash.isUndefined=isUndefined;lodash.isWeakMap=isWeakMap;lodash.isWeakSet=isWeakSet;lodash.join=join;lodash.kebabCase=kebabCase;lodash.last=last;lodash.lastIndexOf=lastIndexOf;lodash.lowerCase=lowerCase;lodash.lowerFirst=lowerFirst;lodash.lt=lt;lodash.lte=lte;lodash.max=max;lodash.maxBy=maxBy;lodash.mean=mean;lodash.meanBy=meanBy;lodash.min=min;lodash.minBy=minBy;lodash.stubArray=stubArray;lodash.stubFalse=stubFalse;lodash.stubObject=stubObject;lodash.stubString=stubString;lodash.stubTrue=stubTrue;lodash.multiply=multiply;lodash.nth=nth;lodash.noConflict=noConflict;lodash.noop=noop;lodash.now=now;lodash.pad=pad;lodash.padEnd=padEnd;lodash.padStart=padStart;lodash.parseInt=parseInt;lodash.random=random;lodash.reduce=reduce;lodash.reduceRight=reduceRight;lodash.repeat=repeat;lodash.replace=replace;lodash.result=result;lodash.round=round;lodash.runInContext=runInContext;lodash.sample=sample;lodash.size=size;lodash.snakeCase=snakeCase;lodash.some=some;lodash.sortedIndex=sortedIndex;lodash.sortedIndexBy=sortedIndexBy;lodash.sortedIndexOf=sortedIndexOf;lodash.sortedLastIndex=sortedLastIndex;lodash.sortedLastIndexBy=sortedLastIndexBy;lodash.sortedLastIndexOf=sortedLastIndexOf;lodash.startCase=startCase;lodash.startsWith=startsWith;lodash.subtract=subtract;lodash.sum=sum;lodash.sumBy=sumBy;lodash.template=template;lodash.times=times;lodash.toFinite=toFinite;lodash.toInteger=toInteger;lodash.toLength=toLength;lodash.toLower=toLower;lodash.toNumber=toNumber;lodash.toSafeInteger=toSafeInteger;lodash.toString=toString;lodash.toUpper=toUpper;lodash.trim=trim;lodash.trimEnd=trimEnd;lodash.trimStart=trimStart;lodash.truncate=truncate;lodash.unescape=unescape;lodash.uniqueId=uniqueId;lodash.upperCase=upperCase;lodash.upperFirst=upperFirst;// Add aliases.
lodash.each=forEach;lodash.eachRight=forEachRight;lodash.first=head;mixin(lodash,function(){var source={};baseForOwn(lodash,function(func,methodName){if(!hasOwnProperty.call(lodash.prototype,methodName)){source[methodName]=func;}});return source;}(),{'chain':false});/*------------------------------------------------------------------------*//**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */lodash.VERSION=VERSION;// Assign default placeholders.
arrayEach(['bind','bindKey','curry','curryRight','partial','partialRight'],function(methodName){lodash[methodName].placeholder=lodash;});// Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
arrayEach(['drop','take'],function(methodName,index){LazyWrapper.prototype[methodName]=function(n){n=n===undefined?1:nativeMax(toInteger(n),0);var result=this.__filtered__&&!index?new LazyWrapper(this):this.clone();if(result.__filtered__){result.__takeCount__=nativeMin(n,result.__takeCount__);}else{result.__views__.push({'size':nativeMin(n,MAX_ARRAY_LENGTH),'type':methodName+(result.__dir__<0?'Right':'')});}return result;};LazyWrapper.prototype[methodName+'Right']=function(n){return this.reverse()[methodName](n).reverse();};});// Add `LazyWrapper` methods that accept an `iteratee` value.
arrayEach(['filter','map','takeWhile'],function(methodName,index){var type=index+1,isFilter=type==LAZY_FILTER_FLAG||type==LAZY_WHILE_FLAG;LazyWrapper.prototype[methodName]=function(iteratee){var result=this.clone();result.__iteratees__.push({'iteratee':getIteratee(iteratee,3),'type':type});result.__filtered__=result.__filtered__||isFilter;return result;};});// Add `LazyWrapper` methods for `_.head` and `_.last`.
arrayEach(['head','last'],function(methodName,index){var takeName='take'+(index?'Right':'');LazyWrapper.prototype[methodName]=function(){return this[takeName](1).value()[0];};});// Add `LazyWrapper` methods for `_.initial` and `_.tail`.
arrayEach(['initial','tail'],function(methodName,index){var dropName='drop'+(index?'':'Right');LazyWrapper.prototype[methodName]=function(){return this.__filtered__?new LazyWrapper(this):this[dropName](1);};});LazyWrapper.prototype.compact=function(){return this.filter(identity);};LazyWrapper.prototype.find=function(predicate){return this.filter(predicate).head();};LazyWrapper.prototype.findLast=function(predicate){return this.reverse().find(predicate);};LazyWrapper.prototype.invokeMap=baseRest(function(path,args){if(typeof path=='function'){return new LazyWrapper(this);}return this.map(function(value){return baseInvoke(value,path,args);});});LazyWrapper.prototype.reject=function(predicate){return this.filter(negate(getIteratee(predicate)));};LazyWrapper.prototype.slice=function(start,end){start=toInteger(start);var result=this;if(result.__filtered__&&(start>0||end<0)){return new LazyWrapper(result);}if(start<0){result=result.takeRight(-start);}else if(start){result=result.drop(start);}if(end!==undefined){end=toInteger(end);result=end<0?result.dropRight(-end):result.take(end-start);}return result;};LazyWrapper.prototype.takeRightWhile=function(predicate){return this.reverse().takeWhile(predicate).reverse();};LazyWrapper.prototype.toArray=function(){return this.take(MAX_ARRAY_LENGTH);};// Add `LazyWrapper` methods to `lodash.prototype`.
baseForOwn(LazyWrapper.prototype,function(func,methodName){var checkIteratee=/^(?:filter|find|map|reject)|While$/.test(methodName),isTaker=/^(?:head|last)$/.test(methodName),lodashFunc=lodash[isTaker?'take'+(methodName=='last'?'Right':''):methodName],retUnwrapped=isTaker||/^find/.test(methodName);if(!lodashFunc){return;}lodash.prototype[methodName]=function(){var value=this.__wrapped__,args=isTaker?[1]:arguments,isLazy=value instanceof LazyWrapper,iteratee=args[0],useLazy=isLazy||isArray(value);var interceptor=function(value){var result=lodashFunc.apply(lodash,arrayPush([value],args));return isTaker&&chainAll?result[0]:result;};if(useLazy&&checkIteratee&&typeof iteratee=='function'&&iteratee.length!=1){// Avoid lazy use if the iteratee has a "length" value other than `1`.
isLazy=useLazy=false;}var chainAll=this.__chain__,isHybrid=!!this.__actions__.length,isUnwrapped=retUnwrapped&&!chainAll,onlyLazy=isLazy&&!isHybrid;if(!retUnwrapped&&useLazy){value=onlyLazy?value:new LazyWrapper(this);var result=func.apply(value,args);result.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(result,chainAll);}if(isUnwrapped&&onlyLazy){return func.apply(this,args);}result=this.thru(interceptor);return isUnwrapped?isTaker?result.value()[0]:result.value():result;};});// Add `Array` methods to `lodash.prototype`.
arrayEach(['pop','push','shift','sort','splice','unshift'],function(methodName){var func=arrayProto[methodName],chainName=/^(?:push|sort|unshift)$/.test(methodName)?'tap':'thru',retUnwrapped=/^(?:pop|shift)$/.test(methodName);lodash.prototype[methodName]=function(){var args=arguments;if(retUnwrapped&&!this.__chain__){var value=this.value();return func.apply(isArray(value)?value:[],args);}return this[chainName](function(value){return func.apply(isArray(value)?value:[],args);});};});// Map minified method names to their real names.
baseForOwn(LazyWrapper.prototype,function(func,methodName){var lodashFunc=lodash[methodName];if(lodashFunc){var key=lodashFunc.name+'';if(!hasOwnProperty.call(realNames,key)){realNames[key]=[];}realNames[key].push({'name':methodName,'func':lodashFunc});}});realNames[createHybrid(undefined,WRAP_BIND_KEY_FLAG).name]=[{'name':'wrapper','func':undefined}];// Add methods to `LazyWrapper`.
LazyWrapper.prototype.clone=lazyClone;LazyWrapper.prototype.reverse=lazyReverse;LazyWrapper.prototype.value=lazyValue;// Add chain sequence methods to the `lodash` wrapper.
lodash.prototype.at=wrapperAt;lodash.prototype.chain=wrapperChain;lodash.prototype.commit=wrapperCommit;lodash.prototype.next=wrapperNext;lodash.prototype.plant=wrapperPlant;lodash.prototype.reverse=wrapperReverse;lodash.prototype.toJSON=lodash.prototype.valueOf=lodash.prototype.value=wrapperValue;// Add lazy aliases.
lodash.prototype.first=lodash.prototype.head;if(symIterator){lodash.prototype[symIterator]=wrapperToIterator;}return lodash;};/*--------------------------------------------------------------------------*/// Export lodash.
var _=runInContext();// Some AMD build optimizers, like r.js, check for condition patterns like:
if(true){// Expose Lodash on the global object to prevent errors when Lodash is
// loaded by a script tag in the presence of an AMD loader.
// See http://requirejs.org/docs/errors.html#mismatch for more details.
// Use `_.noConflict` to remove Lodash from the global object.
root._=_;// Define as an anonymous module so, through path mapping, it can be
// referenced as the "underscore" module.
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return _;}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}// Check for `exports` after `define` in case a build optimizer adds it.
else {}}).call(this);

/***/ }),

/***/ 96359:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const isOptionObject = __webpack_require__(31701);
const {
  hasOwnProperty
} = Object.prototype;
const {
  propertyIsEnumerable
} = Object;
const defineProperty = (object, name, value) => Object.defineProperty(object, name, {
  value,
  writable: true,
  enumerable: true,
  configurable: true
});
const globalThis = this;
const defaultMergeOptions = {
  concatArrays: false,
  ignoreUndefined: false
};
const getEnumerableOwnPropertyKeys = value => {
  const keys = [];
  for (const key in value) {
    if (hasOwnProperty.call(value, key)) {
      keys.push(key);
    }
  }

  /* istanbul ignore else  */
  if (Object.getOwnPropertySymbols) {
    const symbols = Object.getOwnPropertySymbols(value);
    for (const symbol of symbols) {
      if (propertyIsEnumerable.call(value, symbol)) {
        keys.push(symbol);
      }
    }
  }
  return keys;
};
function clone(value) {
  if (Array.isArray(value)) {
    return cloneArray(value);
  }
  if (isOptionObject(value)) {
    return cloneOptionObject(value);
  }
  return value;
}
function cloneArray(array) {
  const result = array.slice(0, 0);
  getEnumerableOwnPropertyKeys(array).forEach(key => {
    defineProperty(result, key, clone(array[key]));
  });
  return result;
}
function cloneOptionObject(object) {
  const result = Object.getPrototypeOf(object) === null ? Object.create(null) : {};
  getEnumerableOwnPropertyKeys(object).forEach(key => {
    defineProperty(result, key, clone(object[key]));
  });
  return result;
}

/**
 * @param {*} merged already cloned
 * @param {*} source something to merge
 * @param {string[]} keys keys to merge
 * @param {Object} config Config Object
 * @returns {*} cloned Object
 */
const mergeKeys = (merged, source, keys, config) => {
  keys.forEach(key => {
    if (typeof source[key] === 'undefined' && config.ignoreUndefined) {
      return;
    }

    // Do not recurse into prototype chain of merged
    if (key in merged && merged[key] !== Object.getPrototypeOf(merged)) {
      defineProperty(merged, key, merge(merged[key], source[key], config));
    } else {
      defineProperty(merged, key, clone(source[key]));
    }
  });
  return merged;
};

/**
 * @param {*} merged already cloned
 * @param {*} source something to merge
 * @param {Object} config Config Object
 * @returns {*} cloned Object
 *
 * see [Array.prototype.concat ( ...arguments )](http://www.ecma-international.org/ecma-262/6.0/#sec-array.prototype.concat)
 */
const concatArrays = (merged, source, config) => {
  let result = merged.slice(0, 0);
  let resultIndex = 0;
  [merged, source].forEach(array => {
    const indices = [];

    // `result.concat(array)` with cloning
    for (let k = 0; k < array.length; k++) {
      if (!hasOwnProperty.call(array, k)) {
        continue;
      }
      indices.push(String(k));
      if (array === merged) {
        // Already cloned
        defineProperty(result, resultIndex++, array[k]);
      } else {
        defineProperty(result, resultIndex++, clone(array[k]));
      }
    }

    // Merge non-index keys
    result = mergeKeys(result, array, getEnumerableOwnPropertyKeys(array).filter(key => !indices.includes(key)), config);
  });
  return result;
};

/**
 * @param {*} merged already cloned
 * @param {*} source something to merge
 * @param {Object} config Config Object
 * @returns {*} cloned Object
 */
function merge(merged, source, config) {
  if (config.concatArrays && Array.isArray(merged) && Array.isArray(source)) {
    return concatArrays(merged, source, config);
  }
  if (!isOptionObject(source) || !isOptionObject(merged)) {
    return clone(source);
  }
  return mergeKeys(merged, source, getEnumerableOwnPropertyKeys(source), config);
}
module.exports = function (...options) {
  const config = merge(clone(defaultMergeOptions), this !== globalThis && this || {}, defaultMergeOptions);
  let merged = {
    _: {}
  };
  for (const option of options) {
    if (option === undefined) {
      continue;
    }
    if (!isOptionObject(option)) {
      throw new TypeError('`' + option + '` is not an Option Object');
    }
    merged = merge(merged, {
      _: option
    }, config);
  }
  return merged._;
};

/***/ }),

/***/ 55514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(66710);

/***/ }),

/***/ 3092:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var _defineProperty = (__webpack_require__(51677)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(92304)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(41981)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(54363)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(4858)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(27031)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(84315)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(82684));
var _head = _interop_require_default(__webpack_require__(92310));
var _imageBlurSvg = __webpack_require__(96552);
var _imageConfig = __webpack_require__(3543);
var _imageConfigContext = __webpack_require__(63968);
var _utils = __webpack_require__(89563);
function Image(_param) {
  var src = _param.src,
    sizes = _param.sizes,
    _unoptimized = _param.unoptimized,
    unoptimized = _unoptimized === void 0 ? false : _unoptimized,
    _priority = _param.priority,
    priority = _priority === void 0 ? false : _priority,
    loading = _param.loading,
    className = _param.className,
    quality = _param.quality,
    width = _param.width,
    height = _param.height,
    fill = _param.fill,
    style = _param.style,
    onLoadingComplete = _param.onLoadingComplete,
    _placeholder = _param.placeholder,
    placeholder = _placeholder === void 0 ? "empty" : _placeholder,
    blurDataURL = _param.blurDataURL,
    all = _object_without_properties_loose(_param, ["src", "sizes", "unoptimized", "priority", "loading", "className", "quality", "width", "height", "fill", "style", "onLoadingComplete", "placeholder", "blurDataURL"]);
  var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
  var config = (0, _react).useMemo(function () {
    var c = configEnv || configContext || _imageConfig.imageConfigDefault;
    var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function (a, b) {
      return a - b;
    });
    var deviceSizes = c.deviceSizes.sort(function (a, b) {
      return a - b;
    });
    return _extends({}, c, {
      allSizes: allSizes,
      deviceSizes: deviceSizes
    });
  }, [configContext]);
  var rest = all;
  var loader = defaultLoader;
  if ("loader" in rest) {
    if (rest.loader) {
      var customImageLoader = rest.loader;
      var _tmp;
      _tmp = function (obj) {
        var _ = obj.config,
          opts = _object_without_properties_loose(obj, ["config"]);
        // The config object is internal only so we must
        // not pass it to the user-defined loader()
        return customImageLoader(opts);
      }, loader = _tmp, _tmp;
    }
    // Remove property so it's not spread on <img>
    delete rest.loader;
  }
  var staticSrc = "";
  var widthInt = getInt(width);
  var heightInt = getInt(height);
  var blurWidth;
  var blurHeight;
  if (isStaticImport(src)) {
    var staticImageData = isStaticRequire(src) ? src.default : src;
    if (!staticImageData.src) {
      throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
    }
    if (!staticImageData.height || !staticImageData.width) {
      throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
    }
    blurWidth = staticImageData.blurWidth;
    blurHeight = staticImageData.blurHeight;
    blurDataURL = blurDataURL || staticImageData.blurDataURL;
    staticSrc = staticImageData.src;
    if (!fill) {
      if (!widthInt && !heightInt) {
        widthInt = staticImageData.width;
        heightInt = staticImageData.height;
      } else if (widthInt && !heightInt) {
        var ratio = widthInt / staticImageData.width;
        heightInt = Math.round(staticImageData.height * ratio);
      } else if (!widthInt && heightInt) {
        var ratio1 = heightInt / staticImageData.height;
        widthInt = Math.round(staticImageData.width * ratio1);
      }
    }
  }
  src = typeof src === "string" ? src : staticSrc;
  var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
  if (src.startsWith("data:") || src.startsWith("blob:")) {
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
    unoptimized = true;
    isLazy = false;
  }
  if (config.unoptimized) {
    unoptimized = true;
  }
  var ref = _slicedToArray((0, _react).useState(false), 2),
    blurComplete = ref[0],
    setBlurComplete = ref[1];
  var ref1 = _slicedToArray((0, _react).useState(false), 2),
    showAltText = ref1[0],
    setShowAltText = ref1[1];
  var qualityInt = getInt(quality);
  if (false) { var url, urlStr, VALID_BLUR_EXT; }
  var imgStyle = Object.assign(fill ? {
    position: "absolute",
    height: "100%",
    width: "100%",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  } : {}, showAltText ? {} : {
    color: "transparent"
  }, style);
  var blurStyle = placeholder === "blur" && blurDataURL && !blurComplete ? {
    backgroundSize: imgStyle.objectFit || "cover",
    backgroundPosition: imgStyle.objectPosition || "50% 50%",
    backgroundRepeat: "no-repeat",
    backgroundImage: 'url("data:image/svg+xml;charset=utf-8,'.concat((0, _imageBlurSvg).getImageBlurSvg({
      widthInt: widthInt,
      heightInt: heightInt,
      blurWidth: blurWidth,
      blurHeight: blurHeight,
      blurDataURL: blurDataURL
    }), '")')
  } : {};
  if (false) {}
  var imgAttributes = generateImgAttrs({
    config: config,
    src: src,
    unoptimized: unoptimized,
    width: widthInt,
    quality: qualityInt,
    sizes: sizes,
    loader: loader
  });
  var srcString = src;
  if (false) { var fullUrl; }
  var imageSrcSetPropName = "imagesrcset";
  var imageSizesPropName = "imagesizes";
  if (true) {
    imageSrcSetPropName = "imageSrcSet";
    imageSizesPropName = "imageSizes";
  }
  var _obj;
  var linkProps = (_obj = {},
  // Note: imagesrcset and imagesizes are not in the link element type with react 17.
  _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _defineProperty(_obj, "crossOrigin", rest.crossOrigin), _obj);
  var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
  (0, _react).useEffect(function () {
    onLoadingCompleteRef.current = onLoadingComplete;
  }, [onLoadingComplete]);
  var imgElementArgs = _extends({
    isLazy: isLazy,
    imgAttributes: imgAttributes,
    heightInt: heightInt,
    widthInt: widthInt,
    qualityInt: qualityInt,
    className: className,
    imgStyle: imgStyle,
    blurStyle: blurStyle,
    loading: loading,
    config: config,
    fill: fill,
    unoptimized: unoptimized,
    placeholder: placeholder,
    loader: loader,
    srcString: srcString,
    onLoadingCompleteRef: onLoadingCompleteRef,
    setBlurComplete: setBlurComplete,
    setShowAltText: setShowAltText
  }, rest);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ImageElement, Object.assign({}, imgElementArgs)), priority ?
  // for browsers that do not support `imagesrcset`, and in those cases
  // it would likely cause the incorrect image to be preloaded.
  //
  // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
  /*#__PURE__*/
  _react.default.createElement(_head.default, null, /*#__PURE__*/_react.default.createElement("link", Object.assign({
    key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
    rel: "preload",
    as: "image",
    href: imgAttributes.srcSet ? undefined : imgAttributes.src
  }, linkProps))) : null);
}
"client";
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":true};
var allImgs = new Map();
var perfObserver;
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && (["lazy", "eager", undefined]));
function isStaticRequire(src) {
  return src.default !== undefined;
}
function isStaticImageData(src) {
  return src.src !== undefined;
}
function isStaticImport(src) {
  return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, sizes) {
  var deviceSizes = param.deviceSizes,
    allSizes = param.allSizes;
  if (sizes) {
    // Find all the "vw" percent sizes used in the sizes prop
    var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
    var percentSizes = [];
    for (var match; match = viewportWidthRe.exec(sizes); match) {
      percentSizes.push(parseInt(match[2]));
    }
    if (percentSizes.length) {
      var _Math;
      var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
      return {
        widths: allSizes.filter(function (s) {
          return s >= deviceSizes[0] * smallestRatio;
        }),
        kind: "w"
      };
    }
    return {
      widths: allSizes,
      kind: "w"
    };
  }
  if (typeof width !== "number") {
    return {
      widths: deviceSizes,
      kind: "w"
    };
  }
  var widths = _toConsumableArray(new Set(
  // > are actually 3x in the green color, but only 1.5x in the red and
  // > blue colors. Showing a 3x resolution image in the app vs a 2x
  // > resolution image will be visually the same, though the 3x image
  // > takes significantly more data. Even true 3x resolution screens are
  // > wasteful as the human eye cannot see that level of detail without
  // > something like a magnifying glass.
  // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
  [width, width * 2 /*, width * 3*/].map(function (w) {
    return allSizes.find(function (p) {
      return p >= w;
    }) || allSizes[allSizes.length - 1];
  })));
  return {
    widths: widths,
    kind: "x"
  };
}
function generateImgAttrs(param) {
  var config = param.config,
    src = param.src,
    unoptimized = param.unoptimized,
    width = param.width,
    quality = param.quality,
    sizes = param.sizes,
    loader = param.loader;
  if (unoptimized) {
    return {
      src: src,
      srcSet: undefined,
      sizes: undefined
    };
  }
  var ref = getWidths(config, width, sizes),
    widths = ref.widths,
    kind = ref.kind;
  var last = widths.length - 1;
  return {
    sizes: !sizes && kind === "w" ? "100vw" : sizes,
    srcSet: widths.map(function (w, i) {
      return "".concat(loader({
        config: config,
        src: src,
        quality: quality,
        width: w
      }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
    }).join(", "),
    // It's intended to keep `src` the last attribute because React updates
    // attributes in order. If we keep `src` the first one, Safari will
    // immediately start to fetch `src`, before `sizes` and `srcSet` are even
    // updated by React. That causes multiple unnecessary requests if `srcSet`
    // and `sizes` are defined.
    // This bug cannot be reproduced in Chrome or Firefox.
    src: loader({
      config: config,
      src: src,
      quality: quality,
      width: widths[last]
    })
  };
}
function getInt(x) {
  if (typeof x === "number" || typeof x === "undefined") {
    return x;
  }
  if (typeof x === "string" && /^[0-9]+$/.test(x)) {
    return parseInt(x, 10);
  }
  return NaN;
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, placeholder, onLoadingCompleteRef, setBlurComplete) {
  if (!img || img["data-loaded-src"] === src) {
    return;
  }
  img["data-loaded-src"] = src;
  var p = "decode" in img ? img.decode() : Promise.resolve();
  p.catch(function () {}).then(function () {
    if (!img.parentNode) {
      // Exit early in case of race condition:
      // - onload() is called
      // - decode() is called but incomplete
      // - unmount is called
      // - decode() completes
      return;
    }
    if (placeholder === "blur") {
      setBlurComplete(true);
    }
    if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
      onLoadingCompleteRef.current(img);
    }
    if (false) { var widthModified, heightModified, valid, position, widthViewportRatio; }
  });
}
var ImageElement = function (_param) {
  var imgAttributes = _param.imgAttributes,
    heightInt = _param.heightInt,
    widthInt = _param.widthInt,
    qualityInt = _param.qualityInt,
    className = _param.className,
    imgStyle = _param.imgStyle,
    blurStyle = _param.blurStyle,
    isLazy = _param.isLazy,
    fill = _param.fill,
    placeholder = _param.placeholder,
    loading = _param.loading,
    srcString = _param.srcString,
    config = _param.config,
    unoptimized = _param.unoptimized,
    loader = _param.loader,
    onLoadingCompleteRef = _param.onLoadingCompleteRef,
    setBlurComplete = _param.setBlurComplete,
    setShowAltText = _param.setShowAltText,
    onLoad = _param.onLoad,
    onError = _param.onError,
    rest = _object_without_properties_loose(_param, ["imgAttributes", "heightInt", "widthInt", "qualityInt", "className", "imgStyle", "blurStyle", "isLazy", "fill", "placeholder", "loading", "srcString", "config", "unoptimized", "loader", "onLoadingCompleteRef", "setBlurComplete", "setShowAltText", "onLoad", "onError"]);
  loading = isLazy ? "lazy" : loading;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
    width: widthInt,
    height: heightInt,
    decoding: "async",
    "data-nimg": "future".concat(fill ? "-fill" : ""),
    className: className,
    // @ts-ignore - TODO: upgrade to `@types/react@17`
    loading: loading,
    style: _extends({}, imgStyle, blurStyle),
    ref: (0, _react).useCallback(function (img) {
      if (!img) {
        return;
      }
      if (onError) {
        // If the image has an error before react hydrates, then the error is lost.
        // The workaround is to wait until the image is mounted which is after hydration,
        // then we set the src again to trigger the error handler (if there was an error).
        // eslint-disable-next-line no-self-assign
        img.src = img.src;
      }
      if (false) {}
      if (img.complete) {
        handleLoading(img, srcString, placeholder, onLoadingCompleteRef, setBlurComplete);
      }
    }, [srcString, placeholder, onLoadingCompleteRef, setBlurComplete, onError]),
    onLoad: function (event) {
      var img = event.currentTarget;
      handleLoading(img, srcString, placeholder, onLoadingCompleteRef, setBlurComplete);
      if (onLoad) {
        onLoad(event);
      }
    },
    onError: function (event) {
      // if the real image fails to load, this will ensure "alt" is visible
      setShowAltText(true);
      if (placeholder === "blur") {
        // If the real image fails to load, this will still remove the placeholder.
        setBlurComplete(true);
      }
      if (onError) {
        onError(event);
      }
    }
  })));
};
function defaultLoader(param) {
  var config = param.config,
    src = param.src,
    width = param.width,
    quality = param.quality;
  if (false) { var hasMatch, parsedSrc, missingValues; }
  if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
    // Special case to make svg serve as-is to avoid proxying
    // through the built-in Image Optimization API.
    return src;
  }
  return "".concat(config.path, "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
  Object.defineProperty(exports.default, "__esModule", {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
} //# sourceMappingURL=image.js.map

/***/ }),

/***/ 96378:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
  if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
    return false;
  }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
  Object.defineProperty(exports.default, "__esModule", {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map

/***/ }),

/***/ 30824:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var _defineProperty = (__webpack_require__(51677)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(92304)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(41981)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(54363)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(4858)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(27031)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(84315)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(82684));
var _head = _interop_require_default(__webpack_require__(92310));
var _imageConfig = __webpack_require__(3543);
var _useIntersection = __webpack_require__(43973);
var _imageConfigContext = __webpack_require__(63968);
var _utils = __webpack_require__(89563);
var _normalizeTrailingSlash = __webpack_require__(12056);
function Image(_param) {
  var src = _param.src,
    sizes = _param.sizes,
    _unoptimized = _param.unoptimized,
    unoptimized = _unoptimized === void 0 ? false : _unoptimized,
    _priority = _param.priority,
    priority = _priority === void 0 ? false : _priority,
    loading = _param.loading,
    _lazyRoot = _param.lazyRoot,
    lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot,
    lazyBoundary = _param.lazyBoundary,
    className = _param.className,
    quality = _param.quality,
    width = _param.width,
    height = _param.height,
    style = _param.style,
    objectFit = _param.objectFit,
    objectPosition = _param.objectPosition,
    onLoadingComplete = _param.onLoadingComplete,
    _placeholder = _param.placeholder,
    placeholder = _placeholder === void 0 ? "empty" : _placeholder,
    blurDataURL = _param.blurDataURL,
    all = _object_without_properties_loose(_param, ["src", "sizes", "unoptimized", "priority", "loading", "lazyRoot", "lazyBoundary", "className", "quality", "width", "height", "style", "objectFit", "objectPosition", "onLoadingComplete", "placeholder", "blurDataURL"]);
  var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
  var config = (0, _react).useMemo(function () {
    var c = configEnv || configContext || _imageConfig.imageConfigDefault;
    var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function (a, b) {
      return a - b;
    });
    var deviceSizes = c.deviceSizes.sort(function (a, b) {
      return a - b;
    });
    return _extends({}, c, {
      allSizes: allSizes,
      deviceSizes: deviceSizes
    });
  }, [configContext]);
  var rest = all;
  var layout = sizes ? "responsive" : "intrinsic";
  if ("layout" in rest) {
    // Override default layout if the user specified one:
    if (rest.layout) layout = rest.layout;
    // Remove property so it's not spread on <img>:
    delete rest.layout;
  }
  var loader = defaultImageLoader;
  if ("loader" in rest) {
    if (rest.loader) {
      var customImageLoader = rest.loader;
      var _tmp;
      _tmp = function (obj) {
        var _ = obj.config,
          opts = _object_without_properties_loose(obj, ["config"]);
        // The config object is internal only so we must
        // not pass it to the user-defined loader()
        return customImageLoader(opts);
      }, loader = _tmp, _tmp;
    }
    // Remove property so it's not spread on <img>
    delete rest.loader;
  }
  var staticSrc = "";
  if (isStaticImport(src)) {
    var staticImageData = isStaticRequire(src) ? src.default : src;
    if (!staticImageData.src) {
      throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
    }
    blurDataURL = blurDataURL || staticImageData.blurDataURL;
    staticSrc = staticImageData.src;
    if (!layout || layout !== "fill") {
      height = height || staticImageData.height;
      width = width || staticImageData.width;
      if (!staticImageData.height || !staticImageData.width) {
        throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
      }
    }
  }
  src = typeof src === "string" ? src : staticSrc;
  var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
  if (src.startsWith("data:") || src.startsWith("blob:")) {
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
    unoptimized = true;
    isLazy = false;
  }
  if ( true && loadedImageURLs.has(src)) {
    isLazy = false;
  }
  if (config.unoptimized) {
    unoptimized = true;
  }
  var ref = _slicedToArray((0, _react).useState(false), 2),
    blurComplete = ref[0],
    setBlurComplete = ref[1];
  var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
      rootRef: lazyRoot,
      rootMargin: lazyBoundary || "200px",
      disabled: !isLazy
    }), 3),
    setIntersection = ref1[0],
    isIntersected = ref1[1],
    resetIntersected = ref1[2];
  var isVisible = !isLazy || isIntersected;
  var wrapperStyle = {
    boxSizing: "border-box",
    display: "block",
    overflow: "hidden",
    width: "initial",
    height: "initial",
    background: "none",
    opacity: 1,
    border: 0,
    margin: 0,
    padding: 0
  };
  var sizerStyle = {
    boxSizing: "border-box",
    display: "block",
    width: "initial",
    height: "initial",
    background: "none",
    opacity: 1,
    border: 0,
    margin: 0,
    padding: 0
  };
  var hasSizer = false;
  var sizerSvgUrl;
  var layoutStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    boxSizing: "border-box",
    padding: 0,
    border: "none",
    margin: "auto",
    display: "block",
    width: 0,
    height: 0,
    minWidth: "100%",
    maxWidth: "100%",
    minHeight: "100%",
    maxHeight: "100%",
    objectFit: objectFit,
    objectPosition: objectPosition
  };
  var widthInt = getInt(width);
  var heightInt = getInt(height);
  var qualityInt = getInt(quality);
  if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
  var imgStyle = Object.assign({}, style, layoutStyle);
  var blurStyle = placeholder === "blur" && !blurComplete ? {
    backgroundSize: objectFit || "cover",
    backgroundPosition: objectPosition || "0% 0%",
    filter: "blur(20px)",
    backgroundImage: 'url("'.concat(blurDataURL, '")')
  } : {};
  if (layout === "fill") {
    // <Image src="i.png" layout="fill" />
    wrapperStyle.display = "block";
    wrapperStyle.position = "absolute";
    wrapperStyle.top = 0;
    wrapperStyle.left = 0;
    wrapperStyle.bottom = 0;
    wrapperStyle.right = 0;
  } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
    // <Image src="i.png" width="100" height="100" />
    var quotient = heightInt / widthInt;
    var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
    if (layout === "responsive") {
      // <Image src="i.png" width="100" height="100" layout="responsive" />
      wrapperStyle.display = "block";
      wrapperStyle.position = "relative";
      hasSizer = true;
      sizerStyle.paddingTop = paddingTop;
    } else if (layout === "intrinsic") {
      // <Image src="i.png" width="100" height="100" layout="intrinsic" />
      wrapperStyle.display = "inline-block";
      wrapperStyle.position = "relative";
      wrapperStyle.maxWidth = "100%";
      hasSizer = true;
      sizerStyle.maxWidth = "100%";
      sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
    } else if (layout === "fixed") {
      // <Image src="i.png" width="100" height="100" layout="fixed" />
      wrapperStyle.display = "inline-block";
      wrapperStyle.position = "relative";
      wrapperStyle.width = widthInt;
      wrapperStyle.height = heightInt;
    }
  } else {
    // <Image src="i.png" />
    if (false) {}
  }
  var imgAttributes = {
    src: emptyDataURL,
    srcSet: undefined,
    sizes: undefined
  };
  if (isVisible) {
    imgAttributes = generateImgAttrs({
      config: config,
      src: src,
      unoptimized: unoptimized,
      layout: layout,
      width: widthInt,
      quality: qualityInt,
      sizes: sizes,
      loader: loader
    });
  }
  var srcString = src;
  if (false) { var fullUrl; }
  var imageSrcSetPropName = "imagesrcset";
  var imageSizesPropName = "imagesizes";
  if (true) {
    imageSrcSetPropName = "imageSrcSet";
    imageSizesPropName = "imageSizes";
  }
  var _obj;
  var linkProps = (_obj = {},
  // Note: imagesrcset and imagesizes are not in the link element type with react 17.
  _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _defineProperty(_obj, "crossOrigin", rest.crossOrigin), _obj);
  var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
  var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
  var previousImageSrc = (0, _react).useRef(src);
  (0, _react).useEffect(function () {
    onLoadingCompleteRef.current = onLoadingComplete;
  }, [onLoadingComplete]);
  useLayoutEffect(function () {
    if (previousImageSrc.current !== src) {
      resetIntersected();
      previousImageSrc.current = src;
    }
  }, [resetIntersected, src]);
  var imgElementArgs = _extends({
    isLazy: isLazy,
    imgAttributes: imgAttributes,
    heightInt: heightInt,
    widthInt: widthInt,
    qualityInt: qualityInt,
    layout: layout,
    className: className,
    imgStyle: imgStyle,
    blurStyle: blurStyle,
    loading: loading,
    config: config,
    unoptimized: unoptimized,
    placeholder: placeholder,
    loader: loader,
    srcString: srcString,
    onLoadingCompleteRef: onLoadingCompleteRef,
    setBlurComplete: setBlurComplete,
    setIntersection: setIntersection,
    isVisible: isVisible,
    noscriptSizes: sizes
  }, rest);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    style: wrapperStyle
  }, hasSizer ? /*#__PURE__*/_react.default.createElement("span", {
    style: sizerStyle
  }, sizerSvgUrl ? /*#__PURE__*/_react.default.createElement("img", {
    style: {
      display: "block",
      maxWidth: "100%",
      width: "initial",
      height: "initial",
      background: "none",
      opacity: 1,
      border: 0,
      margin: 0,
      padding: 0
    },
    alt: "",
    "aria-hidden": true,
    src: sizerSvgUrl
  }) : null) : null, /*#__PURE__*/_react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ?
  // for browsers that do not support `imagesrcset`, and in those cases
  // it would likely cause the incorrect image to be preloaded.
  //
  // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
  /*#__PURE__*/
  _react.default.createElement(_head.default, null, /*#__PURE__*/_react.default.createElement("link", Object.assign({
    key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
    rel: "preload",
    as: "image",
    href: imgAttributes.srcSet ? undefined : imgAttributes.src
  }, linkProps))) : null);
}
"client";
function normalizeSrc(src) {
  return src[0] === "/" ? src.slice(1) : src;
}
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":true};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && (["lazy", "eager", undefined]));
function imgixLoader(param) {
  var config = param.config,
    src = param.src,
    width = param.width,
    quality = param.quality;
  // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
  var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
  var params = url.searchParams;
  // auto params can be combined with comma separation, or reiteration
  params.set("auto", params.getAll("auto").join(",") || "format");
  params.set("fit", params.get("fit") || "max");
  params.set("w", params.get("w") || width.toString());
  if (quality) {
    params.set("q", quality.toString());
  }
  return url.href;
}
function akamaiLoader(param) {
  var config = param.config,
    src = param.src,
    width = param.width;
  return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
  var config = param.config,
    src = param.src,
    width = param.width,
    quality = param.quality;
  // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
  var params = ["f_auto", "c_limit", "w_" + width, "q_" + (quality || "auto")];
  var paramsString = params.join(",") + "/";
  return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
  var src = param.src;
  throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
  var config = param.config,
    src = param.src,
    width = param.width,
    quality = param.quality;
  if (false) { var hasMatch, parsedSrc, missingValues; }
  if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
    // Special case to make svg serve as-is to avoid proxying
    // through the built-in Image Optimization API.
    return src;
  }
  return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
var loaders = new Map([["default", defaultLoader], ["imgix", imgixLoader], ["cloudinary", cloudinaryLoader], ["akamai", akamaiLoader], ["custom", customLoader]]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && (["fill", "fixed", "intrinsic", "responsive", undefined]));
function isStaticRequire(src) {
  return src.default !== undefined;
}
function isStaticImageData(src) {
  return src.src !== undefined;
}
function isStaticImport(src) {
  return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
  var deviceSizes = param.deviceSizes,
    allSizes = param.allSizes;
  if (sizes && (layout === "fill" || layout === "responsive")) {
    // Find all the "vw" percent sizes used in the sizes prop
    var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
    var percentSizes = [];
    for (var match; match = viewportWidthRe.exec(sizes); match) {
      percentSizes.push(parseInt(match[2]));
    }
    if (percentSizes.length) {
      var _Math;
      var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
      return {
        widths: allSizes.filter(function (s) {
          return s >= deviceSizes[0] * smallestRatio;
        }),
        kind: "w"
      };
    }
    return {
      widths: allSizes,
      kind: "w"
    };
  }
  if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
    return {
      widths: deviceSizes,
      kind: "w"
    };
  }
  var widths = _toConsumableArray(new Set(
  // > are actually 3x in the green color, but only 1.5x in the red and
  // > blue colors. Showing a 3x resolution image in the app vs a 2x
  // > resolution image will be visually the same, though the 3x image
  // > takes significantly more data. Even true 3x resolution screens are
  // > wasteful as the human eye cannot see that level of detail without
  // > something like a magnifying glass.
  // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
  [width, width * 2 /*, width * 3*/].map(function (w) {
    return allSizes.find(function (p) {
      return p >= w;
    }) || allSizes[allSizes.length - 1];
  })));
  return {
    widths: widths,
    kind: "x"
  };
}
function generateImgAttrs(param) {
  var config = param.config,
    src = param.src,
    unoptimized = param.unoptimized,
    layout = param.layout,
    width = param.width,
    quality = param.quality,
    sizes = param.sizes,
    loader = param.loader;
  if (unoptimized) {
    return {
      src: src,
      srcSet: undefined,
      sizes: undefined
    };
  }
  var ref = getWidths(config, width, layout, sizes),
    widths = ref.widths,
    kind = ref.kind;
  var last = widths.length - 1;
  return {
    sizes: !sizes && kind === "w" ? "100vw" : sizes,
    srcSet: widths.map(function (w, i) {
      return "".concat(loader({
        config: config,
        src: src,
        quality: quality,
        width: w
      }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
    }).join(", "),
    // It's intended to keep `src` the last attribute because React updates
    // attributes in order. If we keep `src` the first one, Safari will
    // immediately start to fetch `src`, before `sizes` and `srcSet` are even
    // updated by React. That causes multiple unnecessary requests if `srcSet`
    // and `sizes` are defined.
    // This bug cannot be reproduced in Chrome or Firefox.
    src: loader({
      config: config,
      src: src,
      quality: quality,
      width: widths[last]
    })
  };
}
function getInt(x) {
  if (typeof x === "number") {
    return x;
  }
  if (typeof x === "string") {
    return parseInt(x, 10);
  }
  return undefined;
}
function defaultImageLoader(loaderProps) {
  var ref;
  var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
  var load = loaders.get(loaderKey);
  if (load) {
    return load(loaderProps);
  }
  throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
  if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
    return;
  }
  img["data-loaded-src"] = src;
  var p = "decode" in img ? img.decode() : Promise.resolve();
  p.catch(function () {}).then(function () {
    if (!img.parentNode) {
      // Exit early in case of race condition:
      // - onload() is called
      // - decode() is called but incomplete
      // - unmount is called
      // - decode() completes
      return;
    }
    loadedImageURLs.add(src);
    if (placeholder === "blur") {
      setBlurComplete(true);
    }
    if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
      var naturalWidth = img.naturalWidth,
        naturalHeight = img.naturalHeight;
      // Pass back read-only primitive values but not the
      // underlying DOM element because it could be misused.
      onLoadingCompleteRef.current({
        naturalWidth: naturalWidth,
        naturalHeight: naturalHeight
      });
    }
    if (false) { var parent, ref; }
  });
}
var ImageElement = function (_param) {
  var imgAttributes = _param.imgAttributes,
    heightInt = _param.heightInt,
    widthInt = _param.widthInt,
    qualityInt = _param.qualityInt,
    layout = _param.layout,
    className = _param.className,
    imgStyle = _param.imgStyle,
    blurStyle = _param.blurStyle,
    isLazy = _param.isLazy,
    placeholder = _param.placeholder,
    loading = _param.loading,
    srcString = _param.srcString,
    config = _param.config,
    unoptimized = _param.unoptimized,
    loader = _param.loader,
    onLoadingCompleteRef = _param.onLoadingCompleteRef,
    setBlurComplete = _param.setBlurComplete,
    setIntersection = _param.setIntersection,
    onLoad = _param.onLoad,
    onError = _param.onError,
    isVisible = _param.isVisible,
    noscriptSizes = _param.noscriptSizes,
    rest = _object_without_properties_loose(_param, ["imgAttributes", "heightInt", "widthInt", "qualityInt", "layout", "className", "imgStyle", "blurStyle", "isLazy", "placeholder", "loading", "srcString", "config", "unoptimized", "loader", "onLoadingCompleteRef", "setBlurComplete", "setIntersection", "onLoad", "onError", "isVisible", "noscriptSizes"]);
  loading = isLazy ? "lazy" : loading;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
    decoding: "async",
    "data-nimg": layout,
    className: className,
    style: _extends({}, imgStyle, blurStyle),
    ref: (0, _react).useCallback(function (img) {
      if (false) {}
      setIntersection(img);
      if (img == null ? void 0 : img.complete) {
        handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
      }
    }, [setIntersection, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete]),
    onLoad: function (event) {
      var img = event.currentTarget;
      handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
      if (onLoad) {
        onLoad(event);
      }
    },
    onError: function (event) {
      if (placeholder === "blur") {
        // If the real image fails to load, this will still remove the placeholder.
        setBlurComplete(true);
      }
      if (onError) {
        onError(event);
      }
    }
  })), (isLazy || placeholder === "blur") && /*#__PURE__*/_react.default.createElement("noscript", null, /*#__PURE__*/_react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
    config: config,
    src: srcString,
    unoptimized: unoptimized,
    layout: layout,
    width: widthInt,
    quality: qualityInt,
    sizes: noscriptSizes,
    loader: loader
  }), {
    decoding: "async",
    "data-nimg": layout,
    style: imgStyle,
    className: className,
    // @ts-ignore - TODO: upgrade to `@types/react@17`
    loading: loading
  }))));
};
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
  Object.defineProperty(exports.default, "__esModule", {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
} //# sourceMappingURL=image.js.map

/***/ }),

/***/ 94580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var _slicedToArray = (__webpack_require__(92304)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(25125)["default"]);
"client";
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(4858)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(84315)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(82684));
var _router = __webpack_require__(85921);
var _addLocale = __webpack_require__(4079);
var _routerContext = __webpack_require__(3343);
var _appRouterContext = __webpack_require__(5566);
var _useIntersection = __webpack_require__(43973);
var _getDomainLocale = __webpack_require__(96378);
var _addBasePath = __webpack_require__(2774);
"client";
var prefetched = {};
function prefetch(router, href, as, options) {
  if ( false || !router) return;
  if (!(0, _router).isLocalURL(href)) return;
  // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch
  Promise.resolve(router.prefetch(href, as, options)).catch(function (err) {
    if (false) {}
  });
  var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
  // Join on an invalid URI character
  prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
  var nodeName = e.currentTarget.nodeName;
  // anchors inside an svg have a lowercase nodeName
  var isAnchorNodeName = nodeName.toUpperCase() === "A";
  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }
  e.preventDefault();
  var navigate = function () {
    // If the router is an NextRouter instance it will have `beforePopState`
    if ("beforePopState" in router) {
      router[replace ? "replace" : "push"](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
      });
    } else {
      // If `beforePopState` doesn't exist on the router it's the AppRouter.
      var method = replace ? "replace" : "push";
      router[method](href, {
        forceOptimisticNavigation: !prefetchEnabled
      });
    }
  };
  if (isAppRouter) {
    // @ts-expect-error startTransition exists.
    _react.default.startTransition(navigate);
  } else {
    navigate();
  }
}
var Link = /*#__PURE__*/_react.default.forwardRef(function LinkComponent(props, forwardedRef) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
  var children;
  var hrefProp = props.href,
    asProp = props.as,
    childrenProp = props.children,
    prefetchProp = props.prefetch,
    passHref = props.passHref,
    replace = props.replace,
    shallow = props.shallow,
    scroll = props.scroll,
    locale = props.locale,
    onClick = props.onClick,
    onMouseEnter = props.onMouseEnter,
    onTouchStart = props.onTouchStart,
    _legacyBehavior = props.legacyBehavior,
    legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior,
    restProps = _object_without_properties_loose(props, ["href", "as", "children", "prefetch", "passHref", "replace", "shallow", "scroll", "locale", "onClick", "onMouseEnter", "onTouchStart", "legacyBehavior"]);
  children = childrenProp;
  if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
    children = /*#__PURE__*/_react.default.createElement("a", null, children);
  }
  var p = prefetchProp !== false;
  var router = _react.default.useContext(_routerContext.RouterContext);
  // TODO-APP: type error. Remove `as any`
  var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
  if (appRouter) {
    router = appRouter;
  }
  var ref = _react.default.useMemo(function () {
      var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2),
        resolvedHref = ref[0],
        resolvedAs = ref[1];
      return {
        href: resolvedHref,
        as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
      };
    }, [router, hrefProp, asProp]),
    href = ref.href,
    as = ref.as;
  var previousHref = _react.default.useRef(href);
  var previousAs = _react.default.useRef(as);
  // This will return the first child, if multiple are provided it will throw an error
  var child;
  if (legacyBehavior) {
    if (false) {} else {
      child = _react.default.Children.only(children);
    }
  }
  var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
  var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
      rootMargin: "200px"
    }), 3),
    setIntersectionRef = ref1[0],
    isVisible = ref1[1],
    resetVisible = ref1[2];
  var setRef = _react.default.useCallback(function (el) {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }
    setIntersectionRef(el);
    if (childRef) {
      if (typeof childRef === "function") childRef(el);else if (typeof childRef === "object") {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]);
  _react.default.useEffect(function () {
    var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
    var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
    var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);
  var childProps = {
    ref: setRef,
    onClick: function (e) {
      if (false) {}
      if (!legacyBehavior && typeof onClick === "function") {
        onClick(e);
      }
      if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
        child.props.onClick(e);
      }
      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
      }
    },
    onMouseEnter: function (e) {
      if (!legacyBehavior && typeof onMouseEnter === "function") {
        onMouseEnter(e);
      }
      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
        child.props.onMouseEnter(e);
      }
      // Check for not prefetch disabled in page using appRouter
      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    },
    onTouchStart: function (e) {
      if (!legacyBehavior && typeof onTouchStart === "function") {
        onTouchStart(e);
      }
      if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
        child.props.onTouchStart(e);
      }
      // Check for not prefetch disabled in page using appRouter
      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    }
  };
  // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user
  if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
    var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
    // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs
    var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
    childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
  }
  return legacyBehavior ? /*#__PURE__*/_react.default.cloneElement(child, childProps) : /*#__PURE__*/_react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
  Object.defineProperty(exports.default, "__esModule", {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
} //# sourceMappingURL=link.js.map

/***/ }),

/***/ 43973:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var _slicedToArray = (__webpack_require__(92304)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(82684);
var _requestIdleCallback = __webpack_require__(67876);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
  var id = {
    root: options.root || null,
    margin: options.rootMargin || ""
  };
  var existing = idList.find(function (obj) {
    return obj.root === id.root && obj.margin === id.margin;
  });
  var instance;
  if (existing) {
    instance = observers.get(existing);
    if (instance) {
      return instance;
    }
  }
  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  instance = {
    id: id,
    observer: observer,
    elements: elements
  };
  idList.push(id);
  observers.set(id, instance);
  return instance;
}
function observe(element, callback, options) {
  var ref = createObserver(options),
    id = ref.id,
    observer = ref.observer,
    elements = ref.elements;
  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    elements.delete(element);
    observer.unobserve(element);
    // Destroy observer when there's nothing left to watch:
    if (elements.size === 0) {
      observer.disconnect();
      observers.delete(id);
      var index = idList.findIndex(function (obj) {
        return obj.root === id.root && obj.margin === id.margin;
      });
      if (index > -1) {
        idList.splice(index, 1);
      }
    }
  };
}
function useIntersection(param) {
  var rootRef = param.rootRef,
    rootMargin = param.rootMargin,
    disabled = param.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;
  var ref = _slicedToArray((0, _react).useState(false), 2),
    visible = ref[0],
    setVisible = ref[1];
  var ref1 = _slicedToArray((0, _react).useState(null), 2),
    element = ref1[0],
    setElement = ref1[1];
  (0, _react).useEffect(function () {
    if (hasIntersectionObserver) {
      if (isDisabled || visible) return;
      if (element && element.tagName) {
        var unobserve = observe(element, function (isVisible) {
          return isVisible && setVisible(isVisible);
        }, {
          root: rootRef == null ? void 0 : rootRef.current,
          rootMargin: rootMargin
        });
        return unobserve;
      }
    } else {
      if (!visible) {
        var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function () {
          return setVisible(true);
        });
        return function () {
          return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
        };
      }
    }
  }, [element, isDisabled, rootMargin, rootRef, visible]);
  var resetVisible = (0, _react).useCallback(function () {
    setVisible(false);
  }, []);
  return [setElement, visible, resetVisible];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
  Object.defineProperty(exports.default, "__esModule", {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map

/***/ }),

/***/ 5566:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(4858)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(82684));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
var TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map

/***/ }),

/***/ 57867:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var _instanceof = (__webpack_require__(53778)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(54363)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(4858)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(82684));
var _loadable = _interop_require_default(__webpack_require__(8450));
function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable.default;
  var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
    // A loading component is not required, so we default it
    loading: function (param) {
      var error = param.error,
        isLoading = param.isLoading,
        pastDelay = param.pastDelay;
      if (!pastDelay) return null;
      if (false) {}
      return null;
    }
  };
  // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first
  if (_instanceof(dynamicOptions, Promise)) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
  } else if (typeof dynamicOptions === "function") {
    loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === "object") {
    loadableOptions = _extends({}, loadableOptions, dynamicOptions);
  }
  // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
  loadableOptions = _extends({}, loadableOptions, options);
  // Error if Fizz rendering is not enabled and `suspense` option is set to true
  if (false) {}
  if (loadableOptions.suspense) {
    if (false) {}
    delete loadableOptions.ssr;
    delete loadableOptions.loading;
  }
  // coming from build/babel/plugins/react-loadable-plugin.js
  if (loadableOptions.loadableGenerated) {
    loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  }
  // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
  // skip `ssr` for suspense mode and opt-in React.lazy directly
  if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }
    delete loadableOptions.ssr;
  }
  return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules;
  // This check is necessary to prevent react-loadable from initializing on the server
  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }
  var Loading = loadableOptions.loading;
  // This will only be rendered on the server side
  return function () {
    return /*#__PURE__*/_react.default.createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
  Object.defineProperty(exports.default, "__esModule", {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map

/***/ }),

/***/ 96552:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getImageBlurSvg = getImageBlurSvg;
function getImageBlurSvg(param) {
  var widthInt = param.widthInt,
    heightInt = param.heightInt,
    blurWidth = param.blurWidth,
    blurHeight = param.blurHeight,
    blurDataURL = param.blurDataURL;
  var std = blurWidth && blurHeight ? "1" : "20";
  var svgWidth = blurWidth || widthInt;
  var svgHeight = blurHeight || heightInt;
  var feComponentTransfer = blurDataURL.startsWith("data:image/jpeg") ? "%3CfeComponentTransfer%3E%3CfeFuncA type='discrete' tableValues='1 1'/%3E%3C/feComponentTransfer%3E%" : "";
  return "%3Csvg xmlns='http%3A//www.w3.org/2000/svg' viewBox='0 0 ".concat(svgWidth, " ").concat(svgHeight, "'%3E%3Cfilter id='b' color-interpolation-filters='sRGB'%3E%3CfeGaussianBlur stdDeviation='").concat(std, "'/%3E").concat(feComponentTransfer, "%3C/filter%3E%3Cimage filter='url(%23b)' x='0' y='0' height='100%25' width='100%25' href='").concat(blurDataURL, "'/%3E%3C/svg%3E");
} //# sourceMappingURL=image-blur-svg.js.map

/***/ }),

/***/ 18546:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(4858)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(82684));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map

/***/ }),

/***/ 8450:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var _classCallCheck = (__webpack_require__(13749)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(52336)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(54363)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(4858)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(82684));
var _loadableContext = __webpack_require__(18546);
var useSyncExternalStore = ( true ? __webpack_require__(82684) : 0).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  }).catch(function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}
function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
  var init = function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }
    return subscription.promise();
  };
  var useLoadableModule = function useLoadableModule() {
    init();
    var context = _react.default.useContext(_loadableContext.LoadableContext);
    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }
  };
  var LoadableImpl = function LoadableImpl(props, ref) {
    useLoadableModule();
    var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
    _react.default.useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);
    return _react.default.useMemo(function () {
      if (state.loading || state.error) {
        return _react.default.createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return _react.default.createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [props, state]);
  };
  var LazyImpl = function LazyImpl(props, ref) {
    useLoadableModule();
    return _react.default.createElement(opts.lazy, _extends({}, props, {
      ref: ref
    }));
  };
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false
  }, options);
  if (opts.suspense) {
    opts.lazy = _react.default.lazy(opts.loader);
  }
  /** @type LoadableSubscription */
  var subscription = null;
  // Server only
  if (false) {}
  // Client only
  if (!initialized && "object" !== "undefined") {
    // require.resolveWeak check is needed for environments that don't have it available like Jest
    var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
    if (moduleIds) {
      READY_INITIALIZERS.push(function (ids) {
        var _iteratorNormalCompletion = true,
          _didIteratorError = false,
          _iteratorError = undefined;
        try {
          for (var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var moduleId = _step.value;
            if (ids.indexOf(moduleId) !== -1) {
              return init();
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }
  }
  var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
  LoadableComponent.preload = function () {
    return init();
  };
  LoadableComponent.displayName = "LoadableComponent";
  return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);
    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }
  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;
      this._clearTimeouts();
      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var ref = this,
        res = ref._res,
        opts = ref._opts;
      if (res.loading) {
        if (typeof opts.delay === "number") {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }
        if (typeof opts.timeout === "number") {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }
      this._res.promise.then(function () {
        _this._update({});
        _this._clearTimeouts();
      }).catch(function (_err) {
        _this._update({});
        _this._clearTimeouts();
      });
      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _extends({}, this._state, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);
      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this = this;
      this._callbacks.add(callback);
      return function () {
        _this._callbacks.delete(callback);
      };
    }
  }]);
  return LoadableSubscription;
}();
function Loadable(opts) {
  return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
  var promises = [];
  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }
  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}
Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};
Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function () {
      initialized = true;
      return resolvePreload();
    };
    // We always will resolve, errors should be handled within loading UIs.
    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};
if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map

/***/ }),

/***/ 51774:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(57867);

/***/ }),

/***/ 78903:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3092);

/***/ }),

/***/ 60071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(30824);

/***/ }),

/***/ 12691:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(94580);

/***/ }),

/***/ 34376:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(73053);

/***/ }),

/***/ 80599:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(this, function () {
  /************************************
      Variables
  ************************************/

  var numeral,
    _,
    VERSION = '2.0.6',
    formats = {},
    locales = {},
    defaults = {
      currentLocale: 'en',
      zeroFormat: null,
      nullFormat: null,
      defaultFormat: '0,0',
      scalePercentBy100: true
    },
    options = {
      currentLocale: defaults.currentLocale,
      zeroFormat: defaults.zeroFormat,
      nullFormat: defaults.nullFormat,
      defaultFormat: defaults.defaultFormat,
      scalePercentBy100: defaults.scalePercentBy100
    };

  /************************************
      Constructors
  ************************************/

  // Numeral prototype object
  function Numeral(input, number) {
    this._input = input;
    this._value = number;
  }
  numeral = function (input) {
    var value, kind, unformatFunction, regexp;
    if (numeral.isNumeral(input)) {
      value = input.value();
    } else if (input === 0 || typeof input === 'undefined') {
      value = 0;
    } else if (input === null || _.isNaN(input)) {
      value = null;
    } else if (typeof input === 'string') {
      if (options.zeroFormat && input === options.zeroFormat) {
        value = 0;
      } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
        value = null;
      } else {
        for (kind in formats) {
          regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
          if (regexp && input.match(regexp)) {
            unformatFunction = formats[kind].unformat;
            break;
          }
        }
        unformatFunction = unformatFunction || numeral._.stringToNumber;
        value = unformatFunction(input);
      }
    } else {
      value = Number(input) || null;
    }
    return new Numeral(input, value);
  };

  // version number
  numeral.version = VERSION;

  // compare numeral object
  numeral.isNumeral = function (obj) {
    return obj instanceof Numeral;
  };

  // helper functions
  numeral._ = _ = {
    // formats numbers separators, decimals places, signs, abbreviations
    numberToFormat: function (value, format, roundingFunction) {
      var locale = locales[numeral.options.currentLocale],
        negP = false,
        optDec = false,
        leadingCount = 0,
        abbr = '',
        trillion = 1000000000000,
        billion = 1000000000,
        million = 1000000,
        thousand = 1000,
        decimal = '',
        neg = false,
        abbrForce,
        // force abbreviation
        abs,
        min,
        max,
        power,
        int,
        precision,
        signed,
        thousands,
        output;

      // make sure we never format a null value
      value = value || 0;
      abs = Math.abs(value);

      // see if we should use parentheses for negative number or if we should prefix with a sign
      // if both are present we default to parentheses
      if (numeral._.includes(format, '(')) {
        negP = true;
        format = format.replace(/[\(|\)]/g, '');
      } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
        signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
        format = format.replace(/[\+|\-]/g, '');
      }

      // see if abbreviation is wanted
      if (numeral._.includes(format, 'a')) {
        abbrForce = format.match(/a(k|m|b|t)?/);
        abbrForce = abbrForce ? abbrForce[1] : false;

        // check for space before abbreviation
        if (numeral._.includes(format, ' a')) {
          abbr = ' ';
        }
        format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
        if (abs >= trillion && !abbrForce || abbrForce === 't') {
          // trillion
          abbr += locale.abbreviations.trillion;
          value = value / trillion;
        } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
          // billion
          abbr += locale.abbreviations.billion;
          value = value / billion;
        } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
          // million
          abbr += locale.abbreviations.million;
          value = value / million;
        } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
          // thousand
          abbr += locale.abbreviations.thousand;
          value = value / thousand;
        }
      }

      // check for optional decimals
      if (numeral._.includes(format, '[.]')) {
        optDec = true;
        format = format.replace('[.]', '.');
      }

      // break number and format
      int = value.toString().split('.')[0];
      precision = format.split('.')[1];
      thousands = format.indexOf(',');
      leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;
      if (precision) {
        if (numeral._.includes(precision, '[')) {
          precision = precision.replace(']', '');
          precision = precision.split('[');
          decimal = numeral._.toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
        } else {
          decimal = numeral._.toFixed(value, precision.length, roundingFunction);
        }
        int = decimal.split('.')[0];
        if (numeral._.includes(decimal, '.')) {
          decimal = locale.delimiters.decimal + decimal.split('.')[1];
        } else {
          decimal = '';
        }
        if (optDec && Number(decimal.slice(1)) === 0) {
          decimal = '';
        }
      } else {
        int = numeral._.toFixed(value, 0, roundingFunction);
      }

      // check abbreviation again after rounding
      if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
        int = String(Number(int) / 1000);
        switch (abbr) {
          case locale.abbreviations.thousand:
            abbr = locale.abbreviations.million;
            break;
          case locale.abbreviations.million:
            abbr = locale.abbreviations.billion;
            break;
          case locale.abbreviations.billion:
            abbr = locale.abbreviations.trillion;
            break;
        }
      }

      // format number
      if (numeral._.includes(int, '-')) {
        int = int.slice(1);
        neg = true;
      }
      if (int.length < leadingCount) {
        for (var i = leadingCount - int.length; i > 0; i--) {
          int = '0' + int;
        }
      }
      if (thousands > -1) {
        int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
      }
      if (format.indexOf('.') === 0) {
        int = '';
      }
      output = int + decimal + (abbr ? abbr : '');
      if (negP) {
        output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
      } else {
        if (signed >= 0) {
          output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
        } else if (neg) {
          output = '-' + output;
        }
      }
      return output;
    },
    // unformats numbers separators, decimals places, signs, abbreviations
    stringToNumber: function (string) {
      var locale = locales[options.currentLocale],
        stringOriginal = string,
        abbreviations = {
          thousand: 3,
          million: 6,
          billion: 9,
          trillion: 12
        },
        abbreviation,
        value,
        i,
        regexp;
      if (options.zeroFormat && string === options.zeroFormat) {
        value = 0;
      } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
        value = null;
      } else {
        value = 1;
        if (locale.delimiters.decimal !== '.') {
          string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
        }
        for (abbreviation in abbreviations) {
          regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
          if (stringOriginal.match(regexp)) {
            value *= Math.pow(10, abbreviations[abbreviation]);
            break;
          }
        }

        // check for negative number
        value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

        // remove non numbers
        string = string.replace(/[^0-9\.]+/g, '');
        value *= Number(string);
      }
      return value;
    },
    isNaN: function (value) {
      return typeof value === 'number' && isNaN(value);
    },
    includes: function (string, search) {
      return string.indexOf(search) !== -1;
    },
    insert: function (string, subString, start) {
      return string.slice(0, start) + subString + string.slice(start);
    },
    reduce: function (array, callback /*, initialValue*/) {
      if (this === null) {
        throw new TypeError('Array.prototype.reduce called on null or undefined');
      }
      if (typeof callback !== 'function') {
        throw new TypeError(callback + ' is not a function');
      }
      var t = Object(array),
        len = t.length >>> 0,
        k = 0,
        value;
      if (arguments.length === 3) {
        value = arguments[2];
      } else {
        while (k < len && !(k in t)) {
          k++;
        }
        if (k >= len) {
          throw new TypeError('Reduce of empty array with no initial value');
        }
        value = t[k++];
      }
      for (; k < len; k++) {
        if (k in t) {
          value = callback(value, t[k], k, t);
        }
      }
      return value;
    },
    /**
     * Computes the multiplier necessary to make x >= 1,
     * effectively eliminating miscalculations caused by
     * finite precision.
     */
    multiplier: function (x) {
      var parts = x.toString().split('.');
      return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
    },
    /**
     * Given a variable number of arguments, returns the maximum
     * multiplier that must be used to normalize an operation involving
     * all of them.
     */
    correctionFactor: function () {
      var args = Array.prototype.slice.call(arguments);
      return args.reduce(function (accum, next) {
        var mn = _.multiplier(next);
        return accum > mn ? accum : mn;
      }, 1);
    },
    /**
     * Implementation of toFixed() that treats floats more like decimals
     *
     * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
     * problems for accounting- and finance-related software.
     */
    toFixed: function (value, maxDecimals, roundingFunction, optionals) {
      var splitValue = value.toString().split('.'),
        minDecimals = maxDecimals - (optionals || 0),
        boundedPrecision,
        optionalsRegExp,
        power,
        output;

      // Use the smallest precision value possible to avoid errors from floating point representation
      if (splitValue.length === 2) {
        boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
      } else {
        boundedPrecision = minDecimals;
      }
      power = Math.pow(10, boundedPrecision);

      // Multiply up by precision, round accurately, then divide and use native toFixed():
      output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);
      if (optionals > maxDecimals - boundedPrecision) {
        optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
        output = output.replace(optionalsRegExp, '');
      }
      return output;
    }
  };

  // avaliable options
  numeral.options = options;

  // avaliable formats
  numeral.formats = formats;

  // avaliable formats
  numeral.locales = locales;

  // This function sets the current locale.  If
  // no arguments are passed in, it will simply return the current global
  // locale key.
  numeral.locale = function (key) {
    if (key) {
      options.currentLocale = key.toLowerCase();
    }
    return options.currentLocale;
  };

  // This function provides access to the loaded locale data.  If
  // no arguments are passed in, it will simply return the current
  // global locale object.
  numeral.localeData = function (key) {
    if (!key) {
      return locales[options.currentLocale];
    }
    key = key.toLowerCase();
    if (!locales[key]) {
      throw new Error('Unknown locale : ' + key);
    }
    return locales[key];
  };
  numeral.reset = function () {
    for (var property in defaults) {
      options[property] = defaults[property];
    }
  };
  numeral.zeroFormat = function (format) {
    options.zeroFormat = typeof format === 'string' ? format : null;
  };
  numeral.nullFormat = function (format) {
    options.nullFormat = typeof format === 'string' ? format : null;
  };
  numeral.defaultFormat = function (format) {
    options.defaultFormat = typeof format === 'string' ? format : '0.0';
  };
  numeral.register = function (type, name, format) {
    name = name.toLowerCase();
    if (this[type + 's'][name]) {
      throw new TypeError(name + ' ' + type + ' already registered.');
    }
    this[type + 's'][name] = format;
    return format;
  };
  numeral.validate = function (val, culture) {
    var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, localeData, temp;

    //coerce val to string
    if (typeof val !== 'string') {
      val += '';
      if (console.warn) {
        console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
      }
    }

    //trim whitespaces from either sides
    val = val.trim();

    //if val is just digits return true
    if (!!val.match(/^\d+$/)) {
      return true;
    }

    //if val is empty return false
    if (val === '') {
      return false;
    }

    //get the decimal and thousands separator from numeral.localeData
    try {
      //check if the culture is understood by numeral. if not, default it to current locale
      localeData = numeral.localeData(culture);
    } catch (e) {
      localeData = numeral.localeData(numeral.locale());
    }

    //setup the delimiters and currency symbol based on culture/locale
    _currSymbol = localeData.currency.symbol;
    _abbrObj = localeData.abbreviations;
    _decimalSep = localeData.delimiters.decimal;
    if (localeData.delimiters.thousands === '.') {
      _thousandSep = '\\.';
    } else {
      _thousandSep = localeData.delimiters.thousands;
    }

    // validating currency symbol
    temp = val.match(/^[^\d]+/);
    if (temp !== null) {
      val = val.substr(1);
      if (temp[0] !== _currSymbol) {
        return false;
      }
    }

    //validating abbreviation symbol
    temp = val.match(/[^\d]+$/);
    if (temp !== null) {
      val = val.slice(0, -1);
      if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
        return false;
      }
    }
    _thousandRegEx = new RegExp(_thousandSep + '{2}');
    if (!val.match(/[^\d.,]/g)) {
      _valArray = val.split(_decimalSep);
      if (_valArray.length > 2) {
        return false;
      } else {
        if (_valArray.length < 2) {
          return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
        } else {
          if (_valArray[0].length === 1) {
            return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
          } else {
            return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
          }
        }
      }
    }
    return false;
  };

  /************************************
      Numeral Prototype
  ************************************/

  numeral.fn = Numeral.prototype = {
    clone: function () {
      return numeral(this);
    },
    format: function (inputString, roundingFunction) {
      var value = this._value,
        format = inputString || options.defaultFormat,
        kind,
        output,
        formatFunction;

      // make sure we have a roundingFunction
      roundingFunction = roundingFunction || Math.round;

      // format based on value
      if (value === 0 && options.zeroFormat !== null) {
        output = options.zeroFormat;
      } else if (value === null && options.nullFormat !== null) {
        output = options.nullFormat;
      } else {
        for (kind in formats) {
          if (format.match(formats[kind].regexps.format)) {
            formatFunction = formats[kind].format;
            break;
          }
        }
        formatFunction = formatFunction || numeral._.numberToFormat;
        output = formatFunction(value, format, roundingFunction);
      }
      return output;
    },
    value: function () {
      return this._value;
    },
    input: function () {
      return this._input;
    },
    set: function (value) {
      this._value = Number(value);
      return this;
    },
    add: function (value) {
      var corrFactor = _.correctionFactor.call(null, this._value, value);
      function cback(accum, curr, currI, O) {
        return accum + Math.round(corrFactor * curr);
      }
      this._value = _.reduce([this._value, value], cback, 0) / corrFactor;
      return this;
    },
    subtract: function (value) {
      var corrFactor = _.correctionFactor.call(null, this._value, value);
      function cback(accum, curr, currI, O) {
        return accum - Math.round(corrFactor * curr);
      }
      this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;
      return this;
    },
    multiply: function (value) {
      function cback(accum, curr, currI, O) {
        var corrFactor = _.correctionFactor(accum, curr);
        return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
      }
      this._value = _.reduce([this._value, value], cback, 1);
      return this;
    },
    divide: function (value) {
      function cback(accum, curr, currI, O) {
        var corrFactor = _.correctionFactor(accum, curr);
        return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
      }
      this._value = _.reduce([this._value, value], cback);
      return this;
    },
    difference: function (value) {
      return Math.abs(numeral(this._value).subtract(value).value());
    }
  };

  /************************************
      Default Locale && Format
  ************************************/

  numeral.register('locale', 'en', {
    delimiters: {
      thousands: ',',
      decimal: '.'
    },
    abbreviations: {
      thousand: 'k',
      million: 'm',
      billion: 'b',
      trillion: 't'
    },
    ordinal: function (number) {
      var b = number % 10;
      return ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
    },
    currency: {
      symbol: '$'
    }
  });
  (function () {
    numeral.register('format', 'bps', {
      regexps: {
        format: /(BPS)/,
        unformat: /(BPS)/
      },
      format: function (value, format, roundingFunction) {
        var space = numeral._.includes(format, ' BPS') ? ' ' : '',
          output;
        value = value * 10000;

        // check for space before BPS
        format = format.replace(/\s?BPS/, '');
        output = numeral._.numberToFormat(value, format, roundingFunction);
        if (numeral._.includes(output, ')')) {
          output = output.split('');
          output.splice(-1, 0, space + 'BPS');
          output = output.join('');
        } else {
          output = output + space + 'BPS';
        }
        return output;
      },
      unformat: function (string) {
        return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
      }
    });
  })();
  (function () {
    var decimal = {
        base: 1000,
        suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      },
      binary = {
        base: 1024,
        suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
      };
    var allSuffixes = decimal.suffixes.concat(binary.suffixes.filter(function (item) {
      return decimal.suffixes.indexOf(item) < 0;
    }));
    var unformatRegex = allSuffixes.join('|');
    // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
    unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';
    numeral.register('format', 'bytes', {
      regexps: {
        format: /([0\s]i?b)/,
        unformat: new RegExp(unformatRegex)
      },
      format: function (value, format, roundingFunction) {
        var output,
          bytes = numeral._.includes(format, 'ib') ? binary : decimal,
          suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
          power,
          min,
          max;

        // check for space before
        format = format.replace(/\s?i?b/, '');
        for (power = 0; power <= bytes.suffixes.length; power++) {
          min = Math.pow(bytes.base, power);
          max = Math.pow(bytes.base, power + 1);
          if (value === null || value === 0 || value >= min && value < max) {
            suffix += bytes.suffixes[power];
            if (min > 0) {
              value = value / min;
            }
            break;
          }
        }
        output = numeral._.numberToFormat(value, format, roundingFunction);
        return output + suffix;
      },
      unformat: function (string) {
        var value = numeral._.stringToNumber(string),
          power,
          bytesMultiplier;
        if (value) {
          for (power = decimal.suffixes.length - 1; power >= 0; power--) {
            if (numeral._.includes(string, decimal.suffixes[power])) {
              bytesMultiplier = Math.pow(decimal.base, power);
              break;
            }
            if (numeral._.includes(string, binary.suffixes[power])) {
              bytesMultiplier = Math.pow(binary.base, power);
              break;
            }
          }
          value *= bytesMultiplier || 1;
        }
        return value;
      }
    });
  })();
  (function () {
    numeral.register('format', 'currency', {
      regexps: {
        format: /(\$)/
      },
      format: function (value, format, roundingFunction) {
        var locale = numeral.locales[numeral.options.currentLocale],
          symbols = {
            before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
            after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
          },
          output,
          symbol,
          i;

        // strip format of spaces and $
        format = format.replace(/\s?\$\s?/, '');

        // format the number
        output = numeral._.numberToFormat(value, format, roundingFunction);

        // update the before and after based on value
        if (value >= 0) {
          symbols.before = symbols.before.replace(/[\-\(]/, '');
          symbols.after = symbols.after.replace(/[\-\)]/, '');
        } else if (value < 0 && !numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '(')) {
          symbols.before = '-' + symbols.before;
        }

        // loop through each before symbol
        for (i = 0; i < symbols.before.length; i++) {
          symbol = symbols.before[i];
          switch (symbol) {
            case '$':
              output = numeral._.insert(output, locale.currency.symbol, i);
              break;
            case ' ':
              output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
              break;
          }
        }

        // loop through each after symbol
        for (i = symbols.after.length - 1; i >= 0; i--) {
          symbol = symbols.after[i];
          switch (symbol) {
            case '$':
              output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
              break;
            case ' ':
              output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
              break;
          }
        }
        return output;
      }
    });
  })();
  (function () {
    numeral.register('format', 'exponential', {
      regexps: {
        format: /(e\+|e-)/,
        unformat: /(e\+|e-)/
      },
      format: function (value, format, roundingFunction) {
        var output,
          exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
          parts = exponential.split('e');
        format = format.replace(/e[\+|\-]{1}0/, '');
        output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
        return output + 'e' + parts[1];
      },
      unformat: function (string) {
        var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
          value = Number(parts[0]),
          power = Number(parts[1]);
        power = numeral._.includes(string, 'e-') ? power *= -1 : power;
        function cback(accum, curr, currI, O) {
          var corrFactor = numeral._.correctionFactor(accum, curr),
            num = accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
          return num;
        }
        return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
      }
    });
  })();
  (function () {
    numeral.register('format', 'ordinal', {
      regexps: {
        format: /(o)/
      },
      format: function (value, format, roundingFunction) {
        var locale = numeral.locales[numeral.options.currentLocale],
          output,
          ordinal = numeral._.includes(format, ' o') ? ' ' : '';

        // check for space before
        format = format.replace(/\s?o/, '');
        ordinal += locale.ordinal(value);
        output = numeral._.numberToFormat(value, format, roundingFunction);
        return output + ordinal;
      }
    });
  })();
  (function () {
    numeral.register('format', 'percentage', {
      regexps: {
        format: /(%)/,
        unformat: /(%)/
      },
      format: function (value, format, roundingFunction) {
        var space = numeral._.includes(format, ' %') ? ' ' : '',
          output;
        if (numeral.options.scalePercentBy100) {
          value = value * 100;
        }

        // check for space before %
        format = format.replace(/\s?\%/, '');
        output = numeral._.numberToFormat(value, format, roundingFunction);
        if (numeral._.includes(output, ')')) {
          output = output.split('');
          output.splice(-1, 0, space + '%');
          output = output.join('');
        } else {
          output = output + space + '%';
        }
        return output;
      },
      unformat: function (string) {
        var number = numeral._.stringToNumber(string);
        if (numeral.options.scalePercentBy100) {
          return number * 0.01;
        }
        return number;
      }
    });
  })();
  (function () {
    numeral.register('format', 'time', {
      regexps: {
        format: /(:)/,
        unformat: /(:)/
      },
      format: function (value, format, roundingFunction) {
        var hours = Math.floor(value / 60 / 60),
          minutes = Math.floor((value - hours * 60 * 60) / 60),
          seconds = Math.round(value - hours * 60 * 60 - minutes * 60);
        return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
      },
      unformat: function (string) {
        var timeArray = string.split(':'),
          seconds = 0;

        // turn hours and minutes into seconds and add them all up
        if (timeArray.length === 3) {
          // hours
          seconds = seconds + Number(timeArray[0]) * 60 * 60;
          // minutes
          seconds = seconds + Number(timeArray[1]) * 60;
          // seconds
          seconds = seconds + Number(timeArray[2]);
        } else if (timeArray.length === 2) {
          // minutes
          seconds = seconds + Number(timeArray[0]) * 60;
          // seconds
          seconds = seconds + Number(timeArray[1]);
        }
        return Number(seconds);
      }
    });
  })();
  return numeral;
});

/***/ }),

/***/ 554:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
  throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
  throw new Error('clearTimeout has not been defined');
}
(function () {
  try {
    if (typeof setTimeout === 'function') {
      cachedSetTimeout = setTimeout;
    } else {
      cachedSetTimeout = defaultSetTimout;
    }
  } catch (e) {
    cachedSetTimeout = defaultSetTimout;
  }
  try {
    if (typeof clearTimeout === 'function') {
      cachedClearTimeout = clearTimeout;
    } else {
      cachedClearTimeout = defaultClearTimeout;
    }
  } catch (e) {
    cachedClearTimeout = defaultClearTimeout;
  }
})();
function runTimeout(fun) {
  if (cachedSetTimeout === setTimeout) {
    //normal enviroments in sane situations
    return setTimeout(fun, 0);
  }
  // if setTimeout wasn't available but was latter defined
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
    cachedSetTimeout = setTimeout;
    return setTimeout(fun, 0);
  }
  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedSetTimeout(fun, 0);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
      return cachedSetTimeout.call(null, fun, 0);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
      return cachedSetTimeout.call(this, fun, 0);
    }
  }
}
function runClearTimeout(marker) {
  if (cachedClearTimeout === clearTimeout) {
    //normal enviroments in sane situations
    return clearTimeout(marker);
  }
  // if clearTimeout wasn't available but was latter defined
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
    cachedClearTimeout = clearTimeout;
    return clearTimeout(marker);
  }
  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedClearTimeout(marker);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
      return cachedClearTimeout.call(null, marker);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
      // Some versions of I.E. have different rules for clearTimeout vs setTimeout
      return cachedClearTimeout.call(this, marker);
    }
  }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
  if (!draining || !currentQueue) {
    return;
  }
  draining = false;
  if (currentQueue.length) {
    queue = currentQueue.concat(queue);
  } else {
    queueIndex = -1;
  }
  if (queue.length) {
    drainQueue();
  }
}
function drainQueue() {
  if (draining) {
    return;
  }
  var timeout = runTimeout(cleanUpNextTick);
  draining = true;
  var len = queue.length;
  while (len) {
    currentQueue = queue;
    queue = [];
    while (++queueIndex < len) {
      if (currentQueue) {
        currentQueue[queueIndex].run();
      }
    }
    queueIndex = -1;
    len = queue.length;
  }
  currentQueue = null;
  draining = false;
  runClearTimeout(timeout);
}
process.nextTick = function (fun) {
  var args = new Array(arguments.length - 1);
  if (arguments.length > 1) {
    for (var i = 1; i < arguments.length; i++) {
      args[i - 1] = arguments[i];
    }
  }
  queue.push(new Item(fun, args));
  if (queue.length === 1 && !draining) {
    runTimeout(drainQueue);
  }
};

// v8 likes predictible objects
function Item(fun, array) {
  this.fun = fun;
  this.array = array;
}
Item.prototype.run = function () {
  this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function (name) {
  return [];
};
process.binding = function (name) {
  throw new Error('process.binding is not supported');
};
process.cwd = function () {
  return '/';
};
process.chdir = function (dir) {
  throw new Error('process.chdir is not supported');
};
process.umask = function () {
  return 0;
};

/***/ }),

/***/ 9378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Checkbox */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65260);
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56717);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57024);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40656);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91032);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68925);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var rc_util_es_hooks_useMergedState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78877);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82684);





var _excluded = ["prefixCls", "className", "style", "checked", "disabled", "defaultChecked", "type", "title", "onChange"];




var Checkbox = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function (props, ref) {
  var _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-checkbox' : _props$prefixCls,
    className = props.className,
    style = props.style,
    checked = props.checked,
    disabled = props.disabled,
    _props$defaultChecked = props.defaultChecked,
    defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked,
    _props$type = props.type,
    type = _props$type === void 0 ? 'checkbox' : _props$type,
    title = props.title,
    onChange = props.onChange,
    inputProps = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded);
  var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  var holderRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  var _useMergedState = (0,rc_util_es_hooks_useMergedState__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(defaultChecked, {
      value: checked
    }),
    _useMergedState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_useMergedState, 2),
    rawValue = _useMergedState2[0],
    setRawValue = _useMergedState2[1];
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useImperativeHandle)(ref, function () {
    return {
      focus: function focus(options) {
        var _inputRef$current;
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus(options);
      },
      blur: function blur() {
        var _inputRef$current2;
        (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.blur();
      },
      input: inputRef.current,
      nativeElement: holderRef.current
    };
  });
  var classString = classnames__WEBPACK_IMPORTED_MODULE_0___default()(prefixCls, className, (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, "".concat(prefixCls, "-checked"), rawValue), "".concat(prefixCls, "-disabled"), disabled));
  var handleChange = function handleChange(e) {
    if (disabled) {
      return;
    }
    if (!('checked' in props)) {
      setRawValue(e.target.checked);
    }
    onChange === null || onChange === void 0 || onChange({
      target: (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {}, {
        type: type,
        checked: e.target.checked
      }),
      stopPropagation: function stopPropagation() {
        e.stopPropagation();
      },
      preventDefault: function preventDefault() {
        e.preventDefault();
      },
      nativeEvent: e.nativeEvent
    });
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
    className: classString,
    title: title,
    style: style,
    ref: holderRef
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("input", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, inputProps, {
    className: "".concat(prefixCls, "-input"),
    ref: inputRef,
    onChange: handleChange,
    disabled: disabled,
    checked: !!rawValue,
    type: type
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
    className: "".concat(prefixCls, "-inner")
  }));
});
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);

/***/ }),

/***/ 61957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ rc_collapse_es; }
});

// UNUSED EXPORTS: Panel

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMergedState.js
var useMergedState = __webpack_require__(78877);
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(13764);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Children/toArray.js
var toArray = __webpack_require__(93550);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/rc-motion/es/index.js + 13 modules
var es = __webpack_require__(26981);
// EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js
var KeyCode = __webpack_require__(88035);
;// CONCATENATED MODULE: ./node_modules/rc-collapse/es/PanelContent.js




var PanelContent = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    forceRender = props.forceRender,
    className = props.className,
    style = props.style,
    children = props.children,
    isActive = props.isActive,
    role = props.role,
    customizeClassNames = props.classNames,
    styles = props.styles;
  var _React$useState = react.useState(isActive || forceRender),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    rendered = _React$useState2[0],
    setRendered = _React$useState2[1];
  react.useEffect(function () {
    if (forceRender || isActive) {
      setRendered(true);
    }
  }, [forceRender, isActive]);
  if (!rendered) {
    return null;
  }
  return /*#__PURE__*/react.createElement("div", {
    ref: ref,
    className: classnames_default()("".concat(prefixCls, "-content"), (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-content-active"), isActive), "".concat(prefixCls, "-content-inactive"), !isActive), className),
    style: style,
    role: role
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(prefixCls, "-content-box"), customizeClassNames === null || customizeClassNames === void 0 ? void 0 : customizeClassNames.body),
    style: styles === null || styles === void 0 ? void 0 : styles.body
  }, children));
});
PanelContent.displayName = 'PanelContent';
/* harmony default export */ var es_PanelContent = (PanelContent);
;// CONCATENATED MODULE: ./node_modules/rc-collapse/es/Panel.js




var _excluded = ["showArrow", "headerClass", "isActive", "onItemClick", "forceRender", "className", "classNames", "styles", "prefixCls", "collapsible", "accordion", "panelKey", "extra", "header", "expandIcon", "openMotion", "destroyInactivePanel", "children"];





var CollapsePanel = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _props$showArrow = props.showArrow,
    showArrow = _props$showArrow === void 0 ? true : _props$showArrow,
    headerClass = props.headerClass,
    isActive = props.isActive,
    onItemClick = props.onItemClick,
    forceRender = props.forceRender,
    className = props.className,
    _props$classNames = props.classNames,
    customizeClassNames = _props$classNames === void 0 ? {} : _props$classNames,
    _props$styles = props.styles,
    styles = _props$styles === void 0 ? {} : _props$styles,
    prefixCls = props.prefixCls,
    collapsible = props.collapsible,
    accordion = props.accordion,
    panelKey = props.panelKey,
    extra = props.extra,
    header = props.header,
    expandIcon = props.expandIcon,
    openMotion = props.openMotion,
    destroyInactivePanel = props.destroyInactivePanel,
    children = props.children,
    resetProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded);
  var disabled = collapsible === 'disabled';
  var ifExtraExist = extra !== null && extra !== undefined && typeof extra !== 'boolean';
  var collapsibleProps = (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({
    onClick: function onClick() {
      onItemClick === null || onItemClick === void 0 || onItemClick(panelKey);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter' || e.keyCode === KeyCode/* default.ENTER */.Z.ENTER || e.which === KeyCode/* default.ENTER */.Z.ENTER) {
        onItemClick === null || onItemClick === void 0 || onItemClick(panelKey);
      }
    },
    role: accordion ? 'tab' : 'button'
  }, 'aria-expanded', isActive), 'aria-disabled', disabled), "tabIndex", disabled ? -1 : 0);

  // ======================== Icon ========================
  var iconNodeInner = typeof expandIcon === 'function' ? expandIcon(props) : /*#__PURE__*/react.createElement("i", {
    className: "arrow"
  });
  var iconNode = iconNodeInner && /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    className: "".concat(prefixCls, "-expand-icon")
  }, ['header', 'icon'].includes(collapsible) ? collapsibleProps : {}), iconNodeInner);
  var collapsePanelClassNames = classnames_default()("".concat(prefixCls, "-item"), (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-item-active"), isActive), "".concat(prefixCls, "-item-disabled"), disabled), className);
  var headerClassName = classnames_default()(headerClass, "".concat(prefixCls, "-header"), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-collapsible-").concat(collapsible), !!collapsible), customizeClassNames.header);

  // ======================== HeaderProps ========================
  var headerProps = (0,objectSpread2/* default */.Z)({
    className: headerClassName,
    style: styles.header
  }, ['header', 'icon'].includes(collapsible) ? {} : collapsibleProps);

  // ======================== Render ========================
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, resetProps, {
    ref: ref,
    className: collapsePanelClassNames
  }), /*#__PURE__*/react.createElement("div", headerProps, showArrow && iconNode, /*#__PURE__*/react.createElement("span", (0,esm_extends/* default */.Z)({
    className: "".concat(prefixCls, "-header-text")
  }, collapsible === 'header' ? collapsibleProps : {}), header), ifExtraExist && /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-extra")
  }, extra)), /*#__PURE__*/react.createElement(es/* default */.ZP, (0,esm_extends/* default */.Z)({
    visible: isActive,
    leavedClassName: "".concat(prefixCls, "-content-hidden")
  }, openMotion, {
    forceRender: forceRender,
    removeOnLeave: destroyInactivePanel
  }), function (_ref, motionRef) {
    var motionClassName = _ref.className,
      motionStyle = _ref.style;
    return /*#__PURE__*/react.createElement(es_PanelContent, {
      ref: motionRef,
      prefixCls: prefixCls,
      className: motionClassName,
      classNames: customizeClassNames,
      style: motionStyle,
      styles: styles,
      isActive: isActive,
      forceRender: forceRender,
      role: accordion ? 'tabpanel' : void 0
    }, children);
  }));
});
/* harmony default export */ var Panel = (CollapsePanel);
;// CONCATENATED MODULE: ./node_modules/rc-collapse/es/hooks/useItems.js


var useItems_excluded = ["children", "label", "key", "collapsible", "onItemClick", "destroyInactivePanel"];



var convertItemsToNodes = function convertItemsToNodes(items, props) {
  var prefixCls = props.prefixCls,
    accordion = props.accordion,
    collapsible = props.collapsible,
    destroyInactivePanel = props.destroyInactivePanel,
    onItemClick = props.onItemClick,
    activeKey = props.activeKey,
    openMotion = props.openMotion,
    expandIcon = props.expandIcon;
  return items.map(function (item, index) {
    var children = item.children,
      label = item.label,
      rawKey = item.key,
      rawCollapsible = item.collapsible,
      rawOnItemClick = item.onItemClick,
      rawDestroyInactivePanel = item.destroyInactivePanel,
      restProps = (0,objectWithoutProperties/* default */.Z)(item, useItems_excluded);

    // You may be puzzled why you want to convert them all into strings, me too.
    // Maybe: https://github.com/react-component/collapse/blob/aac303a8b6ff30e35060b4f8fecde6f4556fcbe2/src/Collapse.tsx#L15
    var key = String(rawKey !== null && rawKey !== void 0 ? rawKey : index);
    var mergeCollapsible = rawCollapsible !== null && rawCollapsible !== void 0 ? rawCollapsible : collapsible;
    var mergeDestroyInactivePanel = rawDestroyInactivePanel !== null && rawDestroyInactivePanel !== void 0 ? rawDestroyInactivePanel : destroyInactivePanel;
    var handleItemClick = function handleItemClick(value) {
      if (mergeCollapsible === 'disabled') return;
      onItemClick(value);
      rawOnItemClick === null || rawOnItemClick === void 0 || rawOnItemClick(value);
    };
    var isActive = false;
    if (accordion) {
      isActive = activeKey[0] === key;
    } else {
      isActive = activeKey.indexOf(key) > -1;
    }
    return /*#__PURE__*/react.createElement(Panel, (0,esm_extends/* default */.Z)({}, restProps, {
      prefixCls: prefixCls,
      key: key,
      panelKey: key,
      isActive: isActive,
      accordion: accordion,
      openMotion: openMotion,
      expandIcon: expandIcon,
      header: label,
      collapsible: mergeCollapsible,
      onItemClick: handleItemClick,
      destroyInactivePanel: mergeDestroyInactivePanel
    }), children);
  });
};

/**
 * @deprecated The next major version will be removed
 */
var getNewChild = function getNewChild(child, index, props) {
  if (!child) return null;
  var prefixCls = props.prefixCls,
    accordion = props.accordion,
    collapsible = props.collapsible,
    destroyInactivePanel = props.destroyInactivePanel,
    onItemClick = props.onItemClick,
    activeKey = props.activeKey,
    openMotion = props.openMotion,
    expandIcon = props.expandIcon;
  var key = child.key || String(index);
  var _child$props = child.props,
    header = _child$props.header,
    headerClass = _child$props.headerClass,
    childDestroyInactivePanel = _child$props.destroyInactivePanel,
    childCollapsible = _child$props.collapsible,
    childOnItemClick = _child$props.onItemClick;
  var isActive = false;
  if (accordion) {
    isActive = activeKey[0] === key;
  } else {
    isActive = activeKey.indexOf(key) > -1;
  }
  var mergeCollapsible = childCollapsible !== null && childCollapsible !== void 0 ? childCollapsible : collapsible;
  var handleItemClick = function handleItemClick(value) {
    if (mergeCollapsible === 'disabled') return;
    onItemClick(value);
    childOnItemClick === null || childOnItemClick === void 0 || childOnItemClick(value);
  };
  var childProps = {
    key: key,
    panelKey: key,
    header: header,
    headerClass: headerClass,
    isActive: isActive,
    prefixCls: prefixCls,
    destroyInactivePanel: childDestroyInactivePanel !== null && childDestroyInactivePanel !== void 0 ? childDestroyInactivePanel : destroyInactivePanel,
    openMotion: openMotion,
    accordion: accordion,
    children: child.props.children,
    onItemClick: handleItemClick,
    expandIcon: expandIcon,
    collapsible: mergeCollapsible
  };

  // https://github.com/ant-design/ant-design/issues/20479
  if (typeof child.type === 'string') {
    return child;
  }
  Object.keys(childProps).forEach(function (propName) {
    if (typeof childProps[propName] === 'undefined') {
      delete childProps[propName];
    }
  });
  return /*#__PURE__*/react.cloneElement(child, childProps);
};
function useItems(items, rawChildren, props) {
  if (Array.isArray(items)) {
    return convertItemsToNodes(items, props);
  }
  return (0,toArray/* default */.Z)(rawChildren).map(function (child, index) {
    return getNewChild(child, index, props);
  });
}
/* harmony default export */ var hooks_useItems = (useItems);
// EXTERNAL MODULE: ./node_modules/rc-util/es/pickAttrs.js
var pickAttrs = __webpack_require__(75844);
;// CONCATENATED MODULE: ./node_modules/rc-collapse/es/Collapse.js











function getActiveKeysArray(activeKey) {
  var currentActiveKey = activeKey;
  if (!Array.isArray(currentActiveKey)) {
    var activeKeyType = (0,esm_typeof/* default */.Z)(currentActiveKey);
    currentActiveKey = activeKeyType === 'number' || activeKeyType === 'string' ? [currentActiveKey] : [];
  }
  return currentActiveKey.map(function (key) {
    return String(key);
  });
}
var Collapse = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-collapse' : _props$prefixCls,
    _props$destroyInactiv = props.destroyInactivePanel,
    destroyInactivePanel = _props$destroyInactiv === void 0 ? false : _props$destroyInactiv,
    style = props.style,
    accordion = props.accordion,
    className = props.className,
    children = props.children,
    collapsible = props.collapsible,
    openMotion = props.openMotion,
    expandIcon = props.expandIcon,
    rawActiveKey = props.activeKey,
    defaultActiveKey = props.defaultActiveKey,
    _onChange = props.onChange,
    items = props.items;
  var collapseClassName = classnames_default()(prefixCls, className);
  var _useMergedState = (0,useMergedState/* default */.Z)([], {
      value: rawActiveKey,
      onChange: function onChange(v) {
        return _onChange === null || _onChange === void 0 ? void 0 : _onChange(v);
      },
      defaultValue: defaultActiveKey,
      postState: getActiveKeysArray
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    activeKey = _useMergedState2[0],
    setActiveKey = _useMergedState2[1];
  var onItemClick = function onItemClick(key) {
    return setActiveKey(function () {
      if (accordion) {
        return activeKey[0] === key ? [] : [key];
      }
      var index = activeKey.indexOf(key);
      var isActive = index > -1;
      if (isActive) {
        return activeKey.filter(function (item) {
          return item !== key;
        });
      }
      return [].concat((0,toConsumableArray/* default */.Z)(activeKey), [key]);
    });
  };

  // ======================== Children ========================
  (0,warning/* default */.ZP)(!children, '[rc-collapse] `children` will be removed in next major version. Please use `items` instead.');
  var mergedChildren = hooks_useItems(items, children, {
    prefixCls: prefixCls,
    accordion: accordion,
    openMotion: openMotion,
    expandIcon: expandIcon,
    collapsible: collapsible,
    destroyInactivePanel: destroyInactivePanel,
    onItemClick: onItemClick,
    activeKey: activeKey
  });

  // ======================== Render ========================
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    ref: ref,
    className: collapseClassName,
    style: style,
    role: accordion ? 'tablist' : undefined
  }, (0,pickAttrs/* default */.Z)(props, {
    aria: true,
    data: true
  })), mergedChildren);
});
/* harmony default export */ var es_Collapse = (Object.assign(Collapse, {
  /**
   * @deprecated use `items` instead, will be removed in `v4.0.0`
   */
  Panel: Panel
}));
;// CONCATENATED MODULE: ./node_modules/rc-collapse/es/index.js

/* harmony default export */ var rc_collapse_es = (es_Collapse);

/**
 * @deprecated use `items` instead, will be removed in `v4.0.0`
 */
var es_Panel = es_Collapse.Panel;


/***/ }),

/***/ 31414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* reexport */ Content_Panel; },
  "Z": function() { return /* binding */ rc_dialog_es; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@rc-component/portal/es/index.js + 6 modules
var es = __webpack_require__(90604);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/rc-dialog/es/context.js

var RefContext = /*#__PURE__*/react.createContext({});
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/contains.js
var contains = __webpack_require__(79004);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useId.js
var useId = __webpack_require__(73208);
// EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js
var KeyCode = __webpack_require__(88035);
// EXTERNAL MODULE: ./node_modules/rc-util/es/pickAttrs.js
var pickAttrs = __webpack_require__(75844);
;// CONCATENATED MODULE: ./node_modules/rc-dialog/es/util.js
// =============================== Motion ===============================
function getMotionName(prefixCls, transitionName, animationName) {
  var motionName = transitionName;
  if (!motionName && animationName) {
    motionName = "".concat(prefixCls, "-").concat(animationName);
  }
  return motionName;
}

// =============================== Offset ===============================
function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      ret = d.body[method];
    }
  }
  return ret;
}
function offset(el) {
  var rect = el.getBoundingClientRect();
  var pos = {
    left: rect.left,
    top: rect.top
  };
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScroll(w);
  pos.top += getScroll(w, true);
  return pos;
}
// EXTERNAL MODULE: ./node_modules/rc-motion/es/index.js + 13 modules
var rc_motion_es = __webpack_require__(26981);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(99195);
;// CONCATENATED MODULE: ./node_modules/rc-dialog/es/Dialog/Content/MemoChildren.js

/* harmony default export */ var MemoChildren = (/*#__PURE__*/react.memo(function (_ref) {
  var children = _ref.children;
  return children;
}, function (_, _ref2) {
  var shouldUpdate = _ref2.shouldUpdate;
  return !shouldUpdate;
}));
;// CONCATENATED MODULE: ./node_modules/rc-dialog/es/Dialog/Content/Panel.js









var sentinelStyle = {
  width: 0,
  height: 0,
  overflow: 'hidden',
  outline: 'none'
};
var entityStyle = {
  outline: 'none'
};
var Panel = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    className = props.className,
    style = props.style,
    title = props.title,
    ariaId = props.ariaId,
    footer = props.footer,
    closable = props.closable,
    closeIcon = props.closeIcon,
    onClose = props.onClose,
    children = props.children,
    bodyStyle = props.bodyStyle,
    bodyProps = props.bodyProps,
    modalRender = props.modalRender,
    onMouseDown = props.onMouseDown,
    onMouseUp = props.onMouseUp,
    holderRef = props.holderRef,
    visible = props.visible,
    forceRender = props.forceRender,
    width = props.width,
    height = props.height,
    modalClassNames = props.classNames,
    modalStyles = props.styles;

  // ================================= Refs =================================
  var _React$useContext = react.useContext(RefContext),
    panelRef = _React$useContext.panel;
  var mergedRef = (0,es_ref/* useComposeRef */.x1)(holderRef, panelRef);
  var sentinelStartRef = (0,react.useRef)();
  var sentinelEndRef = (0,react.useRef)();
  react.useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        var _sentinelStartRef$cur;
        (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 || _sentinelStartRef$cur.focus({
          preventScroll: true
        });
      },
      changeActive: function changeActive(next) {
        var _document = document,
          activeElement = _document.activeElement;
        if (next && activeElement === sentinelEndRef.current) {
          sentinelStartRef.current.focus({
            preventScroll: true
          });
        } else if (!next && activeElement === sentinelStartRef.current) {
          sentinelEndRef.current.focus({
            preventScroll: true
          });
        }
      }
    };
  });

  // ================================ Style =================================
  var contentStyle = {};
  if (width !== undefined) {
    contentStyle.width = width;
  }
  if (height !== undefined) {
    contentStyle.height = height;
  }
  // ================================ Render ================================
  var footerNode = footer ? /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(prefixCls, "-footer"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.footer),
    style: (0,objectSpread2/* default */.Z)({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.footer)
  }, footer) : null;
  var headerNode = title ? /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(prefixCls, "-header"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.header),
    style: (0,objectSpread2/* default */.Z)({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.header)
  }, /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-title"),
    id: ariaId
  }, title)) : null;
  var closableObj = (0,react.useMemo)(function () {
    if ((0,esm_typeof/* default */.Z)(closable) === 'object' && closable !== null) {
      return closable;
    }
    if (closable) {
      return {
        closeIcon: closeIcon !== null && closeIcon !== void 0 ? closeIcon : /*#__PURE__*/react.createElement("span", {
          className: "".concat(prefixCls, "-close-x")
        })
      };
    }
    return {};
  }, [closable, closeIcon, prefixCls]);
  var ariaProps = (0,pickAttrs/* default */.Z)(closableObj, true);
  var closeBtnIsDisabled = (0,esm_typeof/* default */.Z)(closable) === 'object' && closable.disabled;
  var closerNode = closable ? /*#__PURE__*/react.createElement("button", (0,esm_extends/* default */.Z)({
    type: "button",
    onClick: onClose,
    "aria-label": "Close"
  }, ariaProps, {
    className: "".concat(prefixCls, "-close"),
    disabled: closeBtnIsDisabled
  }), closableObj.closeIcon) : null;
  var content = /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(prefixCls, "-content"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.content),
    style: modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.content
  }, closerNode, headerNode, /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    className: classnames_default()("".concat(prefixCls, "-body"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.body),
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, bodyStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.body)
  }, bodyProps), children), footerNode);
  return /*#__PURE__*/react.createElement("div", {
    key: "dialog-element",
    role: "dialog",
    "aria-labelledby": title ? ariaId : null,
    "aria-modal": "true",
    ref: mergedRef,
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, style), contentStyle),
    className: classnames_default()(prefixCls, className),
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp
  }, /*#__PURE__*/react.createElement("div", {
    ref: sentinelStartRef,
    tabIndex: 0,
    style: entityStyle
  }, /*#__PURE__*/react.createElement(MemoChildren, {
    shouldUpdate: visible || forceRender
  }, modalRender ? modalRender(content) : content)), /*#__PURE__*/react.createElement("div", {
    tabIndex: 0,
    ref: sentinelEndRef,
    style: sentinelStyle
  }));
});
if (false) {}
/* harmony default export */ var Content_Panel = (Panel);
;// CONCATENATED MODULE: ./node_modules/rc-dialog/es/Dialog/Content/index.js









var Content = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    title = props.title,
    style = props.style,
    className = props.className,
    visible = props.visible,
    forceRender = props.forceRender,
    destroyOnClose = props.destroyOnClose,
    motionName = props.motionName,
    ariaId = props.ariaId,
    onVisibleChanged = props.onVisibleChanged,
    mousePosition = props.mousePosition;
  var dialogRef = (0,react.useRef)();

  // ============================= Style ==============================
  var _React$useState = react.useState(),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    transformOrigin = _React$useState2[0],
    setTransformOrigin = _React$useState2[1];
  var contentStyle = {};
  if (transformOrigin) {
    contentStyle.transformOrigin = transformOrigin;
  }
  function onPrepare() {
    var elementOffset = offset(dialogRef.current);
    setTransformOrigin(mousePosition && (mousePosition.x || mousePosition.y) ? "".concat(mousePosition.x - elementOffset.left, "px ").concat(mousePosition.y - elementOffset.top, "px") : '');
  }

  // ============================= Render =============================
  return /*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, {
    visible: visible,
    onVisibleChanged: onVisibleChanged,
    onAppearPrepare: onPrepare,
    onEnterPrepare: onPrepare,
    forceRender: forceRender,
    motionName: motionName,
    removeOnLeave: destroyOnClose,
    ref: dialogRef
  }, function (_ref, motionRef) {
    var motionClassName = _ref.className,
      motionStyle = _ref.style;
    return /*#__PURE__*/react.createElement(Content_Panel, (0,esm_extends/* default */.Z)({}, props, {
      ref: ref,
      title: title,
      ariaId: ariaId,
      prefixCls: prefixCls,
      holderRef: motionRef,
      style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, motionStyle), style), contentStyle),
      className: classnames_default()(className, motionClassName)
    }));
  });
});
Content.displayName = 'Content';
/* harmony default export */ var Dialog_Content = (Content);
;// CONCATENATED MODULE: ./node_modules/rc-dialog/es/Dialog/Mask.js





var Mask = function Mask(props) {
  var prefixCls = props.prefixCls,
    style = props.style,
    visible = props.visible,
    maskProps = props.maskProps,
    motionName = props.motionName,
    className = props.className;
  return /*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, {
    key: "mask",
    visible: visible,
    motionName: motionName,
    leavedClassName: "".concat(prefixCls, "-mask-hidden")
  }, function (_ref, ref) {
    var motionClassName = _ref.className,
      motionStyle = _ref.style;
    return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
      ref: ref,
      style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, motionStyle), style),
      className: classnames_default()("".concat(prefixCls, "-mask"), motionClassName, className)
    }, maskProps));
  });
};
/* harmony default export */ var Dialog_Mask = (Mask);
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(13764);
;// CONCATENATED MODULE: ./node_modules/rc-dialog/es/Dialog/index.js














var Dialog = function Dialog(props) {
  var _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-dialog' : _props$prefixCls,
    zIndex = props.zIndex,
    _props$visible = props.visible,
    visible = _props$visible === void 0 ? false : _props$visible,
    _props$keyboard = props.keyboard,
    keyboard = _props$keyboard === void 0 ? true : _props$keyboard,
    _props$focusTriggerAf = props.focusTriggerAfterClose,
    focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf,
    wrapStyle = props.wrapStyle,
    wrapClassName = props.wrapClassName,
    wrapProps = props.wrapProps,
    onClose = props.onClose,
    afterOpenChange = props.afterOpenChange,
    afterClose = props.afterClose,
    transitionName = props.transitionName,
    animation = props.animation,
    _props$closable = props.closable,
    closable = _props$closable === void 0 ? true : _props$closable,
    _props$mask = props.mask,
    mask = _props$mask === void 0 ? true : _props$mask,
    maskTransitionName = props.maskTransitionName,
    maskAnimation = props.maskAnimation,
    _props$maskClosable = props.maskClosable,
    maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable,
    maskStyle = props.maskStyle,
    maskProps = props.maskProps,
    rootClassName = props.rootClassName,
    modalClassNames = props.classNames,
    modalStyles = props.styles;
  if (false) {}
  var lastOutSideActiveElementRef = (0,react.useRef)();
  var wrapperRef = (0,react.useRef)();
  var contentRef = (0,react.useRef)();
  var _React$useState = react.useState(visible),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    animatedVisible = _React$useState2[0],
    setAnimatedVisible = _React$useState2[1];

  // ========================== Init ==========================
  var ariaId = (0,useId/* default */.Z)();
  function saveLastOutSideActiveElementRef() {
    if (!(0,contains/* default */.Z)(wrapperRef.current, document.activeElement)) {
      lastOutSideActiveElementRef.current = document.activeElement;
    }
  }
  function focusDialogContent() {
    if (!(0,contains/* default */.Z)(wrapperRef.current, document.activeElement)) {
      var _contentRef$current;
      (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
    }
  }

  // ========================= Events =========================
  function onDialogVisibleChanged(newVisible) {
    // Try to focus
    if (newVisible) {
      focusDialogContent();
    } else {
      // Clean up scroll bar & focus back
      setAnimatedVisible(false);
      if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
        try {
          lastOutSideActiveElementRef.current.focus({
            preventScroll: true
          });
        } catch (e) {
          // Do nothing
        }
        lastOutSideActiveElementRef.current = null;
      }

      // Trigger afterClose only when change visible from true to false
      if (animatedVisible) {
        afterClose === null || afterClose === void 0 || afterClose();
      }
    }
    afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(newVisible);
  }
  function onInternalClose(e) {
    onClose === null || onClose === void 0 || onClose(e);
  }

  // >>> Content
  var contentClickRef = (0,react.useRef)(false);
  var contentTimeoutRef = (0,react.useRef)();

  // We need record content click incase content popup out of dialog
  var onContentMouseDown = function onContentMouseDown() {
    clearTimeout(contentTimeoutRef.current);
    contentClickRef.current = true;
  };
  var onContentMouseUp = function onContentMouseUp() {
    contentTimeoutRef.current = setTimeout(function () {
      contentClickRef.current = false;
    });
  };

  // >>> Wrapper
  // Close only when element not on dialog
  var onWrapperClick = null;
  if (maskClosable) {
    onWrapperClick = function onWrapperClick(e) {
      if (contentClickRef.current) {
        contentClickRef.current = false;
      } else if (wrapperRef.current === e.target) {
        onInternalClose(e);
      }
    };
  }
  function onWrapperKeyDown(e) {
    if (keyboard && e.keyCode === KeyCode/* default.ESC */.Z.ESC) {
      e.stopPropagation();
      onInternalClose(e);
      return;
    }

    // keep focus inside dialog
    if (visible && e.keyCode === KeyCode/* default.TAB */.Z.TAB) {
      contentRef.current.changeActive(!e.shiftKey);
    }
  }

  // ========================= Effect =========================
  (0,react.useEffect)(function () {
    if (visible) {
      setAnimatedVisible(true);
      saveLastOutSideActiveElementRef();
    }
  }, [visible]);

  // Remove direct should also check the scroll bar update
  (0,react.useEffect)(function () {
    return function () {
      clearTimeout(contentTimeoutRef.current);
    };
  }, []);
  var mergedStyle = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
    zIndex: zIndex
  }, wrapStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.wrapper), {}, {
    display: !animatedVisible ? 'none' : null
  });

  // ========================= Render =========================
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    className: classnames_default()("".concat(prefixCls, "-root"), rootClassName)
  }, (0,pickAttrs/* default */.Z)(props, {
    data: true
  })), /*#__PURE__*/react.createElement(Dialog_Mask, {
    prefixCls: prefixCls,
    visible: mask && visible,
    motionName: getMotionName(prefixCls, maskTransitionName, maskAnimation),
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
      zIndex: zIndex
    }, maskStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.mask),
    maskProps: maskProps,
    className: modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.mask
  }), /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    tabIndex: -1,
    onKeyDown: onWrapperKeyDown,
    className: classnames_default()("".concat(prefixCls, "-wrap"), wrapClassName, modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.wrapper),
    ref: wrapperRef,
    onClick: onWrapperClick,
    style: mergedStyle
  }, wrapProps), /*#__PURE__*/react.createElement(Dialog_Content, (0,esm_extends/* default */.Z)({}, props, {
    onMouseDown: onContentMouseDown,
    onMouseUp: onContentMouseUp,
    ref: contentRef,
    closable: closable,
    ariaId: ariaId,
    prefixCls: prefixCls,
    visible: visible && animatedVisible,
    onClose: onInternalClose,
    onVisibleChanged: onDialogVisibleChanged,
    motionName: getMotionName(prefixCls, transitionName, animation)
  }))));
};
/* harmony default export */ var es_Dialog = (Dialog);
;// CONCATENATED MODULE: ./node_modules/rc-dialog/es/DialogWrap.js






// fix issue #10656
/*
 * getContainer remarks
 * Custom container should not be return, because in the Portal component, it will remove the
 * return container element here, if the custom container is the only child of it's component,
 * like issue #10656, It will has a conflict with removeChild method in react-dom.
 * So here should add a child (div element) to custom container.
 * */

var DialogWrap = function DialogWrap(props) {
  var visible = props.visible,
    getContainer = props.getContainer,
    forceRender = props.forceRender,
    _props$destroyOnClose = props.destroyOnClose,
    destroyOnClose = _props$destroyOnClose === void 0 ? false : _props$destroyOnClose,
    _afterClose = props.afterClose,
    panelRef = props.panelRef;
  var _React$useState = react.useState(visible),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    animatedVisible = _React$useState2[0],
    setAnimatedVisible = _React$useState2[1];
  var refContext = react.useMemo(function () {
    return {
      panel: panelRef
    };
  }, [panelRef]);
  react.useEffect(function () {
    if (visible) {
      setAnimatedVisible(true);
    }
  }, [visible]);

  // Destroy on close will remove wrapped div
  if (!forceRender && destroyOnClose && !animatedVisible) {
    return null;
  }
  return /*#__PURE__*/react.createElement(RefContext.Provider, {
    value: refContext
  }, /*#__PURE__*/react.createElement(es/* default */.Z, {
    open: visible || forceRender || animatedVisible,
    autoDestroy: false,
    getContainer: getContainer,
    autoLock: visible || animatedVisible
  }, /*#__PURE__*/react.createElement(es_Dialog, (0,esm_extends/* default */.Z)({}, props, {
    destroyOnClose: destroyOnClose,
    afterClose: function afterClose() {
      _afterClose === null || _afterClose === void 0 || _afterClose();
      setAnimatedVisible(false);
    }
  }))));
};
DialogWrap.displayName = 'Dialog';
/* harmony default export */ var es_DialogWrap = (DialogWrap);
;// CONCATENATED MODULE: ./node_modules/rc-dialog/es/index.js



/* harmony default export */ var rc_dialog_es = (es_DialogWrap);

/***/ }),

/***/ 32830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ rc_drawer_es; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@rc-component/portal/es/index.js + 6 modules
var es = __webpack_require__(90604);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useLayoutEffect.js
var useLayoutEffect = __webpack_require__(76963);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/rc-drawer/es/context.js

var DrawerContext = /*#__PURE__*/react.createContext(null);
var RefContext = /*#__PURE__*/react.createContext({});
/* harmony default export */ var context = (DrawerContext);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-motion/es/index.js + 13 modules
var rc_motion_es = __webpack_require__(26981);
// EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js
var KeyCode = __webpack_require__(88035);
// EXTERNAL MODULE: ./node_modules/rc-util/es/pickAttrs.js
var pickAttrs = __webpack_require__(75844);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var ref = __webpack_require__(99195);
;// CONCATENATED MODULE: ./node_modules/rc-drawer/es/DrawerPanel.js


var _excluded = ["prefixCls", "className", "containerRef"];





var DrawerPanel = function DrawerPanel(props) {
  var prefixCls = props.prefixCls,
    className = props.className,
    containerRef = props.containerRef,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded);
  var _React$useContext = react.useContext(RefContext),
    panelRef = _React$useContext.panel;
  var mergedRef = (0,ref/* useComposeRef */.x1)(panelRef, containerRef);

  // =============================== Render ===============================

  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    className: classnames_default()("".concat(prefixCls, "-content"), className),
    role: "dialog",
    ref: mergedRef
  }, (0,pickAttrs/* default */.Z)(props, {
    aria: true
  }), {
    "aria-modal": "true"
  }, restProps));
};
if (false) {}
/* harmony default export */ var es_DrawerPanel = (DrawerPanel);
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var es_warning = __webpack_require__(13764);
;// CONCATENATED MODULE: ./node_modules/rc-drawer/es/util.js


function parseWidthHeight(value) {
  if (typeof value === 'string' && String(Number(value)) === value) {
    (0,es_warning/* default */.ZP)(false, 'Invalid value type of `width` or `height` which should be number type instead.');
    return Number(value);
  }
  return value;
}
function warnCheck(props) {
  warning(!('wrapperClassName' in props), "'wrapperClassName' is removed. Please use 'rootClassName' instead.");
  warning(canUseDom() || !props.open, "Drawer with 'open' in SSR is not work since no place to createPortal. Please move to 'useEffect' instead.");
}
;// CONCATENATED MODULE: ./node_modules/rc-drawer/es/DrawerPopup.js












var sentinelStyle = {
  width: 0,
  height: 0,
  overflow: 'hidden',
  outline: 'none',
  position: 'absolute'
};
function DrawerPopup(props, ref) {
  var _ref, _pushConfig$distance, _pushConfig;
  var prefixCls = props.prefixCls,
    open = props.open,
    placement = props.placement,
    inline = props.inline,
    push = props.push,
    forceRender = props.forceRender,
    autoFocus = props.autoFocus,
    keyboard = props.keyboard,
    drawerClassNames = props.classNames,
    rootClassName = props.rootClassName,
    rootStyle = props.rootStyle,
    zIndex = props.zIndex,
    className = props.className,
    id = props.id,
    style = props.style,
    motion = props.motion,
    width = props.width,
    height = props.height,
    children = props.children,
    mask = props.mask,
    maskClosable = props.maskClosable,
    maskMotion = props.maskMotion,
    maskClassName = props.maskClassName,
    maskStyle = props.maskStyle,
    afterOpenChange = props.afterOpenChange,
    onClose = props.onClose,
    onMouseEnter = props.onMouseEnter,
    onMouseOver = props.onMouseOver,
    onMouseLeave = props.onMouseLeave,
    onClick = props.onClick,
    onKeyDown = props.onKeyDown,
    onKeyUp = props.onKeyUp,
    styles = props.styles,
    drawerRender = props.drawerRender;

  // ================================ Refs ================================
  var panelRef = react.useRef();
  var sentinelStartRef = react.useRef();
  var sentinelEndRef = react.useRef();
  react.useImperativeHandle(ref, function () {
    return panelRef.current;
  });
  var onPanelKeyDown = function onPanelKeyDown(event) {
    var keyCode = event.keyCode,
      shiftKey = event.shiftKey;
    switch (keyCode) {
      // Tab active
      case KeyCode/* default.TAB */.Z.TAB:
        {
          if (keyCode === KeyCode/* default.TAB */.Z.TAB) {
            if (!shiftKey && document.activeElement === sentinelEndRef.current) {
              var _sentinelStartRef$cur;
              (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 || _sentinelStartRef$cur.focus({
                preventScroll: true
              });
            } else if (shiftKey && document.activeElement === sentinelStartRef.current) {
              var _sentinelEndRef$curre;
              (_sentinelEndRef$curre = sentinelEndRef.current) === null || _sentinelEndRef$curre === void 0 || _sentinelEndRef$curre.focus({
                preventScroll: true
              });
            }
          }
          break;
        }

      // Close
      case KeyCode/* default.ESC */.Z.ESC:
        {
          if (onClose && keyboard) {
            event.stopPropagation();
            onClose(event);
          }
          break;
        }
    }
  };

  // ========================== Control ===========================
  // Auto Focus
  react.useEffect(function () {
    if (open && autoFocus) {
      var _panelRef$current;
      (_panelRef$current = panelRef.current) === null || _panelRef$current === void 0 || _panelRef$current.focus({
        preventScroll: true
      });
    }
  }, [open]);

  // ============================ Push ============================
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    pushed = _React$useState2[0],
    setPushed = _React$useState2[1];
  var parentContext = react.useContext(context);

  // Merge push distance
  var pushConfig;
  if (typeof push === 'boolean') {
    pushConfig = push ? {} : {
      distance: 0
    };
  } else {
    pushConfig = push || {};
  }
  var pushDistance = (_ref = (_pushConfig$distance = (_pushConfig = pushConfig) === null || _pushConfig === void 0 ? void 0 : _pushConfig.distance) !== null && _pushConfig$distance !== void 0 ? _pushConfig$distance : parentContext === null || parentContext === void 0 ? void 0 : parentContext.pushDistance) !== null && _ref !== void 0 ? _ref : 180;
  var mergedContext = react.useMemo(function () {
    return {
      pushDistance: pushDistance,
      push: function push() {
        setPushed(true);
      },
      pull: function pull() {
        setPushed(false);
      }
    };
  }, [pushDistance]);

  // ========================= ScrollLock =========================
  // Tell parent to push
  react.useEffect(function () {
    if (open) {
      var _parentContext$push;
      parentContext === null || parentContext === void 0 || (_parentContext$push = parentContext.push) === null || _parentContext$push === void 0 || _parentContext$push.call(parentContext);
    } else {
      var _parentContext$pull;
      parentContext === null || parentContext === void 0 || (_parentContext$pull = parentContext.pull) === null || _parentContext$pull === void 0 || _parentContext$pull.call(parentContext);
    }
  }, [open]);

  // Clean up
  react.useEffect(function () {
    return function () {
      var _parentContext$pull2;
      parentContext === null || parentContext === void 0 || (_parentContext$pull2 = parentContext.pull) === null || _parentContext$pull2 === void 0 || _parentContext$pull2.call(parentContext);
    };
  }, []);

  // ============================ Mask ============================
  var maskNode = /*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, (0,esm_extends/* default */.Z)({
    key: "mask"
  }, maskMotion, {
    visible: mask && open
  }), function (_ref2, maskRef) {
    var motionMaskClassName = _ref2.className,
      motionMaskStyle = _ref2.style;
    return /*#__PURE__*/react.createElement("div", {
      className: classnames_default()("".concat(prefixCls, "-mask"), motionMaskClassName, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.mask, maskClassName),
      style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, motionMaskStyle), maskStyle), styles === null || styles === void 0 ? void 0 : styles.mask),
      onClick: maskClosable && open ? onClose : undefined,
      ref: maskRef
    });
  });

  // =========================== Panel ============================
  var motionProps = typeof motion === 'function' ? motion(placement) : motion;
  var wrapperStyle = {};
  if (pushed && pushDistance) {
    switch (placement) {
      case 'top':
        wrapperStyle.transform = "translateY(".concat(pushDistance, "px)");
        break;
      case 'bottom':
        wrapperStyle.transform = "translateY(".concat(-pushDistance, "px)");
        break;
      case 'left':
        wrapperStyle.transform = "translateX(".concat(pushDistance, "px)");
        break;
      default:
        wrapperStyle.transform = "translateX(".concat(-pushDistance, "px)");
        break;
    }
  }
  if (placement === 'left' || placement === 'right') {
    wrapperStyle.width = parseWidthHeight(width);
  } else {
    wrapperStyle.height = parseWidthHeight(height);
  }
  var eventHandlers = {
    onMouseEnter: onMouseEnter,
    onMouseOver: onMouseOver,
    onMouseLeave: onMouseLeave,
    onClick: onClick,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp
  };
  var panelNode = /*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, (0,esm_extends/* default */.Z)({
    key: "panel"
  }, motionProps, {
    visible: open,
    forceRender: forceRender,
    onVisibleChanged: function onVisibleChanged(nextVisible) {
      afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(nextVisible);
    },
    removeOnLeave: false,
    leavedClassName: "".concat(prefixCls, "-content-wrapper-hidden")
  }), function (_ref3, motionRef) {
    var motionClassName = _ref3.className,
      motionStyle = _ref3.style;
    var content = /*#__PURE__*/react.createElement(es_DrawerPanel, (0,esm_extends/* default */.Z)({
      id: id,
      containerRef: motionRef,
      prefixCls: prefixCls,
      className: classnames_default()(className, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.content),
      style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, style), styles === null || styles === void 0 ? void 0 : styles.content)
    }, (0,pickAttrs/* default */.Z)(props, {
      aria: true
    }), eventHandlers), children);
    return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
      className: classnames_default()("".concat(prefixCls, "-content-wrapper"), drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.wrapper, motionClassName),
      style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, wrapperStyle), motionStyle), styles === null || styles === void 0 ? void 0 : styles.wrapper)
    }, (0,pickAttrs/* default */.Z)(props, {
      data: true
    })), drawerRender ? drawerRender(content) : content);
  });

  // =========================== Render ===========================
  var containerStyle = (0,objectSpread2/* default */.Z)({}, rootStyle);
  if (zIndex) {
    containerStyle.zIndex = zIndex;
  }
  return /*#__PURE__*/react.createElement(context.Provider, {
    value: mergedContext
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(prefixCls, "".concat(prefixCls, "-").concat(placement), rootClassName, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-open"), open), "".concat(prefixCls, "-inline"), inline)),
    style: containerStyle,
    tabIndex: -1,
    ref: panelRef,
    onKeyDown: onPanelKeyDown
  }, maskNode, /*#__PURE__*/react.createElement("div", {
    tabIndex: 0,
    ref: sentinelStartRef,
    style: sentinelStyle,
    "aria-hidden": "true",
    "data-sentinel": "start"
  }), panelNode, /*#__PURE__*/react.createElement("div", {
    tabIndex: 0,
    ref: sentinelEndRef,
    style: sentinelStyle,
    "aria-hidden": "true",
    "data-sentinel": "end"
  })));
}
var RefDrawerPopup = /*#__PURE__*/react.forwardRef(DrawerPopup);
if (false) {}
/* harmony default export */ var es_DrawerPopup = (RefDrawerPopup);
;// CONCATENATED MODULE: ./node_modules/rc-drawer/es/Drawer.js








var Drawer = function Drawer(props) {
  var _props$open = props.open,
    open = _props$open === void 0 ? false : _props$open,
    _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-drawer' : _props$prefixCls,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? 'right' : _props$placement,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
    _props$keyboard = props.keyboard,
    keyboard = _props$keyboard === void 0 ? true : _props$keyboard,
    _props$width = props.width,
    width = _props$width === void 0 ? 378 : _props$width,
    _props$mask = props.mask,
    mask = _props$mask === void 0 ? true : _props$mask,
    _props$maskClosable = props.maskClosable,
    maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable,
    getContainer = props.getContainer,
    forceRender = props.forceRender,
    afterOpenChange = props.afterOpenChange,
    destroyOnClose = props.destroyOnClose,
    onMouseEnter = props.onMouseEnter,
    onMouseOver = props.onMouseOver,
    onMouseLeave = props.onMouseLeave,
    onClick = props.onClick,
    onKeyDown = props.onKeyDown,
    onKeyUp = props.onKeyUp,
    panelRef = props.panelRef;
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    animatedVisible = _React$useState2[0],
    setAnimatedVisible = _React$useState2[1];

  // ============================= Warn =============================
  if (false) {}

  // ============================= Open =============================
  var _React$useState3 = react.useState(false),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    mounted = _React$useState4[0],
    setMounted = _React$useState4[1];
  (0,useLayoutEffect/* default */.Z)(function () {
    setMounted(true);
  }, []);
  var mergedOpen = mounted ? open : false;

  // ============================ Focus =============================
  var popupRef = react.useRef();
  var lastActiveRef = react.useRef();
  (0,useLayoutEffect/* default */.Z)(function () {
    if (mergedOpen) {
      lastActiveRef.current = document.activeElement;
    }
  }, [mergedOpen]);

  // ============================= Open =============================
  var internalAfterOpenChange = function internalAfterOpenChange(nextVisible) {
    var _popupRef$current;
    setAnimatedVisible(nextVisible);
    afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(nextVisible);
    if (!nextVisible && lastActiveRef.current && !((_popupRef$current = popupRef.current) !== null && _popupRef$current !== void 0 && _popupRef$current.contains(lastActiveRef.current))) {
      var _lastActiveRef$curren;
      (_lastActiveRef$curren = lastActiveRef.current) === null || _lastActiveRef$curren === void 0 || _lastActiveRef$curren.focus({
        preventScroll: true
      });
    }
  };

  // =========================== Context ============================
  var refContext = react.useMemo(function () {
    return {
      panel: panelRef
    };
  }, [panelRef]);

  // ============================ Render ============================
  if (!forceRender && !animatedVisible && !mergedOpen && destroyOnClose) {
    return null;
  }
  var eventHandlers = {
    onMouseEnter: onMouseEnter,
    onMouseOver: onMouseOver,
    onMouseLeave: onMouseLeave,
    onClick: onClick,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp
  };
  var drawerPopupProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    open: mergedOpen,
    prefixCls: prefixCls,
    placement: placement,
    autoFocus: autoFocus,
    keyboard: keyboard,
    width: width,
    mask: mask,
    maskClosable: maskClosable,
    inline: getContainer === false,
    afterOpenChange: internalAfterOpenChange,
    ref: popupRef
  }, eventHandlers);
  return /*#__PURE__*/react.createElement(RefContext.Provider, {
    value: refContext
  }, /*#__PURE__*/react.createElement(es/* default */.Z, {
    open: mergedOpen || forceRender || animatedVisible,
    autoDestroy: false,
    getContainer: getContainer,
    autoLock: mask && (mergedOpen || animatedVisible)
  }, /*#__PURE__*/react.createElement(es_DrawerPopup, drawerPopupProps)));
};
if (false) {}
/* harmony default export */ var es_Drawer = (Drawer);
;// CONCATENATED MODULE: ./node_modules/rc-drawer/es/index.js
// export this package's api

/* harmony default export */ var rc_drawer_es = (es_Drawer);

/***/ }),

/***/ 93755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ rc_dropdown_es; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/@rc-component/trigger/es/index.js + 11 modules
var es = __webpack_require__(91831);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(99195);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js
var KeyCode = __webpack_require__(88035);
// EXTERNAL MODULE: ./node_modules/rc-util/es/raf.js
var raf = __webpack_require__(13157);
;// CONCATENATED MODULE: ./node_modules/rc-dropdown/es/hooks/useAccessibility.js



var ESC = KeyCode/* default.ESC */.Z.ESC,
  TAB = KeyCode/* default.TAB */.Z.TAB;
function useAccessibility(_ref) {
  var visible = _ref.visible,
    triggerRef = _ref.triggerRef,
    onVisibleChange = _ref.onVisibleChange,
    autoFocus = _ref.autoFocus,
    overlayRef = _ref.overlayRef;
  var focusMenuRef = react.useRef(false);
  var handleCloseMenuAndReturnFocus = function handleCloseMenuAndReturnFocus() {
    if (visible) {
      var _triggerRef$current, _triggerRef$current$f;
      (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || (_triggerRef$current$f = _triggerRef$current.focus) === null || _triggerRef$current$f === void 0 || _triggerRef$current$f.call(_triggerRef$current);
      onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(false);
    }
  };
  var focusMenu = function focusMenu() {
    var _overlayRef$current;
    if ((_overlayRef$current = overlayRef.current) !== null && _overlayRef$current !== void 0 && _overlayRef$current.focus) {
      overlayRef.current.focus();
      focusMenuRef.current = true;
      return true;
    }
    return false;
  };
  var handleKeyDown = function handleKeyDown(event) {
    switch (event.keyCode) {
      case ESC:
        handleCloseMenuAndReturnFocus();
        break;
      case TAB:
        {
          var focusResult = false;
          if (!focusMenuRef.current) {
            focusResult = focusMenu();
          }
          if (focusResult) {
            event.preventDefault();
          } else {
            handleCloseMenuAndReturnFocus();
          }
          break;
        }
    }
  };
  react.useEffect(function () {
    if (visible) {
      window.addEventListener("keydown", handleKeyDown);
      if (autoFocus) {
        // FIXME: hack with raf
        (0,raf/* default */.Z)(focusMenu, 3);
      }
      return function () {
        window.removeEventListener("keydown", handleKeyDown);
        focusMenuRef.current = false;
      };
    }
    return function () {
      focusMenuRef.current = false;
    };
  }, [visible]); // eslint-disable-line react-hooks/exhaustive-deps
}
;// CONCATENATED MODULE: ./node_modules/rc-dropdown/es/Overlay.js


var Overlay = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var overlay = props.overlay,
    arrow = props.arrow,
    prefixCls = props.prefixCls;
  var overlayNode = (0,react.useMemo)(function () {
    var overlayElement;
    if (typeof overlay === 'function') {
      overlayElement = overlay();
    } else {
      overlayElement = overlay;
    }
    return overlayElement;
  }, [overlay]);
  var composedRef = (0,es_ref/* composeRef */.sQ)(ref, (0,es_ref/* getNodeRef */.C4)(overlayNode));
  return /*#__PURE__*/react.createElement(react.Fragment, null, arrow && /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-arrow")
  }), /*#__PURE__*/react.cloneElement(overlayNode, {
    ref: (0,es_ref/* supportRef */.Yr)(overlayNode) ? composedRef : undefined
  }));
});
/* harmony default export */ var es_Overlay = (Overlay);
;// CONCATENATED MODULE: ./node_modules/rc-dropdown/es/placements.js
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, 0];
var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  }
};
/* harmony default export */ var es_placements = (placements);
;// CONCATENATED MODULE: ./node_modules/rc-dropdown/es/Dropdown.js




var _excluded = ["arrow", "prefixCls", "transitionName", "animation", "align", "placement", "placements", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "visible", "trigger", "autoFocus", "overlay", "children", "onVisibleChange"];







function Dropdown(props, ref) {
  var _children$props;
  var _props$arrow = props.arrow,
    arrow = _props$arrow === void 0 ? false : _props$arrow,
    _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-dropdown' : _props$prefixCls,
    transitionName = props.transitionName,
    animation = props.animation,
    align = props.align,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? 'bottomLeft' : _props$placement,
    _props$placements = props.placements,
    placements = _props$placements === void 0 ? es_placements : _props$placements,
    getPopupContainer = props.getPopupContainer,
    showAction = props.showAction,
    hideAction = props.hideAction,
    overlayClassName = props.overlayClassName,
    overlayStyle = props.overlayStyle,
    visible = props.visible,
    _props$trigger = props.trigger,
    trigger = _props$trigger === void 0 ? ['hover'] : _props$trigger,
    autoFocus = props.autoFocus,
    overlay = props.overlay,
    children = props.children,
    onVisibleChange = props.onVisibleChange,
    otherProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded);
  var _React$useState = react.useState(),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    triggerVisible = _React$useState2[0],
    setTriggerVisible = _React$useState2[1];
  var mergedVisible = 'visible' in props ? visible : triggerVisible;
  var triggerRef = react.useRef(null);
  var overlayRef = react.useRef(null);
  var childRef = react.useRef(null);
  react.useImperativeHandle(ref, function () {
    return triggerRef.current;
  });
  var handleVisibleChange = function handleVisibleChange(newVisible) {
    setTriggerVisible(newVisible);
    onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(newVisible);
  };
  useAccessibility({
    visible: mergedVisible,
    triggerRef: childRef,
    onVisibleChange: handleVisibleChange,
    autoFocus: autoFocus,
    overlayRef: overlayRef
  });
  var onClick = function onClick(e) {
    var onOverlayClick = props.onOverlayClick;
    setTriggerVisible(false);
    if (onOverlayClick) {
      onOverlayClick(e);
    }
  };
  var getMenuElement = function getMenuElement() {
    return /*#__PURE__*/react.createElement(es_Overlay, {
      ref: overlayRef,
      overlay: overlay,
      prefixCls: prefixCls,
      arrow: arrow
    });
  };
  var getMenuElementOrLambda = function getMenuElementOrLambda() {
    if (typeof overlay === 'function') {
      return getMenuElement;
    }
    return getMenuElement();
  };
  var getMinOverlayWidthMatchTrigger = function getMinOverlayWidthMatchTrigger() {
    var minOverlayWidthMatchTrigger = props.minOverlayWidthMatchTrigger,
      alignPoint = props.alignPoint;
    if ('minOverlayWidthMatchTrigger' in props) {
      return minOverlayWidthMatchTrigger;
    }
    return !alignPoint;
  };
  var getOpenClassName = function getOpenClassName() {
    var openClassName = props.openClassName;
    if (openClassName !== undefined) {
      return openClassName;
    }
    return "".concat(prefixCls, "-open");
  };
  var childrenNode = /*#__PURE__*/react.cloneElement(children, {
    className: classnames_default()((_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.className, mergedVisible && getOpenClassName()),
    ref: (0,es_ref/* supportRef */.Yr)(children) ? (0,es_ref/* composeRef */.sQ)(childRef, (0,es_ref/* getNodeRef */.C4)(children)) : undefined
  });
  var triggerHideAction = hideAction;
  if (!triggerHideAction && trigger.indexOf('contextMenu') !== -1) {
    triggerHideAction = ['click'];
  }
  return /*#__PURE__*/react.createElement(es/* default */.Z, (0,esm_extends/* default */.Z)({
    builtinPlacements: placements
  }, otherProps, {
    prefixCls: prefixCls,
    ref: triggerRef,
    popupClassName: classnames_default()(overlayClassName, (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-show-arrow"), arrow)),
    popupStyle: overlayStyle,
    action: trigger,
    showAction: showAction,
    hideAction: triggerHideAction,
    popupPlacement: placement,
    popupAlign: align,
    popupTransitionName: transitionName,
    popupAnimation: animation,
    popupVisible: mergedVisible,
    stretch: getMinOverlayWidthMatchTrigger() ? 'minWidth' : '',
    popup: getMenuElementOrLambda(),
    onPopupVisibleChange: handleVisibleChange,
    onPopupClick: onClick,
    getPopupContainer: getPopupContainer
  }), childrenNode);
}
/* harmony default export */ var es_Dropdown = (/*#__PURE__*/react.forwardRef(Dropdown));
;// CONCATENATED MODULE: ./node_modules/rc-dropdown/es/index.js

/* harmony default export */ var rc_dropdown_es = (es_Dropdown);

/***/ }),

/***/ 54888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gN": function() { return /* reexport */ es_Field; },
  "zb": function() { return /* reexport */ FieldContext; },
  "RV": function() { return /* reexport */ FormProvider; },
  "aV": function() { return /* reexport */ es_List; },
  "ZM": function() { return /* reexport */ es_ListContext; },
  "ZP": function() { return /* binding */ rc_field_form_es; },
  "cI": function() { return /* reexport */ es_useForm; },
  "qo": function() { return /* reexport */ es_useWatch; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 8 modules
var regeneratorRuntime = __webpack_require__(8662);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(2456);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6223);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(79427);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(88569);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(34766);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js
var createSuper = __webpack_require__(56302);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Children/toArray.js
var toArray = __webpack_require__(93550);
// EXTERNAL MODULE: ./node_modules/rc-util/es/isEqual.js
var isEqual = __webpack_require__(55159);
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(13764);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/FieldContext.js


var HOOK_MARK = 'RC_FORM_INTERNAL_HOOKS';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var warningFunc = function warningFunc() {
  (0,warning/* default */.ZP)(false, 'Can not find FormContext. Please make sure you wrap Field under Form.');
};
var Context = /*#__PURE__*/react.createContext({
  getFieldValue: warningFunc,
  getFieldsValue: warningFunc,
  getFieldError: warningFunc,
  getFieldWarning: warningFunc,
  getFieldsError: warningFunc,
  isFieldsTouched: warningFunc,
  isFieldTouched: warningFunc,
  isFieldValidating: warningFunc,
  isFieldsValidating: warningFunc,
  resetFields: warningFunc,
  setFields: warningFunc,
  setFieldValue: warningFunc,
  setFieldsValue: warningFunc,
  validateFields: warningFunc,
  submit: warningFunc,
  getInternalHooks: function getInternalHooks() {
    warningFunc();
    return {
      dispatch: warningFunc,
      initEntityValue: warningFunc,
      registerField: warningFunc,
      useSubscribe: warningFunc,
      setInitialValues: warningFunc,
      destroyForm: warningFunc,
      setCallbacks: warningFunc,
      registerWatch: warningFunc,
      getFields: warningFunc,
      setValidateMessages: warningFunc,
      setPreserve: warningFunc,
      getInitialValue: warningFunc
    };
  }
});
/* harmony default export */ var FieldContext = (Context);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/ListContext.js

var ListContext = /*#__PURE__*/react.createContext(null);
/* harmony default export */ var es_ListContext = (ListContext);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/utils/typeUtil.js
function typeUtil_toArray(value) {
  if (value === undefined || value === null) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
}
function isFormInstance(form) {
  return form && !!form._init;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/messages.js
function newMessages() {
  return {
    default: 'Validation error on field %s',
    required: '%s is required',
    enum: '%s must be one of %s',
    whitespace: '%s cannot be empty',
    date: {
      format: '%s date %s is invalid for format %s',
      parse: '%s date could not be parsed, %s is invalid ',
      invalid: '%s date %s is invalid'
    },
    types: {
      string: '%s is not a %s',
      method: '%s is not a %s (function)',
      array: '%s is not an %s',
      object: '%s is not an %s',
      number: '%s is not a %s',
      date: '%s is not a %s',
      boolean: '%s is not a %s',
      integer: '%s is not an %s',
      float: '%s is not a %s',
      regexp: '%s is not a valid %s',
      email: '%s is not a valid %s',
      url: '%s is not a valid %s',
      hex: '%s is not a valid %s'
    },
    string: {
      len: '%s must be exactly %s characters',
      min: '%s must be at least %s characters',
      max: '%s cannot be longer than %s characters',
      range: '%s must be between %s and %s characters'
    },
    number: {
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    },
    array: {
      len: '%s must be exactly %s in length',
      min: '%s cannot be less than %s in length',
      max: '%s cannot be greater than %s in length',
      range: '%s must be between %s and %s in length'
    },
    pattern: {
      mismatch: '%s value %s does not match pattern %s'
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}
var messages_messages = newMessages();
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(63382);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(87806);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
var isNativeReflectConstruct = __webpack_require__(77536);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/construct.js


function _construct(t, e, r) {
  if ((0,isNativeReflectConstruct/* default */.Z)()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && (0,setPrototypeOf/* default */.Z)(p, r.prototype), p;
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js




function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, (0,getPrototypeOf/* default */.Z)(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), (0,setPrototypeOf/* default */.Z)(Wrapper, t);
  }, _wrapNativeSuper(t);
}

;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/util.js
/* provided dependency */ var process = __webpack_require__(554);










/* eslint no-console:0 */

var formatRegExp = /%[sdj%]/g;
var util_warning = function warning() {};

// don't print warning message when in production env or node runtime
if (typeof process !== 'undefined' && process.env && "production" !== 'production' && 0 && 0) {}
function convertFieldsError(errors) {
  if (!errors || !errors.length) return null;
  var fields = {};
  errors.forEach(function (error) {
    var field = error.field;
    fields[field] = fields[field] || [];
    fields[field].push(error);
  });
  return fields;
}
function format(template) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  var i = 0;
  var len = args.length;
  if (typeof template === 'function') {
    // eslint-disable-next-line prefer-spread
    return template.apply(null, args);
  }
  if (typeof template === 'string') {
    var str = template.replace(formatRegExp, function (x) {
      if (x === '%%') {
        return '%';
      }
      if (i >= len) {
        return x;
      }
      switch (x) {
        case '%s':
          return String(args[i++]);
        case '%d':
          return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
          break;
        default:
          return x;
      }
    });
    return str;
  }
  return template;
}
function isNativeStringType(type) {
  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'date' || type === 'pattern';
}
function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }
  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type) && typeof value === 'string' && !value) {
    return true;
  }
  return false;
}
function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}
function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;
  function count(errors) {
    results.push.apply(results, (0,toConsumableArray/* default */.Z)(errors || []));
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }
  arr.forEach(function (a) {
    func(a, count);
  });
}
function asyncSerialArray(arr, func, callback) {
  var index = 0;
  var arrLength = arr.length;
  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index;
    index = index + 1;
    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }
  next([]);
}
function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function (k) {
    ret.push.apply(ret, (0,toConsumableArray/* default */.Z)(objArr[k] || []));
  });
  return ret;
}
var AsyncValidationError = /*#__PURE__*/function (_Error) {
  (0,inherits/* default */.Z)(AsyncValidationError, _Error);
  var _super = (0,createSuper/* default */.Z)(AsyncValidationError);
  function AsyncValidationError(errors, fields) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, AsyncValidationError);
    _this = _super.call(this, 'Async Validation Error');
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "errors", void 0);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "fields", void 0);
    _this.errors = errors;
    _this.fields = fields;
    return _this;
  }
  return (0,createClass/* default */.Z)(AsyncValidationError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
function asyncMap(objArr, option, func, callback, source) {
  if (option.first) {
    var _pending = new Promise(function (resolve, reject) {
      var next = function next(errors) {
        callback(errors);
        return errors.length ? reject(new AsyncValidationError(errors, convertFieldsError(errors))) : resolve(source);
      };
      var flattenArr = flattenObjArr(objArr);
      asyncSerialArray(flattenArr, func, next);
    });
    _pending.catch(function (e) {
      return e;
    });
    return _pending;
  }
  var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function (resolve, reject) {
    var next = function next(errors) {
      // eslint-disable-next-line prefer-spread
      results.push.apply(results, errors);
      total++;
      if (total === objArrLength) {
        callback(results);
        return results.length ? reject(new AsyncValidationError(results, convertFieldsError(results))) : resolve(source);
      }
    };
    if (!objArrKeys.length) {
      callback(results);
      resolve(source);
    }
    objArrKeys.forEach(function (key) {
      var arr = objArr[key];
      if (firstFields.indexOf(key) !== -1) {
        asyncSerialArray(arr, func, next);
      } else {
        asyncParallelArray(arr, func, next);
      }
    });
  });
  pending.catch(function (e) {
    return e;
  });
  return pending;
}
function isErrorObj(obj) {
  return !!(obj && obj.message !== undefined);
}
function getValue(value, path) {
  var v = value;
  for (var i = 0; i < path.length; i++) {
    if (v == undefined) {
      return v;
    }
    v = v[path[i]];
  }
  return v;
}
function complementError(rule, source) {
  return function (oe) {
    var fieldValue;
    if (rule.fullFields) {
      fieldValue = getValue(source, rule.fullFields);
    } else {
      fieldValue = source[oe.field || rule.fullField];
    }
    if (isErrorObj(oe)) {
      oe.field = oe.field || rule.fullField;
      oe.fieldValue = fieldValue;
      return oe;
    }
    return {
      message: typeof oe === 'function' ? oe() : oe,
      fieldValue: fieldValue,
      field: oe.field || rule.fullField
    };
  };
}
function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];
        if ((0,esm_typeof/* default */.Z)(value) === 'object' && (0,esm_typeof/* default */.Z)(target[s]) === 'object') {
          target[s] = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, target[s]), value);
        } else {
          target[s] = value;
        }
      }
    }
  }
  return target;
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/rule/enum.js

var ENUM = 'enum';
var enumerable = function enumerable(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(format(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
  }
};
/* harmony default export */ var rule_enum = (enumerable);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/rule/pattern.js

var pattern = function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
      // flag is accidentally set to `true`, which in a validation scenario
      // is not necessary and the result might be misleading
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === 'string') {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
};
/* harmony default export */ var rule_pattern = (pattern);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/rule/range.js

var range = function range(rule, value, source, errors, options) {
  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number';
  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === 'number';
  var str = typeof value === 'string';
  var arr = Array.isArray(value);
  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  }
  // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".length !== 3
    val = value.replace(spRegexp, '_').length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(format(options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(format(options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(format(options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(format(options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
};
/* harmony default export */ var rule_range = (range);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/rule/required.js

var required = function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || isEmptyValue(value, type || rule.type))) {
    errors.push(format(options.messages.required, rule.fullField));
  }
};
/* harmony default export */ var rule_required = (required);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/rule/url.js
// https://github.com/kevva/url-regex/blob/master/index.js
var urlReg;
/* harmony default export */ var rule_url = (function () {
  if (urlReg) {
    return urlReg;
  }
  var word = '[a-fA-F\\d:]';
  var b = function b(options) {
    return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(word, ")|(?<=").concat(word, ")(?=\\s|$))") : '';
  };
  var v4 = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}';
  var v6seg = '[a-fA-F\\d]{1,4}';
  var v6List = ["(?:".concat(v6seg, ":){7}(?:").concat(v6seg, "|:)"),
  // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
  "(?:".concat(v6seg, ":){6}(?:").concat(v4, "|:").concat(v6seg, "|:)"),
  // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::
  "(?:".concat(v6seg, ":){5}(?::").concat(v4, "|(?::").concat(v6seg, "){1,2}|:)"),
  // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::
  "(?:".concat(v6seg, ":){4}(?:(?::").concat(v6seg, "){0,1}:").concat(v4, "|(?::").concat(v6seg, "){1,3}|:)"),
  // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::
  "(?:".concat(v6seg, ":){3}(?:(?::").concat(v6seg, "){0,2}:").concat(v4, "|(?::").concat(v6seg, "){1,4}|:)"),
  // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::
  "(?:".concat(v6seg, ":){2}(?:(?::").concat(v6seg, "){0,3}:").concat(v4, "|(?::").concat(v6seg, "){1,5}|:)"),
  // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::
  "(?:".concat(v6seg, ":){1}(?:(?::").concat(v6seg, "){0,4}:").concat(v4, "|(?::").concat(v6seg, "){1,6}|:)"),
  // 1::              1::3:4:5:6:7:8   1::8            1::
  "(?::(?:(?::".concat(v6seg, "){0,5}:").concat(v4, "|(?::").concat(v6seg, "){1,7}|:))") // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
  ];
  var v6Eth0 = "(?:%[0-9a-zA-Z]{1,})?"; // %eth0            %1

  var v6 = "(?:".concat(v6List.join('|'), ")").concat(v6Eth0);

  // Pre-compile only the exact regexes because adding a global flag make regexes stateful
  var v46Exact = new RegExp("(?:^".concat(v4, "$)|(?:^").concat(v6, "$)"));
  var v4exact = new RegExp("^".concat(v4, "$"));
  var v6exact = new RegExp("^".concat(v6, "$"));
  var ip = function ip(options) {
    return options && options.exact ? v46Exact : new RegExp("(?:".concat(b(options)).concat(v4).concat(b(options), ")|(?:").concat(b(options)).concat(v6).concat(b(options), ")"), 'g');
  };
  ip.v4 = function (options) {
    return options && options.exact ? v4exact : new RegExp("".concat(b(options)).concat(v4).concat(b(options)), 'g');
  };
  ip.v6 = function (options) {
    return options && options.exact ? v6exact : new RegExp("".concat(b(options)).concat(v6).concat(b(options)), 'g');
  };
  var protocol = "(?:(?:[a-z]+:)?//)";
  var auth = '(?:\\S+(?::\\S*)?@)?';
  var ipv4 = ip.v4().source;
  var ipv6 = ip.v6().source;
  var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
  var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
  var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
  var port = '(?::\\d{2,5})?';
  var path = '(?:[/?#][^\\s"]*)?';
  var regex = "(?:".concat(protocol, "|www\\.)").concat(auth, "(?:localhost|").concat(ipv4, "|").concat(ipv6, "|").concat(host).concat(domain).concat(tld, ")").concat(port).concat(path);
  urlReg = new RegExp("(?:^".concat(regex, "$)"), 'i');
  return urlReg;
});
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/rule/type.js




/* eslint max-len:0 */

var type_pattern = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  float: function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function' && !isNaN(value.getTime());
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === 'number';
  },
  object: function object(value) {
    return (0,esm_typeof/* default */.Z)(value) === 'object' && !types.array(value);
  },
  method: function method(value) {
    return typeof value === 'function';
  },
  email: function email(value) {
    return typeof value === 'string' && value.length <= 320 && !!value.match(type_pattern.email);
  },
  url: function url(value) {
    return typeof value === 'string' && value.length <= 2048 && !!value.match(rule_url());
  },
  hex: function hex(value) {
    return typeof value === 'string' && !!value.match(type_pattern.hex);
  }
};
var type = function type(rule, value, source, errors, options) {
  if (rule.required && value === undefined) {
    rule_required(rule, value, source, errors, options);
    return;
  }
  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(format(options.messages.types[ruleType], rule.fullField, rule.type));
    }
    // straight typeof check
  } else if (ruleType && (0,esm_typeof/* default */.Z)(value) !== rule.type) {
    errors.push(format(options.messages.types[ruleType], rule.fullField, rule.type));
  }
};
/* harmony default export */ var rule_type = (type);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/rule/whitespace.js


/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
var whitespace = function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === '') {
    errors.push(format(options.messages.whitespace, rule.fullField));
  }
};
/* harmony default export */ var rule_whitespace = (whitespace);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/rule/index.js






/* harmony default export */ var es_rule = ({
  required: rule_required,
  whitespace: rule_whitespace,
  type: rule_type,
  range: rule_range,
  enum: rule_enum,
  pattern: rule_pattern
});
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/validator/any.js


var any = function any(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    es_rule.required(rule, value, source, errors, options);
  }
  callback(errors);
};
/* harmony default export */ var validator_any = (any);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/validator/array.js

var array = function array(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((value === undefined || value === null) && !rule.required) {
      return callback();
    }
    es_rule.required(rule, value, source, errors, options, 'array');
    if (value !== undefined && value !== null) {
      es_rule.type(rule, value, source, errors, options);
      es_rule.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
/* harmony default export */ var validator_array = (array);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/validator/boolean.js


var boolean_boolean = function boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    es_rule.required(rule, value, source, errors, options);
    if (value !== undefined) {
      es_rule.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
/* harmony default export */ var validator_boolean = (boolean_boolean);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/validator/date.js


var date = function date(rule, value, callback, source, options) {
  // console.log('integer rule called %j', rule);
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  // console.log('validate on %s value', value);
  if (validate) {
    if (isEmptyValue(value, 'date') && !rule.required) {
      return callback();
    }
    es_rule.required(rule, value, source, errors, options);
    if (!isEmptyValue(value, 'date')) {
      var dateObject;
      if (value instanceof Date) {
        dateObject = value;
      } else {
        dateObject = new Date(value);
      }
      es_rule.type(rule, dateObject, source, errors, options);
      if (dateObject) {
        es_rule.range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
};
/* harmony default export */ var validator_date = (date);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/validator/enum.js


var enum_ENUM = 'enum';
var enum_enumerable = function enumerable(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    es_rule.required(rule, value, source, errors, options);
    if (value !== undefined) {
      es_rule[enum_ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
};
/* harmony default export */ var validator_enum = (enum_enumerable);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/validator/float.js


var floatFn = function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    es_rule.required(rule, value, source, errors, options);
    if (value !== undefined) {
      es_rule.type(rule, value, source, errors, options);
      es_rule.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
/* harmony default export */ var validator_float = (floatFn);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/validator/integer.js


var integer = function integer(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    es_rule.required(rule, value, source, errors, options);
    if (value !== undefined) {
      es_rule.type(rule, value, source, errors, options);
      es_rule.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
/* harmony default export */ var validator_integer = (integer);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/validator/method.js


var method = function method(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    es_rule.required(rule, value, source, errors, options);
    if (value !== undefined) {
      es_rule.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
/* harmony default export */ var validator_method = (method);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/validator/number.js


var number = function number(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (value === '') {
      // eslint-disable-next-line no-param-reassign
      value = undefined;
    }
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    es_rule.required(rule, value, source, errors, options);
    if (value !== undefined) {
      es_rule.type(rule, value, source, errors, options);
      es_rule.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
/* harmony default export */ var validator_number = (number);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/validator/object.js


var object = function object(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    es_rule.required(rule, value, source, errors, options);
    if (value !== undefined) {
      es_rule.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
/* harmony default export */ var validator_object = (object);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/validator/pattern.js


var pattern_pattern = function pattern(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, 'string') && !rule.required) {
      return callback();
    }
    es_rule.required(rule, value, source, errors, options);
    if (!isEmptyValue(value, 'string')) {
      es_rule.pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
/* harmony default export */ var validator_pattern = (pattern_pattern);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/validator/regexp.js


var regexp = function regexp(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    es_rule.required(rule, value, source, errors, options);
    if (!isEmptyValue(value)) {
      es_rule.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
/* harmony default export */ var validator_regexp = (regexp);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/validator/required.js


var required_required = function required(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : (0,esm_typeof/* default */.Z)(value);
  es_rule.required(rule, value, source, errors, options, type);
  callback(errors);
};
/* harmony default export */ var validator_required = (required_required);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/validator/string.js


var string = function string(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, 'string') && !rule.required) {
      return callback();
    }
    es_rule.required(rule, value, source, errors, options, 'string');
    if (!isEmptyValue(value, 'string')) {
      es_rule.type(rule, value, source, errors, options);
      es_rule.range(rule, value, source, errors, options);
      es_rule.pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        es_rule.whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
};
/* harmony default export */ var validator_string = (string);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/validator/type.js


var type_type = function type(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, ruleType) && !rule.required) {
      return callback();
    }
    es_rule.required(rule, value, source, errors, options, ruleType);
    if (!isEmptyValue(value, ruleType)) {
      es_rule.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
/* harmony default export */ var validator_type = (type_type);
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/validator/index.js















/* harmony default export */ var es_validator = ({
  string: validator_string,
  method: validator_method,
  number: validator_number,
  boolean: validator_boolean,
  regexp: validator_regexp,
  integer: validator_integer,
  float: validator_float,
  array: validator_array,
  object: validator_object,
  enum: validator_enum,
  pattern: validator_pattern,
  date: validator_date,
  url: validator_type,
  hex: validator_type,
  email: validator_type,
  required: validator_required,
  any: validator_any
});
;// CONCATENATED MODULE: ./node_modules/@rc-component/async-validator/es/index.js











/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */
var Schema = /*#__PURE__*/function () {
  function Schema(descriptor) {
    (0,classCallCheck/* default */.Z)(this, Schema);
    // ======================== Instance ========================
    (0,defineProperty/* default */.Z)(this, "rules", null);
    (0,defineProperty/* default */.Z)(this, "_messages", messages_messages);
    this.define(descriptor);
  }
  (0,createClass/* default */.Z)(Schema, [{
    key: "define",
    value: function define(rules) {
      var _this = this;
      if (!rules) {
        throw new Error('Cannot configure a schema with no rules');
      }
      if ((0,esm_typeof/* default */.Z)(rules) !== 'object' || Array.isArray(rules)) {
        throw new Error('Rules must be an object');
      }
      this.rules = {};
      Object.keys(rules).forEach(function (name) {
        var item = rules[name];
        _this.rules[name] = Array.isArray(item) ? item : [item];
      });
    }
  }, {
    key: "messages",
    value: function messages(_messages) {
      if (_messages) {
        this._messages = deepMerge(newMessages(), _messages);
      }
      return this._messages;
    }
  }, {
    key: "validate",
    value: function validate(source_) {
      var _this2 = this;
      var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var oc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
      var source = source_;
      var options = o;
      var callback = oc;
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }
      if (!this.rules || Object.keys(this.rules).length === 0) {
        if (callback) {
          callback(null, source);
        }
        return Promise.resolve(source);
      }
      function complete(results) {
        var errors = [];
        var fields = {};
        function add(e) {
          if (Array.isArray(e)) {
            var _errors;
            errors = (_errors = errors).concat.apply(_errors, (0,toConsumableArray/* default */.Z)(e));
          } else {
            errors.push(e);
          }
        }
        for (var i = 0; i < results.length; i++) {
          add(results[i]);
        }
        if (!errors.length) {
          callback(null, source);
        } else {
          fields = convertFieldsError(errors);
          callback(errors, fields);
        }
      }
      if (options.messages) {
        var messages = this.messages();
        if (messages === messages_messages) {
          messages = newMessages();
        }
        deepMerge(messages, options.messages);
        options.messages = messages;
      } else {
        options.messages = this.messages();
      }
      var series = {};
      var keys = options.keys || Object.keys(this.rules);
      keys.forEach(function (z) {
        var arr = _this2.rules[z];
        var value = source[z];
        arr.forEach(function (r) {
          var rule = r;
          if (typeof rule.transform === 'function') {
            if (source === source_) {
              source = (0,objectSpread2/* default */.Z)({}, source);
            }
            value = source[z] = rule.transform(value);
            if (value !== undefined && value !== null) {
              rule.type = rule.type || (Array.isArray(value) ? 'array' : (0,esm_typeof/* default */.Z)(value));
            }
          }
          if (typeof rule === 'function') {
            rule = {
              validator: rule
            };
          } else {
            rule = (0,objectSpread2/* default */.Z)({}, rule);
          }

          // Fill validator. Skip if nothing need to validate
          rule.validator = _this2.getValidationMethod(rule);
          if (!rule.validator) {
            return;
          }
          rule.field = z;
          rule.fullField = rule.fullField || z;
          rule.type = _this2.getType(rule);
          series[z] = series[z] || [];
          series[z].push({
            rule: rule,
            value: value,
            source: source,
            field: z
          });
        });
      });
      var errorFields = {};
      return asyncMap(series, options, function (data, doIt) {
        var rule = data.rule;
        var deep = (rule.type === 'object' || rule.type === 'array') && ((0,esm_typeof/* default */.Z)(rule.fields) === 'object' || (0,esm_typeof/* default */.Z)(rule.defaultField) === 'object');
        deep = deep && (rule.required || !rule.required && data.value);
        rule.field = data.field;
        function addFullField(key, schema) {
          return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, schema), {}, {
            fullField: "".concat(rule.fullField, ".").concat(key),
            fullFields: rule.fullFields ? [].concat((0,toConsumableArray/* default */.Z)(rule.fullFields), [key]) : [key]
          });
        }
        function cb() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          var errorList = Array.isArray(e) ? e : [e];
          if (!options.suppressWarning && errorList.length) {
            Schema.warning('async-validator:', errorList);
          }
          if (errorList.length && rule.message !== undefined) {
            errorList = [].concat(rule.message);
          }

          // Fill error info
          var filledErrors = errorList.map(complementError(rule, source));
          if (options.first && filledErrors.length) {
            errorFields[rule.field] = 1;
            return doIt(filledErrors);
          }
          if (!deep) {
            doIt(filledErrors);
          } else {
            // if rule is required but the target object
            // does not exist fail at the rule level and don't
            // go deeper
            if (rule.required && !data.value) {
              if (rule.message !== undefined) {
                filledErrors = [].concat(rule.message).map(complementError(rule, source));
              } else if (options.error) {
                filledErrors = [options.error(rule, format(options.messages.required, rule.field))];
              }
              return doIt(filledErrors);
            }
            var fieldsSchema = {};
            if (rule.defaultField) {
              Object.keys(data.value).map(function (key) {
                fieldsSchema[key] = rule.defaultField;
              });
            }
            fieldsSchema = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, fieldsSchema), data.rule.fields);
            var paredFieldsSchema = {};
            Object.keys(fieldsSchema).forEach(function (field) {
              var fieldSchema = fieldsSchema[field];
              var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [fieldSchema];
              paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
            });
            var schema = new Schema(paredFieldsSchema);
            schema.messages(options.messages);
            if (data.rule.options) {
              data.rule.options.messages = options.messages;
              data.rule.options.error = options.error;
            }
            schema.validate(data.value, data.rule.options || options, function (errs) {
              var finalErrors = [];
              if (filledErrors && filledErrors.length) {
                finalErrors.push.apply(finalErrors, (0,toConsumableArray/* default */.Z)(filledErrors));
              }
              if (errs && errs.length) {
                finalErrors.push.apply(finalErrors, (0,toConsumableArray/* default */.Z)(errs));
              }
              doIt(finalErrors.length ? finalErrors : null);
            });
          }
        }
        var res;
        if (rule.asyncValidator) {
          res = rule.asyncValidator(rule, data.value, cb, data.source, options);
        } else if (rule.validator) {
          try {
            res = rule.validator(rule, data.value, cb, data.source, options);
          } catch (error) {
            var _console$error, _console;
            (_console$error = (_console = console).error) === null || _console$error === void 0 || _console$error.call(_console, error);
            // rethrow to report error
            if (!options.suppressValidatorError) {
              setTimeout(function () {
                throw error;
              }, 0);
            }
            cb(error.message);
          }
          if (res === true) {
            cb();
          } else if (res === false) {
            cb(typeof rule.message === 'function' ? rule.message(rule.fullField || rule.field) : rule.message || "".concat(rule.fullField || rule.field, " fails"));
          } else if (res instanceof Array) {
            cb(res);
          } else if (res instanceof Error) {
            cb(res.message);
          }
        }
        if (res && res.then) {
          res.then(function () {
            return cb();
          }, function (e) {
            return cb(e);
          });
        }
      }, function (results) {
        complete(results);
      }, source);
    }
  }, {
    key: "getType",
    value: function getType(rule) {
      if (rule.type === undefined && rule.pattern instanceof RegExp) {
        rule.type = 'pattern';
      }
      if (typeof rule.validator !== 'function' && rule.type && !es_validator.hasOwnProperty(rule.type)) {
        throw new Error(format('Unknown rule type %s', rule.type));
      }
      return rule.type || 'string';
    }
  }, {
    key: "getValidationMethod",
    value: function getValidationMethod(rule) {
      if (typeof rule.validator === 'function') {
        return rule.validator;
      }
      var keys = Object.keys(rule);
      var messageIndex = keys.indexOf('message');
      if (messageIndex !== -1) {
        keys.splice(messageIndex, 1);
      }
      if (keys.length === 1 && keys[0] === 'required') {
        return es_validator.required;
      }
      return es_validator[this.getType(rule)] || undefined;
    }
  }]);
  return Schema;
}();
// ========================= Static =========================
(0,defineProperty/* default */.Z)(Schema, "register", function register(type, validator) {
  if (typeof validator !== 'function') {
    throw new Error('Cannot register a validator by type, validator is not a function');
  }
  es_validator[type] = validator;
});
(0,defineProperty/* default */.Z)(Schema, "warning", util_warning);
(0,defineProperty/* default */.Z)(Schema, "messages", messages_messages);
(0,defineProperty/* default */.Z)(Schema, "validators", es_validator);
/* harmony default export */ var es = (Schema);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/utils/messages.js
var typeTemplate = "'${name}' is not a valid ${type}";
var defaultValidateMessages = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: typeTemplate,
    method: typeTemplate,
    array: typeTemplate,
    object: typeTemplate,
    number: typeTemplate,
    date: typeTemplate,
    boolean: typeTemplate,
    integer: typeTemplate,
    float: typeTemplate,
    regexp: typeTemplate,
    email: typeTemplate,
    url: typeTemplate,
    hex: typeTemplate
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
};
// EXTERNAL MODULE: ./node_modules/rc-util/es/utils/set.js
var set = __webpack_require__(57935);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/utils/validateUtil.js











// Remove incorrect original ts define
var AsyncValidator = es;

/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */
function replaceMessage(template, kv) {
  return template.replace(/\\?\$\{\w+\}/g, function (str) {
    if (str.startsWith('\\')) {
      return str.slice(1);
    }
    var key = str.slice(2, -1);
    return kv[key];
  });
}
var CODE_LOGIC_ERROR = 'CODE_LOGIC_ERROR';
function validateRule(_x, _x2, _x3, _x4, _x5) {
  return _validateRule.apply(this, arguments);
}
/**
 * We use `async-validator` to validate the value.
 * But only check one value in a time to avoid namePath validate issue.
 */
function _validateRule() {
  _validateRule = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(name, value, rule, options, messageVariables) {
    var cloneRule, originValidator, subRuleField, validator, messages, result, subResults, kv, fillVariableResult;
    return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          cloneRule = (0,objectSpread2/* default */.Z)({}, rule); // Bug of `async-validator`
          // https://github.com/react-component/field-form/issues/316
          // https://github.com/react-component/field-form/issues/313
          delete cloneRule.ruleIndex;

          // https://github.com/ant-design/ant-design/issues/40497#issuecomment-1422282378
          AsyncValidator.warning = function () {
            return void 0;
          };
          if (cloneRule.validator) {
            originValidator = cloneRule.validator;
            cloneRule.validator = function () {
              try {
                return originValidator.apply(void 0, arguments);
              } catch (error) {
                console.error(error);
                return Promise.reject(CODE_LOGIC_ERROR);
              }
            };
          }

          // We should special handle array validate
          subRuleField = null;
          if (cloneRule && cloneRule.type === 'array' && cloneRule.defaultField) {
            subRuleField = cloneRule.defaultField;
            delete cloneRule.defaultField;
          }
          validator = new AsyncValidator((0,defineProperty/* default */.Z)({}, name, [cloneRule]));
          messages = (0,set/* merge */.T)(defaultValidateMessages, options.validateMessages);
          validator.messages(messages);
          result = [];
          _context2.prev = 10;
          _context2.next = 13;
          return Promise.resolve(validator.validate((0,defineProperty/* default */.Z)({}, name, value), (0,objectSpread2/* default */.Z)({}, options)));
        case 13:
          _context2.next = 18;
          break;
        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](10);
          if (_context2.t0.errors) {
            result = _context2.t0.errors.map(function (_ref4, index) {
              var message = _ref4.message;
              var mergedMessage = message === CODE_LOGIC_ERROR ? messages.default : message;
              return /*#__PURE__*/react.isValidElement(mergedMessage) ? /*#__PURE__*/
              // Wrap ReactNode with `key`
              react.cloneElement(mergedMessage, {
                key: "error_".concat(index)
              }) : mergedMessage;
            });
          }
        case 18:
          if (!(!result.length && subRuleField)) {
            _context2.next = 23;
            break;
          }
          _context2.next = 21;
          return Promise.all(value.map(function (subValue, i) {
            return validateRule("".concat(name, ".").concat(i), subValue, subRuleField, options, messageVariables);
          }));
        case 21:
          subResults = _context2.sent;
          return _context2.abrupt("return", subResults.reduce(function (prev, errors) {
            return [].concat((0,toConsumableArray/* default */.Z)(prev), (0,toConsumableArray/* default */.Z)(errors));
          }, []));
        case 23:
          // Replace message with variables
          kv = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, rule), {}, {
            name: name,
            enum: (rule.enum || []).join(', ')
          }, messageVariables);
          fillVariableResult = result.map(function (error) {
            if (typeof error === 'string') {
              return replaceMessage(error, kv);
            }
            return error;
          });
          return _context2.abrupt("return", fillVariableResult);
        case 26:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[10, 15]]);
  }));
  return _validateRule.apply(this, arguments);
}
function validateRules(namePath, value, rules, options, validateFirst, messageVariables) {
  var name = namePath.join('.');

  // Fill rule with context
  var filledRules = rules.map(function (currentRule, ruleIndex) {
    var originValidatorFunc = currentRule.validator;
    var cloneRule = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, currentRule), {}, {
      ruleIndex: ruleIndex
    });

    // Replace validator if needed
    if (originValidatorFunc) {
      cloneRule.validator = function (rule, val, callback) {
        var hasPromise = false;

        // Wrap callback only accept when promise not provided
        var wrappedCallback = function wrappedCallback() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          // Wait a tick to make sure return type is a promise
          Promise.resolve().then(function () {
            (0,warning/* default */.ZP)(!hasPromise, 'Your validator function has already return a promise. `callback` will be ignored.');
            if (!hasPromise) {
              callback.apply(void 0, args);
            }
          });
        };

        // Get promise
        var promise = originValidatorFunc(rule, val, wrappedCallback);
        hasPromise = promise && typeof promise.then === 'function' && typeof promise.catch === 'function';

        /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */
        (0,warning/* default */.ZP)(hasPromise, '`callback` is deprecated. Please return a promise instead.');
        if (hasPromise) {
          promise.then(function () {
            callback();
          }).catch(function (err) {
            callback(err || ' ');
          });
        }
      };
    }
    return cloneRule;
  }).sort(function (_ref, _ref2) {
    var w1 = _ref.warningOnly,
      i1 = _ref.ruleIndex;
    var w2 = _ref2.warningOnly,
      i2 = _ref2.ruleIndex;
    if (!!w1 === !!w2) {
      // Let keep origin order
      return i1 - i2;
    }
    if (w1) {
      return 1;
    }
    return -1;
  });

  // Do validate rules
  var summaryPromise;
  if (validateFirst === true) {
    // >>>>> Validate by serialization
    summaryPromise = new Promise(/*#__PURE__*/function () {
      var _ref3 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(resolve, reject) {
        var i, rule, errors;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              i = 0;
            case 1:
              if (!(i < filledRules.length)) {
                _context.next = 12;
                break;
              }
              rule = filledRules[i];
              _context.next = 5;
              return validateRule(name, value, rule, options, messageVariables);
            case 5:
              errors = _context.sent;
              if (!errors.length) {
                _context.next = 9;
                break;
              }
              reject([{
                errors: errors,
                rule: rule
              }]);
              return _context.abrupt("return");
            case 9:
              i += 1;
              _context.next = 1;
              break;
            case 12:
              /* eslint-enable */

              resolve([]);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x6, _x7) {
        return _ref3.apply(this, arguments);
      };
    }());
  } else {
    // >>>>> Validate by parallel
    var rulePromises = filledRules.map(function (rule) {
      return validateRule(name, value, rule, options, messageVariables).then(function (errors) {
        return {
          errors: errors,
          rule: rule
        };
      });
    });
    summaryPromise = (validateFirst ? finishOnFirstFailed(rulePromises) : finishOnAllFailed(rulePromises)).then(function (errors) {
      // Always change to rejection for Field to catch
      return Promise.reject(errors);
    });
  }

  // Internal catch error to avoid console error log.
  summaryPromise.catch(function (e) {
    return e;
  });
  return summaryPromise;
}
function finishOnAllFailed(_x8) {
  return _finishOnAllFailed.apply(this, arguments);
}
function _finishOnAllFailed() {
  _finishOnAllFailed = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3(rulePromises) {
    return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", Promise.all(rulePromises).then(function (errorsList) {
            var _ref5;
            var errors = (_ref5 = []).concat.apply(_ref5, (0,toConsumableArray/* default */.Z)(errorsList));
            return errors;
          }));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _finishOnAllFailed.apply(this, arguments);
}
function finishOnFirstFailed(_x9) {
  return _finishOnFirstFailed.apply(this, arguments);
}
function _finishOnFirstFailed() {
  _finishOnFirstFailed = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee4(rulePromises) {
    var count;
    return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          count = 0;
          return _context4.abrupt("return", new Promise(function (resolve) {
            rulePromises.forEach(function (promise) {
              promise.then(function (ruleError) {
                if (ruleError.errors.length) {
                  resolve([ruleError]);
                }
                count += 1;
                if (count === rulePromises.length) {
                  resolve([]);
                }
              });
            });
          }));
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _finishOnFirstFailed.apply(this, arguments);
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/utils/get.js
var get = __webpack_require__(20713);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/utils/valueUtil.js







/**
 * Convert name to internal supported format.
 * This function should keep since we still thinking if need support like `a.b.c` format.
 * 'a' => ['a']
 * 123 => [123]
 * ['a', 123] => ['a', 123]
 */
function getNamePath(path) {
  return typeUtil_toArray(path);
}
function cloneByNamePathList(store, namePathList) {
  var newStore = {};
  namePathList.forEach(function (namePath) {
    var value = (0,get/* default */.Z)(store, namePath);
    newStore = (0,set/* default */.Z)(newStore, namePath, value);
  });
  return newStore;
}

/**
 * Check if `namePathList` includes `namePath`.
 * @param namePathList A list of `InternalNamePath[]`
 * @param namePath Compare `InternalNamePath`
 * @param partialMatch True will make `[a, b]` match `[a, b, c]`
 */
function containsNamePath(namePathList, namePath) {
  var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return namePathList && namePathList.some(function (path) {
    return matchNamePath(namePath, path, partialMatch);
  });
}

/**
 * Check if `namePath` is super set or equal of `subNamePath`.
 * @param namePath A list of `InternalNamePath[]`
 * @param subNamePath Compare `InternalNamePath`
 * @param partialMatch True will make `[a, b]` match `[a, b, c]`
 */
function matchNamePath(namePath, subNamePath) {
  var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!namePath || !subNamePath) {
    return false;
  }
  if (!partialMatch && namePath.length !== subNamePath.length) {
    return false;
  }
  return subNamePath.every(function (nameUnit, i) {
    return namePath[i] === nameUnit;
  });
}

// Like `shallowEqual`, but we not check the data which may cause re-render

function isSimilar(source, target) {
  if (source === target) {
    return true;
  }
  if (!source && target || source && !target) {
    return false;
  }
  if (!source || !target || (0,esm_typeof/* default */.Z)(source) !== 'object' || (0,esm_typeof/* default */.Z)(target) !== 'object') {
    return false;
  }
  var sourceKeys = Object.keys(source);
  var targetKeys = Object.keys(target);
  var keys = new Set([].concat(sourceKeys, targetKeys));
  return (0,toConsumableArray/* default */.Z)(keys).every(function (key) {
    var sourceValue = source[key];
    var targetValue = target[key];
    if (typeof sourceValue === 'function' && typeof targetValue === 'function') {
      return true;
    }
    return sourceValue === targetValue;
  });
}
function defaultGetValueFromEvent(valuePropName) {
  var event = arguments.length <= 1 ? undefined : arguments[1];
  if (event && event.target && (0,esm_typeof/* default */.Z)(event.target) === 'object' && valuePropName in event.target) {
    return event.target[valuePropName];
  }
  return event;
}

/**
 * Moves an array item from one position in an array to another.
 *
 * Note: This is a pure function so a new array will be returned, instead
 * of altering the array argument.
 *
 * @param array         Array in which to move an item.         (required)
 * @param moveIndex     The index of the item to move.          (required)
 * @param toIndex       The index to move item at moveIndex to. (required)
 */
function valueUtil_move(array, moveIndex, toIndex) {
  var length = array.length;
  if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) {
    return array;
  }
  var item = array[moveIndex];
  var diff = moveIndex - toIndex;
  if (diff > 0) {
    // move left
    return [].concat((0,toConsumableArray/* default */.Z)(array.slice(0, toIndex)), [item], (0,toConsumableArray/* default */.Z)(array.slice(toIndex, moveIndex)), (0,toConsumableArray/* default */.Z)(array.slice(moveIndex + 1, length)));
  }
  if (diff < 0) {
    // move right
    return [].concat((0,toConsumableArray/* default */.Z)(array.slice(0, moveIndex)), (0,toConsumableArray/* default */.Z)(array.slice(moveIndex + 1, toIndex + 1)), [item], (0,toConsumableArray/* default */.Z)(array.slice(toIndex + 1, length)));
  }
  return array;
}
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/Field.js












var _excluded = ["name"];









var EMPTY_ERRORS = [];
function requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
  if (typeof shouldUpdate === 'function') {
    return shouldUpdate(prev, next, 'source' in info ? {
      source: info.source
    } : {});
  }
  return prevValue !== nextValue;
}

// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
// We use Class instead of Hooks here since it will cost much code by using Hooks.
var Field = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(Field, _React$Component);
  var _super = (0,createSuper/* default */.Z)(Field);
  // ============================== Subscriptions ==============================
  function Field(props) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, Field);
    _this = _super.call(this, props);

    // Register on init
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "state", {
      resetCount: 0
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "cancelRegisterFunc", null);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "mounted", false);
    /**
     * Follow state should not management in State since it will async update by React.
     * This makes first render of form can not get correct state value.
     */
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "touched", false);
    /**
     * Mark when touched & validated. Currently only used for `dependencies`.
     * Note that we do not think field with `initialValue` is dirty
     * but this will be by `isFieldDirty` func.
     */
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "dirty", false);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "validatePromise", void 0);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "prevValidating", void 0);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "errors", EMPTY_ERRORS);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "warnings", EMPTY_ERRORS);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "cancelRegister", function () {
      var _this$props = _this.props,
        preserve = _this$props.preserve,
        isListField = _this$props.isListField,
        name = _this$props.name;
      if (_this.cancelRegisterFunc) {
        _this.cancelRegisterFunc(isListField, preserve, getNamePath(name));
      }
      _this.cancelRegisterFunc = null;
    });
    // ================================== Utils ==================================
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "getNamePath", function () {
      var _this$props2 = _this.props,
        name = _this$props2.name,
        fieldContext = _this$props2.fieldContext;
      var _fieldContext$prefixN = fieldContext.prefixName,
        prefixName = _fieldContext$prefixN === void 0 ? [] : _fieldContext$prefixN;
      return name !== undefined ? [].concat((0,toConsumableArray/* default */.Z)(prefixName), (0,toConsumableArray/* default */.Z)(name)) : [];
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "getRules", function () {
      var _this$props3 = _this.props,
        _this$props3$rules = _this$props3.rules,
        rules = _this$props3$rules === void 0 ? [] : _this$props3$rules,
        fieldContext = _this$props3.fieldContext;
      return rules.map(function (rule) {
        if (typeof rule === 'function') {
          return rule(fieldContext);
        }
        return rule;
      });
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "refresh", function () {
      if (!_this.mounted) return;

      /**
       * Clean up current node.
       */
      _this.setState(function (_ref) {
        var resetCount = _ref.resetCount;
        return {
          resetCount: resetCount + 1
        };
      });
    });
    // Event should only trigger when meta changed
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "metaCache", null);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "triggerMetaEvent", function (destroy) {
      var onMetaChange = _this.props.onMetaChange;
      if (onMetaChange) {
        var _meta = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, _this.getMeta()), {}, {
          destroy: destroy
        });
        if (!(0,isEqual/* default */.Z)(_this.metaCache, _meta)) {
          onMetaChange(_meta);
        }
        _this.metaCache = _meta;
      } else {
        _this.metaCache = null;
      }
    });
    // ========================= Field Entity Interfaces =========================
    // Trigger by store update. Check if need update the component
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onStoreChange", function (prevStore, namePathList, info) {
      var _this$props4 = _this.props,
        shouldUpdate = _this$props4.shouldUpdate,
        _this$props4$dependen = _this$props4.dependencies,
        dependencies = _this$props4$dependen === void 0 ? [] : _this$props4$dependen,
        onReset = _this$props4.onReset;
      var store = info.store;
      var namePath = _this.getNamePath();
      var prevValue = _this.getValue(prevStore);
      var curValue = _this.getValue(store);
      var namePathMatch = namePathList && containsNamePath(namePathList, namePath);

      // `setFieldsValue` is a quick access to update related status
      if (info.type === 'valueUpdate' && info.source === 'external' && !(0,isEqual/* default */.Z)(prevValue, curValue)) {
        _this.touched = true;
        _this.dirty = true;
        _this.validatePromise = null;
        _this.errors = EMPTY_ERRORS;
        _this.warnings = EMPTY_ERRORS;
        _this.triggerMetaEvent();
      }
      switch (info.type) {
        case 'reset':
          if (!namePathList || namePathMatch) {
            // Clean up state
            _this.touched = false;
            _this.dirty = false;
            _this.validatePromise = undefined;
            _this.errors = EMPTY_ERRORS;
            _this.warnings = EMPTY_ERRORS;
            _this.triggerMetaEvent();
            onReset === null || onReset === void 0 || onReset();
            _this.refresh();
            return;
          }
          break;

        /**
         * In case field with `preserve = false` nest deps like:
         * - A = 1 => show B
         * - B = 1 => show C
         * - Reset A, need clean B, C
         */
        case 'remove':
          {
            if (shouldUpdate && requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
              _this.reRender();
              return;
            }
            break;
          }
        case 'setField':
          {
            var data = info.data;
            if (namePathMatch) {
              if ('touched' in data) {
                _this.touched = data.touched;
              }
              if ('validating' in data && !('originRCField' in data)) {
                _this.validatePromise = data.validating ? Promise.resolve([]) : null;
              }
              if ('errors' in data) {
                _this.errors = data.errors || EMPTY_ERRORS;
              }
              if ('warnings' in data) {
                _this.warnings = data.warnings || EMPTY_ERRORS;
              }
              _this.dirty = true;
              _this.triggerMetaEvent();
              _this.reRender();
              return;
            } else if ('value' in data && containsNamePath(namePathList, namePath, true)) {
              // Contains path with value should also check
              _this.reRender();
              return;
            }

            // Handle update by `setField` with `shouldUpdate`
            if (shouldUpdate && !namePath.length && requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
              _this.reRender();
              return;
            }
            break;
          }
        case 'dependenciesUpdate':
          {
            /**
             * Trigger when marked `dependencies` updated. Related fields will all update
             */
            var dependencyList = dependencies.map(getNamePath);
            // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
            // emitted earlier and they will work there
            // If set it may cause unnecessary twice rerendering
            if (dependencyList.some(function (dependency) {
              return containsNamePath(info.relatedFields, dependency);
            })) {
              _this.reRender();
              return;
            }
            break;
          }
        default:
          // 1. If `namePath` exists in `namePathList`, means it's related value and should update
          //      For example <List name="list"><Field name={['list', 0]}></List>
          //      If `namePathList` is [['list']] (List value update), Field should be updated
          //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
          // 2.
          //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
          //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
          //       is not provided
          //   2.2 If `shouldUpdate` provided, use customize logic to update the field
          //       else to check if value changed
          if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
            _this.reRender();
            return;
          }
          break;
      }
      if (shouldUpdate === true) {
        _this.reRender();
      }
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "validateRules", function (options) {
      // We should fixed namePath & value to avoid developer change then by form function
      var namePath = _this.getNamePath();
      var currentValue = _this.getValue();
      var _ref2 = options || {},
        triggerName = _ref2.triggerName,
        _ref2$validateOnly = _ref2.validateOnly,
        validateOnly = _ref2$validateOnly === void 0 ? false : _ref2$validateOnly;

      // Force change to async to avoid rule OOD under renderProps field
      var rootPromise = Promise.resolve().then(/*#__PURE__*/(0,asyncToGenerator/* default */.Z)(/*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
        var _this$props5, _this$props5$validate, validateFirst, messageVariables, validateDebounce, filteredRules, promise;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this.mounted) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", []);
            case 2:
              _this$props5 = _this.props, _this$props5$validate = _this$props5.validateFirst, validateFirst = _this$props5$validate === void 0 ? false : _this$props5$validate, messageVariables = _this$props5.messageVariables, validateDebounce = _this$props5.validateDebounce; // Start validate
              filteredRules = _this.getRules();
              if (triggerName) {
                filteredRules = filteredRules.filter(function (rule) {
                  return rule;
                }).filter(function (rule) {
                  var validateTrigger = rule.validateTrigger;
                  if (!validateTrigger) {
                    return true;
                  }
                  var triggerList = typeUtil_toArray(validateTrigger);
                  return triggerList.includes(triggerName);
                });
              }

              // Wait for debounce. Skip if no `triggerName` since its from `validateFields / submit`
              if (!(validateDebounce && triggerName)) {
                _context.next = 10;
                break;
              }
              _context.next = 8;
              return new Promise(function (resolve) {
                setTimeout(resolve, validateDebounce);
              });
            case 8:
              if (!(_this.validatePromise !== rootPromise)) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return", []);
            case 10:
              promise = validateRules(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
              promise.catch(function (e) {
                return e;
              }).then(function () {
                var ruleErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ERRORS;
                if (_this.validatePromise === rootPromise) {
                  var _ruleErrors$forEach;
                  _this.validatePromise = null;

                  // Get errors & warnings
                  var nextErrors = [];
                  var nextWarnings = [];
                  (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function (_ref4) {
                    var warningOnly = _ref4.rule.warningOnly,
                      _ref4$errors = _ref4.errors,
                      errors = _ref4$errors === void 0 ? EMPTY_ERRORS : _ref4$errors;
                    if (warningOnly) {
                      nextWarnings.push.apply(nextWarnings, (0,toConsumableArray/* default */.Z)(errors));
                    } else {
                      nextErrors.push.apply(nextErrors, (0,toConsumableArray/* default */.Z)(errors));
                    }
                  });
                  _this.errors = nextErrors;
                  _this.warnings = nextWarnings;
                  _this.triggerMetaEvent();
                  _this.reRender();
                }
              });
              return _context.abrupt("return", promise);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
      if (validateOnly) {
        return rootPromise;
      }
      _this.validatePromise = rootPromise;
      _this.dirty = true;
      _this.errors = EMPTY_ERRORS;
      _this.warnings = EMPTY_ERRORS;
      _this.triggerMetaEvent();

      // Force trigger re-render since we need sync renderProps with new meta
      _this.reRender();
      return rootPromise;
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "isFieldValidating", function () {
      return !!_this.validatePromise;
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "isFieldTouched", function () {
      return _this.touched;
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "isFieldDirty", function () {
      // Touched or validate or has initialValue
      if (_this.dirty || _this.props.initialValue !== undefined) {
        return true;
      }

      // Form set initialValue
      var fieldContext = _this.props.fieldContext;
      var _fieldContext$getInte = fieldContext.getInternalHooks(HOOK_MARK),
        getInitialValue = _fieldContext$getInte.getInitialValue;
      if (getInitialValue(_this.getNamePath()) !== undefined) {
        return true;
      }
      return false;
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "getErrors", function () {
      return _this.errors;
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "getWarnings", function () {
      return _this.warnings;
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "isListField", function () {
      return _this.props.isListField;
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "isList", function () {
      return _this.props.isList;
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "isPreserve", function () {
      return _this.props.preserve;
    });
    // ============================= Child Component =============================
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "getMeta", function () {
      // Make error & validating in cache to save perf
      _this.prevValidating = _this.isFieldValidating();
      var meta = {
        touched: _this.isFieldTouched(),
        validating: _this.prevValidating,
        errors: _this.errors,
        warnings: _this.warnings,
        name: _this.getNamePath(),
        validated: _this.validatePromise === null
      };
      return meta;
    });
    // Only return validate child node. If invalidate, will do nothing about field.
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "getOnlyChild", function (children) {
      // Support render props
      if (typeof children === 'function') {
        var _meta2 = _this.getMeta();
        return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, _this.getOnlyChild(children(_this.getControlled(), _meta2, _this.props.fieldContext))), {}, {
          isFunction: true
        });
      }

      // Filed element only
      var childList = (0,toArray/* default */.Z)(children);
      if (childList.length !== 1 || ! /*#__PURE__*/react.isValidElement(childList[0])) {
        return {
          child: childList,
          isFunction: false
        };
      }
      return {
        child: childList[0],
        isFunction: false
      };
    });
    // ============================== Field Control ==============================
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "getValue", function (store) {
      var getFieldsValue = _this.props.fieldContext.getFieldsValue;
      var namePath = _this.getNamePath();
      return (0,get/* default */.Z)(store || getFieldsValue(true), namePath);
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "getControlled", function () {
      var childProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props6 = _this.props,
        name = _this$props6.name,
        trigger = _this$props6.trigger,
        validateTrigger = _this$props6.validateTrigger,
        getValueFromEvent = _this$props6.getValueFromEvent,
        normalize = _this$props6.normalize,
        valuePropName = _this$props6.valuePropName,
        getValueProps = _this$props6.getValueProps,
        fieldContext = _this$props6.fieldContext;
      var mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;
      var namePath = _this.getNamePath();
      var getInternalHooks = fieldContext.getInternalHooks,
        getFieldsValue = fieldContext.getFieldsValue;
      var _getInternalHooks = getInternalHooks(HOOK_MARK),
        dispatch = _getInternalHooks.dispatch;
      var value = _this.getValue();
      var mergedGetValueProps = getValueProps || function (val) {
        return (0,defineProperty/* default */.Z)({}, valuePropName, val);
      };
      var originTriggerFunc = childProps[trigger];
      var valueProps = name !== undefined ? mergedGetValueProps(value) : {};

      // warning when prop value is function
      if (false) {}
      var control = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, childProps), valueProps);

      // Add trigger
      control[trigger] = function () {
        // Mark as touched
        _this.touched = true;
        _this.dirty = true;
        _this.triggerMetaEvent();
        var newValue;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (getValueFromEvent) {
          newValue = getValueFromEvent.apply(void 0, args);
        } else {
          newValue = defaultGetValueFromEvent.apply(void 0, [valuePropName].concat(args));
        }
        if (normalize) {
          newValue = normalize(newValue, value, getFieldsValue(true));
        }
        if (newValue !== value) {
          dispatch({
            type: 'updateValue',
            namePath: namePath,
            value: newValue
          });
        }
        if (originTriggerFunc) {
          originTriggerFunc.apply(void 0, args);
        }
      };

      // Add validateTrigger
      var validateTriggerList = typeUtil_toArray(mergedValidateTrigger || []);
      validateTriggerList.forEach(function (triggerName) {
        // Wrap additional function of component, so that we can get latest value from store
        var originTrigger = control[triggerName];
        control[triggerName] = function () {
          if (originTrigger) {
            originTrigger.apply(void 0, arguments);
          }

          // Always use latest rules
          var rules = _this.props.rules;
          if (rules && rules.length) {
            // We dispatch validate to root,
            // since it will update related data with other field with same name
            dispatch({
              type: 'validateField',
              namePath: namePath,
              triggerName: triggerName
            });
          }
        };
      });
      return control;
    });
    if (props.fieldContext) {
      var getInternalHooks = props.fieldContext.getInternalHooks;
      var _getInternalHooks2 = getInternalHooks(HOOK_MARK),
        initEntityValue = _getInternalHooks2.initEntityValue;
      initEntityValue((0,assertThisInitialized/* default */.Z)(_this));
    }
    return _this;
  }
  (0,createClass/* default */.Z)(Field, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props7 = this.props,
        shouldUpdate = _this$props7.shouldUpdate,
        fieldContext = _this$props7.fieldContext;
      this.mounted = true;

      // Register on init
      if (fieldContext) {
        var getInternalHooks = fieldContext.getInternalHooks;
        var _getInternalHooks3 = getInternalHooks(HOOK_MARK),
          registerField = _getInternalHooks3.registerField;
        this.cancelRegisterFunc = registerField(this);
      }

      // One more render for component in case fields not ready
      if (shouldUpdate === true) {
        this.reRender();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelRegister();
      this.triggerMetaEvent(true);
      this.mounted = false;
    }
  }, {
    key: "reRender",
    value: function reRender() {
      if (!this.mounted) return;
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      var resetCount = this.state.resetCount;
      var children = this.props.children;
      var _this$getOnlyChild = this.getOnlyChild(children),
        child = _this$getOnlyChild.child,
        isFunction = _this$getOnlyChild.isFunction;

      // Not need to `cloneElement` since user can handle this in render function self
      var returnChildNode;
      if (isFunction) {
        returnChildNode = child;
      } else if (/*#__PURE__*/react.isValidElement(child)) {
        returnChildNode = /*#__PURE__*/react.cloneElement(child, this.getControlled(child.props));
      } else {
        (0,warning/* default */.ZP)(!child, '`children` of Field is not validate ReactElement.');
        returnChildNode = child;
      }
      return /*#__PURE__*/react.createElement(react.Fragment, {
        key: resetCount
      }, returnChildNode);
    }
  }]);
  return Field;
}(react.Component);
(0,defineProperty/* default */.Z)(Field, "contextType", FieldContext);
(0,defineProperty/* default */.Z)(Field, "defaultProps", {
  trigger: 'onChange',
  valuePropName: 'value'
});
function WrapperField(_ref6) {
  var _restProps$isListFiel;
  var name = _ref6.name,
    restProps = (0,objectWithoutProperties/* default */.Z)(_ref6, _excluded);
  var fieldContext = react.useContext(FieldContext);
  var listContext = react.useContext(es_ListContext);
  var namePath = name !== undefined ? getNamePath(name) : undefined;
  var isMergedListField = (_restProps$isListFiel = restProps.isListField) !== null && _restProps$isListFiel !== void 0 ? _restProps$isListFiel : !!listContext;
  var key = 'keep';
  if (!isMergedListField) {
    key = "_".concat((namePath || []).join('_'));
  }

  // Warning if it's a directly list field.
  // We can still support multiple level field preserve.
  if (false) {}
  return /*#__PURE__*/react.createElement(Field, (0,esm_extends/* default */.Z)({
    key: key,
    name: namePath,
    isListField: isMergedListField
  }, restProps, {
    fieldContext: fieldContext
  }));
}
/* harmony default export */ var es_Field = (WrapperField);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/List.js








function List(_ref) {
  var name = _ref.name,
    initialValue = _ref.initialValue,
    children = _ref.children,
    rules = _ref.rules,
    validateTrigger = _ref.validateTrigger,
    isListField = _ref.isListField;
  var context = react.useContext(FieldContext);
  var wrapperListContext = react.useContext(es_ListContext);
  var keyRef = react.useRef({
    keys: [],
    id: 0
  });
  var keyManager = keyRef.current;
  var prefixName = react.useMemo(function () {
    var parentPrefixName = getNamePath(context.prefixName) || [];
    return [].concat((0,toConsumableArray/* default */.Z)(parentPrefixName), (0,toConsumableArray/* default */.Z)(getNamePath(name)));
  }, [context.prefixName, name]);
  var fieldContext = react.useMemo(function () {
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, context), {}, {
      prefixName: prefixName
    });
  }, [context, prefixName]);

  // List context
  var listContext = react.useMemo(function () {
    return {
      getKey: function getKey(namePath) {
        var len = prefixName.length;
        var pathName = namePath[len];
        return [keyManager.keys[pathName], namePath.slice(len + 1)];
      }
    };
  }, [prefixName]);

  // User should not pass `children` as other type.
  if (typeof children !== 'function') {
    (0,warning/* default */.ZP)(false, 'Form.List only accepts function as children.');
    return null;
  }
  var shouldUpdate = function shouldUpdate(prevValue, nextValue, _ref2) {
    var source = _ref2.source;
    if (source === 'internal') {
      return false;
    }
    return prevValue !== nextValue;
  };
  return /*#__PURE__*/react.createElement(es_ListContext.Provider, {
    value: listContext
  }, /*#__PURE__*/react.createElement(FieldContext.Provider, {
    value: fieldContext
  }, /*#__PURE__*/react.createElement(es_Field, {
    name: [],
    shouldUpdate: shouldUpdate,
    rules: rules,
    validateTrigger: validateTrigger,
    initialValue: initialValue,
    isList: true,
    isListField: isListField !== null && isListField !== void 0 ? isListField : !!wrapperListContext
  }, function (_ref3, meta) {
    var _ref3$value = _ref3.value,
      value = _ref3$value === void 0 ? [] : _ref3$value,
      onChange = _ref3.onChange;
    var getFieldValue = context.getFieldValue;
    var getNewValue = function getNewValue() {
      var values = getFieldValue(prefixName || []);
      return values || [];
    };
    /**
     * Always get latest value in case user update fields by `form` api.
     */
    var operations = {
      add: function add(defaultValue, index) {
        // Mapping keys
        var newValue = getNewValue();
        if (index >= 0 && index <= newValue.length) {
          keyManager.keys = [].concat((0,toConsumableArray/* default */.Z)(keyManager.keys.slice(0, index)), [keyManager.id], (0,toConsumableArray/* default */.Z)(keyManager.keys.slice(index)));
          onChange([].concat((0,toConsumableArray/* default */.Z)(newValue.slice(0, index)), [defaultValue], (0,toConsumableArray/* default */.Z)(newValue.slice(index))));
        } else {
          if (false) {}
          keyManager.keys = [].concat((0,toConsumableArray/* default */.Z)(keyManager.keys), [keyManager.id]);
          onChange([].concat((0,toConsumableArray/* default */.Z)(newValue), [defaultValue]));
        }
        keyManager.id += 1;
      },
      remove: function remove(index) {
        var newValue = getNewValue();
        var indexSet = new Set(Array.isArray(index) ? index : [index]);
        if (indexSet.size <= 0) {
          return;
        }
        keyManager.keys = keyManager.keys.filter(function (_, keysIndex) {
          return !indexSet.has(keysIndex);
        });

        // Trigger store change
        onChange(newValue.filter(function (_, valueIndex) {
          return !indexSet.has(valueIndex);
        }));
      },
      move: function move(from, to) {
        if (from === to) {
          return;
        }
        var newValue = getNewValue();

        // Do not handle out of range
        if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) {
          return;
        }
        keyManager.keys = valueUtil_move(keyManager.keys, from, to);

        // Trigger store change
        onChange(valueUtil_move(newValue, from, to));
      }
    };
    var listValue = value || [];
    if (!Array.isArray(listValue)) {
      listValue = [];
      if (false) {}
    }
    return children(listValue.map(function (__, index) {
      var key = keyManager.keys[index];
      if (key === undefined) {
        keyManager.keys[index] = keyManager.id;
        key = keyManager.keys[index];
        keyManager.id += 1;
      }
      return {
        name: index,
        key: key,
        isListField: true
      };
    }), operations, meta);
  })));
}
/* harmony default export */ var es_List = (List);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/utils/asyncUtil.js
function allPromiseFinish(promiseList) {
  var hasError = false;
  var count = promiseList.length;
  var results = [];
  if (!promiseList.length) {
    return Promise.resolve([]);
  }
  return new Promise(function (resolve, reject) {
    promiseList.forEach(function (promise, index) {
      promise.catch(function (e) {
        hasError = true;
        return e;
      }).then(function (result) {
        count -= 1;
        results[index] = result;
        if (count > 0) {
          return;
        }
        if (hasError) {
          reject(results);
        }
        resolve(results);
      });
    });
  });
}
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/utils/NameMap.js






var SPLIT = '__@field_split__';

/**
 * Convert name path into string to fast the fetch speed of Map.
 */
function normalize(namePath) {
  return namePath.map(function (cell) {
    return "".concat((0,esm_typeof/* default */.Z)(cell), ":").concat(cell);
  })
  // Magic split
  .join(SPLIT);
}

/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */
var NameMap = /*#__PURE__*/function () {
  function NameMap() {
    (0,classCallCheck/* default */.Z)(this, NameMap);
    (0,defineProperty/* default */.Z)(this, "kvs", new Map());
  }
  (0,createClass/* default */.Z)(NameMap, [{
    key: "set",
    value: function set(key, value) {
      this.kvs.set(normalize(key), value);
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.kvs.get(normalize(key));
    }
  }, {
    key: "update",
    value: function update(key, updater) {
      var origin = this.get(key);
      var next = updater(origin);
      if (!next) {
        this.delete(key);
      } else {
        this.set(key, next);
      }
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      this.kvs.delete(normalize(key));
    }

    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function map(callback) {
      return (0,toConsumableArray/* default */.Z)(this.kvs.entries()).map(function (_ref) {
        var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        var cells = key.split(SPLIT);
        return callback({
          key: cells.map(function (cell) {
            var _cell$match = cell.match(/^([^:]*):(.*)$/),
              _cell$match2 = (0,slicedToArray/* default */.Z)(_cell$match, 3),
              type = _cell$match2[1],
              unit = _cell$match2[2];
            return type === 'number' ? Number(unit) : unit;
          }),
          value: value
        });
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = {};
      this.map(function (_ref3) {
        var key = _ref3.key,
          value = _ref3.value;
        json[key.join('.')] = value;
        return null;
      });
      return json;
    }
  }]);
  return NameMap;
}();
/* harmony default export */ var utils_NameMap = (NameMap);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/useForm.js








var useForm_excluded = ["name"];








var FormStore = /*#__PURE__*/(0,createClass/* default */.Z)(function FormStore(forceRootUpdate) {
  var _this = this;
  (0,classCallCheck/* default */.Z)(this, FormStore);
  (0,defineProperty/* default */.Z)(this, "formHooked", false);
  (0,defineProperty/* default */.Z)(this, "forceRootUpdate", void 0);
  (0,defineProperty/* default */.Z)(this, "subscribable", true);
  (0,defineProperty/* default */.Z)(this, "store", {});
  (0,defineProperty/* default */.Z)(this, "fieldEntities", []);
  (0,defineProperty/* default */.Z)(this, "initialValues", {});
  (0,defineProperty/* default */.Z)(this, "callbacks", {});
  (0,defineProperty/* default */.Z)(this, "validateMessages", null);
  (0,defineProperty/* default */.Z)(this, "preserve", null);
  (0,defineProperty/* default */.Z)(this, "lastValidatePromise", null);
  (0,defineProperty/* default */.Z)(this, "getForm", function () {
    return {
      getFieldValue: _this.getFieldValue,
      getFieldsValue: _this.getFieldsValue,
      getFieldError: _this.getFieldError,
      getFieldWarning: _this.getFieldWarning,
      getFieldsError: _this.getFieldsError,
      isFieldsTouched: _this.isFieldsTouched,
      isFieldTouched: _this.isFieldTouched,
      isFieldValidating: _this.isFieldValidating,
      isFieldsValidating: _this.isFieldsValidating,
      resetFields: _this.resetFields,
      setFields: _this.setFields,
      setFieldValue: _this.setFieldValue,
      setFieldsValue: _this.setFieldsValue,
      validateFields: _this.validateFields,
      submit: _this.submit,
      _init: true,
      getInternalHooks: _this.getInternalHooks
    };
  });
  // ======================== Internal Hooks ========================
  (0,defineProperty/* default */.Z)(this, "getInternalHooks", function (key) {
    if (key === HOOK_MARK) {
      _this.formHooked = true;
      return {
        dispatch: _this.dispatch,
        initEntityValue: _this.initEntityValue,
        registerField: _this.registerField,
        useSubscribe: _this.useSubscribe,
        setInitialValues: _this.setInitialValues,
        destroyForm: _this.destroyForm,
        setCallbacks: _this.setCallbacks,
        setValidateMessages: _this.setValidateMessages,
        getFields: _this.getFields,
        setPreserve: _this.setPreserve,
        getInitialValue: _this.getInitialValue,
        registerWatch: _this.registerWatch
      };
    }
    (0,warning/* default */.ZP)(false, '`getInternalHooks` is internal usage. Should not call directly.');
    return null;
  });
  (0,defineProperty/* default */.Z)(this, "useSubscribe", function (subscribable) {
    _this.subscribable = subscribable;
  });
  /**
   * Record prev Form unmount fieldEntities which config preserve false.
   * This need to be refill with initialValues instead of store value.
   */
  (0,defineProperty/* default */.Z)(this, "prevWithoutPreserves", null);
  /**
   * First time `setInitialValues` should update store with initial value
   */
  (0,defineProperty/* default */.Z)(this, "setInitialValues", function (initialValues, init) {
    _this.initialValues = initialValues || {};
    if (init) {
      var _this$prevWithoutPres;
      var nextStore = (0,set/* merge */.T)(initialValues, _this.store);

      // We will take consider prev form unmount fields.
      // When the field is not `preserve`, we need fill this with initialValues instead of store.
      // eslint-disable-next-line array-callback-return
      (_this$prevWithoutPres = _this.prevWithoutPreserves) === null || _this$prevWithoutPres === void 0 || _this$prevWithoutPres.map(function (_ref) {
        var namePath = _ref.key;
        nextStore = (0,set/* default */.Z)(nextStore, namePath, (0,get/* default */.Z)(initialValues, namePath));
      });
      _this.prevWithoutPreserves = null;
      _this.updateStore(nextStore);
    }
  });
  (0,defineProperty/* default */.Z)(this, "destroyForm", function (clearOnDestroy) {
    if (clearOnDestroy) {
      // destroy form reset store
      _this.updateStore({});
    } else {
      // Fill preserve fields
      var prevWithoutPreserves = new utils_NameMap();
      _this.getFieldEntities(true).forEach(function (entity) {
        if (!_this.isMergedPreserve(entity.isPreserve())) {
          prevWithoutPreserves.set(entity.getNamePath(), true);
        }
      });
      _this.prevWithoutPreserves = prevWithoutPreserves;
    }
  });
  (0,defineProperty/* default */.Z)(this, "getInitialValue", function (namePath) {
    var initValue = (0,get/* default */.Z)(_this.initialValues, namePath);

    // Not cloneDeep when without `namePath`
    return namePath.length ? (0,set/* merge */.T)(initValue) : initValue;
  });
  (0,defineProperty/* default */.Z)(this, "setCallbacks", function (callbacks) {
    _this.callbacks = callbacks;
  });
  (0,defineProperty/* default */.Z)(this, "setValidateMessages", function (validateMessages) {
    _this.validateMessages = validateMessages;
  });
  (0,defineProperty/* default */.Z)(this, "setPreserve", function (preserve) {
    _this.preserve = preserve;
  });
  // ============================= Watch ============================
  (0,defineProperty/* default */.Z)(this, "watchList", []);
  (0,defineProperty/* default */.Z)(this, "registerWatch", function (callback) {
    _this.watchList.push(callback);
    return function () {
      _this.watchList = _this.watchList.filter(function (fn) {
        return fn !== callback;
      });
    };
  });
  (0,defineProperty/* default */.Z)(this, "notifyWatch", function () {
    var namePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    // No need to cost perf when nothing need to watch
    if (_this.watchList.length) {
      var values = _this.getFieldsValue();
      var allValues = _this.getFieldsValue(true);
      _this.watchList.forEach(function (callback) {
        callback(values, allValues, namePath);
      });
    }
  });
  // ========================== Dev Warning =========================
  (0,defineProperty/* default */.Z)(this, "timeoutId", null);
  (0,defineProperty/* default */.Z)(this, "warningUnhooked", function () {
    if (false) {}
  });
  // ============================ Store =============================
  (0,defineProperty/* default */.Z)(this, "updateStore", function (nextStore) {
    _this.store = nextStore;
  });
  // ============================ Fields ============================
  /**
   * Get registered field entities.
   * @param pure Only return field which has a `name`. Default: false
   */
  (0,defineProperty/* default */.Z)(this, "getFieldEntities", function () {
    var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (!pure) {
      return _this.fieldEntities;
    }
    return _this.fieldEntities.filter(function (field) {
      return field.getNamePath().length;
    });
  });
  (0,defineProperty/* default */.Z)(this, "getFieldsMap", function () {
    var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var cache = new utils_NameMap();
    _this.getFieldEntities(pure).forEach(function (field) {
      var namePath = field.getNamePath();
      cache.set(namePath, field);
    });
    return cache;
  });
  (0,defineProperty/* default */.Z)(this, "getFieldEntitiesForNamePathList", function (nameList) {
    if (!nameList) {
      return _this.getFieldEntities(true);
    }
    var cache = _this.getFieldsMap(true);
    return nameList.map(function (name) {
      var namePath = getNamePath(name);
      return cache.get(namePath) || {
        INVALIDATE_NAME_PATH: getNamePath(name)
      };
    });
  });
  (0,defineProperty/* default */.Z)(this, "getFieldsValue", function (nameList, filterFunc) {
    _this.warningUnhooked();

    // Fill args
    var mergedNameList;
    var mergedFilterFunc;
    var mergedStrict;
    if (nameList === true || Array.isArray(nameList)) {
      mergedNameList = nameList;
      mergedFilterFunc = filterFunc;
    } else if (nameList && (0,esm_typeof/* default */.Z)(nameList) === 'object') {
      mergedStrict = nameList.strict;
      mergedFilterFunc = nameList.filter;
    }
    if (mergedNameList === true && !mergedFilterFunc) {
      return _this.store;
    }
    var fieldEntities = _this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null);
    var filteredNameList = [];
    fieldEntities.forEach(function (entity) {
      var _isListField, _ref3;
      var namePath = 'INVALIDATE_NAME_PATH' in entity ? entity.INVALIDATE_NAME_PATH : entity.getNamePath();

      // Ignore when it's a list item and not specific the namePath,
      // since parent field is already take in count
      if (mergedStrict) {
        var _isList, _ref2;
        if ((_isList = (_ref2 = entity).isList) !== null && _isList !== void 0 && _isList.call(_ref2)) {
          return;
        }
      } else if (!mergedNameList && (_isListField = (_ref3 = entity).isListField) !== null && _isListField !== void 0 && _isListField.call(_ref3)) {
        return;
      }
      if (!mergedFilterFunc) {
        filteredNameList.push(namePath);
      } else {
        var meta = 'getMeta' in entity ? entity.getMeta() : null;
        if (mergedFilterFunc(meta)) {
          filteredNameList.push(namePath);
        }
      }
    });
    return cloneByNamePathList(_this.store, filteredNameList.map(getNamePath));
  });
  (0,defineProperty/* default */.Z)(this, "getFieldValue", function (name) {
    _this.warningUnhooked();
    var namePath = getNamePath(name);
    return (0,get/* default */.Z)(_this.store, namePath);
  });
  (0,defineProperty/* default */.Z)(this, "getFieldsError", function (nameList) {
    _this.warningUnhooked();
    var fieldEntities = _this.getFieldEntitiesForNamePathList(nameList);
    return fieldEntities.map(function (entity, index) {
      if (entity && !('INVALIDATE_NAME_PATH' in entity)) {
        return {
          name: entity.getNamePath(),
          errors: entity.getErrors(),
          warnings: entity.getWarnings()
        };
      }
      return {
        name: getNamePath(nameList[index]),
        errors: [],
        warnings: []
      };
    });
  });
  (0,defineProperty/* default */.Z)(this, "getFieldError", function (name) {
    _this.warningUnhooked();
    var namePath = getNamePath(name);
    var fieldError = _this.getFieldsError([namePath])[0];
    return fieldError.errors;
  });
  (0,defineProperty/* default */.Z)(this, "getFieldWarning", function (name) {
    _this.warningUnhooked();
    var namePath = getNamePath(name);
    var fieldError = _this.getFieldsError([namePath])[0];
    return fieldError.warnings;
  });
  (0,defineProperty/* default */.Z)(this, "isFieldsTouched", function () {
    _this.warningUnhooked();
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var arg0 = args[0],
      arg1 = args[1];
    var namePathList;
    var isAllFieldsTouched = false;
    if (args.length === 0) {
      namePathList = null;
    } else if (args.length === 1) {
      if (Array.isArray(arg0)) {
        namePathList = arg0.map(getNamePath);
        isAllFieldsTouched = false;
      } else {
        namePathList = null;
        isAllFieldsTouched = arg0;
      }
    } else {
      namePathList = arg0.map(getNamePath);
      isAllFieldsTouched = arg1;
    }
    var fieldEntities = _this.getFieldEntities(true);
    var isFieldTouched = function isFieldTouched(field) {
      return field.isFieldTouched();
    };

    // ===== Will get fully compare when not config namePathList =====
    if (!namePathList) {
      return isAllFieldsTouched ? fieldEntities.every(function (entity) {
        return isFieldTouched(entity) || entity.isList();
      }) : fieldEntities.some(isFieldTouched);
    }

    // Generate a nest tree for validate
    var map = new utils_NameMap();
    namePathList.forEach(function (shortNamePath) {
      map.set(shortNamePath, []);
    });
    fieldEntities.forEach(function (field) {
      var fieldNamePath = field.getNamePath();

      // Find matched entity and put into list
      namePathList.forEach(function (shortNamePath) {
        if (shortNamePath.every(function (nameUnit, i) {
          return fieldNamePath[i] === nameUnit;
        })) {
          map.update(shortNamePath, function (list) {
            return [].concat((0,toConsumableArray/* default */.Z)(list), [field]);
          });
        }
      });
    });

    // Check if NameMap value is touched
    var isNamePathListTouched = function isNamePathListTouched(entities) {
      return entities.some(isFieldTouched);
    };
    var namePathListEntities = map.map(function (_ref4) {
      var value = _ref4.value;
      return value;
    });
    return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
  });
  (0,defineProperty/* default */.Z)(this, "isFieldTouched", function (name) {
    _this.warningUnhooked();
    return _this.isFieldsTouched([name]);
  });
  (0,defineProperty/* default */.Z)(this, "isFieldsValidating", function (nameList) {
    _this.warningUnhooked();
    var fieldEntities = _this.getFieldEntities();
    if (!nameList) {
      return fieldEntities.some(function (testField) {
        return testField.isFieldValidating();
      });
    }
    var namePathList = nameList.map(getNamePath);
    return fieldEntities.some(function (testField) {
      var fieldNamePath = testField.getNamePath();
      return containsNamePath(namePathList, fieldNamePath) && testField.isFieldValidating();
    });
  });
  (0,defineProperty/* default */.Z)(this, "isFieldValidating", function (name) {
    _this.warningUnhooked();
    return _this.isFieldsValidating([name]);
  });
  /**
   * Reset Field with field `initialValue` prop.
   * Can pass `entities` or `namePathList` or just nothing.
   */
  (0,defineProperty/* default */.Z)(this, "resetWithFieldInitialValue", function () {
    var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // Create cache
    var cache = new utils_NameMap();
    var fieldEntities = _this.getFieldEntities(true);
    fieldEntities.forEach(function (field) {
      var initialValue = field.props.initialValue;
      var namePath = field.getNamePath();

      // Record only if has `initialValue`
      if (initialValue !== undefined) {
        var records = cache.get(namePath) || new Set();
        records.add({
          entity: field,
          value: initialValue
        });
        cache.set(namePath, records);
      }
    });

    // Reset
    var resetWithFields = function resetWithFields(entities) {
      entities.forEach(function (field) {
        var initialValue = field.props.initialValue;
        if (initialValue !== undefined) {
          var namePath = field.getNamePath();
          var formInitialValue = _this.getInitialValue(namePath);
          if (formInitialValue !== undefined) {
            // Warning if conflict with form initialValues and do not modify value
            (0,warning/* default */.ZP)(false, "Form already set 'initialValues' with path '".concat(namePath.join('.'), "'. Field can not overwrite it."));
          } else {
            var records = cache.get(namePath);
            if (records && records.size > 1) {
              // Warning if multiple field set `initialValue`and do not modify value
              (0,warning/* default */.ZP)(false, "Multiple Field with path '".concat(namePath.join('.'), "' set 'initialValue'. Can not decide which one to pick."));
            } else if (records) {
              var originValue = _this.getFieldValue(namePath);
              var isListField = field.isListField();

              // Set `initialValue`
              if (!isListField && (!info.skipExist || originValue === undefined)) {
                _this.updateStore((0,set/* default */.Z)(_this.store, namePath, (0,toConsumableArray/* default */.Z)(records)[0].value));
              }
            }
          }
        }
      });
    };
    var requiredFieldEntities;
    if (info.entities) {
      requiredFieldEntities = info.entities;
    } else if (info.namePathList) {
      requiredFieldEntities = [];
      info.namePathList.forEach(function (namePath) {
        var records = cache.get(namePath);
        if (records) {
          var _requiredFieldEntitie;
          (_requiredFieldEntitie = requiredFieldEntities).push.apply(_requiredFieldEntitie, (0,toConsumableArray/* default */.Z)((0,toConsumableArray/* default */.Z)(records).map(function (r) {
            return r.entity;
          })));
        }
      });
    } else {
      requiredFieldEntities = fieldEntities;
    }
    resetWithFields(requiredFieldEntities);
  });
  (0,defineProperty/* default */.Z)(this, "resetFields", function (nameList) {
    _this.warningUnhooked();
    var prevStore = _this.store;
    if (!nameList) {
      _this.updateStore((0,set/* merge */.T)(_this.initialValues));
      _this.resetWithFieldInitialValue();
      _this.notifyObservers(prevStore, null, {
        type: 'reset'
      });
      _this.notifyWatch();
      return;
    }

    // Reset by `nameList`
    var namePathList = nameList.map(getNamePath);
    namePathList.forEach(function (namePath) {
      var initialValue = _this.getInitialValue(namePath);
      _this.updateStore((0,set/* default */.Z)(_this.store, namePath, initialValue));
    });
    _this.resetWithFieldInitialValue({
      namePathList: namePathList
    });
    _this.notifyObservers(prevStore, namePathList, {
      type: 'reset'
    });
    _this.notifyWatch(namePathList);
  });
  (0,defineProperty/* default */.Z)(this, "setFields", function (fields) {
    _this.warningUnhooked();
    var prevStore = _this.store;
    var namePathList = [];
    fields.forEach(function (fieldData) {
      var name = fieldData.name,
        data = (0,objectWithoutProperties/* default */.Z)(fieldData, useForm_excluded);
      var namePath = getNamePath(name);
      namePathList.push(namePath);

      // Value
      if ('value' in data) {
        _this.updateStore((0,set/* default */.Z)(_this.store, namePath, data.value));
      }
      _this.notifyObservers(prevStore, [namePath], {
        type: 'setField',
        data: fieldData
      });
    });
    _this.notifyWatch(namePathList);
  });
  (0,defineProperty/* default */.Z)(this, "getFields", function () {
    var entities = _this.getFieldEntities(true);
    var fields = entities.map(function (field) {
      var namePath = field.getNamePath();
      var meta = field.getMeta();
      var fieldData = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, meta), {}, {
        name: namePath,
        value: _this.getFieldValue(namePath)
      });
      Object.defineProperty(fieldData, 'originRCField', {
        value: true
      });
      return fieldData;
    });
    return fields;
  });
  // =========================== Observer ===========================
  /**
   * This only trigger when a field is on constructor to avoid we get initialValue too late
   */
  (0,defineProperty/* default */.Z)(this, "initEntityValue", function (entity) {
    var initialValue = entity.props.initialValue;
    if (initialValue !== undefined) {
      var namePath = entity.getNamePath();
      var prevValue = (0,get/* default */.Z)(_this.store, namePath);
      if (prevValue === undefined) {
        _this.updateStore((0,set/* default */.Z)(_this.store, namePath, initialValue));
      }
    }
  });
  (0,defineProperty/* default */.Z)(this, "isMergedPreserve", function (fieldPreserve) {
    var mergedPreserve = fieldPreserve !== undefined ? fieldPreserve : _this.preserve;
    return mergedPreserve !== null && mergedPreserve !== void 0 ? mergedPreserve : true;
  });
  (0,defineProperty/* default */.Z)(this, "registerField", function (entity) {
    _this.fieldEntities.push(entity);
    var namePath = entity.getNamePath();
    _this.notifyWatch([namePath]);

    // Set initial values
    if (entity.props.initialValue !== undefined) {
      var prevStore = _this.store;
      _this.resetWithFieldInitialValue({
        entities: [entity],
        skipExist: true
      });
      _this.notifyObservers(prevStore, [entity.getNamePath()], {
        type: 'valueUpdate',
        source: 'internal'
      });
    }

    // un-register field callback
    return function (isListField, preserve) {
      var subNamePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      _this.fieldEntities = _this.fieldEntities.filter(function (item) {
        return item !== entity;
      });

      // Clean up store value if not preserve
      if (!_this.isMergedPreserve(preserve) && (!isListField || subNamePath.length > 1)) {
        var defaultValue = isListField ? undefined : _this.getInitialValue(namePath);
        if (namePath.length && _this.getFieldValue(namePath) !== defaultValue && _this.fieldEntities.every(function (field) {
          return (
            // Only reset when no namePath exist
            !matchNamePath(field.getNamePath(), namePath)
          );
        })) {
          var _prevStore = _this.store;
          _this.updateStore((0,set/* default */.Z)(_prevStore, namePath, defaultValue, true));

          // Notify that field is unmount
          _this.notifyObservers(_prevStore, [namePath], {
            type: 'remove'
          });

          // Dependencies update
          _this.triggerDependenciesUpdate(_prevStore, namePath);
        }
      }
      _this.notifyWatch([namePath]);
    };
  });
  (0,defineProperty/* default */.Z)(this, "dispatch", function (action) {
    switch (action.type) {
      case 'updateValue':
        {
          var namePath = action.namePath,
            value = action.value;
          _this.updateValue(namePath, value);
          break;
        }
      case 'validateField':
        {
          var _namePath = action.namePath,
            triggerName = action.triggerName;
          _this.validateFields([_namePath], {
            triggerName: triggerName
          });
          break;
        }
      default:
      // Currently we don't have other action. Do nothing.
    }
  });
  (0,defineProperty/* default */.Z)(this, "notifyObservers", function (prevStore, namePathList, info) {
    if (_this.subscribable) {
      var mergedInfo = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, info), {}, {
        store: _this.getFieldsValue(true)
      });
      _this.getFieldEntities().forEach(function (_ref5) {
        var onStoreChange = _ref5.onStoreChange;
        onStoreChange(prevStore, namePathList, mergedInfo);
      });
    } else {
      _this.forceRootUpdate();
    }
  });
  /**
   * Notify dependencies children with parent update
   * We need delay to trigger validate in case Field is under render props
   */
  (0,defineProperty/* default */.Z)(this, "triggerDependenciesUpdate", function (prevStore, namePath) {
    var childrenFields = _this.getDependencyChildrenFields(namePath);
    if (childrenFields.length) {
      _this.validateFields(childrenFields);
    }
    _this.notifyObservers(prevStore, childrenFields, {
      type: 'dependenciesUpdate',
      relatedFields: [namePath].concat((0,toConsumableArray/* default */.Z)(childrenFields))
    });
    return childrenFields;
  });
  (0,defineProperty/* default */.Z)(this, "updateValue", function (name, value) {
    var namePath = getNamePath(name);
    var prevStore = _this.store;
    _this.updateStore((0,set/* default */.Z)(_this.store, namePath, value));
    _this.notifyObservers(prevStore, [namePath], {
      type: 'valueUpdate',
      source: 'internal'
    });
    _this.notifyWatch([namePath]);

    // Dependencies update
    var childrenFields = _this.triggerDependenciesUpdate(prevStore, namePath);

    // trigger callback function
    var onValuesChange = _this.callbacks.onValuesChange;
    if (onValuesChange) {
      var changedValues = cloneByNamePathList(_this.store, [namePath]);
      onValuesChange(changedValues, _this.getFieldsValue());
    }
    _this.triggerOnFieldsChange([namePath].concat((0,toConsumableArray/* default */.Z)(childrenFields)));
  });
  // Let all child Field get update.
  (0,defineProperty/* default */.Z)(this, "setFieldsValue", function (store) {
    _this.warningUnhooked();
    var prevStore = _this.store;
    if (store) {
      var nextStore = (0,set/* merge */.T)(_this.store, store);
      _this.updateStore(nextStore);
    }
    _this.notifyObservers(prevStore, null, {
      type: 'valueUpdate',
      source: 'external'
    });
    _this.notifyWatch();
  });
  (0,defineProperty/* default */.Z)(this, "setFieldValue", function (name, value) {
    _this.setFields([{
      name: name,
      value: value,
      errors: [],
      warnings: []
    }]);
  });
  (0,defineProperty/* default */.Z)(this, "getDependencyChildrenFields", function (rootNamePath) {
    var children = new Set();
    var childrenFields = [];
    var dependencies2fields = new utils_NameMap();

    /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */
    _this.getFieldEntities().forEach(function (field) {
      var dependencies = field.props.dependencies;
      (dependencies || []).forEach(function (dependency) {
        var dependencyNamePath = getNamePath(dependency);
        dependencies2fields.update(dependencyNamePath, function () {
          var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Set();
          fields.add(field);
          return fields;
        });
      });
    });
    var fillChildren = function fillChildren(namePath) {
      var fields = dependencies2fields.get(namePath) || new Set();
      fields.forEach(function (field) {
        if (!children.has(field)) {
          children.add(field);
          var fieldNamePath = field.getNamePath();
          if (field.isFieldDirty() && fieldNamePath.length) {
            childrenFields.push(fieldNamePath);
            fillChildren(fieldNamePath);
          }
        }
      });
    };
    fillChildren(rootNamePath);
    return childrenFields;
  });
  (0,defineProperty/* default */.Z)(this, "triggerOnFieldsChange", function (namePathList, filedErrors) {
    var onFieldsChange = _this.callbacks.onFieldsChange;
    if (onFieldsChange) {
      var fields = _this.getFields();

      /**
       * Fill errors since `fields` may be replaced by controlled fields
       */
      if (filedErrors) {
        var cache = new utils_NameMap();
        filedErrors.forEach(function (_ref6) {
          var name = _ref6.name,
            errors = _ref6.errors;
          cache.set(name, errors);
        });
        fields.forEach(function (field) {
          // eslint-disable-next-line no-param-reassign
          field.errors = cache.get(field.name) || field.errors;
        });
      }
      var changedFields = fields.filter(function (_ref7) {
        var fieldName = _ref7.name;
        return containsNamePath(namePathList, fieldName);
      });
      if (changedFields.length) {
        onFieldsChange(changedFields, fields);
      }
    }
  });
  // =========================== Validate ===========================
  (0,defineProperty/* default */.Z)(this, "validateFields", function (arg1, arg2) {
    _this.warningUnhooked();
    var nameList;
    var options;
    if (Array.isArray(arg1) || typeof arg1 === 'string' || typeof arg2 === 'string') {
      nameList = arg1;
      options = arg2;
    } else {
      options = arg1;
    }
    var provideNameList = !!nameList;
    var namePathList = provideNameList ? nameList.map(getNamePath) : [];

    // Collect result in promise list
    var promiseList = [];

    // We temp save the path which need trigger for `onFieldsChange`
    var TMP_SPLIT = String(Date.now());
    var validateNamePathList = new Set();
    var _ref8 = options || {},
      recursive = _ref8.recursive,
      dirty = _ref8.dirty;
    _this.getFieldEntities(true).forEach(function (field) {
      // Add field if not provide `nameList`
      if (!provideNameList) {
        namePathList.push(field.getNamePath());
      }

      // Skip if without rule
      if (!field.props.rules || !field.props.rules.length) {
        return;
      }

      // Skip if only validate dirty field
      if (dirty && !field.isFieldDirty()) {
        return;
      }
      var fieldNamePath = field.getNamePath();
      validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));

      // Add field validate rule in to promise list
      if (!provideNameList || containsNamePath(namePathList, fieldNamePath, recursive)) {
        var promise = field.validateRules((0,objectSpread2/* default */.Z)({
          validateMessages: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, defaultValidateMessages), _this.validateMessages)
        }, options));

        // Wrap promise with field
        promiseList.push(promise.then(function () {
          return {
            name: fieldNamePath,
            errors: [],
            warnings: []
          };
        }).catch(function (ruleErrors) {
          var _ruleErrors$forEach;
          var mergedErrors = [];
          var mergedWarnings = [];
          (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function (_ref9) {
            var warningOnly = _ref9.rule.warningOnly,
              errors = _ref9.errors;
            if (warningOnly) {
              mergedWarnings.push.apply(mergedWarnings, (0,toConsumableArray/* default */.Z)(errors));
            } else {
              mergedErrors.push.apply(mergedErrors, (0,toConsumableArray/* default */.Z)(errors));
            }
          });
          if (mergedErrors.length) {
            return Promise.reject({
              name: fieldNamePath,
              errors: mergedErrors,
              warnings: mergedWarnings
            });
          }
          return {
            name: fieldNamePath,
            errors: mergedErrors,
            warnings: mergedWarnings
          };
        }));
      }
    });
    var summaryPromise = allPromiseFinish(promiseList);
    _this.lastValidatePromise = summaryPromise;

    // Notify fields with rule that validate has finished and need update
    summaryPromise.catch(function (results) {
      return results;
    }).then(function (results) {
      var resultNamePathList = results.map(function (_ref10) {
        var name = _ref10.name;
        return name;
      });
      _this.notifyObservers(_this.store, resultNamePathList, {
        type: 'validateFinish'
      });
      _this.triggerOnFieldsChange(resultNamePathList, results);
    });
    var returnPromise = summaryPromise.then(function () {
      if (_this.lastValidatePromise === summaryPromise) {
        return Promise.resolve(_this.getFieldsValue(namePathList));
      }
      return Promise.reject([]);
    }).catch(function (results) {
      var errorList = results.filter(function (result) {
        return result && result.errors.length;
      });
      return Promise.reject({
        values: _this.getFieldsValue(namePathList),
        errorFields: errorList,
        outOfDate: _this.lastValidatePromise !== summaryPromise
      });
    });

    // Do not throw in console
    returnPromise.catch(function (e) {
      return e;
    });

    // `validating` changed. Trigger `onFieldsChange`
    var triggerNamePathList = namePathList.filter(function (namePath) {
      return validateNamePathList.has(namePath.join(TMP_SPLIT));
    });
    _this.triggerOnFieldsChange(triggerNamePathList);
    return returnPromise;
  });
  // ============================ Submit ============================
  (0,defineProperty/* default */.Z)(this, "submit", function () {
    _this.warningUnhooked();
    _this.validateFields().then(function (values) {
      var onFinish = _this.callbacks.onFinish;
      if (onFinish) {
        try {
          onFinish(values);
        } catch (err) {
          // Should print error if user `onFinish` callback failed
          console.error(err);
        }
      }
    }).catch(function (e) {
      var onFinishFailed = _this.callbacks.onFinishFailed;
      if (onFinishFailed) {
        onFinishFailed(e);
      }
    });
  });
  this.forceRootUpdate = forceRootUpdate;
});
function useForm(form) {
  var formRef = react.useRef();
  var _React$useState = react.useState({}),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    forceUpdate = _React$useState2[1];
  if (!formRef.current) {
    if (form) {
      formRef.current = form;
    } else {
      // Create a new FormStore if not provided
      var forceReRender = function forceReRender() {
        forceUpdate({});
      };
      var formStore = new FormStore(forceReRender);
      formRef.current = formStore.getForm();
    }
  }
  return [formRef.current];
}
/* harmony default export */ var es_useForm = (useForm);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/FormContext.js



var FormContext = /*#__PURE__*/react.createContext({
  triggerFormChange: function triggerFormChange() {},
  triggerFormFinish: function triggerFormFinish() {},
  registerForm: function registerForm() {},
  unregisterForm: function unregisterForm() {}
});
var FormProvider = function FormProvider(_ref) {
  var validateMessages = _ref.validateMessages,
    onFormChange = _ref.onFormChange,
    onFormFinish = _ref.onFormFinish,
    children = _ref.children;
  var formContext = react.useContext(FormContext);
  var formsRef = react.useRef({});
  return /*#__PURE__*/react.createElement(FormContext.Provider, {
    value: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formContext), {}, {
      validateMessages: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formContext.validateMessages), validateMessages),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function triggerFormChange(name, changedFields) {
        if (onFormChange) {
          onFormChange(name, {
            changedFields: changedFields,
            forms: formsRef.current
          });
        }
        formContext.triggerFormChange(name, changedFields);
      },
      triggerFormFinish: function triggerFormFinish(name, values) {
        if (onFormFinish) {
          onFormFinish(name, {
            values: values,
            forms: formsRef.current
          });
        }
        formContext.triggerFormFinish(name, values);
      },
      registerForm: function registerForm(name, form) {
        if (name) {
          formsRef.current = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formsRef.current), {}, (0,defineProperty/* default */.Z)({}, name, form));
        }
        formContext.registerForm(name, form);
      },
      unregisterForm: function unregisterForm(name) {
        var newForms = (0,objectSpread2/* default */.Z)({}, formsRef.current);
        delete newForms[name];
        formsRef.current = newForms;
        formContext.unregisterForm(name);
      }
    })
  }, children);
};

/* harmony default export */ var es_FormContext = (FormContext);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/Form.js




var Form_excluded = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed", "clearOnDestroy"];






var Form = function Form(_ref, ref) {
  var name = _ref.name,
    initialValues = _ref.initialValues,
    fields = _ref.fields,
    form = _ref.form,
    preserve = _ref.preserve,
    children = _ref.children,
    _ref$component = _ref.component,
    Component = _ref$component === void 0 ? 'form' : _ref$component,
    validateMessages = _ref.validateMessages,
    _ref$validateTrigger = _ref.validateTrigger,
    validateTrigger = _ref$validateTrigger === void 0 ? 'onChange' : _ref$validateTrigger,
    onValuesChange = _ref.onValuesChange,
    _onFieldsChange = _ref.onFieldsChange,
    _onFinish = _ref.onFinish,
    onFinishFailed = _ref.onFinishFailed,
    clearOnDestroy = _ref.clearOnDestroy,
    restProps = (0,objectWithoutProperties/* default */.Z)(_ref, Form_excluded);
  var nativeElementRef = react.useRef(null);
  var formContext = react.useContext(es_FormContext);

  // We customize handle event since Context will makes all the consumer re-render:
  // https://reactjs.org/docs/context.html#contextprovider
  var _useForm = es_useForm(form),
    _useForm2 = (0,slicedToArray/* default */.Z)(_useForm, 1),
    formInstance = _useForm2[0];
  var _getInternalHooks = formInstance.getInternalHooks(HOOK_MARK),
    useSubscribe = _getInternalHooks.useSubscribe,
    setInitialValues = _getInternalHooks.setInitialValues,
    setCallbacks = _getInternalHooks.setCallbacks,
    setValidateMessages = _getInternalHooks.setValidateMessages,
    setPreserve = _getInternalHooks.setPreserve,
    destroyForm = _getInternalHooks.destroyForm;

  // Pass ref with form instance
  react.useImperativeHandle(ref, function () {
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formInstance), {}, {
      nativeElement: nativeElementRef.current
    });
  });

  // Register form into Context
  react.useEffect(function () {
    formContext.registerForm(name, formInstance);
    return function () {
      formContext.unregisterForm(name);
    };
  }, [formContext, formInstance, name]);

  // Pass props to store
  setValidateMessages((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formContext.validateMessages), validateMessages));
  setCallbacks({
    onValuesChange: onValuesChange,
    onFieldsChange: function onFieldsChange(changedFields) {
      formContext.triggerFormChange(name, changedFields);
      if (_onFieldsChange) {
        for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          rest[_key - 1] = arguments[_key];
        }
        _onFieldsChange.apply(void 0, [changedFields].concat(rest));
      }
    },
    onFinish: function onFinish(values) {
      formContext.triggerFormFinish(name, values);
      if (_onFinish) {
        _onFinish(values);
      }
    },
    onFinishFailed: onFinishFailed
  });
  setPreserve(preserve);

  // Set initial value, init store value when first mount
  var mountRef = react.useRef(null);
  setInitialValues(initialValues, !mountRef.current);
  if (!mountRef.current) {
    mountRef.current = true;
  }
  react.useEffect(function () {
    return function () {
      return destroyForm(clearOnDestroy);
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);

  // Prepare children by `children` type
  var childrenNode;
  var childrenRenderProps = typeof children === 'function';
  if (childrenRenderProps) {
    var _values = formInstance.getFieldsValue(true);
    childrenNode = children(_values, formInstance);
  } else {
    childrenNode = children;
  }

  // Not use subscribe when using render props
  useSubscribe(!childrenRenderProps);

  // Listen if fields provided. We use ref to save prev data here to avoid additional render
  var prevFieldsRef = react.useRef();
  react.useEffect(function () {
    if (!isSimilar(prevFieldsRef.current || [], fields || [])) {
      formInstance.setFields(fields || []);
    }
    prevFieldsRef.current = fields;
  }, [fields, formInstance]);
  var formContextValue = react.useMemo(function () {
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formInstance), {}, {
      validateTrigger: validateTrigger
    });
  }, [formInstance, validateTrigger]);
  var wrapperNode = /*#__PURE__*/react.createElement(es_ListContext.Provider, {
    value: null
  }, /*#__PURE__*/react.createElement(FieldContext.Provider, {
    value: formContextValue
  }, childrenNode));
  if (Component === false) {
    return wrapperNode;
  }
  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, restProps, {
    ref: nativeElementRef,
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      event.stopPropagation();
      formInstance.submit();
    },
    onReset: function onReset(event) {
      var _restProps$onReset;
      event.preventDefault();
      formInstance.resetFields();
      (_restProps$onReset = restProps.onReset) === null || _restProps$onReset === void 0 || _restProps$onReset.call(restProps, event);
    }
  }), wrapperNode);
};
/* harmony default export */ var es_Form = (Form);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/useWatch.js






function stringify(value) {
  try {
    return JSON.stringify(value);
  } catch (err) {
    return Math.random();
  }
}
var useWatchWarning =  false ? 0 : function () {};

// ------- selector type -------

// ------- selector type end -------

function useWatch() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var dependencies = args[0],
    _args$ = args[1],
    _form = _args$ === void 0 ? {} : _args$;
  var options = isFormInstance(_form) ? {
    form: _form
  } : _form;
  var form = options.form;
  var _useState = (0,react.useState)(),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var valueStr = (0,react.useMemo)(function () {
    return stringify(value);
  }, [value]);
  var valueStrRef = (0,react.useRef)(valueStr);
  valueStrRef.current = valueStr;
  var fieldContext = (0,react.useContext)(FieldContext);
  var formInstance = form || fieldContext;
  var isValidForm = formInstance && formInstance._init;

  // Warning if not exist form instance
  if (false) {}
  var namePath = getNamePath(dependencies);
  var namePathRef = (0,react.useRef)(namePath);
  namePathRef.current = namePath;
  useWatchWarning(namePath);
  (0,react.useEffect)(function () {
    // Skip if not exist form instance
    if (!isValidForm) {
      return;
    }
    var getFieldsValue = formInstance.getFieldsValue,
      getInternalHooks = formInstance.getInternalHooks;
    var _getInternalHooks = getInternalHooks(HOOK_MARK),
      registerWatch = _getInternalHooks.registerWatch;
    var getWatchValue = function getWatchValue(values, allValues) {
      var watchValue = options.preserve ? allValues : values;
      return typeof dependencies === 'function' ? dependencies(watchValue) : (0,get/* default */.Z)(watchValue, namePathRef.current);
    };
    var cancelRegister = registerWatch(function (values, allValues) {
      var newValue = getWatchValue(values, allValues);
      var nextValueStr = stringify(newValue);

      // Compare stringify in case it's nest object
      if (valueStrRef.current !== nextValueStr) {
        valueStrRef.current = nextValueStr;
        setValue(newValue);
      }
    });

    // TODO: We can improve this perf in future
    var initialValue = getWatchValue(getFieldsValue(), getFieldsValue(true));

    // React 18 has the bug that will queue update twice even the value is not changed
    // ref: https://github.com/facebook/react/issues/27213
    if (value !== initialValue) {
      setValue(initialValue);
    }
    return cancelRegister;
  },
  // We do not need re-register since namePath content is the same
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [isValidForm]);
  return value;
}
/* harmony default export */ var es_useWatch = (useWatch);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/index.js









var InternalForm = /*#__PURE__*/react.forwardRef(es_Form);
var RefForm = InternalForm;
RefForm.FormProvider = FormProvider;
RefForm.Field = es_Field;
RefForm.List = es_List;
RefForm.useForm = es_useForm;
RefForm.useWatch = es_useWatch;

/* harmony default export */ var rc_field_form_es = (RefForm);

/***/ }),

/***/ 26137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ rc_image_es; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/rc-util/es/Dom/css.js
/* eslint-disable no-nested-ternary */
var PIXEL_PATTERN = /margin|padding|width|height|max|min|offset/;
var removePixel = {
  left: true,
  top: true
};
var floatMap = {
  cssFloat: 1,
  styleFloat: 1,
  float: 1
};
function getComputedStyle(node) {
  return node.nodeType === 1 ? node.ownerDocument.defaultView.getComputedStyle(node, null) : {};
}
function getStyleValue(node, type, value) {
  type = type.toLowerCase();
  if (value === 'auto') {
    if (type === 'height') {
      return node.offsetHeight;
    }
    if (type === 'width') {
      return node.offsetWidth;
    }
  }
  if (!(type in removePixel)) {
    removePixel[type] = PIXEL_PATTERN.test(type);
  }
  return removePixel[type] ? parseFloat(value) || 0 : value;
}
function get(node, name) {
  var length = arguments.length;
  var style = getComputedStyle(node);
  name = floatMap[name] ? 'cssFloat' in node.style ? 'cssFloat' : 'styleFloat' : name;
  return length === 1 ? style : getStyleValue(node, name, style[name] || node.style[name]);
}
function set(node, name, value) {
  var length = arguments.length;
  name = floatMap[name] ? 'cssFloat' in node.style ? 'cssFloat' : 'styleFloat' : name;
  if (length === 3) {
    if (typeof value === 'number' && PIXEL_PATTERN.test(name)) {
      value = "".concat(value, "px");
    }
    node.style[name] = value; // Number
    return value;
  }
  for (var x in name) {
    if (name.hasOwnProperty(x)) {
      set(node, x, name[x]);
    }
  }
  return getComputedStyle(node);
}
function getOuterWidth(el) {
  if (el === document.body) {
    return document.documentElement.clientWidth;
  }
  return el.offsetWidth;
}
function getOuterHeight(el) {
  if (el === document.body) {
    return window.innerHeight || document.documentElement.clientHeight;
  }
  return el.offsetHeight;
}
function getDocSize() {
  var width = Math.max(document.documentElement.scrollWidth, document.body.scrollWidth);
  var height = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
  return {
    width: width,
    height: height
  };
}
function getClientSize() {
  var width = document.documentElement.clientWidth;
  var height = window.innerHeight || document.documentElement.clientHeight;
  return {
    width: width,
    height: height
  };
}
function getScroll() {
  return {
    scrollLeft: Math.max(document.documentElement.scrollLeft, document.body.scrollLeft),
    scrollTop: Math.max(document.documentElement.scrollTop, document.body.scrollTop)
  };
}
function getOffset(node) {
  var box = node.getBoundingClientRect();
  var docElem = document.documentElement;

  // < ie8 不支持 win.pageXOffset, 则使用 docElem.scrollLeft
  return {
    left: box.left + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
    top: box.top + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
  };
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMergedState.js
var useMergedState = __webpack_require__(78877);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/rc-dialog/es/index.js + 8 modules
var es = __webpack_require__(31414);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/addEventListener.js
var addEventListener = __webpack_require__(35092);
// EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js
var KeyCode = __webpack_require__(88035);
// EXTERNAL MODULE: ./node_modules/@rc-component/portal/es/index.js + 6 modules
var portal_es = __webpack_require__(90604);
// EXTERNAL MODULE: ./node_modules/rc-motion/es/index.js + 13 modules
var rc_motion_es = __webpack_require__(26981);
;// CONCATENATED MODULE: ./node_modules/rc-image/es/context.js

var PreviewGroupContext = /*#__PURE__*/react.createContext(null);
;// CONCATENATED MODULE: ./node_modules/rc-image/es/Operations.js









var Operations = function Operations(props) {
  var visible = props.visible,
    maskTransitionName = props.maskTransitionName,
    getContainer = props.getContainer,
    prefixCls = props.prefixCls,
    rootClassName = props.rootClassName,
    icons = props.icons,
    countRender = props.countRender,
    showSwitch = props.showSwitch,
    showProgress = props.showProgress,
    current = props.current,
    transform = props.transform,
    count = props.count,
    scale = props.scale,
    minScale = props.minScale,
    maxScale = props.maxScale,
    closeIcon = props.closeIcon,
    onActive = props.onActive,
    onClose = props.onClose,
    onZoomIn = props.onZoomIn,
    onZoomOut = props.onZoomOut,
    onRotateRight = props.onRotateRight,
    onRotateLeft = props.onRotateLeft,
    onFlipX = props.onFlipX,
    onFlipY = props.onFlipY,
    onReset = props.onReset,
    toolbarRender = props.toolbarRender,
    zIndex = props.zIndex,
    image = props.image;
  var groupContext = (0,react.useContext)(PreviewGroupContext);
  var rotateLeft = icons.rotateLeft,
    rotateRight = icons.rotateRight,
    zoomIn = icons.zoomIn,
    zoomOut = icons.zoomOut,
    close = icons.close,
    left = icons.left,
    right = icons.right,
    flipX = icons.flipX,
    flipY = icons.flipY;
  var toolClassName = "".concat(prefixCls, "-operations-operation");
  react.useEffect(function () {
    var onKeyDown = function onKeyDown(e) {
      if (e.keyCode === KeyCode/* default.ESC */.Z.ESC) {
        onClose();
      }
    };
    if (visible) {
      window.addEventListener('keydown', onKeyDown);
    }
    return function () {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [visible]);
  var handleActive = function handleActive(e, offset) {
    e.preventDefault();
    e.stopPropagation();
    onActive(offset);
  };
  var renderOperation = react.useCallback(function (_ref) {
    var type = _ref.type,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      icon = _ref.icon;
    return /*#__PURE__*/react.createElement("div", {
      key: type,
      className: classnames_default()(toolClassName, "".concat(prefixCls, "-operations-operation-").concat(type), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-operations-operation-disabled"), !!disabled)),
      onClick: onClick
    }, icon);
  }, [toolClassName, prefixCls]);
  var switchPrevNode = showSwitch ? renderOperation({
    icon: left,
    onClick: function onClick(e) {
      return handleActive(e, -1);
    },
    type: 'prev',
    disabled: current === 0
  }) : undefined;
  var switchNextNode = showSwitch ? renderOperation({
    icon: right,
    onClick: function onClick(e) {
      return handleActive(e, 1);
    },
    type: 'next',
    disabled: current === count - 1
  }) : undefined;
  var flipYNode = renderOperation({
    icon: flipY,
    onClick: onFlipY,
    type: 'flipY'
  });
  var flipXNode = renderOperation({
    icon: flipX,
    onClick: onFlipX,
    type: 'flipX'
  });
  var rotateLeftNode = renderOperation({
    icon: rotateLeft,
    onClick: onRotateLeft,
    type: 'rotateLeft'
  });
  var rotateRightNode = renderOperation({
    icon: rotateRight,
    onClick: onRotateRight,
    type: 'rotateRight'
  });
  var zoomOutNode = renderOperation({
    icon: zoomOut,
    onClick: onZoomOut,
    type: 'zoomOut',
    disabled: scale <= minScale
  });
  var zoomInNode = renderOperation({
    icon: zoomIn,
    onClick: onZoomIn,
    type: 'zoomIn',
    disabled: scale === maxScale
  });
  var toolbarNode = /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-operations")
  }, flipYNode, flipXNode, rotateLeftNode, rotateRightNode, zoomOutNode, zoomInNode);
  return /*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, {
    visible: visible,
    motionName: maskTransitionName
  }, function (_ref2) {
    var className = _ref2.className,
      style = _ref2.style;
    return /*#__PURE__*/react.createElement(portal_es/* default */.Z, {
      open: true,
      getContainer: getContainer !== null && getContainer !== void 0 ? getContainer : document.body
    }, /*#__PURE__*/react.createElement("div", {
      className: classnames_default()("".concat(prefixCls, "-operations-wrapper"), className, rootClassName),
      style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, style), {}, {
        zIndex: zIndex
      })
    }, closeIcon === null ? null : /*#__PURE__*/react.createElement("button", {
      className: "".concat(prefixCls, "-close"),
      onClick: onClose
    }, closeIcon || close), showSwitch && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
      className: classnames_default()("".concat(prefixCls, "-switch-left"), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-switch-left-disabled"), current === 0)),
      onClick: function onClick(e) {
        return handleActive(e, -1);
      }
    }, left), /*#__PURE__*/react.createElement("div", {
      className: classnames_default()("".concat(prefixCls, "-switch-right"), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-switch-right-disabled"), current === count - 1)),
      onClick: function onClick(e) {
        return handleActive(e, 1);
      }
    }, right)), /*#__PURE__*/react.createElement("div", {
      className: "".concat(prefixCls, "-footer")
    }, showProgress && /*#__PURE__*/react.createElement("div", {
      className: "".concat(prefixCls, "-progress")
    }, countRender ? countRender(current + 1, count) : /*#__PURE__*/react.createElement("bdi", null, "".concat(current + 1, " / ").concat(count))), toolbarRender ? toolbarRender(toolbarNode, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
      icons: {
        prevIcon: switchPrevNode,
        nextIcon: switchNextNode,
        flipYIcon: flipYNode,
        flipXIcon: flipXNode,
        rotateLeftIcon: rotateLeftNode,
        rotateRightIcon: rotateRightNode,
        zoomOutIcon: zoomOutNode,
        zoomInIcon: zoomInNode
      },
      actions: {
        onActive: onActive,
        onFlipY: onFlipY,
        onFlipX: onFlipX,
        onRotateLeft: onRotateLeft,
        onRotateRight: onRotateRight,
        onZoomOut: onZoomOut,
        onZoomIn: onZoomIn,
        onReset: onReset,
        onClose: onClose
      },
      transform: transform
    }, groupContext ? {
      current: current,
      total: count
    } : {}), {}, {
      image: image
    })) : toolbarNode)));
  });
};
/* harmony default export */ var es_Operations = (Operations);
// EXTERNAL MODULE: ./node_modules/rc-util/es/isEqual.js
var isEqual = __webpack_require__(55159);
// EXTERNAL MODULE: ./node_modules/rc-util/es/raf.js
var raf = __webpack_require__(13157);
;// CONCATENATED MODULE: ./node_modules/rc-image/es/hooks/useImageTransform.js






var initialTransform = {
  x: 0,
  y: 0,
  rotate: 0,
  scale: 1,
  flipX: false,
  flipY: false
};
function useImageTransform(imgRef, minScale, maxScale, onTransform) {
  var frame = (0,react.useRef)(null);
  var queue = (0,react.useRef)([]);
  var _useState = (0,react.useState)(initialTransform),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    transform = _useState2[0],
    setTransform = _useState2[1];
  var resetTransform = function resetTransform(action) {
    setTransform(initialTransform);
    if (!(0,isEqual/* default */.Z)(initialTransform, transform)) {
      onTransform === null || onTransform === void 0 || onTransform({
        transform: initialTransform,
        action: action
      });
    }
  };

  /** Direct update transform */
  var updateTransform = function updateTransform(newTransform, action) {
    if (frame.current === null) {
      queue.current = [];
      frame.current = (0,raf/* default */.Z)(function () {
        setTransform(function (preState) {
          var memoState = preState;
          queue.current.forEach(function (queueState) {
            memoState = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, memoState), queueState);
          });
          frame.current = null;
          onTransform === null || onTransform === void 0 || onTransform({
            transform: memoState,
            action: action
          });
          return memoState;
        });
      });
    }
    queue.current.push((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, transform), newTransform));
  };

  /** Scale according to the position of centerX and centerY */
  var dispatchZoomChange = function dispatchZoomChange(ratio, action, centerX, centerY, isTouch) {
    var _imgRef$current = imgRef.current,
      width = _imgRef$current.width,
      height = _imgRef$current.height,
      offsetWidth = _imgRef$current.offsetWidth,
      offsetHeight = _imgRef$current.offsetHeight,
      offsetLeft = _imgRef$current.offsetLeft,
      offsetTop = _imgRef$current.offsetTop;
    var newRatio = ratio;
    var newScale = transform.scale * ratio;
    if (newScale > maxScale) {
      newScale = maxScale;
      newRatio = maxScale / transform.scale;
    } else if (newScale < minScale) {
      // For mobile interactions, allow scaling down to the minimum scale.
      newScale = isTouch ? newScale : minScale;
      newRatio = newScale / transform.scale;
    }

    /** Default center point scaling */
    var mergedCenterX = centerX !== null && centerX !== void 0 ? centerX : innerWidth / 2;
    var mergedCenterY = centerY !== null && centerY !== void 0 ? centerY : innerHeight / 2;
    var diffRatio = newRatio - 1;
    /** Deviation calculated from image size */
    var diffImgX = diffRatio * width * 0.5;
    var diffImgY = diffRatio * height * 0.5;
    /** The difference between the click position and the edge of the document */
    var diffOffsetLeft = diffRatio * (mergedCenterX - transform.x - offsetLeft);
    var diffOffsetTop = diffRatio * (mergedCenterY - transform.y - offsetTop);
    /** Final positioning */
    var newX = transform.x - (diffOffsetLeft - diffImgX);
    var newY = transform.y - (diffOffsetTop - diffImgY);

    /**
     * When zooming the image
     * When the image size is smaller than the width and height of the window, the position is initialized
     */
    if (ratio < 1 && newScale === 1) {
      var mergedWidth = offsetWidth * newScale;
      var mergedHeight = offsetHeight * newScale;
      var _getClientSize = getClientSize(),
        clientWidth = _getClientSize.width,
        clientHeight = _getClientSize.height;
      if (mergedWidth <= clientWidth && mergedHeight <= clientHeight) {
        newX = 0;
        newY = 0;
      }
    }
    updateTransform({
      x: newX,
      y: newY,
      scale: newScale
    }, action);
  };
  return {
    transform: transform,
    resetTransform: resetTransform,
    updateTransform: updateTransform,
    dispatchZoomChange: dispatchZoomChange
  };
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(13764);
;// CONCATENATED MODULE: ./node_modules/rc-image/es/getFixScaleEleTransPosition.js



function fixPoint(key, start, width, clientWidth) {
  var startAddWidth = start + width;
  var offsetStart = (width - clientWidth) / 2;
  if (width > clientWidth) {
    if (start > 0) {
      return (0,defineProperty/* default */.Z)({}, key, offsetStart);
    }
    if (start < 0 && startAddWidth < clientWidth) {
      return (0,defineProperty/* default */.Z)({}, key, -offsetStart);
    }
  } else if (start < 0 || startAddWidth > clientWidth) {
    return (0,defineProperty/* default */.Z)({}, key, start < 0 ? offsetStart : -offsetStart);
  }
  return {};
}

/**
 * Fix positon x,y point when
 *
 * Ele width && height < client
 * - Back origin
 *
 * - Ele width | height > clientWidth | clientHeight
 * - left | top > 0 -> Back 0
 * - left | top + width | height < clientWidth | clientHeight -> Back left | top + width | height === clientWidth | clientHeight
 *
 * Regardless of other
 */
function getFixScaleEleTransPosition(width, height, left, top) {
  var _getClientSize = getClientSize(),
    clientWidth = _getClientSize.width,
    clientHeight = _getClientSize.height;
  var fixPos = null;
  if (width <= clientWidth && height <= clientHeight) {
    fixPos = {
      x: 0,
      y: 0
    };
  } else if (width > clientWidth || height > clientHeight) {
    fixPos = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, fixPoint('x', left, width, clientWidth)), fixPoint('y', top, height, clientHeight));
  }
  return fixPos;
}
;// CONCATENATED MODULE: ./node_modules/rc-image/es/previewConfig.js
/** Scale the ratio base */
var BASE_SCALE_RATIO = 1;
/** The maximum zoom ratio when the mouse zooms in, adjustable */
var WHEEL_MAX_SCALE_RATIO = 1;
;// CONCATENATED MODULE: ./node_modules/rc-image/es/hooks/useMouseEvent.js







function useMouseEvent(imgRef, movable, visible, scaleStep, transform, updateTransform, dispatchZoomChange) {
  var rotate = transform.rotate,
    scale = transform.scale,
    x = transform.x,
    y = transform.y;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    isMoving = _useState2[0],
    setMoving = _useState2[1];
  var startPositionInfo = (0,react.useRef)({
    diffX: 0,
    diffY: 0,
    transformX: 0,
    transformY: 0
  });
  var onMouseDown = function onMouseDown(event) {
    // Only allow main button
    if (!movable || event.button !== 0) return;
    event.preventDefault();
    event.stopPropagation();
    startPositionInfo.current = {
      diffX: event.pageX - x,
      diffY: event.pageY - y,
      transformX: x,
      transformY: y
    };
    setMoving(true);
  };
  var onMouseMove = function onMouseMove(event) {
    if (visible && isMoving) {
      updateTransform({
        x: event.pageX - startPositionInfo.current.diffX,
        y: event.pageY - startPositionInfo.current.diffY
      }, 'move');
    }
  };
  var onMouseUp = function onMouseUp() {
    if (visible && isMoving) {
      setMoving(false);

      /** No need to restore the position when the picture is not moved, So as not to interfere with the click */
      var _startPositionInfo$cu = startPositionInfo.current,
        transformX = _startPositionInfo$cu.transformX,
        transformY = _startPositionInfo$cu.transformY;
      var hasChangedPosition = x !== transformX && y !== transformY;
      if (!hasChangedPosition) return;
      var width = imgRef.current.offsetWidth * scale;
      var height = imgRef.current.offsetHeight * scale;
      // eslint-disable-next-line @typescript-eslint/no-shadow
      var _imgRef$current$getBo = imgRef.current.getBoundingClientRect(),
        left = _imgRef$current$getBo.left,
        top = _imgRef$current$getBo.top;
      var isRotate = rotate % 180 !== 0;
      var fixState = getFixScaleEleTransPosition(isRotate ? height : width, isRotate ? width : height, left, top);
      if (fixState) {
        updateTransform((0,objectSpread2/* default */.Z)({}, fixState), 'dragRebound');
      }
    }
  };
  var onWheel = function onWheel(event) {
    if (!visible || event.deltaY == 0) return;
    // Scale ratio depends on the deltaY size
    var scaleRatio = Math.abs(event.deltaY / 100);
    // Limit the maximum scale ratio
    var mergedScaleRatio = Math.min(scaleRatio, WHEEL_MAX_SCALE_RATIO);
    // Scale the ratio each time
    var ratio = BASE_SCALE_RATIO + mergedScaleRatio * scaleStep;
    if (event.deltaY > 0) {
      ratio = BASE_SCALE_RATIO / ratio;
    }
    dispatchZoomChange(ratio, 'wheel', event.clientX, event.clientY);
  };
  (0,react.useEffect)(function () {
    var onTopMouseUpListener;
    var onTopMouseMoveListener;
    var onMouseUpListener;
    var onMouseMoveListener;
    if (movable) {
      onMouseUpListener = (0,addEventListener/* default */.Z)(window, 'mouseup', onMouseUp, false);
      onMouseMoveListener = (0,addEventListener/* default */.Z)(window, 'mousemove', onMouseMove, false);
      try {
        // Resolve if in iframe lost event
        /* istanbul ignore next */
        if (window.top !== window.self) {
          onTopMouseUpListener = (0,addEventListener/* default */.Z)(window.top, 'mouseup', onMouseUp, false);
          onTopMouseMoveListener = (0,addEventListener/* default */.Z)(window.top, 'mousemove', onMouseMove, false);
        }
      } catch (error) {
        /* istanbul ignore next */
        (0,warning/* warning */.Kp)(false, "[rc-image] ".concat(error));
      }
    }
    return function () {
      var _onMouseUpListener, _onMouseMoveListener, _onTopMouseUpListener, _onTopMouseMoveListen;
      (_onMouseUpListener = onMouseUpListener) === null || _onMouseUpListener === void 0 || _onMouseUpListener.remove();
      (_onMouseMoveListener = onMouseMoveListener) === null || _onMouseMoveListener === void 0 || _onMouseMoveListener.remove();
      /* istanbul ignore next */
      (_onTopMouseUpListener = onTopMouseUpListener) === null || _onTopMouseUpListener === void 0 || _onTopMouseUpListener.remove();
      /* istanbul ignore next */
      (_onTopMouseMoveListen = onTopMouseMoveListener) === null || _onTopMouseMoveListen === void 0 || _onTopMouseMoveListen.remove();
    };
  }, [visible, isMoving, x, y, rotate, movable]);
  return {
    isMoving: isMoving,
    onMouseDown: onMouseDown,
    onMouseMove: onMouseMove,
    onMouseUp: onMouseUp,
    onWheel: onWheel
  };
}
;// CONCATENATED MODULE: ./node_modules/rc-image/es/util.js
function isImageValid(src) {
  return new Promise(function (resolve) {
    if (!src) {
      resolve(false);
      return;
    }
    var img = document.createElement('img');
    img.onerror = function () {
      return resolve(false);
    };
    img.onload = function () {
      return resolve(true);
    };
    img.src = src;
  });
}
;// CONCATENATED MODULE: ./node_modules/rc-image/es/hooks/useStatus.js



function useStatus(_ref) {
  var src = _ref.src,
    isCustomPlaceholder = _ref.isCustomPlaceholder,
    fallback = _ref.fallback;
  var _useState = (0,react.useState)(isCustomPlaceholder ? 'loading' : 'normal'),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  var isLoaded = (0,react.useRef)(false);
  var isError = status === 'error';

  // https://github.com/react-component/image/pull/187
  (0,react.useEffect)(function () {
    var isCurrentSrc = true;
    isImageValid(src).then(function (isValid) {
      // https://github.com/ant-design/ant-design/issues/44948
      // If src changes, the previous setStatus should not be triggered
      if (!isValid && isCurrentSrc) {
        setStatus('error');
      }
    });
    return function () {
      isCurrentSrc = false;
    };
  }, [src]);
  (0,react.useEffect)(function () {
    if (isCustomPlaceholder && !isLoaded.current) {
      setStatus('loading');
    } else if (isError) {
      setStatus('normal');
    }
  }, [src]);
  var onLoad = function onLoad() {
    setStatus('normal');
  };
  var getImgRef = function getImgRef(img) {
    isLoaded.current = false;
    if (status === 'loading' && img !== null && img !== void 0 && img.complete && (img.naturalWidth || img.naturalHeight)) {
      isLoaded.current = true;
      onLoad();
    }
  };
  var srcAndOnload = isError && fallback ? {
    src: fallback
  } : {
    onLoad: onLoad,
    src: src
  };
  return [getImgRef, srcAndOnload, status];
}
;// CONCATENATED MODULE: ./node_modules/rc-image/es/hooks/useTouchEvent.js





function getDistance(a, b) {
  var x = a.x - b.x;
  var y = a.y - b.y;
  return Math.hypot(x, y);
}
function getCenter(oldPoint1, oldPoint2, newPoint1, newPoint2) {
  // Calculate the distance each point has moved
  var distance1 = getDistance(oldPoint1, newPoint1);
  var distance2 = getDistance(oldPoint2, newPoint2);

  // If both distances are 0, return the original points
  if (distance1 === 0 && distance2 === 0) {
    return [oldPoint1.x, oldPoint1.y];
  }

  // Calculate the ratio of the distances
  var ratio = distance1 / (distance1 + distance2);

  // Calculate the new center point based on the ratio
  var x = oldPoint1.x + ratio * (oldPoint2.x - oldPoint1.x);
  var y = oldPoint1.y + ratio * (oldPoint2.y - oldPoint1.y);
  return [x, y];
}
function useTouchEvent(imgRef, movable, visible, minScale, transform, updateTransform, dispatchZoomChange) {
  var rotate = transform.rotate,
    scale = transform.scale,
    x = transform.x,
    y = transform.y;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    isTouching = _useState2[0],
    setIsTouching = _useState2[1];
  var touchPointInfo = (0,react.useRef)({
    point1: {
      x: 0,
      y: 0
    },
    point2: {
      x: 0,
      y: 0
    },
    eventType: 'none'
  });
  var updateTouchPointInfo = function updateTouchPointInfo(values) {
    touchPointInfo.current = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, touchPointInfo.current), values);
  };
  var onTouchStart = function onTouchStart(event) {
    if (!movable) return;
    event.stopPropagation();
    setIsTouching(true);
    var _event$touches = event.touches,
      touches = _event$touches === void 0 ? [] : _event$touches;
    if (touches.length > 1) {
      // touch zoom
      updateTouchPointInfo({
        point1: {
          x: touches[0].clientX,
          y: touches[0].clientY
        },
        point2: {
          x: touches[1].clientX,
          y: touches[1].clientY
        },
        eventType: 'touchZoom'
      });
    } else {
      // touch move
      updateTouchPointInfo({
        point1: {
          x: touches[0].clientX - x,
          y: touches[0].clientY - y
        },
        eventType: 'move'
      });
    }
  };
  var onTouchMove = function onTouchMove(event) {
    var _event$touches2 = event.touches,
      touches = _event$touches2 === void 0 ? [] : _event$touches2;
    var _touchPointInfo$curre = touchPointInfo.current,
      point1 = _touchPointInfo$curre.point1,
      point2 = _touchPointInfo$curre.point2,
      eventType = _touchPointInfo$curre.eventType;
    if (touches.length > 1 && eventType === 'touchZoom') {
      // touch zoom
      var newPoint1 = {
        x: touches[0].clientX,
        y: touches[0].clientY
      };
      var newPoint2 = {
        x: touches[1].clientX,
        y: touches[1].clientY
      };
      var _getCenter = getCenter(point1, point2, newPoint1, newPoint2),
        _getCenter2 = (0,slicedToArray/* default */.Z)(_getCenter, 2),
        centerX = _getCenter2[0],
        centerY = _getCenter2[1];
      var ratio = getDistance(newPoint1, newPoint2) / getDistance(point1, point2);
      dispatchZoomChange(ratio, 'touchZoom', centerX, centerY, true);
      updateTouchPointInfo({
        point1: newPoint1,
        point2: newPoint2,
        eventType: 'touchZoom'
      });
    } else if (eventType === 'move') {
      // touch move
      updateTransform({
        x: touches[0].clientX - point1.x,
        y: touches[0].clientY - point1.y
      }, 'move');
      updateTouchPointInfo({
        eventType: 'move'
      });
    }
  };
  var onTouchEnd = function onTouchEnd() {
    if (!visible) return;
    if (isTouching) {
      setIsTouching(false);
    }
    updateTouchPointInfo({
      eventType: 'none'
    });
    if (minScale > scale) {
      /** When the scaling ratio is less than the minimum scaling ratio, reset the scaling ratio */
      return updateTransform({
        x: 0,
        y: 0,
        scale: minScale
      }, 'touchZoom');
    }
    var width = imgRef.current.offsetWidth * scale;
    var height = imgRef.current.offsetHeight * scale;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    var _imgRef$current$getBo = imgRef.current.getBoundingClientRect(),
      left = _imgRef$current$getBo.left,
      top = _imgRef$current$getBo.top;
    var isRotate = rotate % 180 !== 0;
    var fixState = getFixScaleEleTransPosition(isRotate ? height : width, isRotate ? width : height, left, top);
    if (fixState) {
      updateTransform((0,objectSpread2/* default */.Z)({}, fixState), 'dragRebound');
    }
  };
  (0,react.useEffect)(function () {
    var onTouchMoveListener;
    if (visible && movable) {
      onTouchMoveListener = (0,addEventListener/* default */.Z)(window, 'touchmove', function (e) {
        return e.preventDefault();
      }, {
        passive: false
      });
    }
    return function () {
      var _onTouchMoveListener;
      (_onTouchMoveListener = onTouchMoveListener) === null || _onTouchMoveListener === void 0 || _onTouchMoveListener.remove();
    };
  }, [visible, movable]);
  return {
    isTouching: isTouching,
    onTouchStart: onTouchStart,
    onTouchMove: onTouchMove,
    onTouchEnd: onTouchEnd
  };
}
;// CONCATENATED MODULE: ./node_modules/rc-image/es/Preview.js





var _excluded = ["fallback", "src", "imgRef"],
  _excluded2 = ["prefixCls", "src", "alt", "imageInfo", "fallback", "movable", "onClose", "visible", "icons", "rootClassName", "closeIcon", "getContainer", "current", "count", "countRender", "scaleStep", "minScale", "maxScale", "transitionName", "maskTransitionName", "imageRender", "imgCommonProps", "toolbarRender", "onTransform", "onChange"];












var PreviewImage = function PreviewImage(_ref) {
  var fallback = _ref.fallback,
    src = _ref.src,
    imgRef = _ref.imgRef,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  var _useStatus = useStatus({
      src: src,
      fallback: fallback
    }),
    _useStatus2 = (0,slicedToArray/* default */.Z)(_useStatus, 2),
    getImgRef = _useStatus2[0],
    srcAndOnload = _useStatus2[1];
  return /*#__PURE__*/react.createElement("img", (0,esm_extends/* default */.Z)({
    ref: function ref(_ref2) {
      imgRef.current = _ref2;
      getImgRef(_ref2);
    }
  }, props, srcAndOnload));
};
var Preview = function Preview(props) {
  var prefixCls = props.prefixCls,
    src = props.src,
    alt = props.alt,
    imageInfo = props.imageInfo,
    fallback = props.fallback,
    _props$movable = props.movable,
    movable = _props$movable === void 0 ? true : _props$movable,
    onClose = props.onClose,
    visible = props.visible,
    _props$icons = props.icons,
    icons = _props$icons === void 0 ? {} : _props$icons,
    rootClassName = props.rootClassName,
    closeIcon = props.closeIcon,
    getContainer = props.getContainer,
    _props$current = props.current,
    current = _props$current === void 0 ? 0 : _props$current,
    _props$count = props.count,
    count = _props$count === void 0 ? 1 : _props$count,
    countRender = props.countRender,
    _props$scaleStep = props.scaleStep,
    scaleStep = _props$scaleStep === void 0 ? 0.5 : _props$scaleStep,
    _props$minScale = props.minScale,
    minScale = _props$minScale === void 0 ? 1 : _props$minScale,
    _props$maxScale = props.maxScale,
    maxScale = _props$maxScale === void 0 ? 50 : _props$maxScale,
    _props$transitionName = props.transitionName,
    transitionName = _props$transitionName === void 0 ? 'zoom' : _props$transitionName,
    _props$maskTransition = props.maskTransitionName,
    maskTransitionName = _props$maskTransition === void 0 ? 'fade' : _props$maskTransition,
    imageRender = props.imageRender,
    imgCommonProps = props.imgCommonProps,
    toolbarRender = props.toolbarRender,
    onTransform = props.onTransform,
    onChange = props.onChange,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded2);
  var imgRef = (0,react.useRef)();
  var groupContext = (0,react.useContext)(PreviewGroupContext);
  var showLeftOrRightSwitches = groupContext && count > 1;
  var showOperationsProgress = groupContext && count >= 1;
  var _useState = (0,react.useState)(true),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    enableTransition = _useState2[0],
    setEnableTransition = _useState2[1];
  var _useImageTransform = useImageTransform(imgRef, minScale, maxScale, onTransform),
    transform = _useImageTransform.transform,
    resetTransform = _useImageTransform.resetTransform,
    updateTransform = _useImageTransform.updateTransform,
    dispatchZoomChange = _useImageTransform.dispatchZoomChange;
  var _useMouseEvent = useMouseEvent(imgRef, movable, visible, scaleStep, transform, updateTransform, dispatchZoomChange),
    isMoving = _useMouseEvent.isMoving,
    onMouseDown = _useMouseEvent.onMouseDown,
    onWheel = _useMouseEvent.onWheel;
  var _useTouchEvent = useTouchEvent(imgRef, movable, visible, minScale, transform, updateTransform, dispatchZoomChange),
    isTouching = _useTouchEvent.isTouching,
    onTouchStart = _useTouchEvent.onTouchStart,
    onTouchMove = _useTouchEvent.onTouchMove,
    onTouchEnd = _useTouchEvent.onTouchEnd;
  var rotate = transform.rotate,
    scale = transform.scale;
  var wrapClassName = classnames_default()((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-moving"), isMoving));
  (0,react.useEffect)(function () {
    if (!enableTransition) {
      setEnableTransition(true);
    }
  }, [enableTransition]);
  var onAfterClose = function onAfterClose() {
    resetTransform('close');
  };
  var onZoomIn = function onZoomIn() {
    dispatchZoomChange(BASE_SCALE_RATIO + scaleStep, 'zoomIn');
  };
  var onZoomOut = function onZoomOut() {
    dispatchZoomChange(BASE_SCALE_RATIO / (BASE_SCALE_RATIO + scaleStep), 'zoomOut');
  };
  var onRotateRight = function onRotateRight() {
    updateTransform({
      rotate: rotate + 90
    }, 'rotateRight');
  };
  var onRotateLeft = function onRotateLeft() {
    updateTransform({
      rotate: rotate - 90
    }, 'rotateLeft');
  };
  var onFlipX = function onFlipX() {
    updateTransform({
      flipX: !transform.flipX
    }, 'flipX');
  };
  var onFlipY = function onFlipY() {
    updateTransform({
      flipY: !transform.flipY
    }, 'flipY');
  };
  var onReset = function onReset() {
    resetTransform('reset');
  };
  var onActive = function onActive(offset) {
    var position = current + offset;
    if (!Number.isInteger(position) || position < 0 || position > count - 1) {
      return;
    }
    setEnableTransition(false);
    resetTransform(offset < 0 ? 'prev' : 'next');
    onChange === null || onChange === void 0 || onChange(position, current);
  };
  var onKeyDown = function onKeyDown(event) {
    if (!visible || !showLeftOrRightSwitches) return;
    if (event.keyCode === KeyCode/* default.LEFT */.Z.LEFT) {
      onActive(-1);
    } else if (event.keyCode === KeyCode/* default.RIGHT */.Z.RIGHT) {
      onActive(1);
    }
  };
  var onDoubleClick = function onDoubleClick(event) {
    if (visible) {
      if (scale !== 1) {
        updateTransform({
          x: 0,
          y: 0,
          scale: 1
        }, 'doubleClick');
      } else {
        dispatchZoomChange(BASE_SCALE_RATIO + scaleStep, 'doubleClick', event.clientX, event.clientY);
      }
    }
  };
  (0,react.useEffect)(function () {
    var onKeyDownListener = (0,addEventListener/* default */.Z)(window, 'keydown', onKeyDown, false);
    return function () {
      onKeyDownListener.remove();
    };
  }, [visible, showLeftOrRightSwitches, current]);
  var imgNode = /*#__PURE__*/react.createElement(PreviewImage, (0,esm_extends/* default */.Z)({}, imgCommonProps, {
    width: props.width,
    height: props.height,
    imgRef: imgRef,
    className: "".concat(prefixCls, "-img"),
    alt: alt,
    style: {
      transform: "translate3d(".concat(transform.x, "px, ").concat(transform.y, "px, 0) scale3d(").concat(transform.flipX ? '-' : '').concat(scale, ", ").concat(transform.flipY ? '-' : '').concat(scale, ", 1) rotate(").concat(rotate, "deg)"),
      transitionDuration: (!enableTransition || isTouching) && '0s'
    },
    fallback: fallback,
    src: src,
    onWheel: onWheel,
    onMouseDown: onMouseDown,
    onDoubleClick: onDoubleClick,
    onTouchStart: onTouchStart,
    onTouchMove: onTouchMove,
    onTouchEnd: onTouchEnd,
    onTouchCancel: onTouchEnd
  }));
  var image = (0,objectSpread2/* default */.Z)({
    url: src,
    alt: alt
  }, imageInfo);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(es/* default */.Z, (0,esm_extends/* default */.Z)({
    transitionName: transitionName,
    maskTransitionName: maskTransitionName,
    closable: false,
    keyboard: true,
    prefixCls: prefixCls,
    onClose: onClose,
    visible: visible,
    classNames: {
      wrapper: wrapClassName
    },
    rootClassName: rootClassName,
    getContainer: getContainer
  }, restProps, {
    afterClose: onAfterClose
  }), /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-img-wrapper")
  }, imageRender ? imageRender(imgNode, (0,objectSpread2/* default */.Z)({
    transform: transform,
    image: image
  }, groupContext ? {
    current: current
  } : {})) : imgNode)), /*#__PURE__*/react.createElement(es_Operations, {
    visible: visible,
    transform: transform,
    maskTransitionName: maskTransitionName,
    closeIcon: closeIcon,
    getContainer: getContainer,
    prefixCls: prefixCls,
    rootClassName: rootClassName,
    icons: icons,
    countRender: countRender,
    showSwitch: showLeftOrRightSwitches,
    showProgress: showOperationsProgress,
    current: current,
    count: count,
    scale: scale,
    minScale: minScale,
    maxScale: maxScale,
    toolbarRender: toolbarRender,
    onActive: onActive,
    onZoomIn: onZoomIn,
    onZoomOut: onZoomOut,
    onRotateRight: onRotateRight,
    onRotateLeft: onRotateLeft,
    onFlipX: onFlipX,
    onFlipY: onFlipY,
    onClose: onClose,
    onReset: onReset,
    zIndex: restProps.zIndex !== undefined ? restProps.zIndex + 1 : undefined,
    image: image
  }));
};
/* harmony default export */ var es_Preview = (Preview);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
;// CONCATENATED MODULE: ./node_modules/rc-image/es/common.js
var COMMON_PROPS = ['crossOrigin', 'decoding', 'draggable', 'loading', 'referrerPolicy', 'sizes', 'srcSet', 'useMap', 'alt'];
;// CONCATENATED MODULE: ./node_modules/rc-image/es/hooks/usePreviewItems.js






/**
 * Merge props provided `items` or context collected images
 */
function usePreviewItems(items) {
  // Context collection image data
  var _React$useState = react.useState({}),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    images = _React$useState2[0],
    setImages = _React$useState2[1];
  var registerImage = react.useCallback(function (id, data) {
    setImages(function (imgs) {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, imgs), {}, (0,defineProperty/* default */.Z)({}, id, data));
    });
    return function () {
      setImages(function (imgs) {
        var cloneImgs = (0,objectSpread2/* default */.Z)({}, imgs);
        delete cloneImgs[id];
        return cloneImgs;
      });
    };
  }, []);

  // items
  var mergedItems = react.useMemo(function () {
    // use `items` first
    if (items) {
      return items.map(function (item) {
        if (typeof item === 'string') {
          return {
            data: {
              src: item
            }
          };
        }
        var data = {};
        Object.keys(item).forEach(function (key) {
          if (['src'].concat((0,toConsumableArray/* default */.Z)(COMMON_PROPS)).includes(key)) {
            data[key] = item[key];
          }
        });
        return {
          data: data
        };
      });
    }

    // use registered images secondly
    return Object.keys(images).reduce(function (total, id) {
      var _images$id = images[id],
        canPreview = _images$id.canPreview,
        data = _images$id.data;
      if (canPreview) {
        total.push({
          data: data,
          id: id
        });
      }
      return total;
    }, []);
  }, [items, images]);
  return [mergedItems, registerImage, !!items];
}
;// CONCATENATED MODULE: ./node_modules/rc-image/es/PreviewGroup.js




var PreviewGroup_excluded = ["visible", "onVisibleChange", "getContainer", "current", "movable", "minScale", "maxScale", "countRender", "closeIcon", "onChange", "onTransform", "toolbarRender", "imageRender"],
  PreviewGroup_excluded2 = ["src"];






var Group = function Group(_ref) {
  var _mergedItems$current;
  var _ref$previewPrefixCls = _ref.previewPrefixCls,
    previewPrefixCls = _ref$previewPrefixCls === void 0 ? 'rc-image-preview' : _ref$previewPrefixCls,
    children = _ref.children,
    _ref$icons = _ref.icons,
    icons = _ref$icons === void 0 ? {} : _ref$icons,
    items = _ref.items,
    preview = _ref.preview,
    fallback = _ref.fallback;
  var _ref2 = (0,esm_typeof/* default */.Z)(preview) === 'object' ? preview : {},
    previewVisible = _ref2.visible,
    onVisibleChange = _ref2.onVisibleChange,
    getContainer = _ref2.getContainer,
    currentIndex = _ref2.current,
    movable = _ref2.movable,
    minScale = _ref2.minScale,
    maxScale = _ref2.maxScale,
    countRender = _ref2.countRender,
    closeIcon = _ref2.closeIcon,
    onChange = _ref2.onChange,
    onTransform = _ref2.onTransform,
    toolbarRender = _ref2.toolbarRender,
    imageRender = _ref2.imageRender,
    dialogProps = (0,objectWithoutProperties/* default */.Z)(_ref2, PreviewGroup_excluded);

  // ========================== Items ===========================
  var _usePreviewItems = usePreviewItems(items),
    _usePreviewItems2 = (0,slicedToArray/* default */.Z)(_usePreviewItems, 3),
    mergedItems = _usePreviewItems2[0],
    register = _usePreviewItems2[1],
    fromItems = _usePreviewItems2[2];

  // ========================= Preview ==========================
  // >>> Index
  var _useMergedState = (0,useMergedState/* default */.Z)(0, {
      value: currentIndex
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    current = _useMergedState2[0],
    setCurrent = _useMergedState2[1];
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    keepOpenIndex = _useState2[0],
    setKeepOpenIndex = _useState2[1];

  // >>> Image
  var _ref3 = ((_mergedItems$current = mergedItems[current]) === null || _mergedItems$current === void 0 ? void 0 : _mergedItems$current.data) || {},
    src = _ref3.src,
    imgCommonProps = (0,objectWithoutProperties/* default */.Z)(_ref3, PreviewGroup_excluded2);
  // >>> Visible
  var _useMergedState3 = (0,useMergedState/* default */.Z)(!!previewVisible, {
      value: previewVisible,
      onChange: function onChange(val, prevVal) {
        onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(val, prevVal, current);
      }
    }),
    _useMergedState4 = (0,slicedToArray/* default */.Z)(_useMergedState3, 2),
    isShowPreview = _useMergedState4[0],
    setShowPreview = _useMergedState4[1];

  // >>> Position
  var _useState3 = (0,react.useState)(null),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    mousePosition = _useState4[0],
    setMousePosition = _useState4[1];
  var onPreviewFromImage = react.useCallback(function (id, imageSrc, mouseX, mouseY) {
    var index = fromItems ? mergedItems.findIndex(function (item) {
      return item.data.src === imageSrc;
    }) : mergedItems.findIndex(function (item) {
      return item.id === id;
    });
    setCurrent(index < 0 ? 0 : index);
    setShowPreview(true);
    setMousePosition({
      x: mouseX,
      y: mouseY
    });
    setKeepOpenIndex(true);
  }, [mergedItems, fromItems]);

  // Reset current when reopen
  react.useEffect(function () {
    if (isShowPreview) {
      if (!keepOpenIndex) {
        setCurrent(0);
      }
    } else {
      setKeepOpenIndex(false);
    }
  }, [isShowPreview]);

  // ========================== Events ==========================
  var onInternalChange = function onInternalChange(next, prev) {
    setCurrent(next);
    onChange === null || onChange === void 0 || onChange(next, prev);
  };
  var onPreviewClose = function onPreviewClose() {
    setShowPreview(false);
    setMousePosition(null);
  };

  // ========================= Context ==========================
  var previewGroupContext = react.useMemo(function () {
    return {
      register: register,
      onPreview: onPreviewFromImage
    };
  }, [register, onPreviewFromImage]);

  // ========================== Render ==========================
  return /*#__PURE__*/react.createElement(PreviewGroupContext.Provider, {
    value: previewGroupContext
  }, children, /*#__PURE__*/react.createElement(es_Preview, (0,esm_extends/* default */.Z)({
    "aria-hidden": !isShowPreview,
    movable: movable,
    visible: isShowPreview,
    prefixCls: previewPrefixCls,
    closeIcon: closeIcon,
    onClose: onPreviewClose,
    mousePosition: mousePosition,
    imgCommonProps: imgCommonProps,
    src: src,
    fallback: fallback,
    icons: icons,
    minScale: minScale,
    maxScale: maxScale,
    getContainer: getContainer,
    current: current,
    count: mergedItems.length,
    countRender: countRender,
    onTransform: onTransform,
    toolbarRender: toolbarRender,
    imageRender: imageRender,
    onChange: onInternalChange
  }, dialogProps)));
};
/* harmony default export */ var PreviewGroup = (Group);
;// CONCATENATED MODULE: ./node_modules/rc-image/es/hooks/useRegisterImage.js



var uid = 0;
function useRegisterImage(canPreview, data) {
  var _React$useState = react.useState(function () {
      uid += 1;
      return String(uid);
    }),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 1),
    id = _React$useState2[0];
  var groupContext = react.useContext(PreviewGroupContext);
  var registerData = {
    data: data,
    canPreview: canPreview
  };

  // Keep order start
  // Resolve https://github.com/ant-design/ant-design/issues/28881
  // Only need unRegister when component unMount
  react.useEffect(function () {
    if (groupContext) {
      return groupContext.register(id, registerData);
    }
  }, []);
  react.useEffect(function () {
    if (groupContext) {
      groupContext.register(id, registerData);
    }
  }, [canPreview, data]);
  return id;
}
;// CONCATENATED MODULE: ./node_modules/rc-image/es/Image.js






var Image_excluded = ["src", "alt", "onPreviewClose", "prefixCls", "previewPrefixCls", "placeholder", "fallback", "width", "height", "style", "preview", "className", "onClick", "onError", "wrapperClassName", "wrapperStyle", "rootClassName"],
  Image_excluded2 = ["src", "visible", "onVisibleChange", "getContainer", "mask", "maskClassName", "movable", "icons", "scaleStep", "minScale", "maxScale", "imageRender", "toolbarRender"];











var ImageInternal = function ImageInternal(props) {
  var imgSrc = props.src,
    alt = props.alt,
    onInitialPreviewClose = props.onPreviewClose,
    _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-image' : _props$prefixCls,
    _props$previewPrefixC = props.previewPrefixCls,
    previewPrefixCls = _props$previewPrefixC === void 0 ? "".concat(prefixCls, "-preview") : _props$previewPrefixC,
    placeholder = props.placeholder,
    fallback = props.fallback,
    width = props.width,
    height = props.height,
    style = props.style,
    _props$preview = props.preview,
    preview = _props$preview === void 0 ? true : _props$preview,
    className = props.className,
    onClick = props.onClick,
    onError = props.onError,
    wrapperClassName = props.wrapperClassName,
    wrapperStyle = props.wrapperStyle,
    rootClassName = props.rootClassName,
    otherProps = (0,objectWithoutProperties/* default */.Z)(props, Image_excluded);
  var isCustomPlaceholder = placeholder && placeholder !== true;
  var _ref = (0,esm_typeof/* default */.Z)(preview) === 'object' ? preview : {},
    previewSrc = _ref.src,
    _ref$visible = _ref.visible,
    previewVisible = _ref$visible === void 0 ? undefined : _ref$visible,
    _ref$onVisibleChange = _ref.onVisibleChange,
    onPreviewVisibleChange = _ref$onVisibleChange === void 0 ? onInitialPreviewClose : _ref$onVisibleChange,
    _ref$getContainer = _ref.getContainer,
    getPreviewContainer = _ref$getContainer === void 0 ? undefined : _ref$getContainer,
    previewMask = _ref.mask,
    maskClassName = _ref.maskClassName,
    movable = _ref.movable,
    icons = _ref.icons,
    scaleStep = _ref.scaleStep,
    minScale = _ref.minScale,
    maxScale = _ref.maxScale,
    imageRender = _ref.imageRender,
    toolbarRender = _ref.toolbarRender,
    dialogProps = (0,objectWithoutProperties/* default */.Z)(_ref, Image_excluded2);
  var src = previewSrc !== null && previewSrc !== void 0 ? previewSrc : imgSrc;
  var _useMergedState = (0,useMergedState/* default */.Z)(!!previewVisible, {
      value: previewVisible,
      onChange: onPreviewVisibleChange
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    isShowPreview = _useMergedState2[0],
    setShowPreview = _useMergedState2[1];
  var _useStatus = useStatus({
      src: imgSrc,
      isCustomPlaceholder: isCustomPlaceholder,
      fallback: fallback
    }),
    _useStatus2 = (0,slicedToArray/* default */.Z)(_useStatus, 3),
    getImgRef = _useStatus2[0],
    srcAndOnload = _useStatus2[1],
    status = _useStatus2[2];
  var _useState = (0,react.useState)(null),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    mousePosition = _useState2[0],
    setMousePosition = _useState2[1];
  var groupContext = (0,react.useContext)(PreviewGroupContext);
  var canPreview = !!preview;
  var onPreviewClose = function onPreviewClose() {
    setShowPreview(false);
    setMousePosition(null);
  };
  var wrapperClass = classnames_default()(prefixCls, wrapperClassName, rootClassName, (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-error"), status === 'error'));

  // ========================= ImageProps =========================
  var imgCommonProps = (0,react.useMemo)(function () {
    var obj = {};
    COMMON_PROPS.forEach(function (prop) {
      if (props[prop] !== undefined) {
        obj[prop] = props[prop];
      }
    });
    return obj;
  }, COMMON_PROPS.map(function (prop) {
    return props[prop];
  }));

  // ========================== Register ==========================
  var registerData = (0,react.useMemo)(function () {
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, imgCommonProps), {}, {
      src: src
    });
  }, [src, imgCommonProps]);
  var imageId = useRegisterImage(canPreview, registerData);

  // ========================== Preview ===========================
  var onPreview = function onPreview(e) {
    var _getOffset = getOffset(e.target),
      left = _getOffset.left,
      top = _getOffset.top;
    if (groupContext) {
      groupContext.onPreview(imageId, src, left, top);
    } else {
      setMousePosition({
        x: left,
        y: top
      });
      setShowPreview(true);
    }
    onClick === null || onClick === void 0 || onClick(e);
  };

  // =========================== Render ===========================
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, otherProps, {
    className: wrapperClass,
    onClick: canPreview ? onPreview : onClick,
    style: (0,objectSpread2/* default */.Z)({
      width: width,
      height: height
    }, wrapperStyle)
  }), /*#__PURE__*/react.createElement("img", (0,esm_extends/* default */.Z)({}, imgCommonProps, {
    className: classnames_default()("".concat(prefixCls, "-img"), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-img-placeholder"), placeholder === true), className),
    style: (0,objectSpread2/* default */.Z)({
      height: height
    }, style),
    ref: getImgRef
  }, srcAndOnload, {
    width: width,
    height: height,
    onError: onError
  })), status === 'loading' && /*#__PURE__*/react.createElement("div", {
    "aria-hidden": "true",
    className: "".concat(prefixCls, "-placeholder")
  }, placeholder), previewMask && canPreview && /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(prefixCls, "-mask"), maskClassName),
    style: {
      display: (style === null || style === void 0 ? void 0 : style.display) === 'none' ? 'none' : undefined
    }
  }, previewMask)), !groupContext && canPreview && /*#__PURE__*/react.createElement(es_Preview, (0,esm_extends/* default */.Z)({
    "aria-hidden": !isShowPreview,
    visible: isShowPreview,
    prefixCls: previewPrefixCls,
    onClose: onPreviewClose,
    mousePosition: mousePosition,
    src: src,
    alt: alt,
    imageInfo: {
      width: width,
      height: height
    },
    fallback: fallback,
    getContainer: getPreviewContainer,
    icons: icons,
    movable: movable,
    scaleStep: scaleStep,
    minScale: minScale,
    maxScale: maxScale,
    rootClassName: rootClassName,
    imageRender: imageRender,
    imgCommonProps: imgCommonProps,
    toolbarRender: toolbarRender
  }, dialogProps)));
};
ImageInternal.PreviewGroup = PreviewGroup;
if (false) {}
/* harmony default export */ var Image = (ImageInternal);
;// CONCATENATED MODULE: ./node_modules/rc-image/es/index.js


/* harmony default export */ var rc_image_es = (Image);

/***/ }),

/***/ 33984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCount; }
/* harmony export */ });
/* unused harmony export inCountRange */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91032);
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56717);
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45827);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);



var _excluded = ["show"];

/**
 * Cut `value` by the `count.max` prop.
 */
function inCountRange(value, countConfig) {
  if (!countConfig.max) {
    return true;
  }
  var count = countConfig.strategy(value);
  return count <= countConfig.max;
}
function useCount(count, showCount) {
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    var mergedConfig = {};
    if (showCount) {
      mergedConfig.show = (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(showCount) === 'object' && showCount.formatter ? showCount.formatter : !!showCount;
    }
    mergedConfig = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, mergedConfig), count);
    var _ref = mergedConfig,
      show = _ref.show,
      rest = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);
    return (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, rest), {}, {
      show: !!show,
      showFormatter: typeof show === 'function' ? show : undefined,
      strategy: rest.strategy || function (value) {
        return value.length;
      }
    });
  }, [count, showCount]);
}

/***/ }),

/***/ 65802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* reexport */ es_BaseInput; },
  "Z": function() { return /* binding */ es; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/rc-input/es/utils/commonUtils.js
var commonUtils = __webpack_require__(5894);
;// CONCATENATED MODULE: ./node_modules/rc-input/es/BaseInput.js







var BaseInput = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _props, _props2, _props3;
  var inputEl = props.inputElement,
    children = props.children,
    prefixCls = props.prefixCls,
    prefix = props.prefix,
    suffix = props.suffix,
    addonBefore = props.addonBefore,
    addonAfter = props.addonAfter,
    className = props.className,
    style = props.style,
    disabled = props.disabled,
    readOnly = props.readOnly,
    focused = props.focused,
    triggerFocus = props.triggerFocus,
    allowClear = props.allowClear,
    value = props.value,
    handleReset = props.handleReset,
    hidden = props.hidden,
    classes = props.classes,
    classNames = props.classNames,
    dataAttrs = props.dataAttrs,
    styles = props.styles,
    components = props.components,
    onClear = props.onClear;
  var inputElement = children !== null && children !== void 0 ? children : inputEl;
  var AffixWrapperComponent = (components === null || components === void 0 ? void 0 : components.affixWrapper) || 'span';
  var GroupWrapperComponent = (components === null || components === void 0 ? void 0 : components.groupWrapper) || 'span';
  var WrapperComponent = (components === null || components === void 0 ? void 0 : components.wrapper) || 'span';
  var GroupAddonComponent = (components === null || components === void 0 ? void 0 : components.groupAddon) || 'span';
  var containerRef = (0,react.useRef)(null);
  var onInputClick = function onInputClick(e) {
    var _containerRef$current;
    if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(e.target)) {
      triggerFocus === null || triggerFocus === void 0 || triggerFocus();
    }
  };
  var hasAffix = (0,commonUtils/* hasPrefixSuffix */.X3)(props);
  var element = /*#__PURE__*/(0,react.cloneElement)(inputElement, {
    value: value,
    className: classnames_default()((_props = inputElement.props) === null || _props === void 0 ? void 0 : _props.className, !hasAffix && (classNames === null || classNames === void 0 ? void 0 : classNames.variant)) || null
  });

  // ======================== Ref ======================== //
  var groupRef = (0,react.useRef)(null);
  react.useImperativeHandle(ref, function () {
    return {
      nativeElement: groupRef.current || containerRef.current
    };
  });

  // ================== Prefix & Suffix ================== //
  if (hasAffix) {
    // ================== Clear Icon ================== //
    var clearIcon = null;
    if (allowClear) {
      var needClear = !disabled && !readOnly && value;
      var clearIconCls = "".concat(prefixCls, "-clear-icon");
      var iconNode = (0,esm_typeof/* default */.Z)(allowClear) === 'object' && allowClear !== null && allowClear !== void 0 && allowClear.clearIcon ? allowClear.clearIcon : '✖';
      clearIcon = /*#__PURE__*/react.createElement("button", {
        type: "button",
        tabIndex: -1,
        onClick: function onClick(event) {
          handleReset === null || handleReset === void 0 || handleReset(event);
          onClear === null || onClear === void 0 || onClear();
        }
        // Do not trigger onBlur when clear input
        // https://github.com/ant-design/ant-design/issues/31200
        ,

        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        },
        className: classnames_default()(clearIconCls, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(clearIconCls, "-hidden"), !needClear), "".concat(clearIconCls, "-has-suffix"), !!suffix))
      }, iconNode);
    }
    var affixWrapperPrefixCls = "".concat(prefixCls, "-affix-wrapper");
    var affixWrapperCls = classnames_default()(affixWrapperPrefixCls, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-disabled"), disabled), "".concat(affixWrapperPrefixCls, "-disabled"), disabled), "".concat(affixWrapperPrefixCls, "-focused"), focused), "".concat(affixWrapperPrefixCls, "-readonly"), readOnly), "".concat(affixWrapperPrefixCls, "-input-with-clear-btn"), suffix && allowClear && value), classes === null || classes === void 0 ? void 0 : classes.affixWrapper, classNames === null || classNames === void 0 ? void 0 : classNames.affixWrapper, classNames === null || classNames === void 0 ? void 0 : classNames.variant);
    var suffixNode = (suffix || allowClear) && /*#__PURE__*/react.createElement("span", {
      className: classnames_default()("".concat(prefixCls, "-suffix"), classNames === null || classNames === void 0 ? void 0 : classNames.suffix),
      style: styles === null || styles === void 0 ? void 0 : styles.suffix
    }, clearIcon, suffix);
    element = /*#__PURE__*/react.createElement(AffixWrapperComponent, (0,esm_extends/* default */.Z)({
      className: affixWrapperCls,
      style: styles === null || styles === void 0 ? void 0 : styles.affixWrapper,
      onClick: onInputClick
    }, dataAttrs === null || dataAttrs === void 0 ? void 0 : dataAttrs.affixWrapper, {
      ref: containerRef
    }), prefix && /*#__PURE__*/react.createElement("span", {
      className: classnames_default()("".concat(prefixCls, "-prefix"), classNames === null || classNames === void 0 ? void 0 : classNames.prefix),
      style: styles === null || styles === void 0 ? void 0 : styles.prefix
    }, prefix), element, suffixNode);
  }

  // ================== Addon ================== //
  if ((0,commonUtils/* hasAddon */.He)(props)) {
    var wrapperCls = "".concat(prefixCls, "-group");
    var addonCls = "".concat(wrapperCls, "-addon");
    var groupWrapperCls = "".concat(wrapperCls, "-wrapper");
    var mergedWrapperClassName = classnames_default()("".concat(prefixCls, "-wrapper"), wrapperCls, classes === null || classes === void 0 ? void 0 : classes.wrapper, classNames === null || classNames === void 0 ? void 0 : classNames.wrapper);
    var mergedGroupClassName = classnames_default()(groupWrapperCls, (0,defineProperty/* default */.Z)({}, "".concat(groupWrapperCls, "-disabled"), disabled), classes === null || classes === void 0 ? void 0 : classes.group, classNames === null || classNames === void 0 ? void 0 : classNames.groupWrapper);

    // Need another wrapper for changing display:table to display:inline-block
    // and put style prop in wrapper
    element = /*#__PURE__*/react.createElement(GroupWrapperComponent, {
      className: mergedGroupClassName,
      ref: groupRef
    }, /*#__PURE__*/react.createElement(WrapperComponent, {
      className: mergedWrapperClassName
    }, addonBefore && /*#__PURE__*/react.createElement(GroupAddonComponent, {
      className: addonCls
    }, addonBefore), element, addonAfter && /*#__PURE__*/react.createElement(GroupAddonComponent, {
      className: addonCls
    }, addonAfter)));
  }

  // `className` and `style` are always on the root element
  return /*#__PURE__*/react.cloneElement(element, {
    className: classnames_default()((_props2 = element.props) === null || _props2 === void 0 ? void 0 : _props2.className, className) || null,
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, (_props3 = element.props) === null || _props3 === void 0 ? void 0 : _props3.style), style),
    hidden: hidden
  });
});
/* harmony default export */ var es_BaseInput = (BaseInput);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMergedState.js
var useMergedState = __webpack_require__(78877);
// EXTERNAL MODULE: ./node_modules/rc-util/es/omit.js
var omit = __webpack_require__(85401);
// EXTERNAL MODULE: ./node_modules/rc-input/es/hooks/useCount.js
var useCount = __webpack_require__(33984);
;// CONCATENATED MODULE: ./node_modules/rc-input/es/Input.js






var _excluded = ["autoComplete", "onChange", "onFocus", "onBlur", "onPressEnter", "onKeyDown", "onKeyUp", "prefixCls", "disabled", "htmlSize", "className", "maxLength", "suffix", "showCount", "count", "type", "classes", "classNames", "styles", "onCompositionStart", "onCompositionEnd"];







var Input = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var autoComplete = props.autoComplete,
    onChange = props.onChange,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onPressEnter = props.onPressEnter,
    onKeyDown = props.onKeyDown,
    onKeyUp = props.onKeyUp,
    _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-input' : _props$prefixCls,
    disabled = props.disabled,
    htmlSize = props.htmlSize,
    className = props.className,
    maxLength = props.maxLength,
    suffix = props.suffix,
    showCount = props.showCount,
    count = props.count,
    _props$type = props.type,
    type = _props$type === void 0 ? 'text' : _props$type,
    classes = props.classes,
    classNames = props.classNames,
    styles = props.styles,
    _onCompositionStart = props.onCompositionStart,
    onCompositionEnd = props.onCompositionEnd,
    rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    focused = _useState2[0],
    setFocused = _useState2[1];
  var compositionRef = (0,react.useRef)(false);
  var keyLockRef = (0,react.useRef)(false);
  var inputRef = (0,react.useRef)(null);
  var holderRef = (0,react.useRef)(null);
  var focus = function focus(option) {
    if (inputRef.current) {
      (0,commonUtils/* triggerFocus */.nH)(inputRef.current, option);
    }
  };

  // ====================== Value =======================
  var _useMergedState = (0,useMergedState/* default */.Z)(props.defaultValue, {
      value: props.value
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    value = _useMergedState2[0],
    setValue = _useMergedState2[1];
  var formatValue = value === undefined || value === null ? '' : String(value);

  // =================== Select Range ===================
  var _useState3 = (0,react.useState)(null),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    selection = _useState4[0],
    setSelection = _useState4[1];

  // ====================== Count =======================
  var countConfig = (0,useCount/* default */.Z)(count, showCount);
  var mergedMax = countConfig.max || maxLength;
  var valueLength = countConfig.strategy(formatValue);
  var isOutOfRange = !!mergedMax && valueLength > mergedMax;

  // ======================= Ref ========================
  (0,react.useImperativeHandle)(ref, function () {
    var _holderRef$current;
    return {
      focus: focus,
      blur: function blur() {
        var _inputRef$current;
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
      },
      setSelectionRange: function setSelectionRange(start, end, direction) {
        var _inputRef$current2;
        (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.setSelectionRange(start, end, direction);
      },
      select: function select() {
        var _inputRef$current3;
        (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 || _inputRef$current3.select();
      },
      input: inputRef.current,
      nativeElement: ((_holderRef$current = holderRef.current) === null || _holderRef$current === void 0 ? void 0 : _holderRef$current.nativeElement) || inputRef.current
    };
  });
  (0,react.useEffect)(function () {
    if (keyLockRef.current) {
      keyLockRef.current = false;
    }
    setFocused(function (prev) {
      return prev && disabled ? false : prev;
    });
  }, [disabled]);
  var triggerChange = function triggerChange(e, currentValue, info) {
    var cutValue = currentValue;
    if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
      cutValue = countConfig.exceedFormatter(currentValue, {
        max: countConfig.max
      });
      if (currentValue !== cutValue) {
        var _inputRef$current4, _inputRef$current5;
        setSelection([((_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 ? void 0 : _inputRef$current4.selectionStart) || 0, ((_inputRef$current5 = inputRef.current) === null || _inputRef$current5 === void 0 ? void 0 : _inputRef$current5.selectionEnd) || 0]);
      }
    } else if (info.source === 'compositionEnd') {
      // Avoid triggering twice
      // https://github.com/ant-design/ant-design/issues/46587
      return;
    }
    setValue(cutValue);
    if (inputRef.current) {
      (0,commonUtils/* resolveOnChange */.rJ)(inputRef.current, e, onChange, cutValue);
    }
  };
  (0,react.useEffect)(function () {
    if (selection) {
      var _inputRef$current6;
      (_inputRef$current6 = inputRef.current) === null || _inputRef$current6 === void 0 || _inputRef$current6.setSelectionRange.apply(_inputRef$current6, (0,toConsumableArray/* default */.Z)(selection));
    }
  }, [selection]);
  var onInternalChange = function onInternalChange(e) {
    triggerChange(e, e.target.value, {
      source: 'change'
    });
  };
  var onInternalCompositionEnd = function onInternalCompositionEnd(e) {
    compositionRef.current = false;
    triggerChange(e, e.currentTarget.value, {
      source: 'compositionEnd'
    });
    onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (onPressEnter && e.key === 'Enter' && !keyLockRef.current) {
      keyLockRef.current = true;
      onPressEnter(e);
    }
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
  };
  var handleKeyUp = function handleKeyUp(e) {
    if (e.key === 'Enter') {
      keyLockRef.current = false;
    }
    onKeyUp === null || onKeyUp === void 0 || onKeyUp(e);
  };
  var handleFocus = function handleFocus(e) {
    setFocused(true);
    onFocus === null || onFocus === void 0 || onFocus(e);
  };
  var handleBlur = function handleBlur(e) {
    if (keyLockRef.current) {
      keyLockRef.current = false;
    }
    setFocused(false);
    onBlur === null || onBlur === void 0 || onBlur(e);
  };
  var handleReset = function handleReset(e) {
    setValue('');
    focus();
    if (inputRef.current) {
      (0,commonUtils/* resolveOnChange */.rJ)(inputRef.current, e, onChange);
    }
  };

  // ====================== Input =======================
  var outOfRangeCls = isOutOfRange && "".concat(prefixCls, "-out-of-range");
  var getInputElement = function getInputElement() {
    // Fix https://fb.me/react-unknown-prop
    var otherProps = (0,omit/* default */.Z)(props, ['prefixCls', 'onPressEnter', 'addonBefore', 'addonAfter', 'prefix', 'suffix', 'allowClear',
    // Input elements must be either controlled or uncontrolled,
    // specify either the value prop, or the defaultValue prop, but not both.
    'defaultValue', 'showCount', 'count', 'classes', 'htmlSize', 'styles', 'classNames', 'onClear']);
    return /*#__PURE__*/react.createElement("input", (0,esm_extends/* default */.Z)({
      autoComplete: autoComplete
    }, otherProps, {
      onChange: onInternalChange,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      onKeyUp: handleKeyUp,
      className: classnames_default()(prefixCls, (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-disabled"), disabled), classNames === null || classNames === void 0 ? void 0 : classNames.input),
      style: styles === null || styles === void 0 ? void 0 : styles.input,
      ref: inputRef,
      size: htmlSize,
      type: type,
      onCompositionStart: function onCompositionStart(e) {
        compositionRef.current = true;
        _onCompositionStart === null || _onCompositionStart === void 0 || _onCompositionStart(e);
      },
      onCompositionEnd: onInternalCompositionEnd
    }));
  };
  var getSuffix = function getSuffix() {
    // Max length value
    var hasMaxLength = Number(mergedMax) > 0;
    if (suffix || countConfig.show) {
      var dataCount = countConfig.showFormatter ? countConfig.showFormatter({
        value: formatValue,
        count: valueLength,
        maxLength: mergedMax
      }) : "".concat(valueLength).concat(hasMaxLength ? " / ".concat(mergedMax) : '');
      return /*#__PURE__*/react.createElement(react.Fragment, null, countConfig.show && /*#__PURE__*/react.createElement("span", {
        className: classnames_default()("".concat(prefixCls, "-show-count-suffix"), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-show-count-has-suffix"), !!suffix), classNames === null || classNames === void 0 ? void 0 : classNames.count),
        style: (0,objectSpread2/* default */.Z)({}, styles === null || styles === void 0 ? void 0 : styles.count)
      }, dataCount), suffix);
    }
    return null;
  };

  // ====================== Render ======================
  return /*#__PURE__*/react.createElement(es_BaseInput, (0,esm_extends/* default */.Z)({}, rest, {
    prefixCls: prefixCls,
    className: classnames_default()(className, outOfRangeCls),
    handleReset: handleReset,
    value: formatValue,
    focused: focused,
    triggerFocus: focus,
    suffix: getSuffix(),
    disabled: disabled,
    classes: classes,
    classNames: classNames,
    styles: styles,
    ref: holderRef
  }), getInputElement());
});
/* harmony default export */ var es_Input = (Input);
;// CONCATENATED MODULE: ./node_modules/rc-input/es/index.js



/* harmony default export */ var es = (es_Input);

/***/ }),

/***/ 5894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "He": function() { return /* binding */ hasAddon; },
/* harmony export */   "X3": function() { return /* binding */ hasPrefixSuffix; },
/* harmony export */   "nH": function() { return /* binding */ triggerFocus; },
/* harmony export */   "rJ": function() { return /* binding */ resolveOnChange; }
/* harmony export */ });
function hasAddon(props) {
  return !!(props.addonBefore || props.addonAfter);
}
function hasPrefixSuffix(props) {
  return !!(props.prefix || props.suffix || props.allowClear);
}

// TODO: It's better to use `Proxy` replace the `element.value`. But we still need support IE11.
function cloneEvent(event, target, value) {
  // A bug report filed on WebKit's Bugzilla tracker, dating back to 2009, specifically addresses the issue of cloneNode() not copying files of <input type="file"> elements.
  // As of the last update, this bug was still marked as "NEW," indicating that it might not have been resolved yet​​.
  // https://bugs.webkit.org/show_bug.cgi?id=28123
  var currentTarget = target.cloneNode(true);

  // click clear icon
  var newEvent = Object.create(event, {
    target: {
      value: currentTarget
    },
    currentTarget: {
      value: currentTarget
    }
  });

  // Fill data
  currentTarget.value = value;

  // Fill selection. Some type like `email` not support selection
  // https://github.com/ant-design/ant-design/issues/47833
  if (typeof target.selectionStart === 'number' && typeof target.selectionEnd === 'number') {
    currentTarget.selectionStart = target.selectionStart;
    currentTarget.selectionEnd = target.selectionEnd;
  }
  currentTarget.setSelectionRange = function () {
    target.setSelectionRange.apply(target, arguments);
  };
  return newEvent;
}
function resolveOnChange(target, e, onChange, targetValue) {
  if (!onChange) {
    return;
  }
  var event = e;
  if (e.type === 'click') {
    // Clone a new target for event.
    // Avoid the following usage, the setQuery method gets the original value.
    //
    // const [query, setQuery] = React.useState('');
    // <Input
    //   allowClear
    //   value={query}
    //   onChange={(e)=> {
    //     setQuery((prevStatus) => e.target.value);
    //   }}
    // />

    event = cloneEvent(e, target, '');
    onChange(event);
    return;
  }

  // Trigger by composition event, this means we need force change the input value
  // https://github.com/ant-design/ant-design/issues/45737
  // https://github.com/ant-design/ant-design/issues/46598
  if (target.type !== 'file' && targetValue !== undefined) {
    event = cloneEvent(e, target, targetValue);
    onChange(event);
    return;
  }
  onChange(event);
}
function triggerFocus(element, option) {
  if (!element) return;
  element.focus(option);

  // Selection content
  var _ref = option || {},
    cursor = _ref.cursor;
  if (cursor) {
    var len = element.value.length;
    switch (cursor) {
      case 'start':
        element.setSelectionRange(0, 0);
        break;
      case 'end':
        element.setSelectionRange(len, len);
        break;
      default:
        element.setSelectionRange(0, len);
    }
  }
}

/***/ }),

/***/ 2369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iz": function() { return /* reexport */ Divider; },
  "ck": function() { return /* reexport */ es_MenuItem; },
  "BW": function() { return /* reexport */ es_MenuItemGroup; },
  "sN": function() { return /* reexport */ es_MenuItem; },
  "Wd": function() { return /* reexport */ es_SubMenu; },
  "ZP": function() { return /* binding */ rc_menu_es; },
  "Xl": function() { return /* reexport */ useFullPath; }
});

// UNUSED EXPORTS: MenuItemGroup

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-overflow/es/index.js + 6 modules
var es = __webpack_require__(16344);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMergedState.js
var useMergedState = __webpack_require__(78877);
// EXTERNAL MODULE: ./node_modules/rc-util/es/isEqual.js
var isEqual = __webpack_require__(55159);
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(13764);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(85202);
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/context/IdContext.js

var IdContext = /*#__PURE__*/react.createContext(null);
function getMenuId(uuid, eventKey) {
  if (uuid === undefined) {
    return null;
  }
  return "".concat(uuid, "-").concat(eventKey);
}

/**
 * Get `data-menu-id`
 */
function useMenuId(eventKey) {
  var id = react.useContext(IdContext);
  return getMenuId(id, eventKey);
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMemo.js
var useMemo = __webpack_require__(99834);
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/context/MenuContext.js


var _excluded = ["children", "locked"];



var MenuContext = /*#__PURE__*/react.createContext(null);
function mergeProps(origin, target) {
  var clone = (0,objectSpread2/* default */.Z)({}, origin);
  Object.keys(target).forEach(function (key) {
    var value = target[key];
    if (value !== undefined) {
      clone[key] = value;
    }
  });
  return clone;
}
function InheritableContextProvider(_ref) {
  var children = _ref.children,
    locked = _ref.locked,
    restProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  var context = react.useContext(MenuContext);
  var inheritableContext = (0,useMemo/* default */.Z)(function () {
    return mergeProps(context, restProps);
  }, [context, restProps], function (prev, next) {
    return !locked && (prev[0] !== next[0] || !(0,isEqual/* default */.Z)(prev[1], next[1], true));
  });
  return /*#__PURE__*/react.createElement(MenuContext.Provider, {
    value: inheritableContext
  }, children);
}
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/context/PathContext.js


var EmptyList = [];

// ========================= Path Register =========================

var PathRegisterContext = /*#__PURE__*/react.createContext(null);
function useMeasure() {
  return react.useContext(PathRegisterContext);
}

// ========================= Path Tracker ==========================
var PathTrackerContext = /*#__PURE__*/react.createContext(EmptyList);
function useFullPath(eventKey) {
  var parentKeyPath = react.useContext(PathTrackerContext);
  return react.useMemo(function () {
    return eventKey !== undefined ? [].concat((0,toConsumableArray/* default */.Z)(parentKeyPath), [eventKey]) : parentKeyPath;
  }, [parentKeyPath, eventKey]);
}

// =========================== Path User ===========================

var PathUserContext = /*#__PURE__*/react.createContext(null);
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/context/PrivateContext.js

var PrivateContext = /*#__PURE__*/react.createContext({});
/* harmony default export */ var context_PrivateContext = (PrivateContext);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/isVisible.js
var isVisible = __webpack_require__(29504);
;// CONCATENATED MODULE: ./node_modules/rc-util/es/Dom/focus.js


function focusable(node) {
  var includePositive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if ((0,isVisible/* default */.Z)(node)) {
    var nodeName = node.nodeName.toLowerCase();
    var isFocusableElement =
    // Focusable element
    ['input', 'select', 'textarea', 'button'].includes(nodeName) ||
    // Editable element
    node.isContentEditable ||
    // Anchor with href element
    nodeName === 'a' && !!node.getAttribute('href');

    // Get tabIndex
    var tabIndexAttr = node.getAttribute('tabindex');
    var tabIndexNum = Number(tabIndexAttr);

    // Parse as number if validate
    var tabIndex = null;
    if (tabIndexAttr && !Number.isNaN(tabIndexNum)) {
      tabIndex = tabIndexNum;
    } else if (isFocusableElement && tabIndex === null) {
      tabIndex = 0;
    }

    // Block focusable if disabled
    if (isFocusableElement && node.disabled) {
      tabIndex = null;
    }
    return tabIndex !== null && (tabIndex >= 0 || includePositive && tabIndex < 0);
  }
  return false;
}
function getFocusNodeList(node) {
  var includePositive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var res = (0,toConsumableArray/* default */.Z)(node.querySelectorAll('*')).filter(function (child) {
    return focusable(child, includePositive);
  });
  if (focusable(node, includePositive)) {
    res.unshift(node);
  }
  return res;
}
var lastFocusElement = null;

/** @deprecated Do not use since this may failed when used in async */
function saveLastFocusNode() {
  lastFocusElement = document.activeElement;
}

/** @deprecated Do not use since this may failed when used in async */
function clearLastFocusNode() {
  lastFocusElement = null;
}

/** @deprecated Do not use since this may failed when used in async */
function backLastFocusNode() {
  if (lastFocusElement) {
    try {
      // 元素可能已经被移动了
      lastFocusElement.focus();

      /* eslint-disable no-empty */
    } catch (e) {
      // empty
    }
    /* eslint-enable no-empty */
  }
}
function limitTabRange(node, e) {
  if (e.keyCode === 9) {
    var tabNodeList = getFocusNodeList(node);
    var lastTabNode = tabNodeList[e.shiftKey ? 0 : tabNodeList.length - 1];
    var leavingTab = lastTabNode === document.activeElement || node === document.activeElement;
    if (leavingTab) {
      var target = tabNodeList[e.shiftKey ? tabNodeList.length - 1 : 0];
      target.focus();
      e.preventDefault();
    }
  }
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js
var KeyCode = __webpack_require__(88035);
// EXTERNAL MODULE: ./node_modules/rc-util/es/raf.js
var raf = __webpack_require__(13157);
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/hooks/useAccessibility.js






// destruct to reduce minify size
var LEFT = KeyCode/* default.LEFT */.Z.LEFT,
  RIGHT = KeyCode/* default.RIGHT */.Z.RIGHT,
  UP = KeyCode/* default.UP */.Z.UP,
  DOWN = KeyCode/* default.DOWN */.Z.DOWN,
  ENTER = KeyCode/* default.ENTER */.Z.ENTER,
  ESC = KeyCode/* default.ESC */.Z.ESC,
  HOME = KeyCode/* default.HOME */.Z.HOME,
  END = KeyCode/* default.END */.Z.END;
var ArrowKeys = [UP, DOWN, LEFT, RIGHT];
function getOffset(mode, isRootLevel, isRtl, which) {
  var _offsets;
  var prev = 'prev';
  var next = 'next';
  var children = 'children';
  var parent = 'parent';

  // Inline enter is special that we use unique operation
  if (mode === 'inline' && which === ENTER) {
    return {
      inlineTrigger: true
    };
  }
  var inline = (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, UP, prev), DOWN, next);
  var horizontal = (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, LEFT, isRtl ? next : prev), RIGHT, isRtl ? prev : next), DOWN, children), ENTER, children);
  var vertical = (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, UP, prev), DOWN, next), ENTER, children), ESC, parent), LEFT, isRtl ? children : parent), RIGHT, isRtl ? parent : children);
  var offsets = {
    inline: inline,
    horizontal: horizontal,
    vertical: vertical,
    inlineSub: inline,
    horizontalSub: vertical,
    verticalSub: vertical
  };
  var type = (_offsets = offsets["".concat(mode).concat(isRootLevel ? '' : 'Sub')]) === null || _offsets === void 0 ? void 0 : _offsets[which];
  switch (type) {
    case prev:
      return {
        offset: -1,
        sibling: true
      };
    case next:
      return {
        offset: 1,
        sibling: true
      };
    case parent:
      return {
        offset: -1,
        sibling: false
      };
    case children:
      return {
        offset: 1,
        sibling: false
      };
    default:
      return null;
  }
}
function findContainerUL(element) {
  var current = element;
  while (current) {
    if (current.getAttribute('data-menu-list')) {
      return current;
    }
    current = current.parentElement;
  }

  // Normally should not reach this line
  /* istanbul ignore next */
  return null;
}

/**
 * Find focused element within element set provided
 */
function getFocusElement(activeElement, elements) {
  var current = activeElement || document.activeElement;
  while (current) {
    if (elements.has(current)) {
      return current;
    }
    current = current.parentElement;
  }
  return null;
}

/**
 * Get focusable elements from the element set under provided container
 */
function getFocusableElements(container, elements) {
  var list = getFocusNodeList(container, true);
  return list.filter(function (ele) {
    return elements.has(ele);
  });
}
function getNextFocusElement(parentQueryContainer, elements, focusMenuElement) {
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  // Key on the menu item will not get validate parent container
  if (!parentQueryContainer) {
    return null;
  }

  // List current level menu item elements
  var sameLevelFocusableMenuElementList = getFocusableElements(parentQueryContainer, elements);

  // Find next focus index
  var count = sameLevelFocusableMenuElementList.length;
  var focusIndex = sameLevelFocusableMenuElementList.findIndex(function (ele) {
    return focusMenuElement === ele;
  });
  if (offset < 0) {
    if (focusIndex === -1) {
      focusIndex = count - 1;
    } else {
      focusIndex -= 1;
    }
  } else if (offset > 0) {
    focusIndex += 1;
  }
  focusIndex = (focusIndex + count) % count;

  // Focus menu item
  return sameLevelFocusableMenuElementList[focusIndex];
}
var refreshElements = function refreshElements(keys, id) {
  var elements = new Set();
  var key2element = new Map();
  var element2key = new Map();
  keys.forEach(function (key) {
    var element = document.querySelector("[data-menu-id='".concat(getMenuId(id, key), "']"));
    if (element) {
      elements.add(element);
      element2key.set(element, key);
      key2element.set(key, element);
    }
  });
  return {
    elements: elements,
    key2element: key2element,
    element2key: element2key
  };
};
function useAccessibility(mode, activeKey, isRtl, id, containerRef, getKeys, getKeyPath, triggerActiveKey, triggerAccessibilityOpen, originOnKeyDown) {
  var rafRef = react.useRef();
  var activeRef = react.useRef();
  activeRef.current = activeKey;
  var cleanRaf = function cleanRaf() {
    raf/* default.cancel */.Z.cancel(rafRef.current);
  };
  react.useEffect(function () {
    return function () {
      cleanRaf();
    };
  }, []);
  return function (e) {
    var which = e.which;
    if ([].concat(ArrowKeys, [ENTER, ESC, HOME, END]).includes(which)) {
      var keys = getKeys();
      var refreshedElements = refreshElements(keys, id);
      var _refreshedElements = refreshedElements,
        elements = _refreshedElements.elements,
        key2element = _refreshedElements.key2element,
        element2key = _refreshedElements.element2key;

      // First we should find current focused MenuItem/SubMenu element
      var activeElement = key2element.get(activeKey);
      var focusMenuElement = getFocusElement(activeElement, elements);
      var focusMenuKey = element2key.get(focusMenuElement);
      var offsetObj = getOffset(mode, getKeyPath(focusMenuKey, true).length === 1, isRtl, which);

      // Some mode do not have fully arrow operation like inline
      if (!offsetObj && which !== HOME && which !== END) {
        return;
      }

      // Arrow prevent default to avoid page scroll
      if (ArrowKeys.includes(which) || [HOME, END].includes(which)) {
        e.preventDefault();
      }
      var tryFocus = function tryFocus(menuElement) {
        if (menuElement) {
          var focusTargetElement = menuElement;

          // Focus to link instead of menu item if possible
          var link = menuElement.querySelector('a');
          if (link !== null && link !== void 0 && link.getAttribute('href')) {
            focusTargetElement = link;
          }
          var targetKey = element2key.get(menuElement);
          triggerActiveKey(targetKey);

          /**
           * Do not `useEffect` here since `tryFocus` may trigger async
           * which makes React sync update the `activeKey`
           * that force render before `useRef` set the next activeKey
           */
          cleanRaf();
          rafRef.current = (0,raf/* default */.Z)(function () {
            if (activeRef.current === targetKey) {
              focusTargetElement.focus();
            }
          });
        }
      };
      if ([HOME, END].includes(which) || offsetObj.sibling || !focusMenuElement) {
        // ========================== Sibling ==========================
        // Find walkable focus menu element container
        var parentQueryContainer;
        if (!focusMenuElement || mode === 'inline') {
          parentQueryContainer = containerRef.current;
        } else {
          parentQueryContainer = findContainerUL(focusMenuElement);
        }

        // Get next focus element
        var targetElement;
        var focusableElements = getFocusableElements(parentQueryContainer, elements);
        if (which === HOME) {
          targetElement = focusableElements[0];
        } else if (which === END) {
          targetElement = focusableElements[focusableElements.length - 1];
        } else {
          targetElement = getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offsetObj.offset);
        }
        // Focus menu item
        tryFocus(targetElement);

        // ======================= InlineTrigger =======================
      } else if (offsetObj.inlineTrigger) {
        // Inline trigger no need switch to sub menu item
        triggerAccessibilityOpen(focusMenuKey);
        // =========================== Level ===========================
      } else if (offsetObj.offset > 0) {
        triggerAccessibilityOpen(focusMenuKey, true);
        cleanRaf();
        rafRef.current = (0,raf/* default */.Z)(function () {
          // Async should resync elements
          refreshedElements = refreshElements(keys, id);
          var controlId = focusMenuElement.getAttribute('aria-controls');
          var subQueryContainer = document.getElementById(controlId);

          // Get sub focusable menu item
          var targetElement = getNextFocusElement(subQueryContainer, refreshedElements.elements);

          // Focus menu item
          tryFocus(targetElement);
        }, 5);
      } else if (offsetObj.offset < 0) {
        var keyPath = getKeyPath(focusMenuKey, true);
        var parentKey = keyPath[keyPath.length - 2];
        var parentMenuElement = key2element.get(parentKey);

        // Focus menu item
        triggerAccessibilityOpen(parentKey, false);
        tryFocus(parentMenuElement);
      }
    }

    // Pass origin key down event
    originOnKeyDown === null || originOnKeyDown === void 0 || originOnKeyDown(e);
  };
}
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/utils/timeUtil.js
function nextSlice(callback) {
  /* istanbul ignore next */
  Promise.resolve().then(callback);
}
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/hooks/useKeyRecords.js






var PATH_SPLIT = '__RC_UTIL_PATH_SPLIT__';
var getPathStr = function getPathStr(keyPath) {
  return keyPath.join(PATH_SPLIT);
};
var getPathKeys = function getPathKeys(keyPathStr) {
  return keyPathStr.split(PATH_SPLIT);
};
var OVERFLOW_KEY = 'rc-menu-more';
function useKeyRecords() {
  var _React$useState = react.useState({}),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    internalForceUpdate = _React$useState2[1];
  var key2pathRef = (0,react.useRef)(new Map());
  var path2keyRef = (0,react.useRef)(new Map());
  var _React$useState3 = react.useState([]),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    overflowKeys = _React$useState4[0],
    setOverflowKeys = _React$useState4[1];
  var updateRef = (0,react.useRef)(0);
  var destroyRef = (0,react.useRef)(false);
  var forceUpdate = function forceUpdate() {
    if (!destroyRef.current) {
      internalForceUpdate({});
    }
  };
  var registerPath = (0,react.useCallback)(function (key, keyPath) {
    // Warning for invalidate or duplicated `key`
    if (false) {}

    // Fill map
    var connectedPath = getPathStr(keyPath);
    path2keyRef.current.set(connectedPath, key);
    key2pathRef.current.set(key, connectedPath);
    updateRef.current += 1;
    var id = updateRef.current;
    nextSlice(function () {
      if (id === updateRef.current) {
        forceUpdate();
      }
    });
  }, []);
  var unregisterPath = (0,react.useCallback)(function (key, keyPath) {
    var connectedPath = getPathStr(keyPath);
    path2keyRef.current.delete(connectedPath);
    key2pathRef.current.delete(key);
  }, []);
  var refreshOverflowKeys = (0,react.useCallback)(function (keys) {
    setOverflowKeys(keys);
  }, []);
  var getKeyPath = (0,react.useCallback)(function (eventKey, includeOverflow) {
    var fullPath = key2pathRef.current.get(eventKey) || '';
    var keys = getPathKeys(fullPath);
    if (includeOverflow && overflowKeys.includes(keys[0])) {
      keys.unshift(OVERFLOW_KEY);
    }
    return keys;
  }, [overflowKeys]);
  var isSubPathKey = (0,react.useCallback)(function (pathKeys, eventKey) {
    return pathKeys.filter(function (item) {
      return item !== undefined;
    }).some(function (pathKey) {
      var pathKeyList = getKeyPath(pathKey, true);
      return pathKeyList.includes(eventKey);
    });
  }, [getKeyPath]);
  var getKeys = function getKeys() {
    var keys = (0,toConsumableArray/* default */.Z)(key2pathRef.current.keys());
    if (overflowKeys.length) {
      keys.push(OVERFLOW_KEY);
    }
    return keys;
  };

  /**
   * Find current key related child path keys
   */
  var getSubPathKeys = (0,react.useCallback)(function (key) {
    var connectedPath = "".concat(key2pathRef.current.get(key)).concat(PATH_SPLIT);
    var pathKeys = new Set();
    (0,toConsumableArray/* default */.Z)(path2keyRef.current.keys()).forEach(function (pathKey) {
      if (pathKey.startsWith(connectedPath)) {
        pathKeys.add(path2keyRef.current.get(pathKey));
      }
    });
    return pathKeys;
  }, []);
  react.useEffect(function () {
    return function () {
      destroyRef.current = true;
    };
  }, []);
  return {
    // Register
    registerPath: registerPath,
    unregisterPath: unregisterPath,
    refreshOverflowKeys: refreshOverflowKeys,
    // Util
    isSubPathKey: isSubPathKey,
    getKeyPath: getKeyPath,
    getKeys: getKeys,
    getSubPathKeys: getSubPathKeys
  };
}
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/hooks/useMemoCallback.js


/**
 * Cache callback function that always return same ref instead.
 * This is used for context optimization.
 */
function useMemoCallback(func) {
  var funRef = react.useRef(func);
  funRef.current = func;
  var callback = react.useCallback(function () {
    var _funRef$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_funRef$current = funRef.current) === null || _funRef$current === void 0 ? void 0 : _funRef$current.call.apply(_funRef$current, [funRef].concat(args));
  }, []);
  return func ? callback : undefined;
}
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/hooks/useUUID.js



var uniquePrefix = Math.random().toFixed(5).toString().slice(2);
var internalId = 0;
function useUUID(id) {
  var _useMergedState = (0,useMergedState/* default */.Z)(id, {
      value: id
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    uuid = _useMergedState2[0],
    setUUID = _useMergedState2[1];
  react.useEffect(function () {
    internalId += 1;
    var newId =  false ? 0 : "".concat(uniquePrefix, "-").concat(internalId);
    setUUID("rc-menu-uuid-".concat(newId));
  }, []);
  return uuid;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6223);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(79427);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(34766);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js
var createSuper = __webpack_require__(56302);
// EXTERNAL MODULE: ./node_modules/rc-util/es/omit.js
var omit = __webpack_require__(85401);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(99195);
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/hooks/useActive.js


function useActive(eventKey, disabled, onMouseEnter, onMouseLeave) {
  var _React$useContext = react.useContext(MenuContext),
    activeKey = _React$useContext.activeKey,
    onActive = _React$useContext.onActive,
    onInactive = _React$useContext.onInactive;
  var ret = {
    active: activeKey === eventKey
  };

  // Skip when disabled
  if (!disabled) {
    ret.onMouseEnter = function (domEvent) {
      onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
        key: eventKey,
        domEvent: domEvent
      });
      onActive(eventKey);
    };
    ret.onMouseLeave = function (domEvent) {
      onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
        key: eventKey,
        domEvent: domEvent
      });
      onInactive(eventKey);
    };
  }
  return ret;
}
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/hooks/useDirectionStyle.js


function useDirectionStyle(level) {
  var _React$useContext = react.useContext(MenuContext),
    mode = _React$useContext.mode,
    rtl = _React$useContext.rtl,
    inlineIndent = _React$useContext.inlineIndent;
  if (mode !== 'inline') {
    return null;
  }
  var len = level;
  return rtl ? {
    paddingRight: len * inlineIndent
  } : {
    paddingLeft: len * inlineIndent
  };
}
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/Icon.js


function Icon(_ref) {
  var icon = _ref.icon,
    props = _ref.props,
    children = _ref.children;
  var iconNode;
  if (icon === null || icon === false) {
    return null;
  }
  if (typeof icon === 'function') {
    iconNode = /*#__PURE__*/react.createElement(icon, (0,objectSpread2/* default */.Z)({}, props));
  } else if (typeof icon !== "boolean") {
    // Compatible for origin definition
    iconNode = icon;
  }
  return iconNode || children || null;
}
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/utils/warnUtil.js

var warnUtil_excluded = ["item"];


/**
 * `onClick` event return `info.item` which point to react node directly.
 * We should warning this since it will not work on FC.
 */
function warnItemProp(_ref) {
  var item = _ref.item,
    restInfo = (0,objectWithoutProperties/* default */.Z)(_ref, warnUtil_excluded);
  Object.defineProperty(restInfo, 'item', {
    get: function get() {
      (0,warning/* default */.ZP)(false, '`info.item` is deprecated since we will move to function component that not provides React Node instance in future.');
      return item;
    }
  });
  return restInfo;
}
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/MenuItem.js









var MenuItem_excluded = ["title", "attribute", "elementRef"],
  _excluded2 = ["style", "className", "eventKey", "warnKey", "disabled", "itemIcon", "children", "role", "onMouseEnter", "onMouseLeave", "onClick", "onKeyDown", "onFocus"],
  _excluded3 = ["active"];















// Since Menu event provide the `info.item` which point to the MenuItem node instance.
// We have to use class component here.
// This should be removed from doc & api in future.
var LegacyMenuItem = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(LegacyMenuItem, _React$Component);
  var _super = (0,createSuper/* default */.Z)(LegacyMenuItem);
  function LegacyMenuItem() {
    (0,classCallCheck/* default */.Z)(this, LegacyMenuItem);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(LegacyMenuItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        title = _this$props.title,
        attribute = _this$props.attribute,
        elementRef = _this$props.elementRef,
        restProps = (0,objectWithoutProperties/* default */.Z)(_this$props, MenuItem_excluded);

      // Here the props are eventually passed to the DOM element.
      // React does not recognize non-standard attributes.
      // Therefore, remove the props that is not used here.
      // ref: https://github.com/ant-design/ant-design/issues/41395
      var passedProps = (0,omit/* default */.Z)(restProps, ['eventKey', 'popupClassName', 'popupOffset', 'onTitleClick']);
      (0,warning/* default */.ZP)(!attribute, '`attribute` of Menu.Item is deprecated. Please pass attribute directly.');
      return /*#__PURE__*/react.createElement(es/* default.Item */.Z.Item, (0,esm_extends/* default */.Z)({}, attribute, {
        title: typeof title === 'string' ? title : undefined
      }, passedProps, {
        ref: elementRef
      }));
    }
  }]);
  return LegacyMenuItem;
}(react.Component);
/**
 * Real Menu Item component
 */
var InternalMenuItem = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var style = props.style,
    className = props.className,
    eventKey = props.eventKey,
    warnKey = props.warnKey,
    disabled = props.disabled,
    itemIcon = props.itemIcon,
    children = props.children,
    role = props.role,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    onClick = props.onClick,
    onKeyDown = props.onKeyDown,
    onFocus = props.onFocus,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded2);
  var domDataId = useMenuId(eventKey);
  var _React$useContext = react.useContext(MenuContext),
    prefixCls = _React$useContext.prefixCls,
    onItemClick = _React$useContext.onItemClick,
    contextDisabled = _React$useContext.disabled,
    overflowDisabled = _React$useContext.overflowDisabled,
    contextItemIcon = _React$useContext.itemIcon,
    selectedKeys = _React$useContext.selectedKeys,
    onActive = _React$useContext.onActive;
  var _React$useContext2 = react.useContext(context_PrivateContext),
    _internalRenderMenuItem = _React$useContext2._internalRenderMenuItem;
  var itemCls = "".concat(prefixCls, "-item");
  var legacyMenuItemRef = react.useRef();
  var elementRef = react.useRef();
  var mergedDisabled = contextDisabled || disabled;
  var mergedEleRef = (0,es_ref/* useComposeRef */.x1)(ref, elementRef);
  var connectedKeys = useFullPath(eventKey);

  // ================================ Warn ================================
  if (false) {}

  // ============================= Info =============================
  var getEventInfo = function getEventInfo(e) {
    return {
      key: eventKey,
      // Note: For legacy code is reversed which not like other antd component
      keyPath: (0,toConsumableArray/* default */.Z)(connectedKeys).reverse(),
      item: legacyMenuItemRef.current,
      domEvent: e
    };
  };

  // ============================= Icon =============================
  var mergedItemIcon = itemIcon || contextItemIcon;

  // ============================ Active ============================
  var _useActive = useActive(eventKey, mergedDisabled, onMouseEnter, onMouseLeave),
    active = _useActive.active,
    activeProps = (0,objectWithoutProperties/* default */.Z)(_useActive, _excluded3);

  // ============================ Select ============================
  var selected = selectedKeys.includes(eventKey);

  // ======================== DirectionStyle ========================
  var directionStyle = useDirectionStyle(connectedKeys.length);

  // ============================ Events ============================
  var onInternalClick = function onInternalClick(e) {
    if (mergedDisabled) {
      return;
    }
    var info = getEventInfo(e);
    onClick === null || onClick === void 0 || onClick(warnItemProp(info));
    onItemClick(info);
  };
  var onInternalKeyDown = function onInternalKeyDown(e) {
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    if (e.which === KeyCode/* default.ENTER */.Z.ENTER) {
      var info = getEventInfo(e);

      // Legacy. Key will also trigger click event
      onClick === null || onClick === void 0 || onClick(warnItemProp(info));
      onItemClick(info);
    }
  };

  /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */
  var onInternalFocus = function onInternalFocus(e) {
    onActive(eventKey);
    onFocus === null || onFocus === void 0 || onFocus(e);
  };

  // ============================ Render ============================
  var optionRoleProps = {};
  if (props.role === 'option') {
    optionRoleProps['aria-selected'] = selected;
  }
  var renderNode = /*#__PURE__*/react.createElement(LegacyMenuItem, (0,esm_extends/* default */.Z)({
    ref: legacyMenuItemRef,
    elementRef: mergedEleRef,
    role: role === null ? 'none' : role || 'menuitem',
    tabIndex: disabled ? null : -1,
    "data-menu-id": overflowDisabled && domDataId ? null : domDataId
  }, (0,omit/* default */.Z)(restProps, ['extra']), activeProps, optionRoleProps, {
    component: "li",
    "aria-disabled": disabled,
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, directionStyle), style),
    className: classnames_default()(itemCls, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(itemCls, "-active"), active), "".concat(itemCls, "-selected"), selected), "".concat(itemCls, "-disabled"), mergedDisabled), className),
    onClick: onInternalClick,
    onKeyDown: onInternalKeyDown,
    onFocus: onInternalFocus
  }), children, /*#__PURE__*/react.createElement(Icon, {
    props: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
      isSelected: selected
    }),
    icon: mergedItemIcon
  }));
  if (_internalRenderMenuItem) {
    renderNode = _internalRenderMenuItem(renderNode, props, {
      selected: selected
    });
  }
  return renderNode;
});
function MenuItem(props, ref) {
  var eventKey = props.eventKey;

  // ==================== Record KeyPath ====================
  var measure = useMeasure();
  var connectedKeyPath = useFullPath(eventKey);

  // eslint-disable-next-line consistent-return
  react.useEffect(function () {
    if (measure) {
      measure.registerPath(eventKey, connectedKeyPath);
      return function () {
        measure.unregisterPath(eventKey, connectedKeyPath);
      };
    }
  }, [connectedKeyPath]);
  if (measure) {
    return null;
  }

  // ======================== Render ========================
  return /*#__PURE__*/react.createElement(InternalMenuItem, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref
  }));
}
/* harmony default export */ var es_MenuItem = (/*#__PURE__*/react.forwardRef(MenuItem));
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/SubMenu/SubMenuList.js


var SubMenuList_excluded = ["className", "children"];



var InternalSubMenuList = function InternalSubMenuList(_ref, ref) {
  var className = _ref.className,
    children = _ref.children,
    restProps = (0,objectWithoutProperties/* default */.Z)(_ref, SubMenuList_excluded);
  var _React$useContext = react.useContext(MenuContext),
    prefixCls = _React$useContext.prefixCls,
    mode = _React$useContext.mode,
    rtl = _React$useContext.rtl;
  return /*#__PURE__*/react.createElement("ul", (0,esm_extends/* default */.Z)({
    className: classnames_default()(prefixCls, rtl && "".concat(prefixCls, "-rtl"), "".concat(prefixCls, "-sub"), "".concat(prefixCls, "-").concat(mode === 'inline' ? 'inline' : 'vertical'), className),
    role: "menu"
  }, restProps, {
    "data-menu-list": true,
    ref: ref
  }), children);
};
var SubMenuList = /*#__PURE__*/react.forwardRef(InternalSubMenuList);
SubMenuList.displayName = 'SubMenuList';
/* harmony default export */ var SubMenu_SubMenuList = (SubMenuList);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Children/toArray.js
var toArray = __webpack_require__(93550);
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/utils/commonUtil.js



function parseChildren(children, keyPath) {
  return (0,toArray/* default */.Z)(children).map(function (child, index) {
    if (/*#__PURE__*/react.isValidElement(child)) {
      var _eventKey, _child$props;
      var key = child.key;
      var eventKey = (_eventKey = (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.eventKey) !== null && _eventKey !== void 0 ? _eventKey : key;
      var emptyKey = eventKey === null || eventKey === undefined;
      if (emptyKey) {
        eventKey = "tmp_key-".concat([].concat((0,toConsumableArray/* default */.Z)(keyPath), [index]).join('-'));
      }
      var cloneProps = {
        key: eventKey,
        eventKey: eventKey
      };
      if (false) {}
      return /*#__PURE__*/react.cloneElement(child, cloneProps);
    }
    return child;
  });
}
// EXTERNAL MODULE: ./node_modules/@rc-component/trigger/es/index.js + 11 modules
var trigger_es = __webpack_require__(91831);
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/placements.js
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow
  }
};
var placementsRtl = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow
  },
  rightTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow
  },
  rightBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow
  },
  leftTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow
  },
  leftBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow
  }
};
/* harmony default export */ var es_placements = ((/* unused pure expression or super */ null && (placements)));
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/utils/motionUtil.js
function getMotion(mode, motion, defaultMotions) {
  if (motion) {
    return motion;
  }
  if (defaultMotions) {
    return defaultMotions[mode] || defaultMotions.other;
  }
  return undefined;
}
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/SubMenu/PopupTrigger.js










var popupPlacementMap = {
  horizontal: 'bottomLeft',
  vertical: 'rightTop',
  'vertical-left': 'rightTop',
  'vertical-right': 'leftTop'
};
function PopupTrigger(_ref) {
  var prefixCls = _ref.prefixCls,
    visible = _ref.visible,
    children = _ref.children,
    popup = _ref.popup,
    popupStyle = _ref.popupStyle,
    popupClassName = _ref.popupClassName,
    popupOffset = _ref.popupOffset,
    disabled = _ref.disabled,
    mode = _ref.mode,
    onVisibleChange = _ref.onVisibleChange;
  var _React$useContext = react.useContext(MenuContext),
    getPopupContainer = _React$useContext.getPopupContainer,
    rtl = _React$useContext.rtl,
    subMenuOpenDelay = _React$useContext.subMenuOpenDelay,
    subMenuCloseDelay = _React$useContext.subMenuCloseDelay,
    builtinPlacements = _React$useContext.builtinPlacements,
    triggerSubMenuAction = _React$useContext.triggerSubMenuAction,
    forceSubMenuRender = _React$useContext.forceSubMenuRender,
    rootClassName = _React$useContext.rootClassName,
    motion = _React$useContext.motion,
    defaultMotions = _React$useContext.defaultMotions;
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    innerVisible = _React$useState2[0],
    setInnerVisible = _React$useState2[1];
  var placement = rtl ? (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, placementsRtl), builtinPlacements) : (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, placements), builtinPlacements);
  var popupPlacement = popupPlacementMap[mode];
  var targetMotion = getMotion(mode, motion, defaultMotions);
  var targetMotionRef = react.useRef(targetMotion);
  if (mode !== 'inline') {
    /**
     * PopupTrigger is only used for vertical and horizontal types.
     * When collapsed is unfolded, the inline animation will destroy the vertical animation.
     */
    targetMotionRef.current = targetMotion;
  }
  var mergedMotion = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, targetMotionRef.current), {}, {
    leavedClassName: "".concat(prefixCls, "-hidden"),
    removeOnLeave: false,
    motionAppear: true
  });

  // Delay to change visible
  var visibleRef = react.useRef();
  react.useEffect(function () {
    visibleRef.current = (0,raf/* default */.Z)(function () {
      setInnerVisible(visible);
    });
    return function () {
      raf/* default.cancel */.Z.cancel(visibleRef.current);
    };
  }, [visible]);
  return /*#__PURE__*/react.createElement(trigger_es/* default */.Z, {
    prefixCls: prefixCls,
    popupClassName: classnames_default()("".concat(prefixCls, "-popup"), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-rtl"), rtl), popupClassName, rootClassName),
    stretch: mode === 'horizontal' ? 'minWidth' : null,
    getPopupContainer: getPopupContainer,
    builtinPlacements: placement,
    popupPlacement: popupPlacement,
    popupVisible: innerVisible,
    popup: popup,
    popupStyle: popupStyle,
    popupAlign: popupOffset && {
      offset: popupOffset
    },
    action: disabled ? [] : [triggerSubMenuAction],
    mouseEnterDelay: subMenuOpenDelay,
    mouseLeaveDelay: subMenuCloseDelay,
    onPopupVisibleChange: onVisibleChange,
    forceRender: forceSubMenuRender,
    popupMotion: mergedMotion,
    fresh: true
  }, children);
}
// EXTERNAL MODULE: ./node_modules/rc-motion/es/index.js + 13 modules
var rc_motion_es = __webpack_require__(26981);
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/SubMenu/InlineSubMenuList.js








function InlineSubMenuList(_ref) {
  var id = _ref.id,
    open = _ref.open,
    keyPath = _ref.keyPath,
    children = _ref.children;
  var fixedMode = 'inline';
  var _React$useContext = react.useContext(MenuContext),
    prefixCls = _React$useContext.prefixCls,
    forceSubMenuRender = _React$useContext.forceSubMenuRender,
    motion = _React$useContext.motion,
    defaultMotions = _React$useContext.defaultMotions,
    mode = _React$useContext.mode;

  // Always use latest mode check
  var sameModeRef = react.useRef(false);
  sameModeRef.current = mode === fixedMode;

  // We record `destroy` mark here since when mode change from `inline` to others.
  // The inline list should remove when motion end.
  var _React$useState = react.useState(!sameModeRef.current),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    destroy = _React$useState2[0],
    setDestroy = _React$useState2[1];
  var mergedOpen = sameModeRef.current ? open : false;

  // ================================= Effect =================================
  // Reset destroy state when mode change back
  react.useEffect(function () {
    if (sameModeRef.current) {
      setDestroy(false);
    }
  }, [mode]);

  // ================================= Render =================================
  var mergedMotion = (0,objectSpread2/* default */.Z)({}, getMotion(fixedMode, motion, defaultMotions));

  // No need appear since nest inlineCollapse changed
  if (keyPath.length > 1) {
    mergedMotion.motionAppear = false;
  }

  // Hide inline list when mode changed and motion end
  var originOnVisibleChanged = mergedMotion.onVisibleChanged;
  mergedMotion.onVisibleChanged = function (newVisible) {
    if (!sameModeRef.current && !newVisible) {
      setDestroy(true);
    }
    return originOnVisibleChanged === null || originOnVisibleChanged === void 0 ? void 0 : originOnVisibleChanged(newVisible);
  };
  if (destroy) {
    return null;
  }
  return /*#__PURE__*/react.createElement(InheritableContextProvider, {
    mode: fixedMode,
    locked: !sameModeRef.current
  }, /*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, (0,esm_extends/* default */.Z)({
    visible: mergedOpen
  }, mergedMotion, {
    forceRender: forceSubMenuRender,
    removeOnLeave: false,
    leavedClassName: "".concat(prefixCls, "-hidden")
  }), function (_ref2) {
    var motionClassName = _ref2.className,
      motionStyle = _ref2.style;
    return /*#__PURE__*/react.createElement(SubMenu_SubMenuList, {
      id: id,
      className: motionClassName,
      style: motionStyle
    }, children);
  }));
}
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/SubMenu/index.js





var SubMenu_excluded = ["style", "className", "title", "eventKey", "warnKey", "disabled", "internalPopupClose", "children", "itemIcon", "expandIcon", "popupClassName", "popupOffset", "popupStyle", "onClick", "onMouseEnter", "onMouseLeave", "onTitleClick", "onTitleMouseEnter", "onTitleMouseLeave"],
  SubMenu_excluded2 = ["active"];

















var InternalSubMenu = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var style = props.style,
    className = props.className,
    title = props.title,
    eventKey = props.eventKey,
    warnKey = props.warnKey,
    disabled = props.disabled,
    internalPopupClose = props.internalPopupClose,
    children = props.children,
    itemIcon = props.itemIcon,
    expandIcon = props.expandIcon,
    popupClassName = props.popupClassName,
    popupOffset = props.popupOffset,
    popupStyle = props.popupStyle,
    onClick = props.onClick,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    onTitleClick = props.onTitleClick,
    onTitleMouseEnter = props.onTitleMouseEnter,
    onTitleMouseLeave = props.onTitleMouseLeave,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, SubMenu_excluded);
  var domDataId = useMenuId(eventKey);
  var _React$useContext = react.useContext(MenuContext),
    prefixCls = _React$useContext.prefixCls,
    mode = _React$useContext.mode,
    openKeys = _React$useContext.openKeys,
    contextDisabled = _React$useContext.disabled,
    overflowDisabled = _React$useContext.overflowDisabled,
    activeKey = _React$useContext.activeKey,
    selectedKeys = _React$useContext.selectedKeys,
    contextItemIcon = _React$useContext.itemIcon,
    contextExpandIcon = _React$useContext.expandIcon,
    onItemClick = _React$useContext.onItemClick,
    onOpenChange = _React$useContext.onOpenChange,
    onActive = _React$useContext.onActive;
  var _React$useContext2 = react.useContext(context_PrivateContext),
    _internalRenderSubMenuItem = _React$useContext2._internalRenderSubMenuItem;
  var _React$useContext3 = react.useContext(PathUserContext),
    isSubPathKey = _React$useContext3.isSubPathKey;
  var connectedPath = useFullPath();
  var subMenuPrefixCls = "".concat(prefixCls, "-submenu");
  var mergedDisabled = contextDisabled || disabled;
  var elementRef = react.useRef();
  var popupRef = react.useRef();

  // ================================ Warn ================================
  if (false) {}

  // ================================ Icon ================================
  var mergedItemIcon = itemIcon !== null && itemIcon !== void 0 ? itemIcon : contextItemIcon;
  var mergedExpandIcon = expandIcon !== null && expandIcon !== void 0 ? expandIcon : contextExpandIcon;

  // ================================ Open ================================
  var originOpen = openKeys.includes(eventKey);
  var open = !overflowDisabled && originOpen;

  // =============================== Select ===============================
  var childrenSelected = isSubPathKey(selectedKeys, eventKey);

  // =============================== Active ===============================
  var _useActive = useActive(eventKey, mergedDisabled, onTitleMouseEnter, onTitleMouseLeave),
    active = _useActive.active,
    activeProps = (0,objectWithoutProperties/* default */.Z)(_useActive, SubMenu_excluded2);

  // Fallback of active check to avoid hover on menu title or disabled item
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    childrenActive = _React$useState2[0],
    setChildrenActive = _React$useState2[1];
  var triggerChildrenActive = function triggerChildrenActive(newActive) {
    if (!mergedDisabled) {
      setChildrenActive(newActive);
    }
  };
  var onInternalMouseEnter = function onInternalMouseEnter(domEvent) {
    triggerChildrenActive(true);
    onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
      key: eventKey,
      domEvent: domEvent
    });
  };
  var onInternalMouseLeave = function onInternalMouseLeave(domEvent) {
    triggerChildrenActive(false);
    onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
      key: eventKey,
      domEvent: domEvent
    });
  };
  var mergedActive = react.useMemo(function () {
    if (active) {
      return active;
    }
    if (mode !== 'inline') {
      return childrenActive || isSubPathKey([activeKey], eventKey);
    }
    return false;
  }, [mode, active, activeKey, childrenActive, eventKey, isSubPathKey]);

  // ========================== DirectionStyle ==========================
  var directionStyle = useDirectionStyle(connectedPath.length);

  // =============================== Events ===============================
  // >>>> Title click
  var onInternalTitleClick = function onInternalTitleClick(e) {
    // Skip if disabled
    if (mergedDisabled) {
      return;
    }
    onTitleClick === null || onTitleClick === void 0 || onTitleClick({
      key: eventKey,
      domEvent: e
    });

    // Trigger open by click when mode is `inline`
    if (mode === 'inline') {
      onOpenChange(eventKey, !originOpen);
    }
  };

  // >>>> Context for children click
  var onMergedItemClick = useMemoCallback(function (info) {
    onClick === null || onClick === void 0 || onClick(warnItemProp(info));
    onItemClick(info);
  });

  // >>>>> Visible change
  var onPopupVisibleChange = function onPopupVisibleChange(newVisible) {
    if (mode !== 'inline') {
      onOpenChange(eventKey, newVisible);
    }
  };

  /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */
  var onInternalFocus = function onInternalFocus() {
    onActive(eventKey);
  };

  // =============================== Render ===============================
  var popupId = domDataId && "".concat(domDataId, "-popup");
  var expandIconNode = react.useMemo(function () {
    return /*#__PURE__*/react.createElement(Icon, {
      icon: mode !== 'horizontal' ? mergedExpandIcon : undefined,
      props: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
        isOpen: open,
        // [Legacy] Not sure why need this mark
        isSubMenu: true
      })
    }, /*#__PURE__*/react.createElement("i", {
      className: "".concat(subMenuPrefixCls, "-arrow")
    }));
  }, [mode, mergedExpandIcon, props, open, subMenuPrefixCls]);

  // >>>>> Title
  var titleNode = /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    role: "menuitem",
    style: directionStyle,
    className: "".concat(subMenuPrefixCls, "-title"),
    tabIndex: mergedDisabled ? null : -1,
    ref: elementRef,
    title: typeof title === 'string' ? title : null,
    "data-menu-id": overflowDisabled && domDataId ? null : domDataId,
    "aria-expanded": open,
    "aria-haspopup": true,
    "aria-controls": popupId,
    "aria-disabled": mergedDisabled,
    onClick: onInternalTitleClick,
    onFocus: onInternalFocus
  }, activeProps), title, expandIconNode);

  // Cache mode if it change to `inline` which do not have popup motion
  var triggerModeRef = react.useRef(mode);
  if (mode !== 'inline' && connectedPath.length > 1) {
    triggerModeRef.current = 'vertical';
  } else {
    triggerModeRef.current = mode;
  }
  if (!overflowDisabled) {
    var triggerMode = triggerModeRef.current;

    // Still wrap with Trigger here since we need avoid react re-mount dom node
    // Which makes motion failed
    titleNode = /*#__PURE__*/react.createElement(PopupTrigger, {
      mode: triggerMode,
      prefixCls: subMenuPrefixCls,
      visible: !internalPopupClose && open && mode !== 'inline',
      popupClassName: popupClassName,
      popupOffset: popupOffset,
      popupStyle: popupStyle,
      popup: /*#__PURE__*/react.createElement(InheritableContextProvider
      // Special handle of horizontal mode
      , {
        mode: triggerMode === 'horizontal' ? 'vertical' : triggerMode
      }, /*#__PURE__*/react.createElement(SubMenu_SubMenuList, {
        id: popupId,
        ref: popupRef
      }, children)),
      disabled: mergedDisabled,
      onVisibleChange: onPopupVisibleChange
    }, titleNode);
  }

  // >>>>> List node
  var listNode = /*#__PURE__*/react.createElement(es/* default.Item */.Z.Item, (0,esm_extends/* default */.Z)({
    ref: ref,
    role: "none"
  }, restProps, {
    component: "li",
    style: style,
    className: classnames_default()(subMenuPrefixCls, "".concat(subMenuPrefixCls, "-").concat(mode), className, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(subMenuPrefixCls, "-open"), open), "".concat(subMenuPrefixCls, "-active"), mergedActive), "".concat(subMenuPrefixCls, "-selected"), childrenSelected), "".concat(subMenuPrefixCls, "-disabled"), mergedDisabled)),
    onMouseEnter: onInternalMouseEnter,
    onMouseLeave: onInternalMouseLeave
  }), titleNode, !overflowDisabled && /*#__PURE__*/react.createElement(InlineSubMenuList, {
    id: popupId,
    open: open,
    keyPath: connectedPath
  }, children));
  if (_internalRenderSubMenuItem) {
    listNode = _internalRenderSubMenuItem(listNode, props, {
      selected: childrenSelected,
      active: mergedActive,
      open: open,
      disabled: mergedDisabled
    });
  }

  // >>>>> Render
  return /*#__PURE__*/react.createElement(InheritableContextProvider, {
    onItemClick: onMergedItemClick,
    mode: mode === 'horizontal' ? 'vertical' : mode,
    itemIcon: mergedItemIcon,
    expandIcon: mergedExpandIcon
  }, listNode);
});
var SubMenu = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var eventKey = props.eventKey,
    children = props.children;
  var connectedKeyPath = useFullPath(eventKey);
  var childList = parseChildren(children, connectedKeyPath);

  // ==================== Record KeyPath ====================
  var measure = useMeasure();

  // eslint-disable-next-line consistent-return
  react.useEffect(function () {
    if (measure) {
      measure.registerPath(eventKey, connectedKeyPath);
      return function () {
        measure.unregisterPath(eventKey, connectedKeyPath);
      };
    }
  }, [connectedKeyPath]);
  var renderNode;

  // ======================== Render ========================
  if (measure) {
    renderNode = childList;
  } else {
    renderNode = /*#__PURE__*/react.createElement(InternalSubMenu, (0,esm_extends/* default */.Z)({
      ref: ref
    }, props), childList);
  }
  return /*#__PURE__*/react.createElement(PathTrackerContext.Provider, {
    value: connectedKeyPath
  }, renderNode);
});
if (false) {}
/* harmony default export */ var es_SubMenu = (SubMenu);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/Divider.js




function Divider(_ref) {
  var className = _ref.className,
    style = _ref.style;
  var _React$useContext = react.useContext(MenuContext),
    prefixCls = _React$useContext.prefixCls;
  var measure = useMeasure();
  if (measure) {
    return null;
  }
  return /*#__PURE__*/react.createElement("li", {
    role: "separator",
    className: classnames_default()("".concat(prefixCls, "-item-divider"), className),
    style: style
  });
}
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/MenuItemGroup.js


var MenuItemGroup_excluded = ["className", "title", "eventKey", "children"];






var InternalMenuItemGroup = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var className = props.className,
    title = props.title,
    eventKey = props.eventKey,
    children = props.children,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, MenuItemGroup_excluded);
  var _React$useContext = react.useContext(MenuContext),
    prefixCls = _React$useContext.prefixCls;
  var groupPrefixCls = "".concat(prefixCls, "-item-group");
  return /*#__PURE__*/react.createElement("li", (0,esm_extends/* default */.Z)({
    ref: ref,
    role: "presentation"
  }, restProps, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    className: classnames_default()(groupPrefixCls, className)
  }), /*#__PURE__*/react.createElement("div", {
    role: "presentation",
    className: "".concat(groupPrefixCls, "-title"),
    title: typeof title === 'string' ? title : undefined
  }, title), /*#__PURE__*/react.createElement("ul", {
    role: "group",
    className: "".concat(groupPrefixCls, "-list")
  }, children));
});
var MenuItemGroup = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var eventKey = props.eventKey,
    children = props.children;
  var connectedKeyPath = useFullPath(eventKey);
  var childList = parseChildren(children, connectedKeyPath);
  var measure = useMeasure();
  if (measure) {
    return childList;
  }
  return /*#__PURE__*/react.createElement(InternalMenuItemGroup, (0,esm_extends/* default */.Z)({
    ref: ref
  }, (0,omit/* default */.Z)(props, ['warnKey'])), childList);
});
if (false) {}
/* harmony default export */ var es_MenuItemGroup = (MenuItemGroup);
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/utils/nodeUtil.js




var nodeUtil_excluded = ["label", "children", "key", "type", "extra"];






function convertItemsToNodes(list, components, prefixCls) {
  var MergedMenuItem = components.item,
    MergedMenuItemGroup = components.group,
    MergedSubMenu = components.submenu,
    MergedDivider = components.divider;
  return (list || []).map(function (opt, index) {
    if (opt && (0,esm_typeof/* default */.Z)(opt) === 'object') {
      var _ref = opt,
        label = _ref.label,
        children = _ref.children,
        key = _ref.key,
        type = _ref.type,
        extra = _ref.extra,
        restProps = (0,objectWithoutProperties/* default */.Z)(_ref, nodeUtil_excluded);
      var mergedKey = key !== null && key !== void 0 ? key : "tmp-".concat(index);

      // MenuItemGroup & SubMenuItem
      if (children || type === 'group') {
        if (type === 'group') {
          // Group
          return /*#__PURE__*/react.createElement(MergedMenuItemGroup, (0,esm_extends/* default */.Z)({
            key: mergedKey
          }, restProps, {
            title: label
          }), convertItemsToNodes(children, components, prefixCls));
        }

        // Sub Menu
        return /*#__PURE__*/react.createElement(MergedSubMenu, (0,esm_extends/* default */.Z)({
          key: mergedKey
        }, restProps, {
          title: label
        }), convertItemsToNodes(children, components, prefixCls));
      }

      // MenuItem & Divider
      if (type === 'divider') {
        return /*#__PURE__*/react.createElement(MergedDivider, (0,esm_extends/* default */.Z)({
          key: mergedKey
        }, restProps));
      }
      return /*#__PURE__*/react.createElement(MergedMenuItem, (0,esm_extends/* default */.Z)({
        key: mergedKey
      }, restProps, {
        extra: extra
      }), label, (!!extra || extra === 0) && /*#__PURE__*/react.createElement("span", {
        className: "".concat(prefixCls, "-item-extra")
      }, extra));
    }
    return null;
  }).filter(function (opt) {
    return opt;
  });
}
function parseItems(children, items, keyPath, components, prefixCls) {
  var childNodes = children;
  var mergedComponents = (0,objectSpread2/* default */.Z)({
    divider: Divider,
    item: es_MenuItem,
    group: es_MenuItemGroup,
    submenu: es_SubMenu
  }, components);
  if (items) {
    childNodes = convertItemsToNodes(items, mergedComponents, prefixCls);
  }
  return parseChildren(childNodes, keyPath);
}
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/Menu.js






var Menu_excluded = ["prefixCls", "rootClassName", "style", "className", "tabIndex", "items", "children", "direction", "id", "mode", "inlineCollapsed", "disabled", "disabledOverflow", "subMenuOpenDelay", "subMenuCloseDelay", "forceSubMenuRender", "defaultOpenKeys", "openKeys", "activeKey", "defaultActiveFirst", "selectable", "multiple", "defaultSelectedKeys", "selectedKeys", "onSelect", "onDeselect", "inlineIndent", "motion", "defaultMotions", "triggerSubMenuAction", "builtinPlacements", "itemIcon", "expandIcon", "overflowedIndicator", "overflowedIndicatorPopupClassName", "getPopupContainer", "onClick", "onOpenChange", "onKeyDown", "openAnimation", "openTransitionName", "_internalRenderMenuItem", "_internalRenderSubMenuItem", "_internalComponents"];





















/**
 * Menu modify after refactor:
 * ## Add
 * - disabled
 *
 * ## Remove
 * - openTransitionName
 * - openAnimation
 * - onDestroy
 * - siderCollapsed: Seems antd do not use this prop (Need test in antd)
 * - collapsedWidth: Seems this logic should be handle by antd Layout.Sider
 */

// optimize for render
var EMPTY_LIST = [];
var Menu = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _childList$;
  var _ref = props,
    _ref$prefixCls = _ref.prefixCls,
    prefixCls = _ref$prefixCls === void 0 ? 'rc-menu' : _ref$prefixCls,
    rootClassName = _ref.rootClassName,
    style = _ref.style,
    className = _ref.className,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
    items = _ref.items,
    children = _ref.children,
    direction = _ref.direction,
    id = _ref.id,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'vertical' : _ref$mode,
    inlineCollapsed = _ref.inlineCollapsed,
    disabled = _ref.disabled,
    disabledOverflow = _ref.disabledOverflow,
    _ref$subMenuOpenDelay = _ref.subMenuOpenDelay,
    subMenuOpenDelay = _ref$subMenuOpenDelay === void 0 ? 0.1 : _ref$subMenuOpenDelay,
    _ref$subMenuCloseDela = _ref.subMenuCloseDelay,
    subMenuCloseDelay = _ref$subMenuCloseDela === void 0 ? 0.1 : _ref$subMenuCloseDela,
    forceSubMenuRender = _ref.forceSubMenuRender,
    defaultOpenKeys = _ref.defaultOpenKeys,
    openKeys = _ref.openKeys,
    activeKey = _ref.activeKey,
    defaultActiveFirst = _ref.defaultActiveFirst,
    _ref$selectable = _ref.selectable,
    selectable = _ref$selectable === void 0 ? true : _ref$selectable,
    _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? false : _ref$multiple,
    defaultSelectedKeys = _ref.defaultSelectedKeys,
    selectedKeys = _ref.selectedKeys,
    onSelect = _ref.onSelect,
    onDeselect = _ref.onDeselect,
    _ref$inlineIndent = _ref.inlineIndent,
    inlineIndent = _ref$inlineIndent === void 0 ? 24 : _ref$inlineIndent,
    motion = _ref.motion,
    defaultMotions = _ref.defaultMotions,
    _ref$triggerSubMenuAc = _ref.triggerSubMenuAction,
    triggerSubMenuAction = _ref$triggerSubMenuAc === void 0 ? 'hover' : _ref$triggerSubMenuAc,
    builtinPlacements = _ref.builtinPlacements,
    itemIcon = _ref.itemIcon,
    expandIcon = _ref.expandIcon,
    _ref$overflowedIndica = _ref.overflowedIndicator,
    overflowedIndicator = _ref$overflowedIndica === void 0 ? '...' : _ref$overflowedIndica,
    overflowedIndicatorPopupClassName = _ref.overflowedIndicatorPopupClassName,
    getPopupContainer = _ref.getPopupContainer,
    onClick = _ref.onClick,
    onOpenChange = _ref.onOpenChange,
    onKeyDown = _ref.onKeyDown,
    openAnimation = _ref.openAnimation,
    openTransitionName = _ref.openTransitionName,
    _internalRenderMenuItem = _ref._internalRenderMenuItem,
    _internalRenderSubMenuItem = _ref._internalRenderSubMenuItem,
    _internalComponents = _ref._internalComponents,
    restProps = (0,objectWithoutProperties/* default */.Z)(_ref, Menu_excluded);
  var _React$useMemo = react.useMemo(function () {
      return [parseItems(children, items, EMPTY_LIST, _internalComponents, prefixCls), parseItems(children, items, EMPTY_LIST, {}, prefixCls)];
    }, [children, items, _internalComponents]),
    _React$useMemo2 = (0,slicedToArray/* default */.Z)(_React$useMemo, 2),
    childList = _React$useMemo2[0],
    measureChildList = _React$useMemo2[1];
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    mounted = _React$useState2[0],
    setMounted = _React$useState2[1];
  var containerRef = react.useRef();
  var uuid = useUUID(id);
  var isRtl = direction === 'rtl';

  // ========================= Warn =========================
  if (false) {}

  // ========================= Open =========================
  var _useMergedState = (0,useMergedState/* default */.Z)(defaultOpenKeys, {
      value: openKeys,
      postState: function postState(keys) {
        return keys || EMPTY_LIST;
      }
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    mergedOpenKeys = _useMergedState2[0],
    setMergedOpenKeys = _useMergedState2[1];

  // React 18 will merge mouse event which means we open key will not sync
  // ref: https://github.com/ant-design/ant-design/issues/38818
  var triggerOpenKeys = function triggerOpenKeys(keys) {
    var forceFlush = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    function doUpdate() {
      setMergedOpenKeys(keys);
      onOpenChange === null || onOpenChange === void 0 || onOpenChange(keys);
    }
    if (forceFlush) {
      (0,react_dom.flushSync)(doUpdate);
    } else {
      doUpdate();
    }
  };

  // >>>>> Cache & Reset open keys when inlineCollapsed changed
  var _React$useState3 = react.useState(mergedOpenKeys),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    inlineCacheOpenKeys = _React$useState4[0],
    setInlineCacheOpenKeys = _React$useState4[1];
  var mountRef = react.useRef(false);

  // ========================= Mode =========================
  var _React$useMemo3 = react.useMemo(function () {
      if ((mode === 'inline' || mode === 'vertical') && inlineCollapsed) {
        return ['vertical', inlineCollapsed];
      }
      return [mode, false];
    }, [mode, inlineCollapsed]),
    _React$useMemo4 = (0,slicedToArray/* default */.Z)(_React$useMemo3, 2),
    mergedMode = _React$useMemo4[0],
    mergedInlineCollapsed = _React$useMemo4[1];
  var isInlineMode = mergedMode === 'inline';
  var _React$useState5 = react.useState(mergedMode),
    _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
    internalMode = _React$useState6[0],
    setInternalMode = _React$useState6[1];
  var _React$useState7 = react.useState(mergedInlineCollapsed),
    _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
    internalInlineCollapsed = _React$useState8[0],
    setInternalInlineCollapsed = _React$useState8[1];
  react.useEffect(function () {
    setInternalMode(mergedMode);
    setInternalInlineCollapsed(mergedInlineCollapsed);
    if (!mountRef.current) {
      return;
    }
    // Synchronously update MergedOpenKeys
    if (isInlineMode) {
      setMergedOpenKeys(inlineCacheOpenKeys);
    } else {
      // Trigger open event in case its in control
      triggerOpenKeys(EMPTY_LIST);
    }
  }, [mergedMode, mergedInlineCollapsed]);

  // ====================== Responsive ======================
  var _React$useState9 = react.useState(0),
    _React$useState10 = (0,slicedToArray/* default */.Z)(_React$useState9, 2),
    lastVisibleIndex = _React$useState10[0],
    setLastVisibleIndex = _React$useState10[1];
  var allVisible = lastVisibleIndex >= childList.length - 1 || internalMode !== 'horizontal' || disabledOverflow;

  // Cache
  react.useEffect(function () {
    if (isInlineMode) {
      setInlineCacheOpenKeys(mergedOpenKeys);
    }
  }, [mergedOpenKeys]);
  react.useEffect(function () {
    mountRef.current = true;
    return function () {
      mountRef.current = false;
    };
  }, []);

  // ========================= Path =========================
  var _useKeyRecords = useKeyRecords(),
    registerPath = _useKeyRecords.registerPath,
    unregisterPath = _useKeyRecords.unregisterPath,
    refreshOverflowKeys = _useKeyRecords.refreshOverflowKeys,
    isSubPathKey = _useKeyRecords.isSubPathKey,
    getKeyPath = _useKeyRecords.getKeyPath,
    getKeys = _useKeyRecords.getKeys,
    getSubPathKeys = _useKeyRecords.getSubPathKeys;
  var registerPathContext = react.useMemo(function () {
    return {
      registerPath: registerPath,
      unregisterPath: unregisterPath
    };
  }, [registerPath, unregisterPath]);
  var pathUserContext = react.useMemo(function () {
    return {
      isSubPathKey: isSubPathKey
    };
  }, [isSubPathKey]);
  react.useEffect(function () {
    refreshOverflowKeys(allVisible ? EMPTY_LIST : childList.slice(lastVisibleIndex + 1).map(function (child) {
      return child.key;
    }));
  }, [lastVisibleIndex, allVisible]);

  // ======================== Active ========================
  var _useMergedState3 = (0,useMergedState/* default */.Z)(activeKey || defaultActiveFirst && ((_childList$ = childList[0]) === null || _childList$ === void 0 ? void 0 : _childList$.key), {
      value: activeKey
    }),
    _useMergedState4 = (0,slicedToArray/* default */.Z)(_useMergedState3, 2),
    mergedActiveKey = _useMergedState4[0],
    setMergedActiveKey = _useMergedState4[1];
  var onActive = useMemoCallback(function (key) {
    setMergedActiveKey(key);
  });
  var onInactive = useMemoCallback(function () {
    setMergedActiveKey(undefined);
  });
  (0,react.useImperativeHandle)(ref, function () {
    return {
      list: containerRef.current,
      focus: function focus(options) {
        var _childList$find;
        var keys = getKeys();
        var _refreshElements = refreshElements(keys, uuid),
          elements = _refreshElements.elements,
          key2element = _refreshElements.key2element,
          element2key = _refreshElements.element2key;
        var focusableElements = getFocusableElements(containerRef.current, elements);
        var shouldFocusKey = mergedActiveKey !== null && mergedActiveKey !== void 0 ? mergedActiveKey : focusableElements[0] ? element2key.get(focusableElements[0]) : (_childList$find = childList.find(function (node) {
          return !node.props.disabled;
        })) === null || _childList$find === void 0 ? void 0 : _childList$find.key;
        var elementToFocus = key2element.get(shouldFocusKey);
        if (shouldFocusKey && elementToFocus) {
          var _elementToFocus$focus;
          elementToFocus === null || elementToFocus === void 0 || (_elementToFocus$focus = elementToFocus.focus) === null || _elementToFocus$focus === void 0 || _elementToFocus$focus.call(elementToFocus, options);
        }
      }
    };
  });

  // ======================== Select ========================
  // >>>>> Select keys
  var _useMergedState5 = (0,useMergedState/* default */.Z)(defaultSelectedKeys || [], {
      value: selectedKeys,
      // Legacy convert key to array
      postState: function postState(keys) {
        if (Array.isArray(keys)) {
          return keys;
        }
        if (keys === null || keys === undefined) {
          return EMPTY_LIST;
        }
        return [keys];
      }
    }),
    _useMergedState6 = (0,slicedToArray/* default */.Z)(_useMergedState5, 2),
    mergedSelectKeys = _useMergedState6[0],
    setMergedSelectKeys = _useMergedState6[1];

  // >>>>> Trigger select
  var triggerSelection = function triggerSelection(info) {
    if (selectable) {
      // Insert or Remove
      var targetKey = info.key;
      var exist = mergedSelectKeys.includes(targetKey);
      var newSelectKeys;
      if (multiple) {
        if (exist) {
          newSelectKeys = mergedSelectKeys.filter(function (key) {
            return key !== targetKey;
          });
        } else {
          newSelectKeys = [].concat((0,toConsumableArray/* default */.Z)(mergedSelectKeys), [targetKey]);
        }
      } else {
        newSelectKeys = [targetKey];
      }
      setMergedSelectKeys(newSelectKeys);

      // Trigger event
      var selectInfo = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, info), {}, {
        selectedKeys: newSelectKeys
      });
      if (exist) {
        onDeselect === null || onDeselect === void 0 || onDeselect(selectInfo);
      } else {
        onSelect === null || onSelect === void 0 || onSelect(selectInfo);
      }
    }

    // Whatever selectable, always close it
    if (!multiple && mergedOpenKeys.length && internalMode !== 'inline') {
      triggerOpenKeys(EMPTY_LIST);
    }
  };

  // ========================= Open =========================
  /**
   * Click for item. SubMenu do not have selection status
   */
  var onInternalClick = useMemoCallback(function (info) {
    onClick === null || onClick === void 0 || onClick(warnItemProp(info));
    triggerSelection(info);
  });
  var onInternalOpenChange = useMemoCallback(function (key, open) {
    var newOpenKeys = mergedOpenKeys.filter(function (k) {
      return k !== key;
    });
    if (open) {
      newOpenKeys.push(key);
    } else if (internalMode !== 'inline') {
      // We need find all related popup to close
      var subPathKeys = getSubPathKeys(key);
      newOpenKeys = newOpenKeys.filter(function (k) {
        return !subPathKeys.has(k);
      });
    }
    if (!(0,isEqual/* default */.Z)(mergedOpenKeys, newOpenKeys, true)) {
      triggerOpenKeys(newOpenKeys, true);
    }
  });

  // ==================== Accessibility =====================
  var triggerAccessibilityOpen = function triggerAccessibilityOpen(key, open) {
    var nextOpen = open !== null && open !== void 0 ? open : !mergedOpenKeys.includes(key);
    onInternalOpenChange(key, nextOpen);
  };
  var onInternalKeyDown = useAccessibility(internalMode, mergedActiveKey, isRtl, uuid, containerRef, getKeys, getKeyPath, setMergedActiveKey, triggerAccessibilityOpen, onKeyDown);

  // ======================== Effect ========================
  react.useEffect(function () {
    setMounted(true);
  }, []);

  // ======================= Context ========================
  var privateContext = react.useMemo(function () {
    return {
      _internalRenderMenuItem: _internalRenderMenuItem,
      _internalRenderSubMenuItem: _internalRenderSubMenuItem
    };
  }, [_internalRenderMenuItem, _internalRenderSubMenuItem]);

  // ======================== Render ========================

  // >>>>> Children
  var wrappedChildList = internalMode !== 'horizontal' || disabledOverflow ? childList :
  // Need wrap for overflow dropdown that do not response for open
  childList.map(function (child, index) {
    return (/*#__PURE__*/
      // Always wrap provider to avoid sub node re-mount
      react.createElement(InheritableContextProvider, {
        key: child.key,
        overflowDisabled: index > lastVisibleIndex
      }, child)
    );
  });

  // >>>>> Container
  var container = /*#__PURE__*/react.createElement(es/* default */.Z, (0,esm_extends/* default */.Z)({
    id: id,
    ref: containerRef,
    prefixCls: "".concat(prefixCls, "-overflow"),
    component: "ul",
    itemComponent: es_MenuItem,
    className: classnames_default()(prefixCls, "".concat(prefixCls, "-root"), "".concat(prefixCls, "-").concat(internalMode), className, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-inline-collapsed"), internalInlineCollapsed), "".concat(prefixCls, "-rtl"), isRtl), rootClassName),
    dir: direction,
    style: style,
    role: "menu",
    tabIndex: tabIndex,
    data: wrappedChildList,
    renderRawItem: function renderRawItem(node) {
      return node;
    },
    renderRawRest: function renderRawRest(omitItems) {
      // We use origin list since wrapped list use context to prevent open
      var len = omitItems.length;
      var originOmitItems = len ? childList.slice(-len) : null;
      return /*#__PURE__*/react.createElement(es_SubMenu, {
        eventKey: OVERFLOW_KEY,
        title: overflowedIndicator,
        disabled: allVisible,
        internalPopupClose: len === 0,
        popupClassName: overflowedIndicatorPopupClassName
      }, originOmitItems);
    },
    maxCount: internalMode !== 'horizontal' || disabledOverflow ? es/* default.INVALIDATE */.Z.INVALIDATE : es/* default.RESPONSIVE */.Z.RESPONSIVE,
    ssr: "full",
    "data-menu-list": true,
    onVisibleChange: function onVisibleChange(newLastIndex) {
      setLastVisibleIndex(newLastIndex);
    },
    onKeyDown: onInternalKeyDown
  }, restProps));

  // >>>>> Render
  return /*#__PURE__*/react.createElement(context_PrivateContext.Provider, {
    value: privateContext
  }, /*#__PURE__*/react.createElement(IdContext.Provider, {
    value: uuid
  }, /*#__PURE__*/react.createElement(InheritableContextProvider, {
    prefixCls: prefixCls,
    rootClassName: rootClassName,
    mode: internalMode,
    openKeys: mergedOpenKeys,
    rtl: isRtl
    // Disabled
    ,

    disabled: disabled
    // Motion
    ,

    motion: mounted ? motion : null,
    defaultMotions: mounted ? defaultMotions : null
    // Active
    ,

    activeKey: mergedActiveKey,
    onActive: onActive,
    onInactive: onInactive
    // Selection
    ,

    selectedKeys: mergedSelectKeys
    // Level
    ,

    inlineIndent: inlineIndent
    // Popup
    ,

    subMenuOpenDelay: subMenuOpenDelay,
    subMenuCloseDelay: subMenuCloseDelay,
    forceSubMenuRender: forceSubMenuRender,
    builtinPlacements: builtinPlacements,
    triggerSubMenuAction: triggerSubMenuAction,
    getPopupContainer: getPopupContainer
    // Icon
    ,

    itemIcon: itemIcon,
    expandIcon: expandIcon
    // Events
    ,

    onItemClick: onInternalClick,
    onOpenChange: onInternalOpenChange
  }, /*#__PURE__*/react.createElement(PathUserContext.Provider, {
    value: pathUserContext
  }, container), /*#__PURE__*/react.createElement("div", {
    style: {
      display: 'none'
    },
    "aria-hidden": true
  }, /*#__PURE__*/react.createElement(PathRegisterContext.Provider, {
    value: registerPathContext
  }, measureChildList)))));
});
/* harmony default export */ var es_Menu = (Menu);
;// CONCATENATED MODULE: ./node_modules/rc-menu/es/index.js







var ExportMenu = es_Menu;
ExportMenu.Item = es_MenuItem;
ExportMenu.SubMenu = es_SubMenu;
ExportMenu.ItemGroup = es_MenuItemGroup;
ExportMenu.Divider = Divider;
/* harmony default export */ var rc_menu_es = (ExportMenu);

/***/ }),

/***/ 26981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V4": function() { return /* reexport */ CSSMotionList; },
  "zt": function() { return /* reexport */ MotionProvider; },
  "ZP": function() { return /* binding */ rc_motion_es; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/findDOMNode.js
var findDOMNode = __webpack_require__(33970);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(99195);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/context.js

var _excluded = ["children"];

var Context = /*#__PURE__*/react.createContext({});
function MotionProvider(_ref) {
  var children = _ref.children,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: props
  }, children);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6223);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(79427);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(34766);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js
var createSuper = __webpack_require__(56302);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/DomWrapper.js





var DomWrapper = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(DomWrapper, _React$Component);
  var _super = (0,createSuper/* default */.Z)(DomWrapper);
  function DomWrapper() {
    (0,classCallCheck/* default */.Z)(this, DomWrapper);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(DomWrapper, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return DomWrapper;
}(react.Component);
/* harmony default export */ var es_DomWrapper = (DomWrapper);
// EXTERNAL MODULE: ./node_modules/rc-util/es/index.js
var es = __webpack_require__(57433);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useState.js
var useState = __webpack_require__(63345);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useEvent.js
var useEvent = __webpack_require__(47789);
;// CONCATENATED MODULE: ./node_modules/rc-util/es/hooks/useSyncState.js



/**
 * Same as React.useState but will always get latest state.
 * This is useful when React merge multiple state updates into one.
 * e.g. onTransitionEnd trigger multiple event at once will be merged state update in React.
 */
function useSyncState(defaultValue) {
  var _React$useReducer = react.useReducer(function (x) {
      return x + 1;
    }, 0),
    _React$useReducer2 = (0,slicedToArray/* default */.Z)(_React$useReducer, 2),
    forceUpdate = _React$useReducer2[1];
  var currentValueRef = react.useRef(defaultValue);
  var getValue = (0,useEvent/* default */.Z)(function () {
    return currentValueRef.current;
  });
  var setValue = (0,useEvent/* default */.Z)(function (updater) {
    currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
    forceUpdate();
  });
  return [getValue, setValue];
}
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/interface.js
var STATUS_NONE = 'none';
var STATUS_APPEAR = 'appear';
var STATUS_ENTER = 'enter';
var STATUS_LEAVE = 'leave';
var STEP_NONE = 'none';
var STEP_PREPARE = 'prepare';
var STEP_START = 'start';
var STEP_ACTIVE = 'active';
var STEP_ACTIVATED = 'end';
/**
 * Used for disabled motion case.
 * Prepare stage will still work but start & active will be skipped.
 */
var STEP_PREPARED = 'prepared';
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/canUseDom.js
var canUseDom = __webpack_require__(55304);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/util/motion.js


// ================= Transition =================
// Event wrapper. Copy from react source code
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
  prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
  prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
  prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
  return prefixes;
}
function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap('Animation', 'AnimationEnd'),
    transitionend: makePrefixMap('Transition', 'TransitionEnd')
  };
  if (domSupport) {
    if (!('AnimationEvent' in win)) {
      delete prefixes.animationend.animation;
    }
    if (!('TransitionEvent' in win)) {
      delete prefixes.transitionend.transition;
    }
  }
  return prefixes;
}
var vendorPrefixes = getVendorPrefixes((0,canUseDom/* default */.Z)(), typeof window !== 'undefined' ? window : {});
var style = {};
if ((0,canUseDom/* default */.Z)()) {
  var _document$createEleme = document.createElement('div');
  style = _document$createEleme.style;
}
var prefixedEventNames = {};
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }
  var prefixMap = vendorPrefixes[eventName];
  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;
    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];
      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }
  return '';
}
var internalAnimationEndName = getVendorPrefixedEventName('animationend');
var internalTransitionEndName = getVendorPrefixedEventName('transitionend');
var supportTransition = !!(internalAnimationEndName && internalTransitionEndName);
var animationEndName = internalAnimationEndName || 'animationend';
var transitionEndName = internalTransitionEndName || 'transitionend';
function getTransitionName(transitionName, transitionType) {
  if (!transitionName) return null;
  if ((0,esm_typeof/* default */.Z)(transitionName) === 'object') {
    var type = transitionType.replace(/-\w/g, function (match) {
      return match[1].toUpperCase();
    });
    return transitionName[type];
  }
  return "".concat(transitionName, "-").concat(transitionType);
}
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useDomMotionEvents.js



/* harmony default export */ var useDomMotionEvents = (function (onInternalMotionEnd) {
  var cacheElementRef = (0,react.useRef)();

  // Remove events
  function removeMotionEvents(element) {
    if (element) {
      element.removeEventListener(transitionEndName, onInternalMotionEnd);
      element.removeEventListener(animationEndName, onInternalMotionEnd);
    }
  }

  // Patch events
  function patchMotionEvents(element) {
    if (cacheElementRef.current && cacheElementRef.current !== element) {
      removeMotionEvents(cacheElementRef.current);
    }
    if (element && element !== cacheElementRef.current) {
      element.addEventListener(transitionEndName, onInternalMotionEnd);
      element.addEventListener(animationEndName, onInternalMotionEnd);

      // Save as cache in case dom removed trigger by `motionDeadline`
      cacheElementRef.current = element;
    }
  }

  // Clean up when removed
  react.useEffect(function () {
    return function () {
      removeMotionEvents(cacheElementRef.current);
    };
  }, []);
  return [patchMotionEvents, removeMotionEvents];
});
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useIsomorphicLayoutEffect.js



// It's safe to use `useLayoutEffect` but the warning is annoying
var useIsomorphicLayoutEffect = (0,canUseDom/* default */.Z)() ? react.useLayoutEffect : react.useEffect;
/* harmony default export */ var hooks_useIsomorphicLayoutEffect = (useIsomorphicLayoutEffect);
// EXTERNAL MODULE: ./node_modules/rc-util/es/raf.js
var raf = __webpack_require__(13157);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useNextFrame.js


/* harmony default export */ var useNextFrame = (function () {
  var nextFrameRef = react.useRef(null);
  function cancelNextFrame() {
    raf/* default.cancel */.Z.cancel(nextFrameRef.current);
  }
  function nextFrame(callback) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    cancelNextFrame();
    var nextFrameId = (0,raf/* default */.Z)(function () {
      if (delay <= 1) {
        callback({
          isCanceled: function isCanceled() {
            return nextFrameId !== nextFrameRef.current;
          }
        });
      } else {
        nextFrame(callback, delay - 1);
      }
    });
    nextFrameRef.current = nextFrameId;
  }
  react.useEffect(function () {
    return function () {
      cancelNextFrame();
    };
  }, []);
  return [nextFrame, cancelNextFrame];
});
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useStepQueue.js






var FULL_STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED];
var SIMPLE_STEP_QUEUE = [STEP_PREPARE, STEP_PREPARED];

/** Skip current step */
var SkipStep = false;
/** Current step should be update in */
var DoStep = true;
function isActive(step) {
  return step === STEP_ACTIVE || step === STEP_ACTIVATED;
}
/* harmony default export */ var useStepQueue = (function (status, prepareOnly, callback) {
  var _useState = (0,useState/* default */.Z)(STEP_NONE),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  var _useNextFrame = useNextFrame(),
    _useNextFrame2 = (0,slicedToArray/* default */.Z)(_useNextFrame, 2),
    nextFrame = _useNextFrame2[0],
    cancelNextFrame = _useNextFrame2[1];
  function startQueue() {
    setStep(STEP_PREPARE, true);
  }
  var STEP_QUEUE = prepareOnly ? SIMPLE_STEP_QUEUE : FULL_STEP_QUEUE;
  hooks_useIsomorphicLayoutEffect(function () {
    if (step !== STEP_NONE && step !== STEP_ACTIVATED) {
      var index = STEP_QUEUE.indexOf(step);
      var nextStep = STEP_QUEUE[index + 1];
      var result = callback(step);
      if (result === SkipStep) {
        // Skip when no needed
        setStep(nextStep, true);
      } else if (nextStep) {
        // Do as frame for step update
        nextFrame(function (info) {
          function doNext() {
            // Skip since current queue is ood
            if (info.isCanceled()) return;
            setStep(nextStep, true);
          }
          if (result === true) {
            doNext();
          } else {
            // Only promise should be async
            Promise.resolve(result).then(doNext);
          }
        });
      }
    }
  }, [status, step]);
  react.useEffect(function () {
    return function () {
      cancelNextFrame();
    };
  }, []);
  return [startQueue, step];
});
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useStatus.js












function useStatus(supportMotion, visible, getElement, _ref) {
  var _ref$motionEnter = _ref.motionEnter,
    motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter,
    _ref$motionAppear = _ref.motionAppear,
    motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear,
    _ref$motionLeave = _ref.motionLeave,
    motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave,
    motionDeadline = _ref.motionDeadline,
    motionLeaveImmediately = _ref.motionLeaveImmediately,
    onAppearPrepare = _ref.onAppearPrepare,
    onEnterPrepare = _ref.onEnterPrepare,
    onLeavePrepare = _ref.onLeavePrepare,
    onAppearStart = _ref.onAppearStart,
    onEnterStart = _ref.onEnterStart,
    onLeaveStart = _ref.onLeaveStart,
    onAppearActive = _ref.onAppearActive,
    onEnterActive = _ref.onEnterActive,
    onLeaveActive = _ref.onLeaveActive,
    onAppearEnd = _ref.onAppearEnd,
    onEnterEnd = _ref.onEnterEnd,
    onLeaveEnd = _ref.onLeaveEnd,
    onVisibleChanged = _ref.onVisibleChanged;
  // Used for outer render usage to avoid `visible: false & status: none` to render nothing
  var _useState = (0,useState/* default */.Z)(),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    asyncVisible = _useState2[0],
    setAsyncVisible = _useState2[1];
  var _useSyncState = useSyncState(STATUS_NONE),
    _useSyncState2 = (0,slicedToArray/* default */.Z)(_useSyncState, 2),
    getStatus = _useSyncState2[0],
    setStatus = _useSyncState2[1];
  var _useState3 = (0,useState/* default */.Z)(null),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    style = _useState4[0],
    setStyle = _useState4[1];
  var currentStatus = getStatus();
  var mountedRef = (0,react.useRef)(false);
  var deadlineRef = (0,react.useRef)(null);

  // =========================== Dom Node ===========================
  function getDomElement() {
    return getElement();
  }

  // ========================== Motion End ==========================
  var activeRef = (0,react.useRef)(false);

  /**
   * Clean up status & style
   */
  function updateMotionEndStatus() {
    setStatus(STATUS_NONE);
    setStyle(null, true);
  }
  var onInternalMotionEnd = (0,es/* useEvent */.zX)(function (event) {
    var status = getStatus();
    // Do nothing since not in any transition status.
    // This may happen when `motionDeadline` trigger.
    if (status === STATUS_NONE) {
      return;
    }
    var element = getDomElement();
    if (event && !event.deadline && event.target !== element) {
      // event exists
      // not initiated by deadline
      // transitionEnd not fired by inner elements
      return;
    }
    var currentActive = activeRef.current;
    var canEnd;
    if (status === STATUS_APPEAR && currentActive) {
      canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
    } else if (status === STATUS_ENTER && currentActive) {
      canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
    } else if (status === STATUS_LEAVE && currentActive) {
      canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
    }

    // Only update status when `canEnd` and not destroyed
    if (currentActive && canEnd !== false) {
      updateMotionEndStatus();
    }
  });
  var _useDomMotionEvents = useDomMotionEvents(onInternalMotionEnd),
    _useDomMotionEvents2 = (0,slicedToArray/* default */.Z)(_useDomMotionEvents, 1),
    patchMotionEvents = _useDomMotionEvents2[0];

  // ============================= Step =============================
  var getEventHandlers = function getEventHandlers(targetStatus) {
    switch (targetStatus) {
      case STATUS_APPEAR:
        return (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, STEP_PREPARE, onAppearPrepare), STEP_START, onAppearStart), STEP_ACTIVE, onAppearActive);
      case STATUS_ENTER:
        return (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, STEP_PREPARE, onEnterPrepare), STEP_START, onEnterStart), STEP_ACTIVE, onEnterActive);
      case STATUS_LEAVE:
        return (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, STEP_PREPARE, onLeavePrepare), STEP_START, onLeaveStart), STEP_ACTIVE, onLeaveActive);
      default:
        return {};
    }
  };
  var eventHandlers = react.useMemo(function () {
    return getEventHandlers(currentStatus);
  }, [currentStatus]);
  var _useStepQueue = useStepQueue(currentStatus, !supportMotion, function (newStep) {
      // Only prepare step can be skip
      if (newStep === STEP_PREPARE) {
        var onPrepare = eventHandlers[STEP_PREPARE];
        if (!onPrepare) {
          return SkipStep;
        }
        return onPrepare(getDomElement());
      }

      // Rest step is sync update
      if (step in eventHandlers) {
        var _eventHandlers$step;
        setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
      }
      if (step === STEP_ACTIVE && currentStatus !== STATUS_NONE) {
        // Patch events when motion needed
        patchMotionEvents(getDomElement());
        if (motionDeadline > 0) {
          clearTimeout(deadlineRef.current);
          deadlineRef.current = setTimeout(function () {
            onInternalMotionEnd({
              deadline: true
            });
          }, motionDeadline);
        }
      }
      if (step === STEP_PREPARED) {
        updateMotionEndStatus();
      }
      return DoStep;
    }),
    _useStepQueue2 = (0,slicedToArray/* default */.Z)(_useStepQueue, 2),
    startStep = _useStepQueue2[0],
    step = _useStepQueue2[1];
  var active = isActive(step);
  activeRef.current = active;

  // ============================ Status ============================
  var visibleRef = (0,react.useRef)(null);

  // Update with new status
  hooks_useIsomorphicLayoutEffect(function () {
    // When use Suspense, the `visible` will repeat trigger,
    // But not real change of the `visible`, we need to skip it.
    // https://github.com/ant-design/ant-design/issues/44379
    if (mountedRef.current && visibleRef.current === visible) {
      return;
    }
    setAsyncVisible(visible);
    var isMounted = mountedRef.current;
    mountedRef.current = true;

    // if (!supportMotion) {
    //   return;
    // }

    var nextStatus;

    // Appear
    if (!isMounted && visible && motionAppear) {
      nextStatus = STATUS_APPEAR;
    }

    // Enter
    if (isMounted && visible && motionEnter) {
      nextStatus = STATUS_ENTER;
    }

    // Leave
    if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) {
      nextStatus = STATUS_LEAVE;
    }
    var nextEventHandlers = getEventHandlers(nextStatus);

    // Update to next status
    if (nextStatus && (supportMotion || nextEventHandlers[STEP_PREPARE])) {
      setStatus(nextStatus);
      startStep();
    } else {
      // Set back in case no motion but prev status has prepare step
      setStatus(STATUS_NONE);
    }
    visibleRef.current = visible;
  }, [visible]);

  // ============================ Effect ============================
  // Reset when motion changed
  (0,react.useEffect)(function () {
    if (
    // Cancel appear
    currentStatus === STATUS_APPEAR && !motionAppear ||
    // Cancel enter
    currentStatus === STATUS_ENTER && !motionEnter ||
    // Cancel leave
    currentStatus === STATUS_LEAVE && !motionLeave) {
      setStatus(STATUS_NONE);
    }
  }, [motionAppear, motionEnter, motionLeave]);
  (0,react.useEffect)(function () {
    return function () {
      mountedRef.current = false;
      clearTimeout(deadlineRef.current);
    };
  }, []);

  // Trigger `onVisibleChanged`
  var firstMountChangeRef = react.useRef(false);
  (0,react.useEffect)(function () {
    // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
    if (asyncVisible) {
      firstMountChangeRef.current = true;
    }
    if (asyncVisible !== undefined && currentStatus === STATUS_NONE) {
      // Skip first render is invisible since it's nothing changed
      if (firstMountChangeRef.current || asyncVisible) {
        onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
      }
      firstMountChangeRef.current = true;
    }
  }, [asyncVisible, currentStatus]);

  // ============================ Styles ============================
  var mergedStyle = style;
  if (eventHandlers[STEP_PREPARE] && step === STEP_START) {
    mergedStyle = (0,objectSpread2/* default */.Z)({
      transition: 'none'
    }, mergedStyle);
  }
  return [currentStatus, step, mergedStyle, asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible];
}
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/CSSMotion.js




/* eslint-disable react/default-props-match-prop-types, react/no-multi-comp, react/prop-types */











/**
 * `transitionSupport` is used for none transition test case.
 * Default we use browser transition event support check.
 */
function genCSSMotion(config) {
  var transitionSupport = config;
  if ((0,esm_typeof/* default */.Z)(config) === 'object') {
    transitionSupport = config.transitionSupport;
  }
  function isSupportTransition(props, contextMotion) {
    return !!(props.motionName && transitionSupport && contextMotion !== false);
  }
  var CSSMotion = /*#__PURE__*/react.forwardRef(function (props, ref) {
    var _props$visible = props.visible,
      visible = _props$visible === void 0 ? true : _props$visible,
      _props$removeOnLeave = props.removeOnLeave,
      removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave,
      forceRender = props.forceRender,
      children = props.children,
      motionName = props.motionName,
      leavedClassName = props.leavedClassName,
      eventProps = props.eventProps;
    var _React$useContext = react.useContext(Context),
      contextMotion = _React$useContext.motion;
    var supportMotion = isSupportTransition(props, contextMotion);

    // Ref to the react node, it may be a HTMLElement
    var nodeRef = (0,react.useRef)();
    // Ref to the dom wrapper in case ref can not pass to HTMLElement
    var wrapperNodeRef = (0,react.useRef)();
    function getDomElement() {
      try {
        // Here we're avoiding call for findDOMNode since it's deprecated
        // in strict mode. We're calling it only when node ref is not
        // an instance of DOM HTMLElement. Otherwise use
        // findDOMNode as a final resort
        return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0,findDOMNode/* default */.ZP)(wrapperNodeRef.current);
      } catch (e) {
        // Only happen when `motionDeadline` trigger but element removed.
        return null;
      }
    }
    var _useStatus = useStatus(supportMotion, visible, getDomElement, props),
      _useStatus2 = (0,slicedToArray/* default */.Z)(_useStatus, 4),
      status = _useStatus2[0],
      statusStep = _useStatus2[1],
      statusStyle = _useStatus2[2],
      mergedVisible = _useStatus2[3];

    // Record whether content has rendered
    // Will return null for un-rendered even when `removeOnLeave={false}`
    var renderedRef = react.useRef(mergedVisible);
    if (mergedVisible) {
      renderedRef.current = true;
    }

    // ====================== Refs ======================
    var setNodeRef = react.useCallback(function (node) {
      nodeRef.current = node;
      (0,es_ref/* fillRef */.mH)(ref, node);
    }, [ref]);

    // ===================== Render =====================
    var motionChildren;
    var mergedProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, eventProps), {}, {
      visible: visible
    });
    if (!children) {
      // No children
      motionChildren = null;
    } else if (status === STATUS_NONE) {
      // Stable children
      if (mergedVisible) {
        motionChildren = children((0,objectSpread2/* default */.Z)({}, mergedProps), setNodeRef);
      } else if (!removeOnLeave && renderedRef.current && leavedClassName) {
        motionChildren = children((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, mergedProps), {}, {
          className: leavedClassName
        }), setNodeRef);
      } else if (forceRender || !removeOnLeave && !leavedClassName) {
        motionChildren = children((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, mergedProps), {}, {
          style: {
            display: 'none'
          }
        }), setNodeRef);
      } else {
        motionChildren = null;
      }
    } else {
      // In motion
      var statusSuffix;
      if (statusStep === STEP_PREPARE) {
        statusSuffix = 'prepare';
      } else if (isActive(statusStep)) {
        statusSuffix = 'active';
      } else if (statusStep === STEP_START) {
        statusSuffix = 'start';
      }
      var motionCls = getTransitionName(motionName, "".concat(status, "-").concat(statusSuffix));
      motionChildren = children((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, mergedProps), {}, {
        className: classnames_default()(getTransitionName(motionName, status), (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === 'string')),
        style: statusStyle
      }), setNodeRef);
    }

    // Auto inject ref if child node not have `ref` props
    if (/*#__PURE__*/react.isValidElement(motionChildren) && (0,es_ref/* supportRef */.Yr)(motionChildren)) {
      var originNodeRef = (0,es_ref/* getNodeRef */.C4)(motionChildren);
      if (!originNodeRef) {
        motionChildren = /*#__PURE__*/react.cloneElement(motionChildren, {
          ref: setNodeRef
        });
      }
    }
    return /*#__PURE__*/react.createElement(es_DomWrapper, {
      ref: wrapperNodeRef
    }, motionChildren);
  });
  CSSMotion.displayName = 'CSSMotion';
  return CSSMotion;
}
/* harmony default export */ var es_CSSMotion = (genCSSMotion(supportTransition));
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(88569);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/util/diff.js


var STATUS_ADD = 'add';
var STATUS_KEEP = 'keep';
var STATUS_REMOVE = 'remove';
var STATUS_REMOVED = 'removed';
function wrapKeyToObject(key) {
  var keyObj;
  if (key && (0,esm_typeof/* default */.Z)(key) === 'object' && 'key' in key) {
    keyObj = key;
  } else {
    keyObj = {
      key: key
    };
  }
  return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, keyObj), {}, {
    key: String(keyObj.key)
  });
}
function parseKeys() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return keys.map(wrapKeyToObject);
}
function diffKeys() {
  var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var list = [];
  var currentIndex = 0;
  var currentLen = currentKeys.length;
  var prevKeyObjects = parseKeys(prevKeys);
  var currentKeyObjects = parseKeys(currentKeys);

  // Check prev keys to insert or keep
  prevKeyObjects.forEach(function (keyObj) {
    var hit = false;
    for (var i = currentIndex; i < currentLen; i += 1) {
      var currentKeyObj = currentKeyObjects[i];
      if (currentKeyObj.key === keyObj.key) {
        // New added keys should add before current key
        if (currentIndex < i) {
          list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function (obj) {
            return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, obj), {}, {
              status: STATUS_ADD
            });
          }));
          currentIndex = i;
        }
        list.push((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, currentKeyObj), {}, {
          status: STATUS_KEEP
        }));
        currentIndex += 1;
        hit = true;
        break;
      }
    }

    // If not hit, it means key is removed
    if (!hit) {
      list.push((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, keyObj), {}, {
        status: STATUS_REMOVE
      }));
    }
  });

  // Add rest to the list
  if (currentIndex < currentLen) {
    list = list.concat(currentKeyObjects.slice(currentIndex).map(function (obj) {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, obj), {}, {
        status: STATUS_ADD
      });
    }));
  }

  /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */
  var keys = {};
  list.forEach(function (_ref) {
    var key = _ref.key;
    keys[key] = (keys[key] || 0) + 1;
  });
  var duplicatedKeys = Object.keys(keys).filter(function (key) {
    return keys[key] > 1;
  });
  duplicatedKeys.forEach(function (matchKey) {
    // Remove `STATUS_REMOVE` node.
    list = list.filter(function (_ref2) {
      var key = _ref2.key,
        status = _ref2.status;
      return key !== matchKey || status !== STATUS_REMOVE;
    });

    // Update `STATUS_ADD` to `STATUS_KEEP`
    list.forEach(function (node) {
      if (node.key === matchKey) {
        // eslint-disable-next-line no-param-reassign
        node.status = STATUS_KEEP;
      }
    });
  });
  return list;
}
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/CSSMotionList.js









var CSSMotionList_excluded = ["component", "children", "onVisibleChanged", "onAllRemoved"],
  _excluded2 = ["status"];
/* eslint react/prop-types: 0 */




var MOTION_PROP_NAMES = ['eventProps', 'visible', 'children', 'motionName', 'motionAppear', 'motionEnter', 'motionLeave', 'motionLeaveImmediately', 'motionDeadline', 'removeOnLeave', 'leavedClassName', 'onAppearPrepare', 'onAppearStart', 'onAppearActive', 'onAppearEnd', 'onEnterStart', 'onEnterActive', 'onEnterEnd', 'onLeaveStart', 'onLeaveActive', 'onLeaveEnd'];
/**
 * Generate a CSSMotionList component with config
 * @param transitionSupport No need since CSSMotionList no longer depends on transition support
 * @param CSSMotion CSSMotion component
 */
function genCSSMotionList(transitionSupport) {
  var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : es_CSSMotion;
  var CSSMotionList = /*#__PURE__*/function (_React$Component) {
    (0,inherits/* default */.Z)(CSSMotionList, _React$Component);
    var _super = (0,createSuper/* default */.Z)(CSSMotionList);
    function CSSMotionList() {
      var _this;
      (0,classCallCheck/* default */.Z)(this, CSSMotionList);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "state", {
        keyEntities: []
      });
      // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
      (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "removeKey", function (removeKey) {
        _this.setState(function (prevState) {
          var nextKeyEntities = prevState.keyEntities.map(function (entity) {
            if (entity.key !== removeKey) return entity;
            return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, entity), {}, {
              status: STATUS_REMOVED
            });
          });
          return {
            keyEntities: nextKeyEntities
          };
        }, function () {
          var keyEntities = _this.state.keyEntities;
          var restKeysCount = keyEntities.filter(function (_ref) {
            var status = _ref.status;
            return status !== STATUS_REMOVED;
          }).length;
          if (restKeysCount === 0 && _this.props.onAllRemoved) {
            _this.props.onAllRemoved();
          }
        });
      });
      return _this;
    }
    (0,createClass/* default */.Z)(CSSMotionList, [{
      key: "render",
      value: function render() {
        var _this2 = this;
        var keyEntities = this.state.keyEntities;
        var _this$props = this.props,
          component = _this$props.component,
          children = _this$props.children,
          _onVisibleChanged = _this$props.onVisibleChanged,
          onAllRemoved = _this$props.onAllRemoved,
          restProps = (0,objectWithoutProperties/* default */.Z)(_this$props, CSSMotionList_excluded);
        var Component = component || react.Fragment;
        var motionProps = {};
        MOTION_PROP_NAMES.forEach(function (prop) {
          motionProps[prop] = restProps[prop];
          delete restProps[prop];
        });
        delete restProps.keys;
        return /*#__PURE__*/react.createElement(Component, restProps, keyEntities.map(function (_ref2, index) {
          var status = _ref2.status,
            eventProps = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded2);
          var visible = status === STATUS_ADD || status === STATUS_KEEP;
          return /*#__PURE__*/react.createElement(CSSMotion, (0,esm_extends/* default */.Z)({}, motionProps, {
            key: eventProps.key,
            visible: visible,
            eventProps: eventProps,
            onVisibleChanged: function onVisibleChanged(changedVisible) {
              _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                key: eventProps.key
              });
              if (!changedVisible) {
                _this2.removeKey(eventProps.key);
              }
            }
          }), function (props, ref) {
            return children((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
              index: index
            }), ref);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref3, _ref4) {
        var keys = _ref3.keys;
        var keyEntities = _ref4.keyEntities;
        var parsedKeyObjects = parseKeys(keys);
        var mixedKeyEntities = diffKeys(keyEntities, parsedKeyObjects);
        return {
          keyEntities: mixedKeyEntities.filter(function (entity) {
            var prevEntity = keyEntities.find(function (_ref5) {
              var key = _ref5.key;
              return entity.key === key;
            });

            // Remove if already mark as removed
            if (prevEntity && prevEntity.status === STATUS_REMOVED && entity.status === STATUS_REMOVE) {
              return false;
            }
            return true;
          })
        };
      }
    }]);
    return CSSMotionList;
  }(react.Component);
  (0,defineProperty/* default */.Z)(CSSMotionList, "defaultProps", {
    component: 'div'
  });
  return CSSMotionList;
}
/* harmony default export */ var CSSMotionList = (genCSSMotionList(supportTransition));
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/index.js




/* harmony default export */ var rc_motion_es = (es_CSSMotion);

/***/ }),

/***/ 34260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qX": function() { return /* reexport */ Notice; },
  "JB": function() { return /* reexport */ es_NotificationProvider; },
  "lm": function() { return /* reexport */ useNotification; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(85202);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-motion/es/index.js + 13 modules
var es = __webpack_require__(26981);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js
var KeyCode = __webpack_require__(88035);
// EXTERNAL MODULE: ./node_modules/rc-util/es/pickAttrs.js
var pickAttrs = __webpack_require__(75844);
;// CONCATENATED MODULE: ./node_modules/rc-notification/es/Notice.js








var Notify = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    style = props.style,
    className = props.className,
    _props$duration = props.duration,
    duration = _props$duration === void 0 ? 4.5 : _props$duration,
    showProgress = props.showProgress,
    _props$pauseOnHover = props.pauseOnHover,
    pauseOnHover = _props$pauseOnHover === void 0 ? true : _props$pauseOnHover,
    eventKey = props.eventKey,
    content = props.content,
    closable = props.closable,
    _props$closeIcon = props.closeIcon,
    closeIcon = _props$closeIcon === void 0 ? 'x' : _props$closeIcon,
    divProps = props.props,
    onClick = props.onClick,
    onNoticeClose = props.onNoticeClose,
    times = props.times,
    forcedHovering = props.hovering;
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    hovering = _React$useState2[0],
    setHovering = _React$useState2[1];
  var _React$useState3 = react.useState(0),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    percent = _React$useState4[0],
    setPercent = _React$useState4[1];
  var _React$useState5 = react.useState(0),
    _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
    spentTime = _React$useState6[0],
    setSpentTime = _React$useState6[1];
  var mergedHovering = forcedHovering || hovering;
  var mergedShowProgress = duration > 0 && showProgress;

  // ======================== Close =========================
  var onInternalClose = function onInternalClose() {
    onNoticeClose(eventKey);
  };
  var onCloseKeyDown = function onCloseKeyDown(e) {
    if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === KeyCode/* default.ENTER */.Z.ENTER) {
      onInternalClose();
    }
  };

  // ======================== Effect ========================
  react.useEffect(function () {
    if (!mergedHovering && duration > 0) {
      var start = Date.now() - spentTime;
      var timeout = setTimeout(function () {
        onInternalClose();
      }, duration * 1000 - spentTime);
      return function () {
        if (pauseOnHover) {
          clearTimeout(timeout);
        }
        setSpentTime(Date.now() - start);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [duration, mergedHovering, times]);
  react.useEffect(function () {
    if (!mergedHovering && mergedShowProgress && (pauseOnHover || spentTime === 0)) {
      var start = performance.now();
      var animationFrame;
      var calculate = function calculate() {
        cancelAnimationFrame(animationFrame);
        animationFrame = requestAnimationFrame(function (timestamp) {
          var runtime = timestamp + spentTime - start;
          var progress = Math.min(runtime / (duration * 1000), 1);
          setPercent(progress * 100);
          if (progress < 1) {
            calculate();
          }
        });
      };
      calculate();
      return function () {
        if (pauseOnHover) {
          cancelAnimationFrame(animationFrame);
        }
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [duration, spentTime, mergedHovering, mergedShowProgress, times]);

  // ======================== Closable ========================
  var closableObj = react.useMemo(function () {
    if ((0,esm_typeof/* default */.Z)(closable) === 'object' && closable !== null) {
      return closable;
    }
    if (closable) {
      return {
        closeIcon: closeIcon
      };
    }
    return {};
  }, [closable, closeIcon]);
  var ariaProps = (0,pickAttrs/* default */.Z)(closableObj, true);

  // ======================== Progress ========================
  var validPercent = 100 - (!percent || percent < 0 ? 0 : percent > 100 ? 100 : percent);

  // ======================== Render ========================
  var noticePrefixCls = "".concat(prefixCls, "-notice");
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, divProps, {
    ref: ref,
    className: classnames_default()(noticePrefixCls, className, (0,defineProperty/* default */.Z)({}, "".concat(noticePrefixCls, "-closable"), closable)),
    style: style,
    onMouseEnter: function onMouseEnter(e) {
      var _divProps$onMouseEnte;
      setHovering(true);
      divProps === null || divProps === void 0 || (_divProps$onMouseEnte = divProps.onMouseEnter) === null || _divProps$onMouseEnte === void 0 || _divProps$onMouseEnte.call(divProps, e);
    },
    onMouseLeave: function onMouseLeave(e) {
      var _divProps$onMouseLeav;
      setHovering(false);
      divProps === null || divProps === void 0 || (_divProps$onMouseLeav = divProps.onMouseLeave) === null || _divProps$onMouseLeav === void 0 || _divProps$onMouseLeav.call(divProps, e);
    },
    onClick: onClick
  }), /*#__PURE__*/react.createElement("div", {
    className: "".concat(noticePrefixCls, "-content")
  }, content), closable && /*#__PURE__*/react.createElement("a", (0,esm_extends/* default */.Z)({
    tabIndex: 0,
    className: "".concat(noticePrefixCls, "-close"),
    onKeyDown: onCloseKeyDown,
    "aria-label": "Close"
  }, ariaProps, {
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      onInternalClose();
    }
  }), closableObj.closeIcon), mergedShowProgress && /*#__PURE__*/react.createElement("progress", {
    className: "".concat(noticePrefixCls, "-progress"),
    max: "100",
    value: validPercent
  }, validPercent + '%'));
});
/* harmony default export */ var Notice = (Notify);
;// CONCATENATED MODULE: ./node_modules/rc-notification/es/NotificationProvider.js

var NotificationContext = /*#__PURE__*/react.createContext({});
var NotificationProvider = function NotificationProvider(_ref) {
  var children = _ref.children,
    classNames = _ref.classNames;
  return /*#__PURE__*/react.createElement(NotificationContext.Provider, {
    value: {
      classNames: classNames
    }
  }, children);
};
/* harmony default export */ var es_NotificationProvider = (NotificationProvider);
;// CONCATENATED MODULE: ./node_modules/rc-notification/es/hooks/useStack.js

var DEFAULT_OFFSET = 8;
var DEFAULT_THRESHOLD = 3;
var DEFAULT_GAP = 16;
var useStack = function useStack(config) {
  var result = {
    offset: DEFAULT_OFFSET,
    threshold: DEFAULT_THRESHOLD,
    gap: DEFAULT_GAP
  };
  if (config && (0,esm_typeof/* default */.Z)(config) === 'object') {
    var _config$offset, _config$threshold, _config$gap;
    result.offset = (_config$offset = config.offset) !== null && _config$offset !== void 0 ? _config$offset : DEFAULT_OFFSET;
    result.threshold = (_config$threshold = config.threshold) !== null && _config$threshold !== void 0 ? _config$threshold : DEFAULT_THRESHOLD;
    result.gap = (_config$gap = config.gap) !== null && _config$gap !== void 0 ? _config$gap : DEFAULT_GAP;
  }
  return [!!config, result];
};
/* harmony default export */ var hooks_useStack = (useStack);
;// CONCATENATED MODULE: ./node_modules/rc-notification/es/NoticeList.js






var _excluded = ["className", "style", "classNames", "styles"];






var NoticeList = function NoticeList(props) {
  var configList = props.configList,
    placement = props.placement,
    prefixCls = props.prefixCls,
    className = props.className,
    style = props.style,
    motion = props.motion,
    onAllNoticeRemoved = props.onAllNoticeRemoved,
    onNoticeClose = props.onNoticeClose,
    stackConfig = props.stack;
  var _useContext = (0,react.useContext)(NotificationContext),
    ctxCls = _useContext.classNames;
  var dictRef = (0,react.useRef)({});
  var _useState = (0,react.useState)(null),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    latestNotice = _useState2[0],
    setLatestNotice = _useState2[1];
  var _useState3 = (0,react.useState)([]),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    hoverKeys = _useState4[0],
    setHoverKeys = _useState4[1];
  var keys = configList.map(function (config) {
    return {
      config: config,
      key: String(config.key)
    };
  });
  var _useStack = hooks_useStack(stackConfig),
    _useStack2 = (0,slicedToArray/* default */.Z)(_useStack, 2),
    stack = _useStack2[0],
    _useStack2$ = _useStack2[1],
    offset = _useStack2$.offset,
    threshold = _useStack2$.threshold,
    gap = _useStack2$.gap;
  var expanded = stack && (hoverKeys.length > 0 || keys.length <= threshold);
  var placementMotion = typeof motion === 'function' ? motion(placement) : motion;

  // Clean hover key
  (0,react.useEffect)(function () {
    if (stack && hoverKeys.length > 1) {
      setHoverKeys(function (prev) {
        return prev.filter(function (key) {
          return keys.some(function (_ref) {
            var dataKey = _ref.key;
            return key === dataKey;
          });
        });
      });
    }
  }, [hoverKeys, keys, stack]);

  // Force update latest notice
  (0,react.useEffect)(function () {
    var _keys;
    if (stack && dictRef.current[(_keys = keys[keys.length - 1]) === null || _keys === void 0 ? void 0 : _keys.key]) {
      var _keys2;
      setLatestNotice(dictRef.current[(_keys2 = keys[keys.length - 1]) === null || _keys2 === void 0 ? void 0 : _keys2.key]);
    }
  }, [keys, stack]);
  return /*#__PURE__*/react.createElement(es/* CSSMotionList */.V4, (0,esm_extends/* default */.Z)({
    key: placement,
    className: classnames_default()(prefixCls, "".concat(prefixCls, "-").concat(placement), ctxCls === null || ctxCls === void 0 ? void 0 : ctxCls.list, className, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-stack"), !!stack), "".concat(prefixCls, "-stack-expanded"), expanded)),
    style: style,
    keys: keys,
    motionAppear: true
  }, placementMotion, {
    onAllRemoved: function onAllRemoved() {
      onAllNoticeRemoved(placement);
    }
  }), function (_ref2, nodeRef) {
    var config = _ref2.config,
      motionClassName = _ref2.className,
      motionStyle = _ref2.style,
      motionIndex = _ref2.index;
    var _ref3 = config,
      key = _ref3.key,
      times = _ref3.times;
    var strKey = String(key);
    var _ref4 = config,
      configClassName = _ref4.className,
      configStyle = _ref4.style,
      configClassNames = _ref4.classNames,
      configStyles = _ref4.styles,
      restConfig = (0,objectWithoutProperties/* default */.Z)(_ref4, _excluded);
    var dataIndex = keys.findIndex(function (item) {
      return item.key === strKey;
    });

    // If dataIndex is -1, that means this notice has been removed in data, but still in dom
    // Should minus (motionIndex - 1) to get the correct index because keys.length is not the same as dom length
    var stackStyle = {};
    if (stack) {
      var index = keys.length - 1 - (dataIndex > -1 ? dataIndex : motionIndex - 1);
      var transformX = placement === 'top' || placement === 'bottom' ? '-50%' : '0';
      if (index > 0) {
        var _dictRef$current$strK, _dictRef$current$strK2, _dictRef$current$strK3;
        stackStyle.height = expanded ? (_dictRef$current$strK = dictRef.current[strKey]) === null || _dictRef$current$strK === void 0 ? void 0 : _dictRef$current$strK.offsetHeight : latestNotice === null || latestNotice === void 0 ? void 0 : latestNotice.offsetHeight;

        // Transform
        var verticalOffset = 0;
        for (var i = 0; i < index; i++) {
          var _dictRef$current$keys;
          verticalOffset += ((_dictRef$current$keys = dictRef.current[keys[keys.length - 1 - i].key]) === null || _dictRef$current$keys === void 0 ? void 0 : _dictRef$current$keys.offsetHeight) + gap;
        }
        var transformY = (expanded ? verticalOffset : index * offset) * (placement.startsWith('top') ? 1 : -1);
        var scaleX = !expanded && latestNotice !== null && latestNotice !== void 0 && latestNotice.offsetWidth && (_dictRef$current$strK2 = dictRef.current[strKey]) !== null && _dictRef$current$strK2 !== void 0 && _dictRef$current$strK2.offsetWidth ? ((latestNotice === null || latestNotice === void 0 ? void 0 : latestNotice.offsetWidth) - offset * 2 * (index < 3 ? index : 3)) / ((_dictRef$current$strK3 = dictRef.current[strKey]) === null || _dictRef$current$strK3 === void 0 ? void 0 : _dictRef$current$strK3.offsetWidth) : 1;
        stackStyle.transform = "translate3d(".concat(transformX, ", ").concat(transformY, "px, 0) scaleX(").concat(scaleX, ")");
      } else {
        stackStyle.transform = "translate3d(".concat(transformX, ", 0, 0)");
      }
    }
    return /*#__PURE__*/react.createElement("div", {
      ref: nodeRef,
      className: classnames_default()("".concat(prefixCls, "-notice-wrapper"), motionClassName, configClassNames === null || configClassNames === void 0 ? void 0 : configClassNames.wrapper),
      style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, motionStyle), stackStyle), configStyles === null || configStyles === void 0 ? void 0 : configStyles.wrapper),
      onMouseEnter: function onMouseEnter() {
        return setHoverKeys(function (prev) {
          return prev.includes(strKey) ? prev : [].concat((0,toConsumableArray/* default */.Z)(prev), [strKey]);
        });
      },
      onMouseLeave: function onMouseLeave() {
        return setHoverKeys(function (prev) {
          return prev.filter(function (k) {
            return k !== strKey;
          });
        });
      }
    }, /*#__PURE__*/react.createElement(Notice, (0,esm_extends/* default */.Z)({}, restConfig, {
      ref: function ref(node) {
        if (dataIndex > -1) {
          dictRef.current[strKey] = node;
        } else {
          delete dictRef.current[strKey];
        }
      },
      prefixCls: prefixCls,
      classNames: configClassNames,
      styles: configStyles,
      className: classnames_default()(configClassName, ctxCls === null || ctxCls === void 0 ? void 0 : ctxCls.notice),
      style: configStyle,
      times: times,
      key: key,
      eventKey: key,
      onNoticeClose: onNoticeClose,
      hovering: stack && hoverKeys.length > 0
    })));
  });
};
if (false) {}
/* harmony default export */ var es_NoticeList = (NoticeList);
;// CONCATENATED MODULE: ./node_modules/rc-notification/es/Notifications.js






// ant-notification ant-notification-topRight
var Notifications = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-notification' : _props$prefixCls,
    container = props.container,
    motion = props.motion,
    maxCount = props.maxCount,
    className = props.className,
    style = props.style,
    onAllRemoved = props.onAllRemoved,
    stack = props.stack,
    renderNotifications = props.renderNotifications;
  var _React$useState = react.useState([]),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    configList = _React$useState2[0],
    setConfigList = _React$useState2[1];

  // ======================== Close =========================
  var onNoticeClose = function onNoticeClose(key) {
    var _config$onClose;
    // Trigger close event
    var config = configList.find(function (item) {
      return item.key === key;
    });
    config === null || config === void 0 || (_config$onClose = config.onClose) === null || _config$onClose === void 0 || _config$onClose.call(config);
    setConfigList(function (list) {
      return list.filter(function (item) {
        return item.key !== key;
      });
    });
  };

  // ========================= Refs =========================
  react.useImperativeHandle(ref, function () {
    return {
      open: function open(config) {
        setConfigList(function (list) {
          var clone = (0,toConsumableArray/* default */.Z)(list);

          // Replace if exist
          var index = clone.findIndex(function (item) {
            return item.key === config.key;
          });
          var innerConfig = (0,objectSpread2/* default */.Z)({}, config);
          if (index >= 0) {
            var _list$index;
            innerConfig.times = (((_list$index = list[index]) === null || _list$index === void 0 ? void 0 : _list$index.times) || 0) + 1;
            clone[index] = innerConfig;
          } else {
            innerConfig.times = 0;
            clone.push(innerConfig);
          }
          if (maxCount > 0 && clone.length > maxCount) {
            clone = clone.slice(-maxCount);
          }
          return clone;
        });
      },
      close: function close(key) {
        onNoticeClose(key);
      },
      destroy: function destroy() {
        setConfigList([]);
      }
    };
  });

  // ====================== Placements ======================
  var _React$useState3 = react.useState({}),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    placements = _React$useState4[0],
    setPlacements = _React$useState4[1];
  react.useEffect(function () {
    var nextPlacements = {};
    configList.forEach(function (config) {
      var _config$placement = config.placement,
        placement = _config$placement === void 0 ? 'topRight' : _config$placement;
      if (placement) {
        nextPlacements[placement] = nextPlacements[placement] || [];
        nextPlacements[placement].push(config);
      }
    });

    // Fill exist placements to avoid empty list causing remove without motion
    Object.keys(placements).forEach(function (placement) {
      nextPlacements[placement] = nextPlacements[placement] || [];
    });
    setPlacements(nextPlacements);
  }, [configList]);

  // Clean up container if all notices fade out
  var onAllNoticeRemoved = function onAllNoticeRemoved(placement) {
    setPlacements(function (originPlacements) {
      var clone = (0,objectSpread2/* default */.Z)({}, originPlacements);
      var list = clone[placement] || [];
      if (!list.length) {
        delete clone[placement];
      }
      return clone;
    });
  };

  // Effect tell that placements is empty now
  var emptyRef = react.useRef(false);
  react.useEffect(function () {
    if (Object.keys(placements).length > 0) {
      emptyRef.current = true;
    } else if (emptyRef.current) {
      // Trigger only when from exist to empty
      onAllRemoved === null || onAllRemoved === void 0 || onAllRemoved();
      emptyRef.current = false;
    }
  }, [placements]);
  // ======================== Render ========================
  if (!container) {
    return null;
  }
  var placementList = Object.keys(placements);
  return /*#__PURE__*/(0,react_dom.createPortal)(/*#__PURE__*/react.createElement(react.Fragment, null, placementList.map(function (placement) {
    var placementConfigList = placements[placement];
    var list = /*#__PURE__*/react.createElement(es_NoticeList, {
      key: placement,
      configList: placementConfigList,
      placement: placement,
      prefixCls: prefixCls,
      className: className === null || className === void 0 ? void 0 : className(placement),
      style: style === null || style === void 0 ? void 0 : style(placement),
      motion: motion,
      onNoticeClose: onNoticeClose,
      onAllNoticeRemoved: onAllNoticeRemoved,
      stack: stack
    });
    return renderNotifications ? renderNotifications(list, {
      prefixCls: prefixCls,
      key: placement
    }) : list;
  })), container);
});
if (false) {}
/* harmony default export */ var es_Notifications = (Notifications);
// EXTERNAL MODULE: ./node_modules/rc-util/es/index.js
var rc_util_es = __webpack_require__(57433);
;// CONCATENATED MODULE: ./node_modules/rc-notification/es/hooks/useNotification.js



var useNotification_excluded = ["getContainer", "motion", "prefixCls", "maxCount", "className", "style", "onAllRemoved", "stack", "renderNotifications"];



var defaultGetContainer = function defaultGetContainer() {
  return document.body;
};
var uniqueKey = 0;
function mergeConfig() {
  var clone = {};
  for (var _len = arguments.length, objList = new Array(_len), _key = 0; _key < _len; _key++) {
    objList[_key] = arguments[_key];
  }
  objList.forEach(function (obj) {
    if (obj) {
      Object.keys(obj).forEach(function (key) {
        var val = obj[key];
        if (val !== undefined) {
          clone[key] = val;
        }
      });
    }
  });
  return clone;
}
function useNotification() {
  var rootConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _rootConfig$getContai = rootConfig.getContainer,
    getContainer = _rootConfig$getContai === void 0 ? defaultGetContainer : _rootConfig$getContai,
    motion = rootConfig.motion,
    prefixCls = rootConfig.prefixCls,
    maxCount = rootConfig.maxCount,
    className = rootConfig.className,
    style = rootConfig.style,
    onAllRemoved = rootConfig.onAllRemoved,
    stack = rootConfig.stack,
    renderNotifications = rootConfig.renderNotifications,
    shareConfig = (0,objectWithoutProperties/* default */.Z)(rootConfig, useNotification_excluded);
  var _React$useState = react.useState(),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    container = _React$useState2[0],
    setContainer = _React$useState2[1];
  var notificationsRef = react.useRef();
  var contextHolder = /*#__PURE__*/react.createElement(es_Notifications, {
    container: container,
    ref: notificationsRef,
    prefixCls: prefixCls,
    motion: motion,
    maxCount: maxCount,
    className: className,
    style: style,
    onAllRemoved: onAllRemoved,
    stack: stack,
    renderNotifications: renderNotifications
  });
  var _React$useState3 = react.useState([]),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    taskQueue = _React$useState4[0],
    setTaskQueue = _React$useState4[1];
  var open = (0,rc_util_es/* useEvent */.zX)(function (config) {
    var mergedConfig = mergeConfig(shareConfig, config);
    if (mergedConfig.key === null || mergedConfig.key === undefined) {
      mergedConfig.key = "rc-notification-".concat(uniqueKey);
      uniqueKey += 1;
    }
    setTaskQueue(function (queue) {
      return [].concat((0,toConsumableArray/* default */.Z)(queue), [{
        type: 'open',
        config: mergedConfig
      }]);
    });
  });

  // ========================= Refs =========================
  var api = react.useMemo(function () {
    return {
      open: open,
      close: function close(key) {
        setTaskQueue(function (queue) {
          return [].concat((0,toConsumableArray/* default */.Z)(queue), [{
            type: 'close',
            key: key
          }]);
        });
      },
      destroy: function destroy() {
        setTaskQueue(function (queue) {
          return [].concat((0,toConsumableArray/* default */.Z)(queue), [{
            type: 'destroy'
          }]);
        });
      }
    };
  }, []);

  // ======================= Container ======================
  // React 18 should all in effect that we will check container in each render
  // Which means getContainer should be stable.
  react.useEffect(function () {
    setContainer(getContainer());
  });

  // ======================== Effect ========================
  react.useEffect(function () {
    // Flush task when node ready
    if (notificationsRef.current && taskQueue.length) {
      taskQueue.forEach(function (task) {
        switch (task.type) {
          case 'open':
            notificationsRef.current.open(task.config);
            break;
          case 'close':
            notificationsRef.current.close(task.key);
            break;
          case 'destroy':
            notificationsRef.current.destroy();
            break;
        }
      });

      // https://github.com/ant-design/ant-design/issues/52590
      // React `startTransition` will run once `useEffect` but many times `setState`,
      // So `setTaskQueue` with filtered array will cause infinite loop.
      // We cache the first match queue instead.
      var oriTaskQueue;
      var tgtTaskQueue;

      // React 17 will mix order of effect & setState in async
      // - open: setState[0]
      // - effect[0]
      // - open: setState[1]
      // - effect setState([]) * here will clean up [0, 1] in React 17
      setTaskQueue(function (oriQueue) {
        if (oriTaskQueue !== oriQueue || !tgtTaskQueue) {
          oriTaskQueue = oriQueue;
          tgtTaskQueue = oriQueue.filter(function (task) {
            return !taskQueue.includes(task);
          });
        }
        return tgtTaskQueue;
      });
    }
  }, [taskQueue]);

  // ======================== Return ========================
  return [api, contextHolder];
}
;// CONCATENATED MODULE: ./node_modules/rc-notification/es/index.js





/***/ }),

/***/ 16344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ rc_overflow_es; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-resize-observer/es/index.js + 4 modules
var es = __webpack_require__(49938);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useLayoutEffect.js
var useLayoutEffect = __webpack_require__(76963);
;// CONCATENATED MODULE: ./node_modules/rc-overflow/es/Item.js



var _excluded = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"];



// Use shared variable to save bundle size
var UNDEFINED = undefined;
function InternalItem(props, ref) {
  var prefixCls = props.prefixCls,
    invalidate = props.invalidate,
    item = props.item,
    renderItem = props.renderItem,
    responsive = props.responsive,
    responsiveDisabled = props.responsiveDisabled,
    registerSize = props.registerSize,
    itemKey = props.itemKey,
    className = props.className,
    style = props.style,
    children = props.children,
    display = props.display,
    order = props.order,
    _props$component = props.component,
    Component = _props$component === void 0 ? 'div' : _props$component,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded);
  var mergedHidden = responsive && !display;

  // ================================ Effect ================================
  function internalRegisterSize(width) {
    registerSize(itemKey, width);
  }
  react.useEffect(function () {
    return function () {
      internalRegisterSize(null);
    };
  }, []);

  // ================================ Render ================================
  var childNode = renderItem && item !== UNDEFINED ? renderItem(item, {
    index: order
  }) : children;
  var overflowStyle;
  if (!invalidate) {
    overflowStyle = {
      opacity: mergedHidden ? 0 : 1,
      height: mergedHidden ? 0 : UNDEFINED,
      overflowY: mergedHidden ? 'hidden' : UNDEFINED,
      order: responsive ? order : UNDEFINED,
      pointerEvents: mergedHidden ? 'none' : UNDEFINED,
      position: mergedHidden ? 'absolute' : UNDEFINED
    };
  }
  var overflowProps = {};
  if (mergedHidden) {
    overflowProps['aria-hidden'] = true;
  }
  var itemNode = /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    className: classnames_default()(!invalidate && prefixCls, className),
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, overflowStyle), style)
  }, overflowProps, restProps, {
    ref: ref
  }), childNode);
  if (responsive) {
    itemNode = /*#__PURE__*/react.createElement(es/* default */.Z, {
      onResize: function onResize(_ref) {
        var offsetWidth = _ref.offsetWidth;
        internalRegisterSize(offsetWidth);
      },
      disabled: responsiveDisabled
    }, itemNode);
  }
  return itemNode;
}
var Item = /*#__PURE__*/react.forwardRef(InternalItem);
Item.displayName = 'Item';
/* harmony default export */ var es_Item = (Item);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useEvent.js
var useEvent = __webpack_require__(47789);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(85202);
// EXTERNAL MODULE: ./node_modules/rc-util/es/raf.js
var raf = __webpack_require__(13157);
;// CONCATENATED MODULE: ./node_modules/rc-overflow/es/hooks/channelUpdate.js

function channelUpdate(callback) {
  if (typeof MessageChannel === 'undefined') {
    (0,raf/* default */.Z)(callback);
  } else {
    var channel = new MessageChannel();
    channel.port1.onmessage = function () {
      return callback();
    };
    channel.port2.postMessage(undefined);
  }
}
;// CONCATENATED MODULE: ./node_modules/rc-overflow/es/hooks/useEffectState.js





/**
 * Batcher for record any `useEffectState` need update.
 */
function useBatcher() {
  // Updater Trigger
  var updateFuncRef = react.useRef(null);

  // Notify update
  var notifyEffectUpdate = function notifyEffectUpdate(callback) {
    if (!updateFuncRef.current) {
      updateFuncRef.current = [];
      channelUpdate(function () {
        (0,react_dom.unstable_batchedUpdates)(function () {
          updateFuncRef.current.forEach(function (fn) {
            fn();
          });
          updateFuncRef.current = null;
        });
      });
    }
    updateFuncRef.current.push(callback);
  };
  return notifyEffectUpdate;
}

/**
 * Trigger state update by `useLayoutEffect` to save perf.
 */
function useEffectState(notifyEffectUpdate, defaultValue) {
  // Value
  var _React$useState = react.useState(defaultValue),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    stateValue = _React$useState2[0],
    setStateValue = _React$useState2[1];

  // Set State
  var setEffectVal = (0,useEvent/* default */.Z)(function (nextValue) {
    notifyEffectUpdate(function () {
      setStateValue(nextValue);
    });
  });
  return [stateValue, setEffectVal];
}
;// CONCATENATED MODULE: ./node_modules/rc-overflow/es/context.js

var OverflowContext = /*#__PURE__*/react.createContext(null);
;// CONCATENATED MODULE: ./node_modules/rc-overflow/es/RawItem.js


var RawItem_excluded = ["component"],
  _excluded2 = ["className"],
  _excluded3 = ["className"];




var InternalRawItem = function InternalRawItem(props, ref) {
  var context = react.useContext(OverflowContext);

  // Render directly when context not provided
  if (!context) {
    var _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _restProps = (0,objectWithoutProperties/* default */.Z)(props, RawItem_excluded);
    return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, _restProps, {
      ref: ref
    }));
  }
  var contextClassName = context.className,
    restContext = (0,objectWithoutProperties/* default */.Z)(context, _excluded2);
  var className = props.className,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded3);

  // Do not pass context to sub item to avoid multiple measure
  return /*#__PURE__*/react.createElement(OverflowContext.Provider, {
    value: null
  }, /*#__PURE__*/react.createElement(es_Item, (0,esm_extends/* default */.Z)({
    ref: ref,
    className: classnames_default()(contextClassName, className)
  }, restContext, restProps)));
};
var RawItem = /*#__PURE__*/react.forwardRef(InternalRawItem);
RawItem.displayName = 'RawItem';
/* harmony default export */ var es_RawItem = (RawItem);
;// CONCATENATED MODULE: ./node_modules/rc-overflow/es/Overflow.js




var Overflow_excluded = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"];









var RESPONSIVE = 'responsive';
var INVALIDATE = 'invalidate';

function defaultRenderRest(omittedItems) {
  return "+ ".concat(omittedItems.length, " ...");
}
function Overflow(props, ref) {
  var _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-overflow' : _props$prefixCls,
    _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    renderItem = props.renderItem,
    renderRawItem = props.renderRawItem,
    itemKey = props.itemKey,
    _props$itemWidth = props.itemWidth,
    itemWidth = _props$itemWidth === void 0 ? 10 : _props$itemWidth,
    ssr = props.ssr,
    style = props.style,
    className = props.className,
    maxCount = props.maxCount,
    renderRest = props.renderRest,
    renderRawRest = props.renderRawRest,
    suffix = props.suffix,
    _props$component = props.component,
    Component = _props$component === void 0 ? 'div' : _props$component,
    itemComponent = props.itemComponent,
    onVisibleChange = props.onVisibleChange,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, Overflow_excluded);
  var fullySSR = ssr === 'full';
  var notifyEffectUpdate = useBatcher();
  var _useEffectState = useEffectState(notifyEffectUpdate, null),
    _useEffectState2 = (0,slicedToArray/* default */.Z)(_useEffectState, 2),
    containerWidth = _useEffectState2[0],
    setContainerWidth = _useEffectState2[1];
  var mergedContainerWidth = containerWidth || 0;
  var _useEffectState3 = useEffectState(notifyEffectUpdate, new Map()),
    _useEffectState4 = (0,slicedToArray/* default */.Z)(_useEffectState3, 2),
    itemWidths = _useEffectState4[0],
    setItemWidths = _useEffectState4[1];
  var _useEffectState5 = useEffectState(notifyEffectUpdate, 0),
    _useEffectState6 = (0,slicedToArray/* default */.Z)(_useEffectState5, 2),
    prevRestWidth = _useEffectState6[0],
    setPrevRestWidth = _useEffectState6[1];
  var _useEffectState7 = useEffectState(notifyEffectUpdate, 0),
    _useEffectState8 = (0,slicedToArray/* default */.Z)(_useEffectState7, 2),
    restWidth = _useEffectState8[0],
    setRestWidth = _useEffectState8[1];
  var _useEffectState9 = useEffectState(notifyEffectUpdate, 0),
    _useEffectState10 = (0,slicedToArray/* default */.Z)(_useEffectState9, 2),
    suffixWidth = _useEffectState10[0],
    setSuffixWidth = _useEffectState10[1];
  var _useState = (0,react.useState)(null),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    suffixFixedStart = _useState2[0],
    setSuffixFixedStart = _useState2[1];
  var _useState3 = (0,react.useState)(null),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    displayCount = _useState4[0],
    setDisplayCount = _useState4[1];
  var mergedDisplayCount = react.useMemo(function () {
    if (displayCount === null && fullySSR) {
      return Number.MAX_SAFE_INTEGER;
    }
    return displayCount || 0;
  }, [displayCount, containerWidth]);
  var _useState5 = (0,react.useState)(false),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    restReady = _useState6[0],
    setRestReady = _useState6[1];
  var itemPrefixCls = "".concat(prefixCls, "-item");

  // Always use the max width to avoid blink
  var mergedRestWidth = Math.max(prevRestWidth, restWidth);

  // ================================= Data =================================
  var isResponsive = maxCount === RESPONSIVE;
  var shouldResponsive = data.length && isResponsive;
  var invalidate = maxCount === INVALIDATE;

  /**
   * When is `responsive`, we will always render rest node to get the real width of it for calculation
   */
  var showRest = shouldResponsive || typeof maxCount === 'number' && data.length > maxCount;
  var mergedData = (0,react.useMemo)(function () {
    var items = data;
    if (shouldResponsive) {
      if (containerWidth === null && fullySSR) {
        items = data;
      } else {
        items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
      }
    } else if (typeof maxCount === 'number') {
      items = data.slice(0, maxCount);
    }
    return items;
  }, [data, itemWidth, containerWidth, maxCount, shouldResponsive]);
  var omittedItems = (0,react.useMemo)(function () {
    if (shouldResponsive) {
      return data.slice(mergedDisplayCount + 1);
    }
    return data.slice(mergedData.length);
  }, [data, mergedData, shouldResponsive, mergedDisplayCount]);

  // ================================= Item =================================
  var getKey = (0,react.useCallback)(function (item, index) {
    var _ref;
    if (typeof itemKey === 'function') {
      return itemKey(item);
    }
    return (_ref = itemKey && (item === null || item === void 0 ? void 0 : item[itemKey])) !== null && _ref !== void 0 ? _ref : index;
  }, [itemKey]);
  var mergedRenderItem = (0,react.useCallback)(renderItem || function (item) {
    return item;
  }, [renderItem]);
  function updateDisplayCount(count, suffixFixedStartVal, notReady) {
    // React 18 will sync render even when the value is same in some case.
    // We take `mergedData` as deps which may cause dead loop if it's dynamic generate.
    // ref: https://github.com/ant-design/ant-design/issues/36559
    if (displayCount === count && (suffixFixedStartVal === undefined || suffixFixedStartVal === suffixFixedStart)) {
      return;
    }
    setDisplayCount(count);
    if (!notReady) {
      setRestReady(count < data.length - 1);
      onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(count);
    }
    if (suffixFixedStartVal !== undefined) {
      setSuffixFixedStart(suffixFixedStartVal);
    }
  }

  // ================================= Size =================================
  function onOverflowResize(_, element) {
    setContainerWidth(element.clientWidth);
  }
  function registerSize(key, width) {
    setItemWidths(function (origin) {
      var clone = new Map(origin);
      if (width === null) {
        clone.delete(key);
      } else {
        clone.set(key, width);
      }
      return clone;
    });
  }
  function registerOverflowSize(_, width) {
    setRestWidth(width);
    setPrevRestWidth(restWidth);
  }
  function registerSuffixSize(_, width) {
    setSuffixWidth(width);
  }

  // ================================ Effect ================================
  function getItemWidth(index) {
    return itemWidths.get(getKey(mergedData[index], index));
  }
  (0,useLayoutEffect/* default */.Z)(function () {
    if (mergedContainerWidth && typeof mergedRestWidth === 'number' && mergedData) {
      var totalWidth = suffixWidth;
      var len = mergedData.length;
      var lastIndex = len - 1;

      // When data count change to 0, reset this since not loop will reach
      if (!len) {
        updateDisplayCount(0, null);
        return;
      }
      for (var i = 0; i < len; i += 1) {
        var currentItemWidth = getItemWidth(i);

        // Fully will always render
        if (fullySSR) {
          currentItemWidth = currentItemWidth || 0;
        }

        // Break since data not ready
        if (currentItemWidth === undefined) {
          updateDisplayCount(i - 1, undefined, true);
          break;
        }

        // Find best match
        totalWidth += currentItemWidth;
        if (
        // Only one means `totalWidth` is the final width
        lastIndex === 0 && totalWidth <= mergedContainerWidth ||
        // Last two width will be the final width
        i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth) {
          // Additional check if match the end
          updateDisplayCount(lastIndex, null);
          break;
        } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
          // Can not hold all the content to show rest
          updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
          break;
        }
      }
      if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) {
        setSuffixFixedStart(null);
      }
    }
  }, [mergedContainerWidth, itemWidths, restWidth, suffixWidth, getKey, mergedData]);

  // ================================ Render ================================
  var displayRest = restReady && !!omittedItems.length;
  var suffixStyle = {};
  if (suffixFixedStart !== null && shouldResponsive) {
    suffixStyle = {
      position: 'absolute',
      left: suffixFixedStart,
      top: 0
    };
  }
  var itemSharedProps = {
    prefixCls: itemPrefixCls,
    responsive: shouldResponsive,
    component: itemComponent,
    invalidate: invalidate
  };

  // >>>>> Choice render fun by `renderRawItem`
  var internalRenderItemNode = renderRawItem ? function (item, index) {
    var key = getKey(item, index);
    return /*#__PURE__*/react.createElement(OverflowContext.Provider, {
      key: key,
      value: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, itemSharedProps), {}, {
        order: index,
        item: item,
        itemKey: key,
        registerSize: registerSize,
        display: index <= mergedDisplayCount
      })
    }, renderRawItem(item, index));
  } : function (item, index) {
    var key = getKey(item, index);
    return /*#__PURE__*/react.createElement(es_Item, (0,esm_extends/* default */.Z)({}, itemSharedProps, {
      order: index,
      key: key,
      item: item,
      renderItem: mergedRenderItem,
      itemKey: key,
      registerSize: registerSize,
      display: index <= mergedDisplayCount
    }));
  };

  // >>>>> Rest node
  var restContextProps = {
    order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
    className: "".concat(itemPrefixCls, "-rest"),
    registerSize: registerOverflowSize,
    display: displayRest
  };
  var mergedRenderRest = renderRest || defaultRenderRest;
  var restNode = renderRawRest ? /*#__PURE__*/react.createElement(OverflowContext.Provider, {
    value: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, itemSharedProps), restContextProps)
  }, renderRawRest(omittedItems)) : /*#__PURE__*/react.createElement(es_Item, (0,esm_extends/* default */.Z)({}, itemSharedProps, restContextProps), typeof mergedRenderRest === 'function' ? mergedRenderRest(omittedItems) : mergedRenderRest);
  var overflowNode = /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    className: classnames_default()(!invalidate && prefixCls, className),
    style: style,
    ref: ref
  }, restProps), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /*#__PURE__*/react.createElement(es_Item, (0,esm_extends/* default */.Z)({}, itemSharedProps, {
    responsive: isResponsive,
    responsiveDisabled: !shouldResponsive,
    order: mergedDisplayCount,
    className: "".concat(itemPrefixCls, "-suffix"),
    registerSize: registerSuffixSize,
    display: true,
    style: suffixStyle
  }), suffix));
  return isResponsive ? /*#__PURE__*/react.createElement(es/* default */.Z, {
    onResize: onOverflowResize,
    disabled: !shouldResponsive
  }, overflowNode) : overflowNode;
}
var ForwardOverflow = /*#__PURE__*/react.forwardRef(Overflow);
ForwardOverflow.displayName = 'Overflow';
ForwardOverflow.Item = es_RawItem;
ForwardOverflow.RESPONSIVE = RESPONSIVE;
ForwardOverflow.INVALIDATE = INVALIDATE;

// Convert to generic type
/* harmony default export */ var es_Overflow = (ForwardOverflow);
;// CONCATENATED MODULE: ./node_modules/rc-overflow/es/index.js

/* harmony default export */ var rc_overflow_es = (es_Overflow);

/***/ }),

/***/ 84708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ es_Pagination; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMergedState.js
var useMergedState = __webpack_require__(78877);
// EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js
var KeyCode = __webpack_require__(88035);
// EXTERNAL MODULE: ./node_modules/rc-util/es/pickAttrs.js
var pickAttrs = __webpack_require__(75844);
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(13764);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/rc-pagination/es/locale/zh_CN.js
var locale = {
  // Options
  items_per_page: '条/页',
  jump_to: '跳至',
  jump_to_confirm: '确定',
  page: '页',
  // Pagination
  prev_page: '上一页',
  next_page: '下一页',
  prev_5: '向前 5 页',
  next_5: '向后 5 页',
  prev_3: '向前 3 页',
  next_3: '向后 3 页',
  page_size: '页码'
};
/* harmony default export */ var zh_CN = (locale);
;// CONCATENATED MODULE: ./node_modules/rc-pagination/es/Options.js



var defaultPageSizeOptions = [10, 20, 50, 100];
var Options = function Options(props) {
  var _props$pageSizeOption = props.pageSizeOptions,
    pageSizeOptions = _props$pageSizeOption === void 0 ? defaultPageSizeOptions : _props$pageSizeOption,
    locale = props.locale,
    changeSize = props.changeSize,
    pageSize = props.pageSize,
    goButton = props.goButton,
    quickGo = props.quickGo,
    rootPrefixCls = props.rootPrefixCls,
    disabled = props.disabled,
    buildOptionText = props.buildOptionText,
    showSizeChanger = props.showSizeChanger,
    sizeChangerRender = props.sizeChangerRender;
  var _React$useState = react.useState(''),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    goInputText = _React$useState2[0],
    setGoInputText = _React$useState2[1];
  var getValidValue = function getValidValue() {
    return !goInputText || Number.isNaN(goInputText) ? undefined : Number(goInputText);
  };
  var mergeBuildOptionText = typeof buildOptionText === 'function' ? buildOptionText : function (value) {
    return "".concat(value, " ").concat(locale.items_per_page);
  };
  var handleChange = function handleChange(e) {
    setGoInputText(e.target.value);
  };
  var handleBlur = function handleBlur(e) {
    if (goButton || goInputText === '') {
      return;
    }
    setGoInputText('');
    if (e.relatedTarget && (e.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item-link")) >= 0 || e.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item")) >= 0)) {
      return;
    }
    quickGo === null || quickGo === void 0 || quickGo(getValidValue());
  };
  var go = function go(e) {
    if (goInputText === '') {
      return;
    }
    if (e.keyCode === KeyCode/* default.ENTER */.Z.ENTER || e.type === 'click') {
      setGoInputText('');
      quickGo === null || quickGo === void 0 || quickGo(getValidValue());
    }
  };
  var getPageSizeOptions = function getPageSizeOptions() {
    if (pageSizeOptions.some(function (option) {
      return option.toString() === pageSize.toString();
    })) {
      return pageSizeOptions;
    }
    return pageSizeOptions.concat([pageSize]).sort(function (a, b) {
      var numberA = Number.isNaN(Number(a)) ? 0 : Number(a);
      var numberB = Number.isNaN(Number(b)) ? 0 : Number(b);
      return numberA - numberB;
    });
  };
  // ============== cls ==============
  var prefixCls = "".concat(rootPrefixCls, "-options");

  // ============== render ==============

  if (!showSizeChanger && !quickGo) {
    return null;
  }
  var changeSelect = null;
  var goInput = null;
  var gotoButton = null;

  // >>>>> Size Changer
  if (showSizeChanger && sizeChangerRender) {
    changeSelect = sizeChangerRender({
      disabled: disabled,
      size: pageSize,
      onSizeChange: function onSizeChange(nextValue) {
        changeSize === null || changeSize === void 0 || changeSize(Number(nextValue));
      },
      'aria-label': locale.page_size,
      className: "".concat(prefixCls, "-size-changer"),
      options: getPageSizeOptions().map(function (opt) {
        return {
          label: mergeBuildOptionText(opt),
          value: opt
        };
      })
    });
  }

  // >>>>> Quick Go
  if (quickGo) {
    if (goButton) {
      gotoButton = typeof goButton === 'boolean' ? /*#__PURE__*/react.createElement("button", {
        type: "button",
        onClick: go,
        onKeyUp: go,
        disabled: disabled,
        className: "".concat(prefixCls, "-quick-jumper-button")
      }, locale.jump_to_confirm) : /*#__PURE__*/react.createElement("span", {
        onClick: go,
        onKeyUp: go
      }, goButton);
    }
    goInput = /*#__PURE__*/react.createElement("div", {
      className: "".concat(prefixCls, "-quick-jumper")
    }, locale.jump_to, /*#__PURE__*/react.createElement("input", {
      disabled: disabled,
      type: "text",
      value: goInputText,
      onChange: handleChange,
      onKeyUp: go,
      onBlur: handleBlur,
      "aria-label": locale.page
    }), locale.page, gotoButton);
  }
  return /*#__PURE__*/react.createElement("li", {
    className: prefixCls
  }, changeSelect, goInput);
};
if (false) {}
/* harmony default export */ var es_Options = (Options);
;// CONCATENATED MODULE: ./node_modules/rc-pagination/es/Pager.js

/* eslint react/prop-types: 0 */


var Pager = function Pager(props) {
  var rootPrefixCls = props.rootPrefixCls,
    page = props.page,
    active = props.active,
    className = props.className,
    showTitle = props.showTitle,
    onClick = props.onClick,
    onKeyPress = props.onKeyPress,
    itemRender = props.itemRender;
  var prefixCls = "".concat(rootPrefixCls, "-item");
  var cls = classnames_default()(prefixCls, "".concat(prefixCls, "-").concat(page), (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-active"), active), "".concat(prefixCls, "-disabled"), !page), className);
  var handleClick = function handleClick() {
    onClick(page);
  };
  var handleKeyPress = function handleKeyPress(e) {
    onKeyPress(e, onClick, page);
  };
  var pager = itemRender(page, 'page', /*#__PURE__*/react.createElement("a", {
    rel: "nofollow"
  }, page));
  return pager ? /*#__PURE__*/react.createElement("li", {
    title: showTitle ? String(page) : null,
    className: cls,
    onClick: handleClick,
    onKeyDown: handleKeyPress,
    tabIndex: 0
  }, pager) : null;
};
if (false) {}
/* harmony default export */ var es_Pager = (Pager);
;// CONCATENATED MODULE: ./node_modules/rc-pagination/es/Pagination.js














var defaultItemRender = function defaultItemRender(page, type, element) {
  return element;
};
function noop() {}
function isInteger(v) {
  var value = Number(v);
  return typeof value === 'number' && !Number.isNaN(value) && isFinite(value) && Math.floor(value) === value;
}
function calculatePage(p, pageSize, total) {
  var _pageSize = typeof p === 'undefined' ? pageSize : p;
  return Math.floor((total - 1) / _pageSize) + 1;
}
var Pagination = function Pagination(props) {
  var _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-pagination' : _props$prefixCls,
    _props$selectPrefixCl = props.selectPrefixCls,
    selectPrefixCls = _props$selectPrefixCl === void 0 ? 'rc-select' : _props$selectPrefixCl,
    className = props.className,
    currentProp = props.current,
    _props$defaultCurrent = props.defaultCurrent,
    defaultCurrent = _props$defaultCurrent === void 0 ? 1 : _props$defaultCurrent,
    _props$total = props.total,
    total = _props$total === void 0 ? 0 : _props$total,
    pageSizeProp = props.pageSize,
    _props$defaultPageSiz = props.defaultPageSize,
    defaultPageSize = _props$defaultPageSiz === void 0 ? 10 : _props$defaultPageSiz,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? noop : _props$onChange,
    hideOnSinglePage = props.hideOnSinglePage,
    align = props.align,
    _props$showPrevNextJu = props.showPrevNextJumpers,
    showPrevNextJumpers = _props$showPrevNextJu === void 0 ? true : _props$showPrevNextJu,
    showQuickJumper = props.showQuickJumper,
    showLessItems = props.showLessItems,
    _props$showTitle = props.showTitle,
    showTitle = _props$showTitle === void 0 ? true : _props$showTitle,
    _props$onShowSizeChan = props.onShowSizeChange,
    onShowSizeChange = _props$onShowSizeChan === void 0 ? noop : _props$onShowSizeChan,
    _props$locale = props.locale,
    locale = _props$locale === void 0 ? zh_CN : _props$locale,
    style = props.style,
    _props$totalBoundaryS = props.totalBoundaryShowSizeChanger,
    totalBoundaryShowSizeChanger = _props$totalBoundaryS === void 0 ? 50 : _props$totalBoundaryS,
    disabled = props.disabled,
    simple = props.simple,
    showTotal = props.showTotal,
    _props$showSizeChange = props.showSizeChanger,
    showSizeChanger = _props$showSizeChange === void 0 ? total > totalBoundaryShowSizeChanger : _props$showSizeChange,
    sizeChangerRender = props.sizeChangerRender,
    pageSizeOptions = props.pageSizeOptions,
    _props$itemRender = props.itemRender,
    itemRender = _props$itemRender === void 0 ? defaultItemRender : _props$itemRender,
    jumpPrevIcon = props.jumpPrevIcon,
    jumpNextIcon = props.jumpNextIcon,
    prevIcon = props.prevIcon,
    nextIcon = props.nextIcon;
  var paginationRef = react.useRef(null);
  var _useMergedState = (0,useMergedState/* default */.Z)(10, {
      value: pageSizeProp,
      defaultValue: defaultPageSize
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    pageSize = _useMergedState2[0],
    setPageSize = _useMergedState2[1];
  var _useMergedState3 = (0,useMergedState/* default */.Z)(1, {
      value: currentProp,
      defaultValue: defaultCurrent,
      postState: function postState(c) {
        return Math.max(1, Math.min(c, calculatePage(undefined, pageSize, total)));
      }
    }),
    _useMergedState4 = (0,slicedToArray/* default */.Z)(_useMergedState3, 2),
    current = _useMergedState4[0],
    setCurrent = _useMergedState4[1];
  var _React$useState = react.useState(current),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    internalInputVal = _React$useState2[0],
    setInternalInputVal = _React$useState2[1];
  (0,react.useEffect)(function () {
    setInternalInputVal(current);
  }, [current]);
  var hasOnChange = onChange !== noop;
  var hasCurrent = 'current' in props;
  if (false) {}
  var jumpPrevPage = Math.max(1, current - (showLessItems ? 3 : 5));
  var jumpNextPage = Math.min(calculatePage(undefined, pageSize, total), current + (showLessItems ? 3 : 5));
  function getItemIcon(icon, label) {
    var iconNode = icon || /*#__PURE__*/react.createElement("button", {
      type: "button",
      "aria-label": label,
      className: "".concat(prefixCls, "-item-link")
    });
    if (typeof icon === 'function') {
      iconNode = /*#__PURE__*/react.createElement(icon, (0,objectSpread2/* default */.Z)({}, props));
    }
    return iconNode;
  }
  function getValidValue(e) {
    var inputValue = e.target.value;
    var allPages = calculatePage(undefined, pageSize, total);
    var value;
    if (inputValue === '') {
      value = inputValue;
    } else if (Number.isNaN(Number(inputValue))) {
      value = internalInputVal;
    } else if (inputValue >= allPages) {
      value = allPages;
    } else {
      value = Number(inputValue);
    }
    return value;
  }
  function isValid(page) {
    return isInteger(page) && page !== current && isInteger(total) && total > 0;
  }
  var shouldDisplayQuickJumper = total > pageSize ? showQuickJumper : false;

  /**
   * prevent "up arrow" key reseting cursor position within textbox
   * @see https://stackoverflow.com/a/1081114
   */
  function handleKeyDown(event) {
    if (event.keyCode === KeyCode/* default.UP */.Z.UP || event.keyCode === KeyCode/* default.DOWN */.Z.DOWN) {
      event.preventDefault();
    }
  }
  function handleKeyUp(event) {
    var value = getValidValue(event);
    if (value !== internalInputVal) {
      setInternalInputVal(value);
    }
    switch (event.keyCode) {
      case KeyCode/* default.ENTER */.Z.ENTER:
        handleChange(value);
        break;
      case KeyCode/* default.UP */.Z.UP:
        handleChange(value - 1);
        break;
      case KeyCode/* default.DOWN */.Z.DOWN:
        handleChange(value + 1);
        break;
      default:
        break;
    }
  }
  function handleBlur(event) {
    handleChange(getValidValue(event));
  }
  function changePageSize(size) {
    var newCurrent = calculatePage(size, pageSize, total);
    var nextCurrent = current > newCurrent && newCurrent !== 0 ? newCurrent : current;
    setPageSize(size);
    setInternalInputVal(nextCurrent);
    onShowSizeChange === null || onShowSizeChange === void 0 || onShowSizeChange(current, size);
    setCurrent(nextCurrent);
    onChange === null || onChange === void 0 || onChange(nextCurrent, size);
  }
  function handleChange(page) {
    if (isValid(page) && !disabled) {
      var currentPage = calculatePage(undefined, pageSize, total);
      var newPage = page;
      if (page > currentPage) {
        newPage = currentPage;
      } else if (page < 1) {
        newPage = 1;
      }
      if (newPage !== internalInputVal) {
        setInternalInputVal(newPage);
      }
      setCurrent(newPage);
      onChange === null || onChange === void 0 || onChange(newPage, pageSize);
      return newPage;
    }
    return current;
  }
  var hasPrev = current > 1;
  var hasNext = current < calculatePage(undefined, pageSize, total);
  function prevHandle() {
    if (hasPrev) handleChange(current - 1);
  }
  function nextHandle() {
    if (hasNext) handleChange(current + 1);
  }
  function jumpPrevHandle() {
    handleChange(jumpPrevPage);
  }
  function jumpNextHandle() {
    handleChange(jumpNextPage);
  }
  function runIfEnter(event, callback) {
    if (event.key === 'Enter' || event.charCode === KeyCode/* default.ENTER */.Z.ENTER || event.keyCode === KeyCode/* default.ENTER */.Z.ENTER) {
      for (var _len = arguments.length, restParams = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        restParams[_key - 2] = arguments[_key];
      }
      callback.apply(void 0, restParams);
    }
  }
  function runIfEnterPrev(event) {
    runIfEnter(event, prevHandle);
  }
  function runIfEnterNext(event) {
    runIfEnter(event, nextHandle);
  }
  function runIfEnterJumpPrev(event) {
    runIfEnter(event, jumpPrevHandle);
  }
  function runIfEnterJumpNext(event) {
    runIfEnter(event, jumpNextHandle);
  }
  function renderPrev(prevPage) {
    var prevButton = itemRender(prevPage, 'prev', getItemIcon(prevIcon, 'prev page'));
    return /*#__PURE__*/react.isValidElement(prevButton) ? /*#__PURE__*/react.cloneElement(prevButton, {
      disabled: !hasPrev
    }) : prevButton;
  }
  function renderNext(nextPage) {
    var nextButton = itemRender(nextPage, 'next', getItemIcon(nextIcon, 'next page'));
    return /*#__PURE__*/react.isValidElement(nextButton) ? /*#__PURE__*/react.cloneElement(nextButton, {
      disabled: !hasNext
    }) : nextButton;
  }
  function handleGoTO(event) {
    if (event.type === 'click' || event.keyCode === KeyCode/* default.ENTER */.Z.ENTER) {
      handleChange(internalInputVal);
    }
  }
  var jumpPrev = null;
  var dataOrAriaAttributeProps = (0,pickAttrs/* default */.Z)(props, {
    aria: true,
    data: true
  });
  var totalText = showTotal && /*#__PURE__*/react.createElement("li", {
    className: "".concat(prefixCls, "-total-text")
  }, showTotal(total, [total === 0 ? 0 : (current - 1) * pageSize + 1, current * pageSize > total ? total : current * pageSize]));
  var jumpNext = null;
  var allPages = calculatePage(undefined, pageSize, total);

  // ================== Render ==================
  // When hideOnSinglePage is true and there is only 1 page, hide the pager
  if (hideOnSinglePage && total <= pageSize) {
    return null;
  }
  var pagerList = [];
  var pagerProps = {
    rootPrefixCls: prefixCls,
    onClick: handleChange,
    onKeyPress: runIfEnter,
    showTitle: showTitle,
    itemRender: itemRender,
    page: -1
  };
  var prevPage = current - 1 > 0 ? current - 1 : 0;
  var nextPage = current + 1 < allPages ? current + 1 : allPages;
  var goButton = showQuickJumper && showQuickJumper.goButton;

  // ================== Simple ==================
  // FIXME: ts type
  var isReadOnly = (0,esm_typeof/* default */.Z)(simple) === 'object' ? simple.readOnly : !simple;
  var gotoButton = goButton;
  var simplePager = null;
  if (simple) {
    // ====== Simple quick jump ======
    if (goButton) {
      if (typeof goButton === 'boolean') {
        gotoButton = /*#__PURE__*/react.createElement("button", {
          type: "button",
          onClick: handleGoTO,
          onKeyUp: handleGoTO
        }, locale.jump_to_confirm);
      } else {
        gotoButton = /*#__PURE__*/react.createElement("span", {
          onClick: handleGoTO,
          onKeyUp: handleGoTO
        }, goButton);
      }
      gotoButton = /*#__PURE__*/react.createElement("li", {
        title: showTitle ? "".concat(locale.jump_to).concat(current, "/").concat(allPages) : null,
        className: "".concat(prefixCls, "-simple-pager")
      }, gotoButton);
    }
    simplePager = /*#__PURE__*/react.createElement("li", {
      title: showTitle ? "".concat(current, "/").concat(allPages) : null,
      className: "".concat(prefixCls, "-simple-pager")
    }, isReadOnly ? internalInputVal : /*#__PURE__*/react.createElement("input", {
      type: "text",
      "aria-label": locale.jump_to,
      value: internalInputVal,
      disabled: disabled,
      onKeyDown: handleKeyDown,
      onKeyUp: handleKeyUp,
      onChange: handleKeyUp,
      onBlur: handleBlur,
      size: 3
    }), /*#__PURE__*/react.createElement("span", {
      className: "".concat(prefixCls, "-slash")
    }, "/"), allPages);
  }

  // ====================== Normal ======================
  var pageBufferSize = showLessItems ? 1 : 2;
  if (allPages <= 3 + pageBufferSize * 2) {
    if (!allPages) {
      pagerList.push(/*#__PURE__*/react.createElement(es_Pager, (0,esm_extends/* default */.Z)({}, pagerProps, {
        key: "noPager",
        page: 1,
        className: "".concat(prefixCls, "-item-disabled")
      })));
    }
    for (var i = 1; i <= allPages; i += 1) {
      pagerList.push(/*#__PURE__*/react.createElement(es_Pager, (0,esm_extends/* default */.Z)({}, pagerProps, {
        key: i,
        page: i,
        active: current === i
      })));
    }
  } else {
    var prevItemTitle = showLessItems ? locale.prev_3 : locale.prev_5;
    var nextItemTitle = showLessItems ? locale.next_3 : locale.next_5;
    var jumpPrevContent = itemRender(jumpPrevPage, 'jump-prev', getItemIcon(jumpPrevIcon, 'prev page'));
    var jumpNextContent = itemRender(jumpNextPage, 'jump-next', getItemIcon(jumpNextIcon, 'next page'));
    if (showPrevNextJumpers) {
      jumpPrev = jumpPrevContent ? /*#__PURE__*/react.createElement("li", {
        title: showTitle ? prevItemTitle : null,
        key: "prev",
        onClick: jumpPrevHandle,
        tabIndex: 0,
        onKeyDown: runIfEnterJumpPrev,
        className: classnames_default()("".concat(prefixCls, "-jump-prev"), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-jump-prev-custom-icon"), !!jumpPrevIcon))
      }, jumpPrevContent) : null;
      jumpNext = jumpNextContent ? /*#__PURE__*/react.createElement("li", {
        title: showTitle ? nextItemTitle : null,
        key: "next",
        onClick: jumpNextHandle,
        tabIndex: 0,
        onKeyDown: runIfEnterJumpNext,
        className: classnames_default()("".concat(prefixCls, "-jump-next"), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-jump-next-custom-icon"), !!jumpNextIcon))
      }, jumpNextContent) : null;
    }
    var left = Math.max(1, current - pageBufferSize);
    var right = Math.min(current + pageBufferSize, allPages);
    if (current - 1 <= pageBufferSize) {
      right = 1 + pageBufferSize * 2;
    }
    if (allPages - current <= pageBufferSize) {
      left = allPages - pageBufferSize * 2;
    }
    for (var _i = left; _i <= right; _i += 1) {
      pagerList.push(/*#__PURE__*/react.createElement(es_Pager, (0,esm_extends/* default */.Z)({}, pagerProps, {
        key: _i,
        page: _i,
        active: current === _i
      })));
    }
    if (current - 1 >= pageBufferSize * 2 && current !== 1 + 2) {
      pagerList[0] = /*#__PURE__*/react.cloneElement(pagerList[0], {
        className: classnames_default()("".concat(prefixCls, "-item-after-jump-prev"), pagerList[0].props.className)
      });
      pagerList.unshift(jumpPrev);
    }
    if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
      var lastOne = pagerList[pagerList.length - 1];
      pagerList[pagerList.length - 1] = /*#__PURE__*/react.cloneElement(lastOne, {
        className: classnames_default()("".concat(prefixCls, "-item-before-jump-next"), lastOne.props.className)
      });
      pagerList.push(jumpNext);
    }
    if (left !== 1) {
      pagerList.unshift(/*#__PURE__*/react.createElement(es_Pager, (0,esm_extends/* default */.Z)({}, pagerProps, {
        key: 1,
        page: 1
      })));
    }
    if (right !== allPages) {
      pagerList.push(/*#__PURE__*/react.createElement(es_Pager, (0,esm_extends/* default */.Z)({}, pagerProps, {
        key: allPages,
        page: allPages
      })));
    }
  }
  var prev = renderPrev(prevPage);
  if (prev) {
    var prevDisabled = !hasPrev || !allPages;
    prev = /*#__PURE__*/react.createElement("li", {
      title: showTitle ? locale.prev_page : null,
      onClick: prevHandle,
      tabIndex: prevDisabled ? null : 0,
      onKeyDown: runIfEnterPrev,
      className: classnames_default()("".concat(prefixCls, "-prev"), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-disabled"), prevDisabled)),
      "aria-disabled": prevDisabled
    }, prev);
  }
  var next = renderNext(nextPage);
  if (next) {
    var nextDisabled, nextTabIndex;
    if (simple) {
      nextDisabled = !hasNext;
      nextTabIndex = hasPrev ? 0 : null;
    } else {
      nextDisabled = !hasNext || !allPages;
      nextTabIndex = nextDisabled ? null : 0;
    }
    next = /*#__PURE__*/react.createElement("li", {
      title: showTitle ? locale.next_page : null,
      onClick: nextHandle,
      tabIndex: nextTabIndex,
      onKeyDown: runIfEnterNext,
      className: classnames_default()("".concat(prefixCls, "-next"), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-disabled"), nextDisabled)),
      "aria-disabled": nextDisabled
    }, next);
  }
  var cls = classnames_default()(prefixCls, className, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-start"), align === 'start'), "".concat(prefixCls, "-center"), align === 'center'), "".concat(prefixCls, "-end"), align === 'end'), "".concat(prefixCls, "-simple"), simple), "".concat(prefixCls, "-disabled"), disabled));
  return /*#__PURE__*/react.createElement("ul", (0,esm_extends/* default */.Z)({
    className: cls,
    style: style,
    ref: paginationRef
  }, dataOrAriaAttributeProps), totalText, prev, simple ? simplePager : pagerList, next, /*#__PURE__*/react.createElement(es_Options, {
    locale: locale,
    rootPrefixCls: prefixCls,
    disabled: disabled,
    selectPrefixCls: selectPrefixCls,
    changeSize: changePageSize,
    pageSize: pageSize,
    pageSizeOptions: pageSizeOptions,
    quickGo: shouldDisplayQuickJumper ? handleChange : null,
    goButton: gotoButton,
    showSizeChanger: showSizeChanger,
    sizeChangerRender: sizeChangerRender
  }));
};
if (false) {}
/* harmony default export */ var es_Pagination = (Pagination);
;// CONCATENATED MODULE: ./node_modules/rc-pagination/es/index.js


/***/ }),

/***/ 14603:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var locale = {
  // Options
  items_per_page: '/ page',
  jump_to: 'Go to',
  jump_to_confirm: 'confirm',
  page: 'Page',
  // Pagination
  prev_page: 'Previous Page',
  next_page: 'Next Page',
  prev_5: 'Previous 5 Pages',
  next_5: 'Next 5 Pages',
  prev_3: 'Previous 3 Pages',
  next_3: 'Next 3 Pages',
  page_size: 'Page Size'
};
/* harmony default export */ __webpack_exports__["Z"] = (locale);

/***/ }),

/***/ 67586:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var locale = {
  // Options
  items_per_page: '/ page',
  jump_to: 'Go to',
  jump_to_confirm: 'confirm',
  page: 'Page',
  // Pagination
  prev_page: 'Previous Page',
  next_page: 'Next Page',
  prev_5: 'Previous 5 Pages',
  next_5: 'Next 5 Pages',
  prev_3: 'Previous 3 Pages',
  next_3: 'Next 3 Pages',
  page_size: 'Page Size'
};
var _default = exports["default"] = locale;

/***/ }),

/***/ 5641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79555);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_weekday__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91884);
/* harmony import */ var dayjs_plugin_weekday__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_weekday__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55860);
/* harmony import */ var dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_weekOfYear__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98242);
/* harmony import */ var dayjs_plugin_weekOfYear__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_weekOfYear__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs_plugin_weekYear__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45953);
/* harmony import */ var dayjs_plugin_weekYear__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_weekYear__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60524);
/* harmony import */ var dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25943);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_6__);







dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_6___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_5___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_weekday__WEBPACK_IMPORTED_MODULE_1___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_2___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_weekOfYear__WEBPACK_IMPORTED_MODULE_3___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_weekYear__WEBPACK_IMPORTED_MODULE_4___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend(function (o, c) {
  // todo support Wo (ISO week)
  var proto = c.prototype;
  var oldFormat = proto.format;
  proto.format = function f(formatStr) {
    var str = (formatStr || '').replace('Wo', 'wo');
    return oldFormat.bind(this)(str);
  };
});
var localeMap = {
  // ar_EG:
  // az_AZ:
  // bg_BG:
  bn_BD: 'bn-bd',
  by_BY: 'be',
  // ca_ES:
  // cs_CZ:
  // da_DK:
  // de_DE:
  // el_GR:
  en_GB: 'en-gb',
  en_US: 'en',
  // es_ES:
  // et_EE:
  // fa_IR:
  // fi_FI:
  fr_BE: 'fr',
  // todo: dayjs has no fr_BE locale, use fr at present
  fr_CA: 'fr-ca',
  // fr_FR:
  // ga_IE:
  // gl_ES:
  // he_IL:
  // hi_IN:
  // hr_HR:
  // hu_HU:
  hy_AM: 'hy-am',
  // id_ID:
  // is_IS:
  // it_IT:
  // ja_JP:
  // ka_GE:
  // kk_KZ:
  // km_KH:
  kmr_IQ: 'ku',
  // kn_IN:
  // ko_KR:
  // ku_IQ: // previous ku in antd
  // lt_LT:
  // lv_LV:
  // mk_MK:
  // ml_IN:
  // mn_MN:
  // ms_MY:
  // nb_NO:
  // ne_NP:
  nl_BE: 'nl-be',
  // nl_NL:
  // pl_PL:
  pt_BR: 'pt-br',
  // pt_PT:
  // ro_RO:
  // ru_RU:
  // sk_SK:
  // sl_SI:
  // sr_RS:
  // sv_SE:
  // ta_IN:
  // th_TH:
  // tr_TR:
  // uk_UA:
  // ur_PK:
  // vi_VN:
  zh_CN: 'zh-cn',
  zh_HK: 'zh-hk',
  zh_TW: 'zh-tw'
};
var parseLocale = function parseLocale(locale) {
  var mapLocale = localeMap[locale];
  return mapLocale || locale.split('_')[0];
};

/* istanbul ignore next */
var parseNoMatchNotice = function parseNoMatchNotice() {
  // zombieJ:
  // When user typing, its always miss match format.
  // This check is meaningless.
  // https://github.com/ant-design/ant-design/issues/51839
  // noteOnce(false, 'Not match any format. Please help to fire a issue about this.');
};
var generateConfig = {
  // get
  getNow: function getNow() {
    var now = dayjs__WEBPACK_IMPORTED_MODULE_0___default()();
    // https://github.com/ant-design/ant-design/discussions/50934
    if (typeof now.tz === 'function') {
      return now.tz(); // use default timezone
    }
    return now;
  },
  getFixedDate: function getFixedDate(string) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(string, ['YYYY-M-DD', 'YYYY-MM-DD']);
  },
  getEndDate: function getEndDate(date) {
    return date.endOf('month');
  },
  getWeekDay: function getWeekDay(date) {
    var clone = date.locale('en');
    return clone.weekday() + clone.localeData().firstDayOfWeek();
  },
  getYear: function getYear(date) {
    return date.year();
  },
  getMonth: function getMonth(date) {
    return date.month();
  },
  getDate: function getDate(date) {
    return date.date();
  },
  getHour: function getHour(date) {
    return date.hour();
  },
  getMinute: function getMinute(date) {
    return date.minute();
  },
  getSecond: function getSecond(date) {
    return date.second();
  },
  getMillisecond: function getMillisecond(date) {
    return date.millisecond();
  },
  // set
  addYear: function addYear(date, diff) {
    return date.add(diff, 'year');
  },
  addMonth: function addMonth(date, diff) {
    return date.add(diff, 'month');
  },
  addDate: function addDate(date, diff) {
    return date.add(diff, 'day');
  },
  setYear: function setYear(date, year) {
    return date.year(year);
  },
  setMonth: function setMonth(date, month) {
    return date.month(month);
  },
  setDate: function setDate(date, num) {
    return date.date(num);
  },
  setHour: function setHour(date, hour) {
    return date.hour(hour);
  },
  setMinute: function setMinute(date, minute) {
    return date.minute(minute);
  },
  setSecond: function setSecond(date, second) {
    return date.second(second);
  },
  setMillisecond: function setMillisecond(date, milliseconds) {
    return date.millisecond(milliseconds);
  },
  // Compare
  isAfter: function isAfter(date1, date2) {
    return date1.isAfter(date2);
  },
  isValidate: function isValidate(date) {
    return date.isValid();
  },
  locale: {
    getWeekFirstDay: function getWeekFirstDay(locale) {
      return dayjs__WEBPACK_IMPORTED_MODULE_0___default()().locale(parseLocale(locale)).localeData().firstDayOfWeek();
    },
    getWeekFirstDate: function getWeekFirstDate(locale, date) {
      return date.locale(parseLocale(locale)).weekday(0);
    },
    getWeek: function getWeek(locale, date) {
      return date.locale(parseLocale(locale)).week();
    },
    getShortWeekDays: function getShortWeekDays(locale) {
      return dayjs__WEBPACK_IMPORTED_MODULE_0___default()().locale(parseLocale(locale)).localeData().weekdaysMin();
    },
    getShortMonths: function getShortMonths(locale) {
      return dayjs__WEBPACK_IMPORTED_MODULE_0___default()().locale(parseLocale(locale)).localeData().monthsShort();
    },
    format: function format(locale, date, _format) {
      return date.locale(parseLocale(locale)).format(_format);
    },
    parse: function parse(locale, text, formats) {
      var localeStr = parseLocale(locale);
      for (var i = 0; i < formats.length; i += 1) {
        var format = formats[i];
        var formatText = text;
        if (format.includes('wo') || format.includes('Wo')) {
          // parse Wo
          var year = formatText.split('-')[0];
          var weekStr = formatText.split('-')[1];
          var firstWeek = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(year, 'YYYY').startOf('year').locale(localeStr);
          for (var j = 0; j <= 52; j += 1) {
            var nextWeek = firstWeek.add(j, 'week');
            if (nextWeek.format('Wo') === weekStr) {
              return nextWeek;
            }
          }
          parseNoMatchNotice();
          return null;
        }
        var date = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(formatText, format, true).locale(localeStr);
        if (date.isValid()) {
          return date;
        }
      }
      if (text) {
        parseNoMatchNotice();
      }
      return null;
    }
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (generateConfig);

/***/ }),

/***/ 95953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N4": function() { return /* reexport */ es_PickerPanel; },
  "Sq": function() { return /* reexport */ PickerInput_RangePicker; },
  "ZP": function() { return /* binding */ rc_picker_es; }
});

// UNUSED EXPORTS: Picker

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/rc-util/es/index.js
var es = __webpack_require__(57433);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useLayoutEffect.js
var useLayoutEffect = __webpack_require__(76963);
// EXTERNAL MODULE: ./node_modules/rc-util/es/omit.js
var omit = __webpack_require__(85401);
// EXTERNAL MODULE: ./node_modules/rc-util/es/pickAttrs.js
var pickAttrs = __webpack_require__(75844);
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(13764);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/@rc-component/trigger/es/index.js + 11 modules
var trigger_es = __webpack_require__(91831);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/utils/uiUtil.js
// ====================== Mode ======================
function getRealPlacement(placement, rtl) {
  if (placement !== undefined) {
    return placement;
  }
  return rtl ? 'bottomRight' : 'bottomLeft';
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/context.js

var PickerContext = /*#__PURE__*/react.createContext(null);
/* harmony default export */ var PickerInput_context = (PickerContext);
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerTrigger/index.js






var BUILT_IN_PLACEMENTS = {
  bottomLeft: {
    points: ['tl', 'bl'],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ['tr', 'br'],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ['bl', 'tl'],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topRight: {
    points: ['br', 'tr'],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};
function PickerTrigger(_ref) {
  var popupElement = _ref.popupElement,
    popupStyle = _ref.popupStyle,
    popupClassName = _ref.popupClassName,
    popupAlign = _ref.popupAlign,
    transitionName = _ref.transitionName,
    getPopupContainer = _ref.getPopupContainer,
    children = _ref.children,
    range = _ref.range,
    placement = _ref.placement,
    _ref$builtinPlacement = _ref.builtinPlacements,
    builtinPlacements = _ref$builtinPlacement === void 0 ? BUILT_IN_PLACEMENTS : _ref$builtinPlacement,
    direction = _ref.direction,
    visible = _ref.visible,
    onClose = _ref.onClose;
  var _React$useContext = react.useContext(PickerInput_context),
    prefixCls = _React$useContext.prefixCls;
  var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
  var realPlacement = getRealPlacement(placement, direction === 'rtl');
  return /*#__PURE__*/react.createElement(trigger_es/* default */.Z, {
    showAction: [],
    hideAction: ['click'],
    popupPlacement: realPlacement,
    builtinPlacements: builtinPlacements,
    prefixCls: dropdownPrefixCls,
    popupTransitionName: transitionName,
    popup: popupElement,
    popupAlign: popupAlign,
    popupVisible: visible,
    popupClassName: classnames_default()(popupClassName, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(dropdownPrefixCls, "-range"), range), "".concat(dropdownPrefixCls, "-rtl"), direction === 'rtl')),
    popupStyle: popupStyle,
    stretch: "minWidth",
    getPopupContainer: getPopupContainer,
    onPopupVisibleChange: function onPopupVisibleChange(nextVisible) {
      if (!nextVisible) {
        onClose();
      }
    }
  }, children);
}
/* harmony default export */ var es_PickerTrigger = (PickerTrigger);
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/utils/miscUtil.js

function leftPad(str, length) {
  var fill = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
  var current = String(str);
  while (current.length < length) {
    current = "".concat(fill).concat(current);
  }
  return current;
}

/**
 * Convert `value` to array. Will provide `[]` if is null or undefined.
 */
function toArray(val) {
  if (val === null || val === undefined) {
    return [];
  }
  return Array.isArray(val) ? val : [val];
}
function fillIndex(ori, index, value) {
  var clone = (0,toConsumableArray/* default */.Z)(ori);
  clone[index] = value;
  return clone;
}

/** Pick props from the key list. Will filter empty value */
function pickProps(props, keys) {
  var clone = {};
  var mergedKeys = keys || Object.keys(props);
  mergedKeys.forEach(function (key) {
    if (props[key] !== undefined) {
      clone[key] = props[key];
    }
  });
  return clone;
}
function getRowFormat(picker, locale, format) {
  if (format) {
    return format;
  }
  switch (picker) {
    // All from the `locale.fieldXXXFormat` first
    case 'time':
      return locale.fieldTimeFormat;
    case 'datetime':
      return locale.fieldDateTimeFormat;
    case 'month':
      return locale.fieldMonthFormat;
    case 'year':
      return locale.fieldYearFormat;
    case 'quarter':
      return locale.fieldQuarterFormat;
    case 'week':
      return locale.fieldWeekFormat;
    default:
      return locale.fieldDateFormat;
  }
}
function getFromDate(calendarValues, activeIndexList, activeIndex) {
  var mergedActiveIndex = activeIndex !== undefined ? activeIndex : activeIndexList[activeIndexList.length - 1];
  var firstValuedIndex = activeIndexList.find(function (index) {
    return calendarValues[index];
  });
  return mergedActiveIndex !== firstValuedIndex ? calendarValues[firstValuedIndex] : undefined;
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerTrigger/util.js

function pickTriggerProps(props) {
  return pickProps(props, ['placement', 'builtinPlacements', 'popupAlign', 'getPopupContainer', 'transitionName', 'direction']);
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/hooks/useCellRender.js



function useCellRender(cellRender, dateRender, monthCellRender, range) {
  // ========================= Warn =========================
  if (false) {}

  // ======================== Render ========================
  // Merged render
  var mergedCellRender = react.useMemo(function () {
    if (cellRender) {
      return cellRender;
    }
    return function (current, info) {
      var date = current;
      if (dateRender && info.type === 'date') {
        return dateRender(date, info.today);
      }
      if (monthCellRender && info.type === 'month') {
        return monthCellRender(date, info.locale);
      }
      return info.originNode;
    };
  }, [cellRender, monthCellRender, dateRender]);

  // Cell render
  var onInternalCellRender = react.useCallback(function (date, info) {
    return mergedCellRender(date, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, info), {}, {
      range: range
    }));
  }, [mergedCellRender, range]);
  return onInternalCellRender;
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/hooks/useFieldsInvalidate.js



/**
 * Used to control each fields invalidate status
 */
function useFieldsInvalidate(calendarValue, isInvalidateDate) {
  var allowEmpty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var _React$useState = react.useState([false, false]),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    fieldsInvalidates = _React$useState2[0],
    setFieldsInvalidates = _React$useState2[1];
  var onSelectorInvalid = function onSelectorInvalid(invalid, index) {
    setFieldsInvalidates(function (ori) {
      return fillIndex(ori, index, invalid);
    });
  };

  /**
   * For the Selector Input to mark as `aria-disabled`
   */
  var submitInvalidates = react.useMemo(function () {
    return fieldsInvalidates.map(function (invalid, index) {
      // If typing invalidate
      if (invalid) {
        return true;
      }
      var current = calendarValue[index];

      // Not check if all empty
      if (!current) {
        return false;
      }

      // Not allow empty
      if (!allowEmpty[index] && !current) {
        return true;
      }

      // Invalidate
      if (current && isInvalidateDate(current, {
        activeIndex: index
      })) {
        return true;
      }
      return false;
    });
  }, [calendarValue, fieldsInvalidates, isInvalidateDate, allowEmpty]);
  return [submitInvalidates, onSelectorInvalid];
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/hooks/useLocale.js


function fillTimeFormat(showHour, showMinute, showSecond, showMillisecond, showMeridiem) {
  var timeFormat = '';

  // Base HH:mm:ss
  var cells = [];
  if (showHour) {
    cells.push(showMeridiem ? 'hh' : 'HH');
  }
  if (showMinute) {
    cells.push('mm');
  }
  if (showSecond) {
    cells.push('ss');
  }
  timeFormat = cells.join(':');

  // Millisecond
  if (showMillisecond) {
    timeFormat += '.SSS';
  }

  // Meridiem
  if (showMeridiem) {
    timeFormat += ' A';
  }
  return timeFormat;
}

/**
 * Used for `useFilledProps` since it already in the React.useMemo
 */
function fillLocale(locale, showHour, showMinute, showSecond, showMillisecond, use12Hours) {
  // Not fill `monthFormat` since `locale.shortMonths` handle this
  // Not fill `cellMeridiemFormat` since AM & PM by default
  var fieldDateTimeFormat = locale.fieldDateTimeFormat,
    fieldDateFormat = locale.fieldDateFormat,
    fieldTimeFormat = locale.fieldTimeFormat,
    fieldMonthFormat = locale.fieldMonthFormat,
    fieldYearFormat = locale.fieldYearFormat,
    fieldWeekFormat = locale.fieldWeekFormat,
    fieldQuarterFormat = locale.fieldQuarterFormat,
    yearFormat = locale.yearFormat,
    cellYearFormat = locale.cellYearFormat,
    cellQuarterFormat = locale.cellQuarterFormat,
    dayFormat = locale.dayFormat,
    cellDateFormat = locale.cellDateFormat;
  var timeFormat = fillTimeFormat(showHour, showMinute, showSecond, showMillisecond, use12Hours);
  return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, locale), {}, {
    fieldDateTimeFormat: fieldDateTimeFormat || "YYYY-MM-DD ".concat(timeFormat),
    fieldDateFormat: fieldDateFormat || 'YYYY-MM-DD',
    fieldTimeFormat: fieldTimeFormat || timeFormat,
    fieldMonthFormat: fieldMonthFormat || 'YYYY-MM',
    fieldYearFormat: fieldYearFormat || 'YYYY',
    fieldWeekFormat: fieldWeekFormat || 'gggg-wo',
    fieldQuarterFormat: fieldQuarterFormat || 'YYYY-[Q]Q',
    yearFormat: yearFormat || 'YYYY',
    cellYearFormat: cellYearFormat || 'YYYY',
    cellQuarterFormat: cellQuarterFormat || '[Q]Q',
    cellDateFormat: cellDateFormat || dayFormat || 'D'
  });
}

/**
 * Fill locale format as start up
 */
function useLocale(locale, showProps) {
  var showHour = showProps.showHour,
    showMinute = showProps.showMinute,
    showSecond = showProps.showSecond,
    showMillisecond = showProps.showMillisecond,
    use12Hours = showProps.use12Hours;
  return react.useMemo(function () {
    return fillLocale(locale, showHour, showMinute, showSecond, showMillisecond, use12Hours);
  }, [locale, showHour, showMinute, showSecond, showMillisecond, use12Hours]);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/hooks/useTimeConfig.js





function checkShow(format, keywords, show) {
  return show !== null && show !== void 0 ? show : keywords.some(function (keyword) {
    return format.includes(keyword);
  });
}
var showTimeKeys = [
// 'format',
'showNow', 'showHour', 'showMinute', 'showSecond', 'showMillisecond', 'use12Hours', 'hourStep', 'minuteStep', 'secondStep', 'millisecondStep', 'hideDisabledOptions', 'defaultValue', 'disabledHours', 'disabledMinutes', 'disabledSeconds', 'disabledMilliseconds', 'disabledTime', 'changeOnScroll', 'defaultOpenValue'];

/**
 * Get SharedTimeProps from props.
 */
function pickTimeProps(props) {
  var timeProps = pickProps(props, showTimeKeys);
  var format = props.format,
    picker = props.picker;
  var propFormat = null;
  if (format) {
    propFormat = format;
    if (Array.isArray(propFormat)) {
      propFormat = propFormat[0];
    }
    propFormat = (0,esm_typeof/* default */.Z)(propFormat) === 'object' ? propFormat.format : propFormat;
  }
  if (picker === 'time') {
    timeProps.format = propFormat;
  }
  return [timeProps, propFormat];
}
function isStringFormat(format) {
  return format && typeof format === 'string';
}
/** Check if all the showXXX is `undefined` */
function existShowConfig(showHour, showMinute, showSecond, showMillisecond) {
  return [showHour, showMinute, showSecond, showMillisecond].some(function (show) {
    return show !== undefined;
  });
}

/** Fill the showXXX if needed */
function fillShowConfig(hasShowConfig, showHour, showMinute, showSecond, showMillisecond) {
  var parsedShowHour = showHour;
  var parsedShowMinute = showMinute;
  var parsedShowSecond = showSecond;
  if (!hasShowConfig && !parsedShowHour && !parsedShowMinute && !parsedShowSecond && !showMillisecond) {
    parsedShowHour = true;
    parsedShowMinute = true;
    parsedShowSecond = true;
  } else if (hasShowConfig) {
    var _parsedShowHour, _parsedShowMinute, _parsedShowSecond;
    var existFalse = [parsedShowHour, parsedShowMinute, parsedShowSecond].some(function (show) {
      return show === false;
    });
    var existTrue = [parsedShowHour, parsedShowMinute, parsedShowSecond].some(function (show) {
      return show === true;
    });
    var defaultShow = existFalse ? true : !existTrue;
    parsedShowHour = (_parsedShowHour = parsedShowHour) !== null && _parsedShowHour !== void 0 ? _parsedShowHour : defaultShow;
    parsedShowMinute = (_parsedShowMinute = parsedShowMinute) !== null && _parsedShowMinute !== void 0 ? _parsedShowMinute : defaultShow;
    parsedShowSecond = (_parsedShowSecond = parsedShowSecond) !== null && _parsedShowSecond !== void 0 ? _parsedShowSecond : defaultShow;
  }
  return [parsedShowHour, parsedShowMinute, parsedShowSecond, showMillisecond];
}

/**
 * Get `showHour`, `showMinute`, `showSecond` or other from the props.
 * This is pure function, will not get `showXXX` from the `format` prop.
 */
function getTimeProps(componentProps) {
  var showTime = componentProps.showTime;
  var _pickTimeProps = pickTimeProps(componentProps),
    _pickTimeProps2 = (0,slicedToArray/* default */.Z)(_pickTimeProps, 2),
    pickedProps = _pickTimeProps2[0],
    propFormat = _pickTimeProps2[1];
  var showTimeConfig = showTime && (0,esm_typeof/* default */.Z)(showTime) === 'object' ? showTime : {};
  var timeConfig = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
    defaultOpenValue: showTimeConfig.defaultOpenValue || showTimeConfig.defaultValue
  }, pickedProps), showTimeConfig);
  var showMillisecond = timeConfig.showMillisecond;
  var showHour = timeConfig.showHour,
    showMinute = timeConfig.showMinute,
    showSecond = timeConfig.showSecond;
  var hasShowConfig = existShowConfig(showHour, showMinute, showSecond, showMillisecond);
  var _fillShowConfig = fillShowConfig(hasShowConfig, showHour, showMinute, showSecond, showMillisecond);
  var _fillShowConfig2 = (0,slicedToArray/* default */.Z)(_fillShowConfig, 3);
  showHour = _fillShowConfig2[0];
  showMinute = _fillShowConfig2[1];
  showSecond = _fillShowConfig2[2];
  return [timeConfig, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, timeConfig), {}, {
    showHour: showHour,
    showMinute: showMinute,
    showSecond: showSecond,
    showMillisecond: showMillisecond
  }), timeConfig.format, propFormat];
}
function fillShowTimeConfig(picker, showTimeFormat, propFormat, timeConfig, locale) {
  var isTimePicker = picker === 'time';
  if (picker === 'datetime' || isTimePicker) {
    var pickedProps = timeConfig;

    // ====================== BaseFormat ======================
    var defaultLocaleFormat = getRowFormat(picker, locale, null);
    var baselineFormat = defaultLocaleFormat;
    var formatList = [showTimeFormat, propFormat];
    for (var i = 0; i < formatList.length; i += 1) {
      var format = toArray(formatList[i])[0];
      if (isStringFormat(format)) {
        baselineFormat = format;
        break;
      }
    }

    // ========================= Show =========================
    var showHour = pickedProps.showHour,
      showMinute = pickedProps.showMinute,
      showSecond = pickedProps.showSecond,
      showMillisecond = pickedProps.showMillisecond;
    var use12Hours = pickedProps.use12Hours;
    var showMeridiem = checkShow(baselineFormat, ['a', 'A', 'LT', 'LLL', 'LTS'], use12Hours);
    var hasShowConfig = existShowConfig(showHour, showMinute, showSecond, showMillisecond);

    // Fill with format, if needed
    if (!hasShowConfig) {
      showHour = checkShow(baselineFormat, ['H', 'h', 'k', 'LT', 'LLL']);
      showMinute = checkShow(baselineFormat, ['m', 'LT', 'LLL']);
      showSecond = checkShow(baselineFormat, ['s', 'LTS']);
      showMillisecond = checkShow(baselineFormat, ['SSS']);
    }

    // Fallback if all can not see
    // ======================== Format ========================
    var _fillShowConfig3 = fillShowConfig(hasShowConfig, showHour, showMinute, showSecond, showMillisecond);
    var _fillShowConfig4 = (0,slicedToArray/* default */.Z)(_fillShowConfig3, 3);
    showHour = _fillShowConfig4[0];
    showMinute = _fillShowConfig4[1];
    showSecond = _fillShowConfig4[2];
    var timeFormat = showTimeFormat || fillTimeFormat(showHour, showMinute, showSecond, showMillisecond, showMeridiem);

    // ======================== Props =========================
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, pickedProps), {}, {
      // Format
      format: timeFormat,
      // Show Config
      showHour: showHour,
      showMinute: showMinute,
      showSecond: showSecond,
      showMillisecond: showMillisecond,
      use12Hours: showMeridiem
    });
  }
  return null;
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/Selector/hooks/useClearIcon.js




/**
 * Used for `useFilledProps` since it already in the React.useMemo
 */
function fillClearIcon(prefixCls, allowClear, clearIcon) {
  if (false) {}
  if (allowClear === false) {
    return null;
  }
  var config = allowClear && (0,esm_typeof/* default */.Z)(allowClear) === 'object' ? allowClear : {};
  return config.clearIcon || clearIcon || /*#__PURE__*/react.createElement("span", {
    className: "".concat(prefixCls, "-clear-btn")
  });
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/utils/dateUtil.js
var WEEK_DAY_COUNT = 7;

/**
 * Wrap the compare logic.
 * This will compare the each of value is empty first.
 * 1. All is empty, return true.
 * 2. One is empty, return false.
 * 3. return customize compare logic.
 */
function nullableCompare(value1, value2, oriCompareFn) {
  if (!value1 && !value2 || value1 === value2) {
    return true;
  }
  if (!value1 || !value2) {
    return false;
  }
  return oriCompareFn();
}
function isSameDecade(generateConfig, decade1, decade2) {
  return nullableCompare(decade1, decade2, function () {
    var num1 = Math.floor(generateConfig.getYear(decade1) / 10);
    var num2 = Math.floor(generateConfig.getYear(decade2) / 10);
    return num1 === num2;
  });
}
function isSameYear(generateConfig, year1, year2) {
  return nullableCompare(year1, year2, function () {
    return generateConfig.getYear(year1) === generateConfig.getYear(year2);
  });
}
function getQuarter(generateConfig, date) {
  var quota = Math.floor(generateConfig.getMonth(date) / 3);
  return quota + 1;
}
function isSameQuarter(generateConfig, quarter1, quarter2) {
  return nullableCompare(quarter1, quarter2, function () {
    return isSameYear(generateConfig, quarter1, quarter2) && getQuarter(generateConfig, quarter1) === getQuarter(generateConfig, quarter2);
  });
}
function isSameMonth(generateConfig, month1, month2) {
  return nullableCompare(month1, month2, function () {
    return isSameYear(generateConfig, month1, month2) && generateConfig.getMonth(month1) === generateConfig.getMonth(month2);
  });
}
function isSameDate(generateConfig, date1, date2) {
  return nullableCompare(date1, date2, function () {
    return isSameYear(generateConfig, date1, date2) && isSameMonth(generateConfig, date1, date2) && generateConfig.getDate(date1) === generateConfig.getDate(date2);
  });
}
function isSameTime(generateConfig, time1, time2) {
  return nullableCompare(time1, time2, function () {
    return generateConfig.getHour(time1) === generateConfig.getHour(time2) && generateConfig.getMinute(time1) === generateConfig.getMinute(time2) && generateConfig.getSecond(time1) === generateConfig.getSecond(time2);
  });
}

/**
 * Check if the Date is all the same of timestamp
 */
function isSameTimestamp(generateConfig, time1, time2) {
  return nullableCompare(time1, time2, function () {
    return isSameDate(generateConfig, time1, time2) && isSameTime(generateConfig, time1, time2) && generateConfig.getMillisecond(time1) === generateConfig.getMillisecond(time2);
  });
}
function isSameWeek(generateConfig, locale, date1, date2) {
  return nullableCompare(date1, date2, function () {
    var weekStartDate1 = generateConfig.locale.getWeekFirstDate(locale, date1);
    var weekStartDate2 = generateConfig.locale.getWeekFirstDate(locale, date2);
    return isSameYear(generateConfig, weekStartDate1, weekStartDate2) && generateConfig.locale.getWeek(locale, date1) === generateConfig.locale.getWeek(locale, date2);
  });
}
function isSame(generateConfig, locale, source, target, type) {
  switch (type) {
    case 'date':
      return isSameDate(generateConfig, source, target);
    case 'week':
      return isSameWeek(generateConfig, locale.locale, source, target);
    case 'month':
      return isSameMonth(generateConfig, source, target);
    case 'quarter':
      return isSameQuarter(generateConfig, source, target);
    case 'year':
      return isSameYear(generateConfig, source, target);
    case 'decade':
      return isSameDecade(generateConfig, source, target);
    case 'time':
      return isSameTime(generateConfig, source, target);
    default:
      return isSameTimestamp(generateConfig, source, target);
  }
}

/** Between in date but not equal of date */
function isInRange(generateConfig, startDate, endDate, current) {
  if (!startDate || !endDate || !current) {
    return false;
  }
  return generateConfig.isAfter(current, startDate) && generateConfig.isAfter(endDate, current);
}
function isSameOrAfter(generateConfig, locale, date1, date2, type) {
  if (isSame(generateConfig, locale, date1, date2, type)) {
    return true;
  }
  return generateConfig.isAfter(date1, date2);
}
function getWeekStartDate(locale, generateConfig, value) {
  var weekFirstDay = generateConfig.locale.getWeekFirstDay(locale);
  var monthStartDate = generateConfig.setDate(value, 1);
  var startDateWeekDay = generateConfig.getWeekDay(monthStartDate);
  var alignStartDate = generateConfig.addDate(monthStartDate, weekFirstDay - startDateWeekDay);
  if (generateConfig.getMonth(alignStartDate) === generateConfig.getMonth(value) && generateConfig.getDate(alignStartDate) > 1) {
    alignStartDate = generateConfig.addDate(alignStartDate, -7);
  }
  return alignStartDate;
}
function formatValue(value, _ref) {
  var generateConfig = _ref.generateConfig,
    locale = _ref.locale,
    format = _ref.format;
  if (!value) {
    return '';
  }
  return typeof format === 'function' ? format(value) : generateConfig.locale.format(locale.locale, value, format);
}

/**
 * Fill the time info into Date if provided.
 */
function fillTime(generateConfig, date, time) {
  var tmpDate = date;
  var getFn = ['getHour', 'getMinute', 'getSecond', 'getMillisecond'];
  var setFn = ['setHour', 'setMinute', 'setSecond', 'setMillisecond'];
  setFn.forEach(function (fn, index) {
    if (time) {
      tmpDate = generateConfig[fn](tmpDate, generateConfig[getFn[index]](time));
    } else {
      tmpDate = generateConfig[fn](tmpDate, 0);
    }
  });
  return tmpDate;
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/hooks/useDisabledBoundary.js


/**
 * Merge `disabledDate` with `minDate` & `maxDate`.
 */
function useDisabledBoundary(generateConfig, locale, disabledDate, minDate, maxDate) {
  var mergedDisabledDate = (0,es/* useEvent */.zX)(function (date, info) {
    if (disabledDate && disabledDate(date, info)) {
      return true;
    }
    if (minDate && generateConfig.isAfter(minDate, date) && !isSame(generateConfig, locale, minDate, date, info.type)) {
      return true;
    }
    if (maxDate && generateConfig.isAfter(date, maxDate) && !isSame(generateConfig, locale, maxDate, date, info.type)) {
      return true;
    }
    return false;
  });
  return mergedDisabledDate;
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/hooks/useFieldFormat.js



function useFieldFormat(picker, locale, format) {
  return react.useMemo(function () {
    var rawFormat = getRowFormat(picker, locale, format);
    var formatList = toArray(rawFormat);
    var firstFormat = formatList[0];
    var maskFormat = (0,esm_typeof/* default */.Z)(firstFormat) === 'object' && firstFormat.type === 'mask' ? firstFormat.format : null;
    return [
    // Format list
    formatList.map(function (config) {
      return typeof config === 'string' || typeof config === 'function' ? config : config.format;
    }),
    // Mask Format
    maskFormat];
  }, [picker, locale, format]);
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/hooks/useInputReadOnly.js
function useInputReadOnly(formatList, inputReadOnly, multiple) {
  if (typeof formatList[0] === 'function' || multiple) {
    return true;
  }
  return inputReadOnly;
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/hooks/useInvalidate.js


/**
 * Check if provided date is valid for the `disabledDate` & `showTime.disabledTime`.
 */
function useInvalidate(generateConfig, picker, disabledDate, showTime) {
  // Check disabled date
  var isInvalidate = (0,es/* useEvent */.zX)(function (date, info) {
    var outsideInfo = (0,objectSpread2/* default */.Z)({
      type: picker
    }, info);
    delete outsideInfo.activeIndex;
    if (
    // Date object is invalid
    !generateConfig.isValidate(date) ||
    // Date is disabled by `disabledDate`
    disabledDate && disabledDate(date, outsideInfo)) {
      return true;
    }
    if ((picker === 'date' || picker === 'time') && showTime) {
      var _showTime$disabledTim;
      var range = info && info.activeIndex === 1 ? 'end' : 'start';
      var _ref = ((_showTime$disabledTim = showTime.disabledTime) === null || _showTime$disabledTim === void 0 ? void 0 : _showTime$disabledTim.call(showTime, date, range, {
          from: outsideInfo.from
        })) || {},
        disabledHours = _ref.disabledHours,
        disabledMinutes = _ref.disabledMinutes,
        disabledSeconds = _ref.disabledSeconds,
        disabledMilliseconds = _ref.disabledMilliseconds;
      var legacyDisabledHours = showTime.disabledHours,
        legacyDisabledMinutes = showTime.disabledMinutes,
        legacyDisabledSeconds = showTime.disabledSeconds;
      var mergedDisabledHours = disabledHours || legacyDisabledHours;
      var mergedDisabledMinutes = disabledMinutes || legacyDisabledMinutes;
      var mergedDisabledSeconds = disabledSeconds || legacyDisabledSeconds;
      var hour = generateConfig.getHour(date);
      var minute = generateConfig.getMinute(date);
      var second = generateConfig.getSecond(date);
      var millisecond = generateConfig.getMillisecond(date);
      if (mergedDisabledHours && mergedDisabledHours().includes(hour)) {
        return true;
      }
      if (mergedDisabledMinutes && mergedDisabledMinutes(hour).includes(minute)) {
        return true;
      }
      if (mergedDisabledSeconds && mergedDisabledSeconds(hour, minute).includes(second)) {
        return true;
      }
      if (disabledMilliseconds && disabledMilliseconds(hour, minute, second).includes(millisecond)) {
        return true;
      }
    }
    return false;
  });
  return isInvalidate;
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/hooks/useFilledProps.js












function useList(value) {
  var fillMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var values = react.useMemo(function () {
    var list = value ? toArray(value) : value;
    if (fillMode && list) {
      list[1] = list[1] || list[0];
    }
    return list;
  }, [value, fillMode]);
  return values;
}

/**
 * Align the outer props with unique typed and fill undefined props.
 * This is shared with both RangePicker and Picker. This will do:
 * - Convert `value` & `defaultValue` to array
 * - handle the legacy props fill like `clearIcon` + `allowClear` = `clearIcon`
 */
function useFilledProps(props, updater) {
  var generateConfig = props.generateConfig,
    locale = props.locale,
    _props$picker = props.picker,
    picker = _props$picker === void 0 ? 'date' : _props$picker,
    _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-picker' : _props$prefixCls,
    _props$styles = props.styles,
    styles = _props$styles === void 0 ? {} : _props$styles,
    _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? {} : _props$classNames,
    _props$order = props.order,
    order = _props$order === void 0 ? true : _props$order,
    _props$components = props.components,
    components = _props$components === void 0 ? {} : _props$components,
    inputRender = props.inputRender,
    allowClear = props.allowClear,
    clearIcon = props.clearIcon,
    needConfirm = props.needConfirm,
    multiple = props.multiple,
    format = props.format,
    inputReadOnly = props.inputReadOnly,
    disabledDate = props.disabledDate,
    minDate = props.minDate,
    maxDate = props.maxDate,
    showTime = props.showTime,
    value = props.value,
    defaultValue = props.defaultValue,
    pickerValue = props.pickerValue,
    defaultPickerValue = props.defaultPickerValue;
  var values = useList(value);
  var defaultValues = useList(defaultValue);
  var pickerValues = useList(pickerValue);
  var defaultPickerValues = useList(defaultPickerValue);

  // ======================== Picker ========================
  /** Almost same as `picker`, but add `datetime` for `date` with `showTime` */
  var internalPicker = picker === 'date' && showTime ? 'datetime' : picker;

  /** The picker is `datetime` or `time` */
  var multipleInteractivePicker = internalPicker === 'time' || internalPicker === 'datetime';
  var complexPicker = multipleInteractivePicker || multiple;
  var mergedNeedConfirm = needConfirm !== null && needConfirm !== void 0 ? needConfirm : multipleInteractivePicker;

  // ========================== Time ==========================
  // Auto `format` need to check `showTime.showXXX` first.
  // And then merge the `locale` into `mergedShowTime`.
  var _getTimeProps = getTimeProps(props),
    _getTimeProps2 = (0,slicedToArray/* default */.Z)(_getTimeProps, 4),
    timeProps = _getTimeProps2[0],
    localeTimeProps = _getTimeProps2[1],
    showTimeFormat = _getTimeProps2[2],
    propFormat = _getTimeProps2[3];

  // ======================= Locales ========================
  var mergedLocale = useLocale(locale, localeTimeProps);
  var mergedShowTime = react.useMemo(function () {
    return fillShowTimeConfig(internalPicker, showTimeFormat, propFormat, timeProps, mergedLocale);
  }, [internalPicker, showTimeFormat, propFormat, timeProps, mergedLocale]);

  // ======================= Warning ========================
  if (false) {}

  // ======================== Props =========================
  var filledProps = react.useMemo(function () {
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
      prefixCls: prefixCls,
      locale: mergedLocale,
      picker: picker,
      styles: styles,
      classNames: classNames,
      order: order,
      components: (0,objectSpread2/* default */.Z)({
        input: inputRender
      }, components),
      clearIcon: fillClearIcon(prefixCls, allowClear, clearIcon),
      showTime: mergedShowTime,
      value: values,
      defaultValue: defaultValues,
      pickerValue: pickerValues,
      defaultPickerValue: defaultPickerValues
    }, updater === null || updater === void 0 ? void 0 : updater());
  }, [props]);

  // ======================== Format ========================
  var _useFieldFormat = useFieldFormat(internalPicker, mergedLocale, format),
    _useFieldFormat2 = (0,slicedToArray/* default */.Z)(_useFieldFormat, 2),
    formatList = _useFieldFormat2[0],
    maskFormat = _useFieldFormat2[1];

  // ======================= ReadOnly =======================
  var mergedInputReadOnly = useInputReadOnly(formatList, inputReadOnly, multiple);

  // ======================= Boundary =======================
  var disabledBoundaryDate = useDisabledBoundary(generateConfig, locale, disabledDate, minDate, maxDate);

  // ====================== Invalidate ======================
  var isInvalidateDate = useInvalidate(generateConfig, picker, disabledBoundaryDate, mergedShowTime);

  // ======================== Merged ========================
  var mergedProps = react.useMemo(function () {
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, filledProps), {}, {
      needConfirm: mergedNeedConfirm,
      inputReadOnly: mergedInputReadOnly,
      disabledDate: disabledBoundaryDate
    });
  }, [filledProps, mergedNeedConfirm, mergedInputReadOnly, disabledBoundaryDate]);
  return [mergedProps, internalPicker, complexPicker, formatList, maskFormat, isInvalidateDate];
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/raf.js
var raf = __webpack_require__(13157);
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/hooks/useDelayState.js





/**
 * Will be `true` immediately for next effect.
 * But will be `false` for a delay of effect.
 */
function useDelayState(value, defaultValue, onChange) {
  var _useMergedState = (0,es/* useMergedState */.C8)(defaultValue, {
      value: value
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    state = _useMergedState2[0],
    setState = _useMergedState2[1];
  var nextValueRef = react.useRef(value);

  // ============================= Update =============================
  var rafRef = react.useRef();
  var cancelRaf = function cancelRaf() {
    raf/* default.cancel */.Z.cancel(rafRef.current);
  };
  var doUpdate = (0,es/* useEvent */.zX)(function () {
    setState(nextValueRef.current);
    if (onChange && state !== nextValueRef.current) {
      onChange(nextValueRef.current);
    }
  });
  var updateValue = (0,es/* useEvent */.zX)(function (next, immediately) {
    cancelRaf();
    nextValueRef.current = next;
    if (next || immediately) {
      doUpdate();
    } else {
      rafRef.current = (0,raf/* default */.Z)(doUpdate);
    }
  });
  react.useEffect(function () {
    return cancelRaf;
  }, []);
  return [state, updateValue];
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/hooks/useOpen.js



/**
 * Control the open state.
 * Will not close if activeElement is on the popup.
 */
function useOpen(open, defaultOpen) {
  var disabledList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var onOpenChange = arguments.length > 3 ? arguments[3] : undefined;
  var mergedOpen = disabledList.every(function (disabled) {
    return disabled;
  }) ? false : open;

  // Delay for handle the open state, in case fast shift from `open` -> `close` -> `open`
  // const [rafOpen, setRafOpen] = useLockState(open, defaultOpen || false, onOpenChange);
  var _useDelayState = useDelayState(mergedOpen, defaultOpen || false, onOpenChange),
    _useDelayState2 = (0,slicedToArray/* default */.Z)(_useDelayState, 2),
    rafOpen = _useDelayState2[0],
    setRafOpen = _useDelayState2[1];
  function setOpen(next) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!config.inherit || rafOpen) {
      setRafOpen(next, config.force);
    }
  }
  return [rafOpen, setOpen];
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/hooks/usePickerRef.js

function usePickerRef(ref) {
  var selectorRef = react.useRef();
  react.useImperativeHandle(ref, function () {
    var _selectorRef$current;
    return {
      nativeElement: (_selectorRef$current = selectorRef.current) === null || _selectorRef$current === void 0 ? void 0 : _selectorRef$current.nativeElement,
      focus: function focus(options) {
        var _selectorRef$current2;
        (_selectorRef$current2 = selectorRef.current) === null || _selectorRef$current2 === void 0 || _selectorRef$current2.focus(options);
      },
      blur: function blur() {
        var _selectorRef$current3;
        (_selectorRef$current3 = selectorRef.current) === null || _selectorRef$current3 === void 0 || _selectorRef$current3.blur();
      }
    };
  });
  return selectorRef;
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/hooks/usePresets.js



function usePresets(presets, legacyRanges) {
  return react.useMemo(function () {
    if (presets) {
      return presets;
    }
    if (legacyRanges) {
      (0,warning/* default */.ZP)(false, '`ranges` is deprecated. Please use `presets` instead.');
      return Object.entries(legacyRanges).map(function (_ref) {
        var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
          label = _ref2[0],
          value = _ref2[1];
        return {
          label: label,
          value: value
        };
      });
    }
    return [];
  }, [presets, legacyRanges]);
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/hooks/useLockEffect.js




/**
 * Trigger `callback` immediately when `condition` is `true`.
 * But trigger `callback` in next frame when `condition` is `false`.
 */
function useLockEffect(condition, callback) {
  var delayFrames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var callbackRef = react.useRef(callback);
  callbackRef.current = callback;
  (0,useLayoutEffect/* useLayoutUpdateEffect */.o)(function () {
    if (condition) {
      callbackRef.current(condition);
    } else {
      var id = (0,raf/* default */.Z)(function () {
        callbackRef.current(condition);
      }, delayFrames);
      return function () {
        raf/* default.cancel */.Z.cancel(id);
      };
    }
  }, [condition]);
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/hooks/useRangeActive.js



/**
 * When user first focus one input, any submit will trigger focus another one.
 * When second time focus one input, submit will not trigger focus again.
 * When click outside to close the panel, trigger event if it can trigger onChange.
 */
function useRangeActive(disabled) {
  var empty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var mergedOpen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var _React$useState = react.useState(0),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    activeIndex = _React$useState2[0],
    setActiveIndex = _React$useState2[1];
  var _React$useState3 = react.useState(false),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    focused = _React$useState4[0],
    setFocused = _React$useState4[1];
  var activeListRef = react.useRef([]);
  var submitIndexRef = react.useRef(null);
  var lastOperationRef = react.useRef(null);
  var updateSubmitIndex = function updateSubmitIndex(index) {
    submitIndexRef.current = index;
  };
  var hasActiveSubmitValue = function hasActiveSubmitValue(index) {
    return submitIndexRef.current === index;
  };
  var triggerFocus = function triggerFocus(nextFocus) {
    setFocused(nextFocus);
  };

  // ============================= Record =============================
  var lastOperation = function lastOperation(type) {
    if (type) {
      lastOperationRef.current = type;
    }
    return lastOperationRef.current;
  };

  // ============================ Strategy ============================
  // Trigger when input enter or input blur or panel close
  var nextActiveIndex = function nextActiveIndex(nextValue) {
    var list = activeListRef.current;
    var filledActiveSet = new Set(list.filter(function (index) {
      return nextValue[index] || empty[index];
    }));
    var nextIndex = list[list.length - 1] === 0 ? 1 : 0;
    if (filledActiveSet.size >= 2 || disabled[nextIndex]) {
      return null;
    }
    return nextIndex;
  };

  // ============================= Effect =============================
  // Wait in case it's from the click outside to blur
  useLockEffect(focused || mergedOpen, function () {
    if (!focused) {
      activeListRef.current = [];
      updateSubmitIndex(null);
    }
  });
  react.useEffect(function () {
    if (focused) {
      activeListRef.current.push(activeIndex);
    }
  }, [focused, activeIndex]);
  return [focused, triggerFocus, lastOperation, activeIndex, setActiveIndex, nextActiveIndex, activeListRef.current, updateSubmitIndex, hasActiveSubmitValue];
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/hooks/useRangeDisabledDate.js





/**
 * RangePicker need additional logic to handle the `disabled` case. e.g.
 * [disabled, enabled] should end date not before start date
 */
function useRangeDisabledDate(values, disabled, activeIndexList, generateConfig, locale, disabledDate) {
  var activeIndex = activeIndexList[activeIndexList.length - 1];
  var rangeDisabledDate = function rangeDisabledDate(date, info) {
    var _values = (0,slicedToArray/* default */.Z)(values, 2),
      start = _values[0],
      end = _values[1];
    var mergedInfo = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, info), {}, {
      from: getFromDate(values, activeIndexList)
    });

    // ============================ Disabled ============================
    // Should not select days before the start date
    if (activeIndex === 1 && disabled[0] && start &&
    // Same date isOK
    !isSame(generateConfig, locale, start, date, mergedInfo.type) &&
    // Before start date
    generateConfig.isAfter(start, date)) {
      return true;
    }

    // Should not select days after the end date
    if (activeIndex === 0 && disabled[1] && end &&
    // Same date isOK
    !isSame(generateConfig, locale, end, date, mergedInfo.type) &&
    // After end date
    generateConfig.isAfter(date, end)) {
      return true;
    }

    // ============================= Origin =============================
    return disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date, mergedInfo);
  };
  return rangeDisabledDate;
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/hooks/useRangePickerValue.js





function offsetPanelDate(generateConfig, picker, date, offset) {
  switch (picker) {
    case 'date':
    case 'week':
      return generateConfig.addMonth(date, offset);
    case 'month':
    case 'quarter':
      return generateConfig.addYear(date, offset);
    case 'year':
      return generateConfig.addYear(date, offset * 10);
    case 'decade':
      return generateConfig.addYear(date, offset * 100);
    default:
      return date;
  }
}
var EMPTY_LIST = [];
function useRangePickerValue(generateConfig, locale, calendarValue, modes, open, activeIndex, pickerMode, multiplePanel) {
  var defaultPickerValue = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : EMPTY_LIST;
  var pickerValue = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : EMPTY_LIST;
  var timeDefaultValue = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : EMPTY_LIST;
  var onPickerValueChange = arguments.length > 11 ? arguments[11] : undefined;
  var minDate = arguments.length > 12 ? arguments[12] : undefined;
  var maxDate = arguments.length > 13 ? arguments[13] : undefined;
  var isTimePicker = pickerMode === 'time';

  // ======================== Active ========================
  // `activeIndex` must be valid to avoid getting empty `pickerValue`
  var mergedActiveIndex = activeIndex || 0;

  // ===================== Picker Value =====================
  var getDefaultPickerValue = function getDefaultPickerValue(index) {
    var now = generateConfig.getNow();
    if (isTimePicker) {
      now = fillTime(generateConfig, now);
    }
    return defaultPickerValue[index] || calendarValue[index] || now;
  };

  // Align `pickerValue` with `showTime.defaultValue`
  var _pickerValue = (0,slicedToArray/* default */.Z)(pickerValue, 2),
    startPickerValue = _pickerValue[0],
    endPickerValue = _pickerValue[1];

  // PickerValue state
  var _useMergedState = (0,es/* useMergedState */.C8)(function () {
      return getDefaultPickerValue(0);
    }, {
      value: startPickerValue
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    mergedStartPickerValue = _useMergedState2[0],
    setStartPickerValue = _useMergedState2[1];
  var _useMergedState3 = (0,es/* useMergedState */.C8)(function () {
      return getDefaultPickerValue(1);
    }, {
      value: endPickerValue
    }),
    _useMergedState4 = (0,slicedToArray/* default */.Z)(_useMergedState3, 2),
    mergedEndPickerValue = _useMergedState4[0],
    setEndPickerValue = _useMergedState4[1];

  // Current PickerValue
  var currentPickerValue = react.useMemo(function () {
    var current = [mergedStartPickerValue, mergedEndPickerValue][mergedActiveIndex];

    // Merge the `showTime.defaultValue` into `pickerValue`
    return isTimePicker ? current : fillTime(generateConfig, current, timeDefaultValue[mergedActiveIndex]);
  }, [isTimePicker, mergedStartPickerValue, mergedEndPickerValue, mergedActiveIndex, generateConfig, timeDefaultValue]);
  var setCurrentPickerValue = function setCurrentPickerValue(nextPickerValue) {
    var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'panel';
    var updater = [setStartPickerValue, setEndPickerValue][mergedActiveIndex];
    updater(nextPickerValue);
    var clone = [mergedStartPickerValue, mergedEndPickerValue];
    clone[mergedActiveIndex] = nextPickerValue;
    if (onPickerValueChange && (!isSame(generateConfig, locale, mergedStartPickerValue, clone[0], pickerMode) || !isSame(generateConfig, locale, mergedEndPickerValue, clone[1], pickerMode))) {
      onPickerValueChange(clone, {
        source: source,
        range: mergedActiveIndex === 1 ? 'end' : 'start',
        mode: modes
      });
    }
  };

  // ======================== Effect ========================
  /**
   * EndDate pickerValue is little different. It should be:
   * - If date picker (without time), endDate is not same year & month as startDate
   *   - pickerValue minus one month
   * - Else pass directly
   */
  var getEndDatePickerValue = function getEndDatePickerValue(startDate, endDate) {
    if (multiplePanel) {
      // Basic offset
      var SAME_CHECKER = {
        date: 'month',
        week: 'month',
        month: 'year',
        quarter: 'year'
      };
      var mode = SAME_CHECKER[pickerMode];
      if (mode && !isSame(generateConfig, locale, startDate, endDate, mode)) {
        return offsetPanelDate(generateConfig, pickerMode, endDate, -1);
      }

      // Year offset
      if (pickerMode === 'year' && startDate) {
        var srcYear = Math.floor(generateConfig.getYear(startDate) / 10);
        var tgtYear = Math.floor(generateConfig.getYear(endDate) / 10);
        if (srcYear !== tgtYear) {
          return offsetPanelDate(generateConfig, pickerMode, endDate, -1);
        }
      }
    }
    return endDate;
  };

  // >>> When switch field, reset the picker value as prev field picker value
  var prevActiveIndexRef = react.useRef(null);
  (0,useLayoutEffect/* default */.Z)(function () {
    if (open) {
      if (!defaultPickerValue[mergedActiveIndex]) {
        var nextPickerValue = isTimePicker ? null : generateConfig.getNow();

        /**
         * 1. If has prevActiveIndex, use it to avoid panel jump
         * 2. If current field has value
         *    - If `activeIndex` is 1 and `calendarValue[0]` is not same panel as `calendarValue[1]`,
         *      offset `calendarValue[1]` and set it
         *    - Else use `calendarValue[activeIndex]`
         * 3. If current field has no value but another field has value, use another field value
         * 4. Else use now (not any `calendarValue` can ref)
         */

        if (prevActiveIndexRef.current !== null && prevActiveIndexRef.current !== mergedActiveIndex) {
          // If from another field, not jump picker value
          nextPickerValue = [mergedStartPickerValue, mergedEndPickerValue][mergedActiveIndex ^ 1];
        } else if (calendarValue[mergedActiveIndex]) {
          // Current field has value
          nextPickerValue = mergedActiveIndex === 0 ? calendarValue[0] : getEndDatePickerValue(calendarValue[0], calendarValue[1]);
        } else if (calendarValue[mergedActiveIndex ^ 1]) {
          // Current field has no value but another field has value
          nextPickerValue = calendarValue[mergedActiveIndex ^ 1];
        }

        // Only sync when has value, this will sync in the `min-max` logic
        if (nextPickerValue) {
          // nextPickerValue < minDate
          if (minDate && generateConfig.isAfter(minDate, nextPickerValue)) {
            nextPickerValue = minDate;
          }

          // maxDate < nextPickerValue
          var offsetPickerValue = multiplePanel ? offsetPanelDate(generateConfig, pickerMode, nextPickerValue, 1) : nextPickerValue;
          if (maxDate && generateConfig.isAfter(offsetPickerValue, maxDate)) {
            nextPickerValue = multiplePanel ? offsetPanelDate(generateConfig, pickerMode, maxDate, -1) : maxDate;
          }
          setCurrentPickerValue(nextPickerValue, 'reset');
        }
      }
    }
  }, [open, mergedActiveIndex, calendarValue[mergedActiveIndex]]);

  // >>> Reset prevActiveIndex when panel closed
  react.useEffect(function () {
    if (open) {
      prevActiveIndexRef.current = mergedActiveIndex;
    } else {
      prevActiveIndexRef.current = null;
    }
  }, [open, mergedActiveIndex]);

  // >>> defaultPickerValue: Resync to `defaultPickerValue` for each panel focused
  (0,useLayoutEffect/* default */.Z)(function () {
    if (open && defaultPickerValue) {
      if (defaultPickerValue[mergedActiveIndex]) {
        setCurrentPickerValue(defaultPickerValue[mergedActiveIndex], 'reset');
      }
    }
  }, [open, mergedActiveIndex]);
  return [currentPickerValue, setCurrentPickerValue];
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/hooks/useSyncState.js



/**
 * Sync value with state.
 * This should only used for internal which not affect outside calculation.
 * Since it's not safe for suspense.
 */
function useSyncState(defaultValue, controlledValue) {
  var valueRef = react.useRef(defaultValue);
  var _React$useState = react.useState({}),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    forceUpdate = _React$useState2[1];
  var getter = function getter(useControlledValueFirst) {
    return useControlledValueFirst && controlledValue !== undefined ? controlledValue : valueRef.current;
  };
  var setter = function setter(nextValue) {
    valueRef.current = nextValue;
    forceUpdate({});
  };
  return [getter, setter, getter(true)];
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/hooks/useRangeValue.js








var EMPTY_VALUE = [];

// Submit Logic:
// * ✅ Value:
//    * merged value using controlled value, if not, use stateValue
//    * When merged value change, [1] resync calendar value and submit value
// * ✅ Calender Value:
//    * 💻 When user typing is validate, change the calendar value
//    * 🌅 When user click on the panel, change the calendar value
// * Submit Value:
//    * 💻 When user blur the input, flush calendar value to submit value
//    * 🌅 When user click on the panel is no needConfirm, flush calendar value to submit value
//    * 🌅 When user click on the panel is needConfirm and click OK, flush calendar value to submit value
// * Blur logic & close logic:
//    * ✅ For value, always try flush submit
//    * ✅ If `needConfirm`, reset as [1]
//    * Else (`!needConfirm`)
//      * If has another index field, active another index
// * ✅ Flush submit:
//    * If all the start & end field is confirmed or all blur or panel closed
//    * Update `needSubmit` mark to true
//    * trigger onChange by `needSubmit` and update stateValue

function useUtil(generateConfig, locale, formatList) {
  var getDateTexts = function getDateTexts(dates) {
    return dates.map(function (date) {
      return formatValue(date, {
        generateConfig: generateConfig,
        locale: locale,
        format: formatList[0]
      });
    });
  };
  var isSameDates = function isSameDates(source, target) {
    var maxLen = Math.max(source.length, target.length);
    var diffIndex = -1;
    for (var i = 0; i < maxLen; i += 1) {
      var prev = source[i] || null;
      var next = target[i] || null;
      if (prev !== next && !isSameTimestamp(generateConfig, prev, next)) {
        diffIndex = i;
        break;
      }
    }
    return [diffIndex < 0, diffIndex !== 0];
  };
  return [getDateTexts, isSameDates];
}
function orderDates(dates, generateConfig) {
  return (0,toConsumableArray/* default */.Z)(dates).sort(function (a, b) {
    return generateConfig.isAfter(a, b) ? 1 : -1;
  });
}

/**
 * Used for internal value management.
 * It should always use `mergedValue` in render logic
 */
function useCalendarValue(mergedValue) {
  var _useSyncState = useSyncState(mergedValue),
    _useSyncState2 = (0,slicedToArray/* default */.Z)(_useSyncState, 2),
    calendarValue = _useSyncState2[0],
    setCalendarValue = _useSyncState2[1];

  /** Sync calendarValue & submitValue back with value */
  var syncWithValue = (0,es/* useEvent */.zX)(function () {
    setCalendarValue(mergedValue);
  });
  react.useEffect(function () {
    syncWithValue();
  }, [mergedValue]);
  return [calendarValue, setCalendarValue];
}

/**
 * Control the internal `value` align with prop `value` and provide a temp `calendarValue` for ui.
 * `calendarValue` will be reset when blur & focus & open.
 */
function useInnerValue(generateConfig, locale, formatList, /** Used for RangePicker. `true` means [DateType, DateType] or will be DateType[] */
rangeValue,
/**
 * Trigger order when trigger calendar value change.
 * This should only used in SinglePicker with `multiple` mode.
 * So when `rangeValue` is `true`, order will be ignored.
 */
order, defaultValue, value, onCalendarChange, onOk) {
  // This is the root value which will sync with controlled or uncontrolled value
  var _useMergedState = (0,es/* useMergedState */.C8)(defaultValue, {
      value: value
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    innerValue = _useMergedState2[0],
    setInnerValue = _useMergedState2[1];
  var mergedValue = innerValue || EMPTY_VALUE;

  // ========================= Inner Values =========================
  var _useCalendarValue = useCalendarValue(mergedValue),
    _useCalendarValue2 = (0,slicedToArray/* default */.Z)(_useCalendarValue, 2),
    calendarValue = _useCalendarValue2[0],
    setCalendarValue = _useCalendarValue2[1];

  // ============================ Change ============================
  var _useUtil = useUtil(generateConfig, locale, formatList),
    _useUtil2 = (0,slicedToArray/* default */.Z)(_useUtil, 2),
    getDateTexts = _useUtil2[0],
    isSameDates = _useUtil2[1];
  var triggerCalendarChange = (0,es/* useEvent */.zX)(function (nextCalendarValues) {
    var clone = (0,toConsumableArray/* default */.Z)(nextCalendarValues);
    if (rangeValue) {
      for (var i = 0; i < 2; i += 1) {
        clone[i] = clone[i] || null;
      }
    } else if (order) {
      clone = orderDates(clone.filter(function (date) {
        return date;
      }), generateConfig);
    }

    // Update merged value
    var _isSameDates = isSameDates(calendarValue(), clone),
      _isSameDates2 = (0,slicedToArray/* default */.Z)(_isSameDates, 2),
      isSameMergedDates = _isSameDates2[0],
      isSameStart = _isSameDates2[1];
    if (!isSameMergedDates) {
      setCalendarValue(clone);

      // Trigger calendar change event
      if (onCalendarChange) {
        var cellTexts = getDateTexts(clone);
        onCalendarChange(clone, cellTexts, {
          range: isSameStart ? 'end' : 'start'
        });
      }
    }
  });
  var triggerOk = function triggerOk() {
    if (onOk) {
      onOk(calendarValue());
    }
  };
  return [mergedValue, setInnerValue, calendarValue, triggerCalendarChange, triggerOk];
}
function useRangeValue(info, mergedValue, setInnerValue, getCalendarValue, triggerCalendarChange, disabled, formatList, focused, open, isInvalidateDate) {
  var generateConfig = info.generateConfig,
    locale = info.locale,
    picker = info.picker,
    onChange = info.onChange,
    allowEmpty = info.allowEmpty,
    order = info.order;
  var orderOnChange = disabled.some(function (d) {
    return d;
  }) ? false : order;

  // ============================= Util =============================
  var _useUtil3 = useUtil(generateConfig, locale, formatList),
    _useUtil4 = (0,slicedToArray/* default */.Z)(_useUtil3, 2),
    getDateTexts = _useUtil4[0],
    isSameDates = _useUtil4[1];

  // ============================ Values ============================
  // Used for trigger `onChange` event.
  // Record current value which is wait for submit.
  var _useSyncState3 = useSyncState(mergedValue),
    _useSyncState4 = (0,slicedToArray/* default */.Z)(_useSyncState3, 2),
    submitValue = _useSyncState4[0],
    setSubmitValue = _useSyncState4[1];

  /** Sync calendarValue & submitValue back with value */
  var syncWithValue = (0,es/* useEvent */.zX)(function () {
    setSubmitValue(mergedValue);
  });
  react.useEffect(function () {
    syncWithValue();
  }, [mergedValue]);

  // ============================ Submit ============================
  var triggerSubmit = (0,es/* useEvent */.zX)(function (nextValue) {
    var isNullValue = nextValue === null;
    var clone = (0,toConsumableArray/* default */.Z)(nextValue || submitValue());

    // Fill null value
    if (isNullValue) {
      var maxLen = Math.max(disabled.length, clone.length);
      for (var i = 0; i < maxLen; i += 1) {
        if (!disabled[i]) {
          clone[i] = null;
        }
      }
    }

    // Only when exist value to sort
    if (orderOnChange && clone[0] && clone[1]) {
      clone = orderDates(clone, generateConfig);
    }

    // Sync `calendarValue`
    triggerCalendarChange(clone);

    // ========= Validate check =========
    var _clone = clone,
      _clone2 = (0,slicedToArray/* default */.Z)(_clone, 2),
      start = _clone2[0],
      end = _clone2[1];

    // >>> Empty
    var startEmpty = !start;
    var endEmpty = !end;
    var validateEmptyDateRange = allowEmpty ?
    // Validate empty start
    (!startEmpty || allowEmpty[0]) && (
    // Validate empty end
    !endEmpty || allowEmpty[1]) : true;

    // >>> Order
    var validateOrder = !order || startEmpty || endEmpty || isSame(generateConfig, locale, start, end, picker) || generateConfig.isAfter(end, start);

    // >>> Invalid
    var validateDates =
    // Validate start
    (disabled[0] || !start || !isInvalidateDate(start, {
      activeIndex: 0
    })) && (
    // Validate end
    disabled[1] || !end || !isInvalidateDate(end, {
      from: start,
      activeIndex: 1
    }));
    // >>> Result
    var allPassed =
    // Null value is from clear button
    isNullValue ||
    // Normal check
    validateEmptyDateRange && validateOrder && validateDates;
    if (allPassed) {
      // Sync value with submit value
      setInnerValue(clone);
      var _isSameDates3 = isSameDates(clone, mergedValue),
        _isSameDates4 = (0,slicedToArray/* default */.Z)(_isSameDates3, 1),
        isSameMergedDates = _isSameDates4[0];

      // Trigger `onChange` if needed
      if (onChange && !isSameMergedDates) {
        onChange(
        // Return null directly if all date are empty
        isNullValue && clone.every(function (val) {
          return !val;
        }) ? null : clone, getDateTexts(clone));
      }
    }
    return allPassed;
  });

  // ========================= Flush Submit =========================
  var flushSubmit = (0,es/* useEvent */.zX)(function (index, needTriggerChange) {
    var nextSubmitValue = fillIndex(submitValue(), index, getCalendarValue()[index]);
    setSubmitValue(nextSubmitValue);
    if (needTriggerChange) {
      triggerSubmit();
    }
  });

  // ============================ Effect ============================
  // All finished action trigger after 2 frames
  var interactiveFinished = !focused && !open;
  useLockEffect(!interactiveFinished, function () {
    if (interactiveFinished) {
      // Always try to trigger submit first
      triggerSubmit();

      // Trigger calendar change since this is a effect reset
      // https://github.com/ant-design/ant-design/issues/22351
      triggerCalendarChange(mergedValue);

      // Sync with value anyway
      syncWithValue();
    }
  }, 2);

  // ============================ Return ============================
  return [flushSubmit, triggerSubmit];
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/hooks/useShowNow.js
function useShowNow(picker, mode, showNow, showToday, rangePicker) {
  if (mode !== 'date' && mode !== 'time') {
    return false;
  }
  if (showNow !== undefined) {
    return showNow;
  }

  // Compatible with old version `showToday`
  if (showToday !== undefined) {
    return showToday;
  }
  return !rangePicker && (picker === 'date' || picker === 'time');
}
// EXTERNAL MODULE: ./node_modules/rc-resize-observer/es/index.js + 4 modules
var rc_resize_observer_es = __webpack_require__(49938);
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerPanel/TimePanel/TimePanelBody/util.js

function findValidateTime(date, getHourUnits, getMinuteUnits, getSecondUnits, getMillisecondUnits, generateConfig) {
  var nextDate = date;
  function alignValidate(getUnitValue, setUnitValue, units) {
    var nextValue = generateConfig[getUnitValue](nextDate);
    var nextUnit = units.find(function (unit) {
      return unit.value === nextValue;
    });
    if (!nextUnit || nextUnit.disabled) {
      // Find most closest unit
      var validateUnits = units.filter(function (unit) {
        return !unit.disabled;
      });
      var reverseEnabledUnits = (0,toConsumableArray/* default */.Z)(validateUnits).reverse();
      var validateUnit = reverseEnabledUnits.find(function (unit) {
        return unit.value <= nextValue;
      }) || validateUnits[0];
      if (validateUnit) {
        nextValue = validateUnit.value;
        nextDate = generateConfig[setUnitValue](nextDate, nextValue);
      }
    }
    return nextValue;
  }

  // Find validate hour
  var nextHour = alignValidate('getHour', 'setHour', getHourUnits());

  // Find validate minute
  var nextMinute = alignValidate('getMinute', 'setMinute', getMinuteUnits(nextHour));

  // Find validate second
  var nextSecond = alignValidate('getSecond', 'setSecond', getSecondUnits(nextHour, nextMinute));

  // Find validate millisecond
  alignValidate('getMillisecond', 'setMillisecond', getMillisecondUnits(nextHour, nextMinute, nextSecond));
  return nextDate;
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/hooks/useTimeInfo.js






function emptyDisabled() {
  return [];
}
function generateUnits(start, end) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var hideDisabledOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var disabledUnits = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var pad = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 2;
  var units = [];
  var integerStep = step >= 1 ? step | 0 : 1;
  for (var i = start; i <= end; i += integerStep) {
    var disabled = disabledUnits.includes(i);
    if (!disabled || !hideDisabledOptions) {
      units.push({
        label: leftPad(i, pad),
        value: i,
        disabled: disabled
      });
    }
  }
  return units;
}

/**
 * Parse time props to get util info
 */
function useTimeInfo(generateConfig) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var date = arguments.length > 2 ? arguments[2] : undefined;
  var _ref = props || {},
    use12Hours = _ref.use12Hours,
    _ref$hourStep = _ref.hourStep,
    hourStep = _ref$hourStep === void 0 ? 1 : _ref$hourStep,
    _ref$minuteStep = _ref.minuteStep,
    minuteStep = _ref$minuteStep === void 0 ? 1 : _ref$minuteStep,
    _ref$secondStep = _ref.secondStep,
    secondStep = _ref$secondStep === void 0 ? 1 : _ref$secondStep,
    _ref$millisecondStep = _ref.millisecondStep,
    millisecondStep = _ref$millisecondStep === void 0 ? 100 : _ref$millisecondStep,
    hideDisabledOptions = _ref.hideDisabledOptions,
    disabledTime = _ref.disabledTime,
    disabledHours = _ref.disabledHours,
    disabledMinutes = _ref.disabledMinutes,
    disabledSeconds = _ref.disabledSeconds;
  var mergedDate = react.useMemo(function () {
    return date || generateConfig.getNow();
  }, [date, generateConfig]);

  // ======================== Warnings ========================
  if (false) { var isSecondStepValid, isMinuteStepValid, isHourStepValid; }

  // ======================== Disabled ========================
  var getDisabledTimes = react.useCallback(function (targetDate) {
    var disabledConfig = (disabledTime === null || disabledTime === void 0 ? void 0 : disabledTime(targetDate)) || {};
    return [disabledConfig.disabledHours || disabledHours || emptyDisabled, disabledConfig.disabledMinutes || disabledMinutes || emptyDisabled, disabledConfig.disabledSeconds || disabledSeconds || emptyDisabled, disabledConfig.disabledMilliseconds || emptyDisabled];
  }, [disabledTime, disabledHours, disabledMinutes, disabledSeconds]);
  var _React$useMemo = react.useMemo(function () {
      return getDisabledTimes(mergedDate);
    }, [mergedDate, getDisabledTimes]),
    _React$useMemo2 = (0,slicedToArray/* default */.Z)(_React$useMemo, 4),
    mergedDisabledHours = _React$useMemo2[0],
    mergedDisabledMinutes = _React$useMemo2[1],
    mergedDisabledSeconds = _React$useMemo2[2],
    mergedDisabledMilliseconds = _React$useMemo2[3];

  // ========================= Column =========================
  var getAllUnits = react.useCallback(function (getDisabledHours, getDisabledMinutes, getDisabledSeconds, getDisabledMilliseconds) {
    var hours = generateUnits(0, 23, hourStep, hideDisabledOptions, getDisabledHours());

    // Hours
    var rowHourUnits = use12Hours ? hours.map(function (unit) {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, unit), {}, {
        label: leftPad(unit.value % 12 || 12, 2)
      });
    }) : hours;

    // Minutes
    var getMinuteUnits = function getMinuteUnits(nextHour) {
      return generateUnits(0, 59, minuteStep, hideDisabledOptions, getDisabledMinutes(nextHour));
    };

    // Seconds
    var getSecondUnits = function getSecondUnits(nextHour, nextMinute) {
      return generateUnits(0, 59, secondStep, hideDisabledOptions, getDisabledSeconds(nextHour, nextMinute));
    };

    // Milliseconds
    var getMillisecondUnits = function getMillisecondUnits(nextHour, nextMinute, nextSecond) {
      return generateUnits(0, 999, millisecondStep, hideDisabledOptions, getDisabledMilliseconds(nextHour, nextMinute, nextSecond), 3);
    };
    return [rowHourUnits, getMinuteUnits, getSecondUnits, getMillisecondUnits];
  }, [hideDisabledOptions, hourStep, use12Hours, millisecondStep, minuteStep, secondStep]);
  var _React$useMemo3 = react.useMemo(function () {
      return getAllUnits(mergedDisabledHours, mergedDisabledMinutes, mergedDisabledSeconds, mergedDisabledMilliseconds);
    }, [getAllUnits, mergedDisabledHours, mergedDisabledMinutes, mergedDisabledSeconds, mergedDisabledMilliseconds]),
    _React$useMemo4 = (0,slicedToArray/* default */.Z)(_React$useMemo3, 4),
    rowHourUnits = _React$useMemo4[0],
    getMinuteUnits = _React$useMemo4[1],
    getSecondUnits = _React$useMemo4[2],
    getMillisecondUnits = _React$useMemo4[3];

  // ======================== Validate ========================
  /**
   * Get validate time with `disabledTime`, `certainDate` to specific the date need to check
   */
  var getValidTime = function getValidTime(nextTime, certainDate) {
    var getCheckHourUnits = function getCheckHourUnits() {
      return rowHourUnits;
    };
    var getCheckMinuteUnits = getMinuteUnits;
    var getCheckSecondUnits = getSecondUnits;
    var getCheckMillisecondUnits = getMillisecondUnits;
    if (certainDate) {
      var _getDisabledTimes = getDisabledTimes(certainDate),
        _getDisabledTimes2 = (0,slicedToArray/* default */.Z)(_getDisabledTimes, 4),
        targetDisabledHours = _getDisabledTimes2[0],
        targetDisabledMinutes = _getDisabledTimes2[1],
        targetDisabledSeconds = _getDisabledTimes2[2],
        targetDisabledMilliseconds = _getDisabledTimes2[3];
      var _getAllUnits = getAllUnits(targetDisabledHours, targetDisabledMinutes, targetDisabledSeconds, targetDisabledMilliseconds),
        _getAllUnits2 = (0,slicedToArray/* default */.Z)(_getAllUnits, 4),
        targetRowHourUnits = _getAllUnits2[0],
        targetGetMinuteUnits = _getAllUnits2[1],
        targetGetSecondUnits = _getAllUnits2[2],
        targetGetMillisecondUnits = _getAllUnits2[3];
      getCheckHourUnits = function getCheckHourUnits() {
        return targetRowHourUnits;
      };
      getCheckMinuteUnits = targetGetMinuteUnits;
      getCheckSecondUnits = targetGetSecondUnits;
      getCheckMillisecondUnits = targetGetMillisecondUnits;
    }
    var validateDate = findValidateTime(nextTime, getCheckHourUnits, getCheckMinuteUnits, getCheckSecondUnits, getCheckMillisecondUnits, generateConfig);
    return validateDate;
  };
  return [
  // getValidTime
  getValidTime,
  // Units
  rowHourUnits, getMinuteUnits, getSecondUnits, getMillisecondUnits];
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/Popup/Footer.js





function Footer(props) {
  var mode = props.mode,
    internalMode = props.internalMode,
    renderExtraFooter = props.renderExtraFooter,
    showNow = props.showNow,
    showTime = props.showTime,
    onSubmit = props.onSubmit,
    onNow = props.onNow,
    invalid = props.invalid,
    needConfirm = props.needConfirm,
    generateConfig = props.generateConfig,
    disabledDate = props.disabledDate;
  var _React$useContext = react.useContext(PickerInput_context),
    prefixCls = _React$useContext.prefixCls,
    locale = _React$useContext.locale,
    _React$useContext$but = _React$useContext.button,
    Button = _React$useContext$but === void 0 ? 'button' : _React$useContext$but;

  // >>> Now
  var now = generateConfig.getNow();
  var _useTimeInfo = useTimeInfo(generateConfig, showTime, now),
    _useTimeInfo2 = (0,slicedToArray/* default */.Z)(_useTimeInfo, 1),
    getValidTime = _useTimeInfo2[0];

  // ======================== Extra =========================
  var extraNode = renderExtraFooter === null || renderExtraFooter === void 0 ? void 0 : renderExtraFooter(mode);

  // ======================== Ranges ========================
  var nowDisabled = disabledDate(now, {
    type: mode
  });
  var onInternalNow = function onInternalNow() {
    if (!nowDisabled) {
      var validateNow = getValidTime(now);
      onNow(validateNow);
    }
  };
  var nowPrefixCls = "".concat(prefixCls, "-now");
  var nowBtnPrefixCls = "".concat(nowPrefixCls, "-btn");
  var presetNode = showNow && /*#__PURE__*/react.createElement("li", {
    className: nowPrefixCls
  }, /*#__PURE__*/react.createElement("a", {
    className: classnames_default()(nowBtnPrefixCls, nowDisabled && "".concat(nowBtnPrefixCls, "-disabled")),
    "aria-disabled": nowDisabled,
    onClick: onInternalNow
  }, internalMode === 'date' ? locale.today : locale.now));

  // >>> OK
  var okNode = needConfirm && /*#__PURE__*/react.createElement("li", {
    className: "".concat(prefixCls, "-ok")
  }, /*#__PURE__*/react.createElement(Button, {
    disabled: invalid,
    onClick: onSubmit
  }, locale.ok));
  var rangeNode = (presetNode || okNode) && /*#__PURE__*/react.createElement("ul", {
    className: "".concat(prefixCls, "-ranges")
  }, presetNode, okNode);

  // ======================== Render ========================
  if (!extraNode && !rangeNode) {
    return null;
  }
  return /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-footer")
  }, extraNode && /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-footer-extra")
  }, extraNode), rangeNode);
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/hooks/useToggleDates.js


/**
 * Toggles the presence of a value in an array.
 * If the value exists in the array, removed it.
 * Else add it.
 */
function useToggleDates(generateConfig, locale, panelMode) {
  function toggleDates(list, target) {
    var index = list.findIndex(function (date) {
      return isSame(generateConfig, locale, date, target, panelMode);
    });
    if (index === -1) {
      return [].concat((0,toConsumableArray/* default */.Z)(list), [target]);
    }
    var sliceList = (0,toConsumableArray/* default */.Z)(list);
    sliceList.splice(index, 1);
    return sliceList;
  }
  return toggleDates;
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerPanel/context.js

/** Used for each single Panel. e.g. DatePanel */
var PanelContext = /*#__PURE__*/react.createContext(null);
function usePanelContext() {
  return react.useContext(PanelContext);
}

/**
 * Get shared props for the SharedPanelProps interface.
 */
function useInfo(props, panelType) {
  var prefixCls = props.prefixCls,
    generateConfig = props.generateConfig,
    locale = props.locale,
    disabledDate = props.disabledDate,
    minDate = props.minDate,
    maxDate = props.maxDate,
    cellRender = props.cellRender,
    hoverValue = props.hoverValue,
    hoverRangeValue = props.hoverRangeValue,
    onHover = props.onHover,
    values = props.values,
    pickerValue = props.pickerValue,
    onSelect = props.onSelect,
    prevIcon = props.prevIcon,
    nextIcon = props.nextIcon,
    superPrevIcon = props.superPrevIcon,
    superNextIcon = props.superNextIcon;

  // ========================= MISC =========================
  var now = generateConfig.getNow();

  // ========================= Info =========================
  var info = {
    now: now,
    values: values,
    pickerValue: pickerValue,
    prefixCls: prefixCls,
    disabledDate: disabledDate,
    minDate: minDate,
    maxDate: maxDate,
    cellRender: cellRender,
    hoverValue: hoverValue,
    hoverRangeValue: hoverRangeValue,
    onHover: onHover,
    locale: locale,
    generateConfig: generateConfig,
    onSelect: onSelect,
    panelType: panelType,
    // Icons
    prevIcon: prevIcon,
    nextIcon: nextIcon,
    superPrevIcon: superPrevIcon,
    superNextIcon: superNextIcon
  };
  return [info, now];
}

// ============================== Internal ==============================

/**
 * Internal usage for RangePicker to not to show the operation arrow
 */
var PickerHackContext = /*#__PURE__*/react.createContext({});
if (false) {}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerPanel/PanelBody.js







function PanelBody(props) {
  var rowNum = props.rowNum,
    colNum = props.colNum,
    baseDate = props.baseDate,
    getCellDate = props.getCellDate,
    prefixColumn = props.prefixColumn,
    rowClassName = props.rowClassName,
    titleFormat = props.titleFormat,
    getCellText = props.getCellText,
    getCellClassName = props.getCellClassName,
    headerCells = props.headerCells,
    _props$cellSelection = props.cellSelection,
    cellSelection = _props$cellSelection === void 0 ? true : _props$cellSelection,
    disabledDate = props.disabledDate;
  var _usePanelContext = usePanelContext(),
    prefixCls = _usePanelContext.prefixCls,
    type = _usePanelContext.panelType,
    now = _usePanelContext.now,
    contextDisabledDate = _usePanelContext.disabledDate,
    cellRender = _usePanelContext.cellRender,
    onHover = _usePanelContext.onHover,
    hoverValue = _usePanelContext.hoverValue,
    hoverRangeValue = _usePanelContext.hoverRangeValue,
    generateConfig = _usePanelContext.generateConfig,
    values = _usePanelContext.values,
    locale = _usePanelContext.locale,
    onSelect = _usePanelContext.onSelect;
  var mergedDisabledDate = disabledDate || contextDisabledDate;
  var cellPrefixCls = "".concat(prefixCls, "-cell");

  // ============================= Context ==============================
  var _React$useContext = react.useContext(PickerHackContext),
    onCellDblClick = _React$useContext.onCellDblClick;

  // ============================== Value ===============================
  var matchValues = function matchValues(date) {
    return values.some(function (singleValue) {
      return singleValue && isSame(generateConfig, locale, date, singleValue, type);
    });
  };

  // =============================== Body ===============================
  var rows = [];
  for (var row = 0; row < rowNum; row += 1) {
    var rowNode = [];
    var rowStartDate = void 0;
    var _loop = function _loop() {
      var offset = row * colNum + col;
      var currentDate = getCellDate(baseDate, offset);
      var disabled = mergedDisabledDate === null || mergedDisabledDate === void 0 ? void 0 : mergedDisabledDate(currentDate, {
        type: type
      });

      // Row Start Cell
      if (col === 0) {
        rowStartDate = currentDate;
        if (prefixColumn) {
          rowNode.push(prefixColumn(rowStartDate));
        }
      }

      // Range
      var inRange = false;
      var rangeStart = false;
      var rangeEnd = false;
      if (cellSelection && hoverRangeValue) {
        var _hoverRangeValue = (0,slicedToArray/* default */.Z)(hoverRangeValue, 2),
          hoverStart = _hoverRangeValue[0],
          hoverEnd = _hoverRangeValue[1];
        inRange = isInRange(generateConfig, hoverStart, hoverEnd, currentDate);
        rangeStart = isSame(generateConfig, locale, currentDate, hoverStart, type);
        rangeEnd = isSame(generateConfig, locale, currentDate, hoverEnd, type);
      }

      // Title
      var title = titleFormat ? formatValue(currentDate, {
        locale: locale,
        format: titleFormat,
        generateConfig: generateConfig
      }) : undefined;

      // Render
      var inner = /*#__PURE__*/react.createElement("div", {
        className: "".concat(cellPrefixCls, "-inner")
      }, getCellText(currentDate));
      rowNode.push(/*#__PURE__*/react.createElement("td", {
        key: col,
        title: title,
        className: classnames_default()(cellPrefixCls, (0,objectSpread2/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(cellPrefixCls, "-disabled"), disabled), "".concat(cellPrefixCls, "-hover"), (hoverValue || []).some(function (date) {
          return isSame(generateConfig, locale, currentDate, date, type);
        })), "".concat(cellPrefixCls, "-in-range"), inRange && !rangeStart && !rangeEnd), "".concat(cellPrefixCls, "-range-start"), rangeStart), "".concat(cellPrefixCls, "-range-end"), rangeEnd), "".concat(prefixCls, "-cell-selected"), !hoverRangeValue &&
        // WeekPicker use row instead
        type !== 'week' && matchValues(currentDate)), getCellClassName(currentDate))),
        onClick: function onClick() {
          if (!disabled) {
            onSelect(currentDate);
          }
        },
        onDoubleClick: function onDoubleClick() {
          if (!disabled && onCellDblClick) {
            onCellDblClick();
          }
        },
        onMouseEnter: function onMouseEnter() {
          if (!disabled) {
            onHover === null || onHover === void 0 || onHover(currentDate);
          }
        },
        onMouseLeave: function onMouseLeave() {
          if (!disabled) {
            onHover === null || onHover === void 0 || onHover(null);
          }
        }
      }, cellRender ? cellRender(currentDate, {
        prefixCls: prefixCls,
        originNode: inner,
        today: now,
        type: type,
        locale: locale
      }) : inner));
    };
    for (var col = 0; col < colNum; col += 1) {
      _loop();
    }
    rows.push(/*#__PURE__*/react.createElement("tr", {
      key: row,
      className: rowClassName === null || rowClassName === void 0 ? void 0 : rowClassName(rowStartDate)
    }, rowNode));
  }

  // ============================== Render ==============================
  return /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-body")
  }, /*#__PURE__*/react.createElement("table", {
    className: "".concat(prefixCls, "-content")
  }, headerCells && /*#__PURE__*/react.createElement("thead", null, /*#__PURE__*/react.createElement("tr", null, headerCells)), /*#__PURE__*/react.createElement("tbody", null, rows)));
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerPanel/PanelHeader.js




var HIDDEN_STYLE = {
  visibility: 'hidden'
};
function PanelHeader(props) {
  var offset = props.offset,
    superOffset = props.superOffset,
    onChange = props.onChange,
    getStart = props.getStart,
    getEnd = props.getEnd,
    children = props.children;
  var _usePanelContext = usePanelContext(),
    prefixCls = _usePanelContext.prefixCls,
    _usePanelContext$prev = _usePanelContext.prevIcon,
    prevIcon = _usePanelContext$prev === void 0 ? "\u2039" : _usePanelContext$prev,
    _usePanelContext$next = _usePanelContext.nextIcon,
    nextIcon = _usePanelContext$next === void 0 ? "\u203A" : _usePanelContext$next,
    _usePanelContext$supe = _usePanelContext.superPrevIcon,
    superPrevIcon = _usePanelContext$supe === void 0 ? "\xAB" : _usePanelContext$supe,
    _usePanelContext$supe2 = _usePanelContext.superNextIcon,
    superNextIcon = _usePanelContext$supe2 === void 0 ? "\xBB" : _usePanelContext$supe2,
    minDate = _usePanelContext.minDate,
    maxDate = _usePanelContext.maxDate,
    generateConfig = _usePanelContext.generateConfig,
    locale = _usePanelContext.locale,
    pickerValue = _usePanelContext.pickerValue,
    type = _usePanelContext.panelType;
  var headerPrefixCls = "".concat(prefixCls, "-header");
  var _React$useContext = react.useContext(PickerHackContext),
    hidePrev = _React$useContext.hidePrev,
    hideNext = _React$useContext.hideNext,
    hideHeader = _React$useContext.hideHeader;

  // ======================= Limitation =======================
  var disabledOffsetPrev = react.useMemo(function () {
    if (!minDate || !offset || !getEnd) {
      return false;
    }
    var prevPanelLimitDate = getEnd(offset(-1, pickerValue));
    return !isSameOrAfter(generateConfig, locale, prevPanelLimitDate, minDate, type);
  }, [minDate, offset, pickerValue, getEnd, generateConfig, locale, type]);
  var disabledSuperOffsetPrev = react.useMemo(function () {
    if (!minDate || !superOffset || !getEnd) {
      return false;
    }
    var prevPanelLimitDate = getEnd(superOffset(-1, pickerValue));
    return !isSameOrAfter(generateConfig, locale, prevPanelLimitDate, minDate, type);
  }, [minDate, superOffset, pickerValue, getEnd, generateConfig, locale, type]);
  var disabledOffsetNext = react.useMemo(function () {
    if (!maxDate || !offset || !getStart) {
      return false;
    }
    var nextPanelLimitDate = getStart(offset(1, pickerValue));
    return !isSameOrAfter(generateConfig, locale, maxDate, nextPanelLimitDate, type);
  }, [maxDate, offset, pickerValue, getStart, generateConfig, locale, type]);
  var disabledSuperOffsetNext = react.useMemo(function () {
    if (!maxDate || !superOffset || !getStart) {
      return false;
    }
    var nextPanelLimitDate = getStart(superOffset(1, pickerValue));
    return !isSameOrAfter(generateConfig, locale, maxDate, nextPanelLimitDate, type);
  }, [maxDate, superOffset, pickerValue, getStart, generateConfig, locale, type]);

  // ========================= Offset =========================
  var onOffset = function onOffset(distance) {
    if (offset) {
      onChange(offset(distance, pickerValue));
    }
  };
  var onSuperOffset = function onSuperOffset(distance) {
    if (superOffset) {
      onChange(superOffset(distance, pickerValue));
    }
  };

  // ========================= Render =========================
  if (hideHeader) {
    return null;
  }
  var prevBtnCls = "".concat(headerPrefixCls, "-prev-btn");
  var nextBtnCls = "".concat(headerPrefixCls, "-next-btn");
  var superPrevBtnCls = "".concat(headerPrefixCls, "-super-prev-btn");
  var superNextBtnCls = "".concat(headerPrefixCls, "-super-next-btn");
  return /*#__PURE__*/react.createElement("div", {
    className: headerPrefixCls
  }, superOffset && /*#__PURE__*/react.createElement("button", {
    type: "button",
    "aria-label": locale.previousYear,
    onClick: function onClick() {
      return onSuperOffset(-1);
    },
    tabIndex: -1,
    className: classnames_default()(superPrevBtnCls, disabledSuperOffsetPrev && "".concat(superPrevBtnCls, "-disabled")),
    disabled: disabledSuperOffsetPrev,
    style: hidePrev ? HIDDEN_STYLE : {}
  }, superPrevIcon), offset && /*#__PURE__*/react.createElement("button", {
    type: "button",
    "aria-label": locale.previousMonth,
    onClick: function onClick() {
      return onOffset(-1);
    },
    tabIndex: -1,
    className: classnames_default()(prevBtnCls, disabledOffsetPrev && "".concat(prevBtnCls, "-disabled")),
    disabled: disabledOffsetPrev,
    style: hidePrev ? HIDDEN_STYLE : {}
  }, prevIcon), /*#__PURE__*/react.createElement("div", {
    className: "".concat(headerPrefixCls, "-view")
  }, children), offset && /*#__PURE__*/react.createElement("button", {
    type: "button",
    "aria-label": locale.nextMonth,
    onClick: function onClick() {
      return onOffset(1);
    },
    tabIndex: -1,
    className: classnames_default()(nextBtnCls, disabledOffsetNext && "".concat(nextBtnCls, "-disabled")),
    disabled: disabledOffsetNext,
    style: hideNext ? HIDDEN_STYLE : {}
  }, nextIcon), superOffset && /*#__PURE__*/react.createElement("button", {
    type: "button",
    "aria-label": locale.nextYear,
    onClick: function onClick() {
      return onSuperOffset(1);
    },
    tabIndex: -1,
    className: classnames_default()(superNextBtnCls, disabledSuperOffsetNext && "".concat(superNextBtnCls, "-disabled")),
    disabled: disabledSuperOffsetNext,
    style: hideNext ? HIDDEN_STYLE : {}
  }, superNextIcon));
}
/* harmony default export */ var PickerPanel_PanelHeader = (PanelHeader);
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerPanel/DatePanel/index.js









function DatePanel(props) {
  var prefixCls = props.prefixCls,
    _props$panelName = props.panelName,
    panelName = _props$panelName === void 0 ? 'date' : _props$panelName,
    locale = props.locale,
    generateConfig = props.generateConfig,
    pickerValue = props.pickerValue,
    onPickerValueChange = props.onPickerValueChange,
    onModeChange = props.onModeChange,
    _props$mode = props.mode,
    mode = _props$mode === void 0 ? 'date' : _props$mode,
    disabledDate = props.disabledDate,
    onSelect = props.onSelect,
    onHover = props.onHover,
    showWeek = props.showWeek;
  var panelPrefixCls = "".concat(prefixCls, "-").concat(panelName, "-panel");
  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var isWeek = mode === 'week';

  // ========================== Base ==========================
  var _useInfo = useInfo(props, mode),
    _useInfo2 = (0,slicedToArray/* default */.Z)(_useInfo, 2),
    info = _useInfo2[0],
    now = _useInfo2[1];
  var weekFirstDay = generateConfig.locale.getWeekFirstDay(locale.locale);
  var monthStartDate = generateConfig.setDate(pickerValue, 1);
  var baseDate = getWeekStartDate(locale.locale, generateConfig, monthStartDate);
  var month = generateConfig.getMonth(pickerValue);

  // =========================== PrefixColumn ===========================
  var showPrefixColumn = showWeek === undefined ? isWeek : showWeek;
  var prefixColumn = showPrefixColumn ? function (date) {
    // >>> Additional check for disabled
    var disabled = disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date, {
      type: 'week'
    });
    return /*#__PURE__*/react.createElement("td", {
      key: "week",
      className: classnames_default()(cellPrefixCls, "".concat(cellPrefixCls, "-week"), (0,defineProperty/* default */.Z)({}, "".concat(cellPrefixCls, "-disabled"), disabled))
      // Operation: Same as code in PanelBody
      ,

      onClick: function onClick() {
        if (!disabled) {
          onSelect(date);
        }
      },
      onMouseEnter: function onMouseEnter() {
        if (!disabled) {
          onHover === null || onHover === void 0 || onHover(date);
        }
      },
      onMouseLeave: function onMouseLeave() {
        if (!disabled) {
          onHover === null || onHover === void 0 || onHover(null);
        }
      }
    }, /*#__PURE__*/react.createElement("div", {
      className: "".concat(cellPrefixCls, "-inner")
    }, generateConfig.locale.getWeek(locale.locale, date)));
  } : null;

  // ========================= Cells ==========================
  // >>> Header Cells
  var headerCells = [];
  var weekDaysLocale = locale.shortWeekDays || (generateConfig.locale.getShortWeekDays ? generateConfig.locale.getShortWeekDays(locale.locale) : []);
  if (prefixColumn) {
    headerCells.push(/*#__PURE__*/react.createElement("th", {
      key: "empty"
    }, /*#__PURE__*/react.createElement("span", {
      style: {
        width: 0,
        height: 0,
        position: 'absolute',
        overflow: 'hidden',
        opacity: 0
      }
    }, locale.week)));
  }
  for (var i = 0; i < WEEK_DAY_COUNT; i += 1) {
    headerCells.push(/*#__PURE__*/react.createElement("th", {
      key: i
    }, weekDaysLocale[(i + weekFirstDay) % WEEK_DAY_COUNT]));
  }

  // >>> Body Cells
  var getCellDate = function getCellDate(date, offset) {
    return generateConfig.addDate(date, offset);
  };
  var getCellText = function getCellText(date) {
    return formatValue(date, {
      locale: locale,
      format: locale.cellDateFormat,
      generateConfig: generateConfig
    });
  };
  var getCellClassName = function getCellClassName(date) {
    var classObj = (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-cell-in-view"), isSameMonth(generateConfig, date, pickerValue)), "".concat(prefixCls, "-cell-today"), isSameDate(generateConfig, date, now));
    return classObj;
  };

  // ========================= Header =========================
  var monthsLocale = locale.shortMonths || (generateConfig.locale.getShortMonths ? generateConfig.locale.getShortMonths(locale.locale) : []);
  var yearNode = /*#__PURE__*/react.createElement("button", {
    type: "button",
    "aria-label": locale.yearSelect,
    key: "year",
    onClick: function onClick() {
      onModeChange('year', pickerValue);
    },
    tabIndex: -1,
    className: "".concat(prefixCls, "-year-btn")
  }, formatValue(pickerValue, {
    locale: locale,
    format: locale.yearFormat,
    generateConfig: generateConfig
  }));
  var monthNode = /*#__PURE__*/react.createElement("button", {
    type: "button",
    "aria-label": locale.monthSelect,
    key: "month",
    onClick: function onClick() {
      onModeChange('month', pickerValue);
    },
    tabIndex: -1,
    className: "".concat(prefixCls, "-month-btn")
  }, locale.monthFormat ? formatValue(pickerValue, {
    locale: locale,
    format: locale.monthFormat,
    generateConfig: generateConfig
  }) : monthsLocale[month]);
  var monthYearNodes = locale.monthBeforeYear ? [monthNode, yearNode] : [yearNode, monthNode];

  // ========================= Render =========================
  return /*#__PURE__*/react.createElement(PanelContext.Provider, {
    value: info
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(panelPrefixCls, showWeek && "".concat(panelPrefixCls, "-show-week"))
  }, /*#__PURE__*/react.createElement(PickerPanel_PanelHeader, {
    offset: function offset(distance) {
      return generateConfig.addMonth(pickerValue, distance);
    },
    superOffset: function superOffset(distance) {
      return generateConfig.addYear(pickerValue, distance);
    },
    onChange: onPickerValueChange
    // Limitation
    ,

    getStart: function getStart(date) {
      return generateConfig.setDate(date, 1);
    },
    getEnd: function getEnd(date) {
      var clone = generateConfig.setDate(date, 1);
      clone = generateConfig.addMonth(clone, 1);
      return generateConfig.addDate(clone, -1);
    }
  }, monthYearNodes), /*#__PURE__*/react.createElement(PanelBody, (0,esm_extends/* default */.Z)({
    titleFormat: locale.fieldDateFormat
  }, props, {
    colNum: WEEK_DAY_COUNT,
    rowNum: 6,
    baseDate: baseDate
    // Header
    ,

    headerCells: headerCells
    // Body
    ,

    getCellDate: getCellDate,
    getCellText: getCellText,
    getCellClassName: getCellClassName,
    prefixColumn: prefixColumn,
    cellSelection: !isWeek
  }))));
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/isVisible.js
var isVisible = __webpack_require__(29504);
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerPanel/TimePanel/TimePanelBody/useScrollTo.js




var SPEED_PTG = 1 / 3;
function useScrollTo(ulRef, value) {
  // ========================= Scroll =========================
  var scrollingRef = react.useRef(false);
  var scrollRafRef = react.useRef(null);
  var scrollDistRef = react.useRef(null);
  var isScrolling = function isScrolling() {
    return scrollingRef.current;
  };
  var stopScroll = function stopScroll() {
    raf/* default.cancel */.Z.cancel(scrollRafRef.current);
    scrollingRef.current = false;
  };
  var scrollRafTimesRef = react.useRef();
  var startScroll = function startScroll() {
    var ul = ulRef.current;
    scrollDistRef.current = null;
    scrollRafTimesRef.current = 0;
    if (ul) {
      var targetLi = ul.querySelector("[data-value=\"".concat(value, "\"]"));
      var firstLi = ul.querySelector("li");
      var doScroll = function doScroll() {
        stopScroll();
        scrollingRef.current = true;
        scrollRafTimesRef.current += 1;
        var currentTop = ul.scrollTop;
        var firstLiTop = firstLi.offsetTop;
        var targetLiTop = targetLi.offsetTop;
        var targetTop = targetLiTop - firstLiTop;

        // Wait for element exist. 5 frames is enough
        if (targetLiTop === 0 && targetLi !== firstLi || !(0,isVisible/* default */.Z)(ul)) {
          if (scrollRafTimesRef.current <= 5) {
            scrollRafRef.current = (0,raf/* default */.Z)(doScroll);
          }
          return;
        }
        var nextTop = currentTop + (targetTop - currentTop) * SPEED_PTG;
        var dist = Math.abs(targetTop - nextTop);

        // Break if dist get larger, which means user is scrolling
        if (scrollDistRef.current !== null && scrollDistRef.current < dist) {
          stopScroll();
          return;
        }
        scrollDistRef.current = dist;

        // Stop when dist is less than 1
        if (dist <= 1) {
          ul.scrollTop = targetTop;
          stopScroll();
          return;
        }

        // IE not support `scrollTo`
        ul.scrollTop = nextTop;
        scrollRafRef.current = (0,raf/* default */.Z)(doScroll);
      };
      if (targetLi && firstLi) {
        doScroll();
      }
    }
  };

  // ======================== Trigger =========================
  var syncScroll = (0,es/* useEvent */.zX)(startScroll);
  return [syncScroll, stopScroll, isScrolling];
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerPanel/TimePanel/TimePanelBody/TimeColumn.js








var SCROLL_DELAY = 300;
// Not use JSON.stringify to avoid dead loop
function flattenUnits(units) {
  return units.map(function (_ref) {
    var value = _ref.value,
      label = _ref.label,
      disabled = _ref.disabled;
    return [value, label, disabled].join(',');
  }).join(';');
}
function TimeColumn(props) {
  var units = props.units,
    value = props.value,
    optionalValue = props.optionalValue,
    type = props.type,
    onChange = props.onChange,
    onHover = props.onHover,
    onDblClick = props.onDblClick,
    changeOnScroll = props.changeOnScroll;
  var _usePanelContext = usePanelContext(),
    prefixCls = _usePanelContext.prefixCls,
    cellRender = _usePanelContext.cellRender,
    now = _usePanelContext.now,
    locale = _usePanelContext.locale;
  var panelPrefixCls = "".concat(prefixCls, "-time-panel");
  var cellPrefixCls = "".concat(prefixCls, "-time-panel-cell");

  // ========================== Refs ==========================
  var ulRef = react.useRef(null);

  // ========================= Scroll =========================
  var checkDelayRef = react.useRef();
  var clearDelayCheck = function clearDelayCheck() {
    clearTimeout(checkDelayRef.current);
  };

  // ========================== Sync ==========================
  var _useScrollTo = useScrollTo(ulRef, value !== null && value !== void 0 ? value : optionalValue),
    _useScrollTo2 = (0,slicedToArray/* default */.Z)(_useScrollTo, 3),
    syncScroll = _useScrollTo2[0],
    stopScroll = _useScrollTo2[1],
    isScrolling = _useScrollTo2[2];

  // Effect sync value scroll
  (0,useLayoutEffect/* default */.Z)(function () {
    syncScroll();
    clearDelayCheck();
    return function () {
      stopScroll();
      clearDelayCheck();
    };
  }, [value, optionalValue, flattenUnits(units)]);

  // ========================= Change =========================
  // Scroll event if sync onScroll
  var onInternalScroll = function onInternalScroll(event) {
    clearDelayCheck();
    var target = event.target;
    if (!isScrolling() && changeOnScroll) {
      checkDelayRef.current = setTimeout(function () {
        var ul = ulRef.current;
        var firstLiTop = ul.querySelector("li").offsetTop;
        var liList = Array.from(ul.querySelectorAll("li"));
        var liTopList = liList.map(function (li) {
          return li.offsetTop - firstLiTop;
        });
        var liDistList = liTopList.map(function (top, index) {
          if (units[index].disabled) {
            return Number.MAX_SAFE_INTEGER;
          }
          return Math.abs(top - target.scrollTop);
        });

        // Find min distance index
        var minDist = Math.min.apply(Math, (0,toConsumableArray/* default */.Z)(liDistList));
        var minDistIndex = liDistList.findIndex(function (dist) {
          return dist === minDist;
        });
        var targetUnit = units[minDistIndex];
        if (targetUnit && !targetUnit.disabled) {
          onChange(targetUnit.value);
        }
      }, SCROLL_DELAY);
    }
  };

  // ========================= Render =========================
  var columnPrefixCls = "".concat(panelPrefixCls, "-column");
  return /*#__PURE__*/react.createElement("ul", {
    className: columnPrefixCls,
    ref: ulRef,
    "data-type": type,
    onScroll: onInternalScroll
  }, units.map(function (_ref2) {
    var label = _ref2.label,
      unitValue = _ref2.value,
      disabled = _ref2.disabled;
    var inner = /*#__PURE__*/react.createElement("div", {
      className: "".concat(cellPrefixCls, "-inner")
    }, label);
    return /*#__PURE__*/react.createElement("li", {
      key: unitValue,
      className: classnames_default()(cellPrefixCls, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(cellPrefixCls, "-selected"), value === unitValue), "".concat(cellPrefixCls, "-disabled"), disabled)),
      onClick: function onClick() {
        if (!disabled) {
          onChange(unitValue);
        }
      },
      onDoubleClick: function onDoubleClick() {
        if (!disabled && onDblClick) {
          onDblClick();
        }
      },
      onMouseEnter: function onMouseEnter() {
        onHover(unitValue);
      },
      onMouseLeave: function onMouseLeave() {
        onHover(null);
      },
      "data-value": unitValue
    }, cellRender ? cellRender(unitValue, {
      prefixCls: prefixCls,
      originNode: inner,
      today: now,
      type: 'time',
      subType: type,
      locale: locale
    }) : inner);
  }));
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerPanel/TimePanel/TimePanelBody/index.js







function isAM(hour) {
  return hour < 12;
}
function TimePanelBody(props) {
  var showHour = props.showHour,
    showMinute = props.showMinute,
    showSecond = props.showSecond,
    showMillisecond = props.showMillisecond,
    showMeridiem = props.use12Hours,
    changeOnScroll = props.changeOnScroll;
  var _usePanelContext = usePanelContext(),
    prefixCls = _usePanelContext.prefixCls,
    values = _usePanelContext.values,
    generateConfig = _usePanelContext.generateConfig,
    locale = _usePanelContext.locale,
    onSelect = _usePanelContext.onSelect,
    _usePanelContext$onHo = _usePanelContext.onHover,
    onHover = _usePanelContext$onHo === void 0 ? function () {} : _usePanelContext$onHo,
    pickerValue = _usePanelContext.pickerValue;
  var value = (values === null || values === void 0 ? void 0 : values[0]) || null;
  var _React$useContext = react.useContext(PickerHackContext),
    onCellDblClick = _React$useContext.onCellDblClick;

  // ========================== Info ==========================
  var _useTimeInfo = useTimeInfo(generateConfig, props, value),
    _useTimeInfo2 = (0,slicedToArray/* default */.Z)(_useTimeInfo, 5),
    getValidTime = _useTimeInfo2[0],
    rowHourUnits = _useTimeInfo2[1],
    getMinuteUnits = _useTimeInfo2[2],
    getSecondUnits = _useTimeInfo2[3],
    getMillisecondUnits = _useTimeInfo2[4];

  // ========================= Value ==========================
  // PickerValue will tell which one to align on the top
  var getUnitValue = function getUnitValue(func) {
    var valueUnitVal = value && generateConfig[func](value);
    var pickerUnitValue = pickerValue && generateConfig[func](pickerValue);
    return [valueUnitVal, pickerUnitValue];
  };
  var _getUnitValue = getUnitValue('getHour'),
    _getUnitValue2 = (0,slicedToArray/* default */.Z)(_getUnitValue, 2),
    hour = _getUnitValue2[0],
    pickerHour = _getUnitValue2[1];
  var _getUnitValue3 = getUnitValue('getMinute'),
    _getUnitValue4 = (0,slicedToArray/* default */.Z)(_getUnitValue3, 2),
    minute = _getUnitValue4[0],
    pickerMinute = _getUnitValue4[1];
  var _getUnitValue5 = getUnitValue('getSecond'),
    _getUnitValue6 = (0,slicedToArray/* default */.Z)(_getUnitValue5, 2),
    second = _getUnitValue6[0],
    pickerSecond = _getUnitValue6[1];
  var _getUnitValue7 = getUnitValue('getMillisecond'),
    _getUnitValue8 = (0,slicedToArray/* default */.Z)(_getUnitValue7, 2),
    millisecond = _getUnitValue8[0],
    pickerMillisecond = _getUnitValue8[1];
  var meridiem = hour === null ? null : isAM(hour) ? 'am' : 'pm';

  // ========================= Column =========================
  // Hours
  var hourUnits = react.useMemo(function () {
    if (!showMeridiem) {
      return rowHourUnits;
    }
    return isAM(hour) ? rowHourUnits.filter(function (h) {
      return isAM(h.value);
    }) : rowHourUnits.filter(function (h) {
      return !isAM(h.value);
    });
  }, [hour, rowHourUnits, showMeridiem]);

  // >>> Pick Fallback
  var getEnabled = function getEnabled(units, val) {
    var _enabledUnits$;
    var enabledUnits = units.filter(function (unit) {
      return !unit.disabled;
    });
    return val !== null && val !== void 0 ? val :
    // Fallback to enabled value
    enabledUnits === null || enabledUnits === void 0 || (_enabledUnits$ = enabledUnits[0]) === null || _enabledUnits$ === void 0 ? void 0 : _enabledUnits$.value;
  };

  // >>> Minutes
  var validHour = getEnabled(rowHourUnits, hour);
  var minuteUnits = react.useMemo(function () {
    return getMinuteUnits(validHour);
  }, [getMinuteUnits, validHour]);

  // >>> Seconds
  var validMinute = getEnabled(minuteUnits, minute);
  var secondUnits = react.useMemo(function () {
    return getSecondUnits(validHour, validMinute);
  }, [getSecondUnits, validHour, validMinute]);

  // >>> Milliseconds
  var validSecond = getEnabled(secondUnits, second);
  var millisecondUnits = react.useMemo(function () {
    return getMillisecondUnits(validHour, validMinute, validSecond);
  }, [getMillisecondUnits, validHour, validMinute, validSecond]);
  var validMillisecond = getEnabled(millisecondUnits, millisecond);

  // Meridiem
  var meridiemUnits = react.useMemo(function () {
    if (!showMeridiem) {
      return [];
    }
    var base = generateConfig.getNow();
    var amDate = generateConfig.setHour(base, 6);
    var pmDate = generateConfig.setHour(base, 18);
    var formatMeridiem = function formatMeridiem(date, defaultLabel) {
      var cellMeridiemFormat = locale.cellMeridiemFormat;
      return cellMeridiemFormat ? formatValue(date, {
        generateConfig: generateConfig,
        locale: locale,
        format: cellMeridiemFormat
      }) : defaultLabel;
    };
    return [{
      label: formatMeridiem(amDate, 'AM'),
      value: 'am',
      disabled: rowHourUnits.every(function (h) {
        return h.disabled || !isAM(h.value);
      })
    }, {
      label: formatMeridiem(pmDate, 'PM'),
      value: 'pm',
      disabled: rowHourUnits.every(function (h) {
        return h.disabled || isAM(h.value);
      })
    }];
  }, [rowHourUnits, showMeridiem, generateConfig, locale]);

  // ========================= Change =========================
  /**
   * Check if time is validate or will match to validate one
   */
  var triggerChange = function triggerChange(nextDate) {
    var validateDate = getValidTime(nextDate);
    onSelect(validateDate);
  };

  // ========================= Column =========================
  // Create a template date for the trigger change event
  var triggerDateTmpl = react.useMemo(function () {
    var tmpl = value || pickerValue || generateConfig.getNow();
    var isNotNull = function isNotNull(num) {
      return num !== null && num !== undefined;
    };
    if (isNotNull(hour)) {
      tmpl = generateConfig.setHour(tmpl, hour);
      tmpl = generateConfig.setMinute(tmpl, minute);
      tmpl = generateConfig.setSecond(tmpl, second);
      tmpl = generateConfig.setMillisecond(tmpl, millisecond);
    } else if (isNotNull(pickerHour)) {
      tmpl = generateConfig.setHour(tmpl, pickerHour);
      tmpl = generateConfig.setMinute(tmpl, pickerMinute);
      tmpl = generateConfig.setSecond(tmpl, pickerSecond);
      tmpl = generateConfig.setMillisecond(tmpl, pickerMillisecond);
    } else if (isNotNull(validHour)) {
      tmpl = generateConfig.setHour(tmpl, validHour);
      tmpl = generateConfig.setMinute(tmpl, validMinute);
      tmpl = generateConfig.setSecond(tmpl, validSecond);
      tmpl = generateConfig.setMillisecond(tmpl, validMillisecond);
    }
    return tmpl;
  }, [value, pickerValue, hour, minute, second, millisecond, validHour, validMinute, validSecond, validMillisecond, pickerHour, pickerMinute, pickerSecond, pickerMillisecond, generateConfig]);

  // ===================== Columns Change =====================
  var fillColumnValue = function fillColumnValue(val, func) {
    if (val === null) {
      return null;
    }
    return generateConfig[func](triggerDateTmpl, val);
  };
  var getNextHourTime = function getNextHourTime(val) {
    return fillColumnValue(val, 'setHour');
  };
  var getNextMinuteTime = function getNextMinuteTime(val) {
    return fillColumnValue(val, 'setMinute');
  };
  var getNextSecondTime = function getNextSecondTime(val) {
    return fillColumnValue(val, 'setSecond');
  };
  var getNextMillisecondTime = function getNextMillisecondTime(val) {
    return fillColumnValue(val, 'setMillisecond');
  };
  var getMeridiemTime = function getMeridiemTime(val) {
    if (val === null) {
      return null;
    }
    if (val === 'am' && !isAM(hour)) {
      return generateConfig.setHour(triggerDateTmpl, hour - 12);
    } else if (val === 'pm' && isAM(hour)) {
      return generateConfig.setHour(triggerDateTmpl, hour + 12);
    }
    return triggerDateTmpl;
  };
  var onHourChange = function onHourChange(val) {
    triggerChange(getNextHourTime(val));
  };
  var onMinuteChange = function onMinuteChange(val) {
    triggerChange(getNextMinuteTime(val));
  };
  var onSecondChange = function onSecondChange(val) {
    triggerChange(getNextSecondTime(val));
  };
  var onMillisecondChange = function onMillisecondChange(val) {
    triggerChange(getNextMillisecondTime(val));
  };
  var onMeridiemChange = function onMeridiemChange(val) {
    triggerChange(getMeridiemTime(val));
  };

  // ====================== Column Hover ======================
  var onHourHover = function onHourHover(val) {
    onHover(getNextHourTime(val));
  };
  var onMinuteHover = function onMinuteHover(val) {
    onHover(getNextMinuteTime(val));
  };
  var onSecondHover = function onSecondHover(val) {
    onHover(getNextSecondTime(val));
  };
  var onMillisecondHover = function onMillisecondHover(val) {
    onHover(getNextMillisecondTime(val));
  };
  var onMeridiemHover = function onMeridiemHover(val) {
    onHover(getMeridiemTime(val));
  };

  // ========================= Render =========================
  var sharedColumnProps = {
    onDblClick: onCellDblClick,
    changeOnScroll: changeOnScroll
  };
  return /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-content")
  }, showHour && /*#__PURE__*/react.createElement(TimeColumn, (0,esm_extends/* default */.Z)({
    units: hourUnits,
    value: hour,
    optionalValue: pickerHour,
    type: "hour",
    onChange: onHourChange,
    onHover: onHourHover
  }, sharedColumnProps)), showMinute && /*#__PURE__*/react.createElement(TimeColumn, (0,esm_extends/* default */.Z)({
    units: minuteUnits,
    value: minute,
    optionalValue: pickerMinute,
    type: "minute",
    onChange: onMinuteChange,
    onHover: onMinuteHover
  }, sharedColumnProps)), showSecond && /*#__PURE__*/react.createElement(TimeColumn, (0,esm_extends/* default */.Z)({
    units: secondUnits,
    value: second,
    optionalValue: pickerSecond,
    type: "second",
    onChange: onSecondChange,
    onHover: onSecondHover
  }, sharedColumnProps)), showMillisecond && /*#__PURE__*/react.createElement(TimeColumn, (0,esm_extends/* default */.Z)({
    units: millisecondUnits,
    value: millisecond,
    optionalValue: pickerMillisecond,
    type: "millisecond",
    onChange: onMillisecondChange,
    onHover: onMillisecondHover
  }, sharedColumnProps)), showMeridiem && /*#__PURE__*/react.createElement(TimeColumn, (0,esm_extends/* default */.Z)({
    units: meridiemUnits,
    value: meridiem,
    type: "meridiem",
    onChange: onMeridiemChange,
    onHover: onMeridiemHover
  }, sharedColumnProps)));
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerPanel/TimePanel/index.js







function TimePanel(props) {
  var prefixCls = props.prefixCls,
    value = props.value,
    locale = props.locale,
    generateConfig = props.generateConfig,
    showTime = props.showTime;
  var _ref = showTime || {},
    format = _ref.format;
  var panelPrefixCls = "".concat(prefixCls, "-time-panel");

  // ========================== Base ==========================
  var _useInfo = useInfo(props, 'time'),
    _useInfo2 = (0,slicedToArray/* default */.Z)(_useInfo, 1),
    info = _useInfo2[0];

  // ========================= Render =========================
  return /*#__PURE__*/react.createElement(PanelContext.Provider, {
    value: info
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(panelPrefixCls)
  }, /*#__PURE__*/react.createElement(PickerPanel_PanelHeader, null, value ? formatValue(value, {
    locale: locale,
    format: format,
    generateConfig: generateConfig
  }) : "\xA0"), /*#__PURE__*/react.createElement(TimePanelBody, showTime)));
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerPanel/DateTimePanel/index.js







function DateTimePanel(props) {
  var prefixCls = props.prefixCls,
    generateConfig = props.generateConfig,
    showTime = props.showTime,
    onSelect = props.onSelect,
    value = props.value,
    pickerValue = props.pickerValue,
    onHover = props.onHover;
  var panelPrefixCls = "".concat(prefixCls, "-datetime-panel");

  // =============================== Time ===============================
  var _useTimeInfo = useTimeInfo(generateConfig, showTime),
    _useTimeInfo2 = (0,slicedToArray/* default */.Z)(_useTimeInfo, 1),
    getValidTime = _useTimeInfo2[0];

  // Merge the time info from `value` or `pickerValue`
  var mergeTime = function mergeTime(date) {
    if (value) {
      return fillTime(generateConfig, date, value);
    }
    return fillTime(generateConfig, date, pickerValue);
  };

  // ============================== Hover ===============================
  var onDateHover = function onDateHover(date) {
    onHover === null || onHover === void 0 || onHover(date ? mergeTime(date) : date);
  };

  // ============================== Select ==============================
  var onDateSelect = function onDateSelect(date) {
    // Merge with current time
    var cloneDate = mergeTime(date);
    onSelect(getValidTime(cloneDate, cloneDate));
  };

  // ============================== Render ==============================
  return /*#__PURE__*/react.createElement("div", {
    className: panelPrefixCls
  }, /*#__PURE__*/react.createElement(DatePanel, (0,esm_extends/* default */.Z)({}, props, {
    onSelect: onDateSelect,
    onHover: onDateHover
  })), /*#__PURE__*/react.createElement(TimePanel, props));
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerPanel/DecadePanel/index.js








function DecadePanel(props) {
  var prefixCls = props.prefixCls,
    locale = props.locale,
    generateConfig = props.generateConfig,
    pickerValue = props.pickerValue,
    disabledDate = props.disabledDate,
    onPickerValueChange = props.onPickerValueChange;
  var panelPrefixCls = "".concat(prefixCls, "-decade-panel");

  // ========================== Base ==========================
  var _useInfo = useInfo(props, 'decade'),
    _useInfo2 = (0,slicedToArray/* default */.Z)(_useInfo, 1),
    info = _useInfo2[0];
  var getStartYear = function getStartYear(date) {
    var startYear = Math.floor(generateConfig.getYear(date) / 100) * 100;
    return generateConfig.setYear(date, startYear);
  };
  var getEndYear = function getEndYear(date) {
    var startYear = getStartYear(date);
    return generateConfig.addYear(startYear, 99);
  };
  var startYearDate = getStartYear(pickerValue);
  var endYearDate = getEndYear(pickerValue);
  var baseDate = generateConfig.addYear(startYearDate, -10);

  // ========================= Cells ==========================
  var getCellDate = function getCellDate(date, offset) {
    return generateConfig.addYear(date, offset * 10);
  };
  var getCellText = function getCellText(date) {
    var cellYearFormat = locale.cellYearFormat;
    var startYearStr = formatValue(date, {
      locale: locale,
      format: cellYearFormat,
      generateConfig: generateConfig
    });
    var endYearStr = formatValue(generateConfig.addYear(date, 9), {
      locale: locale,
      format: cellYearFormat,
      generateConfig: generateConfig
    });
    return "".concat(startYearStr, "-").concat(endYearStr);
  };
  var getCellClassName = function getCellClassName(date) {
    return (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-cell-in-view"), isSameDecade(generateConfig, date, startYearDate) || isSameDecade(generateConfig, date, endYearDate) || isInRange(generateConfig, startYearDate, endYearDate, date));
  };

  // ======================== Disabled ========================
  var mergedDisabledDate = disabledDate ? function (currentDate, disabledInfo) {
    // Start
    var baseStartDate = generateConfig.setDate(currentDate, 1);
    var baseStartMonth = generateConfig.setMonth(baseStartDate, 0);
    var baseStartYear = generateConfig.setYear(baseStartMonth, Math.floor(generateConfig.getYear(baseStartMonth) / 10) * 10);

    // End
    var baseEndYear = generateConfig.addYear(baseStartYear, 10);
    var baseEndDate = generateConfig.addDate(baseEndYear, -1);
    return disabledDate(baseStartYear, disabledInfo) && disabledDate(baseEndDate, disabledInfo);
  } : null;

  // ========================= Header =========================
  var yearNode = "".concat(formatValue(startYearDate, {
    locale: locale,
    format: locale.yearFormat,
    generateConfig: generateConfig
  }), "-").concat(formatValue(endYearDate, {
    locale: locale,
    format: locale.yearFormat,
    generateConfig: generateConfig
  }));

  // ========================= Render =========================
  return /*#__PURE__*/react.createElement(PanelContext.Provider, {
    value: info
  }, /*#__PURE__*/react.createElement("div", {
    className: panelPrefixCls
  }, /*#__PURE__*/react.createElement(PickerPanel_PanelHeader, {
    superOffset: function superOffset(distance) {
      return generateConfig.addYear(pickerValue, distance * 100);
    },
    onChange: onPickerValueChange
    // Limitation
    ,

    getStart: getStartYear,
    getEnd: getEndYear
  }, yearNode), /*#__PURE__*/react.createElement(PanelBody, (0,esm_extends/* default */.Z)({}, props, {
    disabledDate: mergedDisabledDate,
    colNum: 3,
    rowNum: 4,
    baseDate: baseDate
    // Body
    ,

    getCellDate: getCellDate,
    getCellText: getCellText,
    getCellClassName: getCellClassName
  }))));
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerPanel/MonthPanel/index.js








function MonthPanel(props) {
  var prefixCls = props.prefixCls,
    locale = props.locale,
    generateConfig = props.generateConfig,
    pickerValue = props.pickerValue,
    disabledDate = props.disabledDate,
    onPickerValueChange = props.onPickerValueChange,
    onModeChange = props.onModeChange;
  var panelPrefixCls = "".concat(prefixCls, "-month-panel");

  // ========================== Base ==========================
  var _useInfo = useInfo(props, 'month'),
    _useInfo2 = (0,slicedToArray/* default */.Z)(_useInfo, 1),
    info = _useInfo2[0];
  var baseDate = generateConfig.setMonth(pickerValue, 0);

  // ========================= Month ==========================
  var monthsLocale = locale.shortMonths || (generateConfig.locale.getShortMonths ? generateConfig.locale.getShortMonths(locale.locale) : []);

  // ========================= Cells ==========================
  var getCellDate = function getCellDate(date, offset) {
    return generateConfig.addMonth(date, offset);
  };
  var getCellText = function getCellText(date) {
    var month = generateConfig.getMonth(date);
    return locale.monthFormat ? formatValue(date, {
      locale: locale,
      format: locale.monthFormat,
      generateConfig: generateConfig
    }) : monthsLocale[month];
  };
  var getCellClassName = function getCellClassName() {
    return (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-cell-in-view"), true);
  };

  // ======================== Disabled ========================
  var mergedDisabledDate = disabledDate ? function (currentDate, disabledInfo) {
    var startDate = generateConfig.setDate(currentDate, 1);
    var nextMonthStartDate = generateConfig.setMonth(startDate, generateConfig.getMonth(startDate) + 1);
    var endDate = generateConfig.addDate(nextMonthStartDate, -1);
    return disabledDate(startDate, disabledInfo) && disabledDate(endDate, disabledInfo);
  } : null;

  // ========================= Header =========================
  var yearNode = /*#__PURE__*/react.createElement("button", {
    type: "button",
    key: "year",
    "aria-label": locale.yearSelect,
    onClick: function onClick() {
      onModeChange('year');
    },
    tabIndex: -1,
    className: "".concat(prefixCls, "-year-btn")
  }, formatValue(pickerValue, {
    locale: locale,
    format: locale.yearFormat,
    generateConfig: generateConfig
  }));

  // ========================= Render =========================
  return /*#__PURE__*/react.createElement(PanelContext.Provider, {
    value: info
  }, /*#__PURE__*/react.createElement("div", {
    className: panelPrefixCls
  }, /*#__PURE__*/react.createElement(PickerPanel_PanelHeader, {
    superOffset: function superOffset(distance) {
      return generateConfig.addYear(pickerValue, distance);
    },
    onChange: onPickerValueChange
    // Limitation
    ,

    getStart: function getStart(date) {
      return generateConfig.setMonth(date, 0);
    },
    getEnd: function getEnd(date) {
      return generateConfig.setMonth(date, 11);
    }
  }, yearNode), /*#__PURE__*/react.createElement(PanelBody, (0,esm_extends/* default */.Z)({}, props, {
    disabledDate: mergedDisabledDate,
    titleFormat: locale.fieldMonthFormat,
    colNum: 3,
    rowNum: 4,
    baseDate: baseDate
    // Body
    ,

    getCellDate: getCellDate,
    getCellText: getCellText,
    getCellClassName: getCellClassName
  }))));
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerPanel/QuarterPanel/index.js








function QuarterPanel(props) {
  var prefixCls = props.prefixCls,
    locale = props.locale,
    generateConfig = props.generateConfig,
    pickerValue = props.pickerValue,
    onPickerValueChange = props.onPickerValueChange,
    onModeChange = props.onModeChange;
  var panelPrefixCls = "".concat(prefixCls, "-quarter-panel");

  // ========================== Base ==========================
  var _useInfo = useInfo(props, 'quarter'),
    _useInfo2 = (0,slicedToArray/* default */.Z)(_useInfo, 1),
    info = _useInfo2[0];
  var baseDate = generateConfig.setMonth(pickerValue, 0);

  // ========================= Cells ==========================
  var getCellDate = function getCellDate(date, offset) {
    return generateConfig.addMonth(date, offset * 3);
  };
  var getCellText = function getCellText(date) {
    return formatValue(date, {
      locale: locale,
      format: locale.cellQuarterFormat,
      generateConfig: generateConfig
    });
  };
  var getCellClassName = function getCellClassName() {
    return (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-cell-in-view"), true);
  };

  // ========================= Header =========================
  var yearNode = /*#__PURE__*/react.createElement("button", {
    type: "button",
    key: "year",
    "aria-label": locale.yearSelect,
    onClick: function onClick() {
      onModeChange('year');
    },
    tabIndex: -1,
    className: "".concat(prefixCls, "-year-btn")
  }, formatValue(pickerValue, {
    locale: locale,
    format: locale.yearFormat,
    generateConfig: generateConfig
  }));

  // ========================= Render =========================
  return /*#__PURE__*/react.createElement(PanelContext.Provider, {
    value: info
  }, /*#__PURE__*/react.createElement("div", {
    className: panelPrefixCls
  }, /*#__PURE__*/react.createElement(PickerPanel_PanelHeader, {
    superOffset: function superOffset(distance) {
      return generateConfig.addYear(pickerValue, distance);
    },
    onChange: onPickerValueChange
    // Limitation
    ,

    getStart: function getStart(date) {
      return generateConfig.setMonth(date, 0);
    },
    getEnd: function getEnd(date) {
      return generateConfig.setMonth(date, 11);
    }
  }, yearNode), /*#__PURE__*/react.createElement(PanelBody, (0,esm_extends/* default */.Z)({}, props, {
    titleFormat: locale.fieldQuarterFormat,
    colNum: 4,
    rowNum: 1,
    baseDate: baseDate
    // Body
    ,

    getCellDate: getCellDate,
    getCellText: getCellText,
    getCellClassName: getCellClassName
  }))));
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerPanel/WeekPanel/index.js







function WeekPanel(props) {
  var prefixCls = props.prefixCls,
    generateConfig = props.generateConfig,
    locale = props.locale,
    value = props.value,
    hoverValue = props.hoverValue,
    hoverRangeValue = props.hoverRangeValue;

  // =============================== Row ================================
  var localeName = locale.locale;
  var rowPrefixCls = "".concat(prefixCls, "-week-panel-row");
  var rowClassName = function rowClassName(currentDate) {
    var rangeCls = {};
    if (hoverRangeValue) {
      var _hoverRangeValue = (0,slicedToArray/* default */.Z)(hoverRangeValue, 2),
        rangeStart = _hoverRangeValue[0],
        rangeEnd = _hoverRangeValue[1];
      var isRangeStart = isSameWeek(generateConfig, localeName, rangeStart, currentDate);
      var isRangeEnd = isSameWeek(generateConfig, localeName, rangeEnd, currentDate);
      rangeCls["".concat(rowPrefixCls, "-range-start")] = isRangeStart;
      rangeCls["".concat(rowPrefixCls, "-range-end")] = isRangeEnd;
      rangeCls["".concat(rowPrefixCls, "-range-hover")] = !isRangeStart && !isRangeEnd && isInRange(generateConfig, rangeStart, rangeEnd, currentDate);
    }
    if (hoverValue) {
      rangeCls["".concat(rowPrefixCls, "-hover")] = hoverValue.some(function (date) {
        return isSameWeek(generateConfig, localeName, currentDate, date);
      });
    }
    return classnames_default()(rowPrefixCls, (0,defineProperty/* default */.Z)({}, "".concat(rowPrefixCls, "-selected"), !hoverRangeValue && isSameWeek(generateConfig, localeName, value, currentDate)),
    // Patch for hover range
    rangeCls);
  };

  // ============================== Render ==============================
  return /*#__PURE__*/react.createElement(DatePanel, (0,esm_extends/* default */.Z)({}, props, {
    mode: "week",
    panelName: "week",
    rowClassName: rowClassName
  }));
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerPanel/YearPanel/index.js








function YearPanel(props) {
  var prefixCls = props.prefixCls,
    locale = props.locale,
    generateConfig = props.generateConfig,
    pickerValue = props.pickerValue,
    disabledDate = props.disabledDate,
    onPickerValueChange = props.onPickerValueChange,
    onModeChange = props.onModeChange;
  var panelPrefixCls = "".concat(prefixCls, "-year-panel");

  // ========================== Base ==========================
  var _useInfo = useInfo(props, 'year'),
    _useInfo2 = (0,slicedToArray/* default */.Z)(_useInfo, 1),
    info = _useInfo2[0];
  var getStartYear = function getStartYear(date) {
    var startYear = Math.floor(generateConfig.getYear(date) / 10) * 10;
    return generateConfig.setYear(date, startYear);
  };
  var getEndYear = function getEndYear(date) {
    var startYear = getStartYear(date);
    return generateConfig.addYear(startYear, 9);
  };
  var startYearDate = getStartYear(pickerValue);
  var endYearDate = getEndYear(pickerValue);
  var baseDate = generateConfig.addYear(startYearDate, -1);

  // ========================= Cells ==========================
  var getCellDate = function getCellDate(date, offset) {
    return generateConfig.addYear(date, offset);
  };
  var getCellText = function getCellText(date) {
    return formatValue(date, {
      locale: locale,
      format: locale.cellYearFormat,
      generateConfig: generateConfig
    });
  };
  var getCellClassName = function getCellClassName(date) {
    return (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-cell-in-view"), isSameYear(generateConfig, date, startYearDate) || isSameYear(generateConfig, date, endYearDate) || isInRange(generateConfig, startYearDate, endYearDate, date));
  };

  // ======================== Disabled ========================
  var mergedDisabledDate = disabledDate ? function (currentDate, disabledInfo) {
    // Start
    var startMonth = generateConfig.setMonth(currentDate, 0);
    var startDate = generateConfig.setDate(startMonth, 1);

    // End
    var endMonth = generateConfig.addYear(startDate, 1);
    var endDate = generateConfig.addDate(endMonth, -1);
    return disabledDate(startDate, disabledInfo) && disabledDate(endDate, disabledInfo);
  } : null;

  // ========================= Header =========================
  var yearNode = /*#__PURE__*/react.createElement("button", {
    type: "button",
    key: "decade",
    "aria-label": locale.decadeSelect,
    onClick: function onClick() {
      onModeChange('decade');
    },
    tabIndex: -1,
    className: "".concat(prefixCls, "-decade-btn")
  }, formatValue(startYearDate, {
    locale: locale,
    format: locale.yearFormat,
    generateConfig: generateConfig
  }), "-", formatValue(endYearDate, {
    locale: locale,
    format: locale.yearFormat,
    generateConfig: generateConfig
  }));

  // ========================= Render =========================
  return /*#__PURE__*/react.createElement(PanelContext.Provider, {
    value: info
  }, /*#__PURE__*/react.createElement("div", {
    className: panelPrefixCls
  }, /*#__PURE__*/react.createElement(PickerPanel_PanelHeader, {
    superOffset: function superOffset(distance) {
      return generateConfig.addYear(pickerValue, distance * 10);
    },
    onChange: onPickerValueChange
    // Limitation
    ,

    getStart: getStartYear,
    getEnd: getEndYear
  }, yearNode), /*#__PURE__*/react.createElement(PanelBody, (0,esm_extends/* default */.Z)({}, props, {
    disabledDate: mergedDisabledDate,
    titleFormat: locale.fieldYearFormat,
    colNum: 3,
    rowNum: 4,
    baseDate: baseDate
    // Body
    ,

    getCellDate: getCellDate,
    getCellText: getCellText,
    getCellClassName: getCellClassName
  }))));
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerPanel/index.js
























var DefaultComponents = {
  date: DatePanel,
  datetime: DateTimePanel,
  week: WeekPanel,
  month: MonthPanel,
  quarter: QuarterPanel,
  year: YearPanel,
  decade: DecadePanel,
  time: TimePanel
};
function PickerPanel(props, ref) {
  var _React$useContext;
  var locale = props.locale,
    generateConfig = props.generateConfig,
    direction = props.direction,
    prefixCls = props.prefixCls,
    _props$tabIndex = props.tabIndex,
    tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
    multiple = props.multiple,
    defaultValue = props.defaultValue,
    value = props.value,
    onChange = props.onChange,
    onSelect = props.onSelect,
    defaultPickerValue = props.defaultPickerValue,
    pickerValue = props.pickerValue,
    onPickerValueChange = props.onPickerValueChange,
    mode = props.mode,
    onPanelChange = props.onPanelChange,
    _props$picker = props.picker,
    picker = _props$picker === void 0 ? 'date' : _props$picker,
    showTime = props.showTime,
    hoverValue = props.hoverValue,
    hoverRangeValue = props.hoverRangeValue,
    cellRender = props.cellRender,
    dateRender = props.dateRender,
    monthCellRender = props.monthCellRender,
    _props$components = props.components,
    components = _props$components === void 0 ? {} : _props$components,
    hideHeader = props.hideHeader;
  var mergedPrefixCls = ((_React$useContext = react.useContext(PickerInput_context)) === null || _React$useContext === void 0 ? void 0 : _React$useContext.prefixCls) || prefixCls || 'rc-picker';

  // ========================== Refs ==========================
  var rootRef = react.useRef();
  react.useImperativeHandle(ref, function () {
    return {
      nativeElement: rootRef.current
    };
  });

  // ========================== Time ==========================
  // Auto `format` need to check `showTime.showXXX` first.
  // And then merge the `locale` into `mergedShowTime`.
  var _getTimeProps = getTimeProps(props),
    _getTimeProps2 = (0,slicedToArray/* default */.Z)(_getTimeProps, 4),
    timeProps = _getTimeProps2[0],
    localeTimeProps = _getTimeProps2[1],
    showTimeFormat = _getTimeProps2[2],
    propFormat = _getTimeProps2[3];

  // ========================= Locale =========================
  var filledLocale = useLocale(locale, localeTimeProps);

  // ========================= Picker =========================
  var internalPicker = picker === 'date' && showTime ? 'datetime' : picker;

  // ======================== ShowTime ========================
  var mergedShowTime = react.useMemo(function () {
    return fillShowTimeConfig(internalPicker, showTimeFormat, propFormat, timeProps, filledLocale);
  }, [internalPicker, showTimeFormat, propFormat, timeProps, filledLocale]);

  // ========================== Now ===========================
  var now = generateConfig.getNow();

  // ========================== Mode ==========================
  var _useMergedState = (0,es/* useMergedState */.C8)(picker, {
      value: mode,
      postState: function postState(val) {
        return val || 'date';
      }
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    mergedMode = _useMergedState2[0],
    setMergedMode = _useMergedState2[1];
  var internalMode = mergedMode === 'date' && mergedShowTime ? 'datetime' : mergedMode;

  // ========================= Toggle =========================
  var toggleDates = useToggleDates(generateConfig, locale, internalPicker);

  // ========================= Value ==========================
  // >>> Real value
  // Interactive with `onChange` event which only trigger when the `mode` is `picker`
  var _useMergedState3 = (0,es/* useMergedState */.C8)(defaultValue, {
      value: value
    }),
    _useMergedState4 = (0,slicedToArray/* default */.Z)(_useMergedState3, 2),
    innerValue = _useMergedState4[0],
    setMergedValue = _useMergedState4[1];
  var mergedValue = react.useMemo(function () {
    // Clean up `[null]`
    var values = toArray(innerValue).filter(function (val) {
      return val;
    });
    return multiple ? values : values.slice(0, 1);
  }, [innerValue, multiple]);

  // Sync value and only trigger onChange event when changed
  var triggerChange = (0,es/* useEvent */.zX)(function (nextValue) {
    setMergedValue(nextValue);
    if (onChange && (nextValue === null || mergedValue.length !== nextValue.length || mergedValue.some(function (ori, index) {
      return !isSame(generateConfig, locale, ori, nextValue[index], internalPicker);
    }))) {
      onChange === null || onChange === void 0 || onChange(multiple ? nextValue : nextValue[0]);
    }
  });

  // >>> CalendarValue
  // CalendarValue is a temp value for user operation
  // which will only trigger `onCalendarChange` but not `onChange`
  var onInternalSelect = (0,es/* useEvent */.zX)(function (newDate) {
    onSelect === null || onSelect === void 0 || onSelect(newDate);
    if (mergedMode === picker) {
      var nextValues = multiple ? toggleDates(mergedValue, newDate) : [newDate];
      triggerChange(nextValues);
    }
  });

  // >>> PickerValue
  // PickerValue is used to control the current displaying panel
  var _useMergedState5 = (0,es/* useMergedState */.C8)(defaultPickerValue || mergedValue[0] || now, {
      value: pickerValue
    }),
    _useMergedState6 = (0,slicedToArray/* default */.Z)(_useMergedState5, 2),
    mergedPickerValue = _useMergedState6[0],
    setInternalPickerValue = _useMergedState6[1];
  react.useEffect(function () {
    if (mergedValue[0] && !pickerValue) {
      setInternalPickerValue(mergedValue[0]);
    }
  }, [mergedValue[0]]);

  // Both trigger when manually pickerValue or mode change
  var triggerPanelChange = function triggerPanelChange(viewDate, nextMode) {
    onPanelChange === null || onPanelChange === void 0 || onPanelChange(viewDate || pickerValue, nextMode || mergedMode);
  };
  var setPickerValue = function setPickerValue(nextPickerValue) {
    var triggerPanelEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    setInternalPickerValue(nextPickerValue);
    onPickerValueChange === null || onPickerValueChange === void 0 || onPickerValueChange(nextPickerValue);
    if (triggerPanelEvent) {
      triggerPanelChange(nextPickerValue);
    }
  };
  var triggerModeChange = function triggerModeChange(nextMode, viewDate) {
    setMergedMode(nextMode);
    if (viewDate) {
      setPickerValue(viewDate);
    }
    triggerPanelChange(viewDate, nextMode);
  };
  var onPanelValueSelect = function onPanelValueSelect(nextValue) {
    onInternalSelect(nextValue);
    setPickerValue(nextValue);

    // Update mode if needed
    if (mergedMode !== picker) {
      var decadeYearQueue = ['decade', 'year'];
      var decadeYearMonthQueue = [].concat(decadeYearQueue, ['month']);
      var pickerQueue = {
        quarter: [].concat(decadeYearQueue, ['quarter']),
        week: [].concat((0,toConsumableArray/* default */.Z)(decadeYearMonthQueue), ['week']),
        date: [].concat((0,toConsumableArray/* default */.Z)(decadeYearMonthQueue), ['date'])
      };
      var queue = pickerQueue[picker] || decadeYearMonthQueue;
      var index = queue.indexOf(mergedMode);
      var nextMode = queue[index + 1];
      if (nextMode) {
        triggerModeChange(nextMode, nextValue);
      }
    }
  };

  // ======================= Hover Date =======================
  var hoverRangeDate = react.useMemo(function () {
    var start;
    var end;
    if (Array.isArray(hoverRangeValue)) {
      var _hoverRangeValue = (0,slicedToArray/* default */.Z)(hoverRangeValue, 2);
      start = _hoverRangeValue[0];
      end = _hoverRangeValue[1];
    } else {
      start = hoverRangeValue;
    }

    // Return for not exist
    if (!start && !end) {
      return null;
    }

    // Fill if has empty
    start = start || end;
    end = end || start;
    return generateConfig.isAfter(start, end) ? [end, start] : [start, end];
  }, [hoverRangeValue, generateConfig]);

  // ======================= Components =======================
  // >>> cellRender
  var onInternalCellRender = useCellRender(cellRender, dateRender, monthCellRender);

  // ======================= Components =======================
  var PanelComponent = components[internalMode] || DefaultComponents[internalMode] || DatePanel;

  // ======================== Context =========================
  var parentHackContext = react.useContext(PickerHackContext);
  var pickerPanelContext = react.useMemo(function () {
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, parentHackContext), {}, {
      hideHeader: hideHeader
    });
  }, [parentHackContext, hideHeader]);

  // ======================== Warnings ========================
  if (false) {}

  // ========================= Render =========================
  var panelCls = "".concat(mergedPrefixCls, "-panel");
  var panelProps = pickProps(props, [
  // Week
  'showWeek',
  // Icons
  'prevIcon', 'nextIcon', 'superPrevIcon', 'superNextIcon',
  // Disabled
  'disabledDate', 'minDate', 'maxDate',
  // Hover
  'onHover']);
  return /*#__PURE__*/react.createElement(PickerHackContext.Provider, {
    value: pickerPanelContext
  }, /*#__PURE__*/react.createElement("div", {
    ref: rootRef,
    tabIndex: tabIndex,
    className: classnames_default()(panelCls, (0,defineProperty/* default */.Z)({}, "".concat(panelCls, "-rtl"), direction === 'rtl'))
  }, /*#__PURE__*/react.createElement(PanelComponent, (0,esm_extends/* default */.Z)({}, panelProps, {
    // Time
    showTime: mergedShowTime
    // MISC
    ,

    prefixCls: mergedPrefixCls,
    locale: filledLocale,
    generateConfig: generateConfig
    // Mode
    ,

    onModeChange: triggerModeChange
    // Value
    ,

    pickerValue: mergedPickerValue,
    onPickerValueChange: function onPickerValueChange(nextPickerValue) {
      setPickerValue(nextPickerValue, true);
    },
    value: mergedValue[0],
    onSelect: onPanelValueSelect,
    values: mergedValue
    // Render
    ,

    cellRender: onInternalCellRender
    // Hover
    ,

    hoverRangeValue: hoverRangeDate,
    hoverValue: hoverValue
  }))));
}
var RefPanelPicker = /*#__PURE__*/react.memo(/*#__PURE__*/react.forwardRef(PickerPanel));
if (false) {}

// Make support generic
/* harmony default export */ var es_PickerPanel = (RefPanelPicker);
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/Popup/PopupPanel.js







function PopupPanel(props) {
  var picker = props.picker,
    multiplePanel = props.multiplePanel,
    pickerValue = props.pickerValue,
    onPickerValueChange = props.onPickerValueChange,
    needConfirm = props.needConfirm,
    onSubmit = props.onSubmit,
    range = props.range,
    hoverValue = props.hoverValue;
  var _React$useContext = react.useContext(PickerInput_context),
    prefixCls = _React$useContext.prefixCls,
    generateConfig = _React$useContext.generateConfig;

  // ======================== Offset ========================
  var internalOffsetDate = react.useCallback(function (date, offset) {
    return offsetPanelDate(generateConfig, picker, date, offset);
  }, [generateConfig, picker]);
  var nextPickerValue = react.useMemo(function () {
    return internalOffsetDate(pickerValue, 1);
  }, [pickerValue, internalOffsetDate]);

  // Outside
  var onSecondPickerValueChange = function onSecondPickerValueChange(nextDate) {
    onPickerValueChange(internalOffsetDate(nextDate, -1));
  };

  // ======================= Context ========================
  var sharedContext = {
    onCellDblClick: function onCellDblClick() {
      if (needConfirm) {
        onSubmit();
      }
    }
  };
  var hideHeader = picker === 'time';

  // ======================== Props =========================
  var pickerProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    hoverValue: null,
    hoverRangeValue: null,
    hideHeader: hideHeader
  });
  if (range) {
    pickerProps.hoverRangeValue = hoverValue;
  } else {
    pickerProps.hoverValue = hoverValue;
  }

  // ======================== Render ========================
  // Multiple
  if (multiplePanel) {
    return /*#__PURE__*/react.createElement("div", {
      className: "".concat(prefixCls, "-panels")
    }, /*#__PURE__*/react.createElement(PickerHackContext.Provider, {
      value: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, sharedContext), {}, {
        hideNext: true
      })
    }, /*#__PURE__*/react.createElement(es_PickerPanel, pickerProps)), /*#__PURE__*/react.createElement(PickerHackContext.Provider, {
      value: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, sharedContext), {}, {
        hidePrev: true
      })
    }, /*#__PURE__*/react.createElement(es_PickerPanel, (0,esm_extends/* default */.Z)({}, pickerProps, {
      pickerValue: nextPickerValue,
      onPickerValueChange: onSecondPickerValueChange
    }))));
  }

  // Single
  return /*#__PURE__*/react.createElement(PickerHackContext.Provider, {
    value: (0,objectSpread2/* default */.Z)({}, sharedContext)
  }, /*#__PURE__*/react.createElement(es_PickerPanel, pickerProps));
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/Popup/PresetPanel.js

function executeValue(value) {
  return typeof value === 'function' ? value() : value;
}
function PresetPanel(props) {
  var prefixCls = props.prefixCls,
    presets = props.presets,
    _onClick = props.onClick,
    onHover = props.onHover;
  if (!presets.length) {
    return null;
  }
  return /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-presets")
  }, /*#__PURE__*/react.createElement("ul", null, presets.map(function (_ref, index) {
    var label = _ref.label,
      value = _ref.value;
    return /*#__PURE__*/react.createElement("li", {
      key: index,
      onClick: function onClick() {
        _onClick(executeValue(value));
      },
      onMouseEnter: function onMouseEnter() {
        onHover(executeValue(value));
      },
      onMouseLeave: function onMouseLeave() {
        onHover(null);
      }
    }, label);
  })));
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/Popup/index.js











function Popup(props) {
  var panelRender = props.panelRender,
    internalMode = props.internalMode,
    picker = props.picker,
    showNow = props.showNow,
    range = props.range,
    multiple = props.multiple,
    _props$activeInfo = props.activeInfo,
    activeInfo = _props$activeInfo === void 0 ? [0, 0, 0] : _props$activeInfo,
    presets = props.presets,
    onPresetHover = props.onPresetHover,
    onPresetSubmit = props.onPresetSubmit,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onPanelMouseDown = props.onPanelMouseDown,
    direction = props.direction,
    value = props.value,
    onSelect = props.onSelect,
    isInvalid = props.isInvalid,
    defaultOpenValue = props.defaultOpenValue,
    onOk = props.onOk,
    onSubmit = props.onSubmit;
  var _React$useContext = react.useContext(PickerInput_context),
    prefixCls = _React$useContext.prefixCls;
  var panelPrefixCls = "".concat(prefixCls, "-panel");
  var rtl = direction === 'rtl';

  // ========================= Refs =========================
  var arrowRef = react.useRef(null);
  var wrapperRef = react.useRef(null);

  // ======================== Offset ========================
  var _React$useState = react.useState(0),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    containerWidth = _React$useState2[0],
    setContainerWidth = _React$useState2[1];
  var _React$useState3 = react.useState(0),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    containerOffset = _React$useState4[0],
    setContainerOffset = _React$useState4[1];
  var _React$useState5 = react.useState(0),
    _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
    arrowOffset = _React$useState6[0],
    setArrowOffset = _React$useState6[1];
  var onResize = function onResize(info) {
    if (info.width) {
      setContainerWidth(info.width);
    }
  };
  var _activeInfo = (0,slicedToArray/* default */.Z)(activeInfo, 3),
    activeInputLeft = _activeInfo[0],
    activeInputRight = _activeInfo[1],
    selectorWidth = _activeInfo[2];
  var _React$useState7 = react.useState(0),
    _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
    retryTimes = _React$useState8[0],
    setRetryTimes = _React$useState8[1];
  react.useEffect(function () {
    setRetryTimes(10);
  }, [activeInputLeft]);
  react.useEffect(function () {
    // `activeOffset` is always align with the active input element
    // So we need only check container contains the `activeOffset`
    if (range && wrapperRef.current) {
      var _arrowRef$current;
      // Offset in case container has border radius
      var arrowWidth = ((_arrowRef$current = arrowRef.current) === null || _arrowRef$current === void 0 ? void 0 : _arrowRef$current.offsetWidth) || 0;

      // Arrow Offset
      var wrapperRect = wrapperRef.current.getBoundingClientRect();
      if (!wrapperRect.height || wrapperRect.right < 0) {
        setRetryTimes(function (times) {
          return Math.max(0, times - 1);
        });
        return;
      }
      var nextArrowOffset = (rtl ? activeInputRight - arrowWidth : activeInputLeft) - wrapperRect.left;
      setArrowOffset(nextArrowOffset);

      // Container Offset
      if (containerWidth && containerWidth < selectorWidth) {
        var offset = rtl ? wrapperRect.right - (activeInputRight - arrowWidth + containerWidth) : activeInputLeft + arrowWidth - wrapperRect.left - containerWidth;
        var safeOffset = Math.max(0, offset);
        setContainerOffset(safeOffset);
      } else {
        setContainerOffset(0);
      }
    }
  }, [retryTimes, rtl, containerWidth, activeInputLeft, activeInputRight, selectorWidth, range]);

  // ======================== Custom ========================
  function filterEmpty(list) {
    return list.filter(function (item) {
      return item;
    });
  }
  var valueList = react.useMemo(function () {
    return filterEmpty(toArray(value));
  }, [value]);
  var isTimePickerEmptyValue = picker === 'time' && !valueList.length;
  var footerSubmitValue = react.useMemo(function () {
    if (isTimePickerEmptyValue) {
      return filterEmpty([defaultOpenValue]);
    }
    return valueList;
  }, [isTimePickerEmptyValue, valueList, defaultOpenValue]);
  var popupPanelValue = isTimePickerEmptyValue ? defaultOpenValue : valueList;
  var disableSubmit = react.useMemo(function () {
    // Empty is invalid
    if (!footerSubmitValue.length) {
      return true;
    }
    return footerSubmitValue.some(function (val) {
      return isInvalid(val);
    });
  }, [footerSubmitValue, isInvalid]);
  var onFooterSubmit = function onFooterSubmit() {
    // For TimePicker, we will additional trigger the value update
    if (isTimePickerEmptyValue) {
      onSelect(defaultOpenValue);
    }
    onOk();
    onSubmit();
  };
  var mergedNodes = /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-panel-layout")
  }, /*#__PURE__*/react.createElement(PresetPanel, {
    prefixCls: prefixCls,
    presets: presets,
    onClick: onPresetSubmit,
    onHover: onPresetHover
  }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(PopupPanel, (0,esm_extends/* default */.Z)({}, props, {
    value: popupPanelValue
  })), /*#__PURE__*/react.createElement(Footer, (0,esm_extends/* default */.Z)({}, props, {
    showNow: multiple ? false : showNow,
    invalid: disableSubmit,
    onSubmit: onFooterSubmit
  }))));
  if (panelRender) {
    mergedNodes = panelRender(mergedNodes);
  }

  // ======================== Render ========================
  var containerPrefixCls = "".concat(panelPrefixCls, "-container");
  var marginLeft = 'marginLeft';
  var marginRight = 'marginRight';

  // Container
  var renderNode = /*#__PURE__*/react.createElement("div", {
    onMouseDown: onPanelMouseDown,
    tabIndex: -1,
    className: classnames_default()(containerPrefixCls,
    // Used for Today Button style, safe to remove if no need
    "".concat(prefixCls, "-").concat(internalMode, "-panel-container")),
    style: (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, rtl ? marginRight : marginLeft, containerOffset), rtl ? marginLeft : marginRight, 'auto')
    // Still wish not to lose focus on mouse down
    // onMouseDown={(e) => {
    //   // e.preventDefault();
    // }}
    ,

    onFocus: onFocus,
    onBlur: onBlur
  }, mergedNodes);
  if (range) {
    renderNode = /*#__PURE__*/react.createElement("div", {
      onMouseDown: onPanelMouseDown,
      ref: wrapperRef,
      className: classnames_default()("".concat(prefixCls, "-range-wrapper"), "".concat(prefixCls, "-").concat(picker, "-range-wrapper"))
    }, /*#__PURE__*/react.createElement("div", {
      ref: arrowRef,
      className: "".concat(prefixCls, "-range-arrow"),
      style: {
        left: arrowOffset
      }
    }), /*#__PURE__*/react.createElement(rc_resize_observer_es/* default */.Z, {
      onResize: onResize
    }, renderNode));
  }
  return renderNode;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/Selector/hooks/useInputProps.js





function useInputProps(props, /** Used for SinglePicker */
postProps) {
  var format = props.format,
    maskFormat = props.maskFormat,
    generateConfig = props.generateConfig,
    locale = props.locale,
    preserveInvalidOnBlur = props.preserveInvalidOnBlur,
    inputReadOnly = props.inputReadOnly,
    required = props.required,
    ariaRequired = props['aria-required'],
    onSubmit = props.onSubmit,
    _onFocus = props.onFocus,
    _onBlur = props.onBlur,
    onInputChange = props.onInputChange,
    onInvalid = props.onInvalid,
    open = props.open,
    onOpenChange = props.onOpenChange,
    _onKeyDown = props.onKeyDown,
    _onChange = props.onChange,
    activeHelp = props.activeHelp,
    name = props.name,
    autoComplete = props.autoComplete,
    id = props.id,
    value = props.value,
    invalid = props.invalid,
    placeholder = props.placeholder,
    disabled = props.disabled,
    activeIndex = props.activeIndex,
    allHelp = props.allHelp,
    picker = props.picker;

  // ======================== Parser ========================
  var parseDate = function parseDate(str, formatStr) {
    var parsed = generateConfig.locale.parse(locale.locale, str, [formatStr]);
    return parsed && generateConfig.isValidate(parsed) ? parsed : null;
  };

  // ========================= Text =========================
  var firstFormat = format[0];
  var getText = react.useCallback(function (date) {
    return formatValue(date, {
      locale: locale,
      format: firstFormat,
      generateConfig: generateConfig
    });
  }, [locale, generateConfig, firstFormat]);
  var valueTexts = react.useMemo(function () {
    return value.map(getText);
  }, [value, getText]);

  // ========================= Size =========================
  var size = react.useMemo(function () {
    var defaultSize = picker === 'time' ? 8 : 10;
    var length = typeof firstFormat === 'function' ? firstFormat(generateConfig.getNow()).length : firstFormat.length;
    return Math.max(defaultSize, length) + 2;
  }, [firstFormat, picker, generateConfig]);

  // ======================= Validate =======================
  var _validateFormat = function validateFormat(text) {
    for (var i = 0; i < format.length; i += 1) {
      var singleFormat = format[i];

      // Only support string type
      if (typeof singleFormat === 'string') {
        var parsed = parseDate(text, singleFormat);
        if (parsed) {
          return parsed;
        }
      }
    }
    return false;
  };

  // ======================== Input =========================
  var getInputProps = function getInputProps(index) {
    function getProp(propValue) {
      return index !== undefined ? propValue[index] : propValue;
    }
    var pickedAttrs = (0,pickAttrs/* default */.Z)(props, {
      aria: true,
      data: true
    });
    var inputProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, pickedAttrs), {}, {
      // ============== Shared ==============
      format: maskFormat,
      validateFormat: function validateFormat(text) {
        return !!_validateFormat(text);
      },
      preserveInvalidOnBlur: preserveInvalidOnBlur,
      readOnly: inputReadOnly,
      required: required,
      'aria-required': ariaRequired,
      name: name,
      autoComplete: autoComplete,
      size: size,
      // ============= By Index =============
      id: getProp(id),
      value: getProp(valueTexts) || '',
      invalid: getProp(invalid),
      placeholder: getProp(placeholder),
      active: activeIndex === index,
      helped: allHelp || activeHelp && activeIndex === index,
      disabled: getProp(disabled),
      onFocus: function onFocus(event) {
        _onFocus(event, index);
      },
      onBlur: function onBlur(event) {
        // Blur do not trigger close
        // Since it may focus to the popup panel
        _onBlur(event, index);
      },
      onSubmit: onSubmit,
      // Get validate text value
      onChange: function onChange(text) {
        onInputChange();
        var parsed = _validateFormat(text);
        if (parsed) {
          onInvalid(false, index);
          _onChange(parsed, index);
          return;
        }

        // Tell outer that the value typed is invalid.
        // If text is empty, it means valid.
        onInvalid(!!text, index);
      },
      onHelp: function onHelp() {
        onOpenChange(true, {
          index: index
        });
      },
      onKeyDown: function onKeyDown(event) {
        var prevented = false;
        _onKeyDown === null || _onKeyDown === void 0 || _onKeyDown(event, function () {
          if (false) {}
          prevented = true;
        });
        if (!event.defaultPrevented && !prevented) {
          switch (event.key) {
            case 'Escape':
              onOpenChange(false, {
                index: index
              });
              break;
            case 'Enter':
              if (!open) {
                onOpenChange(true);
              }
              break;
          }
        }
      }
    }, postProps === null || postProps === void 0 ? void 0 : postProps({
      valueTexts: valueTexts
    }));

    // ============== Clean Up ==============
    Object.keys(inputProps).forEach(function (key) {
      if (inputProps[key] === undefined) {
        delete inputProps[key];
      }
    });
    return inputProps;
  };
  return [getInputProps, getText];
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/Selector/hooks/useRootProps.js


var propNames = ['onMouseEnter', 'onMouseLeave'];
function useRootProps(props) {
  return react.useMemo(function () {
    return pickProps(props, propNames);
  }, [props]);
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/Selector/Icon.js


var _excluded = ["icon", "type"],
  _excluded2 = ["onClear"];


function Icon(props) {
  var icon = props.icon,
    type = props.type,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded);
  var _React$useContext = react.useContext(PickerInput_context),
    prefixCls = _React$useContext.prefixCls;
  return icon ? /*#__PURE__*/react.createElement("span", (0,esm_extends/* default */.Z)({
    className: "".concat(prefixCls, "-").concat(type)
  }, restProps), icon) : null;
}
function ClearIcon(_ref) {
  var onClear = _ref.onClear,
    restProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded2);
  return /*#__PURE__*/react.createElement(Icon, (0,esm_extends/* default */.Z)({}, restProps, {
    type: "clear",
    role: "button",
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
    },
    onClick: function onClick(e) {
      e.stopPropagation();
      onClear();
    }
  }));
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6223);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(79427);
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/Selector/MaskFormat.js



var FORMAT_KEYS = ['YYYY', 'MM', 'DD', 'HH', 'mm', 'ss', 'SSS'];
// Use Chinese character to avoid conflict with the mask format
var REPLACE_KEY = '顧';
var MaskFormat = /*#__PURE__*/function () {
  function MaskFormat(format) {
    (0,classCallCheck/* default */.Z)(this, MaskFormat);
    (0,defineProperty/* default */.Z)(this, "format", void 0);
    (0,defineProperty/* default */.Z)(this, "maskFormat", void 0);
    (0,defineProperty/* default */.Z)(this, "cells", void 0);
    (0,defineProperty/* default */.Z)(this, "maskCells", void 0);
    this.format = format;

    // Generate mask format
    var replaceKeys = FORMAT_KEYS.map(function (key) {
      return "(".concat(key, ")");
    }).join('|');
    var replaceReg = new RegExp(replaceKeys, 'g');
    this.maskFormat = format.replace(replaceReg,
    // Use Chinese character to avoid user use it in format
    function (key) {
      return REPLACE_KEY.repeat(key.length);
    });

    // Generate cells
    var cellReg = new RegExp("(".concat(FORMAT_KEYS.join('|'), ")"));
    var strCells = (format.split(cellReg) || []).filter(function (str) {
      return str;
    });
    var offset = 0;
    this.cells = strCells.map(function (text) {
      var mask = FORMAT_KEYS.includes(text);
      var start = offset;
      var end = offset + text.length;
      offset = end;
      return {
        text: text,
        mask: mask,
        start: start,
        end: end
      };
    });

    // Mask cells
    this.maskCells = this.cells.filter(function (cell) {
      return cell.mask;
    });
  }
  (0,createClass/* default */.Z)(MaskFormat, [{
    key: "getSelection",
    value: function getSelection(maskCellIndex) {
      var _ref = this.maskCells[maskCellIndex] || {},
        start = _ref.start,
        end = _ref.end;
      return [start || 0, end || 0];
    }

    /** Check given text match format */
  }, {
    key: "match",
    value: function match(text) {
      for (var i = 0; i < this.maskFormat.length; i += 1) {
        var maskChar = this.maskFormat[i];
        var textChar = text[i];
        if (!textChar || maskChar !== REPLACE_KEY && maskChar !== textChar) {
          return false;
        }
      }
      return true;
    }

    /** Get mask cell count */
  }, {
    key: "size",
    value: function size() {
      return this.maskCells.length;
    }
  }, {
    key: "getMaskCellIndex",
    value: function getMaskCellIndex(anchorIndex) {
      var closetDist = Number.MAX_SAFE_INTEGER;
      var closetIndex = 0;
      for (var i = 0; i < this.maskCells.length; i += 1) {
        var _this$maskCells$i = this.maskCells[i],
          start = _this$maskCells$i.start,
          end = _this$maskCells$i.end;
        if (anchorIndex >= start && anchorIndex <= end) {
          return i;
        }
        var dist = Math.min(Math.abs(anchorIndex - start), Math.abs(anchorIndex - end));
        if (dist < closetDist) {
          closetDist = dist;
          closetIndex = i;
        }
      }
      return closetIndex;
    }
  }]);
  return MaskFormat;
}();

;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/Selector/util.js
function getMaskRange(key) {
  var PresetRange = {
    YYYY: [0, 9999, new Date().getFullYear()],
    MM: [1, 12],
    DD: [1, 31],
    HH: [0, 23],
    mm: [0, 59],
    ss: [0, 59],
    SSS: [0, 999]
  };
  return PresetRange[key];
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/Selector/Input.js




var Input_excluded = ["active", "showActiveCls", "suffixIcon", "format", "validateFormat", "onChange", "onInput", "helped", "onHelp", "onSubmit", "onKeyDown", "preserveInvalidOnBlur", "invalid", "clearIcon"];












// Format logic
//
// First time on focus:
//  1. check if the text is valid, if not fill with format
//  2. set highlight cell to the first cell
// Cells
//  1. Selection the index cell, set inner `cacheValue` to ''
//  2. Key input filter non-number char, patch after the `cacheValue`
//    1. Replace the `cacheValue` with input align the cell length
//    2. Re-selection the mask cell
//  3. If `cacheValue` match the limit length or cell format (like 1 ~ 12 month), go to next cell

var Input = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var active = props.active,
    _props$showActiveCls = props.showActiveCls,
    showActiveCls = _props$showActiveCls === void 0 ? true : _props$showActiveCls,
    suffixIcon = props.suffixIcon,
    format = props.format,
    validateFormat = props.validateFormat,
    onChange = props.onChange,
    onInput = props.onInput,
    helped = props.helped,
    onHelp = props.onHelp,
    onSubmit = props.onSubmit,
    onKeyDown = props.onKeyDown,
    _props$preserveInvali = props.preserveInvalidOnBlur,
    preserveInvalidOnBlur = _props$preserveInvali === void 0 ? false : _props$preserveInvali,
    invalid = props.invalid,
    clearIcon = props.clearIcon,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, Input_excluded);
  var value = props.value,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onMouseUp = props.onMouseUp;
  var _React$useContext = react.useContext(PickerInput_context),
    prefixCls = _React$useContext.prefixCls,
    _React$useContext$inp = _React$useContext.input,
    Component = _React$useContext$inp === void 0 ? 'input' : _React$useContext$inp;
  var inputPrefixCls = "".concat(prefixCls, "-input");

  // ======================== Value =========================
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    focused = _React$useState2[0],
    setFocused = _React$useState2[1];
  var _React$useState3 = react.useState(value),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    internalInputValue = _React$useState4[0],
    setInputValue = _React$useState4[1];
  var _React$useState5 = react.useState(''),
    _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
    focusCellText = _React$useState6[0],
    setFocusCellText = _React$useState6[1];
  var _React$useState7 = react.useState(null),
    _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
    focusCellIndex = _React$useState8[0],
    setFocusCellIndex = _React$useState8[1];
  var _React$useState9 = react.useState(null),
    _React$useState10 = (0,slicedToArray/* default */.Z)(_React$useState9, 2),
    forceSelectionSyncMark = _React$useState10[0],
    forceSelectionSync = _React$useState10[1];
  var inputValue = internalInputValue || '';

  // Sync value if needed
  react.useEffect(function () {
    setInputValue(value);
  }, [value]);

  // ========================= Refs =========================
  var holderRef = react.useRef();
  var inputRef = react.useRef();
  react.useImperativeHandle(ref, function () {
    return {
      nativeElement: holderRef.current,
      inputElement: inputRef.current,
      focus: function focus(options) {
        inputRef.current.focus(options);
      },
      blur: function blur() {
        inputRef.current.blur();
      }
    };
  });

  // ======================== Format ========================
  var maskFormat = react.useMemo(function () {
    return new MaskFormat(format || '');
  }, [format]);
  var _React$useMemo = react.useMemo(function () {
      if (helped) {
        return [0, 0];
      }
      return maskFormat.getSelection(focusCellIndex);
    }, [maskFormat, focusCellIndex, helped]),
    _React$useMemo2 = (0,slicedToArray/* default */.Z)(_React$useMemo, 2),
    selectionStart = _React$useMemo2[0],
    selectionEnd = _React$useMemo2[1];

  // ======================== Modify ========================
  // When input modify content, trigger `onHelp` if is not the format
  var onModify = function onModify(text) {
    if (text && text !== format && text !== value) {
      onHelp();
    }
  };

  // ======================== Change ========================
  /**
   * Triggered by paste, keyDown and focus to show format
   */
  var triggerInputChange = (0,es/* useEvent */.zX)(function (text) {
    if (validateFormat(text)) {
      onChange(text);
    }
    setInputValue(text);
    onModify(text);
  });

  // Directly trigger `onChange` if `format` is empty
  var onInternalChange = function onInternalChange(event) {
    // Hack `onChange` with format to do nothing
    if (!format) {
      var text = event.target.value;
      onModify(text);
      setInputValue(text);
      onChange(text);
    }
  };
  var onFormatPaste = function onFormatPaste(event) {
    // Get paste text
    var pasteText = event.clipboardData.getData('text');
    if (validateFormat(pasteText)) {
      triggerInputChange(pasteText);
    }
  };

  // ======================== Mouse =========================
  // When `mouseDown` get focus, it's better to not to change the selection
  // Since the up position maybe not is the first cell
  var mouseDownRef = react.useRef(false);
  var onFormatMouseDown = function onFormatMouseDown() {
    mouseDownRef.current = true;
  };
  var onFormatMouseUp = function onFormatMouseUp(event) {
    var _ref = event.target,
      start = _ref.selectionStart;
    var closeMaskIndex = maskFormat.getMaskCellIndex(start);
    setFocusCellIndex(closeMaskIndex);

    // Force update the selection
    forceSelectionSync({});
    onMouseUp === null || onMouseUp === void 0 || onMouseUp(event);
    mouseDownRef.current = false;
  };

  // ====================== Focus Blur ======================
  var onFormatFocus = function onFormatFocus(event) {
    setFocused(true);
    setFocusCellIndex(0);
    setFocusCellText('');
    onFocus(event);
  };
  var onSharedBlur = function onSharedBlur(event) {
    onBlur(event);
  };
  var onFormatBlur = function onFormatBlur(event) {
    setFocused(false);
    onSharedBlur(event);
  };

  // ======================== Active ========================
  // Check if blur need reset input value
  useLockEffect(active, function () {
    if (!active && !preserveInvalidOnBlur) {
      setInputValue(value);
    }
  });

  // ======================= Keyboard =======================
  var onSharedKeyDown = function onSharedKeyDown(event) {
    if (event.key === 'Enter' && validateFormat(inputValue)) {
      onSubmit();
    }
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(event);
  };
  var onFormatKeyDown = function onFormatKeyDown(event) {
    onSharedKeyDown(event);
    var key = event.key;

    // Save the cache with cell text
    var nextCellText = null;

    // Fill in the input
    var nextFillText = null;
    var maskCellLen = selectionEnd - selectionStart;
    var cellFormat = format.slice(selectionStart, selectionEnd);

    // Cell Index
    var offsetCellIndex = function offsetCellIndex(offset) {
      setFocusCellIndex(function (idx) {
        var nextIndex = idx + offset;
        nextIndex = Math.max(nextIndex, 0);
        nextIndex = Math.min(nextIndex, maskFormat.size() - 1);
        return nextIndex;
      });
    };

    // Range
    var offsetCellValue = function offsetCellValue(offset) {
      var _getMaskRange = getMaskRange(cellFormat),
        _getMaskRange2 = (0,slicedToArray/* default */.Z)(_getMaskRange, 3),
        rangeStart = _getMaskRange2[0],
        rangeEnd = _getMaskRange2[1],
        rangeDefault = _getMaskRange2[2];
      var currentText = inputValue.slice(selectionStart, selectionEnd);
      var currentTextNum = Number(currentText);
      if (isNaN(currentTextNum)) {
        return String(rangeDefault ? rangeDefault : offset > 0 ? rangeStart : rangeEnd);
      }
      var num = currentTextNum + offset;
      var range = rangeEnd - rangeStart + 1;
      return String(rangeStart + (range + num - rangeStart) % range);
    };
    switch (key) {
      // =============== Remove ===============
      case 'Backspace':
      case 'Delete':
        nextCellText = '';
        nextFillText = cellFormat;
        break;

      // =============== Arrows ===============
      // Left key
      case 'ArrowLeft':
        nextCellText = '';
        offsetCellIndex(-1);
        break;

      // Right key
      case 'ArrowRight':
        nextCellText = '';
        offsetCellIndex(1);
        break;

      // Up key
      case 'ArrowUp':
        nextCellText = '';
        nextFillText = offsetCellValue(1);
        break;

      // Down key
      case 'ArrowDown':
        nextCellText = '';
        nextFillText = offsetCellValue(-1);
        break;

      // =============== Number ===============
      default:
        if (!isNaN(Number(key))) {
          nextCellText = focusCellText + key;
          nextFillText = nextCellText;
        }
        break;
    }

    // Update cell text
    if (nextCellText !== null) {
      setFocusCellText(nextCellText);
      if (nextCellText.length >= maskCellLen) {
        // Go to next cell
        offsetCellIndex(1);
        setFocusCellText('');
      }
    }

    // Update the input text
    if (nextFillText !== null) {
      // Replace selection range with `nextCellText`
      var nextFocusValue =
      // before
      inputValue.slice(0, selectionStart) +
      // replace
      leftPad(nextFillText, maskCellLen) +
      // after
      inputValue.slice(selectionEnd);
      triggerInputChange(nextFocusValue.slice(0, format.length));
    }

    // Always trigger selection sync after key down
    forceSelectionSync({});
  };

  // ======================== Format ========================
  var rafRef = react.useRef();
  (0,useLayoutEffect/* default */.Z)(function () {
    if (!focused || !format || mouseDownRef.current) {
      return;
    }

    // Reset with format if not match
    if (!maskFormat.match(inputValue)) {
      triggerInputChange(format);
      return;
    }

    // Match the selection range
    inputRef.current.setSelectionRange(selectionStart, selectionEnd);

    // Chrome has the bug anchor position looks not correct but actually correct
    rafRef.current = (0,raf/* default */.Z)(function () {
      inputRef.current.setSelectionRange(selectionStart, selectionEnd);
    });
    return function () {
      raf/* default.cancel */.Z.cancel(rafRef.current);
    };
  }, [maskFormat, format, focused, inputValue, focusCellIndex, selectionStart, selectionEnd, forceSelectionSyncMark, triggerInputChange]);

  // ======================== Render ========================
  // Input props for format
  var inputProps = format ? {
    onFocus: onFormatFocus,
    onBlur: onFormatBlur,
    onKeyDown: onFormatKeyDown,
    onMouseDown: onFormatMouseDown,
    onMouseUp: onFormatMouseUp,
    onPaste: onFormatPaste
  } : {};
  return /*#__PURE__*/react.createElement("div", {
    ref: holderRef,
    className: classnames_default()(inputPrefixCls, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(inputPrefixCls, "-active"), active && showActiveCls), "".concat(inputPrefixCls, "-placeholder"), helped))
  }, /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    ref: inputRef,
    "aria-invalid": invalid,
    autoComplete: "off"
  }, restProps, {
    onKeyDown: onSharedKeyDown,
    onBlur: onSharedBlur
    // Replace with format
  }, inputProps, {
    // Value
    value: inputValue,
    onChange: onInternalChange
  })), /*#__PURE__*/react.createElement(Icon, {
    type: "suffix",
    icon: suffixIcon
  }), clearIcon);
});
if (false) {}
/* harmony default export */ var Selector_Input = (Input);
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/Selector/RangeSelector.js






var RangeSelector_excluded = ["id", "prefix", "clearIcon", "suffixIcon", "separator", "activeIndex", "activeHelp", "allHelp", "focused", "onFocus", "onBlur", "onKeyDown", "locale", "generateConfig", "placeholder", "className", "style", "onClick", "onClear", "value", "onChange", "onSubmit", "onInputChange", "format", "maskFormat", "preserveInvalidOnBlur", "onInvalid", "disabled", "invalid", "inputReadOnly", "direction", "onOpenChange", "onActiveInfo", "placement", "onMouseDown", "required", "aria-required", "autoFocus", "tabIndex"],
  RangeSelector_excluded2 = ["index"];









function RangeSelector(props, ref) {
  var id = props.id,
    prefix = props.prefix,
    clearIcon = props.clearIcon,
    suffixIcon = props.suffixIcon,
    _props$separator = props.separator,
    separator = _props$separator === void 0 ? '~' : _props$separator,
    activeIndex = props.activeIndex,
    activeHelp = props.activeHelp,
    allHelp = props.allHelp,
    focused = props.focused,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onKeyDown = props.onKeyDown,
    locale = props.locale,
    generateConfig = props.generateConfig,
    placeholder = props.placeholder,
    className = props.className,
    style = props.style,
    onClick = props.onClick,
    onClear = props.onClear,
    value = props.value,
    onChange = props.onChange,
    onSubmit = props.onSubmit,
    onInputChange = props.onInputChange,
    format = props.format,
    maskFormat = props.maskFormat,
    preserveInvalidOnBlur = props.preserveInvalidOnBlur,
    onInvalid = props.onInvalid,
    disabled = props.disabled,
    invalid = props.invalid,
    inputReadOnly = props.inputReadOnly,
    direction = props.direction,
    onOpenChange = props.onOpenChange,
    onActiveInfo = props.onActiveInfo,
    placement = props.placement,
    _onMouseDown = props.onMouseDown,
    required = props.required,
    ariaRequired = props['aria-required'],
    autoFocus = props.autoFocus,
    tabIndex = props.tabIndex,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, RangeSelector_excluded);
  var rtl = direction === 'rtl';

  // ======================== Prefix ========================
  var _React$useContext = react.useContext(PickerInput_context),
    prefixCls = _React$useContext.prefixCls;

  // ========================== Id ==========================
  var ids = react.useMemo(function () {
    if (typeof id === 'string') {
      return [id];
    }
    var mergedId = id || {};
    return [mergedId.start, mergedId.end];
  }, [id]);

  // ========================= Refs =========================
  var rootRef = react.useRef();
  var inputStartRef = react.useRef();
  var inputEndRef = react.useRef();
  var getInput = function getInput(index) {
    var _index;
    return (_index = [inputStartRef, inputEndRef][index]) === null || _index === void 0 ? void 0 : _index.current;
  };
  react.useImperativeHandle(ref, function () {
    return {
      nativeElement: rootRef.current,
      focus: function focus(options) {
        if ((0,esm_typeof/* default */.Z)(options) === 'object') {
          var _getInput;
          var _ref = options || {},
            _ref$index = _ref.index,
            _index2 = _ref$index === void 0 ? 0 : _ref$index,
            rest = (0,objectWithoutProperties/* default */.Z)(_ref, RangeSelector_excluded2);
          (_getInput = getInput(_index2)) === null || _getInput === void 0 || _getInput.focus(rest);
        } else {
          var _getInput2;
          (_getInput2 = getInput(options !== null && options !== void 0 ? options : 0)) === null || _getInput2 === void 0 || _getInput2.focus();
        }
      },
      blur: function blur() {
        var _getInput3, _getInput4;
        (_getInput3 = getInput(0)) === null || _getInput3 === void 0 || _getInput3.blur();
        (_getInput4 = getInput(1)) === null || _getInput4 === void 0 || _getInput4.blur();
      }
    };
  });

  // ======================== Props =========================
  var rootProps = useRootProps(restProps);

  // ===================== Placeholder ======================
  var mergedPlaceholder = react.useMemo(function () {
    return Array.isArray(placeholder) ? placeholder : [placeholder, placeholder];
  }, [placeholder]);

  // ======================== Inputs ========================
  var _useInputProps = useInputProps((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
      id: ids,
      placeholder: mergedPlaceholder
    })),
    _useInputProps2 = (0,slicedToArray/* default */.Z)(_useInputProps, 1),
    getInputProps = _useInputProps2[0];

  // ====================== ActiveBar =======================
  var _React$useState = react.useState({
      position: 'absolute',
      width: 0
    }),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    activeBarStyle = _React$useState2[0],
    setActiveBarStyle = _React$useState2[1];
  var syncActiveOffset = (0,es/* useEvent */.zX)(function () {
    var input = getInput(activeIndex);
    if (input) {
      var inputRect = input.nativeElement.getBoundingClientRect();
      var parentRect = rootRef.current.getBoundingClientRect();
      var rectOffset = inputRect.left - parentRect.left;
      setActiveBarStyle(function (ori) {
        return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, ori), {}, {
          width: inputRect.width,
          left: rectOffset
        });
      });
      onActiveInfo([inputRect.left, inputRect.right, parentRect.width]);
    }
  });
  react.useEffect(function () {
    syncActiveOffset();
  }, [activeIndex]);

  // ======================== Clear =========================
  var showClear = clearIcon && (value[0] && !disabled[0] || value[1] && !disabled[1]);

  // ======================= Disabled =======================
  var startAutoFocus = autoFocus && !disabled[0];
  var endAutoFocus = autoFocus && !startAutoFocus && !disabled[1];

  // ======================== Render ========================
  return /*#__PURE__*/react.createElement(rc_resize_observer_es/* default */.Z, {
    onResize: syncActiveOffset
  }, /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, rootProps, {
    className: classnames_default()(prefixCls, "".concat(prefixCls, "-range"), (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-focused"), focused), "".concat(prefixCls, "-disabled"), disabled.every(function (i) {
      return i;
    })), "".concat(prefixCls, "-invalid"), invalid.some(function (i) {
      return i;
    })), "".concat(prefixCls, "-rtl"), rtl), className),
    style: style,
    ref: rootRef,
    onClick: onClick
    // Not lose current input focus
    ,

    onMouseDown: function onMouseDown(e) {
      var target = e.target;
      if (target !== inputStartRef.current.inputElement && target !== inputEndRef.current.inputElement) {
        e.preventDefault();
      }
      _onMouseDown === null || _onMouseDown === void 0 || _onMouseDown(e);
    }
  }), prefix && /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-prefix")
  }, prefix), /*#__PURE__*/react.createElement(Selector_Input, (0,esm_extends/* default */.Z)({
    ref: inputStartRef
  }, getInputProps(0), {
    autoFocus: startAutoFocus,
    tabIndex: tabIndex,
    "date-range": "start"
  })), /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-range-separator")
  }, separator), /*#__PURE__*/react.createElement(Selector_Input, (0,esm_extends/* default */.Z)({
    ref: inputEndRef
  }, getInputProps(1), {
    autoFocus: endAutoFocus,
    tabIndex: tabIndex,
    "date-range": "end"
  })), /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-active-bar"),
    style: activeBarStyle
  }), /*#__PURE__*/react.createElement(Icon, {
    type: "suffix",
    icon: suffixIcon
  }), showClear && /*#__PURE__*/react.createElement(ClearIcon, {
    icon: clearIcon,
    onClear: onClear
  })));
}
var RefRangeSelector = /*#__PURE__*/react.forwardRef(RangeSelector);
if (false) {}
/* harmony default export */ var Selector_RangeSelector = (RefRangeSelector);
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/RangePicker.js



























function separateConfig(config, defaultConfig) {
  var singleConfig = config !== null && config !== void 0 ? config : defaultConfig;
  if (Array.isArray(singleConfig)) {
    return singleConfig;
  }
  return [singleConfig, singleConfig];
}

/** Used for change event, it should always be not undefined */

function getActiveRange(activeIndex) {
  return activeIndex === 1 ? 'end' : 'start';
}
function RangePicker(props, ref) {
  // ========================= Prop =========================
  var _useFilledProps = useFilledProps(props, function () {
      var disabled = props.disabled,
        allowEmpty = props.allowEmpty;
      var mergedDisabled = separateConfig(disabled, false);
      var mergedAllowEmpty = separateConfig(allowEmpty, false);
      return {
        disabled: mergedDisabled,
        allowEmpty: mergedAllowEmpty
      };
    }),
    _useFilledProps2 = (0,slicedToArray/* default */.Z)(_useFilledProps, 6),
    filledProps = _useFilledProps2[0],
    internalPicker = _useFilledProps2[1],
    complexPicker = _useFilledProps2[2],
    formatList = _useFilledProps2[3],
    maskFormat = _useFilledProps2[4],
    isInvalidateDate = _useFilledProps2[5];
  var prefixCls = filledProps.prefixCls,
    styles = filledProps.styles,
    classNames = filledProps.classNames,
    defaultValue = filledProps.defaultValue,
    value = filledProps.value,
    needConfirm = filledProps.needConfirm,
    onKeyDown = filledProps.onKeyDown,
    disabled = filledProps.disabled,
    allowEmpty = filledProps.allowEmpty,
    disabledDate = filledProps.disabledDate,
    minDate = filledProps.minDate,
    maxDate = filledProps.maxDate,
    defaultOpen = filledProps.defaultOpen,
    open = filledProps.open,
    onOpenChange = filledProps.onOpenChange,
    locale = filledProps.locale,
    generateConfig = filledProps.generateConfig,
    picker = filledProps.picker,
    showNow = filledProps.showNow,
    showToday = filledProps.showToday,
    showTime = filledProps.showTime,
    mode = filledProps.mode,
    onPanelChange = filledProps.onPanelChange,
    onCalendarChange = filledProps.onCalendarChange,
    onOk = filledProps.onOk,
    defaultPickerValue = filledProps.defaultPickerValue,
    pickerValue = filledProps.pickerValue,
    onPickerValueChange = filledProps.onPickerValueChange,
    inputReadOnly = filledProps.inputReadOnly,
    suffixIcon = filledProps.suffixIcon,
    onFocus = filledProps.onFocus,
    onBlur = filledProps.onBlur,
    presets = filledProps.presets,
    ranges = filledProps.ranges,
    components = filledProps.components,
    cellRender = filledProps.cellRender,
    dateRender = filledProps.dateRender,
    monthCellRender = filledProps.monthCellRender,
    onClick = filledProps.onClick;

  // ========================= Refs =========================
  var selectorRef = usePickerRef(ref);

  // ========================= Open =========================
  var _useOpen = useOpen(open, defaultOpen, disabled, onOpenChange),
    _useOpen2 = (0,slicedToArray/* default */.Z)(_useOpen, 2),
    mergedOpen = _useOpen2[0],
    setMergeOpen = _useOpen2[1];
  var triggerOpen = function triggerOpen(nextOpen, config) {
    // No need to open if all disabled
    if (disabled.some(function (fieldDisabled) {
      return !fieldDisabled;
    }) || !nextOpen) {
      setMergeOpen(nextOpen, config);
    }
  };

  // ======================== Values ========================
  var _useInnerValue = useInnerValue(generateConfig, locale, formatList, true, false, defaultValue, value, onCalendarChange, onOk),
    _useInnerValue2 = (0,slicedToArray/* default */.Z)(_useInnerValue, 5),
    mergedValue = _useInnerValue2[0],
    setInnerValue = _useInnerValue2[1],
    getCalendarValue = _useInnerValue2[2],
    triggerCalendarChange = _useInnerValue2[3],
    triggerOk = _useInnerValue2[4];
  var calendarValue = getCalendarValue();

  // ======================== Active ========================
  var _useRangeActive = useRangeActive(disabled, allowEmpty, mergedOpen),
    _useRangeActive2 = (0,slicedToArray/* default */.Z)(_useRangeActive, 9),
    focused = _useRangeActive2[0],
    triggerFocus = _useRangeActive2[1],
    lastOperation = _useRangeActive2[2],
    activeIndex = _useRangeActive2[3],
    setActiveIndex = _useRangeActive2[4],
    nextActiveIndex = _useRangeActive2[5],
    activeIndexList = _useRangeActive2[6],
    updateSubmitIndex = _useRangeActive2[7],
    hasActiveSubmitValue = _useRangeActive2[8];
  var onSharedFocus = function onSharedFocus(event, index) {
    triggerFocus(true);
    onFocus === null || onFocus === void 0 || onFocus(event, {
      range: getActiveRange(index !== null && index !== void 0 ? index : activeIndex)
    });
  };
  var onSharedBlur = function onSharedBlur(event, index) {
    triggerFocus(false);
    onBlur === null || onBlur === void 0 || onBlur(event, {
      range: getActiveRange(index !== null && index !== void 0 ? index : activeIndex)
    });
  };

  // ======================= ShowTime =======================
  /** Used for Popup panel */
  var mergedShowTime = react.useMemo(function () {
    if (!showTime) {
      return null;
    }
    var disabledTime = showTime.disabledTime;
    var proxyDisabledTime = disabledTime ? function (date) {
      var range = getActiveRange(activeIndex);
      var fromDate = getFromDate(calendarValue, activeIndexList, activeIndex);
      return disabledTime(date, range, {
        from: fromDate
      });
    } : undefined;
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, showTime), {}, {
      disabledTime: proxyDisabledTime
    });
  }, [showTime, activeIndex, calendarValue, activeIndexList]);

  // ========================= Mode =========================
  var _useMergedState = (0,es/* useMergedState */.C8)([picker, picker], {
      value: mode
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    modes = _useMergedState2[0],
    setModes = _useMergedState2[1];
  var mergedMode = modes[activeIndex] || picker;

  /** Extends from `mergedMode` to patch `datetime` mode */
  var internalMode = mergedMode === 'date' && mergedShowTime ? 'datetime' : mergedMode;

  // ====================== PanelCount ======================
  var multiplePanel = internalMode === picker && internalMode !== 'time';

  // ======================= Show Now =======================
  var mergedShowNow = useShowNow(picker, mergedMode, showNow, showToday, true);

  // ======================== Value =========================
  var _useRangeValue = useRangeValue(filledProps, mergedValue, setInnerValue, getCalendarValue, triggerCalendarChange, disabled, formatList, focused, mergedOpen, isInvalidateDate),
    _useRangeValue2 = (0,slicedToArray/* default */.Z)(_useRangeValue, 2),
    /** Trigger `onChange` by check `disabledDate` */
    flushSubmit = _useRangeValue2[0],
    /** Trigger `onChange` directly without check `disabledDate` */
    triggerSubmitChange = _useRangeValue2[1];

  // ===================== DisabledDate =====================
  var mergedDisabledDate = useRangeDisabledDate(calendarValue, disabled, activeIndexList, generateConfig, locale, disabledDate);

  // ======================= Validate =======================
  var _useFieldsInvalidate = useFieldsInvalidate(calendarValue, isInvalidateDate, allowEmpty),
    _useFieldsInvalidate2 = (0,slicedToArray/* default */.Z)(_useFieldsInvalidate, 2),
    submitInvalidates = _useFieldsInvalidate2[0],
    onSelectorInvalid = _useFieldsInvalidate2[1];

  // ===================== Picker Value =====================
  var _useRangePickerValue = useRangePickerValue(generateConfig, locale, calendarValue, modes, mergedOpen, activeIndex, internalPicker, multiplePanel, defaultPickerValue, pickerValue, mergedShowTime === null || mergedShowTime === void 0 ? void 0 : mergedShowTime.defaultOpenValue, onPickerValueChange, minDate, maxDate),
    _useRangePickerValue2 = (0,slicedToArray/* default */.Z)(_useRangePickerValue, 2),
    currentPickerValue = _useRangePickerValue2[0],
    setCurrentPickerValue = _useRangePickerValue2[1];

  // >>> Mode need wait for `pickerValue`
  var triggerModeChange = (0,es/* useEvent */.zX)(function (nextPickerValue, nextMode, triggerEvent) {
    var clone = fillIndex(modes, activeIndex, nextMode);
    if (clone[0] !== modes[0] || clone[1] !== modes[1]) {
      setModes(clone);
    }

    // Compatible with `onPanelChange`
    if (onPanelChange && triggerEvent !== false) {
      var clonePickerValue = (0,toConsumableArray/* default */.Z)(calendarValue);
      if (nextPickerValue) {
        clonePickerValue[activeIndex] = nextPickerValue;
      }
      onPanelChange(clonePickerValue, clone);
    }
  });

  // ======================== Change ========================
  var fillCalendarValue = function fillCalendarValue(date, index) {
    return (
      // Trigger change only when date changed
      fillIndex(calendarValue, index, date)
    );
  };

  // ======================== Submit ========================
  /**
   * Trigger by confirm operation.
   * This function has already handle the `needConfirm` check logic.
   * - Selector: enter key
   * - Panel: OK button
   */
  var triggerPartConfirm = function triggerPartConfirm(date, skipFocus) {
    var nextValue = calendarValue;
    if (date) {
      nextValue = fillCalendarValue(date, activeIndex);
    }
    updateSubmitIndex(activeIndex);
    // Get next focus index
    var nextIndex = nextActiveIndex(nextValue);

    // Change calendar value and tell flush it
    triggerCalendarChange(nextValue);
    flushSubmit(activeIndex, nextIndex === null);
    if (nextIndex === null) {
      triggerOpen(false, {
        force: true
      });
    } else if (!skipFocus) {
      selectorRef.current.focus({
        index: nextIndex
      });
    }
  };

  // ======================== Click =========================
  var onSelectorClick = function onSelectorClick(event) {
    var _activeElement;
    var rootNode = event.target.getRootNode();
    if (!selectorRef.current.nativeElement.contains((_activeElement = rootNode.activeElement) !== null && _activeElement !== void 0 ? _activeElement : document.activeElement)) {
      // Click to focus the enabled input
      var enabledIndex = disabled.findIndex(function (d) {
        return !d;
      });
      if (enabledIndex >= 0) {
        selectorRef.current.focus({
          index: enabledIndex
        });
      }
    }
    triggerOpen(true);
    onClick === null || onClick === void 0 || onClick(event);
  };
  var onSelectorClear = function onSelectorClear() {
    triggerSubmitChange(null);
    triggerOpen(false, {
      force: true
    });
  };

  // ======================== Hover =========================
  var _React$useState = react.useState(null),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    hoverSource = _React$useState2[0],
    setHoverSource = _React$useState2[1];
  var _React$useState3 = react.useState(null),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    internalHoverValues = _React$useState4[0],
    setInternalHoverValues = _React$useState4[1];
  var hoverValues = react.useMemo(function () {
    return internalHoverValues || calendarValue;
  }, [calendarValue, internalHoverValues]);

  // Clean up `internalHoverValues` when closed
  react.useEffect(function () {
    if (!mergedOpen) {
      setInternalHoverValues(null);
    }
  }, [mergedOpen]);

  // ========================================================
  // ==                       Panels                       ==
  // ========================================================
  // Save the offset with active bar position
  // const [activeOffset, setActiveOffset] = React.useState(0);
  var _React$useState5 = react.useState([0, 0, 0]),
    _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
    activeInfo = _React$useState6[0],
    setActiveInfo = _React$useState6[1];

  // ======================= Presets ========================
  var presetList = usePresets(presets, ranges);
  var onPresetHover = function onPresetHover(nextValues) {
    setInternalHoverValues(nextValues);
    setHoverSource('preset');
  };
  var onPresetSubmit = function onPresetSubmit(nextValues) {
    var passed = triggerSubmitChange(nextValues);
    if (passed) {
      triggerOpen(false, {
        force: true
      });
    }
  };
  var onNow = function onNow(now) {
    triggerPartConfirm(now);
  };

  // ======================== Panel =========================
  var onPanelHover = function onPanelHover(date) {
    setInternalHoverValues(date ? fillCalendarValue(date, activeIndex) : null);
    setHoverSource('cell');
  };

  // >>> Focus
  var onPanelFocus = function onPanelFocus(event) {
    triggerOpen(true);
    onSharedFocus(event);
  };

  // >>> MouseDown
  var onPanelMouseDown = function onPanelMouseDown() {
    lastOperation('panel');
  };

  // >>> Calendar
  var onPanelSelect = function onPanelSelect(date) {
    var clone = fillIndex(calendarValue, activeIndex, date);

    // Only trigger calendar event but not update internal `calendarValue` state
    triggerCalendarChange(clone);

    // >>> Trigger next active if !needConfirm
    // Fully logic check `useRangeValue` hook
    if (!needConfirm && !complexPicker && internalPicker === internalMode) {
      triggerPartConfirm(date);
    }
  };

  // >>> Close
  var onPopupClose = function onPopupClose() {
    // Close popup
    triggerOpen(false);
  };

  // >>> cellRender
  var onInternalCellRender = useCellRender(cellRender, dateRender, monthCellRender, getActiveRange(activeIndex));

  // >>> Value
  var panelValue = calendarValue[activeIndex] || null;

  // >>> invalid
  var isPopupInvalidateDate = (0,es/* useEvent */.zX)(function (date) {
    return isInvalidateDate(date, {
      activeIndex: activeIndex
    });
  });
  var panelProps = react.useMemo(function () {
    var domProps = (0,pickAttrs/* default */.Z)(filledProps, false);
    var restProps = (0,omit/* default */.Z)(filledProps, [].concat((0,toConsumableArray/* default */.Z)(Object.keys(domProps)), ['onChange', 'onCalendarChange', 'style', 'className', 'onPanelChange', 'disabledTime']));
    return restProps;
  }, [filledProps]);

  // >>> Render
  var panel = /*#__PURE__*/react.createElement(Popup, (0,esm_extends/* default */.Z)({}, panelProps, {
    showNow: mergedShowNow,
    showTime: mergedShowTime
    // Range
    ,

    range: true,
    multiplePanel: multiplePanel,
    activeInfo: activeInfo
    // Disabled
    ,

    disabledDate: mergedDisabledDate
    // Focus
    ,

    onFocus: onPanelFocus,
    onBlur: onSharedBlur,
    onPanelMouseDown: onPanelMouseDown
    // Mode
    ,

    picker: picker,
    mode: mergedMode,
    internalMode: internalMode,
    onPanelChange: triggerModeChange
    // Value
    ,

    format: maskFormat,
    value: panelValue,
    isInvalid: isPopupInvalidateDate,
    onChange: null,
    onSelect: onPanelSelect
    // PickerValue
    ,

    pickerValue: currentPickerValue,
    defaultOpenValue: toArray(showTime === null || showTime === void 0 ? void 0 : showTime.defaultOpenValue)[activeIndex],
    onPickerValueChange: setCurrentPickerValue
    // Hover
    ,

    hoverValue: hoverValues,
    onHover: onPanelHover
    // Submit
    ,

    needConfirm: needConfirm,
    onSubmit: triggerPartConfirm,
    onOk: triggerOk
    // Preset
    ,

    presets: presetList,
    onPresetHover: onPresetHover,
    onPresetSubmit: onPresetSubmit
    // Now
    ,

    onNow: onNow
    // Render
    ,

    cellRender: onInternalCellRender
  }));

  // ========================================================
  // ==                      Selector                      ==
  // ========================================================

  // ======================== Change ========================
  var onSelectorChange = function onSelectorChange(date, index) {
    var clone = fillCalendarValue(date, index);
    triggerCalendarChange(clone);
  };
  var onSelectorInputChange = function onSelectorInputChange() {
    lastOperation('input');
  };

  // ======================= Selector =======================
  var onSelectorFocus = function onSelectorFocus(event, index) {
    // Check if `needConfirm` but user not submit yet
    var activeListLen = activeIndexList.length;
    var lastActiveIndex = activeIndexList[activeListLen - 1];
    if (activeListLen && lastActiveIndex !== index && needConfirm &&
    // Not change index if is not filled
    !allowEmpty[lastActiveIndex] && !hasActiveSubmitValue(lastActiveIndex) && calendarValue[lastActiveIndex]) {
      selectorRef.current.focus({
        index: lastActiveIndex
      });
      return;
    }
    lastOperation('input');
    triggerOpen(true, {
      inherit: true
    });

    // When click input to switch the field, it will not trigger close.
    // Which means it will lose the part confirm and we need fill back.
    // ref: https://github.com/ant-design/ant-design/issues/49512
    if (activeIndex !== index && mergedOpen && !needConfirm && complexPicker) {
      triggerPartConfirm(null, true);
    }
    setActiveIndex(index);
    onSharedFocus(event, index);
  };
  var onSelectorBlur = function onSelectorBlur(event, index) {
    triggerOpen(false);
    if (!needConfirm && lastOperation() === 'input') {
      var nextIndex = nextActiveIndex(calendarValue);
      flushSubmit(activeIndex, nextIndex === null);
    }
    onSharedBlur(event, index);
  };
  var onSelectorKeyDown = function onSelectorKeyDown(event, preventDefault) {
    if (event.key === 'Tab') {
      triggerPartConfirm(null, true);
    }
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(event, preventDefault);
  };

  // ======================= Context ========================
  var context = react.useMemo(function () {
    return {
      prefixCls: prefixCls,
      locale: locale,
      generateConfig: generateConfig,
      button: components.button,
      input: components.input
    };
  }, [prefixCls, locale, generateConfig, components.button, components.input]);

  // ======================== Effect ========================
  // >>> Mode
  // Reset for every active
  (0,useLayoutEffect/* default */.Z)(function () {
    if (mergedOpen && activeIndex !== undefined) {
      // Legacy compatible. This effect update should not trigger `onPanelChange`
      triggerModeChange(null, picker, false);
    }
  }, [mergedOpen, activeIndex, picker]);

  // >>> For complex picker, we need check if need to focus next one
  (0,useLayoutEffect/* default */.Z)(function () {
    var lastOp = lastOperation();

    // Trade as confirm on field leave
    if (!mergedOpen && lastOp === 'input') {
      triggerOpen(false);
      triggerPartConfirm(null, true);
    }

    // Submit with complex picker
    if (!mergedOpen && complexPicker && !needConfirm && lastOp === 'panel') {
      triggerOpen(true);
      triggerPartConfirm();
    }
  }, [mergedOpen]);

  // ====================== DevWarning ======================
  if (false) { var isIndexEmpty; }

  // ======================== Render ========================
  return /*#__PURE__*/react.createElement(PickerInput_context.Provider, {
    value: context
  }, /*#__PURE__*/react.createElement(es_PickerTrigger, (0,esm_extends/* default */.Z)({}, pickTriggerProps(filledProps), {
    popupElement: panel,
    popupStyle: styles.popup,
    popupClassName: classNames.popup
    // Visible
    ,

    visible: mergedOpen,
    onClose: onPopupClose
    // Range
    ,

    range: true
  }), /*#__PURE__*/react.createElement(Selector_RangeSelector
  // Shared
  , (0,esm_extends/* default */.Z)({}, filledProps, {
    // Ref
    ref: selectorRef
    // Icon
    ,

    suffixIcon: suffixIcon
    // Active
    ,

    activeIndex: focused || mergedOpen ? activeIndex : null,
    activeHelp: !!internalHoverValues,
    allHelp: !!internalHoverValues && hoverSource === 'preset',
    focused: focused,
    onFocus: onSelectorFocus,
    onBlur: onSelectorBlur,
    onKeyDown: onSelectorKeyDown,
    onSubmit: triggerPartConfirm
    // Change
    ,

    value: hoverValues,
    maskFormat: maskFormat,
    onChange: onSelectorChange,
    onInputChange: onSelectorInputChange
    // Format
    ,

    format: formatList,
    inputReadOnly: inputReadOnly
    // Disabled
    ,

    disabled: disabled
    // Open
    ,

    open: mergedOpen,
    onOpenChange: triggerOpen
    // Click
    ,

    onClick: onSelectorClick,
    onClear: onSelectorClear
    // Invalid
    ,

    invalid: submitInvalidates,
    onInvalid: onSelectorInvalid
    // Offset
    ,

    onActiveInfo: setActiveInfo
  }))));
}
var RefRangePicker = /*#__PURE__*/react.forwardRef(RangePicker);
if (false) {}
/* harmony default export */ var PickerInput_RangePicker = (RefRangePicker);
// EXTERNAL MODULE: ./node_modules/rc-overflow/es/index.js + 6 modules
var rc_overflow_es = __webpack_require__(16344);
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/Selector/SingleSelector/MultipleDates.js



function MultipleDates(props) {
  var prefixCls = props.prefixCls,
    value = props.value,
    onRemove = props.onRemove,
    _props$removeIcon = props.removeIcon,
    removeIcon = _props$removeIcon === void 0 ? '×' : _props$removeIcon,
    formatDate = props.formatDate,
    disabled = props.disabled,
    maxTagCount = props.maxTagCount,
    placeholder = props.placeholder;
  var selectorCls = "".concat(prefixCls, "-selector");
  var selectionCls = "".concat(prefixCls, "-selection");
  var overflowCls = "".concat(selectionCls, "-overflow");

  // ========================= Item =========================
  function renderSelector(content, onClose) {
    return /*#__PURE__*/react.createElement("span", {
      className: classnames_default()("".concat(selectionCls, "-item")),
      title: typeof content === 'string' ? content : null
    }, /*#__PURE__*/react.createElement("span", {
      className: "".concat(selectionCls, "-item-content")
    }, content), !disabled && onClose && /*#__PURE__*/react.createElement("span", {
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
      },
      onClick: onClose,
      className: "".concat(selectionCls, "-item-remove")
    }, removeIcon));
  }
  function renderItem(date) {
    var displayLabel = formatDate(date);
    var onClose = function onClose(event) {
      if (event) event.stopPropagation();
      onRemove(date);
    };
    return renderSelector(displayLabel, onClose);
  }

  // ========================= Rest =========================
  function renderRest(omittedValues) {
    var content = "+ ".concat(omittedValues.length, " ...");
    return renderSelector(content);
  }

  // ======================== Render ========================

  return /*#__PURE__*/react.createElement("div", {
    className: selectorCls
  }, /*#__PURE__*/react.createElement(rc_overflow_es/* default */.Z, {
    prefixCls: overflowCls,
    data: value,
    renderItem: renderItem,
    renderRest: renderRest
    // suffix={inputNode}
    ,

    itemKey: function itemKey(date) {
      return formatDate(date);
    },
    maxCount: maxTagCount
  }), !value.length && /*#__PURE__*/react.createElement("span", {
    className: "".concat(prefixCls, "-selection-placeholder")
  }, placeholder));
}
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/Selector/SingleSelector/index.js





var SingleSelector_excluded = ["id", "open", "prefix", "clearIcon", "suffixIcon", "activeHelp", "allHelp", "focused", "onFocus", "onBlur", "onKeyDown", "locale", "generateConfig", "placeholder", "className", "style", "onClick", "onClear", "internalPicker", "value", "onChange", "onSubmit", "onInputChange", "multiple", "maxTagCount", "format", "maskFormat", "preserveInvalidOnBlur", "onInvalid", "disabled", "invalid", "inputReadOnly", "direction", "onOpenChange", "onMouseDown", "required", "aria-required", "autoFocus", "tabIndex", "removeIcon"];









function SingleSelector(props, ref) {
  var id = props.id,
    open = props.open,
    prefix = props.prefix,
    clearIcon = props.clearIcon,
    suffixIcon = props.suffixIcon,
    activeHelp = props.activeHelp,
    allHelp = props.allHelp,
    focused = props.focused,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onKeyDown = props.onKeyDown,
    locale = props.locale,
    generateConfig = props.generateConfig,
    placeholder = props.placeholder,
    className = props.className,
    style = props.style,
    onClick = props.onClick,
    onClear = props.onClear,
    internalPicker = props.internalPicker,
    value = props.value,
    onChange = props.onChange,
    onSubmit = props.onSubmit,
    onInputChange = props.onInputChange,
    multiple = props.multiple,
    maxTagCount = props.maxTagCount,
    format = props.format,
    maskFormat = props.maskFormat,
    preserveInvalidOnBlur = props.preserveInvalidOnBlur,
    onInvalid = props.onInvalid,
    disabled = props.disabled,
    invalid = props.invalid,
    inputReadOnly = props.inputReadOnly,
    direction = props.direction,
    onOpenChange = props.onOpenChange,
    _onMouseDown = props.onMouseDown,
    required = props.required,
    ariaRequired = props['aria-required'],
    autoFocus = props.autoFocus,
    tabIndex = props.tabIndex,
    removeIcon = props.removeIcon,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, SingleSelector_excluded);
  var rtl = direction === 'rtl';

  // ======================== Prefix ========================
  var _React$useContext = react.useContext(PickerInput_context),
    prefixCls = _React$useContext.prefixCls;

  // ========================= Refs =========================
  var rootRef = react.useRef();
  var inputRef = react.useRef();
  react.useImperativeHandle(ref, function () {
    return {
      nativeElement: rootRef.current,
      focus: function focus(options) {
        var _inputRef$current;
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus(options);
      },
      blur: function blur() {
        var _inputRef$current2;
        (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.blur();
      }
    };
  });

  // ======================== Props =========================
  var rootProps = useRootProps(restProps);

  // ======================== Change ========================
  var onSingleChange = function onSingleChange(date) {
    onChange([date]);
  };
  var onMultipleRemove = function onMultipleRemove(date) {
    var nextValues = value.filter(function (oriDate) {
      return oriDate && !isSame(generateConfig, locale, oriDate, date, internalPicker);
    });
    onChange(nextValues);

    // When `open`, it means user is operating the
    if (!open) {
      onSubmit();
    }
  };

  // ======================== Inputs ========================
  var _useInputProps = useInputProps((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
      onChange: onSingleChange
    }), function (_ref) {
      var valueTexts = _ref.valueTexts;
      return {
        value: valueTexts[0] || '',
        active: focused
      };
    }),
    _useInputProps2 = (0,slicedToArray/* default */.Z)(_useInputProps, 2),
    getInputProps = _useInputProps2[0],
    getText = _useInputProps2[1];

  // ======================== Clear =========================
  var showClear = !!(clearIcon && value.length && !disabled);

  // ======================= Multiple =======================
  var selectorNode = multiple ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(MultipleDates, {
    prefixCls: prefixCls,
    value: value,
    onRemove: onMultipleRemove,
    formatDate: getText,
    maxTagCount: maxTagCount,
    disabled: disabled,
    removeIcon: removeIcon,
    placeholder: placeholder
  }), /*#__PURE__*/react.createElement("input", {
    className: "".concat(prefixCls, "-multiple-input"),
    value: value.map(getText).join(','),
    ref: inputRef,
    readOnly: true,
    autoFocus: autoFocus,
    tabIndex: tabIndex
  }), /*#__PURE__*/react.createElement(Icon, {
    type: "suffix",
    icon: suffixIcon
  }), showClear && /*#__PURE__*/react.createElement(ClearIcon, {
    icon: clearIcon,
    onClear: onClear
  })) : /*#__PURE__*/react.createElement(Selector_Input, (0,esm_extends/* default */.Z)({
    ref: inputRef
  }, getInputProps(), {
    autoFocus: autoFocus,
    tabIndex: tabIndex,
    suffixIcon: suffixIcon,
    clearIcon: showClear && /*#__PURE__*/react.createElement(ClearIcon, {
      icon: clearIcon,
      onClear: onClear
    }),
    showActiveCls: false
  }));

  // ======================== Render ========================
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, rootProps, {
    className: classnames_default()(prefixCls, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-multiple"), multiple), "".concat(prefixCls, "-focused"), focused), "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-invalid"), invalid), "".concat(prefixCls, "-rtl"), rtl), className),
    style: style,
    ref: rootRef,
    onClick: onClick
    // Not lose current input focus
    ,

    onMouseDown: function onMouseDown(e) {
      var _inputRef$current3;
      var target = e.target;
      if (target !== ((_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.inputElement)) {
        e.preventDefault();
      }
      _onMouseDown === null || _onMouseDown === void 0 || _onMouseDown(e);
    }
  }), prefix && /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-prefix")
  }, prefix), selectorNode);
}
var RefSingleSelector = /*#__PURE__*/react.forwardRef(SingleSelector);
if (false) {}
/* harmony default export */ var Selector_SingleSelector = (RefSingleSelector);
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerInput/SinglePicker.js



























// TODO: isInvalidateDate with showTime.disabledTime should not provide `range` prop

/** Internal usage. For cross function get same aligned props */

function Picker(props, ref) {
  // ========================= Prop =========================
  var _useFilledProps = useFilledProps(props),
    _useFilledProps2 = (0,slicedToArray/* default */.Z)(_useFilledProps, 6),
    filledProps = _useFilledProps2[0],
    internalPicker = _useFilledProps2[1],
    complexPicker = _useFilledProps2[2],
    formatList = _useFilledProps2[3],
    maskFormat = _useFilledProps2[4],
    isInvalidateDate = _useFilledProps2[5];
  var _ref = filledProps,
    prefixCls = _ref.prefixCls,
    styles = _ref.styles,
    classNames = _ref.classNames,
    order = _ref.order,
    defaultValue = _ref.defaultValue,
    value = _ref.value,
    needConfirm = _ref.needConfirm,
    onChange = _ref.onChange,
    onKeyDown = _ref.onKeyDown,
    disabled = _ref.disabled,
    disabledDate = _ref.disabledDate,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    defaultOpen = _ref.defaultOpen,
    open = _ref.open,
    onOpenChange = _ref.onOpenChange,
    locale = _ref.locale,
    generateConfig = _ref.generateConfig,
    picker = _ref.picker,
    showNow = _ref.showNow,
    showToday = _ref.showToday,
    showTime = _ref.showTime,
    mode = _ref.mode,
    onPanelChange = _ref.onPanelChange,
    onCalendarChange = _ref.onCalendarChange,
    onOk = _ref.onOk,
    multiple = _ref.multiple,
    defaultPickerValue = _ref.defaultPickerValue,
    pickerValue = _ref.pickerValue,
    onPickerValueChange = _ref.onPickerValueChange,
    inputReadOnly = _ref.inputReadOnly,
    suffixIcon = _ref.suffixIcon,
    removeIcon = _ref.removeIcon,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    presets = _ref.presets,
    components = _ref.components,
    cellRender = _ref.cellRender,
    dateRender = _ref.dateRender,
    monthCellRender = _ref.monthCellRender,
    onClick = _ref.onClick;

  // ========================= Refs =========================
  var selectorRef = usePickerRef(ref);

  // ========================= Util =========================
  function pickerParam(values) {
    if (values === null) {
      return null;
    }
    return multiple ? values : values[0];
  }
  var toggleDates = useToggleDates(generateConfig, locale, internalPicker);

  // ========================= Open =========================
  var _useOpen = useOpen(open, defaultOpen, [disabled], onOpenChange),
    _useOpen2 = (0,slicedToArray/* default */.Z)(_useOpen, 2),
    mergedOpen = _useOpen2[0],
    triggerOpen = _useOpen2[1];

  // ======================= Calendar =======================
  var onInternalCalendarChange = function onInternalCalendarChange(dates, dateStrings, info) {
    if (onCalendarChange) {
      var filteredInfo = (0,objectSpread2/* default */.Z)({}, info);
      delete filteredInfo.range;
      onCalendarChange(pickerParam(dates), pickerParam(dateStrings), filteredInfo);
    }
  };
  var onInternalOk = function onInternalOk(dates) {
    onOk === null || onOk === void 0 || onOk(pickerParam(dates));
  };

  // ======================== Values ========================
  var _useInnerValue = useInnerValue(generateConfig, locale, formatList, false, order, defaultValue, value, onInternalCalendarChange, onInternalOk),
    _useInnerValue2 = (0,slicedToArray/* default */.Z)(_useInnerValue, 5),
    mergedValue = _useInnerValue2[0],
    setInnerValue = _useInnerValue2[1],
    getCalendarValue = _useInnerValue2[2],
    triggerCalendarChange = _useInnerValue2[3],
    triggerOk = _useInnerValue2[4];
  var calendarValue = getCalendarValue();

  // ======================== Active ========================
  // In SinglePicker, we will always get `activeIndex` is 0.
  var _useRangeActive = useRangeActive([disabled]),
    _useRangeActive2 = (0,slicedToArray/* default */.Z)(_useRangeActive, 4),
    focused = _useRangeActive2[0],
    triggerFocus = _useRangeActive2[1],
    lastOperation = _useRangeActive2[2],
    activeIndex = _useRangeActive2[3];
  var onSharedFocus = function onSharedFocus(event) {
    triggerFocus(true);
    onFocus === null || onFocus === void 0 || onFocus(event, {});
  };
  var onSharedBlur = function onSharedBlur(event) {
    triggerFocus(false);
    onBlur === null || onBlur === void 0 || onBlur(event, {});
  };

  // ========================= Mode =========================
  var _useMergedState = (0,es/* useMergedState */.C8)(picker, {
      value: mode
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    mergedMode = _useMergedState2[0],
    setMode = _useMergedState2[1];

  /** Extends from `mergedMode` to patch `datetime` mode */
  var internalMode = mergedMode === 'date' && showTime ? 'datetime' : mergedMode;

  // ======================= Show Now =======================
  var mergedShowNow = useShowNow(picker, mergedMode, showNow, showToday);

  // ======================== Value =========================
  var onInternalChange = onChange && function (dates, dateStrings) {
    onChange(pickerParam(dates), pickerParam(dateStrings));
  };
  var _useRangeValue = useRangeValue((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, filledProps), {}, {
      onChange: onInternalChange
    }), mergedValue, setInnerValue, getCalendarValue, triggerCalendarChange, [],
    //disabled,
    formatList, focused, mergedOpen, isInvalidateDate),
    _useRangeValue2 = (0,slicedToArray/* default */.Z)(_useRangeValue, 2),
    /** Trigger `onChange` directly without check `disabledDate` */
    triggerSubmitChange = _useRangeValue2[1];

  // ======================= Validate =======================
  var _useFieldsInvalidate = useFieldsInvalidate(calendarValue, isInvalidateDate),
    _useFieldsInvalidate2 = (0,slicedToArray/* default */.Z)(_useFieldsInvalidate, 2),
    submitInvalidates = _useFieldsInvalidate2[0],
    onSelectorInvalid = _useFieldsInvalidate2[1];
  var submitInvalidate = react.useMemo(function () {
    return submitInvalidates.some(function (invalidated) {
      return invalidated;
    });
  }, [submitInvalidates]);

  // ===================== Picker Value =====================
  // Proxy to single pickerValue
  var onInternalPickerValueChange = function onInternalPickerValueChange(dates, info) {
    if (onPickerValueChange) {
      var cleanInfo = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, info), {}, {
        mode: info.mode[0]
      });
      delete cleanInfo.range;
      onPickerValueChange(dates[0], cleanInfo);
    }
  };
  var _useRangePickerValue = useRangePickerValue(generateConfig, locale, calendarValue, [mergedMode], mergedOpen, activeIndex, internalPicker, false,
    // multiplePanel,
    defaultPickerValue, pickerValue, toArray(showTime === null || showTime === void 0 ? void 0 : showTime.defaultOpenValue), onInternalPickerValueChange, minDate, maxDate),
    _useRangePickerValue2 = (0,slicedToArray/* default */.Z)(_useRangePickerValue, 2),
    currentPickerValue = _useRangePickerValue2[0],
    setCurrentPickerValue = _useRangePickerValue2[1];

  // >>> Mode need wait for `pickerValue`
  var triggerModeChange = (0,es/* useEvent */.zX)(function (nextPickerValue, nextMode, triggerEvent) {
    setMode(nextMode);

    // Compatible with `onPanelChange`
    if (onPanelChange && triggerEvent !== false) {
      var lastPickerValue = nextPickerValue || calendarValue[calendarValue.length - 1];
      onPanelChange(lastPickerValue, nextMode);
    }
  });

  // ======================== Submit ========================
  /**
   * Different with RangePicker, confirm should check `multiple` logic.
   * This will never provide `date` instead.
   */
  var triggerConfirm = function triggerConfirm() {
    triggerSubmitChange(getCalendarValue());
    triggerOpen(false, {
      force: true
    });
  };

  // ======================== Click =========================
  var onSelectorClick = function onSelectorClick(event) {
    if (!disabled && !selectorRef.current.nativeElement.contains(document.activeElement)) {
      // Click to focus the enabled input
      selectorRef.current.focus();
    }
    triggerOpen(true);
    onClick === null || onClick === void 0 || onClick(event);
  };
  var onSelectorClear = function onSelectorClear() {
    triggerSubmitChange(null);
    triggerOpen(false, {
      force: true
    });
  };

  // ======================== Hover =========================
  var _React$useState = react.useState(null),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    hoverSource = _React$useState2[0],
    setHoverSource = _React$useState2[1];
  var _React$useState3 = react.useState(null),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    internalHoverValue = _React$useState4[0],
    setInternalHoverValue = _React$useState4[1];
  var hoverValues = react.useMemo(function () {
    var values = [internalHoverValue].concat((0,toConsumableArray/* default */.Z)(calendarValue)).filter(function (date) {
      return date;
    });
    return multiple ? values : values.slice(0, 1);
  }, [calendarValue, internalHoverValue, multiple]);

  // Selector values is different with RangePicker
  // which can not use `hoverValue` directly
  var selectorValues = react.useMemo(function () {
    if (!multiple && internalHoverValue) {
      return [internalHoverValue];
    }
    return calendarValue.filter(function (date) {
      return date;
    });
  }, [calendarValue, internalHoverValue, multiple]);

  // Clean up `internalHoverValues` when closed
  react.useEffect(function () {
    if (!mergedOpen) {
      setInternalHoverValue(null);
    }
  }, [mergedOpen]);

  // ========================================================
  // ==                       Panels                       ==
  // ========================================================
  // ======================= Presets ========================
  var presetList = usePresets(presets);
  var onPresetHover = function onPresetHover(nextValue) {
    setInternalHoverValue(nextValue);
    setHoverSource('preset');
  };

  // TODO: handle this
  var onPresetSubmit = function onPresetSubmit(nextValue) {
    var nextCalendarValues = multiple ? toggleDates(getCalendarValue(), nextValue) : [nextValue];
    var passed = triggerSubmitChange(nextCalendarValues);
    if (passed && !multiple) {
      triggerOpen(false, {
        force: true
      });
    }
  };
  var onNow = function onNow(now) {
    onPresetSubmit(now);
  };

  // ======================== Panel =========================
  var onPanelHover = function onPanelHover(date) {
    setInternalHoverValue(date);
    setHoverSource('cell');
  };

  // >>> Focus
  var onPanelFocus = function onPanelFocus(event) {
    triggerOpen(true);
    onSharedFocus(event);
  };

  // >>> Calendar
  var onPanelSelect = function onPanelSelect(date) {
    lastOperation('panel');

    // Not change values if multiple and current panel is to match with picker
    if (multiple && internalMode !== picker) {
      return;
    }
    var nextValues = multiple ? toggleDates(getCalendarValue(), date) : [date];

    // Only trigger calendar event but not update internal `calendarValue` state
    triggerCalendarChange(nextValues);

    // >>> Trigger next active if !needConfirm
    // Fully logic check `useRangeValue` hook
    if (!needConfirm && !complexPicker && internalPicker === internalMode) {
      triggerConfirm();
    }
  };

  // >>> Close
  var onPopupClose = function onPopupClose() {
    // Close popup
    triggerOpen(false);
  };

  // >>> cellRender
  var onInternalCellRender = useCellRender(cellRender, dateRender, monthCellRender);

  // >>> invalid

  var panelProps = react.useMemo(function () {
    var domProps = (0,pickAttrs/* default */.Z)(filledProps, false);
    var restProps = (0,omit/* default */.Z)(filledProps, [].concat((0,toConsumableArray/* default */.Z)(Object.keys(domProps)), ['onChange', 'onCalendarChange', 'style', 'className', 'onPanelChange']));
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, restProps), {}, {
      multiple: filledProps.multiple
    });
  }, [filledProps]);

  // >>> Render
  var panel = /*#__PURE__*/react.createElement(Popup, (0,esm_extends/* default */.Z)({}, panelProps, {
    showNow: mergedShowNow,
    showTime: showTime
    // Disabled
    ,

    disabledDate: disabledDate
    // Focus
    ,

    onFocus: onPanelFocus,
    onBlur: onSharedBlur
    // Mode
    ,

    picker: picker,
    mode: mergedMode,
    internalMode: internalMode,
    onPanelChange: triggerModeChange
    // Value
    ,

    format: maskFormat,
    value: calendarValue,
    isInvalid: isInvalidateDate,
    onChange: null,
    onSelect: onPanelSelect
    // PickerValue
    ,

    pickerValue: currentPickerValue,
    defaultOpenValue: showTime === null || showTime === void 0 ? void 0 : showTime.defaultOpenValue,
    onPickerValueChange: setCurrentPickerValue
    // Hover
    ,

    hoverValue: hoverValues,
    onHover: onPanelHover
    // Submit
    ,

    needConfirm: needConfirm,
    onSubmit: triggerConfirm,
    onOk: triggerOk
    // Preset
    ,

    presets: presetList,
    onPresetHover: onPresetHover,
    onPresetSubmit: onPresetSubmit,
    onNow: onNow
    // Render
    ,

    cellRender: onInternalCellRender
  }));

  // ========================================================
  // ==                      Selector                      ==
  // ========================================================

  // ======================== Change ========================
  var onSelectorChange = function onSelectorChange(date) {
    triggerCalendarChange(date);
  };
  var onSelectorInputChange = function onSelectorInputChange() {
    lastOperation('input');
  };

  // ======================= Selector =======================
  var onSelectorFocus = function onSelectorFocus(event) {
    lastOperation('input');
    triggerOpen(true, {
      inherit: true
    });

    // setActiveIndex(index);

    onSharedFocus(event);
  };
  var onSelectorBlur = function onSelectorBlur(event) {
    triggerOpen(false);
    onSharedBlur(event);
  };
  var onSelectorKeyDown = function onSelectorKeyDown(event, preventDefault) {
    if (event.key === 'Tab') {
      triggerConfirm();
    }
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(event, preventDefault);
  };

  // ======================= Context ========================
  var context = react.useMemo(function () {
    return {
      prefixCls: prefixCls,
      locale: locale,
      generateConfig: generateConfig,
      button: components.button,
      input: components.input
    };
  }, [prefixCls, locale, generateConfig, components.button, components.input]);

  // ======================== Effect ========================
  // >>> Mode
  // Reset for every active
  (0,useLayoutEffect/* default */.Z)(function () {
    if (mergedOpen && activeIndex !== undefined) {
      // Legacy compatible. This effect update should not trigger `onPanelChange`
      triggerModeChange(null, picker, false);
    }
  }, [mergedOpen, activeIndex, picker]);

  // >>> For complex picker, we need check if need to focus next one
  (0,useLayoutEffect/* default */.Z)(function () {
    var lastOp = lastOperation();

    // Trade as confirm on field leave
    if (!mergedOpen && lastOp === 'input') {
      triggerOpen(false);
      triggerConfirm();
    }

    // Submit with complex picker
    if (!mergedOpen && complexPicker && !needConfirm && lastOp === 'panel') {
      triggerConfirm();
    }
  }, [mergedOpen]);

  // ======================== Render ========================
  return /*#__PURE__*/react.createElement(PickerInput_context.Provider, {
    value: context
  }, /*#__PURE__*/react.createElement(es_PickerTrigger, (0,esm_extends/* default */.Z)({}, pickTriggerProps(filledProps), {
    popupElement: panel,
    popupStyle: styles.popup,
    popupClassName: classNames.popup
    // Visible
    ,

    visible: mergedOpen,
    onClose: onPopupClose
  }), /*#__PURE__*/react.createElement(Selector_SingleSelector
  // Shared
  , (0,esm_extends/* default */.Z)({}, filledProps, {
    // Ref
    ref: selectorRef
    // Icon
    ,

    suffixIcon: suffixIcon,
    removeIcon: removeIcon
    // Active
    ,

    activeHelp: !!internalHoverValue,
    allHelp: !!internalHoverValue && hoverSource === 'preset',
    focused: focused,
    onFocus: onSelectorFocus,
    onBlur: onSelectorBlur,
    onKeyDown: onSelectorKeyDown,
    onSubmit: triggerConfirm
    // Change
    ,

    value: selectorValues,
    maskFormat: maskFormat,
    onChange: onSelectorChange,
    onInputChange: onSelectorInputChange,
    internalPicker: internalPicker
    // Format
    ,

    format: formatList,
    inputReadOnly: inputReadOnly
    // Disabled
    ,

    disabled: disabled
    // Open
    ,

    open: mergedOpen,
    onOpenChange: triggerOpen
    // Click
    ,

    onClick: onSelectorClick,
    onClear: onSelectorClear
    // Invalid
    ,

    invalid: submitInvalidate,
    onInvalid: function onInvalid(invalid) {
      // Only `single` mode support type date.
      // `multiple` mode can not typing.
      onSelectorInvalid(invalid, 0);
    }
  }))));
}
var RefPicker = /*#__PURE__*/react.forwardRef(Picker);
if (false) {}
/* harmony default export */ var SinglePicker = (RefPicker);
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/index.js
/**
 * What's new?
 * - Common
 *  - [Break] Support special year format, all the year will follow the locale config.
 *  - Blur all of field will trigger `onChange` if validate
 *  - Support `preserveInvalidOnBlur` to not to clean input if invalid and remove `changeOnBlur`
 *  - `pickerValue` is now full controlled
 *    - `defaultPickerValue` will take effect on every field active with popup opening.
 *  - [Break] clear button return the event with `onClick`
 *
 * - Locale
 *  - Remove `dateFormat` since it's never used
 *  - Remove `dateTimeFormat` since it's never used
 *
 * - Picker
 *  - TimePicker support `changeOnScroll`
 *  - TimePicker support `millisecond`
 *  - Support cellMeridiemFormat for AM/PM
 *  - Get correct `disabledHours` when set `use12Hours`
 *  - Support `showWeek`
 *
 * - RangePicker
 *  - [Break] RangePicker is now not limit the range of clicked field.
 *  - Trigger `onCalendarChange` when type correct
 *  - [Break] Not order `value` if given `value` is wrong order.
 *  - Hover `presets` will show date in input field.
 *  - [Break] RangePicker go to end field, `pickerValue` will follow the start field if not controlled.
 */





/* harmony default export */ var rc_picker_es = (SinglePicker);

/***/ }),

/***/ 50371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ en_US; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/locale/common.js
var commonLocale = {
  yearFormat: 'YYYY',
  dayFormat: 'D',
  cellMeridiemFormat: 'A',
  monthBeforeYear: true
};
;// CONCATENATED MODULE: ./node_modules/rc-picker/es/locale/en_US.js


var locale = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, commonLocale), {}, {
  locale: 'en_US',
  today: 'Today',
  now: 'Now',
  backToToday: 'Back to today',
  ok: 'OK',
  clear: 'Clear',
  week: 'Week',
  month: 'Month',
  year: 'Year',
  timeSelect: 'select time',
  dateSelect: 'select date',
  weekSelect: 'Choose a week',
  monthSelect: 'Choose a month',
  yearSelect: 'Choose a year',
  decadeSelect: 'Choose a decade',
  dateFormat: 'M/D/YYYY',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  previousMonth: 'Previous month (PageUp)',
  nextMonth: 'Next month (PageDown)',
  previousYear: 'Last year (Control + left)',
  nextYear: 'Next year (Control + right)',
  previousDecade: 'Last decade',
  nextDecade: 'Next decade',
  previousCentury: 'Last century',
  nextCentury: 'Next century'
});
/* harmony default export */ var en_US = (locale);

/***/ }),

/***/ 39260:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.commonLocale = void 0;
var commonLocale = exports.commonLocale = {
  yearFormat: 'YYYY',
  dayFormat: 'D',
  cellMeridiemFormat: 'A',
  monthBeforeYear: true
};

/***/ }),

/***/ 77387:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(44512)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(28440));
var _common = __webpack_require__(39260);
var locale = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _common.commonLocale), {}, {
  locale: 'en_US',
  today: 'Today',
  now: 'Now',
  backToToday: 'Back to today',
  ok: 'OK',
  clear: 'Clear',
  week: 'Week',
  month: 'Month',
  year: 'Year',
  timeSelect: 'select time',
  dateSelect: 'select date',
  weekSelect: 'Choose a week',
  monthSelect: 'Choose a month',
  yearSelect: 'Choose a year',
  decadeSelect: 'Choose a decade',
  dateFormat: 'M/D/YYYY',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  previousMonth: 'Previous month (PageUp)',
  nextMonth: 'Next month (PageDown)',
  previousYear: 'Last year (Control + left)',
  nextYear: 'Next year (Control + right)',
  previousDecade: 'Last decade',
  nextDecade: 'Next decade',
  previousCentury: 'Last century',
  nextCentury: 'Next century'
});
var _default = exports["default"] = locale;

/***/ }),

/***/ 38100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Cd": function() { return /* reexport */ es_Circle; }
});

// UNUSED EXPORTS: Line, default

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/rc-progress/es/common.js

var defaultProps = {
  percent: 0,
  prefixCls: 'rc-progress',
  strokeColor: '#2db7f5',
  strokeLinecap: 'round',
  strokeWidth: 1,
  trailColor: '#D9D9D9',
  trailWidth: 1,
  gapPosition: 'bottom'
};
var useTransitionDuration = function useTransitionDuration() {
  var pathsRef = (0,react.useRef)([]);
  var prevTimeStamp = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    var now = Date.now();
    var updated = false;
    pathsRef.current.forEach(function (path) {
      if (!path) {
        return;
      }
      updated = true;
      var pathStyle = path.style;
      pathStyle.transitionDuration = '.3s, .3s, .3s, .06s';
      if (prevTimeStamp.current && now - prevTimeStamp.current < 100) {
        pathStyle.transitionDuration = '0s, 0s';
      }
    });
    if (updated) {
      prevTimeStamp.current = Date.now();
    }
  });
  return pathsRef.current;
};
;// CONCATENATED MODULE: ./node_modules/rc-progress/es/Line.js



var _excluded = ["className", "percent", "prefixCls", "strokeColor", "strokeLinecap", "strokeWidth", "style", "trailColor", "trailWidth", "transition"];



var Line = function Line(props) {
  var _defaultProps$props = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, defaultProps), props),
    className = _defaultProps$props.className,
    percent = _defaultProps$props.percent,
    prefixCls = _defaultProps$props.prefixCls,
    strokeColor = _defaultProps$props.strokeColor,
    strokeLinecap = _defaultProps$props.strokeLinecap,
    strokeWidth = _defaultProps$props.strokeWidth,
    style = _defaultProps$props.style,
    trailColor = _defaultProps$props.trailColor,
    trailWidth = _defaultProps$props.trailWidth,
    transition = _defaultProps$props.transition,
    restProps = (0,objectWithoutProperties/* default */.Z)(_defaultProps$props, _excluded);

  // eslint-disable-next-line no-param-reassign
  delete restProps.gapPosition;
  var percentList = Array.isArray(percent) ? percent : [percent];
  var strokeColorList = Array.isArray(strokeColor) ? strokeColor : [strokeColor];
  var paths = useTransitionDuration();
  var center = strokeWidth / 2;
  var right = 100 - strokeWidth / 2;
  var pathString = "M ".concat(strokeLinecap === 'round' ? center : 0, ",").concat(center, "\n         L ").concat(strokeLinecap === 'round' ? right : 100, ",").concat(center);
  var viewBoxString = "0 0 100 ".concat(strokeWidth);
  var stackPtg = 0;
  return /*#__PURE__*/react.createElement("svg", (0,esm_extends/* default */.Z)({
    className: classnames_default()("".concat(prefixCls, "-line"), className),
    viewBox: viewBoxString,
    preserveAspectRatio: "none",
    style: style
  }, restProps), /*#__PURE__*/react.createElement("path", {
    className: "".concat(prefixCls, "-line-trail"),
    d: pathString,
    strokeLinecap: strokeLinecap,
    stroke: trailColor,
    strokeWidth: trailWidth || strokeWidth,
    fillOpacity: "0"
  }), percentList.map(function (ptg, index) {
    var dashPercent = 1;
    switch (strokeLinecap) {
      case 'round':
        dashPercent = 1 - strokeWidth / 100;
        break;
      case 'square':
        dashPercent = 1 - strokeWidth / 2 / 100;
        break;
      default:
        dashPercent = 1;
        break;
    }
    var pathStyle = {
      strokeDasharray: "".concat(ptg * dashPercent, "px, 100px"),
      strokeDashoffset: "-".concat(stackPtg, "px"),
      transition: transition || 'stroke-dashoffset 0.3s ease 0s, stroke-dasharray .3s ease 0s, stroke 0.3s linear'
    };
    var color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
    stackPtg += ptg;
    return /*#__PURE__*/react.createElement("path", {
      key: index,
      className: "".concat(prefixCls, "-line-path"),
      d: pathString,
      strokeLinecap: strokeLinecap,
      stroke: color,
      strokeWidth: strokeWidth,
      fillOpacity: "0",
      ref: function ref(elem) {
        // https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
        // React will call the ref callback with the DOM element when the component mounts,
        // and call it with `null` when it unmounts.
        // Refs are guaranteed to be up-to-date before componentDidMount or componentDidUpdate fires.

        paths[index] = elem;
      },
      style: pathStyle
    });
  }));
};
if (false) {}
/* harmony default export */ var es_Line = (Line);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/canUseDom.js
var canUseDom = __webpack_require__(55304);
;// CONCATENATED MODULE: ./node_modules/rc-progress/es/hooks/useId.js



var uuid = 0;

/** Is client side and not jsdom */
var isBrowserClient =  true && (0,canUseDom/* default */.Z)();

/** Get unique id for accessibility usage */
function getUUID() {
  var retId;

  // Test never reach
  /* istanbul ignore if */
  if (isBrowserClient) {
    retId = uuid;
    uuid += 1;
  } else {
    retId = 'TEST_OR_SSR';
  }
  return retId;
}
/* harmony default export */ var useId = (function (id) {
  // Inner id for accessibility usage. Only work in client side
  var _React$useState = react.useState(),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    innerId = _React$useState2[0],
    setInnerId = _React$useState2[1];
  react.useEffect(function () {
    setInnerId("rc_progress_".concat(getUUID()));
  }, []);
  return id || innerId;
});
;// CONCATENATED MODULE: ./node_modules/rc-progress/es/Circle/PtgCircle.js


var Block = function Block(_ref) {
  var bg = _ref.bg,
    children = _ref.children;
  return /*#__PURE__*/react.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      background: bg
    }
  }, children);
};
function getPtgColors(color, scale) {
  return Object.keys(color).map(function (key) {
    var parsedKey = parseFloat(key);
    var ptgKey = "".concat(Math.floor(parsedKey * scale), "%");
    return "".concat(color[key], " ").concat(ptgKey);
  });
}
var PtgCircle = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    color = props.color,
    gradientId = props.gradientId,
    radius = props.radius,
    circleStyleForStack = props.style,
    ptg = props.ptg,
    strokeLinecap = props.strokeLinecap,
    strokeWidth = props.strokeWidth,
    size = props.size,
    gapDegree = props.gapDegree;
  var isGradient = color && (0,esm_typeof/* default */.Z)(color) === 'object';
  var stroke = isGradient ? "#FFF" : undefined;

  // ========================== Circle ==========================
  var halfSize = size / 2;
  var circleNode = /*#__PURE__*/react.createElement("circle", {
    className: "".concat(prefixCls, "-circle-path"),
    r: radius,
    cx: halfSize,
    cy: halfSize,
    stroke: stroke,
    strokeLinecap: strokeLinecap,
    strokeWidth: strokeWidth,
    opacity: ptg === 0 ? 0 : 1,
    style: circleStyleForStack,
    ref: ref
  });

  // ========================== Render ==========================
  if (!isGradient) {
    return circleNode;
  }
  var maskId = "".concat(gradientId, "-conic");
  var fromDeg = gapDegree ? "".concat(180 + gapDegree / 2, "deg") : '0deg';
  var conicColors = getPtgColors(color, (360 - gapDegree) / 360);
  var linearColors = getPtgColors(color, 1);
  var conicColorBg = "conic-gradient(from ".concat(fromDeg, ", ").concat(conicColors.join(', '), ")");
  var linearColorBg = "linear-gradient(to ".concat(gapDegree ? 'bottom' : 'top', ", ").concat(linearColors.join(', '), ")");
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("mask", {
    id: maskId
  }, circleNode), /*#__PURE__*/react.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: size,
    height: size,
    mask: "url(#".concat(maskId, ")")
  }, /*#__PURE__*/react.createElement(Block, {
    bg: linearColorBg
  }, /*#__PURE__*/react.createElement(Block, {
    bg: conicColorBg
  }))));
});
if (false) {}
/* harmony default export */ var Circle_PtgCircle = (PtgCircle);
;// CONCATENATED MODULE: ./node_modules/rc-progress/es/Circle/util.js
var VIEW_BOX_SIZE = 100;
var getCircleStyle = function getCircleStyle(perimeter, perimeterWithoutGap, offset, percent, rotateDeg, gapDegree, gapPosition, strokeColor, strokeLinecap, strokeWidth) {
  var stepSpace = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : 0;
  var offsetDeg = offset / 100 * 360 * ((360 - gapDegree) / 360);
  var positionDeg = gapDegree === 0 ? 0 : {
    bottom: 0,
    top: 180,
    left: 90,
    right: -90
  }[gapPosition];
  var strokeDashoffset = (100 - percent) / 100 * perimeterWithoutGap;
  // Fix percent accuracy when strokeLinecap is round
  // https://github.com/ant-design/ant-design/issues/35009
  if (strokeLinecap === 'round' && percent !== 100) {
    strokeDashoffset += strokeWidth / 2;
    // when percent is small enough (<= 1%), keep smallest value to avoid it's disappearance
    if (strokeDashoffset >= perimeterWithoutGap) {
      strokeDashoffset = perimeterWithoutGap - 0.01;
    }
  }
  var halfSize = VIEW_BOX_SIZE / 2;
  return {
    stroke: typeof strokeColor === 'string' ? strokeColor : undefined,
    strokeDasharray: "".concat(perimeterWithoutGap, "px ").concat(perimeter),
    strokeDashoffset: strokeDashoffset + stepSpace,
    transform: "rotate(".concat(rotateDeg + offsetDeg + positionDeg, "deg)"),
    transformOrigin: "".concat(halfSize, "px ").concat(halfSize, "px"),
    transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s',
    fillOpacity: 0
  };
};
;// CONCATENATED MODULE: ./node_modules/rc-progress/es/Circle/index.js




var Circle_excluded = ["id", "prefixCls", "steps", "strokeWidth", "trailWidth", "gapDegree", "gapPosition", "trailColor", "strokeLinecap", "style", "className", "strokeColor", "percent"];






function toArray(value) {
  var mergedValue = value !== null && value !== void 0 ? value : [];
  return Array.isArray(mergedValue) ? mergedValue : [mergedValue];
}
var Circle = function Circle(props) {
  var _defaultProps$props = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, defaultProps), props),
    id = _defaultProps$props.id,
    prefixCls = _defaultProps$props.prefixCls,
    steps = _defaultProps$props.steps,
    strokeWidth = _defaultProps$props.strokeWidth,
    trailWidth = _defaultProps$props.trailWidth,
    _defaultProps$props$g = _defaultProps$props.gapDegree,
    gapDegree = _defaultProps$props$g === void 0 ? 0 : _defaultProps$props$g,
    gapPosition = _defaultProps$props.gapPosition,
    trailColor = _defaultProps$props.trailColor,
    strokeLinecap = _defaultProps$props.strokeLinecap,
    style = _defaultProps$props.style,
    className = _defaultProps$props.className,
    strokeColor = _defaultProps$props.strokeColor,
    percent = _defaultProps$props.percent,
    restProps = (0,objectWithoutProperties/* default */.Z)(_defaultProps$props, Circle_excluded);
  var halfSize = VIEW_BOX_SIZE / 2;
  var mergedId = useId(id);
  var gradientId = "".concat(mergedId, "-gradient");
  var radius = halfSize - strokeWidth / 2;
  var perimeter = Math.PI * 2 * radius;
  var rotateDeg = gapDegree > 0 ? 90 + gapDegree / 2 : -90;
  var perimeterWithoutGap = perimeter * ((360 - gapDegree) / 360);
  var _ref = (0,esm_typeof/* default */.Z)(steps) === 'object' ? steps : {
      count: steps,
      gap: 2
    },
    stepCount = _ref.count,
    stepGap = _ref.gap;
  var percentList = toArray(percent);
  var strokeColorList = toArray(strokeColor);
  var gradient = strokeColorList.find(function (color) {
    return color && (0,esm_typeof/* default */.Z)(color) === 'object';
  });
  var isConicGradient = gradient && (0,esm_typeof/* default */.Z)(gradient) === 'object';
  var mergedStrokeLinecap = isConicGradient ? 'butt' : strokeLinecap;
  var circleStyle = getCircleStyle(perimeter, perimeterWithoutGap, 0, 100, rotateDeg, gapDegree, gapPosition, trailColor, mergedStrokeLinecap, strokeWidth);
  var paths = useTransitionDuration();
  var getStokeList = function getStokeList() {
    var stackPtg = 0;
    return percentList.map(function (ptg, index) {
      var color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
      var circleStyleForStack = getCircleStyle(perimeter, perimeterWithoutGap, stackPtg, ptg, rotateDeg, gapDegree, gapPosition, color, mergedStrokeLinecap, strokeWidth);
      stackPtg += ptg;
      return /*#__PURE__*/react.createElement(Circle_PtgCircle, {
        key: index,
        color: color,
        ptg: ptg,
        radius: radius,
        prefixCls: prefixCls,
        gradientId: gradientId,
        style: circleStyleForStack,
        strokeLinecap: mergedStrokeLinecap,
        strokeWidth: strokeWidth,
        gapDegree: gapDegree,
        ref: function ref(elem) {
          // https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
          // React will call the ref callback with the DOM element when the component mounts,
          // and call it with `null` when it unmounts.
          // Refs are guaranteed to be up-to-date before componentDidMount or componentDidUpdate fires.

          paths[index] = elem;
        },
        size: VIEW_BOX_SIZE
      });
    }).reverse();
  };
  var getStepStokeList = function getStepStokeList() {
    // only show the first percent when pass steps
    var current = Math.round(stepCount * (percentList[0] / 100));
    var stepPtg = 100 / stepCount;
    var stackPtg = 0;
    return new Array(stepCount).fill(null).map(function (_, index) {
      var color = index <= current - 1 ? strokeColorList[0] : trailColor;
      var stroke = color && (0,esm_typeof/* default */.Z)(color) === 'object' ? "url(#".concat(gradientId, ")") : undefined;
      var circleStyleForStack = getCircleStyle(perimeter, perimeterWithoutGap, stackPtg, stepPtg, rotateDeg, gapDegree, gapPosition, color, 'butt', strokeWidth, stepGap);
      stackPtg += (perimeterWithoutGap - circleStyleForStack.strokeDashoffset + stepGap) * 100 / perimeterWithoutGap;
      return /*#__PURE__*/react.createElement("circle", {
        key: index,
        className: "".concat(prefixCls, "-circle-path"),
        r: radius,
        cx: halfSize,
        cy: halfSize,
        stroke: stroke,
        strokeWidth: strokeWidth,
        opacity: 1,
        style: circleStyleForStack,
        ref: function ref(elem) {
          paths[index] = elem;
        }
      });
    });
  };
  return /*#__PURE__*/react.createElement("svg", (0,esm_extends/* default */.Z)({
    className: classnames_default()("".concat(prefixCls, "-circle"), className),
    viewBox: "0 0 ".concat(VIEW_BOX_SIZE, " ").concat(VIEW_BOX_SIZE),
    style: style,
    id: id,
    role: "presentation"
  }, restProps), !stepCount && /*#__PURE__*/react.createElement("circle", {
    className: "".concat(prefixCls, "-circle-trail"),
    r: radius,
    cx: halfSize,
    cy: halfSize,
    stroke: trailColor,
    strokeLinecap: mergedStrokeLinecap,
    strokeWidth: trailWidth || strokeWidth,
    style: circleStyle
  }), stepCount ? getStepStokeList() : getStokeList());
};
if (false) {}
/* harmony default export */ var es_Circle = (Circle);
;// CONCATENATED MODULE: ./node_modules/rc-progress/es/index.js



/* harmony default export */ var es = ({
  Line: es_Line,
  Circle: es_Circle
});

/***/ }),

/***/ 49938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es; }
});

// UNUSED EXPORTS: _rs

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Children/toArray.js
var toArray = __webpack_require__(93550);
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(13764);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/findDOMNode.js
var findDOMNode = __webpack_require__(33970);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(99195);
;// CONCATENATED MODULE: ./node_modules/rc-resize-observer/es/Collection.js

var CollectionContext = /*#__PURE__*/react.createContext(null);
/**
 * Collect all the resize event from children ResizeObserver
 */
function Collection(_ref) {
  var children = _ref.children,
    onBatchResize = _ref.onBatchResize;
  var resizeIdRef = react.useRef(0);
  var resizeInfosRef = react.useRef([]);
  var onCollectionResize = react.useContext(CollectionContext);
  var onResize = react.useCallback(function (size, element, data) {
    resizeIdRef.current += 1;
    var currentId = resizeIdRef.current;
    resizeInfosRef.current.push({
      size: size,
      element: element,
      data: data
    });
    Promise.resolve().then(function () {
      if (currentId === resizeIdRef.current) {
        onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
        resizeInfosRef.current = [];
      }
    });

    // Continue bubbling if parent exist
    onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data);
  }, [onBatchResize, onCollectionResize]);
  return /*#__PURE__*/react.createElement(CollectionContext.Provider, {
    value: onResize
  }, children);
}
// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(13665);
;// CONCATENATED MODULE: ./node_modules/rc-resize-observer/es/utils/observerUtil.js

// =============================== Const ===============================
var elementListeners = new Map();
function onResize(entities) {
  entities.forEach(function (entity) {
    var _elementListeners$get;
    var target = entity.target;
    (_elementListeners$get = elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function (listener) {
      return listener(target);
    });
  });
}

// Note: ResizeObserver polyfill not support option to measure border-box resize
var resizeObserver = new ResizeObserver_es/* default */.Z(onResize);

// Dev env only
var _el = (/* unused pure expression or super */ null && ( false ? 0 : null)); // eslint-disable-line
var _rs = (/* unused pure expression or super */ null && ( false ? 0 : null)); // eslint-disable-line

// ============================== Observe ==============================
function observe(element, callback) {
  if (!elementListeners.has(element)) {
    elementListeners.set(element, new Set());
    resizeObserver.observe(element);
  }
  elementListeners.get(element).add(callback);
}
function unobserve(element, callback) {
  if (elementListeners.has(element)) {
    elementListeners.get(element).delete(callback);
    if (!elementListeners.get(element).size) {
      resizeObserver.unobserve(element);
      elementListeners.delete(element);
    }
  }
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6223);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(79427);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(34766);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js
var createSuper = __webpack_require__(56302);
;// CONCATENATED MODULE: ./node_modules/rc-resize-observer/es/SingleObserver/DomWrapper.js





/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */
var DomWrapper = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(DomWrapper, _React$Component);
  var _super = (0,createSuper/* default */.Z)(DomWrapper);
  function DomWrapper() {
    (0,classCallCheck/* default */.Z)(this, DomWrapper);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(DomWrapper, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return DomWrapper;
}(react.Component);

;// CONCATENATED MODULE: ./node_modules/rc-resize-observer/es/SingleObserver/index.js








function SingleObserver(props, ref) {
  var children = props.children,
    disabled = props.disabled;
  var elementRef = react.useRef(null);
  var wrapperRef = react.useRef(null);
  var onCollectionResize = react.useContext(CollectionContext);

  // =========================== Children ===========================
  var isRenderProps = typeof children === 'function';
  var mergedChildren = isRenderProps ? children(elementRef) : children;

  // ============================= Size =============================
  var sizeRef = react.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  });

  // ============================= Ref ==============================
  var canRef = !isRenderProps && /*#__PURE__*/react.isValidElement(mergedChildren) && (0,es_ref/* supportRef */.Yr)(mergedChildren);
  var originRef = canRef ? (0,es_ref/* getNodeRef */.C4)(mergedChildren) : null;
  var mergedRef = (0,es_ref/* useComposeRef */.x1)(originRef, elementRef);
  var getDom = function getDom() {
    var _elementRef$current;
    return (0,findDOMNode/* default */.ZP)(elementRef.current) || (
    // Support `nativeElement` format
    elementRef.current && (0,esm_typeof/* default */.Z)(elementRef.current) === 'object' ? (0,findDOMNode/* default */.ZP)((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || (0,findDOMNode/* default */.ZP)(wrapperRef.current);
  };
  react.useImperativeHandle(ref, function () {
    return getDom();
  });

  // =========================== Observe ============================
  var propsRef = react.useRef(props);
  propsRef.current = props;

  // Handler
  var onInternalResize = react.useCallback(function (target) {
    var _propsRef$current = propsRef.current,
      onResize = _propsRef$current.onResize,
      data = _propsRef$current.data;
    var _target$getBoundingCl = target.getBoundingClientRect(),
      width = _target$getBoundingCl.width,
      height = _target$getBoundingCl.height;
    var offsetWidth = target.offsetWidth,
      offsetHeight = target.offsetHeight;

    /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */
    var fixedWidth = Math.floor(width);
    var fixedHeight = Math.floor(height);
    if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
      var size = {
        width: fixedWidth,
        height: fixedHeight,
        offsetWidth: offsetWidth,
        offsetHeight: offsetHeight
      };
      sizeRef.current = size;

      // IE is strange, right?
      var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
      var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
      var sizeInfo = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, size), {}, {
        offsetWidth: mergedOffsetWidth,
        offsetHeight: mergedOffsetHeight
      });

      // Let collection know what happened
      onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data);
      if (onResize) {
        // defer the callback but not defer to next frame
        Promise.resolve().then(function () {
          onResize(sizeInfo, target);
        });
      }
    }
  }, []);

  // Dynamic observe
  react.useEffect(function () {
    var currentElement = getDom();
    if (currentElement && !disabled) {
      observe(currentElement, onInternalResize);
    }
    return function () {
      return unobserve(currentElement, onInternalResize);
    };
  }, [elementRef.current, disabled]);

  // ============================ Render ============================
  return /*#__PURE__*/react.createElement(DomWrapper, {
    ref: wrapperRef
  }, canRef ? /*#__PURE__*/react.cloneElement(mergedChildren, {
    ref: mergedRef
  }) : mergedChildren);
}
var RefSingleObserver = /*#__PURE__*/react.forwardRef(SingleObserver);
if (false) {}
/* harmony default export */ var es_SingleObserver = (RefSingleObserver);
;// CONCATENATED MODULE: ./node_modules/rc-resize-observer/es/index.js






var INTERNAL_PREFIX_KEY = 'rc-observer-key';


function ResizeObserver(props, ref) {
  var children = props.children;
  var childNodes = typeof children === 'function' ? [children] : (0,toArray/* default */.Z)(children);
  if (false) {}
  return childNodes.map(function (child, index) {
    var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat(INTERNAL_PREFIX_KEY, "-").concat(index);
    return /*#__PURE__*/react.createElement(es_SingleObserver, (0,esm_extends/* default */.Z)({}, props, {
      key: key,
      ref: index === 0 ? ref : undefined
    }), child);
  });
}
var RefResizeObserver = /*#__PURE__*/react.forwardRef(ResizeObserver);
if (false) {}
RefResizeObserver.Collection = Collection;
/* harmony default export */ var es = (RefResizeObserver);

/***/ }),

/***/ 91935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ useId; }
/* harmony export */ });
/* unused harmony exports isBrowserClient, getUUID */
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40656);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var rc_util_es_Dom_canUseDom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55304);



var uuid = 0;

/** Is client side and not jsdom */
var isBrowserClient =  true && (0,rc_util_es_Dom_canUseDom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();

/** Get unique id for accessibility usage */
function getUUID() {
  var retId;

  // Test never reach
  /* istanbul ignore if */
  if (isBrowserClient) {
    retId = uuid;
    uuid += 1;
  } else {
    retId = 'TEST_OR_SSR';
  }
  return retId;
}
function useId(id) {
  // Inner id for accessibility usage. Only work in client side
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(),
    _React$useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_React$useState, 2),
    innerId = _React$useState2[0],
    setInnerId = _React$useState2[1];
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    setInnerId("rc_select_".concat(getUUID()));
  }, []);
  return id || innerId;
}

/***/ }),

/***/ 24311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ac": function() { return /* reexport */ es_BaseSelect; },
  "Xo": function() { return /* reexport */ es_OptGroup; },
  "Wx": function() { return /* reexport */ es_Option; },
  "ZP": function() { return /* binding */ rc_select_es; },
  "lk": function() { return /* reexport */ useBaseProps; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMergedState.js
var useMergedState = __webpack_require__(78877);
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var es_warning = __webpack_require__(13764);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useLayoutEffect.js
var useLayoutEffect = __webpack_require__(76963);
// EXTERNAL MODULE: ./node_modules/rc-util/es/isMobile.js
var isMobile = __webpack_require__(87122);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(99195);
;// CONCATENATED MODULE: ./node_modules/rc-select/es/TransBtn.js


var TransBtn = function TransBtn(props) {
  var className = props.className,
    customizeIcon = props.customizeIcon,
    customizeIconProps = props.customizeIconProps,
    children = props.children,
    _onMouseDown = props.onMouseDown,
    onClick = props.onClick;
  var icon = typeof customizeIcon === 'function' ? customizeIcon(customizeIconProps) : customizeIcon;
  return /*#__PURE__*/react.createElement("span", {
    className: className,
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      _onMouseDown === null || _onMouseDown === void 0 || _onMouseDown(event);
    },
    style: {
      userSelect: 'none',
      WebkitUserSelect: 'none'
    },
    unselectable: "on",
    onClick: onClick,
    "aria-hidden": true
  }, icon !== undefined ? icon : /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(className.split(/\s+/).map(function (cls) {
      return "".concat(cls, "-icon");
    }))
  }, children));
};
/* harmony default export */ var es_TransBtn = (TransBtn);
;// CONCATENATED MODULE: ./node_modules/rc-select/es/hooks/useAllowClear.js



var useAllowClear = function useAllowClear(prefixCls, onClearMouseDown, displayValues, allowClear, clearIcon) {
  var disabled = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var mergedSearchValue = arguments.length > 6 ? arguments[6] : undefined;
  var mode = arguments.length > 7 ? arguments[7] : undefined;
  var mergedClearIcon = react.useMemo(function () {
    if ((0,esm_typeof/* default */.Z)(allowClear) === 'object') {
      return allowClear.clearIcon;
    }
    if (clearIcon) {
      return clearIcon;
    }
  }, [allowClear, clearIcon]);
  var mergedAllowClear = react.useMemo(function () {
    if (!disabled && !!allowClear && (displayValues.length || mergedSearchValue) && !(mode === 'combobox' && mergedSearchValue === '')) {
      return true;
    }
    return false;
  }, [allowClear, disabled, displayValues.length, mergedSearchValue, mode]);
  return {
    allowClear: mergedAllowClear,
    clearIcon: /*#__PURE__*/react.createElement(es_TransBtn, {
      className: "".concat(prefixCls, "-clear"),
      onMouseDown: onClearMouseDown,
      customizeIcon: mergedClearIcon
    }, "\xD7")
  };
};
;// CONCATENATED MODULE: ./node_modules/rc-select/es/hooks/useBaseProps.js
/**
 * BaseSelect provide some parsed data into context.
 * You can use this hooks to get them.
 */


var BaseSelectContext = /*#__PURE__*/react.createContext(null);
function useBaseProps() {
  return react.useContext(BaseSelectContext);
}
;// CONCATENATED MODULE: ./node_modules/rc-select/es/hooks/useDelayReset.js



/**
 * Similar with `useLock`, but this hook will always execute last value.
 * When set to `true`, it will keep `true` for a short time even if `false` is set.
 */
function useDelayReset() {
  var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    bool = _React$useState2[0],
    setBool = _React$useState2[1];
  var delayRef = react.useRef(null);
  var cancelLatest = function cancelLatest() {
    window.clearTimeout(delayRef.current);
  };
  react.useEffect(function () {
    return cancelLatest;
  }, []);
  var delaySetBool = function delaySetBool(value, callback) {
    cancelLatest();
    delayRef.current = window.setTimeout(function () {
      setBool(value);
      if (callback) {
        callback();
      }
    }, timeout);
  };
  return [bool, delaySetBool, cancelLatest];
}
;// CONCATENATED MODULE: ./node_modules/rc-select/es/hooks/useLock.js


/**
 * Locker return cached mark.
 * If set to `true`, will return `true` in a short time even if set `false`.
 * If set to `false` and then set to `true`, will change to `true`.
 * And after time duration, it will back to `null` automatically.
 */
function useLock() {
  var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 250;
  var lockRef = react.useRef(null);
  var timeoutRef = react.useRef(null);

  // Clean up
  react.useEffect(function () {
    return function () {
      window.clearTimeout(timeoutRef.current);
    };
  }, []);
  function doLock(locked) {
    if (locked || lockRef.current === null) {
      lockRef.current = locked;
    }
    window.clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(function () {
      lockRef.current = null;
    }, duration);
  }
  return [function () {
    return lockRef.current;
  }, doLock];
}
;// CONCATENATED MODULE: ./node_modules/rc-select/es/hooks/useSelectTriggerControl.js

function useSelectTriggerControl(elements, open, triggerOpen, customizedTrigger) {
  var propsRef = react.useRef(null);
  propsRef.current = {
    open: open,
    triggerOpen: triggerOpen,
    customizedTrigger: customizedTrigger
  };
  react.useEffect(function () {
    function onGlobalMouseDown(event) {
      var _propsRef$current;
      // If trigger is customized, Trigger will take control of popupVisible
      if ((_propsRef$current = propsRef.current) !== null && _propsRef$current !== void 0 && _propsRef$current.customizedTrigger) {
        return;
      }
      var target = event.target;
      if (target.shadowRoot && event.composed) {
        target = event.composedPath()[0] || target;
      }
      if (propsRef.current.open && elements().filter(function (element) {
        return element;
      }).every(function (element) {
        return !element.contains(target) && element !== target;
      })) {
        // Should trigger close
        propsRef.current.triggerOpen(false);
      }
    }
    window.addEventListener('mousedown', onGlobalMouseDown);
    return function () {
      return window.removeEventListener('mousedown', onGlobalMouseDown);
    };
  }, []);
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js
var KeyCode = __webpack_require__(88035);
;// CONCATENATED MODULE: ./node_modules/rc-select/es/utils/keyUtil.js


/** keyCode Judgment function */
function isValidateOpenKey(currentKeyCode) {
  return (
    // Undefined for Edge bug:
    // https://github.com/ant-design/ant-design/issues/51292
    currentKeyCode &&
    // Other keys
    ![
    // System function button
    KeyCode/* default.ESC */.Z.ESC, KeyCode/* default.SHIFT */.Z.SHIFT, KeyCode/* default.BACKSPACE */.Z.BACKSPACE, KeyCode/* default.TAB */.Z.TAB, KeyCode/* default.WIN_KEY */.Z.WIN_KEY, KeyCode/* default.ALT */.Z.ALT, KeyCode/* default.META */.Z.META, KeyCode/* default.WIN_KEY_RIGHT */.Z.WIN_KEY_RIGHT, KeyCode/* default.CTRL */.Z.CTRL, KeyCode/* default.SEMICOLON */.Z.SEMICOLON, KeyCode/* default.EQUALS */.Z.EQUALS, KeyCode/* default.CAPS_LOCK */.Z.CAPS_LOCK, KeyCode/* default.CONTEXT_MENU */.Z.CONTEXT_MENU,
    // F1-F12
    KeyCode/* default.F1 */.Z.F1, KeyCode/* default.F2 */.Z.F2, KeyCode/* default.F3 */.Z.F3, KeyCode/* default.F4 */.Z.F4, KeyCode/* default.F5 */.Z.F5, KeyCode/* default.F6 */.Z.F6, KeyCode/* default.F7 */.Z.F7, KeyCode/* default.F8 */.Z.F8, KeyCode/* default.F9 */.Z.F9, KeyCode/* default.F10 */.Z.F10, KeyCode/* default.F11 */.Z.F11, KeyCode/* default.F12 */.Z.F12].includes(currentKeyCode)
  );
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/pickAttrs.js
var pickAttrs = __webpack_require__(75844);
// EXTERNAL MODULE: ./node_modules/rc-overflow/es/index.js + 6 modules
var es = __webpack_require__(16344);
;// CONCATENATED MODULE: ./node_modules/rc-util/es/composeProps.js

function composeProps(originProps, patchProps, isAll) {
  var composedProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, originProps), isAll ? patchProps : {});
  Object.keys(patchProps).forEach(function (key) {
    var func = patchProps[key];
    if (typeof func === 'function') {
      composedProps[key] = function () {
        var _originProps$key;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        func.apply(void 0, args);
        return (_originProps$key = originProps[key]) === null || _originProps$key === void 0 ? void 0 : _originProps$key.call.apply(_originProps$key, [originProps].concat(args));
      };
    }
  });
  return composedProps;
}
/* harmony default export */ var es_composeProps = (composeProps);
;// CONCATENATED MODULE: ./node_modules/rc-select/es/Selector/Input.js


var _excluded = ["prefixCls", "id", "inputElement", "autoFocus", "autoComplete", "editable", "activeDescendantId", "value", "open", "attrs"];





var Input = function Input(props, ref) {
  var prefixCls = props.prefixCls,
    id = props.id,
    inputElement = props.inputElement,
    autoFocus = props.autoFocus,
    autoComplete = props.autoComplete,
    editable = props.editable,
    activeDescendantId = props.activeDescendantId,
    value = props.value,
    open = props.open,
    attrs = props.attrs,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded);
  var inputNode = inputElement || /*#__PURE__*/react.createElement("input", null);
  var _inputNode = inputNode,
    originRef = _inputNode.ref,
    originProps = _inputNode.props;
  (0,es_warning/* warning */.Kp)(!('maxLength' in inputNode.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled.");
  inputNode = /*#__PURE__*/react.cloneElement(inputNode, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
    type: 'search'
  }, es_composeProps(restProps, originProps, true)), {}, {
    // Override over origin props
    id: id,
    ref: (0,es_ref/* composeRef */.sQ)(ref, originRef),
    autoComplete: autoComplete || 'off',
    autoFocus: autoFocus,
    className: classnames_default()("".concat(prefixCls, "-selection-search-input"), originProps === null || originProps === void 0 ? void 0 : originProps.className),
    role: 'combobox',
    'aria-expanded': open || false,
    'aria-haspopup': 'listbox',
    'aria-owns': "".concat(id, "_list"),
    'aria-autocomplete': 'list',
    'aria-controls': "".concat(id, "_list"),
    'aria-activedescendant': open ? activeDescendantId : undefined
  }, attrs), {}, {
    value: editable ? value : '',
    readOnly: !editable,
    unselectable: !editable ? 'on' : null,
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, originProps.style), {}, {
      opacity: editable ? null : 0
    })
  }));
  return inputNode;
};
var RefInput = /*#__PURE__*/react.forwardRef(Input);
if (false) {}
/* harmony default export */ var Selector_Input = (RefInput);
;// CONCATENATED MODULE: ./node_modules/rc-select/es/utils/commonUtil.js

function commonUtil_toArray(value) {
  if (Array.isArray(value)) {
    return value;
  }
  return value !== undefined ? [value] : [];
}
var isClient = typeof window !== 'undefined' && window.document && window.document.documentElement;

/** Is client side and not jsdom */
var isBrowserClient =  true && isClient;
function hasValue(value) {
  return value !== undefined && value !== null;
}

/** combo mode no value judgment function */
function isComboNoValue(value) {
  return !value && value !== 0;
}
function isTitleType(title) {
  return ['string', 'number'].includes((0,esm_typeof/* default */.Z)(title));
}
function getTitle(item) {
  var title = undefined;
  if (item) {
    if (isTitleType(item.title)) {
      title = item.title.toString();
    } else if (isTitleType(item.label)) {
      title = item.label.toString();
    }
  }
  return title;
}
;// CONCATENATED MODULE: ./node_modules/rc-select/es/hooks/useLayoutEffect.js
/* eslint-disable react-hooks/rules-of-hooks */



/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */
function useLayoutEffect_useLayoutEffect(effect, deps) {
  // Never happen in test env
  if (isBrowserClient) {
    /* istanbul ignore next */
    react.useLayoutEffect(effect, deps);
  } else {
    react.useEffect(effect, deps);
  }
}
/* eslint-enable */
;// CONCATENATED MODULE: ./node_modules/rc-select/es/Selector/MultipleSelector.js











function itemKey(value) {
  var _value$key;
  return (_value$key = value.key) !== null && _value$key !== void 0 ? _value$key : value.value;
}
var onPreventMouseDown = function onPreventMouseDown(event) {
  event.preventDefault();
  event.stopPropagation();
};
var SelectSelector = function SelectSelector(props) {
  var id = props.id,
    prefixCls = props.prefixCls,
    values = props.values,
    open = props.open,
    searchValue = props.searchValue,
    autoClearSearchValue = props.autoClearSearchValue,
    inputRef = props.inputRef,
    placeholder = props.placeholder,
    disabled = props.disabled,
    mode = props.mode,
    showSearch = props.showSearch,
    autoFocus = props.autoFocus,
    autoComplete = props.autoComplete,
    activeDescendantId = props.activeDescendantId,
    tabIndex = props.tabIndex,
    removeIcon = props.removeIcon,
    maxTagCount = props.maxTagCount,
    maxTagTextLength = props.maxTagTextLength,
    _props$maxTagPlacehol = props.maxTagPlaceholder,
    maxTagPlaceholder = _props$maxTagPlacehol === void 0 ? function (omittedValues) {
      return "+ ".concat(omittedValues.length, " ...");
    } : _props$maxTagPlacehol,
    tagRender = props.tagRender,
    onToggleOpen = props.onToggleOpen,
    onRemove = props.onRemove,
    onInputChange = props.onInputChange,
    onInputPaste = props.onInputPaste,
    onInputKeyDown = props.onInputKeyDown,
    onInputMouseDown = props.onInputMouseDown,
    onInputCompositionStart = props.onInputCompositionStart,
    onInputCompositionEnd = props.onInputCompositionEnd,
    onInputBlur = props.onInputBlur;
  var measureRef = react.useRef(null);
  var _useState = (0,react.useState)(0),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    inputWidth = _useState2[0],
    setInputWidth = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    focused = _useState4[0],
    setFocused = _useState4[1];
  var selectionPrefixCls = "".concat(prefixCls, "-selection");

  // ===================== Search ======================
  var inputValue = open || mode === 'multiple' && autoClearSearchValue === false || mode === 'tags' ? searchValue : '';
  var inputEditable = mode === 'tags' || mode === 'multiple' && autoClearSearchValue === false || showSearch && (open || focused);

  // We measure width and set to the input immediately
  useLayoutEffect_useLayoutEffect(function () {
    setInputWidth(measureRef.current.scrollWidth);
  }, [inputValue]);

  // ===================== Render ======================
  // >>> Render Selector Node. Includes Item & Rest
  var defaultRenderSelector = function defaultRenderSelector(item, content, itemDisabled, closable, onClose) {
    return /*#__PURE__*/react.createElement("span", {
      title: getTitle(item),
      className: classnames_default()("".concat(selectionPrefixCls, "-item"), (0,defineProperty/* default */.Z)({}, "".concat(selectionPrefixCls, "-item-disabled"), itemDisabled))
    }, /*#__PURE__*/react.createElement("span", {
      className: "".concat(selectionPrefixCls, "-item-content")
    }, content), closable && /*#__PURE__*/react.createElement(es_TransBtn, {
      className: "".concat(selectionPrefixCls, "-item-remove"),
      onMouseDown: onPreventMouseDown,
      onClick: onClose,
      customizeIcon: removeIcon
    }, "\xD7"));
  };
  var customizeRenderSelector = function customizeRenderSelector(value, content, itemDisabled, closable, onClose, isMaxTag) {
    var onMouseDown = function onMouseDown(e) {
      onPreventMouseDown(e);
      onToggleOpen(!open);
    };
    return /*#__PURE__*/react.createElement("span", {
      onMouseDown: onMouseDown
    }, tagRender({
      label: content,
      value: value,
      disabled: itemDisabled,
      closable: closable,
      onClose: onClose,
      isMaxTag: !!isMaxTag
    }));
  };
  var renderItem = function renderItem(valueItem) {
    var itemDisabled = valueItem.disabled,
      label = valueItem.label,
      value = valueItem.value;
    var closable = !disabled && !itemDisabled;
    var displayLabel = label;
    if (typeof maxTagTextLength === 'number') {
      if (typeof label === 'string' || typeof label === 'number') {
        var strLabel = String(displayLabel);
        if (strLabel.length > maxTagTextLength) {
          displayLabel = "".concat(strLabel.slice(0, maxTagTextLength), "...");
        }
      }
    }
    var onClose = function onClose(event) {
      if (event) {
        event.stopPropagation();
      }
      onRemove(valueItem);
    };
    return typeof tagRender === 'function' ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose) : defaultRenderSelector(valueItem, displayLabel, itemDisabled, closable, onClose);
  };
  var renderRest = function renderRest(omittedValues) {
    // https://github.com/ant-design/ant-design/issues/48930
    if (!values.length) {
      return null;
    }
    var content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
    return typeof tagRender === 'function' ? customizeRenderSelector(undefined, content, false, false, undefined, true) : defaultRenderSelector({
      title: content
    }, content, false);
  };

  // >>> Input Node
  var inputNode = /*#__PURE__*/react.createElement("div", {
    className: "".concat(selectionPrefixCls, "-search"),
    style: {
      width: inputWidth
    },
    onFocus: function onFocus() {
      setFocused(true);
    },
    onBlur: function onBlur() {
      setFocused(false);
    }
  }, /*#__PURE__*/react.createElement(Selector_Input, {
    ref: inputRef,
    open: open,
    prefixCls: prefixCls,
    id: id,
    inputElement: null,
    disabled: disabled,
    autoFocus: autoFocus,
    autoComplete: autoComplete,
    editable: inputEditable,
    activeDescendantId: activeDescendantId,
    value: inputValue,
    onKeyDown: onInputKeyDown,
    onMouseDown: onInputMouseDown,
    onChange: onInputChange,
    onPaste: onInputPaste,
    onCompositionStart: onInputCompositionStart,
    onCompositionEnd: onInputCompositionEnd,
    onBlur: onInputBlur,
    tabIndex: tabIndex,
    attrs: (0,pickAttrs/* default */.Z)(props, true)
  }), /*#__PURE__*/react.createElement("span", {
    ref: measureRef,
    className: "".concat(selectionPrefixCls, "-search-mirror"),
    "aria-hidden": true
  }, inputValue, "\xA0"));

  // >>> Selections
  var selectionNode = /*#__PURE__*/react.createElement(es/* default */.Z, {
    prefixCls: "".concat(selectionPrefixCls, "-overflow"),
    data: values,
    renderItem: renderItem,
    renderRest: renderRest,
    suffix: inputNode,
    itemKey: itemKey,
    maxCount: maxTagCount
  });
  return /*#__PURE__*/react.createElement("span", {
    className: "".concat(selectionPrefixCls, "-wrap")
  }, selectionNode, !values.length && !inputValue && /*#__PURE__*/react.createElement("span", {
    className: "".concat(selectionPrefixCls, "-placeholder")
  }, placeholder));
};
/* harmony default export */ var MultipleSelector = (SelectSelector);
;// CONCATENATED MODULE: ./node_modules/rc-select/es/Selector/SingleSelector.js





var SingleSelector = function SingleSelector(props) {
  var inputElement = props.inputElement,
    prefixCls = props.prefixCls,
    id = props.id,
    inputRef = props.inputRef,
    disabled = props.disabled,
    autoFocus = props.autoFocus,
    autoComplete = props.autoComplete,
    activeDescendantId = props.activeDescendantId,
    mode = props.mode,
    open = props.open,
    values = props.values,
    placeholder = props.placeholder,
    tabIndex = props.tabIndex,
    showSearch = props.showSearch,
    searchValue = props.searchValue,
    activeValue = props.activeValue,
    maxLength = props.maxLength,
    onInputKeyDown = props.onInputKeyDown,
    onInputMouseDown = props.onInputMouseDown,
    onInputChange = props.onInputChange,
    onInputPaste = props.onInputPaste,
    onInputCompositionStart = props.onInputCompositionStart,
    onInputCompositionEnd = props.onInputCompositionEnd,
    onInputBlur = props.onInputBlur,
    title = props.title;
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    inputChanged = _React$useState2[0],
    setInputChanged = _React$useState2[1];
  var combobox = mode === 'combobox';
  var inputEditable = combobox || showSearch;
  var item = values[0];
  var inputValue = searchValue || '';
  if (combobox && activeValue && !inputChanged) {
    inputValue = activeValue;
  }
  react.useEffect(function () {
    if (combobox) {
      setInputChanged(false);
    }
  }, [combobox, activeValue]);

  // Not show text when closed expect combobox mode
  var hasTextInput = mode !== 'combobox' && !open && !showSearch ? false : !!inputValue;

  // Get title of selection item
  var selectionTitle = title === undefined ? getTitle(item) : title;
  var placeholderNode = react.useMemo(function () {
    if (item) {
      return null;
    }
    return /*#__PURE__*/react.createElement("span", {
      className: "".concat(prefixCls, "-selection-placeholder"),
      style: hasTextInput ? {
        visibility: 'hidden'
      } : undefined
    }, placeholder);
  }, [item, hasTextInput, placeholder, prefixCls]);
  return /*#__PURE__*/react.createElement("span", {
    className: "".concat(prefixCls, "-selection-wrap")
  }, /*#__PURE__*/react.createElement("span", {
    className: "".concat(prefixCls, "-selection-search")
  }, /*#__PURE__*/react.createElement(Selector_Input, {
    ref: inputRef,
    prefixCls: prefixCls,
    id: id,
    open: open,
    inputElement: inputElement,
    disabled: disabled,
    autoFocus: autoFocus,
    autoComplete: autoComplete,
    editable: inputEditable,
    activeDescendantId: activeDescendantId,
    value: inputValue,
    onKeyDown: onInputKeyDown,
    onMouseDown: onInputMouseDown,
    onChange: function onChange(e) {
      setInputChanged(true);
      onInputChange(e);
    },
    onPaste: onInputPaste,
    onCompositionStart: onInputCompositionStart,
    onCompositionEnd: onInputCompositionEnd,
    onBlur: onInputBlur,
    tabIndex: tabIndex,
    attrs: (0,pickAttrs/* default */.Z)(props, true),
    maxLength: combobox ? maxLength : undefined
  })), !combobox && item ? /*#__PURE__*/react.createElement("span", {
    className: "".concat(prefixCls, "-selection-item"),
    title: selectionTitle
    // 当 Select 已经选中选项时，还需 selection 隐藏但留在原地占位
    // https://github.com/ant-design/ant-design/issues/27688
    // https://github.com/ant-design/ant-design/issues/41530
    ,

    style: hasTextInput ? {
      visibility: 'hidden'
    } : undefined
  }, item.label) : null, placeholderNode);
};
/* harmony default export */ var Selector_SingleSelector = (SingleSelector);
;// CONCATENATED MODULE: ./node_modules/rc-select/es/Selector/index.js


/**
 * Cursor rule:
 * 1. Only `showSearch` enabled
 * 2. Only `open` is `true`
 * 3. When typing, set `open` to `true` which hit rule of 2
 *
 * Accessibility:
 * - https://www.w3.org/TR/wai-aria-practices/examples/combobox/aria1.1pattern/listbox-combo.html
 */








var Selector = function Selector(props, ref) {
  var inputRef = (0,react.useRef)(null);
  var compositionStatusRef = (0,react.useRef)(false);
  var prefixCls = props.prefixCls,
    open = props.open,
    mode = props.mode,
    showSearch = props.showSearch,
    tokenWithEnter = props.tokenWithEnter,
    disabled = props.disabled,
    prefix = props.prefix,
    autoClearSearchValue = props.autoClearSearchValue,
    onSearch = props.onSearch,
    onSearchSubmit = props.onSearchSubmit,
    onToggleOpen = props.onToggleOpen,
    onInputKeyDown = props.onInputKeyDown,
    onInputBlur = props.onInputBlur,
    domRef = props.domRef;

  // ======================= Ref =======================
  react.useImperativeHandle(ref, function () {
    return {
      focus: function focus(options) {
        inputRef.current.focus(options);
      },
      blur: function blur() {
        inputRef.current.blur();
      }
    };
  });

  // ====================== Input ======================
  var _useLock = useLock(0),
    _useLock2 = (0,slicedToArray/* default */.Z)(_useLock, 2),
    getInputMouseDown = _useLock2[0],
    setInputMouseDown = _useLock2[1];
  var onInternalInputKeyDown = function onInternalInputKeyDown(event) {
    var which = event.which;

    // Compatible with multiple lines in TextArea
    var isTextAreaElement = inputRef.current instanceof HTMLTextAreaElement;
    if (!isTextAreaElement && open && (which === KeyCode/* default.UP */.Z.UP || which === KeyCode/* default.DOWN */.Z.DOWN)) {
      event.preventDefault();
    }
    if (onInputKeyDown) {
      onInputKeyDown(event);
    }
    if (which === KeyCode/* default.ENTER */.Z.ENTER && mode === 'tags' && !compositionStatusRef.current && !open) {
      // When menu isn't open, OptionList won't trigger a value change
      // So when enter is pressed, the tag's input value should be emitted here to let selector know
      onSearchSubmit === null || onSearchSubmit === void 0 || onSearchSubmit(event.target.value);
    }
    // Move within the text box
    if (isTextAreaElement && !open && ~[KeyCode/* default.UP */.Z.UP, KeyCode/* default.DOWN */.Z.DOWN, KeyCode/* default.LEFT */.Z.LEFT, KeyCode/* default.RIGHT */.Z.RIGHT].indexOf(which)) {
      return;
    }
    if (isValidateOpenKey(which)) {
      onToggleOpen(true);
    }
  };

  /**
   * We can not use `findDOMNode` sine it will get warning,
   * have to use timer to check if is input element.
   */
  var onInternalInputMouseDown = function onInternalInputMouseDown() {
    setInputMouseDown(true);
  };

  // When paste come, ignore next onChange
  var pastedTextRef = (0,react.useRef)(null);
  var triggerOnSearch = function triggerOnSearch(value) {
    if (onSearch(value, true, compositionStatusRef.current) !== false) {
      onToggleOpen(true);
    }
  };
  var onInputCompositionStart = function onInputCompositionStart() {
    compositionStatusRef.current = true;
  };
  var onInputCompositionEnd = function onInputCompositionEnd(e) {
    compositionStatusRef.current = false;

    // Trigger search again to support `tokenSeparators` with typewriting
    if (mode !== 'combobox') {
      triggerOnSearch(e.target.value);
    }
  };
  var onInputChange = function onInputChange(event) {
    var value = event.target.value;

    // Pasted text should replace back to origin content
    if (tokenWithEnter && pastedTextRef.current && /[\r\n]/.test(pastedTextRef.current)) {
      // CRLF will be treated as a single space for input element
      var replacedText = pastedTextRef.current.replace(/[\r\n]+$/, '').replace(/\r\n/g, ' ').replace(/[\r\n]/g, ' ');
      value = value.replace(replacedText, pastedTextRef.current);
    }
    pastedTextRef.current = null;
    triggerOnSearch(value);
  };
  var onInputPaste = function onInputPaste(e) {
    var clipboardData = e.clipboardData;
    var value = clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.getData('text');
    pastedTextRef.current = value || '';
  };
  var onClick = function onClick(_ref) {
    var target = _ref.target;
    if (target !== inputRef.current) {
      // Should focus input if click the selector
      var isIE = document.body.style.msTouchAction !== undefined;
      if (isIE) {
        setTimeout(function () {
          inputRef.current.focus();
        });
      } else {
        inputRef.current.focus();
      }
    }
  };
  var onMouseDown = function onMouseDown(event) {
    var inputMouseDown = getInputMouseDown();

    // when mode is combobox and it is disabled, don't prevent default behavior
    // https://github.com/ant-design/ant-design/issues/37320
    // https://github.com/ant-design/ant-design/issues/48281
    if (event.target !== inputRef.current && !inputMouseDown && !(mode === 'combobox' && disabled)) {
      event.preventDefault();
    }
    if (mode !== 'combobox' && (!showSearch || !inputMouseDown) || !open) {
      if (open && autoClearSearchValue !== false) {
        onSearch('', true, false);
      }
      onToggleOpen();
    }
  };

  // ================= Inner Selector ==================
  var sharedProps = {
    inputRef: inputRef,
    onInputKeyDown: onInternalInputKeyDown,
    onInputMouseDown: onInternalInputMouseDown,
    onInputChange: onInputChange,
    onInputPaste: onInputPaste,
    onInputCompositionStart: onInputCompositionStart,
    onInputCompositionEnd: onInputCompositionEnd,
    onInputBlur: onInputBlur
  };
  var selectNode = mode === 'multiple' || mode === 'tags' ? /*#__PURE__*/react.createElement(MultipleSelector, (0,esm_extends/* default */.Z)({}, props, sharedProps)) : /*#__PURE__*/react.createElement(Selector_SingleSelector, (0,esm_extends/* default */.Z)({}, props, sharedProps));
  return /*#__PURE__*/react.createElement("div", {
    ref: domRef,
    className: "".concat(prefixCls, "-selector"),
    onClick: onClick,
    onMouseDown: onMouseDown
  }, prefix && /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-prefix")
  }, prefix), selectNode);
};
var ForwardSelector = /*#__PURE__*/react.forwardRef(Selector);
if (false) {}
/* harmony default export */ var es_Selector = (ForwardSelector);
// EXTERNAL MODULE: ./node_modules/@rc-component/trigger/es/index.js + 11 modules
var trigger_es = __webpack_require__(91831);
;// CONCATENATED MODULE: ./node_modules/rc-select/es/SelectTrigger.js




var SelectTrigger_excluded = ["prefixCls", "disabled", "visible", "children", "popupElement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "builtinPlacements", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"];



var getBuiltInPlacements = function getBuiltInPlacements(dropdownMatchSelectWidth) {
  // Enable horizontal overflow auto-adjustment when a custom dropdown width is provided
  var adjustX = dropdownMatchSelectWidth === true ? 0 : 1;
  return {
    bottomLeft: {
      points: ['tl', 'bl'],
      offset: [0, 4],
      overflow: {
        adjustX: adjustX,
        adjustY: 1
      },
      htmlRegion: 'scroll'
    },
    bottomRight: {
      points: ['tr', 'br'],
      offset: [0, 4],
      overflow: {
        adjustX: adjustX,
        adjustY: 1
      },
      htmlRegion: 'scroll'
    },
    topLeft: {
      points: ['bl', 'tl'],
      offset: [0, -4],
      overflow: {
        adjustX: adjustX,
        adjustY: 1
      },
      htmlRegion: 'scroll'
    },
    topRight: {
      points: ['br', 'tr'],
      offset: [0, -4],
      overflow: {
        adjustX: adjustX,
        adjustY: 1
      },
      htmlRegion: 'scroll'
    }
  };
};
var SelectTrigger = function SelectTrigger(props, ref) {
  var prefixCls = props.prefixCls,
    disabled = props.disabled,
    visible = props.visible,
    children = props.children,
    popupElement = props.popupElement,
    animation = props.animation,
    transitionName = props.transitionName,
    dropdownStyle = props.dropdownStyle,
    dropdownClassName = props.dropdownClassName,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'ltr' : _props$direction,
    placement = props.placement,
    builtinPlacements = props.builtinPlacements,
    dropdownMatchSelectWidth = props.dropdownMatchSelectWidth,
    dropdownRender = props.dropdownRender,
    dropdownAlign = props.dropdownAlign,
    getPopupContainer = props.getPopupContainer,
    empty = props.empty,
    getTriggerDOMNode = props.getTriggerDOMNode,
    onPopupVisibleChange = props.onPopupVisibleChange,
    onPopupMouseEnter = props.onPopupMouseEnter,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, SelectTrigger_excluded);
  var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
  var popupNode = popupElement;
  if (dropdownRender) {
    popupNode = dropdownRender(popupElement);
  }
  var mergedBuiltinPlacements = react.useMemo(function () {
    return builtinPlacements || getBuiltInPlacements(dropdownMatchSelectWidth);
  }, [builtinPlacements, dropdownMatchSelectWidth]);

  // ===================== Motion ======================
  var mergedTransitionName = animation ? "".concat(dropdownPrefixCls, "-").concat(animation) : transitionName;

  // =================== Popup Width ===================
  var isNumberPopupWidth = typeof dropdownMatchSelectWidth === 'number';
  var stretch = react.useMemo(function () {
    if (isNumberPopupWidth) {
      return null;
    }
    return dropdownMatchSelectWidth === false ? 'minWidth' : 'width';
  }, [dropdownMatchSelectWidth, isNumberPopupWidth]);
  var popupStyle = dropdownStyle;
  if (isNumberPopupWidth) {
    popupStyle = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, popupStyle), {}, {
      width: dropdownMatchSelectWidth
    });
  }

  // ======================= Ref =======================
  var triggerPopupRef = react.useRef(null);
  react.useImperativeHandle(ref, function () {
    return {
      getPopupElement: function getPopupElement() {
        var _triggerPopupRef$curr;
        return (_triggerPopupRef$curr = triggerPopupRef.current) === null || _triggerPopupRef$curr === void 0 ? void 0 : _triggerPopupRef$curr.popupElement;
      }
    };
  });
  return /*#__PURE__*/react.createElement(trigger_es/* default */.Z, (0,esm_extends/* default */.Z)({}, restProps, {
    showAction: onPopupVisibleChange ? ['click'] : [],
    hideAction: onPopupVisibleChange ? ['click'] : [],
    popupPlacement: placement || (direction === 'rtl' ? 'bottomRight' : 'bottomLeft'),
    builtinPlacements: mergedBuiltinPlacements,
    prefixCls: dropdownPrefixCls,
    popupTransitionName: mergedTransitionName,
    popup: /*#__PURE__*/react.createElement("div", {
      onMouseEnter: onPopupMouseEnter
    }, popupNode),
    ref: triggerPopupRef,
    stretch: stretch,
    popupAlign: dropdownAlign,
    popupVisible: visible,
    getPopupContainer: getPopupContainer,
    popupClassName: classnames_default()(dropdownClassName, (0,defineProperty/* default */.Z)({}, "".concat(dropdownPrefixCls, "-empty"), empty)),
    popupStyle: popupStyle,
    getTriggerDOMNode: getTriggerDOMNode,
    onPopupVisibleChange: onPopupVisibleChange
  }), children);
};
var RefSelectTrigger = /*#__PURE__*/react.forwardRef(SelectTrigger);
if (false) {}
/* harmony default export */ var es_SelectTrigger = (RefSelectTrigger);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toArray.js
var esm_toArray = __webpack_require__(75574);
;// CONCATENATED MODULE: ./node_modules/rc-select/es/utils/valueUtil.js




function getKey(data, index) {
  var key = data.key;
  var value;
  if ('value' in data) {
    value = data.value;
  }
  if (key !== null && key !== undefined) {
    return key;
  }
  if (value !== undefined) {
    return value;
  }
  return "rc-index-key-".concat(index);
}
function isValidCount(value) {
  return typeof value !== 'undefined' && !Number.isNaN(value);
}
function fillFieldNames(fieldNames, childrenAsData) {
  var _ref = fieldNames || {},
    label = _ref.label,
    value = _ref.value,
    options = _ref.options,
    groupLabel = _ref.groupLabel;
  var mergedLabel = label || (childrenAsData ? 'children' : 'label');
  return {
    label: mergedLabel,
    value: value || 'value',
    options: options || 'options',
    groupLabel: groupLabel || mergedLabel
  };
}

/**
 * Flat options into flatten list.
 * We use `optionOnly` here is aim to avoid user use nested option group.
 * Here is simply set `key` to the index if not provided.
 */
function flattenOptions(options) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    fieldNames = _ref2.fieldNames,
    childrenAsData = _ref2.childrenAsData;
  var flattenList = [];
  var _fillFieldNames = fillFieldNames(fieldNames, false),
    fieldLabel = _fillFieldNames.label,
    fieldValue = _fillFieldNames.value,
    fieldOptions = _fillFieldNames.options,
    groupLabel = _fillFieldNames.groupLabel;
  function dig(list, isGroupOption) {
    if (!Array.isArray(list)) {
      return;
    }
    list.forEach(function (data) {
      if (isGroupOption || !(fieldOptions in data)) {
        var value = data[fieldValue];

        // Option
        flattenList.push({
          key: getKey(data, flattenList.length),
          groupOption: isGroupOption,
          data: data,
          label: data[fieldLabel],
          value: value
        });
      } else {
        var grpLabel = data[groupLabel];
        if (grpLabel === undefined && childrenAsData) {
          grpLabel = data.label;
        }

        // Option Group
        flattenList.push({
          key: getKey(data, flattenList.length),
          group: true,
          data: data,
          label: grpLabel
        });
        dig(data[fieldOptions], true);
      }
    });
  }
  dig(options, false);
  return flattenList;
}

/**
 * Inject `props` into `option` for legacy usage
 */
function injectPropsWithOption(option) {
  var newOption = (0,objectSpread2/* default */.Z)({}, option);
  if (!('props' in newOption)) {
    Object.defineProperty(newOption, 'props', {
      get: function get() {
        (0,es_warning/* default */.ZP)(false, 'Return type is option instead of Option instance. Please read value directly instead of reading from `props`.');
        return newOption;
      }
    });
  }
  return newOption;
}
var getSeparatedContent = function getSeparatedContent(text, tokens, end) {
  if (!tokens || !tokens.length) {
    return null;
  }
  var match = false;
  var separate = function separate(str, _ref3) {
    var _ref4 = (0,esm_toArray/* default */.Z)(_ref3),
      token = _ref4[0],
      restTokens = _ref4.slice(1);
    if (!token) {
      return [str];
    }
    var list = str.split(token);
    match = match || list.length > 1;
    return list.reduce(function (prevList, unitStr) {
      return [].concat((0,toConsumableArray/* default */.Z)(prevList), (0,toConsumableArray/* default */.Z)(separate(unitStr, restTokens)));
    }, []).filter(Boolean);
  };
  var list = separate(text, tokens);
  if (match) {
    return typeof end !== 'undefined' ? list.slice(0, end) : list;
  } else {
    return null;
  }
};
;// CONCATENATED MODULE: ./node_modules/rc-select/es/SelectContext.js


// Use any here since we do not get the type during compilation

var SelectContext = /*#__PURE__*/react.createContext(null);
/* harmony default export */ var es_SelectContext = (SelectContext);
;// CONCATENATED MODULE: ./node_modules/rc-select/es/BaseSelect/Polite.js


function Polite(props) {
  var visible = props.visible,
    values = props.values;
  if (!visible) {
    return null;
  }

  // Only cut part of values since it's a screen reader
  var MAX_COUNT = 50;
  return /*#__PURE__*/react.createElement("span", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: 'absolute',
      overflow: 'hidden',
      opacity: 0
    }
  }, "".concat(values.slice(0, MAX_COUNT).map(function (_ref) {
    var label = _ref.label,
      value = _ref.value;
    return ['number', 'string'].includes((0,esm_typeof/* default */.Z)(label)) ? label : value;
  }).join(', ')), values.length > MAX_COUNT ? ', ...' : null);
}
;// CONCATENATED MODULE: ./node_modules/rc-select/es/BaseSelect/index.js






var BaseSelect_excluded = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "prefix", "suffixIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "builtinPlacements", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"];

















var DEFAULT_OMIT_PROPS = ['value', 'onChange', 'removeIcon', 'placeholder', 'autoFocus', 'maxTagCount', 'maxTagTextLength', 'maxTagPlaceholder', 'choiceTransitionName', 'onInputKeyDown', 'onPopupScroll', 'tabIndex'];
var BaseSelect_isMultiple = function isMultiple(mode) {
  return mode === 'tags' || mode === 'multiple';
};
var BaseSelect = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _customizeRawInputEle;
  var id = props.id,
    prefixCls = props.prefixCls,
    className = props.className,
    showSearch = props.showSearch,
    tagRender = props.tagRender,
    direction = props.direction,
    omitDomProps = props.omitDomProps,
    displayValues = props.displayValues,
    onDisplayValuesChange = props.onDisplayValuesChange,
    emptyOptions = props.emptyOptions,
    _props$notFoundConten = props.notFoundContent,
    notFoundContent = _props$notFoundConten === void 0 ? 'Not Found' : _props$notFoundConten,
    onClear = props.onClear,
    mode = props.mode,
    disabled = props.disabled,
    loading = props.loading,
    getInputElement = props.getInputElement,
    getRawInputElement = props.getRawInputElement,
    open = props.open,
    defaultOpen = props.defaultOpen,
    onDropdownVisibleChange = props.onDropdownVisibleChange,
    activeValue = props.activeValue,
    onActiveValueChange = props.onActiveValueChange,
    activeDescendantId = props.activeDescendantId,
    searchValue = props.searchValue,
    autoClearSearchValue = props.autoClearSearchValue,
    onSearch = props.onSearch,
    onSearchSplit = props.onSearchSplit,
    tokenSeparators = props.tokenSeparators,
    allowClear = props.allowClear,
    prefix = props.prefix,
    suffixIcon = props.suffixIcon,
    clearIcon = props.clearIcon,
    OptionList = props.OptionList,
    animation = props.animation,
    transitionName = props.transitionName,
    dropdownStyle = props.dropdownStyle,
    dropdownClassName = props.dropdownClassName,
    dropdownMatchSelectWidth = props.dropdownMatchSelectWidth,
    dropdownRender = props.dropdownRender,
    dropdownAlign = props.dropdownAlign,
    placement = props.placement,
    builtinPlacements = props.builtinPlacements,
    getPopupContainer = props.getPopupContainer,
    _props$showAction = props.showAction,
    showAction = _props$showAction === void 0 ? [] : _props$showAction,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onKeyUp = props.onKeyUp,
    onKeyDown = props.onKeyDown,
    onMouseDown = props.onMouseDown,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, BaseSelect_excluded);

  // ============================== MISC ==============================
  var multiple = BaseSelect_isMultiple(mode);
  var mergedShowSearch = (showSearch !== undefined ? showSearch : multiple) || mode === 'combobox';
  var domProps = (0,objectSpread2/* default */.Z)({}, restProps);
  DEFAULT_OMIT_PROPS.forEach(function (propName) {
    delete domProps[propName];
  });
  omitDomProps === null || omitDomProps === void 0 || omitDomProps.forEach(function (propName) {
    delete domProps[propName];
  });

  // ============================= Mobile =============================
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    mobile = _React$useState2[0],
    setMobile = _React$useState2[1];
  react.useEffect(function () {
    // Only update on the client side
    setMobile((0,isMobile/* default */.Z)());
  }, []);

  // ============================== Refs ==============================
  var containerRef = react.useRef(null);
  var selectorDomRef = react.useRef(null);
  var triggerRef = react.useRef(null);
  var selectorRef = react.useRef(null);
  var listRef = react.useRef(null);
  var blurRef = react.useRef(false);

  /** Used for component focused management */
  var _useDelayReset = useDelayReset(),
    _useDelayReset2 = (0,slicedToArray/* default */.Z)(_useDelayReset, 3),
    mockFocused = _useDelayReset2[0],
    setMockFocused = _useDelayReset2[1],
    cancelSetMockFocused = _useDelayReset2[2];

  // =========================== Imperative ===========================
  react.useImperativeHandle(ref, function () {
    var _selectorRef$current, _selectorRef$current2;
    return {
      focus: (_selectorRef$current = selectorRef.current) === null || _selectorRef$current === void 0 ? void 0 : _selectorRef$current.focus,
      blur: (_selectorRef$current2 = selectorRef.current) === null || _selectorRef$current2 === void 0 ? void 0 : _selectorRef$current2.blur,
      scrollTo: function scrollTo(arg) {
        var _listRef$current;
        return (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollTo(arg);
      },
      nativeElement: containerRef.current || selectorDomRef.current
    };
  });

  // ========================== Search Value ==========================
  var mergedSearchValue = react.useMemo(function () {
    var _displayValues$;
    if (mode !== 'combobox') {
      return searchValue;
    }
    var val = (_displayValues$ = displayValues[0]) === null || _displayValues$ === void 0 ? void 0 : _displayValues$.value;
    return typeof val === 'string' || typeof val === 'number' ? String(val) : '';
  }, [searchValue, mode, displayValues]);

  // ========================== Custom Input ==========================
  // Only works in `combobox`
  var customizeInputElement = mode === 'combobox' && typeof getInputElement === 'function' && getInputElement() || null;

  // Used for customize replacement for `rc-cascader`
  var customizeRawInputElement = typeof getRawInputElement === 'function' && getRawInputElement();
  var customizeRawInputRef = (0,es_ref/* useComposeRef */.x1)(selectorDomRef, customizeRawInputElement === null || customizeRawInputElement === void 0 || (_customizeRawInputEle = customizeRawInputElement.props) === null || _customizeRawInputEle === void 0 ? void 0 : _customizeRawInputEle.ref);

  // ============================== Open ==============================
  // SSR not support Portal which means we need delay `open` for the first time render
  var _React$useState3 = react.useState(false),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    rendered = _React$useState4[0],
    setRendered = _React$useState4[1];
  (0,useLayoutEffect/* default */.Z)(function () {
    setRendered(true);
  }, []);
  var _useMergedState = (0,useMergedState/* default */.Z)(false, {
      defaultValue: defaultOpen,
      value: open
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    innerOpen = _useMergedState2[0],
    setInnerOpen = _useMergedState2[1];
  var mergedOpen = rendered ? innerOpen : false;

  // Not trigger `open` in `combobox` when `notFoundContent` is empty
  var emptyListContent = !notFoundContent && emptyOptions;
  if (disabled || emptyListContent && mergedOpen && mode === 'combobox') {
    mergedOpen = false;
  }
  var triggerOpen = emptyListContent ? false : mergedOpen;
  var onToggleOpen = react.useCallback(function (newOpen) {
    var nextOpen = newOpen !== undefined ? newOpen : !mergedOpen;
    if (!disabled) {
      setInnerOpen(nextOpen);
      if (mergedOpen !== nextOpen) {
        onDropdownVisibleChange === null || onDropdownVisibleChange === void 0 || onDropdownVisibleChange(nextOpen);
      }
    }
  }, [disabled, mergedOpen, setInnerOpen, onDropdownVisibleChange]);

  // ============================= Search =============================
  var tokenWithEnter = react.useMemo(function () {
    return (tokenSeparators || []).some(function (tokenSeparator) {
      return ['\n', '\r\n'].includes(tokenSeparator);
    });
  }, [tokenSeparators]);
  var _ref = react.useContext(es_SelectContext) || {},
    maxCount = _ref.maxCount,
    rawValues = _ref.rawValues;
  var onInternalSearch = function onInternalSearch(searchText, fromTyping, isCompositing) {
    if (multiple && isValidCount(maxCount) && (rawValues === null || rawValues === void 0 ? void 0 : rawValues.size) >= maxCount) {
      return;
    }
    var ret = true;
    var newSearchText = searchText;
    onActiveValueChange === null || onActiveValueChange === void 0 || onActiveValueChange(null);
    var separatedList = getSeparatedContent(searchText, tokenSeparators, isValidCount(maxCount) ? maxCount - rawValues.size : undefined);

    // Check if match the `tokenSeparators`
    var patchLabels = isCompositing ? null : separatedList;

    // Ignore combobox since it's not split-able
    if (mode !== 'combobox' && patchLabels) {
      newSearchText = '';
      onSearchSplit === null || onSearchSplit === void 0 || onSearchSplit(patchLabels);

      // Should close when paste finish
      onToggleOpen(false);

      // Tell Selector that break next actions
      ret = false;
    }
    if (onSearch && mergedSearchValue !== newSearchText) {
      onSearch(newSearchText, {
        source: fromTyping ? 'typing' : 'effect'
      });
    }
    return ret;
  };

  // Only triggered when menu is closed & mode is tags
  // If menu is open, OptionList will take charge
  // If mode isn't tags, press enter is not meaningful when you can't see any option
  var onInternalSearchSubmit = function onInternalSearchSubmit(searchText) {
    // prevent empty tags from appearing when you click the Enter button
    if (!searchText || !searchText.trim()) {
      return;
    }
    onSearch(searchText, {
      source: 'submit'
    });
  };

  // Close will clean up single mode search text
  react.useEffect(function () {
    if (!mergedOpen && !multiple && mode !== 'combobox') {
      onInternalSearch('', false, false);
    }
  }, [mergedOpen]);

  // ============================ Disabled ============================
  // Close dropdown & remove focus state when disabled change
  react.useEffect(function () {
    if (innerOpen && disabled) {
      setInnerOpen(false);
    }

    // After onBlur is triggered, the focused does not need to be reset
    if (disabled && !blurRef.current) {
      setMockFocused(false);
    }
  }, [disabled]);

  // ============================ Keyboard ============================
  /**
   * We record input value here to check if can press to clean up by backspace
   * - null: Key is not down, this is reset by key up
   * - true: Search text is empty when first time backspace down
   * - false: Search text is not empty when first time backspace down
   */
  var _useLock = useLock(),
    _useLock2 = (0,slicedToArray/* default */.Z)(_useLock, 2),
    getClearLock = _useLock2[0],
    setClearLock = _useLock2[1];
  var keyLockRef = react.useRef(false);

  // KeyDown
  var onInternalKeyDown = function onInternalKeyDown(event) {
    var clearLock = getClearLock();
    var key = event.key;
    var isEnterKey = key === 'Enter';
    if (isEnterKey) {
      // Do not submit form when type in the input
      if (mode !== 'combobox') {
        event.preventDefault();
      }

      // We only manage open state here, close logic should handle by list component
      if (!mergedOpen) {
        onToggleOpen(true);
      }
    }
    setClearLock(!!mergedSearchValue);

    // Remove value by `backspace`
    if (key === 'Backspace' && !clearLock && multiple && !mergedSearchValue && displayValues.length) {
      var cloneDisplayValues = (0,toConsumableArray/* default */.Z)(displayValues);
      var removedDisplayValue = null;
      for (var i = cloneDisplayValues.length - 1; i >= 0; i -= 1) {
        var current = cloneDisplayValues[i];
        if (!current.disabled) {
          cloneDisplayValues.splice(i, 1);
          removedDisplayValue = current;
          break;
        }
      }
      if (removedDisplayValue) {
        onDisplayValuesChange(cloneDisplayValues, {
          type: 'remove',
          values: [removedDisplayValue]
        });
      }
    }
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    if (mergedOpen && (!isEnterKey || !keyLockRef.current)) {
      var _listRef$current2;
      // Lock the Enter key after it is pressed to avoid repeated triggering of the onChange event.
      if (isEnterKey) {
        keyLockRef.current = true;
      }
      (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 || _listRef$current2.onKeyDown.apply(_listRef$current2, [event].concat(rest));
    }
    onKeyDown === null || onKeyDown === void 0 || onKeyDown.apply(void 0, [event].concat(rest));
  };

  // KeyUp
  var onInternalKeyUp = function onInternalKeyUp(event) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      rest[_key2 - 1] = arguments[_key2];
    }
    if (mergedOpen) {
      var _listRef$current3;
      (_listRef$current3 = listRef.current) === null || _listRef$current3 === void 0 || _listRef$current3.onKeyUp.apply(_listRef$current3, [event].concat(rest));
    }
    if (event.key === 'Enter') {
      keyLockRef.current = false;
    }
    onKeyUp === null || onKeyUp === void 0 || onKeyUp.apply(void 0, [event].concat(rest));
  };

  // ============================ Selector ============================
  var onSelectorRemove = function onSelectorRemove(val) {
    var newValues = displayValues.filter(function (i) {
      return i !== val;
    });
    onDisplayValuesChange(newValues, {
      type: 'remove',
      values: [val]
    });
  };
  var onInputBlur = function onInputBlur() {
    // Unlock the Enter key after the input blur; otherwise, the Enter key needs to be pressed twice to trigger the correct effect.
    keyLockRef.current = false;
  };

  // ========================== Focus / Blur ==========================
  /** Record real focus status */
  var focusRef = react.useRef(false);
  var onContainerFocus = function onContainerFocus() {
    setMockFocused(true);
    if (!disabled) {
      if (onFocus && !focusRef.current) {
        onFocus.apply(void 0, arguments);
      }

      // `showAction` should handle `focus` if set
      if (showAction.includes('focus')) {
        onToggleOpen(true);
      }
    }
    focusRef.current = true;
  };
  var onContainerBlur = function onContainerBlur() {
    blurRef.current = true;
    setMockFocused(false, function () {
      focusRef.current = false;
      blurRef.current = false;
      onToggleOpen(false);
    });
    if (disabled) {
      return;
    }
    if (mergedSearchValue) {
      // `tags` mode should move `searchValue` into values
      if (mode === 'tags') {
        onSearch(mergedSearchValue, {
          source: 'submit'
        });
      } else if (mode === 'multiple') {
        // `multiple` mode only clean the search value but not trigger event
        onSearch('', {
          source: 'blur'
        });
      }
    }
    if (onBlur) {
      onBlur.apply(void 0, arguments);
    }
  };

  // Give focus back of Select
  var activeTimeoutIds = [];
  react.useEffect(function () {
    return function () {
      activeTimeoutIds.forEach(function (timeoutId) {
        return clearTimeout(timeoutId);
      });
      activeTimeoutIds.splice(0, activeTimeoutIds.length);
    };
  }, []);
  var onInternalMouseDown = function onInternalMouseDown(event) {
    var _triggerRef$current;
    var target = event.target;
    var popupElement = (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.getPopupElement();

    // We should give focus back to selector if clicked item is not focusable
    if (popupElement && popupElement.contains(target)) {
      var timeoutId = setTimeout(function () {
        var index = activeTimeoutIds.indexOf(timeoutId);
        if (index !== -1) {
          activeTimeoutIds.splice(index, 1);
        }
        cancelSetMockFocused();
        if (!mobile && !popupElement.contains(document.activeElement)) {
          var _selectorRef$current3;
          (_selectorRef$current3 = selectorRef.current) === null || _selectorRef$current3 === void 0 || _selectorRef$current3.focus();
        }
      });
      activeTimeoutIds.push(timeoutId);
    }
    for (var _len3 = arguments.length, restArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      restArgs[_key3 - 1] = arguments[_key3];
    }
    onMouseDown === null || onMouseDown === void 0 || onMouseDown.apply(void 0, [event].concat(restArgs));
  };

  // ============================ Dropdown ============================
  var _React$useState5 = react.useState({}),
    _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
    forceUpdate = _React$useState6[1];
  // We need force update here since popup dom is render async
  function onPopupMouseEnter() {
    forceUpdate({});
  }

  // Used for raw custom input trigger
  var onTriggerVisibleChange;
  if (customizeRawInputElement) {
    onTriggerVisibleChange = function onTriggerVisibleChange(newOpen) {
      onToggleOpen(newOpen);
    };
  }

  // Close when click on non-select element
  useSelectTriggerControl(function () {
    var _triggerRef$current2;
    return [containerRef.current, (_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : _triggerRef$current2.getPopupElement()];
  }, triggerOpen, onToggleOpen, !!customizeRawInputElement);

  // ============================ Context =============================
  var baseSelectContext = react.useMemo(function () {
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
      notFoundContent: notFoundContent,
      open: mergedOpen,
      triggerOpen: triggerOpen,
      id: id,
      showSearch: mergedShowSearch,
      multiple: multiple,
      toggleOpen: onToggleOpen
    });
  }, [props, notFoundContent, triggerOpen, mergedOpen, id, mergedShowSearch, multiple, onToggleOpen]);

  // ==================================================================
  // ==                            Render                            ==
  // ==================================================================

  // ============================= Arrow ==============================
  var showSuffixIcon = !!suffixIcon || loading;
  var arrowNode;
  if (showSuffixIcon) {
    arrowNode = /*#__PURE__*/react.createElement(es_TransBtn, {
      className: classnames_default()("".concat(prefixCls, "-arrow"), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-arrow-loading"), loading)),
      customizeIcon: suffixIcon,
      customizeIconProps: {
        loading: loading,
        searchValue: mergedSearchValue,
        open: mergedOpen,
        focused: mockFocused,
        showSearch: mergedShowSearch
      }
    });
  }

  // ============================= Clear ==============================
  var onClearMouseDown = function onClearMouseDown() {
    var _selectorRef$current4;
    onClear === null || onClear === void 0 || onClear();
    (_selectorRef$current4 = selectorRef.current) === null || _selectorRef$current4 === void 0 || _selectorRef$current4.focus();
    onDisplayValuesChange([], {
      type: 'clear',
      values: displayValues
    });
    onInternalSearch('', false, false);
  };
  var _useAllowClear = useAllowClear(prefixCls, onClearMouseDown, displayValues, allowClear, clearIcon, disabled, mergedSearchValue, mode),
    mergedAllowClear = _useAllowClear.allowClear,
    clearNode = _useAllowClear.clearIcon;

  // =========================== OptionList ===========================
  var optionList = /*#__PURE__*/react.createElement(OptionList, {
    ref: listRef
  });

  // ============================= Select =============================
  var mergedClassName = classnames_default()(prefixCls, className, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-focused"), mockFocused), "".concat(prefixCls, "-multiple"), multiple), "".concat(prefixCls, "-single"), !multiple), "".concat(prefixCls, "-allow-clear"), allowClear), "".concat(prefixCls, "-show-arrow"), showSuffixIcon), "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-loading"), loading), "".concat(prefixCls, "-open"), mergedOpen), "".concat(prefixCls, "-customize-input"), customizeInputElement), "".concat(prefixCls, "-show-search"), mergedShowSearch));

  // >>> Selector
  var selectorNode = /*#__PURE__*/react.createElement(es_SelectTrigger, {
    ref: triggerRef,
    disabled: disabled,
    prefixCls: prefixCls,
    visible: triggerOpen,
    popupElement: optionList,
    animation: animation,
    transitionName: transitionName,
    dropdownStyle: dropdownStyle,
    dropdownClassName: dropdownClassName,
    direction: direction,
    dropdownMatchSelectWidth: dropdownMatchSelectWidth,
    dropdownRender: dropdownRender,
    dropdownAlign: dropdownAlign,
    placement: placement,
    builtinPlacements: builtinPlacements,
    getPopupContainer: getPopupContainer,
    empty: emptyOptions,
    getTriggerDOMNode: function getTriggerDOMNode(node) {
      return (
        // TODO: This is workaround and should be removed in `rc-select`
        // And use new standard `nativeElement` for ref.
        // But we should update `rc-resize-observer` first.
        selectorDomRef.current || node
      );
    },
    onPopupVisibleChange: onTriggerVisibleChange,
    onPopupMouseEnter: onPopupMouseEnter
  }, customizeRawInputElement ? (/*#__PURE__*/react.cloneElement(customizeRawInputElement, {
    ref: customizeRawInputRef
  })) : /*#__PURE__*/react.createElement(es_Selector, (0,esm_extends/* default */.Z)({}, props, {
    domRef: selectorDomRef,
    prefixCls: prefixCls,
    inputElement: customizeInputElement,
    ref: selectorRef,
    id: id,
    prefix: prefix,
    showSearch: mergedShowSearch,
    autoClearSearchValue: autoClearSearchValue,
    mode: mode,
    activeDescendantId: activeDescendantId,
    tagRender: tagRender,
    values: displayValues,
    open: mergedOpen,
    onToggleOpen: onToggleOpen,
    activeValue: activeValue,
    searchValue: mergedSearchValue,
    onSearch: onInternalSearch,
    onSearchSubmit: onInternalSearchSubmit,
    onRemove: onSelectorRemove,
    tokenWithEnter: tokenWithEnter,
    onInputBlur: onInputBlur
  })));

  // >>> Render
  var renderNode;

  // Render raw
  if (customizeRawInputElement) {
    renderNode = selectorNode;
  } else {
    renderNode = /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
      className: mergedClassName
    }, domProps, {
      ref: containerRef,
      onMouseDown: onInternalMouseDown,
      onKeyDown: onInternalKeyDown,
      onKeyUp: onInternalKeyUp,
      onFocus: onContainerFocus,
      onBlur: onContainerBlur
    }), /*#__PURE__*/react.createElement(Polite, {
      visible: mockFocused && !mergedOpen,
      values: displayValues
    }), selectorNode, arrowNode, mergedAllowClear && clearNode);
  }
  return /*#__PURE__*/react.createElement(BaseSelectContext.Provider, {
    value: baseSelectContext
  }, renderNode);
});

// Set display name for dev
if (false) {}
/* harmony default export */ var es_BaseSelect = (BaseSelect);
;// CONCATENATED MODULE: ./node_modules/rc-select/es/OptGroup.js
/* istanbul ignore file */

/** This is a placeholder, not real render in dom */
var OptGroup = function OptGroup() {
  return null;
};
OptGroup.isSelectOptGroup = true;
/* harmony default export */ var es_OptGroup = (OptGroup);
;// CONCATENATED MODULE: ./node_modules/rc-select/es/Option.js
/* istanbul ignore file */

/** This is a placeholder, not real render in dom */
var Option = function Option() {
  return null;
};
Option.isSelectOption = true;
/* harmony default export */ var es_Option = (Option);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMemo.js
var useMemo = __webpack_require__(99834);
// EXTERNAL MODULE: ./node_modules/rc-util/es/omit.js
var omit = __webpack_require__(85401);
// EXTERNAL MODULE: ./node_modules/rc-virtual-list/es/index.js + 17 modules
var rc_virtual_list_es = __webpack_require__(15371);
;// CONCATENATED MODULE: ./node_modules/rc-select/es/utils/platformUtil.js
/* istanbul ignore file */
function isPlatformMac() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
;// CONCATENATED MODULE: ./node_modules/rc-select/es/OptionList.js





var OptionList_excluded = ["disabled", "title", "children", "style", "className"];














// export interface OptionListProps<OptionsType extends object[]> {

function OptionList_isTitleType(content) {
  return typeof content === 'string' || typeof content === 'number';
}

/**
 * Using virtual list of option display.
 * Will fallback to dom if use customize render.
 */
var OptionList = function OptionList(_, ref) {
  var _useBaseProps = useBaseProps(),
    prefixCls = _useBaseProps.prefixCls,
    id = _useBaseProps.id,
    open = _useBaseProps.open,
    multiple = _useBaseProps.multiple,
    mode = _useBaseProps.mode,
    searchValue = _useBaseProps.searchValue,
    toggleOpen = _useBaseProps.toggleOpen,
    notFoundContent = _useBaseProps.notFoundContent,
    onPopupScroll = _useBaseProps.onPopupScroll;
  var _React$useContext = react.useContext(es_SelectContext),
    maxCount = _React$useContext.maxCount,
    flattenOptions = _React$useContext.flattenOptions,
    onActiveValue = _React$useContext.onActiveValue,
    defaultActiveFirstOption = _React$useContext.defaultActiveFirstOption,
    onSelect = _React$useContext.onSelect,
    menuItemSelectedIcon = _React$useContext.menuItemSelectedIcon,
    rawValues = _React$useContext.rawValues,
    fieldNames = _React$useContext.fieldNames,
    virtual = _React$useContext.virtual,
    direction = _React$useContext.direction,
    listHeight = _React$useContext.listHeight,
    listItemHeight = _React$useContext.listItemHeight,
    optionRender = _React$useContext.optionRender;
  var itemPrefixCls = "".concat(prefixCls, "-item");
  var memoFlattenOptions = (0,useMemo/* default */.Z)(function () {
    return flattenOptions;
  }, [open, flattenOptions], function (prev, next) {
    return next[0] && prev[1] !== next[1];
  });

  // =========================== List ===========================
  var listRef = react.useRef(null);
  var overMaxCount = react.useMemo(function () {
    return multiple && isValidCount(maxCount) && (rawValues === null || rawValues === void 0 ? void 0 : rawValues.size) >= maxCount;
  }, [multiple, maxCount, rawValues === null || rawValues === void 0 ? void 0 : rawValues.size]);
  var onListMouseDown = function onListMouseDown(event) {
    event.preventDefault();
  };
  var scrollIntoView = function scrollIntoView(args) {
    var _listRef$current;
    (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.scrollTo(typeof args === 'number' ? {
      index: args
    } : args);
  };

  // https://github.com/ant-design/ant-design/issues/34975
  var isSelected = react.useCallback(function (value) {
    if (mode === 'combobox') {
      return false;
    }
    return rawValues.has(value);
  }, [mode, (0,toConsumableArray/* default */.Z)(rawValues).toString(), rawValues.size]);

  // ========================== Active ==========================
  var getEnabledActiveIndex = function getEnabledActiveIndex(index) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var len = memoFlattenOptions.length;
    for (var i = 0; i < len; i += 1) {
      var current = (index + i * offset + len) % len;
      var _ref = memoFlattenOptions[current] || {},
        group = _ref.group,
        data = _ref.data;
      if (!group && !(data !== null && data !== void 0 && data.disabled) && (isSelected(data.value) || !overMaxCount)) {
        return current;
      }
    }
    return -1;
  };
  var _React$useState = react.useState(function () {
      return getEnabledActiveIndex(0);
    }),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    activeIndex = _React$useState2[0],
    setActiveIndex = _React$useState2[1];
  var setActive = function setActive(index) {
    var fromKeyboard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    setActiveIndex(index);
    var info = {
      source: fromKeyboard ? 'keyboard' : 'mouse'
    };

    // Trigger active event
    var flattenItem = memoFlattenOptions[index];
    if (!flattenItem) {
      onActiveValue(null, -1, info);
      return;
    }
    onActiveValue(flattenItem.value, index, info);
  };

  // Auto active first item when list length or searchValue changed
  (0,react.useEffect)(function () {
    setActive(defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
  }, [memoFlattenOptions.length, searchValue]);

  // https://github.com/ant-design/ant-design/issues/48036
  var isAriaSelected = react.useCallback(function (value) {
    if (mode === 'combobox') {
      return String(value).toLowerCase() === searchValue.toLowerCase();
    }
    return rawValues.has(value);
  }, [mode, searchValue, (0,toConsumableArray/* default */.Z)(rawValues).toString(), rawValues.size]);

  // Auto scroll to item position in single mode
  (0,react.useEffect)(function () {
    /**
     * React will skip `onChange` when component update.
     * `setActive` function will call root accessibility state update which makes re-render.
     * So we need to delay to let Input component trigger onChange first.
     */
    var timeoutId = setTimeout(function () {
      if (!multiple && open && rawValues.size === 1) {
        var value = Array.from(rawValues)[0];
        // Scroll to the option closest to the searchValue if searching.
        var index = memoFlattenOptions.findIndex(function (_ref2) {
          var data = _ref2.data;
          return searchValue ? String(data.value).startsWith(searchValue) : data.value === value;
        });
        if (index !== -1) {
          setActive(index);
          scrollIntoView(index);
        }
      }
    });

    // Force trigger scrollbar visible when open
    if (open) {
      var _listRef$current2;
      (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 || _listRef$current2.scrollTo(undefined);
    }
    return function () {
      return clearTimeout(timeoutId);
    };
  }, [open, searchValue]);

  // ========================== Values ==========================
  var onSelectValue = function onSelectValue(value) {
    if (value !== undefined) {
      onSelect(value, {
        selected: !rawValues.has(value)
      });
    }

    // Single mode should always close by select
    if (!multiple) {
      toggleOpen(false);
    }
  };

  // ========================= Keyboard =========================
  react.useImperativeHandle(ref, function () {
    return {
      onKeyDown: function onKeyDown(event) {
        var which = event.which,
          ctrlKey = event.ctrlKey;
        switch (which) {
          // >>> Arrow keys & ctrl + n/p on Mac
          case KeyCode/* default.N */.Z.N:
          case KeyCode/* default.P */.Z.P:
          case KeyCode/* default.UP */.Z.UP:
          case KeyCode/* default.DOWN */.Z.DOWN:
            {
              var offset = 0;
              if (which === KeyCode/* default.UP */.Z.UP) {
                offset = -1;
              } else if (which === KeyCode/* default.DOWN */.Z.DOWN) {
                offset = 1;
              } else if (isPlatformMac() && ctrlKey) {
                if (which === KeyCode/* default.N */.Z.N) {
                  offset = 1;
                } else if (which === KeyCode/* default.P */.Z.P) {
                  offset = -1;
                }
              }
              if (offset !== 0) {
                var nextActiveIndex = getEnabledActiveIndex(activeIndex + offset, offset);
                scrollIntoView(nextActiveIndex);
                setActive(nextActiveIndex, true);
              }
              break;
            }

          // >>> Select (Tab / Enter)
          case KeyCode/* default.TAB */.Z.TAB:
          case KeyCode/* default.ENTER */.Z.ENTER:
            {
              var _item$data;
              // value
              var item = memoFlattenOptions[activeIndex];
              if (item && !(item !== null && item !== void 0 && (_item$data = item.data) !== null && _item$data !== void 0 && _item$data.disabled) && !overMaxCount) {
                onSelectValue(item.value);
              } else {
                onSelectValue(undefined);
              }
              if (open) {
                event.preventDefault();
              }
              break;
            }

          // >>> Close
          case KeyCode/* default.ESC */.Z.ESC:
            {
              toggleOpen(false);
              if (open) {
                event.stopPropagation();
              }
            }
        }
      },
      onKeyUp: function onKeyUp() {},
      scrollTo: function scrollTo(index) {
        scrollIntoView(index);
      }
    };
  });

  // ========================== Render ==========================
  if (memoFlattenOptions.length === 0) {
    return /*#__PURE__*/react.createElement("div", {
      role: "listbox",
      id: "".concat(id, "_list"),
      className: "".concat(itemPrefixCls, "-empty"),
      onMouseDown: onListMouseDown
    }, notFoundContent);
  }
  var omitFieldNameList = Object.keys(fieldNames).map(function (key) {
    return fieldNames[key];
  });
  var getLabel = function getLabel(item) {
    return item.label;
  };
  function getItemAriaProps(item, index) {
    var group = item.group;
    return {
      role: group ? 'presentation' : 'option',
      id: "".concat(id, "_list_").concat(index)
    };
  }
  var renderItem = function renderItem(index) {
    var item = memoFlattenOptions[index];
    if (!item) {
      return null;
    }
    var itemData = item.data || {};
    var value = itemData.value;
    var group = item.group;
    var attrs = (0,pickAttrs/* default */.Z)(itemData, true);
    var mergedLabel = getLabel(item);
    return item ? /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
      "aria-label": typeof mergedLabel === 'string' && !group ? mergedLabel : null
    }, attrs, {
      key: index
    }, getItemAriaProps(item, index), {
      "aria-selected": isAriaSelected(value)
    }), value) : null;
  };
  var a11yProps = {
    role: 'listbox',
    id: "".concat(id, "_list")
  };
  return /*#__PURE__*/react.createElement(react.Fragment, null, virtual && /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, a11yProps, {
    style: {
      height: 0,
      width: 0,
      overflow: 'hidden'
    }
  }), renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)), /*#__PURE__*/react.createElement(rc_virtual_list_es/* default */.Z, {
    itemKey: "key",
    ref: listRef,
    data: memoFlattenOptions,
    height: listHeight,
    itemHeight: listItemHeight,
    fullHeight: false,
    onMouseDown: onListMouseDown,
    onScroll: onPopupScroll,
    virtual: virtual,
    direction: direction,
    innerProps: virtual ? null : a11yProps
  }, function (item, itemIndex) {
    var group = item.group,
      groupOption = item.groupOption,
      data = item.data,
      label = item.label,
      value = item.value;
    var key = data.key;

    // Group
    if (group) {
      var _data$title;
      var groupTitle = (_data$title = data.title) !== null && _data$title !== void 0 ? _data$title : OptionList_isTitleType(label) ? label.toString() : undefined;
      return /*#__PURE__*/react.createElement("div", {
        className: classnames_default()(itemPrefixCls, "".concat(itemPrefixCls, "-group"), data.className),
        title: groupTitle
      }, label !== undefined ? label : key);
    }
    var disabled = data.disabled,
      title = data.title,
      children = data.children,
      style = data.style,
      className = data.className,
      otherProps = (0,objectWithoutProperties/* default */.Z)(data, OptionList_excluded);
    var passedProps = (0,omit/* default */.Z)(otherProps, omitFieldNameList);

    // Option
    var selected = isSelected(value);
    var mergedDisabled = disabled || !selected && overMaxCount;
    var optionPrefixCls = "".concat(itemPrefixCls, "-option");
    var optionClassName = classnames_default()(itemPrefixCls, optionPrefixCls, className, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(optionPrefixCls, "-grouped"), groupOption), "".concat(optionPrefixCls, "-active"), activeIndex === itemIndex && !mergedDisabled), "".concat(optionPrefixCls, "-disabled"), mergedDisabled), "".concat(optionPrefixCls, "-selected"), selected));
    var mergedLabel = getLabel(item);
    var iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === 'function' || selected;

    // https://github.com/ant-design/ant-design/issues/34145
    var content = typeof mergedLabel === 'number' ? mergedLabel : mergedLabel || value;
    // https://github.com/ant-design/ant-design/issues/26717
    var optionTitle = OptionList_isTitleType(content) ? content.toString() : undefined;
    if (title !== undefined) {
      optionTitle = title;
    }
    return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, (0,pickAttrs/* default */.Z)(passedProps), !virtual ? getItemAriaProps(item, itemIndex) : {}, {
      "aria-selected": isAriaSelected(value),
      className: optionClassName,
      title: optionTitle,
      onMouseMove: function onMouseMove() {
        if (activeIndex === itemIndex || mergedDisabled) {
          return;
        }
        setActive(itemIndex);
      },
      onClick: function onClick() {
        if (!mergedDisabled) {
          onSelectValue(value);
        }
      },
      style: style
    }), /*#__PURE__*/react.createElement("div", {
      className: "".concat(optionPrefixCls, "-content")
    }, typeof optionRender === 'function' ? optionRender(item, {
      index: itemIndex
    }) : content), /*#__PURE__*/react.isValidElement(menuItemSelectedIcon) || selected, iconVisible && /*#__PURE__*/react.createElement(es_TransBtn, {
      className: "".concat(itemPrefixCls, "-option-state"),
      customizeIcon: menuItemSelectedIcon,
      customizeIconProps: {
        value: value,
        disabled: mergedDisabled,
        isSelected: selected
      }
    }, selected ? '✓' : null));
  }));
};
var RefOptionList = /*#__PURE__*/react.forwardRef(OptionList);
if (false) {}
/* harmony default export */ var es_OptionList = (RefOptionList);
;// CONCATENATED MODULE: ./node_modules/rc-select/es/hooks/useCache.js


/**
 * Cache `value` related LabeledValue & options.
 */
/* harmony default export */ var useCache = (function (labeledValues, valueOptions) {
  var cacheRef = react.useRef({
    values: new Map(),
    options: new Map()
  });
  var filledLabeledValues = react.useMemo(function () {
    var _cacheRef$current = cacheRef.current,
      prevValueCache = _cacheRef$current.values,
      prevOptionCache = _cacheRef$current.options;

    // Fill label by cache
    var patchedValues = labeledValues.map(function (item) {
      if (item.label === undefined) {
        var _prevValueCache$get;
        return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, item), {}, {
          label: (_prevValueCache$get = prevValueCache.get(item.value)) === null || _prevValueCache$get === void 0 ? void 0 : _prevValueCache$get.label
        });
      }
      return item;
    });

    // Refresh cache
    var valueCache = new Map();
    var optionCache = new Map();
    patchedValues.forEach(function (item) {
      valueCache.set(item.value, item);
      optionCache.set(item.value, valueOptions.get(item.value) || prevOptionCache.get(item.value));
    });
    cacheRef.current.values = valueCache;
    cacheRef.current.options = optionCache;
    return patchedValues;
  }, [labeledValues, valueOptions]);
  var getOption = react.useCallback(function (val) {
    return valueOptions.get(val) || cacheRef.current.options.get(val);
  }, [valueOptions]);
  return [filledLabeledValues, getOption];
});
;// CONCATENATED MODULE: ./node_modules/rc-select/es/hooks/useFilterOptions.js





function includes(test, search) {
  return commonUtil_toArray(test).join('').toUpperCase().includes(search);
}
/* harmony default export */ var useFilterOptions = (function (options, fieldNames, searchValue, filterOption, optionFilterProp) {
  return react.useMemo(function () {
    if (!searchValue || filterOption === false) {
      return options;
    }
    var fieldOptions = fieldNames.options,
      fieldLabel = fieldNames.label,
      fieldValue = fieldNames.value;
    var filteredOptions = [];
    var customizeFilter = typeof filterOption === 'function';
    var upperSearch = searchValue.toUpperCase();
    var filterFunc = customizeFilter ? filterOption : function (_, option) {
      // Use provided `optionFilterProp`
      if (optionFilterProp) {
        return includes(option[optionFilterProp], upperSearch);
      }

      // Auto select `label` or `value` by option type
      if (option[fieldOptions]) {
        // hack `fieldLabel` since `OptionGroup` children is not `label`
        return includes(option[fieldLabel !== 'children' ? fieldLabel : 'label'], upperSearch);
      }
      return includes(option[fieldValue], upperSearch);
    };
    var wrapOption = customizeFilter ? function (opt) {
      return injectPropsWithOption(opt);
    } : function (opt) {
      return opt;
    };
    options.forEach(function (item) {
      // Group should check child options
      if (item[fieldOptions]) {
        // Check group first
        var matchGroup = filterFunc(searchValue, wrapOption(item));
        if (matchGroup) {
          filteredOptions.push(item);
        } else {
          // Check option
          var subOptions = item[fieldOptions].filter(function (subItem) {
            return filterFunc(searchValue, wrapOption(subItem));
          });
          if (subOptions.length) {
            filteredOptions.push((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, item), {}, (0,defineProperty/* default */.Z)({}, fieldOptions, subOptions)));
          }
        }
        return;
      }
      if (filterFunc(searchValue, wrapOption(item))) {
        filteredOptions.push(item);
      }
    });
    return filteredOptions;
  }, [options, filterOption, optionFilterProp, searchValue, fieldNames]);
});
// EXTERNAL MODULE: ./node_modules/rc-select/es/hooks/useId.js
var useId = __webpack_require__(91935);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Children/toArray.js
var Children_toArray = __webpack_require__(93550);
;// CONCATENATED MODULE: ./node_modules/rc-select/es/utils/legacyUtil.js


var legacyUtil_excluded = ["children", "value"],
  _excluded2 = ["children"];


function convertNodeToOption(node) {
  var _ref = node,
    key = _ref.key,
    _ref$props = _ref.props,
    children = _ref$props.children,
    value = _ref$props.value,
    restProps = (0,objectWithoutProperties/* default */.Z)(_ref$props, legacyUtil_excluded);
  return (0,objectSpread2/* default */.Z)({
    key: key,
    value: value !== undefined ? value : key,
    children: children
  }, restProps);
}
function legacyUtil_convertChildrenToData(nodes) {
  var optionOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return (0,Children_toArray/* default */.Z)(nodes).map(function (node, index) {
    if (! /*#__PURE__*/react.isValidElement(node) || !node.type) {
      return null;
    }
    var _ref2 = node,
      isSelectOptGroup = _ref2.type.isSelectOptGroup,
      key = _ref2.key,
      _ref2$props = _ref2.props,
      children = _ref2$props.children,
      restProps = (0,objectWithoutProperties/* default */.Z)(_ref2$props, _excluded2);
    if (optionOnly || !isSelectOptGroup) {
      return convertNodeToOption(node);
    }
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
      key: "__RC_SELECT_GRP__".concat(key === null ? index : key, "__"),
      label: key
    }, restProps), {}, {
      options: legacyUtil_convertChildrenToData(children)
    });
  }).filter(function (data) {
    return data;
  });
}
;// CONCATENATED MODULE: ./node_modules/rc-select/es/hooks/useOptions.js



/**
 * Parse `children` to `options` if `options` is not provided.
 * Then flatten the `options`.
 */
var useOptions = function useOptions(options, children, fieldNames, optionFilterProp, optionLabelProp) {
  return react.useMemo(function () {
    var mergedOptions = options;
    var childrenAsData = !options;
    if (childrenAsData) {
      mergedOptions = legacyUtil_convertChildrenToData(children);
    }
    var valueOptions = new Map();
    var labelOptions = new Map();
    var setLabelOptions = function setLabelOptions(labelOptionsMap, option, key) {
      if (key && typeof key === 'string') {
        labelOptionsMap.set(option[key], option);
      }
    };
    var dig = function dig(optionList) {
      var isChildren = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // for loop to speed up collection speed
      for (var i = 0; i < optionList.length; i += 1) {
        var option = optionList[i];
        if (!option[fieldNames.options] || isChildren) {
          valueOptions.set(option[fieldNames.value], option);
          setLabelOptions(labelOptions, option, fieldNames.label);
          // https://github.com/ant-design/ant-design/issues/35304
          setLabelOptions(labelOptions, option, optionFilterProp);
          setLabelOptions(labelOptions, option, optionLabelProp);
        } else {
          dig(option[fieldNames.options], true);
        }
      }
    };
    dig(mergedOptions);
    return {
      options: mergedOptions,
      valueOptions: valueOptions,
      labelOptions: labelOptions
    };
  }, [options, children, fieldNames, optionFilterProp, optionLabelProp]);
};
/* harmony default export */ var hooks_useOptions = (useOptions);
;// CONCATENATED MODULE: ./node_modules/rc-select/es/hooks/useRefFunc.js


/**
 * Same as `React.useCallback` but always return a memoized function
 * but redirect to real function.
 */
function useRefFunc(callback) {
  var funcRef = react.useRef();
  funcRef.current = callback;
  var cacheFn = react.useCallback(function () {
    return funcRef.current.apply(funcRef, arguments);
  }, []);
  return cacheFn;
}
;// CONCATENATED MODULE: ./node_modules/rc-select/es/utils/warningPropsUtil.js







function warningProps(props) {
  var mode = props.mode,
    options = props.options,
    children = props.children,
    backfill = props.backfill,
    allowClear = props.allowClear,
    placeholder = props.placeholder,
    getInputElement = props.getInputElement,
    showSearch = props.showSearch,
    onSearch = props.onSearch,
    defaultOpen = props.defaultOpen,
    autoFocus = props.autoFocus,
    labelInValue = props.labelInValue,
    value = props.value,
    inputValue = props.inputValue,
    optionLabelProp = props.optionLabelProp;
  var multiple = isMultiple(mode);
  var mergedShowSearch = showSearch !== undefined ? showSearch : multiple || mode === 'combobox';
  var mergedOptions = options || convertChildrenToData(children);

  // `tags` should not set option as disabled
  warning(mode !== 'tags' || mergedOptions.every(function (opt) {
    return !opt.disabled;
  }), 'Please avoid setting option to disabled in tags mode since user can always type text as tag.');

  // `combobox` & `tags` should option be `string` type
  if (mode === 'tags' || mode === 'combobox') {
    var hasNumberValue = mergedOptions.some(function (item) {
      if (item.options) {
        return item.options.some(function (opt) {
          return typeof ('value' in opt ? opt.value : opt.key) === 'number';
        });
      }
      return typeof ('value' in item ? item.value : item.key) === 'number';
    });
    warning(!hasNumberValue, '`value` of Option should not use number type when `mode` is `tags` or `combobox`.');
  }

  // `combobox` should not use `optionLabelProp`
  warning(mode !== 'combobox' || !optionLabelProp, '`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly.');

  // Only `combobox` support `backfill`
  warning(mode === 'combobox' || !backfill, '`backfill` only works with `combobox` mode.');

  // Only `combobox` support `getInputElement`
  warning(mode === 'combobox' || !getInputElement, '`getInputElement` only work with `combobox` mode.');

  // Customize `getInputElement` should not use `allowClear` & `placeholder`
  noteOnce(mode !== 'combobox' || !getInputElement || !allowClear || !placeholder, 'Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`.');

  // `onSearch` should use in `combobox` or `showSearch`
  if (onSearch && !mergedShowSearch && mode !== 'combobox' && mode !== 'tags') {
    warning(false, '`onSearch` should work with `showSearch` instead of use alone.');
  }
  noteOnce(!defaultOpen || autoFocus, '`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed.');
  if (value !== undefined && value !== null) {
    var values = toArray(value);
    warning(!labelInValue || values.every(function (val) {
      return _typeof(val) === 'object' && ('key' in val || 'value' in val);
    }), '`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`');
    warning(!multiple || Array.isArray(value), '`value` should be array when `mode` is `multiple` or `tags`');
  }

  // Syntactic sugar should use correct children type
  if (children) {
    var invalidateChildType = null;
    toNodeArray(children).some(function (node) {
      if (! /*#__PURE__*/React.isValidElement(node) || !node.type) {
        return false;
      }
      var _ref = node,
        type = _ref.type;
      if (type.isSelectOption) {
        return false;
      }
      if (type.isSelectOptGroup) {
        var allChildrenValid = toNodeArray(node.props.children).every(function (subNode) {
          if (! /*#__PURE__*/React.isValidElement(subNode) || !node.type || subNode.type.isSelectOption) {
            return true;
          }
          invalidateChildType = subNode.type;
          return false;
        });
        if (allChildrenValid) {
          return false;
        }
        return true;
      }
      invalidateChildType = type;
      return true;
    });
    if (invalidateChildType) {
      warning(false, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(invalidateChildType.displayName || invalidateChildType.name || invalidateChildType, "`."));
    }
    warning(inputValue === undefined, '`inputValue` is deprecated, please use `searchValue` instead.');
  }
}

// value in Select option should not be null
// note: OptGroup has options too
function warningNullOptions(options, fieldNames) {
  if (options) {
    var recursiveOptions = function recursiveOptions(optionsList) {
      var inGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      for (var i = 0; i < optionsList.length; i++) {
        var option = optionsList[i];
        if (option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.value] === null) {
          warning(false, '`value` in Select options should not be `null`.');
          return true;
        }
        if (!inGroup && Array.isArray(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options]) && recursiveOptions(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options], true)) {
          break;
        }
      }
    };
    recursiveOptions(options);
  }
}
/* harmony default export */ var warningPropsUtil = ((/* unused pure expression or super */ null && (warningProps)));
;// CONCATENATED MODULE: ./node_modules/rc-select/es/Select.js







var Select_excluded = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "optionRender", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "direction", "listHeight", "listItemHeight", "labelRender", "value", "defaultValue", "labelInValue", "onChange", "maxCount"];
/**
 * To match accessibility requirement, we always provide an input in the component.
 * Other element will not set `tabIndex` to avoid `onBlur` sequence problem.
 * For focused select, we set `aria-live="polite"` to update the accessibility content.
 *
 * ref:
 * - keyboard: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/listbox_role#Keyboard_interactions
 *
 * New api:
 * - listHeight
 * - listItemHeight
 * - component
 *
 * Remove deprecated api:
 * - multiple
 * - tags
 * - combobox
 * - firstActiveValue
 * - dropdownMenuStyle
 * - openClassName (Not list in api)
 *
 * Update:
 * - `backfill` only support `combobox` mode
 * - `combobox` mode not support `labelInValue` since it's meaningless
 * - `getInputElement` only support `combobox` mode
 * - `onChange` return OptionData instead of ReactNode
 * - `filterOption` `onChange` `onSelect` accept OptionData instead of ReactNode
 * - `combobox` mode trigger `onChange` will get `undefined` if no `value` match in Option
 * - `combobox` mode not support `optionLabelProp`
 */

















var OMIT_DOM_PROPS = ['inputValue'];
function isRawValue(value) {
  return !value || (0,esm_typeof/* default */.Z)(value) !== 'object';
}
var Select = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var id = props.id,
    mode = props.mode,
    _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-select' : _props$prefixCls,
    backfill = props.backfill,
    fieldNames = props.fieldNames,
    inputValue = props.inputValue,
    searchValue = props.searchValue,
    onSearch = props.onSearch,
    _props$autoClearSearc = props.autoClearSearchValue,
    autoClearSearchValue = _props$autoClearSearc === void 0 ? true : _props$autoClearSearc,
    onSelect = props.onSelect,
    onDeselect = props.onDeselect,
    _props$dropdownMatchS = props.dropdownMatchSelectWidth,
    dropdownMatchSelectWidth = _props$dropdownMatchS === void 0 ? true : _props$dropdownMatchS,
    filterOption = props.filterOption,
    filterSort = props.filterSort,
    optionFilterProp = props.optionFilterProp,
    optionLabelProp = props.optionLabelProp,
    options = props.options,
    optionRender = props.optionRender,
    children = props.children,
    defaultActiveFirstOption = props.defaultActiveFirstOption,
    menuItemSelectedIcon = props.menuItemSelectedIcon,
    virtual = props.virtual,
    direction = props.direction,
    _props$listHeight = props.listHeight,
    listHeight = _props$listHeight === void 0 ? 200 : _props$listHeight,
    _props$listItemHeight = props.listItemHeight,
    listItemHeight = _props$listItemHeight === void 0 ? 20 : _props$listItemHeight,
    labelRender = props.labelRender,
    value = props.value,
    defaultValue = props.defaultValue,
    labelInValue = props.labelInValue,
    onChange = props.onChange,
    maxCount = props.maxCount,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, Select_excluded);
  var mergedId = (0,useId/* default */.ZP)(id);
  var multiple = BaseSelect_isMultiple(mode);
  var childrenAsData = !!(!options && children);
  var mergedFilterOption = react.useMemo(function () {
    if (filterOption === undefined && mode === 'combobox') {
      return false;
    }
    return filterOption;
  }, [filterOption, mode]);

  // ========================= FieldNames =========================
  var mergedFieldNames = react.useMemo(function () {
    return fillFieldNames(fieldNames, childrenAsData);
  }, /* eslint-disable react-hooks/exhaustive-deps */
  [
  // We stringify fieldNames to avoid unnecessary re-renders.
  JSON.stringify(fieldNames), childrenAsData]
  /* eslint-enable react-hooks/exhaustive-deps */);

  // =========================== Search ===========================
  var _useMergedState = (0,useMergedState/* default */.Z)('', {
      value: searchValue !== undefined ? searchValue : inputValue,
      postState: function postState(search) {
        return search || '';
      }
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    mergedSearchValue = _useMergedState2[0],
    setSearchValue = _useMergedState2[1];

  // =========================== Option ===========================
  var parsedOptions = hooks_useOptions(options, children, mergedFieldNames, optionFilterProp, optionLabelProp);
  var valueOptions = parsedOptions.valueOptions,
    labelOptions = parsedOptions.labelOptions,
    mergedOptions = parsedOptions.options;

  // ========================= Wrap Value =========================
  var convert2LabelValues = react.useCallback(function (draftValues) {
    // Convert to array
    var valueList = commonUtil_toArray(draftValues);

    // Convert to labelInValue type
    return valueList.map(function (val) {
      var rawValue;
      var rawLabel;
      var rawKey;
      var rawDisabled;
      var rawTitle;

      // Fill label & value
      if (isRawValue(val)) {
        rawValue = val;
      } else {
        var _val$value;
        rawKey = val.key;
        rawLabel = val.label;
        rawValue = (_val$value = val.value) !== null && _val$value !== void 0 ? _val$value : rawKey;
      }
      var option = valueOptions.get(rawValue);
      if (option) {
        var _option$key;
        // Fill missing props
        if (rawLabel === undefined) rawLabel = option === null || option === void 0 ? void 0 : option[optionLabelProp || mergedFieldNames.label];
        if (rawKey === undefined) rawKey = (_option$key = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key !== void 0 ? _option$key : rawValue;
        rawDisabled = option === null || option === void 0 ? void 0 : option.disabled;
        rawTitle = option === null || option === void 0 ? void 0 : option.title;

        // Warning if label not same as provided
        if (false) { var optionLabel; }
      }
      return {
        label: rawLabel,
        value: rawValue,
        key: rawKey,
        disabled: rawDisabled,
        title: rawTitle
      };
    });
  }, [mergedFieldNames, optionLabelProp, valueOptions]);

  // =========================== Values ===========================
  var _useMergedState3 = (0,useMergedState/* default */.Z)(defaultValue, {
      value: value
    }),
    _useMergedState4 = (0,slicedToArray/* default */.Z)(_useMergedState3, 2),
    internalValue = _useMergedState4[0],
    setInternalValue = _useMergedState4[1];

  // Merged value with LabelValueType
  var rawLabeledValues = react.useMemo(function () {
    var _values$;
    var newInternalValue = multiple && internalValue === null ? [] : internalValue;
    var values = convert2LabelValues(newInternalValue);

    // combobox no need save value when it's no value (exclude value equal 0)
    if (mode === 'combobox' && isComboNoValue((_values$ = values[0]) === null || _values$ === void 0 ? void 0 : _values$.value)) {
      return [];
    }
    return values;
  }, [internalValue, convert2LabelValues, mode, multiple]);

  // Fill label with cache to avoid option remove
  var _useCache = useCache(rawLabeledValues, valueOptions),
    _useCache2 = (0,slicedToArray/* default */.Z)(_useCache, 2),
    mergedValues = _useCache2[0],
    getMixedOption = _useCache2[1];
  var displayValues = react.useMemo(function () {
    // `null` need show as placeholder instead
    // https://github.com/ant-design/ant-design/issues/25057
    if (!mode && mergedValues.length === 1) {
      var firstValue = mergedValues[0];
      if (firstValue.value === null && (firstValue.label === null || firstValue.label === undefined)) {
        return [];
      }
    }
    return mergedValues.map(function (item) {
      var _ref;
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, item), {}, {
        label: (_ref = typeof labelRender === 'function' ? labelRender(item) : item.label) !== null && _ref !== void 0 ? _ref : item.value
      });
    });
  }, [mode, mergedValues, labelRender]);

  /** Convert `displayValues` to raw value type set */
  var rawValues = react.useMemo(function () {
    return new Set(mergedValues.map(function (val) {
      return val.value;
    }));
  }, [mergedValues]);
  react.useEffect(function () {
    if (mode === 'combobox') {
      var _mergedValues$;
      var strValue = (_mergedValues$ = mergedValues[0]) === null || _mergedValues$ === void 0 ? void 0 : _mergedValues$.value;
      setSearchValue(hasValue(strValue) ? String(strValue) : '');
    }
  }, [mergedValues]);

  // ======================= Display Option =======================
  // Create a placeholder item if not exist in `options`
  var createTagOption = useRefFunc(function (val, label) {
    var mergedLabel = label !== null && label !== void 0 ? label : val;
    return (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, mergedFieldNames.value, val), mergedFieldNames.label, mergedLabel);
  });

  // Fill tag as option if mode is `tags`
  var filledTagOptions = react.useMemo(function () {
    if (mode !== 'tags') {
      return mergedOptions;
    }

    // >>> Tag mode
    var cloneOptions = (0,toConsumableArray/* default */.Z)(mergedOptions);

    // Check if value exist in options (include new patch item)
    var existOptions = function existOptions(val) {
      return valueOptions.has(val);
    };

    // Fill current value as option
    (0,toConsumableArray/* default */.Z)(mergedValues).sort(function (a, b) {
      return a.value < b.value ? -1 : 1;
    }).forEach(function (item) {
      var val = item.value;
      if (!existOptions(val)) {
        cloneOptions.push(createTagOption(val, item.label));
      }
    });
    return cloneOptions;
  }, [createTagOption, mergedOptions, valueOptions, mergedValues, mode]);
  var filteredOptions = useFilterOptions(filledTagOptions, mergedFieldNames, mergedSearchValue, mergedFilterOption, optionFilterProp);

  // Fill options with search value if needed
  var filledSearchOptions = react.useMemo(function () {
    if (mode !== 'tags' || !mergedSearchValue || filteredOptions.some(function (item) {
      return item[optionFilterProp || 'value'] === mergedSearchValue;
    })) {
      return filteredOptions;
    }
    // ignore when search value equal select input value
    if (filteredOptions.some(function (item) {
      return item[mergedFieldNames.value] === mergedSearchValue;
    })) {
      return filteredOptions;
    }
    // Fill search value as option
    return [createTagOption(mergedSearchValue)].concat((0,toConsumableArray/* default */.Z)(filteredOptions));
  }, [createTagOption, optionFilterProp, mode, filteredOptions, mergedSearchValue, mergedFieldNames]);
  var sorter = function sorter(inputOptions) {
    var sortedOptions = (0,toConsumableArray/* default */.Z)(inputOptions).sort(function (a, b) {
      return filterSort(a, b, {
        searchValue: mergedSearchValue
      });
    });
    return sortedOptions.map(function (item) {
      if (Array.isArray(item.options)) {
        return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, item), {}, {
          options: item.options.length > 0 ? sorter(item.options) : item.options
        });
      }
      return item;
    });
  };
  var orderedFilteredOptions = react.useMemo(function () {
    if (!filterSort) {
      return filledSearchOptions;
    }
    return sorter(filledSearchOptions);
  }, [filledSearchOptions, filterSort, mergedSearchValue]);
  var displayOptions = react.useMemo(function () {
    return flattenOptions(orderedFilteredOptions, {
      fieldNames: mergedFieldNames,
      childrenAsData: childrenAsData
    });
  }, [orderedFilteredOptions, mergedFieldNames, childrenAsData]);

  // =========================== Change ===========================
  var triggerChange = function triggerChange(values) {
    var labeledValues = convert2LabelValues(values);
    setInternalValue(labeledValues);
    if (onChange && (
    // Trigger event only when value changed
    labeledValues.length !== mergedValues.length || labeledValues.some(function (newVal, index) {
      var _mergedValues$index;
      return ((_mergedValues$index = mergedValues[index]) === null || _mergedValues$index === void 0 ? void 0 : _mergedValues$index.value) !== (newVal === null || newVal === void 0 ? void 0 : newVal.value);
    }))) {
      var returnValues = labelInValue ? labeledValues : labeledValues.map(function (v) {
        return v.value;
      });
      var returnOptions = labeledValues.map(function (v) {
        return injectPropsWithOption(getMixedOption(v.value));
      });
      onChange(
      // Value
      multiple ? returnValues : returnValues[0],
      // Option
      multiple ? returnOptions : returnOptions[0]);
    }
  };

  // ======================= Accessibility ========================
  var _React$useState = react.useState(null),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    activeValue = _React$useState2[0],
    setActiveValue = _React$useState2[1];
  var _React$useState3 = react.useState(0),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    accessibilityIndex = _React$useState4[0],
    setAccessibilityIndex = _React$useState4[1];
  var mergedDefaultActiveFirstOption = defaultActiveFirstOption !== undefined ? defaultActiveFirstOption : mode !== 'combobox';
  var onActiveValue = react.useCallback(function (active, index) {
    var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref3$source = _ref3.source,
      source = _ref3$source === void 0 ? 'keyboard' : _ref3$source;
    setAccessibilityIndex(index);
    if (backfill && mode === 'combobox' && active !== null && source === 'keyboard') {
      setActiveValue(String(active));
    }
  }, [backfill, mode]);

  // ========================= OptionList =========================
  var triggerSelect = function triggerSelect(val, selected, type) {
    var getSelectEnt = function getSelectEnt() {
      var _option$key2;
      var option = getMixedOption(val);
      return [labelInValue ? {
        label: option === null || option === void 0 ? void 0 : option[mergedFieldNames.label],
        value: val,
        key: (_option$key2 = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key2 !== void 0 ? _option$key2 : val
      } : val, injectPropsWithOption(option)];
    };
    if (selected && onSelect) {
      var _getSelectEnt = getSelectEnt(),
        _getSelectEnt2 = (0,slicedToArray/* default */.Z)(_getSelectEnt, 2),
        wrappedValue = _getSelectEnt2[0],
        _option = _getSelectEnt2[1];
      onSelect(wrappedValue, _option);
    } else if (!selected && onDeselect && type !== 'clear') {
      var _getSelectEnt3 = getSelectEnt(),
        _getSelectEnt4 = (0,slicedToArray/* default */.Z)(_getSelectEnt3, 2),
        _wrappedValue = _getSelectEnt4[0],
        _option2 = _getSelectEnt4[1];
      onDeselect(_wrappedValue, _option2);
    }
  };

  // Used for OptionList selection
  var onInternalSelect = useRefFunc(function (val, info) {
    var cloneValues;

    // Single mode always trigger select only with option list
    var mergedSelect = multiple ? info.selected : true;
    if (mergedSelect) {
      cloneValues = multiple ? [].concat((0,toConsumableArray/* default */.Z)(mergedValues), [val]) : [val];
    } else {
      cloneValues = mergedValues.filter(function (v) {
        return v.value !== val;
      });
    }
    triggerChange(cloneValues);
    triggerSelect(val, mergedSelect);

    // Clean search value if single or configured
    if (mode === 'combobox') {
      // setSearchValue(String(val));
      setActiveValue('');
    } else if (!BaseSelect_isMultiple || autoClearSearchValue) {
      setSearchValue('');
      setActiveValue('');
    }
  });

  // ======================= Display Change =======================
  // BaseSelect display values change
  var onDisplayValuesChange = function onDisplayValuesChange(nextValues, info) {
    triggerChange(nextValues);
    var type = info.type,
      values = info.values;
    if (type === 'remove' || type === 'clear') {
      values.forEach(function (item) {
        triggerSelect(item.value, false, type);
      });
    }
  };

  // =========================== Search ===========================
  var onInternalSearch = function onInternalSearch(searchText, info) {
    setSearchValue(searchText);
    setActiveValue(null);

    // [Submit] Tag mode should flush input
    if (info.source === 'submit') {
      var formatted = (searchText || '').trim();
      // prevent empty tags from appearing when you click the Enter button
      if (formatted) {
        var newRawValues = Array.from(new Set([].concat((0,toConsumableArray/* default */.Z)(rawValues), [formatted])));
        triggerChange(newRawValues);
        triggerSelect(formatted, true);
        setSearchValue('');
      }
      return;
    }
    if (info.source !== 'blur') {
      if (mode === 'combobox') {
        triggerChange(searchText);
      }
      onSearch === null || onSearch === void 0 || onSearch(searchText);
    }
  };
  var onInternalSearchSplit = function onInternalSearchSplit(words) {
    var patchValues = words;
    if (mode !== 'tags') {
      patchValues = words.map(function (word) {
        var opt = labelOptions.get(word);
        return opt === null || opt === void 0 ? void 0 : opt.value;
      }).filter(function (val) {
        return val !== undefined;
      });
    }
    var newRawValues = Array.from(new Set([].concat((0,toConsumableArray/* default */.Z)(rawValues), (0,toConsumableArray/* default */.Z)(patchValues))));
    triggerChange(newRawValues);
    newRawValues.forEach(function (newRawValue) {
      triggerSelect(newRawValue, true);
    });
  };

  // ========================== Context ===========================
  var selectContext = react.useMemo(function () {
    var realVirtual = virtual !== false && dropdownMatchSelectWidth !== false;
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, parsedOptions), {}, {
      flattenOptions: displayOptions,
      onActiveValue: onActiveValue,
      defaultActiveFirstOption: mergedDefaultActiveFirstOption,
      onSelect: onInternalSelect,
      menuItemSelectedIcon: menuItemSelectedIcon,
      rawValues: rawValues,
      fieldNames: mergedFieldNames,
      virtual: realVirtual,
      direction: direction,
      listHeight: listHeight,
      listItemHeight: listItemHeight,
      childrenAsData: childrenAsData,
      maxCount: maxCount,
      optionRender: optionRender
    });
  }, [maxCount, parsedOptions, displayOptions, onActiveValue, mergedDefaultActiveFirstOption, onInternalSelect, menuItemSelectedIcon, rawValues, mergedFieldNames, virtual, dropdownMatchSelectWidth, direction, listHeight, listItemHeight, childrenAsData, optionRender]);

  // ========================== Warning ===========================
  if (false) {}

  // ==============================================================
  // ==                          Render                          ==
  // ==============================================================
  return /*#__PURE__*/react.createElement(es_SelectContext.Provider, {
    value: selectContext
  }, /*#__PURE__*/react.createElement(es_BaseSelect, (0,esm_extends/* default */.Z)({}, restProps, {
    // >>> MISC
    id: mergedId,
    prefixCls: prefixCls,
    ref: ref,
    omitDomProps: OMIT_DOM_PROPS,
    mode: mode
    // >>> Values
    ,

    displayValues: displayValues,
    onDisplayValuesChange: onDisplayValuesChange
    // >>> Trigger
    ,

    direction: direction
    // >>> Search
    ,

    searchValue: mergedSearchValue,
    onSearch: onInternalSearch,
    autoClearSearchValue: autoClearSearchValue,
    onSearchSplit: onInternalSearchSplit,
    dropdownMatchSelectWidth: dropdownMatchSelectWidth
    // >>> OptionList
    ,

    OptionList: es_OptionList,
    emptyOptions: !displayOptions.length
    // >>> Accessibility
    ,

    activeValue: activeValue,
    activeDescendantId: "".concat(mergedId, "_list_").concat(accessibilityIndex)
  })));
});
if (false) {}
var TypedSelect = Select;
TypedSelect.Option = es_Option;
TypedSelect.OptGroup = es_OptGroup;
/* harmony default export */ var es_Select = (TypedSelect);
;// CONCATENATED MODULE: ./node_modules/rc-select/es/index.js






/* harmony default export */ var rc_select_es = (es_Select);

/***/ }),

/***/ 3659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65260);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57024);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40656);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91032);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68925);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var rc_util_es_hooks_useMergedState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78877);
/* harmony import */ var rc_util_es_KeyCode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88035);




var _excluded = ["prefixCls", "className", "checked", "defaultChecked", "disabled", "loadingIcon", "checkedChildren", "unCheckedChildren", "onClick", "onChange", "onKeyDown"];




var Switch = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (_ref, ref) {
  var _classNames;
  var _ref$prefixCls = _ref.prefixCls,
    prefixCls = _ref$prefixCls === void 0 ? 'rc-switch' : _ref$prefixCls,
    className = _ref.className,
    checked = _ref.checked,
    defaultChecked = _ref.defaultChecked,
    disabled = _ref.disabled,
    loadingIcon = _ref.loadingIcon,
    checkedChildren = _ref.checkedChildren,
    unCheckedChildren = _ref.unCheckedChildren,
    onClick = _ref.onClick,
    onChange = _ref.onChange,
    onKeyDown = _ref.onKeyDown,
    restProps = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);
  var _useMergedState = (0,rc_util_es_hooks_useMergedState__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(false, {
      value: checked,
      defaultValue: defaultChecked
    }),
    _useMergedState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_useMergedState, 2),
    innerChecked = _useMergedState2[0],
    setInnerChecked = _useMergedState2[1];
  function triggerChange(newChecked, event) {
    var mergedChecked = innerChecked;
    if (!disabled) {
      mergedChecked = newChecked;
      setInnerChecked(mergedChecked);
      onChange === null || onChange === void 0 ? void 0 : onChange(mergedChecked, event);
    }
    return mergedChecked;
  }
  function onInternalKeyDown(e) {
    if (e.which === rc_util_es_KeyCode__WEBPACK_IMPORTED_MODULE_3__/* ["default"].LEFT */ .Z.LEFT) {
      triggerChange(false, e);
    } else if (e.which === rc_util_es_KeyCode__WEBPACK_IMPORTED_MODULE_3__/* ["default"].RIGHT */ .Z.RIGHT) {
      triggerChange(true, e);
    }
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
  }
  function onInternalClick(e) {
    var ret = triggerChange(!innerChecked, e);
    // [Legacy] trigger onClick with value
    onClick === null || onClick === void 0 ? void 0 : onClick(ret, e);
  }
  var switchClassName = classnames__WEBPACK_IMPORTED_MODULE_1___default()(prefixCls, className, (_classNames = {}, (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-checked"), innerChecked), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, restProps, {
    type: "button",
    role: "switch",
    "aria-checked": innerChecked,
    disabled: disabled,
    className: switchClassName,
    ref: ref,
    onKeyDown: onInternalKeyDown,
    onClick: onInternalClick
  }), loadingIcon, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "".concat(prefixCls, "-inner")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "".concat(prefixCls, "-inner-checked")
  }, checkedChildren), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "".concat(prefixCls, "-inner-unchecked")
  }, unCheckedChildren)));
});
Switch.displayName = 'Switch';
/* harmony default export */ __webpack_exports__["Z"] = (Switch);

/***/ }),

/***/ 59450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ INTERNAL_HOOKS; },
/* harmony export */   "w": function() { return /* binding */ EXPAND_COLUMN; }
/* harmony export */ });
var EXPAND_COLUMN = {};
var INTERNAL_HOOKS = 'rc-table-internal-hook';

/***/ }),

/***/ 51386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ convertChildrenToColumns; },
  "Z": function() { return /* binding */ hooks_useColumns; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Children/toArray.js
var toArray = __webpack_require__(93550);
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(13764);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/rc-table/es/constant.js
var constant = __webpack_require__(59450);
// EXTERNAL MODULE: ./node_modules/rc-table/es/utils/legacyUtil.js
var legacyUtil = __webpack_require__(17877);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/hooks/useColumns/useWidthColumns.js


function parseColWidth(totalWidth) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (typeof width === 'number') {
    return width;
  }
  if (width.endsWith('%')) {
    return totalWidth * parseFloat(width) / 100;
  }
  return null;
}

/**
 * Fill all column with width
 */
function useWidthColumns(flattenColumns, scrollWidth, clientWidth) {
  return react.useMemo(function () {
    // Fill width if needed
    if (scrollWidth && scrollWidth > 0) {
      var totalWidth = 0;
      var missWidthCount = 0;

      // collect not given width column
      flattenColumns.forEach(function (col) {
        var colWidth = parseColWidth(scrollWidth, col.width);
        if (colWidth) {
          totalWidth += colWidth;
        } else {
          missWidthCount += 1;
        }
      });

      // Fill width
      var maxFitWidth = Math.max(scrollWidth, clientWidth);
      var restWidth = Math.max(maxFitWidth - totalWidth, missWidthCount);
      var restCount = missWidthCount;
      var avgWidth = restWidth / missWidthCount;
      var realTotal = 0;
      var filledColumns = flattenColumns.map(function (col) {
        var clone = (0,objectSpread2/* default */.Z)({}, col);
        var colWidth = parseColWidth(scrollWidth, clone.width);
        if (colWidth) {
          clone.width = colWidth;
        } else {
          var colAvgWidth = Math.floor(avgWidth);
          clone.width = restCount === 1 ? restWidth : colAvgWidth;
          restWidth -= colAvgWidth;
          restCount -= 1;
        }
        realTotal += clone.width;
        return clone;
      });

      // If realTotal is less than clientWidth,
      // We need extend column width
      if (realTotal < maxFitWidth) {
        var scale = maxFitWidth / realTotal;
        restWidth = maxFitWidth;
        filledColumns.forEach(function (col, index) {
          var colWidth = Math.floor(col.width * scale);
          col.width = index === filledColumns.length - 1 ? restWidth : colWidth;
          restWidth -= colWidth;
        });
      }
      return [filledColumns, Math.max(realTotal, maxFitWidth)];
    }
    return [flattenColumns, scrollWidth];
  }, [flattenColumns, scrollWidth, clientWidth]);
}
;// CONCATENATED MODULE: ./node_modules/rc-table/es/hooks/useColumns/index.js






var _excluded = ["children"],
  _excluded2 = ["fixed"];






function convertChildrenToColumns(children) {
  return (0,toArray/* default */.Z)(children).filter(function (node) {
    return /*#__PURE__*/react.isValidElement(node);
  }).map(function (_ref) {
    var key = _ref.key,
      props = _ref.props;
    var nodeChildren = props.children,
      restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded);
    var column = (0,objectSpread2/* default */.Z)({
      key: key
    }, restProps);
    if (nodeChildren) {
      column.children = convertChildrenToColumns(nodeChildren);
    }
    return column;
  });
}
function filterHiddenColumns(columns) {
  return columns.filter(function (column) {
    return column && (0,esm_typeof/* default */.Z)(column) === 'object' && !column.hidden;
  }).map(function (column) {
    var subColumns = column.children;
    if (subColumns && subColumns.length > 0) {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, column), {}, {
        children: filterHiddenColumns(subColumns)
      });
    }
    return column;
  });
}
function flatColumns(columns) {
  var parentKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'key';
  return columns.filter(function (column) {
    return column && (0,esm_typeof/* default */.Z)(column) === 'object';
  }).reduce(function (list, column, index) {
    var fixed = column.fixed;
    // Convert `fixed='true'` to `fixed='left'` instead
    var parsedFixed = fixed === true ? 'left' : fixed;
    var mergedKey = "".concat(parentKey, "-").concat(index);
    var subColumns = column.children;
    if (subColumns && subColumns.length > 0) {
      return [].concat((0,toConsumableArray/* default */.Z)(list), (0,toConsumableArray/* default */.Z)(flatColumns(subColumns, mergedKey).map(function (subColum) {
        return (0,objectSpread2/* default */.Z)({
          fixed: parsedFixed
        }, subColum);
      })));
    }
    return [].concat((0,toConsumableArray/* default */.Z)(list), [(0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
      key: mergedKey
    }, column), {}, {
      fixed: parsedFixed
    })]);
  }, []);
}
function revertForRtl(columns) {
  return columns.map(function (column) {
    var fixed = column.fixed,
      restProps = (0,objectWithoutProperties/* default */.Z)(column, _excluded2);

    // Convert `fixed='left'` to `fixed='right'` instead
    var parsedFixed = fixed;
    if (fixed === 'left') {
      parsedFixed = 'right';
    } else if (fixed === 'right') {
      parsedFixed = 'left';
    }
    return (0,objectSpread2/* default */.Z)({
      fixed: parsedFixed
    }, restProps);
  });
}

/**
 * Parse `columns` & `children` into `columns`.
 */
function useColumns(_ref2, transformColumns) {
  var prefixCls = _ref2.prefixCls,
    columns = _ref2.columns,
    children = _ref2.children,
    expandable = _ref2.expandable,
    expandedKeys = _ref2.expandedKeys,
    columnTitle = _ref2.columnTitle,
    getRowKey = _ref2.getRowKey,
    onTriggerExpand = _ref2.onTriggerExpand,
    expandIcon = _ref2.expandIcon,
    rowExpandable = _ref2.rowExpandable,
    expandIconColumnIndex = _ref2.expandIconColumnIndex,
    _ref2$expandedRowOffs = _ref2.expandedRowOffset,
    expandedRowOffset = _ref2$expandedRowOffs === void 0 ? 0 : _ref2$expandedRowOffs,
    direction = _ref2.direction,
    expandRowByClick = _ref2.expandRowByClick,
    columnWidth = _ref2.columnWidth,
    fixed = _ref2.fixed,
    scrollWidth = _ref2.scrollWidth,
    clientWidth = _ref2.clientWidth;
  var baseColumns = react.useMemo(function () {
    var newColumns = columns || convertChildrenToColumns(children) || [];
    return filterHiddenColumns(newColumns.slice());
  }, [columns, children]);

  // ========================== Expand ==========================
  var withExpandColumns = react.useMemo(function () {
    if (expandable) {
      var cloneColumns = baseColumns.slice();

      // >>> Warning if use `expandIconColumnIndex`
      if (false) {}

      // >>> Insert expand column if not exist
      if (!cloneColumns.includes(constant/* EXPAND_COLUMN */.w)) {
        var expandColIndex = expandIconColumnIndex || 0;
        if (expandColIndex >= 0 && (expandColIndex || fixed === 'left' || !fixed)) {
          cloneColumns.splice(expandColIndex, 0, constant/* EXPAND_COLUMN */.w);
        }
        if (fixed === 'right') {
          cloneColumns.splice(baseColumns.length, 0, constant/* EXPAND_COLUMN */.w);
        }
      }

      // >>> Deduplicate additional expand column
      if (false) {}
      var expandColumnIndex = cloneColumns.indexOf(constant/* EXPAND_COLUMN */.w);
      cloneColumns = cloneColumns.filter(function (column, index) {
        return column !== constant/* EXPAND_COLUMN */.w || index === expandColumnIndex;
      });

      // >>> Check if expand column need to fixed
      var prevColumn = baseColumns[expandColumnIndex];
      var fixedColumn;
      if (fixed) {
        fixedColumn = fixed;
      } else {
        fixedColumn = prevColumn ? prevColumn.fixed : null;
      }

      // >>> Create expandable column
      var expandColumn = (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, legacyUtil/* INTERNAL_COL_DEFINE */.v, {
        className: "".concat(prefixCls, "-expand-icon-col"),
        columnType: 'EXPAND_COLUMN'
      }), "title", columnTitle), "fixed", fixedColumn), "className", "".concat(prefixCls, "-row-expand-icon-cell")), "width", columnWidth), "render", function render(_, record, index) {
        var rowKey = getRowKey(record, index);
        var expanded = expandedKeys.has(rowKey);
        var recordExpandable = rowExpandable ? rowExpandable(record) : true;
        var icon = expandIcon({
          prefixCls: prefixCls,
          expanded: expanded,
          expandable: recordExpandable,
          record: record,
          onExpand: onTriggerExpand
        });
        if (expandRowByClick) {
          return /*#__PURE__*/react.createElement("span", {
            onClick: function onClick(e) {
              return e.stopPropagation();
            }
          }, icon);
        }
        return icon;
      });
      return cloneColumns.map(function (col, index) {
        var column = col === constant/* EXPAND_COLUMN */.w ? expandColumn : col;
        if (index < expandedRowOffset) {
          return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, column), {}, {
            fixed: column.fixed || 'left'
          });
        }
        return column;
      });
    }
    if (false) {}
    return baseColumns.filter(function (col) {
      return col !== constant/* EXPAND_COLUMN */.w;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expandable, baseColumns, getRowKey, expandedKeys, expandIcon, direction, expandedRowOffset]);

  // ========================= Transform ========================
  var mergedColumns = react.useMemo(function () {
    var finalColumns = withExpandColumns;
    if (transformColumns) {
      finalColumns = transformColumns(finalColumns);
    }

    // Always provides at least one column for table display
    if (!finalColumns.length) {
      finalColumns = [{
        render: function render() {
          return null;
        }
      }];
    }
    return finalColumns;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transformColumns, withExpandColumns, direction]);

  // ========================== Flatten =========================
  var flattenColumns = react.useMemo(function () {
    if (direction === 'rtl') {
      return revertForRtl(flatColumns(mergedColumns));
    }
    return flatColumns(mergedColumns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mergedColumns, direction, scrollWidth]);

  // ========================= Gap Fixed ========================
  var hasGapFixed = react.useMemo(function () {
    // Fixed: left, since old browser not support `findLastIndex`, we should use reverse loop
    var lastLeftIndex = -1;
    for (var i = flattenColumns.length - 1; i >= 0; i -= 1) {
      var colFixed = flattenColumns[i].fixed;
      if (colFixed === 'left' || colFixed === true) {
        lastLeftIndex = i;
        break;
      }
    }
    if (lastLeftIndex >= 0) {
      for (var _i = 0; _i <= lastLeftIndex; _i += 1) {
        var _colFixed = flattenColumns[_i].fixed;
        if (_colFixed !== 'left' && _colFixed !== true) {
          return true;
        }
      }
    }

    // Fixed: right
    var firstRightIndex = flattenColumns.findIndex(function (_ref3) {
      var colFixed = _ref3.fixed;
      return colFixed === 'right';
    });
    if (firstRightIndex >= 0) {
      for (var _i2 = firstRightIndex; _i2 < flattenColumns.length; _i2 += 1) {
        var _colFixed2 = flattenColumns[_i2].fixed;
        if (_colFixed2 !== 'right') {
          return true;
        }
      }
    }
    return false;
  }, [flattenColumns]);

  // ========================= FillWidth ========================
  var _useWidthColumns = useWidthColumns(flattenColumns, scrollWidth, clientWidth),
    _useWidthColumns2 = (0,slicedToArray/* default */.Z)(_useWidthColumns, 2),
    filledColumns = _useWidthColumns2[0],
    realScrollWidth = _useWidthColumns2[1];
  return [mergedColumns, filledColumns, realScrollWidth, hasGapFixed];
}
/* harmony default export */ var hooks_useColumns = (useColumns);

/***/ }),

/***/ 78323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w2": function() { return /* reexport */ constant/* EXPAND_COLUMN */.w; },
  "vP": function() { return /* reexport */ legacyUtil/* INTERNAL_COL_DEFINE */.v; },
  "RQ": function() { return /* reexport */ constant/* INTERNAL_HOOKS */.R; },
  "ER": function() { return /* reexport */ FooterComponents; },
  "Q$": function() { return /* reexport */ genTable; },
  "TN": function() { return /* reexport */ genVirtualTable; }
});

// UNUSED EXPORTS: Column, ColumnGroup, VirtualTable, default

// EXTERNAL MODULE: ./node_modules/rc-table/es/constant.js
var constant = __webpack_require__(59450);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useEvent.js
var useEvent = __webpack_require__(47789);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useLayoutEffect.js
var useLayoutEffect = __webpack_require__(76963);
// EXTERNAL MODULE: ./node_modules/rc-util/es/isEqual.js
var isEqual = __webpack_require__(55159);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(85202);
;// CONCATENATED MODULE: ./node_modules/@rc-component/context/es/context.js






function createContext(defaultValue) {
  var Context = /*#__PURE__*/react.createContext(undefined);
  var Provider = function Provider(_ref) {
    var value = _ref.value,
      children = _ref.children;
    var valueRef = react.useRef(value);
    valueRef.current = value;
    var _React$useState = react.useState(function () {
        return {
          getValue: function getValue() {
            return valueRef.current;
          },
          listeners: new Set()
        };
      }),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 1),
      context = _React$useState2[0];
    (0,useLayoutEffect/* default */.Z)(function () {
      (0,react_dom.unstable_batchedUpdates)(function () {
        context.listeners.forEach(function (listener) {
          listener(value);
        });
      });
    }, [value]);
    return /*#__PURE__*/react.createElement(Context.Provider, {
      value: context
    }, children);
  };
  return {
    Context: Context,
    Provider: Provider,
    defaultValue: defaultValue
  };
}

/** e.g. useSelect(userContext) => user */

/** e.g. useSelect(userContext, user => user.name) => user.name */

/** e.g. useSelect(userContext, ['name', 'age']) => user { name, age } */

/** e.g. useSelect(userContext, 'name') => user.name */

function useContext(holder, selector) {
  var eventSelector = (0,useEvent/* default */.Z)(typeof selector === 'function' ? selector : function (ctx) {
    if (selector === undefined) {
      return ctx;
    }
    if (!Array.isArray(selector)) {
      return ctx[selector];
    }
    var obj = {};
    selector.forEach(function (key) {
      obj[key] = ctx[key];
    });
    return obj;
  });
  var context = react.useContext(holder === null || holder === void 0 ? void 0 : holder.Context);
  var _ref2 = context || {},
    listeners = _ref2.listeners,
    getValue = _ref2.getValue;
  var valueRef = react.useRef();
  valueRef.current = eventSelector(context ? getValue() : holder === null || holder === void 0 ? void 0 : holder.defaultValue);
  var _React$useState3 = react.useState({}),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    forceUpdate = _React$useState4[1];
  (0,useLayoutEffect/* default */.Z)(function () {
    if (!context) {
      return;
    }
    function trigger(nextValue) {
      var nextSelectorValue = eventSelector(nextValue);
      if (!(0,isEqual/* default */.Z)(valueRef.current, nextSelectorValue, true)) {
        forceUpdate({});
      }
    }
    listeners.add(trigger);
    return function () {
      listeners.delete(trigger);
    };
  }, [context]);
  return valueRef.current;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(99195);
;// CONCATENATED MODULE: ./node_modules/@rc-component/context/es/Immutable.js



/**
 * Create Immutable pair for `makeImmutable` and `responseImmutable`.
 */
function createImmutable() {
  var ImmutableContext = /*#__PURE__*/react.createContext(null);

  /**
   * Get render update mark by `makeImmutable` root.
   * Do not deps on the return value as render times
   * but only use for `useMemo` or `useCallback` deps.
   */
  function useImmutableMark() {
    return react.useContext(ImmutableContext);
  }

  /**
  * Wrapped Component will be marked as Immutable.
  * When Component parent trigger render,
  * it will notice children component (use with `responseImmutable`) node that parent has updated.
  * @param Component Passed Component
  * @param triggerRender Customize trigger `responseImmutable` children re-render logic. Default will always trigger re-render when this component re-render.
  */
  function makeImmutable(Component, shouldTriggerRender) {
    var refAble = (0,es_ref/* supportRef */.Yr)(Component);
    var ImmutableComponent = function ImmutableComponent(props, ref) {
      var refProps = refAble ? {
        ref: ref
      } : {};
      var renderTimesRef = react.useRef(0);
      var prevProps = react.useRef(props);

      // If parent has the context, we do not wrap it
      var mark = useImmutableMark();
      if (mark !== null) {
        return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, refProps));
      }
      if (
      // Always trigger re-render if not provide `notTriggerRender`
      !shouldTriggerRender || shouldTriggerRender(prevProps.current, props)) {
        renderTimesRef.current += 1;
      }
      prevProps.current = props;
      return /*#__PURE__*/react.createElement(ImmutableContext.Provider, {
        value: renderTimesRef.current
      }, /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, refProps)));
    };
    if (false) {}
    return refAble ? /*#__PURE__*/react.forwardRef(ImmutableComponent) : ImmutableComponent;
  }

  /**
   * Wrapped Component with `React.memo`.
   * But will rerender when parent with `makeImmutable` rerender.
   */
  function responseImmutable(Component, propsAreEqual) {
    var refAble = (0,es_ref/* supportRef */.Yr)(Component);
    var ImmutableComponent = function ImmutableComponent(props, ref) {
      var refProps = refAble ? {
        ref: ref
      } : {};
      useImmutableMark();
      return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, refProps));
    };
    if (false) {}
    return refAble ? /*#__PURE__*/react.memo(/*#__PURE__*/react.forwardRef(ImmutableComponent), propsAreEqual) : /*#__PURE__*/react.memo(ImmutableComponent, propsAreEqual);
  }
  return {
    makeImmutable: makeImmutable,
    responseImmutable: responseImmutable,
    useImmutableMark: useImmutableMark
  };
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/context/es/index.js



// For legacy usage, we export it directly
var _createImmutable = createImmutable(),
  makeImmutable = _createImmutable.makeImmutable,
  responseImmutable = _createImmutable.responseImmutable,
  useImmutableMark = _createImmutable.useImmutableMark;

;// CONCATENATED MODULE: ./node_modules/rc-table/es/context/TableContext.js

var TableContext_createImmutable = createImmutable(),
  TableContext_makeImmutable = TableContext_createImmutable.makeImmutable,
  TableContext_responseImmutable = TableContext_createImmutable.responseImmutable,
  TableContext_useImmutableMark = TableContext_createImmutable.useImmutableMark;

var TableContext = createContext();
/* harmony default export */ var context_TableContext = (TableContext);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/hooks/useRenderTimes.js
/* istanbul ignore file */

function useRenderTimes(props, debug) {
  // Render times
  var timesRef = React.useRef(0);
  timesRef.current += 1;

  // Props changed
  var propsRef = React.useRef(props);
  var keys = [];
  Object.keys(props || {}).map(function (key) {
    var _propsRef$current;
    if ((props === null || props === void 0 ? void 0 : props[key]) !== ((_propsRef$current = propsRef.current) === null || _propsRef$current === void 0 ? void 0 : _propsRef$current[key])) {
      keys.push(key);
    }
  });
  propsRef.current = props;

  // Cache keys since React rerender may cause it lost
  var keysRef = React.useRef([]);
  if (keys.length) {
    keysRef.current = keys;
  }
  React.useDebugValue(timesRef.current);
  React.useDebugValue(keysRef.current.join(', '));
  if (debug) {
    console.log("".concat(debug, ":"), timesRef.current, keysRef.current);
  }
  return timesRef.current;
}
/* harmony default export */ var hooks_useRenderTimes = ((/* unused pure expression or super */ null && ( false ? 0 : function () {})));
var RenderBlock = /*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(function () {
  var times = useRenderTimes();
  return /*#__PURE__*/React.createElement("h1", null, "Render Times: ", times);
})));
if (false) {}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMemo.js
var useMemo = __webpack_require__(99834);
// EXTERNAL MODULE: ./node_modules/rc-util/es/utils/get.js
var get = __webpack_require__(20713);
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(13764);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/context/PerfContext.js

// TODO: Remove when use `responsiveImmutable`
var PerfContext = /*#__PURE__*/react.createContext({
  renderWithProps: false
});
/* harmony default export */ var context_PerfContext = (PerfContext);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/utils/valueUtil.js
var INTERNAL_KEY_PREFIX = 'RC_TABLE_KEY';
function toArray(arr) {
  if (arr === undefined || arr === null) {
    return [];
  }
  return Array.isArray(arr) ? arr : [arr];
}
function getColumnsKey(columns) {
  var columnKeys = [];
  var keys = {};
  columns.forEach(function (column) {
    var _ref = column || {},
      key = _ref.key,
      dataIndex = _ref.dataIndex;
    var mergedKey = key || toArray(dataIndex).join('-') || INTERNAL_KEY_PREFIX;
    while (keys[mergedKey]) {
      mergedKey = "".concat(mergedKey, "_next");
    }
    keys[mergedKey] = true;
    columnKeys.push(mergedKey);
  });
  return columnKeys;
}
function validateValue(val) {
  return val !== null && val !== undefined;
}
function validNumberValue(value) {
  return typeof value === 'number' && !Number.isNaN(value);
}
;// CONCATENATED MODULE: ./node_modules/rc-table/es/Cell/useCellRender.js










function isRenderCell(data) {
  return data && (0,esm_typeof/* default */.Z)(data) === 'object' && !Array.isArray(data) && ! /*#__PURE__*/react.isValidElement(data);
}
function useCellRender(record, dataIndex, renderIndex, children, render, shouldCellUpdate) {
  // TODO: Remove this after next major version
  var perfRecord = react.useContext(context_PerfContext);
  var mark = TableContext_useImmutableMark();

  // ======================== Render ========================
  var retData = (0,useMemo/* default */.Z)(function () {
    if (validateValue(children)) {
      return [children];
    }
    var path = dataIndex === null || dataIndex === undefined || dataIndex === '' ? [] : Array.isArray(dataIndex) ? dataIndex : [dataIndex];
    var value = (0,get/* default */.Z)(record, path);

    // Customize render node
    var returnChildNode = value;
    var returnCellProps = undefined;
    if (render) {
      var renderData = render(value, record, renderIndex);
      if (isRenderCell(renderData)) {
        if (false) {}
        returnChildNode = renderData.children;
        returnCellProps = renderData.props;
        perfRecord.renderWithProps = true;
      } else {
        returnChildNode = renderData;
      }
    }
    return [returnChildNode, returnCellProps];
  }, [
  // Force update deps
  mark,
  // Normal deps
  record, children, dataIndex, render, renderIndex], function (prev, next) {
    if (shouldCellUpdate) {
      var _prev = (0,slicedToArray/* default */.Z)(prev, 2),
        prevRecord = _prev[1];
      var _next = (0,slicedToArray/* default */.Z)(next, 2),
        nextRecord = _next[1];
      return shouldCellUpdate(nextRecord, prevRecord);
    }

    // Legacy mode should always update
    if (perfRecord.renderWithProps) {
      return true;
    }
    return !(0,isEqual/* default */.Z)(prev, next, true);
  });
  return retData;
}
;// CONCATENATED MODULE: ./node_modules/rc-table/es/Cell/useHoverState.js


/** Check if cell is in hover range */
function inHoverRange(cellStartRow, cellRowSpan, startRow, endRow) {
  var cellEndRow = cellStartRow + cellRowSpan - 1;
  return cellStartRow <= endRow && cellEndRow >= startRow;
}
function useHoverState(rowIndex, rowSpan) {
  return useContext(context_TableContext, function (ctx) {
    var hovering = inHoverRange(rowIndex, rowSpan || 1, ctx.hoverStartRow, ctx.hoverEndRow);
    return [hovering, ctx.onHover];
  });
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/index.js
var es = __webpack_require__(57433);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/Cell/index.js













var getTitleFromCellRenderChildren = function getTitleFromCellRenderChildren(_ref) {
  var ellipsis = _ref.ellipsis,
    rowType = _ref.rowType,
    children = _ref.children;
  var title;
  var ellipsisConfig = ellipsis === true ? {
    showTitle: true
  } : ellipsis;
  if (ellipsisConfig && (ellipsisConfig.showTitle || rowType === 'header')) {
    if (typeof children === 'string' || typeof children === 'number') {
      title = children.toString();
    } else if (/*#__PURE__*/react.isValidElement(children) && typeof children.props.children === 'string') {
      title = children.props.children;
    }
  }
  return title;
};
function Cell(props) {
  var _ref2, _ref3, _legacyCellProps$colS, _ref4, _ref5, _legacyCellProps$rowS, _additionalProps$titl, _classNames;
  if (false) {}
  var Component = props.component,
    children = props.children,
    ellipsis = props.ellipsis,
    scope = props.scope,
    prefixCls = props.prefixCls,
    className = props.className,
    align = props.align,
    record = props.record,
    render = props.render,
    dataIndex = props.dataIndex,
    renderIndex = props.renderIndex,
    shouldCellUpdate = props.shouldCellUpdate,
    index = props.index,
    rowType = props.rowType,
    colSpan = props.colSpan,
    rowSpan = props.rowSpan,
    fixLeft = props.fixLeft,
    fixRight = props.fixRight,
    firstFixLeft = props.firstFixLeft,
    lastFixLeft = props.lastFixLeft,
    firstFixRight = props.firstFixRight,
    lastFixRight = props.lastFixRight,
    appendNode = props.appendNode,
    _props$additionalProp = props.additionalProps,
    additionalProps = _props$additionalProp === void 0 ? {} : _props$additionalProp,
    isSticky = props.isSticky;
  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var _useContext = useContext(context_TableContext, ['supportSticky', 'allColumnsFixedLeft', 'rowHoverable']),
    supportSticky = _useContext.supportSticky,
    allColumnsFixedLeft = _useContext.allColumnsFixedLeft,
    rowHoverable = _useContext.rowHoverable;

  // ====================== Value =======================
  var _useCellRender = useCellRender(record, dataIndex, renderIndex, children, render, shouldCellUpdate),
    _useCellRender2 = (0,slicedToArray/* default */.Z)(_useCellRender, 2),
    childNode = _useCellRender2[0],
    legacyCellProps = _useCellRender2[1];

  // ====================== Fixed =======================
  var fixedStyle = {};
  var isFixLeft = typeof fixLeft === 'number' && supportSticky;
  var isFixRight = typeof fixRight === 'number' && supportSticky;
  if (isFixLeft) {
    fixedStyle.position = 'sticky';
    fixedStyle.left = fixLeft;
  }
  if (isFixRight) {
    fixedStyle.position = 'sticky';
    fixedStyle.right = fixRight;
  }

  // ================ RowSpan & ColSpan =================
  var mergedColSpan = (_ref2 = (_ref3 = (_legacyCellProps$colS = legacyCellProps === null || legacyCellProps === void 0 ? void 0 : legacyCellProps.colSpan) !== null && _legacyCellProps$colS !== void 0 ? _legacyCellProps$colS : additionalProps.colSpan) !== null && _ref3 !== void 0 ? _ref3 : colSpan) !== null && _ref2 !== void 0 ? _ref2 : 1;
  var mergedRowSpan = (_ref4 = (_ref5 = (_legacyCellProps$rowS = legacyCellProps === null || legacyCellProps === void 0 ? void 0 : legacyCellProps.rowSpan) !== null && _legacyCellProps$rowS !== void 0 ? _legacyCellProps$rowS : additionalProps.rowSpan) !== null && _ref5 !== void 0 ? _ref5 : rowSpan) !== null && _ref4 !== void 0 ? _ref4 : 1;

  // ====================== Hover =======================
  var _useHoverState = useHoverState(index, mergedRowSpan),
    _useHoverState2 = (0,slicedToArray/* default */.Z)(_useHoverState, 2),
    hovering = _useHoverState2[0],
    onHover = _useHoverState2[1];
  var onMouseEnter = (0,es/* useEvent */.zX)(function (event) {
    var _additionalProps$onMo;
    if (record) {
      onHover(index, index + mergedRowSpan - 1);
    }
    additionalProps === null || additionalProps === void 0 || (_additionalProps$onMo = additionalProps.onMouseEnter) === null || _additionalProps$onMo === void 0 || _additionalProps$onMo.call(additionalProps, event);
  });
  var onMouseLeave = (0,es/* useEvent */.zX)(function (event) {
    var _additionalProps$onMo2;
    if (record) {
      onHover(-1, -1);
    }
    additionalProps === null || additionalProps === void 0 || (_additionalProps$onMo2 = additionalProps.onMouseLeave) === null || _additionalProps$onMo2 === void 0 || _additionalProps$onMo2.call(additionalProps, event);
  });

  // ====================== Render ======================
  if (mergedColSpan === 0 || mergedRowSpan === 0) {
    return null;
  }

  // >>>>> Title
  var title = (_additionalProps$titl = additionalProps.title) !== null && _additionalProps$titl !== void 0 ? _additionalProps$titl : getTitleFromCellRenderChildren({
    rowType: rowType,
    ellipsis: ellipsis,
    children: childNode
  });

  // >>>>> ClassName
  var mergedClassName = classnames_default()(cellPrefixCls, className, (_classNames = {}, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)(_classNames, "".concat(cellPrefixCls, "-fix-left"), isFixLeft && supportSticky), "".concat(cellPrefixCls, "-fix-left-first"), firstFixLeft && supportSticky), "".concat(cellPrefixCls, "-fix-left-last"), lastFixLeft && supportSticky), "".concat(cellPrefixCls, "-fix-left-all"), lastFixLeft && allColumnsFixedLeft && supportSticky), "".concat(cellPrefixCls, "-fix-right"), isFixRight && supportSticky), "".concat(cellPrefixCls, "-fix-right-first"), firstFixRight && supportSticky), "".concat(cellPrefixCls, "-fix-right-last"), lastFixRight && supportSticky), "".concat(cellPrefixCls, "-ellipsis"), ellipsis), "".concat(cellPrefixCls, "-with-append"), appendNode), "".concat(cellPrefixCls, "-fix-sticky"), (isFixLeft || isFixRight) && isSticky && supportSticky), (0,defineProperty/* default */.Z)(_classNames, "".concat(cellPrefixCls, "-row-hover"), !legacyCellProps && hovering)), additionalProps.className, legacyCellProps === null || legacyCellProps === void 0 ? void 0 : legacyCellProps.className);

  // >>>>> Style
  var alignStyle = {};
  if (align) {
    alignStyle.textAlign = align;
  }

  // The order is important since user can overwrite style.
  // For example ant-design/ant-design#51763
  var mergedStyle = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, legacyCellProps === null || legacyCellProps === void 0 ? void 0 : legacyCellProps.style), fixedStyle), alignStyle), additionalProps.style);

  // >>>>> Children Node
  var mergedChildNode = childNode;

  // Not crash if final `childNode` is not validate ReactNode
  if ((0,esm_typeof/* default */.Z)(mergedChildNode) === 'object' && !Array.isArray(mergedChildNode) && ! /*#__PURE__*/react.isValidElement(mergedChildNode)) {
    mergedChildNode = null;
  }
  if (ellipsis && (lastFixLeft || firstFixRight)) {
    mergedChildNode = /*#__PURE__*/react.createElement("span", {
      className: "".concat(cellPrefixCls, "-content")
    }, mergedChildNode);
  }
  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, legacyCellProps, additionalProps, {
    className: mergedClassName,
    style: mergedStyle
    // A11y
    ,

    title: title,
    scope: scope
    // Hover
    ,

    onMouseEnter: rowHoverable ? onMouseEnter : undefined,
    onMouseLeave: rowHoverable ? onMouseLeave : undefined
    //Span
    ,

    colSpan: mergedColSpan !== 1 ? mergedColSpan : null,
    rowSpan: mergedRowSpan !== 1 ? mergedRowSpan : null
  }), appendNode, mergedChildNode);
}
/* harmony default export */ var es_Cell = (/*#__PURE__*/react.memo(Cell));
;// CONCATENATED MODULE: ./node_modules/rc-table/es/utils/fixUtil.js
function getCellFixedInfo(colStart, colEnd, columns, stickyOffsets, direction) {
  var startColumn = columns[colStart] || {};
  var endColumn = columns[colEnd] || {};
  var fixLeft;
  var fixRight;
  if (startColumn.fixed === 'left') {
    fixLeft = stickyOffsets.left[direction === 'rtl' ? colEnd : colStart];
  } else if (endColumn.fixed === 'right') {
    fixRight = stickyOffsets.right[direction === 'rtl' ? colStart : colEnd];
  }
  var lastFixLeft = false;
  var firstFixRight = false;
  var lastFixRight = false;
  var firstFixLeft = false;
  var nextColumn = columns[colEnd + 1];
  var prevColumn = columns[colStart - 1];

  // need show shadow only when canLastFix is true
  var canLastFix = nextColumn && !nextColumn.fixed || prevColumn && !prevColumn.fixed || columns.every(function (col) {
    return col.fixed === 'left';
  });
  if (direction === 'rtl') {
    if (fixLeft !== undefined) {
      var prevFixLeft = prevColumn && prevColumn.fixed === 'left';
      firstFixLeft = !prevFixLeft && canLastFix;
    } else if (fixRight !== undefined) {
      var nextFixRight = nextColumn && nextColumn.fixed === 'right';
      lastFixRight = !nextFixRight && canLastFix;
    }
  } else if (fixLeft !== undefined) {
    var nextFixLeft = nextColumn && nextColumn.fixed === 'left';
    lastFixLeft = !nextFixLeft && canLastFix;
  } else if (fixRight !== undefined) {
    var prevFixRight = prevColumn && prevColumn.fixed === 'right';
    firstFixRight = !prevFixRight && canLastFix;
  }
  return {
    fixLeft: fixLeft,
    fixRight: fixRight,
    lastFixLeft: lastFixLeft,
    firstFixRight: firstFixRight,
    lastFixRight: lastFixRight,
    firstFixLeft: firstFixLeft,
    isSticky: stickyOffsets.isSticky
  };
}
;// CONCATENATED MODULE: ./node_modules/rc-table/es/Footer/SummaryContext.js

var SummaryContext = /*#__PURE__*/react.createContext({});
/* harmony default export */ var Footer_SummaryContext = (SummaryContext);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/Footer/Cell.js







function SummaryCell(_ref) {
  var className = _ref.className,
    index = _ref.index,
    children = _ref.children,
    _ref$colSpan = _ref.colSpan,
    colSpan = _ref$colSpan === void 0 ? 1 : _ref$colSpan,
    rowSpan = _ref.rowSpan,
    align = _ref.align;
  var _useContext = useContext(context_TableContext, ['prefixCls', 'direction']),
    prefixCls = _useContext.prefixCls,
    direction = _useContext.direction;
  var _React$useContext = react.useContext(Footer_SummaryContext),
    scrollColumnIndex = _React$useContext.scrollColumnIndex,
    stickyOffsets = _React$useContext.stickyOffsets,
    flattenColumns = _React$useContext.flattenColumns;
  var lastIndex = index + colSpan - 1;
  var mergedColSpan = lastIndex + 1 === scrollColumnIndex ? colSpan + 1 : colSpan;
  var fixedInfo = getCellFixedInfo(index, index + mergedColSpan - 1, flattenColumns, stickyOffsets, direction);
  return /*#__PURE__*/react.createElement(es_Cell, (0,esm_extends/* default */.Z)({
    className: className,
    index: index,
    component: "td",
    prefixCls: prefixCls,
    record: null,
    dataIndex: null,
    align: align,
    colSpan: mergedColSpan,
    rowSpan: rowSpan,
    render: function render() {
      return children;
    }
  }, fixedInfo));
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/Footer/Row.js

var _excluded = ["children"];

function FooterRow(_ref) {
  var children = _ref.children,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  return /*#__PURE__*/react.createElement("tr", props, children);
}
;// CONCATENATED MODULE: ./node_modules/rc-table/es/Footer/Summary.js


/**
 * Syntactic sugar. Do not support HOC.
 */
function Summary(_ref) {
  var children = _ref.children;
  return children;
}
Summary.Row = FooterRow;
Summary.Cell = SummaryCell;
/* harmony default export */ var Footer_Summary = (Summary);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/Footer/index.js






function Footer(props) {
  if (false) {}
  var children = props.children,
    stickyOffsets = props.stickyOffsets,
    flattenColumns = props.flattenColumns;
  var prefixCls = useContext(context_TableContext, 'prefixCls');
  var lastColumnIndex = flattenColumns.length - 1;
  var scrollColumn = flattenColumns[lastColumnIndex];
  var summaryContext = react.useMemo(function () {
    return {
      stickyOffsets: stickyOffsets,
      flattenColumns: flattenColumns,
      scrollColumnIndex: scrollColumn !== null && scrollColumn !== void 0 && scrollColumn.scrollbar ? lastColumnIndex : null
    };
  }, [scrollColumn, flattenColumns, lastColumnIndex, stickyOffsets]);
  return /*#__PURE__*/react.createElement(Footer_SummaryContext.Provider, {
    value: summaryContext
  }, /*#__PURE__*/react.createElement("tfoot", {
    className: "".concat(prefixCls, "-summary")
  }, children));
}
/* harmony default export */ var es_Footer = (TableContext_responseImmutable(Footer));
var FooterComponents = Footer_Summary;
// EXTERNAL MODULE: ./node_modules/rc-resize-observer/es/index.js + 4 modules
var rc_resize_observer_es = __webpack_require__(49938);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/styleChecker.js
var styleChecker = __webpack_require__(40393);
// EXTERNAL MODULE: ./node_modules/rc-util/es/getScrollBarSize.js
var getScrollBarSize = __webpack_require__(59339);
// EXTERNAL MODULE: ./node_modules/rc-util/es/pickAttrs.js
var pickAttrs = __webpack_require__(75844);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/hooks/useFlattenRecords.js

// recursion (flat tree structure)
function fillRecords(list, record, indent, childrenColumnName, expandedKeys, getRowKey, index) {
  var key = getRowKey(record, index);
  list.push({
    record: record,
    indent: indent,
    index: index,
    rowKey: key
  });
  var expanded = expandedKeys === null || expandedKeys === void 0 ? void 0 : expandedKeys.has(key);
  if (record && Array.isArray(record[childrenColumnName]) && expanded) {
    // expanded state, flat record
    for (var i = 0; i < record[childrenColumnName].length; i += 1) {
      fillRecords(list, record[childrenColumnName][i], indent + 1, childrenColumnName, expandedKeys, getRowKey, i);
    }
  }
}
/**
 * flat tree data on expanded state
 *
 * @export
 * @template T
 * @param {*} data : table data
 * @param {string} childrenColumnName : 指定树形结构的列名
 * @param {Set<Key>} expandedKeys : 展开的行对应的keys
 * @param {GetRowKey<T>} getRowKey  : 获取当前rowKey的方法
 * @returns flattened data
 */
function useFlattenRecords(data, childrenColumnName, expandedKeys, getRowKey) {
  var arr = react.useMemo(function () {
    if (expandedKeys !== null && expandedKeys !== void 0 && expandedKeys.size) {
      var list = [];

      // collect flattened record
      for (var i = 0; i < (data === null || data === void 0 ? void 0 : data.length); i += 1) {
        var record = data[i];

        // using array.push or spread operator may cause "Maximum call stack size exceeded" exception if array size is big enough.
        fillRecords(list, record, 0, childrenColumnName, expandedKeys, getRowKey, i);
      }
      return list;
    }
    return data === null || data === void 0 ? void 0 : data.map(function (item, index) {
      return {
        record: item,
        indent: 0,
        index: index,
        rowKey: getRowKey(item, index)
      };
    });
  }, [data, childrenColumnName, expandedKeys, getRowKey]);
  return arr;
}
;// CONCATENATED MODULE: ./node_modules/rc-table/es/hooks/useRowInfo.js






function useRowInfo(record, rowKey, recordIndex, indent) {
  var context = useContext(context_TableContext, ['prefixCls', 'fixedInfoList', 'flattenColumns', 'expandableType', 'expandRowByClick', 'onTriggerExpand', 'rowClassName', 'expandedRowClassName', 'indentSize', 'expandIcon', 'expandedRowRender', 'expandIconColumnIndex', 'expandedKeys', 'childrenColumnName', 'rowExpandable', 'onRow']);
  var flattenColumns = context.flattenColumns,
    expandableType = context.expandableType,
    expandedKeys = context.expandedKeys,
    childrenColumnName = context.childrenColumnName,
    onTriggerExpand = context.onTriggerExpand,
    rowExpandable = context.rowExpandable,
    onRow = context.onRow,
    expandRowByClick = context.expandRowByClick,
    rowClassName = context.rowClassName;

  // ======================= Expandable =======================
  // Only when row is not expandable and `children` exist in record
  var nestExpandable = expandableType === 'nest';
  var rowSupportExpand = expandableType === 'row' && (!rowExpandable || rowExpandable(record));
  var mergedExpandable = rowSupportExpand || nestExpandable;
  var expanded = expandedKeys && expandedKeys.has(rowKey);
  var hasNestChildren = childrenColumnName && record && record[childrenColumnName];
  var onInternalTriggerExpand = (0,es/* useEvent */.zX)(onTriggerExpand);

  // ========================= onRow ==========================
  var rowProps = onRow === null || onRow === void 0 ? void 0 : onRow(record, recordIndex);
  var onRowClick = rowProps === null || rowProps === void 0 ? void 0 : rowProps.onClick;
  var onClick = function onClick(event) {
    if (expandRowByClick && mergedExpandable) {
      onTriggerExpand(record, event);
    }
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    onRowClick === null || onRowClick === void 0 || onRowClick.apply(void 0, [event].concat(args));
  };

  // ====================== RowClassName ======================
  var computeRowClassName;
  if (typeof rowClassName === 'string') {
    computeRowClassName = rowClassName;
  } else if (typeof rowClassName === 'function') {
    computeRowClassName = rowClassName(record, recordIndex, indent);
  }

  // ========================= Column =========================
  var columnsKey = getColumnsKey(flattenColumns);
  return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, context), {}, {
    columnsKey: columnsKey,
    nestExpandable: nestExpandable,
    expanded: expanded,
    hasNestChildren: hasNestChildren,
    record: record,
    onTriggerExpand: onInternalTriggerExpand,
    rowSupportExpand: rowSupportExpand,
    expandable: mergedExpandable,
    rowProps: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, rowProps), {}, {
      className: classnames_default()(computeRowClassName, rowProps === null || rowProps === void 0 ? void 0 : rowProps.className),
      onClick: onClick
    })
  });
}
;// CONCATENATED MODULE: ./node_modules/rc-table/es/Body/ExpandedRow.js





function ExpandedRow(props) {
  if (false) {}
  var prefixCls = props.prefixCls,
    children = props.children,
    Component = props.component,
    cellComponent = props.cellComponent,
    className = props.className,
    expanded = props.expanded,
    colSpan = props.colSpan,
    isEmpty = props.isEmpty,
    _props$stickyOffset = props.stickyOffset,
    stickyOffset = _props$stickyOffset === void 0 ? 0 : _props$stickyOffset;
  var _useContext = useContext(context_TableContext, ['scrollbarSize', 'fixHeader', 'fixColumn', 'componentWidth', 'horizonScroll']),
    scrollbarSize = _useContext.scrollbarSize,
    fixHeader = _useContext.fixHeader,
    fixColumn = _useContext.fixColumn,
    componentWidth = _useContext.componentWidth,
    horizonScroll = _useContext.horizonScroll;

  // Cache render node
  var contentNode = children;
  if (isEmpty ? horizonScroll && componentWidth : fixColumn) {
    contentNode = /*#__PURE__*/react.createElement("div", {
      style: {
        width: componentWidth - stickyOffset - (fixHeader && !isEmpty ? scrollbarSize : 0),
        position: 'sticky',
        left: stickyOffset,
        overflow: 'hidden'
      },
      className: "".concat(prefixCls, "-expanded-row-fixed")
    }, contentNode);
  }
  return /*#__PURE__*/react.createElement(Component, {
    className: className,
    style: {
      display: expanded ? null : 'none'
    }
  }, /*#__PURE__*/react.createElement(es_Cell, {
    component: cellComponent,
    prefixCls: prefixCls,
    colSpan: colSpan
  }, contentNode));
}
/* harmony default export */ var Body_ExpandedRow = (ExpandedRow);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/utils/expandUtil.js



function renderExpandIcon(_ref) {
  var prefixCls = _ref.prefixCls,
    record = _ref.record,
    onExpand = _ref.onExpand,
    expanded = _ref.expanded,
    expandable = _ref.expandable;
  var expandClassName = "".concat(prefixCls, "-row-expand-icon");
  if (!expandable) {
    return /*#__PURE__*/react.createElement("span", {
      className: classnames_default()(expandClassName, "".concat(prefixCls, "-row-spaced"))
    });
  }
  var onClick = function onClick(event) {
    onExpand(record, event);
    event.stopPropagation();
  };
  return /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(expandClassName, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-row-expanded"), expanded), "".concat(prefixCls, "-row-collapsed"), !expanded)),
    onClick: onClick
  });
}
function findAllChildrenKeys(data, getRowKey, childrenColumnName) {
  var keys = [];
  function dig(list) {
    (list || []).forEach(function (item, index) {
      keys.push(getRowKey(item, index));
      dig(item[childrenColumnName]);
    });
  }
  dig(data);
  return keys;
}
function computedExpandedClassName(cls, record, index, indent) {
  if (typeof cls === 'string') {
    return cls;
  }
  if (typeof cls === 'function') {
    return cls(record, index, indent);
  }
  return '';
}
;// CONCATENATED MODULE: ./node_modules/rc-table/es/Body/BodyRow.js











// ==================================================================================
// ==                                 getCellProps                                 ==
// ==================================================================================
function getCellProps(rowInfo, column, colIndex, indent, index) {
  var _column$onCell;
  var rowKeys = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var expandedRowOffset = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var record = rowInfo.record,
    prefixCls = rowInfo.prefixCls,
    columnsKey = rowInfo.columnsKey,
    fixedInfoList = rowInfo.fixedInfoList,
    expandIconColumnIndex = rowInfo.expandIconColumnIndex,
    nestExpandable = rowInfo.nestExpandable,
    indentSize = rowInfo.indentSize,
    expandIcon = rowInfo.expandIcon,
    expanded = rowInfo.expanded,
    hasNestChildren = rowInfo.hasNestChildren,
    onTriggerExpand = rowInfo.onTriggerExpand,
    expandable = rowInfo.expandable,
    expandedKeys = rowInfo.expandedKeys;
  var key = columnsKey[colIndex];
  var fixedInfo = fixedInfoList[colIndex];

  // ============= Used for nest expandable =============
  var appendCellNode;
  if (colIndex === (expandIconColumnIndex || 0) && nestExpandable) {
    appendCellNode = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("span", {
      style: {
        paddingLeft: "".concat(indentSize * indent, "px")
      },
      className: "".concat(prefixCls, "-row-indent indent-level-").concat(indent)
    }), expandIcon({
      prefixCls: prefixCls,
      expanded: expanded,
      expandable: hasNestChildren,
      record: record,
      onExpand: onTriggerExpand
    }));
  }
  var additionalCellProps = ((_column$onCell = column.onCell) === null || _column$onCell === void 0 ? void 0 : _column$onCell.call(column, record, index)) || {};

  // Expandable row has offset
  if (expandedRowOffset) {
    var _additionalCellProps$ = additionalCellProps.rowSpan,
      rowSpan = _additionalCellProps$ === void 0 ? 1 : _additionalCellProps$;

    // For expandable row with rowSpan,
    // We should increase the rowSpan if the row is expanded
    if (expandable && rowSpan && colIndex < expandedRowOffset) {
      var currentRowSpan = rowSpan;
      for (var i = index; i < index + rowSpan; i += 1) {
        var rowKey = rowKeys[i];
        if (expandedKeys.has(rowKey)) {
          currentRowSpan += 1;
        }
      }
      additionalCellProps.rowSpan = currentRowSpan;
    }
  }
  return {
    key: key,
    fixedInfo: fixedInfo,
    appendCellNode: appendCellNode,
    additionalCellProps: additionalCellProps
  };
}

// ==================================================================================
// ==                                 getCellProps                                 ==
// ==================================================================================
function BodyRow(props) {
  if (false) {}
  var className = props.className,
    style = props.style,
    record = props.record,
    index = props.index,
    renderIndex = props.renderIndex,
    rowKey = props.rowKey,
    rowKeys = props.rowKeys,
    _props$indent = props.indent,
    indent = _props$indent === void 0 ? 0 : _props$indent,
    RowComponent = props.rowComponent,
    cellComponent = props.cellComponent,
    scopeCellComponent = props.scopeCellComponent,
    expandedRowInfo = props.expandedRowInfo;
  var rowInfo = useRowInfo(record, rowKey, index, indent);
  var prefixCls = rowInfo.prefixCls,
    flattenColumns = rowInfo.flattenColumns,
    expandedRowClassName = rowInfo.expandedRowClassName,
    expandedRowRender = rowInfo.expandedRowRender,
    rowProps = rowInfo.rowProps,
    expanded = rowInfo.expanded,
    rowSupportExpand = rowInfo.rowSupportExpand;

  // Force render expand row if expanded before
  var expandedRef = react.useRef(false);
  expandedRef.current || (expandedRef.current = expanded);
  if (false) {}

  // 若没有 expandedRowRender 参数, 将使用 baseRowNode 渲染 Children
  // 此时如果 level > 1 则说明是 expandedRow, 一样需要附加 computedExpandedRowClassName
  var expandedClsName = computedExpandedClassName(expandedRowClassName, record, index, indent);

  // ======================== Base tr row ========================
  var baseRowNode = /*#__PURE__*/react.createElement(RowComponent, (0,esm_extends/* default */.Z)({}, rowProps, {
    "data-row-key": rowKey,
    className: classnames_default()(className, "".concat(prefixCls, "-row"), "".concat(prefixCls, "-row-level-").concat(indent), rowProps === null || rowProps === void 0 ? void 0 : rowProps.className, (0,defineProperty/* default */.Z)({}, expandedClsName, indent >= 1)),
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, style), rowProps === null || rowProps === void 0 ? void 0 : rowProps.style)
  }), flattenColumns.map(function (column, colIndex) {
    var render = column.render,
      dataIndex = column.dataIndex,
      columnClassName = column.className;
    var _getCellProps = getCellProps(rowInfo, column, colIndex, indent, index, rowKeys, expandedRowInfo === null || expandedRowInfo === void 0 ? void 0 : expandedRowInfo.offset),
      key = _getCellProps.key,
      fixedInfo = _getCellProps.fixedInfo,
      appendCellNode = _getCellProps.appendCellNode,
      additionalCellProps = _getCellProps.additionalCellProps;
    return /*#__PURE__*/react.createElement(es_Cell, (0,esm_extends/* default */.Z)({
      className: columnClassName,
      ellipsis: column.ellipsis,
      align: column.align,
      scope: column.rowScope,
      component: column.rowScope ? scopeCellComponent : cellComponent,
      prefixCls: prefixCls,
      key: key,
      record: record,
      index: index,
      renderIndex: renderIndex,
      dataIndex: dataIndex,
      render: render,
      shouldCellUpdate: column.shouldCellUpdate
    }, fixedInfo, {
      appendNode: appendCellNode,
      additionalProps: additionalCellProps
    }));
  }));

  // ======================== Expand Row =========================
  var expandRowNode;
  if (rowSupportExpand && (expandedRef.current || expanded)) {
    var expandContent = expandedRowRender(record, index, indent + 1, expanded);
    expandRowNode = /*#__PURE__*/react.createElement(Body_ExpandedRow, {
      expanded: expanded,
      className: classnames_default()("".concat(prefixCls, "-expanded-row"), "".concat(prefixCls, "-expanded-row-level-").concat(indent + 1), expandedClsName),
      prefixCls: prefixCls,
      component: RowComponent,
      cellComponent: cellComponent,
      colSpan: expandedRowInfo ? expandedRowInfo.colSpan : flattenColumns.length,
      stickyOffset: expandedRowInfo === null || expandedRowInfo === void 0 ? void 0 : expandedRowInfo.sticky,
      isEmpty: false
    }, expandContent);
  }
  return /*#__PURE__*/react.createElement(react.Fragment, null, baseRowNode, expandRowNode);
}
if (false) {}
/* harmony default export */ var Body_BodyRow = (TableContext_responseImmutable(BodyRow));
;// CONCATENATED MODULE: ./node_modules/rc-table/es/Body/MeasureCell.js



function MeasureCell(_ref) {
  var columnKey = _ref.columnKey,
    onColumnResize = _ref.onColumnResize;
  var cellRef = react.useRef();
  (0,useLayoutEffect/* default */.Z)(function () {
    if (cellRef.current) {
      onColumnResize(columnKey, cellRef.current.offsetWidth);
    }
  }, []);
  return /*#__PURE__*/react.createElement(rc_resize_observer_es/* default */.Z, {
    data: columnKey
  }, /*#__PURE__*/react.createElement("td", {
    ref: cellRef,
    style: {
      padding: 0,
      border: 0,
      height: 0
    }
  }, /*#__PURE__*/react.createElement("div", {
    style: {
      height: 0,
      overflow: 'hidden'
    }
  }, "\xA0")));
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/isVisible.js
var isVisible = __webpack_require__(29504);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/Body/MeasureRow.js




function MeasureRow(_ref) {
  var prefixCls = _ref.prefixCls,
    columnsKey = _ref.columnsKey,
    onColumnResize = _ref.onColumnResize;
  var ref = react.useRef(null);
  return /*#__PURE__*/react.createElement("tr", {
    "aria-hidden": "true",
    className: "".concat(prefixCls, "-measure-row"),
    style: {
      height: 0,
      fontSize: 0
    },
    ref: ref
  }, /*#__PURE__*/react.createElement(rc_resize_observer_es/* default.Collection */.Z.Collection, {
    onBatchResize: function onBatchResize(infoList) {
      if ((0,isVisible/* default */.Z)(ref.current)) {
        infoList.forEach(function (_ref2) {
          var columnKey = _ref2.data,
            size = _ref2.size;
          onColumnResize(columnKey, size.offsetWidth);
        });
      }
    }
  }, columnsKey.map(function (columnKey) {
    return /*#__PURE__*/react.createElement(MeasureCell, {
      key: columnKey,
      columnKey: columnKey,
      onColumnResize: onColumnResize
    });
  })));
}
;// CONCATENATED MODULE: ./node_modules/rc-table/es/Body/index.js










function Body(props) {
  if (false) {}
  var data = props.data,
    measureColumnWidth = props.measureColumnWidth;
  var _useContext = useContext(context_TableContext, ['prefixCls', 'getComponent', 'onColumnResize', 'flattenColumns', 'getRowKey', 'expandedKeys', 'childrenColumnName', 'emptyNode', 'expandedRowOffset', 'fixedInfoList', 'colWidths']),
    prefixCls = _useContext.prefixCls,
    getComponent = _useContext.getComponent,
    onColumnResize = _useContext.onColumnResize,
    flattenColumns = _useContext.flattenColumns,
    getRowKey = _useContext.getRowKey,
    expandedKeys = _useContext.expandedKeys,
    childrenColumnName = _useContext.childrenColumnName,
    emptyNode = _useContext.emptyNode,
    _useContext$expandedR = _useContext.expandedRowOffset,
    expandedRowOffset = _useContext$expandedR === void 0 ? 0 : _useContext$expandedR,
    colWidths = _useContext.colWidths;
  var flattenData = useFlattenRecords(data, childrenColumnName, expandedKeys, getRowKey);
  var rowKeys = react.useMemo(function () {
    return flattenData.map(function (item) {
      return item.rowKey;
    });
  }, [flattenData]);

  // =================== Performance ====================
  var perfRef = react.useRef({
    renderWithProps: false
  });

  // ===================== Expanded =====================
  // `expandedRowOffset` data is same for all the rows.
  // Let's calc on Body side to save performance.
  var expandedRowInfo = react.useMemo(function () {
    var expandedColSpan = flattenColumns.length - expandedRowOffset;
    var expandedStickyStart = 0;
    for (var i = 0; i < expandedRowOffset; i += 1) {
      expandedStickyStart += colWidths[i] || 0;
    }
    return {
      offset: expandedRowOffset,
      colSpan: expandedColSpan,
      sticky: expandedStickyStart
    };
  }, [flattenColumns.length, expandedRowOffset, colWidths]);

  // ====================== Render ======================
  var WrapperComponent = getComponent(['body', 'wrapper'], 'tbody');
  var trComponent = getComponent(['body', 'row'], 'tr');
  var tdComponent = getComponent(['body', 'cell'], 'td');
  var thComponent = getComponent(['body', 'cell'], 'th');
  var rows;
  if (data.length) {
    rows = flattenData.map(function (item, idx) {
      var record = item.record,
        indent = item.indent,
        renderIndex = item.index,
        rowKey = item.rowKey;
      return /*#__PURE__*/react.createElement(Body_BodyRow, {
        key: rowKey,
        rowKey: rowKey,
        rowKeys: rowKeys,
        record: record,
        index: idx,
        renderIndex: renderIndex,
        rowComponent: trComponent,
        cellComponent: tdComponent,
        scopeCellComponent: thComponent,
        indent: indent
        // Expanded row info
        ,

        expandedRowInfo: expandedRowInfo
      });
    });
  } else {
    rows = /*#__PURE__*/react.createElement(Body_ExpandedRow, {
      expanded: true,
      className: "".concat(prefixCls, "-placeholder"),
      prefixCls: prefixCls,
      component: trComponent,
      cellComponent: tdComponent,
      colSpan: flattenColumns.length,
      isEmpty: true
    }, emptyNode);
  }
  var columnsKey = getColumnsKey(flattenColumns);
  return /*#__PURE__*/react.createElement(context_PerfContext.Provider, {
    value: perfRef.current
  }, /*#__PURE__*/react.createElement(WrapperComponent, {
    className: "".concat(prefixCls, "-tbody")
  }, measureColumnWidth && /*#__PURE__*/react.createElement(MeasureRow, {
    prefixCls: prefixCls,
    columnsKey: columnsKey,
    onColumnResize: onColumnResize
  }), rows));
}
if (false) {}
/* harmony default export */ var es_Body = (TableContext_responseImmutable(Body));
// EXTERNAL MODULE: ./node_modules/rc-table/es/utils/legacyUtil.js
var legacyUtil = __webpack_require__(17877);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/ColGroup.js


var ColGroup_excluded = ["columnType"];




function ColGroup(_ref) {
  var colWidths = _ref.colWidths,
    columns = _ref.columns,
    columCount = _ref.columCount;
  var _useContext = useContext(context_TableContext, ['tableLayout']),
    tableLayout = _useContext.tableLayout;
  var cols = [];
  var len = columCount || columns.length;

  // Only insert col with width & additional props
  // Skip if rest col do not have any useful info
  var mustInsert = false;
  for (var i = len - 1; i >= 0; i -= 1) {
    var width = colWidths[i];
    var column = columns && columns[i];
    var additionalProps = void 0;
    var minWidth = void 0;
    if (column) {
      additionalProps = column[legacyUtil/* INTERNAL_COL_DEFINE */.v];

      // fixed will cause layout problems
      if (tableLayout === 'auto') {
        minWidth = column.minWidth;
      }
    }
    if (width || minWidth || additionalProps || mustInsert) {
      var _ref2 = additionalProps || {},
        columnType = _ref2.columnType,
        restAdditionalProps = (0,objectWithoutProperties/* default */.Z)(_ref2, ColGroup_excluded);
      cols.unshift(/*#__PURE__*/react.createElement("col", (0,esm_extends/* default */.Z)({
        key: i,
        style: {
          width: width,
          minWidth: minWidth
        }
      }, restAdditionalProps)));
      mustInsert = true;
    }
  }
  return /*#__PURE__*/react.createElement("colgroup", null, cols);
}
/* harmony default export */ var es_ColGroup = (ColGroup);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/FixedHolder/index.js




var FixedHolder_excluded = ["className", "noData", "columns", "flattenColumns", "colWidths", "columCount", "stickyOffsets", "direction", "fixHeader", "stickyTopOffset", "stickyBottomOffset", "stickyClassName", "onScroll", "maxContentScroll", "children"];








function useColumnWidth(colWidths, columCount) {
  return (0,react.useMemo)(function () {
    var cloneColumns = [];
    for (var i = 0; i < columCount; i += 1) {
      var val = colWidths[i];
      if (val !== undefined) {
        cloneColumns[i] = val;
      } else {
        return null;
      }
    }
    return cloneColumns;
  }, [colWidths.join('_'), columCount]);
}
var FixedHolder = /*#__PURE__*/react.forwardRef(function (props, ref) {
  if (false) {}
  var className = props.className,
    noData = props.noData,
    columns = props.columns,
    flattenColumns = props.flattenColumns,
    colWidths = props.colWidths,
    columCount = props.columCount,
    stickyOffsets = props.stickyOffsets,
    direction = props.direction,
    fixHeader = props.fixHeader,
    stickyTopOffset = props.stickyTopOffset,
    stickyBottomOffset = props.stickyBottomOffset,
    stickyClassName = props.stickyClassName,
    onScroll = props.onScroll,
    maxContentScroll = props.maxContentScroll,
    children = props.children,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, FixedHolder_excluded);
  var _useContext = useContext(context_TableContext, ['prefixCls', 'scrollbarSize', 'isSticky', 'getComponent']),
    prefixCls = _useContext.prefixCls,
    scrollbarSize = _useContext.scrollbarSize,
    isSticky = _useContext.isSticky,
    getComponent = _useContext.getComponent;
  var TableComponent = getComponent(['header', 'table'], 'table');
  var combinationScrollBarSize = isSticky && !fixHeader ? 0 : scrollbarSize;

  // Pass wheel to scroll event
  var scrollRef = react.useRef(null);
  var setScrollRef = react.useCallback(function (element) {
    (0,es_ref/* fillRef */.mH)(ref, element);
    (0,es_ref/* fillRef */.mH)(scrollRef, element);
  }, []);
  react.useEffect(function () {
    function onWheel(e) {
      var _ref = e,
        currentTarget = _ref.currentTarget,
        deltaX = _ref.deltaX;
      if (deltaX) {
        onScroll({
          currentTarget: currentTarget,
          scrollLeft: currentTarget.scrollLeft + deltaX
        });
        e.preventDefault();
      }
    }
    var scrollEle = scrollRef.current;
    scrollEle === null || scrollEle === void 0 || scrollEle.addEventListener('wheel', onWheel, {
      passive: false
    });
    return function () {
      scrollEle === null || scrollEle === void 0 || scrollEle.removeEventListener('wheel', onWheel);
    };
  }, []);

  // Check if all flattenColumns has width
  var allFlattenColumnsWithWidth = react.useMemo(function () {
    return flattenColumns.every(function (column) {
      return column.width;
    });
  }, [flattenColumns]);

  // Add scrollbar column
  var lastColumn = flattenColumns[flattenColumns.length - 1];
  var ScrollBarColumn = {
    fixed: lastColumn ? lastColumn.fixed : null,
    scrollbar: true,
    onHeaderCell: function onHeaderCell() {
      return {
        className: "".concat(prefixCls, "-cell-scrollbar")
      };
    }
  };
  var columnsWithScrollbar = (0,react.useMemo)(function () {
    return combinationScrollBarSize ? [].concat((0,toConsumableArray/* default */.Z)(columns), [ScrollBarColumn]) : columns;
  }, [combinationScrollBarSize, columns]);
  var flattenColumnsWithScrollbar = (0,react.useMemo)(function () {
    return combinationScrollBarSize ? [].concat((0,toConsumableArray/* default */.Z)(flattenColumns), [ScrollBarColumn]) : flattenColumns;
  }, [combinationScrollBarSize, flattenColumns]);

  // Calculate the sticky offsets
  var headerStickyOffsets = (0,react.useMemo)(function () {
    var right = stickyOffsets.right,
      left = stickyOffsets.left;
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, stickyOffsets), {}, {
      left: direction === 'rtl' ? [].concat((0,toConsumableArray/* default */.Z)(left.map(function (width) {
        return width + combinationScrollBarSize;
      })), [0]) : left,
      right: direction === 'rtl' ? right : [].concat((0,toConsumableArray/* default */.Z)(right.map(function (width) {
        return width + combinationScrollBarSize;
      })), [0]),
      isSticky: isSticky
    });
  }, [combinationScrollBarSize, stickyOffsets, isSticky]);
  var mergedColumnWidth = useColumnWidth(colWidths, columCount);
  return /*#__PURE__*/react.createElement("div", {
    style: (0,objectSpread2/* default */.Z)({
      overflow: 'hidden'
    }, isSticky ? {
      top: stickyTopOffset,
      bottom: stickyBottomOffset
    } : {}),
    ref: setScrollRef,
    className: classnames_default()(className, (0,defineProperty/* default */.Z)({}, stickyClassName, !!stickyClassName))
  }, /*#__PURE__*/react.createElement(TableComponent, {
    style: {
      tableLayout: 'fixed',
      visibility: noData || mergedColumnWidth ? null : 'hidden'
    }
  }, (!noData || !maxContentScroll || allFlattenColumnsWithWidth) && /*#__PURE__*/react.createElement(es_ColGroup, {
    colWidths: mergedColumnWidth ? [].concat((0,toConsumableArray/* default */.Z)(mergedColumnWidth), [combinationScrollBarSize]) : [],
    columCount: columCount + 1,
    columns: flattenColumnsWithScrollbar
  }), children((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, restProps), {}, {
    stickyOffsets: headerStickyOffsets,
    columns: columnsWithScrollbar,
    flattenColumns: flattenColumnsWithScrollbar
  }))));
});
if (false) {}

/** Return a table in div as fixed element which contains sticky info */
// export default responseImmutable(FixedHolder);
/* harmony default export */ var es_FixedHolder = (/*#__PURE__*/react.memo(FixedHolder));
;// CONCATENATED MODULE: ./node_modules/rc-table/es/Header/HeaderRow.js







var HeaderRow = function HeaderRow(props) {
  var cells = props.cells,
    stickyOffsets = props.stickyOffsets,
    flattenColumns = props.flattenColumns,
    RowComponent = props.rowComponent,
    CellComponent = props.cellComponent,
    onHeaderRow = props.onHeaderRow,
    index = props.index;
  var _useContext = useContext(context_TableContext, ['prefixCls', 'direction']),
    prefixCls = _useContext.prefixCls,
    direction = _useContext.direction;
  var rowProps;
  if (onHeaderRow) {
    rowProps = onHeaderRow(cells.map(function (cell) {
      return cell.column;
    }), index);
  }
  var columnsKey = getColumnsKey(cells.map(function (cell) {
    return cell.column;
  }));
  return /*#__PURE__*/react.createElement(RowComponent, rowProps, cells.map(function (cell, cellIndex) {
    var column = cell.column;
    var fixedInfo = getCellFixedInfo(cell.colStart, cell.colEnd, flattenColumns, stickyOffsets, direction);
    var additionalProps;
    if (column && column.onHeaderCell) {
      additionalProps = cell.column.onHeaderCell(column);
    }
    return /*#__PURE__*/react.createElement(es_Cell, (0,esm_extends/* default */.Z)({}, cell, {
      scope: column.title ? cell.colSpan > 1 ? 'colgroup' : 'col' : null,
      ellipsis: column.ellipsis,
      align: column.align,
      component: CellComponent,
      prefixCls: prefixCls,
      key: columnsKey[cellIndex]
    }, fixedInfo, {
      additionalProps: additionalProps,
      rowType: "header"
    }));
  }));
};
if (false) {}
/* harmony default export */ var Header_HeaderRow = (HeaderRow);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/Header/Header.js





function parseHeaderRows(rootColumns) {
  var rows = [];
  function fillRowCells(columns, colIndex) {
    var rowIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    // Init rows
    rows[rowIndex] = rows[rowIndex] || [];
    var currentColIndex = colIndex;
    var colSpans = columns.filter(Boolean).map(function (column) {
      var cell = {
        key: column.key,
        className: column.className || '',
        children: column.title,
        column: column,
        colStart: currentColIndex
      };
      var colSpan = 1;
      var subColumns = column.children;
      if (subColumns && subColumns.length > 0) {
        colSpan = fillRowCells(subColumns, currentColIndex, rowIndex + 1).reduce(function (total, count) {
          return total + count;
        }, 0);
        cell.hasSubColumns = true;
      }
      if ('colSpan' in column) {
        colSpan = column.colSpan;
      }
      if ('rowSpan' in column) {
        cell.rowSpan = column.rowSpan;
      }
      cell.colSpan = colSpan;
      cell.colEnd = cell.colStart + colSpan - 1;
      rows[rowIndex].push(cell);
      currentColIndex += colSpan;
      return colSpan;
    });
    return colSpans;
  }

  // Generate `rows` cell data
  fillRowCells(rootColumns, 0);

  // Handle `rowSpan`
  var rowCount = rows.length;
  var _loop = function _loop(rowIndex) {
    rows[rowIndex].forEach(function (cell) {
      if (!('rowSpan' in cell) && !cell.hasSubColumns) {
        // eslint-disable-next-line no-param-reassign
        cell.rowSpan = rowCount - rowIndex;
      }
    });
  };
  for (var rowIndex = 0; rowIndex < rowCount; rowIndex += 1) {
    _loop(rowIndex);
  }
  return rows;
}
var Header = function Header(props) {
  if (false) {}
  var stickyOffsets = props.stickyOffsets,
    columns = props.columns,
    flattenColumns = props.flattenColumns,
    onHeaderRow = props.onHeaderRow;
  var _useContext = useContext(context_TableContext, ['prefixCls', 'getComponent']),
    prefixCls = _useContext.prefixCls,
    getComponent = _useContext.getComponent;
  var rows = react.useMemo(function () {
    return parseHeaderRows(columns);
  }, [columns]);
  var WrapperComponent = getComponent(['header', 'wrapper'], 'thead');
  var trComponent = getComponent(['header', 'row'], 'tr');
  var thComponent = getComponent(['header', 'cell'], 'th');
  return /*#__PURE__*/react.createElement(WrapperComponent, {
    className: "".concat(prefixCls, "-thead")
  }, rows.map(function (row, rowIndex) {
    var rowNode = /*#__PURE__*/react.createElement(Header_HeaderRow, {
      key: rowIndex,
      flattenColumns: flattenColumns,
      cells: row,
      stickyOffsets: stickyOffsets,
      rowComponent: trComponent,
      cellComponent: thComponent,
      onHeaderRow: onHeaderRow,
      index: rowIndex
    });
    return rowNode;
  }));
};
/* harmony default export */ var Header_Header = (TableContext_responseImmutable(Header));
// EXTERNAL MODULE: ./node_modules/rc-table/es/hooks/useColumns/index.js + 1 modules
var useColumns = __webpack_require__(51386);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/hooks/useExpand.js








function useExpand(props, mergedData, getRowKey) {
  var expandableConfig = (0,legacyUtil/* getExpandableProps */.g)(props);
  var expandIcon = expandableConfig.expandIcon,
    expandedRowKeys = expandableConfig.expandedRowKeys,
    defaultExpandedRowKeys = expandableConfig.defaultExpandedRowKeys,
    defaultExpandAllRows = expandableConfig.defaultExpandAllRows,
    expandedRowRender = expandableConfig.expandedRowRender,
    onExpand = expandableConfig.onExpand,
    onExpandedRowsChange = expandableConfig.onExpandedRowsChange,
    childrenColumnName = expandableConfig.childrenColumnName;
  var mergedExpandIcon = expandIcon || renderExpandIcon;
  var mergedChildrenColumnName = childrenColumnName || 'children';
  var expandableType = react.useMemo(function () {
    if (expandedRowRender) {
      return 'row';
    }
    /* eslint-disable no-underscore-dangle */
    /**
     * Fix https://github.com/ant-design/ant-design/issues/21154
     * This is a workaround to not to break current behavior.
     * We can remove follow code after final release.
     *
     * To other developer:
     *  Do not use `__PARENT_RENDER_ICON__` in prod since we will remove this when refactor
     */
    if (props.expandable && props.internalHooks === constant/* INTERNAL_HOOKS */.R && props.expandable.__PARENT_RENDER_ICON__ || mergedData.some(function (record) {
      return record && (0,esm_typeof/* default */.Z)(record) === 'object' && record[mergedChildrenColumnName];
    })) {
      return 'nest';
    }
    /* eslint-enable */
    return false;
  }, [!!expandedRowRender, mergedData]);
  var _React$useState = react.useState(function () {
      if (defaultExpandedRowKeys) {
        return defaultExpandedRowKeys;
      }
      if (defaultExpandAllRows) {
        return findAllChildrenKeys(mergedData, getRowKey, mergedChildrenColumnName);
      }
      return [];
    }),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    innerExpandedKeys = _React$useState2[0],
    setInnerExpandedKeys = _React$useState2[1];
  var mergedExpandedKeys = react.useMemo(function () {
    return new Set(expandedRowKeys || innerExpandedKeys || []);
  }, [expandedRowKeys, innerExpandedKeys]);
  var onTriggerExpand = react.useCallback(function (record) {
    var key = getRowKey(record, mergedData.indexOf(record));
    var newExpandedKeys;
    var hasKey = mergedExpandedKeys.has(key);
    if (hasKey) {
      mergedExpandedKeys.delete(key);
      newExpandedKeys = (0,toConsumableArray/* default */.Z)(mergedExpandedKeys);
    } else {
      newExpandedKeys = [].concat((0,toConsumableArray/* default */.Z)(mergedExpandedKeys), [key]);
    }
    setInnerExpandedKeys(newExpandedKeys);
    if (onExpand) {
      onExpand(!hasKey, record);
    }
    if (onExpandedRowsChange) {
      onExpandedRowsChange(newExpandedKeys);
    }
  }, [getRowKey, mergedExpandedKeys, mergedData, onExpand, onExpandedRowsChange]);

  // Warning if use `expandedRowRender` and nest children in the same time
  if (false) {}
  return [expandableConfig, expandableType, mergedExpandedKeys, mergedExpandIcon, mergedChildrenColumnName, onTriggerExpand];
}
;// CONCATENATED MODULE: ./node_modules/rc-table/es/hooks/useFixedInfo.js



function useFixedInfo(flattenColumns, stickyOffsets, direction) {
  var fixedInfoList = flattenColumns.map(function (_, colIndex) {
    return getCellFixedInfo(colIndex, colIndex, flattenColumns, stickyOffsets, direction);
  });
  return (0,useMemo/* default */.Z)(function () {
    return fixedInfoList;
  }, [fixedInfoList], function (prev, next) {
    return !(0,isEqual/* default */.Z)(prev, next);
  });
}
;// CONCATENATED MODULE: ./node_modules/rc-table/es/hooks/useFrame.js


/**
 * Execute code before next frame but async
 */
function useLayoutState(defaultState) {
  var stateRef = (0,react.useRef)(defaultState);
  var _useState = (0,react.useState)({}),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    forceUpdate = _useState2[1];
  var lastPromiseRef = (0,react.useRef)(null);
  var updateBatchRef = (0,react.useRef)([]);
  function setFrameState(updater) {
    updateBatchRef.current.push(updater);
    var promise = Promise.resolve();
    lastPromiseRef.current = promise;
    promise.then(function () {
      if (lastPromiseRef.current === promise) {
        var prevBatch = updateBatchRef.current;
        var prevState = stateRef.current;
        updateBatchRef.current = [];
        prevBatch.forEach(function (batchUpdater) {
          stateRef.current = batchUpdater(stateRef.current);
        });
        lastPromiseRef.current = null;
        if (prevState !== stateRef.current) {
          forceUpdate({});
        }
      }
    });
  }
  (0,react.useEffect)(function () {
    return function () {
      lastPromiseRef.current = null;
    };
  }, []);
  return [stateRef.current, setFrameState];
}

/** Lock frame, when frame pass reset the lock. */
function useTimeoutLock(defaultState) {
  var frameRef = (0,react.useRef)(defaultState || null);
  var timeoutRef = (0,react.useRef)();
  function cleanUp() {
    window.clearTimeout(timeoutRef.current);
  }
  function setState(newState) {
    frameRef.current = newState;
    cleanUp();
    timeoutRef.current = window.setTimeout(function () {
      frameRef.current = null;
      timeoutRef.current = undefined;
    }, 100);
  }
  function getState() {
    return frameRef.current;
  }
  (0,react.useEffect)(function () {
    return cleanUp;
  }, []);
  return [setState, getState];
}
;// CONCATENATED MODULE: ./node_modules/rc-table/es/hooks/useHover.js


function useHover() {
  var _React$useState = react.useState(-1),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    startRow = _React$useState2[0],
    setStartRow = _React$useState2[1];
  var _React$useState3 = react.useState(-1),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    endRow = _React$useState4[0],
    setEndRow = _React$useState4[1];
  var onHover = react.useCallback(function (start, end) {
    setStartRow(start);
    setEndRow(end);
  }, []);
  return [startRow, endRow, onHover];
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/canUseDom.js
var canUseDom = __webpack_require__(55304);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/hooks/useSticky.js



// fix ssr render
var defaultContainer = (0,canUseDom/* default */.Z)() ? window : null;

/** Sticky header hooks */
function useSticky(sticky, prefixCls) {
  var _ref = (0,esm_typeof/* default */.Z)(sticky) === 'object' ? sticky : {},
    _ref$offsetHeader = _ref.offsetHeader,
    offsetHeader = _ref$offsetHeader === void 0 ? 0 : _ref$offsetHeader,
    _ref$offsetSummary = _ref.offsetSummary,
    offsetSummary = _ref$offsetSummary === void 0 ? 0 : _ref$offsetSummary,
    _ref$offsetScroll = _ref.offsetScroll,
    offsetScroll = _ref$offsetScroll === void 0 ? 0 : _ref$offsetScroll,
    _ref$getContainer = _ref.getContainer,
    getContainer = _ref$getContainer === void 0 ? function () {
      return defaultContainer;
    } : _ref$getContainer;
  var container = getContainer() || defaultContainer;
  var isSticky = !!sticky;
  return react.useMemo(function () {
    return {
      isSticky: isSticky,
      stickyClassName: isSticky ? "".concat(prefixCls, "-sticky-holder") : '',
      offsetHeader: offsetHeader,
      offsetSummary: offsetSummary,
      offsetScroll: offsetScroll,
      container: container
    };
  }, [isSticky, offsetScroll, offsetHeader, offsetSummary, prefixCls, container]);
}
;// CONCATENATED MODULE: ./node_modules/rc-table/es/hooks/useStickyOffsets.js

/**
 * Get sticky column offset width
 */
function useStickyOffsets(colWidths, flattenColumns, direction) {
  var stickyOffsets = (0,react.useMemo)(function () {
    var columnCount = flattenColumns.length;
    var getOffsets = function getOffsets(startIndex, endIndex, offset) {
      var offsets = [];
      var total = 0;
      for (var i = startIndex; i !== endIndex; i += offset) {
        offsets.push(total);
        if (flattenColumns[i].fixed) {
          total += colWidths[i] || 0;
        }
      }
      return offsets;
    };
    var startOffsets = getOffsets(0, columnCount, 1);
    var endOffsets = getOffsets(columnCount - 1, -1, -1).reverse();
    return direction === 'rtl' ? {
      left: endOffsets,
      right: startOffsets
    } : {
      left: startOffsets,
      right: endOffsets
    };
  }, [colWidths, flattenColumns, direction]);
  return stickyOffsets;
}
/* harmony default export */ var hooks_useStickyOffsets = (useStickyOffsets);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/Panel/index.js

function Panel(_ref) {
  var className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/react.createElement("div", {
    className: className
  }, children);
}
/* harmony default export */ var es_Panel = (Panel);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/addEventListener.js
var addEventListener = __webpack_require__(35092);
// EXTERNAL MODULE: ./node_modules/rc-util/es/raf.js
var raf = __webpack_require__(13157);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/findDOMNode.js
var findDOMNode = __webpack_require__(33970);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/utils/offsetUtil.js


// Copy from `rc-util/Dom/css.js`
function getOffset(node) {
  var element = (0,findDOMNode/* getDOM */.bn)(node);
  var box = element.getBoundingClientRect();
  var docElem = document.documentElement;

  // < ie8 not support win.pageXOffset, use docElem.scrollLeft instead
  return {
    left: box.left + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
    top: box.top + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
  };
}
;// CONCATENATED MODULE: ./node_modules/rc-table/es/stickyScrollBar.js













var StickyScrollBar = function StickyScrollBar(_ref, ref) {
  var _scrollBodyRef$curren, _scrollBodyRef$curren2;
  var scrollBodyRef = _ref.scrollBodyRef,
    onScroll = _ref.onScroll,
    offsetScroll = _ref.offsetScroll,
    container = _ref.container,
    direction = _ref.direction;
  var prefixCls = useContext(context_TableContext, 'prefixCls');
  var bodyScrollWidth = ((_scrollBodyRef$curren = scrollBodyRef.current) === null || _scrollBodyRef$curren === void 0 ? void 0 : _scrollBodyRef$curren.scrollWidth) || 0;
  var bodyWidth = ((_scrollBodyRef$curren2 = scrollBodyRef.current) === null || _scrollBodyRef$curren2 === void 0 ? void 0 : _scrollBodyRef$curren2.clientWidth) || 0;
  var scrollBarWidth = bodyScrollWidth && bodyWidth * (bodyWidth / bodyScrollWidth);
  var scrollBarRef = react.useRef();
  var _useLayoutState = useLayoutState({
      scrollLeft: 0,
      isHiddenScrollBar: true
    }),
    _useLayoutState2 = (0,slicedToArray/* default */.Z)(_useLayoutState, 2),
    scrollState = _useLayoutState2[0],
    setScrollState = _useLayoutState2[1];
  var refState = react.useRef({
    delta: 0,
    x: 0
  });
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    isActive = _React$useState2[0],
    setActive = _React$useState2[1];
  var rafRef = react.useRef(null);
  react.useEffect(function () {
    return function () {
      raf/* default.cancel */.Z.cancel(rafRef.current);
    };
  }, []);
  var onMouseUp = function onMouseUp() {
    setActive(false);
  };
  var onMouseDown = function onMouseDown(event) {
    event.persist();
    refState.current.delta = event.pageX - scrollState.scrollLeft;
    refState.current.x = 0;
    setActive(true);
    event.preventDefault();
  };
  var onMouseMove = function onMouseMove(event) {
    var _window;
    // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
    var _ref2 = event || ((_window = window) === null || _window === void 0 ? void 0 : _window.event),
      buttons = _ref2.buttons;
    if (!isActive || buttons === 0) {
      // If out body mouse up, we can set isActive false when mouse move
      if (isActive) {
        setActive(false);
      }
      return;
    }
    var left = refState.current.x + event.pageX - refState.current.x - refState.current.delta;
    var isRTL = direction === 'rtl';
    // Limit scroll range
    left = Math.max(isRTL ? scrollBarWidth - bodyWidth : 0, Math.min(isRTL ? 0 : bodyWidth - scrollBarWidth, left));
    // Calculate the scroll position and update
    var shouldScroll = !isRTL || Math.abs(left) + Math.abs(scrollBarWidth) < bodyWidth;
    if (shouldScroll) {
      onScroll({
        scrollLeft: left / bodyWidth * (bodyScrollWidth + 2)
      });
      refState.current.x = event.pageX;
    }
  };
  var checkScrollBarVisible = function checkScrollBarVisible() {
    raf/* default.cancel */.Z.cancel(rafRef.current);
    rafRef.current = (0,raf/* default */.Z)(function () {
      if (!scrollBodyRef.current) {
        return;
      }
      var tableOffsetTop = getOffset(scrollBodyRef.current).top;
      var tableBottomOffset = tableOffsetTop + scrollBodyRef.current.offsetHeight;
      var currentClientOffset = container === window ? document.documentElement.scrollTop + window.innerHeight : getOffset(container).top + container.clientHeight;
      if (tableBottomOffset - (0,getScrollBarSize/* default */.Z)() <= currentClientOffset || tableOffsetTop >= currentClientOffset - offsetScroll) {
        setScrollState(function (state) {
          return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, state), {}, {
            isHiddenScrollBar: true
          });
        });
      } else {
        setScrollState(function (state) {
          return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, state), {}, {
            isHiddenScrollBar: false
          });
        });
      }
    });
  };
  var setScrollLeft = function setScrollLeft(left) {
    setScrollState(function (state) {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, state), {}, {
        scrollLeft: left / bodyScrollWidth * bodyWidth || 0
      });
    });
  };
  react.useImperativeHandle(ref, function () {
    return {
      setScrollLeft: setScrollLeft,
      checkScrollBarVisible: checkScrollBarVisible
    };
  });
  react.useEffect(function () {
    var onMouseUpListener = (0,addEventListener/* default */.Z)(document.body, 'mouseup', onMouseUp, false);
    var onMouseMoveListener = (0,addEventListener/* default */.Z)(document.body, 'mousemove', onMouseMove, false);
    checkScrollBarVisible();
    return function () {
      onMouseUpListener.remove();
      onMouseMoveListener.remove();
    };
  }, [scrollBarWidth, isActive]);

  // Loop for scroll event check
  react.useEffect(function () {
    if (!scrollBodyRef.current) return;
    var scrollParents = [];
    var parent = (0,findDOMNode/* getDOM */.bn)(scrollBodyRef.current);
    while (parent) {
      scrollParents.push(parent);
      parent = parent.parentElement;
    }
    scrollParents.forEach(function (p) {
      return p.addEventListener('scroll', checkScrollBarVisible, false);
    });
    window.addEventListener('resize', checkScrollBarVisible, false);
    window.addEventListener('scroll', checkScrollBarVisible, false);
    container.addEventListener('scroll', checkScrollBarVisible, false);
    return function () {
      scrollParents.forEach(function (p) {
        return p.removeEventListener('scroll', checkScrollBarVisible);
      });
      window.removeEventListener('resize', checkScrollBarVisible);
      window.removeEventListener('scroll', checkScrollBarVisible);
      container.removeEventListener('scroll', checkScrollBarVisible);
    };
  }, [container]);
  react.useEffect(function () {
    if (!scrollState.isHiddenScrollBar) {
      setScrollState(function (state) {
        var bodyNode = scrollBodyRef.current;
        if (!bodyNode) {
          return state;
        }
        return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, state), {}, {
          scrollLeft: bodyNode.scrollLeft / bodyNode.scrollWidth * bodyNode.clientWidth
        });
      });
    }
  }, [scrollState.isHiddenScrollBar]);
  if (bodyScrollWidth <= bodyWidth || !scrollBarWidth || scrollState.isHiddenScrollBar) {
    return null;
  }
  return /*#__PURE__*/react.createElement("div", {
    style: {
      height: (0,getScrollBarSize/* default */.Z)(),
      width: bodyWidth,
      bottom: offsetScroll
    },
    className: "".concat(prefixCls, "-sticky-scroll")
  }, /*#__PURE__*/react.createElement("div", {
    onMouseDown: onMouseDown,
    ref: scrollBarRef,
    className: classnames_default()("".concat(prefixCls, "-sticky-scroll-bar"), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-sticky-scroll-bar-active"), isActive)),
    style: {
      width: "".concat(scrollBarWidth, "px"),
      transform: "translate3d(".concat(scrollState.scrollLeft, "px, 0, 0)")
    }
  }));
};
/* harmony default export */ var stickyScrollBar = (/*#__PURE__*/react.forwardRef(StickyScrollBar));
;// CONCATENATED MODULE: ./node_modules/rc-table/es/sugar/Column.js
/* istanbul ignore next */
/**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Column(_) {
  return null;
}
/* harmony default export */ var sugar_Column = (Column);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/sugar/ColumnGroup.js
/* istanbul ignore next */
/**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function ColumnGroup(_) {
  return null;
}
/* harmony default export */ var sugar_ColumnGroup = (ColumnGroup);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/Table.js




/**
 * Feature:
 *  - fixed not need to set width
 *  - support `rowExpandable` to config row expand logic
 *  - add `summary` to support `() => ReactNode`
 *
 * Update:
 *  - `dataIndex` is `array[]` now
 *  - `expandable` wrap all the expand related props
 *
 * Removed:
 *  - expandIconAsCell
 *  - useFixedHeader
 *  - rowRef
 *  - columns[number].onCellClick
 *  - onRowClick
 *  - onRowDoubleClick
 *  - onRowMouseEnter
 *  - onRowMouseLeave
 *  - getBodyWrapper
 *  - bodyStyle
 *
 * Deprecated:
 *  - All expanded props, move into expandable
 */
































var DEFAULT_PREFIX = 'rc-table';

// Used for conditions cache
var EMPTY_DATA = [];

// Used for customize scroll
var EMPTY_SCROLL_TARGET = {};
function defaultEmpty() {
  return 'No Data';
}
function Table_Table(tableProps, ref) {
  var props = (0,objectSpread2/* default */.Z)({
    rowKey: 'key',
    prefixCls: DEFAULT_PREFIX,
    emptyText: defaultEmpty
  }, tableProps);
  var prefixCls = props.prefixCls,
    className = props.className,
    rowClassName = props.rowClassName,
    style = props.style,
    data = props.data,
    rowKey = props.rowKey,
    scroll = props.scroll,
    tableLayout = props.tableLayout,
    direction = props.direction,
    title = props.title,
    footer = props.footer,
    summary = props.summary,
    caption = props.caption,
    id = props.id,
    showHeader = props.showHeader,
    components = props.components,
    emptyText = props.emptyText,
    onRow = props.onRow,
    onHeaderRow = props.onHeaderRow,
    onScroll = props.onScroll,
    internalHooks = props.internalHooks,
    transformColumns = props.transformColumns,
    internalRefs = props.internalRefs,
    tailor = props.tailor,
    getContainerWidth = props.getContainerWidth,
    sticky = props.sticky,
    _props$rowHoverable = props.rowHoverable,
    rowHoverable = _props$rowHoverable === void 0 ? true : _props$rowHoverable;
  var mergedData = data || EMPTY_DATA;
  var hasData = !!mergedData.length;
  var useInternalHooks = internalHooks === constant/* INTERNAL_HOOKS */.R;

  // ===================== Warning ======================
  if (false) {}

  // ==================== Customize =====================
  var getComponent = react.useCallback(function (path, defaultComponent) {
    return (0,get/* default */.Z)(components, path) || defaultComponent;
  }, [components]);
  var getRowKey = react.useMemo(function () {
    if (typeof rowKey === 'function') {
      return rowKey;
    }
    return function (record) {
      var key = record && record[rowKey];
      if (false) {}
      return key;
    };
  }, [rowKey]);
  var customizeScrollBody = getComponent(['body']);

  // ====================== Hover =======================
  var _useHover = useHover(),
    _useHover2 = (0,slicedToArray/* default */.Z)(_useHover, 3),
    startRow = _useHover2[0],
    endRow = _useHover2[1],
    onHover = _useHover2[2];

  // ====================== Expand ======================
  var _useExpand = useExpand(props, mergedData, getRowKey),
    _useExpand2 = (0,slicedToArray/* default */.Z)(_useExpand, 6),
    expandableConfig = _useExpand2[0],
    expandableType = _useExpand2[1],
    mergedExpandedKeys = _useExpand2[2],
    mergedExpandIcon = _useExpand2[3],
    mergedChildrenColumnName = _useExpand2[4],
    onTriggerExpand = _useExpand2[5];

  // ====================== Column ======================
  var scrollX = scroll === null || scroll === void 0 ? void 0 : scroll.x;
  var _React$useState = react.useState(0),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    componentWidth = _React$useState2[0],
    setComponentWidth = _React$useState2[1];
  var _useColumns = (0,useColumns/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), expandableConfig), {}, {
      expandable: !!expandableConfig.expandedRowRender,
      columnTitle: expandableConfig.columnTitle,
      expandedKeys: mergedExpandedKeys,
      getRowKey: getRowKey,
      // https://github.com/ant-design/ant-design/issues/23894
      onTriggerExpand: onTriggerExpand,
      expandIcon: mergedExpandIcon,
      expandIconColumnIndex: expandableConfig.expandIconColumnIndex,
      direction: direction,
      scrollWidth: useInternalHooks && tailor && typeof scrollX === 'number' ? scrollX : null,
      clientWidth: componentWidth
    }), useInternalHooks ? transformColumns : null),
    _useColumns2 = (0,slicedToArray/* default */.Z)(_useColumns, 4),
    columns = _useColumns2[0],
    flattenColumns = _useColumns2[1],
    flattenScrollX = _useColumns2[2],
    hasGapFixed = _useColumns2[3];
  var mergedScrollX = flattenScrollX !== null && flattenScrollX !== void 0 ? flattenScrollX : scrollX;
  var columnContext = react.useMemo(function () {
    return {
      columns: columns,
      flattenColumns: flattenColumns
    };
  }, [columns, flattenColumns]);

  // ======================= Refs =======================
  var fullTableRef = react.useRef();
  var scrollHeaderRef = react.useRef();
  var scrollBodyRef = react.useRef();
  var scrollBodyContainerRef = react.useRef();
  react.useImperativeHandle(ref, function () {
    return {
      nativeElement: fullTableRef.current,
      scrollTo: function scrollTo(config) {
        var _scrollBodyRef$curren3;
        if (scrollBodyRef.current instanceof HTMLElement) {
          // Native scroll
          var index = config.index,
            top = config.top,
            key = config.key;
          if (validNumberValue(top)) {
            var _scrollBodyRef$curren;
            (_scrollBodyRef$curren = scrollBodyRef.current) === null || _scrollBodyRef$curren === void 0 || _scrollBodyRef$curren.scrollTo({
              top: top
            });
          } else {
            var _scrollBodyRef$curren2;
            var mergedKey = key !== null && key !== void 0 ? key : getRowKey(mergedData[index]);
            (_scrollBodyRef$curren2 = scrollBodyRef.current.querySelector("[data-row-key=\"".concat(mergedKey, "\"]"))) === null || _scrollBodyRef$curren2 === void 0 || _scrollBodyRef$curren2.scrollIntoView();
          }
        } else if ((_scrollBodyRef$curren3 = scrollBodyRef.current) !== null && _scrollBodyRef$curren3 !== void 0 && _scrollBodyRef$curren3.scrollTo) {
          // Pass to proxy
          scrollBodyRef.current.scrollTo(config);
        }
      }
    };
  });

  // ====================== Scroll ======================
  var scrollSummaryRef = react.useRef();
  var _React$useState3 = react.useState(false),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    pingedLeft = _React$useState4[0],
    setPingedLeft = _React$useState4[1];
  var _React$useState5 = react.useState(false),
    _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
    pingedRight = _React$useState6[0],
    setPingedRight = _React$useState6[1];
  var _React$useState7 = react.useState(new Map()),
    _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
    colsWidths = _React$useState8[0],
    updateColsWidths = _React$useState8[1];

  // Convert map to number width
  var colsKeys = getColumnsKey(flattenColumns);
  var pureColWidths = colsKeys.map(function (columnKey) {
    return colsWidths.get(columnKey);
  });
  var colWidths = react.useMemo(function () {
    return pureColWidths;
  }, [pureColWidths.join('_')]);
  var stickyOffsets = hooks_useStickyOffsets(colWidths, flattenColumns, direction);
  var fixHeader = scroll && validateValue(scroll.y);
  var horizonScroll = scroll && validateValue(mergedScrollX) || Boolean(expandableConfig.fixed);
  var fixColumn = horizonScroll && flattenColumns.some(function (_ref) {
    var fixed = _ref.fixed;
    return fixed;
  });

  // Sticky
  var stickyRef = react.useRef();
  var _useSticky = useSticky(sticky, prefixCls),
    isSticky = _useSticky.isSticky,
    offsetHeader = _useSticky.offsetHeader,
    offsetSummary = _useSticky.offsetSummary,
    offsetScroll = _useSticky.offsetScroll,
    stickyClassName = _useSticky.stickyClassName,
    container = _useSticky.container;

  // Footer (Fix footer must fixed header)
  var summaryNode = react.useMemo(function () {
    return summary === null || summary === void 0 ? void 0 : summary(mergedData);
  }, [summary, mergedData]);
  var fixFooter = (fixHeader || isSticky) && /*#__PURE__*/react.isValidElement(summaryNode) && summaryNode.type === Footer_Summary && summaryNode.props.fixed;

  // Scroll
  var scrollXStyle;
  var scrollYStyle;
  var scrollTableStyle;
  if (fixHeader) {
    scrollYStyle = {
      overflowY: hasData ? 'scroll' : 'auto',
      maxHeight: scroll.y
    };
  }
  if (horizonScroll) {
    scrollXStyle = {
      overflowX: 'auto'
    };
    // When no vertical scrollbar, should hide it
    // https://github.com/ant-design/ant-design/pull/20705
    // https://github.com/ant-design/ant-design/issues/21879
    if (!fixHeader) {
      scrollYStyle = {
        overflowY: 'hidden'
      };
    }
    scrollTableStyle = {
      width: mergedScrollX === true ? 'auto' : mergedScrollX,
      minWidth: '100%'
    };
  }
  var onColumnResize = react.useCallback(function (columnKey, width) {
    updateColsWidths(function (widths) {
      if (widths.get(columnKey) !== width) {
        var newWidths = new Map(widths);
        newWidths.set(columnKey, width);
        return newWidths;
      }
      return widths;
    });
  }, []);
  var _useTimeoutLock = useTimeoutLock(null),
    _useTimeoutLock2 = (0,slicedToArray/* default */.Z)(_useTimeoutLock, 2),
    setScrollTarget = _useTimeoutLock2[0],
    getScrollTarget = _useTimeoutLock2[1];
  function forceScroll(scrollLeft, target) {
    if (!target) {
      return;
    }
    if (typeof target === 'function') {
      target(scrollLeft);
    } else if (target.scrollLeft !== scrollLeft) {
      target.scrollLeft = scrollLeft;

      // Delay to force scroll position if not sync
      // ref: https://github.com/ant-design/ant-design/issues/37179
      if (target.scrollLeft !== scrollLeft) {
        setTimeout(function () {
          target.scrollLeft = scrollLeft;
        }, 0);
      }
    }
  }
  var onInternalScroll = (0,useEvent/* default */.Z)(function (_ref2) {
    var currentTarget = _ref2.currentTarget,
      scrollLeft = _ref2.scrollLeft;
    var isRTL = direction === 'rtl';
    var mergedScrollLeft = typeof scrollLeft === 'number' ? scrollLeft : currentTarget.scrollLeft;
    var compareTarget = currentTarget || EMPTY_SCROLL_TARGET;
    if (!getScrollTarget() || getScrollTarget() === compareTarget) {
      var _stickyRef$current;
      setScrollTarget(compareTarget);
      forceScroll(mergedScrollLeft, scrollHeaderRef.current);
      forceScroll(mergedScrollLeft, scrollBodyRef.current);
      forceScroll(mergedScrollLeft, scrollSummaryRef.current);
      forceScroll(mergedScrollLeft, (_stickyRef$current = stickyRef.current) === null || _stickyRef$current === void 0 ? void 0 : _stickyRef$current.setScrollLeft);
    }
    var measureTarget = currentTarget || scrollHeaderRef.current;
    if (measureTarget) {
      var scrollWidth =
      // Should use mergedScrollX in virtual table(useInternalHooks && tailor === true)
      useInternalHooks && tailor && typeof mergedScrollX === 'number' ? mergedScrollX : measureTarget.scrollWidth;
      var clientWidth = measureTarget.clientWidth;
      // There is no space to scroll
      if (scrollWidth === clientWidth) {
        setPingedLeft(false);
        setPingedRight(false);
        return;
      }
      if (isRTL) {
        setPingedLeft(-mergedScrollLeft < scrollWidth - clientWidth);
        setPingedRight(-mergedScrollLeft > 0);
      } else {
        setPingedLeft(mergedScrollLeft > 0);
        setPingedRight(mergedScrollLeft < scrollWidth - clientWidth);
      }
    }
  });
  var onBodyScroll = (0,useEvent/* default */.Z)(function (e) {
    onInternalScroll(e);
    onScroll === null || onScroll === void 0 || onScroll(e);
  });
  var triggerOnScroll = function triggerOnScroll() {
    if (horizonScroll && scrollBodyRef.current) {
      var _scrollBodyRef$curren4;
      onInternalScroll({
        currentTarget: (0,findDOMNode/* getDOM */.bn)(scrollBodyRef.current),
        scrollLeft: (_scrollBodyRef$curren4 = scrollBodyRef.current) === null || _scrollBodyRef$curren4 === void 0 ? void 0 : _scrollBodyRef$curren4.scrollLeft
      });
    } else {
      setPingedLeft(false);
      setPingedRight(false);
    }
  };
  var onFullTableResize = function onFullTableResize(_ref3) {
    var _stickyRef$current2;
    var width = _ref3.width;
    (_stickyRef$current2 = stickyRef.current) === null || _stickyRef$current2 === void 0 || _stickyRef$current2.checkScrollBarVisible();
    var mergedWidth = fullTableRef.current ? fullTableRef.current.offsetWidth : width;
    if (useInternalHooks && getContainerWidth && fullTableRef.current) {
      mergedWidth = getContainerWidth(fullTableRef.current, mergedWidth) || mergedWidth;
    }
    if (mergedWidth !== componentWidth) {
      triggerOnScroll();
      setComponentWidth(mergedWidth);
    }
  };

  // Sync scroll bar when init or `horizonScroll`, `data` and `columns.length` changed
  var mounted = react.useRef(false);
  react.useEffect(function () {
    // onFullTableResize will be trigger once when ResizeObserver is mounted
    // This will reduce one duplicated triggerOnScroll time
    if (mounted.current) {
      triggerOnScroll();
    }
  }, [horizonScroll, data, columns.length]);
  react.useEffect(function () {
    mounted.current = true;
  }, []);

  // ===================== Effects ======================
  var _React$useState9 = react.useState(0),
    _React$useState10 = (0,slicedToArray/* default */.Z)(_React$useState9, 2),
    scrollbarSize = _React$useState10[0],
    setScrollbarSize = _React$useState10[1];
  var _React$useState11 = react.useState(true),
    _React$useState12 = (0,slicedToArray/* default */.Z)(_React$useState11, 2),
    supportSticky = _React$useState12[0],
    setSupportSticky = _React$useState12[1]; // Only IE not support, we mark as support first

  (0,useLayoutEffect/* default */.Z)(function () {
    if (!tailor || !useInternalHooks) {
      if (scrollBodyRef.current instanceof Element) {
        setScrollbarSize((0,getScrollBarSize/* getTargetScrollBarSize */.o)(scrollBodyRef.current).width);
      } else {
        setScrollbarSize((0,getScrollBarSize/* getTargetScrollBarSize */.o)(scrollBodyContainerRef.current).width);
      }
    }
    setSupportSticky((0,styleChecker/* isStyleSupport */.G)('position', 'sticky'));
  }, []);

  // ================== INTERNAL HOOKS ==================
  react.useEffect(function () {
    if (useInternalHooks && internalRefs) {
      internalRefs.body.current = scrollBodyRef.current;
    }
  });

  // ========================================================================
  // ==                               Render                               ==
  // ========================================================================
  // =================== Render: Func ===================
  var renderFixedHeaderTable = react.useCallback(function (fixedHolderPassProps) {
    return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Header_Header, fixedHolderPassProps), fixFooter === 'top' && /*#__PURE__*/react.createElement(es_Footer, fixedHolderPassProps, summaryNode));
  }, [fixFooter, summaryNode]);
  var renderFixedFooterTable = react.useCallback(function (fixedHolderPassProps) {
    return /*#__PURE__*/react.createElement(es_Footer, fixedHolderPassProps, summaryNode);
  }, [summaryNode]);

  // =================== Render: Node ===================
  var TableComponent = getComponent(['table'], 'table');

  // Table layout
  var mergedTableLayout = react.useMemo(function () {
    if (tableLayout) {
      return tableLayout;
    }
    // https://github.com/ant-design/ant-design/issues/25227
    // When scroll.x is max-content, no need to fix table layout
    // it's width should stretch out to fit content
    if (fixColumn) {
      return mergedScrollX === 'max-content' ? 'auto' : 'fixed';
    }
    if (fixHeader || isSticky || flattenColumns.some(function (_ref4) {
      var ellipsis = _ref4.ellipsis;
      return ellipsis;
    })) {
      return 'fixed';
    }
    return 'auto';
  }, [fixHeader, fixColumn, flattenColumns, tableLayout, isSticky]);
  var groupTableNode;

  // Header props
  var headerProps = {
    colWidths: colWidths,
    columCount: flattenColumns.length,
    stickyOffsets: stickyOffsets,
    onHeaderRow: onHeaderRow,
    fixHeader: fixHeader,
    scroll: scroll
  };

  // Empty
  var emptyNode = react.useMemo(function () {
    if (hasData) {
      return null;
    }
    if (typeof emptyText === 'function') {
      return emptyText();
    }
    return emptyText;
  }, [hasData, emptyText]);

  // Body
  var bodyTable = /*#__PURE__*/react.createElement(es_Body, {
    data: mergedData,
    measureColumnWidth: fixHeader || horizonScroll || isSticky
  });
  var bodyColGroup = /*#__PURE__*/react.createElement(es_ColGroup, {
    colWidths: flattenColumns.map(function (_ref5) {
      var width = _ref5.width;
      return width;
    }),
    columns: flattenColumns
  });
  var captionElement = caption !== null && caption !== undefined ? /*#__PURE__*/react.createElement("caption", {
    className: "".concat(prefixCls, "-caption")
  }, caption) : undefined;
  var dataProps = (0,pickAttrs/* default */.Z)(props, {
    data: true
  });
  var ariaProps = (0,pickAttrs/* default */.Z)(props, {
    aria: true
  });
  if (fixHeader || isSticky) {
    // >>>>>> Fixed Header
    var bodyContent;
    if (typeof customizeScrollBody === 'function') {
      bodyContent = customizeScrollBody(mergedData, {
        scrollbarSize: scrollbarSize,
        ref: scrollBodyRef,
        onScroll: onInternalScroll
      });
      headerProps.colWidths = flattenColumns.map(function (_ref6, index) {
        var width = _ref6.width;
        var colWidth = index === flattenColumns.length - 1 ? width - scrollbarSize : width;
        if (typeof colWidth === 'number' && !Number.isNaN(colWidth)) {
          return colWidth;
        }
        if (false) {}
        return 0;
      });
    } else {
      bodyContent = /*#__PURE__*/react.createElement("div", {
        style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, scrollXStyle), scrollYStyle),
        onScroll: onBodyScroll,
        ref: scrollBodyRef,
        className: classnames_default()("".concat(prefixCls, "-body"))
      }, /*#__PURE__*/react.createElement(TableComponent, (0,esm_extends/* default */.Z)({
        style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, scrollTableStyle), {}, {
          tableLayout: mergedTableLayout
        })
      }, ariaProps), captionElement, bodyColGroup, bodyTable, !fixFooter && summaryNode && /*#__PURE__*/react.createElement(es_Footer, {
        stickyOffsets: stickyOffsets,
        flattenColumns: flattenColumns
      }, summaryNode)));
    }

    // Fixed holder share the props
    var fixedHolderProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
      noData: !mergedData.length,
      maxContentScroll: horizonScroll && mergedScrollX === 'max-content'
    }, headerProps), columnContext), {}, {
      direction: direction,
      stickyClassName: stickyClassName,
      onScroll: onInternalScroll
    });
    groupTableNode = /*#__PURE__*/react.createElement(react.Fragment, null, showHeader !== false && /*#__PURE__*/react.createElement(es_FixedHolder, (0,esm_extends/* default */.Z)({}, fixedHolderProps, {
      stickyTopOffset: offsetHeader,
      className: "".concat(prefixCls, "-header"),
      ref: scrollHeaderRef
    }), renderFixedHeaderTable), bodyContent, fixFooter && fixFooter !== 'top' && /*#__PURE__*/react.createElement(es_FixedHolder, (0,esm_extends/* default */.Z)({}, fixedHolderProps, {
      stickyBottomOffset: offsetSummary,
      className: "".concat(prefixCls, "-summary"),
      ref: scrollSummaryRef
    }), renderFixedFooterTable), isSticky && scrollBodyRef.current && scrollBodyRef.current instanceof Element && /*#__PURE__*/react.createElement(stickyScrollBar, {
      ref: stickyRef,
      offsetScroll: offsetScroll,
      scrollBodyRef: scrollBodyRef,
      onScroll: onInternalScroll,
      container: container,
      direction: direction
    }));
  } else {
    // >>>>>> Unique table
    groupTableNode = /*#__PURE__*/react.createElement("div", {
      style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, scrollXStyle), scrollYStyle),
      className: classnames_default()("".concat(prefixCls, "-content")),
      onScroll: onInternalScroll,
      ref: scrollBodyRef
    }, /*#__PURE__*/react.createElement(TableComponent, (0,esm_extends/* default */.Z)({
      style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, scrollTableStyle), {}, {
        tableLayout: mergedTableLayout
      })
    }, ariaProps), captionElement, bodyColGroup, showHeader !== false && /*#__PURE__*/react.createElement(Header_Header, (0,esm_extends/* default */.Z)({}, headerProps, columnContext)), bodyTable, summaryNode && /*#__PURE__*/react.createElement(es_Footer, {
      stickyOffsets: stickyOffsets,
      flattenColumns: flattenColumns
    }, summaryNode)));
  }
  var fullTable = /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    className: classnames_default()(prefixCls, className, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-ping-left"), pingedLeft), "".concat(prefixCls, "-ping-right"), pingedRight), "".concat(prefixCls, "-layout-fixed"), tableLayout === 'fixed'), "".concat(prefixCls, "-fixed-header"), fixHeader), "".concat(prefixCls, "-fixed-column"), fixColumn), "".concat(prefixCls, "-fixed-column-gapped"), fixColumn && hasGapFixed), "".concat(prefixCls, "-scroll-horizontal"), horizonScroll), "".concat(prefixCls, "-has-fix-left"), flattenColumns[0] && flattenColumns[0].fixed), "".concat(prefixCls, "-has-fix-right"), flattenColumns[flattenColumns.length - 1] && flattenColumns[flattenColumns.length - 1].fixed === 'right')),
    style: style,
    id: id,
    ref: fullTableRef
  }, dataProps), title && /*#__PURE__*/react.createElement(es_Panel, {
    className: "".concat(prefixCls, "-title")
  }, title(mergedData)), /*#__PURE__*/react.createElement("div", {
    ref: scrollBodyContainerRef,
    className: "".concat(prefixCls, "-container")
  }, groupTableNode), footer && /*#__PURE__*/react.createElement(es_Panel, {
    className: "".concat(prefixCls, "-footer")
  }, footer(mergedData)));
  if (horizonScroll) {
    fullTable = /*#__PURE__*/react.createElement(rc_resize_observer_es/* default */.Z, {
      onResize: onFullTableResize
    }, fullTable);
  }
  var fixedInfoList = useFixedInfo(flattenColumns, stickyOffsets, direction);
  var TableContextValue = react.useMemo(function () {
    return {
      // Scroll
      scrollX: mergedScrollX,
      // Table
      prefixCls: prefixCls,
      getComponent: getComponent,
      scrollbarSize: scrollbarSize,
      direction: direction,
      fixedInfoList: fixedInfoList,
      isSticky: isSticky,
      supportSticky: supportSticky,
      componentWidth: componentWidth,
      fixHeader: fixHeader,
      fixColumn: fixColumn,
      horizonScroll: horizonScroll,
      // Body
      tableLayout: mergedTableLayout,
      rowClassName: rowClassName,
      expandedRowClassName: expandableConfig.expandedRowClassName,
      expandIcon: mergedExpandIcon,
      expandableType: expandableType,
      expandRowByClick: expandableConfig.expandRowByClick,
      expandedRowRender: expandableConfig.expandedRowRender,
      expandedRowOffset: expandableConfig.expandedRowOffset,
      onTriggerExpand: onTriggerExpand,
      expandIconColumnIndex: expandableConfig.expandIconColumnIndex,
      indentSize: expandableConfig.indentSize,
      allColumnsFixedLeft: flattenColumns.every(function (col) {
        return col.fixed === 'left';
      }),
      emptyNode: emptyNode,
      // Column
      columns: columns,
      flattenColumns: flattenColumns,
      onColumnResize: onColumnResize,
      colWidths: colWidths,
      // Row
      hoverStartRow: startRow,
      hoverEndRow: endRow,
      onHover: onHover,
      rowExpandable: expandableConfig.rowExpandable,
      onRow: onRow,
      getRowKey: getRowKey,
      expandedKeys: mergedExpandedKeys,
      childrenColumnName: mergedChildrenColumnName,
      rowHoverable: rowHoverable
    };
  }, [
  // Scroll
  mergedScrollX,
  // Table
  prefixCls, getComponent, scrollbarSize, direction, fixedInfoList, isSticky, supportSticky, componentWidth, fixHeader, fixColumn, horizonScroll,
  // Body
  mergedTableLayout, rowClassName, expandableConfig.expandedRowClassName, mergedExpandIcon, expandableType, expandableConfig.expandRowByClick, expandableConfig.expandedRowRender, expandableConfig.expandedRowOffset, onTriggerExpand, expandableConfig.expandIconColumnIndex, expandableConfig.indentSize, emptyNode,
  // Column
  columns, flattenColumns, onColumnResize, colWidths,
  // Row
  startRow, endRow, onHover, expandableConfig.rowExpandable, onRow, getRowKey, mergedExpandedKeys, mergedChildrenColumnName, rowHoverable]);
  return /*#__PURE__*/react.createElement(context_TableContext.Provider, {
    value: TableContextValue
  }, fullTable);
}
var RefTable = /*#__PURE__*/react.forwardRef(Table_Table);
if (false) {}
function genTable(shouldTriggerRender) {
  return TableContext_makeImmutable(RefTable, shouldTriggerRender);
}
var ImmutableTable = genTable();
ImmutableTable.EXPAND_COLUMN = constant/* EXPAND_COLUMN */.w;
ImmutableTable.INTERNAL_HOOKS = constant/* INTERNAL_HOOKS */.R;
ImmutableTable.Column = sugar_Column;
ImmutableTable.ColumnGroup = sugar_ColumnGroup;
ImmutableTable.Summary = FooterComponents;
/* harmony default export */ var es_Table = (ImmutableTable);
// EXTERNAL MODULE: ./node_modules/rc-virtual-list/es/index.js + 17 modules
var rc_virtual_list_es = __webpack_require__(15371);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/VirtualTable/context.js

var StaticContext = createContext(null);
var GridContext = createContext(null);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/VirtualTable/VirtualCell.js








/**
 * Return the width of the column by `colSpan`.
 * When `colSpan` is `0` will be trade as `1`.
 */
function getColumnWidth(colIndex, colSpan, columnsOffset) {
  var mergedColSpan = colSpan || 1;
  return columnsOffset[colIndex + mergedColSpan] - (columnsOffset[colIndex] || 0);
}
function VirtualCell(props) {
  var rowInfo = props.rowInfo,
    column = props.column,
    colIndex = props.colIndex,
    indent = props.indent,
    index = props.index,
    component = props.component,
    renderIndex = props.renderIndex,
    record = props.record,
    style = props.style,
    className = props.className,
    inverse = props.inverse,
    getHeight = props.getHeight;
  var render = column.render,
    dataIndex = column.dataIndex,
    columnClassName = column.className,
    colWidth = column.width;
  var _useContext = useContext(GridContext, ['columnsOffset']),
    columnsOffset = _useContext.columnsOffset;

  // TODO: support `expandableRowOffset`
  var _getCellProps = getCellProps(rowInfo, column, colIndex, indent, index),
    key = _getCellProps.key,
    fixedInfo = _getCellProps.fixedInfo,
    appendCellNode = _getCellProps.appendCellNode,
    additionalCellProps = _getCellProps.additionalCellProps;
  var cellStyle = additionalCellProps.style,
    _additionalCellProps$ = additionalCellProps.colSpan,
    colSpan = _additionalCellProps$ === void 0 ? 1 : _additionalCellProps$,
    _additionalCellProps$2 = additionalCellProps.rowSpan,
    rowSpan = _additionalCellProps$2 === void 0 ? 1 : _additionalCellProps$2;

  // ========================= ColWidth =========================
  // column width
  var startColIndex = colIndex - 1;
  var concatColWidth = getColumnWidth(startColIndex, colSpan, columnsOffset);

  // margin offset
  var marginOffset = colSpan > 1 ? colWidth - concatColWidth : 0;

  // ========================== Style ===========================
  var mergedStyle = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, cellStyle), style), {}, {
    flex: "0 0 ".concat(concatColWidth, "px"),
    width: "".concat(concatColWidth, "px"),
    marginRight: marginOffset,
    pointerEvents: 'auto'
  });

  // When `colSpan` or `rowSpan` is `0`, should skip render.
  var needHide = react.useMemo(function () {
    if (inverse) {
      return rowSpan <= 1;
    } else {
      return colSpan === 0 || rowSpan === 0 || rowSpan > 1;
    }
  }, [rowSpan, colSpan, inverse]);

  // 0 rowSpan or colSpan should not render
  if (needHide) {
    mergedStyle.visibility = 'hidden';
  } else if (inverse) {
    mergedStyle.height = getHeight === null || getHeight === void 0 ? void 0 : getHeight(rowSpan);
  }
  var mergedRender = needHide ? function () {
    return null;
  } : render;

  // ========================== Render ==========================
  var cellSpan = {};

  // Virtual should reset `colSpan` & `rowSpan`
  if (rowSpan === 0 || colSpan === 0) {
    cellSpan.rowSpan = 1;
    cellSpan.colSpan = 1;
  }
  return /*#__PURE__*/react.createElement(es_Cell, (0,esm_extends/* default */.Z)({
    className: classnames_default()(columnClassName, className),
    ellipsis: column.ellipsis,
    align: column.align,
    scope: column.rowScope,
    component: component,
    prefixCls: rowInfo.prefixCls,
    key: key,
    record: record,
    index: index,
    renderIndex: renderIndex,
    dataIndex: dataIndex,
    render: mergedRender,
    shouldCellUpdate: column.shouldCellUpdate
  }, fixedInfo, {
    appendNode: appendCellNode,
    additionalProps: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, additionalCellProps), {}, {
      style: mergedStyle
    }, cellSpan)
  }));
}
/* harmony default export */ var VirtualTable_VirtualCell = (VirtualCell);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/VirtualTable/BodyLine.js




var BodyLine_excluded = ["data", "index", "className", "rowKey", "style", "extra", "getHeight"];









var BodyLine = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var data = props.data,
    index = props.index,
    className = props.className,
    rowKey = props.rowKey,
    style = props.style,
    extra = props.extra,
    getHeight = props.getHeight,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, BodyLine_excluded);
  var record = data.record,
    indent = data.indent,
    renderIndex = data.index;
  var _useContext = useContext(context_TableContext, ['prefixCls', 'flattenColumns', 'fixColumn', 'componentWidth', 'scrollX']),
    scrollX = _useContext.scrollX,
    flattenColumns = _useContext.flattenColumns,
    prefixCls = _useContext.prefixCls,
    fixColumn = _useContext.fixColumn,
    componentWidth = _useContext.componentWidth;
  var _useContext2 = useContext(StaticContext, ['getComponent']),
    getComponent = _useContext2.getComponent;
  var rowInfo = useRowInfo(record, rowKey, index, indent);
  var RowComponent = getComponent(['body', 'row'], 'div');
  var cellComponent = getComponent(['body', 'cell'], 'div');

  // ========================== Expand ==========================
  var rowSupportExpand = rowInfo.rowSupportExpand,
    expanded = rowInfo.expanded,
    rowProps = rowInfo.rowProps,
    expandedRowRender = rowInfo.expandedRowRender,
    expandedRowClassName = rowInfo.expandedRowClassName;
  var expandRowNode;
  if (rowSupportExpand && expanded) {
    var expandContent = expandedRowRender(record, index, indent + 1, expanded);
    var expandedClsName = computedExpandedClassName(expandedRowClassName, record, index, indent);
    var additionalProps = {};
    if (fixColumn) {
      additionalProps = {
        style: (0,defineProperty/* default */.Z)({}, '--virtual-width', "".concat(componentWidth, "px"))
      };
    }
    var rowCellCls = "".concat(prefixCls, "-expanded-row-cell");
    expandRowNode = /*#__PURE__*/react.createElement(RowComponent, {
      className: classnames_default()("".concat(prefixCls, "-expanded-row"), "".concat(prefixCls, "-expanded-row-level-").concat(indent + 1), expandedClsName)
    }, /*#__PURE__*/react.createElement(es_Cell, {
      component: cellComponent,
      prefixCls: prefixCls,
      className: classnames_default()(rowCellCls, (0,defineProperty/* default */.Z)({}, "".concat(rowCellCls, "-fixed"), fixColumn)),
      additionalProps: additionalProps
    }, expandContent));
  }

  // ========================== Render ==========================
  var rowStyle = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, style), {}, {
    width: scrollX
  });
  if (extra) {
    rowStyle.position = 'absolute';
    rowStyle.pointerEvents = 'none';
  }
  var rowNode = /*#__PURE__*/react.createElement(RowComponent, (0,esm_extends/* default */.Z)({}, rowProps, restProps, {
    "data-row-key": rowKey,
    ref: rowSupportExpand ? null : ref,
    className: classnames_default()(className, "".concat(prefixCls, "-row"), rowProps === null || rowProps === void 0 ? void 0 : rowProps.className, (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-row-extra"), extra)),
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, rowStyle), rowProps === null || rowProps === void 0 ? void 0 : rowProps.style)
  }), flattenColumns.map(function (column, colIndex) {
    return /*#__PURE__*/react.createElement(VirtualTable_VirtualCell, {
      key: colIndex,
      component: cellComponent,
      rowInfo: rowInfo,
      column: column,
      colIndex: colIndex,
      indent: indent,
      index: index,
      renderIndex: renderIndex,
      record: record,
      inverse: extra,
      getHeight: getHeight
    });
  }));
  if (rowSupportExpand) {
    return /*#__PURE__*/react.createElement("div", {
      ref: ref
    }, rowNode, expandRowNode);
  }
  return rowNode;
});
var ResponseBodyLine = TableContext_responseImmutable(BodyLine);
if (false) {}
/* harmony default export */ var VirtualTable_BodyLine = (ResponseBodyLine);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/VirtualTable/BodyGrid.js









var Grid = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var data = props.data,
    onScroll = props.onScroll;
  var _useContext = useContext(context_TableContext, ['flattenColumns', 'onColumnResize', 'getRowKey', 'prefixCls', 'expandedKeys', 'childrenColumnName', 'scrollX', 'direction']),
    flattenColumns = _useContext.flattenColumns,
    onColumnResize = _useContext.onColumnResize,
    getRowKey = _useContext.getRowKey,
    expandedKeys = _useContext.expandedKeys,
    prefixCls = _useContext.prefixCls,
    childrenColumnName = _useContext.childrenColumnName,
    scrollX = _useContext.scrollX,
    direction = _useContext.direction;
  var _useContext2 = useContext(StaticContext),
    sticky = _useContext2.sticky,
    scrollY = _useContext2.scrollY,
    listItemHeight = _useContext2.listItemHeight,
    getComponent = _useContext2.getComponent,
    onTablePropScroll = _useContext2.onScroll;

  // =========================== Ref ============================
  var listRef = react.useRef();

  // =========================== Data ===========================
  var flattenData = useFlattenRecords(data, childrenColumnName, expandedKeys, getRowKey);

  // ========================== Column ==========================
  var columnsWidth = react.useMemo(function () {
    var total = 0;
    return flattenColumns.map(function (_ref) {
      var width = _ref.width,
        key = _ref.key;
      total += width;
      return [key, width, total];
    });
  }, [flattenColumns]);
  var columnsOffset = react.useMemo(function () {
    return columnsWidth.map(function (colWidth) {
      return colWidth[2];
    });
  }, [columnsWidth]);
  react.useEffect(function () {
    columnsWidth.forEach(function (_ref2) {
      var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
        key = _ref3[0],
        width = _ref3[1];
      onColumnResize(key, width);
    });
  }, [columnsWidth]);

  // =========================== Ref ============================
  react.useImperativeHandle(ref, function () {
    var _listRef$current2;
    var obj = {
      scrollTo: function scrollTo(config) {
        var _listRef$current;
        (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.scrollTo(config);
      },
      nativeElement: (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 ? void 0 : _listRef$current2.nativeElement
    };
    Object.defineProperty(obj, 'scrollLeft', {
      get: function get() {
        var _listRef$current3;
        return ((_listRef$current3 = listRef.current) === null || _listRef$current3 === void 0 ? void 0 : _listRef$current3.getScrollInfo().x) || 0;
      },
      set: function set(value) {
        var _listRef$current4;
        (_listRef$current4 = listRef.current) === null || _listRef$current4 === void 0 || _listRef$current4.scrollTo({
          left: value
        });
      }
    });
    return obj;
  });

  // ======================= Col/Row Span =======================
  var getRowSpan = function getRowSpan(column, index) {
    var _flattenData$index;
    var record = (_flattenData$index = flattenData[index]) === null || _flattenData$index === void 0 ? void 0 : _flattenData$index.record;
    var onCell = column.onCell;
    if (onCell) {
      var _cellProps$rowSpan;
      var cellProps = onCell(record, index);
      return (_cellProps$rowSpan = cellProps === null || cellProps === void 0 ? void 0 : cellProps.rowSpan) !== null && _cellProps$rowSpan !== void 0 ? _cellProps$rowSpan : 1;
    }
    return 1;
  };
  var extraRender = function extraRender(info) {
    var start = info.start,
      end = info.end,
      getSize = info.getSize,
      offsetY = info.offsetY;

    // Do nothing if no data
    if (end < 0) {
      return null;
    }

    // Find first rowSpan column
    var firstRowSpanColumns = flattenColumns.filter(
    // rowSpan is 0
    function (column) {
      return getRowSpan(column, start) === 0;
    });
    var startIndex = start;
    var _loop = function _loop(i) {
      firstRowSpanColumns = firstRowSpanColumns.filter(function (column) {
        return getRowSpan(column, i) === 0;
      });
      if (!firstRowSpanColumns.length) {
        startIndex = i;
        return 1; // break
      }
    };
    for (var i = start; i >= 0; i -= 1) {
      if (_loop(i)) break;
    }

    // Find last rowSpan column
    var lastRowSpanColumns = flattenColumns.filter(
    // rowSpan is not 1
    function (column) {
      return getRowSpan(column, end) !== 1;
    });
    var endIndex = end;
    var _loop2 = function _loop2(_i) {
      lastRowSpanColumns = lastRowSpanColumns.filter(function (column) {
        return getRowSpan(column, _i) !== 1;
      });
      if (!lastRowSpanColumns.length) {
        endIndex = Math.max(_i - 1, end);
        return 1; // break
      }
    };
    for (var _i = end; _i < flattenData.length; _i += 1) {
      if (_loop2(_i)) break;
    }

    // Collect the line who has rowSpan
    var spanLines = [];
    var _loop3 = function _loop3(_i2) {
      var item = flattenData[_i2];

      // This code will never reach, just incase
      if (!item) {
        return 1; // continue
      }
      if (flattenColumns.some(function (column) {
        return getRowSpan(column, _i2) > 1;
      })) {
        spanLines.push(_i2);
      }
    };
    for (var _i2 = startIndex; _i2 <= endIndex; _i2 += 1) {
      if (_loop3(_i2)) continue;
    }

    // Patch extra line on the page
    var nodes = spanLines.map(function (index) {
      var item = flattenData[index];
      var rowKey = getRowKey(item.record, index);
      var getHeight = function getHeight(rowSpan) {
        var endItemIndex = index + rowSpan - 1;
        var endItemKey = getRowKey(flattenData[endItemIndex].record, endItemIndex);
        var sizeInfo = getSize(rowKey, endItemKey);
        return sizeInfo.bottom - sizeInfo.top;
      };
      var sizeInfo = getSize(rowKey);
      return /*#__PURE__*/react.createElement(VirtualTable_BodyLine, {
        key: index,
        data: item,
        rowKey: rowKey,
        index: index,
        style: {
          top: -offsetY + sizeInfo.top
        },
        extra: true,
        getHeight: getHeight
      });
    });
    return nodes;
  };

  // ========================= Context ==========================
  var gridContext = react.useMemo(function () {
    return {
      columnsOffset: columnsOffset
    };
  }, [columnsOffset]);

  // ========================== Render ==========================
  var tblPrefixCls = "".concat(prefixCls, "-tbody");

  // default 'div' in rc-virtual-list
  var wrapperComponent = getComponent(['body', 'wrapper']);

  // ========================== Sticky Scroll Bar ==========================
  var horizontalScrollBarStyle = {};
  if (sticky) {
    horizontalScrollBarStyle.position = 'sticky';
    horizontalScrollBarStyle.bottom = 0;
    if ((0,esm_typeof/* default */.Z)(sticky) === 'object' && sticky.offsetScroll) {
      horizontalScrollBarStyle.bottom = sticky.offsetScroll;
    }
  }
  return /*#__PURE__*/react.createElement(GridContext.Provider, {
    value: gridContext
  }, /*#__PURE__*/react.createElement(rc_virtual_list_es/* default */.Z, {
    fullHeight: false,
    ref: listRef,
    prefixCls: "".concat(tblPrefixCls, "-virtual"),
    styles: {
      horizontalScrollBar: horizontalScrollBarStyle
    },
    className: tblPrefixCls,
    height: scrollY,
    itemHeight: listItemHeight || 24,
    data: flattenData,
    itemKey: function itemKey(item) {
      return getRowKey(item.record);
    },
    component: wrapperComponent,
    scrollWidth: scrollX,
    direction: direction,
    onVirtualScroll: function onVirtualScroll(_ref4) {
      var _listRef$current5;
      var x = _ref4.x;
      onScroll({
        currentTarget: (_listRef$current5 = listRef.current) === null || _listRef$current5 === void 0 ? void 0 : _listRef$current5.nativeElement,
        scrollLeft: x
      });
    },
    onScroll: onTablePropScroll,
    extraRender: extraRender
  }, function (item, index, itemProps) {
    var rowKey = getRowKey(item.record, index);
    return /*#__PURE__*/react.createElement(VirtualTable_BodyLine, {
      data: item,
      rowKey: rowKey,
      index: index,
      style: itemProps.style
    });
  }));
});
var ResponseGrid = TableContext_responseImmutable(Grid);
if (false) {}
/* harmony default export */ var BodyGrid = (ResponseGrid);
;// CONCATENATED MODULE: ./node_modules/rc-table/es/VirtualTable/index.js











var renderBody = function renderBody(rawData, props) {
  var ref = props.ref,
    onScroll = props.onScroll;
  return /*#__PURE__*/react.createElement(BodyGrid, {
    ref: ref,
    data: rawData,
    onScroll: onScroll
  });
};
function VirtualTable(props, ref) {
  var data = props.data,
    columns = props.columns,
    scroll = props.scroll,
    sticky = props.sticky,
    _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? DEFAULT_PREFIX : _props$prefixCls,
    className = props.className,
    listItemHeight = props.listItemHeight,
    components = props.components,
    onScroll = props.onScroll;
  var _ref = scroll || {},
    scrollX = _ref.x,
    scrollY = _ref.y;

  // Fill scrollX
  if (typeof scrollX !== 'number') {
    if (false) {}
    scrollX = 1;
  }

  // Fill scrollY
  if (typeof scrollY !== 'number') {
    scrollY = 500;
    if (false) {}
  }
  var getComponent = (0,es/* useEvent */.zX)(function (path, defaultComponent) {
    return (0,get/* default */.Z)(components, path) || defaultComponent;
  });

  // Memo this
  var onInternalScroll = (0,es/* useEvent */.zX)(onScroll);

  // ========================= Context ==========================
  var context = react.useMemo(function () {
    return {
      sticky: sticky,
      scrollY: scrollY,
      listItemHeight: listItemHeight,
      getComponent: getComponent,
      onScroll: onInternalScroll
    };
  }, [sticky, scrollY, listItemHeight, getComponent, onInternalScroll]);

  // ========================== Render ==========================
  return /*#__PURE__*/react.createElement(StaticContext.Provider, {
    value: context
  }, /*#__PURE__*/react.createElement(es_Table, (0,esm_extends/* default */.Z)({}, props, {
    className: classnames_default()(className, "".concat(prefixCls, "-virtual")),
    scroll: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, scroll), {}, {
      x: scrollX
    }),
    components: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, components), {}, {
      // fix https://github.com/ant-design/ant-design/issues/48991
      body: data !== null && data !== void 0 && data.length ? renderBody : undefined
    }),
    columns: columns,
    internalHooks: constant/* INTERNAL_HOOKS */.R,
    tailor: true,
    ref: ref
  })));
}
var RefVirtualTable = /*#__PURE__*/react.forwardRef(VirtualTable);
if (false) {}
function genVirtualTable(shouldTriggerRender) {
  return TableContext_makeImmutable(RefVirtualTable, shouldTriggerRender);
}
/* harmony default export */ var es_VirtualTable = (genVirtualTable());
;// CONCATENATED MODULE: ./node_modules/rc-table/es/index.js








/* harmony default export */ var rc_table_es = ((/* unused pure expression or super */ null && (Table)));

/***/ }),

/***/ 17877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getExpandableProps; },
/* harmony export */   "v": function() { return /* binding */ INTERNAL_COL_DEFINE; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56717);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91032);
/* harmony import */ var rc_util_es_warning__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13764);


var _excluded = ["expandable"];

var INTERNAL_COL_DEFINE = 'RC_TABLE_INTERNAL_COL_DEFINE';
function getExpandableProps(props) {
  var expandable = props.expandable,
    legacyExpandableConfig = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, _excluded);
  var config;
  if ('expandable' in props) {
    config = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, legacyExpandableConfig), expandable);
  } else {
    if (false) {}
    config = legacyExpandableConfig;
  }
  if (config.showExpandColumn === false) {
    config.expandIconColumnIndex = -1;
  }
  return config;
}

/***/ }),

/***/ 5666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ rc_tabs_es; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMergedState.js
var useMergedState = __webpack_require__(78877);
// EXTERNAL MODULE: ./node_modules/rc-util/es/isMobile.js
var isMobile = __webpack_require__(87122);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/rc-tabs/es/TabContext.js

/* harmony default export */ var TabContext = (/*#__PURE__*/(0,react.createContext)(null));
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
// EXTERNAL MODULE: ./node_modules/rc-resize-observer/es/index.js + 4 modules
var es = __webpack_require__(49938);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useEvent.js
var useEvent = __webpack_require__(47789);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(99195);
// EXTERNAL MODULE: ./node_modules/rc-util/es/raf.js
var raf = __webpack_require__(13157);
;// CONCATENATED MODULE: ./node_modules/rc-tabs/es/hooks/useIndicator.js



var useIndicator = function useIndicator(options) {
  var activeTabOffset = options.activeTabOffset,
    horizontal = options.horizontal,
    rtl = options.rtl,
    _options$indicator = options.indicator,
    indicator = _options$indicator === void 0 ? {} : _options$indicator;
  var size = indicator.size,
    _indicator$align = indicator.align,
    align = _indicator$align === void 0 ? 'center' : _indicator$align;
  var _useState = (0,react.useState)(),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    inkStyle = _useState2[0],
    setInkStyle = _useState2[1];
  var inkBarRafRef = (0,react.useRef)();
  var getLength = react.useCallback(function (origin) {
    if (typeof size === 'function') {
      return size(origin);
    }
    if (typeof size === 'number') {
      return size;
    }
    return origin;
  }, [size]);

  // Delay set ink style to avoid remove tab blink
  function cleanInkBarRaf() {
    raf/* default.cancel */.Z.cancel(inkBarRafRef.current);
  }
  (0,react.useEffect)(function () {
    var newInkStyle = {};
    if (activeTabOffset) {
      if (horizontal) {
        newInkStyle.width = getLength(activeTabOffset.width);
        var key = rtl ? 'right' : 'left';
        if (align === 'start') {
          newInkStyle[key] = activeTabOffset[key];
        }
        if (align === 'center') {
          newInkStyle[key] = activeTabOffset[key] + activeTabOffset.width / 2;
          newInkStyle.transform = rtl ? 'translateX(50%)' : 'translateX(-50%)';
        }
        if (align === 'end') {
          newInkStyle[key] = activeTabOffset[key] + activeTabOffset.width;
          newInkStyle.transform = 'translateX(-100%)';
        }
      } else {
        newInkStyle.height = getLength(activeTabOffset.height);
        if (align === 'start') {
          newInkStyle.top = activeTabOffset.top;
        }
        if (align === 'center') {
          newInkStyle.top = activeTabOffset.top + activeTabOffset.height / 2;
          newInkStyle.transform = 'translateY(-50%)';
        }
        if (align === 'end') {
          newInkStyle.top = activeTabOffset.top + activeTabOffset.height;
          newInkStyle.transform = 'translateY(-100%)';
        }
      }
    }
    cleanInkBarRaf();
    inkBarRafRef.current = (0,raf/* default */.Z)(function () {
      // Avoid jitter caused by tiny numerical differences
      // fix https://github.com/ant-design/ant-design/issues/53378
      var isEqual = inkStyle && newInkStyle && Object.keys(newInkStyle).every(function (key) {
        var newValue = newInkStyle[key];
        var oldValue = inkStyle[key];
        return typeof newValue === 'number' && typeof oldValue === 'number' ? Math.round(newValue) === Math.round(oldValue) : newValue === oldValue;
      });
      if (!isEqual) {
        setInkStyle(newInkStyle);
      }
    });
    return cleanInkBarRaf;
  }, [JSON.stringify(activeTabOffset), horizontal, rtl, align, getLength]);
  return {
    style: inkStyle
  };
};
/* harmony default export */ var hooks_useIndicator = (useIndicator);
;// CONCATENATED MODULE: ./node_modules/rc-tabs/es/hooks/useOffsets.js


var DEFAULT_SIZE = {
  width: 0,
  height: 0,
  left: 0,
  top: 0
};
function useOffsets(tabs, tabSizes, holderScrollWidth) {
  return (0,react.useMemo)(function () {
    var _tabs$;
    var map = new Map();
    var lastOffset = tabSizes.get((_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key) || DEFAULT_SIZE;
    var rightOffset = lastOffset.left + lastOffset.width;
    for (var i = 0; i < tabs.length; i += 1) {
      var key = tabs[i].key;
      var data = tabSizes.get(key);

      // Reuse last one when not exist yet
      if (!data) {
        var _tabs;
        data = tabSizes.get((_tabs = tabs[i - 1]) === null || _tabs === void 0 ? void 0 : _tabs.key) || DEFAULT_SIZE;
      }
      var entity = map.get(key) || (0,objectSpread2/* default */.Z)({}, data);

      // Right
      entity.right = rightOffset - entity.left - entity.width;

      // Update entity
      map.set(key, entity);
    }
    return map;
  }, [tabs.map(function (tab) {
    return tab.key;
  }).join('_'), tabSizes, holderScrollWidth]);
}
;// CONCATENATED MODULE: ./node_modules/rc-tabs/es/hooks/useSyncState.js


function useSyncState(defaultState, onChange) {
  var stateRef = react.useRef(defaultState);
  var _React$useState = react.useState({}),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    forceUpdate = _React$useState2[1];
  function setState(updater) {
    var newValue = typeof updater === 'function' ? updater(stateRef.current) : updater;
    if (newValue !== stateRef.current) {
      onChange(newValue, stateRef.current);
    }
    stateRef.current = newValue;
    forceUpdate({});
  }
  return [stateRef.current, setState];
}
;// CONCATENATED MODULE: ./node_modules/rc-tabs/es/hooks/useTouchMove.js



var MIN_SWIPE_DISTANCE = 0.1;
var STOP_SWIPE_DISTANCE = 0.01;
var REFRESH_INTERVAL = 20;
var SPEED_OFF_MULTIPLE = Math.pow(0.995, REFRESH_INTERVAL);

// ================================= Hook =================================
function useTouchMove(ref, onOffset) {
  var _useState = (0,react.useState)(),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    touchPosition = _useState2[0],
    setTouchPosition = _useState2[1];
  var _useState3 = (0,react.useState)(0),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    lastTimestamp = _useState4[0],
    setLastTimestamp = _useState4[1];
  var _useState5 = (0,react.useState)(0),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    lastTimeDiff = _useState6[0],
    setLastTimeDiff = _useState6[1];
  var _useState7 = (0,react.useState)(),
    _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
    lastOffset = _useState8[0],
    setLastOffset = _useState8[1];
  var motionRef = (0,react.useRef)();

  // ========================= Events =========================
  // >>> Touch events
  function onTouchStart(e) {
    var _e$touches$ = e.touches[0],
      screenX = _e$touches$.screenX,
      screenY = _e$touches$.screenY;
    setTouchPosition({
      x: screenX,
      y: screenY
    });
    window.clearInterval(motionRef.current);
  }
  function onTouchMove(e) {
    if (!touchPosition) return;

    // e.preventDefault();
    var _e$touches$2 = e.touches[0],
      screenX = _e$touches$2.screenX,
      screenY = _e$touches$2.screenY;
    setTouchPosition({
      x: screenX,
      y: screenY
    });
    var offsetX = screenX - touchPosition.x;
    var offsetY = screenY - touchPosition.y;
    onOffset(offsetX, offsetY);
    var now = Date.now();
    setLastTimestamp(now);
    setLastTimeDiff(now - lastTimestamp);
    setLastOffset({
      x: offsetX,
      y: offsetY
    });
  }
  function onTouchEnd() {
    if (!touchPosition) return;
    setTouchPosition(null);
    setLastOffset(null);

    // Swipe if needed
    if (lastOffset) {
      var distanceX = lastOffset.x / lastTimeDiff;
      var distanceY = lastOffset.y / lastTimeDiff;
      var absX = Math.abs(distanceX);
      var absY = Math.abs(distanceY);

      // Skip swipe if low distance
      if (Math.max(absX, absY) < MIN_SWIPE_DISTANCE) return;
      var currentX = distanceX;
      var currentY = distanceY;
      motionRef.current = window.setInterval(function () {
        if (Math.abs(currentX) < STOP_SWIPE_DISTANCE && Math.abs(currentY) < STOP_SWIPE_DISTANCE) {
          window.clearInterval(motionRef.current);
          return;
        }
        currentX *= SPEED_OFF_MULTIPLE;
        currentY *= SPEED_OFF_MULTIPLE;
        onOffset(currentX * REFRESH_INTERVAL, currentY * REFRESH_INTERVAL);
      }, REFRESH_INTERVAL);
    }
  }

  // >>> Wheel event
  var lastWheelDirectionRef = (0,react.useRef)();
  function onWheel(e) {
    var deltaX = e.deltaX,
      deltaY = e.deltaY;

    // Convert both to x & y since wheel only happened on PC
    var mixed = 0;
    var absX = Math.abs(deltaX);
    var absY = Math.abs(deltaY);
    if (absX === absY) {
      mixed = lastWheelDirectionRef.current === 'x' ? deltaX : deltaY;
    } else if (absX > absY) {
      mixed = deltaX;
      lastWheelDirectionRef.current = 'x';
    } else {
      mixed = deltaY;
      lastWheelDirectionRef.current = 'y';
    }
    if (onOffset(-mixed, -mixed)) {
      e.preventDefault();
    }
  }

  // ========================= Effect =========================
  var touchEventsRef = (0,react.useRef)(null);
  touchEventsRef.current = {
    onTouchStart: onTouchStart,
    onTouchMove: onTouchMove,
    onTouchEnd: onTouchEnd,
    onWheel: onWheel
  };
  react.useEffect(function () {
    function onProxyTouchStart(e) {
      touchEventsRef.current.onTouchStart(e);
    }
    function onProxyTouchMove(e) {
      touchEventsRef.current.onTouchMove(e);
    }
    function onProxyTouchEnd(e) {
      touchEventsRef.current.onTouchEnd(e);
    }
    function onProxyWheel(e) {
      touchEventsRef.current.onWheel(e);
    }
    document.addEventListener('touchmove', onProxyTouchMove, {
      passive: false
    });
    document.addEventListener('touchend', onProxyTouchEnd, {
      passive: true
    });

    // No need to clean up since element removed
    ref.current.addEventListener('touchstart', onProxyTouchStart, {
      passive: true
    });
    ref.current.addEventListener('wheel', onProxyWheel, {
      passive: false
    });
    return function () {
      document.removeEventListener('touchmove', onProxyTouchMove);
      document.removeEventListener('touchend', onProxyTouchEnd);
    };
  }, []);
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useLayoutEffect.js
var useLayoutEffect = __webpack_require__(76963);
;// CONCATENATED MODULE: ./node_modules/rc-tabs/es/hooks/useUpdate.js




/**
 * Help to merge callback with `useLayoutEffect`.
 * One time will only trigger once.
 */
function useUpdate(callback) {
  var _useState = (0,react.useState)(0),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    count = _useState2[0],
    setCount = _useState2[1];
  var effectRef = (0,react.useRef)(0);
  var callbackRef = (0,react.useRef)();
  callbackRef.current = callback;

  // Trigger on `useLayoutEffect`
  (0,useLayoutEffect/* useLayoutUpdateEffect */.o)(function () {
    var _callbackRef$current;
    (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 || _callbackRef$current.call(callbackRef);
  }, [count]);

  // Trigger to update count
  return function () {
    if (effectRef.current !== count) {
      return;
    }
    effectRef.current += 1;
    setCount(effectRef.current);
  };
}
function useUpdateState(defaultState) {
  var batchRef = (0,react.useRef)([]);
  var _useState3 = (0,react.useState)({}),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    forceUpdate = _useState4[1];
  var state = (0,react.useRef)(typeof defaultState === 'function' ? defaultState() : defaultState);
  var flushUpdate = useUpdate(function () {
    var current = state.current;
    batchRef.current.forEach(function (callback) {
      current = callback(current);
    });
    batchRef.current = [];
    state.current = current;
    forceUpdate({});
  });
  function updater(callback) {
    batchRef.current.push(callback);
    flushUpdate();
  }
  return [state.current, updater];
}
;// CONCATENATED MODULE: ./node_modules/rc-tabs/es/hooks/useVisibleRange.js

var useVisibleRange_DEFAULT_SIZE = {
  width: 0,
  height: 0,
  left: 0,
  top: 0,
  right: 0
};
function useVisibleRange(tabOffsets, visibleTabContentValue, transform, tabContentSizeValue, addNodeSizeValue, operationNodeSizeValue, _ref) {
  var tabs = _ref.tabs,
    tabPosition = _ref.tabPosition,
    rtl = _ref.rtl;
  var charUnit;
  var position;
  var transformSize;
  if (['top', 'bottom'].includes(tabPosition)) {
    charUnit = 'width';
    position = rtl ? 'right' : 'left';
    transformSize = Math.abs(transform);
  } else {
    charUnit = 'height';
    position = 'top';
    transformSize = -transform;
  }
  return (0,react.useMemo)(function () {
    if (!tabs.length) {
      return [0, 0];
    }
    var len = tabs.length;
    var endIndex = len;
    for (var i = 0; i < len; i += 1) {
      var offset = tabOffsets.get(tabs[i].key) || useVisibleRange_DEFAULT_SIZE;
      if (Math.floor(offset[position] + offset[charUnit]) > Math.floor(transformSize + visibleTabContentValue)) {
        endIndex = i - 1;
        break;
      }
    }
    var startIndex = 0;
    for (var _i = len - 1; _i >= 0; _i -= 1) {
      var _offset = tabOffsets.get(tabs[_i].key) || useVisibleRange_DEFAULT_SIZE;
      if (_offset[position] < transformSize) {
        startIndex = _i + 1;
        break;
      }
    }
    return startIndex > endIndex ? [0, -1] : [startIndex, endIndex];
  }, [tabOffsets, visibleTabContentValue, tabContentSizeValue, addNodeSizeValue, operationNodeSizeValue, transformSize, tabPosition, tabs.map(function (tab) {
    return tab.key;
  }).join('_'), rtl]);
}
;// CONCATENATED MODULE: ./node_modules/rc-tabs/es/util.js
/**
 * We trade Map as deps which may change with same value but different ref object.
 * We should make it as hash for deps
 * */
function stringify(obj) {
  var tgt;
  if (obj instanceof Map) {
    tgt = {};
    obj.forEach(function (v, k) {
      tgt[k] = v;
    });
  } else {
    tgt = obj;
  }
  return JSON.stringify(tgt);
}
var RC_TABS_DOUBLE_QUOTE = 'TABS_DQ';
function genDataNodeKey(key) {
  return String(key).replace(/"/g, RC_TABS_DOUBLE_QUOTE);
}
function getRemovable(closable, closeIcon, editable, disabled) {
  if (
  // Only editable tabs can be removed
  !editable ||
  // Tabs cannot be removed when disabled
  disabled ||
  // closable is false
  closable === false ||
  // If closable is undefined, the remove button should be hidden when closeIcon is null or false
  closable === undefined && (closeIcon === false || closeIcon === null)) {
    return false;
  }
  return true;
}
;// CONCATENATED MODULE: ./node_modules/rc-tabs/es/TabNavList/AddButton.js

var AddButton = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    editable = props.editable,
    locale = props.locale,
    style = props.style;
  if (!editable || editable.showAdd === false) {
    return null;
  }
  return /*#__PURE__*/react.createElement("button", {
    ref: ref,
    type: "button",
    className: "".concat(prefixCls, "-nav-add"),
    style: style,
    "aria-label": (locale === null || locale === void 0 ? void 0 : locale.addAriaLabel) || 'Add tab',
    onClick: function onClick(event) {
      editable.onEdit('add', {
        event: event
      });
    }
  }, editable.addIcon || '+');
});
/* harmony default export */ var TabNavList_AddButton = (AddButton);
;// CONCATENATED MODULE: ./node_modules/rc-tabs/es/TabNavList/ExtraContent.js


var ExtraContent = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var position = props.position,
    prefixCls = props.prefixCls,
    extra = props.extra;
  if (!extra) {
    return null;
  }
  var content;

  // Parse extra
  var assertExtra = {};
  if ((0,esm_typeof/* default */.Z)(extra) === 'object' && ! /*#__PURE__*/react.isValidElement(extra)) {
    assertExtra = extra;
  } else {
    assertExtra.right = extra;
  }
  if (position === 'right') {
    content = assertExtra.right;
  }
  if (position === 'left') {
    content = assertExtra.left;
  }
  return content ? /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-extra-content"),
    ref: ref
  }, content) : null;
});
if (false) {}
/* harmony default export */ var TabNavList_ExtraContent = (ExtraContent);
// EXTERNAL MODULE: ./node_modules/rc-dropdown/es/index.js + 4 modules
var rc_dropdown_es = __webpack_require__(93755);
// EXTERNAL MODULE: ./node_modules/rc-menu/es/index.js + 26 modules
var rc_menu_es = __webpack_require__(2369);
// EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js
var KeyCode = __webpack_require__(88035);
;// CONCATENATED MODULE: ./node_modules/rc-tabs/es/TabNavList/OperationNode.js











var OperationNode = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    id = props.id,
    tabs = props.tabs,
    locale = props.locale,
    mobile = props.mobile,
    _props$more = props.more,
    moreProps = _props$more === void 0 ? {} : _props$more,
    style = props.style,
    className = props.className,
    editable = props.editable,
    tabBarGutter = props.tabBarGutter,
    rtl = props.rtl,
    removeAriaLabel = props.removeAriaLabel,
    onTabClick = props.onTabClick,
    getPopupContainer = props.getPopupContainer,
    popupClassName = props.popupClassName;
  // ======================== Dropdown ========================
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0,react.useState)(null),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    selectedKey = _useState4[0],
    setSelectedKey = _useState4[1];
  var _moreProps$icon = moreProps.icon,
    moreIcon = _moreProps$icon === void 0 ? 'More' : _moreProps$icon;
  var popupId = "".concat(id, "-more-popup");
  var dropdownPrefix = "".concat(prefixCls, "-dropdown");
  var selectedItemId = selectedKey !== null ? "".concat(popupId, "-").concat(selectedKey) : null;
  var dropdownAriaLabel = locale === null || locale === void 0 ? void 0 : locale.dropdownAriaLabel;
  function onRemoveTab(event, key) {
    event.preventDefault();
    event.stopPropagation();
    editable.onEdit('remove', {
      key: key,
      event: event
    });
  }
  var menu = /*#__PURE__*/react.createElement(rc_menu_es/* default */.ZP, {
    onClick: function onClick(_ref) {
      var key = _ref.key,
        domEvent = _ref.domEvent;
      onTabClick(key, domEvent);
      setOpen(false);
    },
    prefixCls: "".concat(dropdownPrefix, "-menu"),
    id: popupId,
    tabIndex: -1,
    role: "listbox",
    "aria-activedescendant": selectedItemId,
    selectedKeys: [selectedKey],
    "aria-label": dropdownAriaLabel !== undefined ? dropdownAriaLabel : 'expanded dropdown'
  }, tabs.map(function (tab) {
    var closable = tab.closable,
      disabled = tab.disabled,
      closeIcon = tab.closeIcon,
      key = tab.key,
      label = tab.label;
    var removable = getRemovable(closable, closeIcon, editable, disabled);
    return /*#__PURE__*/react.createElement(rc_menu_es/* MenuItem */.sN, {
      key: key,
      id: "".concat(popupId, "-").concat(key),
      role: "option",
      "aria-controls": id && "".concat(id, "-panel-").concat(key),
      disabled: disabled
    }, /*#__PURE__*/react.createElement("span", null, label), removable && /*#__PURE__*/react.createElement("button", {
      type: "button",
      "aria-label": removeAriaLabel || 'remove',
      tabIndex: 0,
      className: "".concat(dropdownPrefix, "-menu-item-remove"),
      onClick: function onClick(e) {
        e.stopPropagation();
        onRemoveTab(e, key);
      }
    }, closeIcon || editable.removeIcon || '×'));
  }));
  function selectOffset(offset) {
    var enabledTabs = tabs.filter(function (tab) {
      return !tab.disabled;
    });
    var selectedIndex = enabledTabs.findIndex(function (tab) {
      return tab.key === selectedKey;
    }) || 0;
    var len = enabledTabs.length;
    for (var i = 0; i < len; i += 1) {
      selectedIndex = (selectedIndex + offset + len) % len;
      var tab = enabledTabs[selectedIndex];
      if (!tab.disabled) {
        setSelectedKey(tab.key);
        return;
      }
    }
  }
  function onKeyDown(e) {
    var which = e.which;
    if (!open) {
      if ([KeyCode/* default.DOWN */.Z.DOWN, KeyCode/* default.SPACE */.Z.SPACE, KeyCode/* default.ENTER */.Z.ENTER].includes(which)) {
        setOpen(true);
        e.preventDefault();
      }
      return;
    }
    switch (which) {
      case KeyCode/* default.UP */.Z.UP:
        selectOffset(-1);
        e.preventDefault();
        break;
      case KeyCode/* default.DOWN */.Z.DOWN:
        selectOffset(1);
        e.preventDefault();
        break;
      case KeyCode/* default.ESC */.Z.ESC:
        setOpen(false);
        break;
      case KeyCode/* default.SPACE */.Z.SPACE:
      case KeyCode/* default.ENTER */.Z.ENTER:
        if (selectedKey !== null) {
          onTabClick(selectedKey, e);
        }
        break;
    }
  }

  // ========================= Effect =========================
  (0,react.useEffect)(function () {
    // We use query element here to avoid React strict warning
    var ele = document.getElementById(selectedItemId);
    if (ele && ele.scrollIntoView) {
      ele.scrollIntoView(false);
    }
  }, [selectedKey]);
  (0,react.useEffect)(function () {
    if (!open) {
      setSelectedKey(null);
    }
  }, [open]);

  // ========================= Render =========================
  var moreStyle = (0,defineProperty/* default */.Z)({}, rtl ? 'marginRight' : 'marginLeft', tabBarGutter);
  if (!tabs.length) {
    moreStyle.visibility = 'hidden';
    moreStyle.order = 1;
  }
  var overlayClassName = classnames_default()((0,defineProperty/* default */.Z)({}, "".concat(dropdownPrefix, "-rtl"), rtl));
  var moreNode = mobile ? null : /*#__PURE__*/react.createElement(rc_dropdown_es/* default */.Z, (0,esm_extends/* default */.Z)({
    prefixCls: dropdownPrefix,
    overlay: menu,
    visible: tabs.length ? open : false,
    onVisibleChange: setOpen,
    overlayClassName: classnames_default()(overlayClassName, popupClassName),
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    getPopupContainer: getPopupContainer
  }, moreProps), /*#__PURE__*/react.createElement("button", {
    type: "button",
    className: "".concat(prefixCls, "-nav-more"),
    style: moreStyle,
    "aria-haspopup": "listbox",
    "aria-controls": popupId,
    id: "".concat(id, "-more"),
    "aria-expanded": open,
    onKeyDown: onKeyDown
  }, moreIcon));
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(prefixCls, "-nav-operations"), className),
    style: style,
    ref: ref
  }, moreNode, /*#__PURE__*/react.createElement(TabNavList_AddButton, {
    prefixCls: prefixCls,
    locale: locale,
    editable: editable
  }));
});
/* harmony default export */ var TabNavList_OperationNode = (/*#__PURE__*/react.memo(OperationNode, function (_, next) {
  return (
    // https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    next.tabMoving
  );
}));
;// CONCATENATED MODULE: ./node_modules/rc-tabs/es/TabNavList/TabNode.js




var TabNode = function TabNode(props) {
  var prefixCls = props.prefixCls,
    id = props.id,
    active = props.active,
    focus = props.focus,
    _props$tab = props.tab,
    key = _props$tab.key,
    label = _props$tab.label,
    disabled = _props$tab.disabled,
    closeIcon = _props$tab.closeIcon,
    icon = _props$tab.icon,
    closable = props.closable,
    renderWrapper = props.renderWrapper,
    removeAriaLabel = props.removeAriaLabel,
    editable = props.editable,
    onClick = props.onClick,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onKeyDown = props.onKeyDown,
    onMouseDown = props.onMouseDown,
    onMouseUp = props.onMouseUp,
    style = props.style,
    tabCount = props.tabCount,
    currentPosition = props.currentPosition;
  var tabPrefix = "".concat(prefixCls, "-tab");
  var removable = getRemovable(closable, closeIcon, editable, disabled);
  function onInternalClick(e) {
    if (disabled) {
      return;
    }
    onClick(e);
  }
  function onRemoveTab(event) {
    event.preventDefault();
    event.stopPropagation();
    editable.onEdit('remove', {
      key: key,
      event: event
    });
  }
  var labelNode = react.useMemo(function () {
    return icon && typeof label === 'string' ? /*#__PURE__*/react.createElement("span", null, label) : label;
  }, [label, icon]);
  var btnRef = react.useRef(null);
  react.useEffect(function () {
    if (focus && btnRef.current) {
      btnRef.current.focus();
    }
  }, [focus]);
  var node = /*#__PURE__*/react.createElement("div", {
    key: key,
    "data-node-key": genDataNodeKey(key),
    className: classnames_default()(tabPrefix, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(tabPrefix, "-with-remove"), removable), "".concat(tabPrefix, "-active"), active), "".concat(tabPrefix, "-disabled"), disabled), "".concat(tabPrefix, "-focus"), focus)),
    style: style,
    onClick: onInternalClick
  }, /*#__PURE__*/react.createElement("div", {
    ref: btnRef,
    role: "tab",
    "aria-selected": active,
    id: id && "".concat(id, "-tab-").concat(key),
    className: "".concat(tabPrefix, "-btn"),
    "aria-controls": id && "".concat(id, "-panel-").concat(key),
    "aria-disabled": disabled,
    tabIndex: disabled ? null : active ? 0 : -1,
    onClick: function onClick(e) {
      e.stopPropagation();
      onInternalClick(e);
    },
    onKeyDown: onKeyDown,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    onFocus: onFocus,
    onBlur: onBlur
  }, focus && /*#__PURE__*/react.createElement("div", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: 'absolute',
      overflow: 'hidden',
      opacity: 0
    }
  }, "Tab ".concat(currentPosition, " of ").concat(tabCount)), icon && /*#__PURE__*/react.createElement("span", {
    className: "".concat(tabPrefix, "-icon")
  }, icon), label && labelNode), removable && /*#__PURE__*/react.createElement("button", {
    type: "button",
    role: "tab",
    "aria-label": removeAriaLabel || 'remove',
    tabIndex: active ? 0 : -1,
    className: "".concat(tabPrefix, "-remove"),
    onClick: function onClick(e) {
      e.stopPropagation();
      onRemoveTab(e);
    }
  }, closeIcon || editable.removeIcon || '×'));
  return renderWrapper ? renderWrapper(node) : node;
};
/* harmony default export */ var TabNavList_TabNode = (TabNode);
;// CONCATENATED MODULE: ./node_modules/rc-tabs/es/TabNavList/index.js





/* eslint-disable react-hooks/exhaustive-deps */


















var getTabSize = function getTabSize(tab, containerRect) {
  // tabListRef
  var offsetWidth = tab.offsetWidth,
    offsetHeight = tab.offsetHeight,
    offsetTop = tab.offsetTop,
    offsetLeft = tab.offsetLeft;
  var _tab$getBoundingClien = tab.getBoundingClientRect(),
    width = _tab$getBoundingClien.width,
    height = _tab$getBoundingClien.height,
    left = _tab$getBoundingClien.left,
    top = _tab$getBoundingClien.top;

  // Use getBoundingClientRect to avoid decimal inaccuracy
  if (Math.abs(width - offsetWidth) < 1) {
    return [width, height, left - containerRect.left, top - containerRect.top];
  }
  return [offsetWidth, offsetHeight, offsetLeft, offsetTop];
};
var getSize = function getSize(refObj) {
  var _ref = refObj.current || {},
    _ref$offsetWidth = _ref.offsetWidth,
    offsetWidth = _ref$offsetWidth === void 0 ? 0 : _ref$offsetWidth,
    _ref$offsetHeight = _ref.offsetHeight,
    offsetHeight = _ref$offsetHeight === void 0 ? 0 : _ref$offsetHeight;

  // Use getBoundingClientRect to avoid decimal inaccuracy
  if (refObj.current) {
    var _refObj$current$getBo = refObj.current.getBoundingClientRect(),
      width = _refObj$current$getBo.width,
      height = _refObj$current$getBo.height;
    if (Math.abs(width - offsetWidth) < 1) {
      return [width, height];
    }
  }
  return [offsetWidth, offsetHeight];
};

/**
 * Convert `SizeInfo` to unit value. Such as [123, 456] with `top` position get `123`
 */
var getUnitValue = function getUnitValue(size, tabPositionTopOrBottom) {
  return size[tabPositionTopOrBottom ? 0 : 1];
};
var TabNavList = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var className = props.className,
    style = props.style,
    id = props.id,
    animated = props.animated,
    activeKey = props.activeKey,
    rtl = props.rtl,
    extra = props.extra,
    editable = props.editable,
    locale = props.locale,
    tabPosition = props.tabPosition,
    tabBarGutter = props.tabBarGutter,
    children = props.children,
    onTabClick = props.onTabClick,
    onTabScroll = props.onTabScroll,
    indicator = props.indicator;
  var _React$useContext = react.useContext(TabContext),
    prefixCls = _React$useContext.prefixCls,
    tabs = _React$useContext.tabs;
  var containerRef = (0,react.useRef)(null);
  var extraLeftRef = (0,react.useRef)(null);
  var extraRightRef = (0,react.useRef)(null);
  var tabsWrapperRef = (0,react.useRef)(null);
  var tabListRef = (0,react.useRef)(null);
  var operationsRef = (0,react.useRef)(null);
  var innerAddButtonRef = (0,react.useRef)(null);
  var tabPositionTopOrBottom = tabPosition === 'top' || tabPosition === 'bottom';
  var _useSyncState = useSyncState(0, function (next, prev) {
      if (tabPositionTopOrBottom && onTabScroll) {
        onTabScroll({
          direction: next > prev ? 'left' : 'right'
        });
      }
    }),
    _useSyncState2 = (0,slicedToArray/* default */.Z)(_useSyncState, 2),
    transformLeft = _useSyncState2[0],
    setTransformLeft = _useSyncState2[1];
  var _useSyncState3 = useSyncState(0, function (next, prev) {
      if (!tabPositionTopOrBottom && onTabScroll) {
        onTabScroll({
          direction: next > prev ? 'top' : 'bottom'
        });
      }
    }),
    _useSyncState4 = (0,slicedToArray/* default */.Z)(_useSyncState3, 2),
    transformTop = _useSyncState4[0],
    setTransformTop = _useSyncState4[1];
  var _useState = (0,react.useState)([0, 0]),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    containerExcludeExtraSize = _useState2[0],
    setContainerExcludeExtraSize = _useState2[1];
  var _useState3 = (0,react.useState)([0, 0]),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    tabContentSize = _useState4[0],
    setTabContentSize = _useState4[1];
  var _useState5 = (0,react.useState)([0, 0]),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    addSize = _useState6[0],
    setAddSize = _useState6[1];
  var _useState7 = (0,react.useState)([0, 0]),
    _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
    operationSize = _useState8[0],
    setOperationSize = _useState8[1];
  var _useUpdateState = useUpdateState(new Map()),
    _useUpdateState2 = (0,slicedToArray/* default */.Z)(_useUpdateState, 2),
    tabSizes = _useUpdateState2[0],
    setTabSizes = _useUpdateState2[1];
  var tabOffsets = useOffsets(tabs, tabSizes, tabContentSize[0]);

  // ========================== Unit =========================
  var containerExcludeExtraSizeValue = getUnitValue(containerExcludeExtraSize, tabPositionTopOrBottom);
  var tabContentSizeValue = getUnitValue(tabContentSize, tabPositionTopOrBottom);
  var addSizeValue = getUnitValue(addSize, tabPositionTopOrBottom);
  var operationSizeValue = getUnitValue(operationSize, tabPositionTopOrBottom);
  var needScroll = Math.floor(containerExcludeExtraSizeValue) < Math.floor(tabContentSizeValue + addSizeValue);
  var visibleTabContentValue = needScroll ? containerExcludeExtraSizeValue - operationSizeValue : containerExcludeExtraSizeValue - addSizeValue;

  // ========================== Util =========================
  var operationsHiddenClassName = "".concat(prefixCls, "-nav-operations-hidden");
  var transformMin = 0;
  var transformMax = 0;
  if (!tabPositionTopOrBottom) {
    transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
    transformMax = 0;
  } else if (rtl) {
    transformMin = 0;
    transformMax = Math.max(0, tabContentSizeValue - visibleTabContentValue);
  } else {
    transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
    transformMax = 0;
  }
  function alignInRange(value) {
    if (value < transformMin) {
      return transformMin;
    }
    if (value > transformMax) {
      return transformMax;
    }
    return value;
  }

  // ========================= Mobile ========================
  var touchMovingRef = (0,react.useRef)(null);
  var _useState9 = (0,react.useState)(),
    _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
    lockAnimation = _useState10[0],
    setLockAnimation = _useState10[1];
  function doLockAnimation() {
    setLockAnimation(Date.now());
  }
  function clearTouchMoving() {
    if (touchMovingRef.current) {
      clearTimeout(touchMovingRef.current);
    }
  }
  useTouchMove(tabsWrapperRef, function (offsetX, offsetY) {
    function doMove(setState, offset) {
      setState(function (value) {
        var newValue = alignInRange(value + offset);
        return newValue;
      });
    }

    // Skip scroll if place is enough
    if (!needScroll) {
      return false;
    }
    if (tabPositionTopOrBottom) {
      doMove(setTransformLeft, offsetX);
    } else {
      doMove(setTransformTop, offsetY);
    }
    clearTouchMoving();
    doLockAnimation();
    return true;
  });
  (0,react.useEffect)(function () {
    clearTouchMoving();
    if (lockAnimation) {
      touchMovingRef.current = setTimeout(function () {
        setLockAnimation(0);
      }, 100);
    }
    return clearTouchMoving;
  }, [lockAnimation]);

  // ===================== Visible Range =====================
  // Render tab node & collect tab offset
  var _useVisibleRange = useVisibleRange(tabOffsets,
    // Container
    visibleTabContentValue,
    // Transform
    tabPositionTopOrBottom ? transformLeft : transformTop,
    // Tabs
    tabContentSizeValue,
    // Add
    addSizeValue,
    // Operation
    operationSizeValue, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
      tabs: tabs
    })),
    _useVisibleRange2 = (0,slicedToArray/* default */.Z)(_useVisibleRange, 2),
    visibleStart = _useVisibleRange2[0],
    visibleEnd = _useVisibleRange2[1];

  // ========================= Scroll ========================
  var scrollToTab = (0,useEvent/* default */.Z)(function () {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : activeKey;
    var tabOffset = tabOffsets.get(key) || {
      width: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0
    };
    if (tabPositionTopOrBottom) {
      // ============ Align with top & bottom ============
      var newTransform = transformLeft;

      // RTL
      if (rtl) {
        if (tabOffset.right < transformLeft) {
          newTransform = tabOffset.right;
        } else if (tabOffset.right + tabOffset.width > transformLeft + visibleTabContentValue) {
          newTransform = tabOffset.right + tabOffset.width - visibleTabContentValue;
        }
      }
      // LTR
      else if (tabOffset.left < -transformLeft) {
        newTransform = -tabOffset.left;
      } else if (tabOffset.left + tabOffset.width > -transformLeft + visibleTabContentValue) {
        newTransform = -(tabOffset.left + tabOffset.width - visibleTabContentValue);
      }
      setTransformTop(0);
      setTransformLeft(alignInRange(newTransform));
    } else {
      // ============ Align with left & right ============
      var _newTransform = transformTop;
      if (tabOffset.top < -transformTop) {
        _newTransform = -tabOffset.top;
      } else if (tabOffset.top + tabOffset.height > -transformTop + visibleTabContentValue) {
        _newTransform = -(tabOffset.top + tabOffset.height - visibleTabContentValue);
      }
      setTransformLeft(0);
      setTransformTop(alignInRange(_newTransform));
    }
  });

  // ========================= Focus =========================
  var _useState11 = (0,react.useState)(),
    _useState12 = (0,slicedToArray/* default */.Z)(_useState11, 2),
    focusKey = _useState12[0],
    setFocusKey = _useState12[1];
  var _useState13 = (0,react.useState)(false),
    _useState14 = (0,slicedToArray/* default */.Z)(_useState13, 2),
    isMouse = _useState14[0],
    setIsMouse = _useState14[1];
  var enabledTabs = tabs.filter(function (tab) {
    return !tab.disabled;
  }).map(function (tab) {
    return tab.key;
  });
  var onOffset = function onOffset(offset) {
    var currentIndex = enabledTabs.indexOf(focusKey || activeKey);
    var len = enabledTabs.length;
    var nextIndex = (currentIndex + offset + len) % len;
    var newKey = enabledTabs[nextIndex];
    setFocusKey(newKey);
  };
  var handleRemoveTab = function handleRemoveTab(removalTabKey, e) {
    var removeIndex = enabledTabs.indexOf(removalTabKey);
    var removeTab = tabs.find(function (tab) {
      return tab.key === removalTabKey;
    });
    var removable = getRemovable(removeTab === null || removeTab === void 0 ? void 0 : removeTab.closable, removeTab === null || removeTab === void 0 ? void 0 : removeTab.closeIcon, editable, removeTab === null || removeTab === void 0 ? void 0 : removeTab.disabled);
    if (removable) {
      e.preventDefault();
      e.stopPropagation();
      editable.onEdit('remove', {
        key: removalTabKey,
        event: e
      });

      // when remove last tab, focus previous tab
      if (removeIndex === enabledTabs.length - 1) {
        onOffset(-1);
      } else {
        onOffset(1);
      }
    }
  };
  var handleMouseDown = function handleMouseDown(key, e) {
    setIsMouse(true);
    // Middle mouse button
    if (e.button === 1) {
      handleRemoveTab(key, e);
    }
  };
  var handleKeyDown = function handleKeyDown(e) {
    var code = e.code;
    var isRTL = rtl && tabPositionTopOrBottom;
    var firstEnabledTab = enabledTabs[0];
    var lastEnabledTab = enabledTabs[enabledTabs.length - 1];
    switch (code) {
      // LEFT
      case 'ArrowLeft':
        {
          if (tabPositionTopOrBottom) {
            onOffset(isRTL ? 1 : -1);
          }
          break;
        }

      // RIGHT
      case 'ArrowRight':
        {
          if (tabPositionTopOrBottom) {
            onOffset(isRTL ? -1 : 1);
          }
          break;
        }

      // UP
      case 'ArrowUp':
        {
          e.preventDefault();
          if (!tabPositionTopOrBottom) {
            onOffset(-1);
          }
          break;
        }

      // DOWN
      case 'ArrowDown':
        {
          e.preventDefault();
          if (!tabPositionTopOrBottom) {
            onOffset(1);
          }
          break;
        }

      // HOME
      case 'Home':
        {
          e.preventDefault();
          setFocusKey(firstEnabledTab);
          break;
        }

      // END
      case 'End':
        {
          e.preventDefault();
          setFocusKey(lastEnabledTab);
          break;
        }

      // Enter & Space
      case 'Enter':
      case 'Space':
        {
          e.preventDefault();
          onTabClick(focusKey !== null && focusKey !== void 0 ? focusKey : activeKey, e);
          break;
        }
      // Backspace
      case 'Backspace':
      case 'Delete':
        {
          handleRemoveTab(focusKey, e);
          break;
        }
    }
  };

  // ========================== Tab ==========================
  var tabNodeStyle = {};
  if (tabPositionTopOrBottom) {
    tabNodeStyle[rtl ? 'marginRight' : 'marginLeft'] = tabBarGutter;
  } else {
    tabNodeStyle.marginTop = tabBarGutter;
  }
  var tabNodes = tabs.map(function (tab, i) {
    var key = tab.key;
    return /*#__PURE__*/react.createElement(TabNavList_TabNode, {
      id: id,
      prefixCls: prefixCls,
      key: key,
      tab: tab
      /* first node should not have margin left */,
      style: i === 0 ? undefined : tabNodeStyle,
      closable: tab.closable,
      editable: editable,
      active: key === activeKey,
      focus: key === focusKey,
      renderWrapper: children,
      removeAriaLabel: locale === null || locale === void 0 ? void 0 : locale.removeAriaLabel,
      tabCount: enabledTabs.length,
      currentPosition: i + 1,
      onClick: function onClick(e) {
        onTabClick(key, e);
      },
      onKeyDown: handleKeyDown,
      onFocus: function onFocus() {
        if (!isMouse) {
          setFocusKey(key);
        }
        scrollToTab(key);
        doLockAnimation();
        if (!tabsWrapperRef.current) {
          return;
        }
        // Focus element will make scrollLeft change which we should reset back
        if (!rtl) {
          tabsWrapperRef.current.scrollLeft = 0;
        }
        tabsWrapperRef.current.scrollTop = 0;
      },
      onBlur: function onBlur() {
        setFocusKey(undefined);
      },
      onMouseDown: function onMouseDown(e) {
        return handleMouseDown(key, e);
      },
      onMouseUp: function onMouseUp() {
        setIsMouse(false);
      }
    });
  });

  // Update buttons records
  var updateTabSizes = function updateTabSizes() {
    return setTabSizes(function () {
      var _tabListRef$current;
      var newSizes = new Map();
      var listRect = (_tabListRef$current = tabListRef.current) === null || _tabListRef$current === void 0 ? void 0 : _tabListRef$current.getBoundingClientRect();
      tabs.forEach(function (_ref2) {
        var _tabListRef$current2;
        var key = _ref2.key;
        var btnNode = (_tabListRef$current2 = tabListRef.current) === null || _tabListRef$current2 === void 0 ? void 0 : _tabListRef$current2.querySelector("[data-node-key=\"".concat(genDataNodeKey(key), "\"]"));
        if (btnNode) {
          var _getTabSize = getTabSize(btnNode, listRect),
            _getTabSize2 = (0,slicedToArray/* default */.Z)(_getTabSize, 4),
            width = _getTabSize2[0],
            height = _getTabSize2[1],
            left = _getTabSize2[2],
            top = _getTabSize2[3];
          newSizes.set(key, {
            width: width,
            height: height,
            left: left,
            top: top
          });
        }
      });
      return newSizes;
    });
  };
  (0,react.useEffect)(function () {
    updateTabSizes();
  }, [tabs.map(function (tab) {
    return tab.key;
  }).join('_')]);
  var onListHolderResize = useUpdate(function () {
    // Update wrapper records
    var containerSize = getSize(containerRef);
    var extraLeftSize = getSize(extraLeftRef);
    var extraRightSize = getSize(extraRightRef);
    setContainerExcludeExtraSize([containerSize[0] - extraLeftSize[0] - extraRightSize[0], containerSize[1] - extraLeftSize[1] - extraRightSize[1]]);
    var newAddSize = getSize(innerAddButtonRef);
    setAddSize(newAddSize);
    var newOperationSize = getSize(operationsRef);
    setOperationSize(newOperationSize);

    // Which includes add button size
    var tabContentFullSize = getSize(tabListRef);
    setTabContentSize([tabContentFullSize[0] - newAddSize[0], tabContentFullSize[1] - newAddSize[1]]);

    // Update buttons records
    updateTabSizes();
  });

  // ======================== Dropdown =======================
  var startHiddenTabs = tabs.slice(0, visibleStart);
  var endHiddenTabs = tabs.slice(visibleEnd + 1);
  var hiddenTabs = [].concat((0,toConsumableArray/* default */.Z)(startHiddenTabs), (0,toConsumableArray/* default */.Z)(endHiddenTabs));

  // =================== Link & Operations ===================
  var activeTabOffset = tabOffsets.get(activeKey);
  var _useIndicator = hooks_useIndicator({
      activeTabOffset: activeTabOffset,
      horizontal: tabPositionTopOrBottom,
      indicator: indicator,
      rtl: rtl
    }),
    indicatorStyle = _useIndicator.style;

  // ========================= Effect ========================
  (0,react.useEffect)(function () {
    scrollToTab();
  }, [activeKey, transformMin, transformMax, stringify(activeTabOffset), stringify(tabOffsets), tabPositionTopOrBottom]);

  // Should recalculate when rtl changed
  (0,react.useEffect)(function () {
    onListHolderResize();
    // eslint-disable-next-line
  }, [rtl]);

  // ========================= Render ========================
  var hasDropdown = !!hiddenTabs.length;
  var wrapPrefix = "".concat(prefixCls, "-nav-wrap");
  var pingLeft;
  var pingRight;
  var pingTop;
  var pingBottom;
  if (tabPositionTopOrBottom) {
    if (rtl) {
      pingRight = transformLeft > 0;
      pingLeft = transformLeft !== transformMax;
    } else {
      pingLeft = transformLeft < 0;
      pingRight = transformLeft !== transformMin;
    }
  } else {
    pingTop = transformTop < 0;
    pingBottom = transformTop !== transformMin;
  }
  return /*#__PURE__*/react.createElement(es/* default */.Z, {
    onResize: onListHolderResize
  }, /*#__PURE__*/react.createElement("div", {
    ref: (0,es_ref/* useComposeRef */.x1)(ref, containerRef),
    role: "tablist",
    "aria-orientation": tabPositionTopOrBottom ? 'horizontal' : 'vertical',
    className: classnames_default()("".concat(prefixCls, "-nav"), className),
    style: style,
    onKeyDown: function onKeyDown() {
      // No need animation when use keyboard
      doLockAnimation();
    }
  }, /*#__PURE__*/react.createElement(TabNavList_ExtraContent, {
    ref: extraLeftRef,
    position: "left",
    extra: extra,
    prefixCls: prefixCls
  }), /*#__PURE__*/react.createElement(es/* default */.Z, {
    onResize: onListHolderResize
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(wrapPrefix, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(wrapPrefix, "-ping-left"), pingLeft), "".concat(wrapPrefix, "-ping-right"), pingRight), "".concat(wrapPrefix, "-ping-top"), pingTop), "".concat(wrapPrefix, "-ping-bottom"), pingBottom)),
    ref: tabsWrapperRef
  }, /*#__PURE__*/react.createElement(es/* default */.Z, {
    onResize: onListHolderResize
  }, /*#__PURE__*/react.createElement("div", {
    ref: tabListRef,
    className: "".concat(prefixCls, "-nav-list"),
    style: {
      transform: "translate(".concat(transformLeft, "px, ").concat(transformTop, "px)"),
      transition: lockAnimation ? 'none' : undefined
    }
  }, tabNodes, /*#__PURE__*/react.createElement(TabNavList_AddButton, {
    ref: innerAddButtonRef,
    prefixCls: prefixCls,
    locale: locale,
    editable: editable,
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, tabNodes.length === 0 ? undefined : tabNodeStyle), {}, {
      visibility: hasDropdown ? 'hidden' : null
    })
  }), /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(prefixCls, "-ink-bar"), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-ink-bar-animated"), animated.inkBar)),
    style: indicatorStyle
  }))))), /*#__PURE__*/react.createElement(TabNavList_OperationNode, (0,esm_extends/* default */.Z)({}, props, {
    removeAriaLabel: locale === null || locale === void 0 ? void 0 : locale.removeAriaLabel,
    ref: operationsRef,
    prefixCls: prefixCls,
    tabs: hiddenTabs,
    className: !hasDropdown && operationsHiddenClassName,
    tabMoving: !!lockAnimation
  })), /*#__PURE__*/react.createElement(TabNavList_ExtraContent, {
    ref: extraRightRef,
    position: "right",
    extra: extra,
    prefixCls: prefixCls
  })));
  /* eslint-enable */
});
/* harmony default export */ var es_TabNavList = (TabNavList);
;// CONCATENATED MODULE: ./node_modules/rc-tabs/es/TabPanelList/TabPane.js


var TabPane = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    className = props.className,
    style = props.style,
    id = props.id,
    active = props.active,
    tabKey = props.tabKey,
    children = props.children;
  return /*#__PURE__*/react.createElement("div", {
    id: id && "".concat(id, "-panel-").concat(tabKey),
    role: "tabpanel",
    tabIndex: active ? 0 : -1,
    "aria-labelledby": id && "".concat(id, "-tab-").concat(tabKey),
    "aria-hidden": !active,
    style: style,
    className: classnames_default()(prefixCls, active && "".concat(prefixCls, "-active"), className),
    ref: ref
  }, children);
});
if (false) {}
/* harmony default export */ var TabPanelList_TabPane = (TabPane);
;// CONCATENATED MODULE: ./node_modules/rc-tabs/es/TabNavList/Wrapper.js



var _excluded = ["renderTabBar"],
  _excluded2 = ["label", "key"];
// zombieJ: To compatible with `renderTabBar` usage.





// We have to create a TabNavList components.
var TabNavListWrapper = function TabNavListWrapper(_ref) {
  var renderTabBar = _ref.renderTabBar,
    restProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  var _React$useContext = react.useContext(TabContext),
    tabs = _React$useContext.tabs;
  if (renderTabBar) {
    var tabNavBarProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, restProps), {}, {
      // Legacy support. We do not use this actually
      panes: tabs.map(function (_ref2) {
        var label = _ref2.label,
          key = _ref2.key,
          restTabProps = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded2);
        return /*#__PURE__*/react.createElement(TabPanelList_TabPane, (0,esm_extends/* default */.Z)({
          tab: label,
          key: key,
          tabKey: key
        }, restTabProps));
      })
    });
    return renderTabBar(tabNavBarProps, es_TabNavList);
  }
  return /*#__PURE__*/react.createElement(es_TabNavList, restProps);
};
if (false) {}
/* harmony default export */ var Wrapper = (TabNavListWrapper);
// EXTERNAL MODULE: ./node_modules/rc-motion/es/index.js + 13 modules
var rc_motion_es = __webpack_require__(26981);
;// CONCATENATED MODULE: ./node_modules/rc-tabs/es/TabPanelList/index.js




var TabPanelList_excluded = ["key", "forceRender", "style", "className", "destroyInactiveTabPane"];





var TabPanelList = function TabPanelList(props) {
  var id = props.id,
    activeKey = props.activeKey,
    animated = props.animated,
    tabPosition = props.tabPosition,
    destroyInactiveTabPane = props.destroyInactiveTabPane;
  var _React$useContext = react.useContext(TabContext),
    prefixCls = _React$useContext.prefixCls,
    tabs = _React$useContext.tabs;
  var tabPaneAnimated = animated.tabPane;
  var tabPanePrefixCls = "".concat(prefixCls, "-tabpane");
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(prefixCls, "-content-holder"))
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(prefixCls, "-content"), "".concat(prefixCls, "-content-").concat(tabPosition), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-content-animated"), tabPaneAnimated))
  }, tabs.map(function (item) {
    var key = item.key,
      forceRender = item.forceRender,
      paneStyle = item.style,
      paneClassName = item.className,
      itemDestroyInactiveTabPane = item.destroyInactiveTabPane,
      restTabProps = (0,objectWithoutProperties/* default */.Z)(item, TabPanelList_excluded);
    var active = key === activeKey;
    return /*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, (0,esm_extends/* default */.Z)({
      key: key,
      visible: active,
      forceRender: forceRender,
      removeOnLeave: !!(destroyInactiveTabPane || itemDestroyInactiveTabPane),
      leavedClassName: "".concat(tabPanePrefixCls, "-hidden")
    }, animated.tabPaneMotion), function (_ref, ref) {
      var motionStyle = _ref.style,
        motionClassName = _ref.className;
      return /*#__PURE__*/react.createElement(TabPanelList_TabPane, (0,esm_extends/* default */.Z)({}, restTabProps, {
        prefixCls: tabPanePrefixCls,
        id: id,
        tabKey: key,
        animated: tabPaneAnimated,
        active: active,
        style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, paneStyle), motionStyle),
        className: classnames_default()(paneClassName, motionClassName),
        ref: ref
      }));
    });
  })));
};
/* harmony default export */ var es_TabPanelList = (TabPanelList);
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(13764);
;// CONCATENATED MODULE: ./node_modules/rc-tabs/es/hooks/useAnimateConfig.js



function useAnimateConfig() {
  var animated = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    inkBar: true,
    tabPane: false
  };
  var mergedAnimated;
  if (animated === false) {
    mergedAnimated = {
      inkBar: false,
      tabPane: false
    };
  } else if (animated === true) {
    mergedAnimated = {
      inkBar: true,
      tabPane: false
    };
  } else {
    mergedAnimated = (0,objectSpread2/* default */.Z)({
      inkBar: true
    }, (0,esm_typeof/* default */.Z)(animated) === 'object' ? animated : {});
  }

  // Enable tabPane animation if provide motion
  if (mergedAnimated.tabPaneMotion && mergedAnimated.tabPane === undefined) {
    mergedAnimated.tabPane = true;
  }
  if (!mergedAnimated.tabPaneMotion && mergedAnimated.tabPane) {
    if (false) {}
    mergedAnimated.tabPane = false;
  }
  return mergedAnimated;
}
;// CONCATENATED MODULE: ./node_modules/rc-tabs/es/Tabs.js






var Tabs_excluded = ["id", "prefixCls", "className", "items", "direction", "activeKey", "defaultActiveKey", "editable", "animated", "tabPosition", "tabBarGutter", "tabBarStyle", "tabBarExtraContent", "locale", "more", "destroyInactiveTabPane", "renderTabBar", "onChange", "onTabClick", "onTabScroll", "getPopupContainer", "popupClassName", "indicator"];
// Accessibility https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/Tab_Role









/**
 * Should added antd:
 * - type
 *
 * Removed:
 * - onNextClick
 * - onPrevClick
 * - keyboard
 */

// Used for accessibility
var uuid = 0;
var Tabs = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var id = props.id,
    _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-tabs' : _props$prefixCls,
    className = props.className,
    items = props.items,
    direction = props.direction,
    activeKey = props.activeKey,
    defaultActiveKey = props.defaultActiveKey,
    editable = props.editable,
    animated = props.animated,
    _props$tabPosition = props.tabPosition,
    tabPosition = _props$tabPosition === void 0 ? 'top' : _props$tabPosition,
    tabBarGutter = props.tabBarGutter,
    tabBarStyle = props.tabBarStyle,
    tabBarExtraContent = props.tabBarExtraContent,
    locale = props.locale,
    more = props.more,
    destroyInactiveTabPane = props.destroyInactiveTabPane,
    renderTabBar = props.renderTabBar,
    onChange = props.onChange,
    onTabClick = props.onTabClick,
    onTabScroll = props.onTabScroll,
    getPopupContainer = props.getPopupContainer,
    popupClassName = props.popupClassName,
    indicator = props.indicator,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, Tabs_excluded);
  var tabs = react.useMemo(function () {
    return (items || []).filter(function (item) {
      return item && (0,esm_typeof/* default */.Z)(item) === 'object' && 'key' in item;
    });
  }, [items]);
  var rtl = direction === 'rtl';
  var mergedAnimated = useAnimateConfig(animated);

  // ======================== Mobile ========================
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    mobile = _useState2[0],
    setMobile = _useState2[1];
  (0,react.useEffect)(function () {
    // Only update on the client side
    setMobile((0,isMobile/* default */.Z)());
  }, []);

  // ====================== Active Key ======================
  var _useMergedState = (0,useMergedState/* default */.Z)(function () {
      var _tabs$;
      return (_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key;
    }, {
      value: activeKey,
      defaultValue: defaultActiveKey
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    mergedActiveKey = _useMergedState2[0],
    setMergedActiveKey = _useMergedState2[1];
  var _useState3 = (0,react.useState)(function () {
      return tabs.findIndex(function (tab) {
        return tab.key === mergedActiveKey;
      });
    }),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    activeIndex = _useState4[0],
    setActiveIndex = _useState4[1];

  // Reset active key if not exist anymore
  (0,react.useEffect)(function () {
    var newActiveIndex = tabs.findIndex(function (tab) {
      return tab.key === mergedActiveKey;
    });
    if (newActiveIndex === -1) {
      var _tabs$newActiveIndex;
      newActiveIndex = Math.max(0, Math.min(activeIndex, tabs.length - 1));
      setMergedActiveKey((_tabs$newActiveIndex = tabs[newActiveIndex]) === null || _tabs$newActiveIndex === void 0 ? void 0 : _tabs$newActiveIndex.key);
    }
    setActiveIndex(newActiveIndex);
  }, [tabs.map(function (tab) {
    return tab.key;
  }).join('_'), mergedActiveKey, activeIndex]);

  // ===================== Accessibility ====================
  var _useMergedState3 = (0,useMergedState/* default */.Z)(null, {
      value: id
    }),
    _useMergedState4 = (0,slicedToArray/* default */.Z)(_useMergedState3, 2),
    mergedId = _useMergedState4[0],
    setMergedId = _useMergedState4[1];

  // Async generate id to avoid ssr mapping failed
  (0,react.useEffect)(function () {
    if (!id) {
      setMergedId("rc-tabs-".concat( false ? 0 : uuid));
      uuid += 1;
    }
  }, []);

  // ======================== Events ========================
  function onInternalTabClick(key, e) {
    onTabClick === null || onTabClick === void 0 || onTabClick(key, e);
    var isActiveChanged = key !== mergedActiveKey;
    setMergedActiveKey(key);
    if (isActiveChanged) {
      onChange === null || onChange === void 0 || onChange(key);
    }
  }

  // ======================== Render ========================
  var sharedProps = {
    id: mergedId,
    activeKey: mergedActiveKey,
    animated: mergedAnimated,
    tabPosition: tabPosition,
    rtl: rtl,
    mobile: mobile
  };
  var tabNavBarProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, sharedProps), {}, {
    editable: editable,
    locale: locale,
    more: more,
    tabBarGutter: tabBarGutter,
    onTabClick: onInternalTabClick,
    onTabScroll: onTabScroll,
    extra: tabBarExtraContent,
    style: tabBarStyle,
    panes: null,
    getPopupContainer: getPopupContainer,
    popupClassName: popupClassName,
    indicator: indicator
  });
  return /*#__PURE__*/react.createElement(TabContext.Provider, {
    value: {
      tabs: tabs,
      prefixCls: prefixCls
    }
  }, /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    ref: ref,
    id: id,
    className: classnames_default()(prefixCls, "".concat(prefixCls, "-").concat(tabPosition), (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-mobile"), mobile), "".concat(prefixCls, "-editable"), editable), "".concat(prefixCls, "-rtl"), rtl), className)
  }, restProps), /*#__PURE__*/react.createElement(Wrapper, (0,esm_extends/* default */.Z)({}, tabNavBarProps, {
    renderTabBar: renderTabBar
  })), /*#__PURE__*/react.createElement(es_TabPanelList, (0,esm_extends/* default */.Z)({
    destroyInactiveTabPane: destroyInactiveTabPane
  }, sharedProps, {
    animated: mergedAnimated
  }))));
});
if (false) {}
/* harmony default export */ var es_Tabs = (Tabs);
;// CONCATENATED MODULE: ./node_modules/rc-tabs/es/index.js

/* harmony default export */ var rc_tabs_es = (es_Tabs);

/***/ }),

/***/ 18246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ rc_textarea_es; }
});

// UNUSED EXPORTS: ResizableTextArea

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-input/es/index.js + 2 modules
var es = __webpack_require__(65802);
// EXTERNAL MODULE: ./node_modules/rc-input/es/hooks/useCount.js
var useCount = __webpack_require__(33984);
// EXTERNAL MODULE: ./node_modules/rc-input/es/utils/commonUtils.js
var commonUtils = __webpack_require__(5894);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMergedState.js
var useMergedState = __webpack_require__(78877);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/rc-resize-observer/es/index.js + 4 modules
var rc_resize_observer_es = __webpack_require__(49938);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useLayoutEffect.js
var useLayoutEffect = __webpack_require__(76963);
// EXTERNAL MODULE: ./node_modules/rc-util/es/raf.js
var raf = __webpack_require__(13157);
;// CONCATENATED MODULE: ./node_modules/rc-textarea/es/calculateNodeHeight.js
// Thanks to https://github.com/andreypopp/react-textarea-autosize/

/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */

var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important;\n  pointer-events: none !important;\n";
var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'font-variant', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing', 'word-break', 'white-space'];
var computedStyleCache = {};
var hiddenTextarea;
function calculateNodeStyling(node) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
  if (useCache && computedStyleCache[nodeRef]) {
    return computedStyleCache[nodeRef];
  }
  var style = window.getComputedStyle(node);
  var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
  var sizingStyle = SIZING_STYLE.map(function (name) {
    return "".concat(name, ":").concat(style.getPropertyValue(name));
  }).join(';');
  var nodeInfo = {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };
  if (useCache && nodeRef) {
    computedStyleCache[nodeRef] = nodeInfo;
  }
  return nodeInfo;
}
function calculateAutoSizeStyle(uiTextNode) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    hiddenTextarea.setAttribute('tab-index', '-1');
    hiddenTextarea.setAttribute('aria-hidden', 'true');
    // fix: A form field element should have an id or name attribute
    // A form field element has neither an id nor a name attribute. This might prevent the browser from correctly autofilling the form.
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea
    hiddenTextarea.setAttribute('name', 'hiddenTextarea');
    document.body.appendChild(hiddenTextarea);
  }

  // Fix wrap="off" issue
  // https://github.com/ant-design/ant-design/issues/6577
  if (uiTextNode.getAttribute('wrap')) {
    hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
  } else {
    hiddenTextarea.removeAttribute('wrap');
  }

  // Copy all CSS properties that have an impact on the height of the content in
  // the textbox
  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
    paddingSize = _calculateNodeStyling.paddingSize,
    borderSize = _calculateNodeStyling.borderSize,
    boxSizing = _calculateNodeStyling.boxSizing,
    sizingStyle = _calculateNodeStyling.sizingStyle;

  // Need to have the overflow attribute to hide the scrollbar otherwise
  // text-lines will not calculated properly as the shadow will technically be
  // narrower for content
  hiddenTextarea.setAttribute('style', "".concat(sizingStyle, ";").concat(HIDDEN_TEXTAREA_STYLE));
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
  var minHeight = undefined;
  var maxHeight = undefined;
  var overflowY;
  var height = hiddenTextarea.scrollHeight;
  if (boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    height += borderSize;
  } else if (boxSizing === 'content-box') {
    // remove padding, since height = content
    height -= paddingSize;
  }
  if (minRows !== null || maxRows !== null) {
    // measure height of a textarea with a single row
    hiddenTextarea.value = ' ';
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;
      if (boxSizing === 'border-box') {
        minHeight = minHeight + paddingSize + borderSize;
      }
      height = Math.max(minHeight, height);
    }
    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;
      if (boxSizing === 'border-box') {
        maxHeight = maxHeight + paddingSize + borderSize;
      }
      overflowY = height > maxHeight ? '' : 'hidden';
      height = Math.min(maxHeight, height);
    }
  }
  var style = {
    height: height,
    overflowY: overflowY,
    resize: 'none'
  };
  if (minHeight) {
    style.minHeight = minHeight;
  }
  if (maxHeight) {
    style.maxHeight = maxHeight;
  }
  return style;
}
;// CONCATENATED MODULE: ./node_modules/rc-textarea/es/ResizableTextArea.js






var _excluded = ["prefixCls", "defaultValue", "value", "autoSize", "onResize", "className", "style", "disabled", "onChange", "onInternalAutoSize"];







var RESIZE_START = 0;
var RESIZE_MEASURING = 1;
var RESIZE_STABLE = 2;
var ResizableTextArea = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _ref = props,
    prefixCls = _ref.prefixCls,
    defaultValue = _ref.defaultValue,
    value = _ref.value,
    autoSize = _ref.autoSize,
    onResize = _ref.onResize,
    className = _ref.className,
    style = _ref.style,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    onInternalAutoSize = _ref.onInternalAutoSize,
    restProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  // =============================== Value ================================
  var _useMergedState = (0,useMergedState/* default */.Z)(defaultValue, {
      value: value,
      postState: function postState(val) {
        return val !== null && val !== void 0 ? val : '';
      }
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    mergedValue = _useMergedState2[0],
    setMergedValue = _useMergedState2[1];
  var onInternalChange = function onInternalChange(event) {
    setMergedValue(event.target.value);
    onChange === null || onChange === void 0 || onChange(event);
  };

  // ================================ Ref =================================
  var textareaRef = react.useRef();
  react.useImperativeHandle(ref, function () {
    return {
      textArea: textareaRef.current
    };
  });

  // ============================== AutoSize ==============================
  var _React$useMemo = react.useMemo(function () {
      if (autoSize && (0,esm_typeof/* default */.Z)(autoSize) === 'object') {
        return [autoSize.minRows, autoSize.maxRows];
      }
      return [];
    }, [autoSize]),
    _React$useMemo2 = (0,slicedToArray/* default */.Z)(_React$useMemo, 2),
    minRows = _React$useMemo2[0],
    maxRows = _React$useMemo2[1];
  var needAutoSize = !!autoSize;

  // =============================== Resize ===============================
  var _React$useState = react.useState(RESIZE_STABLE),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    resizeState = _React$useState2[0],
    setResizeState = _React$useState2[1];
  var _React$useState3 = react.useState(),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    autoSizeStyle = _React$useState4[0],
    setAutoSizeStyle = _React$useState4[1];
  var startResize = function startResize() {
    setResizeState(RESIZE_START);
    if (false) {}
  };

  // Change to trigger resize measure
  (0,useLayoutEffect/* default */.Z)(function () {
    if (needAutoSize) {
      startResize();
    }
  }, [value, minRows, maxRows, needAutoSize]);
  (0,useLayoutEffect/* default */.Z)(function () {
    if (resizeState === RESIZE_START) {
      setResizeState(RESIZE_MEASURING);
    } else if (resizeState === RESIZE_MEASURING) {
      var textareaStyles = calculateAutoSizeStyle(textareaRef.current, false, minRows, maxRows);

      // Safari has bug that text will keep break line on text cut when it's prev is break line.
      // ZombieJ: This not often happen. So we just skip it.
      // const { selectionStart, selectionEnd, scrollTop } = textareaRef.current;
      // const { value: tmpValue } = textareaRef.current;
      // textareaRef.current.value = '';
      // textareaRef.current.value = tmpValue;

      // if (document.activeElement === textareaRef.current) {
      //   textareaRef.current.scrollTop = scrollTop;
      //   textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
      // }

      setResizeState(RESIZE_STABLE);
      setAutoSizeStyle(textareaStyles);
    } else {
      // https://github.com/react-component/textarea/pull/23
      // Firefox has blink issue before but fixed in latest version.
    }
  }, [resizeState]);

  // We lock resize trigger by raf to avoid Safari warning
  var resizeRafRef = react.useRef();
  var cleanRaf = function cleanRaf() {
    raf/* default.cancel */.Z.cancel(resizeRafRef.current);
  };
  var onInternalResize = function onInternalResize(size) {
    if (resizeState === RESIZE_STABLE) {
      onResize === null || onResize === void 0 || onResize(size);
      if (autoSize) {
        cleanRaf();
        resizeRafRef.current = (0,raf/* default */.Z)(function () {
          startResize();
        });
      }
    }
  };
  react.useEffect(function () {
    return cleanRaf;
  }, []);

  // =============================== Render ===============================
  var mergedAutoSizeStyle = needAutoSize ? autoSizeStyle : null;
  var mergedStyle = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, style), mergedAutoSizeStyle);
  if (resizeState === RESIZE_START || resizeState === RESIZE_MEASURING) {
    mergedStyle.overflowY = 'hidden';
    mergedStyle.overflowX = 'hidden';
  }
  return /*#__PURE__*/react.createElement(rc_resize_observer_es/* default */.Z, {
    onResize: onInternalResize,
    disabled: !(autoSize || onResize)
  }, /*#__PURE__*/react.createElement("textarea", (0,esm_extends/* default */.Z)({}, restProps, {
    ref: textareaRef,
    style: mergedStyle,
    className: classnames_default()(prefixCls, className, (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-disabled"), disabled)),
    disabled: disabled,
    value: mergedValue,
    onChange: onInternalChange
  })));
});
/* harmony default export */ var es_ResizableTextArea = (ResizableTextArea);
;// CONCATENATED MODULE: ./node_modules/rc-textarea/es/TextArea.js






var TextArea_excluded = ["defaultValue", "value", "onFocus", "onBlur", "onChange", "allowClear", "maxLength", "onCompositionStart", "onCompositionEnd", "suffix", "prefixCls", "showCount", "count", "className", "style", "disabled", "hidden", "classNames", "styles", "onResize", "onClear", "onPressEnter", "readOnly", "autoSize", "onKeyDown"];







var TextArea = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var _countConfig$max;
  var defaultValue = _ref.defaultValue,
    customValue = _ref.value,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    allowClear = _ref.allowClear,
    maxLength = _ref.maxLength,
    onCompositionStart = _ref.onCompositionStart,
    onCompositionEnd = _ref.onCompositionEnd,
    suffix = _ref.suffix,
    _ref$prefixCls = _ref.prefixCls,
    prefixCls = _ref$prefixCls === void 0 ? 'rc-textarea' : _ref$prefixCls,
    showCount = _ref.showCount,
    count = _ref.count,
    className = _ref.className,
    style = _ref.style,
    disabled = _ref.disabled,
    hidden = _ref.hidden,
    classNames = _ref.classNames,
    styles = _ref.styles,
    onResize = _ref.onResize,
    onClear = _ref.onClear,
    onPressEnter = _ref.onPressEnter,
    readOnly = _ref.readOnly,
    autoSize = _ref.autoSize,
    onKeyDown = _ref.onKeyDown,
    rest = (0,objectWithoutProperties/* default */.Z)(_ref, TextArea_excluded);
  var _useMergedState = (0,useMergedState/* default */.Z)(defaultValue, {
      value: customValue,
      defaultValue: defaultValue
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    value = _useMergedState2[0],
    setValue = _useMergedState2[1];
  var formatValue = value === undefined || value === null ? '' : String(value);
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    focused = _React$useState2[0],
    setFocused = _React$useState2[1];
  var compositionRef = react.useRef(false);
  var _React$useState3 = react.useState(null),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    textareaResized = _React$useState4[0],
    setTextareaResized = _React$useState4[1];

  // =============================== Ref ================================
  var holderRef = (0,react.useRef)(null);
  var resizableTextAreaRef = (0,react.useRef)(null);
  var getTextArea = function getTextArea() {
    var _resizableTextAreaRef;
    return (_resizableTextAreaRef = resizableTextAreaRef.current) === null || _resizableTextAreaRef === void 0 ? void 0 : _resizableTextAreaRef.textArea;
  };
  var focus = function focus() {
    getTextArea().focus();
  };
  (0,react.useImperativeHandle)(ref, function () {
    var _holderRef$current;
    return {
      resizableTextArea: resizableTextAreaRef.current,
      focus: focus,
      blur: function blur() {
        getTextArea().blur();
      },
      nativeElement: ((_holderRef$current = holderRef.current) === null || _holderRef$current === void 0 ? void 0 : _holderRef$current.nativeElement) || getTextArea()
    };
  });
  (0,react.useEffect)(function () {
    setFocused(function (prev) {
      return !disabled && prev;
    });
  }, [disabled]);

  // =========================== Select Range ===========================
  var _React$useState5 = react.useState(null),
    _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
    selection = _React$useState6[0],
    setSelection = _React$useState6[1];
  react.useEffect(function () {
    if (selection) {
      var _getTextArea;
      (_getTextArea = getTextArea()).setSelectionRange.apply(_getTextArea, (0,toConsumableArray/* default */.Z)(selection));
    }
  }, [selection]);

  // ============================== Count ===============================
  var countConfig = (0,useCount/* default */.Z)(count, showCount);
  var mergedMax = (_countConfig$max = countConfig.max) !== null && _countConfig$max !== void 0 ? _countConfig$max : maxLength;

  // Max length value
  var hasMaxLength = Number(mergedMax) > 0;
  var valueLength = countConfig.strategy(formatValue);
  var isOutOfRange = !!mergedMax && valueLength > mergedMax;

  // ============================== Change ==============================
  var triggerChange = function triggerChange(e, currentValue) {
    var cutValue = currentValue;
    if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
      cutValue = countConfig.exceedFormatter(currentValue, {
        max: countConfig.max
      });
      if (currentValue !== cutValue) {
        setSelection([getTextArea().selectionStart || 0, getTextArea().selectionEnd || 0]);
      }
    }
    setValue(cutValue);
    (0,commonUtils/* resolveOnChange */.rJ)(e.currentTarget, e, onChange, cutValue);
  };

  // =========================== Value Update ===========================
  var onInternalCompositionStart = function onInternalCompositionStart(e) {
    compositionRef.current = true;
    onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
  };
  var onInternalCompositionEnd = function onInternalCompositionEnd(e) {
    compositionRef.current = false;
    triggerChange(e, e.currentTarget.value);
    onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
  };
  var onInternalChange = function onInternalChange(e) {
    triggerChange(e, e.target.value);
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter' && onPressEnter) {
      onPressEnter(e);
    }
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
  };
  var handleFocus = function handleFocus(e) {
    setFocused(true);
    onFocus === null || onFocus === void 0 || onFocus(e);
  };
  var handleBlur = function handleBlur(e) {
    setFocused(false);
    onBlur === null || onBlur === void 0 || onBlur(e);
  };

  // ============================== Reset ===============================
  var handleReset = function handleReset(e) {
    setValue('');
    focus();
    (0,commonUtils/* resolveOnChange */.rJ)(getTextArea(), e, onChange);
  };
  var suffixNode = suffix;
  var dataCount;
  if (countConfig.show) {
    if (countConfig.showFormatter) {
      dataCount = countConfig.showFormatter({
        value: formatValue,
        count: valueLength,
        maxLength: mergedMax
      });
    } else {
      dataCount = "".concat(valueLength).concat(hasMaxLength ? " / ".concat(mergedMax) : '');
    }
    suffixNode = /*#__PURE__*/react.createElement(react.Fragment, null, suffixNode, /*#__PURE__*/react.createElement("span", {
      className: classnames_default()("".concat(prefixCls, "-data-count"), classNames === null || classNames === void 0 ? void 0 : classNames.count),
      style: styles === null || styles === void 0 ? void 0 : styles.count
    }, dataCount));
  }
  var handleResize = function handleResize(size) {
    var _getTextArea2;
    onResize === null || onResize === void 0 || onResize(size);
    if ((_getTextArea2 = getTextArea()) !== null && _getTextArea2 !== void 0 && _getTextArea2.style.height) {
      setTextareaResized(true);
    }
  };
  var isPureTextArea = !autoSize && !showCount && !allowClear;
  return /*#__PURE__*/react.createElement(es/* BaseInput */.Q, {
    ref: holderRef,
    value: formatValue,
    allowClear: allowClear,
    handleReset: handleReset,
    suffix: suffixNode,
    prefixCls: prefixCls,
    classNames: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, classNames), {}, {
      affixWrapper: classnames_default()(classNames === null || classNames === void 0 ? void 0 : classNames.affixWrapper, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-show-count"), showCount), "".concat(prefixCls, "-textarea-allow-clear"), allowClear))
    }),
    disabled: disabled,
    focused: focused,
    className: classnames_default()(className, isOutOfRange && "".concat(prefixCls, "-out-of-range")),
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, style), textareaResized && !isPureTextArea ? {
      height: 'auto'
    } : {}),
    dataAttrs: {
      affixWrapper: {
        'data-count': typeof dataCount === 'string' ? dataCount : undefined
      }
    },
    hidden: hidden,
    readOnly: readOnly,
    onClear: onClear
  }, /*#__PURE__*/react.createElement(es_ResizableTextArea, (0,esm_extends/* default */.Z)({}, rest, {
    autoSize: autoSize,
    maxLength: maxLength,
    onKeyDown: handleKeyDown,
    onChange: onInternalChange,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onCompositionStart: onInternalCompositionStart,
    onCompositionEnd: onInternalCompositionEnd,
    className: classnames_default()(classNames === null || classNames === void 0 ? void 0 : classNames.textarea),
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, styles === null || styles === void 0 ? void 0 : styles.textarea), {}, {
      resize: style === null || style === void 0 ? void 0 : style.resize
    }),
    disabled: disabled,
    prefixCls: prefixCls,
    onResize: handleResize,
    ref: resizableTextAreaRef,
    readOnly: readOnly
  })));
});
/* harmony default export */ var es_TextArea = (TextArea);
;// CONCATENATED MODULE: ./node_modules/rc-textarea/es/index.js


/* harmony default export */ var rc_textarea_es = (es_TextArea);

/***/ }),

/***/ 59052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* reexport */ Popup; },
  "Z": function() { return /* binding */ rc_tooltip_es; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/rc-tooltip/es/Popup.js


function Popup(props) {
  var children = props.children,
    prefixCls = props.prefixCls,
    id = props.id,
    innerStyle = props.overlayInnerStyle,
    bodyClassName = props.bodyClassName,
    className = props.className,
    style = props.style;
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(prefixCls, "-content"), className),
    style: style
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(prefixCls, "-inner"), bodyClassName),
    id: id,
    role: "tooltip",
    style: innerStyle
  }, typeof children === 'function' ? children() : children));
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/@rc-component/trigger/es/index.js + 11 modules
var es = __webpack_require__(91831);
;// CONCATENATED MODULE: ./node_modules/rc-tooltip/es/placements.js
var autoAdjustOverflowTopBottom = {
  shiftX: 64,
  adjustY: 1
};
var autoAdjustOverflowLeftRight = {
  adjustX: 1,
  shiftY: true
};
var targetOffset = [0, 0];
var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};
/* harmony default export */ var es_placements = ((/* unused pure expression or super */ null && (placements)));
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useId.js
var useId = __webpack_require__(73208);
;// CONCATENATED MODULE: ./node_modules/rc-tooltip/es/Tooltip.js



var _excluded = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow", "classNames", "styles"];







var Tooltip = function Tooltip(props, ref) {
  var overlayClassName = props.overlayClassName,
    _props$trigger = props.trigger,
    trigger = _props$trigger === void 0 ? ['hover'] : _props$trigger,
    _props$mouseEnterDela = props.mouseEnterDelay,
    mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela,
    _props$mouseLeaveDela = props.mouseLeaveDelay,
    mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela,
    overlayStyle = props.overlayStyle,
    _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-tooltip' : _props$prefixCls,
    children = props.children,
    onVisibleChange = props.onVisibleChange,
    afterVisibleChange = props.afterVisibleChange,
    transitionName = props.transitionName,
    animation = props.animation,
    motion = props.motion,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? 'right' : _props$placement,
    _props$align = props.align,
    align = _props$align === void 0 ? {} : _props$align,
    _props$destroyTooltip = props.destroyTooltipOnHide,
    destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip,
    defaultVisible = props.defaultVisible,
    getTooltipContainer = props.getTooltipContainer,
    overlayInnerStyle = props.overlayInnerStyle,
    arrowContent = props.arrowContent,
    overlay = props.overlay,
    id = props.id,
    _props$showArrow = props.showArrow,
    showArrow = _props$showArrow === void 0 ? true : _props$showArrow,
    tooltipClassNames = props.classNames,
    tooltipStyles = props.styles,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded);
  var mergedId = (0,useId/* default */.Z)(id);
  var triggerRef = (0,react.useRef)(null);
  (0,react.useImperativeHandle)(ref, function () {
    return triggerRef.current;
  });
  var extraProps = (0,objectSpread2/* default */.Z)({}, restProps);
  if ('visible' in props) {
    extraProps.popupVisible = props.visible;
  }
  var getPopupElement = function getPopupElement() {
    return /*#__PURE__*/react.createElement(Popup, {
      key: "content",
      prefixCls: prefixCls,
      id: mergedId,
      bodyClassName: tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.body,
      overlayInnerStyle: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, overlayInnerStyle), tooltipStyles === null || tooltipStyles === void 0 ? void 0 : tooltipStyles.body)
    }, overlay);
  };
  var getChildren = function getChildren() {
    var child = react.Children.only(children);
    var originalProps = (child === null || child === void 0 ? void 0 : child.props) || {};
    var childProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, originalProps), {}, {
      'aria-describedby': overlay ? mergedId : null
    });
    return /*#__PURE__*/react.cloneElement(children, childProps);
  };
  return /*#__PURE__*/react.createElement(es/* default */.Z, (0,esm_extends/* default */.Z)({
    popupClassName: classnames_default()(overlayClassName, tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.root),
    prefixCls: prefixCls,
    popup: getPopupElement,
    action: trigger,
    builtinPlacements: placements,
    popupPlacement: placement,
    ref: triggerRef,
    popupAlign: align,
    getPopupContainer: getTooltipContainer,
    onPopupVisibleChange: onVisibleChange,
    afterPopupVisibleChange: afterVisibleChange,
    popupTransitionName: transitionName,
    popupAnimation: animation,
    popupMotion: motion,
    defaultPopupVisible: defaultVisible,
    autoDestroy: destroyTooltipOnHide,
    mouseLeaveDelay: mouseLeaveDelay,
    popupStyle: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, overlayStyle), tooltipStyles === null || tooltipStyles === void 0 ? void 0 : tooltipStyles.root),
    mouseEnterDelay: mouseEnterDelay,
    arrow: showArrow
  }, extraProps), getChildren());
};
/* harmony default export */ var es_Tooltip = (/*#__PURE__*/(0,react.forwardRef)(Tooltip));
;// CONCATENATED MODULE: ./node_modules/rc-tooltip/es/index.js



/* harmony default export */ var rc_tooltip_es = (es_Tooltip);

/***/ }),

/***/ 33863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_TreeNode; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/pickAttrs.js
var pickAttrs = __webpack_require__(75844);
// EXTERNAL MODULE: ./node_modules/rc-tree/es/contextTypes.js
var contextTypes = __webpack_require__(65569);
;// CONCATENATED MODULE: ./node_modules/rc-tree/es/Indent.js



var Indent = function Indent(_ref) {
  var prefixCls = _ref.prefixCls,
    level = _ref.level,
    isStart = _ref.isStart,
    isEnd = _ref.isEnd;
  var baseClassName = "".concat(prefixCls, "-indent-unit");
  var list = [];
  for (var i = 0; i < level; i += 1) {
    list.push(/*#__PURE__*/react.createElement("span", {
      key: i,
      className: classnames_default()(baseClassName, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(baseClassName, "-start"), isStart[i]), "".concat(baseClassName, "-end"), isEnd[i]))
    }));
  }
  return /*#__PURE__*/react.createElement("span", {
    "aria-hidden": "true",
    className: "".concat(prefixCls, "-indent")
  }, list);
};
/* harmony default export */ var es_Indent = (/*#__PURE__*/react.memo(Indent));
// EXTERNAL MODULE: ./node_modules/rc-tree/es/utils/keyUtil.js
var keyUtil = __webpack_require__(645);
// EXTERNAL MODULE: ./node_modules/rc-tree/es/utils/treeUtil.js
var treeUtil = __webpack_require__(77081);
;// CONCATENATED MODULE: ./node_modules/rc-tree/es/TreeNode.js





var _excluded = ["eventKey", "className", "style", "dragOver", "dragOverGapTop", "dragOverGapBottom", "isLeaf", "isStart", "isEnd", "expanded", "selected", "checked", "halfChecked", "loading", "domRef", "active", "data", "onMouseMove", "selectable"];







var ICON_OPEN = 'open';
var ICON_CLOSE = 'close';
var defaultTitle = '---';
var TreeNode = function TreeNode(props) {
  var _unstableContext$node, _context$filterTreeNo, _classNames4;
  var eventKey = props.eventKey,
    className = props.className,
    style = props.style,
    dragOver = props.dragOver,
    dragOverGapTop = props.dragOverGapTop,
    dragOverGapBottom = props.dragOverGapBottom,
    isLeaf = props.isLeaf,
    isStart = props.isStart,
    isEnd = props.isEnd,
    expanded = props.expanded,
    selected = props.selected,
    checked = props.checked,
    halfChecked = props.halfChecked,
    loading = props.loading,
    domRef = props.domRef,
    active = props.active,
    data = props.data,
    onMouseMove = props.onMouseMove,
    selectable = props.selectable,
    otherProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded);
  var context = react.useContext(contextTypes/* TreeContext */.k);
  var unstableContext = react.useContext(contextTypes/* UnstableContext */.y);
  var selectHandleRef = react.useRef(null);
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    dragNodeHighlight = _React$useState2[0],
    setDragNodeHighlight = _React$useState2[1];

  // ======= State: Disabled State =======
  var isDisabled = !!(context.disabled || props.disabled || (_unstableContext$node = unstableContext.nodeDisabled) !== null && _unstableContext$node !== void 0 && _unstableContext$node.call(unstableContext, data));
  var isCheckable = react.useMemo(function () {
    // Return false if tree or treeNode is not checkable
    if (!context.checkable || props.checkable === false) {
      return false;
    }
    return context.checkable;
  }, [context.checkable, props.checkable]);

  // ======= Event Handlers: Selection and Check =======
  var onSelect = function onSelect(e) {
    if (isDisabled) {
      return;
    }
    context.onNodeSelect(e, (0,treeUtil/* convertNodePropsToEventData */.F)(props));
  };
  var onCheck = function onCheck(e) {
    if (isDisabled) {
      return;
    }
    if (!isCheckable || props.disableCheckbox) {
      return;
    }
    context.onNodeCheck(e, (0,treeUtil/* convertNodePropsToEventData */.F)(props), !checked);
  };

  // ======= State: Selectable Check =======
  var isSelectable = react.useMemo(function () {
    // Ignore when selectable is undefined or null
    if (typeof selectable === 'boolean') {
      return selectable;
    }
    return context.selectable;
  }, [selectable, context.selectable]);
  var onSelectorClick = function onSelectorClick(e) {
    // Click trigger before select/check operation
    context.onNodeClick(e, (0,treeUtil/* convertNodePropsToEventData */.F)(props));
    if (isSelectable) {
      onSelect(e);
    } else {
      onCheck(e);
    }
  };
  var onSelectorDoubleClick = function onSelectorDoubleClick(e) {
    context.onNodeDoubleClick(e, (0,treeUtil/* convertNodePropsToEventData */.F)(props));
  };
  var onMouseEnter = function onMouseEnter(e) {
    context.onNodeMouseEnter(e, (0,treeUtil/* convertNodePropsToEventData */.F)(props));
  };
  var onMouseLeave = function onMouseLeave(e) {
    context.onNodeMouseLeave(e, (0,treeUtil/* convertNodePropsToEventData */.F)(props));
  };
  var onContextMenu = function onContextMenu(e) {
    context.onNodeContextMenu(e, (0,treeUtil/* convertNodePropsToEventData */.F)(props));
  };

  // ======= Drag: Drag Enabled =======
  var isDraggable = react.useMemo(function () {
    return !!(context.draggable && (!context.draggable.nodeDraggable || context.draggable.nodeDraggable(data)));
  }, [context.draggable, data]);

  // ======= Drag: Drag Event Handlers =======
  var onDragStart = function onDragStart(e) {
    e.stopPropagation();
    setDragNodeHighlight(true);
    context.onNodeDragStart(e, props);
    try {
      // ie throw error
      // firefox-need-it
      e.dataTransfer.setData('text/plain', '');
    } catch (_unused) {
      // empty
    }
  };
  var onDragEnter = function onDragEnter(e) {
    e.preventDefault();
    e.stopPropagation();
    context.onNodeDragEnter(e, props);
  };
  var onDragOver = function onDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
    context.onNodeDragOver(e, props);
  };
  var onDragLeave = function onDragLeave(e) {
    e.stopPropagation();
    context.onNodeDragLeave(e, props);
  };
  var onDragEnd = function onDragEnd(e) {
    e.stopPropagation();
    setDragNodeHighlight(false);
    context.onNodeDragEnd(e, props);
  };
  var onDrop = function onDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    setDragNodeHighlight(false);
    context.onNodeDrop(e, props);
  };

  // ======= Expand: Node Expansion =======
  var onExpand = function onExpand(e) {
    if (loading) {
      return;
    }
    context.onNodeExpand(e, (0,treeUtil/* convertNodePropsToEventData */.F)(props));
  };

  // ======= State: Has Children =======
  var hasChildren = react.useMemo(function () {
    var _ref = (0,keyUtil/* default */.Z)(context.keyEntities, eventKey) || {},
      children = _ref.children;
    return Boolean((children || []).length);
  }, [context.keyEntities, eventKey]);

  // ======= State: Leaf Check =======
  var memoizedIsLeaf = react.useMemo(function () {
    if (isLeaf === false) {
      return false;
    }
    return isLeaf || !context.loadData && !hasChildren || context.loadData && props.loaded && !hasChildren;
  }, [isLeaf, context.loadData, hasChildren, props.loaded]);

  // ============== Effect ==============
  react.useEffect(function () {
    // Load data to avoid default expanded tree without data
    if (loading) {
      return;
    }
    // read from state to avoid loadData at same time
    if (typeof context.loadData === 'function' && expanded && !memoizedIsLeaf && !props.loaded) {
      // We needn't reload data when has children in sync logic
      // It's only needed in node expanded
      context.onNodeLoad((0,treeUtil/* convertNodePropsToEventData */.F)(props));
    }
  }, [loading, context.loadData, context.onNodeLoad, expanded, memoizedIsLeaf, props]);

  // ==================== Render: Drag Handler ====================
  var dragHandlerNode = react.useMemo(function () {
    var _context$draggable;
    if (!((_context$draggable = context.draggable) !== null && _context$draggable !== void 0 && _context$draggable.icon)) {
      return null;
    }
    return /*#__PURE__*/react.createElement("span", {
      className: "".concat(context.prefixCls, "-draggable-icon")
    }, context.draggable.icon);
  }, [context.draggable]);

  // ====================== Render: Switcher ======================
  var renderSwitcherIconDom = function renderSwitcherIconDom(isInternalLeaf) {
    var switcherIcon = props.switcherIcon || context.switcherIcon;
    // if switcherIconDom is null, no render switcher span
    if (typeof switcherIcon === 'function') {
      return switcherIcon((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
        isLeaf: isInternalLeaf
      }));
    }
    return switcherIcon;
  };

  // Switcher
  var renderSwitcher = function renderSwitcher() {
    if (memoizedIsLeaf) {
      // if switcherIconDom is null, no render switcher span
      var _switcherIconDom = renderSwitcherIconDom(true);
      return _switcherIconDom !== false ? /*#__PURE__*/react.createElement("span", {
        className: classnames_default()("".concat(context.prefixCls, "-switcher"), "".concat(context.prefixCls, "-switcher-noop"))
      }, _switcherIconDom) : null;
    }
    var switcherIconDom = renderSwitcherIconDom(false);
    return switcherIconDom !== false ? /*#__PURE__*/react.createElement("span", {
      onClick: onExpand,
      className: classnames_default()("".concat(context.prefixCls, "-switcher"), "".concat(context.prefixCls, "-switcher_").concat(expanded ? ICON_OPEN : ICON_CLOSE))
    }, switcherIconDom) : null;
  };

  // ====================== Checkbox ======================
  var checkboxNode = react.useMemo(function () {
    if (!isCheckable) {
      return null;
    }

    // [Legacy] Custom element should be separate with `checkable` in future
    var $custom = typeof isCheckable !== 'boolean' ? isCheckable : null;
    return /*#__PURE__*/react.createElement("span", {
      className: classnames_default()("".concat(context.prefixCls, "-checkbox"), (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(context.prefixCls, "-checkbox-checked"), checked), "".concat(context.prefixCls, "-checkbox-indeterminate"), !checked && halfChecked), "".concat(context.prefixCls, "-checkbox-disabled"), isDisabled || props.disableCheckbox)),
      onClick: onCheck,
      role: "checkbox",
      "aria-checked": halfChecked ? 'mixed' : checked,
      "aria-disabled": isDisabled || props.disableCheckbox,
      "aria-label": "Select ".concat(typeof props.title === 'string' ? props.title : 'tree node')
    }, $custom);
  }, [isCheckable, checked, halfChecked, isDisabled, props.disableCheckbox, props.title]);

  // ============== State: Node State (Open/Close) ==============
  var nodeState = react.useMemo(function () {
    if (memoizedIsLeaf) {
      return null;
    }
    return expanded ? ICON_OPEN : ICON_CLOSE;
  }, [memoizedIsLeaf, expanded]);

  // ==================== Render: Title + Icon ====================
  var iconNode = react.useMemo(function () {
    return /*#__PURE__*/react.createElement("span", {
      className: classnames_default()("".concat(context.prefixCls, "-iconEle"), "".concat(context.prefixCls, "-icon__").concat(nodeState || 'docu'), (0,defineProperty/* default */.Z)({}, "".concat(context.prefixCls, "-icon_loading"), loading))
    });
  }, [context.prefixCls, nodeState, loading]);

  // =================== Drop Indicator ===================
  var dropIndicatorNode = react.useMemo(function () {
    var rootDraggable = Boolean(context.draggable);
    // allowDrop is calculated in Tree.tsx, there is no need for calc it here
    var showIndicator = !props.disabled && rootDraggable && context.dragOverNodeKey === eventKey;
    if (!showIndicator) {
      return null;
    }
    return context.dropIndicatorRender({
      dropPosition: context.dropPosition,
      dropLevelOffset: context.dropLevelOffset,
      indent: context.indent,
      prefixCls: context.prefixCls,
      direction: context.direction
    });
  }, [context.dropPosition, context.dropLevelOffset, context.indent, context.prefixCls, context.direction, context.draggable, context.dragOverNodeKey, context.dropIndicatorRender]);

  // Icon + Title
  var selectorNode = react.useMemo(function () {
    var _props$title = props.title,
      title = _props$title === void 0 ? defaultTitle : _props$title;
    var wrapClass = "".concat(context.prefixCls, "-node-content-wrapper");

    // Icon - Still show loading icon when loading without showIcon
    var $icon;
    if (context.showIcon) {
      var currentIcon = props.icon || context.icon;
      $icon = currentIcon ? /*#__PURE__*/react.createElement("span", {
        className: classnames_default()("".concat(context.prefixCls, "-iconEle"), "".concat(context.prefixCls, "-icon__customize"))
      }, typeof currentIcon === 'function' ? currentIcon(props) : currentIcon) : iconNode;
    } else if (context.loadData && loading) {
      $icon = iconNode;
    }

    // Title
    var titleNode;
    if (typeof title === 'function') {
      titleNode = title(data);
    } else if (context.titleRender) {
      titleNode = context.titleRender(data);
    } else {
      titleNode = title;
    }
    return /*#__PURE__*/react.createElement("span", {
      ref: selectHandleRef,
      title: typeof title === 'string' ? title : '',
      className: classnames_default()(wrapClass, "".concat(wrapClass, "-").concat(nodeState || 'normal'), (0,defineProperty/* default */.Z)({}, "".concat(context.prefixCls, "-node-selected"), !isDisabled && (selected || dragNodeHighlight))),
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onContextMenu: onContextMenu,
      onClick: onSelectorClick,
      onDoubleClick: onSelectorDoubleClick
    }, $icon, /*#__PURE__*/react.createElement("span", {
      className: "".concat(context.prefixCls, "-title")
    }, titleNode), dropIndicatorNode);
  }, [context.prefixCls, context.showIcon, props, context.icon, iconNode, context.titleRender, data, nodeState, onMouseEnter, onMouseLeave, onContextMenu, onSelectorClick, onSelectorDoubleClick]);
  var dataOrAriaAttributeProps = (0,pickAttrs/* default */.Z)(otherProps, {
    aria: true,
    data: true
  });
  var _ref2 = (0,keyUtil/* default */.Z)(context.keyEntities, eventKey) || {},
    level = _ref2.level;
  var isEndNode = isEnd[isEnd.length - 1];
  var draggableWithoutDisabled = !isDisabled && isDraggable;
  var dragging = context.draggingNodeKey === eventKey;
  var ariaSelected = selectable !== undefined ? {
    'aria-selected': !!selectable
  } : undefined;
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    ref: domRef,
    role: "treeitem",
    "aria-expanded": isLeaf ? undefined : expanded,
    className: classnames_default()(className, "".concat(context.prefixCls, "-treenode"), (_classNames4 = {}, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)(_classNames4, "".concat(context.prefixCls, "-treenode-disabled"), isDisabled), "".concat(context.prefixCls, "-treenode-switcher-").concat(expanded ? 'open' : 'close'), !isLeaf), "".concat(context.prefixCls, "-treenode-checkbox-checked"), checked), "".concat(context.prefixCls, "-treenode-checkbox-indeterminate"), halfChecked), "".concat(context.prefixCls, "-treenode-selected"), selected), "".concat(context.prefixCls, "-treenode-loading"), loading), "".concat(context.prefixCls, "-treenode-active"), active), "".concat(context.prefixCls, "-treenode-leaf-last"), isEndNode), "".concat(context.prefixCls, "-treenode-draggable"), isDraggable), "dragging", dragging), (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)(_classNames4, 'drop-target', context.dropTargetKey === eventKey), 'drop-container', context.dropContainerKey === eventKey), 'drag-over', !isDisabled && dragOver), 'drag-over-gap-top', !isDisabled && dragOverGapTop), 'drag-over-gap-bottom', !isDisabled && dragOverGapBottom), 'filter-node', (_context$filterTreeNo = context.filterTreeNode) === null || _context$filterTreeNo === void 0 ? void 0 : _context$filterTreeNo.call(context, (0,treeUtil/* convertNodePropsToEventData */.F)(props))), "".concat(context.prefixCls, "-treenode-leaf"), memoizedIsLeaf))),
    style: style
    // Draggable config
    ,

    draggable: draggableWithoutDisabled,
    onDragStart: draggableWithoutDisabled ? onDragStart : undefined
    // Drop config
    ,

    onDragEnter: isDraggable ? onDragEnter : undefined,
    onDragOver: isDraggable ? onDragOver : undefined,
    onDragLeave: isDraggable ? onDragLeave : undefined,
    onDrop: isDraggable ? onDrop : undefined,
    onDragEnd: isDraggable ? onDragEnd : undefined,
    onMouseMove: onMouseMove
  }, ariaSelected, dataOrAriaAttributeProps), /*#__PURE__*/react.createElement(es_Indent, {
    prefixCls: context.prefixCls,
    level: level,
    isStart: isStart,
    isEnd: isEnd
  }), dragHandlerNode, renderSwitcher(), checkboxNode, selectorNode);
};
TreeNode.isTreeNode = 1;
if (false) {}
/* harmony default export */ var es_TreeNode = (TreeNode);

/***/ }),

/***/ 65569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ TreeContext; },
/* harmony export */   "y": function() { return /* binding */ UnstableContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/**
 * Webpack has bug for import loop, which is not the same behavior as ES module.
 * When util.js imports the TreeNode for tree generate will cause treeContextTypes be empty.
 */

var TreeContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);

/** Internal usage, safe to remove. Do not use in prod */
var UnstableContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

/***/ }),

/***/ 54328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "OF": function() { return /* reexport */ TreeNode/* default */.Z; },
  "y6": function() { return /* reexport */ contextTypes/* UnstableContext */.y; },
  "ZP": function() { return /* binding */ rc_tree_es; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6223);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(79427);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(88569);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(34766);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js
var createSuper = __webpack_require__(56302);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js
var KeyCode = __webpack_require__(88035);
// EXTERNAL MODULE: ./node_modules/rc-util/es/pickAttrs.js
var pickAttrs = __webpack_require__(75844);
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(13764);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/rc-tree/es/contextTypes.js
var contextTypes = __webpack_require__(65569);
;// CONCATENATED MODULE: ./node_modules/rc-tree/es/DropIndicator.js

var DropIndicator = function DropIndicator(props) {
  var dropPosition = props.dropPosition,
    dropLevelOffset = props.dropLevelOffset,
    indent = props.indent;
  var style = {
    pointerEvents: 'none',
    position: 'absolute',
    right: 0,
    backgroundColor: 'red',
    height: 2
  };
  switch (dropPosition) {
    case -1:
      style.top = 0;
      style.left = -dropLevelOffset * indent;
      break;
    case 1:
      style.bottom = 0;
      style.left = -dropLevelOffset * indent;
      break;
    case 0:
      style.bottom = 0;
      style.left = indent;
      break;
  }
  return /*#__PURE__*/react.createElement("div", {
    style: style
  });
};
if (false) {}
/* harmony default export */ var es_DropIndicator = (DropIndicator);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty.js
function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useLayoutEffect.js
var useLayoutEffect = __webpack_require__(76963);
// EXTERNAL MODULE: ./node_modules/rc-virtual-list/es/index.js + 17 modules
var es = __webpack_require__(15371);
// EXTERNAL MODULE: ./node_modules/rc-motion/es/index.js + 13 modules
var rc_motion_es = __webpack_require__(26981);
// EXTERNAL MODULE: ./node_modules/rc-tree/es/TreeNode.js + 1 modules
var TreeNode = __webpack_require__(33863);
;// CONCATENATED MODULE: ./node_modules/rc-tree/es/useUnmount.js




/**
 * Trigger only when component unmount
 */
function useUnmount(triggerStart, triggerEnd) {
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    firstMount = _React$useState2[0],
    setFirstMount = _React$useState2[1];
  (0,useLayoutEffect/* default */.Z)(function () {
    if (firstMount) {
      triggerStart();
      return function () {
        triggerEnd();
      };
    }
  }, [firstMount]);
  (0,useLayoutEffect/* default */.Z)(function () {
    setFirstMount(true);
    return function () {
      setFirstMount(false);
    };
  }, []);
}
/* harmony default export */ var es_useUnmount = (useUnmount);
// EXTERNAL MODULE: ./node_modules/rc-tree/es/utils/treeUtil.js
var treeUtil = __webpack_require__(77081);
;// CONCATENATED MODULE: ./node_modules/rc-tree/es/MotionTreeNode.js




var _excluded = ["className", "style", "motion", "motionNodes", "motionType", "onMotionStart", "onMotionEnd", "active", "treeNodeRequiredProps"];








var MotionTreeNode = /*#__PURE__*/react.forwardRef(function (oriProps, ref) {
  var className = oriProps.className,
    style = oriProps.style,
    motion = oriProps.motion,
    motionNodes = oriProps.motionNodes,
    motionType = oriProps.motionType,
    onOriginMotionStart = oriProps.onMotionStart,
    onOriginMotionEnd = oriProps.onMotionEnd,
    active = oriProps.active,
    treeNodeRequiredProps = oriProps.treeNodeRequiredProps,
    props = (0,objectWithoutProperties/* default */.Z)(oriProps, _excluded);
  var _React$useState = react.useState(true),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    visible = _React$useState2[0],
    setVisible = _React$useState2[1];
  var _React$useContext = react.useContext(contextTypes/* TreeContext */.k),
    prefixCls = _React$useContext.prefixCls;

  // Calculate target visible here.
  // And apply in effect to make `leave` motion work.
  var targetVisible = motionNodes && motionType !== 'hide';
  (0,useLayoutEffect/* default */.Z)(function () {
    if (motionNodes) {
      if (targetVisible !== visible) {
        setVisible(targetVisible);
      }
    }
  }, [motionNodes]);
  var triggerMotionStart = function triggerMotionStart() {
    if (motionNodes) {
      onOriginMotionStart();
    }
  };

  // Should only trigger once
  var triggerMotionEndRef = react.useRef(false);
  var triggerMotionEnd = function triggerMotionEnd() {
    if (motionNodes && !triggerMotionEndRef.current) {
      triggerMotionEndRef.current = true;
      onOriginMotionEnd();
    }
  };

  // Effect if unmount
  es_useUnmount(triggerMotionStart, triggerMotionEnd);

  // Motion end event
  var onVisibleChanged = function onVisibleChanged(nextVisible) {
    if (targetVisible === nextVisible) {
      triggerMotionEnd();
    }
  };
  if (motionNodes) {
    return /*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, (0,esm_extends/* default */.Z)({
      ref: ref,
      visible: visible
    }, motion, {
      motionAppear: motionType === 'show',
      onVisibleChanged: onVisibleChanged
    }), function (_ref, motionRef) {
      var motionClassName = _ref.className,
        motionStyle = _ref.style;
      return /*#__PURE__*/react.createElement("div", {
        ref: motionRef,
        className: classnames_default()("".concat(prefixCls, "-treenode-motion"), motionClassName),
        style: motionStyle
      }, motionNodes.map(function (treeNode) {
        var restProps = Object.assign({}, (_objectDestructuringEmpty(treeNode.data), treeNode.data)),
          title = treeNode.title,
          key = treeNode.key,
          isStart = treeNode.isStart,
          isEnd = treeNode.isEnd;
        delete restProps.children;
        var treeNodeProps = (0,treeUtil/* getTreeNodeProps */.H8)(key, treeNodeRequiredProps);
        return /*#__PURE__*/react.createElement(TreeNode/* default */.Z, (0,esm_extends/* default */.Z)({}, restProps, treeNodeProps, {
          title: title,
          active: active,
          data: treeNode.data,
          key: key,
          isStart: isStart,
          isEnd: isEnd
        }));
      }));
    });
  }
  return /*#__PURE__*/react.createElement(TreeNode/* default */.Z, (0,esm_extends/* default */.Z)({
    domRef: ref,
    className: className,
    style: style
  }, props, {
    active: active
  }));
});
if (false) {}
/* harmony default export */ var es_MotionTreeNode = (MotionTreeNode);
;// CONCATENATED MODULE: ./node_modules/rc-tree/es/utils/diffUtil.js
function findExpandedKeys() {
  var prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var prevLen = prev.length;
  var nextLen = next.length;
  if (Math.abs(prevLen - nextLen) !== 1) {
    return {
      add: false,
      key: null
    };
  }
  function find(shorter, longer) {
    var cache = new Map();
    shorter.forEach(function (key) {
      cache.set(key, true);
    });
    var keys = longer.filter(function (key) {
      return !cache.has(key);
    });
    return keys.length === 1 ? keys[0] : null;
  }
  if (prevLen < nextLen) {
    return {
      add: true,
      key: find(prev, next)
    };
  }
  return {
    add: false,
    key: find(next, prev)
  };
}
function getExpandRange(shorter, longer, key) {
  var shorterStartIndex = shorter.findIndex(function (data) {
    return data.key === key;
  });
  var shorterEndNode = shorter[shorterStartIndex + 1];
  var longerStartIndex = longer.findIndex(function (data) {
    return data.key === key;
  });
  if (shorterEndNode) {
    var longerEndIndex = longer.findIndex(function (data) {
      return data.key === shorterEndNode.key;
    });
    return longer.slice(longerStartIndex + 1, longerEndIndex);
  }
  return longer.slice(longerStartIndex + 1);
}
;// CONCATENATED MODULE: ./node_modules/rc-tree/es/NodeList.js




var NodeList_excluded = ["prefixCls", "data", "selectable", "checkable", "expandedKeys", "selectedKeys", "checkedKeys", "loadedKeys", "loadingKeys", "halfCheckedKeys", "keyEntities", "disabled", "dragging", "dragOverNodeKey", "dropPosition", "motion", "height", "itemHeight", "virtual", "scrollWidth", "focusable", "activeItem", "focused", "tabIndex", "onKeyDown", "onFocus", "onBlur", "onActiveChange", "onListChangeStart", "onListChangeEnd"];
/**
 * Handle virtual list of the TreeNodes.
 */







var HIDDEN_STYLE = {
  width: 0,
  height: 0,
  display: 'flex',
  overflow: 'hidden',
  opacity: 0,
  border: 0,
  padding: 0,
  margin: 0
};
var noop = function noop() {};
var MOTION_KEY = "RC_TREE_MOTION_".concat(Math.random());
var MotionNode = {
  key: MOTION_KEY
};
var MotionEntity = {
  key: MOTION_KEY,
  level: 0,
  index: 0,
  pos: '0',
  node: MotionNode,
  nodes: [MotionNode]
};
var MotionFlattenData = {
  parent: null,
  children: [],
  pos: MotionEntity.pos,
  data: MotionNode,
  title: null,
  key: MOTION_KEY,
  /** Hold empty list here since we do not use it */
  isStart: [],
  isEnd: []
};
/**
 * We only need get visible content items to play the animation.
 */
function getMinimumRangeTransitionRange(list, virtual, height, itemHeight) {
  if (virtual === false || !height) {
    return list;
  }
  return list.slice(0, Math.ceil(height / itemHeight) + 1);
}
function itemKey(item) {
  var key = item.key,
    pos = item.pos;
  return (0,treeUtil/* getKey */.km)(key, pos);
}
function getAccessibilityPath(item) {
  var path = String(item.data.key);
  var current = item;
  while (current.parent) {
    current = current.parent;
    path = "".concat(current.data.key, " > ").concat(path);
  }
  return path;
}
var NodeList = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    data = props.data,
    selectable = props.selectable,
    checkable = props.checkable,
    expandedKeys = props.expandedKeys,
    selectedKeys = props.selectedKeys,
    checkedKeys = props.checkedKeys,
    loadedKeys = props.loadedKeys,
    loadingKeys = props.loadingKeys,
    halfCheckedKeys = props.halfCheckedKeys,
    keyEntities = props.keyEntities,
    disabled = props.disabled,
    dragging = props.dragging,
    dragOverNodeKey = props.dragOverNodeKey,
    dropPosition = props.dropPosition,
    motion = props.motion,
    height = props.height,
    itemHeight = props.itemHeight,
    virtual = props.virtual,
    scrollWidth = props.scrollWidth,
    focusable = props.focusable,
    activeItem = props.activeItem,
    focused = props.focused,
    tabIndex = props.tabIndex,
    onKeyDown = props.onKeyDown,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onActiveChange = props.onActiveChange,
    onListChangeStart = props.onListChangeStart,
    onListChangeEnd = props.onListChangeEnd,
    domProps = (0,objectWithoutProperties/* default */.Z)(props, NodeList_excluded);

  // =============================== Ref ================================
  var listRef = react.useRef(null);
  var indentMeasurerRef = react.useRef(null);
  react.useImperativeHandle(ref, function () {
    return {
      scrollTo: function scrollTo(scroll) {
        listRef.current.scrollTo(scroll);
      },
      getIndentWidth: function getIndentWidth() {
        return indentMeasurerRef.current.offsetWidth;
      }
    };
  });

  // ============================== Motion ==============================
  var _React$useState = react.useState(expandedKeys),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    prevExpandedKeys = _React$useState2[0],
    setPrevExpandedKeys = _React$useState2[1];
  var _React$useState3 = react.useState(data),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    prevData = _React$useState4[0],
    setPrevData = _React$useState4[1];
  var _React$useState5 = react.useState(data),
    _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
    transitionData = _React$useState6[0],
    setTransitionData = _React$useState6[1];
  var _React$useState7 = react.useState([]),
    _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
    transitionRange = _React$useState8[0],
    setTransitionRange = _React$useState8[1];
  var _React$useState9 = react.useState(null),
    _React$useState10 = (0,slicedToArray/* default */.Z)(_React$useState9, 2),
    motionType = _React$useState10[0],
    setMotionType = _React$useState10[1];

  // When motion end but data change, this will makes data back to previous one
  var dataRef = react.useRef(data);
  dataRef.current = data;
  function onMotionEnd() {
    var latestData = dataRef.current;
    setPrevData(latestData);
    setTransitionData(latestData);
    setTransitionRange([]);
    setMotionType(null);
    onListChangeEnd();
  }

  // Do animation if expanded keys changed
  // layoutEffect here to avoid blink of node removing
  (0,useLayoutEffect/* default */.Z)(function () {
    setPrevExpandedKeys(expandedKeys);
    var diffExpanded = findExpandedKeys(prevExpandedKeys, expandedKeys);
    if (diffExpanded.key !== null) {
      if (diffExpanded.add) {
        var keyIndex = prevData.findIndex(function (_ref) {
          var key = _ref.key;
          return key === diffExpanded.key;
        });
        var rangeNodes = getMinimumRangeTransitionRange(getExpandRange(prevData, data, diffExpanded.key), virtual, height, itemHeight);
        var newTransitionData = prevData.slice();
        newTransitionData.splice(keyIndex + 1, 0, MotionFlattenData);
        setTransitionData(newTransitionData);
        setTransitionRange(rangeNodes);
        setMotionType('show');
      } else {
        var _keyIndex = data.findIndex(function (_ref2) {
          var key = _ref2.key;
          return key === diffExpanded.key;
        });
        var _rangeNodes = getMinimumRangeTransitionRange(getExpandRange(data, prevData, diffExpanded.key), virtual, height, itemHeight);
        var _newTransitionData = data.slice();
        _newTransitionData.splice(_keyIndex + 1, 0, MotionFlattenData);
        setTransitionData(_newTransitionData);
        setTransitionRange(_rangeNodes);
        setMotionType('hide');
      }
    } else if (prevData !== data) {
      // If whole data changed, we just refresh the list
      setPrevData(data);
      setTransitionData(data);
    }
  }, [expandedKeys, data]);

  // We should clean up motion if is changed by dragging
  react.useEffect(function () {
    if (!dragging) {
      onMotionEnd();
    }
  }, [dragging]);
  var mergedData = motion ? transitionData : data;
  var treeNodeRequiredProps = {
    expandedKeys: expandedKeys,
    selectedKeys: selectedKeys,
    loadedKeys: loadedKeys,
    loadingKeys: loadingKeys,
    checkedKeys: checkedKeys,
    halfCheckedKeys: halfCheckedKeys,
    dragOverNodeKey: dragOverNodeKey,
    dropPosition: dropPosition,
    keyEntities: keyEntities
  };
  return /*#__PURE__*/react.createElement(react.Fragment, null, focused && activeItem && /*#__PURE__*/react.createElement("span", {
    style: HIDDEN_STYLE,
    "aria-live": "assertive"
  }, getAccessibilityPath(activeItem)), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("input", {
    style: HIDDEN_STYLE,
    disabled: focusable === false || disabled,
    tabIndex: focusable !== false ? tabIndex : null,
    onKeyDown: onKeyDown,
    onFocus: onFocus,
    onBlur: onBlur,
    value: "",
    onChange: noop,
    "aria-label": "for screen reader"
  })), /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-treenode"),
    "aria-hidden": true,
    style: {
      position: 'absolute',
      pointerEvents: 'none',
      visibility: 'hidden',
      height: 0,
      overflow: 'hidden',
      border: 0,
      padding: 0
    }
  }, /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-indent")
  }, /*#__PURE__*/react.createElement("div", {
    ref: indentMeasurerRef,
    className: "".concat(prefixCls, "-indent-unit")
  }))), /*#__PURE__*/react.createElement(es/* default */.Z, (0,esm_extends/* default */.Z)({}, domProps, {
    data: mergedData,
    itemKey: itemKey,
    height: height,
    fullHeight: false,
    virtual: virtual,
    itemHeight: itemHeight,
    scrollWidth: scrollWidth,
    prefixCls: "".concat(prefixCls, "-list"),
    ref: listRef,
    role: "tree",
    onVisibleChange: function onVisibleChange(originList) {
      // The best match is using `fullList` - `originList` = `restList`
      // and check the `restList` to see if has the MOTION_KEY node
      // but this will cause performance issue for long list compare
      // we just check `originList` and repeat trigger `onMotionEnd`
      if (originList.every(function (item) {
        return itemKey(item) !== MOTION_KEY;
      })) {
        onMotionEnd();
      }
    }
  }), function (treeNode) {
    var pos = treeNode.pos,
      restProps = Object.assign({}, (_objectDestructuringEmpty(treeNode.data), treeNode.data)),
      title = treeNode.title,
      key = treeNode.key,
      isStart = treeNode.isStart,
      isEnd = treeNode.isEnd;
    var mergedKey = (0,treeUtil/* getKey */.km)(key, pos);
    delete restProps.key;
    delete restProps.children;
    var treeNodeProps = (0,treeUtil/* getTreeNodeProps */.H8)(mergedKey, treeNodeRequiredProps);
    return /*#__PURE__*/react.createElement(es_MotionTreeNode, (0,esm_extends/* default */.Z)({}, restProps, treeNodeProps, {
      title: title,
      active: !!activeItem && key === activeItem.key,
      pos: pos,
      data: treeNode.data,
      isStart: isStart,
      isEnd: isEnd,
      motion: motion,
      motionNodes: key === MOTION_KEY ? transitionRange : null,
      motionType: motionType,
      onMotionStart: onListChangeStart,
      onMotionEnd: onMotionEnd,
      treeNodeRequiredProps: treeNodeRequiredProps,
      onMouseMove: function onMouseMove() {
        onActiveChange(null);
      }
    }));
  }));
});
if (false) {}
/* harmony default export */ var es_NodeList = (NodeList);
// EXTERNAL MODULE: ./node_modules/rc-tree/es/util.js
var util = __webpack_require__(69958);
// EXTERNAL MODULE: ./node_modules/rc-tree/es/utils/conductUtil.js
var conductUtil = __webpack_require__(47139);
// EXTERNAL MODULE: ./node_modules/rc-tree/es/utils/keyUtil.js
var keyUtil = __webpack_require__(645);
;// CONCATENATED MODULE: ./node_modules/rc-tree/es/Tree.js










// TODO: https://www.w3.org/TR/2017/NOTE-wai-aria-practices-1.1-20171214/examples/treeview/treeview-2/treeview-2a.html
// Fully accessibility support














var MAX_RETRY_TIMES = 10;
var Tree = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(Tree, _React$Component);
  var _super = (0,createSuper/* default */.Z)(Tree);
  function Tree() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, Tree);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(_args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "destroyed", false);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "delayedDragEnterLogic", void 0);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "loadingRetryTimes", {});
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "state", {
      keyEntities: {},
      indent: null,
      selectedKeys: [],
      checkedKeys: [],
      halfCheckedKeys: [],
      loadedKeys: [],
      loadingKeys: [],
      expandedKeys: [],
      draggingNodeKey: null,
      dragChildrenKeys: [],
      // dropTargetKey is the key of abstract-drop-node
      // the abstract-drop-node is the real drop node when drag and drop
      // not the DOM drag over node
      dropTargetKey: null,
      dropPosition: null,
      // the drop position of abstract-drop-node, inside 0, top -1, bottom 1
      dropContainerKey: null,
      // the container key of abstract-drop-node if dropPosition is -1 or 1
      dropLevelOffset: null,
      // the drop level offset of abstract-drag-over-node
      dropTargetPos: null,
      // the pos of abstract-drop-node
      dropAllowed: true,
      // if drop to abstract-drop-node is allowed
      // the abstract-drag-over-node
      // if mouse is on the bottom of top dom node or no the top of the bottom dom node
      // abstract-drag-over-node is the top node
      dragOverNodeKey: null,
      treeData: [],
      flattenNodes: [],
      focused: false,
      activeKey: null,
      listChanging: false,
      prevProps: null,
      fieldNames: (0,treeUtil/* fillFieldNames */.w$)()
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "dragStartMousePosition", null);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "dragNodeProps", null);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "currentMouseOverDroppableNodeKey", null);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "listRef", /*#__PURE__*/react.createRef());
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onNodeDragStart", function (event, nodeProps) {
      var _this$state = _this.state,
        expandedKeys = _this$state.expandedKeys,
        keyEntities = _this$state.keyEntities;
      var onDragStart = _this.props.onDragStart;
      var eventKey = nodeProps.eventKey;
      _this.dragNodeProps = nodeProps;
      _this.dragStartMousePosition = {
        x: event.clientX,
        y: event.clientY
      };
      var newExpandedKeys = (0,util/* arrDel */._5)(expandedKeys, eventKey);
      _this.setState({
        draggingNodeKey: eventKey,
        dragChildrenKeys: (0,util/* getDragChildrenKeys */.wA)(eventKey, keyEntities),
        indent: _this.listRef.current.getIndentWidth()
      });
      _this.setExpandedKeys(newExpandedKeys);
      window.addEventListener('dragend', _this.onWindowDragEnd);
      onDragStart === null || onDragStart === void 0 || onDragStart({
        event: event,
        node: (0,treeUtil/* convertNodePropsToEventData */.F)(nodeProps)
      });
    });
    /**
     * [Legacy] Select handler is smaller than node,
     * so that this will trigger when drag enter node or select handler.
     * This is a little tricky if customize css without padding.
     * Better for use mouse move event to refresh drag state.
     * But let's just keep it to avoid event trigger logic change.
     */
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onNodeDragEnter", function (event, nodeProps) {
      var _this$state2 = _this.state,
        expandedKeys = _this$state2.expandedKeys,
        keyEntities = _this$state2.keyEntities,
        dragChildrenKeys = _this$state2.dragChildrenKeys,
        flattenNodes = _this$state2.flattenNodes,
        indent = _this$state2.indent;
      var _this$props = _this.props,
        onDragEnter = _this$props.onDragEnter,
        onExpand = _this$props.onExpand,
        allowDrop = _this$props.allowDrop,
        direction = _this$props.direction;
      var pos = nodeProps.pos,
        eventKey = nodeProps.eventKey;

      // record the key of node which is latest entered, used in dragleave event.
      if (_this.currentMouseOverDroppableNodeKey !== eventKey) {
        _this.currentMouseOverDroppableNodeKey = eventKey;
      }
      if (!_this.dragNodeProps) {
        _this.resetDragState();
        return;
      }
      var _calcDropPosition = (0,util/* calcDropPosition */.OM)(event, _this.dragNodeProps, nodeProps, indent, _this.dragStartMousePosition, allowDrop, flattenNodes, keyEntities, expandedKeys, direction),
        dropPosition = _calcDropPosition.dropPosition,
        dropLevelOffset = _calcDropPosition.dropLevelOffset,
        dropTargetKey = _calcDropPosition.dropTargetKey,
        dropContainerKey = _calcDropPosition.dropContainerKey,
        dropTargetPos = _calcDropPosition.dropTargetPos,
        dropAllowed = _calcDropPosition.dropAllowed,
        dragOverNodeKey = _calcDropPosition.dragOverNodeKey;
      if (
      // don't allow drop inside its children
      dragChildrenKeys.includes(dropTargetKey) ||
      // don't allow drop when drop is not allowed caculated by calcDropPosition
      !dropAllowed) {
        _this.resetDragState();
        return;
      }

      // Side effect for delay drag
      if (!_this.delayedDragEnterLogic) {
        _this.delayedDragEnterLogic = {};
      }
      Object.keys(_this.delayedDragEnterLogic).forEach(function (key) {
        clearTimeout(_this.delayedDragEnterLogic[key]);
      });
      if (_this.dragNodeProps.eventKey !== nodeProps.eventKey) {
        // hoist expand logic here
        // since if logic is on the bottom
        // it will be blocked by abstract dragover node check
        //   => if you dragenter from top, you mouse will still be consider as in the top node
        event.persist();
        _this.delayedDragEnterLogic[pos] = window.setTimeout(function () {
          if (_this.state.draggingNodeKey === null) {
            return;
          }
          var newExpandedKeys = (0,toConsumableArray/* default */.Z)(expandedKeys);
          var entity = (0,keyUtil/* default */.Z)(keyEntities, nodeProps.eventKey);
          if (entity && (entity.children || []).length) {
            newExpandedKeys = (0,util/* arrAdd */.L0)(expandedKeys, nodeProps.eventKey);
          }
          if (!_this.props.hasOwnProperty('expandedKeys')) {
            _this.setExpandedKeys(newExpandedKeys);
          }
          onExpand === null || onExpand === void 0 || onExpand(newExpandedKeys, {
            node: (0,treeUtil/* convertNodePropsToEventData */.F)(nodeProps),
            expanded: true,
            nativeEvent: event.nativeEvent
          });
        }, 800);
      }

      // Skip if drag node is self
      if (_this.dragNodeProps.eventKey === dropTargetKey && dropLevelOffset === 0) {
        _this.resetDragState();
        return;
      }

      // Update drag over node and drag state
      _this.setState({
        dragOverNodeKey: dragOverNodeKey,
        dropPosition: dropPosition,
        dropLevelOffset: dropLevelOffset,
        dropTargetKey: dropTargetKey,
        dropContainerKey: dropContainerKey,
        dropTargetPos: dropTargetPos,
        dropAllowed: dropAllowed
      });
      onDragEnter === null || onDragEnter === void 0 || onDragEnter({
        event: event,
        node: (0,treeUtil/* convertNodePropsToEventData */.F)(nodeProps),
        expandedKeys: expandedKeys
      });
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onNodeDragOver", function (event, nodeProps) {
      var _this$state3 = _this.state,
        dragChildrenKeys = _this$state3.dragChildrenKeys,
        flattenNodes = _this$state3.flattenNodes,
        keyEntities = _this$state3.keyEntities,
        expandedKeys = _this$state3.expandedKeys,
        indent = _this$state3.indent;
      var _this$props2 = _this.props,
        onDragOver = _this$props2.onDragOver,
        allowDrop = _this$props2.allowDrop,
        direction = _this$props2.direction;
      if (!_this.dragNodeProps) {
        return;
      }
      var _calcDropPosition2 = (0,util/* calcDropPosition */.OM)(event, _this.dragNodeProps, nodeProps, indent, _this.dragStartMousePosition, allowDrop, flattenNodes, keyEntities, expandedKeys, direction),
        dropPosition = _calcDropPosition2.dropPosition,
        dropLevelOffset = _calcDropPosition2.dropLevelOffset,
        dropTargetKey = _calcDropPosition2.dropTargetKey,
        dropContainerKey = _calcDropPosition2.dropContainerKey,
        dropTargetPos = _calcDropPosition2.dropTargetPos,
        dropAllowed = _calcDropPosition2.dropAllowed,
        dragOverNodeKey = _calcDropPosition2.dragOverNodeKey;
      if (dragChildrenKeys.includes(dropTargetKey) || !dropAllowed) {
        // don't allow drop inside its children
        // don't allow drop when drop is not allowed calculated by calcDropPosition
        return;
      }

      // Update drag position

      if (_this.dragNodeProps.eventKey === dropTargetKey && dropLevelOffset === 0) {
        if (!(_this.state.dropPosition === null && _this.state.dropLevelOffset === null && _this.state.dropTargetKey === null && _this.state.dropContainerKey === null && _this.state.dropTargetPos === null && _this.state.dropAllowed === false && _this.state.dragOverNodeKey === null)) {
          _this.resetDragState();
        }
      } else if (!(dropPosition === _this.state.dropPosition && dropLevelOffset === _this.state.dropLevelOffset && dropTargetKey === _this.state.dropTargetKey && dropContainerKey === _this.state.dropContainerKey && dropTargetPos === _this.state.dropTargetPos && dropAllowed === _this.state.dropAllowed && dragOverNodeKey === _this.state.dragOverNodeKey)) {
        _this.setState({
          dropPosition: dropPosition,
          dropLevelOffset: dropLevelOffset,
          dropTargetKey: dropTargetKey,
          dropContainerKey: dropContainerKey,
          dropTargetPos: dropTargetPos,
          dropAllowed: dropAllowed,
          dragOverNodeKey: dragOverNodeKey
        });
      }
      onDragOver === null || onDragOver === void 0 || onDragOver({
        event: event,
        node: (0,treeUtil/* convertNodePropsToEventData */.F)(nodeProps)
      });
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onNodeDragLeave", function (event, nodeProps) {
      // if it is outside the droppable area
      // currentMouseOverDroppableNodeKey will be updated in dragenter event when into another droppable receiver.
      if (_this.currentMouseOverDroppableNodeKey === nodeProps.eventKey && !event.currentTarget.contains(event.relatedTarget)) {
        _this.resetDragState();
        _this.currentMouseOverDroppableNodeKey = null;
      }
      var onDragLeave = _this.props.onDragLeave;
      onDragLeave === null || onDragLeave === void 0 || onDragLeave({
        event: event,
        node: (0,treeUtil/* convertNodePropsToEventData */.F)(nodeProps)
      });
    });
    // since stopPropagation() is called in treeNode
    // if onWindowDrag is called, whice means state is keeped, drag state should be cleared
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onWindowDragEnd", function (event) {
      _this.onNodeDragEnd(event, null, true);
      window.removeEventListener('dragend', _this.onWindowDragEnd);
    });
    // if onNodeDragEnd is called, onWindowDragEnd won't be called since stopPropagation() is called
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onNodeDragEnd", function (event, nodeProps) {
      var onDragEnd = _this.props.onDragEnd;
      _this.setState({
        dragOverNodeKey: null
      });
      _this.cleanDragState();
      onDragEnd === null || onDragEnd === void 0 || onDragEnd({
        event: event,
        node: (0,treeUtil/* convertNodePropsToEventData */.F)(nodeProps)
      });
      _this.dragNodeProps = null;
      window.removeEventListener('dragend', _this.onWindowDragEnd);
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onNodeDrop", function (event, _) {
      var _this$getActiveItem;
      var outsideTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var _this$state4 = _this.state,
        dragChildrenKeys = _this$state4.dragChildrenKeys,
        dropPosition = _this$state4.dropPosition,
        dropTargetKey = _this$state4.dropTargetKey,
        dropTargetPos = _this$state4.dropTargetPos,
        dropAllowed = _this$state4.dropAllowed;
      if (!dropAllowed) {
        return;
      }
      var onDrop = _this.props.onDrop;
      _this.setState({
        dragOverNodeKey: null
      });
      _this.cleanDragState();
      if (dropTargetKey === null) return;
      var abstractDropNodeProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, (0,treeUtil/* getTreeNodeProps */.H8)(dropTargetKey, _this.getTreeNodeRequiredProps())), {}, {
        active: ((_this$getActiveItem = _this.getActiveItem()) === null || _this$getActiveItem === void 0 ? void 0 : _this$getActiveItem.key) === dropTargetKey,
        data: (0,keyUtil/* default */.Z)(_this.state.keyEntities, dropTargetKey).node
      });
      var dropToChild = dragChildrenKeys.includes(dropTargetKey);
      (0,warning/* default */.ZP)(!dropToChild, "Can not drop to dragNode's children node. This is a bug of rc-tree. Please report an issue.");
      var posArr = (0,util/* posToArr */.yx)(dropTargetPos);
      var dropResult = {
        event: event,
        node: (0,treeUtil/* convertNodePropsToEventData */.F)(abstractDropNodeProps),
        dragNode: _this.dragNodeProps ? (0,treeUtil/* convertNodePropsToEventData */.F)(_this.dragNodeProps) : null,
        dragNodesKeys: [_this.dragNodeProps.eventKey].concat(dragChildrenKeys),
        dropToGap: dropPosition !== 0,
        dropPosition: dropPosition + Number(posArr[posArr.length - 1])
      };
      if (!outsideTree) {
        onDrop === null || onDrop === void 0 || onDrop(dropResult);
      }
      _this.dragNodeProps = null;
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "cleanDragState", function () {
      var draggingNodeKey = _this.state.draggingNodeKey;
      if (draggingNodeKey !== null) {
        _this.setState({
          draggingNodeKey: null,
          dropPosition: null,
          dropContainerKey: null,
          dropTargetKey: null,
          dropLevelOffset: null,
          dropAllowed: true,
          dragOverNodeKey: null
        });
      }
      _this.dragStartMousePosition = null;
      _this.currentMouseOverDroppableNodeKey = null;
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "triggerExpandActionExpand", function (e, treeNode) {
      var _this$state5 = _this.state,
        expandedKeys = _this$state5.expandedKeys,
        flattenNodes = _this$state5.flattenNodes;
      var expanded = treeNode.expanded,
        key = treeNode.key,
        isLeaf = treeNode.isLeaf;
      if (isLeaf || e.shiftKey || e.metaKey || e.ctrlKey) {
        return;
      }
      var node = flattenNodes.filter(function (nodeItem) {
        return nodeItem.key === key;
      })[0];
      var eventNode = (0,treeUtil/* convertNodePropsToEventData */.F)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, (0,treeUtil/* getTreeNodeProps */.H8)(key, _this.getTreeNodeRequiredProps())), {}, {
        data: node.data
      }));
      _this.setExpandedKeys(expanded ? (0,util/* arrDel */._5)(expandedKeys, key) : (0,util/* arrAdd */.L0)(expandedKeys, key));
      _this.onNodeExpand(e, eventNode);
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onNodeClick", function (e, treeNode) {
      var _this$props3 = _this.props,
        onClick = _this$props3.onClick,
        expandAction = _this$props3.expandAction;
      if (expandAction === 'click') {
        _this.triggerExpandActionExpand(e, treeNode);
      }
      onClick === null || onClick === void 0 || onClick(e, treeNode);
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onNodeDoubleClick", function (e, treeNode) {
      var _this$props4 = _this.props,
        onDoubleClick = _this$props4.onDoubleClick,
        expandAction = _this$props4.expandAction;
      if (expandAction === 'doubleClick') {
        _this.triggerExpandActionExpand(e, treeNode);
      }
      onDoubleClick === null || onDoubleClick === void 0 || onDoubleClick(e, treeNode);
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onNodeSelect", function (e, treeNode) {
      var selectedKeys = _this.state.selectedKeys;
      var _this$state6 = _this.state,
        keyEntities = _this$state6.keyEntities,
        fieldNames = _this$state6.fieldNames;
      var _this$props5 = _this.props,
        onSelect = _this$props5.onSelect,
        multiple = _this$props5.multiple;
      var selected = treeNode.selected;
      var key = treeNode[fieldNames.key];
      var targetSelected = !selected;

      // Update selected keys
      if (!targetSelected) {
        selectedKeys = (0,util/* arrDel */._5)(selectedKeys, key);
      } else if (!multiple) {
        selectedKeys = [key];
      } else {
        selectedKeys = (0,util/* arrAdd */.L0)(selectedKeys, key);
      }

      // [Legacy] Not found related usage in doc or upper libs
      var selectedNodes = selectedKeys.map(function (selectedKey) {
        var entity = (0,keyUtil/* default */.Z)(keyEntities, selectedKey);
        return entity ? entity.node : null;
      }).filter(Boolean);
      _this.setUncontrolledState({
        selectedKeys: selectedKeys
      });
      onSelect === null || onSelect === void 0 || onSelect(selectedKeys, {
        event: 'select',
        selected: targetSelected,
        node: treeNode,
        selectedNodes: selectedNodes,
        nativeEvent: e.nativeEvent
      });
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onNodeCheck", function (e, treeNode, checked) {
      var _this$state7 = _this.state,
        keyEntities = _this$state7.keyEntities,
        oriCheckedKeys = _this$state7.checkedKeys,
        oriHalfCheckedKeys = _this$state7.halfCheckedKeys;
      var _this$props6 = _this.props,
        checkStrictly = _this$props6.checkStrictly,
        onCheck = _this$props6.onCheck;
      var key = treeNode.key;

      // Prepare trigger arguments
      var checkedObj;
      var eventObj = {
        event: 'check',
        node: treeNode,
        checked: checked,
        nativeEvent: e.nativeEvent
      };
      if (checkStrictly) {
        var checkedKeys = checked ? (0,util/* arrAdd */.L0)(oriCheckedKeys, key) : (0,util/* arrDel */._5)(oriCheckedKeys, key);
        var halfCheckedKeys = (0,util/* arrDel */._5)(oriHalfCheckedKeys, key);
        checkedObj = {
          checked: checkedKeys,
          halfChecked: halfCheckedKeys
        };
        eventObj.checkedNodes = checkedKeys.map(function (checkedKey) {
          return (0,keyUtil/* default */.Z)(keyEntities, checkedKey);
        }).filter(Boolean).map(function (entity) {
          return entity.node;
        });
        _this.setUncontrolledState({
          checkedKeys: checkedKeys
        });
      } else {
        // Always fill first
        var _conductCheck = (0,conductUtil/* conductCheck */.S)([].concat((0,toConsumableArray/* default */.Z)(oriCheckedKeys), [key]), true, keyEntities),
          _checkedKeys = _conductCheck.checkedKeys,
          _halfCheckedKeys = _conductCheck.halfCheckedKeys;

        // If remove, we do it again to correction
        if (!checked) {
          var keySet = new Set(_checkedKeys);
          keySet.delete(key);
          var _conductCheck2 = (0,conductUtil/* conductCheck */.S)(Array.from(keySet), {
            checked: false,
            halfCheckedKeys: _halfCheckedKeys
          }, keyEntities);
          _checkedKeys = _conductCheck2.checkedKeys;
          _halfCheckedKeys = _conductCheck2.halfCheckedKeys;
        }
        checkedObj = _checkedKeys;

        // [Legacy] This is used for `rc-tree-select`
        eventObj.checkedNodes = [];
        eventObj.checkedNodesPositions = [];
        eventObj.halfCheckedKeys = _halfCheckedKeys;
        _checkedKeys.forEach(function (checkedKey) {
          var entity = (0,keyUtil/* default */.Z)(keyEntities, checkedKey);
          if (!entity) return;
          var node = entity.node,
            pos = entity.pos;
          eventObj.checkedNodes.push(node);
          eventObj.checkedNodesPositions.push({
            node: node,
            pos: pos
          });
        });
        _this.setUncontrolledState({
          checkedKeys: _checkedKeys
        }, false, {
          halfCheckedKeys: _halfCheckedKeys
        });
      }
      onCheck === null || onCheck === void 0 || onCheck(checkedObj, eventObj);
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onNodeLoad", function (treeNode) {
      var _entity$children;
      var key = treeNode.key;
      var keyEntities = _this.state.keyEntities;

      // Skip if has children already
      var entity = (0,keyUtil/* default */.Z)(keyEntities, key);
      if (entity !== null && entity !== void 0 && (_entity$children = entity.children) !== null && _entity$children !== void 0 && _entity$children.length) {
        return;
      }
      var loadPromise = new Promise(function (resolve, reject) {
        // We need to get the latest state of loading/loaded keys
        _this.setState(function (_ref) {
          var _ref$loadedKeys = _ref.loadedKeys,
            loadedKeys = _ref$loadedKeys === void 0 ? [] : _ref$loadedKeys,
            _ref$loadingKeys = _ref.loadingKeys,
            loadingKeys = _ref$loadingKeys === void 0 ? [] : _ref$loadingKeys;
          var _this$props7 = _this.props,
            loadData = _this$props7.loadData,
            onLoad = _this$props7.onLoad;
          if (!loadData || loadedKeys.includes(key) || loadingKeys.includes(key)) {
            return null;
          }

          // Process load data
          var promise = loadData(treeNode);
          promise.then(function () {
            var currentLoadedKeys = _this.state.loadedKeys;
            var newLoadedKeys = (0,util/* arrAdd */.L0)(currentLoadedKeys, key);

            // onLoad should trigger before internal setState to avoid `loadData` trigger twice.
            // https://github.com/ant-design/ant-design/issues/12464
            onLoad === null || onLoad === void 0 || onLoad(newLoadedKeys, {
              event: 'load',
              node: treeNode
            });
            _this.setUncontrolledState({
              loadedKeys: newLoadedKeys
            });
            _this.setState(function (prevState) {
              return {
                loadingKeys: (0,util/* arrDel */._5)(prevState.loadingKeys, key)
              };
            });
            resolve();
          }).catch(function (e) {
            _this.setState(function (prevState) {
              return {
                loadingKeys: (0,util/* arrDel */._5)(prevState.loadingKeys, key)
              };
            });

            // If exceed max retry times, we give up retry
            _this.loadingRetryTimes[key] = (_this.loadingRetryTimes[key] || 0) + 1;
            if (_this.loadingRetryTimes[key] >= MAX_RETRY_TIMES) {
              var currentLoadedKeys = _this.state.loadedKeys;
              (0,warning/* default */.ZP)(false, 'Retry for `loadData` many times but still failed. No more retry.');
              _this.setUncontrolledState({
                loadedKeys: (0,util/* arrAdd */.L0)(currentLoadedKeys, key)
              });
              resolve();
            }
            reject(e);
          });
          return {
            loadingKeys: (0,util/* arrAdd */.L0)(loadingKeys, key)
          };
        });
      });

      // Not care warning if we ignore this
      loadPromise.catch(function () {});
      return loadPromise;
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onNodeMouseEnter", function (event, node) {
      var onMouseEnter = _this.props.onMouseEnter;
      onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
        event: event,
        node: node
      });
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onNodeMouseLeave", function (event, node) {
      var onMouseLeave = _this.props.onMouseLeave;
      onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
        event: event,
        node: node
      });
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onNodeContextMenu", function (event, node) {
      var onRightClick = _this.props.onRightClick;
      if (onRightClick) {
        event.preventDefault();
        onRightClick({
          event: event,
          node: node
        });
      }
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onFocus", function () {
      var onFocus = _this.props.onFocus;
      _this.setState({
        focused: true
      });
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      onFocus === null || onFocus === void 0 || onFocus.apply(void 0, args);
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onBlur", function () {
      var onBlur = _this.props.onBlur;
      _this.setState({
        focused: false
      });
      _this.onActiveChange(null);
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      onBlur === null || onBlur === void 0 || onBlur.apply(void 0, args);
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "getTreeNodeRequiredProps", function () {
      var _this$state8 = _this.state,
        expandedKeys = _this$state8.expandedKeys,
        selectedKeys = _this$state8.selectedKeys,
        loadedKeys = _this$state8.loadedKeys,
        loadingKeys = _this$state8.loadingKeys,
        checkedKeys = _this$state8.checkedKeys,
        halfCheckedKeys = _this$state8.halfCheckedKeys,
        dragOverNodeKey = _this$state8.dragOverNodeKey,
        dropPosition = _this$state8.dropPosition,
        keyEntities = _this$state8.keyEntities;
      return {
        expandedKeys: expandedKeys || [],
        selectedKeys: selectedKeys || [],
        loadedKeys: loadedKeys || [],
        loadingKeys: loadingKeys || [],
        checkedKeys: checkedKeys || [],
        halfCheckedKeys: halfCheckedKeys || [],
        dragOverNodeKey: dragOverNodeKey,
        dropPosition: dropPosition,
        keyEntities: keyEntities
      };
    });
    // =========================== Expanded ===========================
    /** Set uncontrolled `expandedKeys`. This will also auto update `flattenNodes`. */
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "setExpandedKeys", function (expandedKeys) {
      var _this$state9 = _this.state,
        treeData = _this$state9.treeData,
        fieldNames = _this$state9.fieldNames;
      var flattenNodes = (0,treeUtil/* flattenTreeData */.oH)(treeData, expandedKeys, fieldNames);
      _this.setUncontrolledState({
        expandedKeys: expandedKeys,
        flattenNodes: flattenNodes
      }, true);
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onNodeExpand", function (e, treeNode) {
      var expandedKeys = _this.state.expandedKeys;
      var _this$state10 = _this.state,
        listChanging = _this$state10.listChanging,
        fieldNames = _this$state10.fieldNames;
      var _this$props8 = _this.props,
        onExpand = _this$props8.onExpand,
        loadData = _this$props8.loadData;
      var expanded = treeNode.expanded;
      var key = treeNode[fieldNames.key];

      // Do nothing when motion is in progress
      if (listChanging) {
        return;
      }

      // Update selected keys
      var certain = expandedKeys.includes(key);
      var targetExpanded = !expanded;
      (0,warning/* default */.ZP)(expanded && certain || !expanded && !certain, 'Expand state not sync with index check');
      expandedKeys = targetExpanded ? (0,util/* arrAdd */.L0)(expandedKeys, key) : (0,util/* arrDel */._5)(expandedKeys, key);
      _this.setExpandedKeys(expandedKeys);
      onExpand === null || onExpand === void 0 || onExpand(expandedKeys, {
        node: treeNode,
        expanded: targetExpanded,
        nativeEvent: e.nativeEvent
      });

      // Async Load data
      if (targetExpanded && loadData) {
        var loadPromise = _this.onNodeLoad(treeNode);
        if (loadPromise) {
          loadPromise.then(function () {
            // [Legacy] Refresh logic
            var newFlattenTreeData = (0,treeUtil/* flattenTreeData */.oH)(_this.state.treeData, expandedKeys, fieldNames);
            _this.setUncontrolledState({
              flattenNodes: newFlattenTreeData
            });
          }).catch(function () {
            var currentExpandedKeys = _this.state.expandedKeys;
            var expandedKeysToRestore = (0,util/* arrDel */._5)(currentExpandedKeys, key);
            _this.setExpandedKeys(expandedKeysToRestore);
          });
        }
      }
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onListChangeStart", function () {
      _this.setUncontrolledState({
        listChanging: true
      });
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onListChangeEnd", function () {
      setTimeout(function () {
        _this.setUncontrolledState({
          listChanging: false
        });
      });
    });
    // =========================== Keyboard ===========================
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onActiveChange", function (newActiveKey) {
      var activeKey = _this.state.activeKey;
      var _this$props9 = _this.props,
        onActiveChange = _this$props9.onActiveChange,
        _this$props9$itemScro = _this$props9.itemScrollOffset,
        itemScrollOffset = _this$props9$itemScro === void 0 ? 0 : _this$props9$itemScro;
      if (activeKey === newActiveKey) {
        return;
      }
      _this.setState({
        activeKey: newActiveKey
      });
      if (newActiveKey !== null) {
        _this.scrollTo({
          key: newActiveKey,
          offset: itemScrollOffset
        });
      }
      onActiveChange === null || onActiveChange === void 0 || onActiveChange(newActiveKey);
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "getActiveItem", function () {
      var _this$state11 = _this.state,
        activeKey = _this$state11.activeKey,
        flattenNodes = _this$state11.flattenNodes;
      if (activeKey === null) {
        return null;
      }
      return flattenNodes.find(function (_ref2) {
        var key = _ref2.key;
        return key === activeKey;
      }) || null;
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "offsetActiveKey", function (offset) {
      var _this$state12 = _this.state,
        flattenNodes = _this$state12.flattenNodes,
        activeKey = _this$state12.activeKey;
      var index = flattenNodes.findIndex(function (_ref3) {
        var key = _ref3.key;
        return key === activeKey;
      });

      // Align with index
      if (index === -1 && offset < 0) {
        index = flattenNodes.length;
      }
      index = (index + offset + flattenNodes.length) % flattenNodes.length;
      var item = flattenNodes[index];
      if (item) {
        var _key4 = item.key;
        _this.onActiveChange(_key4);
      } else {
        _this.onActiveChange(null);
      }
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onKeyDown", function (event) {
      var _this$state13 = _this.state,
        activeKey = _this$state13.activeKey,
        expandedKeys = _this$state13.expandedKeys,
        checkedKeys = _this$state13.checkedKeys,
        fieldNames = _this$state13.fieldNames;
      var _this$props10 = _this.props,
        onKeyDown = _this$props10.onKeyDown,
        checkable = _this$props10.checkable,
        selectable = _this$props10.selectable;

      // >>>>>>>>>> Direction
      switch (event.which) {
        case KeyCode/* default.UP */.Z.UP:
          {
            _this.offsetActiveKey(-1);
            event.preventDefault();
            break;
          }
        case KeyCode/* default.DOWN */.Z.DOWN:
          {
            _this.offsetActiveKey(1);
            event.preventDefault();
            break;
          }
      }

      // >>>>>>>>>> Expand & Selection
      var activeItem = _this.getActiveItem();
      if (activeItem && activeItem.data) {
        var treeNodeRequiredProps = _this.getTreeNodeRequiredProps();
        var expandable = activeItem.data.isLeaf === false || !!(activeItem.data[fieldNames.children] || []).length;
        var eventNode = (0,treeUtil/* convertNodePropsToEventData */.F)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, (0,treeUtil/* getTreeNodeProps */.H8)(activeKey, treeNodeRequiredProps)), {}, {
          data: activeItem.data,
          active: true
        }));
        switch (event.which) {
          // >>> Expand
          case KeyCode/* default.LEFT */.Z.LEFT:
            {
              // Collapse if possible
              if (expandable && expandedKeys.includes(activeKey)) {
                _this.onNodeExpand({}, eventNode);
              } else if (activeItem.parent) {
                _this.onActiveChange(activeItem.parent.key);
              }
              event.preventDefault();
              break;
            }
          case KeyCode/* default.RIGHT */.Z.RIGHT:
            {
              // Expand if possible
              if (expandable && !expandedKeys.includes(activeKey)) {
                _this.onNodeExpand({}, eventNode);
              } else if (activeItem.children && activeItem.children.length) {
                _this.onActiveChange(activeItem.children[0].key);
              }
              event.preventDefault();
              break;
            }

          // Selection
          case KeyCode/* default.ENTER */.Z.ENTER:
          case KeyCode/* default.SPACE */.Z.SPACE:
            {
              if (checkable && !eventNode.disabled && eventNode.checkable !== false && !eventNode.disableCheckbox) {
                _this.onNodeCheck({}, eventNode, !checkedKeys.includes(activeKey));
              } else if (!checkable && selectable && !eventNode.disabled && eventNode.selectable !== false) {
                _this.onNodeSelect({}, eventNode);
              }
              break;
            }
        }
      }
      onKeyDown === null || onKeyDown === void 0 || onKeyDown(event);
    });
    /**
     * Only update the value which is not in props
     */
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "setUncontrolledState", function (state) {
      var atomic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var forceState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (!_this.destroyed) {
        var needSync = false;
        var allPassed = true;
        var newState = {};
        Object.keys(state).forEach(function (name) {
          if (_this.props.hasOwnProperty(name)) {
            allPassed = false;
            return;
          }
          needSync = true;
          newState[name] = state[name];
        });
        if (needSync && (!atomic || allPassed)) {
          _this.setState((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, newState), forceState));
        }
      }
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "scrollTo", function (scroll) {
      _this.listRef.current.scrollTo(scroll);
    });
    return _this;
  }
  (0,createClass/* default */.Z)(Tree, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.destroyed = false;
      this.onUpdated();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.onUpdated();
    }
  }, {
    key: "onUpdated",
    value: function onUpdated() {
      var _this$props11 = this.props,
        activeKey = _this$props11.activeKey,
        _this$props11$itemScr = _this$props11.itemScrollOffset,
        itemScrollOffset = _this$props11$itemScr === void 0 ? 0 : _this$props11$itemScr;
      if (activeKey !== undefined && activeKey !== this.state.activeKey) {
        this.setState({
          activeKey: activeKey
        });
        if (activeKey !== null) {
          this.scrollTo({
            key: activeKey,
            offset: itemScrollOffset
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('dragend', this.onWindowDragEnd);
      this.destroyed = true;
    }
  }, {
    key: "resetDragState",
    value: function resetDragState() {
      this.setState({
        dragOverNodeKey: null,
        dropPosition: null,
        dropLevelOffset: null,
        dropTargetKey: null,
        dropContainerKey: null,
        dropTargetPos: null,
        dropAllowed: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state14 = this.state,
        focused = _this$state14.focused,
        flattenNodes = _this$state14.flattenNodes,
        keyEntities = _this$state14.keyEntities,
        draggingNodeKey = _this$state14.draggingNodeKey,
        activeKey = _this$state14.activeKey,
        dropLevelOffset = _this$state14.dropLevelOffset,
        dropContainerKey = _this$state14.dropContainerKey,
        dropTargetKey = _this$state14.dropTargetKey,
        dropPosition = _this$state14.dropPosition,
        dragOverNodeKey = _this$state14.dragOverNodeKey,
        indent = _this$state14.indent;
      var _this$props12 = this.props,
        prefixCls = _this$props12.prefixCls,
        className = _this$props12.className,
        style = _this$props12.style,
        showLine = _this$props12.showLine,
        focusable = _this$props12.focusable,
        _this$props12$tabInde = _this$props12.tabIndex,
        tabIndex = _this$props12$tabInde === void 0 ? 0 : _this$props12$tabInde,
        selectable = _this$props12.selectable,
        showIcon = _this$props12.showIcon,
        icon = _this$props12.icon,
        switcherIcon = _this$props12.switcherIcon,
        draggable = _this$props12.draggable,
        checkable = _this$props12.checkable,
        checkStrictly = _this$props12.checkStrictly,
        disabled = _this$props12.disabled,
        motion = _this$props12.motion,
        loadData = _this$props12.loadData,
        filterTreeNode = _this$props12.filterTreeNode,
        height = _this$props12.height,
        itemHeight = _this$props12.itemHeight,
        scrollWidth = _this$props12.scrollWidth,
        virtual = _this$props12.virtual,
        titleRender = _this$props12.titleRender,
        dropIndicatorRender = _this$props12.dropIndicatorRender,
        onContextMenu = _this$props12.onContextMenu,
        onScroll = _this$props12.onScroll,
        direction = _this$props12.direction,
        rootClassName = _this$props12.rootClassName,
        rootStyle = _this$props12.rootStyle;
      var domProps = (0,pickAttrs/* default */.Z)(this.props, {
        aria: true,
        data: true
      });

      // It's better move to hooks but we just simply keep here
      var draggableConfig;
      if (draggable) {
        if ((0,esm_typeof/* default */.Z)(draggable) === 'object') {
          draggableConfig = draggable;
        } else if (typeof draggable === 'function') {
          draggableConfig = {
            nodeDraggable: draggable
          };
        } else {
          draggableConfig = {};
        }
      }
      var contextValue = {
        prefixCls: prefixCls,
        selectable: selectable,
        showIcon: showIcon,
        icon: icon,
        switcherIcon: switcherIcon,
        draggable: draggableConfig,
        draggingNodeKey: draggingNodeKey,
        checkable: checkable,
        checkStrictly: checkStrictly,
        disabled: disabled,
        keyEntities: keyEntities,
        dropLevelOffset: dropLevelOffset,
        dropContainerKey: dropContainerKey,
        dropTargetKey: dropTargetKey,
        dropPosition: dropPosition,
        dragOverNodeKey: dragOverNodeKey,
        indent: indent,
        direction: direction,
        dropIndicatorRender: dropIndicatorRender,
        loadData: loadData,
        filterTreeNode: filterTreeNode,
        titleRender: titleRender,
        onNodeClick: this.onNodeClick,
        onNodeDoubleClick: this.onNodeDoubleClick,
        onNodeExpand: this.onNodeExpand,
        onNodeSelect: this.onNodeSelect,
        onNodeCheck: this.onNodeCheck,
        onNodeLoad: this.onNodeLoad,
        onNodeMouseEnter: this.onNodeMouseEnter,
        onNodeMouseLeave: this.onNodeMouseLeave,
        onNodeContextMenu: this.onNodeContextMenu,
        onNodeDragStart: this.onNodeDragStart,
        onNodeDragEnter: this.onNodeDragEnter,
        onNodeDragOver: this.onNodeDragOver,
        onNodeDragLeave: this.onNodeDragLeave,
        onNodeDragEnd: this.onNodeDragEnd,
        onNodeDrop: this.onNodeDrop
      };
      return /*#__PURE__*/react.createElement(contextTypes/* TreeContext.Provider */.k.Provider, {
        value: contextValue
      }, /*#__PURE__*/react.createElement("div", {
        className: classnames_default()(prefixCls, className, rootClassName, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-show-line"), showLine), "".concat(prefixCls, "-focused"), focused), "".concat(prefixCls, "-active-focused"), activeKey !== null)),
        style: rootStyle
      }, /*#__PURE__*/react.createElement(es_NodeList, (0,esm_extends/* default */.Z)({
        ref: this.listRef,
        prefixCls: prefixCls,
        style: style,
        data: flattenNodes,
        disabled: disabled,
        selectable: selectable,
        checkable: !!checkable,
        motion: motion,
        dragging: draggingNodeKey !== null,
        height: height,
        itemHeight: itemHeight,
        virtual: virtual,
        focusable: focusable,
        focused: focused,
        tabIndex: tabIndex,
        activeItem: this.getActiveItem(),
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        onActiveChange: this.onActiveChange,
        onListChangeStart: this.onListChangeStart,
        onListChangeEnd: this.onListChangeEnd,
        onContextMenu: onContextMenu,
        onScroll: onScroll,
        scrollWidth: scrollWidth
      }, this.getTreeNodeRequiredProps(), domProps))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, prevState) {
      var prevProps = prevState.prevProps;
      var newState = {
        prevProps: props
      };
      function needSync(name) {
        return !prevProps && props.hasOwnProperty(name) || prevProps && prevProps[name] !== props[name];
      }

      // ================== Tree Node ==================
      var treeData;

      // fieldNames
      var fieldNames = prevState.fieldNames;
      if (needSync('fieldNames')) {
        fieldNames = (0,treeUtil/* fillFieldNames */.w$)(props.fieldNames);
        newState.fieldNames = fieldNames;
      }

      // Check if `treeData` or `children` changed and save into the state.
      if (needSync('treeData')) {
        treeData = props.treeData;
      } else if (needSync('children')) {
        (0,warning/* default */.ZP)(false, '`children` of Tree is deprecated. Please use `treeData` instead.');
        treeData = (0,treeUtil/* convertTreeToData */.zn)(props.children);
      }

      // Save flatten nodes info and convert `treeData` into keyEntities
      if (treeData) {
        newState.treeData = treeData;
        var entitiesMap = (0,treeUtil/* convertDataToEntities */.I8)(treeData, {
          fieldNames: fieldNames
        });
        newState.keyEntities = (0,objectSpread2/* default */.Z)((0,defineProperty/* default */.Z)({}, MOTION_KEY, MotionEntity), entitiesMap.keyEntities);

        // Warning if treeNode not provide key
        if (false) {}
      }
      var keyEntities = newState.keyEntities || prevState.keyEntities;

      // ================ expandedKeys =================
      if (needSync('expandedKeys') || prevProps && needSync('autoExpandParent')) {
        newState.expandedKeys = props.autoExpandParent || !prevProps && props.defaultExpandParent ? (0,util/* conductExpandParent */.r7)(props.expandedKeys, keyEntities) : props.expandedKeys;
      } else if (!prevProps && props.defaultExpandAll) {
        var cloneKeyEntities = (0,objectSpread2/* default */.Z)({}, keyEntities);
        delete cloneKeyEntities[MOTION_KEY];

        // Only take the key who has the children to enhance the performance
        var nextExpandedKeys = [];
        Object.keys(cloneKeyEntities).forEach(function (key) {
          var entity = cloneKeyEntities[key];
          if (entity.children && entity.children.length) {
            nextExpandedKeys.push(entity.key);
          }
        });
        newState.expandedKeys = nextExpandedKeys;
      } else if (!prevProps && props.defaultExpandedKeys) {
        newState.expandedKeys = props.autoExpandParent || props.defaultExpandParent ? (0,util/* conductExpandParent */.r7)(props.defaultExpandedKeys, keyEntities) : props.defaultExpandedKeys;
      }
      if (!newState.expandedKeys) {
        delete newState.expandedKeys;
      }

      // ================ flattenNodes =================
      if (treeData || newState.expandedKeys) {
        var flattenNodes = (0,treeUtil/* flattenTreeData */.oH)(treeData || prevState.treeData, newState.expandedKeys || prevState.expandedKeys, fieldNames);
        newState.flattenNodes = flattenNodes;
      }

      // ================ selectedKeys =================
      if (props.selectable) {
        if (needSync('selectedKeys')) {
          newState.selectedKeys = (0,util/* calcSelectedKeys */.BT)(props.selectedKeys, props);
        } else if (!prevProps && props.defaultSelectedKeys) {
          newState.selectedKeys = (0,util/* calcSelectedKeys */.BT)(props.defaultSelectedKeys, props);
        }
      }

      // ================= checkedKeys =================
      if (props.checkable) {
        var checkedKeyEntity;
        if (needSync('checkedKeys')) {
          checkedKeyEntity = (0,util/* parseCheckedKeys */.E6)(props.checkedKeys) || {};
        } else if (!prevProps && props.defaultCheckedKeys) {
          checkedKeyEntity = (0,util/* parseCheckedKeys */.E6)(props.defaultCheckedKeys) || {};
        } else if (treeData) {
          // If `treeData` changed, we also need check it
          checkedKeyEntity = (0,util/* parseCheckedKeys */.E6)(props.checkedKeys) || {
            checkedKeys: prevState.checkedKeys,
            halfCheckedKeys: prevState.halfCheckedKeys
          };
        }
        if (checkedKeyEntity) {
          var _checkedKeyEntity = checkedKeyEntity,
            _checkedKeyEntity$che = _checkedKeyEntity.checkedKeys,
            checkedKeys = _checkedKeyEntity$che === void 0 ? [] : _checkedKeyEntity$che,
            _checkedKeyEntity$hal = _checkedKeyEntity.halfCheckedKeys,
            halfCheckedKeys = _checkedKeyEntity$hal === void 0 ? [] : _checkedKeyEntity$hal;
          if (!props.checkStrictly) {
            var conductKeys = (0,conductUtil/* conductCheck */.S)(checkedKeys, true, keyEntities);
            checkedKeys = conductKeys.checkedKeys;
            halfCheckedKeys = conductKeys.halfCheckedKeys;
          }
          newState.checkedKeys = checkedKeys;
          newState.halfCheckedKeys = halfCheckedKeys;
        }
      }

      // ================= loadedKeys ==================
      if (needSync('loadedKeys')) {
        newState.loadedKeys = props.loadedKeys;
      }
      return newState;
    }
  }]);
  return Tree;
}(react.Component);
(0,defineProperty/* default */.Z)(Tree, "defaultProps", {
  prefixCls: 'rc-tree',
  showLine: false,
  showIcon: true,
  selectable: true,
  multiple: false,
  checkable: false,
  disabled: false,
  checkStrictly: false,
  draggable: false,
  defaultExpandParent: true,
  autoExpandParent: false,
  defaultExpandAll: false,
  defaultExpandedKeys: [],
  defaultCheckedKeys: [],
  defaultSelectedKeys: [],
  dropIndicatorRender: es_DropIndicator,
  allowDrop: function allowDrop() {
    return true;
  },
  expandAction: false
});
(0,defineProperty/* default */.Z)(Tree, "TreeNode", TreeNode/* default */.Z);
/* harmony default export */ var es_Tree = (Tree);
;// CONCATENATED MODULE: ./node_modules/rc-tree/es/index.js




/* harmony default export */ var rc_tree_es = (es_Tree);

/***/ }),

/***/ 69958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BT": function() { return /* binding */ calcSelectedKeys; },
/* harmony export */   "E6": function() { return /* binding */ parseCheckedKeys; },
/* harmony export */   "L0": function() { return /* binding */ arrAdd; },
/* harmony export */   "OM": function() { return /* binding */ calcDropPosition; },
/* harmony export */   "_5": function() { return /* binding */ arrDel; },
/* harmony export */   "r7": function() { return /* binding */ conductExpandParent; },
/* harmony export */   "wA": function() { return /* binding */ getDragChildrenKeys; },
/* harmony export */   "yx": function() { return /* binding */ posToArr; }
/* harmony export */ });
/* unused harmony exports isLastChild, isFirstChild, convertDataToTree */
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83889);
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45827);
/* harmony import */ var rc_util_es_warning__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13764);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var _TreeNode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33863);
/* harmony import */ var _utils_keyUtil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(645);
/* harmony import */ var _utils_treeUtil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77081);




var _excluded = (/* unused pure expression or super */ null && (["children"]));
/* eslint-disable no-lonely-if */
/**
 * Legacy code. Should avoid to use if you are new to import these code.
 */






function arrDel(list, value) {
  if (!list) return [];
  var clone = list.slice();
  var index = clone.indexOf(value);
  if (index >= 0) {
    clone.splice(index, 1);
  }
  return clone;
}
function arrAdd(list, value) {
  var clone = (list || []).slice();
  if (clone.indexOf(value) === -1) {
    clone.push(value);
  }
  return clone;
}
function posToArr(pos) {
  return pos.split('-');
}
function getDragChildrenKeys(dragNodeKey, keyEntities) {
  // not contains self
  // self for left or right drag
  var dragChildrenKeys = [];
  var entity = (0,_utils_keyUtil__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(keyEntities, dragNodeKey);
  function dig() {
    var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    list.forEach(function (_ref) {
      var key = _ref.key,
        children = _ref.children;
      dragChildrenKeys.push(key);
      dig(children);
    });
  }
  dig(entity.children);
  return dragChildrenKeys;
}
function isLastChild(treeNodeEntity) {
  if (treeNodeEntity.parent) {
    var posArr = posToArr(treeNodeEntity.pos);
    return Number(posArr[posArr.length - 1]) === treeNodeEntity.parent.children.length - 1;
  }
  return false;
}
function isFirstChild(treeNodeEntity) {
  var posArr = posToArr(treeNodeEntity.pos);
  return Number(posArr[posArr.length - 1]) === 0;
}

// Only used when drag, not affect SSR.
function calcDropPosition(event, dragNodeProps, targetNodeProps, indent, startMousePosition, allowDrop, flattenedNodes, keyEntities, expandKeys, direction) {
  var _abstractDropNodeEnti;
  var clientX = event.clientX,
    clientY = event.clientY;
  var _getBoundingClientRec = event.target.getBoundingClientRect(),
    top = _getBoundingClientRec.top,
    height = _getBoundingClientRec.height;
  // optional chain for testing
  var horizontalMouseOffset = (direction === 'rtl' ? -1 : 1) * (((startMousePosition === null || startMousePosition === void 0 ? void 0 : startMousePosition.x) || 0) - clientX);
  var rawDropLevelOffset = (horizontalMouseOffset - 12) / indent;

  // Filter the expanded keys to exclude the node that not has children currently (like async nodes).
  var filteredExpandKeys = expandKeys.filter(function (key) {
    var _keyEntities$key;
    return (_keyEntities$key = keyEntities[key]) === null || _keyEntities$key === void 0 || (_keyEntities$key = _keyEntities$key.children) === null || _keyEntities$key === void 0 ? void 0 : _keyEntities$key.length;
  });

  // find abstract drop node by horizontal offset
  var abstractDropNodeEntity = (0,_utils_keyUtil__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(keyEntities, targetNodeProps.eventKey);
  if (clientY < top + height / 2) {
    // first half, set abstract drop node to previous node
    var nodeIndex = flattenedNodes.findIndex(function (flattenedNode) {
      return flattenedNode.key === abstractDropNodeEntity.key;
    });
    var prevNodeIndex = nodeIndex <= 0 ? 0 : nodeIndex - 1;
    var prevNodeKey = flattenedNodes[prevNodeIndex].key;
    abstractDropNodeEntity = (0,_utils_keyUtil__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(keyEntities, prevNodeKey);
  }
  var initialAbstractDropNodeKey = abstractDropNodeEntity.key;
  var abstractDragOverEntity = abstractDropNodeEntity;
  var dragOverNodeKey = abstractDropNodeEntity.key;
  var dropPosition = 0;
  var dropLevelOffset = 0;

  // Only allow cross level drop when dragging on a non-expanded node
  if (!filteredExpandKeys.includes(initialAbstractDropNodeKey)) {
    for (var i = 0; i < rawDropLevelOffset; i += 1) {
      if (isLastChild(abstractDropNodeEntity)) {
        abstractDropNodeEntity = abstractDropNodeEntity.parent;
        dropLevelOffset += 1;
      } else {
        break;
      }
    }
  }
  var abstractDragDataNode = dragNodeProps.data;
  var abstractDropDataNode = abstractDropNodeEntity.node;
  var dropAllowed = true;
  if (isFirstChild(abstractDropNodeEntity) && abstractDropNodeEntity.level === 0 && clientY < top + height / 2 && allowDrop({
    dragNode: abstractDragDataNode,
    dropNode: abstractDropDataNode,
    dropPosition: -1
  }) && abstractDropNodeEntity.key === targetNodeProps.eventKey) {
    // first half of first node in first level
    dropPosition = -1;
  } else if ((abstractDragOverEntity.children || []).length && filteredExpandKeys.includes(dragOverNodeKey)) {
    // drop on expanded node
    // only allow drop inside
    if (allowDrop({
      dragNode: abstractDragDataNode,
      dropNode: abstractDropDataNode,
      dropPosition: 0
    })) {
      dropPosition = 0;
    } else {
      dropAllowed = false;
    }
  } else if (dropLevelOffset === 0) {
    if (rawDropLevelOffset > -1.5) {
      // | Node     | <- abstractDropNode
      // | -^-===== | <- mousePosition
      // 1. try drop after
      // 2. do not allow drop
      if (allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: 1
      })) {
        dropPosition = 1;
      } else {
        dropAllowed = false;
      }
    } else {
      // | Node     | <- abstractDropNode
      // | ---==^== | <- mousePosition
      // whether it has children or doesn't has children
      // always
      // 1. try drop inside
      // 2. try drop after
      // 3. do not allow drop
      if (allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: 0
      })) {
        dropPosition = 0;
      } else if (allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: 1
      })) {
        dropPosition = 1;
      } else {
        dropAllowed = false;
      }
    }
  } else {
    // | Node1 | <- abstractDropNode
    //      |  Node2  |
    // --^--|----=====| <- mousePosition
    // 1. try insert after Node1
    // 2. do not allow drop
    if (allowDrop({
      dragNode: abstractDragDataNode,
      dropNode: abstractDropDataNode,
      dropPosition: 1
    })) {
      dropPosition = 1;
    } else {
      dropAllowed = false;
    }
  }
  return {
    dropPosition: dropPosition,
    dropLevelOffset: dropLevelOffset,
    dropTargetKey: abstractDropNodeEntity.key,
    dropTargetPos: abstractDropNodeEntity.pos,
    dragOverNodeKey: dragOverNodeKey,
    dropContainerKey: dropPosition === 0 ? null : ((_abstractDropNodeEnti = abstractDropNodeEntity.parent) === null || _abstractDropNodeEnti === void 0 ? void 0 : _abstractDropNodeEnti.key) || null,
    dropAllowed: dropAllowed
  };
}

/**
 * Return selectedKeys according with multiple prop
 * @param selectedKeys
 * @param props
 * @returns [string]
 */
function calcSelectedKeys(selectedKeys, props) {
  if (!selectedKeys) return undefined;
  var multiple = props.multiple;
  if (multiple) {
    return selectedKeys.slice();
  }
  if (selectedKeys.length) {
    return [selectedKeys[0]];
  }
  return selectedKeys;
}
var internalProcessProps = function internalProcessProps(props) {
  return props;
};
function convertDataToTree(treeData, processor) {
  if (!treeData) return [];
  var _ref2 = processor || {},
    _ref2$processProps = _ref2.processProps,
    processProps = _ref2$processProps === void 0 ? internalProcessProps : _ref2$processProps;
  var list = Array.isArray(treeData) ? treeData : [treeData];
  return list.map(function (_ref3) {
    var children = _ref3.children,
      props = _objectWithoutProperties(_ref3, _excluded);
    var childrenNodes = convertDataToTree(children, processor);
    return /*#__PURE__*/React.createElement(TreeNode, _extends({
      key: props.key
    }, processProps(props)), childrenNodes);
  });
}

/**
 * Parse `checkedKeys` to { checkedKeys, halfCheckedKeys } style
 */
function parseCheckedKeys(keys) {
  if (!keys) {
    return null;
  }

  // Convert keys to object format
  var keyProps;
  if (Array.isArray(keys)) {
    // [Legacy] Follow the api doc
    keyProps = {
      checkedKeys: keys,
      halfCheckedKeys: undefined
    };
  } else if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(keys) === 'object') {
    keyProps = {
      checkedKeys: keys.checked || undefined,
      halfCheckedKeys: keys.halfChecked || undefined
    };
  } else {
    (0,rc_util_es_warning__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(false, '`checkedKeys` is not an array or an object');
    return null;
  }
  return keyProps;
}

/**
 * If user use `autoExpandParent` we should get the list of parent node
 * @param keyList
 * @param keyEntities
 */
function conductExpandParent(keyList, keyEntities) {
  var expandedKeys = new Set();
  function conductUp(key) {
    if (expandedKeys.has(key)) return;
    var entity = (0,_utils_keyUtil__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(keyEntities, key);
    if (!entity) return;
    expandedKeys.add(key);
    var parent = entity.parent,
      node = entity.node;
    if (node.disabled) return;
    if (parent) {
      conductUp(parent.key);
    }
  }
  (keyList || []).forEach(function (key) {
    conductUp(key);
  });
  return (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(expandedKeys);
}

/***/ }),

/***/ 47139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ conductCheck; }
/* harmony export */ });
/* unused harmony export isCheckDisabled */
/* harmony import */ var rc_util_es_warning__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13764);
/* harmony import */ var _keyUtil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(645);


function removeFromCheckedKeys(halfCheckedKeys, checkedKeys) {
  var filteredKeys = new Set();
  halfCheckedKeys.forEach(function (key) {
    if (!checkedKeys.has(key)) {
      filteredKeys.add(key);
    }
  });
  return filteredKeys;
}
function isCheckDisabled(node) {
  var _ref = node || {},
    disabled = _ref.disabled,
    disableCheckbox = _ref.disableCheckbox,
    checkable = _ref.checkable;
  return !!(disabled || disableCheckbox) || checkable === false;
}

// Fill miss keys
function fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
  var checkedKeys = new Set(keys);
  var halfCheckedKeys = new Set();

  // Add checked keys top to bottom
  for (var level = 0; level <= maxLevel; level += 1) {
    var entities = levelEntities.get(level) || new Set();
    entities.forEach(function (entity) {
      var key = entity.key,
        node = entity.node,
        _entity$children = entity.children,
        children = _entity$children === void 0 ? [] : _entity$children;
      if (checkedKeys.has(key) && !syntheticGetCheckDisabled(node)) {
        children.filter(function (childEntity) {
          return !syntheticGetCheckDisabled(childEntity.node);
        }).forEach(function (childEntity) {
          checkedKeys.add(childEntity.key);
        });
      }
    });
  }

  // Add checked keys from bottom to top
  var visitedKeys = new Set();
  for (var _level = maxLevel; _level >= 0; _level -= 1) {
    var _entities = levelEntities.get(_level) || new Set();
    _entities.forEach(function (entity) {
      var parent = entity.parent,
        node = entity.node;

      // Skip if no need to check
      if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) {
        return;
      }

      // Skip if parent is disabled
      if (syntheticGetCheckDisabled(entity.parent.node)) {
        visitedKeys.add(parent.key);
        return;
      }
      var allChecked = true;
      var partialChecked = false;
      (parent.children || []).filter(function (childEntity) {
        return !syntheticGetCheckDisabled(childEntity.node);
      }).forEach(function (_ref2) {
        var key = _ref2.key;
        var checked = checkedKeys.has(key);
        if (allChecked && !checked) {
          allChecked = false;
        }
        if (!partialChecked && (checked || halfCheckedKeys.has(key))) {
          partialChecked = true;
        }
      });
      if (allChecked) {
        checkedKeys.add(parent.key);
      }
      if (partialChecked) {
        halfCheckedKeys.add(parent.key);
      }
      visitedKeys.add(parent.key);
    });
  }
  return {
    checkedKeys: Array.from(checkedKeys),
    halfCheckedKeys: Array.from(removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
  };
}

// Remove useless key
function cleanConductCheck(keys, halfKeys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
  var checkedKeys = new Set(keys);
  var halfCheckedKeys = new Set(halfKeys);

  // Remove checked keys from top to bottom
  for (var level = 0; level <= maxLevel; level += 1) {
    var entities = levelEntities.get(level) || new Set();
    entities.forEach(function (entity) {
      var key = entity.key,
        node = entity.node,
        _entity$children2 = entity.children,
        children = _entity$children2 === void 0 ? [] : _entity$children2;
      if (!checkedKeys.has(key) && !halfCheckedKeys.has(key) && !syntheticGetCheckDisabled(node)) {
        children.filter(function (childEntity) {
          return !syntheticGetCheckDisabled(childEntity.node);
        }).forEach(function (childEntity) {
          checkedKeys.delete(childEntity.key);
        });
      }
    });
  }

  // Remove checked keys form bottom to top
  halfCheckedKeys = new Set();
  var visitedKeys = new Set();
  for (var _level2 = maxLevel; _level2 >= 0; _level2 -= 1) {
    var _entities2 = levelEntities.get(_level2) || new Set();
    _entities2.forEach(function (entity) {
      var parent = entity.parent,
        node = entity.node;

      // Skip if no need to check
      if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) {
        return;
      }

      // Skip if parent is disabled
      if (syntheticGetCheckDisabled(entity.parent.node)) {
        visitedKeys.add(parent.key);
        return;
      }
      var allChecked = true;
      var partialChecked = false;
      (parent.children || []).filter(function (childEntity) {
        return !syntheticGetCheckDisabled(childEntity.node);
      }).forEach(function (_ref3) {
        var key = _ref3.key;
        var checked = checkedKeys.has(key);
        if (allChecked && !checked) {
          allChecked = false;
        }
        if (!partialChecked && (checked || halfCheckedKeys.has(key))) {
          partialChecked = true;
        }
      });
      if (!allChecked) {
        checkedKeys.delete(parent.key);
      }
      if (partialChecked) {
        halfCheckedKeys.add(parent.key);
      }
      visitedKeys.add(parent.key);
    });
  }
  return {
    checkedKeys: Array.from(checkedKeys),
    halfCheckedKeys: Array.from(removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
  };
}

/**
 * Conduct with keys.
 * @param keyList current key list
 * @param keyEntities key - dataEntity map
 * @param mode `fill` to fill missing key, `clean` to remove useless key
 */
function conductCheck(keyList, checked, keyEntities, getCheckDisabled) {
  var warningMissKeys = [];
  var syntheticGetCheckDisabled;
  if (getCheckDisabled) {
    syntheticGetCheckDisabled = getCheckDisabled;
  } else {
    syntheticGetCheckDisabled = isCheckDisabled;
  }

  // We only handle exist keys
  var keys = new Set(keyList.filter(function (key) {
    var hasEntity = !!(0,_keyUtil__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(keyEntities, key);
    if (!hasEntity) {
      warningMissKeys.push(key);
    }
    return hasEntity;
  }));
  var levelEntities = new Map();
  var maxLevel = 0;

  // Convert entities by level for calculation
  Object.keys(keyEntities).forEach(function (key) {
    var entity = keyEntities[key];
    var level = entity.level;
    var levelSet = levelEntities.get(level);
    if (!levelSet) {
      levelSet = new Set();
      levelEntities.set(level, levelSet);
    }
    levelSet.add(entity);
    maxLevel = Math.max(maxLevel, level);
  });
  (0,rc_util_es_warning__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(!warningMissKeys.length, "Tree missing follow keys: ".concat(warningMissKeys.slice(0, 100).map(function (key) {
    return "'".concat(key, "'");
  }).join(', ')));
  var result;
  if (checked === true) {
    result = fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled);
  } else {
    result = cleanConductCheck(keys, checked.halfCheckedKeys, levelEntities, maxLevel, syntheticGetCheckDisabled);
  }
  return result;
}

/***/ }),

/***/ 645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getEntity; }
/* harmony export */ });
function getEntity(keyEntities, key) {
  return keyEntities[key];
}

/***/ }),

/***/ 77081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ convertNodePropsToEventData; },
/* harmony export */   "H8": function() { return /* binding */ getTreeNodeProps; },
/* harmony export */   "I8": function() { return /* binding */ convertDataToEntities; },
/* harmony export */   "km": function() { return /* binding */ getKey; },
/* harmony export */   "oH": function() { return /* binding */ flattenTreeData; },
/* harmony export */   "w$": function() { return /* binding */ fillFieldNames; },
/* harmony export */   "zn": function() { return /* binding */ convertTreeToData; }
/* harmony export */ });
/* unused harmony exports getPosition, isTreeNode, warningWithoutKey, traverseDataNodes */
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45827);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83889);
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56717);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91032);
/* harmony import */ var rc_util_es_Children_toArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93550);
/* harmony import */ var rc_util_es_omit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85401);
/* harmony import */ var rc_util_es_warning__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13764);
/* harmony import */ var _keyUtil__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(645);




var _excluded = ["children"];




function getPosition(level, index) {
  return "".concat(level, "-").concat(index);
}
function isTreeNode(node) {
  return node && node.type && node.type.isTreeNode;
}
function getKey(key, pos) {
  if (key !== null && key !== undefined) {
    return key;
  }
  return pos;
}
function fillFieldNames(fieldNames) {
  var _ref = fieldNames || {},
    title = _ref.title,
    _title = _ref._title,
    key = _ref.key,
    children = _ref.children;
  var mergedTitle = title || 'title';
  return {
    title: mergedTitle,
    _title: _title || [mergedTitle],
    key: key || 'key',
    children: children || 'children'
  };
}

/**
 * Warning if TreeNode do not provides key
 */
function warningWithoutKey(treeData, fieldNames) {
  var keys = new Map();
  function dig(list) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    (list || []).forEach(function (treeNode) {
      var key = treeNode[fieldNames.key];
      var children = treeNode[fieldNames.children];
      warning(key !== null && key !== undefined, "Tree node must have a certain key: [".concat(path).concat(key, "]"));
      var recordKey = String(key);
      warning(!keys.has(recordKey) || key === null || key === undefined, "Same 'key' exist in the Tree: ".concat(recordKey));
      keys.set(recordKey, true);
      dig(children, "".concat(path).concat(recordKey, " > "));
    });
  }
  dig(treeData);
}

/**
 * Convert `children` of Tree into `treeData` structure.
 */
function convertTreeToData(rootNodes) {
  function dig(node) {
    var treeNodes = (0,rc_util_es_Children_toArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node);
    return treeNodes.map(function (treeNode) {
      // Filter invalidate node
      if (!isTreeNode(treeNode)) {
        (0,rc_util_es_warning__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(!treeNode, 'Tree/TreeNode can only accept TreeNode as children.');
        return null;
      }
      var key = treeNode.key;
      var _treeNode$props = treeNode.props,
        children = _treeNode$props.children,
        rest = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_treeNode$props, _excluded);
      var dataNode = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        key: key
      }, rest);
      var parsedChildren = dig(children);
      if (parsedChildren.length) {
        dataNode.children = parsedChildren;
      }
      return dataNode;
    }).filter(function (dataNode) {
      return dataNode;
    });
  }
  return dig(rootNodes);
}

/**
 * Flat nest tree data into flatten list. This is used for virtual list render.
 * @param treeNodeList Origin data node list
 * @param expandedKeys
 * need expanded keys, provides `true` means all expanded (used in `rc-tree-select`).
 */
function flattenTreeData(treeNodeList, expandedKeys, fieldNames) {
  var _fillFieldNames = fillFieldNames(fieldNames),
    fieldTitles = _fillFieldNames._title,
    fieldKey = _fillFieldNames.key,
    fieldChildren = _fillFieldNames.children;
  var expandedKeySet = new Set(expandedKeys === true ? [] : expandedKeys);
  var flattenList = [];
  function dig(list) {
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return list.map(function (treeNode, index) {
      var pos = getPosition(parent ? parent.pos : '0', index);
      var mergedKey = getKey(treeNode[fieldKey], pos);

      // Pick matched title in field title list
      var mergedTitle;
      for (var i = 0; i < fieldTitles.length; i += 1) {
        var fieldTitle = fieldTitles[i];
        if (treeNode[fieldTitle] !== undefined) {
          mergedTitle = treeNode[fieldTitle];
          break;
        }
      }

      // Add FlattenDataNode into list
      // We use `Object.assign` here to save perf since babel's `objectSpread` has perf issue
      var flattenNode = Object.assign((0,rc_util_es_omit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(treeNode, [].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(fieldTitles), [fieldKey, fieldChildren])), {
        title: mergedTitle,
        key: mergedKey,
        parent: parent,
        pos: pos,
        children: null,
        data: treeNode,
        isStart: [].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(parent ? parent.isStart : []), [index === 0]),
        isEnd: [].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(parent ? parent.isEnd : []), [index === list.length - 1])
      });
      flattenList.push(flattenNode);

      // Loop treeNode children
      if (expandedKeys === true || expandedKeySet.has(mergedKey)) {
        flattenNode.children = dig(treeNode[fieldChildren] || [], flattenNode);
      } else {
        flattenNode.children = [];
      }
      return flattenNode;
    });
  }
  dig(treeNodeList);
  return flattenList;
}
/**
 * Traverse all the data by `treeData`.
 * Please not use it out of the `rc-tree` since we may refactor this code.
 */
function traverseDataNodes(dataNodes, callback,
// To avoid too many params, let use config instead of origin param
config) {
  var mergedConfig = {};
  if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(config) === 'object') {
    mergedConfig = config;
  } else {
    mergedConfig = {
      externalGetKey: config
    };
  }
  mergedConfig = mergedConfig || {};

  // Init config
  var _mergedConfig = mergedConfig,
    childrenPropName = _mergedConfig.childrenPropName,
    externalGetKey = _mergedConfig.externalGetKey,
    fieldNames = _mergedConfig.fieldNames;
  var _fillFieldNames2 = fillFieldNames(fieldNames),
    fieldKey = _fillFieldNames2.key,
    fieldChildren = _fillFieldNames2.children;
  var mergeChildrenPropName = childrenPropName || fieldChildren;

  // Get keys
  var syntheticGetKey;
  if (externalGetKey) {
    if (typeof externalGetKey === 'string') {
      syntheticGetKey = function syntheticGetKey(node) {
        return node[externalGetKey];
      };
    } else if (typeof externalGetKey === 'function') {
      syntheticGetKey = function syntheticGetKey(node) {
        return externalGetKey(node);
      };
    }
  } else {
    syntheticGetKey = function syntheticGetKey(node, pos) {
      return getKey(node[fieldKey], pos);
    };
  }

  // Process
  function processNode(node, index, parent, pathNodes) {
    var children = node ? node[mergeChildrenPropName] : dataNodes;
    var pos = node ? getPosition(parent.pos, index) : '0';
    var connectNodes = node ? [].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(pathNodes), [node]) : [];

    // Process node if is not root
    if (node) {
      var key = syntheticGetKey(node, pos);
      var _data = {
        node: node,
        index: index,
        pos: pos,
        key: key,
        parentPos: parent.node ? parent.pos : null,
        level: parent.level + 1,
        nodes: connectNodes
      };
      callback(_data);
    }

    // Process children node
    if (children) {
      children.forEach(function (subNode, subIndex) {
        processNode(subNode, subIndex, {
          node: node,
          pos: pos,
          level: parent ? parent.level + 1 : -1
        }, connectNodes);
      });
    }
  }
  processNode(null);
}
/**
 * Convert `treeData` into entity records.
 */
function convertDataToEntities(dataNodes) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    initWrapper = _ref2.initWrapper,
    processEntity = _ref2.processEntity,
    onProcessFinished = _ref2.onProcessFinished,
    externalGetKey = _ref2.externalGetKey,
    childrenPropName = _ref2.childrenPropName,
    fieldNames = _ref2.fieldNames;
  var /** @deprecated Use `config.externalGetKey` instead */
  legacyExternalGetKey = arguments.length > 2 ? arguments[2] : undefined;
  // Init config
  var mergedExternalGetKey = externalGetKey || legacyExternalGetKey;
  var posEntities = {};
  var keyEntities = {};
  var wrapper = {
    posEntities: posEntities,
    keyEntities: keyEntities
  };
  if (initWrapper) {
    wrapper = initWrapper(wrapper) || wrapper;
  }
  traverseDataNodes(dataNodes, function (item) {
    var node = item.node,
      index = item.index,
      pos = item.pos,
      key = item.key,
      parentPos = item.parentPos,
      level = item.level,
      nodes = item.nodes;
    var entity = {
      node: node,
      nodes: nodes,
      index: index,
      key: key,
      pos: pos,
      level: level
    };
    var mergedKey = getKey(key, pos);
    posEntities[pos] = entity;
    keyEntities[mergedKey] = entity;

    // Fill children
    entity.parent = posEntities[parentPos];
    if (entity.parent) {
      entity.parent.children = entity.parent.children || [];
      entity.parent.children.push(entity);
    }
    if (processEntity) {
      processEntity(entity, wrapper);
    }
  }, {
    externalGetKey: mergedExternalGetKey,
    childrenPropName: childrenPropName,
    fieldNames: fieldNames
  });
  if (onProcessFinished) {
    onProcessFinished(wrapper);
  }
  return wrapper;
}
/**
 * Get TreeNode props with Tree props.
 */
function getTreeNodeProps(key, _ref3) {
  var expandedKeys = _ref3.expandedKeys,
    selectedKeys = _ref3.selectedKeys,
    loadedKeys = _ref3.loadedKeys,
    loadingKeys = _ref3.loadingKeys,
    checkedKeys = _ref3.checkedKeys,
    halfCheckedKeys = _ref3.halfCheckedKeys,
    dragOverNodeKey = _ref3.dragOverNodeKey,
    dropPosition = _ref3.dropPosition,
    keyEntities = _ref3.keyEntities;
  var entity = (0,_keyUtil__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(keyEntities, key);
  var treeNodeProps = {
    eventKey: key,
    expanded: expandedKeys.indexOf(key) !== -1,
    selected: selectedKeys.indexOf(key) !== -1,
    loaded: loadedKeys.indexOf(key) !== -1,
    loading: loadingKeys.indexOf(key) !== -1,
    checked: checkedKeys.indexOf(key) !== -1,
    halfChecked: halfCheckedKeys.indexOf(key) !== -1,
    pos: String(entity ? entity.pos : ''),
    // [Legacy] Drag props
    // Since the interaction of drag is changed, the semantic of the props are
    // not accuracy, I think it should be finally removed
    dragOver: dragOverNodeKey === key && dropPosition === 0,
    dragOverGapTop: dragOverNodeKey === key && dropPosition === -1,
    dragOverGapBottom: dragOverNodeKey === key && dropPosition === 1
  };
  return treeNodeProps;
}
function convertNodePropsToEventData(props) {
  var data = props.data,
    expanded = props.expanded,
    selected = props.selected,
    checked = props.checked,
    loaded = props.loaded,
    loading = props.loading,
    halfChecked = props.halfChecked,
    dragOver = props.dragOver,
    dragOverGapTop = props.dragOverGapTop,
    dragOverGapBottom = props.dragOverGapBottom,
    pos = props.pos,
    active = props.active,
    eventKey = props.eventKey;
  var eventData = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), {}, {
    expanded: expanded,
    selected: selected,
    checked: checked,
    loaded: loaded,
    loading: loading,
    halfChecked: halfChecked,
    dragOver: dragOver,
    dragOverGapTop: dragOverGapTop,
    dragOverGapBottom: dragOverGapBottom,
    pos: pos,
    active: active,
    key: eventKey
  });
  if (!('props' in eventData)) {
    Object.defineProperty(eventData, 'props', {
      get: function get() {
        (0,rc_util_es_warning__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(false, 'Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`.');
        return props;
      }
    });
  }
  return eventData;
}

/***/ }),

/***/ 3499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6223);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(79427);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(88569);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(34766);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js
var createSuper = __webpack_require__(56302);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 8 modules
var regeneratorRuntime = __webpack_require__(8662);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(2456);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/pickAttrs.js
var pickAttrs = __webpack_require__(75844);
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(13764);
;// CONCATENATED MODULE: ./node_modules/rc-upload/es/attr-accept.js

/* harmony default export */ var attr_accept = (function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = file.type || '';
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim();
      // This is something like */*,*  allow all files
      if (/^\*(\/\*)?$/.test(type)) {
        return true;
      }

      // like .jpg, .png
      if (validType.charAt(0) === '.') {
        var lowerFileName = fileName.toLowerCase();
        var lowerType = validType.toLowerCase();
        var affixList = [lowerType];
        if (lowerType === '.jpg' || lowerType === '.jpeg') {
          affixList = ['.jpg', '.jpeg'];
        }
        return affixList.some(function (affix) {
          return lowerFileName.endsWith(affix);
        });
      }

      // This is something like a image/* mime type
      if (/\/\*$/.test(validType)) {
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      // Full match
      if (mimeType === validType) {
        return true;
      }

      // Invalidate type should skip
      if (/^\w+$/.test(validType)) {
        (0,warning/* default */.ZP)(false, "Upload takes an invalidate 'accept' type '".concat(validType, "'.Skip for check."));
        return true;
      }
      return false;
    });
  }
  return true;
});
;// CONCATENATED MODULE: ./node_modules/rc-upload/es/request.js
function getError(option, xhr) {
  var msg = "cannot ".concat(option.method, " ").concat(option.action, " ").concat(xhr.status, "'");
  var err = new Error(msg);
  err.status = xhr.status;
  err.method = option.method;
  err.url = option.action;
  return err;
}
function getBody(xhr) {
  var text = xhr.responseText || xhr.response;
  if (!text) {
    return text;
  }
  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}
function upload(option) {
  // eslint-disable-next-line no-undef
  var xhr = new XMLHttpRequest();
  if (option.onProgress && xhr.upload) {
    xhr.upload.onprogress = function progress(e) {
      if (e.total > 0) {
        e.percent = e.loaded / e.total * 100;
      }
      option.onProgress(e);
    };
  }

  // eslint-disable-next-line no-undef
  var formData = new FormData();
  if (option.data) {
    Object.keys(option.data).forEach(function (key) {
      var value = option.data[key];
      // support key-value array data
      if (Array.isArray(value)) {
        value.forEach(function (item) {
          // { list: [ 11, 22 ] }
          // formData.append('list[]', 11);
          formData.append("".concat(key, "[]"), item);
        });
        return;
      }
      formData.append(key, value);
    });
  }

  // eslint-disable-next-line no-undef
  if (option.file instanceof Blob) {
    formData.append(option.filename, option.file, option.file.name);
  } else {
    formData.append(option.filename, option.file);
  }
  xhr.onerror = function error(e) {
    option.onError(e);
  };
  xhr.onload = function onload() {
    // allow success when 2xx status
    // see https://github.com/react-component/upload/issues/34
    if (xhr.status < 200 || xhr.status >= 300) {
      return option.onError(getError(option, xhr), getBody(xhr));
    }
    return option.onSuccess(getBody(xhr), xhr);
  };
  xhr.open(option.method, option.action, true);

  // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
  if (option.withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true;
  }
  var headers = option.headers || {};

  // when set headers['X-Requested-With'] = null , can close default XHR header
  // see https://github.com/react-component/upload/issues/33
  if (headers['X-Requested-With'] !== null) {
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  }
  Object.keys(headers).forEach(function (h) {
    if (headers[h] !== null) {
      xhr.setRequestHeader(h, headers[h]);
    }
  });
  xhr.send(formData);
  return {
    abort: function abort() {
      xhr.abort();
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/rc-upload/es/traverseFileTree.js



// https://github.com/ant-design/ant-design/issues/50080
var traverseFileTree = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee4(files, isAccepted) {
    var flattenFileList, progressFileList, readDirectory, _readDirectory, readFile, _readFile, _traverseFileTree, wipIndex;
    return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _readFile = function _readFile3() {
            _readFile = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3(item) {
              return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    return _context3.abrupt("return", new Promise(function (reslove) {
                      item.file(function (file) {
                        if (isAccepted(file)) {
                          // https://github.com/ant-design/ant-design/issues/16426
                          if (item.fullPath && !file.webkitRelativePath) {
                            Object.defineProperties(file, {
                              webkitRelativePath: {
                                writable: true
                              }
                            });
                            // eslint-disable-next-line no-param-reassign
                            file.webkitRelativePath = item.fullPath.replace(/^\//, '');
                            Object.defineProperties(file, {
                              webkitRelativePath: {
                                writable: false
                              }
                            });
                          }
                          reslove(file);
                        } else {
                          reslove(null);
                        }
                      });
                    }));
                  case 1:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
            return _readFile.apply(this, arguments);
          };
          readFile = function _readFile2(_x4) {
            return _readFile.apply(this, arguments);
          };
          _readDirectory = function _readDirectory3() {
            _readDirectory = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(directory) {
              var dirReader, entries, results, n, i;
              return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    dirReader = directory.createReader();
                    entries = [];
                  case 2:
                    if (false) {}
                    _context2.next = 5;
                    return new Promise(function (resolve) {
                      dirReader.readEntries(resolve, function () {
                        return resolve([]);
                      });
                    });
                  case 5:
                    results = _context2.sent;
                    n = results.length;
                    if (n) {
                      _context2.next = 9;
                      break;
                    }
                    return _context2.abrupt("break", 12);
                  case 9:
                    for (i = 0; i < n; i++) {
                      entries.push(results[i]);
                    }
                    _context2.next = 2;
                    break;
                  case 12:
                    return _context2.abrupt("return", entries);
                  case 13:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return _readDirectory.apply(this, arguments);
          };
          readDirectory = function _readDirectory2(_x3) {
            return _readDirectory.apply(this, arguments);
          };
          flattenFileList = [];
          progressFileList = [];
          files.forEach(function (file) {
            return progressFileList.push(file.webkitGetAsEntry());
          });

          // eslint-disable-next-line @typescript-eslint/naming-convention
          _traverseFileTree = /*#__PURE__*/function () {
            var _ref2 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(item, path) {
              var _file, entries;
              return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (item) {
                      _context.next = 2;
                      break;
                    }
                    return _context.abrupt("return");
                  case 2:
                    // eslint-disable-next-line no-param-reassign
                    item.path = path || '';
                    if (!item.isFile) {
                      _context.next = 10;
                      break;
                    }
                    _context.next = 6;
                    return readFile(item);
                  case 6:
                    _file = _context.sent;
                    if (_file) {
                      flattenFileList.push(_file);
                    }
                    _context.next = 15;
                    break;
                  case 10:
                    if (!item.isDirectory) {
                      _context.next = 15;
                      break;
                    }
                    _context.next = 13;
                    return readDirectory(item);
                  case 13:
                    entries = _context.sent;
                    progressFileList.push.apply(progressFileList, (0,toConsumableArray/* default */.Z)(entries));
                  case 15:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function _traverseFileTree(_x5, _x6) {
              return _ref2.apply(this, arguments);
            };
          }();
          wipIndex = 0;
        case 9:
          if (!(wipIndex < progressFileList.length)) {
            _context4.next = 15;
            break;
          }
          _context4.next = 12;
          return _traverseFileTree(progressFileList[wipIndex]);
        case 12:
          wipIndex++;
          _context4.next = 9;
          break;
        case 15:
          return _context4.abrupt("return", flattenFileList);
        case 16:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function traverseFileTree(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/* harmony default export */ var es_traverseFileTree = (traverseFileTree);
;// CONCATENATED MODULE: ./node_modules/rc-upload/es/uid.js
var now = +new Date();
var index = 0;
function uid() {
  // eslint-disable-next-line no-plusplus
  return "rc-upload-".concat(now, "-").concat(++index);
}
;// CONCATENATED MODULE: ./node_modules/rc-upload/es/AjaxUploader.js













var _excluded = ["component", "prefixCls", "className", "classNames", "disabled", "id", "name", "style", "styles", "multiple", "accept", "capture", "children", "directory", "openFileDialogOnClick", "onMouseEnter", "onMouseLeave", "hasControlInside"];
/* eslint react/no-is-mounted:0,react/sort-comp:0,react/prop-types:0 */







var AjaxUploader = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(AjaxUploader, _Component);
  var _super = (0,createSuper/* default */.Z)(AjaxUploader);
  function AjaxUploader() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, AjaxUploader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "state", {
      uid: uid()
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "reqs", {});
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "fileInput", void 0);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_isMounted", void 0);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onChange", function (e) {
      var _this$props = _this.props,
        accept = _this$props.accept,
        directory = _this$props.directory;
      var files = e.target.files;
      var acceptedFiles = (0,toConsumableArray/* default */.Z)(files).filter(function (file) {
        return !directory || attr_accept(file, accept);
      });
      _this.uploadFiles(acceptedFiles);
      _this.reset();
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onClick", function (event) {
      var el = _this.fileInput;
      if (!el) {
        return;
      }
      var target = event.target;
      var onClick = _this.props.onClick;
      if (target && target.tagName === 'BUTTON') {
        var parent = el.parentNode;
        parent.focus();
        target.blur();
      }
      el.click();
      if (onClick) {
        onClick(event);
      }
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onKeyDown", function (e) {
      if (e.key === 'Enter') {
        _this.onClick(e);
      }
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onDataTransferFiles", /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(dataTransfer, existFileCallback) {
        var _this$props2, multiple, accept, directory, items, files, acceptFiles;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, multiple = _this$props2.multiple, accept = _this$props2.accept, directory = _this$props2.directory;
              items = (0,toConsumableArray/* default */.Z)(dataTransfer.items || []);
              files = (0,toConsumableArray/* default */.Z)(dataTransfer.files || []);
              if (files.length > 0 || items.some(function (item) {
                return item.kind === 'file';
              })) {
                existFileCallback === null || existFileCallback === void 0 || existFileCallback();
              }
              if (!directory) {
                _context.next = 11;
                break;
              }
              _context.next = 7;
              return es_traverseFileTree(Array.prototype.slice.call(items), function (_file) {
                return attr_accept(_file, _this.props.accept);
              });
            case 7:
              files = _context.sent;
              _this.uploadFiles(files);
              _context.next = 14;
              break;
            case 11:
              acceptFiles = (0,toConsumableArray/* default */.Z)(files).filter(function (file) {
                return attr_accept(file, accept);
              });
              if (multiple === false) {
                acceptFiles = files.slice(0, 1);
              }
              _this.uploadFiles(acceptFiles);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onFilePaste", /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(e) {
        var pastable, clipboardData;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              pastable = _this.props.pastable;
              if (pastable) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              if (!(e.type === 'paste')) {
                _context2.next = 6;
                break;
              }
              clipboardData = e.clipboardData;
              return _context2.abrupt("return", _this.onDataTransferFiles(clipboardData, function () {
                e.preventDefault();
              }));
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onFileDragOver", function (e) {
      e.preventDefault();
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onFileDrop", /*#__PURE__*/function () {
      var _ref3 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3(e) {
        var dataTransfer;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              e.preventDefault();
              if (!(e.type === 'drop')) {
                _context3.next = 4;
                break;
              }
              dataTransfer = e.dataTransfer;
              return _context3.abrupt("return", _this.onDataTransferFiles(dataTransfer));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x4) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "uploadFiles", function (files) {
      var originFiles = (0,toConsumableArray/* default */.Z)(files);
      var postFiles = originFiles.map(function (file) {
        // eslint-disable-next-line no-param-reassign
        file.uid = uid();
        return _this.processFile(file, originFiles);
      });

      // Batch upload files
      Promise.all(postFiles).then(function (fileList) {
        var onBatchStart = _this.props.onBatchStart;
        onBatchStart === null || onBatchStart === void 0 || onBatchStart(fileList.map(function (_ref4) {
          var origin = _ref4.origin,
            parsedFile = _ref4.parsedFile;
          return {
            file: origin,
            parsedFile: parsedFile
          };
        }));
        fileList.filter(function (file) {
          return file.parsedFile !== null;
        }).forEach(function (file) {
          _this.post(file);
        });
      });
    });
    /**
     * Process file before upload. When all the file is ready, we start upload.
     */
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "processFile", /*#__PURE__*/function () {
      var _ref5 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee4(file, fileList) {
        var beforeUpload, transformedFile, action, mergedAction, data, mergedData, parsedData, parsedFile, mergedParsedFile;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              beforeUpload = _this.props.beforeUpload;
              transformedFile = file;
              if (!beforeUpload) {
                _context4.next = 14;
                break;
              }
              _context4.prev = 3;
              _context4.next = 6;
              return beforeUpload(file, fileList);
            case 6:
              transformedFile = _context4.sent;
              _context4.next = 12;
              break;
            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](3);
              // Rejection will also trade as false
              transformedFile = false;
            case 12:
              if (!(transformedFile === false)) {
                _context4.next = 14;
                break;
              }
              return _context4.abrupt("return", {
                origin: file,
                parsedFile: null,
                action: null,
                data: null
              });
            case 14:
              // Get latest action
              action = _this.props.action;
              if (!(typeof action === 'function')) {
                _context4.next = 21;
                break;
              }
              _context4.next = 18;
              return action(file);
            case 18:
              mergedAction = _context4.sent;
              _context4.next = 22;
              break;
            case 21:
              mergedAction = action;
            case 22:
              // Get latest data
              data = _this.props.data;
              if (!(typeof data === 'function')) {
                _context4.next = 29;
                break;
              }
              _context4.next = 26;
              return data(file);
            case 26:
              mergedData = _context4.sent;
              _context4.next = 30;
              break;
            case 29:
              mergedData = data;
            case 30:
              parsedData =
              // string type is from legacy `transformFile`.
              // Not sure if this will work since no related test case works with it
              ((0,esm_typeof/* default */.Z)(transformedFile) === 'object' || typeof transformedFile === 'string') && transformedFile ? transformedFile : file;
              if (parsedData instanceof File) {
                parsedFile = parsedData;
              } else {
                parsedFile = new File([parsedData], file.name, {
                  type: file.type
                });
              }
              mergedParsedFile = parsedFile;
              mergedParsedFile.uid = file.uid;
              return _context4.abrupt("return", {
                origin: file,
                data: mergedData,
                parsedFile: mergedParsedFile,
                action: mergedAction
              });
            case 35:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[3, 9]]);
      }));
      return function (_x5, _x6) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "saveFileInput", function (node) {
      _this.fileInput = node;
    });
    return _this;
  }
  (0,createClass/* default */.Z)(AjaxUploader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
      var pastable = this.props.pastable;
      if (pastable) {
        document.addEventListener('paste', this.onFilePaste);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      this.abort();
      document.removeEventListener('paste', this.onFilePaste);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var pastable = this.props.pastable;
      if (pastable && !prevProps.pastable) {
        document.addEventListener('paste', this.onFilePaste);
      } else if (!pastable && prevProps.pastable) {
        document.removeEventListener('paste', this.onFilePaste);
      }
    }
  }, {
    key: "post",
    value: function post(_ref6) {
      var _this2 = this;
      var data = _ref6.data,
        origin = _ref6.origin,
        action = _ref6.action,
        parsedFile = _ref6.parsedFile;
      if (!this._isMounted) {
        return;
      }
      var _this$props3 = this.props,
        onStart = _this$props3.onStart,
        customRequest = _this$props3.customRequest,
        name = _this$props3.name,
        headers = _this$props3.headers,
        withCredentials = _this$props3.withCredentials,
        method = _this$props3.method;
      var uid = origin.uid;
      var request = customRequest || upload;
      var requestOption = {
        action: action,
        filename: name,
        data: data,
        file: parsedFile,
        headers: headers,
        withCredentials: withCredentials,
        method: method || 'post',
        onProgress: function onProgress(e) {
          var onProgress = _this2.props.onProgress;
          onProgress === null || onProgress === void 0 || onProgress(e, parsedFile);
        },
        onSuccess: function onSuccess(ret, xhr) {
          var onSuccess = _this2.props.onSuccess;
          onSuccess === null || onSuccess === void 0 || onSuccess(ret, parsedFile, xhr);
          delete _this2.reqs[uid];
        },
        onError: function onError(err, ret) {
          var onError = _this2.props.onError;
          onError === null || onError === void 0 || onError(err, ret, parsedFile);
          delete _this2.reqs[uid];
        }
      };
      onStart(origin);
      this.reqs[uid] = request(requestOption);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.setState({
        uid: uid()
      });
    }
  }, {
    key: "abort",
    value: function abort(file) {
      var reqs = this.reqs;
      if (file) {
        var uid = file.uid ? file.uid : file;
        if (reqs[uid] && reqs[uid].abort) {
          reqs[uid].abort();
        }
        delete reqs[uid];
      } else {
        Object.keys(reqs).forEach(function (uid) {
          if (reqs[uid] && reqs[uid].abort) {
            reqs[uid].abort();
          }
          delete reqs[uid];
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        Tag = _this$props4.component,
        prefixCls = _this$props4.prefixCls,
        className = _this$props4.className,
        _this$props4$classNam = _this$props4.classNames,
        classNames = _this$props4$classNam === void 0 ? {} : _this$props4$classNam,
        disabled = _this$props4.disabled,
        id = _this$props4.id,
        name = _this$props4.name,
        style = _this$props4.style,
        _this$props4$styles = _this$props4.styles,
        styles = _this$props4$styles === void 0 ? {} : _this$props4$styles,
        multiple = _this$props4.multiple,
        accept = _this$props4.accept,
        capture = _this$props4.capture,
        children = _this$props4.children,
        directory = _this$props4.directory,
        openFileDialogOnClick = _this$props4.openFileDialogOnClick,
        onMouseEnter = _this$props4.onMouseEnter,
        onMouseLeave = _this$props4.onMouseLeave,
        hasControlInside = _this$props4.hasControlInside,
        otherProps = (0,objectWithoutProperties/* default */.Z)(_this$props4, _excluded);
      var cls = classnames_default()((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, prefixCls, true), "".concat(prefixCls, "-disabled"), disabled), className, className));
      // because input don't have directory/webkitdirectory type declaration
      var dirProps = directory ? {
        directory: 'directory',
        webkitdirectory: 'webkitdirectory'
      } : {};
      var events = disabled ? {} : {
        onClick: openFileDialogOnClick ? this.onClick : function () {},
        onKeyDown: openFileDialogOnClick ? this.onKeyDown : function () {},
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onDrop: this.onFileDrop,
        onDragOver: this.onFileDragOver,
        tabIndex: hasControlInside ? undefined : '0'
      };
      return /*#__PURE__*/react.createElement(Tag, (0,esm_extends/* default */.Z)({}, events, {
        className: cls,
        role: hasControlInside ? undefined : 'button',
        style: style
      }), /*#__PURE__*/react.createElement("input", (0,esm_extends/* default */.Z)({}, (0,pickAttrs/* default */.Z)(otherProps, {
        aria: true,
        data: true
      }), {
        id: id
        /**
         * https://github.com/ant-design/ant-design/issues/50643,
         * https://github.com/react-component/upload/pull/575#issuecomment-2320646552
         */,
        name: name,
        disabled: disabled,
        type: "file",
        ref: this.saveFileInput,
        onClick: function onClick(e) {
          return e.stopPropagation();
        } // https://github.com/ant-design/ant-design/issues/19948
        ,

        key: this.state.uid,
        style: (0,objectSpread2/* default */.Z)({
          display: 'none'
        }, styles.input),
        className: classNames.input,
        accept: accept
      }, dirProps, {
        multiple: multiple,
        onChange: this.onChange
      }, capture != null ? {
        capture: capture
      } : {})), children);
    }
  }]);
  return AjaxUploader;
}(react.Component);
/* harmony default export */ var es_AjaxUploader = (AjaxUploader);
;// CONCATENATED MODULE: ./node_modules/rc-upload/es/Upload.js







/* eslint react/prop-types:0 */


function empty() {}
var Upload = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(Upload, _Component);
  var _super = (0,createSuper/* default */.Z)(Upload);
  function Upload() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, Upload);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "uploader", void 0);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "saveUploader", function (node) {
      _this.uploader = node;
    });
    return _this;
  }
  (0,createClass/* default */.Z)(Upload, [{
    key: "abort",
    value: function abort(file) {
      this.uploader.abort(file);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/react.createElement(es_AjaxUploader, (0,esm_extends/* default */.Z)({}, this.props, {
        ref: this.saveUploader
      }));
    }
  }]);
  return Upload;
}(react.Component);
(0,defineProperty/* default */.Z)(Upload, "defaultProps", {
  component: 'span',
  prefixCls: 'rc-upload',
  data: {},
  headers: {},
  name: 'file',
  multipart: false,
  onStart: empty,
  onError: empty,
  onSuccess: empty,
  multiple: false,
  beforeUpload: null,
  customRequest: null,
  withCredentials: false,
  openFileDialogOnClick: true,
  hasControlInside: false
});
/* harmony default export */ var es_Upload = (Upload);
;// CONCATENATED MODULE: ./node_modules/rc-upload/es/index.js

/* harmony default export */ var es = (es_Upload);

/***/ }),

/***/ 93550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toArray; }
/* harmony export */ });
/* harmony import */ var _React_isFragment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29767);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);


function toArray(children) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ret = [];
  react__WEBPACK_IMPORTED_MODULE_1__.Children.forEach(children, function (child) {
    if ((child === undefined || child === null) && !option.keepEmpty) {
      return;
    }
    if (Array.isArray(child)) {
      ret = ret.concat(toArray(child));
    } else if ((0,_React_isFragment__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(child) && child.props) {
      ret = ret.concat(toArray(child.props.children, option));
    } else {
      ret.push(child);
    }
  });
  return ret;
}

/***/ }),

/***/ 35092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addEventListenerWrap; }
/* harmony export */ });
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85202);

function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = react_dom__WEBPACK_IMPORTED_MODULE_0__.unstable_batchedUpdates ? function run(e) {
    react_dom__WEBPACK_IMPORTED_MODULE_0__.unstable_batchedUpdates(cb, e);
  } : cb;
  if (target !== null && target !== void 0 && target.addEventListener) {
    target.addEventListener(eventType, callback, option);
  }
  return {
    remove: function remove() {
      if (target !== null && target !== void 0 && target.removeEventListener) {
        target.removeEventListener(eventType, callback, option);
      }
    }
  };
}

/***/ }),

/***/ 55304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ canUseDom; }
/* harmony export */ });
function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

/***/ }),

/***/ 79004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ contains; }
/* harmony export */ });
function contains(root, n) {
  if (!root) {
    return false;
  }

  // Use native if support
  if (root.contains) {
    return root.contains(n);
  }

  // `document.contains` not support with IE11
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}

/***/ }),

/***/ 6779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hq": function() { return /* binding */ updateCSS; },
/* harmony export */   "jL": function() { return /* binding */ removeCSS; }
/* harmony export */ });
/* unused harmony exports injectCSS, clearContainerCache */
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56717);
/* harmony import */ var _canUseDom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55304);
/* harmony import */ var _contains__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79004);



var APPEND_ORDER = 'data-rc-order';
var APPEND_PRIORITY = 'data-rc-priority';
var MARK_KEY = "rc-util-key";
var containerCache = new Map();
function getMark() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    mark = _ref.mark;
  if (mark) {
    return mark.startsWith('data-') ? mark : "data-".concat(mark);
  }
  return MARK_KEY;
}
function getContainer(option) {
  if (option.attachTo) {
    return option.attachTo;
  }
  var head = document.querySelector('head');
  return head || document.body;
}
function getOrder(prepend) {
  if (prepend === 'queue') {
    return 'prependQueue';
  }
  return prepend ? 'prepend' : 'append';
}

/**
 * Find style which inject by rc-util
 */
function findStyles(container) {
  return Array.from((containerCache.get(container) || container).children).filter(function (node) {
    return node.tagName === 'STYLE';
  });
}
function injectCSS(css) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!(0,_canUseDom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()) {
    return null;
  }
  var csp = option.csp,
    prepend = option.prepend,
    _option$priority = option.priority,
    priority = _option$priority === void 0 ? 0 : _option$priority;
  var mergedOrder = getOrder(prepend);
  var isPrependQueue = mergedOrder === 'prependQueue';
  var styleNode = document.createElement('style');
  styleNode.setAttribute(APPEND_ORDER, mergedOrder);
  if (isPrependQueue && priority) {
    styleNode.setAttribute(APPEND_PRIORITY, "".concat(priority));
  }
  if (csp !== null && csp !== void 0 && csp.nonce) {
    styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
  }
  styleNode.innerHTML = css;
  var container = getContainer(option);
  var firstChild = container.firstChild;
  if (prepend) {
    // If is queue `prepend`, it will prepend first style and then append rest style
    if (isPrependQueue) {
      var existStyle = (option.styles || findStyles(container)).filter(function (node) {
        // Ignore style which not injected by rc-util with prepend
        if (!['prepend', 'prependQueue'].includes(node.getAttribute(APPEND_ORDER))) {
          return false;
        }

        // Ignore style which priority less then new style
        var nodePriority = Number(node.getAttribute(APPEND_PRIORITY) || 0);
        return priority >= nodePriority;
      });
      if (existStyle.length) {
        container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
        return styleNode;
      }
    }

    // Use `insertBefore` as `prepend`
    container.insertBefore(styleNode, firstChild);
  } else {
    container.appendChild(styleNode);
  }
  return styleNode;
}
function findExistNode(key) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var container = getContainer(option);
  return (option.styles || findStyles(container)).find(function (node) {
    return node.getAttribute(getMark(option)) === key;
  });
}
function removeCSS(key) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var existNode = findExistNode(key, option);
  if (existNode) {
    var container = getContainer(option);
    container.removeChild(existNode);
  }
}

/**
 * qiankun will inject `appendChild` to insert into other
 */
function syncRealContainer(container, option) {
  var cachedRealContainer = containerCache.get(container);

  // Find real container when not cached or cached container removed
  if (!cachedRealContainer || !(0,_contains__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(document, cachedRealContainer)) {
    var placeholderStyle = injectCSS('', option);
    var parentNode = placeholderStyle.parentNode;
    containerCache.set(container, parentNode);
    container.removeChild(placeholderStyle);
  }
}

/**
 * manually clear container cache to avoid global cache in unit testes
 */
function clearContainerCache() {
  containerCache.clear();
}
function updateCSS(css, key) {
  var originOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var container = getContainer(originOption);
  var styles = findStyles(container);
  var option = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, originOption), {}, {
    styles: styles
  });

  // Sync real parent
  syncRealContainer(container, option);
  var existNode = findExistNode(key, option);
  if (existNode) {
    var _option$csp, _option$csp2;
    if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
      var _option$csp3;
      existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
    }
    if (existNode.innerHTML !== css) {
      existNode.innerHTML = css;
    }
    return existNode;
  }
  var newNode = injectCSS(css, option);
  newNode.setAttribute(getMark(option), key);
  return newNode;
}

/***/ }),

/***/ 33970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sh": function() { return /* binding */ isDOM; },
/* harmony export */   "ZP": function() { return /* binding */ findDOMNode; },
/* harmony export */   "bn": function() { return /* binding */ getDOM; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45827);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85202);



function isDOM(node) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Element
  // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
  return node instanceof HTMLElement || node instanceof SVGElement;
}

/**
 * Retrieves a DOM node via a ref, and does not invoke `findDOMNode`.
 */
function getDOM(node) {
  if (node && (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(node) === 'object' && isDOM(node.nativeElement)) {
    return node.nativeElement;
  }
  if (isDOM(node)) {
    return node;
  }
  return null;
}

/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */
function findDOMNode(node) {
  var domNode = getDOM(node);
  if (domNode) {
    return domNode;
  }
  if (node instanceof react__WEBPACK_IMPORTED_MODULE_0__.Component) {
    var _ReactDOM$findDOMNode;
    return (_ReactDOM$findDOMNode = react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call(react_dom__WEBPACK_IMPORTED_MODULE_1__, node);
  }
  return null;
}

/***/ }),

/***/ 29504:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = (function (element) {
  if (!element) {
    return false;
  }
  if (element instanceof Element) {
    if (element.offsetParent) {
      return true;
    }
    if (element.getBBox) {
      var _getBBox = element.getBBox(),
        width = _getBBox.width,
        height = _getBBox.height;
      if (width || height) {
        return true;
      }
    }
    if (element.getBoundingClientRect) {
      var _element$getBoundingC = element.getBoundingClientRect(),
        _width = _element$getBoundingC.width,
        _height = _element$getBoundingC.height;
      if (_width || _height) {
        return true;
      }
    }
  }
  return false;
});

/***/ }),

/***/ 96585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getShadowRoot; }
/* harmony export */ });
/* unused harmony export inShadow */
function getRoot(ele) {
  var _ele$getRootNode;
  return ele === null || ele === void 0 || (_ele$getRootNode = ele.getRootNode) === null || _ele$getRootNode === void 0 ? void 0 : _ele$getRootNode.call(ele);
}

/**
 * Check if is in shadowRoot
 */
function inShadow(ele) {
  return getRoot(ele) instanceof ShadowRoot;
}

/**
 * Return shadowRoot if possible
 */
function getShadowRoot(ele) {
  return inShadow(ele) ? getRoot(ele) : null;
}

/***/ }),

/***/ 40393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ isStyleSupport; }
/* harmony export */ });
/* harmony import */ var _canUseDom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55304);

var isStyleNameSupport = function isStyleNameSupport(styleName) {
  if ((0,_canUseDom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)() && window.document.documentElement) {
    var styleNameList = Array.isArray(styleName) ? styleName : [styleName];
    var documentElement = window.document.documentElement;
    return styleNameList.some(function (name) {
      return name in documentElement.style;
    });
  }
  return false;
};
var isStyleValueSupport = function isStyleValueSupport(styleName, value) {
  if (!isStyleNameSupport(styleName)) {
    return false;
  }
  var ele = document.createElement('div');
  var origin = ele.style[styleName];
  ele.style[styleName] = value;
  return ele.style[styleName] !== origin;
};
function isStyleSupport(styleName, styleValue) {
  if (!Array.isArray(styleName) && styleValue !== undefined) {
    return isStyleValueSupport(styleName, styleValue);
  }
  return isStyleNameSupport(styleName);
}

/***/ }),

/***/ 88035:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */

var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;
    if (e.altKey && !e.ctrlKey || e.metaKey ||
    // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    }

    // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.
    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;
      default:
        return true;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }
    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }
    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    }

    // Safari sends zero key code for non-latin characters.
    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }
    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;
      default:
        return false;
    }
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (KeyCode);

/***/ }),

/***/ 29767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isFragment; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45827);

var REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');

/**
 * Compatible with React 18 or 19 to check if node is a Fragment.
 */
function isFragment(object) {
  return (
    // Base object type
    object && (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(object) === 'object' && (
    // React Element type
    object.$$typeof === REACT_ELEMENT_TYPE_18 || object.$$typeof === REACT_ELEMENT_TYPE_19) &&
    // React Fragment type
    object.type === REACT_FRAGMENT_TYPE
  );
}

/***/ }),

/***/ 52010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react_dom__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ render; },
/* harmony export */   "v": function() { return /* binding */ unmount; }
/* harmony export */ });
/* unused harmony exports _r, _u */
/* harmony import */ var _babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8662);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2456);
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45827);
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56717);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85202);





// Let compiler not to search module usage
var fullClone = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, /*#__PURE__*/ (react_dom__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react_dom__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react_dom__WEBPACK_IMPORTED_MODULE_0__, 2))));
var version = fullClone.version,
  reactRender = fullClone.render,
  unmountComponentAtNode = fullClone.unmountComponentAtNode;
var createRoot;
try {
  var mainVersion = Number((version || '').split('.')[0]);
  if (mainVersion >= 18) {
    createRoot = fullClone.createRoot;
  }
} catch (e) {
  // Do nothing;
}
function toggleWarning(skip) {
  var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === 'object') {
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
  }
}
var MARK = '__rc_react_root__';

// ========================== Render ==========================

function modernRender(node, container) {
  toggleWarning(true);
  var root = container[MARK] || createRoot(container);
  toggleWarning(false);
  root.render(node);
  container[MARK] = root;
}
function legacyRender(node, container) {
  reactRender === null || reactRender === void 0 || reactRender(node, container);
}

/** @private Test usage. Not work in prod */
function _r(node, container) {
  if (false) {}
}
function render(node, container) {
  if (createRoot) {
    modernRender(node, container);
    return;
  }
  legacyRender(node, container);
}

// ========================= Unmount ==========================
function modernUnmount(_x) {
  return _modernUnmount.apply(this, arguments);
}
function _modernUnmount() {
  _modernUnmount = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(/*#__PURE__*/(0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().mark(function _callee(container) {
    return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", Promise.resolve().then(function () {
            var _container$MARK;
            (_container$MARK = container[MARK]) === null || _container$MARK === void 0 || _container$MARK.unmount();
            delete container[MARK];
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _modernUnmount.apply(this, arguments);
}
function legacyUnmount(container) {
  unmountComponentAtNode(container);
}

/** @private Test usage. Not work in prod */
function _u(container) {
  if (false) {}
}
function unmount(_x2) {
  return _unmount.apply(this, arguments);
}
function _unmount() {
  _unmount = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(/*#__PURE__*/(0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().mark(function _callee2(container) {
    return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(createRoot !== undefined)) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", modernUnmount(container));
        case 2:
          legacyUnmount(container);
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _unmount.apply(this, arguments);
}

/***/ }),

/***/ 59339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getScrollBarSize; },
/* harmony export */   "o": function() { return /* binding */ getTargetScrollBarSize; }
/* harmony export */ });
/* harmony import */ var _Dom_dynamicCSS__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6779);
/* eslint-disable no-param-reassign */

var cached;
function measureScrollbarSize(ele) {
  var randomId = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7));
  var measureEle = document.createElement('div');
  measureEle.id = randomId;

  // Create Style
  var measureStyle = measureEle.style;
  measureStyle.position = 'absolute';
  measureStyle.left = '0';
  measureStyle.top = '0';
  measureStyle.width = '100px';
  measureStyle.height = '100px';
  measureStyle.overflow = 'scroll';

  // Clone Style if needed
  var fallbackWidth;
  var fallbackHeight;
  if (ele) {
    var targetStyle = getComputedStyle(ele);
    measureStyle.scrollbarColor = targetStyle.scrollbarColor;
    measureStyle.scrollbarWidth = targetStyle.scrollbarWidth;

    // Set Webkit style
    var webkitScrollbarStyle = getComputedStyle(ele, '::-webkit-scrollbar');
    var width = parseInt(webkitScrollbarStyle.width, 10);
    var height = parseInt(webkitScrollbarStyle.height, 10);

    // Try wrap to handle CSP case
    try {
      var widthStyle = width ? "width: ".concat(webkitScrollbarStyle.width, ";") : '';
      var heightStyle = height ? "height: ".concat(webkitScrollbarStyle.height, ";") : '';
      (0,_Dom_dynamicCSS__WEBPACK_IMPORTED_MODULE_0__/* .updateCSS */ .hq)("\n#".concat(randomId, "::-webkit-scrollbar {\n").concat(widthStyle, "\n").concat(heightStyle, "\n}"), randomId);
    } catch (e) {
      // Can't wrap, just log error
      console.error(e);

      // Get from style directly
      fallbackWidth = width;
      fallbackHeight = height;
    }
  }
  document.body.appendChild(measureEle);

  // Measure. Get fallback style if provided
  var scrollWidth = ele && fallbackWidth && !isNaN(fallbackWidth) ? fallbackWidth : measureEle.offsetWidth - measureEle.clientWidth;
  var scrollHeight = ele && fallbackHeight && !isNaN(fallbackHeight) ? fallbackHeight : measureEle.offsetHeight - measureEle.clientHeight;

  // Clean up
  document.body.removeChild(measureEle);
  (0,_Dom_dynamicCSS__WEBPACK_IMPORTED_MODULE_0__/* .removeCSS */ .jL)(randomId);
  return {
    width: scrollWidth,
    height: scrollHeight
  };
}
function getScrollBarSize(fresh) {
  if (typeof document === 'undefined') {
    return 0;
  }
  if (fresh || cached === undefined) {
    cached = measureScrollbarSize();
  }
  return cached.width;
}
function getTargetScrollBarSize(target) {
  if (typeof document === 'undefined' || !target || !(target instanceof Element)) {
    return {
      width: 0,
      height: 0
    };
  }
  return measureScrollbarSize(target);
}

/***/ }),

/***/ 47789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useEvent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);

function useEvent(callback) {
  var fnRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  fnRef.current = callback;
  var memoFn = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    var _fnRef$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [fnRef].concat(args));
  }, []);
  return memoFn;
}

/***/ }),

/***/ 73208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* unused harmony export resetUuid */
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40656);
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);



function getUseId() {
  // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
  var fullClone = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2))));
  return fullClone.useId;
}
var uuid = 0;

/** @private Note only worked in develop env. Not work in production. */
function resetUuid() {
  if (false) {}
}
var useOriginId = getUseId();
/* harmony default export */ __webpack_exports__["Z"] = (useOriginId ?
// Use React `useId`
function useId(id) {
  var reactId = useOriginId();

  // Developer passed id is single source of truth
  if (id) {
    return id;
  }

  // Test env always return mock id
  if (false) {}
  return reactId;
} :
// Use compatible of `useId`
function useCompatId(id) {
  // Inner id for accessibility usage. Only work in client side
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState('ssr-id'),
    _React$useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_React$useState, 2),
    innerId = _React$useState2[0],
    setInnerId = _React$useState2[1];
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    var nextId = uuid;
    uuid += 1;
    setInnerId("rc_unique_".concat(nextId));
  }, []);

  // Developer passed id is single source of truth
  if (id) {
    return id;
  }

  // Test env always return mock id
  if (false) {}

  // Return react native id or inner id
  return innerId;
});

/***/ }),

/***/ 76963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useLayoutUpdateEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var _Dom_canUseDom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55304);



/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */
var useInternalLayoutEffect =  true && (0,_Dom_canUseDom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)() ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
var useLayoutEffect = function useLayoutEffect(callback, deps) {
  var firstMountRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(true);
  useInternalLayoutEffect(function () {
    return callback(firstMountRef.current);
  }, deps);

  // We tell react that first mount has passed
  useInternalLayoutEffect(function () {
    firstMountRef.current = false;
    return function () {
      firstMountRef.current = true;
    };
  }, []);
};
var useLayoutUpdateEffect = function useLayoutUpdateEffect(callback, deps) {
  useLayoutEffect(function (firstMount) {
    if (!firstMount) {
      return callback();
    }
  }, deps);
};
/* harmony default export */ __webpack_exports__["Z"] = (useLayoutEffect);

/***/ }),

/***/ 99834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMemo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);

function useMemo(getValue, condition, shouldUpdate) {
  var cacheRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef({});
  if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
    cacheRef.current.value = getValue();
    cacheRef.current.condition = condition;
  }
  return cacheRef.current.value;
}

/***/ }),

/***/ 78877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMergedState; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40656);
/* harmony import */ var _useEvent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47789);
/* harmony import */ var _useLayoutEffect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76963);
/* harmony import */ var _useState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63345);




/** We only think `undefined` is empty */
function hasValue(value) {
  return value !== undefined;
}

/**
 * Similar to `useState` but will use props value if provided.
 * Note that internal use rc-util `useState` hook.
 */
function useMergedState(defaultStateValue, option) {
  var _ref = option || {},
    defaultValue = _ref.defaultValue,
    value = _ref.value,
    onChange = _ref.onChange,
    postState = _ref.postState;

  // ======================= Init =======================
  var _useState = (0,_useState__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function () {
      if (hasValue(value)) {
        return value;
      } else if (hasValue(defaultValue)) {
        return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
      } else {
        return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
      }
    }),
    _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useState, 2),
    innerValue = _useState2[0],
    setInnerValue = _useState2[1];
  var mergedValue = value !== undefined ? value : innerValue;
  var postMergedValue = postState ? postState(mergedValue) : mergedValue;

  // ====================== Change ======================
  var onChangeFn = (0,_useEvent__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(onChange);
  var _useState3 = (0,_useState__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)([mergedValue]),
    _useState4 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useState3, 2),
    prevValue = _useState4[0],
    setPrevValue = _useState4[1];
  (0,_useLayoutEffect__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutUpdateEffect */ .o)(function () {
    var prev = prevValue[0];
    if (innerValue !== prev) {
      onChangeFn(innerValue, prev);
    }
  }, [prevValue]);

  // Sync value back to `undefined` when it from control to un-control
  (0,_useLayoutEffect__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutUpdateEffect */ .o)(function () {
    if (!hasValue(value)) {
      setInnerValue(value);
    }
  }, [value]);

  // ====================== Update ======================
  var triggerChange = (0,_useEvent__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function (updater, ignoreDestroy) {
    setInnerValue(updater, ignoreDestroy);
    setPrevValue([mergedValue], ignoreDestroy);
  });
  return [postMergedValue, triggerChange];
}

/***/ }),

/***/ 63345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSafeState; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40656);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);


/**
 * Same as React.useState but `setState` accept `ignoreDestroy` param to not to setState after destroyed.
 * We do not make this auto is to avoid real memory leak.
 * Developer should confirm it's safe to ignore themselves.
 */
function useSafeState(defaultValue) {
  var destroyRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(defaultValue),
    _React$useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    destroyRef.current = false;
    return function () {
      destroyRef.current = true;
    };
  }, []);
  function safeSetState(updater, ignoreDestroy) {
    if (ignoreDestroy && destroyRef.current) {
      return;
    }
    setValue(updater);
  }
  return [value, safeSetState];
}

/***/ }),

/***/ 57433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C8": function() { return /* reexport safe */ _hooks_useMergedState__WEBPACK_IMPORTED_MODULE_1__.Z; },
/* harmony export */   "U2": function() { return /* reexport safe */ _utils_get__WEBPACK_IMPORTED_MODULE_3__.Z; },
/* harmony export */   "t8": function() { return /* reexport safe */ _utils_set__WEBPACK_IMPORTED_MODULE_4__.Z; },
/* harmony export */   "zX": function() { return /* reexport safe */ _hooks_useEvent__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _hooks_useEvent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47789);
/* harmony import */ var _hooks_useMergedState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78877);
/* harmony import */ var _ref__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99195);
/* harmony import */ var _utils_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20713);
/* harmony import */ var _utils_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57935);
/* harmony import */ var _warning__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13764);







/***/ }),

/***/ 55159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45827);
/* harmony import */ var _warning__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13764);



/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */
function isEqual(obj1, obj2) {
  var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
  var refSet = new Set();
  function deepEqual(a, b) {
    var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var circular = refSet.has(a);
    (0,_warning__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(!circular, 'Warning: There may be circular references');
    if (circular) {
      return false;
    }
    if (a === b) {
      return true;
    }
    if (shallow && level > 1) {
      return false;
    }
    refSet.add(a);
    var newLevel = level + 1;
    if (Array.isArray(a)) {
      if (!Array.isArray(b) || a.length !== b.length) {
        return false;
      }
      for (var i = 0; i < a.length; i++) {
        if (!deepEqual(a[i], b[i], newLevel)) {
          return false;
        }
      }
      return true;
    }
    if (a && b && (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(a) === 'object' && (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(b) === 'object') {
      var keys = Object.keys(a);
      if (keys.length !== Object.keys(b).length) {
        return false;
      }
      return keys.every(function (key) {
        return deepEqual(a[key], b[key], newLevel);
      });
    }
    // other
    return false;
  }
  return deepEqual(obj1, obj2);
}
/* harmony default export */ __webpack_exports__["Z"] = (isEqual);

/***/ }),

/***/ 87122:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = (function () {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') {
    return false;
  }
  var agent = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
});

/***/ }),

/***/ 85401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ omit; }
/* harmony export */ });
function omit(obj, fields) {
  var clone = Object.assign({}, obj);
  if (Array.isArray(fields)) {
    fields.forEach(function (key) {
      delete clone[key];
    });
  }
  return clone;
}

/***/ }),

/***/ 75844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ pickAttrs; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56717);

var attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/);

/* eslint-enable max-len */
var ariaPrefix = 'aria-';
var dataPrefix = 'data-';
function match(key, prefix) {
  return key.indexOf(prefix) === 0;
}
/**
 * Picker props from exist props with filter
 * @param props Passed props
 * @param ariaOnly boolean | { aria?: boolean; data?: boolean; attr?: boolean; } filter config
 */
function pickAttrs(props) {
  var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var mergedConfig;
  if (ariaOnly === false) {
    mergedConfig = {
      aria: true,
      data: true,
      attr: true
    };
  } else if (ariaOnly === true) {
    mergedConfig = {
      aria: true
    };
  } else {
    mergedConfig = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, ariaOnly);
  }
  var attrs = {};
  Object.keys(props).forEach(function (key) {
    if (
    // Aria
    mergedConfig.aria && (key === 'role' || match(key, ariaPrefix)) ||
    // Data
    mergedConfig.data && match(key, dataPrefix) ||
    // Attr
    mergedConfig.attr && propList.includes(key)) {
      attrs[key] = props[key];
    }
  });
  return attrs;
}

/***/ }),

/***/ 13157:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var raf = function raf(callback) {
  return +setTimeout(callback, 16);
};
var caf = function caf(num) {
  return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
  raf = function raf(callback) {
    return window.requestAnimationFrame(callback);
  };
  caf = function caf(handle) {
    return window.cancelAnimationFrame(handle);
  };
}
var rafUUID = 0;
var rafIds = new Map();
function cleanup(id) {
  rafIds.delete(id);
}
var wrapperRaf = function wrapperRaf(callback) {
  var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  rafUUID += 1;
  var id = rafUUID;
  function callRef(leftTimes) {
    if (leftTimes === 0) {
      // Clean up
      cleanup(id);

      // Trigger
      callback();
    } else {
      // Next raf
      var realId = raf(function () {
        callRef(leftTimes - 1);
      });

      // Bind real raf id
      rafIds.set(id, realId);
    }
  }
  callRef(times);
  return id;
};
wrapperRaf.cancel = function (id) {
  var realId = rafIds.get(id);
  cleanup(id);
  return caf(realId);
};
if (false) {}
/* harmony default export */ __webpack_exports__["Z"] = (wrapperRaf);

/***/ }),

/***/ 99195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C4": function() { return /* binding */ getNodeRef; },
/* harmony export */   "Yr": function() { return /* binding */ supportRef; },
/* harmony export */   "mH": function() { return /* binding */ fillRef; },
/* harmony export */   "sQ": function() { return /* binding */ composeRef; },
/* harmony export */   "t4": function() { return /* binding */ supportNodeRef; },
/* harmony export */   "x1": function() { return /* binding */ useComposeRef; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45827);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27296);
/* harmony import */ var _hooks_useMemo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99834);
/* harmony import */ var _React_isFragment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29767);





var ReactMajorVersion = Number(react__WEBPACK_IMPORTED_MODULE_0__.version.split('.')[0]);
var fillRef = function fillRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ref) === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
};

/**
 * Merge refs into one ref function to support ref passing.
 */
var composeRef = function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  var refList = refs.filter(Boolean);
  if (refList.length <= 1) {
    return refList[0];
  }
  return function (node) {
    refs.forEach(function (ref) {
      fillRef(ref, node);
    });
  };
};
var useComposeRef = function useComposeRef() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }
  return (0,_hooks_useMemo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function () {
    return composeRef.apply(void 0, refs);
  }, refs, function (prev, next) {
    return prev.length !== next.length || prev.every(function (ref, i) {
      return ref !== next[i];
    });
  });
};
var supportRef = function supportRef(nodeOrComponent) {
  var _type$prototype, _nodeOrComponent$prot;
  if (!nodeOrComponent) {
    return false;
  }

  // React 19 no need `forwardRef` anymore. So just pass if is a React element.
  if (isReactElement(nodeOrComponent) && ReactMajorVersion >= 19) {
    return true;
  }
  var type = (0,react_is__WEBPACK_IMPORTED_MODULE_1__.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;

  // Function component node
  if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== react_is__WEBPACK_IMPORTED_MODULE_1__.ForwardRef) {
    return false;
  }

  // Class component
  if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== react_is__WEBPACK_IMPORTED_MODULE_1__.ForwardRef) {
    return false;
  }
  return true;
};
function isReactElement(node) {
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(node) && !(0,_React_isFragment__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(node);
}
var supportNodeRef = function supportNodeRef(node) {
  return isReactElement(node) && supportRef(node);
};

/**
 * In React 19. `ref` is not a property from node.
 * But a property from `props.ref`.
 * To check if `props.ref` exist or fallback to `ref`.
 */
var getNodeRef = function getNodeRef(node) {
  if (node && isReactElement(node)) {
    var ele = node;

    // Source from:
    // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
    return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
  }
  return null;
};

/***/ }),

/***/ 20713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ get; }
/* harmony export */ });
function get(entity, path) {
  var current = entity;
  for (var i = 0; i < path.length; i += 1) {
    if (current === null || current === undefined) {
      return undefined;
    }
    current = current[path[i]];
  }
  return current;
}

/***/ }),

/***/ 57935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ merge; },
/* harmony export */   "Z": function() { return /* binding */ set; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45827);
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56717);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83889);
/* harmony import */ var _babel_runtime_helpers_esm_toArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75574);
/* harmony import */ var _get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20713);





function internalSet(entity, paths, value, removeIfUndefined) {
  if (!paths.length) {
    return value;
  }
  var _paths = (0,_babel_runtime_helpers_esm_toArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(paths),
    path = _paths[0],
    restPath = _paths.slice(1);
  var clone;
  if (!entity && typeof path === 'number') {
    clone = [];
  } else if (Array.isArray(entity)) {
    clone = (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(entity);
  } else {
    clone = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, entity);
  }

  // Delete prop if `removeIfUndefined` and value is undefined
  if (removeIfUndefined && value === undefined && restPath.length === 1) {
    delete clone[path][restPath[0]];
  } else {
    clone[path] = internalSet(clone[path], restPath, value, removeIfUndefined);
  }
  return clone;
}
function set(entity, paths, value) {
  var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  // Do nothing if `removeIfUndefined` and parent object not exist
  if (paths.length && removeIfUndefined && value === undefined && !(0,_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(entity, paths.slice(0, -1))) {
    return entity;
  }
  return internalSet(entity, paths, value, removeIfUndefined);
}
function isObject(obj) {
  return (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function createEmpty(source) {
  return Array.isArray(source) ? [] : {};
}
var keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;

/**
 * Merge objects which will create
 */
function merge() {
  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }
  var clone = createEmpty(sources[0]);
  sources.forEach(function (src) {
    function internalMerge(path, parentLoopSet) {
      var loopSet = new Set(parentLoopSet);
      var value = (0,_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(src, path);
      var isArr = Array.isArray(value);
      if (isArr || isObject(value)) {
        // Only add not loop obj
        if (!loopSet.has(value)) {
          loopSet.add(value);
          var originValue = (0,_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(clone, path);
          if (isArr) {
            // Array will always be override
            clone = set(clone, path, []);
          } else if (!originValue || (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(originValue) !== 'object') {
            // Init container if not exist
            clone = set(clone, path, createEmpty(value));
          }
          keys(value).forEach(function (key) {
            internalMerge([].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(path), [key]), loopSet);
          });
        }
      } else {
        clone = set(clone, path, value);
      }
    }
    internalMerge([]);
  });
  return clone;
}

/***/ }),

/***/ 13764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kp": function() { return /* binding */ warning; }
/* harmony export */ });
/* unused harmony exports preMessage, note, resetWarned, call, warningOnce, noteOnce */
/* eslint-disable no-console */
var warned = {};
var preWarningFns = [];

/**
 * Pre warning enable you to parse content before console.error.
 * Modify to null will prevent warning.
 */
var preMessage = function preMessage(fn) {
  preWarningFns.push(fn);
};

/**
 * Warning if condition not match.
 * @param valid Condition
 * @param message Warning message
 * @example
 * ```js
 * warning(false, 'some error'); // print some error
 * warning(true, 'some error'); // print nothing
 * warning(1 === 2, 'some error'); // print some error
 * ```
 */
function warning(valid, message) {
  if (false) { var finalMessage; }
}

/** @see Similar to {@link warning} */
function note(valid, message) {
  if (false) { var finalMessage; }
}
function resetWarned() {
  warned = {};
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}

/** @see Same as {@link warning}, but only warn once for the same message */
function warningOnce(valid, message) {
  call(warning, valid, message);
}

/** @see Same as {@link warning}, but only warn once for the same message */
function noteOnce(valid, message) {
  call(note, valid, message);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;
/* harmony default export */ __webpack_exports__["ZP"] = (warningOnce);

/***/ }),

/***/ 27690:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var b = Symbol.for("react.element"),
  c = Symbol.for("react.portal"),
  d = Symbol.for("react.fragment"),
  e = Symbol.for("react.strict_mode"),
  f = Symbol.for("react.profiler"),
  g = Symbol.for("react.provider"),
  h = Symbol.for("react.context"),
  k = Symbol.for("react.server_context"),
  l = Symbol.for("react.forward_ref"),
  m = Symbol.for("react.suspense"),
  n = Symbol.for("react.suspense_list"),
  p = Symbol.for("react.memo"),
  q = Symbol.for("react.lazy"),
  t = Symbol.for("react.offscreen"),
  u;
u = Symbol.for("react.module.reference");
function v(a) {
  if ("object" === typeof a && null !== a) {
    var r = a.$$typeof;
    switch (r) {
      case b:
        switch (a = a.type, a) {
          case d:
          case f:
          case e:
          case m:
          case n:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case h:
              case l:
              case q:
              case p:
              case g:
                return a;
              default:
                return r;
            }
        }
      case c:
        return r;
    }
  }
}
__webpack_unused_export__ = h;
__webpack_unused_export__ = g;
__webpack_unused_export__ = b;
exports.ForwardRef = l;
__webpack_unused_export__ = d;
__webpack_unused_export__ = q;
__webpack_unused_export__ = p;
__webpack_unused_export__ = c;
__webpack_unused_export__ = f;
__webpack_unused_export__ = e;
__webpack_unused_export__ = m;
__webpack_unused_export__ = n;
__webpack_unused_export__ = function () {
  return !1;
};
__webpack_unused_export__ = function () {
  return !1;
};
__webpack_unused_export__ = function (a) {
  return v(a) === h;
};
__webpack_unused_export__ = function (a) {
  return v(a) === g;
};
__webpack_unused_export__ = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === b;
};
__webpack_unused_export__ = function (a) {
  return v(a) === l;
};
__webpack_unused_export__ = function (a) {
  return v(a) === d;
};
__webpack_unused_export__ = function (a) {
  return v(a) === q;
};
exports.isMemo = function (a) {
  return v(a) === p;
};
__webpack_unused_export__ = function (a) {
  return v(a) === c;
};
__webpack_unused_export__ = function (a) {
  return v(a) === f;
};
__webpack_unused_export__ = function (a) {
  return v(a) === e;
};
__webpack_unused_export__ = function (a) {
  return v(a) === m;
};
__webpack_unused_export__ = function (a) {
  return v(a) === n;
};
__webpack_unused_export__ = function (a) {
  return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t || "object" === typeof a && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? !0 : !1;
};
__webpack_unused_export__ = v;

/***/ }),

/***/ 27296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(27690);
} else {}

/***/ }),

/***/ 15371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ rc_virtual_list_es; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-resize-observer/es/index.js + 4 modules
var es = __webpack_require__(49938);
// EXTERNAL MODULE: ./node_modules/rc-util/es/index.js
var rc_util_es = __webpack_require__(57433);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useLayoutEffect.js
var useLayoutEffect = __webpack_require__(76963);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(85202);
;// CONCATENATED MODULE: ./node_modules/rc-virtual-list/es/Filler.js






/**
 * Fill component to provided the scroll content real height.
 */
var Filler = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var height = _ref.height,
    offsetY = _ref.offsetY,
    offsetX = _ref.offsetX,
    children = _ref.children,
    prefixCls = _ref.prefixCls,
    onInnerResize = _ref.onInnerResize,
    innerProps = _ref.innerProps,
    rtl = _ref.rtl,
    extra = _ref.extra;
  var outerStyle = {};
  var innerStyle = {
    display: 'flex',
    flexDirection: 'column'
  };
  if (offsetY !== undefined) {
    // Not set `width` since this will break `sticky: right`
    outerStyle = {
      height: height,
      position: 'relative',
      overflow: 'hidden'
    };
    innerStyle = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, innerStyle), {}, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({
      transform: "translateY(".concat(offsetY, "px)")
    }, rtl ? 'marginRight' : 'marginLeft', -offsetX), "position", 'absolute'), "left", 0), "right", 0), "top", 0));
  }
  return /*#__PURE__*/react.createElement("div", {
    style: outerStyle
  }, /*#__PURE__*/react.createElement(es/* default */.Z, {
    onResize: function onResize(_ref2) {
      var offsetHeight = _ref2.offsetHeight;
      if (offsetHeight && onInnerResize) {
        onInnerResize();
      }
    }
  }, /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    style: innerStyle,
    className: classnames_default()((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-holder-inner"), prefixCls)),
    ref: ref
  }, innerProps), children, extra)));
});
Filler.displayName = 'Filler';
/* harmony default export */ var es_Filler = (Filler);
;// CONCATENATED MODULE: ./node_modules/rc-virtual-list/es/Item.js

function Item(_ref) {
  var children = _ref.children,
    setRef = _ref.setRef;
  var refFunc = react.useCallback(function (node) {
    setRef(node);
  }, []);
  return /*#__PURE__*/react.cloneElement(children, {
    ref: refFunc
  });
}
;// CONCATENATED MODULE: ./node_modules/rc-virtual-list/es/hooks/useChildren.js


function useChildren(list, startIndex, endIndex, scrollWidth, offsetX, setNodeRef, renderFunc, _ref) {
  var getKey = _ref.getKey;
  return list.slice(startIndex, endIndex + 1).map(function (item, index) {
    var eleIndex = startIndex + index;
    var node = renderFunc(item, eleIndex, {
      style: {
        width: scrollWidth
      },
      offsetX: offsetX
    });
    var key = getKey(item);
    return /*#__PURE__*/react.createElement(Item, {
      key: key,
      setRef: function setRef(ele) {
        return setNodeRef(item, ele);
      }
    }, node);
  });
}
;// CONCATENATED MODULE: ./node_modules/rc-virtual-list/es/utils/algorithmUtil.js
/**
 * Get index with specific start index one by one. e.g.
 * min: 3, max: 9, start: 6
 *
 * Return index is:
 * [0]: 6
 * [1]: 7
 * [2]: 5
 * [3]: 8
 * [4]: 4
 * [5]: 9
 * [6]: 3
 */
function getIndexByStartLoc(min, max, start, index) {
  var beforeCount = start - min;
  var afterCount = max - start;
  var balanceCount = Math.min(beforeCount, afterCount) * 2;

  // Balance
  if (index <= balanceCount) {
    var stepIndex = Math.floor(index / 2);
    if (index % 2) {
      return start + stepIndex + 1;
    }
    return start - stepIndex;
  }

  // One is out of range
  if (beforeCount > afterCount) {
    return start - (index - afterCount);
  }
  return start + (index - beforeCount);
}

/**
 * We assume that 2 list has only 1 item diff and others keeping the order.
 * So we can use dichotomy algorithm to find changed one.
 */
function findListDiffIndex(originList, targetList, getKey) {
  var originLen = originList.length;
  var targetLen = targetList.length;
  var shortList;
  var longList;
  if (originLen === 0 && targetLen === 0) {
    return null;
  }
  if (originLen < targetLen) {
    shortList = originList;
    longList = targetList;
  } else {
    shortList = targetList;
    longList = originList;
  }
  var notExistKey = {
    __EMPTY_ITEM__: true
  };
  function getItemKey(item) {
    if (item !== undefined) {
      return getKey(item);
    }
    return notExistKey;
  }

  // Loop to find diff one
  var diffIndex = null;
  var multiple = Math.abs(originLen - targetLen) !== 1;
  for (var i = 0; i < longList.length; i += 1) {
    var shortKey = getItemKey(shortList[i]);
    var longKey = getItemKey(longList[i]);
    if (shortKey !== longKey) {
      diffIndex = i;
      multiple = multiple || shortKey !== getItemKey(longList[i + 1]);
      break;
    }
  }
  return diffIndex === null ? null : {
    index: diffIndex,
    multiple: multiple
  };
}
;// CONCATENATED MODULE: ./node_modules/rc-virtual-list/es/hooks/useDiffItem.js



function useDiffItem(data, getKey, onDiff) {
  var _React$useState = react.useState(data),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    prevData = _React$useState2[0],
    setPrevData = _React$useState2[1];
  var _React$useState3 = react.useState(null),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    diffItem = _React$useState4[0],
    setDiffItem = _React$useState4[1];
  react.useEffect(function () {
    var diff = findListDiffIndex(prevData || [], data || [], getKey);
    if ((diff === null || diff === void 0 ? void 0 : diff.index) !== undefined) {
      onDiff === null || onDiff === void 0 || onDiff(diff.index);
      setDiffItem(data[diff.index]);
    }
    setPrevData(data);
  }, [data]);
  return [diffItem];
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/raf.js
var raf = __webpack_require__(13157);
;// CONCATENATED MODULE: ./node_modules/rc-virtual-list/es/utils/isFirefox.js

var isFF = (typeof navigator === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(navigator)) === 'object' && /Firefox/i.test(navigator.userAgent);
/* harmony default export */ var isFirefox = (isFF);
;// CONCATENATED MODULE: ./node_modules/rc-virtual-list/es/hooks/useOriginScroll.js

/* harmony default export */ var useOriginScroll = (function (isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight) {
  // Do lock for a wheel when scrolling
  var lockRef = (0,react.useRef)(false);
  var lockTimeoutRef = (0,react.useRef)(null);
  function lockScroll() {
    clearTimeout(lockTimeoutRef.current);
    lockRef.current = true;
    lockTimeoutRef.current = setTimeout(function () {
      lockRef.current = false;
    }, 50);
  }

  // Pass to ref since global add is in closure
  var scrollPingRef = (0,react.useRef)({
    top: isScrollAtTop,
    bottom: isScrollAtBottom,
    left: isScrollAtLeft,
    right: isScrollAtRight
  });
  scrollPingRef.current.top = isScrollAtTop;
  scrollPingRef.current.bottom = isScrollAtBottom;
  scrollPingRef.current.left = isScrollAtLeft;
  scrollPingRef.current.right = isScrollAtRight;
  return function (isHorizontal, delta) {
    var smoothOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var originScroll = isHorizontal ?
    // Pass origin wheel when on the left
    delta < 0 && scrollPingRef.current.left ||
    // Pass origin wheel when on the right
    delta > 0 && scrollPingRef.current.right // Pass origin wheel when on the top
    : delta < 0 && scrollPingRef.current.top ||
    // Pass origin wheel when on the bottom
    delta > 0 && scrollPingRef.current.bottom;
    if (smoothOffset && originScroll) {
      // No need lock anymore when it's smooth offset from touchMove interval
      clearTimeout(lockTimeoutRef.current);
      lockRef.current = false;
    } else if (!originScroll || lockRef.current) {
      lockScroll();
    }
    return !lockRef.current && originScroll;
  };
});
;// CONCATENATED MODULE: ./node_modules/rc-virtual-list/es/hooks/useFrameWheel.js




function useFrameWheel(inVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, horizontalScroll,
/***
 * Return `true` when you need to prevent default event
 */
onWheelDelta) {
  var offsetRef = (0,react.useRef)(0);
  var nextFrameRef = (0,react.useRef)(null);

  // Firefox patch
  var wheelValueRef = (0,react.useRef)(null);
  var isMouseScrollRef = (0,react.useRef)(false);

  // Scroll status sync
  var originScroll = useOriginScroll(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
  function onWheelY(e, deltaY) {
    raf/* default.cancel */.Z.cancel(nextFrameRef.current);

    // Do nothing when scroll at the edge, Skip check when is in scroll
    if (originScroll(false, deltaY)) return;

    // Skip if nest List has handled this event
    var event = e;
    if (!event._virtualHandled) {
      event._virtualHandled = true;
    } else {
      return;
    }
    offsetRef.current += deltaY;
    wheelValueRef.current = deltaY;

    // Proxy of scroll events
    if (!isFirefox) {
      event.preventDefault();
    }
    nextFrameRef.current = (0,raf/* default */.Z)(function () {
      // Patch a multiple for Firefox to fix wheel number too small
      // ref: https://github.com/ant-design/ant-design/issues/26372#issuecomment-679460266
      var patchMultiple = isMouseScrollRef.current ? 10 : 1;
      onWheelDelta(offsetRef.current * patchMultiple, false);
      offsetRef.current = 0;
    });
  }
  function onWheelX(event, deltaX) {
    onWheelDelta(deltaX, true);
    if (!isFirefox) {
      event.preventDefault();
    }
  }

  // Check for which direction does wheel do. `sx` means `shift + wheel`
  var wheelDirectionRef = (0,react.useRef)(null);
  var wheelDirectionCleanRef = (0,react.useRef)(null);
  function onWheel(event) {
    if (!inVirtual) return;

    // Wait for 2 frame to clean direction
    raf/* default.cancel */.Z.cancel(wheelDirectionCleanRef.current);
    wheelDirectionCleanRef.current = (0,raf/* default */.Z)(function () {
      wheelDirectionRef.current = null;
    }, 2);
    var deltaX = event.deltaX,
      deltaY = event.deltaY,
      shiftKey = event.shiftKey;
    var mergedDeltaX = deltaX;
    var mergedDeltaY = deltaY;
    if (wheelDirectionRef.current === 'sx' || !wheelDirectionRef.current && (shiftKey || false) && deltaY && !deltaX) {
      mergedDeltaX = deltaY;
      mergedDeltaY = 0;
      wheelDirectionRef.current = 'sx';
    }
    var absX = Math.abs(mergedDeltaX);
    var absY = Math.abs(mergedDeltaY);
    if (wheelDirectionRef.current === null) {
      wheelDirectionRef.current = horizontalScroll && absX > absY ? 'x' : 'y';
    }
    if (wheelDirectionRef.current === 'y') {
      onWheelY(event, mergedDeltaY);
    } else {
      onWheelX(event, mergedDeltaX);
    }
  }

  // A patch for firefox
  function onFireFoxScroll(event) {
    if (!inVirtual) return;
    isMouseScrollRef.current = event.detail === wheelValueRef.current;
  }
  return [onWheel, onFireFoxScroll];
}
;// CONCATENATED MODULE: ./node_modules/rc-virtual-list/es/hooks/useGetSize.js



/**
 * Size info need loop query for the `heights` which will has the perf issue.
 * Let cache result for each render phase.
 */
function useGetSize(mergedData, getKey, heights, itemHeight) {
  var _React$useMemo = react.useMemo(function () {
      return [new Map(), []];
    }, [mergedData, heights.id, itemHeight]),
    _React$useMemo2 = (0,slicedToArray/* default */.Z)(_React$useMemo, 2),
    key2Index = _React$useMemo2[0],
    bottomList = _React$useMemo2[1];
  var getSize = function getSize(startKey) {
    var endKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : startKey;
    // Get from cache first
    var startIndex = key2Index.get(startKey);
    var endIndex = key2Index.get(endKey);

    // Loop to fill the cache
    if (startIndex === undefined || endIndex === undefined) {
      var dataLen = mergedData.length;
      for (var i = bottomList.length; i < dataLen; i += 1) {
        var _heights$get;
        var item = mergedData[i];
        var key = getKey(item);
        key2Index.set(key, i);
        var cacheHeight = (_heights$get = heights.get(key)) !== null && _heights$get !== void 0 ? _heights$get : itemHeight;
        bottomList[i] = (bottomList[i - 1] || 0) + cacheHeight;
        if (key === startKey) {
          startIndex = i;
        }
        if (key === endKey) {
          endIndex = i;
        }
        if (startIndex !== undefined && endIndex !== undefined) {
          break;
        }
      }
    }
    return {
      top: bottomList[startIndex - 1] || 0,
      bottom: bottomList[endIndex]
    };
  };
  return getSize;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6223);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(79427);
;// CONCATENATED MODULE: ./node_modules/rc-virtual-list/es/utils/CacheMap.js



// Firefox has low performance of map.
var CacheMap = /*#__PURE__*/function () {
  function CacheMap() {
    (0,classCallCheck/* default */.Z)(this, CacheMap);
    (0,defineProperty/* default */.Z)(this, "maps", void 0);
    // Used for cache key
    // `useMemo` no need to update if `id` not change
    (0,defineProperty/* default */.Z)(this, "id", 0);
    (0,defineProperty/* default */.Z)(this, "diffRecords", new Map());
    this.maps = Object.create(null);
  }
  (0,createClass/* default */.Z)(CacheMap, [{
    key: "set",
    value: function set(key, value) {
      // Record prev value
      this.diffRecords.set(key, this.maps[key]);
      this.maps[key] = value;
      this.id += 1;
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.maps[key];
    }

    /**
     * CacheMap will record the key changed.
     * To help to know what's update in the next render.
     */
  }, {
    key: "resetRecord",
    value: function resetRecord() {
      this.diffRecords.clear();
    }
  }, {
    key: "getRecord",
    value: function getRecord() {
      return this.diffRecords;
    }
  }]);
  return CacheMap;
}();
/* harmony default export */ var utils_CacheMap = (CacheMap);
;// CONCATENATED MODULE: ./node_modules/rc-virtual-list/es/hooks/useHeights.js




function parseNumber(value) {
  var num = parseFloat(value);
  return isNaN(num) ? 0 : num;
}
function useHeights(getKey, onItemAdd, onItemRemove) {
  var _React$useState = react.useState(0),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    updatedMark = _React$useState2[0],
    setUpdatedMark = _React$useState2[1];
  var instanceRef = (0,react.useRef)(new Map());
  var heightsRef = (0,react.useRef)(new utils_CacheMap());
  var promiseIdRef = (0,react.useRef)(0);
  function cancelRaf() {
    promiseIdRef.current += 1;
  }
  function collectHeight() {
    var sync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    cancelRaf();
    var doCollect = function doCollect() {
      var changed = false;
      instanceRef.current.forEach(function (element, key) {
        if (element && element.offsetParent) {
          var offsetHeight = element.offsetHeight;
          var _getComputedStyle = getComputedStyle(element),
            marginTop = _getComputedStyle.marginTop,
            marginBottom = _getComputedStyle.marginBottom;
          var marginTopNum = parseNumber(marginTop);
          var marginBottomNum = parseNumber(marginBottom);
          var totalHeight = offsetHeight + marginTopNum + marginBottomNum;
          if (heightsRef.current.get(key) !== totalHeight) {
            heightsRef.current.set(key, totalHeight);
            changed = true;
          }
        }
      });

      // Always trigger update mark to tell parent that should re-calculate heights when resized
      if (changed) {
        setUpdatedMark(function (c) {
          return c + 1;
        });
      }
    };
    if (sync) {
      doCollect();
    } else {
      promiseIdRef.current += 1;
      var id = promiseIdRef.current;
      Promise.resolve().then(function () {
        if (id === promiseIdRef.current) {
          doCollect();
        }
      });
    }
  }
  function setInstanceRef(item, instance) {
    var key = getKey(item);
    var origin = instanceRef.current.get(key);
    if (instance) {
      instanceRef.current.set(key, instance);
      collectHeight();
    } else {
      instanceRef.current.delete(key);
    }

    // Instance changed
    if (!origin !== !instance) {
      if (instance) {
        onItemAdd === null || onItemAdd === void 0 || onItemAdd(item);
      } else {
        onItemRemove === null || onItemRemove === void 0 || onItemRemove(item);
      }
    }
  }
  (0,react.useEffect)(function () {
    return cancelRaf;
  }, []);
  return [setInstanceRef, collectHeight, heightsRef.current, updatedMark];
}
;// CONCATENATED MODULE: ./node_modules/rc-virtual-list/es/hooks/useMobileTouchMove.js


var SMOOTH_PTG = 14 / 15;
function useMobileTouchMove(inVirtual, listRef, callback) {
  var touchedRef = (0,react.useRef)(false);
  var touchXRef = (0,react.useRef)(0);
  var touchYRef = (0,react.useRef)(0);
  var elementRef = (0,react.useRef)(null);

  // Smooth scroll
  var intervalRef = (0,react.useRef)(null);

  /* eslint-disable prefer-const */
  var cleanUpEvents;
  var onTouchMove = function onTouchMove(e) {
    if (touchedRef.current) {
      var currentX = Math.ceil(e.touches[0].pageX);
      var currentY = Math.ceil(e.touches[0].pageY);
      var offsetX = touchXRef.current - currentX;
      var offsetY = touchYRef.current - currentY;
      var _isHorizontal = Math.abs(offsetX) > Math.abs(offsetY);
      if (_isHorizontal) {
        touchXRef.current = currentX;
      } else {
        touchYRef.current = currentY;
      }
      var scrollHandled = callback(_isHorizontal, _isHorizontal ? offsetX : offsetY, false, e);
      if (scrollHandled) {
        e.preventDefault();
      }

      // Smooth interval
      clearInterval(intervalRef.current);
      if (scrollHandled) {
        intervalRef.current = setInterval(function () {
          if (_isHorizontal) {
            offsetX *= SMOOTH_PTG;
          } else {
            offsetY *= SMOOTH_PTG;
          }
          var offset = Math.floor(_isHorizontal ? offsetX : offsetY);
          if (!callback(_isHorizontal, offset, true) || Math.abs(offset) <= 0.1) {
            clearInterval(intervalRef.current);
          }
        }, 16);
      }
    }
  };
  var onTouchEnd = function onTouchEnd() {
    touchedRef.current = false;
    cleanUpEvents();
  };
  var onTouchStart = function onTouchStart(e) {
    cleanUpEvents();
    if (e.touches.length === 1 && !touchedRef.current) {
      touchedRef.current = true;
      touchXRef.current = Math.ceil(e.touches[0].pageX);
      touchYRef.current = Math.ceil(e.touches[0].pageY);
      elementRef.current = e.target;
      elementRef.current.addEventListener('touchmove', onTouchMove, {
        passive: false
      });
      elementRef.current.addEventListener('touchend', onTouchEnd, {
        passive: true
      });
    }
  };
  cleanUpEvents = function cleanUpEvents() {
    if (elementRef.current) {
      elementRef.current.removeEventListener('touchmove', onTouchMove);
      elementRef.current.removeEventListener('touchend', onTouchEnd);
    }
  };
  (0,useLayoutEffect/* default */.Z)(function () {
    if (inVirtual) {
      listRef.current.addEventListener('touchstart', onTouchStart, {
        passive: true
      });
    }
    return function () {
      var _listRef$current;
      (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.removeEventListener('touchstart', onTouchStart);
      cleanUpEvents();
      clearInterval(intervalRef.current);
    };
  }, [inVirtual]);
}
;// CONCATENATED MODULE: ./node_modules/rc-virtual-list/es/hooks/useScrollDrag.js


function smoothScrollOffset(offset) {
  return Math.floor(Math.pow(offset, 0.5));
}
function getPageXY(e, horizontal) {
  var obj = 'touches' in e ? e.touches[0] : e;
  return obj[horizontal ? 'pageX' : 'pageY'] - window[horizontal ? 'scrollX' : 'scrollY'];
}
function useScrollDrag(inVirtual, componentRef, onScrollOffset) {
  react.useEffect(function () {
    var ele = componentRef.current;
    if (inVirtual && ele) {
      var mouseDownLock = false;
      var rafId;
      var _offset;
      var stopScroll = function stopScroll() {
        raf/* default.cancel */.Z.cancel(rafId);
      };
      var continueScroll = function continueScroll() {
        stopScroll();
        rafId = (0,raf/* default */.Z)(function () {
          onScrollOffset(_offset);
          continueScroll();
        });
      };
      var onMouseDown = function onMouseDown(e) {
        // Skip if element set draggable
        if (e.target.draggable || e.button !== 0) {
          return;
        }
        // Skip if nest List has handled this event
        var event = e;
        if (!event._virtualHandled) {
          event._virtualHandled = true;
          mouseDownLock = true;
        }
      };
      var onMouseUp = function onMouseUp() {
        mouseDownLock = false;
        stopScroll();
      };
      var onMouseMove = function onMouseMove(e) {
        if (mouseDownLock) {
          var mouseY = getPageXY(e, false);
          var _ele$getBoundingClien = ele.getBoundingClientRect(),
            top = _ele$getBoundingClien.top,
            bottom = _ele$getBoundingClien.bottom;
          if (mouseY <= top) {
            var diff = top - mouseY;
            _offset = -smoothScrollOffset(diff);
            continueScroll();
          } else if (mouseY >= bottom) {
            var _diff = mouseY - bottom;
            _offset = smoothScrollOffset(_diff);
            continueScroll();
          } else {
            stopScroll();
          }
        }
      };
      ele.addEventListener('mousedown', onMouseDown);
      ele.ownerDocument.addEventListener('mouseup', onMouseUp);
      ele.ownerDocument.addEventListener('mousemove', onMouseMove);
      return function () {
        ele.removeEventListener('mousedown', onMouseDown);
        ele.ownerDocument.removeEventListener('mouseup', onMouseUp);
        ele.ownerDocument.removeEventListener('mousemove', onMouseMove);
        stopScroll();
      };
    }
  }, [inVirtual]);
}
;// CONCATENATED MODULE: ./node_modules/rc-virtual-list/es/hooks/useScrollTo.js



/* eslint-disable no-param-reassign */




var MAX_TIMES = 10;
function useScrollTo(containerRef, data, heights, itemHeight, getKey, collectHeight, syncScrollTop, triggerFlash) {
  var scrollRef = react.useRef();
  var _React$useState = react.useState(null),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    syncState = _React$useState2[0],
    setSyncState = _React$useState2[1];

  // ========================== Sync Scroll ==========================
  (0,useLayoutEffect/* default */.Z)(function () {
    if (syncState && syncState.times < MAX_TIMES) {
      // Never reach
      if (!containerRef.current) {
        setSyncState(function (ori) {
          return (0,objectSpread2/* default */.Z)({}, ori);
        });
        return;
      }
      collectHeight();
      var targetAlign = syncState.targetAlign,
        originAlign = syncState.originAlign,
        index = syncState.index,
        offset = syncState.offset;
      var height = containerRef.current.clientHeight;
      var needCollectHeight = false;
      var newTargetAlign = targetAlign;
      var targetTop = null;

      // Go to next frame if height not exist
      if (height) {
        var mergedAlign = targetAlign || originAlign;

        // Get top & bottom
        var stackTop = 0;
        var itemTop = 0;
        var itemBottom = 0;
        var maxLen = Math.min(data.length - 1, index);
        for (var i = 0; i <= maxLen; i += 1) {
          var key = getKey(data[i]);
          itemTop = stackTop;
          var cacheHeight = heights.get(key);
          itemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
          stackTop = itemBottom;
        }

        // Check if need sync height (visible range has item not record height)
        var leftHeight = mergedAlign === 'top' ? offset : height - offset;
        for (var _i = maxLen; _i >= 0; _i -= 1) {
          var _key = getKey(data[_i]);
          var _cacheHeight = heights.get(_key);
          if (_cacheHeight === undefined) {
            needCollectHeight = true;
            break;
          }
          leftHeight -= _cacheHeight;
          if (leftHeight <= 0) {
            break;
          }
        }

        // Scroll to
        switch (mergedAlign) {
          case 'top':
            targetTop = itemTop - offset;
            break;
          case 'bottom':
            targetTop = itemBottom - height + offset;
            break;
          default:
            {
              var scrollTop = containerRef.current.scrollTop;
              var scrollBottom = scrollTop + height;
              if (itemTop < scrollTop) {
                newTargetAlign = 'top';
              } else if (itemBottom > scrollBottom) {
                newTargetAlign = 'bottom';
              }
            }
        }
        if (targetTop !== null) {
          syncScrollTop(targetTop);
        }

        // One more time for sync
        if (targetTop !== syncState.lastTop) {
          needCollectHeight = true;
        }
      }

      // Trigger next effect
      if (needCollectHeight) {
        setSyncState((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, syncState), {}, {
          times: syncState.times + 1,
          targetAlign: newTargetAlign,
          lastTop: targetTop
        }));
      }
    } else if (false) {}
  }, [syncState, containerRef.current]);

  // =========================== Scroll To ===========================
  return function (arg) {
    // When not argument provided, we think dev may want to show the scrollbar
    if (arg === null || arg === undefined) {
      triggerFlash();
      return;
    }

    // Normal scroll logic
    raf/* default.cancel */.Z.cancel(scrollRef.current);
    if (typeof arg === 'number') {
      syncScrollTop(arg);
    } else if (arg && (0,esm_typeof/* default */.Z)(arg) === 'object') {
      var index;
      var align = arg.align;
      if ('index' in arg) {
        index = arg.index;
      } else {
        index = data.findIndex(function (item) {
          return getKey(item) === arg.key;
        });
      }
      var _arg$offset = arg.offset,
        offset = _arg$offset === void 0 ? 0 : _arg$offset;
      setSyncState({
        times: 0,
        index: index,
        offset: offset,
        originAlign: align
      });
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/rc-virtual-list/es/ScrollBar.js







var ScrollBar = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    rtl = props.rtl,
    scrollOffset = props.scrollOffset,
    scrollRange = props.scrollRange,
    onStartMove = props.onStartMove,
    onStopMove = props.onStopMove,
    onScroll = props.onScroll,
    horizontal = props.horizontal,
    spinSize = props.spinSize,
    containerSize = props.containerSize,
    style = props.style,
    propsThumbStyle = props.thumbStyle,
    showScrollBar = props.showScrollBar;
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    dragging = _React$useState2[0],
    setDragging = _React$useState2[1];
  var _React$useState3 = react.useState(null),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    pageXY = _React$useState4[0],
    setPageXY = _React$useState4[1];
  var _React$useState5 = react.useState(null),
    _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
    startTop = _React$useState6[0],
    setStartTop = _React$useState6[1];
  var isLTR = !rtl;

  // ========================= Refs =========================
  var scrollbarRef = react.useRef();
  var thumbRef = react.useRef();

  // ======================= Visible ========================
  var _React$useState7 = react.useState(showScrollBar),
    _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
    visible = _React$useState8[0],
    setVisible = _React$useState8[1];
  var visibleTimeoutRef = react.useRef();
  var delayHidden = function delayHidden() {
    if (showScrollBar === true || showScrollBar === false) return;
    clearTimeout(visibleTimeoutRef.current);
    setVisible(true);
    visibleTimeoutRef.current = setTimeout(function () {
      setVisible(false);
    }, 3000);
  };

  // ======================== Range =========================
  var enableScrollRange = scrollRange - containerSize || 0;
  var enableOffsetRange = containerSize - spinSize || 0;

  // ========================= Top ==========================
  var top = react.useMemo(function () {
    if (scrollOffset === 0 || enableScrollRange === 0) {
      return 0;
    }
    var ptg = scrollOffset / enableScrollRange;
    return ptg * enableOffsetRange;
  }, [scrollOffset, enableScrollRange, enableOffsetRange]);

  // ====================== Container =======================
  var onContainerMouseDown = function onContainerMouseDown(e) {
    e.stopPropagation();
    e.preventDefault();
  };

  // ======================== Thumb =========================
  var stateRef = react.useRef({
    top: top,
    dragging: dragging,
    pageY: pageXY,
    startTop: startTop
  });
  stateRef.current = {
    top: top,
    dragging: dragging,
    pageY: pageXY,
    startTop: startTop
  };
  var onThumbMouseDown = function onThumbMouseDown(e) {
    setDragging(true);
    setPageXY(getPageXY(e, horizontal));
    setStartTop(stateRef.current.top);
    onStartMove();
    e.stopPropagation();
    e.preventDefault();
  };

  // ======================== Effect ========================

  // React make event as passive, but we need to preventDefault
  // Add event on dom directly instead.
  // ref: https://github.com/facebook/react/issues/9809
  react.useEffect(function () {
    var onScrollbarTouchStart = function onScrollbarTouchStart(e) {
      e.preventDefault();
    };
    var scrollbarEle = scrollbarRef.current;
    var thumbEle = thumbRef.current;
    scrollbarEle.addEventListener('touchstart', onScrollbarTouchStart, {
      passive: false
    });
    thumbEle.addEventListener('touchstart', onThumbMouseDown, {
      passive: false
    });
    return function () {
      scrollbarEle.removeEventListener('touchstart', onScrollbarTouchStart);
      thumbEle.removeEventListener('touchstart', onThumbMouseDown);
    };
  }, []);

  // Pass to effect
  var enableScrollRangeRef = react.useRef();
  enableScrollRangeRef.current = enableScrollRange;
  var enableOffsetRangeRef = react.useRef();
  enableOffsetRangeRef.current = enableOffsetRange;
  react.useEffect(function () {
    if (dragging) {
      var moveRafId;
      var onMouseMove = function onMouseMove(e) {
        var _stateRef$current = stateRef.current,
          stateDragging = _stateRef$current.dragging,
          statePageY = _stateRef$current.pageY,
          stateStartTop = _stateRef$current.startTop;
        raf/* default.cancel */.Z.cancel(moveRafId);
        var rect = scrollbarRef.current.getBoundingClientRect();
        var scale = containerSize / (horizontal ? rect.width : rect.height);
        if (stateDragging) {
          var offset = (getPageXY(e, horizontal) - statePageY) * scale;
          var newTop = stateStartTop;
          if (!isLTR && horizontal) {
            newTop -= offset;
          } else {
            newTop += offset;
          }
          var tmpEnableScrollRange = enableScrollRangeRef.current;
          var tmpEnableOffsetRange = enableOffsetRangeRef.current;
          var ptg = tmpEnableOffsetRange ? newTop / tmpEnableOffsetRange : 0;
          var newScrollTop = Math.ceil(ptg * tmpEnableScrollRange);
          newScrollTop = Math.max(newScrollTop, 0);
          newScrollTop = Math.min(newScrollTop, tmpEnableScrollRange);
          moveRafId = (0,raf/* default */.Z)(function () {
            onScroll(newScrollTop, horizontal);
          });
        }
      };
      var onMouseUp = function onMouseUp() {
        setDragging(false);
        onStopMove();
      };
      window.addEventListener('mousemove', onMouseMove, {
        passive: true
      });
      window.addEventListener('touchmove', onMouseMove, {
        passive: true
      });
      window.addEventListener('mouseup', onMouseUp, {
        passive: true
      });
      window.addEventListener('touchend', onMouseUp, {
        passive: true
      });
      return function () {
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('touchmove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
        window.removeEventListener('touchend', onMouseUp);
        raf/* default.cancel */.Z.cancel(moveRafId);
      };
    }
  }, [dragging]);
  react.useEffect(function () {
    delayHidden();
    return function () {
      clearTimeout(visibleTimeoutRef.current);
    };
  }, [scrollOffset]);

  // ====================== Imperative ======================
  react.useImperativeHandle(ref, function () {
    return {
      delayHidden: delayHidden
    };
  });

  // ======================== Render ========================
  var scrollbarPrefixCls = "".concat(prefixCls, "-scrollbar");
  var containerStyle = {
    position: 'absolute',
    visibility: visible ? null : 'hidden'
  };
  var thumbStyle = {
    position: 'absolute',
    borderRadius: 99,
    background: 'var(--rc-virtual-list-scrollbar-bg, rgba(0, 0, 0, 0.5))',
    cursor: 'pointer',
    userSelect: 'none'
  };
  if (horizontal) {
    Object.assign(containerStyle, {
      height: 8,
      left: 0,
      right: 0,
      bottom: 0
    });
    Object.assign(thumbStyle, (0,defineProperty/* default */.Z)({
      height: '100%',
      width: spinSize
    }, isLTR ? 'left' : 'right', top));
  } else {
    Object.assign(containerStyle, (0,defineProperty/* default */.Z)({
      width: 8,
      top: 0,
      bottom: 0
    }, isLTR ? 'right' : 'left', 0));
    Object.assign(thumbStyle, {
      width: '100%',
      height: spinSize,
      top: top
    });
  }
  return /*#__PURE__*/react.createElement("div", {
    ref: scrollbarRef,
    className: classnames_default()(scrollbarPrefixCls, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(scrollbarPrefixCls, "-horizontal"), horizontal), "".concat(scrollbarPrefixCls, "-vertical"), !horizontal), "".concat(scrollbarPrefixCls, "-visible"), visible)),
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, containerStyle), style),
    onMouseDown: onContainerMouseDown,
    onMouseMove: delayHidden
  }, /*#__PURE__*/react.createElement("div", {
    ref: thumbRef,
    className: classnames_default()("".concat(scrollbarPrefixCls, "-thumb"), (0,defineProperty/* default */.Z)({}, "".concat(scrollbarPrefixCls, "-thumb-moving"), dragging)),
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, thumbStyle), propsThumbStyle),
    onMouseDown: onThumbMouseDown
  }));
});
if (false) {}
/* harmony default export */ var es_ScrollBar = (ScrollBar);
;// CONCATENATED MODULE: ./node_modules/rc-virtual-list/es/utils/scrollbarUtil.js
var MIN_SIZE = 20;
function getSpinSize() {
  var containerSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var scrollRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var baseSize = containerSize / scrollRange * containerSize;
  if (isNaN(baseSize)) {
    baseSize = 0;
  }
  baseSize = Math.max(baseSize, MIN_SIZE);
  return Math.floor(baseSize);
}
;// CONCATENATED MODULE: ./node_modules/rc-virtual-list/es/List.js






var _excluded = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles", "showScrollBar"];



















var EMPTY_DATA = [];
var ScrollStyle = {
  overflowY: 'auto',
  overflowAnchor: 'none'
};
function RawList(props, ref) {
  var _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-virtual-list' : _props$prefixCls,
    className = props.className,
    height = props.height,
    itemHeight = props.itemHeight,
    _props$fullHeight = props.fullHeight,
    fullHeight = _props$fullHeight === void 0 ? true : _props$fullHeight,
    style = props.style,
    data = props.data,
    children = props.children,
    itemKey = props.itemKey,
    virtual = props.virtual,
    direction = props.direction,
    scrollWidth = props.scrollWidth,
    _props$component = props.component,
    Component = _props$component === void 0 ? 'div' : _props$component,
    onScroll = props.onScroll,
    onVirtualScroll = props.onVirtualScroll,
    onVisibleChange = props.onVisibleChange,
    innerProps = props.innerProps,
    extraRender = props.extraRender,
    styles = props.styles,
    _props$showScrollBar = props.showScrollBar,
    showScrollBar = _props$showScrollBar === void 0 ? 'optional' : _props$showScrollBar,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  // =============================== Item Key ===============================
  var getKey = react.useCallback(function (item) {
    if (typeof itemKey === 'function') {
      return itemKey(item);
    }
    return item === null || item === void 0 ? void 0 : item[itemKey];
  }, [itemKey]);

  // ================================ Height ================================
  var _useHeights = useHeights(getKey, null, null),
    _useHeights2 = (0,slicedToArray/* default */.Z)(_useHeights, 4),
    setInstanceRef = _useHeights2[0],
    collectHeight = _useHeights2[1],
    heights = _useHeights2[2],
    heightUpdatedMark = _useHeights2[3];

  // ================================= MISC =================================
  var useVirtual = !!(virtual !== false && height && itemHeight);
  var containerHeight = react.useMemo(function () {
    return Object.values(heights.maps).reduce(function (total, curr) {
      return total + curr;
    }, 0);
  }, [heights.id, heights.maps]);
  var inVirtual = useVirtual && data && (Math.max(itemHeight * data.length, containerHeight) > height || !!scrollWidth);
  var isRTL = direction === 'rtl';
  var mergedClassName = classnames_default()(prefixCls, (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-rtl"), isRTL), className);
  var mergedData = data || EMPTY_DATA;
  var componentRef = (0,react.useRef)();
  var fillerInnerRef = (0,react.useRef)();
  var containerRef = (0,react.useRef)();

  // =============================== Item Key ===============================

  var _useState = (0,react.useState)(0),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    offsetTop = _useState2[0],
    setOffsetTop = _useState2[1];
  var _useState3 = (0,react.useState)(0),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    offsetLeft = _useState4[0],
    setOffsetLeft = _useState4[1];
  var _useState5 = (0,react.useState)(false),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    scrollMoving = _useState6[0],
    setScrollMoving = _useState6[1];
  var onScrollbarStartMove = function onScrollbarStartMove() {
    setScrollMoving(true);
  };
  var onScrollbarStopMove = function onScrollbarStopMove() {
    setScrollMoving(false);
  };
  var sharedConfig = {
    getKey: getKey
  };

  // ================================ Scroll ================================
  function syncScrollTop(newTop) {
    setOffsetTop(function (origin) {
      var value;
      if (typeof newTop === 'function') {
        value = newTop(origin);
      } else {
        value = newTop;
      }
      var alignedTop = keepInRange(value);
      componentRef.current.scrollTop = alignedTop;
      return alignedTop;
    });
  }

  // ================================ Legacy ================================
  // Put ref here since the range is generate by follow
  var rangeRef = (0,react.useRef)({
    start: 0,
    end: mergedData.length
  });
  var diffItemRef = (0,react.useRef)();
  var _useDiffItem = useDiffItem(mergedData, getKey),
    _useDiffItem2 = (0,slicedToArray/* default */.Z)(_useDiffItem, 1),
    diffItem = _useDiffItem2[0];
  diffItemRef.current = diffItem;

  // ========================== Visible Calculation =========================
  var _React$useMemo = react.useMemo(function () {
      if (!useVirtual) {
        return {
          scrollHeight: undefined,
          start: 0,
          end: mergedData.length - 1,
          offset: undefined
        };
      }

      // Always use virtual scroll bar in avoid shaking
      if (!inVirtual) {
        var _fillerInnerRef$curre;
        return {
          scrollHeight: ((_fillerInnerRef$curre = fillerInnerRef.current) === null || _fillerInnerRef$curre === void 0 ? void 0 : _fillerInnerRef$curre.offsetHeight) || 0,
          start: 0,
          end: mergedData.length - 1,
          offset: undefined
        };
      }
      var itemTop = 0;
      var startIndex;
      var startOffset;
      var endIndex;
      var dataLen = mergedData.length;
      for (var i = 0; i < dataLen; i += 1) {
        var _item = mergedData[i];
        var key = getKey(_item);
        var cacheHeight = heights.get(key);
        var currentItemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);

        // Check item top in the range
        if (currentItemBottom >= offsetTop && startIndex === undefined) {
          startIndex = i;
          startOffset = itemTop;
        }

        // Check item bottom in the range. We will render additional one item for motion usage
        if (currentItemBottom > offsetTop + height && endIndex === undefined) {
          endIndex = i;
        }
        itemTop = currentItemBottom;
      }

      // When scrollTop at the end but data cut to small count will reach this
      if (startIndex === undefined) {
        startIndex = 0;
        startOffset = 0;
        endIndex = Math.ceil(height / itemHeight);
      }
      if (endIndex === undefined) {
        endIndex = mergedData.length - 1;
      }

      // Give cache to improve scroll experience
      endIndex = Math.min(endIndex + 1, mergedData.length - 1);
      return {
        scrollHeight: itemTop,
        start: startIndex,
        end: endIndex,
        offset: startOffset
      };
    }, [inVirtual, useVirtual, offsetTop, mergedData, heightUpdatedMark, height]),
    scrollHeight = _React$useMemo.scrollHeight,
    start = _React$useMemo.start,
    end = _React$useMemo.end,
    fillerOffset = _React$useMemo.offset;
  rangeRef.current.start = start;
  rangeRef.current.end = end;

  // When scroll up, first visible item get real height may not same as `itemHeight`,
  // Which will make scroll jump.
  // Let's sync scroll top to avoid jump
  react.useLayoutEffect(function () {
    var changedRecord = heights.getRecord();
    if (changedRecord.size === 1) {
      var recordKey = Array.from(changedRecord.keys())[0];
      var prevCacheHeight = changedRecord.get(recordKey);

      // Quick switch data may cause `start` not in `mergedData` anymore
      var startItem = mergedData[start];
      if (startItem && prevCacheHeight === undefined) {
        var startIndexKey = getKey(startItem);
        if (startIndexKey === recordKey) {
          var realStartHeight = heights.get(recordKey);
          var diffHeight = realStartHeight - itemHeight;
          syncScrollTop(function (ori) {
            return ori + diffHeight;
          });
        }
      }
    }
    heights.resetRecord();
  }, [scrollHeight]);

  // ================================= Size =================================
  var _React$useState = react.useState({
      width: 0,
      height: height
    }),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    size = _React$useState2[0],
    setSize = _React$useState2[1];
  var onHolderResize = function onHolderResize(sizeInfo) {
    setSize({
      width: sizeInfo.offsetWidth,
      height: sizeInfo.offsetHeight
    });
  };

  // Hack on scrollbar to enable flash call
  var verticalScrollBarRef = (0,react.useRef)();
  var horizontalScrollBarRef = (0,react.useRef)();
  var horizontalScrollBarSpinSize = react.useMemo(function () {
    return getSpinSize(size.width, scrollWidth);
  }, [size.width, scrollWidth]);
  var verticalScrollBarSpinSize = react.useMemo(function () {
    return getSpinSize(size.height, scrollHeight);
  }, [size.height, scrollHeight]);

  // =============================== In Range ===============================
  var maxScrollHeight = scrollHeight - height;
  var maxScrollHeightRef = (0,react.useRef)(maxScrollHeight);
  maxScrollHeightRef.current = maxScrollHeight;
  function keepInRange(newScrollTop) {
    var newTop = newScrollTop;
    if (!Number.isNaN(maxScrollHeightRef.current)) {
      newTop = Math.min(newTop, maxScrollHeightRef.current);
    }
    newTop = Math.max(newTop, 0);
    return newTop;
  }
  var isScrollAtTop = offsetTop <= 0;
  var isScrollAtBottom = offsetTop >= maxScrollHeight;
  var isScrollAtLeft = offsetLeft <= 0;
  var isScrollAtRight = offsetLeft >= scrollWidth;
  var originScroll = useOriginScroll(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);

  // ================================ Scroll ================================
  var getVirtualScrollInfo = function getVirtualScrollInfo() {
    return {
      x: isRTL ? -offsetLeft : offsetLeft,
      y: offsetTop
    };
  };
  var lastVirtualScrollInfoRef = (0,react.useRef)(getVirtualScrollInfo());
  var triggerScroll = (0,rc_util_es/* useEvent */.zX)(function (params) {
    if (onVirtualScroll) {
      var nextInfo = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, getVirtualScrollInfo()), params);

      // Trigger when offset changed
      if (lastVirtualScrollInfoRef.current.x !== nextInfo.x || lastVirtualScrollInfoRef.current.y !== nextInfo.y) {
        onVirtualScroll(nextInfo);
        lastVirtualScrollInfoRef.current = nextInfo;
      }
    }
  });
  function onScrollBar(newScrollOffset, horizontal) {
    var newOffset = newScrollOffset;
    if (horizontal) {
      (0,react_dom.flushSync)(function () {
        setOffsetLeft(newOffset);
      });
      triggerScroll();
    } else {
      syncScrollTop(newOffset);
    }
  }

  // When data size reduce. It may trigger native scroll event back to fit scroll position
  function onFallbackScroll(e) {
    var newScrollTop = e.currentTarget.scrollTop;
    if (newScrollTop !== offsetTop) {
      syncScrollTop(newScrollTop);
    }

    // Trigger origin onScroll
    onScroll === null || onScroll === void 0 || onScroll(e);
    triggerScroll();
  }
  var keepInHorizontalRange = function keepInHorizontalRange(nextOffsetLeft) {
    var tmpOffsetLeft = nextOffsetLeft;
    var max = !!scrollWidth ? scrollWidth - size.width : 0;
    tmpOffsetLeft = Math.max(tmpOffsetLeft, 0);
    tmpOffsetLeft = Math.min(tmpOffsetLeft, max);
    return tmpOffsetLeft;
  };
  var onWheelDelta = (0,rc_util_es/* useEvent */.zX)(function (offsetXY, fromHorizontal) {
    if (fromHorizontal) {
      (0,react_dom.flushSync)(function () {
        setOffsetLeft(function (left) {
          var nextOffsetLeft = left + (isRTL ? -offsetXY : offsetXY);
          return keepInHorizontalRange(nextOffsetLeft);
        });
      });
      triggerScroll();
    } else {
      syncScrollTop(function (top) {
        var newTop = top + offsetXY;
        return newTop;
      });
    }
  });

  // Since this added in global,should use ref to keep update
  var _useFrameWheel = useFrameWheel(useVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, !!scrollWidth, onWheelDelta),
    _useFrameWheel2 = (0,slicedToArray/* default */.Z)(_useFrameWheel, 2),
    onRawWheel = _useFrameWheel2[0],
    onFireFoxScroll = _useFrameWheel2[1];

  // Mobile touch move
  useMobileTouchMove(useVirtual, componentRef, function (isHorizontal, delta, smoothOffset, e) {
    var event = e;
    if (originScroll(isHorizontal, delta, smoothOffset)) {
      return false;
    }

    // Fix nest List trigger TouchMove event
    if (!event || !event._virtualHandled) {
      if (event) {
        event._virtualHandled = true;
      }
      onRawWheel({
        preventDefault: function preventDefault() {},
        deltaX: isHorizontal ? delta : 0,
        deltaY: isHorizontal ? 0 : delta
      });
      return true;
    }
    return false;
  });

  // MouseDown drag for scroll
  useScrollDrag(inVirtual, componentRef, function (offset) {
    syncScrollTop(function (top) {
      return top + offset;
    });
  });
  (0,useLayoutEffect/* default */.Z)(function () {
    // Firefox only
    function onMozMousePixelScroll(e) {
      // scrolling at top/bottom limit
      var scrollingUpAtTop = isScrollAtTop && e.detail < 0;
      var scrollingDownAtBottom = isScrollAtBottom && e.detail > 0;
      if (useVirtual && !scrollingUpAtTop && !scrollingDownAtBottom) {
        e.preventDefault();
      }
    }
    var componentEle = componentRef.current;
    componentEle.addEventListener('wheel', onRawWheel, {
      passive: false
    });
    componentEle.addEventListener('DOMMouseScroll', onFireFoxScroll, {
      passive: true
    });
    componentEle.addEventListener('MozMousePixelScroll', onMozMousePixelScroll, {
      passive: false
    });
    return function () {
      componentEle.removeEventListener('wheel', onRawWheel);
      componentEle.removeEventListener('DOMMouseScroll', onFireFoxScroll);
      componentEle.removeEventListener('MozMousePixelScroll', onMozMousePixelScroll);
    };
  }, [useVirtual, isScrollAtTop, isScrollAtBottom]);

  // Sync scroll left
  (0,useLayoutEffect/* default */.Z)(function () {
    if (scrollWidth) {
      var newOffsetLeft = keepInHorizontalRange(offsetLeft);
      setOffsetLeft(newOffsetLeft);
      triggerScroll({
        x: newOffsetLeft
      });
    }
  }, [size.width, scrollWidth]);

  // ================================= Ref ==================================
  var delayHideScrollBar = function delayHideScrollBar() {
    var _verticalScrollBarRef, _horizontalScrollBarR;
    (_verticalScrollBarRef = verticalScrollBarRef.current) === null || _verticalScrollBarRef === void 0 || _verticalScrollBarRef.delayHidden();
    (_horizontalScrollBarR = horizontalScrollBarRef.current) === null || _horizontalScrollBarR === void 0 || _horizontalScrollBarR.delayHidden();
  };
  var _scrollTo = useScrollTo(componentRef, mergedData, heights, itemHeight, getKey, function () {
    return collectHeight(true);
  }, syncScrollTop, delayHideScrollBar);
  react.useImperativeHandle(ref, function () {
    return {
      nativeElement: containerRef.current,
      getScrollInfo: getVirtualScrollInfo,
      scrollTo: function scrollTo(config) {
        function isPosScroll(arg) {
          return arg && (0,esm_typeof/* default */.Z)(arg) === 'object' && ('left' in arg || 'top' in arg);
        }
        if (isPosScroll(config)) {
          // Scroll X
          if (config.left !== undefined) {
            setOffsetLeft(keepInHorizontalRange(config.left));
          }

          // Scroll Y
          _scrollTo(config.top);
        } else {
          _scrollTo(config);
        }
      }
    };
  });

  // ================================ Effect ================================
  /** We need told outside that some list not rendered */
  (0,useLayoutEffect/* default */.Z)(function () {
    if (onVisibleChange) {
      var renderList = mergedData.slice(start, end + 1);
      onVisibleChange(renderList, mergedData);
    }
  }, [start, end, mergedData]);

  // ================================ Extra =================================
  var getSize = useGetSize(mergedData, getKey, heights, itemHeight);
  var extraContent = extraRender === null || extraRender === void 0 ? void 0 : extraRender({
    start: start,
    end: end,
    virtual: inVirtual,
    offsetX: offsetLeft,
    offsetY: fillerOffset,
    rtl: isRTL,
    getSize: getSize
  });

  // ================================ Render ================================
  var listChildren = useChildren(mergedData, start, end, scrollWidth, offsetLeft, setInstanceRef, children, sharedConfig);
  var componentStyle = null;
  if (height) {
    componentStyle = (0,objectSpread2/* default */.Z)((0,defineProperty/* default */.Z)({}, fullHeight ? 'height' : 'maxHeight', height), ScrollStyle);
    if (useVirtual) {
      componentStyle.overflowY = 'hidden';
      if (scrollWidth) {
        componentStyle.overflowX = 'hidden';
      }
      if (scrollMoving) {
        componentStyle.pointerEvents = 'none';
      }
    }
  }
  var containerProps = {};
  if (isRTL) {
    containerProps.dir = 'rtl';
  }
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    ref: containerRef,
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, style), {}, {
      position: 'relative'
    }),
    className: mergedClassName
  }, containerProps, restProps), /*#__PURE__*/react.createElement(es/* default */.Z, {
    onResize: onHolderResize
  }, /*#__PURE__*/react.createElement(Component, {
    className: "".concat(prefixCls, "-holder"),
    style: componentStyle,
    ref: componentRef,
    onScroll: onFallbackScroll,
    onMouseEnter: delayHideScrollBar
  }, /*#__PURE__*/react.createElement(es_Filler, {
    prefixCls: prefixCls,
    height: scrollHeight,
    offsetX: offsetLeft,
    offsetY: fillerOffset,
    scrollWidth: scrollWidth,
    onInnerResize: collectHeight,
    ref: fillerInnerRef,
    innerProps: innerProps,
    rtl: isRTL,
    extra: extraContent
  }, listChildren))), inVirtual && scrollHeight > height && /*#__PURE__*/react.createElement(es_ScrollBar, {
    ref: verticalScrollBarRef,
    prefixCls: prefixCls,
    scrollOffset: offsetTop,
    scrollRange: scrollHeight,
    rtl: isRTL,
    onScroll: onScrollBar,
    onStartMove: onScrollbarStartMove,
    onStopMove: onScrollbarStopMove,
    spinSize: verticalScrollBarSpinSize,
    containerSize: size.height,
    style: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBar,
    thumbStyle: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBarThumb,
    showScrollBar: showScrollBar
  }), inVirtual && scrollWidth > size.width && /*#__PURE__*/react.createElement(es_ScrollBar, {
    ref: horizontalScrollBarRef,
    prefixCls: prefixCls,
    scrollOffset: offsetLeft,
    scrollRange: scrollWidth,
    rtl: isRTL,
    onScroll: onScrollBar,
    onStartMove: onScrollbarStartMove,
    onStopMove: onScrollbarStopMove,
    spinSize: horizontalScrollBarSpinSize,
    containerSize: size.width,
    horizontal: true,
    style: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBar,
    thumbStyle: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBarThumb,
    showScrollBar: showScrollBar
  }));
}
var List = /*#__PURE__*/react.forwardRef(RawList);
List.displayName = 'List';
/* harmony default export */ var es_List = (List);
;// CONCATENATED MODULE: ./node_modules/rc-virtual-list/es/index.js

/* harmony default export */ var rc_virtual_list_es = (es_List);

/***/ }),

/***/ 8467:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
"use client";

function ___$insertStyle(css) {
  if (!css || typeof window === 'undefined') {
    return;
  }
  const style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}
__webpack_unused_export__ = ({
  value: true
});
var React = __webpack_require__(82684);
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
___$insertStyle(".rfm-marquee-container {\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  width: var(--width);\n  transform: var(--transform);\n}\n.rfm-marquee-container:hover div {\n  animation-play-state: var(--pause-on-hover);\n}\n.rfm-marquee-container:active div {\n  animation-play-state: var(--pause-on-click);\n}\n\n.rfm-overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n.rfm-overlay::before, .rfm-overlay::after {\n  background: linear-gradient(to right, var(--gradient-color), rgba(255, 255, 255, 0));\n  content: \"\";\n  height: 100%;\n  position: absolute;\n  width: var(--gradient-width);\n  z-index: 2;\n  pointer-events: none;\n  touch-action: none;\n}\n.rfm-overlay::after {\n  right: 0;\n  top: 0;\n  transform: rotateZ(180deg);\n}\n.rfm-overlay::before {\n  left: 0;\n  top: 0;\n}\n\n.rfm-marquee {\n  flex: 0 0 auto;\n  min-width: var(--min-width);\n  z-index: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  animation: scroll var(--duration) linear var(--delay) var(--iteration-count);\n  animation-play-state: var(--play);\n  animation-delay: var(--delay);\n  animation-direction: var(--direction);\n}\n@keyframes scroll {\n  0% {\n    transform: translateX(0%);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n.rfm-initial-child-container {\n  flex: 0 0 auto;\n  display: flex;\n  min-width: auto;\n  flex-direction: row;\n  align-items: center;\n}\n\n.rfm-child {\n  transform: var(--transform);\n}");
const Marquee = React.forwardRef(function Marquee({
  style = {},
  className = "",
  autoFill = false,
  play = true,
  pauseOnHover = false,
  pauseOnClick = false,
  direction = "left",
  speed = 50,
  delay = 0,
  loop = 0,
  gradient = false,
  gradientColor = "white",
  gradientWidth = 200,
  onFinish,
  onCycleComplete,
  onMount,
  children
}, ref) {
  // React Hooks
  const [containerWidth, setContainerWidth] = React.useState(0);
  const [marqueeWidth, setMarqueeWidth] = React.useState(0);
  const [multiplier, setMultiplier] = React.useState(1);
  const [isMounted, setIsMounted] = React.useState(false);
  const rootRef = React.useRef(null);
  const containerRef = ref || rootRef;
  const marqueeRef = React.useRef(null);
  // Calculate width of container and marquee and set multiplier
  const calculateWidth = React.useCallback(() => {
    if (marqueeRef.current && containerRef.current) {
      const containerRect = containerRef.current.getBoundingClientRect();
      const marqueeRect = marqueeRef.current.getBoundingClientRect();
      let containerWidth = containerRect.width;
      let marqueeWidth = marqueeRect.width;
      // Swap width and height if direction is up or down
      if (direction === "up" || direction === "down") {
        containerWidth = containerRect.height;
        marqueeWidth = marqueeRect.height;
      }
      if (autoFill && containerWidth && marqueeWidth) {
        setMultiplier(marqueeWidth < containerWidth ? Math.ceil(containerWidth / marqueeWidth) : 1);
      } else {
        setMultiplier(1);
      }
      setContainerWidth(containerWidth);
      setMarqueeWidth(marqueeWidth);
    }
  }, [autoFill, containerRef, direction]);
  // Calculate width and multiplier on mount and on window resize
  React.useEffect(() => {
    if (!isMounted) return;
    calculateWidth();
    if (marqueeRef.current && containerRef.current) {
      const resizeObserver = new ResizeObserver(() => calculateWidth());
      resizeObserver.observe(containerRef.current);
      resizeObserver.observe(marqueeRef.current);
      return () => {
        if (!resizeObserver) return;
        resizeObserver.disconnect();
      };
    }
  }, [calculateWidth, containerRef, isMounted]);
  // Recalculate width when children change
  React.useEffect(() => {
    calculateWidth();
  }, [calculateWidth, children]);
  React.useEffect(() => {
    setIsMounted(true);
  }, []);
  // Runs the onMount callback, if it is a function, when Marquee is mounted.
  React.useEffect(() => {
    if (typeof onMount === "function") {
      onMount();
    }
  }, []);
  // Animation duration
  const duration = React.useMemo(() => {
    if (autoFill) {
      return marqueeWidth * multiplier / speed;
    } else {
      return marqueeWidth < containerWidth ? containerWidth / speed : marqueeWidth / speed;
    }
  }, [autoFill, containerWidth, marqueeWidth, multiplier, speed]);
  const containerStyle = React.useMemo(() => Object.assign(Object.assign({}, style), {
    ["--pause-on-hover"]: !play || pauseOnHover ? "paused" : "running",
    ["--pause-on-click"]: !play || pauseOnHover && !pauseOnClick || pauseOnClick ? "paused" : "running",
    ["--width"]: direction === "up" || direction === "down" ? `100vh` : "100%",
    ["--transform"]: direction === "up" ? "rotate(-90deg)" : direction === "down" ? "rotate(90deg)" : "none"
  }), [style, play, pauseOnHover, pauseOnClick, direction]);
  const gradientStyle = React.useMemo(() => ({
    ["--gradient-color"]: gradientColor,
    ["--gradient-width"]: typeof gradientWidth === "number" ? `${gradientWidth}px` : gradientWidth
  }), [gradientColor, gradientWidth]);
  const marqueeStyle = React.useMemo(() => ({
    ["--play"]: play ? "running" : "paused",
    ["--direction"]: direction === "left" ? "normal" : "reverse",
    ["--duration"]: `${duration}s`,
    ["--delay"]: `${delay}s`,
    ["--iteration-count"]: !!loop ? `${loop}` : "infinite",
    ["--min-width"]: autoFill ? `auto` : "100%"
  }), [play, direction, duration, delay, loop, autoFill]);
  const childStyle = React.useMemo(() => ({
    ["--transform"]: direction === "up" ? "rotate(90deg)" : direction === "down" ? "rotate(-90deg)" : "none"
  }), [direction]);
  // Render {multiplier} number of children
  const multiplyChildren = React.useCallback(multiplier => {
    return [...Array(Number.isFinite(multiplier) && multiplier >= 0 ? multiplier : 0)].map((_, i) => React__default['default'].createElement(React.Fragment, {
      key: i
    }, React.Children.map(children, child => {
      return React__default['default'].createElement("div", {
        style: childStyle,
        className: "rfm-child"
      }, child);
    })));
  }, [childStyle, children]);
  return !isMounted ? null : React__default['default'].createElement("div", {
    ref: containerRef,
    style: containerStyle,
    className: "rfm-marquee-container " + className
  }, gradient && React__default['default'].createElement("div", {
    style: gradientStyle,
    className: "rfm-overlay"
  }), React__default['default'].createElement("div", {
    className: "rfm-marquee",
    style: marqueeStyle,
    onAnimationIteration: onCycleComplete,
    onAnimationEnd: onFinish
  }, React__default['default'].createElement("div", {
    className: "rfm-initial-child-container",
    ref: marqueeRef
  }, React.Children.map(children, child => {
    return React__default['default'].createElement("div", {
      style: childStyle,
      className: "rfm-child"
    }, child);
  })), multiplyChildren(multiplier - 1)), React__default['default'].createElement("div", {
    className: "rfm-marquee",
    style: marqueeStyle
  }, multiplyChildren(multiplier)));
});
exports.Z = Marquee;

/***/ }),

/***/ 12595:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = format;
var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
  return string.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }
    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }
    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === "string" && s.indexOf("@") !== -1;
}
var redacted = "REDACTED (Potential Email Address)";
function redactEmail(string) {
  if (mightBeEmail(string)) {
    console.warn("This arg looks like an email address, redacting.");
    return redacted;
  }
  return string;
}
function format() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var _str = s || "";
  if (titleCase) {
    _str = toTitleCase(s);
  }
  if (redactingEmail) {
    _str = redactEmail(_str);
  }
  return _str;
}

/***/ }),

/***/ 60912:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.GA4 = void 0;
var _gtag = _interopRequireDefault(__webpack_require__(26323));
var _format = _interopRequireDefault(__webpack_require__(12595));
var _excluded = ["eventCategory", "eventAction", "eventLabel", "eventValue", "hitType"],
  _excluded2 = ["title", "location"],
  _excluded3 = ["page", "hitType"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
/*
Links
https://developers.google.com/gtagjs/reference/api
https://developers.google.com/tag-platform/gtagjs/reference
*/
/**
 * @typedef GaOptions
 * @type {Object}
 * @property {boolean} [cookieUpdate=true]
 * @property {number} [cookieExpires=63072000] Default two years
 * @property {string} [cookieDomain="auto"]
 * @property {string} [cookieFlags]
 * @property {string} [userId]
 * @property {string} [clientId]
 * @property {boolean} [anonymizeIp]
 * @property {string} [contentGroup1]
 * @property {string} [contentGroup2]
 * @property {string} [contentGroup3]
 * @property {string} [contentGroup4]
 * @property {string} [contentGroup5]
 * @property {boolean} [allowAdFeatures=true]
 * @property {boolean} [allowAdPersonalizationSignals]
 * @property {boolean} [nonInteraction]
 * @property {string} [page]
 */
/**
 * @typedef UaEventOptions
 * @type {Object}
 * @property {string} action
 * @property {string} category
 * @property {string} [label]
 * @property {number} [value]
 * @property {boolean} [nonInteraction]
 * @property {('beacon'|'xhr'|'image')} [transport]
 */
/**
 * @typedef InitOptions
 * @type {Object}
 * @property {string} trackingId
 * @property {GaOptions|any} [gaOptions]
 * @property {Object} [gtagOptions] New parameter
 */
var GA4 = /*#__PURE__*/function () {
  function GA4() {
    var _this = this;
    _classCallCheck(this, GA4);
    _defineProperty(this, "reset", function () {
      _this.isInitialized = false;
      _this._testMode = false;
      _this._currentMeasurementId;
      _this._hasLoadedGA = false;
      _this._isQueuing = false;
      _this._queueGtag = [];
    });
    _defineProperty(this, "_gtag", function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (!_this._testMode) {
        if (_this._isQueuing) {
          _this._queueGtag.push(args);
        } else {
          _gtag["default"].apply(void 0, args);
        }
      } else {
        _this._queueGtag.push(args);
      }
    });
    _defineProperty(this, "_loadGA", function (GA_MEASUREMENT_ID, nonce) {
      var gtagUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
      if (typeof window === "undefined" || typeof document === "undefined") {
        return;
      }
      if (!_this._hasLoadedGA) {
        // Global Site Tag (gtag.js) - Google Analytics
        var script = document.createElement("script");
        script.async = true;
        script.src = "".concat(gtagUrl, "?id=").concat(GA_MEASUREMENT_ID);
        if (nonce) {
          script.setAttribute("nonce", nonce);
        }
        document.body.appendChild(script);
        window.dataLayer = window.dataLayer || [];
        window.gtag = function gtag() {
          window.dataLayer.push(arguments);
        };
        _this._hasLoadedGA = true;
      }
    });
    _defineProperty(this, "_toGtagOptions", function (gaOptions) {
      if (!gaOptions) {
        return;
      }
      var mapFields = {
        // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
        // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
        cookieUpdate: "cookie_update",
        cookieExpires: "cookie_expires",
        cookieDomain: "cookie_domain",
        cookieFlags: "cookie_flags",
        // must be in set method?
        userId: "user_id",
        clientId: "client_id",
        anonymizeIp: "anonymize_ip",
        // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
        contentGroup1: "content_group1",
        contentGroup2: "content_group2",
        contentGroup3: "content_group3",
        contentGroup4: "content_group4",
        contentGroup5: "content_group5",
        // https://support.google.com/analytics/answer/9050852?hl=en
        allowAdFeatures: "allow_google_signals",
        allowAdPersonalizationSignals: "allow_ad_personalization_signals",
        nonInteraction: "non_interaction",
        page: "page_path",
        hitCallback: "event_callback"
      };
      var gtagOptions = Object.entries(gaOptions).reduce(function (prev, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        if (mapFields[key]) {
          prev[mapFields[key]] = value;
        } else {
          prev[key] = value;
        }
        return prev;
      }, {});
      return gtagOptions;
    });
    _defineProperty(this, "initialize", function (GA_MEASUREMENT_ID) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!GA_MEASUREMENT_ID) {
        throw new Error("Require GA_MEASUREMENT_ID");
      }
      var initConfigs = typeof GA_MEASUREMENT_ID === "string" ? [{
        trackingId: GA_MEASUREMENT_ID
      }] : GA_MEASUREMENT_ID;
      _this._currentMeasurementId = initConfigs[0].trackingId;
      var gaOptions = options.gaOptions,
        gtagOptions = options.gtagOptions,
        nonce = options.nonce,
        _options$testMode = options.testMode,
        testMode = _options$testMode === void 0 ? false : _options$testMode,
        gtagUrl = options.gtagUrl;
      _this._testMode = testMode;
      if (!testMode) {
        _this._loadGA(_this._currentMeasurementId, nonce, gtagUrl);
      }
      if (!_this.isInitialized) {
        _this._gtag("js", new Date());
        initConfigs.forEach(function (config) {
          var mergedGtagOptions = _objectSpread(_objectSpread(_objectSpread({}, _this._toGtagOptions(_objectSpread(_objectSpread({}, gaOptions), config.gaOptions))), gtagOptions), config.gtagOptions);
          if (Object.keys(mergedGtagOptions).length) {
            _this._gtag("config", config.trackingId, mergedGtagOptions);
          } else {
            _this._gtag("config", config.trackingId);
          }
        });
      }
      _this.isInitialized = true;
      if (!testMode) {
        var queues = _toConsumableArray(_this._queueGtag);
        _this._queueGtag = [];
        _this._isQueuing = false;
        while (queues.length) {
          var queue = queues.shift();
          _this._gtag.apply(_this, _toConsumableArray(queue));
          if (queue[0] === "get") {
            _this._isQueuing = true;
          }
        }
      }
    });
    _defineProperty(this, "set", function (fieldsObject) {
      if (!fieldsObject) {
        console.warn("`fieldsObject` is required in .set()");
        return;
      }
      if (_typeof(fieldsObject) !== "object") {
        console.warn("Expected `fieldsObject` arg to be an Object");
        return;
      }
      if (Object.keys(fieldsObject).length === 0) {
        console.warn("empty `fieldsObject` given to .set()");
      }
      _this._gaCommand("set", fieldsObject);
    });
    _defineProperty(this, "_gaCommandSendEvent", function (eventCategory, eventAction, eventLabel, eventValue, fieldsObject) {
      _this._gtag("event", eventAction, _objectSpread(_objectSpread({
        event_category: eventCategory,
        event_label: eventLabel,
        value: eventValue
      }, fieldsObject && {
        non_interaction: fieldsObject.nonInteraction
      }), _this._toGtagOptions(fieldsObject)));
    });
    _defineProperty(this, "_gaCommandSendEventParameters", function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      if (typeof args[0] === "string") {
        _this._gaCommandSendEvent.apply(_this, _toConsumableArray(args.slice(1)));
      } else {
        var _args$ = args[0],
          eventCategory = _args$.eventCategory,
          eventAction = _args$.eventAction,
          eventLabel = _args$.eventLabel,
          eventValue = _args$.eventValue,
          hitType = _args$.hitType,
          rest = _objectWithoutProperties(_args$, _excluded);
        _this._gaCommandSendEvent(eventCategory, eventAction, eventLabel, eventValue, rest);
      }
    });
    _defineProperty(this, "_gaCommandSendTiming", function (timingCategory, timingVar, timingValue, timingLabel) {
      _this._gtag("event", "timing_complete", {
        name: timingVar,
        value: timingValue,
        event_category: timingCategory,
        event_label: timingLabel
      });
    });
    _defineProperty(this, "_gaCommandSendPageview", function (page, fieldsObject) {
      if (fieldsObject && Object.keys(fieldsObject).length) {
        var _this$_toGtagOptions = _this._toGtagOptions(fieldsObject),
          title = _this$_toGtagOptions.title,
          location = _this$_toGtagOptions.location,
          rest = _objectWithoutProperties(_this$_toGtagOptions, _excluded2);
        _this._gtag("event", "page_view", _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, page && {
          page_path: page
        }), title && {
          page_title: title
        }), location && {
          page_location: location
        }), rest));
      } else if (page) {
        _this._gtag("event", "page_view", {
          page_path: page
        });
      } else {
        _this._gtag("event", "page_view");
      }
    });
    _defineProperty(this, "_gaCommandSendPageviewParameters", function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      if (typeof args[0] === "string") {
        _this._gaCommandSendPageview.apply(_this, _toConsumableArray(args.slice(1)));
      } else {
        var _args$2 = args[0],
          page = _args$2.page,
          hitType = _args$2.hitType,
          rest = _objectWithoutProperties(_args$2, _excluded3);
        _this._gaCommandSendPageview(page, rest);
      }
    });
    _defineProperty(this, "_gaCommandSend", function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      var hitType = typeof args[0] === "string" ? args[0] : args[0].hitType;
      switch (hitType) {
        case "event":
          _this._gaCommandSendEventParameters.apply(_this, args);
          break;
        case "pageview":
          _this._gaCommandSendPageviewParameters.apply(_this, args);
          break;
        case "timing":
          _this._gaCommandSendTiming.apply(_this, _toConsumableArray(args.slice(1)));
          break;
        case "screenview":
        case "transaction":
        case "item":
        case "social":
        case "exception":
          console.warn("Unsupported send command: ".concat(hitType));
          break;
        default:
          console.warn("Send command doesn't exist: ".concat(hitType));
      }
    });
    _defineProperty(this, "_gaCommandSet", function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      if (typeof args[0] === "string") {
        args[0] = _defineProperty({}, args[0], args[1]);
      }
      _this._gtag("set", _this._toGtagOptions(args[0]));
    });
    _defineProperty(this, "_gaCommand", function (command) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }
      switch (command) {
        case "send":
          _this._gaCommandSend.apply(_this, args);
          break;
        case "set":
          _this._gaCommandSet.apply(_this, args);
          break;
        default:
          console.warn("Command doesn't exist: ".concat(command));
      }
    });
    _defineProperty(this, "ga", function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }
      if (typeof args[0] === "string") {
        _this._gaCommand.apply(_this, args);
      } else {
        var readyCallback = args[0];
        _this._gtag("get", _this._currentMeasurementId, "client_id", function (clientId) {
          _this._isQueuing = false;
          var queues = _this._queueGtag;
          readyCallback({
            get: function get(property) {
              return property === "clientId" ? clientId : property === "trackingId" ? _this._currentMeasurementId : property === "apiVersion" ? "1" : undefined;
            }
          });
          while (queues.length) {
            var queue = queues.shift();
            _this._gtag.apply(_this, _toConsumableArray(queue));
          }
        });
        _this._isQueuing = true;
      }
      return _this.ga;
    });
    _defineProperty(this, "event", function (optionsOrName, params) {
      if (typeof optionsOrName === "string") {
        _this._gtag("event", optionsOrName, _this._toGtagOptions(params));
      } else {
        var action = optionsOrName.action,
          category = optionsOrName.category,
          label = optionsOrName.label,
          value = optionsOrName.value,
          nonInteraction = optionsOrName.nonInteraction,
          transport = optionsOrName.transport;
        if (!category || !action) {
          console.warn("args.category AND args.action are required in event()");
          return;
        }

        // Required Fields
        var fieldObject = {
          hitType: "event",
          eventCategory: (0, _format["default"])(category),
          eventAction: (0, _format["default"])(action)
        };

        // Optional Fields
        if (label) {
          fieldObject.eventLabel = (0, _format["default"])(label);
        }
        if (typeof value !== "undefined") {
          if (typeof value !== "number") {
            console.warn("Expected `args.value` arg to be a Number.");
          } else {
            fieldObject.eventValue = value;
          }
        }
        if (typeof nonInteraction !== "undefined") {
          if (typeof nonInteraction !== "boolean") {
            console.warn("`args.nonInteraction` must be a boolean.");
          } else {
            fieldObject.nonInteraction = nonInteraction;
          }
        }
        if (typeof transport !== "undefined") {
          if (typeof transport !== "string") {
            console.warn("`args.transport` must be a string.");
          } else {
            if (["beacon", "xhr", "image"].indexOf(transport) === -1) {
              console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
            }
            fieldObject.transport = transport;
          }
        }
        _this._gaCommand("send", fieldObject);
      }
    });
    _defineProperty(this, "send", function (fieldObject) {
      _this._gaCommand("send", fieldObject);
    });
    this.reset();
  }
  _createClass(GA4, [{
    key: "gtag",
    value: function gtag() {
      this._gtag.apply(this, arguments);
    }
  }]);
  return GA4;
}();
exports.GA4 = GA4;
var _default = new GA4();
exports["default"] = _default;

/***/ }),

/***/ 26323:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var gtag = function gtag() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (typeof window !== "undefined") {
    var _window;
    if (typeof window.gtag === "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
    }
    (_window = window).gtag.apply(_window, args);
  }
};
var _default = gtag;
exports["default"] = _default;

/***/ }),

/***/ 57604:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
__webpack_unused_export__ = ({
  value: true
});
exports.ZP = __webpack_unused_export__ = void 0;
var _ga = _interopRequireWildcard(__webpack_require__(60912));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var ReactGAImplementation = _ga.GA4;
__webpack_unused_export__ = ReactGAImplementation;
var _default = _ga["default"];
exports.ZP = _default;

/***/ }),

/***/ 25931:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _warn = __webpack_require__(38596);
var _warn2 = _interopRequireDefault(_warn);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

// https://developers.google.com/tag-manager/quickstart

var Snippets = {
  tags: function tags(_ref) {
    var id = _ref.id,
      events = _ref.events,
      dataLayer = _ref.dataLayer,
      dataLayerName = _ref.dataLayerName,
      preview = _ref.preview,
      auth = _ref.auth;
    var gtm_auth = '&gtm_auth=' + auth;
    var gtm_preview = '&gtm_preview=' + preview;
    if (!id) (0, _warn2.default)('GTM Id is required');
    var iframe = '\n      <iframe src="https://www.googletagmanager.com/ns.html?id=' + id + gtm_auth + gtm_preview + '&gtm_cookies_win=x"\n        height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>';
    var script = '\n      (function(w,d,s,l,i){w[l]=w[l]||[];\n        w[l].push({\'gtm.start\': new Date().getTime(),event:\'gtm.js\', ' + JSON.stringify(events).slice(1, -1) + '});\n        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';\n        j.async=true;j.src=\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl+\'' + gtm_auth + gtm_preview + '&gtm_cookies_win=x\';\n        f.parentNode.insertBefore(j,f);\n      })(window,document,\'script\',\'' + dataLayerName + '\',\'' + id + '\');';
    var dataLayerVar = this.dataLayer(dataLayer, dataLayerName);
    return {
      iframe: iframe,
      script: script,
      dataLayerVar: dataLayerVar
    };
  },
  dataLayer: function dataLayer(_dataLayer, dataLayerName) {
    return '\n      window.' + dataLayerName + ' = window.' + dataLayerName + ' || [];\n      window.' + dataLayerName + '.push(' + JSON.stringify(_dataLayer) + ')';
  }
};
module.exports = Snippets;

/***/ }),

/***/ 47914:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _Snippets = __webpack_require__(25931);
var _Snippets2 = _interopRequireDefault(_Snippets);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var TagManager = {
  dataScript: function dataScript(dataLayer) {
    var script = document.createElement('script');
    script.innerHTML = dataLayer;
    return script;
  },
  gtm: function gtm(args) {
    var snippets = _Snippets2.default.tags(args);
    var noScript = function noScript() {
      var noscript = document.createElement('noscript');
      noscript.innerHTML = snippets.iframe;
      return noscript;
    };
    var script = function script() {
      var script = document.createElement('script');
      script.innerHTML = snippets.script;
      return script;
    };
    var dataScript = this.dataScript(snippets.dataLayerVar);
    return {
      noScript: noScript,
      script: script,
      dataScript: dataScript
    };
  },
  initialize: function initialize(_ref) {
    var gtmId = _ref.gtmId,
      _ref$events = _ref.events,
      events = _ref$events === undefined ? {} : _ref$events,
      dataLayer = _ref.dataLayer,
      _ref$dataLayerName = _ref.dataLayerName,
      dataLayerName = _ref$dataLayerName === undefined ? 'dataLayer' : _ref$dataLayerName,
      _ref$auth = _ref.auth,
      auth = _ref$auth === undefined ? '' : _ref$auth,
      _ref$preview = _ref.preview,
      preview = _ref$preview === undefined ? '' : _ref$preview;
    var gtm = this.gtm({
      id: gtmId,
      events: events,
      dataLayer: dataLayer || undefined,
      dataLayerName: dataLayerName,
      auth: auth,
      preview: preview
    });
    if (dataLayer) document.head.appendChild(gtm.dataScript);
    document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
    document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);
  },
  dataLayer: function dataLayer(_ref2) {
    var _dataLayer = _ref2.dataLayer,
      _ref2$dataLayerName = _ref2.dataLayerName,
      dataLayerName = _ref2$dataLayerName === undefined ? 'dataLayer' : _ref2$dataLayerName;
    if (window[dataLayerName]) return window[dataLayerName].push(_dataLayer);
    var snippets = _Snippets2.default.dataLayer(_dataLayer, dataLayerName);
    var dataScript = this.dataScript(snippets);
    document.head.insertBefore(dataScript, document.head.childNodes[0]);
  }
};
module.exports = TagManager;

/***/ }),

/***/ 11598:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _TagManager = __webpack_require__(47914);
var _TagManager2 = _interopRequireDefault(_TagManager);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
module.exports = _TagManager2.default;

/***/ }),

/***/ 38596:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var warn = function warn(s) {
  console.warn('[react-gtm]', s);
};
exports["default"] = warn;

/***/ }),

/***/ 1967:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var b = "function" === typeof Symbol && Symbol.for,
  c = b ? Symbol.for("react.element") : 60103,
  d = b ? Symbol.for("react.portal") : 60106,
  e = b ? Symbol.for("react.fragment") : 60107,
  f = b ? Symbol.for("react.strict_mode") : 60108,
  g = b ? Symbol.for("react.profiler") : 60114,
  h = b ? Symbol.for("react.provider") : 60109,
  k = b ? Symbol.for("react.context") : 60110,
  l = b ? Symbol.for("react.async_mode") : 60111,
  m = b ? Symbol.for("react.concurrent_mode") : 60111,
  n = b ? Symbol.for("react.forward_ref") : 60112,
  p = b ? Symbol.for("react.suspense") : 60113,
  q = b ? Symbol.for("react.suspense_list") : 60120,
  r = b ? Symbol.for("react.memo") : 60115,
  t = b ? Symbol.for("react.lazy") : 60116,
  v = b ? Symbol.for("react.block") : 60121,
  w = b ? Symbol.for("react.fundamental") : 60117,
  x = b ? Symbol.for("react.responder") : 60118,
  y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function (a) {
  return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function (a) {
  return z(a) === k;
};
exports.isContextProvider = function (a) {
  return z(a) === h;
};
exports.isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function (a) {
  return z(a) === n;
};
exports.isFragment = function (a) {
  return z(a) === e;
};
exports.isLazy = function (a) {
  return z(a) === t;
};
exports.isMemo = function (a) {
  return z(a) === r;
};
exports.isPortal = function (a) {
  return z(a) === d;
};
exports.isProfiler = function (a) {
  return z(a) === g;
};
exports.isStrictMode = function (a) {
  return z(a) === f;
};
exports.isSuspense = function (a) {
  return z(a) === p;
};
exports.isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

/***/ }),

/***/ 58740:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1967);
} else {}

/***/ }),

/***/ 74762:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

// A reserved attribute.
// It is handled by React separately and shouldn't be written to the DOM.
const RESERVED = 0;

// A simple string attribute.
// Attributes that aren't in the filter are presumed to have this type.
const STRING = 1;

// A string attribute that accepts booleans in React. In HTML, these are called
// "enumerated" attributes with "true" and "false" as possible values.
// When true, it should be set to a "true" string.
// When false, it should be set to a "false" string.
const BOOLEANISH_STRING = 2;

// A real boolean attribute.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
const BOOLEAN = 3;

// An attribute that can be used as a flag as well as with a value.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
// For any other value, should be present with that value.
const OVERLOADED_BOOLEAN = 4;

// An attribute that must be numeric or parse as a numeric.
// When falsy, it should be removed.
const NUMERIC = 5;

// An attribute that must be positive numeric or parse as a positive numeric.
// When falsy, it should be removed.
const POSITIVE_NUMERIC = 6;
function getPropertyInfo(name) {
  return properties.hasOwnProperty(name) ? properties[name] : null;
}
function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
  this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
  this.attributeName = attributeName;
  this.attributeNamespace = attributeNamespace;
  this.mustUseProperty = mustUseProperty;
  this.propertyName = name;
  this.type = type;
  this.sanitizeURL = sanitizeURL;
  this.removeEmptyString = removeEmptyString;
}

// When adding attributes to this list, be sure to also add them to
// the `possibleStandardNames` module to ensure casing and incorrect
// name warnings.
const properties = {};

// These props are reserved by React. They shouldn't be written to the DOM.
const reservedProps = ['children', 'dangerouslySetInnerHTML',
// TODO: This prevents the assignment of defaultValue to regular
// elements (not just inputs). Now that ReactDOMInput assigns to the
// defaultValue property -- do we need this?
'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
reservedProps.forEach(name => {
  properties[name] = new PropertyInfoRecord(name, RESERVED, false,
  // mustUseProperty
  name,
  // attributeName
  null,
  // attributeNamespace
  false,
  // sanitizeURL
  false) // removeEmptyString
  ;
});

// A few React string attributes have a different name.
// This is a mapping from React prop names to the attribute names.
[['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(([name, attributeName]) => {
  properties[name] = new PropertyInfoRecord(name, STRING, false,
  // mustUseProperty
  attributeName,
  // attributeName
  null,
  // attributeNamespace
  false,
  // sanitizeURL
  false) // removeEmptyString
  ;
});

// These are "enumerated" HTML attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(name => {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false,
  // mustUseProperty
  name.toLowerCase(),
  // attributeName
  null,
  // attributeNamespace
  false,
  // sanitizeURL
  false) // removeEmptyString
  ;
});

// These are "enumerated" SVG attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
// Since these are SVG attributes, their attribute names are case-sensitive.
['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(name => {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false,
  // mustUseProperty
  name,
  // attributeName
  null,
  // attributeNamespace
  false,
  // sanitizeURL
  false) // removeEmptyString
  ;
});

// These are HTML boolean attributes.
['allowFullScreen', 'async',
// Note: there is a special case that prevents it from being written to the DOM
// on the client side because the browsers are inconsistent. Instead we call focus().
'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'disableRemotePlayback', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless',
// Microdata
'itemScope'].forEach(name => {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, false,
  // mustUseProperty
  name.toLowerCase(),
  // attributeName
  null,
  // attributeNamespace
  false,
  // sanitizeURL
  false) // removeEmptyString
  ;
});

// These are the few React props that we set as DOM properties
// rather than attributes. These are all booleans.
['checked',
// Note: `option.selected` is not updated if `select.multiple` is
// disabled with `removeAttribute`. We have special logic for handling this.
'multiple', 'muted', 'selected'

// NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(name => {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, true,
  // mustUseProperty
  name,
  // attributeName
  null,
  // attributeNamespace
  false,
  // sanitizeURL
  false) // removeEmptyString
  ;
});

// These are HTML attributes that are "overloaded booleans": they behave like
// booleans, but can also accept a string value.
['capture', 'download'

// NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(name => {
  properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false,
  // mustUseProperty
  name,
  // attributeName
  null,
  // attributeNamespace
  false,
  // sanitizeURL
  false) // removeEmptyString
  ;
});

// These are HTML attributes that must be positive numbers.
['cols', 'rows', 'size', 'span'

// NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(name => {
  properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false,
  // mustUseProperty
  name,
  // attributeName
  null,
  // attributeNamespace
  false,
  // sanitizeURL
  false) // removeEmptyString
  ;
});

// These are HTML attributes that must be numbers.
['rowSpan', 'start'].forEach(name => {
  properties[name] = new PropertyInfoRecord(name, NUMERIC, false,
  // mustUseProperty
  name.toLowerCase(),
  // attributeName
  null,
  // attributeNamespace
  false,
  // sanitizeURL
  false) // removeEmptyString
  ;
});
const CAMELIZE = /[\-\:]([a-z])/g;
const capitalize = token => token[1].toUpperCase();

// This is a list of all SVG attributes that need special casing, namespacing,
// or boolean value assignment. Regular attributes that just accept strings
// and have the same names are omitted, just like in the HTML attribute filter.
// Some of these attributes can be hard to find. This list was created by
// scraping the MDN documentation.
['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height'

// NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(attributeName => {
  const name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false,
  // mustUseProperty
  attributeName, null,
  // attributeNamespace
  false,
  // sanitizeURL
  false) // removeEmptyString
  ;
});

// String SVG attributes with the xlink namespace.
['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type'

// NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(attributeName => {
  const name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false,
  // mustUseProperty
  attributeName, 'http://www.w3.org/1999/xlink', false,
  // sanitizeURL
  false) // removeEmptyString
  ;
});

// String SVG attributes with the xml namespace.
['xml:base', 'xml:lang', 'xml:space'

// NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(attributeName => {
  const name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false,
  // mustUseProperty
  attributeName, 'http://www.w3.org/XML/1998/namespace', false,
  // sanitizeURL
  false) // removeEmptyString
  ;
});

// These attribute exists both in HTML and SVG.
// The attribute name is case-sensitive in SVG so we can't just use
// the React name like we do for attributes that exist only in HTML.
['tabIndex', 'crossOrigin'].forEach(attributeName => {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false,
  // mustUseProperty
  attributeName.toLowerCase(),
  // attributeName
  null,
  // attributeNamespace
  false,
  // sanitizeURL
  false) // removeEmptyString
  ;
});

// These attributes accept URLs. These must not allow javascript: URLS.
// These will also need to accept Trusted Types object in the future.
const xlinkHref = 'xlinkHref';
properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false,
// mustUseProperty
'xlink:href', 'http://www.w3.org/1999/xlink', true,
// sanitizeURL
false) // removeEmptyString
;
['src', 'href', 'action', 'formAction'].forEach(attributeName => {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false,
  // mustUseProperty
  attributeName.toLowerCase(),
  // attributeName
  null,
  // attributeNamespace
  true,
  // sanitizeURL
  true) // removeEmptyString
  ;
});

// 
const {
  CAMELCASE,
  SAME,
  possibleStandardNames: possibleStandardNamesOptimized
} = __webpack_require__(73932);
const ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
const ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';

/**
 * Checks whether a property name is a custom attribute.
 *
 * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25
 *
 * @type {(attribute: string) => boolean}
 */
const isCustomAttribute = RegExp.prototype.test.bind(
// eslint-disable-next-line no-misleading-character-class
new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

/**
 * @type {Record<string, string>}
 */
const possibleStandardNames = Object.keys(possibleStandardNamesOptimized).reduce((accumulator, standardName) => {
  const propName = possibleStandardNamesOptimized[standardName];
  if (propName === SAME) {
    accumulator[standardName] = standardName;
  } else if (propName === CAMELCASE) {
    accumulator[standardName.toLowerCase()] = standardName;
  } else {
    accumulator[standardName] = propName;
  }
  return accumulator;
}, {});
exports.BOOLEAN = BOOLEAN;
exports.BOOLEANISH_STRING = BOOLEANISH_STRING;
exports.NUMERIC = NUMERIC;
exports.OVERLOADED_BOOLEAN = OVERLOADED_BOOLEAN;
exports.POSITIVE_NUMERIC = POSITIVE_NUMERIC;
exports.RESERVED = RESERVED;
exports.STRING = STRING;
exports.getPropertyInfo = getPropertyInfo;
exports.isCustomAttribute = isCustomAttribute;
exports.possibleStandardNames = possibleStandardNames;

/***/ }),

/***/ 73932:
/***/ (function(__unused_webpack_module, exports) {

// An attribute in which the DOM/SVG standard name is the same as the React prop name (e.g., 'accept').
var SAME = 0;
exports.SAME = SAME;

// An attribute in which the React prop name is the camelcased version of the DOM/SVG standard name (e.g., 'acceptCharset').
var CAMELCASE = 1;
exports.CAMELCASE = CAMELCASE;
exports.possibleStandardNames = {
  accept: 0,
  acceptCharset: 1,
  'accept-charset': 'acceptCharset',
  accessKey: 1,
  action: 0,
  allowFullScreen: 1,
  alt: 0,
  as: 0,
  async: 0,
  autoCapitalize: 1,
  autoComplete: 1,
  autoCorrect: 1,
  autoFocus: 1,
  autoPlay: 1,
  autoSave: 1,
  capture: 0,
  cellPadding: 1,
  cellSpacing: 1,
  challenge: 0,
  charSet: 1,
  checked: 0,
  children: 0,
  cite: 0,
  class: 'className',
  classID: 1,
  className: 1,
  cols: 0,
  colSpan: 1,
  content: 0,
  contentEditable: 1,
  contextMenu: 1,
  controls: 0,
  controlsList: 1,
  coords: 0,
  crossOrigin: 1,
  dangerouslySetInnerHTML: 1,
  data: 0,
  dateTime: 1,
  default: 0,
  defaultChecked: 1,
  defaultValue: 1,
  defer: 0,
  dir: 0,
  disabled: 0,
  disablePictureInPicture: 1,
  disableRemotePlayback: 1,
  download: 0,
  draggable: 0,
  encType: 1,
  enterKeyHint: 1,
  for: 'htmlFor',
  form: 0,
  formMethod: 1,
  formAction: 1,
  formEncType: 1,
  formNoValidate: 1,
  formTarget: 1,
  frameBorder: 1,
  headers: 0,
  height: 0,
  hidden: 0,
  high: 0,
  href: 0,
  hrefLang: 1,
  htmlFor: 1,
  httpEquiv: 1,
  'http-equiv': 'httpEquiv',
  icon: 0,
  id: 0,
  innerHTML: 1,
  inputMode: 1,
  integrity: 0,
  is: 0,
  itemID: 1,
  itemProp: 1,
  itemRef: 1,
  itemScope: 1,
  itemType: 1,
  keyParams: 1,
  keyType: 1,
  kind: 0,
  label: 0,
  lang: 0,
  list: 0,
  loop: 0,
  low: 0,
  manifest: 0,
  marginWidth: 1,
  marginHeight: 1,
  max: 0,
  maxLength: 1,
  media: 0,
  mediaGroup: 1,
  method: 0,
  min: 0,
  minLength: 1,
  multiple: 0,
  muted: 0,
  name: 0,
  noModule: 1,
  nonce: 0,
  noValidate: 1,
  open: 0,
  optimum: 0,
  pattern: 0,
  placeholder: 0,
  playsInline: 1,
  poster: 0,
  preload: 0,
  profile: 0,
  radioGroup: 1,
  readOnly: 1,
  referrerPolicy: 1,
  rel: 0,
  required: 0,
  reversed: 0,
  role: 0,
  rows: 0,
  rowSpan: 1,
  sandbox: 0,
  scope: 0,
  scoped: 0,
  scrolling: 0,
  seamless: 0,
  selected: 0,
  shape: 0,
  size: 0,
  sizes: 0,
  span: 0,
  spellCheck: 1,
  src: 0,
  srcDoc: 1,
  srcLang: 1,
  srcSet: 1,
  start: 0,
  step: 0,
  style: 0,
  summary: 0,
  tabIndex: 1,
  target: 0,
  title: 0,
  type: 0,
  useMap: 1,
  value: 0,
  width: 0,
  wmode: 0,
  wrap: 0,
  about: 0,
  accentHeight: 1,
  'accent-height': 'accentHeight',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 1,
  'alignment-baseline': 'alignmentBaseline',
  allowReorder: 1,
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 1,
  'arabic-form': 'arabicForm',
  ascent: 0,
  attributeName: 1,
  attributeType: 1,
  autoReverse: 1,
  azimuth: 0,
  baseFrequency: 1,
  baselineShift: 1,
  'baseline-shift': 'baselineShift',
  baseProfile: 1,
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 1,
  capHeight: 1,
  'cap-height': 'capHeight',
  clip: 0,
  clipPath: 1,
  'clip-path': 'clipPath',
  clipPathUnits: 1,
  clipRule: 1,
  'clip-rule': 'clipRule',
  color: 0,
  colorInterpolation: 1,
  'color-interpolation': 'colorInterpolation',
  colorInterpolationFilters: 1,
  'color-interpolation-filters': 'colorInterpolationFilters',
  colorProfile: 1,
  'color-profile': 'colorProfile',
  colorRendering: 1,
  'color-rendering': 'colorRendering',
  contentScriptType: 1,
  contentStyleType: 1,
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  datatype: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 1,
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 1,
  'dominant-baseline': 'dominantBaseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 1,
  elevation: 0,
  enableBackground: 1,
  'enable-background': 'enableBackground',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 1,
  fill: 0,
  fillOpacity: 1,
  'fill-opacity': 'fillOpacity',
  fillRule: 1,
  'fill-rule': 'fillRule',
  filter: 0,
  filterRes: 1,
  filterUnits: 1,
  floodOpacity: 1,
  'flood-opacity': 'floodOpacity',
  floodColor: 1,
  'flood-color': 'floodColor',
  focusable: 0,
  fontFamily: 1,
  'font-family': 'fontFamily',
  fontSize: 1,
  'font-size': 'fontSize',
  fontSizeAdjust: 1,
  'font-size-adjust': 'fontSizeAdjust',
  fontStretch: 1,
  'font-stretch': 'fontStretch',
  fontStyle: 1,
  'font-style': 'fontStyle',
  fontVariant: 1,
  'font-variant': 'fontVariant',
  fontWeight: 1,
  'font-weight': 'fontWeight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 1,
  'glyph-name': 'glyphName',
  glyphOrientationHorizontal: 1,
  'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
  glyphOrientationVertical: 1,
  'glyph-orientation-vertical': 'glyphOrientationVertical',
  glyphRef: 1,
  gradientTransform: 1,
  gradientUnits: 1,
  hanging: 0,
  horizAdvX: 1,
  'horiz-adv-x': 'horizAdvX',
  horizOriginX: 1,
  'horiz-origin-x': 'horizOriginX',
  ideographic: 0,
  imageRendering: 1,
  'image-rendering': 'imageRendering',
  in2: 0,
  in: 0,
  inlist: 0,
  intercept: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  k: 0,
  kernelMatrix: 1,
  kernelUnitLength: 1,
  kerning: 0,
  keyPoints: 1,
  keySplines: 1,
  keyTimes: 1,
  lengthAdjust: 1,
  letterSpacing: 1,
  'letter-spacing': 'letterSpacing',
  lightingColor: 1,
  'lighting-color': 'lightingColor',
  limitingConeAngle: 1,
  local: 0,
  markerEnd: 1,
  'marker-end': 'markerEnd',
  markerHeight: 1,
  markerMid: 1,
  'marker-mid': 'markerMid',
  markerStart: 1,
  'marker-start': 'markerStart',
  markerUnits: 1,
  markerWidth: 1,
  mask: 0,
  maskContentUnits: 1,
  maskUnits: 1,
  mathematical: 0,
  mode: 0,
  numOctaves: 1,
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 1,
  'overline-position': 'overlinePosition',
  overlineThickness: 1,
  'overline-thickness': 'overlineThickness',
  paintOrder: 1,
  'paint-order': 'paintOrder',
  panose1: 0,
  'panose-1': 'panose1',
  pathLength: 1,
  patternContentUnits: 1,
  patternTransform: 1,
  patternUnits: 1,
  pointerEvents: 1,
  'pointer-events': 'pointerEvents',
  points: 0,
  pointsAtX: 1,
  pointsAtY: 1,
  pointsAtZ: 1,
  prefix: 0,
  preserveAlpha: 1,
  preserveAspectRatio: 1,
  primitiveUnits: 1,
  property: 0,
  r: 0,
  radius: 0,
  refX: 1,
  refY: 1,
  renderingIntent: 1,
  'rendering-intent': 'renderingIntent',
  repeatCount: 1,
  repeatDur: 1,
  requiredExtensions: 1,
  requiredFeatures: 1,
  resource: 0,
  restart: 0,
  result: 0,
  results: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  security: 0,
  seed: 0,
  shapeRendering: 1,
  'shape-rendering': 'shapeRendering',
  slope: 0,
  spacing: 0,
  specularConstant: 1,
  specularExponent: 1,
  speed: 0,
  spreadMethod: 1,
  startOffset: 1,
  stdDeviation: 1,
  stemh: 0,
  stemv: 0,
  stitchTiles: 1,
  stopColor: 1,
  'stop-color': 'stopColor',
  stopOpacity: 1,
  'stop-opacity': 'stopOpacity',
  strikethroughPosition: 1,
  'strikethrough-position': 'strikethroughPosition',
  strikethroughThickness: 1,
  'strikethrough-thickness': 'strikethroughThickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 1,
  'stroke-dasharray': 'strokeDasharray',
  strokeDashoffset: 1,
  'stroke-dashoffset': 'strokeDashoffset',
  strokeLinecap: 1,
  'stroke-linecap': 'strokeLinecap',
  strokeLinejoin: 1,
  'stroke-linejoin': 'strokeLinejoin',
  strokeMiterlimit: 1,
  'stroke-miterlimit': 'strokeMiterlimit',
  strokeWidth: 1,
  'stroke-width': 'strokeWidth',
  strokeOpacity: 1,
  'stroke-opacity': 'strokeOpacity',
  suppressContentEditableWarning: 1,
  suppressHydrationWarning: 1,
  surfaceScale: 1,
  systemLanguage: 1,
  tableValues: 1,
  targetX: 1,
  targetY: 1,
  textAnchor: 1,
  'text-anchor': 'textAnchor',
  textDecoration: 1,
  'text-decoration': 'textDecoration',
  textLength: 1,
  textRendering: 1,
  'text-rendering': 'textRendering',
  to: 0,
  transform: 0,
  typeof: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 1,
  'underline-position': 'underlinePosition',
  underlineThickness: 1,
  'underline-thickness': 'underlineThickness',
  unicode: 0,
  unicodeBidi: 1,
  'unicode-bidi': 'unicodeBidi',
  unicodeRange: 1,
  'unicode-range': 'unicodeRange',
  unitsPerEm: 1,
  'units-per-em': 'unitsPerEm',
  unselectable: 0,
  vAlphabetic: 1,
  'v-alphabetic': 'vAlphabetic',
  values: 0,
  vectorEffect: 1,
  'vector-effect': 'vectorEffect',
  version: 0,
  vertAdvY: 1,
  'vert-adv-y': 'vertAdvY',
  vertOriginX: 1,
  'vert-origin-x': 'vertOriginX',
  vertOriginY: 1,
  'vert-origin-y': 'vertOriginY',
  vHanging: 1,
  'v-hanging': 'vHanging',
  vIdeographic: 1,
  'v-ideographic': 'vIdeographic',
  viewBox: 1,
  viewTarget: 1,
  visibility: 0,
  vMathematical: 1,
  'v-mathematical': 'vMathematical',
  vocab: 0,
  widths: 0,
  wordSpacing: 1,
  'word-spacing': 'wordSpacing',
  writingMode: 1,
  'writing-mode': 'writingMode',
  x1: 0,
  x2: 0,
  x: 0,
  xChannelSelector: 1,
  xHeight: 1,
  'x-height': 'xHeight',
  xlinkActuate: 1,
  'xlink:actuate': 'xlinkActuate',
  xlinkArcrole: 1,
  'xlink:arcrole': 'xlinkArcrole',
  xlinkHref: 1,
  'xlink:href': 'xlinkHref',
  xlinkRole: 1,
  'xlink:role': 'xlinkRole',
  xlinkShow: 1,
  'xlink:show': 'xlinkShow',
  xlinkTitle: 1,
  'xlink:title': 'xlinkTitle',
  xlinkType: 1,
  'xlink:type': 'xlinkType',
  xmlBase: 1,
  'xml:base': 'xmlBase',
  xmlLang: 1,
  'xml:lang': 'xmlLang',
  xmlns: 0,
  'xml:space': 'xmlSpace',
  xmlnsXlink: 1,
  'xmlns:xlink': 'xmlnsXlink',
  xmlSpace: 1,
  y1: 0,
  y2: 0,
  y: 0,
  yChannelSelector: 1,
  z: 0,
  zoomAndPan: 1
};

/***/ }),

/***/ 75288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ focusManager; }
/* harmony export */ });
/* unused harmony export FocusManager */
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76282);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86285);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40639);



var FocusManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(FocusManager, _Subscribable);
  function FocusManager() {
    var _this;
    _this = _Subscribable.call(this) || this;
    _this.setup = function (onFocus) {
      var _window;
      if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onFocus();
        }; // Listen to visibillitychange and focus

        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }
    };
    return _this;
  }
  var _proto = FocusManager.prototype;
  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };
  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;
      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };
  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
      _this2 = this;
    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (focused) {
      if (typeof focused === 'boolean') {
        _this2.setFocused(focused);
      } else {
        _this2.onFocus();
      }
    });
  };
  _proto.setFocused = function setFocused(focused) {
    this.focused = focused;
    if (focused) {
      this.onFocus();
    }
  };
  _proto.onFocus = function onFocus() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };
  _proto.isFocused = function isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native

    if (typeof document === 'undefined') {
      return true;
    }
    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  };
  return FocusManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);
var focusManager = new FocusManager();

/***/ }),

/***/ 20721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _queryClient__WEBPACK_IMPORTED_MODULE_0__.S; }
/* harmony export */ });
/* harmony import */ var _queryClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54112);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23243);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useInfiniteQuery")) __webpack_require__.d(__webpack_exports__, { "useInfiniteQuery": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useInfiniteQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useMutation")) __webpack_require__.d(__webpack_exports__, { "useMutation": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useMutation; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useQueryClient")) __webpack_require__.d(__webpack_exports__, { "useQueryClient": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useQueryClient; } });














 // Types



/***/ }),

/***/ 90330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gm": function() { return /* binding */ infiniteQueryBehavior; },
/* harmony export */   "Qy": function() { return /* binding */ hasNextPage; },
/* harmony export */   "ZF": function() { return /* binding */ hasPreviousPage; }
/* harmony export */ });
/* unused harmony exports getNextPageParam, getPreviousPageParam */
/* harmony import */ var _retryer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46955);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40639);


function infiniteQueryBehavior() {
  return {
    onFetch: function onFetch(context) {
      context.fetchFn = function () {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
        var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        var abortController = (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAbortController */ .G9)();
        var abortSignal = abortController == null ? void 0 : abortController.signal;
        var newPageParams = oldPageParams;
        var cancelled = false; // Get query function

        var queryFn = context.options.queryFn || function () {
          return Promise.reject('Missing queryFn');
        };
        var buildNewPages = function buildNewPages(pages, param, page, previous) {
          newPageParams = previous ? [param].concat(newPageParams) : [].concat(newPageParams, [param]);
          return previous ? [page].concat(pages) : [].concat(pages, [page]);
        }; // Create function to fetch a page

        var fetchPage = function fetchPage(pages, manual, param, previous) {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }
          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }
          var queryFnContext = {
            queryKey: context.queryKey,
            signal: abortSignal,
            pageParam: param,
            meta: context.meta
          };
          var queryFnResult = queryFn(queryFnContext);
          var promise = Promise.resolve(queryFnResult).then(function (page) {
            return buildNewPages(pages, param, page, previous);
          });
          if ((0,_retryer__WEBPACK_IMPORTED_MODULE_1__/* .isCancelable */ .LE)(queryFnResult)) {
            var promiseAsAny = promise;
            promiseAsAny.cancel = queryFnResult.cancel;
          }
          return promise;
        };
        var promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
          var manual = typeof pageParam !== 'undefined';
          var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
          promise = fetchPage(oldPages, manual, param);
        } // Fetch previous page?
        else if (isFetchingPreviousPage) {
          var _manual = typeof pageParam !== 'undefined';
          var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);
          promise = fetchPage(oldPages, _manual, _param, true);
        } // Refetch pages
        else {
          (function () {
            newPageParams = [];
            var manual = typeof context.options.getNextPageParam === 'undefined';
            var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

            promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

            var _loop = function _loop(i) {
              promise = promise.then(function (pages) {
                var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                if (shouldFetchNextPage) {
                  var _param2 = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);
                  return fetchPage(pages, manual, _param2);
                }
                return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
              });
            };
            for (var i = 1; i < oldPages.length; i++) {
              _loop(i);
            }
          })();
        }
        var finalPromise = promise.then(function (pages) {
          return {
            pages: pages,
            pageParams: newPageParams
          };
        });
        var finalPromiseAsAny = finalPromise;
        finalPromiseAsAny.cancel = function () {
          cancelled = true;
          abortController == null ? void 0 : abortController.abort();
          if ((0,_retryer__WEBPACK_IMPORTED_MODULE_1__/* .isCancelable */ .LE)(promise)) {
            promise.cancel();
          }
        };
        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */

function hasNextPage(options, pages) {
  if (options.getNextPageParam && Array.isArray(pages)) {
    var nextPageParam = getNextPageParam(options, pages);
    return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
  }
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */

function hasPreviousPage(options, pages) {
  if (options.getPreviousPageParam && Array.isArray(pages)) {
    var previousPageParam = getPreviousPageParam(options, pages);
    return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
  }
}

/***/ }),

/***/ 571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ setLogger; },
/* harmony export */   "j": function() { return /* binding */ getLogger; }
/* harmony export */ });
// TYPES
// FUNCTIONS
var logger = console;
function getLogger() {
  return logger;
}
function setLogger(newLogger) {
  logger = newLogger;
}

/***/ }),

/***/ 35407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getDefaultState; },
/* harmony export */   "m": function() { return /* binding */ Mutation; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65260);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(571);
/* harmony import */ var _notifyManager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5906);
/* harmony import */ var _retryer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46955);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40639);




 // TYPES

// CLASS
var Mutation = /*#__PURE__*/function () {
  function Mutation(config) {
    this.options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, config.defaultOptions, config.options);
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.meta = config.meta;
  }
  var _proto = Mutation.prototype;
  _proto.setState = function setState(state) {
    this.dispatch({
      type: 'setState',
      state: state
    });
  };
  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
    }
  };
  _proto.removeObserver = function removeObserver(observer) {
    this.observers = this.observers.filter(function (x) {
      return x !== observer;
    });
  };
  _proto.cancel = function cancel() {
    if (this.retryer) {
      this.retryer.cancel();
      return this.retryer.promise.then(_utils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT).catch(_utils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT);
    }
    return Promise.resolve();
  };
  _proto.continue = function _continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }
    return this.execute();
  };
  _proto.execute = function execute() {
    var _this = this;
    var data;
    var restored = this.state.status === 'loading';
    var promise = Promise.resolve();
    if (!restored) {
      this.dispatch({
        type: 'loading',
        variables: this.options.variables
      });
      promise = promise.then(function () {
        // Notify cache callback
        _this.mutationCache.config.onMutate == null ? void 0 : _this.mutationCache.config.onMutate(_this.state.variables, _this);
      }).then(function () {
        return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
      }).then(function (context) {
        if (context !== _this.state.context) {
          _this.dispatch({
            type: 'loading',
            context: context,
            variables: _this.state.variables
          });
        }
      });
    }
    return promise.then(function () {
      return _this.executeMutation();
    }).then(function (result) {
      data = result; // Notify cache callback

      _this.mutationCache.config.onSuccess == null ? void 0 : _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
    }).then(function () {
      return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
    }).then(function () {
      return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
    }).then(function () {
      _this.dispatch({
        type: 'success',
        data: data
      });
      return data;
    }).catch(function (error) {
      // Notify cache callback
      _this.mutationCache.config.onError == null ? void 0 : _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error

      (0,_logger__WEBPACK_IMPORTED_MODULE_2__/* .getLogger */ .j)().error(error);
      return Promise.resolve().then(function () {
        return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
      }).then(function () {
        return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
      }).then(function () {
        _this.dispatch({
          type: 'error',
          error: error
        });
        throw error;
      });
    });
  };
  _proto.executeMutation = function executeMutation() {
    var _this2 = this,
      _this$options$retry;
    this.retryer = new _retryer__WEBPACK_IMPORTED_MODULE_3__/* .Retryer */ .m4({
      fn: function fn() {
        if (!_this2.options.mutationFn) {
          return Promise.reject('No mutationFn found');
        }
        return _this2.options.mutationFn(_this2.state.variables);
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay
    });
    return this.retryer.promise;
  };
  _proto.dispatch = function dispatch(action) {
    var _this3 = this;
    this.state = reducer(this.state, action);
    _notifyManager__WEBPACK_IMPORTED_MODULE_4__/* .notifyManager.batch */ .V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onMutationUpdate(action);
      });
      _this3.mutationCache.notify(_this3);
    });
  };
  return Mutation;
}();
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}
function reducer(state, action) {
  switch (action.type) {
    case 'failed':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        failureCount: state.failureCount + 1
      });
    case 'pause':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        isPaused: true
      });
    case 'continue':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        isPaused: false
      });
    case 'loading':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        context: action.context,
        data: undefined,
        error: null,
        isPaused: false,
        status: 'loading',
        variables: action.variables
      });
    case 'success':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        data: action.data,
        error: null,
        status: 'success',
        isPaused: false
      });
    case 'error':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        data: undefined,
        error: action.error,
        failureCount: state.failureCount + 1,
        isPaused: false,
        status: 'error'
      });
    case 'setState':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, action.state);
    default:
      return state;
  }
}

/***/ }),

/***/ 5906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ notifyManager; }
/* harmony export */ });
/* unused harmony export NotifyManager */
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40639);
 // TYPES

// CLASS
var NotifyManager = /*#__PURE__*/function () {
  function NotifyManager() {
    this.queue = [];
    this.transactions = 0;
    this.notifyFn = function (callback) {
      callback();
    };
    this.batchNotifyFn = function (callback) {
      callback();
    };
  }
  var _proto = NotifyManager.prototype;
  _proto.batch = function batch(callback) {
    var result;
    this.transactions++;
    try {
      result = callback();
    } finally {
      this.transactions--;
      if (!this.transactions) {
        this.flush();
      }
    }
    return result;
  };
  _proto.schedule = function schedule(callback) {
    var _this = this;
    if (this.transactions) {
      this.queue.push(callback);
    } else {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this.notifyFn(callback);
      });
    }
  }
  /**
   * All calls to the wrapped function will be batched.
   */;
  _proto.batchCalls = function batchCalls(callback) {
    var _this2 = this;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this2.schedule(function () {
        callback.apply(void 0, args);
      });
    };
  };
  _proto.flush = function flush() {
    var _this3 = this;
    var queue = this.queue;
    this.queue = [];
    if (queue.length) {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this3.batchNotifyFn(function () {
          queue.forEach(function (callback) {
            _this3.notifyFn(callback);
          });
        });
      });
    }
  }
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */;
  _proto.setNotifyFunction = function setNotifyFunction(fn) {
    this.notifyFn = fn;
  }
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */;
  _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
    this.batchNotifyFn = fn;
  };
  return NotifyManager;
}(); // SINGLETON

var notifyManager = new NotifyManager();

/***/ }),

/***/ 20893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ onlineManager; }
/* harmony export */ });
/* unused harmony export OnlineManager */
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76282);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86285);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40639);



var OnlineManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OnlineManager, _Subscribable);
  function OnlineManager() {
    var _this;
    _this = _Subscribable.call(this) || this;
    _this.setup = function (onOnline) {
      var _window;
      if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onOnline();
        }; // Listen to online

        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      }
    };
    return _this;
  }
  var _proto = OnlineManager.prototype;
  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };
  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;
      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };
  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
      _this2 = this;
    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (online) {
      if (typeof online === 'boolean') {
        _this2.setOnline(online);
      } else {
        _this2.onOnline();
      }
    });
  };
  _proto.setOnline = function setOnline(online) {
    this.online = online;
    if (online) {
      this.onOnline();
    }
  };
  _proto.onOnline = function onOnline() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };
  _proto.isOnline = function isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }
    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }
    return navigator.onLine;
  };
  return OnlineManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);
var onlineManager = new OnlineManager();

/***/ }),

/***/ 54112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ QueryClient; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(40639);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(76282);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(5906);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(571);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(46955);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/query.js




 // TYPES

// CLASS
var Query = /*#__PURE__*/function () {
  function Query(config) {
    this.abortSignalConsumed = false;
    this.hadObservers = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || this.getDefaultState(this.options);
    this.state = this.initialState;
    this.meta = config.meta;
    this.scheduleGc();
  }
  var _proto = Query.prototype;
  _proto.setOptions = function setOptions(options) {
    var _this$options$cacheTi;
    this.options = (0,esm_extends/* default */.Z)({}, this.defaultOptions, options);
    this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set

    this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 5 * 60 * 1000);
  };
  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };
  _proto.scheduleGc = function scheduleGc() {
    var _this = this;
    this.clearGcTimeout();
    if ((0,utils/* isValidTimeout */.PN)(this.cacheTime)) {
      this.gcTimeout = setTimeout(function () {
        _this.optionalRemove();
      }, this.cacheTime);
    }
  };
  _proto.clearGcTimeout = function clearGcTimeout() {
    if (this.gcTimeout) {
      clearTimeout(this.gcTimeout);
      this.gcTimeout = undefined;
    }
  };
  _proto.optionalRemove = function optionalRemove() {
    if (!this.observers.length) {
      if (this.state.isFetching) {
        if (this.hadObservers) {
          this.scheduleGc();
        }
      } else {
        this.cache.remove(this);
      }
    }
  };
  _proto.setData = function setData(updater, options) {
    var _this$options$isDataE, _this$options;
    var prevData = this.state.data; // Get the new data

    var data = (0,utils/* functionalUpdate */.SE)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`

    if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) {
      data = prevData;
    } else if (this.options.structuralSharing !== false) {
      // Structurally share data between prev and new data if needed
      data = (0,utils/* replaceEqualDeep */.Q$)(prevData, data);
    } // Set data and mark it as cached

    this.dispatch({
      data: data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt
    });
    return data;
  };
  _proto.setState = function setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state: state,
      setStateOptions: setStateOptions
    });
  };
  _proto.cancel = function cancel(options) {
    var _this$retryer;
    var promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT) : Promise.resolve();
  };
  _proto.destroy = function destroy() {
    this.clearGcTimeout();
    this.cancel({
      silent: true
    });
  };
  _proto.reset = function reset() {
    this.destroy();
    this.setState(this.initialState);
  };
  _proto.isActive = function isActive() {
    return this.observers.some(function (observer) {
      return observer.options.enabled !== false;
    });
  };
  _proto.isFetching = function isFetching() {
    return this.state.isFetching;
  };
  _proto.isStale = function isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
      return observer.getCurrentResult().isStale;
    });
  };
  _proto.isStaleByTime = function isStaleByTime(staleTime) {
    if (staleTime === void 0) {
      staleTime = 0;
    }
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0,utils/* timeUntilStale */.Kp)(this.state.dataUpdatedAt, staleTime);
  };
  _proto.onFocus = function onFocus() {
    var _this$retryer2;
    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnWindowFocus();
    });
    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused

    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  };
  _proto.onOnline = function onOnline() {
    var _this$retryer3;
    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnReconnect();
    });
    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused

    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  };
  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
      this.hadObservers = true; // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer: observer
      });
    }
  };
  _proto.removeObserver = function removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(function (x) {
        return x !== observer;
      });
      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.retryer.isTransportCancelable || this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }
        if (this.cacheTime) {
          this.scheduleGc();
        } else {
          this.cache.remove(this);
        }
      }
      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer: observer
      });
    }
  };
  _proto.getObserversCount = function getObserversCount() {
    return this.observers.length;
  };
  _proto.invalidate = function invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  };
  _proto.fetch = function fetch(options, fetchOptions) {
    var _this2 = this,
      _this$options$behavio,
      _context$fetchOptions,
      _abortController$abor;
    if (this.state.isFetching) {
      if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used

    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.

    if (!this.options.queryFn) {
      var observer = this.observers.find(function (x) {
        return x.options.queryFn;
      });
      if (observer) {
        this.setOptions(observer.options);
      }
    }
    var queryKey = (0,utils/* ensureQueryKeyArray */.mc)(this.queryKey);
    var abortController = (0,utils/* getAbortController */.G9)(); // Create query function context

    var queryFnContext = {
      queryKey: queryKey,
      pageParam: undefined,
      meta: this.meta
    };
    Object.defineProperty(queryFnContext, 'signal', {
      enumerable: true,
      get: function get() {
        if (abortController) {
          _this2.abortSignalConsumed = true;
          return abortController.signal;
        }
        return undefined;
      }
    }); // Create fetch function

    var fetchFn = function fetchFn() {
      if (!_this2.options.queryFn) {
        return Promise.reject('Missing queryFn');
      }
      _this2.abortSignalConsumed = false;
      return _this2.options.queryFn(queryFnContext);
    }; // Trigger behavior hook

    var context = {
      fetchOptions: fetchOptions,
      options: this.options,
      queryKey: queryKey,
      state: this.state,
      fetchFn: fetchFn,
      meta: this.meta
    };
    if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
      var _this$options$behavio2;
      (_this$options$behavio2 = this.options.behavior) == null ? void 0 : _this$options$behavio2.onFetch(context);
    } // Store state in case the current fetch needs to be reverted

    this.revertState = this.state; // Set to fetching state if not already in it

    if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;
      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    } // Try to fetch the data

    this.retryer = new retryer/* Retryer */.m4({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
      onSuccess: function onSuccess(data) {
        _this2.setData(data); // Notify cache callback

        _this2.cache.config.onSuccess == null ? void 0 : _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0

        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onError: function onError(error) {
        // Optimistically update state if needed
        if (!((0,retryer/* isCancelledError */.DV)(error) && error.silent)) {
          _this2.dispatch({
            type: 'error',
            error: error
          });
        }
        if (!(0,retryer/* isCancelledError */.DV)(error)) {
          // Notify cache callback
          _this2.cache.config.onError == null ? void 0 : _this2.cache.config.onError(error, _this2); // Log error

          (0,logger/* getLogger */.j)().error(error);
        } // Remove query after fetching if cache time is 0

        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay
    });
    this.promise = this.retryer.promise;
    return this.promise;
  };
  _proto.dispatch = function dispatch(action) {
    var _this3 = this;
    this.state = this.reducer(this.state, action);
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onQueryUpdate(action);
      });
      _this3.cache.notify({
        query: _this3,
        type: 'queryUpdated',
        action: action
      });
    });
  };
  _proto.getDefaultState = function getDefaultState(options) {
    var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    var hasInitialData = typeof options.initialData !== 'undefined';
    var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    var hasData = typeof data !== 'undefined';
    return {
      data: data,
      dataUpdateCount: 0,
      dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
      error: null,
      errorUpdateCount: 0,
      errorUpdatedAt: 0,
      fetchFailureCount: 0,
      fetchMeta: null,
      isFetching: false,
      isInvalidated: false,
      isPaused: false,
      status: hasData ? 'success' : 'idle'
    };
  };
  _proto.reducer = function reducer(state, action) {
    var _action$meta, _action$dataUpdatedAt;
    switch (action.type) {
      case 'failed':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: state.fetchFailureCount + 1
        });
      case 'pause':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: true
        });
      case 'continue':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: false
        });
      case 'fetch':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: 0,
          fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
          isFetching: true,
          isPaused: false
        }, !state.dataUpdatedAt && {
          error: null,
          status: 'loading'
        });
      case 'success':
        return (0,esm_extends/* default */.Z)({}, state, {
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
          error: null,
          fetchFailureCount: 0,
          isFetching: false,
          isInvalidated: false,
          isPaused: false,
          status: 'success'
        });
      case 'error':
        var error = action.error;
        if ((0,retryer/* isCancelledError */.DV)(error) && error.revert && this.revertState) {
          return (0,esm_extends/* default */.Z)({}, this.revertState);
        }
        return (0,esm_extends/* default */.Z)({}, state, {
          error: error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          isFetching: false,
          isPaused: false,
          status: 'error'
        });
      case 'invalidate':
        return (0,esm_extends/* default */.Z)({}, state, {
          isInvalidated: true
        });
      case 'setState':
        return (0,esm_extends/* default */.Z)({}, state, action.state);
      default:
        return state;
    }
  };
  return Query;
}();
// EXTERNAL MODULE: ./node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(86285);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryCache.js





// CLASS
var QueryCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryCache, _Subscribable);
  function QueryCache(config) {
    var _this;
    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.queries = [];
    _this.queriesMap = {};
    return _this;
  }
  var _proto = QueryCache.prototype;
  _proto.build = function build(client, options, state) {
    var _options$queryHash;
    var queryKey = options.queryKey;
    var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0,utils/* hashQueryKeyByOptions */.Rm)(queryKey, options);
    var query = this.get(queryHash);
    if (!query) {
      query = new Query({
        cache: this,
        queryKey: queryKey,
        queryHash: queryHash,
        options: client.defaultQueryOptions(options),
        state: state,
        defaultOptions: client.getQueryDefaults(queryKey),
        meta: options.meta
      });
      this.add(query);
    }
    return query;
  };
  _proto.add = function add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'queryAdded',
        query: query
      });
    }
  };
  _proto.remove = function remove(query) {
    var queryInMap = this.queriesMap[query.queryHash];
    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(function (x) {
        return x !== query;
      });
      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }
      this.notify({
        type: 'queryRemoved',
        query: query
      });
    }
  };
  _proto.clear = function clear() {
    var _this2 = this;
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.queries.forEach(function (query) {
        _this2.remove(query);
      });
    });
  };
  _proto.get = function get(queryHash) {
    return this.queriesMap[queryHash];
  };
  _proto.getAll = function getAll() {
    return this.queries;
  };
  _proto.find = function find(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
      filters = _parseFilterArgs[0];
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }
    return this.queries.find(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    });
  };
  _proto.findAll = function findAll(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
      filters = _parseFilterArgs2[0];
    return Object.keys(filters).length > 0 ? this.queries.filter(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    }) : this.queries;
  };
  _proto.notify = function notify(event) {
    var _this3 = this;
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(event);
      });
    });
  };
  _proto.onFocus = function onFocus() {
    var _this4 = this;
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this4.queries.forEach(function (query) {
        query.onFocus();
      });
    });
  };
  _proto.onOnline = function onOnline() {
    var _this5 = this;
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queries.forEach(function (query) {
        query.onOnline();
      });
    });
  };
  return QueryCache;
}(subscribable/* Subscribable */.l);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/mutation.js
var core_mutation = __webpack_require__(35407);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/mutationCache.js




 // TYPES

// CLASS
var MutationCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(MutationCache, _Subscribable);
  function MutationCache(config) {
    var _this;
    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }
  var _proto = MutationCache.prototype;
  _proto.build = function build(client, options, state) {
    var mutation = new core_mutation/* Mutation */.m({
      mutationCache: this,
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state: state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
      meta: options.meta
    });
    this.add(mutation);
    return mutation;
  };
  _proto.add = function add(mutation) {
    this.mutations.push(mutation);
    this.notify(mutation);
  };
  _proto.remove = function remove(mutation) {
    this.mutations = this.mutations.filter(function (x) {
      return x !== mutation;
    });
    mutation.cancel();
    this.notify(mutation);
  };
  _proto.clear = function clear() {
    var _this2 = this;
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.mutations.forEach(function (mutation) {
        _this2.remove(mutation);
      });
    });
  };
  _proto.getAll = function getAll() {
    return this.mutations;
  };
  _proto.find = function find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }
    return this.mutations.find(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };
  _proto.findAll = function findAll(filters) {
    return this.mutations.filter(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };
  _proto.notify = function notify(mutation) {
    var _this3 = this;
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(mutation);
      });
    });
  };
  _proto.onFocus = function onFocus() {
    this.resumePausedMutations();
  };
  _proto.onOnline = function onOnline() {
    this.resumePausedMutations();
  };
  _proto.resumePausedMutations = function resumePausedMutations() {
    var pausedMutations = this.mutations.filter(function (x) {
      return x.state.isPaused;
    });
    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return pausedMutations.reduce(function (promise, mutation) {
        return promise.then(function () {
          return mutation.continue().catch(utils/* noop */.ZT);
        });
      }, Promise.resolve());
    });
  };
  return MutationCache;
}(subscribable/* Subscribable */.l);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(75288);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/onlineManager.js
var onlineManager = __webpack_require__(20893);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/infiniteQueryBehavior.js
var infiniteQueryBehavior = __webpack_require__(90330);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryClient.js








// CLASS
var QueryClient = /*#__PURE__*/function () {
  function QueryClient(config) {
    if (config === void 0) {
      config = {};
    }
    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
  }
  var _proto = QueryClient.prototype;
  _proto.mount = function mount() {
    var _this = this;
    this.unsubscribeFocus = focusManager/* focusManager.subscribe */.j.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onFocus();
        _this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager/* onlineManager.subscribe */.N.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onOnline();
        _this.queryCache.onOnline();
      }
    });
  };
  _proto.unmount = function unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;
    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
  };
  _proto.isFetching = function isFetching(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
      filters = _parseFilterArgs[0];
    filters.fetching = true;
    return this.queryCache.findAll(filters).length;
  };
  _proto.isMutating = function isMutating(filters) {
    return this.mutationCache.findAll((0,esm_extends/* default */.Z)({}, filters, {
      fetching: true
    })).length;
  };
  _proto.getQueryData = function getQueryData(queryKey, filters) {
    var _this$queryCache$find;
    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  };
  _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref) {
      var queryKey = _ref.queryKey,
        state = _ref.state;
      var data = state.data;
      return [queryKey, data];
    });
  };
  _proto.setQueryData = function setQueryData(queryKey, updater, options) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(queryKey);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(updater, options);
  };
  _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
    var _this2 = this;
    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref2) {
        var queryKey = _ref2.queryKey;
        return [queryKey, _this2.setQueryData(queryKey, updater, options)];
      });
    });
  };
  _proto.getQueryState = function getQueryState(queryKey, filters) {
    var _this$queryCache$find2;
    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  };
  _proto.removeQueries = function removeQueries(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
      filters = _parseFilterArgs2[0];
    var queryCache = this.queryCache;
    notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        queryCache.remove(query);
      });
    });
  };
  _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
    var _this3 = this;
    var _parseFilterArgs3 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
      filters = _parseFilterArgs3[0],
      options = _parseFilterArgs3[1];
    var queryCache = this.queryCache;
    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      active: true
    });
    return notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        query.reset();
      });
      return _this3.refetchQueries(refetchFilters, options);
    });
  };
  _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
    var _this4 = this;
    var _parseFilterArgs4 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
      filters = _parseFilterArgs4[0],
      _parseFilterArgs4$ = _parseFilterArgs4[1],
      cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;
    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }
    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this4.queryCache.findAll(filters).map(function (query) {
        return query.cancel(cancelOptions);
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };
  _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
    var _ref3,
      _filters$refetchActiv,
      _filters$refetchInact,
      _this5 = this;
    var _parseFilterArgs5 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
      filters = _parseFilterArgs5[0],
      options = _parseFilterArgs5[1];
    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      // if filters.refetchActive is not provided and filters.active is explicitly false,
      // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
      active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
      inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
    });
    return notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queryCache.findAll(filters).forEach(function (query) {
        query.invalidate();
      });
      return _this5.refetchQueries(refetchFilters, options);
    });
  };
  _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
    var _this6 = this;
    var _parseFilterArgs6 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
      filters = _parseFilterArgs6[0],
      options = _parseFilterArgs6[1];
    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this6.queryCache.findAll(filters).map(function (query) {
        return query.fetch(undefined, (0,esm_extends/* default */.Z)({}, options, {
          meta: {
            refetchPage: filters == null ? void 0 : filters.refetchPage
          }
        }));
      });
    });
    var promise = Promise.all(promises).then(utils/* noop */.ZT);
    if (!(options == null ? void 0 : options.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }
    return promise;
  };
  _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }
    var query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  };
  _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };
  _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    parsedOptions.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return this.fetchQuery(parsedOptions);
  };
  _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };
  _proto.cancelMutations = function cancelMutations() {
    var _this7 = this;
    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this7.mutationCache.getAll().map(function (mutation) {
        return mutation.cancel();
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };
  _proto.resumePausedMutations = function resumePausedMutations() {
    return this.getMutationCache().resumePausedMutations();
  };
  _proto.executeMutation = function executeMutation(options) {
    return this.mutationCache.build(this, options).execute();
  };
  _proto.getQueryCache = function getQueryCache() {
    return this.queryCache;
  };
  _proto.getMutationCache = function getMutationCache() {
    return this.mutationCache;
  };
  _proto.getDefaultOptions = function getDefaultOptions() {
    return this.defaultOptions;
  };
  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };
  _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
    var result = this.queryDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(queryKey) === (0,utils/* hashQueryKey */.yF)(x.queryKey);
    });
    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey: queryKey,
        defaultOptions: options
      });
    }
  };
  _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
    var _this$queryDefaults$f;
    return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(queryKey, x.queryKey);
    })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
  };
  _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
    var result = this.mutationDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(mutationKey) === (0,utils/* hashQueryKey */.yF)(x.mutationKey);
    });
    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey: mutationKey,
        defaultOptions: options
      });
    }
  };
  _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
    var _this$mutationDefault;
    return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(mutationKey, x.mutationKey);
    })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
  };
  _proto.defaultQueryOptions = function defaultQueryOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }
    var defaultedOptions = (0,esm_extends/* default */.Z)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
      _defaulted: true
    });
    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = (0,utils/* hashQueryKeyByOptions */.Rm)(defaultedOptions.queryKey, defaultedOptions);
    }
    return defaultedOptions;
  };
  _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
    return this.defaultQueryOptions(options);
  };
  _proto.defaultMutationOptions = function defaultMutationOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }
    return (0,esm_extends/* default */.Z)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
      _defaulted: true
    });
  };
  _proto.clear = function clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  };
  return QueryClient;
}();

/***/ }),

/***/ 46955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ isCancelledError; },
/* harmony export */   "LE": function() { return /* binding */ isCancelable; },
/* harmony export */   "m4": function() { return /* binding */ Retryer; }
/* harmony export */ });
/* unused harmony export CancelledError */
/* harmony import */ var _focusManager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75288);
/* harmony import */ var _onlineManager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20893);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40639);



function defaultRetryDelay(failureCount) {
  return Math.min(1000 * Math.pow(2, failureCount), 30000);
}
function isCancelable(value) {
  return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var CancelledError = function CancelledError(options) {
  this.revert = options == null ? void 0 : options.revert;
  this.silent = options == null ? void 0 : options.silent;
};
function isCancelledError(value) {
  return value instanceof CancelledError;
} // CLASS

var Retryer = function Retryer(config) {
  var _this = this;
  var cancelRetry = false;
  var cancelFn;
  var continueFn;
  var promiseResolve;
  var promiseReject;
  this.abort = config.abort;
  this.cancel = function (cancelOptions) {
    return cancelFn == null ? void 0 : cancelFn(cancelOptions);
  };
  this.cancelRetry = function () {
    cancelRetry = true;
  };
  this.continueRetry = function () {
    cancelRetry = false;
  };
  this.continue = function () {
    return continueFn == null ? void 0 : continueFn();
  };
  this.failureCount = 0;
  this.isPaused = false;
  this.isResolved = false;
  this.isTransportCancelable = false;
  this.promise = new Promise(function (outerResolve, outerReject) {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });
  var resolve = function resolve(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };
  var reject = function reject(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };
  var pause = function pause() {
    return new Promise(function (continueResolve) {
      continueFn = continueResolve;
      _this.isPaused = true;
      config.onPause == null ? void 0 : config.onPause();
    }).then(function () {
      continueFn = undefined;
      _this.isPaused = false;
      config.onContinue == null ? void 0 : config.onContinue();
    });
  }; // Create loop function

  var run = function run() {
    // Do nothing if already resolved
    if (_this.isResolved) {
      return;
    }
    var promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    } // Create callback to cancel this fetch

    cancelFn = function cancelFn(cancelOptions) {
      if (!_this.isResolved) {
        reject(new CancelledError(cancelOptions));
        _this.abort == null ? void 0 : _this.abort(); // Cancel transport if supported

        if (isCancelable(promiseOrValue)) {
          try {
            promiseOrValue.cancel();
          } catch (_unused) {}
        }
      }
    }; // Check if the transport layer support cancellation

    _this.isTransportCancelable = isCancelable(promiseOrValue);
    Promise.resolve(promiseOrValue).then(resolve).catch(function (error) {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (_this.isResolved) {
        return;
      } // Do we need to retry the request?

      var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
      var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);
      if (cancelRetry || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }
      _this.failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(_this.failureCount, error); // Delay

      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .sleep */ .Gh)(delay) // Pause if the document is not visible or when the device is offline
      .then(function () {
        if (!_focusManager__WEBPACK_IMPORTED_MODULE_1__/* .focusManager.isFocused */ .j.isFocused() || !_onlineManager__WEBPACK_IMPORTED_MODULE_2__/* .onlineManager.isOnline */ .N.isOnline()) {
          return pause();
        }
      }).then(function () {
        if (cancelRetry) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop

  run();
};

/***/ }),

/***/ 86285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Subscribable; }
/* harmony export */ });
var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    this.listeners = [];
  }
  var _proto = Subscribable.prototype;
  _proto.subscribe = function subscribe(listener) {
    var _this = this;
    var callback = listener || function () {
      return undefined;
    };
    this.listeners.push(callback);
    this.onSubscribe();
    return function () {
      _this.listeners = _this.listeners.filter(function (x) {
        return x !== callback;
      });
      _this.onUnsubscribe();
    };
  };
  _proto.hasListeners = function hasListeners() {
    return this.listeners.length > 0;
  };
  _proto.onSubscribe = function onSubscribe() {// Do nothing
  };
  _proto.onUnsubscribe = function onUnsubscribe() {// Do nothing
  };
  return Subscribable;
}();

/***/ }),

/***/ 23243:
/***/ (function() {



/***/ }),

/***/ 40639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ scheduleMicrotask; },
/* harmony export */   "G9": function() { return /* binding */ getAbortController; },
/* harmony export */   "Gh": function() { return /* binding */ sleep; },
/* harmony export */   "I6": function() { return /* binding */ parseFilterArgs; },
/* harmony export */   "Kp": function() { return /* binding */ timeUntilStale; },
/* harmony export */   "PN": function() { return /* binding */ isValidTimeout; },
/* harmony export */   "Q$": function() { return /* binding */ replaceEqualDeep; },
/* harmony export */   "Rm": function() { return /* binding */ hashQueryKeyByOptions; },
/* harmony export */   "SE": function() { return /* binding */ functionalUpdate; },
/* harmony export */   "VS": function() { return /* binding */ shallowEqualObjects; },
/* harmony export */   "X7": function() { return /* binding */ matchMutation; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "_v": function() { return /* binding */ parseQueryArgs; },
/* harmony export */   "_x": function() { return /* binding */ matchQuery; },
/* harmony export */   "lV": function() { return /* binding */ parseMutationArgs; },
/* harmony export */   "mc": function() { return /* binding */ ensureQueryKeyArray; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "to": function() { return /* binding */ partialMatchKey; },
/* harmony export */   "yF": function() { return /* binding */ hashQueryKey; }
/* harmony export */ });
/* unused harmony exports difference, replaceAt, parseMutationFilterArgs, mapQueryStatusFilter, stableValueHash, partialDeepEqual, isPlainObject, isQueryKey, isError */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65260);

// TYPES
// UTILS
var isServer = typeof window === 'undefined';
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function ensureQueryKeyArray(value) {
  return Array.isArray(value) ? value : [value];
}
function difference(array1, array2) {
  return array1.filter(function (x) {
    return array2.indexOf(x) === -1;
  });
}
function replaceAt(array, index, value) {
  var copy = array.slice(0);
  copy[index] = value;
  return copy;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }
  if (typeof arg2 === 'function') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg3, {
      queryKey: arg1,
      queryFn: arg2
    });
  }
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  });
}
function parseMutationArgs(arg1, arg2, arg3) {
  if (isQueryKey(arg1)) {
    if (typeof arg2 === 'function') {
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg3, {
        mutationKey: arg1,
        mutationFn: arg2
      });
    }
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
      mutationKey: arg1
    });
  }
  if (typeof arg1 === 'function') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
      mutationFn: arg1
    });
  }
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg1);
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  }), arg3] : [arg1 || {}, arg2];
}
function parseMutationFilterArgs(arg1, arg2) {
  return isQueryKey(arg1) ? _extends({}, arg2, {
    mutationKey: arg1
  }) : arg1;
}
function mapQueryStatusFilter(active, inactive) {
  if (active === true && inactive === true || active == null && inactive == null) {
    return 'all';
  } else if (active === false && inactive === false) {
    return 'none';
  } else {
    // At this point, active|inactive can only be true|false or false|true
    // so, when only one value is provided, the missing one has to be the negated value
    var isActive = active != null ? active : !inactive;
    return isActive ? 'active' : 'inactive';
  }
}
function matchQuery(filters, query) {
  var active = filters.active,
    exact = filters.exact,
    fetching = filters.fetching,
    inactive = filters.inactive,
    predicate = filters.predicate,
    queryKey = filters.queryKey,
    stale = filters.stale;
  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }
  var queryStatusFilter = mapQueryStatusFilter(active, inactive);
  if (queryStatusFilter === 'none') {
    return false;
  } else if (queryStatusFilter !== 'all') {
    var isActive = query.isActive();
    if (queryStatusFilter === 'active' && !isActive) {
      return false;
    }
    if (queryStatusFilter === 'inactive' && isActive) {
      return false;
    }
  }
  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }
  if (typeof fetching === 'boolean' && query.isFetching() !== fetching) {
    return false;
  }
  if (predicate && !predicate(query)) {
    return false;
  }
  return true;
}
function matchMutation(filters, mutation) {
  var exact = filters.exact,
    fetching = filters.fetching,
    predicate = filters.predicate,
    mutationKey = filters.mutationKey;
  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }
    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }
  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }
  if (predicate && !predicate(mutation)) {
    return false;
  }
  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 */

function hashQueryKey(queryKey) {
  var asArray = ensureQueryKeyArray(queryKey);
  return stableValueHash(asArray);
}
/**
 * Hashes the value into a stable hash.
 */

function stableValueHash(value) {
  return JSON.stringify(value, function (_, val) {
    return isPlainObject(val) ? Object.keys(val).sort().reduce(function (result, key) {
      result[key] = val[key];
      return result;
    }, {}) : val;
  });
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(function (key) {
      return !partialDeepEqual(a[key], b[key]);
    });
  }
  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }
  var array = Array.isArray(a) && Array.isArray(b);
  if (array || isPlainObject(a) && isPlainObject(b)) {
    var aSize = array ? a.length : Object.keys(a).length;
    var bItems = array ? b : Object.keys(b);
    var bSize = bItems.length;
    var copy = array ? [] : {};
    var equalItems = 0;
    for (var i = 0; i < bSize; i++) {
      var key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);
      if (copy[key] === a[key]) {
        equalItems++;
      }
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
  }
  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }
  for (var key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }
  return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor

  var ctor = o.constructor;
  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype

  var prot = ctor.prototype;
  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method

  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object

  return true;
}
function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}
function isQueryKey(value) {
  return typeof value === 'string' || Array.isArray(value);
}
function isError(value) {
  return value instanceof Error;
}
function sleep(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  Promise.resolve().then(callback).catch(function (error) {
    return setTimeout(function () {
      throw error;
    });
  });
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }
}

/***/ }),

/***/ 97478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _core__WEBPACK_IMPORTED_MODULE_0__.QueryClient; },
/* harmony export */   "QueryClientProvider": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider; },
/* harmony export */   "useInfiniteQuery": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useInfiniteQuery; },
/* harmony export */   "useMutation": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useMutation; },
/* harmony export */   "useQuery": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useQuery; },
/* harmony export */   "useQueryClient": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useQueryClient; }
/* harmony export */ });
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20721);
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useInfiniteQuery")) __webpack_require__.d(__webpack_exports__, { "useInfiniteQuery": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useInfiniteQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useMutation")) __webpack_require__.d(__webpack_exports__, { "useMutation": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useMutation; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useQueryClient")) __webpack_require__.d(__webpack_exports__, { "useQueryClient": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useQueryClient; } });
/* harmony import */ var _react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44261);



/***/ }),

/***/ 44261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "QueryClientProvider": function() { return /* reexport */ QueryClientProvider; },
  "useInfiniteQuery": function() { return /* reexport */ useInfiniteQuery; },
  "useMutation": function() { return /* reexport */ useMutation; },
  "useQuery": function() { return /* reexport */ useQuery; },
  "useQueryClient": function() { return /* reexport */ useQueryClient; }
});

// UNUSED EXPORTS: Hydrate, QueryErrorResetBoundary, useHydrate, useIsFetching, useIsMutating, useQueries, useQueryErrorResetBoundary

// EXTERNAL MODULE: ./node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(5906);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(85202);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/reactBatchedUpdates.js

var unstable_batchedUpdates = react_dom.unstable_batchedUpdates;
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/setBatchUpdatesFn.js


notifyManager/* notifyManager.setBatchNotifyFunction */.V.setBatchNotifyFunction(unstable_batchedUpdates);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(571);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/logger.js
var logger_logger = console;
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/setLogger.js


(0,logger/* setLogger */.E)(logger_logger);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/QueryClientProvider.js

var defaultContext = /*#__PURE__*/react.createContext(undefined);
var QueryClientSharingContext = /*#__PURE__*/react.createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(contextSharing) {
  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }
    return window.ReactQueryClientContext;
  }
  return defaultContext;
}
var useQueryClient = function useQueryClient() {
  var queryClient = react.useContext(getQueryClientContext(react.useContext(QueryClientSharingContext)));
  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }
  return queryClient;
};
var QueryClientProvider = function QueryClientProvider(_ref) {
  var client = _ref.client,
    _ref$contextSharing = _ref.contextSharing,
    contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing,
    children = _ref.children;
  react.useEffect(function () {
    client.mount();
    return function () {
      client.unmount();
    };
  }, [client]);
  var Context = getQueryClientContext(contextSharing);
  return /*#__PURE__*/react.createElement(QueryClientSharingContext.Provider, {
    value: contextSharing
  }, /*#__PURE__*/react.createElement(Context.Provider, {
    value: client
  }, children));
};
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(40639);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(76282);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/mutation.js
var mutation = __webpack_require__(35407);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(86285);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/mutationObserver.js





// CLASS
var MutationObserver = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(MutationObserver, _Subscribable);
  function MutationObserver(client, options) {
    var _this;
    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.setOptions(options);
    _this.bindMethods();
    _this.updateResult();
    return _this;
  }
  var _proto = MutationObserver.prototype;
  _proto.bindMethods = function bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  };
  _proto.setOptions = function setOptions(options) {
    this.options = this.client.defaultMutationOptions(options);
  };
  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      var _this$currentMutation;
      (_this$currentMutation = this.currentMutation) == null ? void 0 : _this$currentMutation.removeObserver(this);
    }
  };
  _proto.onMutationUpdate = function onMutationUpdate(action) {
    this.updateResult(); // Determine which callbacks to trigger

    var notifyOptions = {
      listeners: true
    };
    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error') {
      notifyOptions.onError = true;
    }
    this.notify(notifyOptions);
  };
  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };
  _proto.reset = function reset() {
    this.currentMutation = undefined;
    this.updateResult();
    this.notify({
      listeners: true
    });
  };
  _proto.mutate = function mutate(variables, options) {
    this.mutateOptions = options;
    if (this.currentMutation) {
      this.currentMutation.removeObserver(this);
    }
    this.currentMutation = this.client.getMutationCache().build(this.client, (0,esm_extends/* default */.Z)({}, this.options, {
      variables: typeof variables !== 'undefined' ? variables : this.options.variables
    }));
    this.currentMutation.addObserver(this);
    return this.currentMutation.execute();
  };
  _proto.updateResult = function updateResult() {
    var state = this.currentMutation ? this.currentMutation.state : (0,mutation/* getDefaultState */.R)();
    var result = (0,esm_extends/* default */.Z)({}, state, {
      isLoading: state.status === 'loading',
      isSuccess: state.status === 'success',
      isError: state.status === 'error',
      isIdle: state.status === 'idle',
      mutate: this.mutate,
      reset: this.reset
    });
    this.currentResult = result;
  };
  _proto.notify = function notify(options) {
    var _this2 = this;
    notifyManager/* notifyManager.batch */.V.batch(function () {
      // First trigger the mutate callbacks
      if (_this2.mutateOptions) {
        if (options.onSuccess) {
          _this2.mutateOptions.onSuccess == null ? void 0 : _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
        } else if (options.onError) {
          _this2.mutateOptions.onError == null ? void 0 : _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
        }
      } // Then trigger the listeners

      if (options.listeners) {
        _this2.listeners.forEach(function (listener) {
          listener(_this2.currentResult);
        });
      }
    });
  };
  return MutationObserver;
}(subscribable/* Subscribable */.l);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/utils.js
function shouldThrowError(suspense, _useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary.apply(void 0, params);
  } // Allow useErrorBoundary to override suspense's throwing behavior

  if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors

  return !!suspense;
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useMutation.js






 // HOOK

function useMutation(arg1, arg2, arg3) {
  var mountedRef = react.useRef(false);
  var _React$useState = react.useState(0),
    forceUpdate = _React$useState[1];
  var options = (0,utils/* parseMutationArgs */.lV)(arg1, arg2, arg3);
  var queryClient = useQueryClient();
  var obsRef = react.useRef();
  if (!obsRef.current) {
    obsRef.current = new MutationObserver(queryClient, options);
  } else {
    obsRef.current.setOptions(options);
  }
  var currentResult = obsRef.current.getCurrentResult();
  react.useEffect(function () {
    mountedRef.current = true;
    var unsubscribe = obsRef.current.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    }));
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, []);
  var mutate = react.useCallback(function (variables, mutateOptions) {
    obsRef.current.mutate(variables, mutateOptions).catch(utils/* noop */.ZT);
  }, []);
  if (currentResult.error && shouldThrowError(undefined, obsRef.current.options.useErrorBoundary, [currentResult.error])) {
    throw currentResult.error;
  }
  return (0,esm_extends/* default */.Z)({}, currentResult, {
    mutate: mutate,
    mutateAsync: currentResult.mutate
  });
}
// EXTERNAL MODULE: ./node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(75288);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(46955);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryObserver.js








var QueryObserver = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryObserver, _Subscribable);
  function QueryObserver(client, options) {
    var _this;
    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.options = options;
    _this.trackedProps = [];
    _this.selectError = null;
    _this.bindMethods();
    _this.setOptions(options);
    return _this;
  }
  var _proto = QueryObserver.prototype;
  _proto.bindMethods = function bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  };
  _proto.onSubscribe = function onSubscribe() {
    if (this.listeners.length === 1) {
      this.currentQuery.addObserver(this);
      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }
      this.updateTimers();
    }
  };
  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  };
  _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
  };
  _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  };
  _proto.destroy = function destroy() {
    this.listeners = [];
    this.clearTimers();
    this.currentQuery.removeObserver(this);
  };
  _proto.setOptions = function setOptions(options, notifyOptions) {
    var prevOptions = this.options;
    var prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryObserverOptions(options);
    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one

    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }
    this.updateQuery();
    var mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result

    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }
    var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  };
  _proto.getOptimisticResult = function getOptimisticResult(options) {
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return this.createResult(query, defaultedOptions);
  };
  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };
  _proto.trackResult = function trackResult(result, defaultedOptions) {
    var _this2 = this;
    var trackedResult = {};
    var trackProp = function trackProp(key) {
      if (!_this2.trackedProps.includes(key)) {
        _this2.trackedProps.push(key);
      }
    };
    Object.keys(result).forEach(function (key) {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: function get() {
          trackProp(key);
          return result[key];
        }
      });
    });
    if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) {
      trackProp('error');
    }
    return trackedResult;
  };
  _proto.getNextResult = function getNextResult(options) {
    var _this3 = this;
    return new Promise(function (resolve, reject) {
      var unsubscribe = _this3.subscribe(function (result) {
        if (!result.isFetching) {
          unsubscribe();
          if (result.isError && (options == null ? void 0 : options.throwOnError)) {
            reject(result.error);
          } else {
            resolve(result);
          }
        }
      });
    });
  };
  _proto.getCurrentQuery = function getCurrentQuery() {
    return this.currentQuery;
  };
  _proto.remove = function remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  };
  _proto.refetch = function refetch(options) {
    return this.fetch((0,esm_extends/* default */.Z)({}, options, {
      meta: {
        refetchPage: options == null ? void 0 : options.refetchPage
      }
    }));
  };
  _proto.fetchOptimistic = function fetchOptimistic(options) {
    var _this4 = this;
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return query.fetch().then(function () {
      return _this4.createResult(query, defaultedOptions);
    });
  };
  _proto.fetch = function fetch(fetchOptions) {
    var _this5 = this;
    return this.executeFetch(fetchOptions).then(function () {
      _this5.updateResult();
      return _this5.currentResult;
    });
  };
  _proto.executeFetch = function executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    var promise = this.currentQuery.fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }
    return promise;
  };
  _proto.updateStaleTimeout = function updateStaleTimeout() {
    var _this6 = this;
    this.clearStaleTimeout();
    if (utils/* isServer */.sk || this.currentResult.isStale || !(0,utils/* isValidTimeout */.PN)(this.options.staleTime)) {
      return;
    }
    var time = (0,utils/* timeUntilStale */.Kp)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    var timeout = time + 1;
    this.staleTimeoutId = setTimeout(function () {
      if (!_this6.currentResult.isStale) {
        _this6.updateResult();
      }
    }, timeout);
  };
  _proto.computeRefetchInterval = function computeRefetchInterval() {
    var _this$options$refetch;
    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  };
  _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
    var _this7 = this;
    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;
    if (utils/* isServer */.sk || this.options.enabled === false || !(0,utils/* isValidTimeout */.PN)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }
    this.refetchIntervalId = setInterval(function () {
      if (_this7.options.refetchIntervalInBackground || focusManager/* focusManager.isFocused */.j.isFocused()) {
        _this7.executeFetch();
      }
    }, this.currentRefetchInterval);
  };
  _proto.updateTimers = function updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  };
  _proto.clearTimers = function clearTimers() {
    this.clearStaleTimeout();
    this.clearRefetchInterval();
  };
  _proto.clearStaleTimeout = function clearStaleTimeout() {
    if (this.staleTimeoutId) {
      clearTimeout(this.staleTimeoutId);
      this.staleTimeoutId = undefined;
    }
  };
  _proto.clearRefetchInterval = function clearRefetchInterval() {
    if (this.refetchIntervalId) {
      clearInterval(this.refetchIntervalId);
      this.refetchIntervalId = undefined;
    }
  };
  _proto.createResult = function createResult(query, options) {
    var prevQuery = this.currentQuery;
    var prevOptions = this.options;
    var prevResult = this.currentResult;
    var prevResultState = this.currentResultState;
    var prevResultOptions = this.currentResultOptions;
    var queryChange = query !== prevQuery;
    var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    var state = query.state;
    var dataUpdatedAt = state.dataUpdatedAt,
      error = state.error,
      errorUpdatedAt = state.errorUpdatedAt,
      isFetching = state.isFetching,
      status = state.status;
    var isPreviousData = false;
    var isPlaceholderData = false;
    var data; // Optimistically set result in fetching state if needed

    if (options.optimisticResults) {
      var mounted = this.hasListeners();
      var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
      if (fetchOnMount || fetchOptionally) {
        isFetching = true;
        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }
    } // Keep previous data if needed

    if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
      // Memoize select result
      if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) {
        data = this.selectResult;
      } else {
        try {
          this.selectFn = options.select;
          data = options.select(state.data);
          if (options.structuralSharing !== false) {
            data = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, data);
          }
          this.selectResult = data;
          this.selectError = null;
        } catch (selectError) {
          (0,logger/* getLogger */.j)().error(selectError);
          this.selectError = selectError;
        }
      }
    } // Use query data
    else {
      data = state.data;
    } // Show placeholder data if needed

    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
      var placeholderData; // Memoize placeholder data

      if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);
            if (options.structuralSharing !== false) {
              placeholderData = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, placeholderData);
            }
            this.selectError = null;
          } catch (selectError) {
            (0,logger/* getLogger */.j)().error(selectError);
            this.selectError = selectError;
          }
        }
      }
      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = placeholderData;
        isPlaceholderData = true;
      }
    }
    if (this.selectError) {
      error = this.selectError;
      data = this.selectResult;
      errorUpdatedAt = Date.now();
      status = 'error';
    }
    var result = {
      status: status,
      isLoading: status === 'loading',
      isSuccess: status === 'success',
      isError: status === 'error',
      isIdle: status === 'idle',
      data: data,
      dataUpdatedAt: dataUpdatedAt,
      error: error,
      errorUpdatedAt: errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      errorUpdateCount: state.errorUpdateCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching: isFetching,
      isRefetching: isFetching && status !== 'loading',
      isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
      isPlaceholderData: isPlaceholderData,
      isPreviousData: isPreviousData,
      isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  };
  _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
    if (!prevResult) {
      return true;
    }
    var _this$options = this.options,
      notifyOnChangeProps = _this$options.notifyOnChangeProps,
      notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;
    if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) {
      return true;
    }
    if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) {
      return true;
    }
    var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
    return Object.keys(result).some(function (key) {
      var typedKey = key;
      var changed = result[typedKey] !== prevResult[typedKey];
      var isIncluded = includedProps == null ? void 0 : includedProps.some(function (x) {
        return x === key;
      });
      var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function (x) {
        return x === key;
      });
      return changed && !isExcluded && (!includedProps || isIncluded);
    });
  };
  _proto.updateResult = function updateResult(notifyOptions) {
    var prevResult = this.currentResult;
    this.currentResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify if something has changed

    if ((0,utils/* shallowEqualObjects */.VS)(this.currentResult, prevResult)) {
      return;
    } // Determine which callbacks to trigger

    var defaultNotifyOptions = {
      cache: true
    };
    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) {
      defaultNotifyOptions.listeners = true;
    }
    this.notify((0,esm_extends/* default */.Z)({}, defaultNotifyOptions, notifyOptions));
  };
  _proto.updateQuery = function updateQuery() {
    var query = this.client.getQueryCache().build(this.client, this.options);
    if (query === this.currentQuery) {
      return;
    }
    var prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;
    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  };
  _proto.onQueryUpdate = function onQueryUpdate(action) {
    var notifyOptions = {};
    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error' && !(0,retryer/* isCancelledError */.DV)(action.error)) {
      notifyOptions.onError = true;
    }
    this.updateResult(notifyOptions);
    if (this.hasListeners()) {
      this.updateTimers();
    }
  };
  _proto.notify = function notify(notifyOptions) {
    var _this8 = this;
    notifyManager/* notifyManager.batch */.V.batch(function () {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        _this8.options.onSuccess == null ? void 0 : _this8.options.onSuccess(_this8.currentResult.data);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(_this8.currentResult.data, null);
      } else if (notifyOptions.onError) {
        _this8.options.onError == null ? void 0 : _this8.options.onError(_this8.currentResult.error);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(undefined, _this8.currentResult.error);
      } // Then trigger the listeners

      if (notifyOptions.listeners) {
        _this8.listeners.forEach(function (listener) {
          listener(_this8.currentResult);
        });
      } // Then the cache listeners

      if (notifyOptions.cache) {
        _this8.client.getQueryCache().notify({
          query: _this8.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  };
  return QueryObserver;
}(subscribable/* Subscribable */.l);
function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}
function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}
function shouldFetchOn(query, options, field) {
  if (options.enabled !== false) {
    var value = typeof field === 'function' ? field(query) : field;
    return value === 'always' || value !== false && isStale(query, options);
  }
  return false;
}
function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}
function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/QueryErrorResetBoundary.js
 // CONTEXT

function createValue() {
  var _isReset = false;
  return {
    clearReset: function clearReset() {
      _isReset = false;
    },
    reset: function reset() {
      _isReset = true;
    },
    isReset: function isReset() {
      return _isReset;
    }
  };
}
var QueryErrorResetBoundaryContext = /*#__PURE__*/react.createContext(createValue()); // HOOK

var useQueryErrorResetBoundary = function useQueryErrorResetBoundary() {
  return react.useContext(QueryErrorResetBoundaryContext);
}; // COMPONENT

var QueryErrorResetBoundary = function QueryErrorResetBoundary(_ref) {
  var children = _ref.children;
  var value = React.useMemo(function () {
    return createValue();
  }, []);
  return /*#__PURE__*/React.createElement(QueryErrorResetBoundaryContext.Provider, {
    value: value
  }, typeof children === 'function' ? children(value) : children);
};
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useBaseQuery.js





function useBaseQuery(options, Observer) {
  var mountedRef = react.useRef(false);
  var _React$useState = react.useState(0),
    forceUpdate = _React$useState[1];
  var queryClient = useQueryClient();
  var errorResetBoundary = useQueryErrorResetBoundary();
  var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions.optimisticResults = true; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onError);
  }
  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSuccess);
  }
  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSettled);
  }
  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    } // Set cache time to 1 if the option has been set to 0
    // when using suspense to prevent infinite loop of fetches

    if (defaultedOptions.cacheTime === 0) {
      defaultedOptions.cacheTime = 1;
    }
  }
  if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      defaultedOptions.retryOnMount = false;
    }
  }
  var _React$useState2 = react.useState(function () {
      return new Observer(queryClient, defaultedOptions);
    }),
    observer = _React$useState2[0];
  var result = observer.getOptimisticResult(defaultedOptions);
  react.useEffect(function () {
    mountedRef.current = true;
    errorResetBoundary.clearReset();
    var unsubscribe = observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    })); // Update result to make sure we did not miss any query updates
    // between creating the observer and subscribing to it.

    observer.updateResult();
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [errorResetBoundary, observer]);
  react.useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (defaultedOptions.suspense && result.isLoading) {
    throw observer.fetchOptimistic(defaultedOptions).then(function (_ref) {
      var data = _ref.data;
      defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
    }).catch(function (error) {
      errorResetBoundary.clearReset();
      defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
    });
  } // Handle error boundary

  if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && shouldThrowError(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [result.error, observer.getCurrentQuery()])) {
    throw result.error;
  } // Handle result property usage tracking

  if (defaultedOptions.notifyOnChangeProps === 'tracked') {
    result = observer.trackResult(result, defaultedOptions);
  }
  return result;
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useQuery.js


 // HOOK

function useQuery(arg1, arg2, arg3) {
  var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(parsedOptions, QueryObserver);
}
// EXTERNAL MODULE: ./node_modules/react-query/es/core/infiniteQueryBehavior.js
var infiniteQueryBehavior = __webpack_require__(90330);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/infiniteQueryObserver.js




var InfiniteQueryObserver = /*#__PURE__*/function (_QueryObserver) {
  (0,inheritsLoose/* default */.Z)(InfiniteQueryObserver, _QueryObserver);

  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  function InfiniteQueryObserver(client, options) {
    return _QueryObserver.call(this, client, options) || this;
  }
  var _proto = InfiniteQueryObserver.prototype;
  _proto.bindMethods = function bindMethods() {
    _QueryObserver.prototype.bindMethods.call(this);
    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  };
  _proto.setOptions = function setOptions(options, notifyOptions) {
    _QueryObserver.prototype.setOptions.call(this, (0,esm_extends/* default */.Z)({}, options, {
      behavior: (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)()
    }), notifyOptions);
  };
  _proto.getOptimisticResult = function getOptimisticResult(options) {
    options.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return _QueryObserver.prototype.getOptimisticResult.call(this, options);
  };
  _proto.fetchNextPage = function fetchNextPage(options) {
    var _options$cancelRefetc;
    return this.fetch({
      // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
      cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
      throwOnError: options == null ? void 0 : options.throwOnError,
      meta: {
        fetchMore: {
          direction: 'forward',
          pageParam: options == null ? void 0 : options.pageParam
        }
      }
    });
  };
  _proto.fetchPreviousPage = function fetchPreviousPage(options) {
    var _options$cancelRefetc2;
    return this.fetch({
      // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
      cancelRefetch: (_options$cancelRefetc2 = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc2 : true,
      throwOnError: options == null ? void 0 : options.throwOnError,
      meta: {
        fetchMore: {
          direction: 'backward',
          pageParam: options == null ? void 0 : options.pageParam
        }
      }
    });
  };
  _proto.createResult = function createResult(query, options) {
    var _state$data, _state$data2, _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet;
    var state = query.state;
    var result = _QueryObserver.prototype.createResult.call(this, query, options);
    return (0,esm_extends/* default */.Z)({}, result, {
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: (0,infiniteQueryBehavior/* hasNextPage */.Qy)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
      hasPreviousPage: (0,infiniteQueryBehavior/* hasPreviousPage */.ZF)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
      isFetchingNextPage: state.isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward',
      isFetchingPreviousPage: state.isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward'
    });
  };
  return InfiniteQueryObserver;
}(QueryObserver);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useInfiniteQuery.js


 // HOOK

function useInfiniteQuery(arg1, arg2, arg3) {
  var options = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(options, InfiniteQueryObserver);
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/index.js
// Side effects










 // Types



/***/ }),

/***/ 9616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zt": function() { return /* reexport */ components_Provider; },
  "$j": function() { return /* reexport */ components_connect; },
  "I0": function() { return /* reexport */ useDispatch; },
  "v9": function() { return /* reexport */ useSelector; }
});

// UNUSED EXPORTS: ReactReduxContext, batch, createDispatchHook, createSelectorHook, createStoreHook, shallowEqual, useStore

// EXTERNAL MODULE: ./node_modules/use-sync-external-store/shim/index.js
var shim = __webpack_require__(48216);
// EXTERNAL MODULE: ./node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(81550);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(85202);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/reactBatchedUpdates.js

;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/batch.js
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}
let batch = defaultNoopBatch; // Allow injecting another batching function later

const setBatch = newBatch => batch = newBatch; // Supply a getter just to skip dealing with ESM bindings

const getBatch = () => batch;
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Context.js

const ContextKey = Symbol.for(`react-redux-context`);
const gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
{};
function getContext() {
  var _gT$ContextKey;
  if (!react.createContext) return {};
  const contextMap = (_gT$ContextKey = gT[ContextKey]) != null ? _gT$ContextKey : gT[ContextKey] = new Map();
  let realContext = contextMap.get(react.createContext);
  if (!realContext) {
    realContext = react.createContext(null);
    if (false) {}
    contextMap.set(react.createContext, realContext);
  }
  return realContext;
}
const ReactReduxContext = /*#__PURE__*/getContext();
/* harmony default export */ var Context = ((/* unused pure expression or super */ null && (ReactReduxContext)));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useReduxContext.js



/**
 * Hook factory, which creates a `useReduxContext` hook bound to a given context. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useReduxContext` hook bound to the specified context.
 */
function createReduxContextHook(context = ReactReduxContext) {
  return function useReduxContext() {
    const contextValue = (0,react.useContext)(context);
    if (false) {}
    return contextValue;
  };
}
/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

const useReduxContext_useReduxContext = /*#__PURE__*/createReduxContextHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/useSyncExternalStore.js
const notInitialized = () => {
  throw new Error('uSES not initialized!');
};
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useSelector.js




let useSyncExternalStoreWithSelector = notInitialized;
const initializeUseSelector = fn => {
  useSyncExternalStoreWithSelector = fn;
};
const refEquality = (a, b) => a === b;
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */

function createSelectorHook(context = ReactReduxContext) {
  const useReduxContext = context === ReactReduxContext ? useReduxContext_useReduxContext : createReduxContextHook(context);
  return function useSelector(selector, equalityFnOrOptions = {}) {
    const {
      equalityFn = refEquality,
      stabilityCheck = undefined,
      noopCheck = undefined
    } = typeof equalityFnOrOptions === 'function' ? {
      equalityFn: equalityFnOrOptions
    } : equalityFnOrOptions;
    if (false) {}
    const {
      store,
      subscription,
      getServerState,
      stabilityCheck: globalStabilityCheck,
      noopCheck: globalNoopCheck
    } = useReduxContext();
    const firstRun = (0,react.useRef)(true);
    const wrappedSelector = (0,react.useCallback)({
      [selector.name](state) {
        const selected = selector(state);
        if (false) {}
        return selected;
      }
    }[selector.name], [selector, globalStabilityCheck, stabilityCheck]);
    const selectedState = useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
    (0,react.useDebugValue)(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

const useSelector = /*#__PURE__*/createSelectorHook();
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(38);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(89483);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/react-redux/node_modules/react-is/index.js
var react_is = __webpack_require__(12553);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/selectorFactory.js

const _excluded = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, {
  areStatesEqual,
  areOwnPropsEqual,
  areStatePropsEqual
}) {
  let hasRunAtLeastOnce = false;
  let state;
  let ownProps;
  let stateProps;
  let dispatchProps;
  let mergedProps;
  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }
  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }
  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }
  function handleNewState() {
    const nextStateProps = mapStateToProps(state, ownProps);
    const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }
  function handleSubsequentCalls(nextState, nextOwnProps) {
    const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }
  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}
// TODO: Add more comments
// The selector returned by selectorFactory will memoize its results,
// allowing connect's shouldComponentUpdate to return false if final
// props have not changed.
function finalPropsSelectorFactory(dispatch, _ref) {
  let {
      initMapStateToProps,
      initMapDispatchToProps,
      initMergeProps
    } = _ref,
    options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, _excluded);
  const mapStateToProps = initMapStateToProps(dispatch, options);
  const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  const mergeProps = initMergeProps(dispatch, options);
  if (false) {}
  return pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/bindActionCreators.js
function bindActionCreators(actionCreators, dispatch) {
  const boundActionCreators = {};
  for (const key in actionCreators) {
    const actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = (...args) => dispatch(actionCreator(...args));
    }
  }
  return boundActionCreators;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/wrapMapToProps.js

function wrapMapToPropsConstant(
// * Note:
//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
  return function initConstantSelector(dispatch) {
    const constant = getConstant(dispatch);
    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
// TODO Can this get pulled out so that we can subscribe directly to the store if we don't need ownProps?

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, {
    displayName
  }) {
    const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
    }; // allow detectFactoryAndVerify to get ownProps

    proxy.dependsOnOwnProps = true;
    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      let props = proxy(stateOrDispatch, ownProps);
      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }
      if (false) {}
      return props;
    };
    return proxy;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/invalidArgFactory.js
function createInvalidArgFactory(arg, name) {
  return (dispatch, options) => {
    throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapDispatchToProps.js



function mapDispatchToPropsFactory(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(dispatch =>
  // @ts-ignore
  bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? wrapMapToPropsConstant(dispatch => ({
    dispatch
  })) : typeof mapDispatchToProps === 'function' ?
  // @ts-ignore
  wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : createInvalidArgFactory(mapDispatchToProps, 'mapDispatchToProps');
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapStateToProps.js


function mapStateToPropsFactory(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(() => ({})) : typeof mapStateToProps === 'function' ?
  // @ts-ignore
  wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : createInvalidArgFactory(mapStateToProps, 'mapStateToProps');
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mergeProps.js



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  // @ts-ignore
  return (0,esm_extends/* default */.Z)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, {
    displayName,
    areMergedPropsEqual
  }) {
    let hasRunOnce = false;
    let mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
      if (hasRunOnce) {
        if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) {}
      }
      return mergedProps;
    };
  };
}
function mergePropsFactory(mergeProps) {
  return !mergeProps ? () => defaultMergeProps : typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : createInvalidArgFactory(mergeProps, 'mergeProps');
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  const batch = getBatch();
  let first = null;
  let last = null;
  return {
    clear() {
      first = null;
      last = null;
    },
    notify() {
      batch(() => {
        let listener = first;
        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get() {
      let listeners = [];
      let listener = first;
      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }
      return listeners;
    },
    subscribe(callback) {
      let isSubscribed = true;
      let listener = last = {
        callback,
        next: null,
        prev: last
      };
      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }
      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;
        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }
        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}
const nullListeners = {
  notify() {},
  get: () => []
};
function createSubscription(store, parentSub) {
  let unsubscribe;
  let listeners = nullListeners; // Reasons to keep the subscription active

  let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)

  let selfSubscribed = false;
  function addNestedSub(listener) {
    trySubscribe();
    const cleanupListener = listeners.subscribe(listener); // cleanup nested sub

    let removed = false;
    return () => {
      if (!removed) {
        removed = true;
        cleanupListener();
        tryUnsubscribe();
      }
    };
  }
  function notifyNestedSubs() {
    listeners.notify();
  }
  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }
  function isSubscribed() {
    return selfSubscribed;
  }
  function trySubscribe() {
    subscriptionsAmount++;
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }
  function tryUnsubscribe() {
    subscriptionsAmount--;
    if (unsubscribe && subscriptionsAmount === 0) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }
  function trySubscribeSelf() {
    if (!selfSubscribed) {
      selfSubscribed = true;
      trySubscribe();
    }
  }
  function tryUnsubscribeSelf() {
    if (selfSubscribed) {
      selfSubscribed = false;
      tryUnsubscribe();
    }
  }
  const subscription = {
    addNestedSub,
    notifyNestedSubs,
    handleChangeWrapper,
    isSubscribed,
    trySubscribe: trySubscribeSelf,
    tryUnsubscribe: tryUnsubscribeSelf,
    getListeners: () => listeners
  };
  return subscription;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/useIsomorphicLayoutEffect.js
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed
// Matches logic in React's `shared/ExecutionEnvironment` file

const canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const useIsomorphicLayoutEffect = canUseDOM ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/shallowEqual.js
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}
function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;
  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }
  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;
  for (let i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/connect.js


const connect_excluded = ["reactReduxForwardedRef"];

/* eslint-disable valid-jsdoc, @typescript-eslint/no-unused-vars */













let useSyncExternalStore = notInitialized;
const initializeConnect = fn => {
  useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these

const EMPTY_ARRAY = (/* unused pure expression or super */ null && ([null, 0]));
const NO_SUBSCRIPTION_ARRAY = [null, null]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message

const stringifyComponent = Comp => {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect(() => effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps,
// actualChildProps: unknown,
childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs,
// forceComponentUpdateDispatch: React.Dispatch<any>,
additionalSubscribeListener) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return () => {}; // Capture values for checking if and when this component unmounts

  let didUnsubscribe = false;
  let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  const checkForUpdates = () => {
    if (didUnsubscribe || !isMounted.current) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    } // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it

    const latestStoreState = store.getState();
    let newChildProps, error;
    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }
    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update

    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
      // Trigger the React `useSyncExternalStore` subscriber

      additionalSubscribeListener();
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)

  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();
  const unsubscribeWrapper = () => {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;
    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };
  return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer

const initStateUpdates = () => EMPTY_ARRAY;
function strictEqual(a, b) {
  return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */

let hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */

function connect(mapStateToProps, mapDispatchToProps, mergeProps, {
  // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
  // @ts-ignore
  pure,
  areStatesEqual = strictEqual,
  areOwnPropsEqual = shallowEqual,
  areStatePropsEqual = shallowEqual,
  areMergedPropsEqual = shallowEqual,
  // use React's forwardRef to expose a ref of the wrapped component
  forwardRef = false,
  // the context consumer to use
  context = ReactReduxContext
} = {}) {
  if (false) {}
  const Context = context;
  const initMapStateToProps = mapStateToPropsFactory(mapStateToProps);
  const initMapDispatchToProps = mapDispatchToPropsFactory(mapDispatchToProps);
  const initMergeProps = mergePropsFactory(mergeProps);
  const shouldHandleStateChanges = Boolean(mapStateToProps);
  const wrapWithConnect = WrappedComponent => {
    if (false) {}
    const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    const displayName = `Connect(${wrappedComponentName})`;
    const selectorFactoryOptions = {
      shouldHandleStateChanges,
      displayName,
      wrappedComponentName,
      WrappedComponent,
      // @ts-ignore
      initMapStateToProps,
      // @ts-ignore
      initMapDispatchToProps,
      initMergeProps,
      areStatesEqual,
      areStatePropsEqual,
      areOwnPropsEqual,
      areMergedPropsEqual
    };
    function ConnectFunction(props) {
      const [propsContext, reactReduxForwardedRef, wrapperProps] = react.useMemo(() => {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        const {
            reactReduxForwardedRef
          } = props,
          wrapperProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props, connect_excluded);
        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]);
      const ContextToUse = react.useMemo(() => {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer &&
        // @ts-ignore
        (0,react_is.isContextConsumer)(/*#__PURE__*/react.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      const contextValue = react.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
      if (false) {} // Based on the previous check, one of these must be true

      const store = didStoreComeFromProps ? props.store : contextValue.store;
      const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
      const childPropsSelector = react.useMemo(() => {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
      }, [store]);
      const [subscription, notifyNestedSubs] = react.useMemo(() => {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        const subscription = createSubscription(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]); // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.

      const overriddenContextValue = react.useMemo(() => {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done

        return (0,esm_extends/* default */.Z)({}, contextValue, {
          subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // Set up refs to coordinate values between the subscription effect and the render logic

      const lastChildProps = react.useRef();
      const lastWrapperProps = react.useRef(wrapperProps);
      const childPropsFromStoreUpdate = react.useRef();
      const renderIsScheduled = react.useRef(false);
      const isProcessingDispatch = react.useRef(false);
      const isMounted = react.useRef(false);
      const latestSubscriptionCallbackError = react.useRef();
      useIsomorphicLayoutEffect(() => {
        isMounted.current = true;
        return () => {
          isMounted.current = false;
        };
      }, []);
      const actualChildPropsSelector = react.useMemo(() => {
        const selector = () => {
          // Tricky logic here:
          // - This render may have been triggered by a Redux store update that produced new child props
          // - However, we may have gotten new wrapper props after that
          // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
          // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
          // So, we'll use the child props from store update only if the wrapper props are the same as last time.
          if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
            return childPropsFromStoreUpdate.current;
          } // TODO We're reading the store directly in render() here. Bad idea?
          // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
          // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
          // to determine what the child props should be.

          return childPropsSelector(store.getState(), wrapperProps);
        };
        return selector;
      }, [store, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      const subscribeForReact = react.useMemo(() => {
        const subscribe = reactListener => {
          if (!subscription) {
            return () => {};
          }
          return subscribeUpdates(shouldHandleStateChanges, store, subscription,
          // @ts-ignore
          childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
        };
        return subscribe;
      }, [subscription]);
      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs]);
      let actualChildProps;
      try {
        actualChildProps = useSyncExternalStore(
        // TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
        subscribeForReact,
        // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
        // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
        actualChildPropsSelector, getServerState ? () => childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
      } catch (err) {
        if (latestSubscriptionCallbackError.current) {
          ;
          err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
        }
        throw err;
      }
      useIsomorphicLayoutEffect(() => {
        latestSubscriptionCallbackError.current = undefined;
        childPropsFromStoreUpdate.current = undefined;
        lastChildProps.current = actualChildProps;
      }); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      const renderedWrappedComponent = react.useMemo(() => {
        return (/*#__PURE__*/
          // @ts-ignore
          react.createElement(WrappedComponent, (0,esm_extends/* default */.Z)({}, actualChildProps, {
            ref: reactReduxForwardedRef
          }))
        );
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      const renderedChild = react.useMemo(() => {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/react.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }
        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    }
    const _Connect = react.memo(ConnectFunction);

    // Add a hacky cast to get the right output type
    const Connect = _Connect;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;
    if (forwardRef) {
      const _forwarded = react.forwardRef(function forwardConnectRef(props, ref) {
        // @ts-ignore
        return /*#__PURE__*/react.createElement(Connect, (0,esm_extends/* default */.Z)({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      const forwarded = _forwarded;
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoist_non_react_statics_cjs_default()(forwarded, WrappedComponent);
    }
    return hoist_non_react_statics_cjs_default()(Connect, WrappedComponent);
  };
  return wrapWithConnect;
}
/* harmony default export */ var components_connect = (connect);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js




function Provider({
  store,
  context,
  children,
  serverState,
  stabilityCheck = 'once',
  noopCheck = 'once'
}) {
  const contextValue = react.useMemo(() => {
    const subscription = createSubscription(store);
    return {
      store,
      subscription,
      getServerState: serverState ? () => serverState : undefined,
      stabilityCheck,
      noopCheck
    };
  }, [store, serverState, stabilityCheck, noopCheck]);
  const previousState = react.useMemo(() => store.getState(), [store]);
  useIsomorphicLayoutEffect(() => {
    const {
      subscription
    } = contextValue;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();
    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }
    return () => {
      subscription.tryUnsubscribe();
      subscription.onStateChange = undefined;
    };
  }, [contextValue, previousState]);
  const Context = context || ReactReduxContext; // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype

  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: contextValue
  }, children);
}
/* harmony default export */ var components_Provider = (Provider);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useStore.js


/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context = ReactReduxContext) {
  const useReduxContext =
  // @ts-ignore
  context === ReactReduxContext ? useReduxContext_useReduxContext :
  // @ts-ignore
  createReduxContextHook(context);
  return function useStore() {
    const {
      store
    } = useReduxContext(); // @ts-ignore

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

const useStore_useStore = /*#__PURE__*/createStoreHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useDispatch.js


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context = ReactReduxContext) {
  const useStore =
  // @ts-ignore
  context === ReactReduxContext ? useStore_useStore : createStoreHook(context);
  return function useDispatch() {
    const store = useStore(); // @ts-ignore

    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

const useDispatch = /*#__PURE__*/createDispatchHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/exports.js









;// CONCATENATED MODULE: ./node_modules/react-redux/es/index.js
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.






initializeUseSelector(with_selector.useSyncExternalStoreWithSelector);
initializeConnect(shim.useSyncExternalStore); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

setBatch(react_dom.unstable_batchedUpdates);



/***/ }),

/***/ 78870:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var b = Symbol.for("react.element"),
  c = Symbol.for("react.portal"),
  d = Symbol.for("react.fragment"),
  e = Symbol.for("react.strict_mode"),
  f = Symbol.for("react.profiler"),
  g = Symbol.for("react.provider"),
  h = Symbol.for("react.context"),
  k = Symbol.for("react.server_context"),
  l = Symbol.for("react.forward_ref"),
  m = Symbol.for("react.suspense"),
  n = Symbol.for("react.suspense_list"),
  p = Symbol.for("react.memo"),
  q = Symbol.for("react.lazy"),
  t = Symbol.for("react.offscreen"),
  u;
u = Symbol.for("react.module.reference");
function v(a) {
  if ("object" === typeof a && null !== a) {
    var r = a.$$typeof;
    switch (r) {
      case b:
        switch (a = a.type, a) {
          case d:
          case f:
          case e:
          case m:
          case n:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case h:
              case l:
              case q:
              case p:
              case g:
                return a;
              default:
                return r;
            }
        }
      case c:
        return r;
    }
  }
}
__webpack_unused_export__ = h;
__webpack_unused_export__ = g;
__webpack_unused_export__ = b;
__webpack_unused_export__ = l;
__webpack_unused_export__ = d;
__webpack_unused_export__ = q;
__webpack_unused_export__ = p;
__webpack_unused_export__ = c;
__webpack_unused_export__ = f;
__webpack_unused_export__ = e;
__webpack_unused_export__ = m;
__webpack_unused_export__ = n;
__webpack_unused_export__ = function () {
  return !1;
};
__webpack_unused_export__ = function () {
  return !1;
};
exports.isContextConsumer = function (a) {
  return v(a) === h;
};
__webpack_unused_export__ = function (a) {
  return v(a) === g;
};
__webpack_unused_export__ = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === b;
};
__webpack_unused_export__ = function (a) {
  return v(a) === l;
};
__webpack_unused_export__ = function (a) {
  return v(a) === d;
};
__webpack_unused_export__ = function (a) {
  return v(a) === q;
};
__webpack_unused_export__ = function (a) {
  return v(a) === p;
};
__webpack_unused_export__ = function (a) {
  return v(a) === c;
};
__webpack_unused_export__ = function (a) {
  return v(a) === f;
};
__webpack_unused_export__ = function (a) {
  return v(a) === e;
};
__webpack_unused_export__ = function (a) {
  return v(a) === m;
};
__webpack_unused_export__ = function (a) {
  return v(a) === n;
};
__webpack_unused_export__ = function (a) {
  return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t || "object" === typeof a && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? !0 : !1;
};
__webpack_unused_export__ = v;

/***/ }),

/***/ 12553:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(78870);
} else {}

/***/ }),

/***/ 50976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ isMobileDevice; },
  "B": function() { return /* binding */ multiValueAsValue; },
  "C": function() { return /* binding */ singleValueAsValue; },
  "D": function() { return /* binding */ valueTernary; },
  "E": function() { return /* binding */ classNames; },
  "F": function() { return /* binding */ defaultComponents; },
  "G": function() { return /* binding */ isDocumentElement; },
  "H": function() { return /* binding */ cleanValue; },
  "I": function() { return /* binding */ scrollIntoView; },
  "J": function() { return /* binding */ noop; },
  "K": function() { return /* binding */ notNullish; },
  "M": function() { return /* binding */ MenuPlacer; },
  "a": function() { return /* binding */ clearIndicatorCSS; },
  "b": function() { return /* binding */ containerCSS; },
  "c": function() { return /* binding */ components; },
  "d": function() { return /* binding */ css$1; },
  "e": function() { return /* binding */ dropdownIndicatorCSS; },
  "f": function() { return /* binding */ groupHeadingCSS; },
  "g": function() { return /* binding */ groupCSS; },
  "h": function() { return /* binding */ indicatorSeparatorCSS; },
  "i": function() { return /* binding */ indicatorsContainerCSS; },
  "j": function() { return /* binding */ inputCSS; },
  "k": function() { return /* binding */ loadingMessageCSS; },
  "l": function() { return /* binding */ loadingIndicatorCSS; },
  "m": function() { return /* binding */ menuCSS; },
  "n": function() { return /* binding */ menuListCSS; },
  "o": function() { return /* binding */ menuPortalCSS; },
  "p": function() { return /* binding */ multiValueCSS; },
  "q": function() { return /* binding */ multiValueLabelCSS; },
  "r": function() { return /* binding */ removeProps; },
  "s": function() { return /* binding */ supportsPassiveEvents; },
  "t": function() { return /* binding */ multiValueRemoveCSS; },
  "u": function() { return /* binding */ noOptionsMessageCSS; },
  "v": function() { return /* binding */ optionCSS; },
  "w": function() { return /* binding */ placeholderCSS; },
  "x": function() { return /* binding */ css; },
  "y": function() { return /* binding */ valueContainerCSS; },
  "z": function() { return /* binding */ isTouchCapable; }
});

// UNUSED EXPORTS: L

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js + 6 modules
var emotion_react_browser_esm = __webpack_require__(17867);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(85202);
// EXTERNAL MODULE: ./node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs + 1 modules
var floating_ui_dom = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/use-isomorphic-layout-effect/dist/use-isomorphic-layout-effect.browser.esm.js
var use_isomorphic_layout_effect_browser_esm = __webpack_require__(51858);
;// CONCATENATED MODULE: ./node_modules/react-select/dist/index-641ee5b8.esm.js












var _excluded$4 = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
// ==============================
// NO OP
// ==============================

var noop = function noop() {};

// ==============================
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/
function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}
function classNames(prefix, state) {
  for (var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    classNameList[_key - 2] = arguments[_key];
  }
  var arr = [].concat(classNameList);
  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }
  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
}
// ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (isArray(value)) return value.filter(Boolean);
  if ((0,esm_typeof/* default */.Z)(value) === 'object' && value !== null) return [value];
  return [];
};

// ==============================
// Clean Common Props
// ==============================

var cleanCommonProps = function cleanCommonProps(props) {
  //className
  props.className;
  props.clearValue;
  props.cx;
  props.getStyles;
  props.getClassNames;
  props.getValue;
  props.hasValue;
  props.isMulti;
  props.isRtl;
  props.options;
  props.selectOption;
  props.selectProps;
  props.setValue;
  props.theme;
  var innerProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded$4);
  return (0,objectSpread2/* default */.Z)({}, innerProps);
};

// ==============================
// Get Style Props
// ==============================

var getStyleProps = function getStyleProps(props, name, classNamesState) {
  var cx = props.cx,
    getStyles = props.getStyles,
    getClassNames = props.getClassNames,
    className = props.className;
  return {
    css: getStyles(name, props),
    className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
  };
};

// ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var _newValue = onInputChange(inputValue, actionMeta);
    if (typeof _newValue === 'string') return _newValue;
  }
  return inputValue;
}

// ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}

// Normalized Scroll Top
// ------------------------------

function normalizedHeight(el) {
  if (isDocumentElement(el)) {
    return window.innerHeight;
  }
  return el.clientHeight;
}

// Normalized scrollTo & scrollTop
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }
  el.scrollTop = top;
}

// Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  if (style.position === 'fixed') return document.documentElement;
  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === 'static') {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }
  return document.documentElement;
}

// Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/
function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}
function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;
  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}

// Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;
  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}

// ==============================
// Get bounding client object
// ==============================

// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}

// ==============================
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

// ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}

// ==============================
// Passive Event Detector
// ==============================

// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }
};
// check for SSR
var w = typeof window !== 'undefined' ? window : {};
if (w.addEventListener && w.removeEventListener) {
  w.addEventListener('p', noop, options);
  w.removeEventListener('p', noop, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
  return item != null;
}
function isArray(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}
var removeProps = function removeProps(propsObj) {
  for (var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    properties[_key2 - 1] = arguments[_key2];
  }
  var propsMap = Object.entries(propsObj).filter(function (_ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 1),
      key = _ref2[0];
    return !properties.includes(key);
  });
  return propsMap.reduce(function (newProps, _ref3) {
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
      key = _ref4[0],
      val = _ref4[1];
    newProps[key] = val;
    return newProps;
  }, {});
};
var _excluded$3 = ["children", "innerProps"],
  _excluded2$1 = ["children", "innerProps"];
function getMenuPlacement(_ref) {
  var preferredMaxHeight = _ref.maxHeight,
    menuEl = _ref.menuEl,
    minHeight = _ref.minHeight,
    preferredPlacement = _ref.placement,
    shouldScroll = _ref.shouldScroll,
    isFixedPosition = _ref.isFixedPosition,
    controlHeight = _ref.controlHeight;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: preferredMaxHeight
  };

  // something went wrong, return default state
  if (!menuEl || !menuEl.offsetParent) return defaultState;

  // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered
  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
    scrollHeight = _scrollParent$getBoun.height;
  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
    menuBottom = _menuEl$getBoundingCl.bottom,
    menuHeight = _menuEl$getBoundingCl.height,
    menuTop = _menuEl$getBoundingCl.top;
  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
    containerTop = _menuEl$offsetParent$.top;
  var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;
  switch (preferredPlacement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      }

      // 4. Forked beviour when there isn't enough space below

      // AUTO: flip the menu, render above
      if (preferredPlacement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = preferredMaxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
        }
        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      }

      // BOTTOM: allow browser to increase scrollable area and immediately set scroll
      if (preferredPlacement === 'bottom') {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }
      break;
    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: preferredMaxHeight
        };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: 'top',
          maxHeight: preferredMaxHeight
        };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = preferredMaxHeight;

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      }

      // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below
      return {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
      };
    default:
      throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
  }
  return defaultState;
}

// Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};
var menuCSS = function menuCSS(_ref2, unstyled) {
  var _objectSpread2;
  var placement = _ref2.placement,
    _ref2$theme = _ref2.theme,
    borderRadius = _ref2$theme.borderRadius,
    spacing = _ref2$theme.spacing,
    colors = _ref2$theme.colors;
  return (0,objectSpread2/* default */.Z)((_objectSpread2 = {
    label: 'menu'
  }, (0,defineProperty/* default */.Z)(_objectSpread2, alignToControl(placement), '100%'), (0,defineProperty/* default */.Z)(_objectSpread2, "position", 'absolute'), (0,defineProperty/* default */.Z)(_objectSpread2, "width", '100%'), (0,defineProperty/* default */.Z)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
    backgroundColor: colors.neutral0,
    borderRadius: borderRadius,
    boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
    marginBottom: spacing.menuGutter,
    marginTop: spacing.menuGutter
  });
};
var PortalPlacementContext = /*#__PURE__*/(0,react.createContext)(null);

// NOTE: internal only
var MenuPlacer = function MenuPlacer(props) {
  var children = props.children,
    minMenuHeight = props.minMenuHeight,
    maxMenuHeight = props.maxMenuHeight,
    menuPlacement = props.menuPlacement,
    menuPosition = props.menuPosition,
    menuShouldScrollIntoView = props.menuShouldScrollIntoView,
    theme = props.theme;
  var _ref3 = (0,react.useContext)(PortalPlacementContext) || {},
    setPortalPlacement = _ref3.setPortalPlacement;
  var ref = (0,react.useRef)(null);
  var _useState = (0,react.useState)(maxMenuHeight),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    maxHeight = _useState2[0],
    setMaxHeight = _useState2[1];
  var _useState3 = (0,react.useState)(null),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    placement = _useState4[0],
    setPlacement = _useState4[1];
  var controlHeight = theme.spacing.controlHeight;
  (0,use_isomorphic_layout_effect_browser_esm/* default */.Z)(function () {
    var menuEl = ref.current;
    if (!menuEl) return;

    // DO NOT scroll if position is fixed
    var isFixedPosition = menuPosition === 'fixed';
    var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
    var state = getMenuPlacement({
      maxHeight: maxMenuHeight,
      menuEl: menuEl,
      minHeight: minMenuHeight,
      placement: menuPlacement,
      shouldScroll: shouldScroll,
      isFixedPosition: isFixedPosition,
      controlHeight: controlHeight
    });
    setMaxHeight(state.maxHeight);
    setPlacement(state.placement);
    setPortalPlacement === null || setPortalPlacement === void 0 ? void 0 : setPortalPlacement(state.placement);
  }, [maxMenuHeight, menuPlacement, menuPosition, menuShouldScrollIntoView, minMenuHeight, setPortalPlacement, controlHeight]);
  return children({
    ref: ref,
    placerProps: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
      placement: placement || coercePlacement(menuPlacement),
      maxHeight: maxHeight
    })
  });
};
var Menu = function Menu(props) {
  var children = props.children,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'menu', {
    menu: true
  }), {
    ref: innerRef
  }, innerProps), children);
};
var Menu$1 = Menu;

// ==============================
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4, unstyled) {
  var maxHeight = _ref4.maxHeight,
    baseUnit = _ref4.theme.spacing.baseUnit;
  return (0,objectSpread2/* default */.Z)({
    maxHeight: maxHeight,
    overflowY: 'auto',
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  }, unstyled ? {} : {
    paddingBottom: baseUnit,
    paddingTop: baseUnit
  });
};
var MenuList = function MenuList(props) {
  var children = props.children,
    innerProps = props.innerProps,
    innerRef = props.innerRef,
    isMulti = props.isMulti;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'menuList', {
    'menu-list': true,
    'menu-list--is-multi': isMulti
  }), {
    ref: innerRef
  }, innerProps), children);
};

// ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5, unstyled) {
  var _ref5$theme = _ref5.theme,
    baseUnit = _ref5$theme.spacing.baseUnit,
    colors = _ref5$theme.colors;
  return (0,objectSpread2/* default */.Z)({
    textAlign: 'center'
  }, unstyled ? {} : {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
  });
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(_ref6) {
  var _ref6$children = _ref6.children,
    children = _ref6$children === void 0 ? 'No options' : _ref6$children,
    innerProps = _ref6.innerProps,
    restProps = (0,objectWithoutProperties/* default */.Z)(_ref6, _excluded$3);
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, restProps), {}, {
    children: children,
    innerProps: innerProps
  }), 'noOptionsMessage', {
    'menu-notice': true,
    'menu-notice--no-options': true
  }), innerProps), children);
};
var LoadingMessage = function LoadingMessage(_ref7) {
  var _ref7$children = _ref7.children,
    children = _ref7$children === void 0 ? 'Loading...' : _ref7$children,
    innerProps = _ref7.innerProps,
    restProps = (0,objectWithoutProperties/* default */.Z)(_ref7, _excluded2$1);
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, restProps), {}, {
    children: children,
    innerProps: innerProps
  }), 'loadingMessage', {
    'menu-notice': true,
    'menu-notice--loading': true
  }), innerProps), children);
};

// ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref8) {
  var rect = _ref8.rect,
    offset = _ref8.offset,
    position = _ref8.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = function MenuPortal(props) {
  var appendTo = props.appendTo,
    children = props.children,
    controlElement = props.controlElement,
    innerProps = props.innerProps,
    menuPlacement = props.menuPlacement,
    menuPosition = props.menuPosition;
  var menuPortalRef = (0,react.useRef)(null);
  var cleanupRef = (0,react.useRef)(null);
  var _useState5 = (0,react.useState)(coercePlacement(menuPlacement)),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    placement = _useState6[0],
    setPortalPlacement = _useState6[1];
  var portalPlacementContext = (0,react.useMemo)(function () {
    return {
      setPortalPlacement: setPortalPlacement
    };
  }, []);
  var _useState7 = (0,react.useState)(null),
    _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
    computedPosition = _useState8[0],
    setComputedPosition = _useState8[1];
  var updateComputedPosition = (0,react.useCallback)(function () {
    if (!controlElement) return;
    var rect = getBoundingClientObj(controlElement);
    var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
    var offset = rect[placement] + scrollDistance;
    if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) {
      setComputedPosition({
        offset: offset,
        rect: rect
      });
    }
  }, [controlElement, menuPosition, placement, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width]);
  (0,use_isomorphic_layout_effect_browser_esm/* default */.Z)(function () {
    updateComputedPosition();
  }, [updateComputedPosition]);
  var runAutoUpdate = (0,react.useCallback)(function () {
    if (typeof cleanupRef.current === 'function') {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (controlElement && menuPortalRef.current) {
      cleanupRef.current = (0,floating_ui_dom/* autoUpdate */.Me)(controlElement, menuPortalRef.current, updateComputedPosition, {
        elementResize: 'ResizeObserver' in window
      });
    }
  }, [controlElement, updateComputedPosition]);
  (0,use_isomorphic_layout_effect_browser_esm/* default */.Z)(function () {
    runAutoUpdate();
  }, [runAutoUpdate]);
  var setMenuPortalElement = (0,react.useCallback)(function (menuPortalElement) {
    menuPortalRef.current = menuPortalElement;
    runAutoUpdate();
  }, [runAutoUpdate]);

  // bail early if required elements aren't present
  if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;

  // same wrapper element whether fixed or portalled
  var menuWrapper = (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    ref: setMenuPortalElement
  }, getStyleProps((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    offset: computedPosition.offset,
    position: menuPosition,
    rect: computedPosition.rect
  }), 'menuPortal', {
    'menu-portal': true
  }), innerProps), children);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(PortalPlacementContext.Provider, {
    value: portalPlacementContext
  }, appendTo ? /*#__PURE__*/(0,react_dom.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

// ==============================
// Root Container
// ==============================

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
    isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : undefined,
    pointerEvents: isDisabled ? 'none' : undefined,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    isRtl = props.isRtl;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'container', {
    '--is-disabled': isDisabled,
    '--is-rtl': isRtl
  }), innerProps), children);
};

// ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2, unstyled) {
  var spacing = _ref2.theme.spacing,
    isMulti = _ref2.isMulti,
    hasValue = _ref2.hasValue,
    controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
  return (0,objectSpread2/* default */.Z)({
    alignItems: 'center',
    display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
    flex: 1,
    flexWrap: 'wrap',
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  }, unstyled ? {} : {
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
  });
};
var ValueContainer = function ValueContainer(props) {
  var children = props.children,
    innerProps = props.innerProps,
    isMulti = props.isMulti,
    hasValue = props.hasValue;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'valueContainer', {
    'value-container': true,
    'value-container--is-multi': isMulti,
    'value-container--has-value': hasValue
  }), innerProps), children);
};

// ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'indicatorsContainer', {
    indicators: true
  }), innerProps), children);
};
var _templateObject;
var _excluded$2 = ["size"],
  _excluded2 = ["innerProps", "isRtl", "size"];
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

// ==============================
// Dropdown & Clear Icons
// ==============================
var _ref2 =  true ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : 0;
var Svg = function Svg(_ref) {
  var size = _ref.size,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded$2);
  return (0,emotion_react_browser_esm/* jsx */.tZ)("svg", (0,esm_extends/* default */.Z)({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2
  }, props));
};
var CrossIcon = function CrossIcon(props) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Svg, (0,esm_extends/* default */.Z)({
    size: 20
  }, props), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Svg, (0,esm_extends/* default */.Z)({
    size: 20
  }, props), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
};

// ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3, unstyled) {
  var isFocused = _ref3.isFocused,
    _ref3$theme = _ref3.theme,
    baseUnit = _ref3$theme.spacing.baseUnit,
    colors = _ref3$theme.colors;
  return (0,objectSpread2/* default */.Z)({
    label: 'indicatorContainer',
    display: 'flex',
    transition: 'color 150ms'
  }, unstyled ? {} : {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    padding: baseUnit * 2,
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  });
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'dropdownIndicator', {
    indicator: true,
    'dropdown-indicator': true
  }), innerProps), children || (0,emotion_react_browser_esm/* jsx */.tZ)(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'clearIndicator', {
    indicator: true,
    'clear-indicator': true
  }), innerProps), children || (0,emotion_react_browser_esm/* jsx */.tZ)(CrossIcon, null));
};

// ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4, unstyled) {
  var isDisabled = _ref4.isDisabled,
    _ref4$theme = _ref4.theme,
    baseUnit = _ref4$theme.spacing.baseUnit,
    colors = _ref4$theme.colors;
  return (0,objectSpread2/* default */.Z)({
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    width: 1
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2
  });
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("span", (0,esm_extends/* default */.Z)({}, innerProps, getStyleProps(props, 'indicatorSeparator', {
    'indicator-separator': true
  })));
};

// ==============================
// Loading
// ==============================

var loadingDotAnimations = (0,emotion_react_browser_esm/* keyframes */.F4)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5, unstyled) {
  var isFocused = _ref5.isFocused,
    size = _ref5.size,
    _ref5$theme = _ref5.theme,
    colors = _ref5$theme.colors,
    baseUnit = _ref5$theme.spacing.baseUnit;
  return (0,objectSpread2/* default */.Z)({
    label: 'loadingIndicator',
    display: 'flex',
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  }, unstyled ? {} : {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    padding: baseUnit * 2
  });
};
var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
    offset = _ref6.offset;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : undefined,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    },  true ? "" : 0,  true ? "" : 0)
  });
};
var LoadingIndicator = function LoadingIndicator(_ref7) {
  var innerProps = _ref7.innerProps,
    isRtl = _ref7.isRtl,
    _ref7$size = _ref7.size,
    size = _ref7$size === void 0 ? 4 : _ref7$size,
    restProps = (0,objectWithoutProperties/* default */.Z)(_ref7, _excluded2);
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, restProps), {}, {
    innerProps: innerProps,
    isRtl: isRtl,
    size: size
  }), 'loadingIndicator', {
    indicator: true,
    'loading-indicator': true
  }), innerProps), (0,emotion_react_browser_esm/* jsx */.tZ)(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(LoadingDot, {
    delay: 160,
    offset: true
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
var css$1 = function css(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    _ref$theme = _ref.theme,
    colors = _ref$theme.colors,
    borderRadius = _ref$theme.borderRadius,
    spacing = _ref$theme.spacing;
  return (0,objectSpread2/* default */.Z)({
    label: 'control',
    alignItems: 'center',
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms'
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  });
};
var Control = function Control(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    innerRef = props.innerRef,
    innerProps = props.innerProps,
    menuIsOpen = props.menuIsOpen;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    ref: innerRef
  }, getStyleProps(props, 'control', {
    control: true,
    'control--is-disabled': isDisabled,
    'control--is-focused': isFocused,
    'control--menu-is-open': menuIsOpen
  }), innerProps, {
    "aria-disabled": isDisabled || undefined
  }), children);
};
var Control$1 = Control;
var _excluded$1 = ["data"];
var groupCSS = function groupCSS(_ref, unstyled) {
  var spacing = _ref.theme.spacing;
  return unstyled ? {} : {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};
var Group = function Group(props) {
  var children = props.children,
    cx = props.cx,
    getStyles = props.getStyles,
    getClassNames = props.getClassNames,
    Heading = props.Heading,
    headingProps = props.headingProps,
    innerProps = props.innerProps,
    label = props.label,
    theme = props.theme,
    selectProps = props.selectProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'group', {
    group: true
  }), innerProps), (0,emotion_react_browser_esm/* jsx */.tZ)(Heading, (0,esm_extends/* default */.Z)({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    getClassNames: getClassNames,
    cx: cx
  }), label), (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS(_ref2, unstyled) {
  var _ref2$theme = _ref2.theme,
    colors = _ref2$theme.colors,
    spacing = _ref2$theme.spacing;
  return (0,objectSpread2/* default */.Z)({
    label: 'group',
    cursor: 'default',
    display: 'block'
  }, unstyled ? {} : {
    color: colors.neutral40,
    fontSize: '75%',
    fontWeight: 500,
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  });
};
var GroupHeading = function GroupHeading(props) {
  var _cleanCommonProps = cleanCommonProps(props);
  _cleanCommonProps.data;
  var innerProps = (0,objectWithoutProperties/* default */.Z)(_cleanCommonProps, _excluded$1);
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'groupHeading', {
    'group-heading': true
  }), innerProps));
};
var Group$1 = Group;
var _excluded = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    value = _ref.value,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
    visibility: isDisabled ? 'hidden' : 'visible',
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: value ? 'translateZ(0)' : ''
  }, containerStyle), unstyled ? {} : {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    color: colors.neutral80
  });
};
var spacingStyle = {
  gridArea: '1 / 2',
  font: 'inherit',
  minWidth: '2px',
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: '1 1 auto',
  display: 'inline-grid',
  gridArea: '1 / 1 / 2 / 3',
  gridTemplateColumns: '0 min-content',
  '&:after': (0,objectSpread2/* default */.Z)({
    content: 'attr(data-value) " "',
    visibility: 'hidden',
    whiteSpace: 'pre'
  }, spacingStyle)
};
var inputStyle = function inputStyle(isHidden) {
  return (0,objectSpread2/* default */.Z)({
    label: 'input',
    color: 'inherit',
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: '100%'
  }, spacingStyle);
};
var Input = function Input(props) {
  var cx = props.cx,
    value = props.value;
  var _cleanCommonProps = cleanCommonProps(props),
    innerRef = _cleanCommonProps.innerRef,
    isDisabled = _cleanCommonProps.isDisabled,
    isHidden = _cleanCommonProps.isHidden,
    inputClassName = _cleanCommonProps.inputClassName,
    innerProps = (0,objectWithoutProperties/* default */.Z)(_cleanCommonProps, _excluded);
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'input', {
    'input-container': true
  }), {
    "data-value": value || ''
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("input", (0,esm_extends/* default */.Z)({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};
var Input$1 = Input;
var multiValueCSS = function multiValueCSS(_ref, unstyled) {
  var _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    borderRadius = _ref$theme.borderRadius,
    colors = _ref$theme.colors;
  return (0,objectSpread2/* default */.Z)({
    label: 'multiValue',
    display: 'flex',
    minWidth: 0
  }, unstyled ? {} : {
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    margin: spacing.baseUnit / 2
  });
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2, unstyled) {
  var _ref2$theme = _ref2.theme,
    borderRadius = _ref2$theme.borderRadius,
    colors = _ref2$theme.colors,
    cropWithEllipsis = _ref2.cropWithEllipsis;
  return (0,objectSpread2/* default */.Z)({
    overflow: 'hidden',
    textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
    whiteSpace: 'nowrap'
  }, unstyled ? {} : {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    padding: 3,
    paddingLeft: 6
  });
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3, unstyled) {
  var _ref3$theme = _ref3.theme,
    spacing = _ref3$theme.spacing,
    borderRadius = _ref3$theme.borderRadius,
    colors = _ref3$theme.colors,
    isFocused = _ref3.isFocused;
  return (0,objectSpread2/* default */.Z)({
    alignItems: 'center',
    display: 'flex'
  }, unstyled ? {} : {
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused ? colors.dangerLight : undefined,
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  });
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
    innerProps = _ref4.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children,
    innerProps = _ref5.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    role: "button"
  }, innerProps), children || (0,emotion_react_browser_esm/* jsx */.tZ)(CrossIcon, {
    size: 14
  }));
}
var MultiValue = function MultiValue(props) {
  var children = props.children,
    components = props.components,
    data = props.data,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    removeProps = props.removeProps,
    selectProps = props.selectProps;
  var Container = components.Container,
    Label = components.Label,
    Remove = components.Remove;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Container, {
    data: data,
    innerProps: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, getStyleProps(props, 'multiValue', {
      'multi-value': true,
      'multi-value--is-disabled': isDisabled
    })), innerProps),
    selectProps: selectProps
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Label, {
    data: data,
    innerProps: (0,objectSpread2/* default */.Z)({}, getStyleProps(props, 'multiValueLabel', {
      'multi-value__label': true
    })),
    selectProps: selectProps
  }, children), (0,emotion_react_browser_esm/* jsx */.tZ)(Remove, {
    data: data,
    innerProps: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, getStyleProps(props, 'multiValueRemove', {
      'multi-value__remove': true
    })), {}, {
      'aria-label': "Remove ".concat(children || 'option')
    }, removeProps),
    selectProps: selectProps
  }));
};
var MultiValue$1 = MultiValue;
var optionCSS = function optionCSS(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    isSelected = _ref.isSelected,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return (0,objectSpread2/* default */.Z)({
    label: 'option',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
  }, unstyled ? {} : {
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
    }
  });
};
var Option = function Option(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    isSelected = props.isSelected,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'option', {
    option: true,
    'option--is-disabled': isDisabled,
    'option--is-focused': isFocused,
    'option--is-selected': isSelected
  }), {
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};
var Option$1 = Option;
var placeholderCSS = function placeholderCSS(_ref, unstyled) {
  var _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return (0,objectSpread2/* default */.Z)({
    label: 'placeholder',
    gridArea: '1 / 1 / 2 / 3'
  }, unstyled ? {} : {
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  });
};
var Placeholder = function Placeholder(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'placeholder', {
    placeholder: true
  }), innerProps), children);
};
var Placeholder$1 = Placeholder;
var css = function css(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return (0,objectSpread2/* default */.Z)({
    label: 'singleValue',
    gridArea: '1 / 1 / 2 / 3',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }, unstyled ? {} : {
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  });
};
var SingleValue = function SingleValue(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'singleValue', {
    'single-value': true,
    'single-value--is-disabled': isDisabled
  }), innerProps), children);
};
var SingleValue$1 = SingleValue;
var components = {
  ClearIndicator: ClearIndicator,
  Control: Control$1,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group$1,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input$1,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu$1,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue$1,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option$1,
  Placeholder: Placeholder$1,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue$1,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, components), props.components);
};


/***/ }),

/***/ 12285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ StateManagedSelect$1; }
});

// UNUSED EXPORTS: NonceProvider, components, createFilter, defaultTheme, mergeStyles, useStateManager

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/react-select/dist/useStateManager-7e1e8489.esm.js




var _excluded = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(_ref) {
  var _ref$defaultInputValu = _ref.defaultInputValue,
    defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu,
    _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen,
    defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
    propsInputValue = _ref.inputValue,
    propsMenuIsOpen = _ref.menuIsOpen,
    propsOnChange = _ref.onChange,
    propsOnInputChange = _ref.onInputChange,
    propsOnMenuClose = _ref.onMenuClose,
    propsOnMenuOpen = _ref.onMenuOpen,
    propsValue = _ref.value,
    restSelectProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  var _useState = (0,react.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    stateInputValue = _useState2[0],
    setStateInputValue = _useState2[1];
  var _useState3 = (0,react.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    stateMenuIsOpen = _useState4[0],
    setStateMenuIsOpen = _useState4[1];
  var _useState5 = (0,react.useState)(propsValue !== undefined ? propsValue : defaultValue),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    stateValue = _useState6[0],
    setStateValue = _useState6[1];
  var onChange = (0,react.useCallback)(function (value, actionMeta) {
    if (typeof propsOnChange === 'function') {
      propsOnChange(value, actionMeta);
    }
    setStateValue(value);
  }, [propsOnChange]);
  var onInputChange = (0,react.useCallback)(function (value, actionMeta) {
    var newValue;
    if (typeof propsOnInputChange === 'function') {
      newValue = propsOnInputChange(value, actionMeta);
    }
    setStateInputValue(newValue !== undefined ? newValue : value);
  }, [propsOnInputChange]);
  var onMenuOpen = (0,react.useCallback)(function () {
    if (typeof propsOnMenuOpen === 'function') {
      propsOnMenuOpen();
    }
    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = (0,react.useCallback)(function () {
    if (typeof propsOnMenuClose === 'function') {
      propsOnMenuClose();
    }
    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== undefined ? propsValue : stateValue;
  return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, restSelectProps), {}, {
    inputValue: inputValue,
    menuIsOpen: menuIsOpen,
    onChange: onChange,
    onInputChange: onInputChange,
    onMenuClose: onMenuClose,
    onMenuOpen: onMenuOpen,
    value: value
  });
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6223);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(79427);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(34766);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js
var createSuper = __webpack_require__(56302);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
// EXTERNAL MODULE: ./node_modules/react-select/dist/index-641ee5b8.esm.js + 1 modules
var index_641ee5b8_esm = __webpack_require__(50976);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js + 6 modules
var emotion_react_browser_esm = __webpack_require__(17867);
;// CONCATENATED MODULE: ./node_modules/memoize-one/dist/memoize-one.esm.js
var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === 'number' && value !== value;
};
function isEqual(first, second) {
  if (first === second) {
    return true;
  }
  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }
  return false;
}
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i = 0; i < newInputs.length; i++) {
    if (!isEqual(newInputs[i], lastInputs[i])) {
      return false;
    }
  }
  return true;
}
function memoizeOne(resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = areInputsEqual;
  }
  var cache = null;
  function memoized() {
    var newArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }
    if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) {
      return cache.lastResult;
    }
    var lastResult = resultFn.apply(this, newArgs);
    cache = {
      lastResult: lastResult,
      lastArgs: newArgs,
      lastThis: this
    };
    return lastResult;
  }
  memoized.clear = function clear() {
    cache = null;
  };
  return memoized;
}

;// CONCATENATED MODULE: ./node_modules/react-select/dist/Select-ef7c0426.esm.js













function _EMOTION_STRINGIFIED_CSS_ERROR__$2() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

// Assistive text to describe visual elements. Hidden for sighted users.
var _ref =  true ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : 0;
var A11yText = function A11yText(props) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)("span", (0,esm_extends/* default */.Z)({
    css: _ref
  }, props));
};
var A11yText$1 = A11yText;
var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable,
      isMulti = props.isMulti,
      tabSelectsValue = props.tabSelectsValue,
      context = props.context,
      isInitialFocus = props.isInitialFocus;
    switch (context) {
      case 'menu':
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
      case 'input':
        return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
      case 'value':
        return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
      default:
        return '';
    }
  },
  onChange: function onChange(props) {
    var action = props.action,
      _props$label = props.label,
      label = _props$label === void 0 ? '' : _props$label,
      labels = props.labels,
      isDisabled = props.isDisabled;
    switch (action) {
      case 'deselect-option':
      case 'pop-value':
      case 'remove-value':
        return "option ".concat(label, ", deselected.");
      case 'clear':
        return 'All selected options have been cleared.';
      case 'initial-input-focus':
        return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
      case 'select-option':
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
      default:
        return '';
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context,
      focused = props.focused,
      options = props.options,
      _props$label2 = props.label,
      label = _props$label2 === void 0 ? '' : _props$label2,
      selectValue = props.selectValue,
      isDisabled = props.isDisabled,
      isSelected = props.isSelected,
      isAppleDevice = props.isAppleDevice;
    var getArrayIndex = function getArrayIndex(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
    };
    if (context === 'value' && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }
    if (context === 'menu' && isAppleDevice) {
      var disabled = isDisabled ? ' disabled' : '';
      var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
      return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
    }
    return '';
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue,
      resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
  }
};
var LiveRegion = function LiveRegion(props) {
  var ariaSelection = props.ariaSelection,
    focusedOption = props.focusedOption,
    focusedValue = props.focusedValue,
    focusableOptions = props.focusableOptions,
    isFocused = props.isFocused,
    selectValue = props.selectValue,
    selectProps = props.selectProps,
    id = props.id,
    isAppleDevice = props.isAppleDevice;
  var ariaLiveMessages = selectProps.ariaLiveMessages,
    getOptionLabel = selectProps.getOptionLabel,
    inputValue = selectProps.inputValue,
    isMulti = selectProps.isMulti,
    isOptionDisabled = selectProps.isOptionDisabled,
    isSearchable = selectProps.isSearchable,
    menuIsOpen = selectProps.menuIsOpen,
    options = selectProps.options,
    screenReaderStatus = selectProps.screenReaderStatus,
    tabSelectsValue = selectProps.tabSelectsValue,
    isLoading = selectProps.isLoading;
  var ariaLabel = selectProps['aria-label'];
  var ariaLive = selectProps['aria-live'];

  // Update aria live message configuration when prop changes
  var messages = (0,react.useMemo)(function () {
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]);

  // Update aria live selected option when prop changes
  var ariaSelected = (0,react.useMemo)(function () {
    var message = '';
    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option,
        selectedOptions = ariaSelection.options,
        removedValue = ariaSelection.removedValue,
        removedValues = ariaSelection.removedValues,
        value = ariaSelection.value;
      // select-option when !isMulti does not return option so we assume selected option is value
      var asOption = function asOption(val) {
        return !Array.isArray(val) ? val : null;
      };

      // If there is just one item from the action then get its label
      var selected = removedValue || option || asOption(value);
      var label = selected ? getOptionLabel(selected) : '';

      // If there are multiple items from the action then return an array of labels
      var multiSelected = selectedOptions || removedValues || undefined;
      var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
      var onChangeProps = (0,objectSpread2/* default */.Z)({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: selected && isOptionDisabled(selected, selectValue),
        label: label,
        labels: labels
      }, ariaSelection);
      message = messages.onChange(onChangeProps);
    }
    return message;
  }, [ariaSelection, messages, isOptionDisabled, selectValue, getOptionLabel]);
  var ariaFocused = (0,react.useMemo)(function () {
    var focusMsg = '';
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused: focused,
        label: getOptionLabel(focused),
        isDisabled: isOptionDisabled(focused, selectValue),
        isSelected: isSelected,
        options: focusableOptions,
        context: focused === focusedOption ? 'menu' : 'value',
        selectValue: selectValue,
        isAppleDevice: isAppleDevice
      };
      focusMsg = messages.onFocus(onFocusProps);
    }
    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel, isOptionDisabled, messages, focusableOptions, selectValue, isAppleDevice]);
  var ariaResults = (0,react.useMemo)(function () {
    var resultsMsg = '';
    if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
      var resultsMessage = screenReaderStatus({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue: inputValue,
        resultsMessage: resultsMessage
      });
    }
    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options, screenReaderStatus, isLoading]);
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
  var ariaGuidance = (0,react.useMemo)(function () {
    var guidanceMsg = '';
    if (messages.guidance) {
      var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
      guidanceMsg = messages.guidance({
        'aria-label': ariaLabel,
        context: context,
        isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
        isMulti: isMulti,
        isSearchable: isSearchable,
        tabSelectsValue: tabSelectsValue,
        isInitialFocus: isInitialFocus
      });
    }
    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue, isInitialFocus]);
  var ScreenReaderText = (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    id: "aria-selection"
  }, ariaSelected), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    id: "aria-focused"
  }, ariaFocused), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    id: "aria-results"
  }, ariaResults), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    id: "aria-guidance"
  }, ariaGuidance));
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(A11yText$1, {
    id: id
  }, isInitialFocus && ScreenReaderText), (0,emotion_react_browser_esm/* jsx */.tZ)(A11yText$1, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};
var LiveRegion$1 = LiveRegion;
var diacritics = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp('[' + diacritics.map(function (d) {
  return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};
for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];
  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}
var stripDiacritics = function stripDiacritics(str) {
  return str.replace(anyDiacritic, function (match) {
    return diacriticToBase[match];
  });
};
var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics);
var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};
var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    // eslint-disable-next-line no-underscore-dangle
    if (option.data.__isNew__) return true;
    var _ignoreCase$ignoreAcc = (0,objectSpread2/* default */.Z)({
        ignoreCase: true,
        ignoreAccents: true,
        stringify: defaultStringify,
        trim: true,
        matchFrom: 'any'
      }, config),
      ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
      ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
      stringify = _ignoreCase$ignoreAcc.stringify,
      trim = _ignoreCase$ignoreAcc.trim,
      matchFrom = _ignoreCase$ignoreAcc.matchFrom;
    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};
var Select_ef7c0426_esm_excluded = ["innerRef"];
function DummyInput(_ref) {
  var innerRef = _ref.innerRef,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, Select_ef7c0426_esm_excluded);
  // Remove animation props not meant for HTML elements
  var filteredProps = (0,index_641ee5b8_esm.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
  return (0,emotion_react_browser_esm/* jsx */.tZ)("input", (0,esm_extends/* default */.Z)({
    ref: innerRef
  }, filteredProps, {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
      label: 'dummyInput',
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: 'transparent',
      fontSize: 'inherit',
      gridArea: '1 / 1 / 2 / 3',
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: 'transparent',
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: 'relative',
      transform: 'scale(.01)'
    },  true ? "" : 0,  true ? "" : 0)
  }));
}
var cancelScroll = function cancelScroll(event) {
  if (event.cancelable) event.preventDefault();
  event.stopPropagation();
};
function useScrollCapture(_ref) {
  var isEnabled = _ref.isEnabled,
    onBottomArrive = _ref.onBottomArrive,
    onBottomLeave = _ref.onBottomLeave,
    onTopArrive = _ref.onTopArrive,
    onTopLeave = _ref.onTopLeave;
  var isBottom = (0,react.useRef)(false);
  var isTop = (0,react.useRef)(false);
  var touchStart = (0,react.useRef)(0);
  var scrollTarget = (0,react.useRef)(null);
  var handleEventDelta = (0,react.useCallback)(function (event, delta) {
    if (scrollTarget.current === null) return;
    var _scrollTarget$current = scrollTarget.current,
      scrollTop = _scrollTarget$current.scrollTop,
      scrollHeight = _scrollTarget$current.scrollHeight,
      clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false;

    // reset bottom/top flags
    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave) onBottomLeave(event);
      isBottom.current = false;
    }
    if (isDeltaPositive && isTop.current) {
      if (onTopLeave) onTopLeave(event);
      isTop.current = false;
    }

    // bottom limit
    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }
      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true;

      // top limit
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }
      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    }

    // cancel scroll
    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = (0,react.useCallback)(function (event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = (0,react.useCallback)(function (event) {
    // set touch start so we can calculate touchmove delta
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = (0,react.useCallback)(function (event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = (0,react.useCallback)(function (el) {
    // bail early if no element is available to attach to
    if (!el) return;
    var notPassive = index_641ee5b8_esm.s ? {
      passive: false
    } : false;
    el.addEventListener('wheel', onWheel, notPassive);
    el.addEventListener('touchstart', onTouchStart, notPassive);
    el.addEventListener('touchmove', onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = (0,react.useCallback)(function (el) {
    // bail early if no element is available to detach from
    if (!el) return;
    el.removeEventListener('wheel', onWheel, false);
    el.removeEventListener('touchstart', onTouchStart, false);
    el.removeEventListener('touchmove', onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  (0,react.useEffect)(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    startListening(element);
    return function () {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function (element) {
    scrollTarget.current = element;
  };
}
var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};
function preventTouchMove(e) {
  if (e.cancelable) e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;
  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}

// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref) {
  var isEnabled = _ref.isEnabled,
    _ref$accountForScroll = _ref.accountForScrollbars,
    accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = (0,react.useRef)({});
  var scrollTarget = (0,react.useRef)(null);
  var addScrollLock = (0,react.useCallback)(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;
    if (accountForScrollbars) {
      // store any styles already applied to the body
      STYLE_KEYS.forEach(function (key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    }

    // apply the lock styles and padding if this is the first scroll lock
    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function (key) {
        var val = LOCK_STYLES[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    }

    // account for touch devices
    if (target && isTouchDevice()) {
      // Mobile Safari ignores { overflow: hidden } declaration on the body.
      target.addEventListener('touchmove', preventTouchMove, listenerOptions);

      // Allow scroll on provided target
      if (touchScrollTarget) {
        touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }

    // increment active scroll locks
    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = (0,react.useCallback)(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;

    // safely decrement active scroll locks
    activeScrollLocks = Math.max(activeScrollLocks - 1, 0);

    // reapply original body styles, if any
    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function (key) {
        var val = originalStyles.current[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    }

    // remove touch listeners
    if (target && isTouchDevice()) {
      target.removeEventListener('touchmove', preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  (0,react.useEffect)(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function () {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function (element) {
    scrollTarget.current = element;
  };
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var blurSelectInput = function blurSelectInput(event) {
  var element = event.target;
  return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var _ref2$1 =  true ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : 0;
function ScrollManager(_ref) {
  var children = _ref.children,
    lockEnabled = _ref.lockEnabled,
    _ref$captureEnabled = _ref.captureEnabled,
    captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled,
    onBottomArrive = _ref.onBottomArrive,
    onBottomLeave = _ref.onBottomLeave,
    onTopArrive = _ref.onTopArrive,
    onTopLeave = _ref.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive: onBottomArrive,
    onBottomLeave: onBottomLeave,
    onTopArrive: onTopArrive,
    onTopLeave: onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });
  var targetRef = function targetRef(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, lockEnabled && (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    onClick: blurSelectInput,
    css: _ref2$1
  }), children(targetRef));
}
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref2 =  true ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : 0;
var RequiredInput = function RequiredInput(_ref) {
  var name = _ref.name,
    onFocus = _ref.onFocus;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("input", {
    required: true,
    name: name,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: onFocus,
    css: _ref2
    // Prevent `Switching from uncontrolled to controlled` error
    ,

    value: "",
    onChange: function onChange() {}
  });
};
var RequiredInput$1 = RequiredInput;

/// <reference types="user-agent-data-types" />

function testPlatform(re) {
  var _window$navigator$use;
  return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function isIPhone() {
  return testPlatform(/^iPhone/i);
}
function isMac() {
  return testPlatform(/^Mac/i);
}
function isIPad() {
  return testPlatform(/^iPad/i) ||
  // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  isMac() && navigator.maxTouchPoints > 1;
}
function isIOS() {
  return isIPhone() || isIPad();
}
function isAppleDevice() {
  return isMac() || isIOS();
}
var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};
var defaultStyles = {
  clearIndicator: index_641ee5b8_esm.a,
  container: index_641ee5b8_esm.b,
  control: index_641ee5b8_esm.d,
  dropdownIndicator: index_641ee5b8_esm.e,
  group: index_641ee5b8_esm.g,
  groupHeading: index_641ee5b8_esm.f,
  indicatorsContainer: index_641ee5b8_esm.i,
  indicatorSeparator: index_641ee5b8_esm.h,
  input: index_641ee5b8_esm.j,
  loadingIndicator: index_641ee5b8_esm.l,
  loadingMessage: index_641ee5b8_esm.k,
  menu: index_641ee5b8_esm.m,
  menuList: index_641ee5b8_esm.n,
  menuPortal: index_641ee5b8_esm.o,
  multiValue: index_641ee5b8_esm.p,
  multiValueLabel: index_641ee5b8_esm.q,
  multiValueRemove: index_641ee5b8_esm.t,
  noOptionsMessage: index_641ee5b8_esm.u,
  option: index_641ee5b8_esm.v,
  placeholder: index_641ee5b8_esm.w,
  singleValue: index_641ee5b8_esm.x,
  valueContainer: index_641ee5b8_esm.y
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // initialize with source styles
  var styles = _objectSpread({}, source);

  // massage in target styles
  Object.keys(target).forEach(function (keyAsString) {
    var key = keyAsString;
    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });
  return styles;
}
var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var baseUnit = 4;
// The minimum height of the control
var controlHeight = 38;
// The amount of space between the control and menu */
var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};
var defaultProps = {
  'aria-live': 'polite',
  backspaceRemovesValue: true,
  blurInputOnSelect: (0,index_641ee5b8_esm.z)(),
  captureMenuScroll: !(0,index_641ee5b8_esm.z)(),
  classNames: {},
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !(0,index_641ee5b8_esm.A)(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true,
  unstyled: false
};
function toCategorizedOption(props, option, selectValue, index) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);
  var isSelected = _isOptionSelected(props, option, selectValue);
  var label = getOptionLabel(props, option);
  var value = getOptionValue(props, option);
  return {
    type: 'option',
    data: option,
    isDisabled: isDisabled,
    isSelected: isSelected,
    label: label,
    value: value,
    index: index
  };
}
function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function (groupOrOption, groupOrOptionIndex) {
    if ('options' in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function (option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function (categorizedOption) {
        return isFocusable(props, categorizedOption);
      });
      return categorizedOptions.length > 0 ? {
        type: 'group',
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : undefined;
    }
    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
  }).filter(index_641ee5b8_esm.K);
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === 'group') {
      optionsAccumulator.push.apply(optionsAccumulator, (0,toConsumableArray/* default */.Z)(categorizedOption.options.map(function (option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptionsWithIds(categorizedOptions, optionId) {
  return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === 'group') {
      optionsAccumulator.push.apply(optionsAccumulator, (0,toConsumableArray/* default */.Z)(categorizedOption.options.map(function (option) {
        return {
          data: option.data,
          id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
        };
      })));
    } else {
      optionsAccumulator.push({
        data: categorizedOption.data,
        id: "".concat(optionId, "-").concat(categorizedOption.index)
      });
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue,
    inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
  var data = categorizedOption.data,
    isSelected = categorizedOption.isSelected,
    label = categorizedOption.label,
    value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label: label,
    value: value,
    data: data
  }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue,
    lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
    if (nextFocusedIndex > -1) {
      // the focused value is still in the selectValue, return it
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      // the focusedValue is not present in the next selectValue array by
      // reference, so return the new value at the same index
      return nextSelectValue[lastFocusedIndex];
    }
  }
  return null;
}
function getNextFocusedOption(state, options) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
  var _focusableOptionsWith;
  var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function (option) {
    return option.data === focusedOption;
  })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
  return focusedOptionId || null;
};
var getOptionLabel = function getOptionLabel(props, data) {
  return props.getOptionLabel(data);
};
var getOptionValue = function getOptionValue(props, data) {
  return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1) return true;
  if (typeof props.isOptionSelected === 'function') {
    return props.isOptionSelected(option, selectValue);
  }
  var candidate = getOptionValue(props, option);
  return selectValue.some(function (i) {
    return getOptionValue(props, i) === candidate;
  });
}
function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
  var hideSelectedOptions = props.hideSelectedOptions,
    isMulti = props.isMulti;
  if (hideSelectedOptions === undefined) return isMulti;
  return hideSelectedOptions;
};
var instanceId = 1;
var Select = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(Select, _Component);
  var _super = (0,createSuper/* default */.Z)(Select);
  // Misc. Instance Properties
  // ------------------------------

  // TODO

  // Refs
  // ------------------------------

  // Lifecycle
  // ------------------------------

  function Select(_props) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, Select);
    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: undefined,
      prevProps: undefined,
      instancePrefix: '',
      isAppleDevice: false
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;
    _this.getControlRef = function (ref) {
      _this.controlRef = ref;
    };
    _this.focusedOptionRef = null;
    _this.getFocusedOptionRef = function (ref) {
      _this.focusedOptionRef = ref;
    };
    _this.menuListRef = null;
    _this.getMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };
    _this.inputRef = null;
    _this.getInputRef = function (ref) {
      _this.inputRef = ref;
    };
    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;
    _this.onChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        name = _this$props.name;
      actionMeta.name = name;
      _this.ariaOnChange(newValue, actionMeta);
      onChange(newValue, actionMeta);
    };
    _this.setValue = function (newValue, action, option) {
      var _this$props2 = _this.props,
        closeMenuOnSelect = _this$props2.closeMenuOnSelect,
        isMulti = _this$props2.isMulti,
        inputValue = _this$props2.inputValue;
      _this.onInputChange('', {
        action: 'set-value',
        prevInputValue: inputValue
      });
      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      }
      // when the select value should change, we should reset focusedValue
      _this.setState({
        clearFocusValueOnUpdate: true
      });
      _this.onChange(newValue, {
        action: action,
        option: option
      });
    };
    _this.selectOption = function (newValue) {
      var _this$props3 = _this.props,
        blurInputOnSelect = _this$props3.blurInputOnSelect,
        isMulti = _this$props3.isMulti,
        name = _this$props3.name;
      var selectValue = _this.state.selectValue;
      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
      var isDisabled = _this.isOptionDisabled(newValue, selectValue);
      if (deselected) {
        var candidate = _this.getOptionValue(newValue);
        _this.setValue((0,index_641ee5b8_esm.B)(selectValue.filter(function (i) {
          return _this.getOptionValue(i) !== candidate;
        })), 'deselect-option', newValue);
      } else if (!isDisabled) {
        // Select option if option is not disabled
        if (isMulti) {
          _this.setValue((0,index_641ee5b8_esm.B)([].concat((0,toConsumableArray/* default */.Z)(selectValue), [newValue])), 'select-option', newValue);
        } else {
          _this.setValue((0,index_641ee5b8_esm.C)(newValue), 'select-option');
        }
      } else {
        _this.ariaOnChange((0,index_641ee5b8_esm.C)(newValue), {
          action: 'select-option',
          option: newValue,
          name: name
        });
        return;
      }
      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };
    _this.removeValue = function (removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var candidate = _this.getOptionValue(removedValue);
      var newValueArray = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });
      var newValue = (0,index_641ee5b8_esm.D)(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: 'remove-value',
        removedValue: removedValue
      });
      _this.focusInput();
    };
    _this.clearValue = function () {
      var selectValue = _this.state.selectValue;
      _this.onChange((0,index_641ee5b8_esm.D)(_this.props.isMulti, [], null), {
        action: 'clear',
        removedValues: selectValue
      });
    };
    _this.popValue = function () {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = (0,index_641ee5b8_esm.D)(isMulti, newValueArray, newValueArray[0] || null);
      if (lastSelectedValue) {
        _this.onChange(newValue, {
          action: 'pop-value',
          removedValue: lastSelectedValue
        });
      }
    };
    _this.getFocusedOptionId = function (focusedOption) {
      return getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
    };
    _this.getFocusableOptionsWithIds = function () {
      return buildFocusableOptionsWithIds(buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
    };
    _this.getValue = function () {
      return _this.state.selectValue;
    };
    _this.cx = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return index_641ee5b8_esm.E.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };
    _this.getOptionLabel = function (data) {
      return getOptionLabel(_this.props, data);
    };
    _this.getOptionValue = function (data) {
      return getOptionValue(_this.props, data);
    };
    _this.getStyles = function (key, props) {
      var unstyled = _this.props.unstyled;
      var base = defaultStyles[key](props, unstyled);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };
    _this.getClassNames = function (key, props) {
      var _this$props$className, _this$props$className2;
      return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
    };
    _this.getElementId = function (element) {
      return "".concat(_this.state.instancePrefix, "-").concat(element);
    };
    _this.getComponents = function () {
      return (0,index_641ee5b8_esm.F)(_this.props);
    };
    _this.buildCategorizedOptions = function () {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };
    _this.getCategorizedOptions = function () {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };
    _this.buildFocusableOptions = function () {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };
    _this.getFocusableOptions = function () {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };
    _this.ariaOnChange = function (value, actionMeta) {
      _this.setState({
        ariaSelection: (0,objectSpread2/* default */.Z)({
          value: value
        }, actionMeta)
      });
    };
    _this.onMenuMouseDown = function (event) {
      if (event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      _this.focusInput();
    };
    _this.onMenuMouseMove = function (event) {
      _this.blockOptionHover = false;
    };
    _this.onControlMouseDown = function (event) {
      // Event captured by dropdown indicator
      if (event.defaultPrevented) {
        return;
      }
      var openMenuOnClick = _this.props.openMenuOnClick;
      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }
        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          _this.onMenuClose();
        }
      }
      if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
        event.preventDefault();
      }
    };
    _this.onDropdownIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
        isMulti = _this$props4.isMulti,
        menuIsOpen = _this$props4.menuIsOpen;
      _this.focusInput();
      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }
      event.preventDefault();
    };
    _this.onClearIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      _this.clearValue();
      event.preventDefault();
      _this.openAfterFocus = false;
      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    };
    _this.onScroll = function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && (0,index_641ee5b8_esm.G)(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };
    _this.onCompositionStart = function () {
      _this.isComposing = true;
    };
    _this.onCompositionEnd = function () {
      _this.isComposing = false;
    };
    _this.onTouchStart = function (_ref2) {
      var touches = _ref2.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };
    _this.onTouchMove = function (_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };
    _this.onTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).
      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      }

      // reset move vars
      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };
    _this.onControlTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onControlMouseDown(event);
    };
    _this.onClearIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onClearIndicatorMouseDown(event);
    };
    _this.onDropdownIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onDropdownIndicatorMouseDown(event);
    };
    _this.handleInputChange = function (event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;
      _this.setState({
        inputIsHiddenAfterUpdate: false
      });
      _this.onInputChange(inputValue, {
        action: 'input-change',
        prevInputValue: prevInputValue
      });
      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };
    _this.onInputFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });
      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }
      _this.openAfterFocus = false;
    };
    _this.onInputBlur = function (event) {
      var prevInputValue = _this.props.inputValue;
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();
        return;
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      _this.onInputChange('', {
        action: 'input-blur',
        prevInputValue: prevInputValue
      });
      _this.onMenuClose();
      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };
    _this.onOptionHover = function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }
      var options = _this.getFocusableOptions();
      var focusedOptionIndex = options.indexOf(focusedOption);
      _this.setState({
        focusedOption: focusedOption,
        focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
      });
    };
    _this.shouldHideSelectedOptions = function () {
      return shouldHideSelectedOptions(_this.props);
    };
    _this.onValueInputFocus = function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.focus();
    };
    _this.onKeyDown = function (event) {
      var _this$props5 = _this.props,
        isMulti = _this$props5.isMulti,
        backspaceRemovesValue = _this$props5.backspaceRemovesValue,
        escapeClearsValue = _this$props5.escapeClearsValue,
        inputValue = _this$props5.inputValue,
        isClearable = _this$props5.isClearable,
        isDisabled = _this$props5.isDisabled,
        menuIsOpen = _this$props5.menuIsOpen,
        onKeyDown = _this$props5.onKeyDown,
        tabSelectsValue = _this$props5.tabSelectsValue,
        openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state,
        focusedOption = _this$state.focusedOption,
        focusedValue = _this$state.focusedValue,
        selectValue = _this$state.selectValue;
      if (isDisabled) return;
      if (typeof onKeyDown === 'function') {
        onKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      }

      // Block option hover events when the user has just pressed a key
      _this.blockOptionHover = true;
      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;
          _this.focusValue('previous');
          break;
        case 'ArrowRight':
          if (!isMulti || inputValue) return;
          _this.focusValue('next');
          break;
        case 'Delete':
        case 'Backspace':
          if (inputValue) return;
          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;
            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }
          break;
        case 'Tab':
          if (_this.isComposing) return;
          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption ||
          // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }
          _this.selectOption(focusedOption);
          break;
        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }
          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;
            _this.selectOption(focusedOption);
            break;
          }
          return;
        case 'Escape':
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange('', {
              action: 'menu-close',
              prevInputValue: inputValue
            });
            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }
          break;
        case ' ':
          // space
          if (inputValue) {
            return;
          }
          if (!menuIsOpen) {
            _this.openMenu('first');
            break;
          }
          if (!focusedOption) return;
          _this.selectOption(focusedOption);
          break;
        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }
          break;
        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }
          break;
        case 'PageUp':
          if (!menuIsOpen) return;
          _this.focusOption('pageup');
          break;
        case 'PageDown':
          if (!menuIsOpen) return;
          _this.focusOption('pagedown');
          break;
        case 'Home':
          if (!menuIsOpen) return;
          _this.focusOption('first');
          break;
        case 'End':
          if (!menuIsOpen) return;
          _this.focusOption('last');
          break;
        default:
          return;
      }
      event.preventDefault();
    };
    _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = (0,index_641ee5b8_esm.H)(_props.value);
    // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
    if (_props.menuIsOpen && _this.state.selectValue.length) {
      var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
      var focusableOptions = _this.buildFocusableOptions();
      var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
      _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
      _this.state.focusedOption = focusableOptions[optionIndex];
      _this.state.focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
    }
    return _this;
  }
  (0,createClass/* default */.Z)(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();
      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }
      if (this.props.autoFocus) {
        this.focusInput();
      }

      // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
      if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) {
        (0,index_641ee5b8_esm.I)(this.menuListRef, this.focusedOptionRef);
      }
      if (isAppleDevice()) {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({
          isAppleDevice: true
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props,
        isDisabled = _this$props6.isDisabled,
        menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;
      if (
      // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled ||
      // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }
      if (isFocused && isDisabled && !prevProps.isDisabled) {
        // ensure select state gets blurred in case Select is programmatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) {
        // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isFocused: true
        });
      }

      // scroll the focused option into view if necessary
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        (0,index_641ee5b8_esm.I)(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }

    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange('', {
        action: 'menu-close',
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }

    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    }

    // aliased for consumers
  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;
      var _this$state2 = this.state,
        selectValue = _this$state2.selectValue,
        isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }

      // only scroll if the menu isn't already open
      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex],
        focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
      }, function () {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state,
        selectValue = _this$state3.selectValue,
        focusedValue = _this$state3.focusedValue;

      // Only multiselects support value focusing
      if (!this.props.isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
      }
      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;
      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }
      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options = this.getFocusableOptions();
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'
      var focusedIndex = options.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
      }
      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null,
        focusedOptionId: this.getFocusedOptionId(options[nextFocus])
      });
    }
  }, {
    key: "getTheme",
    value:
    // ==============================
    // Getters
    // ==============================

    function getTheme() {
      // Use the default theme if there are no customisations.
      if (!this.props.theme) {
        return defaultTheme;
      }
      // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.
      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      }
      // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
        cx = this.cx,
        getStyles = this.getStyles,
        getClassNames = this.getClassNames,
        getValue = this.getValue,
        selectOption = this.selectOption,
        setValue = this.setValue,
        props = this.props;
      var isMulti = props.isMulti,
        isRtl = props.isRtl,
        options = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue: clearValue,
        cx: cx,
        getStyles: getStyles,
        getClassNames: getClassNames,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        selectProps: props,
        setValue: setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props,
        isClearable = _this$props7.isClearable,
        isMulti = _this$props7.isMulti;

      // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable
      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    }

    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value:
    // ==============================
    // Composition Handlers
    // ==============================

    function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value:
    // ==============================
    // Touch Handlers
    // ==============================

    function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value:
    // ==============================
    // Renderers
    // ==============================
    function renderInput() {
      var _this$props8 = this.props,
        isDisabled = _this$props8.isDisabled,
        isSearchable = _this$props8.isSearchable,
        inputId = _this$props8.inputId,
        inputValue = _this$props8.inputValue,
        tabIndex = _this$props8.tabIndex,
        form = _this$props8.form,
        menuIsOpen = _this$props8.menuIsOpen,
        required = _this$props8.required;
      var _this$getComponents = this.getComponents(),
        Input = _this$getComponents.Input;
      var _this$state4 = this.state,
        inputIsHidden = _this$state4.inputIsHidden,
        ariaSelection = _this$state4.ariaSelection;
      var commonProps = this.commonProps;
      var id = inputId || this.getElementId('input');

      // aria attributes makes the JSX "noisy", separated for clarity
      var ariaAttributes = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
        'aria-autocomplete': 'list',
        'aria-expanded': menuIsOpen,
        'aria-haspopup': true,
        'aria-errormessage': this.props['aria-errormessage'],
        'aria-invalid': this.props['aria-invalid'],
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby'],
        'aria-required': required,
        role: 'combobox',
        'aria-activedescendant': this.state.isAppleDevice ? undefined : this.state.focusedOptionId || ''
      }, menuIsOpen && {
        'aria-controls': this.getElementId('listbox')
      }), !isSearchable && {
        'aria-readonly': true
      }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
        'aria-describedby': this.getElementId('live-region')
      } : {
        'aria-describedby': this.getElementId('placeholder')
      });
      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/react.createElement(DummyInput, (0,esm_extends/* default */.Z)({
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: index_641ee5b8_esm.J,
          onFocus: this.onInputFocus,
          disabled: isDisabled,
          tabIndex: tabIndex,
          inputMode: "none",
          form: form,
          value: ""
        }, ariaAttributes));
      }
      return /*#__PURE__*/react.createElement(Input, (0,esm_extends/* default */.Z)({}, commonProps, {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex: tabIndex,
        form: form,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;
      var _this$getComponents2 = this.getComponents(),
        MultiValue = _this$getComponents2.MultiValue,
        MultiValueContainer = _this$getComponents2.MultiValueContainer,
        MultiValueLabel = _this$getComponents2.MultiValueLabel,
        MultiValueRemove = _this$getComponents2.MultiValueRemove,
        SingleValue = _this$getComponents2.SingleValue,
        Placeholder = _this$getComponents2.Placeholder;
      var commonProps = this.commonProps;
      var _this$props9 = this.props,
        controlShouldRenderValue = _this$props9.controlShouldRenderValue,
        isDisabled = _this$props9.isDisabled,
        isMulti = _this$props9.isMulti,
        inputValue = _this$props9.inputValue,
        placeholder = _this$props9.placeholder;
      var _this$state5 = this.state,
        selectValue = _this$state5.selectValue,
        focusedValue = _this$state5.focusedValue,
        isFocused = _this$state5.isFocused;
      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /*#__PURE__*/react.createElement(Placeholder, (0,esm_extends/* default */.Z)({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused,
          innerProps: {
            id: this.getElementId('placeholder')
          }
        }), placeholder);
      }
      if (isMulti) {
        return selectValue.map(function (opt, index) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /*#__PURE__*/react.createElement(MultiValue, (0,esm_extends/* default */.Z)({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: key,
            index: index,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, 'value'));
        });
      }
      if (inputValue) {
        return null;
      }
      var singleValue = selectValue[0];
      return /*#__PURE__*/react.createElement(SingleValue, (0,esm_extends/* default */.Z)({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(),
        ClearIndicator = _this$getComponents3.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props10 = this.props,
        isDisabled = _this$props10.isDisabled,
        isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;
      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }
      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/react.createElement(ClearIndicator, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(),
        LoadingIndicator = _this$getComponents4.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props11 = this.props,
        isDisabled = _this$props11.isDisabled,
        isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/react.createElement(LoadingIndicator, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(),
        DropdownIndicator = _this$getComponents5.DropdownIndicator,
        IndicatorSeparator = _this$getComponents5.IndicatorSeparator;

      // separator doesn't make sense without the dropdown indicator
      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /*#__PURE__*/react.createElement(IndicatorSeparator, (0,esm_extends/* default */.Z)({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(),
        DropdownIndicator = _this$getComponents6.DropdownIndicator;
      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/react.createElement(DropdownIndicator, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;
      var _this$getComponents7 = this.getComponents(),
        Group = _this$getComponents7.Group,
        GroupHeading = _this$getComponents7.GroupHeading,
        Menu = _this$getComponents7.Menu,
        MenuList = _this$getComponents7.MenuList,
        MenuPortal = _this$getComponents7.MenuPortal,
        LoadingMessage = _this$getComponents7.LoadingMessage,
        NoOptionsMessage = _this$getComponents7.NoOptionsMessage,
        Option = _this$getComponents7.Option;
      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props,
        captureMenuScroll = _this$props12.captureMenuScroll,
        inputValue = _this$props12.inputValue,
        isLoading = _this$props12.isLoading,
        loadingMessage = _this$props12.loadingMessage,
        minMenuHeight = _this$props12.minMenuHeight,
        maxMenuHeight = _this$props12.maxMenuHeight,
        menuIsOpen = _this$props12.menuIsOpen,
        menuPlacement = _this$props12.menuPlacement,
        menuPosition = _this$props12.menuPosition,
        menuPortalTarget = _this$props12.menuPortalTarget,
        menuShouldBlockScroll = _this$props12.menuShouldBlockScroll,
        menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView,
        noOptionsMessage = _this$props12.noOptionsMessage,
        onMenuScrollToTop = _this$props12.onMenuScrollToTop,
        onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen) return null;

      // TODO: Internal Option Type here
      var render = function render(props, id) {
        var type = props.type,
          data = props.data,
          isDisabled = props.isDisabled,
          isSelected = props.isSelected,
          label = props.label,
          value = props.value;
        var isFocused = focusedOption === data;
        var onHover = isDisabled ? undefined : function () {
          return _this4.onOptionHover(data);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this4.selectOption(data);
        };
        var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1,
          role: 'option',
          'aria-selected': _this4.state.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
        };
        return /*#__PURE__*/react.createElement(Option, (0,esm_extends/* default */.Z)({}, commonProps, {
          innerProps: innerProps,
          data: data,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: type,
          value: value,
          isFocused: isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
        }), _this4.formatOptionLabel(props.data, 'menu'));
      };
      var menuUI;
      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function (item) {
          if (item.type === 'group') {
            var _data = item.data,
              options = item.options,
              groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /*#__PURE__*/react.createElement(Group, (0,esm_extends/* default */.Z)({}, commonProps, {
              key: groupId,
              data: _data,
              options: options,
              Heading: GroupHeading,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this4.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item.type === 'option') {
            return render(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = /*#__PURE__*/react.createElement(LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });
        if (_message === null) return null;
        menuUI = /*#__PURE__*/react.createElement(NoOptionsMessage, commonProps, _message);
      }
      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = /*#__PURE__*/react.createElement(index_641ee5b8_esm.M, (0,esm_extends/* default */.Z)({}, commonProps, menuPlacementProps), function (_ref4) {
        var ref = _ref4.ref,
          _ref4$placerProps = _ref4.placerProps,
          placement = _ref4$placerProps.placement,
          maxHeight = _ref4$placerProps.maxHeight;
        return /*#__PURE__*/react.createElement(Menu, (0,esm_extends/* default */.Z)({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove
          },
          isLoading: isLoading,
          placement: placement
        }), /*#__PURE__*/react.createElement(ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function (scrollTargetRef) {
          return /*#__PURE__*/react.createElement(MenuList, (0,esm_extends/* default */.Z)({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);
              scrollTargetRef(instance);
            },
            innerProps: {
              role: 'listbox',
              'aria-multiselectable': commonProps.isMulti,
              id: _this4.getElementId('listbox')
            },
            isLoading: isLoading,
            maxHeight: maxHeight,
            focusedOption: focusedOption
          }), menuUI);
        }));
      });

      // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`
      return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/react.createElement(MenuPortal, (0,esm_extends/* default */.Z)({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;
      var _this$props13 = this.props,
        delimiter = _this$props13.delimiter,
        isDisabled = _this$props13.isDisabled,
        isMulti = _this$props13.isMulti,
        name = _this$props13.name,
        required = _this$props13.required;
      var selectValue = this.state.selectValue;
      if (required && !this.hasValue() && !isDisabled) {
        return /*#__PURE__*/react.createElement(RequiredInput$1, {
          name: name,
          onFocus: this.onValueInputFocus
        });
      }
      if (!name || isDisabled) return;
      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter);
          return /*#__PURE__*/react.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return /*#__PURE__*/react.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /*#__PURE__*/react.createElement("input", {
            name: name,
            type: "hidden",
            value: ""
          });
          return /*#__PURE__*/react.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
        return /*#__PURE__*/react.createElement("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state,
        ariaSelection = _this$state6.ariaSelection,
        focusedOption = _this$state6.focusedOption,
        focusedValue = _this$state6.focusedValue,
        isFocused = _this$state6.isFocused,
        selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /*#__PURE__*/react.createElement(LiveRegion$1, (0,esm_extends/* default */.Z)({}, commonProps, {
        id: this.getElementId('live-region'),
        ariaSelection: ariaSelection,
        focusedOption: focusedOption,
        focusedValue: focusedValue,
        isFocused: isFocused,
        selectValue: selectValue,
        focusableOptions: focusableOptions,
        isAppleDevice: this.state.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(),
        Control = _this$getComponents8.Control,
        IndicatorsContainer = _this$getComponents8.IndicatorsContainer,
        SelectContainer = _this$getComponents8.SelectContainer,
        ValueContainer = _this$getComponents8.ValueContainer;
      var _this$props14 = this.props,
        className = _this$props14.className,
        id = _this$props14.id,
        isDisabled = _this$props14.isDisabled,
        menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /*#__PURE__*/react.createElement(SelectContainer, (0,esm_extends/* default */.Z)({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), /*#__PURE__*/react.createElement(Control, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), /*#__PURE__*/react.createElement(ValueContainer, (0,esm_extends/* default */.Z)({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/react.createElement(IndicatorsContainer, (0,esm_extends/* default */.Z)({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps,
        clearFocusValueOnUpdate = state.clearFocusValueOnUpdate,
        inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate,
        ariaSelection = state.ariaSelection,
        isFocused = state.isFocused,
        prevWasFocused = state.prevWasFocused,
        instancePrefix = state.instancePrefix;
      var options = props.options,
        value = props.value,
        menuIsOpen = props.menuIsOpen,
        inputValue = props.inputValue,
        isMulti = props.isMulti;
      var selectValue = (0,index_641ee5b8_esm.H)(value);
      var newMenuOptionsState = {};
      if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusableOptionsWithIds = menuIsOpen ? buildFocusableOptionsWithIds(buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        var focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusedOption);
        newMenuOptionsState = {
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedOptionId: focusedOptionId,
          focusableOptionsWithIds: focusableOptionsWithIds,
          focusedValue: focusedValue,
          clearFocusValueOnUpdate: false
        };
      }
      // some updates should toggle the state of the input visibility
      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: undefined
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;
      if (isFocused && !hasKeptFocus) {
        // If `value` or `defaultValue` props are not empty then announce them
        // when the Select is initially focused
        newAriaSelection = {
          value: (0,index_641ee5b8_esm.D)(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: 'initial-input-focus'
        };
        hasKeptFocus = !prevWasFocused;
      }

      // If the 'initial-input-focus' action has been set already
      // then reset the ariaSelection to null
      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') {
        newAriaSelection = null;
      }
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);
  return Select;
}(react.Component);
Select.defaultProps = defaultProps;

// EXTERNAL MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 7 modules
var emotion_cache_browser_esm = __webpack_require__(92608);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(85202);
// EXTERNAL MODULE: ./node_modules/use-isomorphic-layout-effect/dist/use-isomorphic-layout-effect.browser.esm.js
var use_isomorphic_layout_effect_browser_esm = __webpack_require__(51858);
;// CONCATENATED MODULE: ./node_modules/react-select/dist/react-select.esm.js

























var StateManagedSelect = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var baseSelectProps = useStateManager(props);
  return /*#__PURE__*/react.createElement(Select, (0,esm_extends/* default */.Z)({
    ref: ref
  }, baseSelectProps));
});
var StateManagedSelect$1 = StateManagedSelect;
var NonceProvider = function (_ref) {
  var nonce = _ref.nonce,
    children = _ref.children,
    cacheKey = _ref.cacheKey;
  var emotionCache = useMemo(function () {
    return createCache({
      key: cacheKey,
      nonce: nonce
    });
  }, [cacheKey, nonce]);
  return /*#__PURE__*/React.createElement(CacheProvider, {
    value: emotionCache
  }, children);
};


/***/ }),

/***/ 42236:
/***/ (function(module) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) {
    obj[key] = desc.value;
  };
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    });
    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: true
  });
  defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: true
  });
  GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  exports.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction ||
    // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };
  exports.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function (arg) {
    return {
      __await: arg
    };
  };
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }
        return PromiseImpl.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function (error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }
    var previousPromise;
    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }
      return previousPromise =
      // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
      // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", {
      value: enqueue
    });
  }
  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };
  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;
    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }
      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per GeneratorResume behavior specified since ES2015:
        // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
        // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
        return doneResult();
      }
      context.method = method;
      context.arg = arg;
      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }
          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }
        state = GenStateExecuting;
        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;
          if (record.arg === ContinueSentinel) {
            continue;
          }
          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next method, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined;
        maybeInvokeDelegate(delegate, context);
        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
      }
      return ContinueSentinel;
    }
    var record = tryCatch(method, delegate.iterator, context.arg);
    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }
    var info = record.arg;
    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }
    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);
  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function () {
    return this;
  });
  define(Gp, "toString", function () {
    return "[object Generator]";
  });
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    if (1 in locs) {
      entry.catchLoc = locs[1];
    }
    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }
    this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }
  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{
      tryLoc: "root"
    }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }
  exports.keys = function (val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };
  function values(iterable) {
    if (iterable != null) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }
      if (typeof iterable.next === "function") {
        return iterable;
      }
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }
            next.value = undefined;
            next.done = true;
            return next;
          };
        return next.next = next;
      }
    }
    throw new TypeError(typeof iterable + " is not iterable");
  }
  exports.values = values;
  function doneResult() {
    return {
      value: undefined,
      done: true
    };
  }
  Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;
      this.method = "next";
      this.arg = undefined;
      this.tryEntries.forEach(resetTryEntry);
      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },
    stop: function () {
      this.done = true;
      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) {
        throw exception;
      }
      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;
        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }
        return !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;
        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }
      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;
      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }
      return this.complete(record);
    },
    complete: function (record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }
      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }
      return ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },
    "catch": function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };
      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }
      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;
}(
// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
 true ? module.exports : 0);
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

/***/ }),

/***/ 13665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = function () {
  if (typeof Map !== 'undefined') {
    return Map;
  }
  /**
   * Returns index in provided array that matches the specified key.
   *
   * @param {Array<Array>} arr
   * @param {*} key
   * @returns {number}
   */
  function getIndex(arr, key) {
    var result = -1;
    arr.some(function (entry, index) {
      if (entry[0] === key) {
        result = index;
        return true;
      }
      return false;
    });
    return result;
  }
  return /** @class */function () {
    function class_1() {
      this.__entries__ = [];
    }
    Object.defineProperty(class_1.prototype, "size", {
      /**
       * @returns {boolean}
       */
      get: function () {
        return this.__entries__.length;
      },
      enumerable: true,
      configurable: true
    });
    /**
     * @param {*} key
     * @returns {*}
     */
    class_1.prototype.get = function (key) {
      var index = getIndex(this.__entries__, key);
      var entry = this.__entries__[index];
      return entry && entry[1];
    };
    /**
     * @param {*} key
     * @param {*} value
     * @returns {void}
     */
    class_1.prototype.set = function (key, value) {
      var index = getIndex(this.__entries__, key);
      if (~index) {
        this.__entries__[index][1] = value;
      } else {
        this.__entries__.push([key, value]);
      }
    };
    /**
     * @param {*} key
     * @returns {void}
     */
    class_1.prototype.delete = function (key) {
      var entries = this.__entries__;
      var index = getIndex(entries, key);
      if (~index) {
        entries.splice(index, 1);
      }
    };
    /**
     * @param {*} key
     * @returns {void}
     */
    class_1.prototype.has = function (key) {
      return !!~getIndex(this.__entries__, key);
    };
    /**
     * @returns {void}
     */
    class_1.prototype.clear = function () {
      this.__entries__.splice(0);
    };
    /**
     * @param {Function} callback
     * @param {*} [ctx=null]
     * @returns {void}
     */
    class_1.prototype.forEach = function (callback, ctx) {
      if (ctx === void 0) {
        ctx = null;
      }
      for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
        var entry = _a[_i];
        callback.call(ctx, entry[1], entry[0]);
      }
    };
    return class_1;
  }();
}();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = function () {
  if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.Math === Math) {
    return __webpack_require__.g;
  }
  if (typeof self !== 'undefined' && self.Math === Math) {
    return self;
  }
  if (typeof window !== 'undefined' && window.Math === Math) {
    return window;
  }
  // eslint-disable-next-line no-new-func
  return Function('return this')();
}();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = function () {
  if (typeof requestAnimationFrame === 'function') {
    // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind(global$1);
  }
  return function (callback) {
    return setTimeout(function () {
      return callback(Date.now());
    }, 1000 / 60);
  };
}();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle(callback, delay) {
  var leadingCall = false,
    trailingCall = false,
    lastCallTime = 0;
  /**
   * Invokes the original callback function and schedules new invocation if
   * the "proxy" was called during current request.
   *
   * @returns {void}
   */
  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }
    if (trailingCall) {
      proxy();
    }
  }
  /**
   * Callback invoked after the specified delay. It will further postpone
   * invocation of the original function delegating it to the
   * requestAnimationFrame.
   *
   * @returns {void}
   */
  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  /**
   * Schedules invocation of the original function.
   *
   * @returns {void}
   */
  function proxy() {
    var timeStamp = Date.now();
    if (leadingCall) {
      // Reject immediately following calls.
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      }
      // Schedule new call to be in invoked when the pending one is resolved.
      // This is important for "transitions" which never actually start
      // immediately so there is a chance that we might miss one if change
      // happens amids the pending invocation.
      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }
    lastCallTime = timeStamp;
  }
  return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */function () {
  /**
   * Creates a new instance of ResizeObserverController.
   *
   * @private
   */
  function ResizeObserverController() {
    /**
     * Indicates whether DOM listeners have been added.
     *
     * @private {boolean}
     */
    this.connected_ = false;
    /**
     * Tells that controller has subscribed for Mutation Events.
     *
     * @private {boolean}
     */
    this.mutationEventsAdded_ = false;
    /**
     * Keeps reference to the instance of MutationObserver.
     *
     * @private {MutationObserver}
     */
    this.mutationsObserver_ = null;
    /**
     * A list of connected observers.
     *
     * @private {Array<ResizeObserverSPI>}
     */
    this.observers_ = [];
    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
  }
  /**
   * Adds observer to observers list.
   *
   * @param {ResizeObserverSPI} observer - Observer to be added.
   * @returns {void}
   */
  ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
      this.observers_.push(observer);
    }
    // Add listeners if they haven't been added yet.
    if (!this.connected_) {
      this.connect_();
    }
  };
  /**
   * Removes observer from observers list.
   *
   * @param {ResizeObserverSPI} observer - Observer to be removed.
   * @returns {void}
   */
  ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer);
    // Remove observer if it's present in registry.
    if (~index) {
      observers.splice(index, 1);
    }
    // Remove listeners if controller has no connected observers.
    if (!observers.length && this.connected_) {
      this.disconnect_();
    }
  };
  /**
   * Invokes the update of observers. It will continue running updates insofar
   * it detects changes.
   *
   * @returns {void}
   */
  ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_();
    // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.
    if (changesDetected) {
      this.refresh();
    }
  };
  /**
   * Updates every observer from observers list and notifies them of queued
   * entries.
   *
   * @private
   * @returns {boolean} Returns "true" if any observer has detected changes in
   *      dimensions of it's elements.
   */
  ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
      return observer.gatherActive(), observer.hasActive();
    });
    // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.
    activeObservers.forEach(function (observer) {
      return observer.broadcastActive();
    });
    return activeObservers.length > 0;
  };
  /**
   * Initializes DOM listeners.
   *
   * @private
   * @returns {void}
   */
  ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser || this.connected_) {
      return;
    }
    // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.
    document.addEventListener('transitionend', this.onTransitionEnd_);
    window.addEventListener('resize', this.refresh);
    if (mutationObserverSupported) {
      this.mutationsObserver_ = new MutationObserver(this.refresh);
      this.mutationsObserver_.observe(document, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    } else {
      document.addEventListener('DOMSubtreeModified', this.refresh);
      this.mutationEventsAdded_ = true;
    }
    this.connected_ = true;
  };
  /**
   * Removes DOM listeners.
   *
   * @private
   * @returns {void}
   */
  ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser || !this.connected_) {
      return;
    }
    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);
    if (this.mutationsObserver_) {
      this.mutationsObserver_.disconnect();
    }
    if (this.mutationEventsAdded_) {
      document.removeEventListener('DOMSubtreeModified', this.refresh);
    }
    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
  };
  /**
   * "Transitionend" event handler.
   *
   * @private
   * @param {TransitionEvent} event
   * @returns {void}
   */
  ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
    var _b = _a.propertyName,
      propertyName = _b === void 0 ? '' : _b;
    // Detect whether transition may affect dimensions of an element.
    var isReflowProperty = transitionKeys.some(function (key) {
      return !!~propertyName.indexOf(key);
    });
    if (isReflowProperty) {
      this.refresh();
    }
  };
  /**
   * Returns instance of the ResizeObserverController.
   *
   * @returns {ResizeObserverController}
   */
  ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
      this.instance_ = new ResizeObserverController();
    }
    return this.instance_;
  };
  /**
   * Holds reference to the controller's instance.
   *
   * @private {ResizeObserverController}
   */
  ResizeObserverController.instance_ = null;
  return ResizeObserverController;
}();

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = function (target, props) {
  for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
    var key = _a[_i];
    Object.defineProperty(target, key, {
      value: props[key],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }
  return target;
};

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = function (target) {
  // Assume that the element is an instance of Node, which means that it
  // has the "ownerDocument" property from which we can retrieve a
  // corresponding global object.
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
  // Return the local global object if it's not possible extract one from
  // provided element.
  return ownerGlobal || global$1;
};

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
  return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
  var positions = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }
  return positions.reduce(function (size, position) {
    var value = styles['border-' + position + '-width'];
    return size + toFloat(value);
  }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
  var positions = ['top', 'right', 'bottom', 'left'];
  var paddings = {};
  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position = positions_1[_i];
    var value = styles['padding-' + position];
    paddings[position] = toFloat(value);
  }
  return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
  // Client width & height properties can't be
  // used exclusively as they provide rounded values.
  var clientWidth = target.clientWidth,
    clientHeight = target.clientHeight;
  // By this condition we can catch all non-replaced inline, hidden and
  // detached elements. Though elements with width & height properties less
  // than 0.5 will be discarded as well.
  //
  // Without it we would need to implement separate methods for each of
  // those cases and it's not possible to perform a precise and performance
  // effective test for hidden elements. E.g. even jQuery's ':visible' filter
  // gives wrong results for elements with width & height less than 0.5.
  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }
  var styles = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom;
  // Computed styles of width & height are being used because they are the
  // only dimensions available to JS that contain non-rounded values. It could
  // be possible to utilize the getBoundingClientRect if only it's data wasn't
  // affected by CSS transformations let alone paddings, borders and scroll bars.
  var width = toFloat(styles.width),
    height = toFloat(styles.height);
  // Width & height include paddings and borders when the 'border-box' box
  // model is applied (except for IE).
  if (styles.boxSizing === 'border-box') {
    // Following conditions are required to handle Internet Explorer which
    // doesn't include paddings and borders to computed CSS dimensions.
    //
    // We can say that if CSS dimensions + paddings are equal to the "client"
    // properties then it's either IE, and thus we don't need to subtract
    // anything, or an element merely doesn't have paddings/borders styles.
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles, 'left', 'right') + horizPad;
    }
    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
  }
  // Following steps can't be applied to the document's root element as its
  // client[Width/Height] properties represent viewport area of the window.
  // Besides, it's as well not necessary as the <html> itself neither has
  // rendered scroll bars nor it can be clipped.
  if (!isDocumentElement(target)) {
    // In some browsers (only in Firefox, actually) CSS width & height
    // include scroll bars size which can be removed at this step as scroll
    // bars are the only difference between rounded dimensions + paddings
    // and "client" properties, though that is not always true in Chrome.
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight;
    // Chrome has a rather weird rounding of "client" properties.
    // E.g. for an element with content width of 314.2px it sometimes gives
    // the client width of 315px and for the width of 314.7px it may give
    // 314px. And it doesn't happen all the time. So just ignore this delta
    // as a non-relevant.
    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }
    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }
  return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = function () {
  // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
  // interface.
  if (typeof SVGGraphicsElement !== 'undefined') {
    return function (target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  }
  // If it's so, then check that element is at least an instance of the
  // SVGElement and that it has the "getBBox" method.
  // eslint-disable-next-line no-extra-parens
  return function (target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
  };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
  if (!isBrowser) {
    return emptyRect;
  }
  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }
  return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
  var x = _a.x,
    y = _a.y,
    width = _a.width,
    height = _a.height;
  // If DOMRectReadOnly is available use it as a prototype for the rectangle.
  var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype);
  // Rectangle's properties are not writable and non-enumerable.
  defineConfigurable(rect, {
    x: x,
    y: y,
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: height + y,
    left: x
  });
  return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
  return {
    x: x,
    y: y,
    width: width,
    height: height
  };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */function () {
  /**
   * Creates an instance of ResizeObservation.
   *
   * @param {Element} target - Element to be observed.
   */
  function ResizeObservation(target) {
    /**
     * Broadcasted width of content rectangle.
     *
     * @type {number}
     */
    this.broadcastWidth = 0;
    /**
     * Broadcasted height of content rectangle.
     *
     * @type {number}
     */
    this.broadcastHeight = 0;
    /**
     * Reference to the last observed content rectangle.
     *
     * @private {DOMRectInit}
     */
    this.contentRect_ = createRectInit(0, 0, 0, 0);
    this.target = target;
  }
  /**
   * Updates content rectangle and tells whether it's width or height properties
   * have changed since the last broadcast.
   *
   * @returns {boolean}
   */
  ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);
    this.contentRect_ = rect;
    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
  };
  /**
   * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
   * from the corresponding properties of the last observed content rectangle.
   *
   * @returns {DOMRectInit} Last observed content rectangle.
   */
  ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;
    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;
    return rect;
  };
  return ResizeObservation;
}();
var ResizeObserverEntry = /** @class */function () {
  /**
   * Creates an instance of ResizeObserverEntry.
   *
   * @param {Element} target - Element that is being observed.
   * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
   */
  function ResizeObserverEntry(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);
    // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.
    defineConfigurable(this, {
      target: target,
      contentRect: contentRect
    });
  }
  return ResizeObserverEntry;
}();
var ResizeObserverSPI = /** @class */function () {
  /**
   * Creates a new instance of ResizeObserver.
   *
   * @param {ResizeObserverCallback} callback - Callback function that is invoked
   *      when one of the observed elements changes it's content dimensions.
   * @param {ResizeObserverController} controller - Controller instance which
   *      is responsible for the updates of observer.
   * @param {ResizeObserver} callbackCtx - Reference to the public
   *      ResizeObserver instance which will be passed to callback function.
   */
  function ResizeObserverSPI(callback, controller, callbackCtx) {
    /**
     * Collection of resize observations that have detected changes in dimensions
     * of elements.
     *
     * @private {Array<ResizeObservation>}
     */
    this.activeObservations_ = [];
    /**
     * Registry of the ResizeObservation instances.
     *
     * @private {Map<Element, ResizeObservation>}
     */
    this.observations_ = new MapShim();
    if (typeof callback !== 'function') {
      throw new TypeError('The callback provided as parameter 1 is not a function.');
    }
    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
  }
  /**
   * Starts observing provided element.
   *
   * @param {Element} target - Element to be observed.
   * @returns {void}
   */
  ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }
    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    // Do nothing if element is already being observed.
    if (observations.has(target)) {
      return;
    }
    observations.set(target, new ResizeObservation(target));
    this.controller_.addObserver(this);
    // Force the update of observations.
    this.controller_.refresh();
  };
  /**
   * Stops observing provided element.
   *
   * @param {Element} target - Element to stop observing.
   * @returns {void}
   */
  ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }
    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    // Do nothing if element is not being observed.
    if (!observations.has(target)) {
      return;
    }
    observations.delete(target);
    if (!observations.size) {
      this.controller_.removeObserver(this);
    }
  };
  /**
   * Stops observing all elements.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
  };
  /**
   * Collects observation instances the associated element of which has changed
   * it's content rectangle.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.gatherActive = function () {
    var _this = this;
    this.clearActive();
    this.observations_.forEach(function (observation) {
      if (observation.isActive()) {
        _this.activeObservations_.push(observation);
      }
    });
  };
  /**
   * Invokes initial callback function with a list of ResizeObserverEntry
   * instances collected from active resize observations.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
      return;
    }
    var ctx = this.callbackCtx_;
    // Create ResizeObserverEntry instance for every active observation.
    var entries = this.activeObservations_.map(function (observation) {
      return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });
    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
  };
  /**
   * Clears the collection of active observations.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
  };
  /**
   * Tells whether observer has active observations.
   *
   * @returns {boolean}
   */
  ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
  };
  return ResizeObserverSPI;
}();

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */function () {
  /**
   * Creates a new instance of ResizeObserver.
   *
   * @param {ResizeObserverCallback} callback - Callback that is invoked when
   *      dimensions of the observed elements change.
   */
  function ResizeObserver(callback) {
    if (!(this instanceof ResizeObserver)) {
      throw new TypeError('Cannot call a class as a function.');
    }
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }
    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);
    observers.set(this, observer);
  }
  return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
  ResizeObserver.prototype[method] = function () {
    var _a;
    return (_a = observers.get(this))[method].apply(_a, arguments);
  };
});
var index = function () {
  // Export existing implementation if available.
  if (typeof global$1.ResizeObserver !== 'undefined') {
    return global$1.ResizeObserver;
  }
  return ResizeObserver;
}();
/* harmony default export */ __webpack_exports__["Z"] = (index);

/***/ }),

/***/ 97438:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
var jsxRuntime=__webpack_require__(28598);var dayjs=__webpack_require__(79555);var updateLocale=__webpack_require__(16510);var React=__webpack_require__(82684);var isoWeek=__webpack_require__(89486);var clsx=__webpack_require__(14791);var antd=__webpack_require__(11155);var isBetween=__webpack_require__(81807);var reactDom=__webpack_require__(85202);var enUS=__webpack_require__(93228);var react=__webpack_require__(36179);var StarterKit=__webpack_require__(65988);var state=__webpack_require__(96297);var view=__webpack_require__(40585);__webpack_require__(72222);var model=__webpack_require__(37480);var transform=__webpack_require__(78879);var commands$1=__webpack_require__(99549);var schemaList=__webpack_require__(61818);var react$1=__webpack_require__(90451);var TextAlign=__webpack_require__(78956);var Underline=__webpack_require__(12545);var TaskList=__webpack_require__(55931);var TaskItem=__webpack_require__(15791);var Highlight=__webpack_require__(81800);var Typography=__webpack_require__(24545);var Superscript=__webpack_require__(5046);var Subscript=__webpack_require__(60692);var FontFamily=__webpack_require__(24724);var Color=__webpack_require__(10934);var TiptapLink=__webpack_require__(84961);var TextStyle=__webpack_require__(4412);var Placeholder=__webpack_require__(48299);var Table=__webpack_require__(60152);var TableHeader=__webpack_require__(92008);var TableRow=__webpack_require__(15201);var TableCell=__webpack_require__(9799);var tables=__webpack_require__(26575);function _interopDefaultLegacy(e){return e&&typeof e==='object'&&'default'in e?e:{'default':e};}function _interopNamespace(e){if(e&&e.__esModule)return e;var n=Object.create(null);if(e){Object.keys(e).forEach(function(k){if(k!=='default'){var d=Object.getOwnPropertyDescriptor(e,k);Object.defineProperty(n,k,d.get?d:{enumerable:true,get:function(){return e[k];}});}});}n["default"]=e;return n;}var dayjs__default=/*#__PURE__*/_interopDefaultLegacy(dayjs);var updateLocale__default=/*#__PURE__*/_interopDefaultLegacy(updateLocale);var React__default=/*#__PURE__*/_interopDefaultLegacy(React);var React__namespace=/*#__PURE__*/_interopNamespace(React);var isoWeek__default=/*#__PURE__*/_interopDefaultLegacy(isoWeek);var clsx__default=/*#__PURE__*/_interopDefaultLegacy(clsx);var isBetween__default=/*#__PURE__*/_interopDefaultLegacy(isBetween);var enUS__default=/*#__PURE__*/_interopDefaultLegacy(enUS);var StarterKit__default=/*#__PURE__*/_interopDefaultLegacy(StarterKit);var TextAlign__default=/*#__PURE__*/_interopDefaultLegacy(TextAlign);var Underline__default=/*#__PURE__*/_interopDefaultLegacy(Underline);var TaskList__default=/*#__PURE__*/_interopDefaultLegacy(TaskList);var TaskItem__default=/*#__PURE__*/_interopDefaultLegacy(TaskItem);var Highlight__default=/*#__PURE__*/_interopDefaultLegacy(Highlight);var Typography__default=/*#__PURE__*/_interopDefaultLegacy(Typography);var Superscript__default=/*#__PURE__*/_interopDefaultLegacy(Superscript);var Subscript__default=/*#__PURE__*/_interopDefaultLegacy(Subscript);var FontFamily__default=/*#__PURE__*/_interopDefaultLegacy(FontFamily);var Color__default=/*#__PURE__*/_interopDefaultLegacy(Color);var TiptapLink__default=/*#__PURE__*/_interopDefaultLegacy(TiptapLink);var TextStyle__default=/*#__PURE__*/_interopDefaultLegacy(TextStyle);var Placeholder__default=/*#__PURE__*/_interopDefaultLegacy(Placeholder);var Table__default=/*#__PURE__*/_interopDefaultLegacy(Table);var TableHeader__default=/*#__PURE__*/_interopDefaultLegacy(TableHeader);var TableRow__default=/*#__PURE__*/_interopDefaultLegacy(TableRow);var TableCell__default=/*#__PURE__*/_interopDefaultLegacy(TableCell);function _arrayLikeToArray(r,a){(null==a||a>r.length)&&(a=r.length);for(var e=0,n=Array(a);e<a;e++)n[e]=r[e];return n;}function _createForOfIteratorHelperLoose(r,e){var t="undefined"!=typeof Symbol&&r[Symbol.iterator]||r["@@iterator"];if(t)return(t=t.call(r)).next.bind(t);if(Array.isArray(r)||(t=_unsupportedIterableToArray(r))||e&&r&&"number"==typeof r.length){t&&(r=t);var o=0;return function(){return o>=r.length?{done:!0}:{done:!1,value:r[o++]};};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _extends(){return _extends=Object.assign?Object.assign.bind():function(n){for(var e=1;e<arguments.length;e++){var t=arguments[e];for(var r in t)({}).hasOwnProperty.call(t,r)&&(n[r]=t[r]);}return n;},_extends.apply(null,arguments);}function _objectDestructuringEmpty(t){if(null==t)throw new TypeError("Cannot destructure "+t);}function _objectWithoutPropertiesLoose(r,e){if(null==r)return{};var t={};for(var n in r)if({}.hasOwnProperty.call(r,n)){if(-1!==e.indexOf(n))continue;t[n]=r[n];}return t;}function _unsupportedIterableToArray(r,a){if(r){if("string"==typeof r)return _arrayLikeToArray(r,a);var t={}.toString.call(r).slice(8,-1);return"Object"===t&&r.constructor&&(t=r.constructor.name),"Map"===t||"Set"===t?Array.from(r):"Arguments"===t||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)?_arrayLikeToArray(r,a):void 0;}}/* eslint-disable no-unused-vars */var HOURS_PER_DAY=24;var MINUTES_PER_HOUR=60;var TIME_FORMAT='HH:mm';var MIN_HEIGHT_HIDE_DETAIL=60;var MIN_HEIGHT_EVENT=30;var BORDER_WEEKLY_CELL=1;var EVENT_VERTICAL_SPACING=12;var DAYS_OF_WEEK;(function(DAYS_OF_WEEK){DAYS_OF_WEEK["Monday"]="Monday";DAYS_OF_WEEK["Tuesday"]="Tuesday";DAYS_OF_WEEK["Wednesday"]="Wednesday";DAYS_OF_WEEK["Thursday"]="Thursday";DAYS_OF_WEEK["Friday"]="Friday";DAYS_OF_WEEK["Saturday"]="Saturday";DAYS_OF_WEEK["Sunday"]="Sunday";})(DAYS_OF_WEEK||(DAYS_OF_WEEK={}));var DAYS_OF_WEEK_SHORTEN;(function(DAYS_OF_WEEK_SHORTEN){DAYS_OF_WEEK_SHORTEN["Monday"]="Mon";DAYS_OF_WEEK_SHORTEN["Tuesday"]="Tue";DAYS_OF_WEEK_SHORTEN["Wednesday"]="Wed";DAYS_OF_WEEK_SHORTEN["Thursday"]="Thur";DAYS_OF_WEEK_SHORTEN["Friday"]="Fri";DAYS_OF_WEEK_SHORTEN["Saturday"]="Sat";DAYS_OF_WEEK_SHORTEN["Sunday"]="Sun";})(DAYS_OF_WEEK_SHORTEN||(DAYS_OF_WEEK_SHORTEN={}));var HOUR_OF_DAY;(function(HOUR_OF_DAY){HOUR_OF_DAY["07:00"]="07:00";HOUR_OF_DAY["08:00"]="08:00";HOUR_OF_DAY["09:00"]="09:00";HOUR_OF_DAY["10:00"]="10:00";HOUR_OF_DAY["11:00"]="11:00";HOUR_OF_DAY["12:00"]="12:00";HOUR_OF_DAY["13:00"]="13:00";HOUR_OF_DAY["14:00"]="14:00";HOUR_OF_DAY["15:00"]="15:00";HOUR_OF_DAY["16:00"]="16:00";HOUR_OF_DAY["17:00"]="17:00";HOUR_OF_DAY["18:00"]="18:00";HOUR_OF_DAY["19:00"]="19:00";HOUR_OF_DAY["20:00"]="20:00";HOUR_OF_DAY["21:00"]="21:00";HOUR_OF_DAY["22:00"]="22:00";HOUR_OF_DAY["23:00"]="23:00";HOUR_OF_DAY["24:00"]="24:00";})(HOUR_OF_DAY||(HOUR_OF_DAY={}));var EVENT_TYPES;(function(EVENT_TYPES){EVENT_TYPES["TEACHING"]="TEACHING";EVENT_TYPES["BUSY"]="BUSY";EVENT_TYPES["HOLIDAY"]="HOLIDAY";EVENT_TYPES["OTHER"]="OTHER";EVENT_TYPES["LIVE_ONLINE"]="LIVE_ONLINE";EVENT_TYPES["INACTIVE"]="INACTIVE";})(EVENT_TYPES||(EVENT_TYPES={}));var FORMAT_DATE_CARLENDA;(function(FORMAT_DATE_CARLENDA){FORMAT_DATE_CARLENDA["MONTH_AND_WEEK"]="MMMM YYYY";FORMAT_DATE_CARLENDA["DATE"]="DD";})(FORMAT_DATE_CARLENDA||(FORMAT_DATE_CARLENDA={}));var LEARNING_MODE;(function(LEARNING_MODE){LEARNING_MODE["ONLINE"]="ONLINE";LEARNING_MODE["LIVE_ONLINE"]="LIVE_ONLINE";LEARNING_MODE["OFFLINE"]="OFFLINE";LEARNING_MODE["CASE_STUDY"]="CASE_STUDY";LEARNING_MODE["HOLIDAY"]="HOLIDAY";LEARNING_MODE["OVERDUE"]="OVERDUE";LEARNING_MODE["TEST"]="TEST";LEARNING_MODE["KEY_BEFORE_CONTENT"]="KEY_BEFORE_CONTENT";})(LEARNING_MODE||(LEARNING_MODE={}));var CALENDAR_TYPE;(function(CALENDAR_TYPE){CALENDAR_TYPE["OPS"]="OPS";CALENDAR_TYPE["LMS"]="LMS";})(CALENDAR_TYPE||(CALENDAR_TYPE={}));var STATUS_NORM;(function(STATUS_NORM){STATUS_NORM["PENDING"]="PENDING";STATUS_NORM["APPROVED"]="APPROVED";})(STATUS_NORM||(STATUS_NORM={}));var useEffectAfterMounted=function useEffectAfterMounted(callback,dependencies){var _useState=React.useState(false),mounted=_useState[0],setMounted=_useState[1];React.useEffect(function(){if(!mounted){setMounted(true);return;}return callback();},dependencies);};var FlagIcon$1=function FlagIcon(props){return jsxRuntime.jsxs("svg",_extends({xmlns:'http://www.w3.org/2000/svg',width:'12',height:'14',fill:'none'},props,{children:[jsxRuntime.jsx("g",{clipPath:'url(#a)',children:jsxRuntime.jsx("path",{fill:'#FFB800',d:'m9.834 4.333 1.7-2.266A.667.667 0 0 0 11.001 1H3a.667.667 0 0 0-1.334 0v11.333h-.666a.667.667 0 1 0 0 1.334h2.666a.667.667 0 0 0 0-1.334h-.666V7.667h8a.667.667 0 0 0 .533-1.067l-1.7-2.267Z'})}),jsxRuntime.jsx("defs",{children:jsxRuntime.jsx("clipPath",{id:'a',children:jsxRuntime.jsx("path",{fill:'#fff',d:'M0 0h12v14H0z'})})})]}));};var _getIconEvent$1,_getIconEventDisable;var Left$1=function Left(){return jsxRuntime.jsx("svg",{width:'16',height:'16',viewBox:'0 0 16 16',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:jsxRuntime.jsx("path",{d:'M9.68642 12.6136C9.59868 12.6141 9.5117 12.5973 9.43048 12.5641C9.34925 12.5309 9.27538 12.482 9.21308 12.4202L5.25975 8.47356C5.13793 8.3458 5.06887 8.17674 5.06642 8.00023C5.06591 7.91249 5.08273 7.82551 5.1159 7.74429C5.14908 7.66306 5.19796 7.58919 5.25975 7.52689L9.21308 3.58023C9.34062 3.47101 9.50467 3.41394 9.67245 3.42042C9.84024 3.4269 9.9994 3.49645 10.1181 3.61518C10.2369 3.73391 10.3064 3.89307 10.3129 4.06086C10.3194 4.22864 10.2623 4.39269 10.1531 4.52023L6.66642 8.00023L10.1398 11.4802C10.2639 11.6051 10.3336 11.7741 10.3336 11.9502C10.3336 12.1264 10.2639 12.2953 10.1398 12.4202C10.0189 12.5402 9.85668 12.6094 9.68642 12.6136Z',fill:'#252F4A'})});};var Right$1=function Right(){return jsxRuntime.jsx("svg",{width:'16',height:'16',viewBox:'0 0 16 16',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:jsxRuntime.jsx("path",{d:'M6.84715 12.6666C6.75894 12.6662 6.67169 12.6483 6.59044 12.614C6.50919 12.5797 6.43556 12.5295 6.37381 12.4666C6.24965 12.3416 6.17995 12.1727 6.17995 11.9966C6.17995 11.8204 6.24965 11.6515 6.37381 11.5266L9.85381 7.99989L6.37381 4.55322C6.31165 4.49019 6.26252 4.41553 6.22921 4.3335C6.19591 4.25148 6.17908 4.1637 6.1797 4.07517C6.18032 3.98665 6.19837 3.89911 6.23282 3.81756C6.26727 3.73601 6.31744 3.66205 6.38048 3.59989C6.44351 3.53773 6.51817 3.48859 6.6002 3.45529C6.68222 3.42198 6.77 3.40516 6.85853 3.40578C6.94705 3.4064 7.03459 3.42445 7.11614 3.4589C7.19769 3.49334 7.27165 3.54352 7.33381 3.60655L11.2805 7.55989C11.4046 7.6848 11.4743 7.85376 11.4743 8.02989C11.4743 8.20601 11.4046 8.37498 11.2805 8.49989L7.33381 12.4466C7.27224 12.5148 7.19722 12.5696 7.11347 12.6074C7.02972 12.6453 6.93905 12.6654 6.84715 12.6666Z',fill:'#252F4A'})});};var Book$1=function Book(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?'#025EFF':_ref$color;return jsxRuntime.jsx("svg",{width:'20',height:'20',viewBox:'0 0 20 20',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:jsxRuntime.jsx("path",{fillRule:'evenodd',clipRule:'evenodd',d:'M7.36051 3.61971C6.37671 3.45978 5.3735 3.45977 4.38969 3.61969C4.04645 3.67549 3.70164 3.7585 2.93716 3.94368C2.81469 3.97335 2.74354 3.99072 2.69032 4.00583C2.6569 4.01532 2.64293 4.02058 2.6395 4.02196C2.6395 4.02196 2.6395 4.02196 2.6395 4.02196C2.57147 4.05542 2.52252 4.11776 2.50609 4.19125C2.50556 4.19493 2.50375 4.2097 2.5024 4.24419C2.50024 4.29939 2.50011 4.37254 2.50011 4.49846V15.8196C2.50011 15.9083 2.50015 15.9626 2.50105 16.0033C2.50163 16.0294 2.50244 16.041 2.50265 16.0437C2.52153 16.1749 2.64055 16.2691 2.7739 16.2564C2.7766 16.2559 2.78803 16.254 2.81375 16.2484C2.85362 16.2397 2.90644 16.2269 2.99264 16.206L3.00819 16.2023C3.34117 16.1216 3.52697 16.0766 3.71304 16.0384C5.13954 15.7457 6.61067 15.7457 8.03717 16.0384C8.22321 16.0766 8.40898 16.1216 8.74185 16.2022L9.25011 16.3253V4.04958L8.81305 3.94371C8.04857 3.75852 7.70375 3.6755 7.36051 3.61971ZM10.7501 4.04959V16.3253L11.2582 16.2023C11.5912 16.1216 11.777 16.0766 11.963 16.0384C13.3895 15.7457 14.8607 15.7457 16.2872 16.0384C16.4732 16.0766 16.659 16.1216 16.992 16.2023L17.0076 16.206C17.0938 16.2269 17.1466 16.2397 17.1865 16.2484C17.2256 16.257 17.2317 16.257 17.2242 16.2562C17.3584 16.2701 17.4786 16.1756 17.4976 16.0437C17.4978 16.041 17.4986 16.0294 17.4992 16.0033C17.5001 15.9626 17.5001 15.9083 17.5001 15.8196V4.49852C17.5001 4.37258 17.5 4.29943 17.4978 4.24423C17.4965 4.20973 17.4947 4.19496 17.4941 4.19129C17.4777 4.11779 17.4287 4.05545 17.3607 4.022C17.3573 4.02062 17.3433 4.01536 17.3099 4.00587C17.2567 3.99075 17.1855 3.97338 17.063 3.94372C16.2985 3.75853 15.9537 3.67551 15.6104 3.61972C14.6267 3.45981 13.6235 3.45981 12.6398 3.61972C12.2965 3.67551 11.9517 3.75853 11.1872 3.94372L10.7501 4.04959ZM4.14902 2.13913C5.29223 1.95329 6.45799 1.9533 7.6012 2.13914C8.00774 2.20523 8.41052 2.30281 9.13225 2.47765L9.80168 2.63981C9.87479 2.65752 9.91513 2.66723 9.94602 2.67381C9.97272 2.67949 9.97804 2.67967 9.97581 2.67945C9.99197 2.68102 10.0082 2.68102 10.0244 2.67945C10.0222 2.67967 10.0275 2.67949 10.0542 2.67381C10.0851 2.66723 10.1254 2.65752 10.1985 2.63982L10.868 2.47765C11.5897 2.30281 11.9925 2.20524 12.3991 2.13915C13.5423 1.95333 14.708 1.95333 15.8511 2.13915C16.2577 2.20524 16.6605 2.30281 17.3822 2.47765L17.4162 2.48588C17.4319 2.48969 17.4478 2.4935 17.4637 2.49732C17.6482 2.5417 17.8425 2.58844 18.0149 2.67215C18.4972 2.9064 18.8457 3.34888 18.9599 3.87292C19.0008 4.0602 19.0005 4.26011 19.0002 4.44971C19.0001 4.46606 19.0001 4.48234 19.0001 4.49852V15.8196C19.0001 15.8317 19.0001 15.8438 19.0001 15.8559C19.0003 15.9884 19.0004 16.1238 18.9843 16.2426C18.8576 17.1797 18.0092 17.8457 17.0693 17.7482C16.9501 17.7358 16.8185 17.7038 16.6896 17.6724C16.6779 17.6696 16.6661 17.6667 16.6544 17.6639C16.3018 17.5784 16.1428 17.54 15.9857 17.5078C14.7581 17.2559 13.4921 17.2559 12.2645 17.5078C12.1074 17.54 11.9484 17.5784 11.5958 17.6639L10.5517 17.9168C10.5427 17.9189 10.5337 17.9211 10.5246 17.9233C10.4134 17.9504 10.2943 17.9794 10.1697 17.9915C10.0569 18.0025 9.9433 18.0025 9.83048 17.9915C9.70589 17.9794 9.5868 17.9504 9.47557 17.9233C9.4665 17.9211 9.45749 17.9189 9.44854 17.9168L8.40443 17.6639C8.05182 17.5784 7.89278 17.54 7.7357 17.5078C6.50811 17.2559 5.2421 17.2559 4.01452 17.5078C3.85743 17.54 3.6984 17.5784 3.34578 17.6639C3.33408 17.6667 3.32234 17.6696 3.31058 17.6724C3.18171 17.7038 3.05015 17.7358 2.93091 17.7482C1.991 17.8457 1.14259 17.1797 1.01588 16.2426C0.999808 16.1238 0.999947 15.9883 1.00008 15.8559C1.00009 15.8438 1.00011 15.8317 1.00011 15.8196V4.49846C1.00011 4.48228 1.00008 4.466 1.00005 4.44965C0.999745 4.26006 0.999419 4.06018 1.04026 3.8729C1.15455 3.34885 1.50299 2.90636 1.98536 2.67211C2.15773 2.5884 2.35205 2.54166 2.53655 2.49729C2.55245 2.49346 2.56828 2.48965 2.58402 2.48584L2.61796 2.47762C3.3397 2.30278 3.74248 2.20521 4.14902 2.13913Z',fill:color})});};var CalendarDelete$1=function CalendarDelete(_ref2){var _ref2$color=_ref2.color,color=_ref2$color===void 0?'#D20306':_ref2$color;return jsxRuntime.jsx("svg",{width:'20',height:'20',viewBox:'0 0 20 20',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:jsxRuntime.jsx("path",{fillRule:'evenodd',clipRule:'evenodd',d:'M6.75 1C7.16421 1 7.5 1.33579 7.5 1.75V3H12.5V1.75C12.5 1.33579 12.8358 1 13.25 1C13.6642 1 14 1.33579 14 1.75V3H16.25C17.7688 3 19 4.23122 19 5.75V8.75C19 9.16421 18.6642 9.5 18.25 9.5H2.5V16.25C2.5 16.9404 3.05964 17.5 3.75 17.5H8.75C9.16421 17.5 9.5 17.8358 9.5 18.25C9.5 18.6642 9.16421 19 8.75 19H3.75C2.23122 19 1 17.7688 1 16.25V5.75C1 4.23122 2.23122 3 3.75 3H6V1.75C6 1.33579 6.33579 1 6.75 1ZM6 4.5H3.75C3.05964 4.5 2.5 5.05964 2.5 5.75V8H17.5V5.75C17.5 5.05964 16.9404 4.5 16.25 4.5H14V5.25C14 5.66421 13.6642 6 13.25 6C12.8358 6 12.5 5.66421 12.5 5.25V4.5H7.5V5.25C7.5 5.66421 7.16421 6 6.75 6C6.33579 6 6 5.66421 6 5.25V4.5ZM12 15.75C12 15.3358 12.3358 15 12.75 15H19.25C19.6642 15 20 15.3358 20 15.75C20 16.1642 19.6642 16.5 19.25 16.5H12.75C12.3358 16.5 12 16.1642 12 15.75Z',fill:color})});};var CalendarAccept$1=function CalendarAccept(){return jsxRuntime.jsxs("svg",{width:'20',height:'20',viewBox:'0 0 20 20',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:[jsxRuntime.jsx("g",{clipPath:'url(#clip0_678_4877)',children:jsxRuntime.jsx("path",{fillRule:'evenodd',clipRule:'evenodd',d:'M6.75 1C7.16421 1 7.5 1.33579 7.5 1.75V3H12.5V1.75C12.5 1.33579 12.8358 1 13.25 1C13.6642 1 14 1.33579 14 1.75V3H16.25C17.7688 3 19 4.23122 19 5.75V8.75C19 9.16421 18.6642 9.5 18.25 9.5H2.5V16.25C2.5 16.9404 3.05964 17.5 3.75 17.5H8.75C9.16421 17.5 9.5 17.8358 9.5 18.25C9.5 18.6642 9.16421 19 8.75 19H3.75C2.23122 19 1 17.7688 1 16.25V5.75C1 4.23122 2.23122 3 3.75 3H6V1.75C6 1.33579 6.33579 1 6.75 1ZM6 4.5H3.75C3.05964 4.5 2.5 5.05964 2.5 5.75V8H17.5V5.75C17.5 5.05964 16.9404 4.5 16.25 4.5H14V5.25C14 5.66421 13.6642 6 13.25 6C12.8358 6 12.5 5.66421 12.5 5.25V4.5H7.5V5.25C7.5 5.66421 7.16421 6 6.75 6C6.33579 6 6 5.66421 6 5.25V4.5ZM19.765 13.2047C20.0661 13.4891 20.0797 13.9638 19.7953 14.265L15.5453 18.765C15.4014 18.9173 15.2005 19.0025 14.991 18.9999C14.7815 18.9974 14.5827 18.9074 14.4425 18.7517L12.1925 16.2517C11.9154 15.9438 11.9404 15.4696 12.2483 15.1925C12.5562 14.9154 13.0304 14.9404 13.3075 15.2483L15.0133 17.1436L18.7047 13.235C18.9891 12.9339 19.4638 12.9203 19.765 13.2047Z',fill:'#07AF17'})}),jsxRuntime.jsx("defs",{children:jsxRuntime.jsx("clipPath",{id:'clip0_678_4877',children:jsxRuntime.jsx("rect",{width:'20',height:'20',fill:'white'})})})]});};var Star$1=function Star(){return jsxRuntime.jsx("svg",{width:'20',height:'20',viewBox:'0 0 20 20',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:jsxRuntime.jsx("path",{fillRule:'evenodd',clipRule:'evenodd',d:'M10.0928 2.52324C9.99905 2.47488 9.86181 2.50026 9.79335 2.64522L8.00799 6.42557C7.76215 6.94613 7.27807 7.32297 6.69953 7.41082L2.70736 8.01703C2.66367 8.02366 2.61758 8.04593 2.57857 8.08775C2.47149 8.20255 2.47467 8.39827 2.58316 8.50878L5.47192 11.4514C5.87611 11.8631 6.05323 12.4463 5.96057 13.0109L5.27863 17.1659C5.2674 17.2343 5.27853 17.3035 5.30766 17.3614C5.3787 17.5027 5.51526 17.5255 5.60897 17.474L9.17967 15.5123C9.69201 15.2308 10.3079 15.2308 10.8202 15.5123L14.3909 17.474C14.434 17.4977 14.48 17.5045 14.5234 17.4967C14.5864 17.4854 14.6553 17.4449 14.7056 17.3752C14.754 17.3081 14.7706 17.2347 14.7603 17.1681L14.0393 13.0109C13.9466 12.4463 14.1238 11.8631 14.5279 11.4514L17.4167 8.50878C17.4568 8.46792 17.4872 8.40957 17.4968 8.34084C17.5227 8.15465 17.3972 8.03293 17.2925 8.01703L13.3003 7.41082C12.7218 7.32297 12.2377 6.94613 11.9919 6.42557L10.2065 2.64522C10.1788 2.58657 10.1367 2.54586 10.0928 2.52324ZM8.437 2.00466C8.85086 1.12835 9.89685 0.734429 10.7804 1.1901C11.1257 1.36818 11.3985 1.65664 11.5629 2.00466L13.3482 5.78501C13.3898 5.87307 13.4613 5.91807 13.5255 5.92782L17.5177 6.53403C18.4915 6.6819 19.1133 7.60658 18.9825 8.54743C18.9296 8.92748 18.7578 9.28392 18.4871 9.5596L15.5984 12.5022C15.5379 12.5637 15.5029 12.662 15.5191 12.7656L16.2401 16.9229C16.4008 17.902 15.7151 18.807 14.788 18.9732C14.4037 19.042 14.0097 18.976 13.6686 18.7887L10.0979 16.8269C10.0354 16.7926 9.96447 16.7926 9.90194 16.8269L6.33123 18.7887C5.46031 19.2671 4.40376 18.9024 3.96767 18.0356C3.79485 17.692 3.7363 17.3015 3.79843 16.9229L4.48038 12.7679C4.49751 12.6635 4.4624 12.5642 4.40151 12.5022L1.51275 9.5596C0.840839 8.87517 0.828048 7.76534 1.48168 7.0646C1.74558 6.78168 2.09641 6.59261 2.48217 6.53403L6.47434 5.92782C6.53853 5.91807 6.61006 5.87307 6.65165 5.78501L8.437 2.00466Z',fill:'#F57C00'})});};var TestIcon$2=function TestIcon(){return jsxRuntime.jsxs("svg",{width:'14',height:'15',viewBox:'0 0 14 15',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:[jsxRuntime.jsx("path",{d:'M4.38413 3.03685H7.85239C8.24984 3.03685 8.52203 2.6436 8.37463 2.28174L7.99366 1.34663C7.90843 1.13708 7.7017 1 7.47142 1H4.76462C4.53482 1 4.32762 1.13754 4.24238 1.34663L3.86189 2.28174C3.71449 2.6436 3.98668 3.03685 4.38413 3.03685Z',fill:'#FFB800'}),jsxRuntime.jsx("path",{d:'M12.7209 8.27831C12.3488 7.9183 11.7508 7.9183 11.3788 8.27831L10.9775 8.67433L12.3206 9.98607L12.7209 9.59375C13.0929 9.22912 13.0929 8.64294 12.7209 8.27831Z',fill:'#FFB800'}),jsxRuntime.jsx("path",{d:'M10.4791 9.16455L8.18108 11.4169C8.12928 11.4631 8.09631 11.5277 8.0869 11.597L7.90795 12.6124C7.87028 12.8385 8.06806 13.0324 8.29881 12.9955L9.33952 12.8247C9.40545 12.8108 9.47138 12.7785 9.51847 12.7324L11.8212 10.4754L10.4791 9.16455Z',fill:'#FFB800'}),jsxRuntime.jsx("path",{d:'M9.68361 2.01953H9.02857L9.03092 2.02553C9.18727 2.40816 9.13923 2.84156 8.90331 3.18312C8.66738 3.52513 8.27464 3.7296 7.85317 3.7296H4.38444C3.96297 3.7296 3.57023 3.52559 3.33431 3.18312C3.09791 2.8411 3.05035 2.40816 3.20622 2.02507L3.20857 2.01953H2.55401C1.69224 2.01953 1 2.70263 1 3.54267V11.4768C1 12.3169 1.69224 13 2.55401 13H7.25888C7.20285 12.8412 7.1826 12.6709 7.21085 12.5006L7.39074 11.4791C7.41805 11.2728 7.53154 11.0591 7.70625 10.904L10.196 8.46286L10.8764 7.79037C10.9852 7.68514 11.1081 7.60298 11.2367 7.5319V3.54267C11.2376 2.70263 10.5407 2.01953 9.68361 2.01953ZM3.90128 9.69568H3.47229C3.23824 9.69568 3.04846 9.50967 3.04846 9.28028C3.04846 9.05088 3.23824 8.86488 3.47229 8.86488H3.90176C4.1358 8.86488 4.32558 9.05088 4.32558 9.28028C4.32558 9.50967 4.13533 9.69568 3.90128 9.69568ZM3.90128 7.17512H3.47229C3.23824 7.17512 3.04846 6.98911 3.04846 6.75972C3.04846 6.53032 3.23824 6.34432 3.47229 6.34432H3.90176C4.1358 6.34432 4.32558 6.53032 4.32558 6.75972C4.32558 6.98911 4.13533 7.17512 3.90128 7.17512ZM7.69683 9.69522H5.60128C5.36723 9.69522 5.17745 9.50921 5.17745 9.27981C5.17745 9.05042 5.36723 8.86441 5.60128 8.86441H7.69683C7.93087 8.86441 8.12065 9.05042 8.12065 9.27981C8.12065 9.50921 7.93135 9.69522 7.69683 9.69522ZM8.76533 7.17512H5.60033C5.36629 7.17512 5.17651 6.98911 5.17651 6.75972C5.17651 6.53032 5.36629 6.34432 5.60033 6.34432H8.76533C8.99937 6.34432 9.18915 6.53032 9.18915 6.75972C9.18915 6.98911 8.99937 7.17512 8.76533 7.17512Z',fill:'#FFB800'})]});};var HiddenEyeIcon=function HiddenEyeIcon(){return jsxRuntime.jsxs("svg",{width:'16',height:'17',viewBox:'0 0 16 17',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:[jsxRuntime.jsx("path",{d:'M7.92867 10.5001C8.45911 10.5001 8.96782 10.2894 9.34289 9.91436C9.71796 9.53929 9.92868 9.03058 9.92868 8.50015C9.92868 8.44158 9.926 8.38354 9.921 8.32622L7.75475 10.4925C7.81207 10.4975 7.86992 10.5001 7.92867 10.5001ZM14.5487 2.31372L13.7858 1.55157C13.759 1.5248 13.7227 1.50977 13.6848 1.50977C13.647 1.50977 13.6106 1.5248 13.5839 1.55157L11.6317 3.50425C10.5548 2.9539 9.34427 2.67872 8.0001 2.67872C4.56796 2.67872 2.00725 4.46622 0.31796 8.04122C0.250059 8.185 0.214844 8.34203 0.214844 8.50104C0.214844 8.66005 0.250059 8.81708 0.31796 8.96086C0.99296 10.3826 1.80576 11.5222 2.75635 12.3796L0.867246 14.268C0.840475 14.2948 0.825437 14.3311 0.825437 14.369C0.825437 14.4069 0.840475 14.4432 0.867246 14.47L1.62957 15.2323C1.65636 15.2591 1.69268 15.2741 1.73055 15.2741C1.76842 15.2741 1.80474 15.2591 1.83153 15.2323L14.5487 2.51586C14.562 2.50259 14.5725 2.48684 14.5797 2.46949C14.5869 2.45215 14.5906 2.43356 14.5906 2.41479C14.5906 2.39602 14.5869 2.37743 14.5797 2.36008C14.5725 2.34274 14.562 2.32698 14.5487 2.31372ZM4.78582 8.50015C4.78577 7.9573 4.92632 7.4237 5.1938 6.95132C5.46127 6.47894 5.84653 6.08389 6.31206 5.80466C6.77758 5.52543 7.30749 5.37154 7.85017 5.35798C8.39285 5.34442 8.92979 5.47166 9.40868 5.72729L8.54046 6.5955C8.19032 6.48339 7.81606 6.46989 7.45875 6.55648C7.10143 6.64307 6.77488 6.82641 6.51491 7.08638C6.25494 7.34635 6.0716 7.67291 5.98501 8.03022C5.89841 8.38753 5.91192 8.76179 6.02403 9.11193L5.15582 9.98015C4.91218 9.52493 4.78506 9.01646 4.78582 8.50015Z',fill:'#DCDDDD'}),jsxRuntime.jsx("path",{d:'M15.6819 8.03917C15.0533 6.71536 14.3052 5.6359 13.4374 4.80078L10.8635 7.37489C11.0805 7.94206 11.1286 8.55992 11.002 9.15383C10.8754 9.74774 10.5795 10.2923 10.1501 10.7217C9.72073 11.1511 9.17618 11.4469 8.58227 11.5735C7.98836 11.7001 7.3705 11.652 6.80333 11.4351L4.62012 13.6183C5.63297 14.087 6.75952 14.3213 7.99976 14.3213C11.4319 14.3213 13.9926 12.5338 15.6819 8.95882C15.7498 8.81504 15.785 8.65801 15.785 8.499C15.785 8.33999 15.7498 8.18295 15.6819 8.03917Z',fill:'#DCDDDD'})]});};var EyeIcon=function EyeIcon(){return jsxRuntime.jsx("svg",{width:'16',height:'17',viewBox:'0 0 16 17',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:jsxRuntime.jsx("path",{d:'M5.92868 8.50014C5.92868 9.03057 6.13939 9.53928 6.51446 9.91435C6.88953 10.2894 7.39824 10.5001 7.92868 10.5001C8.45911 10.5001 8.96782 10.2894 9.34289 9.91435C9.71796 9.53928 9.92868 9.03057 9.92868 8.50014C9.92868 7.96971 9.71796 7.461 9.34289 7.08593C8.96782 6.71085 8.45911 6.50014 7.92868 6.50014C7.39824 6.50014 6.88953 6.71085 6.51446 7.08593C6.13939 7.461 5.92868 7.96971 5.92868 8.50014ZM15.6822 8.03943C13.9894 4.47335 11.4305 2.67871 8.0001 2.67871C4.56796 2.67871 2.01082 4.47335 0.31796 8.04121C0.250059 8.18499 0.214844 8.34203 0.214844 8.50103C0.214844 8.66004 0.250059 8.81707 0.31796 8.96085C2.01082 12.5269 4.56975 14.3216 8.0001 14.3216C11.4322 14.3216 13.9894 12.5269 15.6822 8.95907C15.8197 8.66978 15.8197 8.33407 15.6822 8.03943ZM7.92868 11.643C6.19296 11.643 4.78582 10.2359 4.78582 8.50014C4.78582 6.76443 6.19296 5.35728 7.92868 5.35728C9.66439 5.35728 11.0715 6.76443 11.0715 8.50014C11.0715 10.2359 9.66439 11.643 7.92868 11.643Z',fill:'#DCDDDD'})});};var GoldStarIcon=function GoldStarIcon(){return jsxRuntime.jsxs("svg",{width:'14',height:'15',viewBox:'0 0 14 15',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:[jsxRuntime.jsx("g",{clipPath:'url(#clip0_23522_33890)',children:jsxRuntime.jsx("path",{d:'M13.9308 5.27509L9.73388 4.66514L7.85774 0.86162C7.8065 0.757482 7.7222 0.67318 7.61806 0.621937C7.35689 0.493005 7.03951 0.600449 6.90893 0.86162L5.03279 4.66514L0.835862 5.27509C0.720153 5.29162 0.614362 5.34617 0.533366 5.42882C0.435446 5.52946 0.381488 5.66486 0.383347 5.80527C0.385207 5.94568 0.442733 6.0796 0.543284 6.17762L3.57982 9.13811L2.86242 13.3185C2.8456 13.4158 2.85636 13.5158 2.89348 13.6072C2.93061 13.6987 2.99261 13.7779 3.07246 13.8359C3.15231 13.8939 3.24682 13.9283 3.34526 13.9353C3.4437 13.9424 3.54213 13.9216 3.62941 13.8756L7.38333 11.9019L11.1373 13.8756C11.2397 13.9301 11.3588 13.9483 11.4728 13.9285C11.7604 13.8789 11.9538 13.6061 11.9042 13.3185L11.1869 9.13811L14.2234 6.17762C14.306 6.09662 14.3606 5.99083 14.3771 5.87512C14.4217 5.58585 14.2201 5.31807 13.9308 5.27509Z',fill:'#FFB800'})}),jsxRuntime.jsx("defs",{children:jsxRuntime.jsx("clipPath",{id:'clip0_23522_33890',children:jsxRuntime.jsx("rect",{width:'14',height:'14',fill:'white',transform:'translate(0 0.5)'})})})]});};var TagIcon=function TagIcon(){return jsxRuntime.jsxs("svg",{width:'20',height:'21',viewBox:'0 0 20 21',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:[jsxRuntime.jsx("path",{d:'M11.25 1.125L0 12.375L6.875 19.25L18.125 8V1.125H11.25ZM14.375 6.125C14.1278 6.125 13.8861 6.05169 13.6805 5.91434C13.475 5.77699 13.3148 5.58176 13.2201 5.35335C13.1255 5.12495 13.1008 4.87361 13.149 4.63114C13.1972 4.38866 13.3163 4.16593 13.4911 3.99112C13.6659 3.8163 13.8887 3.69725 14.1311 3.64902C14.3736 3.60079 14.6249 3.62554 14.8534 3.72015C15.0818 3.81476 15.277 3.97498 15.4143 4.18054C15.5517 4.3861 15.625 4.62777 15.625 4.875C15.625 5.20652 15.4933 5.52446 15.2589 5.75888C15.0245 5.9933 14.7065 6.125 14.375 6.125Z',fill:'#21272A'}),jsxRuntime.jsx("path",{d:'M18.75 3V8.625L8.47266 18.9023L9.45313 19.875L20 9.25V3H18.75Z',fill:'#21272A'})]});};var EducationIcon=function EducationIcon(){return jsxRuntime.jsxs("svg",{width:'20',height:'21',viewBox:'0 0 20 21',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:[jsxRuntime.jsxs("g",{clipPath:'url(#clip0_22306_18116)',children:[jsxRuntime.jsx("path",{d:'M10 14.9699L3.75 11.3984V15.243L10 18.7148L16.25 15.243V11.3984L10 14.9699Z',fill:'#21272A'}),jsxRuntime.jsx("path",{d:'M20.0098 8.0002L10 2.28027L-0.00976562 8.0002L10 13.7201L18.125 9.07715V15.5002H20V8.00566L20.0098 8.0002Z',fill:'#21272A'})]}),jsxRuntime.jsx("defs",{children:jsxRuntime.jsx("clipPath",{id:'clip0_22306_18116',children:jsxRuntime.jsx("rect",{width:'20',height:'20',fill:'white',transform:'translate(0 0.5)'})})})]});};var FilterIcon$1=function FilterIcon(){return jsxRuntime.jsx("svg",{width:'35',height:'35',viewBox:'0 0 35 35',fill:'currentColor',xmlns:'http://www.w3.org/2000/svg',children:jsxRuntime.jsx("path",{d:'M26.5 8.4961V26.5036H8.5V8.4961H26.5ZM28 6.99609L7 6.99619L7 28.0036L28 27.9961V6.99609ZM10.2625 9.9886H17.7625V24.9886H10.2625V9.9886Z',fill:'currentColor'})});};var LeftArrowIcon$1=function LeftArrowIcon(){return jsxRuntime.jsx("svg",{width:'16',height:'17',viewBox:'0 0 16 17',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:jsxRuntime.jsx("path",{d:'M11.3125 3.36853V13.631C11.3125 13.9388 10.9875 14.1107 10.7656 13.9201L4.81563 8.78884C4.64531 8.64196 4.64531 8.35915 4.81563 8.21071L10.7656 3.07946C10.9875 2.88884 11.3125 3.06071 11.3125 3.36853Z',fill:'#404041'})});};var RightArrowIcon$1=function RightArrowIcon(){return jsxRuntime.jsx("svg",{width:'8',height:'11',viewBox:'0 0 8 11',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:jsxRuntime.jsx("path",{d:'M0.6875 0.368526L0.6875 10.631C0.6875 10.9388 1.0125 11.1107 1.23438 10.9201L7.18437 5.78884C7.35469 5.64196 7.35469 5.35915 7.18437 5.21071L1.23438 0.079463C1.0125 -0.111162 0.6875 0.0607128 0.6875 0.368526Z',fill:'#404041'})});};var getIconEvent$1=(_getIconEvent$1={},_getIconEvent$1[EVENT_TYPES.TEACHING]=jsxRuntime.jsx(Book$1,{}),_getIconEvent$1[EVENT_TYPES.BUSY]=jsxRuntime.jsx(CalendarDelete$1,{}),_getIconEvent$1[EVENT_TYPES.HOLIDAY]=jsxRuntime.jsx(Star$1,{}),_getIconEvent$1[EVENT_TYPES.OTHER]=jsxRuntime.jsx(CalendarAccept$1,{}),_getIconEvent$1[EVENT_TYPES.LIVE_ONLINE]=null,_getIconEvent$1[EVENT_TYPES.INACTIVE]=null,_getIconEvent$1);var getIconEventDisable=(_getIconEventDisable={},_getIconEventDisable[EVENT_TYPES.TEACHING]=jsxRuntime.jsx(Book$1,{color:'#8CB5EA'}),_getIconEventDisable[EVENT_TYPES.BUSY]=jsxRuntime.jsx(CalendarDelete$1,{color:'#EF8F8F'}),_getIconEventDisable[EVENT_TYPES.HOLIDAY]=jsxRuntime.jsx(Star$1,{}),_getIconEventDisable[EVENT_TYPES.OTHER]=jsxRuntime.jsx(CalendarAccept$1,{}),_getIconEventDisable[EVENT_TYPES.LIVE_ONLINE]=null,_getIconEventDisable[EVENT_TYPES.INACTIVE]=null,_getIconEventDisable);var getIconforEvent$1=function getIconforEvent(event,isActive){if(isActive===void 0){isActive=true;}if(event.source===CALENDAR_TYPE.LMS){var icon=[];if(event.type===EVENT_TYPES.HOLIDAY){return[];}if(event.isCaseStudy){icon.push(jsxRuntime.jsx(GoldStarIcon,{}));}if(event.isTest){icon.push(jsxRuntime.jsx(TestIcon$2,{}));}if(event.isKeyContentAfter||event.isKeyContentBefore){icon.push(jsxRuntime.jsx(FlagIcon$1,{}));}return icon;}else{return isActive?getIconEvent$1[event.type]:getIconEventDisable[event.type];}};var IconFilter=function IconFilter(_ref3){var open=_ref3.open;return jsxRuntime.jsx("svg",{width:"24",height:"24",viewBox:"0 0 24 24",fill:"white",xmlns:"http://www.w3.org/2000/svg",children:jsxRuntime.jsx("path",{d:"M10.1303 2.26001C9.02243 2.26463 7.95215 2.66211 7.10984 3.38174C6.26753 4.10137 5.70782 5.09647 5.53028 6.19001H2.78028C2.68177 6.18599 2.58344 6.20143 2.4909 6.23546C2.39836 6.26948 2.31344 6.32141 2.241 6.38828C2.16855 6.45516 2.11 6.53566 2.0687 6.62518C2.02739 6.7147 2.00415 6.81149 2.00028 6.91001C2.00027 7.10985 2.07896 7.30166 2.21934 7.44391C2.35971 7.58615 2.55046 7.66738 2.75028 7.67001H5.45028H5.53028C5.67163 8.54879 6.06169 9.36871 6.65433 10.0328C7.24697 10.6969 8.0174 11.1773 8.8745 11.4174C9.73161 11.6574 10.6395 11.6469 11.4909 11.3872C12.3422 11.1275 13.1014 10.6294 13.6785 9.95186C14.2557 9.2743 14.6268 8.44561 14.7479 7.5638C14.8689 6.682 14.7349 5.78397 14.3617 4.97593C13.9884 4.16789 13.3916 3.48364 12.6417 3.00412C11.8919 2.52459 11.0204 2.26984 10.1303 2.27001V2.26001ZM10.1303 10.09C9.50289 10.09 8.88961 9.90383 8.36809 9.55507C7.84657 9.2063 7.44027 8.71062 7.20064 8.1308C6.96101 7.55097 6.89882 6.91308 7.02195 6.29789C7.14507 5.68269 7.44798 5.11787 7.89231 4.67494C8.33665 4.23201 8.90242 3.93089 9.518 3.80971C10.1336 3.68852 10.7713 3.75273 11.3503 3.99419C11.9294 4.23566 12.4238 4.64352 12.7709 5.16614C13.118 5.68875 13.3023 6.30262 13.3003 6.93001C13.2976 7.76901 12.9625 8.57275 12.3683 9.16508C11.7741 9.75741 10.9693 10.09 10.1303 10.09ZM16.6403 7.68001C16.4414 7.68001 16.2506 7.60099 16.11 7.46034C15.9693 7.31969 15.8903 7.12892 15.8903 6.93001C15.8876 6.83163 15.9048 6.73371 15.9409 6.64216C15.977 6.5506 16.0312 6.46728 16.1004 6.39723C16.1695 6.32717 16.2521 6.27181 16.3431 6.23448C16.4342 6.19715 16.5319 6.17862 16.6303 6.18001H21.2203C21.4175 6.17999 21.6067 6.25764 21.7471 6.39613C21.8875 6.53463 21.9677 6.72284 21.9703 6.92001C21.9703 7.11985 21.8916 7.31166 21.7512 7.45391C21.6109 7.59615 21.4201 7.67738 21.2203 7.68001H16.6403ZM21.2203 16.31H18.5503H18.4803C18.2954 15.1472 17.679 14.0969 16.754 13.3684C15.829 12.6399 14.6635 12.2868 13.4897 12.3796C12.316 12.4723 11.2203 13.004 10.4212 13.8688C9.62215 14.7335 9.17836 15.8676 9.17836 17.045C9.17836 18.2224 9.62215 19.3565 10.4212 20.2213C11.2203 21.086 12.316 21.6177 13.4897 21.7105C14.6635 21.8032 15.829 21.4501 16.754 20.7216C17.679 19.9932 18.2954 18.9428 18.4803 17.78H18.5603H21.2303C21.4292 17.78 21.62 17.701 21.7606 17.5603C21.9013 17.4197 21.9803 17.2289 21.9803 17.03C21.97 16.8355 21.8855 16.6523 21.744 16.5183C21.6026 16.3843 21.4151 16.3097 21.2203 16.31ZM13.8703 20.25C13.2417 20.2579 12.6249 20.0788 12.0984 19.7353C11.5718 19.3919 11.1593 18.8996 10.9132 18.3211C10.6671 17.7426 10.5986 17.104 10.7164 16.4865C10.8342 15.8689 11.1329 15.3004 11.5746 14.853C12.0163 14.4057 12.581 14.0998 13.197 13.9742C13.813 13.8486 14.4524 13.909 15.034 14.1477C15.6155 14.3864 16.113 14.7926 16.4631 15.3148C16.8133 15.8369 17.0002 16.4514 17.0003 17.08C16.9978 17.9131 16.6684 18.7119 16.0831 19.3047C15.4978 19.8975 14.7032 20.2369 13.8703 20.25ZM7.36028 17.83H2.78028C2.67759 17.8342 2.57514 17.8172 2.47929 17.7801C2.38344 17.743 2.29624 17.6866 2.2231 17.6144C2.14996 17.5422 2.09244 17.4557 2.05411 17.3603C2.01578 17.265 1.99746 17.1627 2.00028 17.06C2.00287 16.8619 2.08272 16.6726 2.22282 16.5325C2.36291 16.3924 2.55218 16.3126 2.75028 16.31H7.33028C7.42869 16.3086 7.52637 16.3272 7.61743 16.3645C7.7085 16.4018 7.79108 16.4572 7.8602 16.5272C7.92932 16.5973 7.98357 16.6806 8.01967 16.7722C8.05577 16.8637 8.07299 16.9616 8.07028 17.06C8.07578 17.2556 8.0046 17.4456 7.87196 17.5895C7.73931 17.7333 7.55569 17.8197 7.36028 17.83Z",fill:open?'white':'#99A1B7'})});};var FlagIcon=function FlagIcon(props){return jsxRuntime.jsx("svg",_extends({},props,{width:"20",height:"21",viewBox:"0 0 20 21",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M4.16406 1.19165C4.50924 1.19165 4.78906 1.47147 4.78906 1.81665V2.72094L6.10038 2.45868C7.59471 2.15981 9.1437 2.30203 10.5586 2.868L10.7283 2.93588C11.9073 3.40747 13.2049 3.49553 14.4368 3.18756C15.4623 2.93118 16.4557 3.70682 16.4557 4.76389V10.9031C16.4557 11.7268 15.8951 12.4448 15.096 12.6446L14.9173 12.6892C13.3152 13.0898 11.6277 12.9752 10.0944 12.3619C8.9046 11.886 7.60208 11.7664 6.34553 12.0177L4.78906 12.329V18.4833C4.78906 18.8285 4.50924 19.1083 4.16406 19.1083C3.81888 19.1083 3.53906 18.8285 3.53906 18.4833V1.81665C3.53906 1.47147 3.81888 1.19165 4.16406 1.19165ZM4.78906 11.0543L6.10038 10.792C7.59471 10.4931 9.1437 10.6354 10.5586 11.2013C11.8479 11.7171 13.267 11.8134 14.6141 11.4766L14.7928 11.4319C15.0355 11.3712 15.2057 11.1532 15.2057 10.9031V4.76389C15.2057 4.52003 14.9766 4.3411 14.74 4.40024C13.2532 4.77194 11.687 4.66565 10.2641 4.09647L10.0944 4.02859C8.9046 3.55268 7.60208 3.43309 6.34553 3.6844L4.78906 3.99569V11.0543Z",fill:"#1C274C"})}));};var CaseStudyIcon=function CaseStudyIcon(props){return jsxRuntime.jsxs("svg",_extends({},props,{width:"20",height:"21",viewBox:"0 0 20 21",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntime.jsx("path",{d:"M18.9983 15.4568L17.9116 14.3625C18.474 13.6254 18.7779 12.7135 18.7779 11.7787C18.7779 9.43055 16.8629 7.50793 14.5071 7.50793C12.1513 7.50793 10.2439 9.43055 10.2439 11.7787C10.2439 13.9825 11.9233 15.8064 14.0664 16.0268C13.9904 16.1636 13.8992 16.2775 13.7928 16.3839C13.466 16.7031 13.0328 16.9007 12.2653 16.9995C11.4826 17.1059 10.4567 17.1059 9.00521 17.1059H7.48534C6.03387 17.1059 5.00796 17.1059 4.22523 16.9995C3.4577 16.9007 3.02454 16.7031 2.69777 16.3839C2.3786 16.0572 2.18862 15.624 2.08223 14.8565C1.97584 14.0737 1.97584 13.0478 1.97584 11.5964V8.55663C1.97584 7.10516 1.97584 6.07925 2.08223 5.29652C2.18862 4.52899 2.3786 4.09583 2.69777 3.76906C3.02454 3.44989 3.4577 3.25991 4.22523 3.15352C5.00796 3.04712 6.03387 3.04712 7.48534 3.04712H9.00521C10.4567 3.04712 11.4826 3.04712 12.2653 3.15352C13.0328 3.25991 13.466 3.44989 13.7928 3.76906C14.0132 3.98944 14.3779 3.98944 14.5983 3.76906C14.8187 3.54868 14.8187 3.18391 14.5983 2.96353C14.0284 2.39358 13.3064 2.14281 12.4173 2.02122C11.551 1.90723 10.4415 1.90723 9.0508 1.90723H7.43975C6.04907 1.90723 4.93957 1.90723 4.07325 2.02122C3.18413 2.14281 2.46219 2.39358 1.89224 2.96353C1.32229 3.53348 1.07152 4.25542 0.949927 5.14454C0.835938 6.01086 0.835938 7.12036 0.835938 8.51104V11.642C0.835938 13.0326 0.835938 14.1421 0.949927 15.0085C1.07152 15.8976 1.32229 16.6195 1.89224 17.1895C2.46219 17.7594 3.18413 18.0102 4.07325 18.1318C4.93957 18.2458 6.04907 18.2458 7.43975 18.2458H9.0508C10.4415 18.2458 11.551 18.2458 12.4173 18.1318C13.3064 18.0102 14.0284 17.7594 14.5983 17.1895C14.9403 16.8399 15.1759 16.4371 15.3278 15.966C15.9662 15.8444 16.5741 15.5784 17.0909 15.1832L18.1852 16.2699C18.2916 16.3839 18.436 16.4371 18.5955 16.4371C18.7551 16.4371 18.8919 16.3839 18.9983 16.2699C19.2263 16.0496 19.2263 15.6848 18.9983 15.4568ZM15.571 14.7121C15.2366 14.8337 14.8795 14.9021 14.5071 14.9021C14.4691 14.9021 14.4387 14.9021 14.4007 14.8945C12.7289 14.8413 11.3914 13.4658 11.3914 11.7787C11.3914 10.0917 12.7897 8.66302 14.5071 8.66302C16.2246 8.66302 17.6304 10.0613 17.6304 11.7787C17.6304 13.1314 16.7717 14.2789 15.571 14.7121Z",fill:"#1B274C"}),jsxRuntime.jsx("path",{d:"M10.7151 7.79668C10.7151 7.48511 10.4567 7.22673 10.1451 7.22673H5.20555C4.89398 7.22673 4.6356 7.48511 4.6356 7.79668C4.6356 8.10825 4.89398 8.36663 5.20555 8.36663H10.1451C10.4567 8.36663 10.7151 8.10825 10.7151 7.79668Z",fill:"#1B274C"}),jsxRuntime.jsx("path",{d:"M7.67533 10.8364C7.67533 10.5248 7.41695 10.2665 7.10538 10.2665H5.20555C4.89398 10.2665 4.6356 10.5248 4.6356 10.8364C4.6356 11.148 4.89398 11.4064 5.20555 11.4064H7.10538C7.41695 11.4064 7.67533 11.148 7.67533 10.8364Z",fill:"#1B274C"}),jsxRuntime.jsx("path",{d:"M5.20555 13.3062C4.89398 13.3062 4.6356 13.5646 4.6356 13.8762C4.6356 14.1877 4.89398 14.4461 5.20555 14.4461H6.34545C6.65702 14.4461 6.9154 14.1877 6.9154 13.8762C6.9154 13.5646 6.65702 13.3062 6.34545 13.3062H5.20555Z",fill:"#1B274C"})]}));};var _getIconEvent;var Left=function Left(){return jsxRuntime.jsx("svg",{width:'16',height:'16',viewBox:'0 0 16 16',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:jsxRuntime.jsx("path",{d:'M9.68642 12.6136C9.59868 12.6141 9.5117 12.5973 9.43048 12.5641C9.34925 12.5309 9.27538 12.482 9.21308 12.4202L5.25975 8.47356C5.13793 8.3458 5.06887 8.17674 5.06642 8.00023C5.06591 7.91249 5.08273 7.82551 5.1159 7.74429C5.14908 7.66306 5.19796 7.58919 5.25975 7.52689L9.21308 3.58023C9.34062 3.47101 9.50467 3.41394 9.67245 3.42042C9.84024 3.4269 9.9994 3.49645 10.1181 3.61518C10.2369 3.73391 10.3064 3.89307 10.3129 4.06086C10.3194 4.22864 10.2623 4.39269 10.1531 4.52023L6.66642 8.00023L10.1398 11.4802C10.2639 11.6051 10.3336 11.7741 10.3336 11.9502C10.3336 12.1264 10.2639 12.2953 10.1398 12.4202C10.0189 12.5402 9.85668 12.6094 9.68642 12.6136Z',fill:'#252F4A'})});};var Right=function Right(){return jsxRuntime.jsx("svg",{width:'16',height:'16',viewBox:'0 0 16 16',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:jsxRuntime.jsx("path",{d:'M6.84715 12.6666C6.75894 12.6662 6.67169 12.6483 6.59044 12.614C6.50919 12.5797 6.43556 12.5295 6.37381 12.4666C6.24965 12.3416 6.17995 12.1727 6.17995 11.9966C6.17995 11.8204 6.24965 11.6515 6.37381 11.5266L9.85381 7.99989L6.37381 4.55322C6.31165 4.49019 6.26252 4.41553 6.22921 4.3335C6.19591 4.25148 6.17908 4.1637 6.1797 4.07517C6.18032 3.98665 6.19837 3.89911 6.23282 3.81756C6.26727 3.73601 6.31744 3.66205 6.38048 3.59989C6.44351 3.53773 6.51817 3.48859 6.6002 3.45529C6.68222 3.42198 6.77 3.40516 6.85853 3.40578C6.94705 3.4064 7.03459 3.42445 7.11614 3.4589C7.19769 3.49334 7.27165 3.54352 7.33381 3.60655L11.2805 7.55989C11.4046 7.6848 11.4743 7.85376 11.4743 8.02989C11.4743 8.20601 11.4046 8.37498 11.2805 8.49989L7.33381 12.4466C7.27224 12.5148 7.19722 12.5696 7.11347 12.6074C7.02972 12.6453 6.93905 12.6654 6.84715 12.6666Z',fill:'#252F4A'})});};var Book=function Book(){return jsxRuntime.jsx("svg",{width:'20',height:'20',viewBox:'0 0 20 20',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:jsxRuntime.jsx("path",{fillRule:'evenodd',clipRule:'evenodd',d:'M7.36051 3.61971C6.37671 3.45978 5.3735 3.45977 4.38969 3.61969C4.04645 3.67549 3.70164 3.7585 2.93716 3.94368C2.81469 3.97335 2.74354 3.99072 2.69032 4.00583C2.6569 4.01532 2.64293 4.02058 2.6395 4.02196C2.6395 4.02196 2.6395 4.02196 2.6395 4.02196C2.57147 4.05542 2.52252 4.11776 2.50609 4.19125C2.50556 4.19493 2.50375 4.2097 2.5024 4.24419C2.50024 4.29939 2.50011 4.37254 2.50011 4.49846V15.8196C2.50011 15.9083 2.50015 15.9626 2.50105 16.0033C2.50163 16.0294 2.50244 16.041 2.50265 16.0437C2.52153 16.1749 2.64055 16.2691 2.7739 16.2564C2.7766 16.2559 2.78803 16.254 2.81375 16.2484C2.85362 16.2397 2.90644 16.2269 2.99264 16.206L3.00819 16.2023C3.34117 16.1216 3.52697 16.0766 3.71304 16.0384C5.13954 15.7457 6.61067 15.7457 8.03717 16.0384C8.22321 16.0766 8.40898 16.1216 8.74185 16.2022L9.25011 16.3253V4.04958L8.81305 3.94371C8.04857 3.75852 7.70375 3.6755 7.36051 3.61971ZM10.7501 4.04959V16.3253L11.2582 16.2023C11.5912 16.1216 11.777 16.0766 11.963 16.0384C13.3895 15.7457 14.8607 15.7457 16.2872 16.0384C16.4732 16.0766 16.659 16.1216 16.992 16.2023L17.0076 16.206C17.0938 16.2269 17.1466 16.2397 17.1865 16.2484C17.2256 16.257 17.2317 16.257 17.2242 16.2562C17.3584 16.2701 17.4786 16.1756 17.4976 16.0437C17.4978 16.041 17.4986 16.0294 17.4992 16.0033C17.5001 15.9626 17.5001 15.9083 17.5001 15.8196V4.49852C17.5001 4.37258 17.5 4.29943 17.4978 4.24423C17.4965 4.20973 17.4947 4.19496 17.4941 4.19129C17.4777 4.11779 17.4287 4.05545 17.3607 4.022C17.3573 4.02062 17.3433 4.01536 17.3099 4.00587C17.2567 3.99075 17.1855 3.97338 17.063 3.94372C16.2985 3.75853 15.9537 3.67551 15.6104 3.61972C14.6267 3.45981 13.6235 3.45981 12.6398 3.61972C12.2965 3.67551 11.9517 3.75853 11.1872 3.94372L10.7501 4.04959ZM4.14902 2.13913C5.29223 1.95329 6.45799 1.9533 7.6012 2.13914C8.00774 2.20523 8.41052 2.30281 9.13225 2.47765L9.80168 2.63981C9.87479 2.65752 9.91513 2.66723 9.94602 2.67381C9.97272 2.67949 9.97804 2.67967 9.97581 2.67945C9.99197 2.68102 10.0082 2.68102 10.0244 2.67945C10.0222 2.67967 10.0275 2.67949 10.0542 2.67381C10.0851 2.66723 10.1254 2.65752 10.1985 2.63982L10.868 2.47765C11.5897 2.30281 11.9925 2.20524 12.3991 2.13915C13.5423 1.95333 14.708 1.95333 15.8511 2.13915C16.2577 2.20524 16.6605 2.30281 17.3822 2.47765L17.4162 2.48588C17.4319 2.48969 17.4478 2.4935 17.4637 2.49732C17.6482 2.5417 17.8425 2.58844 18.0149 2.67215C18.4972 2.9064 18.8457 3.34888 18.9599 3.87292C19.0008 4.0602 19.0005 4.26011 19.0002 4.44971C19.0001 4.46606 19.0001 4.48234 19.0001 4.49852V15.8196C19.0001 15.8317 19.0001 15.8438 19.0001 15.8559C19.0003 15.9884 19.0004 16.1238 18.9843 16.2426C18.8576 17.1797 18.0092 17.8457 17.0693 17.7482C16.9501 17.7358 16.8185 17.7038 16.6896 17.6724C16.6779 17.6696 16.6661 17.6667 16.6544 17.6639C16.3018 17.5784 16.1428 17.54 15.9857 17.5078C14.7581 17.2559 13.4921 17.2559 12.2645 17.5078C12.1074 17.54 11.9484 17.5784 11.5958 17.6639L10.5517 17.9168C10.5427 17.9189 10.5337 17.9211 10.5246 17.9233C10.4134 17.9504 10.2943 17.9794 10.1697 17.9915C10.0569 18.0025 9.9433 18.0025 9.83048 17.9915C9.70589 17.9794 9.5868 17.9504 9.47557 17.9233C9.4665 17.9211 9.45749 17.9189 9.44854 17.9168L8.40443 17.6639C8.05182 17.5784 7.89278 17.54 7.7357 17.5078C6.50811 17.2559 5.2421 17.2559 4.01452 17.5078C3.85743 17.54 3.6984 17.5784 3.34578 17.6639C3.33408 17.6667 3.32234 17.6696 3.31058 17.6724C3.18171 17.7038 3.05015 17.7358 2.93091 17.7482C1.991 17.8457 1.14259 17.1797 1.01588 16.2426C0.999808 16.1238 0.999947 15.9883 1.00008 15.8559C1.00009 15.8438 1.00011 15.8317 1.00011 15.8196V4.49846C1.00011 4.48228 1.00008 4.466 1.00005 4.44965C0.999745 4.26006 0.999419 4.06018 1.04026 3.8729C1.15455 3.34885 1.50299 2.90636 1.98536 2.67211C2.15773 2.5884 2.35205 2.54166 2.53655 2.49729C2.55245 2.49346 2.56828 2.48965 2.58402 2.48584L2.61796 2.47762C3.3397 2.30278 3.74248 2.20521 4.14902 2.13913Z',fill:'#025EFF'})});};var CalendarDelete=function CalendarDelete(){return jsxRuntime.jsx("svg",{width:'20',height:'20',viewBox:'0 0 20 20',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:jsxRuntime.jsx("path",{fillRule:'evenodd',clipRule:'evenodd',d:'M6.75 1C7.16421 1 7.5 1.33579 7.5 1.75V3H12.5V1.75C12.5 1.33579 12.8358 1 13.25 1C13.6642 1 14 1.33579 14 1.75V3H16.25C17.7688 3 19 4.23122 19 5.75V8.75C19 9.16421 18.6642 9.5 18.25 9.5H2.5V16.25C2.5 16.9404 3.05964 17.5 3.75 17.5H8.75C9.16421 17.5 9.5 17.8358 9.5 18.25C9.5 18.6642 9.16421 19 8.75 19H3.75C2.23122 19 1 17.7688 1 16.25V5.75C1 4.23122 2.23122 3 3.75 3H6V1.75C6 1.33579 6.33579 1 6.75 1ZM6 4.5H3.75C3.05964 4.5 2.5 5.05964 2.5 5.75V8H17.5V5.75C17.5 5.05964 16.9404 4.5 16.25 4.5H14V5.25C14 5.66421 13.6642 6 13.25 6C12.8358 6 12.5 5.66421 12.5 5.25V4.5H7.5V5.25C7.5 5.66421 7.16421 6 6.75 6C6.33579 6 6 5.66421 6 5.25V4.5ZM12 15.75C12 15.3358 12.3358 15 12.75 15H19.25C19.6642 15 20 15.3358 20 15.75C20 16.1642 19.6642 16.5 19.25 16.5H12.75C12.3358 16.5 12 16.1642 12 15.75Z',fill:'#D20306'})});};var CalendarAccept=function CalendarAccept(){return jsxRuntime.jsxs("svg",{width:'20',height:'20',viewBox:'0 0 20 20',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:[jsxRuntime.jsx("g",{clipPath:'url(#clip0_678_4877)',children:jsxRuntime.jsx("path",{fillRule:'evenodd',clipRule:'evenodd',d:'M6.75 1C7.16421 1 7.5 1.33579 7.5 1.75V3H12.5V1.75C12.5 1.33579 12.8358 1 13.25 1C13.6642 1 14 1.33579 14 1.75V3H16.25C17.7688 3 19 4.23122 19 5.75V8.75C19 9.16421 18.6642 9.5 18.25 9.5H2.5V16.25C2.5 16.9404 3.05964 17.5 3.75 17.5H8.75C9.16421 17.5 9.5 17.8358 9.5 18.25C9.5 18.6642 9.16421 19 8.75 19H3.75C2.23122 19 1 17.7688 1 16.25V5.75C1 4.23122 2.23122 3 3.75 3H6V1.75C6 1.33579 6.33579 1 6.75 1ZM6 4.5H3.75C3.05964 4.5 2.5 5.05964 2.5 5.75V8H17.5V5.75C17.5 5.05964 16.9404 4.5 16.25 4.5H14V5.25C14 5.66421 13.6642 6 13.25 6C12.8358 6 12.5 5.66421 12.5 5.25V4.5H7.5V5.25C7.5 5.66421 7.16421 6 6.75 6C6.33579 6 6 5.66421 6 5.25V4.5ZM19.765 13.2047C20.0661 13.4891 20.0797 13.9638 19.7953 14.265L15.5453 18.765C15.4014 18.9173 15.2005 19.0025 14.991 18.9999C14.7815 18.9974 14.5827 18.9074 14.4425 18.7517L12.1925 16.2517C11.9154 15.9438 11.9404 15.4696 12.2483 15.1925C12.5562 14.9154 13.0304 14.9404 13.3075 15.2483L15.0133 17.1436L18.7047 13.235C18.9891 12.9339 19.4638 12.9203 19.765 13.2047Z',fill:'#07AF17'})}),jsxRuntime.jsx("defs",{children:jsxRuntime.jsx("clipPath",{id:'clip0_678_4877',children:jsxRuntime.jsx("rect",{width:'20',height:'20',fill:'white'})})})]});};var Star=function Star(){return jsxRuntime.jsx("svg",{width:'20',height:'20',viewBox:'0 0 20 20',fill:'none',xmlns:'http://www.w3.org/2000/svg',children:jsxRuntime.jsx("path",{fillRule:'evenodd',clipRule:'evenodd',d:'M10.0928 2.52324C9.99905 2.47488 9.86181 2.50026 9.79335 2.64522L8.00799 6.42557C7.76215 6.94613 7.27807 7.32297 6.69953 7.41082L2.70736 8.01703C2.66367 8.02366 2.61758 8.04593 2.57857 8.08775C2.47149 8.20255 2.47467 8.39827 2.58316 8.50878L5.47192 11.4514C5.87611 11.8631 6.05323 12.4463 5.96057 13.0109L5.27863 17.1659C5.2674 17.2343 5.27853 17.3035 5.30766 17.3614C5.3787 17.5027 5.51526 17.5255 5.60897 17.474L9.17967 15.5123C9.69201 15.2308 10.3079 15.2308 10.8202 15.5123L14.3909 17.474C14.434 17.4977 14.48 17.5045 14.5234 17.4967C14.5864 17.4854 14.6553 17.4449 14.7056 17.3752C14.754 17.3081 14.7706 17.2347 14.7603 17.1681L14.0393 13.0109C13.9466 12.4463 14.1238 11.8631 14.5279 11.4514L17.4167 8.50878C17.4568 8.46792 17.4872 8.40957 17.4968 8.34084C17.5227 8.15465 17.3972 8.03293 17.2925 8.01703L13.3003 7.41082C12.7218 7.32297 12.2377 6.94613 11.9919 6.42557L10.2065 2.64522C10.1788 2.58657 10.1367 2.54586 10.0928 2.52324ZM8.437 2.00466C8.85086 1.12835 9.89685 0.734429 10.7804 1.1901C11.1257 1.36818 11.3985 1.65664 11.5629 2.00466L13.3482 5.78501C13.3898 5.87307 13.4613 5.91807 13.5255 5.92782L17.5177 6.53403C18.4915 6.6819 19.1133 7.60658 18.9825 8.54743C18.9296 8.92748 18.7578 9.28392 18.4871 9.5596L15.5984 12.5022C15.5379 12.5637 15.5029 12.662 15.5191 12.7656L16.2401 16.9229C16.4008 17.902 15.7151 18.807 14.788 18.9732C14.4037 19.042 14.0097 18.976 13.6686 18.7887L10.0979 16.8269C10.0354 16.7926 9.96447 16.7926 9.90194 16.8269L6.33123 18.7887C5.46031 19.2671 4.40376 18.9024 3.96767 18.0356C3.79485 17.692 3.7363 17.3015 3.79843 16.9229L4.48038 12.7679C4.49751 12.6635 4.4624 12.5642 4.40151 12.5022L1.51275 9.5596C0.840839 8.87517 0.828048 7.76534 1.48168 7.0646C1.74558 6.78168 2.09641 6.59261 2.48217 6.53403L6.47434 5.92782C6.53853 5.91807 6.61006 5.87307 6.65165 5.78501L8.437 2.00466Z',fill:'#F57C00'})});};var TestIcon$1=function TestIcon(){return jsxRuntime.jsxs("svg",{width:"19",height:"19",viewBox:"0 0 19 19",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M7.40068 1.44583C7.13326 1.28774 6.78831 1.37637 6.63021 1.6438C6.47212 1.91123 6.56076 2.25618 6.82818 2.41427L6.97512 2.50114L1.93129 11.2072C0.769772 13.212 1.45986 15.7748 3.46961 16.9311C5.47822 18.0868 8.04752 17.4017 9.20838 15.398L14.2549 6.6873L14.3992 6.77036C14.6684 6.92534 15.0123 6.83272 15.1673 6.56348C15.3223 6.29425 15.2297 5.95034 14.9604 5.79536L14.33 5.43246L8.02445 1.81458L7.40068 1.44583ZM2.90473 11.7711L7.94727 3.06732L13.2795 6.12674L12.1508 8.07503L10.7183 7.25088C10.4491 7.09595 10.1052 7.18864 9.95026 7.45791C9.79533 7.72719 9.88803 8.07107 10.1573 8.22599L11.5868 9.04847L10.8657 10.2931L8.19959 8.75916C7.93032 8.60424 7.58644 8.69693 7.43151 8.9662C7.27659 9.23547 7.36928 9.57935 7.63855 9.73428L10.3017 11.2666L9.63754 12.413L8.16412 11.5653C7.89485 11.4104 7.55097 11.5031 7.39604 11.7723C7.24111 12.0416 7.33381 12.3855 7.60308 12.5404L9.07358 13.3865L8.23494 14.834C7.38581 16.2997 5.50344 16.8034 4.03065 15.956C2.55899 15.1092 2.05625 13.2357 2.90473 11.7711Z",fill:"#1C274C"}),jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M16.3112 9.50613C15.8291 8.99746 15.0305 8.99746 14.5484 9.50613C14.3177 9.74953 14.0362 10.0725 13.8089 10.4169C13.5956 10.74 13.3673 11.1732 13.3673 11.6175C13.3673 12.7692 14.2693 13.7425 15.4298 13.7425C16.5903 13.7425 17.4923 12.7692 17.4923 11.6175C17.4923 11.1732 17.264 10.74 17.0507 10.4169C16.8234 10.0725 16.5419 9.74953 16.3112 9.50613ZM15.3649 10.28C15.3869 10.2568 15.4099 10.2496 15.4298 10.2496C15.4497 10.2496 15.4727 10.2568 15.4947 10.28C15.7036 10.5005 15.9356 10.7697 16.1118 11.0366C16.302 11.3247 16.3673 11.5218 16.3673 11.6175C16.3673 12.1916 15.9262 12.6175 15.4298 12.6175C14.9335 12.6175 14.4923 12.1916 14.4923 11.6175C14.4923 11.5218 14.5576 11.3247 14.7478 11.0366C14.924 10.7697 15.156 10.5005 15.3649 10.28Z",fill:"#1C274C"})]});};var FilterIcon=function FilterIcon(){return jsxRuntime.jsxs("svg",{width:"20",height:"22",viewBox:"0 0 20 21",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M15.2057 5.9834C15.2057 7.70929 13.8066 9.1084 12.0807 9.1084C10.3548 9.1084 8.95573 7.70929 8.95573 5.9834C8.95573 4.25751 10.3548 2.8584 12.0807 2.8584C13.8066 2.8584 15.2057 4.25751 15.2057 5.9834ZM12.0807 7.8584C13.1163 7.8584 13.9557 7.01893 13.9557 5.9834C13.9557 4.94786 13.1163 4.1084 12.0807 4.1084C11.0452 4.1084 10.2057 4.94786 10.2057 5.9834C10.2057 7.01893 11.0452 7.8584 12.0807 7.8584Z",fill:"#1F2937"}),jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M4.78906 14.3167C4.78906 16.0426 6.18817 17.4417 7.91406 17.4417C9.63995 17.4417 11.0391 16.0426 11.0391 14.3167C11.0391 12.5908 9.63995 11.1917 7.91406 11.1917C6.18817 11.1917 4.78906 12.5908 4.78906 14.3167ZM7.91406 16.1917C6.87853 16.1917 6.03906 15.3523 6.03906 14.3167C6.03906 13.2812 6.87853 12.4417 7.91406 12.4417C8.9496 12.4417 9.78906 13.2812 9.78906 14.3167C9.78906 15.3523 8.9496 16.1917 7.91406 16.1917Z",fill:"#1F2937"}),jsxRuntime.jsx("path",{d:"M11.8724 14.2822C11.8724 13.937 12.1522 13.6572 12.4974 13.6572H18.3307C18.6759 13.6572 18.9557 13.937 18.9557 14.2822C18.9557 14.6273 18.6759 14.9072 18.3307 14.9072H12.4974C12.1522 14.9072 11.8724 14.6273 11.8724 14.2822Z",fill:"#1F2937"}),jsxRuntime.jsx("path",{d:"M7.4974 5.32383C7.84257 5.32383 8.1224 5.60365 8.1224 5.94883C8.1224 6.29401 7.84257 6.57383 7.4974 6.57383L1.66406 6.57383C1.31888 6.57383 1.03906 6.29401 1.03906 5.94883C1.03906 5.60365 1.31888 5.32383 1.66406 5.32383L7.4974 5.32383Z",fill:"#1F2937"}),jsxRuntime.jsx("path",{d:"M1.03906 14.2822C1.03906 13.937 1.31888 13.6572 1.66406 13.6572H3.33073C3.67591 13.6572 3.95573 13.937 3.95573 14.2822C3.95573 14.6273 3.67591 14.9072 3.33073 14.9072H1.66406C1.31888 14.9072 1.03906 14.6273 1.03906 14.2822Z",fill:"#1F2937"}),jsxRuntime.jsx("path",{d:"M18.3307 5.32383C18.6759 5.32383 18.9557 5.60365 18.9557 5.94883C18.9557 6.29401 18.6759 6.57383 18.3307 6.57383H16.6641C16.3189 6.57383 16.0391 6.29401 16.0391 5.94883C16.0391 5.60365 16.3189 5.32383 16.6641 5.32383H18.3307Z",fill:"#1FFFBF2"})]});};var FilterDateIcon=function FilterDateIcon(){return jsxRuntime.jsxs("svg",{width:"20",height:"22",viewBox:"0 0 20 21",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntime.jsx("path",{d:"M14.1641 11.8167C14.6243 11.8167 14.9974 11.4436 14.9974 10.9834C14.9974 10.5232 14.6243 10.1501 14.1641 10.1501C13.7038 10.1501 13.3307 10.5232 13.3307 10.9834C13.3307 11.4436 13.7038 11.8167 14.1641 11.8167Z",fill:"#1F2937"}),jsxRuntime.jsx("path",{d:"M14.1641 15.1501C14.6243 15.1501 14.9974 14.777 14.9974 14.3167C14.9974 13.8565 14.6243 13.4834 14.1641 13.4834C13.7038 13.4834 13.3307 13.8565 13.3307 14.3167C13.3307 14.777 13.7038 15.1501 14.1641 15.1501Z",fill:"#1F2937"}),jsxRuntime.jsx("path",{d:"M10.8307 10.9834C10.8307 11.4436 10.4576 11.8167 9.9974 11.8167C9.53716 11.8167 9.16406 11.4436 9.16406 10.9834C9.16406 10.5232 9.53716 10.1501 9.9974 10.1501C10.4576 10.1501 10.8307 10.5232 10.8307 10.9834Z",fill:"#1F2937"}),jsxRuntime.jsx("path",{d:"M10.8307 14.3167C10.8307 14.777 10.4576 15.1501 9.9974 15.1501C9.53716 15.1501 9.16406 14.777 9.16406 14.3167C9.16406 13.8565 9.53716 13.4834 9.9974 13.4834C10.4576 13.4834 10.8307 13.8565 10.8307 14.3167Z",fill:"#1F2937"}),jsxRuntime.jsx("path",{d:"M5.83073 11.8167C6.29097 11.8167 6.66406 11.4436 6.66406 10.9834C6.66406 10.5232 6.29097 10.1501 5.83073 10.1501C5.37049 10.1501 4.9974 10.5232 4.9974 10.9834C4.9974 11.4436 5.37049 11.8167 5.83073 11.8167Z",fill:"#1F2937"}),jsxRuntime.jsx("path",{d:"M5.83073 15.1501C6.29097 15.1501 6.66406 14.777 6.66406 14.3167C6.66406 13.8565 6.29097 13.4834 5.83073 13.4834C5.37049 13.4834 4.9974 13.8565 4.9974 14.3167C4.9974 14.777 5.37049 15.1501 5.83073 15.1501Z",fill:"#1F2937"}),jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M5.83073 1.6084C6.17591 1.6084 6.45573 1.88822 6.45573 2.2334V2.869C7.00739 2.85839 7.61517 2.85839 8.28361 2.8584H11.7111C12.3795 2.85839 12.9874 2.85839 13.5391 2.869V2.2334C13.5391 1.88822 13.8189 1.6084 14.1641 1.6084C14.5092 1.6084 14.7891 1.88822 14.7891 2.2334V2.92264C15.0057 2.93915 15.2108 2.95991 15.4049 2.98601C16.3819 3.11737 17.1727 3.39413 17.7964 4.01777C18.42 4.6414 18.6968 5.43219 18.8281 6.40921C18.9558 7.35855 18.9557 8.57157 18.9557 10.103V11.8637C18.9557 13.3952 18.9558 14.6082 18.8281 15.5576C18.6968 16.5346 18.42 17.3254 17.7964 17.949C17.1727 18.5727 16.3819 18.8494 15.4049 18.9808C14.4556 19.1084 13.2426 19.1084 11.7111 19.1084H8.28372C6.75227 19.1084 5.53922 19.1084 4.58988 18.9808C3.61286 18.8494 2.82207 18.5727 2.19843 17.949C1.5748 17.3254 1.29803 16.5346 1.16668 15.5576C1.03904 14.6082 1.03905 13.3952 1.03906 11.8637V10.1031C1.03905 8.57158 1.03904 7.35856 1.16668 6.40921C1.29803 5.43219 1.5748 4.6414 2.19843 4.01777C2.82207 3.39413 3.61286 3.11737 4.58988 2.98601C4.78398 2.95991 4.98911 2.93915 5.20573 2.92264V2.2334C5.20573 1.88822 5.48555 1.6084 5.83073 1.6084ZM4.75644 4.22486C3.91803 4.33759 3.43499 4.54898 3.08232 4.90165C2.72964 5.25433 2.51825 5.73736 2.40553 6.57577C2.38644 6.71776 2.37048 6.86724 2.35713 7.02506H17.6377C17.6243 6.86724 17.6084 6.71776 17.5893 6.57577C17.4765 5.73736 17.2652 5.25433 16.9125 4.90165C16.5598 4.54898 16.0768 4.33758 15.2384 4.22486C14.382 4.10973 13.2531 4.1084 11.6641 4.1084H8.33073C6.74171 4.1084 5.61282 4.10973 4.75644 4.22486ZM2.28906 10.1501C2.28906 9.43839 2.28933 8.81901 2.29997 8.27506H17.6948C17.7055 8.81901 17.7057 9.43839 17.7057 10.1501V11.8167C17.7057 13.4057 17.7044 14.5346 17.5893 15.391C17.4765 16.2294 17.2652 16.7125 16.9125 17.0651C16.5598 17.4178 16.0768 17.6292 15.2384 17.7419C14.382 17.8571 13.2531 17.8584 11.6641 17.8584H8.33073C6.74171 17.8584 5.61282 17.8571 4.75644 17.7419C3.91803 17.6292 3.43499 17.4178 3.08232 17.0651C2.72964 16.7125 2.51825 16.2294 2.40553 15.391C2.29039 14.5346 2.28906 13.4057 2.28906 11.8167V10.1501Z",fill:"#1F2937"})]});};var DropDownIcon=function DropDownIcon(_ref){var _ref$size=_ref.size,size=_ref$size===void 0?20:_ref$size;return jsxRuntime.jsx("svg",{width:size,height:size,viewBox:"0 0 20 21",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M3.68954 7.24317C3.91418 6.98109 4.30874 6.95074 4.57082 7.17538L9.99741 11.8267L15.424 7.17538C15.6861 6.95074 16.0806 6.98109 16.3053 7.24317C16.5299 7.50525 16.4996 7.89981 16.2375 8.12445L10.4042 13.1244C10.1701 13.3251 9.82472 13.3251 9.59066 13.1244L3.75733 8.12445C3.49525 7.89981 3.4649 7.50525 3.68954 7.24317Z",fill:"#1F2937"})});};var LeftArrowIcon=function LeftArrowIcon(){return jsxRuntime.jsx("svg",{width:"20",height:"21",viewBox:"0 0 20 21",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M12.9067 3.84188C13.1688 4.06652 13.1992 4.46108 12.9745 4.72316L8.32317 10.1498L12.9745 15.5763C13.1992 15.8384 13.1688 16.233 12.9067 16.4576C12.6447 16.6823 12.2501 16.6519 12.0255 16.3898L7.02546 10.5565C6.82485 10.3224 6.82485 9.97706 7.02546 9.74301L12.0255 3.90967C12.2501 3.64759 12.6447 3.61724 12.9067 3.84188Z",fill:"#1F2937"})});};var RightArrowIcon=function RightArrowIcon(){return jsxRuntime.jsx("svg",{width:"20",height:"21",viewBox:"0 0 20 21",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M7.09327 3.84188C7.35535 3.61724 7.74991 3.64759 7.97455 3.90967L12.9745 9.74301C13.1752 9.97706 13.1752 10.3224 12.9745 10.5565L7.97455 16.3898C7.74991 16.6519 7.35535 16.6823 7.09327 16.4576C6.83119 16.233 6.80084 15.8384 7.02548 15.5763L11.6768 10.1498L7.02548 4.72316C6.80084 4.46108 6.83119 4.06652 7.09327 3.84188Z",fill:"#1F2937"})});};var CloseIcon$1=function CloseIcon(){return jsxRuntime.jsxs("svg",{width:"25",height:"24",viewBox:"0 0 25 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntime.jsx("path",{d:"M18.5 18L6.5 6",stroke:"#3F3F3F","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}),jsxRuntime.jsx("path",{d:"M6.5 18L18.5 6",stroke:"#3F3F3F","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"})]});};var CheckIcon$1=function CheckIcon(){return jsxRuntime.jsx("svg",{width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M17.1089 5.39106C17.353 5.63514 17.353 6.03087 17.1089 6.27495L9.95407 13.4298C9.05916 14.3248 7.60816 14.3248 6.71321 13.4298L3.72505 10.4416C3.48097 10.1975 3.48097 9.80184 3.72505 9.55776C3.96912 9.31367 4.36486 9.31367 4.60893 9.55776L7.59709 12.5459C8.00388 12.9527 8.66341 12.9527 9.07024 12.5459L16.2251 5.39106C16.4692 5.14699 16.8648 5.14699 17.1089 5.39106Z",fill:"#FFB800"})});};var getIconEvent=(_getIconEvent={},_getIconEvent[EVENT_TYPES.TEACHING]=jsxRuntime.jsx(Book,{}),_getIconEvent[EVENT_TYPES.BUSY]=jsxRuntime.jsx(CalendarDelete,{}),_getIconEvent[EVENT_TYPES.HOLIDAY]=jsxRuntime.jsx(Star,{}),_getIconEvent[EVENT_TYPES.OTHER]=jsxRuntime.jsx(CalendarAccept,{}),_getIconEvent[EVENT_TYPES.LIVE_ONLINE]=null,_getIconEvent[EVENT_TYPES.INACTIVE]=null,_getIconEvent);var getIconforEvent=function getIconforEvent(event){if(event.source===CALENDAR_TYPE.LMS){var icon=[];if(event.type===EVENT_TYPES.HOLIDAY){return[];}if(event.isCaseStudy){icon.push(jsxRuntime.jsx(CaseStudyIcon,{}));}if(event.isTest){icon.push(jsxRuntime.jsx(TestIcon$1,{}));}if(event.isKeyContentAfter||event.isKeyContentBefore){icon.push(jsxRuntime.jsx(FlagIcon,{}));}return icon;}else{return getIconEvent[event.type];}};var _convertType,_convertTypeDisable;dayjs__default["default"].extend(isoWeek__default["default"]);var customDateFormat=function customDateFormat(value,formatStr){return dayjs__default["default"](value).format(formatStr);};var extractMonthYear=function extractMonthYear(value){var date=dayjs__default["default"](value);return{month:date.format('MMMM'),year:date.year()};};var extractWeek=function extractWeek(value){var date=dayjs__default["default"](value);var startOfWeek=date.startOf('isoWeek');var endOfWeek=date.endOf('isoWeek');return{startDateDisplay:startOfWeek.format('D MMMM'),endDateDisplay:endOfWeek.format('D MMMM'),year:endOfWeek.year()};};var convertType=(_convertType={},_convertType[EVENT_TYPES.TEACHING]='info',_convertType[EVENT_TYPES.BUSY]='error',_convertType[EVENT_TYPES.HOLIDAY]='warning',_convertType[EVENT_TYPES.OTHER]='success',_convertType[EVENT_TYPES.LIVE_ONLINE]='purple',_convertType[EVENT_TYPES.INACTIVE]='inactive',_convertType);var convertTypeDisable=(_convertTypeDisable={},_convertTypeDisable[EVENT_TYPES.TEACHING]='infoDisable',_convertTypeDisable[EVENT_TYPES.BUSY]='errorDisable',_convertTypeDisable[EVENT_TYPES.HOLIDAY]='warning',_convertTypeDisable[EVENT_TYPES.OTHER]='success',_convertTypeDisable[EVENT_TYPES.LIVE_ONLINE]='purple',_convertTypeDisable[EVENT_TYPES.INACTIVE]='inactive',_convertTypeDisable);var daysOfWeekKeys=Object.values(DAYS_OF_WEEK);var calculateNormOfWeek=function calculateNormOfWeek(norms,events,startDate,endDate){var norm=norms.find(function(norm){return startDate.isBetween(norm.startDate,norm.endDate,'day','[]')&&endDate.isBetween(norm.startDate,norm.endDate,'day','[]');});if(!norm){return{normOfWeek:0,totalNorm:0};}var normsOfWeek=events.filter(function(event){return dayjs__default["default"](event.startDate).isBetween(startDate,endDate,'day','[]')&&endDate.isBetween(startDate,endDate,'day','[]')&&event.type===EVENT_TYPES.TEACHING;});return{normOfWeek:normsOfWeek.length,totalNorm:norm.maxShift,status:norm.status};};var splitEventsIntoDays=function splitEventsIntoDays(events){var splittedEvents=[];for(var _iterator=_createForOfIteratorHelperLoose(events),_step;!(_step=_iterator()).done;){var event=_step.value;var startDate=dayjs__default["default"](event.startDate);var endDate=dayjs__default["default"](event.endDate);var isSameDay=startDate.isSame(endDate,'day');if(isSameDay){splittedEvents.push(event);continue;}// Start day
// splittedEvents.push({
//   ...event,
//   startDate: startDate.toDate(),
//   endDate: startDate.endOf('day').toDate()
// })
// All-day events for intermediate days
var currentDate=startDate.startOf('day');while(currentDate.isBefore(endDate,'day')){splittedEvents.push(_extends({},event,{startDate:currentDate.startOf('day').toDate(),endDate:currentDate.endOf('day').toDate()}));currentDate=currentDate.add(1,'day');}// End day
splittedEvents.push(_extends({},event,{startDate:endDate.startOf('day').toDate(),endDate:endDate.toDate()}));}return splittedEvents;};var checkIsAllday=function checkIsAllday(startDate,endDate){if(!startDate.isValid()||!endDate.isValid()){return false;}return startDate.format(TIME_FORMAT)===startDate.startOf('day').format(TIME_FORMAT)&&endDate.format(TIME_FORMAT)===endDate.endOf('day').format(TIME_FORMAT)&&startDate.isBefore(endDate);};var hoursOfDayKeys=Object.values(HOUR_OF_DAY);var isDisplayIcon=function isDisplayIcon(event){var iconList=getIconforEvent$1(event,event.isActive);if(event.source==='LMS'){return Array.isArray(iconList)&&iconList.length>0;}return!!iconList;};var isDisplayIconV2=function isDisplayIconV2(event){var iconList=getIconforEvent(event);if(event.source==='LMS'){return Array.isArray(iconList)&&iconList.length>0;}return!!iconList;};var Notepad=function Notepad(props){return jsxRuntime.jsx("svg",_extends({},props,{xmlns:'http://www.w3.org/2000/svg',width:'12',height:'14',fill:'none',children:jsxRuntime.jsx("path",{fill:'#FFB800',d:'M9.662 1.687A2.667 2.667 0 0 1 12 4.333V11a2.667 2.667 0 0 1-2.667 2.667H2.667A2.667 2.667 0 0 1 0 11V4.333a2.667 2.667 0 0 1 2.338-2.646A2.167 2.167 0 0 0 4.5 4h3a2.167 2.167 0 0 0 2.162-2.313ZM3.333 10.5a.5.5 0 0 0 0 1H6a.5.5 0 0 0 0-1H3.333Zm0-2.666a.5.5 0 0 0 0 1h5.334a.5.5 0 0 0 0-1H3.333Zm0-2.667a.5.5 0 0 0 0 1h5.334a.5.5 0 0 0 0-1H3.333Zm4-4.834a1.334 1.334 0 0 1 0 2.667H4.667a1.334 1.334 0 1 1 0-2.667h2.666Z'})}));};var StarFilled=function StarFilled(props){return jsxRuntime.jsx("svg",_extends({},props,{xmlns:'http://www.w3.org/2000/svg',width:'16',height:'16',fill:'none',children:jsxRuntime.jsx("path",{fill:'#FFB800',d:'m15.073 5.162-4.534-.659L8.512.395a.574.574 0 0 0-1.025 0L5.46 4.503l-4.534.66a.57.57 0 0 0-.316.974l3.28 3.199-.774 4.516a.57.57 0 0 0 .828.601L8 12.322l4.055 2.133a.57.57 0 0 0 .829-.602l-.775-4.516 3.28-3.199a.57.57 0 0 0-.316-.975Z'})}));};var styles$5={"calendar-legend":"_mE711","calendar-legend__dot":"_lwotK","calendar-legend--container":"_Hv9Dj","calendar-legend--online":"_f-Onm","calendar-legend--live-online":"_bIxRM","calendar-legend--offline":"_LRnll","calendar-legend--cancel":"_FJVJC","calendar-legend--holiday":"_XKt4T"};var colors$1=[{label:'Online',color:'calendar-legend--online'},{label:'Live Online',color:'calendar-legend--live-online'},{label:'Offline',color:'calendar-legend--offline'},{label:'Cancelled',color:'calendar-legend--cancel'},{label:'Holiday',color:'calendar-legend--holiday'}];var CalendarLegend$1=function CalendarLegend(){return jsxRuntime.jsxs("div",{className:styles$5['calendar-legend'],children:[colors$1.map(function(_ref){var label=_ref.label,color=_ref.color;return jsxRuntime.jsxs("div",{className:styles$5['calendar-legend--container'],children:[jsxRuntime.jsx("div",{className:clsx__default["default"](styles$5['calendar-legend__dot'],styles$5[color])}),jsxRuntime.jsx("span",{children:label})]},color);}),jsxRuntime.jsxs("div",{className:styles$5['calendar-legend--container'],children:[jsxRuntime.jsx(StarFilled,{}),jsxRuntime.jsx("span",{children:"Case Study"})]}),jsxRuntime.jsxs("div",{className:styles$5['calendar-legend--container'],children:[jsxRuntime.jsx(Notepad,{}),jsxRuntime.jsx("span",{children:"Test"})]}),jsxRuntime.jsxs("div",{className:styles$5['calendar-legend--container'],children:[jsxRuntime.jsx(FlagIcon$1,{}),jsxRuntime.jsx("span",{children:"Key Content"})]})]});};var styles$4={"ant-picker-calendar-header":"_RyM4N","ant-radio-group":"_8Mba-","ant-picker-calendar-month-select":"_2BgdA","calendar-filter":"_mGzVN","calendar-filter_title":"_rYhBF","calendar-filter_note_blue":"_fysXj","calendar-filter_note_pureple":"_j5erl","calendar-filter_note_green":"_cwlzN","calendar-filter_note_yellow":"_WJzdW","calendar-filter_note_red":"_sqyaT","calendar-filter_content_list_item":"_U9xSN","calendar-filter_content_item_eye":"_jHR9c"};var FilterCalendar$1=function FilterCalendar(_ref){var filter=_ref.filter,setFilter=_ref.setFilter,courses=_ref.courses,onRefetchAPI=_ref.onRefetchAPI;var noteFilter=React.useMemo(function(){return[{title:'Online',icon:jsxRuntime.jsx("div",{className:styles$4['calendar-filter_note_blue']}),value:LEARNING_MODE.ONLINE},{title:'Live Online',icon:jsxRuntime.jsx("div",{className:styles$4['calendar-filter_note_pureple']}),value:LEARNING_MODE.LIVE_ONLINE},{title:'Offline',icon:jsxRuntime.jsx("div",{className:styles$4['calendar-filter_note_green']}),value:LEARNING_MODE.OFFLINE},{title:'Test',icon:jsxRuntime.jsx(TestIcon$2,{}),value:LEARNING_MODE.TEST},{title:'Case Study',icon:jsxRuntime.jsx(GoldStarIcon,{}),value:LEARNING_MODE.CASE_STUDY},{title:'Key Content Of',icon:jsxRuntime.jsx(FlagIcon$1,{}),value:LEARNING_MODE.KEY_BEFORE_CONTENT},{title:'Holiday',icon:jsxRuntime.jsx("div",{className:styles$4['calendar-filter_note_yellow']}),value:LEARNING_MODE.HOLIDAY},{title:'Overdue',icon:jsxRuntime.jsx("div",{className:styles$4['calendar-filter_note_red']}),value:LEARNING_MODE.OVERDUE}];},[]);var handleFilter=function handleFilter(type,value){switch(type){case'course':{setFilter(function(prev){var courseId=prev.courseId||[];var updatedCourseId=courseId.includes(value)?courseId.filter(function(item){return item!==value;}):[].concat(courseId,[value]);return _extends({},prev,{courseId:updatedCourseId});});break;}case'note':{setFilter(function(prev){var typeArray=prev.type||[];var updatedType=typeArray.includes(value)?typeArray.filter(function(item){return item!==value;}):[].concat(typeArray,[value]);return _extends({},prev,{type:updatedType});});break;}case'day':{setFilter(function(prev){return _extends({},prev,{day:value});});break;}}};var handleFilterday=function handleFilterday(date){onRefetchAPI(date.toDate());handleFilter('day',date.toString());};return jsxRuntime.jsxs("div",{className:styles$4['calendar-filter'],children:[jsxRuntime.jsx(antd.Calendar,{mode:'month',className:styles$4['custom-today-picker'],fullscreen:false,onChange:handleFilterday}),jsxRuntime.jsxs("div",{children:[jsxRuntime.jsxs("div",{className:styles$4['calendar-filter_title'],children:[jsxRuntime.jsx(TagIcon,{}),jsxRuntime.jsx("h3",{children:"Notes"})]}),jsxRuntime.jsx("div",{children:noteFilter.map(function(item){var _filter$type;return jsxRuntime.jsxs("div",{className:styles$4['calendar-filter_content_list_item'],children:[jsxRuntime.jsxs("div",{className:styles$4['calendar-filter_content_list_item'],children:[item.icon,item.title]}),jsxRuntime.jsx("div",{onClick:function onClick(){return handleFilter('note',item.value);},className:styles$4['calendar-filter_content_item_eye'],children:(_filter$type=filter.type)!=null&&_filter$type.includes(item.value)?jsxRuntime.jsx(EyeIcon,{}):jsxRuntime.jsx(HiddenEyeIcon,{})})]},item.value);})})]}),jsxRuntime.jsxs("div",{children:[jsxRuntime.jsxs("div",{className:styles$4['calendar-filter_title'],children:[jsxRuntime.jsx(EducationIcon,{}),jsxRuntime.jsx("h3",{children:"My courses"})]}),jsxRuntime.jsx("div",{children:courses==null?void 0:courses.map(function(item,key){var _filter$courseId;return jsxRuntime.jsxs("div",{className:styles$4['calendar-filter_content_list_item'],children:[jsxRuntime.jsx("div",{className:styles$4['calendar-filter_content_list_item'],children:item.name}),jsxRuntime.jsx("div",{onClick:function onClick(){return handleFilter('course',item.id);},className:styles$4['calendar-filter_content_item_eye'],children:(_filter$courseId=filter.courseId)!=null&&_filter$courseId.includes(item.id)?jsxRuntime.jsx(EyeIcon,{}):jsxRuntime.jsx(HiddenEyeIcon,{})})]},key);})})]})]});};var styles$3={"container":"_SpV6D","pointer-events-none":"_vFx-k","visible":"_fWGsO","fixed":"_lkhc1","absolute":"_PWRxf","relative":"_hdFra","!mx-3":"_fg0Yo","mx-1":"_cuR5n","my-4":"_y91IM","mb-5":"_q3M7c","mt-4":"_2YLeF","mt-6":"_4zan0","mt-auto":"_NP9--","block":"_2W2Ge","inline-block":"_s-WcM","inline":"_dVyLR","flex":"_ZGkMv","table":"_iKHPC","grid":"_uwvus","hidden":"_99KRX","h-4":"_OSSv8","h-5":"_0QuOn","h-full":"_nZUjq","w-5":"_hV-6m","w-full":"_S6Q0J","min-w-0":"_7W07D","max-w-[703px]":"_6a0zS","flex-1":"_sD8yp","transform":"_KMtsK","cursor-pointer":"_xcNdB","select-none":"_52U4H","resize":"_eE5fG","flex-col":"_kn8LZ","items-center":"_ZvSxl","justify-start":"_3VBtX","justify-between":"_lek3f","gap-2":"_nGZk7","gap-4":"_itL1n","gap-[6px]":"_QKLha","rounded-none":"_QgJGl","rounded-xl":"_7G56K","border":"_ZVmZ8","border-gray-4":"_XANCC","bg-button":"_ox58n","bg-info/10":"_c0hzA","bg-transparent":"_XyeTv","bg-white":"_nX8HF","p-4":"_evbYj","px-1":"_6af29","pt-2":"_c2Hfn","text-sm":"_mTbZi","text-xl":"_4tSr4","text-xs":"_Ok1KW","font-medium":"_Cllvq","font-normal":"_2H-kN","font-semibold":"_iQEpf","italic":"_VFRam","leading-7":"_pJW5A","!text-error":"_kT2oa","!text-errorDisable":"_ypvyT","!text-warning":"_0ldSj","!text-warningDisable":"_Rif-d","text-[#1F2937]":"_-q8op","text-[#FFB700]":"_ZJYz1","text-black":"_dUcyb","text-gray-600":"_lkgl-","text-info":"_HMq4g","text-secondary-text":"_rXm9M","text-success":"_v1TAm","text-white":"_aZrRY","underline":"_tNANI","outline":"_UCKhq","!filter":"_NUKtm","filter":"_RAZcZ","transition":"_thH8-","ease-in-out":"_PaiZq","sapp-calendar":"_HB3Er","btn":"_WCYuT","icon":"_hbyRC","btn-default":"_jotM7","btn-primary":"_GIETX","event-info":"_lymSr","event-warning":"_XvNcY","event-success":"_deveu","event-purple":"_Qz5Gv","event-error":"_sLbJe","event-errorDisable":"_6nIlk","event-infoDisable":"_6YGQm","event-default":"_0Arj8","event-inactive":"_FytCR","sapp-calendar__container":"_TXkIh","header-calendar":"_8Pu8y","header-calendar__nav":"_JXPCB","header-calendar__date-picker":"_Om36m","header-calendar__title":"_sDPwE","header-calendar__controls":"_ig6Rh","header-calendar__divider":"_xJ-E0","monthly-calendar":"_CY-hQ","weekly-calendar":"_oH4om","monthly-calendar__title":"_Cvu1k","monthly-calendar__title-active":"_Jnzib","weekly-norm__cell":"_fPnDK","weekly-norm__value":"_3ttLr","monthly-calendar__cell":"_zidk8","monthly-calendar__cell--active":"_Zl5UI","calendar-tooltip":"_4C7hb","monthly-event__title":"_9rwn2","monthly-event__date":"_8amdb","weekly-calendar__title":"_EBTvw","weekly-calendar__cell":"_tVELx","weekly-event":"_atT-z","event--min-height":"_KYw1V","weekly-event__content":"_qLto4","weekly-event__title":"_eFqOq","weekly-event__title--truncate":"_BVqse","weekly-event__date":"_8hA6L","weekly-event__date--truncate":"_WG35d","weekly-event--collapse":"_4xKZY","btn-lms-default":"_tEt7m","ant-select-dropdown":"_CM2VE","text-lms-primary":"_8BTl9","header-calendar_filter":"_LRIuw","ant-picker-calendar-header":"_FObax","ant-picker-calendar-mode-switch":"_Lhriu","hover-item":"_gDoWt","weekly-event__title_icon":"_7syad","monthly-event__date_tablet":"_xYovh","calendar-filter":"_8PBZv","see-more":"_uHdlB","weekly-calendar-lms__cell":"_g5aHI","truncate-text":"_aZyd4","md:max-w-full":"_pHS0x","md:text-sm":"_Blpar"};var Button$2=function Button(_ref){var _ref$type=_ref.type,type=_ref$type===void 0?'button':_ref$type,_ref$color=_ref.color,color=_ref$color===void 0?'default':_ref$color,onClick=_ref.onClick,children=_ref.children;return jsxRuntime.jsx("button",{type:type,onClick:onClick,className:styles$3.btn+" "+styles$3["btn-"+color],children:children});};var Icon$1=function Icon(_ref){var icon=_ref.icon,onClick=_ref.onClick,className=_ref.className;return jsxRuntime.jsx("div",{className:clsx.clsx(styles$3.icon,onClick&&styles$3['cursor-pointer'],className),onClick:onClick,children:icon});};var SelectBox$1=function SelectBox(_ref){var value=_ref.value,options=_ref.options,defaultValue=_ref.defaultValue,_ref$className=_ref.className,className=_ref$className===void 0?'':_ref$className,disabled=_ref.disabled,onChange=_ref.onChange;return jsxRuntime.jsx(antd.Select,{defaultValue:defaultValue,className:className,disabled:disabled,options:options,value:value,onChange:onChange});};var options=[{label:"Online",value:"ONLINE",color:"#1890ff"},{label:"Live Online",value:"LIVE_ONLINE",color:"#9254de"},{label:"Offline",value:"OFFLINE",color:"#52c41a"},{label:"Cancel",value:"CANCEL",color:"#ff4d4f"},{label:"Holiday",value:"HOLIDAY",color:"#fa8c16"},{label:"Manual Schedule",value:"MANUAL",color:""},{label:"Automatic Schedule",value:"AUTO",color:""}];var initialFilter={modes:[],arrange_types:[],is_cancel:undefined,show_holiday:undefined};var modeValues=["ONLINE","LIVE_ONLINE","OFFLINE"];var arrangeTypeValues=["AUTO","MANUAL"];var ScheduleFilter=function ScheduleFilter(_ref){var fetchGetSchedule=_ref.fetchGetSchedule,loading=_ref.loading;var _useState=React.useState(initialFilter),filter=_useState[0],setFilter=_useState[1];console.log(loading);var handleChange=function handleChange(value){setFilter(function(prev){if(modeValues.includes(value)){var modes=prev.modes.includes(value)?prev.modes.filter(function(v){return v!==value;}):[].concat(prev.modes,[value]);return _extends({},prev,{modes:modes});}if(arrangeTypeValues.includes(value)){var arrange_types=prev.arrange_types.includes(value)?prev.arrange_types.filter(function(v){return v!==value;}):[].concat(prev.arrange_types,[value]);return _extends({},prev,{arrange_types:arrange_types});}if(value==="CANCEL"){return _extends({},prev,{is_cancel:prev.is_cancel?undefined:true});}if(value==="HOLIDAY"){return _extends({},prev,{show_holiday:!prev.show_holiday});}return prev;});};var isChecked=function isChecked(value){if(modeValues.includes(value))return filter.modes.includes(value);if(arrangeTypeValues.includes(value))return filter.arrange_types.includes(value);if(value==="CANCEL")return filter.is_cancel===true;if(value==="HOLIDAY")return!!filter.show_holiday;return false;};var handleReset=function handleReset(){setFilter(initialFilter);fetchGetSchedule==null||fetchGetSchedule({});};var handleSearch=function handleSearch(){fetchGetSchedule==null||fetchGetSchedule(_extends({},filter));};return jsxRuntime.jsxs("div",{style:{display:"flex",flexDirection:"column",gap:8},children:[options.map(function(opt){return jsxRuntime.jsxs("label",{style:{display:"flex",alignItems:"center",gap:8,cursor:"pointer"},children:[jsxRuntime.jsx(antd.Checkbox,{checked:isChecked(opt.value),onChange:function onChange(){return handleChange(opt.value);}}),opt.color&&jsxRuntime.jsx("span",{style:{width:12,height:12,borderRadius:4,backgroundColor:opt.color,display:"inline-block"}}),jsxRuntime.jsx("span",{style:{fontSize:14,lineHeight:"22px",color:"#374151"},children:opt.label})]},opt.value);}),jsxRuntime.jsxs("div",{style:{display:"flex",justifyContent:"end",gap:12,marginTop:24},children:[jsxRuntime.jsx("div",{onClick:!loading?handleReset:undefined,style:{borderRadius:6,background:"#F9F9F9",fontSize:13,fontWeight:500,lineHeight:"14px",color:"#252F4A",padding:12,cursor:"pointer"},children:loading?jsxRuntime.jsx(antd.Spin,{size:"small"}):"Reset"}),jsxRuntime.jsx("div",{onClick:!loading?handleSearch:undefined,style:{borderRadius:6,background:"#FFB800",color:"white",fontSize:13,fontWeight:500,lineHeight:"14px",padding:12,cursor:"pointer"},children:loading?jsxRuntime.jsx(antd.Spin,{size:"small"}):"Search"})]})]});};var HeaderCalendar$1=function HeaderCalendar(_ref){var title=_ref.title,showTeacherName=_ref.showTeacherName,currentDate=_ref.currentDate,setCurrentDate=_ref.setCurrentDate,calendarMode=_ref.calendarMode,setCalendarMode=_ref.setCalendarMode,_ref$isFiltered=_ref.isFiltered,isFiltered=_ref$isFiltered===void 0?false:_ref$isFiltered,fetchGetSchedule=_ref.fetchGetSchedule,loading=_ref.loading;var handleChangeDate=function handleChangeDate(date){setCurrentDate(date);};var handleChangeMode=function handleChangeMode(mode){setCalendarMode(mode);setCurrentDate(currentDate.startOf('month'));};var _useState=React.useState(false),open=_useState[0],setOpen=_useState[1];return jsxRuntime.jsxs("div",{className:styles$3['header-calendar'],children:[jsxRuntime.jsxs("div",{className:styles$3['header-calendar__nav'],children:[jsxRuntime.jsx(Icon$1,{icon:jsxRuntime.jsx(Left$1,{}),onClick:function onClick(){return handleChangeDate(currentDate.subtract(1,calendarMode));}}),jsxRuntime.jsx(antd.DatePicker,{picker:calendarMode==='day'?'date':calendarMode,onChange:handleChangeDate,format:function format(value){return customDateFormat(value,'MMMM, YYYY');},value:currentDate,allowClear:false,suffixIcon:null,className:styles$3['header-calendar__date-picker'],size:'large'}),jsxRuntime.jsx(Icon$1,{icon:jsxRuntime.jsx(Right$1,{}),onClick:function onClick(){return handleChangeDate(currentDate.add(1,calendarMode));}})]}),showTeacherName&&jsxRuntime.jsx("div",{className:styles$3['header-calendar__title'],children:title}),jsxRuntime.jsxs("div",{className:styles$3['header-calendar__controls'],children:[jsxRuntime.jsx(antd.Popover,{open:open,onOpenChange:setOpen,className:'sapp-popover',trigger:"click",style:{padding:8,borderRadius:'6px',background:open?"#FFB800":"#F9F9F9",cursor:'pointer'},content:jsxRuntime.jsx(ScheduleFilter,{fetchGetSchedule:fetchGetSchedule,loading:loading}),title:'Sort Filter',arrow:false,placement:'bottomRight',children:jsxRuntime.jsx("div",{style:{padding:8,borderRadius:'6px',background:open?"#FFB800":"#F9F9F9",cursor:'pointer'},children:jsxRuntime.jsx(IconFilter,{open:open})})}),jsxRuntime.jsx(Button$2,{onClick:function onClick(){return handleChangeDate(dayjs__default["default"]());},children:"Today"}),jsxRuntime.jsx("div",{className:styles$3['header-calendar__divider']}),isFiltered?jsxRuntime.jsx(SelectBox$1,{value:calendarMode,options:[// {
//   value: 'today',
//   label: 'Today'
// },
{value:'month',label:'Month'},{value:'week',label:'Week'}],className:'select-mode',onChange:function onChange(mode){return handleChangeMode(mode);}}):jsxRuntime.jsxs(React__default["default"].Fragment,{children:[jsxRuntime.jsx(Button$2,{color:calendarMode==='month'?'primary':'default',onClick:function onClick(){return handleChangeMode('month');},children:"Month"}),jsxRuntime.jsx(Button$2,{color:calendarMode==='week'?'primary':'default',onClick:function onClick(){return handleChangeMode('week');},children:"Week"})]})]})]});};var LMSHeaderCalendar$1=function LMSHeaderCalendar(_ref){var title=_ref.title,showTeacherName=_ref.showTeacherName,currentDate=_ref.currentDate,setCurrentDate=_ref.setCurrentDate,calendarMode=_ref.calendarMode,setCalendarMode=_ref.setCalendarMode,toggleTurnOnFilter=_ref.toggleTurnOnFilter,filter=_ref.filter,hasFilter=_ref.hasFilter;var options=[{value:'month',label:'Month'},{value:'week',label:'Week'}];var handleChangeDate=function handleChangeDate(date){setCurrentDate(date);};var handleChangeMode=function handleChangeMode(mode){setCalendarMode(mode);setCurrentDate(dayjs__default["default"]());};return jsxRuntime.jsxs("div",{className:styles$3['header-calendar'],children:[jsxRuntime.jsxs("div",{className:styles$3['header-calendar_filter'],children:[hasFilter&&jsxRuntime.jsx("div",{className:clsx__default["default"](styles$3['hover-item'],filter.isOpen&&styles$3['text-lms-primary']),onClick:toggleTurnOnFilter,children:jsxRuntime.jsx(FilterIcon$1,{})}),jsxRuntime.jsxs("div",{className:""+styles$3['header-calendar__nav'],children:[jsxRuntime.jsx(Icon$1,{icon:jsxRuntime.jsx(LeftArrowIcon$1,{}),onClick:function onClick(){return handleChangeDate(currentDate.subtract(1,calendarMode));},className:styles$3['rounded-none']}),jsxRuntime.jsx(antd.DatePicker,{picker:calendarMode==='day'?'date':calendarMode,onChange:handleChangeDate,format:function format(value){return customDateFormat(value,calendarMode==='day'?FORMAT_DATE_CARLENDA.DATE:FORMAT_DATE_CARLENDA.MONTH_AND_WEEK);},value:currentDate,allowClear:false,suffixIcon:null,className:styles$3['header-calendar__date-picker'],size:'large'}),jsxRuntime.jsx(Icon$1,{icon:jsxRuntime.jsx(RightArrowIcon$1,{}),onClick:function onClick(){return handleChangeDate(currentDate.add(1,calendarMode));}})]})]}),showTeacherName&&jsxRuntime.jsx("div",{className:styles$3['header-calendar__title'],children:title}),jsxRuntime.jsxs("div",{className:styles$3['header-calendar__controls'],children:[jsxRuntime.jsx(Button$2,{color:'lms-default',onClick:function onClick(){return handleChangeDate(dayjs__default["default"]());},children:"Today"}),jsxRuntime.jsx("div",{className:styles$3['header-calendar__divider']}),jsxRuntime.jsx(SelectBox$1,{value:calendarMode,options:options,className:'select-mode',onChange:function onChange(mode){handleChangeMode(mode);}})]})]});};var CustomTooltip$1=function CustomTooltip(_ref){var title=_ref.title,children=_ref.children,_ref$placement=_ref.placement,placement=_ref$placement===void 0?'top':_ref$placement;return jsxRuntime.jsx(antd.Tooltip,{color:'#ffffff',title:jsxRuntime.jsx("div",{className:styles$3['text-gray-600'],children:title}),placement:placement,children:jsxRuntime.jsx("div",{children:children})});};var calculateBoxSize$2=function calculateBoxSize(startTime,endTime,isAllDay){if(isAllDay){return{top:10,height:MIN_HEIGHT_HIDE_DETAIL};}var minutes=dayjs__default["default"](startTime).minute();var diffMinutes=dayjs__default["default"](endTime).diff(startTime,'minute',true);var border=Math.floor((minutes+diffMinutes)/MINUTES_PER_HOUR*BORDER_WEEKLY_CELL);return{top:minutes,height:diffMinutes+border};};var WeeklyEvent$1=function WeeklyEvent(_ref){var event=_ref.event,onOpenDetail=_ref.onOpenDetail,onEventDetail=_ref.onEventDetail,zIndex=_ref.zIndex;var contentRef=React.useRef(null);var _useState=React.useState(false),shouldTruncateTitle=_useState[0],setShouldTruncateTitle=_useState[1];var _useState2=React.useState(false),shouldTruncateContent=_useState2[0],setShouldTruncateContent=_useState2[1];var _calculateBoxSize=calculateBoxSize$2(event.startDate,event.endDate,event.isAllDay),top=_calculateBoxSize.top,height=_calculateBoxSize.height;React.useEffect(function(){if(contentRef.current){var actualHeight=contentRef.current.offsetHeight;var padding=12*2;// 12px top and bottom padding
var needsTruncation=actualHeight+padding>height;if(needsTruncation){setShouldTruncateTitle(true);if(!shouldTruncateTitle){return;}setShouldTruncateContent(true);}}},[height,shouldTruncateTitle]);var isMinHeight=height<MIN_HEIGHT_EVENT;var formattedDate=customDateFormat(event.startDate,TIME_FORMAT)+' - '+customDateFormat(event.endDate,TIME_FORMAT);var iconList=getIconforEvent$1(event,event.isActive);var typeClass=event.isActive?convertType[event.type]||'default':convertTypeDisable[event.type]||'default';var className=event!=null&&event.isOverDue?"event-error":"event-"+typeClass;return jsxRuntime.jsx("div",{className:clsx__default["default"](styles$3[className]),onClick:function onClick(){onOpenDetail&&onOpenDetail(dayjs__default["default"](event.startDate).toDate(),[event]);onEventDetail&&onEventDetail(event);},style:{top:top+"px",height:Math.max(height,MIN_HEIGHT_EVENT)+"px",zIndex:zIndex},children:jsxRuntime.jsxs("div",{className:clsx__default["default"](styles$3['weekly-event'],isMinHeight&&styles$3['event--min-height']),children:[isDisplayIcon(event)&&jsxRuntime.jsx("div",{className:styles$3['weekly-event__title_icon'],children:iconList}),jsxRuntime.jsxs("div",{ref:contentRef,className:clsx__default["default"](styles$3['weekly-event__content'],height<MIN_HEIGHT_HIDE_DETAIL&&styles$3['weekly-event--collapse']),children:[jsxRuntime.jsx("div",{className:clsx__default["default"](styles$3['weekly-event__title'],shouldTruncateTitle&&styles$3['weekly-event__title--truncate']),children:jsxRuntime.jsx(CustomTooltip$1,{title:event.title,children:event.title})}),jsxRuntime.jsx("div",{className:clsx__default["default"](styles$3['weekly-event__date'],shouldTruncateContent&&styles$3['weekly-event__date--truncate']),children:jsxRuntime.jsx(CustomTooltip$1,{title:formattedDate,children:formattedDate})})]})]})});};var WeeklyCell$1=function WeeklyCell(_ref){var events=_ref.events,date=_ref.date,onOpenDetail=_ref.onOpenDetail,onOpenCreate=_ref.onOpenCreate,onEventDetail=_ref.onEventDetail;var isToday=dayjs__default["default"]().isSame(date,'day');var handleOpenCreateModal=function handleOpenCreateModal(e){if(e.target!==e.currentTarget)return;onOpenCreate&&onOpenCreate(dayjs__default["default"](date).toDate());};events.sort(function(a,b){return a.type===EVENT_TYPES.BUSY&&b.type!==EVENT_TYPES.BUSY?1:-1;});var renderWeeklyEvent=React.useMemo(function(){var isAllDay=events.some(function(item){return item.isAllDay;});if(isAllDay&&events.length>1){return jsxRuntime.jsxs(React__default["default"].Fragment,{children:[jsxRuntime.jsx(WeeklyEvent$1,{event:events[0],onOpenDetail:onOpenDetail,onEventDetail:onEventDetail,zIndex:1}),jsxRuntime.jsx("div",{className:styles$3['see-more'],children:jsxRuntime.jsxs(CustomTooltip$1,{placement:'bottom',title:jsxRuntime.jsx("div",{className:styles$3['calendar-tooltip'],children:events.slice(1,events.length).map(function(event,index){return jsxRuntime.jsx(WeeklyEvent$1,{event:event,onOpenDetail:onOpenDetail,onEventDetail:onEventDetail,zIndex:index+1},index+1);})}),children:["+",Math.max(events.length-1,0)," More"]})})]});}return events.map(function(event,index){return jsxRuntime.jsx(WeeklyEvent$1,{event:event,onOpenDetail:onOpenDetail,onEventDetail:onEventDetail,zIndex:index+1},index);});},[events]);return jsxRuntime.jsx("div",{className:styles$3['weekly-calendar__cell']+" "+(isToday?styles$3['bg-info/10']:styles$3['bg-white']),onClick:handleOpenCreateModal,children:renderWeeklyEvent});};dayjs__default["default"].extend(isBetween__default["default"]);var getEventAllDay$1=function getEventAllDay(events,targetDate){return daysOfWeekKeys.reduce(function(acc,day,index){var currentDate=targetDate.add(index,'day');acc[day]={events:events.reduce(function(filteredEvents,event){if(dayjs__default["default"](event.startDate).isSame(currentDate.startOf('day'))&&checkIsAllday(dayjs__default["default"](event.startDate),dayjs__default["default"](event.endDate))){filteredEvents.push(_extends({},event,{isAllDay:true}));}return filteredEvents;},[]),date:currentDate};return acc;},{});};var getEventsOfDay$1=function getEventsOfDay(events,targetHour){return daysOfWeekKeys.reduce(function(acc,day,index){var currentDate=targetHour.add(index,'day');acc[day]={events:events.filter(function(event){return dayjs__default["default"](event.startDate).isSame(currentDate,'hour')&&!checkIsAllday(dayjs__default["default"](event.startDate),dayjs__default["default"](event.endDate));}),date:currentDate};return acc;},{});};var WeeklyCalendar$1=function WeeklyCalendar(_ref){var startDate=_ref.startDate,endDate=_ref.endDate,events=_ref.events,norms=_ref.norms,showWeeklyNorm=_ref.showWeeklyNorm,onOpenDetail=_ref.onOpenDetail,onOpenCreate=_ref.onOpenCreate,onEventDetail=_ref.onEventDetail,loading=_ref.loading,type=_ref.type;var getTableColumns=function getTableColumns(){var _calculateNormOfWeek=calculateNormOfWeek(norms,events,startDate,endDate),normOfWeek=_calculateNormOfWeek.normOfWeek,totalNorm=_calculateNormOfWeek.totalNorm,status=_calculateNormOfWeek.status;var hourColumn={title:jsxRuntime.jsx("div",{className:styles$3['weekly-calendar__title'],children:showWeeklyNorm&&jsxRuntime.jsxs(React__default["default"].Fragment,{children:[jsxRuntime.jsx("div",{children:"Weekly Norm"}),jsxRuntime.jsx("div",{className:clsx__default["default"](styles$3['weekly-norm__value'],normOfWeek>totalNorm&&status===STATUS_NORM.APPROVED?styles$3['!text-error']:normOfWeek>totalNorm&&status===STATUS_NORM.PENDING?styles$3['!text-errorDisable']:normOfWeek<totalNorm&&status===STATUS_NORM.APPROVED?styles$3['!text-warning']:styles$3['!text-warningDisable']),children:normOfWeek+"/"+totalNorm}),' ',status===STATUS_NORM.PENDING&&jsxRuntime.jsx("div",{className:clsx__default["default"](styles$3['weekly-norm__value'],normOfWeek>totalNorm&&styles$3['!text-error']),children:"Expected"})]})}),dataIndex:'hour',key:'hour',width:'100px',render:function render(value){return jsxRuntime.jsx("div",{children:value});}};var dayColumns=Object.values(DAYS_OF_WEEK).map(function(day,index){return{title:jsxRuntime.jsxs("div",{className:styles$3['weekly-calendar__title'],children:[jsxRuntime.jsx("div",{children:day.slice(0,3)}),jsxRuntime.jsx("div",{children:dayjs__default["default"](startDate).add(index,'day').format('DD/MM')})]}),dataIndex:day,key:day,width:'calc((100% - 100px) / 7)',render:function render(value){return jsxRuntime.jsx(WeeklyCell$1,{events:value.events,date:value.date,onOpenDetail:onOpenDetail,onOpenCreate:onOpenCreate,onEventDetail:onEventDetail},index);}};});return[hourColumn].concat(dayColumns);};var getTableData=function getTableData(){var data=[];// All day
data.push(_extends({id:-1,hour:'All day'},getEventAllDay$1(events,startDate)));var count=type===CALENDAR_TYPE.LMS?7:0;// Hour
for(var i=count;i<HOURS_PER_DAY;i++){var targetHour=dayjs__default["default"](startDate).add(i,'hour');data.push(_extends({id:i,hour:targetHour.format('HH:mm')},getEventsOfDay$1(events,targetHour)));}return data;};return jsxRuntime.jsx(antd.Table,{rowKey:function rowKey(record){return record.id;},columns:getTableColumns(),dataSource:getTableData(),pagination:false,rowHoverable:false,className:styles$3['weekly-calendar'],loading:loading,tableLayout:'fixed'});};var calculateBoxSize$1=function calculateBoxSize(startTime,endTime){var minutes=dayjs__default["default"](startTime).minute();var diffMinutes=dayjs__default["default"](endTime).diff(startTime,'hour',true);return{width:diffMinutes||1,left:Math.floor(minutes/MINUTES_PER_HOUR*100)};};var LMSWeeklyEvent=function LMSWeeklyEvent(_ref){var event=_ref.event,onOpenDetail=_ref.onOpenDetail,onEventDetail=_ref.onEventDetail;var formattedDate=customDateFormat(event.startDate,TIME_FORMAT)+' - '+customDateFormat(event.endDate,TIME_FORMAT);var _calculateBoxSize=calculateBoxSize$1(event.startDate,event.endDate),width=_calculateBoxSize.width,left=_calculateBoxSize.left;var iconList=getIconforEvent$1(event,event.isActive);var typeClass=event.isActive?convertType[event.type]||'default':convertTypeDisable[event.type]||'default';var className=event!=null&&event.isOverDue?"event-error":"event-"+typeClass;return jsxRuntime.jsx("div",{className:styles$3[className],onClick:function onClick(){onOpenDetail&&onOpenDetail(dayjs__default["default"](event.startDate).toDate(),[event]);onEventDetail&&onEventDetail(event);},style:{top:"0%",height:"100%",width:width*100+'%',left:left+'%',zIndex:event.type===EVENT_TYPES.BUSY?2:1},children:jsxRuntime.jsxs("div",{className:clsx__default["default"](styles$3['weekly-event']),children:[jsxRuntime.jsx("div",{className:clsx__default["default"](styles$3['weekly-event--collapse']),children:jsxRuntime.jsxs("div",{className:styles$3['weekly-event__title'],children:[isDisplayIcon(event)&&jsxRuntime.jsx("div",{className:styles$3['weekly-event__title_icon'],children:iconList}),jsxRuntime.jsx(CustomTooltip$1,{title:event.title,children:jsxRuntime.jsx("div",{className:styles$3['truncate-text'],children:event.title})})]})}),jsxRuntime.jsx("div",{className:styles$3['weekly-event__date'],children:jsxRuntime.jsx(CustomTooltip$1,{title:formattedDate,children:formattedDate})})]})});};var LMSWeeklyCell=function LMSWeeklyCell(_ref){var _events;var events=_ref.events,date=_ref.date,onOpenDetail=_ref.onOpenDetail,onOpenCreate=_ref.onOpenCreate,onEventDetail=_ref.onEventDetail;var isToday=dayjs__default["default"]().isSame(date,'day');var handleOpenCreateModal=function handleOpenCreateModal(e){if(e.target!==e.currentTarget)return;onOpenCreate&&onOpenCreate(dayjs__default["default"](date).toDate());};events=(_events=events)==null?void 0:_events.sort(function(a,b){return a.type===EVENT_TYPES.BUSY&&b.type!==EVENT_TYPES.BUSY?1:-1;});var renderWeeklyEvent=React.useMemo(function(){var _events2,_events3,_events4;var isAllDay=(_events2=events)==null?void 0:_events2.some(function(item){return item.isAllDay;});if(isAllDay&&((_events3=events)==null?void 0:_events3.length)>1){return jsxRuntime.jsxs(React__default["default"].Fragment,{children:[jsxRuntime.jsx(LMSWeeklyEvent,{event:events[0],onOpenDetail:onOpenDetail,onEventDetail:onEventDetail}),jsxRuntime.jsx("div",{className:styles$3['see-more'],children:jsxRuntime.jsxs(CustomTooltip$1,{placement:'bottom',title:jsxRuntime.jsx("div",{className:styles$3['calendar-tooltip'],children:events.slice(1,events.length).map(function(event,index){return jsxRuntime.jsx(LMSWeeklyEvent,{event:event,onOpenDetail:onOpenDetail,onEventDetail:onEventDetail},index+1);})}),children:["+",Math.max(events.length-1,0)," More"]})})]});}return(_events4=events)==null?void 0:_events4.map(function(event,index){return jsxRuntime.jsx(LMSWeeklyEvent,{event:event,onOpenDetail:onOpenDetail,onEventDetail:onEventDetail},index);});},[events]);return jsxRuntime.jsx("div",{className:styles$3['weekly-calendar__cell']+" "+styles$3['weekly-calendar-lms__cell']+"  "+(isToday?styles$3['bg-info/10']:styles$3['bg-white']),onClick:handleOpenCreateModal,children:renderWeeklyEvent});};dayjs__default["default"].extend(isBetween__default["default"]);var LMSWeeklyCalendar=function LMSWeeklyCalendar(_ref){var startDate=_ref.startDate,events=_ref.events,onOpenDetail=_ref.onOpenDetail,onOpenCreate=_ref.onOpenCreate,onEventDetail=_ref.onEventDetail,loading=_ref.loading;var getEventsOfHour=function getEventsOfHour(events,targetHour){return hoursOfDayKeys.reduce(function(acc,hour){acc[hour]={events:events.filter(function(event){return dayjs__default["default"](event.startDate).isSame(dayjs__default["default"](targetHour.format('YYYY-MM-DD')+"T"+hour+":00"),'hour')&&!checkIsAllday(dayjs__default["default"](event.startDate),dayjs__default["default"](event.endDate));}),date:dayjs__default["default"](targetHour.format('YYYY-MM-DD')+"T"+hour)};return acc;},{});};var getTableColumns=function getTableColumns(){var hourColumn={title:jsxRuntime.jsx("div",{className:styles$3['weekly-calendar__title']}),dataIndex:'hour',key:'hour',width:1,render:function render(value){return jsxRuntime.jsx("div",{children:value});}};var hours=Array.from({length:17},function(_,i){return 7+i;});var timeColums=hours.map(function(time,index){return{title:jsxRuntime.jsx("div",{className:styles$3['weekly-calendar__title'],children:time%2!==0?jsxRuntime.jsx("div",{style:{textAlign:'start'},children:time<10?'0'+time+':00':time+':00'}):jsxRuntime.jsx("div",{style:{minWidth:'35px'}})}),dataIndex:""+(time<10?'0'+time+':00':time+':00'),key:""+(time<10?'0'+time+':00':time+':00'),render:function render(value){return jsxRuntime.jsx(LMSWeeklyCell,{events:value==null?void 0:value.events,date:value==null?void 0:value.date,onOpenDetail:onOpenDetail,onOpenCreate:onOpenCreate,onEventDetail:onEventDetail},index);}};});return[hourColumn].concat(timeColums);};var getTableData=function getTableData(){var data=[];for(var i=0;i<7;i++){var targetHour=dayjs__default["default"](startDate).add(i+1,'day');data.push(_extends({id:i,hour:jsxRuntime.jsxs("div",{children:[jsxRuntime.jsx("div",{className:styles$3['lms-calendar__tablet'],children:Object.values(DAYS_OF_WEEK_SHORTEN)[i]}),jsxRuntime.jsx("div",{className:styles$3['lms-calendar__tablet'],children:dayjs__default["default"](startDate).add(i,'day').format('DD')})]})},getEventsOfHour(events,targetHour)));}return data;};return jsxRuntime.jsx(antd.Table,{rowKey:function rowKey(record){return record.id;},columns:getTableColumns(),dataSource:getTableData(),pagination:false,rowHoverable:false,className:styles$3['weekly-calendar'],loading:loading});};function LMSModeWeeklyCalendar$1(_ref){var startDate=_ref.startDate,endDate=_ref.endDate,events=_ref.events,norms=_ref.norms,_ref$showWeeklyNorm=_ref.showWeeklyNorm,showWeeklyNorm=_ref$showWeeklyNorm===void 0?false:_ref$showWeeklyNorm,onOpenDetail=_ref.onOpenDetail,onOpenCreate=_ref.onOpenCreate,onEventDetail=_ref.onEventDetail,loading=_ref.loading;var _useState=React.useState(window.innerWidth),windowWidth=_useState[0],setWindowWidth=_useState[1];React.useEffect(function(){var handleResize=function handleResize(){setWindowWidth(window.innerWidth);};window.addEventListener('resize',handleResize);return function(){window.removeEventListener('resize',handleResize);};},[]);return jsxRuntime.jsx(React__default["default"].Fragment,{children:windowWidth>1024?jsxRuntime.jsx(WeeklyCalendar$1,{startDate:startDate,endDate:endDate,events:events,norms:norms,showWeeklyNorm:showWeeklyNorm,onOpenDetail:onOpenDetail,onOpenCreate:onOpenCreate,onEventDetail:onEventDetail,loading:loading,type:CALENDAR_TYPE.LMS}):jsxRuntime.jsx(LMSWeeklyCalendar,{startDate:startDate,endDate:endDate,events:events,norms:norms,onOpenDetail:onOpenDetail,onOpenCreate:onOpenCreate,onEventDetail:onEventDetail,loading:loading,type:CALENDAR_TYPE.LMS})});}var MonthlyEvent$1=function MonthlyEvent(_ref){var event=_ref.event,isSameMonth=_ref.isSameMonth,onEventDetail=_ref.onEventDetail;var formateTimeSchudule=event.type==='INACTIVE'?'D/M/YYYY':TIME_FORMAT;var formattedDate=customDateFormat(event.startDate,formateTimeSchudule)+' - '+customDateFormat(event.endDate,formateTimeSchudule);var formattedDateStart=customDateFormat(event.startDate,TIME_FORMAT);var iconList=getIconforEvent$1(event,event.isActive);var typeClass=event.isActive!==undefined?event.isActive===true?convertType[event.type]||'default':convertTypeDisable[event.type]||'default':convertType[event.type]||'default';var className=event!=null&&event.isOverDue?"event-error":isSameMonth?"event-"+typeClass:'event-default';return jsxRuntime.jsx(React__default["default"].Fragment,{children:jsxRuntime.jsxs("li",{className:styles$3[className],style:{cursor:'pointer'},onClick:function onClick(){return onEventDetail&&onEventDetail(event);},children:[jsxRuntime.jsxs("div",{className:styles$3['monthly-event__title'],children:[isDisplayIcon(event)&&jsxRuntime.jsx("div",{className:styles$3['weekly-event__title_icon'],children:iconList}),jsxRuntime.jsx(CustomTooltip$1,{title:event.title,children:jsxRuntime.jsx("div",{className:styles$3['truncate-text'],children:event.title})})]}),jsxRuntime.jsx("div",{className:styles$3['monthly-event__date'],children:jsxRuntime.jsx(CustomTooltip$1,{title:formattedDate,children:formattedDate})}),jsxRuntime.jsxs("div",{className:styles$3['monthly-event__date_tablet'],children:[iconList,jsxRuntime.jsx(CustomTooltip$1,{title:formattedDate,children:formattedDateStart})]})]})});};var MonthlyCell$1=function MonthlyCell(_ref){var currentDate=_ref.currentDate,events=_ref.events,date=_ref.date,onOpenDetail=_ref.onOpenDetail,onOpenCreate=_ref.onOpenCreate,onEventDetail=_ref.onEventDetail;var hasMore=events.length>2;var isSameMonth=currentDate.isSame(date,'month');var isToday=dayjs__default["default"]().isSame(date,'day');var handleOpenCreateModal=function handleOpenCreateModal(e){if(e.target!==e.currentTarget)return;onOpenCreate&&onOpenCreate(dayjs__default["default"](date).hour(dayjs__default["default"]().hour()).minute(dayjs__default["default"]().minute()).toDate());};return jsxRuntime.jsxs("div",{className:styles$3['monthly-calendar__cell']+" "+(isToday?styles$3['monthly-calendar__cell--active']:styles$3['border-gray-4'])+" "+(isSameMonth?styles$3['bg-white']:styles$3['bg-button']),onClick:handleOpenCreateModal,children:[jsxRuntime.jsx("div",{className:isSameMonth?styles$3['text-black']:styles$3['text-secondary-text'],children:date.format('DD')}),jsxRuntime.jsxs("ul",{onClick:function onClick(){return onOpenDetail&&onOpenDetail(date.toDate(),events);},children:[events.slice(0,2).map(function(event,index){return jsxRuntime.jsx(MonthlyEvent$1,{event:event,isSameMonth:isSameMonth,onEventDetail:onEventDetail},index);}),hasMore&&jsxRuntime.jsx(CustomTooltip$1,{placement:'bottom',title:jsxRuntime.jsx("div",{className:styles$3['calendar-tooltip'],children:events.slice(2,events.length).map(function(event,index){return jsxRuntime.jsx(MonthlyEvent$1,{event:event,isSameMonth:isSameMonth,onEventDetail:onEventDetail},index);})}),children:jsxRuntime.jsxs("div",{className:isSameMonth?styles$3['text-info']:styles$3['text-secondary-text'],children:["+",Math.max(events.length-2,0)," More"]})})]})]});};var getEventsOfWeek$1=function getEventsOfWeek(events,targetDate){return daysOfWeekKeys.reduce(function(acc,day,index){var currentDate=targetDate.add(index,'day');acc[day]={events:events.filter(function(event){return dayjs__default["default"](event.startDate).isSame(currentDate,'date');}),date:currentDate};return acc;},{});};var getCalendarBoundaries$1=function getCalendarBoundaries(currentDate){var rawStart=currentDate.startOf('month');var rawEnd=currentDate.endOf('month');// Đảm bảo tuần bắt đầu từ thứ Hai
var startDate=rawStart.day()===0?rawStart.subtract(6,'day')// Chủ nhật -> lùi 6 ngày về thứ 2
:rawStart.subtract(rawStart.day()-1,'day');// Các ngày khác -> lùi về thứ 2
// Đảm bảo tuần kết thúc đến hết Chủ nhật
var endDate=rawEnd.day()===0?rawEnd:rawEnd.add(7-rawEnd.day(),'day');// Tiến tới Chủ nhật gần nhất
return{startDate:startDate,endDate:endDate};};var MonthlyCalendar$1=function MonthlyCalendar(_ref){var currentDate=_ref.currentDate,events=_ref.events,norms=_ref.norms,showWeeklyNorm=_ref.showWeeklyNorm,onOpenDetail=_ref.onOpenDetail,onOpenCreate=_ref.onOpenCreate,onEventDetail=_ref.onEventDetail,loading=_ref.loading;var getTableColumns=function getTableColumns(){var weeklyNormColumn={title:jsxRuntime.jsx("div",{className:styles$3['monthly-calendar__title']+" "+styles$3['monthly-calendar__title-active'],children:"Weekly Norm"}),dataIndex:'norm',key:'norm',width:'100px',render:function render(value){var normOfWeek=value.normOfWeek,totalNorm=value.totalNorm,status=value.status;return jsxRuntime.jsxs("div",{className:styles$3['weekly-norm__cell'],children:[jsxRuntime.jsx("div",{className:clsx__default["default"](styles$3['weekly-norm__value'],normOfWeek>totalNorm&&status===STATUS_NORM.APPROVED?styles$3['!text-error']:normOfWeek>totalNorm&&status===STATUS_NORM.PENDING?styles$3['!text-errorDisable']:normOfWeek<totalNorm&&status===STATUS_NORM.APPROVED?styles$3['!text-warning']:styles$3['!text-warningDisable']),children:normOfWeek+"/"+totalNorm}),status===STATUS_NORM.PENDING&&jsxRuntime.jsx("div",{className:clsx__default["default"](styles$3['weekly-norm__value'],normOfWeek>totalNorm&&styles$3['!text-error']),children:"Expected"})]});}};var dayColumns=Object.values(DAYS_OF_WEEK).map(function(day,index){return{title:jsxRuntime.jsx("div",{className:styles$3['monthly-calendar__title'],children:day.slice(0,3)}),dataIndex:day,key:day,width:'calc((100% - 100px) / 7)',render:function render(value){return jsxRuntime.jsx(MonthlyCell$1,{events:value.events,date:value.date,currentDate:currentDate,onOpenDetail:onOpenDetail,onOpenCreate:onOpenCreate,onEventDetail:onEventDetail},index);}};});return showWeeklyNorm?[weeklyNormColumn].concat(dayColumns):dayColumns;};var getWeeksOfFullMonth=function getWeeksOfFullMonth(startDate,endDate){var weeks=[];var targetDate=startDate.clone();while(targetDate.isBefore(endDate)||targetDate.isSame(endDate,'day')){weeks.push(targetDate);targetDate=targetDate.add(1,'week');}return weeks;};var getTableData=function getTableData(){var _getCalendarBoundarie=getCalendarBoundaries$1(currentDate),startDate=_getCalendarBoundarie.startDate,endDate=_getCalendarBoundarie.endDate;var weeks=getWeeksOfFullMonth(startDate,endDate);var data=weeks.map(function(week,index){var eventsOfWeek=getEventsOfWeek$1(events,week);if(!showWeeklyNorm){return _extends({id:index},eventsOfWeek);}return _extends({id:index,norm:calculateNormOfWeek(norms,events,week,week.endOf('week'))},eventsOfWeek);});return data;};return jsxRuntime.jsx(antd.Table,{rowKey:function rowKey(record){return record.id;},columns:getTableColumns(),dataSource:getTableData(),pagination:false,rowHoverable:false,className:styles$3['monthly-calendar'],loading:loading,tableLayout:'fixed'});};dayjs__default["default"].extend(updateLocale__default["default"]);dayjs__default["default"].updateLocale('en',{weekStart:1});var SAPPCalendar$1=function SAPPCalendar(_ref){var teacherName=_ref.teacherName,events=_ref.events,_ref$norms=_ref.norms,norms=_ref$norms===void 0?[]:_ref$norms,_ref$showTeacherName=_ref.showTeacherName,showTeacherName=_ref$showTeacherName===void 0?true:_ref$showTeacherName,_ref$showWeeklyNorm=_ref.showWeeklyNorm,showWeeklyNorm=_ref$showWeeklyNorm===void 0?true:_ref$showWeeklyNorm,onOpenDetail=_ref.onOpenDetail,onOpenCreate=_ref.onOpenCreate,onRefetchAPI=_ref.onRefetchAPI,onEventDetail=_ref.onEventDetail,loading=_ref.loading,_ref$type=_ref.type,type=_ref$type===void 0?'OPS':_ref$type,courses=_ref.courses,onfilter=_ref.onfilter,_ref$hasFilter=_ref.hasFilter,hasFilter=_ref$hasFilter===void 0?false:_ref$hasFilter,_ref$headerType=_ref.headerType,headerType=_ref$headerType===void 0?CALENDAR_TYPE.OPS:_ref$headerType,_ref$isFiltered=_ref.isFiltered,isFiltered=_ref$isFiltered===void 0?false:_ref$isFiltered,fetchGetSchedule=_ref.fetchGetSchedule;var _useState=React.useState(dayjs__default["default"]()),currentDate=_useState[0],setCurrentDate=_useState[1];var _useState2=React.useState('month'),calendarMode=_useState2[0],setCalendarMode=_useState2[1];var _useState3=React.useState({courseId:courses?courses.map(function(item){return item.id;}):[],isOpen:false,type:Object.values(LEARNING_MODE),day:''}),filter=_useState3[0],setFilter=_useState3[1];var startDate=React.useMemo(function(){return currentDate.startOf(calendarMode).startOf('week');},[currentDate,calendarMode]);var endDate=React.useMemo(function(){return currentDate.endOf(calendarMode).endOf('week');},[currentDate,calendarMode]);var splittedEvents=splitEventsIntoDays(events);splittedEvents.sort(function(a,b){return dayjs__default["default"](a.startDate).diff(b.startDate);});var handleFilterDate=function handleFilterDate(date){setCurrentDate(date);};React.useEffect(function(){onfilter&&onfilter(filter);},[filter]);useEffectAfterMounted(function(){onRefetchAPI(startDate.toDate(),endDate.toDate());},[startDate,endDate]);React.useEffect(function(){setFilter(function(prev){return _extends({},prev,{courseId:courses?courses.map(function(item){return item.id;}):[]});});},[courses]);return jsxRuntime.jsxs("div",{className:styles$3['sapp-calendar'],children:[filter.isOpen&&jsxRuntime.jsx(FilterCalendar$1,{filter:filter,courses:courses,setFilter:setFilter,onRefetchAPI:function onRefetchAPI(date){return handleFilterDate(dayjs__default["default"](date));}}),jsxRuntime.jsxs("div",{className:styles$3['sapp-calendar__container'],children:[headerType===CALENDAR_TYPE.LMS?jsxRuntime.jsx(LMSHeaderCalendar$1,{title:teacherName,showTeacherName:showTeacherName,currentDate:currentDate,setCurrentDate:setCurrentDate,calendarMode:calendarMode,setCalendarMode:setCalendarMode,toggleTurnOnFilter:function toggleTurnOnFilter(){return setFilter(function(prev){return _extends({},prev,{isOpen:!filter.isOpen});});},hasFilter:hasFilter,filter:filter}):jsxRuntime.jsx(HeaderCalendar$1,{title:teacherName,showTeacherName:showTeacherName,currentDate:currentDate,setCurrentDate:setCurrentDate,calendarMode:calendarMode,setCalendarMode:setCalendarMode,isFiltered:isFiltered,fetchGetSchedule:fetchGetSchedule,loading:loading}),headerType===CALENDAR_TYPE.OPS&&jsxRuntime.jsx(CalendarLegend$1,{}),calendarMode==='month'&&jsxRuntime.jsx(MonthlyCalendar$1,{currentDate:currentDate,startDate:startDate,endDate:endDate,events:splittedEvents,norms:norms,showWeeklyNorm:showWeeklyNorm,onOpenDetail:onOpenDetail,onOpenCreate:onOpenCreate,onEventDetail:onEventDetail,loading:loading}),calendarMode==='week'&&type===CALENDAR_TYPE.LMS&&jsxRuntime.jsx(LMSModeWeeklyCalendar$1,{startDate:startDate,endDate:endDate,events:splittedEvents,norms:norms,showWeeklyNorm:showWeeklyNorm,onOpenDetail:onOpenDetail,onOpenCreate:onOpenCreate,onEventDetail:onEventDetail,loading:loading}),calendarMode==='week'&&type===CALENDAR_TYPE.OPS&&jsxRuntime.jsx(WeeklyCalendar$1,{startDate:startDate,endDate:endDate,events:splittedEvents,norms:norms,showWeeklyNorm:showWeeklyNorm,onOpenDetail:onOpenDetail,onOpenCreate:onOpenCreate,onEventDetail:onEventDetail,loading:loading})]})]});};var TestIcon=function TestIcon(props){return jsxRuntime.jsxs("svg",_extends({},props,{width:"20",height:"21",viewBox:"0 0 20 21",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M7.74295 1.27849C7.44581 1.10283 7.06253 1.20131 6.88687 1.49845C6.71121 1.79559 6.80969 2.17887 7.10683 2.35452L7.2701 2.45104L1.66585 12.1244C0.375268 14.3521 1.14203 17.1995 3.37508 18.4843C5.60688 19.7684 8.46165 19.0073 9.7515 16.7809L15.3587 7.10234L15.5191 7.19462C15.8182 7.36683 16.2003 7.26392 16.3725 6.96476C16.5447 6.66561 16.4418 6.2835 16.1427 6.11129L15.4422 5.70807L8.43603 1.68821L7.74295 1.27849ZM2.74744 12.751L8.35027 3.08014L14.275 6.47949L13.0208 8.64426L11.4292 7.72853C11.13 7.55639 10.748 7.65938 10.5758 7.95858C10.4037 8.25777 10.5067 8.63986 10.8059 8.812L12.3942 9.72586L11.593 11.1088L8.63063 9.40441C8.33144 9.23227 7.94934 9.33526 7.7772 9.63445C7.60506 9.93364 7.70805 10.3157 8.00724 10.4879L10.9663 12.1904L10.2283 13.4643L8.59121 12.5223C8.29202 12.3502 7.90993 12.4532 7.73779 12.7524C7.56565 13.0516 7.66864 13.4337 7.96783 13.6058L9.60172 14.5459L8.6699 16.1543C7.72642 17.7828 5.6349 18.3424 3.99846 17.4009C2.36328 16.4601 1.80469 14.3783 2.74744 12.751Z",fill:"#1C274C"}),jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M17.6436 10.2344C17.1079 9.66918 16.2205 9.66918 15.6848 10.2344C15.4285 10.5048 15.1158 10.8637 14.8632 11.2463C14.6262 11.6054 14.3725 12.0867 14.3725 12.5803C14.3725 13.86 15.3747 14.9414 16.6642 14.9414C17.9537 14.9414 18.9559 13.86 18.9559 12.5803C18.9559 12.0867 18.7022 11.6054 18.4652 11.2463C18.2126 10.8637 17.8999 10.5048 17.6436 10.2344ZM16.5921 11.0942C16.6165 11.0685 16.6421 11.0605 16.6642 11.0605C16.6863 11.0605 16.7119 11.0685 16.7363 11.0942C16.9685 11.3392 17.2262 11.6383 17.422 11.9349C17.6333 12.2551 17.7059 12.4741 17.7059 12.5803C17.7059 13.2183 17.2157 13.6914 16.6642 13.6914C16.1127 13.6914 15.6225 13.2183 15.6225 12.5803C15.6225 12.4741 15.6951 12.2551 15.9064 11.9349C16.1022 11.6383 16.3599 11.3392 16.5921 11.0942Z",fill:"#1C274C"})]}));};var styles$2={"calendar-legend":"_KFAE5","calendar-legend__dot":"_hKgQP","calendar-legend--container":"_AsxqR","calendar-legend--online":"_l8XiL","calendar-legend--live-online":"_GGnl7","calendar-legend--offline":"_bGIXk","calendar-legend--cancel":"_OjQd9","calendar-legend--holiday":"_8JBWx"};var getDeviceType=function getDeviceType(width){if(width<768)return'mobile';// nhỏ hơn 768px: mobile
if(width<1024)return'tablet';// từ 768px đến dưới 1024px: tablet
return'desktop';// từ 1024px trở lên: desktop
};var useDeviceType=function useDeviceType(){var _useState=React.useState(function(){return getDeviceType(typeof window!=='undefined'?window.innerWidth:1024);}),deviceType=_useState[0],setDeviceType=_useState[1];React.useEffect(function(){var handleResize=function handleResize(){setDeviceType(getDeviceType(window.innerWidth));};window.addEventListener('resize',handleResize);return function(){return window.removeEventListener('resize',handleResize);};},[]);return deviceType;};var colors=[{label:'Online',color:'calendar-legend--online'},{label:'Live Online',color:'calendar-legend--live-online'},{label:'Offline',color:'calendar-legend--offline'},{label:'Cancelled',color:'calendar-legend--cancel'},{label:'Holiday',color:'calendar-legend--holiday'}];var CalendarLegend=function CalendarLegend(){useDeviceType();var classNameIcon=clsx__default["default"]('w-5 h-5');return jsxRuntime.jsxs("div",{className:styles$2['calendar-legend'],children:[colors.map(function(_ref){var label=_ref.label,color=_ref.color;return jsxRuntime.jsxs("div",{className:styles$2['calendar-legend--container'],children:[jsxRuntime.jsx("div",{className:clsx__default["default"](styles$2['calendar-legend__dot'],styles$2[color])}),jsxRuntime.jsx("span",{className:'text-xs md:text-sm',children:label})]},color);}),jsxRuntime.jsxs("div",{className:styles$2['calendar-legend--container'],children:[jsxRuntime.jsx(CaseStudyIcon,{className:classNameIcon}),jsxRuntime.jsx("span",{className:'text-xs md:text-sm',children:"Case Study"})]}),jsxRuntime.jsxs("div",{className:styles$2['calendar-legend--container'],children:[jsxRuntime.jsx(TestIcon,{className:classNameIcon}),jsxRuntime.jsx("span",{className:'text-xs md:text-sm',children:"Test"})]}),jsxRuntime.jsxs("div",{className:styles$2['calendar-legend--container'],children:[jsxRuntime.jsx(FlagIcon,{className:classNameIcon}),jsxRuntime.jsx("span",{className:'text-xs md:text-sm',children:"Key Content Before"})]})]});};var styles$1={"ant-picker-calendar-header":"_N05E6","ant-radio-group":"_7pJ0I","ant-picker-calendar-month-select":"_AHnMR","calendar-filter":"_QFLIK","calendar-filter_title":"_-1j92","calendar-filter_note_blue":"_AeUXi","calendar-filter_note_pureple":"_JpWMH","calendar-filter_note_green":"_BHiAu","calendar-filter_note_yellow":"_3dDpe","calendar-filter_note_red":"_SXksq","calendar-filter_container_list_item":"_KAg3M","calendar-filter_content_list_item":"_drdRr","calendar-filter_content_item_eye":"_QMgtr","calendar-filter__container-button":"_p05ba","ant-picker-content":"_-ZcDW"};var styles={"container":"_-WH8n","pointer-events-none":"_9AtQW","visible":"_ar6Pf","fixed":"_1jUwG","absolute":"_2KqPV","relative":"_cubrl","!mx-3":"_GMvGY","mx-1":"_nQUSH","my-4":"_0jcTr","mb-5":"_KkFcb","mt-4":"_kpMDQ","mt-6":"_H0oyd","mt-auto":"_4TAMB","block":"_40yZK","inline-block":"_3Lyl4","inline":"_qXpW4","flex":"_iV7B2","table":"_mfwgQ","grid":"_-cKLa","hidden":"_-Ctdn","h-4":"_BbUTV","h-5":"_BuSV-","h-full":"_csPqD","w-5":"_j7A6Q","w-full":"_XhXVk","min-w-0":"_RE13y","max-w-[703px]":"_bwneh","flex-1":"_53vRZ","transform":"_yuMr8","cursor-pointer":"_HdkRl","select-none":"_gPCpZ","resize":"_H1Glg","flex-col":"_J0r5P","items-center":"_T4JSa","justify-start":"_A5T7P","justify-between":"_wOCvq","gap-2":"_sLrPV","gap-4":"_8N8ft","gap-[6px]":"_p-g3-","rounded-none":"_olVBl","rounded-xl":"_vBYPb","border":"_A0zHv","border-gray-4":"_y9TXe","bg-button":"_4endB","bg-info/10":"_N5HL-","bg-transparent":"_n--J2","bg-white":"_xSPjR","p-4":"_xcFmL","px-1":"_OFfX1","pt-2":"_IccsW","text-sm":"_v4clN","text-xl":"_2Iq07","text-xs":"_OxrCr","font-medium":"_TwFpH","font-normal":"_2Z-Wd","font-semibold":"_ge-OR","italic":"_1dN41","leading-7":"_-txBd","!text-error":"_dYbKM","text-[#1F2937]":"_B0sEx","text-[#FFB700]":"_t--Z9","text-black":"_EtbXW","text-gray-600":"_YjaU5","text-info":"_hVvxX","text-secondary-text":"_7Cz-h","text-success":"_GBjUc","text-white":"_o-Qfr","underline":"_xyU7N","outline":"_MLIsx","!filter":"_4fe3J","filter":"_bsDZV","transition":"_Rsn0T","ease-in-out":"_ellhA","sapp-calendar":"_YOyvY","btn-icon":"_1VBOK","monthly-event__before":"_q0UmW","weekly-event__before":"_RA4a4","event__before-info":"_6rAqO","event__before-error":"_uzKlG","event__before-purple":"_WBy84","event__before-success":"_UjUiy","event__before-warning":"_wCM0J","event__border-info":"_S-stM","event__border-error":"_7xSQJ","event__border-purple":"_ZoY92","event__border-success":"_Hf6-j","event__border-warning":"_ZQr3L","event":"_3FvD2","event-weekly":"_LEQkd","btn":"_dUmWz","icon":"_NKmpt","btn-default":"_dndkP","btn-primary":"_CCDC-","btn--active":"_FdnKm","event-info":"_G2lxy","event-warning":"_D5Wmb","event-success":"_w8kI7","event-purple":"_Mmxd7","event-error":"_Ehs4f","event-default":"_pfXrw","sapp-calendar__container":"_3QkFb","header-calendar":"_-ibAt","header-calendar__right":"_WulV0","header-calendar__week":"_KLelW","header-calendar__month":"_VkzuW","header-calendar__year":"_RJEJw","header-calendar__nav":"_vlaud","header-calendar__date-picker":"_5Ngls","header-calendar__title":"_FTAOd","header-calendar__controls":"_g-P-s","header-calendar__divider":"_nb8oy","monthly-calendar":"_aF-Gd","weekly-calendar":"_npXTw","ant-table-body":"_bp4or","monthly-calendar__title":"_p9hmX","monthly-calendar__title-active":"_smT4Q","weekly-norm__cell":"_Aqzw2","weekly-norm__value":"_k4Xvb","ant-table-thead":"_RFKvq","monthly-calendar__cell":"_Hdiwd","monthly-calendar__title-container-text":"_VDn3V","monthly-calendar__cell--active":"_8J3jb","calendar-tooltip":"_FSmAY","monthly-calendar__cell--not-current-month":"_4xsd8","monthly-event__content":"_xUn2m","monthly-event__title":"_WO79S","monthly-event__date":"_4yGFM","weekly-calendar__title":"_DnGLJ","weekly-calendar__title--active":"_oepHo","weekly-calendar__title-day":"_e1wzO","weekly-calendar__title-weekday":"_W7Hmn","weekly-calendar__cell":"_fdsR5","weekly-event":"_q5PYV","event--min-height":"_6P62f","weekly-event__content":"_q-uuj","weekly-event__title":"_6ygPM","weekly-event__title--truncate":"_k2fQI","weekly-event__date":"_-UNyP","weekly-event__date--truncate":"_Swmci","weekly-event--collapse":"_JrmQf","btn-lms-default":"_h8RfQ","text-lms-primary":"_fuNy8","header-calendar_filter":"_ZSZlq","ant-picker-calendar-header":"_xgjyv","ant-picker-calendar-mode-switch":"_yjfeD","hover-item":"_UkUnw","weekly-event__title_icon":"_F4Iud","see-more":"_MuNK5","weekly-calendar--md":"_Avodw","weekly-calendar--sm":"_5zUQi","truncate-text":"_me8Fz","filter-select__mode":"_JiMM9","ant-select":"_qk5Oh","ant-select-single":"_qO-g8","ant-select-customize-input":"_mEEjN","ant-select-selector":"_7QPgC","ant-select-selection-item":"_YWKix","ant-select-item":"_idKOl","ant-select-dropdown":"_2--aL","monthly-calendar__title-container":"_053ZT","ant-picker-panel-container":"_2hO1G","bg-active":"_S9PNy","weekly-calendar-table":"_Eswh-","ant-table-tbody":"_ZIxXD","ant-spin-container":"_EQ4fW","header-calendar__tablet":"_3KHHI","header-calendar__mobile":"_90R39","monthly-calendar__mobile":"_5c6Hz","ant-picker-content":"_AD4LQ","ant-picker-cell":"_7Gl2E","ant-picker-week-panel-row-selected":"_nHOGx","ant-picker-week-panel-row":"_DQd3a","ant-picker-body":"_cSYSp","ant-picker-dropdown":"_Q9h4A","ant-picker-cell-inner":"_cjJjI","ant-picker-week-panel-row-hover":"_9YJ-Q","md:max-w-full":"_Yv7nA","md:text-sm":"_hBDCH"};var Button$1=function Button(_ref){var _ref$type=_ref.type,type=_ref$type===void 0?'button':_ref$type,_ref$color=_ref.color,color=_ref$color===void 0?'default':_ref$color,onClick=_ref.onClick,fullWidth=_ref.fullWidth,children=_ref.children;return jsxRuntime.jsx("button",{type:type,onClick:onClick,className:styles.btn+" "+styles["btn-"+color]+" "+(fullWidth&&'w-full'),children:children});};var FilterCalendar=React.forwardRef(function(_ref,ref){var filter=_ref.filter,setFilter=_ref.setFilter,onRefetchAPI=_ref.onRefetchAPI;// Temporary filter state for UI
var _useState=React.useState(filter),tempFilter=_useState[0],setTempFilter=_useState[1];// Update temp filter when prop filter changes
React.useEffect(function(){setTempFilter(filter);},[filter]);var noteFilter=React.useMemo(function(){return[{title:'Online',icon:jsxRuntime.jsx("div",{className:styles$1['calendar-filter_note_blue']}),value:LEARNING_MODE.ONLINE},{title:'Live Online',icon:jsxRuntime.jsx("div",{className:styles$1['calendar-filter_note_pureple']}),value:LEARNING_MODE.LIVE_ONLINE},{title:'Offline',icon:jsxRuntime.jsx("div",{className:styles$1['calendar-filter_note_green']}),value:LEARNING_MODE.OFFLINE},{title:'Holiday',icon:jsxRuntime.jsx("div",{className:styles$1['calendar-filter_note_yellow']}),value:LEARNING_MODE.HOLIDAY},{title:'Overdue',icon:jsxRuntime.jsx("div",{className:styles$1['calendar-filter_note_red']}),value:LEARNING_MODE.OVERDUE},{title:'Test',icon:jsxRuntime.jsx(TestIcon,{}),value:LEARNING_MODE.TEST},{title:'Case Study',icon:jsxRuntime.jsx(CaseStudyIcon,{}),value:LEARNING_MODE.CASE_STUDY},{title:'Key Content Before',icon:jsxRuntime.jsx(FlagIcon,{}),value:LEARNING_MODE.KEY_BEFORE_CONTENT}];},[]);var handleTempFilter=function handleTempFilter(type,value){switch(type){case'course':{setTempFilter(function(prev){var courseId=prev.courseId||[];var updatedCourseId=courseId.includes(value)?courseId.filter(function(item){return item!==value;}):[].concat(courseId,[value]);return _extends({},prev,{courseId:updatedCourseId});});break;}case'note':{setTempFilter(function(prev){var typeArray=prev.type||[];var updatedType=typeArray.includes(value)?typeArray.filter(function(item){return item!==value;}):[].concat(typeArray,[value]);return _extends({},prev,{type:updatedType});});break;}case'day':{setTempFilter(function(prev){return _extends({},prev,{day:value});});break;}}};var handleConfirm=function handleConfirm(){// Apply the temporary filter to the actual filter
setFilter(_extends({},tempFilter,{isOpen:false}));// If there's a day filter, also trigger the API refetch
if(tempFilter.day){onRefetchAPI(dayjs__default["default"](tempFilter.day).toDate());}};// const handleFilterday = (date: Dayjs) => {
//   setTempFilter((prev) => ({ ...prev, day: date.toString() }))
//   onRefetchAPI(date.toDate())
// }
return jsxRuntime.jsxs("div",{ref:ref,className:styles$1['calendar-filter'],children:[jsxRuntime.jsx("div",{className:styles$1['calendar-filter_title'],children:"Sort Filter"}),jsxRuntime.jsx("div",{className:styles$1['calendar-filter_container_list_item'],children:noteFilter.map(function(item){var _tempFilter$type;return jsxRuntime.jsxs("div",{className:styles$1['calendar-filter_content_list_item'],children:[jsxRuntime.jsx("div",{onClick:function onClick(){return handleTempFilter('note',item.value);},className:styles$1['calendar-filter_content_item_eye'],children:jsxRuntime.jsx(antd.Checkbox,{className:styles$1['custom-checkbox'],checked:(_tempFilter$type=tempFilter.type)==null?void 0:_tempFilter$type.includes(item.value)})}),jsxRuntime.jsxs("div",{className:styles$1['calendar-filter_content_list_item'],children:[item.icon,item.title]})]},item.value);})}),jsxRuntime.jsx("div",{className:styles$1["calendar-filter__container-button"],children:jsxRuntime.jsx(Button$1,{color:'primary',onClick:handleConfirm,children:" Confirm"})})]});});var Icon=function Icon(_ref){var icon=_ref.icon,onClick=_ref.onClick,className=_ref.className;return jsxRuntime.jsx("div",{className:clsx.clsx(styles.icon,onClick&&styles['cursor-pointer'],className),onClick:onClick,children:icon});};var HeaderCalendar=function HeaderCalendar(_ref){var title=_ref.title,showTeacherName=_ref.showTeacherName,currentDate=_ref.currentDate,setCurrentDate=_ref.setCurrentDate,calendarMode=_ref.calendarMode,setCalendarMode=_ref.setCalendarMode;var handleChangeDate=function handleChangeDate(date){setCurrentDate(date);};var handleChangeMode=function handleChangeMode(mode){setCalendarMode(mode);setCurrentDate(currentDate.startOf('month'));};return jsxRuntime.jsx("div",{children:jsxRuntime.jsxs("div",{className:styles['header-calendar'],children:[jsxRuntime.jsxs("div",{className:styles['header-calendar__nav'],children:[jsxRuntime.jsx(Icon,{icon:jsxRuntime.jsx(Left,{}),onClick:function onClick(){return handleChangeDate(currentDate.subtract(1,calendarMode));}}),jsxRuntime.jsx(antd.DatePicker,{picker:calendarMode==='day'?'date':calendarMode,onChange:handleChangeDate,format:function format(value){return customDateFormat(value,'MMMM, YYYY');},value:currentDate,allowClear:false,suffixIcon:null,className:styles['header-calendar__date-picker'],size:'large'}),jsxRuntime.jsx(Icon,{icon:jsxRuntime.jsx(Right,{}),onClick:function onClick(){return handleChangeDate(currentDate.add(1,calendarMode));}})]}),showTeacherName&&jsxRuntime.jsx("div",{className:styles['header-calendar__title'],children:title}),jsxRuntime.jsxs("div",{className:styles['header-calendar__controls'],children:[jsxRuntime.jsx(Button$1,{onClick:function onClick(){return handleChangeDate(dayjs__default["default"]());},children:"Today"}),jsxRuntime.jsx("div",{className:styles['header-calendar__divider']}),jsxRuntime.jsx(Button$1,{color:calendarMode==='month'?'primary':'default',onClick:function onClick(){return handleChangeMode('month');},children:"Month"}),jsxRuntime.jsx(Button$1,{color:calendarMode==='week'?'primary':'default',onClick:function onClick(){return handleChangeMode('week');},children:"Week"})]})]})});};var _excluded$O=["value","options","defaultValue","className","disabled","onChange"];var SelectBox=function SelectBox(_ref){var value=_ref.value,options=_ref.options,defaultValue=_ref.defaultValue,_ref$className=_ref.className,className=_ref$className===void 0?'':_ref$className,disabled=_ref.disabled,onChange=_ref.onChange,restProps=_objectWithoutPropertiesLoose(_ref,_excluded$O);return jsxRuntime.jsx(antd.Select,_extends({defaultValue:defaultValue,className:className,disabled:disabled,options:options,value:value,getPopupContainer:function getPopupContainer(trigger){return trigger.parentNode;},onChange:onChange,dropdownAlign:{points:['tl','bl'],offset:[0,12]}},restProps));};var CustomDatePicker=function CustomDatePicker(_ref){var currentDate=_ref.currentDate,setCurrentDate=_ref.setCurrentDate,calendarMode=_ref.calendarMode;var _useState=React.useState(false),visible=_useState[0],setVisible=_useState[1];var wrapperRef=React.useRef(null);var handleIconClick=function handleIconClick(e){e.stopPropagation();setVisible(function(prev){return!prev;});};var handleDateChange=function handleDateChange(date){if(date){setCurrentDate(date);}};React.useEffect(function(){var handleClickOutside=function handleClickOutside(e){var popup=document.querySelector('.ant-picker-dropdown');if(wrapperRef.current&&!wrapperRef.current.contains(e.target)&&!(popup&&popup.contains(e.target))){setVisible(false);}};document.addEventListener('mousedown',handleClickOutside);return function(){return document.removeEventListener('mousedown',handleClickOutside);};},[]);return jsxRuntime.jsxs("div",{ref:wrapperRef,style:{position:'relative',height:'fit-content'},children:[jsxRuntime.jsx("div",{onClick:handleIconClick,className:clsx__default["default"](styles['hover-item'],styles['btn-icon'],'cursor-pointer',visible&&styles['btn--active']),children:jsxRuntime.jsx(FilterDateIcon,{})}),jsxRuntime.jsx(antd.DatePicker,{style:{position:'absolute',opacity:0,pointerEvents:'none',width:'38px'},open:visible,value:currentDate,onChange:handleDateChange,placement:'bottomRight',picker:calendarMode==='day'?'date':calendarMode==='week'?'week':'month',components:{input:function input(inputProps){return jsxRuntime.jsx("input",_extends({},inputProps,{style:{position:'absolute',opacity:0.001,left:0,top:0,zIndex:-1,width:'100%',height:'100%',pointerEvents:'auto'}}));}},allowClear:false,suffixIcon:null,getPopupContainer:function getPopupContainer(){return document.body;},popupStyle:{pointerEvents:'auto',zIndex:9999}})]});};var LMSHeaderCalendar=function LMSHeaderCalendar(_ref){var _clsx;var title=_ref.title,showTeacherName=_ref.showTeacherName,currentDate=_ref.currentDate,setCurrentDate=_ref.setCurrentDate,calendarMode=_ref.calendarMode,setCalendarMode=_ref.setCalendarMode,toggleTurnOnFilter=_ref.toggleTurnOnFilter,filter=_ref.filter,hasFilter=_ref.hasFilter;var handleChangeMode=function handleChangeMode(mode){setCalendarMode(mode);setCurrentDate(dayjs__default["default"]());};var handleGoToToday=function handleGoToToday(){setCurrentDate(dayjs__default["default"]());};var handleGoToPrevious=function handleGoToPrevious(){setCurrentDate(currentDate.subtract(1,calendarMode));};var handleGoToNext=function handleGoToNext(){setCurrentDate(currentDate.add(1,calendarMode));};// ✅ Tối ưu hóa tính toán tháng/năm với useMemo
var _useMemo=React.useMemo(function(){return extractMonthYear(dayjs__default["default"](currentDate.valueOf()));},[currentDate]),month=_useMemo.month,year=_useMemo.year;var _useMemo2=React.useMemo(function(){return extractWeek(dayjs__default["default"](currentDate.valueOf()));},[currentDate]),startDateDisplay=_useMemo2.startDateDisplay,endDateDisplay=_useMemo2.endDateDisplay,weekYear=_useMemo2.year;var calendarModeOptions=[{value:'month',label:'Month'},{value:'week',label:'Week'}];return jsxRuntime.jsxs(jsxRuntime.Fragment,{children:[jsxRuntime.jsxs("div",{className:styles['header-calendar'],children:[jsxRuntime.jsx("div",{className:styles['header-calendar_left'],children:jsxRuntime.jsx("div",{className:styles['header-calendar__controls'],children:jsxRuntime.jsx(Button$1,{color:"lms-default",onClick:handleGoToToday,children:"Today"})})}),jsxRuntime.jsx("div",{className:styles['header-calendar_center'],children:jsxRuntime.jsxs("div",{className:styles['header-calendar__nav'],children:[jsxRuntime.jsx(Icon,{icon:jsxRuntime.jsx(LeftArrowIcon,{}),onClick:handleGoToPrevious,className:styles['rounded-none']}),jsxRuntime.jsxs("div",{className:styles['header-calendar__date'],"data-testid":"header-date",children:[calendarMode==='week'&&jsxRuntime.jsxs(jsxRuntime.Fragment,{children:[jsxRuntime.jsxs("span",{className:styles['header-calendar__week'],children:[startDateDisplay," - ",endDateDisplay,", "]}),jsxRuntime.jsx("span",{className:styles['header-calendar__year'],children:weekYear})]}),calendarMode==='month'&&jsxRuntime.jsxs(jsxRuntime.Fragment,{children:[jsxRuntime.jsxs("span",{className:styles['header-calendar__month'],children:[month,", "]}),jsxRuntime.jsx("span",{className:styles['header-calendar__year'],children:year})]})]}),jsxRuntime.jsx(Icon,{icon:jsxRuntime.jsx(RightArrowIcon,{}),onClick:handleGoToNext})]})}),jsxRuntime.jsxs("div",{className:styles['header-calendar__right'],children:[hasFilter&&jsxRuntime.jsx("div",{className:clsx__default["default"](styles['hover-item'],styles['btn-icon'],(_clsx={},_clsx[styles['text-lms-primary']]=filter.isOpen,_clsx[styles['btn--active']]=filter.isOpen,_clsx['pointer-events-none']=filter.isOpen,_clsx)),onClick:toggleTurnOnFilter,children:jsxRuntime.jsx(FilterIcon,{})}),jsxRuntime.jsx(CustomDatePicker,{currentDate:currentDate,setCurrentDate:setCurrentDate,calendarMode:calendarMode}),jsxRuntime.jsx(SelectBox,{value:calendarMode,options:calendarModeOptions,className:"filter-select__mode",onChange:function onChange(mode){return handleChangeMode(mode);},suffixIcon:jsxRuntime.jsx(DropDownIcon,{})})]})]}),showTeacherName&&jsxRuntime.jsx("div",{className:styles['header-calendar__title'],children:title})]});};var CustomTooltip=function CustomTooltip(_ref){var title=_ref.title,children=_ref.children,_ref$placement=_ref.placement,placement=_ref$placement===void 0?'top':_ref$placement;return jsxRuntime.jsx(antd.Tooltip,{color:'#404041',className:'font-normal text-sm',title:jsxRuntime.jsx("div",{className:styles['text-white'],children:title}),placement:placement,style:{boxShadow:'0 4px 16px 0 rgba(0, 0, 0, 0.08)'},children:jsxRuntime.jsx("div",{children:children})});};var calculateBoxSize=function calculateBoxSize(startTime,endTime,isAllDay){var deviceType=useDeviceType();if(isAllDay){return{top:2,height:MIN_HEIGHT_HIDE_DETAIL};}var minutes=dayjs__default["default"](startTime).minute();var diffMinutes=dayjs__default["default"](endTime).diff(startTime,'minute',true);var border=Math.floor((minutes+diffMinutes)/MINUTES_PER_HOUR*BORDER_WEEKLY_CELL);var height;if(deviceType==='mobile'){height=diffMinutes*(28/60)+border;}else if(deviceType==='tablet'){height=diffMinutes*(40/60)+border;}else{height=diffMinutes+border;}return{top:minutes,height:height};};var WeeklyEvent=function WeeklyEvent(_ref){var _event$spanDays;var event=_ref.event,onOpenDetail=_ref.onOpenDetail,onEventDetail=_ref.onEventDetail,isAllDay=_ref.isAllDay,setEventDetail=_ref.setEventDetail,isOnDetail=_ref.isOnDetail,date=_ref.date,_ref$overlapCount=_ref.overlapCount,overlapCount=_ref$overlapCount===void 0?1:_ref$overlapCount,_ref$overlapIndex=_ref.overlapIndex,overlapIndex=_ref$overlapIndex===void 0?0:_ref$overlapIndex;var contentRef=React.useRef(null);var _useState=React.useState(false),shouldTruncateTitle=_useState[0],setShouldTruncateTitle=_useState[1];var _useState2=React.useState(false),shouldTruncateContent=_useState2[0],setShouldTruncateContent=_useState2[1];var deviceType=useDeviceType();var _calculateBoxSize=calculateBoxSize(event.startDate,event.endDate,event.isAllDay),top=_calculateBoxSize.top,height=_calculateBoxSize.height;React.useEffect(function(){if(contentRef.current){var padding=0;var extraHeight=0;if(deviceType==='mobile'){padding=4*2;extraHeight=0;}else if(deviceType==='tablet'){padding=8*2;extraHeight=24;}else{padding=12*2;extraHeight=0;}var actualHeight=contentRef.current.offsetHeight;var needsTruncation=actualHeight+padding+extraHeight>height;if(needsTruncation){setShouldTruncateTitle(true);if(!shouldTruncateTitle)return;setShouldTruncateContent(true);}}},[height,shouldTruncateTitle]);var isMinHeight=height<MIN_HEIGHT_EVENT;var formattedDate=customDateFormat(event.startDate,TIME_FORMAT)+' - '+customDateFormat(event.endDate,TIME_FORMAT);var iconList=getIconforEvent(event);var className=event!=null&&event.isOverDue?"event-error":"event-"+(convertType[event.type]||'default');var classNameBefore=event!=null&&event.isOverDue?"event__before-error":"event__before-"+(convertType[event.type]||'default');var classNameBorder=event!=null&&event.isOverDue?"event__border-error":"event__border-"+(convertType[event.type]||'default');// ---- Width responsive theo thiết bị ----
var WEEKLY_CELL_WIDTH_DESKTOP=100;var WEEKLY_CELL_WIDTH_TABLET='152px';var WEEKLY_CELL_WIDTH_MOBILE='90px';var eventWidth='auto';var days=(_event$spanDays=event.spanDays)!=null?_event$spanDays:1;if(isAllDay&&days>1){if(deviceType==='desktop'){eventWidth="calc("+WEEKLY_CELL_WIDTH_DESKTOP*days+"%)";}else if(deviceType==='tablet'){eventWidth="calc("+WEEKLY_CELL_WIDTH_TABLET+" * "+days+")";}else{eventWidth="calc("+WEEKLY_CELL_WIDTH_MOBILE+" * "+days+")";}}var margin=4;var gap=margin;var percent=100/overlapCount;var width="calc("+percent+"% - "+gap*(overlapCount-1)/overlapCount+"px - "+margin+"px)";var left="calc("+percent*overlapIndex+"% )";return jsxRuntime.jsxs("div",{className:clsx__default["default"](styles[className],styles['event-weekly'],isOnDetail&&styles[classNameBorder]),onClick:function onClick(){onOpenDetail&&onOpenDetail(dayjs__default["default"](event.startDate).toDate(),[event]);onEventDetail&&onEventDetail(_extends({},event,{current_date:date}));setEventDetail&&setEventDetail({event:event,date:date});},style:{position:'absolute',top:top+"px",height:!isAllDay?Math.max(height,MIN_HEIGHT_EVENT)-EVENT_VERTICAL_SPACING+"px":"60px",zIndex:isAllDay&&days>1?2:1,width:isAllDay?eventWidth:width,left:isAllDay?undefined:left},children:[jsxRuntime.jsx("span",{className:clsx__default["default"](styles['weekly-event__before'],styles[classNameBefore])}),jsxRuntime.jsxs("div",{className:clsx__default["default"](styles['weekly-event'],isMinHeight&&styles['event--min-height']),children:[isDisplayIconV2(event)&&jsxRuntime.jsx("div",{className:styles['weekly-event__title_icon'],children:iconList}),jsxRuntime.jsxs("div",{ref:contentRef,className:clsx__default["default"](styles['weekly-event__content'],height<MIN_HEIGHT_HIDE_DETAIL&&styles['weekly-event--collapse']),children:[jsxRuntime.jsx("div",{className:clsx__default["default"](styles['weekly-event__title'],shouldTruncateTitle&&styles['weekly-event__title--truncate']),children:jsxRuntime.jsx(CustomTooltip,{title:event.title,children:event.title})}),jsxRuntime.jsx("div",{className:clsx__default["default"](styles['weekly-event__date'],shouldTruncateContent&&styles['weekly-event__date--truncate']),children:jsxRuntime.jsx(CustomTooltip,{title:formattedDate,children:formattedDate})})]})]})]});};// Overlap đã tính ở WeeklyCalendar theo từng ngày
var WeeklyCell=function WeeklyCell(_ref){var events=_ref.events,date=_ref.date,onOpenDetail=_ref.onOpenDetail,onOpenCreate=_ref.onOpenCreate,onEventDetail=_ref.onEventDetail,eventDetail=_ref.eventDetail,setEventDetail=_ref.setEventDetail,overlapMap=_ref.overlapMap;var isToday=dayjs__default["default"]().isSame(date,'day');var handleOpenCreateModal=function handleOpenCreateModal(e){if(e.target!==e.currentTarget)return;onOpenCreate&&onOpenCreate(dayjs__default["default"](date).toDate());};events.sort(function(a,b){return a.type===EVENT_TYPES.BUSY&&b.type!==EVENT_TYPES.BUSY?1:-1;});var renderWeeklyEvent=React.useMemo(function(){var isAllDay=events.some(function(item){return item.isAllDay;});if(isAllDay&&events.length>1){return jsxRuntime.jsxs(React__default["default"].Fragment,{children:[jsxRuntime.jsx(WeeklyEvent,{event:events[0],onOpenDetail:onOpenDetail,onEventDetail:onEventDetail,zIndex:1,isAllDay:isAllDay,date:date}),jsxRuntime.jsx("div",{className:styles['see-more'],children:jsxRuntime.jsxs(CustomTooltip,{placement:'bottom',title:jsxRuntime.jsx("div",{className:styles['calendar-tooltip'],children:events.slice(1,events.length).map(function(event,index){var _eventDetail$event;return jsxRuntime.jsx(WeeklyEvent,{event:event,onOpenDetail:onOpenDetail,onEventDetail:onEventDetail,zIndex:index+1,isAllDay:isAllDay,setEventDetail:setEventDetail,isOnDetail:(eventDetail==null||(_eventDetail$event=eventDetail.event)==null?void 0:_eventDetail$event.id)===event.id&&eventDetail.date.isSame(date,'day'),date:date},index+1);})}),children:["+",Math.max(events.length-1,0)," More"]})})]});}// Overlap per day đã tính ở trên, map cho từng event
return events.map(function(event,idx){var _info$count,_info$index,_eventDetail$event2;var info=overlapMap==null?void 0:overlapMap[event.id];var count=(_info$count=info==null?void 0:info.count)!=null?_info$count:1;var index=(_info$index=info==null?void 0:info.index)!=null?_info$index:0;return jsxRuntime.jsx(WeeklyEvent,{event:event,onOpenDetail:onOpenDetail,onEventDetail:onEventDetail,zIndex:idx+1,isAllDay:isAllDay,setEventDetail:setEventDetail,isOnDetail:(eventDetail==null||(_eventDetail$event2=eventDetail.event)==null?void 0:_eventDetail$event2.id)===event.id&&eventDetail.date.isSame(date,'day'),date:date,overlapCount:count,overlapIndex:index},event.id);});},[events]);return jsxRuntime.jsx("div",{className:clsx__default["default"](styles['weekly-calendar__cell'],isToday?styles['bg-active']:styles['bg-white']),onClick:handleOpenCreateModal,children:renderWeeklyEvent});};dayjs__default["default"].extend(isBetween__default["default"]);dayjs__default["default"].extend(isoWeek__default["default"]);var getEventAllDay=function getEventAllDay(events,targetDate){var allDayEvents=events.filter(function(e){return e.isAllDay||e.type==='HOLIDAY';});var groupedById={};allDayEvents.forEach(function(event){if(!groupedById[event.id])groupedById[event.id]=[];groupedById[event.id].push(event);});var spanDaysMap={};var idToMaxSpan={};Object.entries(groupedById).forEach(function(_ref){var id=_ref[0],events=_ref[1];var sorted=events.sort(function(a,b){return dayjs__default["default"](a.startDate).unix()-dayjs__default["default"](b.startDate).unix();});var i=0;while(i<sorted.length){var start=i;var end=i;while(end+1<sorted.length&&dayjs__default["default"](sorted[end+1].startDate).startOf('day').diff(dayjs__default["default"](sorted[end].startDate).startOf('day'),'day')===1){end++;}var span=end-start+1;var startKey=dayjs__default["default"](sorted[start].startDate).format('YYYY-MM-DD');if(!spanDaysMap[id])spanDaysMap[id]={};spanDaysMap[id][startKey]=span;if(!idToMaxSpan[id]||span>idToMaxSpan[id]){idToMaxSpan[id]=span;}i=end+1;}});return daysOfWeekKeys.reduce(function(acc,day,index){var currentDate=targetDate.add(index,'day');currentDate.format('YYYY-MM-DD');var maxSpanAllowed=7-index;// ví dụ Chủ nhật = 1, T7 = 2, v.v.
var eventsForDay=events.reduce(function(result,e){var isAllDay=e.isAllDay||e.type==='HOLIDAY';var isSameDay=dayjs__default["default"](e.startDate).isSame(currentDate,'day');if(isAllDay&&isSameDay){var _spanDaysMap$e$id;var eventKey=dayjs__default["default"](e.startDate).format('YYYY-MM-DD');var spanDays=(_spanDaysMap$e$id=spanDaysMap[e.id])==null?void 0:_spanDaysMap$e$id[eventKey];// Apply maxSpanAllowed logic
if(spanDays!==undefined){spanDays=Math.min(spanDays,maxSpanAllowed);}result.push(_extends({},e,{isAllDay:true,spanDays:spanDays!=null?spanDays:undefined}));}return result;},[]);var sortedEvents=eventsForDay.sort(function(a,b){var aMax=idToMaxSpan[a.id]||0;var bMax=idToMaxSpan[b.id]||0;if(aMax!==bMax)return bMax-aMax;// span dài hơn lên trước
return a.id.localeCompare(b.id);// fallback: theo id tăng dần
});acc[day]={date:currentDate,events:sortedEvents};return acc;},{});};var getEventsOfDay=function getEventsOfDay(events,targetHour){return daysOfWeekKeys.reduce(function(acc,day,index){var currentDate=targetHour.add(index,'day');acc[day]={events:events.filter(function(event){return dayjs__default["default"](event.startDate).isSame(currentDate,'hour')&&!checkIsAllday(dayjs__default["default"](event.startDate),dayjs__default["default"](event.endDate));}),date:currentDate};return acc;},{});};var WeeklyCalendar=function WeeklyCalendar(_ref2){var startDate=_ref2.startDate,endDate=_ref2.endDate,events=_ref2.events,norms=_ref2.norms,showWeeklyNorm=_ref2.showWeeklyNorm,onOpenDetail=_ref2.onOpenDetail,onOpenCreate=_ref2.onOpenCreate,onEventDetail=_ref2.onEventDetail,loading=_ref2.loading,type=_ref2.type,eventDetail=_ref2.eventDetail,setEventDetail=_ref2.setEventDetail;var deviceType=useDeviceType();// Tính overlap theo ngày: tạo map eventId -> {count, index} cho mỗi ngày trong tuần
var overlapMapsByDay=React__default["default"].useMemo(function(){var buildClusters=function buildClusters(dayEvents){var nonAllDay=dayEvents.filter(function(e){return!checkIsAllday(dayjs__default["default"](e.startDate),dayjs__default["default"](e.endDate));});if(nonAllDay.length===0)return[];var sorted=[].concat(nonAllDay).sort(function(a,b){return dayjs__default["default"](a.startDate).valueOf()-dayjs__default["default"](b.startDate).valueOf();});var clusters=[];var active=[];var currentCluster=[];sorted.forEach(function(ev){var startMs=dayjs__default["default"](ev.startDate).valueOf();active=active.filter(function(a){return dayjs__default["default"](a.endDate).valueOf()>startMs;});if(active.length===0&&currentCluster.length>0){clusters.push(currentCluster);currentCluster=[];}currentCluster.push(ev);active.push(ev);});if(currentCluster.length>0)clusters.push(currentCluster);return clusters;};var buildOverlapMapForDay=function buildOverlapMapForDay(dayEvents){var clusters=buildClusters(dayEvents);var result={};clusters.forEach(function(cluster){// Gán cột cho cluster bằng greedy theo end-time cho từng cột
var byStart=[].concat(cluster).sort(function(a,b){return dayjs__default["default"](a.startDate).valueOf()-dayjs__default["default"](b.startDate).valueOf();});var columnEndTimes=[];var assignments=[];byStart.forEach(function(ev){var start=dayjs__default["default"](ev.startDate).valueOf();var end=dayjs__default["default"](ev.endDate).valueOf();var placed=-1;for(var c=0;c<columnEndTimes.length;c++){if(columnEndTimes[c]<=start){placed=c;columnEndTimes[c]=end;break;}}if(placed===-1){columnEndTimes.push(end);placed=columnEndTimes.length-1;}assignments.push({id:ev.id,col:placed});});var totalCols=columnEndTimes.length;assignments.forEach(function(_ref3){var id=_ref3.id,col=_ref3.col;result[id]={count:totalCols,index:col};});});return result;};// Tạo 7 map cho 7 ngày
var maps=[];var _loop=function _loop(){var date=dayjs__default["default"](startDate).add(i,'day');var dayEvents=events.filter(function(e){return dayjs__default["default"](e.startDate).isSame(date,'day');});maps.push(buildOverlapMapForDay(dayEvents));};for(var i=0;i<7;i++){_loop();}return maps;},[events,startDate]);var getTableColumns=function getTableColumns(){var _calculateNormOfWeek=calculateNormOfWeek(norms,events,startDate,endDate),normOfWeek=_calculateNormOfWeek.normOfWeek,totalNorm=_calculateNormOfWeek.totalNorm;// Xác định width cho cột giờ (hour column) theo loại thiết bị
var HOUR_COLUMN_WIDTH_MOBILE='52px';var HOUR_COLUMN_WIDTH_TABLET_DESKTOP='70px';var hourColumnWidth=HOUR_COLUMN_WIDTH_TABLET_DESKTOP;if(deviceType==='mobile'){hourColumnWidth=HOUR_COLUMN_WIDTH_MOBILE;}var hourColumn={title:jsxRuntime.jsx("div",{className:styles['weekly-calendar__title'],children:showWeeklyNorm&&jsxRuntime.jsxs(React__default["default"].Fragment,{children:[jsxRuntime.jsx("div",{children:"Weekly Norm"}),jsxRuntime.jsx("div",{className:clsx__default["default"](normOfWeek>totalNorm&&styles['!text-error']),children:normOfWeek+"/"+totalNorm})]})}),dataIndex:'hour',key:'hour',width:hourColumnWidth,render:function render(value){return jsxRuntime.jsx("div",{children:value});}};var isToday=function isToday(index){return dayjs__default["default"](startDate).add(index,'day').isSame(dayjs__default["default"](),'day');};// Xác định width cho từng loại thiết bị
var WEEKLY_CELL_WIDTH_DESKTOP='calc((100% - 100px) / 7)';var WEEKLY_CELL_WIDTH_TABLET='152px';var WEEKLY_CELL_WIDTH_MOBILE='90px';var weeklyCellWidth=WEEKLY_CELL_WIDTH_DESKTOP;if(deviceType==='tablet'){weeklyCellWidth=WEEKLY_CELL_WIDTH_TABLET;}else if(deviceType==='mobile'){weeklyCellWidth=WEEKLY_CELL_WIDTH_MOBILE;}var dayColumns=Object.values(DAYS_OF_WEEK).map(function(day,index){return{title:jsxRuntime.jsxs("div",{className:clsx__default["default"](styles['weekly-calendar__title'],isToday(index)&&styles['weekly-calendar__title--active']),children:[jsxRuntime.jsx("div",{className:styles['weekly-calendar__title-day'],children:dayjs__default["default"](startDate).add(index,'day').format('DD')}),jsxRuntime.jsx("div",{className:styles['weekly-calendar__title-weekday'],children:day.slice(0,3)})]}),dataIndex:day,key:day,width:weeklyCellWidth,render:function render(value){return jsxRuntime.jsx(WeeklyCell,{events:value.events,date:value.date,onOpenDetail:onOpenDetail,onOpenCreate:onOpenCreate,onEventDetail:onEventDetail,eventDetail:eventDetail,setEventDetail:setEventDetail,overlapMap:overlapMapsByDay[index]},index);}};});return[hourColumn].concat(dayColumns);};var getTableData=function getTableData(){var data=[];// All day
data.push(_extends({id:-1,hour:'All day'},getEventAllDay(events,startDate)));var count=type===CALENDAR_TYPE.LMS?7:0;// Hour
for(var i=count;i<HOURS_PER_DAY;i++){var targetHour=dayjs__default["default"](startDate).add(i,'hour');data.push(_extends({id:i,hour:targetHour.format('HH:mm')},getEventsOfDay(events,targetHour)));}return data;};return jsxRuntime.jsx("div",{className:"weekly-calendar-table",children:jsxRuntime.jsx(antd.Table,{scroll:deviceType==='mobile'?{y:'calc(100vh - 274px)'}:undefined,rowKey:function rowKey(record){return record.id;},columns:getTableColumns(),dataSource:getTableData(),pagination:false,rowHoverable:false,className:clsx__default["default"](deviceType==='mobile'?styles['weekly-calendar--sm']:styles['weekly-calendar--md'],styles['weekly-calendar']),loading:loading,tableLayout:'fixed',rowClassName:function rowClassName(record,index){var data=getTableData();return index===data.length-1?'table-row-last':'';}})});};function LMSModeWeeklyCalendar(_ref){var startDate=_ref.startDate,endDate=_ref.endDate,events=_ref.events,norms=_ref.norms,_ref$showWeeklyNorm=_ref.showWeeklyNorm,showWeeklyNorm=_ref$showWeeklyNorm===void 0?false:_ref$showWeeklyNorm,onOpenDetail=_ref.onOpenDetail,onOpenCreate=_ref.onOpenCreate,onEventDetail=_ref.onEventDetail,loading=_ref.loading,eventDetail=_ref.eventDetail,setEventDetail=_ref.setEventDetail;var _useState=React.useState(window.innerWidth),setWindowWidth=_useState[1];dayjs__default["default"].updateLocale('en',{weekdaysMin:['Sun','Mon','Tue','Wed','Thu','Fri','Sat']});React.useEffect(function(){var handleResize=function handleResize(){setWindowWidth(window.innerWidth);};window.addEventListener('resize',handleResize);return function(){window.removeEventListener('resize',handleResize);};},[]);return jsxRuntime.jsx(React__default["default"].Fragment,{children:jsxRuntime.jsx(WeeklyCalendar,{startDate:startDate,endDate:endDate,events:events,norms:norms,showWeeklyNorm:showWeeklyNorm,onOpenDetail:onOpenDetail,onOpenCreate:onOpenCreate,onEventDetail:onEventDetail,loading:loading,type:CALENDAR_TYPE.LMS,eventDetail:eventDetail,setEventDetail:setEventDetail})});}var MonthlyEvent=function MonthlyEvent(_ref){var event=_ref.event,isSameMonth=_ref.isSameMonth,onEventDetail=_ref.onEventDetail,_ref$isOnDetail=_ref.isOnDetail,isOnDetail=_ref$isOnDetail===void 0?false:_ref$isOnDetail,setEventDetail=_ref.setEventDetail,date=_ref.date;var formattedDate=customDateFormat(event.startDate,TIME_FORMAT)+' - '+customDateFormat(event.endDate,TIME_FORMAT);var iconList=getIconforEvent(event);var className=event!=null&&event.isOverDue?"event-error":isSameMonth?"event-"+(convertType[event.type]||'default'):'event-default';var classNameBefore=event!=null&&event.isOverDue?"event__before-error":isSameMonth?"event__before-"+(convertType[event.type]||'default'):'event__before-default';var classNameBorder=event!=null&&event.isOverDue?"event__border-error":isSameMonth?"event__border-"+(convertType[event.type]||'default'):'event__border-default';return jsxRuntime.jsx(React__default["default"].Fragment,{children:jsxRuntime.jsxs("li",{className:clsx__default["default"](styles[className],styles['event'],isOnDetail&&styles[classNameBorder]),style:{cursor:'pointer'},onClick:function onClick(){onEventDetail&&onEventDetail(_extends({},event,{current_date:date}));setEventDetail&&setEventDetail({event:event,date:date});},children:[jsxRuntime.jsx("span",{className:clsx__default["default"](styles['monthly-event__before'],styles[classNameBefore])}),jsxRuntime.jsxs("div",{className:styles["monthly-event__content"],children:[jsxRuntime.jsxs("div",{className:styles['monthly-event__title'],children:[isDisplayIconV2(event)&&jsxRuntime.jsx("div",{className:styles['weekly-event__title_icon'],children:iconList}),jsxRuntime.jsx("div",{className:'flex-1 min-w-0',children:jsxRuntime.jsx(CustomTooltip,{title:event.title,children:jsxRuntime.jsx("div",{className:styles['truncate-text'],children:event.title})})})]}),jsxRuntime.jsx("div",{className:styles['monthly-event__date'],children:jsxRuntime.jsx(CustomTooltip,{title:formattedDate,children:formattedDate})})]})]})});};var MonthlyCell=function MonthlyCell(_ref){var currentDate=_ref.currentDate,events=_ref.events,date=_ref.date,onOpenDetail=_ref.onOpenDetail,onOpenCreate=_ref.onOpenCreate,onEventDetail=_ref.onEventDetail,eventDetail=_ref.eventDetail,setEventDetail=_ref.setEventDetail;var _useState=React.useState(false),isHovered=_useState[0],setIsHovered=_useState[1];var hasMore=events.length>2;var isSameMonth=currentDate.isSame(date,'month');var isToday=dayjs__default["default"]().isSame(date,'day');var handleOpenCreateModal=function handleOpenCreateModal(e){if(e.target!==e.currentTarget)return;onOpenCreate&&onOpenCreate(dayjs__default["default"](date).hour(dayjs__default["default"]().hour()).minute(dayjs__default["default"]().minute()).toDate());};var isOnDetail=eventDetail&&eventDetail.date.isSame(date,'day')&&events.some(function(event){var _eventDetail$event;return event.id===((_eventDetail$event=eventDetail.event)==null?void 0:_eventDetail$event.id);});return jsxRuntime.jsxs("div",{className:clsx__default["default"](styles['monthly-calendar__cell'],isToday?styles['monthly-calendar__cell--active']:styles['border-gray-4'],isSameMonth?styles['bg-white']:[styles['monthly-calendar__cell--not-current-month']],isOnDetail&&styles['bg-active']),onMouseLeave:function onMouseLeave(){return setIsHovered(false);},style:{height:isHovered?'fit-content':'',boxShadow:isHovered?"0px 4px 16px 0px rgba(0, 0, 0, 0.08)":'',transition:'transform 0.2s ease-in-out',transform:isHovered?'scale(1.03)':'scale(1)',position:isHovered?'absolute':'relative',zIndex:isHovered?1:0,width:isHovered?'184px !important':'100%',top:'0px',left:'0px',minHeight:"100%"},onClick:handleOpenCreateModal,children:[jsxRuntime.jsx("div",{className:styles["monthly-calendar__title-container"],children:jsxRuntime.jsx("span",{className:clsx__default["default"](styles["monthly-calendar__title-container-text"],isSameMonth?styles['text-black']:styles['text-secondary-text']),children:date.format('DD')})}),jsxRuntime.jsxs("ul",{onClick:function onClick(){return onOpenDetail&&onOpenDetail(date.toDate(),events);},children:[(isHovered?events:events.slice(0,2)).map(function(event,index){var _eventDetail$event2;return jsxRuntime.jsx(MonthlyEvent,{event:event,isSameMonth:isSameMonth,onEventDetail:onEventDetail,setEventDetail:setEventDetail,isOnDetail:(eventDetail==null||(_eventDetail$event2=eventDetail.event)==null?void 0:_eventDetail$event2.id)===event.id&&eventDetail.date.isSame(date,'day'),date:date},index);}),!isHovered&&hasMore&&jsxRuntime.jsx(CustomTooltip,{placement:"bottom",title:jsxRuntime.jsx("div",{className:styles['calendar-tooltip'],children:events.slice(2).map(function(event,index){var _eventDetail$event3;return jsxRuntime.jsx(MonthlyEvent,{event:event,isSameMonth:isSameMonth,onEventDetail:onEventDetail,setEventDetail:setEventDetail,isOnDetail:(eventDetail==null||(_eventDetail$event3=eventDetail.event)==null?void 0:_eventDetail$event3.id)===event.id&&eventDetail.date.isSame(date,'day'),date:date},index);})}),children:jsxRuntime.jsxs("div",{className:clsx__default["default"](isSameMonth?styles['text-success']:styles['text-secondary-text']),onMouseEnter:function onMouseEnter(){return setIsHovered(true);},onMouseLeave:function onMouseLeave(){return setIsHovered(false);},children:["+",Math.max(events.length-2,0)," More"]})})]})]});};var getEventsOfWeek=function getEventsOfWeek(events,targetDate){return daysOfWeekKeys.reduce(function(acc,day,index){var currentDate=targetDate.add(index,'day');acc[day]={events:events.filter(function(event){return dayjs__default["default"](event.startDate).isSame(currentDate,'date');}),date:currentDate};return acc;},{});};var getCalendarBoundaries=function getCalendarBoundaries(currentDate){var rawStart=currentDate.startOf('month');var rawEnd=currentDate.endOf('month');// Đảm bảo tuần bắt đầu từ thứ Hai
var startDate=rawStart.day()===0?rawStart.subtract(6,'day')// Chủ nhật -> lùi 6 ngày về thứ 2
:rawStart.subtract(rawStart.day()-1,'day');// Các ngày khác -> lùi về thứ 2
// Đảm bảo tuần kết thúc đến hết Chủ nhật
var endDate=rawEnd.day()===0?rawEnd:rawEnd.add(7-rawEnd.day(),'day');// Tiến tới Chủ nhật gần nhất
return{startDate:startDate,endDate:endDate};};var MonthlyCalendar=function MonthlyCalendar(_ref){var currentDate=_ref.currentDate,events=_ref.events,norms=_ref.norms,showWeeklyNorm=_ref.showWeeklyNorm,onOpenDetail=_ref.onOpenDetail,onOpenCreate=_ref.onOpenCreate,onEventDetail=_ref.onEventDetail,loading=_ref.loading,eventDetail=_ref.eventDetail,setEventDetail=_ref.setEventDetail;var getTableColumns=function getTableColumns(){var weeklyNormColumn={title:jsxRuntime.jsx("div",{className:styles['monthly-calendar__title']+" "+styles['monthly-calendar__title-active'],children:"Weekly Norm"}),dataIndex:'norm',key:'norm',width:'100px',render:function render(value){var normOfWeek=value.normOfWeek,totalNorm=value.totalNorm;return jsxRuntime.jsx("div",{className:styles['weekly-norm__cell'],children:jsxRuntime.jsx("div",{className:clsx__default["default"](styles['weekly-norm__value'],normOfWeek>totalNorm&&styles['!text-error']),children:normOfWeek+"/"+totalNorm})});}};var dayColumns=Object.values(DAYS_OF_WEEK).map(function(day,index){return{title:jsxRuntime.jsx("div",{className:styles['monthly-calendar__title'],children:day.slice(0,3)}),dataIndex:day,key:day,width:'calc((100% - 100px) / 7)',render:function render(value){return jsxRuntime.jsx(MonthlyCell,{events:value.events,date:value.date,currentDate:currentDate,onOpenDetail:onOpenDetail,onOpenCreate:onOpenCreate,onEventDetail:onEventDetail,eventDetail:eventDetail,setEventDetail:setEventDetail},index);}};});return showWeeklyNorm?[weeklyNormColumn].concat(dayColumns):dayColumns;};var getWeeksOfFullMonth=function getWeeksOfFullMonth(startDate,endDate){var weeks=[];var targetDate=startDate.clone();while(targetDate.isBefore(endDate)||targetDate.isSame(endDate,'day')){weeks.push(targetDate);targetDate=targetDate.add(1,'week');}return weeks;};var getTableData=function getTableData(){var _getCalendarBoundarie=getCalendarBoundaries(currentDate),startDate=_getCalendarBoundarie.startDate,endDate=_getCalendarBoundarie.endDate;var weeks=getWeeksOfFullMonth(startDate,endDate);var data=weeks.map(function(week,index){var eventsOfWeek=getEventsOfWeek(events,week);if(!showWeeklyNorm){return _extends({id:index},eventsOfWeek);}return _extends({id:index,norm:calculateNormOfWeek(norms,events,week,week.endOf('week'))},eventsOfWeek);});return data;};return jsxRuntime.jsx(antd.Table,{rowKey:function rowKey(record){return record.id;},columns:getTableColumns(),dataSource:getTableData(),pagination:false,rowHoverable:false,className:styles['monthly-calendar'],loading:loading,tableLayout:'fixed',rowClassName:function rowClassName(record,index){var data=getTableData();return index===data.length-1?'table-row-last':'';}});};var PortalWrapper=function PortalWrapper(_ref){var children=_ref.children,_ref$containerId=_ref.containerId,containerId=_ref$containerId===void 0?'root':_ref$containerId;var container=document.getElementById(containerId);return container?reactDom.createPortal(children,container):null;};var LMSHeaderCalendarTablet=function LMSHeaderCalendarTablet(_ref){var _clsx;var title=_ref.title,showTeacherName=_ref.showTeacherName,currentDate=_ref.currentDate,setCurrentDate=_ref.setCurrentDate,calendarMode=_ref.calendarMode,setCalendarMode=_ref.setCalendarMode,toggleTurnOnFilter=_ref.toggleTurnOnFilter,filter=_ref.filter,hasFilter=_ref.hasFilter,filterComponent=_ref.filterComponent;var handleChangeMode=function handleChangeMode(mode){setCalendarMode(mode);setCurrentDate(dayjs__default["default"]());};var handleGoToToday=function handleGoToToday(){setCurrentDate(dayjs__default["default"]());};var handleGoToPrevious=function handleGoToPrevious(){setCurrentDate(currentDate.subtract(1,calendarMode));};var handleGoToNext=function handleGoToNext(){setCurrentDate(currentDate.add(1,calendarMode));};var calendarModeOptions=[{value:'month',label:'Month'},{value:'week',label:'Week'}];// ✅ Tối ưu hóa tính toán tháng/năm với useMemo
var _useMemo=React.useMemo(function(){return extractMonthYear(dayjs__default["default"](currentDate.valueOf()));},[currentDate]),month=_useMemo.month,year=_useMemo.year;var _useMemo2=React.useMemo(function(){return extractWeek(dayjs__default["default"](currentDate.valueOf()));},[currentDate]),startDateDisplay=_useMemo2.startDateDisplay,endDateDisplay=_useMemo2.endDateDisplay,weekYear=_useMemo2.year;return jsxRuntime.jsxs(jsxRuntime.Fragment,{children:[jsxRuntime.jsxs(PortalWrapper,{containerId:'calendar-root',children:[jsxRuntime.jsx("div",{className:styles['header-calendar__tablet'],children:jsxRuntime.jsxs("div",{className:styles['header-calendar__controls'],children:[hasFilter&&jsxRuntime.jsx("div",{className:clsx__default["default"](styles['hover-item'],styles['btn-icon'],(_clsx={},_clsx[styles['text-lms-primary']]=filter.isOpen,_clsx[styles['btn--active']]=filter.isOpen,_clsx['pointer-events-none']=filter.isOpen,_clsx)),onClick:toggleTurnOnFilter,children:jsxRuntime.jsx(FilterIcon,{})}),jsxRuntime.jsx(CustomDatePicker,{currentDate:currentDate,setCurrentDate:setCurrentDate,calendarMode:calendarMode}),jsxRuntime.jsxs("div",{className:"flex gap-[6px] items-center",children:[jsxRuntime.jsx(SelectBox,{value:calendarMode,options:calendarModeOptions,className:"filter-select__mode",onChange:function onChange(mode){return handleChangeMode(mode);},suffixIcon:jsxRuntime.jsx(DropDownIcon,{})}),jsxRuntime.jsx(antd.Divider,{type:'vertical',className:'h-4 !mx-3'}),jsxRuntime.jsx(Button$1,{color:"lms-default",onClick:handleGoToToday,children:"Today"})]})]})}),filterComponent]}),jsxRuntime.jsx("div",{className:styles['header-calendar'],children:jsxRuntime.jsxs("div",{className:styles['header-calendar__nav'],children:[jsxRuntime.jsx(Icon,{icon:jsxRuntime.jsx(LeftArrowIcon,{}),onClick:handleGoToPrevious}),jsxRuntime.jsxs("div",{className:styles['header-calendar__date'],"data-testid":"header-date",children:[calendarMode==='week'&&jsxRuntime.jsxs(jsxRuntime.Fragment,{children:[jsxRuntime.jsxs("span",{className:styles['header-calendar__week'],children:[startDateDisplay," - ",endDateDisplay,",",' ']}),jsxRuntime.jsx("span",{className:styles['header-calendar__year'],children:weekYear})]}),calendarMode==='month'&&jsxRuntime.jsxs(jsxRuntime.Fragment,{children:[jsxRuntime.jsxs("span",{className:styles['header-calendar__month'],children:[month,", "]}),jsxRuntime.jsx("span",{className:styles['header-calendar__year'],children:year})]})]}),jsxRuntime.jsx(Icon,{icon:jsxRuntime.jsx(RightArrowIcon,{}),onClick:handleGoToNext})]})}),showTeacherName&&jsxRuntime.jsx("div",{className:styles['header-calendar__title'],children:title})]});};var MonthlyCalendarMobile=function MonthlyCalendarMobile(_ref){var currentDate=_ref.currentDate,events=_ref.events,onSelectDate=_ref.onSelectDate,selectedDate=_ref.selectedDate;var calendarRef=React.useRef(null);var _useState=React.useState(currentDate),displayedMonth=_useState[0],setDisplayedMonth=_useState[1];React.useEffect(function(){setDisplayedMonth(currentDate);},[currentDate]);React.useEffect(function(){if(!calendarRef.current)return;// Tìm tất cả các tr trong calendar
var trs=calendarRef.current.querySelectorAll('tr');trs.forEach(function(tr){var divs=tr.querySelectorAll('td > div');var allSelectNone=Array.from(divs).every(function(div){return div.classList.contains('select-none');});if(divs.length>0&&allSelectNone){tr.remove();}});},[displayedMonth,events]);return jsxRuntime.jsx(antd.ConfigProvider,{locale:enUS__default["default"],children:jsxRuntime.jsx("div",{ref:calendarRef,children:jsxRuntime.jsx(antd.Calendar,{className:'monthly-calendar__mobile',value:currentDate,onSelect:function onSelect(date){return onSelectDate==null?void 0:onSelectDate(date);},onPanelChange:function onPanelChange(date){return setDisplayedMonth(date);},dateFullCellRender:function dateFullCellRender(date){var day=date.date();var isToday=dayjs__default["default"]().isSame(date,'day');var isSelected=(selectedDate==null?void 0:selectedDate.isSame(date,'day'))||false;var isCurrentMonth=date.month()===displayedMonth.month()&&date.year()===displayedMonth.year();// Check if this date has events
var hasEvents=events.some(function(event){return dayjs__default["default"](event.startDate).isSame(date,'day');});if(!isCurrentMonth){// Ẩn ngày không thuộc tháng hiện tại
return jsxRuntime.jsx("div",{className:"pointer-events-none select-none"});}return jsxRuntime.jsxs("div",{className:"custom-date-cell cursor-pointer",onClick:function onClick(){return onSelectDate==null?void 0:onSelectDate(date);},style:{display:'flex',height:'34px',borderRadius:'50%',width:'100%',flexDirection:'column',gap:'2px',alignItems:'center',justifyContent:'start'},children:[jsxRuntime.jsx("div",{style:{fontWeight:500,borderRadius:'100px',background:isSelected?'#FFF1CC':'',color:isToday?'#FFB700':isSelected?'#FFB700':'#1F2937',width:'28px',height:'28px',padding:'4px',display:'flex',justifyContent:'center',alignItems:'center',fontSize:'12px',lineHeight:'22px'},children:day.toString().padStart(2,'0')}),hasEvents&&jsxRuntime.jsx("div",{style:{width:4,height:4,borderRadius:'50%',backgroundColor:'#FFB700'}})]});},fullscreen:true})})});};var CalendarDrawerMobile=function CalendarDrawerMobile(_ref){var open=_ref.open,onClose=_ref.onClose,title=_ref.title,children=_ref.children;return jsxRuntime.jsx(antd.Drawer,{placement:"bottom",open:open,onClose:onClose,height:"auto",closable:false,rootClassName:"calendar-drawer",className:"rounded-xl",children:jsxRuntime.jsxs("div",{className:"p-4",children:[jsxRuntime.jsxs("div",{className:"flex justify-between items-center",children:[jsxRuntime.jsx("div",{className:"text-xl font-semibold leading-7",children:title}),jsxRuntime.jsx("div",{onClick:onClose,children:jsxRuntime.jsx(CloseIcon$1,{})})]}),jsxRuntime.jsx(antd.Divider,{className:"my-4"}),children]})});};var SelectMobile=function SelectMobile(_ref){var open=_ref.open,onClose=_ref.onClose,onConfirm=_ref.onConfirm,_ref$defaultValue=_ref.defaultValue,defaultValue=_ref$defaultValue===void 0?'Month':_ref$defaultValue,options=_ref.options;var _useState=React.useState(defaultValue),value=_useState[0],setValue=_useState[1];var handleSelect=function handleSelect(option){setValue(option);};return jsxRuntime.jsxs(CalendarDrawerMobile,{title:"Filter",open:open,onClose:onClose,children:[jsxRuntime.jsx("div",{className:"flex flex-col gap-4",children:options.map(function(option){var isSelected=value===option.value;return jsxRuntime.jsxs("div",{className:"flex justify-between items-center px-1",onClick:function onClick(){return handleSelect(option.value);},children:[jsxRuntime.jsx("span",{className:"text-sm font-medium "+(isSelected?'text-[#FFB700]':'text-[#1F2937]'),children:option.label}),isSelected&&jsxRuntime.jsx(CheckIcon$1,{})]},option.value);})}),jsxRuntime.jsx("div",{className:"mt-6",children:jsxRuntime.jsx(Button$1,{color:"primary",fullWidth:true,onClick:function onClick(){onConfirm(value);onClose();},children:"Confirm"})})]});};var LMSHeaderCalendarMobile=function LMSHeaderCalendarMobile(_ref){var _clsx;var title=_ref.title,showTeacherName=_ref.showTeacherName,currentDate=_ref.currentDate,setCurrentDate=_ref.setCurrentDate,calendarMode=_ref.calendarMode,setCalendarMode=_ref.setCalendarMode,toggleTurnOnFilter=_ref.toggleTurnOnFilter,filter=_ref.filter,hasFilter=_ref.hasFilter;var _useState=React.useState(false),openSelectModeMobile=_useState[0],setOpenSelectModeMobile=_useState[1];var handleChangeMode=function handleChangeMode(mode){setCalendarMode(mode);setCurrentDate(dayjs__default["default"]());};var handleGoToPrevious=function handleGoToPrevious(){setCurrentDate(currentDate.subtract(1,calendarMode));};var handleGoToNext=function handleGoToNext(){setCurrentDate(currentDate.add(1,calendarMode));};var calendarModeOptions=[{value:'month',label:'Month'},{value:'week',label:'Week'}];// ✅ Tối ưu hóa tính toán tháng/năm với useMemo
var _useMemo=React.useMemo(function(){return extractMonthYear(dayjs__default["default"](currentDate.valueOf()));},[currentDate]),month=_useMemo.month,year=_useMemo.year;var _useMemo2=React.useMemo(function(){return extractWeek(dayjs__default["default"](currentDate.valueOf()));},[currentDate]),startDateDisplay=_useMemo2.startDateDisplay,endDateDisplay=_useMemo2.endDateDisplay,weekYear=_useMemo2.year;return jsxRuntime.jsxs(jsxRuntime.Fragment,{children:[jsxRuntime.jsx(PortalWrapper,{containerId:'calendar-root',children:jsxRuntime.jsx("div",{className:styles['header-calendar__mobile'],children:jsxRuntime.jsx("div",{className:styles['header-calendar__controls'],children:hasFilter&&jsxRuntime.jsx("div",{className:clsx__default["default"](styles['hover-item'],(_clsx={},_clsx[styles['text-lms-primary']]=filter.isOpen,_clsx['pointer-events-none']=filter.isOpen,_clsx)),onClick:toggleTurnOnFilter,children:jsxRuntime.jsx(FilterIcon,{})})})})}),jsxRuntime.jsxs("div",{className:"flex justify-between items-center mx-1 mb-5",children:[jsxRuntime.jsxs("div",{className:styles['header-calendar__nav'],children:[jsxRuntime.jsx(Icon,{icon:jsxRuntime.jsx(LeftArrowIcon,{}),onClick:handleGoToPrevious}),jsxRuntime.jsxs("div",{className:styles['header-calendar__date'],"data-testid":"header-date",children:[calendarMode==='week'&&jsxRuntime.jsxs(jsxRuntime.Fragment,{children:[jsxRuntime.jsxs("span",{className:styles['header-calendar__week'],children:[startDateDisplay," - ",endDateDisplay,",",' ']}),jsxRuntime.jsx("span",{className:styles['header-calendar__year'],children:weekYear})]}),calendarMode==='month'&&jsxRuntime.jsxs(jsxRuntime.Fragment,{children:[jsxRuntime.jsxs("span",{className:styles['header-calendar__month'],children:[month,", "]}),jsxRuntime.jsx("span",{className:styles['header-calendar__year'],children:year})]})]}),jsxRuntime.jsx(Icon,{icon:jsxRuntime.jsx(RightArrowIcon,{}),onClick:handleGoToNext})]}),jsxRuntime.jsx(SelectBox,{open:false,value:calendarMode,options:calendarModeOptions,className:"filter-select__mode",onClick:function onClick(){return setOpenSelectModeMobile(true);},onChange:function onChange(mode){return handleChangeMode(mode);},suffixIcon:jsxRuntime.jsx(DropDownIcon,{size:16})})]}),jsxRuntime.jsx(SelectMobile,{defaultValue:calendarModeOptions[0].value,options:calendarModeOptions,open:openSelectModeMobile,onClose:function onClose(){return setOpenSelectModeMobile(false);},onConfirm:function onConfirm(mode){return handleChangeMode(mode);}}),showTeacherName&&jsxRuntime.jsx("div",{className:styles['header-calendar__title'],children:title})]});};var FilterCalendarMobile=function FilterCalendarMobile(_ref){var open=_ref.open,onClose=_ref.onClose,filter=_ref.filter,setFilter=_ref.setFilter,onRefetchAPI=_ref.onRefetchAPI;var _useState=React.useState(filter),tempFilter=_useState[0],setTempFilter=_useState[1];React.useEffect(function(){setTempFilter(filter);},[filter]);var noteFilter=React.useMemo(function(){return[{title:'Online',icon:jsxRuntime.jsx("div",{className:styles$1['calendar-filter_note_blue']}),value:LEARNING_MODE.ONLINE},{title:'Live Online',icon:jsxRuntime.jsx("div",{className:styles$1['calendar-filter_note_pureple']}),value:LEARNING_MODE.LIVE_ONLINE},{title:'Offline',icon:jsxRuntime.jsx("div",{className:styles$1['calendar-filter_note_green']}),value:LEARNING_MODE.OFFLINE},{title:'Holiday',icon:jsxRuntime.jsx("div",{className:styles$1['calendar-filter_note_yellow']}),value:LEARNING_MODE.HOLIDAY},{title:'Overdue',icon:jsxRuntime.jsx("div",{className:styles$1['calendar-filter_note_red']}),value:LEARNING_MODE.OVERDUE},{title:'Test',icon:jsxRuntime.jsx(TestIcon,{}),value:LEARNING_MODE.TEST},{title:'Case Study',icon:jsxRuntime.jsx(CaseStudyIcon,{}),value:LEARNING_MODE.CASE_STUDY},{title:'Key Content Before',icon:jsxRuntime.jsx(FlagIcon,{}),value:LEARNING_MODE.KEY_BEFORE_CONTENT}];},[]);var handleTempFilter=function handleTempFilter(value){setTempFilter(function(prev){var _prev$type;var updated=(_prev$type=prev.type)!=null&&_prev$type.includes(value)?prev.type.filter(function(item){return item!==value;}):[].concat(prev.type||[],[value]);return _extends({},prev,{type:updated});});};var handleConfirm=function handleConfirm(){setFilter(_extends({},tempFilter,{isOpen:false}));if(tempFilter.day){onRefetchAPI(dayjs__default["default"](tempFilter.day).toDate());}onClose();};return jsxRuntime.jsxs(CalendarDrawerMobile,{title:'Sort Filter',open:open,onClose:onClose,children:[jsxRuntime.jsx("div",{className:"flex flex-col gap-4",children:noteFilter.map(function(item){var _tempFilter$type;return jsxRuntime.jsxs("div",{className:"flex items-center justify-start gap-2",onClick:function onClick(){return handleTempFilter(item.value);},children:[jsxRuntime.jsx(antd.Checkbox,{checked:(_tempFilter$type=tempFilter.type)==null?void 0:_tempFilter$type.includes(item.value),className:styles$1['custom-checkbox']}),jsxRuntime.jsxs("div",{className:"flex items-center gap-2",children:[item.icon,jsxRuntime.jsx("span",{children:item.title})]})]},item.value);})}),jsxRuntime.jsx("div",{className:"mt-4",children:jsxRuntime.jsx(Button$1,{color:"primary",fullWidth:true,onClick:handleConfirm,children:"Confirm"})})]});};var ListEventInDayMobile=function ListEventInDayMobile(_ref){var _ref$events=_ref.events,events=_ref$events===void 0?[]:_ref$events,_ref$selectedDate=_ref.selectedDate,selectedDate=_ref$selectedDate===void 0?new Date():_ref$selectedDate,onEventDetail=_ref.onEventDetail,eventDetail=_ref.eventDetail,setEventDetail=_ref.setEventDetail;var eventsInDay=React.useMemo(function(){var targetDate=dayjs__default["default"](selectedDate);return events.filter(function(event){var eventDate=dayjs__default["default"](event.startDate);return eventDate.isSame(targetDate,'day');});},[events,selectedDate]);if(eventsInDay.length===0){return jsxRuntime.jsx("div",{className:"h-full"});}return jsxRuntime.jsx("div",{className:"flex flex-col gap-2 h-full",children:eventsInDay.map(function(event){var _eventDetail$event;return jsxRuntime.jsx(MonthlyEvent,{event:event,isSameMonth:true,onEventDetail:onEventDetail,isOnDetail:event.id===(eventDetail==null||(_eventDetail$event=eventDetail.event)==null?void 0:_eventDetail$event.id),setEventDetail:setEventDetail,date:dayjs__default["default"](selectedDate)},event.id);})});};dayjs__default["default"].extend(updateLocale__default["default"]);dayjs__default["default"].updateLocale('en',{weekStart:1});var SAPPCalendar=function SAPPCalendar(_ref){var teacherName=_ref.teacherName,events=_ref.events,_ref$norms=_ref.norms,norms=_ref$norms===void 0?[]:_ref$norms,_ref$showTeacherName=_ref.showTeacherName,showTeacherName=_ref$showTeacherName===void 0?true:_ref$showTeacherName,_ref$showWeeklyNorm=_ref.showWeeklyNorm,showWeeklyNorm=_ref$showWeeklyNorm===void 0?true:_ref$showWeeklyNorm,onOpenDetail=_ref.onOpenDetail,onOpenCreate=_ref.onOpenCreate,onRefetchAPI=_ref.onRefetchAPI,onEventDetail=_ref.onEventDetail,loading=_ref.loading,_ref$type=_ref.type,type=_ref$type===void 0?'OPS':_ref$type,courses=_ref.courses,onfilter=_ref.onfilter,_ref$hasFilter=_ref.hasFilter,hasFilter=_ref$hasFilter===void 0?false:_ref$hasFilter,_ref$headerType=_ref.headerType,headerType=_ref$headerType===void 0?CALENDAR_TYPE.OPS:_ref$headerType;var _useState=React.useState(dayjs__default["default"]()),currentDate=_useState[0],setCurrentDate=_useState[1];var _useState2=React.useState(dayjs__default["default"]()),selectedDate=_useState2[0],setSelectedDate=_useState2[1];var _useState3=React.useState('month'),calendarMode=_useState3[0],setCalendarMode=_useState3[1];var _useState4=React.useState({courseId:courses?courses.map(function(item){return item.id;}):[],isOpen:false,type:Object.values(LEARNING_MODE),day:''}),filter=_useState4[0],setFilter=_useState4[1];var deviceType=useDeviceType();var _useState5=React.useState(null),eventDetail=_useState5[0],setEventDetail=_useState5[1];var filterRef=React.useRef(null);var startDate=React.useMemo(function(){return currentDate.startOf(calendarMode).startOf('week');},[currentDate,calendarMode]);var endDate=React.useMemo(function(){return currentDate.endOf(calendarMode).endOf('week');},[currentDate,calendarMode]);var splittedEvents=splitEventsIntoDays(events);splittedEvents.sort(function(a,b){return dayjs__default["default"](a.startDate).diff(b.startDate);});var handleFilterDate=function handleFilterDate(date){setCurrentDate(date);};React.useEffect(function(){onfilter&&onfilter(filter);},[filter]);useEffectAfterMounted(function(){onRefetchAPI(startDate.toDate(),endDate.toDate());},[startDate,endDate]);React.useEffect(function(){setFilter(function(prev){return _extends({},prev,{courseId:courses?courses.map(function(item){return item.id;}):[]});});},[courses]);React.useEffect(function(){var handleClickOutside=function handleClickOutside(event){if(filterRef.current&&!filterRef.current.contains(event.target)){setFilter(function(prev){return _extends({},prev,{isOpen:false});});}};if(filter.isOpen){document.addEventListener('mousedown',handleClickOutside);}return function(){document.removeEventListener('mousedown',handleClickOutside);};},[filter.isOpen]);return jsxRuntime.jsx("div",{className:styles['sapp-calendar'],children:jsxRuntime.jsxs("div",{className:clsx__default["default"](styles['sapp-calendar__container'],'max-w-[703px] md:max-w-full'),children:[headerType===CALENDAR_TYPE.LMS?jsxRuntime.jsxs("div",{className:"relative",children:[deviceType==='desktop'&&jsxRuntime.jsx(LMSHeaderCalendar,{title:teacherName,showTeacherName:showTeacherName,currentDate:currentDate,setCurrentDate:setCurrentDate,calendarMode:calendarMode,setCalendarMode:setCalendarMode,toggleTurnOnFilter:function toggleTurnOnFilter(){if(!filter.isOpen){setFilter(function(prev){return _extends({},prev,{isOpen:!filter.isOpen});});}},hasFilter:hasFilter,filter:filter}),deviceType==='tablet'&&jsxRuntime.jsx(LMSHeaderCalendarTablet,{title:teacherName,showTeacherName:showTeacherName,currentDate:currentDate,setCurrentDate:setCurrentDate,calendarMode:calendarMode,setCalendarMode:setCalendarMode,toggleTurnOnFilter:function toggleTurnOnFilter(){if(!filter.isOpen){setFilter(function(prev){return _extends({},prev,{isOpen:!filter.isOpen});});}},hasFilter:hasFilter,filter:filter,filterComponent:filter.isOpen?jsxRuntime.jsx(FilterCalendar,{ref:filterRef,filter:filter,courses:courses,setFilter:setFilter,onRefetchAPI:function onRefetchAPI(date){return handleFilterDate(dayjs__default["default"](date));}}):null}),deviceType==='mobile'&&jsxRuntime.jsx(LMSHeaderCalendarMobile,{title:teacherName,showTeacherName:showTeacherName,currentDate:currentDate,setCurrentDate:setCurrentDate,calendarMode:calendarMode,setCalendarMode:setCalendarMode,toggleTurnOnFilter:function toggleTurnOnFilter(){if(!filter.isOpen){setFilter(function(prev){return _extends({},prev,{isOpen:!filter.isOpen});});}},hasFilter:hasFilter,filter:filter}),filter.isOpen&&deviceType==='desktop'&&jsxRuntime.jsx(FilterCalendar,{ref:filterRef,filter:filter,courses:courses,setFilter:setFilter,onRefetchAPI:function onRefetchAPI(date){return handleFilterDate(dayjs__default["default"](date));}}),jsxRuntime.jsx(FilterCalendarMobile,{open:filter.isOpen&&deviceType==='mobile',onClose:function onClose(){return setFilter(function(prev){return _extends({},prev,{isOpen:!filter.isOpen});});},filter:filter,courses:courses,setFilter:setFilter,onRefetchAPI:function onRefetchAPI(date){return handleFilterDate(dayjs__default["default"](date));}})]}):jsxRuntime.jsx(HeaderCalendar,{title:teacherName,showTeacherName:showTeacherName,currentDate:currentDate,setCurrentDate:setCurrentDate,calendarMode:calendarMode,setCalendarMode:setCalendarMode}),calendarMode==='month'&&(deviceType==='desktop'||deviceType==='tablet'?jsxRuntime.jsxs(jsxRuntime.Fragment,{children:[jsxRuntime.jsx(CalendarLegend,{}),jsxRuntime.jsx(MonthlyCalendar,{currentDate:currentDate,startDate:startDate,endDate:endDate,events:splittedEvents,norms:norms,showWeeklyNorm:showWeeklyNorm,onOpenDetail:onOpenDetail,onOpenCreate:onOpenCreate,onEventDetail:onEventDetail,loading:loading,eventDetail:eventDetail,setEventDetail:setEventDetail})]}):jsxRuntime.jsxs("div",{className:'flex flex-col h-full gap-4',children:[jsxRuntime.jsx(MonthlyCalendarMobile,{currentDate:currentDate,events:splittedEvents,onOpenDetail:onOpenDetail,onOpenCreate:onOpenCreate,onEventDetail:onEventDetail,loading:loading,onSelectDate:setSelectedDate,selectedDate:selectedDate}),jsxRuntime.jsx("div",{className:"flex-1",children:jsxRuntime.jsx(ListEventInDayMobile,{events:splittedEvents,selectedDate:selectedDate.toDate(),onEventDetail:onEventDetail,eventDetail:eventDetail,setEventDetail:setEventDetail})}),jsxRuntime.jsx(CalendarLegend,{})]})),calendarMode==='week'&&type===CALENDAR_TYPE.LMS&&jsxRuntime.jsxs(jsxRuntime.Fragment,{children:[(deviceType==='desktop'||deviceType==='tablet')&&jsxRuntime.jsx(CalendarLegend,{}),jsxRuntime.jsx(LMSModeWeeklyCalendar,{startDate:startDate,endDate:endDate,events:splittedEvents,norms:norms,showWeeklyNorm:showWeeklyNorm,onOpenDetail:onOpenDetail,onOpenCreate:onOpenCreate,onEventDetail:onEventDetail,loading:loading,eventDetail:eventDetail,setEventDetail:setEventDetail}),deviceType==='mobile'&&jsxRuntime.jsx("div",{className:"mt-auto pt-2",children:jsxRuntime.jsx(CalendarLegend,{})})]}),calendarMode==='week'&&type===CALENDAR_TYPE.OPS&&jsxRuntime.jsx(WeeklyCalendar,{startDate:startDate,endDate:endDate,events:splittedEvents,norms:norms,showWeeklyNorm:showWeeklyNorm,onOpenDetail:onOpenDetail,onOpenCreate:onOpenCreate,onEventDetail:onEventDetail,loading:loading})]})});};/**
 * Takes a Transaction & Editor State and turns it into a chainable state object
 * @param config The transaction and state to create the chainable state from
 * @returns A chainable Editor state object
 */function createChainableState(config){const{state,transaction}=config;let{selection}=transaction;let{doc}=transaction;let{storedMarks}=transaction;return{...state,apply:state.apply.bind(state),applyTransaction:state.applyTransaction.bind(state),plugins:state.plugins,schema:state.schema,reconfigure:state.reconfigure.bind(state),toJSON:state.toJSON.bind(state),get storedMarks(){return storedMarks;},get selection(){return selection;},get doc(){return doc;},get tr(){selection=transaction.selection;doc=transaction.doc;storedMarks=transaction.storedMarks;return transaction;}};}class CommandManager{constructor(props){this.editor=props.editor;this.rawCommands=this.editor.extensionManager.commands;this.customState=props.state;}get hasCustomState(){return!!this.customState;}get state(){return this.customState||this.editor.state;}get commands(){const{rawCommands,editor,state}=this;const{view}=editor;const{tr}=state;const props=this.buildProps(tr);return Object.fromEntries(Object.entries(rawCommands).map(([name,command])=>{const method=(...args)=>{const callback=command(...args)(props);if(!tr.getMeta('preventDispatch')&&!this.hasCustomState){view.dispatch(tr);}return callback;};return[name,method];}));}get chain(){return()=>this.createChain();}get can(){return()=>this.createCan();}createChain(startTr,shouldDispatch=true){const{rawCommands,editor,state}=this;const{view}=editor;const callbacks=[];const hasStartTransaction=!!startTr;const tr=startTr||state.tr;const run=()=>{if(!hasStartTransaction&&shouldDispatch&&!tr.getMeta('preventDispatch')&&!this.hasCustomState){view.dispatch(tr);}return callbacks.every(callback=>callback===true);};const chain={...Object.fromEntries(Object.entries(rawCommands).map(([name,command])=>{const chainedCommand=(...args)=>{const props=this.buildProps(tr,shouldDispatch);const callback=command(...args)(props);callbacks.push(callback);return chain;};return[name,chainedCommand];})),run};return chain;}createCan(startTr){const{rawCommands,state}=this;const dispatch=false;const tr=startTr||state.tr;const props=this.buildProps(tr,dispatch);const formattedCommands=Object.fromEntries(Object.entries(rawCommands).map(([name,command])=>{return[name,(...args)=>command(...args)({...props,dispatch:undefined})];}));return{...formattedCommands,chain:()=>this.createChain(tr,dispatch)};}buildProps(tr,shouldDispatch=true){const{rawCommands,editor,state}=this;const{view}=editor;const props={tr,editor,view,state:createChainableState({state,transaction:tr}),dispatch:shouldDispatch?()=>undefined:undefined,chain:()=>this.createChain(tr,shouldDispatch),can:()=>this.createCan(tr),get commands(){return Object.fromEntries(Object.entries(rawCommands).map(([name,command])=>{return[name,(...args)=>command(...args)(props)];}));}};return props;}}/**
 * Returns a field from an extension
 * @param extension The Tiptap extension
 * @param field The field, for example `renderHTML` or `priority`
 * @param context The context object that should be passed as `this` into the function
 * @returns The field value
 */function getExtensionField(extension,field,context){if(extension.config[field]===undefined&&extension.parent){return getExtensionField(extension.parent,field,context);}if(typeof extension.config[field]==='function'){const value=extension.config[field].bind({...context,parent:extension.parent?getExtensionField(extension.parent,field,context):null});return value;}return extension.config[field];}function splitExtensions(extensions){const baseExtensions=extensions.filter(extension=>extension.type==='extension');const nodeExtensions=extensions.filter(extension=>extension.type==='node');const markExtensions=extensions.filter(extension=>extension.type==='mark');return{baseExtensions,nodeExtensions,markExtensions};}function getNodeType(nameOrType,schema){if(typeof nameOrType==='string'){if(!schema.nodes[nameOrType]){throw Error(`There is no node type named '${nameOrType}'. Maybe you forgot to add the extension?`);}return schema.nodes[nameOrType];}return nameOrType;}function mergeAttributes(...objects){return objects.filter(item=>!!item).reduce((items,item)=>{const mergedAttributes={...items};Object.entries(item).forEach(([key,value])=>{const exists=mergedAttributes[key];if(!exists){mergedAttributes[key]=value;return;}if(key==='class'){const valueClasses=value?String(value).split(' '):[];const existingClasses=mergedAttributes[key]?mergedAttributes[key].split(' '):[];const insertClasses=valueClasses.filter(valueClass=>!existingClasses.includes(valueClass));mergedAttributes[key]=[...existingClasses,...insertClasses].join(' ');}else if(key==='style'){const newStyles=value?value.split(';').map(style=>style.trim()).filter(Boolean):[];const existingStyles=mergedAttributes[key]?mergedAttributes[key].split(';').map(style=>style.trim()).filter(Boolean):[];const styleMap=new Map();existingStyles.forEach(style=>{const[property,val]=style.split(':').map(part=>part.trim());styleMap.set(property,val);});newStyles.forEach(style=>{const[property,val]=style.split(':').map(part=>part.trim());styleMap.set(property,val);});mergedAttributes[key]=Array.from(styleMap.entries()).map(([property,val])=>`${property}: ${val}`).join('; ');}else{mergedAttributes[key]=value;}});return mergedAttributes;},{});}// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function isFunction(value){return typeof value==='function';}/**
 * Optionally calls `value` as a function.
 * Otherwise it is returned directly.
 * @param value Function or any value.
 * @param context Optional context to bind to function.
 * @param props Optional props to pass to function.
 */function callOrReturn(value,context=undefined,...props){if(isFunction(value)){if(context){return value.bind(context)(...props);}return value(...props);}return value;}function isRegExp(value){return Object.prototype.toString.call(value)==='[object RegExp]';}// see: https://github.com/mesqueeb/is-what/blob/88d6e4ca92fb2baab6003c54e02eedf4e729e5ab/src/index.ts
function getType(value){return Object.prototype.toString.call(value).slice(8,-1);}function isPlainObject(value){if(getType(value)!=='Object'){return false;}return value.constructor===Object&&Object.getPrototypeOf(value)===Object.prototype;}function mergeDeep(target,source){const output={...target};if(isPlainObject(target)&&isPlainObject(source)){Object.keys(source).forEach(key=>{if(isPlainObject(source[key])&&isPlainObject(target[key])){output[key]=mergeDeep(target[key],source[key]);}else{output[key]=source[key];}});}return output;}/**
 * The Extension class is the base class for all extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */class Extension{constructor(config={}){this.type='extension';this.name='extension';this.parent=null;this.child=null;this.config={name:this.name,defaultOptions:{}};this.config={...this.config,...config};this.name=this.config.name;if(config.defaultOptions&&Object.keys(config.defaultOptions).length>0){console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);}// TODO: remove `addOptions` fallback
this.options=this.config.defaultOptions;if(this.config.addOptions){this.options=callOrReturn(getExtensionField(this,'addOptions',{name:this.name}));}this.storage=callOrReturn(getExtensionField(this,'addStorage',{name:this.name,options:this.options}))||{};}static create(config={}){return new Extension(config);}configure(options={}){// return a new instance so we can use the same extension
// with different calls of `configure`
const extension=this.extend({...this.config,addOptions:()=>{return mergeDeep(this.options,options);}});// Always preserve the current name
extension.name=this.name;// Set the parent to be our parent
extension.parent=this.parent;return extension;}extend(extendedConfig={}){const extension=new Extension({...this.config,...extendedConfig});extension.parent=this;this.child=extension;extension.name=extendedConfig.name?extendedConfig.name:extension.parent.name;if(extendedConfig.defaultOptions&&Object.keys(extendedConfig.defaultOptions).length>0){console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);}extension.options=callOrReturn(getExtensionField(extension,'addOptions',{name:extension.name}));extension.storage=callOrReturn(getExtensionField(extension,'addStorage',{name:extension.name,options:extension.options}));return extension;}}/**
 * Gets the text between two positions in a Prosemirror node
 * and serializes it using the given text serializers and block separator (see getText)
 * @param startNode The Prosemirror node to start from
 * @param range The range of the text to get
 * @param options Options for the text serializer & block separator
 * @returns The text between the two positions
 */function getTextBetween(startNode,range,options){const{from,to}=range;const{blockSeparator='\n\n',textSerializers={}}=options||{};let text='';startNode.nodesBetween(from,to,(node,pos,parent,index)=>{var _a;if(node.isBlock&&pos>from){text+=blockSeparator;}const textSerializer=textSerializers===null||textSerializers===void 0?void 0:textSerializers[node.type.name];if(textSerializer){if(parent){text+=textSerializer({node,pos,parent,index,range});}// do not descend into child nodes when there exists a serializer
return false;}if(node.isText){text+=(_a=node===null||node===void 0?void 0:node.text)===null||_a===void 0?void 0:_a.slice(Math.max(from,pos)-pos,to-pos);// eslint-disable-line
}});return text;}/**
 * Find text serializers `toText` in a Prosemirror schema
 * @param schema The Prosemirror schema to search in
 * @returns A record of text serializers by node name
 */function getTextSerializersFromSchema(schema){return Object.fromEntries(Object.entries(schema.nodes).filter(([,node])=>node.spec.toText).map(([name,node])=>[name,node.spec.toText]));}Extension.create({name:'clipboardTextSerializer',addOptions(){return{blockSeparator:undefined};},addProseMirrorPlugins(){return[new state.Plugin({key:new state.PluginKey('clipboardTextSerializer'),props:{clipboardTextSerializer:()=>{const{editor}=this;const{state,schema}=editor;const{doc,selection}=state;const{ranges}=selection;const from=Math.min(...ranges.map(range=>range.$from.pos));const to=Math.max(...ranges.map(range=>range.$to.pos));const textSerializers=getTextSerializersFromSchema(schema);const range={from,to};return getTextBetween(doc,range,{...(this.options.blockSeparator!==undefined?{blockSeparator:this.options.blockSeparator}:{}),textSerializers});}}})];}});const blur=()=>({editor,view})=>{requestAnimationFrame(()=>{var _a;if(!editor.isDestroyed){view.dom.blur();// Browsers should remove the caret on blur but safari does not.
// See: https://github.com/ueberdosis/tiptap/issues/2405
(_a=window===null||window===void 0?void 0:window.getSelection())===null||_a===void 0?void 0:_a.removeAllRanges();}});return true;};const clearContent=(emitUpdate=false)=>({commands})=>{return commands.setContent('',emitUpdate);};const clearNodes=()=>({state,tr,dispatch})=>{const{selection}=tr;const{ranges}=selection;if(!dispatch){return true;}ranges.forEach(({$from,$to})=>{state.doc.nodesBetween($from.pos,$to.pos,(node,pos)=>{if(node.type.isText){return;}const{doc,mapping}=tr;const $mappedFrom=doc.resolve(mapping.map(pos));const $mappedTo=doc.resolve(mapping.map(pos+node.nodeSize));const nodeRange=$mappedFrom.blockRange($mappedTo);if(!nodeRange){return;}const targetLiftDepth=transform.liftTarget(nodeRange);if(node.type.isTextblock){const{defaultType}=$mappedFrom.parent.contentMatchAt($mappedFrom.index());tr.setNodeMarkup(nodeRange.start,defaultType);}if(targetLiftDepth||targetLiftDepth===0){tr.lift(nodeRange,targetLiftDepth);}});});return true;};const command=fn=>props=>{return fn(props);};const createParagraphNear=()=>({state,dispatch})=>{return commands$1.createParagraphNear(state,dispatch);};const cut=(originRange,targetPos)=>({editor,tr})=>{const{state:state$1}=editor;const contentSlice=state$1.doc.slice(originRange.from,originRange.to);tr.deleteRange(originRange.from,originRange.to);const newPos=tr.mapping.map(targetPos);tr.insert(newPos,contentSlice.content);tr.setSelection(new state.TextSelection(tr.doc.resolve(newPos-1)));return true;};const deleteCurrentNode=()=>({tr,dispatch})=>{const{selection}=tr;const currentNode=selection.$anchor.node();// if there is content inside the current node, break out of this command
if(currentNode.content.size>0){return false;}const $pos=tr.selection.$anchor;for(let depth=$pos.depth;depth>0;depth-=1){const node=$pos.node(depth);if(node.type===currentNode.type){if(dispatch){const from=$pos.before(depth);const to=$pos.after(depth);tr.delete(from,to).scrollIntoView();}return true;}}return false;};const deleteNode=typeOrName=>({tr,state,dispatch})=>{const type=getNodeType(typeOrName,state.schema);const $pos=tr.selection.$anchor;for(let depth=$pos.depth;depth>0;depth-=1){const node=$pos.node(depth);if(node.type===type){if(dispatch){const from=$pos.before(depth);const to=$pos.after(depth);tr.delete(from,to).scrollIntoView();}return true;}}return false;};const deleteRange=range=>({tr,dispatch})=>{const{from,to}=range;if(dispatch){tr.delete(from,to);}return true;};const deleteSelection=()=>({state,dispatch})=>{return commands$1.deleteSelection(state,dispatch);};const enter=()=>({commands})=>{return commands.keyboardShortcut('Enter');};const exitCode=()=>({state,dispatch})=>{return commands$1.exitCode(state,dispatch);};/**
 * Check if object1 includes object2
 * @param object1 Object
 * @param object2 Object
 */function objectIncludes(object1,object2,options={strict:true}){const keys=Object.keys(object2);if(!keys.length){return true;}return keys.every(key=>{if(options.strict){return object2[key]===object1[key];}if(isRegExp(object2[key])){return object2[key].test(object1[key]);}return object2[key]===object1[key];});}function findMarkInSet(marks,type,attributes={}){return marks.find(item=>{return item.type===type&&objectIncludes(// Only check equality for the attributes that are provided
Object.fromEntries(Object.keys(attributes).map(k=>[k,item.attrs[k]])),attributes);});}function isMarkInSet(marks,type,attributes={}){return!!findMarkInSet(marks,type,attributes);}/**
 * Get the range of a mark at a resolved position.
 */function getMarkRange(/**
 * The position to get the mark range for.
 */$pos,/**
 * The mark type to get the range for.
 */type,/**
 * The attributes to match against.
 * If not provided, only the first mark at the position will be matched.
 */attributes){var _a;if(!$pos||!type){return;}let start=$pos.parent.childAfter($pos.parentOffset);// If the cursor is at the start of a text node that does not have the mark, look backward
if(!start.node||!start.node.marks.some(mark=>mark.type===type)){start=$pos.parent.childBefore($pos.parentOffset);}// If there is no text node with the mark even backward, return undefined
if(!start.node||!start.node.marks.some(mark=>mark.type===type)){return;}// Default to only matching against the first mark's attributes
attributes=attributes||((_a=start.node.marks[0])===null||_a===void 0?void 0:_a.attrs);// We now know that the cursor is either at the start, middle or end of a text node with the specified mark
// so we can look it up on the targeted mark
const mark=findMarkInSet([...start.node.marks],type,attributes);if(!mark){return;}let startIndex=start.index;let startPos=$pos.start()+start.offset;let endIndex=startIndex+1;let endPos=startPos+start.node.nodeSize;while(startIndex>0&&isMarkInSet([...$pos.parent.child(startIndex-1).marks],type,attributes)){startIndex-=1;startPos-=$pos.parent.child(startIndex).nodeSize;}while(endIndex<$pos.parent.childCount&&isMarkInSet([...$pos.parent.child(endIndex).marks],type,attributes)){endPos+=$pos.parent.child(endIndex).nodeSize;endIndex+=1;}return{from:startPos,to:endPos};}function getMarkType(nameOrType,schema){if(typeof nameOrType==='string'){if(!schema.marks[nameOrType]){throw Error(`There is no mark type named '${nameOrType}'. Maybe you forgot to add the extension?`);}return schema.marks[nameOrType];}return nameOrType;}const extendMarkRange=(typeOrName,attributes={})=>({tr,state:state$1,dispatch})=>{const type=getMarkType(typeOrName,state$1.schema);const{doc,selection}=tr;const{$from,from,to}=selection;if(dispatch){const range=getMarkRange($from,type,attributes);if(range&&range.from<=from&&range.to>=to){const newSelection=state.TextSelection.create(doc,range.from,range.to);tr.setSelection(newSelection);}}return true;};const first=commands=>props=>{const items=typeof commands==='function'?commands(props):commands;for(let i=0;i<items.length;i+=1){if(items[i](props)){return true;}}return false;};function isTextSelection(value){return value instanceof state.TextSelection;}function minMax(value=0,min=0,max=0){return Math.min(Math.max(value,min),max);}function resolveFocusPosition(doc,position=null){if(!position){return null;}const selectionAtStart=state.Selection.atStart(doc);const selectionAtEnd=state.Selection.atEnd(doc);if(position==='start'||position===true){return selectionAtStart;}if(position==='end'){return selectionAtEnd;}const minPos=selectionAtStart.from;const maxPos=selectionAtEnd.to;if(position==='all'){return state.TextSelection.create(doc,minMax(0,minPos,maxPos),minMax(doc.content.size,minPos,maxPos));}return state.TextSelection.create(doc,minMax(position,minPos,maxPos),minMax(position,minPos,maxPos));}function isAndroid(){return navigator.platform==='Android'||/android/i.test(navigator.userAgent);}function isiOS(){return['iPad Simulator','iPhone Simulator','iPod Simulator','iPad','iPhone','iPod'].includes(navigator.platform)// iPad on iOS 13 detection
||navigator.userAgent.includes('Mac')&&'ontouchend'in document;}const focus=(position=null,options={})=>({editor,view,tr,dispatch})=>{options={scrollIntoView:true,...options};const delayedFocus=()=>{// focus within `requestAnimationFrame` breaks focus on iOS and Android
// so we have to call this
if(isiOS()||isAndroid()){view.dom.focus();}// For React we have to focus asynchronously. Otherwise wild things happen.
// see: https://github.com/ueberdosis/tiptap/issues/1520
requestAnimationFrame(()=>{if(!editor.isDestroyed){view.focus();if(options===null||options===void 0?void 0:options.scrollIntoView){editor.commands.scrollIntoView();}}});};if(view.hasFocus()&&position===null||position===false){return true;}// we don’t try to resolve a NodeSelection or CellSelection
if(dispatch&&position===null&&!isTextSelection(editor.state.selection)){delayedFocus();return true;}// pass through tr.doc instead of editor.state.doc
// since transactions could change the editors state before this command has been run
const selection=resolveFocusPosition(tr.doc,position)||editor.state.selection;const isSameSelection=editor.state.selection.eq(selection);if(dispatch){if(!isSameSelection){tr.setSelection(selection);}// `tr.setSelection` resets the stored marks
// so we’ll restore them if the selection is the same as before
if(isSameSelection&&tr.storedMarks){tr.setStoredMarks(tr.storedMarks);}delayedFocus();}return true;};const forEach=(items,fn)=>props=>{return items.every((item,index)=>fn(item,{...props,index}));};const insertContent=(value,options)=>({tr,commands})=>{return commands.insertContentAt({from:tr.selection.from,to:tr.selection.to},value,options);};const removeWhitespaces=node=>{const children=node.childNodes;for(let i=children.length-1;i>=0;i-=1){const child=children[i];if(child.nodeType===3&&child.nodeValue&&/^(\n\s\s|\n)$/.test(child.nodeValue)){node.removeChild(child);}else if(child.nodeType===1){removeWhitespaces(child);}}return node;};function elementFromString(value){// add a wrapper to preserve leading and trailing whitespace
const wrappedValue=`<body>${value}</body>`;const html=new window.DOMParser().parseFromString(wrappedValue,'text/html').body;return removeWhitespaces(html);}/**
 * Takes a JSON or HTML content and creates a Prosemirror node or fragment from it.
 * @param content The JSON or HTML content to create the node from
 * @param schema The Prosemirror schema to use for the node
 * @param options Options for the parser
 * @returns The created Prosemirror node or fragment
 */function createNodeFromContent(content,schema,options){if(content instanceof model.Node||content instanceof model.Fragment){return content;}options={slice:true,parseOptions:{},...options};const isJSONContent=typeof content==='object'&&content!==null;const isTextContent=typeof content==='string';if(isJSONContent){try{const isArrayContent=Array.isArray(content)&&content.length>0;// if the JSON Content is an array of nodes, create a fragment for each node
if(isArrayContent){return model.Fragment.fromArray(content.map(item=>schema.nodeFromJSON(item)));}const node=schema.nodeFromJSON(content);if(options.errorOnInvalidContent){node.check();}return node;}catch(error){if(options.errorOnInvalidContent){throw new Error('[tiptap error]: Invalid JSON content',{cause:error});}console.warn('[tiptap warn]: Invalid content.','Passed value:',content,'Error:',error);return createNodeFromContent('',schema,options);}}if(isTextContent){// Check for invalid content
if(options.errorOnInvalidContent){let hasInvalidContent=false;let invalidContent='';// A copy of the current schema with a catch-all node at the end
const contentCheckSchema=new model.Schema({topNode:schema.spec.topNode,marks:schema.spec.marks,// Prosemirror's schemas are executed such that: the last to execute, matches last
// This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
nodes:schema.spec.nodes.append({__tiptap__private__unknown__catch__all__node:{content:'inline*',group:'block',parseDOM:[{tag:'*',getAttrs:e=>{// If this is ever called, we know that the content has something that we don't know how to handle in the schema
hasInvalidContent=true;// Try to stringify the element for a more helpful error message
invalidContent=typeof e==='string'?e:e.outerHTML;return null;}}]}})});if(options.slice){model.DOMParser.fromSchema(contentCheckSchema).parseSlice(elementFromString(content),options.parseOptions);}else{model.DOMParser.fromSchema(contentCheckSchema).parse(elementFromString(content),options.parseOptions);}if(options.errorOnInvalidContent&&hasInvalidContent){throw new Error('[tiptap error]: Invalid HTML content',{cause:new Error(`Invalid element found: ${invalidContent}`)});}}const parser=model.DOMParser.fromSchema(schema);if(options.slice){return parser.parseSlice(elementFromString(content),options.parseOptions).content;}return parser.parse(elementFromString(content),options.parseOptions);}return createNodeFromContent('',schema,options);}// source: https://github.com/ProseMirror/prosemirror-state/blob/master/src/selection.js#L466
function selectionToInsertionEnd(tr,startLen,bias){const last=tr.steps.length-1;if(last<startLen){return;}const step=tr.steps[last];if(!(step instanceof transform.ReplaceStep||step instanceof transform.ReplaceAroundStep)){return;}const map=tr.mapping.maps[last];let end=0;map.forEach((_from,_to,_newFrom,newTo)=>{if(end===0){end=newTo;}});tr.setSelection(state.Selection.near(tr.doc.resolve(end),bias));}const isFragment=nodeOrFragment=>{return!('type'in nodeOrFragment);};const insertContentAt=(position,value,options)=>({tr,dispatch,editor})=>{var _a;if(dispatch){options={parseOptions:editor.options.parseOptions,updateSelection:true,applyInputRules:false,applyPasteRules:false,...options};let content;try{content=createNodeFromContent(value,editor.schema,{parseOptions:{preserveWhitespace:'full',...options.parseOptions},errorOnInvalidContent:(_a=options.errorOnInvalidContent)!==null&&_a!==void 0?_a:editor.options.enableContentCheck});}catch(e){editor.emit('contentError',{editor,error:e,disableCollaboration:()=>{if(editor.storage.collaboration){editor.storage.collaboration.isDisabled=true;}}});return false;}let{from,to}=typeof position==='number'?{from:position,to:position}:{from:position.from,to:position.to};let isOnlyTextContent=true;let isOnlyBlockContent=true;const nodes=isFragment(content)?content:[content];nodes.forEach(node=>{// check if added node is valid
node.check();isOnlyTextContent=isOnlyTextContent?node.isText&&node.marks.length===0:false;isOnlyBlockContent=isOnlyBlockContent?node.isBlock:false;});// check if we can replace the wrapping node by
// the newly inserted content
// example:
// replace an empty paragraph by an inserted image
// instead of inserting the image below the paragraph
if(from===to&&isOnlyBlockContent){const{parent}=tr.doc.resolve(from);const isEmptyTextBlock=parent.isTextblock&&!parent.type.spec.code&&!parent.childCount;if(isEmptyTextBlock){from-=1;to+=1;}}let newContent;// if there is only plain text we have to use `insertText`
// because this will keep the current marks
if(isOnlyTextContent){// if value is string, we can use it directly
// otherwise if it is an array, we have to join it
if(Array.isArray(value)){newContent=value.map(v=>v.text||'').join('');}else if(value instanceof model.Fragment){let text='';value.forEach(node=>{if(node.text){text+=node.text;}});newContent=text;}else if(typeof value==='object'&&!!value&&!!value.text){newContent=value.text;}else{newContent=value;}tr.insertText(newContent,from,to);}else{newContent=content;tr.replaceWith(from,to,newContent);}// set cursor at end of inserted content
if(options.updateSelection){selectionToInsertionEnd(tr,tr.steps.length-1,-1);}if(options.applyInputRules){tr.setMeta('applyInputRules',{from,text:newContent});}if(options.applyPasteRules){tr.setMeta('applyPasteRules',{from,text:newContent});}}return true;};const joinUp=()=>({state,dispatch})=>{return commands$1.joinUp(state,dispatch);};const joinDown=()=>({state,dispatch})=>{return commands$1.joinDown(state,dispatch);};const joinBackward=()=>({state,dispatch})=>{return commands$1.joinBackward(state,dispatch);};const joinForward=()=>({state,dispatch})=>{return commands$1.joinForward(state,dispatch);};const joinItemBackward=()=>({state,dispatch,tr})=>{try{const point=transform.joinPoint(state.doc,state.selection.$from.pos,-1);if(point===null||point===undefined){return false;}tr.join(point,2);if(dispatch){dispatch(tr);}return true;}catch{return false;}};const joinItemForward=()=>({state,dispatch,tr})=>{try{const point=transform.joinPoint(state.doc,state.selection.$from.pos,+1);if(point===null||point===undefined){return false;}tr.join(point,2);if(dispatch){dispatch(tr);}return true;}catch{return false;}};const joinTextblockBackward=()=>({state,dispatch})=>{return commands$1.joinTextblockBackward(state,dispatch);};const joinTextblockForward=()=>({state,dispatch})=>{return commands$1.joinTextblockForward(state,dispatch);};function isMacOS(){return typeof navigator!=='undefined'?/Mac/.test(navigator.platform):false;}function normalizeKeyName(name){const parts=name.split(/-(?!$)/);let result=parts[parts.length-1];if(result==='Space'){result=' ';}let alt;let ctrl;let shift;let meta;for(let i=0;i<parts.length-1;i+=1){const mod=parts[i];if(/^(cmd|meta|m)$/i.test(mod)){meta=true;}else if(/^a(lt)?$/i.test(mod)){alt=true;}else if(/^(c|ctrl|control)$/i.test(mod)){ctrl=true;}else if(/^s(hift)?$/i.test(mod)){shift=true;}else if(/^mod$/i.test(mod)){if(isiOS()||isMacOS()){meta=true;}else{ctrl=true;}}else{throw new Error(`Unrecognized modifier name: ${mod}`);}}if(alt){result=`Alt-${result}`;}if(ctrl){result=`Ctrl-${result}`;}if(meta){result=`Meta-${result}`;}if(shift){result=`Shift-${result}`;}return result;}const keyboardShortcut=name=>({editor,view,tr,dispatch})=>{const keys=normalizeKeyName(name).split(/-(?!$)/);const key=keys.find(item=>!['Alt','Ctrl','Meta','Shift'].includes(item));const event=new KeyboardEvent('keydown',{key:key==='Space'?' ':key,altKey:keys.includes('Alt'),ctrlKey:keys.includes('Ctrl'),metaKey:keys.includes('Meta'),shiftKey:keys.includes('Shift'),bubbles:true,cancelable:true});const capturedTransaction=editor.captureTransaction(()=>{view.someProp('handleKeyDown',f=>f(view,event));});capturedTransaction===null||capturedTransaction===void 0?void 0:capturedTransaction.steps.forEach(step=>{const newStep=step.map(tr.mapping);if(newStep&&dispatch){tr.maybeStep(newStep);}});return true;};function isNodeActive$1(state,typeOrName,attributes={}){const{from,to,empty}=state.selection;const type=typeOrName?getNodeType(typeOrName,state.schema):null;const nodeRanges=[];state.doc.nodesBetween(from,to,(node,pos)=>{if(node.isText){return;}const relativeFrom=Math.max(from,pos);const relativeTo=Math.min(to,pos+node.nodeSize);nodeRanges.push({node,from:relativeFrom,to:relativeTo});});const selectionRange=to-from;const matchedNodeRanges=nodeRanges.filter(nodeRange=>{if(!type){return true;}return type.name===nodeRange.node.type.name;}).filter(nodeRange=>objectIncludes(nodeRange.node.attrs,attributes,{strict:false}));if(empty){return!!matchedNodeRanges.length;}const range=matchedNodeRanges.reduce((sum,nodeRange)=>sum+nodeRange.to-nodeRange.from,0);return range>=selectionRange;}const lift=(typeOrName,attributes={})=>({state,dispatch})=>{const type=getNodeType(typeOrName,state.schema);const isActive=isNodeActive$1(state,type,attributes);if(!isActive){return false;}return commands$1.lift(state,dispatch);};const liftEmptyBlock=()=>({state,dispatch})=>{return commands$1.liftEmptyBlock(state,dispatch);};const liftListItem=typeOrName=>({state,dispatch})=>{const type=getNodeType(typeOrName,state.schema);return schemaList.liftListItem(type)(state,dispatch);};const newlineInCode=()=>({state,dispatch})=>{return commands$1.newlineInCode(state,dispatch);};/**
 * Get the type of a schema item by its name.
 * @param name The name of the schema item
 * @param schema The Prosemiror schema to search in
 * @returns The type of the schema item (`node` or `mark`), or null if it doesn't exist
 */function getSchemaTypeNameByName(name,schema){if(schema.nodes[name]){return'node';}if(schema.marks[name]){return'mark';}return null;}/**
 * Remove a property or an array of properties from an object
 * @param obj Object
 * @param key Key to remove
 */function deleteProps(obj,propOrProps){const props=typeof propOrProps==='string'?[propOrProps]:propOrProps;return Object.keys(obj).reduce((newObj,prop)=>{if(!props.includes(prop)){newObj[prop]=obj[prop];}return newObj;},{});}const resetAttributes=(typeOrName,attributes)=>({tr,state,dispatch})=>{let nodeType=null;let markType=null;const schemaType=getSchemaTypeNameByName(typeof typeOrName==='string'?typeOrName:typeOrName.name,state.schema);if(!schemaType){return false;}if(schemaType==='node'){nodeType=getNodeType(typeOrName,state.schema);}if(schemaType==='mark'){markType=getMarkType(typeOrName,state.schema);}if(dispatch){tr.selection.ranges.forEach(range=>{state.doc.nodesBetween(range.$from.pos,range.$to.pos,(node,pos)=>{if(nodeType&&nodeType===node.type){tr.setNodeMarkup(pos,undefined,deleteProps(node.attrs,attributes));}if(markType&&node.marks.length){node.marks.forEach(mark=>{if(markType===mark.type){tr.addMark(pos,pos+node.nodeSize,markType.create(deleteProps(mark.attrs,attributes)));}});}});});}return true;};const scrollIntoView=()=>({tr,dispatch})=>{if(dispatch){tr.scrollIntoView();}return true;};const selectAll=()=>({tr,dispatch})=>{if(dispatch){const selection=new state.AllSelection(tr.doc);tr.setSelection(selection);}return true;};const selectNodeBackward=()=>({state,dispatch})=>{return commands$1.selectNodeBackward(state,dispatch);};const selectNodeForward=()=>({state,dispatch})=>{return commands$1.selectNodeForward(state,dispatch);};const selectParentNode=()=>({state,dispatch})=>{return commands$1.selectParentNode(state,dispatch);};// @ts-ignore
// TODO: add types to @types/prosemirror-commands
const selectTextblockEnd=()=>({state,dispatch})=>{return commands$1.selectTextblockEnd(state,dispatch);};// @ts-ignore
// TODO: add types to @types/prosemirror-commands
const selectTextblockStart=()=>({state,dispatch})=>{return commands$1.selectTextblockStart(state,dispatch);};/**
 * Create a new Prosemirror document node from content.
 * @param content The JSON or HTML content to create the document from
 * @param schema The Prosemirror schema to use for the document
 * @param parseOptions Options for the parser
 * @returns The created Prosemirror document node
 */function createDocument(content,schema,parseOptions={},options={}){return createNodeFromContent(content,schema,{slice:false,parseOptions,errorOnInvalidContent:options.errorOnInvalidContent});}const setContent=(content,emitUpdate=false,parseOptions={},options={})=>({editor,tr,dispatch,commands})=>{var _a,_b;const{doc}=tr;// This is to keep backward compatibility with the previous behavior
// TODO remove this in the next major version
if(parseOptions.preserveWhitespace!=='full'){const document=createDocument(content,editor.schema,parseOptions,{errorOnInvalidContent:(_a=options.errorOnInvalidContent)!==null&&_a!==void 0?_a:editor.options.enableContentCheck});if(dispatch){tr.replaceWith(0,doc.content.size,document).setMeta('preventUpdate',!emitUpdate);}return true;}if(dispatch){tr.setMeta('preventUpdate',!emitUpdate);}return commands.insertContentAt({from:0,to:doc.content.size},content,{parseOptions,errorOnInvalidContent:(_b=options.errorOnInvalidContent)!==null&&_b!==void 0?_b:editor.options.enableContentCheck});};function getMarkAttributes(state,typeOrName){const type=getMarkType(typeOrName,state.schema);const{from,to,empty}=state.selection;const marks=[];if(empty){if(state.storedMarks){marks.push(...state.storedMarks);}marks.push(...state.selection.$head.marks());}else{state.doc.nodesBetween(from,to,node=>{marks.push(...node.marks);});}const mark=marks.find(markItem=>markItem.type.name===type.name);if(!mark){return{};}return{...mark.attrs};}/**
 * Gets the default block type at a given match
 * @param match The content match to get the default block type from
 * @returns The default block type or null
 */function defaultBlockAt(match){for(let i=0;i<match.edgeCount;i+=1){const{type}=match.edge(i);if(type.isTextblock&&!type.hasRequiredAttrs()){return type;}}return null;}/**
 * Finds the closest parent node to a resolved position that matches a predicate.
 * @param $pos The resolved position to search from
 * @param predicate The predicate to match
 * @returns The closest parent node to the resolved position that matches the predicate
 * @example ```js
 * findParentNodeClosestToPos($from, node => node.type.name === 'paragraph')
 * ```
 */function findParentNodeClosestToPos($pos,predicate){for(let i=$pos.depth;i>0;i-=1){const node=$pos.node(i);if(predicate(node)){return{pos:i>0?$pos.before(i):0,start:$pos.start(i),depth:i,node};}}}/**
 * Finds the closest parent node to the current selection that matches a predicate.
 * @param predicate The predicate to match
 * @returns A command that finds the closest parent node to the current selection that matches the predicate
 * @example ```js
 * findParentNode(node => node.type.name === 'paragraph')
 * ```
 */function findParentNode(predicate){return selection=>findParentNodeClosestToPos(selection.$from,predicate);}/**
 * Return attributes of an extension that should be splitted by keepOnSplit flag
 * @param extensionAttributes Array of extension attributes
 * @param typeName The type of the extension
 * @param attributes The attributes of the extension
 * @returns The splitted attributes
 */function getSplittedAttributes(extensionAttributes,typeName,attributes){return Object.fromEntries(Object.entries(attributes).filter(([name])=>{const extensionAttribute=extensionAttributes.find(item=>{return item.type===typeName&&item.name===name;});if(!extensionAttribute){return false;}return extensionAttribute.attribute.keepOnSplit;}));}function isMarkActive$1(state,typeOrName,attributes={}){const{empty,ranges}=state.selection;const type=typeOrName?getMarkType(typeOrName,state.schema):null;if(empty){return!!(state.storedMarks||state.selection.$from.marks()).filter(mark=>{if(!type){return true;}return type.name===mark.type.name;}).find(mark=>objectIncludes(mark.attrs,attributes,{strict:false}));}let selectionRange=0;const markRanges=[];ranges.forEach(({$from,$to})=>{const from=$from.pos;const to=$to.pos;state.doc.nodesBetween(from,to,(node,pos)=>{if(!node.isText&&!node.marks.length){return;}const relativeFrom=Math.max(from,pos);const relativeTo=Math.min(to,pos+node.nodeSize);const range=relativeTo-relativeFrom;selectionRange+=range;markRanges.push(...node.marks.map(mark=>({mark,from:relativeFrom,to:relativeTo})));});});if(selectionRange===0){return false;}// calculate range of matched mark
const matchedRange=markRanges.filter(markRange=>{if(!type){return true;}return type.name===markRange.mark.type.name;}).filter(markRange=>objectIncludes(markRange.mark.attrs,attributes,{strict:false})).reduce((sum,markRange)=>sum+markRange.to-markRange.from,0);// calculate range of marks that excludes the searched mark
// for example `code` doesn’t allow any other marks
const excludedRange=markRanges.filter(markRange=>{if(!type){return true;}return markRange.mark.type!==type&&markRange.mark.type.excludes(type);}).reduce((sum,markRange)=>sum+markRange.to-markRange.from,0);// we only include the result of `excludedRange`
// if there is a match at all
const range=matchedRange>0?matchedRange+excludedRange:matchedRange;return range>=selectionRange;}function isList(name,extensions){const{nodeExtensions}=splitExtensions(extensions);const extension=nodeExtensions.find(item=>item.name===name);if(!extension){return false;}const context={name:extension.name,options:extension.options,storage:extension.storage};const group=callOrReturn(getExtensionField(extension,'group',context));if(typeof group!=='string'){return false;}return group.split(' ').includes('list');}/**
 * Returns true if the given prosemirror node is empty.
 */function isNodeEmpty(node,{checkChildren=true,ignoreWhitespace=false}={}){var _a;if(ignoreWhitespace){if(node.type.name==='hardBreak'){// Hard breaks are considered empty
return true;}if(node.isText){return /^\s*$/m.test((_a=node.text)!==null&&_a!==void 0?_a:'');}}if(node.isText){return!node.text;}if(node.isAtom||node.isLeaf){return false;}if(node.content.childCount===0){return true;}if(checkChildren){let isContentEmpty=true;node.content.forEach(childNode=>{if(isContentEmpty===false){// Exit early for perf
return;}if(!isNodeEmpty(childNode,{ignoreWhitespace,checkChildren})){isContentEmpty=false;}});return isContentEmpty;}return false;}function canSetMark(state,tr,newMarkType){var _a;const{selection}=tr;let cursor=null;if(isTextSelection(selection)){cursor=selection.$cursor;}if(cursor){const currentMarks=(_a=state.storedMarks)!==null&&_a!==void 0?_a:cursor.marks();// There can be no current marks that exclude the new mark
return!!newMarkType.isInSet(currentMarks)||!currentMarks.some(mark=>mark.type.excludes(newMarkType));}const{ranges}=selection;return ranges.some(({$from,$to})=>{let someNodeSupportsMark=$from.depth===0?state.doc.inlineContent&&state.doc.type.allowsMarkType(newMarkType):false;state.doc.nodesBetween($from.pos,$to.pos,(node,_pos,parent)=>{// If we already found a mark that we can enable, return false to bypass the remaining search
if(someNodeSupportsMark){return false;}if(node.isInline){const parentAllowsMarkType=!parent||parent.type.allowsMarkType(newMarkType);const currentMarksAllowMarkType=!!newMarkType.isInSet(node.marks)||!node.marks.some(otherMark=>otherMark.type.excludes(newMarkType));someNodeSupportsMark=parentAllowsMarkType&&currentMarksAllowMarkType;}return!someNodeSupportsMark;});return someNodeSupportsMark;});}const setMark=(typeOrName,attributes={})=>({tr,state,dispatch})=>{const{selection}=tr;const{empty,ranges}=selection;const type=getMarkType(typeOrName,state.schema);if(dispatch){if(empty){const oldAttributes=getMarkAttributes(state,type);tr.addStoredMark(type.create({...oldAttributes,...attributes}));}else{ranges.forEach(range=>{const from=range.$from.pos;const to=range.$to.pos;state.doc.nodesBetween(from,to,(node,pos)=>{const trimmedFrom=Math.max(pos,from);const trimmedTo=Math.min(pos+node.nodeSize,to);const someHasMark=node.marks.find(mark=>mark.type===type);// if there is already a mark of this type
// we know that we have to merge its attributes
// otherwise we add a fresh new mark
if(someHasMark){node.marks.forEach(mark=>{if(type===mark.type){tr.addMark(trimmedFrom,trimmedTo,type.create({...mark.attrs,...attributes}));}});}else{tr.addMark(trimmedFrom,trimmedTo,type.create(attributes));}});});}}return canSetMark(state,tr,type);};const setMeta=(key,value)=>({tr})=>{tr.setMeta(key,value);return true;};const setNode=(typeOrName,attributes={})=>({state,dispatch,chain})=>{const type=getNodeType(typeOrName,state.schema);let attributesToCopy;if(state.selection.$anchor.sameParent(state.selection.$head)){// only copy attributes if the selection is pointing to a node of the same type
attributesToCopy=state.selection.$anchor.parent.attrs;}// TODO: use a fallback like insertContent?
if(!type.isTextblock){console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.');return false;}return chain()// try to convert node to default node if needed
.command(({commands})=>{const canSetBlock=commands$1.setBlockType(type,{...attributesToCopy,...attributes})(state);if(canSetBlock){return true;}return commands.clearNodes();}).command(({state:updatedState})=>{return commands$1.setBlockType(type,{...attributesToCopy,...attributes})(updatedState,dispatch);}).run();};const setNodeSelection=position=>({tr,dispatch})=>{if(dispatch){const{doc}=tr;const from=minMax(position,0,doc.content.size);const selection=state.NodeSelection.create(doc,from);tr.setSelection(selection);}return true;};const setTextSelection=position=>({tr,dispatch})=>{if(dispatch){const{doc}=tr;const{from,to}=typeof position==='number'?{from:position,to:position}:position;const minPos=state.TextSelection.atStart(doc).from;const maxPos=state.TextSelection.atEnd(doc).to;const resolvedFrom=minMax(from,minPos,maxPos);const resolvedEnd=minMax(to,minPos,maxPos);const selection=state.TextSelection.create(doc,resolvedFrom,resolvedEnd);tr.setSelection(selection);}return true;};const sinkListItem=typeOrName=>({state,dispatch})=>{const type=getNodeType(typeOrName,state.schema);return schemaList.sinkListItem(type)(state,dispatch);};function ensureMarks(state,splittableMarks){const marks=state.storedMarks||state.selection.$to.parentOffset&&state.selection.$from.marks();if(marks){const filteredMarks=marks.filter(mark=>splittableMarks===null||splittableMarks===void 0?void 0:splittableMarks.includes(mark.type.name));state.tr.ensureMarks(filteredMarks);}}const splitBlock=({keepMarks=true}={})=>({tr,state:state$1,dispatch,editor})=>{const{selection,doc}=tr;const{$from,$to}=selection;const extensionAttributes=editor.extensionManager.attributes;const newAttributes=getSplittedAttributes(extensionAttributes,$from.node().type.name,$from.node().attrs);if(selection instanceof state.NodeSelection&&selection.node.isBlock){if(!$from.parentOffset||!transform.canSplit(doc,$from.pos)){return false;}if(dispatch){if(keepMarks){ensureMarks(state$1,editor.extensionManager.splittableMarks);}tr.split($from.pos).scrollIntoView();}return true;}if(!$from.parent.isBlock){return false;}const atEnd=$to.parentOffset===$to.parent.content.size;const deflt=$from.depth===0?undefined:defaultBlockAt($from.node(-1).contentMatchAt($from.indexAfter(-1)));let types=atEnd&&deflt?[{type:deflt,attrs:newAttributes}]:undefined;let can=transform.canSplit(tr.doc,tr.mapping.map($from.pos),1,types);if(!types&&!can&&transform.canSplit(tr.doc,tr.mapping.map($from.pos),1,deflt?[{type:deflt}]:undefined)){can=true;types=deflt?[{type:deflt,attrs:newAttributes}]:undefined;}if(dispatch){if(can){if(selection instanceof state.TextSelection){tr.deleteSelection();}tr.split(tr.mapping.map($from.pos),1,types);if(deflt&&!atEnd&&!$from.parentOffset&&$from.parent.type!==deflt){const first=tr.mapping.map($from.before());const $first=tr.doc.resolve(first);if($from.node(-1).canReplaceWith($first.index(),$first.index()+1,deflt)){tr.setNodeMarkup(tr.mapping.map($from.before()),deflt);}}}if(keepMarks){ensureMarks(state$1,editor.extensionManager.splittableMarks);}tr.scrollIntoView();}return can;};const splitListItem=(typeOrName,overrideAttrs={})=>({tr,state:state$1,dispatch,editor})=>{var _a;const type=getNodeType(typeOrName,state$1.schema);const{$from,$to}=state$1.selection;// @ts-ignore
// eslint-disable-next-line
const node=state$1.selection.node;if(node&&node.isBlock||$from.depth<2||!$from.sameParent($to)){return false;}const grandParent=$from.node(-1);if(grandParent.type!==type){return false;}const extensionAttributes=editor.extensionManager.attributes;if($from.parent.content.size===0&&$from.node(-1).childCount===$from.indexAfter(-1)){// In an empty block. If this is a nested list, the wrapping
// list item should be split. Otherwise, bail out and let next
// command handle lifting.
if($from.depth===2||$from.node(-3).type!==type||$from.index(-2)!==$from.node(-2).childCount-1){return false;}if(dispatch){let wrap=model.Fragment.empty;// eslint-disable-next-line
const depthBefore=$from.index(-1)?1:$from.index(-2)?2:3;// Build a fragment containing empty versions of the structure
// from the outer list item to the parent node of the cursor
for(let d=$from.depth-depthBefore;d>=$from.depth-3;d-=1){wrap=model.Fragment.from($from.node(d).copy(wrap));}// eslint-disable-next-line
const depthAfter=$from.indexAfter(-1)<$from.node(-2).childCount?1:$from.indexAfter(-2)<$from.node(-3).childCount?2:3;// Add a second list item with an empty default start node
const newNextTypeAttributes={...getSplittedAttributes(extensionAttributes,$from.node().type.name,$from.node().attrs),...overrideAttrs};const nextType=((_a=type.contentMatch.defaultType)===null||_a===void 0?void 0:_a.createAndFill(newNextTypeAttributes))||undefined;wrap=wrap.append(model.Fragment.from(type.createAndFill(null,nextType)||undefined));const start=$from.before($from.depth-(depthBefore-1));tr.replace(start,$from.after(-depthAfter),new model.Slice(wrap,4-depthBefore,0));let sel=-1;tr.doc.nodesBetween(start,tr.doc.content.size,(n,pos)=>{if(sel>-1){return false;}if(n.isTextblock&&n.content.size===0){sel=pos+1;}});if(sel>-1){tr.setSelection(state.TextSelection.near(tr.doc.resolve(sel)));}tr.scrollIntoView();}return true;}const nextType=$to.pos===$from.end()?grandParent.contentMatchAt(0).defaultType:null;const newTypeAttributes={...getSplittedAttributes(extensionAttributes,grandParent.type.name,grandParent.attrs),...overrideAttrs};const newNextTypeAttributes={...getSplittedAttributes(extensionAttributes,$from.node().type.name,$from.node().attrs),...overrideAttrs};tr.delete($from.pos,$to.pos);const types=nextType?[{type,attrs:newTypeAttributes},{type:nextType,attrs:newNextTypeAttributes}]:[{type,attrs:newTypeAttributes}];if(!transform.canSplit(tr.doc,$from.pos,2)){return false;}if(dispatch){const{selection,storedMarks}=state$1;const{splittableMarks}=editor.extensionManager;const marks=storedMarks||selection.$to.parentOffset&&selection.$from.marks();tr.split($from.pos,2,types).scrollIntoView();if(!marks||!dispatch){return true;}const filteredMarks=marks.filter(mark=>splittableMarks.includes(mark.type.name));tr.ensureMarks(filteredMarks);}return true;};const joinListBackwards=(tr,listType)=>{const list=findParentNode(node=>node.type===listType)(tr.selection);if(!list){return true;}const before=tr.doc.resolve(Math.max(0,list.pos-1)).before(list.depth);if(before===undefined){return true;}const nodeBefore=tr.doc.nodeAt(before);const canJoinBackwards=list.node.type===(nodeBefore===null||nodeBefore===void 0?void 0:nodeBefore.type)&&transform.canJoin(tr.doc,list.pos);if(!canJoinBackwards){return true;}tr.join(list.pos);return true;};const joinListForwards=(tr,listType)=>{const list=findParentNode(node=>node.type===listType)(tr.selection);if(!list){return true;}const after=tr.doc.resolve(list.start).after(list.depth);if(after===undefined){return true;}const nodeAfter=tr.doc.nodeAt(after);const canJoinForwards=list.node.type===(nodeAfter===null||nodeAfter===void 0?void 0:nodeAfter.type)&&transform.canJoin(tr.doc,after);if(!canJoinForwards){return true;}tr.join(after);return true;};const toggleList$1=(listTypeOrName,itemTypeOrName,keepMarks,attributes={})=>({editor,tr,state,dispatch,chain,commands,can})=>{const{extensions,splittableMarks}=editor.extensionManager;const listType=getNodeType(listTypeOrName,state.schema);const itemType=getNodeType(itemTypeOrName,state.schema);const{selection,storedMarks}=state;const{$from,$to}=selection;const range=$from.blockRange($to);const marks=storedMarks||selection.$to.parentOffset&&selection.$from.marks();if(!range){return false;}const parentList=findParentNode(node=>isList(node.type.name,extensions))(selection);if(range.depth>=1&&parentList&&range.depth-parentList.depth<=1){// remove list
if(parentList.node.type===listType){return commands.liftListItem(itemType);}// change list type
if(isList(parentList.node.type.name,extensions)&&listType.validContent(parentList.node.content)&&dispatch){return chain().command(()=>{tr.setNodeMarkup(parentList.pos,listType);return true;}).command(()=>joinListBackwards(tr,listType)).command(()=>joinListForwards(tr,listType)).run();}}if(!keepMarks||!marks||!dispatch){return chain()// try to convert node to default node if needed
.command(()=>{const canWrapInList=can().wrapInList(listType,attributes);if(canWrapInList){return true;}return commands.clearNodes();}).wrapInList(listType,attributes).command(()=>joinListBackwards(tr,listType)).command(()=>joinListForwards(tr,listType)).run();}return chain()// try to convert node to default node if needed
.command(()=>{const canWrapInList=can().wrapInList(listType,attributes);const filteredMarks=marks.filter(mark=>splittableMarks.includes(mark.type.name));tr.ensureMarks(filteredMarks);if(canWrapInList){return true;}return commands.clearNodes();}).wrapInList(listType,attributes).command(()=>joinListBackwards(tr,listType)).command(()=>joinListForwards(tr,listType)).run();};const toggleMark$1=(typeOrName,attributes={},options={})=>({state,commands})=>{const{extendEmptyMarkRange=false}=options;const type=getMarkType(typeOrName,state.schema);const isActive=isMarkActive$1(state,type,attributes);if(isActive){return commands.unsetMark(type,{extendEmptyMarkRange});}return commands.setMark(type,attributes);};const toggleNode$1=(typeOrName,toggleTypeOrName,attributes={})=>({state,commands})=>{const type=getNodeType(typeOrName,state.schema);const toggleType=getNodeType(toggleTypeOrName,state.schema);const isActive=isNodeActive$1(state,type,attributes);let attributesToCopy;if(state.selection.$anchor.sameParent(state.selection.$head)){// only copy attributes if the selection is pointing to a node of the same type
attributesToCopy=state.selection.$anchor.parent.attrs;}if(isActive){return commands.setNode(toggleType,attributesToCopy);}// If the node is not active, we want to set the new node type with the given attributes
// Copying over the attributes from the current node if the selection is pointing to a node of the same type
return commands.setNode(type,{...attributesToCopy,...attributes});};const toggleWrap=(typeOrName,attributes={})=>({state,commands})=>{const type=getNodeType(typeOrName,state.schema);const isActive=isNodeActive$1(state,type,attributes);if(isActive){return commands.lift(type);}return commands.wrapIn(type,attributes);};const undoInputRule=()=>({state,dispatch})=>{const plugins=state.plugins;for(let i=0;i<plugins.length;i+=1){const plugin=plugins[i];let undoable;// @ts-ignore
// eslint-disable-next-line
if(plugin.spec.isInputRules&&(undoable=plugin.getState(state))){if(dispatch){const tr=state.tr;const toUndo=undoable.transform;for(let j=toUndo.steps.length-1;j>=0;j-=1){tr.step(toUndo.steps[j].invert(toUndo.docs[j]));}if(undoable.text){const marks=tr.doc.resolve(undoable.from).marks();tr.replaceWith(undoable.from,undoable.to,state.schema.text(undoable.text,marks));}else{tr.delete(undoable.from,undoable.to);}}return true;}}return false;};const unsetAllMarks=()=>({tr,dispatch})=>{const{selection}=tr;const{empty,ranges}=selection;if(empty){return true;}if(dispatch){ranges.forEach(range=>{tr.removeMark(range.$from.pos,range.$to.pos);});}return true;};const unsetMark=(typeOrName,options={})=>({tr,state,dispatch})=>{var _a;const{extendEmptyMarkRange=false}=options;const{selection}=tr;const type=getMarkType(typeOrName,state.schema);const{$from,empty,ranges}=selection;if(!dispatch){return true;}if(empty&&extendEmptyMarkRange){let{from,to}=selection;const attrs=(_a=$from.marks().find(mark=>mark.type===type))===null||_a===void 0?void 0:_a.attrs;const range=getMarkRange($from,type,attrs);if(range){from=range.from;to=range.to;}tr.removeMark(from,to,type);}else{ranges.forEach(range=>{tr.removeMark(range.$from.pos,range.$to.pos,type);});}tr.removeStoredMark(type);return true;};const updateAttributes=(typeOrName,attributes={})=>({tr,state,dispatch})=>{let nodeType=null;let markType=null;const schemaType=getSchemaTypeNameByName(typeof typeOrName==='string'?typeOrName:typeOrName.name,state.schema);if(!schemaType){return false;}if(schemaType==='node'){nodeType=getNodeType(typeOrName,state.schema);}if(schemaType==='mark'){markType=getMarkType(typeOrName,state.schema);}if(dispatch){tr.selection.ranges.forEach(range=>{const from=range.$from.pos;const to=range.$to.pos;let lastPos;let lastNode;let trimmedFrom;let trimmedTo;if(tr.selection.empty){state.doc.nodesBetween(from,to,(node,pos)=>{if(nodeType&&nodeType===node.type){trimmedFrom=Math.max(pos,from);trimmedTo=Math.min(pos+node.nodeSize,to);lastPos=pos;lastNode=node;}});}else{state.doc.nodesBetween(from,to,(node,pos)=>{if(pos<from&&nodeType&&nodeType===node.type){trimmedFrom=Math.max(pos,from);trimmedTo=Math.min(pos+node.nodeSize,to);lastPos=pos;lastNode=node;}if(pos>=from&&pos<=to){if(nodeType&&nodeType===node.type){tr.setNodeMarkup(pos,undefined,{...node.attrs,...attributes});}if(markType&&node.marks.length){node.marks.forEach(mark=>{if(markType===mark.type){const trimmedFrom2=Math.max(pos,from);const trimmedTo2=Math.min(pos+node.nodeSize,to);tr.addMark(trimmedFrom2,trimmedTo2,markType.create({...mark.attrs,...attributes}));}});}}});}if(lastNode){if(lastPos!==undefined){tr.setNodeMarkup(lastPos,undefined,{...lastNode.attrs,...attributes});}if(markType&&lastNode.marks.length){lastNode.marks.forEach(mark=>{if(markType===mark.type){tr.addMark(trimmedFrom,trimmedTo,markType.create({...mark.attrs,...attributes}));}});}}});}return true;};const wrapIn=(typeOrName,attributes={})=>({state,dispatch})=>{const type=getNodeType(typeOrName,state.schema);return commands$1.wrapIn(type,attributes)(state,dispatch);};const wrapInList=(typeOrName,attributes={})=>({state,dispatch})=>{const type=getNodeType(typeOrName,state.schema);return schemaList.wrapInList(type,attributes)(state,dispatch);};var commands=/*#__PURE__*/Object.freeze({__proto__:null,blur:blur,clearContent:clearContent,clearNodes:clearNodes,command:command,createParagraphNear:createParagraphNear,cut:cut,deleteCurrentNode:deleteCurrentNode,deleteNode:deleteNode,deleteRange:deleteRange,deleteSelection:deleteSelection,enter:enter,exitCode:exitCode,extendMarkRange:extendMarkRange,first:first,focus:focus,forEach:forEach,insertContent:insertContent,insertContentAt:insertContentAt,joinBackward:joinBackward,joinDown:joinDown,joinForward:joinForward,joinItemBackward:joinItemBackward,joinItemForward:joinItemForward,joinTextblockBackward:joinTextblockBackward,joinTextblockForward:joinTextblockForward,joinUp:joinUp,keyboardShortcut:keyboardShortcut,lift:lift,liftEmptyBlock:liftEmptyBlock,liftListItem:liftListItem,newlineInCode:newlineInCode,resetAttributes:resetAttributes,scrollIntoView:scrollIntoView,selectAll:selectAll,selectNodeBackward:selectNodeBackward,selectNodeForward:selectNodeForward,selectParentNode:selectParentNode,selectTextblockEnd:selectTextblockEnd,selectTextblockStart:selectTextblockStart,setContent:setContent,setMark:setMark,setMeta:setMeta,setNode:setNode,setNodeSelection:setNodeSelection,setTextSelection:setTextSelection,sinkListItem:sinkListItem,splitBlock:splitBlock,splitListItem:splitListItem,toggleList:toggleList$1,toggleMark:toggleMark$1,toggleNode:toggleNode$1,toggleWrap:toggleWrap,undoInputRule:undoInputRule,unsetAllMarks:unsetAllMarks,unsetMark:unsetMark,updateAttributes:updateAttributes,wrapIn:wrapIn,wrapInList:wrapInList});Extension.create({name:'commands',addCommands(){return{...commands};}});Extension.create({name:'drop',addProseMirrorPlugins(){return[new state.Plugin({key:new state.PluginKey('tiptapDrop'),props:{handleDrop:(_,e,slice,moved)=>{this.editor.emit('drop',{editor:this.editor,event:e,slice,moved});}}})];}});Extension.create({name:'editable',addProseMirrorPlugins(){return[new state.Plugin({key:new state.PluginKey('editable'),props:{editable:()=>this.editor.options.editable}})];}});const focusEventsPluginKey=new state.PluginKey('focusEvents');Extension.create({name:'focusEvents',addProseMirrorPlugins(){const{editor}=this;return[new state.Plugin({key:focusEventsPluginKey,props:{handleDOMEvents:{focus:(view,event)=>{editor.isFocused=true;const transaction=editor.state.tr.setMeta('focus',{event}).setMeta('addToHistory',false);view.dispatch(transaction);return false;},blur:(view,event)=>{editor.isFocused=false;const transaction=editor.state.tr.setMeta('blur',{event}).setMeta('addToHistory',false);view.dispatch(transaction);return false;}}}})];}});Extension.create({name:'keymap',addKeyboardShortcuts(){const handleBackspace=()=>this.editor.commands.first(({commands})=>[()=>commands.undoInputRule(),// maybe convert first text block node to default node
()=>commands.command(({tr})=>{const{selection,doc}=tr;const{empty,$anchor}=selection;const{pos,parent}=$anchor;const $parentPos=$anchor.parent.isTextblock&&pos>0?tr.doc.resolve(pos-1):$anchor;const parentIsIsolating=$parentPos.parent.type.spec.isolating;const parentPos=$anchor.pos-$anchor.parentOffset;const isAtStart=parentIsIsolating&&$parentPos.parent.childCount===1?parentPos===$anchor.pos:state.Selection.atStart(doc).from===pos;if(!empty||!parent.type.isTextblock||parent.textContent.length||!isAtStart||isAtStart&&$anchor.parent.type.name==='paragraph'// prevent clearNodes when no nodes to clear, otherwise history stack is appended
){return false;}return commands.clearNodes();}),()=>commands.deleteSelection(),()=>commands.joinBackward(),()=>commands.selectNodeBackward()]);const handleDelete=()=>this.editor.commands.first(({commands})=>[()=>commands.deleteSelection(),()=>commands.deleteCurrentNode(),()=>commands.joinForward(),()=>commands.selectNodeForward()]);const handleEnter=()=>this.editor.commands.first(({commands})=>[()=>commands.newlineInCode(),()=>commands.createParagraphNear(),()=>commands.liftEmptyBlock(),()=>commands.splitBlock()]);const baseKeymap={Enter:handleEnter,'Mod-Enter':()=>this.editor.commands.exitCode(),Backspace:handleBackspace,'Mod-Backspace':handleBackspace,'Shift-Backspace':handleBackspace,Delete:handleDelete,'Mod-Delete':handleDelete,'Mod-a':()=>this.editor.commands.selectAll()};const pcKeymap={...baseKeymap};const macKeymap={...baseKeymap,'Ctrl-h':handleBackspace,'Alt-Backspace':handleBackspace,'Ctrl-d':handleDelete,'Ctrl-Alt-Backspace':handleDelete,'Alt-Delete':handleDelete,'Alt-d':handleDelete,'Ctrl-a':()=>this.editor.commands.selectTextblockStart(),'Ctrl-e':()=>this.editor.commands.selectTextblockEnd()};if(isiOS()||isMacOS()){return macKeymap;}return pcKeymap;},addProseMirrorPlugins(){return[// With this plugin we check if the whole document was selected and deleted.
// In this case we will additionally call `clearNodes()` to convert e.g. a heading
// to a paragraph if necessary.
// This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
// with many other commands.
new state.Plugin({key:new state.PluginKey('clearDocument'),appendTransaction:(transactions,oldState,newState)=>{if(transactions.some(tr=>tr.getMeta('composition'))){return;}const docChanges=transactions.some(transaction=>transaction.docChanged)&&!oldState.doc.eq(newState.doc);const ignoreTr=transactions.some(transaction=>transaction.getMeta('preventClearDocument'));if(!docChanges||ignoreTr){return;}const{empty,from,to}=oldState.selection;const allFrom=state.Selection.atStart(oldState.doc).from;const allEnd=state.Selection.atEnd(oldState.doc).to;const allWasSelected=from===allFrom&&to===allEnd;if(empty||!allWasSelected){return;}const isEmpty=isNodeEmpty(newState.doc);if(!isEmpty){return;}const tr=newState.tr;const state$1=createChainableState({state:newState,transaction:tr});const{commands}=new CommandManager({editor:this.editor,state:state$1});commands.clearNodes();if(!tr.steps.length){return;}return tr;}})];}});Extension.create({name:'paste',addProseMirrorPlugins(){return[new state.Plugin({key:new state.PluginKey('tiptapPaste'),props:{handlePaste:(_view,e,slice)=>{this.editor.emit('paste',{editor:this.editor,event:e,slice});}}})];}});Extension.create({name:'tabindex',addProseMirrorPlugins(){return[new state.Plugin({key:new state.PluginKey('tabindex'),props:{attributes:()=>this.editor.isEditable?{tabindex:'0'}:{}}})];}});/**
 * The Node class is used to create custom node extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */class Node{constructor(config={}){this.type='node';this.name='node';this.parent=null;this.child=null;this.config={name:this.name,defaultOptions:{}};this.config={...this.config,...config};this.name=this.config.name;if(config.defaultOptions&&Object.keys(config.defaultOptions).length>0){console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);}// TODO: remove `addOptions` fallback
this.options=this.config.defaultOptions;if(this.config.addOptions){this.options=callOrReturn(getExtensionField(this,'addOptions',{name:this.name}));}this.storage=callOrReturn(getExtensionField(this,'addStorage',{name:this.name,options:this.options}))||{};}static create(config={}){return new Node(config);}configure(options={}){// return a new instance so we can use the same extension
// with different calls of `configure`
const extension=this.extend({...this.config,addOptions:()=>{return mergeDeep(this.options,options);}});// Always preserve the current name
extension.name=this.name;// Set the parent to be our parent
extension.parent=this.parent;return extension;}extend(extendedConfig={}){const extension=new Node(extendedConfig);extension.parent=this;this.child=extension;extension.name=extendedConfig.name?extendedConfig.name:extension.parent.name;if(extendedConfig.defaultOptions&&Object.keys(extendedConfig.defaultOptions).length>0){console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);}extension.options=callOrReturn(getExtensionField(extension,'addOptions',{name:extension.name}));extension.storage=callOrReturn(getExtensionField(extension,'addStorage',{name:extension.name,options:extension.options}));return extension;}}/**
 * The default document node which represents the top level node of the editor.
 * @see https://tiptap.dev/api/nodes/document
 */const Document=Node.create({name:'doc',topNode:true,content:'block+'});/**
 * This extension allows you to create paragraphs.
 * @see https://www.tiptap.dev/api/nodes/paragraph
 */const Paragraph=Node.create({name:'paragraph',priority:1000,addOptions(){return{HTMLAttributes:{}};},group:'block',content:'inline*',parseHTML(){return[{tag:'p'}];},renderHTML({HTMLAttributes}){return['p',mergeAttributes(this.options.HTMLAttributes,HTMLAttributes),0];},addCommands(){return{setParagraph:()=>({commands})=>{return commands.setNode(this.name);}};},addKeyboardShortcuts(){return{'Mod-Alt-0':()=>this.editor.commands.setParagraph()};}});/**
 * This extension allows you to create text nodes.
 * @see https://www.tiptap.dev/api/nodes/text
 */const Text=Node.create({name:'text',group:'inline'});var _excluded$N=["orientation","size","className","style"];var Spacer=React__namespace.forwardRef(function(_ref,ref){var _ref$orientation=_ref.orientation,orientation=_ref$orientation===void 0?'horizontal':_ref$orientation,size=_ref.size,_ref$className=_ref.className,className=_ref$className===void 0?'':_ref$className,_ref$style=_ref.style,style=_ref$style===void 0?{}:_ref$style,props=_objectWithoutPropertiesLoose(_ref,_excluded$N);var computedStyle=_extends({},style,orientation==='horizontal'&&!size&&{flex:1},size&&{width:orientation==='vertical'?'1px':size,height:orientation==='horizontal'?'1px':size});return jsxRuntime.jsx("div",_extends({ref:ref},props,{className:className,style:computedStyle}));});Spacer.displayName='Spacer';var _excluded$M=["decorative","orientation","className"];var Separator=React__namespace.forwardRef(function(_ref,ref){var decorative=_ref.decorative,_ref$orientation=_ref.orientation,orientation=_ref$orientation===void 0?'vertical':_ref$orientation,_ref$className=_ref.className,className=_ref$className===void 0?'':_ref$className,divProps=_objectWithoutPropertiesLoose(_ref,_excluded$M);var ariaOrientation=orientation==='vertical'?orientation:undefined;var semanticProps=decorative?{role:'none'}:{'aria-orientation':ariaOrientation,role:'separator'};return jsxRuntime.jsx("div",_extends({className:("tiptap-separator "+className).trim(),"data-orientation":orientation},semanticProps,divProps,{ref:ref}));});Separator.displayName='Separator';var _excluded$L=["children","className","variant"],_excluded2$5=["children","className"],_excluded3$3=["children","className"];var mergeRefs=function mergeRefs(refs){return function(value){refs.forEach(function(ref){if(typeof ref==='function'){ref(value);}else if(ref!=null){ref.current=value;}});};};var useObserveVisibility=function useObserveVisibility(ref,callback){React__namespace.useEffect(function(){var element=ref.current;if(!element)return;var isMounted=true;if(isMounted){requestAnimationFrame(callback);}var observer=new MutationObserver(function(){if(isMounted){requestAnimationFrame(callback);}});observer.observe(element,{childList:true,subtree:true,attributes:true});return function(){isMounted=false;observer.disconnect();};},[ref,callback]);};var useToolbarKeyboardNav=function useToolbarKeyboardNav(toolbarRef){React__namespace.useEffect(function(){var toolbar=toolbarRef.current;if(!toolbar)return;var getFocusableElements=function getFocusableElements(){return Array.from(toolbar.querySelectorAll('button:not([disabled]), [role="button"]:not([disabled]), [tabindex="0"]:not([disabled])'));};var navigateToIndex=function navigateToIndex(e,targetIndex,elements){var _elements$nextIndex;e.preventDefault();var nextIndex=targetIndex;if(nextIndex>=elements.length){nextIndex=0;}else if(nextIndex<0){nextIndex=elements.length-1;}(_elements$nextIndex=elements[nextIndex])==null||_elements$nextIndex.focus();};var handleKeyDown=function handleKeyDown(e){var focusableElements=getFocusableElements();if(!focusableElements.length)return;var currentElement=document.activeElement;var currentIndex=focusableElements.indexOf(currentElement);if(!toolbar.contains(currentElement))return;var keyActions={ArrowRight:function ArrowRight(){return navigateToIndex(e,currentIndex+1,focusableElements);},ArrowDown:function ArrowDown(){return navigateToIndex(e,currentIndex+1,focusableElements);},ArrowLeft:function ArrowLeft(){return navigateToIndex(e,currentIndex-1,focusableElements);},ArrowUp:function ArrowUp(){return navigateToIndex(e,currentIndex-1,focusableElements);},Home:function Home(){return navigateToIndex(e,0,focusableElements);},End:function End(){return navigateToIndex(e,focusableElements.length-1,focusableElements);}};var action=keyActions[e.key];if(action){action();}};toolbar.addEventListener('keydown',handleKeyDown);return function(){return toolbar.removeEventListener('keydown',handleKeyDown);};},[toolbarRef]);};var useToolbarVisibility=function useToolbarVisibility(ref){var _React$useState=React__namespace.useState(true),isVisible=_React$useState[0],setIsVisible=_React$useState[1];var isMountedRef=React__namespace.useRef(false);React__namespace.useEffect(function(){isMountedRef.current=true;return function(){isMountedRef.current=false;};},[]);var checkVisibility=React__namespace.useCallback(function(){if(!isMountedRef.current)return;var toolbar=ref.current;if(!toolbar)return;// Check if any group has visible children
var hasVisibleChildren=Array.from(toolbar.children).some(function(child){if(!(child instanceof HTMLElement))return false;if(child.getAttribute('role')==='row'){return child.children.length>0;}return false;});setIsVisible(hasVisibleChildren);},[ref]);useObserveVisibility(ref,checkVisibility);return isVisible;};var useRowVisibility=function useRowVisibility(ref){var _React$useState2=React__namespace.useState(true),isVisible=_React$useState2[0],setIsVisible=_React$useState2[1];var isMountedRef=React__namespace.useRef(false);React__namespace.useEffect(function(){isMountedRef.current=true;return function(){isMountedRef.current=false;};},[]);var checkVisibility=React__namespace.useCallback(function(){if(!isMountedRef.current)return;var toolbar=ref.current;if(!toolbar)return;// Check if any group has visible children
var hasVisibleChildren=Array.from(toolbar.children).some(function(child){if(!(child instanceof HTMLElement))return false;if(child.getAttribute('role')==='group'){return child.children.length>0;}return false;});setIsVisible(hasVisibleChildren);},[ref]);useObserveVisibility(ref,checkVisibility);return isVisible;};var useGroupVisibility=function useGroupVisibility(ref){var _React$useState3=React__namespace.useState(true),isVisible=_React$useState3[0],setIsVisible=_React$useState3[1];var isMountedRef=React__namespace.useRef(false);React__namespace.useEffect(function(){isMountedRef.current=true;return function(){isMountedRef.current=false;};},[]);var checkVisibility=React__namespace.useCallback(function(){if(!isMountedRef.current)return;var group=ref.current;if(!group)return;var hasVisibleChildren=Array.from(group.children).some(function(child){if(!(child instanceof HTMLElement))return false;return true;});setIsVisible(hasVisibleChildren);},[ref]);useObserveVisibility(ref,checkVisibility);return isVisible;};var useSeparatorVisibility=function useSeparatorVisibility(ref){var _React$useState4=React__namespace.useState(true),isVisible=_React$useState4[0],setIsVisible=_React$useState4[1];var isMountedRef=React__namespace.useRef(false);React__namespace.useEffect(function(){isMountedRef.current=true;return function(){isMountedRef.current=false;};},[]);var checkVisibility=React__namespace.useCallback(function(){if(!isMountedRef.current)return;var separator=ref.current;if(!separator)return;var prevSibling=separator.previousElementSibling;var nextSibling=separator.nextElementSibling;if(!prevSibling||!nextSibling){setIsVisible(false);return;}var areBothGroups=prevSibling.getAttribute('role')==='group'&&nextSibling.getAttribute('role')==='group';var haveBothChildren=prevSibling.children.length>0&&nextSibling.children.length>0;setIsVisible(areBothGroups&&haveBothChildren);},[ref]);useObserveVisibility(ref,checkVisibility);return isVisible;};var Toolbar=React__namespace.forwardRef(function(_ref,ref){var children=_ref.children,className=_ref.className,_ref$variant=_ref.variant,variant=_ref$variant===void 0?'fixed':_ref$variant,props=_objectWithoutPropertiesLoose(_ref,_excluded$L);var toolbarRef=React__namespace.useRef(null);var isVisible=useToolbarVisibility(toolbarRef);useToolbarKeyboardNav(toolbarRef);if(!isVisible)return null;return jsxRuntime.jsx("div",_extends({ref:mergeRefs([toolbarRef,ref]),role:"toolbar","aria-label":"toolbar","data-variant":variant,className:"tiptap-toolbar "+(className||'')},props,{children:children}));});Toolbar.displayName='Toolbar';var ToolbarRow=React__namespace.forwardRef(function(_ref2,ref){var children=_ref2.children,className=_ref2.className,props=_objectWithoutPropertiesLoose(_ref2,_excluded2$5);var rowRef=React__namespace.useRef(null);var isVisible=useRowVisibility(rowRef);if(!isVisible)return null;return jsxRuntime.jsx("div",_extends({ref:mergeRefs([rowRef,ref]),role:"row",className:clsx__default["default"]("tiptap-toolbar-row",className)},props,{children:children}));});ToolbarRow.displayName='ToolbarRow';var ToolbarGroup=React__namespace.forwardRef(function(_ref3,ref){var children=_ref3.children,className=_ref3.className,props=_objectWithoutPropertiesLoose(_ref3,_excluded3$3);var groupRef=React__namespace.useRef(null);var isVisible=useGroupVisibility(groupRef);if(!isVisible)return null;return jsxRuntime.jsx("div",_extends({ref:mergeRefs([groupRef,ref]),role:"group",className:"tiptap-toolbar-group "+(className||'')},props,{children:children}));});ToolbarGroup.displayName='ToolbarGroup';var ToolbarSeparator=React__namespace.forwardRef(function(_ref4,ref){var props=_extends({},(_objectDestructuringEmpty(_ref4),_ref4));var separatorRef=React__namespace.useRef(null);var isVisible=useSeparatorVisibility(separatorRef);if(!isVisible)return null;return jsxRuntime.jsx(Separator,_extends({ref:mergeRefs([separatorRef,ref]),orientation:"vertical",decorative:true,style:{margin:'0 16px'}},props));});ToolbarSeparator.displayName='ToolbarSeparator';function useTiptapEditor(providedEditor){var _useCurrentEditor=react.useCurrentEditor(),coreEditor=_useCurrentEditor.editor;return React__namespace.useMemo(function(){return providedEditor||coreEditor;},[providedEditor,coreEditor]);}var _excluded$K=["className","children","tooltip","showTooltip","shortcutKeys","aria-label"];var Button=React__namespace.forwardRef(function(_ref2,ref){var _ref2$className=_ref2.className,className=_ref2$className===void 0?'':_ref2$className,children=_ref2.children,ariaLabel=_ref2['aria-label'],props=_objectWithoutPropertiesLoose(_ref2,_excluded$K);return jsxRuntime.jsx("button",_extends({className:("tiptap-button "+className).trim(),ref:ref,"aria-label":ariaLabel},props,{children:children}));});Button.displayName='Button';var _excluded$J=["className"];var Undo2Icon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$J);return jsxRuntime.jsx("svg",_extends({width:"24",height:"24",className:className,viewBox:"0 0 24 24",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg"},props,{children:jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M9.70711 3.70711C10.0976 3.31658 10.0976 2.68342 9.70711 2.29289C9.31658 1.90237 8.68342 1.90237 8.29289 2.29289L3.29289 7.29289C2.90237 7.68342 2.90237 8.31658 3.29289 8.70711L8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071C10.0976 13.3166 10.0976 12.6834 9.70711 12.2929L6.41421 9H14.5C15.0909 9 15.6761 9.1164 16.2221 9.34254C16.768 9.56869 17.2641 9.90016 17.682 10.318C18.0998 10.7359 18.4313 11.232 18.6575 11.7779C18.8836 12.3239 19 12.9091 19 13.5C19 14.0909 18.8836 14.6761 18.6575 15.2221C18.4313 15.768 18.0998 16.2641 17.682 16.682C17.2641 17.0998 16.768 17.4313 16.2221 17.6575C15.6761 17.8836 15.0909 18 14.5 18H11C10.4477 18 10 18.4477 10 19C10 19.5523 10.4477 20 11 20H14.5C15.3536 20 16.1988 19.8319 16.9874 19.5052C17.7761 19.1786 18.4926 18.6998 19.0962 18.0962C19.6998 17.4926 20.1786 16.7761 20.5052 15.9874C20.8319 15.1988 21 14.3536 21 13.5C21 12.6464 20.8319 11.8012 20.5052 11.0126C20.1786 10.2239 19.6998 9.50739 19.0962 8.90381C18.4926 8.30022 17.7761 7.82144 16.9874 7.49478C16.1988 7.16813 15.3536 7 14.5 7H6.41421L9.70711 3.70711Z",fill:"currentColor"})}));});Undo2Icon.displayName='Undo2Icon';var _excluded$I=["className"];var Redo2Icon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$I);return jsxRuntime.jsx("svg",_extends({width:"24",height:"24",className:className,viewBox:"0 0 24 24",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg"},props,{children:jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M15.7071 2.29289C15.3166 1.90237 14.6834 1.90237 14.2929 2.29289C13.9024 2.68342 13.9024 3.31658 14.2929 3.70711L17.5858 7H9.5C7.77609 7 6.12279 7.68482 4.90381 8.90381C3.68482 10.1228 3 11.7761 3 13.5C3 14.3536 3.16813 15.1988 3.49478 15.9874C3.82144 16.7761 4.30023 17.4926 4.90381 18.0962C6.12279 19.3152 7.77609 20 9.5 20H13C13.5523 20 14 19.5523 14 19C14 18.4477 13.5523 18 13 18H9.5C8.30653 18 7.16193 17.5259 6.31802 16.682C5.90016 16.2641 5.56869 15.768 5.34254 15.2221C5.1164 14.6761 5 14.0909 5 13.5C5 12.3065 5.47411 11.1619 6.31802 10.318C7.16193 9.47411 8.30653 9 9.5 9H17.5858L14.2929 12.2929C13.9024 12.6834 13.9024 13.3166 14.2929 13.7071C14.6834 14.0976 15.3166 14.0976 15.7071 13.7071L20.7071 8.70711C21.0976 8.31658 21.0976 7.68342 20.7071 7.29289L15.7071 2.29289Z",fill:"currentColor"})}));});Redo2Icon.displayName='Redo2Icon';var _excluded$H=["editor","action","text","className","disabled","onClick","children"];var historyIcons={undo:Undo2Icon,redo:Redo2Icon};var historyShortcutKeys={undo:'Ctrl-z',redo:'Ctrl-Shift-z'};var historyActionLabels={undo:'Undo',redo:'Redo'};/**
 * Checks if a history action can be executed.
 *
 * @param editor The TipTap editor instance
 * @param action The history action to check
 * @returns Whether the action can be executed
 */function canExecuteHistoryAction(editor,action){if(!editor)return false;return action==='undo'?editor.can().undo():editor.can().redo();}/**
 * Executes a history action on the editor.
 *
 * @param editor The TipTap editor instance
 * @param action The history action to execute
 * @returns Whether the action was executed successfully
 */function executeHistoryAction(editor,action){if(!editor)return false;var chain=editor.chain().focus();return action==='undo'?chain.undo().run():chain.redo().run();}/**
 * Determines if a history action should be disabled.
 *
 * @param editor The TipTap editor instance
 * @param action The history action to check
 * @param userDisabled Whether the action is explicitly disabled by the user
 * @returns Whether the action should be disabled
 */function isHistoryActionDisabled(editor,action,userDisabled){if(userDisabled===void 0){userDisabled=false;}if(userDisabled)return true;return!canExecuteHistoryAction(editor,action);}/**
 * Hook that provides all the necessary state and handlers for a history action.
 *
 * @param editor The TipTap editor instance
 * @param action The history action to handle
 * @param disabled Whether the action is explicitly disabled
 * @returns Object containing state and handlers for the history action
 */function useHistoryAction(editor,action,disabled){if(disabled===void 0){disabled=false;}var canExecute=React__namespace.useMemo(function(){return canExecuteHistoryAction(editor,action);},[editor,action]);var isDisabled=isHistoryActionDisabled(editor,action,disabled);var handleAction=React__namespace.useCallback(function(){if(!editor||isDisabled)return;executeHistoryAction(editor,action);},[editor,action,isDisabled]);var Icon=historyIcons[action];var actionLabel=historyActionLabels[action];var shortcutKey=historyShortcutKeys[action];return{canExecute:canExecute,isDisabled:isDisabled,handleAction:handleAction,Icon:Icon,actionLabel:actionLabel,shortcutKey:shortcutKey};}/**
 * Button component for triggering undo/redo actions in a TipTap editor.
 */var UndoRedoButton=React__namespace.forwardRef(function(_ref,ref){var providedEditor=_ref.editor,action=_ref.action,text=_ref.text,_ref$className=_ref.className,className=_ref$className===void 0?'':_ref$className,disabled=_ref.disabled,onClick=_ref.onClick,children=_ref.children,buttonProps=_objectWithoutPropertiesLoose(_ref,_excluded$H);var editor=useTiptapEditor(providedEditor);var _useHistoryAction=useHistoryAction(editor,action,disabled),isDisabled=_useHistoryAction.isDisabled,handleAction=_useHistoryAction.handleAction,Icon=_useHistoryAction.Icon,actionLabel=_useHistoryAction.actionLabel,shortcutKey=_useHistoryAction.shortcutKey;var handleClick=React__namespace.useCallback(function(e){onClick==null||onClick(e);if(!e.defaultPrevented&&!disabled){handleAction();}},[onClick,disabled,handleAction]);if(!editor||!editor.isEditable){return null;}return jsxRuntime.jsx(Button,_extends({ref:ref,type:"button",className:className.trim(),disabled:isDisabled,"data-style":"ghost","data-disabled":isDisabled,role:"button",tabIndex:-1,"aria-label":actionLabel,tooltip:actionLabel,shortcutKeys:shortcutKey,onClick:handleClick},buttonProps,{children:children||jsxRuntime.jsxs(React__namespace.Fragment,{children:[jsxRuntime.jsx(Icon,{className:"tiptap-button-icon"}),text&&jsxRuntime.jsx("span",{className:"tiptap-button-text",children:text})]})}));});UndoRedoButton.displayName='UndoRedoButton';var _excluded$G=["className"];var BoldIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$G);return jsxRuntime.jsxs("svg",_extends({xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",className:className},props,{children:[jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M6.03906 6.26747C6.03906 5.22193 6.88664 4.37435 7.93218 4.37435H9.9974C11.7233 4.37435 13.1224 5.77346 13.1224 7.49935C13.1224 8.35683 12.777 9.13365 12.2178 9.69829C13.2478 10.2093 13.9557 11.2716 13.9557 12.4993C13.9557 14.2252 12.5566 15.6243 10.8307 15.6243H7.64445C6.75782 15.6243 6.03906 14.9056 6.03906 14.019V6.26747ZM7.28906 9.37435H9.9974C11.0329 9.37435 11.8724 8.53488 11.8724 7.49935C11.8724 6.46382 11.0329 5.62435 9.9974 5.62435H7.93218C7.577 5.62435 7.28906 5.91228 7.28906 6.26747V9.37435ZM7.28906 10.6243V14.019C7.28906 14.2152 7.44818 14.3743 7.64445 14.3743H10.8307C11.8663 14.3743 12.7057 13.5349 12.7057 12.4993C12.7057 11.4638 11.8663 10.6243 10.8307 10.6243H7.28906Z",fill:"currentColor"}),jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M9.94958 1.04102H10.0452C11.9689 1.04101 13.4764 1.041 14.6526 1.19914C15.8566 1.361 16.8066 1.69879 17.5523 2.44446C18.298 3.19014 18.6357 4.14016 18.7976 5.3441C18.9557 6.52034 18.9557 8.02788 18.9557 9.95154V10.0472C18.9557 11.9708 18.9557 13.4784 18.7976 14.6546C18.6357 15.8585 18.298 16.8086 17.5523 17.5542C16.8066 18.2999 15.8566 18.6377 14.6526 18.7996C13.4764 18.9577 11.9689 18.9577 10.0452 18.9577H9.94959C8.02592 18.9577 6.51839 18.9577 5.34215 18.7996C4.1382 18.6377 3.18818 18.2999 2.44251 17.5542C1.69683 16.8086 1.35905 15.8585 1.19718 14.6546C1.03904 13.4784 1.03905 11.9708 1.03906 10.0472V9.95153C1.03905 8.02787 1.03904 6.52034 1.19718 5.3441C1.35905 4.14016 1.69683 3.19014 2.44251 2.44446C3.18818 1.69879 4.1382 1.361 5.34215 1.19914C6.51839 1.041 8.02592 1.04101 9.94958 1.04102ZM5.50871 2.43799C4.44337 2.58122 3.80111 2.85363 3.32639 3.32835C2.85168 3.80306 2.57927 4.44533 2.43604 5.51066C2.29039 6.59398 2.28906 8.0175 2.28906 9.99935C2.28906 11.9812 2.29039 13.4047 2.43604 14.488C2.57927 15.5534 2.85168 16.1956 3.32639 16.6704C3.80111 17.1451 4.44337 17.4175 5.50871 17.5607C6.59203 17.7064 8.01554 17.7077 9.9974 17.7077C11.9793 17.7077 13.4028 17.7064 14.4861 17.5607C15.5514 17.4175 16.1937 17.1451 16.6684 16.6704C17.1431 16.1956 17.4155 15.5534 17.5588 14.488C17.7044 13.4047 17.7057 11.9812 17.7057 9.99935C17.7057 8.0175 17.7044 6.59398 17.5588 5.51066C17.4155 4.44533 17.1431 3.80306 16.6684 3.32835C16.1937 2.85363 15.5514 2.58122 14.4861 2.43799C13.4028 2.29234 11.9793 2.29102 9.9974 2.29102C8.01554 2.29102 6.59203 2.29234 5.50871 2.43799Z",fill:"currentColor"})]}));});BoldIcon.displayName='BoldIcon';var _excluded$F=["className"];var ItalicIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$F);return jsxRuntime.jsxs("svg",_extends({xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",className:className},props,{children:[jsxRuntime.jsx("path",{d:"M8.88629 5.20768H11.0943C11.1035 5.20748 11.1127 5.20748 11.122 5.20768H13.3307C13.6759 5.20768 13.9557 5.4875 13.9557 5.83268C13.9557 6.17786 13.6759 6.45768 13.3307 6.45768H11.5887L9.69979 13.541H11.1085C11.4537 13.541 11.7335 13.8208 11.7335 14.166C11.7335 14.5112 11.4537 14.791 11.1085 14.791H8.90053C8.89133 14.7912 8.88209 14.7912 8.87283 14.791H6.66406C6.31888 14.791 6.03906 14.5112 6.03906 14.166C6.03906 13.8208 6.31888 13.541 6.66406 13.541H8.40611L10.295 6.45768H8.88629C8.54111 6.45768 8.26129 6.17786 8.26129 5.83268C8.26129 5.4875 8.54111 5.20768 8.88629 5.20768Z",fill:"currentColor"}),jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M9.94958 1.04102C8.02592 1.04101 6.51839 1.041 5.34215 1.19914C4.1382 1.361 3.18818 1.69879 2.44251 2.44446C1.69683 3.19014 1.35905 4.14016 1.19718 5.3441C1.03904 6.52034 1.03905 8.02787 1.03906 9.95153V10.0472C1.03905 11.9708 1.03904 13.4784 1.19718 14.6546C1.35905 15.8585 1.69683 16.8086 2.44251 17.5542C3.18818 18.2999 4.1382 18.6377 5.34215 18.7996C6.51839 18.9577 8.02592 18.9577 9.94959 18.9577H10.0452C11.9689 18.9577 13.4764 18.9577 14.6526 18.7996C15.8566 18.6377 16.8066 18.2999 17.5523 17.5542C18.298 16.8086 18.6357 15.8585 18.7976 14.6546C18.9557 13.4784 18.9557 11.9708 18.9557 10.0472V9.95154C18.9557 8.02788 18.9557 6.52034 18.7976 5.3441C18.6357 4.14016 18.298 3.19014 17.5523 2.44446C16.8066 1.69879 15.8566 1.361 14.6526 1.19914C13.4764 1.041 11.9689 1.04101 10.0452 1.04102H9.94958ZM3.32639 3.32835C3.80111 2.85363 4.44337 2.58122 5.50871 2.43799C6.59203 2.29234 8.01554 2.29102 9.9974 2.29102C11.9793 2.29102 13.4028 2.29234 14.4861 2.43799C15.5514 2.58122 16.1937 2.85363 16.6684 3.32835C17.1431 3.80306 17.4155 4.44533 17.5588 5.51066C17.7044 6.59398 17.7057 8.0175 17.7057 9.99935C17.7057 11.9812 17.7044 13.4047 17.5588 14.488C17.4155 15.5534 17.1431 16.1956 16.6684 16.6704C16.1937 17.1451 15.5514 17.4175 14.4861 17.5607C13.4028 17.7064 11.9793 17.7077 9.9974 17.7077C8.01554 17.7077 6.59203 17.7064 5.50871 17.5607C4.44337 17.4175 3.80111 17.1451 3.32639 16.6704C2.85168 16.1956 2.57927 15.5534 2.43604 14.488C2.29039 13.4047 2.28906 11.9812 2.28906 9.99935C2.28906 8.0175 2.29039 6.59398 2.43604 5.51066C2.57927 4.44533 2.85168 3.80306 3.32639 3.32835Z",fill:"currentColor"})]}));});ItalicIcon.displayName='ItalicIcon';var _excluded$E=["className"];var UnderlineIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$E);return jsxRuntime.jsxs("svg",_extends({xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",className:className},props,{children:[jsxRuntime.jsx("path",{d:"M6.03906 14.166C6.03906 13.8208 6.31888 13.541 6.66406 13.541H13.3307C13.6759 13.541 13.9557 13.8208 13.9557 14.166C13.9557 14.5112 13.6759 14.791 13.3307 14.791H6.66406C6.31888 14.791 6.03906 14.5112 6.03906 14.166Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M7.28906 5.83268C7.28906 5.4875 7.00924 5.20768 6.66406 5.20768C6.31888 5.20768 6.03906 5.4875 6.03906 5.83268V8.33268C6.03906 10.5188 7.81127 12.291 9.9974 12.291C12.1835 12.291 13.9557 10.5188 13.9557 8.33268V5.83268C13.9557 5.4875 13.6759 5.20768 13.3307 5.20768C12.9856 5.20768 12.7057 5.4875 12.7057 5.83268V8.33268C12.7057 9.82845 11.4932 11.041 9.9974 11.041C8.50162 11.041 7.28906 9.82845 7.28906 8.33268V5.83268Z",fill:"currentColor"}),jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M9.94958 1.04102H10.0452C11.9689 1.04101 13.4764 1.041 14.6526 1.19914C15.8566 1.361 16.8066 1.69879 17.5523 2.44446C18.298 3.19014 18.6357 4.14016 18.7976 5.3441C18.9557 6.52034 18.9557 8.02788 18.9557 9.95154V10.0472C18.9557 11.9708 18.9557 13.4784 18.7976 14.6546C18.6357 15.8585 18.298 16.8086 17.5523 17.5542C16.8066 18.2999 15.8566 18.6377 14.6526 18.7996C13.4764 18.9577 11.9689 18.9577 10.0452 18.9577H9.94959C8.02592 18.9577 6.51839 18.9577 5.34215 18.7996C4.1382 18.6377 3.18818 18.2999 2.44251 17.5542C1.69683 16.8086 1.35905 15.8585 1.19718 14.6546C1.03904 13.4784 1.03905 11.9708 1.03906 10.0472V9.95153C1.03905 8.02787 1.03904 6.52034 1.19718 5.3441C1.35905 4.14016 1.69683 3.19014 2.44251 2.44446C3.18818 1.69879 4.1382 1.361 5.34215 1.19914C6.51839 1.041 8.02592 1.04101 9.94958 1.04102ZM5.50871 2.43799C4.44337 2.58122 3.80111 2.85363 3.32639 3.32835C2.85168 3.80306 2.57927 4.44533 2.43604 5.51066C2.29039 6.59398 2.28906 8.0175 2.28906 9.99935C2.28906 11.9812 2.29039 13.4047 2.43604 14.488C2.57927 15.5534 2.85168 16.1956 3.32639 16.6704C3.80111 17.1451 4.44337 17.4175 5.50871 17.5607C6.59203 17.7064 8.01554 17.7077 9.9974 17.7077C11.9793 17.7077 13.4028 17.7064 14.4861 17.5607C15.5514 17.4175 16.1937 17.1451 16.6684 16.6704C17.1431 16.1956 17.4155 15.5534 17.5588 14.488C17.7044 13.4047 17.7057 11.9812 17.7057 9.99935C17.7057 8.0175 17.7044 6.59398 17.5588 5.51066C17.4155 4.44533 17.1431 3.80306 16.6684 3.32835C16.1937 2.85363 15.5514 2.58122 14.4861 2.43799C13.4028 2.29234 11.9793 2.29102 9.9974 2.29102C8.01554 2.29102 6.59203 2.29234 5.50871 2.43799Z",fill:"currentColor"})]}));});UnderlineIcon.displayName='UnderlineIcon';var _excluded$D=["className"];var StrikeIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$D);return jsxRuntime.jsxs("svg",_extends({width:"24",height:"24",className:className,viewBox:"0 0 24 24",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg"},props,{children:[jsxRuntime.jsx("path",{d:"M9.00039 3H16.0001C16.5524 3 17.0001 3.44772 17.0001 4C17.0001 4.55229 16.5524 5 16.0001 5H9.00011C8.68006 4.99983 8.36412 5.07648 8.07983 5.22349C7.79555 5.37051 7.55069 5.5836 7.36585 5.84487C7.181 6.10614 7.06155 6.40796 7.01754 6.72497C6.97352 7.04198 7.00623 7.36492 7.11292 7.66667C7.29701 8.18737 7.02414 8.75872 6.50344 8.94281C5.98274 9.1269 5.4114 8.85403 5.2273 8.33333C5.01393 7.72984 4.94851 7.08396 5.03654 6.44994C5.12456 5.81592 5.36346 5.21229 5.73316 4.68974C6.10285 4.1672 6.59256 3.74101 7.16113 3.44698C7.72955 3.15303 8.36047 2.99975 9.00039 3Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M18 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H14C14.7956 13 15.5587 13.3161 16.1213 13.8787C16.6839 14.4413 17 15.2044 17 16C17 16.7956 16.6839 17.5587 16.1213 18.1213C15.5587 18.6839 14.7956 19 14 19H6C5.44772 19 5 19.4477 5 20C5 20.5523 5.44772 21 6 21H14C15.3261 21 16.5979 20.4732 17.5355 19.5355C18.4732 18.5979 19 17.3261 19 16C19 14.9119 18.6453 13.8604 18 13Z",fill:"currentColor"})]}));});StrikeIcon.displayName='StrikeIcon';var _excluded$C=["className"];var Code2Icon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$C);return jsxRuntime.jsxs("svg",_extends({width:"24",height:"24",className:className,viewBox:"0 0 24 24",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg"},props,{children:[jsxRuntime.jsx("path",{d:"M15.4545 4.2983C15.6192 3.77115 15.3254 3.21028 14.7983 3.04554C14.2712 2.88081 13.7103 3.1746 13.5455 3.70175L8.54554 19.7017C8.38081 20.2289 8.6746 20.7898 9.20175 20.9545C9.72889 21.1192 10.2898 20.8254 10.4545 20.2983L15.4545 4.2983Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M6.70711 7.29289C7.09763 7.68342 7.09763 8.31658 6.70711 8.70711L3.41421 12L6.70711 15.2929C7.09763 15.6834 7.09763 16.3166 6.70711 16.7071C6.31658 17.0976 5.68342 17.0976 5.29289 16.7071L1.29289 12.7071C0.902369 12.3166 0.902369 11.6834 1.29289 11.2929L5.29289 7.29289C5.68342 6.90237 6.31658 6.90237 6.70711 7.29289Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M17.2929 7.29289C17.6834 6.90237 18.3166 6.90237 18.7071 7.29289L22.7071 11.2929C23.0976 11.6834 23.0976 12.3166 22.7071 12.7071L18.7071 16.7071C18.3166 17.0976 17.6834 17.0976 17.2929 16.7071C16.9024 16.3166 16.9024 15.6834 17.2929 15.2929L20.5858 12L17.2929 8.70711C16.9024 8.31658 16.9024 7.68342 17.2929 7.29289Z",fill:"currentColor"})]}));});Code2Icon.displayName='Code2Icon';var _excluded$B=["className"];var SuperscriptIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$B);return jsxRuntime.jsxs("svg",_extends({width:"24",height:"24",className:className,viewBox:"0 0 24 24",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg"},props,{children:[jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M12.7071 7.29289C13.0976 7.68342 13.0976 8.31658 12.7071 8.70711L4.70711 16.7071C4.31658 17.0976 3.68342 17.0976 3.29289 16.7071C2.90237 16.3166 2.90237 15.6834 3.29289 15.2929L11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289Z",fill:"currentColor"}),jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M3.29289 7.29289C3.68342 6.90237 4.31658 6.90237 4.70711 7.29289L12.7071 15.2929C13.0976 15.6834 13.0976 16.3166 12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L3.29289 8.70711C2.90237 8.31658 2.90237 7.68342 3.29289 7.29289Z",fill:"currentColor"}),jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M17.405 1.40657C18.0246 1.05456 18.7463 0.92634 19.4492 1.04344C20.1521 1.16054 20.7933 1.51583 21.2652 2.0497L21.2697 2.05469L21.2696 2.05471C21.7431 2.5975 22 3.28922 22 4.00203C22 5.08579 21.3952 5.84326 20.7727 6.34289C20.1966 6.80531 19.4941 7.13675 18.9941 7.37261C18.9714 7.38332 18.9491 7.39383 18.9273 7.40415C18.4487 7.63034 18.2814 7.78152 18.1927 7.91844C18.1778 7.94155 18.1625 7.96834 18.1473 8.00003H21C21.5523 8.00003 22 8.44774 22 9.00003C22 9.55231 21.5523 10 21 10H17C16.4477 10 16 9.55231 16 9.00003C16 8.17007 16.1183 7.44255 16.5138 6.83161C16.9107 6.21854 17.4934 5.86971 18.0728 5.59591C18.6281 5.33347 19.1376 5.09075 19.5208 4.78316C19.8838 4.49179 20 4.25026 20 4.00203C20 3.77192 19.9178 3.54865 19.7646 3.37182C19.5968 3.18324 19.3696 3.05774 19.1205 3.01625C18.8705 2.97459 18.6137 3.02017 18.3933 3.14533C18.1762 3.26898 18.0191 3.45826 17.9406 3.67557C17.7531 4.19504 17.18 4.46414 16.6605 4.27662C16.141 4.0891 15.8719 3.51596 16.0594 2.99649C16.303 2.3219 16.7817 1.76125 17.4045 1.40689L17.405 1.40657Z",fill:"currentColor"})]}));});SuperscriptIcon.displayName='SuperscriptIcon';var _excluded$A=["className"];var SubscriptIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$A);return jsxRuntime.jsxs("svg",_extends({width:"24",height:"24",className:className,viewBox:"0 0 24 24",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg"},props,{children:[jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M3.29289 7.29289C3.68342 6.90237 4.31658 6.90237 4.70711 7.29289L12.7071 15.2929C13.0976 15.6834 13.0976 16.3166 12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L3.29289 8.70711C2.90237 8.31658 2.90237 7.68342 3.29289 7.29289Z",fill:"currentColor"}),jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M12.7071 7.29289C13.0976 7.68342 13.0976 8.31658 12.7071 8.70711L4.70711 16.7071C4.31658 17.0976 3.68342 17.0976 3.29289 16.7071C2.90237 16.3166 2.90237 15.6834 3.29289 15.2929L11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289Z",fill:"currentColor"}),jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M17.4079 14.3995C18.0284 14.0487 18.7506 13.9217 19.4536 14.0397C20.1566 14.1578 20.7977 14.5138 21.2696 15.0481L21.2779 15.0574L21.2778 15.0575C21.7439 15.5988 22 16.2903 22 17C22 18.0823 21.3962 18.8401 20.7744 19.3404C20.194 19.8073 19.4858 20.141 18.9828 20.378C18.9638 20.387 18.9451 20.3958 18.9266 20.4045C18.4473 20.6306 18.2804 20.7817 18.1922 20.918C18.1773 20.9412 18.1619 20.9681 18.1467 21H21C21.5523 21 22 21.4477 22 22C22 22.5523 21.5523 23 21 23H17C16.4477 23 16 22.5523 16 22C16 21.1708 16.1176 20.4431 16.5128 19.832C16.9096 19.2184 17.4928 18.8695 18.0734 18.5956C18.6279 18.334 19.138 18.0901 19.5207 17.7821C19.8838 17.49 20 17.2477 20 17C20 16.7718 19.9176 16.5452 19.7663 16.3672C19.5983 16.1792 19.3712 16.0539 19.1224 16.0121C18.8722 15.9701 18.6152 16.015 18.3942 16.1394C18.1794 16.2628 18.0205 16.4549 17.9422 16.675C17.7572 17.1954 17.1854 17.4673 16.665 17.2822C16.1446 17.0972 15.8728 16.5254 16.0578 16.005C16.2993 15.3259 16.7797 14.7584 17.4039 14.4018L17.4079 14.3995L17.4079 14.3995Z",fill:"currentColor"})]}));});SubscriptIcon.displayName='SubscriptIcon';var MAX_FILE_SIZE=5*1024*1024;// 5MB
/**
 * Checks if a mark exists in the editor schema
 *
 * @param markName - The name of the mark to check
 * @param editor - The editor instance
 */var isMarkInSchema=function isMarkInSchema(markName,editor){return(editor==null?void 0:editor.schema.spec.marks.get(markName))!==undefined;};/**
 * Checks if a node exists in the editor schema
 *
 * @param nodeName - The name of the node to check
 * @param editor - The editor instance
 */var isNodeInSchema=function isNodeInSchema(nodeName,editor){return(editor==null?void 0:editor.schema.spec.nodes.get(nodeName))!==undefined;};var generateUUID=function generateUUID(){// Polyfill thuần v4
return'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,function(c){var r=crypto.getRandomValues(new Uint8Array(1))[0]&15;var v=c==='x'?r:r&0x3|0x8;return v.toString(16);});};var _excluded$z=["className"];var ColorIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$z);return jsxRuntime.jsxs("svg",_extends({xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",className:className},props,{children:[jsxRuntime.jsx("path",{d:"M10.0031 9.99919L5.42054 0.832031L0.835938 9.99817",stroke:"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}),jsxRuntime.jsx("path",{d:"M1.75 8.16358H9.08169",stroke:"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}),jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M12.6736 18.8377L18.8411 12.6702C19.2791 12.2323 19.2791 11.5233 18.8411 11.0864L17.0637 9.30896C16.6257 8.87097 15.9168 8.87097 15.4798 9.30896L9.31236 15.4764C9.10151 15.6873 8.98438 15.9714 8.98438 16.2679V19.1657H11.8822C12.1786 19.1657 12.4628 19.0486 12.6736 18.8377Z",fill:"#1C274C"})]}));});ColorIcon.displayName='ColorIcon';var _excluded$y=["editor","type","text","hideWhenUnavailable","className","disabled","onClick","children"];var markIcons={bold:BoldIcon,italic:ItalicIcon,underline:UnderlineIcon,strike:StrikeIcon,code:Code2Icon,superscript:SuperscriptIcon,subscript:SubscriptIcon,color:ColorIcon};var markShortcutKeys={bold:'Ctrl-b',italic:'Ctrl-i',underline:'Ctrl-u',strike:'Ctrl-Shift-s',code:'Ctrl-e',superscript:'Ctrl-.',subscript:'Ctrl-,',color:'Ctrl-Shift-c'};function canToggleMark(editor,type){if(!editor)return false;try{return editor.can().toggleMark(type);}catch(_unused){return false;}}function isMarkActive(editor,type){if(!editor)return false;return editor.isActive(type);}function toggleMark(editor,type){if(!editor)return;editor.chain().focus().toggleMark(type).run();}function isMarkButtonDisabled(editor,type,userDisabled){if(userDisabled===void 0){userDisabled=false;}if(!editor)return true;if(userDisabled)return true;if(editor.isActive('codeBlock'))return true;if(!canToggleMark(editor,type))return true;return false;}function shouldShowMarkButton(params){var editor=params.editor,type=params.type,hideWhenUnavailable=params.hideWhenUnavailable,markInSchema=params.markInSchema;if(!markInSchema){return false;}if(hideWhenUnavailable){if(react.isNodeSelection(editor==null?void 0:editor.state.selection)||!canToggleMark(editor,type)){return false;}}return true;}function getFormattedMarkName(type){return type.charAt(0).toUpperCase()+type.slice(1);}function useMarkState(editor,type,disabled){if(disabled===void 0){disabled=false;}var markInSchema=isMarkInSchema(type,editor);var isDisabled=isMarkButtonDisabled(editor,type,disabled);var isActive=isMarkActive(editor,type);var Icon=markIcons[type];var shortcutKey=markShortcutKeys[type];var formattedName=getFormattedMarkName(type);return{markInSchema:markInSchema,isDisabled:isDisabled,isActive:isActive,Icon:Icon,shortcutKey:shortcutKey,formattedName:formattedName};}var MarkButton=React__namespace.forwardRef(function(_ref,ref){var providedEditor=_ref.editor,type=_ref.type,text=_ref.text,_ref$hideWhenUnavaila=_ref.hideWhenUnavailable,hideWhenUnavailable=_ref$hideWhenUnavaila===void 0?false:_ref$hideWhenUnavaila,_ref$className=_ref.className,className=_ref$className===void 0?'':_ref$className,disabled=_ref.disabled,onClick=_ref.onClick,children=_ref.children,buttonProps=_objectWithoutPropertiesLoose(_ref,_excluded$y);var editor=useTiptapEditor(providedEditor);var _useMarkState=useMarkState(editor,type,disabled),markInSchema=_useMarkState.markInSchema,isDisabled=_useMarkState.isDisabled,isActive=_useMarkState.isActive,Icon=_useMarkState.Icon,shortcutKey=_useMarkState.shortcutKey,formattedName=_useMarkState.formattedName;var handleClick=React__namespace.useCallback(function(e){onClick==null||onClick(e);if(!e.defaultPrevented&&!isDisabled&&editor){toggleMark(editor,type);}},[onClick,isDisabled,editor,type]);var show=React__namespace.useMemo(function(){return shouldShowMarkButton({editor:editor,type:type,hideWhenUnavailable:hideWhenUnavailable,markInSchema:markInSchema});},[editor,type,hideWhenUnavailable,markInSchema]);if(!show||!editor||!editor.isEditable){return null;}return jsxRuntime.jsx(Button,_extends({type:"button",className:className.trim(),disabled:isDisabled,"data-style":"ghost","data-active-state":isActive?'on':'off',"data-disabled":isDisabled,"data-size":"large",role:"button",tabIndex:-1,"aria-label":type,"aria-pressed":isActive,tooltip:formattedName,shortcutKeys:shortcutKey,onClick:handleClick},buttonProps,{ref:ref,children:children||jsxRuntime.jsxs(React__namespace.Fragment,{children:[jsxRuntime.jsx(Icon,{className:"tiptap-button-icon"}),text&&jsxRuntime.jsx("span",{className:"tiptap-button-text",children:text})]})}));});MarkButton.displayName='MarkButton';var TableIcon=function TableIcon(_ref){var className=_ref.className;return jsxRuntime.jsx("svg",{xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",className:className,children:jsxRuntime.jsx("path",{d:"M16.875 10.625H10.625V16.875H15C16.0355 16.875 16.875 16.0355 16.875 15V10.625ZM3.125 15C3.125 16.0355 3.96447 16.875 5 16.875H9.375V10.625H3.125V15ZM16.875 5C16.875 3.96447 16.0355 3.125 15 3.125H10.625V9.375H16.875V5ZM3.125 9.375H9.375V3.125H5C3.96447 3.125 3.125 3.96447 3.125 5V9.375ZM18.125 15C18.125 16.7259 16.7259 18.125 15 18.125H5C3.27411 18.125 1.875 16.7259 1.875 15V5C1.875 3.27411 3.27411 1.875 5 1.875H15C16.7259 1.875 18.125 3.27411 18.125 5V15Z",fill:"currentColor"})});};var _excluded$x=["children","modal"],_excluded2$4=["children","asChild"],_excluded3$2=["className","side","align","style","portal","portalProps"];var PopoverContext=React__namespace.createContext(null);function usePopoverContext(){var context=React__namespace.useContext(PopoverContext);if(!context){throw new Error('Popover components must be wrapped in <Popover />');}return context;}function usePopover(_temp){var _ref=_temp===void 0?{}:_temp,_ref$initialOpen=_ref.initialOpen,initialOpen=_ref$initialOpen===void 0?false:_ref$initialOpen,modal=_ref.modal,controlledOpen=_ref.open,setControlledOpen=_ref.onOpenChange,_ref$side=_ref.side,side=_ref$side===void 0?'bottom':_ref$side,_ref$align=_ref.align,align=_ref$align===void 0?'center':_ref$align;var _React$useState=React__namespace.useState(initialOpen),uncontrolledOpen=_React$useState[0],setUncontrolledOpen=_React$useState[1];var _React$useState2=React__namespace.useState(),labelId=_React$useState2[0],setLabelId=_React$useState2[1];var _React$useState3=React__namespace.useState(),descriptionId=_React$useState3[0],setDescriptionId=_React$useState3[1];var _React$useState4=React__namespace.useState(side+"-"+align),currentPlacement=_React$useState4[0],setCurrentPlacement=_React$useState4[1];var open=controlledOpen||uncontrolledOpen;var setOpen=setControlledOpen||setUncontrolledOpen;var middleware=React__namespace.useMemo(function(){return[react$1.offset(4),react$1.flip({fallbackAxisSideDirection:'end',crossAxis:false}),react$1.shift({limiter:react$1.limitShift({offset:4})})];},[]);var floating=react$1.useFloating({placement:currentPlacement,open:open,onOpenChange:setOpen,whileElementsMounted:react$1.autoUpdate,middleware:middleware});var interactions=react$1.useInteractions([react$1.useClick(floating.context),react$1.useDismiss(floating.context),react$1.useRole(floating.context)]);var updatePosition=React__namespace.useCallback(function(newSide,newAlign){setCurrentPlacement(newSide+"-"+newAlign);},[]);return React__namespace.useMemo(function(){return _extends({open:open,setOpen:setOpen},interactions,floating,{modal:modal,labelId:labelId,descriptionId:descriptionId,setLabelId:setLabelId,setDescriptionId:setDescriptionId,updatePosition:updatePosition});},[open,setOpen,interactions,floating,modal,labelId,descriptionId,updatePosition]);}function Popover(_ref2){var children=_ref2.children,_ref2$modal=_ref2.modal,modal=_ref2$modal===void 0?false:_ref2$modal,options=_objectWithoutPropertiesLoose(_ref2,_excluded$x);var popover=usePopover(_extends({modal:modal},options));return jsxRuntime.jsx(PopoverContext.Provider,{value:popover,children:children});}var PopoverTrigger=React__namespace.forwardRef(function PopoverTrigger(_ref3,propRef){var children=_ref3.children,_ref3$asChild=_ref3.asChild,asChild=_ref3$asChild===void 0?false:_ref3$asChild,props=_objectWithoutPropertiesLoose(_ref3,_excluded2$4);var context=usePopoverContext();var childrenRef=React__namespace.isValidElement(children)?parseInt(React__namespace.version,10)>=19?children.props.ref:children.ref:undefined;var ref=react$1.useMergeRefs([context.refs.setReference,propRef,childrenRef]);if(asChild&&React__namespace.isValidElement(children)){return React__namespace.cloneElement(children,context.getReferenceProps(_extends({ref:ref},props,children.props,{'data-state':context.open?'open':'closed'})));}return jsxRuntime.jsx("button",_extends({ref:ref,"data-state":context.open?'open':'closed'},context.getReferenceProps(props),{children:children}));});var PopoverContent=React__namespace.forwardRef(function PopoverContent(_ref4,propRef){var className=_ref4.className,_ref4$side=_ref4.side,side=_ref4$side===void 0?'bottom':_ref4$side,_ref4$align=_ref4.align,align=_ref4$align===void 0?'center':_ref4$align,style=_ref4.style,_ref4$portal=_ref4.portal,portal=_ref4$portal===void 0?true:_ref4$portal,_ref4$portalProps=_ref4.portalProps,portalProps=_ref4$portalProps===void 0?{}:_ref4$portalProps,props=_objectWithoutPropertiesLoose(_ref4,_excluded3$2);var context=usePopoverContext();var ref=react$1.useMergeRefs([context.refs.setFloating,propRef]);React__namespace.useEffect(function(){context.updatePosition(side,align);},[context,side,align]);if(!context.context.open)return null;var content=jsxRuntime.jsx(react$1.FloatingFocusManager,{context:context.context,modal:context.modal,children:jsxRuntime.jsx("div",_extends({ref:ref,style:_extends({position:context.strategy,top:context.y||0,left:context.x||0},style),"aria-labelledby":context.labelId,"aria-describedby":context.descriptionId,className:"tiptap-popover "+(className||''),"data-side":side,"data-align":align,"data-state":context.context.open?'open':'closed'},context.getFloatingProps(props),{children:props.children}))});if(portal){return jsxRuntime.jsx(react$1.FloatingPortal,_extends({},portalProps,{children:content}));}return content;});PopoverTrigger.displayName='PopoverTrigger';PopoverContent.displayName='PopoverContent';var _excluded$w=["className"];var HighlighterIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$w);return jsxRuntime.jsx("svg",_extends({xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",className:className},props,{children:jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M11.2394 2.5905C10.2755 1.6365 8.71535 1.6365 7.75144 2.5905L1.88187 8.39975C1.39899 8.87767 1.15625 9.50658 1.15625 10.1348C1.15625 10.7632 1.39899 11.3921 1.88187 11.87L5.79492 15.7428C6.75883 16.6968 8.319 16.6968 9.28293 15.7428L14.4284 10.6502L16.9465 9.40408C17.1275 9.3145 17.2541 9.14308 17.2864 8.94375C17.3186 8.74442 17.2525 8.54175 17.109 8.39975L11.2394 2.5905ZM15.6073 8.67217L13.9144 9.50983H2.58407C2.63295 9.43117 2.69197 9.35667 2.76118 9.28817L8.63077 3.47894C9.1076 3.00702 9.88327 3.00702 10.3601 3.47894L15.6073 8.67217ZM16.6572 17.4878C17.4905 17.4878 18.3239 16.9935 18.3239 15.6128C18.3239 14.2321 16.6572 12.4878 16.6572 12.4878C16.6572 12.4878 14.9905 14.2321 14.9905 15.6128C14.9905 16.9935 15.8239 17.4878 16.6572 17.4878Z",fill:"currentColor"})}));});HighlighterIcon.displayName='HighlighterIcon';function useMenuNavigation(_ref){var editor=_ref.editor,containerRef=_ref.containerRef,query=_ref.query,items=_ref.items,onSelect=_ref.onSelect,onClose=_ref.onClose,_ref$orientation=_ref.orientation,orientation=_ref$orientation===void 0?'vertical':_ref$orientation,_ref$autoSelectFirstI=_ref.autoSelectFirstItem,autoSelectFirstItem=_ref$autoSelectFirstI===void 0?true:_ref$autoSelectFirstI;var _React$useState=React__namespace.useState(autoSelectFirstItem?0:-1),selectedIndex=_React$useState[0],setSelectedIndex=_React$useState[1];React__namespace.useEffect(function(){var handleKeyboardNavigation=function handleKeyboardNavigation(event){if(!items.length)return false;var moveNext=function moveNext(){return setSelectedIndex(function(currentIndex){if(currentIndex===-1)return 0;return(currentIndex+1)%items.length;});};var movePrev=function movePrev(){return setSelectedIndex(function(currentIndex){if(currentIndex===-1)return items.length-1;return(currentIndex-1+items.length)%items.length;});};switch(event.key){case'ArrowUp':{if(orientation==='horizontal')return false;event.preventDefault();movePrev();return true;}case'ArrowDown':{if(orientation==='horizontal')return false;event.preventDefault();moveNext();return true;}case'ArrowLeft':{if(orientation==='vertical')return false;event.preventDefault();movePrev();return true;}case'ArrowRight':{if(orientation==='vertical')return false;event.preventDefault();moveNext();return true;}case'Tab':{event.preventDefault();if(event.shiftKey){movePrev();}else{moveNext();}return true;}case'Home':{event.preventDefault();setSelectedIndex(0);return true;}case'End':{event.preventDefault();setSelectedIndex(items.length-1);return true;}case'Enter':{if(event.isComposing)return false;event.preventDefault();if(selectedIndex!==-1&&items[selectedIndex]){onSelect==null||onSelect(items[selectedIndex]);}return true;}case'Escape':{event.preventDefault();onClose==null||onClose();return true;}default:return false;}};var targetElement=null;if(editor){targetElement=editor.view.dom;}else if(containerRef!=null&&containerRef.current){targetElement=containerRef.current;}if(targetElement){targetElement.addEventListener('keydown',handleKeyboardNavigation,true);return function(){var _targetElement;(_targetElement=targetElement)==null||_targetElement.removeEventListener('keydown',handleKeyboardNavigation,true);};}return undefined;},[editor,containerRef,items,selectedIndex,onSelect,onClose,orientation]);React__namespace.useEffect(function(){if(query){setSelectedIndex(autoSelectFirstItem?0:-1);}},[query,autoSelectFirstItem]);return{selectedIndex:items.length?selectedIndex:undefined,setSelectedIndex:setSelectedIndex};}var _excluded$v=["className","width","height"];var ChevronDownIcon=React__namespace.memo(function(_ref){var className=_ref.className,_ref$width=_ref.width,width=_ref$width===void 0?'24px':_ref$width,_ref$height=_ref.height,height=_ref$height===void 0?'24px':_ref$height,props=_objectWithoutPropertiesLoose(_ref,_excluded$v);return jsxRuntime.jsx("svg",_extends({xmlns:"http://www.w3.org/2000/svg",width:width,height:height,className:className},props,{viewBox:"0 0 16 16",fill:"none",children:jsxRuntime.jsx("path",{d:"M8.24954 10.5574L12.536 6.1371C12.8035 5.86128 12.6413 5.33398 12.2891 5.33398H3.71614C3.36386 5.33398 3.20173 5.86128 3.4692 6.1371L7.75567 10.5574C7.89776 10.704 8.10744 10.704 8.24954 10.5574Z",fill:"currentColor"})}));});ChevronDownIcon.displayName='ChevronDownIcon';var _excluded$u=["className"];var CheckIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$u);return jsxRuntime.jsxs("svg",_extends({width:"24",height:"24",viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",className:className},props,{children:[jsxRuntime.jsx("g",{id:"SVGRepo_bgCarrier","stroke-width":"0"}),jsxRuntime.jsx("g",{id:"SVGRepo_tracerCarrier","stroke-linecap":"round","stroke-linejoin":"round"}),jsxRuntime.jsxs("g",{id:"SVGRepo_iconCarrier",children:[" ",jsxRuntime.jsx("path",{d:"M9 12L10.5 13.5V13.5C10.7761 13.7761 11.2239 13.7761 11.5 13.5V13.5L15 10",stroke:"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"})," "]})]}));});CheckIcon.displayName='CheckIcon';var _excluded$t=["className","children"],_excluded2$3=["editor","colors","hideWhenUnavailable"];var DEFAULT_HIGHLIGHT_COLORS=[{label:'Black-900',value:'#1A1A1A',border:'#999999'},{label:'Black-400',value:'#999999',border:'#999999'},{label:'Black-300',value:'#B3B3B3',border:'#B3B3B3'},{label:'Black-200',value:'#CCCCCC',border:'#CCCCCC'},{label:'Black-100',value:'#E6E6E6',border:'#E6E6E6'},{label:'White',value:'#FFFFFF',border:'#FFFFFF'},// Red
{label:'Red-500',value:'#FF0000',border:'#FF0000'},{label:'Red-50',value:'#FFE5E5',border:'#FFE5E5'},{label:'Red-100',value:'#EA9999',border:'#EA9999'},{label:'Red-700',value:'#CC0000',border:'#CC0000'},{label:'Red-800',value:'#990000',border:'#990000'},{label:'Red-900',value:'#660000',border:'#660000'},// Orange
{label:'Orange-500',value:'#FF9900',border:'#FF9900'},{label:'Orange-50',value:'#FCE5CD',border:'#FCE5CD'},{label:'Orange-100',value:'#F9CB9C',border:'#F9CB9C'},{label:'Orange-700',value:'#E69138',border:'#E69138'},{label:'Orange-800',value:'#B45F06',border:'#B45F06'},{label:'Orange-900',value:'#783F04',border:'#783F04'},// Yellow
{label:'Yellow-500',value:'#FFFF00',border:'#FFFF00'},{label:'Yellow-50',value:'#FFF2CC',border:'#FFF2CC'},{label:'Yellow-100',value:'#FFE599',border:'#FFE599'},{label:'Yellow-700',value:'#FFD466',border:'#FFD466'},{label:'Yellow-800',value:'#BF9000',border:'#BF9000'},{label:'Yellow-900',value:'#7F6000',border:'#7F6000'},// Green
{label:'Green-500',value:'#00FF00',border:'#00FF00'},{label:'Green-50',value:'#D9EAD3',border:'#D9EAD3'},{label:'Green-100',value:'#B6D7A8',border:'#B6D7A8'},{label:'Green-700',value:'#6AA84F',border:'#6AA84F'},{label:'Green-800',value:'#38761D',border:'#38761D'},{label:'Green-900',value:'#274E13',border:'#274E13'},// Mint
{label:'Mint-500',value:'#00FFFF',border:'#00FFFF'},{label:'Mint-50',value:'#D0E0E3',border:'#D0E0E3'},{label:'Mint-100',value:'#A2C4C9',border:'#A2C4C9'},{label:'Mint-700',value:'#45818E',border:'#45818E'},{label:'Mint-800',value:'#134F5C',border:'#134F5C'},{label:'Mint-900',value:'#0C343D',border:'#0C343D'},// Blue
{label:'Blue-500',value:'#4B86E8',border:'#4B86E8'},{label:'Blue-50',value:'#C9DAF8',border:'#C9DAF8'},{label:'Blue-100',value:'#6D9EEB',border:'#6D9EEB'},{label:'Blue-700',value:'#3C78D8',border:'#3C78D8'},{label:'Blue-800',value:'#1155CC',border:'#1155CC'},{label:'Blue-900',value:'#1C4587',border:'#1C4587'},// Purple
{label:'Purple-500',value:'#9900FF',border:'#9900FF'},{label:'Purple-50',value:'#D9D2E9',border:'#D9D2E9'},{label:'Purple-100',value:'#B4A7D6',border:'#B4A7D6'},{label:'Purple-700',value:'#674EA7',border:'#674EA7'},{label:'Purple-800',value:'#351C75',border:'#351C75'},{label:'Purple-900',value:'#20124D',border:'#20124D'},// Pink
{label:'Pink-500',value:'#FF00FF',border:'#FF00FF'},{label:'Pink-50',value:'#EAD1DC',border:'#EAD1DC'},{label:'Pink-100',value:'#D5A6BD',border:'#D5A6BD'},{label:'Pink-700',value:'#A64D79',border:'#A64D79'},{label:'Pink-800',value:'#741B47',border:'#741B47'},{label:'Pink-900',value:'#4C1130',border:'#4C1130'}];var useHighlighter=function useHighlighter(editor){var markAvailable=isMarkInSchema('highlight',editor);var getActiveColor=React__namespace.useCallback(function(){if(!editor)return null;if(!editor.isActive('highlight'))return null;var attrs=editor.getAttributes('highlight');return attrs.color||null;},[editor]);var toggleHighlight=React__namespace.useCallback(function(color){if(!markAvailable||!editor)return;if(color==='none'){editor.chain().focus().unsetMark('highlight').run();}else{editor.chain().focus().toggleMark('highlight',{color:color}).run();}},[markAvailable,editor]);return{markAvailable:markAvailable,getActiveColor:getActiveColor,toggleHighlight:toggleHighlight};};var HighlighterButton=React__namespace.forwardRef(function(_ref,ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$t);return jsxRuntime.jsxs(Button,_extends({type:"button",className:className,"data-style":"ghost","data-appearance":"default",role:"button",tabIndex:-1,"aria-label":"Highlight text",tooltip:"Highlight","data-size":'large',ref:ref},props,{children:[jsxRuntime.jsx(HighlighterIcon,{className:"tiptap-button-icon"}),jsxRuntime.jsx(ChevronDownIcon,{width:'16px',height:'16px',className:"tiptap-button-dropdown-small"})]}));});function HighlightContent(_ref2){var providedEditor=_ref2.editor,_ref2$colors=_ref2.colors,colors=_ref2$colors===void 0?DEFAULT_HIGHLIGHT_COLORS:_ref2$colors,onClose=_ref2.onClose;var editor=useTiptapEditor(providedEditor);var ROWS_PER_COLUMN=6;// Tính padding để cột cuối không bị "lệch"
var remainder=colors.length%ROWS_PER_COLUMN;remainder===0?colors:[].concat(colors,Array(ROWS_PER_COLUMN-remainder).fill(null));var containerRef=React__namespace.useRef(null);var _useHighlighter=useHighlighter(editor),getActiveColor=_useHighlighter.getActiveColor,toggleHighlight=_useHighlighter.toggleHighlight;var activeColor=getActiveColor();var menuItems=React__namespace.useMemo(function(){return[].concat(colors,[{label:'Remove highlight',value:'none'}]);},[colors]);var _useMenuNavigation=useMenuNavigation({containerRef:containerRef,items:menuItems,orientation:'both',onSelect:function onSelect(item){toggleHighlight(item.value);onClose==null||onClose();},onClose:onClose,autoSelectFirstItem:false}),selectedIndex=_useMenuNavigation.selectedIndex;return jsxRuntime.jsxs("div",{ref:containerRef,className:"tiptap-highlight-content",tabIndex:0,children:[jsxRuntime.jsx("div",{className:'sapp-background-none',onClick:function onClick(){return toggleHighlight('none');},children:"None"}),jsxRuntime.jsx("div",{className:"sapp-background-dropdown-menu","data-orientation":"horizontal",children:colors.map(function(color,index){return jsxRuntime.jsx(Button,{type:"button",role:"menuitem","data-active-state":activeColor===color.value?'on':'off',"aria-label":color.label+" highlight color",tabIndex:index===selectedIndex?0:-1,"data-style":"ghost",onClick:function onClick(){return toggleHighlight(color.value);},"data-highlighted":selectedIndex===index,className:'',children:jsxRuntime.jsx("span",{className:"tiptap-button-highlight",style:{'--highlight-color':color.value},children:activeColor===color.value?jsxRuntime.jsx(CheckIcon,{style:{color:'white'}}):jsxRuntime.jsx("span",{})})},color.value);})})]});}function HighlightPopover(_ref3){var providedEditor=_ref3.editor,_ref3$colors=_ref3.colors,colors=_ref3$colors===void 0?DEFAULT_HIGHLIGHT_COLORS:_ref3$colors,_ref3$hideWhenUnavail=_ref3.hideWhenUnavailable,hideWhenUnavailable=_ref3$hideWhenUnavail===void 0?false:_ref3$hideWhenUnavail,props=_objectWithoutPropertiesLoose(_ref3,_excluded2$3);var editor=useTiptapEditor(providedEditor);var _useHighlighter2=useHighlighter(editor),markAvailable=_useHighlighter2.markAvailable;var _React$useState=React__namespace.useState(false),isOpen=_React$useState[0],setIsOpen=_React$useState[1];var isDisabled=React__namespace.useMemo(function(){if(!markAvailable||!editor){return true;}return editor.isActive('code')||editor.isActive('codeBlock')||editor.isActive('imageUpload');},[markAvailable,editor]);var canSetMark=React__namespace.useMemo(function(){if(!editor||!markAvailable)return false;try{return editor.can().setMark('highlight');}catch(_unused){return false;}},[editor,markAvailable]);var isActive=(editor==null?void 0:editor.isActive('highlight'))||false;var show=React__namespace.useMemo(function(){if(hideWhenUnavailable){if(react.isNodeSelection(editor==null?void 0:editor.state.selection)||!canSetMark){return false;}}return true;},[hideWhenUnavailable,editor,canSetMark]);if(!show||!editor||!editor.isEditable){return null;}return jsxRuntime.jsxs(Popover,{open:isOpen,onOpenChange:setIsOpen,children:[jsxRuntime.jsx(PopoverTrigger,{asChild:true,children:jsxRuntime.jsx(HighlighterButton,_extends({disabled:isDisabled,"data-active-state":isActive?'on':'off',"data-disabled":isDisabled,"aria-pressed":isActive},props))}),jsxRuntime.jsx(PopoverContent,{"aria-label":"Highlight colors",children:jsxRuntime.jsx(HighlightContent,{editor:editor,colors:colors,onClose:function onClose(){return setIsOpen(false);}})})]});}HighlighterButton.displayName='HighlighterButton';var _excluded$s=["className"];var LinkIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$s);return jsxRuntime.jsxs("svg",_extends({xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 20 20",fill:"none",className:className},props,{children:[jsxRuntime.jsx("path",{d:"M16.449 3.55098C14.2143 1.31634 10.5912 1.31634 8.3566 3.55098L7.75589 4.15169C7.51182 4.39577 7.51182 4.7915 7.75589 5.03558C7.99997 5.27965 8.3957 5.27965 8.63978 5.03558L9.24048 4.43487C10.987 2.68838 13.8186 2.68838 15.5651 4.43487C17.3116 6.18136 17.3116 9.01298 15.5651 10.7595L14.9644 11.3602C14.7203 11.6043 14.7203 12 14.9644 12.2441C15.2085 12.4881 15.6042 12.4881 15.8483 12.2441L16.449 11.6434C18.6836 9.40871 18.6836 5.78563 16.449 3.55098Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M5.03558 7.75589C5.27965 7.99997 5.27965 8.3957 5.03558 8.63978L4.43487 9.24048C2.68838 10.987 2.68838 13.8186 4.43487 15.5651C6.18136 17.3116 9.01298 17.3116 10.7595 15.5651L11.3602 14.9644C11.6043 14.7203 12 14.7203 12.2441 14.9644C12.4881 15.2085 12.4881 15.6042 12.2441 15.8483L11.6434 16.449C9.40871 18.6836 5.78563 18.6836 3.55099 16.449C1.31634 14.2143 1.31634 10.5912 3.55099 8.3566L4.15169 7.75589C4.39577 7.51182 4.7915 7.51182 5.03558 7.75589Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M12.244 7.75589C12.4881 7.99997 12.4881 8.3957 12.244 8.63978L8.63978 12.244C8.3957 12.4881 7.99997 12.4881 7.75589 12.244C7.51182 11.9999 7.51182 11.6042 7.75589 11.3601L11.3601 7.75589C11.6042 7.51182 11.9999 7.51182 12.244 7.75589Z",fill:"currentColor"})]}));});LinkIcon.displayName='LinkIcon';var _excluded$r=["className"];var CornerDownLeftIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$r);return jsxRuntime.jsx("svg",_extends({width:"24",height:"24",className:className,viewBox:"0 0 24 24",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg"},props,{children:jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M21 4C21 3.44772 20.5523 3 20 3C19.4477 3 19 3.44772 19 4V11C19 11.7956 18.6839 12.5587 18.1213 13.1213C17.5587 13.6839 16.7956 14 16 14H6.41421L9.70711 10.7071C10.0976 10.3166 10.0976 9.68342 9.70711 9.29289C9.31658 8.90237 8.68342 8.90237 8.29289 9.29289L3.29289 14.2929C2.90237 14.6834 2.90237 15.3166 3.29289 15.7071L8.29289 20.7071C8.68342 21.0976 9.31658 21.0976 9.70711 20.7071C10.0976 20.3166 10.0976 19.6834 9.70711 19.2929L6.41421 16H16C17.3261 16 18.5979 15.4732 19.5355 14.5355C20.4732 13.5979 21 12.3261 21 11V4Z",fill:"currentColor"})}));});CornerDownLeftIcon.displayName='CornerDownLeftIcon';var _excluded$q=["className"];var ExternalLinkIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$q);return jsxRuntime.jsxs("svg",_extends({width:"24",height:"24",className:className,viewBox:"0 0 24 24",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg"},props,{children:[jsxRuntime.jsx("path",{d:"M14 3C14 2.44772 14.4477 2 15 2H21C21.5523 2 22 2.44772 22 3V9C22 9.55228 21.5523 10 21 10C20.4477 10 20 9.55228 20 9V5.41421L10.7071 14.7071C10.3166 15.0976 9.68342 15.0976 9.29289 14.7071C8.90237 14.3166 8.90237 13.6834 9.29289 13.2929L18.5858 4H15C14.4477 4 14 3.55228 14 3Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M4.29289 7.29289C4.48043 7.10536 4.73478 7 5 7H11C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5H5C4.20435 5 3.44129 5.31607 2.87868 5.87868C2.31607 6.44129 2 7.20435 2 8V19C2 19.7957 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H16C16.7957 22 17.5587 21.6839 18.1213 21.1213C18.6839 20.5587 19 19.7957 19 19V13C19 12.4477 18.5523 12 18 12C17.4477 12 17 12.4477 17 13V19C17 19.2652 16.8946 19.5196 16.7071 19.7071C16.5196 19.8946 16.2652 20 16 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V8C4 7.73478 4.10536 7.48043 4.29289 7.29289Z",fill:"currentColor"})]}));});ExternalLinkIcon.displayName='ExternalLinkIcon';var _excluded$p=["className"];var TrashIcon$1=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$p);return jsxRuntime.jsx("svg",_extends({width:"24",height:"24",className:className,viewBox:"0 0 24 24",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg"},props,{children:jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M7 5V4C7 3.17477 7.40255 2.43324 7.91789 1.91789C8.43324 1.40255 9.17477 1 10 1H14C14.8252 1 15.5668 1.40255 16.0821 1.91789C16.5975 2.43324 17 3.17477 17 4V5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H20V20C20 20.8252 19.5975 21.5668 19.0821 22.0821C18.5668 22.5975 17.8252 23 17 23H7C6.17477 23 5.43324 22.5975 4.91789 22.0821C4.40255 21.5668 4 20.8252 4 20V7H3C2.44772 7 2 6.55228 2 6C2 5.44772 2.44772 5 3 5H7ZM9 4C9 3.82523 9.09745 3.56676 9.33211 3.33211C9.56676 3.09745 9.82523 3 10 3H14C14.1748 3 14.4332 3.09745 14.6679 3.33211C14.9025 3.56676 15 3.82523 15 4V5H9V4ZM6 7V20C6 20.1748 6.09745 20.4332 6.33211 20.6679C6.56676 20.9025 6.82523 21 7 21H17C17.1748 21 17.4332 20.9025 17.6679 20.6679C17.9025 20.4332 18 20.1748 18 20V7H6Z",fill:"currentColor"})}));});TrashIcon$1.displayName='TrashIcon';var _excluded$o=["className","children"],_excluded2$2=["editor","hideWhenUnavailable","onOpenChange","autoOpenOnLinkActive"];var useLinkHandler=function useLinkHandler(props){var editor=props.editor,onSetLink=props.onSetLink,onLinkActive=props.onLinkActive;var _React$useState=React__namespace.useState(''),url=_React$useState[0],setUrl=_React$useState[1];React__namespace.useEffect(function(){if(!editor)return;// Get URL immediately on mount
var _editor$getAttributes=editor.getAttributes('link'),href=_editor$getAttributes.href;if(editor.isActive('link')&&!url){setUrl(href||'');onLinkActive==null||onLinkActive();}},[editor,onLinkActive,url]);React__namespace.useEffect(function(){if(!editor)return;var updateLinkState=function updateLinkState(){var _editor$getAttributes2=editor.getAttributes('link'),href=_editor$getAttributes2.href;setUrl(href||'');if(editor.isActive('link')&&!url){onLinkActive==null||onLinkActive();}};editor.on('selectionUpdate',updateLinkState);return function(){editor.off('selectionUpdate',updateLinkState);};},[editor,onLinkActive,url]);var setLink=React__namespace.useCallback(function(){if(!url||!editor)return;var _editor$state$selecti=editor.state.selection,from=_editor$state$selecti.from,to=_editor$state$selecti.to;var text=editor.state.doc.textBetween(from,to);editor.chain().focus().extendMarkRange('link').insertContent({type:'text',text:text||url,marks:[{type:'link',attrs:{href:url}}]}).run();onSetLink==null||onSetLink();},[editor,onSetLink,url]);var removeLink=React__namespace.useCallback(function(){if(!editor)return;editor.chain().focus().unsetMark('link',{extendEmptyMarkRange:true}).setMeta('preventAutolink',true).run();setUrl('');},[editor]);return{url:url,setUrl:setUrl,setLink:setLink,removeLink:removeLink,isActive:(editor==null?void 0:editor.isActive('link'))||false};};var LinkButton=React__namespace.forwardRef(function(_ref,ref){var className=_ref.className,children=_ref.children,props=_objectWithoutPropertiesLoose(_ref,_excluded$o);return jsxRuntime.jsx(Button,_extends({type:"button",className:className,"data-style":"ghost",role:"button",tabIndex:-1,"aria-label":"Link",tooltip:"Link",ref:ref,"data-size":'large'},props,{children:children||jsxRuntime.jsx(LinkIcon,{className:"tiptap-button-icon"})}));});var LinkContent=function LinkContent(_ref2){var providedEditor=_ref2.editor;var editor=useTiptapEditor(providedEditor);var linkHandler=useLinkHandler({editor:editor});return jsxRuntime.jsx(LinkMain,_extends({},linkHandler));};var LinkMain=function LinkMain(_ref3){var url=_ref3.url,setUrl=_ref3.setUrl,setLink=_ref3.setLink,removeLink=_ref3.removeLink,isActive=_ref3.isActive;var handleKeyDown=function handleKeyDown(event){if(event.key==='Enter'){event.preventDefault();setLink();}};return jsxRuntime.jsxs("div",{children:[jsxRuntime.jsx("input",{type:"url",placeholder:"Paste a link...",value:url,onChange:function onChange(e){return setUrl(e.target.value);},onKeyDown:handleKeyDown,autoComplete:"off",autoCorrect:"off",autoCapitalize:"off",className:"tiptap-input tiptap-input-clamp"}),jsxRuntime.jsx("div",{className:"tiptap-button-group","data-orientation":"horizontal",children:jsxRuntime.jsx(Button,{type:"button",onClick:setLink,title:"Apply link",disabled:!url&&!isActive,"data-style":"ghost",children:jsxRuntime.jsx(CornerDownLeftIcon,{className:"tiptap-button-icon"})})}),jsxRuntime.jsxs("div",{className:"tiptap-button-group","data-orientation":"horizontal",children:[jsxRuntime.jsx(Button,{type:"button",onClick:function onClick(){return window.open(url,'_blank');},title:"Open in new window",disabled:!url&&!isActive,"data-style":"ghost",children:jsxRuntime.jsx(ExternalLinkIcon,{className:"tiptap-button-icon"})}),jsxRuntime.jsx(Button,{type:"button",onClick:removeLink,title:"Remove link",disabled:!url&&!isActive,"data-style":"ghost",children:jsxRuntime.jsx(TrashIcon$1,{className:"tiptap-button-icon"})})]})]});};function LinkPopover(_ref4){var providedEditor=_ref4.editor,_ref4$hideWhenUnavail=_ref4.hideWhenUnavailable,hideWhenUnavailable=_ref4$hideWhenUnavail===void 0?false:_ref4$hideWhenUnavail,onOpenChange=_ref4.onOpenChange,_ref4$autoOpenOnLinkA=_ref4.autoOpenOnLinkActive,autoOpenOnLinkActive=_ref4$autoOpenOnLinkA===void 0?true:_ref4$autoOpenOnLinkA,props=_objectWithoutPropertiesLoose(_ref4,_excluded2$2);var editor=useTiptapEditor(providedEditor);var linkInSchema=isMarkInSchema('link',editor);var _React$useState2=React__namespace.useState(false),isOpen=_React$useState2[0],setIsOpen=_React$useState2[1];var onSetLink=function onSetLink(){setIsOpen(false);};var onLinkActive=function onLinkActive(){return setIsOpen(autoOpenOnLinkActive);};var linkHandler=useLinkHandler({editor:editor,onSetLink:onSetLink,onLinkActive:onLinkActive});var isDisabled=React__namespace.useMemo(function(){var _editor$can$setLink,_editor$can;if(!editor)return true;if(editor.isActive('codeBlock'))return true;return!((_editor$can$setLink=(_editor$can=editor.can()).setLink)!=null&&_editor$can$setLink.call(_editor$can,{href:''}));},[editor]);var canSetLink=React__namespace.useMemo(function(){if(!editor)return false;try{return editor.can().setMark('link');}catch(_unused){return false;}},[editor]);var isActive=(editor==null?void 0:editor.isActive('link'))||false;var handleOnOpenChange=React__namespace.useCallback(function(nextIsOpen){setIsOpen(nextIsOpen);onOpenChange==null||onOpenChange(nextIsOpen);},[onOpenChange]);var show=React__namespace.useMemo(function(){if(!linkInSchema){return false;}if(hideWhenUnavailable){if(react.isNodeSelection(editor==null?void 0:editor.state.selection)||!canSetLink){return false;}}return true;},[linkInSchema,hideWhenUnavailable,editor,canSetLink]);if(!show||!editor||!editor.isEditable){return null;}return jsxRuntime.jsxs(Popover,{open:isOpen,onOpenChange:handleOnOpenChange,children:[jsxRuntime.jsx(PopoverTrigger,{asChild:true,children:jsxRuntime.jsx(LinkButton,_extends({disabled:isDisabled,"data-active-state":isActive?'on':'off',"data-disabled":isDisabled},props))}),jsxRuntime.jsx(PopoverContent,{children:jsxRuntime.jsx(LinkMain,_extends({},linkHandler))})]});}LinkButton.displayName='LinkButton';var _excluded$n=["className"];var ImagePlusIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$n);return jsxRuntime.jsx("svg",_extends({xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",className:className},props,{children:jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M9.94958 1.04102H10.0452C11.9689 1.04101 13.4764 1.041 14.6526 1.19914C15.8566 1.361 16.8066 1.69879 17.5523 2.44446C18.298 3.19014 18.6357 4.14016 18.7976 5.3441C18.9557 6.52034 18.9557 8.02788 18.9557 9.95154V10.0472C18.9557 11.9708 18.9557 13.4784 18.7976 14.6546C18.6357 15.8585 18.298 16.8086 17.5523 17.5542C16.8066 18.2999 15.8566 18.6377 14.6526 18.7996C13.4764 18.9577 11.9689 18.9577 10.0452 18.9577H9.94959C8.02592 18.9577 6.51839 18.9577 5.34215 18.7996C4.1382 18.6377 3.18818 18.2999 2.44251 17.5542C1.69683 16.8086 1.35905 15.8585 1.19718 14.6546C1.03904 13.4784 1.03905 11.9708 1.03906 10.0472V9.95153C1.03905 8.02787 1.03904 6.52034 1.19718 5.3441C1.35905 4.14016 1.69683 3.19014 2.44251 2.44446C3.18818 1.69879 4.1382 1.361 5.34215 1.19914C6.51839 1.041 8.02592 1.04101 9.94958 1.04102ZM5.50871 2.43799C4.44337 2.58122 3.80111 2.85363 3.32639 3.32835C2.85168 3.80306 2.57927 4.44533 2.43604 5.51066C2.29039 6.59398 2.28906 8.01749 2.28906 9.99935C2.28906 11.9812 2.29039 13.4047 2.43604 14.488C2.57927 15.5534 2.85168 16.1956 3.32639 16.6704C3.80111 17.1451 4.44337 17.4175 5.50871 17.5607C6.59203 17.7064 8.01554 17.7077 9.9974 17.7077C11.9792 17.7077 13.4028 17.7064 14.4861 17.5607C15.5514 17.4175 16.1937 17.1451 16.6684 16.6704C17.1431 16.1956 17.4155 15.5534 17.5588 14.488C17.7044 13.4047 17.7057 11.9812 17.7057 9.99935C17.7057 8.01749 17.7044 6.59398 17.5588 5.51066C17.4155 4.44533 17.1431 3.80306 16.6684 3.32835C16.1937 2.85363 15.5514 2.58122 14.4861 2.43799C13.4028 2.29234 11.9792 2.29102 9.9974 2.29102C8.01554 2.29102 6.59203 2.29234 5.50871 2.43799ZM13.3307 5.62435C12.7554 5.62435 12.2891 6.09072 12.2891 6.66602C12.2891 7.24131 12.7554 7.70768 13.3307 7.70768C13.906 7.70768 14.3724 7.24131 14.3724 6.66602C14.3724 6.09072 13.906 5.62435 13.3307 5.62435ZM11.0391 6.66602C11.0391 5.40036 12.0651 4.37435 13.3307 4.37435C14.5964 4.37435 15.6224 5.40036 15.6224 6.66602C15.6224 7.93167 14.5964 8.95768 13.3307 8.95768C12.0651 8.95768 11.0391 7.93167 11.0391 6.66602ZM7.08404 10.9799C6.59732 10.4632 5.7849 10.4361 5.26483 10.9191L4.5894 11.5465C4.33649 11.7814 3.94103 11.7668 3.70612 11.5139C3.47121 11.261 3.48581 10.8655 3.73872 10.6306L4.41415 10.0033C5.43753 9.05274 7.03615 9.10609 7.99389 10.1227L10.2001 12.4647C10.4309 12.7096 10.8087 12.7426 11.0784 12.5414C12.0783 11.7954 13.4706 11.8802 14.3726 12.742L16.2625 14.5474C16.5121 14.7859 16.5211 15.1815 16.2826 15.4311C16.0442 15.6807 15.6486 15.6897 15.399 15.4513L13.5091 13.6458C13.0482 13.2055 12.3368 13.1621 11.8258 13.5433C11.0471 14.1243 9.95649 14.029 9.29027 13.3218L7.08404 10.9799Z",fill:"currentColor"})}));});ImagePlusIcon.displayName='ImagePlusIcon';var _excluded$m=["editor","extensionName","text","className","disabled","onClick","children"];function isImageActive(editor,extensionName){if(!editor)return false;return editor.isActive(extensionName);}function insertImage(editor,extensionName){if(!editor)return false;return editor.chain().focus().insertContent({type:extensionName,attrs:{src:'https://unsplash.com/s/photos/image'}}).run();}function useImageUploadButton(editor,extensionName,disabled){if(extensionName===void 0){extensionName='imageUpload';}if(disabled===void 0){disabled=false;}var isActive=isImageActive(editor,extensionName);var handleInsertImage=React__namespace.useCallback(function(){if(disabled)return false;return insertImage(editor,extensionName);},[editor,extensionName,disabled]);return{isActive:isActive,handleInsertImage:handleInsertImage};}var ImageUploadButton=React__namespace.forwardRef(function(_ref,ref){var providedEditor=_ref.editor,_ref$extensionName=_ref.extensionName,extensionName=_ref$extensionName===void 0?'imageUpload':_ref$extensionName,text=_ref.text,_ref$className=_ref.className,className=_ref$className===void 0?'':_ref$className,disabled=_ref.disabled,onClick=_ref.onClick,children=_ref.children,buttonProps=_objectWithoutPropertiesLoose(_ref,_excluded$m);var editor=useTiptapEditor(providedEditor);var _useImageUploadButton=useImageUploadButton(editor,extensionName,disabled),isActive=_useImageUploadButton.isActive,handleInsertImage=_useImageUploadButton.handleInsertImage;var handleClick=React__namespace.useCallback(function(e){onClick==null||onClick(e);if(!e.defaultPrevented&&!disabled){handleInsertImage();}},[onClick,disabled,handleInsertImage]);if(!editor||!editor.isEditable){return null;}return jsxRuntime.jsx(Button,_extends({ref:ref,type:"button",className:className.trim(),"data-style":"ghost","data-active-state":isActive?'on':'off',role:"button",tabIndex:-1,"aria-label":"Add image","aria-pressed":isActive,tooltip:"Add image","data-size":'large',onClick:handleClick},buttonProps,{children:children||jsxRuntime.jsxs("div",{children:[jsxRuntime.jsx(ImagePlusIcon,{className:"tiptap-button-icon"}),text&&jsxRuntime.jsx("span",{className:"tiptap-button-text",children:text})]})}));});ImageUploadButton.displayName='ImageUploadButton';var _excluded$l=["className"];var ArrowLeftIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$l);return jsxRuntime.jsx("svg",_extends({width:"24",height:"24",className:className,viewBox:"0 0 24 24",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg"},props,{children:jsxRuntime.jsx("path",{d:"M12.7071 5.70711C13.0976 5.31658 13.0976 4.68342 12.7071 4.29289C12.3166 3.90237 11.6834 3.90237 11.2929 4.29289L4.29289 11.2929C3.90237 11.6834 3.90237 12.3166 4.29289 12.7071L11.2929 19.7071C11.6834 20.0976 12.3166 20.0976 12.7071 19.7071C13.0976 19.3166 13.0976 18.6834 12.7071 18.2929L7.41421 13L19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11L7.41421 11L12.7071 5.70711Z",fill:"currentColor"})}));});ArrowLeftIcon.displayName='ArrowLeftIcon';var _excluded$k=["className"];var CloseIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$k);return jsxRuntime.jsx("svg",_extends({width:"24",height:"24",className:className,viewBox:"0 0 24 24",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg"},props,{children:jsxRuntime.jsx("path",{d:"M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z",fill:"currentColor"})}));});CloseIcon.displayName='CloseIcon';function _catch(body,recover){try{var result=body();}catch(e){return recover(e);}if(result&&result.then){return result.then(void 0,recover);}return result;}function useFileUpload(options){var _React$useState=React__namespace.useState(null),fileItem=_React$useState[0],setFileItem=_React$useState[1];var uploadFile=function uploadFile(file){try{if(file.size>options.maxSize){var error=new Error("File size exceeds maximum allowed ("+options.maxSize/1024/1024+"MB)");options.onError==null||options.onError(error);return Promise.resolve(null);}var abortController=new AbortController();var newFileItem={id:generateUUID(),file:file,progress:0,status:'uploading',abortController:abortController};setFileItem(newFileItem);return Promise.resolve(_catch(function(){if(!options.upload){throw new Error('Upload function is not defined');}return Promise.resolve(options.upload(file,function(event){setFileItem(function(prev){if(!prev)return null;return _extends({},prev,{progress:event.progress});});},abortController.signal)).then(function(url){if(!url)throw new Error('Upload failed: No URL returned');if(!abortController.signal.aborted){setFileItem(function(prev){if(!prev)return null;return _extends({},prev,{status:'success',url:url,progress:100});});options.onSuccess==null||options.onSuccess(url);return url;}return null;});},function(error){if(!abortController.signal.aborted){setFileItem(function(prev){if(!prev)return null;return _extends({},prev,{status:'error',progress:0});});options.onError==null||options.onError(error instanceof Error?error:new Error('Upload failed'));}return null;}));}catch(e){return Promise.reject(e);}};var uploadFiles=function uploadFiles(files){try{if(!files||files.length===0){options.onError==null||options.onError(new Error('No files to upload'));return Promise.resolve(null);}if(options.limit&&files.length>options.limit){options.onError==null||options.onError(new Error("Maximum "+options.limit+" file"+(options.limit===1?'':'s')+" allowed"));return Promise.resolve(null);}var file=files[0];if(!file){options.onError==null||options.onError(new Error('File is undefined'));return Promise.resolve(null);}return uploadFile(file);}catch(e){return Promise.reject(e);}};var clearFileItem=function clearFileItem(){if(!fileItem)return;if(fileItem.abortController){fileItem.abortController.abort();}if(fileItem.url){URL.revokeObjectURL(fileItem.url);}setFileItem(null);};return{fileItem:fileItem,uploadFiles:uploadFiles,clearFileItem:clearFileItem};}var CloudUploadIcon=function CloudUploadIcon(){return jsxRuntime.jsxs("svg",{width:"24",height:"24",viewBox:"0 0 24 24",className:"tiptap-image-upload-icon",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntime.jsx("path",{d:"M11.1953 4.41771C10.3478 4.08499 9.43578 3.94949 8.5282 4.02147C7.62062 4.09345 6.74133 4.37102 5.95691 4.83316C5.1725 5.2953 4.50354 5.92989 4.00071 6.68886C3.49788 7.44783 3.17436 8.31128 3.05465 9.2138C2.93495 10.1163 3.0222 11.0343 3.3098 11.8981C3.5974 12.7619 4.07781 13.5489 4.71463 14.1995C5.10094 14.5942 5.09414 15.2274 4.69945 15.6137C4.30476 16 3.67163 15.9932 3.28532 15.5985C2.43622 14.731 1.79568 13.6816 1.41221 12.5299C1.02875 11.3781 0.91241 10.1542 1.07201 8.95084C1.23162 7.74748 1.66298 6.59621 2.33343 5.58425C3.00387 4.57229 3.89581 3.72617 4.9417 3.10998C5.98758 2.4938 7.15998 2.1237 8.37008 2.02773C9.58018 1.93176 10.7963 2.11243 11.9262 2.55605C13.0561 2.99968 14.0703 3.69462 14.8919 4.58825C15.5423 5.29573 16.0585 6.11304 16.4177 7.00002H17.4999C18.6799 6.99991 19.8288 7.37933 20.7766 8.08222C21.7245 8.78515 22.4212 9.7743 22.7637 10.9036C23.1062 12.0328 23.0765 13.2423 22.6788 14.3534C22.2812 15.4644 21.5367 16.4181 20.5554 17.0736C20.0962 17.3803 19.4752 17.2567 19.1684 16.7975C18.8617 16.3382 18.9853 15.7172 19.4445 15.4105C20.069 14.9934 20.5427 14.3865 20.7958 13.6794C21.0488 12.9724 21.0678 12.2027 20.8498 11.4841C20.6318 10.7655 20.1885 10.136 19.5853 9.6887C18.9821 9.24138 18.251 8.99993 17.5001 9.00002H15.71C15.2679 9.00002 14.8783 8.70973 14.7518 8.28611C14.4913 7.41374 14.0357 6.61208 13.4195 5.94186C12.8034 5.27164 12.0427 4.75043 11.1953 4.41771Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M11 14.4142V21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21V14.4142L15.2929 16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071C17.0976 16.3166 17.0976 15.6834 16.7071 15.2929L12.7078 11.2936C12.7054 11.2912 12.703 11.2888 12.7005 11.2864C12.5208 11.1099 12.2746 11.0008 12.003 11L12 11L11.997 11C11.8625 11.0004 11.7343 11.0273 11.6172 11.0759C11.502 11.1236 11.3938 11.1937 11.2995 11.2864C11.297 11.2888 11.2946 11.2912 11.2922 11.2936L7.29289 15.2929C6.90237 15.6834 6.90237 16.3166 7.29289 16.7071C7.68342 17.0976 8.31658 17.0976 8.70711 16.7071L11 14.4142Z",fill:"currentColor"})]});};var FileIcon=function FileIcon(){return jsxRuntime.jsx("svg",{width:"43",height:"57",viewBox:"0 0 43 57",fill:"currentColor",className:"tiptap-image-upload-dropzone-rect-primary",xmlns:"http://www.w3.org/2000/svg",children:jsxRuntime.jsx("path",{d:"M0.75 10.75C0.75 5.64137 4.89137 1.5 10 1.5H32.3431C33.2051 1.5 34.0317 1.84241 34.6412 2.4519L40.2981 8.10876C40.9076 8.71825 41.25 9.5449 41.25 10.4069V46.75C41.25 51.8586 37.1086 56 32 56H10C4.89137 56 0.75 51.8586 0.75 46.75V10.75Z",fill:"currentColor",fillOpacity:"0.11",stroke:"currentColor",strokeWidth:"1.5"})});};var FileCornerIcon=function FileCornerIcon(){return jsxRuntime.jsx("svg",{width:"10",height:"10",className:"tiptap-image-upload-dropzone-rect-secondary",viewBox:"0 0 10 10",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg",children:jsxRuntime.jsx("path",{d:"M0 0.75H0.343146C1.40401 0.75 2.42143 1.17143 3.17157 1.92157L8.82843 7.57843C9.57857 8.32857 10 9.34599 10 10.4069V10.75H4C1.79086 10.75 0 8.95914 0 6.75V0.75Z",fill:"currentColor"})});};var ImageUploadDragArea=function ImageUploadDragArea(_ref){var onFile=_ref.onFile,children=_ref.children;var _React$useState2=React__namespace.useState(false),dragover=_React$useState2[0],setDragover=_React$useState2[1];var onDrop=function onDrop(e){setDragover(false);e.preventDefault();e.stopPropagation();var files=Array.from(e.dataTransfer.files);onFile(files);};var onDragover=function onDragover(e){e.preventDefault();setDragover(true);};var onDragleave=function onDragleave(e){e.preventDefault();setDragover(false);};return jsxRuntime.jsx("div",{className:"tiptap-image-upload-dragger "+(dragover?'tiptap-image-upload-dragger-active':''),onDrop:onDrop,onDragOver:onDragover,onDragLeave:onDragleave,children:children});};var ImageUploadPreview=function ImageUploadPreview(_ref2){var file=_ref2.file,progress=_ref2.progress,status=_ref2.status,onRemove=_ref2.onRemove;var formatFileSize=function formatFileSize(bytes){if(bytes===0)return'0 Bytes';var k=1024;var sizes=['Bytes','KB','MB','GB'];var i=Math.floor(Math.log(bytes)/Math.log(k));return parseFloat((bytes/Math.pow(k,i)).toFixed(2))+" "+sizes[i];};return jsxRuntime.jsxs("div",{className:"tiptap-image-upload-preview",children:[status==='uploading'&&jsxRuntime.jsx("div",{className:"tiptap-image-upload-progress",style:{width:progress+"%"}}),jsxRuntime.jsxs("div",{className:"tiptap-image-upload-preview-content",children:[jsxRuntime.jsxs("div",{className:"tiptap-image-upload-file-info",children:[jsxRuntime.jsx("div",{className:"tiptap-image-upload-file-icon",children:jsxRuntime.jsx(CloudUploadIcon,{})}),jsxRuntime.jsxs("div",{className:"tiptap-image-upload-details",children:[jsxRuntime.jsx("span",{className:"tiptap-image-upload-text",children:file.name}),jsxRuntime.jsx("span",{className:"tiptap-image-upload-subtext",children:formatFileSize(file.size)})]})]}),jsxRuntime.jsxs("div",{className:"tiptap-image-upload-actions",children:[status==='uploading'&&jsxRuntime.jsxs("span",{className:"tiptap-image-upload-progress-text",children:[progress,"%"]}),jsxRuntime.jsx("button",{className:"tiptap-image-upload-close-btn",onClick:function onClick(e){e.stopPropagation();onRemove();},children:jsxRuntime.jsx(CloseIcon,{})})]})]})]});};var DropZoneContent=function DropZoneContent(_ref3){var maxSize=_ref3.maxSize;return jsxRuntime.jsxs("div",{children:[jsxRuntime.jsxs("div",{className:"tiptap-image-upload-dropzone",children:[jsxRuntime.jsx(FileIcon,{}),jsxRuntime.jsx(FileCornerIcon,{}),jsxRuntime.jsx("div",{className:"tiptap-image-upload-icon-container",children:jsxRuntime.jsx(CloudUploadIcon,{})})]}),jsxRuntime.jsxs("div",{className:"tiptap-image-upload-content",children:[jsxRuntime.jsxs("span",{className:"tiptap-image-upload-text",children:[jsxRuntime.jsx("em",{children:"Click to upload"})," or drag and drop"]}),jsxRuntime.jsxs("span",{className:"tiptap-image-upload-subtext",children:["Maximum file size ",maxSize/1024/1024,"MB."]})]})]});};var ImageUploadNode$1=function ImageUploadNode(props){var _props$node$attrs=props.node.attrs,accept=_props$node$attrs.accept,limit=_props$node$attrs.limit,maxSize=_props$node$attrs.maxSize;var inputRef=React__namespace.useRef(null);var extension=props.extension;var uploadOptions={maxSize:maxSize,limit:limit,accept:accept,upload:extension.options.upload,onSuccess:extension.options.onSuccess,onError:extension.options.onError};var _useFileUpload=useFileUpload(uploadOptions),fileItem=_useFileUpload.fileItem,uploadFiles=_useFileUpload.uploadFiles,clearFileItem=_useFileUpload.clearFileItem;var handleChange=function handleChange(e){var files=e.target.files;if(!files||files.length===0){extension.options.onError==null||extension.options.onError(new Error('No file selected'));return;}handleUpload(Array.from(files));};var handleUpload=function handleUpload(files){try{return Promise.resolve(uploadFiles(files)).then(function(url){if(url){var _files$;var pos=props.getPos();var filename=((_files$=files[0])==null?void 0:_files$.name.replace(/\.[^/.]+$/,''))||'unknown';props.editor.chain().focus().deleteRange({from:pos,to:pos+1}).insertContentAt(pos,[{type:'image',attrs:{src:url,alt:filename,title:filename}}]).run();}});}catch(e){return Promise.reject(e);}};var handleClick=function handleClick(){if(inputRef.current&&!fileItem){inputRef.current.value='';inputRef.current.click();}};return jsxRuntime.jsxs(react.NodeViewWrapper,{className:"tiptap-image-upload",tabIndex:0,onClick:handleClick,children:[!fileItem&&jsxRuntime.jsx(ImageUploadDragArea,{onFile:handleUpload,children:jsxRuntime.jsx(DropZoneContent,{maxSize:maxSize})}),fileItem&&jsxRuntime.jsx(ImageUploadPreview,{file:fileItem.file,progress:fileItem.progress,status:fileItem.status,onRemove:clearFileItem}),jsxRuntime.jsx("input",{ref:inputRef,name:"file",accept:accept,type:"file",onChange:handleChange,onClick:function onClick(e){return e.stopPropagation();}})]});};/**
 * A TipTap node extension that creates an image upload component.
 * @see registry/tiptap-node/image-upload-node/image-upload-node
 */var ImageUploadNode=react.Node.create({name:'imageUpload',group:'block',draggable:true,selectable:true,atom:true,addOptions:function addOptions(){return{accept:'image/*',limit:1,maxSize:0,upload:undefined,onError:undefined,onSuccess:undefined};},addAttributes:function addAttributes(){return{accept:{"default":this.options.accept},limit:{"default":this.options.limit},maxSize:{"default":this.options.maxSize}};},parseHTML:function parseHTML(){return[{tag:'div[data-type="image-upload"]'}];},renderHTML:function renderHTML(_ref){var HTMLAttributes=_ref.HTMLAttributes;return['div',react.mergeAttributes({'data-type':'image-upload'},HTMLAttributes)];},addNodeView:function addNodeView(){return react.ReactNodeViewRenderer(ImageUploadNode$1);},addCommands:function addCommands(){var _this=this;return{setImageUploadNode:function setImageUploadNode(options){if(options===void 0){options={};}return function(_ref2){var commands=_ref2.commands;return commands.insertContent({type:_this.name,attrs:options});};}};},/**
   * Adds Enter key handler to trigger the upload component when it's selected.
   */addKeyboardShortcuts:function addKeyboardShortcuts(){return{Enter:function Enter(_ref3){var editor=_ref3.editor;var selection=editor.state.selection;var nodeAfter=selection.$from.nodeAfter;if(nodeAfter&&nodeAfter.type.name==='imageUpload'&&editor.isActive('imageUpload')){var nodeEl=editor.view.nodeDOM(selection.$from.pos);if(nodeEl&&nodeEl instanceof HTMLElement){// Since NodeViewWrapper is wrapped with a div, we need to click the first child
var firstChild=nodeEl.firstChild;if(firstChild&&firstChild instanceof HTMLElement){firstChild.click();return true;}}}return false;}};}});function nodeEqualsType(_ref){var types=_ref.types,node=_ref.node;if(!node)return false;if(Array.isArray(types)){return types.includes(node.type);}return node.type===types;}var TrailingNode=react.Extension.create({name:'trailingNode',addOptions:function addOptions(){return{node:'paragraph',notAfter:['paragraph']};},addProseMirrorPlugins:function addProseMirrorPlugins(){var _this=this;var plugin=new state.PluginKey(this.name);var disabledNodes=Object.entries(this.editor.schema.nodes).map(function(_ref2){var value=_ref2[1];return value;}).filter(function(node){return _this.options.notAfter.includes(node.name);});return[new state.Plugin({key:plugin,appendTransaction:function appendTransaction(_,__,state){var doc=state.doc,tr=state.tr,schema=state.schema;var shouldInsertNodeAtEnd=plugin.getState(state);var endPosition=doc.content.size;var type=schema.nodes[_this.options.node];if(!shouldInsertNodeAtEnd){return null;}if(type){return tr.insert(endPosition,type.create());}return null;},state:{init:function init(_,state){var lastNode=state.tr.doc.lastChild;return!nodeEqualsType({node:lastNode,types:disabledNodes});},apply:function apply(tr,value){if(!tr.docChanged){return value;}var lastNode=tr.doc.lastChild;return!nodeEqualsType({node:lastNode,types:disabledNodes});}}})];}});var Link=TiptapLink__default["default"].extend({inclusive:false,parseHTML:function parseHTML(){return[{tag:'a[href]:not([data-type="button"]):not([href *= "javascript:" i])'}];},addProseMirrorPlugins:function addProseMirrorPlugins(){var _this$parent;var editor=this.editor;return[].concat(((_this$parent=this.parent)==null?void 0:_this$parent.call(this))||[],[new state.Plugin({props:{handleKeyDown:function handleKeyDown(_,event){var selection=editor.state.selection;if(event.key==='Escape'&&selection.empty!==true){editor.commands.focus(selection.to,{scrollIntoView:false});}return false;},handleClick:function handleClick(view,pos){var _view$state=view.state,schema=_view$state.schema,doc=_view$state.doc,tr=_view$state.tr;var range;if(schema.marks.link){range=react.getMarkRange(doc.resolve(pos),schema.marks.link);}if(!range){return;}var _range=range,from=_range.from,to=_range.to;var start=Math.min(from,to);var end=Math.max(from,to);if(pos<start||pos>end){return;}var $start=doc.resolve(start);var $end=doc.resolve(end);var transaction=tr.setSelection(new state.TextSelection($start,$end));view.dispatch(transaction);}}})]);}});var MOBILE_BREAKPOINT=768;function useMobile(){var _React$useState=React__namespace.useState(undefined),isMobile=_React$useState[0],setIsMobile=_React$useState[1];React__namespace.useEffect(function(){var mql=window.matchMedia("(max-width: "+(MOBILE_BREAKPOINT-1)+"px)");var onChange=function onChange(){setIsMobile(window.innerWidth<MOBILE_BREAKPOINT);};mql.addEventListener('change',onChange);setIsMobile(window.innerWidth<MOBILE_BREAKPOINT);return function(){return mql.removeEventListener('change',onChange);};},[]);return!!isMobile;}function useWindowSize(){var _useState=React.useState({width:0,height:0,offsetTop:0}),size=_useState[0],setSize=_useState[1];React.useEffect(function(){var updateSize=function updateSize(){var vv=window.visualViewport;if(!vv)return;var width=vv.width,height=vv.height,offsetTop=vv.offsetTop;setSize(function(prev){return width===prev.width&&height===prev.height&&offsetTop===prev.offsetTop?prev:{width:width,height:height,offsetTop:offsetTop};});};var vv=window.visualViewport;vv==null||vv.addEventListener('resize',updateSize);vv==null||vv.addEventListener('scroll',updateSize);updateSize();return function(){vv==null||vv.removeEventListener('resize',updateSize);vv==null||vv.removeEventListener('scroll',updateSize);};},[]);return size;}var classes={color:{position:"absolute",top:20,left:0,width:0,height:0,opacity:0,WebkitAppearance:"none",MozAppearance:"none",appearance:"none",pointerEvents:'none',backgroundColor:"transparent",border:"none",cursor:"pointer","&::WebkitColorSwatch":{borderRadius:4,border:"none"},"&::MozColorSwatch":{borderRadius:4,border:"none"}}};var ColorPicker=function ColorPicker(_ref){var editor=_ref.editor;var handleInput=function handleInput(event){editor.chain().focus().setColor(event.target.value).run();};var isActive=!!editor.getAttributes("textStyle").color;return jsxRuntime.jsxs("div",{style:{position:'relative'},children:[jsxRuntime.jsx(Button,{disabled:false,"data-style":"ghost","data-active-state":isActive?'on':'off',"data-disabled":false,"data-size":"large",type:"button",role:"button",onClick:function onClick(){var _document$getElementB;return(_document$getElementB=document.getElementById('color-picker'))==null?void 0:_document$getElementB.click();},children:jsxRuntime.jsx(ColorIcon,{className:"tiptap-button-icon",style:{color:editor.getAttributes("textStyle").color}})}),jsxRuntime.jsx("input",{id:"color-picker",type:"color",onInput:handleInput,value:editor.getAttributes("textStyle").color,style:classes.color})]});};var Selection=react.Extension.create({name:'selection',addProseMirrorPlugins:function addProseMirrorPlugins(){var editor=this.editor;return[new state.Plugin({key:new state.PluginKey('selection'),props:{decorations:function decorations(state){if(state.selection.empty){return null;}if(!editor.isEditable){return null;}if(react.isNodeSelection(state.selection)){return null;}return view.DecorationSet.create(state.doc,[view.Decoration.inline(state.selection.from,state.selection.to,{"class":'selection'})]);}}})];}});var _excluded$j=["className"];var MoonStarIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$j);return jsxRuntime.jsxs("svg",_extends({width:"24",height:"24",className:className,viewBox:"0 0 24 24",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg"},props,{children:[jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 11.5955 21.7564 11.2309 21.3827 11.0761C21.009 10.9213 20.5789 11.0069 20.2929 11.2929C19.287 12.2988 17.9226 12.864 16.5 12.864C15.0774 12.864 13.713 12.2988 12.7071 11.2929C11.7012 10.287 11.136 8.92261 11.136 7.5C11.136 6.07739 11.7012 4.71304 12.7071 3.70711C12.9931 3.42111 13.0787 2.99099 12.9239 2.61732C12.7691 2.24364 12.4045 2 12 2ZM7.55544 5.34824C8.27036 4.87055 9.05353 4.51389 9.87357 4.28778C9.39271 5.27979 9.13604 6.37666 9.13604 7.5C9.13604 9.45304 9.91189 11.3261 11.2929 12.7071C12.6739 14.0881 14.547 14.864 16.5 14.864C17.6233 14.864 18.7202 14.6073 19.7122 14.1264C19.4861 14.9465 19.1295 15.7296 18.6518 16.4446C17.7727 17.7602 16.5233 18.7855 15.0615 19.391C13.5997 19.9965 11.9911 20.155 10.4393 19.8463C8.88743 19.5376 7.46197 18.7757 6.34315 17.6569C5.22433 16.538 4.4624 15.1126 4.15372 13.5607C3.84504 12.0089 4.00347 10.4003 4.60897 8.93853C5.21447 7.47672 6.23985 6.22729 7.55544 5.34824Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M19 2C19.5523 2 20 2.44772 20 3V4H21C21.5523 4 22 4.44772 22 5C22 5.55228 21.5523 6 21 6H20V7C20 7.55228 19.5523 8 19 8C18.4477 8 18 7.55228 18 7V6H17C16.4477 6 16 5.55228 16 5C16 4.44772 16.4477 4 17 4H18V3C18 2.44772 18.4477 2 19 2Z",fill:"currentColor"})]}));});MoonStarIcon.displayName='MoonStarIcon';var _excluded$i=["className"];var SunIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$i);return jsxRuntime.jsxs("svg",_extends({width:"24",height:"24",className:className,viewBox:"0 0 24 24",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg"},props,{children:[jsxRuntime.jsx("path",{d:"M12 1C12.5523 1 13 1.44772 13 2V4C13 4.55228 12.5523 5 12 5C11.4477 5 11 4.55228 11 4V2C11 1.44772 11.4477 1 12 1Z",fill:"currentColor"}),jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M13 20C13 19.4477 12.5523 19 12 19C11.4477 19 11 19.4477 11 20V22C11 22.5523 11.4477 23 12 23C12.5523 23 13 22.5523 13 22V20Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M4.22282 4.22289C4.61335 3.83236 5.24651 3.83236 5.63704 4.22289L7.04704 5.63289C7.43756 6.02341 7.43756 6.65658 7.04704 7.0471C6.65651 7.43762 6.02335 7.43762 5.63283 7.0471L4.22282 5.6371C3.8323 5.24658 3.8323 4.61341 4.22282 4.22289Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M18.367 16.9529C17.9765 16.5623 17.3433 16.5623 16.9528 16.9529C16.5623 17.3434 16.5623 17.9766 16.9528 18.3671L18.3628 19.7771C18.7533 20.1676 19.3865 20.1676 19.777 19.7771C20.1675 19.3866 20.1675 18.7534 19.777 18.3629L18.367 16.9529Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M1 12C1 11.4477 1.44772 11 2 11H4C4.55228 11 5 11.4477 5 12C5 12.5523 4.55228 13 4 13H2C1.44772 13 1 12.5523 1 12Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M20 11C19.4477 11 19 11.4477 19 12C19 12.5523 19.4477 13 20 13H22C22.5523 13 23 12.5523 23 12C23 11.4477 22.5523 11 22 11H20Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M7.04704 16.9529C7.43756 17.3434 7.43756 17.9766 7.04704 18.3671L5.63704 19.7771C5.24651 20.1676 4.61335 20.1676 4.22282 19.7771C3.8323 19.3866 3.8323 18.7534 4.22283 18.3629L5.63283 16.9529C6.02335 16.5623 6.65651 16.5623 7.04704 16.9529Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M19.777 5.6371C20.1675 5.24657 20.1675 4.61341 19.777 4.22289C19.3865 3.83236 18.7533 3.83236 18.3628 4.22289L16.9528 5.63289C16.5623 6.02341 16.5623 6.65658 16.9528 7.0471C17.3433 7.43762 17.9765 7.43762 18.367 7.0471L19.777 5.6371Z",fill:"currentColor"})]}));});SunIcon.displayName='SunIcon';function ThemeToggle(){var _React$useState=React__default["default"].useState(false),isDarkMode=_React$useState[0],setIsDarkMode=_React$useState[1];React__default["default"].useEffect(function(){var mediaQuery=window.matchMedia('(prefers-color-scheme: dark)');var handleChange=function handleChange(){return setIsDarkMode(mediaQuery.matches);};mediaQuery.addEventListener('change',handleChange);return function(){return mediaQuery.removeEventListener('change',handleChange);};},[]);React__default["default"].useEffect(function(){var initialDarkMode=!!document.querySelector('meta[name="color-scheme"][content="dark"]')||window.matchMedia('(prefers-color-scheme: dark)').matches;setIsDarkMode(initialDarkMode);},[]);React__default["default"].useEffect(function(){document.documentElement.classList.toggle('dark',isDarkMode);},[isDarkMode]);var toggleDarkMode=function toggleDarkMode(){return setIsDarkMode(function(isDark){return!isDark;});};return jsxRuntime.jsx(Button,{onClick:toggleDarkMode,"aria-label":"Switch to "+(isDarkMode?'light':'dark')+" mode","data-style":"ghost",children:isDarkMode?jsxRuntime.jsx(MoonStarIcon,{className:"tiptap-button-icon"}):jsxRuntime.jsx(SunIcon,{className:"tiptap-button-icon"})});}// extensions/FontSize.ts
var FontSize=Extension.create({name:'fontSize',addOptions:function addOptions(){return{types:['textStyle'],defaultSize:'16px'};},addGlobalAttributes:function addGlobalAttributes(){return[{types:this.options.types,attributes:{fontSize:{"default":this.options.defaultSize,parseHTML:function parseHTML(element){return element.style.fontSize||null;},renderHTML:function renderHTML(attributes){if(!attributes.fontSize)return{};return{style:"font-size: "+attributes.fontSize};}}}}];},addCommands:function addCommands(){return{setFontSize:function setFontSize(size){return function(_ref){var chain=_ref.chain;return chain().setMark('textStyle',{fontSize:size}).run();};}};}});var _excluded$h=["className"];var MoreIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$h);return jsxRuntime.jsxs("svg",_extends({width:"34px",height:"34px",viewBox:"0 0 24 24",fill:"#000",xmlns:"http://www.w3.org/2000/svg",className:className},props,{children:[jsxRuntime.jsx("g",{id:"SVGRepo_bgCarrier","stroke-width":"0"}),jsxRuntime.jsx("g",{id:"SVGRepo_tracerCarrier","stroke-linecap":"round","stroke-linejoin":"round"}),jsxRuntime.jsxs("g",{id:"SVGRepo_iconCarrier",children:[jsxRuntime.jsx("circle",{cx:"12",cy:"6",r:"1.5",fill:"#000"}),jsxRuntime.jsx("circle",{cx:"12",cy:"12",r:"1.5",fill:"#000"}),jsxRuntime.jsx("circle",{cx:"12",cy:"18",r:"1.5",fill:"#000"})]})]}));});MoreIcon.displayName='MoreIcon';var _excluded$g=["children"],_excluded2$1=["children","asChild"],_excluded3$1=["style","className","orientation","side","align","portal","portalProps"],_excluded4$1=["children","disabled","asChild","onSelect","className"],_excluded5=["children","label","className"],_excluded6=["className"];var DropdownMenuContext=React__namespace.createContext(null);function useDropdownMenuContext(){var context=React__namespace.useContext(DropdownMenuContext);if(!context){throw new Error('DropdownMenu components must be wrapped in <DropdownMenu />');}return context;}function useDropdownMenu(_ref){var _ref$initialOpen=_ref.initialOpen,initialOpen=_ref$initialOpen===void 0?false:_ref$initialOpen,controlledOpen=_ref.open,setControlledOpen=_ref.onOpenChange,_ref$side=_ref.side,side=_ref$side===void 0?'bottom':_ref$side,_ref$align=_ref.align,align=_ref$align===void 0?'start':_ref$align;var _React$useState=React__namespace.useState(initialOpen),uncontrolledOpen=_React$useState[0],setUncontrolledOpen=_React$useState[1];var _React$useState2=React__namespace.useState(side+"-"+align),currentPlacement=_React$useState2[0],setCurrentPlacement=_React$useState2[1];var _React$useState3=React__namespace.useState(null),activeIndex=_React$useState3[0],setActiveIndex=_React$useState3[1];var open=controlledOpen||uncontrolledOpen;var setOpen=setControlledOpen||setUncontrolledOpen;var elementsRef=React__namespace.useRef([]);var labelsRef=React__namespace.useRef([]);var floating=react$1.useFloating({open:open,onOpenChange:setOpen,placement:currentPlacement,middleware:[react$1.offset({mainAxis:4}),react$1.flip(),react$1.shift({padding:4})],whileElementsMounted:react$1.autoUpdate});var context=floating.context;var interactions=react$1.useInteractions([react$1.useClick(context,{event:'mousedown',toggle:true,ignoreMouse:false}),react$1.useRole(context,{role:'menu'}),react$1.useDismiss(context,{outsidePress:true,outsidePressEvent:'mousedown'}),react$1.useListNavigation(context,{listRef:elementsRef,activeIndex:activeIndex,onNavigate:setActiveIndex,loop:true}),react$1.useTypeahead(context,{listRef:labelsRef,onMatch:open?setActiveIndex:undefined,activeIndex:activeIndex})]);var updatePosition=React__namespace.useCallback(function(newSide,newAlign){setCurrentPlacement(newSide+"-"+newAlign);},[]);return React__namespace.useMemo(function(){return _extends({open:open,setOpen:setOpen,activeIndex:activeIndex,setActiveIndex:setActiveIndex,elementsRef:elementsRef,labelsRef:labelsRef,updatePosition:updatePosition},interactions,floating);},[open,setOpen,activeIndex,interactions,floating,updatePosition]);}function DropdownMenu(_ref2){var children=_ref2.children,options=_objectWithoutPropertiesLoose(_ref2,_excluded$g);var dropdown=useDropdownMenu(options);return jsxRuntime.jsx(DropdownMenuContext.Provider,{value:dropdown,children:jsxRuntime.jsx(react$1.FloatingList,{elementsRef:dropdown.elementsRef,labelsRef:dropdown.labelsRef,children:children})});}var DropdownMenuTrigger=React__namespace.forwardRef(function(_ref3,propRef){var children=_ref3.children,_ref3$asChild=_ref3.asChild,asChild=_ref3$asChild===void 0?false:_ref3$asChild,props=_objectWithoutPropertiesLoose(_ref3,_excluded2$1);var context=useDropdownMenuContext();var childrenRef=React__namespace.isValidElement(children)?parseInt(React__namespace.version,10)>=19?children.props.ref:children.ref:undefined;var ref=react$1.useMergeRefs([context.refs.setReference,propRef,childrenRef]);if(asChild&&React__namespace.isValidElement(children)){var dataAttributes={'data-state':context.open?'open':'closed'};return React__namespace.cloneElement(children,context.getReferenceProps(_extends({ref:ref},props,typeof children.props==='object'?children.props:{},{'aria-expanded':context.open,'aria-haspopup':'menu'},dataAttributes)));}return jsxRuntime.jsx("button",_extends({ref:ref,"aria-expanded":context.open,"aria-haspopup":"menu","data-state":context.open?'open':'closed'},context.getReferenceProps(props),{children:children}));});DropdownMenuTrigger.displayName='DropdownMenuTrigger';var DropdownMenuContent=React__namespace.forwardRef(function(_ref4,propRef){var style=_ref4.style,className=_ref4.className,_ref4$orientation=_ref4.orientation,orientation=_ref4$orientation===void 0?'vertical':_ref4$orientation,_ref4$side=_ref4.side,side=_ref4$side===void 0?'bottom':_ref4$side,_ref4$align=_ref4.align,align=_ref4$align===void 0?'start':_ref4$align,_ref4$portal=_ref4.portal,portal=_ref4$portal===void 0?true:_ref4$portal,_ref4$portalProps=_ref4.portalProps,portalProps=_ref4$portalProps===void 0?{}:_ref4$portalProps,props=_objectWithoutPropertiesLoose(_ref4,_excluded3$1);var context=useDropdownMenuContext();var ref=react$1.useMergeRefs([context.refs.setFloating,propRef]);React__namespace.useEffect(function(){context.updatePosition(side,align);},[context,side,align]);if(!context.open)return null;var content=jsxRuntime.jsx(react$1.FloatingFocusManager,{context:context.context,modal:false,initialFocus:0,returnFocus:true,children:jsxRuntime.jsx("div",_extends({ref:ref,className:"tiptap-dropdown-menu "+(className||''),style:_extends({position:context.strategy,top:context.y||0,left:context.x||0,outline:'none'},style),"aria-orientation":orientation,"data-orientation":orientation,"data-state":context.open?'open':'closed',"data-side":side,"data-align":align},context.getFloatingProps(props),{children:props.children}))});if(portal){return jsxRuntime.jsx(react$1.FloatingPortal,_extends({},portalProps,{children:content}));}return content;});DropdownMenuContent.displayName='DropdownMenuContent';var DropdownMenuItem=React__namespace.forwardRef(function(_ref5,ref){var children=_ref5.children,disabled=_ref5.disabled,_ref5$asChild=_ref5.asChild,asChild=_ref5$asChild===void 0?false:_ref5$asChild,onSelect=_ref5.onSelect,className=_ref5.className,props=_objectWithoutPropertiesLoose(_ref5,_excluded4$1);var context=useDropdownMenuContext();var item=react$1.useListItem({label:disabled?null:children==null?void 0:children.toString()});var isActive=context.activeIndex===item.index;var handleSelect=React__namespace.useCallback(function(event){if(disabled)return;onSelect==null||onSelect();props.onClick==null||props.onClick(event);context.setOpen(false);},[context,disabled,onSelect,props]);var itemProps=_extends({ref:react$1.useMergeRefs([item.ref,ref]),role:'menuitem',className:className,tabIndex:isActive?0:-1,'data-highlighted':isActive,'aria-disabled':disabled},context.getItemProps(_extends({},props,{onClick:handleSelect})));if(asChild&&React__namespace.isValidElement(children)){var childProps=children.props;// Create merged props without adding onClick directly to the props object
var mergedProps=_extends({},itemProps,typeof children.props==='object'?children.props:{});// Handle onClick separately based on the element type
var eventHandlers={onClick:function onClick(event){// Cast the event to make it compatible with handleSelect
handleSelect(event);childProps.onClick==null||childProps.onClick(event);}};return React__namespace.cloneElement(children,_extends({},mergedProps,eventHandlers));}return jsxRuntime.jsx("div",_extends({},itemProps,{children:children}));});DropdownMenuItem.displayName='DropdownMenuItem';var DropdownMenuGroup=React__namespace.forwardRef(function(_ref6,ref){var children=_ref6.children,label=_ref6.label,className=_ref6.className,props=_objectWithoutPropertiesLoose(_ref6,_excluded5);return jsxRuntime.jsx("div",_extends({},props,{ref:ref,role:"group","aria-label":label,className:"tiptap-button-group "+(className||''),children:children}));});DropdownMenuGroup.displayName='DropdownMenuGroup';var DropdownMenuSeparator=React__namespace.forwardRef(function(_ref7,ref){var className=_ref7.className,props=_objectWithoutPropertiesLoose(_ref7,_excluded6);return jsxRuntime.jsx(Separator,_extends({ref:ref,className:"tiptap-dropdown-menu-separator "+(className||'')},props));});DropdownMenuSeparator.displayName=Separator.displayName;var _excluded$f=["className"];var CodeBlockIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$f);return jsxRuntime.jsxs("svg",_extends({width:"24",height:"24",className:className,viewBox:"0 0 24 24",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg"},props,{children:[jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M6.70711 2.29289C7.09763 2.68342 7.09763 3.31658 6.70711 3.70711L4.41421 6L6.70711 8.29289C7.09763 8.68342 7.09763 9.31658 6.70711 9.70711C6.31658 10.0976 5.68342 10.0976 5.29289 9.70711L2.29289 6.70711C1.90237 6.31658 1.90237 5.68342 2.29289 5.29289L5.29289 2.29289C5.68342 1.90237 6.31658 1.90237 6.70711 2.29289Z",fill:"currentColor"}),jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M10.2929 2.29289C10.6834 1.90237 11.3166 1.90237 11.7071 2.29289L14.7071 5.29289C15.0976 5.68342 15.0976 6.31658 14.7071 6.70711L11.7071 9.70711C11.3166 10.0976 10.6834 10.0976 10.2929 9.70711C9.90237 9.31658 9.90237 8.68342 10.2929 8.29289L12.5858 6L10.2929 3.70711C9.90237 3.31658 9.90237 2.68342 10.2929 2.29289Z",fill:"currentColor"}),jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M17 4C17 3.44772 17.4477 3 18 3H19C20.6569 3 22 4.34315 22 6V18C22 19.6569 20.6569 21 19 21H5C3.34315 21 2 19.6569 2 18V12C2 11.4477 2.44772 11 3 11C3.55228 11 4 11.4477 4 12V18C4 18.5523 4.44772 19 5 19H19C19.5523 19 20 18.5523 20 18V6C20 5.44772 19.5523 5 19 5H18C17.4477 5 17 4.55228 17 4Z",fill:"currentColor"})]}));});CodeBlockIcon.displayName='CodeBlockIcon';var _excluded$e=["className"];var BlockQuoteIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$e);return jsxRuntime.jsxs("svg",_extends({width:"24",height:"24",className:className,viewBox:"0 0 24 24",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg"},props,{children:[jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M8 6C8 5.44772 8.44772 5 9 5H16C16.5523 5 17 5.44772 17 6C17 6.55228 16.5523 7 16 7H9C8.44772 7 8 6.55228 8 6Z",fill:"currentColor"}),jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M4 3C4.55228 3 5 3.44772 5 4L5 20C5 20.5523 4.55229 21 4 21C3.44772 21 3 20.5523 3 20L3 4C3 3.44772 3.44772 3 4 3Z",fill:"currentColor"}),jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M8 12C8 11.4477 8.44772 11 9 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H9C8.44772 13 8 12.5523 8 12Z",fill:"currentColor"}),jsxRuntime.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M8 18C8 17.4477 8.44772 17 9 17H16C16.5523 17 17 17.4477 17 18C17 18.5523 16.5523 19 16 19H9C8.44772 19 8 18.5523 8 18Z",fill:"currentColor"})]}));});BlockQuoteIcon.displayName='BlockQuoteIcon';var _excluded$d=["editor","type","text","hideWhenUnavailable","className","disabled","onClick","children"];var nodeIcons={codeBlock:CodeBlockIcon,blockquote:BlockQuoteIcon};var nodeShortcutKeys={codeBlock:'Ctrl-Alt-c',blockquote:'Ctrl-Shift-b'};var nodeLabels={codeBlock:'Code Block',blockquote:'Blockquote'};function canToggleNode(editor,type){if(!editor)return false;try{return type==='codeBlock'?editor.can().toggleNode('codeBlock','paragraph'):editor.can().toggleWrap('blockquote');}catch(_unused){return false;}}function isNodeActive(editor,type){if(!editor)return false;return editor.isActive(type);}function toggleNode(editor,type){if(!editor)return false;if(type==='codeBlock'){return editor.chain().focus().toggleNode('codeBlock','paragraph').run();}else{return editor.chain().focus().toggleWrap('blockquote').run();}}function isNodeButtonDisabled(editor,canToggle,userDisabled){if(userDisabled===void 0){userDisabled=false;}if(!editor)return true;if(userDisabled)return true;if(!canToggle)return true;return false;}function shouldShowNodeButton(params){var editor=params.editor,hideWhenUnavailable=params.hideWhenUnavailable,nodeInSchema=params.nodeInSchema,canToggle=params.canToggle;if(!nodeInSchema){return false;}if(hideWhenUnavailable){if(react.isNodeSelection(editor==null?void 0:editor.state.selection)||!canToggle){return false;}}return Boolean(editor==null?void 0:editor.isEditable);}function useNodeState(editor,type,disabled,hideWhenUnavailable){if(disabled===void 0){disabled=false;}if(hideWhenUnavailable===void 0){hideWhenUnavailable=false;}var nodeInSchema=isNodeInSchema(type,editor);var canToggle=canToggleNode(editor,type);var isDisabled=isNodeButtonDisabled(editor,canToggle,disabled);var isActive=isNodeActive(editor,type);var shouldShow=React__namespace.useMemo(function(){return shouldShowNodeButton({editor:editor,type:type,hideWhenUnavailable:hideWhenUnavailable,nodeInSchema:nodeInSchema,canToggle:canToggle});},[editor,type,hideWhenUnavailable,nodeInSchema,canToggle]);var handleToggle=React__namespace.useCallback(function(){if(!isDisabled&&editor){return toggleNode(editor,type);}return false;},[editor,type,isDisabled]);var Icon=nodeIcons[type];var shortcutKey=nodeShortcutKeys[type];var label=nodeLabels[type];return{nodeInSchema:nodeInSchema,canToggle:canToggle,isDisabled:isDisabled,isActive:isActive,shouldShow:shouldShow,handleToggle:handleToggle,Icon:Icon,shortcutKey:shortcutKey,label:label};}var NodeButton=React__namespace.forwardRef(function(_ref,ref){var providedEditor=_ref.editor,type=_ref.type,text=_ref.text,_ref$hideWhenUnavaila=_ref.hideWhenUnavailable,hideWhenUnavailable=_ref$hideWhenUnavaila===void 0?false:_ref$hideWhenUnavaila,_ref$className=_ref.className,className=_ref$className===void 0?'':_ref$className,disabled=_ref.disabled,onClick=_ref.onClick,children=_ref.children,buttonProps=_objectWithoutPropertiesLoose(_ref,_excluded$d);var editor=useTiptapEditor(providedEditor);var _useNodeState=useNodeState(editor,type,disabled,hideWhenUnavailable),isDisabled=_useNodeState.isDisabled,isActive=_useNodeState.isActive,shouldShow=_useNodeState.shouldShow,handleToggle=_useNodeState.handleToggle,Icon=_useNodeState.Icon,shortcutKey=_useNodeState.shortcutKey,label=_useNodeState.label;var handleClick=React__namespace.useCallback(function(e){onClick==null||onClick(e);if(!e.defaultPrevented&&!isDisabled){handleToggle();}},[onClick,isDisabled,handleToggle]);if(!shouldShow||!editor||!editor.isEditable){return null;}return jsxRuntime.jsx(Button,_extends({type:"button",className:className.trim(),disabled:isDisabled,"data-style":"ghost","data-active-state":isActive?'on':'off',"data-disabled":isDisabled,role:"button",tabIndex:-1,"aria-label":type,"aria-pressed":isActive,tooltip:label,shortcutKeys:shortcutKey,onClick:handleClick},buttonProps,{ref:ref,children:children||jsxRuntime.jsxs(React__namespace.Fragment,{children:[jsxRuntime.jsx(Icon,{className:"tiptap-button-icon"}),text&&jsxRuntime.jsx("span",{className:"tiptap-button-text",children:text})]})}));});NodeButton.displayName='NodeButton';var _excluded$c=["editor","className","disabled","onClick","children"];/**
 * Button component for triggering undo/redo actions in a TipTap editor.
 */var MoreButton=React__namespace.forwardRef(function(_ref,ref){var providedEditor=_ref.editor,_ref$className=_ref.className,className=_ref$className===void 0?'':_ref$className,disabled=_ref.disabled,onClick=_ref.onClick,children=_ref.children,buttonProps=_objectWithoutPropertiesLoose(_ref,_excluded$c);var _React$useState=React__namespace.useState(false),isOpen=_React$useState[0],setIsOpen=_React$useState[1];var editor=useTiptapEditor(providedEditor);var handleOnOpenChange=function handleOnOpenChange(open){setIsOpen(open);};React__namespace.useCallback(function(e){onClick==null||onClick(e);},[onClick,disabled]);if(!editor||!editor.isEditable){return null;}return jsxRuntime.jsxs(DropdownMenu,{open:isOpen,onOpenChange:handleOnOpenChange,children:[jsxRuntime.jsx(DropdownMenuTrigger,{asChild:true,children:jsxRuntime.jsx(Button,_extends({ref:ref,type:"button",className:className.trim(),disabled:disabled,"data-style":"ghost","data-disabled":disabled,role:"button",tabIndex:-1},buttonProps,{children:children||jsxRuntime.jsx(React__namespace.Fragment,{children:jsxRuntime.jsx(MoreIcon,{className:"tiptap-button-icon"})})}))}),jsxRuntime.jsx(DropdownMenuContent,{align:"center",children:jsxRuntime.jsxs(DropdownMenuGroup,{className:'more-dropdown-menu',children:[jsxRuntime.jsxs("div",{className:'more-dropdown-group-item',children:[jsxRuntime.jsx(NodeButton,{type:"codeBlock"}),jsxRuntime.jsx(NodeButton,{type:"blockquote"})]}),jsxRuntime.jsx(antd.Divider,{type:'vertical'}),jsxRuntime.jsxs("div",{className:'more-dropdown-group-item',children:[jsxRuntime.jsx(MarkButton,{type:"superscript"}),jsxRuntime.jsx(MarkButton,{type:"subscript"})]})]})})]});});MoreButton.displayName='MoreButton';var FontSizeDropdown=function FontSizeDropdown(_ref){var editor=_ref.editor;if(!editor)return null;var sizesOptions=['8px','10px','12px','14px','16px','18px','20px','22px','24px','32px','48px'];var currentFontSize=editor==null?void 0:editor.getAttributes('textStyle').fontSize;var fontSizeOptions=sizesOptions.map(function(size){return{label:size.replace('px',''),value:size};});var activeFont=sizesOptions.find(function(option){return option===currentFontSize;})||'14px';var handleChangeFontSize=function handleChangeFontSize(value){editor==null||editor.chain().focus().setFontSize(value).run();};return jsxRuntime.jsx(antd.Select,{variant:'borderless',value:activeFont||undefined,onChange:handleChangeFontSize,options:fontSizeOptions,suffixIcon:jsxRuntime.jsx(ChevronDownIcon,{width:'16px',height:'16px'}),className:'sapp-toolbar-select',dropdownStyle:{width:60,textAlign:'center'},size:'small'});};var _excluded$b=["className"];var EyeOpenIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$b);return jsxRuntime.jsxs("svg",_extends({width:"24px",height:"24px",viewBox:"0 -0.5 25 25",fill:"none",xmlns:"http://www.w3.org/2000/svg",className:className},props,{children:[jsxRuntime.jsx("g",{id:"SVGRepo_bgCarrier","stroke-width":"0"}),jsxRuntime.jsx("g",{id:"SVGRepo_tracerCarrier","stroke-linecap":"round","stroke-linejoin":"round"}),jsxRuntime.jsxs("g",{id:"SVGRepo_iconCarrier",children:[jsxRuntime.jsx("path",{d:"M12.0003 5.251C7.96932 5.183 3.80032 8 1.17932 10.885C0.904199 11.1904 0.751953 11.5869 0.751953 11.998C0.751953 12.4091 0.904199 12.8056 1.17932 13.111C3.74332 15.935 7.90032 18.817 12.0003 18.748C16.1003 18.817 20.2583 15.935 22.8243 13.111C23.0994 12.8056 23.2517 12.4091 23.2517 11.998C23.2517 11.5869 23.0994 11.1904 22.8243 10.885C20.2003 8 16.0313 5.183 12.0003 5.251Z",stroke:"#71717A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"})," ",jsxRuntime.jsx("path",{d:"M15.75 12C15.7498 12.7416 15.5297 13.4666 15.1175 14.0831C14.7054 14.6997 14.1196 15.1802 13.4344 15.4638C12.7491 15.7475 11.9952 15.8216 11.2678 15.6768C10.5404 15.532 9.87234 15.1748 9.348 14.6503C8.82365 14.1258 8.4666 13.4576 8.32198 12.7302C8.17737 12.0028 8.25169 11.2489 8.53555 10.5637C8.81941 9.87854 9.30005 9.29293 9.91672 8.88092C10.5334 8.46891 11.2584 8.249 12 8.249C12.4926 8.24887 12.9804 8.34581 13.4355 8.53428C13.8905 8.72275 14.304 8.99906 14.6523 9.34741C15.0006 9.69576 15.2768 10.1093 15.4651 10.5645C15.6535 11.0196 15.7503 11.5074 15.75 12Z",stroke:"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"})]})]}));});EyeOpenIcon.displayName='EyeOpenIcon';// Image Preview Modal Component
var ImagePreviewModal=function ImagePreviewModal(_ref){var src=_ref.src,alt=_ref.alt,onClose=_ref.onClose;React.useEffect(function(){var handleEscape=function handleEscape(e){if(e.key==='Escape'){onClose();}};document.addEventListener('keydown',handleEscape);document.body.style.overflow='hidden';return function(){document.removeEventListener('keydown',handleEscape);document.body.style.overflow='unset';};},[onClose]);return jsxRuntime.jsx("div",{className:"image-preview-overlay",onClick:onClose,style:{position:'fixed',top:0,left:0,right:0,bottom:0,backgroundColor:'rgba(0, 0, 0, 0.9)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000,cursor:'pointer'},children:jsxRuntime.jsxs("div",{className:"image-preview-container",onClick:function onClick(e){return e.stopPropagation();},style:{position:'relative',maxWidth:'90vw',maxHeight:'90vh',cursor:'default'},children:[jsxRuntime.jsx("img",{src:src,alt:alt,style:{maxWidth:'100%',maxHeight:'100%',objectFit:'contain',borderRadius:'8px',boxShadow:'0 4px 20px rgba(0, 0, 0, 0.5)'}}),jsxRuntime.jsx("button",{onClick:onClose,style:{position:'absolute',top:'-40px',right:'0',background:'rgba(255, 255, 255, 0.9)',border:'none',borderRadius:'50%',width:'32px',height:'32px',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'16px',fontWeight:'bold',color:'#333'},children:"\xD7"}),alt&&jsxRuntime.jsx("div",{style:{position:'absolute',bottom:'-40px',left:'0',right:'0',color:'white',textAlign:'center',fontSize:'14px',opacity:0.8},children:alt})]})});};var ResizableImageComponent=function ResizableImageComponent(_ref2){var node=_ref2.node,updateAttributes=_ref2.updateAttributes,selected=_ref2.selected;var _useState=React.useState(false),setIsResizing=_useState[1];var _useState2=React.useState(1),aspectRatio=_useState2[0],setAspectRatio=_useState2[1];var _useState3=React.useState(false),showPreview=_useState3[0],setShowPreview=_useState3[1];var _useState4=React.useState(false),isHovering=_useState4[0],setIsHovering=_useState4[1];var imageRef=React.useRef(null);var containerRef=React.useRef(null);var _node$attrs=node.attrs,src=_node$attrs.src,alt=_node$attrs.alt,title=_node$attrs.title,width=_node$attrs.width,height=_node$attrs.height;React.useEffect(function(){if(imageRef.current&&imageRef.current.naturalWidth&&imageRef.current.naturalHeight){setAspectRatio(imageRef.current.naturalWidth/imageRef.current.naturalHeight);}},[src]);var handleImageDoubleClick=React.useCallback(function(e){e.preventDefault();e.stopPropagation();setShowPreview(true);},[]);var handlePreviewIconClick=React.useCallback(function(e){e.preventDefault();e.stopPropagation();setShowPreview(true);},[]);var closePreview=React.useCallback(function(){setShowPreview(false);},[]);var handleMouseDown=React.useCallback(function(e,direction){var _imageRef$current,_imageRef$current2;e.preventDefault();setIsResizing(true);var startX=e.clientX;var startWidth=width||((_imageRef$current=imageRef.current)==null?void 0:_imageRef$current.offsetWidth)||0;var startHeight=height||((_imageRef$current2=imageRef.current)==null?void 0:_imageRef$current2.offsetHeight)||0;var handleMouseMove=function handleMouseMove(e){var deltaX=e.clientX-startX;var newWidth=startWidth;var newHeight=startHeight;switch(direction){case'se':// Southeast corner
newWidth=Math.max(50,startWidth+deltaX);newHeight=Math.max(50,newWidth/aspectRatio);break;case'sw':// Southwest corner
newWidth=Math.max(50,startWidth-deltaX);newHeight=Math.max(50,newWidth/aspectRatio);break;case'ne':// Northeast corner
newWidth=Math.max(50,startWidth+deltaX);newHeight=Math.max(50,newWidth/aspectRatio);break;case'nw':// Northwest corner
newWidth=Math.max(50,startWidth-deltaX);newHeight=Math.max(50,newWidth/aspectRatio);break;case'e':// East side
newWidth=Math.max(50,startWidth+deltaX);newHeight=Math.max(50,newWidth/aspectRatio);break;case'w':// West side
newWidth=Math.max(50,startWidth-deltaX);newHeight=Math.max(50,newWidth/aspectRatio);break;}updateAttributes({width:Math.round(newWidth),height:Math.round(newHeight)});};var _handleMouseUp=function handleMouseUp(){setIsResizing(false);document.removeEventListener('mousemove',handleMouseMove);document.removeEventListener('mouseup',_handleMouseUp);};document.addEventListener('mousemove',handleMouseMove);document.addEventListener('mouseup',_handleMouseUp);},[width,height,aspectRatio,updateAttributes]);var resizeHandles=[{position:'nw',cursor:'nw-resize'},{position:'ne',cursor:'ne-resize'},{position:'sw',cursor:'sw-resize'},{position:'se',cursor:'se-resize'},{position:'w',cursor:'w-resize'},{position:'e',cursor:'e-resize'}];return jsxRuntime.jsxs(React__default["default"].Fragment,{children:[jsxRuntime.jsxs(react.NodeViewWrapper,{className:"resizable-image-wrapper",children:[jsxRuntime.jsxs("div",{ref:containerRef,className:"resizable-image-container "+(selected?'selected':''),style:{position:'relative',display:'inline-block',maxWidth:'100%'},onMouseEnter:function onMouseEnter(){return setIsHovering(true);},onMouseLeave:function onMouseLeave(){return setIsHovering(false);},children:[jsxRuntime.jsx("img",{ref:imageRef,src:src,alt:alt,title:title,width:width,height:height,style:{maxWidth:'100%',height:'auto',display:'block',cursor:'pointer',transition:'opacity 0.2s ease'},onLoad:function onLoad(){if(imageRef.current){setAspectRatio(imageRef.current.naturalWidth/imageRef.current.naturalHeight);}},onDoubleClick:handleImageDoubleClick}),(isHovering||selected)&&jsxRuntime.jsx("div",{className:"preview-icon",onClick:handlePreviewIconClick,style:{position:'absolute',top:'8px',right:'8px',width:'28px',height:'28px',backgroundColor:'rgba(0, 0, 0, 0.7)',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',color:'white',fontSize:'14px',transition:'all 0.2s ease',zIndex:5},title:"Preview image (or double-click)",children:jsxRuntime.jsx(EyeOpenIcon,{})}),selected&&jsxRuntime.jsx(jsxRuntime.Fragment,{children:resizeHandles.map(function(_ref3){var position=_ref3.position,cursor=_ref3.cursor;return jsxRuntime.jsx("div",{className:"resize-handle resize-handle-"+position,style:_extends({position:'absolute',width:'12px',height:'12px',backgroundColor:'#10B367',border:'1px solid #fff',borderRadius:'100px',cursor:cursor,zIndex:10},getHandlePosition(position)),onMouseDown:function onMouseDown(e){return handleMouseDown(e,position);}},position);})})]}),jsxRuntime.jsx("style",{children:"\n        .resizable-image-wrapper {\n          display: inline-block;\n          max-width: 100%;\n        }\n        \n        .resizable-image-container.selected {\n          outline: 2px solid #10B367;\n        }\n        \n        .resize-handle {\n          user-select: none;\n        }\n        \n        .resize-handle:hover {\n          background-color: #0056b3;\n        }\n        .preview-icon:hover {\n        background-color: rgba(0, 0, 0, 0.9);\n        transform: scale(1.1);\n        }\n      "})]}),showPreview&&jsxRuntime.jsx(ImagePreviewModal,{src:src,alt:alt,onClose:closePreview})]});};function getHandlePosition(position){var offset=-4;// Half of handle size
switch(position){case'nw':return{top:offset,left:offset};case'ne':return{top:offset,right:offset};case'sw':return{bottom:offset,left:offset};case'se':return{bottom:offset,right:offset};case'w':return{top:'50%',left:offset,transform:'translateY(-50%)'};case'e':return{top:'50%',right:offset,transform:'translateY(-50%)'};default:return{};}}var ResizableImage=Node.create({name:'image',addOptions:function addOptions(){return{inline:false,allowBase64:false,HTMLAttributes:{}};},inline:function inline(){return this.options.inline;},group:function group(){return this.options.inline?'inline':'block';},draggable:true,addAttributes:function addAttributes(){return{src:{"default":null},alt:{"default":null},title:{"default":null},width:{"default":null,parseHTML:function parseHTML(element){return element.getAttribute('width');},renderHTML:function renderHTML(attributes){if(!attributes.width)return{};return{width:attributes.width};}},height:{"default":null,parseHTML:function parseHTML(element){return element.getAttribute('height');},renderHTML:function renderHTML(attributes){if(!attributes.height)return{};return{height:attributes.height};}}};},parseHTML:function parseHTML(){return[{tag:'img[src]'}];},renderHTML:function renderHTML(_ref){var HTMLAttributes=_ref.HTMLAttributes;return['img',mergeAttributes(this.options.HTMLAttributes,HTMLAttributes)];},addNodeView:function addNodeView(){return react.ReactNodeViewRenderer(ResizableImageComponent);},addCommands:function addCommands(){var _this=this;return{setImage:function setImage(options){return function(_ref2){var commands=_ref2.commands;return commands.insertContent({type:_this.name,attrs:options});};}};}});var _excluded$a=["className"];var AlignLeftIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$a);return jsxRuntime.jsx("svg",_extends({xmlns:"http://www.w3.org/2000/svg",className:className,width:"20",height:"20",viewBox:"0 0 20 20",fill:"none"},props,{children:jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M2.71094 5.83398C2.71094 5.48881 2.99076 5.20898 3.33594 5.20898H16.6693C17.0144 5.20898 17.2943 5.48881 17.2943 5.83398C17.2943 6.17916 17.0144 6.45898 16.6693 6.45898H3.33594C2.99076 6.45898 2.71094 6.17916 2.71094 5.83398ZM2.71094 10.0007C2.71094 9.65547 2.99076 9.37565 3.33594 9.37565H12.5026C12.8478 9.37565 13.1276 9.65547 13.1276 10.0007C13.1276 10.3458 12.8478 10.6257 12.5026 10.6257H3.33594C2.99076 10.6257 2.71094 10.3458 2.71094 10.0007ZM2.71094 14.1673C2.71094 13.8221 2.99076 13.5423 3.33594 13.5423H7.5026C7.84778 13.5423 8.1276 13.8221 8.1276 14.1673C8.1276 14.5125 7.84778 14.7923 7.5026 14.7923H3.33594C2.99076 14.7923 2.71094 14.5125 2.71094 14.1673Z",fill:"currentColor"})}));});AlignLeftIcon.displayName='AlignLeftIcon';var _excluded$9=["className"];var AlignCenterIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$9);return jsxRuntime.jsxs("svg",_extends({xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",className:className},props,{children:[jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M18.9609 5.83398C18.9609 6.17916 18.6811 6.45898 18.3359 6.45898L1.66927 6.45898C1.32409 6.45898 1.04427 6.17916 1.04427 5.83398C1.04427 5.48881 1.32409 5.20898 1.66927 5.20898L18.3359 5.20898C18.6811 5.20898 18.9609 5.48881 18.9609 5.83398Z",fill:"currentColor"}),jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M16.4609 10C16.4609 10.3452 16.1811 10.625 15.8359 10.625L4.16927 10.625C3.82409 10.625 3.54427 10.3452 3.54427 10C3.54427 9.65482 3.82409 9.375 4.16927 9.375L15.8359 9.375C16.1811 9.375 16.4609 9.65482 16.4609 10Z",fill:"currentColor"}),jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M13.9609 14.166C13.9609 14.5112 13.6811 14.791 13.3359 14.791L6.66927 14.791C6.32409 14.791 6.04427 14.5112 6.04427 14.166C6.04427 13.8208 6.32409 13.541 6.66927 13.541H13.3359C13.6811 13.541 13.9609 13.8208 13.9609 14.166Z",fill:"currentColor"})]}));});AlignCenterIcon.displayName='AlignCenterIcon';var _excluded$8=["className"];var AlignRightIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$8);return jsxRuntime.jsx("svg",_extends({xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",className:className},props,{children:jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M17.2891 5.83398C17.2891 5.48881 17.0092 5.20898 16.6641 5.20898H3.33073C2.98555 5.20898 2.70573 5.48881 2.70573 5.83398C2.70573 6.17916 2.98555 6.45898 3.33073 6.45898H16.6641C17.0092 6.45898 17.2891 6.17916 17.2891 5.83398ZM17.2891 10.0007C17.2891 9.65547 17.0092 9.37565 16.6641 9.37565H7.4974C7.15222 9.37565 6.8724 9.65547 6.8724 10.0007C6.8724 10.3458 7.15222 10.6257 7.4974 10.6257H16.6641C17.0092 10.6257 17.2891 10.3458 17.2891 10.0007ZM17.2891 14.1673C17.2891 13.8221 17.0092 13.5423 16.6641 13.5423H12.4974C12.1522 13.5423 11.8724 13.8221 11.8724 14.1673C11.8724 14.5125 12.1522 14.7923 12.4974 14.7923H16.6641C17.0092 14.7923 17.2891 14.5125 17.2891 14.1673Z",fill:"currentColor"})}));});AlignRightIcon.displayName='AlignRightIcon';var _excluded$7=["className"];var AlignJustifyIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$7);return jsxRuntime.jsxs("svg",_extends({xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",className:className},props,{children:[jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M17.2891 5.83398C17.2891 6.17916 17.0092 6.45898 16.6641 6.45898L3.33073 6.45898C2.98555 6.45898 2.70573 6.17916 2.70573 5.83398C2.70573 5.48881 2.98555 5.20898 3.33073 5.20898L16.6641 5.20898C17.0092 5.20898 17.2891 5.48881 17.2891 5.83398Z",fill:"currentColor"}),jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M17.2891 10C17.2891 10.3452 17.0092 10.625 16.6641 10.625L3.33073 10.625C2.98555 10.625 2.70573 10.3452 2.70573 10C2.70573 9.65482 2.98555 9.375 3.33073 9.375L16.6641 9.375C17.0092 9.375 17.2891 9.65482 17.2891 10Z",fill:"currentColor"}),jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M17.2891 14.166C17.2891 14.5112 17.0092 14.791 16.6641 14.791L3.33073 14.791C2.98555 14.791 2.70573 14.5112 2.70573 14.166C2.70573 13.8208 2.98555 13.541 3.33073 13.541L16.6641 13.541C17.0092 13.541 17.2891 13.8208 17.2891 14.166Z",fill:"currentColor"})]}));});AlignJustifyIcon.displayName='AlignJustifyIcon';var _excluded$6=["editor","align","text","hideWhenUnavailable","className","disabled","onClick","children"];var textAlignIcons={left:AlignLeftIcon,center:AlignCenterIcon,right:AlignRightIcon,justify:AlignJustifyIcon};var textAlignShortcutKeys={left:'Ctrl-Shift-l',center:'Ctrl-Shift-e',right:'Ctrl-Shift-r',justify:'Ctrl-Shift-j'};var textAlignLabels={left:'Align left',center:'Align center',right:'Align right',justify:'Align justify'};function hasSetTextAlign(commands){return'setTextAlign'in commands;}function checkTextAlignExtension(editor){if(!editor)return false;var hasExtension=editor.extensionManager.extensions.some(function(extension){return extension.name==='textAlign';});return hasExtension;}function canSetTextAlign(editor,align,alignAvailable){if(!editor||!alignAvailable)return false;try{return editor.can().setTextAlign(align);}catch(_unused){return false;}}function isTextAlignActive(editor,align){if(!editor)return false;return editor.isActive({textAlign:align});}function setTextAlign(editor,align){if(!editor)return false;var chain=editor.chain().focus();if(hasSetTextAlign(chain)){return chain.setTextAlign(align).run();}return false;}function isTextAlignButtonDisabled(editor,alignAvailable,canAlign,userDisabled){if(userDisabled===void 0){userDisabled=false;}if(!editor||!alignAvailable)return true;if(userDisabled)return true;if(!canAlign)return true;return false;}function shouldShowTextAlignButton(editor,canAlign,hideWhenUnavailable){if(!(editor!=null&&editor.isEditable))return false;if(hideWhenUnavailable&&!canAlign)return false;return true;}function useTextAlign(editor,align,disabled,hideWhenUnavailable){if(disabled===void 0){disabled=false;}if(hideWhenUnavailable===void 0){hideWhenUnavailable=false;}var alignAvailable=React__namespace.useMemo(function(){return checkTextAlignExtension(editor);},[editor]);var canAlign=React__namespace.useMemo(function(){return canSetTextAlign(editor,align,alignAvailable);},[editor,align,alignAvailable]);var isDisabled=isTextAlignButtonDisabled(editor,alignAvailable,canAlign,disabled);var isActive=isTextAlignActive(editor,align);var handleAlignment=React__namespace.useCallback(function(){if(!alignAvailable||!editor||isDisabled)return false;return setTextAlign(editor,align);},[alignAvailable,editor,isDisabled,align]);var shouldShow=React__namespace.useMemo(function(){return shouldShowTextAlignButton(editor,canAlign,hideWhenUnavailable);},[editor,canAlign,hideWhenUnavailable]);var Icon=textAlignIcons[align];var shortcutKey=textAlignShortcutKeys[align];var label=textAlignLabels[align];return{alignAvailable:alignAvailable,canAlign:canAlign,isDisabled:isDisabled,isActive:isActive,handleAlignment:handleAlignment,shouldShow:shouldShow,Icon:Icon,shortcutKey:shortcutKey,label:label};}var TextAlignButton=React__namespace.forwardRef(function(_ref,ref){var providedEditor=_ref.editor,align=_ref.align,text=_ref.text,_ref$hideWhenUnavaila=_ref.hideWhenUnavailable,hideWhenUnavailable=_ref$hideWhenUnavaila===void 0?false:_ref$hideWhenUnavaila,_ref$className=_ref.className,className=_ref$className===void 0?'':_ref$className,disabled=_ref.disabled,onClick=_ref.onClick,children=_ref.children,buttonProps=_objectWithoutPropertiesLoose(_ref,_excluded$6);var editor=useTiptapEditor(providedEditor);var _useTextAlign=useTextAlign(editor,align,disabled,hideWhenUnavailable),isDisabled=_useTextAlign.isDisabled,isActive=_useTextAlign.isActive,handleAlignment=_useTextAlign.handleAlignment,shouldShow=_useTextAlign.shouldShow,Icon=_useTextAlign.Icon,shortcutKey=_useTextAlign.shortcutKey,label=_useTextAlign.label;var handleClick=React__namespace.useCallback(function(e){onClick==null||onClick(e);if(!e.defaultPrevented&&!disabled){handleAlignment();}},[onClick,disabled,handleAlignment]);if(!shouldShow||!editor||!editor.isEditable){return null;}return jsxRuntime.jsx(Button,_extends({type:"button",className:className.trim(),disabled:isDisabled,"data-style":"ghost","data-active-state":isActive?'on':'off',"data-disabled":isDisabled,role:"button",tabIndex:-1,"aria-label":label,"aria-pressed":isActive,tooltip:label,shortcutKeys:shortcutKey,onClick:handleClick},buttonProps,{ref:ref,children:children||jsxRuntime.jsxs(React__namespace.Fragment,{children:[jsxRuntime.jsx(Icon,{className:"tiptap-button-icon"}),text&&jsxRuntime.jsx("span",{className:"tiptap-button-text",children:text})]})}));});TextAlignButton.displayName='TextAlignButton';var _excluded$5=["editor","listTypes","hideWhenUnavailable"];function TextAlignDropdownMenu(_ref){var providedEditor=_ref.editor,_ref$listTypes=_ref.listTypes,listTypes=_ref$listTypes===void 0?['left','center','right','justify']:_ref$listTypes,_ref$hideWhenUnavaila=_ref.hideWhenUnavailable,hideWhenUnavailable=_ref$hideWhenUnavaila===void 0?false:_ref$hideWhenUnavaila,props=_objectWithoutPropertiesLoose(_ref,_excluded$5);var _React$useState=React__namespace.useState(false),isOpen=_React$useState[0],setIsOpen=_React$useState[1];var editor=useTiptapEditor(providedEditor);var handleOnOpenChange=function handleOnOpenChange(open){setIsOpen(open);};var getActiveIcon=React__namespace.useCallback(function(){if(!editor)return jsxRuntime.jsx(AlignLeftIcon,{className:"tiptap-button-icon"});var activeAlign=listTypes.find(function(align){return editor.isActive('paragraph',{textAlign:align});});switch(activeAlign){case'left':return jsxRuntime.jsx(AlignLeftIcon,{className:"tiptap-button-icon"});case'center':return jsxRuntime.jsx(AlignCenterIcon,{className:"tiptap-button-icon"});case'right':return jsxRuntime.jsx(AlignRightIcon,{className:"tiptap-button-icon"});case'justify':return jsxRuntime.jsx(AlignJustifyIcon,{className:"tiptap-button-icon"});default:return jsxRuntime.jsx(AlignLeftIcon,{className:"tiptap-button-icon"});}},[editor,listTypes]);var canToggleAnyAlign=React__namespace.useCallback(function(){if(!editor)return false;return listTypes.some(function(align){return canSetTextAlign(editor,align,true);});},[editor,listTypes]);var isAnyAlignActive=React__namespace.useMemo(function(){if(!editor)return false;return listTypes.some(function(align){return isTextAlignActive(editor,align);});},[editor,listTypes]);var isDisabled=!canToggleAnyAlign();var shouldShow=React__namespace.useMemo(function(){return shouldShowTextAlignButton(editor,!isDisabled,hideWhenUnavailable);},[editor,isDisabled,hideWhenUnavailable]);if(!shouldShow||!editor||!editor.isEditable){return null;}return jsxRuntime.jsxs(DropdownMenu,{open:isOpen,onOpenChange:handleOnOpenChange,children:[jsxRuntime.jsx(DropdownMenuTrigger,{asChild:true,children:jsxRuntime.jsxs(Button,_extends({type:"button",disabled:isDisabled,"data-style":"ghost","data-active-state":isAnyAlignActive?'on':'off',"data-disabled":isDisabled,role:"button",tabIndex:-1,"aria-label":"Text Align","aria-pressed":isAnyAlignActive,tooltip:"","data-size":"large"},props,{children:[getActiveIcon(),jsxRuntime.jsx(ChevronDownIcon,{width:'16px',height:'16px',className:"tiptap-button-dropdown-small"})]}))}),jsxRuntime.jsx(DropdownMenuContent,{children:jsxRuntime.jsx(DropdownMenuGroup,{className:'align-dropdown-menu',children:listTypes.map(function(align){return jsxRuntime.jsx(DropdownMenuItem,{asChild:true,children:jsxRuntime.jsx(TextAlignButton,{align:align})},"heading-"+align);})})})]});}var _excluded$4=["className"];var ListIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$4);return jsxRuntime.jsxs("svg",_extends({width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",xmlns:"http://www.w3.org/2000/svg",className:className},props,{children:[jsxRuntime.jsxs("g",{"clip-path":"url(#clip0_6001_108000)",children:[jsxRuntime.jsx("path",{d:"M2.39062 5C2.39062 5.55228 1.9429 6 1.39062 6C0.838345 6 0.390625 5.55228 0.390625 5C0.390625 4.44772 0.838345 4 1.39062 4C1.9429 4 2.39062 4.44772 2.39062 5Z",fill:"currentColor"}),jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M5.39062 5C5.39062 4.58579 5.72642 4.25 6.14062 4.25H18.1406C18.5548 4.25 18.8906 4.58579 18.8906 5C18.8906 5.41421 18.5548 5.75 18.1406 5.75H6.14062C5.72642 5.75 5.39062 5.41421 5.39062 5Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M2.39062 10C2.39062 10.5523 1.9429 11 1.39062 11C0.838345 11 0.390625 10.5523 0.390625 10C0.390625 9.4477 0.838345 9 1.39062 9C1.9429 9 2.39062 9.4477 2.39062 10Z",fill:"currentColor"}),jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M5.39062 10C5.39062 9.5858 5.72642 9.25 6.14062 9.25H18.1406C18.5548 9.25 18.8906 9.5858 18.8906 10C18.8906 10.4142 18.5548 10.75 18.1406 10.75H6.14062C5.72642 10.75 5.39062 10.4142 5.39062 10Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M2.39062 15C2.39062 15.5523 1.9429 16 1.39062 16C0.838345 16 0.390625 15.5523 0.390625 15C0.390625 14.4477 0.838345 14 1.39062 14C1.9429 14 2.39062 14.4477 2.39062 15Z",fill:"currentColor"}),jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M5.39062 15C5.39062 14.5858 5.72642 14.25 6.14062 14.25H18.1406C18.5548 14.25 18.8906 14.5858 18.8906 15C18.8906 15.4142 18.5548 15.75 18.1406 15.75H6.14062C5.72642 15.75 5.39062 15.4142 5.39062 15Z",fill:"currentColor"})]}),jsxRuntime.jsx("defs",{children:jsxRuntime.jsx("clipPath",{id:"clip0_6001_108000",children:jsxRuntime.jsx("rect",{width:"18.5",height:"12",fill:"white",transform:"translate(0.390625 4)"})})})]}));});ListIcon.displayName='ListIcon';var _excluded$3=["className"];var ListOrderedIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$3);return jsxRuntime.jsxs("svg",_extends({xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",className:className},props,{children:[jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M6.875 3.75C6.875 3.40482 7.15482 3.125 7.5 3.125H15.8333C16.1785 3.125 16.4583 3.40482 16.4583 3.75C16.4583 4.09518 16.1785 4.375 15.8333 4.375H7.5C7.15482 4.375 6.875 4.09518 6.875 3.75ZM6.875 9.58333C6.875 9.23816 7.15482 8.95833 7.5 8.95833H15.8333C16.1785 8.95833 16.4583 9.23816 16.4583 9.58333C16.4583 9.92851 16.1785 10.2083 15.8333 10.2083H7.5C7.15482 10.2083 6.875 9.92851 6.875 9.58333ZM6.875 15.4167C6.875 15.0715 7.15482 14.7917 7.5 14.7917H15.8333C16.1785 14.7917 16.4583 15.0715 16.4583 15.4167C16.4583 15.7618 16.1785 16.0417 15.8333 16.0417H7.5C7.15482 16.0417 6.875 15.7618 6.875 15.4167Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M3.38553 8.72881C3.49738 8.51489 3.67686 8.3504 3.89189 8.26474C4.10692 8.17908 4.34349 8.17783 4.55931 8.26123C4.717 8.35929 4.84273 8.50658 4.91959 8.68325C4.99644 8.85992 5.02072 9.05749 4.98914 9.24933C4.93955 9.58458 4.71636 9.72574 4.16254 10.2815C3.79883 10.6521 3.52606 10.9609 3.33594 11.1638H4.98914M3.4434 13.8239H4.98914L4.07988 14.8208C4.33496 14.8412 4.57257 14.9668 4.74232 15.171C4.91207 15.3752 5.0006 15.642 4.98914 15.9147C4.94638 16.1186 4.84258 16.3021 4.69344 16.4374C4.5443 16.5727 4.35794 16.6524 4.16254 16.6646C4.02373 16.6739 3.88468 16.6512 3.75486 16.5979C3.62505 16.5446 3.50754 16.462 3.41033 16.3559M3.84843 2.92347L4.50971 2.5V5.43784",stroke:"currentColor","stroke-linecap":"round","stroke-linejoin":"round"})]}));});ListOrderedIcon.displayName='ListOrderedIcon';var _excluded$2=["className"];var ListTodoIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded$2);return jsxRuntime.jsx("svg",_extends({xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",className:className},props,{children:jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M6.70433 2.07355C6.93985 2.3259 6.92621 2.72139 6.67387 2.95691L3.10244 6.29025C2.97567 6.40856 2.80546 6.46889 2.63248 6.45682C2.4595 6.44475 2.29931 6.36136 2.19021 6.22658L1.17831 4.97658C0.96112 4.7083 1.00255 4.31474 1.27083 4.09756C1.53912 3.88037 1.93268 3.9218 2.14986 4.19009L2.73981 4.91884L5.82097 2.04309C6.07331 1.80757 6.4688 1.82121 6.70433 2.07355ZM9.37242 4.16667C9.37242 3.82149 9.65224 3.54167 9.99742 3.54167H18.3307C18.6759 3.54167 18.9557 3.82149 18.9557 4.16667C18.9557 4.51185 18.6759 4.79167 18.3307 4.79167H9.99742C9.65224 4.79167 9.37242 4.51185 9.37242 4.16667ZM6.70433 7.90689C6.93985 8.15923 6.92621 8.55472 6.67387 8.79025L3.10244 12.1236C2.97567 12.2419 2.80546 12.3022 2.63248 12.2902C2.4595 12.2781 2.29931 12.1947 2.19021 12.0599L1.17831 10.8099C0.96112 10.5416 1.00255 10.1481 1.27083 9.93089C1.53912 9.71371 1.93268 9.75513 2.14986 10.0234L2.73981 10.7522L5.82097 7.87643C6.07331 7.6409 6.4688 7.65454 6.70433 7.90689ZM9.37242 10C9.37242 9.65482 9.65224 9.375 9.99742 9.375H18.3307C18.6759 9.375 18.9557 9.65482 18.9557 10C18.9557 10.3452 18.6759 10.625 18.3307 10.625H9.99742C9.65224 10.625 9.37242 10.3452 9.37242 10ZM6.70433 13.7402C6.93985 13.9926 6.92621 14.3881 6.67387 14.6236L3.10244 17.9569C2.97567 18.0752 2.80546 18.1356 2.63248 18.1235C2.4595 18.1114 2.29931 18.028 2.19021 17.8932L1.17831 16.6433C0.96112 16.375 1.00255 15.9814 1.27083 15.7642C1.53912 15.547 1.93268 15.5885 2.14986 15.8568L2.73981 16.5855L5.82097 13.7098C6.07331 13.4742 6.4688 13.4879 6.70433 13.7402ZM9.37242 15.8333C9.37242 15.4882 9.65224 15.2083 9.99742 15.2083H18.3307C18.6759 15.2083 18.9557 15.4882 18.9557 15.8333C18.9557 16.1785 18.6759 16.4583 18.3307 16.4583H9.99742C9.65224 16.4583 9.37242 16.1785 9.37242 15.8333Z",fill:"currentColor"})}));});ListTodoIcon.displayName='ListTodoIcon';var _excluded$1=["editor","type","hideWhenUnavailable","className","onClick","text","children"];var listOptions=[{label:'Bullet List',type:'bulletList',icon:ListIcon},{label:'Ordered List',type:'orderedList',icon:ListOrderedIcon},{label:'Task List',type:'taskList',icon:ListTodoIcon}];var listShortcutKeys={bulletList:'Ctrl-Shift-8',orderedList:'Ctrl-Shift-7',taskList:'Ctrl-Shift-9'};function canToggleList(editor,type){if(!editor){return false;}switch(type){case'bulletList':return editor.can().toggleBulletList();case'orderedList':return editor.can().toggleOrderedList();case'taskList':return editor.can().toggleList('taskList','taskItem');default:return false;}}function isListActive(editor,type){if(!editor)return false;switch(type){case'bulletList':return editor.isActive('bulletList');case'orderedList':return editor.isActive('orderedList');case'taskList':return editor.isActive('taskList');default:return false;}}function toggleList(editor,type){if(!editor)return;switch(type){case'bulletList':editor.chain().focus().toggleBulletList().run();break;case'orderedList':editor.chain().focus().toggleOrderedList().run();break;case'taskList':editor.chain().focus().toggleList('taskList','taskItem').run();break;}}function getListOption(type){return listOptions.find(function(option){return option.type===type;});}function shouldShowListButton(params){var editor=params.editor,type=params.type,hideWhenUnavailable=params.hideWhenUnavailable,listInSchema=params.listInSchema;if(!listInSchema){return false;}if(hideWhenUnavailable){if(react.isNodeSelection(editor==null?void 0:editor.state.selection)&&!canToggleList(editor,type)){return false;}}return true;}function useListState(editor,type){var listInSchema=isNodeInSchema(type,editor);var listOption=getListOption(type);var isActive=isListActive(editor,type);var shortcutKey=listShortcutKeys[type];return{listInSchema:listInSchema,listOption:listOption,isActive:isActive,shortcutKey:shortcutKey};}var ListButton=React__namespace.forwardRef(function(_ref,ref){var providedEditor=_ref.editor,type=_ref.type,_ref$hideWhenUnavaila=_ref.hideWhenUnavailable,hideWhenUnavailable=_ref$hideWhenUnavaila===void 0?false:_ref$hideWhenUnavaila,_ref$className=_ref.className,className=_ref$className===void 0?'':_ref$className,onClick=_ref.onClick,text=_ref.text,children=_ref.children,buttonProps=_objectWithoutPropertiesLoose(_ref,_excluded$1);var editor=useTiptapEditor(providedEditor);var _useListState=useListState(editor,type),listInSchema=_useListState.listInSchema,listOption=_useListState.listOption,isActive=_useListState.isActive,shortcutKey=_useListState.shortcutKey;var Icon=(listOption==null?void 0:listOption.icon)||ListIcon;var handleClick=React__namespace.useCallback(function(e){onClick==null||onClick(e);if(!e.defaultPrevented&&editor){toggleList(editor,type);}},[onClick,editor,type]);var show=React__namespace.useMemo(function(){return shouldShowListButton({editor:editor,type:type,hideWhenUnavailable:hideWhenUnavailable,listInSchema:listInSchema});},[editor,type,hideWhenUnavailable,listInSchema]);if(!show||!editor||!editor.isEditable){return null;}return jsxRuntime.jsx(Button,_extends({type:"button",className:className.trim(),"data-style":"ghost","data-active-state":isActive?'on':'off',role:"button",tabIndex:-1,"aria-label":(listOption==null?void 0:listOption.label)||type,"aria-pressed":isActive,tooltip:(listOption==null?void 0:listOption.label)||type,shortcutKeys:shortcutKey,onClick:handleClick,"data-size":'large'},buttonProps,{ref:ref,children:children||jsxRuntime.jsxs(React__namespace.Fragment,{children:[jsxRuntime.jsx(Icon,{className:"tiptap-button-icon"}),text&&jsxRuntime.jsx("span",{className:"tiptap-button-text",children:text})]})}));});ListButton.displayName='ListButton';function useIsInTable(editor){var _useState=React.useState(false),inTable=_useState[0],setInTable=_useState[1];React.useEffect(function(){if(!editor)return;var update=function update(){setInTable(tables.isInTable(editor.state));};update();editor.on('selectionUpdate',update);return function(){editor.off('selectionUpdate',update);};},[editor]);return inTable;}var _excluded=["className"],_excluded2=["className"],_excluded3=["className"],_excluded4=["className"];var AddCircleIcon=React__namespace.memo(function(_ref){var className=_ref.className,props=_objectWithoutPropertiesLoose(_ref,_excluded);return jsxRuntime.jsxs("svg",_extends({xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",className:className},props,{children:[jsxRuntime.jsx("path",{d:"M10.6224 7.50033C10.6224 7.15515 10.3426 6.87533 9.9974 6.87533C9.65222 6.87533 9.3724 7.15515 9.3724 7.50033L9.3724 9.37535H7.4974C7.15222 9.37535 6.8724 9.65517 6.8724 10.0003C6.8724 10.3455 7.15222 10.6253 7.4974 10.6253H9.3724V12.5003C9.3724 12.8455 9.65222 13.1253 9.9974 13.1253C10.3426 13.1253 10.6224 12.8455 10.6224 12.5003L10.6224 10.6253H12.4974C12.8426 10.6253 13.1224 10.3455 13.1224 10.0003C13.1224 9.65517 12.8426 9.37535 12.4974 9.37535H10.6224V7.50033Z",fill:"currentColor"}),jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M9.9974 1.04199C5.04985 1.04199 1.03906 5.05277 1.03906 10.0003C1.03906 14.9479 5.04985 18.9587 9.9974 18.9587C14.9449 18.9587 18.9557 14.9479 18.9557 10.0003C18.9557 5.05277 14.9449 1.04199 9.9974 1.04199ZM2.28906 10.0003C2.28906 5.74313 5.7402 2.29199 9.9974 2.29199C14.2546 2.29199 17.7057 5.74313 17.7057 10.0003C17.7057 14.2575 14.2546 17.7087 9.9974 17.7087C5.7402 17.7087 2.28906 14.2575 2.28906 10.0003Z",fill:"currentColor"})]}));});AddCircleIcon.displayName='AddCircleIcon';var TrashIcon=React__namespace.memo(function(_ref2){var className=_ref2.className,props=_objectWithoutPropertiesLoose(_ref2,_excluded2);return jsxRuntime.jsxs("svg",_extends({xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",className:className},props,{children:[jsxRuntime.jsx("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M8.58853 1.87502H11.4064C11.5867 1.8749 11.7438 1.8748 11.8922 1.89849C12.4783 1.99208 12.9854 2.35762 13.2595 2.88403C13.3289 3.01727 13.3785 3.16634 13.4354 3.33745L13.5284 3.61654C13.5442 3.66378 13.5487 3.67715 13.5525 3.68768C13.6984 4.09111 14.0768 4.36383 14.5057 4.3747C14.5169 4.37498 14.5308 4.37503 14.5808 4.37503H17.0808C17.426 4.37503 17.7058 4.65485 17.7058 5.00003C17.7058 5.34521 17.426 5.62503 17.0808 5.62503H2.91406C2.56888 5.62503 2.28906 5.34521 2.28906 5.00003C2.28906 4.65485 2.56888 4.37503 2.91406 4.37503H5.41413C5.46417 4.37503 5.47798 4.37498 5.48926 4.3747C5.91813 4.36383 6.29648 4.09113 6.44242 3.6877C6.44625 3.67709 6.45066 3.66401 6.46649 3.61654L6.55949 3.33747C6.61641 3.16637 6.666 3.01728 6.73538 2.88403C7.0095 2.35762 7.51667 1.99208 8.10275 1.89849C8.2511 1.8748 8.4082 1.8749 8.58853 1.87502ZM7.50419 4.37503C7.54711 4.29085 7.58515 4.20337 7.61788 4.1129C7.62781 4.08543 7.63756 4.05619 7.65008 4.01861L7.73325 3.7691C7.80922 3.54118 7.82672 3.49469 7.84407 3.46137C7.93544 3.2859 8.1045 3.16405 8.29986 3.13285C8.33696 3.12693 8.38659 3.12503 8.62685 3.12503H11.3681C11.6083 3.12503 11.658 3.12693 11.6951 3.13285C11.8904 3.16405 12.0595 3.2859 12.1509 3.46137C12.1682 3.49469 12.1857 3.54117 12.2617 3.7691L12.3448 4.01846L12.3771 4.11292C12.4098 4.20338 12.4478 4.29085 12.4907 4.37503H7.50419Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M4.92664 7.04179C4.90368 6.69738 4.60586 6.43679 4.26145 6.45975C3.91703 6.48271 3.65644 6.78053 3.67941 7.12494L4.06561 12.9181C4.13686 13.987 4.19441 14.8505 4.32939 15.528C4.46972 16.2324 4.7084 16.8208 5.2014 17.2821C5.69439 17.7433 6.29735 17.9423 7.00956 18.0355C7.69458 18.1251 8.55993 18.125 9.63123 18.125H10.3636C11.4349 18.125 12.3003 18.1251 12.9854 18.0355C13.6976 17.9423 14.3005 17.7433 14.7935 17.2821C15.2865 16.8208 15.5252 16.2324 15.6655 15.528C15.8005 14.8505 15.8581 13.987 15.9293 12.9181L16.3155 7.12494C16.3385 6.78053 16.0779 6.48271 15.7335 6.45975C15.3891 6.43679 15.0913 6.69738 15.0683 7.04179L14.685 12.7911C14.6101 13.9143 14.5568 14.6958 14.4396 15.2838C14.326 15.8542 14.1674 16.1561 13.9396 16.3692C13.7117 16.5824 13.3999 16.7206 12.8232 16.796C12.2287 16.8738 11.4454 16.875 10.3197 16.875H9.67523C8.54953 16.875 7.76619 16.8738 7.17169 16.796C6.59502 16.7206 6.28322 16.5824 6.05538 16.3692C5.82753 16.1561 5.66892 15.8542 5.5553 15.2838C5.43816 14.6958 5.3848 13.9143 5.30992 12.7911L4.92664 7.04179Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M7.85195 8.5448C8.19541 8.51045 8.50169 8.76104 8.53604 9.10451L8.9527 13.2712C8.98705 13.6146 8.73646 13.9209 8.393 13.9553C8.04953 13.9896 7.74325 13.739 7.70891 13.3956L7.29224 9.22889C7.25789 8.88542 7.50848 8.57915 7.85195 8.5448Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M12.143 8.5448C12.4865 8.57915 12.737 8.88542 12.7027 9.22889L12.286 13.3956C12.2517 13.739 11.9454 13.9896 11.6019 13.9553C11.2585 13.9209 11.0079 13.6146 11.0422 13.2712L11.4589 9.10451C11.4933 8.76104 11.7995 8.51045 12.143 8.5448Z",fill:"currentColor"})]}));});TrashIcon.displayName='TrashIcon';var ParagraphSpacingIcon=React__namespace.memo(function(_ref3){var className=_ref3.className,props=_objectWithoutPropertiesLoose(_ref3,_excluded3);return jsxRuntime.jsxs("svg",_extends({xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",className:className},props,{children:[jsxRuntime.jsx("path",{d:"M2.5 17.292C2.15482 17.292 1.875 17.0122 1.875 16.667L1.875 3.33366C1.875 2.98848 2.15482 2.70866 2.5 2.70866C2.84518 2.70866 3.125 2.98848 3.125 3.33366L3.125 16.667C3.125 17.0122 2.84518 17.292 2.5 17.292Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M17.5 17.292C17.1548 17.292 16.875 17.0122 16.875 16.667L16.875 3.33366C16.875 2.98848 17.1548 2.70866 17.5 2.70866C17.8452 2.70866 18.125 2.98848 18.125 3.33366L18.125 16.667C18.125 17.0122 17.8452 17.292 17.5 17.292Z",fill:"currentColor"}),jsxRuntime.jsx("path",{d:"M4.14139 9.55838C3.89731 9.80246 3.89731 10.1982 4.14139 10.4423L6.64139 12.9423C6.88547 13.1863 7.2812 13.1863 7.52528 12.9423C7.76935 12.6982 7.76935 12.3025 7.52528 12.0584L6.09222 10.6253L13.9078 10.6253L12.4747 12.0584C12.2306 12.3025 12.2306 12.6982 12.4747 12.9423C12.7188 13.1863 13.1145 13.1863 13.3586 12.9423L15.8586 10.4423C16.1027 10.1982 16.1027 9.80246 15.8586 9.55838L13.3586 7.05838C13.1145 6.81431 12.7188 6.81431 12.4747 7.05838C12.2306 7.30246 12.2306 7.69819 12.4747 7.94227L13.9078 9.37533L6.09222 9.37533L7.52527 7.94227C7.76935 7.69819 7.76935 7.30246 7.52527 7.05838C7.2812 6.81431 6.88547 6.81431 6.64139 7.05838L4.14139 9.55838Z",fill:"currentColor"})]}));});ParagraphSpacingIcon.displayName='ParagraphSpacingIcon';var ParagraphSplitIcon=React__namespace.memo(function(_ref4){var className=_ref4.className,props=_objectWithoutPropertiesLoose(_ref4,_excluded4);return jsxRuntime.jsxs("svg",_extends({fill:"currentColor",width:"20",height:"20",viewBox:"0 0 24.00 24.00",xmlns:"http://www.w3.org/2000/svg",stroke:"currentColor","stroke-width":"0.00024000000000000003",transform:"rotate(0)",className:className},props,{children:[jsxRuntime.jsx("g",{id:"SVGRepo_bgCarrier","stroke-width":"0"}),jsxRuntime.jsx("g",{id:"SVGRepo_tracerCarrier","stroke-linecap":"round","stroke-linejoin":"round"}),jsxRuntime.jsxs("g",{id:"SVGRepo_iconCarrier",children:[" ",jsxRuntime.jsx("path",{d:"M19.2928932,12 L14,12 L14,19.5 C14,19.7761424 13.7761424,20 13.5,20 C13.2238576,20 13,19.7761424 13,19.5 L13,3.5 C13,3.22385763 13.2238576,3 13.5,3 C13.7761424,3 14,3.22385763 14,3.5 L14,11 L19.2928932,11 L16.1464466,7.85355339 C15.9511845,7.65829124 15.9511845,7.34170876 16.1464466,7.14644661 C16.3417088,6.95118446 16.6582912,6.95118446 16.8535534,7.14644661 L20.8535534,11.1464466 C21.0488155,11.3417088 21.0488155,11.6582912 20.8535534,11.8535534 L16.8535534,15.8535534 C16.6582912,16.0488155 16.3417088,16.0488155 16.1464466,15.8535534 C15.9511845,15.6582912 15.9511845,15.3417088 16.1464466,15.1464466 L19.2928932,12 Z M4.70710678,11 L10,11 L10,3.5 C10,3.22385763 10.2238576,3 10.5,3 C10.7761424,3 11,3.22385763 11,3.5 L11,19.5 C11,19.7761424 10.7761424,20 10.5,20 C10.2238576,20 10,19.7761424 10,19.5 L10,12 L4.70710678,12 L7.85355339,15.1464466 C8.04881554,15.3417088 8.04881554,15.6582912 7.85355339,15.8535534 C7.65829124,16.0488155 7.34170876,16.0488155 7.14644661,15.8535534 L3.14644661,11.8535534 C2.95118446,11.6582912 2.95118446,11.3417088 3.14644661,11.1464466 L7.14644661,7.14644661 C7.34170876,6.95118446 7.65829124,6.95118446 7.85355339,7.14644661 C8.04881554,7.34170876 8.04881554,7.65829124 7.85355339,7.85355339 L4.70710678,11 Z"})," "]})]}));});ParagraphSplitIcon.displayName='ParagraphSplitIcon';var FloatingTableButton=function FloatingTableButton(_ref){var editor=_ref.editor;var isInTable=useIsInTable(editor);var _useState=React.useState({top:0,left:0}),position=_useState[0],setPosition=_useState[1];var _useState2=React.useState(null),tableElement=_useState2[0],setTableElement=_useState2[1];var appendToDom=document.querySelector('.simple-editor-content')||document.body;React.useEffect(function(){if(!editor||!isInTable)return;var _editor$view$domAtPos=editor.view.domAtPos(editor.state.selection.anchor),node=_editor$view$domAtPos.node;var cell=node.nodeType===3?node.parentElement:node;var tableCell=cell==null?void 0:cell.closest('td, th');if(tableCell&&appendToDom instanceof HTMLElement){var containerRect=appendToDom.getBoundingClientRect();var cellRect=tableCell.getBoundingClientRect();setPosition({top:cellRect.top-containerRect.top+10,left:cellRect.left-containerRect.left+cellRect.width-24});setTableElement(tableCell);}else{setTableElement(null);}},[editor,isInTable,editor.state.selection]);if(!isInTable||!tableElement)return null;var onClick=function onClick(_ref2){var key=_ref2.key;if(!editor||!editor.isEditable)return;// if (!editor.state.selection.$from.node().type.spec.tableRole) return
try{switch(key){case'addRowAbove':editor.chain().focus().addRowBefore().run();break;case'addRowBelow':editor.chain().focus().addRowAfter().run();break;case'addColumnLeft':editor.chain().focus().addColumnBefore().run();break;case'addColumnRight':editor.chain().focus().addColumnAfter().run();break;case'removeRow':editor.chain().focus().deleteRow().run();break;case'removeColumn':editor.chain().focus().deleteColumn().run();break;case'removeTable':editor.chain().focus().deleteTable().run();break;case'mergeCells':editor.chain().focus().mergeCells().run();break;case'splitCell':editor.chain().focus().splitCell().run();break;case'toggleHeaderRow':editor.chain().focus().toggleHeaderRow().run();break;case'toggleHeaderColumn':editor.chain().focus().toggleHeaderColumn().run();break;case'toggleHeaderCell':editor.chain().focus().toggleHeaderCell().run();break;default:break;}}catch(e){console.warn('Table command failed:',e);}};var items=[{key:'addRowAbove',label:"Add row above",// action: editor => editor.chain().focus().addRowBefore().run(),
icon:jsxRuntime.jsx(AddCircleIcon,{className:'tiptap-button-icon'})},{key:'addRowBelow',label:"Add row below",// action: editor => editor.chain().focus().addRowAfter().run(),
icon:jsxRuntime.jsx(AddCircleIcon,{className:'tiptap-button-icon'})},{key:'addColumnLeft',label:"Add column left",// action: editor => editor.chain().focus().addColumnBefore().run(),
icon:jsxRuntime.jsx(AddCircleIcon,{className:'tiptap-button-icon'})},{key:'addColumnRight',label:"Add column right",// action: editor => editor.chain().focus().addColumnAfter().run(),
icon:jsxRuntime.jsx(AddCircleIcon,{className:'tiptap-button-icon'})},{type:'divider'},{key:'removeRow',label:"Remove row",// action: editor => editor.chain().focus().deleteRow().run(),
icon:jsxRuntime.jsx(TrashIcon,{className:'tiptap-button-icon'})},{key:'removeColumn',label:"Remove column",// action: editor => editor.chain().focus().deleteColumn().run(),
icon:jsxRuntime.jsx(TrashIcon,{className:'tiptap-button-icon'})},{key:'removeTable',label:"Remove table",// action: editor => editor.chain().focus().deleteTable().run(),
icon:jsxRuntime.jsx(TrashIcon,{className:'tiptap-button-icon'})},{type:'divider'},{key:'mergeCells',label:"Merge cells",// action: editor => editor.chain().focus().mergeCells(),
icon:jsxRuntime.jsx(ParagraphSpacingIcon,{className:'tiptap-button-icon'})},{key:'splitCell',label:"Split cell",// action: editor => editor.chain().focus().splitCell().run(),
icon:jsxRuntime.jsx(ParagraphSplitIcon,{className:'tiptap-button-icon'})}// {
//   label: "Toggle header row",
//   type: 'action',
//   action: editor => editor.chain().focus().toggleHeaderRow().run()
// },
// {
//   label: "Toggle header column",
//   type: 'action',
//   action: editor => editor.chain().focus().toggleHeaderColumn().run()
// },
// {
//   label: "Toggle header cell",
//   type: 'action',
//   action: editor => editor.chain().focus().toggleHeaderCell().run()
// },
];var button=jsxRuntime.jsx("div",{style:{position:'absolute',top:position.top+"px",left:position.left+"px",zIndex:1},children:jsxRuntime.jsx(antd.Dropdown,{menu:{items:items,onClick:onClick},trigger:['click'],rootClassName:'sapp-table-dropdown',children:jsxRuntime.jsx("button",{className:"sapp-table-trigger-button","data-active-state":'on',type:"button",children:jsxRuntime.jsx(ChevronDownIcon,{width:'16px',height:'16px'})})})});return reactDom.createPortal(button,appendToDom);};var fontOptions=[{label:'Roboto',value:'Roboto'},{label:'Andale Mono',value:'"Andale Mono"'},{label:'Arial',value:'Arial'},{label:'Arial Black',value:'"Arial Black"'},{label:'Book Antiqua',value:'"Book Antiqua"'},{label:'Comic Sans MS',value:'"Comic Sans MS", "Comic Sans"'},{label:'Courier New',value:'"Courier New", Courier'},{label:'Georgia',value:'Georgia'},{label:'Helvetica',value:'Helvetica'},{label:'Impact',value:'Impact'},{label:'Symbol',value:'Symbol'},{label:'Tahoma',value:'Tahoma'},{label:'Terminal',value:'Terminal'},{label:'Times New Roman',value:'"Times New Roman", Times'},{label:'Trebuchet MS',value:'"Trebuchet MS"'},{label:'Verdana',value:'Verdana'},{label:'Webdings',value:'Webdings'},{label:'Wingdings',value:'Wingdings'}];var MainToolbarContent=function MainToolbarContent(_ref){var _fontOptions$find;var onHighlighterClick=_ref.onHighlighterClick,onLinkClick=_ref.onLinkClick,isMobile=_ref.isMobile,editor=_ref.editor,isShowIconImageUpload=_ref.isShowIconImageUpload,disabled=_ref.disabled;React.useState(false);// Xác định font đang active
var activeFont=((_fontOptions$find=fontOptions.find(function(option){return editor==null?void 0:editor.isActive('textStyle',{fontFamily:option.value});}))==null?void 0:_fontOptions$find.value)||'Roboto';var handleChangeFontFamily=function handleChangeFontFamily(value){if(value==='unset'){editor==null||editor.chain().focus().unsetFontFamily().run();}else{editor==null||editor.chain().focus().setFontFamily(value).run();}};if(disabled)return jsxRuntime.jsxs(React__default["default"].Fragment,{children:[" ",jsxRuntime.jsx(Spacer,{}),jsxRuntime.jsxs(ToolbarGroup,{children:[" ",jsxRuntime.jsx(ThemeToggle,{})," "]})]});return jsxRuntime.jsx(React__default["default"].Fragment,{children:jsxRuntime.jsxs(ToolbarRow,{children:[jsxRuntime.jsxs(ToolbarGroup,{children:[jsxRuntime.jsx(antd.Select,{variant:'borderless',placeholder:"Ch\u1ECDn font",value:activeFont||undefined,onChange:handleChangeFontFamily,options:[].concat(fontOptions,[{label:'Unset',value:'unset'}]),dropdownStyle:{width:200,borderRadius:12},suffixIcon:jsxRuntime.jsx(ChevronDownIcon,{width:'16px',height:'16px'}),className:'sapp-toolbar-select',size:'small'}),jsxRuntime.jsx(FontSizeDropdown,{editor:editor})]}),jsxRuntime.jsx(ToolbarSeparator,{}),jsxRuntime.jsxs(ToolbarGroup,{children:[jsxRuntime.jsx(MarkButton,{type:"bold"}),jsxRuntime.jsx(MarkButton,{type:"italic"}),jsxRuntime.jsx(MarkButton,{type:"underline"}),editor&&jsxRuntime.jsx(ColorPicker,{editor:editor})]}),jsxRuntime.jsx(ToolbarSeparator,{}),jsxRuntime.jsxs(ToolbarGroup,{children:[jsxRuntime.jsx(TextAlignDropdownMenu,{listTypes:['left','center','right','justify']}),jsxRuntime.jsx(ListButton,{type:"taskList"}),jsxRuntime.jsx(ListButton,{type:"bulletList"}),jsxRuntime.jsx(ListButton,{type:"orderedList"})]}),jsxRuntime.jsx(ToolbarSeparator,{}),jsxRuntime.jsxs(ToolbarGroup,{children:[!isMobile?jsxRuntime.jsx(LinkPopover,{}):jsxRuntime.jsx(LinkButton,{onClick:onLinkClick}),isShowIconImageUpload&&jsxRuntime.jsx(ImageUploadButton,{})]}),jsxRuntime.jsx(ToolbarSeparator,{}),jsxRuntime.jsxs(ToolbarGroup,{children:[jsxRuntime.jsx("button",{onClick:function onClick(){return editor==null?void 0:editor.commands.insertTable({rows:3,cols:3,withHeaderRow:true});},className:"tiptap-button tiptap-button-ghost bg-transparent","data-size":'large',children:jsxRuntime.jsx(TableIcon,{className:"tiptap-button-icon"})}),!isMobile?jsxRuntime.jsx(HighlightPopover,{}):jsxRuntime.jsx(HighlighterButton,{onClick:onHighlighterClick})]}),jsxRuntime.jsx(ToolbarSeparator,{}),jsxRuntime.jsxs(ToolbarGroup,{children:[jsxRuntime.jsx(UndoRedoButton,{action:"undo"}),jsxRuntime.jsx(UndoRedoButton,{action:"redo"})]}),jsxRuntime.jsx(Spacer,{}),jsxRuntime.jsx(MoreButton,{})]})});};var MobileToolbarContent=function MobileToolbarContent(_ref2){var type=_ref2.type,onBack=_ref2.onBack;return jsxRuntime.jsxs("div",{children:[jsxRuntime.jsx(ToolbarGroup,{children:jsxRuntime.jsxs(Button,{"data-style":"ghost",onClick:onBack,children:[jsxRuntime.jsx(ArrowLeftIcon,{className:"tiptap-button-icon"}),type==='highlighter'?jsxRuntime.jsx(HighlighterIcon,{className:"tiptap-button-icon"}):jsxRuntime.jsx(LinkIcon,{className:"tiptap-button-icon"})]})}),jsxRuntime.jsx(ToolbarSeparator,{}),type==='highlighter'?jsxRuntime.jsx(HighlightContent,{}):jsxRuntime.jsx(LinkContent,{})]});};var SAPPEditor=React.forwardRef(function(props,ref){var _props$content=props.content,content=_props$content===void 0?'':_props$content,onChange=props.onChange,handleImageUpload=props.handleImageUpload,_props$disabled=props.disabled,disabled=_props$disabled===void 0?false:_props$disabled,_props$placeholder=props.placeholder,placeholder=_props$placeholder===void 0?'':_props$placeholder;var isMobile=useMobile();var windowSize=useWindowSize();var _React$useState=React__default["default"].useState('main'),mobileView=_React$useState[0],setMobileView=_React$useState[1];var _React$useState2=React__default["default"].useState({x:0,y:0,width:0,height:0}),rect=_React$useState2[0];var toolbarRef=React__default["default"].useRef(null);var editor=react.useEditor({editable:!disabled,immediatelyRender:false,editorProps:{handleDOMEvents:{focus:function focus(){return true;}},attributes:{autocomplete:'off',autocorrect:'off',autocapitalize:'off','aria-label':'Main content area, start typing to enter text.'},handlePaste:function handlePaste(view,event,slice){var _event$clipboardData;var items=Array.from(((_event$clipboardData=event.clipboardData)==null?void 0:_event$clipboardData.items)||[]);for(var _i=0,_items=items;_i<_items.length;_i++){var item=_items[_i];if(item.type.startsWith('image/')){var file=item.getAsFile();if(file&&handleImageUpload){// 👉 Xử lý upload ảnh tại đây
handleImageUpload(file).then(function(url){editor==null||editor.chain().focus().setImage({src:url}).run();});}return true;// Ngăn dán mặc định
}}return false;// Cho phép các nội dung khác dán bình thường
}},extensions:[StarterKit__default["default"],Placeholder__default["default"].configure({placeholder:placeholder,emptyEditorClass:'is-editor-empty',showOnlyWhenEditable:true}),TextStyle__default["default"],FontFamily__default["default"].configure({types:['textStyle']}),FontSize.configure({defaultSize:'14px'}),Document,Text,Paragraph,TextAlign__default["default"].configure({types:['heading','paragraph']}),Underline__default["default"],TaskList__default["default"],Table__default["default"].configure({resizable:true}),TableRow__default["default"],TableHeader__default["default"],TableCell__default["default"],TaskItem__default["default"].configure({nested:true}),Highlight__default["default"].configure({multicolor:true}),ResizableImage.configure({inline:false,allowBase64:true}),Selection,Typography__default["default"],Superscript__default["default"],Subscript__default["default"],Color__default["default"].configure({types:['textStyle']}),ImageUploadNode.configure({accept:'image/*',maxSize:MAX_FILE_SIZE,limit:3,upload:handleImageUpload,onError:function onError(error){// Handle error without console.log
return error;}}),TrailingNode,Link.configure({openOnClick:false})],content:content,onUpdate:function onUpdate(_ref3){var editor=_ref3.editor;var html=editor.getHTML();onChange==null||onChange(html);}});var initialContentRef=React.useRef(content);// Hàm di chuyển selection ra ngoài table
var moveSelectionOutOfTable=function moveSelectionOutOfTable(){if(!editor)return;requestAnimationFrame(function(){var $from=editor.state.selection.$from;if($from.node().type.name==='table'){editor.chain().setTextSelection(editor.state.doc.content.size).run();}});};// Hàm reset content safe
var resetContentSafe=function resetContentSafe(newContent){if(!editor)return;try{requestAnimationFrame(function(){var $from=editor.state.selection.$from;if($from.node().type.name==='table'){editor.chain().setTextSelection(editor.state.doc.content.size).run();}editor.chain().setContent(newContent).focus().run();});}catch(err){console.warn('Reset editor content failed:',err);}};React.useEffect(function(){if(editor&&content!==initialContentRef.current){// Chỉ update khi content thật sự thay đổi từ bên ngoài
// if (editor.getHTML() !== content) {
//   console.log('update content that')
editor.chain().setContent(content).focus().run();initialContentRef.current=content;// }
}},[editor]);React.useEffect(function(){if(editor){editor.setEditable(!disabled);}},[disabled,editor]);// Expose ra bên ngoài
React.useImperativeHandle(ref,function(){return{moveSelectionOutOfTable:moveSelectionOutOfTable,resetContentSafe:resetContentSafe};});return jsxRuntime.jsx(react.EditorContext.Provider,{value:{editor:editor},children:jsxRuntime.jsxs("div",{className:"sapp-editor-container",children:[!disabled&&jsxRuntime.jsx("div",{className:'sapp-toolbar-wrapper',children:jsxRuntime.jsx(Toolbar,{ref:toolbarRef,style:isMobile?{bottom:"calc(100% - "+(windowSize.height-rect.y)+"px)"}:{},children:mobileView==='main'?jsxRuntime.jsx(MainToolbarContent,{onHighlighterClick:function onHighlighterClick(){return setMobileView('highlighter');},onLinkClick:function onLinkClick(){return setMobileView('link');},isMobile:isMobile,editor:editor,isShowIconImageUpload:!!handleImageUpload,disabled:disabled}):jsxRuntime.jsx(MobileToolbarContent,{type:mobileView==='highlighter'?'highlighter':'link',onBack:function onBack(){return setMobileView('main');}})})}),jsxRuntime.jsx(react.EditorContent,{editor:editor,role:"presentation",className:"simple-editor-content",onMouseDown:function onMouseDown(e){// Cho phép select
e.stopPropagation();},onChange:function onChange(e){console.log(e);}}),editor&&jsxRuntime.jsx(FloatingTableButton,{editor:editor})]})});});exports.R5=SAPPCalendar$1;__webpack_unused_export__=SAPPCalendar;exports.Ad=SAPPEditor;

/***/ }),

/***/ 11155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Affix": function() { return /* reexport */ es_affix; },
  "Alert": function() { return /* reexport */ es_alert; },
  "Anchor": function() { return /* reexport */ es_anchor; },
  "App": function() { return /* reexport */ app; },
  "AutoComplete": function() { return /* reexport */ auto_complete; },
  "Avatar": function() { return /* reexport */ avatar; },
  "BackTop": function() { return /* reexport */ back_top; },
  "Badge": function() { return /* reexport */ es_badge; },
  "Breadcrumb": function() { return /* reexport */ breadcrumb; },
  "Button": function() { return /* reexport */ es_button; },
  "Calendar": function() { return /* reexport */ calendar; },
  "Card": function() { return /* reexport */ card; },
  "Carousel": function() { return /* reexport */ carousel; },
  "Cascader": function() { return /* reexport */ cascader; },
  "Checkbox": function() { return /* reexport */ es_checkbox; },
  "Col": function() { return /* reexport */ es_col; },
  "Collapse": function() { return /* reexport */ es_collapse; },
  "ColorPicker": function() { return /* reexport */ color_picker; },
  "ConfigProvider": function() { return /* reexport */ config_provider; },
  "DatePicker": function() { return /* reexport */ date_picker; },
  "Descriptions": function() { return /* reexport */ descriptions; },
  "Divider": function() { return /* reexport */ divider; },
  "Drawer": function() { return /* reexport */ drawer; },
  "Dropdown": function() { return /* reexport */ es_dropdown; },
  "Empty": function() { return /* reexport */ es_empty; },
  "Flex": function() { return /* reexport */ flex; },
  "FloatButton": function() { return /* reexport */ float_button; },
  "Form": function() { return /* reexport */ es_form; },
  "Grid": function() { return /* reexport */ grid; },
  "Image": function() { return /* reexport */ es_image; },
  "Input": function() { return /* reexport */ es_input; },
  "InputNumber": function() { return /* reexport */ input_number; },
  "Layout": function() { return /* reexport */ es_layout; },
  "List": function() { return /* reexport */ list; },
  "Mentions": function() { return /* reexport */ mentions; },
  "Menu": function() { return /* reexport */ es_menu; },
  "Modal": function() { return /* reexport */ modal; },
  "Pagination": function() { return /* reexport */ es_pagination; },
  "Popconfirm": function() { return /* reexport */ popconfirm; },
  "Popover": function() { return /* reexport */ popover; },
  "Progress": function() { return /* reexport */ es_progress; },
  "QRCode": function() { return /* reexport */ qr_code; },
  "Radio": function() { return /* reexport */ es_radio; },
  "Rate": function() { return /* reexport */ rate; },
  "Result": function() { return /* reexport */ result; },
  "Row": function() { return /* reexport */ es_row; },
  "Segmented": function() { return /* reexport */ segmented; },
  "Select": function() { return /* reexport */ es_select; },
  "Skeleton": function() { return /* reexport */ skeleton; },
  "Slider": function() { return /* reexport */ slider; },
  "Space": function() { return /* reexport */ space; },
  "Spin": function() { return /* reexport */ spin; },
  "Splitter": function() { return /* reexport */ splitter; },
  "Statistic": function() { return /* reexport */ statistic; },
  "Steps": function() { return /* reexport */ steps; },
  "Switch": function() { return /* reexport */ es_switch; },
  "Table": function() { return /* reexport */ table; },
  "Tabs": function() { return /* reexport */ es_tabs; },
  "Tag": function() { return /* reexport */ tag; },
  "TimePicker": function() { return /* reexport */ time_picker; },
  "Timeline": function() { return /* reexport */ timeline; },
  "Tooltip": function() { return /* reexport */ es_tooltip; },
  "Tour": function() { return /* reexport */ tour; },
  "Transfer": function() { return /* reexport */ transfer; },
  "Tree": function() { return /* reexport */ tree; },
  "TreeSelect": function() { return /* reexport */ tree_select; },
  "Typography": function() { return /* reexport */ typography; },
  "Upload": function() { return /* reexport */ upload; },
  "Watermark": function() { return /* reexport */ watermark; },
  "message": function() { return /* reexport */ es_message; },
  "notification": function() { return /* reexport */ es_notification; },
  "theme": function() { return /* reexport */ es_theme; },
  "unstableSetRender": function() { return /* reexport */ unstableSetRender; },
  "version": function() { return /* reexport */ es_version; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(68925);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-resize-observer/es/index.js + 4 modules
var es = __webpack_require__(49938);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(83889);
// EXTERNAL MODULE: ./node_modules/rc-util/es/raf.js
var raf = __webpack_require__(13157);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/throttleByAnimationFrame.js


function throttleByAnimationFrame(fn) {
  let requestId = null;
  const later = args => () => {
    requestId = null;
    fn.apply(void 0, (0,toConsumableArray/* default */.Z)(args));
  };
  const throttled = (...args) => {
    if (requestId === null) {
      requestId = (0,raf/* default */.Z)(later(args));
    }
  };
  throttled.cancel = () => {
    raf/* default.cancel */.Z.cancel(requestId);
    requestId = null;
  };
  return throttled;
}
/* harmony default export */ var _util_throttleByAnimationFrame = (throttleByAnimationFrame);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/config-provider/context.js

const defaultPrefixCls = 'ant';
const defaultIconPrefixCls = 'anticon';
const Variants = ['outlined', 'borderless', 'filled', 'underlined'];
const defaultGetPrefixCls = (suffixCls, customizePrefixCls) => {
  if (customizePrefixCls) {
    return customizePrefixCls;
  }
  return suffixCls ? `${defaultPrefixCls}-${suffixCls}` : defaultPrefixCls;
};
// zombieJ: 🚨 Do not pass `defaultRenderEmpty` here since it will cause circular dependency.
const ConfigContext = /*#__PURE__*/react.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: defaultGetPrefixCls,
  iconPrefixCls: defaultIconPrefixCls
});
const {
  Consumer: ConfigConsumer
} = ConfigContext;
const EMPTY_OBJECT = {};
/**
 * Get ConfigProvider configured component props.
 * This help to reduce bundle size for saving `?.` operator.
 * Do not use as `useMemo` deps since we do not cache the object here.
 *
 * NOTE: not refactor this with `useMemo` since memo will cost another memory space,
 * which will waste both compare calculation & memory.
 */
function useComponentConfig(propName) {
  const context = react.useContext(ConfigContext);
  const {
    getPrefixCls,
    direction,
    getPopupContainer
  } = context;
  const propValue = context[propName];
  return Object.assign(Object.assign({
    classNames: EMPTY_OBJECT,
    styles: EMPTY_OBJECT
  }, propValue), {
    getPrefixCls,
    direction,
    getPopupContainer
  });
}
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs-utils/es/index.js + 12 modules
var cssinjs_utils_es = __webpack_require__(89158);
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs/es/index.js + 37 modules
var cssinjs_es = __webpack_require__(68946);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/style/index.js
"use client";


const textEllipsis = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis'
};
const resetComponent = (token, needInheritFontFamily = false) => ({
  boxSizing: 'border-box',
  margin: 0,
  padding: 0,
  color: token.colorText,
  fontSize: token.fontSize,
  // font-variant: @font-variant-base;
  lineHeight: token.lineHeight,
  listStyle: 'none',
  // font-feature-settings: @font-feature-settings-base;
  fontFamily: needInheritFontFamily ? 'inherit' : token.fontFamily
});
const resetIcon = () => ({
  display: 'inline-flex',
  alignItems: 'center',
  color: 'inherit',
  fontStyle: 'normal',
  lineHeight: 0,
  textAlign: 'center',
  textTransform: 'none',
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: '-0.125em',
  textRendering: 'optimizeLegibility',
  '-webkit-font-smoothing': 'antialiased',
  '-moz-osx-font-smoothing': 'grayscale',
  '> *': {
    lineHeight: 1
  },
  svg: {
    display: 'inline-block'
  }
});
const clearFix = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  '&::before': {
    display: 'table',
    content: '""'
  },
  '&::after': {
    // https://github.com/ant-design/ant-design/issues/21864
    display: 'table',
    clear: 'both',
    content: '""'
  }
});
const genLinkStyle = token => ({
  a: {
    color: token.colorLink,
    textDecoration: token.linkDecoration,
    backgroundColor: 'transparent',
    // remove the gray background on active links in IE 10.
    outline: 'none',
    cursor: 'pointer',
    transition: `color ${token.motionDurationSlow}`,
    '-webkit-text-decoration-skip': 'objects',
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    '&:hover': {
      color: token.colorLinkHover
    },
    '&:active': {
      color: token.colorLinkActive
    },
    '&:active, &:hover': {
      textDecoration: token.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    '&:focus': {
      textDecoration: token.linkFocusDecoration,
      outline: 0
    },
    '&[disabled]': {
      color: token.colorTextDisabled,
      cursor: 'not-allowed'
    }
  }
});
const genCommonStyle = (token, componentPrefixCls, rootCls, resetFont) => {
  const prefixSelector = `[class^="${componentPrefixCls}"], [class*=" ${componentPrefixCls}"]`;
  const rootPrefixSelector = rootCls ? `.${rootCls}` : prefixSelector;
  const resetStyle = {
    boxSizing: 'border-box',
    '&::before, &::after': {
      boxSizing: 'border-box'
    }
  };
  let resetFontStyle = {};
  if (resetFont !== false) {
    resetFontStyle = {
      fontFamily: token.fontFamily,
      fontSize: token.fontSize
    };
  }
  return {
    [rootPrefixSelector]: Object.assign(Object.assign(Object.assign({}, resetFontStyle), resetStyle), {
      [prefixSelector]: resetStyle
    })
  };
};
const genFocusOutline = (token, offset) => ({
  outline: `${(0,cssinjs_es/* unit */.bf)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`,
  outlineOffset: offset !== null && offset !== void 0 ? offset : 1,
  transition: 'outline-offset 0s, outline 0s'
});
const genFocusStyle = (token, offset) => ({
  '&:focus-visible': genFocusOutline(token, offset)
});
const genIconStyle = iconPrefixCls => ({
  [`.${iconPrefixCls}`]: Object.assign(Object.assign({}, resetIcon()), {
    [`.${iconPrefixCls} .${iconPrefixCls}-icon`]: {
      display: 'block'
    }
  })
});
const operationUnit = token => Object.assign(Object.assign({
  // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
  // And Typography use this to generate link style which should not do this.
  color: token.colorLink,
  textDecoration: token.linkDecoration,
  outline: 'none',
  cursor: 'pointer',
  transition: `all ${token.motionDurationSlow}`,
  border: 0,
  padding: 0,
  background: 'none',
  userSelect: 'none'
}, genFocusStyle(token)), {
  '&:focus, &:hover': {
    color: token.colorLinkHover
  },
  '&:active': {
    color: token.colorLinkActive
  }
});
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/version/version.js
/* harmony default export */ var version = ('5.27.1');
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/version/index.js
"use client";

// @ts-ignore

/* harmony default export */ var es_version = (version);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/themes/seed.js
const defaultPresetColors = {
  blue: '#1677FF',
  purple: '#722ED1',
  cyan: '#13C2C2',
  green: '#52C41A',
  magenta: '#EB2F96',
  /**
   * @deprecated Use magenta instead
   */
  pink: '#EB2F96',
  red: '#F5222D',
  orange: '#FA8C16',
  yellow: '#FADB14',
  volcano: '#FA541C',
  geekblue: '#2F54EB',
  gold: '#FAAD14',
  lime: '#A0D911'
};
const seedToken = Object.assign(Object.assign({}, defaultPresetColors), {
  // Color
  colorPrimary: '#1677ff',
  colorSuccess: '#52c41a',
  colorWarning: '#faad14',
  colorError: '#ff4d4f',
  colorInfo: '#1677ff',
  colorLink: '',
  colorTextBase: '',
  colorBgBase: '',
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: `'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace`,
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: 'solid',
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: 'cubic-bezier(0.08, 0.82, 0.17, 1)',
  motionEaseInOutCirc: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
  motionEaseOut: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
  motionEaseInOut: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
  motionEaseOutBack: 'cubic-bezier(0.12, 0.4, 0.29, 1.46)',
  motionEaseInBack: 'cubic-bezier(0.71, -0.46, 0.88, 0.6)',
  motionEaseInQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
  motionEaseOutQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1000,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: false,
  // Motion
  motion: true
});
/* harmony default export */ var seed = (seedToken);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/context.js



// ================================ Context =================================
// To ensure snapshot stable. We disable hashed in test env.
const defaultConfig = {
  token: seed,
  override: {
    override: seed
  },
  hashed: true
};
const DesignTokenContext = /*#__PURE__*/react.createContext(defaultConfig);
// EXTERNAL MODULE: ./node_modules/@ant-design/colors/es/index.js + 2 modules
var colors_es = __webpack_require__(61835);
// EXTERNAL MODULE: ./node_modules/@ant-design/fast-color/es/index.js + 1 modules
var fast_color_es = __webpack_require__(99620);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/themes/shared/genColorMapToken.js

function genColorMapToken(seed, {
  generateColorPalettes,
  generateNeutralColorPalettes
}) {
  const {
    colorSuccess: colorSuccessBase,
    colorWarning: colorWarningBase,
    colorError: colorErrorBase,
    colorInfo: colorInfoBase,
    colorPrimary: colorPrimaryBase,
    colorBgBase,
    colorTextBase
  } = seed;
  const primaryColors = generateColorPalettes(colorPrimaryBase);
  const successColors = generateColorPalettes(colorSuccessBase);
  const warningColors = generateColorPalettes(colorWarningBase);
  const errorColors = generateColorPalettes(colorErrorBase);
  const infoColors = generateColorPalettes(colorInfoBase);
  const neutralColors = generateNeutralColorPalettes(colorBgBase, colorTextBase);
  // Color Link
  const colorLink = seed.colorLink || seed.colorInfo;
  const linkColors = generateColorPalettes(colorLink);
  const colorErrorBgFilledHover = new fast_color_es/* FastColor */.t(errorColors[1]).mix(new fast_color_es/* FastColor */.t(errorColors[3]), 50).toHexString();
  return Object.assign(Object.assign({}, neutralColors), {
    colorPrimaryBg: primaryColors[1],
    colorPrimaryBgHover: primaryColors[2],
    colorPrimaryBorder: primaryColors[3],
    colorPrimaryBorderHover: primaryColors[4],
    colorPrimaryHover: primaryColors[5],
    colorPrimary: primaryColors[6],
    colorPrimaryActive: primaryColors[7],
    colorPrimaryTextHover: primaryColors[8],
    colorPrimaryText: primaryColors[9],
    colorPrimaryTextActive: primaryColors[10],
    colorSuccessBg: successColors[1],
    colorSuccessBgHover: successColors[2],
    colorSuccessBorder: successColors[3],
    colorSuccessBorderHover: successColors[4],
    colorSuccessHover: successColors[4],
    colorSuccess: successColors[6],
    colorSuccessActive: successColors[7],
    colorSuccessTextHover: successColors[8],
    colorSuccessText: successColors[9],
    colorSuccessTextActive: successColors[10],
    colorErrorBg: errorColors[1],
    colorErrorBgHover: errorColors[2],
    colorErrorBgFilledHover,
    colorErrorBgActive: errorColors[3],
    colorErrorBorder: errorColors[3],
    colorErrorBorderHover: errorColors[4],
    colorErrorHover: errorColors[5],
    colorError: errorColors[6],
    colorErrorActive: errorColors[7],
    colorErrorTextHover: errorColors[8],
    colorErrorText: errorColors[9],
    colorErrorTextActive: errorColors[10],
    colorWarningBg: warningColors[1],
    colorWarningBgHover: warningColors[2],
    colorWarningBorder: warningColors[3],
    colorWarningBorderHover: warningColors[4],
    colorWarningHover: warningColors[4],
    colorWarning: warningColors[6],
    colorWarningActive: warningColors[7],
    colorWarningTextHover: warningColors[8],
    colorWarningText: warningColors[9],
    colorWarningTextActive: warningColors[10],
    colorInfoBg: infoColors[1],
    colorInfoBgHover: infoColors[2],
    colorInfoBorder: infoColors[3],
    colorInfoBorderHover: infoColors[4],
    colorInfoHover: infoColors[4],
    colorInfo: infoColors[6],
    colorInfoActive: infoColors[7],
    colorInfoTextHover: infoColors[8],
    colorInfoText: infoColors[9],
    colorInfoTextActive: infoColors[10],
    colorLinkHover: linkColors[4],
    colorLink: linkColors[6],
    colorLinkActive: linkColors[7],
    colorBgMask: new fast_color_es/* FastColor */.t('#000').setA(0.45).toRgbString(),
    colorWhite: '#fff'
  });
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/themes/shared/genRadius.js
const genRadius = radiusBase => {
  let radiusLG = radiusBase;
  let radiusSM = radiusBase;
  let radiusXS = radiusBase;
  let radiusOuter = radiusBase;
  // radiusLG
  if (radiusBase < 6 && radiusBase >= 5) {
    radiusLG = radiusBase + 1;
  } else if (radiusBase < 16 && radiusBase >= 6) {
    radiusLG = radiusBase + 2;
  } else if (radiusBase >= 16) {
    radiusLG = 16;
  }
  // radiusSM
  if (radiusBase < 7 && radiusBase >= 5) {
    radiusSM = 4;
  } else if (radiusBase < 8 && radiusBase >= 7) {
    radiusSM = 5;
  } else if (radiusBase < 14 && radiusBase >= 8) {
    radiusSM = 6;
  } else if (radiusBase < 16 && radiusBase >= 14) {
    radiusSM = 7;
  } else if (radiusBase >= 16) {
    radiusSM = 8;
  }
  // radiusXS
  if (radiusBase < 6 && radiusBase >= 2) {
    radiusXS = 1;
  } else if (radiusBase >= 6) {
    radiusXS = 2;
  }
  // radiusOuter
  if (radiusBase > 4 && radiusBase < 8) {
    radiusOuter = 4;
  } else if (radiusBase >= 8) {
    radiusOuter = 6;
  }
  return {
    borderRadius: radiusBase,
    borderRadiusXS: radiusXS,
    borderRadiusSM: radiusSM,
    borderRadiusLG: radiusLG,
    borderRadiusOuter: radiusOuter
  };
};
/* harmony default export */ var shared_genRadius = (genRadius);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/themes/shared/genCommonMapToken.js

function genCommonMapToken(token) {
  const {
    motionUnit,
    motionBase,
    borderRadius,
    lineWidth
  } = token;
  return Object.assign({
    // motion
    motionDurationFast: `${(motionBase + motionUnit).toFixed(1)}s`,
    motionDurationMid: `${(motionBase + motionUnit * 2).toFixed(1)}s`,
    motionDurationSlow: `${(motionBase + motionUnit * 3).toFixed(1)}s`,
    // line
    lineWidthBold: lineWidth + 1
  }, shared_genRadius(borderRadius));
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/themes/shared/genControlHeight.js
const genControlHeight = token => {
  const {
    controlHeight
  } = token;
  return {
    controlHeightSM: controlHeight * 0.75,
    controlHeightXS: controlHeight * 0.5,
    controlHeightLG: controlHeight * 1.25
  };
};
/* harmony default export */ var shared_genControlHeight = (genControlHeight);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/themes/shared/genFontSizes.js
function getLineHeight(fontSize) {
  return (fontSize + 8) / fontSize;
}
// https://zhuanlan.zhihu.com/p/32746810
function getFontSizes(base) {
  const fontSizes = Array.from({
    length: 10
  }).map((_, index) => {
    const i = index - 1;
    const baseSize = base * Math.pow(Math.E, i / 5);
    const intSize = index > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
    // Convert to even
    return Math.floor(intSize / 2) * 2;
  });
  fontSizes[1] = base;
  return fontSizes.map(size => ({
    size,
    lineHeight: getLineHeight(size)
  }));
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/themes/shared/genFontMapToken.js

const genFontMapToken = fontSize => {
  const fontSizePairs = getFontSizes(fontSize);
  const fontSizes = fontSizePairs.map(pair => pair.size);
  const lineHeights = fontSizePairs.map(pair => pair.lineHeight);
  const fontSizeMD = fontSizes[1];
  const fontSizeSM = fontSizes[0];
  const fontSizeLG = fontSizes[2];
  const lineHeight = lineHeights[1];
  const lineHeightSM = lineHeights[0];
  const lineHeightLG = lineHeights[2];
  return {
    fontSizeSM,
    fontSize: fontSizeMD,
    fontSizeLG,
    fontSizeXL: fontSizes[3],
    fontSizeHeading1: fontSizes[6],
    fontSizeHeading2: fontSizes[5],
    fontSizeHeading3: fontSizes[4],
    fontSizeHeading4: fontSizes[3],
    fontSizeHeading5: fontSizes[2],
    lineHeight,
    lineHeightLG,
    lineHeightSM,
    fontHeight: Math.round(lineHeight * fontSizeMD),
    fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
    fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
    lineHeightHeading1: lineHeights[6],
    lineHeightHeading2: lineHeights[5],
    lineHeightHeading3: lineHeights[4],
    lineHeightHeading4: lineHeights[3],
    lineHeightHeading5: lineHeights[2]
  };
};
/* harmony default export */ var shared_genFontMapToken = (genFontMapToken);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/themes/shared/genSizeMapToken.js
function genSizeMapToken(token) {
  const {
    sizeUnit,
    sizeStep
  } = token;
  return {
    sizeXXL: sizeUnit * (sizeStep + 8),
    // 48
    sizeXL: sizeUnit * (sizeStep + 4),
    // 32
    sizeLG: sizeUnit * (sizeStep + 2),
    // 24
    sizeMD: sizeUnit * (sizeStep + 1),
    // 20
    sizeMS: sizeUnit * sizeStep,
    // 16
    size: sizeUnit * sizeStep,
    // 16
    sizeSM: sizeUnit * (sizeStep - 1),
    // 12
    sizeXS: sizeUnit * (sizeStep - 2),
    // 8
    sizeXXS: sizeUnit * (sizeStep - 3) // 4
  };
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/themes/default/colorAlgorithm.js

const getAlphaColor = (baseColor, alpha) => new fast_color_es/* FastColor */.t(baseColor).setA(alpha).toRgbString();
const getSolidColor = (baseColor, brightness) => {
  const instance = new fast_color_es/* FastColor */.t(baseColor);
  return instance.darken(brightness).toHexString();
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/themes/default/colors.js


const generateColorPalettes = baseColor => {
  const colors = (0,colors_es/* generate */.R_)(baseColor);
  return {
    1: colors[0],
    2: colors[1],
    3: colors[2],
    4: colors[3],
    5: colors[4],
    6: colors[5],
    7: colors[6],
    8: colors[4],
    9: colors[5],
    10: colors[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
};
const generateNeutralColorPalettes = (bgBaseColor, textBaseColor) => {
  const colorBgBase = bgBaseColor || '#fff';
  const colorTextBase = textBaseColor || '#000';
  return {
    colorBgBase,
    colorTextBase,
    colorText: getAlphaColor(colorTextBase, 0.88),
    colorTextSecondary: getAlphaColor(colorTextBase, 0.65),
    colorTextTertiary: getAlphaColor(colorTextBase, 0.45),
    colorTextQuaternary: getAlphaColor(colorTextBase, 0.25),
    colorFill: getAlphaColor(colorTextBase, 0.15),
    colorFillSecondary: getAlphaColor(colorTextBase, 0.06),
    colorFillTertiary: getAlphaColor(colorTextBase, 0.04),
    colorFillQuaternary: getAlphaColor(colorTextBase, 0.02),
    colorBgSolid: getAlphaColor(colorTextBase, 1),
    colorBgSolidHover: getAlphaColor(colorTextBase, 0.75),
    colorBgSolidActive: getAlphaColor(colorTextBase, 0.95),
    colorBgLayout: getSolidColor(colorBgBase, 4),
    colorBgContainer: getSolidColor(colorBgBase, 0),
    colorBgElevated: getSolidColor(colorBgBase, 0),
    colorBgSpotlight: getAlphaColor(colorTextBase, 0.85),
    colorBgBlur: 'transparent',
    colorBorder: getSolidColor(colorBgBase, 15),
    colorBorderSecondary: getSolidColor(colorBgBase, 6)
  };
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/themes/default/index.js








function derivative(token) {
  // pink is deprecated name of magenta, keep this for backwards compatibility
  colors_es/* presetPrimaryColors.pink */.ez.pink = colors_es/* presetPrimaryColors.magenta */.ez.magenta;
  colors_es/* presetPalettes.pink */.Ti.pink = colors_es/* presetPalettes.magenta */.Ti.magenta;
  const colorPalettes = Object.keys(defaultPresetColors).map(colorKey => {
    const colors = token[colorKey] === colors_es/* presetPrimaryColors */.ez[colorKey] ? colors_es/* presetPalettes */.Ti[colorKey] : (0,colors_es/* generate */.R_)(token[colorKey]);
    return Array.from({
      length: 10
    }, () => 1).reduce((prev, _, i) => {
      prev[`${colorKey}-${i + 1}`] = colors[i];
      prev[`${colorKey}${i + 1}`] = colors[i];
      return prev;
    }, {});
  }).reduce((prev, cur) => {
    prev = Object.assign(Object.assign({}, prev), cur);
    return prev;
  }, {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, token), colorPalettes), genColorMapToken(token, {
    generateColorPalettes: generateColorPalettes,
    generateNeutralColorPalettes: generateNeutralColorPalettes
  })), shared_genFontMapToken(token.fontSize)), genSizeMapToken(token)), shared_genControlHeight(token)), genCommonMapToken(token));
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/themes/default/theme.js


const defaultTheme = (0,cssinjs_es/* createTheme */.jG)(derivative);
/* harmony default export */ var default_theme = (defaultTheme);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/util/getAlphaColor.js

function isStableColor(color) {
  return color >= 0 && color <= 255;
}
function getAlphaColor_getAlphaColor(frontColor, backgroundColor) {
  const {
    r: fR,
    g: fG,
    b: fB,
    a: originAlpha
  } = new fast_color_es/* FastColor */.t(frontColor).toRgb();
  if (originAlpha < 1) {
    return frontColor;
  }
  const {
    r: bR,
    g: bG,
    b: bB
  } = new fast_color_es/* FastColor */.t(backgroundColor).toRgb();
  for (let fA = 0.01; fA <= 1; fA += 0.01) {
    const r = Math.round((fR - bR * (1 - fA)) / fA);
    const g = Math.round((fG - bG * (1 - fA)) / fA);
    const b = Math.round((fB - bB * (1 - fA)) / fA);
    if (isStableColor(r) && isStableColor(g) && isStableColor(b)) {
      return new fast_color_es/* FastColor */.t({
        r,
        g,
        b,
        a: Math.round(fA * 100) / 100
      }).toRgbString();
    }
  }
  // fallback
  /* istanbul ignore next */
  return new fast_color_es/* FastColor */.t({
    r: fR,
    g: fG,
    b: fB,
    a: 1
  }).toRgbString();
}
/* harmony default export */ var util_getAlphaColor = (getAlphaColor_getAlphaColor);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/util/alias.js
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};



/**
 * Seed (designer) > Derivative (designer) > Alias (developer).
 *
 * Merge seed & derivative & override token and generate alias token for developer.
 */
function formatToken(derivativeToken) {
  const {
      override
    } = derivativeToken,
    restToken = __rest(derivativeToken, ["override"]);
  const overrideTokens = Object.assign({}, override);
  Object.keys(seed).forEach(token => {
    delete overrideTokens[token];
  });
  const mergedToken = Object.assign(Object.assign({}, restToken), overrideTokens);
  const screenXS = 480;
  const screenSM = 576;
  const screenMD = 768;
  const screenLG = 992;
  const screenXL = 1200;
  const screenXXL = 1600;
  // Motion
  if (mergedToken.motion === false) {
    const fastDuration = '0s';
    mergedToken.motionDurationFast = fastDuration;
    mergedToken.motionDurationMid = fastDuration;
    mergedToken.motionDurationSlow = fastDuration;
  }
  // Generate alias token
  const aliasToken = Object.assign(Object.assign(Object.assign({}, mergedToken), {
    // ============== Background ============== //
    colorFillContent: mergedToken.colorFillSecondary,
    colorFillContentHover: mergedToken.colorFill,
    colorFillAlter: mergedToken.colorFillQuaternary,
    colorBgContainerDisabled: mergedToken.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: mergedToken.colorBgContainer,
    colorSplit: util_getAlphaColor(mergedToken.colorBorderSecondary, mergedToken.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: mergedToken.colorTextQuaternary,
    colorTextDisabled: mergedToken.colorTextQuaternary,
    colorTextHeading: mergedToken.colorText,
    colorTextLabel: mergedToken.colorTextSecondary,
    colorTextDescription: mergedToken.colorTextTertiary,
    colorTextLightSolid: mergedToken.colorWhite,
    colorHighlight: mergedToken.colorError,
    colorBgTextHover: mergedToken.colorFillSecondary,
    colorBgTextActive: mergedToken.colorFill,
    colorIcon: mergedToken.colorTextTertiary,
    colorIconHover: mergedToken.colorText,
    colorErrorOutline: util_getAlphaColor(mergedToken.colorErrorBg, mergedToken.colorBgContainer),
    colorWarningOutline: util_getAlphaColor(mergedToken.colorWarningBg, mergedToken.colorBgContainer),
    // Font
    fontSizeIcon: mergedToken.fontSizeSM,
    // Line
    lineWidthFocus: mergedToken.lineWidth * 3,
    // Control
    lineWidth: mergedToken.lineWidth,
    controlOutlineWidth: mergedToken.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: mergedToken.controlHeight / 2,
    controlItemBgHover: mergedToken.colorFillTertiary,
    controlItemBgActive: mergedToken.colorPrimaryBg,
    controlItemBgActiveHover: mergedToken.colorPrimaryBgHover,
    controlItemBgActiveDisabled: mergedToken.colorFill,
    controlTmpOutline: mergedToken.colorFillQuaternary,
    controlOutline: util_getAlphaColor(mergedToken.colorPrimaryBg, mergedToken.colorBgContainer),
    lineType: mergedToken.lineType,
    borderRadius: mergedToken.borderRadius,
    borderRadiusXS: mergedToken.borderRadiusXS,
    borderRadiusSM: mergedToken.borderRadiusSM,
    borderRadiusLG: mergedToken.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: 'none',
    linkHoverDecoration: 'none',
    linkFocusDecoration: 'none',
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: mergedToken.sizeXXS,
    paddingXS: mergedToken.sizeXS,
    paddingSM: mergedToken.sizeSM,
    padding: mergedToken.size,
    paddingMD: mergedToken.sizeMD,
    paddingLG: mergedToken.sizeLG,
    paddingXL: mergedToken.sizeXL,
    paddingContentHorizontalLG: mergedToken.sizeLG,
    paddingContentVerticalLG: mergedToken.sizeMS,
    paddingContentHorizontal: mergedToken.sizeMS,
    paddingContentVertical: mergedToken.sizeSM,
    paddingContentHorizontalSM: mergedToken.size,
    paddingContentVerticalSM: mergedToken.sizeXS,
    marginXXS: mergedToken.sizeXXS,
    marginXS: mergedToken.sizeXS,
    marginSM: mergedToken.sizeSM,
    margin: mergedToken.size,
    marginMD: mergedToken.sizeMD,
    marginLG: mergedToken.sizeLG,
    marginXL: mergedToken.sizeXL,
    marginXXL: mergedToken.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS,
    screenXSMin: screenXS,
    screenXSMax: screenSM - 1,
    screenSM,
    screenSMMin: screenSM,
    screenSMMax: screenMD - 1,
    screenMD,
    screenMDMin: screenMD,
    screenMDMax: screenLG - 1,
    screenLG,
    screenLGMin: screenLG,
    screenLGMax: screenXL - 1,
    screenXL,
    screenXLMin: screenXL,
    screenXLMax: screenXXL - 1,
    screenXXL,
    screenXXLMin: screenXXL,
    boxShadowPopoverArrow: '2px 2px 5px rgba(0, 0, 0, 0.05)',
    boxShadowCard: `
      0 1px 2px -2px ${new fast_color_es/* FastColor */.t('rgba(0, 0, 0, 0.16)').toRgbString()},
      0 3px 6px 0 ${new fast_color_es/* FastColor */.t('rgba(0, 0, 0, 0.12)').toRgbString()},
      0 5px 12px 4px ${new fast_color_es/* FastColor */.t('rgba(0, 0, 0, 0.09)').toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: 'inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)',
    boxShadowTabsOverflowRight: 'inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)',
    boxShadowTabsOverflowTop: 'inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)',
    boxShadowTabsOverflowBottom: 'inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)'
  }), overrideTokens);
  return aliasToken;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/useToken.js
var useToken_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






const unitless = {
  lineHeight: true,
  lineHeightSM: true,
  lineHeightLG: true,
  lineHeightHeading1: true,
  lineHeightHeading2: true,
  lineHeightHeading3: true,
  lineHeightHeading4: true,
  lineHeightHeading5: true,
  opacityLoading: true,
  fontWeightStrong: true,
  zIndexPopupBase: true,
  zIndexBase: true,
  opacityImage: true
};
const ignore = {
  motionBase: true,
  motionUnit: true
};
const preserve = {
  screenXS: true,
  screenXSMin: true,
  screenXSMax: true,
  screenSM: true,
  screenSMMin: true,
  screenSMMax: true,
  screenMD: true,
  screenMDMin: true,
  screenMDMax: true,
  screenLG: true,
  screenLGMin: true,
  screenLGMax: true,
  screenXL: true,
  screenXLMin: true,
  screenXLMax: true,
  screenXXL: true,
  screenXXLMin: true
};
const getComputedToken = (originToken, overrideToken, theme) => {
  const derivativeToken = theme.getDerivativeToken(originToken);
  const {
      override
    } = overrideToken,
    components = useToken_rest(overrideToken, ["override"]);
  // Merge with override
  let mergedDerivativeToken = Object.assign(Object.assign({}, derivativeToken), {
    override
  });
  // Format if needed
  mergedDerivativeToken = formatToken(mergedDerivativeToken);
  if (components) {
    Object.entries(components).forEach(([key, value]) => {
      const {
          theme: componentTheme
        } = value,
        componentTokens = useToken_rest(value, ["theme"]);
      let mergedComponentToken = componentTokens;
      if (componentTheme) {
        mergedComponentToken = getComputedToken(Object.assign(Object.assign({}, mergedDerivativeToken), componentTokens), {
          override: componentTokens
        }, componentTheme);
      }
      mergedDerivativeToken[key] = mergedComponentToken;
    });
  }
  return mergedDerivativeToken;
};
// ================================== Hook ==================================
function useToken() {
  const {
    token: rootDesignToken,
    hashed,
    theme,
    override,
    cssVar
  } = react.useContext(DesignTokenContext);
  const salt = `${es_version}-${hashed || ''}`;
  const mergedTheme = theme || default_theme;
  const [token, hashId, realToken] = (0,cssinjs_es/* useCacheToken */.fp)(mergedTheme, [seed, rootDesignToken], {
    salt,
    override,
    getComputedToken,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken: formatToken,
    cssVar: cssVar && {
      prefix: cssVar.prefix,
      key: cssVar.key,
      unitless,
      ignore,
      preserve
    }
  });
  return [mergedTheme, realToken, hashed ? hashId : '', token, cssVar];
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/util/genStyleUtils.js





const {
  genStyleHooks,
  genComponentStyleHook,
  genSubStyleComponent
} = (0,cssinjs_utils_es/* genStyleUtils */.rb)({
  usePrefix: () => {
    const {
      getPrefixCls,
      iconPrefixCls
    } = (0,react.useContext)(ConfigContext);
    const rootPrefixCls = getPrefixCls();
    return {
      rootPrefixCls,
      iconPrefixCls
    };
  },
  useToken: () => {
    const [theme, realToken, hashId, token, cssVar] = useToken();
    return {
      theme,
      realToken,
      hashId,
      token,
      cssVar
    };
  },
  useCSP: () => {
    const {
      csp
    } = (0,react.useContext)(ConfigContext);
    return csp !== null && csp !== void 0 ? csp : {};
  },
  getResetStyles: (token, config) => {
    var _a;
    const linkStyle = genLinkStyle(token);
    return [linkStyle, {
      '&': linkStyle
    }, genIconStyle((_a = config === null || config === void 0 ? void 0 : config.prefix.iconPrefixCls) !== null && _a !== void 0 ? _a : defaultIconPrefixCls)];
  },
  getCommonStyle: genCommonStyle,
  getCompUnitless: () => unitless
});
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/affix/style/index.js

// ============================== Shared ==============================
const genSharedAffixStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [componentCls]: {
      position: 'fixed',
      zIndex: token.zIndexPopup
    }
  };
};
const prepareComponentToken = token => ({
  zIndexPopup: token.zIndexBase + 10
});
// ============================== Export ==============================
/* harmony default export */ var affix_style = (genStyleHooks('Affix', genSharedAffixStyle, prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/affix/utils.js
function getTargetRect(target) {
  return target !== window ? target.getBoundingClientRect() : {
    top: 0,
    bottom: window.innerHeight
  };
}
function getFixedTop(placeholderRect, targetRect, offsetTop) {
  if (offsetTop !== undefined && Math.round(targetRect.top) > Math.round(placeholderRect.top) - offsetTop) {
    return offsetTop + targetRect.top;
  }
  return undefined;
}
function getFixedBottom(placeholderRect, targetRect, offsetBottom) {
  if (offsetBottom !== undefined && Math.round(targetRect.bottom) < Math.round(placeholderRect.bottom) + offsetBottom) {
    const targetBottomOffset = window.innerHeight - targetRect.bottom;
    return offsetBottom + targetBottomOffset;
  }
  return undefined;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/affix/index.js
"use client";

var affix_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







const TRIGGER_EVENTS = ['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'];
function getDefaultTarget() {
  return typeof window !== 'undefined' ? window : null;
}
const AFFIX_STATUS_NONE = 0;
const AFFIX_STATUS_PREPARE = 1;
const Affix = /*#__PURE__*/react.forwardRef((props, ref) => {
  var _a;
  const {
      style,
      offsetTop,
      offsetBottom,
      prefixCls,
      className,
      rootClassName,
      children,
      target,
      onChange,
      onTestUpdatePosition
    } = props,
    restProps = affix_rest(props, ["style", "offsetTop", "offsetBottom", "prefixCls", "className", "rootClassName", "children", "target", "onChange", "onTestUpdatePosition"]);
  const {
    getPrefixCls,
    getTargetContainer
  } = react.useContext(ConfigContext);
  const affixPrefixCls = getPrefixCls('affix', prefixCls);
  const [lastAffix, setLastAffix] = react.useState(false);
  const [affixStyle, setAffixStyle] = react.useState();
  const [placeholderStyle, setPlaceholderStyle] = react.useState();
  const status = react.useRef(AFFIX_STATUS_NONE);
  const prevTarget = react.useRef(null);
  const prevListener = react.useRef(null);
  const placeholderNodeRef = react.useRef(null);
  const fixedNodeRef = react.useRef(null);
  const timer = react.useRef(null);
  const targetFunc = (_a = target !== null && target !== void 0 ? target : getTargetContainer) !== null && _a !== void 0 ? _a : getDefaultTarget;
  const internalOffsetTop = offsetBottom === undefined && offsetTop === undefined ? 0 : offsetTop;
  // =================== Measure ===================
  const measure = () => {
    if (status.current !== AFFIX_STATUS_PREPARE || !fixedNodeRef.current || !placeholderNodeRef.current || !targetFunc) {
      return;
    }
    const targetNode = targetFunc();
    if (targetNode) {
      const newState = {
        status: AFFIX_STATUS_NONE
      };
      const placeholderRect = getTargetRect(placeholderNodeRef.current);
      if (placeholderRect.top === 0 && placeholderRect.left === 0 && placeholderRect.width === 0 && placeholderRect.height === 0) {
        return;
      }
      const targetRect = getTargetRect(targetNode);
      const fixedTop = getFixedTop(placeholderRect, targetRect, internalOffsetTop);
      const fixedBottom = getFixedBottom(placeholderRect, targetRect, offsetBottom);
      if (fixedTop !== undefined) {
        newState.affixStyle = {
          position: 'fixed',
          top: fixedTop,
          width: placeholderRect.width,
          height: placeholderRect.height
        };
        newState.placeholderStyle = {
          width: placeholderRect.width,
          height: placeholderRect.height
        };
      } else if (fixedBottom !== undefined) {
        newState.affixStyle = {
          position: 'fixed',
          bottom: fixedBottom,
          width: placeholderRect.width,
          height: placeholderRect.height
        };
        newState.placeholderStyle = {
          width: placeholderRect.width,
          height: placeholderRect.height
        };
      }
      newState.lastAffix = !!newState.affixStyle;
      if (lastAffix !== newState.lastAffix) {
        onChange === null || onChange === void 0 ? void 0 : onChange(newState.lastAffix);
      }
      status.current = newState.status;
      setAffixStyle(newState.affixStyle);
      setPlaceholderStyle(newState.placeholderStyle);
      setLastAffix(newState.lastAffix);
    }
  };
  const prepareMeasure = () => {
    status.current = AFFIX_STATUS_PREPARE;
    measure();
    if (false) {}
  };
  const updatePosition = _util_throttleByAnimationFrame(() => {
    prepareMeasure();
  });
  const lazyUpdatePosition = _util_throttleByAnimationFrame(() => {
    // Check position change before measure to make Safari smooth
    if (targetFunc && affixStyle) {
      const targetNode = targetFunc();
      if (targetNode && placeholderNodeRef.current) {
        const targetRect = getTargetRect(targetNode);
        const placeholderRect = getTargetRect(placeholderNodeRef.current);
        const fixedTop = getFixedTop(placeholderRect, targetRect, internalOffsetTop);
        const fixedBottom = getFixedBottom(placeholderRect, targetRect, offsetBottom);
        if (fixedTop !== undefined && affixStyle.top === fixedTop || fixedBottom !== undefined && affixStyle.bottom === fixedBottom) {
          return;
        }
      }
    }
    // Directly call prepare measure since it's already throttled.
    prepareMeasure();
  });
  const addListeners = () => {
    const listenerTarget = targetFunc === null || targetFunc === void 0 ? void 0 : targetFunc();
    if (!listenerTarget) {
      return;
    }
    TRIGGER_EVENTS.forEach(eventName => {
      var _a;
      if (prevListener.current) {
        (_a = prevTarget.current) === null || _a === void 0 ? void 0 : _a.removeEventListener(eventName, prevListener.current);
      }
      listenerTarget === null || listenerTarget === void 0 ? void 0 : listenerTarget.addEventListener(eventName, lazyUpdatePosition);
    });
    prevTarget.current = listenerTarget;
    prevListener.current = lazyUpdatePosition;
  };
  const removeListeners = () => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
    const newTarget = targetFunc === null || targetFunc === void 0 ? void 0 : targetFunc();
    TRIGGER_EVENTS.forEach(eventName => {
      var _a;
      newTarget === null || newTarget === void 0 ? void 0 : newTarget.removeEventListener(eventName, lazyUpdatePosition);
      if (prevListener.current) {
        (_a = prevTarget.current) === null || _a === void 0 ? void 0 : _a.removeEventListener(eventName, prevListener.current);
      }
    });
    updatePosition.cancel();
    lazyUpdatePosition.cancel();
  };
  react.useImperativeHandle(ref, () => ({
    updatePosition
  }));
  // mount & unmount
  react.useEffect(() => {
    // [Legacy] Wait for parent component ref has its value.
    // We should use target as directly element instead of function which makes element check hard.
    timer.current = setTimeout(addListeners);
    return () => removeListeners();
  }, []);
  react.useEffect(() => {
    addListeners();
    return () => removeListeners();
  }, [target, affixStyle, lastAffix, offsetTop, offsetBottom]);
  react.useEffect(() => {
    updatePosition();
  }, [target, offsetTop, offsetBottom]);
  const [wrapCSSVar, hashId, cssVarCls] = affix_style(affixPrefixCls);
  const rootCls = classnames_default()(rootClassName, hashId, affixPrefixCls, cssVarCls);
  const mergedCls = classnames_default()({
    [rootCls]: affixStyle
  });
  return wrapCSSVar(/*#__PURE__*/react.createElement(es/* default */.Z, {
    onResize: updatePosition
  }, /*#__PURE__*/react.createElement("div", Object.assign({
    style: style,
    className: className,
    ref: placeholderNodeRef
  }, restProps), affixStyle && /*#__PURE__*/react.createElement("div", {
    style: placeholderStyle,
    "aria-hidden": "true"
  }), /*#__PURE__*/react.createElement("div", {
    className: mergedCls,
    ref: fixedNodeRef,
    style: affixStyle
  }, /*#__PURE__*/react.createElement(es/* default */.Z, {
    onResize: updatePosition
  }, children)))));
});
if (false) {}
/* harmony default export */ var es_affix = (Affix);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CheckCircleFilled.js + 1 modules
var CheckCircleFilled = __webpack_require__(14007);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CloseCircleFilled.js + 1 modules
var CloseCircleFilled = __webpack_require__(16088);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CloseOutlined.js + 1 modules
var CloseOutlined = __webpack_require__(27289);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/ExclamationCircleFilled.js + 1 modules
var ExclamationCircleFilled = __webpack_require__(37588);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/InfoCircleFilled.js + 1 modules
var InfoCircleFilled = __webpack_require__(42178);
// EXTERNAL MODULE: ./node_modules/rc-motion/es/index.js + 13 modules
var rc_motion_es = __webpack_require__(26981);
// EXTERNAL MODULE: ./node_modules/rc-util/es/pickAttrs.js
var pickAttrs = __webpack_require__(75844);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(99195);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/reactNode.js

function isFragment(child) {
  return child && /*#__PURE__*/react.isValidElement(child) && child.type === react.Fragment;
}
const replaceElement = (element, replacement, props) => {
  if (! /*#__PURE__*/react.isValidElement(element)) {
    return replacement;
  }
  return /*#__PURE__*/react.cloneElement(element, typeof props === 'function' ? props(element.props || {}) : props);
};
function cloneElement(element, props) {
  return replaceElement(element, element, props);
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/alert/style/index.js



const genAlertTypeStyle = (bgColor, borderColor, iconColor, token, alertCls) => ({
  background: bgColor,
  border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${borderColor}`,
  [`${alertCls}-icon`]: {
    color: iconColor
  }
});
const genBaseStyle = token => {
  const {
    componentCls,
    motionDurationSlow: duration,
    marginXS,
    marginSM,
    fontSize,
    fontSizeLG,
    lineHeight,
    borderRadiusLG: borderRadius,
    motionEaseInOutCirc,
    withDescriptionIconSize,
    colorText,
    colorTextHeading,
    withDescriptionPadding,
    defaultPadding
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      padding: defaultPadding,
      wordWrap: 'break-word',
      borderRadius,
      [`&${componentCls}-rtl`]: {
        direction: 'rtl'
      },
      [`${componentCls}-content`]: {
        flex: 1,
        minWidth: 0
      },
      [`${componentCls}-icon`]: {
        marginInlineEnd: marginXS,
        lineHeight: 0
      },
      '&-description': {
        display: 'none',
        fontSize,
        lineHeight
      },
      '&-message': {
        color: colorTextHeading
      },
      [`&${componentCls}-motion-leave`]: {
        overflow: 'hidden',
        opacity: 1,
        transition: `max-height ${duration} ${motionEaseInOutCirc}, opacity ${duration} ${motionEaseInOutCirc},
        padding-top ${duration} ${motionEaseInOutCirc}, padding-bottom ${duration} ${motionEaseInOutCirc},
        margin-bottom ${duration} ${motionEaseInOutCirc}`
      },
      [`&${componentCls}-motion-leave-active`]: {
        maxHeight: 0,
        marginBottom: '0 !important',
        paddingTop: 0,
        paddingBottom: 0,
        opacity: 0
      }
    }),
    [`${componentCls}-with-description`]: {
      alignItems: 'flex-start',
      padding: withDescriptionPadding,
      [`${componentCls}-icon`]: {
        marginInlineEnd: marginSM,
        fontSize: withDescriptionIconSize,
        lineHeight: 0
      },
      [`${componentCls}-message`]: {
        display: 'block',
        marginBottom: marginXS,
        color: colorTextHeading,
        fontSize: fontSizeLG
      },
      [`${componentCls}-description`]: {
        display: 'block',
        color: colorText
      }
    },
    [`${componentCls}-banner`]: {
      marginBottom: 0,
      border: '0 !important',
      borderRadius: 0
    }
  };
};
const genTypeStyle = token => {
  const {
    componentCls,
    colorSuccess,
    colorSuccessBorder,
    colorSuccessBg,
    colorWarning,
    colorWarningBorder,
    colorWarningBg,
    colorError,
    colorErrorBorder,
    colorErrorBg,
    colorInfo,
    colorInfoBorder,
    colorInfoBg
  } = token;
  return {
    [componentCls]: {
      '&-success': genAlertTypeStyle(colorSuccessBg, colorSuccessBorder, colorSuccess, token, componentCls),
      '&-info': genAlertTypeStyle(colorInfoBg, colorInfoBorder, colorInfo, token, componentCls),
      '&-warning': genAlertTypeStyle(colorWarningBg, colorWarningBorder, colorWarning, token, componentCls),
      '&-error': Object.assign(Object.assign({}, genAlertTypeStyle(colorErrorBg, colorErrorBorder, colorError, token, componentCls)), {
        [`${componentCls}-description > pre`]: {
          margin: 0,
          padding: 0
        }
      })
    }
  };
};
const genActionStyle = token => {
  const {
    componentCls,
    iconCls,
    motionDurationMid,
    marginXS,
    fontSizeIcon,
    colorIcon,
    colorIconHover
  } = token;
  return {
    [componentCls]: {
      '&-action': {
        marginInlineStart: marginXS
      },
      [`${componentCls}-close-icon`]: {
        marginInlineStart: marginXS,
        padding: 0,
        overflow: 'hidden',
        fontSize: fontSizeIcon,
        lineHeight: (0,cssinjs_es/* unit */.bf)(fontSizeIcon),
        backgroundColor: 'transparent',
        border: 'none',
        outline: 'none',
        cursor: 'pointer',
        [`${iconCls}-close`]: {
          color: colorIcon,
          transition: `color ${motionDurationMid}`,
          '&:hover': {
            color: colorIconHover
          }
        }
      },
      '&-close-text': {
        color: colorIcon,
        transition: `color ${motionDurationMid}`,
        '&:hover': {
          color: colorIconHover
        }
      }
    }
  };
};
const style_prepareComponentToken = token => {
  const paddingHorizontal = 12; // Fixed value here.
  return {
    withDescriptionIconSize: token.fontSizeHeading3,
    defaultPadding: `${token.paddingContentVerticalSM}px ${paddingHorizontal}px`,
    withDescriptionPadding: `${token.paddingMD}px ${token.paddingContentHorizontalLG}px`
  };
};
/* harmony default export */ var alert_style = (genStyleHooks('Alert', token => [genBaseStyle(token), genTypeStyle(token), genActionStyle(token)], style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/alert/Alert.js
"use client";

var Alert_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};














const iconMapFilled = {
  success: CheckCircleFilled/* default */.Z,
  info: InfoCircleFilled/* default */.Z,
  error: CloseCircleFilled/* default */.Z,
  warning: ExclamationCircleFilled/* default */.Z
};
const IconNode = props => {
  const {
    icon,
    prefixCls,
    type
  } = props;
  const iconType = iconMapFilled[type] || null;
  if (icon) {
    return replaceElement(icon, /*#__PURE__*/react.createElement("span", {
      className: `${prefixCls}-icon`
    }, icon), () => ({
      className: classnames_default()(`${prefixCls}-icon`, icon.props.className)
    }));
  }
  return /*#__PURE__*/react.createElement(iconType, {
    className: `${prefixCls}-icon`
  });
};
const CloseIconNode = props => {
  const {
    isClosable,
    prefixCls,
    closeIcon,
    handleClose,
    ariaProps
  } = props;
  const mergedCloseIcon = closeIcon === true || closeIcon === undefined ? /*#__PURE__*/react.createElement(CloseOutlined/* default */.Z, null) : closeIcon;
  return isClosable ? (/*#__PURE__*/react.createElement("button", Object.assign({
    type: "button",
    onClick: handleClose,
    className: `${prefixCls}-close-icon`,
    tabIndex: 0
  }, ariaProps), mergedCloseIcon)) : null;
};
const Alert = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      description,
      prefixCls: customizePrefixCls,
      message,
      banner,
      className,
      rootClassName,
      style,
      onMouseEnter,
      onMouseLeave,
      onClick,
      afterClose,
      showIcon,
      closable,
      closeText,
      closeIcon,
      action,
      id
    } = props,
    otherProps = Alert_rest(props, ["description", "prefixCls", "message", "banner", "className", "rootClassName", "style", "onMouseEnter", "onMouseLeave", "onClick", "afterClose", "showIcon", "closable", "closeText", "closeIcon", "action", "id"]);
  const [closed, setClosed] = react.useState(false);
  if (false) {}
  const internalRef = react.useRef(null);
  react.useImperativeHandle(ref, () => ({
    nativeElement: internalRef.current
  }));
  const {
    getPrefixCls,
    direction,
    closable: contextClosable,
    closeIcon: contextCloseIcon,
    className: contextClassName,
    style: contextStyle
  } = useComponentConfig('alert');
  const prefixCls = getPrefixCls('alert', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = alert_style(prefixCls);
  const handleClose = e => {
    var _a;
    setClosed(true);
    (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props, e);
  };
  const type = react.useMemo(() => {
    if (props.type !== undefined) {
      return props.type;
    }
    // banner mode defaults to 'warning'
    return banner ? 'warning' : 'info';
  }, [props.type, banner]);
  // closeable when closeText or closeIcon is assigned
  const isClosable = react.useMemo(() => {
    if (typeof closable === 'object' && closable.closeIcon) return true;
    if (closeText) {
      return true;
    }
    if (typeof closable === 'boolean') {
      return closable;
    }
    // should be true when closeIcon is 0 or ''
    if (closeIcon !== false && closeIcon !== null && closeIcon !== undefined) {
      return true;
    }
    return !!contextClosable;
  }, [closeText, closeIcon, closable, contextClosable]);
  // banner mode defaults to Icon
  const isShowIcon = banner && showIcon === undefined ? true : showIcon;
  const alertCls = classnames_default()(prefixCls, `${prefixCls}-${type}`, {
    [`${prefixCls}-with-description`]: !!description,
    [`${prefixCls}-no-icon`]: !isShowIcon,
    [`${prefixCls}-banner`]: !!banner,
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, contextClassName, className, rootClassName, cssVarCls, hashId);
  const restProps = (0,pickAttrs/* default */.Z)(otherProps, {
    aria: true,
    data: true
  });
  const mergedCloseIcon = react.useMemo(() => {
    if (typeof closable === 'object' && closable.closeIcon) {
      return closable.closeIcon;
    }
    if (closeText) {
      return closeText;
    }
    if (closeIcon !== undefined) {
      return closeIcon;
    }
    if (typeof contextClosable === 'object' && contextClosable.closeIcon) {
      return contextClosable.closeIcon;
    }
    return contextCloseIcon;
  }, [closeIcon, closable, closeText, contextCloseIcon]);
  const mergedAriaProps = react.useMemo(() => {
    const merged = closable !== null && closable !== void 0 ? closable : contextClosable;
    if (typeof merged === 'object') {
      const {
          closeIcon: _
        } = merged,
        ariaProps = Alert_rest(merged, ["closeIcon"]);
      return ariaProps;
    }
    return {};
  }, [closable, contextClosable]);
  return wrapCSSVar(/*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, {
    visible: !closed,
    motionName: `${prefixCls}-motion`,
    motionAppear: false,
    motionEnter: false,
    onLeaveStart: node => ({
      maxHeight: node.offsetHeight
    }),
    onLeaveEnd: afterClose
  }, ({
    className: motionClassName,
    style: motionStyle
  }, setRef) => (/*#__PURE__*/react.createElement("div", Object.assign({
    id: id,
    ref: (0,es_ref/* composeRef */.sQ)(internalRef, setRef),
    "data-show": !closed,
    className: classnames_default()(alertCls, motionClassName),
    style: Object.assign(Object.assign(Object.assign({}, contextStyle), style), motionStyle),
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: onClick,
    role: "alert"
  }, restProps), isShowIcon ? (/*#__PURE__*/react.createElement(IconNode, {
    description: description,
    icon: props.icon,
    prefixCls: prefixCls,
    type: type
  })) : null, /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-content`
  }, message ? /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-message`
  }, message) : null, description ? /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-description`
  }, description) : null), action ? /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-action`
  }, action) : null, /*#__PURE__*/react.createElement(CloseIconNode, {
    isClosable: isClosable,
    prefixCls: prefixCls,
    closeIcon: mergedCloseIcon,
    handleClose: handleClose,
    ariaProps: mergedAriaProps
  })))));
});
if (false) {}
/* harmony default export */ var alert_Alert = (Alert);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6223);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(79427);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/callSuper.js
var callSuper = __webpack_require__(43889);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(34766);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/alert/ErrorBoundary.js
"use client";







let ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function ErrorBoundary() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, ErrorBoundary);
    _this = (0,callSuper/* default */.Z)(this, ErrorBoundary, arguments);
    _this.state = {
      error: undefined,
      info: {
        componentStack: ''
      }
    };
    return _this;
  }
  (0,inherits/* default */.Z)(ErrorBoundary, _React$Component);
  return (0,createClass/* default */.Z)(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      this.setState({
        error,
        info
      });
    }
  }, {
    key: "render",
    value: function render() {
      const {
        message,
        description,
        id,
        children
      } = this.props;
      const {
        error,
        info
      } = this.state;
      const componentStack = (info === null || info === void 0 ? void 0 : info.componentStack) || null;
      const errorMessage = typeof message === 'undefined' ? (error || '').toString() : message;
      const errorDescription = typeof description === 'undefined' ? componentStack : description;
      if (error) {
        return /*#__PURE__*/react.createElement(alert_Alert, {
          id: id,
          type: "error",
          message: errorMessage,
          description: /*#__PURE__*/react.createElement("pre", {
            style: {
              fontSize: '0.9em',
              overflowX: 'auto'
            }
          }, errorDescription)
        });
      }
      return children;
    }
  }]);
}(react.Component);
/* harmony default export */ var alert_ErrorBoundary = (ErrorBoundary);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/alert/index.js
"use client";



const es_alert_Alert = alert_Alert;
es_alert_Alert.ErrorBoundary = alert_ErrorBoundary;
/* harmony default export */ var es_alert = (es_alert_Alert);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useEvent.js
var hooks_useEvent = __webpack_require__(47789);
;// CONCATENATED MODULE: ./node_modules/compute-scroll-into-view/dist/index.js
const t = t => "object" == typeof t && null != t && 1 === t.nodeType,
  e = (t, e) => (!e || "hidden" !== t) && "visible" !== t && "clip" !== t,
  n = (t, n) => {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
      const o = getComputedStyle(t, null);
      return e(o.overflowY, n) || e(o.overflowX, n) || (t => {
        const e = (t => {
          if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
          try {
            return t.ownerDocument.defaultView.frameElement;
          } catch (t) {
            return null;
          }
        })(t);
        return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
      })(t);
    }
    return !1;
  },
  o = (t, e, n, o, l, r, i, s) => r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0,
  l = t => {
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
  },
  dist_r = (e, r) => {
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const {
        scrollMode: c,
        block: f,
        inline: u,
        boundary: a,
        skipOverflowHiddenElements: g
      } = r,
      p = "function" == typeof a ? a : t => t !== a;
    if (!t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement,
      w = [];
    let W = e;
    for (; t(W) && p(W);) {
      if (W = l(W), W === m) {
        w.push(W);
        break;
      }
      null != W && W === document.body && n(W) && !n(document.documentElement) || null != W && n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth,
      H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight,
      {
        scrollX: y,
        scrollY: M
      } = window,
      {
        height: v,
        width: E,
        top: x,
        right: C,
        bottom: I,
        left: R
      } = e.getBoundingClientRect(),
      {
        top: T,
        right: B,
        bottom: F,
        left: V
      } = (t => {
        const e = window.getComputedStyle(t);
        return {
          top: parseFloat(e.scrollMarginTop) || 0,
          right: parseFloat(e.scrollMarginRight) || 0,
          bottom: parseFloat(e.scrollMarginBottom) || 0,
          left: parseFloat(e.scrollMarginLeft) || 0
        };
      })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F,
      D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for (let t = 0; t < w.length; t++) {
      const e = w[t],
        {
          height: l,
          width: r,
          top: i,
          right: s,
          bottom: d,
          left: h
        } = e.getBoundingClientRect();
      if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && (e === m && !n(e) || x >= i && I <= d && R >= h && C <= s)) return L;
      const a = getComputedStyle(e),
        g = parseInt(a.borderLeftWidth, 10),
        p = parseInt(a.borderTopWidth, 10),
        W = parseInt(a.borderRightWidth, 10),
        T = parseInt(a.borderBottomWidth, 10);
      let B = 0,
        F = 0;
      const V = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - g - W : 0,
        S = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - p - T : 0,
        X = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : r / e.offsetWidth : 0,
        Y = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : l / e.offsetHeight : 0;
      if (m === e) B = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? o(M, M + H, H, p, T, M + k, M + k + v, v) : k - H / 2, F = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : o(y, y + b, b, g, W, y + D, y + D + E, E), B = Math.max(0, B + M), F = Math.max(0, F + y);else {
        B = "start" === f ? k - i - p : "end" === f ? k - d + T + S : "nearest" === f ? o(i, d, l, p, T + S, k, k + v, v) : k - (i + l / 2) + S / 2, F = "start" === u ? D - h - g : "center" === u ? D - (h + r / 2) + V / 2 : "end" === u ? D - s + W + V : o(h, s, r, g, W + V, D, D + E, E);
        const {
          scrollLeft: t,
          scrollTop: n
        } = e;
        B = 0 === Y ? 0 : Math.max(0, Math.min(n + B / Y, e.scrollHeight - l / Y + S)), F = 0 === X ? 0 : Math.max(0, Math.min(t + F / X, e.scrollWidth - r / X + V)), k += n - B, D += t - F;
      }
      L.push({
        el: e,
        top: B,
        left: F
      });
    }
    return L;
  };

;// CONCATENATED MODULE: ./node_modules/scroll-into-view-if-needed/dist/index.js

const dist_o = t => !1 === t ? {
  block: "end",
  inline: "nearest"
} : (t => t === Object(t) && 0 !== Object.keys(t).length)(t) ? t : {
  block: "start",
  inline: "nearest"
};
function dist_e(e, r) {
  if (!e.isConnected || !(t => {
    let o = t;
    for (; o && o.parentNode;) {
      if (o.parentNode === document) return !0;
      o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
    }
    return !1;
  })(e)) return;
  const n = (t => {
    const o = window.getComputedStyle(t);
    return {
      top: parseFloat(o.scrollMarginTop) || 0,
      right: parseFloat(o.scrollMarginRight) || 0,
      bottom: parseFloat(o.scrollMarginBottom) || 0,
      left: parseFloat(o.scrollMarginLeft) || 0
    };
  })(e);
  if ((t => "object" == typeof t && "function" == typeof t.behavior)(r)) return r.behavior(dist_r(e, r));
  const l = "boolean" == typeof r || null == r ? void 0 : r.behavior;
  for (const {
    el: a,
    top: i,
    left: s
  } of dist_r(e, dist_o(r))) {
    const t = i - n.top + n.bottom,
      o = s - n.left + n.right;
    a.scroll({
      top: t,
      left: o,
      behavior: l
    });
  }
}

;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/getScroll.js
function isWindow(obj) {
  return obj !== null && obj !== undefined && obj === obj.window;
}
const getScroll = target => {
  var _a, _b;
  if (typeof window === 'undefined') {
    /* istanbul ignore next */
    return 0;
  }
  let result = 0;
  if (isWindow(target)) {
    result = target.pageYOffset;
  } else if (target instanceof Document) {
    result = target.documentElement.scrollTop;
  } else if (target instanceof HTMLElement) {
    result = target.scrollTop;
  } else if (target) {
    // According to the type inference, the `target` is `never` type.
    // Since we configured the loose mode type checking, and supports mocking the target with such shape below::
    //    `{ documentElement: { scrollLeft: 200, scrollTop: 400 } }`,
    //    the program may falls into this branch.
    // Check the corresponding tests for details. Don't sure what is the real scenario this happens.
    /* biome-ignore lint/complexity/useLiteralKeys: target is a never type */ /* eslint-disable-next-line dot-notation */
    result = target['scrollTop'];
  }
  if (target && !isWindow(target) && typeof result !== 'number') {
    result = (_b = ((_a = target.ownerDocument) !== null && _a !== void 0 ? _a : target).documentElement) === null || _b === void 0 ? void 0 : _b.scrollTop;
  }
  return result;
};
/* harmony default export */ var _util_getScroll = (getScroll);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/easings.js
function easeInOutCubic(t, b, c, d) {
  const cc = c - b;
  t /= d / 2;
  if (t < 1) {
    return cc / 2 * t * t * t + b;
  }
  // biome-ignore lint: it is a common easing function
  return cc / 2 * ((t -= 2) * t * t + 2) + b;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/scrollTo.js



function scrollTo(y, options = {}) {
  const {
    getContainer = () => window,
    callback,
    duration = 450
  } = options;
  const container = getContainer();
  const scrollTop = _util_getScroll(container);
  const startTime = Date.now();
  const frameFunc = () => {
    const timestamp = Date.now();
    const time = timestamp - startTime;
    const nextScrollTop = easeInOutCubic(time > duration ? duration : time, scrollTop, y, duration);
    if (isWindow(container)) {
      container.scrollTo(window.pageXOffset, nextScrollTop);
    } else if (container instanceof Document || container.constructor.name === 'HTMLDocument') {
      container.documentElement.scrollTop = nextScrollTop;
    } else {
      container.scrollTop = nextScrollTop;
    }
    if (time < duration) {
      (0,raf/* default */.Z)(frameFunc);
    } else if (typeof callback === 'function') {
      callback();
    }
  };
  (0,raf/* default */.Z)(frameFunc);
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/config-provider/hooks/useCSSVarCls.js

/**
 * This hook is only for cssVar to add root className for components.
 * If root ClassName is needed, this hook could be refactored with `-root`
 * @param prefixCls
 */
const useCSSVarCls = prefixCls => {
  const [,,,, cssVar] = useToken();
  return cssVar ? `${prefixCls}-css-var` : '';
};
/* harmony default export */ var hooks_useCSSVarCls = (useCSSVarCls);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/anchor/context.js

const AnchorContext = /*#__PURE__*/react.createContext(undefined);
/* harmony default export */ var anchor_context = (AnchorContext);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/anchor/AnchorLink.js
"use client";






const AnchorLink = props => {
  const {
    href,
    title,
    prefixCls: customizePrefixCls,
    children,
    className,
    target,
    replace
  } = props;
  const context = react.useContext(anchor_context);
  const {
    registerLink,
    unregisterLink,
    scrollTo,
    onClick,
    activeLink,
    direction
  } = context || {};
  react.useEffect(() => {
    registerLink === null || registerLink === void 0 ? void 0 : registerLink(href);
    return () => {
      unregisterLink === null || unregisterLink === void 0 ? void 0 : unregisterLink(href);
    };
  }, [href]);
  const handleClick = e => {
    onClick === null || onClick === void 0 ? void 0 : onClick(e, {
      title,
      href
    });
    scrollTo === null || scrollTo === void 0 ? void 0 : scrollTo(href);
    // Support clicking on an anchor does not record history.
    if (e.defaultPrevented) {
      return;
    }
    const isExternalLink = href.startsWith('http://') || href.startsWith('https://');
    // Support external link
    if (isExternalLink) {
      if (replace) {
        e.preventDefault();
        window.location.replace(href);
      }
      return;
    }
    // Handling internal anchor link
    e.preventDefault();
    const historyMethod = replace ? 'replaceState' : 'pushState';
    window.history[historyMethod](null, '', href);
  };
  // =================== Warning =====================
  if (false) {}
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('anchor', customizePrefixCls);
  const active = activeLink === href;
  const wrapperClassName = classnames_default()(`${prefixCls}-link`, className, {
    [`${prefixCls}-link-active`]: active
  });
  const titleClassName = classnames_default()(`${prefixCls}-link-title`, {
    [`${prefixCls}-link-title-active`]: active
  });
  return /*#__PURE__*/react.createElement("div", {
    className: wrapperClassName
  }, /*#__PURE__*/react.createElement("a", {
    className: titleClassName,
    href: href,
    title: typeof title === 'string' ? title : '',
    target: target,
    onClick: handleClick
  }, title), direction !== 'horizontal' ? children : null);
};
/* harmony default export */ var anchor_AnchorLink = (AnchorLink);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/anchor/style/index.js



// ============================== Shared ==============================
const genSharedAnchorStyle = token => {
  const {
    componentCls,
    holderOffsetBlock,
    motionDurationSlow,
    lineWidthBold,
    colorPrimary,
    lineType,
    colorSplit,
    calc
  } = token;
  return {
    [`${componentCls}-wrapper`]: {
      marginBlockStart: calc(holderOffsetBlock).mul(-1).equal(),
      paddingBlockStart: holderOffsetBlock,
      // delete overflow: auto
      // overflow: 'auto',
      [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
        position: 'relative',
        paddingInlineStart: lineWidthBold,
        [`${componentCls}-link`]: {
          paddingBlock: token.linkPaddingBlock,
          paddingInline: `${(0,cssinjs_es/* unit */.bf)(token.linkPaddingInlineStart)} 0`,
          '&-title': Object.assign(Object.assign({}, textEllipsis), {
            position: 'relative',
            display: 'block',
            marginBlockEnd: token.anchorTitleBlock,
            color: token.colorText,
            transition: `all ${token.motionDurationSlow}`,
            '&:only-child': {
              marginBlockEnd: 0
            }
          }),
          [`&-active > ${componentCls}-link-title`]: {
            color: token.colorPrimary
          },
          // link link
          [`${componentCls}-link`]: {
            paddingBlock: token.anchorPaddingBlockSecondary
          }
        }
      }),
      [`&:not(${componentCls}-wrapper-horizontal)`]: {
        [componentCls]: {
          '&::before': {
            position: 'absolute',
            insetInlineStart: 0,
            top: 0,
            height: '100%',
            borderInlineStart: `${(0,cssinjs_es/* unit */.bf)(lineWidthBold)} ${lineType} ${colorSplit}`,
            content: '" "'
          },
          [`${componentCls}-ink`]: {
            position: 'absolute',
            insetInlineStart: 0,
            display: 'none',
            transform: 'translateY(-50%)',
            transition: `top ${motionDurationSlow} ease-in-out`,
            width: lineWidthBold,
            backgroundColor: colorPrimary,
            [`&${componentCls}-ink-visible`]: {
              display: 'inline-block'
            }
          }
        }
      },
      [`${componentCls}-fixed ${componentCls}-ink ${componentCls}-ink`]: {
        display: 'none'
      }
    }
  };
};
const genSharedAnchorHorizontalStyle = token => {
  const {
    componentCls,
    motionDurationSlow,
    lineWidthBold,
    colorPrimary
  } = token;
  return {
    [`${componentCls}-wrapper-horizontal`]: {
      position: 'relative',
      '&::before': {
        position: 'absolute',
        left: {
          _skip_check_: true,
          value: 0
        },
        right: {
          _skip_check_: true,
          value: 0
        },
        bottom: 0,
        borderBottom: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`,
        content: '" "'
      },
      [componentCls]: {
        overflowX: 'scroll',
        position: 'relative',
        display: 'flex',
        scrollbarWidth: 'none' /* Firefox */,
        '&::-webkit-scrollbar': {
          display: 'none' /* Safari and Chrome */
        },
        [`${componentCls}-link:first-of-type`]: {
          paddingInline: 0
        },
        [`${componentCls}-ink`]: {
          position: 'absolute',
          bottom: 0,
          transition: `left ${motionDurationSlow} ease-in-out, width ${motionDurationSlow} ease-in-out`,
          height: lineWidthBold,
          backgroundColor: colorPrimary
        }
      }
    }
  };
};
const anchor_style_prepareComponentToken = token => ({
  linkPaddingBlock: token.paddingXXS,
  linkPaddingInlineStart: token.padding
});
// ============================== Export ==============================
/* harmony default export */ var anchor_style = (genStyleHooks('Anchor', token => {
  const {
    fontSize,
    fontSizeLG,
    paddingXXS,
    calc
  } = token;
  const anchorToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    holderOffsetBlock: paddingXXS,
    anchorPaddingBlockSecondary: calc(paddingXXS).div(2).equal(),
    anchorTitleBlock: calc(fontSize).div(14).mul(3).equal(),
    anchorBallSize: calc(fontSizeLG).div(2).equal()
  });
  return [genSharedAnchorStyle(anchorToken), genSharedAnchorHorizontalStyle(anchorToken)];
}, anchor_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/anchor/Anchor.js
"use client";















function getDefaultContainer() {
  return window;
}
function getOffsetTop(element, container) {
  if (!element.getClientRects().length) {
    return 0;
  }
  const rect = element.getBoundingClientRect();
  if (rect.width || rect.height) {
    if (container === window) {
      return rect.top - element.ownerDocument.documentElement.clientTop;
    }
    return rect.top - container.getBoundingClientRect().top;
  }
  return rect.top;
}
const sharpMatcherRegex = /#([\S ]+)$/;
const Anchor = props => {
  var _a;
  const {
    rootClassName,
    prefixCls: customPrefixCls,
    className,
    style,
    offsetTop,
    affix = true,
    showInkInFixed = false,
    children,
    items,
    direction: anchorDirection = 'vertical',
    bounds,
    targetOffset,
    onClick,
    onChange,
    getContainer,
    getCurrentAnchor,
    replace
  } = props;
  // =================== Warning =====================
  if (false) {}
  const [links, setLinks] = react.useState([]);
  const [activeLink, setActiveLink] = react.useState(null);
  const activeLinkRef = react.useRef(activeLink);
  const wrapperRef = react.useRef(null);
  const spanLinkNode = react.useRef(null);
  const animating = react.useRef(false);
  const {
    direction,
    getPrefixCls,
    className: anchorClassName,
    style: anchorStyle
  } = useComponentConfig('anchor');
  const {
    getTargetContainer
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('anchor', customPrefixCls);
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = anchor_style(prefixCls, rootCls);
  const getCurrentContainer = (_a = getContainer !== null && getContainer !== void 0 ? getContainer : getTargetContainer) !== null && _a !== void 0 ? _a : getDefaultContainer;
  const dependencyListItem = JSON.stringify(links);
  const registerLink = (0,hooks_useEvent/* default */.Z)(link => {
    if (!links.includes(link)) {
      setLinks(prev => [].concat((0,toConsumableArray/* default */.Z)(prev), [link]));
    }
  });
  const unregisterLink = (0,hooks_useEvent/* default */.Z)(link => {
    if (links.includes(link)) {
      setLinks(prev => prev.filter(i => i !== link));
    }
  });
  const updateInk = () => {
    var _a;
    const linkNode = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`.${prefixCls}-link-title-active`);
    if (linkNode && spanLinkNode.current) {
      const {
        style: inkStyle
      } = spanLinkNode.current;
      const horizontalAnchor = anchorDirection === 'horizontal';
      inkStyle.top = horizontalAnchor ? '' : `${linkNode.offsetTop + linkNode.clientHeight / 2}px`;
      inkStyle.height = horizontalAnchor ? '' : `${linkNode.clientHeight}px`;
      inkStyle.left = horizontalAnchor ? `${linkNode.offsetLeft}px` : '';
      inkStyle.width = horizontalAnchor ? `${linkNode.clientWidth}px` : '';
      if (horizontalAnchor) {
        dist_e(linkNode, {
          scrollMode: 'if-needed',
          block: 'nearest'
        });
      }
    }
  };
  const getInternalCurrentAnchor = (_links, _offsetTop = 0, _bounds = 5) => {
    const linkSections = [];
    const container = getCurrentContainer();
    _links.forEach(link => {
      const sharpLinkMatch = sharpMatcherRegex.exec(link === null || link === void 0 ? void 0 : link.toString());
      if (!sharpLinkMatch) {
        return;
      }
      const target = document.getElementById(sharpLinkMatch[1]);
      if (target) {
        const top = getOffsetTop(target, container);
        if (top <= _offsetTop + _bounds) {
          linkSections.push({
            link,
            top
          });
        }
      }
    });
    if (linkSections.length) {
      const maxSection = linkSections.reduce((prev, curr) => curr.top > prev.top ? curr : prev);
      return maxSection.link;
    }
    return '';
  };
  const setCurrentActiveLink = (0,hooks_useEvent/* default */.Z)(link => {
    // FIXME: Seems a bug since this compare is not equals
    // `activeLinkRef` is parsed value which will always trigger `onChange` event.
    if (activeLinkRef.current === link) {
      return;
    }
    // https://github.com/ant-design/ant-design/issues/30584
    const newLink = typeof getCurrentAnchor === 'function' ? getCurrentAnchor(link) : link;
    setActiveLink(newLink);
    activeLinkRef.current = newLink;
    // onChange should respect the original link (which may caused by
    // window scroll or user click), not the new link
    onChange === null || onChange === void 0 ? void 0 : onChange(link);
  });
  const handleScroll = react.useCallback(() => {
    if (animating.current) {
      return;
    }
    const currentActiveLink = getInternalCurrentAnchor(links, targetOffset !== undefined ? targetOffset : offsetTop || 0, bounds);
    setCurrentActiveLink(currentActiveLink);
  }, [dependencyListItem, targetOffset, offsetTop]);
  const handleScrollTo = react.useCallback(link => {
    setCurrentActiveLink(link);
    const sharpLinkMatch = sharpMatcherRegex.exec(link);
    if (!sharpLinkMatch) {
      return;
    }
    const targetElement = document.getElementById(sharpLinkMatch[1]);
    if (!targetElement) {
      return;
    }
    const container = getCurrentContainer();
    const scrollTop = _util_getScroll(container);
    const eleOffsetTop = getOffsetTop(targetElement, container);
    let y = scrollTop + eleOffsetTop;
    y -= targetOffset !== undefined ? targetOffset : offsetTop || 0;
    animating.current = true;
    scrollTo(y, {
      getContainer: getCurrentContainer,
      callback() {
        animating.current = false;
      }
    });
  }, [targetOffset, offsetTop]);
  const wrapperClass = classnames_default()(hashId, cssVarCls, rootCls, rootClassName, `${prefixCls}-wrapper`, {
    [`${prefixCls}-wrapper-horizontal`]: anchorDirection === 'horizontal',
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, className, anchorClassName);
  const anchorClass = classnames_default()(prefixCls, {
    [`${prefixCls}-fixed`]: !affix && !showInkInFixed
  });
  const inkClass = classnames_default()(`${prefixCls}-ink`, {
    [`${prefixCls}-ink-visible`]: activeLink
  });
  const wrapperStyle = Object.assign(Object.assign({
    maxHeight: offsetTop ? `calc(100vh - ${offsetTop}px)` : '100vh'
  }, anchorStyle), style);
  const createNestedLink = options => Array.isArray(options) ? options.map(item => (/*#__PURE__*/react.createElement(anchor_AnchorLink, Object.assign({
    replace: replace
  }, item, {
    key: item.key
  }), anchorDirection === 'vertical' && createNestedLink(item.children)))) : null;
  const anchorContent = /*#__PURE__*/react.createElement("div", {
    ref: wrapperRef,
    className: wrapperClass,
    style: wrapperStyle
  }, /*#__PURE__*/react.createElement("div", {
    className: anchorClass
  }, /*#__PURE__*/react.createElement("span", {
    className: inkClass,
    ref: spanLinkNode
  }), 'items' in props ? createNestedLink(items) : children));
  react.useEffect(() => {
    const scrollContainer = getCurrentContainer();
    handleScroll();
    scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.addEventListener('scroll', handleScroll);
    return () => {
      scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [dependencyListItem]);
  react.useEffect(() => {
    if (typeof getCurrentAnchor === 'function') {
      setCurrentActiveLink(getCurrentAnchor(activeLinkRef.current || ''));
    }
  }, [getCurrentAnchor]);
  react.useEffect(() => {
    updateInk();
  }, [anchorDirection, getCurrentAnchor, dependencyListItem, activeLink]);
  const memoizedContextValue = react.useMemo(() => ({
    registerLink,
    unregisterLink,
    scrollTo: handleScrollTo,
    activeLink,
    onClick,
    direction: anchorDirection
  }), [activeLink, onClick, handleScrollTo, anchorDirection]);
  const affixProps = affix && typeof affix === 'object' ? affix : undefined;
  return wrapCSSVar(/*#__PURE__*/react.createElement(anchor_context.Provider, {
    value: memoizedContextValue
  }, affix ? (/*#__PURE__*/react.createElement(es_affix, Object.assign({
    offsetTop: offsetTop,
    target: getCurrentContainer
  }, affixProps), anchorContent)) : anchorContent));
};
if (false) {}
/* harmony default export */ var anchor_Anchor = (Anchor);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/anchor/index.js
"use client";



const es_anchor_Anchor = anchor_Anchor;
es_anchor_Anchor.Link = anchor_AnchorLink;
/* harmony default export */ var es_anchor = (es_anchor_Anchor);
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var es_warning = __webpack_require__(13764);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/warning.js


function noop() {}
let deprecatedWarnList = null;
function resetWarned() {
  deprecatedWarnList = null;
  rcResetWarned();
}
let _warning = (/* unused pure expression or super */ null && (noop));
if (false) {}
const warning_warning = (/* unused pure expression or super */ null && (_warning));
const WarningContext = /*#__PURE__*/react.createContext({});
/**
 * This is a hook but we not named as `useWarning`
 * since this is only used in development.
 * We should always wrap this in `if (process.env.NODE_ENV !== 'production')` condition
 */
const warning_devUseWarning =  false ? 0 : () => {
  const noopWarning = () => {};
  noopWarning.deprecated = noop;
  return noopWarning;
};
/* harmony default export */ var _util_warning = ((/* unused pure expression or super */ null && (warning_warning)));
// EXTERNAL MODULE: ./node_modules/rc-notification/es/index.js + 6 modules
var rc_notification_es = __webpack_require__(34260);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/LoadingOutlined.js + 1 modules
var LoadingOutlined = __webpack_require__(50733);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/zindexContext.js

const zIndexContext = /*#__PURE__*/react.createContext(undefined);
if (false) {}
/* harmony default export */ var zindexContext = (zIndexContext);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/hooks/useZIndex.js




// Z-Index control range
// Container: 1000 + offset 100 (max base + 10 * offset = 2000)
// Popover: offset 50
// Notification: Container Max zIndex + componentOffset
const CONTAINER_OFFSET = 100;
const CONTAINER_OFFSET_MAX_COUNT = 10;
const CONTAINER_MAX_OFFSET = CONTAINER_OFFSET * CONTAINER_OFFSET_MAX_COUNT;
/**
 * Static function will default be the `CONTAINER_MAX_OFFSET`.
 * But it still may have children component like Select, Dropdown.
 * So the warning zIndex should exceed the `CONTAINER_MAX_OFFSET`.
 */
const CONTAINER_MAX_OFFSET_WITH_CHILDREN = CONTAINER_MAX_OFFSET + CONTAINER_OFFSET;
const containerBaseZIndexOffset = {
  Modal: CONTAINER_OFFSET,
  Drawer: CONTAINER_OFFSET,
  Popover: CONTAINER_OFFSET,
  Popconfirm: CONTAINER_OFFSET,
  Tooltip: CONTAINER_OFFSET,
  Tour: CONTAINER_OFFSET,
  FloatButton: CONTAINER_OFFSET
};
const consumerBaseZIndexOffset = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function isContainerType(type) {
  return type in containerBaseZIndexOffset;
}
const useZIndex = (componentType, customZIndex) => {
  const [, token] = useToken();
  const parentZIndex = react.useContext(zindexContext);
  const isContainer = isContainerType(componentType);
  let result;
  if (customZIndex !== undefined) {
    result = [customZIndex, customZIndex];
  } else {
    let zIndex = parentZIndex !== null && parentZIndex !== void 0 ? parentZIndex : 0;
    if (isContainer) {
      zIndex +=
      // Use preset token zIndex by default but not stack when has parent container
      (parentZIndex ? 0 : token.zIndexPopupBase) +
      // Container offset
      containerBaseZIndexOffset[componentType];
    } else {
      zIndex += consumerBaseZIndexOffset[componentType];
    }
    result = [parentZIndex === undefined ? customZIndex : zIndex, zIndex];
  }
  if (false) {}
  return result;
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/message/style/index.js




const genMessageStyle = token => {
  const {
    componentCls,
    iconCls,
    boxShadow,
    colorText,
    colorSuccess,
    colorError,
    colorWarning,
    colorInfo,
    fontSizeLG,
    motionEaseInOutCirc,
    motionDurationSlow,
    marginXS,
    paddingXS,
    borderRadiusLG,
    zIndexPopup,
    // Custom token
    contentPadding,
    contentBg
  } = token;
  const noticeCls = `${componentCls}-notice`;
  const messageMoveIn = new cssinjs_es/* Keyframes */.E4('MessageMoveIn', {
    '0%': {
      padding: 0,
      transform: 'translateY(-100%)',
      opacity: 0
    },
    '100%': {
      padding: paddingXS,
      transform: 'translateY(0)',
      opacity: 1
    }
  });
  const messageMoveOut = new cssinjs_es/* Keyframes */.E4('MessageMoveOut', {
    '0%': {
      maxHeight: token.height,
      padding: paddingXS,
      opacity: 1
    },
    '100%': {
      maxHeight: 0,
      padding: 0,
      opacity: 0
    }
  });
  const noticeStyle = {
    padding: paddingXS,
    textAlign: 'center',
    [`${componentCls}-custom-content`]: {
      display: 'flex',
      alignItems: 'center'
    },
    [`${componentCls}-custom-content > ${iconCls}`]: {
      marginInlineEnd: marginXS,
      // affected by ltr or rtl
      fontSize: fontSizeLG
    },
    [`${noticeCls}-content`]: {
      display: 'inline-block',
      padding: contentPadding,
      background: contentBg,
      borderRadius: borderRadiusLG,
      boxShadow,
      pointerEvents: 'all'
    },
    [`${componentCls}-success > ${iconCls}`]: {
      color: colorSuccess
    },
    [`${componentCls}-error > ${iconCls}`]: {
      color: colorError
    },
    [`${componentCls}-warning > ${iconCls}`]: {
      color: colorWarning
    },
    [`${componentCls}-info > ${iconCls},
      ${componentCls}-loading > ${iconCls}`]: {
      color: colorInfo
    }
  };
  return [
  // ============================ Holder ============================
  {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      color: colorText,
      position: 'fixed',
      top: marginXS,
      width: '100%',
      pointerEvents: 'none',
      zIndex: zIndexPopup,
      [`${componentCls}-move-up`]: {
        animationFillMode: 'forwards'
      },
      [`
        ${componentCls}-move-up-appear,
        ${componentCls}-move-up-enter
      `]: {
        animationName: messageMoveIn,
        animationDuration: motionDurationSlow,
        animationPlayState: 'paused',
        animationTimingFunction: motionEaseInOutCirc
      },
      [`
        ${componentCls}-move-up-appear${componentCls}-move-up-appear-active,
        ${componentCls}-move-up-enter${componentCls}-move-up-enter-active
      `]: {
        animationPlayState: 'running'
      },
      [`${componentCls}-move-up-leave`]: {
        animationName: messageMoveOut,
        animationDuration: motionDurationSlow,
        animationPlayState: 'paused',
        animationTimingFunction: motionEaseInOutCirc
      },
      [`${componentCls}-move-up-leave${componentCls}-move-up-leave-active`]: {
        animationPlayState: 'running'
      },
      '&-rtl': {
        direction: 'rtl',
        span: {
          direction: 'rtl'
        }
      }
    })
  },
  // ============================ Notice ============================
  {
    [componentCls]: {
      [`${noticeCls}-wrapper`]: Object.assign({}, noticeStyle)
    }
  },
  // ============================= Pure =============================
  {
    [`${componentCls}-notice-pure-panel`]: Object.assign(Object.assign({}, noticeStyle), {
      padding: 0,
      textAlign: 'start'
    })
  }];
};
const message_style_prepareComponentToken = token => ({
  zIndexPopup: token.zIndexPopupBase + CONTAINER_MAX_OFFSET + 10,
  contentBg: token.colorBgElevated,
  contentPadding: `${(token.controlHeightLG - token.fontSize * token.lineHeight) / 2}px ${token.paddingSM}px`
});
// ============================== Export ==============================
/* harmony default export */ var style = (genStyleHooks('Message', token => {
  // Gen-style functions here
  const combinedToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    height: 150
  });
  return genMessageStyle(combinedToken);
}, message_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/message/PurePanel.js
"use client";

var PurePanel_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};











const TypeIcon = {
  info: /*#__PURE__*/react.createElement(InfoCircleFilled/* default */.Z, null),
  success: /*#__PURE__*/react.createElement(CheckCircleFilled/* default */.Z, null),
  error: /*#__PURE__*/react.createElement(CloseCircleFilled/* default */.Z, null),
  warning: /*#__PURE__*/react.createElement(ExclamationCircleFilled/* default */.Z, null),
  loading: /*#__PURE__*/react.createElement(LoadingOutlined/* default */.Z, null)
};
const PureContent = ({
  prefixCls,
  type,
  icon,
  children
}) => (/*#__PURE__*/react.createElement("div", {
  className: classnames_default()(`${prefixCls}-custom-content`, `${prefixCls}-${type}`)
}, icon || TypeIcon[type], /*#__PURE__*/react.createElement("span", null, children)));
/** @private Internal Component. Do not use in your production. */
const PurePanel = props => {
  const {
      prefixCls: staticPrefixCls,
      className,
      type,
      icon,
      content
    } = props,
    restProps = PurePanel_rest(props, ["prefixCls", "className", "type", "icon", "content"]);
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = staticPrefixCls || getPrefixCls('message');
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style(prefixCls, rootCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement(rc_notification_es/* Notice */.qX, Object.assign({}, restProps, {
    prefixCls: prefixCls,
    className: classnames_default()(className, hashId, `${prefixCls}-notice-pure-panel`, cssVarCls, rootCls),
    eventKey: "pure",
    duration: null,
    content: /*#__PURE__*/react.createElement(PureContent, {
      prefixCls: prefixCls,
      type: type,
      icon: icon
    }, content)
  })));
};
/* harmony default export */ var message_PurePanel = (PurePanel);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/message/util.js
function getMotion(prefixCls, transitionName) {
  return {
    motionName: transitionName !== null && transitionName !== void 0 ? transitionName : `${prefixCls}-move-up`
  };
}
/** Wrap message open with promise like function */
function wrapPromiseFn(openFn) {
  let closeFn;
  const closePromise = new Promise(resolve => {
    closeFn = openFn(() => {
      resolve(true);
    });
  });
  const result = () => {
    closeFn === null || closeFn === void 0 ? void 0 : closeFn();
  };
  result.then = (filled, rejected) => closePromise.then(filled, rejected);
  result.promise = closePromise;
  return result;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/message/useMessage.js
"use client";

var useMessage_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};










const DEFAULT_OFFSET = 8;
const DEFAULT_DURATION = 3;
const Wrapper = ({
  children,
  prefixCls
}) => {
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style(prefixCls, rootCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement(rc_notification_es/* NotificationProvider */.JB, {
    classNames: {
      list: classnames_default()(hashId, cssVarCls, rootCls)
    }
  }, children));
};
const renderNotifications = (node, {
  prefixCls,
  key
}) => (/*#__PURE__*/react.createElement(Wrapper, {
  prefixCls: prefixCls,
  key: key
}, node));
const Holder = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    top,
    prefixCls: staticPrefixCls,
    getContainer: staticGetContainer,
    maxCount,
    duration = DEFAULT_DURATION,
    rtl,
    transitionName,
    onAllRemoved
  } = props;
  const {
    getPrefixCls,
    getPopupContainer,
    message,
    direction
  } = react.useContext(ConfigContext);
  const prefixCls = staticPrefixCls || getPrefixCls('message');
  // =============================== Style ===============================
  const getStyle = () => ({
    left: '50%',
    transform: 'translateX(-50%)',
    top: top !== null && top !== void 0 ? top : DEFAULT_OFFSET
  });
  const getClassName = () => classnames_default()({
    [`${prefixCls}-rtl`]: rtl !== null && rtl !== void 0 ? rtl : direction === 'rtl'
  });
  // ============================== Motion ===============================
  const getNotificationMotion = () => getMotion(prefixCls, transitionName);
  // ============================ Close Icon =============================
  const mergedCloseIcon = /*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-close-x`
  }, /*#__PURE__*/react.createElement(CloseOutlined/* default */.Z, {
    className: `${prefixCls}-close-icon`
  }));
  // ============================== Origin ===============================
  const [api, holder] = (0,rc_notification_es/* useNotification */.lm)({
    prefixCls,
    style: getStyle,
    className: getClassName,
    motion: getNotificationMotion,
    closable: false,
    closeIcon: mergedCloseIcon,
    duration,
    getContainer: () => (staticGetContainer === null || staticGetContainer === void 0 ? void 0 : staticGetContainer()) || (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer()) || document.body,
    maxCount,
    onAllRemoved,
    renderNotifications
  });
  // ================================ Ref ================================
  react.useImperativeHandle(ref, () => Object.assign(Object.assign({}, api), {
    prefixCls,
    message
  }));
  return holder;
});
// ==============================================================================
// ==                                   Hook                                   ==
// ==============================================================================
let keyIndex = 0;
function useInternalMessage(messageConfig) {
  const holderRef = react.useRef(null);
  const warning = warning_devUseWarning('Message');
  // ================================ API ================================
  const wrapAPI = react.useMemo(() => {
    // Wrap with notification content
    // >>> close
    const close = key => {
      var _a;
      (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.close(key);
    };
    // >>> Open
    const open = config => {
      if (!holderRef.current) {
         false ? 0 : void 0;
        const fakeResult = () => {};
        fakeResult.then = () => {};
        return fakeResult;
      }
      const {
        open: originOpen,
        prefixCls,
        message
      } = holderRef.current;
      const noticePrefixCls = `${prefixCls}-notice`;
      const {
          content,
          icon,
          type,
          key,
          className,
          style,
          onClose
        } = config,
        restConfig = useMessage_rest(config, ["content", "icon", "type", "key", "className", "style", "onClose"]);
      let mergedKey = key;
      if (mergedKey === undefined || mergedKey === null) {
        keyIndex += 1;
        mergedKey = `antd-message-${keyIndex}`;
      }
      return wrapPromiseFn(resolve => {
        originOpen(Object.assign(Object.assign({}, restConfig), {
          key: mergedKey,
          content: (/*#__PURE__*/react.createElement(PureContent, {
            prefixCls: prefixCls,
            type: type,
            icon: icon
          }, content)),
          placement: 'top',
          className: classnames_default()(type && `${noticePrefixCls}-${type}`, className, message === null || message === void 0 ? void 0 : message.className),
          style: Object.assign(Object.assign({}, message === null || message === void 0 ? void 0 : message.style), style),
          onClose: () => {
            onClose === null || onClose === void 0 ? void 0 : onClose();
            resolve();
          }
        }));
        // Return close function
        return () => {
          close(mergedKey);
        };
      });
    };
    // >>> destroy
    const destroy = key => {
      var _a;
      if (key !== undefined) {
        close(key);
      } else {
        (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
      }
    };
    const clone = {
      open,
      destroy
    };
    const keys = ['info', 'success', 'warning', 'error', 'loading'];
    keys.forEach(type => {
      const typeOpen = (jointContent, duration, onClose) => {
        let config;
        if (jointContent && typeof jointContent === 'object' && 'content' in jointContent) {
          config = jointContent;
        } else {
          config = {
            content: jointContent
          };
        }
        // Params
        let mergedDuration;
        let mergedOnClose;
        if (typeof duration === 'function') {
          mergedOnClose = duration;
        } else {
          mergedDuration = duration;
          mergedOnClose = onClose;
        }
        const mergedConfig = Object.assign(Object.assign({
          onClose: mergedOnClose,
          duration: mergedDuration
        }, config), {
          type
        });
        return open(mergedConfig);
      };
      clone[type] = typeOpen;
    });
    return clone;
  }, []);
  // ============================== Return ===============================
  return [wrapAPI, /*#__PURE__*/react.createElement(Holder, Object.assign({
    key: "message-holder"
  }, messageConfig, {
    ref: holderRef
  }))];
}
function useMessage(messageConfig) {
  return useInternalMessage(messageConfig);
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/hooks/usePatchElement.js


function usePatchElement() {
  const [elements, setElements] = react.useState([]);
  const patchElement = react.useCallback(element => {
    // append a new element to elements (and create a new ref)
    setElements(originElements => [].concat((0,toConsumableArray/* default */.Z)(originElements), [element]));
    // return a function that removes the new element out of elements (and create a new ref)
    // it works a little like useEffect
    return () => {
      setElements(originElements => originElements.filter(ele => ele !== element));
    };
  }, []);
  return [elements, patchElement];
}
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Context.js
var Context = __webpack_require__(15479);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMemo.js
var useMemo = __webpack_require__(99834);
// EXTERNAL MODULE: ./node_modules/rc-util/es/utils/set.js
var set = __webpack_require__(57935);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/validateMessagesContext.js
"use client";


// ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-field-form`
/* harmony default export */ var validateMessagesContext = (/*#__PURE__*/(0,react.createContext)(undefined));
// EXTERNAL MODULE: ./node_modules/rc-pagination/es/locale/en_US.js
var en_US = __webpack_require__(14603);
// EXTERNAL MODULE: ./node_modules/rc-picker/es/locale/en_US.js + 1 modules
var locale_en_US = __webpack_require__(50371);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/time-picker/locale/en_US.js
const locale = {
  placeholder: 'Select time',
  rangePlaceholder: ['Start time', 'End time']
};
/* harmony default export */ var time_picker_locale_en_US = (locale);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/date-picker/locale/en_US.js


// Merge into a locale object
const en_US_locale = {
  lang: Object.assign({
    placeholder: 'Select date',
    yearPlaceholder: 'Select year',
    quarterPlaceholder: 'Select quarter',
    monthPlaceholder: 'Select month',
    weekPlaceholder: 'Select week',
    rangePlaceholder: ['Start date', 'End date'],
    rangeYearPlaceholder: ['Start year', 'End year'],
    rangeQuarterPlaceholder: ['Start quarter', 'End quarter'],
    rangeMonthPlaceholder: ['Start month', 'End month'],
    rangeWeekPlaceholder: ['Start week', 'End week']
  }, locale_en_US/* default */.Z),
  timePickerLocale: Object.assign({}, time_picker_locale_en_US)
};
// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
/* harmony default export */ var date_picker_locale_en_US = (en_US_locale);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/calendar/locale/en_US.js

/* harmony default export */ var calendar_locale_en_US = (date_picker_locale_en_US);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/locale/en_US.js




const typeTemplate = '${label} is not a valid ${type}';
const localeValues = {
  locale: 'en',
  Pagination: en_US/* default */.Z,
  DatePicker: date_picker_locale_en_US,
  TimePicker: time_picker_locale_en_US,
  Calendar: calendar_locale_en_US,
  global: {
    placeholder: 'Please select',
    close: 'Close'
  },
  Table: {
    filterTitle: 'Filter menu',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    filterEmptyText: 'No filters',
    filterCheckAll: 'Select all items',
    filterSearchPlaceholder: 'Search in filters',
    emptyText: 'No data',
    selectAll: 'Select current page',
    selectInvert: 'Invert current page',
    selectNone: 'Clear all data',
    selectionAll: 'Select all data',
    sortTitle: 'Sort',
    expand: 'Expand row',
    collapse: 'Collapse row',
    triggerDesc: 'Click to sort descending',
    triggerAsc: 'Click to sort ascending',
    cancelSort: 'Click to cancel sorting'
  },
  Tour: {
    Next: 'Next',
    Previous: 'Previous',
    Finish: 'Finish'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Cancel',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Cancel'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Search here',
    itemUnit: 'item',
    itemsUnit: 'items',
    remove: 'Remove',
    selectCurrent: 'Select current page',
    removeCurrent: 'Remove current page',
    selectAll: 'Select all data',
    deselectAll: 'Deselect all data',
    removeAll: 'Remove all data',
    selectInvert: 'Invert current page'
  },
  Upload: {
    uploading: 'Uploading...',
    removeFile: 'Remove file',
    uploadError: 'Upload error',
    previewFile: 'Preview file',
    downloadFile: 'Download file'
  },
  Empty: {
    description: 'No data'
  },
  Icon: {
    icon: 'icon'
  },
  Text: {
    edit: 'Edit',
    copy: 'Copy',
    copied: 'Copied',
    expand: 'Expand',
    collapse: 'Collapse'
  },
  Form: {
    optional: '(optional)',
    defaultValidateMessages: {
      default: 'Field validation error for ${label}',
      required: 'Please enter ${label}',
      enum: '${label} must be one of [${enum}]',
      whitespace: '${label} cannot be a blank character',
      date: {
        format: '${label} date format is invalid',
        parse: '${label} cannot be converted to a date',
        invalid: '${label} is an invalid date'
      },
      types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        boolean: typeTemplate,
        integer: typeTemplate,
        float: typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate
      },
      string: {
        len: '${label} must be ${len} characters',
        min: '${label} must be at least ${min} characters',
        max: '${label} must be up to ${max} characters',
        range: '${label} must be between ${min}-${max} characters'
      },
      number: {
        len: '${label} must be equal to ${len}',
        min: '${label} must be minimum ${min}',
        max: '${label} must be maximum ${max}',
        range: '${label} must be between ${min}-${max}'
      },
      array: {
        len: 'Must be ${len} ${label}',
        min: 'At least ${min} ${label}',
        max: 'At most ${max} ${label}',
        range: 'The amount of ${label} must be between ${min}-${max}'
      },
      pattern: {
        mismatch: '${label} does not match the pattern ${pattern}'
      }
    }
  },
  Image: {
    preview: 'Preview'
  },
  QRCode: {
    expired: 'QR code expired',
    refresh: 'Refresh',
    scanned: 'Scanned'
  },
  ColorPicker: {
    presetEmpty: 'Empty',
    transparent: 'Transparent',
    singleColor: 'Single',
    gradientColor: 'Gradient'
  }
};
/* harmony default export */ var es_locale_en_US = (localeValues);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/modal/locale.js

let runtimeLocale = Object.assign({}, es_locale_en_US.Modal);
let localeList = [];
const generateLocale = () => localeList.reduce((merged, locale) => Object.assign(Object.assign({}, merged), locale), es_locale_en_US.Modal);
function changeConfirmLocale(newLocale) {
  if (newLocale) {
    const cloneLocale = Object.assign({}, newLocale);
    localeList.push(cloneLocale);
    runtimeLocale = generateLocale();
    return () => {
      localeList = localeList.filter(locale => locale !== cloneLocale);
      runtimeLocale = generateLocale();
    };
  }
  runtimeLocale = Object.assign({}, es_locale_en_US.Modal);
}
function getConfirmLocale() {
  return runtimeLocale;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/locale/context.js

const LocaleContext = /*#__PURE__*/(0,react.createContext)(undefined);
/* harmony default export */ var locale_context = (LocaleContext);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/locale/index.js
"use client";






const ANT_MARK = 'internalMark';
const LocaleProvider = props => {
  const {
    locale = {},
    children,
    _ANT_MARK__
  } = props;
  if (false) {}
  react.useEffect(() => {
    const clearLocale = changeConfirmLocale(locale === null || locale === void 0 ? void 0 : locale.Modal);
    return clearLocale;
  }, [locale]);
  const getMemoizedContextValue = react.useMemo(() => Object.assign(Object.assign({}, locale), {
    exist: true
  }), [locale]);
  return /*#__PURE__*/react.createElement(locale_context.Provider, {
    value: getMemoizedContextValue
  }, children);
};
if (false) {}
/* harmony default export */ var es_locale = (LocaleProvider);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/canUseDom.js
var canUseDom = __webpack_require__(55304);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/dynamicCSS.js
var dynamicCSS = __webpack_require__(6779);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/config-provider/cssVariables.js





const dynamicStyleMark = `-ant-${Date.now()}-${Math.random()}`;
function getStyle(globalPrefixCls, theme) {
  const variables = {};
  const formatColor = (color, updater) => {
    let clone = color.clone();
    clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
    return clone.toRgbString();
  };
  const fillColor = (colorVal, type) => {
    const baseColor = new fast_color_es/* FastColor */.t(colorVal);
    const colorPalettes = (0,colors_es/* generate */.R_)(baseColor.toRgbString());
    variables[`${type}-color`] = formatColor(baseColor);
    variables[`${type}-color-disabled`] = colorPalettes[1];
    variables[`${type}-color-hover`] = colorPalettes[4];
    variables[`${type}-color-active`] = colorPalettes[6];
    variables[`${type}-color-outline`] = baseColor.clone().setA(0.2).toRgbString();
    variables[`${type}-color-deprecated-bg`] = colorPalettes[0];
    variables[`${type}-color-deprecated-border`] = colorPalettes[2];
  };
  // ================ Primary Color ================
  if (theme.primaryColor) {
    fillColor(theme.primaryColor, 'primary');
    const primaryColor = new fast_color_es/* FastColor */.t(theme.primaryColor);
    const primaryColors = (0,colors_es/* generate */.R_)(primaryColor.toRgbString());
    // Legacy - We should use semantic naming standard
    primaryColors.forEach((color, index) => {
      variables[`primary-${index + 1}`] = color;
    });
    // Deprecated
    variables['primary-color-deprecated-l-35'] = formatColor(primaryColor, c => c.lighten(35));
    variables['primary-color-deprecated-l-20'] = formatColor(primaryColor, c => c.lighten(20));
    variables['primary-color-deprecated-t-20'] = formatColor(primaryColor, c => c.tint(20));
    variables['primary-color-deprecated-t-50'] = formatColor(primaryColor, c => c.tint(50));
    variables['primary-color-deprecated-f-12'] = formatColor(primaryColor, c => c.setA(c.a * 0.12));
    const primaryActiveColor = new fast_color_es/* FastColor */.t(primaryColors[0]);
    variables['primary-color-active-deprecated-f-30'] = formatColor(primaryActiveColor, c => c.setA(c.a * 0.3));
    variables['primary-color-active-deprecated-d-02'] = formatColor(primaryActiveColor, c => c.darken(2));
  }
  // ================ Success Color ================
  if (theme.successColor) {
    fillColor(theme.successColor, 'success');
  }
  // ================ Warning Color ================
  if (theme.warningColor) {
    fillColor(theme.warningColor, 'warning');
  }
  // ================= Error Color =================
  if (theme.errorColor) {
    fillColor(theme.errorColor, 'error');
  }
  // ================= Info Color ==================
  if (theme.infoColor) {
    fillColor(theme.infoColor, 'info');
  }
  // Convert to css variables
  const cssList = Object.keys(variables).map(key => `--${globalPrefixCls}-${key}: ${variables[key]};`);
  return `
  :root {
    ${cssList.join('\n')}
  }
  `.trim();
}
function registerTheme(globalPrefixCls, theme) {
  const style = getStyle(globalPrefixCls, theme);
  if ((0,canUseDom/* default */.Z)()) {
    (0,dynamicCSS/* updateCSS */.hq)(style, `${dynamicStyleMark}-dynamic-theme`);
  } else {
     false ? 0 : void 0;
  }
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/config-provider/DisabledContext.js
"use client";


const DisabledContext = /*#__PURE__*/react.createContext(false);
const DisabledContextProvider = ({
  children,
  disabled
}) => {
  const originDisabled = react.useContext(DisabledContext);
  return /*#__PURE__*/react.createElement(DisabledContext.Provider, {
    value: disabled !== null && disabled !== void 0 ? disabled : originDisabled
  }, children);
};
/* harmony default export */ var config_provider_DisabledContext = (DisabledContext);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/config-provider/SizeContext.js
"use client";


const SizeContext = /*#__PURE__*/react.createContext(undefined);
const SizeContextProvider = ({
  children,
  size
}) => {
  const originSize = react.useContext(SizeContext);
  return /*#__PURE__*/react.createElement(SizeContext.Provider, {
    value: size || originSize
  }, children);
};
/* harmony default export */ var config_provider_SizeContext = (SizeContext);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/config-provider/hooks/useConfig.js



function useConfig() {
  const componentDisabled = (0,react.useContext)(config_provider_DisabledContext);
  const componentSize = (0,react.useContext)(config_provider_SizeContext);
  return {
    componentDisabled,
    componentSize
  };
}
/* harmony default export */ var hooks_useConfig = (useConfig);
// EXTERNAL MODULE: ./node_modules/rc-util/es/isEqual.js
var isEqual = __webpack_require__(55159);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/config-provider/hooks/useThemeKey.js

const fullClone = Object.assign({}, react_namespaceObject);
const {
  useId
} = fullClone;
const useEmptyId = () => '';
const useThemeKey = typeof useId === 'undefined' ? useEmptyId : useId;
/* harmony default export */ var hooks_useThemeKey = (useThemeKey);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/config-provider/hooks/useTheme.js





function useTheme(theme, parentTheme, config) {
  var _a, _b;
  const warning = warning_devUseWarning('ConfigProvider');
  const themeConfig = theme || {};
  const parentThemeConfig = themeConfig.inherit === false || !parentTheme ? Object.assign(Object.assign({}, defaultConfig), {
    hashed: (_a = parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.hashed) !== null && _a !== void 0 ? _a : defaultConfig.hashed,
    cssVar: parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.cssVar
  }) : parentTheme;
  const themeKey = hooks_useThemeKey();
  if (false) {}
  return (0,useMemo/* default */.Z)(() => {
    var _a, _b;
    if (!theme) {
      return parentTheme;
    }
    // Override
    const mergedComponents = Object.assign({}, parentThemeConfig.components);
    Object.keys(theme.components || {}).forEach(componentName => {
      mergedComponents[componentName] = Object.assign(Object.assign({}, mergedComponents[componentName]), theme.components[componentName]);
    });
    const cssVarKey = `css-var-${themeKey.replace(/:/g, '')}`;
    const mergedCssVar = ((_a = themeConfig.cssVar) !== null && _a !== void 0 ? _a : parentThemeConfig.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: config === null || config === void 0 ? void 0 : config.prefixCls
    }, typeof parentThemeConfig.cssVar === 'object' ? parentThemeConfig.cssVar : {}), typeof themeConfig.cssVar === 'object' ? themeConfig.cssVar : {}), {
      key: typeof themeConfig.cssVar === 'object' && ((_b = themeConfig.cssVar) === null || _b === void 0 ? void 0 : _b.key) || cssVarKey
    });
    // Base token
    return Object.assign(Object.assign(Object.assign({}, parentThemeConfig), themeConfig), {
      token: Object.assign(Object.assign({}, parentThemeConfig.token), themeConfig.token),
      components: mergedComponents,
      cssVar: mergedCssVar
    });
  }, [themeConfig, parentThemeConfig], (prev, next) => prev.some((prevTheme, index) => {
    const nextTheme = next[index];
    return !(0,isEqual/* default */.Z)(prevTheme, nextTheme, true);
  }));
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/config-provider/MotionWrapper.js
"use client";




const MotionCacheContext = /*#__PURE__*/react.createContext(true);
if (false) {}
function MotionWrapper(props) {
  const parentMotion = react.useContext(MotionCacheContext);
  const {
    children
  } = props;
  const [, token] = useToken();
  const {
    motion
  } = token;
  const needWrapMotionProviderRef = react.useRef(false);
  needWrapMotionProviderRef.current || (needWrapMotionProviderRef.current = parentMotion !== motion);
  if (needWrapMotionProviderRef.current) {
    return /*#__PURE__*/react.createElement(MotionCacheContext.Provider, {
      value: motion
    }, /*#__PURE__*/react.createElement(rc_motion_es/* Provider */.zt, {
      motion: motion
    }, children));
  }
  return children;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/config-provider/PropWarning.js
"use client";



/**
 * Warning for ConfigProviderProps.
 * This will be empty function in production.
 */
const PropWarning = /*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(({
  dropdownMatchSelectWidth
}) => {
  const warning = devUseWarning('ConfigProvider');
  warning.deprecated(dropdownMatchSelectWidth === undefined, 'dropdownMatchSelectWidth', 'popupMatchSelectWidth');
  return null;
})));
if (false) {}
/* harmony default export */ var config_provider_PropWarning = ( false ? 0 : () => null);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/util/useResetIconStyle.js



const useResetIconStyle = (iconPrefixCls, csp) => {
  const [theme, token] = useToken();
  // Generate style for icons
  return (0,cssinjs_es/* useStyleRegister */.xy)({
    theme,
    token,
    hashId: '',
    path: ['ant-design-icons', iconPrefixCls],
    nonce: () => csp === null || csp === void 0 ? void 0 : csp.nonce,
    layer: {
      name: 'antd'
    }
  }, () => genIconStyle(iconPrefixCls));
};
/* harmony default export */ var util_useResetIconStyle = (useResetIconStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/config-provider/index.js
"use client";

var config_provider_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






















/**
 * Since too many feedback using static method like `Modal.confirm` not getting theme, we record the
 * theme register info here to help developer get warning info.
 */
let existThemeConfig = false;
const warnContext = (/* unused pure expression or super */ null && ( false ? 0 : /* istanbul ignore next */
null));

const configConsumerProps = (/* unused pure expression or super */ null && (['getTargetContainer', 'getPopupContainer', 'rootPrefixCls', 'getPrefixCls', 'renderEmpty', 'csp', 'autoInsertSpaceInButton', 'locale']));
// These props is used by `useContext` directly in sub component
const PASSED_PROPS = ['getTargetContainer', 'getPopupContainer', 'renderEmpty', 'input', 'pagination', 'form', 'select', 'button'];
let globalPrefixCls;
let globalIconPrefixCls;
let globalTheme;
let globalHolderRender;
function getGlobalPrefixCls() {
  return globalPrefixCls || defaultPrefixCls;
}
function getGlobalIconPrefixCls() {
  return globalIconPrefixCls || defaultIconPrefixCls;
}
function isLegacyTheme(theme) {
  return Object.keys(theme).some(key => key.endsWith('Color'));
}
const setGlobalConfig = props => {
  const {
    prefixCls,
    iconPrefixCls,
    theme,
    holderRender
  } = props;
  if (prefixCls !== undefined) {
    globalPrefixCls = prefixCls;
  }
  if (iconPrefixCls !== undefined) {
    globalIconPrefixCls = iconPrefixCls;
  }
  if ('holderRender' in props) {
    globalHolderRender = holderRender;
  }
  if (theme) {
    if (isLegacyTheme(theme)) {
       false ? 0 : void 0;
      registerTheme(getGlobalPrefixCls(), theme);
    } else {
      globalTheme = theme;
    }
  }
};
const globalConfig = () => ({
  getPrefixCls: (suffixCls, customizePrefixCls) => {
    if (customizePrefixCls) {
      return customizePrefixCls;
    }
    return suffixCls ? `${getGlobalPrefixCls()}-${suffixCls}` : getGlobalPrefixCls();
  },
  getIconPrefixCls: getGlobalIconPrefixCls,
  getRootPrefixCls: () => {
    // If Global prefixCls provided, use this
    if (globalPrefixCls) {
      return globalPrefixCls;
    }
    // Fallback to default prefixCls
    return getGlobalPrefixCls();
  },
  getTheme: () => globalTheme,
  holderRender: globalHolderRender
});
const ProviderChildren = props => {
  const {
    children,
    csp: customCsp,
    autoInsertSpaceInButton,
    alert,
    anchor,
    form,
    locale,
    componentSize,
    direction,
    space,
    splitter,
    virtual,
    dropdownMatchSelectWidth,
    popupMatchSelectWidth,
    popupOverflow,
    legacyLocale,
    parentContext,
    iconPrefixCls: customIconPrefixCls,
    theme,
    componentDisabled,
    segmented,
    statistic,
    spin,
    calendar,
    carousel,
    cascader,
    collapse,
    typography,
    checkbox,
    descriptions,
    divider,
    drawer,
    skeleton,
    steps,
    image,
    layout,
    list,
    mentions,
    modal,
    progress,
    result,
    slider,
    breadcrumb,
    menu,
    pagination,
    input,
    textArea,
    empty,
    badge,
    radio,
    rate,
    switch: SWITCH,
    transfer,
    avatar,
    message,
    tag,
    table,
    card,
    tabs,
    timeline,
    timePicker,
    upload,
    notification,
    tree,
    colorPicker,
    datePicker,
    rangePicker,
    flex,
    wave,
    dropdown,
    warning: warningConfig,
    tour,
    tooltip,
    popover,
    popconfirm,
    floatButton,
    floatButtonGroup,
    variant,
    inputNumber,
    treeSelect
  } = props;
  // =================================== Context ===================================
  const getPrefixCls = react.useCallback((suffixCls, customizePrefixCls) => {
    const {
      prefixCls
    } = props;
    if (customizePrefixCls) {
      return customizePrefixCls;
    }
    const mergedPrefixCls = prefixCls || parentContext.getPrefixCls('');
    return suffixCls ? `${mergedPrefixCls}-${suffixCls}` : mergedPrefixCls;
  }, [parentContext.getPrefixCls, props.prefixCls]);
  const iconPrefixCls = customIconPrefixCls || parentContext.iconPrefixCls || defaultIconPrefixCls;
  const csp = customCsp || parentContext.csp;
  util_useResetIconStyle(iconPrefixCls, csp);
  const mergedTheme = useTheme(theme, parentContext.theme, {
    prefixCls: getPrefixCls('')
  });
  if (false) {}
  const baseConfig = {
    csp,
    autoInsertSpaceInButton,
    alert,
    anchor,
    locale: locale || legacyLocale,
    direction,
    space,
    splitter,
    virtual,
    popupMatchSelectWidth: popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth,
    popupOverflow,
    getPrefixCls,
    iconPrefixCls,
    theme: mergedTheme,
    segmented,
    statistic,
    spin,
    calendar,
    carousel,
    cascader,
    collapse,
    typography,
    checkbox,
    descriptions,
    divider,
    drawer,
    skeleton,
    steps,
    image,
    input,
    textArea,
    layout,
    list,
    mentions,
    modal,
    progress,
    result,
    slider,
    breadcrumb,
    menu,
    pagination,
    empty,
    badge,
    radio,
    rate,
    switch: SWITCH,
    transfer,
    avatar,
    message,
    tag,
    table,
    card,
    tabs,
    timeline,
    timePicker,
    upload,
    notification,
    tree,
    colorPicker,
    datePicker,
    rangePicker,
    flex,
    wave,
    dropdown,
    warning: warningConfig,
    tour,
    tooltip,
    popover,
    popconfirm,
    floatButton,
    floatButtonGroup,
    variant,
    inputNumber,
    treeSelect
  };
  if (false) {}
  const config = Object.assign({}, parentContext);
  Object.keys(baseConfig).forEach(key => {
    if (baseConfig[key] !== undefined) {
      config[key] = baseConfig[key];
    }
  });
  // Pass the props used by `useContext` directly with child component.
  // These props should merged into `config`.
  PASSED_PROPS.forEach(propName => {
    const propValue = props[propName];
    if (propValue) {
      config[propName] = propValue;
    }
  });
  if (typeof autoInsertSpaceInButton !== 'undefined') {
    // merge deprecated api
    config.button = Object.assign({
      autoInsertSpace: autoInsertSpaceInButton
    }, config.button);
  }
  // https://github.com/ant-design/ant-design/issues/27617
  const memoedConfig = (0,useMemo/* default */.Z)(() => config, config, (prevConfig, currentConfig) => {
    const prevKeys = Object.keys(prevConfig);
    const currentKeys = Object.keys(currentConfig);
    return prevKeys.length !== currentKeys.length || prevKeys.some(key => prevConfig[key] !== currentConfig[key]);
  });
  const {
    layer
  } = react.useContext(cssinjs_es/* StyleContext */.uP);
  const memoIconContextValue = react.useMemo(() => ({
    prefixCls: iconPrefixCls,
    csp,
    layer: layer ? 'antd' : undefined
  }), [iconPrefixCls, csp, layer]);
  let childNode = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(config_provider_PropWarning, {
    dropdownMatchSelectWidth: dropdownMatchSelectWidth
  }), children);
  const validateMessages = react.useMemo(() => {
    var _a, _b, _c, _d;
    return (0,set/* merge */.T)(((_a = es_locale_en_US.Form) === null || _a === void 0 ? void 0 : _a.defaultValidateMessages) || {}, ((_c = (_b = memoedConfig.locale) === null || _b === void 0 ? void 0 : _b.Form) === null || _c === void 0 ? void 0 : _c.defaultValidateMessages) || {}, ((_d = memoedConfig.form) === null || _d === void 0 ? void 0 : _d.validateMessages) || {}, (form === null || form === void 0 ? void 0 : form.validateMessages) || {});
  }, [memoedConfig, form === null || form === void 0 ? void 0 : form.validateMessages]);
  if (Object.keys(validateMessages).length > 0) {
    childNode = /*#__PURE__*/react.createElement(validateMessagesContext.Provider, {
      value: validateMessages
    }, childNode);
  }
  if (locale) {
    childNode = /*#__PURE__*/react.createElement(es_locale, {
      locale: locale,
      _ANT_MARK__: ANT_MARK
    }, childNode);
  }
  if (iconPrefixCls || csp) {
    childNode = /*#__PURE__*/react.createElement(Context/* default.Provider */.Z.Provider, {
      value: memoIconContextValue
    }, childNode);
  }
  if (componentSize) {
    childNode = /*#__PURE__*/react.createElement(SizeContextProvider, {
      size: componentSize
    }, childNode);
  }
  // =================================== Motion ===================================
  childNode = /*#__PURE__*/react.createElement(MotionWrapper, null, childNode);
  // ================================ Dynamic theme ================================
  const memoTheme = react.useMemo(() => {
    const _a = mergedTheme || {},
      {
        algorithm,
        token,
        components,
        cssVar
      } = _a,
      rest = config_provider_rest(_a, ["algorithm", "token", "components", "cssVar"]);
    const themeObj = algorithm && (!Array.isArray(algorithm) || algorithm.length > 0) ? (0,cssinjs_es/* createTheme */.jG)(algorithm) : default_theme;
    const parsedComponents = {};
    Object.entries(components || {}).forEach(([componentName, componentToken]) => {
      const parsedToken = Object.assign({}, componentToken);
      if ('algorithm' in parsedToken) {
        if (parsedToken.algorithm === true) {
          parsedToken.theme = themeObj;
        } else if (Array.isArray(parsedToken.algorithm) || typeof parsedToken.algorithm === 'function') {
          parsedToken.theme = (0,cssinjs_es/* createTheme */.jG)(parsedToken.algorithm);
        }
        delete parsedToken.algorithm;
      }
      parsedComponents[componentName] = parsedToken;
    });
    const mergedToken = Object.assign(Object.assign({}, seed), token);
    return Object.assign(Object.assign({}, rest), {
      theme: themeObj,
      token: mergedToken,
      components: parsedComponents,
      override: Object.assign({
        override: mergedToken
      }, parsedComponents),
      cssVar: cssVar
    });
  }, [mergedTheme]);
  if (theme) {
    childNode = /*#__PURE__*/react.createElement(DesignTokenContext.Provider, {
      value: memoTheme
    }, childNode);
  }
  // ================================== Warning ===================================
  if (memoedConfig.warning) {
    childNode = /*#__PURE__*/react.createElement(WarningContext.Provider, {
      value: memoedConfig.warning
    }, childNode);
  }
  // =================================== Render ===================================
  if (componentDisabled !== undefined) {
    childNode = /*#__PURE__*/react.createElement(DisabledContextProvider, {
      disabled: componentDisabled
    }, childNode);
  }
  return /*#__PURE__*/react.createElement(ConfigContext.Provider, {
    value: memoedConfig
  }, childNode);
};
const ConfigProvider = props => {
  const context = react.useContext(ConfigContext);
  const antLocale = react.useContext(locale_context);
  return /*#__PURE__*/react.createElement(ProviderChildren, Object.assign({
    parentContext: context,
    legacyLocale: antLocale
  }, props));
};
ConfigProvider.ConfigContext = ConfigContext;
ConfigProvider.SizeContext = config_provider_SizeContext;
ConfigProvider.config = setGlobalConfig;
ConfigProvider.useConfig = hooks_useConfig;
Object.defineProperty(ConfigProvider, 'SizeContext', {
  get: () => {
     false ? 0 : void 0;
    return config_provider_SizeContext;
  }
});
if (false) {}
/* harmony default export */ var config_provider = (ConfigProvider);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(85202);
// EXTERNAL MODULE: ./node_modules/rc-util/es/React/render.js
var render = __webpack_require__(52010);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/config-provider/UnstableContext.js
"use client";





const defaultReactRender = (node, container) => {
  // TODO: Remove in v6
  // Warning for React 19
  if (false) {}
  (0,render/* render */.s)(node, container);
  return () => {
    return (0,render/* unmount */.v)(container);
  };
};
let unstableRender = defaultReactRender;
/**
 * @deprecated Set React render function for compatible usage.
 * This is internal usage only compatible with React 19.
 * And will be removed in next major version.
 */
function unstableSetRender(render) {
  if (render) {
    unstableRender = render;
  }
  return unstableRender;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/motion.js

// ================== Collapse Motion ==================
const getCollapsedHeight = () => ({
  height: 0,
  opacity: 0
});
const getRealHeight = node => {
  const {
    scrollHeight
  } = node;
  return {
    height: scrollHeight,
    opacity: 1
  };
};
const getCurrentHeight = node => ({
  height: node ? node.offsetHeight : 0
});
const skipOpacityTransition = (_, event) => (event === null || event === void 0 ? void 0 : event.deadline) === true || event.propertyName === 'height';
const initCollapseMotion = (rootCls = defaultPrefixCls) => ({
  motionName: `${rootCls}-motion-collapse`,
  onAppearStart: getCollapsedHeight,
  onEnterStart: getCollapsedHeight,
  onAppearActive: getRealHeight,
  onEnterActive: getRealHeight,
  onLeaveStart: getCurrentHeight,
  onLeaveActive: getCollapsedHeight,
  onAppearEnd: skipOpacityTransition,
  onEnterEnd: skipOpacityTransition,
  onLeaveEnd: skipOpacityTransition,
  motionDeadline: 500
});
const _SelectPlacements = (/* unused pure expression or super */ null && (['bottomLeft', 'bottomRight', 'topLeft', 'topRight']));
const getTransitionName = (rootPrefixCls, motion, transitionName) => {
  if (transitionName !== undefined) {
    return transitionName;
  }
  return `${rootPrefixCls}-${motion}`;
};

/* harmony default export */ var _util_motion = (initCollapseMotion);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/locale/useLocale.js



const useLocale = (componentName, defaultLocale) => {
  const fullLocale = react.useContext(locale_context);
  const getLocale = react.useMemo(() => {
    var _a;
    const locale = defaultLocale || es_locale_en_US[componentName];
    const localeFromContext = (_a = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale[componentName]) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
  }, [componentName, defaultLocale, fullLocale]);
  const getLocaleCode = react.useMemo(() => {
    const localeCode = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.locale;
    // Had use LocaleProvide but didn't set locale
    if ((fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.exist) && !localeCode) {
      return es_locale_en_US.locale;
    }
    return localeCode;
  }, [fullLocale]);
  return [getLocale, getLocaleCode];
};
/* harmony default export */ var locale_useLocale = (useLocale);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useState.js
var useState = __webpack_require__(63345);
// EXTERNAL MODULE: ./node_modules/rc-util/es/omit.js
var omit = __webpack_require__(85401);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useLayoutEffect.js
var hooks_useLayoutEffect = __webpack_require__(76963);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/isVisible.js
var isVisible = __webpack_require__(29504);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/wave/style.js

const genWaveStyle = token => {
  const {
    componentCls,
    colorPrimary
  } = token;
  return {
    [componentCls]: {
      position: 'absolute',
      background: 'transparent',
      pointerEvents: 'none',
      boxSizing: 'border-box',
      color: `var(--wave-color, ${colorPrimary})`,
      boxShadow: `0 0 0 0 currentcolor`,
      opacity: 0.2,
      // =================== Motion ===================
      '&.wave-motion-appear': {
        transition: [`box-shadow 0.4s ${token.motionEaseOutCirc}`, `opacity 2s ${token.motionEaseOutCirc}`].join(','),
        '&-active': {
          boxShadow: `0 0 0 6px currentcolor`,
          opacity: 0
        },
        '&.wave-quick': {
          transition: [`box-shadow ${token.motionDurationSlow} ${token.motionEaseInOut}`, `opacity ${token.motionDurationSlow} ${token.motionEaseInOut}`].join(',')
        }
      }
    }
  };
};
/* harmony default export */ var wave_style = (genComponentStyleHook('Wave', genWaveStyle));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/wave/interface.js

const TARGET_CLS = `${defaultPrefixCls}-wave-target`;
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/wave/util.js
function isValidWaveColor(color) {
  return color && color !== '#fff' && color !== '#ffffff' && color !== 'rgb(255, 255, 255)' && color !== 'rgba(255, 255, 255, 1)' && !/rgba\((?:\d*, ){3}0\)/.test(color) &&
  // any transparent rgba color
  color !== 'transparent' && color !== 'canvastext';
}
function getTargetWaveColor(node) {
  var _a;
  const {
    borderTopColor,
    borderColor,
    backgroundColor
  } = getComputedStyle(node);
  return (_a = [borderTopColor, borderColor, backgroundColor].find(isValidWaveColor)) !== null && _a !== void 0 ? _a : null;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/wave/WaveEffect.js
"use client";









function validateNum(value) {
  return Number.isNaN(value) ? 0 : value;
}
const WaveEffect = props => {
  const {
    className,
    target,
    component,
    registerUnmount
  } = props;
  const divRef = react.useRef(null);
  // ====================== Refs ======================
  const unmountRef = react.useRef(null);
  react.useEffect(() => {
    unmountRef.current = registerUnmount();
  }, []);
  // ===================== Effect =====================
  const [color, setWaveColor] = react.useState(null);
  const [borderRadius, setBorderRadius] = react.useState([]);
  const [left, setLeft] = react.useState(0);
  const [top, setTop] = react.useState(0);
  const [width, setWidth] = react.useState(0);
  const [height, setHeight] = react.useState(0);
  const [enabled, setEnabled] = react.useState(false);
  const waveStyle = {
    left,
    top,
    width,
    height,
    borderRadius: borderRadius.map(radius => `${radius}px`).join(' ')
  };
  if (color) {
    waveStyle['--wave-color'] = color;
  }
  function syncPos() {
    const nodeStyle = getComputedStyle(target);
    // Get wave color from target
    setWaveColor(getTargetWaveColor(target));
    const isStatic = nodeStyle.position === 'static';
    // Rect
    const {
      borderLeftWidth,
      borderTopWidth
    } = nodeStyle;
    setLeft(isStatic ? target.offsetLeft : validateNum(-parseFloat(borderLeftWidth)));
    setTop(isStatic ? target.offsetTop : validateNum(-parseFloat(borderTopWidth)));
    setWidth(target.offsetWidth);
    setHeight(target.offsetHeight);
    // Get border radius
    const {
      borderTopLeftRadius,
      borderTopRightRadius,
      borderBottomLeftRadius,
      borderBottomRightRadius
    } = nodeStyle;
    setBorderRadius([borderTopLeftRadius, borderTopRightRadius, borderBottomRightRadius, borderBottomLeftRadius].map(radius => validateNum(parseFloat(radius))));
  }
  react.useEffect(() => {
    if (target) {
      // We need delay to check position here
      // since UI may change after click
      const id = (0,raf/* default */.Z)(() => {
        syncPos();
        setEnabled(true);
      });
      // Add resize observer to follow size
      let resizeObserver;
      if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(syncPos);
        resizeObserver.observe(target);
      }
      return () => {
        raf/* default.cancel */.Z.cancel(id);
        resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.disconnect();
      };
    }
  }, []);
  if (!enabled) {
    return null;
  }
  const isSmallComponent = (component === 'Checkbox' || component === 'Radio') && (target === null || target === void 0 ? void 0 : target.classList.contains(TARGET_CLS));
  return /*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, {
    visible: true,
    motionAppear: true,
    motionName: "wave-motion",
    motionDeadline: 5000,
    onAppearEnd: (_, event) => {
      var _a, _b;
      if (event.deadline || event.propertyName === 'opacity') {
        const holder = (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
        (_b = unmountRef.current) === null || _b === void 0 ? void 0 : _b.call(unmountRef).then(() => {
          holder === null || holder === void 0 ? void 0 : holder.remove();
        });
      }
      return false;
    }
  }, ({
    className: motionClassName
  }, ref) => (/*#__PURE__*/react.createElement("div", {
    ref: (0,es_ref/* composeRef */.sQ)(divRef, ref),
    className: classnames_default()(className, motionClassName, {
      'wave-quick': isSmallComponent
    }),
    style: waveStyle
  })));
};
const showWaveEffect = (target, info) => {
  var _a;
  const {
    component
  } = info;
  // Skip for unchecked checkbox
  if (component === 'Checkbox' && !((_a = target.querySelector('input')) === null || _a === void 0 ? void 0 : _a.checked)) {
    return;
  }
  // Create holder
  const holder = document.createElement('div');
  holder.style.position = 'absolute';
  holder.style.left = '0px';
  holder.style.top = '0px';
  target === null || target === void 0 ? void 0 : target.insertBefore(holder, target === null || target === void 0 ? void 0 : target.firstChild);
  const reactRender = unstableSetRender();
  let unmountCallback = null;
  function registerUnmount() {
    return unmountCallback;
  }
  unmountCallback = reactRender(/*#__PURE__*/react.createElement(WaveEffect, Object.assign({}, info, {
    target: target,
    registerUnmount: registerUnmount
  })), holder);
};
/* harmony default export */ var wave_WaveEffect = (showWaveEffect);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/wave/useWave.js







const useWave = (nodeRef, className, component) => {
  const {
    wave
  } = react.useContext(ConfigContext);
  const [, token, hashId] = useToken();
  const showWave = (0,hooks_useEvent/* default */.Z)(event => {
    const node = nodeRef.current;
    if ((wave === null || wave === void 0 ? void 0 : wave.disabled) || !node) {
      return;
    }
    const targetNode = node.querySelector(`.${TARGET_CLS}`) || node;
    const {
      showEffect
    } = wave || {};
    // Customize wave effect
    (showEffect || wave_WaveEffect)(targetNode, {
      className,
      token,
      component,
      event,
      hashId
    });
  });
  const rafId = react.useRef(null);
  // Merge trigger event into one for each frame
  const showDebounceWave = event => {
    raf/* default.cancel */.Z.cancel(rafId.current);
    rafId.current = (0,raf/* default */.Z)(() => {
      showWave(event);
    });
  };
  return showDebounceWave;
};
/* harmony default export */ var wave_useWave = (useWave);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/wave/index.js








const Wave = props => {
  const {
    children,
    disabled,
    component
  } = props;
  const {
    getPrefixCls
  } = (0,react.useContext)(ConfigContext);
  const containerRef = (0,react.useRef)(null);
  // ============================== Style ===============================
  const prefixCls = getPrefixCls('wave');
  const [, hashId] = wave_style(prefixCls);
  // =============================== Wave ===============================
  const showWave = wave_useWave(containerRef, classnames_default()(prefixCls, hashId), component);
  // ============================== Effect ==============================
  react.useEffect(() => {
    const node = containerRef.current;
    if (!node || node.nodeType !== 1 || disabled) {
      return;
    }
    // Click handler
    const onClick = e => {
      // Fix radio button click twice
      if (!(0,isVisible/* default */.Z)(e.target) ||
      // No need wave
      !node.getAttribute || node.getAttribute('disabled') || node.disabled || node.className.includes('disabled') || node.className.includes('-leave')) {
        return;
      }
      showWave(e);
    };
    // Bind events
    node.addEventListener('click', onClick, true);
    return () => {
      node.removeEventListener('click', onClick, true);
    };
  }, [disabled]);
  // ============================== Render ==============================
  if (! /*#__PURE__*/react.isValidElement(children)) {
    return children !== null && children !== void 0 ? children : null;
  }
  const ref = (0,es_ref/* supportRef */.Yr)(children) ? (0,es_ref/* composeRef */.sQ)((0,es_ref/* getNodeRef */.C4)(children), containerRef) : containerRef;
  return cloneElement(children, {
    ref
  });
};
if (false) {}
/* harmony default export */ var wave = (Wave);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/config-provider/hooks/useSize.js


const useSize = customSize => {
  const size = react.useContext(config_provider_SizeContext);
  const mergedSize = react.useMemo(() => {
    if (!customSize) {
      return size;
    }
    if (typeof customSize === 'string') {
      return customSize !== null && customSize !== void 0 ? customSize : size;
    }
    if (typeof customSize === 'function') {
      return customSize(size);
    }
    return size;
  }, [customSize, size]);
  return mergedSize;
};
/* harmony default export */ var hooks_useSize = (useSize);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Children/toArray.js
var Children_toArray = __webpack_require__(93550);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/space/style/compact.js
const genSpaceCompactStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [componentCls]: {
      '&-block': {
        display: 'flex',
        width: '100%'
      },
      '&-vertical': {
        flexDirection: 'column'
      }
    }
  };
};
// ============================== Export ==============================
/* harmony default export */ var compact = (genSpaceCompactStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/space/style/index.js


const genSpaceStyle = token => {
  const {
    componentCls,
    antCls
  } = token;
  return {
    [componentCls]: {
      display: 'inline-flex',
      '&-rtl': {
        direction: 'rtl'
      },
      '&-vertical': {
        flexDirection: 'column'
      },
      '&-align': {
        flexDirection: 'column',
        '&-center': {
          alignItems: 'center'
        },
        '&-start': {
          alignItems: 'flex-start'
        },
        '&-end': {
          alignItems: 'flex-end'
        },
        '&-baseline': {
          alignItems: 'baseline'
        }
      },
      [`${componentCls}-item:empty`]: {
        display: 'none'
      },
      // https://github.com/ant-design/ant-design/issues/47875
      [`${componentCls}-item > ${antCls}-badge-not-a-wrapper:only-child`]: {
        display: 'block'
      }
    }
  };
};
const genSpaceGapStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [componentCls]: {
      '&-gap-row-small': {
        rowGap: token.spaceGapSmallSize
      },
      '&-gap-row-middle': {
        rowGap: token.spaceGapMiddleSize
      },
      '&-gap-row-large': {
        rowGap: token.spaceGapLargeSize
      },
      '&-gap-col-small': {
        columnGap: token.spaceGapSmallSize
      },
      '&-gap-col-middle': {
        columnGap: token.spaceGapMiddleSize
      },
      '&-gap-col-large': {
        columnGap: token.spaceGapLargeSize
      }
    }
  };
};
// ============================== Export ==============================
const space_style_prepareComponentToken = () => ({});
/* harmony default export */ var space_style = (genStyleHooks('Space', token => {
  const spaceToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    spaceGapSmallSize: token.paddingXS,
    spaceGapMiddleSize: token.padding,
    spaceGapLargeSize: token.paddingLG
  });
  return [genSpaceStyle(spaceToken), genSpaceGapStyle(spaceToken), compact(spaceToken)];
}, () => ({}), {
  // Space component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/40315
  resetStyle: false
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/space/Compact.js
"use client";

var Compact_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






const SpaceCompactItemContext = /*#__PURE__*/react.createContext(null);
const useCompactItemContext = (prefixCls, direction) => {
  const compactItemContext = react.useContext(SpaceCompactItemContext);
  const compactItemClassnames = react.useMemo(() => {
    if (!compactItemContext) {
      return '';
    }
    const {
      compactDirection,
      isFirstItem,
      isLastItem
    } = compactItemContext;
    const separator = compactDirection === 'vertical' ? '-vertical-' : '-';
    return classnames_default()(`${prefixCls}-compact${separator}item`, {
      [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
      [`${prefixCls}-compact${separator}last-item`]: isLastItem,
      [`${prefixCls}-compact${separator}item-rtl`]: direction === 'rtl'
    });
  }, [prefixCls, direction, compactItemContext]);
  return {
    compactSize: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactSize,
    compactDirection: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactDirection,
    compactItemClassnames
  };
};
const NoCompactStyle = props => {
  const {
    children
  } = props;
  return /*#__PURE__*/react.createElement(SpaceCompactItemContext.Provider, {
    value: null
  }, children);
};
const CompactItem = props => {
  const {
      children
    } = props,
    others = Compact_rest(props, ["children"]);
  return /*#__PURE__*/react.createElement(SpaceCompactItemContext.Provider, {
    value: react.useMemo(() => others, [others])
  }, children);
};
const Compact = props => {
  const {
    getPrefixCls,
    direction: directionConfig
  } = react.useContext(ConfigContext);
  const {
      size,
      direction,
      block,
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      children
    } = props,
    restProps = Compact_rest(props, ["size", "direction", "block", "prefixCls", "className", "rootClassName", "children"]);
  const mergedSize = hooks_useSize(ctx => size !== null && size !== void 0 ? size : ctx);
  const prefixCls = getPrefixCls('space-compact', customizePrefixCls);
  const [wrapCSSVar, hashId] = space_style(prefixCls);
  const clx = classnames_default()(prefixCls, hashId, {
    [`${prefixCls}-rtl`]: directionConfig === 'rtl',
    [`${prefixCls}-block`]: block,
    [`${prefixCls}-vertical`]: direction === 'vertical'
  }, className, rootClassName);
  const compactItemContext = react.useContext(SpaceCompactItemContext);
  const childNodes = (0,Children_toArray/* default */.Z)(children);
  const nodes = react.useMemo(() => childNodes.map((child, i) => {
    const key = (child === null || child === void 0 ? void 0 : child.key) || `${prefixCls}-item-${i}`;
    return /*#__PURE__*/react.createElement(CompactItem, {
      key: key,
      compactSize: mergedSize,
      compactDirection: direction,
      isFirstItem: i === 0 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isFirstItem)),
      isLastItem: i === childNodes.length - 1 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isLastItem))
    }, child);
  }), [size, childNodes, compactItemContext]);
  // =========================== Render ===========================
  if (childNodes.length === 0) {
    return null;
  }
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", Object.assign({
    className: clx
  }, restProps), nodes));
};
/* harmony default export */ var space_Compact = (Compact);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/button/button-group.js
"use client";

var button_group_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





const GroupSizeContext = /*#__PURE__*/react.createContext(undefined);
const ButtonGroup = props => {
  const {
    getPrefixCls,
    direction
  } = react.useContext(ConfigContext);
  const {
      prefixCls: customizePrefixCls,
      size,
      className
    } = props,
    others = button_group_rest(props, ["prefixCls", "size", "className"]);
  const prefixCls = getPrefixCls('btn-group', customizePrefixCls);
  const [,, hashId] = useToken();
  const sizeCls = react.useMemo(() => {
    switch (size) {
      case 'large':
        return 'lg';
      case 'small':
        return 'sm';
      default:
        return '';
    }
  }, [size]);
  if (false) {}
  const classes = classnames_default()(prefixCls, {
    [`${prefixCls}-${sizeCls}`]: sizeCls,
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, className, hashId);
  return /*#__PURE__*/react.createElement(GroupSizeContext.Provider, {
    value: size
  }, /*#__PURE__*/react.createElement("div", Object.assign({}, others, {
    className: classes
  })));
};
/* harmony default export */ var button_group = (ButtonGroup);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/interface/presetColors.js
const PresetColors = ['blue', 'purple', 'cyan', 'green', 'magenta', 'pink', 'red', 'orange', 'yellow', 'volcano', 'geekblue', 'lime', 'gold'];
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/button/buttonHelpers.js
"use client";





const rxTwoCNChar = /^[\u4E00-\u9FA5]{2}$/;
const isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function convertLegacyProps(type) {
  if (type === 'danger') {
    return {
      danger: true
    };
  }
  return {
    type
  };
}
function isString(str) {
  return typeof str === 'string';
}
function isUnBorderedButtonVariant(type) {
  return type === 'text' || type === 'link';
}
function splitCNCharsBySpace(child, needInserted) {
  if (child === null || child === undefined) {
    return;
  }
  const SPACE = needInserted ? ' ' : '';
  if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
    return cloneElement(child, {
      children: child.props.children.split('').join(SPACE)
    });
  }
  if (isString(child)) {
    return isTwoCNChar(child) ? /*#__PURE__*/react.createElement("span", null, child.split('').join(SPACE)) : /*#__PURE__*/react.createElement("span", null, child);
  }
  if (isFragment(child)) {
    return /*#__PURE__*/react.createElement("span", null, child);
  }
  return child;
}
function spaceChildren(children, needInserted) {
  let isPrevChildPure = false;
  const childList = [];
  react.Children.forEach(children, child => {
    const type = typeof child;
    const isCurrentChildPure = type === 'string' || type === 'number';
    if (isPrevChildPure && isCurrentChildPure) {
      const lastIndex = childList.length - 1;
      const lastChild = childList[lastIndex];
      childList[lastIndex] = `${lastChild}${child}`;
    } else {
      childList.push(child);
    }
    isPrevChildPure = isCurrentChildPure;
  });
  return react.Children.map(childList, child => splitCNCharsBySpace(child, needInserted));
}
const _ButtonTypes = (/* unused pure expression or super */ null && (['default', 'primary', 'dashed', 'link', 'text']));
const _ButtonShapes = (/* unused pure expression or super */ null && (['default', 'circle', 'round']));
const _ButtonHTMLTypes = (/* unused pure expression or super */ null && (['submit', 'button', 'reset']));
const _ButtonVariantTypes = (/* unused pure expression or super */ null && (['outlined', 'dashed', 'solid', 'filled', 'text', 'link']));
const _ButtonColorTypes = ['default', 'primary', 'danger'].concat((0,toConsumableArray/* default */.Z)(PresetColors));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/button/IconWrapper.js
"use client";



const IconWrapper = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  const {
    className,
    style,
    children,
    prefixCls
  } = props;
  const iconWrapperCls = classnames_default()(`${prefixCls}-icon`, className);
  return /*#__PURE__*/react.createElement("span", {
    ref: ref,
    className: iconWrapperCls,
    style: style
  }, children);
});
/* harmony default export */ var button_IconWrapper = (IconWrapper);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/button/DefaultLoadingIcon.js
"use client";






const InnerLoadingIcon = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  const {
    prefixCls,
    className,
    style,
    iconClassName
  } = props;
  const mergedIconCls = classnames_default()(`${prefixCls}-loading-icon`, className);
  return /*#__PURE__*/react.createElement(button_IconWrapper, {
    prefixCls: prefixCls,
    className: mergedIconCls,
    style: style,
    ref: ref
  }, /*#__PURE__*/react.createElement(LoadingOutlined/* default */.Z, {
    className: iconClassName
  }));
});
const getCollapsedWidth = () => ({
  width: 0,
  opacity: 0,
  transform: 'scale(0)'
});
const getRealWidth = node => ({
  width: node.scrollWidth,
  opacity: 1,
  transform: 'scale(1)'
});
const DefaultLoadingIcon = props => {
  const {
    prefixCls,
    loading,
    existIcon,
    className,
    style,
    mount
  } = props;
  const visible = !!loading;
  if (existIcon) {
    return /*#__PURE__*/react.createElement(InnerLoadingIcon, {
      prefixCls: prefixCls,
      className: className,
      style: style
    });
  }
  return /*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, {
    visible: visible,
    // Used for minus flex gap style only
    motionName: `${prefixCls}-loading-icon-motion`,
    motionAppear: !mount,
    motionEnter: !mount,
    motionLeave: !mount,
    removeOnLeave: true,
    onAppearStart: getCollapsedWidth,
    onAppearActive: getRealWidth,
    onEnterStart: getCollapsedWidth,
    onEnterActive: getRealWidth,
    onLeaveStart: getRealWidth,
    onLeaveActive: getCollapsedWidth
  }, ({
    className: motionCls,
    style: motionStyle
  }, ref) => {
    const mergedStyle = Object.assign(Object.assign({}, style), motionStyle);
    return /*#__PURE__*/react.createElement(InnerLoadingIcon, {
      prefixCls: prefixCls,
      className: classnames_default()(className, motionCls),
      style: mergedStyle,
      ref: ref
    });
  });
};
/* harmony default export */ var button_DefaultLoadingIcon = (DefaultLoadingIcon);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/button/style/group.js
const genButtonBorderStyle = (buttonTypeCls, borderColor) => ({
  // Border
  [`> span, > ${buttonTypeCls}`]: {
    '&:not(:last-child)': {
      [`&, & > ${buttonTypeCls}`]: {
        '&:not(:disabled)': {
          borderInlineEndColor: borderColor
        }
      }
    },
    '&:not(:first-child)': {
      [`&, & > ${buttonTypeCls}`]: {
        '&:not(:disabled)': {
          borderInlineStartColor: borderColor
        }
      }
    }
  }
});
const genGroupStyle = token => {
  const {
    componentCls,
    fontSize,
    lineWidth,
    groupBorderColor,
    colorErrorHover
  } = token;
  return {
    [`${componentCls}-group`]: [{
      position: 'relative',
      display: 'inline-flex',
      // Border
      [`> span, > ${componentCls}`]: {
        '&:not(:last-child)': {
          [`&, & > ${componentCls}`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        '&:not(:first-child)': {
          marginInlineStart: token.calc(lineWidth).mul(-1).equal(),
          [`&, & > ${componentCls}`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        }
      },
      [componentCls]: {
        position: 'relative',
        zIndex: 1,
        '&:hover, &:focus, &:active': {
          zIndex: 2
        },
        '&[disabled]': {
          zIndex: 0
        }
      },
      [`${componentCls}-icon-only`]: {
        fontSize
      }
    },
    // Border Color
    genButtonBorderStyle(`${componentCls}-primary`, groupBorderColor), genButtonBorderStyle(`${componentCls}-danger`, colorErrorHover)]
  };
};
/* harmony default export */ var group = (genGroupStyle);
// EXTERNAL MODULE: ./node_modules/@rc-component/color-picker/es/index.js + 13 modules
var color_picker_es = __webpack_require__(3434);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/color.js



const toHexFormat = (value, alpha) => (value === null || value === void 0 ? void 0 : value.replace(/[^\w/]/g, '').slice(0, alpha ? 8 : 6)) || '';
const getHex = (value, alpha) => value ? toHexFormat(value, alpha) : '';
let AggregationColor = /*#__PURE__*/function () {
  function AggregationColor(color) {
    (0,classCallCheck/* default */.Z)(this, AggregationColor);
    var _a;
    this.cleared = false;
    // Clone from another AggregationColor
    if (color instanceof AggregationColor) {
      this.metaColor = color.metaColor.clone();
      this.colors = (_a = color.colors) === null || _a === void 0 ? void 0 : _a.map(info => ({
        color: new AggregationColor(info.color),
        percent: info.percent
      }));
      this.cleared = color.cleared;
      return;
    }
    const isArray = Array.isArray(color);
    if (isArray && color.length) {
      this.colors = color.map(({
        color: c,
        percent
      }) => ({
        color: new AggregationColor(c),
        percent
      }));
      this.metaColor = new color_picker_es/* Color */.Il(this.colors[0].color.metaColor);
    } else {
      this.metaColor = new color_picker_es/* Color */.Il(isArray ? '' : color);
    }
    if (!color || isArray && !this.colors) {
      this.metaColor = this.metaColor.setA(0);
      this.cleared = true;
    }
  }
  return (0,createClass/* default */.Z)(AggregationColor, [{
    key: "toHsb",
    value: function toHsb() {
      return this.metaColor.toHsb();
    }
  }, {
    key: "toHsbString",
    value: function toHsbString() {
      return this.metaColor.toHsbString();
    }
  }, {
    key: "toHex",
    value: function toHex() {
      return getHex(this.toHexString(), this.metaColor.a < 1);
    }
  }, {
    key: "toHexString",
    value: function toHexString() {
      return this.metaColor.toHexString();
    }
  }, {
    key: "toRgb",
    value: function toRgb() {
      return this.metaColor.toRgb();
    }
  }, {
    key: "toRgbString",
    value: function toRgbString() {
      return this.metaColor.toRgbString();
    }
  }, {
    key: "isGradient",
    value: function isGradient() {
      return !!this.colors && !this.cleared;
    }
  }, {
    key: "getColors",
    value: function getColors() {
      return this.colors || [{
        color: this,
        percent: 0
      }];
    }
  }, {
    key: "toCssString",
    value: function toCssString() {
      const {
        colors
      } = this;
      // CSS line-gradient
      if (colors) {
        const colorsStr = colors.map(c => `${c.color.toRgbString()} ${c.percent}%`).join(', ');
        return `linear-gradient(90deg, ${colorsStr})`;
      }
      return this.metaColor.toRgbString();
    }
  }, {
    key: "equals",
    value: function equals(color) {
      if (!color || this.isGradient() !== color.isGradient()) {
        return false;
      }
      if (!this.isGradient()) {
        return this.toHexString() === color.toHexString();
      }
      return this.colors.length === color.colors.length && this.colors.every((c, i) => {
        const target = color.colors[i];
        return c.percent === target.percent && c.color.equals(target.color);
      });
    }
  }]);
}();
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMergedState.js
var useMergedState = __webpack_require__(78877);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/RightOutlined.js + 1 modules
var RightOutlined = __webpack_require__(95092);
// EXTERNAL MODULE: ./node_modules/rc-collapse/es/index.js + 4 modules
var rc_collapse_es = __webpack_require__(61957);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/collapse/CollapsePanel.js
"use client";






const CollapsePanel = /*#__PURE__*/react.forwardRef((props, ref) => {
  if (false) {}
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const {
    prefixCls: customizePrefixCls,
    className,
    showArrow = true
  } = props;
  const prefixCls = getPrefixCls('collapse', customizePrefixCls);
  const collapsePanelClassName = classnames_default()({
    [`${prefixCls}-no-arrow`]: !showArrow
  }, className);
  return /*#__PURE__*/react.createElement(rc_collapse_es/* default.Panel */.Z.Panel, Object.assign({
    ref: ref
  }, props, {
    prefixCls: prefixCls,
    className: collapsePanelClassName
  }));
});
/* harmony default export */ var collapse_CollapsePanel = (CollapsePanel);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/style/motion/collapse.js
const genCollapseMotion = token => ({
  [token.componentCls]: {
    // For common/openAnimation
    [`${token.antCls}-motion-collapse-legacy`]: {
      overflow: 'hidden',
      '&-active': {
        transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
      }
    },
    [`${token.antCls}-motion-collapse`]: {
      overflow: 'hidden',
      transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
    }
  }
});
/* harmony default export */ var collapse = (genCollapseMotion);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/collapse/style/index.js




const style_genBaseStyle = token => {
  const {
    componentCls,
    contentBg,
    padding,
    headerBg,
    headerPadding,
    collapseHeaderPaddingSM,
    collapseHeaderPaddingLG,
    collapsePanelBorderRadius,
    lineWidth,
    lineType,
    colorBorder,
    colorText,
    colorTextHeading,
    colorTextDisabled,
    fontSizeLG,
    lineHeight,
    lineHeightLG,
    marginSM,
    paddingSM,
    paddingLG,
    paddingXS,
    motionDurationSlow,
    fontSizeIcon,
    contentPadding,
    fontHeight,
    fontHeightLG
  } = token;
  const borderBase = `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${colorBorder}`;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      backgroundColor: headerBg,
      border: borderBase,
      borderRadius: collapsePanelBorderRadius,
      '&-rtl': {
        direction: 'rtl'
      },
      [`& > ${componentCls}-item`]: {
        borderBottom: borderBase,
        '&:first-child': {
          [`
            &,
            & > ${componentCls}-header`]: {
            borderRadius: `${(0,cssinjs_es/* unit */.bf)(collapsePanelBorderRadius)} ${(0,cssinjs_es/* unit */.bf)(collapsePanelBorderRadius)} 0 0`
          }
        },
        '&:last-child': {
          [`
            &,
            & > ${componentCls}-header`]: {
            borderRadius: `0 0 ${(0,cssinjs_es/* unit */.bf)(collapsePanelBorderRadius)} ${(0,cssinjs_es/* unit */.bf)(collapsePanelBorderRadius)}`
          }
        },
        [`> ${componentCls}-header`]: Object.assign(Object.assign({
          position: 'relative',
          display: 'flex',
          flexWrap: 'nowrap',
          alignItems: 'flex-start',
          padding: headerPadding,
          color: colorTextHeading,
          lineHeight,
          cursor: 'pointer',
          transition: `all ${motionDurationSlow}, visibility 0s`
        }, genFocusStyle(token)), {
          [`> ${componentCls}-header-text`]: {
            flex: 'auto'
          },
          // >>>>> Arrow
          [`${componentCls}-expand-icon`]: {
            height: fontHeight,
            display: 'flex',
            alignItems: 'center',
            paddingInlineEnd: marginSM
          },
          [`${componentCls}-arrow`]: Object.assign(Object.assign({}, resetIcon()), {
            fontSize: fontSizeIcon,
            // when `transform: rotate()` is applied to icon's root element
            transition: `transform ${motionDurationSlow}`,
            // when `transform: rotate()` is applied to icon's child element
            svg: {
              transition: `transform ${motionDurationSlow}`
            }
          }),
          // >>>>> Text
          [`${componentCls}-header-text`]: {
            marginInlineEnd: 'auto'
          }
        }),
        [`${componentCls}-collapsible-header`]: {
          cursor: 'default',
          [`${componentCls}-header-text`]: {
            flex: 'none',
            cursor: 'pointer'
          },
          [`${componentCls}-expand-icon`]: {
            cursor: 'pointer'
          }
        },
        [`${componentCls}-collapsible-icon`]: {
          cursor: 'unset',
          [`${componentCls}-expand-icon`]: {
            cursor: 'pointer'
          }
        }
      },
      [`${componentCls}-content`]: {
        color: colorText,
        backgroundColor: contentBg,
        borderTop: borderBase,
        [`& > ${componentCls}-content-box`]: {
          padding: contentPadding
        },
        '&-hidden': {
          display: 'none'
        }
      },
      '&-small': {
        [`> ${componentCls}-item`]: {
          [`> ${componentCls}-header`]: {
            padding: collapseHeaderPaddingSM,
            paddingInlineStart: paddingXS,
            [`> ${componentCls}-expand-icon`]: {
              // Arrow offset
              marginInlineStart: token.calc(paddingSM).sub(paddingXS).equal()
            }
          },
          [`> ${componentCls}-content > ${componentCls}-content-box`]: {
            padding: paddingSM
          }
        }
      },
      '&-large': {
        [`> ${componentCls}-item`]: {
          fontSize: fontSizeLG,
          lineHeight: lineHeightLG,
          [`> ${componentCls}-header`]: {
            padding: collapseHeaderPaddingLG,
            paddingInlineStart: padding,
            [`> ${componentCls}-expand-icon`]: {
              height: fontHeightLG,
              // Arrow offset
              marginInlineStart: token.calc(paddingLG).sub(padding).equal()
            }
          },
          [`> ${componentCls}-content > ${componentCls}-content-box`]: {
            padding: paddingLG
          }
        }
      },
      [`${componentCls}-item:last-child`]: {
        borderBottom: 0,
        [`> ${componentCls}-content`]: {
          borderRadius: `0 0 ${(0,cssinjs_es/* unit */.bf)(collapsePanelBorderRadius)} ${(0,cssinjs_es/* unit */.bf)(collapsePanelBorderRadius)}`
        }
      },
      [`& ${componentCls}-item-disabled > ${componentCls}-header`]: {
        [`
          &,
          & > .arrow
        `]: {
          color: colorTextDisabled,
          cursor: 'not-allowed'
        }
      },
      // ========================== Icon Position ==========================
      [`&${componentCls}-icon-position-end`]: {
        [`& > ${componentCls}-item`]: {
          [`> ${componentCls}-header`]: {
            [`${componentCls}-expand-icon`]: {
              order: 1,
              paddingInlineEnd: 0,
              paddingInlineStart: marginSM
            }
          }
        }
      }
    })
  };
};
const genArrowStyle = token => {
  const {
    componentCls
  } = token;
  const fixedSelector = `> ${componentCls}-item > ${componentCls}-header ${componentCls}-arrow`;
  return {
    [`${componentCls}-rtl`]: {
      [fixedSelector]: {
        transform: `rotate(180deg)`
      }
    }
  };
};
const genBorderlessStyle = token => {
  const {
    componentCls,
    headerBg,
    borderlessContentPadding,
    borderlessContentBg,
    colorBorder
  } = token;
  return {
    [`${componentCls}-borderless`]: {
      backgroundColor: headerBg,
      border: 0,
      [`> ${componentCls}-item`]: {
        borderBottom: `1px solid ${colorBorder}`
      },
      [`
        > ${componentCls}-item:last-child,
        > ${componentCls}-item:last-child ${componentCls}-header
      `]: {
        borderRadius: 0
      },
      [`> ${componentCls}-item:last-child`]: {
        borderBottom: 0
      },
      [`> ${componentCls}-item > ${componentCls}-content`]: {
        backgroundColor: borderlessContentBg,
        borderTop: 0
      },
      [`> ${componentCls}-item > ${componentCls}-content > ${componentCls}-content-box`]: {
        padding: borderlessContentPadding
      }
    }
  };
};
const genGhostStyle = token => {
  const {
    componentCls,
    paddingSM
  } = token;
  return {
    [`${componentCls}-ghost`]: {
      backgroundColor: 'transparent',
      border: 0,
      [`> ${componentCls}-item`]: {
        borderBottom: 0,
        [`> ${componentCls}-content`]: {
          backgroundColor: 'transparent',
          border: 0,
          [`> ${componentCls}-content-box`]: {
            paddingBlock: paddingSM
          }
        }
      }
    }
  };
};
const collapse_style_prepareComponentToken = token => ({
  headerPadding: `${token.paddingSM}px ${token.padding}px`,
  headerBg: token.colorFillAlter,
  contentPadding: `${token.padding}px 16px`,
  // Fixed Value
  contentBg: token.colorBgContainer,
  borderlessContentPadding: `${token.paddingXXS}px 16px ${token.padding}px`,
  borderlessContentBg: 'transparent'
});
/* harmony default export */ var collapse_style = (genStyleHooks('Collapse', token => {
  const collapseToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    collapseHeaderPaddingSM: `${(0,cssinjs_es/* unit */.bf)(token.paddingXS)} ${(0,cssinjs_es/* unit */.bf)(token.paddingSM)}`,
    collapseHeaderPaddingLG: `${(0,cssinjs_es/* unit */.bf)(token.padding)} ${(0,cssinjs_es/* unit */.bf)(token.paddingLG)}`,
    collapsePanelBorderRadius: token.borderRadiusLG
  });
  return [style_genBaseStyle(collapseToken), genBorderlessStyle(collapseToken), genGhostStyle(collapseToken), genArrowStyle(collapseToken), collapse(collapseToken)];
}, collapse_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/collapse/Collapse.js
"use client";














const Collapse = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    getPrefixCls,
    direction,
    expandIcon: contextExpandIcon,
    className: contextClassName,
    style: contextStyle
  } = useComponentConfig('collapse');
  const {
    prefixCls: customizePrefixCls,
    className,
    rootClassName,
    style,
    bordered = true,
    ghost,
    size: customizeSize,
    expandIconPosition = 'start',
    children,
    destroyInactivePanel,
    destroyOnHidden,
    expandIcon
  } = props;
  const mergedSize = hooks_useSize(ctx => {
    var _a;
    return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : ctx) !== null && _a !== void 0 ? _a : 'middle';
  });
  const prefixCls = getPrefixCls('collapse', customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  const [wrapCSSVar, hashId, cssVarCls] = collapse_style(prefixCls);
  if (false) {}
  // Align with logic position
  const mergedExpandIconPosition = react.useMemo(() => {
    if (expandIconPosition === 'left') {
      return 'start';
    }
    return expandIconPosition === 'right' ? 'end' : expandIconPosition;
  }, [expandIconPosition]);
  const mergedExpandIcon = expandIcon !== null && expandIcon !== void 0 ? expandIcon : contextExpandIcon;
  const renderExpandIcon = react.useCallback((panelProps = {}) => {
    const icon = typeof mergedExpandIcon === 'function' ? mergedExpandIcon(panelProps) : (/*#__PURE__*/react.createElement(RightOutlined/* default */.Z, {
      rotate: panelProps.isActive ? direction === 'rtl' ? -90 : 90 : undefined,
      "aria-label": panelProps.isActive ? 'expanded' : 'collapsed'
    }));
    return cloneElement(icon, () => {
      var _a;
      return {
        className: classnames_default()((_a = icon.props) === null || _a === void 0 ? void 0 : _a.className, `${prefixCls}-arrow`)
      };
    });
  }, [mergedExpandIcon, prefixCls, direction]);
  const collapseClassName = classnames_default()(`${prefixCls}-icon-position-${mergedExpandIconPosition}`, {
    [`${prefixCls}-borderless`]: !bordered,
    [`${prefixCls}-rtl`]: direction === 'rtl',
    [`${prefixCls}-ghost`]: !!ghost,
    [`${prefixCls}-${mergedSize}`]: mergedSize !== 'middle'
  }, contextClassName, className, rootClassName, hashId, cssVarCls);
  const openMotion = react.useMemo(() => Object.assign(Object.assign({}, _util_motion(rootPrefixCls)), {
    motionAppear: false,
    leavedClassName: `${prefixCls}-content-hidden`
  }), [rootPrefixCls, prefixCls]);
  const items = react.useMemo(() => {
    if (!children) {
      return null;
    }
    return (0,Children_toArray/* default */.Z)(children).map((child, index) => {
      var _a, _b;
      const childProps = child.props;
      if (childProps === null || childProps === void 0 ? void 0 : childProps.disabled) {
        const key = (_a = child.key) !== null && _a !== void 0 ? _a : String(index);
        const mergedChildProps = Object.assign(Object.assign({}, (0,omit/* default */.Z)(child.props, ['disabled'])), {
          key,
          collapsible: (_b = childProps.collapsible) !== null && _b !== void 0 ? _b : 'disabled'
        });
        return cloneElement(child, mergedChildProps);
      }
      return child;
    });
  }, [children]);
  return wrapCSSVar(/*#__PURE__*/
  // @ts-ignore
  react.createElement(rc_collapse_es/* default */.Z, Object.assign({
    ref: ref,
    openMotion: openMotion
  }, (0,omit/* default */.Z)(props, ['rootClassName']), {
    expandIcon: renderExpandIcon,
    prefixCls: prefixCls,
    className: collapseClassName,
    style: Object.assign(Object.assign({}, contextStyle), style),
    // TODO: In the future, destroyInactivePanel in rc-collapse needs to be upgrade to destroyOnHidden
    destroyInactivePanel: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : destroyInactivePanel
  }), items));
});
if (false) {}
/* harmony default export */ var collapse_Collapse = (Object.assign(Collapse, {
  Panel: collapse_CollapsePanel
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/collapse/index.js
"use client";


/* harmony default export */ var es_collapse = (collapse_Collapse);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/util.js



const generateColor = color => {
  if (color instanceof AggregationColor) {
    return color;
  }
  return new AggregationColor(color);
};
const getRoundNumber = value => Math.round(Number(value || 0));
const getColorAlpha = color => getRoundNumber(color.toHsb().a * 100);
/** Return the color whose `alpha` is 1 */
const genAlphaColor = (color, alpha) => {
  const rgba = color.toRgb();
  // Color from hsb input may get `rgb` is (0/0/0) when `hsb.b` is 0
  // So if rgb is empty, we should get from hsb
  if (!rgba.r && !rgba.g && !rgba.b) {
    const hsba = color.toHsb();
    hsba.a = alpha || 1;
    return generateColor(hsba);
  }
  rgba.a = alpha || 1;
  return generateColor(rgba);
};
/**
 * Get percent position color. e.g. [10%-#fff, 20%-#000], 15% => #888
 */
const getGradientPercentColor = (colors, percent) => {
  const filledColors = [{
    percent: 0,
    color: colors[0].color
  }].concat((0,toConsumableArray/* default */.Z)(colors), [{
    percent: 100,
    color: colors[colors.length - 1].color
  }]);
  for (let i = 0; i < filledColors.length - 1; i += 1) {
    const startPtg = filledColors[i].percent;
    const endPtg = filledColors[i + 1].percent;
    const startColor = filledColors[i].color;
    const endColor = filledColors[i + 1].color;
    if (startPtg <= percent && percent <= endPtg) {
      const dist = endPtg - startPtg;
      if (dist === 0) {
        return startColor;
      }
      const ratio = (percent - startPtg) / dist * 100;
      const startRcColor = new color_picker_es/* Color */.Il(startColor);
      const endRcColor = new color_picker_es/* Color */.Il(endColor);
      return startRcColor.mix(endRcColor, ratio).toRgbString();
    }
  }
  // This will never reach
  /* istanbul ignore next */
  return '';
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/components/ColorPresets.js
"use client";









const genPresetColor = list => list.map(value => {
  value.colors = value.colors.map(generateColor);
  return value;
});
const isBright = (value, bgColorToken) => {
  const {
    r,
    g,
    b,
    a
  } = value.toRgb();
  const hsv = new color_picker_es/* Color */.Il(value.toRgbString()).onBackground(bgColorToken).toHsv();
  if (a <= 0.5) {
    // Adapted to dark mode
    return hsv.v > 0.5;
  }
  return r * 0.299 + g * 0.587 + b * 0.114 > 192;
};
const genCollapsePanelKey = (preset, index) => {
  var _a;
  const mergedKey = (_a = preset.key) !== null && _a !== void 0 ? _a : index;
  return `panel-${mergedKey}`;
};
const ColorPresets = ({
  prefixCls,
  presets,
  value: color,
  onChange
}) => {
  const [locale] = locale_useLocale('ColorPicker');
  const [, token] = useToken();
  const [presetsValue] = (0,useMergedState/* default */.Z)(genPresetColor(presets), {
    value: genPresetColor(presets),
    postState: genPresetColor
  });
  const colorPresetsPrefixCls = `${prefixCls}-presets`;
  const activeKeys = (0,react.useMemo)(() => presetsValue.reduce((acc, preset, index) => {
    const {
      defaultOpen = true
    } = preset;
    if (defaultOpen) {
      acc.push(genCollapsePanelKey(preset, index));
    }
    return acc;
  }, []), [presetsValue]);
  const handleClick = colorValue => {
    onChange === null || onChange === void 0 ? void 0 : onChange(colorValue);
  };
  const items = presetsValue.map((preset, index) => {
    var _a;
    return {
      key: genCollapsePanelKey(preset, index),
      label: /*#__PURE__*/react.createElement("div", {
        className: `${colorPresetsPrefixCls}-label`
      }, preset === null || preset === void 0 ? void 0 : preset.label),
      children: (/*#__PURE__*/react.createElement("div", {
        className: `${colorPresetsPrefixCls}-items`
      }, Array.isArray(preset === null || preset === void 0 ? void 0 : preset.colors) && ((_a = preset.colors) === null || _a === void 0 ? void 0 : _a.length) > 0 ? preset.colors.map((presetColor, index) => (/*#__PURE__*/react.createElement(color_picker_es/* ColorBlock */.G5
      // eslint-disable-next-line react/no-array-index-key
      , {
        // eslint-disable-next-line react/no-array-index-key
        key: `preset-${index}-${presetColor.toHexString()}`,
        color: generateColor(presetColor).toRgbString(),
        prefixCls: prefixCls,
        className: classnames_default()(`${colorPresetsPrefixCls}-color`, {
          [`${colorPresetsPrefixCls}-color-checked`]: presetColor.toHexString() === (color === null || color === void 0 ? void 0 : color.toHexString()),
          [`${colorPresetsPrefixCls}-color-bright`]: isBright(presetColor, token.colorBgElevated)
        }),
        onClick: () => handleClick(presetColor)
      }))) : (/*#__PURE__*/react.createElement("span", {
        className: `${colorPresetsPrefixCls}-empty`
      }, locale.presetEmpty))))
    };
  });
  return /*#__PURE__*/react.createElement("div", {
    className: colorPresetsPrefixCls
  }, /*#__PURE__*/react.createElement(es_collapse, {
    defaultActiveKey: activeKeys,
    ghost: true,
    items: items
  }));
};
/* harmony default export */ var components_ColorPresets = (ColorPresets);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/button/style/token.js






const prepareToken = token => {
  const {
    paddingInline,
    onlyIconSize
  } = token;
  const buttonToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    buttonPaddingHorizontal: paddingInline,
    buttonPaddingVertical: 0,
    buttonIconOnlyFontSize: onlyIconSize
  });
  return buttonToken;
};
const token_prepareComponentToken = token => {
  var _a, _b, _c, _d, _e, _f;
  const contentFontSize = (_a = token.contentFontSize) !== null && _a !== void 0 ? _a : token.fontSize;
  const contentFontSizeSM = (_b = token.contentFontSizeSM) !== null && _b !== void 0 ? _b : token.fontSize;
  const contentFontSizeLG = (_c = token.contentFontSizeLG) !== null && _c !== void 0 ? _c : token.fontSizeLG;
  const contentLineHeight = (_d = token.contentLineHeight) !== null && _d !== void 0 ? _d : getLineHeight(contentFontSize);
  const contentLineHeightSM = (_e = token.contentLineHeightSM) !== null && _e !== void 0 ? _e : getLineHeight(contentFontSizeSM);
  const contentLineHeightLG = (_f = token.contentLineHeightLG) !== null && _f !== void 0 ? _f : getLineHeight(contentFontSizeLG);
  const solidTextColor = isBright(new AggregationColor(token.colorBgSolid), '#fff') ? '#000' : '#fff';
  const shadowColorTokens = PresetColors.reduce((prev, colorKey) => Object.assign(Object.assign({}, prev), {
    [`${colorKey}ShadowColor`]: `0 ${(0,cssinjs_es/* unit */.bf)(token.controlOutlineWidth)} 0 ${util_getAlphaColor(token[`${colorKey}1`], token.colorBgContainer)}`
  }), {});
  return Object.assign(Object.assign({}, shadowColorTokens), {
    fontWeight: 400,
    iconGap: token.marginXS,
    defaultShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlTmpOutline}`,
    primaryShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlOutline}`,
    dangerShadow: `0 ${token.controlOutlineWidth}px 0 ${token.colorErrorOutline}`,
    primaryColor: token.colorTextLightSolid,
    dangerColor: token.colorTextLightSolid,
    borderColorDisabled: token.colorBorder,
    defaultGhostColor: token.colorBgContainer,
    ghostBg: 'transparent',
    defaultGhostBorderColor: token.colorBgContainer,
    paddingInline: token.paddingContentHorizontal - token.lineWidth,
    paddingInlineLG: token.paddingContentHorizontal - token.lineWidth,
    paddingInlineSM: 8 - token.lineWidth,
    onlyIconSize: 'inherit',
    onlyIconSizeSM: 'inherit',
    onlyIconSizeLG: 'inherit',
    groupBorderColor: token.colorPrimaryHover,
    linkHoverBg: 'transparent',
    textTextColor: token.colorText,
    textTextHoverColor: token.colorText,
    textTextActiveColor: token.colorText,
    textHoverBg: token.colorFillTertiary,
    defaultColor: token.colorText,
    defaultBg: token.colorBgContainer,
    defaultBorderColor: token.colorBorder,
    defaultBorderColorDisabled: token.colorBorder,
    defaultHoverBg: token.colorBgContainer,
    defaultHoverColor: token.colorPrimaryHover,
    defaultHoverBorderColor: token.colorPrimaryHover,
    defaultActiveBg: token.colorBgContainer,
    defaultActiveColor: token.colorPrimaryActive,
    defaultActiveBorderColor: token.colorPrimaryActive,
    solidTextColor,
    contentFontSize,
    contentFontSizeSM,
    contentFontSizeLG,
    contentLineHeight,
    contentLineHeightSM,
    contentLineHeightLG,
    paddingBlock: Math.max((token.controlHeight - contentFontSize * contentLineHeight) / 2 - token.lineWidth, 0),
    paddingBlockSM: Math.max((token.controlHeightSM - contentFontSizeSM * contentLineHeightSM) / 2 - token.lineWidth, 0),
    paddingBlockLG: Math.max((token.controlHeightLG - contentFontSizeLG * contentLineHeightLG) / 2 - token.lineWidth, 0)
  });
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/button/style/index.js






// ============================== Shared ==============================
const genSharedButtonStyle = token => {
  const {
    componentCls,
    iconCls,
    fontWeight,
    opacityLoading,
    motionDurationSlow,
    motionEaseInOut,
    iconGap,
    calc
  } = token;
  return {
    [componentCls]: {
      outline: 'none',
      position: 'relative',
      display: 'inline-flex',
      gap: iconGap,
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight,
      whiteSpace: 'nowrap',
      textAlign: 'center',
      backgroundImage: 'none',
      background: 'transparent',
      border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} transparent`,
      cursor: 'pointer',
      transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
      userSelect: 'none',
      touchAction: 'manipulation',
      color: token.colorText,
      '&:disabled > *': {
        pointerEvents: 'none'
      },
      // https://github.com/ant-design/ant-design/issues/51380
      [`${componentCls}-icon > svg`]: resetIcon(),
      '> a': {
        color: 'currentColor'
      },
      '&:not(:disabled)': genFocusStyle(token),
      [`&${componentCls}-two-chinese-chars::first-letter`]: {
        letterSpacing: '0.34em'
      },
      [`&${componentCls}-two-chinese-chars > *:not(${iconCls})`]: {
        marginInlineEnd: '-0.34em',
        letterSpacing: '0.34em'
      },
      [`&${componentCls}-icon-only`]: {
        paddingInline: 0,
        // make `btn-icon-only` not too narrow
        [`&${componentCls}-compact-item`]: {
          flex: 'none'
        },
        [`&${componentCls}-round`]: {
          width: 'auto'
        }
      },
      // Loading
      [`&${componentCls}-loading`]: {
        opacity: opacityLoading,
        cursor: 'default'
      },
      [`${componentCls}-loading-icon`]: {
        transition: ['width', 'opacity', 'margin'].map(transition => `${transition} ${motionDurationSlow} ${motionEaseInOut}`).join(',')
      },
      // iconPosition
      [`&:not(${componentCls}-icon-end)`]: {
        [`${componentCls}-loading-icon-motion`]: {
          '&-appear-start, &-enter-start': {
            marginInlineEnd: calc(iconGap).mul(-1).equal()
          },
          '&-appear-active, &-enter-active': {
            marginInlineEnd: 0
          },
          '&-leave-start': {
            marginInlineEnd: 0
          },
          '&-leave-active': {
            marginInlineEnd: calc(iconGap).mul(-1).equal()
          }
        }
      },
      '&-icon-end': {
        flexDirection: 'row-reverse',
        [`${componentCls}-loading-icon-motion`]: {
          '&-appear-start, &-enter-start': {
            marginInlineStart: calc(iconGap).mul(-1).equal()
          },
          '&-appear-active, &-enter-active': {
            marginInlineStart: 0
          },
          '&-leave-start': {
            marginInlineStart: 0
          },
          '&-leave-active': {
            marginInlineStart: calc(iconGap).mul(-1).equal()
          }
        }
      }
    }
  };
};
const genHoverActiveButtonStyle = (btnCls, hoverStyle, activeStyle) => ({
  [`&:not(:disabled):not(${btnCls}-disabled)`]: {
    '&:hover': hoverStyle,
    '&:active': activeStyle
  }
});
// ============================== Shape ===============================
const genCircleButtonStyle = token => ({
  minWidth: token.controlHeight,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  borderRadius: '50%'
});
const genRoundButtonStyle = token => ({
  borderRadius: token.controlHeight,
  paddingInlineStart: token.calc(token.controlHeight).div(2).equal(),
  paddingInlineEnd: token.calc(token.controlHeight).div(2).equal()
});
const genDisabledStyle = token => ({
  cursor: 'not-allowed',
  borderColor: token.borderColorDisabled,
  color: token.colorTextDisabled,
  background: token.colorBgContainerDisabled,
  boxShadow: 'none'
});
const genGhostButtonStyle = (btnCls, background, textColor, borderColor, textColorDisabled, borderColorDisabled, hoverStyle, activeStyle) => ({
  [`&${btnCls}-background-ghost`]: Object.assign(Object.assign({
    color: textColor || undefined,
    background,
    borderColor: borderColor || undefined,
    boxShadow: 'none'
  }, genHoverActiveButtonStyle(btnCls, Object.assign({
    background
  }, hoverStyle), Object.assign({
    background
  }, activeStyle))), {
    '&:disabled': {
      cursor: 'not-allowed',
      color: textColorDisabled || undefined,
      borderColor: borderColorDisabled || undefined
    }
  })
});
const genSolidDisabledButtonStyle = token => ({
  [`&:disabled, &${token.componentCls}-disabled`]: Object.assign({}, genDisabledStyle(token))
});
const genPureDisabledButtonStyle = token => ({
  [`&:disabled, &${token.componentCls}-disabled`]: {
    cursor: 'not-allowed',
    color: token.colorTextDisabled
  }
});
// ============================== Variant =============================
const genVariantButtonStyle = (token, hoverStyle, activeStyle, variant) => {
  const isPureDisabled = variant && ['link', 'text'].includes(variant);
  const genDisabledButtonStyle = isPureDisabled ? genPureDisabledButtonStyle : genSolidDisabledButtonStyle;
  return Object.assign(Object.assign({}, genDisabledButtonStyle(token)), genHoverActiveButtonStyle(token.componentCls, hoverStyle, activeStyle));
};
const genSolidButtonStyle = (token, textColor, background, hoverStyle, activeStyle) => ({
  [`&${token.componentCls}-variant-solid`]: Object.assign({
    color: textColor,
    background
  }, genVariantButtonStyle(token, hoverStyle, activeStyle))
});
const genOutlinedDashedButtonStyle = (token, borderColor, background, hoverStyle, activeStyle) => ({
  [`&${token.componentCls}-variant-outlined, &${token.componentCls}-variant-dashed`]: Object.assign({
    borderColor,
    background
  }, genVariantButtonStyle(token, hoverStyle, activeStyle))
});
const genDashedButtonStyle = token => ({
  [`&${token.componentCls}-variant-dashed`]: {
    borderStyle: 'dashed'
  }
});
const genFilledButtonStyle = (token, background, hoverStyle, activeStyle) => ({
  [`&${token.componentCls}-variant-filled`]: Object.assign({
    boxShadow: 'none',
    background
  }, genVariantButtonStyle(token, hoverStyle, activeStyle))
});
const genTextLinkButtonStyle = (token, textColor, variant, hoverStyle, activeStyle) => ({
  [`&${token.componentCls}-variant-${variant}`]: Object.assign({
    color: textColor,
    boxShadow: 'none'
  }, genVariantButtonStyle(token, hoverStyle, activeStyle, variant))
});
// =============================== Color ==============================
const genPresetColorStyle = token => {
  const {
    componentCls
  } = token;
  return PresetColors.reduce((prev, colorKey) => {
    const darkColor = token[`${colorKey}6`];
    const lightColor = token[`${colorKey}1`];
    const hoverColor = token[`${colorKey}5`];
    const lightHoverColor = token[`${colorKey}2`];
    const lightBorderColor = token[`${colorKey}3`];
    const activeColor = token[`${colorKey}7`];
    return Object.assign(Object.assign({}, prev), {
      [`&${componentCls}-color-${colorKey}`]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: darkColor,
        boxShadow: token[`${colorKey}ShadowColor`]
      }, genSolidButtonStyle(token, token.colorTextLightSolid, darkColor, {
        background: hoverColor
      }, {
        background: activeColor
      })), genOutlinedDashedButtonStyle(token, darkColor, token.colorBgContainer, {
        color: hoverColor,
        borderColor: hoverColor,
        background: token.colorBgContainer
      }, {
        color: activeColor,
        borderColor: activeColor,
        background: token.colorBgContainer
      })), genDashedButtonStyle(token)), genFilledButtonStyle(token, lightColor, {
        color: darkColor,
        background: lightHoverColor
      }, {
        color: darkColor,
        background: lightBorderColor
      })), genTextLinkButtonStyle(token, darkColor, 'link', {
        color: hoverColor
      }, {
        color: activeColor
      })), genTextLinkButtonStyle(token, darkColor, 'text', {
        color: hoverColor,
        background: lightColor
      }, {
        color: activeColor,
        background: lightBorderColor
      }))
    });
  }, {});
};
const genDefaultButtonStyle = token => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: token.defaultColor,
  boxShadow: token.defaultShadow
}, genSolidButtonStyle(token, token.solidTextColor, token.colorBgSolid, {
  color: token.solidTextColor,
  background: token.colorBgSolidHover
}, {
  color: token.solidTextColor,
  background: token.colorBgSolidActive
})), genDashedButtonStyle(token)), genFilledButtonStyle(token, token.colorFillTertiary, {
  color: token.defaultColor,
  background: token.colorFillSecondary
}, {
  color: token.defaultColor,
  background: token.colorFill
})), genGhostButtonStyle(token.componentCls, token.ghostBg, token.defaultGhostColor, token.defaultGhostBorderColor, token.colorTextDisabled, token.colorBorder)), genTextLinkButtonStyle(token, token.textTextColor, 'link', {
  color: token.colorLinkHover,
  background: token.linkHoverBg
}, {
  color: token.colorLinkActive
}));
const genPrimaryButtonStyle = token => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: token.colorPrimary,
  boxShadow: token.primaryShadow
}, genOutlinedDashedButtonStyle(token, token.colorPrimary, token.colorBgContainer, {
  color: token.colorPrimaryTextHover,
  borderColor: token.colorPrimaryHover,
  background: token.colorBgContainer
}, {
  color: token.colorPrimaryTextActive,
  borderColor: token.colorPrimaryActive,
  background: token.colorBgContainer
})), genDashedButtonStyle(token)), genFilledButtonStyle(token, token.colorPrimaryBg, {
  color: token.colorPrimary,
  background: token.colorPrimaryBgHover
}, {
  color: token.colorPrimary,
  background: token.colorPrimaryBorder
})), genTextLinkButtonStyle(token, token.colorPrimaryText, 'text', {
  color: token.colorPrimaryTextHover,
  background: token.colorPrimaryBg
}, {
  color: token.colorPrimaryTextActive,
  background: token.colorPrimaryBorder
})), genTextLinkButtonStyle(token, token.colorPrimaryText, 'link', {
  color: token.colorPrimaryTextHover,
  background: token.linkHoverBg
}, {
  color: token.colorPrimaryTextActive
})), genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorPrimary, token.colorPrimary, token.colorTextDisabled, token.colorBorder, {
  color: token.colorPrimaryHover,
  borderColor: token.colorPrimaryHover
}, {
  color: token.colorPrimaryActive,
  borderColor: token.colorPrimaryActive
}));
const genDangerousStyle = token => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: token.colorError,
  boxShadow: token.dangerShadow
}, genSolidButtonStyle(token, token.dangerColor, token.colorError, {
  background: token.colorErrorHover
}, {
  background: token.colorErrorActive
})), genOutlinedDashedButtonStyle(token, token.colorError, token.colorBgContainer, {
  color: token.colorErrorHover,
  borderColor: token.colorErrorBorderHover
}, {
  color: token.colorErrorActive,
  borderColor: token.colorErrorActive
})), genDashedButtonStyle(token)), genFilledButtonStyle(token, token.colorErrorBg, {
  color: token.colorError,
  background: token.colorErrorBgFilledHover
}, {
  color: token.colorError,
  background: token.colorErrorBgActive
})), genTextLinkButtonStyle(token, token.colorError, 'text', {
  color: token.colorErrorHover,
  background: token.colorErrorBg
}, {
  color: token.colorErrorHover,
  background: token.colorErrorBgActive
})), genTextLinkButtonStyle(token, token.colorError, 'link', {
  color: token.colorErrorHover
}, {
  color: token.colorErrorActive
})), genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorError, token.colorError, token.colorTextDisabled, token.colorBorder, {
  color: token.colorErrorHover,
  borderColor: token.colorErrorHover
}, {
  color: token.colorErrorActive,
  borderColor: token.colorErrorActive
}));
const style_genLinkStyle = token => Object.assign(Object.assign({}, genTextLinkButtonStyle(token, token.colorLink, 'link', {
  color: token.colorLinkHover
}, {
  color: token.colorLinkActive
})), genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorInfo, token.colorInfo, token.colorTextDisabled, token.colorBorder, {
  color: token.colorInfoHover,
  borderColor: token.colorInfoHover
}, {
  color: token.colorInfoActive,
  borderColor: token.colorInfoActive
}));
const genColorButtonStyle = token => {
  const {
    componentCls
  } = token;
  return Object.assign({
    [`${componentCls}-color-default`]: genDefaultButtonStyle(token),
    [`${componentCls}-color-primary`]: genPrimaryButtonStyle(token),
    [`${componentCls}-color-dangerous`]: genDangerousStyle(token),
    [`${componentCls}-color-link`]: style_genLinkStyle(token)
  }, genPresetColorStyle(token));
};
// =========== Compatible with versions earlier than 5.21.0 ===========
const genCompatibleButtonStyle = token => Object.assign(Object.assign(Object.assign(Object.assign({}, genOutlinedDashedButtonStyle(token, token.defaultBorderColor, token.defaultBg, {
  color: token.defaultHoverColor,
  borderColor: token.defaultHoverBorderColor,
  background: token.defaultHoverBg
}, {
  color: token.defaultActiveColor,
  borderColor: token.defaultActiveBorderColor,
  background: token.defaultActiveBg
})), genTextLinkButtonStyle(token, token.textTextColor, 'text', {
  color: token.textTextHoverColor,
  background: token.textHoverBg
}, {
  color: token.textTextActiveColor,
  background: token.colorBgTextActive
})), genSolidButtonStyle(token, token.primaryColor, token.colorPrimary, {
  background: token.colorPrimaryHover,
  color: token.primaryColor
}, {
  background: token.colorPrimaryActive,
  color: token.primaryColor
})), genTextLinkButtonStyle(token, token.colorLink, 'link', {
  color: token.colorLinkHover,
  background: token.linkHoverBg
}, {
  color: token.colorLinkActive
}));
// =============================== Size ===============================
const genButtonStyle = (token, prefixCls = '') => {
  const {
    componentCls,
    controlHeight,
    fontSize,
    borderRadius,
    buttonPaddingHorizontal,
    iconCls,
    buttonPaddingVertical,
    buttonIconOnlyFontSize
  } = token;
  return [{
    [prefixCls]: {
      fontSize,
      height: controlHeight,
      padding: `${(0,cssinjs_es/* unit */.bf)(buttonPaddingVertical)} ${(0,cssinjs_es/* unit */.bf)(buttonPaddingHorizontal)}`,
      borderRadius,
      [`&${componentCls}-icon-only`]: {
        width: controlHeight,
        [iconCls]: {
          fontSize: buttonIconOnlyFontSize
        }
      }
    }
  },
  // Shape - patch prefixCls again to override solid border radius style
  {
    [`${componentCls}${componentCls}-circle${prefixCls}`]: genCircleButtonStyle(token)
  }, {
    [`${componentCls}${componentCls}-round${prefixCls}`]: genRoundButtonStyle(token)
  }];
};
const genSizeBaseButtonStyle = token => {
  const baseToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    fontSize: token.contentFontSize
  });
  return genButtonStyle(baseToken, token.componentCls);
};
const genSizeSmallButtonStyle = token => {
  const smallToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    controlHeight: token.controlHeightSM,
    fontSize: token.contentFontSizeSM,
    padding: token.paddingXS,
    buttonPaddingHorizontal: token.paddingInlineSM,
    buttonPaddingVertical: 0,
    borderRadius: token.borderRadiusSM,
    buttonIconOnlyFontSize: token.onlyIconSizeSM
  });
  return genButtonStyle(smallToken, `${token.componentCls}-sm`);
};
const genSizeLargeButtonStyle = token => {
  const largeToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    controlHeight: token.controlHeightLG,
    fontSize: token.contentFontSizeLG,
    buttonPaddingHorizontal: token.paddingInlineLG,
    buttonPaddingVertical: 0,
    borderRadius: token.borderRadiusLG,
    buttonIconOnlyFontSize: token.onlyIconSizeLG
  });
  return genButtonStyle(largeToken, `${token.componentCls}-lg`);
};
const genBlockButtonStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [componentCls]: {
      [`&${componentCls}-block`]: {
        width: '100%'
      }
    }
  };
};
// ============================== Export ==============================
/* harmony default export */ var button_style = (genStyleHooks('Button', token => {
  const buttonToken = prepareToken(token);
  return [
  // Shared
  genSharedButtonStyle(buttonToken),
  // Size
  genSizeBaseButtonStyle(buttonToken), genSizeSmallButtonStyle(buttonToken), genSizeLargeButtonStyle(buttonToken),
  // Block
  genBlockButtonStyle(buttonToken),
  // Color
  genColorButtonStyle(buttonToken),
  // https://github.com/ant-design/ant-design/issues/50969
  genCompatibleButtonStyle(buttonToken),
  // Button Group
  group(buttonToken)];
}, token_prepareComponentToken, {
  unitless: {
    fontWeight: true,
    contentLineHeight: true,
    contentLineHeightSM: true,
    contentLineHeightLG: true
  }
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/style/compact-item.js
// handle border collapse
function compactItemBorder(token, parentCls, options, prefixCls) {
  const {
    focusElCls,
    focus,
    borderElCls
  } = options;
  const childCombinator = borderElCls ? '> *' : '';
  const hoverEffects = ['hover', focus ? 'focus' : null, 'active'].filter(Boolean).map(n => `&:${n} ${childCombinator}`).join(',');
  return {
    [`&-item:not(${parentCls}-last-item)`]: {
      marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal()
    },
    [`&-item:not(${prefixCls}-status-success)`]: {
      zIndex: 2
    },
    '&-item': Object.assign(Object.assign({
      [hoverEffects]: {
        zIndex: 3
      }
    }, focusElCls ? {
      [`&${focusElCls}`]: {
        zIndex: 3
      }
    } : {}), {
      [`&[disabled] ${childCombinator}`]: {
        zIndex: 0
      }
    })
  };
}
// handle border-radius
function compactItemBorderRadius(prefixCls, parentCls, options) {
  const {
    borderElCls
  } = options;
  const childCombinator = borderElCls ? `> ${borderElCls}` : '';
  return {
    [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
      borderRadius: 0
    },
    [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
      [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
      [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function genCompactItemStyle(token, options = {
  focus: true
}) {
  const {
    componentCls
  } = token;
  const compactCls = `${componentCls}-compact`;
  return {
    [compactCls]: Object.assign(Object.assign({}, compactItemBorder(token, compactCls, options, componentCls)), compactItemBorderRadius(componentCls, compactCls, options))
  };
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/style/compact-item-vertical.js
function compactItemVerticalBorder(token, parentCls, prefixCls) {
  return {
    // border collapse
    [`&-item:not(${parentCls}-last-item)`]: {
      marginBottom: token.calc(token.lineWidth).mul(-1).equal()
    },
    [`&-item:not(${prefixCls}-status-success)`]: {
      zIndex: 2
    },
    '&-item': {
      '&:hover,&:focus,&:active': {
        zIndex: 3
      },
      '&[disabled]': {
        zIndex: 0
      }
    }
  };
}
function compactItemBorderVerticalRadius(prefixCls, parentCls) {
  return {
    [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${parentCls}-first-item:not(${parentCls}-last-item)`]: {
      [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${parentCls}-last-item:not(${parentCls}-first-item)`]: {
      [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function genCompactItemVerticalStyle(token) {
  const compactCls = `${token.componentCls}-compact-vertical`;
  return {
    [compactCls]: Object.assign(Object.assign({}, compactItemVerticalBorder(token, compactCls, token.componentCls)), compactItemBorderVerticalRadius(token.componentCls, compactCls))
  };
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/button/style/compact.js




const genButtonCompactStyle = token => {
  const {
    componentCls,
    colorPrimaryHover,
    lineWidth,
    calc
  } = token;
  const insetOffset = calc(lineWidth).mul(-1).equal();
  const getCompactBorderStyle = vertical => {
    const selector = `${componentCls}-compact${vertical ? '-vertical' : ''}-item${componentCls}-primary:not([disabled])`;
    return {
      [`${selector} + ${selector}::before`]: {
        position: 'absolute',
        top: vertical ? insetOffset : 0,
        insetInlineStart: vertical ? 0 : insetOffset,
        backgroundColor: colorPrimaryHover,
        content: '""',
        width: vertical ? '100%' : lineWidth,
        height: vertical ? lineWidth : '100%'
      }
    };
  };
  // Special styles for Primary Button
  return Object.assign(Object.assign({}, getCompactBorderStyle()), getCompactBorderStyle(true));
};
// ============================== Export ==============================
/* harmony default export */ var style_compact = (genSubStyleComponent(['Button', 'compact'], token => {
  const buttonToken = prepareToken(token);
  return [
  // Space Compact
  genCompactItemStyle(buttonToken), genCompactItemVerticalStyle(buttonToken), genButtonCompactStyle(buttonToken)];
}, token_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/button/button.js
"use client";

var button_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

















function getLoadingConfig(loading) {
  if (typeof loading === 'object' && loading) {
    let delay = loading === null || loading === void 0 ? void 0 : loading.delay;
    delay = !Number.isNaN(delay) && typeof delay === 'number' ? delay : 0;
    return {
      loading: delay <= 0,
      delay
    };
  }
  return {
    loading: !!loading,
    delay: 0
  };
}
const ButtonTypeMap = {
  default: ['default', 'outlined'],
  primary: ['primary', 'solid'],
  dashed: ['default', 'dashed'],
  // `link` is not a real color but we should compatible with it
  link: ['link', 'link'],
  text: ['default', 'text']
};
const InternalCompoundedButton = /*#__PURE__*/react.forwardRef((props, ref) => {
  var _a, _b;
  const {
      loading = false,
      prefixCls: customizePrefixCls,
      color,
      variant,
      type,
      danger = false,
      shape: customizeShape,
      size: customizeSize,
      styles,
      disabled: customDisabled,
      className,
      rootClassName,
      children,
      icon,
      iconPosition = 'start',
      ghost = false,
      block = false,
      // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
      htmlType = 'button',
      classNames: customClassNames,
      style: customStyle = {},
      autoInsertSpace,
      autoFocus
    } = props,
    rest = button_rest(props, ["loading", "prefixCls", "color", "variant", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "iconPosition", "ghost", "block", "htmlType", "classNames", "style", "autoInsertSpace", "autoFocus"]);
  // https://github.com/ant-design/ant-design/issues/47605
  // Compatible with original `type` behavior
  const mergedType = type || 'default';
  const {
    button
  } = react.useContext(ConfigContext);
  const shape = customizeShape || (button === null || button === void 0 ? void 0 : button.shape) || 'default';
  const [mergedColor, mergedVariant] = (0,react.useMemo)(() => {
    // >>>>> Local
    // Color & Variant
    if (color && variant) {
      return [color, variant];
    }
    // Sugar syntax
    if (type || danger) {
      const colorVariantPair = ButtonTypeMap[mergedType] || [];
      if (danger) {
        return ['danger', colorVariantPair[1]];
      }
      return colorVariantPair;
    }
    // >>> Context fallback
    if ((button === null || button === void 0 ? void 0 : button.color) && (button === null || button === void 0 ? void 0 : button.variant)) {
      return [button.color, button.variant];
    }
    return ['default', 'outlined'];
  }, [type, color, variant, danger, button === null || button === void 0 ? void 0 : button.variant, button === null || button === void 0 ? void 0 : button.color]);
  const isDanger = mergedColor === 'danger';
  const mergedColorText = isDanger ? 'dangerous' : mergedColor;
  const {
    getPrefixCls,
    direction,
    autoInsertSpace: contextAutoInsertSpace,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig('button');
  const mergedInsertSpace = (_a = autoInsertSpace !== null && autoInsertSpace !== void 0 ? autoInsertSpace : contextAutoInsertSpace) !== null && _a !== void 0 ? _a : true;
  const prefixCls = getPrefixCls('btn', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = button_style(prefixCls);
  const disabled = (0,react.useContext)(config_provider_DisabledContext);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  const groupSize = (0,react.useContext)(GroupSizeContext);
  const loadingOrDelay = (0,react.useMemo)(() => getLoadingConfig(loading), [loading]);
  const [innerLoading, setLoading] = (0,react.useState)(loadingOrDelay.loading);
  const [hasTwoCNChar, setHasTwoCNChar] = (0,react.useState)(false);
  const buttonRef = (0,react.useRef)(null);
  const mergedRef = (0,es_ref/* useComposeRef */.x1)(ref, buttonRef);
  const needInserted = react.Children.count(children) === 1 && !icon && !isUnBorderedButtonVariant(mergedVariant);
  // ========================= Mount ==========================
  // Record for mount status.
  // This will help to no to show the animation of loading on the first mount.
  const isMountRef = (0,react.useRef)(true);
  react.useEffect(() => {
    isMountRef.current = false;
    return () => {
      isMountRef.current = true;
    };
  }, []);
  // ========================= Effect =========================
  // Loading. Should use `useLayoutEffect` to avoid low perf multiple click issue.
  // https://github.com/ant-design/ant-design/issues/51325
  (0,hooks_useLayoutEffect/* default */.Z)(() => {
    let delayTimer = null;
    if (loadingOrDelay.delay > 0) {
      delayTimer = setTimeout(() => {
        delayTimer = null;
        setLoading(true);
      }, loadingOrDelay.delay);
    } else {
      setLoading(loadingOrDelay.loading);
    }
    function cleanupTimer() {
      if (delayTimer) {
        clearTimeout(delayTimer);
        delayTimer = null;
      }
    }
    return cleanupTimer;
  }, [loadingOrDelay.delay, loadingOrDelay.loading]);
  // Two chinese characters check
  (0,react.useEffect)(() => {
    // FIXME: for HOC usage like <FormatMessage />
    if (!buttonRef.current || !mergedInsertSpace) {
      return;
    }
    const buttonText = buttonRef.current.textContent || '';
    if (needInserted && isTwoCNChar(buttonText)) {
      if (!hasTwoCNChar) {
        setHasTwoCNChar(true);
      }
    } else if (hasTwoCNChar) {
      setHasTwoCNChar(false);
    }
  });
  // Auto focus
  (0,react.useEffect)(() => {
    if (autoFocus && buttonRef.current) {
      buttonRef.current.focus();
    }
  }, []);
  // ========================= Events =========================
  const handleClick = react.useCallback(e => {
    var _a;
    // FIXME: https://github.com/ant-design/ant-design/issues/30207
    if (innerLoading || mergedDisabled) {
      e.preventDefault();
      return;
    }
    (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, 'href' in props ? e : e);
  }, [props.onClick, innerLoading, mergedDisabled]);
  // ========================== Warn ==========================
  if (false) {}
  // ========================== Size ==========================
  const {
    compactSize,
    compactItemClassnames
  } = useCompactItemContext(prefixCls, direction);
  const sizeClassNameMap = {
    large: 'lg',
    small: 'sm',
    middle: undefined
  };
  const sizeFullName = hooks_useSize(ctxSize => {
    var _a, _b;
    return (_b = (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : groupSize) !== null && _b !== void 0 ? _b : ctxSize;
  });
  const sizeCls = sizeFullName ? (_b = sizeClassNameMap[sizeFullName]) !== null && _b !== void 0 ? _b : '' : '';
  const iconType = innerLoading ? 'loading' : icon;
  const linkButtonRestProps = (0,omit/* default */.Z)(rest, ['navigate']);
  // ========================= Render =========================
  const classes = classnames_default()(prefixCls, hashId, cssVarCls, {
    [`${prefixCls}-${shape}`]: shape !== 'default' && shape,
    // Compatible with versions earlier than 5.21.0
    [`${prefixCls}-${mergedType}`]: mergedType,
    [`${prefixCls}-dangerous`]: danger,
    [`${prefixCls}-color-${mergedColorText}`]: mergedColorText,
    [`${prefixCls}-variant-${mergedVariant}`]: mergedVariant,
    [`${prefixCls}-${sizeCls}`]: sizeCls,
    [`${prefixCls}-icon-only`]: !children && children !== 0 && !!iconType,
    [`${prefixCls}-background-ghost`]: ghost && !isUnBorderedButtonVariant(mergedVariant),
    [`${prefixCls}-loading`]: innerLoading,
    [`${prefixCls}-two-chinese-chars`]: hasTwoCNChar && mergedInsertSpace && !innerLoading,
    [`${prefixCls}-block`]: block,
    [`${prefixCls}-rtl`]: direction === 'rtl',
    [`${prefixCls}-icon-end`]: iconPosition === 'end'
  }, compactItemClassnames, className, rootClassName, contextClassName);
  const fullStyle = Object.assign(Object.assign({}, contextStyle), customStyle);
  const iconClasses = classnames_default()(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.icon, contextClassNames.icon);
  const iconStyle = Object.assign(Object.assign({}, (styles === null || styles === void 0 ? void 0 : styles.icon) || {}), contextStyles.icon || {});
  const iconNode = icon && !innerLoading ? (/*#__PURE__*/react.createElement(button_IconWrapper, {
    prefixCls: prefixCls,
    className: iconClasses,
    style: iconStyle
  }, icon)) : loading && typeof loading === 'object' && loading.icon ? (/*#__PURE__*/react.createElement(button_IconWrapper, {
    prefixCls: prefixCls,
    className: iconClasses,
    style: iconStyle
  }, loading.icon)) : (/*#__PURE__*/react.createElement(button_DefaultLoadingIcon, {
    existIcon: !!icon,
    prefixCls: prefixCls,
    loading: innerLoading,
    mount: isMountRef.current
  }));
  const kids = children || children === 0 ? spaceChildren(children, needInserted && mergedInsertSpace) : null;
  if (linkButtonRestProps.href !== undefined) {
    return wrapCSSVar(/*#__PURE__*/react.createElement("a", Object.assign({}, linkButtonRestProps, {
      className: classnames_default()(classes, {
        [`${prefixCls}-disabled`]: mergedDisabled
      }),
      href: mergedDisabled ? undefined : linkButtonRestProps.href,
      style: fullStyle,
      onClick: handleClick,
      ref: mergedRef,
      tabIndex: mergedDisabled ? -1 : 0
    }), iconNode, kids));
  }
  let buttonNode = /*#__PURE__*/react.createElement("button", Object.assign({}, rest, {
    type: htmlType,
    className: classes,
    style: fullStyle,
    onClick: handleClick,
    disabled: mergedDisabled,
    ref: mergedRef
  }), iconNode, kids, compactItemClassnames && /*#__PURE__*/react.createElement(style_compact, {
    prefixCls: prefixCls
  }));
  if (!isUnBorderedButtonVariant(mergedVariant)) {
    buttonNode = /*#__PURE__*/react.createElement(wave, {
      component: "Button",
      disabled: innerLoading
    }, buttonNode);
  }
  return wrapCSSVar(buttonNode);
});
const Button = InternalCompoundedButton;
Button.Group = button_group;
Button.__ANT_BUTTON = true;
if (false) {}
/* harmony default export */ var button_button = (Button);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/button/index.js
"use client";



/* harmony default export */ var es_button = (button_button);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/ActionButton.js
"use client";





function isThenable(thing) {
  return !!(thing === null || thing === void 0 ? void 0 : thing.then);
}
const ActionButton = props => {
  const {
    type,
    children,
    prefixCls,
    buttonProps,
    close,
    autoFocus,
    emitEvent,
    isSilent,
    quitOnNullishReturnValue,
    actionFn
  } = props;
  const clickedRef = react.useRef(false);
  const buttonRef = react.useRef(null);
  const [loading, setLoading] = (0,useState/* default */.Z)(false);
  const onInternalClose = (...args) => {
    close === null || close === void 0 ? void 0 : close.apply(void 0, args);
  };
  react.useEffect(() => {
    let timeoutId = null;
    if (autoFocus) {
      timeoutId = setTimeout(() => {
        var _a;
        (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus({
          preventScroll: true
        });
      });
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);
  const handlePromiseOnOk = returnValueOfOnOk => {
    if (!isThenable(returnValueOfOnOk)) {
      return;
    }
    setLoading(true);
    returnValueOfOnOk.then((...args) => {
      setLoading(false, true);
      onInternalClose.apply(void 0, args);
      clickedRef.current = false;
    }, e => {
      // See: https://github.com/ant-design/ant-design/issues/6183
      setLoading(false, true);
      clickedRef.current = false;
      // Do not throw if is `await` mode
      if (isSilent === null || isSilent === void 0 ? void 0 : isSilent()) {
        return;
      }
      return Promise.reject(e);
    });
  };
  const onClick = e => {
    if (clickedRef.current) {
      return;
    }
    clickedRef.current = true;
    if (!actionFn) {
      onInternalClose();
      return;
    }
    let returnValueOfOnOk;
    if (emitEvent) {
      returnValueOfOnOk = actionFn(e);
      if (quitOnNullishReturnValue && !isThenable(returnValueOfOnOk)) {
        clickedRef.current = false;
        onInternalClose(e);
        return;
      }
    } else if (actionFn.length) {
      returnValueOfOnOk = actionFn(close);
      // https://github.com/ant-design/ant-design/issues/23358
      clickedRef.current = false;
    } else {
      returnValueOfOnOk = actionFn();
      if (!isThenable(returnValueOfOnOk)) {
        onInternalClose();
        return;
      }
    }
    handlePromiseOnOk(returnValueOfOnOk);
  };
  return /*#__PURE__*/react.createElement(es_button, Object.assign({}, convertLegacyProps(type), {
    onClick: onClick,
    loading: loading,
    prefixCls: prefixCls
  }, buttonProps, {
    ref: buttonRef
  }), children);
};
/* harmony default export */ var _util_ActionButton = (ActionButton);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/modal/context.js

const ModalContext = /*#__PURE__*/react.createContext({});
const {
  Provider: ModalContextProvider
} = ModalContext;
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/modal/components/ConfirmCancelBtn.js
"use client";




const ConfirmCancelBtn = () => {
  const {
    autoFocusButton,
    cancelButtonProps,
    cancelTextLocale,
    isSilent,
    mergedOkCancel,
    rootPrefixCls,
    close,
    onCancel,
    onConfirm
  } = (0,react.useContext)(ModalContext);
  return mergedOkCancel ? (/*#__PURE__*/react.createElement(_util_ActionButton, {
    isSilent: isSilent,
    actionFn: onCancel,
    close: (...args) => {
      close === null || close === void 0 ? void 0 : close.apply(void 0, args);
      onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(false);
    },
    autoFocus: autoFocusButton === 'cancel',
    buttonProps: cancelButtonProps,
    prefixCls: `${rootPrefixCls}-btn`
  }, cancelTextLocale)) : null;
};
/* harmony default export */ var components_ConfirmCancelBtn = (ConfirmCancelBtn);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/modal/components/ConfirmOkBtn.js
"use client";




const ConfirmOkBtn = () => {
  const {
    autoFocusButton,
    close,
    isSilent,
    okButtonProps,
    rootPrefixCls,
    okTextLocale,
    okType,
    onConfirm,
    onOk
  } = (0,react.useContext)(ModalContext);
  return /*#__PURE__*/react.createElement(_util_ActionButton, {
    isSilent: isSilent,
    type: okType || 'primary',
    actionFn: onOk,
    close: (...args) => {
      close === null || close === void 0 ? void 0 : close.apply(void 0, args);
      onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(true);
    },
    autoFocus: autoFocusButton === 'ok',
    buttonProps: okButtonProps,
    prefixCls: `${rootPrefixCls}-btn`
  }, okTextLocale);
};
/* harmony default export */ var components_ConfirmOkBtn = (ConfirmOkBtn);
// EXTERNAL MODULE: ./node_modules/rc-dialog/es/index.js + 8 modules
var rc_dialog_es = __webpack_require__(31414);
// EXTERNAL MODULE: ./node_modules/rc-field-form/es/index.js + 44 modules
var rc_field_form_es = __webpack_require__(54888);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/context.js
"use client";




const FormContext = /*#__PURE__*/react.createContext({
  labelAlign: 'right',
  layout: 'horizontal',
  itemRef: () => {}
});
const NoStyleItemContext = /*#__PURE__*/react.createContext(null);
const FormProvider = props => {
  const providerProps = (0,omit/* default */.Z)(props, ['prefixCls']);
  return /*#__PURE__*/react.createElement(rc_field_form_es/* FormProvider */.RV, Object.assign({}, providerProps));
};
const FormItemPrefixContext = /*#__PURE__*/react.createContext({
  prefixCls: ''
});
const FormItemInputContext = /*#__PURE__*/react.createContext({});
if (false) {}
const NoFormStyle = ({
  children,
  status,
  override
}) => {
  const formItemInputContext = react.useContext(FormItemInputContext);
  const newFormItemInputContext = react.useMemo(() => {
    const newContext = Object.assign({}, formItemInputContext);
    if (override) {
      delete newContext.isFormItemInput;
    }
    if (status) {
      delete newContext.status;
      delete newContext.hasFeedback;
      delete newContext.feedbackIcon;
    }
    return newContext;
  }, [status, override, formItemInputContext]);
  return /*#__PURE__*/react.createElement(FormItemInputContext.Provider, {
    value: newFormItemInputContext
  }, children);
};
const VariantContext = /*#__PURE__*/react.createContext(undefined);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/ContextIsolator.js
"use client";




const ContextIsolator = props => {
  const {
    space,
    form,
    children
  } = props;
  if (children === undefined || children === null) {
    return null;
  }
  let result = children;
  if (form) {
    result = /*#__PURE__*/react.createElement(NoFormStyle, {
      override: true,
      status: true
    }, result);
  }
  if (space) {
    result = /*#__PURE__*/react.createElement(NoCompactStyle, null, result);
  }
  return result;
};
/* harmony default export */ var _util_ContextIsolator = (ContextIsolator);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/extendsObject.js
function mergeProps(...items) {
  const ret = {};
  items.forEach(item => {
    if (item) {
      Object.keys(item).forEach(key => {
        if (item[key] !== undefined) {
          ret[key] = item[key];
        }
      });
    }
  });
  return ret;
}
/* harmony default export */ var extendsObject = (mergeProps);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/hooks/useClosable.js
"use client";







function pickClosable(context) {
  if (!context) {
    return undefined;
  }
  const {
    closable,
    closeIcon
  } = context;
  return {
    closable,
    closeIcon
  };
}
/** Convert `closable` and `closeIcon` to config object */
function useClosableConfig(closableCollection) {
  const {
    closable,
    closeIcon
  } = closableCollection || {};
  return react.useMemo(() => {
    if (
    // If `closable`, whatever rest be should be true
    !closable && (closable === false || closeIcon === false || closeIcon === null)) {
      return false;
    }
    if (closable === undefined && closeIcon === undefined) {
      return null;
    }
    let closableConfig = {
      closeIcon: typeof closeIcon !== 'boolean' && closeIcon !== null ? closeIcon : undefined
    };
    if (closable && typeof closable === 'object') {
      closableConfig = Object.assign(Object.assign({}, closableConfig), closable);
    }
    return closableConfig;
  }, [closable, closeIcon]);
}
/** Use same object to support `useMemo` optimization */
const EmptyFallbackCloseCollection = {};
function useClosable(propCloseCollection, contextCloseCollection, fallbackCloseCollection = EmptyFallbackCloseCollection) {
  // Align the `props`, `context` `fallback` to config object first
  const propCloseConfig = useClosableConfig(propCloseCollection);
  const contextCloseConfig = useClosableConfig(contextCloseCollection);
  const [contextLocale] = locale_useLocale('global', es_locale_en_US.global);
  const closeBtnIsDisabled = typeof propCloseConfig !== 'boolean' ? !!(propCloseConfig === null || propCloseConfig === void 0 ? void 0 : propCloseConfig.disabled) : false;
  const mergedFallbackCloseCollection = react.useMemo(() => Object.assign({
    closeIcon: /*#__PURE__*/react.createElement(CloseOutlined/* default */.Z, null)
  }, fallbackCloseCollection), [fallbackCloseCollection]);
  // Use fallback logic to fill the config
  const mergedClosableConfig = react.useMemo(() => {
    // ================ Props First ================
    // Skip if prop is disabled
    if (propCloseConfig === false) {
      return false;
    }
    if (propCloseConfig) {
      return extendsObject(mergedFallbackCloseCollection, contextCloseConfig, propCloseConfig);
    }
    // =============== Context Second ==============
    // Skip if context is disabled
    if (contextCloseConfig === false) {
      return false;
    }
    if (contextCloseConfig) {
      return extendsObject(mergedFallbackCloseCollection, contextCloseConfig);
    }
    // ============= Fallback Default ==============
    return !mergedFallbackCloseCollection.closable ? false : mergedFallbackCloseCollection;
  }, [propCloseConfig, contextCloseConfig, mergedFallbackCloseCollection]);
  // Calculate the final closeIcon
  return react.useMemo(() => {
    var _a, _b;
    if (mergedClosableConfig === false) {
      return [false, null, closeBtnIsDisabled, {}];
    }
    const {
      closeIconRender
    } = mergedFallbackCloseCollection;
    const {
      closeIcon
    } = mergedClosableConfig;
    let mergedCloseIcon = closeIcon;
    // Wrap the closeIcon with aria props
    const ariaOrDataProps = (0,pickAttrs/* default */.Z)(mergedClosableConfig, true);
    if (mergedCloseIcon !== null && mergedCloseIcon !== undefined) {
      // Wrap the closeIcon if needed
      if (closeIconRender) {
        mergedCloseIcon = closeIconRender(closeIcon);
      }
      mergedCloseIcon = /*#__PURE__*/react.isValidElement(mergedCloseIcon) ? (/*#__PURE__*/react.cloneElement(mergedCloseIcon, Object.assign(Object.assign(Object.assign({}, mergedCloseIcon.props), {
        'aria-label': (_b = (_a = mergedCloseIcon.props) === null || _a === void 0 ? void 0 : _a['aria-label']) !== null && _b !== void 0 ? _b : contextLocale.close
      }), ariaOrDataProps))) : (/*#__PURE__*/react.createElement("span", Object.assign({
        "aria-label": contextLocale.close
      }, ariaOrDataProps), mergedCloseIcon));
    }
    return [true, mergedCloseIcon, closeBtnIsDisabled, ariaOrDataProps];
  }, [mergedClosableConfig, mergedFallbackCloseCollection]);
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/styleChecker.js


const canUseDocElement = () => (0,canUseDom/* default */.Z)() && window.document.documentElement;

;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/skeleton/Element.js
"use client";



const Element = props => {
  const {
    prefixCls,
    className,
    style,
    size,
    shape
  } = props;
  const sizeCls = classnames_default()({
    [`${prefixCls}-lg`]: size === 'large',
    [`${prefixCls}-sm`]: size === 'small'
  });
  const shapeCls = classnames_default()({
    [`${prefixCls}-circle`]: shape === 'circle',
    [`${prefixCls}-square`]: shape === 'square',
    [`${prefixCls}-round`]: shape === 'round'
  });
  const sizeStyle = react.useMemo(() => typeof size === 'number' ? {
    width: size,
    height: size,
    lineHeight: `${size}px`
  } : {}, [size]);
  return /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(prefixCls, sizeCls, shapeCls, className),
    style: Object.assign(Object.assign({}, sizeStyle), style)
  });
};
/* harmony default export */ var skeleton_Element = (Element);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/skeleton/style/index.js


const skeletonClsLoading = new cssinjs_es/* Keyframes */.E4(`ant-skeleton-loading`, {
  '0%': {
    backgroundPosition: '100% 50%'
  },
  '100%': {
    backgroundPosition: '0 50%'
  }
});
const genSkeletonElementCommonSize = size => ({
  height: size,
  lineHeight: (0,cssinjs_es/* unit */.bf)(size)
});
const genSkeletonElementAvatarSize = size => Object.assign({
  width: size
}, genSkeletonElementCommonSize(size));
const genSkeletonColor = token => ({
  background: token.skeletonLoadingBackground,
  backgroundSize: '400% 100%',
  animationName: skeletonClsLoading,
  animationDuration: token.skeletonLoadingMotionDuration,
  animationTimingFunction: 'ease',
  animationIterationCount: 'infinite'
});
const genSkeletonElementInputSize = (size, calc) => Object.assign({
  width: calc(size).mul(5).equal(),
  minWidth: calc(size).mul(5).equal()
}, genSkeletonElementCommonSize(size));
const genSkeletonElementAvatar = token => {
  const {
    skeletonAvatarCls,
    gradientFromColor,
    controlHeight,
    controlHeightLG,
    controlHeightSM
  } = token;
  return {
    [skeletonAvatarCls]: Object.assign({
      display: 'inline-block',
      verticalAlign: 'top',
      background: gradientFromColor
    }, genSkeletonElementAvatarSize(controlHeight)),
    [`${skeletonAvatarCls}${skeletonAvatarCls}-circle`]: {
      borderRadius: '50%'
    },
    [`${skeletonAvatarCls}${skeletonAvatarCls}-lg`]: Object.assign({}, genSkeletonElementAvatarSize(controlHeightLG)),
    [`${skeletonAvatarCls}${skeletonAvatarCls}-sm`]: Object.assign({}, genSkeletonElementAvatarSize(controlHeightSM))
  };
};
const genSkeletonElementInput = token => {
  const {
    controlHeight,
    borderRadiusSM,
    skeletonInputCls,
    controlHeightLG,
    controlHeightSM,
    gradientFromColor,
    calc
  } = token;
  return {
    [skeletonInputCls]: Object.assign({
      display: 'inline-block',
      verticalAlign: 'top',
      background: gradientFromColor,
      borderRadius: borderRadiusSM
    }, genSkeletonElementInputSize(controlHeight, calc)),
    [`${skeletonInputCls}-lg`]: Object.assign({}, genSkeletonElementInputSize(controlHeightLG, calc)),
    [`${skeletonInputCls}-sm`]: Object.assign({}, genSkeletonElementInputSize(controlHeightSM, calc))
  };
};
const genSkeletonElementImageSize = size => Object.assign({
  width: size
}, genSkeletonElementCommonSize(size));
const genSkeletonElementImage = token => {
  const {
    skeletonImageCls,
    imageSizeBase,
    gradientFromColor,
    borderRadiusSM,
    calc
  } = token;
  return {
    [skeletonImageCls]: Object.assign(Object.assign({
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      verticalAlign: 'middle',
      background: gradientFromColor,
      borderRadius: borderRadiusSM
    }, genSkeletonElementImageSize(calc(imageSizeBase).mul(2).equal())), {
      [`${skeletonImageCls}-path`]: {
        fill: '#bfbfbf'
      },
      [`${skeletonImageCls}-svg`]: Object.assign(Object.assign({}, genSkeletonElementImageSize(imageSizeBase)), {
        maxWidth: calc(imageSizeBase).mul(4).equal(),
        maxHeight: calc(imageSizeBase).mul(4).equal()
      }),
      [`${skeletonImageCls}-svg${skeletonImageCls}-svg-circle`]: {
        borderRadius: '50%'
      }
    }),
    [`${skeletonImageCls}${skeletonImageCls}-circle`]: {
      borderRadius: '50%'
    }
  };
};
const genSkeletonElementButtonShape = (token, size, buttonCls) => {
  const {
    skeletonButtonCls
  } = token;
  return {
    [`${buttonCls}${skeletonButtonCls}-circle`]: {
      width: size,
      minWidth: size,
      borderRadius: '50%'
    },
    [`${buttonCls}${skeletonButtonCls}-round`]: {
      borderRadius: size
    }
  };
};
const genSkeletonElementButtonSize = (size, calc) => Object.assign({
  width: calc(size).mul(2).equal(),
  minWidth: calc(size).mul(2).equal()
}, genSkeletonElementCommonSize(size));
const genSkeletonElementButton = token => {
  const {
    borderRadiusSM,
    skeletonButtonCls,
    controlHeight,
    controlHeightLG,
    controlHeightSM,
    gradientFromColor,
    calc
  } = token;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    [skeletonButtonCls]: Object.assign({
      display: 'inline-block',
      verticalAlign: 'top',
      background: gradientFromColor,
      borderRadius: borderRadiusSM,
      width: calc(controlHeight).mul(2).equal(),
      minWidth: calc(controlHeight).mul(2).equal()
    }, genSkeletonElementButtonSize(controlHeight, calc))
  }, genSkeletonElementButtonShape(token, controlHeight, skeletonButtonCls)), {
    [`${skeletonButtonCls}-lg`]: Object.assign({}, genSkeletonElementButtonSize(controlHeightLG, calc))
  }), genSkeletonElementButtonShape(token, controlHeightLG, `${skeletonButtonCls}-lg`)), {
    [`${skeletonButtonCls}-sm`]: Object.assign({}, genSkeletonElementButtonSize(controlHeightSM, calc))
  }), genSkeletonElementButtonShape(token, controlHeightSM, `${skeletonButtonCls}-sm`));
};
// =============================== Base ===============================
const skeleton_style_genBaseStyle = token => {
  const {
    componentCls,
    skeletonAvatarCls,
    skeletonTitleCls,
    skeletonParagraphCls,
    skeletonButtonCls,
    skeletonInputCls,
    skeletonImageCls,
    controlHeight,
    controlHeightLG,
    controlHeightSM,
    gradientFromColor,
    padding,
    marginSM,
    borderRadius,
    titleHeight,
    blockRadius,
    paragraphLiHeight,
    controlHeightXS,
    paragraphMarginTop
  } = token;
  return {
    [componentCls]: {
      display: 'table',
      width: '100%',
      [`${componentCls}-header`]: {
        display: 'table-cell',
        paddingInlineEnd: padding,
        verticalAlign: 'top',
        // Avatar
        [skeletonAvatarCls]: Object.assign({
          display: 'inline-block',
          verticalAlign: 'top',
          background: gradientFromColor
        }, genSkeletonElementAvatarSize(controlHeight)),
        [`${skeletonAvatarCls}-circle`]: {
          borderRadius: '50%'
        },
        [`${skeletonAvatarCls}-lg`]: Object.assign({}, genSkeletonElementAvatarSize(controlHeightLG)),
        [`${skeletonAvatarCls}-sm`]: Object.assign({}, genSkeletonElementAvatarSize(controlHeightSM))
      },
      [`${componentCls}-content`]: {
        display: 'table-cell',
        width: '100%',
        verticalAlign: 'top',
        // Title
        [skeletonTitleCls]: {
          width: '100%',
          height: titleHeight,
          background: gradientFromColor,
          borderRadius: blockRadius,
          [`+ ${skeletonParagraphCls}`]: {
            marginBlockStart: controlHeightSM
          }
        },
        // paragraph
        [skeletonParagraphCls]: {
          padding: 0,
          '> li': {
            width: '100%',
            height: paragraphLiHeight,
            listStyle: 'none',
            background: gradientFromColor,
            borderRadius: blockRadius,
            '+ li': {
              marginBlockStart: controlHeightXS
            }
          }
        },
        [`${skeletonParagraphCls}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
          width: '61%'
        }
      },
      [`&-round ${componentCls}-content`]: {
        [`${skeletonTitleCls}, ${skeletonParagraphCls} > li`]: {
          borderRadius
        }
      }
    },
    [`${componentCls}-with-avatar ${componentCls}-content`]: {
      // Title
      [skeletonTitleCls]: {
        marginBlockStart: marginSM,
        [`+ ${skeletonParagraphCls}`]: {
          marginBlockStart: paragraphMarginTop
        }
      }
    },
    // Skeleton element
    [`${componentCls}${componentCls}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
      display: 'inline-block',
      width: 'auto'
    }, genSkeletonElementButton(token)), genSkeletonElementAvatar(token)), genSkeletonElementInput(token)), genSkeletonElementImage(token)),
    // Skeleton Block Button, Input
    [`${componentCls}${componentCls}-block`]: {
      width: '100%',
      [skeletonButtonCls]: {
        width: '100%'
      },
      [skeletonInputCls]: {
        width: '100%'
      }
    },
    // With active animation
    [`${componentCls}${componentCls}-active`]: {
      [`
        ${skeletonTitleCls},
        ${skeletonParagraphCls} > li,
        ${skeletonAvatarCls},
        ${skeletonButtonCls},
        ${skeletonInputCls},
        ${skeletonImageCls}
      `]: Object.assign({}, genSkeletonColor(token))
    }
  };
};
// ============================== Export ==============================
const skeleton_style_prepareComponentToken = token => {
  const {
    colorFillContent,
    colorFill
  } = token;
  const gradientFromColor = colorFillContent;
  const gradientToColor = colorFill;
  return {
    color: gradientFromColor,
    colorGradientEnd: gradientToColor,
    gradientFromColor,
    gradientToColor,
    titleHeight: token.controlHeight / 2,
    blockRadius: token.borderRadiusSM,
    paragraphMarginTop: token.marginLG + token.marginXXS,
    paragraphLiHeight: token.controlHeight / 2
  };
};
/* harmony default export */ var skeleton_style = (genStyleHooks('Skeleton', token => {
  const {
    componentCls,
    calc
  } = token;
  const skeletonToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    skeletonAvatarCls: `${componentCls}-avatar`,
    skeletonTitleCls: `${componentCls}-title`,
    skeletonParagraphCls: `${componentCls}-paragraph`,
    skeletonButtonCls: `${componentCls}-button`,
    skeletonInputCls: `${componentCls}-input`,
    skeletonImageCls: `${componentCls}-image`,
    imageSizeBase: calc(token.controlHeight).mul(1.5).equal(),
    borderRadius: 100,
    // Large number to make capsule shape
    skeletonLoadingBackground: `linear-gradient(90deg, ${token.gradientFromColor} 25%, ${token.gradientToColor} 37%, ${token.gradientFromColor} 63%)`,
    skeletonLoadingMotionDuration: '1.4s'
  });
  return skeleton_style_genBaseStyle(skeletonToken);
}, skeleton_style_prepareComponentToken, {
  deprecatedTokens: [['color', 'gradientFromColor'], ['colorGradientEnd', 'gradientToColor']]
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/skeleton/Avatar.js
"use client";







const SkeletonAvatar = props => {
  const {
    prefixCls: customizePrefixCls,
    className,
    rootClassName,
    active,
    shape = 'circle',
    size = 'default'
  } = props;
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = skeleton_style(prefixCls);
  const otherProps = (0,omit/* default */.Z)(props, ['prefixCls', 'className']);
  const cls = classnames_default()(prefixCls, `${prefixCls}-element`, {
    [`${prefixCls}-active`]: active
  }, className, rootClassName, hashId, cssVarCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    className: cls
  }, /*#__PURE__*/react.createElement(skeleton_Element, Object.assign({
    prefixCls: `${prefixCls}-avatar`,
    shape: shape,
    size: size
  }, otherProps))));
};
/* harmony default export */ var Avatar = (SkeletonAvatar);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/skeleton/Button.js
"use client";







const SkeletonButton = props => {
  const {
    prefixCls: customizePrefixCls,
    className,
    rootClassName,
    active,
    block = false,
    size = 'default'
  } = props;
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = skeleton_style(prefixCls);
  const otherProps = (0,omit/* default */.Z)(props, ['prefixCls']);
  const cls = classnames_default()(prefixCls, `${prefixCls}-element`, {
    [`${prefixCls}-active`]: active,
    [`${prefixCls}-block`]: block
  }, className, rootClassName, hashId, cssVarCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    className: cls
  }, /*#__PURE__*/react.createElement(skeleton_Element, Object.assign({
    prefixCls: `${prefixCls}-button`,
    size: size
  }, otherProps))));
};
/* harmony default export */ var skeleton_Button = (SkeletonButton);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/skeleton/Image.js
"use client";





const path = 'M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z';
const SkeletonImage = props => {
  const {
    prefixCls: customizePrefixCls,
    className,
    rootClassName,
    style,
    active
  } = props;
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = skeleton_style(prefixCls);
  const cls = classnames_default()(prefixCls, `${prefixCls}-element`, {
    [`${prefixCls}-active`]: active
  }, className, rootClassName, hashId, cssVarCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    className: cls
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${prefixCls}-image`, className),
    style: style
  }, /*#__PURE__*/react.createElement("svg", {
    viewBox: "0 0 1098 1024",
    xmlns: "http://www.w3.org/2000/svg",
    className: `${prefixCls}-image-svg`
  }, /*#__PURE__*/react.createElement("title", null, "Image placeholder"), /*#__PURE__*/react.createElement("path", {
    d: path,
    className: `${prefixCls}-image-path`
  })))));
};
/* harmony default export */ var skeleton_Image = (SkeletonImage);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/skeleton/Input.js
"use client";







const SkeletonInput = props => {
  const {
    prefixCls: customizePrefixCls,
    className,
    rootClassName,
    active,
    block,
    size = 'default'
  } = props;
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = skeleton_style(prefixCls);
  const otherProps = (0,omit/* default */.Z)(props, ['prefixCls']);
  const cls = classnames_default()(prefixCls, `${prefixCls}-element`, {
    [`${prefixCls}-active`]: active,
    [`${prefixCls}-block`]: block
  }, className, rootClassName, hashId, cssVarCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    className: cls
  }, /*#__PURE__*/react.createElement(skeleton_Element, Object.assign({
    prefixCls: `${prefixCls}-input`,
    size: size
  }, otherProps))));
};
/* harmony default export */ var Input = (SkeletonInput);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/skeleton/Node.js
"use client";





const SkeletonNode = props => {
  const {
    prefixCls: customizePrefixCls,
    className,
    rootClassName,
    style,
    active,
    children
  } = props;
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = skeleton_style(prefixCls);
  const cls = classnames_default()(prefixCls, `${prefixCls}-element`, {
    [`${prefixCls}-active`]: active
  }, hashId, className, rootClassName, cssVarCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    className: cls
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${prefixCls}-image`, className),
    style: style
  }, children)));
};
/* harmony default export */ var Node = (SkeletonNode);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/skeleton/Paragraph.js
"use client";



const getWidth = (index, props) => {
  const {
    width,
    rows = 2
  } = props;
  if (Array.isArray(width)) {
    return width[index];
  }
  // last paragraph
  if (rows - 1 === index) {
    return width;
  }
  return undefined;
};
const Paragraph = props => {
  const {
    prefixCls,
    className,
    style,
    rows = 0
  } = props;
  const rowList = Array.from({
    length: rows
  }).map((_, index) => (/*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  react.createElement("li", {
    key: index,
    style: {
      width: getWidth(index, props)
    }
  })));
  return /*#__PURE__*/react.createElement("ul", {
    className: classnames_default()(prefixCls, className),
    style: style
  }, rowList);
};
/* harmony default export */ var skeleton_Paragraph = (Paragraph);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/skeleton/Title.js
"use client";

/* eslint-disable jsx-a11y/heading-has-content */


const Title = ({
  prefixCls,
  className,
  width,
  style
}) => (/*#__PURE__*/
// biome-ignore lint/a11y/useHeadingContent: HOC here
react.createElement("h3", {
  className: classnames_default()(prefixCls, className),
  style: Object.assign({
    width
  }, style)
}));
/* harmony default export */ var skeleton_Title = (Title);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/skeleton/Skeleton.js
"use client";













function getComponentProps(prop) {
  if (prop && typeof prop === 'object') {
    return prop;
  }
  return {};
}
function getAvatarBasicProps(hasTitle, hasParagraph) {
  if (hasTitle && !hasParagraph) {
    // Square avatar
    return {
      size: 'large',
      shape: 'square'
    };
  }
  return {
    size: 'large',
    shape: 'circle'
  };
}
function getTitleBasicProps(hasAvatar, hasParagraph) {
  if (!hasAvatar && hasParagraph) {
    return {
      width: '38%'
    };
  }
  if (hasAvatar && hasParagraph) {
    return {
      width: '50%'
    };
  }
  return {};
}
function getParagraphBasicProps(hasAvatar, hasTitle) {
  const basicProps = {};
  // Width
  if (!hasAvatar || !hasTitle) {
    basicProps.width = '61%';
  }
  // Rows
  if (!hasAvatar && hasTitle) {
    basicProps.rows = 3;
  } else {
    basicProps.rows = 2;
  }
  return basicProps;
}
const Skeleton = props => {
  const {
    prefixCls: customizePrefixCls,
    loading,
    className,
    rootClassName,
    style,
    children,
    avatar = false,
    title = true,
    paragraph = true,
    active,
    round
  } = props;
  const {
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle
  } = useComponentConfig('skeleton');
  const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = skeleton_style(prefixCls);
  if (loading || !('loading' in props)) {
    const hasAvatar = !!avatar;
    const hasTitle = !!title;
    const hasParagraph = !!paragraph;
    // Avatar
    let avatarNode;
    if (hasAvatar) {
      const avatarProps = Object.assign(Object.assign({
        prefixCls: `${prefixCls}-avatar`
      }, getAvatarBasicProps(hasTitle, hasParagraph)), getComponentProps(avatar));
      // We direct use SkeletonElement as avatar in skeleton internal.
      avatarNode = /*#__PURE__*/react.createElement("div", {
        className: `${prefixCls}-header`
      }, /*#__PURE__*/react.createElement(skeleton_Element, Object.assign({}, avatarProps)));
    }
    let contentNode;
    if (hasTitle || hasParagraph) {
      // Title
      let $title;
      if (hasTitle) {
        const titleProps = Object.assign(Object.assign({
          prefixCls: `${prefixCls}-title`
        }, getTitleBasicProps(hasAvatar, hasParagraph)), getComponentProps(title));
        $title = /*#__PURE__*/react.createElement(skeleton_Title, Object.assign({}, titleProps));
      }
      // Paragraph
      let paragraphNode;
      if (hasParagraph) {
        const paragraphProps = Object.assign(Object.assign({
          prefixCls: `${prefixCls}-paragraph`
        }, getParagraphBasicProps(hasAvatar, hasTitle)), getComponentProps(paragraph));
        paragraphNode = /*#__PURE__*/react.createElement(skeleton_Paragraph, Object.assign({}, paragraphProps));
      }
      contentNode = /*#__PURE__*/react.createElement("div", {
        className: `${prefixCls}-content`
      }, $title, paragraphNode);
    }
    const cls = classnames_default()(prefixCls, {
      [`${prefixCls}-with-avatar`]: hasAvatar,
      [`${prefixCls}-active`]: active,
      [`${prefixCls}-rtl`]: direction === 'rtl',
      [`${prefixCls}-round`]: round
    }, contextClassName, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
      className: cls,
      style: Object.assign(Object.assign({}, contextStyle), style)
    }, avatarNode, contentNode));
  }
  return children !== null && children !== void 0 ? children : null;
};
Skeleton.Button = skeleton_Button;
Skeleton.Avatar = Avatar;
Skeleton.Input = Input;
Skeleton.Image = skeleton_Image;
Skeleton.Node = Node;
if (false) {}
/* harmony default export */ var skeleton_Skeleton = (Skeleton);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/skeleton/index.js
"use client";


/* harmony default export */ var skeleton = (skeleton_Skeleton);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/watermark/context.js


function voidFunc() {}
const WatermarkContext = /*#__PURE__*/react.createContext({
  add: voidFunc,
  remove: voidFunc
});
function usePanelRef(panelSelector) {
  const watermark = react.useContext(WatermarkContext);
  const panelEleRef = react.useRef(null);
  const panelRef = (0,hooks_useEvent/* default */.Z)(ele => {
    if (ele) {
      const innerContentEle = panelSelector ? ele.querySelector(panelSelector) : ele;
      watermark.add(innerContentEle);
      panelEleRef.current = innerContentEle;
    } else {
      watermark.remove(panelEleRef.current);
    }
  });
  return panelRef;
}
/* harmony default export */ var context = (WatermarkContext);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/modal/components/NormalCancelBtn.js
"use client";




const NormalCancelBtn = () => {
  const {
    cancelButtonProps,
    cancelTextLocale,
    onCancel
  } = (0,react.useContext)(ModalContext);
  return /*#__PURE__*/react.createElement(es_button, Object.assign({
    onClick: onCancel
  }, cancelButtonProps), cancelTextLocale);
};
/* harmony default export */ var components_NormalCancelBtn = (NormalCancelBtn);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/modal/components/NormalOkBtn.js
"use client";





const NormalOkBtn = () => {
  const {
    confirmLoading,
    okButtonProps,
    okType,
    okTextLocale,
    onOk
  } = (0,react.useContext)(ModalContext);
  return /*#__PURE__*/react.createElement(es_button, Object.assign({}, convertLegacyProps(okType), {
    loading: confirmLoading,
    onClick: onOk
  }, okButtonProps), okTextLocale);
};
/* harmony default export */ var components_NormalOkBtn = (NormalOkBtn);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/modal/shared.js
"use client";










function renderCloseIcon(prefixCls, closeIcon) {
  return /*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-close-x`
  }, closeIcon || /*#__PURE__*/react.createElement(CloseOutlined/* default */.Z, {
    className: `${prefixCls}-close-icon`
  }));
}
const Footer = props => {
  const {
    okText,
    okType = 'primary',
    cancelText,
    confirmLoading,
    onOk,
    onCancel,
    okButtonProps,
    cancelButtonProps,
    footer
  } = props;
  const [locale] = locale_useLocale('Modal', getConfirmLocale());
  // ================== Locale Text ==================
  const okTextLocale = okText || (locale === null || locale === void 0 ? void 0 : locale.okText);
  const cancelTextLocale = cancelText || (locale === null || locale === void 0 ? void 0 : locale.cancelText);
  // ================= Context Value =================
  const btnCtxValue = {
    confirmLoading,
    okButtonProps,
    cancelButtonProps,
    okTextLocale,
    cancelTextLocale,
    okType,
    onOk,
    onCancel
  };
  const btnCtxValueMemo = react.useMemo(() => btnCtxValue, (0,toConsumableArray/* default */.Z)(Object.values(btnCtxValue)));
  let footerNode;
  if (typeof footer === 'function' || typeof footer === 'undefined') {
    footerNode = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(components_NormalCancelBtn, null), /*#__PURE__*/react.createElement(components_NormalOkBtn, null));
    if (typeof footer === 'function') {
      footerNode = footer(footerNode, {
        OkBtn: components_NormalOkBtn,
        CancelBtn: components_NormalCancelBtn
      });
    }
    footerNode = /*#__PURE__*/react.createElement(ModalContextProvider, {
      value: btnCtxValueMemo
    }, footerNode);
  } else {
    footerNode = footer;
  }
  return /*#__PURE__*/react.createElement(DisabledContextProvider, {
    disabled: false
  }, footerNode);
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/grid/style/index.js


// ============================== Row-Shared ==============================
const genGridRowStyle = token => {
  const {
    componentCls
  } = token;
  return {
    // Grid system
    [componentCls]: {
      display: 'flex',
      flexFlow: 'row wrap',
      minWidth: 0,
      '&::before, &::after': {
        display: 'flex'
      },
      '&-no-wrap': {
        flexWrap: 'nowrap'
      },
      // The origin of the X-axis
      '&-start': {
        justifyContent: 'flex-start'
      },
      // The center of the X-axis
      '&-center': {
        justifyContent: 'center'
      },
      // The opposite of the X-axis
      '&-end': {
        justifyContent: 'flex-end'
      },
      '&-space-between': {
        justifyContent: 'space-between'
      },
      '&-space-around': {
        justifyContent: 'space-around'
      },
      '&-space-evenly': {
        justifyContent: 'space-evenly'
      },
      // Align at the top
      '&-top': {
        alignItems: 'flex-start'
      },
      // Align at the center
      '&-middle': {
        alignItems: 'center'
      },
      '&-bottom': {
        alignItems: 'flex-end'
      }
    }
  };
};
// ============================== Col-Shared ==============================
const genGridColStyle = token => {
  const {
    componentCls
  } = token;
  return {
    // Grid system
    [componentCls]: {
      position: 'relative',
      maxWidth: '100%',
      // Prevent columns from collapsing when empty
      minHeight: 1
    }
  };
};
const genLoopGridColumnsStyle = (token, sizeCls) => {
  const {
    prefixCls,
    componentCls,
    gridColumns
  } = token;
  const gridColumnsStyle = {};
  for (let i = gridColumns; i >= 0; i--) {
    if (i === 0) {
      gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = {
        display: 'none'
      };
      gridColumnsStyle[`${componentCls}-push-${i}`] = {
        insetInlineStart: 'auto'
      };
      gridColumnsStyle[`${componentCls}-pull-${i}`] = {
        insetInlineEnd: 'auto'
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
        insetInlineStart: 'auto'
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
        insetInlineEnd: 'auto'
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
        marginInlineStart: 0
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
        order: 0
      };
    } else {
      gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = [
      // https://github.com/ant-design/ant-design/issues/44456
      // Form set `display: flex` on Col which will override `display: block`.
      // Let's get it from css variable to support override.
      {
        ['--ant-display']: 'block',
        // Fallback to display if variable not support
        display: 'block'
      }, {
        display: 'var(--ant-display)',
        flex: `0 0 ${i / gridColumns * 100}%`,
        maxWidth: `${i / gridColumns * 100}%`
      }];
      gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
        insetInlineStart: `${i / gridColumns * 100}%`
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
        insetInlineEnd: `${i / gridColumns * 100}%`
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
        marginInlineStart: `${i / gridColumns * 100}%`
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
        order: i
      };
    }
  }
  // Flex CSS Var
  gridColumnsStyle[`${componentCls}${sizeCls}-flex`] = {
    flex: `var(--${prefixCls}${sizeCls}-flex)`
  };
  return gridColumnsStyle;
};
const genGridStyle = (token, sizeCls) => genLoopGridColumnsStyle(token, sizeCls);
const genGridMediaStyle = (token, screenSize, sizeCls) => ({
  [`@media (min-width: ${(0,cssinjs_es/* unit */.bf)(screenSize)})`]: Object.assign({}, genGridStyle(token, sizeCls))
});
const prepareRowComponentToken = () => ({});
const prepareColComponentToken = () => ({});
// ============================== Export ==============================
const useRowStyle = genStyleHooks('Grid', genGridRowStyle, prepareRowComponentToken);
const getMediaSize = token => {
  const mediaSizesMap = {
    xs: token.screenXSMin,
    sm: token.screenSMMin,
    md: token.screenMDMin,
    lg: token.screenLGMin,
    xl: token.screenXLMin,
    xxl: token.screenXXLMin
  };
  return mediaSizesMap;
};
const useColStyle = genStyleHooks('Grid', token => {
  const gridToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    gridColumns: 24 // Row is divided into 24 parts in Grid
  });
  const gridMediaSizesMap = getMediaSize(gridToken);
  delete gridMediaSizesMap.xs;
  return [genGridColStyle(gridToken), genGridStyle(gridToken, ''), genGridStyle(gridToken, '-xs'), Object.keys(gridMediaSizesMap).map(key => genGridMediaStyle(gridToken, gridMediaSizesMap[key], `-${key}`)).reduce((pre, cur) => Object.assign(Object.assign({}, pre), cur), {})];
}, prepareColComponentToken);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/style/motion/motion.js
const initMotionCommon = duration => ({
  animationDuration: duration,
  animationFillMode: 'both'
});
// FIXME: origin less code seems same as initMotionCommon. Maybe we can safe remove
const initMotionCommonLeave = duration => ({
  animationDuration: duration,
  animationFillMode: 'both'
});
const initMotion = (motionCls, inKeyframes, outKeyframes, duration, sameLevel = false) => {
  const sameLevelPrefix = sameLevel ? '&' : '';
  return {
    [`
      ${sameLevelPrefix}${motionCls}-enter,
      ${sameLevelPrefix}${motionCls}-appear
    `]: Object.assign(Object.assign({}, initMotionCommon(duration)), {
      animationPlayState: 'paused'
    }),
    [`${sameLevelPrefix}${motionCls}-leave`]: Object.assign(Object.assign({}, initMotionCommonLeave(duration)), {
      animationPlayState: 'paused'
    }),
    [`
      ${sameLevelPrefix}${motionCls}-enter${motionCls}-enter-active,
      ${sameLevelPrefix}${motionCls}-appear${motionCls}-appear-active
    `]: {
      animationName: inKeyframes,
      animationPlayState: 'running'
    },
    [`${sameLevelPrefix}${motionCls}-leave${motionCls}-leave-active`]: {
      animationName: outKeyframes,
      animationPlayState: 'running',
      pointerEvents: 'none'
    }
  };
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/style/motion/fade.js


const fadeIn = new cssinjs_es/* Keyframes */.E4('antFadeIn', {
  '0%': {
    opacity: 0
  },
  '100%': {
    opacity: 1
  }
});
const fadeOut = new cssinjs_es/* Keyframes */.E4('antFadeOut', {
  '0%': {
    opacity: 1
  },
  '100%': {
    opacity: 0
  }
});
const initFadeMotion = (token, sameLevel = false) => {
  const {
    antCls
  } = token;
  const motionCls = `${antCls}-fade`;
  const sameLevelPrefix = sameLevel ? '&' : '';
  return [initMotion(motionCls, fadeIn, fadeOut, token.motionDurationMid, sameLevel), {
    [`
        ${sameLevelPrefix}${motionCls}-enter,
        ${sameLevelPrefix}${motionCls}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: 'linear'
    },
    [`${sameLevelPrefix}${motionCls}-leave`]: {
      animationTimingFunction: 'linear'
    }
  }];
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/style/motion/zoom.js


const zoomIn = new cssinjs_es/* Keyframes */.E4('antZoomIn', {
  '0%': {
    transform: 'scale(0.2)',
    opacity: 0
  },
  '100%': {
    transform: 'scale(1)',
    opacity: 1
  }
});
const zoomOut = new cssinjs_es/* Keyframes */.E4('antZoomOut', {
  '0%': {
    transform: 'scale(1)'
  },
  '100%': {
    transform: 'scale(0.2)',
    opacity: 0
  }
});
const zoomBigIn = new cssinjs_es/* Keyframes */.E4('antZoomBigIn', {
  '0%': {
    transform: 'scale(0.8)',
    opacity: 0
  },
  '100%': {
    transform: 'scale(1)',
    opacity: 1
  }
});
const zoomBigOut = new cssinjs_es/* Keyframes */.E4('antZoomBigOut', {
  '0%': {
    transform: 'scale(1)'
  },
  '100%': {
    transform: 'scale(0.8)',
    opacity: 0
  }
});
const zoomUpIn = new cssinjs_es/* Keyframes */.E4('antZoomUpIn', {
  '0%': {
    transform: 'scale(0.8)',
    transformOrigin: '50% 0%',
    opacity: 0
  },
  '100%': {
    transform: 'scale(1)',
    transformOrigin: '50% 0%'
  }
});
const zoomUpOut = new cssinjs_es/* Keyframes */.E4('antZoomUpOut', {
  '0%': {
    transform: 'scale(1)',
    transformOrigin: '50% 0%'
  },
  '100%': {
    transform: 'scale(0.8)',
    transformOrigin: '50% 0%',
    opacity: 0
  }
});
const zoomLeftIn = new cssinjs_es/* Keyframes */.E4('antZoomLeftIn', {
  '0%': {
    transform: 'scale(0.8)',
    transformOrigin: '0% 50%',
    opacity: 0
  },
  '100%': {
    transform: 'scale(1)',
    transformOrigin: '0% 50%'
  }
});
const zoomLeftOut = new cssinjs_es/* Keyframes */.E4('antZoomLeftOut', {
  '0%': {
    transform: 'scale(1)',
    transformOrigin: '0% 50%'
  },
  '100%': {
    transform: 'scale(0.8)',
    transformOrigin: '0% 50%',
    opacity: 0
  }
});
const zoomRightIn = new cssinjs_es/* Keyframes */.E4('antZoomRightIn', {
  '0%': {
    transform: 'scale(0.8)',
    transformOrigin: '100% 50%',
    opacity: 0
  },
  '100%': {
    transform: 'scale(1)',
    transformOrigin: '100% 50%'
  }
});
const zoomRightOut = new cssinjs_es/* Keyframes */.E4('antZoomRightOut', {
  '0%': {
    transform: 'scale(1)',
    transformOrigin: '100% 50%'
  },
  '100%': {
    transform: 'scale(0.8)',
    transformOrigin: '100% 50%',
    opacity: 0
  }
});
const zoomDownIn = new cssinjs_es/* Keyframes */.E4('antZoomDownIn', {
  '0%': {
    transform: 'scale(0.8)',
    transformOrigin: '50% 100%',
    opacity: 0
  },
  '100%': {
    transform: 'scale(1)',
    transformOrigin: '50% 100%'
  }
});
const zoomDownOut = new cssinjs_es/* Keyframes */.E4('antZoomDownOut', {
  '0%': {
    transform: 'scale(1)',
    transformOrigin: '50% 100%'
  },
  '100%': {
    transform: 'scale(0.8)',
    transformOrigin: '50% 100%',
    opacity: 0
  }
});
const zoomMotion = {
  zoom: {
    inKeyframes: zoomIn,
    outKeyframes: zoomOut
  },
  'zoom-big': {
    inKeyframes: zoomBigIn,
    outKeyframes: zoomBigOut
  },
  'zoom-big-fast': {
    inKeyframes: zoomBigIn,
    outKeyframes: zoomBigOut
  },
  'zoom-left': {
    inKeyframes: zoomLeftIn,
    outKeyframes: zoomLeftOut
  },
  'zoom-right': {
    inKeyframes: zoomRightIn,
    outKeyframes: zoomRightOut
  },
  'zoom-up': {
    inKeyframes: zoomUpIn,
    outKeyframes: zoomUpOut
  },
  'zoom-down': {
    inKeyframes: zoomDownIn,
    outKeyframes: zoomDownOut
  }
};
const initZoomMotion = (token, motionName) => {
  const {
    antCls
  } = token;
  const motionCls = `${antCls}-${motionName}`;
  const {
    inKeyframes,
    outKeyframes
  } = zoomMotion[motionName];
  return [initMotion(motionCls, inKeyframes, outKeyframes, motionName === 'zoom-big-fast' ? token.motionDurationFast : token.motionDurationMid), {
    [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
      transform: 'scale(0)',
      opacity: 0,
      animationTimingFunction: token.motionEaseOutCirc,
      '&-prepare': {
        transform: 'none'
      }
    },
    [`${motionCls}-leave`]: {
      animationTimingFunction: token.motionEaseInOutCirc
    }
  }];
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/modal/style/index.js






function box(position) {
  return {
    position,
    inset: 0
  };
}
const genModalMaskStyle = token => {
  const {
    componentCls,
    antCls
  } = token;
  return [{
    [`${componentCls}-root`]: {
      [`${componentCls}${antCls}-zoom-enter, ${componentCls}${antCls}-zoom-appear`]: {
        // reset scale avoid mousePosition bug
        transform: 'none',
        opacity: 0,
        animationDuration: token.motionDurationSlow,
        // https://github.com/ant-design/ant-design/issues/11777
        userSelect: 'none'
      },
      // https://github.com/ant-design/ant-design/issues/37329
      // https://github.com/ant-design/ant-design/issues/40272
      [`${componentCls}${antCls}-zoom-leave ${componentCls}-content`]: {
        pointerEvents: 'none'
      },
      [`${componentCls}-mask`]: Object.assign(Object.assign({}, box('fixed')), {
        zIndex: token.zIndexPopupBase,
        height: '100%',
        backgroundColor: token.colorBgMask,
        pointerEvents: 'none',
        [`${componentCls}-hidden`]: {
          display: 'none'
        }
      }),
      [`${componentCls}-wrap`]: Object.assign(Object.assign({}, box('fixed')), {
        zIndex: token.zIndexPopupBase,
        overflow: 'auto',
        outline: 0,
        WebkitOverflowScrolling: 'touch'
      })
    }
  }, {
    [`${componentCls}-root`]: initFadeMotion(token)
  }];
};
const genModalStyle = token => {
  const {
    componentCls
  } = token;
  return [
  // ======================== Root =========================
  {
    [`${componentCls}-root`]: {
      [`${componentCls}-wrap-rtl`]: {
        direction: 'rtl'
      },
      [`${componentCls}-centered`]: {
        textAlign: 'center',
        '&::before': {
          display: 'inline-block',
          width: 0,
          height: '100%',
          verticalAlign: 'middle',
          content: '""'
        },
        [componentCls]: {
          top: 0,
          display: 'inline-block',
          paddingBottom: 0,
          textAlign: 'start',
          verticalAlign: 'middle'
        }
      },
      [`@media (max-width: ${token.screenSMMax}px)`]: {
        [componentCls]: {
          maxWidth: 'calc(100vw - 16px)',
          margin: `${(0,cssinjs_es/* unit */.bf)(token.marginXS)} auto`
        },
        [`${componentCls}-centered`]: {
          [componentCls]: {
            flex: 1
          }
        }
      }
    }
  },
  // ======================== Modal ========================
  {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      pointerEvents: 'none',
      position: 'relative',
      top: 100,
      width: 'auto',
      maxWidth: `calc(100vw - ${(0,cssinjs_es/* unit */.bf)(token.calc(token.margin).mul(2).equal())})`,
      margin: '0 auto',
      paddingBottom: token.paddingLG,
      [`${componentCls}-title`]: {
        margin: 0,
        color: token.titleColor,
        fontWeight: token.fontWeightStrong,
        fontSize: token.titleFontSize,
        lineHeight: token.titleLineHeight,
        wordWrap: 'break-word'
      },
      [`${componentCls}-content`]: {
        position: 'relative',
        backgroundColor: token.contentBg,
        backgroundClip: 'padding-box',
        border: 0,
        borderRadius: token.borderRadiusLG,
        boxShadow: token.boxShadow,
        pointerEvents: 'auto',
        padding: token.contentPadding
      },
      [`${componentCls}-close`]: Object.assign({
        position: 'absolute',
        top: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
        insetInlineEnd: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
        zIndex: token.calc(token.zIndexPopupBase).add(10).equal(),
        padding: 0,
        color: token.modalCloseIconColor,
        fontWeight: token.fontWeightStrong,
        lineHeight: 1,
        textDecoration: 'none',
        background: 'transparent',
        borderRadius: token.borderRadiusSM,
        width: token.modalCloseBtnSize,
        height: token.modalCloseBtnSize,
        border: 0,
        outline: 0,
        cursor: 'pointer',
        transition: `color ${token.motionDurationMid}, background-color ${token.motionDurationMid}`,
        '&-x': {
          display: 'flex',
          fontSize: token.fontSizeLG,
          fontStyle: 'normal',
          lineHeight: (0,cssinjs_es/* unit */.bf)(token.modalCloseBtnSize),
          justifyContent: 'center',
          textTransform: 'none',
          textRendering: 'auto'
        },
        '&:disabled': {
          pointerEvents: 'none'
        },
        '&:hover': {
          color: token.modalCloseIconHoverColor,
          backgroundColor: token.colorBgTextHover,
          textDecoration: 'none'
        },
        '&:active': {
          backgroundColor: token.colorBgTextActive
        }
      }, genFocusStyle(token)),
      [`${componentCls}-header`]: {
        color: token.colorText,
        background: token.headerBg,
        borderRadius: `${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} ${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} 0 0`,
        marginBottom: token.headerMarginBottom,
        padding: token.headerPadding,
        borderBottom: token.headerBorderBottom
      },
      [`${componentCls}-body`]: {
        fontSize: token.fontSize,
        lineHeight: token.lineHeight,
        wordWrap: 'break-word',
        padding: token.bodyPadding,
        [`${componentCls}-body-skeleton`]: {
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: `${(0,cssinjs_es/* unit */.bf)(token.margin)} auto`
        }
      },
      [`${componentCls}-footer`]: {
        textAlign: 'end',
        background: token.footerBg,
        marginTop: token.footerMarginTop,
        padding: token.footerPadding,
        borderTop: token.footerBorderTop,
        borderRadius: token.footerBorderRadius,
        [`> ${token.antCls}-btn + ${token.antCls}-btn`]: {
          marginInlineStart: token.marginXS
        }
      },
      [`${componentCls}-open`]: {
        overflow: 'hidden'
      }
    })
  },
  // ======================== Pure =========================
  {
    [`${componentCls}-pure-panel`]: {
      top: 'auto',
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      [`${componentCls}-content,
          ${componentCls}-body,
          ${componentCls}-confirm-body-wrapper`]: {
        display: 'flex',
        flexDirection: 'column',
        flex: 'auto'
      },
      [`${componentCls}-confirm-body`]: {
        marginBottom: 'auto'
      }
    }
  }];
};
const genRTLStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}-root`]: {
      [`${componentCls}-wrap-rtl`]: {
        direction: 'rtl',
        [`${componentCls}-confirm-body`]: {
          direction: 'rtl'
        }
      }
    }
  };
};
const genResponsiveWidthStyle = token => {
  const {
    componentCls
  } = token;
  const oriGridMediaSizesMap = getMediaSize(token);
  const gridMediaSizesMap = Object.assign({}, oriGridMediaSizesMap);
  delete gridMediaSizesMap.xs;
  const cssVarPrefix = `--${componentCls.replace('.', '')}-`;
  const responsiveStyles = Object.keys(gridMediaSizesMap).map(key => ({
    [`@media (min-width: ${(0,cssinjs_es/* unit */.bf)(gridMediaSizesMap[key])})`]: {
      width: `var(${cssVarPrefix}${key}-width)`
    }
  }));
  return {
    [`${componentCls}-root`]: {
      [componentCls]: [].concat((0,toConsumableArray/* default */.Z)(Object.keys(oriGridMediaSizesMap).map((currentKey, index) => {
        const previousKey = Object.keys(oriGridMediaSizesMap)[index - 1];
        return previousKey ? {
          [`${cssVarPrefix}${currentKey}-width`]: `var(${cssVarPrefix}${previousKey}-width)`
        } : null;
      })), [{
        width: `var(${cssVarPrefix}xs-width)`
      }], (0,toConsumableArray/* default */.Z)(responsiveStyles))
    }
  };
};
// ============================== Export ==============================
const style_prepareToken = token => {
  const headerPaddingVertical = token.padding;
  const headerFontSize = token.fontSizeHeading5;
  const headerLineHeight = token.lineHeightHeading5;
  const modalToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    modalHeaderHeight: token.calc(token.calc(headerLineHeight).mul(headerFontSize).equal()).add(token.calc(headerPaddingVertical).mul(2).equal()).equal(),
    modalFooterBorderColorSplit: token.colorSplit,
    modalFooterBorderStyle: token.lineType,
    modalFooterBorderWidth: token.lineWidth,
    modalCloseIconColor: token.colorIcon,
    modalCloseIconHoverColor: token.colorIconHover,
    modalCloseBtnSize: token.controlHeight,
    modalConfirmIconSize: token.fontHeight,
    modalTitleHeight: token.calc(token.titleFontSize).mul(token.titleLineHeight).equal()
  });
  return modalToken;
};
const modal_style_prepareComponentToken = token => ({
  footerBg: 'transparent',
  headerBg: token.colorBgElevated,
  titleLineHeight: token.lineHeightHeading5,
  titleFontSize: token.fontSizeHeading5,
  contentBg: token.colorBgElevated,
  titleColor: token.colorTextHeading,
  // internal
  contentPadding: token.wireframe ? 0 : `${(0,cssinjs_es/* unit */.bf)(token.paddingMD)} ${(0,cssinjs_es/* unit */.bf)(token.paddingContentHorizontalLG)}`,
  headerPadding: token.wireframe ? `${(0,cssinjs_es/* unit */.bf)(token.padding)} ${(0,cssinjs_es/* unit */.bf)(token.paddingLG)}` : 0,
  headerBorderBottom: token.wireframe ? `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : 'none',
  headerMarginBottom: token.wireframe ? 0 : token.marginXS,
  bodyPadding: token.wireframe ? token.paddingLG : 0,
  footerPadding: token.wireframe ? `${(0,cssinjs_es/* unit */.bf)(token.paddingXS)} ${(0,cssinjs_es/* unit */.bf)(token.padding)}` : 0,
  footerBorderTop: token.wireframe ? `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : 'none',
  footerBorderRadius: token.wireframe ? `0 0 ${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} ${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)}` : 0,
  footerMarginTop: token.wireframe ? 0 : token.marginSM,
  confirmBodyPadding: token.wireframe ? `${(0,cssinjs_es/* unit */.bf)(token.padding * 2)} ${(0,cssinjs_es/* unit */.bf)(token.padding * 2)} ${(0,cssinjs_es/* unit */.bf)(token.paddingLG)}` : 0,
  confirmIconMarginInlineEnd: token.wireframe ? token.margin : token.marginSM,
  confirmBtnsMarginTop: token.wireframe ? token.marginLG : token.marginSM
});
/* harmony default export */ var modal_style = (genStyleHooks('Modal', token => {
  const modalToken = style_prepareToken(token);
  return [genModalStyle(modalToken), genRTLStyle(modalToken), genModalMaskStyle(modalToken), initZoomMotion(modalToken, 'zoom'), genResponsiveWidthStyle(modalToken)];
}, modal_style_prepareComponentToken, {
  unitless: {
    titleLineHeight: true
  }
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/modal/Modal.js
"use client";

var Modal_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


















let mousePosition;
// ref: https://github.com/ant-design/ant-design/issues/15795
const getClickPosition = e => {
  mousePosition = {
    x: e.pageX,
    y: e.pageY
  };
  // 100ms 内发生过点击事件，则从点击位置动画展示
  // 否则直接 zoom 展示
  // 这样可以兼容非点击方式展开
  setTimeout(() => {
    mousePosition = null;
  }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
if (canUseDocElement()) {
  document.documentElement.addEventListener('click', getClickPosition, true);
}
const Modal = props => {
  const {
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      open,
      wrapClassName,
      centered,
      getContainer,
      focusTriggerAfterClose = true,
      style,
      // Deprecated
      visible,
      width = 520,
      footer,
      classNames: modalClassNames,
      styles: modalStyles,
      children,
      loading,
      confirmLoading,
      zIndex: customizeZIndex,
      mousePosition: customizeMousePosition,
      onOk,
      onCancel,
      destroyOnHidden,
      destroyOnClose,
      panelRef = null
    } = props,
    restProps = Modal_rest(props, ["prefixCls", "className", "rootClassName", "open", "wrapClassName", "centered", "getContainer", "focusTriggerAfterClose", "style", "visible", "width", "footer", "classNames", "styles", "children", "loading", "confirmLoading", "zIndex", "mousePosition", "onOk", "onCancel", "destroyOnHidden", "destroyOnClose", "panelRef"]);
  const {
    getPopupContainer: getContextPopupContainer,
    getPrefixCls,
    direction,
    modal: modalContext
  } = react.useContext(ConfigContext);
  const handleCancel = e => {
    if (confirmLoading) {
      return;
    }
    onCancel === null || onCancel === void 0 ? void 0 : onCancel(e);
  };
  const handleOk = e => {
    onOk === null || onOk === void 0 ? void 0 : onOk(e);
  };
  if (false) {}
  const prefixCls = getPrefixCls('modal', customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  // Style
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = modal_style(prefixCls, rootCls);
  const wrapClassNameExtended = classnames_default()(wrapClassName, {
    [`${prefixCls}-centered`]: centered !== null && centered !== void 0 ? centered : modalContext === null || modalContext === void 0 ? void 0 : modalContext.centered,
    [`${prefixCls}-wrap-rtl`]: direction === 'rtl'
  });
  const dialogFooter = footer !== null && !loading ? (/*#__PURE__*/react.createElement(Footer, Object.assign({}, props, {
    onOk: handleOk,
    onCancel: handleCancel
  }))) : null;
  const [mergedClosable, mergedCloseIcon, closeBtnIsDisabled, ariaProps] = useClosable(pickClosable(props), pickClosable(modalContext), {
    closable: true,
    closeIcon: /*#__PURE__*/react.createElement(CloseOutlined/* default */.Z, {
      className: `${prefixCls}-close-icon`
    }),
    closeIconRender: icon => renderCloseIcon(prefixCls, icon)
  });
  // ============================ Refs ============================
  // Select `ant-modal-content` by `panelRef`
  const innerPanelRef = usePanelRef(`.${prefixCls}-content`);
  const mergedPanelRef = (0,es_ref/* composeRef */.sQ)(panelRef, innerPanelRef);
  // ============================ zIndex ============================
  const [zIndex, contextZIndex] = useZIndex('Modal', customizeZIndex);
  // =========================== Width ============================
  const [numWidth, responsiveWidth] = react.useMemo(() => {
    if (width && typeof width === 'object') {
      return [undefined, width];
    }
    return [width, undefined];
  }, [width]);
  const responsiveWidthVars = react.useMemo(() => {
    const vars = {};
    if (responsiveWidth) {
      Object.keys(responsiveWidth).forEach(breakpoint => {
        const breakpointWidth = responsiveWidth[breakpoint];
        if (breakpointWidth !== undefined) {
          vars[`--${prefixCls}-${breakpoint}-width`] = typeof breakpointWidth === 'number' ? `${breakpointWidth}px` : breakpointWidth;
        }
      });
    }
    return vars;
  }, [responsiveWidth]);
  // =========================== Render ===========================
  return wrapCSSVar(/*#__PURE__*/react.createElement(_util_ContextIsolator, {
    form: true,
    space: true
  }, /*#__PURE__*/react.createElement(zindexContext.Provider, {
    value: contextZIndex
  }, /*#__PURE__*/react.createElement(rc_dialog_es/* default */.Z, Object.assign({
    width: numWidth
  }, restProps, {
    zIndex: zIndex,
    getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
    prefixCls: prefixCls,
    rootClassName: classnames_default()(hashId, rootClassName, cssVarCls, rootCls),
    footer: dialogFooter,
    visible: open !== null && open !== void 0 ? open : visible,
    mousePosition: customizeMousePosition !== null && customizeMousePosition !== void 0 ? customizeMousePosition : mousePosition,
    onClose: handleCancel,
    closable: mergedClosable ? Object.assign({
      disabled: closeBtnIsDisabled,
      closeIcon: mergedCloseIcon
    }, ariaProps) : mergedClosable,
    closeIcon: mergedCloseIcon,
    focusTriggerAfterClose: focusTriggerAfterClose,
    transitionName: getTransitionName(rootPrefixCls, 'zoom', props.transitionName),
    maskTransitionName: getTransitionName(rootPrefixCls, 'fade', props.maskTransitionName),
    className: classnames_default()(hashId, className, modalContext === null || modalContext === void 0 ? void 0 : modalContext.className),
    style: Object.assign(Object.assign(Object.assign({}, modalContext === null || modalContext === void 0 ? void 0 : modalContext.style), style), responsiveWidthVars),
    classNames: Object.assign(Object.assign(Object.assign({}, modalContext === null || modalContext === void 0 ? void 0 : modalContext.classNames), modalClassNames), {
      wrapper: classnames_default()(wrapClassNameExtended, modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.wrapper)
    }),
    styles: Object.assign(Object.assign({}, modalContext === null || modalContext === void 0 ? void 0 : modalContext.styles), modalStyles),
    panelRef: mergedPanelRef,
    // TODO: In the future, destroyOnClose in rc-dialog needs to be upgrade to destroyOnHidden
    destroyOnClose: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : destroyOnClose
  }), loading ? (/*#__PURE__*/react.createElement(skeleton, {
    active: true,
    title: false,
    paragraph: {
      rows: 4
    },
    className: `${prefixCls}-body-skeleton`
  })) : children))));
};
/* harmony default export */ var modal_Modal = (Modal);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/modal/style/confirm.js
// Style as confirm component




// ============================= Confirm ==============================
const genModalConfirmStyle = token => {
  const {
    componentCls,
    titleFontSize,
    titleLineHeight,
    modalConfirmIconSize,
    fontSize,
    lineHeight,
    modalTitleHeight,
    fontHeight,
    confirmBodyPadding
  } = token;
  const confirmComponentCls = `${componentCls}-confirm`;
  return {
    [confirmComponentCls]: {
      '&-rtl': {
        direction: 'rtl'
      },
      [`${token.antCls}-modal-header`]: {
        display: 'none'
      },
      [`${confirmComponentCls}-body-wrapper`]: Object.assign({}, clearFix()),
      [`&${componentCls} ${componentCls}-body`]: {
        padding: confirmBodyPadding
      },
      // ====================== Body ======================
      [`${confirmComponentCls}-body`]: {
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'start',
        [`> ${token.iconCls}`]: {
          flex: 'none',
          fontSize: modalConfirmIconSize,
          marginInlineEnd: token.confirmIconMarginInlineEnd,
          marginTop: token.calc(token.calc(fontHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
        },
        [`&-has-title > ${token.iconCls}`]: {
          marginTop: token.calc(token.calc(modalTitleHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
        }
      },
      [`${confirmComponentCls}-paragraph`]: {
        display: 'flex',
        flexDirection: 'column',
        flex: 'auto',
        rowGap: token.marginXS,
        // https://github.com/ant-design/ant-design/issues/51912
        maxWidth: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(token.marginSM)})`
      },
      // https://github.com/ant-design/ant-design/issues/48159
      [`${token.iconCls} + ${confirmComponentCls}-paragraph`]: {
        maxWidth: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(token.calc(token.modalConfirmIconSize).add(token.marginSM).equal())})`
      },
      [`${confirmComponentCls}-title`]: {
        color: token.colorTextHeading,
        fontWeight: token.fontWeightStrong,
        fontSize: titleFontSize,
        lineHeight: titleLineHeight
      },
      [`${confirmComponentCls}-content`]: {
        color: token.colorText,
        fontSize,
        lineHeight
      },
      // ===================== Footer =====================
      [`${confirmComponentCls}-btns`]: {
        textAlign: 'end',
        marginTop: token.confirmBtnsMarginTop,
        [`${token.antCls}-btn + ${token.antCls}-btn`]: {
          marginBottom: 0,
          marginInlineStart: token.marginXS
        }
      }
    },
    [`${confirmComponentCls}-error ${confirmComponentCls}-body > ${token.iconCls}`]: {
      color: token.colorError
    },
    [`${confirmComponentCls}-warning ${confirmComponentCls}-body > ${token.iconCls},
        ${confirmComponentCls}-confirm ${confirmComponentCls}-body > ${token.iconCls}`]: {
      color: token.colorWarning
    },
    [`${confirmComponentCls}-info ${confirmComponentCls}-body > ${token.iconCls}`]: {
      color: token.colorInfo
    },
    [`${confirmComponentCls}-success ${confirmComponentCls}-body > ${token.iconCls}`]: {
      color: token.colorSuccess
    }
  };
};
// ============================== Export ==============================
/* harmony default export */ var style_confirm = (genSubStyleComponent(['Modal', 'confirm'], token => {
  const modalToken = style_prepareToken(token);
  return genModalConfirmStyle(modalToken);
}, modal_style_prepareComponentToken, {
  // confirm is weak than modal since no conflict here
  order: -1000
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/modal/ConfirmDialog.js
"use client";


var ConfirmDialog_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

















function ConfirmContent(props) {
  const {
      prefixCls,
      icon,
      okText,
      cancelText,
      confirmPrefixCls,
      type,
      okCancel,
      footer,
      // Legacy for static function usage
      locale: staticLocale
    } = props,
    resetProps = ConfirmDialog_rest(props, ["prefixCls", "icon", "okText", "cancelText", "confirmPrefixCls", "type", "okCancel", "footer", "locale"]);
  if (false) {}
  // Icon
  let mergedIcon = icon;
  // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon
  if (!icon && icon !== null) {
    switch (type) {
      case 'info':
        mergedIcon = /*#__PURE__*/react.createElement(InfoCircleFilled/* default */.Z, null);
        break;
      case 'success':
        mergedIcon = /*#__PURE__*/react.createElement(CheckCircleFilled/* default */.Z, null);
        break;
      case 'error':
        mergedIcon = /*#__PURE__*/react.createElement(CloseCircleFilled/* default */.Z, null);
        break;
      default:
        mergedIcon = /*#__PURE__*/react.createElement(ExclamationCircleFilled/* default */.Z, null);
    }
  }
  // 默认为 true，保持向下兼容
  const mergedOkCancel = okCancel !== null && okCancel !== void 0 ? okCancel : type === 'confirm';
  const autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
  const [locale] = locale_useLocale('Modal');
  const mergedLocale = staticLocale || locale;
  // ================== Locale Text ==================
  const okTextLocale = okText || (mergedOkCancel ? mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.okText : mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.justOkText);
  const cancelTextLocale = cancelText || (mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.cancelText);
  // ================= Context Value =================
  const btnCtxValue = Object.assign({
    autoFocusButton,
    cancelTextLocale,
    okTextLocale,
    mergedOkCancel
  }, resetProps);
  const btnCtxValueMemo = react.useMemo(() => btnCtxValue, (0,toConsumableArray/* default */.Z)(Object.values(btnCtxValue)));
  // ====================== Footer Origin Node ======================
  const footerOriginNode = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(components_ConfirmCancelBtn, null), /*#__PURE__*/react.createElement(components_ConfirmOkBtn, null));
  const hasTitle = props.title !== undefined && props.title !== null;
  const bodyCls = `${confirmPrefixCls}-body`;
  return /*#__PURE__*/react.createElement("div", {
    className: `${confirmPrefixCls}-body-wrapper`
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(bodyCls, {
      [`${bodyCls}-has-title`]: hasTitle
    })
  }, mergedIcon, /*#__PURE__*/react.createElement("div", {
    className: `${confirmPrefixCls}-paragraph`
  }, hasTitle && /*#__PURE__*/react.createElement("span", {
    className: `${confirmPrefixCls}-title`
  }, props.title), /*#__PURE__*/react.createElement("div", {
    className: `${confirmPrefixCls}-content`
  }, props.content))), footer === undefined || typeof footer === 'function' ? (/*#__PURE__*/react.createElement(ModalContextProvider, {
    value: btnCtxValueMemo
  }, /*#__PURE__*/react.createElement("div", {
    className: `${confirmPrefixCls}-btns`
  }, typeof footer === 'function' ? footer(footerOriginNode, {
    OkBtn: components_ConfirmOkBtn,
    CancelBtn: components_ConfirmCancelBtn
  }) : footerOriginNode))) : footer, /*#__PURE__*/react.createElement(style_confirm, {
    prefixCls: prefixCls
  }));
}
const ConfirmDialog = props => {
  const {
    close,
    zIndex,
    maskStyle,
    direction,
    prefixCls,
    wrapClassName,
    rootPrefixCls,
    bodyStyle,
    closable = false,
    onConfirm,
    styles
  } = props;
  if (false) {}
  const confirmPrefixCls = `${prefixCls}-confirm`;
  const width = props.width || 416;
  const style = props.style || {};
  const mask = props.mask === undefined ? true : props.mask;
  // 默认为 false，保持旧版默认行为
  const maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
  const classString = classnames_default()(confirmPrefixCls, `${confirmPrefixCls}-${props.type}`, {
    [`${confirmPrefixCls}-rtl`]: direction === 'rtl'
  }, props.className);
  // ========================= zIndex =========================
  const [, token] = useToken();
  const mergedZIndex = react.useMemo(() => {
    if (zIndex !== undefined) {
      return zIndex;
    }
    // Static always use max zIndex
    return token.zIndexPopupBase + CONTAINER_MAX_OFFSET;
  }, [zIndex, token]);
  // ========================= Render =========================
  return /*#__PURE__*/react.createElement(modal_Modal, Object.assign({}, props, {
    className: classString,
    wrapClassName: classnames_default()({
      [`${confirmPrefixCls}-centered`]: !!props.centered
    }, wrapClassName),
    onCancel: () => {
      close === null || close === void 0 ? void 0 : close({
        triggerCancel: true
      });
      onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(false);
    },
    title: "",
    footer: null,
    transitionName: getTransitionName(rootPrefixCls || '', 'zoom', props.transitionName),
    maskTransitionName: getTransitionName(rootPrefixCls || '', 'fade', props.maskTransitionName),
    mask: mask,
    maskClosable: maskClosable,
    style: style,
    styles: Object.assign({
      body: bodyStyle,
      mask: maskStyle
    }, styles),
    width: width,
    zIndex: mergedZIndex,
    closable: closable
  }), /*#__PURE__*/react.createElement(ConfirmContent, Object.assign({}, props, {
    confirmPrefixCls: confirmPrefixCls
  })));
};
const ConfirmDialogWrapper = props => {
  const {
    rootPrefixCls,
    iconPrefixCls,
    direction,
    theme
  } = props;
  return /*#__PURE__*/react.createElement(config_provider, {
    prefixCls: rootPrefixCls,
    iconPrefixCls: iconPrefixCls,
    direction: direction,
    theme: theme
  }, /*#__PURE__*/react.createElement(ConfirmDialog, Object.assign({}, props)));
};
if (false) {}
/* harmony default export */ var modal_ConfirmDialog = (ConfirmDialogWrapper);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/modal/destroyFns.js
const destroyFns = [];
/* harmony default export */ var modal_destroyFns = (destroyFns);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/modal/confirm.js
"use client";









let defaultRootPrefixCls = '';
function getRootPrefixCls() {
  return defaultRootPrefixCls;
}
const confirm_ConfirmDialogWrapper = props => {
  var _a, _b;
  const {
    prefixCls: customizePrefixCls,
    getContainer,
    direction
  } = props;
  const runtimeLocale = getConfirmLocale();
  const config = (0,react.useContext)(ConfigContext);
  const rootPrefixCls = getRootPrefixCls() || config.getPrefixCls();
  // because Modal.config set rootPrefixCls, which is different from other components
  const prefixCls = customizePrefixCls || `${rootPrefixCls}-modal`;
  let mergedGetContainer = getContainer;
  if (mergedGetContainer === false) {
    mergedGetContainer = undefined;
    if (false) {}
  }
  return /*#__PURE__*/react.createElement(modal_ConfirmDialog, Object.assign({}, props, {
    rootPrefixCls: rootPrefixCls,
    prefixCls: prefixCls,
    iconPrefixCls: config.iconPrefixCls,
    theme: config.theme,
    direction: direction !== null && direction !== void 0 ? direction : config.direction,
    locale: (_b = (_a = config.locale) === null || _a === void 0 ? void 0 : _a.Modal) !== null && _b !== void 0 ? _b : runtimeLocale,
    getContainer: mergedGetContainer
  }));
};
function confirm_confirm(config) {
  const global = globalConfig();
  if (false) {}
  const container = document.createDocumentFragment();
  let currentConfig = Object.assign(Object.assign({}, config), {
    close,
    open: true
  });
  let timeoutId;
  let reactUnmount;
  function destroy(...args) {
    var _a;
    const triggerCancel = args.some(param => param === null || param === void 0 ? void 0 : param.triggerCancel);
    if (triggerCancel) {
      var _a2;
      (_a = config.onCancel) === null || _a === void 0 ? void 0 : (_a2 = _a).call.apply(_a2, [config, () => {}].concat((0,toConsumableArray/* default */.Z)(args.slice(1))));
    }
    for (let i = 0; i < modal_destroyFns.length; i++) {
      const fn = modal_destroyFns[i];
      if (fn === close) {
        modal_destroyFns.splice(i, 1);
        break;
      }
    }
    reactUnmount();
  }
  function render(props) {
    clearTimeout(timeoutId);
    /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */
    timeoutId = setTimeout(() => {
      const rootPrefixCls = global.getPrefixCls(undefined, getRootPrefixCls());
      const iconPrefixCls = global.getIconPrefixCls();
      const theme = global.getTheme();
      const dom = /*#__PURE__*/react.createElement(confirm_ConfirmDialogWrapper, Object.assign({}, props));
      const reactRender = unstableSetRender();
      reactUnmount = reactRender(/*#__PURE__*/react.createElement(config_provider, {
        prefixCls: rootPrefixCls,
        iconPrefixCls: iconPrefixCls,
        theme: theme
      }, global.holderRender ? global.holderRender(dom) : dom), container);
    });
  }
  function close(...args) {
    currentConfig = Object.assign(Object.assign({}, currentConfig), {
      open: false,
      afterClose: () => {
        if (typeof config.afterClose === 'function') {
          config.afterClose();
        }
        // @ts-ignore
        destroy.apply(this, args);
      }
    });
    // Legacy support
    if (currentConfig.visible) {
      delete currentConfig.visible;
    }
    render(currentConfig);
  }
  function update(configUpdate) {
    if (typeof configUpdate === 'function') {
      currentConfig = configUpdate(currentConfig);
    } else {
      currentConfig = Object.assign(Object.assign({}, currentConfig), configUpdate);
    }
    render(currentConfig);
  }
  render(currentConfig);
  modal_destroyFns.push(close);
  return {
    destroy: close,
    update
  };
}
function withWarn(props) {
  return Object.assign(Object.assign({}, props), {
    type: 'warning'
  });
}
function withInfo(props) {
  return Object.assign(Object.assign({}, props), {
    type: 'info'
  });
}
function withSuccess(props) {
  return Object.assign(Object.assign({}, props), {
    type: 'success'
  });
}
function withError(props) {
  return Object.assign(Object.assign({}, props), {
    type: 'error'
  });
}
function withConfirm(props) {
  return Object.assign(Object.assign({}, props), {
    type: 'confirm'
  });
}
function modalGlobalConfig({
  rootPrefixCls
}) {
   false ? 0 : void 0;
  defaultRootPrefixCls = rootPrefixCls;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/modal/useModal/HookModal.js
"use client";


var HookModal_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





const HookModal = (_a, ref) => {
  var _b;
  var {
      afterClose: hookAfterClose,
      config
    } = _a,
    restProps = HookModal_rest(_a, ["afterClose", "config"]);
  const [open, setOpen] = react.useState(true);
  const [innerConfig, setInnerConfig] = react.useState(config);
  const {
    direction,
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('modal');
  const rootPrefixCls = getPrefixCls();
  const afterClose = () => {
    var _a;
    hookAfterClose();
    (_a = innerConfig.afterClose) === null || _a === void 0 ? void 0 : _a.call(innerConfig);
  };
  const close = (...args) => {
    var _a;
    setOpen(false);
    const triggerCancel = args.some(param => param === null || param === void 0 ? void 0 : param.triggerCancel);
    if (triggerCancel) {
      var _a2;
      (_a = innerConfig.onCancel) === null || _a === void 0 ? void 0 : (_a2 = _a).call.apply(_a2, [innerConfig, () => {}].concat((0,toConsumableArray/* default */.Z)(args.slice(1))));
    }
  };
  react.useImperativeHandle(ref, () => ({
    destroy: close,
    update: newConfig => {
      setInnerConfig(originConfig => {
        const nextConfig = typeof newConfig === 'function' ? newConfig(originConfig) : newConfig;
        return Object.assign(Object.assign({}, originConfig), nextConfig);
      });
    }
  }));
  const mergedOkCancel = (_b = innerConfig.okCancel) !== null && _b !== void 0 ? _b : innerConfig.type === 'confirm';
  const [contextLocale] = locale_useLocale('Modal', es_locale_en_US.Modal);
  return /*#__PURE__*/react.createElement(modal_ConfirmDialog, Object.assign({
    prefixCls: prefixCls,
    rootPrefixCls: rootPrefixCls
  }, innerConfig, {
    close: close,
    open: open,
    afterClose: afterClose,
    okText: innerConfig.okText || (mergedOkCancel ? contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.okText : contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.justOkText),
    direction: innerConfig.direction || direction,
    cancelText: innerConfig.cancelText || (contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.cancelText)
  }, restProps));
};
/* harmony default export */ var useModal_HookModal = (/*#__PURE__*/react.forwardRef(HookModal));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/modal/useModal/index.js
"use client";







let uuid = 0;
const ElementsHolder = /*#__PURE__*/react.memo(/*#__PURE__*/react.forwardRef((_props, ref) => {
  const [elements, patchElement] = usePatchElement();
  react.useImperativeHandle(ref, () => ({
    patchElement
  }), []);
  return /*#__PURE__*/react.createElement(react.Fragment, null, elements);
}));
function useModal() {
  const holderRef = react.useRef(null);
  // ========================== Effect ==========================
  const [actionQueue, setActionQueue] = react.useState([]);
  react.useEffect(() => {
    if (actionQueue.length) {
      const cloneQueue = (0,toConsumableArray/* default */.Z)(actionQueue);
      cloneQueue.forEach(action => {
        action();
      });
      setActionQueue([]);
    }
  }, [actionQueue]);
  // =========================== Hook ===========================
  const getConfirmFunc = react.useCallback(withFunc => function hookConfirm(config) {
    var _a;
    uuid += 1;
    const modalRef = /*#__PURE__*/react.createRef();
    // Proxy to promise with `onClose`
    let resolvePromise;
    const promise = new Promise(resolve => {
      resolvePromise = resolve;
    });
    let silent = false;
    let closeFunc;
    const modal = /*#__PURE__*/react.createElement(useModal_HookModal, {
      key: `modal-${uuid}`,
      config: withFunc(config),
      ref: modalRef,
      afterClose: () => {
        closeFunc === null || closeFunc === void 0 ? void 0 : closeFunc();
      },
      isSilent: () => silent,
      onConfirm: confirmed => {
        resolvePromise(confirmed);
      }
    });
    closeFunc = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.patchElement(modal);
    if (closeFunc) {
      modal_destroyFns.push(closeFunc);
    }
    const instance = {
      destroy: () => {
        function destroyAction() {
          var _a;
          (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
        }
        if (modalRef.current) {
          destroyAction();
        } else {
          setActionQueue(prev => [].concat((0,toConsumableArray/* default */.Z)(prev), [destroyAction]));
        }
      },
      update: newConfig => {
        function updateAction() {
          var _a;
          (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.update(newConfig);
        }
        if (modalRef.current) {
          updateAction();
        } else {
          setActionQueue(prev => [].concat((0,toConsumableArray/* default */.Z)(prev), [updateAction]));
        }
      },
      then: resolve => {
        silent = true;
        return promise.then(resolve);
      }
    };
    return instance;
  }, []);
  const fns = react.useMemo(() => ({
    info: getConfirmFunc(withInfo),
    success: getConfirmFunc(withSuccess),
    error: getConfirmFunc(withError),
    warning: getConfirmFunc(withWarn),
    confirm: getConfirmFunc(withConfirm)
  }), []);
  return [fns, /*#__PURE__*/react.createElement(ElementsHolder, {
    key: "modal-holder",
    ref: holderRef
  })];
}
/* harmony default export */ var modal_useModal = (useModal);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/notification/style/placement.js

const genNotificationPlacementStyle = token => {
  const {
    componentCls,
    notificationMarginEdge,
    animationMaxHeight
  } = token;
  const noticeCls = `${componentCls}-notice`;
  const rightFadeIn = new cssinjs_es/* Keyframes */.E4('antNotificationFadeIn', {
    '0%': {
      transform: `translate3d(100%, 0, 0)`,
      opacity: 0
    },
    '100%': {
      transform: `translate3d(0, 0, 0)`,
      opacity: 1
    }
  });
  const topFadeIn = new cssinjs_es/* Keyframes */.E4('antNotificationTopFadeIn', {
    '0%': {
      top: -animationMaxHeight,
      opacity: 0
    },
    '100%': {
      top: 0,
      opacity: 1
    }
  });
  const bottomFadeIn = new cssinjs_es/* Keyframes */.E4('antNotificationBottomFadeIn', {
    '0%': {
      bottom: token.calc(animationMaxHeight).mul(-1).equal(),
      opacity: 0
    },
    '100%': {
      bottom: 0,
      opacity: 1
    }
  });
  const leftFadeIn = new cssinjs_es/* Keyframes */.E4('antNotificationLeftFadeIn', {
    '0%': {
      transform: `translate3d(-100%, 0, 0)`,
      opacity: 0
    },
    '100%': {
      transform: `translate3d(0, 0, 0)`,
      opacity: 1
    }
  });
  return {
    [componentCls]: {
      [`&${componentCls}-top, &${componentCls}-bottom`]: {
        marginInline: 0,
        [noticeCls]: {
          marginInline: 'auto auto'
        }
      },
      [`&${componentCls}-top`]: {
        [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
          animationName: topFadeIn
        }
      },
      [`&${componentCls}-bottom`]: {
        [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
          animationName: bottomFadeIn
        }
      },
      [`&${componentCls}-topRight, &${componentCls}-bottomRight`]: {
        [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
          animationName: rightFadeIn
        }
      },
      [`&${componentCls}-topLeft, &${componentCls}-bottomLeft`]: {
        marginRight: {
          value: 0,
          _skip_check_: true
        },
        marginLeft: {
          value: notificationMarginEdge,
          _skip_check_: true
        },
        [noticeCls]: {
          marginInlineEnd: 'auto',
          marginInlineStart: 0
        },
        [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
          animationName: leftFadeIn
        }
      }
    }
  };
};
/* harmony default export */ var placement = (genNotificationPlacementStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/notification/interface.js
const NotificationPlacements = ['top', 'topLeft', 'topRight', 'bottom', 'bottomLeft', 'bottomRight'];
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/notification/style/stack.js

const placementAlignProperty = {
  topLeft: 'left',
  topRight: 'right',
  bottomLeft: 'left',
  bottomRight: 'right',
  top: 'left',
  bottom: 'left'
};
const genPlacementStackStyle = (token, placement) => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}-${placement}`]: {
      [`&${componentCls}-stack > ${componentCls}-notice-wrapper`]: {
        [placement.startsWith('top') ? 'top' : 'bottom']: 0,
        [placementAlignProperty[placement]]: {
          value: 0,
          _skip_check_: true
        }
      }
    }
  };
};
const genStackChildrenStyle = token => {
  const childrenStyle = {};
  for (let i = 1; i < token.notificationStackLayer; i++) {
    childrenStyle[`&:nth-last-child(${i + 1})`] = {
      overflow: 'hidden',
      [`& > ${token.componentCls}-notice`]: {
        opacity: 0,
        transition: `opacity ${token.motionDurationMid}`
      }
    };
  }
  return Object.assign({
    [`&:not(:nth-last-child(-n+${token.notificationStackLayer}))`]: {
      opacity: 0,
      overflow: 'hidden',
      color: 'transparent',
      pointerEvents: 'none'
    }
  }, childrenStyle);
};
const genStackedNoticeStyle = token => {
  const childrenStyle = {};
  for (let i = 1; i < token.notificationStackLayer; i++) {
    childrenStyle[`&:nth-last-child(${i + 1})`] = {
      background: token.colorBgBlur,
      backdropFilter: 'blur(10px)',
      '-webkit-backdrop-filter': 'blur(10px)'
    };
  }
  return Object.assign({}, childrenStyle);
};
const genStackStyle = token => {
  const {
    componentCls
  } = token;
  return Object.assign({
    [`${componentCls}-stack`]: {
      [`& > ${componentCls}-notice-wrapper`]: Object.assign({
        transition: `transform ${token.motionDurationSlow}, backdrop-filter 0s`,
        willChange: 'transform, opacity',
        position: 'absolute'
      }, genStackChildrenStyle(token))
    },
    [`${componentCls}-stack:not(${componentCls}-stack-expanded)`]: {
      [`& > ${componentCls}-notice-wrapper`]: Object.assign({}, genStackedNoticeStyle(token))
    },
    [`${componentCls}-stack${componentCls}-stack-expanded`]: {
      [`& > ${componentCls}-notice-wrapper`]: {
        '&:not(:nth-last-child(-n + 1))': {
          opacity: 1,
          overflow: 'unset',
          color: 'inherit',
          pointerEvents: 'auto',
          [`& > ${token.componentCls}-notice`]: {
            opacity: 1
          }
        },
        '&:after': {
          content: '""',
          position: 'absolute',
          height: token.margin,
          width: '100%',
          insetInline: 0,
          bottom: token.calc(token.margin).mul(-1).equal(),
          background: 'transparent',
          pointerEvents: 'auto'
        }
      }
    }
  }, NotificationPlacements.map(placement => genPlacementStackStyle(token, placement)).reduce((acc, cur) => Object.assign(Object.assign({}, acc), cur), {}));
};
/* harmony default export */ var stack = (genStackStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/notification/style/index.js






const genNoticeStyle = token => {
  const {
    iconCls,
    componentCls,
    // .ant-notification
    boxShadow,
    fontSizeLG,
    notificationMarginBottom,
    borderRadiusLG,
    colorSuccess,
    colorInfo,
    colorWarning,
    colorError,
    colorTextHeading,
    notificationBg,
    notificationPadding,
    notificationMarginEdge,
    notificationProgressBg,
    notificationProgressHeight,
    fontSize,
    lineHeight,
    width,
    notificationIconSize,
    colorText
  } = token;
  const noticeCls = `${componentCls}-notice`;
  return {
    position: 'relative',
    marginBottom: notificationMarginBottom,
    marginInlineStart: 'auto',
    background: notificationBg,
    borderRadius: borderRadiusLG,
    boxShadow,
    [noticeCls]: {
      padding: notificationPadding,
      width,
      maxWidth: `calc(100vw - ${(0,cssinjs_es/* unit */.bf)(token.calc(notificationMarginEdge).mul(2).equal())})`,
      overflow: 'hidden',
      lineHeight,
      wordWrap: 'break-word'
    },
    [`${noticeCls}-message`]: {
      color: colorTextHeading,
      fontSize: fontSizeLG,
      lineHeight: token.lineHeightLG
    },
    [`${noticeCls}-description`]: {
      fontSize,
      color: colorText,
      marginTop: token.marginXS
    },
    [`${noticeCls}-closable ${noticeCls}-message`]: {
      paddingInlineEnd: token.paddingLG
    },
    [`${noticeCls}-with-icon ${noticeCls}-message`]: {
      marginInlineStart: token.calc(token.marginSM).add(notificationIconSize).equal(),
      fontSize: fontSizeLG
    },
    [`${noticeCls}-with-icon ${noticeCls}-description`]: {
      marginInlineStart: token.calc(token.marginSM).add(notificationIconSize).equal(),
      fontSize
    },
    // Icon & color style in different selector level
    // https://github.com/ant-design/ant-design/issues/16503
    // https://github.com/ant-design/ant-design/issues/15512
    [`${noticeCls}-icon`]: {
      position: 'absolute',
      fontSize: notificationIconSize,
      lineHeight: 1,
      // icon-font
      [`&-success${iconCls}`]: {
        color: colorSuccess
      },
      [`&-info${iconCls}`]: {
        color: colorInfo
      },
      [`&-warning${iconCls}`]: {
        color: colorWarning
      },
      [`&-error${iconCls}`]: {
        color: colorError
      }
    },
    [`${noticeCls}-close`]: Object.assign({
      position: 'absolute',
      top: token.notificationPaddingVertical,
      insetInlineEnd: token.notificationPaddingHorizontal,
      color: token.colorIcon,
      outline: 'none',
      width: token.notificationCloseButtonSize,
      height: token.notificationCloseButtonSize,
      borderRadius: token.borderRadiusSM,
      transition: `background-color ${token.motionDurationMid}, color ${token.motionDurationMid}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'none',
      border: 'none',
      '&:hover': {
        color: token.colorIconHover,
        backgroundColor: token.colorBgTextHover
      },
      '&:active': {
        backgroundColor: token.colorBgTextActive
      }
    }, genFocusStyle(token)),
    [`${noticeCls}-progress`]: {
      position: 'absolute',
      display: 'block',
      appearance: 'none',
      inlineSize: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(borderRadiusLG)} * 2)`,
      left: {
        _skip_check_: true,
        value: borderRadiusLG
      },
      right: {
        _skip_check_: true,
        value: borderRadiusLG
      },
      bottom: 0,
      blockSize: notificationProgressHeight,
      border: 0,
      '&, &::-webkit-progress-bar': {
        borderRadius: borderRadiusLG,
        backgroundColor: `rgba(0, 0, 0, 0.04)`
      },
      '&::-moz-progress-bar': {
        background: notificationProgressBg
      },
      '&::-webkit-progress-value': {
        borderRadius: borderRadiusLG,
        background: notificationProgressBg
      }
    },
    [`${noticeCls}-actions`]: {
      float: 'right',
      marginTop: token.marginSM
    }
  };
};
const genNotificationStyle = token => {
  const {
    componentCls,
    // .ant-notification
    notificationMarginBottom,
    notificationMarginEdge,
    motionDurationMid,
    motionEaseInOut
  } = token;
  const noticeCls = `${componentCls}-notice`;
  const fadeOut = new cssinjs_es/* Keyframes */.E4('antNotificationFadeOut', {
    '0%': {
      maxHeight: token.animationMaxHeight,
      marginBottom: notificationMarginBottom
    },
    '100%': {
      maxHeight: 0,
      marginBottom: 0,
      paddingTop: 0,
      paddingBottom: 0,
      opacity: 0
    }
  });
  return [
  // ============================ Holder ============================
  {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      position: 'fixed',
      zIndex: token.zIndexPopup,
      marginRight: {
        value: notificationMarginEdge,
        _skip_check_: true
      },
      [`${componentCls}-hook-holder`]: {
        position: 'relative'
      },
      //  animation
      [`${componentCls}-fade-appear-prepare`]: {
        opacity: '0 !important'
      },
      [`${componentCls}-fade-enter, ${componentCls}-fade-appear`]: {
        animationDuration: token.motionDurationMid,
        animationTimingFunction: motionEaseInOut,
        animationFillMode: 'both',
        opacity: 0,
        animationPlayState: 'paused'
      },
      [`${componentCls}-fade-leave`]: {
        animationTimingFunction: motionEaseInOut,
        animationFillMode: 'both',
        animationDuration: motionDurationMid,
        animationPlayState: 'paused'
      },
      [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
        animationPlayState: 'running'
      },
      [`${componentCls}-fade-leave${componentCls}-fade-leave-active`]: {
        animationName: fadeOut,
        animationPlayState: 'running'
      },
      // RTL
      '&-rtl': {
        direction: 'rtl',
        [`${noticeCls}-actions`]: {
          float: 'left'
        }
      }
    })
  },
  // ============================ Notice ============================
  {
    [componentCls]: {
      [`${noticeCls}-wrapper`]: Object.assign({}, genNoticeStyle(token))
    }
  }];
};
// ============================== Export ==============================
const notification_style_prepareComponentToken = token => ({
  zIndexPopup: token.zIndexPopupBase + CONTAINER_MAX_OFFSET + 50,
  width: 384
});
const prepareNotificationToken = token => {
  const notificationPaddingVertical = token.paddingMD;
  const notificationPaddingHorizontal = token.paddingLG;
  const notificationToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    notificationBg: token.colorBgElevated,
    notificationPaddingVertical,
    notificationPaddingHorizontal,
    notificationIconSize: token.calc(token.fontSizeLG).mul(token.lineHeightLG).equal(),
    notificationCloseButtonSize: token.calc(token.controlHeightLG).mul(0.55).equal(),
    notificationMarginBottom: token.margin,
    notificationPadding: `${(0,cssinjs_es/* unit */.bf)(token.paddingMD)} ${(0,cssinjs_es/* unit */.bf)(token.paddingContentHorizontalLG)}`,
    notificationMarginEdge: token.marginLG,
    animationMaxHeight: 150,
    notificationStackLayer: 3,
    notificationProgressHeight: 2,
    notificationProgressBg: `linear-gradient(90deg, ${token.colorPrimaryBorderHover}, ${token.colorPrimary})`
  });
  return notificationToken;
};
/* harmony default export */ var notification_style = (genStyleHooks('Notification', token => {
  const notificationToken = prepareNotificationToken(token);
  return [genNotificationStyle(notificationToken), placement(notificationToken), stack(notificationToken)];
}, notification_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/notification/style/pure-panel.js



/* harmony default export */ var pure_panel = (genSubStyleComponent(['Notification', 'PurePanel'], token => {
  const noticeCls = `${token.componentCls}-notice`;
  const notificationToken = prepareNotificationToken(token);
  return {
    [`${noticeCls}-pure-panel`]: Object.assign(Object.assign({}, genNoticeStyle(notificationToken)), {
      width: notificationToken.width,
      maxWidth: `calc(100vw - ${(0,cssinjs_es/* unit */.bf)(token.calc(notificationToken.notificationMarginEdge).mul(2).equal())})`,
      margin: 0
    })
  };
}, notification_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/notification/PurePanel.js
"use client";

var notification_PurePanel_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};














const PurePanel_TypeIcon = {
  info: /*#__PURE__*/react.createElement(InfoCircleFilled/* default */.Z, null),
  success: /*#__PURE__*/react.createElement(CheckCircleFilled/* default */.Z, null),
  error: /*#__PURE__*/react.createElement(CloseCircleFilled/* default */.Z, null),
  warning: /*#__PURE__*/react.createElement(ExclamationCircleFilled/* default */.Z, null),
  loading: /*#__PURE__*/react.createElement(LoadingOutlined/* default */.Z, null)
};
function getCloseIcon(prefixCls, closeIcon) {
  if (closeIcon === null || closeIcon === false) {
    return null;
  }
  return closeIcon || /*#__PURE__*/react.createElement(CloseOutlined/* default */.Z, {
    className: `${prefixCls}-close-icon`
  });
}
const typeToIcon = {
  success: CheckCircleFilled/* default */.Z,
  info: InfoCircleFilled/* default */.Z,
  error: CloseCircleFilled/* default */.Z,
  warning: ExclamationCircleFilled/* default */.Z
};
const PurePanel_PureContent = props => {
  const {
    prefixCls,
    icon,
    type,
    message,
    description,
    actions,
    role = 'alert'
  } = props;
  let iconNode = null;
  if (icon) {
    iconNode = /*#__PURE__*/react.createElement("span", {
      className: `${prefixCls}-icon`
    }, icon);
  } else if (type) {
    iconNode = /*#__PURE__*/react.createElement(typeToIcon[type] || null, {
      className: classnames_default()(`${prefixCls}-icon`, `${prefixCls}-icon-${type}`)
    });
  }
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()({
      [`${prefixCls}-with-icon`]: iconNode
    }),
    role: role
  }, iconNode, /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-message`
  }, message), description && /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-description`
  }, description), actions && /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-actions`
  }, actions));
};
/** @private Internal Component. Do not use in your production. */
const PurePanel_PurePanel = props => {
  const {
      prefixCls: staticPrefixCls,
      className,
      icon,
      type,
      message,
      description,
      btn,
      actions,
      closable = true,
      closeIcon,
      className: notificationClassName
    } = props,
    restProps = notification_PurePanel_rest(props, ["prefixCls", "className", "icon", "type", "message", "description", "btn", "actions", "closable", "closeIcon", "className"]);
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const mergedActions = actions !== null && actions !== void 0 ? actions : btn;
  if (false) {}
  const prefixCls = staticPrefixCls || getPrefixCls('notification');
  const noticePrefixCls = `${prefixCls}-notice`;
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = notification_style(prefixCls, rootCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${noticePrefixCls}-pure-panel`, hashId, className, cssVarCls, rootCls)
  }, /*#__PURE__*/react.createElement(pure_panel, {
    prefixCls: prefixCls
  }), /*#__PURE__*/react.createElement(rc_notification_es/* Notice */.qX, Object.assign({}, restProps, {
    prefixCls: prefixCls,
    eventKey: "pure",
    duration: null,
    closable: closable,
    className: classnames_default()({
      notificationClassName
    }),
    closeIcon: getCloseIcon(prefixCls, closeIcon),
    content: /*#__PURE__*/react.createElement(PurePanel_PureContent, {
      prefixCls: noticePrefixCls,
      icon: icon,
      type: type,
      message: message,
      description: description,
      actions: mergedActions
    })
  }))));
};
/* harmony default export */ var notification_PurePanel = (PurePanel_PurePanel);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/notification/util.js
function getPlacementStyle(placement, top, bottom) {
  let style;
  switch (placement) {
    case 'top':
      style = {
        left: '50%',
        transform: 'translateX(-50%)',
        right: 'auto',
        top,
        bottom: 'auto'
      };
      break;
    case 'topLeft':
      style = {
        left: 0,
        top,
        bottom: 'auto'
      };
      break;
    case 'topRight':
      style = {
        right: 0,
        top,
        bottom: 'auto'
      };
      break;
    case 'bottom':
      style = {
        left: '50%',
        transform: 'translateX(-50%)',
        right: 'auto',
        top: 'auto',
        bottom
      };
      break;
    case 'bottomLeft':
      style = {
        left: 0,
        top: 'auto',
        bottom
      };
      break;
    default:
      style = {
        right: 0,
        top: 'auto',
        bottom
      };
      break;
  }
  return style;
}
function util_getMotion(prefixCls) {
  return {
    motionName: `${prefixCls}-fade`
  };
}
function getCloseIconConfig(closeIcon, notificationConfig, notification) {
  if (typeof closeIcon !== 'undefined') {
    return closeIcon;
  }
  if (typeof (notificationConfig === null || notificationConfig === void 0 ? void 0 : notificationConfig.closeIcon) !== 'undefined') {
    return notificationConfig.closeIcon;
  }
  return notification === null || notification === void 0 ? void 0 : notification.closeIcon;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/notification/useNotification.js
"use client";

var useNotification_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};










const useNotification_DEFAULT_OFFSET = 24;
const useNotification_DEFAULT_DURATION = 4.5;
const DEFAULT_PLACEMENT = 'topRight';
const useNotification_Wrapper = ({
  children,
  prefixCls
}) => {
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = notification_style(prefixCls, rootCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement(rc_notification_es/* NotificationProvider */.JB, {
    classNames: {
      list: classnames_default()(hashId, cssVarCls, rootCls)
    }
  }, children));
};
const useNotification_renderNotifications = (node, {
  prefixCls,
  key
}) => (/*#__PURE__*/react.createElement(useNotification_Wrapper, {
  prefixCls: prefixCls,
  key: key
}, node));
const useNotification_Holder = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    top,
    bottom,
    prefixCls: staticPrefixCls,
    getContainer: staticGetContainer,
    maxCount,
    rtl,
    onAllRemoved,
    stack,
    duration,
    pauseOnHover = true,
    showProgress
  } = props;
  const {
    getPrefixCls,
    getPopupContainer,
    notification,
    direction
  } = (0,react.useContext)(ConfigContext);
  const [, token] = useToken();
  const prefixCls = staticPrefixCls || getPrefixCls('notification');
  // =============================== Style ===============================
  const getStyle = placement => getPlacementStyle(placement, top !== null && top !== void 0 ? top : useNotification_DEFAULT_OFFSET, bottom !== null && bottom !== void 0 ? bottom : useNotification_DEFAULT_OFFSET);
  const getClassName = () => classnames_default()({
    [`${prefixCls}-rtl`]: rtl !== null && rtl !== void 0 ? rtl : direction === 'rtl'
  });
  // ============================== Motion ===============================
  const getNotificationMotion = () => util_getMotion(prefixCls);
  // ============================== Origin ===============================
  const [api, holder] = (0,rc_notification_es/* useNotification */.lm)({
    prefixCls,
    style: getStyle,
    className: getClassName,
    motion: getNotificationMotion,
    closable: true,
    closeIcon: getCloseIcon(prefixCls),
    duration: duration !== null && duration !== void 0 ? duration : useNotification_DEFAULT_DURATION,
    getContainer: () => (staticGetContainer === null || staticGetContainer === void 0 ? void 0 : staticGetContainer()) || (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer()) || document.body,
    maxCount,
    pauseOnHover,
    showProgress,
    onAllRemoved,
    renderNotifications: useNotification_renderNotifications,
    stack: stack === false ? false : {
      threshold: typeof stack === 'object' ? stack === null || stack === void 0 ? void 0 : stack.threshold : undefined,
      offset: 8,
      gap: token.margin
    }
  });
  // ================================ Ref ================================
  react.useImperativeHandle(ref, () => Object.assign(Object.assign({}, api), {
    prefixCls,
    notification
  }));
  return holder;
});
// ==============================================================================
// ==                                   Hook                                   ==
// ==============================================================================
function useInternalNotification(notificationConfig) {
  const holderRef = react.useRef(null);
  const warning = warning_devUseWarning('Notification');
  // ================================ API ================================
  const wrapAPI = react.useMemo(() => {
    // Wrap with notification content
    // >>> Open
    const open = config => {
      var _a;
      if (!holderRef.current) {
         false ? 0 : void 0;
        return;
      }
      const {
        open: originOpen,
        prefixCls,
        notification
      } = holderRef.current;
      const noticePrefixCls = `${prefixCls}-notice`;
      const {
          message,
          description,
          icon,
          type,
          btn,
          actions,
          className,
          style,
          role = 'alert',
          closeIcon,
          closable
        } = config,
        restConfig = useNotification_rest(config, ["message", "description", "icon", "type", "btn", "actions", "className", "style", "role", "closeIcon", "closable"]);
      if (false) {}
      const mergedActions = actions !== null && actions !== void 0 ? actions : btn;
      const realCloseIcon = getCloseIcon(noticePrefixCls, getCloseIconConfig(closeIcon, notificationConfig, notification));
      return originOpen(Object.assign(Object.assign({
        // use placement from props instead of hard-coding "topRight"
        placement: (_a = notificationConfig === null || notificationConfig === void 0 ? void 0 : notificationConfig.placement) !== null && _a !== void 0 ? _a : DEFAULT_PLACEMENT
      }, restConfig), {
        content: (/*#__PURE__*/react.createElement(PurePanel_PureContent, {
          prefixCls: noticePrefixCls,
          icon: icon,
          type: type,
          message: message,
          description: description,
          actions: mergedActions,
          role: role
        })),
        className: classnames_default()(type && `${noticePrefixCls}-${type}`, className, notification === null || notification === void 0 ? void 0 : notification.className),
        style: Object.assign(Object.assign({}, notification === null || notification === void 0 ? void 0 : notification.style), style),
        closeIcon: realCloseIcon,
        closable: closable !== null && closable !== void 0 ? closable : !!realCloseIcon
      }));
    };
    // >>> destroy
    const destroy = key => {
      var _a, _b;
      if (key !== undefined) {
        (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.close(key);
      } else {
        (_b = holderRef.current) === null || _b === void 0 ? void 0 : _b.destroy();
      }
    };
    const clone = {
      open,
      destroy
    };
    const keys = ['success', 'info', 'warning', 'error'];
    keys.forEach(type => {
      clone[type] = config => open(Object.assign(Object.assign({}, config), {
        type
      }));
    });
    return clone;
  }, []);
  // ============================== Return ===============================
  return [wrapAPI, /*#__PURE__*/react.createElement(useNotification_Holder, Object.assign({
    key: "notification-holder"
  }, notificationConfig, {
    ref: holderRef
  }))];
}
function useNotification(notificationConfig) {
  return useInternalNotification(notificationConfig);
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/app/context.js

const AppConfigContext = /*#__PURE__*/react.createContext({});
const AppContext = /*#__PURE__*/react.createContext({
  message: {},
  notification: {},
  modal: {}
});
/* harmony default export */ var app_context = (AppContext);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/app/style/index.js

// =============================== Base ===============================
const app_style_genBaseStyle = token => {
  const {
    componentCls,
    colorText,
    fontSize,
    lineHeight,
    fontFamily
  } = token;
  return {
    [componentCls]: {
      color: colorText,
      fontSize,
      lineHeight,
      fontFamily,
      [`&${componentCls}-rtl`]: {
        direction: 'rtl'
      }
    }
  };
};
const app_style_prepareComponentToken = () => ({});
// ============================== Export ==============================
/* harmony default export */ var app_style = (genStyleHooks('App', app_style_genBaseStyle, app_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/app/App.js
"use client";










const App = props => {
  const {
    prefixCls: customizePrefixCls,
    children,
    className,
    rootClassName,
    message,
    notification,
    style,
    component = 'div'
  } = props;
  const {
    direction,
    getPrefixCls
  } = (0,react.useContext)(ConfigContext);
  const prefixCls = getPrefixCls('app', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = app_style(prefixCls);
  const customClassName = classnames_default()(hashId, prefixCls, className, rootClassName, cssVarCls, {
    [`${prefixCls}-rtl`]: direction === 'rtl'
  });
  const appConfig = (0,react.useContext)(AppConfigContext);
  const mergedAppConfig = react.useMemo(() => ({
    message: Object.assign(Object.assign({}, appConfig.message), message),
    notification: Object.assign(Object.assign({}, appConfig.notification), notification)
  }), [message, notification, appConfig.message, appConfig.notification]);
  const [messageApi, messageContextHolder] = useMessage(mergedAppConfig.message);
  const [notificationApi, notificationContextHolder] = useNotification(mergedAppConfig.notification);
  const [ModalApi, ModalContextHolder] = modal_useModal();
  const memoizedContextValue = react.useMemo(() => ({
    message: messageApi,
    notification: notificationApi,
    modal: ModalApi
  }), [messageApi, notificationApi, ModalApi]);
  // https://github.com/ant-design/ant-design/issues/48802#issuecomment-2097813526
  warning_devUseWarning('App')(!(cssVarCls && component === false), 'usage', 'When using cssVar, ensure `component` is assigned a valid React component string.');
  // ============================ Render ============================
  const Component = component === false ? react.Fragment : component;
  const rootProps = {
    className: customClassName,
    style
  };
  return wrapCSSVar(/*#__PURE__*/react.createElement(app_context.Provider, {
    value: memoizedContextValue
  }, /*#__PURE__*/react.createElement(AppConfigContext.Provider, {
    value: mergedAppConfig
  }, /*#__PURE__*/react.createElement(Component, Object.assign({}, component === false ? undefined : rootProps), ModalContextHolder, messageContextHolder, notificationContextHolder, children))));
};
if (false) {}
/* harmony default export */ var app_App = (App);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/app/useApp.js


const useApp = () => react.useContext(app_context);
/* harmony default export */ var app_useApp = (useApp);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/app/index.js
"use client";



const es_app_App = app_App;
es_app_App.useApp = app_useApp;
/* harmony default export */ var app = (es_app_App);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/PurePanel.js
"use client";




function withPureRenderTheme(Component) {
  return props => (/*#__PURE__*/react.createElement(config_provider, {
    theme: {
      token: {
        motion: false,
        zIndexPopupBase: 0
      }
    }
  }, /*#__PURE__*/react.createElement(Component, Object.assign({}, props))));
}
/* istanbul ignore next */
const genPurePanel = (Component, alignPropName, postProps, defaultPrefixCls, getDropdownCls) => {
  const PurePanel = props => {
    const {
      prefixCls: customizePrefixCls,
      style
    } = props;
    const holderRef = react.useRef(null);
    const [popupHeight, setPopupHeight] = react.useState(0);
    const [popupWidth, setPopupWidth] = react.useState(0);
    const [open, setOpen] = (0,useMergedState/* default */.Z)(false, {
      value: props.open
    });
    const {
      getPrefixCls
    } = react.useContext(ConfigContext);
    const prefixCls = getPrefixCls(defaultPrefixCls || 'select', customizePrefixCls);
    react.useEffect(() => {
      // We do not care about ssr
      setOpen(true);
      if (typeof ResizeObserver !== 'undefined') {
        const resizeObserver = new ResizeObserver(entries => {
          const element = entries[0].target;
          setPopupHeight(element.offsetHeight + 8);
          setPopupWidth(element.offsetWidth);
        });
        const interval = setInterval(() => {
          var _a;
          const dropdownCls = getDropdownCls ? `.${getDropdownCls(prefixCls)}` : `.${prefixCls}-dropdown`;
          const popup = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(dropdownCls);
          if (popup) {
            clearInterval(interval);
            resizeObserver.observe(popup);
          }
        }, 10);
        return () => {
          clearInterval(interval);
          resizeObserver.disconnect();
        };
      }
    }, []);
    let mergedProps = Object.assign(Object.assign({}, props), {
      style: Object.assign(Object.assign({}, style), {
        margin: 0
      }),
      open,
      visible: open,
      getPopupContainer: () => holderRef.current
    });
    if (postProps) {
      mergedProps = postProps(mergedProps);
    }
    if (alignPropName) {
      Object.assign(mergedProps, {
        [alignPropName]: {
          overflow: {
            adjustX: false,
            adjustY: false
          }
        }
      });
    }
    const mergedStyle = {
      paddingBottom: popupHeight,
      position: 'relative',
      minWidth: popupWidth
    };
    return /*#__PURE__*/react.createElement("div", {
      ref: holderRef,
      style: mergedStyle
    }, /*#__PURE__*/react.createElement(Component, Object.assign({}, mergedProps)));
  };
  return withPureRenderTheme(PurePanel);
};
/* harmony default export */ var _util_PurePanel = (genPurePanel);
// EXTERNAL MODULE: ./node_modules/rc-select/es/index.js + 30 modules
var rc_select_es = __webpack_require__(24311);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/statusUtils.js

const _InputStatuses = (/* unused pure expression or super */ null && (['warning', 'error', '']));
function getStatusClassNames(prefixCls, status, hasFeedback) {
  return classnames_default()({
    [`${prefixCls}-status-success`]: status === 'success',
    [`${prefixCls}-status-warning`]: status === 'warning',
    [`${prefixCls}-status-error`]: status === 'error',
    [`${prefixCls}-status-validating`]: status === 'validating',
    [`${prefixCls}-has-feedback`]: hasFeedback
  });
}
const getMergedStatus = (contextStatus, customStatus) => customStatus || contextStatus;
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/empty/empty.js
"use client";





const Empty = () => {
  const [, token] = useToken();
  const [locale] = locale_useLocale('Empty');
  const bgColor = new fast_color_es/* FastColor */.t(token.colorBgBase);
  // Dark Theme need more dark of this
  const themeStyle = bgColor.toHsl().l < 0.5 ? {
    opacity: 0.65
  } : {};
  return /*#__PURE__*/react.createElement("svg", {
    style: themeStyle,
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react.createElement("title", null, (locale === null || locale === void 0 ? void 0 : locale.description) || 'Empty'), /*#__PURE__*/react.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("g", {
    transform: "translate(24 31.67)"
  }, /*#__PURE__*/react.createElement("ellipse", {
    fillOpacity: ".8",
    fill: "#F5F5F7",
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
    fill: "#AEB8C2"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    fill: "url(#linearGradient-1)",
    transform: "translate(13.56)"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    fill: "#F5F5F7"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
    fill: "#DCE0E6"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
    fill: "#DCE0E6"
  }), /*#__PURE__*/react.createElement("g", {
    transform: "translate(149.65 15.383)",
    fill: "#FFF"
  }, /*#__PURE__*/react.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))));
};
if (false) {}
/* harmony default export */ var empty = (Empty);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/empty/simple.js
"use client";






const Simple = () => {
  const [, token] = useToken();
  const [locale] = locale_useLocale('Empty');
  const {
    colorFill,
    colorFillTertiary,
    colorFillQuaternary,
    colorBgContainer
  } = token;
  const {
    borderColor,
    shadowColor,
    contentColor
  } = (0,react.useMemo)(() => ({
    borderColor: new fast_color_es/* FastColor */.t(colorFill).onBackground(colorBgContainer).toHexString(),
    shadowColor: new fast_color_es/* FastColor */.t(colorFillTertiary).onBackground(colorBgContainer).toHexString(),
    contentColor: new fast_color_es/* FastColor */.t(colorFillQuaternary).onBackground(colorBgContainer).toHexString()
  }), [colorFill, colorFillTertiary, colorFillQuaternary, colorBgContainer]);
  return /*#__PURE__*/react.createElement("svg", {
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react.createElement("title", null, (locale === null || locale === void 0 ? void 0 : locale.description) || 'Empty'), /*#__PURE__*/react.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("ellipse", {
    fill: shadowColor,
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), /*#__PURE__*/react.createElement("g", {
    fillRule: "nonzero",
    stroke: borderColor
  }, /*#__PURE__*/react.createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    fill: contentColor
  }))));
};
if (false) {}
/* harmony default export */ var simple = (Simple);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/empty/style/index.js

// ============================== Shared ==============================
const genSharedEmptyStyle = token => {
  const {
    componentCls,
    margin,
    marginXS,
    marginXL,
    fontSize,
    lineHeight
  } = token;
  return {
    [componentCls]: {
      marginInline: marginXS,
      fontSize,
      lineHeight,
      textAlign: 'center',
      // 原来 &-image 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
      [`${componentCls}-image`]: {
        height: token.emptyImgHeight,
        marginBottom: marginXS,
        opacity: token.opacityImage,
        img: {
          height: '100%'
        },
        svg: {
          maxWidth: '100%',
          height: '100%',
          margin: 'auto'
        }
      },
      [`${componentCls}-description`]: {
        color: token.colorTextDescription
      },
      // 原来 &-footer 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
      [`${componentCls}-footer`]: {
        marginTop: margin
      },
      '&-normal': {
        marginBlock: marginXL,
        color: token.colorTextDescription,
        [`${componentCls}-description`]: {
          color: token.colorTextDescription
        },
        [`${componentCls}-image`]: {
          height: token.emptyImgHeightMD
        }
      },
      '&-small': {
        marginBlock: marginXS,
        color: token.colorTextDescription,
        [`${componentCls}-image`]: {
          height: token.emptyImgHeightSM
        }
      }
    }
  };
};
// ============================== Export ==============================
/* harmony default export */ var empty_style = (genStyleHooks('Empty', token => {
  const {
    componentCls,
    controlHeightLG,
    calc
  } = token;
  const emptyToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    emptyImgCls: `${componentCls}-img`,
    emptyImgHeight: calc(controlHeightLG).mul(2.5).equal(),
    emptyImgHeightMD: controlHeightLG,
    emptyImgHeightSM: calc(controlHeightLG).mul(0.875).equal()
  });
  return genSharedEmptyStyle(emptyToken);
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/empty/index.js
"use client";

var empty_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};








const defaultEmptyImg = /*#__PURE__*/react.createElement(empty, null);
const simpleEmptyImg = /*#__PURE__*/react.createElement(simple, null);
const empty_Empty = props => {
  var _a;
  const {
      className,
      rootClassName,
      prefixCls: customizePrefixCls,
      image,
      description,
      children,
      imageStyle,
      style,
      classNames: emptyClassNames,
      styles
    } = props,
    restProps = empty_rest(props, ["className", "rootClassName", "prefixCls", "image", "description", "children", "imageStyle", "style", "classNames", "styles"]);
  const {
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles,
    image: contextImage
  } = useComponentConfig('empty');
  const prefixCls = getPrefixCls('empty', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = empty_style(prefixCls);
  const [locale] = locale_useLocale('Empty');
  const des = typeof description !== 'undefined' ? description : locale === null || locale === void 0 ? void 0 : locale.description;
  const alt = typeof des === 'string' ? des : 'empty';
  const mergedImage = (_a = image !== null && image !== void 0 ? image : contextImage) !== null && _a !== void 0 ? _a : defaultEmptyImg;
  let imageNode = null;
  if (typeof mergedImage === 'string') {
    imageNode = /*#__PURE__*/react.createElement("img", {
      alt: alt,
      src: mergedImage
    });
  } else {
    imageNode = mergedImage;
  }
  // ============================= Warning ==============================
  if (false) {}
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", Object.assign({
    className: classnames_default()(hashId, cssVarCls, prefixCls, contextClassName, {
      [`${prefixCls}-normal`]: mergedImage === simpleEmptyImg,
      [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, contextClassNames.root, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.root),
    style: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.root), contextStyle), styles === null || styles === void 0 ? void 0 : styles.root), style)
  }, restProps), /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${prefixCls}-image`, contextClassNames.image, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.image),
    style: Object.assign(Object.assign(Object.assign({}, imageStyle), contextStyles.image), styles === null || styles === void 0 ? void 0 : styles.image)
  }, imageNode), des && (/*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${prefixCls}-description`, contextClassNames.description, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.description),
    style: Object.assign(Object.assign({}, contextStyles.description), styles === null || styles === void 0 ? void 0 : styles.description)
  }, des)), children && (/*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${prefixCls}-footer`, contextClassNames.footer, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.footer),
    style: Object.assign(Object.assign({}, contextStyles.footer), styles === null || styles === void 0 ? void 0 : styles.footer)
  }, children))));
};
empty_Empty.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
empty_Empty.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
if (false) {}
/* harmony default export */ var es_empty = (empty_Empty);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/config-provider/defaultRenderEmpty.js
"use client";




const DefaultRenderEmpty = props => {
  const {
    componentName
  } = props;
  const {
    getPrefixCls
  } = (0,react.useContext)(ConfigContext);
  const prefix = getPrefixCls('empty');
  switch (componentName) {
    case 'Table':
    case 'List':
      return /*#__PURE__*/react.createElement(es_empty, {
        image: es_empty.PRESENTED_IMAGE_SIMPLE
      });
    case 'Select':
    case 'TreeSelect':
    case 'Cascader':
    case 'Transfer':
    case 'Mentions':
      return /*#__PURE__*/react.createElement(es_empty, {
        image: es_empty.PRESENTED_IMAGE_SIMPLE,
        className: `${prefix}-small`
      });
    /**
     * This type of component should satisfy the nullish coalescing operator(??) on the left-hand side.
     * to let the component itself implement the logic.
     * For example `Table.filter`.
     */
    case 'Table.filter':
      // why `null`? legacy react16 node type `undefined` is not allowed.
      return null;
    default:
      // Should never hit if we take all the component into consider.
      return /*#__PURE__*/react.createElement(es_empty, null);
  }
};
/* harmony default export */ var defaultRenderEmpty = (DefaultRenderEmpty);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/hooks/useVariants.js



/**
 * Compatible for legacy `bordered` prop.
 */
const useVariant = (component, variant, legacyBordered = undefined) => {
  var _a, _b;
  const {
    variant: configVariant,
    [component]: componentConfig
  } = react.useContext(ConfigContext);
  const ctxVariant = react.useContext(VariantContext);
  const configComponentVariant = componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.variant;
  let mergedVariant;
  if (typeof variant !== 'undefined') {
    mergedVariant = variant;
  } else if (legacyBordered === false) {
    mergedVariant = 'borderless';
  } else {
    // form variant > component global variant > global variant
    mergedVariant = (_b = (_a = ctxVariant !== null && ctxVariant !== void 0 ? ctxVariant : configComponentVariant) !== null && _a !== void 0 ? _a : configVariant) !== null && _b !== void 0 ? _b : 'outlined';
  }
  const enableVariantCls = Variants.includes(mergedVariant);
  return [mergedVariant, enableVariantCls];
};
/* harmony default export */ var useVariants = (useVariant);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/select/mergedBuiltinPlacements.js
const getBuiltInPlacements = popupOverflow => {
  const htmlRegion = popupOverflow === 'scroll' ? 'scroll' : 'visible';
  const sharedConfig = {
    overflow: {
      adjustX: true,
      adjustY: true,
      shiftY: true
    },
    htmlRegion,
    dynamicInset: true
  };
  return {
    bottomLeft: Object.assign(Object.assign({}, sharedConfig), {
      points: ['tl', 'bl'],
      offset: [0, 4]
    }),
    bottomRight: Object.assign(Object.assign({}, sharedConfig), {
      points: ['tr', 'br'],
      offset: [0, 4]
    }),
    topLeft: Object.assign(Object.assign({}, sharedConfig), {
      points: ['bl', 'tl'],
      offset: [0, -4]
    }),
    topRight: Object.assign(Object.assign({}, sharedConfig), {
      points: ['br', 'tr'],
      offset: [0, -4]
    })
  };
};
function mergedBuiltinPlacements(buildInPlacements, popupOverflow) {
  return buildInPlacements || getBuiltInPlacements(popupOverflow);
}
/* harmony default export */ var select_mergedBuiltinPlacements = (mergedBuiltinPlacements);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/style/motion/slide.js


const slideUpIn = new cssinjs_es/* Keyframes */.E4('antSlideUpIn', {
  '0%': {
    transform: 'scaleY(0.8)',
    transformOrigin: '0% 0%',
    opacity: 0
  },
  '100%': {
    transform: 'scaleY(1)',
    transformOrigin: '0% 0%',
    opacity: 1
  }
});
const slideUpOut = new cssinjs_es/* Keyframes */.E4('antSlideUpOut', {
  '0%': {
    transform: 'scaleY(1)',
    transformOrigin: '0% 0%',
    opacity: 1
  },
  '100%': {
    transform: 'scaleY(0.8)',
    transformOrigin: '0% 0%',
    opacity: 0
  }
});
const slideDownIn = new cssinjs_es/* Keyframes */.E4('antSlideDownIn', {
  '0%': {
    transform: 'scaleY(0.8)',
    transformOrigin: '100% 100%',
    opacity: 0
  },
  '100%': {
    transform: 'scaleY(1)',
    transformOrigin: '100% 100%',
    opacity: 1
  }
});
const slideDownOut = new cssinjs_es/* Keyframes */.E4('antSlideDownOut', {
  '0%': {
    transform: 'scaleY(1)',
    transformOrigin: '100% 100%',
    opacity: 1
  },
  '100%': {
    transform: 'scaleY(0.8)',
    transformOrigin: '100% 100%',
    opacity: 0
  }
});
const slideLeftIn = new cssinjs_es/* Keyframes */.E4('antSlideLeftIn', {
  '0%': {
    transform: 'scaleX(0.8)',
    transformOrigin: '0% 0%',
    opacity: 0
  },
  '100%': {
    transform: 'scaleX(1)',
    transformOrigin: '0% 0%',
    opacity: 1
  }
});
const slideLeftOut = new cssinjs_es/* Keyframes */.E4('antSlideLeftOut', {
  '0%': {
    transform: 'scaleX(1)',
    transformOrigin: '0% 0%',
    opacity: 1
  },
  '100%': {
    transform: 'scaleX(0.8)',
    transformOrigin: '0% 0%',
    opacity: 0
  }
});
const slideRightIn = new cssinjs_es/* Keyframes */.E4('antSlideRightIn', {
  '0%': {
    transform: 'scaleX(0.8)',
    transformOrigin: '100% 0%',
    opacity: 0
  },
  '100%': {
    transform: 'scaleX(1)',
    transformOrigin: '100% 0%',
    opacity: 1
  }
});
const slideRightOut = new cssinjs_es/* Keyframes */.E4('antSlideRightOut', {
  '0%': {
    transform: 'scaleX(1)',
    transformOrigin: '100% 0%',
    opacity: 1
  },
  '100%': {
    transform: 'scaleX(0.8)',
    transformOrigin: '100% 0%',
    opacity: 0
  }
});
const slideMotion = {
  'slide-up': {
    inKeyframes: slideUpIn,
    outKeyframes: slideUpOut
  },
  'slide-down': {
    inKeyframes: slideDownIn,
    outKeyframes: slideDownOut
  },
  'slide-left': {
    inKeyframes: slideLeftIn,
    outKeyframes: slideLeftOut
  },
  'slide-right': {
    inKeyframes: slideRightIn,
    outKeyframes: slideRightOut
  }
};
const initSlideMotion = (token, motionName) => {
  const {
    antCls
  } = token;
  const motionCls = `${antCls}-${motionName}`;
  const {
    inKeyframes,
    outKeyframes
  } = slideMotion[motionName];
  return [initMotion(motionCls, inKeyframes, outKeyframes, token.motionDurationMid), {
    [`
      ${motionCls}-enter,
      ${motionCls}-appear
    `]: {
      transform: 'scale(0)',
      transformOrigin: '0% 0%',
      opacity: 0,
      animationTimingFunction: token.motionEaseOutQuint,
      '&-prepare': {
        transform: 'scale(1)'
      }
    },
    [`${motionCls}-leave`]: {
      animationTimingFunction: token.motionEaseInQuint
    }
  }];
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/style/motion/move.js


const moveDownIn = new cssinjs_es/* Keyframes */.E4('antMoveDownIn', {
  '0%': {
    transform: 'translate3d(0, 100%, 0)',
    transformOrigin: '0 0',
    opacity: 0
  },
  '100%': {
    transform: 'translate3d(0, 0, 0)',
    transformOrigin: '0 0',
    opacity: 1
  }
});
const moveDownOut = new cssinjs_es/* Keyframes */.E4('antMoveDownOut', {
  '0%': {
    transform: 'translate3d(0, 0, 0)',
    transformOrigin: '0 0',
    opacity: 1
  },
  '100%': {
    transform: 'translate3d(0, 100%, 0)',
    transformOrigin: '0 0',
    opacity: 0
  }
});
const moveLeftIn = new cssinjs_es/* Keyframes */.E4('antMoveLeftIn', {
  '0%': {
    transform: 'translate3d(-100%, 0, 0)',
    transformOrigin: '0 0',
    opacity: 0
  },
  '100%': {
    transform: 'translate3d(0, 0, 0)',
    transformOrigin: '0 0',
    opacity: 1
  }
});
const moveLeftOut = new cssinjs_es/* Keyframes */.E4('antMoveLeftOut', {
  '0%': {
    transform: 'translate3d(0, 0, 0)',
    transformOrigin: '0 0',
    opacity: 1
  },
  '100%': {
    transform: 'translate3d(-100%, 0, 0)',
    transformOrigin: '0 0',
    opacity: 0
  }
});
const moveRightIn = new cssinjs_es/* Keyframes */.E4('antMoveRightIn', {
  '0%': {
    transform: 'translate3d(100%, 0, 0)',
    transformOrigin: '0 0',
    opacity: 0
  },
  '100%': {
    transform: 'translate3d(0, 0, 0)',
    transformOrigin: '0 0',
    opacity: 1
  }
});
const moveRightOut = new cssinjs_es/* Keyframes */.E4('antMoveRightOut', {
  '0%': {
    transform: 'translate3d(0, 0, 0)',
    transformOrigin: '0 0',
    opacity: 1
  },
  '100%': {
    transform: 'translate3d(100%, 0, 0)',
    transformOrigin: '0 0',
    opacity: 0
  }
});
const moveUpIn = new cssinjs_es/* Keyframes */.E4('antMoveUpIn', {
  '0%': {
    transform: 'translate3d(0, -100%, 0)',
    transformOrigin: '0 0',
    opacity: 0
  },
  '100%': {
    transform: 'translate3d(0, 0, 0)',
    transformOrigin: '0 0',
    opacity: 1
  }
});
const moveUpOut = new cssinjs_es/* Keyframes */.E4('antMoveUpOut', {
  '0%': {
    transform: 'translate3d(0, 0, 0)',
    transformOrigin: '0 0',
    opacity: 1
  },
  '100%': {
    transform: 'translate3d(0, -100%, 0)',
    transformOrigin: '0 0',
    opacity: 0
  }
});
const moveMotion = {
  'move-up': {
    inKeyframes: moveUpIn,
    outKeyframes: moveUpOut
  },
  'move-down': {
    inKeyframes: moveDownIn,
    outKeyframes: moveDownOut
  },
  'move-left': {
    inKeyframes: moveLeftIn,
    outKeyframes: moveLeftOut
  },
  'move-right': {
    inKeyframes: moveRightIn,
    outKeyframes: moveRightOut
  }
};
const initMoveMotion = (token, motionName) => {
  const {
    antCls
  } = token;
  const motionCls = `${antCls}-${motionName}`;
  const {
    inKeyframes,
    outKeyframes
  } = moveMotion[motionName];
  return [initMotion(motionCls, inKeyframes, outKeyframes, token.motionDurationMid), {
    [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: token.motionEaseOutCirc
    },
    [`${motionCls}-leave`]: {
      animationTimingFunction: token.motionEaseInOutCirc
    }
  }];
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/select/style/dropdown.js


const genItemStyle = token => {
  const {
    optionHeight,
    optionFontSize,
    optionLineHeight,
    optionPadding
  } = token;
  return {
    position: 'relative',
    display: 'block',
    minHeight: optionHeight,
    padding: optionPadding,
    color: token.colorText,
    fontWeight: 'normal',
    fontSize: optionFontSize,
    lineHeight: optionLineHeight,
    boxSizing: 'border-box'
  };
};
const genSingleStyle = token => {
  const {
    antCls,
    componentCls
  } = token;
  const selectItemCls = `${componentCls}-item`;
  const slideUpEnterActive = `&${antCls}-slide-up-enter${antCls}-slide-up-enter-active`;
  const slideUpAppearActive = `&${antCls}-slide-up-appear${antCls}-slide-up-appear-active`;
  const slideUpLeaveActive = `&${antCls}-slide-up-leave${antCls}-slide-up-leave-active`;
  const dropdownPlacementCls = `${componentCls}-dropdown-placement-`;
  const selectedItemCls = `${selectItemCls}-option-selected`;
  return [{
    [`${componentCls}-dropdown`]: Object.assign(Object.assign({}, resetComponent(token)), {
      position: 'absolute',
      top: -9999,
      zIndex: token.zIndexPopup,
      boxSizing: 'border-box',
      padding: token.paddingXXS,
      overflow: 'hidden',
      fontSize: token.fontSize,
      // Fix select render lag of long text in chrome
      // https://github.com/ant-design/ant-design/issues/11456
      // https://github.com/ant-design/ant-design/issues/11843
      fontVariant: 'initial',
      backgroundColor: token.colorBgElevated,
      borderRadius: token.borderRadiusLG,
      outline: 'none',
      boxShadow: token.boxShadowSecondary,
      [`
          ${slideUpEnterActive}${dropdownPlacementCls}bottomLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}bottomLeft
        `]: {
        animationName: slideUpIn
      },
      [`
          ${slideUpEnterActive}${dropdownPlacementCls}topLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}topLeft,
          ${slideUpEnterActive}${dropdownPlacementCls}topRight,
          ${slideUpAppearActive}${dropdownPlacementCls}topRight
        `]: {
        animationName: slideDownIn
      },
      [`${slideUpLeaveActive}${dropdownPlacementCls}bottomLeft`]: {
        animationName: slideUpOut
      },
      [`
          ${slideUpLeaveActive}${dropdownPlacementCls}topLeft,
          ${slideUpLeaveActive}${dropdownPlacementCls}topRight
        `]: {
        animationName: slideDownOut
      },
      '&-hidden': {
        display: 'none'
      },
      [selectItemCls]: Object.assign(Object.assign({}, genItemStyle(token)), {
        cursor: 'pointer',
        transition: `background ${token.motionDurationSlow} ease`,
        borderRadius: token.borderRadiusSM,
        // =========== Group ============
        '&-group': {
          color: token.colorTextDescription,
          fontSize: token.fontSizeSM,
          cursor: 'default'
        },
        // =========== Option ===========
        '&-option': {
          display: 'flex',
          '&-content': Object.assign({
            flex: 'auto'
          }, textEllipsis),
          '&-state': {
            flex: 'none',
            display: 'flex',
            alignItems: 'center'
          },
          [`&-active:not(${selectItemCls}-option-disabled)`]: {
            backgroundColor: token.optionActiveBg
          },
          [`&-selected:not(${selectItemCls}-option-disabled)`]: {
            color: token.optionSelectedColor,
            fontWeight: token.optionSelectedFontWeight,
            backgroundColor: token.optionSelectedBg,
            [`${selectItemCls}-option-state`]: {
              color: token.colorPrimary
            }
          },
          '&-disabled': {
            [`&${selectItemCls}-option-selected`]: {
              backgroundColor: token.colorBgContainerDisabled
            },
            color: token.colorTextDisabled,
            cursor: 'not-allowed'
          },
          '&-grouped': {
            paddingInlineStart: token.calc(token.controlPaddingHorizontal).mul(2).equal()
          }
        },
        '&-empty': Object.assign(Object.assign({}, genItemStyle(token)), {
          color: token.colorTextDisabled
        })
      }),
      // https://github.com/ant-design/ant-design/pull/46646
      [`${selectedItemCls}:has(+ ${selectedItemCls})`]: {
        borderEndStartRadius: 0,
        borderEndEndRadius: 0,
        [`& + ${selectedItemCls}`]: {
          borderStartStartRadius: 0,
          borderStartEndRadius: 0
        }
      },
      // =========================== RTL ===========================
      '&-rtl': {
        direction: 'rtl'
      }
    })
  },
  // Follow code may reuse in other components
  initSlideMotion(token, 'slide-up'), initSlideMotion(token, 'slide-down'), initMoveMotion(token, 'move-up'), initMoveMotion(token, 'move-down')];
};
/* harmony default export */ var dropdown = (genSingleStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/select/style/multiple.js



/**
 * Get multiple selector needed style. The calculation:
 *
 * ContainerPadding = BasePadding - ItemMargin
 *
 * Border:                    ╔═══════════════════════════╗                 ┬
 * ContainerPadding:          ║                           ║                 │
 *                            ╟───────────────────────────╢     ┬           │
 * Item Margin:               ║                           ║     │           │
 *                            ║             ┌──────────┐  ║     │           │
 * Item(multipleItemHeight):  ║ BasePadding │   Item   │  ║  Overflow  Container(ControlHeight)
 *                            ║             └──────────┘  ║     │           │
 * Item Margin:               ║                           ║     │           │
 *                            ╟───────────────────────────╢     ┴           │
 * ContainerPadding:          ║                           ║                 │
 * Border:                    ╚═══════════════════════════╝                 ┴
 */
const getMultipleSelectorUnit = token => {
  const {
    multipleSelectItemHeight,
    paddingXXS,
    lineWidth,
    INTERNAL_FIXED_ITEM_MARGIN
  } = token;
  const basePadding = token.max(token.calc(paddingXXS).sub(lineWidth).equal(), 0);
  const containerPadding = token.max(token.calc(basePadding).sub(INTERNAL_FIXED_ITEM_MARGIN).equal(), 0);
  return {
    basePadding,
    containerPadding,
    itemHeight: (0,cssinjs_es/* unit */.bf)(multipleSelectItemHeight),
    itemLineHeight: (0,cssinjs_es/* unit */.bf)(token.calc(multipleSelectItemHeight).sub(token.calc(token.lineWidth).mul(2)).equal())
  };
};
const getSelectItemStyle = token => {
  const {
    multipleSelectItemHeight,
    selectHeight,
    lineWidth
  } = token;
  const selectItemDist = token.calc(selectHeight).sub(multipleSelectItemHeight).div(2).sub(lineWidth).equal();
  return selectItemDist;
};
/**
 * Get the `rc-overflow` needed style.
 * It's a share style which means not affected by `size`.
 */
const genOverflowStyle = token => {
  const {
    componentCls,
    iconCls,
    borderRadiusSM,
    motionDurationSlow,
    paddingXS,
    multipleItemColorDisabled,
    multipleItemBorderColorDisabled,
    colorIcon,
    colorIconHover,
    INTERNAL_FIXED_ITEM_MARGIN
  } = token;
  const selectOverflowPrefixCls = `${componentCls}-selection-overflow`;
  return {
    /**
     * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
     * may update to redesign with its align logic.
     */
    // =========================== Overflow ===========================
    [selectOverflowPrefixCls]: {
      position: 'relative',
      display: 'flex',
      flex: 'auto',
      flexWrap: 'wrap',
      maxWidth: '100%',
      '&-item': {
        flex: 'none',
        alignSelf: 'center',
        // https://github.com/ant-design/ant-design/issues/54179
        maxWidth: 'calc(100% - 4px)',
        display: 'inline-flex'
      },
      // ======================== Selections ==========================
      [`${componentCls}-selection-item`]: {
        display: 'flex',
        alignSelf: 'center',
        flex: 'none',
        boxSizing: 'border-box',
        maxWidth: '100%',
        marginBlock: INTERNAL_FIXED_ITEM_MARGIN,
        borderRadius: borderRadiusSM,
        cursor: 'default',
        transition: `font-size ${motionDurationSlow}, line-height ${motionDurationSlow}, height ${motionDurationSlow}`,
        marginInlineEnd: token.calc(INTERNAL_FIXED_ITEM_MARGIN).mul(2).equal(),
        paddingInlineStart: paddingXS,
        paddingInlineEnd: token.calc(paddingXS).div(2).equal(),
        [`${componentCls}-disabled&`]: {
          color: multipleItemColorDisabled,
          borderColor: multipleItemBorderColorDisabled,
          cursor: 'not-allowed'
        },
        // It's ok not to do this, but 24px makes bottom narrow in view should adjust
        '&-content': {
          display: 'inline-block',
          marginInlineEnd: token.calc(paddingXS).div(2).equal(),
          overflow: 'hidden',
          whiteSpace: 'pre',
          // fix whitespace wrapping. custom tags display all whitespace within.
          textOverflow: 'ellipsis'
        },
        '&-remove': Object.assign(Object.assign({}, resetIcon()), {
          display: 'inline-flex',
          alignItems: 'center',
          color: colorIcon,
          fontWeight: 'bold',
          fontSize: 10,
          lineHeight: 'inherit',
          cursor: 'pointer',
          [`> ${iconCls}`]: {
            verticalAlign: '-0.2em'
          },
          '&:hover': {
            color: colorIconHover
          }
        })
      }
    }
  };
};
const genSelectionStyle = (token, suffix) => {
  const {
    componentCls,
    INTERNAL_FIXED_ITEM_MARGIN
  } = token;
  const selectOverflowPrefixCls = `${componentCls}-selection-overflow`;
  const selectItemHeight = token.multipleSelectItemHeight;
  const selectItemDist = getSelectItemStyle(token);
  const suffixCls = suffix ? `${componentCls}-${suffix}` : '';
  const multipleSelectorUnit = getMultipleSelectorUnit(token);
  return {
    [`${componentCls}-multiple${suffixCls}`]: Object.assign(Object.assign({}, genOverflowStyle(token)), {
      // ========================= Selector =========================
      [`${componentCls}-selector`]: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        // Multiple is little different that horizontal is follow the vertical
        paddingInline: multipleSelectorUnit.basePadding,
        paddingBlock: multipleSelectorUnit.containerPadding,
        borderRadius: token.borderRadius,
        [`${componentCls}-disabled&`]: {
          background: token.multipleSelectorBgDisabled,
          cursor: 'not-allowed'
        },
        '&:after': {
          display: 'inline-block',
          width: 0,
          margin: `${(0,cssinjs_es/* unit */.bf)(INTERNAL_FIXED_ITEM_MARGIN)} 0`,
          lineHeight: (0,cssinjs_es/* unit */.bf)(selectItemHeight),
          visibility: 'hidden',
          content: '"\\a0"'
        }
      },
      // ======================== Selections ========================
      [`${componentCls}-selection-item`]: {
        height: multipleSelectorUnit.itemHeight,
        lineHeight: (0,cssinjs_es/* unit */.bf)(multipleSelectorUnit.itemLineHeight)
      },
      // ========================== Wrap ===========================
      [`${componentCls}-selection-wrap`]: {
        alignSelf: 'flex-start',
        '&:after': {
          lineHeight: (0,cssinjs_es/* unit */.bf)(selectItemHeight),
          marginBlock: INTERNAL_FIXED_ITEM_MARGIN
        }
      },
      // ========================== Input ==========================
      [`${componentCls}-prefix`]: {
        marginInlineStart: token.calc(token.inputPaddingHorizontalBase).sub(multipleSelectorUnit.basePadding).equal()
      },
      [`${selectOverflowPrefixCls}-item + ${selectOverflowPrefixCls}-item,
        ${componentCls}-prefix + ${componentCls}-selection-wrap
      `]: {
        [`${componentCls}-selection-search`]: {
          marginInlineStart: 0
        },
        [`${componentCls}-selection-placeholder`]: {
          insetInlineStart: 0
        }
      },
      // https://github.com/ant-design/ant-design/issues/44754
      // Same as `wrap:after`
      [`${selectOverflowPrefixCls}-item-suffix`]: {
        minHeight: multipleSelectorUnit.itemHeight,
        marginBlock: INTERNAL_FIXED_ITEM_MARGIN
      },
      [`${componentCls}-selection-search`]: {
        display: 'inline-flex',
        position: 'relative',
        maxWidth: '100%',
        marginInlineStart: token.calc(token.inputPaddingHorizontalBase).sub(selectItemDist).equal(),
        [`
          &-input,
          &-mirror
        `]: {
          height: selectItemHeight,
          fontFamily: token.fontFamily,
          lineHeight: (0,cssinjs_es/* unit */.bf)(selectItemHeight),
          transition: `all ${token.motionDurationSlow}`
        },
        '&-input': {
          width: '100%',
          minWidth: 4.1 // fix search cursor missing
        },
        '&-mirror': {
          position: 'absolute',
          top: 0,
          insetInlineStart: 0,
          insetInlineEnd: 'auto',
          zIndex: 999,
          whiteSpace: 'pre',
          // fix whitespace wrapping caused width calculation bug
          visibility: 'hidden'
        }
      },
      // ======================= Placeholder =======================
      [`${componentCls}-selection-placeholder`]: {
        position: 'absolute',
        top: '50%',
        insetInlineStart: token.calc(token.inputPaddingHorizontalBase).sub(multipleSelectorUnit.basePadding).equal(),
        insetInlineEnd: token.inputPaddingHorizontalBase,
        transform: 'translateY(-50%)',
        transition: `all ${token.motionDurationSlow}`
      }
    })
  };
};
function genSizeStyle(token, suffix) {
  const {
    componentCls
  } = token;
  const suffixCls = suffix ? `${componentCls}-${suffix}` : '';
  const rawStyle = {
    [`${componentCls}-multiple${suffixCls}`]: {
      fontSize: token.fontSize,
      // ========================= Selector =========================
      [`${componentCls}-selector`]: {
        [`${componentCls}-show-search&`]: {
          cursor: 'text'
        }
      },
      [`
        &${componentCls}-show-arrow ${componentCls}-selector,
        &${componentCls}-allow-clear ${componentCls}-selector
      `]: {
        paddingInlineEnd: token.calc(token.fontSizeIcon).add(token.controlPaddingHorizontal).equal()
      }
    }
  };
  return [genSelectionStyle(token, suffix), rawStyle];
}
const genMultipleStyle = token => {
  const {
    componentCls
  } = token;
  const smallToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    selectHeight: token.controlHeightSM,
    multipleSelectItemHeight: token.multipleItemHeightSM,
    borderRadius: token.borderRadiusSM,
    borderRadiusSM: token.borderRadiusXS
  });
  const largeToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    fontSize: token.fontSizeLG,
    selectHeight: token.controlHeightLG,
    multipleSelectItemHeight: token.multipleItemHeightLG,
    borderRadius: token.borderRadiusLG,
    borderRadiusSM: token.borderRadius
  });
  return [genSizeStyle(token),
  // ======================== Small ========================
  genSizeStyle(smallToken, 'sm'),
  // Padding
  {
    [`${componentCls}-multiple${componentCls}-sm`]: {
      [`${componentCls}-selection-placeholder`]: {
        insetInline: token.calc(token.controlPaddingHorizontalSM).sub(token.lineWidth).equal()
      },
      // https://github.com/ant-design/ant-design/issues/29559
      [`${componentCls}-selection-search`]: {
        marginInlineStart: 2 // Magic Number
      }
    }
  },
  // ======================== Large ========================
  genSizeStyle(largeToken, 'lg')];
};
/* harmony default export */ var multiple = (genMultipleStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/select/style/single.js



function single_genSizeStyle(token, suffix) {
  const {
    componentCls,
    inputPaddingHorizontalBase,
    borderRadius
  } = token;
  const selectHeightWithoutBorder = token.calc(token.controlHeight).sub(token.calc(token.lineWidth).mul(2)).equal();
  const suffixCls = suffix ? `${componentCls}-${suffix}` : '';
  return {
    [`${componentCls}-single${suffixCls}`]: {
      fontSize: token.fontSize,
      height: token.controlHeight,
      // ========================= Selector =========================
      [`${componentCls}-selector`]: Object.assign(Object.assign({}, resetComponent(token, true)), {
        display: 'flex',
        borderRadius,
        flex: '1 1 auto',
        [`${componentCls}-selection-wrap:after`]: {
          lineHeight: (0,cssinjs_es/* unit */.bf)(selectHeightWithoutBorder)
        },
        [`${componentCls}-selection-search`]: {
          position: 'absolute',
          inset: 0,
          width: '100%',
          '&-input': {
            width: '100%',
            WebkitAppearance: 'textfield'
          }
        },
        [`
          ${componentCls}-selection-item,
          ${componentCls}-selection-placeholder
        `]: {
          display: 'block',
          padding: 0,
          lineHeight: (0,cssinjs_es/* unit */.bf)(selectHeightWithoutBorder),
          transition: `all ${token.motionDurationSlow}, visibility 0s`,
          alignSelf: 'center'
        },
        [`${componentCls}-selection-placeholder`]: {
          transition: 'none',
          pointerEvents: 'none'
        },
        // For common baseline align
        [['&:after', /* For '' value baseline align */
        `${componentCls}-selection-item:empty:after`, /* For undefined value baseline align */
        `${componentCls}-selection-placeholder:empty:after`].join(',')]: {
          display: 'inline-block',
          width: 0,
          visibility: 'hidden',
          content: '"\\a0"'
        }
      }),
      [`
        &${componentCls}-show-arrow ${componentCls}-selection-item,
        &${componentCls}-show-arrow ${componentCls}-selection-search,
        &${componentCls}-show-arrow ${componentCls}-selection-placeholder
      `]: {
        paddingInlineEnd: token.showArrowPaddingInlineEnd
      },
      // Opacity selection if open
      [`&${componentCls}-open ${componentCls}-selection-item`]: {
        color: token.colorTextPlaceholder
      },
      // ========================== Input ==========================
      // We only change the style of non-customize input which is only support by `combobox` mode.
      // Not customize
      [`&:not(${componentCls}-customize-input)`]: {
        [`${componentCls}-selector`]: {
          width: '100%',
          height: '100%',
          alignItems: 'center',
          padding: `0 ${(0,cssinjs_es/* unit */.bf)(inputPaddingHorizontalBase)}`,
          [`${componentCls}-selection-search-input`]: {
            height: selectHeightWithoutBorder,
            fontSize: token.fontSize
          },
          '&:after': {
            lineHeight: (0,cssinjs_es/* unit */.bf)(selectHeightWithoutBorder)
          }
        }
      },
      [`&${componentCls}-customize-input`]: {
        [`${componentCls}-selector`]: {
          '&:after': {
            display: 'none'
          },
          [`${componentCls}-selection-search`]: {
            position: 'static',
            width: '100%'
          },
          [`${componentCls}-selection-placeholder`]: {
            position: 'absolute',
            insetInlineStart: 0,
            insetInlineEnd: 0,
            padding: `0 ${(0,cssinjs_es/* unit */.bf)(inputPaddingHorizontalBase)}`,
            '&:after': {
              display: 'none'
            }
          }
        }
      }
    }
  };
}
function single_genSingleStyle(token) {
  const {
    componentCls
  } = token;
  const inputPaddingHorizontalSM = token.calc(token.controlPaddingHorizontalSM).sub(token.lineWidth).equal();
  return [single_genSizeStyle(token),
  // ======================== Small ========================
  // Shared
  single_genSizeStyle((0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    controlHeight: token.controlHeightSM,
    borderRadius: token.borderRadiusSM
  }), 'sm'),
  // padding
  {
    [`${componentCls}-single${componentCls}-sm`]: {
      [`&:not(${componentCls}-customize-input)`]: {
        [`${componentCls}-selector`]: {
          padding: `0 ${(0,cssinjs_es/* unit */.bf)(inputPaddingHorizontalSM)}`
        },
        // With arrow should provides `padding-right` to show the arrow
        [`&${componentCls}-show-arrow ${componentCls}-selection-search`]: {
          insetInlineEnd: token.calc(inputPaddingHorizontalSM).add(token.calc(token.fontSize).mul(1.5)).equal()
        },
        [`
            &${componentCls}-show-arrow ${componentCls}-selection-item,
            &${componentCls}-show-arrow ${componentCls}-selection-placeholder
          `]: {
          paddingInlineEnd: token.calc(token.fontSize).mul(1.5).equal()
        }
      }
    }
  },
  // ======================== Large ========================
  // Shared
  single_genSizeStyle((0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    controlHeight: token.singleItemHeightLG,
    fontSize: token.fontSizeLG,
    borderRadius: token.borderRadiusLG
  }), 'lg')];
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/select/style/token.js
const style_token_prepareComponentToken = token => {
  const {
    fontSize,
    lineHeight,
    lineWidth,
    controlHeight,
    controlHeightSM,
    controlHeightLG,
    paddingXXS,
    controlPaddingHorizontal,
    zIndexPopupBase,
    colorText,
    fontWeightStrong,
    controlItemBgActive,
    controlItemBgHover,
    colorBgContainer,
    colorFillSecondary,
    colorBgContainerDisabled,
    colorTextDisabled,
    colorPrimaryHover,
    colorPrimary,
    controlOutline
  } = token;
  // Item height default use `controlHeight - 2 * paddingXXS`,
  // but some case `paddingXXS=0`.
  // Let's fallback it.
  const dblPaddingXXS = paddingXXS * 2;
  const dblLineWidth = lineWidth * 2;
  const multipleItemHeight = Math.min(controlHeight - dblPaddingXXS, controlHeight - dblLineWidth);
  const multipleItemHeightSM = Math.min(controlHeightSM - dblPaddingXXS, controlHeightSM - dblLineWidth);
  const multipleItemHeightLG = Math.min(controlHeightLG - dblPaddingXXS, controlHeightLG - dblLineWidth);
  // FIXED_ITEM_MARGIN is a hardcode calculation since calc not support rounding
  const INTERNAL_FIXED_ITEM_MARGIN = Math.floor(paddingXXS / 2);
  return {
    INTERNAL_FIXED_ITEM_MARGIN,
    zIndexPopup: zIndexPopupBase + 50,
    optionSelectedColor: colorText,
    optionSelectedFontWeight: fontWeightStrong,
    optionSelectedBg: controlItemBgActive,
    optionActiveBg: controlItemBgHover,
    optionPadding: `${(controlHeight - fontSize * lineHeight) / 2}px ${controlPaddingHorizontal}px`,
    optionFontSize: fontSize,
    optionLineHeight: lineHeight,
    optionHeight: controlHeight,
    selectorBg: colorBgContainer,
    clearBg: colorBgContainer,
    singleItemHeightLG: controlHeightLG,
    multipleItemBg: colorFillSecondary,
    multipleItemBorderColor: 'transparent',
    multipleItemHeight,
    multipleItemHeightSM,
    multipleItemHeightLG,
    multipleSelectorBgDisabled: colorBgContainerDisabled,
    multipleItemColorDisabled: colorTextDisabled,
    multipleItemBorderColorDisabled: 'transparent',
    showArrowPaddingInlineEnd: Math.ceil(token.fontSize * 1.25),
    hoverBorderColor: colorPrimaryHover,
    activeBorderColor: colorPrimary,
    activeOutlineColor: controlOutline,
    selectAffixPadding: paddingXXS
  };
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/select/style/variants.js

// =====================================================
// ==                  Outlined                       ==
// =====================================================
const genBaseOutlinedStyle = (token, options) => {
  const {
    componentCls,
    antCls,
    controlOutlineWidth
  } = token;
  return {
    [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: {
      border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${options.borderColor}`,
      background: token.selectorBg
    },
    [`&:not(${componentCls}-disabled):not(${componentCls}-customize-input):not(${antCls}-pagination-size-changer)`]: {
      [`&:hover ${componentCls}-selector`]: {
        borderColor: options.hoverBorderHover
      },
      [`${componentCls}-focused& ${componentCls}-selector`]: {
        borderColor: options.activeBorderColor,
        boxShadow: `0 0 0 ${(0,cssinjs_es/* unit */.bf)(controlOutlineWidth)} ${options.activeOutlineColor}`,
        outline: 0
      },
      [`${componentCls}-prefix`]: {
        color: options.color
      }
    }
  };
};
const genOutlinedStatusStyle = (token, options) => ({
  [`&${token.componentCls}-status-${options.status}`]: Object.assign({}, genBaseOutlinedStyle(token, options))
});
const genOutlinedStyle = token => ({
  '&-outlined': Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseOutlinedStyle(token, {
    borderColor: token.colorBorder,
    hoverBorderHover: token.hoverBorderColor,
    activeBorderColor: token.activeBorderColor,
    activeOutlineColor: token.activeOutlineColor,
    color: token.colorText
  })), genOutlinedStatusStyle(token, {
    status: 'error',
    borderColor: token.colorError,
    hoverBorderHover: token.colorErrorHover,
    activeBorderColor: token.colorError,
    activeOutlineColor: token.colorErrorOutline,
    color: token.colorError
  })), genOutlinedStatusStyle(token, {
    status: 'warning',
    borderColor: token.colorWarning,
    hoverBorderHover: token.colorWarningHover,
    activeBorderColor: token.colorWarning,
    activeOutlineColor: token.colorWarningOutline,
    color: token.colorWarning
  })), {
    [`&${token.componentCls}-disabled`]: {
      [`&:not(${token.componentCls}-customize-input) ${token.componentCls}-selector`]: {
        background: token.colorBgContainerDisabled,
        color: token.colorTextDisabled
      }
    },
    [`&${token.componentCls}-multiple ${token.componentCls}-selection-item`]: {
      background: token.multipleItemBg,
      border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
    }
  })
});
// =====================================================
// ==                   Filled                        ==
// =====================================================
const genBaseFilledStyle = (token, options) => {
  const {
    componentCls,
    antCls
  } = token;
  return {
    [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: {
      background: options.bg,
      border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} transparent`,
      color: options.color
    },
    [`&:not(${componentCls}-disabled):not(${componentCls}-customize-input):not(${antCls}-pagination-size-changer)`]: {
      [`&:hover ${componentCls}-selector`]: {
        background: options.hoverBg
      },
      [`${componentCls}-focused& ${componentCls}-selector`]: {
        background: token.selectorBg,
        borderColor: options.activeBorderColor,
        outline: 0
      }
    }
  };
};
const genFilledStatusStyle = (token, options) => ({
  [`&${token.componentCls}-status-${options.status}`]: Object.assign({}, genBaseFilledStyle(token, options))
});
const genFilledStyle = token => ({
  '&-filled': Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseFilledStyle(token, {
    bg: token.colorFillTertiary,
    hoverBg: token.colorFillSecondary,
    activeBorderColor: token.activeBorderColor,
    color: token.colorText
  })), genFilledStatusStyle(token, {
    status: 'error',
    bg: token.colorErrorBg,
    hoverBg: token.colorErrorBgHover,
    activeBorderColor: token.colorError,
    color: token.colorError
  })), genFilledStatusStyle(token, {
    status: 'warning',
    bg: token.colorWarningBg,
    hoverBg: token.colorWarningBgHover,
    activeBorderColor: token.colorWarning,
    color: token.colorWarning
  })), {
    [`&${token.componentCls}-disabled`]: {
      [`&:not(${token.componentCls}-customize-input) ${token.componentCls}-selector`]: {
        borderColor: token.colorBorder,
        background: token.colorBgContainerDisabled,
        color: token.colorTextDisabled
      }
    },
    [`&${token.componentCls}-multiple ${token.componentCls}-selection-item`]: {
      background: token.colorBgContainer,
      border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
    }
  })
});
// =====================================================
// ==                 Borderless                      ==
// =====================================================
const variants_genBorderlessStyle = token => ({
  '&-borderless': {
    [`${token.componentCls}-selector`]: {
      background: 'transparent',
      border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} transparent`
    },
    [`&${token.componentCls}-disabled`]: {
      [`&:not(${token.componentCls}-customize-input) ${token.componentCls}-selector`]: {
        color: token.colorTextDisabled
      }
    },
    [`&${token.componentCls}-multiple ${token.componentCls}-selection-item`]: {
      background: token.multipleItemBg,
      border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
    },
    // Status
    [`&${token.componentCls}-status-error`]: {
      [`${token.componentCls}-prefix, ${token.componentCls}-selection-item`]: {
        color: token.colorError
      }
    },
    [`&${token.componentCls}-status-warning`]: {
      [`${token.componentCls}-prefix, ${token.componentCls}-selection-item`]: {
        color: token.colorWarning
      }
    }
  }
});
// =====================================================
// ==                 Underlined                      ==
// =====================================================
const genBaseUnderlinedStyle = (token, options) => {
  const {
    componentCls,
    antCls
  } = token;
  return {
    [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: {
      borderWidth: `0 0 ${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} 0`,
      borderStyle: `none none ${token.lineType} none`,
      borderColor: options.borderColor,
      background: token.selectorBg,
      borderRadius: 0
    },
    [`&:not(${componentCls}-disabled):not(${componentCls}-customize-input):not(${antCls}-pagination-size-changer)`]: {
      [`&:hover ${componentCls}-selector`]: {
        borderColor: options.hoverBorderHover
      },
      [`${componentCls}-focused& ${componentCls}-selector`]: {
        borderColor: options.activeBorderColor,
        outline: 0
      },
      [`${componentCls}-prefix`]: {
        color: options.color
      }
    }
  };
};
const genUnderlinedStatusStyle = (token, options) => ({
  [`&${token.componentCls}-status-${options.status}`]: Object.assign({}, genBaseUnderlinedStyle(token, options))
});
const genUnderlinedStyle = token => ({
  '&-underlined': Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseUnderlinedStyle(token, {
    borderColor: token.colorBorder,
    hoverBorderHover: token.hoverBorderColor,
    activeBorderColor: token.activeBorderColor,
    activeOutlineColor: token.activeOutlineColor,
    color: token.colorText
  })), genUnderlinedStatusStyle(token, {
    status: 'error',
    borderColor: token.colorError,
    hoverBorderHover: token.colorErrorHover,
    activeBorderColor: token.colorError,
    activeOutlineColor: token.colorErrorOutline,
    color: token.colorError
  })), genUnderlinedStatusStyle(token, {
    status: 'warning',
    borderColor: token.colorWarning,
    hoverBorderHover: token.colorWarningHover,
    activeBorderColor: token.colorWarning,
    activeOutlineColor: token.colorWarningOutline,
    color: token.colorWarning
  })), {
    [`&${token.componentCls}-disabled`]: {
      [`&:not(${token.componentCls}-customize-input) ${token.componentCls}-selector`]: {
        color: token.colorTextDisabled
      }
    },
    [`&${token.componentCls}-multiple ${token.componentCls}-selection-item`]: {
      background: token.multipleItemBg,
      border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
    }
  })
});
const genVariantsStyle = token => ({
  [token.componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, genOutlinedStyle(token)), genFilledStyle(token)), variants_genBorderlessStyle(token)), genUnderlinedStyle(token))
});
/* harmony default export */ var variants = (genVariantsStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/select/style/index.js








// ============================= Selector =============================
const genSelectorStyle = token => {
  const {
    componentCls
  } = token;
  return {
    position: 'relative',
    transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
    input: {
      cursor: 'pointer'
    },
    [`${componentCls}-show-search&`]: {
      cursor: 'text',
      input: {
        cursor: 'auto',
        color: 'inherit',
        height: '100%'
      }
    },
    [`${componentCls}-disabled&`]: {
      cursor: 'not-allowed',
      input: {
        cursor: 'not-allowed'
      }
    }
  };
};
// ============================== Styles ==============================
// /* Reset search input style */
const getSearchInputWithoutBorderStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}-selection-search-input`]: {
      margin: 0,
      padding: 0,
      background: 'transparent',
      border: 'none',
      outline: 'none',
      appearance: 'none',
      fontFamily: 'inherit',
      '&::-webkit-search-cancel-button': {
        display: 'none',
        appearance: 'none'
      }
    }
  };
};
// =============================== Base ===============================
const select_style_genBaseStyle = token => {
  const {
    antCls,
    componentCls,
    inputPaddingHorizontalBase,
    iconCls
  } = token;
  const hoverShowClearStyle = {
    [`${componentCls}-clear`]: {
      opacity: 1,
      background: token.colorBgBase,
      borderRadius: '50%'
    }
  };
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      position: 'relative',
      display: 'inline-flex',
      cursor: 'pointer',
      [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: Object.assign(Object.assign({}, genSelectorStyle(token)), getSearchInputWithoutBorderStyle(token)),
      // ======================== Selection ========================
      [`${componentCls}-selection-item`]: Object.assign(Object.assign({
        flex: 1,
        fontWeight: 'normal',
        position: 'relative',
        userSelect: 'none'
      }, textEllipsis), {
        // https://github.com/ant-design/ant-design/issues/40421
        [`> ${antCls}-typography`]: {
          display: 'inline'
        }
      }),
      // ======================= Placeholder =======================
      [`${componentCls}-selection-placeholder`]: Object.assign(Object.assign({}, textEllipsis), {
        flex: 1,
        color: token.colorTextPlaceholder,
        pointerEvents: 'none'
      }),
      // ========================== Arrow ==========================
      [`${componentCls}-arrow`]: Object.assign(Object.assign({}, resetIcon()), {
        position: 'absolute',
        top: '50%',
        insetInlineStart: 'auto',
        insetInlineEnd: inputPaddingHorizontalBase,
        height: token.fontSizeIcon,
        marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
        color: token.colorTextQuaternary,
        fontSize: token.fontSizeIcon,
        lineHeight: 1,
        textAlign: 'center',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        transition: `opacity ${token.motionDurationSlow} ease`,
        [iconCls]: {
          verticalAlign: 'top',
          transition: `transform ${token.motionDurationSlow}`,
          '> svg': {
            verticalAlign: 'top'
          },
          [`&:not(${componentCls}-suffix)`]: {
            pointerEvents: 'auto'
          }
        },
        [`${componentCls}-disabled &`]: {
          cursor: 'not-allowed'
        },
        '> *:not(:last-child)': {
          marginInlineEnd: 8 // FIXME: magic
        }
      }),
      // ========================== Wrap ===========================
      [`${componentCls}-selection-wrap`]: {
        display: 'flex',
        width: '100%',
        position: 'relative',
        minWidth: 0,
        // https://github.com/ant-design/ant-design/issues/51669
        '&:after': {
          content: '"\\a0"',
          width: 0,
          overflow: 'hidden'
        }
      },
      // ========================= Prefix ==========================
      [`${componentCls}-prefix`]: {
        flex: 'none',
        marginInlineEnd: token.selectAffixPadding
      },
      // ========================== Clear ==========================
      [`${componentCls}-clear`]: {
        position: 'absolute',
        top: '50%',
        insetInlineStart: 'auto',
        insetInlineEnd: inputPaddingHorizontalBase,
        zIndex: 1,
        display: 'inline-block',
        width: token.fontSizeIcon,
        height: token.fontSizeIcon,
        marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
        color: token.colorTextQuaternary,
        fontSize: token.fontSizeIcon,
        fontStyle: 'normal',
        lineHeight: 1,
        textAlign: 'center',
        textTransform: 'none',
        cursor: 'pointer',
        opacity: 0,
        transition: `color ${token.motionDurationMid} ease, opacity ${token.motionDurationSlow} ease`,
        textRendering: 'auto',
        // https://github.com/ant-design/ant-design/issues/54205
        // Force GPU compositing on Safari to prevent flickering on opacity/transform transitions
        transform: 'translateZ(0)',
        '&:before': {
          display: 'block'
        },
        '&:hover': {
          color: token.colorIcon
        }
      },
      '@media(hover:none)': hoverShowClearStyle,
      '&:hover': hoverShowClearStyle
    }),
    // ========================= Feedback ==========================
    [`${componentCls}-status`]: {
      '&-error, &-warning, &-success, &-validating': {
        [`&${componentCls}-has-feedback`]: {
          [`${componentCls}-clear`]: {
            insetInlineEnd: token.calc(inputPaddingHorizontalBase).add(token.fontSize).add(token.paddingXS).equal()
          }
        }
      }
    }
  };
};
// ============================== Styles ==============================
const genSelectStyle = token => {
  const {
    componentCls
  } = token;
  return [{
    [componentCls]: {
      // ==================== In Form ====================
      [`&${componentCls}-in-form-item`]: {
        width: '100%'
      }
    }
  },
  // =====================================================
  // ==                       LTR                       ==
  // =====================================================
  // Base
  select_style_genBaseStyle(token),
  // Single
  single_genSingleStyle(token),
  // Multiple
  multiple(token),
  // Dropdown
  dropdown(token),
  // =====================================================
  // ==                       RTL                       ==
  // =====================================================
  {
    [`${componentCls}-rtl`]: {
      direction: 'rtl'
    }
  },
  // =====================================================
  // ==             Space Compact                       ==
  // =====================================================
  genCompactItemStyle(token, {
    borderElCls: `${componentCls}-selector`,
    focusElCls: `${componentCls}-focused`
  })];
};
// ============================== Export ==============================
/* harmony default export */ var select_style = (genStyleHooks('Select', (token, {
  rootPrefixCls
}) => {
  const selectToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    rootPrefixCls,
    inputPaddingHorizontalBase: token.calc(token.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: token.multipleItemHeight,
    selectHeight: token.controlHeight
  });
  return [genSelectStyle(selectToken), variants(selectToken)];
}, style_token_prepareComponentToken, {
  unitless: {
    optionLineHeight: true,
    optionSelectedFontWeight: true
  }
}));
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CheckOutlined.js + 1 modules
var CheckOutlined = __webpack_require__(71109);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/DownOutlined.js + 1 modules
var DownOutlined = __webpack_require__(16954);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/SearchOutlined.js + 1 modules
var SearchOutlined = __webpack_require__(66148);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/select/useIcons.js
"use client";









function useIcons({
  suffixIcon,
  clearIcon,
  menuItemSelectedIcon,
  removeIcon,
  loading,
  multiple,
  hasFeedback,
  prefixCls,
  showSuffixIcon,
  feedbackIcon,
  showArrow,
  componentName
}) {
  if (false) {}
  // Clear Icon
  const mergedClearIcon = clearIcon !== null && clearIcon !== void 0 ? clearIcon : /*#__PURE__*/react.createElement(CloseCircleFilled/* default */.Z, null);
  // Validation Feedback Icon
  const getSuffixIconNode = arrowIcon => {
    if (suffixIcon === null && !hasFeedback && !showArrow) {
      return null;
    }
    return /*#__PURE__*/react.createElement(react.Fragment, null, showSuffixIcon !== false && arrowIcon, hasFeedback && feedbackIcon);
  };
  // Arrow item icon
  let mergedSuffixIcon = null;
  if (suffixIcon !== undefined) {
    mergedSuffixIcon = getSuffixIconNode(suffixIcon);
  } else if (loading) {
    mergedSuffixIcon = getSuffixIconNode(/*#__PURE__*/react.createElement(LoadingOutlined/* default */.Z, {
      spin: true
    }));
  } else {
    const iconCls = `${prefixCls}-suffix`;
    mergedSuffixIcon = ({
      open,
      showSearch
    }) => {
      if (open && showSearch) {
        return getSuffixIconNode(/*#__PURE__*/react.createElement(SearchOutlined/* default */.Z, {
          className: iconCls
        }));
      }
      return getSuffixIconNode(/*#__PURE__*/react.createElement(DownOutlined/* default */.Z, {
        className: iconCls
      }));
    };
  }
  // Checked item icon
  let mergedItemIcon = null;
  if (menuItemSelectedIcon !== undefined) {
    mergedItemIcon = menuItemSelectedIcon;
  } else if (multiple) {
    mergedItemIcon = /*#__PURE__*/react.createElement(CheckOutlined/* default */.Z, null);
  } else {
    mergedItemIcon = null;
  }
  let mergedRemoveIcon = null;
  if (removeIcon !== undefined) {
    mergedRemoveIcon = removeIcon;
  } else {
    mergedRemoveIcon = /*#__PURE__*/react.createElement(CloseOutlined/* default */.Z, null);
  }
  return {
    clearIcon: mergedClearIcon,
    suffixIcon: mergedSuffixIcon,
    itemIcon: mergedItemIcon,
    removeIcon: mergedRemoveIcon
  };
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/select/usePopupRender.js
"use client";



function usePopupRender(renderFn) {
  return react.useMemo(() => {
    if (!renderFn) {
      return undefined;
    }
    return (...args) => /*#__PURE__*/react.createElement(_util_ContextIsolator, {
      space: true
    }, renderFn.apply(void 0, args));
  }, [renderFn]);
}
/* harmony default export */ var select_usePopupRender = (usePopupRender);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/select/useShowArrow.js
/**
 * Since Select, TreeSelect, Cascader is same Select like component.
 * We just use same hook to handle this logic.
 *
 * If `suffixIcon` is not equal to `null`, always show it.
 */
function useShowArrow(suffixIcon, showArrow) {
  return showArrow !== undefined ? showArrow : suffixIcon !== null;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/select/index.js
"use client";

var select_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
// TODO: 4.0 - codemod should help to change `filterOption` to support node props.
























const SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
const InternalSelect = (props, ref) => {
  var _a, _b, _c, _d, _e;
  const {
      prefixCls: customizePrefixCls,
      bordered,
      className,
      rootClassName,
      getPopupContainer,
      popupClassName,
      dropdownClassName,
      listHeight = 256,
      placement,
      listItemHeight: customListItemHeight,
      size: customizeSize,
      disabled: customDisabled,
      notFoundContent,
      status: customStatus,
      builtinPlacements,
      dropdownMatchSelectWidth,
      popupMatchSelectWidth,
      direction: propDirection,
      style,
      allowClear,
      variant: customizeVariant,
      dropdownStyle,
      transitionName,
      tagRender,
      maxCount,
      prefix,
      dropdownRender,
      popupRender,
      onDropdownVisibleChange,
      onOpenChange,
      styles,
      classNames
    } = props,
    rest = select_rest(props, ["prefixCls", "bordered", "className", "rootClassName", "getPopupContainer", "popupClassName", "dropdownClassName", "listHeight", "placement", "listItemHeight", "size", "disabled", "notFoundContent", "status", "builtinPlacements", "dropdownMatchSelectWidth", "popupMatchSelectWidth", "direction", "style", "allowClear", "variant", "dropdownStyle", "transitionName", "tagRender", "maxCount", "prefix", "dropdownRender", "popupRender", "onDropdownVisibleChange", "onOpenChange", "styles", "classNames"]);
  const {
    getPopupContainer: getContextPopupContainer,
    getPrefixCls,
    renderEmpty,
    direction: contextDirection,
    virtual,
    popupMatchSelectWidth: contextPopupMatchSelectWidth,
    popupOverflow
  } = react.useContext(ConfigContext);
  const {
    showSearch,
    style: contextStyle,
    styles: contextStyles,
    className: contextClassName,
    classNames: contextClassNames
  } = useComponentConfig('select');
  const [, token] = useToken();
  const listItemHeight = customListItemHeight !== null && customListItemHeight !== void 0 ? customListItemHeight : token === null || token === void 0 ? void 0 : token.controlHeight;
  const prefixCls = getPrefixCls('select', customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  const direction = propDirection !== null && propDirection !== void 0 ? propDirection : contextDirection;
  const {
    compactSize,
    compactItemClassnames
  } = useCompactItemContext(prefixCls, direction);
  const [variant, enableVariantCls] = useVariants('select', customizeVariant, bordered);
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = select_style(prefixCls, rootCls);
  const mode = react.useMemo(() => {
    const {
      mode: m
    } = props;
    if (m === 'combobox') {
      return undefined;
    }
    if (m === SECRET_COMBOBOX_MODE_DO_NOT_USE) {
      return 'combobox';
    }
    return m;
  }, [props.mode]);
  const isMultiple = mode === 'multiple' || mode === 'tags';
  const showSuffixIcon = useShowArrow(props.suffixIcon, props.showArrow);
  const mergedPopupMatchSelectWidth = (_a = popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth) !== null && _a !== void 0 ? _a : contextPopupMatchSelectWidth;
  const mergedPopupStyle = ((_b = styles === null || styles === void 0 ? void 0 : styles.popup) === null || _b === void 0 ? void 0 : _b.root) || ((_c = contextStyles.popup) === null || _c === void 0 ? void 0 : _c.root) || dropdownStyle;
  const mergedPopupRender = select_usePopupRender(popupRender || dropdownRender);
  const mergedOnOpenChange = onOpenChange || onDropdownVisibleChange;
  // ===================== Form Status =====================
  const {
    status: contextStatus,
    hasFeedback,
    isFormItemInput,
    feedbackIcon
  } = react.useContext(FormItemInputContext);
  const mergedStatus = getMergedStatus(contextStatus, customStatus);
  // ===================== Empty =====================
  let mergedNotFound;
  if (notFoundContent !== undefined) {
    mergedNotFound = notFoundContent;
  } else if (mode === 'combobox') {
    mergedNotFound = null;
  } else {
    mergedNotFound = (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty('Select')) || /*#__PURE__*/react.createElement(defaultRenderEmpty, {
      componentName: "Select"
    });
  }
  // ===================== Icons =====================
  const {
    suffixIcon,
    itemIcon,
    removeIcon,
    clearIcon
  } = useIcons(Object.assign(Object.assign({}, rest), {
    multiple: isMultiple,
    hasFeedback,
    feedbackIcon,
    showSuffixIcon,
    prefixCls,
    componentName: 'Select'
  }));
  const mergedAllowClear = allowClear === true ? {
    clearIcon
  } : allowClear;
  const selectProps = (0,omit/* default */.Z)(rest, ['suffixIcon', 'itemIcon']);
  const mergedPopupClassName = classnames_default()(((_d = classNames === null || classNames === void 0 ? void 0 : classNames.popup) === null || _d === void 0 ? void 0 : _d.root) || ((_e = contextClassNames === null || contextClassNames === void 0 ? void 0 : contextClassNames.popup) === null || _e === void 0 ? void 0 : _e.root) || popupClassName || dropdownClassName, {
    [`${prefixCls}-dropdown-${direction}`]: direction === 'rtl'
  }, rootClassName, contextClassNames.root, classNames === null || classNames === void 0 ? void 0 : classNames.root, cssVarCls, rootCls, hashId);
  const mergedSize = hooks_useSize(ctx => {
    var _a;
    return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
  });
  // ===================== Disabled =====================
  const disabled = react.useContext(config_provider_DisabledContext);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  const mergedClassName = classnames_default()({
    [`${prefixCls}-lg`]: mergedSize === 'large',
    [`${prefixCls}-sm`]: mergedSize === 'small',
    [`${prefixCls}-rtl`]: direction === 'rtl',
    [`${prefixCls}-${variant}`]: enableVariantCls,
    [`${prefixCls}-in-form-item`]: isFormItemInput
  }, getStatusClassNames(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, contextClassName, className, contextClassNames.root, classNames === null || classNames === void 0 ? void 0 : classNames.root, rootClassName, cssVarCls, rootCls, hashId);
  // ===================== Placement =====================
  const memoPlacement = react.useMemo(() => {
    if (placement !== undefined) {
      return placement;
    }
    return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
  }, [placement, direction]);
  // ====================== Warning ======================
  if (false) {}
  // ====================== zIndex =========================
  const [zIndex] = useZIndex('SelectLike', mergedPopupStyle === null || mergedPopupStyle === void 0 ? void 0 : mergedPopupStyle.zIndex);
  // ====================== Render =======================
  return wrapCSSVar(/*#__PURE__*/react.createElement(rc_select_es/* default */.ZP, Object.assign({
    ref: ref,
    virtual: virtual,
    showSearch: showSearch
  }, selectProps, {
    style: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.root), styles === null || styles === void 0 ? void 0 : styles.root), contextStyle), style),
    dropdownMatchSelectWidth: mergedPopupMatchSelectWidth,
    transitionName: getTransitionName(rootPrefixCls, 'slide-up', transitionName),
    builtinPlacements: select_mergedBuiltinPlacements(builtinPlacements, popupOverflow),
    listHeight: listHeight,
    listItemHeight: listItemHeight,
    mode: mode,
    prefixCls: prefixCls,
    placement: memoPlacement,
    direction: direction,
    prefix: prefix,
    suffixIcon: suffixIcon,
    menuItemSelectedIcon: itemIcon,
    removeIcon: removeIcon,
    allowClear: mergedAllowClear,
    notFoundContent: mergedNotFound,
    className: mergedClassName,
    getPopupContainer: getPopupContainer || getContextPopupContainer,
    dropdownClassName: mergedPopupClassName,
    disabled: mergedDisabled,
    dropdownStyle: Object.assign(Object.assign({}, mergedPopupStyle), {
      zIndex
    }),
    maxCount: isMultiple ? maxCount : undefined,
    tagRender: isMultiple ? tagRender : undefined,
    dropdownRender: mergedPopupRender,
    onDropdownVisibleChange: mergedOnOpenChange
  })));
};
if (false) {}
const Select = /*#__PURE__*/react.forwardRef(InternalSelect);
// We don't care debug panel
/* istanbul ignore next */
const select_PurePanel = _util_PurePanel(Select, 'dropdownAlign');
Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = SECRET_COMBOBOX_MODE_DO_NOT_USE;
Select.Option = rc_select_es/* Option */.Wx;
Select.OptGroup = rc_select_es/* OptGroup */.Xo;
Select._InternalPanelDoNotUseOrYouWillBeFired = select_PurePanel;
if (false) {}
/* harmony default export */ var es_select = (Select);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/auto-complete/AutoComplete.js
"use client";









const {
  Option
} = es_select;
function isSelectOptionOrSelectOptGroup(child) {
  return (child === null || child === void 0 ? void 0 : child.type) && (child.type.isSelectOption || child.type.isSelectOptGroup);
}
const AutoComplete = (props, ref) => {
  var _a, _b;
  const {
    prefixCls: customizePrefixCls,
    className,
    popupClassName,
    dropdownClassName,
    children,
    dataSource,
    dropdownStyle,
    dropdownRender,
    popupRender,
    onDropdownVisibleChange,
    onOpenChange,
    styles,
    classNames
  } = props;
  const childNodes = (0,Children_toArray/* default */.Z)(children);
  const mergedPopupStyle = ((_a = styles === null || styles === void 0 ? void 0 : styles.popup) === null || _a === void 0 ? void 0 : _a.root) || dropdownStyle;
  const mergedPopupClassName = ((_b = classNames === null || classNames === void 0 ? void 0 : classNames.popup) === null || _b === void 0 ? void 0 : _b.root) || popupClassName || dropdownClassName;
  const mergedPopupRender = popupRender || dropdownRender;
  const mergedOnOpenChange = onOpenChange || onDropdownVisibleChange;
  // ============================= Input =============================
  let customizeInput;
  if (childNodes.length === 1 && /*#__PURE__*/react.isValidElement(childNodes[0]) && !isSelectOptionOrSelectOptGroup(childNodes[0])) {
    [customizeInput] = childNodes;
  }
  const getInputElement = customizeInput ? () => customizeInput : undefined;
  // ============================ Options ============================
  let optionChildren;
  // [Legacy] convert `children` or `dataSource` into option children
  if (childNodes.length && isSelectOptionOrSelectOptGroup(childNodes[0])) {
    optionChildren = children;
  } else {
    optionChildren = dataSource ? dataSource.map(item => {
      if (/*#__PURE__*/react.isValidElement(item)) {
        return item;
      }
      switch (typeof item) {
        case 'string':
          return /*#__PURE__*/react.createElement(Option, {
            key: item,
            value: item
          }, item);
        case 'object':
          {
            const {
              value: optionValue
            } = item;
            return /*#__PURE__*/react.createElement(Option, {
              key: optionValue,
              value: optionValue
            }, item.text);
          }
        default:
          return undefined;
      }
    }) : [];
  }
  if (false) {}
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('select', customizePrefixCls);
  // ============================ zIndex ============================
  const [zIndex] = useZIndex('SelectLike', mergedPopupStyle === null || mergedPopupStyle === void 0 ? void 0 : mergedPopupStyle.zIndex);
  return /*#__PURE__*/react.createElement(es_select, Object.assign({
    ref: ref,
    suffixIcon: null
  }, (0,omit/* default */.Z)(props, ['dataSource', 'dropdownClassName', 'popupClassName']), {
    prefixCls: prefixCls,
    classNames: {
      popup: {
        root: mergedPopupClassName
      },
      root: classNames === null || classNames === void 0 ? void 0 : classNames.root
    },
    styles: {
      popup: {
        root: Object.assign(Object.assign({}, mergedPopupStyle), {
          zIndex
        })
      },
      root: styles === null || styles === void 0 ? void 0 : styles.root
    },
    className: classnames_default()(`${prefixCls}-auto-complete`, className),
    mode: es_select.SECRET_COMBOBOX_MODE_DO_NOT_USE,
    popupRender: mergedPopupRender,
    onOpenChange: mergedOnOpenChange,
    // Internal api
    getInputElement
  }), optionChildren);
};
const RefAutoComplete = /*#__PURE__*/react.forwardRef(AutoComplete);
if (false) {}
/* harmony default export */ var auto_complete_AutoComplete = (RefAutoComplete);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/auto-complete/index.js
"use client";





const {
  Option: auto_complete_Option
} = es_select;
// We don't care debug panel
/* istanbul ignore next */
const auto_complete_PurePanel = _util_PurePanel(auto_complete_AutoComplete, 'dropdownAlign', props => (0,omit/* default */.Z)(props, ['visible']));
const es_auto_complete_AutoComplete = auto_complete_AutoComplete;
es_auto_complete_AutoComplete.Option = auto_complete_Option;
es_auto_complete_AutoComplete._InternalPanelDoNotUseOrYouWillBeFired = auto_complete_PurePanel;
/* harmony default export */ var auto_complete = (es_auto_complete_AutoComplete);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/mediaQueryUtil.js
const addMediaQueryListener = (mql, handler) => {
  // Don't delete here, please keep the code compatible
  if (typeof (mql === null || mql === void 0 ? void 0 : mql.addEventListener) !== 'undefined') {
    mql.addEventListener('change', handler);
  } else if (typeof (mql === null || mql === void 0 ? void 0 : mql.addListener) !== 'undefined') {
    mql.addListener(handler);
  }
};
const removeMediaQueryListener = (mql, handler) => {
  // Don't delete here, please keep the code compatible
  if (typeof (mql === null || mql === void 0 ? void 0 : mql.removeEventListener) !== 'undefined') {
    mql.removeEventListener('change', handler);
  } else if (typeof (mql === null || mql === void 0 ? void 0 : mql.removeListener) !== 'undefined') {
    mql.removeListener(handler);
  }
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/responsiveObserver.js



const responsiveArray = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
const getResponsiveMap = token => ({
  xs: `(max-width: ${token.screenXSMax}px)`,
  sm: `(min-width: ${token.screenSM}px)`,
  md: `(min-width: ${token.screenMD}px)`,
  lg: `(min-width: ${token.screenLG}px)`,
  xl: `(min-width: ${token.screenXL}px)`,
  xxl: `(min-width: ${token.screenXXL}px)`
});
/**
 * Ensures that the breakpoints token are valid, in good order
 * For each breakpoint : screenMin <= screen <= screenMax and screenMax <= nextScreenMin
 */
const validateBreakpoints = token => {
  const indexableToken = token;
  const revBreakpoints = [].concat(responsiveArray).reverse();
  revBreakpoints.forEach((breakpoint, i) => {
    const breakpointUpper = breakpoint.toUpperCase();
    const screenMin = `screen${breakpointUpper}Min`;
    const screen = `screen${breakpointUpper}`;
    if (!(indexableToken[screenMin] <= indexableToken[screen])) {
      throw new Error(`${screenMin}<=${screen} fails : !(${indexableToken[screenMin]}<=${indexableToken[screen]})`);
    }
    if (i < revBreakpoints.length - 1) {
      const screenMax = `screen${breakpointUpper}Max`;
      if (!(indexableToken[screen] <= indexableToken[screenMax])) {
        throw new Error(`${screen}<=${screenMax} fails : !(${indexableToken[screen]}<=${indexableToken[screenMax]})`);
      }
      const nextBreakpointUpperMin = revBreakpoints[i + 1].toUpperCase();
      const nextScreenMin = `screen${nextBreakpointUpperMin}Min`;
      if (!(indexableToken[screenMax] <= indexableToken[nextScreenMin])) {
        throw new Error(`${screenMax}<=${nextScreenMin} fails : !(${indexableToken[screenMax]}<=${indexableToken[nextScreenMin]})`);
      }
    }
  });
  return token;
};
const matchScreen = (screens, screenSizes) => {
  if (!screenSizes) {
    return;
  }
  for (const breakpoint of responsiveArray) {
    if (screens[breakpoint] && (screenSizes === null || screenSizes === void 0 ? void 0 : screenSizes[breakpoint]) !== undefined) {
      return screenSizes[breakpoint];
    }
  }
};
const useResponsiveObserver = () => {
  const [, token] = useToken();
  const responsiveMap = getResponsiveMap(validateBreakpoints(token));
  // To avoid repeat create instance, we add `useMemo` here.
  return react.useMemo(() => {
    const subscribers = new Map();
    let subUid = -1;
    let screens = {};
    return {
      responsiveMap,
      matchHandlers: {},
      dispatch(pointMap) {
        screens = pointMap;
        subscribers.forEach(func => func(screens));
        return subscribers.size >= 1;
      },
      subscribe(func) {
        if (!subscribers.size) {
          this.register();
        }
        subUid += 1;
        subscribers.set(subUid, func);
        func(screens);
        return subUid;
      },
      unsubscribe(paramToken) {
        subscribers.delete(paramToken);
        if (!subscribers.size) {
          this.unregister();
        }
      },
      register() {
        Object.entries(responsiveMap).forEach(([screen, mediaQuery]) => {
          const listener = ({
            matches
          }) => {
            this.dispatch(Object.assign(Object.assign({}, screens), {
              [screen]: matches
            }));
          };
          const mql = window.matchMedia(mediaQuery);
          addMediaQueryListener(mql, listener);
          this.matchHandlers[mediaQuery] = {
            mql,
            listener
          };
          listener(mql);
        });
      },
      unregister() {
        Object.values(responsiveMap).forEach(mediaQuery => {
          const handler = this.matchHandlers[mediaQuery];
          removeMediaQueryListener(handler === null || handler === void 0 ? void 0 : handler.mql, handler === null || handler === void 0 ? void 0 : handler.listener);
        });
        subscribers.clear();
      }
    };
  }, [token]);
};
/* harmony default export */ var _util_responsiveObserver = (useResponsiveObserver);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/hooks/useForceUpdate.js

function useForceUpdate() {
  const [, forceUpdate] = react.useReducer(x => x + 1, 0);
  return forceUpdate;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/grid/hooks/useBreakpoint.js
"use client";





function useBreakpoint(refreshOnChange = true, defaultScreens = {}) {
  const screensRef = (0,react.useRef)(defaultScreens);
  const forceUpdate = useForceUpdate();
  const responsiveObserver = _util_responsiveObserver();
  (0,hooks_useLayoutEffect/* default */.Z)(() => {
    const token = responsiveObserver.subscribe(supportScreens => {
      screensRef.current = supportScreens;
      if (refreshOnChange) {
        forceUpdate();
      }
    });
    return () => responsiveObserver.unsubscribe(token);
  }, []);
  return screensRef.current;
}
/* harmony default export */ var hooks_useBreakpoint = (useBreakpoint);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/avatar/AvatarContext.js

const AvatarContext = /*#__PURE__*/react.createContext({});
/* harmony default export */ var avatar_AvatarContext = (AvatarContext);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/avatar/style/index.js



const avatar_style_genBaseStyle = token => {
  const {
    antCls,
    componentCls,
    iconCls,
    avatarBg,
    avatarColor,
    containerSize,
    containerSizeLG,
    containerSizeSM,
    textFontSize,
    textFontSizeLG,
    textFontSizeSM,
    iconFontSize,
    iconFontSizeLG,
    iconFontSizeSM,
    borderRadius,
    borderRadiusLG,
    borderRadiusSM,
    lineWidth,
    lineType
  } = token;
  // Avatar size style
  const avatarSizeStyle = (size, fontSize, iconFontSize, radius) => ({
    width: size,
    height: size,
    borderRadius: '50%',
    fontSize,
    [`&${componentCls}-square`]: {
      borderRadius: radius
    },
    [`&${componentCls}-icon`]: {
      fontSize: iconFontSize,
      [`> ${iconCls}`]: {
        margin: 0
      }
    }
  });
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), {
      position: 'relative',
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
      color: avatarColor,
      whiteSpace: 'nowrap',
      textAlign: 'center',
      verticalAlign: 'middle',
      background: avatarBg,
      border: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} transparent`,
      '&-image': {
        background: 'transparent'
      },
      [`${antCls}-image-img`]: {
        display: 'block'
      }
    }), avatarSizeStyle(containerSize, textFontSize, iconFontSize, borderRadius)), {
      '&-lg': Object.assign({}, avatarSizeStyle(containerSizeLG, textFontSizeLG, iconFontSizeLG, borderRadiusLG)),
      '&-sm': Object.assign({}, avatarSizeStyle(containerSizeSM, textFontSizeSM, iconFontSizeSM, borderRadiusSM)),
      '> img': {
        display: 'block',
        width: '100%',
        height: '100%',
        objectFit: 'cover'
      }
    })
  };
};
const style_genGroupStyle = token => {
  const {
    componentCls,
    groupBorderColor,
    groupOverlapping,
    groupSpace
  } = token;
  return {
    [`${componentCls}-group`]: {
      display: 'inline-flex',
      [componentCls]: {
        borderColor: groupBorderColor
      },
      '> *:not(:first-child)': {
        marginInlineStart: groupOverlapping
      }
    },
    [`${componentCls}-group-popover`]: {
      [`${componentCls} + ${componentCls}`]: {
        marginInlineStart: groupSpace
      }
    }
  };
};
const avatar_style_prepareComponentToken = token => {
  const {
    controlHeight,
    controlHeightLG,
    controlHeightSM,
    fontSize,
    fontSizeLG,
    fontSizeXL,
    fontSizeHeading3,
    marginXS,
    marginXXS,
    colorBorderBg
  } = token;
  return {
    containerSize: controlHeight,
    containerSizeLG: controlHeightLG,
    containerSizeSM: controlHeightSM,
    textFontSize: fontSize,
    textFontSizeLG: fontSize,
    textFontSizeSM: fontSize,
    iconFontSize: Math.round((fontSizeLG + fontSizeXL) / 2),
    iconFontSizeLG: fontSizeHeading3,
    iconFontSizeSM: fontSize,
    groupSpace: marginXXS,
    groupOverlapping: -marginXS,
    groupBorderColor: colorBorderBg
  };
};
/* harmony default export */ var avatar_style = (genStyleHooks('Avatar', token => {
  const {
    colorTextLightSolid,
    colorTextPlaceholder
  } = token;
  const avatarToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    avatarBg: colorTextPlaceholder,
    avatarColor: colorTextLightSolid
  });
  return [avatar_style_genBaseStyle(avatarToken), style_genGroupStyle(avatarToken)];
}, avatar_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/avatar/Avatar.js
"use client";

var Avatar_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};












const Avatar_Avatar = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      shape,
      size: customSize,
      src,
      srcSet,
      icon,
      className,
      rootClassName,
      style,
      alt,
      draggable,
      children,
      crossOrigin,
      gap = 4,
      onError
    } = props,
    others = Avatar_rest(props, ["prefixCls", "shape", "size", "src", "srcSet", "icon", "className", "rootClassName", "style", "alt", "draggable", "children", "crossOrigin", "gap", "onError"]);
  const [scale, setScale] = react.useState(1);
  const [mounted, setMounted] = react.useState(false);
  const [isImgExist, setIsImgExist] = react.useState(true);
  const avatarNodeRef = react.useRef(null);
  const avatarChildrenRef = react.useRef(null);
  const avatarNodeMergedRef = (0,es_ref/* composeRef */.sQ)(ref, avatarNodeRef);
  const {
    getPrefixCls,
    avatar
  } = react.useContext(ConfigContext);
  const avatarCtx = react.useContext(avatar_AvatarContext);
  const setScaleParam = () => {
    if (!avatarChildrenRef.current || !avatarNodeRef.current) {
      return;
    }
    const childrenWidth = avatarChildrenRef.current.offsetWidth; // offsetWidth avoid affecting be transform scale
    const nodeWidth = avatarNodeRef.current.offsetWidth;
    // denominator is 0 is no meaning
    if (childrenWidth !== 0 && nodeWidth !== 0) {
      if (gap * 2 < nodeWidth) {
        setScale(nodeWidth - gap * 2 < childrenWidth ? (nodeWidth - gap * 2) / childrenWidth : 1);
      }
    }
  };
  react.useEffect(() => {
    setMounted(true);
  }, []);
  react.useEffect(() => {
    setIsImgExist(true);
    setScale(1);
  }, [src]);
  react.useEffect(setScaleParam, [gap]);
  const handleImgLoadError = () => {
    const errorFlag = onError === null || onError === void 0 ? void 0 : onError();
    if (errorFlag !== false) {
      setIsImgExist(false);
    }
  };
  const size = hooks_useSize(ctxSize => {
    var _a, _b;
    return (_b = (_a = customSize !== null && customSize !== void 0 ? customSize : avatarCtx === null || avatarCtx === void 0 ? void 0 : avatarCtx.size) !== null && _a !== void 0 ? _a : ctxSize) !== null && _b !== void 0 ? _b : 'default';
  });
  const needResponsive = Object.keys(typeof size === 'object' ? size || {} : {}).some(key => ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].includes(key));
  const screens = hooks_useBreakpoint(needResponsive);
  const responsiveSizeStyle = react.useMemo(() => {
    if (typeof size !== 'object') {
      return {};
    }
    const currentBreakpoint = responsiveArray.find(screen => screens[screen]);
    const currentSize = size[currentBreakpoint];
    return currentSize ? {
      width: currentSize,
      height: currentSize,
      fontSize: currentSize && (icon || children) ? currentSize / 2 : 18
    } : {};
  }, [screens, size]);
  if (false) {}
  const prefixCls = getPrefixCls('avatar', customizePrefixCls);
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = avatar_style(prefixCls, rootCls);
  const sizeCls = classnames_default()({
    [`${prefixCls}-lg`]: size === 'large',
    [`${prefixCls}-sm`]: size === 'small'
  });
  const hasImageElement = /*#__PURE__*/react.isValidElement(src);
  const mergedShape = shape || (avatarCtx === null || avatarCtx === void 0 ? void 0 : avatarCtx.shape) || 'circle';
  const classString = classnames_default()(prefixCls, sizeCls, avatar === null || avatar === void 0 ? void 0 : avatar.className, `${prefixCls}-${mergedShape}`, {
    [`${prefixCls}-image`]: hasImageElement || src && isImgExist,
    [`${prefixCls}-icon`]: !!icon
  }, cssVarCls, rootCls, className, rootClassName, hashId);
  const sizeStyle = typeof size === 'number' ? {
    width: size,
    height: size,
    fontSize: icon ? size / 2 : 18
  } : {};
  let childrenToRender;
  if (typeof src === 'string' && isImgExist) {
    childrenToRender = /*#__PURE__*/react.createElement("img", {
      src: src,
      draggable: draggable,
      srcSet: srcSet,
      onError: handleImgLoadError,
      alt: alt,
      crossOrigin: crossOrigin
    });
  } else if (hasImageElement) {
    childrenToRender = src;
  } else if (icon) {
    childrenToRender = icon;
  } else if (mounted || scale !== 1) {
    const transformString = `scale(${scale})`;
    const childrenStyle = {
      msTransform: transformString,
      WebkitTransform: transformString,
      transform: transformString
    };
    childrenToRender = /*#__PURE__*/react.createElement(es/* default */.Z, {
      onResize: setScaleParam
    }, /*#__PURE__*/react.createElement("span", {
      className: `${prefixCls}-string`,
      ref: avatarChildrenRef,
      style: Object.assign({}, childrenStyle)
    }, children));
  } else {
    childrenToRender = /*#__PURE__*/react.createElement("span", {
      className: `${prefixCls}-string`,
      style: {
        opacity: 0
      },
      ref: avatarChildrenRef
    }, children);
  }
  return wrapCSSVar(/*#__PURE__*/react.createElement("span", Object.assign({}, others, {
    style: Object.assign(Object.assign(Object.assign(Object.assign({}, sizeStyle), responsiveSizeStyle), avatar === null || avatar === void 0 ? void 0 : avatar.style), style),
    className: classString,
    ref: avatarNodeMergedRef
  }), childrenToRender));
});
if (false) {}
/* harmony default export */ var avatar_Avatar = (Avatar_Avatar);
// EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js
var KeyCode = __webpack_require__(88035);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/getRenderPropValue.js
const getRenderPropValue = propValue => {
  if (!propValue) {
    return null;
  }
  return typeof propValue === 'function' ? propValue() : propValue;
};
// EXTERNAL MODULE: ./node_modules/rc-tooltip/es/index.js + 3 modules
var rc_tooltip_es = __webpack_require__(59052);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/style/roundedArrow.js

function getArrowToken(token) {
  const {
    sizePopupArrow,
    borderRadiusXS,
    borderRadiusOuter
  } = token;
  const unitWidth = sizePopupArrow / 2;
  const ax = 0;
  const ay = unitWidth;
  const bx = borderRadiusOuter * 1 / Math.sqrt(2);
  const by = unitWidth - borderRadiusOuter * (1 - 1 / Math.sqrt(2));
  const cx = unitWidth - borderRadiusXS * (1 / Math.sqrt(2));
  const cy = borderRadiusOuter * (Math.sqrt(2) - 1) + borderRadiusXS * (1 / Math.sqrt(2));
  const dx = 2 * unitWidth - cx;
  const dy = cy;
  const ex = 2 * unitWidth - bx;
  const ey = by;
  const fx = 2 * unitWidth - ax;
  const fy = ay;
  const shadowWidth = unitWidth * Math.sqrt(2) + borderRadiusOuter * (Math.sqrt(2) - 2);
  const polygonOffset = borderRadiusOuter * (Math.sqrt(2) - 1);
  const arrowPolygon = `polygon(${polygonOffset}px 100%, 50% ${polygonOffset}px, ${2 * unitWidth - polygonOffset}px 100%, ${polygonOffset}px 100%)`;
  const arrowPath = `path('M ${ax} ${ay} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${bx} ${by} L ${cx} ${cy} A ${borderRadiusXS} ${borderRadiusXS} 0 0 1 ${dx} ${dy} L ${ex} ${ey} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${fx} ${fy} Z')`;
  return {
    arrowShadowWidth: shadowWidth,
    arrowPath,
    arrowPolygon
  };
}
const genRoundedArrow = (token, bgColor, boxShadow) => {
  const {
    sizePopupArrow,
    arrowPolygon,
    arrowPath,
    arrowShadowWidth,
    borderRadiusXS,
    calc
  } = token;
  return {
    pointerEvents: 'none',
    width: sizePopupArrow,
    height: sizePopupArrow,
    overflow: 'hidden',
    '&::before': {
      position: 'absolute',
      bottom: 0,
      insetInlineStart: 0,
      width: sizePopupArrow,
      height: calc(sizePopupArrow).div(2).equal(),
      background: bgColor,
      clipPath: {
        _multi_value_: true,
        value: [arrowPolygon, arrowPath]
      },
      content: '""'
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      width: arrowShadowWidth,
      height: arrowShadowWidth,
      bottom: 0,
      insetInline: 0,
      margin: 'auto',
      borderRadius: {
        _skip_check_: true,
        value: `0 0 ${(0,cssinjs_es/* unit */.bf)(borderRadiusXS)} 0`
      },
      transform: 'translateY(50%) rotate(-135deg)',
      boxShadow,
      zIndex: 0,
      background: 'transparent'
    }
  };
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/style/placementArrow.js


const MAX_VERTICAL_CONTENT_RADIUS = 8;
function getArrowOffsetToken(options) {
  const {
    contentRadius,
    limitVerticalRadius
  } = options;
  const arrowOffset = contentRadius > 12 ? contentRadius + 2 : 12;
  const arrowOffsetVertical = limitVerticalRadius ? MAX_VERTICAL_CONTENT_RADIUS : arrowOffset;
  return {
    arrowOffsetHorizontal: arrowOffset,
    arrowOffsetVertical
  };
}
function isInject(valid, code) {
  if (!valid) {
    return {};
  }
  return code;
}
function getArrowStyle(token, colorBg, options) {
  const {
    componentCls,
    boxShadowPopoverArrow,
    arrowOffsetVertical,
    arrowOffsetHorizontal
  } = token;
  const {
    arrowDistance = 0,
    arrowPlacement = {
      left: true,
      right: true,
      top: true,
      bottom: true
    }
  } = options || {};
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      [`${componentCls}-arrow`]: [Object.assign(Object.assign({
        position: 'absolute',
        zIndex: 1,
        display: 'block'
      }, genRoundedArrow(token, colorBg, boxShadowPopoverArrow)), {
        '&:before': {
          background: colorBg
        }
      })]
    }, isInject(!!arrowPlacement.top, {
      [[`&-placement-top > ${componentCls}-arrow`, `&-placement-topLeft > ${componentCls}-arrow`, `&-placement-topRight > ${componentCls}-arrow`].join(',')]: {
        bottom: arrowDistance,
        transform: 'translateY(100%) rotate(180deg)'
      },
      [`&-placement-top > ${componentCls}-arrow`]: {
        left: {
          _skip_check_: true,
          value: '50%'
        },
        transform: 'translateX(-50%) translateY(100%) rotate(180deg)'
      },
      '&-placement-topLeft': {
        '--arrow-offset-horizontal': arrowOffsetHorizontal,
        [`> ${componentCls}-arrow`]: {
          left: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
          }
        }
      },
      '&-placement-topRight': {
        '--arrow-offset-horizontal': `calc(100% - ${(0,cssinjs_es/* unit */.bf)(arrowOffsetHorizontal)})`,
        [`> ${componentCls}-arrow`]: {
          right: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
          }
        }
      }
    })), isInject(!!arrowPlacement.bottom, {
      [[`&-placement-bottom > ${componentCls}-arrow`, `&-placement-bottomLeft > ${componentCls}-arrow`, `&-placement-bottomRight > ${componentCls}-arrow`].join(',')]: {
        top: arrowDistance,
        transform: `translateY(-100%)`
      },
      [`&-placement-bottom > ${componentCls}-arrow`]: {
        left: {
          _skip_check_: true,
          value: '50%'
        },
        transform: `translateX(-50%) translateY(-100%)`
      },
      '&-placement-bottomLeft': {
        '--arrow-offset-horizontal': arrowOffsetHorizontal,
        [`> ${componentCls}-arrow`]: {
          left: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
          }
        }
      },
      '&-placement-bottomRight': {
        '--arrow-offset-horizontal': `calc(100% - ${(0,cssinjs_es/* unit */.bf)(arrowOffsetHorizontal)})`,
        [`> ${componentCls}-arrow`]: {
          right: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
          }
        }
      }
    })), isInject(!!arrowPlacement.left, {
      [[`&-placement-left > ${componentCls}-arrow`, `&-placement-leftTop > ${componentCls}-arrow`, `&-placement-leftBottom > ${componentCls}-arrow`].join(',')]: {
        right: {
          _skip_check_: true,
          value: arrowDistance
        },
        transform: 'translateX(100%) rotate(90deg)'
      },
      [`&-placement-left > ${componentCls}-arrow`]: {
        top: {
          _skip_check_: true,
          value: '50%'
        },
        transform: 'translateY(-50%) translateX(100%) rotate(90deg)'
      },
      [`&-placement-leftTop > ${componentCls}-arrow`]: {
        top: arrowOffsetVertical
      },
      [`&-placement-leftBottom > ${componentCls}-arrow`]: {
        bottom: arrowOffsetVertical
      }
    })), isInject(!!arrowPlacement.right, {
      [[`&-placement-right > ${componentCls}-arrow`, `&-placement-rightTop > ${componentCls}-arrow`, `&-placement-rightBottom > ${componentCls}-arrow`].join(',')]: {
        left: {
          _skip_check_: true,
          value: arrowDistance
        },
        transform: 'translateX(-100%) rotate(-90deg)'
      },
      [`&-placement-right > ${componentCls}-arrow`]: {
        top: {
          _skip_check_: true,
          value: '50%'
        },
        transform: 'translateY(-50%) translateX(-100%) rotate(-90deg)'
      },
      [`&-placement-rightTop > ${componentCls}-arrow`]: {
        top: arrowOffsetVertical
      },
      [`&-placement-rightBottom > ${componentCls}-arrow`]: {
        bottom: arrowOffsetVertical
      }
    }))
  };
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/placements.js

function getOverflowOptions(placement, arrowOffset, arrowWidth, autoAdjustOverflow) {
  if (autoAdjustOverflow === false) {
    return {
      adjustX: false,
      adjustY: false
    };
  }
  const overflow = autoAdjustOverflow && typeof autoAdjustOverflow === 'object' ? autoAdjustOverflow : {};
  const baseOverflow = {};
  switch (placement) {
    case 'top':
    case 'bottom':
      baseOverflow.shiftX = arrowOffset.arrowOffsetHorizontal * 2 + arrowWidth;
      baseOverflow.shiftY = true;
      baseOverflow.adjustY = true;
      break;
    case 'left':
    case 'right':
      baseOverflow.shiftY = arrowOffset.arrowOffsetVertical * 2 + arrowWidth;
      baseOverflow.shiftX = true;
      baseOverflow.adjustX = true;
      break;
  }
  const mergedOverflow = Object.assign(Object.assign({}, baseOverflow), overflow);
  // Support auto shift
  if (!mergedOverflow.shiftX) {
    mergedOverflow.adjustX = true;
  }
  if (!mergedOverflow.shiftY) {
    mergedOverflow.adjustY = true;
  }
  return mergedOverflow;
}
const PlacementAlignMap = {
  left: {
    points: ['cr', 'cl']
  },
  right: {
    points: ['cl', 'cr']
  },
  top: {
    points: ['bc', 'tc']
  },
  bottom: {
    points: ['tc', 'bc']
  },
  topLeft: {
    points: ['bl', 'tl']
  },
  leftTop: {
    points: ['tr', 'tl']
  },
  topRight: {
    points: ['br', 'tr']
  },
  rightTop: {
    points: ['tl', 'tr']
  },
  bottomRight: {
    points: ['tr', 'br']
  },
  rightBottom: {
    points: ['bl', 'br']
  },
  bottomLeft: {
    points: ['tl', 'bl']
  },
  leftBottom: {
    points: ['br', 'bl']
  }
};
const ArrowCenterPlacementAlignMap = {
  topLeft: {
    points: ['bl', 'tc']
  },
  leftTop: {
    points: ['tr', 'cl']
  },
  topRight: {
    points: ['br', 'tc']
  },
  rightTop: {
    points: ['tl', 'cr']
  },
  bottomRight: {
    points: ['tr', 'bc']
  },
  rightBottom: {
    points: ['bl', 'cr']
  },
  bottomLeft: {
    points: ['tl', 'bc']
  },
  leftBottom: {
    points: ['br', 'cl']
  }
};
const DisableAutoArrowList = new Set(['topLeft', 'topRight', 'bottomLeft', 'bottomRight', 'leftTop', 'leftBottom', 'rightTop', 'rightBottom']);
function getPlacements(config) {
  const {
    arrowWidth,
    autoAdjustOverflow,
    arrowPointAtCenter,
    offset,
    borderRadius,
    visibleFirst
  } = config;
  const halfArrowWidth = arrowWidth / 2;
  const placementMap = {};
  // Dynamic offset
  const arrowOffset = getArrowOffsetToken({
    contentRadius: borderRadius,
    limitVerticalRadius: true
  });
  Object.keys(PlacementAlignMap).forEach(key => {
    const template = arrowPointAtCenter && ArrowCenterPlacementAlignMap[key] || PlacementAlignMap[key];
    const placementInfo = Object.assign(Object.assign({}, template), {
      offset: [0, 0],
      dynamicInset: true
    });
    placementMap[key] = placementInfo;
    // Disable autoArrow since design is fixed position
    if (DisableAutoArrowList.has(key)) {
      placementInfo.autoArrow = false;
    }
    // Static offset
    switch (key) {
      case 'top':
      case 'topLeft':
      case 'topRight':
        placementInfo.offset[1] = -halfArrowWidth - offset;
        break;
      case 'bottom':
      case 'bottomLeft':
      case 'bottomRight':
        placementInfo.offset[1] = halfArrowWidth + offset;
        break;
      case 'left':
      case 'leftTop':
      case 'leftBottom':
        placementInfo.offset[0] = -halfArrowWidth - offset;
        break;
      case 'right':
      case 'rightTop':
      case 'rightBottom':
        placementInfo.offset[0] = halfArrowWidth + offset;
        break;
    }
    if (arrowPointAtCenter) {
      switch (key) {
        case 'topLeft':
        case 'bottomLeft':
          placementInfo.offset[0] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
          break;
        case 'topRight':
        case 'bottomRight':
          placementInfo.offset[0] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
          break;
        case 'leftTop':
        case 'rightTop':
          placementInfo.offset[1] = -arrowOffset.arrowOffsetHorizontal * 2 + halfArrowWidth;
          break;
        case 'leftBottom':
        case 'rightBottom':
          placementInfo.offset[1] = arrowOffset.arrowOffsetHorizontal * 2 - halfArrowWidth;
          break;
      }
    }
    // Overflow
    placementInfo.overflow = getOverflowOptions(key, arrowOffset, arrowWidth, autoAdjustOverflow);
    // VisibleFirst
    if (visibleFirst) {
      placementInfo.htmlRegion = 'visibleFirst';
    }
  });
  return placementMap;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/util/genPresetColor.js

function genPresetColor_genPresetColor(token, genCss) {
  return PresetColors.reduce((prev, colorKey) => {
    const lightColor = token[`${colorKey}1`];
    const lightBorderColor = token[`${colorKey}3`];
    const darkColor = token[`${colorKey}6`];
    const textColor = token[`${colorKey}7`];
    return Object.assign(Object.assign({}, prev), genCss(colorKey, {
      lightColor,
      lightBorderColor,
      darkColor,
      textColor
    }));
  }, {});
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tooltip/style/index.js






const genTooltipStyle = token => {
  const {
    calc,
    componentCls,
    // ant-tooltip
    tooltipMaxWidth,
    tooltipColor,
    tooltipBg,
    tooltipBorderRadius,
    zIndexPopup,
    controlHeight,
    boxShadowSecondary,
    paddingSM,
    paddingXS,
    arrowOffsetHorizontal,
    sizePopupArrow
  } = token;
  // arrowOffsetHorizontal + arrowWidth + borderRadius
  const edgeAlignMinWidth = calc(tooltipBorderRadius).add(sizePopupArrow).add(arrowOffsetHorizontal).equal();
  // borderRadius * 2 + arrowWidth
  const centerAlignMinWidth = calc(tooltipBorderRadius).mul(2).add(sizePopupArrow).equal();
  return [{
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), {
      position: 'absolute',
      zIndex: zIndexPopup,
      display: 'block',
      width: 'max-content',
      maxWidth: tooltipMaxWidth,
      visibility: 'visible',
      // When use `autoArrow`, origin will follow the arrow position
      '--valid-offset-x': 'var(--arrow-offset-horizontal, var(--arrow-x))',
      transformOrigin: [`var(--valid-offset-x, 50%)`, `var(--arrow-y, 50%)`].join(' '),
      '&-hidden': {
        display: 'none'
      },
      '--antd-arrow-background-color': tooltipBg,
      // Wrapper for the tooltip content
      [`${componentCls}-inner`]: {
        minWidth: centerAlignMinWidth,
        minHeight: controlHeight,
        padding: `${(0,cssinjs_es/* unit */.bf)(token.calc(paddingSM).div(2).equal())} ${(0,cssinjs_es/* unit */.bf)(paddingXS)}`,
        color: `var(--ant-tooltip-color, ${tooltipColor})`,
        textAlign: 'start',
        textDecoration: 'none',
        wordWrap: 'break-word',
        backgroundColor: tooltipBg,
        borderRadius: tooltipBorderRadius,
        boxShadow: boxShadowSecondary,
        boxSizing: 'border-box'
      },
      // Align placement should have another min width
      [[`&-placement-topLeft`, `&-placement-topRight`, `&-placement-bottomLeft`, `&-placement-bottomRight`].join(',')]: {
        minWidth: edgeAlignMinWidth
      },
      // Limit left and right placement radius
      [[`&-placement-left`, `&-placement-leftTop`, `&-placement-leftBottom`, `&-placement-right`, `&-placement-rightTop`, `&-placement-rightBottom`].join(',')]: {
        [`${componentCls}-inner`]: {
          borderRadius: token.min(tooltipBorderRadius, MAX_VERTICAL_CONTENT_RADIUS)
        }
      },
      [`${componentCls}-content`]: {
        position: 'relative'
      }
    }), genPresetColor_genPresetColor(token, (colorKey, {
      darkColor
    }) => ({
      [`&${componentCls}-${colorKey}`]: {
        [`${componentCls}-inner`]: {
          backgroundColor: darkColor
        },
        [`${componentCls}-arrow`]: {
          '--antd-arrow-background-color': darkColor
        }
      }
    }))), {
      // RTL
      '&-rtl': {
        direction: 'rtl'
      }
    })
  },
  // Arrow Style
  getArrowStyle(token, 'var(--antd-arrow-background-color)'),
  // Pure Render
  {
    [`${componentCls}-pure`]: {
      position: 'relative',
      maxWidth: 'none',
      margin: token.sizePopupArrow
    }
  }];
};
// ============================== Export ==============================
const tooltip_style_prepareComponentToken = token => Object.assign(Object.assign({
  zIndexPopup: token.zIndexPopupBase + 70
}, getArrowOffsetToken({
  contentRadius: token.borderRadius,
  limitVerticalRadius: true
})), getArrowToken((0,cssinjs_utils_es/* mergeToken */.IX)(token, {
  borderRadiusOuter: Math.min(token.borderRadiusOuter, 4)
})));
/* harmony default export */ var tooltip_style = ((prefixCls, injectStyle = true) => {
  const useStyle = genStyleHooks('Tooltip', token => {
    const {
      borderRadius,
      colorTextLightSolid,
      colorBgSpotlight
    } = token;
    const TooltipToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
      // default variables
      tooltipMaxWidth: 250,
      tooltipColor: colorTextLightSolid,
      tooltipBorderRadius: borderRadius,
      tooltipBg: colorBgSpotlight
    });
    return [genTooltipStyle(TooltipToken), initZoomMotion(token, 'zoom-big-fast')];
  }, tooltip_style_prepareComponentToken, {
    resetStyle: false,
    // Popover use Tooltip as internal component. We do not need to handle this.
    injectStyle
  });
  return useStyle(prefixCls);
});
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/colors.js


const inverseColors = PresetColors.map(color => `${color}-inverse`);
const PresetStatusColorTypes = ['success', 'processing', 'error', 'default', 'warning'];
/**
 * determine if the color keyword belongs to the `Ant Design` {@link PresetColors}.
 * @param color color to be judged
 * @param includeInverse whether to include reversed colors
 */
function isPresetColor(color, includeInverse = true) {
  if (includeInverse) {
    return [].concat((0,toConsumableArray/* default */.Z)(inverseColors), (0,toConsumableArray/* default */.Z)(PresetColors)).includes(color);
  }
  return PresetColors.includes(color);
}
function isPresetStatusColor(color) {
  return PresetStatusColorTypes.includes(color);
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tooltip/util.js



function parseColor(prefixCls, color) {
  const isInternalColor = isPresetColor(color);
  const className = classnames_default()({
    [`${prefixCls}-${color}`]: color && isInternalColor
  });
  const overlayStyle = {};
  const arrowStyle = {};
  const rgb = generateColor(color).toRgb();
  const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
  const textColor = luminance < 0.5 ? '#FFF' : '#000';
  if (color && !isInternalColor) {
    overlayStyle.background = color;
    overlayStyle['--ant-tooltip-color'] = textColor;
    // @ts-ignore
    arrowStyle['--antd-arrow-background-color'] = color;
  }
  return {
    className,
    overlayStyle,
    arrowStyle
  };
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tooltip/PurePanel.js
"use client";







/** @private Internal Component. Do not use in your production. */
const tooltip_PurePanel_PurePanel = props => {
  const {
    prefixCls: customizePrefixCls,
    className,
    placement = 'top',
    title,
    color,
    overlayInnerStyle
  } = props;
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = tooltip_style(prefixCls);
  // Color
  const colorInfo = parseColor(prefixCls, color);
  const arrowContentStyle = colorInfo.arrowStyle;
  const formattedOverlayInnerStyle = Object.assign(Object.assign({}, overlayInnerStyle), colorInfo.overlayStyle);
  const cls = classnames_default()(hashId, cssVarCls, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className, colorInfo.className);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    className: cls,
    style: arrowContentStyle
  }, /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-arrow`
  }), /*#__PURE__*/react.createElement(rc_tooltip_es/* Popup */.G, Object.assign({}, props, {
    className: hashId,
    prefixCls: prefixCls,
    overlayInnerStyle: formattedOverlayInnerStyle
  }), title)));
};
/* harmony default export */ var tooltip_PurePanel = (tooltip_PurePanel_PurePanel);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tooltip/index.js
"use client";

var tooltip_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
















const InternalTooltip = /*#__PURE__*/react.forwardRef((props, ref) => {
  var _a, _b;
  const {
      prefixCls: customizePrefixCls,
      openClassName,
      getTooltipContainer,
      color,
      overlayInnerStyle,
      children,
      afterOpenChange,
      afterVisibleChange,
      destroyTooltipOnHide,
      destroyOnHidden,
      arrow = true,
      title,
      overlay,
      builtinPlacements,
      arrowPointAtCenter = false,
      autoAdjustOverflow = true,
      motion,
      getPopupContainer,
      placement = 'top',
      mouseEnterDelay = 0.1,
      mouseLeaveDelay = 0.1,
      overlayStyle,
      rootClassName,
      overlayClassName,
      styles,
      classNames: tooltipClassNames
    } = props,
    restProps = tooltip_rest(props, ["prefixCls", "openClassName", "getTooltipContainer", "color", "overlayInnerStyle", "children", "afterOpenChange", "afterVisibleChange", "destroyTooltipOnHide", "destroyOnHidden", "arrow", "title", "overlay", "builtinPlacements", "arrowPointAtCenter", "autoAdjustOverflow", "motion", "getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "rootClassName", "overlayClassName", "styles", "classNames"]);
  const mergedShowArrow = !!arrow;
  const [, token] = useToken();
  const {
    getPopupContainer: getContextPopupContainer,
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig('tooltip');
  // ============================== Ref ===============================
  const warning = warning_devUseWarning('Tooltip');
  const tooltipRef = react.useRef(null);
  const forceAlign = () => {
    var _a;
    (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.forceAlign();
  };
  react.useImperativeHandle(ref, () => {
    var _a, _b;
    return {
      forceAlign,
      forcePopupAlign: () => {
        warning.deprecated(false, 'forcePopupAlign', 'forceAlign');
        forceAlign();
      },
      nativeElement: (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.nativeElement,
      popupElement: (_b = tooltipRef.current) === null || _b === void 0 ? void 0 : _b.popupElement
    };
  });
  // ============================== Warn ==============================
  if (false) {}
  // ============================== Open ==============================
  const [open, setOpen] = (0,useMergedState/* default */.Z)(false, {
    value: (_a = props.open) !== null && _a !== void 0 ? _a : props.visible,
    defaultValue: (_b = props.defaultOpen) !== null && _b !== void 0 ? _b : props.defaultVisible
  });
  const noTitle = !title && !overlay && title !== 0; // overlay for old version compatibility
  const onOpenChange = vis => {
    var _a, _b;
    setOpen(noTitle ? false : vis);
    if (!noTitle) {
      (_a = props.onOpenChange) === null || _a === void 0 ? void 0 : _a.call(props, vis);
      (_b = props.onVisibleChange) === null || _b === void 0 ? void 0 : _b.call(props, vis);
    }
  };
  const tooltipPlacements = react.useMemo(() => {
    var _a, _b;
    let mergedArrowPointAtCenter = arrowPointAtCenter;
    if (typeof arrow === 'object') {
      mergedArrowPointAtCenter = (_b = (_a = arrow.pointAtCenter) !== null && _a !== void 0 ? _a : arrow.arrowPointAtCenter) !== null && _b !== void 0 ? _b : arrowPointAtCenter;
    }
    return builtinPlacements || getPlacements({
      arrowPointAtCenter: mergedArrowPointAtCenter,
      autoAdjustOverflow,
      arrowWidth: mergedShowArrow ? token.sizePopupArrow : 0,
      borderRadius: token.borderRadius,
      offset: token.marginXXS,
      visibleFirst: true
    });
  }, [arrowPointAtCenter, arrow, builtinPlacements, token]);
  const memoOverlay = react.useMemo(() => {
    if (title === 0) {
      return title;
    }
    return overlay || title || '';
  }, [overlay, title]);
  const memoOverlayWrapper = /*#__PURE__*/react.createElement(_util_ContextIsolator, {
    space: true
  }, typeof memoOverlay === 'function' ? memoOverlay() : memoOverlay);
  const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  const injectFromPopover = props['data-popover-inject'];
  let tempOpen = open;
  // Hide tooltip when there is no title
  if (!('open' in props) && !('visible' in props) && noTitle) {
    tempOpen = false;
  }
  // ============================= Render =============================
  const child = /*#__PURE__*/react.isValidElement(children) && !isFragment(children) ? children : /*#__PURE__*/react.createElement("span", null, children);
  const childProps = child.props;
  const childCls = !childProps.className || typeof childProps.className === 'string' ? classnames_default()(childProps.className, openClassName || `${prefixCls}-open`) : childProps.className;
  // Style
  const [wrapCSSVar, hashId, cssVarCls] = tooltip_style(prefixCls, !injectFromPopover);
  // Color
  const colorInfo = parseColor(prefixCls, color);
  const arrowContentStyle = colorInfo.arrowStyle;
  const rootClassNames = classnames_default()(overlayClassName, {
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, colorInfo.className, rootClassName, hashId, cssVarCls, contextClassName, contextClassNames.root, tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.root);
  const bodyClassNames = classnames_default()(contextClassNames.body, tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.body);
  // ============================ zIndex ============================
  const [zIndex, contextZIndex] = useZIndex('Tooltip', restProps.zIndex);
  const content = /*#__PURE__*/react.createElement(rc_tooltip_es/* default */.Z, Object.assign({}, restProps, {
    zIndex: zIndex,
    showArrow: mergedShowArrow,
    placement: placement,
    mouseEnterDelay: mouseEnterDelay,
    mouseLeaveDelay: mouseLeaveDelay,
    prefixCls: prefixCls,
    classNames: {
      root: rootClassNames,
      body: bodyClassNames
    },
    styles: {
      root: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, arrowContentStyle), contextStyles.root), contextStyle), overlayStyle), styles === null || styles === void 0 ? void 0 : styles.root),
      body: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.body), overlayInnerStyle), styles === null || styles === void 0 ? void 0 : styles.body), colorInfo.overlayStyle)
    },
    getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
    ref: tooltipRef,
    builtinPlacements: tooltipPlacements,
    overlay: memoOverlayWrapper,
    visible: tempOpen,
    onVisibleChange: onOpenChange,
    afterVisibleChange: afterOpenChange !== null && afterOpenChange !== void 0 ? afterOpenChange : afterVisibleChange,
    arrowContent: /*#__PURE__*/react.createElement("span", {
      className: `${prefixCls}-arrow-content`
    }),
    motion: {
      motionName: getTransitionName(rootPrefixCls, 'zoom-big-fast', props.transitionName),
      motionDeadline: 1000
    },
    // TODO: In the future, destroyTooltipOnHide in rc-tooltip needs to be upgrade to destroyOnHidden
    destroyTooltipOnHide: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : !!destroyTooltipOnHide
  }), tempOpen ? cloneElement(child, {
    className: childCls
  }) : child);
  return wrapCSSVar(/*#__PURE__*/react.createElement(zindexContext.Provider, {
    value: contextZIndex
  }, content));
});
const Tooltip = InternalTooltip;
if (false) {}
Tooltip._InternalPanelDoNotUseOrYouWillBeFired = tooltip_PurePanel;
/* harmony default export */ var es_tooltip = (Tooltip);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/popover/style/index.js





const popover_style_genBaseStyle = token => {
  const {
    componentCls,
    popoverColor,
    titleMinWidth,
    fontWeightStrong,
    innerPadding,
    boxShadowSecondary,
    colorTextHeading,
    borderRadiusLG,
    zIndexPopup,
    titleMarginBottom,
    colorBgElevated,
    popoverBg,
    titleBorderBottom,
    innerContentPadding,
    titlePadding
  } = token;
  return [{
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      position: 'absolute',
      top: 0,
      // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
      left: {
        _skip_check_: true,
        value: 0
      },
      zIndex: zIndexPopup,
      fontWeight: 'normal',
      whiteSpace: 'normal',
      textAlign: 'start',
      cursor: 'auto',
      userSelect: 'text',
      // When use `autoArrow`, origin will follow the arrow position
      '--valid-offset-x': 'var(--arrow-offset-horizontal, var(--arrow-x))',
      transformOrigin: [`var(--valid-offset-x, 50%)`, `var(--arrow-y, 50%)`].join(' '),
      '--antd-arrow-background-color': colorBgElevated,
      width: 'max-content',
      maxWidth: '100vw',
      '&-rtl': {
        direction: 'rtl'
      },
      '&-hidden': {
        display: 'none'
      },
      [`${componentCls}-content`]: {
        position: 'relative'
      },
      [`${componentCls}-inner`]: {
        backgroundColor: popoverBg,
        backgroundClip: 'padding-box',
        borderRadius: borderRadiusLG,
        boxShadow: boxShadowSecondary,
        padding: innerPadding
      },
      [`${componentCls}-title`]: {
        minWidth: titleMinWidth,
        marginBottom: titleMarginBottom,
        color: colorTextHeading,
        fontWeight: fontWeightStrong,
        borderBottom: titleBorderBottom,
        padding: titlePadding
      },
      [`${componentCls}-inner-content`]: {
        color: popoverColor,
        padding: innerContentPadding
      }
    })
  },
  // Arrow Style
  getArrowStyle(token, 'var(--antd-arrow-background-color)'),
  // Pure Render
  {
    [`${componentCls}-pure`]: {
      position: 'relative',
      maxWidth: 'none',
      margin: token.sizePopupArrow,
      display: 'inline-block',
      [`${componentCls}-content`]: {
        display: 'inline-block'
      }
    }
  }];
};
const genColorStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [componentCls]: PresetColors.map(colorKey => {
      const lightColor = token[`${colorKey}6`];
      return {
        [`&${componentCls}-${colorKey}`]: {
          '--antd-arrow-background-color': lightColor,
          [`${componentCls}-inner`]: {
            backgroundColor: lightColor
          },
          [`${componentCls}-arrow`]: {
            background: 'transparent'
          }
        }
      };
    })
  };
};
const popover_style_prepareComponentToken = token => {
  const {
    lineWidth,
    controlHeight,
    fontHeight,
    padding,
    wireframe,
    zIndexPopupBase,
    borderRadiusLG,
    marginXS,
    lineType,
    colorSplit,
    paddingSM
  } = token;
  const titlePaddingBlockDist = controlHeight - fontHeight;
  const popoverTitlePaddingBlockTop = titlePaddingBlockDist / 2;
  const popoverTitlePaddingBlockBottom = titlePaddingBlockDist / 2 - lineWidth;
  const popoverPaddingHorizontal = padding;
  return Object.assign(Object.assign(Object.assign({
    titleMinWidth: 177,
    zIndexPopup: zIndexPopupBase + 30
  }, getArrowToken(token)), getArrowOffsetToken({
    contentRadius: borderRadiusLG,
    limitVerticalRadius: true
  })), {
    // internal
    innerPadding: wireframe ? 0 : 12,
    titleMarginBottom: wireframe ? 0 : marginXS,
    titlePadding: wireframe ? `${popoverTitlePaddingBlockTop}px ${popoverPaddingHorizontal}px ${popoverTitlePaddingBlockBottom}px` : 0,
    titleBorderBottom: wireframe ? `${lineWidth}px ${lineType} ${colorSplit}` : 'none',
    innerContentPadding: wireframe ? `${paddingSM}px ${popoverPaddingHorizontal}px` : 0
  });
};
/* harmony default export */ var popover_style = (genStyleHooks('Popover', token => {
  const {
    colorBgElevated,
    colorText
  } = token;
  const popoverToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    popoverBg: colorBgElevated,
    popoverColor: colorText
  });
  return [popover_style_genBaseStyle(popoverToken), genColorStyle(popoverToken), initZoomMotion(popoverToken, 'zoom-big')];
}, popover_style_prepareComponentToken, {
  resetStyle: false,
  deprecatedTokens: [['width', 'titleMinWidth'], ['minWidth', 'titleMinWidth']]
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/popover/PurePanel.js
"use client";

var popover_PurePanel_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






const Overlay = ({
  title,
  content,
  prefixCls
}) => {
  if (!title && !content) {
    return null;
  }
  return /*#__PURE__*/react.createElement(react.Fragment, null, title && /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-title`
  }, title), content && /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-inner-content`
  }, content));
};
const RawPurePanel = props => {
  const {
    hashId,
    prefixCls,
    className,
    style,
    placement = 'top',
    title,
    content,
    children
  } = props;
  const titleNode = getRenderPropValue(title);
  const contentNode = getRenderPropValue(content);
  const cls = classnames_default()(hashId, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className);
  return /*#__PURE__*/react.createElement("div", {
    className: cls,
    style: style
  }, /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-arrow`
  }), /*#__PURE__*/react.createElement(rc_tooltip_es/* Popup */.G, Object.assign({}, props, {
    className: hashId,
    prefixCls: prefixCls
  }), children || /*#__PURE__*/react.createElement(Overlay, {
    prefixCls: prefixCls,
    title: titleNode,
    content: contentNode
  })));
};
const popover_PurePanel_PurePanel = props => {
  const {
      prefixCls: customizePrefixCls,
      className
    } = props,
    restProps = popover_PurePanel_rest(props, ["prefixCls", "className"]);
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('popover', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = popover_style(prefixCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement(RawPurePanel, Object.assign({}, restProps, {
    prefixCls: prefixCls,
    hashId: hashId,
    className: classnames_default()(className, cssVarCls)
  })));
};
/* harmony default export */ var popover_PurePanel = (popover_PurePanel_PurePanel);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/popover/index.js
"use client";

var popover_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};











// CSSINJS

const InternalPopover = /*#__PURE__*/react.forwardRef((props, ref) => {
  var _a, _b;
  const {
      prefixCls: customizePrefixCls,
      title,
      content,
      overlayClassName,
      placement = 'top',
      trigger = 'hover',
      children,
      mouseEnterDelay = 0.1,
      mouseLeaveDelay = 0.1,
      onOpenChange,
      overlayStyle = {},
      styles,
      classNames: popoverClassNames
    } = props,
    otherProps = popover_rest(props, ["prefixCls", "title", "content", "overlayClassName", "placement", "trigger", "children", "mouseEnterDelay", "mouseLeaveDelay", "onOpenChange", "overlayStyle", "styles", "classNames"]);
  const {
    getPrefixCls,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig('popover');
  const prefixCls = getPrefixCls('popover', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = popover_style(prefixCls);
  const rootPrefixCls = getPrefixCls();
  const rootClassNames = classnames_default()(overlayClassName, hashId, cssVarCls, contextClassName, contextClassNames.root, popoverClassNames === null || popoverClassNames === void 0 ? void 0 : popoverClassNames.root);
  const bodyClassNames = classnames_default()(contextClassNames.body, popoverClassNames === null || popoverClassNames === void 0 ? void 0 : popoverClassNames.body);
  const [open, setOpen] = (0,useMergedState/* default */.Z)(false, {
    value: (_a = props.open) !== null && _a !== void 0 ? _a : props.visible,
    defaultValue: (_b = props.defaultOpen) !== null && _b !== void 0 ? _b : props.defaultVisible
  });
  const settingOpen = (value, e) => {
    setOpen(value, true);
    onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(value, e);
  };
  const onKeyDown = e => {
    if (e.keyCode === KeyCode/* default.ESC */.Z.ESC) {
      settingOpen(false, e);
    }
  };
  const onInternalOpenChange = value => {
    settingOpen(value);
  };
  const titleNode = getRenderPropValue(title);
  const contentNode = getRenderPropValue(content);
  return wrapCSSVar(/*#__PURE__*/react.createElement(es_tooltip, Object.assign({
    placement: placement,
    trigger: trigger,
    mouseEnterDelay: mouseEnterDelay,
    mouseLeaveDelay: mouseLeaveDelay
  }, otherProps, {
    prefixCls: prefixCls,
    classNames: {
      root: rootClassNames,
      body: bodyClassNames
    },
    styles: {
      root: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.root), contextStyle), overlayStyle), styles === null || styles === void 0 ? void 0 : styles.root),
      body: Object.assign(Object.assign({}, contextStyles.body), styles === null || styles === void 0 ? void 0 : styles.body)
    },
    ref: ref,
    open: open,
    onOpenChange: onInternalOpenChange,
    overlay: titleNode || contentNode ? (/*#__PURE__*/react.createElement(Overlay, {
      prefixCls: prefixCls,
      title: titleNode,
      content: contentNode
    })) : null,
    transitionName: getTransitionName(rootPrefixCls, 'zoom-big', otherProps.transitionName),
    "data-popover-inject": true
  }), cloneElement(children, {
    onKeyDown: e => {
      var _a, _b;
      if (/*#__PURE__*/(0,react.isValidElement)(children)) {
        (_b = children === null || children === void 0 ? void 0 : (_a = children.props).onKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a, e);
      }
      onKeyDown(e);
    }
  })));
});
const Popover = InternalPopover;
Popover._InternalPanelDoNotUseOrYouWillBeFired = popover_PurePanel;
if (false) {}
/* harmony default export */ var popover = (Popover);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/avatar/AvatarGroup.js
"use client";












const AvatarContextProvider = props => {
  const {
    size,
    shape
  } = react.useContext(avatar_AvatarContext);
  const avatarContextValue = react.useMemo(() => ({
    size: props.size || size,
    shape: props.shape || shape
  }), [props.size, props.shape, size, shape]);
  return /*#__PURE__*/react.createElement(avatar_AvatarContext.Provider, {
    value: avatarContextValue
  }, props.children);
};
const AvatarGroup = props => {
  var _a, _b, _c, _d;
  const {
    getPrefixCls,
    direction
  } = react.useContext(ConfigContext);
  const {
    prefixCls: customizePrefixCls,
    className,
    rootClassName,
    style,
    maxCount,
    maxStyle,
    size,
    shape,
    maxPopoverPlacement,
    maxPopoverTrigger,
    children,
    max
  } = props;
  if (false) {}
  const prefixCls = getPrefixCls('avatar', customizePrefixCls);
  const groupPrefixCls = `${prefixCls}-group`;
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = avatar_style(prefixCls, rootCls);
  const cls = classnames_default()(groupPrefixCls, {
    [`${groupPrefixCls}-rtl`]: direction === 'rtl'
  }, cssVarCls, rootCls, className, rootClassName, hashId);
  const childrenWithProps = (0,Children_toArray/* default */.Z)(children).map((child, index) => cloneElement(child, {
    // eslint-disable-next-line react/no-array-index-key
    key: `avatar-key-${index}`
  }));
  const mergeCount = (max === null || max === void 0 ? void 0 : max.count) || maxCount;
  const numOfChildren = childrenWithProps.length;
  if (mergeCount && mergeCount < numOfChildren) {
    const childrenShow = childrenWithProps.slice(0, mergeCount);
    const childrenHidden = childrenWithProps.slice(mergeCount, numOfChildren);
    const mergeStyle = (max === null || max === void 0 ? void 0 : max.style) || maxStyle;
    const mergePopoverTrigger = ((_a = max === null || max === void 0 ? void 0 : max.popover) === null || _a === void 0 ? void 0 : _a.trigger) || maxPopoverTrigger || 'hover';
    const mergePopoverPlacement = ((_b = max === null || max === void 0 ? void 0 : max.popover) === null || _b === void 0 ? void 0 : _b.placement) || maxPopoverPlacement || 'top';
    const mergeProps = Object.assign(Object.assign({
      content: childrenHidden
    }, max === null || max === void 0 ? void 0 : max.popover), {
      classNames: {
        root: classnames_default()(`${groupPrefixCls}-popover`, (_d = (_c = max === null || max === void 0 ? void 0 : max.popover) === null || _c === void 0 ? void 0 : _c.classNames) === null || _d === void 0 ? void 0 : _d.root)
      },
      placement: mergePopoverPlacement,
      trigger: mergePopoverTrigger
    });
    childrenShow.push(/*#__PURE__*/react.createElement(popover, Object.assign({
      key: "avatar-popover-key",
      destroyOnHidden: true
    }, mergeProps), /*#__PURE__*/react.createElement(avatar_Avatar, {
      style: mergeStyle
    }, `+${numOfChildren - mergeCount}`)));
    return wrapCSSVar(/*#__PURE__*/react.createElement(AvatarContextProvider, {
      shape: shape,
      size: size
    }, /*#__PURE__*/react.createElement("div", {
      className: cls,
      style: style
    }, childrenShow)));
  }
  return wrapCSSVar(/*#__PURE__*/react.createElement(AvatarContextProvider, {
    shape: shape,
    size: size
  }, /*#__PURE__*/react.createElement("div", {
    className: cls,
    style: style
  }, childrenWithProps)));
};
/* harmony default export */ var avatar_AvatarGroup = (AvatarGroup);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/avatar/index.js
"use client";



const es_avatar_Avatar = avatar_Avatar;
es_avatar_Avatar.Group = avatar_AvatarGroup;
/* harmony default export */ var avatar = (es_avatar_Avatar);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/VerticalAlignTopOutlined.js
// This icon file is generated automatically.
var VerticalAlignTopOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M859.9 168H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM518.3 355a8 8 0 00-12.6 0l-112 141.7a7.98 7.98 0 006.3 12.9h73.9V848c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V509.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 355z"
      }
    }]
  },
  "name": "vertical-align-top",
  "theme": "outlined"
};
/* harmony default export */ var asn_VerticalAlignTopOutlined = (VerticalAlignTopOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/VerticalAlignTopOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var VerticalAlignTopOutlined_VerticalAlignTopOutlined = function VerticalAlignTopOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_VerticalAlignTopOutlined
  }));
};

/**![vertical-align-top](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1OS45IDE2OEgxNjQuMWMtNC41IDAtOC4xIDMuNi04LjEgOHY2MGMwIDQuNCAzLjYgOCA4LjEgOGg2OTUuOGM0LjUgMCA4LjEtMy42IDguMS04di02MGMwLTQuNC0zLjYtOC04LjEtOHpNNTE4LjMgMzU1YTggOCAwIDAwLTEyLjYgMGwtMTEyIDE0MS43YTcuOTggNy45OCAwIDAwNi4zIDEyLjloNzMuOVY4NDhjMCA0LjQgMy42IDggOCA4aDYwYzQuNCAwIDgtMy42IDgtOFY1MDkuN0g2MjRjNi43IDAgMTAuNC03LjcgNi4zLTEyLjlMNTE4LjMgMzU1eiIgLz48L3N2Zz4=) */
var RefIcon = /*#__PURE__*/react.forwardRef(VerticalAlignTopOutlined_VerticalAlignTopOutlined);
if (false) {}
/* harmony default export */ var icons_VerticalAlignTopOutlined = (RefIcon);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/back-top/style/index.js



// ============================== Shared ==============================
const genSharedBackTopStyle = token => {
  const {
    componentCls,
    backTopFontSize,
    backTopSize,
    zIndexPopup
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      position: 'fixed',
      insetInlineEnd: token.backTopInlineEnd,
      insetBlockEnd: token.backTopBlockEnd,
      zIndex: zIndexPopup,
      width: 40,
      height: 40,
      cursor: 'pointer',
      '&:empty': {
        display: 'none'
      },
      [`${componentCls}-content`]: {
        width: backTopSize,
        height: backTopSize,
        overflow: 'hidden',
        color: token.backTopColor,
        textAlign: 'center',
        backgroundColor: token.backTopBackground,
        borderRadius: backTopSize,
        transition: `all ${token.motionDurationMid}`,
        '&:hover': {
          backgroundColor: token.backTopHoverBackground,
          transition: `all ${token.motionDurationMid}`
        }
      },
      // change to .backtop .backtop-icon
      [`${componentCls}-icon`]: {
        fontSize: backTopFontSize,
        lineHeight: (0,cssinjs_es/* unit */.bf)(backTopSize)
      }
    })
  };
};
const genMediaBackTopStyle = token => {
  const {
    componentCls,
    screenMD,
    screenXS,
    backTopInlineEndMD,
    backTopInlineEndXS
  } = token;
  return {
    [`@media (max-width: ${(0,cssinjs_es/* unit */.bf)(screenMD)})`]: {
      [componentCls]: {
        insetInlineEnd: backTopInlineEndMD
      }
    },
    [`@media (max-width: ${(0,cssinjs_es/* unit */.bf)(screenXS)})`]: {
      [componentCls]: {
        insetInlineEnd: backTopInlineEndXS
      }
    }
  };
};
const back_top_style_prepareComponentToken = token => ({
  zIndexPopup: token.zIndexBase + 10
});
// ============================== Export ==============================
/* harmony default export */ var back_top_style = (genStyleHooks('BackTop', token => {
  const {
    fontSizeHeading3,
    colorTextDescription,
    colorTextLightSolid,
    colorText,
    controlHeightLG,
    calc
  } = token;
  const backTopToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    backTopBackground: colorTextDescription,
    backTopColor: colorTextLightSolid,
    backTopHoverBackground: colorText,
    backTopFontSize: fontSizeHeading3,
    backTopSize: controlHeightLG,
    backTopBlockEnd: calc(controlHeightLG).mul(1.25).equal(),
    backTopInlineEnd: calc(controlHeightLG).mul(2.5).equal(),
    backTopInlineEndMD: calc(controlHeightLG).mul(1.5).equal(),
    backTopInlineEndXS: calc(controlHeightLG).mul(0.5).equal()
  });
  return [genSharedBackTopStyle(backTopToken), genMediaBackTopStyle(backTopToken)];
}, back_top_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/back-top/index.js
"use client";













const BackTop = props => {
  const {
    prefixCls: customizePrefixCls,
    className,
    rootClassName,
    visibilityHeight = 400,
    target,
    onClick,
    duration = 450
  } = props;
  const [visible, setVisible] = react.useState(visibilityHeight === 0);
  const ref = react.useRef(null);
  const getDefaultTarget = () => {
    var _a;
    return ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) || window;
  };
  const handleScroll = _util_throttleByAnimationFrame(e => {
    const scrollTop = _util_getScroll(e.target);
    setVisible(scrollTop >= visibilityHeight);
  });
  if (false) {}
  react.useEffect(() => {
    const getTarget = target || getDefaultTarget;
    const container = getTarget();
    handleScroll({
      target: container
    });
    container === null || container === void 0 ? void 0 : container.addEventListener('scroll', handleScroll);
    return () => {
      handleScroll.cancel();
      container === null || container === void 0 ? void 0 : container.removeEventListener('scroll', handleScroll);
    };
  }, [target]);
  const scrollToTop = e => {
    scrollTo(0, {
      getContainer: target || getDefaultTarget,
      duration
    });
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  const {
    getPrefixCls,
    direction
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('back-top', customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  const [wrapCSSVar, hashId, cssVarCls] = back_top_style(prefixCls);
  const classString = classnames_default()(hashId, cssVarCls, prefixCls, {
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, className, rootClassName);
  // fix https://fb.me/react-unknown-prop
  const divProps = (0,omit/* default */.Z)(props, ['prefixCls', 'className', 'rootClassName', 'children', 'visibilityHeight', 'target']);
  const defaultElement = /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-content`
  }, /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-icon`
  }, /*#__PURE__*/react.createElement(icons_VerticalAlignTopOutlined, null)));
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", Object.assign({}, divProps, {
    className: classString,
    onClick: scrollToTop,
    ref: ref
  }), /*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, {
    visible: visible,
    motionName: `${rootPrefixCls}-fade`
  }, ({
    className: motionClassName
  }) => cloneElement(props.children || defaultElement, ({
    className: cloneCls
  }) => ({
    className: classnames_default()(motionClassName, cloneCls)
  })))));
};
if (false) {}
/* harmony default export */ var back_top = (BackTop);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/badge/style/index.js



const antStatusProcessing = new cssinjs_es/* Keyframes */.E4('antStatusProcessing', {
  '0%': {
    transform: 'scale(0.8)',
    opacity: 0.5
  },
  '100%': {
    transform: 'scale(2.4)',
    opacity: 0
  }
});
const antZoomBadgeIn = new cssinjs_es/* Keyframes */.E4('antZoomBadgeIn', {
  '0%': {
    transform: 'scale(0) translate(50%, -50%)',
    opacity: 0
  },
  '100%': {
    transform: 'scale(1) translate(50%, -50%)'
  }
});
const antZoomBadgeOut = new cssinjs_es/* Keyframes */.E4('antZoomBadgeOut', {
  '0%': {
    transform: 'scale(1) translate(50%, -50%)'
  },
  '100%': {
    transform: 'scale(0) translate(50%, -50%)',
    opacity: 0
  }
});
const antNoWrapperZoomBadgeIn = new cssinjs_es/* Keyframes */.E4('antNoWrapperZoomBadgeIn', {
  '0%': {
    transform: 'scale(0)',
    opacity: 0
  },
  '100%': {
    transform: 'scale(1)'
  }
});
const antNoWrapperZoomBadgeOut = new cssinjs_es/* Keyframes */.E4('antNoWrapperZoomBadgeOut', {
  '0%': {
    transform: 'scale(1)'
  },
  '100%': {
    transform: 'scale(0)',
    opacity: 0
  }
});
const antBadgeLoadingCircle = new cssinjs_es/* Keyframes */.E4('antBadgeLoadingCircle', {
  '0%': {
    transformOrigin: '50%'
  },
  '100%': {
    transform: 'translate(50%, -50%) rotate(360deg)',
    transformOrigin: '50%'
  }
});
const genSharedBadgeStyle = token => {
  const {
    componentCls,
    iconCls,
    antCls,
    badgeShadowSize,
    textFontSize,
    textFontSizeSM,
    statusSize,
    dotSize,
    textFontWeight,
    indicatorHeight,
    indicatorHeightSM,
    marginXS,
    calc
  } = token;
  const numberPrefixCls = `${antCls}-scroll-number`;
  const colorPreset = genPresetColor_genPresetColor(token, (colorKey, {
    darkColor
  }) => ({
    [`&${componentCls} ${componentCls}-color-${colorKey}`]: {
      background: darkColor,
      [`&:not(${componentCls}-count)`]: {
        color: darkColor
      },
      'a:hover &': {
        background: darkColor
      }
    }
  }));
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), {
      position: 'relative',
      display: 'inline-block',
      width: 'fit-content',
      lineHeight: 1,
      [`${componentCls}-count`]: {
        display: 'inline-flex',
        justifyContent: 'center',
        zIndex: token.indicatorZIndex,
        minWidth: indicatorHeight,
        height: indicatorHeight,
        color: token.badgeTextColor,
        fontWeight: textFontWeight,
        fontSize: textFontSize,
        lineHeight: (0,cssinjs_es/* unit */.bf)(indicatorHeight),
        whiteSpace: 'nowrap',
        textAlign: 'center',
        background: token.badgeColor,
        borderRadius: calc(indicatorHeight).div(2).equal(),
        boxShadow: `0 0 0 ${(0,cssinjs_es/* unit */.bf)(badgeShadowSize)} ${token.badgeShadowColor}`,
        transition: `background ${token.motionDurationMid}`,
        a: {
          color: token.badgeTextColor
        },
        'a:hover': {
          color: token.badgeTextColor
        },
        'a:hover &': {
          background: token.badgeColorHover
        }
      },
      [`${componentCls}-count-sm`]: {
        minWidth: indicatorHeightSM,
        height: indicatorHeightSM,
        fontSize: textFontSizeSM,
        lineHeight: (0,cssinjs_es/* unit */.bf)(indicatorHeightSM),
        borderRadius: calc(indicatorHeightSM).div(2).equal()
      },
      [`${componentCls}-multiple-words`]: {
        padding: `0 ${(0,cssinjs_es/* unit */.bf)(token.paddingXS)}`,
        bdi: {
          unicodeBidi: 'plaintext'
        }
      },
      [`${componentCls}-dot`]: {
        zIndex: token.indicatorZIndex,
        width: dotSize,
        minWidth: dotSize,
        height: dotSize,
        background: token.badgeColor,
        borderRadius: '100%',
        boxShadow: `0 0 0 ${(0,cssinjs_es/* unit */.bf)(badgeShadowSize)} ${token.badgeShadowColor}`
      },
      [`${componentCls}-count, ${componentCls}-dot, ${numberPrefixCls}-custom-component`]: {
        position: 'absolute',
        top: 0,
        insetInlineEnd: 0,
        transform: 'translate(50%, -50%)',
        transformOrigin: '100% 0%',
        [`&${iconCls}-spin`]: {
          animationName: antBadgeLoadingCircle,
          animationDuration: '1s',
          animationIterationCount: 'infinite',
          animationTimingFunction: 'linear'
        }
      },
      [`&${componentCls}-status`]: {
        lineHeight: 'inherit',
        verticalAlign: 'baseline',
        [`${componentCls}-status-dot`]: {
          position: 'relative',
          top: -1,
          // Magic number, but seems better experience
          display: 'inline-block',
          width: statusSize,
          height: statusSize,
          verticalAlign: 'middle',
          borderRadius: '50%'
        },
        [`${componentCls}-status-success`]: {
          backgroundColor: token.colorSuccess
        },
        [`${componentCls}-status-processing`]: {
          overflow: 'visible',
          color: token.colorInfo,
          backgroundColor: token.colorInfo,
          borderColor: 'currentcolor',
          '&::after': {
            position: 'absolute',
            top: 0,
            insetInlineStart: 0,
            width: '100%',
            height: '100%',
            borderWidth: badgeShadowSize,
            borderStyle: 'solid',
            borderColor: 'inherit',
            borderRadius: '50%',
            animationName: antStatusProcessing,
            animationDuration: token.badgeProcessingDuration,
            animationIterationCount: 'infinite',
            animationTimingFunction: 'ease-in-out',
            content: '""'
          }
        },
        [`${componentCls}-status-default`]: {
          backgroundColor: token.colorTextPlaceholder
        },
        [`${componentCls}-status-error`]: {
          backgroundColor: token.colorError
        },
        [`${componentCls}-status-warning`]: {
          backgroundColor: token.colorWarning
        },
        [`${componentCls}-status-text`]: {
          marginInlineStart: marginXS,
          color: token.colorText,
          fontSize: token.fontSize
        }
      }
    }), colorPreset), {
      [`${componentCls}-zoom-appear, ${componentCls}-zoom-enter`]: {
        animationName: antZoomBadgeIn,
        animationDuration: token.motionDurationSlow,
        animationTimingFunction: token.motionEaseOutBack,
        animationFillMode: 'both'
      },
      [`${componentCls}-zoom-leave`]: {
        animationName: antZoomBadgeOut,
        animationDuration: token.motionDurationSlow,
        animationTimingFunction: token.motionEaseOutBack,
        animationFillMode: 'both'
      },
      [`&${componentCls}-not-a-wrapper`]: {
        [`${componentCls}-zoom-appear, ${componentCls}-zoom-enter`]: {
          animationName: antNoWrapperZoomBadgeIn,
          animationDuration: token.motionDurationSlow,
          animationTimingFunction: token.motionEaseOutBack
        },
        [`${componentCls}-zoom-leave`]: {
          animationName: antNoWrapperZoomBadgeOut,
          animationDuration: token.motionDurationSlow,
          animationTimingFunction: token.motionEaseOutBack
        },
        [`&:not(${componentCls}-status)`]: {
          verticalAlign: 'middle'
        },
        [`${numberPrefixCls}-custom-component, ${componentCls}-count`]: {
          transform: 'none'
        },
        [`${numberPrefixCls}-custom-component, ${numberPrefixCls}`]: {
          position: 'relative',
          top: 'auto',
          display: 'block',
          transformOrigin: '50% 50%'
        }
      },
      [numberPrefixCls]: {
        overflow: 'hidden',
        transition: `all ${token.motionDurationMid} ${token.motionEaseOutBack}`,
        [`${numberPrefixCls}-only`]: {
          position: 'relative',
          display: 'inline-block',
          height: indicatorHeight,
          transition: `all ${token.motionDurationSlow} ${token.motionEaseOutBack}`,
          WebkitTransformStyle: 'preserve-3d',
          WebkitBackfaceVisibility: 'hidden',
          [`> p${numberPrefixCls}-only-unit`]: {
            height: indicatorHeight,
            margin: 0,
            WebkitTransformStyle: 'preserve-3d',
            WebkitBackfaceVisibility: 'hidden'
          }
        },
        [`${numberPrefixCls}-symbol`]: {
          verticalAlign: 'top'
        }
      },
      // ====================== RTL =======================
      '&-rtl': {
        direction: 'rtl',
        [`${componentCls}-count, ${componentCls}-dot, ${numberPrefixCls}-custom-component`]: {
          transform: 'translate(-50%, -50%)'
        }
      }
    })
  };
};
// ============================== Export ==============================
const badge_style_prepareToken = token => {
  const {
    fontHeight,
    lineWidth,
    marginXS,
    colorBorderBg
  } = token;
  const badgeFontHeight = fontHeight;
  const badgeShadowSize = lineWidth;
  const badgeTextColor = token.colorTextLightSolid;
  const badgeColor = token.colorError;
  const badgeColorHover = token.colorErrorHover;
  const badgeToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    badgeFontHeight,
    badgeShadowSize,
    badgeTextColor,
    badgeColor,
    badgeColorHover,
    badgeShadowColor: colorBorderBg,
    badgeProcessingDuration: '1.2s',
    badgeRibbonOffset: marginXS,
    // Follow token just by Design. Not related with token
    badgeRibbonCornerTransform: 'scaleY(0.75)',
    badgeRibbonCornerFilter: `brightness(75%)`
  });
  return badgeToken;
};
const badge_style_prepareComponentToken = token => {
  const {
    fontSize,
    lineHeight,
    fontSizeSM,
    lineWidth
  } = token;
  return {
    indicatorZIndex: 'auto',
    indicatorHeight: Math.round(fontSize * lineHeight) - 2 * lineWidth,
    indicatorHeightSM: fontSize,
    dotSize: fontSizeSM / 2,
    textFontSize: fontSizeSM,
    textFontSizeSM: fontSizeSM,
    textFontWeight: 'normal',
    statusSize: fontSizeSM / 2
  };
};
/* harmony default export */ var badge_style = (genStyleHooks('Badge', token => {
  const badgeToken = badge_style_prepareToken(token);
  return genSharedBadgeStyle(badgeToken);
}, badge_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/badge/style/ribbon.js




// ============================== Ribbon ==============================
const genRibbonStyle = token => {
  const {
    antCls,
    badgeFontHeight,
    marginXS,
    badgeRibbonOffset,
    calc
  } = token;
  const ribbonPrefixCls = `${antCls}-ribbon`;
  const ribbonWrapperPrefixCls = `${antCls}-ribbon-wrapper`;
  const statusRibbonPreset = genPresetColor_genPresetColor(token, (colorKey, {
    darkColor
  }) => ({
    [`&${ribbonPrefixCls}-color-${colorKey}`]: {
      background: darkColor,
      color: darkColor
    }
  }));
  return {
    [ribbonWrapperPrefixCls]: {
      position: 'relative'
    },
    [ribbonPrefixCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), {
      position: 'absolute',
      top: marginXS,
      padding: `0 ${(0,cssinjs_es/* unit */.bf)(token.paddingXS)}`,
      color: token.colorPrimary,
      lineHeight: (0,cssinjs_es/* unit */.bf)(badgeFontHeight),
      whiteSpace: 'nowrap',
      backgroundColor: token.colorPrimary,
      borderRadius: token.borderRadiusSM,
      [`${ribbonPrefixCls}-text`]: {
        color: token.badgeTextColor
      },
      [`${ribbonPrefixCls}-corner`]: {
        position: 'absolute',
        top: '100%',
        width: badgeRibbonOffset,
        height: badgeRibbonOffset,
        color: 'currentcolor',
        border: `${(0,cssinjs_es/* unit */.bf)(calc(badgeRibbonOffset).div(2).equal())} solid`,
        transform: token.badgeRibbonCornerTransform,
        transformOrigin: 'top',
        filter: token.badgeRibbonCornerFilter
      }
    }), statusRibbonPreset), {
      [`&${ribbonPrefixCls}-placement-end`]: {
        insetInlineEnd: calc(badgeRibbonOffset).mul(-1).equal(),
        borderEndEndRadius: 0,
        [`${ribbonPrefixCls}-corner`]: {
          insetInlineEnd: 0,
          borderInlineEndColor: 'transparent',
          borderBlockEndColor: 'transparent'
        }
      },
      [`&${ribbonPrefixCls}-placement-start`]: {
        insetInlineStart: calc(badgeRibbonOffset).mul(-1).equal(),
        borderEndStartRadius: 0,
        [`${ribbonPrefixCls}-corner`]: {
          insetInlineStart: 0,
          borderBlockEndColor: 'transparent',
          borderInlineStartColor: 'transparent'
        }
      },
      // ====================== RTL =======================
      '&-rtl': {
        direction: 'rtl'
      }
    })
  };
};
// ============================== Export ==============================
/* harmony default export */ var ribbon = (genStyleHooks(['Badge', 'Ribbon'], token => {
  const badgeToken = badge_style_prepareToken(token);
  return genRibbonStyle(badgeToken);
}, badge_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/badge/Ribbon.js
"use client";






const Ribbon = props => {
  const {
    className,
    prefixCls: customizePrefixCls,
    style,
    color,
    children,
    text,
    placement = 'end',
    rootClassName
  } = props;
  const {
    getPrefixCls,
    direction
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('ribbon', customizePrefixCls);
  const wrapperCls = `${prefixCls}-wrapper`;
  const [wrapCSSVar, hashId, cssVarCls] = ribbon(prefixCls, wrapperCls);
  const colorInPreset = isPresetColor(color, false);
  const ribbonCls = classnames_default()(prefixCls, `${prefixCls}-placement-${placement}`, {
    [`${prefixCls}-rtl`]: direction === 'rtl',
    [`${prefixCls}-color-${color}`]: colorInPreset
  }, className);
  const colorStyle = {};
  const cornerColorStyle = {};
  if (color && !colorInPreset) {
    colorStyle.background = color;
    cornerColorStyle.color = color;
  }
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    className: classnames_default()(wrapperCls, rootClassName, hashId, cssVarCls)
  }, children, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(ribbonCls, hashId),
    style: Object.assign(Object.assign({}, colorStyle), style)
  }, /*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-text`
  }, text), /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-corner`,
    style: cornerColorStyle
  }))));
};
if (false) {}
/* harmony default export */ var badge_Ribbon = (Ribbon);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/badge/SingleNumber.js
"use client";



const UnitNumber = props => {
  const {
    prefixCls,
    value,
    current,
    offset = 0
  } = props;
  let style;
  if (offset) {
    style = {
      position: 'absolute',
      top: `${offset}00%`,
      left: 0
    };
  }
  return /*#__PURE__*/react.createElement("span", {
    style: style,
    className: classnames_default()(`${prefixCls}-only-unit`, {
      current
    })
  }, value);
};
function getOffset(start, end, unit) {
  let index = start;
  let offset = 0;
  while ((index + 10) % 10 !== end) {
    index += unit;
    offset += unit;
  }
  return offset;
}
const SingleNumber = props => {
  const {
    prefixCls,
    count: originCount,
    value: originValue
  } = props;
  const value = Number(originValue);
  const count = Math.abs(originCount);
  const [prevValue, setPrevValue] = react.useState(value);
  const [prevCount, setPrevCount] = react.useState(count);
  // ============================= Events =============================
  const onTransitionEnd = () => {
    setPrevValue(value);
    setPrevCount(count);
  };
  // Fallback if transition events are not supported
  react.useEffect(() => {
    const timer = setTimeout(onTransitionEnd, 1000);
    return () => clearTimeout(timer);
  }, [value]);
  // ============================= Render =============================
  // Render unit list
  let unitNodes;
  let offsetStyle;
  if (prevValue === value || Number.isNaN(value) || Number.isNaN(prevValue)) {
    // Nothing to change
    unitNodes = [/*#__PURE__*/react.createElement(UnitNumber, Object.assign({}, props, {
      key: value,
      current: true
    }))];
    offsetStyle = {
      transition: 'none'
    };
  } else {
    unitNodes = [];
    // Fill basic number units
    const end = value + 10;
    const unitNumberList = [];
    for (let index = value; index <= end; index += 1) {
      unitNumberList.push(index);
    }
    const unit = prevCount < count ? 1 : -1;
    // Fill with number unit nodes
    const prevIndex = unitNumberList.findIndex(n => n % 10 === prevValue);
    // Cut list
    const cutUnitNumberList = unit < 0 ? unitNumberList.slice(0, prevIndex + 1) : unitNumberList.slice(prevIndex);
    unitNodes = cutUnitNumberList.map((n, index) => {
      const singleUnit = n % 10;
      return /*#__PURE__*/react.createElement(UnitNumber, Object.assign({}, props, {
        key: n,
        value: singleUnit,
        offset: unit < 0 ? index - prevIndex : index,
        current: index === prevIndex
      }));
    });
    // Calculate container offset value
    offsetStyle = {
      transform: `translateY(${-getOffset(prevValue, value, unit)}00%)`
    };
  }
  return /*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-only`,
    style: offsetStyle,
    onTransitionEnd: onTransitionEnd
  }, unitNodes);
};
/* harmony default export */ var badge_SingleNumber = (SingleNumber);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/badge/ScrollNumber.js
"use client";

var ScrollNumber_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





const ScrollNumber = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      count,
      className,
      motionClassName,
      style,
      title,
      show,
      component: Component = 'sup',
      children
    } = props,
    restProps = ScrollNumber_rest(props, ["prefixCls", "count", "className", "motionClassName", "style", "title", "show", "component", "children"]);
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('scroll-number', customizePrefixCls);
  // ============================ Render ============================
  const newProps = Object.assign(Object.assign({}, restProps), {
    'data-show': show,
    style,
    className: classnames_default()(prefixCls, className, motionClassName),
    title: title
  });
  // Only integer need motion
  let numberNodes = count;
  if (count && Number(count) % 1 === 0) {
    const numberList = String(count).split('');
    numberNodes = /*#__PURE__*/react.createElement("bdi", null, numberList.map((num, i) => (/*#__PURE__*/react.createElement(badge_SingleNumber, {
      prefixCls: prefixCls,
      count: Number(count),
      value: num,
      // eslint-disable-next-line react/no-array-index-key
      key: numberList.length - i
    }))));
  }
  // allow specify the border
  // mock border-color by box-shadow for compatible with old usage:
  // <Badge count={4} style={{ backgroundColor: '#fff', color: '#999', borderColor: '#d9d9d9' }} />
  if (style === null || style === void 0 ? void 0 : style.borderColor) {
    newProps.style = Object.assign(Object.assign({}, style), {
      boxShadow: `0 0 0 1px ${style.borderColor} inset`
    });
  }
  if (children) {
    return cloneElement(children, oriProps => ({
      className: classnames_default()(`${prefixCls}-custom-component`, oriProps === null || oriProps === void 0 ? void 0 : oriProps.className, motionClassName)
    }));
  }
  return /*#__PURE__*/react.createElement(Component, Object.assign({}, newProps, {
    ref: ref
  }), numberNodes);
});
/* harmony default export */ var badge_ScrollNumber = (ScrollNumber);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/badge/index.js
"use client";

var badge_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};










const InternalBadge = /*#__PURE__*/react.forwardRef((props, ref) => {
  var _a, _b, _c, _d, _e;
  const {
      prefixCls: customizePrefixCls,
      scrollNumberPrefixCls: customizeScrollNumberPrefixCls,
      children,
      status,
      text,
      color,
      count = null,
      overflowCount = 99,
      dot = false,
      size = 'default',
      title,
      offset,
      style,
      className,
      rootClassName,
      classNames,
      styles,
      showZero = false
    } = props,
    restProps = badge_rest(props, ["prefixCls", "scrollNumberPrefixCls", "children", "status", "text", "color", "count", "overflowCount", "dot", "size", "title", "offset", "style", "className", "rootClassName", "classNames", "styles", "showZero"]);
  const {
    getPrefixCls,
    direction,
    badge
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('badge', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = badge_style(prefixCls);
  // ================================ Misc ================================
  const numberedDisplayCount = count > overflowCount ? `${overflowCount}+` : count;
  const isZero = numberedDisplayCount === '0' || numberedDisplayCount === 0;
  const ignoreCount = count === null || isZero && !showZero;
  const hasStatus = (status !== null && status !== undefined || color !== null && color !== undefined) && ignoreCount;
  const hasStatusValue = status !== null && status !== undefined || !isZero;
  const showAsDot = dot && !isZero;
  const mergedCount = showAsDot ? '' : numberedDisplayCount;
  const isHidden = (0,react.useMemo)(() => {
    const isEmpty = mergedCount === null || mergedCount === undefined || mergedCount === '';
    return (isEmpty || isZero && !showZero) && !showAsDot;
  }, [mergedCount, isZero, showZero, showAsDot]);
  // Count should be cache in case hidden change it
  const countRef = (0,react.useRef)(count);
  if (!isHidden) {
    countRef.current = count;
  }
  const livingCount = countRef.current;
  // We need cache count since remove motion should not change count display
  const displayCountRef = (0,react.useRef)(mergedCount);
  if (!isHidden) {
    displayCountRef.current = mergedCount;
  }
  const displayCount = displayCountRef.current;
  // We will cache the dot status to avoid shaking on leaved motion
  const isDotRef = (0,react.useRef)(showAsDot);
  if (!isHidden) {
    isDotRef.current = showAsDot;
  }
  // =============================== Styles ===============================
  const mergedStyle = (0,react.useMemo)(() => {
    if (!offset) {
      return Object.assign(Object.assign({}, badge === null || badge === void 0 ? void 0 : badge.style), style);
    }
    const offsetStyle = {
      marginTop: offset[1]
    };
    if (direction === 'rtl') {
      offsetStyle.left = parseInt(offset[0], 10);
    } else {
      offsetStyle.right = -parseInt(offset[0], 10);
    }
    return Object.assign(Object.assign(Object.assign({}, offsetStyle), badge === null || badge === void 0 ? void 0 : badge.style), style);
  }, [direction, offset, style, badge === null || badge === void 0 ? void 0 : badge.style]);
  // =============================== Render ===============================
  // >>> Title
  const titleNode = title !== null && title !== void 0 ? title : typeof livingCount === 'string' || typeof livingCount === 'number' ? livingCount : undefined;
  // >>> Status Text
  const statusTextNode = isHidden || !text ? null : /*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-status-text`
  }, text);
  // >>> Display Component
  const displayNode = !livingCount || typeof livingCount !== 'object' ? undefined : cloneElement(livingCount, oriProps => ({
    style: Object.assign(Object.assign({}, mergedStyle), oriProps.style)
  }));
  // InternalColor
  const isInternalColor = isPresetColor(color, false);
  // Shared styles
  const statusCls = classnames_default()(classNames === null || classNames === void 0 ? void 0 : classNames.indicator, (_a = badge === null || badge === void 0 ? void 0 : badge.classNames) === null || _a === void 0 ? void 0 : _a.indicator, {
    [`${prefixCls}-status-dot`]: hasStatus,
    [`${prefixCls}-status-${status}`]: !!status,
    [`${prefixCls}-color-${color}`]: isInternalColor
  });
  const statusStyle = {};
  if (color && !isInternalColor) {
    statusStyle.color = color;
    statusStyle.background = color;
  }
  const badgeClassName = classnames_default()(prefixCls, {
    [`${prefixCls}-status`]: hasStatus,
    [`${prefixCls}-not-a-wrapper`]: !children,
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, className, rootClassName, badge === null || badge === void 0 ? void 0 : badge.className, (_b = badge === null || badge === void 0 ? void 0 : badge.classNames) === null || _b === void 0 ? void 0 : _b.root, classNames === null || classNames === void 0 ? void 0 : classNames.root, hashId, cssVarCls);
  // <Badge status="success" />
  if (!children && hasStatus && (text || hasStatusValue || !ignoreCount)) {
    const statusTextColor = mergedStyle.color;
    return wrapCSSVar(/*#__PURE__*/react.createElement("span", Object.assign({}, restProps, {
      className: badgeClassName,
      style: Object.assign(Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.root), (_c = badge === null || badge === void 0 ? void 0 : badge.styles) === null || _c === void 0 ? void 0 : _c.root), mergedStyle)
    }), /*#__PURE__*/react.createElement("span", {
      className: statusCls,
      style: Object.assign(Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.indicator), (_d = badge === null || badge === void 0 ? void 0 : badge.styles) === null || _d === void 0 ? void 0 : _d.indicator), statusStyle)
    }), text && (/*#__PURE__*/react.createElement("span", {
      style: {
        color: statusTextColor
      },
      className: `${prefixCls}-status-text`
    }, text))));
  }
  return wrapCSSVar(/*#__PURE__*/react.createElement("span", Object.assign({
    ref: ref
  }, restProps, {
    className: badgeClassName,
    style: Object.assign(Object.assign({}, (_e = badge === null || badge === void 0 ? void 0 : badge.styles) === null || _e === void 0 ? void 0 : _e.root), styles === null || styles === void 0 ? void 0 : styles.root)
  }), children, /*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, {
    visible: !isHidden,
    motionName: `${prefixCls}-zoom`,
    motionAppear: false,
    motionDeadline: 1000
  }, ({
    className: motionClassName
  }) => {
    var _a, _b;
    const scrollNumberPrefixCls = getPrefixCls('scroll-number', customizeScrollNumberPrefixCls);
    const isDot = isDotRef.current;
    const scrollNumberCls = classnames_default()(classNames === null || classNames === void 0 ? void 0 : classNames.indicator, (_a = badge === null || badge === void 0 ? void 0 : badge.classNames) === null || _a === void 0 ? void 0 : _a.indicator, {
      [`${prefixCls}-dot`]: isDot,
      [`${prefixCls}-count`]: !isDot,
      [`${prefixCls}-count-sm`]: size === 'small',
      [`${prefixCls}-multiple-words`]: !isDot && displayCount && displayCount.toString().length > 1,
      [`${prefixCls}-status-${status}`]: !!status,
      [`${prefixCls}-color-${color}`]: isInternalColor
    });
    let scrollNumberStyle = Object.assign(Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.indicator), (_b = badge === null || badge === void 0 ? void 0 : badge.styles) === null || _b === void 0 ? void 0 : _b.indicator), mergedStyle);
    if (color && !isInternalColor) {
      scrollNumberStyle = scrollNumberStyle || {};
      scrollNumberStyle.background = color;
    }
    return /*#__PURE__*/react.createElement(badge_ScrollNumber, {
      prefixCls: scrollNumberPrefixCls,
      show: !isHidden,
      motionClassName: motionClassName,
      className: scrollNumberCls,
      count: displayCount,
      title: titleNode,
      style: scrollNumberStyle,
      key: "scrollNumber"
    }, displayNode);
  }), statusTextNode));
});
const Badge = InternalBadge;
Badge.Ribbon = badge_Ribbon;
if (false) {}
/* harmony default export */ var es_badge = (Badge);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/LeftOutlined.js + 1 modules
var LeftOutlined = __webpack_require__(58113);
// EXTERNAL MODULE: ./node_modules/rc-dropdown/es/index.js + 4 modules
var rc_dropdown_es = __webpack_require__(93755);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/isPrimitive.js
const isPrimitive = value => typeof value !== 'object' && typeof value !== 'function' || value === null;
/* harmony default export */ var _util_isPrimitive = (isPrimitive);
// EXTERNAL MODULE: ./node_modules/rc-menu/es/index.js + 26 modules
var rc_menu_es = __webpack_require__(2369);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/BarsOutlined.js + 1 modules
var BarsOutlined = __webpack_require__(51055);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/layout/context.js

const LayoutContext = /*#__PURE__*/react.createContext({
  siderHook: {
    addSider: () => null,
    removeSider: () => null
  }
});
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/layout/style/index.js


const genLayoutStyle = token => {
  const {
    antCls,
    // .ant
    componentCls,
    // .ant-layout
    colorText,
    footerBg,
    headerHeight,
    headerPadding,
    headerColor,
    footerPadding,
    fontSize,
    bodyBg,
    headerBg
  } = token;
  return {
    [componentCls]: {
      display: 'flex',
      flex: 'auto',
      flexDirection: 'column',
      /* fix firefox can't set height smaller than content on flex item */
      minHeight: 0,
      background: bodyBg,
      '&, *': {
        boxSizing: 'border-box'
      },
      [`&${componentCls}-has-sider`]: {
        flexDirection: 'row',
        [`> ${componentCls}, > ${componentCls}-content`]: {
          // https://segmentfault.com/a/1190000019498300
          width: 0
        }
      },
      [`${componentCls}-header, &${componentCls}-footer`]: {
        flex: '0 0 auto'
      },
      // RTL
      '&-rtl': {
        direction: 'rtl'
      }
    },
    // ==================== Header ====================
    [`${componentCls}-header`]: {
      height: headerHeight,
      padding: headerPadding,
      color: headerColor,
      lineHeight: (0,cssinjs_es/* unit */.bf)(headerHeight),
      background: headerBg,
      // Other components/menu/style/index.less line:686
      // Integration with header element so menu items have the same height
      [`${antCls}-menu`]: {
        lineHeight: 'inherit'
      }
    },
    // ==================== Footer ====================
    [`${componentCls}-footer`]: {
      padding: footerPadding,
      color: colorText,
      fontSize,
      background: footerBg
    },
    // =================== Content ====================
    [`${componentCls}-content`]: {
      flex: 'auto',
      color: colorText,
      // fix firefox can't set height smaller than content on flex item
      minHeight: 0
    }
  };
};
const layout_style_prepareComponentToken = token => {
  const {
    colorBgLayout,
    controlHeight,
    controlHeightLG,
    colorText,
    controlHeightSM,
    marginXXS,
    colorTextLightSolid,
    colorBgContainer
  } = token;
  const paddingInline = controlHeightLG * 1.25;
  return {
    // Deprecated
    colorBgHeader: '#001529',
    colorBgBody: colorBgLayout,
    colorBgTrigger: '#002140',
    bodyBg: colorBgLayout,
    headerBg: '#001529',
    headerHeight: controlHeight * 2,
    headerPadding: `0 ${paddingInline}px`,
    headerColor: colorText,
    footerPadding: `${controlHeightSM}px ${paddingInline}px`,
    footerBg: colorBgLayout,
    siderBg: '#001529',
    triggerHeight: controlHeightLG + marginXXS * 2,
    triggerBg: '#002140',
    triggerColor: colorTextLightSolid,
    zeroTriggerWidth: controlHeightLG,
    zeroTriggerHeight: controlHeightLG,
    lightSiderBg: colorBgContainer,
    lightTriggerBg: colorBgContainer,
    lightTriggerColor: colorText
  };
};
// ============================== Export ==============================
const DEPRECATED_TOKENS = [['colorBgBody', 'bodyBg'], ['colorBgHeader', 'headerBg'], ['colorBgTrigger', 'triggerBg']];
/* harmony default export */ var layout_style = (genStyleHooks('Layout', genLayoutStyle, layout_style_prepareComponentToken, {
  deprecatedTokens: DEPRECATED_TOKENS
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/layout/style/sider.js



const genSiderStyle = token => {
  const {
    componentCls,
    siderBg,
    motionDurationMid,
    motionDurationSlow,
    antCls,
    triggerHeight,
    triggerColor,
    triggerBg,
    headerHeight,
    zeroTriggerWidth,
    zeroTriggerHeight,
    borderRadiusLG,
    lightSiderBg,
    lightTriggerColor,
    lightTriggerBg,
    bodyBg
  } = token;
  return {
    [componentCls]: {
      position: 'relative',
      // fix firefox can't set width smaller than content on flex item
      minWidth: 0,
      background: siderBg,
      transition: `all ${motionDurationMid}, background 0s`,
      '&-has-trigger': {
        paddingBottom: triggerHeight
      },
      '&-right': {
        order: 1
      },
      [`${componentCls}-children`]: {
        height: '100%',
        // Hack for fixing margin collapse bug
        // https://github.com/ant-design/ant-design/issues/7967
        // solution from https://stackoverflow.com/a/33132624/3040605
        marginTop: -0.1,
        paddingTop: 0.1,
        [`${antCls}-menu${antCls}-menu-inline-collapsed`]: {
          width: 'auto'
        }
      },
      [`&-zero-width ${componentCls}-children`]: {
        overflow: 'hidden'
      },
      [`${componentCls}-trigger`]: {
        position: 'fixed',
        bottom: 0,
        zIndex: 1,
        height: triggerHeight,
        color: triggerColor,
        lineHeight: (0,cssinjs_es/* unit */.bf)(triggerHeight),
        textAlign: 'center',
        background: triggerBg,
        cursor: 'pointer',
        transition: `all ${motionDurationMid}`
      },
      [`${componentCls}-zero-width-trigger`]: {
        position: 'absolute',
        top: headerHeight,
        insetInlineEnd: token.calc(zeroTriggerWidth).mul(-1).equal(),
        zIndex: 1,
        width: zeroTriggerWidth,
        height: zeroTriggerHeight,
        color: triggerColor,
        fontSize: token.fontSizeXL,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: siderBg,
        borderRadius: `0 ${(0,cssinjs_es/* unit */.bf)(borderRadiusLG)} ${(0,cssinjs_es/* unit */.bf)(borderRadiusLG)} 0`,
        cursor: 'pointer',
        transition: `background ${motionDurationSlow} ease`,
        '&::after': {
          position: 'absolute',
          inset: 0,
          background: 'transparent',
          transition: `all ${motionDurationSlow}`,
          content: '""'
        },
        '&:hover::after': {
          background: `rgba(255, 255, 255, 0.2)`
        },
        '&-right': {
          insetInlineStart: token.calc(zeroTriggerWidth).mul(-1).equal(),
          borderRadius: `${(0,cssinjs_es/* unit */.bf)(borderRadiusLG)} 0 0 ${(0,cssinjs_es/* unit */.bf)(borderRadiusLG)}`
        }
      },
      // Light
      '&-light': {
        background: lightSiderBg,
        [`${componentCls}-trigger`]: {
          color: lightTriggerColor,
          background: lightTriggerBg
        },
        [`${componentCls}-zero-width-trigger`]: {
          color: lightTriggerColor,
          background: lightTriggerBg,
          border: `1px solid ${bodyBg}`,
          // Safe to modify to any other color
          borderInlineStart: 0
        }
      }
    }
  };
};
/* harmony default export */ var sider = (genStyleHooks(['Layout', 'Sider'], genSiderStyle, layout_style_prepareComponentToken, {
  deprecatedTokens: DEPRECATED_TOKENS
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/layout/Sider.js
"use client";

var Sider_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};











const dimensionMaxMap = {
  xs: '479.98px',
  sm: '575.98px',
  md: '767.98px',
  lg: '991.98px',
  xl: '1199.98px',
  xxl: '1599.98px'
};
const isNumeric = value => !Number.isNaN(Number.parseFloat(value)) && isFinite(value);
const SiderContext = /*#__PURE__*/react.createContext({});
const generateId = (() => {
  let i = 0;
  return (prefix = '') => {
    i += 1;
    return `${prefix}${i}`;
  };
})();
const Sider = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      className,
      trigger,
      children,
      defaultCollapsed = false,
      theme = 'dark',
      style = {},
      collapsible = false,
      reverseArrow = false,
      width = 200,
      collapsedWidth = 80,
      zeroWidthTriggerStyle,
      breakpoint,
      onCollapse,
      onBreakpoint
    } = props,
    otherProps = Sider_rest(props, ["prefixCls", "className", "trigger", "children", "defaultCollapsed", "theme", "style", "collapsible", "reverseArrow", "width", "collapsedWidth", "zeroWidthTriggerStyle", "breakpoint", "onCollapse", "onBreakpoint"]);
  const {
    siderHook
  } = (0,react.useContext)(LayoutContext);
  const [collapsed, setCollapsed] = (0,react.useState)('collapsed' in props ? props.collapsed : defaultCollapsed);
  const [below, setBelow] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    if ('collapsed' in props) {
      setCollapsed(props.collapsed);
    }
  }, [props.collapsed]);
  const handleSetCollapsed = (value, type) => {
    if (!('collapsed' in props)) {
      setCollapsed(value);
    }
    onCollapse === null || onCollapse === void 0 ? void 0 : onCollapse(value, type);
  };
  // =========================== Prefix ===========================
  const {
    getPrefixCls,
    direction
  } = (0,react.useContext)(ConfigContext);
  const prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = sider(prefixCls);
  // ========================= Responsive =========================
  const responsiveHandlerRef = (0,react.useRef)(null);
  responsiveHandlerRef.current = mql => {
    setBelow(mql.matches);
    onBreakpoint === null || onBreakpoint === void 0 ? void 0 : onBreakpoint(mql.matches);
    if (collapsed !== mql.matches) {
      handleSetCollapsed(mql.matches, 'responsive');
    }
  };
  (0,react.useEffect)(() => {
    function responsiveHandler(mql) {
      var _a;
      return (_a = responsiveHandlerRef.current) === null || _a === void 0 ? void 0 : _a.call(responsiveHandlerRef, mql);
    }
    let mql;
    if (typeof (window === null || window === void 0 ? void 0 : window.matchMedia) !== 'undefined' && breakpoint && breakpoint in dimensionMaxMap) {
      mql = window.matchMedia(`screen and (max-width: ${dimensionMaxMap[breakpoint]})`);
      addMediaQueryListener(mql, responsiveHandler);
      responsiveHandler(mql);
    }
    return () => {
      removeMediaQueryListener(mql, responsiveHandler);
    };
  }, [breakpoint]); // in order to accept dynamic 'breakpoint' property, we need to add 'breakpoint' into dependency array.
  (0,react.useEffect)(() => {
    const uniqueId = generateId('ant-sider-');
    siderHook.addSider(uniqueId);
    return () => siderHook.removeSider(uniqueId);
  }, []);
  const toggle = () => {
    handleSetCollapsed(!collapsed, 'clickTrigger');
  };
  const divProps = (0,omit/* default */.Z)(otherProps, ['collapsed']);
  const rawWidth = collapsed ? collapsedWidth : width;
  // use "px" as fallback unit for width
  const siderWidth = isNumeric(rawWidth) ? `${rawWidth}px` : String(rawWidth);
  // special trigger when collapsedWidth == 0
  const zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? (/*#__PURE__*/react.createElement("span", {
    onClick: toggle,
    className: classnames_default()(`${prefixCls}-zero-width-trigger`, `${prefixCls}-zero-width-trigger-${reverseArrow ? 'right' : 'left'}`),
    style: zeroWidthTriggerStyle
  }, trigger || /*#__PURE__*/react.createElement(BarsOutlined/* default */.Z, null))) : null;
  const reverseIcon = direction === 'rtl' === !reverseArrow;
  const iconObj = {
    expanded: reverseIcon ? /*#__PURE__*/react.createElement(RightOutlined/* default */.Z, null) : /*#__PURE__*/react.createElement(LeftOutlined/* default */.Z, null),
    collapsed: reverseIcon ? /*#__PURE__*/react.createElement(LeftOutlined/* default */.Z, null) : /*#__PURE__*/react.createElement(RightOutlined/* default */.Z, null)
  };
  const status = collapsed ? 'collapsed' : 'expanded';
  const defaultTrigger = iconObj[status];
  const triggerDom = trigger !== null ? zeroWidthTrigger || (/*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-trigger`,
    onClick: toggle,
    style: {
      width: siderWidth
    }
  }, trigger || defaultTrigger)) : null;
  const divStyle = Object.assign(Object.assign({}, style), {
    flex: `0 0 ${siderWidth}`,
    maxWidth: siderWidth,
    minWidth: siderWidth,
    width: siderWidth
  });
  const siderCls = classnames_default()(prefixCls, `${prefixCls}-${theme}`, {
    [`${prefixCls}-collapsed`]: !!collapsed,
    [`${prefixCls}-has-trigger`]: collapsible && trigger !== null && !zeroWidthTrigger,
    [`${prefixCls}-below`]: !!below,
    [`${prefixCls}-zero-width`]: parseFloat(siderWidth) === 0
  }, className, hashId, cssVarCls);
  const contextValue = react.useMemo(() => ({
    siderCollapsed: collapsed
  }), [collapsed]);
  return wrapCSSVar(/*#__PURE__*/react.createElement(SiderContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/react.createElement("aside", Object.assign({
    className: siderCls
  }, divProps, {
    style: divStyle,
    ref: ref
  }), /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-children`
  }, children), collapsible || below && zeroWidthTrigger ? triggerDom : null)));
});
if (false) {}
/* harmony default export */ var layout_Sider = (Sider);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/EllipsisOutlined.js + 1 modules
var EllipsisOutlined = __webpack_require__(5745);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/menu/MenuContext.js
"use client";


const MenuContext = /*#__PURE__*/(0,react.createContext)({
  prefixCls: '',
  firstLevel: true,
  inlineCollapsed: false
});
/* harmony default export */ var menu_MenuContext = (MenuContext);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/menu/MenuDivider.js
"use client";

var MenuDivider_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




const MenuDivider = props => {
  const {
      prefixCls: customizePrefixCls,
      className,
      dashed
    } = props,
    restProps = MenuDivider_rest(props, ["prefixCls", "className", "dashed"]);
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('menu', customizePrefixCls);
  const classString = classnames_default()({
    [`${prefixCls}-item-divider-dashed`]: !!dashed
  }, className);
  return /*#__PURE__*/react.createElement(rc_menu_es/* Divider */.iz, Object.assign({
    className: classString
  }, restProps));
};
/* harmony default export */ var menu_MenuDivider = (MenuDivider);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/menu/MenuItem.js
"use client";










const MenuItem = props => {
  var _a;
  const {
    className,
    children,
    icon,
    title,
    danger,
    extra
  } = props;
  const {
    prefixCls,
    firstLevel,
    direction,
    disableMenuItemTitleTooltip,
    inlineCollapsed: isInlineCollapsed
  } = react.useContext(menu_MenuContext);
  const renderItemChildren = inlineCollapsed => {
    const label = children === null || children === void 0 ? void 0 : children[0];
    const wrapNode = /*#__PURE__*/react.createElement("span", {
      className: classnames_default()(`${prefixCls}-title-content`, {
        [`${prefixCls}-title-content-with-extra`]: !!extra || extra === 0
      })
    }, children);
    // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
    // ref: https://github.com/ant-design/ant-design/pull/23456
    if (!icon || /*#__PURE__*/react.isValidElement(children) && children.type === 'span') {
      if (children && inlineCollapsed && firstLevel && typeof label === 'string') {
        return /*#__PURE__*/react.createElement("div", {
          className: `${prefixCls}-inline-collapsed-noicon`
        }, label.charAt(0));
      }
    }
    return wrapNode;
  };
  const {
    siderCollapsed
  } = react.useContext(SiderContext);
  let tooltipTitle = title;
  if (typeof title === 'undefined') {
    tooltipTitle = firstLevel ? children : '';
  } else if (title === false) {
    tooltipTitle = '';
  }
  const tooltipProps = {
    title: tooltipTitle
  };
  if (!siderCollapsed && !isInlineCollapsed) {
    tooltipProps.title = null;
    // Reset `open` to fix control mode tooltip display not correct
    // ref: https://github.com/ant-design/ant-design/issues/16742
    tooltipProps.open = false;
  }
  const childrenLength = (0,Children_toArray/* default */.Z)(children).length;
  let returnNode = /*#__PURE__*/react.createElement(rc_menu_es/* Item */.ck, Object.assign({}, (0,omit/* default */.Z)(props, ['title', 'icon', 'danger']), {
    className: classnames_default()({
      [`${prefixCls}-item-danger`]: danger,
      [`${prefixCls}-item-only-child`]: (icon ? childrenLength + 1 : childrenLength) === 1
    }, className),
    title: typeof title === 'string' ? title : undefined
  }), cloneElement(icon, {
    className: classnames_default()(/*#__PURE__*/react.isValidElement(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : undefined, `${prefixCls}-item-icon`)
  }), renderItemChildren(isInlineCollapsed));
  if (!disableMenuItemTitleTooltip) {
    returnNode = /*#__PURE__*/react.createElement(es_tooltip, Object.assign({}, tooltipProps, {
      placement: direction === 'rtl' ? 'left' : 'right',
      classNames: {
        root: `${prefixCls}-inline-collapsed-tooltip`
      }
    }), returnNode);
  }
  return returnNode;
};
/* harmony default export */ var menu_MenuItem = (MenuItem);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/menu/OverrideContext.js
"use client";

var OverrideContext_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};



const OverrideContext = /*#__PURE__*/react.createContext(null);
/** @internal Only used for Dropdown component. Do not use this in your production. */
const OverrideProvider = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      children
    } = props,
    restProps = OverrideContext_rest(props, ["children"]);
  const override = react.useContext(OverrideContext);
  const context = react.useMemo(() => Object.assign(Object.assign({}, override), restProps), [override, restProps.prefixCls,
  // restProps.expandIcon, Not mark as deps since this is a ReactNode
  restProps.mode, restProps.selectable, restProps.rootClassName
  // restProps.validator, Not mark as deps since this is a function
  ]);
  const canRef = (0,es_ref/* supportNodeRef */.t4)(children);
  const mergedRef = (0,es_ref/* useComposeRef */.x1)(ref, canRef ? (0,es_ref/* getNodeRef */.C4)(children) : null);
  return /*#__PURE__*/react.createElement(OverrideContext.Provider, {
    value: context
  }, /*#__PURE__*/react.createElement(_util_ContextIsolator, {
    space: true
  }, canRef ? /*#__PURE__*/react.cloneElement(children, {
    ref: mergedRef
  }) : children));
});
/** @internal Only used for Dropdown component. Do not use this in your production. */
/* harmony default export */ var menu_OverrideContext = (OverrideContext);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/menu/style/horizontal.js

const getHorizontalStyle = token => {
  const {
    componentCls,
    motionDurationSlow,
    horizontalLineHeight,
    colorSplit,
    lineWidth,
    lineType,
    itemPaddingInline
  } = token;
  return {
    [`${componentCls}-horizontal`]: {
      lineHeight: horizontalLineHeight,
      border: 0,
      borderBottom: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${colorSplit}`,
      boxShadow: 'none',
      '&::after': {
        display: 'block',
        clear: 'both',
        height: 0,
        content: '"\\20"'
      },
      // ======================= Item =======================
      [`${componentCls}-item, ${componentCls}-submenu`]: {
        position: 'relative',
        display: 'inline-block',
        verticalAlign: 'bottom',
        paddingInline: itemPaddingInline
      },
      [`> ${componentCls}-item:hover,
        > ${componentCls}-item-active,
        > ${componentCls}-submenu ${componentCls}-submenu-title:hover`]: {
        backgroundColor: 'transparent'
      },
      [`${componentCls}-item, ${componentCls}-submenu-title`]: {
        transition: [`border-color ${motionDurationSlow}`, `background ${motionDurationSlow}`].join(',')
      },
      // ===================== Sub Menu =====================
      [`${componentCls}-submenu-arrow`]: {
        display: 'none'
      }
    }
  };
};
/* harmony default export */ var horizontal = (getHorizontalStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/menu/style/rtl.js

const getRTLStyle = ({
  componentCls,
  menuArrowOffset,
  calc
}) => ({
  [`${componentCls}-rtl`]: {
    direction: 'rtl'
  },
  [`${componentCls}-submenu-rtl`]: {
    transformOrigin: '100% 0'
  },
  // Vertical Arrow
  [`${componentCls}-rtl${componentCls}-vertical,
    ${componentCls}-submenu-rtl ${componentCls}-vertical`]: {
    [`${componentCls}-submenu-arrow`]: {
      '&::before': {
        transform: `rotate(-45deg) translateY(${(0,cssinjs_es/* unit */.bf)(calc(menuArrowOffset).mul(-1).equal())})`
      },
      '&::after': {
        transform: `rotate(45deg) translateY(${(0,cssinjs_es/* unit */.bf)(menuArrowOffset)})`
      }
    }
  }
});
/* harmony default export */ var rtl = (getRTLStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/menu/style/theme.js


const accessibilityFocus = token => genFocusOutline(token);
const getThemeStyle = (token, themeSuffix) => {
  const {
    componentCls,
    itemColor,
    itemSelectedColor,
    subMenuItemSelectedColor,
    groupTitleColor,
    itemBg,
    subMenuItemBg,
    itemSelectedBg,
    activeBarHeight,
    activeBarWidth,
    activeBarBorderWidth,
    motionDurationSlow,
    motionEaseInOut,
    motionEaseOut,
    itemPaddingInline,
    motionDurationMid,
    itemHoverColor,
    lineType,
    colorSplit,
    // Disabled
    itemDisabledColor,
    // Danger
    dangerItemColor,
    dangerItemHoverColor,
    dangerItemSelectedColor,
    dangerItemActiveBg,
    dangerItemSelectedBg,
    // Bg
    popupBg,
    itemHoverBg,
    itemActiveBg,
    menuSubMenuBg,
    // Horizontal
    horizontalItemSelectedColor,
    horizontalItemSelectedBg,
    horizontalItemBorderRadius,
    horizontalItemHoverBg
  } = token;
  return {
    [`${componentCls}-${themeSuffix}, ${componentCls}-${themeSuffix} > ${componentCls}`]: {
      color: itemColor,
      background: itemBg,
      [`&${componentCls}-root:focus-visible`]: Object.assign({}, accessibilityFocus(token)),
      // ======================== Item ========================
      [`${componentCls}-item`]: {
        '&-group-title, &-extra': {
          color: groupTitleColor
        }
      },
      [`${componentCls}-submenu-selected > ${componentCls}-submenu-title`]: {
        color: subMenuItemSelectedColor
      },
      [`${componentCls}-item, ${componentCls}-submenu-title`]: {
        color: itemColor,
        [`&:not(${componentCls}-item-disabled):focus-visible`]: Object.assign({}, accessibilityFocus(token))
      },
      // Disabled
      [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
        color: `${itemDisabledColor} !important`
      },
      // Hover
      [`${componentCls}-item:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
        [`&:hover, > ${componentCls}-submenu-title:hover`]: {
          color: itemHoverColor
        }
      },
      [`&:not(${componentCls}-horizontal)`]: {
        [`${componentCls}-item:not(${componentCls}-item-selected)`]: {
          '&:hover': {
            backgroundColor: itemHoverBg
          },
          '&:active': {
            backgroundColor: itemActiveBg
          }
        },
        [`${componentCls}-submenu-title`]: {
          '&:hover': {
            backgroundColor: itemHoverBg
          },
          '&:active': {
            backgroundColor: itemActiveBg
          }
        }
      },
      // Danger - only Item has
      [`${componentCls}-item-danger`]: {
        color: dangerItemColor,
        [`&${componentCls}-item:hover`]: {
          [`&:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
            color: dangerItemHoverColor
          }
        },
        [`&${componentCls}-item:active`]: {
          background: dangerItemActiveBg
        }
      },
      [`${componentCls}-item a`]: {
        '&, &:hover': {
          color: 'inherit'
        }
      },
      [`${componentCls}-item-selected`]: {
        color: itemSelectedColor,
        // Danger
        [`&${componentCls}-item-danger`]: {
          color: dangerItemSelectedColor
        },
        'a, a:hover': {
          color: 'inherit'
        }
      },
      [`& ${componentCls}-item-selected`]: {
        backgroundColor: itemSelectedBg,
        // Danger
        [`&${componentCls}-item-danger`]: {
          backgroundColor: dangerItemSelectedBg
        }
      },
      [`&${componentCls}-submenu > ${componentCls}`]: {
        backgroundColor: menuSubMenuBg
      },
      // ===== 设置浮层的颜色 =======
      // ！dark 模式会被popupBg 会被rest 为 darkPopupBg
      [`&${componentCls}-popup > ${componentCls}`]: {
        backgroundColor: popupBg
      },
      [`&${componentCls}-submenu-popup > ${componentCls}`]: {
        backgroundColor: popupBg
      },
      // ===== 设置浮层的颜色 end =======
      // ====================== Horizontal ======================
      [`&${componentCls}-horizontal`]: Object.assign(Object.assign({}, themeSuffix === 'dark' ? {
        borderBottom: 0
      } : {}), {
        [`> ${componentCls}-item, > ${componentCls}-submenu`]: {
          top: activeBarBorderWidth,
          marginTop: token.calc(activeBarBorderWidth).mul(-1).equal(),
          marginBottom: 0,
          borderRadius: horizontalItemBorderRadius,
          '&::after': {
            position: 'absolute',
            insetInline: itemPaddingInline,
            bottom: 0,
            borderBottom: `${(0,cssinjs_es/* unit */.bf)(activeBarHeight)} solid transparent`,
            transition: `border-color ${motionDurationSlow} ${motionEaseInOut}`,
            content: '""'
          },
          '&:hover, &-active, &-open': {
            background: horizontalItemHoverBg,
            '&::after': {
              borderBottomWidth: activeBarHeight,
              borderBottomColor: horizontalItemSelectedColor
            }
          },
          '&-selected': {
            color: horizontalItemSelectedColor,
            backgroundColor: horizontalItemSelectedBg,
            '&:hover': {
              backgroundColor: horizontalItemSelectedBg
            },
            '&::after': {
              borderBottomWidth: activeBarHeight,
              borderBottomColor: horizontalItemSelectedColor
            }
          }
        }
      }),
      // ================== Inline & Vertical ===================
      //
      [`&${componentCls}-root`]: {
        [`&${componentCls}-inline, &${componentCls}-vertical`]: {
          borderInlineEnd: `${(0,cssinjs_es/* unit */.bf)(activeBarBorderWidth)} ${lineType} ${colorSplit}`
        }
      },
      // ======================== Inline ========================
      [`&${componentCls}-inline`]: {
        // Sub
        [`${componentCls}-sub${componentCls}-inline`]: {
          background: subMenuItemBg
        },
        [`${componentCls}-item`]: {
          position: 'relative',
          '&::after': {
            position: 'absolute',
            insetBlock: 0,
            insetInlineEnd: 0,
            borderInlineEnd: `${(0,cssinjs_es/* unit */.bf)(activeBarWidth)} solid ${itemSelectedColor}`,
            transform: 'scaleY(0.0001)',
            opacity: 0,
            transition: [`transform ${motionDurationMid} ${motionEaseOut}`, `opacity ${motionDurationMid} ${motionEaseOut}`].join(','),
            content: '""'
          },
          // Danger
          [`&${componentCls}-item-danger`]: {
            '&::after': {
              borderInlineEndColor: dangerItemSelectedColor
            }
          }
        },
        [`${componentCls}-selected, ${componentCls}-item-selected`]: {
          '&::after': {
            transform: 'scaleY(1)',
            opacity: 1,
            transition: [`transform ${motionDurationMid} ${motionEaseInOut}`, `opacity ${motionDurationMid} ${motionEaseInOut}`].join(',')
          }
        }
      }
    }
  };
};
/* harmony default export */ var theme = (getThemeStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/menu/style/vertical.js


const getVerticalInlineStyle = token => {
  const {
    componentCls,
    itemHeight,
    itemMarginInline,
    padding,
    menuArrowSize,
    marginXS,
    itemMarginBlock,
    itemWidth,
    itemPaddingInline
  } = token;
  const paddingWithArrow = token.calc(menuArrowSize).add(padding).add(marginXS).equal();
  return {
    [`${componentCls}-item`]: {
      position: 'relative',
      overflow: 'hidden'
    },
    [`${componentCls}-item, ${componentCls}-submenu-title`]: {
      height: itemHeight,
      lineHeight: (0,cssinjs_es/* unit */.bf)(itemHeight),
      paddingInline: itemPaddingInline,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      marginInline: itemMarginInline,
      marginBlock: itemMarginBlock,
      width: itemWidth
    },
    [`> ${componentCls}-item,
            > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
      height: itemHeight,
      lineHeight: (0,cssinjs_es/* unit */.bf)(itemHeight)
    },
    [`${componentCls}-item-group-list ${componentCls}-submenu-title,
            ${componentCls}-submenu-title`]: {
      paddingInlineEnd: paddingWithArrow
    }
  };
};
const getVerticalStyle = token => {
  const {
    componentCls,
    iconCls,
    itemHeight,
    colorTextLightSolid,
    dropdownWidth,
    controlHeightLG,
    motionEaseOut,
    paddingXL,
    itemMarginInline,
    fontSizeLG,
    motionDurationFast,
    motionDurationSlow,
    paddingXS,
    boxShadowSecondary,
    collapsedWidth,
    collapsedIconSize
  } = token;
  const inlineItemStyle = {
    height: itemHeight,
    lineHeight: (0,cssinjs_es/* unit */.bf)(itemHeight),
    listStylePosition: 'inside',
    listStyleType: 'disc'
  };
  return [{
    [componentCls]: {
      '&-inline, &-vertical': Object.assign({
        [`&${componentCls}-root`]: {
          boxShadow: 'none'
        }
      }, getVerticalInlineStyle(token))
    },
    [`${componentCls}-submenu-popup`]: {
      [`${componentCls}-vertical`]: Object.assign(Object.assign({}, getVerticalInlineStyle(token)), {
        boxShadow: boxShadowSecondary
      })
    }
  },
  // Vertical only
  {
    [`${componentCls}-submenu-popup ${componentCls}-vertical${componentCls}-sub`]: {
      minWidth: dropdownWidth,
      maxHeight: `calc(100vh - ${(0,cssinjs_es/* unit */.bf)(token.calc(controlHeightLG).mul(2.5).equal())})`,
      padding: '0',
      overflow: 'hidden',
      borderInlineEnd: 0,
      // https://github.com/ant-design/ant-design/issues/22244
      // https://github.com/ant-design/ant-design/issues/26812
      "&:not([class*='-active'])": {
        overflowX: 'hidden',
        overflowY: 'auto'
      }
    }
  },
  // Inline Only
  {
    [`${componentCls}-inline`]: {
      width: '100%',
      // Motion enhance for first level
      [`&${componentCls}-root`]: {
        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
          display: 'flex',
          alignItems: 'center',
          transition: [`border-color ${motionDurationSlow}`, `background ${motionDurationSlow}`, `padding ${motionDurationFast} ${motionEaseOut}`].join(','),
          [`> ${componentCls}-title-content`]: {
            flex: 'auto',
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          },
          '> *': {
            flex: 'none'
          }
        }
      },
      // >>>>> Sub
      [`${componentCls}-sub${componentCls}-inline`]: {
        padding: 0,
        border: 0,
        borderRadius: 0,
        boxShadow: 'none',
        [`& > ${componentCls}-submenu > ${componentCls}-submenu-title`]: inlineItemStyle,
        [`& ${componentCls}-item-group-title`]: {
          paddingInlineStart: paddingXL
        }
      },
      // >>>>> Item
      [`${componentCls}-item`]: inlineItemStyle
    }
  },
  // Inline Collapse Only
  {
    [`${componentCls}-inline-collapsed`]: {
      width: collapsedWidth,
      [`&${componentCls}-root`]: {
        [`${componentCls}-item, ${componentCls}-submenu ${componentCls}-submenu-title`]: {
          [`> ${componentCls}-inline-collapsed-noicon`]: {
            fontSize: fontSizeLG,
            textAlign: 'center'
          }
        }
      },
      [`> ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-submenu > ${componentCls}-submenu-title,
          > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
        insetInlineStart: 0,
        paddingInline: `calc(50% - ${(0,cssinjs_es/* unit */.bf)(token.calc(collapsedIconSize).div(2).equal())} - ${(0,cssinjs_es/* unit */.bf)(itemMarginInline)})`,
        textOverflow: 'clip',
        [`
            ${componentCls}-submenu-arrow,
            ${componentCls}-submenu-expand-icon
          `]: {
          opacity: 0
        },
        [`${componentCls}-item-icon, ${iconCls}`]: {
          margin: 0,
          fontSize: collapsedIconSize,
          lineHeight: (0,cssinjs_es/* unit */.bf)(itemHeight),
          '+ span': {
            display: 'inline-block',
            opacity: 0
          }
        }
      },
      [`${componentCls}-item-icon, ${iconCls}`]: {
        display: 'inline-block'
      },
      '&-tooltip': {
        pointerEvents: 'none',
        [`${componentCls}-item-icon, ${iconCls}`]: {
          display: 'none'
        },
        'a, a:hover': {
          color: colorTextLightSolid
        }
      },
      [`${componentCls}-item-group-title`]: Object.assign(Object.assign({}, textEllipsis), {
        paddingInline: paddingXS
      })
    }
  }];
};
/* harmony default export */ var vertical = (getVerticalStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/menu/style/index.js









const genMenuItemStyle = token => {
  const {
    componentCls,
    motionDurationSlow,
    motionDurationMid,
    motionEaseInOut,
    motionEaseOut,
    iconCls,
    iconSize,
    iconMarginInlineEnd
  } = token;
  return {
    // >>>>> Item
    [`${componentCls}-item, ${componentCls}-submenu-title`]: {
      position: 'relative',
      display: 'block',
      margin: 0,
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      transition: [`border-color ${motionDurationSlow}`, `background ${motionDurationSlow}`, `padding calc(${motionDurationSlow} + 0.1s) ${motionEaseInOut}`].join(','),
      [`${componentCls}-item-icon, ${iconCls}`]: {
        minWidth: iconSize,
        fontSize: iconSize,
        transition: [`font-size ${motionDurationMid} ${motionEaseOut}`, `margin ${motionDurationSlow} ${motionEaseInOut}`, `color ${motionDurationSlow}`].join(','),
        '+ span': {
          marginInlineStart: iconMarginInlineEnd,
          opacity: 1,
          transition: [`opacity ${motionDurationSlow} ${motionEaseInOut}`, `margin ${motionDurationSlow}`, `color ${motionDurationSlow}`].join(',')
        }
      },
      [`${componentCls}-item-icon`]: Object.assign({}, resetIcon()),
      [`&${componentCls}-item-only-child`]: {
        [`> ${iconCls}, > ${componentCls}-item-icon`]: {
          marginInlineEnd: 0
        }
      }
    },
    // Disabled state sets text to gray and nukes hover/tab effects
    [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
      background: 'none !important',
      cursor: 'not-allowed',
      '&::after': {
        borderColor: 'transparent !important'
      },
      a: {
        color: 'inherit !important',
        cursor: 'not-allowed',
        pointerEvents: 'none'
      },
      [`> ${componentCls}-submenu-title`]: {
        color: 'inherit !important',
        cursor: 'not-allowed'
      }
    }
  };
};
const genSubMenuArrowStyle = token => {
  const {
    componentCls,
    motionDurationSlow,
    motionEaseInOut,
    borderRadius,
    menuArrowSize,
    menuArrowOffset
  } = token;
  return {
    [`${componentCls}-submenu`]: {
      '&-expand-icon, &-arrow': {
        position: 'absolute',
        top: '50%',
        insetInlineEnd: token.margin,
        width: menuArrowSize,
        color: 'currentcolor',
        transform: 'translateY(-50%)',
        transition: `transform ${motionDurationSlow} ${motionEaseInOut}, opacity ${motionDurationSlow}`
      },
      '&-arrow': {
        // →
        '&::before, &::after': {
          position: 'absolute',
          width: token.calc(menuArrowSize).mul(0.6).equal(),
          height: token.calc(menuArrowSize).mul(0.15).equal(),
          backgroundColor: 'currentcolor',
          borderRadius,
          transition: [`background ${motionDurationSlow} ${motionEaseInOut}`, `transform ${motionDurationSlow} ${motionEaseInOut}`, `top ${motionDurationSlow} ${motionEaseInOut}`, `color ${motionDurationSlow} ${motionEaseInOut}`].join(','),
          content: '""'
        },
        '&::before': {
          transform: `rotate(45deg) translateY(${(0,cssinjs_es/* unit */.bf)(token.calc(menuArrowOffset).mul(-1).equal())})`
        },
        '&::after': {
          transform: `rotate(-45deg) translateY(${(0,cssinjs_es/* unit */.bf)(menuArrowOffset)})`
        }
      }
    }
  };
};
// =============================== Base ===============================
const getBaseStyle = token => {
  const {
    antCls,
    componentCls,
    fontSize,
    motionDurationSlow,
    motionDurationMid,
    motionEaseInOut,
    paddingXS,
    padding,
    colorSplit,
    lineWidth,
    zIndexPopup,
    borderRadiusLG,
    subMenuItemBorderRadius,
    menuArrowSize,
    menuArrowOffset,
    lineType,
    groupTitleLineHeight,
    groupTitleFontSize
  } = token;
  return [
  // Misc
  {
    '': {
      [componentCls]: Object.assign(Object.assign({}, clearFix()), {
        // Hidden
        '&-hidden': {
          display: 'none'
        }
      })
    },
    [`${componentCls}-submenu-hidden`]: {
      display: 'none'
    }
  }, {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), clearFix()), {
      marginBottom: 0,
      paddingInlineStart: 0,
      // Override default ul/ol
      fontSize,
      lineHeight: 0,
      listStyle: 'none',
      outline: 'none',
      // Magic cubic here but smooth transition
      transition: `width ${motionDurationSlow} cubic-bezier(0.2, 0, 0, 1) 0s`,
      'ul, ol': {
        margin: 0,
        padding: 0,
        listStyle: 'none'
      },
      // Overflow ellipsis
      '&-overflow': {
        display: 'flex',
        [`${componentCls}-item`]: {
          flex: 'none'
        }
      },
      [`${componentCls}-item, ${componentCls}-submenu, ${componentCls}-submenu-title`]: {
        borderRadius: token.itemBorderRadius
      },
      [`${componentCls}-item-group-title`]: {
        padding: `${(0,cssinjs_es/* unit */.bf)(paddingXS)} ${(0,cssinjs_es/* unit */.bf)(padding)}`,
        fontSize: groupTitleFontSize,
        lineHeight: groupTitleLineHeight,
        transition: `all ${motionDurationSlow}`
      },
      [`&-horizontal ${componentCls}-submenu`]: {
        transition: [`border-color ${motionDurationSlow} ${motionEaseInOut}`, `background ${motionDurationSlow} ${motionEaseInOut}`].join(',')
      },
      [`${componentCls}-submenu, ${componentCls}-submenu-inline`]: {
        transition: [`border-color ${motionDurationSlow} ${motionEaseInOut}`, `background ${motionDurationSlow} ${motionEaseInOut}`, `padding ${motionDurationMid} ${motionEaseInOut}`].join(',')
      },
      [`${componentCls}-submenu ${componentCls}-sub`]: {
        cursor: 'initial',
        transition: [`background ${motionDurationSlow} ${motionEaseInOut}`, `padding ${motionDurationSlow} ${motionEaseInOut}`].join(',')
      },
      [`${componentCls}-title-content`]: {
        transition: `color ${motionDurationSlow}`,
        '&-with-extra': {
          display: 'inline-flex',
          alignItems: 'center',
          width: '100%'
        },
        // https://github.com/ant-design/ant-design/issues/41143
        [`> ${antCls}-typography-ellipsis-single-line`]: {
          display: 'inline',
          verticalAlign: 'unset'
        },
        [`${componentCls}-item-extra`]: {
          marginInlineStart: 'auto',
          paddingInlineStart: token.padding
        }
      },
      [`${componentCls}-item a`]: {
        '&::before': {
          position: 'absolute',
          inset: 0,
          backgroundColor: 'transparent',
          content: '""'
        }
      },
      // Removed a Badge related style seems it's safe
      // https://github.com/ant-design/ant-design/issues/19809
      // >>>>> Divider
      [`${componentCls}-item-divider`]: {
        overflow: 'hidden',
        lineHeight: 0,
        borderColor: colorSplit,
        borderStyle: lineType,
        borderWidth: 0,
        borderTopWidth: lineWidth,
        marginBlock: lineWidth,
        padding: 0,
        '&-dashed': {
          borderStyle: 'dashed'
        }
      }
    }), genMenuItemStyle(token)), {
      [`${componentCls}-item-group`]: {
        [`${componentCls}-item-group-list`]: {
          margin: 0,
          padding: 0,
          [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            paddingInline: `${(0,cssinjs_es/* unit */.bf)(token.calc(fontSize).mul(2).equal())} ${(0,cssinjs_es/* unit */.bf)(padding)}`
          }
        }
      },
      // ======================= Sub Menu =======================
      '&-submenu': {
        '&-popup': {
          position: 'absolute',
          zIndex: zIndexPopup,
          borderRadius: borderRadiusLG,
          boxShadow: 'none',
          transformOrigin: '0 0',
          [`&${componentCls}-submenu`]: {
            background: 'transparent'
          },
          // https://github.com/ant-design/ant-design/issues/13955
          '&::before': {
            position: 'absolute',
            inset: 0,
            zIndex: -1,
            width: '100%',
            height: '100%',
            opacity: 0,
            content: '""'
          },
          [`> ${componentCls}`]: Object.assign(Object.assign(Object.assign({
            borderRadius: borderRadiusLG
          }, genMenuItemStyle(token)), genSubMenuArrowStyle(token)), {
            [`${componentCls}-item, ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
              borderRadius: subMenuItemBorderRadius
            },
            [`${componentCls}-submenu-title::after`]: {
              transition: `transform ${motionDurationSlow} ${motionEaseInOut}`
            }
          })
        },
        [`
          &-placement-leftTop,
          &-placement-bottomRight,
          `]: {
          transformOrigin: '100% 0'
        },
        [`
          &-placement-leftBottom,
          &-placement-topRight,
          `]: {
          transformOrigin: '100% 100%'
        },
        [`
          &-placement-rightBottom,
          &-placement-topLeft,
          `]: {
          transformOrigin: '0 100%'
        },
        [`
          &-placement-bottomLeft,
          &-placement-rightTop,
          `]: {
          transformOrigin: '0 0'
        },
        [`
          &-placement-leftTop,
          &-placement-leftBottom
          `]: {
          paddingInlineEnd: token.paddingXS
        },
        [`
          &-placement-rightTop,
          &-placement-rightBottom
          `]: {
          paddingInlineStart: token.paddingXS
        },
        [`
          &-placement-topRight,
          &-placement-topLeft
          `]: {
          paddingBottom: token.paddingXS
        },
        [`
          &-placement-bottomRight,
          &-placement-bottomLeft
          `]: {
          paddingTop: token.paddingXS
        }
      }
    }), genSubMenuArrowStyle(token)), {
      [`&-inline-collapsed ${componentCls}-submenu-arrow,
        &-inline ${componentCls}-submenu-arrow`]: {
        // ↓
        '&::before': {
          transform: `rotate(-45deg) translateX(${(0,cssinjs_es/* unit */.bf)(menuArrowOffset)})`
        },
        '&::after': {
          transform: `rotate(45deg) translateX(${(0,cssinjs_es/* unit */.bf)(token.calc(menuArrowOffset).mul(-1).equal())})`
        }
      },
      [`${componentCls}-submenu-open${componentCls}-submenu-inline > ${componentCls}-submenu-title > ${componentCls}-submenu-arrow`]: {
        // ↑
        transform: `translateY(${(0,cssinjs_es/* unit */.bf)(token.calc(menuArrowSize).mul(0.2).mul(-1).equal())})`,
        '&::after': {
          transform: `rotate(-45deg) translateX(${(0,cssinjs_es/* unit */.bf)(token.calc(menuArrowOffset).mul(-1).equal())})`
        },
        '&::before': {
          transform: `rotate(45deg) translateX(${(0,cssinjs_es/* unit */.bf)(menuArrowOffset)})`
        }
      }
    })
  },
  // Integration with header element so menu items have the same height
  {
    [`${antCls}-layout-header`]: {
      [componentCls]: {
        lineHeight: 'inherit'
      }
    }
  }];
};
const menu_style_prepareComponentToken = token => {
  var _a, _b, _c;
  const {
    colorPrimary,
    colorError,
    colorTextDisabled,
    colorErrorBg,
    colorText,
    colorTextDescription,
    colorBgContainer,
    colorFillAlter,
    colorFillContent,
    lineWidth,
    lineWidthBold,
    controlItemBgActive,
    colorBgTextHover,
    controlHeightLG,
    lineHeight,
    colorBgElevated,
    marginXXS,
    padding,
    fontSize,
    controlHeightSM,
    fontSizeLG,
    colorTextLightSolid,
    colorErrorHover
  } = token;
  const activeBarWidth = (_a = token.activeBarWidth) !== null && _a !== void 0 ? _a : 0;
  const activeBarBorderWidth = (_b = token.activeBarBorderWidth) !== null && _b !== void 0 ? _b : lineWidth;
  const itemMarginInline = (_c = token.itemMarginInline) !== null && _c !== void 0 ? _c : token.marginXXS;
  const colorTextDark = new fast_color_es/* FastColor */.t(colorTextLightSolid).setA(0.65).toRgbString();
  return {
    dropdownWidth: 160,
    zIndexPopup: token.zIndexPopupBase + 50,
    radiusItem: token.borderRadiusLG,
    itemBorderRadius: token.borderRadiusLG,
    radiusSubMenuItem: token.borderRadiusSM,
    subMenuItemBorderRadius: token.borderRadiusSM,
    colorItemText: colorText,
    itemColor: colorText,
    colorItemTextHover: colorText,
    itemHoverColor: colorText,
    colorItemTextHoverHorizontal: colorPrimary,
    horizontalItemHoverColor: colorPrimary,
    colorGroupTitle: colorTextDescription,
    groupTitleColor: colorTextDescription,
    colorItemTextSelected: colorPrimary,
    itemSelectedColor: colorPrimary,
    subMenuItemSelectedColor: colorPrimary,
    colorItemTextSelectedHorizontal: colorPrimary,
    horizontalItemSelectedColor: colorPrimary,
    colorItemBg: colorBgContainer,
    itemBg: colorBgContainer,
    colorItemBgHover: colorBgTextHover,
    itemHoverBg: colorBgTextHover,
    colorItemBgActive: colorFillContent,
    itemActiveBg: controlItemBgActive,
    colorSubItemBg: colorFillAlter,
    subMenuItemBg: colorFillAlter,
    colorItemBgSelected: controlItemBgActive,
    itemSelectedBg: controlItemBgActive,
    colorItemBgSelectedHorizontal: 'transparent',
    horizontalItemSelectedBg: 'transparent',
    colorActiveBarWidth: 0,
    activeBarWidth,
    colorActiveBarHeight: lineWidthBold,
    activeBarHeight: lineWidthBold,
    colorActiveBarBorderSize: lineWidth,
    activeBarBorderWidth,
    // Disabled
    colorItemTextDisabled: colorTextDisabled,
    itemDisabledColor: colorTextDisabled,
    // Danger
    colorDangerItemText: colorError,
    dangerItemColor: colorError,
    colorDangerItemTextHover: colorError,
    dangerItemHoverColor: colorError,
    colorDangerItemTextSelected: colorError,
    dangerItemSelectedColor: colorError,
    colorDangerItemBgActive: colorErrorBg,
    dangerItemActiveBg: colorErrorBg,
    colorDangerItemBgSelected: colorErrorBg,
    dangerItemSelectedBg: colorErrorBg,
    itemMarginInline,
    horizontalItemBorderRadius: 0,
    horizontalItemHoverBg: 'transparent',
    itemHeight: controlHeightLG,
    groupTitleLineHeight: lineHeight,
    collapsedWidth: controlHeightLG * 2,
    popupBg: colorBgElevated,
    itemMarginBlock: marginXXS,
    itemPaddingInline: padding,
    horizontalLineHeight: `${controlHeightLG * 1.15}px`,
    iconSize: fontSize,
    iconMarginInlineEnd: controlHeightSM - fontSize,
    collapsedIconSize: fontSizeLG,
    groupTitleFontSize: fontSize,
    // Disabled
    darkItemDisabledColor: new fast_color_es/* FastColor */.t(colorTextLightSolid).setA(0.25).toRgbString(),
    // Dark
    darkItemColor: colorTextDark,
    darkDangerItemColor: colorError,
    darkItemBg: '#001529',
    darkPopupBg: '#001529',
    darkSubMenuItemBg: '#000c17',
    darkItemSelectedColor: colorTextLightSolid,
    darkItemSelectedBg: colorPrimary,
    darkDangerItemSelectedBg: colorError,
    darkItemHoverBg: 'transparent',
    darkGroupTitleColor: colorTextDark,
    darkItemHoverColor: colorTextLightSolid,
    darkDangerItemHoverColor: colorErrorHover,
    darkDangerItemSelectedColor: colorTextLightSolid,
    darkDangerItemActiveBg: colorError,
    // internal
    itemWidth: activeBarWidth ? `calc(100% + ${activeBarBorderWidth}px)` : `calc(100% - ${itemMarginInline * 2}px)`
  };
};
// ============================== Export ==============================
/* harmony default export */ var menu_style = ((prefixCls, rootCls = prefixCls, injectStyle = true) => {
  const useStyle = genStyleHooks('Menu', token => {
    const {
      colorBgElevated,
      controlHeightLG,
      fontSize,
      darkItemColor,
      darkDangerItemColor,
      darkItemBg,
      darkSubMenuItemBg,
      darkItemSelectedColor,
      darkItemSelectedBg,
      darkDangerItemSelectedBg,
      darkItemHoverBg,
      darkGroupTitleColor,
      darkItemHoverColor,
      darkItemDisabledColor,
      darkDangerItemHoverColor,
      darkDangerItemSelectedColor,
      darkDangerItemActiveBg,
      popupBg,
      darkPopupBg
    } = token;
    const menuArrowSize = token.calc(fontSize).div(7).mul(5).equal();
    // Menu Token
    const menuToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
      menuArrowSize,
      menuHorizontalHeight: token.calc(controlHeightLG).mul(1.15).equal(),
      menuArrowOffset: token.calc(menuArrowSize).mul(0.25).equal(),
      menuSubMenuBg: colorBgElevated,
      calc: token.calc,
      popupBg
    });
    const menuDarkToken = (0,cssinjs_utils_es/* mergeToken */.IX)(menuToken, {
      itemColor: darkItemColor,
      itemHoverColor: darkItemHoverColor,
      groupTitleColor: darkGroupTitleColor,
      itemSelectedColor: darkItemSelectedColor,
      subMenuItemSelectedColor: darkItemSelectedColor,
      itemBg: darkItemBg,
      popupBg: darkPopupBg,
      subMenuItemBg: darkSubMenuItemBg,
      itemActiveBg: 'transparent',
      itemSelectedBg: darkItemSelectedBg,
      activeBarHeight: 0,
      activeBarBorderWidth: 0,
      itemHoverBg: darkItemHoverBg,
      // Disabled
      itemDisabledColor: darkItemDisabledColor,
      // Danger
      dangerItemColor: darkDangerItemColor,
      dangerItemHoverColor: darkDangerItemHoverColor,
      dangerItemSelectedColor: darkDangerItemSelectedColor,
      dangerItemActiveBg: darkDangerItemActiveBg,
      dangerItemSelectedBg: darkDangerItemSelectedBg,
      menuSubMenuBg: darkSubMenuItemBg,
      // Horizontal
      horizontalItemSelectedColor: darkItemSelectedColor,
      horizontalItemSelectedBg: darkItemSelectedBg
    });
    return [
    // Basic
    getBaseStyle(menuToken),
    // Horizontal
    horizontal(menuToken),
    // Hard code for some light style
    // Vertical
    vertical(menuToken),
    // Hard code for some light style
    // Theme
    theme(menuToken, 'light'), theme(menuDarkToken, 'dark'),
    // RTL
    rtl(menuToken),
    // Motion
    collapse(menuToken), initSlideMotion(menuToken, 'slide-up'), initSlideMotion(menuToken, 'slide-down'), initZoomMotion(menuToken, 'zoom-big')];
  }, menu_style_prepareComponentToken, {
    deprecatedTokens: [['colorGroupTitle', 'groupTitleColor'], ['radiusItem', 'itemBorderRadius'], ['radiusSubMenuItem', 'subMenuItemBorderRadius'], ['colorItemText', 'itemColor'], ['colorItemTextHover', 'itemHoverColor'], ['colorItemTextHoverHorizontal', 'horizontalItemHoverColor'], ['colorItemTextSelected', 'itemSelectedColor'], ['colorItemTextSelectedHorizontal', 'horizontalItemSelectedColor'], ['colorItemTextDisabled', 'itemDisabledColor'], ['colorDangerItemText', 'dangerItemColor'], ['colorDangerItemTextHover', 'dangerItemHoverColor'], ['colorDangerItemTextSelected', 'dangerItemSelectedColor'], ['colorDangerItemBgActive', 'dangerItemActiveBg'], ['colorDangerItemBgSelected', 'dangerItemSelectedBg'], ['colorItemBg', 'itemBg'], ['colorItemBgHover', 'itemHoverBg'], ['colorSubItemBg', 'subMenuItemBg'], ['colorItemBgActive', 'itemActiveBg'], ['colorItemBgSelectedHorizontal', 'horizontalItemSelectedBg'], ['colorActiveBarWidth', 'activeBarWidth'], ['colorActiveBarHeight', 'activeBarHeight'], ['colorActiveBarBorderSize', 'activeBarBorderWidth'], ['colorItemBgSelected', 'itemSelectedBg']],
    // Dropdown will handle menu style self. We do not need to handle this.
    injectStyle,
    unitless: {
      groupTitleLineHeight: true
    }
  });
  return useStyle(prefixCls, rootCls);
});
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/menu/SubMenu.js
"use client";








const SubMenu = props => {
  var _a;
  const {
    popupClassName,
    icon,
    title,
    theme: customTheme
  } = props;
  const context = react.useContext(menu_MenuContext);
  const {
    prefixCls,
    inlineCollapsed,
    theme: contextTheme
  } = context;
  const parentPath = (0,rc_menu_es/* useFullPath */.Xl)();
  let titleNode;
  if (!icon) {
    titleNode = inlineCollapsed && !parentPath.length && title && typeof title === 'string' ? (/*#__PURE__*/react.createElement("div", {
      className: `${prefixCls}-inline-collapsed-noicon`
    }, title.charAt(0))) : (/*#__PURE__*/react.createElement("span", {
      className: `${prefixCls}-title-content`
    }, title));
  } else {
    // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
    // ref: https://github.com/ant-design/ant-design/pull/23456
    const titleIsSpan = /*#__PURE__*/react.isValidElement(title) && title.type === 'span';
    titleNode = /*#__PURE__*/react.createElement(react.Fragment, null, cloneElement(icon, {
      className: classnames_default()(/*#__PURE__*/react.isValidElement(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : undefined, `${prefixCls}-item-icon`)
    }), titleIsSpan ? title : /*#__PURE__*/react.createElement("span", {
      className: `${prefixCls}-title-content`
    }, title));
  }
  const contextValue = react.useMemo(() => Object.assign(Object.assign({}, context), {
    firstLevel: false
  }), [context]);
  // ============================ zIndex ============================
  const [zIndex] = useZIndex('Menu');
  return /*#__PURE__*/react.createElement(menu_MenuContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/react.createElement(rc_menu_es/* SubMenu */.Wd, Object.assign({}, (0,omit/* default */.Z)(props, ['icon']), {
    title: titleNode,
    popupClassName: classnames_default()(prefixCls, popupClassName, `${prefixCls}-${customTheme || contextTheme}`),
    popupStyle: Object.assign({
      zIndex
    }, props.popupStyle)
  })));
};
/* harmony default export */ var menu_SubMenu = (SubMenu);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/menu/menu.js
"use client";

var menu_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


















function isEmptyIcon(icon) {
  return icon === null || icon === false;
}
const MENU_COMPONENTS = {
  item: menu_MenuItem,
  submenu: menu_SubMenu,
  divider: menu_MenuDivider
};
const InternalMenu = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var _a;
  const override = react.useContext(menu_OverrideContext);
  const overrideObj = override || {};
  const {
    getPrefixCls,
    getPopupContainer,
    direction,
    menu
  } = react.useContext(ConfigContext);
  const rootPrefixCls = getPrefixCls();
  const {
      prefixCls: customizePrefixCls,
      className,
      style,
      theme = 'light',
      expandIcon,
      _internalDisableMenuItemTitleTooltip,
      inlineCollapsed,
      siderCollapsed,
      rootClassName,
      mode,
      selectable,
      onClick,
      overflowedIndicatorPopupClassName
    } = props,
    restProps = menu_rest(props, ["prefixCls", "className", "style", "theme", "expandIcon", "_internalDisableMenuItemTitleTooltip", "inlineCollapsed", "siderCollapsed", "rootClassName", "mode", "selectable", "onClick", "overflowedIndicatorPopupClassName"]);
  const passedProps = (0,omit/* default */.Z)(restProps, ['collapsedWidth']);
  // ======================== Warning ==========================
  if (false) {}
  (_a = overrideObj.validator) === null || _a === void 0 ? void 0 : _a.call(overrideObj, {
    mode
  });
  // ========================== Click ==========================
  // Tell dropdown that item clicked
  const onItemClick = (0,hooks_useEvent/* default */.Z)((...args) => {
    var _a;
    onClick === null || onClick === void 0 ? void 0 : onClick.apply(void 0, args);
    (_a = overrideObj.onClick) === null || _a === void 0 ? void 0 : _a.call(overrideObj);
  });
  // ========================== Mode ===========================
  const mergedMode = overrideObj.mode || mode;
  // ======================= Selectable ========================
  const mergedSelectable = selectable !== null && selectable !== void 0 ? selectable : overrideObj.selectable;
  // ======================== Collapsed ========================
  // Inline Collapsed
  const mergedInlineCollapsed = inlineCollapsed !== null && inlineCollapsed !== void 0 ? inlineCollapsed : siderCollapsed;
  const defaultMotions = {
    horizontal: {
      motionName: `${rootPrefixCls}-slide-up`
    },
    inline: _util_motion(rootPrefixCls),
    other: {
      motionName: `${rootPrefixCls}-zoom-big`
    }
  };
  const prefixCls = getPrefixCls('menu', customizePrefixCls || overrideObj.prefixCls);
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = menu_style(prefixCls, rootCls, !override);
  const menuClassName = classnames_default()(`${prefixCls}-${theme}`, menu === null || menu === void 0 ? void 0 : menu.className, className);
  // ====================== ExpandIcon ========================
  const mergedExpandIcon = react.useMemo(() => {
    var _a, _b;
    if (typeof expandIcon === 'function' || isEmptyIcon(expandIcon)) {
      return expandIcon || null;
    }
    if (typeof overrideObj.expandIcon === 'function' || isEmptyIcon(overrideObj.expandIcon)) {
      return overrideObj.expandIcon || null;
    }
    if (typeof (menu === null || menu === void 0 ? void 0 : menu.expandIcon) === 'function' || isEmptyIcon(menu === null || menu === void 0 ? void 0 : menu.expandIcon)) {
      return (menu === null || menu === void 0 ? void 0 : menu.expandIcon) || null;
    }
    const mergedIcon = (_a = expandIcon !== null && expandIcon !== void 0 ? expandIcon : overrideObj === null || overrideObj === void 0 ? void 0 : overrideObj.expandIcon) !== null && _a !== void 0 ? _a : menu === null || menu === void 0 ? void 0 : menu.expandIcon;
    return cloneElement(mergedIcon, {
      className: classnames_default()(`${prefixCls}-submenu-expand-icon`, /*#__PURE__*/react.isValidElement(mergedIcon) ? (_b = mergedIcon.props) === null || _b === void 0 ? void 0 : _b.className : undefined)
    });
  }, [expandIcon, overrideObj === null || overrideObj === void 0 ? void 0 : overrideObj.expandIcon, menu === null || menu === void 0 ? void 0 : menu.expandIcon, prefixCls]);
  // ======================== Context ==========================
  const contextValue = react.useMemo(() => ({
    prefixCls,
    inlineCollapsed: mergedInlineCollapsed || false,
    direction,
    firstLevel: true,
    theme,
    mode: mergedMode,
    disableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip
  }), [prefixCls, mergedInlineCollapsed, direction, _internalDisableMenuItemTitleTooltip, theme]);
  // ========================= Render ==========================
  return wrapCSSVar(/*#__PURE__*/react.createElement(menu_OverrideContext.Provider, {
    value: null
  }, /*#__PURE__*/react.createElement(menu_MenuContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/react.createElement(rc_menu_es/* default */.ZP, Object.assign({
    getPopupContainer: getPopupContainer,
    overflowedIndicator: /*#__PURE__*/react.createElement(EllipsisOutlined/* default */.Z, null),
    overflowedIndicatorPopupClassName: classnames_default()(prefixCls, `${prefixCls}-${theme}`, overflowedIndicatorPopupClassName),
    mode: mergedMode,
    selectable: mergedSelectable,
    onClick: onItemClick
  }, passedProps, {
    inlineCollapsed: mergedInlineCollapsed,
    style: Object.assign(Object.assign({}, menu === null || menu === void 0 ? void 0 : menu.style), style),
    className: menuClassName,
    prefixCls: prefixCls,
    direction: direction,
    defaultMotions: defaultMotions,
    expandIcon: mergedExpandIcon,
    ref: ref,
    rootClassName: classnames_default()(rootClassName, hashId, overrideObj.rootClassName, cssVarCls, rootCls),
    _internalComponents: MENU_COMPONENTS
  })))));
});
/* harmony default export */ var menu = (InternalMenu);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/menu/index.js
"use client";









const Menu = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  const menuRef = (0,react.useRef)(null);
  const context = react.useContext(SiderContext);
  (0,react.useImperativeHandle)(ref, () => ({
    menu: menuRef.current,
    focus: options => {
      var _a;
      (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.focus(options);
    }
  }));
  return /*#__PURE__*/react.createElement(menu, Object.assign({
    ref: menuRef
  }, props, context));
});
Menu.Item = menu_MenuItem;
Menu.SubMenu = menu_SubMenu;
Menu.Divider = menu_MenuDivider;
Menu.ItemGroup = rc_menu_es/* ItemGroup */.BW;
if (false) {}
/* harmony default export */ var es_menu = (Menu);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/dropdown/style/status.js
const genStatusStyle = token => {
  const {
    componentCls,
    menuCls,
    colorError,
    colorTextLightSolid
  } = token;
  const itemCls = `${menuCls}-item`;
  return {
    [`${componentCls}, ${componentCls}-menu-submenu`]: {
      [`${menuCls} ${itemCls}`]: {
        [`&${itemCls}-danger:not(${itemCls}-disabled)`]: {
          color: colorError,
          '&:hover': {
            color: colorTextLightSolid,
            backgroundColor: colorError
          }
        }
      }
    }
  };
};
/* harmony default export */ var style_status = (genStatusStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/dropdown/style/index.js







// =============================== Base ===============================
const dropdown_style_genBaseStyle = token => {
  const {
    componentCls,
    menuCls,
    zIndexPopup,
    dropdownArrowDistance,
    sizePopupArrow,
    antCls,
    iconCls,
    motionDurationMid,
    paddingBlock,
    fontSize,
    dropdownEdgeChildPadding,
    colorTextDisabled,
    fontSizeIcon,
    controlPaddingHorizontal,
    colorBgElevated
  } = token;
  return [{
    [componentCls]: {
      position: 'absolute',
      top: -9999,
      left: {
        _skip_check_: true,
        value: -9999
      },
      zIndex: zIndexPopup,
      display: 'block',
      // A placeholder out of dropdown visible range to avoid close when user moving
      '&::before': {
        position: 'absolute',
        insetBlock: token.calc(sizePopupArrow).div(2).sub(dropdownArrowDistance).equal(),
        // insetInlineStart: -7, // FIXME: Seems not work for hidden element
        zIndex: -9999,
        opacity: 0.0001,
        content: '""'
      },
      // Makes vertical dropdowns have a scrollbar once they become taller than the viewport.
      '&-menu-vertical': {
        maxHeight: '100vh',
        overflowY: 'auto'
      },
      [`&-trigger${antCls}-btn`]: {
        [`& > ${iconCls}-down, & > ${antCls}-btn-icon > ${iconCls}-down`]: {
          fontSize: fontSizeIcon
        }
      },
      [`${componentCls}-wrap`]: {
        position: 'relative',
        [`${antCls}-btn > ${iconCls}-down`]: {
          fontSize: fontSizeIcon
        },
        [`${iconCls}-down::before`]: {
          transition: `transform ${motionDurationMid}`
        }
      },
      [`${componentCls}-wrap-open`]: {
        [`${iconCls}-down::before`]: {
          transform: `rotate(180deg)`
        }
      },
      [`
        &-hidden,
        &-menu-hidden,
        &-menu-submenu-hidden
      `]: {
        display: 'none'
      },
      // =============================================================
      // ==                         Motion                          ==
      // =============================================================
      // When position is not enough for dropdown, the placement will revert.
      // We will handle this with revert motion name.
      [`&${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomRight,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomRight`]: {
        animationName: slideUpIn
      },
      [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-top,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-top,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topRight`]: {
        animationName: slideDownIn
      },
      [`&${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomRight`]: {
        animationName: slideUpOut
      },
      [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-top,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topRight`]: {
        animationName: slideDownOut
      }
    }
  },
  // =============================================================
  // ==                        Arrow style                      ==
  // =============================================================
  getArrowStyle(token, colorBgElevated, {
    arrowPlacement: {
      top: true,
      bottom: true
    }
  }), {
    // =============================================================
    // ==                          Menu                           ==
    // =============================================================
    [`${componentCls} ${menuCls}`]: {
      position: 'relative',
      margin: 0
    },
    [`${menuCls}-submenu-popup`]: {
      position: 'absolute',
      zIndex: zIndexPopup,
      background: 'transparent',
      boxShadow: 'none',
      transformOrigin: '0 0',
      'ul, li': {
        listStyle: 'none',
        margin: 0
      }
    },
    [`${componentCls}, ${componentCls}-menu-submenu`]: Object.assign(Object.assign({}, resetComponent(token)), {
      [menuCls]: Object.assign(Object.assign({
        padding: dropdownEdgeChildPadding,
        listStyleType: 'none',
        backgroundColor: colorBgElevated,
        backgroundClip: 'padding-box',
        borderRadius: token.borderRadiusLG,
        outline: 'none',
        boxShadow: token.boxShadowSecondary
      }, genFocusStyle(token)), {
        '&:empty': {
          padding: 0,
          boxShadow: 'none'
        },
        [`${menuCls}-item-group-title`]: {
          padding: `${(0,cssinjs_es/* unit */.bf)(paddingBlock)} ${(0,cssinjs_es/* unit */.bf)(controlPaddingHorizontal)}`,
          color: token.colorTextDescription,
          transition: `all ${motionDurationMid}`
        },
        // ======================= Item Content =======================
        [`${menuCls}-item`]: {
          position: 'relative',
          display: 'flex',
          alignItems: 'center'
        },
        [`${menuCls}-item-icon`]: {
          minWidth: fontSize,
          marginInlineEnd: token.marginXS,
          fontSize: token.fontSizeSM
        },
        [`${menuCls}-title-content`]: {
          flex: 'auto',
          '&-with-extra': {
            display: 'inline-flex',
            alignItems: 'center',
            width: '100%'
          },
          '> a': {
            color: 'inherit',
            transition: `all ${motionDurationMid}`,
            '&:hover': {
              color: 'inherit'
            },
            '&::after': {
              position: 'absolute',
              inset: 0,
              content: '""'
            }
          },
          [`${menuCls}-item-extra`]: {
            paddingInlineStart: token.padding,
            marginInlineStart: 'auto',
            fontSize: token.fontSizeSM,
            color: token.colorTextDescription
          }
        },
        // =========================== Item ===========================
        [`${menuCls}-item, ${menuCls}-submenu-title`]: Object.assign(Object.assign({
          display: 'flex',
          margin: 0,
          padding: `${(0,cssinjs_es/* unit */.bf)(paddingBlock)} ${(0,cssinjs_es/* unit */.bf)(controlPaddingHorizontal)}`,
          color: token.colorText,
          fontWeight: 'normal',
          fontSize,
          lineHeight: token.lineHeight,
          cursor: 'pointer',
          transition: `all ${motionDurationMid}`,
          borderRadius: token.borderRadiusSM,
          '&:hover, &-active': {
            backgroundColor: token.controlItemBgHover
          }
        }, genFocusStyle(token)), {
          '&-selected': {
            color: token.colorPrimary,
            backgroundColor: token.controlItemBgActive,
            '&:hover, &-active': {
              backgroundColor: token.controlItemBgActiveHover
            }
          },
          '&-disabled': {
            color: colorTextDisabled,
            cursor: 'not-allowed',
            '&:hover': {
              color: colorTextDisabled,
              backgroundColor: colorBgElevated,
              cursor: 'not-allowed'
            },
            a: {
              pointerEvents: 'none'
            }
          },
          '&-divider': {
            height: 1,
            // By design
            margin: `${(0,cssinjs_es/* unit */.bf)(token.marginXXS)} 0`,
            overflow: 'hidden',
            lineHeight: 0,
            backgroundColor: token.colorSplit
          },
          [`${componentCls}-menu-submenu-expand-icon`]: {
            position: 'absolute',
            insetInlineEnd: token.paddingXS,
            [`${componentCls}-menu-submenu-arrow-icon`]: {
              marginInlineEnd: '0 !important',
              color: token.colorIcon,
              fontSize: fontSizeIcon,
              fontStyle: 'normal'
            }
          }
        }),
        [`${menuCls}-item-group-list`]: {
          margin: `0 ${(0,cssinjs_es/* unit */.bf)(token.marginXS)}`,
          padding: 0,
          listStyle: 'none'
        },
        [`${menuCls}-submenu-title`]: {
          paddingInlineEnd: token.calc(controlPaddingHorizontal).add(token.fontSizeSM).equal()
        },
        [`${menuCls}-submenu-vertical`]: {
          position: 'relative'
        },
        [`${menuCls}-submenu${menuCls}-submenu-disabled ${componentCls}-menu-submenu-title`]: {
          [`&, ${componentCls}-menu-submenu-arrow-icon`]: {
            color: colorTextDisabled,
            backgroundColor: colorBgElevated,
            cursor: 'not-allowed'
          }
        },
        // https://github.com/ant-design/ant-design/issues/19264
        [`${menuCls}-submenu-selected ${componentCls}-menu-submenu-title`]: {
          color: token.colorPrimary
        }
      })
    })
  },
  // Follow code may reuse in other components
  [initSlideMotion(token, 'slide-up'), initSlideMotion(token, 'slide-down'), initMoveMotion(token, 'move-up'), initMoveMotion(token, 'move-down'), initZoomMotion(token, 'zoom-big')]];
};
// ============================== Export ==============================
const dropdown_style_prepareComponentToken = token => Object.assign(Object.assign({
  zIndexPopup: token.zIndexPopupBase + 50,
  paddingBlock: (token.controlHeight - token.fontSize * token.lineHeight) / 2
}, getArrowOffsetToken({
  contentRadius: token.borderRadiusLG,
  limitVerticalRadius: true
})), getArrowToken(token));
/* harmony default export */ var dropdown_style = (genStyleHooks('Dropdown', token => {
  const {
    marginXXS,
    sizePopupArrow,
    paddingXXS,
    componentCls
  } = token;
  const dropdownToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    menuCls: `${componentCls}-menu`,
    dropdownArrowDistance: token.calc(sizePopupArrow).div(2).add(marginXXS).equal(),
    dropdownEdgeChildPadding: paddingXXS
  });
  return [dropdown_style_genBaseStyle(dropdownToken), style_status(dropdownToken)];
}, dropdown_style_prepareComponentToken, {
  resetStyle: false
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/dropdown/dropdown.js
"use client";






















const _Placements = (/* unused pure expression or super */ null && (['topLeft', 'topCenter', 'topRight', 'bottomLeft', 'bottomCenter', 'bottomRight', 'top', 'bottom']));
const Dropdown = props => {
  var _a;
  const {
    menu,
    arrow,
    prefixCls: customizePrefixCls,
    children,
    trigger,
    disabled,
    dropdownRender,
    popupRender,
    getPopupContainer,
    overlayClassName,
    rootClassName,
    overlayStyle,
    open,
    onOpenChange,
    // Deprecated
    visible,
    onVisibleChange,
    mouseEnterDelay = 0.15,
    mouseLeaveDelay = 0.1,
    autoAdjustOverflow = true,
    placement = '',
    overlay,
    transitionName,
    destroyOnHidden,
    destroyPopupOnHide
  } = props;
  const {
    getPopupContainer: getContextPopupContainer,
    getPrefixCls,
    direction,
    dropdown
  } = react.useContext(ConfigContext);
  const mergedPopupRender = popupRender || dropdownRender;
  // Warning for deprecated usage
  const warning = warning_devUseWarning('Dropdown');
  if (false) {}
  const memoTransitionName = react.useMemo(() => {
    const rootPrefixCls = getPrefixCls();
    if (transitionName !== undefined) {
      return transitionName;
    }
    if (placement.includes('top')) {
      return `${rootPrefixCls}-slide-down`;
    }
    return `${rootPrefixCls}-slide-up`;
  }, [getPrefixCls, placement, transitionName]);
  const memoPlacement = react.useMemo(() => {
    if (!placement) {
      return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    }
    if (placement.includes('Center')) {
      return placement.slice(0, placement.indexOf('Center'));
    }
    return placement;
  }, [placement, direction]);
  const prefixCls = getPrefixCls('dropdown', customizePrefixCls);
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = dropdown_style(prefixCls, rootCls);
  const [, token] = useToken();
  const child = react.Children.only(_util_isPrimitive(children) ? /*#__PURE__*/react.createElement("span", null, children) : children);
  const popupTrigger = cloneElement(child, {
    className: classnames_default()(`${prefixCls}-trigger`, {
      [`${prefixCls}-rtl`]: direction === 'rtl'
    }, child.props.className),
    disabled: (_a = child.props.disabled) !== null && _a !== void 0 ? _a : disabled
  });
  const triggerActions = disabled ? [] : trigger;
  const alignPoint = !!(triggerActions === null || triggerActions === void 0 ? void 0 : triggerActions.includes('contextMenu'));
  // =========================== Open ============================
  const [mergedOpen, setOpen] = (0,useMergedState/* default */.Z)(false, {
    value: open !== null && open !== void 0 ? open : visible
  });
  const onInnerOpenChange = (0,hooks_useEvent/* default */.Z)(nextOpen => {
    onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(nextOpen, {
      source: 'trigger'
    });
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(nextOpen);
    setOpen(nextOpen);
  });
  // =========================== Overlay ============================
  const overlayClassNameCustomized = classnames_default()(overlayClassName, rootClassName, hashId, cssVarCls, rootCls, dropdown === null || dropdown === void 0 ? void 0 : dropdown.className, {
    [`${prefixCls}-rtl`]: direction === 'rtl'
  });
  const builtinPlacements = getPlacements({
    arrowPointAtCenter: typeof arrow === 'object' && arrow.pointAtCenter,
    autoAdjustOverflow,
    offset: token.marginXXS,
    arrowWidth: arrow ? token.sizePopupArrow : 0,
    borderRadius: token.borderRadius
  });
  const onMenuClick = react.useCallback(() => {
    if ((menu === null || menu === void 0 ? void 0 : menu.selectable) && (menu === null || menu === void 0 ? void 0 : menu.multiple)) {
      return;
    }
    onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(false, {
      source: 'menu'
    });
    setOpen(false);
  }, [menu === null || menu === void 0 ? void 0 : menu.selectable, menu === null || menu === void 0 ? void 0 : menu.multiple]);
  const renderOverlay = () => {
    // rc-dropdown already can process the function of overlay, but we have check logic here.
    // So we need render the element to check and pass back to rc-dropdown.
    let overlayNode;
    if (menu === null || menu === void 0 ? void 0 : menu.items) {
      overlayNode = /*#__PURE__*/react.createElement(es_menu, Object.assign({}, menu));
    } else if (typeof overlay === 'function') {
      overlayNode = overlay();
    } else {
      overlayNode = overlay;
    }
    if (mergedPopupRender) {
      overlayNode = mergedPopupRender(overlayNode);
    }
    overlayNode = react.Children.only(typeof overlayNode === 'string' ? /*#__PURE__*/react.createElement("span", null, overlayNode) : overlayNode);
    return /*#__PURE__*/react.createElement(OverrideProvider, {
      prefixCls: `${prefixCls}-menu`,
      rootClassName: classnames_default()(cssVarCls, rootCls),
      expandIcon: /*#__PURE__*/react.createElement("span", {
        className: `${prefixCls}-menu-submenu-arrow`
      }, direction === 'rtl' ? (/*#__PURE__*/react.createElement(LeftOutlined/* default */.Z, {
        className: `${prefixCls}-menu-submenu-arrow-icon`
      })) : (/*#__PURE__*/react.createElement(RightOutlined/* default */.Z, {
        className: `${prefixCls}-menu-submenu-arrow-icon`
      }))),
      mode: "vertical",
      selectable: false,
      onClick: onMenuClick,
      validator: ({
        mode
      }) => {
        // Warning if use other mode
         false ? 0 : void 0;
      }
    }, overlayNode);
  };
  // =========================== zIndex ============================
  const [zIndex, contextZIndex] = useZIndex('Dropdown', overlayStyle === null || overlayStyle === void 0 ? void 0 : overlayStyle.zIndex);
  // ============================ Render ============================
  let renderNode = /*#__PURE__*/react.createElement(rc_dropdown_es/* default */.Z, Object.assign({
    alignPoint: alignPoint
  }, (0,omit/* default */.Z)(props, ['rootClassName']), {
    mouseEnterDelay: mouseEnterDelay,
    mouseLeaveDelay: mouseLeaveDelay,
    visible: mergedOpen,
    builtinPlacements: builtinPlacements,
    arrow: !!arrow,
    overlayClassName: overlayClassNameCustomized,
    prefixCls: prefixCls,
    getPopupContainer: getPopupContainer || getContextPopupContainer,
    transitionName: memoTransitionName,
    trigger: triggerActions,
    overlay: renderOverlay,
    placement: memoPlacement,
    onVisibleChange: onInnerOpenChange,
    overlayStyle: Object.assign(Object.assign(Object.assign({}, dropdown === null || dropdown === void 0 ? void 0 : dropdown.style), overlayStyle), {
      zIndex
    }),
    autoDestroy: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : destroyPopupOnHide
  }), popupTrigger);
  if (zIndex) {
    renderNode = /*#__PURE__*/react.createElement(zindexContext.Provider, {
      value: contextZIndex
    }, renderNode);
  }
  return wrapCSSVar(renderNode);
};
// We don't care debug panel
const dropdown_PurePanel = _util_PurePanel(Dropdown, 'align', undefined, 'dropdown', prefixCls => prefixCls);
/* istanbul ignore next */
const WrapPurePanel = props => (/*#__PURE__*/react.createElement(dropdown_PurePanel, Object.assign({}, props), /*#__PURE__*/react.createElement("span", null)));
Dropdown._InternalPanelDoNotUseOrYouWillBeFired = WrapPurePanel;
if (false) {}
/* harmony default export */ var dropdown_dropdown = (Dropdown);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/breadcrumb/BreadcrumbSeparator.js
"use client";



const BreadcrumbSeparator = ({
  children
}) => {
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('breadcrumb');
  return /*#__PURE__*/react.createElement("li", {
    className: `${prefixCls}-separator`,
    "aria-hidden": "true"
  }, children === '' ? children : children || '/');
};
BreadcrumbSeparator.__ANT_BREADCRUMB_SEPARATOR = true;
/* harmony default export */ var breadcrumb_BreadcrumbSeparator = (BreadcrumbSeparator);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/breadcrumb/useItemRender.js
"use client";

var useItemRender_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};



function getBreadcrumbName(route, params) {
  if (route.title === undefined || route.title === null) {
    return null;
  }
  const paramsKeys = Object.keys(params).join('|');
  return typeof route.title === 'object' ? route.title : String(route.title).replace(new RegExp(`:(${paramsKeys})`, 'g'), (replacement, key) => params[key] || replacement);
}
function renderItem(prefixCls, item, children, href) {
  if (children === null || children === undefined) {
    return null;
  }
  const {
      className,
      onClick
    } = item,
    restItem = useItemRender_rest(item, ["className", "onClick"]);
  const passedProps = Object.assign(Object.assign({}, (0,pickAttrs/* default */.Z)(restItem, {
    data: true,
    aria: true
  })), {
    onClick
  });
  if (href !== undefined) {
    return /*#__PURE__*/react.createElement("a", Object.assign({}, passedProps, {
      className: classnames_default()(`${prefixCls}-link`, className),
      href: href
    }), children);
  }
  return /*#__PURE__*/react.createElement("span", Object.assign({}, passedProps, {
    className: classnames_default()(`${prefixCls}-link`, className)
  }), children);
}
function useItemRender(prefixCls, itemRender) {
  const mergedItemRender = (item, params, routes, path, href) => {
    if (itemRender) {
      return itemRender(item, params, routes, path);
    }
    const name = getBreadcrumbName(item, params);
    return renderItem(prefixCls, item, name, href);
  };
  return mergedItemRender;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/breadcrumb/BreadcrumbItem.js
"use client";

var BreadcrumbItem_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







const InternalBreadcrumbItem = props => {
  const {
    prefixCls,
    separator = '/',
    children,
    menu,
    overlay,
    dropdownProps,
    href
  } = props;
  // Warning for deprecated usage
  if (false) {}
  /** If overlay is have Wrap a Dropdown */
  const renderBreadcrumbNode = breadcrumbItem => {
    if (menu || overlay) {
      const mergeDropDownProps = Object.assign({}, dropdownProps);
      if (menu) {
        const _a = menu || {},
          {
            items
          } = _a,
          menuProps = BreadcrumbItem_rest(_a, ["items"]);
        mergeDropDownProps.menu = Object.assign(Object.assign({}, menuProps), {
          items: items === null || items === void 0 ? void 0 : items.map((_a, index) => {
            var {
                key,
                title,
                label,
                path
              } = _a,
              itemProps = BreadcrumbItem_rest(_a, ["key", "title", "label", "path"]);
            let mergedLabel = label !== null && label !== void 0 ? label : title;
            if (path) {
              mergedLabel = /*#__PURE__*/react.createElement("a", {
                href: `${href}${path}`
              }, mergedLabel);
            }
            return Object.assign(Object.assign({}, itemProps), {
              key: key !== null && key !== void 0 ? key : index,
              label: mergedLabel
            });
          })
        });
      } else if (overlay) {
        mergeDropDownProps.overlay = overlay;
      }
      return /*#__PURE__*/react.createElement(dropdown_dropdown, Object.assign({
        placement: "bottom"
      }, mergeDropDownProps), /*#__PURE__*/react.createElement("span", {
        className: `${prefixCls}-overlay-link`
      }, breadcrumbItem, /*#__PURE__*/react.createElement(DownOutlined/* default */.Z, null)));
    }
    return breadcrumbItem;
  };
  // wrap to dropDown
  const link = renderBreadcrumbNode(children);
  if (link !== undefined && link !== null) {
    return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("li", null, link), separator && /*#__PURE__*/react.createElement(breadcrumb_BreadcrumbSeparator, null, separator));
  }
  return null;
};
const BreadcrumbItem = props => {
  const {
      prefixCls: customizePrefixCls,
      children,
      href
    } = props,
    restProps = BreadcrumbItem_rest(props, ["prefixCls", "children", "href"]);
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
  return /*#__PURE__*/react.createElement(InternalBreadcrumbItem, Object.assign({}, restProps, {
    prefixCls: prefixCls
  }), renderItem(prefixCls, restProps, children, href));
};
BreadcrumbItem.__ANT_BREADCRUMB_ITEM = true;
/* harmony default export */ var breadcrumb_BreadcrumbItem = (BreadcrumbItem);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/breadcrumb/style/index.js



const genBreadcrumbStyle = token => {
  const {
    componentCls,
    iconCls,
    calc
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      color: token.itemColor,
      fontSize: token.fontSize,
      [iconCls]: {
        fontSize: token.iconFontSize
      },
      ol: {
        display: 'flex',
        flexWrap: 'wrap',
        margin: 0,
        padding: 0,
        listStyle: 'none'
      },
      a: Object.assign({
        color: token.linkColor,
        transition: `color ${token.motionDurationMid}`,
        padding: `0 ${(0,cssinjs_es/* unit */.bf)(token.paddingXXS)}`,
        borderRadius: token.borderRadiusSM,
        height: token.fontHeight,
        display: 'inline-block',
        marginInline: calc(token.marginXXS).mul(-1).equal(),
        '&:hover': {
          color: token.linkHoverColor,
          backgroundColor: token.colorBgTextHover
        }
      }, genFocusStyle(token)),
      'li:last-child': {
        color: token.lastItemColor
      },
      [`${componentCls}-separator`]: {
        marginInline: token.separatorMargin,
        color: token.separatorColor
      },
      [`${componentCls}-link`]: {
        [`
          > ${iconCls} + span,
          > ${iconCls} + a
        `]: {
          marginInlineStart: token.marginXXS
        }
      },
      [`${componentCls}-overlay-link`]: {
        borderRadius: token.borderRadiusSM,
        height: token.fontHeight,
        display: 'inline-block',
        padding: `0 ${(0,cssinjs_es/* unit */.bf)(token.paddingXXS)}`,
        marginInline: calc(token.marginXXS).mul(-1).equal(),
        [`> ${iconCls}`]: {
          marginInlineStart: token.marginXXS,
          fontSize: token.fontSizeIcon
        },
        '&:hover': {
          color: token.linkHoverColor,
          backgroundColor: token.colorBgTextHover,
          a: {
            color: token.linkHoverColor
          }
        },
        a: {
          '&:hover': {
            backgroundColor: 'transparent'
          }
        }
      },
      // rtl style
      [`&${token.componentCls}-rtl`]: {
        direction: 'rtl'
      }
    })
  };
};
const breadcrumb_style_prepareComponentToken = token => ({
  itemColor: token.colorTextDescription,
  lastItemColor: token.colorText,
  iconFontSize: token.fontSize,
  linkColor: token.colorTextDescription,
  linkHoverColor: token.colorText,
  separatorColor: token.colorTextDescription,
  separatorMargin: token.marginXS
});
// ============================== Export ==============================
/* harmony default export */ var breadcrumb_style = (genStyleHooks('Breadcrumb', token => {
  const breadcrumbToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {});
  return genBreadcrumbStyle(breadcrumbToken);
}, breadcrumb_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/breadcrumb/useItems.js
var useItems_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

function route2item(route) {
  const {
      breadcrumbName,
      children
    } = route,
    rest = useItems_rest(route, ["breadcrumbName", "children"]);
  const clone = Object.assign({
    title: breadcrumbName
  }, rest);
  if (children) {
    clone.menu = {
      items: children.map(_a => {
        var {
            breadcrumbName: itemBreadcrumbName
          } = _a,
          itemProps = useItems_rest(_a, ["breadcrumbName"]);
        return Object.assign(Object.assign({}, itemProps), {
          title: itemBreadcrumbName
        });
      })
    };
  }
  return clone;
}
function useItems(items, routes) {
  return (0,react.useMemo)(() => {
    if (items) {
      return items;
    }
    if (routes) {
      return routes.map(route2item);
    }
    return null;
  }, [items, routes]);
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/breadcrumb/Breadcrumb.js
"use client";

var Breadcrumb_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};












const getPath = (params, path) => {
  if (path === undefined) {
    return path;
  }
  let mergedPath = (path || '').replace(/^\//, '');
  Object.keys(params).forEach(key => {
    mergedPath = mergedPath.replace(`:${key}`, params[key]);
  });
  return mergedPath;
};
const Breadcrumb = props => {
  const {
      prefixCls: customizePrefixCls,
      separator = '/',
      style,
      className,
      rootClassName,
      routes: legacyRoutes,
      items,
      children,
      itemRender,
      params = {}
    } = props,
    restProps = Breadcrumb_rest(props, ["prefixCls", "separator", "style", "className", "rootClassName", "routes", "items", "children", "itemRender", "params"]);
  const {
    getPrefixCls,
    direction,
    breadcrumb
  } = react.useContext(ConfigContext);
  let crumbs;
  const prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = breadcrumb_style(prefixCls);
  const mergedItems = useItems(items, legacyRoutes);
  if (false) {}
  const mergedItemRender = useItemRender(prefixCls, itemRender);
  if (mergedItems && mergedItems.length > 0) {
    // generated by route
    const paths = [];
    const itemRenderRoutes = items || legacyRoutes;
    crumbs = mergedItems.map((item, index) => {
      const {
        path,
        key,
        type,
        menu,
        overlay,
        onClick,
        className: itemClassName,
        separator: itemSeparator,
        dropdownProps
      } = item;
      const mergedPath = getPath(params, path);
      if (mergedPath !== undefined) {
        paths.push(mergedPath);
      }
      const mergedKey = key !== null && key !== void 0 ? key : index;
      if (type === 'separator') {
        return /*#__PURE__*/react.createElement(breadcrumb_BreadcrumbSeparator, {
          key: mergedKey
        }, itemSeparator);
      }
      const itemProps = {};
      const isLastItem = index === mergedItems.length - 1;
      if (menu) {
        itemProps.menu = menu;
      } else if (overlay) {
        itemProps.overlay = overlay;
      }
      let {
        href
      } = item;
      if (paths.length && mergedPath !== undefined) {
        href = `#/${paths.join('/')}`;
      }
      return /*#__PURE__*/react.createElement(InternalBreadcrumbItem, Object.assign({
        key: mergedKey
      }, itemProps, (0,pickAttrs/* default */.Z)(item, {
        data: true,
        aria: true
      }), {
        className: itemClassName,
        dropdownProps: dropdownProps,
        href: href,
        separator: isLastItem ? '' : separator,
        onClick: onClick,
        prefixCls: prefixCls
      }), mergedItemRender(item, params, itemRenderRoutes, paths, href));
    });
  } else if (children) {
    const childrenLength = (0,Children_toArray/* default */.Z)(children).length;
    crumbs = (0,Children_toArray/* default */.Z)(children).map((element, index) => {
      if (!element) {
        return element;
      }
      const isLastItem = index === childrenLength - 1;
      return cloneElement(element, {
        separator: isLastItem ? '' : separator,
        // eslint-disable-next-line react/no-array-index-key
        key: index
      });
    });
  }
  const breadcrumbClassName = classnames_default()(prefixCls, breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.className, {
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, className, rootClassName, hashId, cssVarCls);
  const mergedStyle = Object.assign(Object.assign({}, breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.style), style);
  return wrapCSSVar(/*#__PURE__*/react.createElement("nav", Object.assign({
    className: breadcrumbClassName,
    style: mergedStyle
  }, restProps), /*#__PURE__*/react.createElement("ol", null, crumbs)));
};
Breadcrumb.Item = breadcrumb_BreadcrumbItem;
Breadcrumb.Separator = breadcrumb_BreadcrumbSeparator;
if (false) {}
/* harmony default export */ var breadcrumb_Breadcrumb = (Breadcrumb);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/breadcrumb/index.js
"use client";


/* harmony default export */ var breadcrumb = (breadcrumb_Breadcrumb);
// EXTERNAL MODULE: ./node_modules/rc-picker/es/generate/dayjs.js
var dayjs = __webpack_require__(5641);
// EXTERNAL MODULE: ./node_modules/rc-picker/es/index.js + 60 modules
var rc_picker_es = __webpack_require__(95953);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useId.js
var hooks_useId = __webpack_require__(73208);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/radio/context.js

const RadioGroupContext = /*#__PURE__*/react.createContext(null);
const RadioGroupContextProvider = RadioGroupContext.Provider;
/* harmony default export */ var radio_context = (RadioGroupContext);
const RadioOptionTypeContext = /*#__PURE__*/react.createContext(null);
const RadioOptionTypeContextProvider = RadioOptionTypeContext.Provider;
// EXTERNAL MODULE: ./node_modules/rc-checkbox/es/index.js
var rc_checkbox_es = __webpack_require__(9378);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/checkbox/useBubbleLock.js


/**
 * When click on the label,
 * the event will be stopped to prevent the label from being clicked twice.
 * label click -> input click -> label click again
 */
function useBubbleLock(onOriginInputClick) {
  const labelClickLockRef = react.useRef(null);
  const clearLock = () => {
    raf/* default.cancel */.Z.cancel(labelClickLockRef.current);
    labelClickLockRef.current = null;
  };
  const onLabelClick = () => {
    clearLock();
    labelClickLockRef.current = (0,raf/* default */.Z)(() => {
      labelClickLockRef.current = null;
    });
  };
  const onInputClick = e => {
    if (labelClickLockRef.current) {
      e.stopPropagation();
      clearLock();
    }
    onOriginInputClick === null || onOriginInputClick === void 0 ? void 0 : onOriginInputClick(e);
  };
  return [onLabelClick, onInputClick];
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/radio/style/index.js



// ============================== Styles ==============================
// styles from RadioGroup only
const getGroupRadioStyle = token => {
  const {
    componentCls,
    antCls
  } = token;
  const groupPrefixCls = `${componentCls}-group`;
  return {
    [groupPrefixCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      display: 'inline-block',
      fontSize: 0,
      // RTL
      [`&${groupPrefixCls}-rtl`]: {
        direction: 'rtl'
      },
      [`&${groupPrefixCls}-block`]: {
        display: 'flex'
      },
      [`${antCls}-badge ${antCls}-badge-count`]: {
        zIndex: 1
      },
      [`> ${antCls}-badge:not(:first-child) > ${antCls}-button-wrapper`]: {
        borderInlineStart: 'none'
      }
    })
  };
};
// Styles from radio-wrapper
const getRadioBasicStyle = token => {
  const {
    componentCls,
    wrapperMarginInlineEnd,
    colorPrimary,
    radioSize,
    motionDurationSlow,
    motionDurationMid,
    motionEaseInOutCirc,
    colorBgContainer,
    colorBorder,
    lineWidth,
    colorBgContainerDisabled,
    colorTextDisabled,
    paddingXS,
    dotColorDisabled,
    lineType,
    radioColor,
    radioBgColor,
    calc
  } = token;
  const radioInnerPrefixCls = `${componentCls}-inner`;
  const dotPadding = 4;
  const radioDotDisabledSize = calc(radioSize).sub(calc(dotPadding).mul(2));
  const radioSizeCalc = calc(1).mul(radioSize).equal({
    unit: true
  });
  return {
    [`${componentCls}-wrapper`]: Object.assign(Object.assign({}, resetComponent(token)), {
      display: 'inline-flex',
      alignItems: 'baseline',
      marginInlineStart: 0,
      marginInlineEnd: wrapperMarginInlineEnd,
      cursor: 'pointer',
      '&:last-child': {
        marginInlineEnd: 0
      },
      // RTL
      [`&${componentCls}-wrapper-rtl`]: {
        direction: 'rtl'
      },
      '&-disabled': {
        cursor: 'not-allowed',
        color: token.colorTextDisabled
      },
      '&::after': {
        display: 'inline-block',
        width: 0,
        overflow: 'hidden',
        content: '"\\a0"'
      },
      '&-block': {
        flex: 1,
        justifyContent: 'center'
      },
      // hashId 在 wrapper 上，只能铺平
      [`${componentCls}-checked::after`]: {
        position: 'absolute',
        insetBlockStart: 0,
        insetInlineStart: 0,
        width: '100%',
        height: '100%',
        border: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${colorPrimary}`,
        borderRadius: '50%',
        visibility: 'hidden',
        opacity: 0,
        content: '""'
      },
      [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
        position: 'relative',
        display: 'inline-block',
        outline: 'none',
        cursor: 'pointer',
        alignSelf: 'center',
        borderRadius: '50%'
      }),
      [`${componentCls}-wrapper:hover &,
        &:hover ${radioInnerPrefixCls}`]: {
        borderColor: colorPrimary
      },
      [`${componentCls}-input:focus-visible + ${radioInnerPrefixCls}`]: genFocusOutline(token),
      [`${componentCls}:hover::after, ${componentCls}-wrapper:hover &::after`]: {
        visibility: 'visible'
      },
      [`${componentCls}-inner`]: {
        '&::after': {
          boxSizing: 'border-box',
          position: 'absolute',
          insetBlockStart: '50%',
          insetInlineStart: '50%',
          display: 'block',
          width: radioSizeCalc,
          height: radioSizeCalc,
          marginBlockStart: calc(1).mul(radioSize).div(-2).equal({
            unit: true
          }),
          marginInlineStart: calc(1).mul(radioSize).div(-2).equal({
            unit: true
          }),
          backgroundColor: radioColor,
          borderBlockStart: 0,
          borderInlineStart: 0,
          borderRadius: radioSizeCalc,
          transform: 'scale(0)',
          opacity: 0,
          transition: `all ${motionDurationSlow} ${motionEaseInOutCirc}`,
          content: '""'
        },
        boxSizing: 'border-box',
        position: 'relative',
        insetBlockStart: 0,
        insetInlineStart: 0,
        display: 'block',
        width: radioSizeCalc,
        height: radioSizeCalc,
        backgroundColor: colorBgContainer,
        borderColor: colorBorder,
        borderStyle: 'solid',
        borderWidth: lineWidth,
        borderRadius: '50%',
        transition: `all ${motionDurationMid}`
      },
      [`${componentCls}-input`]: {
        position: 'absolute',
        inset: 0,
        zIndex: 1,
        cursor: 'pointer',
        opacity: 0
      },
      // 选中状态
      [`${componentCls}-checked`]: {
        [radioInnerPrefixCls]: {
          borderColor: colorPrimary,
          backgroundColor: radioBgColor,
          '&::after': {
            transform: `scale(${token.calc(token.dotSize).div(radioSize).equal()})`,
            opacity: 1,
            transition: `all ${motionDurationSlow} ${motionEaseInOutCirc}`
          }
        }
      },
      [`${componentCls}-disabled`]: {
        cursor: 'not-allowed',
        [radioInnerPrefixCls]: {
          backgroundColor: colorBgContainerDisabled,
          borderColor: colorBorder,
          cursor: 'not-allowed',
          '&::after': {
            backgroundColor: dotColorDisabled
          }
        },
        [`${componentCls}-input`]: {
          cursor: 'not-allowed'
        },
        [`${componentCls}-disabled + span`]: {
          color: colorTextDisabled,
          cursor: 'not-allowed'
        },
        [`&${componentCls}-checked`]: {
          [radioInnerPrefixCls]: {
            '&::after': {
              transform: `scale(${calc(radioDotDisabledSize).div(radioSize).equal()})`
            }
          }
        }
      },
      [`span${componentCls} + *`]: {
        paddingInlineStart: paddingXS,
        paddingInlineEnd: paddingXS
      }
    })
  };
};
// Styles from radio-button
const getRadioButtonStyle = token => {
  const {
    buttonColor,
    controlHeight,
    componentCls,
    lineWidth,
    lineType,
    colorBorder,
    motionDurationSlow,
    motionDurationMid,
    buttonPaddingInline,
    fontSize,
    buttonBg,
    fontSizeLG,
    controlHeightLG,
    controlHeightSM,
    paddingXS,
    borderRadius,
    borderRadiusSM,
    borderRadiusLG,
    buttonCheckedBg,
    buttonSolidCheckedColor,
    colorTextDisabled,
    colorBgContainerDisabled,
    buttonCheckedBgDisabled,
    buttonCheckedColorDisabled,
    colorPrimary,
    colorPrimaryHover,
    colorPrimaryActive,
    buttonSolidCheckedBg,
    buttonSolidCheckedHoverBg,
    buttonSolidCheckedActiveBg,
    calc
  } = token;
  return {
    [`${componentCls}-button-wrapper`]: {
      position: 'relative',
      display: 'inline-block',
      height: controlHeight,
      margin: 0,
      paddingInline: buttonPaddingInline,
      paddingBlock: 0,
      color: buttonColor,
      fontSize,
      lineHeight: (0,cssinjs_es/* unit */.bf)(calc(controlHeight).sub(calc(lineWidth).mul(2)).equal()),
      background: buttonBg,
      border: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${colorBorder}`,
      // strange align fix for chrome but works
      // https://gw.alipayobjects.com/zos/rmsportal/VFTfKXJuogBAXcvfAUWJ.gif
      borderBlockStartWidth: calc(lineWidth).add(0.02).equal(),
      borderInlineStartWidth: 0,
      borderInlineEndWidth: lineWidth,
      cursor: 'pointer',
      transition: [`color ${motionDurationMid}`, `background ${motionDurationMid}`, `box-shadow ${motionDurationMid}`].join(','),
      a: {
        color: buttonColor
      },
      [`> ${componentCls}-button`]: {
        position: 'absolute',
        insetBlockStart: 0,
        insetInlineStart: 0,
        zIndex: -1,
        width: '100%',
        height: '100%'
      },
      '&:not(:first-child)': {
        '&::before': {
          position: 'absolute',
          insetBlockStart: calc(lineWidth).mul(-1).equal(),
          insetInlineStart: calc(lineWidth).mul(-1).equal(),
          display: 'block',
          boxSizing: 'content-box',
          width: 1,
          height: '100%',
          paddingBlock: lineWidth,
          paddingInline: 0,
          backgroundColor: colorBorder,
          transition: `background-color ${motionDurationSlow}`,
          content: '""'
        }
      },
      '&:first-child': {
        borderInlineStart: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${colorBorder}`,
        borderStartStartRadius: borderRadius,
        borderEndStartRadius: borderRadius
      },
      '&:last-child': {
        borderStartEndRadius: borderRadius,
        borderEndEndRadius: borderRadius
      },
      '&:first-child:last-child': {
        borderRadius
      },
      [`${componentCls}-group-large &`]: {
        height: controlHeightLG,
        fontSize: fontSizeLG,
        lineHeight: (0,cssinjs_es/* unit */.bf)(calc(controlHeightLG).sub(calc(lineWidth).mul(2)).equal()),
        '&:first-child': {
          borderStartStartRadius: borderRadiusLG,
          borderEndStartRadius: borderRadiusLG
        },
        '&:last-child': {
          borderStartEndRadius: borderRadiusLG,
          borderEndEndRadius: borderRadiusLG
        }
      },
      [`${componentCls}-group-small &`]: {
        height: controlHeightSM,
        paddingInline: calc(paddingXS).sub(lineWidth).equal(),
        paddingBlock: 0,
        lineHeight: (0,cssinjs_es/* unit */.bf)(calc(controlHeightSM).sub(calc(lineWidth).mul(2)).equal()),
        '&:first-child': {
          borderStartStartRadius: borderRadiusSM,
          borderEndStartRadius: borderRadiusSM
        },
        '&:last-child': {
          borderStartEndRadius: borderRadiusSM,
          borderEndEndRadius: borderRadiusSM
        }
      },
      '&:hover': {
        position: 'relative',
        color: colorPrimary
      },
      '&:has(:focus-visible)': genFocusOutline(token),
      [`${componentCls}-inner, input[type='checkbox'], input[type='radio']`]: {
        width: 0,
        height: 0,
        opacity: 0,
        pointerEvents: 'none'
      },
      [`&-checked:not(${componentCls}-button-wrapper-disabled)`]: {
        zIndex: 1,
        color: colorPrimary,
        background: buttonCheckedBg,
        borderColor: colorPrimary,
        '&::before': {
          backgroundColor: colorPrimary
        },
        '&:first-child': {
          borderColor: colorPrimary
        },
        '&:hover': {
          color: colorPrimaryHover,
          borderColor: colorPrimaryHover,
          '&::before': {
            backgroundColor: colorPrimaryHover
          }
        },
        '&:active': {
          color: colorPrimaryActive,
          borderColor: colorPrimaryActive,
          '&::before': {
            backgroundColor: colorPrimaryActive
          }
        }
      },
      [`${componentCls}-group-solid &-checked:not(${componentCls}-button-wrapper-disabled)`]: {
        color: buttonSolidCheckedColor,
        background: buttonSolidCheckedBg,
        borderColor: buttonSolidCheckedBg,
        '&:hover': {
          color: buttonSolidCheckedColor,
          background: buttonSolidCheckedHoverBg,
          borderColor: buttonSolidCheckedHoverBg
        },
        '&:active': {
          color: buttonSolidCheckedColor,
          background: buttonSolidCheckedActiveBg,
          borderColor: buttonSolidCheckedActiveBg
        }
      },
      '&-disabled': {
        color: colorTextDisabled,
        backgroundColor: colorBgContainerDisabled,
        borderColor: colorBorder,
        cursor: 'not-allowed',
        '&:first-child, &:hover': {
          color: colorTextDisabled,
          backgroundColor: colorBgContainerDisabled,
          borderColor: colorBorder
        }
      },
      [`&-disabled${componentCls}-button-wrapper-checked`]: {
        color: buttonCheckedColorDisabled,
        backgroundColor: buttonCheckedBgDisabled,
        borderColor: colorBorder,
        boxShadow: 'none'
      },
      '&-block': {
        flex: 1,
        textAlign: 'center'
      }
    }
  };
};
// ============================== Export ==============================
const radio_style_prepareComponentToken = token => {
  const {
    wireframe,
    padding,
    marginXS,
    lineWidth,
    fontSizeLG,
    colorText,
    colorBgContainer,
    colorTextDisabled,
    controlItemBgActiveDisabled,
    colorTextLightSolid,
    colorPrimary,
    colorPrimaryHover,
    colorPrimaryActive,
    colorWhite
  } = token;
  const dotPadding = 4; // Fixed value
  const radioSize = fontSizeLG;
  const radioDotSize = wireframe ? radioSize - dotPadding * 2 : radioSize - (dotPadding + lineWidth) * 2;
  return {
    // Radio
    radioSize,
    dotSize: radioDotSize,
    dotColorDisabled: colorTextDisabled,
    // Radio buttons
    buttonSolidCheckedColor: colorTextLightSolid,
    buttonSolidCheckedBg: colorPrimary,
    buttonSolidCheckedHoverBg: colorPrimaryHover,
    buttonSolidCheckedActiveBg: colorPrimaryActive,
    buttonBg: colorBgContainer,
    buttonCheckedBg: colorBgContainer,
    buttonColor: colorText,
    buttonCheckedBgDisabled: controlItemBgActiveDisabled,
    buttonCheckedColorDisabled: colorTextDisabled,
    buttonPaddingInline: padding - lineWidth,
    wrapperMarginInlineEnd: marginXS,
    // internal
    radioColor: wireframe ? colorPrimary : colorWhite,
    radioBgColor: wireframe ? colorBgContainer : colorPrimary
  };
};
/* harmony default export */ var radio_style = (genStyleHooks('Radio', token => {
  const {
    controlOutline,
    controlOutlineWidth
  } = token;
  const radioFocusShadow = `0 0 0 ${(0,cssinjs_es/* unit */.bf)(controlOutlineWidth)} ${controlOutline}`;
  const radioButtonFocusShadow = radioFocusShadow;
  const radioToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    radioFocusShadow,
    radioButtonFocusShadow
  });
  return [getGroupRadioStyle(radioToken), getRadioBasicStyle(radioToken), getRadioButtonStyle(radioToken)];
}, radio_style_prepareComponentToken, {
  unitless: {
    radioSize: true,
    dotSize: true
  }
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/radio/radio.js
"use client";

var radio_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};














const InternalRadio = (props, ref) => {
  var _a, _b;
  const groupContext = react.useContext(radio_context);
  const radioOptionTypeContext = react.useContext(RadioOptionTypeContext);
  const {
    getPrefixCls,
    direction,
    radio
  } = react.useContext(ConfigContext);
  const innerRef = react.useRef(null);
  const mergedRef = (0,es_ref/* composeRef */.sQ)(ref, innerRef);
  const {
    isFormItemInput
  } = react.useContext(FormItemInputContext);
  if (false) {}
  const onChange = e => {
    var _a, _b;
    (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e);
    (_b = groupContext === null || groupContext === void 0 ? void 0 : groupContext.onChange) === null || _b === void 0 ? void 0 : _b.call(groupContext, e);
  };
  const {
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      children,
      style,
      title
    } = props,
    restProps = radio_rest(props, ["prefixCls", "className", "rootClassName", "children", "style", "title"]);
  const radioPrefixCls = getPrefixCls('radio', customizePrefixCls);
  const isButtonType = ((groupContext === null || groupContext === void 0 ? void 0 : groupContext.optionType) || radioOptionTypeContext) === 'button';
  const prefixCls = isButtonType ? `${radioPrefixCls}-button` : radioPrefixCls;
  // Style
  const rootCls = hooks_useCSSVarCls(radioPrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = radio_style(radioPrefixCls, rootCls);
  const radioProps = Object.assign({}, restProps);
  // ===================== Disabled =====================
  const disabled = react.useContext(config_provider_DisabledContext);
  if (groupContext) {
    radioProps.name = groupContext.name;
    radioProps.onChange = onChange;
    radioProps.checked = props.value === groupContext.value;
    radioProps.disabled = (_a = radioProps.disabled) !== null && _a !== void 0 ? _a : groupContext.disabled;
  }
  radioProps.disabled = (_b = radioProps.disabled) !== null && _b !== void 0 ? _b : disabled;
  const wrapperClassString = classnames_default()(`${prefixCls}-wrapper`, {
    [`${prefixCls}-wrapper-checked`]: radioProps.checked,
    [`${prefixCls}-wrapper-disabled`]: radioProps.disabled,
    [`${prefixCls}-wrapper-rtl`]: direction === 'rtl',
    [`${prefixCls}-wrapper-in-form-item`]: isFormItemInput,
    [`${prefixCls}-wrapper-block`]: !!(groupContext === null || groupContext === void 0 ? void 0 : groupContext.block)
  }, radio === null || radio === void 0 ? void 0 : radio.className, className, rootClassName, hashId, cssVarCls, rootCls);
  // ============================ Event Lock ============================
  const [onLabelClick, onInputClick] = useBubbleLock(radioProps.onClick);
  // ============================== Render ==============================
  return wrapCSSVar(/*#__PURE__*/react.createElement(wave, {
    component: "Radio",
    disabled: radioProps.disabled
  }, /*#__PURE__*/react.createElement("label", {
    className: wrapperClassString,
    style: Object.assign(Object.assign({}, radio === null || radio === void 0 ? void 0 : radio.style), style),
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    title: title,
    onClick: onLabelClick
  }, /*#__PURE__*/react.createElement(rc_checkbox_es/* default */.Z, Object.assign({}, radioProps, {
    className: classnames_default()(radioProps.className, {
      [TARGET_CLS]: !isButtonType
    }),
    type: "radio",
    prefixCls: prefixCls,
    ref: mergedRef,
    onClick: onInputClick
  })), children !== undefined ? /*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-label`
  }, children) : null)));
};
const Radio = /*#__PURE__*/react.forwardRef(InternalRadio);
if (false) {}
/* harmony default export */ var radio_radio = (Radio);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/findDOMNode.js
var Dom_findDOMNode = __webpack_require__(33970);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/util.js
// form item name black list.  in form ,you can use form.id get the form item element.
// use object hasOwnProperty will get better performance if black list is longer.
const formItemNameBlackList = ['parentNode'];
// default form item id prefix.
const defaultItemNamePrefixCls = 'form_item';
function util_toArray(candidate) {
  if (candidate === undefined || candidate === false) return [];
  return Array.isArray(candidate) ? candidate : [candidate];
}
function getFieldId(namePath, formName) {
  if (!namePath.length) {
    return undefined;
  }
  const mergedId = namePath.join('_');
  if (formName) {
    return `${formName}_${mergedId}`;
  }
  const isIllegalName = formItemNameBlackList.includes(mergedId);
  return isIllegalName ? `${defaultItemNamePrefixCls}_${mergedId}` : mergedId;
}
/**
 * Get merged status by meta or passed `validateStatus`.
 */
function getStatus(errors, warnings, meta, defaultValidateStatus, hasFeedback, validateStatus) {
  let status = defaultValidateStatus;
  if (validateStatus !== undefined) {
    status = validateStatus;
  } else if (meta.validating) {
    status = 'validating';
  } else if (errors.length) {
    status = 'error';
  } else if (warnings.length) {
    status = 'warning';
  } else if (meta.touched || hasFeedback && meta.validated) {
    // success feedback should display when pass hasFeedback prop and current value is valid value
    status = 'success';
  }
  return status;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/hooks/useForm.js
var useForm_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





function toNamePathStr(name) {
  const namePath = util_toArray(name);
  return namePath.join('_');
}
function getFieldDOMNode(name, wrapForm) {
  const field = wrapForm.getFieldInstance(name);
  const fieldDom = (0,Dom_findDOMNode/* getDOM */.bn)(field);
  if (fieldDom) {
    return fieldDom;
  }
  const fieldId = getFieldId(util_toArray(name), wrapForm.__INTERNAL__.name);
  if (fieldId) {
    return document.getElementById(fieldId);
  }
}
function useForm(form) {
  const [rcForm] = (0,rc_field_form_es/* useForm */.cI)();
  const itemsRef = react.useRef({});
  const wrapForm = react.useMemo(() => form !== null && form !== void 0 ? form : Object.assign(Object.assign({}, rcForm), {
    __INTERNAL__: {
      itemRef: name => node => {
        const namePathStr = toNamePathStr(name);
        if (node) {
          itemsRef.current[namePathStr] = node;
        } else {
          delete itemsRef.current[namePathStr];
        }
      }
    },
    scrollToField: (name, options = {}) => {
      const {
          focus
        } = options,
        restOpt = useForm_rest(options, ["focus"]);
      const node = getFieldDOMNode(name, wrapForm);
      if (node) {
        dist_e(node, Object.assign({
          scrollMode: 'if-needed',
          block: 'nearest'
        }, restOpt));
        // Focus if scroll success
        if (focus) {
          wrapForm.focusField(name);
        }
      }
    },
    focusField: name => {
      var _a, _b;
      const itemRef = wrapForm.getFieldInstance(name);
      if (typeof (itemRef === null || itemRef === void 0 ? void 0 : itemRef.focus) === 'function') {
        itemRef.focus();
      } else {
        (_b = (_a = getFieldDOMNode(name, wrapForm)) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
      }
    },
    getFieldInstance: name => {
      const namePathStr = toNamePathStr(name);
      return itemsRef.current[namePathStr];
    }
  }), [form, rcForm]);
  return [wrapForm];
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/radio/group.js
"use client";














const RadioGroup = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    getPrefixCls,
    direction
  } = react.useContext(ConfigContext);
  const {
    name: formItemName
  } = react.useContext(FormItemInputContext);
  const defaultName = (0,hooks_useId/* default */.Z)(toNamePathStr(formItemName));
  const {
    prefixCls: customizePrefixCls,
    className,
    rootClassName,
    options,
    buttonStyle = 'outline',
    disabled,
    children,
    size: customizeSize,
    style,
    id,
    optionType,
    name = defaultName,
    defaultValue,
    value: customizedValue,
    block = false,
    onChange,
    onMouseEnter,
    onMouseLeave,
    onFocus,
    onBlur
  } = props;
  const [value, setValue] = (0,useMergedState/* default */.Z)(defaultValue, {
    value: customizedValue
  });
  const onRadioChange = react.useCallback(event => {
    const lastValue = value;
    const val = event.target.value;
    if (!('value' in props)) {
      setValue(val);
    }
    if (val !== lastValue) {
      onChange === null || onChange === void 0 ? void 0 : onChange(event);
    }
  }, [value, setValue, onChange]);
  const prefixCls = getPrefixCls('radio', customizePrefixCls);
  const groupPrefixCls = `${prefixCls}-group`;
  // Style
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = radio_style(prefixCls, rootCls);
  let childrenToRender = children;
  // 如果存在 options, 优先使用
  if (options && options.length > 0) {
    childrenToRender = options.map(option => {
      if (typeof option === 'string' || typeof option === 'number') {
        // 此处类型自动推导为 string
        return /*#__PURE__*/react.createElement(radio_radio, {
          key: option.toString(),
          prefixCls: prefixCls,
          disabled: disabled,
          value: option,
          checked: value === option
        }, option);
      }
      // 此处类型自动推导为 { label: string value: string }
      return /*#__PURE__*/react.createElement(radio_radio, {
        key: `radio-group-value-options-${option.value}`,
        prefixCls: prefixCls,
        disabled: option.disabled || disabled,
        value: option.value,
        checked: value === option.value,
        title: option.title,
        style: option.style,
        className: option.className,
        id: option.id,
        required: option.required
      }, option.label);
    });
  }
  const mergedSize = hooks_useSize(customizeSize);
  const classString = classnames_default()(groupPrefixCls, `${groupPrefixCls}-${buttonStyle}`, {
    [`${groupPrefixCls}-${mergedSize}`]: mergedSize,
    [`${groupPrefixCls}-rtl`]: direction === 'rtl',
    [`${groupPrefixCls}-block`]: block
  }, className, rootClassName, hashId, cssVarCls, rootCls);
  const memoizedValue = react.useMemo(() => ({
    onChange: onRadioChange,
    value,
    disabled,
    name,
    optionType,
    block
  }), [onRadioChange, value, disabled, name, optionType, block]);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", Object.assign({}, (0,pickAttrs/* default */.Z)(props, {
    aria: true,
    data: true
  }), {
    className: classString,
    style: style,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onFocus: onFocus,
    onBlur: onBlur,
    id: id,
    ref: ref
  }), /*#__PURE__*/react.createElement(RadioGroupContextProvider, {
    value: memoizedValue
  }, childrenToRender)));
});
/* harmony default export */ var radio_group = (/*#__PURE__*/react.memo(RadioGroup));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/radio/radioButton.js
"use client";

var radioButton_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




const RadioButton = (props, ref) => {
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const {
      prefixCls: customizePrefixCls
    } = props,
    radioProps = radioButton_rest(props, ["prefixCls"]);
  const prefixCls = getPrefixCls('radio', customizePrefixCls);
  return /*#__PURE__*/react.createElement(RadioOptionTypeContextProvider, {
    value: "button"
  }, /*#__PURE__*/react.createElement(radio_radio, Object.assign({
    prefixCls: prefixCls
  }, radioProps, {
    type: "radio",
    ref: ref
  })));
};
/* harmony default export */ var radioButton = (/*#__PURE__*/react.forwardRef(RadioButton));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/calendar/Header.js
"use client";






const YEAR_SELECT_OFFSET = 10;
const YEAR_SELECT_TOTAL = 20;
function YearSelect(props) {
  const {
    fullscreen,
    validRange,
    generateConfig,
    locale,
    prefixCls,
    value,
    onChange,
    divRef
  } = props;
  const year = generateConfig.getYear(value || generateConfig.getNow());
  let start = year - YEAR_SELECT_OFFSET;
  let end = start + YEAR_SELECT_TOTAL;
  if (validRange) {
    start = generateConfig.getYear(validRange[0]);
    end = generateConfig.getYear(validRange[1]) + 1;
  }
  const suffix = locale && locale.year === '年' ? '年' : '';
  const options = [];
  for (let index = start; index < end; index++) {
    options.push({
      label: `${index}${suffix}`,
      value: index
    });
  }
  return /*#__PURE__*/react.createElement(es_select, {
    size: fullscreen ? undefined : 'small',
    options: options,
    value: year,
    className: `${prefixCls}-year-select`,
    onChange: numYear => {
      let newDate = generateConfig.setYear(value, numYear);
      if (validRange) {
        const [startDate, endDate] = validRange;
        const newYear = generateConfig.getYear(newDate);
        const newMonth = generateConfig.getMonth(newDate);
        if (newYear === generateConfig.getYear(endDate) && newMonth > generateConfig.getMonth(endDate)) {
          newDate = generateConfig.setMonth(newDate, generateConfig.getMonth(endDate));
        }
        if (newYear === generateConfig.getYear(startDate) && newMonth < generateConfig.getMonth(startDate)) {
          newDate = generateConfig.setMonth(newDate, generateConfig.getMonth(startDate));
        }
      }
      onChange(newDate);
    },
    getPopupContainer: () => divRef.current
  });
}
function MonthSelect(props) {
  const {
    prefixCls,
    fullscreen,
    validRange,
    value,
    generateConfig,
    locale,
    onChange,
    divRef
  } = props;
  const month = generateConfig.getMonth(value || generateConfig.getNow());
  let start = 0;
  let end = 11;
  if (validRange) {
    const [rangeStart, rangeEnd] = validRange;
    const currentYear = generateConfig.getYear(value);
    if (generateConfig.getYear(rangeEnd) === currentYear) {
      end = generateConfig.getMonth(rangeEnd);
    }
    if (generateConfig.getYear(rangeStart) === currentYear) {
      start = generateConfig.getMonth(rangeStart);
    }
  }
  const months = locale.shortMonths || generateConfig.locale.getShortMonths(locale.locale);
  const options = [];
  for (let index = start; index <= end; index += 1) {
    options.push({
      label: months[index],
      value: index
    });
  }
  return /*#__PURE__*/react.createElement(es_select, {
    size: fullscreen ? undefined : 'small',
    className: `${prefixCls}-month-select`,
    value: month,
    options: options,
    onChange: newMonth => {
      onChange(generateConfig.setMonth(value, newMonth));
    },
    getPopupContainer: () => divRef.current
  });
}
function ModeSwitch(props) {
  const {
    prefixCls,
    locale,
    mode,
    fullscreen,
    onModeChange
  } = props;
  return /*#__PURE__*/react.createElement(radio_group, {
    onChange: ({
      target: {
        value
      }
    }) => {
      onModeChange(value);
    },
    value: mode,
    size: fullscreen ? undefined : 'small',
    className: `${prefixCls}-mode-switch`
  }, /*#__PURE__*/react.createElement(radioButton, {
    value: "month"
  }, locale.month), /*#__PURE__*/react.createElement(radioButton, {
    value: "year"
  }, locale.year));
}
function CalendarHeader(props) {
  const {
    prefixCls,
    fullscreen,
    mode,
    onChange,
    onModeChange
  } = props;
  const divRef = react.useRef(null);
  const formItemInputContext = (0,react.useContext)(FormItemInputContext);
  const mergedFormItemInputContext = (0,react.useMemo)(() => Object.assign(Object.assign({}, formItemInputContext), {
    isFormItemInput: false
  }), [formItemInputContext]);
  const sharedProps = Object.assign(Object.assign({}, props), {
    fullscreen,
    divRef
  });
  return /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-header`,
    ref: divRef
  }, /*#__PURE__*/react.createElement(FormItemInputContext.Provider, {
    value: mergedFormItemInputContext
  }, /*#__PURE__*/react.createElement(YearSelect, Object.assign({}, sharedProps, {
    onChange: v => {
      onChange(v, 'year');
    }
  })), mode === 'month' && (/*#__PURE__*/react.createElement(MonthSelect, Object.assign({}, sharedProps, {
    onChange: v => {
      onChange(v, 'month');
    }
  })))), /*#__PURE__*/react.createElement(ModeSwitch, Object.assign({}, sharedProps, {
    onModeChange: onModeChange
  })));
}
/* harmony default export */ var Header = (CalendarHeader);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/date-picker/style/panel.js


const genPickerCellInnerStyle = token => {
  const {
    pickerCellCls,
    pickerCellInnerCls,
    cellHeight,
    borderRadiusSM,
    motionDurationMid,
    cellHoverBg,
    lineWidth,
    lineType,
    colorPrimary,
    cellActiveWithRangeBg,
    colorTextLightSolid,
    colorTextDisabled,
    cellBgDisabled,
    colorFillSecondary
  } = token;
  return {
    '&::before': {
      position: 'absolute',
      top: '50%',
      insetInlineStart: 0,
      insetInlineEnd: 0,
      zIndex: 1,
      height: cellHeight,
      transform: 'translateY(-50%)',
      content: '""',
      pointerEvents: 'none'
    },
    // >>> Default
    [pickerCellInnerCls]: {
      position: 'relative',
      zIndex: 2,
      display: 'inline-block',
      minWidth: cellHeight,
      height: cellHeight,
      lineHeight: (0,cssinjs_es/* unit */.bf)(cellHeight),
      borderRadius: borderRadiusSM,
      transition: `background ${motionDurationMid}`
    },
    // >>> Hover
    [`&:hover:not(${pickerCellCls}-in-view):not(${pickerCellCls}-disabled),
    &:hover:not(${pickerCellCls}-selected):not(${pickerCellCls}-range-start):not(${pickerCellCls}-range-end):not(${pickerCellCls}-disabled)`]: {
      [pickerCellInnerCls]: {
        background: cellHoverBg
      }
    },
    // >>> Today
    [`&-in-view${pickerCellCls}-today ${pickerCellInnerCls}`]: {
      '&::before': {
        position: 'absolute',
        top: 0,
        insetInlineEnd: 0,
        bottom: 0,
        insetInlineStart: 0,
        zIndex: 1,
        border: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${colorPrimary}`,
        borderRadius: borderRadiusSM,
        content: '""'
      }
    },
    // >>> In Range
    [`&-in-view${pickerCellCls}-in-range,
      &-in-view${pickerCellCls}-range-start,
      &-in-view${pickerCellCls}-range-end`]: {
      position: 'relative',
      [`&:not(${pickerCellCls}-disabled):before`]: {
        background: cellActiveWithRangeBg
      }
    },
    // >>> Selected
    [`&-in-view${pickerCellCls}-selected,
      &-in-view${pickerCellCls}-range-start,
      &-in-view${pickerCellCls}-range-end`]: {
      [`&:not(${pickerCellCls}-disabled) ${pickerCellInnerCls}`]: {
        color: colorTextLightSolid,
        background: colorPrimary
      },
      [`&${pickerCellCls}-disabled ${pickerCellInnerCls}`]: {
        background: colorFillSecondary
      }
    },
    [`&-in-view${pickerCellCls}-range-start:not(${pickerCellCls}-disabled):before`]: {
      insetInlineStart: '50%'
    },
    [`&-in-view${pickerCellCls}-range-end:not(${pickerCellCls}-disabled):before`]: {
      insetInlineEnd: '50%'
    },
    // range start border-radius
    [`&-in-view${pickerCellCls}-range-start:not(${pickerCellCls}-range-end) ${pickerCellInnerCls}`]: {
      borderStartStartRadius: borderRadiusSM,
      borderEndStartRadius: borderRadiusSM,
      borderStartEndRadius: 0,
      borderEndEndRadius: 0
    },
    // range end border-radius
    [`&-in-view${pickerCellCls}-range-end:not(${pickerCellCls}-range-start) ${pickerCellInnerCls}`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      borderStartEndRadius: borderRadiusSM,
      borderEndEndRadius: borderRadiusSM
    },
    // >>> Disabled
    '&-disabled': {
      color: colorTextDisabled,
      cursor: 'not-allowed',
      [pickerCellInnerCls]: {
        background: 'transparent'
      },
      '&::before': {
        background: cellBgDisabled
      }
    },
    [`&-disabled${pickerCellCls}-today ${pickerCellInnerCls}::before`]: {
      borderColor: colorTextDisabled
    }
  };
};
const genPanelStyle = token => {
  const {
    componentCls,
    pickerCellCls,
    pickerCellInnerCls,
    pickerYearMonthCellWidth,
    pickerControlIconSize,
    cellWidth,
    paddingSM,
    paddingXS,
    paddingXXS,
    colorBgContainer,
    lineWidth,
    lineType,
    borderRadiusLG,
    colorPrimary,
    colorTextHeading,
    colorSplit,
    pickerControlIconBorderWidth,
    colorIcon,
    textHeight,
    motionDurationMid,
    colorIconHover,
    fontWeightStrong,
    cellHeight,
    pickerCellPaddingVertical,
    colorTextDisabled,
    colorText,
    fontSize,
    motionDurationSlow,
    withoutTimeCellHeight,
    pickerQuarterPanelContentHeight,
    borderRadiusSM,
    colorTextLightSolid,
    cellHoverBg,
    timeColumnHeight,
    timeColumnWidth,
    timeCellHeight,
    controlItemBgActive,
    marginXXS,
    pickerDatePanelPaddingHorizontal,
    pickerControlIconMargin
  } = token;
  const pickerPanelWidth = token.calc(cellWidth).mul(7).add(token.calc(pickerDatePanelPaddingHorizontal).mul(2)).equal();
  return {
    [componentCls]: {
      '&-panel': {
        display: 'inline-flex',
        flexDirection: 'column',
        textAlign: 'center',
        background: colorBgContainer,
        borderRadius: borderRadiusLG,
        outline: 'none',
        '&-focused': {
          borderColor: colorPrimary
        },
        '&-rtl': {
          [`${componentCls}-prev-icon,
              ${componentCls}-super-prev-icon`]: {
            transform: 'rotate(45deg)'
          },
          [`${componentCls}-next-icon,
              ${componentCls}-super-next-icon`]: {
            transform: 'rotate(-135deg)'
          },
          [`${componentCls}-time-panel`]: {
            [`${componentCls}-content`]: {
              direction: 'ltr',
              '> *': {
                direction: 'rtl'
              }
            }
          }
        }
      },
      // ========================================================
      // =                     Shared Panel                     =
      // ========================================================
      [`&-decade-panel,
        &-year-panel,
        &-quarter-panel,
        &-month-panel,
        &-week-panel,
        &-date-panel,
        &-time-panel`]: {
        display: 'flex',
        flexDirection: 'column',
        width: pickerPanelWidth
      },
      // ======================= Header =======================
      '&-header': {
        display: 'flex',
        padding: `0 ${(0,cssinjs_es/* unit */.bf)(paddingXS)}`,
        color: colorTextHeading,
        borderBottom: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${colorSplit}`,
        '> *': {
          flex: 'none'
        },
        button: {
          padding: 0,
          color: colorIcon,
          lineHeight: (0,cssinjs_es/* unit */.bf)(textHeight),
          background: 'transparent',
          border: 0,
          cursor: 'pointer',
          transition: `color ${motionDurationMid}`,
          fontSize: 'inherit',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          '&:empty': {
            display: 'none'
          }
        },
        '> button': {
          minWidth: '1.6em',
          fontSize,
          '&:hover': {
            color: colorIconHover
          },
          '&:disabled': {
            opacity: 0.25,
            pointerEvents: 'none'
          }
        },
        '&-view': {
          flex: 'auto',
          fontWeight: fontWeightStrong,
          lineHeight: (0,cssinjs_es/* unit */.bf)(textHeight),
          '> button': {
            color: 'inherit',
            fontWeight: 'inherit',
            verticalAlign: 'top',
            '&:not(:first-child)': {
              marginInlineStart: paddingXS
            },
            '&:hover': {
              color: colorPrimary
            }
          }
        }
      },
      // Arrow button
      [`&-prev-icon,
        &-next-icon,
        &-super-prev-icon,
        &-super-next-icon`]: {
        position: 'relative',
        width: pickerControlIconSize,
        height: pickerControlIconSize,
        '&::before': {
          position: 'absolute',
          top: 0,
          insetInlineStart: 0,
          width: pickerControlIconSize,
          height: pickerControlIconSize,
          border: `0 solid currentcolor`,
          borderBlockStartWidth: pickerControlIconBorderWidth,
          borderInlineStartWidth: pickerControlIconBorderWidth,
          content: '""'
        }
      },
      [`&-super-prev-icon,
        &-super-next-icon`]: {
        '&::after': {
          position: 'absolute',
          top: pickerControlIconMargin,
          insetInlineStart: pickerControlIconMargin,
          display: 'inline-block',
          width: pickerControlIconSize,
          height: pickerControlIconSize,
          border: '0 solid currentcolor',
          borderBlockStartWidth: pickerControlIconBorderWidth,
          borderInlineStartWidth: pickerControlIconBorderWidth,
          content: '""'
        }
      },
      '&-prev-icon, &-super-prev-icon': {
        transform: 'rotate(-45deg)'
      },
      '&-next-icon, &-super-next-icon': {
        transform: 'rotate(135deg)'
      },
      // ======================== Body ========================
      '&-content': {
        width: '100%',
        tableLayout: 'fixed',
        borderCollapse: 'collapse',
        'th, td': {
          position: 'relative',
          minWidth: cellHeight,
          fontWeight: 'normal'
        },
        th: {
          height: token.calc(cellHeight).add(token.calc(pickerCellPaddingVertical).mul(2)).equal(),
          color: colorText,
          verticalAlign: 'middle'
        }
      },
      '&-cell': Object.assign({
        padding: `${(0,cssinjs_es/* unit */.bf)(pickerCellPaddingVertical)} 0`,
        color: colorTextDisabled,
        cursor: 'pointer',
        // In view
        '&-in-view': {
          color: colorText
        }
      }, genPickerCellInnerStyle(token)),
      [`&-decade-panel,
        &-year-panel,
        &-quarter-panel,
        &-month-panel`]: {
        [`${componentCls}-content`]: {
          height: token.calc(withoutTimeCellHeight).mul(4).equal()
        },
        [pickerCellInnerCls]: {
          padding: `0 ${(0,cssinjs_es/* unit */.bf)(paddingXS)}`
        }
      },
      '&-quarter-panel': {
        [`${componentCls}-content`]: {
          height: pickerQuarterPanelContentHeight
        }
      },
      // ========================================================
      // =                       Special                        =
      // ========================================================
      // ===================== Decade Panel =====================
      '&-decade-panel': {
        [pickerCellInnerCls]: {
          padding: `0 ${(0,cssinjs_es/* unit */.bf)(token.calc(paddingXS).div(2).equal())}`
        },
        [`${componentCls}-cell::before`]: {
          display: 'none'
        }
      },
      // ============= Year & Quarter & Month Panel =============
      [`&-year-panel,
        &-quarter-panel,
        &-month-panel`]: {
        [`${componentCls}-body`]: {
          padding: `0 ${(0,cssinjs_es/* unit */.bf)(paddingXS)}`
        },
        [pickerCellInnerCls]: {
          width: pickerYearMonthCellWidth
        }
      },
      // ====================== Date Panel ======================
      '&-date-panel': {
        [`${componentCls}-body`]: {
          padding: `${(0,cssinjs_es/* unit */.bf)(paddingXS)} ${(0,cssinjs_es/* unit */.bf)(pickerDatePanelPaddingHorizontal)}`
        },
        [`${componentCls}-content th`]: {
          boxSizing: 'border-box',
          padding: 0
        }
      },
      // ====================== Week Panel ======================
      '&-week-panel-row': {
        td: {
          '&:before': {
            transition: `background ${motionDurationMid}`
          },
          '&:first-child:before': {
            borderStartStartRadius: borderRadiusSM,
            borderEndStartRadius: borderRadiusSM
          },
          '&:last-child:before': {
            borderStartEndRadius: borderRadiusSM,
            borderEndEndRadius: borderRadiusSM
          }
        },
        '&:hover td:before': {
          background: cellHoverBg
        },
        '&-range-start td, &-range-end td, &-selected td, &-hover td': {
          // Rise priority to override hover style
          [`&${pickerCellCls}`]: {
            '&:before': {
              background: colorPrimary
            },
            [`&${componentCls}-cell-week`]: {
              color: new fast_color_es/* FastColor */.t(colorTextLightSolid).setA(0.5).toHexString()
            },
            [pickerCellInnerCls]: {
              color: colorTextLightSolid
            }
          }
        },
        '&-range-hover td:before': {
          background: controlItemBgActive
        }
      },
      // >>> ShowWeek
      '&-week-panel, &-date-panel-show-week': {
        [`${componentCls}-body`]: {
          padding: `${(0,cssinjs_es/* unit */.bf)(paddingXS)} ${(0,cssinjs_es/* unit */.bf)(paddingSM)}`
        },
        [`${componentCls}-content th`]: {
          width: 'auto'
        }
      },
      // ==================== Datetime Panel ====================
      '&-datetime-panel': {
        display: 'flex',
        [`${componentCls}-time-panel`]: {
          borderInlineStart: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${colorSplit}`
        },
        [`${componentCls}-date-panel,
          ${componentCls}-time-panel`]: {
          transition: `opacity ${motionDurationSlow}`
        },
        // Keyboard
        '&-active': {
          [`${componentCls}-date-panel,
            ${componentCls}-time-panel`]: {
            opacity: 0.3,
            '&-active': {
              opacity: 1
            }
          }
        }
      },
      // ====================== Time Panel ======================
      '&-time-panel': {
        width: 'auto',
        minWidth: 'auto',
        [`${componentCls}-content`]: {
          display: 'flex',
          flex: 'auto',
          height: timeColumnHeight
        },
        '&-column': {
          flex: '1 0 auto',
          width: timeColumnWidth,
          margin: `${(0,cssinjs_es/* unit */.bf)(paddingXXS)} 0`,
          padding: 0,
          overflowY: 'hidden',
          textAlign: 'start',
          listStyle: 'none',
          transition: `background ${motionDurationMid}`,
          overflowX: 'hidden',
          '&::-webkit-scrollbar': {
            width: 8,
            backgroundColor: 'transparent'
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: token.colorTextTertiary,
            borderRadius: token.borderRadiusSM
          },
          // For Firefox
          '&': {
            scrollbarWidth: 'thin',
            scrollbarColor: `${token.colorTextTertiary} transparent`
          },
          '&::after': {
            display: 'block',
            height: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(timeCellHeight)})`,
            content: '""'
          },
          '&:not(:first-child)': {
            borderInlineStart: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${colorSplit}`
          },
          '&-active': {
            background: new fast_color_es/* FastColor */.t(controlItemBgActive).setA(0.2).toHexString()
          },
          '&:hover': {
            overflowY: 'auto'
          },
          '> li': {
            margin: 0,
            padding: 0,
            [`&${componentCls}-time-panel-cell`]: {
              marginInline: marginXXS,
              [`${componentCls}-time-panel-cell-inner`]: {
                display: 'block',
                width: token.calc(timeColumnWidth).sub(token.calc(marginXXS).mul(2)).equal(),
                height: timeCellHeight,
                margin: 0,
                paddingBlock: 0,
                paddingInlineEnd: 0,
                paddingInlineStart: token.calc(timeColumnWidth).sub(timeCellHeight).div(2).equal(),
                color: colorText,
                lineHeight: (0,cssinjs_es/* unit */.bf)(timeCellHeight),
                borderRadius: borderRadiusSM,
                cursor: 'pointer',
                transition: `background ${motionDurationMid}`,
                '&:hover': {
                  background: cellHoverBg
                }
              },
              '&-selected': {
                [`${componentCls}-time-panel-cell-inner`]: {
                  background: controlItemBgActive
                }
              },
              '&-disabled': {
                [`${componentCls}-time-panel-cell-inner`]: {
                  color: colorTextDisabled,
                  background: 'transparent',
                  cursor: 'not-allowed'
                }
              }
            }
          }
        }
      }
    }
  };
};
const genPickerPanelStyle = token => {
  const {
    componentCls,
    textHeight,
    lineWidth,
    paddingSM,
    antCls,
    colorPrimary,
    cellActiveWithRangeBg,
    colorPrimaryBorder,
    lineType,
    colorSplit
  } = token;
  return {
    [`${componentCls}-dropdown`]: {
      // ======================== Footer ========================
      [`${componentCls}-footer`]: {
        borderTop: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${colorSplit}`,
        '&-extra': {
          padding: `0 ${(0,cssinjs_es/* unit */.bf)(paddingSM)}`,
          lineHeight: (0,cssinjs_es/* unit */.bf)(token.calc(textHeight).sub(token.calc(lineWidth).mul(2)).equal()),
          textAlign: 'start',
          '&:not(:last-child)': {
            borderBottom: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${colorSplit}`
          }
        }
      },
      // ==================== Footer > Ranges ===================
      [`${componentCls}-panels + ${componentCls}-footer ${componentCls}-ranges`]: {
        justifyContent: 'space-between'
      },
      [`${componentCls}-ranges`]: {
        marginBlock: 0,
        paddingInline: (0,cssinjs_es/* unit */.bf)(paddingSM),
        overflow: 'hidden',
        textAlign: 'start',
        listStyle: 'none',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '> li': {
          lineHeight: (0,cssinjs_es/* unit */.bf)(token.calc(textHeight).sub(token.calc(lineWidth).mul(2)).equal()),
          display: 'inline-block'
        },
        [`${componentCls}-now-btn-disabled`]: {
          pointerEvents: 'none',
          color: token.colorTextDisabled
        },
        // https://github.com/ant-design/ant-design/issues/23687
        [`${componentCls}-preset > ${antCls}-tag-blue`]: {
          color: colorPrimary,
          background: cellActiveWithRangeBg,
          borderColor: colorPrimaryBorder,
          cursor: 'pointer'
        },
        [`${componentCls}-ok`]: {
          paddingBlock: token.calc(lineWidth).mul(2).equal(),
          marginInlineStart: 'auto'
        }
      }
    }
  };
};
/* harmony default export */ var panel = (genPickerPanelStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/input/style/token.js

function initInputToken(token) {
  return (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    inputAffixPadding: token.paddingXXS
  });
}
const token_initComponentToken = token => {
  const {
    controlHeight,
    fontSize,
    lineHeight,
    lineWidth,
    controlHeightSM,
    controlHeightLG,
    fontSizeLG,
    lineHeightLG,
    paddingSM,
    controlPaddingHorizontalSM,
    controlPaddingHorizontal,
    colorFillAlter,
    colorPrimaryHover,
    colorPrimary,
    controlOutlineWidth,
    controlOutline,
    colorErrorOutline,
    colorWarningOutline,
    colorBgContainer,
    inputFontSize,
    inputFontSizeLG,
    inputFontSizeSM
  } = token;
  const mergedFontSize = inputFontSize || fontSize;
  const mergedFontSizeSM = inputFontSizeSM || mergedFontSize;
  const mergedFontSizeLG = inputFontSizeLG || fontSizeLG;
  const paddingBlock = Math.round((controlHeight - mergedFontSize * lineHeight) / 2 * 10) / 10 - lineWidth;
  const paddingBlockSM = Math.round((controlHeightSM - mergedFontSizeSM * lineHeight) / 2 * 10) / 10 - lineWidth;
  const paddingBlockLG = Math.ceil((controlHeightLG - mergedFontSizeLG * lineHeightLG) / 2 * 10) / 10 - lineWidth;
  return {
    paddingBlock: Math.max(paddingBlock, 0),
    paddingBlockSM: Math.max(paddingBlockSM, 0),
    paddingBlockLG: Math.max(paddingBlockLG, 0),
    paddingInline: paddingSM - lineWidth,
    paddingInlineSM: controlPaddingHorizontalSM - lineWidth,
    paddingInlineLG: controlPaddingHorizontal - lineWidth,
    addonBg: colorFillAlter,
    activeBorderColor: colorPrimary,
    hoverBorderColor: colorPrimaryHover,
    activeShadow: `0 0 0 ${controlOutlineWidth}px ${controlOutline}`,
    errorActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorErrorOutline}`,
    warningActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorWarningOutline}`,
    hoverBg: colorBgContainer,
    activeBg: colorBgContainer,
    inputFontSize: mergedFontSize,
    inputFontSizeLG: mergedFontSizeLG,
    inputFontSizeSM: mergedFontSizeSM
  };
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/date-picker/style/token.js



const initPickerPanelToken = token => {
  const {
    componentCls,
    controlHeightLG,
    paddingXXS,
    padding
  } = token;
  return {
    pickerCellCls: `${componentCls}-cell`,
    pickerCellInnerCls: `${componentCls}-cell-inner`,
    pickerYearMonthCellWidth: token.calc(controlHeightLG).mul(1.5).equal(),
    pickerQuarterPanelContentHeight: token.calc(controlHeightLG).mul(1.4).equal(),
    pickerCellPaddingVertical: token.calc(paddingXXS).add(token.calc(paddingXXS).div(2)).equal(),
    pickerCellBorderGap: 2,
    // Magic for gap between cells
    pickerControlIconSize: 7,
    pickerControlIconMargin: 4,
    pickerControlIconBorderWidth: 1.5,
    pickerDatePanelPaddingHorizontal: token.calc(padding).add(token.calc(paddingXXS).div(2)).equal() // 18 in normal
  };
};
const initPanelComponentToken = token => {
  const {
    colorBgContainerDisabled,
    controlHeight,
    controlHeightSM,
    controlHeightLG,
    paddingXXS,
    lineWidth
  } = token;
  // Item height default use `controlHeight - 2 * paddingXXS`,
  // but some case `paddingXXS=0`.
  // Let's fallback it.
  const dblPaddingXXS = paddingXXS * 2;
  const dblLineWidth = lineWidth * 2;
  const multipleItemHeight = Math.min(controlHeight - dblPaddingXXS, controlHeight - dblLineWidth);
  const multipleItemHeightSM = Math.min(controlHeightSM - dblPaddingXXS, controlHeightSM - dblLineWidth);
  const multipleItemHeightLG = Math.min(controlHeightLG - dblPaddingXXS, controlHeightLG - dblLineWidth);
  // FIXED_ITEM_MARGIN is a hardcode calculation since calc not support rounding
  const INTERNAL_FIXED_ITEM_MARGIN = Math.floor(paddingXXS / 2);
  const filledToken = {
    INTERNAL_FIXED_ITEM_MARGIN,
    cellHoverBg: token.controlItemBgHover,
    cellActiveWithRangeBg: token.controlItemBgActive,
    cellHoverWithRangeBg: new fast_color_es/* FastColor */.t(token.colorPrimary).lighten(35).toHexString(),
    cellRangeBorderColor: new fast_color_es/* FastColor */.t(token.colorPrimary).lighten(20).toHexString(),
    cellBgDisabled: colorBgContainerDisabled,
    timeColumnWidth: controlHeightLG * 1.4,
    timeColumnHeight: 28 * 8,
    timeCellHeight: 28,
    cellWidth: controlHeightSM * 1.5,
    cellHeight: controlHeightSM,
    textHeight: controlHeightLG,
    withoutTimeCellHeight: controlHeightLG * 1.65,
    multipleItemBg: token.colorFillSecondary,
    multipleItemBorderColor: 'transparent',
    multipleItemHeight,
    multipleItemHeightSM,
    multipleItemHeightLG,
    multipleSelectorBgDisabled: colorBgContainerDisabled,
    multipleItemColorDisabled: token.colorTextDisabled,
    multipleItemBorderColorDisabled: 'transparent'
  };
  return filledToken;
};
const date_picker_style_token_prepareComponentToken = token => Object.assign(Object.assign(Object.assign(Object.assign({}, token_initComponentToken(token)), initPanelComponentToken(token)), getArrowToken(token)), {
  presetsWidth: 120,
  presetsMaxWidth: 200,
  zIndexPopup: token.zIndexPopupBase + 50
});
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/calendar/style/index.js




const genCalendarStyles = token => {
  const {
    calendarCls,
    componentCls,
    fullBg,
    fullPanelBg,
    itemActiveBg
  } = token;
  return {
    [calendarCls]: Object.assign(Object.assign(Object.assign({}, genPanelStyle(token)), resetComponent(token)), {
      background: fullBg,
      '&-rtl': {
        direction: 'rtl'
      },
      [`${calendarCls}-header`]: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: `${(0,cssinjs_es/* unit */.bf)(token.paddingSM)} 0`,
        [`${calendarCls}-year-select`]: {
          minWidth: token.yearControlWidth
        },
        [`${calendarCls}-month-select`]: {
          minWidth: token.monthControlWidth,
          marginInlineStart: token.marginXS
        },
        [`${calendarCls}-mode-switch`]: {
          marginInlineStart: token.marginXS
        }
      }
    }),
    [`${calendarCls} ${componentCls}-panel`]: {
      background: fullPanelBg,
      border: 0,
      borderTop: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`,
      borderRadius: 0,
      [`${componentCls}-month-panel, ${componentCls}-date-panel`]: {
        width: 'auto'
      },
      [`${componentCls}-body`]: {
        padding: `${(0,cssinjs_es/* unit */.bf)(token.paddingXS)} 0`
      },
      [`${componentCls}-content`]: {
        width: '100%'
      }
    },
    [`${calendarCls}-mini`]: {
      borderRadius: token.borderRadiusLG,
      [`${calendarCls}-header`]: {
        paddingInlineEnd: token.paddingXS,
        paddingInlineStart: token.paddingXS
      },
      [`${componentCls}-panel`]: {
        borderRadius: `0 0 ${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} ${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)}`
      },
      [`${componentCls}-content`]: {
        height: token.miniContentHeight,
        th: {
          height: 'auto',
          padding: 0,
          lineHeight: (0,cssinjs_es/* unit */.bf)(token.weekHeight)
        }
      },
      [`${componentCls}-cell::before`]: {
        pointerEvents: 'none'
      }
    },
    [`${calendarCls}${calendarCls}-full`]: {
      [`${componentCls}-panel`]: {
        display: 'block',
        width: '100%',
        textAlign: 'end',
        background: fullBg,
        border: 0,
        [`${componentCls}-body`]: {
          'th, td': {
            padding: 0
          },
          th: {
            height: 'auto',
            paddingInlineEnd: token.paddingSM,
            paddingBottom: token.paddingXXS,
            lineHeight: (0,cssinjs_es/* unit */.bf)(token.weekHeight)
          }
        }
      },
      [`${componentCls}-cell-week ${componentCls}-cell-inner`]: {
        display: 'block',
        borderRadius: 0,
        borderTop: `${(0,cssinjs_es/* unit */.bf)(token.lineWidthBold)} ${token.lineType} ${token.colorSplit}`,
        width: '100%',
        height: token.calc(token.dateValueHeight).add(token.dateContentHeight).add(token.calc(token.paddingXS).div(2)).add(token.lineWidthBold).equal()
      },
      [`${componentCls}-cell`]: {
        '&::before': {
          display: 'none'
        },
        '&:hover': {
          [`${calendarCls}-date`]: {
            background: token.controlItemBgHover
          }
        },
        [`${calendarCls}-date-today::before`]: {
          display: 'none'
        },
        // >>> Selected
        [`&-in-view${componentCls}-cell-selected`]: {
          [`${calendarCls}-date, ${calendarCls}-date-today`]: {
            background: itemActiveBg
          }
        },
        '&-selected, &-selected:hover': {
          [`${calendarCls}-date, ${calendarCls}-date-today`]: {
            [`${calendarCls}-date-value`]: {
              color: token.colorPrimary
            }
          }
        }
      },
      [`${calendarCls}-date`]: {
        display: 'block',
        width: 'auto',
        height: 'auto',
        margin: `0 ${(0,cssinjs_es/* unit */.bf)(token.calc(token.marginXS).div(2).equal())}`,
        padding: `${(0,cssinjs_es/* unit */.bf)(token.calc(token.paddingXS).div(2).equal())} ${(0,cssinjs_es/* unit */.bf)(token.paddingXS)} 0`,
        border: 0,
        borderTop: `${(0,cssinjs_es/* unit */.bf)(token.lineWidthBold)} ${token.lineType} ${token.colorSplit}`,
        borderRadius: 0,
        transition: `background ${token.motionDurationSlow}`,
        '&-value': {
          lineHeight: (0,cssinjs_es/* unit */.bf)(token.dateValueHeight),
          transition: `color ${token.motionDurationSlow}`
        },
        '&-content': {
          position: 'static',
          width: 'auto',
          height: token.dateContentHeight,
          overflowY: 'auto',
          color: token.colorText,
          lineHeight: token.lineHeight,
          textAlign: 'start'
        },
        '&-today': {
          borderColor: token.colorPrimary,
          [`${calendarCls}-date-value`]: {
            color: token.colorText
          }
        }
      }
    },
    [`@media only screen and (max-width: ${(0,cssinjs_es/* unit */.bf)(token.screenXS)}) `]: {
      [calendarCls]: {
        [`${calendarCls}-header`]: {
          display: 'block',
          [`${calendarCls}-year-select`]: {
            width: '50%'
          },
          [`${calendarCls}-month-select`]: {
            width: `calc(50% - ${(0,cssinjs_es/* unit */.bf)(token.paddingXS)})`
          },
          [`${calendarCls}-mode-switch`]: {
            width: '100%',
            marginTop: token.marginXS,
            marginInlineStart: 0,
            '> label': {
              width: '50%',
              textAlign: 'center'
            }
          }
        }
      }
    }
  };
};
const calendar_style_prepareComponentToken = token => Object.assign({
  fullBg: token.colorBgContainer,
  fullPanelBg: token.colorBgContainer,
  itemActiveBg: token.controlItemBgActive,
  yearControlWidth: 80,
  monthControlWidth: 70,
  miniContentHeight: 256
}, initPanelComponentToken(token));
/* harmony default export */ var calendar_style = (genStyleHooks('Calendar', token => {
  const calendarCls = `${token.componentCls}-calendar`;
  const calendarToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, initPickerPanelToken(token), {
    calendarCls,
    pickerCellInnerCls: `${token.componentCls}-cell-inner`,
    dateValueHeight: token.controlHeightSM,
    weekHeight: token.calc(token.controlHeightSM).mul(0.75).equal(),
    dateContentHeight: token.calc(token.calc(token.fontHeightSM).add(token.marginXS)).mul(3).add(token.calc(token.lineWidth).mul(2)).equal()
  });
  return genCalendarStyles(calendarToken);
}, calendar_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/calendar/generateCalendar.js
"use client";











const isSameYear = (date1, date2, config) => {
  const {
    getYear
  } = config;
  return date1 && date2 && getYear(date1) === getYear(date2);
};
const isSameMonth = (date1, date2, config) => {
  const {
    getMonth
  } = config;
  return isSameYear(date1, date2, config) && getMonth(date1) === getMonth(date2);
};
const isSameDate = (date1, date2, config) => {
  const {
    getDate
  } = config;
  return isSameMonth(date1, date2, config) && getDate(date1) === getDate(date2);
};
const generateCalendar = generateConfig => {
  const Calendar = props => {
    const {
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      style,
      dateFullCellRender,
      dateCellRender,
      monthFullCellRender,
      monthCellRender,
      cellRender,
      fullCellRender,
      headerRender,
      value,
      defaultValue,
      disabledDate,
      mode,
      validRange,
      fullscreen = true,
      showWeek,
      onChange,
      onPanelChange,
      onSelect
    } = props;
    const {
      getPrefixCls,
      direction,
      className: contextClassName,
      style: contextStyle
    } = useComponentConfig('calendar');
    const prefixCls = getPrefixCls('picker', customizePrefixCls);
    const calendarPrefixCls = `${prefixCls}-calendar`;
    const [wrapCSSVar, hashId, cssVarCls] = calendar_style(prefixCls, calendarPrefixCls);
    const today = generateConfig.getNow();
    // ====================== Warning =======================
    if (false) {}
    // ====================== State =======================
    // Value
    const [mergedValue, setMergedValue] = (0,useMergedState/* default */.Z)(() => value || generateConfig.getNow(), {
      defaultValue,
      value
    });
    // Mode
    const [mergedMode, setMergedMode] = (0,useMergedState/* default */.Z)('month', {
      value: mode
    });
    const panelMode = react.useMemo(() => mergedMode === 'year' ? 'month' : 'date', [mergedMode]);
    // Disabled Date
    const mergedDisabledDate = react.useCallback(date => {
      const notInRange = validRange ? generateConfig.isAfter(validRange[0], date) || generateConfig.isAfter(date, validRange[1]) : false;
      return notInRange || !!(disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date));
    }, [disabledDate, validRange]);
    // ====================== Events ======================
    const triggerPanelChange = (date, newMode) => {
      onPanelChange === null || onPanelChange === void 0 ? void 0 : onPanelChange(date, newMode);
    };
    const triggerChange = date => {
      setMergedValue(date);
      if (!isSameDate(date, mergedValue, generateConfig)) {
        // Trigger when month panel switch month
        if (panelMode === 'date' && !isSameMonth(date, mergedValue, generateConfig) || panelMode === 'month' && !isSameYear(date, mergedValue, generateConfig)) {
          triggerPanelChange(date, mergedMode);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(date);
      }
    };
    const triggerModeChange = newMode => {
      setMergedMode(newMode);
      triggerPanelChange(mergedValue, newMode);
    };
    const onInternalSelect = (date, source) => {
      triggerChange(date);
      onSelect === null || onSelect === void 0 ? void 0 : onSelect(date, {
        source
      });
    };
    // ====================== Render ======================
    const dateRender = react.useCallback((date, info) => {
      if (fullCellRender) {
        return fullCellRender(date, info);
      }
      if (dateFullCellRender) {
        return dateFullCellRender(date);
      }
      return /*#__PURE__*/react.createElement("div", {
        className: classnames_default()(`${prefixCls}-cell-inner`, `${calendarPrefixCls}-date`, {
          [`${calendarPrefixCls}-date-today`]: isSameDate(today, date, generateConfig)
        })
      }, /*#__PURE__*/react.createElement("div", {
        className: `${calendarPrefixCls}-date-value`
      }, String(generateConfig.getDate(date)).padStart(2, '0')), /*#__PURE__*/react.createElement("div", {
        className: `${calendarPrefixCls}-date-content`
      }, cellRender ? cellRender(date, info) : dateCellRender === null || dateCellRender === void 0 ? void 0 : dateCellRender(date)));
    }, [dateFullCellRender, dateCellRender, cellRender, fullCellRender]);
    const monthRender = react.useCallback((date, info) => {
      if (fullCellRender) {
        return fullCellRender(date, info);
      }
      if (monthFullCellRender) {
        return monthFullCellRender(date);
      }
      const months = info.locale.shortMonths || generateConfig.locale.getShortMonths(info.locale.locale);
      return /*#__PURE__*/react.createElement("div", {
        className: classnames_default()(`${prefixCls}-cell-inner`, `${calendarPrefixCls}-date`, {
          [`${calendarPrefixCls}-date-today`]: isSameMonth(today, date, generateConfig)
        })
      }, /*#__PURE__*/react.createElement("div", {
        className: `${calendarPrefixCls}-date-value`
      }, months[generateConfig.getMonth(date)]), /*#__PURE__*/react.createElement("div", {
        className: `${calendarPrefixCls}-date-content`
      }, cellRender ? cellRender(date, info) : monthCellRender === null || monthCellRender === void 0 ? void 0 : monthCellRender(date)));
    }, [monthFullCellRender, monthCellRender, cellRender, fullCellRender]);
    const [contextLocale] = locale_useLocale('Calendar', calendar_locale_en_US);
    const locale = Object.assign(Object.assign({}, contextLocale), props.locale);
    const mergedCellRender = (current, info) => {
      if (info.type === 'date') {
        return dateRender(current, info);
      }
      if (info.type === 'month') {
        return monthRender(current, Object.assign(Object.assign({}, info), {
          locale: locale === null || locale === void 0 ? void 0 : locale.lang
        }));
      }
    };
    return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
      className: classnames_default()(calendarPrefixCls, {
        [`${calendarPrefixCls}-full`]: fullscreen,
        [`${calendarPrefixCls}-mini`]: !fullscreen,
        [`${calendarPrefixCls}-rtl`]: direction === 'rtl'
      }, contextClassName, className, rootClassName, hashId, cssVarCls),
      style: Object.assign(Object.assign({}, contextStyle), style)
    }, headerRender ? headerRender({
      value: mergedValue,
      type: mergedMode,
      onChange: nextDate => {
        onInternalSelect(nextDate, 'customize');
      },
      onTypeChange: triggerModeChange
    }) : (/*#__PURE__*/react.createElement(Header, {
      prefixCls: calendarPrefixCls,
      value: mergedValue,
      generateConfig: generateConfig,
      mode: mergedMode,
      fullscreen: fullscreen,
      locale: locale === null || locale === void 0 ? void 0 : locale.lang,
      validRange: validRange,
      onChange: onInternalSelect,
      onModeChange: triggerModeChange
    })), /*#__PURE__*/react.createElement(rc_picker_es/* PickerPanel */.N4, {
      value: mergedValue,
      prefixCls: prefixCls,
      locale: locale === null || locale === void 0 ? void 0 : locale.lang,
      generateConfig: generateConfig,
      cellRender: mergedCellRender,
      onSelect: nextDate => {
        onInternalSelect(nextDate, panelMode);
      },
      mode: panelMode,
      picker: panelMode,
      disabledDate: mergedDisabledDate,
      hideHeader: true,
      showWeek: showWeek
    })));
  };
  if (false) {}
  return Calendar;
};
/* harmony default export */ var calendar_generateCalendar = (generateCalendar);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/calendar/index.js
"use client";



const Calendar = calendar_generateCalendar(dayjs/* default */.Z);
Calendar.generateCalendar = calendar_generateCalendar;
/* harmony default export */ var calendar = (Calendar);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PlusOutlined.js + 1 modules
var PlusOutlined = __webpack_require__(81074);
// EXTERNAL MODULE: ./node_modules/rc-tabs/es/index.js + 18 modules
var rc_tabs_es = __webpack_require__(5666);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tabs/hooks/useAnimateConfig.js

const motion = {
  motionAppear: false,
  motionEnter: true,
  motionLeave: true
};
function useAnimateConfig(prefixCls, animated = {
  inkBar: true,
  tabPane: false
}) {
  let mergedAnimated;
  if (animated === false) {
    mergedAnimated = {
      inkBar: false,
      tabPane: false
    };
  } else if (animated === true) {
    mergedAnimated = {
      inkBar: true,
      tabPane: true
    };
  } else {
    mergedAnimated = Object.assign({
      inkBar: true
    }, typeof animated === 'object' ? animated : {});
  }
  if (mergedAnimated.tabPane) {
    mergedAnimated.tabPaneMotion = Object.assign(Object.assign({}, motion), {
      motionName: getTransitionName(prefixCls, 'switch')
    });
  }
  return mergedAnimated;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tabs/hooks/useLegacyItems.js
var useLegacyItems_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};



function filter(items) {
  return items.filter(item => item);
}
function useLegacyItems(items, children) {
  if (false) {}
  if (items) {
    return items.map(item => {
      var _a;
      const mergedDestroyOnHidden = (_a = item.destroyOnHidden) !== null && _a !== void 0 ? _a : item.destroyInactiveTabPane;
      return Object.assign(Object.assign({}, item), {
        // TODO: In the future, destroyInactiveTabPane in rc-tabs needs to be upgrade to destroyOnHidden
        destroyInactiveTabPane: mergedDestroyOnHidden
      });
    });
  }
  const childrenItems = (0,Children_toArray/* default */.Z)(children).map(node => {
    if (/*#__PURE__*/react.isValidElement(node)) {
      const {
        key,
        props
      } = node;
      const _a = props || {},
        {
          tab
        } = _a,
        restProps = useLegacyItems_rest(_a, ["tab"]);
      const item = Object.assign(Object.assign({
        key: String(key)
      }, restProps), {
        label: tab
      });
      return item;
    }
    return null;
  });
  return filter(childrenItems);
}
/* harmony default export */ var hooks_useLegacyItems = (useLegacyItems);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tabs/style/motion.js

const genMotionStyle = token => {
  const {
    componentCls,
    motionDurationSlow
  } = token;
  return [{
    [componentCls]: {
      [`${componentCls}-switch`]: {
        '&-appear, &-enter': {
          transition: 'none',
          '&-start': {
            opacity: 0
          },
          '&-active': {
            opacity: 1,
            transition: `opacity ${motionDurationSlow}`
          }
        },
        '&-leave': {
          position: 'absolute',
          transition: 'none',
          inset: 0,
          '&-start': {
            opacity: 1
          },
          '&-active': {
            opacity: 0,
            transition: `opacity ${motionDurationSlow}`
          }
        }
      }
    }
  },
  // Follow code may reuse in other components
  [initSlideMotion(token, 'slide-up'), initSlideMotion(token, 'slide-down')]];
};
/* harmony default export */ var style_motion = (genMotionStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tabs/style/index.js




const genCardStyle = token => {
  const {
    componentCls,
    tabsCardPadding,
    cardBg,
    cardGutter,
    colorBorderSecondary,
    itemSelectedColor
  } = token;
  return {
    [`${componentCls}-card`]: {
      [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
        [`${componentCls}-tab`]: {
          margin: 0,
          padding: tabsCardPadding,
          background: cardBg,
          border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
          transition: `all ${token.motionDurationSlow} ${token.motionEaseInOut}`
        },
        [`${componentCls}-tab-active`]: {
          color: itemSelectedColor,
          background: token.colorBgContainer
        },
        [`${componentCls}-tab-focus:has(${componentCls}-tab-btn:focus-visible)`]: genFocusOutline(token, -3),
        [`& ${componentCls}-tab${componentCls}-tab-focus ${componentCls}-tab-btn:focus-visible`]: {
          outline: 'none'
        },
        [`${componentCls}-ink-bar`]: {
          visibility: 'hidden'
        }
      },
      // ========================== Top & Bottom ==========================
      [`&${componentCls}-top, &${componentCls}-bottom`]: {
        [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
          [`${componentCls}-tab + ${componentCls}-tab`]: {
            marginLeft: {
              _skip_check_: true,
              value: (0,cssinjs_es/* unit */.bf)(cardGutter)
            }
          }
        }
      },
      [`&${componentCls}-top`]: {
        [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
          [`${componentCls}-tab`]: {
            borderRadius: `${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} ${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} 0 0`
          },
          [`${componentCls}-tab-active`]: {
            borderBottomColor: token.colorBgContainer
          }
        }
      },
      [`&${componentCls}-bottom`]: {
        [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
          [`${componentCls}-tab`]: {
            borderRadius: `0 0 ${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} ${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)}`
          },
          [`${componentCls}-tab-active`]: {
            borderTopColor: token.colorBgContainer
          }
        }
      },
      // ========================== Left & Right ==========================
      [`&${componentCls}-left, &${componentCls}-right`]: {
        [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
          [`${componentCls}-tab + ${componentCls}-tab`]: {
            marginTop: (0,cssinjs_es/* unit */.bf)(cardGutter)
          }
        }
      },
      [`&${componentCls}-left`]: {
        [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
          [`${componentCls}-tab`]: {
            borderRadius: {
              _skip_check_: true,
              value: `${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} 0 0 ${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)}`
            }
          },
          [`${componentCls}-tab-active`]: {
            borderRightColor: {
              _skip_check_: true,
              value: token.colorBgContainer
            }
          }
        }
      },
      [`&${componentCls}-right`]: {
        [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
          [`${componentCls}-tab`]: {
            borderRadius: {
              _skip_check_: true,
              value: `0 ${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} ${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} 0`
            }
          },
          [`${componentCls}-tab-active`]: {
            borderLeftColor: {
              _skip_check_: true,
              value: token.colorBgContainer
            }
          }
        }
      }
    }
  };
};
const genDropdownStyle = token => {
  const {
    componentCls,
    itemHoverColor,
    dropdownEdgeChildVerticalPadding
  } = token;
  return {
    [`${componentCls}-dropdown`]: Object.assign(Object.assign({}, resetComponent(token)), {
      position: 'absolute',
      top: -9999,
      left: {
        _skip_check_: true,
        value: -9999
      },
      zIndex: token.zIndexPopup,
      display: 'block',
      '&-hidden': {
        display: 'none'
      },
      [`${componentCls}-dropdown-menu`]: {
        maxHeight: token.tabsDropdownHeight,
        margin: 0,
        padding: `${(0,cssinjs_es/* unit */.bf)(dropdownEdgeChildVerticalPadding)} 0`,
        overflowX: 'hidden',
        overflowY: 'auto',
        textAlign: {
          _skip_check_: true,
          value: 'left'
        },
        listStyleType: 'none',
        backgroundColor: token.colorBgContainer,
        backgroundClip: 'padding-box',
        borderRadius: token.borderRadiusLG,
        outline: 'none',
        boxShadow: token.boxShadowSecondary,
        '&-item': Object.assign(Object.assign({}, textEllipsis), {
          display: 'flex',
          alignItems: 'center',
          minWidth: token.tabsDropdownWidth,
          margin: 0,
          padding: `${(0,cssinjs_es/* unit */.bf)(token.paddingXXS)} ${(0,cssinjs_es/* unit */.bf)(token.paddingSM)}`,
          color: token.colorText,
          fontWeight: 'normal',
          fontSize: token.fontSize,
          lineHeight: token.lineHeight,
          cursor: 'pointer',
          transition: `all ${token.motionDurationSlow}`,
          '> span': {
            flex: 1,
            whiteSpace: 'nowrap'
          },
          '&-remove': {
            flex: 'none',
            marginLeft: {
              _skip_check_: true,
              value: token.marginSM
            },
            color: token.colorIcon,
            fontSize: token.fontSizeSM,
            background: 'transparent',
            border: 0,
            cursor: 'pointer',
            '&:hover': {
              color: itemHoverColor
            }
          },
          '&:hover': {
            background: token.controlItemBgHover
          },
          '&-disabled': {
            '&, &:hover': {
              color: token.colorTextDisabled,
              background: 'transparent',
              cursor: 'not-allowed'
            }
          }
        })
      }
    })
  };
};
const genPositionStyle = token => {
  const {
    componentCls,
    margin,
    colorBorderSecondary,
    horizontalMargin,
    verticalItemPadding,
    verticalItemMargin,
    calc
  } = token;
  return {
    // ========================== Top & Bottom ==========================
    [`${componentCls}-top, ${componentCls}-bottom`]: {
      flexDirection: 'column',
      [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
        margin: horizontalMargin,
        '&::before': {
          position: 'absolute',
          right: {
            _skip_check_: true,
            value: 0
          },
          left: {
            _skip_check_: true,
            value: 0
          },
          borderBottom: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
          content: "''"
        },
        [`${componentCls}-ink-bar`]: {
          height: token.lineWidthBold,
          '&-animated': {
            transition: `width ${token.motionDurationSlow}, left ${token.motionDurationSlow},
            right ${token.motionDurationSlow}`
          }
        },
        [`${componentCls}-nav-wrap`]: {
          '&::before, &::after': {
            top: 0,
            bottom: 0,
            width: token.controlHeight
          },
          '&::before': {
            left: {
              _skip_check_: true,
              value: 0
            },
            boxShadow: token.boxShadowTabsOverflowLeft
          },
          '&::after': {
            right: {
              _skip_check_: true,
              value: 0
            },
            boxShadow: token.boxShadowTabsOverflowRight
          },
          [`&${componentCls}-nav-wrap-ping-left::before`]: {
            opacity: 1
          },
          [`&${componentCls}-nav-wrap-ping-right::after`]: {
            opacity: 1
          }
        }
      }
    },
    [`${componentCls}-top`]: {
      [`> ${componentCls}-nav,
        > div > ${componentCls}-nav`]: {
        '&::before': {
          bottom: 0
        },
        [`${componentCls}-ink-bar`]: {
          bottom: 0
        }
      }
    },
    [`${componentCls}-bottom`]: {
      [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
        order: 1,
        marginTop: margin,
        marginBottom: 0,
        '&::before': {
          top: 0
        },
        [`${componentCls}-ink-bar`]: {
          top: 0
        }
      },
      [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
        order: 0
      }
    },
    // ========================== Left & Right ==========================
    [`${componentCls}-left, ${componentCls}-right`]: {
      [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
        flexDirection: 'column',
        minWidth: calc(token.controlHeight).mul(1.25).equal(),
        // >>>>>>>>>>> Tab
        [`${componentCls}-tab`]: {
          padding: verticalItemPadding,
          textAlign: 'center'
        },
        [`${componentCls}-tab + ${componentCls}-tab`]: {
          margin: verticalItemMargin
        },
        // >>>>>>>>>>> Nav
        [`${componentCls}-nav-wrap`]: {
          flexDirection: 'column',
          '&::before, &::after': {
            right: {
              _skip_check_: true,
              value: 0
            },
            left: {
              _skip_check_: true,
              value: 0
            },
            height: token.controlHeight
          },
          '&::before': {
            top: 0,
            boxShadow: token.boxShadowTabsOverflowTop
          },
          '&::after': {
            bottom: 0,
            boxShadow: token.boxShadowTabsOverflowBottom
          },
          [`&${componentCls}-nav-wrap-ping-top::before`]: {
            opacity: 1
          },
          [`&${componentCls}-nav-wrap-ping-bottom::after`]: {
            opacity: 1
          }
        },
        // >>>>>>>>>>> Ink Bar
        [`${componentCls}-ink-bar`]: {
          width: token.lineWidthBold,
          '&-animated': {
            transition: `height ${token.motionDurationSlow}, top ${token.motionDurationSlow}`
          }
        },
        [`${componentCls}-nav-list, ${componentCls}-nav-operations`]: {
          flex: '1 0 auto',
          // fix safari scroll problem
          flexDirection: 'column'
        }
      }
    },
    [`${componentCls}-left`]: {
      [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
        [`${componentCls}-ink-bar`]: {
          right: {
            _skip_check_: true,
            value: 0
          }
        }
      },
      [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
        marginLeft: {
          _skip_check_: true,
          value: (0,cssinjs_es/* unit */.bf)(calc(token.lineWidth).mul(-1).equal())
        },
        borderLeft: {
          _skip_check_: true,
          value: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
        },
        [`> ${componentCls}-content > ${componentCls}-tabpane`]: {
          paddingLeft: {
            _skip_check_: true,
            value: token.paddingLG
          }
        }
      }
    },
    [`${componentCls}-right`]: {
      [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
        order: 1,
        [`${componentCls}-ink-bar`]: {
          left: {
            _skip_check_: true,
            value: 0
          }
        }
      },
      [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
        order: 0,
        marginRight: {
          _skip_check_: true,
          value: calc(token.lineWidth).mul(-1).equal()
        },
        borderRight: {
          _skip_check_: true,
          value: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
        },
        [`> ${componentCls}-content > ${componentCls}-tabpane`]: {
          paddingRight: {
            _skip_check_: true,
            value: token.paddingLG
          }
        }
      }
    }
  };
};
const style_genSizeStyle = token => {
  const {
    componentCls,
    cardPaddingSM,
    cardPaddingLG,
    cardHeightSM,
    cardHeightLG,
    horizontalItemPaddingSM,
    horizontalItemPaddingLG
  } = token;
  return {
    // >>>>> shared
    [componentCls]: {
      '&-small': {
        [`> ${componentCls}-nav`]: {
          [`${componentCls}-tab`]: {
            padding: horizontalItemPaddingSM,
            fontSize: token.titleFontSizeSM
          }
        }
      },
      '&-large': {
        [`> ${componentCls}-nav`]: {
          [`${componentCls}-tab`]: {
            padding: horizontalItemPaddingLG,
            fontSize: token.titleFontSizeLG,
            lineHeight: token.lineHeightLG
          }
        }
      }
    },
    // >>>>> card
    [`${componentCls}-card`]: {
      // Small
      [`&${componentCls}-small`]: {
        [`> ${componentCls}-nav`]: {
          [`${componentCls}-tab`]: {
            padding: cardPaddingSM
          },
          [`${componentCls}-nav-add`]: {
            minWidth: cardHeightSM,
            minHeight: cardHeightSM
          }
        },
        [`&${componentCls}-bottom`]: {
          [`> ${componentCls}-nav ${componentCls}-tab`]: {
            borderRadius: `0 0 ${(0,cssinjs_es/* unit */.bf)(token.borderRadius)} ${(0,cssinjs_es/* unit */.bf)(token.borderRadius)}`
          }
        },
        [`&${componentCls}-top`]: {
          [`> ${componentCls}-nav ${componentCls}-tab`]: {
            borderRadius: `${(0,cssinjs_es/* unit */.bf)(token.borderRadius)} ${(0,cssinjs_es/* unit */.bf)(token.borderRadius)} 0 0`
          }
        },
        [`&${componentCls}-right`]: {
          [`> ${componentCls}-nav ${componentCls}-tab`]: {
            borderRadius: {
              _skip_check_: true,
              value: `0 ${(0,cssinjs_es/* unit */.bf)(token.borderRadius)} ${(0,cssinjs_es/* unit */.bf)(token.borderRadius)} 0`
            }
          }
        },
        [`&${componentCls}-left`]: {
          [`> ${componentCls}-nav ${componentCls}-tab`]: {
            borderRadius: {
              _skip_check_: true,
              value: `${(0,cssinjs_es/* unit */.bf)(token.borderRadius)} 0 0 ${(0,cssinjs_es/* unit */.bf)(token.borderRadius)}`
            }
          }
        }
      },
      // Large
      [`&${componentCls}-large`]: {
        [`> ${componentCls}-nav`]: {
          [`${componentCls}-tab`]: {
            padding: cardPaddingLG
          },
          [`${componentCls}-nav-add`]: {
            minWidth: cardHeightLG,
            minHeight: cardHeightLG
          }
        }
      }
    }
  };
};
const genTabStyle = token => {
  const {
    componentCls,
    itemActiveColor,
    itemHoverColor,
    iconCls,
    tabsHorizontalItemMargin,
    horizontalItemPadding,
    itemSelectedColor,
    itemColor
  } = token;
  const tabCls = `${componentCls}-tab`;
  return {
    [tabCls]: {
      position: 'relative',
      WebkitTouchCallout: 'none',
      WebkitTapHighlightColor: 'transparent',
      display: 'inline-flex',
      alignItems: 'center',
      padding: horizontalItemPadding,
      fontSize: token.titleFontSize,
      background: 'transparent',
      border: 0,
      outline: 'none',
      cursor: 'pointer',
      color: itemColor,
      '&-btn, &-remove': {
        '&:focus:not(:focus-visible), &:active': {
          color: itemActiveColor
        }
      },
      '&-btn': {
        outline: 'none',
        transition: `all ${token.motionDurationSlow}`,
        [`${tabCls}-icon:not(:last-child)`]: {
          marginInlineEnd: token.marginSM
        }
      },
      '&-remove': Object.assign({
        flex: 'none',
        marginRight: {
          _skip_check_: true,
          value: token.calc(token.marginXXS).mul(-1).equal()
        },
        marginLeft: {
          _skip_check_: true,
          value: token.marginXS
        },
        color: token.colorIcon,
        fontSize: token.fontSizeSM,
        background: 'transparent',
        border: 'none',
        outline: 'none',
        cursor: 'pointer',
        transition: `all ${token.motionDurationSlow}`,
        '&:hover': {
          color: token.colorTextHeading
        }
      }, genFocusStyle(token)),
      '&:hover': {
        color: itemHoverColor
      },
      [`&${tabCls}-active ${tabCls}-btn`]: {
        color: itemSelectedColor,
        textShadow: token.tabsActiveTextShadow
      },
      [`&${tabCls}-focus ${tabCls}-btn:focus-visible`]: genFocusOutline(token),
      [`&${tabCls}-disabled`]: {
        color: token.colorTextDisabled,
        cursor: 'not-allowed'
      },
      [`&${tabCls}-disabled ${tabCls}-btn, &${tabCls}-disabled ${componentCls}-remove`]: {
        '&:focus, &:active': {
          color: token.colorTextDisabled
        }
      },
      [`& ${tabCls}-remove ${iconCls}`]: {
        margin: 0
      },
      [`${iconCls}:not(:last-child)`]: {
        marginRight: {
          _skip_check_: true,
          value: token.marginSM
        }
      }
    },
    [`${tabCls} + ${tabCls}`]: {
      margin: {
        _skip_check_: true,
        value: tabsHorizontalItemMargin
      }
    }
  };
};
const genRtlStyle = token => {
  const {
    componentCls,
    tabsHorizontalItemMarginRTL,
    iconCls,
    cardGutter,
    calc
  } = token;
  const rtlCls = `${componentCls}-rtl`;
  return {
    [rtlCls]: {
      direction: 'rtl',
      [`${componentCls}-nav`]: {
        [`${componentCls}-tab`]: {
          margin: {
            _skip_check_: true,
            value: tabsHorizontalItemMarginRTL
          },
          [`${componentCls}-tab:last-of-type`]: {
            marginLeft: {
              _skip_check_: true,
              value: 0
            }
          },
          [iconCls]: {
            marginRight: {
              _skip_check_: true,
              value: 0
            },
            marginLeft: {
              _skip_check_: true,
              value: (0,cssinjs_es/* unit */.bf)(token.marginSM)
            }
          },
          [`${componentCls}-tab-remove`]: {
            marginRight: {
              _skip_check_: true,
              value: (0,cssinjs_es/* unit */.bf)(token.marginXS)
            },
            marginLeft: {
              _skip_check_: true,
              value: (0,cssinjs_es/* unit */.bf)(calc(token.marginXXS).mul(-1).equal())
            },
            [iconCls]: {
              margin: 0
            }
          }
        }
      },
      [`&${componentCls}-left`]: {
        [`> ${componentCls}-nav`]: {
          order: 1
        },
        [`> ${componentCls}-content-holder`]: {
          order: 0
        }
      },
      [`&${componentCls}-right`]: {
        [`> ${componentCls}-nav`]: {
          order: 0
        },
        [`> ${componentCls}-content-holder`]: {
          order: 1
        }
      },
      // ====================== Card ======================
      [`&${componentCls}-card${componentCls}-top, &${componentCls}-card${componentCls}-bottom`]: {
        [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
          [`${componentCls}-tab + ${componentCls}-tab`]: {
            marginRight: {
              _skip_check_: true,
              value: cardGutter
            },
            marginLeft: {
              _skip_check_: true,
              value: 0
            }
          }
        }
      }
    },
    [`${componentCls}-dropdown-rtl`]: {
      direction: 'rtl'
    },
    [`${componentCls}-menu-item`]: {
      [`${componentCls}-dropdown-rtl`]: {
        textAlign: {
          _skip_check_: true,
          value: 'right'
        }
      }
    }
  };
};
const genTabsStyle = token => {
  const {
    componentCls,
    tabsCardPadding,
    cardHeight,
    cardGutter,
    itemHoverColor,
    itemActiveColor,
    colorBorderSecondary
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), {
      display: 'flex',
      // ========================== Navigation ==========================
      [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
        position: 'relative',
        display: 'flex',
        flex: 'none',
        alignItems: 'center',
        [`${componentCls}-nav-wrap`]: {
          position: 'relative',
          display: 'flex',
          flex: 'auto',
          alignSelf: 'stretch',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          transform: 'translate(0)',
          // Fix chrome render bug
          // >>>>> Ping shadow
          '&::before, &::after': {
            position: 'absolute',
            zIndex: 1,
            opacity: 0,
            transition: `opacity ${token.motionDurationSlow}`,
            content: "''",
            pointerEvents: 'none'
          }
        },
        [`${componentCls}-nav-list`]: {
          position: 'relative',
          display: 'flex',
          transition: `opacity ${token.motionDurationSlow}`
        },
        // >>>>>>>> Operations
        [`${componentCls}-nav-operations`]: {
          display: 'flex',
          alignSelf: 'stretch'
        },
        [`${componentCls}-nav-operations-hidden`]: {
          position: 'absolute',
          visibility: 'hidden',
          pointerEvents: 'none'
        },
        [`${componentCls}-nav-more`]: {
          position: 'relative',
          padding: tabsCardPadding,
          background: 'transparent',
          border: 0,
          color: token.colorText,
          '&::after': {
            position: 'absolute',
            right: {
              _skip_check_: true,
              value: 0
            },
            bottom: 0,
            left: {
              _skip_check_: true,
              value: 0
            },
            height: token.calc(token.controlHeightLG).div(8).equal(),
            transform: 'translateY(100%)',
            content: "''"
          }
        },
        [`${componentCls}-nav-add`]: Object.assign({
          minWidth: cardHeight,
          minHeight: cardHeight,
          marginLeft: {
            _skip_check_: true,
            value: cardGutter
          },
          background: 'transparent',
          border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
          borderRadius: `${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} ${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} 0 0`,
          outline: 'none',
          cursor: 'pointer',
          color: token.colorText,
          transition: `all ${token.motionDurationSlow} ${token.motionEaseInOut}`,
          '&:hover': {
            color: itemHoverColor
          },
          '&:active, &:focus:not(:focus-visible)': {
            color: itemActiveColor
          }
        }, genFocusStyle(token, -3))
      },
      [`${componentCls}-extra-content`]: {
        flex: 'none'
      },
      // ============================ InkBar ============================
      [`${componentCls}-ink-bar`]: {
        position: 'absolute',
        background: token.inkBarColor,
        pointerEvents: 'none'
      }
    }), genTabStyle(token)), {
      // =========================== TabPanes ===========================
      [`${componentCls}-content`]: {
        position: 'relative',
        width: '100%'
      },
      [`${componentCls}-content-holder`]: {
        flex: 'auto',
        minWidth: 0,
        minHeight: 0
      },
      [`${componentCls}-tabpane`]: Object.assign(Object.assign({}, genFocusStyle(token)), {
        '&-hidden': {
          display: 'none'
        }
      })
    }),
    [`${componentCls}-centered`]: {
      [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
        [`${componentCls}-nav-wrap`]: {
          [`&:not([class*='${componentCls}-nav-wrap-ping']) > ${componentCls}-nav-list`]: {
            margin: 'auto'
          }
        }
      }
    }
  };
};
const tabs_style_prepareComponentToken = token => {
  const {
    cardHeight,
    cardHeightSM,
    cardHeightLG,
    controlHeight,
    controlHeightLG
  } = token;
  const mergedCardHeight = cardHeight || controlHeightLG;
  const mergedCardHeightSM = cardHeightSM || controlHeight;
  // `controlHeight` missing XL variable, so we directly write it here:
  const mergedCardHeightLG = cardHeightLG || controlHeightLG + 8;
  return {
    zIndexPopup: token.zIndexPopupBase + 50,
    cardBg: token.colorFillAlter,
    // We can not pass this as valid value,
    // Since `cardHeight` will lock nav add button height.
    cardHeight: mergedCardHeight,
    cardHeightSM: mergedCardHeightSM,
    cardHeightLG: mergedCardHeightLG,
    // Initialize with empty string, because cardPadding will be calculated with cardHeight by default.
    cardPadding: `${(mergedCardHeight - token.fontHeight) / 2 - token.lineWidth}px ${token.padding}px`,
    cardPaddingSM: `${(mergedCardHeightSM - token.fontHeight) / 2 - token.lineWidth}px ${token.paddingXS}px`,
    cardPaddingLG: `${(mergedCardHeightLG - token.fontHeightLG) / 2 - token.lineWidth}px ${token.padding}px`,
    titleFontSize: token.fontSize,
    titleFontSizeLG: token.fontSizeLG,
    titleFontSizeSM: token.fontSize,
    inkBarColor: token.colorPrimary,
    horizontalMargin: `0 0 ${token.margin}px 0`,
    horizontalItemGutter: 32,
    // Fixed Value
    // Initialize with empty string, because horizontalItemMargin will be calculated with horizontalItemGutter by default.
    horizontalItemMargin: ``,
    horizontalItemMarginRTL: ``,
    horizontalItemPadding: `${token.paddingSM}px 0`,
    horizontalItemPaddingSM: `${token.paddingXS}px 0`,
    horizontalItemPaddingLG: `${token.padding}px 0`,
    verticalItemPadding: `${token.paddingXS}px ${token.paddingLG}px`,
    verticalItemMargin: `${token.margin}px 0 0 0`,
    itemColor: token.colorText,
    itemSelectedColor: token.colorPrimary,
    itemHoverColor: token.colorPrimaryHover,
    itemActiveColor: token.colorPrimaryActive,
    cardGutter: token.marginXXS / 2
  };
};
// ============================== Export ==============================
/* harmony default export */ var tabs_style = (genStyleHooks('Tabs', token => {
  const tabsToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    // `cardPadding` is empty by default, so we could calculate with dynamic `cardHeight`
    tabsCardPadding: token.cardPadding,
    dropdownEdgeChildVerticalPadding: token.paddingXXS,
    tabsActiveTextShadow: '0 0 0.25px currentcolor',
    tabsDropdownHeight: 200,
    tabsDropdownWidth: 120,
    tabsHorizontalItemMargin: `0 0 0 ${(0,cssinjs_es/* unit */.bf)(token.horizontalItemGutter)}`,
    tabsHorizontalItemMarginRTL: `0 0 0 ${(0,cssinjs_es/* unit */.bf)(token.horizontalItemGutter)}`
  });
  return [style_genSizeStyle(tabsToken), genRtlStyle(tabsToken), genPositionStyle(tabsToken), genDropdownStyle(tabsToken), genCardStyle(tabsToken), genTabsStyle(tabsToken), style_motion(tabsToken)];
}, tabs_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tabs/TabPane.js
const TabPane = () => null;
if (false) {}
/* harmony default export */ var tabs_TabPane = (TabPane);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tabs/index.js
"use client";

var tabs_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};














const InternalTabs = /*#__PURE__*/react.forwardRef((props, ref) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
  const {
      type,
      className,
      rootClassName,
      size: customSize,
      onEdit,
      hideAdd,
      centered,
      addIcon,
      removeIcon,
      moreIcon,
      more,
      popupClassName,
      children,
      items,
      animated,
      style,
      indicatorSize,
      indicator,
      destroyInactiveTabPane,
      destroyOnHidden
    } = props,
    otherProps = tabs_rest(props, ["type", "className", "rootClassName", "size", "onEdit", "hideAdd", "centered", "addIcon", "removeIcon", "moreIcon", "more", "popupClassName", "children", "items", "animated", "style", "indicatorSize", "indicator", "destroyInactiveTabPane", "destroyOnHidden"]);
  const {
    prefixCls: customizePrefixCls
  } = otherProps;
  const {
    direction,
    tabs,
    getPrefixCls,
    getPopupContainer
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('tabs', customizePrefixCls);
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = tabs_style(prefixCls, rootCls);
  const tabsRef = react.useRef(null);
  react.useImperativeHandle(ref, () => ({
    nativeElement: tabsRef.current
  }));
  let editable;
  if (type === 'editable-card') {
    editable = {
      onEdit: (editType, {
        key,
        event
      }) => {
        onEdit === null || onEdit === void 0 ? void 0 : onEdit(editType === 'add' ? event : key, editType);
      },
      removeIcon: (_a = removeIcon !== null && removeIcon !== void 0 ? removeIcon : tabs === null || tabs === void 0 ? void 0 : tabs.removeIcon) !== null && _a !== void 0 ? _a : /*#__PURE__*/react.createElement(CloseOutlined/* default */.Z, null),
      addIcon: (addIcon !== null && addIcon !== void 0 ? addIcon : tabs === null || tabs === void 0 ? void 0 : tabs.addIcon) || /*#__PURE__*/react.createElement(PlusOutlined/* default */.Z, null),
      showAdd: hideAdd !== true
    };
  }
  const rootPrefixCls = getPrefixCls();
  if (false) {}
  const size = hooks_useSize(customSize);
  const mergedItems = hooks_useLegacyItems(items, children);
  const mergedAnimated = useAnimateConfig(prefixCls, animated);
  const mergedStyle = Object.assign(Object.assign({}, tabs === null || tabs === void 0 ? void 0 : tabs.style), style);
  const mergedIndicator = {
    align: (_b = indicator === null || indicator === void 0 ? void 0 : indicator.align) !== null && _b !== void 0 ? _b : (_c = tabs === null || tabs === void 0 ? void 0 : tabs.indicator) === null || _c === void 0 ? void 0 : _c.align,
    size: (_g = (_e = (_d = indicator === null || indicator === void 0 ? void 0 : indicator.size) !== null && _d !== void 0 ? _d : indicatorSize) !== null && _e !== void 0 ? _e : (_f = tabs === null || tabs === void 0 ? void 0 : tabs.indicator) === null || _f === void 0 ? void 0 : _f.size) !== null && _g !== void 0 ? _g : tabs === null || tabs === void 0 ? void 0 : tabs.indicatorSize
  };
  return wrapCSSVar(/*#__PURE__*/react.createElement(rc_tabs_es/* default */.Z, Object.assign({
    ref: tabsRef,
    direction: direction,
    getPopupContainer: getPopupContainer
  }, otherProps, {
    items: mergedItems,
    className: classnames_default()({
      [`${prefixCls}-${size}`]: size,
      [`${prefixCls}-card`]: ['card', 'editable-card'].includes(type),
      [`${prefixCls}-editable-card`]: type === 'editable-card',
      [`${prefixCls}-centered`]: centered
    }, tabs === null || tabs === void 0 ? void 0 : tabs.className, className, rootClassName, hashId, cssVarCls, rootCls),
    popupClassName: classnames_default()(popupClassName, hashId, cssVarCls, rootCls),
    style: mergedStyle,
    editable: editable,
    more: Object.assign({
      icon: (_l = (_k = (_j = (_h = tabs === null || tabs === void 0 ? void 0 : tabs.more) === null || _h === void 0 ? void 0 : _h.icon) !== null && _j !== void 0 ? _j : tabs === null || tabs === void 0 ? void 0 : tabs.moreIcon) !== null && _k !== void 0 ? _k : moreIcon) !== null && _l !== void 0 ? _l : /*#__PURE__*/react.createElement(EllipsisOutlined/* default */.Z, null),
      transitionName: `${rootPrefixCls}-slide-up`
    }, more),
    prefixCls: prefixCls,
    animated: mergedAnimated,
    indicator: mergedIndicator,
    // TODO: In the future, destroyInactiveTabPane in rc-tabs needs to be upgrade to destroyOnHidden
    destroyInactiveTabPane: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : destroyInactiveTabPane
  })));
});
const Tabs = InternalTabs;
Tabs.TabPane = tabs_TabPane;
if (false) {}
/* harmony default export */ var es_tabs = (Tabs);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/card/Grid.js
"use client";

var Grid_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};



const Grid = _a => {
  var {
      prefixCls,
      className,
      hoverable = true
    } = _a,
    props = Grid_rest(_a, ["prefixCls", "className", "hoverable"]);
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefix = getPrefixCls('card', prefixCls);
  const classString = classnames_default()(`${prefix}-grid`, className, {
    [`${prefix}-grid-hoverable`]: hoverable
  });
  return /*#__PURE__*/react.createElement("div", Object.assign({}, props, {
    className: classString
  }));
};
/* harmony default export */ var card_Grid = (Grid);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/card/style/index.js



// ============================== Styles ==============================
// ============================== Head ==============================
const genCardHeadStyle = token => {
  const {
    antCls,
    componentCls,
    headerHeight,
    headerPadding,
    tabsMarginBottom
  } = token;
  return Object.assign(Object.assign({
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    minHeight: headerHeight,
    marginBottom: -1,
    padding: `0 ${(0,cssinjs_es/* unit */.bf)(headerPadding)}`,
    color: token.colorTextHeading,
    fontWeight: token.fontWeightStrong,
    fontSize: token.headerFontSize,
    background: token.headerBg,
    borderBottom: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorBorderSecondary}`,
    borderRadius: `${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} ${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} 0 0`
  }, clearFix()), {
    '&-wrapper': {
      width: '100%',
      display: 'flex',
      alignItems: 'center'
    },
    '&-title': Object.assign(Object.assign({
      display: 'inline-block',
      flex: 1
    }, textEllipsis), {
      [`
          > ${componentCls}-typography,
          > ${componentCls}-typography-edit-content
        `]: {
        insetInlineStart: 0,
        marginTop: 0,
        marginBottom: 0
      }
    }),
    [`${antCls}-tabs-top`]: {
      clear: 'both',
      marginBottom: tabsMarginBottom,
      color: token.colorText,
      fontWeight: 'normal',
      fontSize: token.fontSize,
      '&-bar': {
        borderBottom: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorBorderSecondary}`
      }
    }
  });
};
// ============================== Grid ==============================
const genCardGridStyle = token => {
  const {
    cardPaddingBase,
    colorBorderSecondary,
    cardShadow,
    lineWidth
  } = token;
  return {
    width: '33.33%',
    padding: cardPaddingBase,
    border: 0,
    borderRadius: 0,
    boxShadow: `
      ${(0,cssinjs_es/* unit */.bf)(lineWidth)} 0 0 0 ${colorBorderSecondary},
      0 ${(0,cssinjs_es/* unit */.bf)(lineWidth)} 0 0 ${colorBorderSecondary},
      ${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${(0,cssinjs_es/* unit */.bf)(lineWidth)} 0 0 ${colorBorderSecondary},
      ${(0,cssinjs_es/* unit */.bf)(lineWidth)} 0 0 0 ${colorBorderSecondary} inset,
      0 ${(0,cssinjs_es/* unit */.bf)(lineWidth)} 0 0 ${colorBorderSecondary} inset;
    `,
    transition: `all ${token.motionDurationMid}`,
    '&-hoverable:hover': {
      position: 'relative',
      zIndex: 1,
      boxShadow: cardShadow
    }
  };
};
// ============================== Actions ==============================
const genCardActionsStyle = token => {
  const {
    componentCls,
    iconCls,
    actionsLiMargin,
    cardActionsIconSize,
    colorBorderSecondary,
    actionsBg
  } = token;
  return Object.assign(Object.assign({
    margin: 0,
    padding: 0,
    listStyle: 'none',
    background: actionsBg,
    borderTop: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
    display: 'flex',
    borderRadius: `0 0 ${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} ${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)}`
  }, clearFix()), {
    '& > li': {
      margin: actionsLiMargin,
      color: token.colorTextDescription,
      textAlign: 'center',
      '> span': {
        position: 'relative',
        display: 'block',
        minWidth: token.calc(token.cardActionsIconSize).mul(2).equal(),
        fontSize: token.fontSize,
        lineHeight: token.lineHeight,
        cursor: 'pointer',
        '&:hover': {
          color: token.colorPrimary,
          transition: `color ${token.motionDurationMid}`
        },
        [`a:not(${componentCls}-btn), > ${iconCls}`]: {
          display: 'inline-block',
          width: '100%',
          color: token.colorIcon,
          lineHeight: (0,cssinjs_es/* unit */.bf)(token.fontHeight),
          transition: `color ${token.motionDurationMid}`,
          '&:hover': {
            color: token.colorPrimary
          }
        },
        [`> ${iconCls}`]: {
          fontSize: cardActionsIconSize,
          lineHeight: (0,cssinjs_es/* unit */.bf)(token.calc(cardActionsIconSize).mul(token.lineHeight).equal())
        }
      },
      '&:not(:last-child)': {
        borderInlineEnd: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`
      }
    }
  });
};
// ============================== Meta ==============================
const genCardMetaStyle = token => Object.assign(Object.assign({
  margin: `${(0,cssinjs_es/* unit */.bf)(token.calc(token.marginXXS).mul(-1).equal())} 0`,
  display: 'flex'
}, clearFix()), {
  '&-avatar': {
    paddingInlineEnd: token.padding
  },
  '&-detail': {
    overflow: 'hidden',
    flex: 1,
    '> div:not(:last-child)': {
      marginBottom: token.marginXS
    }
  },
  '&-title': Object.assign({
    color: token.colorTextHeading,
    fontWeight: token.fontWeightStrong,
    fontSize: token.fontSizeLG
  }, textEllipsis),
  '&-description': {
    color: token.colorTextDescription
  }
});
// ============================== Inner ==============================
const genCardTypeInnerStyle = token => {
  const {
    componentCls,
    colorFillAlter,
    headerPadding,
    bodyPadding
  } = token;
  return {
    [`${componentCls}-head`]: {
      padding: `0 ${(0,cssinjs_es/* unit */.bf)(headerPadding)}`,
      background: colorFillAlter,
      '&-title': {
        fontSize: token.fontSize
      }
    },
    [`${componentCls}-body`]: {
      padding: `${(0,cssinjs_es/* unit */.bf)(token.padding)} ${(0,cssinjs_es/* unit */.bf)(bodyPadding)}`
    }
  };
};
// ============================== Loading ==============================
const genCardLoadingStyle = token => {
  const {
    componentCls
  } = token;
  return {
    overflow: 'hidden',
    [`${componentCls}-body`]: {
      userSelect: 'none'
    }
  };
};
// ============================== Basic ==============================
const style_genCardStyle = token => {
  const {
    componentCls,
    cardShadow,
    cardHeadPadding,
    colorBorderSecondary,
    boxShadowTertiary,
    bodyPadding,
    extraColor
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      position: 'relative',
      background: token.colorBgContainer,
      borderRadius: token.borderRadiusLG,
      [`&:not(${componentCls}-bordered)`]: {
        boxShadow: boxShadowTertiary
      },
      [`${componentCls}-head`]: genCardHeadStyle(token),
      [`${componentCls}-extra`]: {
        // https://stackoverflow.com/a/22429853/3040605
        marginInlineStart: 'auto',
        color: extraColor,
        fontWeight: 'normal',
        fontSize: token.fontSize
      },
      [`${componentCls}-body`]: Object.assign({
        padding: bodyPadding,
        borderRadius: `0 0 ${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} ${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)}`
      }, clearFix()),
      [`${componentCls}-grid`]: genCardGridStyle(token),
      [`${componentCls}-cover`]: {
        '> *': {
          display: 'block',
          width: '100%',
          borderRadius: `${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} ${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} 0 0`
        }
      },
      [`${componentCls}-actions`]: genCardActionsStyle(token),
      [`${componentCls}-meta`]: genCardMetaStyle(token)
    }),
    [`${componentCls}-bordered`]: {
      border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
      [`${componentCls}-cover`]: {
        marginTop: -1,
        marginInlineStart: -1,
        marginInlineEnd: -1
      }
    },
    [`${componentCls}-hoverable`]: {
      cursor: 'pointer',
      transition: `box-shadow ${token.motionDurationMid}, border-color ${token.motionDurationMid}`,
      '&:hover': {
        borderColor: 'transparent',
        boxShadow: cardShadow
      }
    },
    [`${componentCls}-contain-grid`]: {
      borderRadius: `${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} ${(0,cssinjs_es/* unit */.bf)(token.borderRadiusLG)} 0 0 `,
      [`${componentCls}-body`]: {
        display: 'flex',
        flexWrap: 'wrap'
      },
      [`&:not(${componentCls}-loading) ${componentCls}-body`]: {
        marginBlockStart: token.calc(token.lineWidth).mul(-1).equal(),
        marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
        padding: 0
      }
    },
    [`${componentCls}-contain-tabs`]: {
      [`> div${componentCls}-head`]: {
        minHeight: 0,
        [`${componentCls}-head-title, ${componentCls}-extra`]: {
          paddingTop: cardHeadPadding
        }
      }
    },
    [`${componentCls}-type-inner`]: genCardTypeInnerStyle(token),
    [`${componentCls}-loading`]: genCardLoadingStyle(token),
    [`${componentCls}-rtl`]: {
      direction: 'rtl'
    }
  };
};
// ============================== Size ==============================
const genCardSizeStyle = token => {
  const {
    componentCls,
    bodyPaddingSM,
    headerPaddingSM,
    headerHeightSM,
    headerFontSizeSM
  } = token;
  return {
    [`${componentCls}-small`]: {
      [`> ${componentCls}-head`]: {
        minHeight: headerHeightSM,
        padding: `0 ${(0,cssinjs_es/* unit */.bf)(headerPaddingSM)}`,
        fontSize: headerFontSizeSM,
        [`> ${componentCls}-head-wrapper`]: {
          [`> ${componentCls}-extra`]: {
            fontSize: token.fontSize
          }
        }
      },
      [`> ${componentCls}-body`]: {
        padding: bodyPaddingSM
      }
    },
    [`${componentCls}-small${componentCls}-contain-tabs`]: {
      [`> ${componentCls}-head`]: {
        [`${componentCls}-head-title, ${componentCls}-extra`]: {
          paddingTop: 0,
          display: 'flex',
          alignItems: 'center'
        }
      }
    }
  };
};
const card_style_prepareComponentToken = token => {
  var _a, _b;
  return {
    headerBg: 'transparent',
    headerFontSize: token.fontSizeLG,
    headerFontSizeSM: token.fontSize,
    headerHeight: token.fontSizeLG * token.lineHeightLG + token.padding * 2,
    headerHeightSM: token.fontSize * token.lineHeight + token.paddingXS * 2,
    actionsBg: token.colorBgContainer,
    actionsLiMargin: `${token.paddingSM}px 0`,
    tabsMarginBottom: -token.padding - token.lineWidth,
    extraColor: token.colorText,
    bodyPaddingSM: 12,
    // Fixed padding.
    headerPaddingSM: 12,
    bodyPadding: (_a = token.bodyPadding) !== null && _a !== void 0 ? _a : token.paddingLG,
    headerPadding: (_b = token.headerPadding) !== null && _b !== void 0 ? _b : token.paddingLG
  };
};
// ============================== Export ==============================
/* harmony default export */ var card_style = (genStyleHooks('Card', token => {
  const cardToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    cardShadow: token.boxShadowCard,
    cardHeadPadding: token.padding,
    cardPaddingBase: token.paddingLG,
    cardActionsIconSize: token.fontSize
  });
  return [
  // Style
  style_genCardStyle(cardToken),
  // Size
  genCardSizeStyle(cardToken)];
}, card_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/card/Card.js
"use client";

var Card_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};











const ActionNode = props => {
  const {
    actionClasses,
    actions = [],
    actionStyle
  } = props;
  return /*#__PURE__*/react.createElement("ul", {
    className: actionClasses,
    style: actionStyle
  }, actions.map((action, index) => {
    // Move this out since eslint not allow index key
    // And eslint-disable makes conflict with rollup
    // ref https://github.com/ant-design/ant-design/issues/46022
    const key = `action-${index}`;
    return /*#__PURE__*/react.createElement("li", {
      style: {
        width: `${100 / actions.length}%`
      },
      key: key
    }, /*#__PURE__*/react.createElement("span", null, action));
  }));
};
const Card = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      style,
      extra,
      headStyle = {},
      bodyStyle = {},
      title,
      loading,
      bordered,
      variant: customVariant,
      size: customizeSize,
      type,
      cover,
      actions,
      tabList,
      children,
      activeTabKey,
      defaultActiveTabKey,
      tabBarExtraContent,
      hoverable,
      tabProps = {},
      classNames: customClassNames,
      styles: customStyles
    } = props,
    others = Card_rest(props, ["prefixCls", "className", "rootClassName", "style", "extra", "headStyle", "bodyStyle", "title", "loading", "bordered", "variant", "size", "type", "cover", "actions", "tabList", "children", "activeTabKey", "defaultActiveTabKey", "tabBarExtraContent", "hoverable", "tabProps", "classNames", "styles"]);
  const {
    getPrefixCls,
    direction,
    card
  } = react.useContext(ConfigContext);
  const [variant] = useVariants('card', customVariant, bordered);
  // =================Warning===================
  if (false) {}
  const onTabChange = key => {
    var _a;
    (_a = props.onTabChange) === null || _a === void 0 ? void 0 : _a.call(props, key);
  };
  const moduleClass = moduleName => {
    var _a;
    return classnames_default()((_a = card === null || card === void 0 ? void 0 : card.classNames) === null || _a === void 0 ? void 0 : _a[moduleName], customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames[moduleName]);
  };
  const moduleStyle = moduleName => {
    var _a;
    return Object.assign(Object.assign({}, (_a = card === null || card === void 0 ? void 0 : card.styles) === null || _a === void 0 ? void 0 : _a[moduleName]), customStyles === null || customStyles === void 0 ? void 0 : customStyles[moduleName]);
  };
  const isContainGrid = react.useMemo(() => {
    let containGrid = false;
    react.Children.forEach(children, element => {
      if ((element === null || element === void 0 ? void 0 : element.type) === card_Grid) {
        containGrid = true;
      }
    });
    return containGrid;
  }, [children]);
  const prefixCls = getPrefixCls('card', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = card_style(prefixCls);
  const loadingBlock = /*#__PURE__*/react.createElement(skeleton, {
    loading: true,
    active: true,
    paragraph: {
      rows: 4
    },
    title: false
  }, children);
  const hasActiveTabKey = activeTabKey !== undefined;
  const extraProps = Object.assign(Object.assign({}, tabProps), {
    [hasActiveTabKey ? 'activeKey' : 'defaultActiveKey']: hasActiveTabKey ? activeTabKey : defaultActiveTabKey,
    tabBarExtraContent
  });
  let head;
  const mergedSize = hooks_useSize(customizeSize);
  const tabSize = !mergedSize || mergedSize === 'default' ? 'large' : mergedSize;
  const tabs = tabList ? (/*#__PURE__*/react.createElement(es_tabs, Object.assign({
    size: tabSize
  }, extraProps, {
    className: `${prefixCls}-head-tabs`,
    onChange: onTabChange,
    items: tabList.map(_a => {
      var {
          tab
        } = _a,
        item = Card_rest(_a, ["tab"]);
      return Object.assign({
        label: tab
      }, item);
    })
  }))) : null;
  if (title || extra || tabs) {
    const headClasses = classnames_default()(`${prefixCls}-head`, moduleClass('header'));
    const titleClasses = classnames_default()(`${prefixCls}-head-title`, moduleClass('title'));
    const extraClasses = classnames_default()(`${prefixCls}-extra`, moduleClass('extra'));
    const mergedHeadStyle = Object.assign(Object.assign({}, headStyle), moduleStyle('header'));
    head = /*#__PURE__*/react.createElement("div", {
      className: headClasses,
      style: mergedHeadStyle
    }, /*#__PURE__*/react.createElement("div", {
      className: `${prefixCls}-head-wrapper`
    }, title && (/*#__PURE__*/react.createElement("div", {
      className: titleClasses,
      style: moduleStyle('title')
    }, title)), extra && (/*#__PURE__*/react.createElement("div", {
      className: extraClasses,
      style: moduleStyle('extra')
    }, extra))), tabs);
  }
  const coverClasses = classnames_default()(`${prefixCls}-cover`, moduleClass('cover'));
  const coverDom = cover ? (/*#__PURE__*/react.createElement("div", {
    className: coverClasses,
    style: moduleStyle('cover')
  }, cover)) : null;
  const bodyClasses = classnames_default()(`${prefixCls}-body`, moduleClass('body'));
  const mergedBodyStyle = Object.assign(Object.assign({}, bodyStyle), moduleStyle('body'));
  const body = /*#__PURE__*/react.createElement("div", {
    className: bodyClasses,
    style: mergedBodyStyle
  }, loading ? loadingBlock : children);
  const actionClasses = classnames_default()(`${prefixCls}-actions`, moduleClass('actions'));
  const actionDom = (actions === null || actions === void 0 ? void 0 : actions.length) ? (/*#__PURE__*/react.createElement(ActionNode, {
    actionClasses: actionClasses,
    actionStyle: moduleStyle('actions'),
    actions: actions
  })) : null;
  const divProps = (0,omit/* default */.Z)(others, ['onTabChange']);
  const classString = classnames_default()(prefixCls, card === null || card === void 0 ? void 0 : card.className, {
    [`${prefixCls}-loading`]: loading,
    [`${prefixCls}-bordered`]: variant !== 'borderless',
    [`${prefixCls}-hoverable`]: hoverable,
    [`${prefixCls}-contain-grid`]: isContainGrid,
    [`${prefixCls}-contain-tabs`]: tabList === null || tabList === void 0 ? void 0 : tabList.length,
    [`${prefixCls}-${mergedSize}`]: mergedSize,
    [`${prefixCls}-type-${type}`]: !!type,
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, className, rootClassName, hashId, cssVarCls);
  const mergedStyle = Object.assign(Object.assign({}, card === null || card === void 0 ? void 0 : card.style), style);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", Object.assign({
    ref: ref
  }, divProps, {
    className: classString,
    style: mergedStyle
  }), head, coverDom, body, actionDom));
});
/* harmony default export */ var card_Card = (Card);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/card/Meta.js
"use client";

var Meta_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};



const Meta = props => {
  const {
      prefixCls: customizePrefixCls,
      className,
      avatar,
      title,
      description
    } = props,
    others = Meta_rest(props, ["prefixCls", "className", "avatar", "title", "description"]);
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('card', customizePrefixCls);
  const classString = classnames_default()(`${prefixCls}-meta`, className);
  const avatarDom = avatar ? (/*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-meta-avatar`
  }, avatar)) : null;
  const titleDom = title ? (/*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-meta-title`
  }, title)) : null;
  const descriptionDom = description ? (/*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-meta-description`
  }, description)) : null;
  const MetaDetail = titleDom || descriptionDom ? (/*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-meta-detail`
  }, titleDom, descriptionDom)) : null;
  return /*#__PURE__*/react.createElement("div", Object.assign({}, others, {
    className: classString
  }), avatarDom, MetaDetail);
};
/* harmony default export */ var card_Meta = (Meta);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/card/index.js
"use client";




const es_card_Card = card_Card;
es_card_Card.Grid = card_Grid;
es_card_Card.Meta = card_Meta;
if (false) {}
/* harmony default export */ var card = (es_card_Card);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(56717);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(58783);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
var isNativeReflectConstruct = __webpack_require__(77536);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(63382);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(57024);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(91032);
;// CONCATENATED MODULE: ./node_modules/@ant-design/react-slick/es/initial-state.js
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0,
  targetSlide: 0
};
/* harmony default export */ var initial_state = (initialState);
// EXTERNAL MODULE: ./node_modules/throttle-debounce/esm/index.js
var esm = __webpack_require__(99422);
;// CONCATENATED MODULE: ./node_modules/@ant-design/react-slick/es/default-props.js

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return /*#__PURE__*/react.createElement("ul", {
      style: {
        display: "block"
      }
    }, dots);
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return /*#__PURE__*/react.createElement("button", null, i + 1);
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true,
  asNavFor: null
};
/* harmony default export */ var default_props = (defaultProps);
;// CONCATENATED MODULE: ./node_modules/@ant-design/react-slick/es/utils/innerSliderUtils.js



function clamp(number, lowerBound, upperBound) {
  return Math.max(lowerBound, Math.min(number, upperBound));
}
var safePreventDefault = function safePreventDefault(event) {
  var passiveEvents = ["onTouchStart", "onTouchMove", "onWheel"];
  if (!passiveEvents.includes(event._reactName)) {
    event.preventDefault();
  }
};
var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};

// return list of slides that need to be present
var getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }
  return requiredSlides;
};

// startIndex that needs to be present
var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};

// get width of an element
var innerSliderUtils_getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }
  return "vertical";
};

// whether or not we can go next
var canGoNext = function canGoNext(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};

// given an object and a list of keys, return new object with given keys
var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};

// get initialized state
var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = react.Children.count(spec.children);
  var listNode = spec.listRef;
  var listWidth = Math.ceil(innerSliderUtils_getWidth(listNode));
  var trackNode = spec.trackRef && spec.trackRef.node;
  var trackWidth = Math.ceil(innerSliderUtils_getWidth(trackNode));
  var slideWidth;
  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, spec), {}, {
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }));
  lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };
  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }
  return state;
};
var slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
    animating = spec.animating,
    fade = spec.fade,
    infinite = spec.infinite,
    index = spec.index,
    slideCount = spec.slideCount,
    lazyLoad = spec.lazyLoad,
    currentSlide = spec.currentSlide,
    centerMode = spec.centerMode,
    slidesToScroll = spec.slidesToScroll,
    slidesToShow = spec.slidesToShow,
    useCSS = spec.useCSS;
  var lazyLoadedList = spec.lazyLoadedList;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
    finalSlide,
    animationLeft,
    finalLeft;
  var state = {},
    nextState = {};
  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);
  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};
    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList = lazyLoadedList.concat(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList,
      targetSlide: animationSlide
    };
    nextState = {
      animating: false,
      targetSlide: animationSlide
    };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }
    if (!infinite && animationSlide + slidesToShow >= slideCount) {
      finalSlide = slideCount - slidesToShow;
    }
    animationLeft = getTrackLeft((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, spec), {}, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, spec), {}, {
      slideIndex: finalSlide
    }));
    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    if (lazyLoad) {
      lazyLoadedList = lazyLoadedList.concat(getOnDemandLazySlides((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, spec), {}, {
        currentSlide: animationSlide
      })));
    }
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, spec), {}, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, spec), {}, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, spec), {}, {
          left: finalLeft
        })),
        swipeLeft: null,
        targetSlide: targetSlide
      };
    }
  }
  return {
    state: state,
    nextState: nextState
  };
};
var changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
    slidesToShow = spec.slidesToShow,
    slideCount = spec.slideCount,
    currentSlide = spec.currentSlide,
    previousTargetSlide = spec.targetSlide,
    lazyLoad = spec.lazyLoad,
    infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
    if (!infinite) {
      targetSlide = previousTargetSlide - slidesToScroll;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
    if (!infinite) {
      targetSlide = previousTargetSlide + slidesToScroll;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;
    if (infinite) {
      var direction = siblingDirection((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, spec), {}, {
        targetSlide: targetSlide
      }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
  }
  return targetSlide;
};
var keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};
var swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && safePreventDefault(e);
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
var swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
    animating = spec.animating,
    vertical = spec.vertical,
    swipeToSlide = spec.swipeToSlide,
    verticalSwiping = spec.verticalSwiping,
    rtl = spec.rtl,
    currentSlide = spec.currentSlide,
    edgeFriction = spec.edgeFriction,
    edgeDragged = spec.edgeDragged,
    onEdge = spec.onEdge,
    swiped = spec.swiped,
    swiping = spec.swiping,
    slideCount = spec.slideCount,
    slidesToScroll = spec.slidesToScroll,
    infinite = spec.infinite,
    touchObject = spec.touchObject,
    swipeEvent = spec.swipeEvent,
    listHeight = spec.listHeight,
    listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return safePreventDefault(e);
  if (vertical && swipeToSlide && verticalSwiping) safePreventDefault(e);
  var swipeLeft,
    state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }
  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, state), {}, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, spec), {}, {
      left: swipeLeft
    }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    safePreventDefault(e);
  }
  return state;
};
var swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
    swipe = spec.swipe,
    touchObject = spec.touchObject,
    listWidth = spec.listWidth,
    touchThreshold = spec.touchThreshold,
    verticalSwiping = spec.verticalSwiping,
    listHeight = spec.listHeight,
    swipeToSlide = spec.swipeToSlide,
    scrolling = spec.scrolling,
    onSwipe = spec.onSwipe,
    targetSlide = spec.targetSlide,
    currentSlide = spec.currentSlide,
    infinite = spec.infinite;
  if (!dragging) {
    if (swipe) safePreventDefault(e);
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  // reset the state of touch related state variables.
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    safePreventDefault(e);
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount, newSlide;
    var activeSlide = infinite ? currentSlide : targetSlide;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = activeSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = activeSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = activeSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, spec), {}, {
      left: currentLeft
    }));
  }
  return state;
};
var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }
      prevNavigable = navigables[n];
    }
  }
  return index;
};
var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide;
    var slickList = spec.listRef;
    var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + innerSliderUtils_getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }
      return true;
    });
    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};
var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return (
    // eslint-disable-next-line no-prototype-builtins
    keysArray.reduce(function (value, key) {
      return value && spec.hasOwnProperty(key);
    }, true) ? null : console.error("Keys Missing:", spec)
  );
};
var getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    var trackChildren = spec.unslick ? spec.slideCount : spec.slideCount + 2 * spec.slidesToShow;
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, style), {}, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }
  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight;

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }
  return style;
};
var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }
  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
    trackRef = spec.trackRef,
    infinite = spec.infinite,
    centerMode = spec.centerMode,
    slideCount = spec.slideCount,
    slidesToShow = spec.slidesToShow,
    slidesToScroll = spec.slidesToScroll,
    slideWidth = spec.slideWidth,
    listWidth = spec.listWidth,
    variableWidth = spec.variableWidth,
    slideHeight = spec.slideHeight,
    fade = spec.fade,
    vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;
  if (fade || spec.slideCount === 1) {
    return 0;
  }
  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    // shift current slide to center of the frame
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;
  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }
  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = trackRef && trackRef.node;
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }
  return targetLeft;
};
var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};
var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};
var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
    centerMode = _ref.centerMode,
    rtl = _ref.rtl,
    centerPadding = _ref.centerPadding;
  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }
  if (rtl) {
    return 0;
  }
  return slidesToShow - 1;
};
var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
    centerMode = _ref2.centerMode,
    rtl = _ref2.rtl,
    centerPadding = _ref2.centerPadding;
  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }
  if (rtl) {
    return slidesToShow - 1;
  }
  return 0;
};
var canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};
var validSettings = Object.keys(default_props);
function filterSettings(settings) {
  return validSettings.reduce(function (acc, settingName) {
    if (settings.hasOwnProperty(settingName)) {
      acc[settingName] = settings[settingName];
    }
    return acc;
  }, {});
}
;// CONCATENATED MODULE: ./node_modules/@ant-design/react-slick/es/track.js











function _callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, (0,isNativeReflectConstruct/* default */.Z)() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}




// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;
  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  var focusedSlide;
  if (spec.targetSlide < 0) {
    focusedSlide = spec.targetSlide + spec.slideCount;
  } else if (spec.targetSlide >= spec.slideCount) {
    focusedSlide = spec.targetSlide - spec.slideCount;
  } else {
    focusedSlide = spec.targetSlide;
  }
  var slickCurrent = index === focusedSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL
  };
};
var getSlideStyle = function getSlideStyle(spec) {
  var style = {};
  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }
  if (spec.fade) {
    style.position = "relative";
    if (spec.vertical && spec.slideHeight) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.zIndex = spec.currentSlide === spec.index ? 999 : 998;
    if (spec.useCSS) {
      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getKey = function getKey(child, fallbackKey) {
  return child.key + "-" + fallbackKey;
};
var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = react.Children.count(spec.children);
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  react.Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    // in case of lazyLoad, whether or not we want to fetch the slide
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = /*#__PURE__*/react.createElement("div", null);
    }
    var childStyle = getSlideStyle((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, spec), {}, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, spec), {}, {
      index: index
    }));
    // push a cloned element of the desired slide
    slides.push(/*#__PURE__*/react.cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: classnames_default()(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
        outline: "none"
      }, child.props.style || {}), childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));

    // if slide needs to be precloned or postcloned
    if (spec.infinite && childrenCount > 1 && spec.fade === false && !spec.unslick) {
      var preCloneNo = childrenCount - index;
      if (preCloneNo <= getPreClones(spec)) {
        key = -preCloneNo;
        if (key >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, spec), {}, {
          index: key
        }));
        preCloneSlides.push(/*#__PURE__*/react.cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: classnames_default()(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
      key = childrenCount + index;
      if (key < endIndex) {
        child = elem;
      }
      slideClasses = getSlideClasses((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, spec), {}, {
        index: key
      }));
      postCloneSlides.push(/*#__PURE__*/react.cloneElement(child, {
        key: "postcloned" + getKey(child, key),
        "data-index": key,
        tabIndex: "-1",
        className: classnames_default()(slideClasses, slideClass),
        "aria-hidden": !slideClasses["slick-active"],
        style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, child.props.style || {}), childStyle),
        onClick: function onClick(e) {
          child.props && child.props.onClick && child.props.onClick(e);
          if (spec.focusOnSelect) {
            spec.focusOnSelect(childOnClickOptions);
          }
        }
      }));
    }
  });
  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};
var Track = /*#__PURE__*/function (_React$PureComponent) {
  function Track() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, Track);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Track, [].concat(args));
    (0,defineProperty/* default */.Z)(_this, "node", null);
    (0,defineProperty/* default */.Z)(_this, "handleRef", function (ref) {
      _this.node = ref;
    });
    return _this;
  }
  (0,inherits/* default */.Z)(Track, _React$PureComponent);
  return (0,createClass/* default */.Z)(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
        onMouseEnter = _this$props.onMouseEnter,
        onMouseOver = _this$props.onMouseOver,
        onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);
}(react.PureComponent);
;// CONCATENATED MODULE: ./node_modules/@ant-design/react-slick/es/dots.js









function dots_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, (0,isNativeReflectConstruct/* default */.Z)() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}



var getDotCount = function getDotCount(spec) {
  var dots;
  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }
  return dots;
};
var Dots = /*#__PURE__*/function (_React$PureComponent) {
  function Dots() {
    (0,classCallCheck/* default */.Z)(this, Dots);
    return dots_callSuper(this, Dots, arguments);
  }
  (0,inherits/* default */.Z)(Dots, _React$PureComponent);
  return (0,createClass/* default */.Z)(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        onMouseEnter = _this$props.onMouseEnter,
        onMouseOver = _this$props.onMouseOver,
        onMouseLeave = _this$props.onMouseLeave,
        infinite = _this$props.infinite,
        slidesToScroll = _this$props.slidesToScroll,
        slidesToShow = _this$props.slidesToShow,
        slideCount = _this$props.slideCount,
        currentSlide = _this$props.currentSlide;
      var dotCount = getDotCount({
        slideCount: slideCount,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow,
        infinite: infinite
      });
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = [];
      for (var i = 0; i < dotCount; i++) {
        var _rightBound = (i + 1) * slidesToScroll - 1;
        var rightBound = infinite ? _rightBound : clamp(_rightBound, 0, slideCount - 1);
        var _leftBound = rightBound - (slidesToScroll - 1);
        var leftBound = infinite ? _leftBound : clamp(_leftBound, 0, slideCount - 1);
        var className = classnames_default()({
          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: slidesToScroll,
          currentSlide: currentSlide
        };
        var onClick = this.clickHandler.bind(this, dotOptions);
        dots = dots.concat(/*#__PURE__*/react.createElement("li", {
          key: i,
          className: className
        }, /*#__PURE__*/react.cloneElement(this.props.customPaging(i), {
          onClick: onClick
        })));
      }
      return /*#__PURE__*/react.cloneElement(this.props.appendDots(dots), (0,objectSpread2/* default */.Z)({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);
}(react.PureComponent);
;// CONCATENATED MODULE: ./node_modules/@ant-design/react-slick/es/arrows.js










function arrows_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, (0,isNativeReflectConstruct/* default */.Z)() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}



var PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
  function PrevArrow() {
    (0,classCallCheck/* default */.Z)(this, PrevArrow);
    return arrows_callSuper(this, PrevArrow, arguments);
  }
  (0,inherits/* default */.Z)(PrevArrow, _React$PureComponent);
  return (0,createClass/* default */.Z)(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }
      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });
      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }
      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: classnames_default()(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;
      if (this.props.prevArrow) {
        prevArrow = /*#__PURE__*/react.cloneElement(this.props.prevArrow, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, prevArrowProps), customProps));
      } else {
        prevArrow = /*#__PURE__*/react.createElement("button", (0,esm_extends/* default */.Z)({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }
      return prevArrow;
    }
  }]);
}(react.PureComponent);
var NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
  function NextArrow() {
    (0,classCallCheck/* default */.Z)(this, NextArrow);
    return arrows_callSuper(this, NextArrow, arguments);
  }
  (0,inherits/* default */.Z)(NextArrow, _React$PureComponent2);
  return (0,createClass/* default */.Z)(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }
      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });
      if (!canGoNext(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }
      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: classnames_default()(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;
      if (this.props.nextArrow) {
        nextArrow = /*#__PURE__*/react.cloneElement(this.props.nextArrow, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, nextArrowProps), customProps));
      } else {
        nextArrow = /*#__PURE__*/react.createElement("button", (0,esm_extends/* default */.Z)({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }
      return nextArrow;
    }
  }]);
}(react.PureComponent);
// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(13665);
;// CONCATENATED MODULE: ./node_modules/@ant-design/react-slick/es/inner-slider.js













var _excluded = ["animating"];
function inner_slider_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, (0,isNativeReflectConstruct/* default */.Z)() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}









var InnerSlider = /*#__PURE__*/function (_React$Component) {
  function InnerSlider(props) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, InnerSlider);
    _this = inner_slider_callSuper(this, InnerSlider, [props]);
    (0,defineProperty/* default */.Z)(_this, "listRefHandler", function (ref) {
      return _this.list = ref;
    });
    (0,defineProperty/* default */.Z)(_this, "trackRefHandler", function (ref) {
      return _this.track = ref;
    });
    (0,defineProperty/* default */.Z)(_this, "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
        _this.list.style.height = getHeight(elem) + "px";
      }
    });
    (0,defineProperty/* default */.Z)(_this, "componentDidMount", function () {
      _this.props.onInit && _this.props.onInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = getOnDemandLazySlides((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, _this.props), _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      var spec = (0,objectSpread2/* default */.Z)({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);
      _this.updateState(spec, true, function () {
        _this.adaptHeight();
        _this.props.autoplay && _this.autoPlay("playing");
      });
      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }
      _this.ro = new ResizeObserver_es/* default */.Z(function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });
      _this.ro.observe(_this.list);
      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });
      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });
    (0,defineProperty/* default */.Z)(_this, "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }
      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }
      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        _this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      _this.ro.disconnect();
    });
    (0,defineProperty/* default */.Z)(_this, "componentDidUpdate", function (prevProps) {
      _this.checkImagesLoad();
      _this.props.onReInit && _this.props.onReInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = getOnDemandLazySlides((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, _this.props), _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }
      _this.adaptHeight();
      var spec = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);
      var setTrackStyle = _this.didPropsChange(prevProps);
      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= react.Children.count(_this.props.children)) {
          _this.changeSlide({
            message: "index",
            index: react.Children.count(_this.props.children) - _this.props.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }
        if (prevProps.autoplay !== _this.props.autoplay || prevProps.autoplaySpeed !== _this.props.autoplaySpeed) {
          if (!prevProps.autoplay && _this.props.autoplay) {
            _this.autoPlay("playing");
          } else if (_this.props.autoplay) {
            _this.autoPlay("update");
          } else {
            _this.pause("paused");
          }
        }
      });
    });
    (0,defineProperty/* default */.Z)(_this, "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0,esm/* debounce */.D)(50, function () {
        return _this.resizeWindow(setTrackStyle);
      });
      _this.debouncedResize();
    });
    (0,defineProperty/* default */.Z)(_this, "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var isTrackMounted = Boolean(_this.track && _this.track.node);
      // prevent warning: setting state on unmounted component (server side rendering)
      if (!isTrackMounted) return;
      var spec = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });
      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });
    (0,defineProperty/* default */.Z)(_this, "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = initializedState(spec);
      spec = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, spec), updatedState), {}, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = getTrackLeft(spec);
      spec = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, spec), {}, {
        left: targetLeft
      });
      var trackStyle = getTrackCSS(spec);
      if (setTrackStyle || react.Children.count(_this.props.children) !== react.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this.setState(updatedState, callback);
    });
    (0,defineProperty/* default */.Z)(_this, "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
          _trackLeft = 0;
        var childrenWidths = [];
        var preClones = getPreClones((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));
        var postClones = getPostClones((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i = 0; _i < postClones; _i++) {
          _trackWidth += childrenWidths[_i];
        }
        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
          _trackLeft += childrenWidths[_i2];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }
        return {
          trackStyle: _trackStyle
        };
      }
      var childrenCount = react.Children.count(_this.props.children);
      var spec = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, _this.props), _this.state), {}, {
        slideCount: childrenCount
      });
      var slideCount = getPreClones(spec) + getPostClones(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * (getPreClones(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      return {
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      };
    });
    (0,defineProperty/* default */.Z)(_this, "checkImagesLoad", function () {
      var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
      var imagesCount = images.length,
        loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function (e) {
            prevClickHandler(e);
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });
    (0,defineProperty/* default */.Z)(_this, "progressiveLazyLoad", function () {
      var slidesToLoad = [];
      var spec = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, _this.props), _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + getPostClones(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -getPreClones(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });
    (0,defineProperty/* default */.Z)(_this, "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
        asNavFor = _this$props.asNavFor,
        beforeChange = _this$props.beforeChange,
        onLazyLoad = _this$props.onLazyLoad,
        speed = _this$props.speed,
        afterChange = _this$props.afterChange;
      // capture currentslide before state is updated
      var currentSlide = _this.state.currentSlide;
      var _slideHandler = slideHandler((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
          index: index
        }, _this.props), _this.state), {}, {
          trackRef: _this.track,
          useCSS: _this.props.useCSS && !dontAnimate
        })),
        state = _slideHandler.state,
        nextState = _slideHandler.nextState;
      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
        afterChange && afterChange(currentSlide);
        delete _this.animationEndCallback;
      }
      _this.setState(state, function () {
        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
        if (asNavFor && _this.asNavForIndex !== index) {
          _this.asNavForIndex = index;
          asNavFor.innerSlider.slideHandler(index);
        }
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
            firstBatch = (0,objectWithoutProperties/* default */.Z)(nextState, _excluded);
          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });
    (0,defineProperty/* default */.Z)(_this, "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var spec = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, _this.props), _this.state);
      var targetSlide = changeSlide(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
      _this.props.autoplay && _this.autoPlay("update");
      if (_this.props.focusOnSelect) {
        var nodes = _this.list.querySelectorAll(".slick-current");
        nodes[0] && nodes[0].focus();
      }
    });
    (0,defineProperty/* default */.Z)(_this, "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    });
    (0,defineProperty/* default */.Z)(_this, "keyHandler", function (e) {
      var dir = keyHandler(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });
    (0,defineProperty/* default */.Z)(_this, "selectHandler", function (options) {
      _this.changeSlide(options);
    });
    (0,defineProperty/* default */.Z)(_this, "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    });
    (0,defineProperty/* default */.Z)(_this, "enableBodyScroll", function () {
      window.ontouchmove = null;
    });
    (0,defineProperty/* default */.Z)(_this, "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = swipeStart(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });
    (0,defineProperty/* default */.Z)(_this, "swipeMove", function (e) {
      var state = swipeMove(e, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      if (state["swiping"]) {
        _this.clickable = false;
      }
      _this.setState(state);
    });
    (0,defineProperty/* default */.Z)(_this, "swipeEnd", function (e) {
      var state = swipeEnd(e, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this.setState(state);
      if (triggerSlideHandler === undefined) return;
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });
    (0,defineProperty/* default */.Z)(_this, "touchEnd", function (e) {
      _this.swipeEnd(e);
      _this.clickable = true;
    });
    (0,defineProperty/* default */.Z)(_this, "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });
    (0,defineProperty/* default */.Z)(_this, "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });
    (0,defineProperty/* default */.Z)(_this, "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });
    (0,defineProperty/* default */.Z)(_this, "play", function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if (canGoNext((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, _this.props), _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }
      _this.slideHandler(nextIndex);
    });
    (0,defineProperty/* default */.Z)(_this, "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({
        autoplaying: "playing"
      });
    });
    (0,defineProperty/* default */.Z)(_this, "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });
    (0,defineProperty/* default */.Z)(_this, "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });
    (0,defineProperty/* default */.Z)(_this, "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });
    (0,defineProperty/* default */.Z)(_this, "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });
    (0,defineProperty/* default */.Z)(_this, "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });
    (0,defineProperty/* default */.Z)(_this, "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });
    (0,defineProperty/* default */.Z)(_this, "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });
    (0,defineProperty/* default */.Z)(_this, "render", function () {
      var className = classnames_default()("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, _this.props), _this.state);
      var trackProps = extractObject(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, trackProps), {}, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
      });
      var dots;
      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = extractObject(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, dotProps), {}, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = /*#__PURE__*/react.createElement(Dots, dotProps);
      }
      var prevArrow, nextArrow;
      var arrowProps = extractObject(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;
      if (_this.props.arrows) {
        prevArrow = /*#__PURE__*/react.createElement(PrevArrow, arrowProps);
        nextArrow = /*#__PURE__*/react.createElement(NextArrow, arrowProps);
      }
      var verticalHeightStyle = null;
      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }
      var centerPaddingStyle = null;
      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }
      var listStyle = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, verticalHeightStyle), centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.touchEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr",
        style: _this.props.style
      };
      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className,
          style: _this.props.style
        };
      }
      return /*#__PURE__*/react.createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
        ref: _this.listRefHandler
      }, listProps), /*#__PURE__*/react.createElement(Track, (0,esm_extends/* default */.Z)({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
    });
    _this.list = null;
    _this.track = null;
    _this.state = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, initial_state), {}, {
      currentSlide: _this.props.initialSlide,
      targetSlide: _this.props.initialSlide ? _this.props.initialSlide : 0,
      slideCount: react.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    var ssrState = _this.ssrInit();
    _this.state = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, _this.state), ssrState);
    return _this;
  }
  (0,inherits/* default */.Z)(InnerSlider, _React$Component);
  return (0,createClass/* default */.Z)(InnerSlider, [{
    key: "didPropsChange",
    value: function didPropsChange(prevProps) {
      var setTrackStyle = false;
      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];
        // eslint-disable-next-line no-prototype-builtins
        if (!prevProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }
        if ((0,esm_typeof/* default */.Z)(prevProps[key]) === "object" || typeof prevProps[key] === "function" || isNaN(prevProps[key])) {
          continue;
        }
        if (prevProps[key] !== this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }
      return setTrackStyle || react.Children.count(this.props.children) !== react.Children.count(prevProps.children);
    }
  }]);
}(react.Component);
// EXTERNAL MODULE: ./node_modules/json2mq/index.js
var json2mq = __webpack_require__(22770);
var json2mq_default = /*#__PURE__*/__webpack_require__.n(json2mq);
;// CONCATENATED MODULE: ./node_modules/@ant-design/react-slick/es/slider.js











function slider_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, (0,isNativeReflectConstruct/* default */.Z)() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}





var Slider = /*#__PURE__*/function (_React$Component) {
  function Slider(props) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, Slider);
    _this = slider_callSuper(this, Slider, [props]);
    (0,defineProperty/* default */.Z)(_this, "innerSliderRefHandler", function (ref) {
      return _this.innerSlider = ref;
    });
    (0,defineProperty/* default */.Z)(_this, "slickPrev", function () {
      return _this.innerSlider.slickPrev();
    });
    (0,defineProperty/* default */.Z)(_this, "slickNext", function () {
      return _this.innerSlider.slickNext();
    });
    (0,defineProperty/* default */.Z)(_this, "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    });
    (0,defineProperty/* default */.Z)(_this, "slickPause", function () {
      return _this.innerSlider.pause("paused");
    });
    (0,defineProperty/* default */.Z)(_this, "slickPlay", function () {
      return _this.innerSlider.autoPlay("play");
    });
    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }
  (0,inherits/* default */.Z)(Slider, _React$Component);
  return (0,createClass/* default */.Z)(Slider, [{
    key: "media",
    value: function media(query, handler) {
      // javascript handler for  css media query
      var mql = window.matchMedia(query);
      var listener = function listener(_ref) {
        var matches = _ref.matches;
        if (matches) {
          handler();
        }
      };
      mql.addListener(listener);
      listener(mql);
      this._responsiveMediaHandlers.push({
        mql: mql,
        query: query,
        listener: listener
      });
    }

    // handles responsive breakpoints
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // performance monitoring
      //if (process.env.NODE_ENV !== 'production') {
      //const { whyDidYouUpdate } = require('why-did-you-update')
      //whyDidYouUpdate(React)
      //}
      if (this.props.responsive) {
        var breakpoints = this.props.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        });
        // sort them in increasing order of their numerical value
        breakpoints.sort(function (x, y) {
          return x - y;
        });
        breakpoints.forEach(function (breakpoint, index) {
          // media query for each breakpoint
          var bQuery;
          if (index === 0) {
            bQuery = json2mq_default()({
              minWidth: 0,
              maxWidth: breakpoint
            });
          } else {
            bQuery = json2mq_default()({
              minWidth: breakpoints[index - 1] + 1,
              maxWidth: breakpoint
            });
          }
          // when not using server side rendering
          canUseDOM() && _this2.media(bQuery, function () {
            _this2.setState({
              breakpoint: breakpoint
            });
          });
        });

        // Register media query for full screen. Need to support resize from small to large
        // convert javascript object to media query string
        var query = json2mq_default()({
          minWidth: breakpoints.slice(-1)[0]
        });
        canUseDOM() && this.media(query, function () {
          _this2.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._responsiveMediaHandlers.forEach(function (obj) {
        obj.mql.removeListener(obj.listener);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var settings;
      var newProps;
      if (this.state.breakpoint) {
        newProps = this.props.responsive.filter(function (resp) {
          return resp.breakpoint === _this3.state.breakpoint;
        });
        settings = newProps[0].settings === "unslick" ? "unslick" : (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, default_props), this.props), newProps[0].settings);
      } else {
        settings = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, default_props), this.props);
      }

      // force scrolling by one if centerMode is on
      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && "production" !== "production") {}
        settings.slidesToScroll = 1;
      }
      // force showing one slide and scrolling by one if the fade mode is on
      if (settings.fade) {
        if (settings.slidesToShow > 1 && "production" !== "production") {}
        if (settings.slidesToScroll > 1 && "production" !== "production") {}
        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      }

      // makes sure that children is an array, even when there is only 1 child
      var children = react.Children.toArray(this.props.children);

      // Children may contain false or null, so we should filter them
      // children may also contain string filled with spaces (in certain cases where we use jsx strings)
      children = children.filter(function (child) {
        if (typeof child === "string") {
          return !!child.trim();
        }
        return !!child;
      });

      // rows and slidesPerRow logic is handled here
      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
        settings.variableWidth = false;
      }
      var newChildren = [];
      var currentWidth = null;
      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
        var newSlide = [];
        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
          var row = [];
          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
            if (settings.variableWidth && children[k].props.style) {
              currentWidth = children[k].props.style.width;
            }
            if (k >= children.length) break;
            row.push(/*#__PURE__*/react.cloneElement(children[k], {
              key: 100 * i + 10 * j + k,
              tabIndex: -1,
              style: {
                width: "".concat(100 / settings.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          }
          newSlide.push(/*#__PURE__*/react.createElement("div", {
            key: 10 * i + j
          }, row));
        }
        if (settings.variableWidth) {
          newChildren.push(/*#__PURE__*/react.createElement("div", {
            key: i,
            style: {
              width: currentWidth
            }
          }, newSlide));
        } else {
          newChildren.push(/*#__PURE__*/react.createElement("div", {
            key: i
          }, newSlide));
        }
      }
      if (settings === "unslick") {
        var className = "regular slider " + (this.props.className || "");
        return /*#__PURE__*/react.createElement("div", {
          className: className
        }, children);
      } else if (newChildren.length <= settings.slidesToShow && !settings.infinite) {
        settings.unslick = true;
      }
      return /*#__PURE__*/react.createElement(InnerSlider, (0,esm_extends/* default */.Z)({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, filterSettings(settings)), newChildren);
    }
  }]);
}(react.Component);

;// CONCATENATED MODULE: ./node_modules/@ant-design/react-slick/es/index.js

/* harmony default export */ var react_slick_es = (Slider);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/carousel/style/index.js



const DotDuration = '--dot-duration';
const genCarouselStyle = token => {
  const {
    componentCls,
    antCls
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      '.slick-slider': {
        position: 'relative',
        display: 'block',
        boxSizing: 'border-box',
        touchAction: 'pan-y',
        WebkitTouchCallout: 'none',
        WebkitTapHighlightColor: 'transparent',
        '.slick-track, .slick-list': {
          transform: 'translate3d(0, 0, 0)',
          touchAction: 'pan-y'
        }
      },
      '.slick-list': {
        position: 'relative',
        display: 'block',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
        '&:focus': {
          outline: 'none'
        },
        '&.dragging': {
          cursor: 'pointer'
        },
        '.slick-slide': {
          pointerEvents: 'none',
          // https://github.com/ant-design/ant-design/issues/23294
          [`input${antCls}-radio-input, input${antCls}-checkbox-input`]: {
            visibility: 'hidden'
          },
          '&.slick-active': {
            pointerEvents: 'auto',
            [`input${antCls}-radio-input, input${antCls}-checkbox-input`]: {
              visibility: 'visible'
            }
          },
          // fix Carousel content height not match parent node
          // when children is empty node
          // https://github.com/ant-design/ant-design/issues/25878
          '> div > div': {
            verticalAlign: 'bottom'
          }
        }
      },
      '.slick-track': {
        position: 'relative',
        top: 0,
        insetInlineStart: 0,
        display: 'block',
        '&::before, &::after': {
          display: 'table',
          content: '""'
        },
        '&::after': {
          clear: 'both'
        }
      },
      '.slick-slide': {
        display: 'none',
        float: 'left',
        height: '100%',
        minHeight: 1,
        img: {
          display: 'block'
        },
        '&.dragging img': {
          pointerEvents: 'none'
        }
      },
      '.slick-initialized .slick-slide': {
        display: 'block'
      },
      '.slick-vertical .slick-slide': {
        display: 'block',
        height: 'auto'
      }
    })
  };
};
const genArrowsStyle = token => {
  const {
    componentCls,
    motionDurationSlow,
    arrowSize,
    arrowOffset
  } = token;
  const arrowLength = token.calc(arrowSize).div(Math.SQRT2).equal();
  return {
    [componentCls]: {
      // Arrows
      '.slick-prev, .slick-next': {
        position: 'absolute',
        top: '50%',
        width: arrowSize,
        height: arrowSize,
        transform: 'translateY(-50%)',
        color: '#fff',
        opacity: 0.4,
        background: 'transparent',
        padding: 0,
        lineHeight: 0,
        border: 0,
        outline: 'none',
        cursor: 'pointer',
        zIndex: 1,
        transition: `opacity ${motionDurationSlow}`,
        '&:hover, &:focus': {
          opacity: 1
        },
        '&.slick-disabled': {
          pointerEvents: 'none',
          opacity: 0
        },
        '&::after': {
          boxSizing: 'border-box',
          position: 'absolute',
          top: token.calc(arrowSize).sub(arrowLength).div(2).equal(),
          insetInlineStart: token.calc(arrowSize).sub(arrowLength).div(2).equal(),
          display: 'inline-block',
          width: arrowLength,
          height: arrowLength,
          border: `0 solid currentcolor`,
          borderInlineStartWidth: 2,
          borderBlockStartWidth: 2,
          borderRadius: 1,
          content: '""'
        }
      },
      '.slick-prev': {
        insetInlineStart: arrowOffset,
        '&::after': {
          transform: 'rotate(-45deg)'
        }
      },
      '.slick-next': {
        insetInlineEnd: arrowOffset,
        '&::after': {
          transform: 'rotate(135deg)'
        }
      }
    }
  };
};
const genDotsStyle = token => {
  const {
    componentCls,
    dotOffset,
    dotWidth,
    dotHeight,
    dotGap,
    colorBgContainer,
    motionDurationSlow
  } = token;
  return {
    [componentCls]: {
      '.slick-dots': {
        position: 'absolute',
        insetInlineEnd: 0,
        bottom: 0,
        insetInlineStart: 0,
        zIndex: 15,
        display: 'flex !important',
        justifyContent: 'center',
        paddingInlineStart: 0,
        margin: 0,
        listStyle: 'none',
        '&-bottom': {
          bottom: dotOffset
        },
        '&-top': {
          top: dotOffset,
          bottom: 'auto'
        },
        li: {
          position: 'relative',
          display: 'inline-block',
          flex: '0 1 auto',
          boxSizing: 'content-box',
          width: dotWidth,
          height: dotHeight,
          marginInline: dotGap,
          padding: 0,
          textAlign: 'center',
          textIndent: -999,
          verticalAlign: 'top',
          transition: `all ${motionDurationSlow}`,
          borderRadius: dotHeight,
          overflow: 'hidden',
          '&::after': {
            display: 'block',
            position: 'absolute',
            top: 0,
            insetInlineStart: 0,
            width: '100%',
            height: dotHeight,
            content: '""',
            background: 'transparent',
            borderRadius: dotHeight,
            opacity: 1,
            outline: 'none',
            cursor: 'pointer',
            overflow: 'hidden',
            transform: 'translate3d(-100%, 0, 0)'
          },
          button: {
            position: 'relative',
            display: 'block',
            width: '100%',
            height: dotHeight,
            padding: 0,
            color: 'transparent',
            fontSize: 0,
            background: colorBgContainer,
            border: 0,
            borderRadius: dotHeight,
            outline: 'none',
            cursor: 'pointer',
            opacity: 0.2,
            transition: `all ${motionDurationSlow}`,
            overflow: 'hidden',
            '&:hover': {
              opacity: 0.75
            },
            '&::after': {
              position: 'absolute',
              inset: token.calc(dotGap).mul(-1).equal(),
              content: '""'
            }
          },
          '&.slick-active': {
            width: token.dotActiveWidth,
            position: 'relative',
            '&:hover': {
              opacity: 1
            },
            '&::after': {
              background: colorBgContainer,
              transform: 'translate3d(0, 0, 0)',
              transition: `transform var(${DotDuration}) ease-out`
            }
          }
        }
      }
    }
  };
};
const genCarouselVerticalStyle = token => {
  const {
    componentCls,
    dotOffset,
    arrowOffset,
    marginXXS
  } = token;
  const reverseSizeOfDot = {
    width: token.dotHeight,
    height: token.dotWidth
  };
  return {
    [`${componentCls}-vertical`]: {
      '.slick-prev, .slick-next': {
        insetInlineStart: '50%',
        marginBlockStart: 'unset',
        transform: 'translateX(-50%)'
      },
      '.slick-prev': {
        insetBlockStart: arrowOffset,
        insetInlineStart: '50%',
        '&::after': {
          transform: 'rotate(45deg)'
        }
      },
      '.slick-next': {
        insetBlockStart: 'auto',
        insetBlockEnd: arrowOffset,
        '&::after': {
          transform: 'rotate(-135deg)'
        }
      },
      '.slick-dots': {
        top: '50%',
        bottom: 'auto',
        flexDirection: 'column',
        width: token.dotHeight,
        height: 'auto',
        margin: 0,
        transform: 'translateY(-50%)',
        '&-left': {
          insetInlineEnd: 'auto',
          insetInlineStart: dotOffset
        },
        '&-right': {
          insetInlineEnd: dotOffset,
          insetInlineStart: 'auto'
        },
        li: Object.assign(Object.assign({}, reverseSizeOfDot), {
          margin: `${(0,cssinjs_es/* unit */.bf)(marginXXS)} 0`,
          verticalAlign: 'baseline',
          button: reverseSizeOfDot,
          '&::after': Object.assign(Object.assign({}, reverseSizeOfDot), {
            height: 0
          }),
          '&.slick-active': Object.assign(Object.assign({}, reverseSizeOfDot), {
            button: reverseSizeOfDot,
            '&::after': Object.assign(Object.assign({}, reverseSizeOfDot), {
              transition: `height var(${DotDuration}) ease-out`
            })
          })
        })
      }
    }
  };
};
const genCarouselRtlStyle = token => {
  const {
    componentCls
  } = token;
  return [{
    [`${componentCls}-rtl`]: {
      direction: 'rtl',
      // Dots
      '.slick-dots': {
        [`${componentCls}-rtl&`]: {
          flexDirection: 'row-reverse'
        }
      }
    }
  }, {
    [`${componentCls}-vertical`]: {
      '.slick-dots': {
        [`${componentCls}-rtl&`]: {
          flexDirection: 'column'
        }
      }
    }
  }];
};
const carousel_style_prepareComponentToken = token => {
  const dotActiveWidth = 24;
  return {
    arrowSize: 16,
    arrowOffset: token.marginXS,
    dotWidth: 16,
    dotHeight: 3,
    dotGap: token.marginXXS,
    dotOffset: 12,
    dotWidthActive: dotActiveWidth,
    dotActiveWidth
  };
};
// ============================== Export ==============================
/* harmony default export */ var carousel_style = (genStyleHooks('Carousel', token => [genCarouselStyle(token), genArrowsStyle(token), genDotsStyle(token), genCarouselVerticalStyle(token), genCarouselRtlStyle(token)], carousel_style_prepareComponentToken, {
  deprecatedTokens: [['dotWidthActive', 'dotActiveWidth']]
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/carousel/index.js
"use client";

var carousel_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





const dotsClass = 'slick-dots';
const ArrowButton = _a => {
  var {
      currentSlide,
      slideCount
    } = _a,
    rest = carousel_rest(_a, ["currentSlide", "slideCount"]);
  return /*#__PURE__*/react.createElement("button", Object.assign({
    type: "button"
  }, rest));
};
const Carousel = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      dots = true,
      arrows = false,
      prevArrow = /*#__PURE__*/react.createElement(ArrowButton, {
        "aria-label": "prev"
      }),
      nextArrow = /*#__PURE__*/react.createElement(ArrowButton, {
        "aria-label": "next"
      }),
      draggable = false,
      waitForAnimate = false,
      dotPosition = 'bottom',
      vertical = dotPosition === 'left' || dotPosition === 'right',
      rootClassName,
      className: customClassName,
      style,
      id,
      autoplay = false,
      autoplaySpeed = 3000
    } = props,
    otherProps = carousel_rest(props, ["dots", "arrows", "prevArrow", "nextArrow", "draggable", "waitForAnimate", "dotPosition", "vertical", "rootClassName", "className", "style", "id", "autoplay", "autoplaySpeed"]);
  const {
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle
  } = useComponentConfig('carousel');
  const slickRef = react.useRef(null);
  const goTo = (slide, dontAnimate = false) => {
    slickRef.current.slickGoTo(slide, dontAnimate);
  };
  react.useImperativeHandle(ref, () => ({
    goTo,
    autoPlay: slickRef.current.innerSlider.autoPlay,
    innerSlider: slickRef.current.innerSlider,
    prev: slickRef.current.slickPrev,
    next: slickRef.current.slickNext
  }), [slickRef.current]);
  const prevCount = react.useRef(react.Children.count(props.children));
  react.useEffect(() => {
    if (prevCount.current !== react.Children.count(props.children)) {
      goTo(props.initialSlide || 0, false);
      prevCount.current = react.Children.count(props.children);
    }
  }, [props.children]);
  const newProps = Object.assign({
    vertical,
    className: classnames_default()(customClassName, contextClassName),
    style: Object.assign(Object.assign({}, contextStyle), style),
    autoplay: !!autoplay
  }, otherProps);
  if (newProps.effect === 'fade') {
    newProps.fade = true;
  }
  const prefixCls = getPrefixCls('carousel', newProps.prefixCls);
  const enableDots = !!dots;
  const dsClass = classnames_default()(dotsClass, `${dotsClass}-${dotPosition}`, typeof dots === 'boolean' ? false : dots === null || dots === void 0 ? void 0 : dots.className);
  const [wrapCSSVar, hashId, cssVarCls] = carousel_style(prefixCls);
  const className = classnames_default()(prefixCls, {
    [`${prefixCls}-rtl`]: direction === 'rtl',
    [`${prefixCls}-vertical`]: newProps.vertical
  }, hashId, cssVarCls, rootClassName);
  const mergedShowDuration = autoplay && (typeof autoplay === 'object' ? autoplay.dotDuration : false);
  const dotDurationStyle = mergedShowDuration ? {
    [DotDuration]: `${autoplaySpeed}ms`
  } : {};
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    className: className,
    id: id,
    style: dotDurationStyle
  }, /*#__PURE__*/react.createElement(react_slick_es, Object.assign({
    ref: slickRef
  }, newProps, {
    dots: enableDots,
    dotsClass: dsClass,
    arrows: arrows,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    draggable: draggable,
    verticalSwiping: vertical,
    autoplaySpeed: autoplaySpeed,
    waitForAnimate: waitForAnimate
  }))));
});
if (false) {}
/* harmony default export */ var carousel = (Carousel);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(40656);
// EXTERNAL MODULE: ./node_modules/rc-select/es/hooks/useId.js
var es_hooks_useId = __webpack_require__(91935);
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/context.js

var CascaderContext = /*#__PURE__*/react.createContext({});
/* harmony default export */ var es_context = (CascaderContext);
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/hooks/useSearchOptions.js




var SEARCH_MARK = '__rc_cascader_search_mark__';
var defaultFilter = function defaultFilter(search, options, _ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label;
  return options.some(function (opt) {
    return String(opt[label]).toLowerCase().includes(search.toLowerCase());
  });
};
var defaultRender = function defaultRender(inputValue, path, prefixCls, fieldNames) {
  return path.map(function (opt) {
    return opt[fieldNames.label];
  }).join(' / ');
};
var useSearchOptions = function useSearchOptions(search, options, fieldNames, prefixCls, config, enableHalfPath) {
  var _config$filter = config.filter,
    filter = _config$filter === void 0 ? defaultFilter : _config$filter,
    _config$render = config.render,
    render = _config$render === void 0 ? defaultRender : _config$render,
    _config$limit = config.limit,
    limit = _config$limit === void 0 ? 50 : _config$limit,
    sort = config.sort;
  return react.useMemo(function () {
    var filteredOptions = [];
    if (!search) {
      return [];
    }
    function dig(list, pathOptions) {
      var parentDisabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      list.forEach(function (option) {
        // Perf saving when `sort` is disabled and `limit` is provided
        if (!sort && limit !== false && limit > 0 && filteredOptions.length >= limit) {
          return;
        }
        var connectedPathOptions = [].concat((0,toConsumableArray/* default */.Z)(pathOptions), [option]);
        var children = option[fieldNames.children];
        var mergedDisabled = parentDisabled || option.disabled;

        // If current option is filterable
        if (
        // If is leaf option
        !children || children.length === 0 ||
        // If is changeOnSelect or multiple
        enableHalfPath) {
          if (filter(search, connectedPathOptions, {
            label: fieldNames.label
          })) {
            var _objectSpread2;
            filteredOptions.push((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, option), {}, (_objectSpread2 = {
              disabled: mergedDisabled
            }, (0,defineProperty/* default */.Z)(_objectSpread2, fieldNames.label, render(search, connectedPathOptions, prefixCls, fieldNames)), (0,defineProperty/* default */.Z)(_objectSpread2, SEARCH_MARK, connectedPathOptions), (0,defineProperty/* default */.Z)(_objectSpread2, fieldNames.children, undefined), _objectSpread2)));
          }
        }
        if (children) {
          dig(option[fieldNames.children], connectedPathOptions, mergedDisabled);
        }
      });
    }
    dig(options, []);

    // Do sort
    if (sort) {
      filteredOptions.sort(function (a, b) {
        return sort(a[SEARCH_MARK], b[SEARCH_MARK], search, fieldNames);
      });
    }
    return limit !== false && limit > 0 ? filteredOptions.slice(0, limit) : filteredOptions;
  }, [search, options, fieldNames, prefixCls, render, enableHalfPath, filter, sort, limit]);
};
/* harmony default export */ var hooks_useSearchOptions = (useSearchOptions);
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/utils/commonUtil.js

var VALUE_SPLIT = '__RC_CASCADER_SPLIT__';
var SHOW_PARENT = 'SHOW_PARENT';
var SHOW_CHILD = 'SHOW_CHILD';

/**
 * Will convert value to string, and join with `VALUE_SPLIT`
 */
function toPathKey(value) {
  return value.join(VALUE_SPLIT);
}

/**
 * Batch convert value to string, and join with `VALUE_SPLIT`
 */
function toPathKeys(value) {
  return value.map(toPathKey);
}
function toPathValueStr(pathKey) {
  return pathKey.split(VALUE_SPLIT);
}
function fillFieldNames(fieldNames) {
  var _ref = fieldNames || {},
    label = _ref.label,
    value = _ref.value,
    children = _ref.children;
  var val = value || 'value';
  return {
    label: label || 'label',
    value: val,
    key: val,
    children: children || 'children'
  };
}
function isLeaf(option, fieldNames) {
  var _option$isLeaf, _option;
  return (_option$isLeaf = option.isLeaf) !== null && _option$isLeaf !== void 0 ? _option$isLeaf : !((_option = option[fieldNames.children]) !== null && _option !== void 0 && _option.length);
}
function scrollIntoParentView(element) {
  var parent = element.parentElement;
  if (!parent) {
    return;
  }
  var elementToParent = element.offsetTop - parent.offsetTop; // offsetParent may not be parent.
  if (elementToParent - parent.scrollTop < 0) {
    parent.scrollTo({
      top: elementToParent
    });
  } else if (elementToParent + element.offsetHeight - parent.scrollTop > parent.offsetHeight) {
    parent.scrollTo({
      top: elementToParent + element.offsetHeight - parent.offsetHeight
    });
  }
}
function getFullPathKeys(options, fieldNames) {
  return options.map(function (item) {
    var _item$SEARCH_MARK;
    return (_item$SEARCH_MARK = item[SEARCH_MARK]) === null || _item$SEARCH_MARK === void 0 ? void 0 : _item$SEARCH_MARK.map(function (opt) {
      return opt[fieldNames.value];
    });
  });
}
function isMultipleValue(value) {
  return Array.isArray(value) && Array.isArray(value[0]);
}
function toRawValues(value) {
  if (!value) {
    return [];
  }
  if (isMultipleValue(value)) {
    return value;
  }
  return (value.length === 0 ? [] : [value]).map(function (val) {
    return Array.isArray(val) ? val : [val];
  });
}
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/utils/treeUtil.js

function formatStrategyValues(pathKeys, getKeyPathEntities, showCheckedStrategy) {
  var valueSet = new Set(pathKeys);
  var keyPathEntities = getKeyPathEntities();
  return pathKeys.filter(function (key) {
    var entity = keyPathEntities[key];
    var parent = entity ? entity.parent : null;
    var children = entity ? entity.children : null;
    if (entity && entity.node.disabled) {
      return true;
    }
    return showCheckedStrategy === SHOW_CHILD ? !(children && children.some(function (child) {
      return child.key && valueSet.has(child.key);
    })) : !(parent && !parent.node.disabled && valueSet.has(parent.key));
  });
}
function toPathOptions(valueCells, options, fieldNames) {
  var stringMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var currentList = options;
  var valueOptions = [];
  var _loop = function _loop() {
    var _currentList, _currentList2, _foundOption$fieldNam;
    var valueCell = valueCells[i];
    var foundIndex = (_currentList = currentList) === null || _currentList === void 0 ? void 0 : _currentList.findIndex(function (option) {
      var val = option[fieldNames.value];
      return stringMode ? String(val) === String(valueCell) : val === valueCell;
    });
    var foundOption = foundIndex !== -1 ? (_currentList2 = currentList) === null || _currentList2 === void 0 ? void 0 : _currentList2[foundIndex] : null;
    valueOptions.push({
      value: (_foundOption$fieldNam = foundOption === null || foundOption === void 0 ? void 0 : foundOption[fieldNames.value]) !== null && _foundOption$fieldNam !== void 0 ? _foundOption$fieldNam : valueCell,
      index: foundIndex,
      option: foundOption
    });
    currentList = foundOption === null || foundOption === void 0 ? void 0 : foundOption[fieldNames.children];
  };
  for (var i = 0; i < valueCells.length; i += 1) {
    _loop();
  }
  return valueOptions;
}
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/hooks/useDisplayValues.js





/* harmony default export */ var useDisplayValues = (function (rawValues, options, fieldNames, multiple, displayRender) {
  return react.useMemo(function () {
    var mergedDisplayRender = displayRender ||
    // Default displayRender
    function (labels) {
      var mergedLabels = multiple ? labels.slice(-1) : labels;
      var SPLIT = ' / ';
      if (mergedLabels.every(function (label) {
        return ['string', 'number'].includes((0,esm_typeof/* default */.Z)(label));
      })) {
        return mergedLabels.join(SPLIT);
      }

      // If exist non-string value, use ReactNode instead
      return mergedLabels.reduce(function (list, label, index) {
        var keyedLabel = /*#__PURE__*/react.isValidElement(label) ? /*#__PURE__*/react.cloneElement(label, {
          key: index
        }) : label;
        if (index === 0) {
          return [keyedLabel];
        }
        return [].concat((0,toConsumableArray/* default */.Z)(list), [SPLIT, keyedLabel]);
      }, []);
    };
    return rawValues.map(function (valueCells) {
      var _valueOptions;
      var valueOptions = toPathOptions(valueCells, options, fieldNames);
      var label = mergedDisplayRender(valueOptions.map(function (_ref) {
        var _option$fieldNames$la;
        var option = _ref.option,
          value = _ref.value;
        return (_option$fieldNames$la = option === null || option === void 0 ? void 0 : option[fieldNames.label]) !== null && _option$fieldNames$la !== void 0 ? _option$fieldNames$la : value;
      }), valueOptions.map(function (_ref2) {
        var option = _ref2.option;
        return option;
      }));
      var value = toPathKey(valueCells);
      return {
        label: label,
        value: value,
        key: value,
        valueCells: valueCells,
        disabled: (_valueOptions = valueOptions[valueOptions.length - 1]) === null || _valueOptions === void 0 || (_valueOptions = _valueOptions.option) === null || _valueOptions === void 0 ? void 0 : _valueOptions.disabled
      };
    });
  }, [rawValues, options, fieldNames, displayRender, multiple]);
});
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/hooks/useMissingValues.js


function useMissingValues(options, fieldNames) {
  return react.useCallback(function (rawValues) {
    var missingValues = [];
    var existsValues = [];
    rawValues.forEach(function (valueCell) {
      var pathOptions = toPathOptions(valueCell, options, fieldNames);
      if (pathOptions.every(function (opt) {
        return opt.option;
      })) {
        existsValues.push(valueCell);
      } else {
        missingValues.push(valueCell);
      }
    });
    return [existsValues, missingValues];
  }, [options, fieldNames]);
}
// EXTERNAL MODULE: ./node_modules/rc-tree/es/utils/treeUtil.js
var treeUtil = __webpack_require__(77081);
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/hooks/useEntities.js




/** Lazy parse options data into conduct-able info to avoid perf issue in single mode */
/* harmony default export */ var useEntities = (function (options, fieldNames) {
  var cacheRef = react.useRef({
    options: [],
    info: {
      keyEntities: {},
      pathKeyEntities: {}
    }
  });
  var getEntities = react.useCallback(function () {
    if (cacheRef.current.options !== options) {
      cacheRef.current.options = options;
      cacheRef.current.info = (0,treeUtil/* convertDataToEntities */.I8)(options, {
        fieldNames: fieldNames,
        initWrapper: function initWrapper(wrapper) {
          return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, wrapper), {}, {
            pathKeyEntities: {}
          });
        },
        processEntity: function processEntity(entity, wrapper) {
          var pathKey = entity.nodes.map(function (node) {
            return node[fieldNames.value];
          }).join(VALUE_SPLIT);
          wrapper.pathKeyEntities[pathKey] = entity;

          // Overwrite origin key.
          // this is very hack but we need let conduct logic work with connect path
          entity.key = pathKey;
        }
      });
    }
    return cacheRef.current.info.pathKeyEntities;
  }, [fieldNames, options]);
  return getEntities;
});
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/hooks/useOptions.js


function useOptions(mergedFieldNames, options) {
  var mergedOptions = react.useMemo(function () {
    return options || [];
  }, [options]);

  // Only used in multiple mode, this fn will not call in single mode
  var getPathKeyEntities = useEntities(mergedOptions, mergedFieldNames);

  /** Convert path key back to value format */
  var getValueByKeyPath = react.useCallback(function (pathKeys) {
    var keyPathEntities = getPathKeyEntities();
    return pathKeys.map(function (pathKey) {
      var nodes = keyPathEntities[pathKey].nodes;
      return nodes.map(function (node) {
        return node[mergedFieldNames.value];
      });
    });
  }, [getPathKeyEntities, mergedFieldNames]);
  return [mergedOptions, getPathKeyEntities, getValueByKeyPath];
}
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/hooks/useSearchConfig.js




// Convert `showSearch` to unique config
function useSearchConfig(showSearch) {
  return react.useMemo(function () {
    if (!showSearch) {
      return [false, {}];
    }
    var searchConfig = {
      matchInputWidth: true,
      limit: 50
    };
    if (showSearch && (0,esm_typeof/* default */.Z)(showSearch) === 'object') {
      searchConfig = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, searchConfig), showSearch);
    }
    if (searchConfig.limit <= 0) {
      searchConfig.limit = false;
      if (false) {}
    }
    return [true, searchConfig];
  }, [showSearch]);
}
// EXTERNAL MODULE: ./node_modules/rc-tree/es/utils/conductUtil.js
var conductUtil = __webpack_require__(47139);
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/hooks/useSelect.js




function useSelect(multiple, triggerChange, checkedValues, halfCheckedValues, missingCheckedValues, getPathKeyEntities, getValueByKeyPath, showCheckedStrategy) {
  return function (valuePath) {
    if (!multiple) {
      triggerChange(valuePath);
    } else {
      // Prepare conduct required info
      var pathKey = toPathKey(valuePath);
      var checkedPathKeys = toPathKeys(checkedValues);
      var halfCheckedPathKeys = toPathKeys(halfCheckedValues);
      var existInChecked = checkedPathKeys.includes(pathKey);
      var existInMissing = missingCheckedValues.some(function (valueCells) {
        return toPathKey(valueCells) === pathKey;
      });

      // Do update
      var nextCheckedValues = checkedValues;
      var nextMissingValues = missingCheckedValues;
      if (existInMissing && !existInChecked) {
        // Missing value only do filter
        nextMissingValues = missingCheckedValues.filter(function (valueCells) {
          return toPathKey(valueCells) !== pathKey;
        });
      } else {
        // Update checked key first
        var nextRawCheckedKeys = existInChecked ? checkedPathKeys.filter(function (key) {
          return key !== pathKey;
        }) : [].concat((0,toConsumableArray/* default */.Z)(checkedPathKeys), [pathKey]);
        var pathKeyEntities = getPathKeyEntities();

        // Conduction by selected or not
        var checkedKeys;
        if (existInChecked) {
          var _conductCheck = (0,conductUtil/* conductCheck */.S)(nextRawCheckedKeys, {
            checked: false,
            halfCheckedKeys: halfCheckedPathKeys
          }, pathKeyEntities);
          checkedKeys = _conductCheck.checkedKeys;
        } else {
          var _conductCheck2 = (0,conductUtil/* conductCheck */.S)(nextRawCheckedKeys, true, pathKeyEntities);
          checkedKeys = _conductCheck2.checkedKeys;
        }

        // Roll up to parent level keys
        var deDuplicatedKeys = formatStrategyValues(checkedKeys, getPathKeyEntities, showCheckedStrategy);
        nextCheckedValues = getValueByKeyPath(deDuplicatedKeys);
      }
      triggerChange([].concat((0,toConsumableArray/* default */.Z)(nextMissingValues), (0,toConsumableArray/* default */.Z)(nextCheckedValues)));
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/hooks/useValues.js




function useValues(multiple, rawValues, getPathKeyEntities, getValueByKeyPath, getMissingValues) {
  // Fill `rawValues` with checked conduction values
  return react.useMemo(function () {
    var _getMissingValues = getMissingValues(rawValues),
      _getMissingValues2 = (0,slicedToArray/* default */.Z)(_getMissingValues, 2),
      existValues = _getMissingValues2[0],
      missingValues = _getMissingValues2[1];
    if (!multiple || !rawValues.length) {
      return [existValues, [], missingValues];
    }
    var keyPathValues = toPathKeys(existValues);
    var keyPathEntities = getPathKeyEntities();
    var _conductCheck = (0,conductUtil/* conductCheck */.S)(keyPathValues, true, keyPathEntities),
      checkedKeys = _conductCheck.checkedKeys,
      halfCheckedKeys = _conductCheck.halfCheckedKeys;

    // Convert key back to value cells
    return [getValueByKeyPath(checkedKeys), getValueByKeyPath(halfCheckedKeys), missingValues];
  }, [multiple, rawValues, getPathKeyEntities, getValueByKeyPath, getMissingValues]);
}
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/OptionList/CacheContent.js

var CacheContent = /*#__PURE__*/react.memo(function (_ref) {
  var children = _ref.children;
  return children;
}, function (_, next) {
  return !next.open;
});
if (false) {}
/* harmony default export */ var OptionList_CacheContent = (CacheContent);
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/OptionList/Checkbox.js




function Checkbox(_ref) {
  var _classNames;
  var prefixCls = _ref.prefixCls,
    checked = _ref.checked,
    halfChecked = _ref.halfChecked,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    disableCheckbox = _ref.disableCheckbox;
  var _React$useContext = react.useContext(es_context),
    checkable = _React$useContext.checkable;
  var customCheckbox = typeof checkable !== 'boolean' ? checkable : null;
  return /*#__PURE__*/react.createElement("span", {
    className: classnames_default()("".concat(prefixCls), (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-checked"), checked), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-indeterminate"), !checked && halfChecked), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-disabled"), disabled || disableCheckbox), _classNames)),
    onClick: onClick
  }, customCheckbox);
}
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/OptionList/Column.js








var FIX_LABEL = '__cascader_fix_label__';
function Column(_ref) {
  var prefixCls = _ref.prefixCls,
    multiple = _ref.multiple,
    options = _ref.options,
    activeValue = _ref.activeValue,
    prevValuePath = _ref.prevValuePath,
    onToggleOpen = _ref.onToggleOpen,
    onSelect = _ref.onSelect,
    onActive = _ref.onActive,
    checkedSet = _ref.checkedSet,
    halfCheckedSet = _ref.halfCheckedSet,
    loadingKeys = _ref.loadingKeys,
    isSelectable = _ref.isSelectable,
    propsDisabled = _ref.disabled;
  var menuPrefixCls = "".concat(prefixCls, "-menu");
  var menuItemPrefixCls = "".concat(prefixCls, "-menu-item");
  var _React$useContext = react.useContext(es_context),
    fieldNames = _React$useContext.fieldNames,
    changeOnSelect = _React$useContext.changeOnSelect,
    expandTrigger = _React$useContext.expandTrigger,
    expandIcon = _React$useContext.expandIcon,
    loadingIcon = _React$useContext.loadingIcon,
    dropdownMenuColumnStyle = _React$useContext.dropdownMenuColumnStyle,
    optionRender = _React$useContext.optionRender;
  var hoverOpen = expandTrigger === 'hover';
  var isOptionDisabled = function isOptionDisabled(disabled) {
    return propsDisabled || disabled;
  };

  // ============================ Option ============================
  var optionInfoList = react.useMemo(function () {
    return options.map(function (option) {
      var _option$FIX_LABEL;
      var disabled = option.disabled,
        disableCheckbox = option.disableCheckbox;
      var searchOptions = option[SEARCH_MARK];
      var label = (_option$FIX_LABEL = option[FIX_LABEL]) !== null && _option$FIX_LABEL !== void 0 ? _option$FIX_LABEL : option[fieldNames.label];
      var value = option[fieldNames.value];
      var isMergedLeaf = isLeaf(option, fieldNames);

      // Get real value of option. Search option is different way.
      var fullPath = searchOptions ? searchOptions.map(function (opt) {
        return opt[fieldNames.value];
      }) : [].concat((0,toConsumableArray/* default */.Z)(prevValuePath), [value]);
      var fullPathKey = toPathKey(fullPath);
      var isLoading = loadingKeys.includes(fullPathKey);

      // >>>>> checked
      var checked = checkedSet.has(fullPathKey);

      // >>>>> halfChecked
      var halfChecked = halfCheckedSet.has(fullPathKey);
      return {
        disabled: disabled,
        label: label,
        value: value,
        isLeaf: isMergedLeaf,
        isLoading: isLoading,
        checked: checked,
        halfChecked: halfChecked,
        option: option,
        disableCheckbox: disableCheckbox,
        fullPath: fullPath,
        fullPathKey: fullPathKey
      };
    });
  }, [options, checkedSet, fieldNames, halfCheckedSet, loadingKeys, prevValuePath]);

  // ============================ Render ============================
  return /*#__PURE__*/react.createElement("ul", {
    className: menuPrefixCls,
    role: "menu"
  }, optionInfoList.map(function (_ref2) {
    var _classNames;
    var disabled = _ref2.disabled,
      label = _ref2.label,
      value = _ref2.value,
      isMergedLeaf = _ref2.isLeaf,
      isLoading = _ref2.isLoading,
      checked = _ref2.checked,
      halfChecked = _ref2.halfChecked,
      option = _ref2.option,
      fullPath = _ref2.fullPath,
      fullPathKey = _ref2.fullPathKey,
      disableCheckbox = _ref2.disableCheckbox;
    // >>>>> Open
    var triggerOpenPath = function triggerOpenPath() {
      if (isOptionDisabled(disabled)) {
        return;
      }
      var nextValueCells = (0,toConsumableArray/* default */.Z)(fullPath);
      if (hoverOpen && isMergedLeaf) {
        nextValueCells.pop();
      }
      onActive(nextValueCells);
    };

    // >>>>> Selection
    var triggerSelect = function triggerSelect() {
      if (isSelectable(option) && !isOptionDisabled(disabled)) {
        onSelect(fullPath, isMergedLeaf);
      }
    };

    // >>>>> Title
    var title;
    if (typeof option.title === 'string') {
      title = option.title;
    } else if (typeof label === 'string') {
      title = label;
    }

    // >>>>> Render
    return /*#__PURE__*/react.createElement("li", {
      key: fullPathKey,
      className: classnames_default()(menuItemPrefixCls, (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(menuItemPrefixCls, "-expand"), !isMergedLeaf), (0,defineProperty/* default */.Z)(_classNames, "".concat(menuItemPrefixCls, "-active"), activeValue === value || activeValue === fullPathKey), (0,defineProperty/* default */.Z)(_classNames, "".concat(menuItemPrefixCls, "-disabled"), isOptionDisabled(disabled)), (0,defineProperty/* default */.Z)(_classNames, "".concat(menuItemPrefixCls, "-loading"), isLoading), _classNames)),
      style: dropdownMenuColumnStyle,
      role: "menuitemcheckbox",
      title: title,
      "aria-checked": checked,
      "data-path-key": fullPathKey,
      onClick: function onClick() {
        triggerOpenPath();
        if (disableCheckbox) {
          return;
        }
        if (!multiple || isMergedLeaf) {
          triggerSelect();
        }
      },
      onDoubleClick: function onDoubleClick() {
        if (changeOnSelect) {
          onToggleOpen(false);
        }
      },
      onMouseEnter: function onMouseEnter() {
        if (hoverOpen) {
          triggerOpenPath();
        }
      },
      onMouseDown: function onMouseDown(e) {
        // Prevent selector from blurring
        e.preventDefault();
      }
    }, multiple && /*#__PURE__*/react.createElement(Checkbox, {
      prefixCls: "".concat(prefixCls, "-checkbox"),
      checked: checked,
      halfChecked: halfChecked,
      disabled: isOptionDisabled(disabled) || disableCheckbox,
      disableCheckbox: disableCheckbox,
      onClick: function onClick(e) {
        if (disableCheckbox) {
          return;
        }
        e.stopPropagation();
        triggerSelect();
      }
    }), /*#__PURE__*/react.createElement("div", {
      className: "".concat(menuItemPrefixCls, "-content")
    }, optionRender ? optionRender(option) : label), !isLoading && expandIcon && !isMergedLeaf && /*#__PURE__*/react.createElement("div", {
      className: "".concat(menuItemPrefixCls, "-expand-icon")
    }, expandIcon), isLoading && loadingIcon && /*#__PURE__*/react.createElement("div", {
      className: "".concat(menuItemPrefixCls, "-loading-icon")
    }, loadingIcon));
  }));
}
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/OptionList/useActive.js




/**
 * Control the active open options path.
 */
var useActive = function useActive(multiple, open) {
  var _React$useContext = react.useContext(es_context),
    values = _React$useContext.values;
  var firstValueCells = values[0];

  // Record current dropdown active options
  // This also control the open status
  var _React$useState = react.useState([]),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    activeValueCells = _React$useState2[0],
    setActiveValueCells = _React$useState2[1];
  react.useEffect(function () {
    if (!multiple) {
      setActiveValueCells(firstValueCells || []);
    }
  }, /* eslint-disable react-hooks/exhaustive-deps */
  [open, firstValueCells]
  /* eslint-enable react-hooks/exhaustive-deps */);
  return [activeValueCells, setActiveValueCells];
};
/* harmony default export */ var OptionList_useActive = (useActive);
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/OptionList/useKeyboard.js






/* harmony default export */ var useKeyboard = (function (ref, options, fieldNames, activeValueCells, setActiveValueCells, onKeyBoardSelect, contextProps) {
  var direction = contextProps.direction,
    searchValue = contextProps.searchValue,
    toggleOpen = contextProps.toggleOpen,
    open = contextProps.open;
  var rtl = direction === 'rtl';
  var _React$useMemo = react.useMemo(function () {
      var activeIndex = -1;
      var currentOptions = options;
      var mergedActiveIndexes = [];
      var mergedActiveValueCells = [];
      var len = activeValueCells.length;
      var pathKeys = getFullPathKeys(options, fieldNames);

      // Fill validate active value cells and index
      var _loop = function _loop(i) {
        // Mark the active index for current options
        var nextActiveIndex = currentOptions.findIndex(function (option, index) {
          return (pathKeys[index] ? toPathKey(pathKeys[index]) : option[fieldNames.value]) === activeValueCells[i];
        });
        if (nextActiveIndex === -1) {
          return 1; // break
        }
        activeIndex = nextActiveIndex;
        mergedActiveIndexes.push(activeIndex);
        mergedActiveValueCells.push(activeValueCells[i]);
        currentOptions = currentOptions[activeIndex][fieldNames.children];
      };
      for (var i = 0; i < len && currentOptions; i += 1) {
        if (_loop(i)) break;
      }

      // Fill last active options
      var activeOptions = options;
      for (var _i = 0; _i < mergedActiveIndexes.length - 1; _i += 1) {
        activeOptions = activeOptions[mergedActiveIndexes[_i]][fieldNames.children];
      }
      return [mergedActiveValueCells, activeIndex, activeOptions, pathKeys];
    }, [activeValueCells, fieldNames, options]),
    _React$useMemo2 = (0,slicedToArray/* default */.Z)(_React$useMemo, 4),
    validActiveValueCells = _React$useMemo2[0],
    lastActiveIndex = _React$useMemo2[1],
    lastActiveOptions = _React$useMemo2[2],
    fullPathKeys = _React$useMemo2[3];

  // Update active value cells and scroll to target element
  var internalSetActiveValueCells = function internalSetActiveValueCells(next) {
    setActiveValueCells(next);
  };

  // Same options offset
  var offsetActiveOption = function offsetActiveOption(offset) {
    var len = lastActiveOptions.length;
    var currentIndex = lastActiveIndex;
    if (currentIndex === -1 && offset < 0) {
      currentIndex = len;
    }
    for (var i = 0; i < len; i += 1) {
      currentIndex = (currentIndex + offset + len) % len;
      var _option = lastActiveOptions[currentIndex];
      if (_option && !_option.disabled) {
        var nextActiveCells = validActiveValueCells.slice(0, -1).concat(fullPathKeys[currentIndex] ? toPathKey(fullPathKeys[currentIndex]) : _option[fieldNames.value]);
        internalSetActiveValueCells(nextActiveCells);
        return;
      }
    }
  };

  // Different options offset
  var prevColumn = function prevColumn() {
    if (validActiveValueCells.length > 1) {
      var nextActiveCells = validActiveValueCells.slice(0, -1);
      internalSetActiveValueCells(nextActiveCells);
    } else {
      toggleOpen(false);
    }
  };
  var nextColumn = function nextColumn() {
    var _lastActiveOptions$la;
    var nextOptions = ((_lastActiveOptions$la = lastActiveOptions[lastActiveIndex]) === null || _lastActiveOptions$la === void 0 ? void 0 : _lastActiveOptions$la[fieldNames.children]) || [];
    var nextOption = nextOptions.find(function (option) {
      return !option.disabled;
    });
    if (nextOption) {
      var nextActiveCells = [].concat((0,toConsumableArray/* default */.Z)(validActiveValueCells), [nextOption[fieldNames.value]]);
      internalSetActiveValueCells(nextActiveCells);
    }
  };
  react.useImperativeHandle(ref, function () {
    return {
      // scrollTo: treeRef.current?.scrollTo,
      onKeyDown: function onKeyDown(event) {
        var which = event.which;
        switch (which) {
          // >>> Arrow keys
          case KeyCode/* default.UP */.Z.UP:
          case KeyCode/* default.DOWN */.Z.DOWN:
            {
              var offset = 0;
              if (which === KeyCode/* default.UP */.Z.UP) {
                offset = -1;
              } else if (which === KeyCode/* default.DOWN */.Z.DOWN) {
                offset = 1;
              }
              if (offset !== 0) {
                offsetActiveOption(offset);
              }
              break;
            }
          case KeyCode/* default.LEFT */.Z.LEFT:
            {
              if (searchValue) {
                break;
              }
              if (rtl) {
                nextColumn();
              } else {
                prevColumn();
              }
              break;
            }
          case KeyCode/* default.RIGHT */.Z.RIGHT:
            {
              if (searchValue) {
                break;
              }
              if (rtl) {
                prevColumn();
              } else {
                nextColumn();
              }
              break;
            }
          case KeyCode/* default.BACKSPACE */.Z.BACKSPACE:
            {
              if (!searchValue) {
                prevColumn();
              }
              break;
            }

          // >>> Select
          case KeyCode/* default.ENTER */.Z.ENTER:
            {
              if (validActiveValueCells.length) {
                var _option2 = lastActiveOptions[lastActiveIndex];

                // Search option should revert back of origin options
                var originOptions = (_option2 === null || _option2 === void 0 ? void 0 : _option2[SEARCH_MARK]) || [];
                if (originOptions.length) {
                  onKeyBoardSelect(originOptions.map(function (opt) {
                    return opt[fieldNames.value];
                  }), originOptions[originOptions.length - 1]);
                } else {
                  onKeyBoardSelect(validActiveValueCells, lastActiveOptions[lastActiveIndex]);
                }
              }
              break;
            }

          // >>> Close
          case KeyCode/* default.ESC */.Z.ESC:
            {
              toggleOpen(false);
              if (open) {
                event.stopPropagation();
              }
            }
        }
      },
      onKeyUp: function onKeyUp() {}
    };
  });
});
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/OptionList/List.js





/* eslint-disable default-case */









var RawOptionList = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _optionColumns$, _ref3, _classNames;
  var prefixCls = props.prefixCls,
    multiple = props.multiple,
    searchValue = props.searchValue,
    toggleOpen = props.toggleOpen,
    notFoundContent = props.notFoundContent,
    direction = props.direction,
    open = props.open,
    disabled = props.disabled;
  var containerRef = react.useRef(null);
  var rtl = direction === 'rtl';
  var _React$useContext = react.useContext(es_context),
    options = _React$useContext.options,
    values = _React$useContext.values,
    halfValues = _React$useContext.halfValues,
    fieldNames = _React$useContext.fieldNames,
    changeOnSelect = _React$useContext.changeOnSelect,
    onSelect = _React$useContext.onSelect,
    searchOptions = _React$useContext.searchOptions,
    dropdownPrefixCls = _React$useContext.dropdownPrefixCls,
    loadData = _React$useContext.loadData,
    expandTrigger = _React$useContext.expandTrigger;
  var mergedPrefixCls = dropdownPrefixCls || prefixCls;

  // ========================= loadData =========================
  var _React$useState = react.useState([]),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    loadingKeys = _React$useState2[0],
    setLoadingKeys = _React$useState2[1];
  var internalLoadData = function internalLoadData(valueCells) {
    // Do not load when search
    if (!loadData || searchValue) {
      return;
    }
    var optionList = toPathOptions(valueCells, options, fieldNames);
    var rawOptions = optionList.map(function (_ref) {
      var option = _ref.option;
      return option;
    });
    var lastOption = rawOptions[rawOptions.length - 1];
    if (lastOption && !isLeaf(lastOption, fieldNames)) {
      var pathKey = toPathKey(valueCells);
      setLoadingKeys(function (keys) {
        return [].concat((0,toConsumableArray/* default */.Z)(keys), [pathKey]);
      });
      loadData(rawOptions);
    }
  };

  // zombieJ: This is bad. We should make this same as `rc-tree` to use Promise instead.
  react.useEffect(function () {
    if (loadingKeys.length) {
      loadingKeys.forEach(function (loadingKey) {
        var valueStrCells = toPathValueStr(loadingKey);
        var optionList = toPathOptions(valueStrCells, options, fieldNames, true).map(function (_ref2) {
          var option = _ref2.option;
          return option;
        });
        var lastOption = optionList[optionList.length - 1];
        if (!lastOption || lastOption[fieldNames.children] || isLeaf(lastOption, fieldNames)) {
          setLoadingKeys(function (keys) {
            return keys.filter(function (key) {
              return key !== loadingKey;
            });
          });
        }
      });
    }
  }, [options, loadingKeys, fieldNames]);

  // ========================== Values ==========================
  var checkedSet = react.useMemo(function () {
    return new Set(toPathKeys(values));
  }, [values]);
  var halfCheckedSet = react.useMemo(function () {
    return new Set(toPathKeys(halfValues));
  }, [halfValues]);

  // ====================== Accessibility =======================
  var _useActive = OptionList_useActive(multiple, open),
    _useActive2 = (0,slicedToArray/* default */.Z)(_useActive, 2),
    activeValueCells = _useActive2[0],
    setActiveValueCells = _useActive2[1];

  // =========================== Path ===========================
  var onPathOpen = function onPathOpen(nextValueCells) {
    setActiveValueCells(nextValueCells);

    // Trigger loadData
    internalLoadData(nextValueCells);
  };
  var isSelectable = function isSelectable(option) {
    if (disabled) {
      return false;
    }
    var optionDisabled = option.disabled;
    var isMergedLeaf = isLeaf(option, fieldNames);
    return !optionDisabled && (isMergedLeaf || changeOnSelect || multiple);
  };
  var onPathSelect = function onPathSelect(valuePath, leaf) {
    var fromKeyboard = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    onSelect(valuePath);
    if (!multiple && (leaf || changeOnSelect && (expandTrigger === 'hover' || fromKeyboard))) {
      toggleOpen(false);
    }
  };

  // ========================== Option ==========================
  var mergedOptions = react.useMemo(function () {
    if (searchValue) {
      return searchOptions;
    }
    return options;
  }, [searchValue, searchOptions, options]);

  // ========================== Column ==========================
  var optionColumns = react.useMemo(function () {
    var optionList = [{
      options: mergedOptions
    }];
    var currentList = mergedOptions;
    var fullPathKeys = getFullPathKeys(currentList, fieldNames);
    var _loop = function _loop() {
      var activeValueCell = activeValueCells[i];
      var currentOption = currentList.find(function (option, index) {
        return (fullPathKeys[index] ? toPathKey(fullPathKeys[index]) : option[fieldNames.value]) === activeValueCell;
      });
      var subOptions = currentOption === null || currentOption === void 0 ? void 0 : currentOption[fieldNames.children];
      if (!(subOptions !== null && subOptions !== void 0 && subOptions.length)) {
        return 1; // break
      }
      currentList = subOptions;
      optionList.push({
        options: subOptions
      });
    };
    for (var i = 0; i < activeValueCells.length; i += 1) {
      if (_loop()) break;
    }
    return optionList;
  }, [mergedOptions, activeValueCells, fieldNames]);

  // ========================= Keyboard =========================
  var onKeyboardSelect = function onKeyboardSelect(selectValueCells, option) {
    if (isSelectable(option)) {
      onPathSelect(selectValueCells, isLeaf(option, fieldNames), true);
    }
  };
  useKeyboard(ref, mergedOptions, fieldNames, activeValueCells, onPathOpen, onKeyboardSelect, {
    direction: direction,
    searchValue: searchValue,
    toggleOpen: toggleOpen,
    open: open
  });

  // >>>>> Active Scroll
  react.useEffect(function () {
    if (searchValue) {
      return;
    }
    for (var i = 0; i < activeValueCells.length; i += 1) {
      var _containerRef$current;
      var cellPath = activeValueCells.slice(0, i + 1);
      var cellKeyPath = toPathKey(cellPath);
      var ele = (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.querySelector("li[data-path-key=\"".concat(cellKeyPath.replace(/\\{0,2}"/g, '\\"'), "\"]") // matches unescaped double quotes
      );
      if (ele) {
        scrollIntoParentView(ele);
      }
    }
  }, [activeValueCells, searchValue]);

  // ========================== Render ==========================
  // >>>>> Empty
  var isEmpty = !((_optionColumns$ = optionColumns[0]) !== null && _optionColumns$ !== void 0 && (_optionColumns$ = _optionColumns$.options) !== null && _optionColumns$ !== void 0 && _optionColumns$.length);
  var emptyList = [(_ref3 = {}, (0,defineProperty/* default */.Z)(_ref3, fieldNames.value, '__EMPTY__'), (0,defineProperty/* default */.Z)(_ref3, FIX_LABEL, notFoundContent), (0,defineProperty/* default */.Z)(_ref3, "disabled", true), _ref3)];
  var columnProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    multiple: !isEmpty && multiple,
    onSelect: onPathSelect,
    onActive: onPathOpen,
    onToggleOpen: toggleOpen,
    checkedSet: checkedSet,
    halfCheckedSet: halfCheckedSet,
    loadingKeys: loadingKeys,
    isSelectable: isSelectable
  });

  // >>>>> Columns
  var mergedOptionColumns = isEmpty ? [{
    options: emptyList
  }] : optionColumns;
  var columnNodes = mergedOptionColumns.map(function (col, index) {
    var prevValuePath = activeValueCells.slice(0, index);
    var activeValue = activeValueCells[index];
    return /*#__PURE__*/react.createElement(Column, (0,esm_extends/* default */.Z)({
      key: index
    }, columnProps, {
      prefixCls: mergedPrefixCls,
      options: col.options,
      prevValuePath: prevValuePath,
      activeValue: activeValue
    }));
  });

  // >>>>> Render
  return /*#__PURE__*/react.createElement(OptionList_CacheContent, {
    open: open
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(mergedPrefixCls, "-menus"), (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(mergedPrefixCls, "-menu-empty"), isEmpty), (0,defineProperty/* default */.Z)(_classNames, "".concat(mergedPrefixCls, "-rtl"), rtl), _classNames)),
    ref: containerRef
  }, columnNodes));
});
if (false) {}
/* harmony default export */ var List = (RawOptionList);
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/OptionList/index.js




var RefOptionList = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var baseProps = (0,rc_select_es/* useBaseProps */.lk)();

  // >>>>> Render
  return /*#__PURE__*/react.createElement(List, (0,esm_extends/* default */.Z)({}, props, baseProps, {
    ref: ref
  }));
});
/* harmony default export */ var OptionList = (RefOptionList);
// EXTERNAL MODULE: ./node_modules/rc-util/es/index.js
var rc_util_es = __webpack_require__(57433);
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/Panel.js













function Panel_noop() {}
function Panel(props) {
  var _classNames;
  var _ref = props,
    _ref$prefixCls = _ref.prefixCls,
    prefixCls = _ref$prefixCls === void 0 ? 'rc-cascader' : _ref$prefixCls,
    style = _ref.style,
    className = _ref.className,
    options = _ref.options,
    checkable = _ref.checkable,
    defaultValue = _ref.defaultValue,
    value = _ref.value,
    fieldNames = _ref.fieldNames,
    changeOnSelect = _ref.changeOnSelect,
    onChange = _ref.onChange,
    showCheckedStrategy = _ref.showCheckedStrategy,
    loadData = _ref.loadData,
    expandTrigger = _ref.expandTrigger,
    _ref$expandIcon = _ref.expandIcon,
    expandIcon = _ref$expandIcon === void 0 ? '>' : _ref$expandIcon,
    loadingIcon = _ref.loadingIcon,
    direction = _ref.direction,
    _ref$notFoundContent = _ref.notFoundContent,
    notFoundContent = _ref$notFoundContent === void 0 ? 'Not Found' : _ref$notFoundContent,
    disabled = _ref.disabled;

  // ======================== Multiple ========================
  var multiple = !!checkable;

  // ========================= Values =========================
  var _useMergedState = (0,rc_util_es/* useMergedState */.C8)(defaultValue, {
      value: value,
      postState: toRawValues
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    rawValues = _useMergedState2[0],
    setRawValues = _useMergedState2[1];

  // ========================= FieldNames =========================
  var mergedFieldNames = react.useMemo(function () {
    return fillFieldNames(fieldNames);
  }, /* eslint-disable react-hooks/exhaustive-deps */
  [JSON.stringify(fieldNames)]
  /* eslint-enable react-hooks/exhaustive-deps */);

  // =========================== Option ===========================
  var _useOptions = useOptions(mergedFieldNames, options),
    _useOptions2 = (0,slicedToArray/* default */.Z)(_useOptions, 3),
    mergedOptions = _useOptions2[0],
    getPathKeyEntities = _useOptions2[1],
    getValueByKeyPath = _useOptions2[2];

  // ========================= Values =========================
  var getMissingValues = useMissingValues(mergedOptions, mergedFieldNames);

  // Fill `rawValues` with checked conduction values
  var _useValues = useValues(multiple, rawValues, getPathKeyEntities, getValueByKeyPath, getMissingValues),
    _useValues2 = (0,slicedToArray/* default */.Z)(_useValues, 3),
    checkedValues = _useValues2[0],
    halfCheckedValues = _useValues2[1],
    missingCheckedValues = _useValues2[2];

  // =========================== Change ===========================
  var triggerChange = (0,rc_util_es/* useEvent */.zX)(function (nextValues) {
    setRawValues(nextValues);

    // Save perf if no need trigger event
    if (onChange) {
      var nextRawValues = toRawValues(nextValues);
      var valueOptions = nextRawValues.map(function (valueCells) {
        return toPathOptions(valueCells, mergedOptions, mergedFieldNames).map(function (valueOpt) {
          return valueOpt.option;
        });
      });
      var triggerValues = multiple ? nextRawValues : nextRawValues[0];
      var triggerOptions = multiple ? valueOptions : valueOptions[0];
      onChange(triggerValues, triggerOptions);
    }
  });

  // =========================== Select ===========================
  var handleSelection = useSelect(multiple, triggerChange, checkedValues, halfCheckedValues, missingCheckedValues, getPathKeyEntities, getValueByKeyPath, showCheckedStrategy);
  var onInternalSelect = (0,rc_util_es/* useEvent */.zX)(function (valuePath) {
    handleSelection(valuePath);
  });

  // ======================== Context =========================
  var cascaderContext = react.useMemo(function () {
    return {
      options: mergedOptions,
      fieldNames: mergedFieldNames,
      values: checkedValues,
      halfValues: halfCheckedValues,
      changeOnSelect: changeOnSelect,
      onSelect: onInternalSelect,
      checkable: checkable,
      searchOptions: [],
      dropdownPrefixCls: undefined,
      loadData: loadData,
      expandTrigger: expandTrigger,
      expandIcon: expandIcon,
      loadingIcon: loadingIcon,
      dropdownMenuColumnStyle: undefined
    };
  }, [mergedOptions, mergedFieldNames, checkedValues, halfCheckedValues, changeOnSelect, onInternalSelect, checkable, loadData, expandTrigger, expandIcon, loadingIcon]);

  // ========================= Render =========================
  var panelPrefixCls = "".concat(prefixCls, "-panel");
  var isEmpty = !mergedOptions.length;
  return /*#__PURE__*/react.createElement(es_context.Provider, {
    value: cascaderContext
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(panelPrefixCls, (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(panelPrefixCls, "-rtl"), direction === 'rtl'), (0,defineProperty/* default */.Z)(_classNames, "".concat(panelPrefixCls, "-empty"), isEmpty), _classNames), className),
    style: style
  }, isEmpty ? notFoundContent : /*#__PURE__*/react.createElement(List, {
    prefixCls: prefixCls,
    searchValue: "",
    multiple: multiple,
    toggleOpen: Panel_noop,
    open: true,
    direction: direction,
    disabled: disabled
  })));
}
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/utils/warningPropsUtil.js

function warningProps(props) {
  var onPopupVisibleChange = props.onPopupVisibleChange,
    popupVisible = props.popupVisible,
    popupClassName = props.popupClassName,
    popupPlacement = props.popupPlacement,
    onDropdownVisibleChange = props.onDropdownVisibleChange;
  warning(!onPopupVisibleChange, '`onPopupVisibleChange` is deprecated. Please use `onOpenChange` instead.');
  warning(!onDropdownVisibleChange, '`onDropdownVisibleChange` is deprecated. Please use `onOpenChange` instead.');
  warning(popupVisible === undefined, '`popupVisible` is deprecated. Please use `open` instead.');
  warning(popupClassName === undefined, '`popupClassName` is deprecated. Please use `dropdownClassName` instead.');
  warning(popupPlacement === undefined, '`popupPlacement` is deprecated. Please use `placement` instead.');
}

// value in Cascader options should not be null
function warningNullOptions(options, fieldNames) {
  if (options) {
    var recursiveOptions = function recursiveOptions(optionsList) {
      for (var i = 0; i < optionsList.length; i++) {
        var option = optionsList[i];
        if (option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.value] === null) {
          warning(false, '`value` in Cascader options should not be `null`.');
          return true;
        }
        if (Array.isArray(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.children]) && recursiveOptions(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.children])) {
          return true;
        }
      }
    };
    recursiveOptions(options);
  }
}
/* harmony default export */ var warningPropsUtil = ((/* unused pure expression or super */ null && (warningProps)));
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/Cascader.js





var Cascader_excluded = ["id", "prefixCls", "fieldNames", "defaultValue", "value", "changeOnSelect", "onChange", "displayRender", "checkable", "autoClearSearchValue", "searchValue", "onSearch", "showSearch", "expandTrigger", "options", "dropdownPrefixCls", "loadData", "popupVisible", "open", "popupClassName", "dropdownClassName", "dropdownMenuColumnStyle", "dropdownStyle", "popupPlacement", "placement", "onDropdownVisibleChange", "onPopupVisibleChange", "onOpenChange", "expandIcon", "loadingIcon", "children", "dropdownMatchSelectWidth", "showCheckedStrategy", "optionRender"];


















var Cascader = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var id = props.id,
    _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-cascader' : _props$prefixCls,
    fieldNames = props.fieldNames,
    defaultValue = props.defaultValue,
    value = props.value,
    changeOnSelect = props.changeOnSelect,
    onChange = props.onChange,
    displayRender = props.displayRender,
    checkable = props.checkable,
    _props$autoClearSearc = props.autoClearSearchValue,
    autoClearSearchValue = _props$autoClearSearc === void 0 ? true : _props$autoClearSearc,
    searchValue = props.searchValue,
    onSearch = props.onSearch,
    showSearch = props.showSearch,
    expandTrigger = props.expandTrigger,
    options = props.options,
    dropdownPrefixCls = props.dropdownPrefixCls,
    loadData = props.loadData,
    popupVisible = props.popupVisible,
    open = props.open,
    popupClassName = props.popupClassName,
    dropdownClassName = props.dropdownClassName,
    dropdownMenuColumnStyle = props.dropdownMenuColumnStyle,
    customDropdownStyle = props.dropdownStyle,
    popupPlacement = props.popupPlacement,
    placement = props.placement,
    onDropdownVisibleChange = props.onDropdownVisibleChange,
    onPopupVisibleChange = props.onPopupVisibleChange,
    onOpenChange = props.onOpenChange,
    _props$expandIcon = props.expandIcon,
    expandIcon = _props$expandIcon === void 0 ? '>' : _props$expandIcon,
    loadingIcon = props.loadingIcon,
    children = props.children,
    _props$dropdownMatchS = props.dropdownMatchSelectWidth,
    dropdownMatchSelectWidth = _props$dropdownMatchS === void 0 ? false : _props$dropdownMatchS,
    _props$showCheckedStr = props.showCheckedStrategy,
    showCheckedStrategy = _props$showCheckedStr === void 0 ? SHOW_PARENT : _props$showCheckedStr,
    optionRender = props.optionRender,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, Cascader_excluded);
  var mergedId = (0,es_hooks_useId/* default */.ZP)(id);
  var multiple = !!checkable;

  // =========================== Values ===========================
  var _useMergedState = (0,useMergedState/* default */.Z)(defaultValue, {
      value: value,
      postState: toRawValues
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    rawValues = _useMergedState2[0],
    setRawValues = _useMergedState2[1];

  // ========================= FieldNames =========================
  var mergedFieldNames = react.useMemo(function () {
    return fillFieldNames(fieldNames);
  }, /* eslint-disable react-hooks/exhaustive-deps */
  [JSON.stringify(fieldNames)]
  /* eslint-enable react-hooks/exhaustive-deps */);

  // =========================== Option ===========================
  var _useOptions = useOptions(mergedFieldNames, options),
    _useOptions2 = (0,slicedToArray/* default */.Z)(_useOptions, 3),
    mergedOptions = _useOptions2[0],
    getPathKeyEntities = _useOptions2[1],
    getValueByKeyPath = _useOptions2[2];

  // =========================== Search ===========================
  var _useMergedState3 = (0,useMergedState/* default */.Z)('', {
      value: searchValue,
      postState: function postState(search) {
        return search || '';
      }
    }),
    _useMergedState4 = (0,slicedToArray/* default */.Z)(_useMergedState3, 2),
    mergedSearchValue = _useMergedState4[0],
    setSearchValue = _useMergedState4[1];
  var onInternalSearch = function onInternalSearch(searchText, info) {
    setSearchValue(searchText);
    if (info.source !== 'blur' && onSearch) {
      onSearch(searchText);
    }
  };
  var _useSearchConfig = useSearchConfig(showSearch),
    _useSearchConfig2 = (0,slicedToArray/* default */.Z)(_useSearchConfig, 2),
    mergedShowSearch = _useSearchConfig2[0],
    searchConfig = _useSearchConfig2[1];
  var searchOptions = hooks_useSearchOptions(mergedSearchValue, mergedOptions, mergedFieldNames, dropdownPrefixCls || prefixCls, searchConfig, changeOnSelect || multiple);

  // =========================== Values ===========================
  var getMissingValues = useMissingValues(mergedOptions, mergedFieldNames);

  // Fill `rawValues` with checked conduction values
  var _useValues = useValues(multiple, rawValues, getPathKeyEntities, getValueByKeyPath, getMissingValues),
    _useValues2 = (0,slicedToArray/* default */.Z)(_useValues, 3),
    checkedValues = _useValues2[0],
    halfCheckedValues = _useValues2[1],
    missingCheckedValues = _useValues2[2];
  var deDuplicatedValues = react.useMemo(function () {
    var checkedKeys = toPathKeys(checkedValues);
    var deduplicateKeys = formatStrategyValues(checkedKeys, getPathKeyEntities, showCheckedStrategy);
    return [].concat((0,toConsumableArray/* default */.Z)(missingCheckedValues), (0,toConsumableArray/* default */.Z)(getValueByKeyPath(deduplicateKeys)));
  }, [checkedValues, getPathKeyEntities, getValueByKeyPath, missingCheckedValues, showCheckedStrategy]);
  var displayValues = useDisplayValues(deDuplicatedValues, mergedOptions, mergedFieldNames, multiple, displayRender);

  // =========================== Change ===========================
  var triggerChange = (0,hooks_useEvent/* default */.Z)(function (nextValues) {
    setRawValues(nextValues);

    // Save perf if no need trigger event
    if (onChange) {
      var nextRawValues = toRawValues(nextValues);
      var valueOptions = nextRawValues.map(function (valueCells) {
        return toPathOptions(valueCells, mergedOptions, mergedFieldNames).map(function (valueOpt) {
          return valueOpt.option;
        });
      });
      var triggerValues = multiple ? nextRawValues : nextRawValues[0];
      var triggerOptions = multiple ? valueOptions : valueOptions[0];
      onChange(triggerValues, triggerOptions);
    }
  });

  // =========================== Select ===========================
  var handleSelection = useSelect(multiple, triggerChange, checkedValues, halfCheckedValues, missingCheckedValues, getPathKeyEntities, getValueByKeyPath, showCheckedStrategy);
  var onInternalSelect = (0,hooks_useEvent/* default */.Z)(function (valuePath) {
    if (!multiple || autoClearSearchValue) {
      setSearchValue('');
    }
    handleSelection(valuePath);
  });

  // Display Value change logic
  var onDisplayValuesChange = function onDisplayValuesChange(_, info) {
    if (info.type === 'clear') {
      triggerChange([]);
      return;
    }

    // Cascader do not support `add` type. Only support `remove`
    var _ref = info.values[0],
      valueCells = _ref.valueCells;
    onInternalSelect(valueCells);
  };

  // ============================ Open ============================
  var mergedOpen = open !== undefined ? open : popupVisible;
  var mergedDropdownClassName = dropdownClassName || popupClassName;
  var mergedPlacement = placement || popupPlacement;
  var onInternalDropdownVisibleChange = function onInternalDropdownVisibleChange(nextVisible) {
    onOpenChange === null || onOpenChange === void 0 || onOpenChange(nextVisible);
    onDropdownVisibleChange === null || onDropdownVisibleChange === void 0 || onDropdownVisibleChange(nextVisible);
    onPopupVisibleChange === null || onPopupVisibleChange === void 0 || onPopupVisibleChange(nextVisible);
  };

  // ========================== Warning ===========================
  if (false) {}

  // ========================== Context ===========================
  var cascaderContext = react.useMemo(function () {
    return {
      options: mergedOptions,
      fieldNames: mergedFieldNames,
      values: checkedValues,
      halfValues: halfCheckedValues,
      changeOnSelect: changeOnSelect,
      onSelect: onInternalSelect,
      checkable: checkable,
      searchOptions: searchOptions,
      dropdownPrefixCls: dropdownPrefixCls,
      loadData: loadData,
      expandTrigger: expandTrigger,
      expandIcon: expandIcon,
      loadingIcon: loadingIcon,
      dropdownMenuColumnStyle: dropdownMenuColumnStyle,
      optionRender: optionRender
    };
  }, [mergedOptions, mergedFieldNames, checkedValues, halfCheckedValues, changeOnSelect, onInternalSelect, checkable, searchOptions, dropdownPrefixCls, loadData, expandTrigger, expandIcon, loadingIcon, dropdownMenuColumnStyle, optionRender]);

  // ==============================================================
  // ==                          Render                          ==
  // ==============================================================
  var emptyOptions = !(mergedSearchValue ? searchOptions : mergedOptions).length;
  var dropdownStyle =
  // Search to match width
  mergedSearchValue && searchConfig.matchInputWidth ||
  // Empty keep the width
  emptyOptions ? {} : {
    minWidth: 'auto'
  };
  return /*#__PURE__*/react.createElement(es_context.Provider, {
    value: cascaderContext
  }, /*#__PURE__*/react.createElement(rc_select_es/* BaseSelect */.Ac, (0,esm_extends/* default */.Z)({}, restProps, {
    // MISC
    ref: ref,
    id: mergedId,
    prefixCls: prefixCls,
    autoClearSearchValue: autoClearSearchValue,
    dropdownMatchSelectWidth: dropdownMatchSelectWidth,
    dropdownStyle: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, dropdownStyle), customDropdownStyle)
    // Value
    ,

    displayValues: displayValues,
    onDisplayValuesChange: onDisplayValuesChange,
    mode: multiple ? 'multiple' : undefined
    // Search
    ,

    searchValue: mergedSearchValue,
    onSearch: onInternalSearch,
    showSearch: mergedShowSearch
    // Options
    ,

    OptionList: OptionList,
    emptyOptions: emptyOptions
    // Open
    ,

    open: mergedOpen,
    dropdownClassName: mergedDropdownClassName,
    placement: mergedPlacement,
    onDropdownVisibleChange: onInternalDropdownVisibleChange
    // Children
    ,

    getRawInputElement: function getRawInputElement() {
      return children;
    }
  })));
});
if (false) {}
Cascader.SHOW_PARENT = SHOW_PARENT;
Cascader.SHOW_CHILD = SHOW_CHILD;
Cascader.Panel = Panel;
/* harmony default export */ var es_Cascader = (Cascader);
;// CONCATENATED MODULE: ./node_modules/rc-cascader/es/index.js



/* harmony default export */ var rc_cascader_es = (es_Cascader);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/cascader/hooks/useBase.js


function useBase(customizePrefixCls, direction) {
  const {
    getPrefixCls,
    direction: rootDirection,
    renderEmpty
  } = react.useContext(ConfigContext);
  const mergedDirection = direction || rootDirection;
  const prefixCls = getPrefixCls('select', customizePrefixCls);
  const cascaderPrefixCls = getPrefixCls('cascader', customizePrefixCls);
  return [prefixCls, cascaderPrefixCls, mergedDirection, renderEmpty];
}
/* harmony default export */ var hooks_useBase = (useBase);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/cascader/hooks/useCheckable.js
"use client";


function useCheckable(cascaderPrefixCls, multiple) {
  return react.useMemo(() => multiple ? /*#__PURE__*/react.createElement("span", {
    className: `${cascaderPrefixCls}-checkbox-inner`
  }) : false, [multiple]);
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/cascader/hooks/useColumnIcons.js
"use client";





const useColumnIcons = (prefixCls, rtl, expandIcon) => {
  let mergedExpandIcon = expandIcon;
  if (!expandIcon) {
    mergedExpandIcon = rtl ? /*#__PURE__*/react.createElement(LeftOutlined/* default */.Z, null) : /*#__PURE__*/react.createElement(RightOutlined/* default */.Z, null);
  }
  const loadingIcon = /*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-menu-item-loading-icon`
  }, /*#__PURE__*/react.createElement(LoadingOutlined/* default */.Z, {
    spin: true
  }));
  return react.useMemo(() => [mergedExpandIcon, loadingIcon], [mergedExpandIcon]);
};
/* harmony default export */ var hooks_useColumnIcons = (useColumnIcons);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/checkbox/style/index.js



// ============================== Styles ==============================
const genCheckboxStyle = token => {
  const {
    checkboxCls
  } = token;
  const wrapperCls = `${checkboxCls}-wrapper`;
  return [
  // ===================== Basic =====================
  {
    // Group
    [`${checkboxCls}-group`]: Object.assign(Object.assign({}, resetComponent(token)), {
      display: 'inline-flex',
      flexWrap: 'wrap',
      columnGap: token.marginXS,
      // Group > Grid
      [`> ${token.antCls}-row`]: {
        flex: 1
      }
    }),
    // Wrapper
    [wrapperCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      display: 'inline-flex',
      alignItems: 'baseline',
      cursor: 'pointer',
      // Fix checkbox & radio in flex align #30260
      '&:after': {
        display: 'inline-block',
        width: 0,
        overflow: 'hidden',
        content: "'\\a0'"
      },
      // Checkbox near checkbox
      [`& + ${wrapperCls}`]: {
        marginInlineStart: 0
      },
      [`&${wrapperCls}-in-form-item`]: {
        'input[type="checkbox"]': {
          width: 14,
          // FIXME: magic
          height: 14 // FIXME: magic
        }
      }
    }),
    // Wrapper > Checkbox
    [checkboxCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      position: 'relative',
      whiteSpace: 'nowrap',
      lineHeight: 1,
      cursor: 'pointer',
      borderRadius: token.borderRadiusSM,
      // To make alignment right when `controlHeight` is changed
      // Ref: https://github.com/ant-design/ant-design/issues/41564
      alignSelf: 'center',
      // Wrapper > Checkbox > input
      [`${checkboxCls}-input`]: {
        position: 'absolute',
        // Since baseline align will get additional space offset,
        // we need to move input to top to make it align with text.
        // Ref: https://github.com/ant-design/ant-design/issues/38926#issuecomment-1486137799
        inset: 0,
        zIndex: 1,
        cursor: 'pointer',
        opacity: 0,
        margin: 0,
        [`&:focus-visible + ${checkboxCls}-inner`]: genFocusOutline(token)
      },
      // Wrapper > Checkbox > inner
      [`${checkboxCls}-inner`]: {
        boxSizing: 'border-box',
        display: 'block',
        width: token.checkboxSize,
        height: token.checkboxSize,
        direction: 'ltr',
        backgroundColor: token.colorBgContainer,
        border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
        borderRadius: token.borderRadiusSM,
        borderCollapse: 'separate',
        transition: `all ${token.motionDurationSlow}`,
        '&:after': {
          boxSizing: 'border-box',
          position: 'absolute',
          top: '50%',
          insetInlineStart: '25%',
          display: 'table',
          width: token.calc(token.checkboxSize).div(14).mul(5).equal(),
          height: token.calc(token.checkboxSize).div(14).mul(8).equal(),
          border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidthBold)} solid ${token.colorWhite}`,
          borderTop: 0,
          borderInlineStart: 0,
          transform: 'rotate(45deg) scale(0) translate(-50%,-50%)',
          opacity: 0,
          content: '""',
          transition: `all ${token.motionDurationFast} ${token.motionEaseInBack}, opacity ${token.motionDurationFast}`
        }
      },
      // Wrapper > Checkbox + Text
      '& + span': {
        paddingInlineStart: token.paddingXS,
        paddingInlineEnd: token.paddingXS
      }
    })
  },
  // ===================== Hover =====================
  {
    // Wrapper & Wrapper > Checkbox
    [`
        ${wrapperCls}:not(${wrapperCls}-disabled),
        ${checkboxCls}:not(${checkboxCls}-disabled)
      `]: {
      [`&:hover ${checkboxCls}-inner`]: {
        borderColor: token.colorPrimary
      }
    },
    [`${wrapperCls}:not(${wrapperCls}-disabled)`]: {
      [`&:hover ${checkboxCls}-checked:not(${checkboxCls}-disabled) ${checkboxCls}-inner`]: {
        backgroundColor: token.colorPrimaryHover,
        borderColor: 'transparent'
      },
      [`&:hover ${checkboxCls}-checked:not(${checkboxCls}-disabled):after`]: {
        borderColor: token.colorPrimaryHover
      }
    }
  },
  // ==================== Checked ====================
  {
    // Wrapper > Checkbox
    [`${checkboxCls}-checked`]: {
      [`${checkboxCls}-inner`]: {
        backgroundColor: token.colorPrimary,
        borderColor: token.colorPrimary,
        '&:after': {
          opacity: 1,
          transform: 'rotate(45deg) scale(1) translate(-50%,-50%)',
          transition: `all ${token.motionDurationMid} ${token.motionEaseOutBack} ${token.motionDurationFast}`
        }
      }
    },
    [`
        ${wrapperCls}-checked:not(${wrapperCls}-disabled),
        ${checkboxCls}-checked:not(${checkboxCls}-disabled)
      `]: {
      [`&:hover ${checkboxCls}-inner`]: {
        backgroundColor: token.colorPrimaryHover,
        borderColor: 'transparent'
      }
    }
  },
  // ================= Indeterminate =================
  {
    [checkboxCls]: {
      '&-indeterminate': {
        '&': {
          // Wrapper > Checkbox > inner
          [`${checkboxCls}-inner`]: {
            backgroundColor: `${token.colorBgContainer}`,
            borderColor: `${token.colorBorder}`,
            '&:after': {
              top: '50%',
              insetInlineStart: '50%',
              width: token.calc(token.fontSizeLG).div(2).equal(),
              height: token.calc(token.fontSizeLG).div(2).equal(),
              backgroundColor: token.colorPrimary,
              border: 0,
              transform: 'translate(-50%, -50%) scale(1)',
              opacity: 1,
              content: '""'
            }
          },
          // https://github.com/ant-design/ant-design/issues/50074
          [`&:hover ${checkboxCls}-inner`]: {
            backgroundColor: `${token.colorBgContainer}`,
            borderColor: `${token.colorPrimary}`
          }
        }
      }
    }
  },
  // ==================== Disable ====================
  {
    // Wrapper
    [`${wrapperCls}-disabled`]: {
      cursor: 'not-allowed'
    },
    // Wrapper > Checkbox
    [`${checkboxCls}-disabled`]: {
      // Wrapper > Checkbox > input
      [`&, ${checkboxCls}-input`]: {
        cursor: 'not-allowed',
        // Disabled for native input to enable Tooltip event handler
        // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-1365075901
        pointerEvents: 'none'
      },
      // Wrapper > Checkbox > inner
      [`${checkboxCls}-inner`]: {
        background: token.colorBgContainerDisabled,
        borderColor: token.colorBorder,
        '&:after': {
          borderColor: token.colorTextDisabled
        }
      },
      '&:after': {
        display: 'none'
      },
      '& + span': {
        color: token.colorTextDisabled
      },
      [`&${checkboxCls}-indeterminate ${checkboxCls}-inner::after`]: {
        background: token.colorTextDisabled
      }
    }
  }];
};
// ============================== Export ==============================
function style_getStyle(prefixCls, token) {
  const checkboxToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    checkboxCls: `.${prefixCls}`,
    checkboxSize: token.controlInteractiveSize
  });
  return genCheckboxStyle(checkboxToken);
}
/* harmony default export */ var checkbox_style = (genStyleHooks('Checkbox', (token, {
  prefixCls
}) => [style_getStyle(prefixCls, token)]));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/cascader/style/columns.js



const getColumnsStyle = token => {
  const {
    prefixCls,
    componentCls
  } = token;
  const cascaderMenuItemCls = `${componentCls}-menu-item`;
  const iconCls = `
  &${cascaderMenuItemCls}-expand ${cascaderMenuItemCls}-expand-icon,
  ${cascaderMenuItemCls}-loading-icon
`;
  return [
  // ==================== Checkbox ====================
  style_getStyle(`${prefixCls}-checkbox`, token), {
    [componentCls]: {
      // ================== Checkbox ==================
      '&-checkbox': {
        top: 0,
        marginInlineEnd: token.paddingXS,
        pointerEvents: 'unset'
      },
      // ==================== Menu ====================
      // >>> Menus
      '&-menus': {
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'flex-start',
        [`&${componentCls}-menu-empty`]: {
          [`${componentCls}-menu`]: {
            width: '100%',
            height: 'auto',
            [cascaderMenuItemCls]: {
              color: token.colorTextDisabled
            }
          }
        }
      },
      // >>> Menu
      '&-menu': {
        flexGrow: 1,
        flexShrink: 0,
        minWidth: token.controlItemWidth,
        height: token.dropdownHeight,
        margin: 0,
        padding: token.menuPadding,
        overflow: 'auto',
        verticalAlign: 'top',
        listStyle: 'none',
        '-ms-overflow-style': '-ms-autohiding-scrollbar',
        // https://github.com/ant-design/ant-design/issues/11857
        '&:not(:last-child)': {
          borderInlineEnd: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
        },
        '&-item': Object.assign(Object.assign({}, textEllipsis), {
          display: 'flex',
          flexWrap: 'nowrap',
          alignItems: 'center',
          padding: token.optionPadding,
          lineHeight: token.lineHeight,
          cursor: 'pointer',
          transition: `all ${token.motionDurationMid}`,
          borderRadius: token.borderRadiusSM,
          '&:hover': {
            background: token.controlItemBgHover
          },
          '&-disabled': {
            color: token.colorTextDisabled,
            cursor: 'not-allowed',
            '&:hover': {
              background: 'transparent'
            },
            [iconCls]: {
              color: token.colorTextDisabled
            }
          },
          [`&-active:not(${cascaderMenuItemCls}-disabled)`]: {
            '&, &:hover': {
              color: token.optionSelectedColor,
              fontWeight: token.optionSelectedFontWeight,
              backgroundColor: token.optionSelectedBg
            }
          },
          '&-content': {
            flex: 'auto'
          },
          [iconCls]: {
            marginInlineStart: token.paddingXXS,
            color: token.colorIcon,
            fontSize: token.fontSizeIcon
          },
          '&-keyword': {
            color: token.colorHighlight
          }
        })
      }
    }
  }];
};
/* harmony default export */ var columns = (getColumnsStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/cascader/style/index.js



// =============================== Base ===============================
const cascader_style_genBaseStyle = token => {
  const {
    componentCls,
    antCls
  } = token;
  return [
  // =====================================================
  // ==                     Control                     ==
  // =====================================================
  {
    [componentCls]: {
      width: token.controlWidth
    }
  },
  // =====================================================
  // ==                      Popup                      ==
  // =====================================================
  {
    [`${componentCls}-dropdown`]: [{
      [`&${antCls}-select-dropdown`]: {
        padding: 0
      }
    }, columns(token)]
  },
  // =====================================================
  // ==                       RTL                       ==
  // =====================================================
  {
    [`${componentCls}-dropdown-rtl`]: {
      direction: 'rtl'
    }
  },
  // =====================================================
  // ==             Space Compact                       ==
  // =====================================================
  genCompactItemStyle(token)];
};
// ============================== Export ==============================
const cascader_style_prepareComponentToken = token => {
  const itemPaddingVertical = Math.round((token.controlHeight - token.fontSize * token.lineHeight) / 2);
  return {
    controlWidth: 184,
    controlItemWidth: 111,
    dropdownHeight: 180,
    optionSelectedBg: token.controlItemBgActive,
    optionSelectedFontWeight: token.fontWeightStrong,
    optionPadding: `${itemPaddingVertical}px ${token.paddingSM}px`,
    menuPadding: token.paddingXXS,
    optionSelectedColor: token.colorText
  };
};
/* harmony default export */ var cascader_style = (genStyleHooks('Cascader', cascader_style_genBaseStyle, cascader_style_prepareComponentToken, {
  unitless: {
    optionSelectedFontWeight: true
  }
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/cascader/style/panel.js




// ============================== Panel ===============================
const panel_genPanelStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}-panel`]: [columns(token), {
      display: 'inline-flex',
      border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`,
      borderRadius: token.borderRadiusLG,
      overflowX: 'auto',
      maxWidth: '100%',
      [`${componentCls}-menus`]: {
        alignItems: 'stretch'
      },
      [`${componentCls}-menu`]: {
        height: 'auto'
      },
      '&-empty': {
        padding: token.paddingXXS
      }
    }]
  };
};
// ============================== Export ==============================
/* harmony default export */ var style_panel = (genComponentStyleHook(['Cascader', 'Panel'], panel_genPanelStyle, cascader_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/cascader/Panel.js
"use client";












function CascaderPanel(props) {
  const {
    prefixCls: customizePrefixCls,
    className,
    multiple,
    rootClassName,
    notFoundContent,
    direction,
    expandIcon,
    disabled: customDisabled
  } = props;
  const disabled = react.useContext(config_provider_DisabledContext);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  const [prefixCls, cascaderPrefixCls, mergedDirection, renderEmpty] = hooks_useBase(customizePrefixCls, direction);
  const rootCls = hooks_useCSSVarCls(cascaderPrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = cascader_style(cascaderPrefixCls, rootCls);
  style_panel(cascaderPrefixCls);
  const isRtl = mergedDirection === 'rtl';
  // ===================== Icon ======================
  const [mergedExpandIcon, loadingIcon] = hooks_useColumnIcons(prefixCls, isRtl, expandIcon);
  // ===================== Empty =====================
  const mergedNotFoundContent = notFoundContent || (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty('Cascader')) || (/*#__PURE__*/react.createElement(defaultRenderEmpty, {
    componentName: "Cascader"
  }));
  // =================== Multiple ====================
  const checkable = useCheckable(cascaderPrefixCls, multiple);
  // ==================== Render =====================
  return wrapCSSVar(/*#__PURE__*/react.createElement(Panel, Object.assign({}, props, {
    checkable: checkable,
    prefixCls: cascaderPrefixCls,
    className: classnames_default()(className, hashId, rootClassName, cssVarCls, rootCls),
    notFoundContent: mergedNotFoundContent,
    direction: mergedDirection,
    expandIcon: mergedExpandIcon,
    loadingIcon: loadingIcon,
    disabled: mergedDisabled
  })));
}
/* harmony default export */ var cascader_Panel = (CascaderPanel);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/cascader/index.js
"use client";


var cascader_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




























const {
  SHOW_CHILD: cascader_SHOW_CHILD,
  SHOW_PARENT: cascader_SHOW_PARENT
} = rc_cascader_es;
function highlightKeyword(str, lowerKeyword, prefixCls) {
  const cells = str.toLowerCase().split(lowerKeyword).reduce((list, cur, index) => index === 0 ? [cur] : [].concat((0,toConsumableArray/* default */.Z)(list), [lowerKeyword, cur]), []);
  const fillCells = [];
  let start = 0;
  cells.forEach((cell, index) => {
    const end = start + cell.length;
    let originWorld = str.slice(start, end);
    start = end;
    if (index % 2 === 1) {
      originWorld = /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      react.createElement("span", {
        className: `${prefixCls}-menu-item-keyword`,
        key: `separator-${index}`
      }, originWorld);
    }
    fillCells.push(originWorld);
  });
  return fillCells;
}
const defaultSearchRender = (inputValue, path, prefixCls, fieldNames) => {
  const optionList = [];
  // We do lower here to save perf
  const lower = inputValue.toLowerCase();
  path.forEach((node, index) => {
    if (index !== 0) {
      optionList.push(' / ');
    }
    let label = node[fieldNames.label];
    const type = typeof label;
    if (type === 'string' || type === 'number') {
      label = highlightKeyword(String(label), lower, prefixCls);
    }
    optionList.push(label);
  });
  return optionList;
};
const cascader_Cascader = /*#__PURE__*/react.forwardRef((props, ref) => {
  var _a, _b, _c, _d;
  const {
      prefixCls: customizePrefixCls,
      size: customizeSize,
      disabled: customDisabled,
      className,
      rootClassName,
      multiple,
      bordered = true,
      transitionName,
      choiceTransitionName = '',
      popupClassName,
      dropdownClassName,
      expandIcon,
      placement,
      showSearch,
      allowClear = true,
      notFoundContent,
      direction,
      getPopupContainer,
      status: customStatus,
      showArrow,
      builtinPlacements,
      style,
      variant: customVariant,
      dropdownRender,
      onDropdownVisibleChange,
      dropdownMenuColumnStyle,
      popupRender,
      dropdownStyle,
      popupMenuColumnStyle,
      onOpenChange,
      styles,
      classNames
    } = props,
    rest = cascader_rest(props, ["prefixCls", "size", "disabled", "className", "rootClassName", "multiple", "bordered", "transitionName", "choiceTransitionName", "popupClassName", "dropdownClassName", "expandIcon", "placement", "showSearch", "allowClear", "notFoundContent", "direction", "getPopupContainer", "status", "showArrow", "builtinPlacements", "style", "variant", "dropdownRender", "onDropdownVisibleChange", "dropdownMenuColumnStyle", "popupRender", "dropdownStyle", "popupMenuColumnStyle", "onOpenChange", "styles", "classNames"]);
  const restProps = (0,omit/* default */.Z)(rest, ['suffixIcon']);
  const {
    getPrefixCls,
    getPopupContainer: getContextPopupContainer,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig('cascader');
  const {
    popupOverflow
  } = react.useContext(ConfigContext);
  // =================== Form =====================
  const {
    status: contextStatus,
    hasFeedback,
    isFormItemInput,
    feedbackIcon
  } = react.useContext(FormItemInputContext);
  const mergedStatus = getMergedStatus(contextStatus, customStatus);
  // =================== Warning =====================
  if (false) {}
  // ==================== Prefix =====================
  const [prefixCls, cascaderPrefixCls, mergedDirection, renderEmpty] = hooks_useBase(customizePrefixCls, direction);
  const isRtl = mergedDirection === 'rtl';
  const rootPrefixCls = getPrefixCls();
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapSelectCSSVar, hashId, cssVarCls] = select_style(prefixCls, rootCls);
  const cascaderRootCls = hooks_useCSSVarCls(cascaderPrefixCls);
  const [wrapCascaderCSSVar] = cascader_style(cascaderPrefixCls, cascaderRootCls);
  const {
    compactSize,
    compactItemClassnames
  } = useCompactItemContext(prefixCls, direction);
  const [variant, enableVariantCls] = useVariants('cascader', customVariant, bordered);
  // =================== No Found ====================
  const mergedNotFoundContent = notFoundContent || (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty('Cascader')) || (/*#__PURE__*/react.createElement(defaultRenderEmpty, {
    componentName: "Cascader"
  }));
  // =================== Dropdown ====================
  const mergedPopupClassName = classnames_default()(((_a = classNames === null || classNames === void 0 ? void 0 : classNames.popup) === null || _a === void 0 ? void 0 : _a.root) || ((_b = contextClassNames.popup) === null || _b === void 0 ? void 0 : _b.root) || popupClassName || dropdownClassName, `${cascaderPrefixCls}-dropdown`, {
    [`${cascaderPrefixCls}-dropdown-rtl`]: mergedDirection === 'rtl'
  }, rootClassName, rootCls, contextClassNames.root, classNames === null || classNames === void 0 ? void 0 : classNames.root, cascaderRootCls, hashId, cssVarCls);
  const mergedPopupRender = select_usePopupRender(popupRender || dropdownRender);
  const mergedPopupMenuColumnStyle = popupMenuColumnStyle || dropdownMenuColumnStyle;
  const mergedOnOpenChange = onOpenChange || onDropdownVisibleChange;
  const mergedPopupStyle = ((_c = styles === null || styles === void 0 ? void 0 : styles.popup) === null || _c === void 0 ? void 0 : _c.root) || ((_d = contextStyles.popup) === null || _d === void 0 ? void 0 : _d.root) || dropdownStyle;
  // ==================== Search =====================
  const mergedShowSearch = react.useMemo(() => {
    if (!showSearch) {
      return showSearch;
    }
    let searchConfig = {
      render: defaultSearchRender
    };
    if (typeof showSearch === 'object') {
      searchConfig = Object.assign(Object.assign({}, searchConfig), showSearch);
    }
    return searchConfig;
  }, [showSearch]);
  // ===================== Size ======================
  const mergedSize = hooks_useSize(ctx => {
    var _a;
    return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
  });
  // ===================== Disabled =====================
  const disabled = react.useContext(config_provider_DisabledContext);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  // ===================== Icon ======================
  const [mergedExpandIcon, loadingIcon] = hooks_useColumnIcons(prefixCls, isRtl, expandIcon);
  // =================== Multiple ====================
  const checkable = useCheckable(cascaderPrefixCls, multiple);
  // ===================== Icons =====================
  const showSuffixIcon = useShowArrow(props.suffixIcon, showArrow);
  const {
    suffixIcon,
    removeIcon,
    clearIcon
  } = useIcons(Object.assign(Object.assign({}, props), {
    hasFeedback,
    feedbackIcon,
    showSuffixIcon,
    multiple,
    prefixCls,
    componentName: 'Cascader'
  }));
  // ===================== Placement =====================
  const memoPlacement = react.useMemo(() => {
    if (placement !== undefined) {
      return placement;
    }
    return isRtl ? 'bottomRight' : 'bottomLeft';
  }, [placement, isRtl]);
  const mergedAllowClear = allowClear === true ? {
    clearIcon
  } : allowClear;
  // ============================ zIndex ============================
  const [zIndex] = useZIndex('SelectLike', mergedPopupStyle === null || mergedPopupStyle === void 0 ? void 0 : mergedPopupStyle.zIndex);
  // ==================== Render =====================
  const renderNode = /*#__PURE__*/react.createElement(rc_cascader_es, Object.assign({
    prefixCls: prefixCls,
    className: classnames_default()(!customizePrefixCls && cascaderPrefixCls, {
      [`${prefixCls}-lg`]: mergedSize === 'large',
      [`${prefixCls}-sm`]: mergedSize === 'small',
      [`${prefixCls}-rtl`]: isRtl,
      [`${prefixCls}-${variant}`]: enableVariantCls,
      [`${prefixCls}-in-form-item`]: isFormItemInput
    }, getStatusClassNames(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, contextClassName, className, rootClassName, classNames === null || classNames === void 0 ? void 0 : classNames.root, contextClassNames.root, rootCls, cascaderRootCls, hashId, cssVarCls),
    disabled: mergedDisabled,
    style: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.root), styles === null || styles === void 0 ? void 0 : styles.root), contextStyle), style)
  }, restProps, {
    builtinPlacements: select_mergedBuiltinPlacements(builtinPlacements, popupOverflow),
    direction: mergedDirection,
    placement: memoPlacement,
    notFoundContent: mergedNotFoundContent,
    allowClear: mergedAllowClear,
    showSearch: mergedShowSearch,
    expandIcon: mergedExpandIcon,
    suffixIcon: suffixIcon,
    removeIcon: removeIcon,
    loadingIcon: loadingIcon,
    checkable: checkable,
    dropdownClassName: mergedPopupClassName,
    dropdownPrefixCls: customizePrefixCls || cascaderPrefixCls,
    dropdownStyle: Object.assign(Object.assign({}, mergedPopupStyle), {
      zIndex
    }),
    dropdownRender: mergedPopupRender,
    dropdownMenuColumnStyle: mergedPopupMenuColumnStyle,
    onOpenChange: mergedOnOpenChange,
    choiceTransitionName: getTransitionName(rootPrefixCls, '', choiceTransitionName),
    transitionName: getTransitionName(rootPrefixCls, 'slide-up', transitionName),
    getPopupContainer: getPopupContainer || getContextPopupContainer,
    ref: ref
  }));
  return wrapCascaderCSSVar(wrapSelectCSSVar(renderNode));
});
if (false) {}
// We don't care debug panel
/* istanbul ignore next */
const cascader_PurePanel = _util_PurePanel(cascader_Cascader, 'dropdownAlign', props => (0,omit/* default */.Z)(props, ['visible']));
cascader_Cascader.SHOW_PARENT = cascader_SHOW_PARENT;
cascader_Cascader.SHOW_CHILD = cascader_SHOW_CHILD;
cascader_Cascader.Panel = cascader_Panel;
cascader_Cascader._InternalPanelDoNotUseOrYouWillBeFired = cascader_PurePanel;
/* harmony default export */ var cascader = (cascader_Cascader);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/checkbox/GroupContext.js

const GroupContext = /*#__PURE__*/react.createContext(null);
/* harmony default export */ var checkbox_GroupContext = (GroupContext);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/checkbox/Checkbox.js
"use client";

var Checkbox_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};














const InternalCheckbox = (props, ref) => {
  var _a;
  const {
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      children,
      indeterminate = false,
      style,
      onMouseEnter,
      onMouseLeave,
      skipGroup = false,
      disabled
    } = props,
    restProps = Checkbox_rest(props, ["prefixCls", "className", "rootClassName", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave", "skipGroup", "disabled"]);
  const {
    getPrefixCls,
    direction,
    checkbox
  } = react.useContext(ConfigContext);
  const checkboxGroup = react.useContext(checkbox_GroupContext);
  const {
    isFormItemInput
  } = react.useContext(FormItemInputContext);
  const contextDisabled = react.useContext(config_provider_DisabledContext);
  const mergedDisabled = (_a = (checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.disabled) || disabled) !== null && _a !== void 0 ? _a : contextDisabled;
  const prevValue = react.useRef(restProps.value);
  const checkboxRef = react.useRef(null);
  const mergedRef = (0,es_ref/* composeRef */.sQ)(ref, checkboxRef);
  if (false) {}
  react.useEffect(() => {
    checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.registerValue(restProps.value);
  }, []);
  react.useEffect(() => {
    if (skipGroup) {
      return;
    }
    if (restProps.value !== prevValue.current) {
      checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(prevValue.current);
      checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.registerValue(restProps.value);
      prevValue.current = restProps.value;
    }
    return () => checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(restProps.value);
  }, [restProps.value]);
  react.useEffect(() => {
    var _a;
    if ((_a = checkboxRef.current) === null || _a === void 0 ? void 0 : _a.input) {
      checkboxRef.current.input.indeterminate = indeterminate;
    }
  }, [indeterminate]);
  const prefixCls = getPrefixCls('checkbox', customizePrefixCls);
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = checkbox_style(prefixCls, rootCls);
  const checkboxProps = Object.assign({}, restProps);
  if (checkboxGroup && !skipGroup) {
    checkboxProps.onChange = (...args) => {
      if (restProps.onChange) {
        restProps.onChange.apply(restProps, args);
      }
      if (checkboxGroup.toggleOption) {
        checkboxGroup.toggleOption({
          label: children,
          value: restProps.value
        });
      }
    };
    checkboxProps.name = checkboxGroup.name;
    checkboxProps.checked = checkboxGroup.value.includes(restProps.value);
  }
  const classString = classnames_default()(`${prefixCls}-wrapper`, {
    [`${prefixCls}-rtl`]: direction === 'rtl',
    [`${prefixCls}-wrapper-checked`]: checkboxProps.checked,
    [`${prefixCls}-wrapper-disabled`]: mergedDisabled,
    [`${prefixCls}-wrapper-in-form-item`]: isFormItemInput
  }, checkbox === null || checkbox === void 0 ? void 0 : checkbox.className, className, rootClassName, cssVarCls, rootCls, hashId);
  const checkboxClass = classnames_default()({
    [`${prefixCls}-indeterminate`]: indeterminate
  }, TARGET_CLS, hashId);
  // ============================ Event Lock ============================
  const [onLabelClick, onInputClick] = useBubbleLock(checkboxProps.onClick);
  // ============================== Render ==============================
  return wrapCSSVar(/*#__PURE__*/react.createElement(wave, {
    component: "Checkbox",
    disabled: mergedDisabled
  }, /*#__PURE__*/react.createElement("label", {
    className: classString,
    style: Object.assign(Object.assign({}, checkbox === null || checkbox === void 0 ? void 0 : checkbox.style), style),
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: onLabelClick
  }, /*#__PURE__*/react.createElement(rc_checkbox_es/* default */.Z, Object.assign({}, checkboxProps, {
    onClick: onInputClick,
    prefixCls: prefixCls,
    className: checkboxClass,
    disabled: mergedDisabled,
    ref: mergedRef
  })), children !== undefined && children !== null && (/*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-label`
  }, children)))));
};
const Checkbox_Checkbox = /*#__PURE__*/react.forwardRef(InternalCheckbox);
if (false) {}
/* harmony default export */ var checkbox_Checkbox = (Checkbox_Checkbox);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/checkbox/Group.js
"use client";


var Group_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};








const CheckboxGroup = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      defaultValue,
      children,
      options = [],
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      style,
      onChange
    } = props,
    restProps = Group_rest(props, ["defaultValue", "children", "options", "prefixCls", "className", "rootClassName", "style", "onChange"]);
  const {
    getPrefixCls,
    direction
  } = react.useContext(ConfigContext);
  const [value, setValue] = react.useState(restProps.value || defaultValue || []);
  const [registeredValues, setRegisteredValues] = react.useState([]);
  react.useEffect(() => {
    if ('value' in restProps) {
      setValue(restProps.value || []);
    }
  }, [restProps.value]);
  const memoizedOptions = react.useMemo(() => options.map(option => {
    if (typeof option === 'string' || typeof option === 'number') {
      return {
        label: option,
        value: option
      };
    }
    return option;
  }), [options]);
  const cancelValue = val => {
    setRegisteredValues(prevValues => prevValues.filter(v => v !== val));
  };
  const registerValue = val => {
    setRegisteredValues(prevValues => [].concat((0,toConsumableArray/* default */.Z)(prevValues), [val]));
  };
  const toggleOption = option => {
    const optionIndex = value.indexOf(option.value);
    const newValue = (0,toConsumableArray/* default */.Z)(value);
    if (optionIndex === -1) {
      newValue.push(option.value);
    } else {
      newValue.splice(optionIndex, 1);
    }
    if (!('value' in restProps)) {
      setValue(newValue);
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(newValue.filter(val => registeredValues.includes(val)).sort((a, b) => {
      const indexA = memoizedOptions.findIndex(opt => opt.value === a);
      const indexB = memoizedOptions.findIndex(opt => opt.value === b);
      return indexA - indexB;
    }));
  };
  const prefixCls = getPrefixCls('checkbox', customizePrefixCls);
  const groupPrefixCls = `${prefixCls}-group`;
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = checkbox_style(prefixCls, rootCls);
  const domProps = (0,omit/* default */.Z)(restProps, ['value', 'disabled']);
  const childrenNode = options.length ? memoizedOptions.map(option => (/*#__PURE__*/react.createElement(checkbox_Checkbox, {
    prefixCls: prefixCls,
    key: option.value.toString(),
    disabled: 'disabled' in option ? option.disabled : restProps.disabled,
    value: option.value,
    checked: value.includes(option.value),
    onChange: option.onChange,
    className: classnames_default()(`${groupPrefixCls}-item`, option.className),
    style: option.style,
    title: option.title,
    id: option.id,
    required: option.required
  }, option.label))) : children;
  const memoizedContext = react.useMemo(() => ({
    toggleOption,
    value,
    disabled: restProps.disabled,
    name: restProps.name,
    // https://github.com/ant-design/ant-design/issues/16376
    registerValue,
    cancelValue
  }), [toggleOption, value, restProps.disabled, restProps.name, registerValue, cancelValue]);
  const classString = classnames_default()(groupPrefixCls, {
    [`${groupPrefixCls}-rtl`]: direction === 'rtl'
  }, className, rootClassName, cssVarCls, rootCls, hashId);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", Object.assign({
    className: classString,
    style: style
  }, domProps, {
    ref: ref
  }), /*#__PURE__*/react.createElement(checkbox_GroupContext.Provider, {
    value: memoizedContext
  }, childrenNode)));
});

/* harmony default export */ var Group = (CheckboxGroup);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/checkbox/index.js
"use client";



const es_checkbox_Checkbox = checkbox_Checkbox;
es_checkbox_Checkbox.Group = Group;
es_checkbox_Checkbox.__ANT_CHECKBOX = true;
if (false) {}
/* harmony default export */ var es_checkbox = (es_checkbox_Checkbox);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/grid/RowContext.js

const RowContext = /*#__PURE__*/(0,react.createContext)({});
/* harmony default export */ var grid_RowContext = (RowContext);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/grid/col.js
"use client";

var col_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





function parseFlex(flex) {
  if (typeof flex === 'number') {
    return `${flex} ${flex} auto`;
  }
  if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) {
    return `0 0 ${flex}`;
  }
  return flex;
}
const sizes = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
const Col = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    getPrefixCls,
    direction
  } = react.useContext(ConfigContext);
  const {
    gutter,
    wrap
  } = react.useContext(grid_RowContext);
  const {
      prefixCls: customizePrefixCls,
      span,
      order,
      offset,
      push,
      pull,
      className,
      children,
      flex,
      style
    } = props,
    others = col_rest(props, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children", "flex", "style"]);
  const prefixCls = getPrefixCls('col', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = useColStyle(prefixCls);
  // ===================== Size ======================
  const sizeStyle = {};
  let sizeClassObj = {};
  sizes.forEach(size => {
    let sizeProps = {};
    const propSize = props[size];
    if (typeof propSize === 'number') {
      sizeProps.span = propSize;
    } else if (typeof propSize === 'object') {
      sizeProps = propSize || {};
    }
    delete others[size];
    sizeClassObj = Object.assign(Object.assign({}, sizeClassObj), {
      [`${prefixCls}-${size}-${sizeProps.span}`]: sizeProps.span !== undefined,
      [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0,
      [`${prefixCls}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0,
      [`${prefixCls}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0,
      [`${prefixCls}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0,
      [`${prefixCls}-rtl`]: direction === 'rtl'
    });
    // Responsive flex layout
    if (sizeProps.flex) {
      sizeClassObj[`${prefixCls}-${size}-flex`] = true;
      sizeStyle[`--${prefixCls}-${size}-flex`] = parseFlex(sizeProps.flex);
    }
  });
  // ==================== Normal =====================
  const classes = classnames_default()(prefixCls, {
    [`${prefixCls}-${span}`]: span !== undefined,
    [`${prefixCls}-order-${order}`]: order,
    [`${prefixCls}-offset-${offset}`]: offset,
    [`${prefixCls}-push-${push}`]: push,
    [`${prefixCls}-pull-${pull}`]: pull
  }, className, sizeClassObj, hashId, cssVarCls);
  const mergedStyle = {};
  // Horizontal gutter use padding
  if (gutter && gutter[0] > 0) {
    const horizontalGutter = gutter[0] / 2;
    mergedStyle.paddingLeft = horizontalGutter;
    mergedStyle.paddingRight = horizontalGutter;
  }
  if (flex) {
    mergedStyle.flex = parseFlex(flex);
    // Hack for Firefox to avoid size issue
    // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
    if (wrap === false && !mergedStyle.minWidth) {
      mergedStyle.minWidth = 0;
    }
  }
  // ==================== Render =====================
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", Object.assign({}, others, {
    style: Object.assign(Object.assign(Object.assign({}, mergedStyle), style), sizeStyle),
    className: classes,
    ref: ref
  }), children));
});
if (false) {}
/* harmony default export */ var col = (Col);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/col/index.js
"use client";


/* harmony default export */ var es_col = (col);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/divider/style/index.js



// ============================== Size ================================
const genSizeDividerStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [componentCls]: {
      '&-horizontal': {
        [`&${componentCls}`]: {
          '&-sm': {
            marginBlock: token.marginXS
          },
          '&-md': {
            marginBlock: token.margin
          }
        }
      }
    }
  };
};
// ============================== Shared ==============================
const genSharedDividerStyle = token => {
  const {
    componentCls,
    sizePaddingEdgeHorizontal,
    colorSplit,
    lineWidth,
    textPaddingInline,
    orientationMargin,
    verticalMarginInline
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      borderBlockStart: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} solid ${colorSplit}`,
      // vertical
      '&-vertical': {
        position: 'relative',
        top: '-0.06em',
        display: 'inline-block',
        height: '0.9em',
        marginInline: verticalMarginInline,
        marginBlock: 0,
        verticalAlign: 'middle',
        borderTop: 0,
        borderInlineStart: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} solid ${colorSplit}`
      },
      '&-horizontal': {
        display: 'flex',
        clear: 'both',
        width: '100%',
        minWidth: '100%',
        // Fix https://github.com/ant-design/ant-design/issues/10914
        margin: `${(0,cssinjs_es/* unit */.bf)(token.marginLG)} 0`
      },
      [`&-horizontal${componentCls}-with-text`]: {
        display: 'flex',
        alignItems: 'center',
        margin: `${(0,cssinjs_es/* unit */.bf)(token.dividerHorizontalWithTextGutterMargin)} 0`,
        color: token.colorTextHeading,
        fontWeight: 500,
        fontSize: token.fontSizeLG,
        whiteSpace: 'nowrap',
        textAlign: 'center',
        borderBlockStart: `0 ${colorSplit}`,
        '&::before, &::after': {
          position: 'relative',
          width: '50%',
          borderBlockStart: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} solid transparent`,
          // Chrome not accept `inherit` in `border-top`
          borderBlockStartColor: 'inherit',
          borderBlockEnd: 0,
          transform: 'translateY(50%)',
          content: "''"
        }
      },
      [`&-horizontal${componentCls}-with-text-start`]: {
        '&::before': {
          width: `calc(${orientationMargin} * 100%)`
        },
        '&::after': {
          width: `calc(100% - ${orientationMargin} * 100%)`
        }
      },
      [`&-horizontal${componentCls}-with-text-end`]: {
        '&::before': {
          width: `calc(100% - ${orientationMargin} * 100%)`
        },
        '&::after': {
          width: `calc(${orientationMargin} * 100%)`
        }
      },
      [`${componentCls}-inner-text`]: {
        display: 'inline-block',
        paddingBlock: 0,
        paddingInline: textPaddingInline
      },
      '&-dashed': {
        background: 'none',
        borderColor: colorSplit,
        borderStyle: 'dashed',
        borderWidth: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} 0 0`
      },
      [`&-horizontal${componentCls}-with-text${componentCls}-dashed`]: {
        '&::before, &::after': {
          borderStyle: 'dashed none none'
        }
      },
      [`&-vertical${componentCls}-dashed`]: {
        borderInlineStartWidth: lineWidth,
        borderInlineEnd: 0,
        borderBlockStart: 0,
        borderBlockEnd: 0
      },
      '&-dotted': {
        background: 'none',
        borderColor: colorSplit,
        borderStyle: 'dotted',
        borderWidth: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} 0 0`
      },
      [`&-horizontal${componentCls}-with-text${componentCls}-dotted`]: {
        '&::before, &::after': {
          borderStyle: 'dotted none none'
        }
      },
      [`&-vertical${componentCls}-dotted`]: {
        borderInlineStartWidth: lineWidth,
        borderInlineEnd: 0,
        borderBlockStart: 0,
        borderBlockEnd: 0
      },
      [`&-plain${componentCls}-with-text`]: {
        color: token.colorText,
        fontWeight: 'normal',
        fontSize: token.fontSize
      },
      [`&-horizontal${componentCls}-with-text-start${componentCls}-no-default-orientation-margin-start`]: {
        '&::before': {
          width: 0
        },
        '&::after': {
          width: '100%'
        },
        [`${componentCls}-inner-text`]: {
          paddingInlineStart: sizePaddingEdgeHorizontal
        }
      },
      [`&-horizontal${componentCls}-with-text-end${componentCls}-no-default-orientation-margin-end`]: {
        '&::before': {
          width: '100%'
        },
        '&::after': {
          width: 0
        },
        [`${componentCls}-inner-text`]: {
          paddingInlineEnd: sizePaddingEdgeHorizontal
        }
      }
    })
  };
};
const divider_style_prepareComponentToken = token => ({
  textPaddingInline: '1em',
  orientationMargin: 0.05,
  verticalMarginInline: token.marginXS
});
// ============================== Export ==============================
/* harmony default export */ var divider_style = (genStyleHooks('Divider', token => {
  const dividerToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    dividerHorizontalWithTextGutterMargin: token.margin,
    sizePaddingEdgeHorizontal: 0
  });
  return [genSharedDividerStyle(dividerToken), genSizeDividerStyle(dividerToken)];
}, divider_style_prepareComponentToken, {
  unitless: {
    orientationMargin: true
  }
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/divider/index.js
"use client";

var divider_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






const sizeClassNameMap = {
  small: 'sm',
  middle: 'md'
};
const Divider = props => {
  const {
    getPrefixCls,
    direction,
    className: dividerClassName,
    style: dividerStyle
  } = useComponentConfig('divider');
  const {
      prefixCls: customizePrefixCls,
      type = 'horizontal',
      orientation = 'center',
      orientationMargin,
      className,
      rootClassName,
      children,
      dashed,
      variant = 'solid',
      plain,
      style,
      size: customSize
    } = props,
    restProps = divider_rest(props, ["prefixCls", "type", "orientation", "orientationMargin", "className", "rootClassName", "children", "dashed", "variant", "plain", "style", "size"]);
  const prefixCls = getPrefixCls('divider', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = divider_style(prefixCls);
  const sizeFullName = hooks_useSize(customSize);
  const sizeCls = sizeClassNameMap[sizeFullName];
  const hasChildren = !!children;
  const mergedOrientation = react.useMemo(() => {
    if (orientation === 'left') {
      return direction === 'rtl' ? 'end' : 'start';
    }
    if (orientation === 'right') {
      return direction === 'rtl' ? 'start' : 'end';
    }
    return orientation;
  }, [direction, orientation]);
  const hasMarginStart = mergedOrientation === 'start' && orientationMargin != null;
  const hasMarginEnd = mergedOrientation === 'end' && orientationMargin != null;
  const classString = classnames_default()(prefixCls, dividerClassName, hashId, cssVarCls, `${prefixCls}-${type}`, {
    [`${prefixCls}-with-text`]: hasChildren,
    [`${prefixCls}-with-text-${mergedOrientation}`]: hasChildren,
    [`${prefixCls}-dashed`]: !!dashed,
    [`${prefixCls}-${variant}`]: variant !== 'solid',
    [`${prefixCls}-plain`]: !!plain,
    [`${prefixCls}-rtl`]: direction === 'rtl',
    [`${prefixCls}-no-default-orientation-margin-start`]: hasMarginStart,
    [`${prefixCls}-no-default-orientation-margin-end`]: hasMarginEnd,
    [`${prefixCls}-${sizeCls}`]: !!sizeCls
  }, className, rootClassName);
  const memoizedOrientationMargin = react.useMemo(() => {
    if (typeof orientationMargin === 'number') {
      return orientationMargin;
    }
    if (/^\d+$/.test(orientationMargin)) {
      return Number(orientationMargin);
    }
    return orientationMargin;
  }, [orientationMargin]);
  const innerStyle = {
    marginInlineStart: hasMarginStart ? memoizedOrientationMargin : undefined,
    marginInlineEnd: hasMarginEnd ? memoizedOrientationMargin : undefined
  };
  // Warning children not work in vertical mode
  if (false) {}
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", Object.assign({
    className: classString,
    style: Object.assign(Object.assign({}, dividerStyle), style)
  }, restProps, {
    role: "separator"
  }), children && type !== 'vertical' && (/*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-inner-text`,
    style: innerStyle
  }, children))));
};
if (false) {}
/* harmony default export */ var divider = (Divider);
;// CONCATENATED MODULE: ./node_modules/rc-segmented/es/MotionThumb.js







var calcThumbStyle = function calcThumbStyle(targetElement, vertical) {
  if (!targetElement) return null;
  var style = {
    left: targetElement.offsetLeft,
    right: targetElement.parentElement.clientWidth - targetElement.clientWidth - targetElement.offsetLeft,
    width: targetElement.clientWidth,
    top: targetElement.offsetTop,
    bottom: targetElement.parentElement.clientHeight - targetElement.clientHeight - targetElement.offsetTop,
    height: targetElement.clientHeight
  };
  if (vertical) {
    // Adjusts positioning and size for vertical layout by setting horizontal properties to 0 and using vertical properties from the style object.
    return {
      left: 0,
      right: 0,
      width: 0,
      top: style.top,
      bottom: style.bottom,
      height: style.height
    };
  }
  return {
    left: style.left,
    right: style.right,
    width: style.width,
    top: 0,
    bottom: 0,
    height: 0
  };
};
var toPX = function toPX(value) {
  return value !== undefined ? "".concat(value, "px") : undefined;
};
function MotionThumb(props) {
  var prefixCls = props.prefixCls,
    containerRef = props.containerRef,
    value = props.value,
    getValueIndex = props.getValueIndex,
    motionName = props.motionName,
    onMotionStart = props.onMotionStart,
    onMotionEnd = props.onMotionEnd,
    direction = props.direction,
    _props$vertical = props.vertical,
    vertical = _props$vertical === void 0 ? false : _props$vertical;
  var thumbRef = react.useRef(null);
  var _React$useState = react.useState(value),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    prevValue = _React$useState2[0],
    setPrevValue = _React$useState2[1];

  // =========================== Effect ===========================
  var findValueElement = function findValueElement(val) {
    var _containerRef$current;
    var index = getValueIndex(val);
    var ele = (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.querySelectorAll(".".concat(prefixCls, "-item"))[index];
    return (ele === null || ele === void 0 ? void 0 : ele.offsetParent) && ele;
  };
  var _React$useState3 = react.useState(null),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    prevStyle = _React$useState4[0],
    setPrevStyle = _React$useState4[1];
  var _React$useState5 = react.useState(null),
    _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
    nextStyle = _React$useState6[0],
    setNextStyle = _React$useState6[1];
  (0,hooks_useLayoutEffect/* default */.Z)(function () {
    if (prevValue !== value) {
      var prev = findValueElement(prevValue);
      var next = findValueElement(value);
      var calcPrevStyle = calcThumbStyle(prev, vertical);
      var calcNextStyle = calcThumbStyle(next, vertical);
      setPrevValue(value);
      setPrevStyle(calcPrevStyle);
      setNextStyle(calcNextStyle);
      if (prev && next) {
        onMotionStart();
      } else {
        onMotionEnd();
      }
    }
  }, [value]);
  var thumbStart = react.useMemo(function () {
    if (vertical) {
      var _prevStyle$top;
      return toPX((_prevStyle$top = prevStyle === null || prevStyle === void 0 ? void 0 : prevStyle.top) !== null && _prevStyle$top !== void 0 ? _prevStyle$top : 0);
    }
    if (direction === 'rtl') {
      return toPX(-(prevStyle === null || prevStyle === void 0 ? void 0 : prevStyle.right));
    }
    return toPX(prevStyle === null || prevStyle === void 0 ? void 0 : prevStyle.left);
  }, [vertical, direction, prevStyle]);
  var thumbActive = react.useMemo(function () {
    if (vertical) {
      var _nextStyle$top;
      return toPX((_nextStyle$top = nextStyle === null || nextStyle === void 0 ? void 0 : nextStyle.top) !== null && _nextStyle$top !== void 0 ? _nextStyle$top : 0);
    }
    if (direction === 'rtl') {
      return toPX(-(nextStyle === null || nextStyle === void 0 ? void 0 : nextStyle.right));
    }
    return toPX(nextStyle === null || nextStyle === void 0 ? void 0 : nextStyle.left);
  }, [vertical, direction, nextStyle]);

  // =========================== Motion ===========================
  var onAppearStart = function onAppearStart() {
    if (vertical) {
      return {
        transform: 'translateY(var(--thumb-start-top))',
        height: 'var(--thumb-start-height)'
      };
    }
    return {
      transform: 'translateX(var(--thumb-start-left))',
      width: 'var(--thumb-start-width)'
    };
  };
  var onAppearActive = function onAppearActive() {
    if (vertical) {
      return {
        transform: 'translateY(var(--thumb-active-top))',
        height: 'var(--thumb-active-height)'
      };
    }
    return {
      transform: 'translateX(var(--thumb-active-left))',
      width: 'var(--thumb-active-width)'
    };
  };
  var onVisibleChanged = function onVisibleChanged() {
    setPrevStyle(null);
    setNextStyle(null);
    onMotionEnd();
  };

  // =========================== Render ===========================
  // No need motion when nothing exist in queue
  if (!prevStyle || !nextStyle) {
    return null;
  }
  return /*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, {
    visible: true,
    motionName: motionName,
    motionAppear: true,
    onAppearStart: onAppearStart,
    onAppearActive: onAppearActive,
    onVisibleChanged: onVisibleChanged
  }, function (_ref, ref) {
    var motionClassName = _ref.className,
      motionStyle = _ref.style;
    var mergedStyle = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, motionStyle), {}, {
      '--thumb-start-left': thumbStart,
      '--thumb-start-width': toPX(prevStyle === null || prevStyle === void 0 ? void 0 : prevStyle.width),
      '--thumb-active-left': thumbActive,
      '--thumb-active-width': toPX(nextStyle === null || nextStyle === void 0 ? void 0 : nextStyle.width),
      '--thumb-start-top': thumbStart,
      '--thumb-start-height': toPX(prevStyle === null || prevStyle === void 0 ? void 0 : prevStyle.height),
      '--thumb-active-top': thumbActive,
      '--thumb-active-height': toPX(nextStyle === null || nextStyle === void 0 ? void 0 : nextStyle.height)
    });

    // It's little ugly which should be refactor when @umi/test update to latest jsdom
    var motionProps = {
      ref: (0,es_ref/* composeRef */.sQ)(thumbRef, ref),
      style: mergedStyle,
      className: classnames_default()("".concat(prefixCls, "-thumb"), motionClassName)
    };
    if (false) {}
    return /*#__PURE__*/react.createElement("div", motionProps);
  });
}
;// CONCATENATED MODULE: ./node_modules/rc-segmented/es/index.js






var es_excluded = ["prefixCls", "direction", "vertical", "options", "disabled", "defaultValue", "value", "name", "onChange", "className", "motionName"];






function getValidTitle(option) {
  if (typeof option.title !== 'undefined') {
    return option.title;
  }

  // read `label` when title is `undefined`
  if ((0,esm_typeof/* default */.Z)(option.label) !== 'object') {
    var _option$label;
    return (_option$label = option.label) === null || _option$label === void 0 ? void 0 : _option$label.toString();
  }
}
function normalizeOptions(options) {
  return options.map(function (option) {
    if ((0,esm_typeof/* default */.Z)(option) === 'object' && option !== null) {
      var validTitle = getValidTitle(option);
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, option), {}, {
        title: validTitle
      });
    }
    return {
      label: option === null || option === void 0 ? void 0 : option.toString(),
      title: option === null || option === void 0 ? void 0 : option.toString(),
      value: option
    };
  });
}
var InternalSegmentedOption = function InternalSegmentedOption(_ref) {
  var prefixCls = _ref.prefixCls,
    className = _ref.className,
    disabled = _ref.disabled,
    checked = _ref.checked,
    label = _ref.label,
    title = _ref.title,
    value = _ref.value,
    name = _ref.name,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    onKeyDown = _ref.onKeyDown,
    onKeyUp = _ref.onKeyUp,
    onMouseDown = _ref.onMouseDown;
  var handleChange = function handleChange(event) {
    if (disabled) {
      return;
    }
    onChange(event, value);
  };
  return /*#__PURE__*/react.createElement("label", {
    className: classnames_default()(className, (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-item-disabled"), disabled)),
    onMouseDown: onMouseDown
  }, /*#__PURE__*/react.createElement("input", {
    name: name,
    className: "".concat(prefixCls, "-item-input"),
    type: "radio",
    disabled: disabled,
    checked: checked,
    onChange: handleChange,
    onFocus: onFocus,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp
  }), /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-item-label"),
    title: title,
    "aria-selected": checked
  }, label));
};
var Segmented = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _segmentedOptions$, _classNames2;
  var _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-segmented' : _props$prefixCls,
    direction = props.direction,
    vertical = props.vertical,
    _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    disabled = props.disabled,
    defaultValue = props.defaultValue,
    value = props.value,
    name = props.name,
    onChange = props.onChange,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$motionName = props.motionName,
    motionName = _props$motionName === void 0 ? 'thumb-motion' : _props$motionName,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, es_excluded);
  var containerRef = react.useRef(null);
  var mergedRef = react.useMemo(function () {
    return (0,es_ref/* composeRef */.sQ)(containerRef, ref);
  }, [containerRef, ref]);
  var segmentedOptions = react.useMemo(function () {
    return normalizeOptions(options);
  }, [options]);

  // Note: We should not auto switch value when value not exist in options
  // which may break single source of truth.
  var _useMergedState = (0,useMergedState/* default */.Z)((_segmentedOptions$ = segmentedOptions[0]) === null || _segmentedOptions$ === void 0 ? void 0 : _segmentedOptions$.value, {
      value: value,
      defaultValue: defaultValue
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    rawValue = _useMergedState2[0],
    setRawValue = _useMergedState2[1];

  // ======================= Change ========================
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    thumbShow = _React$useState2[0],
    setThumbShow = _React$useState2[1];
  var handleChange = function handleChange(event, val) {
    setRawValue(val);
    onChange === null || onChange === void 0 || onChange(val);
  };
  var divProps = (0,omit/* default */.Z)(restProps, ['children']);

  // ======================= Focus ========================
  var _React$useState3 = react.useState(false),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    isKeyboard = _React$useState4[0],
    setIsKeyboard = _React$useState4[1];
  var _React$useState5 = react.useState(false),
    _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
    isFocused = _React$useState6[0],
    setIsFocused = _React$useState6[1];
  var handleFocus = function handleFocus() {
    setIsFocused(true);
  };
  var handleBlur = function handleBlur() {
    setIsFocused(false);
  };
  var handleMouseDown = function handleMouseDown() {
    setIsKeyboard(false);
  };

  // capture keyboard tab interaction for correct focus style
  var handleKeyUp = function handleKeyUp(event) {
    if (event.key === 'Tab') {
      setIsKeyboard(true);
    }
  };

  // ======================= Keyboard ========================
  var onOffset = function onOffset(offset) {
    var currentIndex = segmentedOptions.findIndex(function (option) {
      return option.value === rawValue;
    });
    var total = segmentedOptions.length;
    var nextIndex = (currentIndex + offset + total) % total;
    var nextOption = segmentedOptions[nextIndex];
    if (nextOption) {
      setRawValue(nextOption.value);
      onChange === null || onChange === void 0 || onChange(nextOption.value);
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        onOffset(-1);
        break;
      case 'ArrowRight':
      case 'ArrowDown':
        onOffset(1);
        break;
    }
  };
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    role: "radiogroup",
    "aria-label": "segmented control",
    tabIndex: disabled ? undefined : 0
  }, divProps, {
    className: classnames_default()(prefixCls, (_classNames2 = {}, (0,defineProperty/* default */.Z)(_classNames2, "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0,defineProperty/* default */.Z)(_classNames2, "".concat(prefixCls, "-disabled"), disabled), (0,defineProperty/* default */.Z)(_classNames2, "".concat(prefixCls, "-vertical"), vertical), _classNames2), className),
    ref: mergedRef
  }), /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-group")
  }, /*#__PURE__*/react.createElement(MotionThumb, {
    vertical: vertical,
    prefixCls: prefixCls,
    value: rawValue,
    containerRef: containerRef,
    motionName: "".concat(prefixCls, "-").concat(motionName),
    direction: direction,
    getValueIndex: function getValueIndex(val) {
      return segmentedOptions.findIndex(function (n) {
        return n.value === val;
      });
    },
    onMotionStart: function onMotionStart() {
      setThumbShow(true);
    },
    onMotionEnd: function onMotionEnd() {
      setThumbShow(false);
    }
  }), segmentedOptions.map(function (segmentedOption) {
    var _classNames3;
    return /*#__PURE__*/react.createElement(InternalSegmentedOption, (0,esm_extends/* default */.Z)({}, segmentedOption, {
      name: name,
      key: segmentedOption.value,
      prefixCls: prefixCls,
      className: classnames_default()(segmentedOption.className, "".concat(prefixCls, "-item"), (_classNames3 = {}, (0,defineProperty/* default */.Z)(_classNames3, "".concat(prefixCls, "-item-selected"), segmentedOption.value === rawValue && !thumbShow), (0,defineProperty/* default */.Z)(_classNames3, "".concat(prefixCls, "-item-focused"), isFocused && isKeyboard && segmentedOption.value === rawValue), _classNames3)),
      checked: segmentedOption.value === rawValue,
      onChange: handleChange,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      onKeyUp: handleKeyUp,
      onMouseDown: handleMouseDown,
      disabled: !!disabled || !!segmentedOption.disabled
    }));
  })));
});
if (false) {}
var TypedSegmented = Segmented;
/* harmony default export */ var rc_segmented_es = (TypedSegmented);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/segmented/style/index.js



// ============================== Mixins ==============================
function getItemDisabledStyle(cls, token) {
  return {
    [`${cls}, ${cls}:hover, ${cls}:focus`]: {
      color: token.colorTextDisabled,
      cursor: 'not-allowed'
    }
  };
}
function getItemSelectedStyle(token) {
  return {
    backgroundColor: token.itemSelectedBg,
    boxShadow: token.boxShadowTertiary
  };
}
const segmentedTextEllipsisCss = Object.assign({
  overflow: 'hidden'
}, textEllipsis);
// ============================== Styles ==============================
const genSegmentedStyle = token => {
  const {
    componentCls
  } = token;
  const labelHeight = token.calc(token.controlHeight).sub(token.calc(token.trackPadding).mul(2)).equal();
  const labelHeightLG = token.calc(token.controlHeightLG).sub(token.calc(token.trackPadding).mul(2)).equal();
  const labelHeightSM = token.calc(token.controlHeightSM).sub(token.calc(token.trackPadding).mul(2)).equal();
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), {
      display: 'inline-block',
      padding: token.trackPadding,
      color: token.itemColor,
      background: token.trackBg,
      borderRadius: token.borderRadius,
      transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`
    }), genFocusStyle(token)), {
      [`${componentCls}-group`]: {
        position: 'relative',
        display: 'flex',
        alignItems: 'stretch',
        justifyItems: 'flex-start',
        flexDirection: 'row',
        width: '100%'
      },
      // RTL styles
      [`&${componentCls}-rtl`]: {
        direction: 'rtl'
      },
      [`&${componentCls}-vertical`]: {
        [`${componentCls}-group`]: {
          flexDirection: 'column'
        },
        [`${componentCls}-thumb`]: {
          width: '100%',
          height: 0,
          padding: `0 ${(0,cssinjs_es/* unit */.bf)(token.paddingXXS)}`
        }
      },
      // block styles
      [`&${componentCls}-block`]: {
        display: 'flex'
      },
      [`&${componentCls}-block ${componentCls}-item`]: {
        flex: 1,
        minWidth: 0
      },
      // item styles
      [`${componentCls}-item`]: {
        position: 'relative',
        textAlign: 'center',
        cursor: 'pointer',
        transition: `color ${token.motionDurationMid} ${token.motionEaseInOut}`,
        borderRadius: token.borderRadiusSM,
        // Fix Safari render bug
        // https://github.com/ant-design/ant-design/issues/45250
        transform: 'translateZ(0)',
        '&-selected': Object.assign(Object.assign({}, getItemSelectedStyle(token)), {
          color: token.itemSelectedColor
        }),
        '&-focused': genFocusOutline(token),
        '&::after': {
          content: '""',
          position: 'absolute',
          zIndex: -1,
          width: '100%',
          height: '100%',
          top: 0,
          insetInlineStart: 0,
          borderRadius: 'inherit',
          opacity: 0,
          transition: `opacity ${token.motionDurationMid}`,
          // This is mandatory to make it not clickable or hoverable
          // Ref: https://github.com/ant-design/ant-design/issues/40888
          pointerEvents: 'none'
        },
        [`&:hover:not(${componentCls}-item-selected):not(${componentCls}-item-disabled)`]: {
          color: token.itemHoverColor,
          '&::after': {
            opacity: 1,
            backgroundColor: token.itemHoverBg
          }
        },
        [`&:active:not(${componentCls}-item-selected):not(${componentCls}-item-disabled)`]: {
          color: token.itemHoverColor,
          '&::after': {
            opacity: 1,
            backgroundColor: token.itemActiveBg
          }
        },
        '&-label': Object.assign({
          minHeight: labelHeight,
          lineHeight: (0,cssinjs_es/* unit */.bf)(labelHeight),
          padding: `0 ${(0,cssinjs_es/* unit */.bf)(token.segmentedPaddingHorizontal)}`
        }, segmentedTextEllipsisCss),
        // syntactic sugar to add `icon` for Segmented Item
        '&-icon + *': {
          marginInlineStart: token.calc(token.marginSM).div(2).equal()
        },
        '&-input': {
          position: 'absolute',
          insetBlockStart: 0,
          insetInlineStart: 0,
          width: 0,
          height: 0,
          opacity: 0,
          pointerEvents: 'none'
        }
      },
      // thumb styles
      [`${componentCls}-thumb`]: Object.assign(Object.assign({}, getItemSelectedStyle(token)), {
        position: 'absolute',
        insetBlockStart: 0,
        insetInlineStart: 0,
        width: 0,
        height: '100%',
        padding: `${(0,cssinjs_es/* unit */.bf)(token.paddingXXS)} 0`,
        borderRadius: token.borderRadiusSM,
        transition: `transform ${token.motionDurationSlow} ${token.motionEaseInOut}, height ${token.motionDurationSlow} ${token.motionEaseInOut}`,
        [`& ~ ${componentCls}-item:not(${componentCls}-item-selected):not(${componentCls}-item-disabled)::after`]: {
          backgroundColor: 'transparent'
        }
      }),
      // size styles
      [`&${componentCls}-lg`]: {
        borderRadius: token.borderRadiusLG,
        [`${componentCls}-item-label`]: {
          minHeight: labelHeightLG,
          lineHeight: (0,cssinjs_es/* unit */.bf)(labelHeightLG),
          padding: `0 ${(0,cssinjs_es/* unit */.bf)(token.segmentedPaddingHorizontal)}`,
          fontSize: token.fontSizeLG
        },
        [`${componentCls}-item, ${componentCls}-thumb`]: {
          borderRadius: token.borderRadius
        }
      },
      [`&${componentCls}-sm`]: {
        borderRadius: token.borderRadiusSM,
        [`${componentCls}-item-label`]: {
          minHeight: labelHeightSM,
          lineHeight: (0,cssinjs_es/* unit */.bf)(labelHeightSM),
          padding: `0 ${(0,cssinjs_es/* unit */.bf)(token.segmentedPaddingHorizontalSM)}`
        },
        [`${componentCls}-item, ${componentCls}-thumb`]: {
          borderRadius: token.borderRadiusXS
        }
      }
    }), getItemDisabledStyle(`&-disabled ${componentCls}-item`, token)), getItemDisabledStyle(`${componentCls}-item-disabled`, token)), {
      // transition effect when `appear-active`
      [`${componentCls}-thumb-motion-appear-active`]: {
        transition: `transform ${token.motionDurationSlow} ${token.motionEaseInOut}, width ${token.motionDurationSlow} ${token.motionEaseInOut}`,
        willChange: 'transform, width'
      },
      [`&${componentCls}-shape-round`]: {
        borderRadius: 9999,
        [`${componentCls}-item, ${componentCls}-thumb`]: {
          borderRadius: 9999
        }
      }
    })
  };
};
// ============================== Export ==============================
const segmented_style_prepareComponentToken = token => {
  const {
    colorTextLabel,
    colorText,
    colorFillSecondary,
    colorBgElevated,
    colorFill,
    lineWidthBold,
    colorBgLayout
  } = token;
  return {
    trackPadding: lineWidthBold,
    trackBg: colorBgLayout,
    itemColor: colorTextLabel,
    itemHoverColor: colorText,
    itemHoverBg: colorFillSecondary,
    itemSelectedBg: colorBgElevated,
    itemActiveBg: colorFill,
    itemSelectedColor: colorText
  };
};
/* harmony default export */ var segmented_style = (genStyleHooks('Segmented', token => {
  const {
    lineWidth,
    calc
  } = token;
  const segmentedToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    segmentedPaddingHorizontal: calc(token.controlPaddingHorizontal).sub(lineWidth).equal(),
    segmentedPaddingHorizontalSM: calc(token.controlPaddingHorizontalSM).sub(lineWidth).equal()
  });
  return genSegmentedStyle(segmentedToken);
}, segmented_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/segmented/index.js
"use client";

var segmented_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







function isSegmentedLabeledOptionWithIcon(option) {
  return typeof option === 'object' && !!(option === null || option === void 0 ? void 0 : option.icon);
}
const InternalSegmented = /*#__PURE__*/react.forwardRef((props, ref) => {
  const defaultName = (0,hooks_useId/* default */.Z)();
  const {
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      block,
      options = [],
      size: customSize = 'middle',
      style,
      vertical,
      shape = 'default',
      name = defaultName
    } = props,
    restProps = segmented_rest(props, ["prefixCls", "className", "rootClassName", "block", "options", "size", "style", "vertical", "shape", "name"]);
  const {
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle
  } = useComponentConfig('segmented');
  const prefixCls = getPrefixCls('segmented', customizePrefixCls);
  // Style
  const [wrapCSSVar, hashId, cssVarCls] = segmented_style(prefixCls);
  // ===================== Size =====================
  const mergedSize = hooks_useSize(customSize);
  // syntactic sugar to support `icon` for Segmented Item
  const extendedOptions = react.useMemo(() => options.map(option => {
    if (isSegmentedLabeledOptionWithIcon(option)) {
      const {
          icon,
          label
        } = option,
        restOption = segmented_rest(option, ["icon", "label"]);
      return Object.assign(Object.assign({}, restOption), {
        label: (/*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("span", {
          className: `${prefixCls}-item-icon`
        }, icon), label && /*#__PURE__*/react.createElement("span", null, label)))
      });
    }
    return option;
  }), [options, prefixCls]);
  const cls = classnames_default()(className, rootClassName, contextClassName, {
    [`${prefixCls}-block`]: block,
    [`${prefixCls}-sm`]: mergedSize === 'small',
    [`${prefixCls}-lg`]: mergedSize === 'large',
    [`${prefixCls}-vertical`]: vertical,
    [`${prefixCls}-shape-${shape}`]: shape === 'round'
  }, hashId, cssVarCls);
  const mergedStyle = Object.assign(Object.assign({}, contextStyle), style);
  return wrapCSSVar(/*#__PURE__*/react.createElement(rc_segmented_es, Object.assign({}, restProps, {
    name: name,
    className: cls,
    style: mergedStyle,
    options: extendedOptions,
    ref: ref,
    prefixCls: prefixCls,
    direction: direction,
    vertical: vertical
  })));
});
const segmented_Segmented = InternalSegmented;
if (false) {}
/* harmony default export */ var segmented = (segmented_Segmented);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/context.js

const PanelPickerContext = /*#__PURE__*/react.createContext({});
const PanelPresetsContext = /*#__PURE__*/react.createContext({});
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/components/ColorClear.js
"use client";



const ColorClear = ({
  prefixCls,
  value,
  onChange
}) => {
  const handleClick = () => {
    if (onChange && value && !value.cleared) {
      const hsba = value.toHsb();
      hsba.a = 0;
      const genColor = generateColor(hsba);
      genColor.cleared = true;
      onChange(genColor);
    }
  };
  return /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-clear`,
    onClick: handleClick
  });
};
/* harmony default export */ var components_ColorClear = (ColorClear);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/interface.js
const FORMAT_HEX = 'hex';
const FORMAT_RGB = 'rgb';
const FORMAT_HSB = 'hsb';
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/UpOutlined.js
// This icon file is generated automatically.
var UpOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z"
      }
    }]
  },
  "name": "up",
  "theme": "outlined"
};
/* harmony default export */ var asn_UpOutlined = (UpOutlined);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/UpOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UpOutlined_UpOutlined = function UpOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_UpOutlined
  }));
};

/**![up](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg5MC41IDc1NS4zTDUzNy45IDI2OS4yYy0xMi44LTE3LjYtMzktMTcuNi01MS43IDBMMTMzLjUgNzU1LjNBOCA4IDAgMDAxNDAgNzY4aDc1YzUuMSAwIDkuOS0yLjUgMTIuOS02LjZMNTEyIDM2OS44bDI4NC4xIDM5MS42YzMgNC4xIDcuOCA2LjYgMTIuOSA2LjZoNzVjNi41IDAgMTAuMy03LjQgNi41LTEyLjd6IiAvPjwvc3ZnPg==) */
var UpOutlined_RefIcon = /*#__PURE__*/react.forwardRef(UpOutlined_UpOutlined);
if (false) {}
/* harmony default export */ var icons_UpOutlined = (UpOutlined_RefIcon);
;// CONCATENATED MODULE: ./node_modules/@rc-component/mini-decimal/es/supportUtil.js
function supportBigInt() {
  return typeof BigInt === 'function';
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/mini-decimal/es/numberUtil.js

function isEmpty(value) {
  return !value && value !== 0 && !Number.isNaN(value) || !String(value).trim();
}

/**
 * Format string number to readable number
 */
function trimNumber(numStr) {
  var str = numStr.trim();
  var negative = str.startsWith('-');
  if (negative) {
    str = str.slice(1);
  }
  str = str
  // Remove decimal 0. `1.000` => `1.`, `1.100` => `1.1`
  .replace(/(\.\d*[^0])0*$/, '$1')
  // Remove useless decimal. `1.` => `1`
  .replace(/\.0*$/, '')
  // Remove integer 0. `0001` => `1`, 000.1' => `.1`
  .replace(/^0+/, '');
  if (str.startsWith('.')) {
    str = "0".concat(str);
  }
  var trimStr = str || '0';
  var splitNumber = trimStr.split('.');
  var integerStr = splitNumber[0] || '0';
  var decimalStr = splitNumber[1] || '0';
  if (integerStr === '0' && decimalStr === '0') {
    negative = false;
  }
  var negativeStr = negative ? '-' : '';
  return {
    negative: negative,
    negativeStr: negativeStr,
    trimStr: trimStr,
    integerStr: integerStr,
    decimalStr: decimalStr,
    fullStr: "".concat(negativeStr).concat(trimStr)
  };
}
function isE(number) {
  var str = String(number);
  return !Number.isNaN(Number(str)) && str.includes('e');
}

/**
 * [Legacy] Convert 1e-9 to 0.000000001.
 * This may lose some precision if user really want 1e-9.
 */
function getNumberPrecision(number) {
  var numStr = String(number);
  if (isE(number)) {
    var precision = Number(numStr.slice(numStr.indexOf('e-') + 2));
    var decimalMatch = numStr.match(/\.(\d+)/);
    if (decimalMatch !== null && decimalMatch !== void 0 && decimalMatch[1]) {
      precision += decimalMatch[1].length;
    }
    return precision;
  }
  return numStr.includes('.') && validateNumber(numStr) ? numStr.length - numStr.indexOf('.') - 1 : 0;
}

/**
 * Convert number (includes scientific notation) to -xxx.yyy format
 */
function num2str(number) {
  var numStr = String(number);
  if (isE(number)) {
    if (number > Number.MAX_SAFE_INTEGER) {
      return String(supportBigInt() ? BigInt(number).toString() : Number.MAX_SAFE_INTEGER);
    }
    if (number < Number.MIN_SAFE_INTEGER) {
      return String(supportBigInt() ? BigInt(number).toString() : Number.MIN_SAFE_INTEGER);
    }
    numStr = number.toFixed(getNumberPrecision(numStr));
  }
  return trimNumber(numStr).fullStr;
}
function validateNumber(num) {
  if (typeof num === 'number') {
    return !Number.isNaN(num);
  }

  // Empty
  if (!num) {
    return false;
  }
  return (
    // Normal type: 11.28
    /^\s*-?\d+(\.\d+)?\s*$/.test(num) ||
    // Pre-number: 1.
    /^\s*-?\d+\.\s*$/.test(num) ||
    // Post-number: .1
    /^\s*-?\.\d+\s*$/.test(num)
  );
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/mini-decimal/es/BigIntDecimal.js




var BigIntDecimal = /*#__PURE__*/function () {
  /** BigInt will convert `0009` to `9`. We need record the len of decimal */

  function BigIntDecimal(value) {
    (0,classCallCheck/* default */.Z)(this, BigIntDecimal);
    (0,defineProperty/* default */.Z)(this, "origin", '');
    (0,defineProperty/* default */.Z)(this, "negative", void 0);
    (0,defineProperty/* default */.Z)(this, "integer", void 0);
    (0,defineProperty/* default */.Z)(this, "decimal", void 0);
    (0,defineProperty/* default */.Z)(this, "decimalLen", void 0);
    (0,defineProperty/* default */.Z)(this, "empty", void 0);
    (0,defineProperty/* default */.Z)(this, "nan", void 0);
    if (isEmpty(value)) {
      this.empty = true;
      return;
    }
    this.origin = String(value);

    // Act like Number convert
    if (value === '-' || Number.isNaN(value)) {
      this.nan = true;
      return;
    }
    var mergedValue = value;

    // We need convert back to Number since it require `toFixed` to handle this
    if (isE(mergedValue)) {
      mergedValue = Number(mergedValue);
    }
    mergedValue = typeof mergedValue === 'string' ? mergedValue : num2str(mergedValue);
    if (validateNumber(mergedValue)) {
      var trimRet = trimNumber(mergedValue);
      this.negative = trimRet.negative;
      var numbers = trimRet.trimStr.split('.');
      this.integer = BigInt(numbers[0]);
      var decimalStr = numbers[1] || '0';
      this.decimal = BigInt(decimalStr);
      this.decimalLen = decimalStr.length;
    } else {
      this.nan = true;
    }
  }
  (0,createClass/* default */.Z)(BigIntDecimal, [{
    key: "getMark",
    value: function getMark() {
      return this.negative ? '-' : '';
    }
  }, {
    key: "getIntegerStr",
    value: function getIntegerStr() {
      return this.integer.toString();
    }

    /**
     * @private get decimal string
     */
  }, {
    key: "getDecimalStr",
    value: function getDecimalStr() {
      return this.decimal.toString().padStart(this.decimalLen, '0');
    }

    /**
     * @private Align BigIntDecimal with same decimal length. e.g. 12.3 + 5 = 1230000
     * This is used for add function only.
     */
  }, {
    key: "alignDecimal",
    value: function alignDecimal(decimalLength) {
      var str = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd(decimalLength, '0'));
      return BigInt(str);
    }
  }, {
    key: "negate",
    value: function negate() {
      var clone = new BigIntDecimal(this.toString());
      clone.negative = !clone.negative;
      return clone;
    }
  }, {
    key: "cal",
    value: function cal(offset, calculator, calDecimalLen) {
      var maxDecimalLength = Math.max(this.getDecimalStr().length, offset.getDecimalStr().length);
      var myAlignedDecimal = this.alignDecimal(maxDecimalLength);
      var offsetAlignedDecimal = offset.alignDecimal(maxDecimalLength);
      var valueStr = calculator(myAlignedDecimal, offsetAlignedDecimal).toString();
      var nextDecimalLength = calDecimalLen(maxDecimalLength);

      // We need fill string length back to `maxDecimalLength` to avoid parser failed
      var _trimNumber = trimNumber(valueStr),
        negativeStr = _trimNumber.negativeStr,
        trimStr = _trimNumber.trimStr;
      var hydrateValueStr = "".concat(negativeStr).concat(trimStr.padStart(nextDecimalLength + 1, '0'));
      return new BigIntDecimal("".concat(hydrateValueStr.slice(0, -nextDecimalLength), ".").concat(hydrateValueStr.slice(-nextDecimalLength)));
    }
  }, {
    key: "add",
    value: function add(value) {
      if (this.isInvalidate()) {
        return new BigIntDecimal(value);
      }
      var offset = new BigIntDecimal(value);
      if (offset.isInvalidate()) {
        return this;
      }
      return this.cal(offset, function (num1, num2) {
        return num1 + num2;
      }, function (len) {
        return len;
      });
    }
  }, {
    key: "multi",
    value: function multi(value) {
      var target = new BigIntDecimal(value);
      if (this.isInvalidate() || target.isInvalidate()) {
        return new BigIntDecimal(NaN);
      }
      return this.cal(target, function (num1, num2) {
        return num1 * num2;
      }, function (len) {
        return len * 2;
      });
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function isNaN() {
      return this.nan;
    }
  }, {
    key: "isInvalidate",
    value: function isInvalidate() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function equals(target) {
      return this.toString() === (target === null || target === void 0 ? void 0 : target.toString());
    }
  }, {
    key: "lessEquals",
    value: function lessEquals(target) {
      return this.add(target.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function toNumber() {
      if (this.isNaN()) {
        return NaN;
      }
      return Number(this.toString());
    }
  }, {
    key: "toString",
    value: function toString() {
      var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!safe) {
        return this.origin;
      }
      if (this.isInvalidate()) {
        return '';
      }
      return trimNumber("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr;
    }
  }]);
  return BigIntDecimal;
}();

;// CONCATENATED MODULE: ./node_modules/@rc-component/mini-decimal/es/NumberDecimal.js





/**
 * We can remove this when IE not support anymore
 */
var NumberDecimal = /*#__PURE__*/function () {
  function NumberDecimal(value) {
    (0,classCallCheck/* default */.Z)(this, NumberDecimal);
    (0,defineProperty/* default */.Z)(this, "origin", '');
    (0,defineProperty/* default */.Z)(this, "number", void 0);
    (0,defineProperty/* default */.Z)(this, "empty", void 0);
    if (isEmpty(value)) {
      this.empty = true;
      return;
    }
    this.origin = String(value);
    this.number = Number(value);
  }
  (0,createClass/* default */.Z)(NumberDecimal, [{
    key: "negate",
    value: function negate() {
      return new NumberDecimal(-this.toNumber());
    }
  }, {
    key: "add",
    value: function add(value) {
      if (this.isInvalidate()) {
        return new NumberDecimal(value);
      }
      var target = Number(value);
      if (Number.isNaN(target)) {
        return this;
      }
      var number = this.number + target;

      // [Legacy] Back to safe integer
      if (number > Number.MAX_SAFE_INTEGER) {
        return new NumberDecimal(Number.MAX_SAFE_INTEGER);
      }
      if (number < Number.MIN_SAFE_INTEGER) {
        return new NumberDecimal(Number.MIN_SAFE_INTEGER);
      }
      var maxPrecision = Math.max(getNumberPrecision(this.number), getNumberPrecision(target));
      return new NumberDecimal(number.toFixed(maxPrecision));
    }
  }, {
    key: "multi",
    value: function multi(value) {
      var target = Number(value);
      if (this.isInvalidate() || Number.isNaN(target)) {
        return new NumberDecimal(NaN);
      }
      var number = this.number * target;

      // [Legacy] Back to safe integer
      if (number > Number.MAX_SAFE_INTEGER) {
        return new NumberDecimal(Number.MAX_SAFE_INTEGER);
      }
      if (number < Number.MIN_SAFE_INTEGER) {
        return new NumberDecimal(Number.MIN_SAFE_INTEGER);
      }
      var maxPrecision = Math.max(getNumberPrecision(this.number), getNumberPrecision(target));
      return new NumberDecimal(number.toFixed(maxPrecision));
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function isNaN() {
      return Number.isNaN(this.number);
    }
  }, {
    key: "isInvalidate",
    value: function isInvalidate() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function equals(target) {
      return this.toNumber() === (target === null || target === void 0 ? void 0 : target.toNumber());
    }
  }, {
    key: "lessEquals",
    value: function lessEquals(target) {
      return this.add(target.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function toNumber() {
      return this.number;
    }
  }, {
    key: "toString",
    value: function toString() {
      var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!safe) {
        return this.origin;
      }
      if (this.isInvalidate()) {
        return '';
      }
      return num2str(this.number);
    }
  }]);
  return NumberDecimal;
}();

;// CONCATENATED MODULE: ./node_modules/@rc-component/mini-decimal/es/MiniDecimal.js
/* eslint-disable max-classes-per-file */






// Still support origin export

function getMiniDecimal(value) {
  // We use BigInt here.
  // Will fallback to Number if not support.
  if (supportBigInt()) {
    return new BigIntDecimal(value);
  }
  return new NumberDecimal(value);
}

/**
 * Align the logic of toFixed to around like 1.5 => 2.
 * If set `cutOnly`, will just remove the over decimal part.
 */
function toFixed(numStr, separatorStr, precision) {
  var cutOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (numStr === '') {
    return '';
  }
  var _trimNumber = trimNumber(numStr),
    negativeStr = _trimNumber.negativeStr,
    integerStr = _trimNumber.integerStr,
    decimalStr = _trimNumber.decimalStr;
  var precisionDecimalStr = "".concat(separatorStr).concat(decimalStr);
  var numberWithoutDecimal = "".concat(negativeStr).concat(integerStr);
  if (precision >= 0) {
    // We will get last + 1 number to check if need advanced number
    var advancedNum = Number(decimalStr[precision]);
    if (advancedNum >= 5 && !cutOnly) {
      var advancedDecimal = getMiniDecimal(numStr).add("".concat(negativeStr, "0.").concat('0'.repeat(precision)).concat(10 - advancedNum));
      return toFixed(advancedDecimal.toString(), separatorStr, precision, cutOnly);
    }
    if (precision === 0) {
      return numberWithoutDecimal;
    }
    return "".concat(numberWithoutDecimal).concat(separatorStr).concat(decimalStr.padEnd(precision, '0').slice(0, precision));
  }
  if (precisionDecimalStr === '.0') {
    return numberWithoutDecimal;
  }
  return "".concat(numberWithoutDecimal).concat(precisionDecimalStr);
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/mini-decimal/es/index.js




/* harmony default export */ var mini_decimal_es = (getMiniDecimal);
// EXTERNAL MODULE: ./node_modules/rc-input/es/index.js + 2 modules
var rc_input_es = __webpack_require__(65802);
;// CONCATENATED MODULE: ./node_modules/rc-util/es/proxyObject.js
/**
 * Proxy object if environment supported
 */
function proxyObject(obj, extendProps) {
  if (typeof Proxy !== 'undefined' && obj) {
    return new Proxy(obj, {
      get: function get(target, prop) {
        if (extendProps[prop]) {
          return extendProps[prop];
        }

        // Proxy origin property
        var originProp = target[prop];
        return typeof originProp === 'function' ? originProp.bind(target) : originProp;
      }
    });
  }
  return obj;
}
;// CONCATENATED MODULE: ./node_modules/rc-input-number/es/hooks/useCursor.js


/**
 * Keep input cursor in the correct position if possible.
 * Is this necessary since we have `formatter` which may mass the content?
 */
function useCursor(input, focused) {
  var selectionRef = (0,react.useRef)(null);
  function recordCursor() {
    // Record position
    try {
      var start = input.selectionStart,
        end = input.selectionEnd,
        value = input.value;
      var beforeTxt = value.substring(0, start);
      var afterTxt = value.substring(end);
      selectionRef.current = {
        start: start,
        end: end,
        value: value,
        beforeTxt: beforeTxt,
        afterTxt: afterTxt
      };
    } catch (e) {
      // Fix error in Chrome:
      // Failed to read the 'selectionStart' property from 'HTMLInputElement'
      // http://stackoverflow.com/q/21177489/3040605
    }
  }

  /**
   * Restore logic:
   *  1. back string same
   *  2. start string same
   */
  function restoreCursor() {
    if (input && selectionRef.current && focused) {
      try {
        var value = input.value;
        var _selectionRef$current = selectionRef.current,
          beforeTxt = _selectionRef$current.beforeTxt,
          afterTxt = _selectionRef$current.afterTxt,
          start = _selectionRef$current.start;
        var startPos = value.length;
        if (value.startsWith(beforeTxt)) {
          startPos = beforeTxt.length;
        } else if (value.endsWith(afterTxt)) {
          startPos = value.length - selectionRef.current.afterTxt.length;
        } else {
          var beforeLastChar = beforeTxt[start - 1];
          var newIndex = value.indexOf(beforeLastChar, start - 1);
          if (newIndex !== -1) {
            startPos = newIndex + 1;
          }
        }
        input.setSelectionRange(startPos, startPos);
      } catch (e) {
        (0,es_warning/* default */.ZP)(false, "Something warning of cursor restore. Please fire issue about this: ".concat(e.message));
      }
    }
  }
  return [recordCursor, restoreCursor];
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/isMobile.js
var isMobile = __webpack_require__(87122);
;// CONCATENATED MODULE: ./node_modules/rc-util/es/hooks/useMobile.js





/**
 * Hook to detect if the user is on a mobile device
 * Notice that this hook will only detect the device type in effect, so it will always be false in server side
 */
var useMobile = function useMobile() {
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    mobile = _useState2[0],
    setMobile = _useState2[1];
  (0,hooks_useLayoutEffect/* default */.Z)(function () {
    setMobile((0,isMobile/* default */.Z)());
  }, []);
  return mobile;
};
/* harmony default export */ var hooks_useMobile = (useMobile);
;// CONCATENATED MODULE: ./node_modules/rc-input-number/es/StepHandler.js


/* eslint-disable react/no-unknown-property */





/**
 * When click and hold on a button - the speed of auto changing the value.
 */
var STEP_INTERVAL = 200;

/**
 * When click and hold on a button - the delay before auto changing the value.
 */
var STEP_DELAY = 600;
function StepHandler(_ref) {
  var prefixCls = _ref.prefixCls,
    upNode = _ref.upNode,
    downNode = _ref.downNode,
    upDisabled = _ref.upDisabled,
    downDisabled = _ref.downDisabled,
    onStep = _ref.onStep;
  // ======================== Step ========================
  var stepTimeoutRef = react.useRef();
  var frameIds = react.useRef([]);
  var onStepRef = react.useRef();
  onStepRef.current = onStep;
  var onStopStep = function onStopStep() {
    clearTimeout(stepTimeoutRef.current);
  };

  // We will interval update step when hold mouse down
  var onStepMouseDown = function onStepMouseDown(e, up) {
    e.preventDefault();
    onStopStep();
    onStepRef.current(up);

    // Loop step for interval
    function loopStep() {
      onStepRef.current(up);
      stepTimeoutRef.current = setTimeout(loopStep, STEP_INTERVAL);
    }

    // First time press will wait some time to trigger loop step update
    stepTimeoutRef.current = setTimeout(loopStep, STEP_DELAY);
  };
  react.useEffect(function () {
    return function () {
      onStopStep();
      frameIds.current.forEach(function (id) {
        return raf/* default.cancel */.Z.cancel(id);
      });
    };
  }, []);

  // ======================= Render =======================
  var isMobile = hooks_useMobile();
  if (isMobile) {
    return null;
  }
  var handlerClassName = "".concat(prefixCls, "-handler");
  var upClassName = classnames_default()(handlerClassName, "".concat(handlerClassName, "-up"), (0,defineProperty/* default */.Z)({}, "".concat(handlerClassName, "-up-disabled"), upDisabled));
  var downClassName = classnames_default()(handlerClassName, "".concat(handlerClassName, "-down"), (0,defineProperty/* default */.Z)({}, "".concat(handlerClassName, "-down-disabled"), downDisabled));

  // fix: https://github.com/ant-design/ant-design/issues/43088
  // In Safari, When we fire onmousedown and onmouseup events in quick succession, 
  // there may be a problem that the onmouseup events are executed first, 
  // resulting in a disordered program execution.
  // So, we need to use requestAnimationFrame to ensure that the onmouseup event is executed after the onmousedown event.
  var safeOnStopStep = function safeOnStopStep() {
    return frameIds.current.push((0,raf/* default */.Z)(onStopStep));
  };
  var sharedHandlerProps = {
    unselectable: 'on',
    role: 'button',
    onMouseUp: safeOnStopStep,
    onMouseLeave: safeOnStopStep
  };
  return /*#__PURE__*/react.createElement("div", {
    className: "".concat(handlerClassName, "-wrap")
  }, /*#__PURE__*/react.createElement("span", (0,esm_extends/* default */.Z)({}, sharedHandlerProps, {
    onMouseDown: function onMouseDown(e) {
      onStepMouseDown(e, true);
    },
    "aria-label": "Increase Value",
    "aria-disabled": upDisabled,
    className: upClassName
  }), upNode || /*#__PURE__*/react.createElement("span", {
    unselectable: "on",
    className: "".concat(prefixCls, "-handler-up-inner")
  })), /*#__PURE__*/react.createElement("span", (0,esm_extends/* default */.Z)({}, sharedHandlerProps, {
    onMouseDown: function onMouseDown(e) {
      onStepMouseDown(e, false);
    },
    "aria-label": "Decrease Value",
    "aria-disabled": downDisabled,
    className: downClassName
  }), downNode || /*#__PURE__*/react.createElement("span", {
    unselectable: "on",
    className: "".concat(prefixCls, "-handler-down-inner")
  })));
}
;// CONCATENATED MODULE: ./node_modules/rc-input-number/es/utils/numberUtil.js

function getDecupleSteps(step) {
  var stepStr = typeof step === 'number' ? num2str(step) : trimNumber(step).fullStr;
  var hasPoint = stepStr.includes('.');
  if (!hasPoint) {
    return step + '0';
  }
  return trimNumber(stepStr.replace(/(\d)\.(\d)/g, '$1$2.')).fullStr;
}
// EXTERNAL MODULE: ./node_modules/rc-input/es/utils/commonUtils.js
var commonUtils = __webpack_require__(5894);
;// CONCATENATED MODULE: ./node_modules/rc-input-number/es/hooks/useFrame.js



/**
 * Always trigger latest once when call multiple time
 */
/* harmony default export */ var useFrame = (function () {
  var idRef = (0,react.useRef)(0);
  var cleanUp = function cleanUp() {
    raf/* default.cancel */.Z.cancel(idRef.current);
  };
  (0,react.useEffect)(function () {
    return cleanUp;
  }, []);
  return function (callback) {
    cleanUp();
    idRef.current = (0,raf/* default */.Z)(function () {
      callback();
    });
  };
});
;// CONCATENATED MODULE: ./node_modules/rc-input-number/es/InputNumber.js





var InputNumber_excluded = ["prefixCls", "className", "style", "min", "max", "step", "defaultValue", "value", "disabled", "readOnly", "upHandler", "downHandler", "keyboard", "changeOnWheel", "controls", "classNames", "stringMode", "parser", "formatter", "precision", "decimalSeparator", "onChange", "onInput", "onPressEnter", "onStep", "changeOnBlur", "domRef"],
  _excluded2 = ["disabled", "style", "prefixCls", "value", "prefix", "suffix", "addonBefore", "addonAfter", "className", "classNames"];












/**
 * We support `stringMode` which need handle correct type when user call in onChange
 * format max or min value
 * 1. if isInvalid return null
 * 2. if precision is undefined, return decimal
 * 3. format with precision
 *    I. if max > 0, round down with precision. Example: max= 3.5, precision=0  afterFormat: 3
 *    II. if max < 0, round up with precision. Example: max= -3.5, precision=0  afterFormat: -4
 *    III. if min > 0, round up with precision. Example: min= 3.5, precision=0  afterFormat: 4
 *    IV. if min < 0, round down with precision. Example: max= -3.5, precision=0  afterFormat: -3
 */
var getDecimalValue = function getDecimalValue(stringMode, decimalValue) {
  if (stringMode || decimalValue.isEmpty()) {
    return decimalValue.toString();
  }
  return decimalValue.toNumber();
};
var getDecimalIfValidate = function getDecimalIfValidate(value) {
  var decimal = mini_decimal_es(value);
  return decimal.isInvalidate() ? null : decimal;
};
var InternalInputNumber = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    className = props.className,
    style = props.style,
    min = props.min,
    max = props.max,
    _props$step = props.step,
    step = _props$step === void 0 ? 1 : _props$step,
    defaultValue = props.defaultValue,
    value = props.value,
    disabled = props.disabled,
    readOnly = props.readOnly,
    upHandler = props.upHandler,
    downHandler = props.downHandler,
    keyboard = props.keyboard,
    _props$changeOnWheel = props.changeOnWheel,
    changeOnWheel = _props$changeOnWheel === void 0 ? false : _props$changeOnWheel,
    _props$controls = props.controls,
    controls = _props$controls === void 0 ? true : _props$controls,
    classNames = props.classNames,
    stringMode = props.stringMode,
    parser = props.parser,
    formatter = props.formatter,
    precision = props.precision,
    decimalSeparator = props.decimalSeparator,
    onChange = props.onChange,
    onInput = props.onInput,
    onPressEnter = props.onPressEnter,
    onStep = props.onStep,
    _props$changeOnBlur = props.changeOnBlur,
    changeOnBlur = _props$changeOnBlur === void 0 ? true : _props$changeOnBlur,
    domRef = props.domRef,
    inputProps = (0,objectWithoutProperties/* default */.Z)(props, InputNumber_excluded);
  var inputClassName = "".concat(prefixCls, "-input");
  var inputRef = react.useRef(null);
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    focus = _React$useState2[0],
    setFocus = _React$useState2[1];
  var userTypingRef = react.useRef(false);
  var compositionRef = react.useRef(false);
  var shiftKeyRef = react.useRef(false);

  // ============================ Value =============================
  // Real value control
  var _React$useState3 = react.useState(function () {
      return mini_decimal_es(value !== null && value !== void 0 ? value : defaultValue);
    }),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    decimalValue = _React$useState4[0],
    setDecimalValue = _React$useState4[1];
  function setUncontrolledDecimalValue(newDecimal) {
    if (value === undefined) {
      setDecimalValue(newDecimal);
    }
  }

  // ====================== Parser & Formatter ======================
  /**
   * `precision` is used for formatter & onChange.
   * It will auto generate by `value` & `step`.
   * But it will not block user typing.
   *
   * Note: Auto generate `precision` is used for legacy logic.
   * We should remove this since we already support high precision with BigInt.
   *
   * @param number  Provide which number should calculate precision
   * @param userTyping  Change by user typing
   */
  var getPrecision = react.useCallback(function (numStr, userTyping) {
    if (userTyping) {
      return undefined;
    }
    if (precision >= 0) {
      return precision;
    }
    return Math.max(getNumberPrecision(numStr), getNumberPrecision(step));
  }, [precision, step]);

  // >>> Parser
  var mergedParser = react.useCallback(function (num) {
    var numStr = String(num);
    if (parser) {
      return parser(numStr);
    }
    var parsedStr = numStr;
    if (decimalSeparator) {
      parsedStr = parsedStr.replace(decimalSeparator, '.');
    }

    // [Legacy] We still support auto convert `$ 123,456` to `123456`
    return parsedStr.replace(/[^\w.-]+/g, '');
  }, [parser, decimalSeparator]);

  // >>> Formatter
  var inputValueRef = react.useRef('');
  var mergedFormatter = react.useCallback(function (number, userTyping) {
    if (formatter) {
      return formatter(number, {
        userTyping: userTyping,
        input: String(inputValueRef.current)
      });
    }
    var str = typeof number === 'number' ? num2str(number) : number;

    // User typing will not auto format with precision directly
    if (!userTyping) {
      var mergedPrecision = getPrecision(str, userTyping);
      if (validateNumber(str) && (decimalSeparator || mergedPrecision >= 0)) {
        // Separator
        var separatorStr = decimalSeparator || '.';
        str = toFixed(str, separatorStr, mergedPrecision);
      }
    }
    return str;
  }, [formatter, getPrecision, decimalSeparator]);

  // ========================== InputValue ==========================
  /**
   * Input text value control
   *
   * User can not update input content directly. It updates with follow rules by priority:
   *  1. controlled `value` changed
   *    * [SPECIAL] Typing like `1.` should not immediately convert to `1`
   *  2. User typing with format (not precision)
   *  3. Blur or Enter trigger revalidate
   */
  var _React$useState5 = react.useState(function () {
      var initValue = defaultValue !== null && defaultValue !== void 0 ? defaultValue : value;
      if (decimalValue.isInvalidate() && ['string', 'number'].includes((0,esm_typeof/* default */.Z)(initValue))) {
        return Number.isNaN(initValue) ? '' : initValue;
      }
      return mergedFormatter(decimalValue.toString(), false);
    }),
    _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
    inputValue = _React$useState6[0],
    setInternalInputValue = _React$useState6[1];
  inputValueRef.current = inputValue;

  // Should always be string
  function setInputValue(newValue, userTyping) {
    setInternalInputValue(mergedFormatter(
    // Invalidate number is sometime passed by external control, we should let it go
    // Otherwise is controlled by internal interactive logic which check by userTyping
    // You can ref 'show limited value when input is not focused' test for more info.
    newValue.isInvalidate() ? newValue.toString(false) : newValue.toString(!userTyping), userTyping));
  }

  // >>> Max & Min limit
  var maxDecimal = react.useMemo(function () {
    return getDecimalIfValidate(max);
  }, [max, precision]);
  var minDecimal = react.useMemo(function () {
    return getDecimalIfValidate(min);
  }, [min, precision]);
  var upDisabled = react.useMemo(function () {
    if (!maxDecimal || !decimalValue || decimalValue.isInvalidate()) {
      return false;
    }
    return maxDecimal.lessEquals(decimalValue);
  }, [maxDecimal, decimalValue]);
  var downDisabled = react.useMemo(function () {
    if (!minDecimal || !decimalValue || decimalValue.isInvalidate()) {
      return false;
    }
    return decimalValue.lessEquals(minDecimal);
  }, [minDecimal, decimalValue]);

  // Cursor controller
  var _useCursor = useCursor(inputRef.current, focus),
    _useCursor2 = (0,slicedToArray/* default */.Z)(_useCursor, 2),
    recordCursor = _useCursor2[0],
    restoreCursor = _useCursor2[1];

  // ============================= Data =============================
  /**
   * Find target value closet within range.
   * e.g. [11, 28]:
   *    3  => 11
   *    23 => 23
   *    99 => 28
   */
  var getRangeValue = function getRangeValue(target) {
    // target > max
    if (maxDecimal && !target.lessEquals(maxDecimal)) {
      return maxDecimal;
    }

    // target < min
    if (minDecimal && !minDecimal.lessEquals(target)) {
      return minDecimal;
    }
    return null;
  };

  /**
   * Check value is in [min, max] range
   */
  var isInRange = function isInRange(target) {
    return !getRangeValue(target);
  };

  /**
   * Trigger `onChange` if value validated and not equals of origin.
   * Return the value that re-align in range.
   */
  var triggerValueUpdate = function triggerValueUpdate(newValue, userTyping) {
    var updateValue = newValue;
    var isRangeValidate = isInRange(updateValue) || updateValue.isEmpty();

    // Skip align value when trigger value is empty.
    // We just trigger onChange(null)
    // This should not block user typing
    if (!updateValue.isEmpty() && !userTyping) {
      // Revert value in range if needed
      updateValue = getRangeValue(updateValue) || updateValue;
      isRangeValidate = true;
    }
    if (!readOnly && !disabled && isRangeValidate) {
      var numStr = updateValue.toString();
      var mergedPrecision = getPrecision(numStr, userTyping);
      if (mergedPrecision >= 0) {
        updateValue = mini_decimal_es(toFixed(numStr, '.', mergedPrecision));

        // When to fixed. The value may out of min & max range.
        // 4 in [0, 3.8] => 3.8 => 4 (toFixed)
        if (!isInRange(updateValue)) {
          updateValue = mini_decimal_es(toFixed(numStr, '.', mergedPrecision, true));
        }
      }

      // Trigger event
      if (!updateValue.equals(decimalValue)) {
        setUncontrolledDecimalValue(updateValue);
        onChange === null || onChange === void 0 || onChange(updateValue.isEmpty() ? null : getDecimalValue(stringMode, updateValue));

        // Reformat input if value is not controlled
        if (value === undefined) {
          setInputValue(updateValue, userTyping);
        }
      }
      return updateValue;
    }
    return decimalValue;
  };

  // ========================== User Input ==========================
  var onNextPromise = useFrame();

  // >>> Collect input value
  var collectInputValue = function collectInputValue(inputStr) {
    recordCursor();

    // Update inputValue in case input can not parse as number
    // Refresh ref value immediately since it may used by formatter
    inputValueRef.current = inputStr;
    setInternalInputValue(inputStr);

    // Parse number
    if (!compositionRef.current) {
      var finalValue = mergedParser(inputStr);
      var finalDecimal = mini_decimal_es(finalValue);
      if (!finalDecimal.isNaN()) {
        triggerValueUpdate(finalDecimal, true);
      }
    }

    // Trigger onInput later to let user customize value if they want to handle something after onChange
    onInput === null || onInput === void 0 || onInput(inputStr);

    // optimize for chinese input experience
    // https://github.com/ant-design/ant-design/issues/8196
    onNextPromise(function () {
      var nextInputStr = inputStr;
      if (!parser) {
        nextInputStr = inputStr.replace(/。/g, '.');
      }
      if (nextInputStr !== inputStr) {
        collectInputValue(nextInputStr);
      }
    });
  };

  // >>> Composition
  var onCompositionStart = function onCompositionStart() {
    compositionRef.current = true;
  };
  var onCompositionEnd = function onCompositionEnd() {
    compositionRef.current = false;
    collectInputValue(inputRef.current.value);
  };

  // >>> Input
  var onInternalInput = function onInternalInput(e) {
    collectInputValue(e.target.value);
  };

  // ============================= Step =============================
  var onInternalStep = function onInternalStep(up) {
    var _inputRef$current;
    // Ignore step since out of range
    if (up && upDisabled || !up && downDisabled) {
      return;
    }

    // Clear typing status since it may be caused by up & down key.
    // We should sync with input value.
    userTypingRef.current = false;
    var stepDecimal = mini_decimal_es(shiftKeyRef.current ? getDecupleSteps(step) : step);
    if (!up) {
      stepDecimal = stepDecimal.negate();
    }
    var target = (decimalValue || mini_decimal_es(0)).add(stepDecimal.toString());
    var updatedValue = triggerValueUpdate(target, false);
    onStep === null || onStep === void 0 || onStep(getDecimalValue(stringMode, updatedValue), {
      offset: shiftKeyRef.current ? getDecupleSteps(step) : step,
      type: up ? 'up' : 'down'
    });
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
  };

  // ============================ Flush =============================
  /**
   * Flush current input content to trigger value change & re-formatter input if needed.
   * This will always flush input value for update.
   * If it's invalidate, will fallback to last validate value.
   */
  var flushInputValue = function flushInputValue(userTyping) {
    var parsedValue = mini_decimal_es(mergedParser(inputValue));
    var formatValue;
    if (!parsedValue.isNaN()) {
      // Only validate value or empty value can be re-fill to inputValue
      // Reassign the formatValue within ranged of trigger control
      formatValue = triggerValueUpdate(parsedValue, userTyping);
    } else {
      formatValue = triggerValueUpdate(decimalValue, userTyping);
    }
    if (value !== undefined) {
      // Reset back with controlled value first
      setInputValue(decimalValue, false);
    } else if (!formatValue.isNaN()) {
      // Reset input back since no validate value
      setInputValue(formatValue, false);
    }
  };

  // Solve the issue of the event triggering sequence when entering numbers in chinese input (Safari)
  var onBeforeInput = function onBeforeInput() {
    userTypingRef.current = true;
  };
  var onKeyDown = function onKeyDown(event) {
    var key = event.key,
      shiftKey = event.shiftKey;
    userTypingRef.current = true;
    shiftKeyRef.current = shiftKey;
    if (key === 'Enter') {
      if (!compositionRef.current) {
        userTypingRef.current = false;
      }
      flushInputValue(false);
      onPressEnter === null || onPressEnter === void 0 || onPressEnter(event);
    }
    if (keyboard === false) {
      return;
    }

    // Do step
    if (!compositionRef.current && ['Up', 'ArrowUp', 'Down', 'ArrowDown'].includes(key)) {
      onInternalStep(key === 'Up' || key === 'ArrowUp');
      event.preventDefault();
    }
  };
  var onKeyUp = function onKeyUp() {
    userTypingRef.current = false;
    shiftKeyRef.current = false;
  };
  react.useEffect(function () {
    if (changeOnWheel && focus) {
      var onWheel = function onWheel(event) {
        // moving mouse wheel rises wheel event with deltaY < 0
        // scroll value grows from top to bottom, as screen Y coordinate
        onInternalStep(event.deltaY < 0);
        event.preventDefault();
      };
      var input = inputRef.current;
      if (input) {
        // React onWheel is passive and we can't preventDefault() in it.
        // That's why we should subscribe with DOM listener
        // https://stackoverflow.com/questions/63663025/react-onwheel-handler-cant-preventdefault-because-its-a-passive-event-listenev
        input.addEventListener('wheel', onWheel, {
          passive: false
        });
        return function () {
          return input.removeEventListener('wheel', onWheel);
        };
      }
    }
  });

  // >>> Focus & Blur
  var onBlur = function onBlur() {
    if (changeOnBlur) {
      flushInputValue(false);
    }
    setFocus(false);
    userTypingRef.current = false;
  };

  // ========================== Controlled ==========================
  // Input by precision & formatter
  (0,hooks_useLayoutEffect/* useLayoutUpdateEffect */.o)(function () {
    if (!decimalValue.isInvalidate()) {
      setInputValue(decimalValue, false);
    }
  }, [precision, formatter]);

  // Input by value
  (0,hooks_useLayoutEffect/* useLayoutUpdateEffect */.o)(function () {
    var newValue = mini_decimal_es(value);
    setDecimalValue(newValue);
    var currentParsedValue = mini_decimal_es(mergedParser(inputValue));

    // When user typing from `1.2` to `1.`, we should not convert to `1` immediately.
    // But let it go if user set `formatter`
    if (!newValue.equals(currentParsedValue) || !userTypingRef.current || formatter) {
      // Update value as effect
      setInputValue(newValue, userTypingRef.current);
    }
  }, [value]);

  // ============================ Cursor ============================
  (0,hooks_useLayoutEffect/* useLayoutUpdateEffect */.o)(function () {
    if (formatter) {
      restoreCursor();
    }
  }, [inputValue]);

  // ============================ Render ============================
  return /*#__PURE__*/react.createElement("div", {
    ref: domRef,
    className: classnames_default()(prefixCls, className, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-focused"), focus), "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-readonly"), readOnly), "".concat(prefixCls, "-not-a-number"), decimalValue.isNaN()), "".concat(prefixCls, "-out-of-range"), !decimalValue.isInvalidate() && !isInRange(decimalValue))),
    style: style,
    onFocus: function onFocus() {
      setFocus(true);
    },
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onCompositionStart: onCompositionStart,
    onCompositionEnd: onCompositionEnd,
    onBeforeInput: onBeforeInput
  }, controls && /*#__PURE__*/react.createElement(StepHandler, {
    prefixCls: prefixCls,
    upNode: upHandler,
    downNode: downHandler,
    upDisabled: upDisabled,
    downDisabled: downDisabled,
    onStep: onInternalStep
  }), /*#__PURE__*/react.createElement("div", {
    className: "".concat(inputClassName, "-wrap")
  }, /*#__PURE__*/react.createElement("input", (0,esm_extends/* default */.Z)({
    autoComplete: "off",
    role: "spinbutton",
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": decimalValue.isInvalidate() ? null : decimalValue.toString(),
    step: step
  }, inputProps, {
    ref: (0,es_ref/* composeRef */.sQ)(inputRef, ref),
    className: inputClassName,
    value: inputValue,
    onChange: onInternalInput,
    disabled: disabled,
    readOnly: readOnly
  }))));
});
var InputNumber = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var disabled = props.disabled,
    style = props.style,
    _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-input-number' : _props$prefixCls,
    value = props.value,
    prefix = props.prefix,
    suffix = props.suffix,
    addonBefore = props.addonBefore,
    addonAfter = props.addonAfter,
    className = props.className,
    classNames = props.classNames,
    rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded2);
  var holderRef = react.useRef(null);
  var inputNumberDomRef = react.useRef(null);
  var inputFocusRef = react.useRef(null);
  var focus = function focus(option) {
    if (inputFocusRef.current) {
      (0,commonUtils/* triggerFocus */.nH)(inputFocusRef.current, option);
    }
  };
  react.useImperativeHandle(ref, function () {
    return proxyObject(inputFocusRef.current, {
      focus: focus,
      nativeElement: holderRef.current.nativeElement || inputNumberDomRef.current
    });
  });
  return /*#__PURE__*/react.createElement(rc_input_es/* BaseInput */.Q, {
    className: className,
    triggerFocus: focus,
    prefixCls: prefixCls,
    value: value,
    disabled: disabled,
    style: style,
    prefix: prefix,
    suffix: suffix,
    addonAfter: addonAfter,
    addonBefore: addonBefore,
    classNames: classNames,
    components: {
      affixWrapper: 'div',
      groupWrapper: 'div',
      wrapper: 'div',
      groupAddon: 'div'
    },
    ref: holderRef
  }, /*#__PURE__*/react.createElement(InternalInputNumber, (0,esm_extends/* default */.Z)({
    prefixCls: prefixCls,
    disabled: disabled,
    ref: inputFocusRef,
    domRef: inputNumberDomRef,
    className: classNames === null || classNames === void 0 ? void 0 : classNames.input
  }, rest)));
});
if (false) {}
/* harmony default export */ var es_InputNumber = (InputNumber);
;// CONCATENATED MODULE: ./node_modules/rc-input-number/es/index.js

/* harmony default export */ var rc_input_number_es = (es_InputNumber);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/input/style/variants.js


const genHoverStyle = token => ({
  borderColor: token.hoverBorderColor,
  backgroundColor: token.hoverBg
});
const variants_genDisabledStyle = token => ({
  color: token.colorTextDisabled,
  backgroundColor: token.colorBgContainerDisabled,
  borderColor: token.colorBorder,
  boxShadow: 'none',
  cursor: 'not-allowed',
  opacity: 1,
  'input[disabled], textarea[disabled]': {
    cursor: 'not-allowed'
  },
  '&:hover:not([disabled])': Object.assign({}, genHoverStyle((0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    hoverBorderColor: token.colorBorder,
    hoverBg: token.colorBgContainerDisabled
  })))
});
/* ============== Outlined ============== */
const variants_genBaseOutlinedStyle = (token, options) => ({
  background: token.colorBgContainer,
  borderWidth: token.lineWidth,
  borderStyle: token.lineType,
  borderColor: options.borderColor,
  '&:hover': {
    borderColor: options.hoverBorderColor,
    backgroundColor: token.hoverBg
  },
  '&:focus, &:focus-within': {
    borderColor: options.activeBorderColor,
    boxShadow: options.activeShadow,
    outline: 0,
    backgroundColor: token.activeBg
  }
});
const variants_genOutlinedStatusStyle = (token, options) => ({
  [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: Object.assign(Object.assign({}, variants_genBaseOutlinedStyle(token, options)), {
    [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
      color: options.affixColor
    }
  }),
  [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
    borderColor: options.borderColor
  }
});
const variants_genOutlinedStyle = (token, extraStyles) => ({
  '&-outlined': Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, variants_genBaseOutlinedStyle(token, {
    borderColor: token.colorBorder,
    hoverBorderColor: token.hoverBorderColor,
    activeBorderColor: token.activeBorderColor,
    activeShadow: token.activeShadow
  })), {
    [`&${token.componentCls}-disabled, &[disabled]`]: Object.assign({}, variants_genDisabledStyle(token))
  }), variants_genOutlinedStatusStyle(token, {
    status: 'error',
    borderColor: token.colorError,
    hoverBorderColor: token.colorErrorBorderHover,
    activeBorderColor: token.colorError,
    activeShadow: token.errorActiveShadow,
    affixColor: token.colorError
  })), variants_genOutlinedStatusStyle(token, {
    status: 'warning',
    borderColor: token.colorWarning,
    hoverBorderColor: token.colorWarningBorderHover,
    activeBorderColor: token.colorWarning,
    activeShadow: token.warningActiveShadow,
    affixColor: token.colorWarning
  })), extraStyles)
});
const genOutlinedGroupStatusStyle = (token, options) => ({
  [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
    [`${token.componentCls}-group-addon`]: {
      borderColor: options.addonBorderColor,
      color: options.addonColor
    }
  }
});
const genOutlinedGroupStyle = token => ({
  '&-outlined': Object.assign(Object.assign(Object.assign({
    [`${token.componentCls}-group`]: {
      '&-addon': {
        background: token.addonBg,
        border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
      },
      '&-addon:first-child': {
        borderInlineEnd: 0
      },
      '&-addon:last-child': {
        borderInlineStart: 0
      }
    }
  }, genOutlinedGroupStatusStyle(token, {
    status: 'error',
    addonBorderColor: token.colorError,
    addonColor: token.colorErrorText
  })), genOutlinedGroupStatusStyle(token, {
    status: 'warning',
    addonBorderColor: token.colorWarning,
    addonColor: token.colorWarningText
  })), {
    [`&${token.componentCls}-group-wrapper-disabled`]: {
      [`${token.componentCls}-group-addon`]: Object.assign({}, variants_genDisabledStyle(token))
    }
  })
});
/* ============ Borderless ============ */
const style_variants_genBorderlessStyle = (token, extraStyles) => {
  const {
    componentCls
  } = token;
  return {
    '&-borderless': Object.assign({
      background: 'transparent',
      border: 'none',
      '&:focus, &:focus-within': {
        outline: 'none'
      },
      // >>>>> Disabled
      [`&${componentCls}-disabled, &[disabled]`]: {
        color: token.colorTextDisabled,
        cursor: 'not-allowed'
      },
      // >>>>> Status
      [`&${componentCls}-status-error`]: {
        '&, & input, & textarea': {
          color: token.colorError
        }
      },
      [`&${componentCls}-status-warning`]: {
        '&, & input, & textarea': {
          color: token.colorWarning
        }
      }
    }, extraStyles)
  };
};
/* ============== Filled ============== */
const variants_genBaseFilledStyle = (token, options) => {
  var _a;
  return {
    background: options.bg,
    borderWidth: token.lineWidth,
    borderStyle: token.lineType,
    borderColor: 'transparent',
    'input&, & input, textarea&, & textarea': {
      color: (_a = options === null || options === void 0 ? void 0 : options.inputColor) !== null && _a !== void 0 ? _a : 'unset'
    },
    '&:hover': {
      background: options.hoverBg
    },
    '&:focus, &:focus-within': {
      outline: 0,
      borderColor: options.activeBorderColor,
      backgroundColor: token.activeBg
    }
  };
};
const variants_genFilledStatusStyle = (token, options) => ({
  [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: Object.assign(Object.assign({}, variants_genBaseFilledStyle(token, options)), {
    [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
      color: options.affixColor
    }
  })
});
const variants_genFilledStyle = (token, extraStyles) => ({
  '&-filled': Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, variants_genBaseFilledStyle(token, {
    bg: token.colorFillTertiary,
    hoverBg: token.colorFillSecondary,
    activeBorderColor: token.activeBorderColor
  })), {
    [`&${token.componentCls}-disabled, &[disabled]`]: Object.assign({}, variants_genDisabledStyle(token))
  }), variants_genFilledStatusStyle(token, {
    status: 'error',
    bg: token.colorErrorBg,
    hoverBg: token.colorErrorBgHover,
    activeBorderColor: token.colorError,
    inputColor: token.colorErrorText,
    affixColor: token.colorError
  })), variants_genFilledStatusStyle(token, {
    status: 'warning',
    bg: token.colorWarningBg,
    hoverBg: token.colorWarningBgHover,
    activeBorderColor: token.colorWarning,
    inputColor: token.colorWarningText,
    affixColor: token.colorWarning
  })), extraStyles)
});
const genFilledGroupStatusStyle = (token, options) => ({
  [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
    [`${token.componentCls}-group-addon`]: {
      background: options.addonBg,
      color: options.addonColor
    }
  }
});
const genFilledGroupStyle = token => ({
  '&-filled': Object.assign(Object.assign(Object.assign({
    [`${token.componentCls}-group-addon`]: {
      background: token.colorFillTertiary,
      '&:last-child': {
        position: 'static'
      }
    }
  }, genFilledGroupStatusStyle(token, {
    status: 'error',
    addonBg: token.colorErrorBg,
    addonColor: token.colorErrorText
  })), genFilledGroupStatusStyle(token, {
    status: 'warning',
    addonBg: token.colorWarningBg,
    addonColor: token.colorWarningText
  })), {
    [`&${token.componentCls}-group-wrapper-disabled`]: {
      [`${token.componentCls}-group`]: {
        '&-addon': {
          background: token.colorFillTertiary,
          color: token.colorTextDisabled
        },
        '&-addon:first-child': {
          borderInlineStart: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
          borderTop: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
          borderBottom: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
        },
        '&-addon:last-child': {
          borderInlineEnd: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
          borderTop: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
          borderBottom: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
        }
      }
    }
  })
});
/* ============== Underlined ============== */
// https://github.com/ant-design/ant-design/issues/51379
const variants_genBaseUnderlinedStyle = (token, options) => ({
  background: token.colorBgContainer,
  borderWidth: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} 0`,
  borderStyle: `${token.lineType} none`,
  borderColor: `transparent transparent ${options.borderColor} transparent`,
  borderRadius: 0,
  '&:hover': {
    borderColor: `transparent transparent ${options.borderColor} transparent`,
    backgroundColor: token.hoverBg
  },
  '&:focus, &:focus-within': {
    borderColor: `transparent transparent ${options.activeBorderColor} transparent`,
    outline: 0,
    backgroundColor: token.activeBg
  }
});
const variants_genUnderlinedStatusStyle = (token, options) => ({
  [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: Object.assign(Object.assign({}, variants_genBaseUnderlinedStyle(token, options)), {
    [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
      color: options.affixColor
    }
  }),
  [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
    borderColor: `transparent transparent ${options.borderColor} transparent`
  }
});
const variants_genUnderlinedStyle = (token, extraStyles) => ({
  '&-underlined': Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, variants_genBaseUnderlinedStyle(token, {
    borderColor: token.colorBorder,
    hoverBorderColor: token.hoverBorderColor,
    activeBorderColor: token.activeBorderColor,
    activeShadow: token.activeShadow
  })), {
    // >>>>> Disabled
    [`&${token.componentCls}-disabled, &[disabled]`]: {
      color: token.colorTextDisabled,
      boxShadow: 'none',
      cursor: 'not-allowed',
      '&:hover': {
        borderColor: `transparent transparent ${token.colorBorder} transparent`
      }
    },
    'input[disabled], textarea[disabled]': {
      cursor: 'not-allowed'
    }
  }), variants_genUnderlinedStatusStyle(token, {
    status: 'error',
    borderColor: token.colorError,
    hoverBorderColor: token.colorErrorBorderHover,
    activeBorderColor: token.colorError,
    activeShadow: token.errorActiveShadow,
    affixColor: token.colorError
  })), variants_genUnderlinedStatusStyle(token, {
    status: 'warning',
    borderColor: token.colorWarning,
    hoverBorderColor: token.colorWarningBorderHover,
    activeBorderColor: token.colorWarning,
    activeShadow: token.warningActiveShadow,
    affixColor: token.colorWarning
  })), extraStyles)
});
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/input/style/index.js







const genPlaceholderStyle = color => ({
  // Firefox
  '&::-moz-placeholder': {
    opacity: 1
  },
  '&::placeholder': {
    color,
    userSelect: 'none' // https://github.com/ant-design/ant-design/pull/32639
  },
  '&:placeholder-shown': {
    textOverflow: 'ellipsis'
  }
});
const genActiveStyle = token => ({
  borderColor: token.activeBorderColor,
  boxShadow: token.activeShadow,
  outline: 0,
  backgroundColor: token.activeBg
});
const genInputLargeStyle = token => {
  const {
    paddingBlockLG,
    lineHeightLG,
    borderRadiusLG,
    paddingInlineLG
  } = token;
  return {
    padding: `${(0,cssinjs_es/* unit */.bf)(paddingBlockLG)} ${(0,cssinjs_es/* unit */.bf)(paddingInlineLG)}`,
    fontSize: token.inputFontSizeLG,
    lineHeight: lineHeightLG,
    borderRadius: borderRadiusLG
  };
};
const genInputSmallStyle = token => ({
  padding: `${(0,cssinjs_es/* unit */.bf)(token.paddingBlockSM)} ${(0,cssinjs_es/* unit */.bf)(token.paddingInlineSM)}`,
  fontSize: token.inputFontSizeSM,
  borderRadius: token.borderRadiusSM
});
const genBasicInputStyle = token => Object.assign(Object.assign({
  position: 'relative',
  display: 'inline-block',
  width: '100%',
  minWidth: 0,
  padding: `${(0,cssinjs_es/* unit */.bf)(token.paddingBlock)} ${(0,cssinjs_es/* unit */.bf)(token.paddingInline)}`,
  color: token.colorText,
  fontSize: token.inputFontSize,
  lineHeight: token.lineHeight,
  borderRadius: token.borderRadius,
  transition: `all ${token.motionDurationMid}`
}, genPlaceholderStyle(token.colorTextPlaceholder)), {
  // Size
  '&-lg': Object.assign({}, genInputLargeStyle(token)),
  '&-sm': Object.assign({}, genInputSmallStyle(token)),
  // RTL
  '&-rtl, &-textarea-rtl': {
    direction: 'rtl'
  }
});
const genInputGroupStyle = token => {
  const {
    componentCls,
    antCls
  } = token;
  return {
    position: 'relative',
    display: 'table',
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: 0,
    // Undo padding and float of grid classes
    "&[class*='col-']": {
      paddingInlineEnd: token.paddingXS,
      '&:last-child': {
        paddingInlineEnd: 0
      }
    },
    // Sizing options
    [`&-lg ${componentCls}, &-lg > ${componentCls}-group-addon`]: Object.assign({}, genInputLargeStyle(token)),
    [`&-sm ${componentCls}, &-sm > ${componentCls}-group-addon`]: Object.assign({}, genInputSmallStyle(token)),
    // Fix https://github.com/ant-design/ant-design/issues/5754
    [`&-lg ${antCls}-select-single ${antCls}-select-selector`]: {
      height: token.controlHeightLG
    },
    [`&-sm ${antCls}-select-single ${antCls}-select-selector`]: {
      height: token.controlHeightSM
    },
    [`> ${componentCls}`]: {
      display: 'table-cell',
      '&:not(:first-child):not(:last-child)': {
        borderRadius: 0
      }
    },
    [`${componentCls}-group`]: {
      '&-addon, &-wrap': {
        display: 'table-cell',
        width: 1,
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
        '&:not(:first-child):not(:last-child)': {
          borderRadius: 0
        }
      },
      '&-wrap > *': {
        display: 'block !important'
      },
      '&-addon': {
        position: 'relative',
        padding: `0 ${(0,cssinjs_es/* unit */.bf)(token.paddingInline)}`,
        color: token.colorText,
        fontWeight: 'normal',
        fontSize: token.inputFontSize,
        textAlign: 'center',
        borderRadius: token.borderRadius,
        transition: `all ${token.motionDurationSlow}`,
        lineHeight: 1,
        // Reset Select's style in addon
        [`${antCls}-select`]: {
          margin: `${(0,cssinjs_es/* unit */.bf)(token.calc(token.paddingBlock).add(1).mul(-1).equal())} ${(0,cssinjs_es/* unit */.bf)(token.calc(token.paddingInline).mul(-1).equal())}`,
          [`&${antCls}-select-single:not(${antCls}-select-customize-input):not(${antCls}-pagination-size-changer)`]: {
            [`${antCls}-select-selector`]: {
              backgroundColor: 'inherit',
              border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} transparent`,
              boxShadow: 'none'
            }
          }
        },
        // https://github.com/ant-design/ant-design/issues/31333
        [`${antCls}-cascader-picker`]: {
          margin: `-9px ${(0,cssinjs_es/* unit */.bf)(token.calc(token.paddingInline).mul(-1).equal())}`,
          backgroundColor: 'transparent',
          [`${antCls}-cascader-input`]: {
            textAlign: 'start',
            border: 0,
            boxShadow: 'none'
          }
        }
      }
    },
    [componentCls]: {
      width: '100%',
      marginBottom: 0,
      textAlign: 'inherit',
      '&:focus': {
        zIndex: 1,
        // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
        borderInlineEndWidth: 1
      },
      '&:hover': {
        zIndex: 1,
        borderInlineEndWidth: 1,
        [`${componentCls}-search-with-button &`]: {
          zIndex: 0
        }
      }
    },
    // Reset rounded corners
    [`> ${componentCls}:first-child, ${componentCls}-group-addon:first-child`]: {
      borderStartEndRadius: 0,
      borderEndEndRadius: 0,
      // Reset Select's style in addon
      [`${antCls}-select ${antCls}-select-selector`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${componentCls}-affix-wrapper`]: {
      [`&:not(:first-child) ${componentCls}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      },
      [`&:not(:last-child) ${componentCls}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${componentCls}:last-child, ${componentCls}-group-addon:last-child`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      // Reset Select's style in addon
      [`${antCls}-select ${antCls}-select-selector`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`${componentCls}-affix-wrapper`]: {
      '&:not(:last-child)': {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0,
        [`${componentCls}-search &`]: {
          borderStartStartRadius: token.borderRadius,
          borderEndStartRadius: token.borderRadius
        }
      },
      [`&:not(:first-child), ${componentCls}-search &:not(:first-child)`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&${componentCls}-group-compact`]: Object.assign(Object.assign({
      display: 'block'
    }, clearFix()), {
      [`${componentCls}-group-addon, ${componentCls}-group-wrap, > ${componentCls}`]: {
        '&:not(:first-child):not(:last-child)': {
          borderInlineEndWidth: token.lineWidth,
          '&:hover, &:focus': {
            zIndex: 1
          }
        }
      },
      '& > *': {
        display: 'inline-flex',
        float: 'none',
        verticalAlign: 'top',
        // https://github.com/ant-design/ant-design-pro/issues/139
        borderRadius: 0
      },
      [`
        & > ${componentCls}-affix-wrapper,
        & > ${componentCls}-number-affix-wrapper,
        & > ${antCls}-picker-range
      `]: {
        display: 'inline-flex'
      },
      '& > *:not(:last-child)': {
        marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
        borderInlineEndWidth: token.lineWidth
      },
      // Undo float for .ant-input-group .ant-input
      [componentCls]: {
        float: 'none'
      },
      // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
      [`& > ${antCls}-select > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete ${componentCls},
      & > ${antCls}-cascader-picker ${componentCls},
      & > ${componentCls}-group-wrapper ${componentCls}`]: {
        borderInlineEndWidth: token.lineWidth,
        borderRadius: 0,
        '&:hover, &:focus': {
          zIndex: 1
        }
      },
      [`& > ${antCls}-select-focused`]: {
        zIndex: 1
      },
      // update z-index for arrow icon
      [`& > ${antCls}-select > ${antCls}-select-arrow`]: {
        zIndex: 1 // https://github.com/ant-design/ant-design/issues/20371
      },
      [`& > *:first-child,
      & > ${antCls}-select:first-child > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete:first-child ${componentCls},
      & > ${antCls}-cascader-picker:first-child ${componentCls}`]: {
        borderStartStartRadius: token.borderRadius,
        borderEndStartRadius: token.borderRadius
      },
      [`& > *:last-child,
      & > ${antCls}-select:last-child > ${antCls}-select-selector,
      & > ${antCls}-cascader-picker:last-child ${componentCls},
      & > ${antCls}-cascader-picker-focused:last-child ${componentCls}`]: {
        borderInlineEndWidth: token.lineWidth,
        borderStartEndRadius: token.borderRadius,
        borderEndEndRadius: token.borderRadius
      },
      // https://github.com/ant-design/ant-design/issues/12493
      [`& > ${antCls}-select-auto-complete ${componentCls}`]: {
        verticalAlign: 'top'
      },
      [`${componentCls}-group-wrapper + ${componentCls}-group-wrapper`]: {
        marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
        [`${componentCls}-affix-wrapper`]: {
          borderRadius: 0
        }
      },
      [`${componentCls}-group-wrapper:not(:last-child)`]: {
        [`&${componentCls}-search > ${componentCls}-group`]: {
          [`& > ${componentCls}-group-addon > ${componentCls}-search-button`]: {
            borderRadius: 0
          },
          [`& > ${componentCls}`]: {
            borderStartStartRadius: token.borderRadius,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            borderEndStartRadius: token.borderRadius
          }
        }
      }
    })
  };
};
const genInputStyle = token => {
  const {
    componentCls,
    controlHeightSM,
    lineWidth,
    calc
  } = token;
  const FIXED_CHROME_COLOR_HEIGHT = 16;
  const colorSmallPadding = calc(controlHeightSM).sub(calc(lineWidth).mul(2)).sub(FIXED_CHROME_COLOR_HEIGHT).div(2).equal();
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), genBasicInputStyle(token)), variants_genOutlinedStyle(token)), variants_genFilledStyle(token)), style_variants_genBorderlessStyle(token)), variants_genUnderlinedStyle(token)), {
      '&[type="color"]': {
        height: token.controlHeight,
        [`&${componentCls}-lg`]: {
          height: token.controlHeightLG
        },
        [`&${componentCls}-sm`]: {
          height: controlHeightSM,
          paddingTop: colorSmallPadding,
          paddingBottom: colorSmallPadding
        }
      },
      '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
        appearance: 'none'
      }
    })
  };
};
const genAllowClearStyle = token => {
  const {
    componentCls
  } = token;
  return {
    // ========================= Input =========================
    [`${componentCls}-clear-icon`]: {
      margin: 0,
      padding: 0,
      lineHeight: 0,
      color: token.colorTextQuaternary,
      fontSize: token.fontSizeIcon,
      verticalAlign: -1,
      // https://github.com/ant-design/ant-design/pull/18151
      // https://codesandbox.io/s/wizardly-sun-u10br
      cursor: 'pointer',
      transition: `color ${token.motionDurationSlow}`,
      border: 'none',
      outline: 'none',
      backgroundColor: 'transparent',
      '&:hover': {
        color: token.colorIcon
      },
      '&:active': {
        color: token.colorText
      },
      '&-hidden': {
        visibility: 'hidden'
      },
      '&-has-suffix': {
        margin: `0 ${(0,cssinjs_es/* unit */.bf)(token.inputAffixPadding)}`
      }
    }
  };
};
const genAffixStyle = token => {
  const {
    componentCls,
    inputAffixPadding,
    colorTextDescription,
    motionDurationSlow,
    colorIcon,
    colorIconHover,
    iconCls
  } = token;
  const affixCls = `${componentCls}-affix-wrapper`;
  const affixClsDisabled = `${componentCls}-affix-wrapper-disabled`;
  return {
    [affixCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, genBasicInputStyle(token)), {
      display: 'inline-flex',
      [`&:not(${componentCls}-disabled):hover`]: {
        zIndex: 1,
        [`${componentCls}-search-with-button &`]: {
          zIndex: 0
        }
      },
      '&-focused, &:focus': {
        zIndex: 1
      },
      [`> input${componentCls}`]: {
        padding: 0
      },
      [`> input${componentCls}, > textarea${componentCls}`]: {
        fontSize: 'inherit',
        border: 'none',
        borderRadius: 0,
        outline: 'none',
        background: 'transparent',
        color: 'inherit',
        '&::-ms-reveal': {
          display: 'none'
        },
        '&:focus': {
          boxShadow: 'none !important'
        }
      },
      '&::before': {
        display: 'inline-block',
        width: 0,
        visibility: 'hidden',
        content: '"\\a0"'
      },
      [componentCls]: {
        '&-prefix, &-suffix': {
          display: 'flex',
          flex: 'none',
          alignItems: 'center',
          '> *:not(:last-child)': {
            marginInlineEnd: token.paddingXS
          }
        },
        '&-show-count-suffix': {
          color: colorTextDescription,
          direction: 'ltr'
        },
        '&-show-count-has-suffix': {
          marginInlineEnd: token.paddingXXS
        },
        '&-prefix': {
          marginInlineEnd: inputAffixPadding
        },
        '&-suffix': {
          marginInlineStart: inputAffixPadding
        }
      }
    }), genAllowClearStyle(token)), {
      // password
      [`${iconCls}${componentCls}-password-icon`]: {
        color: colorIcon,
        cursor: 'pointer',
        transition: `all ${motionDurationSlow}`,
        '&:hover': {
          color: colorIconHover
        }
      }
    }),
    // 覆盖 affix-wrapper borderRadius！
    [`${componentCls}-underlined`]: {
      borderRadius: 0
    },
    [affixClsDisabled]: {
      // password disabled
      [`${iconCls}${componentCls}-password-icon`]: {
        color: colorIcon,
        cursor: 'not-allowed',
        '&:hover': {
          color: colorIcon
        }
      }
    }
  };
};
const input_style_genGroupStyle = token => {
  const {
    componentCls,
    borderRadiusLG,
    borderRadiusSM
  } = token;
  return {
    [`${componentCls}-group`]: Object.assign(Object.assign(Object.assign({}, resetComponent(token)), genInputGroupStyle(token)), {
      '&-rtl': {
        direction: 'rtl'
      },
      '&-wrapper': Object.assign(Object.assign(Object.assign({
        display: 'inline-block',
        width: '100%',
        textAlign: 'start',
        verticalAlign: 'top',
        '&-rtl': {
          direction: 'rtl'
        },
        // Size
        '&-lg': {
          [`${componentCls}-group-addon`]: {
            borderRadius: borderRadiusLG,
            fontSize: token.inputFontSizeLG
          }
        },
        '&-sm': {
          [`${componentCls}-group-addon`]: {
            borderRadius: borderRadiusSM
          }
        }
      }, genOutlinedGroupStyle(token)), genFilledGroupStyle(token)), {
        // '&-disabled': {
        //   [`${componentCls}-group-addon`]: {
        //     ...genDisabledStyle(token),
        //   },
        // },
        // Fix the issue of using icons in Space Compact mode
        // https://github.com/ant-design/ant-design/issues/42122
        [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
          [`${componentCls}, ${componentCls}-group-addon`]: {
            borderRadius: 0
          }
        },
        [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
          [`${componentCls}, ${componentCls}-group-addon`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
          [`${componentCls}, ${componentCls}-group-addon`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        },
        // Fix the issue of input use show-count param in space compact mode
        // https://github.com/ant-design/ant-design/issues/46872
        [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
          [`${componentCls}-affix-wrapper`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        // Fix the issue of input use `addonAfter` param in space compact mode
        // https://github.com/ant-design/ant-design/issues/52483
        [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-item`]: {
          [`${componentCls}-affix-wrapper`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        }
      })
    })
  };
};
const genSearchInputStyle = token => {
  const {
    componentCls,
    antCls
  } = token;
  const searchPrefixCls = `${componentCls}-search`;
  return {
    [searchPrefixCls]: {
      [componentCls]: {
        '&:hover, &:focus': {
          [`+ ${componentCls}-group-addon ${searchPrefixCls}-button:not(${antCls}-btn-color-primary):not(${antCls}-btn-variant-text)`]: {
            borderInlineStartColor: token.colorPrimaryHover
          }
        }
      },
      [`${componentCls}-affix-wrapper`]: {
        height: token.controlHeight,
        borderRadius: 0
      },
      // fix slight height diff in Firefox:
      // https://ant.design/components/auto-complete-cn/#auto-complete-demo-certain-category
      [`${componentCls}-lg`]: {
        lineHeight: token.calc(token.lineHeightLG).sub(0.0002).equal()
      },
      [`> ${componentCls}-group`]: {
        [`> ${componentCls}-group-addon:last-child`]: {
          insetInlineStart: -1,
          padding: 0,
          border: 0,
          [`${searchPrefixCls}-button`]: {
            // Fix https://github.com/ant-design/ant-design/issues/47150
            marginInlineEnd: -1,
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            boxShadow: 'none'
          },
          [`${searchPrefixCls}-button:not(${antCls}-btn-color-primary)`]: {
            color: token.colorTextDescription,
            '&:hover': {
              color: token.colorPrimaryHover
            },
            '&:active': {
              color: token.colorPrimaryActive
            },
            [`&${antCls}-btn-loading::before`]: {
              inset: 0
            }
          }
        }
      },
      [`${searchPrefixCls}-button`]: {
        height: token.controlHeight,
        '&:hover, &:focus': {
          zIndex: 1
        }
      },
      '&-large': {
        [`${componentCls}-affix-wrapper, ${searchPrefixCls}-button`]: {
          height: token.controlHeightLG
        }
      },
      '&-small': {
        [`${componentCls}-affix-wrapper, ${searchPrefixCls}-button`]: {
          height: token.controlHeightSM
        }
      },
      '&-rtl': {
        direction: 'rtl'
      },
      // ===================== Compact Item Customized Styles =====================
      [`&${componentCls}-compact-item`]: {
        [`&:not(${componentCls}-compact-last-item)`]: {
          [`${componentCls}-group-addon`]: {
            [`${componentCls}-search-button`]: {
              marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
              borderRadius: 0
            }
          }
        },
        [`&:not(${componentCls}-compact-first-item)`]: {
          [`${componentCls},${componentCls}-affix-wrapper`]: {
            borderRadius: 0
          }
        },
        [`> ${componentCls}-group-addon ${componentCls}-search-button,
        > ${componentCls},
        ${componentCls}-affix-wrapper`]: {
          '&:hover, &:focus, &:active': {
            zIndex: 2
          }
        },
        [`> ${componentCls}-affix-wrapper-focused`]: {
          zIndex: 2
        }
      }
    }
  };
};
// ============================== Range ===============================
const genRangeStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}-out-of-range`]: {
      [`&, & input, & textarea, ${componentCls}-show-count-suffix, ${componentCls}-data-count`]: {
        color: token.colorError
      }
    }
  };
};
// ============================== Export ==============================
const useSharedStyle = genStyleHooks(['Input', 'Shared'], token => {
  const inputToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, initInputToken(token));
  return [genInputStyle(inputToken), genAffixStyle(inputToken)];
}, token_initComponentToken, {
  resetFont: false
});
/* harmony default export */ var input_style = (genStyleHooks(['Input', 'Component'], token => {
  const inputToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, initInputToken(token));
  return [input_style_genGroupStyle(inputToken), genSearchInputStyle(inputToken), genRangeStyle(inputToken),
  // =====================================================
  // ==             Space Compact                       ==
  // =====================================================
  genCompactItemStyle(inputToken)];
}, token_initComponentToken, {
  resetFont: false
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/input-number/style/token.js


const input_number_style_token_prepareComponentToken = token => {
  var _a;
  const handleVisible = (_a = token.handleVisible) !== null && _a !== void 0 ? _a : 'auto';
  const handleWidth = token.controlHeightSM - token.lineWidth * 2;
  return Object.assign(Object.assign({}, token_initComponentToken(token)), {
    controlWidth: 90,
    handleWidth,
    handleFontSize: token.fontSize / 2,
    handleVisible,
    handleActiveBg: token.colorFillAlter,
    handleBg: token.colorBgContainer,
    filledHandleBg: new fast_color_es/* FastColor */.t(token.colorFillSecondary).onBackground(token.colorBgContainer).toHexString(),
    handleHoverColor: token.colorPrimary,
    handleBorderColor: token.colorBorder,
    handleOpacity: handleVisible === true ? 1 : 0,
    handleVisibleWidth: handleVisible === true ? handleWidth : 0
  });
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/input-number/style/index.js







const genRadiusStyle = ({
  componentCls,
  borderRadiusSM,
  borderRadiusLG
}, size) => {
  const borderRadius = size === 'lg' ? borderRadiusLG : borderRadiusSM;
  return {
    [`&-${size}`]: {
      [`${componentCls}-handler-wrap`]: {
        borderStartEndRadius: borderRadius,
        borderEndEndRadius: borderRadius
      },
      [`${componentCls}-handler-up`]: {
        borderStartEndRadius: borderRadius
      },
      [`${componentCls}-handler-down`]: {
        borderEndEndRadius: borderRadius
      }
    }
  };
};
const genInputNumberStyles = token => {
  const {
    componentCls,
    lineWidth,
    lineType,
    borderRadius,
    inputFontSizeSM,
    inputFontSizeLG,
    controlHeightLG,
    controlHeightSM,
    colorError,
    paddingInlineSM,
    paddingBlockSM,
    paddingBlockLG,
    paddingInlineLG,
    colorIcon,
    motionDurationMid,
    handleHoverColor,
    handleOpacity,
    paddingInline,
    paddingBlock,
    handleBg,
    handleActiveBg,
    colorTextDisabled,
    borderRadiusSM,
    borderRadiusLG,
    controlWidth,
    handleBorderColor,
    filledHandleBg,
    lineHeightLG,
    calc
  } = token;
  return [{
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), genBasicInputStyle(token)), {
      display: 'inline-block',
      width: controlWidth,
      margin: 0,
      padding: 0,
      borderRadius
    }), variants_genOutlinedStyle(token, {
      [`${componentCls}-handler-wrap`]: {
        background: handleBg,
        [`${componentCls}-handler-down`]: {
          borderBlockStart: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${handleBorderColor}`
        }
      }
    })), variants_genFilledStyle(token, {
      [`${componentCls}-handler-wrap`]: {
        background: filledHandleBg,
        [`${componentCls}-handler-down`]: {
          borderBlockStart: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${handleBorderColor}`
        }
      },
      '&:focus-within': {
        [`${componentCls}-handler-wrap`]: {
          background: handleBg
        }
      }
    })), variants_genUnderlinedStyle(token, {
      [`${componentCls}-handler-wrap`]: {
        background: handleBg,
        [`${componentCls}-handler-down`]: {
          borderBlockStart: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${handleBorderColor}`
        }
      }
    })), style_variants_genBorderlessStyle(token)), {
      '&-rtl': {
        direction: 'rtl',
        [`${componentCls}-input`]: {
          direction: 'rtl'
        }
      },
      '&-lg': {
        padding: 0,
        fontSize: inputFontSizeLG,
        lineHeight: lineHeightLG,
        borderRadius: borderRadiusLG,
        [`input${componentCls}-input`]: {
          height: calc(controlHeightLG).sub(calc(lineWidth).mul(2)).equal(),
          padding: `${(0,cssinjs_es/* unit */.bf)(paddingBlockLG)} ${(0,cssinjs_es/* unit */.bf)(paddingInlineLG)}`
        }
      },
      '&-sm': {
        padding: 0,
        fontSize: inputFontSizeSM,
        borderRadius: borderRadiusSM,
        [`input${componentCls}-input`]: {
          height: calc(controlHeightSM).sub(calc(lineWidth).mul(2)).equal(),
          padding: `${(0,cssinjs_es/* unit */.bf)(paddingBlockSM)} ${(0,cssinjs_es/* unit */.bf)(paddingInlineSM)}`
        }
      },
      // ===================== Out Of Range =====================
      '&-out-of-range': {
        [`${componentCls}-input-wrap`]: {
          input: {
            color: colorError
          }
        }
      },
      // Style for input-group: input with label, with button or dropdown...
      '&-group': Object.assign(Object.assign(Object.assign({}, resetComponent(token)), genInputGroupStyle(token)), {
        '&-wrapper': Object.assign(Object.assign(Object.assign({
          display: 'inline-block',
          textAlign: 'start',
          verticalAlign: 'top',
          [`${componentCls}-affix-wrapper`]: {
            width: '100%'
          },
          // Size
          '&-lg': {
            [`${componentCls}-group-addon`]: {
              borderRadius: borderRadiusLG,
              fontSize: token.fontSizeLG
            }
          },
          '&-sm': {
            [`${componentCls}-group-addon`]: {
              borderRadius: borderRadiusSM
            }
          }
        }, genOutlinedGroupStyle(token)), genFilledGroupStyle(token)), {
          // Fix the issue of using icons in Space Compact mode
          // https://github.com/ant-design/ant-design/issues/45764
          [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
            [`${componentCls}, ${componentCls}-group-addon`]: {
              borderRadius: 0
            }
          },
          [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
            [`${componentCls}, ${componentCls}-group-addon`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
            [`${componentCls}, ${componentCls}-group-addon`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          }
        })
      }),
      [`&-disabled ${componentCls}-input`]: {
        cursor: 'not-allowed'
      },
      [componentCls]: {
        '&-input': Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), {
          width: '100%',
          padding: `${(0,cssinjs_es/* unit */.bf)(paddingBlock)} ${(0,cssinjs_es/* unit */.bf)(paddingInline)}`,
          textAlign: 'start',
          backgroundColor: 'transparent',
          border: 0,
          borderRadius,
          outline: 0,
          transition: `all ${motionDurationMid} linear`,
          appearance: 'textfield',
          fontSize: 'inherit'
        }), genPlaceholderStyle(token.colorTextPlaceholder)), {
          '&[type="number"]::-webkit-inner-spin-button, &[type="number"]::-webkit-outer-spin-button': {
            margin: 0,
            appearance: 'none'
          }
        })
      },
      [`&:hover ${componentCls}-handler-wrap, &-focused ${componentCls}-handler-wrap`]: {
        width: token.handleWidth,
        opacity: 1
      }
    })
  },
  // Handler
  {
    [componentCls]: Object.assign(Object.assign(Object.assign({
      [`${componentCls}-handler-wrap`]: {
        position: 'absolute',
        insetBlockStart: 0,
        insetInlineEnd: 0,
        width: token.handleVisibleWidth,
        opacity: handleOpacity,
        height: '100%',
        borderStartStartRadius: 0,
        borderStartEndRadius: borderRadius,
        borderEndEndRadius: borderRadius,
        borderEndStartRadius: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        transition: `all ${motionDurationMid}`,
        overflow: 'hidden',
        // Fix input number inside Menu makes icon too large
        // We arise the selector priority by nest selector here
        // https://github.com/ant-design/ant-design/issues/14367
        [`${componentCls}-handler`]: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flex: 'auto',
          height: '40%',
          [`
              ${componentCls}-handler-up-inner,
              ${componentCls}-handler-down-inner
            `]: {
            marginInlineEnd: 0,
            fontSize: token.handleFontSize
          }
        }
      },
      [`${componentCls}-handler`]: {
        height: '50%',
        overflow: 'hidden',
        color: colorIcon,
        fontWeight: 'bold',
        lineHeight: 0,
        textAlign: 'center',
        cursor: 'pointer',
        borderInlineStart: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${handleBorderColor}`,
        transition: `all ${motionDurationMid} linear`,
        '&:active': {
          background: handleActiveBg
        },
        // Hover
        '&:hover': {
          height: `60%`,
          [`
              ${componentCls}-handler-up-inner,
              ${componentCls}-handler-down-inner
            `]: {
            color: handleHoverColor
          }
        },
        '&-up-inner, &-down-inner': Object.assign(Object.assign({}, resetIcon()), {
          color: colorIcon,
          transition: `all ${motionDurationMid} linear`,
          userSelect: 'none'
        })
      },
      [`${componentCls}-handler-up`]: {
        borderStartEndRadius: borderRadius
      },
      [`${componentCls}-handler-down`]: {
        borderEndEndRadius: borderRadius
      }
    }, genRadiusStyle(token, 'lg')), genRadiusStyle(token, 'sm')), {
      // Disabled
      '&-disabled, &-readonly': {
        [`${componentCls}-handler-wrap`]: {
          display: 'none'
        },
        [`${componentCls}-input`]: {
          color: 'inherit'
        }
      },
      [`
          ${componentCls}-handler-up-disabled,
          ${componentCls}-handler-down-disabled
        `]: {
        cursor: 'not-allowed'
      },
      [`
          ${componentCls}-handler-up-disabled:hover &-handler-up-inner,
          ${componentCls}-handler-down-disabled:hover &-handler-down-inner
        `]: {
        color: colorTextDisabled
      }
    })
  }];
};
const genAffixWrapperStyles = token => {
  const {
    componentCls,
    paddingBlock,
    paddingInline,
    inputAffixPadding,
    controlWidth,
    borderRadiusLG,
    borderRadiusSM,
    paddingInlineLG,
    paddingInlineSM,
    paddingBlockLG,
    paddingBlockSM,
    motionDurationMid
  } = token;
  return {
    [`${componentCls}-affix-wrapper`]: Object.assign(Object.assign({
      [`input${componentCls}-input`]: {
        padding: `${(0,cssinjs_es/* unit */.bf)(paddingBlock)} 0`
      }
    }, genBasicInputStyle(token)), {
      // or number handler will cover form status
      position: 'relative',
      display: 'inline-flex',
      alignItems: 'center',
      width: controlWidth,
      padding: 0,
      paddingInlineStart: paddingInline,
      '&-lg': {
        borderRadius: borderRadiusLG,
        paddingInlineStart: paddingInlineLG,
        [`input${componentCls}-input`]: {
          padding: `${(0,cssinjs_es/* unit */.bf)(paddingBlockLG)} 0`
        }
      },
      '&-sm': {
        borderRadius: borderRadiusSM,
        paddingInlineStart: paddingInlineSM,
        [`input${componentCls}-input`]: {
          padding: `${(0,cssinjs_es/* unit */.bf)(paddingBlockSM)} 0`
        }
      },
      [`&:not(${componentCls}-disabled):hover`]: {
        zIndex: 1
      },
      '&-focused, &:focus': {
        zIndex: 1
      },
      [`&-disabled > ${componentCls}-disabled`]: {
        background: 'transparent'
      },
      [`> div${componentCls}`]: {
        width: '100%',
        border: 'none',
        outline: 'none',
        [`&${componentCls}-focused`]: {
          boxShadow: 'none !important'
        }
      },
      '&::before': {
        display: 'inline-block',
        width: 0,
        visibility: 'hidden',
        content: '"\\a0"'
      },
      [`${componentCls}-handler-wrap`]: {
        zIndex: 2
      },
      [componentCls]: {
        position: 'static',
        color: 'inherit',
        '&-prefix, &-suffix': {
          display: 'flex',
          flex: 'none',
          alignItems: 'center',
          pointerEvents: 'none'
        },
        '&-prefix': {
          marginInlineEnd: inputAffixPadding
        },
        '&-suffix': {
          insetBlockStart: 0,
          insetInlineEnd: 0,
          height: '100%',
          marginInlineEnd: paddingInline,
          marginInlineStart: inputAffixPadding,
          transition: `margin ${motionDurationMid}`
        }
      },
      [`&:hover ${componentCls}-handler-wrap, &-focused ${componentCls}-handler-wrap`]: {
        width: token.handleWidth,
        opacity: 1
      },
      [`&:not(${componentCls}-affix-wrapper-without-controls):hover ${componentCls}-suffix`]: {
        marginInlineEnd: token.calc(token.handleWidth).add(paddingInline).equal()
      }
    }),
    // 覆盖 affix-wrapper borderRadius！
    [`${componentCls}-underlined`]: {
      borderRadius: 0
    }
  };
};
/* harmony default export */ var input_number_style = (genStyleHooks('InputNumber', token => {
  const inputNumberToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, initInputToken(token));
  return [genInputNumberStyles(inputNumberToken), genAffixWrapperStyles(inputNumberToken),
  // =====================================================
  // ==             Space Compact                       ==
  // =====================================================
  genCompactItemStyle(inputNumberToken)];
}, input_number_style_token_prepareComponentToken, {
  unitless: {
    handleOpacity: true
  },
  resetFont: false
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/input-number/index.js
"use client";

var input_number_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
















const input_number_InputNumber = /*#__PURE__*/react.forwardRef((props, ref) => {
  if (false) {}
  const {
    getPrefixCls,
    direction
  } = react.useContext(ConfigContext);
  const inputRef = react.useRef(null);
  react.useImperativeHandle(ref, () => inputRef.current);
  const {
      className,
      rootClassName,
      size: customizeSize,
      disabled: customDisabled,
      prefixCls: customizePrefixCls,
      addonBefore,
      addonAfter,
      prefix,
      suffix,
      bordered,
      readOnly,
      status: customStatus,
      controls,
      variant: customVariant
    } = props,
    others = input_number_rest(props, ["className", "rootClassName", "size", "disabled", "prefixCls", "addonBefore", "addonAfter", "prefix", "suffix", "bordered", "readOnly", "status", "controls", "variant"]);
  const prefixCls = getPrefixCls('input-number', customizePrefixCls);
  // Style
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = input_number_style(prefixCls, rootCls);
  const {
    compactSize,
    compactItemClassnames
  } = useCompactItemContext(prefixCls, direction);
  let upIcon = /*#__PURE__*/react.createElement(icons_UpOutlined, {
    className: `${prefixCls}-handler-up-inner`
  });
  let downIcon = /*#__PURE__*/react.createElement(DownOutlined/* default */.Z, {
    className: `${prefixCls}-handler-down-inner`
  });
  const controlsTemp = typeof controls === 'boolean' ? controls : undefined;
  if (typeof controls === 'object') {
    upIcon = typeof controls.upIcon === 'undefined' ? upIcon : (/*#__PURE__*/react.createElement("span", {
      className: `${prefixCls}-handler-up-inner`
    }, controls.upIcon));
    downIcon = typeof controls.downIcon === 'undefined' ? downIcon : (/*#__PURE__*/react.createElement("span", {
      className: `${prefixCls}-handler-down-inner`
    }, controls.downIcon));
  }
  const {
    hasFeedback,
    status: contextStatus,
    isFormItemInput,
    feedbackIcon
  } = react.useContext(FormItemInputContext);
  const mergedStatus = getMergedStatus(contextStatus, customStatus);
  const mergedSize = hooks_useSize(ctx => {
    var _a;
    return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
  });
  // ===================== Disabled =====================
  const disabled = react.useContext(config_provider_DisabledContext);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  const [variant, enableVariantCls] = useVariants('inputNumber', customVariant, bordered);
  const suffixNode = hasFeedback && /*#__PURE__*/react.createElement(react.Fragment, null, feedbackIcon);
  const inputNumberClass = classnames_default()({
    [`${prefixCls}-lg`]: mergedSize === 'large',
    [`${prefixCls}-sm`]: mergedSize === 'small',
    [`${prefixCls}-rtl`]: direction === 'rtl',
    [`${prefixCls}-in-form-item`]: isFormItemInput
  }, hashId);
  const wrapperClassName = `${prefixCls}-group`;
  const element = /*#__PURE__*/react.createElement(rc_input_number_es, Object.assign({
    ref: inputRef,
    disabled: mergedDisabled,
    className: classnames_default()(cssVarCls, rootCls, className, rootClassName, compactItemClassnames),
    upHandler: upIcon,
    downHandler: downIcon,
    prefixCls: prefixCls,
    readOnly: readOnly,
    controls: controlsTemp,
    prefix: prefix,
    suffix: suffixNode || suffix,
    addonBefore: addonBefore && (/*#__PURE__*/react.createElement(_util_ContextIsolator, {
      form: true,
      space: true
    }, addonBefore)),
    addonAfter: addonAfter && (/*#__PURE__*/react.createElement(_util_ContextIsolator, {
      form: true,
      space: true
    }, addonAfter)),
    classNames: {
      input: inputNumberClass,
      variant: classnames_default()({
        [`${prefixCls}-${variant}`]: enableVariantCls
      }, getStatusClassNames(prefixCls, mergedStatus, hasFeedback)),
      affixWrapper: classnames_default()({
        [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
        [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
        [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl',
        [`${prefixCls}-affix-wrapper-without-controls`]: controls === false || mergedDisabled || readOnly
      }, hashId),
      wrapper: classnames_default()({
        [`${wrapperClassName}-rtl`]: direction === 'rtl'
      }, hashId),
      groupWrapper: classnames_default()({
        [`${prefixCls}-group-wrapper-sm`]: mergedSize === 'small',
        [`${prefixCls}-group-wrapper-lg`]: mergedSize === 'large',
        [`${prefixCls}-group-wrapper-rtl`]: direction === 'rtl',
        [`${prefixCls}-group-wrapper-${variant}`]: enableVariantCls
      }, getStatusClassNames(`${prefixCls}-group-wrapper`, mergedStatus, hasFeedback), hashId)
    }
  }, others));
  return wrapCSSVar(element);
});
const TypedInputNumber = input_number_InputNumber;
/** @private Internal Component. Do not use in your production. */
const PureInputNumber = props => (/*#__PURE__*/react.createElement(config_provider, {
  theme: {
    components: {
      InputNumber: {
        handleVisible: true
      }
    }
  }
}, /*#__PURE__*/react.createElement(input_number_InputNumber, Object.assign({}, props))));
if (false) {}
TypedInputNumber._InternalPanelDoNotUseOrYouWillBeFired = PureInputNumber;
/* harmony default export */ var input_number = (TypedInputNumber);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/components/ColorSteppers.js
"use client";




const ColorSteppers = ({
  prefixCls,
  min = 0,
  max = 100,
  value,
  onChange,
  className,
  formatter
}) => {
  const colorSteppersPrefixCls = `${prefixCls}-steppers`;
  const [internalValue, setInternalValue] = (0,react.useState)(0);
  const stepValue = !Number.isNaN(value) ? value : internalValue;
  return /*#__PURE__*/react.createElement(input_number, {
    className: classnames_default()(colorSteppersPrefixCls, className),
    min: min,
    max: max,
    value: stepValue,
    formatter: formatter,
    size: "small",
    onChange: step => {
      setInternalValue(step || 0);
      onChange === null || onChange === void 0 ? void 0 : onChange(step);
    }
  });
};
/* harmony default export */ var components_ColorSteppers = (ColorSteppers);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/components/ColorAlphaInput.js
"use client";




const ColorAlphaInput = ({
  prefixCls,
  value,
  onChange
}) => {
  const colorAlphaInputPrefixCls = `${prefixCls}-alpha-input`;
  const [internalValue, setInternalValue] = (0,react.useState)(() => generateColor(value || '#000'));
  const alphaValue = value || internalValue;
  const handleAlphaChange = step => {
    const hsba = alphaValue.toHsb();
    hsba.a = (step || 0) / 100;
    const genColor = generateColor(hsba);
    setInternalValue(genColor);
    onChange === null || onChange === void 0 ? void 0 : onChange(genColor);
  };
  return /*#__PURE__*/react.createElement(components_ColorSteppers, {
    value: getColorAlpha(alphaValue),
    prefixCls: prefixCls,
    formatter: step => `${step}%`,
    className: colorAlphaInputPrefixCls,
    onChange: handleAlphaChange
  });
};
/* harmony default export */ var components_ColorAlphaInput = (ColorAlphaInput);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/getAllowClear.js
"use client";



const getAllowClear = allowClear => {
  let mergedAllowClear;
  if (typeof allowClear === 'object' && (allowClear === null || allowClear === void 0 ? void 0 : allowClear.clearIcon)) {
    mergedAllowClear = allowClear;
  } else if (allowClear) {
    mergedAllowClear = {
      clearIcon: /*#__PURE__*/react.createElement(CloseCircleFilled/* default */.Z, null)
    };
  }
  return mergedAllowClear;
};
/* harmony default export */ var _util_getAllowClear = (getAllowClear);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/input/hooks/useRemovePasswordTimeout.js

function useRemovePasswordTimeout(inputRef, triggerOnMount) {
  const removePasswordTimeoutRef = (0,react.useRef)([]);
  const removePasswordTimeout = () => {
    removePasswordTimeoutRef.current.push(setTimeout(() => {
      var _a, _b, _c, _d;
      if (((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) && ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.input.getAttribute('type')) === 'password' && ((_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.input.hasAttribute('value'))) {
        (_d = inputRef.current) === null || _d === void 0 ? void 0 : _d.input.removeAttribute('value');
      }
    }));
  };
  (0,react.useEffect)(() => {
    if (triggerOnMount) {
      removePasswordTimeout();
    }
    return () => removePasswordTimeoutRef.current.forEach(timer => {
      if (timer) {
        clearTimeout(timer);
      }
    });
  }, []);
  return removePasswordTimeout;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/input/utils.js
function hasPrefixSuffix(props) {
  return !!(props.prefix || props.suffix || props.allowClear || props.showCount);
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/input/Input.js
"use client";

var Input_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




















const Input_Input = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      bordered = true,
      status: customStatus,
      size: customSize,
      disabled: customDisabled,
      onBlur,
      onFocus,
      suffix,
      allowClear,
      addonAfter,
      addonBefore,
      className,
      style,
      styles,
      rootClassName,
      onChange,
      classNames,
      variant: customVariant
    } = props,
    rest = Input_rest(props, ["prefixCls", "bordered", "status", "size", "disabled", "onBlur", "onFocus", "suffix", "allowClear", "addonAfter", "addonBefore", "className", "style", "styles", "rootClassName", "onChange", "classNames", "variant"]);
  if (false) {}
  const {
    getPrefixCls,
    direction,
    allowClear: contextAllowClear,
    autoComplete: contextAutoComplete,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig('input');
  const prefixCls = getPrefixCls('input', customizePrefixCls);
  const inputRef = (0,react.useRef)(null);
  // Style
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapSharedCSSVar, hashId, cssVarCls] = useSharedStyle(prefixCls, rootClassName);
  const [wrapCSSVar] = input_style(prefixCls, rootCls);
  // ===================== Compact Item =====================
  const {
    compactSize,
    compactItemClassnames
  } = useCompactItemContext(prefixCls, direction);
  // ===================== Size =====================
  const mergedSize = hooks_useSize(ctx => {
    var _a;
    return (_a = customSize !== null && customSize !== void 0 ? customSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
  });
  // ===================== Disabled =====================
  const disabled = react.useContext(config_provider_DisabledContext);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  // ===================== Status =====================
  const {
    status: contextStatus,
    hasFeedback,
    feedbackIcon
  } = (0,react.useContext)(FormItemInputContext);
  const mergedStatus = getMergedStatus(contextStatus, customStatus);
  // ===================== Focus warning =====================
  const inputHasPrefixSuffix = hasPrefixSuffix(props) || !!hasFeedback;
  const prevHasPrefixSuffix = (0,react.useRef)(inputHasPrefixSuffix);
  /* eslint-disable react-hooks/rules-of-hooks */
  if (false) {}
  /* eslint-enable */
  // ===================== Remove Password value =====================
  const removePasswordTimeout = useRemovePasswordTimeout(inputRef, true);
  const handleBlur = e => {
    removePasswordTimeout();
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
  };
  const handleFocus = e => {
    removePasswordTimeout();
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
  };
  const handleChange = e => {
    removePasswordTimeout();
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  };
  const suffixNode = (hasFeedback || suffix) && (/*#__PURE__*/react.createElement(react.Fragment, null, suffix, hasFeedback && feedbackIcon));
  const mergedAllowClear = _util_getAllowClear(allowClear !== null && allowClear !== void 0 ? allowClear : contextAllowClear);
  const [variant, enableVariantCls] = useVariants('input', customVariant, bordered);
  return wrapSharedCSSVar(wrapCSSVar(/*#__PURE__*/react.createElement(rc_input_es/* default */.Z, Object.assign({
    ref: (0,es_ref/* composeRef */.sQ)(ref, inputRef),
    prefixCls: prefixCls,
    autoComplete: contextAutoComplete
  }, rest, {
    disabled: mergedDisabled,
    onBlur: handleBlur,
    onFocus: handleFocus,
    style: Object.assign(Object.assign({}, contextStyle), style),
    styles: Object.assign(Object.assign({}, contextStyles), styles),
    suffix: suffixNode,
    allowClear: mergedAllowClear,
    className: classnames_default()(className, rootClassName, cssVarCls, rootCls, compactItemClassnames, contextClassName),
    onChange: handleChange,
    addonBefore: addonBefore && (/*#__PURE__*/react.createElement(_util_ContextIsolator, {
      form: true,
      space: true
    }, addonBefore)),
    addonAfter: addonAfter && (/*#__PURE__*/react.createElement(_util_ContextIsolator, {
      form: true,
      space: true
    }, addonAfter)),
    classNames: Object.assign(Object.assign(Object.assign({}, classNames), contextClassNames), {
      input: classnames_default()({
        [`${prefixCls}-sm`]: mergedSize === 'small',
        [`${prefixCls}-lg`]: mergedSize === 'large',
        [`${prefixCls}-rtl`]: direction === 'rtl'
      }, classNames === null || classNames === void 0 ? void 0 : classNames.input, contextClassNames.input, hashId),
      variant: classnames_default()({
        [`${prefixCls}-${variant}`]: enableVariantCls
      }, getStatusClassNames(prefixCls, mergedStatus)),
      affixWrapper: classnames_default()({
        [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
        [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
        [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl'
      }, hashId),
      wrapper: classnames_default()({
        [`${prefixCls}-group-rtl`]: direction === 'rtl'
      }, hashId),
      groupWrapper: classnames_default()({
        [`${prefixCls}-group-wrapper-sm`]: mergedSize === 'small',
        [`${prefixCls}-group-wrapper-lg`]: mergedSize === 'large',
        [`${prefixCls}-group-wrapper-rtl`]: direction === 'rtl',
        [`${prefixCls}-group-wrapper-${variant}`]: enableVariantCls
      }, getStatusClassNames(`${prefixCls}-group-wrapper`, mergedStatus, hasFeedback), hashId)
    })
  }))));
});
if (false) {}
/* harmony default export */ var input_Input = (Input_Input);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/components/ColorHexInput.js
"use client";





const hexReg = /(^#[\da-f]{6}$)|(^#[\da-f]{8}$)/i;
const isHexString = hex => hexReg.test(`#${hex}`);
const ColorHexInput = ({
  prefixCls,
  value,
  onChange
}) => {
  const colorHexInputPrefixCls = `${prefixCls}-hex-input`;
  const [hexValue, setHexValue] = (0,react.useState)(() => value ? toHexFormat(value.toHexString()) : undefined);
  // Update step value
  (0,react.useEffect)(() => {
    if (value) {
      setHexValue(toHexFormat(value.toHexString()));
    }
  }, [value]);
  const handleHexChange = e => {
    const originValue = e.target.value;
    setHexValue(toHexFormat(originValue));
    if (isHexString(toHexFormat(originValue, true))) {
      onChange === null || onChange === void 0 ? void 0 : onChange(generateColor(originValue));
    }
  };
  return /*#__PURE__*/react.createElement(input_Input, {
    className: colorHexInputPrefixCls,
    value: hexValue,
    prefix: "#",
    onChange: handleHexChange,
    size: "small"
  });
};
/* harmony default export */ var components_ColorHexInput = (ColorHexInput);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/components/ColorHsbInput.js
"use client";




const ColorHsbInput = ({
  prefixCls,
  value,
  onChange
}) => {
  const colorHsbInputPrefixCls = `${prefixCls}-hsb-input`;
  const [internalValue, setInternalValue] = (0,react.useState)(() => generateColor(value || '#000'));
  const hsbValue = value || internalValue;
  const handleHsbChange = (step, type) => {
    const hsb = hsbValue.toHsb();
    hsb[type] = type === 'h' ? step : (step || 0) / 100;
    const genColor = generateColor(hsb);
    setInternalValue(genColor);
    onChange === null || onChange === void 0 ? void 0 : onChange(genColor);
  };
  return /*#__PURE__*/react.createElement("div", {
    className: colorHsbInputPrefixCls
  }, /*#__PURE__*/react.createElement(components_ColorSteppers, {
    max: 360,
    min: 0,
    value: Number(hsbValue.toHsb().h),
    prefixCls: prefixCls,
    className: colorHsbInputPrefixCls,
    formatter: step => getRoundNumber(step || 0).toString(),
    onChange: step => handleHsbChange(Number(step), 'h')
  }), /*#__PURE__*/react.createElement(components_ColorSteppers, {
    max: 100,
    min: 0,
    value: Number(hsbValue.toHsb().s) * 100,
    prefixCls: prefixCls,
    className: colorHsbInputPrefixCls,
    formatter: step => `${getRoundNumber(step || 0)}%`,
    onChange: step => handleHsbChange(Number(step), 's')
  }), /*#__PURE__*/react.createElement(components_ColorSteppers, {
    max: 100,
    min: 0,
    value: Number(hsbValue.toHsb().b) * 100,
    prefixCls: prefixCls,
    className: colorHsbInputPrefixCls,
    formatter: step => `${getRoundNumber(step || 0)}%`,
    onChange: step => handleHsbChange(Number(step), 'b')
  }));
};
/* harmony default export */ var components_ColorHsbInput = (ColorHsbInput);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/components/ColorRgbInput.js
"use client";




const ColorRgbInput = ({
  prefixCls,
  value,
  onChange
}) => {
  const colorRgbInputPrefixCls = `${prefixCls}-rgb-input`;
  const [internalValue, setInternalValue] = (0,react.useState)(() => generateColor(value || '#000'));
  const rgbValue = value || internalValue;
  const handleRgbChange = (step, type) => {
    const rgb = rgbValue.toRgb();
    rgb[type] = step || 0;
    const genColor = generateColor(rgb);
    setInternalValue(genColor);
    onChange === null || onChange === void 0 ? void 0 : onChange(genColor);
  };
  return /*#__PURE__*/react.createElement("div", {
    className: colorRgbInputPrefixCls
  }, /*#__PURE__*/react.createElement(components_ColorSteppers, {
    max: 255,
    min: 0,
    value: Number(rgbValue.toRgb().r),
    prefixCls: prefixCls,
    className: colorRgbInputPrefixCls,
    onChange: step => handleRgbChange(Number(step), 'r')
  }), /*#__PURE__*/react.createElement(components_ColorSteppers, {
    max: 255,
    min: 0,
    value: Number(rgbValue.toRgb().g),
    prefixCls: prefixCls,
    className: colorRgbInputPrefixCls,
    onChange: step => handleRgbChange(Number(step), 'g')
  }), /*#__PURE__*/react.createElement(components_ColorSteppers, {
    max: 255,
    min: 0,
    value: Number(rgbValue.toRgb().b),
    prefixCls: prefixCls,
    className: colorRgbInputPrefixCls,
    onChange: step => handleRgbChange(Number(step), 'b')
  }));
};
/* harmony default export */ var components_ColorRgbInput = (ColorRgbInput);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/components/ColorInput.js
"use client";









const selectOptions = [FORMAT_HEX, FORMAT_HSB, FORMAT_RGB].map(format => ({
  value: format,
  label: format.toUpperCase()
}));
const ColorInput = props => {
  const {
    prefixCls,
    format,
    value,
    disabledAlpha,
    onFormatChange,
    onChange,
    disabledFormat
  } = props;
  const [colorFormat, setColorFormat] = (0,useMergedState/* default */.Z)(FORMAT_HEX, {
    value: format,
    onChange: onFormatChange
  });
  const colorInputPrefixCls = `${prefixCls}-input`;
  const handleFormatChange = newFormat => {
    setColorFormat(newFormat);
  };
  const steppersNode = (0,react.useMemo)(() => {
    const inputProps = {
      value,
      prefixCls,
      onChange
    };
    switch (colorFormat) {
      case FORMAT_HSB:
        return /*#__PURE__*/react.createElement(components_ColorHsbInput, Object.assign({}, inputProps));
      case FORMAT_RGB:
        return /*#__PURE__*/react.createElement(components_ColorRgbInput, Object.assign({}, inputProps));
      // case FORMAT_HEX:
      default:
        return /*#__PURE__*/react.createElement(components_ColorHexInput, Object.assign({}, inputProps));
    }
  }, [colorFormat, prefixCls, value, onChange]);
  return /*#__PURE__*/react.createElement("div", {
    className: `${colorInputPrefixCls}-container`
  }, !disabledFormat && (/*#__PURE__*/react.createElement(es_select, {
    value: colorFormat,
    variant: "borderless",
    getPopupContainer: current => current,
    popupMatchSelectWidth: 68,
    placement: "bottomRight",
    onChange: handleFormatChange,
    className: `${prefixCls}-format-select`,
    size: "small",
    options: selectOptions
  })), /*#__PURE__*/react.createElement("div", {
    className: colorInputPrefixCls
  }, steppersNode), !disabledAlpha && (/*#__PURE__*/react.createElement(components_ColorAlphaInput, {
    prefixCls: prefixCls,
    value: value,
    onChange: onChange
  })));
};
/* harmony default export */ var components_ColorInput = (ColorInput);
;// CONCATENATED MODULE: ./node_modules/rc-slider/es/util.js
function util_getOffset(value, min, max) {
  return (value - min) / (max - min);
}
function getDirectionStyle(direction, value, min, max) {
  var offset = util_getOffset(value, min, max);
  var positionStyle = {};
  switch (direction) {
    case 'rtl':
      positionStyle.right = "".concat(offset * 100, "%");
      positionStyle.transform = 'translateX(50%)';
      break;
    case 'btt':
      positionStyle.bottom = "".concat(offset * 100, "%");
      positionStyle.transform = 'translateY(50%)';
      break;
    case 'ttb':
      positionStyle.top = "".concat(offset * 100, "%");
      positionStyle.transform = 'translateY(-50%)';
      break;
    default:
      positionStyle.left = "".concat(offset * 100, "%");
      positionStyle.transform = 'translateX(-50%)';
      break;
  }
  return positionStyle;
}

/** Return index value if is list or return value directly */
function getIndex(value, index) {
  return Array.isArray(value) ? value[index] : value;
}
;// CONCATENATED MODULE: ./node_modules/rc-slider/es/context.js

var SliderContext = /*#__PURE__*/react.createContext({
  min: 0,
  max: 0,
  direction: 'ltr',
  step: 1,
  includedStart: 0,
  includedEnd: 0,
  tabIndex: 0,
  keyboard: true,
  styles: {},
  classNames: {}
});
/* harmony default export */ var rc_slider_es_context = (SliderContext);
/** @private NOT PROMISE AVAILABLE. DO NOT USE IN PRODUCTION. */
var UnstableContext = /*#__PURE__*/react.createContext({});
;// CONCATENATED MODULE: ./node_modules/rc-slider/es/Handles/Handle.js




var Handle_excluded = ["prefixCls", "value", "valueIndex", "onStartMove", "onDelete", "style", "render", "dragging", "draggingDelete", "onOffsetChange", "onChangeComplete", "onFocus", "onMouseEnter"];





var Handle = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    value = props.value,
    valueIndex = props.valueIndex,
    onStartMove = props.onStartMove,
    onDelete = props.onDelete,
    style = props.style,
    render = props.render,
    dragging = props.dragging,
    draggingDelete = props.draggingDelete,
    onOffsetChange = props.onOffsetChange,
    onChangeComplete = props.onChangeComplete,
    onFocus = props.onFocus,
    onMouseEnter = props.onMouseEnter,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, Handle_excluded);
  var _React$useContext = react.useContext(rc_slider_es_context),
    min = _React$useContext.min,
    max = _React$useContext.max,
    direction = _React$useContext.direction,
    disabled = _React$useContext.disabled,
    keyboard = _React$useContext.keyboard,
    range = _React$useContext.range,
    tabIndex = _React$useContext.tabIndex,
    ariaLabelForHandle = _React$useContext.ariaLabelForHandle,
    ariaLabelledByForHandle = _React$useContext.ariaLabelledByForHandle,
    ariaRequired = _React$useContext.ariaRequired,
    ariaValueTextFormatterForHandle = _React$useContext.ariaValueTextFormatterForHandle,
    styles = _React$useContext.styles,
    classNames = _React$useContext.classNames;
  var handlePrefixCls = "".concat(prefixCls, "-handle");

  // ============================ Events ============================
  var onInternalStartMove = function onInternalStartMove(e) {
    if (!disabled) {
      onStartMove(e, valueIndex);
    }
  };
  var onInternalFocus = function onInternalFocus(e) {
    onFocus === null || onFocus === void 0 || onFocus(e, valueIndex);
  };
  var onInternalMouseEnter = function onInternalMouseEnter(e) {
    onMouseEnter(e, valueIndex);
  };

  // =========================== Keyboard ===========================
  var onKeyDown = function onKeyDown(e) {
    if (!disabled && keyboard) {
      var offset = null;

      // Change the value
      switch (e.which || e.keyCode) {
        case KeyCode/* default.LEFT */.Z.LEFT:
          offset = direction === 'ltr' || direction === 'btt' ? -1 : 1;
          break;
        case KeyCode/* default.RIGHT */.Z.RIGHT:
          offset = direction === 'ltr' || direction === 'btt' ? 1 : -1;
          break;

        // Up is plus
        case KeyCode/* default.UP */.Z.UP:
          offset = direction !== 'ttb' ? 1 : -1;
          break;

        // Down is minus
        case KeyCode/* default.DOWN */.Z.DOWN:
          offset = direction !== 'ttb' ? -1 : 1;
          break;
        case KeyCode/* default.HOME */.Z.HOME:
          offset = 'min';
          break;
        case KeyCode/* default.END */.Z.END:
          offset = 'max';
          break;
        case KeyCode/* default.PAGE_UP */.Z.PAGE_UP:
          offset = 2;
          break;
        case KeyCode/* default.PAGE_DOWN */.Z.PAGE_DOWN:
          offset = -2;
          break;
        case KeyCode/* default.BACKSPACE */.Z.BACKSPACE:
        case KeyCode/* default.DELETE */.Z.DELETE:
          onDelete(valueIndex);
          break;
      }
      if (offset !== null) {
        e.preventDefault();
        onOffsetChange(offset, valueIndex);
      }
    }
  };
  var handleKeyUp = function handleKeyUp(e) {
    switch (e.which || e.keyCode) {
      case KeyCode/* default.LEFT */.Z.LEFT:
      case KeyCode/* default.RIGHT */.Z.RIGHT:
      case KeyCode/* default.UP */.Z.UP:
      case KeyCode/* default.DOWN */.Z.DOWN:
      case KeyCode/* default.HOME */.Z.HOME:
      case KeyCode/* default.END */.Z.END:
      case KeyCode/* default.PAGE_UP */.Z.PAGE_UP:
      case KeyCode/* default.PAGE_DOWN */.Z.PAGE_DOWN:
        onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete();
        break;
    }
  };

  // ============================ Offset ============================
  var positionStyle = getDirectionStyle(direction, value, min, max);

  // ============================ Render ============================
  var divProps = {};
  if (valueIndex !== null) {
    var _getIndex;
    divProps = {
      tabIndex: disabled ? null : getIndex(tabIndex, valueIndex),
      role: 'slider',
      'aria-valuemin': min,
      'aria-valuemax': max,
      'aria-valuenow': value,
      'aria-disabled': disabled,
      'aria-label': getIndex(ariaLabelForHandle, valueIndex),
      'aria-labelledby': getIndex(ariaLabelledByForHandle, valueIndex),
      'aria-required': getIndex(ariaRequired, valueIndex),
      'aria-valuetext': (_getIndex = getIndex(ariaValueTextFormatterForHandle, valueIndex)) === null || _getIndex === void 0 ? void 0 : _getIndex(value),
      'aria-orientation': direction === 'ltr' || direction === 'rtl' ? 'horizontal' : 'vertical',
      onMouseDown: onInternalStartMove,
      onTouchStart: onInternalStartMove,
      onFocus: onInternalFocus,
      onMouseEnter: onInternalMouseEnter,
      onKeyDown: onKeyDown,
      onKeyUp: handleKeyUp
    };
  }
  var handleNode = /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    ref: ref,
    className: classnames_default()(handlePrefixCls, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(handlePrefixCls, "-").concat(valueIndex + 1), valueIndex !== null && range), "".concat(handlePrefixCls, "-dragging"), dragging), "".concat(handlePrefixCls, "-dragging-delete"), draggingDelete), classNames.handle),
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, positionStyle), style), styles.handle)
  }, divProps, restProps));

  // Customize
  if (render) {
    handleNode = render(handleNode, {
      index: valueIndex,
      prefixCls: prefixCls,
      value: value,
      dragging: dragging,
      draggingDelete: draggingDelete
    });
  }
  return handleNode;
});
if (false) {}
/* harmony default export */ var Handles_Handle = (Handle);
;// CONCATENATED MODULE: ./node_modules/rc-slider/es/Handles/index.js




var Handles_excluded = ["prefixCls", "style", "onStartMove", "onOffsetChange", "values", "handleRender", "activeHandleRender", "draggingIndex", "draggingDelete", "onFocus"];




var Handles = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    style = props.style,
    onStartMove = props.onStartMove,
    onOffsetChange = props.onOffsetChange,
    values = props.values,
    handleRender = props.handleRender,
    activeHandleRender = props.activeHandleRender,
    draggingIndex = props.draggingIndex,
    draggingDelete = props.draggingDelete,
    onFocus = props.onFocus,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, Handles_excluded);
  var handlesRef = react.useRef({});

  // =========================== Active ===========================
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    activeVisible = _React$useState2[0],
    setActiveVisible = _React$useState2[1];
  var _React$useState3 = react.useState(-1),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    activeIndex = _React$useState4[0],
    setActiveIndex = _React$useState4[1];
  var onActive = function onActive(index) {
    setActiveIndex(index);
    setActiveVisible(true);
  };
  var onHandleFocus = function onHandleFocus(e, index) {
    onActive(index);
    onFocus === null || onFocus === void 0 || onFocus(e);
  };
  var onHandleMouseEnter = function onHandleMouseEnter(e, index) {
    onActive(index);
  };

  // =========================== Render ===========================
  react.useImperativeHandle(ref, function () {
    return {
      focus: function focus(index) {
        var _handlesRef$current$i;
        (_handlesRef$current$i = handlesRef.current[index]) === null || _handlesRef$current$i === void 0 || _handlesRef$current$i.focus();
      },
      hideHelp: function hideHelp() {
        (0,react_dom.flushSync)(function () {
          setActiveVisible(false);
        });
      }
    };
  });

  // =========================== Render ===========================
  // Handle Props
  var handleProps = (0,objectSpread2/* default */.Z)({
    prefixCls: prefixCls,
    onStartMove: onStartMove,
    onOffsetChange: onOffsetChange,
    render: handleRender,
    onFocus: onHandleFocus,
    onMouseEnter: onHandleMouseEnter
  }, restProps);
  return /*#__PURE__*/react.createElement(react.Fragment, null, values.map(function (value, index) {
    var dragging = draggingIndex === index;
    return /*#__PURE__*/react.createElement(Handles_Handle, (0,esm_extends/* default */.Z)({
      ref: function ref(node) {
        if (!node) {
          delete handlesRef.current[index];
        } else {
          handlesRef.current[index] = node;
        }
      },
      dragging: dragging,
      draggingDelete: dragging && draggingDelete,
      style: getIndex(style, index),
      key: index,
      value: value,
      valueIndex: index
    }, handleProps));
  }), activeHandleRender && activeVisible && /*#__PURE__*/react.createElement(Handles_Handle, (0,esm_extends/* default */.Z)({
    key: "a11y"
  }, handleProps, {
    value: values[activeIndex],
    valueIndex: null,
    dragging: draggingIndex !== -1,
    draggingDelete: draggingDelete,
    render: activeHandleRender,
    style: {
      pointerEvents: 'none'
    },
    tabIndex: null,
    "aria-hidden": true
  })));
});
if (false) {}
/* harmony default export */ var es_Handles = (Handles);
;// CONCATENATED MODULE: ./node_modules/rc-slider/es/Marks/Mark.js






var Mark = function Mark(props) {
  var prefixCls = props.prefixCls,
    style = props.style,
    children = props.children,
    value = props.value,
    _onClick = props.onClick;
  var _React$useContext = react.useContext(rc_slider_es_context),
    min = _React$useContext.min,
    max = _React$useContext.max,
    direction = _React$useContext.direction,
    includedStart = _React$useContext.includedStart,
    includedEnd = _React$useContext.includedEnd,
    included = _React$useContext.included;
  var textCls = "".concat(prefixCls, "-text");

  // ============================ Offset ============================
  var positionStyle = getDirectionStyle(direction, value, min, max);
  return /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(textCls, (0,defineProperty/* default */.Z)({}, "".concat(textCls, "-active"), included && includedStart <= value && value <= includedEnd)),
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, positionStyle), style),
    onMouseDown: function onMouseDown(e) {
      e.stopPropagation();
    },
    onClick: function onClick() {
      _onClick(value);
    }
  }, children);
};
/* harmony default export */ var Marks_Mark = (Mark);
;// CONCATENATED MODULE: ./node_modules/rc-slider/es/Marks/index.js


var Marks = function Marks(props) {
  var prefixCls = props.prefixCls,
    marks = props.marks,
    onClick = props.onClick;
  var markPrefixCls = "".concat(prefixCls, "-mark");

  // Not render mark if empty
  if (!marks.length) {
    return null;
  }
  return /*#__PURE__*/react.createElement("div", {
    className: markPrefixCls
  }, marks.map(function (_ref) {
    var value = _ref.value,
      style = _ref.style,
      label = _ref.label;
    return /*#__PURE__*/react.createElement(Marks_Mark, {
      key: value,
      prefixCls: markPrefixCls,
      style: style,
      value: value,
      onClick: onClick
    }, label);
  }));
};
/* harmony default export */ var es_Marks = (Marks);
;// CONCATENATED MODULE: ./node_modules/rc-slider/es/Steps/Dot.js






var Dot = function Dot(props) {
  var prefixCls = props.prefixCls,
    value = props.value,
    style = props.style,
    activeStyle = props.activeStyle;
  var _React$useContext = react.useContext(rc_slider_es_context),
    min = _React$useContext.min,
    max = _React$useContext.max,
    direction = _React$useContext.direction,
    included = _React$useContext.included,
    includedStart = _React$useContext.includedStart,
    includedEnd = _React$useContext.includedEnd;
  var dotClassName = "".concat(prefixCls, "-dot");
  var active = included && includedStart <= value && value <= includedEnd;

  // ============================ Offset ============================
  var mergedStyle = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, getDirectionStyle(direction, value, min, max)), typeof style === 'function' ? style(value) : style);
  if (active) {
    mergedStyle = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, mergedStyle), typeof activeStyle === 'function' ? activeStyle(value) : activeStyle);
  }
  return /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(dotClassName, (0,defineProperty/* default */.Z)({}, "".concat(dotClassName, "-active"), active)),
    style: mergedStyle
  });
};
/* harmony default export */ var Steps_Dot = (Dot);
;// CONCATENATED MODULE: ./node_modules/rc-slider/es/Steps/index.js



var Steps = function Steps(props) {
  var prefixCls = props.prefixCls,
    marks = props.marks,
    dots = props.dots,
    style = props.style,
    activeStyle = props.activeStyle;
  var _React$useContext = react.useContext(rc_slider_es_context),
    min = _React$useContext.min,
    max = _React$useContext.max,
    step = _React$useContext.step;
  var stepDots = react.useMemo(function () {
    var dotSet = new Set();

    // Add marks
    marks.forEach(function (mark) {
      dotSet.add(mark.value);
    });

    // Fill dots
    if (dots && step !== null) {
      var current = min;
      while (current <= max) {
        dotSet.add(current);
        current += step;
      }
    }
    return Array.from(dotSet);
  }, [min, max, step, dots, marks]);
  return /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-step")
  }, stepDots.map(function (dotValue) {
    return /*#__PURE__*/react.createElement(Steps_Dot, {
      prefixCls: prefixCls,
      key: dotValue,
      value: dotValue,
      style: style,
      activeStyle: activeStyle
    });
  }));
};
/* harmony default export */ var es_Steps = (Steps);
;// CONCATENATED MODULE: ./node_modules/rc-slider/es/Tracks/Track.js






var Track_Track = function Track(props) {
  var prefixCls = props.prefixCls,
    style = props.style,
    start = props.start,
    end = props.end,
    index = props.index,
    onStartMove = props.onStartMove,
    replaceCls = props.replaceCls;
  var _React$useContext = react.useContext(rc_slider_es_context),
    direction = _React$useContext.direction,
    min = _React$useContext.min,
    max = _React$useContext.max,
    disabled = _React$useContext.disabled,
    range = _React$useContext.range,
    classNames = _React$useContext.classNames;
  var trackPrefixCls = "".concat(prefixCls, "-track");
  var offsetStart = util_getOffset(start, min, max);
  var offsetEnd = util_getOffset(end, min, max);

  // ============================ Events ============================
  var onInternalStartMove = function onInternalStartMove(e) {
    if (!disabled && onStartMove) {
      onStartMove(e, -1);
    }
  };

  // ============================ Render ============================
  var positionStyle = {};
  switch (direction) {
    case 'rtl':
      positionStyle.right = "".concat(offsetStart * 100, "%");
      positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
      break;
    case 'btt':
      positionStyle.bottom = "".concat(offsetStart * 100, "%");
      positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
      break;
    case 'ttb':
      positionStyle.top = "".concat(offsetStart * 100, "%");
      positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
      break;
    default:
      positionStyle.left = "".concat(offsetStart * 100, "%");
      positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
  }
  var className = replaceCls || classnames_default()(trackPrefixCls, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(trackPrefixCls, "-").concat(index + 1), index !== null && range), "".concat(prefixCls, "-track-draggable"), onStartMove), classNames.track);
  return /*#__PURE__*/react.createElement("div", {
    className: className,
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, positionStyle), style),
    onMouseDown: onInternalStartMove,
    onTouchStart: onInternalStartMove
  });
};
/* harmony default export */ var Tracks_Track = (Track_Track);
;// CONCATENATED MODULE: ./node_modules/rc-slider/es/Tracks/index.js






var Tracks = function Tracks(props) {
  var prefixCls = props.prefixCls,
    style = props.style,
    values = props.values,
    startPoint = props.startPoint,
    onStartMove = props.onStartMove;
  var _React$useContext = react.useContext(rc_slider_es_context),
    included = _React$useContext.included,
    range = _React$useContext.range,
    min = _React$useContext.min,
    styles = _React$useContext.styles,
    classNames = _React$useContext.classNames;

  // =========================== List ===========================
  var trackList = react.useMemo(function () {
    if (!range) {
      // null value do not have track
      if (values.length === 0) {
        return [];
      }
      var startValue = startPoint !== null && startPoint !== void 0 ? startPoint : min;
      var endValue = values[0];
      return [{
        start: Math.min(startValue, endValue),
        end: Math.max(startValue, endValue)
      }];
    }

    // Multiple
    var list = [];
    for (var i = 0; i < values.length - 1; i += 1) {
      list.push({
        start: values[i],
        end: values[i + 1]
      });
    }
    return list;
  }, [values, range, startPoint, min]);
  if (!included) {
    return null;
  }

  // ========================== Render ==========================
  var tracksNode = trackList !== null && trackList !== void 0 && trackList.length && (classNames.tracks || styles.tracks) ? /*#__PURE__*/react.createElement(Tracks_Track, {
    index: null,
    prefixCls: prefixCls,
    start: trackList[0].start,
    end: trackList[trackList.length - 1].end,
    replaceCls: classnames_default()(classNames.tracks, "".concat(prefixCls, "-tracks")),
    style: styles.tracks
  }) : null;
  return /*#__PURE__*/react.createElement(react.Fragment, null, tracksNode, trackList.map(function (_ref, index) {
    var start = _ref.start,
      end = _ref.end;
    return /*#__PURE__*/react.createElement(Tracks_Track, {
      index: index,
      prefixCls: prefixCls,
      style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, getIndex(style, index)), styles.track),
      start: start,
      end: end,
      key: index,
      onStartMove: onStartMove
    });
  }));
};
/* harmony default export */ var es_Tracks = (Tracks);
;// CONCATENATED MODULE: ./node_modules/rc-slider/es/hooks/useDrag.js






/** Drag to delete offset. It's a user experience number for dragging out */
var REMOVE_DIST = 130;
function getPosition(e) {
  var obj = 'targetTouches' in e ? e.targetTouches[0] : e;
  return {
    pageX: obj.pageX,
    pageY: obj.pageY
  };
}
function useDrag(containerRef, direction, rawValues, min, max, formatValue, triggerChange, finishChange, offsetValues, editable, minCount) {
  var _React$useState = react.useState(null),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    draggingValue = _React$useState2[0],
    setDraggingValue = _React$useState2[1];
  var _React$useState3 = react.useState(-1),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    draggingIndex = _React$useState4[0],
    setDraggingIndex = _React$useState4[1];
  var _React$useState5 = react.useState(false),
    _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
    draggingDelete = _React$useState6[0],
    setDraggingDelete = _React$useState6[1];
  var _React$useState7 = react.useState(rawValues),
    _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
    cacheValues = _React$useState8[0],
    setCacheValues = _React$useState8[1];
  var _React$useState9 = react.useState(rawValues),
    _React$useState10 = (0,slicedToArray/* default */.Z)(_React$useState9, 2),
    originValues = _React$useState10[0],
    setOriginValues = _React$useState10[1];
  var mouseMoveEventRef = react.useRef(null);
  var mouseUpEventRef = react.useRef(null);
  var touchEventTargetRef = react.useRef(null);
  var _React$useContext = react.useContext(UnstableContext),
    onDragStart = _React$useContext.onDragStart,
    onDragChange = _React$useContext.onDragChange;
  (0,hooks_useLayoutEffect/* default */.Z)(function () {
    if (draggingIndex === -1) {
      setCacheValues(rawValues);
    }
  }, [rawValues, draggingIndex]);

  // Clean up event
  react.useEffect(function () {
    return function () {
      document.removeEventListener('mousemove', mouseMoveEventRef.current);
      document.removeEventListener('mouseup', mouseUpEventRef.current);
      if (touchEventTargetRef.current) {
        touchEventTargetRef.current.removeEventListener('touchmove', mouseMoveEventRef.current);
        touchEventTargetRef.current.removeEventListener('touchend', mouseUpEventRef.current);
      }
    };
  }, []);
  var flushValues = function flushValues(nextValues, nextValue, deleteMark) {
    // Perf: Only update state when value changed
    if (nextValue !== undefined) {
      setDraggingValue(nextValue);
    }
    setCacheValues(nextValues);
    var changeValues = nextValues;
    if (deleteMark) {
      changeValues = nextValues.filter(function (_, i) {
        return i !== draggingIndex;
      });
    }
    triggerChange(changeValues);
    if (onDragChange) {
      onDragChange({
        rawValues: nextValues,
        deleteIndex: deleteMark ? draggingIndex : -1,
        draggingIndex: draggingIndex,
        draggingValue: nextValue
      });
    }
  };
  var updateCacheValue = (0,hooks_useEvent/* default */.Z)(function (valueIndex, offsetPercent, deleteMark) {
    if (valueIndex === -1) {
      // >>>> Dragging on the track
      var startValue = originValues[0];
      var endValue = originValues[originValues.length - 1];
      var maxStartOffset = min - startValue;
      var maxEndOffset = max - endValue;

      // Get valid offset
      var offset = offsetPercent * (max - min);
      offset = Math.max(offset, maxStartOffset);
      offset = Math.min(offset, maxEndOffset);

      // Use first value to revert back of valid offset (like steps marks)
      var formatStartValue = formatValue(startValue + offset);
      offset = formatStartValue - startValue;
      var cloneCacheValues = originValues.map(function (val) {
        return val + offset;
      });
      flushValues(cloneCacheValues);
    } else {
      // >>>> Dragging on the handle
      var offsetDist = (max - min) * offsetPercent;

      // Always start with the valueIndex origin value
      var cloneValues = (0,toConsumableArray/* default */.Z)(cacheValues);
      cloneValues[valueIndex] = originValues[valueIndex];
      var next = offsetValues(cloneValues, offsetDist, valueIndex, 'dist');
      flushValues(next.values, next.value, deleteMark);
    }
  });
  var onStartMove = function onStartMove(e, valueIndex, startValues) {
    e.stopPropagation();

    // 如果是点击 track 触发的，需要传入变化后的初始值，而不能直接用 rawValues
    var initialValues = startValues || rawValues;
    var originValue = initialValues[valueIndex];
    setDraggingIndex(valueIndex);
    setDraggingValue(originValue);
    setOriginValues(initialValues);
    setCacheValues(initialValues);
    setDraggingDelete(false);
    var _getPosition = getPosition(e),
      startX = _getPosition.pageX,
      startY = _getPosition.pageY;

    // We declare it here since closure can't get outer latest value
    var deleteMark = false;

    // Internal trigger event
    if (onDragStart) {
      onDragStart({
        rawValues: initialValues,
        draggingIndex: valueIndex,
        draggingValue: originValue
      });
    }

    // Moving
    var onMouseMove = function onMouseMove(event) {
      event.preventDefault();
      var _getPosition2 = getPosition(event),
        moveX = _getPosition2.pageX,
        moveY = _getPosition2.pageY;
      var offsetX = moveX - startX;
      var offsetY = moveY - startY;
      var _containerRef$current = containerRef.current.getBoundingClientRect(),
        width = _containerRef$current.width,
        height = _containerRef$current.height;
      var offSetPercent;
      var removeDist;
      switch (direction) {
        case 'btt':
          offSetPercent = -offsetY / height;
          removeDist = offsetX;
          break;
        case 'ttb':
          offSetPercent = offsetY / height;
          removeDist = offsetX;
          break;
        case 'rtl':
          offSetPercent = -offsetX / width;
          removeDist = offsetY;
          break;
        default:
          offSetPercent = offsetX / width;
          removeDist = offsetY;
      }

      // Check if need mark remove
      deleteMark = editable ? Math.abs(removeDist) > REMOVE_DIST && minCount < cacheValues.length : false;
      setDraggingDelete(deleteMark);
      updateCacheValue(valueIndex, offSetPercent, deleteMark);
    };

    // End
    var onMouseUp = function onMouseUp(event) {
      event.preventDefault();
      document.removeEventListener('mouseup', onMouseUp);
      document.removeEventListener('mousemove', onMouseMove);
      if (touchEventTargetRef.current) {
        touchEventTargetRef.current.removeEventListener('touchmove', mouseMoveEventRef.current);
        touchEventTargetRef.current.removeEventListener('touchend', mouseUpEventRef.current);
      }
      mouseMoveEventRef.current = null;
      mouseUpEventRef.current = null;
      touchEventTargetRef.current = null;
      finishChange(deleteMark);
      setDraggingIndex(-1);
      setDraggingDelete(false);
    };
    document.addEventListener('mouseup', onMouseUp);
    document.addEventListener('mousemove', onMouseMove);
    e.currentTarget.addEventListener('touchend', onMouseUp);
    e.currentTarget.addEventListener('touchmove', onMouseMove);
    mouseMoveEventRef.current = onMouseMove;
    mouseUpEventRef.current = onMouseUp;
    touchEventTargetRef.current = e.currentTarget;
  };

  // Only return cache value when it mapping with rawValues
  var returnValues = react.useMemo(function () {
    var sourceValues = (0,toConsumableArray/* default */.Z)(rawValues).sort(function (a, b) {
      return a - b;
    });
    var targetValues = (0,toConsumableArray/* default */.Z)(cacheValues).sort(function (a, b) {
      return a - b;
    });
    var counts = {};
    targetValues.forEach(function (val) {
      counts[val] = (counts[val] || 0) + 1;
    });
    sourceValues.forEach(function (val) {
      counts[val] = (counts[val] || 0) - 1;
    });
    var maxDiffCount = editable ? 1 : 0;
    var diffCount = Object.values(counts).reduce(function (prev, next) {
      return prev + Math.abs(next);
    }, 0);
    return diffCount <= maxDiffCount ? cacheValues : rawValues;
  }, [rawValues, cacheValues, editable]);
  return [draggingIndex, draggingValue, draggingDelete, returnValues, onStartMove];
}
/* harmony default export */ var hooks_useDrag = (useDrag);
;// CONCATENATED MODULE: ./node_modules/rc-slider/es/hooks/useOffset.js



/** Format the value in the range of [min, max] */

/** Format value align with step */

/** Format value align with step & marks */

function useOffset(min, max, step, markList, allowCross, pushable) {
  var formatRangeValue = react.useCallback(function (val) {
    return Math.max(min, Math.min(max, val));
  }, [min, max]);
  var formatStepValue = react.useCallback(function (val) {
    if (step !== null) {
      var stepValue = min + Math.round((formatRangeValue(val) - min) / step) * step;

      // Cut number in case to be like 0.30000000000000004
      var getDecimal = function getDecimal(num) {
        return (String(num).split('.')[1] || '').length;
      };
      var maxDecimal = Math.max(getDecimal(step), getDecimal(max), getDecimal(min));
      var fixedValue = Number(stepValue.toFixed(maxDecimal));
      return min <= fixedValue && fixedValue <= max ? fixedValue : null;
    }
    return null;
  }, [step, min, max, formatRangeValue]);
  var formatValue = react.useCallback(function (val) {
    var formatNextValue = formatRangeValue(val);

    // List align values
    var alignValues = markList.map(function (mark) {
      return mark.value;
    });
    if (step !== null) {
      alignValues.push(formatStepValue(val));
    }

    // min & max
    alignValues.push(min, max);

    // Align with marks
    var closeValue = alignValues[0];
    var closeDist = max - min;
    alignValues.forEach(function (alignValue) {
      var dist = Math.abs(formatNextValue - alignValue);
      if (dist <= closeDist) {
        closeValue = alignValue;
        closeDist = dist;
      }
    });
    return closeValue;
  }, [min, max, markList, step, formatRangeValue, formatStepValue]);

  // ========================== Offset ==========================
  // Single Value
  var offsetValue = function offsetValue(values, offset, valueIndex) {
    var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unit';
    if (typeof offset === 'number') {
      var nextValue;
      var originValue = values[valueIndex];

      // Only used for `dist` mode
      var targetDistValue = originValue + offset;

      // Compare next step value & mark value which is best match
      var potentialValues = [];
      markList.forEach(function (mark) {
        potentialValues.push(mark.value);
      });

      // Min & Max
      potentialValues.push(min, max);

      // In case origin value is align with mark but not with step
      potentialValues.push(formatStepValue(originValue));

      // Put offset step value also
      var sign = offset > 0 ? 1 : -1;
      if (mode === 'unit') {
        potentialValues.push(formatStepValue(originValue + sign * step));
      } else {
        potentialValues.push(formatStepValue(targetDistValue));
      }

      // Find close one
      potentialValues = potentialValues.filter(function (val) {
        return val !== null;
      })
      // Remove reverse value
      .filter(function (val) {
        return offset < 0 ? val <= originValue : val >= originValue;
      });
      if (mode === 'unit') {
        // `unit` mode can not contain itself
        potentialValues = potentialValues.filter(function (val) {
          return val !== originValue;
        });
      }
      var compareValue = mode === 'unit' ? originValue : targetDistValue;
      nextValue = potentialValues[0];
      var valueDist = Math.abs(nextValue - compareValue);
      potentialValues.forEach(function (potentialValue) {
        var dist = Math.abs(potentialValue - compareValue);
        if (dist < valueDist) {
          nextValue = potentialValue;
          valueDist = dist;
        }
      });

      // Out of range will back to range
      if (nextValue === undefined) {
        return offset < 0 ? min : max;
      }

      // `dist` mode
      if (mode === 'dist') {
        return nextValue;
      }

      // `unit` mode may need another round
      if (Math.abs(offset) > 1) {
        var cloneValues = (0,toConsumableArray/* default */.Z)(values);
        cloneValues[valueIndex] = nextValue;
        return offsetValue(cloneValues, offset - sign, valueIndex, mode);
      }
      return nextValue;
    } else if (offset === 'min') {
      return min;
    } else if (offset === 'max') {
      return max;
    }
  };

  /** Same as `offsetValue` but return `changed` mark to tell value changed */
  var offsetChangedValue = function offsetChangedValue(values, offset, valueIndex) {
    var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unit';
    var originValue = values[valueIndex];
    var nextValue = offsetValue(values, offset, valueIndex, mode);
    return {
      value: nextValue,
      changed: nextValue !== originValue
    };
  };
  var needPush = function needPush(dist) {
    return pushable === null && dist === 0 || typeof pushable === 'number' && dist < pushable;
  };

  // Values
  var offsetValues = function offsetValues(values, offset, valueIndex) {
    var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unit';
    var nextValues = values.map(formatValue);
    var originValue = nextValues[valueIndex];
    var nextValue = offsetValue(nextValues, offset, valueIndex, mode);
    nextValues[valueIndex] = nextValue;
    if (allowCross === false) {
      // >>>>> Allow Cross
      var pushNum = pushable || 0;

      // ============ AllowCross ===============
      if (valueIndex > 0 && nextValues[valueIndex - 1] !== originValue) {
        nextValues[valueIndex] = Math.max(nextValues[valueIndex], nextValues[valueIndex - 1] + pushNum);
      }
      if (valueIndex < nextValues.length - 1 && nextValues[valueIndex + 1] !== originValue) {
        nextValues[valueIndex] = Math.min(nextValues[valueIndex], nextValues[valueIndex + 1] - pushNum);
      }
    } else if (typeof pushable === 'number' || pushable === null) {
      // >>>>> Pushable
      // =============== Push ==================

      // >>>>>> Basic push
      // End values
      for (var i = valueIndex + 1; i < nextValues.length; i += 1) {
        var changed = true;
        while (needPush(nextValues[i] - nextValues[i - 1]) && changed) {
          var _offsetChangedValue = offsetChangedValue(nextValues, 1, i);
          nextValues[i] = _offsetChangedValue.value;
          changed = _offsetChangedValue.changed;
        }
      }

      // Start values
      for (var _i = valueIndex; _i > 0; _i -= 1) {
        var _changed = true;
        while (needPush(nextValues[_i] - nextValues[_i - 1]) && _changed) {
          var _offsetChangedValue2 = offsetChangedValue(nextValues, -1, _i - 1);
          nextValues[_i - 1] = _offsetChangedValue2.value;
          _changed = _offsetChangedValue2.changed;
        }
      }

      // >>>>> Revert back to safe push range
      // End to Start
      for (var _i2 = nextValues.length - 1; _i2 > 0; _i2 -= 1) {
        var _changed2 = true;
        while (needPush(nextValues[_i2] - nextValues[_i2 - 1]) && _changed2) {
          var _offsetChangedValue3 = offsetChangedValue(nextValues, -1, _i2 - 1);
          nextValues[_i2 - 1] = _offsetChangedValue3.value;
          _changed2 = _offsetChangedValue3.changed;
        }
      }

      // Start to End
      for (var _i3 = 0; _i3 < nextValues.length - 1; _i3 += 1) {
        var _changed3 = true;
        while (needPush(nextValues[_i3 + 1] - nextValues[_i3]) && _changed3) {
          var _offsetChangedValue4 = offsetChangedValue(nextValues, 1, _i3 + 1);
          nextValues[_i3 + 1] = _offsetChangedValue4.value;
          _changed3 = _offsetChangedValue4.changed;
        }
      }
    }
    return {
      value: nextValues[valueIndex],
      values: nextValues
    };
  };
  return [formatValue, offsetValues];
}
;// CONCATENATED MODULE: ./node_modules/rc-slider/es/hooks/useRange.js


function useRange(range) {
  return (0,react.useMemo)(function () {
    if (range === true || !range) {
      return [!!range, false, false, 0];
    }
    var editable = range.editable,
      draggableTrack = range.draggableTrack,
      minCount = range.minCount,
      maxCount = range.maxCount;
    if (false) {}
    return [true, editable, !editable && draggableTrack, minCount || 0, maxCount];
  }, [range]);
}
;// CONCATENATED MODULE: ./node_modules/rc-slider/es/Slider.js




















/**
 * New:
 * - click mark to update range value
 * - handleRender
 * - Fix handle with count not correct
 * - Fix pushable not work in some case
 * - No more FindDOMNode
 * - Move all position related style into inline style
 * - Key: up is plus, down is minus
 * - fix Key with step = null not align with marks
 * - Change range should not trigger onChange
 * - keyboard support pushable
 */

var Slider_Slider = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-slider' : _props$prefixCls,
    className = props.className,
    style = props.style,
    classNames = props.classNames,
    styles = props.styles,
    id = props.id,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$keyboard = props.keyboard,
    keyboard = _props$keyboard === void 0 ? true : _props$keyboard,
    autoFocus = props.autoFocus,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    _props$min = props.min,
    min = _props$min === void 0 ? 0 : _props$min,
    _props$max = props.max,
    max = _props$max === void 0 ? 100 : _props$max,
    _props$step = props.step,
    step = _props$step === void 0 ? 1 : _props$step,
    value = props.value,
    defaultValue = props.defaultValue,
    range = props.range,
    count = props.count,
    onChange = props.onChange,
    onBeforeChange = props.onBeforeChange,
    onAfterChange = props.onAfterChange,
    onChangeComplete = props.onChangeComplete,
    _props$allowCross = props.allowCross,
    allowCross = _props$allowCross === void 0 ? true : _props$allowCross,
    _props$pushable = props.pushable,
    pushable = _props$pushable === void 0 ? false : _props$pushable,
    reverse = props.reverse,
    vertical = props.vertical,
    _props$included = props.included,
    included = _props$included === void 0 ? true : _props$included,
    startPoint = props.startPoint,
    trackStyle = props.trackStyle,
    handleStyle = props.handleStyle,
    railStyle = props.railStyle,
    dotStyle = props.dotStyle,
    activeDotStyle = props.activeDotStyle,
    marks = props.marks,
    dots = props.dots,
    handleRender = props.handleRender,
    activeHandleRender = props.activeHandleRender,
    track = props.track,
    _props$tabIndex = props.tabIndex,
    tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
    ariaLabelForHandle = props.ariaLabelForHandle,
    ariaLabelledByForHandle = props.ariaLabelledByForHandle,
    ariaRequired = props.ariaRequired,
    ariaValueTextFormatterForHandle = props.ariaValueTextFormatterForHandle;
  var handlesRef = react.useRef(null);
  var containerRef = react.useRef(null);
  var direction = react.useMemo(function () {
    if (vertical) {
      return reverse ? 'ttb' : 'btt';
    }
    return reverse ? 'rtl' : 'ltr';
  }, [reverse, vertical]);

  // ============================ Range =============================
  var _useRange = useRange(range),
    _useRange2 = (0,slicedToArray/* default */.Z)(_useRange, 5),
    rangeEnabled = _useRange2[0],
    rangeEditable = _useRange2[1],
    rangeDraggableTrack = _useRange2[2],
    minCount = _useRange2[3],
    maxCount = _useRange2[4];
  var mergedMin = react.useMemo(function () {
    return isFinite(min) ? min : 0;
  }, [min]);
  var mergedMax = react.useMemo(function () {
    return isFinite(max) ? max : 100;
  }, [max]);

  // ============================= Step =============================
  var mergedStep = react.useMemo(function () {
    return step !== null && step <= 0 ? 1 : step;
  }, [step]);

  // ============================= Push =============================
  var mergedPush = react.useMemo(function () {
    if (typeof pushable === 'boolean') {
      return pushable ? mergedStep : false;
    }
    return pushable >= 0 ? pushable : false;
  }, [pushable, mergedStep]);

  // ============================ Marks =============================
  var markList = react.useMemo(function () {
    return Object.keys(marks || {}).map(function (key) {
      var mark = marks[key];
      var markObj = {
        value: Number(key)
      };
      if (mark && (0,esm_typeof/* default */.Z)(mark) === 'object' && ! /*#__PURE__*/react.isValidElement(mark) && ('label' in mark || 'style' in mark)) {
        markObj.style = mark.style;
        markObj.label = mark.label;
      } else {
        markObj.label = mark;
      }
      return markObj;
    }).filter(function (_ref) {
      var label = _ref.label;
      return label || typeof label === 'number';
    }).sort(function (a, b) {
      return a.value - b.value;
    });
  }, [marks]);

  // ============================ Format ============================
  var _useOffset = useOffset(mergedMin, mergedMax, mergedStep, markList, allowCross, mergedPush),
    _useOffset2 = (0,slicedToArray/* default */.Z)(_useOffset, 2),
    formatValue = _useOffset2[0],
    offsetValues = _useOffset2[1];

  // ============================ Values ============================
  var _useMergedState = (0,useMergedState/* default */.Z)(defaultValue, {
      value: value
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    mergedValue = _useMergedState2[0],
    setValue = _useMergedState2[1];
  var rawValues = react.useMemo(function () {
    var valueList = mergedValue === null || mergedValue === undefined ? [] : Array.isArray(mergedValue) ? mergedValue : [mergedValue];
    var _valueList = (0,slicedToArray/* default */.Z)(valueList, 1),
      _valueList$ = _valueList[0],
      val0 = _valueList$ === void 0 ? mergedMin : _valueList$;
    var returnValues = mergedValue === null ? [] : [val0];

    // Format as range
    if (rangeEnabled) {
      returnValues = (0,toConsumableArray/* default */.Z)(valueList);

      // When count provided or value is `undefined`, we fill values
      if (count || mergedValue === undefined) {
        var pointCount = count >= 0 ? count + 1 : 2;
        returnValues = returnValues.slice(0, pointCount);

        // Fill with count
        while (returnValues.length < pointCount) {
          var _returnValues;
          returnValues.push((_returnValues = returnValues[returnValues.length - 1]) !== null && _returnValues !== void 0 ? _returnValues : mergedMin);
        }
      }
      returnValues.sort(function (a, b) {
        return a - b;
      });
    }

    // Align in range
    returnValues.forEach(function (val, index) {
      returnValues[index] = formatValue(val);
    });
    return returnValues;
  }, [mergedValue, rangeEnabled, mergedMin, count, formatValue]);

  // =========================== onChange ===========================
  var getTriggerValue = function getTriggerValue(triggerValues) {
    return rangeEnabled ? triggerValues : triggerValues[0];
  };
  var triggerChange = (0,hooks_useEvent/* default */.Z)(function (nextValues) {
    // Order first
    var cloneNextValues = (0,toConsumableArray/* default */.Z)(nextValues).sort(function (a, b) {
      return a - b;
    });

    // Trigger event if needed
    if (onChange && !(0,isEqual/* default */.Z)(cloneNextValues, rawValues, true)) {
      onChange(getTriggerValue(cloneNextValues));
    }

    // We set this later since it will re-render component immediately
    setValue(cloneNextValues);
  });
  var finishChange = (0,hooks_useEvent/* default */.Z)(function (draggingDelete) {
    // Trigger from `useDrag` will tell if it's a delete action
    if (draggingDelete) {
      handlesRef.current.hideHelp();
    }
    var finishValue = getTriggerValue(rawValues);
    onAfterChange === null || onAfterChange === void 0 || onAfterChange(finishValue);
    (0,es_warning/* default */.ZP)(!onAfterChange, '[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.');
    onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete(finishValue);
  });
  var onDelete = function onDelete(index) {
    if (disabled || !rangeEditable || rawValues.length <= minCount) {
      return;
    }
    var cloneNextValues = (0,toConsumableArray/* default */.Z)(rawValues);
    cloneNextValues.splice(index, 1);
    onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(cloneNextValues));
    triggerChange(cloneNextValues);
    var nextFocusIndex = Math.max(0, index - 1);
    handlesRef.current.hideHelp();
    handlesRef.current.focus(nextFocusIndex);
  };
  var _useDrag = hooks_useDrag(containerRef, direction, rawValues, mergedMin, mergedMax, formatValue, triggerChange, finishChange, offsetValues, rangeEditable, minCount),
    _useDrag2 = (0,slicedToArray/* default */.Z)(_useDrag, 5),
    draggingIndex = _useDrag2[0],
    draggingValue = _useDrag2[1],
    draggingDelete = _useDrag2[2],
    cacheValues = _useDrag2[3],
    onStartDrag = _useDrag2[4];

  /**
   * When `rangeEditable` will insert a new value in the values array.
   * Else it will replace the value in the values array.
   */
  var changeToCloseValue = function changeToCloseValue(newValue, e) {
    if (!disabled) {
      // Create new values
      var cloneNextValues = (0,toConsumableArray/* default */.Z)(rawValues);
      var valueIndex = 0;
      var valueBeforeIndex = 0; // Record the index which value < newValue
      var valueDist = mergedMax - mergedMin;
      rawValues.forEach(function (val, index) {
        var dist = Math.abs(newValue - val);
        if (dist <= valueDist) {
          valueDist = dist;
          valueIndex = index;
        }
        if (val < newValue) {
          valueBeforeIndex = index;
        }
      });
      var focusIndex = valueIndex;
      if (rangeEditable && valueDist !== 0 && (!maxCount || rawValues.length < maxCount)) {
        cloneNextValues.splice(valueBeforeIndex + 1, 0, newValue);
        focusIndex = valueBeforeIndex + 1;
      } else {
        cloneNextValues[valueIndex] = newValue;
      }

      // Fill value to match default 2 (only when `rawValues` is empty)
      if (rangeEnabled && !rawValues.length && count === undefined) {
        cloneNextValues.push(newValue);
      }
      var nextValue = getTriggerValue(cloneNextValues);
      onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(nextValue);
      triggerChange(cloneNextValues);
      if (e) {
        var _document$activeEleme, _document$activeEleme2;
        (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 || (_document$activeEleme2 = _document$activeEleme.blur) === null || _document$activeEleme2 === void 0 || _document$activeEleme2.call(_document$activeEleme);
        handlesRef.current.focus(focusIndex);
        onStartDrag(e, focusIndex, cloneNextValues);
      } else {
        // https://github.com/ant-design/ant-design/issues/49997
        onAfterChange === null || onAfterChange === void 0 || onAfterChange(nextValue);
        (0,es_warning/* default */.ZP)(!onAfterChange, '[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.');
        onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete(nextValue);
      }
    }
  };

  // ============================ Click =============================
  var onSliderMouseDown = function onSliderMouseDown(e) {
    e.preventDefault();
    var _containerRef$current = containerRef.current.getBoundingClientRect(),
      width = _containerRef$current.width,
      height = _containerRef$current.height,
      left = _containerRef$current.left,
      top = _containerRef$current.top,
      bottom = _containerRef$current.bottom,
      right = _containerRef$current.right;
    var clientX = e.clientX,
      clientY = e.clientY;
    var percent;
    switch (direction) {
      case 'btt':
        percent = (bottom - clientY) / height;
        break;
      case 'ttb':
        percent = (clientY - top) / height;
        break;
      case 'rtl':
        percent = (right - clientX) / width;
        break;
      default:
        percent = (clientX - left) / width;
    }
    var nextValue = mergedMin + percent * (mergedMax - mergedMin);
    changeToCloseValue(formatValue(nextValue), e);
  };

  // =========================== Keyboard ===========================
  var _React$useState = react.useState(null),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    keyboardValue = _React$useState2[0],
    setKeyboardValue = _React$useState2[1];
  var onHandleOffsetChange = function onHandleOffsetChange(offset, valueIndex) {
    if (!disabled) {
      var next = offsetValues(rawValues, offset, valueIndex);
      onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValues));
      triggerChange(next.values);
      setKeyboardValue(next.value);
    }
  };
  react.useEffect(function () {
    if (keyboardValue !== null) {
      var valueIndex = rawValues.indexOf(keyboardValue);
      if (valueIndex >= 0) {
        handlesRef.current.focus(valueIndex);
      }
    }
    setKeyboardValue(null);
  }, [keyboardValue]);

  // ============================= Drag =============================
  var mergedDraggableTrack = react.useMemo(function () {
    if (rangeDraggableTrack && mergedStep === null) {
      if (false) {}
      return false;
    }
    return rangeDraggableTrack;
  }, [rangeDraggableTrack, mergedStep]);
  var onStartMove = (0,hooks_useEvent/* default */.Z)(function (e, valueIndex) {
    onStartDrag(e, valueIndex);
    onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValues));
  });

  // Auto focus for updated handle
  var dragging = draggingIndex !== -1;
  react.useEffect(function () {
    if (!dragging) {
      var valueIndex = rawValues.lastIndexOf(draggingValue);
      handlesRef.current.focus(valueIndex);
    }
  }, [dragging]);

  // =========================== Included ===========================
  var sortedCacheValues = react.useMemo(function () {
    return (0,toConsumableArray/* default */.Z)(cacheValues).sort(function (a, b) {
      return a - b;
    });
  }, [cacheValues]);

  // Provide a range values with included [min, max]
  // Used for Track, Mark & Dot
  var _React$useMemo = react.useMemo(function () {
      if (!rangeEnabled) {
        return [mergedMin, sortedCacheValues[0]];
      }
      return [sortedCacheValues[0], sortedCacheValues[sortedCacheValues.length - 1]];
    }, [sortedCacheValues, rangeEnabled, mergedMin]),
    _React$useMemo2 = (0,slicedToArray/* default */.Z)(_React$useMemo, 2),
    includedStart = _React$useMemo2[0],
    includedEnd = _React$useMemo2[1];

  // ============================= Refs =============================
  react.useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        handlesRef.current.focus(0);
      },
      blur: function blur() {
        var _containerRef$current2;
        var _document = document,
          activeElement = _document.activeElement;
        if ((_containerRef$current2 = containerRef.current) !== null && _containerRef$current2 !== void 0 && _containerRef$current2.contains(activeElement)) {
          activeElement === null || activeElement === void 0 || activeElement.blur();
        }
      }
    };
  });

  // ========================== Auto Focus ==========================
  react.useEffect(function () {
    if (autoFocus) {
      handlesRef.current.focus(0);
    }
  }, []);

  // =========================== Context ============================
  var context = react.useMemo(function () {
    return {
      min: mergedMin,
      max: mergedMax,
      direction: direction,
      disabled: disabled,
      keyboard: keyboard,
      step: mergedStep,
      included: included,
      includedStart: includedStart,
      includedEnd: includedEnd,
      range: rangeEnabled,
      tabIndex: tabIndex,
      ariaLabelForHandle: ariaLabelForHandle,
      ariaLabelledByForHandle: ariaLabelledByForHandle,
      ariaRequired: ariaRequired,
      ariaValueTextFormatterForHandle: ariaValueTextFormatterForHandle,
      styles: styles || {},
      classNames: classNames || {}
    };
  }, [mergedMin, mergedMax, direction, disabled, keyboard, mergedStep, included, includedStart, includedEnd, rangeEnabled, tabIndex, ariaLabelForHandle, ariaLabelledByForHandle, ariaRequired, ariaValueTextFormatterForHandle, styles, classNames]);

  // ============================ Render ============================
  return /*#__PURE__*/react.createElement(rc_slider_es_context.Provider, {
    value: context
  }, /*#__PURE__*/react.createElement("div", {
    ref: containerRef,
    className: classnames_default()(prefixCls, className, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-vertical"), vertical), "".concat(prefixCls, "-horizontal"), !vertical), "".concat(prefixCls, "-with-marks"), markList.length)),
    style: style,
    onMouseDown: onSliderMouseDown,
    id: id
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(prefixCls, "-rail"), classNames === null || classNames === void 0 ? void 0 : classNames.rail),
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, railStyle), styles === null || styles === void 0 ? void 0 : styles.rail)
  }), track !== false && /*#__PURE__*/react.createElement(es_Tracks, {
    prefixCls: prefixCls,
    style: trackStyle,
    values: rawValues,
    startPoint: startPoint,
    onStartMove: mergedDraggableTrack ? onStartMove : undefined
  }), /*#__PURE__*/react.createElement(es_Steps, {
    prefixCls: prefixCls,
    marks: markList,
    dots: dots,
    style: dotStyle,
    activeStyle: activeDotStyle
  }), /*#__PURE__*/react.createElement(es_Handles, {
    ref: handlesRef,
    prefixCls: prefixCls,
    style: handleStyle,
    values: cacheValues,
    draggingIndex: draggingIndex,
    draggingDelete: draggingDelete,
    onStartMove: onStartMove,
    onOffsetChange: onHandleOffsetChange,
    onFocus: onFocus,
    onBlur: onBlur,
    handleRender: handleRender,
    activeHandleRender: activeHandleRender,
    onChangeComplete: finishChange,
    onDelete: rangeEditable ? onDelete : undefined
  }), /*#__PURE__*/react.createElement(es_Marks, {
    prefixCls: prefixCls,
    marks: markList,
    onClick: changeToCloseValue
  })));
});
if (false) {}
/* harmony default export */ var es_Slider = (Slider_Slider);
;// CONCATENATED MODULE: ./node_modules/rc-slider/es/index.js


/* harmony default export */ var rc_slider_es = (es_Slider);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/slider/Context.js

/** @private Internal context. Do not use in your production. */
const SliderInternalContext = /*#__PURE__*/(0,react.createContext)({});
/* harmony default export */ var slider_Context = (SliderInternalContext);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/slider/SliderTooltip.js
"use client";






const SliderTooltip = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    open,
    draggingDelete,
    value
  } = props;
  const innerRef = (0,react.useRef)(null);
  const mergedOpen = open && !draggingDelete;
  const rafRef = (0,react.useRef)(null);
  function cancelKeepAlign() {
    raf/* default.cancel */.Z.cancel(rafRef.current);
    rafRef.current = null;
  }
  function keepAlign() {
    rafRef.current = (0,raf/* default */.Z)(() => {
      var _a;
      (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.forceAlign();
      rafRef.current = null;
    });
  }
  react.useEffect(() => {
    if (mergedOpen) {
      keepAlign();
    } else {
      cancelKeepAlign();
    }
    return cancelKeepAlign;
  }, [mergedOpen, props.title, value]);
  return /*#__PURE__*/react.createElement(es_tooltip, Object.assign({
    ref: (0,es_ref/* composeRef */.sQ)(innerRef, ref)
  }, props, {
    open: mergedOpen
  }));
});
if (false) {}
/* harmony default export */ var slider_SliderTooltip = (SliderTooltip);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/slider/style/index.js




// =============================== Base ===============================
const slider_style_genBaseStyle = token => {
  const {
    componentCls,
    antCls,
    controlSize,
    dotSize,
    marginFull,
    marginPart,
    colorFillContentHover,
    handleColorDisabled,
    calc,
    handleSize,
    handleSizeHover,
    handleActiveColor,
    handleActiveOutlineColor,
    handleLineWidth,
    handleLineWidthHover,
    motionDurationMid
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      position: 'relative',
      height: controlSize,
      margin: `${(0,cssinjs_es/* unit */.bf)(marginPart)} ${(0,cssinjs_es/* unit */.bf)(marginFull)}`,
      padding: 0,
      cursor: 'pointer',
      touchAction: 'none',
      '&-vertical': {
        margin: `${(0,cssinjs_es/* unit */.bf)(marginFull)} ${(0,cssinjs_es/* unit */.bf)(marginPart)}`
      },
      [`${componentCls}-rail`]: {
        position: 'absolute',
        backgroundColor: token.railBg,
        borderRadius: token.borderRadiusXS,
        transition: `background-color ${motionDurationMid}`
      },
      [`${componentCls}-track,${componentCls}-tracks`]: {
        position: 'absolute',
        transition: `background-color ${motionDurationMid}`
      },
      [`${componentCls}-track`]: {
        backgroundColor: token.trackBg,
        borderRadius: token.borderRadiusXS
      },
      [`${componentCls}-track-draggable`]: {
        boxSizing: 'content-box',
        backgroundClip: 'content-box',
        border: 'solid rgba(0,0,0,0)'
      },
      '&:hover': {
        [`${componentCls}-rail`]: {
          backgroundColor: token.railHoverBg
        },
        [`${componentCls}-track`]: {
          backgroundColor: token.trackHoverBg
        },
        [`${componentCls}-dot`]: {
          borderColor: colorFillContentHover
        },
        [`${componentCls}-handle::after`]: {
          boxShadow: `0 0 0 ${(0,cssinjs_es/* unit */.bf)(handleLineWidth)} ${token.colorPrimaryBorderHover}`
        },
        [`${componentCls}-dot-active`]: {
          borderColor: token.dotActiveBorderColor
        }
      },
      [`${componentCls}-handle`]: {
        position: 'absolute',
        width: handleSize,
        height: handleSize,
        outline: 'none',
        userSelect: 'none',
        // Dragging status
        '&-dragging-delete': {
          opacity: 0
        },
        // 扩大选区
        '&::before': {
          content: '""',
          position: 'absolute',
          insetInlineStart: calc(handleLineWidth).mul(-1).equal(),
          insetBlockStart: calc(handleLineWidth).mul(-1).equal(),
          width: calc(handleSize).add(calc(handleLineWidth).mul(2)).equal(),
          height: calc(handleSize).add(calc(handleLineWidth).mul(2)).equal(),
          backgroundColor: 'transparent'
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          insetBlockStart: 0,
          insetInlineStart: 0,
          width: handleSize,
          height: handleSize,
          backgroundColor: token.colorBgElevated,
          boxShadow: `0 0 0 ${(0,cssinjs_es/* unit */.bf)(handleLineWidth)} ${token.handleColor}`,
          outline: `0px solid transparent`,
          borderRadius: '50%',
          cursor: 'pointer',
          transition: `
            inset-inline-start ${motionDurationMid},
            inset-block-start ${motionDurationMid},
            width ${motionDurationMid},
            height ${motionDurationMid},
            box-shadow ${motionDurationMid},
            outline ${motionDurationMid}
          `
        },
        '&:hover, &:active, &:focus': {
          '&::before': {
            insetInlineStart: calc(handleSizeHover).sub(handleSize).div(2).add(handleLineWidthHover).mul(-1).equal(),
            insetBlockStart: calc(handleSizeHover).sub(handleSize).div(2).add(handleLineWidthHover).mul(-1).equal(),
            width: calc(handleSizeHover).add(calc(handleLineWidthHover).mul(2)).equal(),
            height: calc(handleSizeHover).add(calc(handleLineWidthHover).mul(2)).equal()
          },
          '&::after': {
            boxShadow: `0 0 0 ${(0,cssinjs_es/* unit */.bf)(handleLineWidthHover)} ${handleActiveColor}`,
            outline: `6px solid ${handleActiveOutlineColor}`,
            width: handleSizeHover,
            height: handleSizeHover,
            insetInlineStart: token.calc(handleSize).sub(handleSizeHover).div(2).equal(),
            insetBlockStart: token.calc(handleSize).sub(handleSizeHover).div(2).equal()
          }
        }
      },
      [`&-lock ${componentCls}-handle`]: {
        '&::before, &::after': {
          transition: 'none'
        }
      },
      [`${componentCls}-mark`]: {
        position: 'absolute',
        fontSize: token.fontSize
      },
      [`${componentCls}-mark-text`]: {
        position: 'absolute',
        display: 'inline-block',
        color: token.colorTextDescription,
        textAlign: 'center',
        wordBreak: 'keep-all',
        cursor: 'pointer',
        userSelect: 'none',
        '&-active': {
          color: token.colorText
        }
      },
      [`${componentCls}-step`]: {
        position: 'absolute',
        background: 'transparent',
        pointerEvents: 'none'
      },
      [`${componentCls}-dot`]: {
        position: 'absolute',
        width: dotSize,
        height: dotSize,
        backgroundColor: token.colorBgElevated,
        border: `${(0,cssinjs_es/* unit */.bf)(handleLineWidth)} solid ${token.dotBorderColor}`,
        borderRadius: '50%',
        cursor: 'pointer',
        transition: `border-color ${token.motionDurationSlow}`,
        pointerEvents: 'auto',
        '&-active': {
          borderColor: token.dotActiveBorderColor
        }
      },
      [`&${componentCls}-disabled`]: {
        cursor: 'not-allowed',
        [`${componentCls}-rail`]: {
          backgroundColor: `${token.railBg} !important`
        },
        [`${componentCls}-track`]: {
          backgroundColor: `${token.trackBgDisabled} !important`
        },
        [`
          ${componentCls}-dot
        `]: {
          backgroundColor: token.colorBgElevated,
          borderColor: token.trackBgDisabled,
          boxShadow: 'none',
          cursor: 'not-allowed'
        },
        [`${componentCls}-handle::after`]: {
          backgroundColor: token.colorBgElevated,
          cursor: 'not-allowed',
          width: handleSize,
          height: handleSize,
          boxShadow: `0 0 0 ${(0,cssinjs_es/* unit */.bf)(handleLineWidth)} ${handleColorDisabled}`,
          insetInlineStart: 0,
          insetBlockStart: 0
        },
        [`
          ${componentCls}-mark-text,
          ${componentCls}-dot
        `]: {
          cursor: `not-allowed !important`
        }
      },
      [`&-tooltip ${antCls}-tooltip-inner`]: {
        minWidth: 'unset'
      }
    })
  };
};
// ============================ Horizontal ============================
const genDirectionStyle = (token, horizontal) => {
  const {
    componentCls,
    railSize,
    handleSize,
    dotSize,
    marginFull,
    calc
  } = token;
  const railPadding = horizontal ? 'paddingBlock' : 'paddingInline';
  const full = horizontal ? 'width' : 'height';
  const part = horizontal ? 'height' : 'width';
  const handlePos = horizontal ? 'insetBlockStart' : 'insetInlineStart';
  const markInset = horizontal ? 'top' : 'insetInlineStart';
  const handlePosSize = calc(railSize).mul(3).sub(handleSize).div(2).equal();
  const draggableBorderSize = calc(handleSize).sub(railSize).div(2).equal();
  const draggableBorder = horizontal ? {
    borderWidth: `${(0,cssinjs_es/* unit */.bf)(draggableBorderSize)} 0`,
    transform: `translateY(${(0,cssinjs_es/* unit */.bf)(calc(draggableBorderSize).mul(-1).equal())})`
  } : {
    borderWidth: `0 ${(0,cssinjs_es/* unit */.bf)(draggableBorderSize)}`,
    transform: `translateX(${(0,cssinjs_es/* unit */.bf)(token.calc(draggableBorderSize).mul(-1).equal())})`
  };
  return {
    [railPadding]: railSize,
    [part]: calc(railSize).mul(3).equal(),
    [`${componentCls}-rail`]: {
      [full]: '100%',
      [part]: railSize
    },
    [`${componentCls}-track,${componentCls}-tracks`]: {
      [part]: railSize
    },
    [`${componentCls}-track-draggable`]: Object.assign({}, draggableBorder),
    [`${componentCls}-handle`]: {
      [handlePos]: handlePosSize
    },
    [`${componentCls}-mark`]: {
      // Reset all
      insetInlineStart: 0,
      top: 0,
      // https://github.com/ant-design/ant-design/issues/43731
      [markInset]: calc(railSize).mul(3).add(horizontal ? 0 : marginFull).equal(),
      [full]: '100%'
    },
    [`${componentCls}-step`]: {
      // Reset all
      insetInlineStart: 0,
      top: 0,
      [markInset]: railSize,
      [full]: '100%',
      [part]: railSize
    },
    [`${componentCls}-dot`]: {
      position: 'absolute',
      [handlePos]: calc(railSize).sub(dotSize).div(2).equal()
    }
  };
};
// ============================ Horizontal ============================
const genHorizontalStyle = token => {
  const {
    componentCls,
    marginPartWithMark
  } = token;
  return {
    [`${componentCls}-horizontal`]: Object.assign(Object.assign({}, genDirectionStyle(token, true)), {
      [`&${componentCls}-with-marks`]: {
        marginBottom: marginPartWithMark
      }
    })
  };
};
// ============================= Vertical =============================
const genVerticalStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}-vertical`]: Object.assign(Object.assign({}, genDirectionStyle(token, false)), {
      height: '100%'
    })
  };
};
// ============================== Export ==============================
const slider_style_prepareComponentToken = token => {
  // Handle line width is always width-er 1px
  const increaseHandleWidth = 1;
  const controlSize = token.controlHeightLG / 4;
  const controlSizeHover = token.controlHeightSM / 2;
  const handleLineWidth = token.lineWidth + increaseHandleWidth;
  const handleLineWidthHover = token.lineWidth + increaseHandleWidth * 1.5;
  const handleActiveColor = token.colorPrimary;
  const handleActiveOutlineColor = new fast_color_es/* FastColor */.t(handleActiveColor).setA(0.2).toRgbString();
  return {
    controlSize,
    railSize: 4,
    handleSize: controlSize,
    handleSizeHover: controlSizeHover,
    dotSize: 8,
    handleLineWidth,
    handleLineWidthHover,
    railBg: token.colorFillTertiary,
    railHoverBg: token.colorFillSecondary,
    trackBg: token.colorPrimaryBorder,
    trackHoverBg: token.colorPrimaryBorderHover,
    handleColor: token.colorPrimaryBorder,
    handleActiveColor,
    handleActiveOutlineColor,
    handleColorDisabled: new fast_color_es/* FastColor */.t(token.colorTextDisabled).onBackground(token.colorBgContainer).toHexString(),
    dotBorderColor: token.colorBorderSecondary,
    dotActiveBorderColor: token.colorPrimaryBorder,
    trackBgDisabled: token.colorBgContainerDisabled
  };
};
/* harmony default export */ var slider_style = (genStyleHooks('Slider', token => {
  const sliderToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    marginPart: token.calc(token.controlHeight).sub(token.controlSize).div(2).equal(),
    marginFull: token.calc(token.controlSize).div(2).equal(),
    marginPartWithMark: token.calc(token.controlHeightLG).sub(token.controlSize).equal()
  });
  return [slider_style_genBaseStyle(sliderToken), genHorizontalStyle(sliderToken), genVerticalStyle(sliderToken)];
}, slider_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/slider/useRafLock.js


function useRafLock() {
  const [state, setState] = react.useState(false);
  const rafRef = react.useRef(null);
  const cleanup = () => {
    raf/* default.cancel */.Z.cancel(rafRef.current);
  };
  const setDelayState = nextState => {
    cleanup();
    if (nextState) {
      setState(nextState);
    } else {
      rafRef.current = (0,raf/* default */.Z)(() => {
        setState(nextState);
      });
    }
  };
  react.useEffect(() => cleanup, []);
  return [state, setDelayState];
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/slider/index.js
"use client";

var slider_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};











function getTipFormatter(tipFormatter, legacyTipFormatter) {
  if (tipFormatter || tipFormatter === null) {
    return tipFormatter;
  }
  if (legacyTipFormatter || legacyTipFormatter === null) {
    return legacyTipFormatter;
  }
  return val => typeof val === 'number' ? val.toString() : '';
}
const slider_Slider = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      range,
      className,
      rootClassName,
      style,
      disabled,
      // Deprecated Props
      tooltipPrefixCls: legacyTooltipPrefixCls,
      tipFormatter: legacyTipFormatter,
      tooltipVisible: legacyTooltipVisible,
      getTooltipPopupContainer: legacyGetTooltipPopupContainer,
      tooltipPlacement: legacyTooltipPlacement,
      tooltip = {},
      onChangeComplete,
      classNames: sliderClassNames,
      styles
    } = props,
    restProps = slider_rest(props, ["prefixCls", "range", "className", "rootClassName", "style", "disabled", "tooltipPrefixCls", "tipFormatter", "tooltipVisible", "getTooltipPopupContainer", "tooltipPlacement", "tooltip", "onChangeComplete", "classNames", "styles"]);
  const {
    vertical
  } = props;
  const {
    getPrefixCls,
    direction: contextDirection,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles,
    getPopupContainer
  } = useComponentConfig('slider');
  const contextDisabled = react.useContext(config_provider_DisabledContext);
  const mergedDisabled = disabled !== null && disabled !== void 0 ? disabled : contextDisabled;
  // ============================= Context ==============================
  const {
    handleRender: contextHandleRender,
    direction: internalContextDirection
  } = react.useContext(slider_Context);
  const mergedDirection = internalContextDirection || contextDirection;
  const isRTL = mergedDirection === 'rtl';
  // =============================== Open ===============================
  const [hoverOpen, setHoverOpen] = useRafLock();
  const [focusOpen, setFocusOpen] = useRafLock();
  const tooltipProps = Object.assign({}, tooltip);
  const {
    open: tooltipOpen,
    placement: tooltipPlacement,
    getPopupContainer: getTooltipPopupContainer,
    prefixCls: customizeTooltipPrefixCls,
    formatter: tipFormatter
  } = tooltipProps;
  const lockOpen = tooltipOpen !== null && tooltipOpen !== void 0 ? tooltipOpen : legacyTooltipVisible;
  const activeOpen = (hoverOpen || focusOpen) && lockOpen !== false;
  const mergedTipFormatter = getTipFormatter(tipFormatter, legacyTipFormatter);
  // ============================= Change ==============================
  const [dragging, setDragging] = useRafLock();
  const onInternalChangeComplete = nextValues => {
    onChangeComplete === null || onChangeComplete === void 0 ? void 0 : onChangeComplete(nextValues);
    setDragging(false);
  };
  // ============================ Placement ============================
  const getTooltipPlacement = (placement, vert) => {
    if (placement) {
      return placement;
    }
    if (!vert) {
      return 'top';
    }
    return isRTL ? 'left' : 'right';
  };
  // ============================== Style ===============================
  const prefixCls = getPrefixCls('slider', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = slider_style(prefixCls);
  const rootClassNames = classnames_default()(className, contextClassName, contextClassNames.root, sliderClassNames === null || sliderClassNames === void 0 ? void 0 : sliderClassNames.root, rootClassName, {
    [`${prefixCls}-rtl`]: isRTL,
    [`${prefixCls}-lock`]: dragging
  }, hashId, cssVarCls);
  // make reverse default on rtl direction
  if (isRTL && !restProps.vertical) {
    restProps.reverse = !restProps.reverse;
  }
  // ============================= Warning ==============================
  // Warning for deprecated usage
  if (false) {}
  // ============================== Handle ==============================
  react.useEffect(() => {
    const onMouseUp = () => {
      // Delay for 1 frame to make the click to enable hide tooltip
      // even when the handle is focused
      (0,raf/* default */.Z)(() => {
        setFocusOpen(false);
      }, 1);
    };
    document.addEventListener('mouseup', onMouseUp);
    return () => {
      document.removeEventListener('mouseup', onMouseUp);
    };
  }, []);
  const useActiveTooltipHandle = range && !lockOpen;
  const handleRender = contextHandleRender || ((node, info) => {
    const {
      index
    } = info;
    const nodeProps = node.props;
    function proxyEvent(eventName, event, triggerRestPropsEvent) {
      var _a, _b, _c, _d;
      if (triggerRestPropsEvent) {
        (_b = (_a = restProps)[eventName]) === null || _b === void 0 ? void 0 : _b.call(_a, event);
      }
      (_d = (_c = nodeProps)[eventName]) === null || _d === void 0 ? void 0 : _d.call(_c, event);
    }
    const passedProps = Object.assign(Object.assign({}, nodeProps), {
      onMouseEnter: e => {
        setHoverOpen(true);
        proxyEvent('onMouseEnter', e);
      },
      onMouseLeave: e => {
        setHoverOpen(false);
        proxyEvent('onMouseLeave', e);
      },
      onMouseDown: e => {
        setFocusOpen(true);
        setDragging(true);
        proxyEvent('onMouseDown', e);
      },
      onFocus: e => {
        var _a;
        setFocusOpen(true);
        (_a = restProps.onFocus) === null || _a === void 0 ? void 0 : _a.call(restProps, e);
        proxyEvent('onFocus', e, true);
      },
      onBlur: e => {
        var _a;
        setFocusOpen(false);
        (_a = restProps.onBlur) === null || _a === void 0 ? void 0 : _a.call(restProps, e);
        proxyEvent('onBlur', e, true);
      }
    });
    const cloneNode = /*#__PURE__*/react.cloneElement(node, passedProps);
    const open = (!!lockOpen || activeOpen) && mergedTipFormatter !== null;
    // Wrap on handle with Tooltip when is single mode or multiple with all show tooltip
    if (!useActiveTooltipHandle) {
      return /*#__PURE__*/react.createElement(slider_SliderTooltip, Object.assign({}, tooltipProps, {
        prefixCls: getPrefixCls('tooltip', customizeTooltipPrefixCls !== null && customizeTooltipPrefixCls !== void 0 ? customizeTooltipPrefixCls : legacyTooltipPrefixCls),
        title: mergedTipFormatter ? mergedTipFormatter(info.value) : '',
        value: info.value,
        open: open,
        placement: getTooltipPlacement(tooltipPlacement !== null && tooltipPlacement !== void 0 ? tooltipPlacement : legacyTooltipPlacement, vertical),
        key: index,
        classNames: {
          root: `${prefixCls}-tooltip`
        },
        getPopupContainer: getTooltipPopupContainer || legacyGetTooltipPopupContainer || getPopupContainer
      }), cloneNode);
    }
    return cloneNode;
  });
  // ========================== Active Handle ===========================
  const activeHandleRender = useActiveTooltipHandle ? (handle, info) => {
    const cloneNode = /*#__PURE__*/react.cloneElement(handle, {
      style: Object.assign(Object.assign({}, handle.props.style), {
        visibility: 'hidden'
      })
    });
    return /*#__PURE__*/react.createElement(slider_SliderTooltip, Object.assign({}, tooltipProps, {
      prefixCls: getPrefixCls('tooltip', customizeTooltipPrefixCls !== null && customizeTooltipPrefixCls !== void 0 ? customizeTooltipPrefixCls : legacyTooltipPrefixCls),
      title: mergedTipFormatter ? mergedTipFormatter(info.value) : '',
      open: mergedTipFormatter !== null && activeOpen,
      placement: getTooltipPlacement(tooltipPlacement !== null && tooltipPlacement !== void 0 ? tooltipPlacement : legacyTooltipPlacement, vertical),
      key: "tooltip",
      classNames: {
        root: `${prefixCls}-tooltip`
      },
      getPopupContainer: getTooltipPopupContainer || legacyGetTooltipPopupContainer || getPopupContainer,
      draggingDelete: info.draggingDelete
    }), cloneNode);
  } : undefined;
  // ============================== Render ==============================
  const rootStyle = Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.root), contextStyle), styles === null || styles === void 0 ? void 0 : styles.root), style);
  const mergedTracks = Object.assign(Object.assign({}, contextStyles.tracks), styles === null || styles === void 0 ? void 0 : styles.tracks);
  const mergedTracksClassNames = classnames_default()(contextClassNames.tracks, sliderClassNames === null || sliderClassNames === void 0 ? void 0 : sliderClassNames.tracks);
  return wrapCSSVar(/*#__PURE__*/
  // @ts-ignore
  react.createElement(rc_slider_es, Object.assign({}, restProps, {
    classNames: Object.assign({
      handle: classnames_default()(contextClassNames.handle, sliderClassNames === null || sliderClassNames === void 0 ? void 0 : sliderClassNames.handle),
      rail: classnames_default()(contextClassNames.rail, sliderClassNames === null || sliderClassNames === void 0 ? void 0 : sliderClassNames.rail),
      track: classnames_default()(contextClassNames.track, sliderClassNames === null || sliderClassNames === void 0 ? void 0 : sliderClassNames.track)
    }, mergedTracksClassNames ? {
      tracks: mergedTracksClassNames
    } : {}),
    styles: Object.assign({
      handle: Object.assign(Object.assign({}, contextStyles.handle), styles === null || styles === void 0 ? void 0 : styles.handle),
      rail: Object.assign(Object.assign({}, contextStyles.rail), styles === null || styles === void 0 ? void 0 : styles.rail),
      track: Object.assign(Object.assign({}, contextStyles.track), styles === null || styles === void 0 ? void 0 : styles.track)
    }, Object.keys(mergedTracks).length ? {
      tracks: mergedTracks
    } : {}),
    step: restProps.step,
    range: range,
    className: rootClassNames,
    style: rootStyle,
    disabled: mergedDisabled,
    ref: ref,
    prefixCls: prefixCls,
    handleRender: handleRender,
    activeHandleRender: activeHandleRender,
    onChangeComplete: onInternalChangeComplete
  })));
});
if (false) {}
/* harmony default export */ var slider = (slider_Slider);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/components/ColorSlider.js
"use client";

var ColorSlider_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







const GradientColorSlider = props => {
  const {
      prefixCls,
      colors,
      type,
      color,
      range = false,
      className,
      activeIndex,
      onActive,
      onDragStart,
      onDragChange,
      onKeyDelete
    } = props,
    restProps = ColorSlider_rest(props, ["prefixCls", "colors", "type", "color", "range", "className", "activeIndex", "onActive", "onDragStart", "onDragChange", "onKeyDelete"]);
  const sliderProps = Object.assign(Object.assign({}, restProps), {
    track: false
  });
  // ========================== Background ==========================
  const linearCss = react.useMemo(() => {
    const colorsStr = colors.map(c => `${c.color} ${c.percent}%`).join(', ');
    return `linear-gradient(90deg, ${colorsStr})`;
  }, [colors]);
  const pointColor = react.useMemo(() => {
    if (!color || !type) {
      return null;
    }
    if (type === 'alpha') {
      return color.toRgbString();
    }
    return `hsl(${color.toHsb().h}, 100%, 50%)`;
  }, [color, type]);
  // ======================= Context: Slider ========================
  const onInternalDragStart = (0,hooks_useEvent/* default */.Z)(onDragStart);
  const onInternalDragChange = (0,hooks_useEvent/* default */.Z)(onDragChange);
  const unstableContext = react.useMemo(() => ({
    onDragStart: onInternalDragStart,
    onDragChange: onInternalDragChange
  }), []);
  // ======================= Context: Render ========================
  const handleRender = (0,hooks_useEvent/* default */.Z)((ori, info) => {
    const {
      onFocus,
      style,
      className: handleCls,
      onKeyDown
    } = ori.props;
    // Point Color
    const mergedStyle = Object.assign({}, style);
    if (type === 'gradient') {
      mergedStyle.background = getGradientPercentColor(colors, info.value);
    }
    return /*#__PURE__*/react.cloneElement(ori, {
      onFocus: e => {
        onActive === null || onActive === void 0 ? void 0 : onActive(info.index);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
      },
      style: mergedStyle,
      className: classnames_default()(handleCls, {
        [`${prefixCls}-slider-handle-active`]: activeIndex === info.index
      }),
      onKeyDown: e => {
        if ((e.key === 'Delete' || e.key === 'Backspace') && onKeyDelete) {
          onKeyDelete(info.index);
        }
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
      }
    });
  });
  const sliderContext = react.useMemo(() => ({
    direction: 'ltr',
    handleRender
  }), []);
  // ============================ Render ============================
  return /*#__PURE__*/react.createElement(slider_Context.Provider, {
    value: sliderContext
  }, /*#__PURE__*/react.createElement(UnstableContext.Provider, {
    value: unstableContext
  }, /*#__PURE__*/react.createElement(slider, Object.assign({}, sliderProps, {
    className: classnames_default()(className, `${prefixCls}-slider`),
    tooltip: {
      open: false
    },
    range: {
      editable: range,
      minCount: 2
    },
    styles: {
      rail: {
        background: linearCss
      },
      handle: pointColor ? {
        background: pointColor
      } : {}
    },
    classNames: {
      rail: `${prefixCls}-slider-rail`,
      handle: `${prefixCls}-slider-handle`
    }
  }))));
};
const SingleColorSlider = props => {
  const {
    value,
    onChange,
    onChangeComplete
  } = props;
  const singleOnChange = v => onChange(v[0]);
  const singleOnChangeComplete = v => onChangeComplete(v[0]);
  return /*#__PURE__*/react.createElement(GradientColorSlider, Object.assign({}, props, {
    value: [value],
    onChange: singleOnChange,
    onChangeComplete: singleOnChangeComplete
  }));
};
/* harmony default export */ var ColorSlider = (SingleColorSlider);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/components/PanelPicker/GradientColorBar.js
"use client";






function sortColors(colors) {
  return (0,toConsumableArray/* default */.Z)(colors).sort((a, b) => a.percent - b.percent);
}
/**
 * GradientColorBar will auto show when the mode is `gradient`.
 */
const GradientColorBar = props => {
  const {
    prefixCls,
    mode,
    onChange,
    onChangeComplete,
    onActive,
    activeIndex,
    onGradientDragging,
    colors
  } = props;
  const isGradient = mode === 'gradient';
  // ============================= Colors =============================
  const colorList = react.useMemo(() => colors.map(info => ({
    percent: info.percent,
    color: info.color.toRgbString()
  })), [colors]);
  const values = react.useMemo(() => colorList.map(info => info.percent), [colorList]);
  // ============================== Drag ==============================
  const colorsRef = react.useRef(colorList);
  // Record current colors
  const onDragStart = ({
    rawValues,
    draggingIndex,
    draggingValue
  }) => {
    if (rawValues.length > colorList.length) {
      // Add new node
      const newPointColor = getGradientPercentColor(colorList, draggingValue);
      const nextColors = (0,toConsumableArray/* default */.Z)(colorList);
      nextColors.splice(draggingIndex, 0, {
        percent: draggingValue,
        color: newPointColor
      });
      colorsRef.current = nextColors;
    } else {
      colorsRef.current = colorList;
    }
    onGradientDragging(true);
    onChange(new AggregationColor(sortColors(colorsRef.current)), true);
  };
  // Adjust color when dragging
  const onDragChange = ({
    deleteIndex,
    draggingIndex,
    draggingValue
  }) => {
    let nextColors = (0,toConsumableArray/* default */.Z)(colorsRef.current);
    if (deleteIndex !== -1) {
      nextColors.splice(deleteIndex, 1);
    } else {
      nextColors[draggingIndex] = Object.assign(Object.assign({}, nextColors[draggingIndex]), {
        percent: draggingValue
      });
      nextColors = sortColors(nextColors);
    }
    onChange(new AggregationColor(nextColors), true);
  };
  // ============================== Key ===============================
  const onKeyDelete = index => {
    const nextColors = (0,toConsumableArray/* default */.Z)(colorList);
    nextColors.splice(index, 1);
    const nextColor = new AggregationColor(nextColors);
    onChange(nextColor);
    onChangeComplete(nextColor);
  };
  // ============================= Change =============================
  const onInternalChangeComplete = nextValues => {
    onChangeComplete(new AggregationColor(colorList));
    // Reset `activeIndex` if out of range
    if (activeIndex >= nextValues.length) {
      onActive(nextValues.length - 1);
    }
    onGradientDragging(false);
  };
  // ============================= Render =============================
  if (!isGradient) {
    return null;
  }
  return /*#__PURE__*/react.createElement(GradientColorSlider, {
    min: 0,
    max: 100,
    prefixCls: prefixCls,
    className: `${prefixCls}-gradient-slider`,
    colors: colorList,
    color: null,
    value: values,
    range: true,
    onChangeComplete: onInternalChangeComplete,
    disabled: false,
    type: "gradient",
    // Active
    activeIndex: activeIndex,
    onActive: onActive,
    // Drag
    onDragStart: onDragStart,
    onDragChange: onDragChange,
    onKeyDelete: onKeyDelete
  });
};
/* harmony default export */ var PanelPicker_GradientColorBar = (/*#__PURE__*/react.memo(GradientColorBar));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/components/PanelPicker/index.js
"use client";


var PanelPicker_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};











const components = {
  slider: ColorSlider
};
const PanelPicker = () => {
  const panelPickerContext = (0,react.useContext)(PanelPickerContext);
  const {
      mode,
      onModeChange,
      modeOptions,
      prefixCls,
      allowClear,
      value,
      disabledAlpha,
      onChange,
      onClear,
      onChangeComplete,
      activeIndex,
      gradientDragging
    } = panelPickerContext,
    injectProps = PanelPicker_rest(panelPickerContext, ["mode", "onModeChange", "modeOptions", "prefixCls", "allowClear", "value", "disabledAlpha", "onChange", "onClear", "onChangeComplete", "activeIndex", "gradientDragging"]);
  // ============================ Colors ============================
  const colors = react.useMemo(() => {
    if (!value.cleared) {
      return value.getColors();
    }
    return [{
      percent: 0,
      color: new AggregationColor('')
    }, {
      percent: 100,
      color: new AggregationColor('')
    }];
  }, [value]);
  // ========================= Single Color =========================
  const isSingle = !value.isGradient();
  // We cache the point color in case user drag the gradient point across another one
  const [lockedColor, setLockedColor] = react.useState(value);
  // Use layout effect here since `useEffect` will cause a blink when mouseDown
  (0,hooks_useLayoutEffect/* default */.Z)(() => {
    var _a;
    if (!isSingle) {
      setLockedColor((_a = colors[activeIndex]) === null || _a === void 0 ? void 0 : _a.color);
    }
  }, [gradientDragging, activeIndex]);
  const activeColor = react.useMemo(() => {
    var _a;
    if (isSingle) {
      return value;
    }
    // Use cache when dragging. User can not operation panel when dragging.
    if (gradientDragging) {
      return lockedColor;
    }
    return (_a = colors[activeIndex]) === null || _a === void 0 ? void 0 : _a.color;
  }, [value, activeIndex, isSingle, lockedColor, gradientDragging]);
  // ========================= Picker Color =========================
  const [pickerColor, setPickerColor] = react.useState(activeColor);
  const [forceSync, setForceSync] = react.useState(0);
  const mergedPickerColor = (pickerColor === null || pickerColor === void 0 ? void 0 : pickerColor.equals(activeColor)) ? activeColor : pickerColor;
  (0,hooks_useLayoutEffect/* default */.Z)(() => {
    setPickerColor(activeColor);
  }, [forceSync, activeColor === null || activeColor === void 0 ? void 0 : activeColor.toHexString()]);
  // ============================ Change ============================
  const fillColor = (nextColor, info) => {
    let submitColor = generateColor(nextColor);
    // Fill alpha color to 100% if origin is cleared color
    if (value.cleared) {
      const rgb = submitColor.toRgb();
      // Auto fill color if origin is `0/0/0` to enhance user experience
      if (!rgb.r && !rgb.g && !rgb.b && info) {
        const {
          type: infoType,
          value: infoValue = 0
        } = info;
        submitColor = new AggregationColor({
          h: infoType === 'hue' ? infoValue : 0,
          s: 1,
          b: 1,
          a: infoType === 'alpha' ? infoValue / 100 : 1
        });
      } else {
        submitColor = genAlphaColor(submitColor);
      }
    }
    if (mode === 'single') {
      return submitColor;
    }
    const nextColors = (0,toConsumableArray/* default */.Z)(colors);
    nextColors[activeIndex] = Object.assign(Object.assign({}, nextColors[activeIndex]), {
      color: submitColor
    });
    return new AggregationColor(nextColors);
  };
  const onPickerChange = (colorValue, fromPicker, info) => {
    const nextColor = fillColor(colorValue, info);
    setPickerColor(nextColor.isGradient() ? nextColor.getColors()[activeIndex].color : nextColor);
    onChange(nextColor, fromPicker);
  };
  const onInternalChangeComplete = (nextColor, info) => {
    // Trigger complete event
    onChangeComplete(fillColor(nextColor, info));
    // Back of origin color in case in controlled
    // This will set after `onChangeComplete` to avoid `setState` trigger rerender
    // which will make `fillColor` get wrong `color.cleared` state
    setForceSync(ori => ori + 1);
  };
  const onInputChange = colorValue => {
    onChange(fillColor(colorValue));
  };
  // ============================ Render ============================
  // Operation bar
  let operationNode = null;
  const showMode = modeOptions.length > 1;
  if (allowClear || showMode) {
    operationNode = /*#__PURE__*/react.createElement("div", {
      className: `${prefixCls}-operation`
    }, showMode && (/*#__PURE__*/react.createElement(segmented, {
      size: "small",
      options: modeOptions,
      value: mode,
      onChange: onModeChange
    })), /*#__PURE__*/react.createElement(components_ColorClear, Object.assign({
      prefixCls: prefixCls,
      value: value,
      onChange: clearColor => {
        onChange(clearColor);
        onClear === null || onClear === void 0 ? void 0 : onClear();
      }
    }, injectProps)));
  }
  // Return
  return /*#__PURE__*/react.createElement(react.Fragment, null, operationNode, /*#__PURE__*/react.createElement(PanelPicker_GradientColorBar, Object.assign({}, panelPickerContext, {
    colors: colors
  })), /*#__PURE__*/react.createElement(color_picker_es/* default */.ZP, {
    prefixCls: prefixCls,
    value: mergedPickerColor === null || mergedPickerColor === void 0 ? void 0 : mergedPickerColor.toHsb(),
    disabledAlpha: disabledAlpha,
    onChange: (colorValue, info) => {
      onPickerChange(colorValue, true, info);
    },
    onChangeComplete: (colorValue, info) => {
      onInternalChangeComplete(colorValue, info);
    },
    components: components
  }), /*#__PURE__*/react.createElement(components_ColorInput, Object.assign({
    value: activeColor,
    onChange: onInputChange,
    prefixCls: prefixCls,
    disabledAlpha: disabledAlpha
  }, injectProps)));
};
/* harmony default export */ var components_PanelPicker = (PanelPicker);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/components/PanelPresets.js
"use client";




const PanelPresets = () => {
  const {
    prefixCls,
    value,
    presets,
    onChange
  } = (0,react.useContext)(PanelPresetsContext);
  return Array.isArray(presets) ? (/*#__PURE__*/react.createElement(components_ColorPresets, {
    value: value,
    presets: presets,
    prefixCls: prefixCls,
    onChange: onChange
  })) : null;
};
/* harmony default export */ var components_PanelPresets = (PanelPresets);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/ColorPickerPanel.js
"use client";






const ColorPickerPanel = props => {
  const {
    prefixCls,
    presets,
    panelRender,
    value,
    onChange,
    onClear,
    allowClear,
    disabledAlpha,
    mode,
    onModeChange,
    modeOptions,
    onChangeComplete,
    activeIndex,
    onActive,
    format,
    onFormatChange,
    gradientDragging,
    onGradientDragging,
    disabledFormat
  } = props;
  const colorPickerPanelPrefixCls = `${prefixCls}-inner`;
  // ===================== Context ======================
  const panelContext = react.useMemo(() => ({
    prefixCls,
    value,
    onChange,
    onClear,
    allowClear,
    disabledAlpha,
    mode,
    onModeChange,
    modeOptions,
    onChangeComplete,
    activeIndex,
    onActive,
    format,
    onFormatChange,
    gradientDragging,
    onGradientDragging,
    disabledFormat
  }), [prefixCls, value, onChange, onClear, allowClear, disabledAlpha, mode, onModeChange, modeOptions, onChangeComplete, activeIndex, onActive, format, onFormatChange, gradientDragging, onGradientDragging, disabledFormat]);
  const presetContext = react.useMemo(() => ({
    prefixCls,
    value,
    presets,
    onChange
  }), [prefixCls, value, presets, onChange]);
  // ====================== Render ======================
  const innerPanel = /*#__PURE__*/react.createElement("div", {
    className: `${colorPickerPanelPrefixCls}-content`
  }, /*#__PURE__*/react.createElement(components_PanelPicker, null), Array.isArray(presets) && /*#__PURE__*/react.createElement(divider, null), /*#__PURE__*/react.createElement(components_PanelPresets, null));
  return /*#__PURE__*/react.createElement(PanelPickerContext.Provider, {
    value: panelContext
  }, /*#__PURE__*/react.createElement(PanelPresetsContext.Provider, {
    value: presetContext
  }, /*#__PURE__*/react.createElement("div", {
    className: colorPickerPanelPrefixCls
  }, typeof panelRender === 'function' ? panelRender(innerPanel, {
    components: {
      Picker: components_PanelPicker,
      Presets: components_PanelPresets
    }
  }) : innerPanel)));
};
if (false) {}
/* harmony default export */ var color_picker_ColorPickerPanel = (ColorPickerPanel);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/components/ColorTrigger.js
"use client";

var ColorTrigger_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







const ColorTrigger = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  const {
      color,
      prefixCls,
      open,
      disabled,
      format,
      className,
      showText,
      activeIndex
    } = props,
    rest = ColorTrigger_rest(props, ["color", "prefixCls", "open", "disabled", "format", "className", "showText", "activeIndex"]);
  const colorTriggerPrefixCls = `${prefixCls}-trigger`;
  const colorTextPrefixCls = `${colorTriggerPrefixCls}-text`;
  const colorTextCellPrefixCls = `${colorTextPrefixCls}-cell`;
  const [locale] = locale_useLocale('ColorPicker');
  // ============================== Text ==============================
  const desc = react.useMemo(() => {
    if (!showText) {
      return '';
    }
    if (typeof showText === 'function') {
      return showText(color);
    }
    if (color.cleared) {
      return locale.transparent;
    }
    if (color.isGradient()) {
      return color.getColors().map((c, index) => {
        const inactive = activeIndex !== -1 && activeIndex !== index;
        return /*#__PURE__*/react.createElement("span", {
          key: index,
          className: classnames_default()(colorTextCellPrefixCls, inactive && `${colorTextCellPrefixCls}-inactive`)
        }, c.color.toRgbString(), " ", c.percent, "%");
      });
    }
    const hexString = color.toHexString().toUpperCase();
    const alpha = getColorAlpha(color);
    switch (format) {
      case 'rgb':
        return color.toRgbString();
      case 'hsb':
        return color.toHsbString();
      // case 'hex':
      default:
        return alpha < 100 ? `${hexString.slice(0, 7)},${alpha}%` : hexString;
    }
  }, [color, format, showText, activeIndex]);
  // ============================= Render =============================
  const containerNode = (0,react.useMemo)(() => color.cleared ? (/*#__PURE__*/react.createElement(components_ColorClear, {
    prefixCls: prefixCls
  })) : (/*#__PURE__*/react.createElement(color_picker_es/* ColorBlock */.G5, {
    prefixCls: prefixCls,
    color: color.toCssString()
  })), [color, prefixCls]);
  return /*#__PURE__*/react.createElement("div", Object.assign({
    ref: ref,
    className: classnames_default()(colorTriggerPrefixCls, className, {
      [`${colorTriggerPrefixCls}-active`]: open,
      [`${colorTriggerPrefixCls}-disabled`]: disabled
    })
  }, (0,pickAttrs/* default */.Z)(rest)), containerNode, showText && /*#__PURE__*/react.createElement("div", {
    className: colorTextPrefixCls
  }, desc));
});
/* harmony default export */ var components_ColorTrigger = (ColorTrigger);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/hooks/useModeColor.js





/**
 * Combine the `color` and `mode` to make sure sync of state.
 */
function useModeColor(defaultValue, value, mode) {
  const [locale] = locale_useLocale('ColorPicker');
  // ======================== Base ========================
  // Color
  const [mergedColor, setMergedColor] = (0,useMergedState/* default */.Z)(defaultValue, {
    value
  });
  // Mode
  const [modeState, setModeState] = react.useState('single');
  const [modeOptionList, modeSet] = react.useMemo(() => {
    const list = (Array.isArray(mode) ? mode : [mode]).filter(m => m);
    if (!list.length) {
      list.push('single');
    }
    const modes = new Set(list);
    const optionList = [];
    const pushOption = (modeType, localeTxt) => {
      if (modes.has(modeType)) {
        optionList.push({
          label: localeTxt,
          value: modeType
        });
      }
    };
    pushOption('single', locale.singleColor);
    pushOption('gradient', locale.gradientColor);
    return [optionList, modes];
  }, [mode]);
  // ======================== Post ========================
  // We need align `mode` with `color` state
  // >>>>> Color
  const [cacheColor, setCacheColor] = react.useState(null);
  const setColor = (0,hooks_useEvent/* default */.Z)(nextColor => {
    setCacheColor(nextColor);
    setMergedColor(nextColor);
  });
  const postColor = react.useMemo(() => {
    const colorObj = generateColor(mergedColor || '');
    // Use `cacheColor` in case the color is `cleared`
    return colorObj.equals(cacheColor) ? cacheColor : colorObj;
  }, [mergedColor, cacheColor]);
  // >>>>> Mode
  const postMode = react.useMemo(() => {
    var _a;
    if (modeSet.has(modeState)) {
      return modeState;
    }
    return (_a = modeOptionList[0]) === null || _a === void 0 ? void 0 : _a.value;
  }, [modeSet, modeState, modeOptionList]);
  // ======================= Effect =======================
  // Dynamic update mode when color change
  react.useEffect(() => {
    setModeState(postColor.isGradient() ? 'gradient' : 'single');
  }, [postColor]);
  // ======================= Return =======================
  return [postColor, setColor, postMode, setModeState, modeOptionList];
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/style/color-block.js

/**
 * @private Internal usage only
 * see: https://developer.mozilla.org/en-US/docs/Web/CSS/gradient/conic-gradient#checkerboard
 */
const getTransBg = (size, colorFill) => ({
  backgroundImage: `conic-gradient(${colorFill} 25%, transparent 25% 50%, ${colorFill} 50% 75%, transparent 75% 100%)`,
  backgroundSize: `${size} ${size}`
});
const genColorBlockStyle = (token, size) => {
  const {
    componentCls,
    borderRadiusSM,
    colorPickerInsetShadow,
    lineWidth,
    colorFillSecondary
  } = token;
  return {
    [`${componentCls}-color-block`]: Object.assign(Object.assign({
      position: 'relative',
      borderRadius: borderRadiusSM,
      width: size,
      height: size,
      boxShadow: colorPickerInsetShadow,
      flex: 'none'
    }, getTransBg('50%', token.colorFillSecondary)), {
      [`${componentCls}-color-block-inner`]: {
        width: '100%',
        height: '100%',
        boxShadow: `inset 0 0 0 ${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${colorFillSecondary}`,
        borderRadius: 'inherit'
      }
    })
  };
};
/* harmony default export */ var color_block = (genColorBlockStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/style/input.js

const input_genInputStyle = token => {
  const {
    componentCls,
    antCls,
    fontSizeSM,
    lineHeightSM,
    colorPickerAlphaInputWidth,
    marginXXS,
    paddingXXS,
    controlHeightSM,
    marginXS,
    fontSizeIcon,
    paddingXS,
    colorTextPlaceholder,
    colorPickerInputNumberHandleWidth,
    lineWidth
  } = token;
  return {
    [`${componentCls}-input-container`]: {
      display: 'flex',
      [`${componentCls}-steppers${antCls}-input-number`]: {
        fontSize: fontSizeSM,
        lineHeight: lineHeightSM,
        [`${antCls}-input-number-input`]: {
          paddingInlineStart: paddingXXS,
          paddingInlineEnd: 0
        },
        [`${antCls}-input-number-handler-wrap`]: {
          width: colorPickerInputNumberHandleWidth
        }
      },
      [`${componentCls}-steppers${componentCls}-alpha-input`]: {
        flex: `0 0 ${(0,cssinjs_es/* unit */.bf)(colorPickerAlphaInputWidth)}`,
        marginInlineStart: marginXXS
      },
      [`${componentCls}-format-select${antCls}-select`]: {
        marginInlineEnd: marginXS,
        width: 'auto',
        '&-single': {
          [`${antCls}-select-selector`]: {
            padding: 0,
            border: 0
          },
          [`${antCls}-select-arrow`]: {
            insetInlineEnd: 0
          },
          [`${antCls}-select-selection-item`]: {
            paddingInlineEnd: token.calc(fontSizeIcon).add(marginXXS).equal(),
            fontSize: fontSizeSM,
            lineHeight: (0,cssinjs_es/* unit */.bf)(controlHeightSM)
          },
          [`${antCls}-select-item-option-content`]: {
            fontSize: fontSizeSM,
            lineHeight: lineHeightSM
          },
          [`${antCls}-select-dropdown`]: {
            [`${antCls}-select-item`]: {
              minHeight: 'auto'
            }
          }
        }
      },
      [`${componentCls}-input`]: {
        gap: marginXXS,
        alignItems: 'center',
        flex: 1,
        width: 0,
        [`${componentCls}-hsb-input,${componentCls}-rgb-input`]: {
          display: 'flex',
          gap: marginXXS,
          alignItems: 'center'
        },
        [`${componentCls}-steppers`]: {
          flex: 1
        },
        [`${componentCls}-hex-input${antCls}-input-affix-wrapper`]: {
          flex: 1,
          padding: `0 ${(0,cssinjs_es/* unit */.bf)(paddingXS)}`,
          [`${antCls}-input`]: {
            fontSize: fontSizeSM,
            textTransform: 'uppercase',
            lineHeight: (0,cssinjs_es/* unit */.bf)(token.calc(controlHeightSM).sub(token.calc(lineWidth).mul(2)).equal())
          },
          [`${antCls}-input-prefix`]: {
            color: colorTextPlaceholder
          }
        }
      }
    }
  };
};
/* harmony default export */ var input = (input_genInputStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/style/picker.js

const genPickerStyle = token => {
  const {
    componentCls,
    controlHeightLG,
    borderRadiusSM,
    colorPickerInsetShadow,
    marginSM,
    colorBgElevated,
    colorFillSecondary,
    lineWidthBold,
    colorPickerHandlerSize
  } = token;
  return {
    userSelect: 'none',
    [`${componentCls}-select`]: {
      [`${componentCls}-palette`]: {
        minHeight: token.calc(controlHeightLG).mul(4).equal(),
        overflow: 'hidden',
        borderRadius: borderRadiusSM
      },
      [`${componentCls}-saturation`]: {
        position: 'absolute',
        borderRadius: 'inherit',
        boxShadow: colorPickerInsetShadow,
        inset: 0
      },
      marginBottom: marginSM
    },
    // ======================== Panel =========================
    [`${componentCls}-handler`]: {
      width: colorPickerHandlerSize,
      height: colorPickerHandlerSize,
      border: `${(0,cssinjs_es/* unit */.bf)(lineWidthBold)} solid ${colorBgElevated}`,
      position: 'relative',
      borderRadius: '50%',
      cursor: 'pointer',
      boxShadow: `${colorPickerInsetShadow}, 0 0 0 1px ${colorFillSecondary}`
    }
  };
};
/* harmony default export */ var picker = (genPickerStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/style/presets.js

const genPresetsStyle = token => {
  const {
    componentCls,
    antCls,
    colorTextQuaternary,
    paddingXXS,
    colorPickerPresetColorSize,
    fontSizeSM,
    colorText,
    lineHeightSM,
    lineWidth,
    borderRadius,
    colorFill,
    colorWhite,
    marginXXS,
    paddingXS,
    fontHeightSM
  } = token;
  return {
    [`${componentCls}-presets`]: {
      [`${antCls}-collapse-item > ${antCls}-collapse-header`]: {
        padding: 0,
        [`${antCls}-collapse-expand-icon`]: {
          height: fontHeightSM,
          color: colorTextQuaternary,
          paddingInlineEnd: paddingXXS
        }
      },
      [`${antCls}-collapse`]: {
        display: 'flex',
        flexDirection: 'column',
        gap: marginXXS
      },
      [`${antCls}-collapse-item > ${antCls}-collapse-content > ${antCls}-collapse-content-box`]: {
        padding: `${(0,cssinjs_es/* unit */.bf)(paddingXS)} 0`
      },
      '&-label': {
        fontSize: fontSizeSM,
        color: colorText,
        lineHeight: lineHeightSM
      },
      '&-items': {
        display: 'flex',
        flexWrap: 'wrap',
        gap: token.calc(marginXXS).mul(1.5).equal(),
        [`${componentCls}-presets-color`]: {
          position: 'relative',
          cursor: 'pointer',
          width: colorPickerPresetColorSize,
          height: colorPickerPresetColorSize,
          '&::before': {
            content: '""',
            pointerEvents: 'none',
            width: token.calc(colorPickerPresetColorSize).add(token.calc(lineWidth).mul(4)).equal(),
            height: token.calc(colorPickerPresetColorSize).add(token.calc(lineWidth).mul(4)).equal(),
            position: 'absolute',
            top: token.calc(lineWidth).mul(-2).equal(),
            insetInlineStart: token.calc(lineWidth).mul(-2).equal(),
            borderRadius,
            border: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} solid transparent`,
            transition: `border-color ${token.motionDurationMid} ${token.motionEaseInBack}`
          },
          '&:hover::before': {
            borderColor: colorFill
          },
          '&::after': {
            boxSizing: 'border-box',
            position: 'absolute',
            top: '50%',
            insetInlineStart: '21.5%',
            display: 'table',
            width: token.calc(colorPickerPresetColorSize).div(13).mul(5).equal(),
            height: token.calc(colorPickerPresetColorSize).div(13).mul(8).equal(),
            border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidthBold)} solid ${token.colorWhite}`,
            borderTop: 0,
            borderInlineStart: 0,
            transform: 'rotate(45deg) scale(0) translate(-50%,-50%)',
            opacity: 0,
            content: '""',
            transition: `all ${token.motionDurationFast} ${token.motionEaseInBack}, opacity ${token.motionDurationFast}`
          },
          [`&${componentCls}-presets-color-checked`]: {
            '&::after': {
              opacity: 1,
              borderColor: colorWhite,
              transform: 'rotate(45deg) scale(1) translate(-50%,-50%)',
              transition: `transform ${token.motionDurationMid} ${token.motionEaseOutBack} ${token.motionDurationFast}`
            },
            [`&${componentCls}-presets-color-bright`]: {
              '&::after': {
                borderColor: 'rgba(0, 0, 0, 0.45)'
              }
            }
          }
        }
      },
      '&-empty': {
        fontSize: fontSizeSM,
        color: colorTextQuaternary
      }
    }
  };
};
/* harmony default export */ var presets = (genPresetsStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/style/slider.js


const genSliderStyle = token => {
  const {
    componentCls,
    colorPickerInsetShadow,
    colorBgElevated,
    colorFillSecondary,
    lineWidthBold,
    colorPickerHandlerSizeSM,
    colorPickerSliderHeight,
    marginSM,
    marginXS
  } = token;
  const handleInnerSize = token.calc(colorPickerHandlerSizeSM).sub(token.calc(lineWidthBold).mul(2).equal()).equal();
  const handleHoverSize = token.calc(colorPickerHandlerSizeSM).add(token.calc(lineWidthBold).mul(2).equal()).equal();
  const activeHandleStyle = {
    '&:after': {
      transform: 'scale(1)',
      boxShadow: `${colorPickerInsetShadow}, 0 0 0 1px ${token.colorPrimaryActive}`
    }
  };
  return {
    // ======================== Slider ========================
    [`${componentCls}-slider`]: [getTransBg((0,cssinjs_es/* unit */.bf)(colorPickerSliderHeight), token.colorFillSecondary), {
      margin: 0,
      padding: 0,
      height: colorPickerSliderHeight,
      borderRadius: token.calc(colorPickerSliderHeight).div(2).equal(),
      '&-rail': {
        height: colorPickerSliderHeight,
        borderRadius: token.calc(colorPickerSliderHeight).div(2).equal(),
        boxShadow: colorPickerInsetShadow
      },
      [`& ${componentCls}-slider-handle`]: {
        width: handleInnerSize,
        height: handleInnerSize,
        top: 0,
        borderRadius: '100%',
        '&:before': {
          display: 'block',
          position: 'absolute',
          background: 'transparent',
          left: {
            _skip_check_: true,
            value: '50%'
          },
          top: '50%',
          transform: 'translate(-50%, -50%)',
          width: handleHoverSize,
          height: handleHoverSize,
          borderRadius: '100%'
        },
        '&:after': {
          width: colorPickerHandlerSizeSM,
          height: colorPickerHandlerSizeSM,
          border: `${(0,cssinjs_es/* unit */.bf)(lineWidthBold)} solid ${colorBgElevated}`,
          boxShadow: `${colorPickerInsetShadow}, 0 0 0 1px ${colorFillSecondary}`,
          outline: 'none',
          insetInlineStart: token.calc(lineWidthBold).mul(-1).equal(),
          top: token.calc(lineWidthBold).mul(-1).equal(),
          background: 'transparent',
          transition: 'none'
        },
        '&:focus': activeHandleStyle
      }
    }],
    // ======================== Layout ========================
    [`${componentCls}-slider-container`]: {
      display: 'flex',
      gap: marginSM,
      marginBottom: marginSM,
      // Group
      [`${componentCls}-slider-group`]: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'space-between',
        display: 'flex',
        '&-disabled-alpha': {
          justifyContent: 'center'
        }
      }
    },
    [`${componentCls}-gradient-slider`]: {
      marginBottom: marginXS,
      [`& ${componentCls}-slider-handle`]: {
        '&:after': {
          transform: 'scale(0.8)'
        },
        '&-active, &:focus': activeHandleStyle
      }
    }
  };
};
/* harmony default export */ var style_slider = (genSliderStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/style/index.js








const style_genActiveStyle = (token, borderColor, outlineColor) => ({
  borderInlineEndWidth: token.lineWidth,
  borderColor,
  boxShadow: `0 0 0 ${(0,cssinjs_es/* unit */.bf)(token.controlOutlineWidth)} ${outlineColor}`,
  outline: 0
});
const style_genRtlStyle = token => {
  const {
    componentCls
  } = token;
  return {
    '&-rtl': {
      [`${componentCls}-presets-color`]: {
        '&::after': {
          direction: 'ltr'
        }
      },
      [`${componentCls}-clear`]: {
        '&::after': {
          direction: 'ltr'
        }
      }
    }
  };
};
const genClearStyle = (token, size, extraStyle) => {
  const {
    componentCls,
    borderRadiusSM,
    lineWidth,
    colorSplit,
    colorBorder,
    red6
  } = token;
  return {
    [`${componentCls}-clear`]: Object.assign(Object.assign({
      width: size,
      height: size,
      borderRadius: borderRadiusSM,
      border: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} solid ${colorSplit}`,
      position: 'relative',
      overflow: 'hidden',
      cursor: 'inherit',
      transition: `all ${token.motionDurationFast}`
    }, extraStyle), {
      '&::after': {
        content: '""',
        position: 'absolute',
        insetInlineEnd: token.calc(lineWidth).mul(-1).equal(),
        top: token.calc(lineWidth).mul(-1).equal(),
        display: 'block',
        width: 40,
        // maximum
        height: 2,
        // fixed
        transformOrigin: `calc(100% - 1px) 1px`,
        transform: 'rotate(-45deg)',
        backgroundColor: red6
      },
      '&:hover': {
        borderColor: colorBorder
      }
    })
  };
};
const style_genStatusStyle = token => {
  const {
    componentCls,
    colorError,
    colorWarning,
    colorErrorHover,
    colorWarningHover,
    colorErrorOutline,
    colorWarningOutline
  } = token;
  return {
    [`&${componentCls}-status-error`]: {
      borderColor: colorError,
      '&:hover': {
        borderColor: colorErrorHover
      },
      [`&${componentCls}-trigger-active`]: Object.assign({}, style_genActiveStyle(token, colorError, colorErrorOutline))
    },
    [`&${componentCls}-status-warning`]: {
      borderColor: colorWarning,
      '&:hover': {
        borderColor: colorWarningHover
      },
      [`&${componentCls}-trigger-active`]: Object.assign({}, style_genActiveStyle(token, colorWarning, colorWarningOutline))
    }
  };
};
const color_picker_style_genSizeStyle = token => {
  const {
    componentCls,
    controlHeightLG,
    controlHeightSM,
    controlHeight,
    controlHeightXS,
    borderRadius,
    borderRadiusSM,
    borderRadiusXS,
    borderRadiusLG,
    fontSizeLG
  } = token;
  return {
    [`&${componentCls}-lg`]: {
      minWidth: controlHeightLG,
      minHeight: controlHeightLG,
      borderRadius: borderRadiusLG,
      [`${componentCls}-color-block, ${componentCls}-clear`]: {
        width: controlHeight,
        height: controlHeight,
        borderRadius
      },
      [`${componentCls}-trigger-text`]: {
        fontSize: fontSizeLG
      }
    },
    [`&${componentCls}-sm`]: {
      minWidth: controlHeightSM,
      minHeight: controlHeightSM,
      borderRadius: borderRadiusSM,
      [`${componentCls}-color-block, ${componentCls}-clear`]: {
        width: controlHeightXS,
        height: controlHeightXS,
        borderRadius: borderRadiusXS
      },
      [`${componentCls}-trigger-text`]: {
        lineHeight: (0,cssinjs_es/* unit */.bf)(controlHeightXS)
      }
    }
  };
};
const genColorPickerStyle = token => {
  const {
    antCls,
    componentCls,
    colorPickerWidth,
    colorPrimary,
    motionDurationMid,
    colorBgElevated,
    colorTextDisabled,
    colorText,
    colorBgContainerDisabled,
    borderRadius,
    marginXS,
    marginSM,
    controlHeight,
    controlHeightSM,
    colorBgTextActive,
    colorPickerPresetColorSize,
    colorPickerPreviewSize,
    lineWidth,
    colorBorder,
    paddingXXS,
    fontSize,
    colorPrimaryHover,
    controlOutline
  } = token;
  return [{
    [componentCls]: Object.assign({
      [`${componentCls}-inner`]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        '&-content': {
          display: 'flex',
          flexDirection: 'column',
          width: colorPickerWidth,
          [`& > ${antCls}-divider`]: {
            margin: `${(0,cssinjs_es/* unit */.bf)(marginSM)} 0 ${(0,cssinjs_es/* unit */.bf)(marginXS)}`
          }
        },
        [`${componentCls}-panel`]: Object.assign({}, picker(token))
      }, style_slider(token)), color_block(token, colorPickerPreviewSize)), input(token)), presets(token)), genClearStyle(token, colorPickerPresetColorSize, {
        marginInlineStart: 'auto'
      })), {
        // Operation bar
        [`${componentCls}-operation`]: {
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: marginXS
        }
      }),
      '&-trigger': Object.assign(Object.assign(Object.assign(Object.assign({
        minWidth: controlHeight,
        minHeight: controlHeight,
        borderRadius,
        border: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} solid ${colorBorder}`,
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        transition: `all ${motionDurationMid}`,
        background: colorBgElevated,
        padding: token.calc(paddingXXS).sub(lineWidth).equal(),
        [`${componentCls}-trigger-text`]: {
          marginInlineStart: marginXS,
          marginInlineEnd: token.calc(marginXS).sub(token.calc(paddingXXS).sub(lineWidth)).equal(),
          fontSize,
          color: colorText,
          alignSelf: 'center',
          '&-cell': {
            '&:not(:last-child):after': {
              content: '", "'
            },
            '&-inactive': {
              color: colorTextDisabled
            }
          }
        },
        '&:hover': {
          borderColor: colorPrimaryHover
        },
        [`&${componentCls}-trigger-active`]: Object.assign({}, style_genActiveStyle(token, colorPrimary, controlOutline)),
        '&-disabled': {
          color: colorTextDisabled,
          background: colorBgContainerDisabled,
          cursor: 'not-allowed',
          '&:hover': {
            borderColor: colorBgTextActive
          },
          [`${componentCls}-trigger-text`]: {
            color: colorTextDisabled
          }
        }
      }, genClearStyle(token, controlHeightSM)), color_block(token, controlHeightSM)), style_genStatusStyle(token)), color_picker_style_genSizeStyle(token))
    }, style_genRtlStyle(token))
  }, genCompactItemStyle(token, {
    focusElCls: `${componentCls}-trigger-active`
  })];
};
/* harmony default export */ var color_picker_style = (genStyleHooks('ColorPicker', token => {
  const {
    colorTextQuaternary,
    marginSM
  } = token;
  const colorPickerSliderHeight = 8;
  const colorPickerToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    colorPickerWidth: 234,
    colorPickerHandlerSize: 16,
    colorPickerHandlerSizeSM: 12,
    colorPickerAlphaInputWidth: 44,
    colorPickerInputNumberHandleWidth: 16,
    colorPickerPresetColorSize: 24,
    colorPickerInsetShadow: `inset 0 0 1px 0 ${colorTextQuaternary}`,
    colorPickerSliderHeight,
    colorPickerPreviewSize: token.calc(colorPickerSliderHeight).mul(2).add(marginSM).equal()
  });
  return genColorPickerStyle(colorPickerToken);
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/ColorPicker.js
"use client";

var ColorPicker_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




















const ColorPicker = props => {
  const {
      mode,
      value,
      defaultValue,
      format,
      defaultFormat,
      allowClear = false,
      presets,
      children,
      trigger = 'click',
      open,
      disabled,
      placement = 'bottomLeft',
      arrow = true,
      panelRender,
      showText,
      style,
      className,
      size: customizeSize,
      rootClassName,
      prefixCls: customizePrefixCls,
      styles,
      disabledAlpha = false,
      onFormatChange,
      onChange,
      onClear,
      onOpenChange,
      onChangeComplete,
      getPopupContainer,
      autoAdjustOverflow = true,
      destroyTooltipOnHide,
      destroyOnHidden,
      disabledFormat
    } = props,
    rest = ColorPicker_rest(props, ["mode", "value", "defaultValue", "format", "defaultFormat", "allowClear", "presets", "children", "trigger", "open", "disabled", "placement", "arrow", "panelRender", "showText", "style", "className", "size", "rootClassName", "prefixCls", "styles", "disabledAlpha", "onFormatChange", "onChange", "onClear", "onOpenChange", "onChangeComplete", "getPopupContainer", "autoAdjustOverflow", "destroyTooltipOnHide", "destroyOnHidden", "disabledFormat"]);
  const {
    getPrefixCls,
    direction,
    colorPicker
  } = (0,react.useContext)(ConfigContext);
  const contextDisabled = (0,react.useContext)(config_provider_DisabledContext);
  const mergedDisabled = disabled !== null && disabled !== void 0 ? disabled : contextDisabled;
  const [popupOpen, setPopupOpen] = (0,useMergedState/* default */.Z)(false, {
    value: open,
    postState: openData => !mergedDisabled && openData,
    onChange: onOpenChange
  });
  const [formatValue, setFormatValue] = (0,useMergedState/* default */.Z)(format, {
    value: format,
    defaultValue: defaultFormat,
    onChange: onFormatChange
  });
  const prefixCls = getPrefixCls('color-picker', customizePrefixCls);
  // ================== Value & Mode =================
  const [mergedColor, setColor, modeState, setModeState, modeOptions] = useModeColor(defaultValue, value, mode);
  const isAlphaColor = (0,react.useMemo)(() => getColorAlpha(mergedColor) < 100, [mergedColor]);
  // ==================== Change =====================
  // To enhance user experience, we cache the gradient color when switch from gradient to single
  // If user not modify single color, we will use the cached gradient color.
  const [cachedGradientColor, setCachedGradientColor] = react.useState(null);
  const onInternalChangeComplete = color => {
    if (onChangeComplete) {
      let changeColor = generateColor(color);
      // ignore alpha color
      if (disabledAlpha && isAlphaColor) {
        changeColor = genAlphaColor(color);
      }
      onChangeComplete(changeColor);
    }
  };
  const onInternalChange = (data, changeFromPickerDrag) => {
    let color = generateColor(data);
    // ignore alpha color
    if (disabledAlpha && isAlphaColor) {
      color = genAlphaColor(color);
    }
    setColor(color);
    setCachedGradientColor(null);
    // Trigger change event
    if (onChange) {
      onChange(color, color.toCssString());
    }
    // Only for drag-and-drop color picking
    if (!changeFromPickerDrag) {
      onInternalChangeComplete(color);
    }
  };
  // =================== Gradient ====================
  const [activeIndex, setActiveIndex] = react.useState(0);
  const [gradientDragging, setGradientDragging] = react.useState(false);
  // Mode change should also trigger color change
  const onInternalModeChange = newMode => {
    setModeState(newMode);
    if (newMode === 'single' && mergedColor.isGradient()) {
      setActiveIndex(0);
      onInternalChange(new AggregationColor(mergedColor.getColors()[0].color));
      // Should after `onInternalChange` since it will clear the cached color
      setCachedGradientColor(mergedColor);
    } else if (newMode === 'gradient' && !mergedColor.isGradient()) {
      const baseColor = isAlphaColor ? genAlphaColor(mergedColor) : mergedColor;
      onInternalChange(new AggregationColor(cachedGradientColor || [{
        percent: 0,
        color: baseColor
      }, {
        percent: 100,
        color: baseColor
      }]));
    }
  };
  // ================== Form Status ==================
  const {
    status: contextStatus
  } = react.useContext(FormItemInputContext);
  // ==================== Compact ====================
  const {
    compactSize,
    compactItemClassnames
  } = useCompactItemContext(prefixCls, direction);
  // ===================== Style =====================
  const mergedSize = hooks_useSize(ctx => {
    var _a;
    return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
  });
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = color_picker_style(prefixCls, rootCls);
  const rtlCls = {
    [`${prefixCls}-rtl`]: direction
  };
  const mergedRootCls = classnames_default()(rootClassName, cssVarCls, rootCls, rtlCls);
  const mergedCls = classnames_default()(getStatusClassNames(prefixCls, contextStatus), {
    [`${prefixCls}-sm`]: mergedSize === 'small',
    [`${prefixCls}-lg`]: mergedSize === 'large'
  }, compactItemClassnames, colorPicker === null || colorPicker === void 0 ? void 0 : colorPicker.className, mergedRootCls, className, hashId);
  const mergedPopupCls = classnames_default()(prefixCls, mergedRootCls);
  // ===================== Warning ======================
  if (false) {}
  const popoverProps = {
    open: popupOpen,
    trigger,
    placement,
    arrow,
    rootClassName,
    getPopupContainer,
    autoAdjustOverflow,
    destroyOnHidden: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : !!destroyTooltipOnHide
  };
  const mergedStyle = Object.assign(Object.assign({}, colorPicker === null || colorPicker === void 0 ? void 0 : colorPicker.style), style);
  // ============================ zIndex ============================
  return wrapCSSVar(/*#__PURE__*/react.createElement(popover, Object.assign({
    style: styles === null || styles === void 0 ? void 0 : styles.popup,
    styles: {
      body: styles === null || styles === void 0 ? void 0 : styles.popupOverlayInner
    },
    onOpenChange: visible => {
      if (!visible || !mergedDisabled) {
        setPopupOpen(visible);
      }
    },
    content: /*#__PURE__*/react.createElement(_util_ContextIsolator, {
      form: true
    }, /*#__PURE__*/react.createElement(color_picker_ColorPickerPanel, {
      mode: modeState,
      onModeChange: onInternalModeChange,
      modeOptions: modeOptions,
      prefixCls: prefixCls,
      value: mergedColor,
      allowClear: allowClear,
      disabled: mergedDisabled,
      disabledAlpha: disabledAlpha,
      presets: presets,
      panelRender: panelRender,
      format: formatValue,
      onFormatChange: setFormatValue,
      onChange: onInternalChange,
      onChangeComplete: onInternalChangeComplete,
      onClear: onClear,
      activeIndex: activeIndex,
      onActive: setActiveIndex,
      gradientDragging: gradientDragging,
      onGradientDragging: setGradientDragging,
      disabledFormat: disabledFormat
    })),
    classNames: {
      root: mergedPopupCls
    }
  }, popoverProps), children || (/*#__PURE__*/react.createElement(components_ColorTrigger, Object.assign({
    activeIndex: popupOpen ? activeIndex : -1,
    open: popupOpen,
    className: mergedCls,
    style: mergedStyle,
    prefixCls: prefixCls,
    disabled: mergedDisabled,
    showText: showText,
    format: formatValue
  }, rest, {
    color: mergedColor
  })))));
};
if (false) {}
const ColorPicker_PurePanel = _util_PurePanel(ColorPicker, undefined, props => Object.assign(Object.assign({}, props), {
  placement: 'bottom',
  autoAdjustOverflow: false
}), 'color-picker', /* istanbul ignore next */
prefixCls => prefixCls);
ColorPicker._InternalPanelDoNotUseOrYouWillBeFired = ColorPicker_PurePanel;
/* harmony default export */ var color_picker_ColorPicker = (ColorPicker);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/color-picker/index.js
"use client";


/* harmony default export */ var color_picker = (color_picker_ColorPicker);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CalendarOutlined.js + 1 modules
var CalendarOutlined = __webpack_require__(9974);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/ClockCircleOutlined.js + 1 modules
var ClockCircleOutlined = __webpack_require__(7243);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/SwapRightOutlined.js + 1 modules
var SwapRightOutlined = __webpack_require__(55056);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/date-picker/style/multiple.js



const genSize = (token, suffix) => {
  const {
    componentCls,
    controlHeight
  } = token;
  const suffixCls = suffix ? `${componentCls}-${suffix}` : '';
  const multipleSelectorUnit = getMultipleSelectorUnit(token);
  return [
  // genSelectionStyle(token, suffix),
  {
    [`${componentCls}-multiple${suffixCls}`]: {
      paddingBlock: multipleSelectorUnit.containerPadding,
      paddingInlineStart: multipleSelectorUnit.basePadding,
      minHeight: controlHeight,
      // ======================== Selections ========================
      [`${componentCls}-selection-item`]: {
        height: multipleSelectorUnit.itemHeight,
        lineHeight: (0,cssinjs_es/* unit */.bf)(multipleSelectorUnit.itemLineHeight)
      }
    }
  }];
};
const genPickerMultipleStyle = token => {
  const {
    componentCls,
    calc,
    lineWidth
  } = token;
  const smallToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    fontHeight: token.fontSize,
    selectHeight: token.controlHeightSM,
    multipleSelectItemHeight: token.multipleItemHeightSM,
    borderRadius: token.borderRadiusSM,
    borderRadiusSM: token.borderRadiusXS,
    controlHeight: token.controlHeightSM
  });
  const largeToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    fontHeight: calc(token.multipleItemHeightLG).sub(calc(lineWidth).mul(2).equal()).equal(),
    fontSize: token.fontSizeLG,
    selectHeight: token.controlHeightLG,
    multipleSelectItemHeight: token.multipleItemHeightLG,
    borderRadius: token.borderRadiusLG,
    borderRadiusSM: token.borderRadius,
    controlHeight: token.controlHeightLG
  });
  return [
  // ======================== Size ========================
  genSize(smallToken, 'small'), genSize(token), genSize(largeToken, 'large'),
  // ====================== Selection ======================
  {
    [`${componentCls}${componentCls}-multiple`]: Object.assign(Object.assign({
      width: '100%',
      cursor: 'text',
      // ==================== Selector =====================
      [`${componentCls}-selector`]: {
        flex: 'auto',
        padding: 0,
        position: 'relative',
        '&:after': {
          margin: 0
        },
        // ================== placeholder ==================
        [`${componentCls}-selection-placeholder`]: {
          position: 'absolute',
          top: '50%',
          insetInlineStart: token.inputPaddingHorizontalBase,
          insetInlineEnd: 0,
          transform: 'translateY(-50%)',
          transition: `all ${token.motionDurationSlow}`,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          flex: 1,
          color: token.colorTextPlaceholder,
          pointerEvents: 'none'
        }
      }
    }, genOverflowStyle(token)), {
      // ====================== Input ======================
      // Input is `readonly`, which is used for a11y only
      [`${componentCls}-multiple-input`]: {
        width: 0,
        height: 0,
        border: 0,
        visibility: 'hidden',
        position: 'absolute',
        zIndex: -1
      }
    })
  }];
};
/* harmony default export */ var style_multiple = (genPickerMultipleStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/date-picker/style/variants.js


const variants_genVariantsStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [componentCls]: [Object.assign(Object.assign(Object.assign(Object.assign({}, variants_genOutlinedStyle(token)), variants_genUnderlinedStyle(token)), variants_genFilledStyle(token)), style_variants_genBorderlessStyle(token)),
    // ========================= Multiple =========================
    {
      '&-outlined': {
        [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
          background: token.multipleItemBg,
          border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
        }
      },
      '&-filled': {
        [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
          background: token.colorBgContainer,
          border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
        }
      },
      '&-borderless': {
        [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
          background: token.multipleItemBg,
          border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
        }
      },
      '&-underlined': {
        [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
          background: token.multipleItemBg,
          border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
        }
      }
    }]
  };
};
/* harmony default export */ var style_variants = (variants_genVariantsStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/date-picker/style/index.js












const genPickerPadding = (paddingBlock, paddingInline) => {
  return {
    padding: `${(0,cssinjs_es/* unit */.bf)(paddingBlock)} ${(0,cssinjs_es/* unit */.bf)(paddingInline)}`
  };
};
const genPickerStatusStyle = token => {
  const {
    componentCls,
    colorError,
    colorWarning
  } = token;
  return {
    [`${componentCls}:not(${componentCls}-disabled):not([disabled])`]: {
      [`&${componentCls}-status-error`]: {
        [`${componentCls}-active-bar`]: {
          background: colorError
        }
      },
      [`&${componentCls}-status-warning`]: {
        [`${componentCls}-active-bar`]: {
          background: colorWarning
        }
      }
    }
  };
};
const style_genPickerStyle = token => {
  var _a;
  const {
    componentCls,
    antCls,
    paddingInline,
    lineWidth,
    lineType,
    colorBorder,
    borderRadius,
    motionDurationMid,
    colorTextDisabled,
    colorTextPlaceholder,
    fontSizeLG,
    inputFontSizeLG,
    fontSizeSM,
    inputFontSizeSM,
    controlHeightSM,
    paddingInlineSM,
    paddingXS,
    marginXS,
    colorIcon,
    lineWidthBold,
    colorPrimary,
    motionDurationSlow,
    zIndexPopup,
    paddingXXS,
    sizePopupArrow,
    colorBgElevated,
    borderRadiusLG,
    boxShadowSecondary,
    borderRadiusSM,
    colorSplit,
    cellHoverBg,
    presetsWidth,
    presetsMaxWidth,
    boxShadowPopoverArrow,
    fontHeight,
    lineHeightLG
  } = token;
  return [{
    [componentCls]: Object.assign(Object.assign(Object.assign({}, resetComponent(token)), genPickerPadding(token.paddingBlock, token.paddingInline)), {
      position: 'relative',
      display: 'inline-flex',
      alignItems: 'center',
      lineHeight: 1,
      borderRadius,
      transition: `border ${motionDurationMid}, box-shadow ${motionDurationMid}, background ${motionDurationMid}`,
      [`${componentCls}-prefix`]: {
        flex: '0 0 auto',
        marginInlineEnd: token.inputAffixPadding
      },
      // ======================== Input =========================
      [`${componentCls}-input`]: {
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        width: '100%',
        '> input': Object.assign(Object.assign({
          position: 'relative',
          display: 'inline-block',
          width: '100%',
          color: 'inherit',
          fontSize: (_a = token.inputFontSize) !== null && _a !== void 0 ? _a : token.fontSize,
          lineHeight: token.lineHeight,
          transition: `all ${motionDurationMid}`
        }, genPlaceholderStyle(colorTextPlaceholder)), {
          flex: 'auto',
          // Fix Firefox flex not correct:
          // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
          minWidth: 1,
          height: 'auto',
          padding: 0,
          background: 'transparent',
          border: 0,
          fontFamily: 'inherit',
          '&:focus': {
            boxShadow: 'none',
            outline: 0
          },
          '&[disabled]': {
            background: 'transparent',
            color: colorTextDisabled,
            cursor: 'not-allowed'
          }
        }),
        '&-placeholder': {
          '> input': {
            color: colorTextPlaceholder
          }
        }
      },
      // Size
      '&-large': Object.assign(Object.assign({}, genPickerPadding(token.paddingBlockLG, token.paddingInlineLG)), {
        [`${componentCls}-input > input`]: {
          fontSize: inputFontSizeLG !== null && inputFontSizeLG !== void 0 ? inputFontSizeLG : fontSizeLG,
          lineHeight: lineHeightLG
        }
      }),
      '&-small': Object.assign(Object.assign({}, genPickerPadding(token.paddingBlockSM, token.paddingInlineSM)), {
        [`${componentCls}-input > input`]: {
          fontSize: inputFontSizeSM !== null && inputFontSizeSM !== void 0 ? inputFontSizeSM : fontSizeSM
        }
      }),
      [`${componentCls}-suffix`]: {
        display: 'flex',
        flex: 'none',
        alignSelf: 'center',
        marginInlineStart: token.calc(paddingXS).div(2).equal(),
        color: colorTextDisabled,
        lineHeight: 1,
        pointerEvents: 'none',
        transition: `opacity ${motionDurationMid}, color ${motionDurationMid}`,
        '> *': {
          verticalAlign: 'top',
          '&:not(:last-child)': {
            marginInlineEnd: marginXS
          }
        }
      },
      [`${componentCls}-clear`]: {
        position: 'absolute',
        top: '50%',
        insetInlineEnd: 0,
        color: colorTextDisabled,
        lineHeight: 1,
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        opacity: 0,
        transition: `opacity ${motionDurationMid}, color ${motionDurationMid}`,
        '> *': {
          verticalAlign: 'top'
        },
        '&:hover': {
          color: colorIcon
        }
      },
      '&:hover': {
        [`${componentCls}-clear`]: {
          opacity: 1
        },
        // Should use the following selector, but since `:has` has poor compatibility,
        // we use `:not(:last-child)` instead, which may cause some problems in some cases.
        // [`${componentCls}-suffix:has(+ ${componentCls}-clear)`]: {
        [`${componentCls}-suffix:not(:last-child)`]: {
          opacity: 0
        }
      },
      [`${componentCls}-separator`]: {
        position: 'relative',
        display: 'inline-block',
        width: '1em',
        height: fontSizeLG,
        color: colorTextDisabled,
        fontSize: fontSizeLG,
        verticalAlign: 'top',
        cursor: 'default',
        [`${componentCls}-focused &`]: {
          color: colorIcon
        },
        [`${componentCls}-range-separator &`]: {
          [`${componentCls}-disabled &`]: {
            cursor: 'not-allowed'
          }
        }
      },
      // ======================== Range =========================
      '&-range': {
        position: 'relative',
        display: 'inline-flex',
        // Active bar
        [`${componentCls}-active-bar`]: {
          bottom: token.calc(lineWidth).mul(-1).equal(),
          height: lineWidthBold,
          background: colorPrimary,
          opacity: 0,
          transition: `all ${motionDurationSlow} ease-out`,
          pointerEvents: 'none'
        },
        [`&${componentCls}-focused`]: {
          [`${componentCls}-active-bar`]: {
            opacity: 1
          }
        },
        [`${componentCls}-range-separator`]: {
          alignItems: 'center',
          padding: `0 ${(0,cssinjs_es/* unit */.bf)(paddingXS)}`,
          lineHeight: 1
        }
      },
      // ======================== Clear =========================
      '&-range, &-multiple': {
        // Clear
        [`${componentCls}-clear`]: {
          insetInlineEnd: paddingInline
        },
        [`&${componentCls}-small`]: {
          [`${componentCls}-clear`]: {
            insetInlineEnd: paddingInlineSM
          }
        }
      },
      // ======================= Dropdown =======================
      '&-dropdown': Object.assign(Object.assign(Object.assign({}, resetComponent(token)), genPanelStyle(token)), {
        pointerEvents: 'none',
        position: 'absolute',
        // Fix incorrect position of picker popup
        // https://github.com/ant-design/ant-design/issues/35590
        top: -9999,
        left: {
          _skip_check_: true,
          value: -9999
        },
        zIndex: zIndexPopup,
        [`&${componentCls}-dropdown-hidden`]: {
          display: 'none'
        },
        '&-rtl': {
          direction: 'rtl'
        },
        [`&${componentCls}-dropdown-placement-bottomLeft,
            &${componentCls}-dropdown-placement-bottomRight`]: {
          [`${componentCls}-range-arrow`]: {
            top: 0,
            display: 'block',
            transform: 'translateY(-100%)'
          }
        },
        [`&${componentCls}-dropdown-placement-topLeft,
            &${componentCls}-dropdown-placement-topRight`]: {
          [`${componentCls}-range-arrow`]: {
            bottom: 0,
            display: 'block',
            transform: 'translateY(100%) rotate(180deg)'
          }
        },
        [`&${antCls}-slide-up-appear, &${antCls}-slide-up-enter`]: {
          [`${componentCls}-range-arrow${componentCls}-range-arrow`]: {
            transition: 'none'
          }
        },
        [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-topLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-topRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-topLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-topRight`]: {
          animationName: slideDownIn
        },
        [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-bottomLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-bottomRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-bottomLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-bottomRight`]: {
          animationName: slideUpIn
        },
        // https://github.com/ant-design/ant-design/issues/48727
        [`&${antCls}-slide-up-leave ${componentCls}-panel-container`]: {
          pointerEvents: 'none'
        },
        [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-topLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-topRight`]: {
          animationName: slideDownOut
        },
        [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-bottomLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-bottomRight`]: {
          animationName: slideUpOut
        },
        // Time picker with additional style
        [`${componentCls}-panel > ${componentCls}-time-panel`]: {
          paddingTop: paddingXXS
        },
        // ======================== Ranges ========================
        [`${componentCls}-range-wrapper`]: {
          display: 'flex',
          position: 'relative'
        },
        [`${componentCls}-range-arrow`]: Object.assign(Object.assign({
          position: 'absolute',
          zIndex: 1,
          display: 'none',
          paddingInline: token.calc(paddingInline).mul(1.5).equal(),
          boxSizing: 'content-box',
          transition: `all ${motionDurationSlow} ease-out`
        }, genRoundedArrow(token, colorBgElevated, boxShadowPopoverArrow)), {
          '&:before': {
            insetInlineStart: token.calc(paddingInline).mul(1.5).equal()
          }
        }),
        [`${componentCls}-panel-container`]: {
          overflow: 'hidden',
          verticalAlign: 'top',
          background: colorBgElevated,
          borderRadius: borderRadiusLG,
          boxShadow: boxShadowSecondary,
          transition: `margin ${motionDurationSlow}`,
          display: 'inline-block',
          pointerEvents: 'auto',
          // ======================== Layout ========================
          [`${componentCls}-panel-layout`]: {
            display: 'flex',
            flexWrap: 'nowrap',
            alignItems: 'stretch'
          },
          // ======================== Preset ========================
          [`${componentCls}-presets`]: {
            display: 'flex',
            flexDirection: 'column',
            minWidth: presetsWidth,
            maxWidth: presetsMaxWidth,
            ul: {
              height: 0,
              flex: 'auto',
              listStyle: 'none',
              overflow: 'auto',
              margin: 0,
              padding: paddingXS,
              borderInlineEnd: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${colorSplit}`,
              li: Object.assign(Object.assign({}, textEllipsis), {
                borderRadius: borderRadiusSM,
                paddingInline: paddingXS,
                paddingBlock: token.calc(controlHeightSM).sub(fontHeight).div(2).equal(),
                cursor: 'pointer',
                transition: `all ${motionDurationSlow}`,
                '+ li': {
                  marginTop: marginXS
                },
                '&:hover': {
                  background: cellHoverBg
                }
              })
            }
          },
          // ======================== Panels ========================
          [`${componentCls}-panels`]: {
            display: 'inline-flex',
            flexWrap: 'nowrap',
            // [`${componentCls}-panel`]: {
            //   borderWidth: `0 0 ${unit(lineWidth)}`,
            // },
            '&:last-child': {
              [`${componentCls}-panel`]: {
                borderWidth: 0
              }
            }
          },
          [`${componentCls}-panel`]: {
            verticalAlign: 'top',
            background: 'transparent',
            borderRadius: 0,
            borderWidth: 0,
            [`${componentCls}-content, table`]: {
              textAlign: 'center'
            },
            '&-focused': {
              borderColor: colorBorder
            }
          }
        }
      }),
      '&-dropdown-range': {
        padding: `${(0,cssinjs_es/* unit */.bf)(token.calc(sizePopupArrow).mul(2).div(3).equal())} 0`,
        '&-hidden': {
          display: 'none'
        }
      },
      '&-rtl': {
        direction: 'rtl',
        [`${componentCls}-separator`]: {
          transform: 'scale(-1, 1)'
        },
        [`${componentCls}-footer`]: {
          '&-extra': {
            direction: 'rtl'
          }
        }
      }
    })
  },
  // Follow code may reuse in other components
  initSlideMotion(token, 'slide-up'), initSlideMotion(token, 'slide-down'), initMoveMotion(token, 'move-up'), initMoveMotion(token, 'move-down')];
};
// ============================== Export ==============================
/* harmony default export */ var date_picker_style = (genStyleHooks('DatePicker', token => {
  const pickerToken = (0,cssinjs_utils_es/* mergeToken */.IX)(initInputToken(token), initPickerPanelToken(token), {
    inputPaddingHorizontalBase: token.calc(token.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: token.multipleItemHeight,
    selectHeight: token.controlHeight
  });
  return [panel(pickerToken), style_genPickerStyle(pickerToken), style_variants(pickerToken), genPickerStatusStyle(pickerToken), style_multiple(pickerToken),
  // =====================================================
  // ==             Space Compact                       ==
  // =====================================================
  genCompactItemStyle(token, {
    focusElCls: `${token.componentCls}-focused`
  })];
}, date_picker_style_token_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/date-picker/util.js


function getPlaceholder(locale, picker, customizePlaceholder) {
  if (customizePlaceholder !== undefined) {
    return customizePlaceholder;
  }
  if (picker === 'year' && locale.lang.yearPlaceholder) {
    return locale.lang.yearPlaceholder;
  }
  if (picker === 'quarter' && locale.lang.quarterPlaceholder) {
    return locale.lang.quarterPlaceholder;
  }
  if (picker === 'month' && locale.lang.monthPlaceholder) {
    return locale.lang.monthPlaceholder;
  }
  if (picker === 'week' && locale.lang.weekPlaceholder) {
    return locale.lang.weekPlaceholder;
  }
  if (picker === 'time' && locale.timePickerLocale.placeholder) {
    return locale.timePickerLocale.placeholder;
  }
  return locale.lang.placeholder;
}
function getRangePlaceholder(locale, picker, customizePlaceholder) {
  if (customizePlaceholder !== undefined) {
    return customizePlaceholder;
  }
  if (picker === 'year' && locale.lang.yearPlaceholder) {
    return locale.lang.rangeYearPlaceholder;
  }
  if (picker === 'quarter' && locale.lang.quarterPlaceholder) {
    return locale.lang.rangeQuarterPlaceholder;
  }
  if (picker === 'month' && locale.lang.monthPlaceholder) {
    return locale.lang.rangeMonthPlaceholder;
  }
  if (picker === 'week' && locale.lang.weekPlaceholder) {
    return locale.lang.rangeWeekPlaceholder;
  }
  if (picker === 'time' && locale.timePickerLocale.placeholder) {
    return locale.timePickerLocale.rangePlaceholder;
  }
  return locale.lang.rangePlaceholder;
}
function util_useIcons(props, prefixCls) {
  const {
    allowClear = true
  } = props;
  const {
    clearIcon,
    removeIcon
  } = useIcons(Object.assign(Object.assign({}, props), {
    prefixCls,
    componentName: 'DatePicker'
  }));
  const mergedAllowClear = react.useMemo(() => {
    if (allowClear === false) {
      return false;
    }
    const allowClearConfig = allowClear === true ? {} : allowClear;
    return Object.assign({
      clearIcon: clearIcon
    }, allowClearConfig);
  }, [allowClear, clearIcon]);
  return [mergedAllowClear, removeIcon];
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/date-picker/generatePicker/constant.js
const [WEEK, WEEKPICKER] = ['week', 'WeekPicker'];
const [MONTH, MONTHPICKER] = ['month', 'MonthPicker'];
const [YEAR, YEARPICKER] = ['year', 'YearPicker'];
const [QUARTER, QUARTERPICKER] = ['quarter', 'QuarterPicker'];
const [TIME, TIMEPICKER] = ['time', 'TimePicker'];
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/date-picker/PickerButton.js
"use client";



const PickerButton = props => (/*#__PURE__*/react.createElement(es_button, Object.assign({
  size: "small",
  type: "primary"
}, props)));
/* harmony default export */ var date_picker_PickerButton = (PickerButton);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/date-picker/generatePicker/useComponents.js


function useComponents(components) {
  return (0,react.useMemo)(() => Object.assign({
    button: date_picker_PickerButton
  }, components), [components]);
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/hooks/useMergeSemantic/index.js



// ========================= ClassNames =========================
function mergeClassNames(schema, ...classNames) {
  const mergedSchema = schema || {};
  return classNames.reduce((acc, cur) => {
    // Loop keys of the current classNames
    Object.keys(cur || {}).forEach(key => {
      const keySchema = mergedSchema[key];
      const curVal = cur[key];
      if (keySchema && typeof keySchema === 'object') {
        if (curVal && typeof curVal === 'object') {
          // Loop fill
          acc[key] = mergeClassNames(keySchema, acc[key], curVal);
        } else {
          // Covert string to object structure
          const {
            _default: defaultField
          } = keySchema;
          acc[key] = acc[key] || {};
          acc[key][defaultField] = classnames_default()(acc[key][defaultField], curVal);
        }
      } else {
        // Flatten fill
        acc[key] = classnames_default()(acc[key], curVal);
      }
    });
    return acc;
  }, {});
}
function useSemanticClassNames(schema, ...classNames) {
  return react.useMemo(() => mergeClassNames.apply(void 0, [schema].concat(classNames)), [classNames]);
}
// =========================== Styles ===========================
function useSemanticStyles(...styles) {
  return react.useMemo(() => {
    return styles.reduce((acc, cur = {}) => {
      Object.keys(cur).forEach(key => {
        acc[key] = Object.assign(Object.assign({}, acc[key]), cur[key]);
      });
      return acc;
    }, {});
  }, [styles]);
}
// =========================== Export ===========================
function fillObjectBySchema(obj, schema) {
  const newObj = Object.assign({}, obj);
  Object.keys(schema).forEach(key => {
    if (key !== '_default') {
      const nestSchema = schema[key];
      const nextValue = newObj[key] || {};
      newObj[key] = nestSchema ? fillObjectBySchema(nextValue, nestSchema) : nextValue;
    }
  });
  return newObj;
}
/**
 * Merge classNames and styles from multiple sources.
 * When `schema` is provided, it will **must** provide the nest object structure.
 */
function useMergeSemantic(classNamesList, stylesList, schema) {
  const mergedClassNames = useSemanticClassNames.apply(void 0, [schema].concat((0,toConsumableArray/* default */.Z)(classNamesList)));
  const mergedStyles = useSemanticStyles.apply(void 0, (0,toConsumableArray/* default */.Z)(stylesList));
  return react.useMemo(() => {
    return [fillObjectBySchema(mergedClassNames, schema), fillObjectBySchema(mergedStyles, schema)];
  }, [mergedClassNames, mergedStyles]);
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/date-picker/hooks/useMergedPickerSemantic.js




const useMergedPickerSemantic = (pickerType, classNames, styles, popupClassName, popupStyle) => {
  const {
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig(pickerType);
  const [mergedClassNames, mergedStyles] = useMergeSemantic([contextClassNames, classNames], [contextStyles, styles], {
    popup: {
      _default: 'root'
    }
  });
  return react.useMemo(() => {
    var _a, _b;
    // ClassNames
    const filledClassNames = Object.assign(Object.assign({}, mergedClassNames), {
      popup: Object.assign(Object.assign({}, mergedClassNames.popup), {
        root: classnames_default()((_a = mergedClassNames.popup) === null || _a === void 0 ? void 0 : _a.root, popupClassName)
      })
    });
    // Styles
    const filledStyles = Object.assign(Object.assign({}, mergedStyles), {
      popup: Object.assign(Object.assign({}, mergedStyles.popup), {
        root: Object.assign(Object.assign({}, (_b = mergedStyles.popup) === null || _b === void 0 ? void 0 : _b.root), popupStyle)
      })
    });
    // Return
    return [filledClassNames, filledStyles];
  }, [mergedClassNames, mergedStyles, popupClassName, popupStyle]);
};
/* harmony default export */ var hooks_useMergedPickerSemantic = (useMergedPickerSemantic);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/date-picker/generatePicker/generateRangePicker.js
"use client";

var generateRangePicker_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

























const generateRangePicker = generateConfig => {
  const RangePicker = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
    var _a;
    const {
        prefixCls: customizePrefixCls,
        getPopupContainer: customGetPopupContainer,
        components,
        className,
        style,
        placement,
        size: customizeSize,
        disabled: customDisabled,
        bordered = true,
        placeholder,
        popupStyle,
        popupClassName,
        dropdownClassName,
        status: customStatus,
        rootClassName,
        variant: customVariant,
        picker,
        styles,
        classNames
      } = props,
      restProps = generateRangePicker_rest(props, ["prefixCls", "getPopupContainer", "components", "className", "style", "placement", "size", "disabled", "bordered", "placeholder", "popupStyle", "popupClassName", "dropdownClassName", "status", "rootClassName", "variant", "picker", "styles", "classNames"]);
    const pickerType = picker === TIME ? 'timePicker' : 'datePicker';
    const innerRef = react.useRef(null);
    const {
      getPrefixCls,
      direction,
      getPopupContainer,
      rangePicker
    } = (0,react.useContext)(ConfigContext);
    const prefixCls = getPrefixCls('picker', customizePrefixCls);
    const {
      compactSize,
      compactItemClassnames
    } = useCompactItemContext(prefixCls, direction);
    const rootPrefixCls = getPrefixCls();
    const [variant, enableVariantCls] = useVariants('rangePicker', customVariant, bordered);
    const rootCls = hooks_useCSSVarCls(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = date_picker_style(prefixCls, rootCls);
    // =================== Warning =====================
    if (false) {}
    const [mergedClassNames, mergedStyles] = hooks_useMergedPickerSemantic(pickerType, classNames, styles, popupClassName || dropdownClassName, popupStyle);
    // ===================== Icon =====================
    const [mergedAllowClear] = util_useIcons(props, prefixCls);
    // ================== components ==================
    const mergedComponents = useComponents(components);
    // ===================== Size =====================
    const mergedSize = hooks_useSize(ctx => {
      var _a;
      return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    // ===================== Disabled =====================
    const disabled = react.useContext(config_provider_DisabledContext);
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    // ===================== FormItemInput =====================
    const formItemContext = (0,react.useContext)(FormItemInputContext);
    const {
      hasFeedback,
      status: contextStatus,
      feedbackIcon
    } = formItemContext;
    const suffixNode = /*#__PURE__*/react.createElement(react.Fragment, null, picker === TIME ? /*#__PURE__*/react.createElement(ClockCircleOutlined/* default */.Z, null) : /*#__PURE__*/react.createElement(CalendarOutlined/* default */.Z, null), hasFeedback && feedbackIcon);
    (0,react.useImperativeHandle)(ref, () => innerRef.current);
    const [contextLocale] = locale_useLocale('Calendar', date_picker_locale_en_US);
    const locale = Object.assign(Object.assign({}, contextLocale), props.locale);
    // ============================ zIndex ============================
    const [zIndex] = useZIndex('DatePicker', (_a = mergedStyles.popup.root) === null || _a === void 0 ? void 0 : _a.zIndex);
    return wrapCSSVar(/*#__PURE__*/react.createElement(_util_ContextIsolator, {
      space: true
    }, /*#__PURE__*/react.createElement(rc_picker_es/* RangePicker */.Sq, Object.assign({
      separator: /*#__PURE__*/react.createElement("span", {
        "aria-label": "to",
        className: `${prefixCls}-separator`
      }, /*#__PURE__*/react.createElement(SwapRightOutlined/* default */.Z, null)),
      disabled: mergedDisabled,
      ref: innerRef,
      placement: placement,
      placeholder: getRangePlaceholder(locale, picker, placeholder),
      suffixIcon: suffixNode,
      prevIcon: /*#__PURE__*/react.createElement("span", {
        className: `${prefixCls}-prev-icon`
      }),
      nextIcon: /*#__PURE__*/react.createElement("span", {
        className: `${prefixCls}-next-icon`
      }),
      superPrevIcon: /*#__PURE__*/react.createElement("span", {
        className: `${prefixCls}-super-prev-icon`
      }),
      superNextIcon: /*#__PURE__*/react.createElement("span", {
        className: `${prefixCls}-super-next-icon`
      }),
      transitionName: `${rootPrefixCls}-slide-up`,
      picker: picker
    }, restProps, {
      className: classnames_default()({
        [`${prefixCls}-${mergedSize}`]: mergedSize,
        [`${prefixCls}-${variant}`]: enableVariantCls
      }, getStatusClassNames(prefixCls, getMergedStatus(contextStatus, customStatus), hasFeedback), hashId, compactItemClassnames, className, rangePicker === null || rangePicker === void 0 ? void 0 : rangePicker.className, cssVarCls, rootCls, rootClassName, mergedClassNames.root),
      style: Object.assign(Object.assign(Object.assign({}, rangePicker === null || rangePicker === void 0 ? void 0 : rangePicker.style), style), mergedStyles.root),
      locale: locale.lang,
      prefixCls: prefixCls,
      getPopupContainer: customGetPopupContainer || getPopupContainer,
      generateConfig: generateConfig,
      components: mergedComponents,
      direction: direction,
      classNames: {
        popup: classnames_default()(hashId, cssVarCls, rootCls, rootClassName, mergedClassNames.popup.root)
      },
      styles: {
        popup: Object.assign(Object.assign({}, mergedStyles.popup.root), {
          zIndex
        })
      },
      allowClear: mergedAllowClear
    }))));
  });
  if (false) {}
  return RangePicker;
};
/* harmony default export */ var generatePicker_generateRangePicker = (generateRangePicker);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/date-picker/generatePicker/generateSinglePicker.js
"use client";

var generateSinglePicker_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
























const generatePicker = generateConfig => {
  const getPicker = (picker, displayName) => {
    const consumerName = displayName === TIMEPICKER ? 'timePicker' : 'datePicker';
    const Picker = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
      var _a;
      const {
          prefixCls: customizePrefixCls,
          getPopupContainer: customizeGetPopupContainer,
          components,
          style,
          className,
          rootClassName,
          size: customizeSize,
          bordered,
          placement,
          placeholder,
          popupStyle,
          popupClassName,
          dropdownClassName,
          disabled: customDisabled,
          status: customStatus,
          variant: customVariant,
          onCalendarChange,
          styles,
          classNames
        } = props,
        restProps = generateSinglePicker_rest(props, ["prefixCls", "getPopupContainer", "components", "style", "className", "rootClassName", "size", "bordered", "placement", "placeholder", "popupStyle", "popupClassName", "dropdownClassName", "disabled", "status", "variant", "onCalendarChange", "styles", "classNames"]);
      const {
        getPrefixCls,
        direction,
        getPopupContainer,
        // Consume different styles according to different names
        [consumerName]: consumerStyle
      } = (0,react.useContext)(ConfigContext);
      const prefixCls = getPrefixCls('picker', customizePrefixCls);
      const {
        compactSize,
        compactItemClassnames
      } = useCompactItemContext(prefixCls, direction);
      const innerRef = react.useRef(null);
      const [variant, enableVariantCls] = useVariants('datePicker', customVariant, bordered);
      const rootCls = hooks_useCSSVarCls(prefixCls);
      const [wrapCSSVar, hashId, cssVarCls] = date_picker_style(prefixCls, rootCls);
      (0,react.useImperativeHandle)(ref, () => innerRef.current);
      const additionalProps = {
        showToday: true
      };
      const mergedPicker = picker || props.picker;
      const rootPrefixCls = getPrefixCls();
      // ==================== Legacy =====================
      const {
        onSelect,
        multiple
      } = restProps;
      const hasLegacyOnSelect = onSelect && picker === 'time' && !multiple;
      const onInternalCalendarChange = (date, dateStr, info) => {
        onCalendarChange === null || onCalendarChange === void 0 ? void 0 : onCalendarChange(date, dateStr, info);
        if (hasLegacyOnSelect) {
          onSelect(date);
        }
      };
      // =================== Warning =====================
      if (false) {}
      const [mergedClassNames, mergedStyles] = hooks_useMergedPickerSemantic(consumerName, classNames, styles, popupClassName || dropdownClassName, popupStyle);
      // ===================== Icon =====================
      const [mergedAllowClear, removeIcon] = util_useIcons(props, prefixCls);
      // ================== components ==================
      const mergedComponents = useComponents(components);
      // ===================== Size =====================
      const mergedSize = hooks_useSize(ctx => {
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
      });
      // ===================== Disabled =====================
      const disabled = react.useContext(config_provider_DisabledContext);
      const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
      // ===================== FormItemInput =====================
      const formItemContext = (0,react.useContext)(FormItemInputContext);
      const {
        hasFeedback,
        status: contextStatus,
        feedbackIcon
      } = formItemContext;
      const suffixNode = /*#__PURE__*/react.createElement(react.Fragment, null, mergedPicker === 'time' ? /*#__PURE__*/react.createElement(ClockCircleOutlined/* default */.Z, null) : /*#__PURE__*/react.createElement(CalendarOutlined/* default */.Z, null), hasFeedback && feedbackIcon);
      const [contextLocale] = locale_useLocale('DatePicker', date_picker_locale_en_US);
      const locale = Object.assign(Object.assign({}, contextLocale), props.locale);
      // ============================ zIndex ============================
      const [zIndex] = useZIndex('DatePicker', (_a = mergedStyles.popup.root) === null || _a === void 0 ? void 0 : _a.zIndex);
      return wrapCSSVar(/*#__PURE__*/react.createElement(_util_ContextIsolator, {
        space: true
      }, /*#__PURE__*/react.createElement(rc_picker_es/* default */.ZP, Object.assign({
        ref: innerRef,
        placeholder: getPlaceholder(locale, mergedPicker, placeholder),
        suffixIcon: suffixNode,
        placement: placement,
        prevIcon: /*#__PURE__*/react.createElement("span", {
          className: `${prefixCls}-prev-icon`
        }),
        nextIcon: /*#__PURE__*/react.createElement("span", {
          className: `${prefixCls}-next-icon`
        }),
        superPrevIcon: /*#__PURE__*/react.createElement("span", {
          className: `${prefixCls}-super-prev-icon`
        }),
        superNextIcon: /*#__PURE__*/react.createElement("span", {
          className: `${prefixCls}-super-next-icon`
        }),
        transitionName: `${rootPrefixCls}-slide-up`,
        picker: picker,
        onCalendarChange: onInternalCalendarChange
      }, additionalProps, restProps, {
        locale: locale.lang,
        className: classnames_default()({
          [`${prefixCls}-${mergedSize}`]: mergedSize,
          [`${prefixCls}-${variant}`]: enableVariantCls
        }, getStatusClassNames(prefixCls, getMergedStatus(contextStatus, customStatus), hasFeedback), hashId, compactItemClassnames, consumerStyle === null || consumerStyle === void 0 ? void 0 : consumerStyle.className, className, cssVarCls, rootCls, rootClassName, mergedClassNames.root),
        style: Object.assign(Object.assign(Object.assign({}, consumerStyle === null || consumerStyle === void 0 ? void 0 : consumerStyle.style), style), mergedStyles.root),
        prefixCls: prefixCls,
        getPopupContainer: customizeGetPopupContainer || getPopupContainer,
        generateConfig: generateConfig,
        components: mergedComponents,
        direction: direction,
        disabled: mergedDisabled,
        classNames: {
          popup: classnames_default()(hashId, cssVarCls, rootCls, rootClassName, mergedClassNames.popup.root)
        },
        styles: {
          popup: Object.assign(Object.assign({}, mergedStyles.popup.root), {
            zIndex
          })
        },
        allowClear: mergedAllowClear,
        removeIcon: removeIcon
      }))));
    });
    if (false) {}
    return Picker;
  };
  const DatePicker = getPicker();
  const WeekPicker = getPicker(WEEK, WEEKPICKER);
  const MonthPicker = getPicker(MONTH, MONTHPICKER);
  const YearPicker = getPicker(YEAR, YEARPICKER);
  const QuarterPicker = getPicker(QUARTER, QUARTERPICKER);
  const TimePicker = getPicker(TIME, TIMEPICKER);
  return {
    DatePicker,
    WeekPicker,
    MonthPicker,
    YearPicker,
    TimePicker,
    QuarterPicker
  };
};
/* harmony default export */ var generateSinglePicker = (generatePicker);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/date-picker/generatePicker/index.js
"use client";



const generatePicker_generatePicker = generateConfig => {
  // =========================== Picker ===========================
  const {
    DatePicker,
    WeekPicker,
    MonthPicker,
    YearPicker,
    TimePicker,
    QuarterPicker
  } = generateSinglePicker(generateConfig);
  // ======================== Range Picker ========================
  const RangePicker = generatePicker_generateRangePicker(generateConfig);
  const MergedDatePicker = DatePicker;
  MergedDatePicker.WeekPicker = WeekPicker;
  MergedDatePicker.MonthPicker = MonthPicker;
  MergedDatePicker.YearPicker = YearPicker;
  MergedDatePicker.RangePicker = RangePicker;
  MergedDatePicker.TimePicker = TimePicker;
  MergedDatePicker.QuarterPicker = QuarterPicker;
  if (false) {}
  return MergedDatePicker;
};
/* harmony default export */ var date_picker_generatePicker = (generatePicker_generatePicker);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/date-picker/index.js
"use client";




const DatePicker = date_picker_generatePicker(dayjs/* default */.Z);
// We don't care debug panel
/* istanbul ignore next */
const date_picker_PurePanel = _util_PurePanel(DatePicker, 'popupAlign', undefined, 'picker');
DatePicker._InternalPanelDoNotUseOrYouWillBeFired = date_picker_PurePanel;
const PureRangePanel = _util_PurePanel(DatePicker.RangePicker, 'popupAlign', undefined, 'picker');
DatePicker._InternalRangePanelDoNotUseOrYouWillBeFired = PureRangePanel;
DatePicker.generatePicker = date_picker_generatePicker;
/* harmony default export */ var date_picker = (DatePicker);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/descriptions/constant.js
const DEFAULT_COLUMN_MAP = {
  xxl: 3,
  xl: 3,
  lg: 3,
  md: 3,
  sm: 2,
  xs: 1
};
/* harmony default export */ var constant = (DEFAULT_COLUMN_MAP);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/descriptions/DescriptionsContext.js

const DescriptionsContext = /*#__PURE__*/react.createContext({});
/* harmony default export */ var descriptions_DescriptionsContext = (DescriptionsContext);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/descriptions/hooks/useItems.js
var hooks_useItems_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};



// Convert children into items
const transChildren2Items = childNodes => (0,Children_toArray/* default */.Z)(childNodes).map(node => Object.assign(Object.assign({}, node === null || node === void 0 ? void 0 : node.props), {
  key: node.key
}));
function useItems_useItems(screens, items, children) {
  const mergedItems = react.useMemo(() =>
  // Take `items` first or convert `children` into items
  items || transChildren2Items(children), [items, children]);
  const responsiveItems = react.useMemo(() => mergedItems.map(_a => {
    var {
        span
      } = _a,
      restItem = hooks_useItems_rest(_a, ["span"]);
    if (span === 'filled') {
      return Object.assign(Object.assign({}, restItem), {
        filled: true
      });
    }
    return Object.assign(Object.assign({}, restItem), {
      span: typeof span === 'number' ? span : matchScreen(screens, span)
    });
  }), [mergedItems, screens]);
  return responsiveItems;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/descriptions/hooks/useRow.js
var useRow_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


// Calculate the sum of span in a row
function getCalcRows(rowItems, mergedColumn) {
  let rows = [];
  let tmpRow = [];
  let exceed = false;
  let count = 0;
  rowItems.filter(n => n).forEach(rowItem => {
    const {
        filled
      } = rowItem,
      restItem = useRow_rest(rowItem, ["filled"]);
    if (filled) {
      tmpRow.push(restItem);
      rows.push(tmpRow);
      // reset
      tmpRow = [];
      count = 0;
      return;
    }
    const restSpan = mergedColumn - count;
    count += rowItem.span || 1;
    if (count >= mergedColumn) {
      if (count > mergedColumn) {
        exceed = true;
        tmpRow.push(Object.assign(Object.assign({}, restItem), {
          span: restSpan
        }));
      } else {
        tmpRow.push(restItem);
      }
      rows.push(tmpRow);
      // reset
      tmpRow = [];
      count = 0;
    } else {
      tmpRow.push(restItem);
    }
  });
  if (tmpRow.length > 0) {
    rows.push(tmpRow);
  }
  rows = rows.map(rows => {
    const count = rows.reduce((acc, item) => acc + (item.span || 1), 0);
    if (count < mergedColumn) {
      // If the span of the last element in the current row is less than the column, then add its span to the remaining columns
      const last = rows[rows.length - 1];
      last.span = mergedColumn - (count - (last.span || 1));
      return rows;
    }
    return rows;
  });
  return [rows, exceed];
}
const useRow = (mergedColumn, items) => {
  const [rows, exceed] = (0,react.useMemo)(() => getCalcRows(items, mergedColumn), [items, mergedColumn]);
  if (false) {}
  return rows;
};
/* harmony default export */ var hooks_useRow = (useRow);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/descriptions/Item.js
// JSX Structure Syntactic Sugar. Never reach the render code.
/* istanbul ignore next */
const DescriptionsItem = ({
  children
}) => children;
/* harmony default export */ var Item = (DescriptionsItem);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/descriptions/Cell.js
"use client";




function notEmpty(val) {
  return val !== undefined && val !== null;
}
const Cell = props => {
  const {
    itemPrefixCls,
    component,
    span,
    className,
    style,
    labelStyle,
    contentStyle,
    bordered,
    label,
    content,
    colon,
    type,
    styles
  } = props;
  const Component = component;
  const descContext = react.useContext(descriptions_DescriptionsContext);
  const {
    classNames: descriptionsClassNames
  } = descContext;
  if (bordered) {
    return /*#__PURE__*/react.createElement(Component, {
      className: classnames_default()({
        [`${itemPrefixCls}-item-label`]: type === 'label',
        [`${itemPrefixCls}-item-content`]: type === 'content',
        [`${descriptionsClassNames === null || descriptionsClassNames === void 0 ? void 0 : descriptionsClassNames.label}`]: type === 'label',
        [`${descriptionsClassNames === null || descriptionsClassNames === void 0 ? void 0 : descriptionsClassNames.content}`]: type === 'content'
      }, className),
      style: style,
      colSpan: span
    }, notEmpty(label) && /*#__PURE__*/react.createElement("span", {
      style: Object.assign(Object.assign({}, labelStyle), styles === null || styles === void 0 ? void 0 : styles.label)
    }, label), notEmpty(content) && /*#__PURE__*/react.createElement("span", {
      style: Object.assign(Object.assign({}, labelStyle), styles === null || styles === void 0 ? void 0 : styles.content)
    }, content));
  }
  return /*#__PURE__*/react.createElement(Component, {
    className: classnames_default()(`${itemPrefixCls}-item`, className),
    style: style,
    colSpan: span
  }, /*#__PURE__*/react.createElement("div", {
    className: `${itemPrefixCls}-item-container`
  }, (label || label === 0) && (/*#__PURE__*/react.createElement("span", {
    className: classnames_default()(`${itemPrefixCls}-item-label`, descriptionsClassNames === null || descriptionsClassNames === void 0 ? void 0 : descriptionsClassNames.label, {
      [`${itemPrefixCls}-item-no-colon`]: !colon
    }),
    style: Object.assign(Object.assign({}, labelStyle), styles === null || styles === void 0 ? void 0 : styles.label)
  }, label)), (content || content === 0) && (/*#__PURE__*/react.createElement("span", {
    className: classnames_default()(`${itemPrefixCls}-item-content`, descriptionsClassNames === null || descriptionsClassNames === void 0 ? void 0 : descriptionsClassNames.content),
    style: Object.assign(Object.assign({}, contentStyle), styles === null || styles === void 0 ? void 0 : styles.content)
  }, content))));
};
/* harmony default export */ var descriptions_Cell = (Cell);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/descriptions/Row.js
"use client";




function renderCells(items, {
  colon,
  prefixCls,
  bordered
}, {
  component,
  type,
  showLabel,
  showContent,
  labelStyle: rootLabelStyle,
  contentStyle: rootContentStyle,
  styles: rootStyles
}) {
  return items.map(({
    label,
    children,
    prefixCls: itemPrefixCls = prefixCls,
    className,
    style,
    labelStyle,
    contentStyle,
    span = 1,
    key,
    styles
  }, index) => {
    if (typeof component === 'string') {
      return /*#__PURE__*/react.createElement(descriptions_Cell, {
        key: `${type}-${key || index}`,
        className: className,
        style: style,
        styles: {
          label: Object.assign(Object.assign(Object.assign(Object.assign({}, rootLabelStyle), rootStyles === null || rootStyles === void 0 ? void 0 : rootStyles.label), labelStyle), styles === null || styles === void 0 ? void 0 : styles.label),
          content: Object.assign(Object.assign(Object.assign(Object.assign({}, rootContentStyle), rootStyles === null || rootStyles === void 0 ? void 0 : rootStyles.content), contentStyle), styles === null || styles === void 0 ? void 0 : styles.content)
        },
        span: span,
        colon: colon,
        component: component,
        itemPrefixCls: itemPrefixCls,
        bordered: bordered,
        label: showLabel ? label : null,
        content: showContent ? children : null,
        type: type
      });
    }
    return [/*#__PURE__*/react.createElement(descriptions_Cell, {
      key: `label-${key || index}`,
      className: className,
      style: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, rootLabelStyle), rootStyles === null || rootStyles === void 0 ? void 0 : rootStyles.label), style), labelStyle), styles === null || styles === void 0 ? void 0 : styles.label),
      span: 1,
      colon: colon,
      component: component[0],
      itemPrefixCls: itemPrefixCls,
      bordered: bordered,
      label: label,
      type: "label"
    }), /*#__PURE__*/react.createElement(descriptions_Cell, {
      key: `content-${key || index}`,
      className: className,
      style: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, rootContentStyle), rootStyles === null || rootStyles === void 0 ? void 0 : rootStyles.content), style), contentStyle), styles === null || styles === void 0 ? void 0 : styles.content),
      span: span * 2 - 1,
      component: component[1],
      itemPrefixCls: itemPrefixCls,
      bordered: bordered,
      content: children,
      type: "content"
    })];
  });
}
const Row = props => {
  const descContext = react.useContext(descriptions_DescriptionsContext);
  const {
    prefixCls,
    vertical,
    row,
    index,
    bordered
  } = props;
  if (vertical) {
    return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("tr", {
      key: `label-${index}`,
      className: `${prefixCls}-row`
    }, renderCells(row, props, Object.assign({
      component: 'th',
      type: 'label',
      showLabel: true
    }, descContext))), /*#__PURE__*/react.createElement("tr", {
      key: `content-${index}`,
      className: `${prefixCls}-row`
    }, renderCells(row, props, Object.assign({
      component: 'td',
      type: 'content',
      showContent: true
    }, descContext))));
  }
  return /*#__PURE__*/react.createElement("tr", {
    key: index,
    className: `${prefixCls}-row`
  }, renderCells(row, props, Object.assign({
    component: bordered ? ['th', 'td'] : 'td',
    type: 'item',
    showLabel: true,
    showContent: true
  }, descContext)));
};
/* harmony default export */ var descriptions_Row = (Row);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/descriptions/style/index.js



const genBorderedStyle = token => {
  const {
    componentCls,
    labelBg
  } = token;
  return {
    [`&${componentCls}-bordered`]: {
      [`> ${componentCls}-view`]: {
        border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`,
        '> table': {
          tableLayout: 'auto'
        },
        [`${componentCls}-row`]: {
          borderBottom: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`,
          '&:first-child': {
            '> th:first-child, > td:first-child': {
              borderStartStartRadius: token.borderRadiusLG
            }
          },
          '&:last-child': {
            borderBottom: 'none',
            '> th:first-child, > td:first-child': {
              borderEndStartRadius: token.borderRadiusLG
            }
          },
          [`> ${componentCls}-item-label, > ${componentCls}-item-content`]: {
            padding: `${(0,cssinjs_es/* unit */.bf)(token.padding)} ${(0,cssinjs_es/* unit */.bf)(token.paddingLG)}`,
            borderInlineEnd: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`,
            '&:last-child': {
              borderInlineEnd: 'none'
            }
          },
          [`> ${componentCls}-item-label`]: {
            color: token.colorTextSecondary,
            backgroundColor: labelBg,
            '&::after': {
              display: 'none'
            }
          }
        }
      },
      [`&${componentCls}-middle`]: {
        [`${componentCls}-row`]: {
          [`> ${componentCls}-item-label, > ${componentCls}-item-content`]: {
            padding: `${(0,cssinjs_es/* unit */.bf)(token.paddingSM)} ${(0,cssinjs_es/* unit */.bf)(token.paddingLG)}`
          }
        }
      },
      [`&${componentCls}-small`]: {
        [`${componentCls}-row`]: {
          [`> ${componentCls}-item-label, > ${componentCls}-item-content`]: {
            padding: `${(0,cssinjs_es/* unit */.bf)(token.paddingXS)} ${(0,cssinjs_es/* unit */.bf)(token.padding)}`
          }
        }
      }
    }
  };
};
const genDescriptionStyles = token => {
  const {
    componentCls,
    extraColor,
    itemPaddingBottom,
    itemPaddingEnd,
    colonMarginRight,
    colonMarginLeft,
    titleMarginBottom
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign({}, resetComponent(token)), genBorderedStyle(token)), {
      '&-rtl': {
        direction: 'rtl'
      },
      [`${componentCls}-header`]: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: titleMarginBottom
      },
      [`${componentCls}-title`]: Object.assign(Object.assign({}, textEllipsis), {
        flex: 'auto',
        color: token.titleColor,
        fontWeight: token.fontWeightStrong,
        fontSize: token.fontSizeLG,
        lineHeight: token.lineHeightLG
      }),
      [`${componentCls}-extra`]: {
        marginInlineStart: 'auto',
        color: extraColor,
        fontSize: token.fontSize
      },
      [`${componentCls}-view`]: {
        width: '100%',
        borderRadius: token.borderRadiusLG,
        table: {
          width: '100%',
          tableLayout: 'fixed',
          borderCollapse: 'collapse'
        }
      },
      [`${componentCls}-row`]: {
        '> th, > td': {
          paddingBottom: itemPaddingBottom,
          paddingInlineEnd: itemPaddingEnd
        },
        '> th:last-child, > td:last-child': {
          paddingInlineEnd: 0
        },
        '&:last-child': {
          borderBottom: 'none',
          '> th, > td': {
            paddingBottom: 0
          }
        }
      },
      [`${componentCls}-item-label`]: {
        color: token.labelColor,
        fontWeight: 'normal',
        fontSize: token.fontSize,
        lineHeight: token.lineHeight,
        textAlign: 'start',
        '&::after': {
          content: '":"',
          position: 'relative',
          top: -0.5,
          // magic for position
          marginInline: `${(0,cssinjs_es/* unit */.bf)(colonMarginLeft)} ${(0,cssinjs_es/* unit */.bf)(colonMarginRight)}`
        },
        [`&${componentCls}-item-no-colon::after`]: {
          content: '""'
        }
      },
      [`${componentCls}-item-no-label`]: {
        '&::after': {
          margin: 0,
          content: '""'
        }
      },
      [`${componentCls}-item-content`]: {
        display: 'table-cell',
        flex: 1,
        color: token.contentColor,
        fontSize: token.fontSize,
        lineHeight: token.lineHeight,
        wordBreak: 'break-word',
        overflowWrap: 'break-word'
      },
      [`${componentCls}-item`]: {
        paddingBottom: 0,
        verticalAlign: 'top',
        '&-container': {
          display: 'flex',
          [`${componentCls}-item-label`]: {
            display: 'inline-flex',
            alignItems: 'baseline'
          },
          [`${componentCls}-item-content`]: {
            display: 'inline-flex',
            alignItems: 'baseline',
            minWidth: '1em'
          }
        }
      },
      '&-middle': {
        [`${componentCls}-row`]: {
          '> th, > td': {
            paddingBottom: token.paddingSM
          }
        }
      },
      '&-small': {
        [`${componentCls}-row`]: {
          '> th, > td': {
            paddingBottom: token.paddingXS
          }
        }
      }
    })
  };
};
const descriptions_style_prepareComponentToken = token => ({
  labelBg: token.colorFillAlter,
  labelColor: token.colorTextTertiary,
  titleColor: token.colorText,
  titleMarginBottom: token.fontSizeSM * token.lineHeightSM,
  itemPaddingBottom: token.padding,
  itemPaddingEnd: token.padding,
  colonMarginRight: token.marginXS,
  colonMarginLeft: token.marginXXS / 2,
  contentColor: token.colorText,
  extraColor: token.colorText
});
// ============================== Export ==============================
/* harmony default export */ var descriptions_style = (genStyleHooks('Descriptions', token => {
  const descriptionToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {});
  return genDescriptionStyles(descriptionToken);
}, descriptions_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/descriptions/index.js
"use client";

var descriptions_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable react/no-array-index-key */














const Descriptions = props => {
  const {
      prefixCls: customizePrefixCls,
      title,
      extra,
      column,
      colon = true,
      bordered,
      layout,
      children,
      className,
      rootClassName,
      style,
      size: customizeSize,
      labelStyle,
      contentStyle,
      styles,
      items,
      classNames: descriptionsClassNames
    } = props,
    restProps = descriptions_rest(props, ["prefixCls", "title", "extra", "column", "colon", "bordered", "layout", "children", "className", "rootClassName", "style", "size", "labelStyle", "contentStyle", "styles", "items", "classNames"]);
  const {
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig('descriptions');
  const prefixCls = getPrefixCls('descriptions', customizePrefixCls);
  const screens = hooks_useBreakpoint();
  // ============================== Warn ==============================
  if (false) {}
  // Column count
  const mergedColumn = react.useMemo(() => {
    var _a;
    if (typeof column === 'number') {
      return column;
    }
    return (_a = matchScreen(screens, Object.assign(Object.assign({}, constant), column))) !== null && _a !== void 0 ? _a : 3;
  }, [screens, column]);
  // Items with responsive
  const mergedItems = useItems_useItems(screens, items, children);
  const mergedSize = hooks_useSize(customizeSize);
  const rows = hooks_useRow(mergedColumn, mergedItems);
  const [wrapCSSVar, hashId, cssVarCls] = descriptions_style(prefixCls);
  // ======================== Render ========================
  const contextValue = react.useMemo(() => ({
    labelStyle,
    contentStyle,
    styles: {
      content: Object.assign(Object.assign({}, contextStyles.content), styles === null || styles === void 0 ? void 0 : styles.content),
      label: Object.assign(Object.assign({}, contextStyles.label), styles === null || styles === void 0 ? void 0 : styles.label)
    },
    classNames: {
      label: classnames_default()(contextClassNames.label, descriptionsClassNames === null || descriptionsClassNames === void 0 ? void 0 : descriptionsClassNames.label),
      content: classnames_default()(contextClassNames.content, descriptionsClassNames === null || descriptionsClassNames === void 0 ? void 0 : descriptionsClassNames.content)
    }
  }), [labelStyle, contentStyle, styles, descriptionsClassNames, contextClassNames, contextStyles]);
  return wrapCSSVar(/*#__PURE__*/react.createElement(descriptions_DescriptionsContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/react.createElement("div", Object.assign({
    className: classnames_default()(prefixCls, contextClassName, contextClassNames.root, descriptionsClassNames === null || descriptionsClassNames === void 0 ? void 0 : descriptionsClassNames.root, {
      [`${prefixCls}-${mergedSize}`]: mergedSize && mergedSize !== 'default',
      [`${prefixCls}-bordered`]: !!bordered,
      [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, hashId, cssVarCls),
    style: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyle), contextStyles.root), styles === null || styles === void 0 ? void 0 : styles.root), style)
  }, restProps), (title || extra) && (/*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${prefixCls}-header`, contextClassNames.header, descriptionsClassNames === null || descriptionsClassNames === void 0 ? void 0 : descriptionsClassNames.header),
    style: Object.assign(Object.assign({}, contextStyles.header), styles === null || styles === void 0 ? void 0 : styles.header)
  }, title && (/*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${prefixCls}-title`, contextClassNames.title, descriptionsClassNames === null || descriptionsClassNames === void 0 ? void 0 : descriptionsClassNames.title),
    style: Object.assign(Object.assign({}, contextStyles.title), styles === null || styles === void 0 ? void 0 : styles.title)
  }, title)), extra && (/*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${prefixCls}-extra`, contextClassNames.extra, descriptionsClassNames === null || descriptionsClassNames === void 0 ? void 0 : descriptionsClassNames.extra),
    style: Object.assign(Object.assign({}, contextStyles.extra), styles === null || styles === void 0 ? void 0 : styles.extra)
  }, extra)))), /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-view`
  }, /*#__PURE__*/react.createElement("table", null, /*#__PURE__*/react.createElement("tbody", null, rows.map((row, index) => (/*#__PURE__*/react.createElement(descriptions_Row, {
    key: index,
    index: index,
    colon: colon,
    prefixCls: prefixCls,
    vertical: layout === 'vertical',
    bordered: bordered,
    row: row
  })))))))));
};
if (false) {}

Descriptions.Item = Item;
/* harmony default export */ var descriptions = (Descriptions);
// EXTERNAL MODULE: ./node_modules/rc-drawer/es/index.js + 5 modules
var rc_drawer_es = __webpack_require__(32830);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/drawer/DrawerPanel.js
"use client";






const DrawerPanel = props => {
  var _a, _b;
  const {
    prefixCls,
    title,
    footer,
    extra,
    loading,
    onClose,
    headerStyle,
    bodyStyle,
    footerStyle,
    children,
    classNames: drawerClassNames,
    styles: drawerStyles
  } = props;
  const drawerContext = useComponentConfig('drawer');
  const customCloseIconRender = react.useCallback(icon => (/*#__PURE__*/react.createElement("button", {
    type: "button",
    onClick: onClose,
    className: `${prefixCls}-close`
  }, icon)), [onClose]);
  const [mergedClosable, mergedCloseIcon] = useClosable(pickClosable(props), pickClosable(drawerContext), {
    closable: true,
    closeIconRender: customCloseIconRender
  });
  const headerNode = react.useMemo(() => {
    var _a, _b;
    if (!title && !mergedClosable) {
      return null;
    }
    return /*#__PURE__*/react.createElement("div", {
      style: Object.assign(Object.assign(Object.assign({}, (_a = drawerContext.styles) === null || _a === void 0 ? void 0 : _a.header), headerStyle), drawerStyles === null || drawerStyles === void 0 ? void 0 : drawerStyles.header),
      className: classnames_default()(`${prefixCls}-header`, {
        [`${prefixCls}-header-close-only`]: mergedClosable && !title && !extra
      }, (_b = drawerContext.classNames) === null || _b === void 0 ? void 0 : _b.header, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.header)
    }, /*#__PURE__*/react.createElement("div", {
      className: `${prefixCls}-header-title`
    }, mergedCloseIcon, title && /*#__PURE__*/react.createElement("div", {
      className: `${prefixCls}-title`
    }, title)), extra && /*#__PURE__*/react.createElement("div", {
      className: `${prefixCls}-extra`
    }, extra));
  }, [mergedClosable, mergedCloseIcon, extra, headerStyle, prefixCls, title]);
  const footerNode = react.useMemo(() => {
    var _a, _b;
    if (!footer) {
      return null;
    }
    const footerClassName = `${prefixCls}-footer`;
    return /*#__PURE__*/react.createElement("div", {
      className: classnames_default()(footerClassName, (_a = drawerContext.classNames) === null || _a === void 0 ? void 0 : _a.footer, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.footer),
      style: Object.assign(Object.assign(Object.assign({}, (_b = drawerContext.styles) === null || _b === void 0 ? void 0 : _b.footer), footerStyle), drawerStyles === null || drawerStyles === void 0 ? void 0 : drawerStyles.footer)
    }, footer);
  }, [footer, footerStyle, prefixCls]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, headerNode, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${prefixCls}-body`, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.body, (_a = drawerContext.classNames) === null || _a === void 0 ? void 0 : _a.body),
    style: Object.assign(Object.assign(Object.assign({}, (_b = drawerContext.styles) === null || _b === void 0 ? void 0 : _b.body), bodyStyle), drawerStyles === null || drawerStyles === void 0 ? void 0 : drawerStyles.body)
  }, loading ? (/*#__PURE__*/react.createElement(skeleton, {
    active: true,
    title: false,
    paragraph: {
      rows: 5
    },
    className: `${prefixCls}-body-skeleton`
  })) : children), footerNode);
};
/* harmony default export */ var drawer_DrawerPanel = (DrawerPanel);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/drawer/style/motion.js
const getMoveTranslate = direction => {
  const value = '100%';
  return {
    left: `translateX(-${value})`,
    right: `translateX(${value})`,
    top: `translateY(-${value})`,
    bottom: `translateY(${value})`
  }[direction];
};
const getEnterLeaveStyle = (startStyle, endStyle) => ({
  '&-enter, &-appear': Object.assign(Object.assign({}, startStyle), {
    '&-active': endStyle
  }),
  '&-leave': Object.assign(Object.assign({}, endStyle), {
    '&-active': startStyle
  })
});
const getFadeStyle = (from, duration) => Object.assign({
  '&-enter, &-appear, &-leave': {
    '&-start': {
      transition: 'none'
    },
    '&-active': {
      transition: `all ${duration}`
    }
  }
}, getEnterLeaveStyle({
  opacity: from
}, {
  opacity: 1
}));
const getPanelMotionStyles = (direction, duration) => [getFadeStyle(0.7, duration), getEnterLeaveStyle({
  transform: getMoveTranslate(direction)
}, {
  transform: 'none'
})];
const motion_genMotionStyle = token => {
  const {
    componentCls,
    motionDurationSlow
  } = token;
  return {
    [componentCls]: {
      // ======================== Mask ========================
      [`${componentCls}-mask-motion`]: getFadeStyle(0, motionDurationSlow),
      // ======================= Panel ========================
      [`${componentCls}-panel-motion`]: ['left', 'right', 'top', 'bottom'].reduce((obj, direction) => Object.assign(Object.assign({}, obj), {
        [`&-${direction}`]: getPanelMotionStyles(direction, motionDurationSlow)
      }), {})
    }
  };
};
/* harmony default export */ var drawer_style_motion = (motion_genMotionStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/drawer/style/index.js




// =============================== Base ===============================
const genDrawerStyle = token => {
  const {
    borderRadiusSM,
    componentCls,
    zIndexPopup,
    colorBgMask,
    colorBgElevated,
    motionDurationSlow,
    motionDurationMid,
    paddingXS,
    padding,
    paddingLG,
    fontSizeLG,
    lineHeightLG,
    lineWidth,
    lineType,
    colorSplit,
    marginXS,
    colorIcon,
    colorIconHover,
    colorBgTextHover,
    colorBgTextActive,
    colorText,
    fontWeightStrong,
    footerPaddingBlock,
    footerPaddingInline,
    calc
  } = token;
  const wrapperCls = `${componentCls}-content-wrapper`;
  return {
    [componentCls]: {
      position: 'fixed',
      inset: 0,
      zIndex: zIndexPopup,
      pointerEvents: 'none',
      color: colorText,
      '&-pure': {
        position: 'relative',
        background: colorBgElevated,
        display: 'flex',
        flexDirection: 'column',
        [`&${componentCls}-left`]: {
          boxShadow: token.boxShadowDrawerLeft
        },
        [`&${componentCls}-right`]: {
          boxShadow: token.boxShadowDrawerRight
        },
        [`&${componentCls}-top`]: {
          boxShadow: token.boxShadowDrawerUp
        },
        [`&${componentCls}-bottom`]: {
          boxShadow: token.boxShadowDrawerDown
        }
      },
      '&-inline': {
        position: 'absolute'
      },
      // ====================== Mask ======================
      [`${componentCls}-mask`]: {
        position: 'absolute',
        inset: 0,
        zIndex: zIndexPopup,
        background: colorBgMask,
        pointerEvents: 'auto'
      },
      // ==================== Content =====================
      [wrapperCls]: {
        position: 'absolute',
        zIndex: zIndexPopup,
        maxWidth: '100vw',
        transition: `all ${motionDurationSlow}`,
        '&-hidden': {
          display: 'none'
        }
      },
      // Placement
      [`&-left > ${wrapperCls}`]: {
        top: 0,
        bottom: 0,
        left: {
          _skip_check_: true,
          value: 0
        },
        boxShadow: token.boxShadowDrawerLeft
      },
      [`&-right > ${wrapperCls}`]: {
        top: 0,
        right: {
          _skip_check_: true,
          value: 0
        },
        bottom: 0,
        boxShadow: token.boxShadowDrawerRight
      },
      [`&-top > ${wrapperCls}`]: {
        top: 0,
        insetInline: 0,
        boxShadow: token.boxShadowDrawerUp
      },
      [`&-bottom > ${wrapperCls}`]: {
        bottom: 0,
        insetInline: 0,
        boxShadow: token.boxShadowDrawerDown
      },
      [`${componentCls}-content`]: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        overflow: 'auto',
        background: colorBgElevated,
        pointerEvents: 'auto'
      },
      // Header
      [`${componentCls}-header`]: {
        display: 'flex',
        flex: 0,
        alignItems: 'center',
        padding: `${(0,cssinjs_es/* unit */.bf)(padding)} ${(0,cssinjs_es/* unit */.bf)(paddingLG)}`,
        fontSize: fontSizeLG,
        lineHeight: lineHeightLG,
        borderBottom: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${colorSplit}`,
        '&-title': {
          display: 'flex',
          flex: 1,
          alignItems: 'center',
          minWidth: 0,
          minHeight: 0
        }
      },
      [`${componentCls}-extra`]: {
        flex: 'none'
      },
      [`${componentCls}-close`]: Object.assign({
        display: 'inline-flex',
        width: calc(fontSizeLG).add(paddingXS).equal(),
        height: calc(fontSizeLG).add(paddingXS).equal(),
        borderRadius: borderRadiusSM,
        justifyContent: 'center',
        alignItems: 'center',
        marginInlineEnd: marginXS,
        color: colorIcon,
        fontWeight: fontWeightStrong,
        fontSize: fontSizeLG,
        fontStyle: 'normal',
        lineHeight: 1,
        textAlign: 'center',
        textTransform: 'none',
        textDecoration: 'none',
        background: 'transparent',
        border: 0,
        cursor: 'pointer',
        transition: `all ${motionDurationMid}`,
        textRendering: 'auto',
        '&:hover': {
          color: colorIconHover,
          backgroundColor: colorBgTextHover,
          textDecoration: 'none'
        },
        '&:active': {
          backgroundColor: colorBgTextActive
        }
      }, genFocusStyle(token)),
      [`${componentCls}-title`]: {
        flex: 1,
        margin: 0,
        fontWeight: token.fontWeightStrong,
        fontSize: fontSizeLG,
        lineHeight: lineHeightLG
      },
      // Body
      [`${componentCls}-body`]: {
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        padding: paddingLG,
        overflow: 'auto',
        [`${componentCls}-body-skeleton`]: {
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center'
        }
      },
      // Footer
      [`${componentCls}-footer`]: {
        flexShrink: 0,
        padding: `${(0,cssinjs_es/* unit */.bf)(footerPaddingBlock)} ${(0,cssinjs_es/* unit */.bf)(footerPaddingInline)}`,
        borderTop: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${colorSplit}`
      },
      // ====================== RTL =======================
      '&-rtl': {
        direction: 'rtl'
      }
    }
  };
};
const drawer_style_prepareComponentToken = token => ({
  zIndexPopup: token.zIndexPopupBase,
  footerPaddingBlock: token.paddingXS,
  footerPaddingInline: token.padding
});
// ============================== Export ==============================
/* harmony default export */ var drawer_style = (genStyleHooks('Drawer', token => {
  const drawerToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {});
  return [genDrawerStyle(drawerToken), drawer_style_motion(drawerToken)];
}, drawer_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/drawer/index.js
"use client";

var drawer_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};














const _SizeTypes = (/* unused pure expression or super */ null && (['default', 'large']));
const defaultPushState = {
  distance: 180
};
const Drawer = props => {
  var _a;
  const {
      rootClassName,
      width,
      height,
      size = 'default',
      mask = true,
      push = defaultPushState,
      open,
      afterOpenChange,
      onClose,
      prefixCls: customizePrefixCls,
      getContainer: customizeGetContainer,
      panelRef = null,
      style,
      className,
      // Deprecated
      visible,
      afterVisibleChange,
      maskStyle,
      drawerStyle,
      contentWrapperStyle,
      destroyOnClose,
      destroyOnHidden
    } = props,
    rest = drawer_rest(props, ["rootClassName", "width", "height", "size", "mask", "push", "open", "afterOpenChange", "onClose", "prefixCls", "getContainer", "panelRef", "style", "className", "visible", "afterVisibleChange", "maskStyle", "drawerStyle", "contentWrapperStyle", "destroyOnClose", "destroyOnHidden"]);
  const {
    getPopupContainer,
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig('drawer');
  const prefixCls = getPrefixCls('drawer', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = drawer_style(prefixCls);
  const getContainer =
  // 有可能为 false，所以不能直接判断
  customizeGetContainer === undefined && getPopupContainer ? () => getPopupContainer(document.body) : customizeGetContainer;
  const drawerClassName = classnames_default()({
    'no-mask': !mask,
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, rootClassName, hashId, cssVarCls);
  // ========================== Warning ===========================
  if (false) {}
  // ============================ Size ============================
  const mergedWidth = react.useMemo(() => width !== null && width !== void 0 ? width : size === 'large' ? 736 : 378, [width, size]);
  const mergedHeight = react.useMemo(() => height !== null && height !== void 0 ? height : size === 'large' ? 736 : 378, [height, size]);
  // =========================== Motion ===========================
  const maskMotion = {
    motionName: getTransitionName(prefixCls, 'mask-motion'),
    motionAppear: true,
    motionEnter: true,
    motionLeave: true,
    motionDeadline: 500
  };
  const panelMotion = motionPlacement => ({
    motionName: getTransitionName(prefixCls, `panel-motion-${motionPlacement}`),
    motionAppear: true,
    motionEnter: true,
    motionLeave: true,
    motionDeadline: 500
  });
  // ============================ Refs ============================
  // Select `ant-drawer-content` by `panelRef`
  const innerPanelRef = usePanelRef();
  const mergedPanelRef = (0,es_ref/* composeRef */.sQ)(panelRef, innerPanelRef);
  // ============================ zIndex ============================
  const [zIndex, contextZIndex] = useZIndex('Drawer', rest.zIndex);
  // =========================== Render ===========================
  const {
    classNames: propClassNames = {},
    styles: propStyles = {}
  } = rest;
  return wrapCSSVar(/*#__PURE__*/react.createElement(_util_ContextIsolator, {
    form: true,
    space: true
  }, /*#__PURE__*/react.createElement(zindexContext.Provider, {
    value: contextZIndex
  }, /*#__PURE__*/react.createElement(rc_drawer_es/* default */.Z, Object.assign({
    prefixCls: prefixCls,
    onClose: onClose,
    maskMotion: maskMotion,
    motion: panelMotion
  }, rest, {
    classNames: {
      mask: classnames_default()(propClassNames.mask, contextClassNames.mask),
      content: classnames_default()(propClassNames.content, contextClassNames.content),
      wrapper: classnames_default()(propClassNames.wrapper, contextClassNames.wrapper)
    },
    styles: {
      mask: Object.assign(Object.assign(Object.assign({}, propStyles.mask), maskStyle), contextStyles.mask),
      content: Object.assign(Object.assign(Object.assign({}, propStyles.content), drawerStyle), contextStyles.content),
      wrapper: Object.assign(Object.assign(Object.assign({}, propStyles.wrapper), contentWrapperStyle), contextStyles.wrapper)
    },
    open: open !== null && open !== void 0 ? open : visible,
    mask: mask,
    push: push,
    width: mergedWidth,
    height: mergedHeight,
    style: Object.assign(Object.assign({}, contextStyle), style),
    className: classnames_default()(contextClassName, className),
    rootClassName: drawerClassName,
    getContainer: getContainer,
    afterOpenChange: afterOpenChange !== null && afterOpenChange !== void 0 ? afterOpenChange : afterVisibleChange,
    panelRef: mergedPanelRef,
    zIndex: zIndex,
    // TODO: In the future, destroyOnClose in rc-drawer needs to be upgrade to destroyOnHidden
    destroyOnClose: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : destroyOnClose
  }), /*#__PURE__*/react.createElement(drawer_DrawerPanel, Object.assign({
    prefixCls: prefixCls
  }, rest, {
    onClose: onClose
  }))))));
};
/** @private Internal Component. Do not use in your production. */
const drawer_PurePanel = props => {
  const {
      prefixCls: customizePrefixCls,
      style,
      className,
      placement = 'right'
    } = props,
    restProps = drawer_rest(props, ["prefixCls", "style", "className", "placement"]);
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('drawer', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = drawer_style(prefixCls);
  const cls = classnames_default()(prefixCls, `${prefixCls}-pure`, `${prefixCls}-${placement}`, hashId, cssVarCls, className);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    className: cls,
    style: style
  }, /*#__PURE__*/react.createElement(drawer_DrawerPanel, Object.assign({
    prefixCls: prefixCls
  }, restProps))));
};
Drawer._InternalPanelDoNotUseOrYouWillBeFired = drawer_PurePanel;
if (false) {}
/* harmony default export */ var drawer = (Drawer);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/gapSize.js
function isPresetSize(size) {
  return ['small', 'middle', 'large'].includes(size);
}
function isValidGapNumber(size) {
  if (!size) {
    // The case of size = 0 is deliberately excluded here, because the default value of the gap attribute in CSS is 0, so if the user passes 0 in, we can directly ignore it.
    return false;
  }
  return typeof size === 'number' && !Number.isNaN(size);
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/space/context.js

const SpaceContext = /*#__PURE__*/react.createContext({
  latestIndex: 0
});
const SpaceContextProvider = SpaceContext.Provider;
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/space/Item.js
"use client";



const Item_Item = ({
  className,
  index,
  children,
  split,
  style
}) => {
  const {
    latestIndex
  } = react.useContext(SpaceContext);
  if (children === null || children === undefined) {
    return null;
  }
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    className: className,
    style: style
  }, children), index < latestIndex && split && /*#__PURE__*/react.createElement("span", {
    className: `${className}-split`
  }, split));
};
/* harmony default export */ var space_Item = (Item_Item);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/space/index.js
"use client";

var space_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};










const InternalSpace = /*#__PURE__*/react.forwardRef((props, ref) => {
  var _a;
  const {
    getPrefixCls,
    direction: directionConfig,
    size: contextSize,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig('space');
  const {
      size = contextSize !== null && contextSize !== void 0 ? contextSize : 'small',
      align,
      className,
      rootClassName,
      children,
      direction = 'horizontal',
      prefixCls: customizePrefixCls,
      split,
      style,
      wrap = false,
      classNames: customClassNames,
      styles
    } = props,
    otherProps = space_rest(props, ["size", "align", "className", "rootClassName", "children", "direction", "prefixCls", "split", "style", "wrap", "classNames", "styles"]);
  const [horizontalSize, verticalSize] = Array.isArray(size) ? size : [size, size];
  const isPresetVerticalSize = isPresetSize(verticalSize);
  const isPresetHorizontalSize = isPresetSize(horizontalSize);
  const isValidVerticalSize = isValidGapNumber(verticalSize);
  const isValidHorizontalSize = isValidGapNumber(horizontalSize);
  const childNodes = (0,Children_toArray/* default */.Z)(children, {
    keepEmpty: true
  });
  const mergedAlign = align === undefined && direction === 'horizontal' ? 'center' : align;
  const prefixCls = getPrefixCls('space', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = space_style(prefixCls);
  const cls = classnames_default()(prefixCls, contextClassName, hashId, `${prefixCls}-${direction}`, {
    [`${prefixCls}-rtl`]: directionConfig === 'rtl',
    [`${prefixCls}-align-${mergedAlign}`]: mergedAlign,
    [`${prefixCls}-gap-row-${verticalSize}`]: isPresetVerticalSize,
    [`${prefixCls}-gap-col-${horizontalSize}`]: isPresetHorizontalSize
  }, className, rootClassName, cssVarCls);
  const itemClassName = classnames_default()(`${prefixCls}-item`, (_a = customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.item) !== null && _a !== void 0 ? _a : contextClassNames.item);
  // Calculate latest one
  let latestIndex = 0;
  const nodes = childNodes.map((child, i) => {
    var _a;
    if (child !== null && child !== undefined) {
      latestIndex = i;
    }
    const key = (child === null || child === void 0 ? void 0 : child.key) || `${itemClassName}-${i}`;
    return /*#__PURE__*/react.createElement(space_Item, {
      className: itemClassName,
      key: key,
      index: i,
      split: split,
      style: (_a = styles === null || styles === void 0 ? void 0 : styles.item) !== null && _a !== void 0 ? _a : contextStyles.item
    }, child);
  });
  const spaceContext = react.useMemo(() => ({
    latestIndex
  }), [latestIndex]);
  // =========================== Render ===========================
  if (childNodes.length === 0) {
    return null;
  }
  const gapStyle = {};
  if (wrap) {
    gapStyle.flexWrap = 'wrap';
  }
  if (!isPresetHorizontalSize && isValidHorizontalSize) {
    gapStyle.columnGap = horizontalSize;
  }
  if (!isPresetVerticalSize && isValidVerticalSize) {
    gapStyle.rowGap = verticalSize;
  }
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", Object.assign({
    ref: ref,
    className: cls,
    style: Object.assign(Object.assign(Object.assign({}, gapStyle), contextStyle), style)
  }, otherProps), /*#__PURE__*/react.createElement(SpaceContextProvider, {
    value: spaceContext
  }, nodes)));
});
const Space = InternalSpace;
Space.Compact = space_Compact;
if (false) {}
/* harmony default export */ var space = (Space);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/dropdown/dropdown-button.js
"use client";

var dropdown_button_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};








const DropdownButton = props => {
  const {
    getPopupContainer: getContextPopupContainer,
    getPrefixCls,
    direction
  } = react.useContext(ConfigContext);
  const {
      prefixCls: customizePrefixCls,
      type = 'default',
      danger,
      disabled,
      loading,
      onClick,
      htmlType,
      children,
      className,
      menu,
      arrow,
      autoFocus,
      overlay,
      trigger,
      align,
      open,
      onOpenChange,
      placement,
      getPopupContainer,
      href,
      icon = /*#__PURE__*/react.createElement(EllipsisOutlined/* default */.Z, null),
      title,
      buttonsRender = buttons => buttons,
      mouseEnterDelay,
      mouseLeaveDelay,
      overlayClassName,
      overlayStyle,
      destroyOnHidden,
      destroyPopupOnHide,
      dropdownRender,
      popupRender
    } = props,
    restProps = dropdown_button_rest(props, ["prefixCls", "type", "danger", "disabled", "loading", "onClick", "htmlType", "children", "className", "menu", "arrow", "autoFocus", "overlay", "trigger", "align", "open", "onOpenChange", "placement", "getPopupContainer", "href", "icon", "title", "buttonsRender", "mouseEnterDelay", "mouseLeaveDelay", "overlayClassName", "overlayStyle", "destroyOnHidden", "destroyPopupOnHide", "dropdownRender", "popupRender"]);
  const prefixCls = getPrefixCls('dropdown', customizePrefixCls);
  const buttonPrefixCls = `${prefixCls}-button`;
  const mergedPopupRender = popupRender || dropdownRender;
  const dropdownProps = {
    menu,
    arrow,
    autoFocus,
    align,
    disabled,
    trigger: disabled ? [] : trigger,
    onOpenChange,
    getPopupContainer: getPopupContainer || getContextPopupContainer,
    mouseEnterDelay,
    mouseLeaveDelay,
    overlayClassName,
    overlayStyle,
    destroyOnHidden,
    popupRender: mergedPopupRender
  };
  const {
    compactSize,
    compactItemClassnames
  } = useCompactItemContext(prefixCls, direction);
  const classes = classnames_default()(buttonPrefixCls, compactItemClassnames, className);
  if ('destroyPopupOnHide' in props) {
    dropdownProps.destroyPopupOnHide = destroyPopupOnHide;
  }
  if ('overlay' in props) {
    dropdownProps.overlay = overlay;
  }
  if ('open' in props) {
    dropdownProps.open = open;
  }
  if ('placement' in props) {
    dropdownProps.placement = placement;
  } else {
    dropdownProps.placement = direction === 'rtl' ? 'bottomLeft' : 'bottomRight';
  }
  const leftButton = /*#__PURE__*/react.createElement(es_button, {
    type: type,
    danger: danger,
    disabled: disabled,
    loading: loading,
    onClick: onClick,
    htmlType: htmlType,
    href: href,
    title: title
  }, children);
  const rightButton = /*#__PURE__*/react.createElement(es_button, {
    type: type,
    danger: danger,
    icon: icon
  });
  const [leftButtonToRender, rightButtonToRender] = buttonsRender([leftButton, rightButton]);
  return /*#__PURE__*/react.createElement(space.Compact, Object.assign({
    className: classes,
    size: compactSize,
    block: true
  }, restProps), leftButtonToRender, /*#__PURE__*/react.createElement(dropdown_dropdown, Object.assign({}, dropdownProps), rightButtonToRender));
};
DropdownButton.__ANT_BUTTON = true;
/* harmony default export */ var dropdown_button = (DropdownButton);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/dropdown/index.js
"use client";



const dropdown_Dropdown = dropdown_dropdown;
dropdown_Dropdown.Button = dropdown_button;
/* harmony default export */ var es_dropdown = (dropdown_Dropdown);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/flex/utils.js

const flexWrapValues = ['wrap', 'nowrap', 'wrap-reverse'];
const justifyContentValues = ['flex-start', 'flex-end', 'start', 'end', 'center', 'space-between', 'space-around', 'space-evenly', 'stretch', 'normal', 'left', 'right'];
const alignItemsValues = ['center', 'start', 'end', 'flex-start', 'flex-end', 'self-start', 'self-end', 'baseline', 'normal', 'stretch'];
const genClsWrap = (prefixCls, props) => {
  const wrap = props.wrap === true ? 'wrap' : props.wrap;
  return {
    [`${prefixCls}-wrap-${wrap}`]: wrap && flexWrapValues.includes(wrap)
  };
};
const genClsAlign = (prefixCls, props) => {
  const alignCls = {};
  alignItemsValues.forEach(cssKey => {
    alignCls[`${prefixCls}-align-${cssKey}`] = props.align === cssKey;
  });
  alignCls[`${prefixCls}-align-stretch`] = !props.align && !!props.vertical;
  return alignCls;
};
const genClsJustify = (prefixCls, props) => {
  const justifyCls = {};
  justifyContentValues.forEach(cssKey => {
    justifyCls[`${prefixCls}-justify-${cssKey}`] = props.justify === cssKey;
  });
  return justifyCls;
};
function createFlexClassNames(prefixCls, props) {
  return classnames_default()(Object.assign(Object.assign(Object.assign({}, genClsWrap(prefixCls, props)), genClsAlign(prefixCls, props)), genClsJustify(prefixCls, props)));
}
/* harmony default export */ var utils = (createFlexClassNames);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/flex/style/index.js


const genFlexStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [componentCls]: {
      display: 'flex',
      margin: 0,
      padding: 0,
      '&-vertical': {
        flexDirection: 'column'
      },
      '&-rtl': {
        direction: 'rtl'
      },
      '&:empty': {
        display: 'none'
      }
    }
  };
};
const genFlexGapStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [componentCls]: {
      '&-gap-small': {
        gap: token.flexGapSM
      },
      '&-gap-middle': {
        gap: token.flexGap
      },
      '&-gap-large': {
        gap: token.flexGapLG
      }
    }
  };
};
const genFlexWrapStyle = token => {
  const {
    componentCls
  } = token;
  const wrapStyle = {};
  flexWrapValues.forEach(value => {
    wrapStyle[`${componentCls}-wrap-${value}`] = {
      flexWrap: value
    };
  });
  return wrapStyle;
};
const genAlignItemsStyle = token => {
  const {
    componentCls
  } = token;
  const alignStyle = {};
  alignItemsValues.forEach(value => {
    alignStyle[`${componentCls}-align-${value}`] = {
      alignItems: value
    };
  });
  return alignStyle;
};
const genJustifyContentStyle = token => {
  const {
    componentCls
  } = token;
  const justifyStyle = {};
  justifyContentValues.forEach(value => {
    justifyStyle[`${componentCls}-justify-${value}`] = {
      justifyContent: value
    };
  });
  return justifyStyle;
};
const flex_style_prepareComponentToken = () => ({});
/* harmony default export */ var flex_style = (genStyleHooks('Flex', token => {
  const {
    paddingXS,
    padding,
    paddingLG
  } = token;
  const flexToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    flexGapSM: paddingXS,
    flexGap: padding,
    flexGapLG: paddingLG
  });
  return [genFlexStyle(flexToken), genFlexGapStyle(flexToken), genFlexWrapStyle(flexToken), genAlignItemsStyle(flexToken), genJustifyContentStyle(flexToken)];
}, flex_style_prepareComponentToken, {
  // Flex component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/46403
  resetStyle: false
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/flex/index.js
"use client";

var flex_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







const Flex = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      rootClassName,
      className,
      style,
      flex,
      gap,
      vertical = false,
      component: Component = 'div'
    } = props,
    othersProps = flex_rest(props, ["prefixCls", "rootClassName", "className", "style", "flex", "gap", "vertical", "component"]);
  const {
    flex: ctxFlex,
    direction: ctxDirection,
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('flex', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = flex_style(prefixCls);
  const mergedVertical = vertical !== null && vertical !== void 0 ? vertical : ctxFlex === null || ctxFlex === void 0 ? void 0 : ctxFlex.vertical;
  const mergedCls = classnames_default()(className, rootClassName, ctxFlex === null || ctxFlex === void 0 ? void 0 : ctxFlex.className, prefixCls, hashId, cssVarCls, utils(prefixCls, props), {
    [`${prefixCls}-rtl`]: ctxDirection === 'rtl',
    [`${prefixCls}-gap-${gap}`]: isPresetSize(gap),
    [`${prefixCls}-vertical`]: mergedVertical
  });
  const mergedStyle = Object.assign(Object.assign({}, ctxFlex === null || ctxFlex === void 0 ? void 0 : ctxFlex.style), style);
  if (flex) {
    mergedStyle.flex = flex;
  }
  if (gap && !isPresetSize(gap)) {
    mergedStyle.gap = gap;
  }
  return wrapCSSVar(/*#__PURE__*/react.createElement(Component, Object.assign({
    ref: ref,
    className: mergedCls,
    style: mergedStyle
  }, (0,omit/* default */.Z)(othersProps, ['justify', 'wrap', 'align']))));
});
if (false) {}
/* harmony default export */ var flex = (Flex);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/float-button/context.js

const FloatButtonGroupContext = /*#__PURE__*/react.createContext(undefined);
const {
  Provider: FloatButtonGroupProvider
} = FloatButtonGroupContext;
/* harmony default export */ var float_button_context = (FloatButtonGroupContext);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/convertToTooltipProps.js

function convertToTooltipProps(tooltip) {
  // isNil
  if (tooltip === undefined || tooltip === null) {
    return null;
  }
  if (typeof tooltip === 'object' && ! /*#__PURE__*/(0,react.isValidElement)(tooltip)) {
    return tooltip;
  }
  return {
    title: tooltip
  };
}
/* harmony default export */ var _util_convertToTooltipProps = (convertToTooltipProps);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/FileTextOutlined.js
// This icon file is generated automatically.
var FileTextOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z"
      }
    }]
  },
  "name": "file-text",
  "theme": "outlined"
};
/* harmony default export */ var asn_FileTextOutlined = (FileTextOutlined);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/FileTextOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileTextOutlined_FileTextOutlined = function FileTextOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_FileTextOutlined
  }));
};

/**![file-text](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTc5MC4yIDMyNkg2MDJWMTM3LjhMNzkwLjIgMzI2em0xLjggNTYySDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHpNNTA0IDYxOEgzMjBjLTQuNCAwLTggMy42LTggOHY0OGMwIDQuNCAzLjYgOCA4IDhoMTg0YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04ek0zMTIgNDkwdjQ4YzAgNC40IDMuNiA4IDggOGgzODRjNC40IDAgOC0zLjYgOC04di00OGMwLTQuNC0zLjYtOC04LThIMzIwYy00LjQgMC04IDMuNi04IDh6IiAvPjwvc3ZnPg==) */
var FileTextOutlined_RefIcon = /*#__PURE__*/react.forwardRef(FileTextOutlined_FileTextOutlined);
if (false) {}
/* harmony default export */ var icons_FileTextOutlined = (FileTextOutlined_RefIcon);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/float-button/FloatButtonContent.js
"use client";

var FloatButtonContent_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};



const FloatButtonContent = props => {
  const {
      icon,
      description,
      prefixCls,
      className
    } = props,
    rest = FloatButtonContent_rest(props, ["icon", "description", "prefixCls", "className"]);
  const defaultElement = /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-icon`
  }, /*#__PURE__*/react.createElement(icons_FileTextOutlined, null));
  return /*#__PURE__*/react.createElement("div", Object.assign({}, rest, {
    className: classnames_default()(className, `${prefixCls}-content`)
  }), icon || description ? (/*#__PURE__*/react.createElement(react.Fragment, null, icon && /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-icon`
  }, icon), description && /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-description`
  }, description))) : defaultElement);
};
/* harmony default export */ var float_button_FloatButtonContent = (/*#__PURE__*/(0,react.memo)(FloatButtonContent));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/float-button/util.js
const float_button_util_getOffset = radius => {
  if (radius === 0) {
    return 0;
  }
  // 如果要考虑通用性，这里应该用三角函数 Math.sin(45)
  // 但是这个场景比较特殊，始终是等腰直角三角形，所以直接用 Math.sqrt() 开方即可
  return radius - Math.sqrt(Math.pow(radius, 2) / 2);
};
/* harmony default export */ var util = (float_button_util_getOffset);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/float-button/style/keyframes.js


const floatButtonGroupMotion = token => {
  const {
    componentCls,
    floatButtonSize,
    motionDurationSlow,
    motionEaseInOutCirc,
    calc
  } = token;
  const moveTopIn = new cssinjs_es/* Keyframes */.E4('antFloatButtonMoveTopIn', {
    '0%': {
      transform: `translate3d(0, ${(0,cssinjs_es/* unit */.bf)(floatButtonSize)}, 0)`,
      transformOrigin: '0 0',
      opacity: 0
    },
    '100%': {
      transform: 'translate3d(0, 0, 0)',
      transformOrigin: '0 0',
      opacity: 1
    }
  });
  const moveTopOut = new cssinjs_es/* Keyframes */.E4('antFloatButtonMoveTopOut', {
    '0%': {
      transform: 'translate3d(0, 0, 0)',
      transformOrigin: '0 0',
      opacity: 1
    },
    '100%': {
      transform: `translate3d(0, ${(0,cssinjs_es/* unit */.bf)(floatButtonSize)}, 0)`,
      transformOrigin: '0 0',
      opacity: 0
    }
  });
  const moveRightIn = new cssinjs_es/* Keyframes */.E4('antFloatButtonMoveRightIn', {
    '0%': {
      transform: `translate3d(${(0,cssinjs_es/* unit */.bf)(calc(floatButtonSize).mul(-1).equal())}, 0, 0)`,
      transformOrigin: '0 0',
      opacity: 0
    },
    '100%': {
      transform: 'translate3d(0, 0, 0)',
      transformOrigin: '0 0',
      opacity: 1
    }
  });
  const moveRightOut = new cssinjs_es/* Keyframes */.E4('antFloatButtonMoveRightOut', {
    '0%': {
      transform: 'translate3d(0, 0, 0)',
      transformOrigin: '0 0',
      opacity: 1
    },
    '100%': {
      transform: `translate3d(${(0,cssinjs_es/* unit */.bf)(calc(floatButtonSize).mul(-1).equal())}, 0, 0)`,
      transformOrigin: '0 0',
      opacity: 0
    }
  });
  const moveBottomIn = new cssinjs_es/* Keyframes */.E4('antFloatButtonMoveBottomIn', {
    '0%': {
      transform: `translate3d(0, ${(0,cssinjs_es/* unit */.bf)(calc(floatButtonSize).mul(-1).equal())}, 0)`,
      transformOrigin: '0 0',
      opacity: 0
    },
    '100%': {
      transform: 'translate3d(0, 0, 0)',
      transformOrigin: '0 0',
      opacity: 1
    }
  });
  const moveBottomOut = new cssinjs_es/* Keyframes */.E4('antFloatButtonMoveBottomOut', {
    '0%': {
      transform: 'translate3d(0, 0, 0)',
      transformOrigin: '0 0',
      opacity: 1
    },
    '100%': {
      transform: `translate3d(0, ${(0,cssinjs_es/* unit */.bf)(calc(floatButtonSize).mul(-1).equal())}, 0)`,
      transformOrigin: '0 0',
      opacity: 0
    }
  });
  const moveLeftIn = new cssinjs_es/* Keyframes */.E4('antFloatButtonMoveLeftIn', {
    '0%': {
      transform: `translate3d(${(0,cssinjs_es/* unit */.bf)(floatButtonSize)}, 0, 0)`,
      transformOrigin: '0 0',
      opacity: 0
    },
    '100%': {
      transform: 'translate3d(0, 0, 0)',
      transformOrigin: '0 0',
      opacity: 1
    }
  });
  const moveLeftOut = new cssinjs_es/* Keyframes */.E4('antFloatButtonMoveLeftOut', {
    '0%': {
      transform: 'translate3d(0, 0, 0)',
      transformOrigin: '0 0',
      opacity: 1
    },
    '100%': {
      transform: `translate3d(${(0,cssinjs_es/* unit */.bf)(floatButtonSize)}, 0, 0)`,
      transformOrigin: '0 0',
      opacity: 0
    }
  });
  const groupPrefixCls = `${componentCls}-group`;
  return [{
    [groupPrefixCls]: {
      [`&${groupPrefixCls}-top ${groupPrefixCls}-wrap`]: initMotion(`${groupPrefixCls}-wrap`, moveTopIn, moveTopOut, motionDurationSlow, true),
      [`&${groupPrefixCls}-bottom ${groupPrefixCls}-wrap`]: initMotion(`${groupPrefixCls}-wrap`, moveBottomIn, moveBottomOut, motionDurationSlow, true),
      [`&${groupPrefixCls}-left ${groupPrefixCls}-wrap`]: initMotion(`${groupPrefixCls}-wrap`, moveLeftIn, moveLeftOut, motionDurationSlow, true),
      [`&${groupPrefixCls}-right ${groupPrefixCls}-wrap`]: initMotion(`${groupPrefixCls}-wrap`, moveRightIn, moveRightOut, motionDurationSlow, true)
    }
  }, {
    [`${groupPrefixCls}-wrap`]: {
      [`&${groupPrefixCls}-wrap-enter, &${groupPrefixCls}-wrap-appear`]: {
        opacity: 0,
        animationTimingFunction: motionEaseInOutCirc
      },
      [`&${groupPrefixCls}-wrap-leave`]: {
        opacity: 1,
        animationTimingFunction: motionEaseInOutCirc
      }
    }
  }];
};
/* harmony default export */ var keyframes = (floatButtonGroupMotion);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/float-button/style/index.js






// ============================== Group ==============================
const floatButtonGroupStyle = token => {
  const {
    antCls,
    componentCls,
    floatButtonSize,
    margin,
    borderRadiusLG,
    borderRadiusSM,
    badgeOffset,
    floatButtonBodyPadding,
    zIndexPopupBase,
    calc
  } = token;
  const groupPrefixCls = `${componentCls}-group`;
  return {
    [groupPrefixCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      zIndex: zIndexPopupBase,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      border: 'none',
      position: 'fixed',
      height: 'auto',
      boxShadow: 'none',
      minWidth: floatButtonSize,
      minHeight: floatButtonSize,
      insetInlineEnd: token.floatButtonInsetInlineEnd,
      bottom: token.floatButtonInsetBlockEnd,
      borderRadius: borderRadiusLG,
      [`${groupPrefixCls}-wrap`]: {
        zIndex: -1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute'
      },
      [`&${groupPrefixCls}-rtl`]: {
        direction: 'rtl'
      },
      [componentCls]: {
        position: 'static'
      }
    }),
    [`${groupPrefixCls}-top > ${groupPrefixCls}-wrap`]: {
      flexDirection: 'column',
      top: 'auto',
      bottom: calc(floatButtonSize).add(margin).equal(),
      '&::after': {
        content: '""',
        position: 'absolute',
        width: '100%',
        height: margin,
        bottom: calc(margin).mul(-1).equal()
      }
    },
    [`${groupPrefixCls}-bottom > ${groupPrefixCls}-wrap`]: {
      flexDirection: 'column',
      top: calc(floatButtonSize).add(margin).equal(),
      bottom: 'auto',
      '&::after': {
        content: '""',
        position: 'absolute',
        width: '100%',
        height: margin,
        top: calc(margin).mul(-1).equal()
      }
    },
    [`${groupPrefixCls}-right > ${groupPrefixCls}-wrap`]: {
      flexDirection: 'row',
      left: {
        _skip_check_: true,
        value: calc(floatButtonSize).add(margin).equal()
      },
      right: {
        _skip_check_: true,
        value: 'auto'
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        width: margin,
        height: '100%',
        left: {
          _skip_check_: true,
          value: calc(margin).mul(-1).equal()
        }
      }
    },
    [`${groupPrefixCls}-left > ${groupPrefixCls}-wrap`]: {
      flexDirection: 'row',
      left: {
        _skip_check_: true,
        value: 'auto'
      },
      right: {
        _skip_check_: true,
        value: calc(floatButtonSize).add(margin).equal()
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        width: margin,
        height: '100%',
        right: {
          _skip_check_: true,
          value: calc(margin).mul(-1).equal()
        }
      }
    },
    [`${groupPrefixCls}-circle`]: {
      gap: margin,
      [`${groupPrefixCls}-wrap`]: {
        gap: margin
      }
    },
    [`${groupPrefixCls}-square`]: {
      [`${componentCls}-square`]: {
        padding: 0,
        borderRadius: 0,
        [`&${groupPrefixCls}-trigger`]: {
          borderRadius: borderRadiusLG
        },
        '&:first-child': {
          borderStartStartRadius: borderRadiusLG,
          borderStartEndRadius: borderRadiusLG
        },
        '&:last-child': {
          borderEndStartRadius: borderRadiusLG,
          borderEndEndRadius: borderRadiusLG
        },
        '&:not(:last-child)': {
          borderBottom: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
        },
        [`${antCls}-badge`]: {
          [`${antCls}-badge-count`]: {
            top: calc(calc(floatButtonBodyPadding).add(badgeOffset)).mul(-1).equal(),
            insetInlineEnd: calc(calc(floatButtonBodyPadding).add(badgeOffset)).mul(-1).equal()
          }
        }
      },
      [`${groupPrefixCls}-wrap`]: {
        borderRadius: borderRadiusLG,
        boxShadow: token.boxShadowSecondary,
        [`${componentCls}-square`]: {
          boxShadow: 'none',
          borderRadius: 0,
          padding: floatButtonBodyPadding,
          [`${componentCls}-body`]: {
            width: token.floatButtonBodySize,
            height: token.floatButtonBodySize,
            borderRadius: borderRadiusSM
          }
        }
      }
    },
    [`${groupPrefixCls}-top > ${groupPrefixCls}-wrap, ${groupPrefixCls}-bottom > ${groupPrefixCls}-wrap`]: {
      [`> ${componentCls}-square`]: {
        '&:first-child': {
          borderStartStartRadius: borderRadiusLG,
          borderStartEndRadius: borderRadiusLG
        },
        '&:last-child': {
          borderEndStartRadius: borderRadiusLG,
          borderEndEndRadius: borderRadiusLG
        },
        '&:not(:last-child)': {
          borderBottom: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
        }
      }
    },
    [`${groupPrefixCls}-left > ${groupPrefixCls}-wrap, ${groupPrefixCls}-right > ${groupPrefixCls}-wrap`]: {
      [`> ${componentCls}-square`]: {
        '&:first-child': {
          borderStartStartRadius: borderRadiusLG,
          borderEndStartRadius: borderRadiusLG
        },
        '&:last-child': {
          borderStartEndRadius: borderRadiusLG,
          borderEndEndRadius: borderRadiusLG
        },
        '&:not(:last-child)': {
          borderBottom: 'none',
          borderInlineEnd: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
        }
      }
    },
    [`${groupPrefixCls}-circle-shadow`]: {
      boxShadow: 'none'
    },
    [`${groupPrefixCls}-square-shadow`]: {
      boxShadow: token.boxShadowSecondary,
      [`${componentCls}-square`]: {
        boxShadow: 'none',
        padding: floatButtonBodyPadding,
        [`${componentCls}-body`]: {
          width: token.floatButtonBodySize,
          height: token.floatButtonBodySize,
          borderRadius: borderRadiusSM
        }
      }
    }
  };
};
// ============================== Shared ==============================
const sharedFloatButtonStyle = token => {
  const {
    antCls,
    componentCls,
    floatButtonBodyPadding,
    floatButtonIconSize,
    floatButtonSize,
    borderRadiusLG,
    badgeOffset,
    dotOffsetInSquare,
    dotOffsetInCircle,
    zIndexPopupBase,
    calc
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      border: 'none',
      position: 'fixed',
      cursor: 'pointer',
      zIndex: zIndexPopupBase,
      // Do not remove the 'display: block' here.
      // Deleting it will cause marginBottom to become ineffective.
      // Ref: https://github.com/ant-design/ant-design/issues/44700
      display: 'block',
      width: floatButtonSize,
      height: floatButtonSize,
      insetInlineEnd: token.floatButtonInsetInlineEnd,
      bottom: token.floatButtonInsetBlockEnd,
      boxShadow: token.boxShadowSecondary,
      // Pure Panel
      '&-pure': {
        position: 'relative',
        inset: 'auto'
      },
      '&:empty': {
        display: 'none'
      },
      [`${antCls}-badge`]: {
        width: '100%',
        height: '100%',
        [`${antCls}-badge-count`]: {
          transform: 'translate(0, 0)',
          transformOrigin: 'center',
          top: calc(badgeOffset).mul(-1).equal(),
          insetInlineEnd: calc(badgeOffset).mul(-1).equal()
        }
      },
      [`${componentCls}-body`]: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: `all ${token.motionDurationMid}`,
        [`${componentCls}-content`]: {
          overflow: 'hidden',
          textAlign: 'center',
          minHeight: floatButtonSize,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: `${(0,cssinjs_es/* unit */.bf)(calc(floatButtonBodyPadding).div(2).equal())} ${(0,cssinjs_es/* unit */.bf)(floatButtonBodyPadding)}`,
          [`${componentCls}-icon`]: {
            textAlign: 'center',
            margin: 'auto',
            width: floatButtonIconSize,
            fontSize: floatButtonIconSize,
            lineHeight: 1
          }
        }
      }
    }),
    [`${componentCls}-rtl`]: {
      direction: 'rtl'
    },
    [`${componentCls}-circle`]: {
      height: floatButtonSize,
      borderRadius: '50%',
      [`${antCls}-badge`]: {
        [`${antCls}-badge-dot`]: {
          top: dotOffsetInCircle,
          insetInlineEnd: dotOffsetInCircle
        }
      },
      [`${componentCls}-body`]: {
        borderRadius: '50%'
      }
    },
    [`${componentCls}-square`]: {
      height: 'auto',
      minHeight: floatButtonSize,
      borderRadius: borderRadiusLG,
      [`${antCls}-badge`]: {
        [`${antCls}-badge-dot`]: {
          top: dotOffsetInSquare,
          insetInlineEnd: dotOffsetInSquare
        }
      },
      [`${componentCls}-body`]: {
        height: 'auto',
        borderRadius: borderRadiusLG
      }
    },
    [`${componentCls}-default`]: {
      backgroundColor: token.floatButtonBackgroundColor,
      transition: `background-color ${token.motionDurationMid}`,
      [`${componentCls}-body`]: {
        backgroundColor: token.floatButtonBackgroundColor,
        transition: `background-color ${token.motionDurationMid}`,
        '&:hover': {
          backgroundColor: token.colorFillContent
        },
        [`${componentCls}-content`]: {
          [`${componentCls}-icon`]: {
            color: token.colorText
          },
          [`${componentCls}-description`]: {
            display: 'flex',
            alignItems: 'center',
            lineHeight: (0,cssinjs_es/* unit */.bf)(token.fontSizeLG),
            color: token.colorText,
            fontSize: token.fontSizeSM
          }
        }
      }
    },
    [`${componentCls}-primary`]: {
      backgroundColor: token.colorPrimary,
      [`${componentCls}-body`]: {
        backgroundColor: token.colorPrimary,
        transition: `background-color ${token.motionDurationMid}`,
        '&:hover': {
          backgroundColor: token.colorPrimaryHover
        },
        [`${componentCls}-content`]: {
          [`${componentCls}-icon`]: {
            color: token.colorTextLightSolid
          },
          [`${componentCls}-description`]: {
            display: 'flex',
            alignItems: 'center',
            lineHeight: (0,cssinjs_es/* unit */.bf)(token.fontSizeLG),
            color: token.colorTextLightSolid,
            fontSize: token.fontSizeSM
          }
        }
      }
    }
  };
};
// ============================== Export ==============================
const float_button_style_prepareComponentToken = token => ({
  dotOffsetInCircle: util(token.controlHeightLG / 2),
  dotOffsetInSquare: util(token.borderRadiusLG)
});
/* harmony default export */ var float_button_style = (genStyleHooks('FloatButton', token => {
  const {
    colorTextLightSolid,
    colorBgElevated,
    controlHeightLG,
    marginXXL,
    marginLG,
    fontSize,
    fontSizeIcon,
    controlItemBgHover,
    paddingXXS,
    calc
  } = token;
  const floatButtonToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    floatButtonBackgroundColor: colorBgElevated,
    floatButtonColor: colorTextLightSolid,
    floatButtonHoverBackgroundColor: controlItemBgHover,
    floatButtonFontSize: fontSize,
    floatButtonIconSize: calc(fontSizeIcon).mul(1.5).equal(),
    floatButtonSize: controlHeightLG,
    floatButtonInsetBlockEnd: marginXXL,
    floatButtonInsetInlineEnd: marginLG,
    floatButtonBodySize: calc(controlHeightLG).sub(calc(paddingXXS).mul(2)).equal(),
    // 这里的 paddingXXS 是简写，完整逻辑是 (controlHeightLG - (controlHeightLG - paddingXXS * 2)) / 2,
    floatButtonBodyPadding: paddingXXS,
    badgeOffset: calc(paddingXXS).mul(1.5).equal()
  });
  return [floatButtonGroupStyle(floatButtonToken), sharedFloatButtonStyle(floatButtonToken), initFadeMotion(token), keyframes(floatButtonToken)];
}, float_button_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/float-button/FloatButton.js
"use client";

var FloatButton_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};













const floatButtonPrefixCls = 'float-btn';
const InternalFloatButton = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      style,
      type = 'default',
      shape = 'circle',
      icon,
      description,
      tooltip,
      htmlType = 'button',
      badge = {}
    } = props,
    restProps = FloatButton_rest(props, ["prefixCls", "className", "rootClassName", "style", "type", "shape", "icon", "description", "tooltip", "htmlType", "badge"]);
  const {
    getPrefixCls,
    direction
  } = (0,react.useContext)(ConfigContext);
  const groupShape = (0,react.useContext)(float_button_context);
  const prefixCls = getPrefixCls(floatButtonPrefixCls, customizePrefixCls);
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = float_button_style(prefixCls, rootCls);
  const mergedShape = groupShape || shape;
  const classString = classnames_default()(hashId, cssVarCls, rootCls, prefixCls, className, rootClassName, `${prefixCls}-${type}`, `${prefixCls}-${mergedShape}`, {
    [`${prefixCls}-rtl`]: direction === 'rtl'
  });
  // ============================ zIndex ============================
  const [zIndex] = useZIndex('FloatButton', style === null || style === void 0 ? void 0 : style.zIndex);
  const mergedStyle = Object.assign(Object.assign({}, style), {
    zIndex
  });
  // 虽然在 ts 中已经 omit 过了，但是为了防止多余的属性被透传进来，这里再 omit 一遍，以防万一
  const badgeProps = (0,omit/* default */.Z)(badge, ['title', 'children', 'status', 'text']);
  let buttonNode = /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-body`
  }, /*#__PURE__*/react.createElement(float_button_FloatButtonContent, {
    prefixCls: prefixCls,
    description: description,
    icon: icon
  }));
  if ('badge' in props) {
    buttonNode = /*#__PURE__*/react.createElement(es_badge, Object.assign({}, badgeProps), buttonNode);
  }
  // ============================ Tooltip ============================
  const tooltipProps = _util_convertToTooltipProps(tooltip);
  if (tooltipProps) {
    buttonNode = /*#__PURE__*/react.createElement(es_tooltip, Object.assign({}, tooltipProps), buttonNode);
  }
  if (false) {}
  return wrapCSSVar(props.href ? (/*#__PURE__*/react.createElement("a", Object.assign({
    ref: ref
  }, restProps, {
    className: classString,
    style: mergedStyle
  }), buttonNode)) : (/*#__PURE__*/react.createElement("button", Object.assign({
    ref: ref
  }, restProps, {
    className: classString,
    style: mergedStyle,
    type: htmlType
  }), buttonNode)));
});
const FloatButton = InternalFloatButton;
if (false) {}
/* harmony default export */ var float_button_FloatButton = (FloatButton);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/float-button/BackTop.js
"use client";

var BackTop_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};












const defaultIcon = /*#__PURE__*/react.createElement(icons_VerticalAlignTopOutlined, null);
const BackTop_BackTop = /*#__PURE__*/react.forwardRef((props, ref) => {
  var _a;
  const {
    backTopIcon: contextIcon
  } = useComponentConfig('floatButton');
  const {
      prefixCls: customizePrefixCls,
      className,
      type = 'default',
      shape = 'circle',
      visibilityHeight = 400,
      icon,
      target,
      onClick,
      duration = 450
    } = props,
    restProps = BackTop_rest(props, ["prefixCls", "className", "type", "shape", "visibilityHeight", "icon", "target", "onClick", "duration"]);
  const mergedIcon = (_a = icon !== null && icon !== void 0 ? icon : contextIcon) !== null && _a !== void 0 ? _a : defaultIcon;
  const [visible, setVisible] = (0,react.useState)(visibilityHeight === 0);
  const internalRef = react.useRef(null);
  react.useImperativeHandle(ref, () => ({
    nativeElement: internalRef.current
  }));
  const getDefaultTarget = () => {
    var _a;
    return ((_a = internalRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) || window;
  };
  const handleScroll = _util_throttleByAnimationFrame(e => {
    const scrollTop = _util_getScroll(e.target);
    setVisible(scrollTop >= visibilityHeight);
  });
  (0,react.useEffect)(() => {
    const getTarget = target || getDefaultTarget;
    const container = getTarget();
    handleScroll({
      target: container
    });
    container === null || container === void 0 ? void 0 : container.addEventListener('scroll', handleScroll);
    return () => {
      handleScroll.cancel();
      container === null || container === void 0 ? void 0 : container.removeEventListener('scroll', handleScroll);
    };
  }, [target]);
  const scrollToTop = e => {
    scrollTo(0, {
      getContainer: target || getDefaultTarget,
      duration
    });
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  const {
    getPrefixCls
  } = (0,react.useContext)(ConfigContext);
  const prefixCls = getPrefixCls(floatButtonPrefixCls, customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  const groupShape = (0,react.useContext)(float_button_context);
  const mergedShape = groupShape || shape;
  const contentProps = Object.assign({
    prefixCls,
    icon: mergedIcon,
    type,
    shape: mergedShape
  }, restProps);
  return /*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, {
    visible: visible,
    motionName: `${rootPrefixCls}-fade`
  }, ({
    className: motionClassName
  }, setRef) => (/*#__PURE__*/react.createElement(float_button_FloatButton, Object.assign({
    ref: (0,es_ref/* composeRef */.sQ)(internalRef, setRef)
  }, contentProps, {
    onClick: scrollToTop,
    className: classnames_default()(className, motionClassName)
  }))));
});
if (false) {}
/* harmony default export */ var float_button_BackTop = (BackTop_BackTop);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/float-button/FloatButtonGroup.js
"use client";

var FloatButtonGroup_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};














const FloatButtonGroup = props => {
  var _a;
  const {
      prefixCls: customizePrefixCls,
      className,
      style,
      shape = 'circle',
      type = 'default',
      placement = 'top',
      icon = /*#__PURE__*/react.createElement(icons_FileTextOutlined, null),
      closeIcon,
      description,
      trigger,
      children,
      onOpenChange,
      open: customOpen,
      onClick: onTriggerButtonClick
    } = props,
    floatButtonProps = FloatButtonGroup_rest(props, ["prefixCls", "className", "style", "shape", "type", "placement", "icon", "closeIcon", "description", "trigger", "children", "onOpenChange", "open", "onClick"]);
  const {
    direction,
    getPrefixCls,
    closeIcon: contextCloseIcon
  } = useComponentConfig('floatButtonGroup');
  const mergedCloseIcon = (_a = closeIcon !== null && closeIcon !== void 0 ? closeIcon : contextCloseIcon) !== null && _a !== void 0 ? _a : /*#__PURE__*/react.createElement(CloseOutlined/* default */.Z, null);
  const prefixCls = getPrefixCls(floatButtonPrefixCls, customizePrefixCls);
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = float_button_style(prefixCls, rootCls);
  const groupPrefixCls = `${prefixCls}-group`;
  const isMenuMode = trigger && ['click', 'hover'].includes(trigger);
  const isValidPlacement = placement && ['top', 'left', 'right', 'bottom'].includes(placement);
  const groupCls = classnames_default()(groupPrefixCls, hashId, cssVarCls, rootCls, className, {
    [`${groupPrefixCls}-rtl`]: direction === 'rtl',
    [`${groupPrefixCls}-${shape}`]: shape,
    [`${groupPrefixCls}-${shape}-shadow`]: !isMenuMode,
    [`${groupPrefixCls}-${placement}`]: isMenuMode && isValidPlacement // 只有菜单模式才支持弹出方向
  });
  // ============================ zIndex ============================
  const [zIndex] = useZIndex('FloatButton', style === null || style === void 0 ? void 0 : style.zIndex);
  const mergedStyle = Object.assign(Object.assign({}, style), {
    zIndex
  });
  const wrapperCls = classnames_default()(hashId, `${groupPrefixCls}-wrap`);
  const [open, setOpen] = (0,useMergedState/* default */.Z)(false, {
    value: customOpen
  });
  const floatButtonGroupRef = react.useRef(null);
  // ========================== Open ==========================
  const hoverTrigger = trigger === 'hover';
  const clickTrigger = trigger === 'click';
  const triggerOpen = (0,hooks_useEvent/* default */.Z)(nextOpen => {
    if (open !== nextOpen) {
      setOpen(nextOpen);
      onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(nextOpen);
    }
  });
  // ===================== Trigger: Hover =====================
  const onMouseEnter = () => {
    if (hoverTrigger) {
      triggerOpen(true);
    }
  };
  const onMouseLeave = () => {
    if (hoverTrigger) {
      triggerOpen(false);
    }
  };
  // ===================== Trigger: Click =====================
  const onInternalTriggerButtonClick = e => {
    if (clickTrigger) {
      triggerOpen(!open);
    }
    onTriggerButtonClick === null || onTriggerButtonClick === void 0 ? void 0 : onTriggerButtonClick(e);
  };
  react.useEffect(() => {
    if (clickTrigger) {
      const onDocClick = e => {
        var _a;
        // Skip if click on the group
        if ((_a = floatButtonGroupRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
          return;
        }
        triggerOpen(false);
      };
      document.addEventListener('click', onDocClick, {
        capture: true
      });
      return () => document.removeEventListener('click', onDocClick, {
        capture: true
      });
    }
  }, [clickTrigger]);
  // ======================== Warning =========================
  if (false) {}
  // ========================= Render =========================
  return wrapCSSVar(/*#__PURE__*/react.createElement(FloatButtonGroupProvider, {
    value: shape
  }, /*#__PURE__*/react.createElement("div", {
    ref: floatButtonGroupRef,
    className: groupCls,
    style: mergedStyle,
    // Hover trigger
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, isMenuMode ? (/*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, {
    visible: open,
    motionName: `${groupPrefixCls}-wrap`
  }, ({
    className: motionClassName
  }) => (/*#__PURE__*/react.createElement("div", {
    className: classnames_default()(motionClassName, wrapperCls)
  }, children))), /*#__PURE__*/react.createElement(float_button_FloatButton, Object.assign({
    type: type,
    icon: open ? mergedCloseIcon : icon,
    description: description,
    "aria-label": props['aria-label'],
    className: `${groupPrefixCls}-trigger`,
    onClick: onInternalTriggerButtonClick
  }, floatButtonProps)))) : children)));
};
/* harmony default export */ var float_button_FloatButtonGroup = (FloatButtonGroup);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/float-button/PurePanel.js
"use client";

var float_button_PurePanel_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable react/no-array-index-key */






const PureFloatButton = _a => {
  var {
      backTop
    } = _a,
    props = float_button_PurePanel_rest(_a, ["backTop"]);
  return backTop ? /*#__PURE__*/react.createElement(float_button_BackTop, Object.assign({}, props, {
    visibilityHeight: 0
  })) : /*#__PURE__*/react.createElement(float_button_FloatButton, Object.assign({}, props));
};
/** @private Internal Component. Do not use in your production. */
const float_button_PurePanel_PurePanel = _a => {
  var {
      className,
      items
    } = _a,
    props = float_button_PurePanel_rest(_a, ["className", "items"]);
  const {
    prefixCls: customizePrefixCls
  } = props;
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls(floatButtonPrefixCls, customizePrefixCls);
  const pureCls = `${prefixCls}-pure`;
  if (items) {
    return /*#__PURE__*/react.createElement(float_button_FloatButtonGroup, Object.assign({
      className: classnames_default()(className, pureCls)
    }, props), items.map((item, index) => (/*#__PURE__*/react.createElement(PureFloatButton, Object.assign({
      key: index
    }, item)))));
  }
  return /*#__PURE__*/react.createElement(PureFloatButton, Object.assign({
    className: classnames_default()(className, pureCls)
  }, props));
};
/* harmony default export */ var float_button_PurePanel = (float_button_PurePanel_PurePanel);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/float-button/index.js
"use client";





float_button_FloatButton.BackTop = float_button_BackTop;
float_button_FloatButton.Group = float_button_FloatButtonGroup;
float_button_FloatButton._InternalPanelDoNotUseOrYouWillBeFired = float_button_PurePanel;
/* harmony default export */ var float_button = (float_button_FloatButton);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/hooks/useDebounce.js

function useDebounce(value) {
  const [cacheValue, setCacheValue] = react.useState(value);
  react.useEffect(() => {
    const timeout = setTimeout(() => {
      setCacheValue(value);
    }, value.length ? 0 : 10);
    return () => {
      clearTimeout(timeout);
    };
  }, [value]);
  return cacheValue;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/style/explain.js
const genFormValidateMotionStyle = token => {
  const {
    componentCls
  } = token;
  const helpCls = `${componentCls}-show-help`;
  const helpItemCls = `${componentCls}-show-help-item`;
  return {
    [helpCls]: {
      // Explain holder
      transition: `opacity ${token.motionDurationFast} ${token.motionEaseInOut}`,
      '&-appear, &-enter': {
        opacity: 0,
        '&-active': {
          opacity: 1
        }
      },
      '&-leave': {
        opacity: 1,
        '&-active': {
          opacity: 0
        }
      },
      // Explain
      [helpItemCls]: {
        overflow: 'hidden',
        transition: `height ${token.motionDurationFast} ${token.motionEaseInOut},
                     opacity ${token.motionDurationFast} ${token.motionEaseInOut},
                     transform ${token.motionDurationFast} ${token.motionEaseInOut} !important`,
        [`&${helpItemCls}-appear, &${helpItemCls}-enter`]: {
          transform: `translateY(-5px)`,
          opacity: 0,
          '&-active': {
            transform: 'translateY(0)',
            opacity: 1
          }
        },
        [`&${helpItemCls}-leave-active`]: {
          transform: `translateY(-5px)`
        }
      }
    }
  };
};
/* harmony default export */ var explain = (genFormValidateMotionStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/style/index.js





const resetForm = token => ({
  legend: {
    display: 'block',
    width: '100%',
    marginBottom: token.marginLG,
    padding: 0,
    color: token.colorTextDescription,
    fontSize: token.fontSizeLG,
    lineHeight: 'inherit',
    border: 0,
    borderBottom: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
  },
  'input[type="search"]': {
    boxSizing: 'border-box'
  },
  // Position radios and checkboxes better
  'input[type="radio"], input[type="checkbox"]': {
    lineHeight: 'normal'
  },
  'input[type="file"]': {
    display: 'block'
  },
  // Make range inputs behave like textual form controls
  'input[type="range"]': {
    display: 'block',
    width: '100%'
  },
  // Make multiple select elements height not fixed
  'select[multiple], select[size]': {
    height: 'auto'
  },
  // Focus for file, radio, and checkbox
  [`input[type='file']:focus,
  input[type='radio']:focus,
  input[type='checkbox']:focus`]: {
    outline: 0,
    boxShadow: `0 0 0 ${(0,cssinjs_es/* unit */.bf)(token.controlOutlineWidth)} ${token.controlOutline}`
  },
  // Adjust output element
  output: {
    display: 'block',
    paddingTop: 15,
    color: token.colorText,
    fontSize: token.fontSize,
    lineHeight: token.lineHeight
  }
});
const genFormSize = (token, height) => {
  const {
    formItemCls
  } = token;
  return {
    [formItemCls]: {
      [`${formItemCls}-label > label`]: {
        height
      },
      [`${formItemCls}-control-input`]: {
        minHeight: height
      }
    }
  };
};
const genFormStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [token.componentCls]: Object.assign(Object.assign(Object.assign({}, resetComponent(token)), resetForm(token)), {
      [`${componentCls}-text`]: {
        display: 'inline-block',
        paddingInlineEnd: token.paddingSM
      },
      // ================================================================
      // =                             Size                             =
      // ================================================================
      '&-small': Object.assign({}, genFormSize(token, token.controlHeightSM)),
      '&-large': Object.assign({}, genFormSize(token, token.controlHeightLG))
    })
  };
};
const genFormItemStyle = token => {
  const {
    formItemCls,
    iconCls,
    rootPrefixCls,
    antCls,
    labelRequiredMarkColor,
    labelColor,
    labelFontSize,
    labelHeight,
    labelColonMarginInlineStart,
    labelColonMarginInlineEnd,
    itemMarginBottom
  } = token;
  return {
    [formItemCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      marginBottom: itemMarginBottom,
      verticalAlign: 'top',
      '&-with-help': {
        transition: 'none'
      },
      [`&-hidden,
        &-hidden${antCls}-row`]: {
        // https://github.com/ant-design/ant-design/issues/26141
        display: 'none'
      },
      '&-has-warning': {
        [`${formItemCls}-split`]: {
          color: token.colorError
        }
      },
      '&-has-error': {
        [`${formItemCls}-split`]: {
          color: token.colorWarning
        }
      },
      // ==============================================================
      // =                            Label                           =
      // ==============================================================
      [`${formItemCls}-label`]: {
        flexGrow: 0,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textAlign: 'end',
        verticalAlign: 'middle',
        '&-left': {
          textAlign: 'start'
        },
        '&-wrap': {
          overflow: 'unset',
          lineHeight: token.lineHeight,
          whiteSpace: 'unset',
          '> label': {
            verticalAlign: 'middle',
            textWrap: 'balance'
          }
        },
        '> label': {
          position: 'relative',
          display: 'inline-flex',
          alignItems: 'center',
          maxWidth: '100%',
          height: labelHeight,
          color: labelColor,
          fontSize: labelFontSize,
          [`> ${iconCls}`]: {
            fontSize: token.fontSize,
            verticalAlign: 'top'
          },
          [`&${formItemCls}-required`]: {
            '&::before': {
              display: 'inline-block',
              marginInlineEnd: token.marginXXS,
              color: labelRequiredMarkColor,
              fontSize: token.fontSize,
              fontFamily: 'SimSun, sans-serif',
              lineHeight: 1,
              content: '"*"'
            },
            [`&${formItemCls}-required-mark-hidden, &${formItemCls}-required-mark-optional`]: {
              '&::before': {
                display: 'none'
              }
            }
          },
          // Optional mark
          [`${formItemCls}-optional`]: {
            display: 'inline-block',
            marginInlineStart: token.marginXXS,
            color: token.colorTextDescription,
            [`&${formItemCls}-required-mark-hidden`]: {
              display: 'none'
            }
          },
          // Optional mark
          [`${formItemCls}-tooltip`]: {
            color: token.colorTextDescription,
            cursor: 'help',
            writingMode: 'horizontal-tb',
            marginInlineStart: token.marginXXS
          },
          '&::after': {
            content: '":"',
            position: 'relative',
            marginBlock: 0,
            marginInlineStart: labelColonMarginInlineStart,
            marginInlineEnd: labelColonMarginInlineEnd
          },
          [`&${formItemCls}-no-colon::after`]: {
            content: '"\\a0"'
          }
        }
      },
      // ==============================================================
      // =                            Input                           =
      // ==============================================================
      [`${formItemCls}-control`]: {
        ['--ant-display']: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        [`&:first-child:not([class^="'${rootPrefixCls}-col-'"]):not([class*="' ${rootPrefixCls}-col-'"])`]: {
          width: '100%'
        },
        '&-input': {
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          minHeight: token.controlHeight,
          '&-content': {
            flex: 'auto',
            maxWidth: '100%',
            // Fix https://github.com/ant-design/ant-design/issues/54042
            // Remove impact of whitespaces
            [`&:has(> ${antCls}-switch:only-child, > ${antCls}-rate:only-child)`]: {
              display: 'flex',
              alignItems: 'center'
            }
          }
        }
      },
      // ==============================================================
      // =                           Explain                          =
      // ==============================================================
      [formItemCls]: {
        '&-additional': {
          display: 'flex',
          flexDirection: 'column'
        },
        '&-explain, &-extra': {
          clear: 'both',
          color: token.colorTextDescription,
          fontSize: token.fontSize,
          lineHeight: token.lineHeight
        },
        '&-explain-connected': {
          width: '100%'
        },
        '&-extra': {
          minHeight: token.controlHeightSM,
          transition: `color ${token.motionDurationMid} ${token.motionEaseOut}` // sync input color transition
        },
        '&-explain': {
          '&-error': {
            color: token.colorError
          },
          '&-warning': {
            color: token.colorWarning
          }
        }
      },
      [`&-with-help ${formItemCls}-explain`]: {
        height: 'auto',
        opacity: 1
      },
      // ==============================================================
      // =                        Feedback Icon                       =
      // ==============================================================
      [`${formItemCls}-feedback-icon`]: {
        fontSize: token.fontSize,
        textAlign: 'center',
        visibility: 'visible',
        animationName: zoomIn,
        animationDuration: token.motionDurationMid,
        animationTimingFunction: token.motionEaseOutBack,
        pointerEvents: 'none',
        '&-success': {
          color: token.colorSuccess
        },
        '&-error': {
          color: token.colorError
        },
        '&-warning': {
          color: token.colorWarning
        },
        '&-validating': {
          color: token.colorPrimary
        }
      }
    })
  };
};
const makeVerticalLayoutLabel = token => ({
  padding: token.verticalLabelPadding,
  margin: token.verticalLabelMargin,
  whiteSpace: 'initial',
  textAlign: 'start',
  '> label': {
    margin: 0,
    '&::after': {
      // https://github.com/ant-design/ant-design/issues/43538
      visibility: 'hidden'
    }
  }
});
const style_genHorizontalStyle = token => {
  const {
    antCls,
    formItemCls
  } = token;
  return {
    [`${formItemCls}-horizontal`]: {
      [`${formItemCls}-label`]: {
        flexGrow: 0
      },
      [`${formItemCls}-control`]: {
        flex: '1 1 0',
        // https://github.com/ant-design/ant-design/issues/32777
        // https://github.com/ant-design/ant-design/issues/33773
        minWidth: 0
      },
      // Do not change this to `ant-col-24`! `-24` match all the responsive rules
      // https://github.com/ant-design/ant-design/issues/32980
      // https://github.com/ant-design/ant-design/issues/34903
      // https://github.com/ant-design/ant-design/issues/44538
      [`${formItemCls}-label[class$='-24'], ${formItemCls}-label[class*='-24 ']`]: {
        [`& + ${formItemCls}-control`]: {
          minWidth: 'unset'
        }
      },
      [`${antCls}-col-24${formItemCls}-label,
        ${antCls}-col-xl-24${formItemCls}-label`]: makeVerticalLayoutLabel(token)
    }
  };
};
const genInlineStyle = token => {
  const {
    componentCls,
    formItemCls,
    inlineItemMarginBottom
  } = token;
  return {
    [`${componentCls}-inline`]: {
      display: 'flex',
      flexWrap: 'wrap',
      [`${formItemCls}-inline`]: {
        flex: 'none',
        marginInlineEnd: token.margin,
        marginBottom: inlineItemMarginBottom,
        '&-row': {
          flexWrap: 'nowrap'
        },
        [`> ${formItemCls}-label,
        > ${formItemCls}-control`]: {
          display: 'inline-block',
          verticalAlign: 'top'
        },
        [`> ${formItemCls}-label`]: {
          flex: 'none'
        },
        [`${componentCls}-text`]: {
          display: 'inline-block'
        },
        [`${formItemCls}-has-feedback`]: {
          display: 'inline-block'
        }
      }
    }
  };
};
const makeVerticalLayout = token => {
  const {
    componentCls,
    formItemCls,
    rootPrefixCls
  } = token;
  return {
    [`${formItemCls} ${formItemCls}-label`]: makeVerticalLayoutLabel(token),
    // ref: https://github.com/ant-design/ant-design/issues/45122
    [`${componentCls}:not(${componentCls}-inline)`]: {
      [formItemCls]: {
        flexWrap: 'wrap',
        [`${formItemCls}-label, ${formItemCls}-control`]: {
          // When developer pass `xs: { span }`,
          // It should follow the `xs` screen config
          // ref: https://github.com/ant-design/ant-design/issues/44386
          [`&:not([class*=" ${rootPrefixCls}-col-xs"])`]: {
            flex: '0 0 100%',
            maxWidth: '100%'
          }
        }
      }
    }
  };
};
const style_genVerticalStyle = token => {
  const {
    componentCls,
    formItemCls,
    antCls
  } = token;
  return {
    [`${formItemCls}-vertical`]: {
      [`${formItemCls}-row`]: {
        flexDirection: 'column'
      },
      [`${formItemCls}-label > label`]: {
        height: 'auto'
      },
      [`${formItemCls}-control`]: {
        width: '100%'
      },
      [`${formItemCls}-label,
        ${antCls}-col-24${formItemCls}-label,
        ${antCls}-col-xl-24${formItemCls}-label`]: makeVerticalLayoutLabel(token)
    },
    [`@media (max-width: ${(0,cssinjs_es/* unit */.bf)(token.screenXSMax)})`]: [makeVerticalLayout(token), {
      [componentCls]: {
        [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
          [`${antCls}-col-xs-24${formItemCls}-label`]: makeVerticalLayoutLabel(token)
        }
      }
    }],
    [`@media (max-width: ${(0,cssinjs_es/* unit */.bf)(token.screenSMMax)})`]: {
      [componentCls]: {
        [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
          [`${antCls}-col-sm-24${formItemCls}-label`]: makeVerticalLayoutLabel(token)
        }
      }
    },
    [`@media (max-width: ${(0,cssinjs_es/* unit */.bf)(token.screenMDMax)})`]: {
      [componentCls]: {
        [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
          [`${antCls}-col-md-24${formItemCls}-label`]: makeVerticalLayoutLabel(token)
        }
      }
    },
    [`@media (max-width: ${(0,cssinjs_es/* unit */.bf)(token.screenLGMax)})`]: {
      [componentCls]: {
        [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
          [`${antCls}-col-lg-24${formItemCls}-label`]: makeVerticalLayoutLabel(token)
        }
      }
    }
  };
};
// ============================== Export ==============================
const form_style_prepareComponentToken = token => ({
  labelRequiredMarkColor: token.colorError,
  labelColor: token.colorTextHeading,
  labelFontSize: token.fontSize,
  labelHeight: token.controlHeight,
  labelColonMarginInlineStart: token.marginXXS / 2,
  labelColonMarginInlineEnd: token.marginXS,
  itemMarginBottom: token.marginLG,
  verticalLabelPadding: `0 0 ${token.paddingXS}px`,
  verticalLabelMargin: 0,
  inlineItemMarginBottom: 0
});
const form_style_prepareToken = (token, rootPrefixCls) => {
  const formToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    formItemCls: `${token.componentCls}-item`,
    rootPrefixCls
  });
  return formToken;
};
/* harmony default export */ var form_style = (genStyleHooks('Form', (token, {
  rootPrefixCls
}) => {
  const formToken = form_style_prepareToken(token, rootPrefixCls);
  return [genFormStyle(formToken), genFormItemStyle(formToken), explain(formToken), style_genHorizontalStyle(formToken), genInlineStyle(formToken), style_genVerticalStyle(formToken), collapse(formToken), zoomIn];
}, form_style_prepareComponentToken, {
  // Let From style before the Grid
  // ref https://github.com/ant-design/ant-design/issues/44386
  order: -1000
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/ErrorList.js
"use client";










const EMPTY_LIST = [];
function toErrorEntity(error, prefix, errorStatus, index = 0) {
  return {
    key: typeof error === 'string' ? error : `${prefix}-${index}`,
    error,
    errorStatus
  };
}
const ErrorList = ({
  help,
  helpStatus,
  errors = EMPTY_LIST,
  warnings = EMPTY_LIST,
  className: rootClassName,
  fieldId,
  onVisibleChanged
}) => {
  const {
    prefixCls
  } = react.useContext(FormItemPrefixContext);
  const baseClassName = `${prefixCls}-item-explain`;
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = form_style(prefixCls, rootCls);
  const collapseMotion = react.useMemo(() => _util_motion(prefixCls), [prefixCls]);
  // We have to debounce here again since somewhere use ErrorList directly still need no shaking
  // ref: https://github.com/ant-design/ant-design/issues/36336
  const debounceErrors = useDebounce(errors);
  const debounceWarnings = useDebounce(warnings);
  const fullKeyList = react.useMemo(() => {
    if (help !== undefined && help !== null) {
      return [toErrorEntity(help, 'help', helpStatus)];
    }
    return [].concat((0,toConsumableArray/* default */.Z)(debounceErrors.map((error, index) => toErrorEntity(error, 'error', 'error', index))), (0,toConsumableArray/* default */.Z)(debounceWarnings.map((warning, index) => toErrorEntity(warning, 'warning', 'warning', index))));
  }, [help, helpStatus, debounceErrors, debounceWarnings]);
  const filledKeyFullKeyList = react.useMemo(() => {
    const keysCount = {};
    fullKeyList.forEach(({
      key
    }) => {
      keysCount[key] = (keysCount[key] || 0) + 1;
    });
    return fullKeyList.map((entity, index) => Object.assign(Object.assign({}, entity), {
      key: keysCount[entity.key] > 1 ? `${entity.key}-fallback-${index}` : entity.key
    }));
  }, [fullKeyList]);
  const helpProps = {};
  if (fieldId) {
    helpProps.id = `${fieldId}_help`;
  }
  return wrapCSSVar(/*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, {
    motionDeadline: collapseMotion.motionDeadline,
    motionName: `${prefixCls}-show-help`,
    visible: !!filledKeyFullKeyList.length,
    onVisibleChanged: onVisibleChanged
  }, holderProps => {
    const {
      className: holderClassName,
      style: holderStyle
    } = holderProps;
    return /*#__PURE__*/react.createElement("div", Object.assign({}, helpProps, {
      className: classnames_default()(baseClassName, holderClassName, cssVarCls, rootCls, rootClassName, hashId),
      style: holderStyle
    }), /*#__PURE__*/react.createElement(rc_motion_es/* CSSMotionList */.V4, Object.assign({
      keys: filledKeyFullKeyList
    }, _util_motion(prefixCls), {
      motionName: `${prefixCls}-show-help-item`,
      component: false
    }), itemProps => {
      const {
        key,
        error,
        errorStatus,
        className: itemClassName,
        style: itemStyle
      } = itemProps;
      return /*#__PURE__*/react.createElement("div", {
        key: key,
        className: classnames_default()(itemClassName, {
          [`${baseClassName}-${errorStatus}`]: errorStatus
        }),
        style: itemStyle
      }, error);
    }));
  }));
};
/* harmony default export */ var form_ErrorList = (ErrorList);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/Form.js
"use client";

var Form_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};













const InternalForm = (props, ref) => {
  const contextDisabled = react.useContext(config_provider_DisabledContext);
  const {
    getPrefixCls,
    direction,
    requiredMark: contextRequiredMark,
    colon: contextColon,
    scrollToFirstError: contextScrollToFirstError,
    className: contextClassName,
    style: contextStyle
  } = useComponentConfig('form');
  const {
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      size,
      disabled = contextDisabled,
      form,
      colon,
      labelAlign,
      labelWrap,
      labelCol,
      wrapperCol,
      hideRequiredMark,
      layout = 'horizontal',
      scrollToFirstError,
      requiredMark,
      onFinishFailed,
      name,
      style,
      feedbackIcons,
      variant
    } = props,
    restFormProps = Form_rest(props, ["prefixCls", "className", "rootClassName", "size", "disabled", "form", "colon", "labelAlign", "labelWrap", "labelCol", "wrapperCol", "hideRequiredMark", "layout", "scrollToFirstError", "requiredMark", "onFinishFailed", "name", "style", "feedbackIcons", "variant"]);
  const mergedSize = hooks_useSize(size);
  const contextValidateMessages = react.useContext(validateMessagesContext);
  if (false) {}
  const mergedRequiredMark = react.useMemo(() => {
    if (requiredMark !== undefined) {
      return requiredMark;
    }
    if (hideRequiredMark) {
      return false;
    }
    if (contextRequiredMark !== undefined) {
      return contextRequiredMark;
    }
    return true;
  }, [hideRequiredMark, requiredMark, contextRequiredMark]);
  const mergedColon = colon !== null && colon !== void 0 ? colon : contextColon;
  const prefixCls = getPrefixCls('form', customizePrefixCls);
  // Style
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = form_style(prefixCls, rootCls);
  const formClassName = classnames_default()(prefixCls, `${prefixCls}-${layout}`, {
    [`${prefixCls}-hide-required-mark`]: mergedRequiredMark === false,
    // todo: remove in next major version
    [`${prefixCls}-rtl`]: direction === 'rtl',
    [`${prefixCls}-${mergedSize}`]: mergedSize
  }, cssVarCls, rootCls, hashId, contextClassName, className, rootClassName);
  const [wrapForm] = useForm(form);
  const {
    __INTERNAL__
  } = wrapForm;
  __INTERNAL__.name = name;
  const formContextValue = react.useMemo(() => ({
    name,
    labelAlign,
    labelCol,
    labelWrap,
    wrapperCol,
    layout,
    colon: mergedColon,
    requiredMark: mergedRequiredMark,
    itemRef: __INTERNAL__.itemRef,
    form: wrapForm,
    feedbackIcons
  }), [name, labelAlign, labelCol, wrapperCol, layout, mergedColon, mergedRequiredMark, wrapForm, feedbackIcons]);
  const nativeElementRef = react.useRef(null);
  react.useImperativeHandle(ref, () => {
    var _a;
    return Object.assign(Object.assign({}, wrapForm), {
      nativeElement: (_a = nativeElementRef.current) === null || _a === void 0 ? void 0 : _a.nativeElement
    });
  });
  const scrollToField = (options, fieldName) => {
    if (options) {
      let defaultScrollToFirstError = {
        block: 'nearest'
      };
      if (typeof options === 'object') {
        defaultScrollToFirstError = Object.assign(Object.assign({}, defaultScrollToFirstError), options);
      }
      wrapForm.scrollToField(fieldName, defaultScrollToFirstError);
    }
  };
  const onInternalFinishFailed = errorInfo => {
    onFinishFailed === null || onFinishFailed === void 0 ? void 0 : onFinishFailed(errorInfo);
    if (errorInfo.errorFields.length) {
      const fieldName = errorInfo.errorFields[0].name;
      if (scrollToFirstError !== undefined) {
        scrollToField(scrollToFirstError, fieldName);
        return;
      }
      if (contextScrollToFirstError !== undefined) {
        scrollToField(contextScrollToFirstError, fieldName);
      }
    }
  };
  return wrapCSSVar(/*#__PURE__*/react.createElement(VariantContext.Provider, {
    value: variant
  }, /*#__PURE__*/react.createElement(DisabledContextProvider, {
    disabled: disabled
  }, /*#__PURE__*/react.createElement(config_provider_SizeContext.Provider, {
    value: mergedSize
  }, /*#__PURE__*/react.createElement(FormProvider, {
    // This is not list in API, we pass with spread
    validateMessages: contextValidateMessages
  }, /*#__PURE__*/react.createElement(FormContext.Provider, {
    value: formContextValue
  }, /*#__PURE__*/react.createElement(NoFormStyle, {
    status: true
  }, /*#__PURE__*/react.createElement(rc_field_form_es/* default */.ZP, Object.assign({
    id: name
  }, restFormProps, {
    name: name,
    onFinishFailed: onInternalFinishFailed,
    form: wrapForm,
    ref: nativeElementRef,
    style: Object.assign(Object.assign({}, contextStyle), style),
    className: formClassName
  })))))))));
};
const Form = /*#__PURE__*/react.forwardRef(InternalForm);
if (false) {}

/* harmony default export */ var form_Form = (Form);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/hooks/useChildren.js

function useChildren(children) {
  if (typeof children === 'function') {
    return children;
  }
  const childList = (0,Children_toArray/* default */.Z)(children);
  return childList.length <= 1 ? childList[0] : childList;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/hooks/useFormItemStatus.js



const useFormItemStatus = () => {
  const {
    status,
    errors = [],
    warnings = []
  } = react.useContext(FormItemInputContext);
  if (false) {}
  return {
    status,
    errors,
    warnings
  };
};
// Only used for compatible package. Not promise this will work on future version.
useFormItemStatus.Context = FormItemInputContext;
/* harmony default export */ var hooks_useFormItemStatus = (useFormItemStatus);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/hooks/useFrameState.js


function useFrameState(defaultValue) {
  const [value, setValue] = react.useState(defaultValue);
  const frameRef = react.useRef(null);
  const batchRef = react.useRef([]);
  const destroyRef = react.useRef(false);
  react.useEffect(() => {
    destroyRef.current = false;
    return () => {
      destroyRef.current = true;
      raf/* default.cancel */.Z.cancel(frameRef.current);
      frameRef.current = null;
    };
  }, []);
  function setFrameValue(updater) {
    if (destroyRef.current) {
      return;
    }
    if (frameRef.current === null) {
      batchRef.current = [];
      frameRef.current = (0,raf/* default */.Z)(() => {
        frameRef.current = null;
        setValue(prevValue => {
          let current = prevValue;
          batchRef.current.forEach(func => {
            current = func(current);
          });
          return current;
        });
      });
    }
    batchRef.current.push(updater);
  }
  return [value, setFrameValue];
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/hooks/useItemRef.js



function useItemRef() {
  const {
    itemRef
  } = react.useContext(FormContext);
  const cacheRef = react.useRef({});
  function getRef(name, children) {
    // Outer caller already check the `supportRef`
    const childrenRef = children && typeof children === 'object' && (0,es_ref/* getNodeRef */.C4)(children);
    const nameStr = name.join('_');
    if (cacheRef.current.name !== nameStr || cacheRef.current.originRef !== childrenRef) {
      cacheRef.current.name = nameStr;
      cacheRef.current.originRef = childrenRef;
      cacheRef.current.ref = (0,es_ref/* composeRef */.sQ)(itemRef(name), childrenRef);
    }
    return cacheRef.current.ref;
  }
  return getRef;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/grid/hooks/useGutter.js

function useGutter(gutter, screens) {
  const results = [undefined, undefined];
  const normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, undefined];
  // By default use as `xs`
  const mergedScreens = screens || {
    xs: true,
    sm: true,
    md: true,
    lg: true,
    xl: true,
    xxl: true
  };
  normalizedGutter.forEach((g, index) => {
    if (typeof g === 'object' && g !== null) {
      for (let i = 0; i < responsiveArray.length; i++) {
        const breakpoint = responsiveArray[i];
        if (mergedScreens[breakpoint] && g[breakpoint] !== undefined) {
          results[index] = g[breakpoint];
          break;
        }
      }
    } else {
      results[index] = g;
    }
  });
  return results;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/grid/row.js
"use client";

var row_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};








const _RowAligns = (/* unused pure expression or super */ null && (['top', 'middle', 'bottom', 'stretch']));
const _RowJustify = (/* unused pure expression or super */ null && (['start', 'end', 'center', 'space-around', 'space-between', 'space-evenly']));
function useMergedPropByScreen(oriProp, screen) {
  const [prop, setProp] = react.useState(typeof oriProp === 'string' ? oriProp : '');
  const calcMergedAlignOrJustify = () => {
    if (typeof oriProp === 'string') {
      setProp(oriProp);
    }
    if (typeof oriProp !== 'object') {
      return;
    }
    for (let i = 0; i < responsiveArray.length; i++) {
      const breakpoint = responsiveArray[i];
      // if do not match, do nothing
      if (!screen || !screen[breakpoint]) {
        continue;
      }
      const curVal = oriProp[breakpoint];
      if (curVal !== undefined) {
        setProp(curVal);
        return;
      }
    }
  };
  react.useEffect(() => {
    calcMergedAlignOrJustify();
  }, [JSON.stringify(oriProp), screen]);
  return prop;
}
const row_Row = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      justify,
      align,
      className,
      style,
      children,
      gutter = 0,
      wrap
    } = props,
    others = row_rest(props, ["prefixCls", "justify", "align", "className", "style", "children", "gutter", "wrap"]);
  const {
    getPrefixCls,
    direction
  } = react.useContext(ConfigContext);
  const screens = hooks_useBreakpoint(true, null);
  const mergedAlign = useMergedPropByScreen(align, screens);
  const mergedJustify = useMergedPropByScreen(justify, screens);
  const prefixCls = getPrefixCls('row', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = useRowStyle(prefixCls);
  const gutters = useGutter(gutter, screens);
  const classes = classnames_default()(prefixCls, {
    [`${prefixCls}-no-wrap`]: wrap === false,
    [`${prefixCls}-${mergedJustify}`]: mergedJustify,
    [`${prefixCls}-${mergedAlign}`]: mergedAlign,
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, className, hashId, cssVarCls);
  // Add gutter related style
  const rowStyle = {};
  const horizontalGutter = gutters[0] != null && gutters[0] > 0 ? gutters[0] / -2 : undefined;
  if (horizontalGutter) {
    rowStyle.marginLeft = horizontalGutter;
    rowStyle.marginRight = horizontalGutter;
  }
  // "gutters" is a new array in each rendering phase, it'll make 'React.useMemo' effectless.
  // So we deconstruct "gutters" variable here.
  const [gutterH, gutterV] = gutters;
  rowStyle.rowGap = gutterV;
  const rowContext = react.useMemo(() => ({
    gutter: [gutterH, gutterV],
    wrap
  }), [gutterH, gutterV, wrap]);
  return wrapCSSVar(/*#__PURE__*/react.createElement(grid_RowContext.Provider, {
    value: rowContext
  }, /*#__PURE__*/react.createElement("div", Object.assign({}, others, {
    className: classes,
    style: Object.assign(Object.assign({}, rowStyle), style),
    ref: ref
  }), children)));
});
if (false) {}
/* harmony default export */ var row = (row_Row);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/style/fallbackCmp.js
/**
 * Fallback of IE.
 * Safe to remove.
 */
// Style as inline component


// ============================= Fallback =============================
const genFallbackStyle = token => {
  const {
    formItemCls
  } = token;
  return {
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
      // Fallback for IE, safe to remove we not support it anymore
      [`${formItemCls}-control`]: {
        display: 'flex'
      }
    }
  };
};
// ============================== Export ==============================
/* harmony default export */ var fallbackCmp = (genSubStyleComponent(['Form', 'item-item'], (token, {
  rootPrefixCls
}) => {
  const formToken = form_style_prepareToken(token, rootPrefixCls);
  return genFallbackStyle(formToken);
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/FormItemInput.js
"use client";

var FormItemInput_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};








const GRID_MAX = 24;
const FormItemInput = props => {
  const {
    prefixCls,
    status,
    labelCol,
    wrapperCol,
    children,
    errors,
    warnings,
    _internalItemRender: formItemRender,
    extra,
    help,
    fieldId,
    marginBottom,
    onErrorVisibleChanged,
    label
  } = props;
  const baseClassName = `${prefixCls}-item`;
  const formContext = react.useContext(FormContext);
  const mergedWrapperCol = react.useMemo(() => {
    let mergedWrapper = Object.assign({}, wrapperCol || formContext.wrapperCol || {});
    if (label === null && !labelCol && !wrapperCol && formContext.labelCol) {
      const list = [undefined, 'xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
      list.forEach(size => {
        const _size = size ? [size] : [];
        const formLabel = (0,rc_util_es/* get */.U2)(formContext.labelCol, _size);
        const formLabelObj = typeof formLabel === 'object' ? formLabel : {};
        const wrapper = (0,rc_util_es/* get */.U2)(mergedWrapper, _size);
        const wrapperObj = typeof wrapper === 'object' ? wrapper : {};
        if ('span' in formLabelObj && !('offset' in wrapperObj) && formLabelObj.span < GRID_MAX) {
          mergedWrapper = (0,rc_util_es/* set */.t8)(mergedWrapper, [].concat(_size, ['offset']), formLabelObj.span);
        }
      });
    }
    return mergedWrapper;
  }, [wrapperCol, formContext]);
  const className = classnames_default()(`${baseClassName}-control`, mergedWrapperCol.className);
  // Pass to sub FormItem should not with col info
  const subFormContext = react.useMemo(() => {
    const {
        labelCol,
        wrapperCol
      } = formContext,
      rest = FormItemInput_rest(formContext, ["labelCol", "wrapperCol"]);
    return rest;
  }, [formContext]);
  const extraRef = react.useRef(null);
  const [extraHeight, setExtraHeight] = react.useState(0);
  (0,hooks_useLayoutEffect/* default */.Z)(() => {
    if (extra && extraRef.current) {
      setExtraHeight(extraRef.current.clientHeight);
    } else {
      setExtraHeight(0);
    }
  }, [extra]);
  const inputDom = /*#__PURE__*/react.createElement("div", {
    className: `${baseClassName}-control-input`
  }, /*#__PURE__*/react.createElement("div", {
    className: `${baseClassName}-control-input-content`
  }, children));
  const formItemContext = react.useMemo(() => ({
    prefixCls,
    status
  }), [prefixCls, status]);
  const errorListDom = marginBottom !== null || errors.length || warnings.length ? (/*#__PURE__*/react.createElement(FormItemPrefixContext.Provider, {
    value: formItemContext
  }, /*#__PURE__*/react.createElement(form_ErrorList, {
    fieldId: fieldId,
    errors: errors,
    warnings: warnings,
    help: help,
    helpStatus: status,
    className: `${baseClassName}-explain-connected`,
    onVisibleChanged: onErrorVisibleChanged
  }))) : null;
  const extraProps = {};
  if (fieldId) {
    extraProps.id = `${fieldId}_extra`;
  }
  // If extra = 0, && will goes wrong
  // 0&&error -> 0
  const extraDom = extra ? (/*#__PURE__*/react.createElement("div", Object.assign({}, extraProps, {
    className: `${baseClassName}-extra`,
    ref: extraRef
  }), extra)) : null;
  const additionalDom = errorListDom || extraDom ? (/*#__PURE__*/react.createElement("div", {
    className: `${baseClassName}-additional`,
    style: marginBottom ? {
      minHeight: marginBottom + extraHeight
    } : {}
  }, errorListDom, extraDom)) : null;
  const dom = formItemRender && formItemRender.mark === 'pro_table_render' && formItemRender.render ? formItemRender.render(props, {
    input: inputDom,
    errorList: errorListDom,
    extra: extraDom
  }) : (/*#__PURE__*/react.createElement(react.Fragment, null, inputDom, additionalDom));
  return /*#__PURE__*/react.createElement(FormContext.Provider, {
    value: subFormContext
  }, /*#__PURE__*/react.createElement(col, Object.assign({}, mergedWrapperCol, {
    className: className
  }), dom), /*#__PURE__*/react.createElement(fallbackCmp, {
    prefixCls: prefixCls
  }));
};
/* harmony default export */ var form_FormItemInput = (FormItemInput);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/QuestionCircleOutlined.js
// This icon file is generated automatically.
var QuestionCircleOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"
      }
    }]
  },
  "name": "question-circle",
  "theme": "outlined"
};
/* harmony default export */ var asn_QuestionCircleOutlined = (QuestionCircleOutlined);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/QuestionCircleOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var QuestionCircleOutlined_QuestionCircleOutlined = function QuestionCircleOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_QuestionCircleOutlined
  }));
};

/**![question-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTYyMy42IDMxNi43QzU5My42IDI5MC40IDU1NCAyNzYgNTEyIDI3NnMtODEuNiAxNC41LTExMS42IDQwLjdDMzY5LjIgMzQ0IDM1MiAzODAuNyAzNTIgNDIwdjcuNmMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04VjQyMGMwLTQ0LjEgNDMuMS04MCA5Ni04MHM5NiAzNS45IDk2IDgwYzAgMzEuMS0yMiA1OS42LTU2LjEgNzIuNy0yMS4yIDguMS0zOS4yIDIyLjMtNTIuMSA0MC45LTEzLjEgMTktMTkuOSA0MS44LTE5LjkgNjQuOVY2MjBjMCA0LjQgMy42IDggOCA4aDQ4YzQuNCAwIDgtMy42IDgtOHYtMjIuN2E0OC4zIDQ4LjMgMCAwMTMwLjktNDQuOGM1OS0yMi43IDk3LjEtNzQuNyA5Ny4xLTEzMi41LjEtMzkuMy0xNy4xLTc2LTQ4LjMtMTAzLjN6TTQ3MiA3MzJhNDAgNDAgMCAxMDgwIDAgNDAgNDAgMCAxMC04MCAweiIgLz48L3N2Zz4=) */
var QuestionCircleOutlined_RefIcon = /*#__PURE__*/react.forwardRef(QuestionCircleOutlined_QuestionCircleOutlined);
if (false) {}
/* harmony default export */ var icons_QuestionCircleOutlined = (QuestionCircleOutlined_RefIcon);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/FormItemLabel.js
"use client";

var FormItemLabel_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};









const FormItemLabel = ({
  prefixCls,
  label,
  htmlFor,
  labelCol,
  labelAlign,
  colon,
  required,
  requiredMark,
  tooltip,
  vertical
}) => {
  var _a;
  const [formLocale] = locale_useLocale('Form');
  const {
    labelAlign: contextLabelAlign,
    labelCol: contextLabelCol,
    labelWrap,
    colon: contextColon
  } = react.useContext(FormContext);
  if (!label) {
    return null;
  }
  const mergedLabelCol = labelCol || contextLabelCol || {};
  const mergedLabelAlign = labelAlign || contextLabelAlign;
  const labelClsBasic = `${prefixCls}-item-label`;
  const labelColClassName = classnames_default()(labelClsBasic, mergedLabelAlign === 'left' && `${labelClsBasic}-left`, mergedLabelCol.className, {
    [`${labelClsBasic}-wrap`]: !!labelWrap
  });
  let labelChildren = label;
  // Keep label is original where there should have no colon
  const computedColon = colon === true || contextColon !== false && colon !== false;
  const haveColon = computedColon && !vertical;
  // Remove duplicated user input colon
  if (haveColon && typeof label === 'string' && label.trim()) {
    labelChildren = label.replace(/[:|：]\s*$/, '');
  }
  // Tooltip
  const tooltipProps = _util_convertToTooltipProps(tooltip);
  if (tooltipProps) {
    const {
        icon = /*#__PURE__*/react.createElement(icons_QuestionCircleOutlined, null)
      } = tooltipProps,
      restTooltipProps = FormItemLabel_rest(tooltipProps, ["icon"]);
    const tooltipNode = /*#__PURE__*/react.createElement(es_tooltip, Object.assign({}, restTooltipProps), /*#__PURE__*/react.cloneElement(icon, {
      className: `${prefixCls}-item-tooltip`,
      title: '',
      onClick: e => {
        // Prevent label behavior in tooltip icon
        // https://github.com/ant-design/ant-design/issues/46154
        e.preventDefault();
      },
      tabIndex: null
    }));
    labelChildren = /*#__PURE__*/react.createElement(react.Fragment, null, labelChildren, tooltipNode);
  }
  // Required Mark
  const isOptionalMark = requiredMark === 'optional';
  const isRenderMark = typeof requiredMark === 'function';
  const hideRequiredMark = requiredMark === false;
  if (isRenderMark) {
    labelChildren = requiredMark(labelChildren, {
      required: !!required
    });
  } else if (isOptionalMark && !required) {
    labelChildren = /*#__PURE__*/react.createElement(react.Fragment, null, labelChildren, /*#__PURE__*/react.createElement("span", {
      className: `${prefixCls}-item-optional`,
      title: ""
    }, (formLocale === null || formLocale === void 0 ? void 0 : formLocale.optional) || ((_a = es_locale_en_US.Form) === null || _a === void 0 ? void 0 : _a.optional)));
  }
  // https://github.com/ant-design/ant-design/pull/52950#discussion_r1980880316
  let markType;
  if (hideRequiredMark) {
    markType = 'hidden';
  } else if (isOptionalMark || isRenderMark) {
    markType = 'optional';
  }
  const labelClassName = classnames_default()({
    [`${prefixCls}-item-required`]: required,
    [`${prefixCls}-item-required-mark-${markType}`]: markType,
    [`${prefixCls}-item-no-colon`]: !computedColon
  });
  return /*#__PURE__*/react.createElement(col, Object.assign({}, mergedLabelCol, {
    className: labelColClassName
  }), /*#__PURE__*/react.createElement("label", {
    htmlFor: htmlFor,
    className: labelClassName,
    title: typeof label === 'string' ? label : ''
  }, labelChildren));
};
/* harmony default export */ var form_FormItemLabel = (FormItemLabel);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/FormItem/StatusProvider.js
"use client";









const iconMap = {
  success: CheckCircleFilled/* default */.Z,
  warning: ExclamationCircleFilled/* default */.Z,
  error: CloseCircleFilled/* default */.Z,
  validating: LoadingOutlined/* default */.Z
};
function StatusProvider({
  children,
  errors,
  warnings,
  hasFeedback,
  validateStatus,
  prefixCls,
  meta,
  noStyle,
  name
}) {
  const itemPrefixCls = `${prefixCls}-item`;
  const {
    feedbackIcons
  } = react.useContext(FormContext);
  const mergedValidateStatus = getStatus(errors, warnings, meta, null, !!hasFeedback, validateStatus);
  const {
    isFormItemInput: parentIsFormItemInput,
    status: parentStatus,
    hasFeedback: parentHasFeedback,
    feedbackIcon: parentFeedbackIcon,
    name: parentName
  } = react.useContext(FormItemInputContext);
  // ====================== Context =======================
  const formItemStatusContext = react.useMemo(() => {
    var _a;
    let feedbackIcon;
    if (hasFeedback) {
      const customIcons = hasFeedback !== true && hasFeedback.icons || feedbackIcons;
      const customIconNode = mergedValidateStatus && ((_a = customIcons === null || customIcons === void 0 ? void 0 : customIcons({
        status: mergedValidateStatus,
        errors,
        warnings
      })) === null || _a === void 0 ? void 0 : _a[mergedValidateStatus]);
      const IconNode = mergedValidateStatus && iconMap[mergedValidateStatus];
      feedbackIcon = customIconNode !== false && IconNode ? (/*#__PURE__*/react.createElement("span", {
        className: classnames_default()(`${itemPrefixCls}-feedback-icon`, `${itemPrefixCls}-feedback-icon-${mergedValidateStatus}`)
      }, customIconNode || /*#__PURE__*/react.createElement(IconNode, null))) : null;
    }
    const context = {
      status: mergedValidateStatus || '',
      errors,
      warnings,
      hasFeedback: !!hasFeedback,
      feedbackIcon,
      isFormItemInput: true,
      name
    };
    // No style will follow parent context
    if (noStyle) {
      context.status = (mergedValidateStatus !== null && mergedValidateStatus !== void 0 ? mergedValidateStatus : parentStatus) || '';
      context.isFormItemInput = parentIsFormItemInput;
      context.hasFeedback = !!(hasFeedback !== null && hasFeedback !== void 0 ? hasFeedback : parentHasFeedback);
      context.feedbackIcon = hasFeedback !== undefined ? context.feedbackIcon : parentFeedbackIcon;
      context.name = name !== null && name !== void 0 ? name : parentName;
    }
    return context;
  }, [mergedValidateStatus, hasFeedback, noStyle, parentIsFormItemInput, parentStatus]);
  // ======================= Render =======================
  return /*#__PURE__*/react.createElement(FormItemInputContext.Provider, {
    value: formItemStatusContext
  }, children);
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/FormItem/ItemHolder.js
"use client";

var ItemHolder_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};












function ItemHolder(props) {
  const {
      prefixCls,
      className,
      rootClassName,
      style,
      help,
      errors,
      warnings,
      validateStatus,
      meta,
      hasFeedback,
      hidden,
      children,
      fieldId,
      required,
      isRequired,
      onSubItemMetaChange,
      layout: propsLayout,
      name
    } = props,
    restProps = ItemHolder_rest(props, ["prefixCls", "className", "rootClassName", "style", "help", "errors", "warnings", "validateStatus", "meta", "hasFeedback", "hidden", "children", "fieldId", "required", "isRequired", "onSubItemMetaChange", "layout", "name"]);
  const itemPrefixCls = `${prefixCls}-item`;
  const {
    requiredMark,
    layout: formLayout
  } = react.useContext(FormContext);
  const layout = propsLayout || formLayout;
  const vertical = layout === 'vertical';
  // ======================== Margin ========================
  const itemRef = react.useRef(null);
  const debounceErrors = useDebounce(errors);
  const debounceWarnings = useDebounce(warnings);
  const hasHelp = help !== undefined && help !== null;
  const hasError = !!(hasHelp || errors.length || warnings.length);
  const isOnScreen = !!itemRef.current && (0,isVisible/* default */.Z)(itemRef.current);
  const [marginBottom, setMarginBottom] = react.useState(null);
  (0,hooks_useLayoutEffect/* default */.Z)(() => {
    if (hasError && itemRef.current) {
      // The element must be part of the DOMTree to use getComputedStyle
      // https://stackoverflow.com/questions/35360711/getcomputedstyle-returns-a-cssstyledeclaration-but-all-properties-are-empty-on-a
      const itemStyle = getComputedStyle(itemRef.current);
      setMarginBottom(parseInt(itemStyle.marginBottom, 10));
    }
  }, [hasError, isOnScreen]);
  const onErrorVisibleChanged = nextVisible => {
    if (!nextVisible) {
      setMarginBottom(null);
    }
  };
  // ======================== Status ========================
  const getValidateState = (isDebounce = false) => {
    const _errors = isDebounce ? debounceErrors : meta.errors;
    const _warnings = isDebounce ? debounceWarnings : meta.warnings;
    return getStatus(_errors, _warnings, meta, '', !!hasFeedback, validateStatus);
  };
  const mergedValidateStatus = getValidateState();
  // ======================== Render ========================
  const itemClassName = classnames_default()(itemPrefixCls, className, rootClassName, {
    [`${itemPrefixCls}-with-help`]: hasHelp || debounceErrors.length || debounceWarnings.length,
    // Status
    [`${itemPrefixCls}-has-feedback`]: mergedValidateStatus && hasFeedback,
    [`${itemPrefixCls}-has-success`]: mergedValidateStatus === 'success',
    [`${itemPrefixCls}-has-warning`]: mergedValidateStatus === 'warning',
    [`${itemPrefixCls}-has-error`]: mergedValidateStatus === 'error',
    [`${itemPrefixCls}-is-validating`]: mergedValidateStatus === 'validating',
    [`${itemPrefixCls}-hidden`]: hidden,
    // Layout
    [`${itemPrefixCls}-${layout}`]: layout
  });
  return /*#__PURE__*/react.createElement("div", {
    className: itemClassName,
    style: style,
    ref: itemRef
  }, /*#__PURE__*/react.createElement(row, Object.assign({
    className: `${itemPrefixCls}-row`
  }, (0,omit/* default */.Z)(restProps, ['_internalItemRender', 'colon', 'dependencies', 'extra', 'fieldKey', 'getValueFromEvent', 'getValueProps', 'htmlFor', 'id',
  // It is deprecated because `htmlFor` is its replacement.
  'initialValue', 'isListField', 'label', 'labelAlign', 'labelCol', 'labelWrap', 'messageVariables', 'name', 'normalize', 'noStyle', 'preserve', 'requiredMark', 'rules', 'shouldUpdate', 'trigger', 'tooltip', 'validateFirst', 'validateTrigger', 'valuePropName', 'wrapperCol', 'validateDebounce'])), /*#__PURE__*/react.createElement(form_FormItemLabel, Object.assign({
    htmlFor: fieldId
  }, props, {
    requiredMark: requiredMark,
    required: required !== null && required !== void 0 ? required : isRequired,
    prefixCls: prefixCls,
    vertical: vertical
  })), /*#__PURE__*/react.createElement(form_FormItemInput, Object.assign({}, props, meta, {
    errors: debounceErrors,
    warnings: debounceWarnings,
    prefixCls: prefixCls,
    status: mergedValidateStatus,
    help: help,
    marginBottom: marginBottom,
    onErrorVisibleChanged: onErrorVisibleChanged
  }), /*#__PURE__*/react.createElement(NoStyleItemContext.Provider, {
    value: onSubItemMetaChange
  }, /*#__PURE__*/react.createElement(StatusProvider, {
    prefixCls: prefixCls,
    meta: meta,
    errors: meta.errors,
    warnings: meta.warnings,
    hasFeedback: hasFeedback,
    // Already calculated
    validateStatus: mergedValidateStatus,
    name: name
  }, children)))), !!marginBottom && (/*#__PURE__*/react.createElement("div", {
    className: `${itemPrefixCls}-margin-offset`,
    style: {
      marginBottom: -marginBottom
    }
  })));
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/FormItem/index.js
"use client";




















const NAME_SPLIT = '__SPLIT__';
const _ValidateStatuses = (/* unused pure expression or super */ null && (['success', 'warning', 'error', 'validating', '']));
// https://github.com/ant-design/ant-design/issues/46417
// `getValueProps` may modify the value props name,
// we should check if the control is similar.
function isSimilarControl(a, b) {
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  return keysA.length === keysB.length && keysA.every(key => {
    const propValueA = a[key];
    const propValueB = b[key];
    return propValueA === propValueB || typeof propValueA === 'function' || typeof propValueB === 'function';
  });
}
const MemoInput = /*#__PURE__*/react.memo(({
  children
}) => children, (prev, next) => isSimilarControl(prev.control, next.control) && prev.update === next.update && prev.childProps.length === next.childProps.length && prev.childProps.every((value, index) => value === next.childProps[index]));
function genEmptyMeta() {
  return {
    errors: [],
    warnings: [],
    touched: false,
    validating: false,
    name: [],
    validated: false
  };
}
function InternalFormItem(props) {
  const {
    name,
    noStyle,
    className,
    dependencies,
    prefixCls: customizePrefixCls,
    shouldUpdate,
    rules,
    children,
    required,
    label,
    messageVariables,
    trigger = 'onChange',
    validateTrigger,
    hidden,
    help,
    layout
  } = props;
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const {
    name: formName
  } = react.useContext(FormContext);
  const mergedChildren = useChildren(children);
  const isRenderProps = typeof mergedChildren === 'function';
  const notifyParentMetaChange = react.useContext(NoStyleItemContext);
  const {
    validateTrigger: contextValidateTrigger
  } = react.useContext(rc_field_form_es/* FieldContext */.zb);
  const mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : contextValidateTrigger;
  const hasName = !(name === undefined || name === null);
  const prefixCls = getPrefixCls('form', customizePrefixCls);
  // Style
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = form_style(prefixCls, rootCls);
  // ========================= Warn =========================
  const warning = warning_devUseWarning('Form.Item');
  if (false) {}
  // ========================= MISC =========================
  // Get `noStyle` required info
  const listContext = react.useContext(rc_field_form_es/* ListContext */.ZM);
  const fieldKeyPathRef = react.useRef(null);
  // ======================== Errors ========================
  // >>>>> Collect sub field errors
  const [subFieldErrors, setSubFieldErrors] = useFrameState({});
  // >>>>> Current field errors
  const [meta, setMeta] = (0,useState/* default */.Z)(() => genEmptyMeta());
  const onMetaChange = nextMeta => {
    // This keyInfo is not correct when field is removed
    // Since origin keyManager no longer keep the origin key anymore
    // Which means we need cache origin one and reuse when removed
    const keyInfo = listContext === null || listContext === void 0 ? void 0 : listContext.getKey(nextMeta.name);
    // Destroy will reset all the meta
    setMeta(nextMeta.destroy ? genEmptyMeta() : nextMeta, true);
    // Bump to parent since noStyle
    if (noStyle && help !== false && notifyParentMetaChange) {
      let namePath = nextMeta.name;
      if (!nextMeta.destroy) {
        if (keyInfo !== undefined) {
          const [fieldKey, restPath] = keyInfo;
          namePath = [fieldKey].concat((0,toConsumableArray/* default */.Z)(restPath));
          fieldKeyPathRef.current = namePath;
        }
      } else {
        // Use origin cache data
        namePath = fieldKeyPathRef.current || namePath;
      }
      notifyParentMetaChange(nextMeta, namePath);
    }
  };
  // >>>>> Collect noStyle Field error to the top FormItem
  const onSubItemMetaChange = (subMeta, uniqueKeys) => {
    // Only `noStyle` sub item will trigger
    setSubFieldErrors(prevSubFieldErrors => {
      const clone = Object.assign({}, prevSubFieldErrors);
      // name: ['user', 1] + key: [4] = ['user', 4]
      const mergedNamePath = [].concat((0,toConsumableArray/* default */.Z)(subMeta.name.slice(0, -1)), (0,toConsumableArray/* default */.Z)(uniqueKeys));
      const mergedNameKey = mergedNamePath.join(NAME_SPLIT);
      if (subMeta.destroy) {
        // Remove
        delete clone[mergedNameKey];
      } else {
        // Update
        clone[mergedNameKey] = subMeta;
      }
      return clone;
    });
  };
  // >>>>> Get merged errors
  const [mergedErrors, mergedWarnings] = react.useMemo(() => {
    const errorList = (0,toConsumableArray/* default */.Z)(meta.errors);
    const warningList = (0,toConsumableArray/* default */.Z)(meta.warnings);
    Object.values(subFieldErrors).forEach(subFieldError => {
      errorList.push.apply(errorList, (0,toConsumableArray/* default */.Z)(subFieldError.errors || []));
      warningList.push.apply(warningList, (0,toConsumableArray/* default */.Z)(subFieldError.warnings || []));
    });
    return [errorList, warningList];
  }, [subFieldErrors, meta.errors, meta.warnings]);
  // ===================== Children Ref =====================
  const getItemRef = useItemRef();
  // ======================== Render ========================
  function renderLayout(baseChildren, fieldId, isRequired) {
    if (noStyle && !hidden) {
      return /*#__PURE__*/react.createElement(StatusProvider, {
        prefixCls: prefixCls,
        hasFeedback: props.hasFeedback,
        validateStatus: props.validateStatus,
        meta: meta,
        errors: mergedErrors,
        warnings: mergedWarnings,
        noStyle: true,
        name: name
      }, baseChildren);
    }
    return /*#__PURE__*/react.createElement(ItemHolder, Object.assign({
      key: "row"
    }, props, {
      className: classnames_default()(className, cssVarCls, rootCls, hashId),
      prefixCls: prefixCls,
      fieldId: fieldId,
      isRequired: isRequired,
      errors: mergedErrors,
      warnings: mergedWarnings,
      meta: meta,
      onSubItemMetaChange: onSubItemMetaChange,
      layout: layout,
      name: name
    }), baseChildren);
  }
  if (!hasName && !isRenderProps && !dependencies) {
    return wrapCSSVar(renderLayout(mergedChildren));
  }
  let variables = {};
  if (typeof label === 'string') {
    variables.label = label;
  } else if (name) {
    variables.label = String(name);
  }
  if (messageVariables) {
    variables = Object.assign(Object.assign({}, variables), messageVariables);
  }
  // >>>>> With Field
  return wrapCSSVar(/*#__PURE__*/react.createElement(rc_field_form_es/* Field */.gN, Object.assign({}, props, {
    messageVariables: variables,
    trigger: trigger,
    validateTrigger: mergedValidateTrigger,
    onMetaChange: onMetaChange
  }), (control, renderMeta, context) => {
    const mergedName = util_toArray(name).length && renderMeta ? renderMeta.name : [];
    const fieldId = getFieldId(mergedName, formName);
    const isRequired = required !== undefined ? required : !!(rules === null || rules === void 0 ? void 0 : rules.some(rule => {
      if (rule && typeof rule === 'object' && rule.required && !rule.warningOnly) {
        return true;
      }
      if (typeof rule === 'function') {
        const ruleEntity = rule(context);
        return (ruleEntity === null || ruleEntity === void 0 ? void 0 : ruleEntity.required) && !(ruleEntity === null || ruleEntity === void 0 ? void 0 : ruleEntity.warningOnly);
      }
      return false;
    }));
    // ======================= Children =======================
    const mergedControl = Object.assign({}, control);
    let childNode = null;
     false ? 0 : void 0;
    if (Array.isArray(mergedChildren) && hasName) {
       false ? 0 : void 0;
      childNode = mergedChildren;
    } else if (isRenderProps && (!(shouldUpdate || dependencies) || hasName)) {
       false ? 0 : void 0;
       false ? 0 : void 0;
    } else if (dependencies && !isRenderProps && !hasName) {
       false ? 0 : void 0;
    } else if (/*#__PURE__*/react.isValidElement(mergedChildren)) {
       false ? 0 : void 0;
      const childProps = Object.assign(Object.assign({}, mergedChildren.props), mergedControl);
      if (!childProps.id) {
        childProps.id = fieldId;
      }
      if (help || mergedErrors.length > 0 || mergedWarnings.length > 0 || props.extra) {
        const describedbyArr = [];
        if (help || mergedErrors.length > 0) {
          describedbyArr.push(`${fieldId}_help`);
        }
        if (props.extra) {
          describedbyArr.push(`${fieldId}_extra`);
        }
        childProps['aria-describedby'] = describedbyArr.join(' ');
      }
      if (mergedErrors.length > 0) {
        childProps['aria-invalid'] = 'true';
      }
      if (isRequired) {
        childProps['aria-required'] = 'true';
      }
      if ((0,es_ref/* supportRef */.Yr)(mergedChildren)) {
        childProps.ref = getItemRef(mergedName, mergedChildren);
      }
      // We should keep user origin event handler
      const triggers = new Set([].concat((0,toConsumableArray/* default */.Z)(util_toArray(trigger)), (0,toConsumableArray/* default */.Z)(util_toArray(mergedValidateTrigger))));
      triggers.forEach(eventName => {
        childProps[eventName] = (...args) => {
          var _a2, _c2;
          var _a, _b, _c;
          (_a = mergedControl[eventName]) === null || _a === void 0 ? void 0 : (_a2 = _a).call.apply(_a2, [mergedControl].concat(args));
          (_c = (_b = mergedChildren.props)[eventName]) === null || _c === void 0 ? void 0 : (_c2 = _c).call.apply(_c2, [_b].concat(args));
        };
      });
      // List of props that need to be watched for changes -> if changes are detected in MemoInput -> rerender
      const watchingChildProps = [childProps['aria-required'], childProps['aria-invalid'], childProps['aria-describedby']];
      childNode = /*#__PURE__*/react.createElement(MemoInput, {
        control: mergedControl,
        update: mergedChildren,
        childProps: watchingChildProps
      }, cloneElement(mergedChildren, childProps));
    } else if (isRenderProps && (shouldUpdate || dependencies) && !hasName) {
      childNode = mergedChildren(context);
    } else {
       false ? 0 : void 0;
      childNode = mergedChildren;
    }
    return renderLayout(childNode, fieldId, isRequired);
  }));
}
const FormItem = InternalFormItem;
FormItem.useStatus = hooks_useFormItemStatus;
/* harmony default export */ var form_FormItem = (FormItem);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/FormList.js
"use client";

var FormList_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





const FormList = _a => {
  var {
      prefixCls: customizePrefixCls,
      children
    } = _a,
    props = FormList_rest(_a, ["prefixCls", "children"]);
  if (false) {}
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('form', customizePrefixCls);
  const contextValue = react.useMemo(() => ({
    prefixCls,
    status: 'error'
  }), [prefixCls]);
  return /*#__PURE__*/react.createElement(rc_field_form_es/* List */.aV, Object.assign({}, props), (fields, operation, meta) => (/*#__PURE__*/react.createElement(FormItemPrefixContext.Provider, {
    value: contextValue
  }, children(fields.map(field => Object.assign(Object.assign({}, field), {
    fieldKey: field.key
  })), operation, {
    errors: meta.errors,
    warnings: meta.warnings
  }))));
};
/* harmony default export */ var form_FormList = (FormList);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/hooks/useFormInstance.js


function useFormInstance() {
  const {
    form
  } = react.useContext(FormContext);
  return form;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/form/index.js
"use client";








const es_form_Form = form_Form;
es_form_Form.Item = form_FormItem;
es_form_Form.List = form_FormList;
es_form_Form.ErrorList = form_ErrorList;
es_form_Form.useForm = useForm;
es_form_Form.useFormInstance = useFormInstance;
es_form_Form.useWatch = rc_field_form_es/* useWatch */.qo;
es_form_Form.Provider = FormProvider;
es_form_Form.create = () => {
   false ? 0 : void 0;
};
/* harmony default export */ var es_form = (es_form_Form);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/grid/index.js
"use client";




// Do not export params
function grid_useBreakpoint() {
  return hooks_useBreakpoint();
}

/* harmony default export */ var grid = ({
  useBreakpoint: grid_useBreakpoint
});
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/EyeOutlined.js + 1 modules
var EyeOutlined = __webpack_require__(7282);
// EXTERNAL MODULE: ./node_modules/rc-image/es/index.js + 16 modules
var rc_image_es = __webpack_require__(26137);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/RotateLeftOutlined.js + 1 modules
var RotateLeftOutlined = __webpack_require__(50780);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/RotateRightOutlined.js + 1 modules
var RotateRightOutlined = __webpack_require__(58421);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/SwapOutlined.js + 1 modules
var SwapOutlined = __webpack_require__(53624);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/ZoomInOutlined.js + 1 modules
var ZoomInOutlined = __webpack_require__(47997);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/ZoomOutOutlined.js + 1 modules
var ZoomOutOutlined = __webpack_require__(6106);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/image/style/index.js






const genBoxStyle = position => ({
  position: position || 'absolute',
  inset: 0
});
const genImageMaskStyle = token => {
  const {
    iconCls,
    motionDurationSlow,
    paddingXXS,
    marginXXS,
    prefixCls,
    colorTextLightSolid
  } = token;
  return {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: colorTextLightSolid,
    background: new fast_color_es/* FastColor */.t('#000').setA(0.5).toRgbString(),
    cursor: 'pointer',
    opacity: 0,
    transition: `opacity ${motionDurationSlow}`,
    [`.${prefixCls}-mask-info`]: Object.assign(Object.assign({}, textEllipsis), {
      padding: `0 ${(0,cssinjs_es/* unit */.bf)(paddingXXS)}`,
      [iconCls]: {
        marginInlineEnd: marginXXS,
        svg: {
          verticalAlign: 'baseline'
        }
      }
    })
  };
};
const genPreviewOperationsStyle = token => {
  const {
    previewCls,
    modalMaskBg,
    paddingSM,
    marginXL,
    margin,
    paddingLG,
    previewOperationColorDisabled,
    previewOperationHoverColor,
    motionDurationSlow,
    iconCls,
    colorTextLightSolid
  } = token;
  const operationBg = new fast_color_es/* FastColor */.t(modalMaskBg).setA(0.1);
  const operationBgHover = operationBg.clone().setA(0.2);
  return {
    [`${previewCls}-footer`]: {
      position: 'fixed',
      bottom: marginXL,
      left: {
        _skip_check_: true,
        value: '50%'
      },
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      color: token.previewOperationColor,
      transform: 'translateX(-50%)'
    },
    [`${previewCls}-progress`]: {
      marginBottom: margin
    },
    [`${previewCls}-close`]: {
      position: 'fixed',
      top: marginXL,
      right: {
        _skip_check_: true,
        value: marginXL
      },
      display: 'flex',
      color: colorTextLightSolid,
      backgroundColor: operationBg.toRgbString(),
      borderRadius: '50%',
      padding: paddingSM,
      outline: 0,
      border: 0,
      cursor: 'pointer',
      transition: `all ${motionDurationSlow}`,
      '&:hover': {
        backgroundColor: operationBgHover.toRgbString()
      },
      [`& > ${iconCls}`]: {
        fontSize: token.previewOperationSize
      }
    },
    [`${previewCls}-operations`]: {
      display: 'flex',
      alignItems: 'center',
      padding: `0 ${(0,cssinjs_es/* unit */.bf)(paddingLG)}`,
      backgroundColor: operationBg.toRgbString(),
      borderRadius: 100,
      '&-operation': {
        marginInlineStart: paddingSM,
        padding: paddingSM,
        cursor: 'pointer',
        transition: `all ${motionDurationSlow}`,
        userSelect: 'none',
        [`&:not(${previewCls}-operations-operation-disabled):hover > ${iconCls}`]: {
          color: previewOperationHoverColor
        },
        '&-disabled': {
          color: previewOperationColorDisabled,
          cursor: 'not-allowed'
        },
        '&:first-of-type': {
          marginInlineStart: 0
        },
        [`& > ${iconCls}`]: {
          fontSize: token.previewOperationSize
        }
      }
    }
  };
};
const genPreviewSwitchStyle = token => {
  const {
    modalMaskBg,
    iconCls,
    previewOperationColorDisabled,
    previewCls,
    zIndexPopup,
    motionDurationSlow
  } = token;
  const operationBg = new fast_color_es/* FastColor */.t(modalMaskBg).setA(0.1);
  const operationBgHover = operationBg.clone().setA(0.2);
  return {
    [`${previewCls}-switch-left, ${previewCls}-switch-right`]: {
      position: 'fixed',
      insetBlockStart: '50%',
      zIndex: token.calc(zIndexPopup).add(1).equal(),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: token.imagePreviewSwitchSize,
      height: token.imagePreviewSwitchSize,
      marginTop: token.calc(token.imagePreviewSwitchSize).mul(-1).div(2).equal(),
      color: token.previewOperationColor,
      background: operationBg.toRgbString(),
      borderRadius: '50%',
      transform: `translateY(-50%)`,
      cursor: 'pointer',
      transition: `all ${motionDurationSlow}`,
      userSelect: 'none',
      '&:hover': {
        background: operationBgHover.toRgbString()
      },
      '&-disabled': {
        '&, &:hover': {
          color: previewOperationColorDisabled,
          background: 'transparent',
          cursor: 'not-allowed',
          [`> ${iconCls}`]: {
            cursor: 'not-allowed'
          }
        }
      },
      [`> ${iconCls}`]: {
        fontSize: token.previewOperationSize
      }
    },
    [`${previewCls}-switch-left`]: {
      insetInlineStart: token.marginSM
    },
    [`${previewCls}-switch-right`]: {
      insetInlineEnd: token.marginSM
    }
  };
};
const genImagePreviewStyle = token => {
  const {
    motionEaseOut,
    previewCls,
    motionDurationSlow,
    componentCls
  } = token;
  return [{
    [`${componentCls}-preview-root`]: {
      [previewCls]: {
        height: '100%',
        textAlign: 'center',
        pointerEvents: 'none'
      },
      [`${previewCls}-body`]: Object.assign(Object.assign({}, genBoxStyle()), {
        overflow: 'hidden'
      }),
      [`${previewCls}-img`]: {
        maxWidth: '100%',
        maxHeight: '70%',
        verticalAlign: 'middle',
        transform: 'scale3d(1, 1, 1)',
        cursor: 'grab',
        transition: `transform ${motionDurationSlow} ${motionEaseOut} 0s`,
        userSelect: 'none',
        '&-wrapper': Object.assign(Object.assign({}, genBoxStyle()), {
          transition: `transform ${motionDurationSlow} ${motionEaseOut} 0s`,
          // https://github.com/ant-design/ant-design/issues/39913
          // TailwindCSS will reset img default style.
          // Let's set back.
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          '& > *': {
            pointerEvents: 'auto'
          },
          '&::before': {
            display: 'inline-block',
            width: 1,
            height: '50%',
            marginInlineEnd: -1,
            content: '""'
          }
        })
      },
      [`${previewCls}-moving`]: {
        [`${previewCls}-preview-img`]: {
          cursor: 'grabbing',
          '&-wrapper': {
            transitionDuration: '0s'
          }
        }
      }
    }
  },
  // Override
  {
    [`${componentCls}-preview-root`]: {
      [`${previewCls}-wrap`]: {
        zIndex: token.zIndexPopup
      }
    }
  },
  // Preview operations & switch
  {
    [`${componentCls}-preview-operations-wrapper`]: {
      position: 'fixed',
      zIndex: token.calc(token.zIndexPopup).add(1).equal()
    },
    '&': [genPreviewOperationsStyle(token), genPreviewSwitchStyle(token)]
  }];
};
const genImageStyle = token => {
  const {
    componentCls
  } = token;
  return {
    // ============================== image ==============================
    [componentCls]: {
      position: 'relative',
      display: 'inline-block',
      [`${componentCls}-img`]: {
        width: '100%',
        height: 'auto',
        verticalAlign: 'middle'
      },
      [`${componentCls}-img-placeholder`]: {
        backgroundColor: token.colorBgContainerDisabled,
        backgroundImage: "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSAyLjVoLTEzQS41LjUgMCAwIDAgMSAzdjEwYS41LjUgMCAwIDAgLjUuNWgxM2EuNS41IDAgMCAwIC41LS41VjNhLjUuNSAwIDAgMC0uNS0uNXpNNS4yODEgNC43NWExIDEgMCAwIDEgMCAyIDEgMSAwIDAgMSAwLTJ6bTguMDMgNi44M2EuMTI3LjEyNyAwIDAgMS0uMDgxLjAzSDIuNzY5YS4xMjUuMTI1IDAgMCAxLS4wOTYtLjIwN2wyLjY2MS0zLjE1NmEuMTI2LjEyNiAwIDAgMSAuMTc3LS4wMTZsLjAxNi4wMTZMNy4wOCAxMC4wOWwyLjQ3LTIuOTNhLjEyNi4xMjYgMCAwIDEgLjE3Ny0uMDE2bC4wMTUuMDE2IDMuNTg4IDQuMjQ0YS4xMjcuMTI3IDAgMCAxLS4wMi4xNzV6IiBmaWxsPSIjOEM4QzhDIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=')",
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: '30%'
      },
      [`${componentCls}-mask`]: Object.assign({}, genImageMaskStyle(token)),
      [`${componentCls}-mask:hover`]: {
        opacity: 1
      },
      [`${componentCls}-placeholder`]: Object.assign({}, genBoxStyle())
    }
  };
};
const genPreviewMotion = token => {
  const {
    previewCls
  } = token;
  return {
    [`${previewCls}-root`]: initZoomMotion(token, 'zoom'),
    '&': initFadeMotion(token, true)
  };
};
// ============================== Export ==============================
const image_style_prepareComponentToken = token => ({
  zIndexPopup: token.zIndexPopupBase + 80,
  previewOperationColor: new fast_color_es/* FastColor */.t(token.colorTextLightSolid).setA(0.65).toRgbString(),
  previewOperationHoverColor: new fast_color_es/* FastColor */.t(token.colorTextLightSolid).setA(0.85).toRgbString(),
  previewOperationColorDisabled: new fast_color_es/* FastColor */.t(token.colorTextLightSolid).setA(0.25).toRgbString(),
  previewOperationSize: token.fontSizeIcon * 1.5 // FIXME: fontSizeIconLG
});
/* harmony default export */ var image_style = (genStyleHooks('Image', token => {
  const previewCls = `${token.componentCls}-preview`;
  const imageToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    previewCls,
    modalMaskBg: new fast_color_es/* FastColor */.t('#000').setA(0.45).toRgbString(),
    // FIXME: Shared Token
    imagePreviewSwitchSize: token.controlHeightLG
  });
  return [genImageStyle(imageToken), genImagePreviewStyle(imageToken), genModalMaskStyle((0,cssinjs_utils_es/* mergeToken */.IX)(imageToken, {
    componentCls: previewCls
  })), genPreviewMotion(imageToken)];
}, image_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/image/PreviewGroup.js
"use client";

var PreviewGroup_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
















const icons = {
  rotateLeft: /*#__PURE__*/react.createElement(RotateLeftOutlined/* default */.Z, null),
  rotateRight: /*#__PURE__*/react.createElement(RotateRightOutlined/* default */.Z, null),
  zoomIn: /*#__PURE__*/react.createElement(ZoomInOutlined/* default */.Z, null),
  zoomOut: /*#__PURE__*/react.createElement(ZoomOutOutlined/* default */.Z, null),
  close: /*#__PURE__*/react.createElement(CloseOutlined/* default */.Z, null),
  left: /*#__PURE__*/react.createElement(LeftOutlined/* default */.Z, null),
  right: /*#__PURE__*/react.createElement(RightOutlined/* default */.Z, null),
  flipX: /*#__PURE__*/react.createElement(SwapOutlined/* default */.Z, null),
  flipY: /*#__PURE__*/react.createElement(SwapOutlined/* default */.Z, {
    rotate: 90
  })
};
const InternalPreviewGroup = _a => {
  var {
      previewPrefixCls: customizePrefixCls,
      preview
    } = _a,
    otherProps = PreviewGroup_rest(_a, ["previewPrefixCls", "preview"]);
  const {
    getPrefixCls,
    direction
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('image', customizePrefixCls);
  const previewPrefixCls = `${prefixCls}-preview`;
  const rootPrefixCls = getPrefixCls();
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = image_style(prefixCls, rootCls);
  const [zIndex] = useZIndex('ImagePreview', typeof preview === 'object' ? preview.zIndex : undefined);
  const memoizedIcons = react.useMemo(() => Object.assign(Object.assign({}, icons), {
    left: direction === 'rtl' ? /*#__PURE__*/react.createElement(RightOutlined/* default */.Z, null) : /*#__PURE__*/react.createElement(LeftOutlined/* default */.Z, null),
    right: direction === 'rtl' ? /*#__PURE__*/react.createElement(LeftOutlined/* default */.Z, null) : /*#__PURE__*/react.createElement(RightOutlined/* default */.Z, null)
  }), [direction]);
  const mergedPreview = react.useMemo(() => {
    var _a;
    if (preview === false) {
      return preview;
    }
    const _preview = typeof preview === 'object' ? preview : {};
    const mergedRootClassName = classnames_default()(hashId, cssVarCls, rootCls, (_a = _preview.rootClassName) !== null && _a !== void 0 ? _a : '');
    return Object.assign(Object.assign({}, _preview), {
      transitionName: getTransitionName(rootPrefixCls, 'zoom', _preview.transitionName),
      maskTransitionName: getTransitionName(rootPrefixCls, 'fade', _preview.maskTransitionName),
      rootClassName: mergedRootClassName,
      zIndex
    });
  }, [preview]);
  return wrapCSSVar(/*#__PURE__*/react.createElement(rc_image_es/* default.PreviewGroup */.Z.PreviewGroup, Object.assign({
    preview: mergedPreview,
    previewPrefixCls: previewPrefixCls,
    icons: memoizedIcons
  }, otherProps)));
};
/* harmony default export */ var PreviewGroup = (InternalPreviewGroup);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/image/index.js
"use client";

var image_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};












const image_Image = props => {
  const {
      prefixCls: customizePrefixCls,
      preview,
      className,
      rootClassName,
      style
    } = props,
    otherProps = image_rest(props, ["prefixCls", "preview", "className", "rootClassName", "style"]);
  if (false) {}
  const {
    getPrefixCls,
    getPopupContainer: getContextPopupContainer,
    className: contextClassName,
    style: contextStyle,
    preview: contextPreview
  } = useComponentConfig('image');
  const [imageLocale] = locale_useLocale('Image');
  const prefixCls = getPrefixCls('image', customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  // Style
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = image_style(prefixCls, rootCls);
  const mergedRootClassName = classnames_default()(rootClassName, hashId, cssVarCls, rootCls);
  const mergedClassName = classnames_default()(className, hashId, contextClassName);
  const [zIndex] = useZIndex('ImagePreview', typeof preview === 'object' ? preview.zIndex : undefined);
  const mergedPreview = react.useMemo(() => {
    if (preview === false) {
      return preview;
    }
    const _preview = typeof preview === 'object' ? preview : {};
    const {
        getContainer,
        closeIcon,
        rootClassName,
        destroyOnClose,
        destroyOnHidden
      } = _preview,
      restPreviewProps = image_rest(_preview, ["getContainer", "closeIcon", "rootClassName", "destroyOnClose", "destroyOnHidden"]);
    return Object.assign(Object.assign({
      mask: (/*#__PURE__*/react.createElement("div", {
        className: `${prefixCls}-mask-info`
      }, /*#__PURE__*/react.createElement(EyeOutlined/* default */.Z, null), imageLocale === null || imageLocale === void 0 ? void 0 : imageLocale.preview)),
      icons: icons
    }, restPreviewProps), {
      // TODO: In the future, destroyOnClose in rc-image needs to be upgrade to destroyOnHidden
      destroyOnClose: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : destroyOnClose,
      rootClassName: classnames_default()(mergedRootClassName, rootClassName),
      getContainer: getContainer !== null && getContainer !== void 0 ? getContainer : getContextPopupContainer,
      transitionName: getTransitionName(rootPrefixCls, 'zoom', _preview.transitionName),
      maskTransitionName: getTransitionName(rootPrefixCls, 'fade', _preview.maskTransitionName),
      zIndex,
      closeIcon: closeIcon !== null && closeIcon !== void 0 ? closeIcon : contextPreview === null || contextPreview === void 0 ? void 0 : contextPreview.closeIcon
    });
  }, [preview, imageLocale, contextPreview === null || contextPreview === void 0 ? void 0 : contextPreview.closeIcon]);
  const mergedStyle = Object.assign(Object.assign({}, contextStyle), style);
  return wrapCSSVar(/*#__PURE__*/react.createElement(rc_image_es/* default */.Z, Object.assign({
    prefixCls: prefixCls,
    preview: mergedPreview,
    rootClassName: mergedRootClassName,
    className: mergedClassName,
    style: mergedStyle
  }, otherProps)));
};
image_Image.PreviewGroup = PreviewGroup;
if (false) {}
/* harmony default export */ var es_image = (image_Image);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/input/Group.js
"use client";








/** @deprecated Please use `Space.Compact` */
const Group_Group = props => {
  const {
    getPrefixCls,
    direction
  } = (0,react.useContext)(ConfigContext);
  const {
    prefixCls: customizePrefixCls,
    className
  } = props;
  const prefixCls = getPrefixCls('input-group', customizePrefixCls);
  const inputPrefixCls = getPrefixCls('input');
  const [wrapCSSVar, hashId, cssVarCls] = input_style(inputPrefixCls);
  const cls = classnames_default()(prefixCls, cssVarCls, {
    [`${prefixCls}-lg`]: props.size === 'large',
    [`${prefixCls}-sm`]: props.size === 'small',
    [`${prefixCls}-compact`]: props.compact,
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, hashId, className);
  const formItemContext = (0,react.useContext)(FormItemInputContext);
  const groupFormItemContext = (0,react.useMemo)(() => Object.assign(Object.assign({}, formItemContext), {
    isFormItemInput: false
  }), [formItemContext]);
  if (false) {}
  return wrapCSSVar(/*#__PURE__*/react.createElement("span", {
    className: cls,
    style: props.style,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    onFocus: props.onFocus,
    onBlur: props.onBlur
  }, /*#__PURE__*/react.createElement(FormItemInputContext.Provider, {
    value: groupFormItemContext
  }, props.children)));
};
/* harmony default export */ var input_Group = (Group_Group);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/input/style/otp.js


// =============================== OTP ================================
const genOTPStyle = token => {
  const {
    componentCls,
    paddingXS
  } = token;
  return {
    [componentCls]: {
      display: 'inline-flex',
      alignItems: 'center',
      flexWrap: 'nowrap',
      columnGap: paddingXS,
      [`${componentCls}-input-wrapper`]: {
        position: 'relative',
        [`${componentCls}-mask-icon`]: {
          position: 'absolute',
          zIndex: '1',
          top: '50%',
          right: '50%',
          transform: 'translate(50%, -50%)',
          pointerEvents: 'none'
        },
        [`${componentCls}-mask-input`]: {
          color: 'transparent',
          caretColor: token.colorText
        },
        [`${componentCls}-mask-input[type=number]::-webkit-inner-spin-button`]: {
          '-webkit-appearance': 'none',
          margin: 0
        },
        [`${componentCls}-mask-input[type=number]`]: {
          '-moz-appearance': 'textfield'
        }
      },
      '&-rtl': {
        direction: 'rtl'
      },
      [`${componentCls}-input`]: {
        textAlign: 'center',
        paddingInline: token.paddingXXS
      },
      // ================= Size =================
      [`&${componentCls}-sm ${componentCls}-input`]: {
        paddingInline: token.calc(token.paddingXXS).div(2).equal()
      },
      [`&${componentCls}-lg ${componentCls}-input`]: {
        paddingInline: token.paddingXS
      }
    }
  };
};
// ============================== Export ==============================
/* harmony default export */ var otp = (genStyleHooks(['Input', 'OTP'], token => {
  const inputToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, initInputToken(token));
  return genOTPStyle(inputToken);
}, token_initComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/input/OTP/OTPInput.js
"use client";

var OTPInput_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





const OTPInput = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      className,
      value,
      onChange,
      onActiveChange,
      index,
      mask
    } = props,
    restProps = OTPInput_rest(props, ["className", "value", "onChange", "onActiveChange", "index", "mask"]);
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('otp');
  const maskValue = typeof mask === 'string' ? mask : value;
  // ========================== Ref ===========================
  const inputRef = react.useRef(null);
  react.useImperativeHandle(ref, () => inputRef.current);
  // ========================= Input ==========================
  const onInternalChange = e => {
    onChange(index, e.target.value);
  };
  // ========================= Focus ==========================
  const syncSelection = () => {
    (0,raf/* default */.Z)(() => {
      var _a;
      const inputEle = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input;
      if (document.activeElement === inputEle && inputEle) {
        inputEle.select();
      }
    });
  };
  // ======================== Keyboard ========================
  const onInternalKeyDown = event => {
    const {
      key,
      ctrlKey,
      metaKey
    } = event;
    if (key === 'ArrowLeft') {
      onActiveChange(index - 1);
    } else if (key === 'ArrowRight') {
      onActiveChange(index + 1);
    } else if (key === 'z' && (ctrlKey || metaKey)) {
      event.preventDefault();
    }
    syncSelection();
  };
  const onInternalKeyUp = e => {
    if (e.key === 'Backspace' && !value) {
      onActiveChange(index - 1);
    }
    syncSelection();
  };
  // ========================= Render =========================
  return /*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-input-wrapper`,
    role: "presentation"
  }, mask && value !== '' && value !== undefined && (/*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-mask-icon`,
    "aria-hidden": "true"
  }, maskValue)), /*#__PURE__*/react.createElement(input_Input, Object.assign({
    "aria-label": `OTP Input ${index + 1}`,
    type: mask === true ? 'password' : 'text'
  }, restProps, {
    ref: inputRef,
    value: value,
    onInput: onInternalChange,
    onFocus: syncSelection,
    onKeyDown: onInternalKeyDown,
    onKeyUp: onInternalKeyUp,
    onMouseDown: syncSelection,
    onMouseUp: syncSelection,
    className: classnames_default()(className, {
      [`${prefixCls}-mask-input`]: mask
    })
  })));
});
/* harmony default export */ var OTP_OTPInput = (OTPInput);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/input/OTP/index.js
"use client";


var OTP_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};











function strToArr(str) {
  return (str || '').split('');
}
const Separator = props => {
  const {
    index,
    prefixCls,
    separator
  } = props;
  const separatorNode = typeof separator === 'function' ? separator(index) : separator;
  if (!separatorNode) {
    return null;
  }
  return /*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-separator`
  }, separatorNode);
};
const OTP = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      length = 6,
      size: customSize,
      defaultValue,
      value,
      onChange,
      formatter,
      separator,
      variant,
      disabled,
      status: customStatus,
      autoFocus,
      mask,
      type,
      onInput,
      inputMode
    } = props,
    restProps = OTP_rest(props, ["prefixCls", "length", "size", "defaultValue", "value", "onChange", "formatter", "separator", "variant", "disabled", "status", "autoFocus", "mask", "type", "onInput", "inputMode"]);
  if (false) {}
  const {
    getPrefixCls,
    direction
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('otp', customizePrefixCls);
  const domAttrs = (0,pickAttrs/* default */.Z)(restProps, {
    aria: true,
    data: true,
    attr: true
  });
  // ========================= Root =========================
  // Style
  const [wrapCSSVar, hashId, cssVarCls] = otp(prefixCls);
  // ========================= Size =========================
  const mergedSize = hooks_useSize(ctx => customSize !== null && customSize !== void 0 ? customSize : ctx);
  // ======================== Status ========================
  const formContext = react.useContext(FormItemInputContext);
  const mergedStatus = getMergedStatus(formContext.status, customStatus);
  const proxyFormContext = react.useMemo(() => Object.assign(Object.assign({}, formContext), {
    status: mergedStatus,
    hasFeedback: false,
    feedbackIcon: null
  }), [formContext, mergedStatus]);
  // ========================= Refs =========================
  const containerRef = react.useRef(null);
  const refs = react.useRef({});
  react.useImperativeHandle(ref, () => ({
    focus: () => {
      var _a;
      (_a = refs.current[0]) === null || _a === void 0 ? void 0 : _a.focus();
    },
    blur: () => {
      var _a;
      for (let i = 0; i < length; i += 1) {
        (_a = refs.current[i]) === null || _a === void 0 ? void 0 : _a.blur();
      }
    },
    nativeElement: containerRef.current
  }));
  // ======================= Formatter ======================
  const internalFormatter = txt => formatter ? formatter(txt) : txt;
  // ======================== Values ========================
  const [valueCells, setValueCells] = react.useState(() => strToArr(internalFormatter(defaultValue || '')));
  react.useEffect(() => {
    if (value !== undefined) {
      setValueCells(strToArr(value));
    }
  }, [value]);
  const triggerValueCellsChange = (0,hooks_useEvent/* default */.Z)(nextValueCells => {
    setValueCells(nextValueCells);
    if (onInput) {
      onInput(nextValueCells);
    }
    // Trigger if all cells are filled
    if (onChange && nextValueCells.length === length && nextValueCells.every(c => c) && nextValueCells.some((c, index) => valueCells[index] !== c)) {
      onChange(nextValueCells.join(''));
    }
  });
  const patchValue = (0,hooks_useEvent/* default */.Z)((index, txt) => {
    let nextCells = (0,toConsumableArray/* default */.Z)(valueCells);
    // Fill cells till index
    for (let i = 0; i < index; i += 1) {
      if (!nextCells[i]) {
        nextCells[i] = '';
      }
    }
    if (txt.length <= 1) {
      nextCells[index] = txt;
    } else {
      nextCells = nextCells.slice(0, index).concat(strToArr(txt));
    }
    nextCells = nextCells.slice(0, length);
    // Clean the last empty cell
    for (let i = nextCells.length - 1; i >= 0; i -= 1) {
      if (nextCells[i]) {
        break;
      }
      nextCells.pop();
    }
    // Format if needed
    const formattedValue = internalFormatter(nextCells.map(c => c || ' ').join(''));
    nextCells = strToArr(formattedValue).map((c, i) => {
      if (c === ' ' && !nextCells[i]) {
        return nextCells[i];
      }
      return c;
    });
    return nextCells;
  });
  // ======================== Change ========================
  const onInputChange = (index, txt) => {
    var _a;
    const nextCells = patchValue(index, txt);
    const nextIndex = Math.min(index + txt.length, length - 1);
    if (nextIndex !== index && nextCells[index] !== undefined) {
      (_a = refs.current[nextIndex]) === null || _a === void 0 ? void 0 : _a.focus();
    }
    triggerValueCellsChange(nextCells);
  };
  const onInputActiveChange = nextIndex => {
    var _a;
    (_a = refs.current[nextIndex]) === null || _a === void 0 ? void 0 : _a.focus();
  };
  // ======================== Render ========================
  const inputSharedProps = {
    variant,
    disabled,
    status: mergedStatus,
    mask,
    type,
    inputMode
  };
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", Object.assign({}, domAttrs, {
    ref: containerRef,
    className: classnames_default()(prefixCls, {
      [`${prefixCls}-sm`]: mergedSize === 'small',
      [`${prefixCls}-lg`]: mergedSize === 'large',
      [`${prefixCls}-rtl`]: direction === 'rtl'
    }, cssVarCls, hashId),
    role: "group"
  }), /*#__PURE__*/react.createElement(FormItemInputContext.Provider, {
    value: proxyFormContext
  }, Array.from({
    length
  }).map((_, index) => {
    const key = `otp-${index}`;
    const singleValue = valueCells[index] || '';
    return /*#__PURE__*/react.createElement(react.Fragment, {
      key: key
    }, /*#__PURE__*/react.createElement(OTP_OTPInput, Object.assign({
      ref: inputEle => {
        refs.current[index] = inputEle;
      },
      index: index,
      size: mergedSize,
      htmlSize: 1,
      className: `${prefixCls}-input`,
      onChange: onInputChange,
      value: singleValue,
      onActiveChange: onInputActiveChange,
      autoFocus: index === 0 && autoFocus
    }, inputSharedProps)), index < length - 1 && (/*#__PURE__*/react.createElement(Separator, {
      separator: separator,
      index: index,
      prefixCls: prefixCls
    })));
  }))));
});
/* harmony default export */ var input_OTP = (OTP);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/EyeInvisibleOutlined.js + 1 modules
var EyeInvisibleOutlined = __webpack_require__(29952);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/input/Password.js
"use client";

var Password_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};











const defaultIconRender = visible => visible ? /*#__PURE__*/react.createElement(EyeOutlined/* default */.Z, null) : /*#__PURE__*/react.createElement(EyeInvisibleOutlined/* default */.Z, null);
const actionMap = {
  click: 'onClick',
  hover: 'onMouseOver'
};
const Password = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    disabled: customDisabled,
    action = 'click',
    visibilityToggle = true,
    iconRender = defaultIconRender,
    suffix
  } = props;
  // ===================== Disabled =====================
  const disabled = react.useContext(config_provider_DisabledContext);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  const visibilityControlled = typeof visibilityToggle === 'object' && visibilityToggle.visible !== undefined;
  const [visible, setVisible] = (0,react.useState)(() => visibilityControlled ? visibilityToggle.visible : false);
  const inputRef = (0,react.useRef)(null);
  react.useEffect(() => {
    if (visibilityControlled) {
      setVisible(visibilityToggle.visible);
    }
  }, [visibilityControlled, visibilityToggle]);
  // Remove Password value
  const removePasswordTimeout = useRemovePasswordTimeout(inputRef);
  const onVisibleChange = () => {
    var _a;
    if (mergedDisabled) {
      return;
    }
    if (visible) {
      removePasswordTimeout();
    }
    const nextVisible = !visible;
    setVisible(nextVisible);
    if (typeof visibilityToggle === 'object') {
      (_a = visibilityToggle.onVisibleChange) === null || _a === void 0 ? void 0 : _a.call(visibilityToggle, nextVisible);
    }
  };
  const getIcon = prefixCls => {
    const iconTrigger = actionMap[action] || '';
    const icon = iconRender(visible);
    const iconProps = {
      [iconTrigger]: onVisibleChange,
      className: `${prefixCls}-icon`,
      key: 'passwordIcon',
      onMouseDown: e => {
        // Prevent focused state lost
        // https://github.com/ant-design/ant-design/issues/15173
        e.preventDefault();
      },
      onMouseUp: e => {
        // Prevent caret position change
        // https://github.com/ant-design/ant-design/issues/23524
        e.preventDefault();
      }
    };
    return /*#__PURE__*/react.cloneElement(/*#__PURE__*/react.isValidElement(icon) ? icon : /*#__PURE__*/react.createElement("span", null, icon), iconProps);
  };
  const {
      className,
      prefixCls: customizePrefixCls,
      inputPrefixCls: customizeInputPrefixCls,
      size
    } = props,
    restProps = Password_rest(props, ["className", "prefixCls", "inputPrefixCls", "size"]);
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
  const prefixCls = getPrefixCls('input-password', customizePrefixCls);
  const suffixIcon = visibilityToggle && getIcon(prefixCls);
  const inputClassName = classnames_default()(prefixCls, className, {
    [`${prefixCls}-${size}`]: !!size
  });
  const omittedProps = Object.assign(Object.assign({}, (0,omit/* default */.Z)(restProps, ['suffix', 'iconRender', 'visibilityToggle'])), {
    type: visible ? 'text' : 'password',
    className: inputClassName,
    prefixCls: inputPrefixCls,
    suffix: (/*#__PURE__*/react.createElement(react.Fragment, null, suffixIcon, suffix))
  });
  if (size) {
    omittedProps.size = size;
  }
  return /*#__PURE__*/react.createElement(input_Input, Object.assign({
    ref: (0,es_ref/* composeRef */.sQ)(ref, inputRef)
  }, omittedProps));
});
if (false) {}
/* harmony default export */ var input_Password = (Password);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/input/Search.js
"use client";

var Search_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};










const Search = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      inputPrefixCls: customizeInputPrefixCls,
      className,
      size: customizeSize,
      suffix,
      enterButton = false,
      addonAfter,
      loading,
      disabled,
      onSearch: customOnSearch,
      onChange: customOnChange,
      onCompositionStart,
      onCompositionEnd,
      variant,
      onPressEnter: customOnPressEnter
    } = props,
    restProps = Search_rest(props, ["prefixCls", "inputPrefixCls", "className", "size", "suffix", "enterButton", "addonAfter", "loading", "disabled", "onSearch", "onChange", "onCompositionStart", "onCompositionEnd", "variant", "onPressEnter"]);
  const {
    getPrefixCls,
    direction
  } = react.useContext(ConfigContext);
  const composedRef = react.useRef(false);
  const prefixCls = getPrefixCls('input-search', customizePrefixCls);
  const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
  const {
    compactSize
  } = useCompactItemContext(prefixCls, direction);
  const size = hooks_useSize(ctx => {
    var _a;
    return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
  });
  const inputRef = react.useRef(null);
  const onChange = e => {
    if ((e === null || e === void 0 ? void 0 : e.target) && e.type === 'click' && customOnSearch) {
      customOnSearch(e.target.value, e, {
        source: 'clear'
      });
    }
    customOnChange === null || customOnChange === void 0 ? void 0 : customOnChange(e);
  };
  const onMouseDown = e => {
    var _a;
    if (document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input)) {
      e.preventDefault();
    }
  };
  const onSearch = e => {
    var _a, _b;
    if (customOnSearch) {
      customOnSearch((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.value, e, {
        source: 'input'
      });
    }
  };
  const onPressEnter = e => {
    if (composedRef.current || loading) {
      return;
    }
    customOnPressEnter === null || customOnPressEnter === void 0 ? void 0 : customOnPressEnter(e);
    onSearch(e);
  };
  const searchIcon = typeof enterButton === 'boolean' ? /*#__PURE__*/react.createElement(SearchOutlined/* default */.Z, null) : null;
  const btnClassName = `${prefixCls}-button`;
  let button;
  const enterButtonAsElement = enterButton || {};
  const isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
  if (isAntdButton || enterButtonAsElement.type === 'button') {
    button = cloneElement(enterButtonAsElement, Object.assign({
      onMouseDown,
      onClick: e => {
        var _a, _b;
        (_b = (_a = enterButtonAsElement === null || enterButtonAsElement === void 0 ? void 0 : enterButtonAsElement.props) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        onSearch(e);
      },
      key: 'enterButton'
    }, isAntdButton ? {
      className: btnClassName,
      size
    } : {}));
  } else {
    button = /*#__PURE__*/react.createElement(es_button, {
      className: btnClassName,
      color: enterButton ? 'primary' : 'default',
      size: size,
      disabled: disabled,
      key: "enterButton",
      onMouseDown: onMouseDown,
      onClick: onSearch,
      loading: loading,
      icon: searchIcon,
      variant: variant === 'borderless' || variant === 'filled' || variant === 'underlined' ? 'text' : enterButton ? 'solid' : undefined
    }, enterButton);
  }
  if (addonAfter) {
    button = [button, cloneElement(addonAfter, {
      key: 'addonAfter'
    })];
  }
  const cls = classnames_default()(prefixCls, {
    [`${prefixCls}-rtl`]: direction === 'rtl',
    [`${prefixCls}-${size}`]: !!size,
    [`${prefixCls}-with-button`]: !!enterButton
  }, className);
  const handleOnCompositionStart = e => {
    composedRef.current = true;
    onCompositionStart === null || onCompositionStart === void 0 ? void 0 : onCompositionStart(e);
  };
  const handleOnCompositionEnd = e => {
    composedRef.current = false;
    onCompositionEnd === null || onCompositionEnd === void 0 ? void 0 : onCompositionEnd(e);
  };
  const inputProps = Object.assign(Object.assign({}, restProps), {
    className: cls,
    prefixCls: inputPrefixCls,
    type: 'search',
    size,
    variant,
    onPressEnter,
    onCompositionStart: handleOnCompositionStart,
    onCompositionEnd: handleOnCompositionEnd,
    addonAfter: button,
    suffix,
    onChange,
    disabled
  });
  return /*#__PURE__*/react.createElement(input_Input, Object.assign({
    ref: (0,es_ref/* composeRef */.sQ)(inputRef, ref)
  }, inputProps));
});
if (false) {}
/* harmony default export */ var input_Search = (Search);
// EXTERNAL MODULE: ./node_modules/rc-textarea/es/index.js + 3 modules
var rc_textarea_es = __webpack_require__(18246);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/input/style/textarea.js



const genTextAreaStyle = token => {
  const {
    componentCls,
    paddingLG
  } = token;
  const textareaPrefixCls = `${componentCls}-textarea`;
  return {
    // Raw Textarea
    [`textarea${componentCls}`]: {
      maxWidth: '100%',
      // prevent textarea resize from coming out of its container
      height: 'auto',
      minHeight: token.controlHeight,
      lineHeight: token.lineHeight,
      verticalAlign: 'bottom',
      transition: `all ${token.motionDurationSlow}`,
      resize: 'vertical',
      [`&${componentCls}-mouse-active`]: {
        transition: `all ${token.motionDurationSlow}, height 0s, width 0s`
      }
    },
    // Wrapper for resize
    [`${componentCls}-textarea-affix-wrapper-resize-dirty`]: {
      width: 'auto'
    },
    [textareaPrefixCls]: {
      position: 'relative',
      '&-show-count': {
        [`${componentCls}-data-count`]: {
          position: 'absolute',
          bottom: token.calc(token.fontSize).mul(token.lineHeight).mul(-1).equal(),
          insetInlineEnd: 0,
          color: token.colorTextDescription,
          whiteSpace: 'nowrap',
          pointerEvents: 'none'
        }
      },
      [`
        &-allow-clear > ${componentCls},
        &-affix-wrapper${textareaPrefixCls}-has-feedback ${componentCls}
      `]: {
        paddingInlineEnd: paddingLG
      },
      [`&-affix-wrapper${componentCls}-affix-wrapper`]: {
        padding: 0,
        [`> textarea${componentCls}`]: {
          fontSize: 'inherit',
          border: 'none',
          outline: 'none',
          background: 'transparent',
          minHeight: token.calc(token.controlHeight).sub(token.calc(token.lineWidth).mul(2)).equal(),
          '&:focus': {
            boxShadow: 'none !important'
          }
        },
        [`${componentCls}-suffix`]: {
          margin: 0,
          '> *:not(:last-child)': {
            marginInline: 0
          },
          // Clear Icon
          [`${componentCls}-clear-icon`]: {
            position: 'absolute',
            insetInlineEnd: token.paddingInline,
            insetBlockStart: token.paddingXS
          },
          // Feedback Icon
          [`${textareaPrefixCls}-suffix`]: {
            position: 'absolute',
            top: 0,
            insetInlineEnd: token.paddingInline,
            bottom: 0,
            zIndex: 1,
            display: 'inline-flex',
            alignItems: 'center',
            margin: 'auto',
            pointerEvents: 'none'
          }
        }
      },
      [`&-affix-wrapper${componentCls}-affix-wrapper-rtl`]: {
        [`${componentCls}-suffix`]: {
          [`${componentCls}-data-count`]: {
            direction: 'ltr',
            insetInlineStart: 0
          }
        }
      },
      [`&-affix-wrapper${componentCls}-affix-wrapper-sm`]: {
        [`${componentCls}-suffix`]: {
          [`${componentCls}-clear-icon`]: {
            insetInlineEnd: token.paddingInlineSM
          }
        }
      }
    }
  };
};
// ============================== Export ==============================
/* harmony default export */ var style_textarea = (genStyleHooks(['Input', 'TextArea'], token => {
  const inputToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, initInputToken(token));
  return genTextAreaStyle(inputToken);
}, token_initComponentToken, {
  resetFont: false
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/input/TextArea.js
"use client";

var TextArea_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

















const TextArea = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var _a;
  const {
      prefixCls: customizePrefixCls,
      bordered = true,
      size: customizeSize,
      disabled: customDisabled,
      status: customStatus,
      allowClear,
      classNames: classes,
      rootClassName,
      className,
      style,
      styles,
      variant: customVariant,
      showCount,
      onMouseDown,
      onResize
    } = props,
    rest = TextArea_rest(props, ["prefixCls", "bordered", "size", "disabled", "status", "allowClear", "classNames", "rootClassName", "className", "style", "styles", "variant", "showCount", "onMouseDown", "onResize"]);
  if (false) {}
  const {
    getPrefixCls,
    direction,
    allowClear: contextAllowClear,
    autoComplete: contextAutoComplete,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig('textArea');
  // =================== Disabled ===================
  const disabled = react.useContext(config_provider_DisabledContext);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  // ==================== Status ====================
  const {
    status: contextStatus,
    hasFeedback,
    feedbackIcon
  } = react.useContext(FormItemInputContext);
  const mergedStatus = getMergedStatus(contextStatus, customStatus);
  // ===================== Ref ======================
  const innerRef = react.useRef(null);
  react.useImperativeHandle(ref, () => {
    var _a;
    return {
      resizableTextArea: (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea,
      focus: option => {
        var _a, _b;
        (0,commonUtils/* triggerFocus */.nH)((_b = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea, option);
      },
      blur: () => {
        var _a;
        return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.blur();
      }
    };
  });
  const prefixCls = getPrefixCls('input', customizePrefixCls);
  // ==================== Style =====================
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapSharedCSSVar, hashId, cssVarCls] = useSharedStyle(prefixCls, rootClassName);
  const [wrapCSSVar] = style_textarea(prefixCls, rootCls);
  // ================= Compact Item =================
  const {
    compactSize,
    compactItemClassnames
  } = useCompactItemContext(prefixCls, direction);
  // ===================== Size =====================
  const mergedSize = hooks_useSize(ctx => {
    var _a;
    return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
  });
  const [variant, enableVariantCls] = useVariants('textArea', customVariant, bordered);
  const mergedAllowClear = _util_getAllowClear(allowClear !== null && allowClear !== void 0 ? allowClear : contextAllowClear);
  // ==================== Resize ====================
  // https://github.com/ant-design/ant-design/issues/51594
  const [isMouseDown, setIsMouseDown] = react.useState(false);
  // When has wrapper, resize will make as dirty for `resize: both` style
  const [resizeDirty, setResizeDirty] = react.useState(false);
  const onInternalMouseDown = e => {
    setIsMouseDown(true);
    onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
    const onMouseUp = () => {
      setIsMouseDown(false);
      document.removeEventListener('mouseup', onMouseUp);
    };
    document.addEventListener('mouseup', onMouseUp);
  };
  const onInternalResize = size => {
    var _a, _b;
    onResize === null || onResize === void 0 ? void 0 : onResize(size);
    // Change to dirty since this maybe from the `resize: both` style
    if (isMouseDown && typeof getComputedStyle === 'function') {
      const ele = (_b = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.querySelector('textarea');
      if (ele && getComputedStyle(ele).resize === 'both') {
        setResizeDirty(true);
      }
    }
  };
  // ==================== Render ====================
  return wrapSharedCSSVar(wrapCSSVar(/*#__PURE__*/react.createElement(rc_textarea_es/* default */.Z, Object.assign({
    autoComplete: contextAutoComplete
  }, rest, {
    style: Object.assign(Object.assign({}, contextStyle), style),
    styles: Object.assign(Object.assign({}, contextStyles), styles),
    disabled: mergedDisabled,
    allowClear: mergedAllowClear,
    className: classnames_default()(cssVarCls, rootCls, className, rootClassName, compactItemClassnames, contextClassName,
    // Only for wrapper
    resizeDirty && `${prefixCls}-textarea-affix-wrapper-resize-dirty`),
    classNames: Object.assign(Object.assign(Object.assign({}, classes), contextClassNames), {
      textarea: classnames_default()({
        [`${prefixCls}-sm`]: mergedSize === 'small',
        [`${prefixCls}-lg`]: mergedSize === 'large'
      }, hashId, classes === null || classes === void 0 ? void 0 : classes.textarea, contextClassNames.textarea, isMouseDown && `${prefixCls}-mouse-active`),
      variant: classnames_default()({
        [`${prefixCls}-${variant}`]: enableVariantCls
      }, getStatusClassNames(prefixCls, mergedStatus)),
      affixWrapper: classnames_default()(`${prefixCls}-textarea-affix-wrapper`, {
        [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl',
        [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
        [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
        [`${prefixCls}-textarea-show-count`]: showCount || ((_a = props.count) === null || _a === void 0 ? void 0 : _a.show)
      }, hashId)
    }),
    prefixCls: prefixCls,
    suffix: hasFeedback && /*#__PURE__*/react.createElement("span", {
      className: `${prefixCls}-textarea-suffix`
    }, feedbackIcon),
    showCount: showCount,
    ref: innerRef,
    onResize: onInternalResize,
    onMouseDown: onInternalMouseDown
  }))));
});
/* harmony default export */ var input_TextArea = (TextArea);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/input/index.js
"use client";







const es_input_Input = input_Input;
es_input_Input.Group = input_Group;
es_input_Input.Search = input_Search;
es_input_Input.TextArea = input_TextArea;
es_input_Input.Password = input_Password;
es_input_Input.OTP = input_OTP;
/* harmony default export */ var es_input = (es_input_Input);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/layout/hooks/useHasSider.js


function useHasSider(siders, children, hasSider) {
  if (typeof hasSider === 'boolean') {
    return hasSider;
  }
  if (siders.length) {
    return true;
  }
  const childNodes = (0,Children_toArray/* default */.Z)(children);
  return childNodes.some(node => node.type === layout_Sider);
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/layout/layout.js
"use client";


var layout_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};








function generator({
  suffixCls,
  tagName,
  displayName
}) {
  return BasicComponent => {
    const Adapter = /*#__PURE__*/react.forwardRef((props, ref) => (/*#__PURE__*/react.createElement(BasicComponent, Object.assign({
      ref: ref,
      suffixCls: suffixCls,
      tagName: tagName
    }, props))));
    if (false) {}
    return Adapter;
  };
}
const Basic = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      suffixCls,
      className,
      tagName: TagName
    } = props,
    others = layout_rest(props, ["prefixCls", "suffixCls", "className", "tagName"]);
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('layout', customizePrefixCls);
  const [wrapSSR, hashId, cssVarCls] = layout_style(prefixCls);
  const prefixWithSuffixCls = suffixCls ? `${prefixCls}-${suffixCls}` : prefixCls;
  return wrapSSR(/*#__PURE__*/react.createElement(TagName, Object.assign({
    className: classnames_default()(customizePrefixCls || prefixWithSuffixCls, className, hashId, cssVarCls),
    ref: ref
  }, others)));
});
const BasicLayout = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    direction
  } = react.useContext(ConfigContext);
  const [siders, setSiders] = react.useState([]);
  const {
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      children,
      hasSider,
      tagName: Tag,
      style
    } = props,
    others = layout_rest(props, ["prefixCls", "className", "rootClassName", "children", "hasSider", "tagName", "style"]);
  const passedProps = (0,omit/* default */.Z)(others, ['suffixCls']);
  const {
    getPrefixCls,
    className: contextClassName,
    style: contextStyle
  } = useComponentConfig('layout');
  const prefixCls = getPrefixCls('layout', customizePrefixCls);
  const mergedHasSider = useHasSider(siders, children, hasSider);
  const [wrapCSSVar, hashId, cssVarCls] = layout_style(prefixCls);
  const classString = classnames_default()(prefixCls, {
    [`${prefixCls}-has-sider`]: mergedHasSider,
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, contextClassName, className, rootClassName, hashId, cssVarCls);
  const contextValue = react.useMemo(() => ({
    siderHook: {
      addSider: id => {
        setSiders(prev => [].concat((0,toConsumableArray/* default */.Z)(prev), [id]));
      },
      removeSider: id => {
        setSiders(prev => prev.filter(currentId => currentId !== id));
      }
    }
  }), []);
  return wrapCSSVar(/*#__PURE__*/react.createElement(LayoutContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/react.createElement(Tag, Object.assign({
    ref: ref,
    className: classString,
    style: Object.assign(Object.assign({}, contextStyle), style)
  }, passedProps), children)));
});
const Layout = generator({
  tagName: 'div',
  displayName: 'Layout'
})(BasicLayout);
const layout_Header = generator({
  suffixCls: 'header',
  tagName: 'header',
  displayName: 'Header'
})(Basic);
const layout_Footer = generator({
  suffixCls: 'footer',
  tagName: 'footer',
  displayName: 'Footer'
})(Basic);
const Content = generator({
  suffixCls: 'content',
  tagName: 'main',
  displayName: 'Content'
})(Basic);

/* harmony default export */ var layout = (Layout);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/layout/index.js
"use client";



const layout_Layout = layout;
layout_Layout.Header = layout_Header;
layout_Layout.Footer = layout_Footer;
layout_Layout.Content = Content;
layout_Layout.Sider = layout_Sider;
layout_Layout._InternalSiderContext = SiderContext;
/* harmony default export */ var es_layout = (layout_Layout);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/DoubleLeftOutlined.js + 1 modules
var DoubleLeftOutlined = __webpack_require__(55737);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/DoubleRightOutlined.js + 1 modules
var DoubleRightOutlined = __webpack_require__(24459);
// EXTERNAL MODULE: ./node_modules/rc-pagination/es/index.js + 4 modules
var rc_pagination_es = __webpack_require__(84708);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/pagination/style/index.js





const genPaginationDisabledStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}-disabled`]: {
      '&, &:hover': {
        cursor: 'not-allowed',
        [`${componentCls}-item-link`]: {
          color: token.colorTextDisabled,
          cursor: 'not-allowed'
        }
      },
      '&:focus-visible': {
        cursor: 'not-allowed',
        [`${componentCls}-item-link`]: {
          color: token.colorTextDisabled,
          cursor: 'not-allowed'
        }
      }
    },
    [`&${componentCls}-disabled`]: {
      cursor: 'not-allowed',
      [`${componentCls}-item`]: {
        cursor: 'not-allowed',
        backgroundColor: 'transparent',
        '&:hover, &:active': {
          backgroundColor: 'transparent'
        },
        a: {
          color: token.colorTextDisabled,
          backgroundColor: 'transparent',
          border: 'none',
          cursor: 'not-allowed'
        },
        '&-active': {
          borderColor: token.colorBorder,
          backgroundColor: token.itemActiveBgDisabled,
          '&:hover, &:active': {
            backgroundColor: token.itemActiveBgDisabled
          },
          a: {
            color: token.itemActiveColorDisabled
          }
        }
      },
      [`${componentCls}-item-link`]: {
        color: token.colorTextDisabled,
        cursor: 'not-allowed',
        '&:hover, &:active': {
          backgroundColor: 'transparent'
        },
        [`${componentCls}-simple&`]: {
          backgroundColor: 'transparent',
          '&:hover, &:active': {
            backgroundColor: 'transparent'
          }
        }
      },
      [`${componentCls}-simple-pager`]: {
        color: token.colorTextDisabled
      },
      [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
        [`${componentCls}-item-link-icon`]: {
          opacity: 0
        },
        [`${componentCls}-item-ellipsis`]: {
          opacity: 1
        }
      }
    }
  };
};
const genPaginationMiniStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`&${componentCls}-mini ${componentCls}-total-text, &${componentCls}-mini ${componentCls}-simple-pager`]: {
      height: token.itemSizeSM,
      lineHeight: (0,cssinjs_es/* unit */.bf)(token.itemSizeSM)
    },
    [`&${componentCls}-mini ${componentCls}-item`]: {
      minWidth: token.itemSizeSM,
      height: token.itemSizeSM,
      margin: 0,
      lineHeight: (0,cssinjs_es/* unit */.bf)(token.calc(token.itemSizeSM).sub(2).equal())
    },
    [`&${componentCls}-mini ${componentCls}-prev, &${componentCls}-mini ${componentCls}-next`]: {
      minWidth: token.itemSizeSM,
      height: token.itemSizeSM,
      margin: 0,
      lineHeight: (0,cssinjs_es/* unit */.bf)(token.itemSizeSM)
    },
    [`&${componentCls}-mini:not(${componentCls}-disabled)`]: {
      [`${componentCls}-prev, ${componentCls}-next`]: {
        [`&:hover ${componentCls}-item-link`]: {
          backgroundColor: token.colorBgTextHover
        },
        [`&:active ${componentCls}-item-link`]: {
          backgroundColor: token.colorBgTextActive
        },
        [`&${componentCls}-disabled:hover ${componentCls}-item-link`]: {
          backgroundColor: 'transparent'
        }
      }
    },
    [`
    &${componentCls}-mini ${componentCls}-prev ${componentCls}-item-link,
    &${componentCls}-mini ${componentCls}-next ${componentCls}-item-link
    `]: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      '&::after': {
        height: token.itemSizeSM,
        lineHeight: (0,cssinjs_es/* unit */.bf)(token.itemSizeSM)
      }
    },
    [`&${componentCls}-mini ${componentCls}-jump-prev, &${componentCls}-mini ${componentCls}-jump-next`]: {
      height: token.itemSizeSM,
      marginInlineEnd: 0,
      lineHeight: (0,cssinjs_es/* unit */.bf)(token.itemSizeSM)
    },
    [`&${componentCls}-mini ${componentCls}-options`]: {
      marginInlineStart: token.paginationMiniOptionsMarginInlineStart,
      '&-size-changer': {
        top: token.miniOptionsSizeChangerTop
      },
      '&-quick-jumper': {
        height: token.itemSizeSM,
        lineHeight: (0,cssinjs_es/* unit */.bf)(token.itemSizeSM),
        input: Object.assign(Object.assign({}, genInputSmallStyle(token)), {
          width: token.paginationMiniQuickJumperInputWidth,
          height: token.controlHeightSM
        })
      }
    }
  };
};
const genPaginationSimpleStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`&${componentCls}-simple`]: {
      [`${componentCls}-prev, ${componentCls}-next`]: {
        height: token.itemSize,
        lineHeight: (0,cssinjs_es/* unit */.bf)(token.itemSize),
        verticalAlign: 'top',
        [`${componentCls}-item-link`]: {
          height: token.itemSize,
          backgroundColor: 'transparent',
          border: 0,
          '&:hover': {
            backgroundColor: token.colorBgTextHover
          },
          '&:active': {
            backgroundColor: token.colorBgTextActive
          },
          '&::after': {
            height: token.itemSize,
            lineHeight: (0,cssinjs_es/* unit */.bf)(token.itemSize)
          }
        }
      },
      [`${componentCls}-simple-pager`]: {
        display: 'inline-flex',
        alignItems: 'center',
        height: token.itemSize,
        marginInlineEnd: token.marginXS,
        input: {
          boxSizing: 'border-box',
          height: '100%',
          width: token.quickJumperInputWidth,
          padding: `0 ${(0,cssinjs_es/* unit */.bf)(token.paginationItemPaddingInline)}`,
          textAlign: 'center',
          backgroundColor: token.itemInputBg,
          border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
          borderRadius: token.borderRadius,
          outline: 'none',
          transition: `border-color ${token.motionDurationMid}`,
          color: 'inherit',
          '&:hover': {
            borderColor: token.colorPrimary
          },
          '&:focus': {
            borderColor: token.colorPrimaryHover,
            boxShadow: `${(0,cssinjs_es/* unit */.bf)(token.inputOutlineOffset)} 0 ${(0,cssinjs_es/* unit */.bf)(token.controlOutlineWidth)} ${token.controlOutline}`
          },
          '&[disabled]': {
            color: token.colorTextDisabled,
            backgroundColor: token.colorBgContainerDisabled,
            borderColor: token.colorBorder,
            cursor: 'not-allowed'
          }
        }
      },
      [`&${componentCls}-disabled`]: {
        [`${componentCls}-prev, ${componentCls}-next`]: {
          [`${componentCls}-item-link`]: {
            '&:hover, &:active': {
              backgroundColor: 'transparent'
            }
          }
        }
      },
      [`&${componentCls}-mini`]: {
        [`${componentCls}-prev, ${componentCls}-next`]: {
          height: token.itemSizeSM,
          lineHeight: (0,cssinjs_es/* unit */.bf)(token.itemSizeSM),
          [`${componentCls}-item-link`]: {
            height: token.itemSizeSM,
            '&::after': {
              height: token.itemSizeSM,
              lineHeight: (0,cssinjs_es/* unit */.bf)(token.itemSizeSM)
            }
          }
        },
        [`${componentCls}-simple-pager`]: {
          height: token.itemSizeSM,
          width: token.paginationMiniQuickJumperInputWidth
        }
      }
    }
  };
};
const genPaginationJumpStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
      outline: 0,
      [`${componentCls}-item-container`]: {
        position: 'relative',
        [`${componentCls}-item-link-icon`]: {
          color: token.colorPrimary,
          fontSize: token.fontSizeSM,
          opacity: 0,
          transition: `all ${token.motionDurationMid}`,
          '&-svg': {
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            margin: 'auto'
          }
        },
        [`${componentCls}-item-ellipsis`]: {
          position: 'absolute',
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          display: 'block',
          margin: 'auto',
          color: token.colorTextDisabled,
          letterSpacing: token.paginationEllipsisLetterSpacing,
          textAlign: 'center',
          textIndent: token.paginationEllipsisTextIndent,
          opacity: 1,
          transition: `all ${token.motionDurationMid}`
        }
      },
      '&:hover': {
        [`${componentCls}-item-link-icon`]: {
          opacity: 1
        },
        [`${componentCls}-item-ellipsis`]: {
          opacity: 0
        }
      }
    },
    [`
    ${componentCls}-prev,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
      marginInlineEnd: token.marginXS
    },
    [`
    ${componentCls}-prev,
    ${componentCls}-next,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
      display: 'inline-block',
      minWidth: token.itemSize,
      height: token.itemSize,
      color: token.colorText,
      fontFamily: token.fontFamily,
      lineHeight: (0,cssinjs_es/* unit */.bf)(token.itemSize),
      textAlign: 'center',
      verticalAlign: 'middle',
      listStyle: 'none',
      borderRadius: token.borderRadius,
      cursor: 'pointer',
      transition: `all ${token.motionDurationMid}`
    },
    [`${componentCls}-prev, ${componentCls}-next`]: {
      outline: 0,
      button: {
        color: token.colorText,
        cursor: 'pointer',
        userSelect: 'none'
      },
      [`${componentCls}-item-link`]: {
        display: 'block',
        width: '100%',
        height: '100%',
        padding: 0,
        fontSize: token.fontSizeSM,
        textAlign: 'center',
        backgroundColor: 'transparent',
        border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} transparent`,
        borderRadius: token.borderRadius,
        outline: 'none',
        transition: `all ${token.motionDurationMid}`
      },
      [`&:hover ${componentCls}-item-link`]: {
        backgroundColor: token.colorBgTextHover
      },
      [`&:active ${componentCls}-item-link`]: {
        backgroundColor: token.colorBgTextActive
      },
      [`&${componentCls}-disabled:hover`]: {
        [`${componentCls}-item-link`]: {
          backgroundColor: 'transparent'
        }
      }
    },
    [`${componentCls}-slash`]: {
      marginInlineEnd: token.paginationSlashMarginInlineEnd,
      marginInlineStart: token.paginationSlashMarginInlineStart
    },
    [`${componentCls}-options`]: {
      display: 'inline-block',
      marginInlineStart: token.margin,
      verticalAlign: 'middle',
      '&-size-changer': {
        display: 'inline-block',
        width: 'auto'
      },
      '&-quick-jumper': {
        display: 'inline-block',
        height: token.controlHeight,
        marginInlineStart: token.marginXS,
        lineHeight: (0,cssinjs_es/* unit */.bf)(token.controlHeight),
        verticalAlign: 'top',
        input: Object.assign(Object.assign(Object.assign({}, genBasicInputStyle(token)), variants_genBaseOutlinedStyle(token, {
          borderColor: token.colorBorder,
          hoverBorderColor: token.colorPrimaryHover,
          activeBorderColor: token.colorPrimary,
          activeShadow: token.activeShadow
        })), {
          '&[disabled]': Object.assign({}, variants_genDisabledStyle(token)),
          width: token.quickJumperInputWidth,
          height: token.controlHeight,
          boxSizing: 'border-box',
          margin: 0,
          marginInlineStart: token.marginXS,
          marginInlineEnd: token.marginXS
        })
      }
    }
  };
};
const genPaginationItemStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}-item`]: {
      display: 'inline-block',
      minWidth: token.itemSize,
      height: token.itemSize,
      marginInlineEnd: token.marginXS,
      fontFamily: token.fontFamily,
      lineHeight: (0,cssinjs_es/* unit */.bf)(token.calc(token.itemSize).sub(2).equal()),
      textAlign: 'center',
      verticalAlign: 'middle',
      listStyle: 'none',
      backgroundColor: token.itemBg,
      border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} transparent`,
      borderRadius: token.borderRadius,
      outline: 0,
      cursor: 'pointer',
      userSelect: 'none',
      a: {
        display: 'block',
        padding: `0 ${(0,cssinjs_es/* unit */.bf)(token.paginationItemPaddingInline)}`,
        color: token.colorText,
        '&:hover': {
          textDecoration: 'none'
        }
      },
      [`&:not(${componentCls}-item-active)`]: {
        '&:hover': {
          transition: `all ${token.motionDurationMid}`,
          backgroundColor: token.colorBgTextHover
        },
        '&:active': {
          backgroundColor: token.colorBgTextActive
        }
      },
      '&-active': {
        fontWeight: token.fontWeightStrong,
        backgroundColor: token.itemActiveBg,
        borderColor: token.colorPrimary,
        a: {
          color: token.colorPrimary
        },
        '&:hover': {
          borderColor: token.colorPrimaryHover
        },
        '&:hover a': {
          color: token.colorPrimaryHover
        }
      }
    }
  };
};
const genPaginationStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), {
      display: 'flex',
      '&-start': {
        justifyContent: 'start'
      },
      '&-center': {
        justifyContent: 'center'
      },
      '&-end': {
        justifyContent: 'end'
      },
      'ul, ol': {
        margin: 0,
        padding: 0,
        listStyle: 'none'
      },
      '&::after': {
        display: 'block',
        clear: 'both',
        height: 0,
        overflow: 'hidden',
        visibility: 'hidden',
        content: '""'
      },
      [`${componentCls}-total-text`]: {
        display: 'inline-block',
        height: token.itemSize,
        marginInlineEnd: token.marginXS,
        lineHeight: (0,cssinjs_es/* unit */.bf)(token.calc(token.itemSize).sub(2).equal()),
        verticalAlign: 'middle'
      }
    }), genPaginationItemStyle(token)), genPaginationJumpStyle(token)), genPaginationSimpleStyle(token)), genPaginationMiniStyle(token)), genPaginationDisabledStyle(token)), {
      // media query style
      [`@media only screen and (max-width: ${token.screenLG}px)`]: {
        [`${componentCls}-item`]: {
          '&-after-jump-prev, &-before-jump-next': {
            display: 'none'
          }
        }
      },
      [`@media only screen and (max-width: ${token.screenSM}px)`]: {
        [`${componentCls}-options`]: {
          display: 'none'
        }
      }
    }),
    // rtl style
    [`&${token.componentCls}-rtl`]: {
      direction: 'rtl'
    }
  };
};
const genPaginationFocusStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}:not(${componentCls}-disabled)`]: {
      [`${componentCls}-item`]: Object.assign({}, genFocusStyle(token)),
      [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
        '&:focus-visible': Object.assign({
          [`${componentCls}-item-link-icon`]: {
            opacity: 1
          },
          [`${componentCls}-item-ellipsis`]: {
            opacity: 0
          }
        }, genFocusOutline(token))
      },
      [`${componentCls}-prev, ${componentCls}-next`]: {
        [`&:focus-visible ${componentCls}-item-link`]: genFocusOutline(token)
      }
    }
  };
};
const pagination_style_prepareComponentToken = token => Object.assign({
  itemBg: token.colorBgContainer,
  itemSize: token.controlHeight,
  itemSizeSM: token.controlHeightSM,
  itemActiveBg: token.colorBgContainer,
  itemLinkBg: token.colorBgContainer,
  itemActiveColorDisabled: token.colorTextDisabled,
  itemActiveBgDisabled: token.controlItemBgActiveDisabled,
  itemInputBg: token.colorBgContainer,
  miniOptionsSizeChangerTop: 0
}, token_initComponentToken(token));
const pagination_style_prepareToken = token => (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
  inputOutlineOffset: 0,
  quickJumperInputWidth: token.calc(token.controlHeightLG).mul(1.25).equal(),
  paginationMiniOptionsMarginInlineStart: token.calc(token.marginXXS).div(2).equal(),
  paginationMiniQuickJumperInputWidth: token.calc(token.controlHeightLG).mul(1.1).equal(),
  paginationItemPaddingInline: token.calc(token.marginXXS).mul(1.5).equal(),
  paginationEllipsisLetterSpacing: token.calc(token.marginXXS).div(2).equal(),
  paginationSlashMarginInlineStart: token.marginSM,
  paginationSlashMarginInlineEnd: token.marginSM,
  paginationEllipsisTextIndent: '0.13em' // magic for ui experience
}, initInputToken(token));
// ============================== Export ==============================
/* harmony default export */ var pagination_style = (genStyleHooks('Pagination', token => {
  const paginationToken = pagination_style_prepareToken(token);
  return [genPaginationStyle(paginationToken), genPaginationFocusStyle(paginationToken)];
}, pagination_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/pagination/style/bordered.js



const bordered_genBorderedStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}${componentCls}-bordered${componentCls}-disabled:not(${componentCls}-mini)`]: {
      '&, &:hover': {
        [`${componentCls}-item-link`]: {
          borderColor: token.colorBorder
        }
      },
      '&:focus-visible': {
        [`${componentCls}-item-link`]: {
          borderColor: token.colorBorder
        }
      },
      [`${componentCls}-item, ${componentCls}-item-link`]: {
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorder,
        [`&:hover:not(${componentCls}-item-active)`]: {
          backgroundColor: token.colorBgContainerDisabled,
          borderColor: token.colorBorder,
          a: {
            color: token.colorTextDisabled
          }
        },
        [`&${componentCls}-item-active`]: {
          backgroundColor: token.itemActiveBgDisabled
        }
      },
      [`${componentCls}-prev, ${componentCls}-next`]: {
        '&:hover button': {
          backgroundColor: token.colorBgContainerDisabled,
          borderColor: token.colorBorder,
          color: token.colorTextDisabled
        },
        [`${componentCls}-item-link`]: {
          backgroundColor: token.colorBgContainerDisabled,
          borderColor: token.colorBorder
        }
      }
    },
    [`${componentCls}${componentCls}-bordered:not(${componentCls}-mini)`]: {
      [`${componentCls}-prev, ${componentCls}-next`]: {
        '&:hover button': {
          borderColor: token.colorPrimaryHover,
          backgroundColor: token.itemBg
        },
        [`${componentCls}-item-link`]: {
          backgroundColor: token.itemLinkBg,
          borderColor: token.colorBorder
        },
        [`&:hover ${componentCls}-item-link`]: {
          borderColor: token.colorPrimary,
          backgroundColor: token.itemBg,
          color: token.colorPrimary
        },
        [`&${componentCls}-disabled`]: {
          [`${componentCls}-item-link`]: {
            borderColor: token.colorBorder,
            color: token.colorTextDisabled
          }
        }
      },
      [`${componentCls}-item`]: {
        backgroundColor: token.itemBg,
        border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
        [`&:hover:not(${componentCls}-item-active)`]: {
          borderColor: token.colorPrimary,
          backgroundColor: token.itemBg,
          a: {
            color: token.colorPrimary
          }
        },
        '&-active': {
          borderColor: token.colorPrimary
        }
      }
    }
  };
};
/* harmony default export */ var bordered = (genSubStyleComponent(['Pagination', 'bordered'], token => {
  const paginationToken = pagination_style_prepareToken(token);
  return bordered_genBorderedStyle(paginationToken);
}, pagination_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/pagination/useShowSizeChanger.js

function useShowSizeChanger(showSizeChanger) {
  return (0,react.useMemo)(() => {
    if (typeof showSizeChanger === 'boolean') {
      return [showSizeChanger, {}];
    }
    if (showSizeChanger && typeof showSizeChanger === 'object') {
      return [true, showSizeChanger];
    }
    return [undefined, undefined];
  }, [showSizeChanger]);
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/pagination/Pagination.js
"use client";

var Pagination_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


















const Pagination = props => {
  const {
      align,
      prefixCls: customizePrefixCls,
      selectPrefixCls: customizeSelectPrefixCls,
      className,
      rootClassName,
      style,
      size: customizeSize,
      locale: customLocale,
      responsive,
      showSizeChanger,
      selectComponentClass,
      pageSizeOptions
    } = props,
    restProps = Pagination_rest(props, ["align", "prefixCls", "selectPrefixCls", "className", "rootClassName", "style", "size", "locale", "responsive", "showSizeChanger", "selectComponentClass", "pageSizeOptions"]);
  const {
    xs
  } = hooks_useBreakpoint(responsive);
  const [, token] = useToken();
  const {
    getPrefixCls,
    direction,
    showSizeChanger: contextShowSizeChangerConfig,
    className: contextClassName,
    style: contextStyle
  } = useComponentConfig('pagination');
  const prefixCls = getPrefixCls('pagination', customizePrefixCls);
  // Style
  const [wrapCSSVar, hashId, cssVarCls] = pagination_style(prefixCls);
  // ============================== Size ==============================
  const mergedSize = hooks_useSize(customizeSize);
  const isSmall = mergedSize === 'small' || !!(xs && !mergedSize && responsive);
  // ============================= Locale =============================
  const [contextLocale] = locale_useLocale('Pagination', en_US/* default */.Z);
  const locale = Object.assign(Object.assign({}, contextLocale), customLocale);
  // ========================== Size Changer ==========================
  // Merge the props showSizeChanger
  const [propShowSizeChanger, propSizeChangerSelectProps] = useShowSizeChanger(showSizeChanger);
  const [contextShowSizeChanger, contextSizeChangerSelectProps] = useShowSizeChanger(contextShowSizeChangerConfig);
  const mergedShowSizeChanger = propShowSizeChanger !== null && propShowSizeChanger !== void 0 ? propShowSizeChanger : contextShowSizeChanger;
  const mergedShowSizeChangerSelectProps = propSizeChangerSelectProps !== null && propSizeChangerSelectProps !== void 0 ? propSizeChangerSelectProps : contextSizeChangerSelectProps;
  const SizeChanger = selectComponentClass || es_select;
  // Generate options
  const mergedPageSizeOptions = react.useMemo(() => {
    return pageSizeOptions ? pageSizeOptions.map(option => Number(option)) : undefined;
  }, [pageSizeOptions]);
  // Render size changer
  const sizeChangerRender = info => {
    var _a;
    const {
      disabled,
      size: pageSize,
      onSizeChange,
      'aria-label': ariaLabel,
      className: sizeChangerClassName,
      options
    } = info;
    const {
      className: propSizeChangerClassName,
      onChange: propSizeChangerOnChange
    } = mergedShowSizeChangerSelectProps || {};
    // Origin Select is using Select.Option,
    // So it make the option value must be string
    // Just for compatible
    const selectedValue = (_a = options.find(option => String(option.value) === String(pageSize))) === null || _a === void 0 ? void 0 : _a.value;
    return /*#__PURE__*/react.createElement(SizeChanger, Object.assign({
      disabled: disabled,
      showSearch: true,
      popupMatchSelectWidth: false,
      getPopupContainer: triggerNode => triggerNode.parentNode,
      "aria-label": ariaLabel,
      options: options
    }, mergedShowSizeChangerSelectProps, {
      value: selectedValue,
      onChange: (nextSize, option) => {
        onSizeChange === null || onSizeChange === void 0 ? void 0 : onSizeChange(nextSize);
        propSizeChangerOnChange === null || propSizeChangerOnChange === void 0 ? void 0 : propSizeChangerOnChange(nextSize, option);
      },
      size: isSmall ? 'small' : 'middle',
      className: classnames_default()(sizeChangerClassName, propSizeChangerClassName)
    }));
  };
  if (false) {}
  // ============================= Render =============================
  const iconsProps = react.useMemo(() => {
    const ellipsis = /*#__PURE__*/react.createElement("span", {
      className: `${prefixCls}-item-ellipsis`
    }, "\u2022\u2022\u2022");
    const prevIcon = /*#__PURE__*/react.createElement("button", {
      className: `${prefixCls}-item-link`,
      type: "button",
      tabIndex: -1
    }, direction === 'rtl' ? /*#__PURE__*/react.createElement(RightOutlined/* default */.Z, null) : /*#__PURE__*/react.createElement(LeftOutlined/* default */.Z, null));
    const nextIcon = /*#__PURE__*/react.createElement("button", {
      className: `${prefixCls}-item-link`,
      type: "button",
      tabIndex: -1
    }, direction === 'rtl' ? /*#__PURE__*/react.createElement(LeftOutlined/* default */.Z, null) : /*#__PURE__*/react.createElement(RightOutlined/* default */.Z, null));
    const jumpPrevIcon = /*#__PURE__*/
    // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
    react.createElement("a", {
      className: `${prefixCls}-item-link`
    }, /*#__PURE__*/react.createElement("div", {
      className: `${prefixCls}-item-container`
    }, direction === 'rtl' ? (/*#__PURE__*/react.createElement(DoubleRightOutlined/* default */.Z, {
      className: `${prefixCls}-item-link-icon`
    })) : (/*#__PURE__*/react.createElement(DoubleLeftOutlined/* default */.Z, {
      className: `${prefixCls}-item-link-icon`
    })), ellipsis));
    const jumpNextIcon = /*#__PURE__*/
    // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
    react.createElement("a", {
      className: `${prefixCls}-item-link`
    }, /*#__PURE__*/react.createElement("div", {
      className: `${prefixCls}-item-container`
    }, direction === 'rtl' ? (/*#__PURE__*/react.createElement(DoubleLeftOutlined/* default */.Z, {
      className: `${prefixCls}-item-link-icon`
    })) : (/*#__PURE__*/react.createElement(DoubleRightOutlined/* default */.Z, {
      className: `${prefixCls}-item-link-icon`
    })), ellipsis));
    return {
      prevIcon,
      nextIcon,
      jumpPrevIcon,
      jumpNextIcon
    };
  }, [direction, prefixCls]);
  const selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
  const extendedClassName = classnames_default()({
    [`${prefixCls}-${align}`]: !!align,
    [`${prefixCls}-mini`]: isSmall,
    [`${prefixCls}-rtl`]: direction === 'rtl',
    [`${prefixCls}-bordered`]: token.wireframe
  }, contextClassName, className, rootClassName, hashId, cssVarCls);
  const mergedStyle = Object.assign(Object.assign({}, contextStyle), style);
  return wrapCSSVar(/*#__PURE__*/react.createElement(react.Fragment, null, token.wireframe && /*#__PURE__*/react.createElement(bordered, {
    prefixCls: prefixCls
  }), /*#__PURE__*/react.createElement(rc_pagination_es/* default */.Z, Object.assign({}, iconsProps, restProps, {
    style: mergedStyle,
    prefixCls: prefixCls,
    selectPrefixCls: selectPrefixCls,
    className: extendedClassName,
    locale: locale,
    pageSizeOptions: mergedPageSizeOptions,
    showSizeChanger: mergedShowSizeChanger,
    sizeChangerRender: sizeChangerRender
  }))));
};
if (false) {}
/* harmony default export */ var pagination_Pagination = (Pagination);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/pagination/index.js
"use client";


/* harmony default export */ var es_pagination = (pagination_Pagination);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/spin/Indicator/Progress.js
"use client";




const viewSize = 100;
const borderWidth = viewSize / 5;
const radius = viewSize / 2 - borderWidth / 2;
const circumference = radius * 2 * Math.PI;
const position = 50;
const CustomCircle = props => {
  const {
    dotClassName,
    style,
    hasCircleCls
  } = props;
  return /*#__PURE__*/react.createElement("circle", {
    className: classnames_default()(`${dotClassName}-circle`, {
      [`${dotClassName}-circle-bg`]: hasCircleCls
    }),
    r: radius,
    cx: position,
    cy: position,
    strokeWidth: borderWidth,
    style: style
  });
};
const Progress = ({
  percent,
  prefixCls
}) => {
  const dotClassName = `${prefixCls}-dot`;
  const holderClassName = `${dotClassName}-holder`;
  const hideClassName = `${holderClassName}-hidden`;
  const [render, setRender] = react.useState(false);
  // ==================== Visible =====================
  (0,hooks_useLayoutEffect/* default */.Z)(() => {
    if (percent !== 0) {
      setRender(true);
    }
  }, [percent !== 0]);
  // ==================== Progress ====================
  const safePtg = Math.max(Math.min(percent, 100), 0);
  // ===================== Render =====================
  if (!render) {
    return null;
  }
  const circleStyle = {
    strokeDashoffset: `${circumference / 4}`,
    strokeDasharray: `${circumference * safePtg / 100} ${circumference * (100 - safePtg) / 100}`
  };
  return /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(holderClassName, `${dotClassName}-progress`, safePtg <= 0 && hideClassName)
  }, /*#__PURE__*/react.createElement("svg", {
    viewBox: `0 0 ${viewSize} ${viewSize}`,
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": safePtg
  }, /*#__PURE__*/react.createElement(CustomCircle, {
    dotClassName: dotClassName,
    hasCircleCls: true
  }), /*#__PURE__*/react.createElement(CustomCircle, {
    dotClassName: dotClassName,
    style: circleStyle
  })));
};
/* harmony default export */ var Indicator_Progress = (Progress);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/spin/Indicator/Looper.js
"use client";




function Looper(props) {
  const {
    prefixCls,
    percent = 0
  } = props;
  const dotClassName = `${prefixCls}-dot`;
  const holderClassName = `${dotClassName}-holder`;
  const hideClassName = `${holderClassName}-hidden`;
  // ===================== Render =====================
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(holderClassName, percent > 0 && hideClassName)
  }, /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(dotClassName, `${prefixCls}-dot-spin`)
  }, [1, 2, 3, 4].map(i => (/*#__PURE__*/react.createElement("i", {
    className: `${prefixCls}-dot-item`,
    key: i
  }))))), /*#__PURE__*/react.createElement(Indicator_Progress, {
    prefixCls: prefixCls,
    percent: percent
  }));
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/spin/Indicator/index.js
"use client";





function Indicator(props) {
  var _a;
  const {
    prefixCls,
    indicator,
    percent
  } = props;
  const dotClassName = `${prefixCls}-dot`;
  if (indicator && /*#__PURE__*/react.isValidElement(indicator)) {
    return cloneElement(indicator, {
      className: classnames_default()((_a = indicator.props) === null || _a === void 0 ? void 0 : _a.className, dotClassName),
      percent
    });
  }
  return /*#__PURE__*/react.createElement(Looper, {
    prefixCls: prefixCls,
    percent: percent
  });
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/spin/style/index.js



const antSpinMove = new cssinjs_es/* Keyframes */.E4('antSpinMove', {
  to: {
    opacity: 1
  }
});
const antRotate = new cssinjs_es/* Keyframes */.E4('antRotate', {
  to: {
    transform: 'rotate(405deg)'
  }
});
const genSpinStyle = token => {
  const {
    componentCls,
    calc
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      position: 'absolute',
      display: 'none',
      color: token.colorPrimary,
      fontSize: 0,
      textAlign: 'center',
      verticalAlign: 'middle',
      opacity: 0,
      transition: `transform ${token.motionDurationSlow} ${token.motionEaseInOutCirc}`,
      '&-spinning': {
        position: 'relative',
        display: 'inline-block',
        opacity: 1
      },
      [`${componentCls}-text`]: {
        fontSize: token.fontSize,
        paddingTop: calc(calc(token.dotSize).sub(token.fontSize)).div(2).add(2).equal()
      },
      '&-fullscreen': {
        position: 'fixed',
        width: '100vw',
        height: '100vh',
        backgroundColor: token.colorBgMask,
        zIndex: token.zIndexPopupBase,
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        opacity: 0,
        visibility: 'hidden',
        transition: `all ${token.motionDurationMid}`,
        '&-show': {
          opacity: 1,
          visibility: 'visible'
        },
        [componentCls]: {
          [`${componentCls}-dot-holder`]: {
            color: token.colorWhite
          },
          [`${componentCls}-text`]: {
            color: token.colorTextLightSolid
          }
        }
      },
      '&-nested-loading': {
        position: 'relative',
        [`> div > ${componentCls}`]: {
          position: 'absolute',
          top: 0,
          insetInlineStart: 0,
          zIndex: 4,
          display: 'block',
          width: '100%',
          height: '100%',
          maxHeight: token.contentHeight,
          [`${componentCls}-dot`]: {
            position: 'absolute',
            top: '50%',
            insetInlineStart: '50%',
            margin: calc(token.dotSize).mul(-1).div(2).equal()
          },
          [`${componentCls}-text`]: {
            position: 'absolute',
            top: '50%',
            width: '100%',
            textShadow: `0 1px 2px ${token.colorBgContainer}` // FIXME: shadow
          },
          [`&${componentCls}-show-text ${componentCls}-dot`]: {
            marginTop: calc(token.dotSize).div(2).mul(-1).sub(10).equal()
          },
          '&-sm': {
            [`${componentCls}-dot`]: {
              margin: calc(token.dotSizeSM).mul(-1).div(2).equal()
            },
            [`${componentCls}-text`]: {
              paddingTop: calc(calc(token.dotSizeSM).sub(token.fontSize)).div(2).add(2).equal()
            },
            [`&${componentCls}-show-text ${componentCls}-dot`]: {
              marginTop: calc(token.dotSizeSM).div(2).mul(-1).sub(10).equal()
            }
          },
          '&-lg': {
            [`${componentCls}-dot`]: {
              margin: calc(token.dotSizeLG).mul(-1).div(2).equal()
            },
            [`${componentCls}-text`]: {
              paddingTop: calc(calc(token.dotSizeLG).sub(token.fontSize)).div(2).add(2).equal()
            },
            [`&${componentCls}-show-text ${componentCls}-dot`]: {
              marginTop: calc(token.dotSizeLG).div(2).mul(-1).sub(10).equal()
            }
          }
        },
        [`${componentCls}-container`]: {
          position: 'relative',
          transition: `opacity ${token.motionDurationSlow}`,
          '&::after': {
            position: 'absolute',
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            zIndex: 10,
            width: '100%',
            height: '100%',
            background: token.colorBgContainer,
            opacity: 0,
            transition: `all ${token.motionDurationSlow}`,
            content: '""',
            pointerEvents: 'none'
          }
        },
        [`${componentCls}-blur`]: {
          clear: 'both',
          opacity: 0.5,
          userSelect: 'none',
          pointerEvents: 'none',
          '&::after': {
            opacity: 0.4,
            pointerEvents: 'auto'
          }
        }
      },
      // tip
      // ------------------------------
      '&-tip': {
        color: token.spinDotDefault
      },
      // holder
      // ------------------------------
      [`${componentCls}-dot-holder`]: {
        width: '1em',
        height: '1em',
        fontSize: token.dotSize,
        display: 'inline-block',
        transition: `transform ${token.motionDurationSlow} ease, opacity ${token.motionDurationSlow} ease`,
        transformOrigin: '50% 50%',
        lineHeight: 1,
        color: token.colorPrimary,
        '&-hidden': {
          transform: 'scale(0.3)',
          opacity: 0
        }
      },
      // progress
      // ------------------------------
      [`${componentCls}-dot-progress`]: {
        position: 'absolute',
        inset: 0
      },
      // dots
      // ------------------------------
      [`${componentCls}-dot`]: {
        position: 'relative',
        display: 'inline-block',
        fontSize: token.dotSize,
        width: '1em',
        height: '1em',
        '&-item': {
          position: 'absolute',
          display: 'block',
          width: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
          height: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
          background: 'currentColor',
          borderRadius: '100%',
          transform: 'scale(0.75)',
          transformOrigin: '50% 50%',
          opacity: 0.3,
          animationName: antSpinMove,
          animationDuration: '1s',
          animationIterationCount: 'infinite',
          animationTimingFunction: 'linear',
          animationDirection: 'alternate',
          '&:nth-child(1)': {
            top: 0,
            insetInlineStart: 0,
            animationDelay: '0s'
          },
          '&:nth-child(2)': {
            top: 0,
            insetInlineEnd: 0,
            animationDelay: '0.4s'
          },
          '&:nth-child(3)': {
            insetInlineEnd: 0,
            bottom: 0,
            animationDelay: '0.8s'
          },
          '&:nth-child(4)': {
            bottom: 0,
            insetInlineStart: 0,
            animationDelay: '1.2s'
          }
        },
        '&-spin': {
          transform: 'rotate(45deg)',
          animationName: antRotate,
          animationDuration: '1.2s',
          animationIterationCount: 'infinite',
          animationTimingFunction: 'linear'
        },
        '&-circle': {
          strokeLinecap: 'round',
          transition: ['stroke-dashoffset', 'stroke-dasharray', 'stroke', 'stroke-width', 'opacity'].map(item => `${item} ${token.motionDurationSlow} ease`).join(','),
          fillOpacity: 0,
          stroke: 'currentcolor'
        },
        '&-circle-bg': {
          stroke: token.colorFillSecondary
        }
      },
      // small
      [`&-sm ${componentCls}-dot`]: {
        '&, &-holder': {
          fontSize: token.dotSizeSM
        }
      },
      [`&-sm ${componentCls}-dot-holder`]: {
        i: {
          width: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal(),
          height: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal()
        }
      },
      // large
      [`&-lg ${componentCls}-dot`]: {
        '&, &-holder': {
          fontSize: token.dotSizeLG
        }
      },
      [`&-lg ${componentCls}-dot-holder`]: {
        i: {
          width: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal(),
          height: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal()
        }
      },
      [`&${componentCls}-show-text ${componentCls}-text`]: {
        display: 'block'
      }
    })
  };
};
const spin_style_prepareComponentToken = token => {
  const {
    controlHeightLG,
    controlHeight
  } = token;
  return {
    contentHeight: 400,
    dotSize: controlHeightLG / 2,
    dotSizeSM: controlHeightLG * 0.35,
    dotSizeLG: controlHeight
  };
};
// ============================== Export ==============================
/* harmony default export */ var spin_style = (genStyleHooks('Spin', token => {
  const spinToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    spinDotDefault: token.colorTextDescription
  });
  return genSpinStyle(spinToken);
}, spin_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/spin/usePercent.js

const AUTO_INTERVAL = 200;
const STEP_BUCKETS = [[30, 0.05], [70, 0.03], [96, 0.01]];
function usePercent(spinning, percent) {
  const [mockPercent, setMockPercent] = react.useState(0);
  const mockIntervalRef = react.useRef(null);
  const isAuto = percent === 'auto';
  react.useEffect(() => {
    if (isAuto && spinning) {
      setMockPercent(0);
      mockIntervalRef.current = setInterval(() => {
        setMockPercent(prev => {
          const restPTG = 100 - prev;
          for (let i = 0; i < STEP_BUCKETS.length; i += 1) {
            const [limit, stepPtg] = STEP_BUCKETS[i];
            if (prev <= limit) {
              return prev + restPTG * stepPtg;
            }
          }
          return prev;
        });
      }, AUTO_INTERVAL);
    }
    return () => {
      clearInterval(mockIntervalRef.current);
    };
  }, [isAuto, spinning]);
  return isAuto ? mockPercent : percent;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/spin/index.js
"use client";

var spin_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};








const _SpinSizes = (/* unused pure expression or super */ null && (['small', 'default', 'large']));
// Render indicator
let defaultIndicator;
function shouldDelay(spinning, delay) {
  return !!spinning && !!delay && !Number.isNaN(Number(delay));
}
const Spin = props => {
  var _a;
  const {
      prefixCls: customizePrefixCls,
      spinning: customSpinning = true,
      delay = 0,
      className,
      rootClassName,
      size = 'default',
      tip,
      wrapperClassName,
      style,
      children,
      fullscreen = false,
      indicator,
      percent
    } = props,
    restProps = spin_rest(props, ["prefixCls", "spinning", "delay", "className", "rootClassName", "size", "tip", "wrapperClassName", "style", "children", "fullscreen", "indicator", "percent"]);
  const {
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle,
    indicator: contextIndicator
  } = useComponentConfig('spin');
  const prefixCls = getPrefixCls('spin', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = spin_style(prefixCls);
  const [spinning, setSpinning] = react.useState(() => customSpinning && !shouldDelay(customSpinning, delay));
  const mergedPercent = usePercent(spinning, percent);
  react.useEffect(() => {
    if (customSpinning) {
      const showSpinning = (0,esm/* debounce */.D)(delay, () => {
        setSpinning(true);
      });
      showSpinning();
      return () => {
        var _a;
        (_a = showSpinning === null || showSpinning === void 0 ? void 0 : showSpinning.cancel) === null || _a === void 0 ? void 0 : _a.call(showSpinning);
      };
    }
    setSpinning(false);
  }, [delay, customSpinning]);
  const isNestedPattern = react.useMemo(() => typeof children !== 'undefined' && !fullscreen, [children, fullscreen]);
  if (false) {}
  const spinClassName = classnames_default()(prefixCls, contextClassName, {
    [`${prefixCls}-sm`]: size === 'small',
    [`${prefixCls}-lg`]: size === 'large',
    [`${prefixCls}-spinning`]: spinning,
    [`${prefixCls}-show-text`]: !!tip,
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, className, !fullscreen && rootClassName, hashId, cssVarCls);
  const containerClassName = classnames_default()(`${prefixCls}-container`, {
    [`${prefixCls}-blur`]: spinning
  });
  const mergedIndicator = (_a = indicator !== null && indicator !== void 0 ? indicator : contextIndicator) !== null && _a !== void 0 ? _a : defaultIndicator;
  const mergedStyle = Object.assign(Object.assign({}, contextStyle), style);
  const spinElement = /*#__PURE__*/react.createElement("div", Object.assign({}, restProps, {
    style: mergedStyle,
    className: spinClassName,
    "aria-live": "polite",
    "aria-busy": spinning
  }), /*#__PURE__*/react.createElement(Indicator, {
    prefixCls: prefixCls,
    indicator: mergedIndicator,
    percent: mergedPercent
  }), tip && (isNestedPattern || fullscreen) ? (/*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-text`
  }, tip)) : null);
  if (isNestedPattern) {
    return wrapCSSVar(/*#__PURE__*/react.createElement("div", Object.assign({}, restProps, {
      className: classnames_default()(`${prefixCls}-nested-loading`, wrapperClassName, hashId, cssVarCls)
    }), spinning && /*#__PURE__*/react.createElement("div", {
      key: "loading"
    }, spinElement), /*#__PURE__*/react.createElement("div", {
      className: containerClassName,
      key: "container"
    }, children)));
  }
  if (fullscreen) {
    return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
      className: classnames_default()(`${prefixCls}-fullscreen`, {
        [`${prefixCls}-fullscreen-show`]: spinning
      }, rootClassName, hashId, cssVarCls)
    }, spinElement));
  }
  return wrapCSSVar(spinElement);
};
Spin.setDefaultIndicator = indicator => {
  defaultIndicator = indicator;
};
if (false) {}
/* harmony default export */ var spin = (Spin);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/list/context.js

const ListContext = /*#__PURE__*/react.createContext({});
const ListConsumer = ListContext.Consumer;
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/list/Item.js
"use client";

var Item_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






const Item_Meta = _a => {
  var {
      prefixCls: customizePrefixCls,
      className,
      avatar,
      title,
      description
    } = _a,
    others = Item_rest(_a, ["prefixCls", "className", "avatar", "title", "description"]);
  const {
    getPrefixCls
  } = (0,react.useContext)(ConfigContext);
  const prefixCls = getPrefixCls('list', customizePrefixCls);
  const classString = classnames_default()(`${prefixCls}-item-meta`, className);
  const content = /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-item-meta-content`
  }, title && /*#__PURE__*/react.createElement("h4", {
    className: `${prefixCls}-item-meta-title`
  }, title), description && /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-item-meta-description`
  }, description));
  return /*#__PURE__*/react.createElement("div", Object.assign({}, others, {
    className: classString
  }), avatar && /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-item-meta-avatar`
  }, avatar), (title || description) && content);
};
const InternalItem = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      children,
      actions,
      extra,
      styles,
      className,
      classNames: customizeClassNames,
      colStyle
    } = props,
    others = Item_rest(props, ["prefixCls", "children", "actions", "extra", "styles", "className", "classNames", "colStyle"]);
  const {
    grid,
    itemLayout
  } = (0,react.useContext)(ListContext);
  const {
    getPrefixCls,
    list
  } = (0,react.useContext)(ConfigContext);
  const moduleClass = moduleName => {
    var _a, _b;
    return classnames_default()((_b = (_a = list === null || list === void 0 ? void 0 : list.item) === null || _a === void 0 ? void 0 : _a.classNames) === null || _b === void 0 ? void 0 : _b[moduleName], customizeClassNames === null || customizeClassNames === void 0 ? void 0 : customizeClassNames[moduleName]);
  };
  const moduleStyle = moduleName => {
    var _a, _b;
    return Object.assign(Object.assign({}, (_b = (_a = list === null || list === void 0 ? void 0 : list.item) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b[moduleName]), styles === null || styles === void 0 ? void 0 : styles[moduleName]);
  };
  const isItemContainsTextNodeAndNotSingular = () => {
    let result = false;
    react.Children.forEach(children, element => {
      if (typeof element === 'string') {
        result = true;
      }
    });
    return result && react.Children.count(children) > 1;
  };
  const isFlexMode = () => {
    if (itemLayout === 'vertical') {
      return !!extra;
    }
    return !isItemContainsTextNodeAndNotSingular();
  };
  const prefixCls = getPrefixCls('list', customizePrefixCls);
  const actionsContent = actions && actions.length > 0 && (/*#__PURE__*/react.createElement("ul", {
    className: classnames_default()(`${prefixCls}-item-action`, moduleClass('actions')),
    key: "actions",
    style: moduleStyle('actions')
  }, actions.map((action, i) => (/*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  react.createElement("li", {
    key: `${prefixCls}-item-action-${i}`
  }, action, i !== actions.length - 1 && /*#__PURE__*/react.createElement("em", {
    className: `${prefixCls}-item-action-split`
  }))))));
  const Element = grid ? 'div' : 'li';
  const itemChildren = /*#__PURE__*/react.createElement(Element, Object.assign({}, others, !grid ? {
    ref
  } : {}, {
    className: classnames_default()(`${prefixCls}-item`, {
      [`${prefixCls}-item-no-flex`]: !isFlexMode()
    }, className)
  }), itemLayout === 'vertical' && extra ? [/*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-item-main`,
    key: "content"
  }, children, actionsContent), /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${prefixCls}-item-extra`, moduleClass('extra')),
    key: "extra",
    style: moduleStyle('extra')
  }, extra)] : [children, actionsContent, cloneElement(extra, {
    key: 'extra'
  })]);
  return grid ? (/*#__PURE__*/react.createElement(col, {
    ref: ref,
    flex: 1,
    style: colStyle
  }, itemChildren)) : itemChildren;
});
const list_Item_Item = InternalItem;
list_Item_Item.Meta = Item_Meta;
/* harmony default export */ var list_Item = (list_Item_Item);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/list/style/index.js



const style_genBorderedStyle = token => {
  const {
    listBorderedCls,
    componentCls,
    paddingLG,
    margin,
    itemPaddingSM,
    itemPaddingLG,
    marginLG,
    borderRadiusLG
  } = token;
  return {
    [listBorderedCls]: {
      border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
      borderRadius: borderRadiusLG,
      [`${componentCls}-header,${componentCls}-footer,${componentCls}-item`]: {
        paddingInline: paddingLG
      },
      [`${componentCls}-pagination`]: {
        margin: `${(0,cssinjs_es/* unit */.bf)(margin)} ${(0,cssinjs_es/* unit */.bf)(marginLG)}`
      }
    },
    [`${listBorderedCls}${componentCls}-sm`]: {
      [`${componentCls}-item,${componentCls}-header,${componentCls}-footer`]: {
        padding: itemPaddingSM
      }
    },
    [`${listBorderedCls}${componentCls}-lg`]: {
      [`${componentCls}-item,${componentCls}-header,${componentCls}-footer`]: {
        padding: itemPaddingLG
      }
    }
  };
};
const genResponsiveStyle = token => {
  const {
    componentCls,
    screenSM,
    screenMD,
    marginLG,
    marginSM,
    margin
  } = token;
  return {
    [`@media screen and (max-width:${screenMD}px)`]: {
      [componentCls]: {
        [`${componentCls}-item`]: {
          [`${componentCls}-item-action`]: {
            marginInlineStart: marginLG
          }
        }
      },
      [`${componentCls}-vertical`]: {
        [`${componentCls}-item`]: {
          [`${componentCls}-item-extra`]: {
            marginInlineStart: marginLG
          }
        }
      }
    },
    [`@media screen and (max-width: ${screenSM}px)`]: {
      [componentCls]: {
        [`${componentCls}-item`]: {
          flexWrap: 'wrap',
          [`${componentCls}-action`]: {
            marginInlineStart: marginSM
          }
        }
      },
      [`${componentCls}-vertical`]: {
        [`${componentCls}-item`]: {
          flexWrap: 'wrap-reverse',
          [`${componentCls}-item-main`]: {
            minWidth: token.contentWidth
          },
          [`${componentCls}-item-extra`]: {
            margin: `auto auto ${(0,cssinjs_es/* unit */.bf)(margin)}`
          }
        }
      }
    }
  };
};
// =============================== Base ===============================
const list_style_genBaseStyle = token => {
  const {
    componentCls,
    antCls,
    controlHeight,
    minHeight,
    paddingSM,
    marginLG,
    padding,
    itemPadding,
    colorPrimary,
    itemPaddingSM,
    itemPaddingLG,
    paddingXS,
    margin,
    colorText,
    colorTextDescription,
    motionDurationSlow,
    lineWidth,
    headerBg,
    footerBg,
    emptyTextPadding,
    metaMarginBottom,
    avatarMarginRight,
    titleMarginBottom,
    descriptionFontSize
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      position: 'relative',
      // fix https://github.com/ant-design/ant-design/issues/46177
      ['--rc-virtual-list-scrollbar-bg']: token.colorSplit,
      '*': {
        outline: 'none'
      },
      [`${componentCls}-header`]: {
        background: headerBg
      },
      [`${componentCls}-footer`]: {
        background: footerBg
      },
      [`${componentCls}-header, ${componentCls}-footer`]: {
        paddingBlock: paddingSM
      },
      [`${componentCls}-pagination`]: {
        marginBlockStart: marginLG,
        // https://github.com/ant-design/ant-design/issues/20037
        [`${antCls}-pagination-options`]: {
          textAlign: 'start'
        }
      },
      [`${componentCls}-spin`]: {
        minHeight,
        textAlign: 'center'
      },
      [`${componentCls}-items`]: {
        margin: 0,
        padding: 0,
        listStyle: 'none'
      },
      [`${componentCls}-item`]: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: itemPadding,
        color: colorText,
        [`${componentCls}-item-meta`]: {
          display: 'flex',
          flex: 1,
          alignItems: 'flex-start',
          maxWidth: '100%',
          [`${componentCls}-item-meta-avatar`]: {
            marginInlineEnd: avatarMarginRight
          },
          [`${componentCls}-item-meta-content`]: {
            flex: '1 0',
            width: 0,
            color: colorText
          },
          [`${componentCls}-item-meta-title`]: {
            margin: `0 0 ${(0,cssinjs_es/* unit */.bf)(token.marginXXS)} 0`,
            color: colorText,
            fontSize: token.fontSize,
            lineHeight: token.lineHeight,
            '> a': {
              color: colorText,
              transition: `all ${motionDurationSlow}`,
              '&:hover': {
                color: colorPrimary
              }
            }
          },
          [`${componentCls}-item-meta-description`]: {
            color: colorTextDescription,
            fontSize: descriptionFontSize,
            lineHeight: token.lineHeight
          }
        },
        [`${componentCls}-item-action`]: {
          flex: '0 0 auto',
          marginInlineStart: token.marginXXL,
          padding: 0,
          fontSize: 0,
          listStyle: 'none',
          '& > li': {
            position: 'relative',
            display: 'inline-block',
            padding: `0 ${(0,cssinjs_es/* unit */.bf)(paddingXS)}`,
            color: colorTextDescription,
            fontSize: token.fontSize,
            lineHeight: token.lineHeight,
            textAlign: 'center',
            '&:first-child': {
              paddingInlineStart: 0
            }
          },
          [`${componentCls}-item-action-split`]: {
            position: 'absolute',
            insetBlockStart: '50%',
            insetInlineEnd: 0,
            width: lineWidth,
            height: token.calc(token.fontHeight).sub(token.calc(token.marginXXS).mul(2)).equal(),
            transform: 'translateY(-50%)',
            backgroundColor: token.colorSplit
          }
        }
      },
      [`${componentCls}-empty`]: {
        padding: `${(0,cssinjs_es/* unit */.bf)(padding)} 0`,
        color: colorTextDescription,
        fontSize: token.fontSizeSM,
        textAlign: 'center'
      },
      [`${componentCls}-empty-text`]: {
        padding: emptyTextPadding,
        color: token.colorTextDisabled,
        fontSize: token.fontSize,
        textAlign: 'center'
      },
      // ============================ without flex ============================
      [`${componentCls}-item-no-flex`]: {
        display: 'block'
      }
    }),
    [`${componentCls}-grid ${antCls}-col > ${componentCls}-item`]: {
      display: 'block',
      maxWidth: '100%',
      marginBlockEnd: margin,
      paddingBlock: 0,
      borderBlockEnd: 'none'
    },
    [`${componentCls}-vertical ${componentCls}-item`]: {
      alignItems: 'initial',
      [`${componentCls}-item-main`]: {
        display: 'block',
        flex: 1
      },
      [`${componentCls}-item-extra`]: {
        marginInlineStart: marginLG
      },
      [`${componentCls}-item-meta`]: {
        marginBlockEnd: metaMarginBottom,
        [`${componentCls}-item-meta-title`]: {
          marginBlockStart: 0,
          marginBlockEnd: titleMarginBottom,
          color: colorText,
          fontSize: token.fontSizeLG,
          lineHeight: token.lineHeightLG
        }
      },
      [`${componentCls}-item-action`]: {
        marginBlockStart: padding,
        marginInlineStart: 'auto',
        '> li': {
          padding: `0 ${(0,cssinjs_es/* unit */.bf)(padding)}`,
          '&:first-child': {
            paddingInlineStart: 0
          }
        }
      }
    },
    [`${componentCls}-split ${componentCls}-item`]: {
      borderBlockEnd: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`,
      '&:last-child': {
        borderBlockEnd: 'none'
      }
    },
    [`${componentCls}-split ${componentCls}-header`]: {
      borderBlockEnd: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
    },
    [`${componentCls}-split${componentCls}-empty ${componentCls}-footer`]: {
      borderTop: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
    },
    [`${componentCls}-loading ${componentCls}-spin-nested-loading`]: {
      minHeight: controlHeight
    },
    [`${componentCls}-split${componentCls}-something-after-last-item ${antCls}-spin-container > ${componentCls}-items > ${componentCls}-item:last-child`]: {
      borderBlockEnd: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
    },
    [`${componentCls}-lg ${componentCls}-item`]: {
      padding: itemPaddingLG
    },
    [`${componentCls}-sm ${componentCls}-item`]: {
      padding: itemPaddingSM
    },
    // Horizontal
    [`${componentCls}:not(${componentCls}-vertical)`]: {
      [`${componentCls}-item-no-flex`]: {
        [`${componentCls}-item-action`]: {
          float: 'right'
        }
      }
    }
  };
};
const list_style_prepareComponentToken = token => ({
  contentWidth: 220,
  itemPadding: `${(0,cssinjs_es/* unit */.bf)(token.paddingContentVertical)} 0`,
  itemPaddingSM: `${(0,cssinjs_es/* unit */.bf)(token.paddingContentVerticalSM)} ${(0,cssinjs_es/* unit */.bf)(token.paddingContentHorizontal)}`,
  itemPaddingLG: `${(0,cssinjs_es/* unit */.bf)(token.paddingContentVerticalLG)} ${(0,cssinjs_es/* unit */.bf)(token.paddingContentHorizontalLG)}`,
  headerBg: 'transparent',
  footerBg: 'transparent',
  emptyTextPadding: token.padding,
  metaMarginBottom: token.padding,
  avatarMarginRight: token.padding,
  titleMarginBottom: token.paddingSM,
  descriptionFontSize: token.fontSize
});
// ============================== Export ==============================
/* harmony default export */ var list_style = (genStyleHooks('List', token => {
  const listToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    listBorderedCls: `${token.componentCls}-bordered`,
    minHeight: token.controlHeightLG
  });
  return [list_style_genBaseStyle(listToken), style_genBorderedStyle(listToken), genResponsiveStyle(listToken)];
}, list_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/list/index.js
"use client";


var list_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};















function InternalList(props, ref) {
  const {
      pagination = false,
      prefixCls: customizePrefixCls,
      bordered = false,
      split = true,
      className,
      rootClassName,
      style,
      children,
      itemLayout,
      loadMore,
      grid,
      dataSource = [],
      size: customizeSize,
      header,
      footer,
      loading = false,
      rowKey,
      renderItem,
      locale
    } = props,
    rest = list_rest(props, ["pagination", "prefixCls", "bordered", "split", "className", "rootClassName", "style", "children", "itemLayout", "loadMore", "grid", "dataSource", "size", "header", "footer", "loading", "rowKey", "renderItem", "locale"]);
  const paginationObj = pagination && typeof pagination === 'object' ? pagination : {};
  const [paginationCurrent, setPaginationCurrent] = react.useState(paginationObj.defaultCurrent || 1);
  const [paginationSize, setPaginationSize] = react.useState(paginationObj.defaultPageSize || 10);
  const {
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle
  } = useComponentConfig('list');
  const {
    renderEmpty
  } = react.useContext(ConfigContext);
  const defaultPaginationProps = {
    current: 1,
    total: 0,
    position: 'bottom'
  };
  const triggerPaginationEvent = eventName => (page, pageSize) => {
    var _a;
    setPaginationCurrent(page);
    setPaginationSize(pageSize);
    if (pagination) {
      (_a = pagination === null || pagination === void 0 ? void 0 : pagination[eventName]) === null || _a === void 0 ? void 0 : _a.call(pagination, page, pageSize);
    }
  };
  const onPaginationChange = triggerPaginationEvent('onChange');
  const onPaginationShowSizeChange = triggerPaginationEvent('onShowSizeChange');
  const renderInternalItem = (item, index) => {
    if (!renderItem) {
      return null;
    }
    let key;
    if (typeof rowKey === 'function') {
      key = rowKey(item);
    } else if (rowKey) {
      key = item[rowKey];
    } else {
      key = item.key;
    }
    if (!key) {
      key = `list-item-${index}`;
    }
    return /*#__PURE__*/react.createElement(react.Fragment, {
      key: key
    }, renderItem(item, index));
  };
  const isSomethingAfterLastItem = !!(loadMore || pagination || footer);
  const prefixCls = getPrefixCls('list', customizePrefixCls);
  // Style
  const [wrapCSSVar, hashId, cssVarCls] = list_style(prefixCls);
  let loadingProp = loading;
  if (typeof loadingProp === 'boolean') {
    loadingProp = {
      spinning: loadingProp
    };
  }
  const isLoading = !!(loadingProp === null || loadingProp === void 0 ? void 0 : loadingProp.spinning);
  const mergedSize = hooks_useSize(customizeSize);
  // large => lg
  // small => sm
  let sizeCls = '';
  switch (mergedSize) {
    case 'large':
      sizeCls = 'lg';
      break;
    case 'small':
      sizeCls = 'sm';
      break;
    default:
      break;
  }
  const classString = classnames_default()(prefixCls, {
    [`${prefixCls}-vertical`]: itemLayout === 'vertical',
    [`${prefixCls}-${sizeCls}`]: sizeCls,
    [`${prefixCls}-split`]: split,
    [`${prefixCls}-bordered`]: bordered,
    [`${prefixCls}-loading`]: isLoading,
    [`${prefixCls}-grid`]: !!grid,
    [`${prefixCls}-something-after-last-item`]: isSomethingAfterLastItem,
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, contextClassName, className, rootClassName, hashId, cssVarCls);
  const paginationProps = extendsObject(defaultPaginationProps, {
    total: dataSource.length,
    current: paginationCurrent,
    pageSize: paginationSize
  }, pagination || {});
  const largestPage = Math.ceil(paginationProps.total / paginationProps.pageSize);
  paginationProps.current = Math.min(paginationProps.current, largestPage);
  const paginationContent = pagination && (/*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${prefixCls}-pagination`)
  }, /*#__PURE__*/react.createElement(es_pagination, Object.assign({
    align: "end"
  }, paginationProps, {
    onChange: onPaginationChange,
    onShowSizeChange: onPaginationShowSizeChange
  }))));
  let splitDataSource = (0,toConsumableArray/* default */.Z)(dataSource);
  if (pagination) {
    if (dataSource.length > (paginationProps.current - 1) * paginationProps.pageSize) {
      splitDataSource = (0,toConsumableArray/* default */.Z)(dataSource).splice((paginationProps.current - 1) * paginationProps.pageSize, paginationProps.pageSize);
    }
  }
  const needResponsive = Object.keys(grid || {}).some(key => ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].includes(key));
  const screens = hooks_useBreakpoint(needResponsive);
  const currentBreakpoint = react.useMemo(() => {
    for (let i = 0; i < responsiveArray.length; i += 1) {
      const breakpoint = responsiveArray[i];
      if (screens[breakpoint]) {
        return breakpoint;
      }
    }
    return undefined;
  }, [screens]);
  const colStyle = react.useMemo(() => {
    if (!grid) {
      return undefined;
    }
    const columnCount = currentBreakpoint && grid[currentBreakpoint] ? grid[currentBreakpoint] : grid.column;
    if (columnCount) {
      return {
        width: `${100 / columnCount}%`,
        maxWidth: `${100 / columnCount}%`
      };
    }
  }, [JSON.stringify(grid), currentBreakpoint]);
  let childrenContent = isLoading && /*#__PURE__*/react.createElement("div", {
    style: {
      minHeight: 53
    }
  });
  if (splitDataSource.length > 0) {
    const items = splitDataSource.map(renderInternalItem);
    childrenContent = grid ? (/*#__PURE__*/react.createElement(row, {
      gutter: grid.gutter
    }, react.Children.map(items, child => (/*#__PURE__*/react.createElement("div", {
      key: child === null || child === void 0 ? void 0 : child.key,
      style: colStyle
    }, child))))) : (/*#__PURE__*/react.createElement("ul", {
      className: `${prefixCls}-items`
    }, items));
  } else if (!children && !isLoading) {
    childrenContent = /*#__PURE__*/react.createElement("div", {
      className: `${prefixCls}-empty-text`
    }, (locale === null || locale === void 0 ? void 0 : locale.emptyText) || (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty('List')) || /*#__PURE__*/react.createElement(defaultRenderEmpty, {
      componentName: "List"
    }));
  }
  const paginationPosition = paginationProps.position;
  const contextValue = react.useMemo(() => ({
    grid,
    itemLayout
  }), [JSON.stringify(grid), itemLayout]);
  return wrapCSSVar(/*#__PURE__*/react.createElement(ListContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/react.createElement("div", Object.assign({
    ref: ref,
    style: Object.assign(Object.assign({}, contextStyle), style),
    className: classString
  }, rest), (paginationPosition === 'top' || paginationPosition === 'both') && paginationContent, header && /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-header`
  }, header), /*#__PURE__*/react.createElement(spin, Object.assign({}, loadingProp), childrenContent, children), footer && /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-footer`
  }, footer), loadMore || (paginationPosition === 'bottom' || paginationPosition === 'both') && paginationContent)));
}
const ListWithForwardRef = /*#__PURE__*/react.forwardRef(InternalList);
if (false) {}
const list_List = ListWithForwardRef;
list_List.Item = list_Item;
/* harmony default export */ var list = (list_List);
;// CONCATENATED MODULE: ./node_modules/rc-mentions/es/hooks/useEffectState.js


/**
 * Trigger a callback on state change
 */
function useEffectState() {
  var _useState = (0,react.useState)({
      id: 0,
      callback: null
    }),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    effectId = _useState2[0],
    setEffectId = _useState2[1];
  var update = (0,react.useCallback)(function (callback) {
    setEffectId(function (_ref) {
      var id = _ref.id;
      return {
        id: id + 1,
        callback: callback
      };
    });
  }, []);
  (0,react.useEffect)(function () {
    var _effectId$callback;
    (_effectId$callback = effectId.callback) === null || _effectId$callback === void 0 || _effectId$callback.call(effectId);
  }, [effectId]);
  return update;
}
// EXTERNAL MODULE: ./node_modules/@rc-component/trigger/es/index.js + 11 modules
var trigger_es = __webpack_require__(91831);
;// CONCATENATED MODULE: ./node_modules/rc-mentions/es/MentionsContext.js
/* tslint:disable: no-object-literal-type-assertion */

// We will never use default, here only to fix TypeScript warning
var MentionsContext = /*#__PURE__*/react.createContext(null);
/* harmony default export */ var es_MentionsContext = (MentionsContext);
;// CONCATENATED MODULE: ./node_modules/rc-mentions/es/DropdownMenu.js



/**
 * We only use Menu to display the candidate.
 * The focus is controlled by textarea to make accessibility easy.
 */
function DropdownMenu(props) {
  var _React$useContext = react.useContext(es_MentionsContext),
    notFoundContent = _React$useContext.notFoundContent,
    activeIndex = _React$useContext.activeIndex,
    setActiveIndex = _React$useContext.setActiveIndex,
    selectOption = _React$useContext.selectOption,
    onFocus = _React$useContext.onFocus,
    onBlur = _React$useContext.onBlur,
    onScroll = _React$useContext.onScroll;
  var prefixCls = props.prefixCls,
    options = props.options;
  var activeOption = options[activeIndex] || {};
  return /*#__PURE__*/react.createElement(rc_menu_es/* default */.ZP, {
    prefixCls: "".concat(prefixCls, "-menu"),
    activeKey: activeOption.key,
    onSelect: function onSelect(_ref) {
      var key = _ref.key;
      var option = options.find(function (_ref2) {
        var optionKey = _ref2.key;
        return optionKey === key;
      });
      selectOption(option);
    },
    onFocus: onFocus,
    onBlur: onBlur,
    onScroll: onScroll
  }, options.map(function (option, index) {
    var key = option.key,
      disabled = option.disabled,
      className = option.className,
      style = option.style,
      label = option.label;
    return /*#__PURE__*/react.createElement(rc_menu_es/* MenuItem */.sN, {
      key: key,
      disabled: disabled,
      className: className,
      style: style,
      onMouseEnter: function onMouseEnter() {
        setActiveIndex(index);
      }
    }, label);
  }), !options.length && /*#__PURE__*/react.createElement(rc_menu_es/* MenuItem */.sN, {
    disabled: true
  }, notFoundContent));
}
/* harmony default export */ var es_DropdownMenu = (DropdownMenu);
;// CONCATENATED MODULE: ./node_modules/rc-mentions/es/KeywordTrigger.js




var BUILT_IN_PLACEMENTS = {
  bottomRight: {
    points: ['tl', 'br'],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomLeft: {
    points: ['tr', 'bl'],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topRight: {
    points: ['bl', 'tr'],
    offset: [0, -4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ['br', 'tl'],
    offset: [0, -4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  }
};
var KeywordTrigger = function KeywordTrigger(props) {
  var prefixCls = props.prefixCls,
    options = props.options,
    children = props.children,
    visible = props.visible,
    transitionName = props.transitionName,
    getPopupContainer = props.getPopupContainer,
    dropdownClassName = props.dropdownClassName,
    direction = props.direction,
    placement = props.placement;
  var dropdownPrefix = "".concat(prefixCls, "-dropdown");
  var dropdownElement = /*#__PURE__*/react.createElement(es_DropdownMenu, {
    prefixCls: dropdownPrefix,
    options: options
  });
  var dropdownPlacement = (0,react.useMemo)(function () {
    var popupPlacement;
    if (direction === 'rtl') {
      popupPlacement = placement === 'top' ? 'topLeft' : 'bottomLeft';
    } else {
      popupPlacement = placement === 'top' ? 'topRight' : 'bottomRight';
    }
    return popupPlacement;
  }, [direction, placement]);
  return /*#__PURE__*/react.createElement(trigger_es/* default */.Z, {
    prefixCls: dropdownPrefix,
    popupVisible: visible,
    popup: dropdownElement,
    popupPlacement: dropdownPlacement,
    popupTransitionName: transitionName,
    builtinPlacements: BUILT_IN_PLACEMENTS,
    getPopupContainer: getPopupContainer,
    popupClassName: dropdownClassName
  }, children);
};
/* harmony default export */ var es_KeywordTrigger = (KeywordTrigger);
;// CONCATENATED MODULE: ./node_modules/rc-mentions/es/Option.js
var Option_Option = function Option() {
  return null;
};
/* harmony default export */ var es_Option = (Option_Option);
;// CONCATENATED MODULE: ./node_modules/rc-mentions/es/util.js
/**
 * Cut input selection into 2 part and return text before selection start
 */
function getBeforeSelectionText(input) {
  var selectionStart = input.selectionStart;
  return input.value.slice(0, selectionStart);
}
/**
 * Find the last match prefix index
 */
function getLastMeasureIndex(text, prefix) {
  return prefix.reduce(function (lastMatch, prefixStr) {
    var lastIndex = text.lastIndexOf(prefixStr);
    if (lastIndex > lastMatch.location) {
      return {
        location: lastIndex,
        prefix: prefixStr
      };
    }
    return lastMatch;
  }, {
    location: -1,
    prefix: ''
  });
}
function lower(char) {
  return (char || '').toLowerCase();
}
function reduceText(text, targetText, split) {
  var firstChar = text[0];
  if (!firstChar || firstChar === split) {
    return text;
  }

  // Reuse rest text as it can
  var restText = text;
  var targetTextLen = targetText.length;
  for (var i = 0; i < targetTextLen; i += 1) {
    if (lower(restText[i]) !== lower(targetText[i])) {
      restText = restText.slice(i);
      break;
    } else if (i === targetTextLen - 1) {
      restText = restText.slice(targetTextLen);
    }
  }
  return restText;
}

/**
 * Paint targetText into current text:
 *  text: little@litest
 *  targetText: light
 *  => little @light test
 */
function replaceWithMeasure(text, measureConfig) {
  var measureLocation = measureConfig.measureLocation,
    prefix = measureConfig.prefix,
    targetText = measureConfig.targetText,
    selectionStart = measureConfig.selectionStart,
    split = measureConfig.split;

  // Before text will append one space if have other text
  var beforeMeasureText = text.slice(0, measureLocation);
  if (beforeMeasureText[beforeMeasureText.length - split.length] === split) {
    beforeMeasureText = beforeMeasureText.slice(0, beforeMeasureText.length - split.length);
  }
  if (beforeMeasureText) {
    beforeMeasureText = "".concat(beforeMeasureText).concat(split);
  }

  // Cut duplicate string with current targetText
  var restText = reduceText(text.slice(selectionStart), targetText.slice(selectionStart - measureLocation - prefix.length), split);
  if (restText.slice(0, split.length) === split) {
    restText = restText.slice(split.length);
  }
  var connectedStartText = "".concat(beforeMeasureText).concat(prefix).concat(targetText).concat(split);
  return {
    text: "".concat(connectedStartText).concat(restText),
    selectionLocation: connectedStartText.length
  };
}
function setInputSelection(input, location) {
  input.setSelectionRange(location, location);

  /**
   * Reset caret into view.
   * Since this function always called by user control, it's safe to focus element.
   */
  input.blur();
  input.focus();
}
function util_validateSearch(text, split) {
  return !split || text.indexOf(split) === -1;
}
function util_filterOption(input, _ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value;
  var lowerCase = input.toLowerCase();
  return value.toLowerCase().indexOf(lowerCase) !== -1;
}
;// CONCATENATED MODULE: ./node_modules/rc-mentions/es/Mentions.js




var Mentions_excluded = ["prefixCls", "className", "style", "prefix", "split", "notFoundContent", "value", "defaultValue", "children", "options", "open", "allowClear", "silent", "validateSearch", "filterOption", "onChange", "onKeyDown", "onKeyUp", "onPressEnter", "onSearch", "onSelect", "onFocus", "onBlur", "transitionName", "placement", "direction", "getPopupContainer", "dropdownClassName", "rows", "visible", "onPopupScroll"],
  Mentions_excluded2 = ["suffix", "prefixCls", "defaultValue", "value", "allowClear", "onChange", "classNames", "className", "disabled", "onClear"];













var InternalMentions = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var prefixCls = props.prefixCls,
    className = props.className,
    style = props.style,
    _props$prefix = props.prefix,
    prefix = _props$prefix === void 0 ? '@' : _props$prefix,
    _props$split = props.split,
    split = _props$split === void 0 ? ' ' : _props$split,
    _props$notFoundConten = props.notFoundContent,
    notFoundContent = _props$notFoundConten === void 0 ? 'Not Found' : _props$notFoundConten,
    value = props.value,
    defaultValue = props.defaultValue,
    children = props.children,
    options = props.options,
    open = props.open,
    allowClear = props.allowClear,
    silent = props.silent,
    _props$validateSearch = props.validateSearch,
    validateSearch = _props$validateSearch === void 0 ? util_validateSearch : _props$validateSearch,
    _props$filterOption = props.filterOption,
    filterOption = _props$filterOption === void 0 ? util_filterOption : _props$filterOption,
    onChange = props.onChange,
    onKeyDown = props.onKeyDown,
    onKeyUp = props.onKeyUp,
    onPressEnter = props.onPressEnter,
    onSearch = props.onSearch,
    onSelect = props.onSelect,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    transitionName = props.transitionName,
    placement = props.placement,
    direction = props.direction,
    getPopupContainer = props.getPopupContainer,
    dropdownClassName = props.dropdownClassName,
    _props$rows = props.rows,
    rows = _props$rows === void 0 ? 1 : _props$rows,
    visible = props.visible,
    onPopupScroll = props.onPopupScroll,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, Mentions_excluded);
  var mergedPrefix = (0,react.useMemo)(function () {
    return Array.isArray(prefix) ? prefix : [prefix];
  }, [prefix]);

  // =============================== Refs ===============================
  var containerRef = (0,react.useRef)(null);
  var textareaRef = (0,react.useRef)(null);
  var measureRef = (0,react.useRef)(null);
  var getTextArea = function getTextArea() {
    var _textareaRef$current;
    return (_textareaRef$current = textareaRef.current) === null || _textareaRef$current === void 0 || (_textareaRef$current = _textareaRef$current.resizableTextArea) === null || _textareaRef$current === void 0 ? void 0 : _textareaRef$current.textArea;
  };
  react.useImperativeHandle(ref, function () {
    var _textareaRef$current4;
    return {
      focus: function focus() {
        var _textareaRef$current2;
        return (_textareaRef$current2 = textareaRef.current) === null || _textareaRef$current2 === void 0 ? void 0 : _textareaRef$current2.focus();
      },
      blur: function blur() {
        var _textareaRef$current3;
        return (_textareaRef$current3 = textareaRef.current) === null || _textareaRef$current3 === void 0 ? void 0 : _textareaRef$current3.blur();
      },
      textarea: (_textareaRef$current4 = textareaRef.current) === null || _textareaRef$current4 === void 0 || (_textareaRef$current4 = _textareaRef$current4.resizableTextArea) === null || _textareaRef$current4 === void 0 ? void 0 : _textareaRef$current4.textArea,
      nativeElement: containerRef.current
    };
  });

  // ============================== State ===============================
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    measuring = _useState2[0],
    setMeasuring = _useState2[1];
  var _useState3 = (0,react.useState)(''),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    measureText = _useState4[0],
    setMeasureText = _useState4[1];
  var _useState5 = (0,react.useState)(''),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    measurePrefix = _useState6[0],
    setMeasurePrefix = _useState6[1];
  var _useState7 = (0,react.useState)(0),
    _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
    measureLocation = _useState8[0],
    setMeasureLocation = _useState8[1];
  var _useState9 = (0,react.useState)(0),
    _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
    activeIndex = _useState10[0],
    setActiveIndex = _useState10[1];
  var _useState11 = (0,react.useState)(false),
    _useState12 = (0,slicedToArray/* default */.Z)(_useState11, 2),
    isFocus = _useState12[0],
    setIsFocus = _useState12[1];

  // ============================== Value ===============================
  var _useMergedState = (0,useMergedState/* default */.Z)('', {
      defaultValue: defaultValue,
      value: value
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    mergedValue = _useMergedState2[0],
    setMergedValue = _useMergedState2[1];

  // =============================== Open ===============================
  (0,react.useEffect)(function () {
    // Sync measure div top with textarea for rc-trigger usage
    if (measuring && measureRef.current) {
      measureRef.current.scrollTop = getTextArea().scrollTop;
    }
  }, [measuring]);
  var _React$useMemo = react.useMemo(function () {
      if (open) {
        if (false) {}
        for (var i = 0; i < mergedPrefix.length; i += 1) {
          var curPrefix = mergedPrefix[i];
          var index = mergedValue.lastIndexOf(curPrefix);
          if (index >= 0) {
            return [true, '', curPrefix, index];
          }
        }
      }
      return [measuring, measureText, measurePrefix, measureLocation];
    }, [open, measuring, mergedPrefix, mergedValue, measureText, measurePrefix, measureLocation]),
    _React$useMemo2 = (0,slicedToArray/* default */.Z)(_React$useMemo, 4),
    mergedMeasuring = _React$useMemo2[0],
    mergedMeasureText = _React$useMemo2[1],
    mergedMeasurePrefix = _React$useMemo2[2],
    mergedMeasureLocation = _React$useMemo2[3];

  // ============================== Option ==============================
  var getOptions = react.useCallback(function (targetMeasureText) {
    var list;
    if (options && options.length > 0) {
      list = options.map(function (item) {
        var _item$key;
        return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, item), {}, {
          key: (_item$key = item === null || item === void 0 ? void 0 : item.key) !== null && _item$key !== void 0 ? _item$key : item.value
        });
      });
    } else {
      list = (0,Children_toArray/* default */.Z)(children).map(function (_ref) {
        var optionProps = _ref.props,
          key = _ref.key;
        return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, optionProps), {}, {
          label: optionProps.children,
          key: key || optionProps.value
        });
      });
    }
    return list.filter(function (option) {
      /** Return all result if `filterOption` is false. */
      if (filterOption === false) {
        return true;
      }
      return filterOption(targetMeasureText, option);
    });
  }, [children, options, filterOption]);
  var mergedOptions = react.useMemo(function () {
    return getOptions(mergedMeasureText);
  }, [getOptions, mergedMeasureText]);

  // ============================= Measure ==============================
  // Mark that we will reset input selection to target position when user select option
  var onSelectionEffect = useEffectState();
  var startMeasure = function startMeasure(nextMeasureText, nextMeasurePrefix, nextMeasureLocation) {
    setMeasuring(true);
    setMeasureText(nextMeasureText);
    setMeasurePrefix(nextMeasurePrefix);
    setMeasureLocation(nextMeasureLocation);
    setActiveIndex(0);
  };
  var stopMeasure = function stopMeasure(callback) {
    setMeasuring(false);
    setMeasureLocation(0);
    setMeasureText('');
    onSelectionEffect(callback);
  };

  // ============================== Change ==============================
  var triggerChange = function triggerChange(nextValue) {
    setMergedValue(nextValue);
    onChange === null || onChange === void 0 || onChange(nextValue);
  };
  var onInternalChange = function onInternalChange(_ref2) {
    var nextValue = _ref2.target.value;
    triggerChange(nextValue);
  };
  var selectOption = function selectOption(option) {
    var _getTextArea;
    var _option$value = option.value,
      mentionValue = _option$value === void 0 ? '' : _option$value;
    var _replaceWithMeasure = replaceWithMeasure(mergedValue, {
        measureLocation: mergedMeasureLocation,
        targetText: mentionValue,
        prefix: mergedMeasurePrefix,
        selectionStart: (_getTextArea = getTextArea()) === null || _getTextArea === void 0 ? void 0 : _getTextArea.selectionStart,
        split: split
      }),
      text = _replaceWithMeasure.text,
      selectionLocation = _replaceWithMeasure.selectionLocation;
    triggerChange(text);
    stopMeasure(function () {
      // We need restore the selection position
      setInputSelection(getTextArea(), selectionLocation);
    });
    onSelect === null || onSelect === void 0 || onSelect(option, mergedMeasurePrefix);
  };

  // ============================= KeyEvent =============================
  // Check if hit the measure keyword
  var onInternalKeyDown = function onInternalKeyDown(event) {
    var which = event.which;
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(event);

    // Skip if not measuring
    if (!mergedMeasuring) {
      return;
    }
    if (which === KeyCode/* default.UP */.Z.UP || which === KeyCode/* default.DOWN */.Z.DOWN) {
      // Control arrow function
      var optionLen = mergedOptions.length;
      var offset = which === KeyCode/* default.UP */.Z.UP ? -1 : 1;
      var newActiveIndex = (activeIndex + offset + optionLen) % optionLen;
      setActiveIndex(newActiveIndex);
      event.preventDefault();
    } else if (which === KeyCode/* default.ESC */.Z.ESC) {
      stopMeasure();
    } else if (which === KeyCode/* default.ENTER */.Z.ENTER) {
      // Measure hit
      event.preventDefault();
      // loading skip
      if (silent) {
        return;
      }
      if (!mergedOptions.length) {
        stopMeasure();
        return;
      }
      var _option = mergedOptions[activeIndex];
      selectOption(_option);
    }
  };

  /**
   * When to start measure:
   * 1. When user press `prefix`
   * 2. When measureText !== prevMeasureText
   *  - If measure hit
   *  - If measuring
   *
   * When to stop measure:
   * 1. Selection is out of range
   * 2. Contains `space`
   * 3. ESC or select one
   */
  var onInternalKeyUp = function onInternalKeyUp(event) {
    var key = event.key,
      which = event.which;
    var target = event.target;
    var selectionStartText = getBeforeSelectionText(target);
    var _getLastMeasureIndex = getLastMeasureIndex(selectionStartText, mergedPrefix),
      measureIndex = _getLastMeasureIndex.location,
      nextMeasurePrefix = _getLastMeasureIndex.prefix;

    // If the client implements an onKeyUp handler, call it
    onKeyUp === null || onKeyUp === void 0 || onKeyUp(event);

    // Skip if match the white key list
    if ([KeyCode/* default.ESC */.Z.ESC, KeyCode/* default.UP */.Z.UP, KeyCode/* default.DOWN */.Z.DOWN, KeyCode/* default.ENTER */.Z.ENTER].indexOf(which) !== -1) {
      return;
    }
    if (measureIndex !== -1) {
      var nextMeasureText = selectionStartText.slice(measureIndex + nextMeasurePrefix.length);
      var validateMeasure = validateSearch(nextMeasureText, split);
      var matchOption = !!getOptions(nextMeasureText).length;
      if (validateMeasure) {
        // adding AltGraph also fort azert keyboard
        if (key === nextMeasurePrefix || key === 'Shift' || which === KeyCode/* default.ALT */.Z.ALT || key === 'AltGraph' || mergedMeasuring || nextMeasureText !== mergedMeasureText && matchOption) {
          startMeasure(nextMeasureText, nextMeasurePrefix, measureIndex);
        }
      } else if (mergedMeasuring) {
        // Stop if measureText is invalidate
        stopMeasure();
      }

      /**
       * We will trigger `onSearch` to developer since they may use for async update.
       * If met `space` means user finished searching.
       */
      if (onSearch && validateMeasure) {
        onSearch(nextMeasureText, nextMeasurePrefix);
      }
    } else if (mergedMeasuring) {
      stopMeasure();
    }
  };
  var onInternalPressEnter = function onInternalPressEnter(event) {
    if (!mergedMeasuring && onPressEnter) {
      onPressEnter(event);
    }
  };

  // ============================ Focus Blur ============================
  var focusRef = (0,react.useRef)();
  var onInternalFocus = function onInternalFocus(event) {
    window.clearTimeout(focusRef.current);
    if (!isFocus && event && onFocus) {
      onFocus(event);
    }
    setIsFocus(true);
  };
  var onInternalBlur = function onInternalBlur(event) {
    focusRef.current = window.setTimeout(function () {
      setIsFocus(false);
      stopMeasure();
      onBlur === null || onBlur === void 0 || onBlur(event);
    }, 0);
  };
  var onDropdownFocus = function onDropdownFocus() {
    onInternalFocus();
  };
  var onDropdownBlur = function onDropdownBlur() {
    onInternalBlur();
  };

  // ============================== Scroll ===============================
  var onInternalPopupScroll = function onInternalPopupScroll(event) {
    onPopupScroll === null || onPopupScroll === void 0 || onPopupScroll(event);
  };

  // ============================== Render ==============================

  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(prefixCls, className),
    style: style,
    ref: containerRef
  }, /*#__PURE__*/react.createElement(rc_textarea_es/* default */.Z, (0,esm_extends/* default */.Z)({
    ref: textareaRef,
    value: mergedValue
  }, restProps, {
    rows: rows,
    onChange: onInternalChange,
    onKeyDown: onInternalKeyDown,
    onKeyUp: onInternalKeyUp,
    onPressEnter: onInternalPressEnter,
    onFocus: onInternalFocus,
    onBlur: onInternalBlur
  })), mergedMeasuring && /*#__PURE__*/react.createElement("div", {
    ref: measureRef,
    className: "".concat(prefixCls, "-measure")
  }, mergedValue.slice(0, mergedMeasureLocation), /*#__PURE__*/react.createElement(es_MentionsContext.Provider, {
    value: {
      notFoundContent: notFoundContent,
      activeIndex: activeIndex,
      setActiveIndex: setActiveIndex,
      selectOption: selectOption,
      onFocus: onDropdownFocus,
      onBlur: onDropdownBlur,
      onScroll: onInternalPopupScroll
    }
  }, /*#__PURE__*/react.createElement(es_KeywordTrigger, {
    prefixCls: prefixCls,
    transitionName: transitionName,
    placement: placement,
    direction: direction,
    options: mergedOptions,
    visible: true,
    getPopupContainer: getPopupContainer,
    dropdownClassName: dropdownClassName
  }, /*#__PURE__*/react.createElement("span", null, mergedMeasurePrefix))), mergedValue.slice(mergedMeasureLocation + mergedMeasurePrefix.length)));
});
var Mentions = /*#__PURE__*/(0,react.forwardRef)(function (_ref3, ref) {
  var suffix = _ref3.suffix,
    _ref3$prefixCls = _ref3.prefixCls,
    prefixCls = _ref3$prefixCls === void 0 ? 'rc-mentions' : _ref3$prefixCls,
    defaultValue = _ref3.defaultValue,
    customValue = _ref3.value,
    allowClear = _ref3.allowClear,
    onChange = _ref3.onChange,
    classes = _ref3.classNames,
    className = _ref3.className,
    disabled = _ref3.disabled,
    onClear = _ref3.onClear,
    rest = (0,objectWithoutProperties/* default */.Z)(_ref3, Mentions_excluded2);
  // =============================== Ref ================================
  var holderRef = (0,react.useRef)(null);
  var mentionRef = (0,react.useRef)(null);
  (0,react.useImperativeHandle)(ref, function () {
    var _holderRef$current, _mentionRef$current;
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, mentionRef.current), {}, {
      nativeElement: ((_holderRef$current = holderRef.current) === null || _holderRef$current === void 0 ? void 0 : _holderRef$current.nativeElement) || ((_mentionRef$current = mentionRef.current) === null || _mentionRef$current === void 0 ? void 0 : _mentionRef$current.nativeElement)
    });
  });

  // ============================== Value ===============================
  var _useMergedState3 = (0,useMergedState/* default */.Z)('', {
      defaultValue: defaultValue,
      value: customValue
    }),
    _useMergedState4 = (0,slicedToArray/* default */.Z)(_useMergedState3, 2),
    mergedValue = _useMergedState4[0],
    setMergedValue = _useMergedState4[1];

  // ============================== Change ==============================
  var triggerChange = function triggerChange(currentValue) {
    setMergedValue(currentValue);
    onChange === null || onChange === void 0 || onChange(currentValue);
  };

  // ============================== Reset ===============================
  var handleReset = function handleReset() {
    triggerChange('');
  };
  return /*#__PURE__*/react.createElement(rc_input_es/* BaseInput */.Q, {
    suffix: suffix,
    prefixCls: prefixCls,
    value: mergedValue,
    allowClear: allowClear,
    handleReset: handleReset,
    className: className,
    classNames: classes,
    disabled: disabled,
    ref: holderRef,
    onClear: onClear
  }, /*#__PURE__*/react.createElement(InternalMentions, (0,esm_extends/* default */.Z)({
    className: classes === null || classes === void 0 ? void 0 : classes.mentions,
    prefixCls: prefixCls,
    ref: mentionRef,
    onChange: triggerChange,
    disabled: disabled
  }, rest)));
});
Mentions.Option = es_Option;
/* harmony default export */ var es_Mentions = (Mentions);
;// CONCATENATED MODULE: ./node_modules/rc-mentions/es/index.js

/* harmony default export */ var rc_mentions_es = (es_Mentions);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/toList.js
const toList = (candidate, skipEmpty = false) => {
  if (skipEmpty && (candidate === undefined || candidate === null)) {
    return [];
  }
  return Array.isArray(candidate) ? candidate : [candidate];
};
/* harmony default export */ var _util_toList = (toList);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/mentions/style/index.js





const genMentionsStyle = token => {
  const {
    componentCls,
    antCls,
    colorTextDisabled,
    controlItemBgHover,
    controlPaddingHorizontal,
    colorText,
    motionDurationSlow,
    lineHeight,
    controlHeight,
    paddingInline,
    paddingBlock,
    fontSize,
    fontSizeIcon,
    colorIcon,
    colorTextQuaternary,
    colorBgElevated,
    paddingXXS,
    borderRadius,
    borderRadiusLG,
    boxShadowSecondary,
    itemPaddingVertical,
    calc
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), genBasicInputStyle(token)), {
      position: 'relative',
      display: 'inline-block',
      height: 'auto',
      padding: `0 ${(0,cssinjs_es/* unit */.bf)(token.paddingInline)}`,
      overflow: 'hidden',
      lineHeight,
      whiteSpace: 'pre-wrap',
      verticalAlign: 'bottom'
    }), variants_genOutlinedStyle(token)), variants_genFilledStyle(token)), style_variants_genBorderlessStyle(token)), {
      '&-affix-wrapper': Object.assign(Object.assign({}, genBasicInputStyle(token)), {
        display: 'inline-flex',
        paddingBlock: 0,
        paddingInlineStart: 0,
        paddingInlineEnd: token.paddingInline,
        '&::before': {
          display: 'inline-block',
          width: 0,
          visibility: 'hidden',
          content: '"\\a0"'
        },
        [`${componentCls}-suffix`]: {
          display: 'inline-flex',
          alignItems: 'center',
          // 当页面中存在 feedback-icon 时，给 clear-icon 添加右边距
          [`&:has(${antCls}-form-item-feedback-icon) ${componentCls}-clear-icon`]: {
            marginInlineEnd: token.marginXS
          },
          [`${antCls}-form-item-feedback-icon`]: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center'
          }
        },
        [`${componentCls}-clear-icon`]: {
          insetInlineEnd: 0,
          insetBlockStart: calc(fontSize).mul(lineHeight).mul(0.5).add(paddingBlock).equal(),
          padding: 0,
          lineHeight: 0,
          color: colorTextQuaternary,
          fontSize: fontSizeIcon,
          verticalAlign: -1,
          // https://github.com/ant-design/ant-design/pull/18151
          // https://codesandbox.io/s/wizardly-sun-u10br
          cursor: 'pointer',
          transition: `color ${motionDurationSlow}`,
          border: 'none',
          outline: 'none',
          backgroundColor: 'transparent',
          '&:hover': {
            color: colorIcon
          },
          '&:active': {
            color: colorText
          },
          '&-hidden': {
            visibility: 'hidden'
          }
        }
      })
    }), variants_genUnderlinedStyle(token)), {
      '&-disabled': {
        '> textarea': Object.assign({}, variants_genDisabledStyle(token))
      },
      // ================= Input Area =================
      [`&, &-affix-wrapper > ${componentCls}`]: {
        [`> textarea, ${componentCls}-measure`]: {
          color: colorText,
          boxSizing: 'border-box',
          minHeight: token.calc(controlHeight).sub(2).equal(),
          margin: 0,
          padding: `${(0,cssinjs_es/* unit */.bf)(paddingBlock)} ${(0,cssinjs_es/* unit */.bf)(paddingInline)}`,
          overflow: 'inherit',
          overflowX: 'hidden',
          overflowY: 'auto',
          fontWeight: 'inherit',
          fontSize: 'inherit',
          fontFamily: 'inherit',
          fontStyle: 'inherit',
          fontVariant: 'inherit',
          fontSizeAdjust: 'inherit',
          fontStretch: 'inherit',
          lineHeight: 'inherit',
          direction: 'inherit',
          letterSpacing: 'inherit',
          whiteSpace: 'inherit',
          textAlign: 'inherit',
          verticalAlign: 'top',
          wordWrap: 'break-word',
          wordBreak: 'inherit',
          tabSize: 'inherit'
        },
        '> textarea': Object.assign(Object.assign({
          width: '100%',
          border: 'none',
          outline: 'none',
          resize: 'none',
          backgroundColor: 'transparent'
        }, genPlaceholderStyle(token.colorTextPlaceholder)), {
          padding: `${(0,cssinjs_es/* unit */.bf)(token.paddingBlock)} 0`
        }),
        [`${componentCls}-measure`]: {
          position: 'absolute',
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          zIndex: -1,
          color: 'transparent',
          pointerEvents: 'none',
          '> span': {
            display: 'inline-block',
            minHeight: '1em'
          }
        }
      },
      // ================== Dropdown ==================
      '&-dropdown': Object.assign(Object.assign({}, resetComponent(token)), {
        position: 'absolute',
        top: -9999,
        insetInlineStart: -9999,
        zIndex: token.zIndexPopup,
        boxSizing: 'border-box',
        fontSize,
        fontVariant: 'initial',
        padding: paddingXXS,
        backgroundColor: colorBgElevated,
        borderRadius: borderRadiusLG,
        outline: 'none',
        boxShadow: boxShadowSecondary,
        '&-hidden': {
          display: 'none'
        },
        [`${componentCls}-dropdown-menu`]: {
          maxHeight: token.dropdownHeight,
          margin: 0,
          paddingInlineStart: 0,
          // Override default ul/ol
          overflow: 'auto',
          listStyle: 'none',
          outline: 'none',
          '&-item': Object.assign(Object.assign({}, textEllipsis), {
            position: 'relative',
            display: 'block',
            minWidth: token.controlItemWidth,
            padding: `${(0,cssinjs_es/* unit */.bf)(itemPaddingVertical)} ${(0,cssinjs_es/* unit */.bf)(controlPaddingHorizontal)}`,
            color: colorText,
            borderRadius,
            fontWeight: 'normal',
            lineHeight,
            cursor: 'pointer',
            transition: `background ${motionDurationSlow} ease`,
            '&:hover': {
              backgroundColor: controlItemBgHover
            },
            '&-disabled': {
              color: colorTextDisabled,
              cursor: 'not-allowed',
              '&:hover': {
                color: colorTextDisabled,
                backgroundColor: controlItemBgHover,
                cursor: 'not-allowed'
              }
            },
            '&-selected': {
              color: colorText,
              fontWeight: token.fontWeightStrong,
              backgroundColor: controlItemBgHover
            },
            '&-active': {
              backgroundColor: controlItemBgHover
            }
          })
        }
      })
    })
  };
};
const mentions_style_prepareComponentToken = token => Object.assign(Object.assign({}, token_initComponentToken(token)), {
  dropdownHeight: 250,
  controlItemWidth: 100,
  zIndexPopup: token.zIndexPopupBase + 50,
  itemPaddingVertical: (token.controlHeight - token.fontHeight) / 2
});
// ============================== Export ==============================
/* harmony default export */ var mentions_style = (genStyleHooks('Mentions', token => {
  const mentionsToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, initInputToken(token));
  return genMentionsStyle(mentionsToken);
}, mentions_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/mentions/index.js
"use client";

var mentions_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
















const {
  Option: mentions_Option
} = rc_mentions_es;
function loadingFilterOption() {
  return true;
}
const mentions_InternalMentions = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      disabled,
      loading,
      filterOption,
      children,
      notFoundContent,
      options,
      status: customStatus,
      allowClear = false,
      popupClassName,
      style,
      variant: customVariant
    } = props,
    restProps = mentions_rest(props, ["prefixCls", "className", "rootClassName", "disabled", "loading", "filterOption", "children", "notFoundContent", "options", "status", "allowClear", "popupClassName", "style", "variant"]);
  const [focused, setFocused] = react.useState(false);
  const innerRef = react.useRef(null);
  const mergedRef = (0,es_ref/* composeRef */.sQ)(ref, innerRef);
  // =================== Warning =====================
  if (false) {}
  const {
    getPrefixCls,
    renderEmpty,
    direction,
    mentions: contextMentions
  } = react.useContext(ConfigContext);
  const {
    status: contextStatus,
    hasFeedback,
    feedbackIcon
  } = react.useContext(FormItemInputContext);
  const mergedStatus = getMergedStatus(contextStatus, customStatus);
  const onFocus = (...args) => {
    if (restProps.onFocus) {
      restProps.onFocus.apply(restProps, args);
    }
    setFocused(true);
  };
  const onBlur = (...args) => {
    if (restProps.onBlur) {
      restProps.onBlur.apply(restProps, args);
    }
    setFocused(false);
  };
  const notFoundContentEle = react.useMemo(() => {
    if (notFoundContent !== undefined) {
      return notFoundContent;
    }
    return (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty('Select')) || /*#__PURE__*/react.createElement(defaultRenderEmpty, {
      componentName: "Select"
    });
  }, [notFoundContent, renderEmpty]);
  const mentionOptions = react.useMemo(() => {
    if (loading) {
      return /*#__PURE__*/react.createElement(mentions_Option, {
        value: "ANTD_SEARCHING",
        disabled: true
      }, /*#__PURE__*/react.createElement(spin, {
        size: "small"
      }));
    }
    return children;
  }, [loading, children]);
  const mergedOptions = loading ? [{
    value: 'ANTD_SEARCHING',
    disabled: true,
    label: /*#__PURE__*/react.createElement(spin, {
      size: "small"
    })
  }] : options;
  const mentionsfilterOption = loading ? loadingFilterOption : filterOption;
  const prefixCls = getPrefixCls('mentions', customizePrefixCls);
  const mergedAllowClear = _util_getAllowClear(allowClear);
  // Style
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = mentions_style(prefixCls, rootCls);
  const [variant, enableVariantCls] = useVariants('mentions', customVariant);
  const suffixNode = hasFeedback && /*#__PURE__*/react.createElement(react.Fragment, null, feedbackIcon);
  const mergedClassName = classnames_default()(contextMentions === null || contextMentions === void 0 ? void 0 : contextMentions.className, className, rootClassName, cssVarCls, rootCls);
  const mentions = /*#__PURE__*/react.createElement(rc_mentions_es, Object.assign({
    silent: loading,
    prefixCls: prefixCls,
    notFoundContent: notFoundContentEle,
    className: mergedClassName,
    disabled: disabled,
    allowClear: mergedAllowClear,
    direction: direction,
    style: Object.assign(Object.assign({}, contextMentions === null || contextMentions === void 0 ? void 0 : contextMentions.style), style)
  }, restProps, {
    filterOption: mentionsfilterOption,
    onFocus: onFocus,
    onBlur: onBlur,
    dropdownClassName: classnames_default()(popupClassName, rootClassName, hashId, cssVarCls, rootCls),
    ref: mergedRef,
    options: mergedOptions,
    suffix: suffixNode,
    classNames: {
      mentions: classnames_default()({
        [`${prefixCls}-disabled`]: disabled,
        [`${prefixCls}-focused`]: focused,
        [`${prefixCls}-rtl`]: direction === 'rtl'
      }, hashId),
      variant: classnames_default()({
        [`${prefixCls}-${variant}`]: enableVariantCls
      }, getStatusClassNames(prefixCls, mergedStatus)),
      affixWrapper: hashId
    }
  }), mentionOptions);
  return wrapCSSVar(mentions);
});
const mentions_Mentions = mentions_InternalMentions;
if (false) {}
mentions_Mentions.Option = mentions_Option;
// We don't care debug panel
/* istanbul ignore next */
const mentions_PurePanel = _util_PurePanel(mentions_Mentions, undefined, undefined, 'mentions');
mentions_Mentions._InternalPanelDoNotUseOrYouWillBeFired = mentions_PurePanel;
mentions_Mentions.getMentions = (value = '', config = {}) => {
  const {
    prefix = '@',
    split = ' '
  } = config;
  const prefixList = _util_toList(prefix);
  return value.split(split).map((str = '') => {
    let hitPrefix = null;
    prefixList.some(prefixStr => {
      const startStr = str.slice(0, prefixStr.length);
      if (startStr === prefixStr) {
        hitPrefix = prefixStr;
        return true;
      }
      return false;
    });
    if (hitPrefix !== null) {
      return {
        prefix: hitPrefix,
        value: str.slice(hitPrefix.length)
      };
    }
    return null;
  }).filter(entity => !!entity && !!entity.value);
};
/* harmony default export */ var mentions = (mentions_Mentions);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/message/index.js
"use client";









let message = null;
let act = callback => callback();
let taskQueue = [];
let defaultGlobalConfig = {};
function getGlobalContext() {
  const {
    getContainer,
    duration,
    rtl,
    maxCount,
    top
  } = defaultGlobalConfig;
  const mergedContainer = (getContainer === null || getContainer === void 0 ? void 0 : getContainer()) || document.body;
  return {
    getContainer: () => mergedContainer,
    duration,
    rtl,
    maxCount,
    top
  };
}
const GlobalHolder = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    messageConfig,
    sync
  } = props;
  const {
    getPrefixCls
  } = (0,react.useContext)(ConfigContext);
  const prefixCls = defaultGlobalConfig.prefixCls || getPrefixCls('message');
  const appConfig = (0,react.useContext)(AppConfigContext);
  const [api, holder] = useInternalMessage(Object.assign(Object.assign(Object.assign({}, messageConfig), {
    prefixCls
  }), appConfig.message));
  react.useImperativeHandle(ref, () => {
    const instance = Object.assign({}, api);
    Object.keys(instance).forEach(method => {
      instance[method] = (...args) => {
        sync();
        return api[method].apply(api, args);
      };
    });
    return {
      instance,
      sync
    };
  });
  return holder;
});
const GlobalHolderWrapper = /*#__PURE__*/react.forwardRef((_, ref) => {
  const [messageConfig, setMessageConfig] = react.useState(getGlobalContext);
  const sync = () => {
    setMessageConfig(getGlobalContext);
  };
  react.useEffect(sync, []);
  const global = globalConfig();
  const rootPrefixCls = global.getRootPrefixCls();
  const rootIconPrefixCls = global.getIconPrefixCls();
  const theme = global.getTheme();
  const dom = /*#__PURE__*/react.createElement(GlobalHolder, {
    ref: ref,
    sync: sync,
    messageConfig: messageConfig
  });
  return /*#__PURE__*/react.createElement(config_provider, {
    prefixCls: rootPrefixCls,
    iconPrefixCls: rootIconPrefixCls,
    theme: theme
  }, global.holderRender ? global.holderRender(dom) : dom);
});
const flushMessageQueue = () => {
  if (!message) {
    const holderFragment = document.createDocumentFragment();
    const newMessage = {
      fragment: holderFragment
    };
    message = newMessage;
    // Delay render to avoid sync issue
    act(() => {
      const reactRender = unstableSetRender();
      reactRender(/*#__PURE__*/react.createElement(GlobalHolderWrapper, {
        ref: node => {
          const {
            instance,
            sync
          } = node || {};
          // React 18 test env will throw if call immediately in ref
          Promise.resolve().then(() => {
            if (!newMessage.instance && instance) {
              newMessage.instance = instance;
              newMessage.sync = sync;
              flushMessageQueue();
            }
          });
        }
      }), holderFragment);
    });
    return;
  }
  // Notification not ready
  if (!message.instance) {
    return;
  }
  // >>> Execute task
  taskQueue.forEach(task => {
    const {
      type,
      skipped
    } = task;
    // Only `skipped` when user call notice but cancel it immediately
    // and instance not ready
    if (!skipped) {
      switch (type) {
        case 'open':
          {
            act(() => {
              const closeFn = message.instance.open(Object.assign(Object.assign({}, defaultGlobalConfig), task.config));
              closeFn === null || closeFn === void 0 ? void 0 : closeFn.then(task.resolve);
              task.setCloseFn(closeFn);
            });
            break;
          }
        case 'destroy':
          act(() => {
            message === null || message === void 0 ? void 0 : message.instance.destroy(task.key);
          });
          break;
        // Other type open
        default:
          {
            act(() => {
              var _message$instance;
              const closeFn = (_message$instance = message.instance)[type].apply(_message$instance, (0,toConsumableArray/* default */.Z)(task.args));
              closeFn === null || closeFn === void 0 ? void 0 : closeFn.then(task.resolve);
              task.setCloseFn(closeFn);
            });
          }
      }
    }
  });
  // Clean up
  taskQueue = [];
};
// ==============================================================================
// ==                                  Export                                  ==
// ==============================================================================
function setMessageGlobalConfig(config) {
  defaultGlobalConfig = Object.assign(Object.assign({}, defaultGlobalConfig), config);
  // Trigger sync for it
  act(() => {
    var _a;
    (_a = message === null || message === void 0 ? void 0 : message.sync) === null || _a === void 0 ? void 0 : _a.call(message);
  });
}
function message_open(config) {
  const result = wrapPromiseFn(resolve => {
    let closeFn;
    const task = {
      type: 'open',
      config,
      resolve,
      setCloseFn: fn => {
        closeFn = fn;
      }
    };
    taskQueue.push(task);
    return () => {
      if (closeFn) {
        act(() => {
          closeFn();
        });
      } else {
        task.skipped = true;
      }
    };
  });
  flushMessageQueue();
  return result;
}
function typeOpen(type, args) {
  const global = globalConfig();
  if (false) {}
  const result = wrapPromiseFn(resolve => {
    let closeFn;
    const task = {
      type,
      args,
      resolve,
      setCloseFn: fn => {
        closeFn = fn;
      }
    };
    taskQueue.push(task);
    return () => {
      if (closeFn) {
        act(() => {
          closeFn();
        });
      } else {
        task.skipped = true;
      }
    };
  });
  flushMessageQueue();
  return result;
}
const destroy = key => {
  taskQueue.push({
    type: 'destroy',
    key
  });
  flushMessageQueue();
};
const methods = ['success', 'info', 'warning', 'error', 'loading'];
const baseStaticMethods = {
  open: message_open,
  destroy,
  config: setMessageGlobalConfig,
  useMessage: useMessage,
  _InternalPanelDoNotUseOrYouWillBeFired: message_PurePanel
};
const staticMethods = baseStaticMethods;
methods.forEach(type => {
  staticMethods[type] = (...args) => typeOpen(type, args);
});
// ==============================================================================
// ==                                   Test                                   ==
// ==============================================================================
const message_noop = () => {};
let _actWrapper = (/* unused pure expression or super */ null && (message_noop));
if (false) {}
const actWrapper = (/* unused pure expression or super */ null && (_actWrapper));

let _actDestroy = (/* unused pure expression or super */ null && (message_noop));
if (false) {}
const actDestroy = (/* unused pure expression or super */ null && (_actDestroy));

/* harmony default export */ var es_message = (staticMethods);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/modal/PurePanel.js
"use client";

var modal_PurePanel_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};









const modal_PurePanel_PurePanel = props => {
  const {
      prefixCls: customizePrefixCls,
      className,
      closeIcon,
      closable,
      type,
      title,
      children,
      footer
    } = props,
    restProps = modal_PurePanel_rest(props, ["prefixCls", "className", "closeIcon", "closable", "type", "title", "children", "footer"]);
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const rootPrefixCls = getPrefixCls();
  const prefixCls = customizePrefixCls || getPrefixCls('modal');
  const rootCls = hooks_useCSSVarCls(rootPrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = modal_style(prefixCls, rootCls);
  const confirmPrefixCls = `${prefixCls}-confirm`;
  // Choose target props by confirm mark
  let additionalProps = {};
  if (type) {
    additionalProps = {
      closable: closable !== null && closable !== void 0 ? closable : false,
      title: '',
      footer: '',
      children: (/*#__PURE__*/react.createElement(ConfirmContent, Object.assign({}, props, {
        prefixCls: prefixCls,
        confirmPrefixCls: confirmPrefixCls,
        rootPrefixCls: rootPrefixCls,
        content: children
      })))
    };
  } else {
    additionalProps = {
      closable: closable !== null && closable !== void 0 ? closable : true,
      title,
      footer: footer !== null && /*#__PURE__*/react.createElement(Footer, Object.assign({}, props)),
      children
    };
  }
  return wrapCSSVar(/*#__PURE__*/react.createElement(rc_dialog_es/* Panel */.s, Object.assign({
    prefixCls: prefixCls,
    className: classnames_default()(hashId, `${prefixCls}-pure-panel`, type && confirmPrefixCls, type && `${confirmPrefixCls}-${type}`, className, cssVarCls, rootCls)
  }, restProps, {
    closeIcon: renderCloseIcon(prefixCls, closeIcon),
    closable: closable
  }, additionalProps)));
};
/* harmony default export */ var modal_PurePanel = (withPureRenderTheme(modal_PurePanel_PurePanel));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/modal/index.js
"use client";






function modalWarn(props) {
  return confirm_confirm(withWarn(props));
}
const es_modal_Modal = modal_Modal;
es_modal_Modal.useModal = modal_useModal;
es_modal_Modal.info = function infoFn(props) {
  return confirm_confirm(withInfo(props));
};
es_modal_Modal.success = function successFn(props) {
  return confirm_confirm(withSuccess(props));
};
es_modal_Modal.error = function errorFn(props) {
  return confirm_confirm(withError(props));
};
es_modal_Modal.warning = modalWarn;
es_modal_Modal.warn = modalWarn;
es_modal_Modal.confirm = function confirmFn(props) {
  return confirm_confirm(withConfirm(props));
};
es_modal_Modal.destroyAll = function destroyAllFn() {
  while (modal_destroyFns.length) {
    const close = modal_destroyFns.pop();
    if (close) {
      close();
    }
  }
};
es_modal_Modal.config = modalGlobalConfig;
es_modal_Modal._InternalPanelDoNotUseOrYouWillBeFired = modal_PurePanel;
if (false) {}
/* harmony default export */ var modal = (es_modal_Modal);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/notification/index.js
"use client";







let notification = null;
let notification_act = callback => callback();
let notification_taskQueue = [];
let notification_defaultGlobalConfig = {};
function notification_getGlobalContext() {
  const {
    getContainer,
    rtl,
    maxCount,
    top,
    bottom,
    showProgress,
    pauseOnHover
  } = notification_defaultGlobalConfig;
  const mergedContainer = (getContainer === null || getContainer === void 0 ? void 0 : getContainer()) || document.body;
  return {
    getContainer: () => mergedContainer,
    rtl,
    maxCount,
    top,
    bottom,
    showProgress,
    pauseOnHover
  };
}
const notification_GlobalHolder = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    notificationConfig,
    sync
  } = props;
  const {
    getPrefixCls
  } = (0,react.useContext)(ConfigContext);
  const prefixCls = notification_defaultGlobalConfig.prefixCls || getPrefixCls('notification');
  const appConfig = (0,react.useContext)(AppConfigContext);
  const [api, holder] = useInternalNotification(Object.assign(Object.assign(Object.assign({}, notificationConfig), {
    prefixCls
  }), appConfig.notification));
  react.useEffect(sync, []);
  react.useImperativeHandle(ref, () => {
    const instance = Object.assign({}, api);
    Object.keys(instance).forEach(method => {
      instance[method] = (...args) => {
        sync();
        return api[method].apply(api, args);
      };
    });
    return {
      instance,
      sync
    };
  });
  return holder;
});
const notification_GlobalHolderWrapper = /*#__PURE__*/react.forwardRef((_, ref) => {
  const [notificationConfig, setNotificationConfig] = react.useState(notification_getGlobalContext);
  const sync = () => {
    setNotificationConfig(notification_getGlobalContext);
  };
  react.useEffect(sync, []);
  const global = globalConfig();
  const rootPrefixCls = global.getRootPrefixCls();
  const rootIconPrefixCls = global.getIconPrefixCls();
  const theme = global.getTheme();
  const dom = /*#__PURE__*/react.createElement(notification_GlobalHolder, {
    ref: ref,
    sync: sync,
    notificationConfig: notificationConfig
  });
  return /*#__PURE__*/react.createElement(config_provider, {
    prefixCls: rootPrefixCls,
    iconPrefixCls: rootIconPrefixCls,
    theme: theme
  }, global.holderRender ? global.holderRender(dom) : dom);
});
const flushNotificationQueue = () => {
  if (!notification) {
    const holderFragment = document.createDocumentFragment();
    const newNotification = {
      fragment: holderFragment
    };
    notification = newNotification;
    // Delay render to avoid sync issue
    notification_act(() => {
      const reactRender = unstableSetRender();
      reactRender(/*#__PURE__*/react.createElement(notification_GlobalHolderWrapper, {
        ref: node => {
          const {
            instance,
            sync
          } = node || {};
          Promise.resolve().then(() => {
            if (!newNotification.instance && instance) {
              newNotification.instance = instance;
              newNotification.sync = sync;
              flushNotificationQueue();
            }
          });
        }
      }), holderFragment);
    });
    return;
  }
  // Notification not ready
  if (!notification.instance) {
    return;
  }
  // >>> Execute task
  notification_taskQueue.forEach(task => {
    switch (task.type) {
      case 'open':
        {
          notification_act(() => {
            notification.instance.open(Object.assign(Object.assign({}, notification_defaultGlobalConfig), task.config));
          });
          break;
        }
      case 'destroy':
        notification_act(() => {
          var _a;
          (_a = notification === null || notification === void 0 ? void 0 : notification.instance) === null || _a === void 0 ? void 0 : _a.destroy(task.key);
        });
        break;
    }
  });
  // Clean up
  notification_taskQueue = [];
};
// ==============================================================================
// ==                                  Export                                  ==
// ==============================================================================
function setNotificationGlobalConfig(config) {
  notification_defaultGlobalConfig = Object.assign(Object.assign({}, notification_defaultGlobalConfig), config);
  // Trigger sync for it
  notification_act(() => {
    var _a;
    (_a = notification === null || notification === void 0 ? void 0 : notification.sync) === null || _a === void 0 ? void 0 : _a.call(notification);
  });
}
function notification_open(config) {
  const global = globalConfig();
  if (false) {}
  notification_taskQueue.push({
    type: 'open',
    config
  });
  flushNotificationQueue();
}
const notification_destroy = key => {
  notification_taskQueue.push({
    type: 'destroy',
    key
  });
  flushNotificationQueue();
};
const notification_methods = ['success', 'info', 'warning', 'error'];
const notification_baseStaticMethods = {
  open: notification_open,
  destroy: notification_destroy,
  config: setNotificationGlobalConfig,
  useNotification: useNotification,
  _InternalPanelDoNotUseOrYouWillBeFired: notification_PurePanel
};
const notification_staticMethods = notification_baseStaticMethods;
notification_methods.forEach(type => {
  notification_staticMethods[type] = config => notification_open(Object.assign(Object.assign({}, config), {
    type
  }));
});
// ==============================================================================
// ==                                   Test                                   ==
// ==============================================================================
const notification_noop = () => {};
let notification_actWrapper = (/* unused pure expression or super */ null && (notification_noop));
if (false) {}
const es_notification_actWrapper = (/* unused pure expression or super */ null && (notification_actWrapper));

let notification_actDestroy = (/* unused pure expression or super */ null && (notification_noop));
if (false) {}
const es_notification_actDestroy = (/* unused pure expression or super */ null && (notification_actDestroy));

/* harmony default export */ var es_notification = (notification_staticMethods);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/popconfirm/style/index.js

// =============================== Base ===============================
const popconfirm_style_genBaseStyle = token => {
  const {
    componentCls,
    iconCls,
    antCls,
    zIndexPopup,
    colorText,
    colorWarning,
    marginXXS,
    marginXS,
    fontSize,
    fontWeightStrong,
    colorTextHeading
  } = token;
  return {
    [componentCls]: {
      zIndex: zIndexPopup,
      [`&${antCls}-popover`]: {
        fontSize
      },
      [`${componentCls}-message`]: {
        marginBottom: marginXS,
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'start',
        [`> ${componentCls}-message-icon ${iconCls}`]: {
          color: colorWarning,
          fontSize,
          lineHeight: 1,
          marginInlineEnd: marginXS
        },
        [`${componentCls}-title`]: {
          fontWeight: fontWeightStrong,
          color: colorTextHeading,
          '&:only-child': {
            fontWeight: 'normal'
          }
        },
        [`${componentCls}-description`]: {
          marginTop: marginXXS,
          color: colorText
        }
      },
      [`${componentCls}-buttons`]: {
        textAlign: 'end',
        whiteSpace: 'nowrap',
        button: {
          marginInlineStart: marginXS
        }
      }
    }
  };
};
// ============================== Export ==============================
const popconfirm_style_prepareComponentToken = token => {
  const {
    zIndexPopupBase
  } = token;
  return {
    zIndexPopup: zIndexPopupBase + 60
  };
};
/* harmony default export */ var popconfirm_style = (genStyleHooks('Popconfirm', token => popconfirm_style_genBaseStyle(token), popconfirm_style_prepareComponentToken, {
  resetStyle: false
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/popconfirm/PurePanel.js
"use client";

var popconfirm_PurePanel_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};












const PurePanel_Overlay = props => {
  const {
    prefixCls,
    okButtonProps,
    cancelButtonProps,
    title,
    description,
    cancelText,
    okText,
    okType = 'primary',
    icon = /*#__PURE__*/react.createElement(ExclamationCircleFilled/* default */.Z, null),
    showCancel = true,
    close,
    onConfirm,
    onCancel,
    onPopupClick
  } = props;
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const [contextLocale] = locale_useLocale('Popconfirm', es_locale_en_US.Popconfirm);
  const titleNode = getRenderPropValue(title);
  const descriptionNode = getRenderPropValue(description);
  return /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-inner-content`,
    onClick: onPopupClick
  }, /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-message`
  }, icon && /*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-message-icon`
  }, icon), /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-message-text`
  }, titleNode && /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-title`
  }, titleNode), descriptionNode && /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-description`
  }, descriptionNode))), /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-buttons`
  }, showCancel && (/*#__PURE__*/react.createElement(es_button, Object.assign({
    onClick: onCancel,
    size: "small"
  }, cancelButtonProps), cancelText || (contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.cancelText))), /*#__PURE__*/react.createElement(_util_ActionButton, {
    buttonProps: Object.assign(Object.assign({
      size: 'small'
    }, convertLegacyProps(okType)), okButtonProps),
    actionFn: onConfirm,
    close: close,
    prefixCls: getPrefixCls('btn'),
    quitOnNullishReturnValue: true,
    emitEvent: true
  }, okText || (contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.okText))));
};
const popconfirm_PurePanel_PurePanel = props => {
  const {
      prefixCls: customizePrefixCls,
      placement,
      className,
      style
    } = props,
    restProps = popconfirm_PurePanel_rest(props, ["prefixCls", "placement", "className", "style"]);
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('popconfirm', customizePrefixCls);
  const [wrapCSSVar] = popconfirm_style(prefixCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement(popover_PurePanel, {
    placement: placement,
    className: classnames_default()(prefixCls, className),
    style: style,
    content: /*#__PURE__*/react.createElement(PurePanel_Overlay, Object.assign({
      prefixCls: prefixCls
    }, restProps))
  }));
};
/* harmony default export */ var popconfirm_PurePanel = (popconfirm_PurePanel_PurePanel);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/popconfirm/index.js
"use client";

var popconfirm_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};









const InternalPopconfirm = /*#__PURE__*/react.forwardRef((props, ref) => {
  var _a, _b;
  const {
      prefixCls: customizePrefixCls,
      placement = 'top',
      trigger = 'click',
      okType = 'primary',
      icon = /*#__PURE__*/react.createElement(ExclamationCircleFilled/* default */.Z, null),
      children,
      overlayClassName,
      onOpenChange,
      onVisibleChange,
      overlayStyle,
      styles,
      classNames: popconfirmClassNames
    } = props,
    restProps = popconfirm_rest(props, ["prefixCls", "placement", "trigger", "okType", "icon", "children", "overlayClassName", "onOpenChange", "onVisibleChange", "overlayStyle", "styles", "classNames"]);
  const {
    getPrefixCls,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig('popconfirm');
  const [open, setOpen] = (0,useMergedState/* default */.Z)(false, {
    value: (_a = props.open) !== null && _a !== void 0 ? _a : props.visible,
    defaultValue: (_b = props.defaultOpen) !== null && _b !== void 0 ? _b : props.defaultVisible
  });
  const settingOpen = (value, e) => {
    setOpen(value, true);
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(value);
    onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(value, e);
  };
  const close = e => {
    settingOpen(false, e);
  };
  const onConfirm = e => {
    var _a;
    return (_a = props.onConfirm) === null || _a === void 0 ? void 0 : _a.call(undefined, e);
  };
  const onCancel = e => {
    var _a;
    settingOpen(false, e);
    (_a = props.onCancel) === null || _a === void 0 ? void 0 : _a.call(undefined, e);
  };
  const onInternalOpenChange = (value, e) => {
    const {
      disabled = false
    } = props;
    if (disabled) {
      return;
    }
    settingOpen(value, e);
  };
  const prefixCls = getPrefixCls('popconfirm', customizePrefixCls);
  const rootClassNames = classnames_default()(prefixCls, contextClassName, overlayClassName, contextClassNames.root, popconfirmClassNames === null || popconfirmClassNames === void 0 ? void 0 : popconfirmClassNames.root);
  const bodyClassNames = classnames_default()(contextClassNames.body, popconfirmClassNames === null || popconfirmClassNames === void 0 ? void 0 : popconfirmClassNames.body);
  const [wrapCSSVar] = popconfirm_style(prefixCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement(popover, Object.assign({}, (0,omit/* default */.Z)(restProps, ['title']), {
    trigger: trigger,
    placement: placement,
    onOpenChange: onInternalOpenChange,
    open: open,
    ref: ref,
    classNames: {
      root: rootClassNames,
      body: bodyClassNames
    },
    styles: {
      root: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.root), contextStyle), overlayStyle), styles === null || styles === void 0 ? void 0 : styles.root),
      body: Object.assign(Object.assign({}, contextStyles.body), styles === null || styles === void 0 ? void 0 : styles.body)
    },
    content: /*#__PURE__*/react.createElement(PurePanel_Overlay, Object.assign({
      okType: okType,
      icon: icon
    }, props, {
      prefixCls: prefixCls,
      close: close,
      onConfirm: onConfirm,
      onCancel: onCancel
    })),
    "data-popover-inject": true
  }), children));
});
const Popconfirm = InternalPopconfirm;
// We don't care debug panel
/* istanbul ignore next */
Popconfirm._InternalPanelDoNotUseOrYouWillBeFired = popconfirm_PurePanel;
if (false) {}
/* harmony default export */ var popconfirm = (Popconfirm);
// EXTERNAL MODULE: ./node_modules/rc-progress/es/index.js + 6 modules
var rc_progress_es = __webpack_require__(38100);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/progress/utils.js

function validProgress(progress) {
  if (!progress || progress < 0) {
    return 0;
  }
  if (progress > 100) {
    return 100;
  }
  return progress;
}
function getSuccessPercent({
  success,
  successPercent
}) {
  let percent = successPercent;
  /** @deprecated Use `percent` instead */
  if (success && 'progress' in success) {
    percent = success.progress;
  }
  if (success && 'percent' in success) {
    percent = success.percent;
  }
  return percent;
}
const getPercentage = ({
  percent,
  success,
  successPercent
}) => {
  const realSuccessPercent = validProgress(getSuccessPercent({
    success,
    successPercent
  }));
  return [realSuccessPercent, validProgress(validProgress(percent) - realSuccessPercent)];
};
const getStrokeColor = ({
  success = {},
  strokeColor
}) => {
  const {
    strokeColor: successColor
  } = success;
  return [successColor || colors_es/* presetPrimaryColors.green */.ez.green, strokeColor || null];
};
const getSize = (size, type, extra) => {
  var _a, _b, _c, _d;
  let width = -1;
  let height = -1;
  if (type === 'step') {
    const steps = extra.steps;
    const strokeWidth = extra.strokeWidth;
    if (typeof size === 'string' || typeof size === 'undefined') {
      width = size === 'small' ? 2 : 14;
      height = strokeWidth !== null && strokeWidth !== void 0 ? strokeWidth : 8;
    } else if (typeof size === 'number') {
      [width, height] = [size, size];
    } else {
      [width = 14, height = 8] = Array.isArray(size) ? size : [size.width, size.height];
    }
    width *= steps;
  } else if (type === 'line') {
    const strokeWidth = extra === null || extra === void 0 ? void 0 : extra.strokeWidth;
    if (typeof size === 'string' || typeof size === 'undefined') {
      height = strokeWidth || (size === 'small' ? 6 : 8);
    } else if (typeof size === 'number') {
      [width, height] = [size, size];
    } else {
      [width = -1, height = 8] = Array.isArray(size) ? size : [size.width, size.height];
    }
  } else if (type === 'circle' || type === 'dashboard') {
    if (typeof size === 'string' || typeof size === 'undefined') {
      [width, height] = size === 'small' ? [60, 60] : [120, 120];
    } else if (typeof size === 'number') {
      [width, height] = [size, size];
    } else if (Array.isArray(size)) {
      width = (_b = (_a = size[0]) !== null && _a !== void 0 ? _a : size[1]) !== null && _b !== void 0 ? _b : 120;
      height = (_d = (_c = size[0]) !== null && _c !== void 0 ? _c : size[1]) !== null && _d !== void 0 ? _d : 120;
    }
  }
  return [width, height];
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/progress/Circle.js
"use client";






const CIRCLE_MIN_STROKE_WIDTH = 3;
const getMinPercent = width => CIRCLE_MIN_STROKE_WIDTH / width * 100;
const Circle = props => {
  const {
    prefixCls,
    trailColor = null,
    strokeLinecap = 'round',
    gapPosition,
    gapDegree,
    width: originWidth = 120,
    type,
    children,
    success,
    size = originWidth,
    steps
  } = props;
  const [width, height] = getSize(size, 'circle');
  let {
    strokeWidth
  } = props;
  if (strokeWidth === undefined) {
    strokeWidth = Math.max(getMinPercent(width), 6);
  }
  const circleStyle = {
    width,
    height,
    fontSize: width * 0.15 + 6
  };
  const realGapDegree = react.useMemo(() => {
    // Support gapDeg = 0 when type = 'dashboard'
    if (gapDegree || gapDegree === 0) {
      return gapDegree;
    }
    if (type === 'dashboard') {
      return 75;
    }
    return undefined;
  }, [gapDegree, type]);
  const percentArray = getPercentage(props);
  const gapPos = gapPosition || type === 'dashboard' && 'bottom' || undefined;
  // using className to style stroke color
  const isGradient = Object.prototype.toString.call(props.strokeColor) === '[object Object]';
  const strokeColor = getStrokeColor({
    success,
    strokeColor: props.strokeColor
  });
  const wrapperClassName = classnames_default()(`${prefixCls}-inner`, {
    [`${prefixCls}-circle-gradient`]: isGradient
  });
  const circleContent = /*#__PURE__*/react.createElement(rc_progress_es/* Circle */.Cd, {
    steps: steps,
    percent: steps ? percentArray[1] : percentArray,
    strokeWidth: strokeWidth,
    trailWidth: strokeWidth,
    strokeColor: steps ? strokeColor[1] : strokeColor,
    strokeLinecap: strokeLinecap,
    trailColor: trailColor,
    prefixCls: prefixCls,
    gapDegree: realGapDegree,
    gapPosition: gapPos
  });
  const smallCircle = width <= 20;
  const node = /*#__PURE__*/react.createElement("div", {
    className: wrapperClassName,
    style: circleStyle
  }, circleContent, !smallCircle && children);
  if (smallCircle) {
    return /*#__PURE__*/react.createElement(es_tooltip, {
      title: children
    }, node);
  }
  return node;
};
/* harmony default export */ var progress_Circle = (Circle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/progress/style/index.js



const LineStrokeColorVar = '--progress-line-stroke-color';
const Percent = '--progress-percent';
const genAntProgressActive = isRtl => {
  const direction = isRtl ? '100%' : '-100%';
  return new cssinjs_es/* Keyframes */.E4(`antProgress${isRtl ? 'RTL' : 'LTR'}Active`, {
    '0%': {
      transform: `translateX(${direction}) scaleX(0)`,
      opacity: 0.1
    },
    '20%': {
      transform: `translateX(${direction}) scaleX(0)`,
      opacity: 0.5
    },
    to: {
      transform: 'translateX(0) scaleX(1)',
      opacity: 0
    }
  });
};
const progress_style_genBaseStyle = token => {
  const {
    componentCls: progressCls,
    iconCls: iconPrefixCls
  } = token;
  return {
    [progressCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      display: 'inline-block',
      '&-rtl': {
        direction: 'rtl'
      },
      '&-line': {
        position: 'relative',
        width: '100%',
        fontSize: token.fontSize
      },
      [`${progressCls}-outer`]: {
        display: 'inline-flex',
        alignItems: 'center',
        width: '100%'
      },
      [`${progressCls}-inner`]: {
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        flex: 1,
        overflow: 'hidden',
        verticalAlign: 'middle',
        backgroundColor: token.remainingColor,
        borderRadius: token.lineBorderRadius
      },
      [`${progressCls}-inner:not(${progressCls}-circle-gradient)`]: {
        [`${progressCls}-circle-path`]: {
          stroke: token.defaultColor
        }
      },
      [`${progressCls}-success-bg, ${progressCls}-bg`]: {
        position: 'relative',
        background: token.defaultColor,
        borderRadius: token.lineBorderRadius,
        transition: `all ${token.motionDurationSlow} ${token.motionEaseInOutCirc}`
      },
      [`${progressCls}-layout-bottom`]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        [`${progressCls}-text`]: {
          width: 'max-content',
          marginInlineStart: 0,
          marginTop: token.marginXXS
        }
      },
      [`${progressCls}-bg`]: {
        overflow: 'hidden',
        '&::after': {
          content: '""',
          background: {
            _multi_value_: true,
            value: ['inherit', `var(${LineStrokeColorVar})`]
          },
          height: '100%',
          width: `calc(1 / var(${Percent}) * 100%)`,
          display: 'block'
        },
        [`&${progressCls}-bg-inner`]: {
          minWidth: 'max-content',
          '&::after': {
            content: 'none'
          },
          [`${progressCls}-text-inner`]: {
            color: token.colorWhite,
            [`&${progressCls}-text-bright`]: {
              color: 'rgba(0, 0, 0, 0.45)'
            }
          }
        }
      },
      [`${progressCls}-success-bg`]: {
        position: 'absolute',
        insetBlockStart: 0,
        insetInlineStart: 0,
        backgroundColor: token.colorSuccess
      },
      [`${progressCls}-text`]: {
        display: 'inline-block',
        marginInlineStart: token.marginXS,
        color: token.colorText,
        lineHeight: 1,
        width: '2em',
        whiteSpace: 'nowrap',
        textAlign: 'start',
        verticalAlign: 'middle',
        wordBreak: 'normal',
        [iconPrefixCls]: {
          fontSize: token.fontSize
        },
        [`&${progressCls}-text-outer`]: {
          width: 'max-content'
        },
        [`&${progressCls}-text-outer${progressCls}-text-start`]: {
          width: 'max-content',
          marginInlineStart: 0,
          marginInlineEnd: token.marginXS
        }
      },
      [`${progressCls}-text-inner`]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        marginInlineStart: 0,
        padding: `0 ${(0,cssinjs_es/* unit */.bf)(token.paddingXXS)}`,
        [`&${progressCls}-text-start`]: {
          justifyContent: 'start'
        },
        [`&${progressCls}-text-end`]: {
          justifyContent: 'end'
        }
      },
      [`&${progressCls}-status-active`]: {
        [`${progressCls}-bg::before`]: {
          position: 'absolute',
          inset: 0,
          backgroundColor: token.colorBgContainer,
          borderRadius: token.lineBorderRadius,
          opacity: 0,
          animationName: genAntProgressActive(),
          animationDuration: token.progressActiveMotionDuration,
          animationTimingFunction: token.motionEaseOutQuint,
          animationIterationCount: 'infinite',
          content: '""'
        }
      },
      [`&${progressCls}-rtl${progressCls}-status-active`]: {
        [`${progressCls}-bg::before`]: {
          animationName: genAntProgressActive(true)
        }
      },
      [`&${progressCls}-status-exception`]: {
        [`${progressCls}-bg`]: {
          backgroundColor: token.colorError
        },
        [`${progressCls}-text`]: {
          color: token.colorError
        }
      },
      [`&${progressCls}-status-exception ${progressCls}-inner:not(${progressCls}-circle-gradient)`]: {
        [`${progressCls}-circle-path`]: {
          stroke: token.colorError
        }
      },
      [`&${progressCls}-status-success`]: {
        [`${progressCls}-bg`]: {
          backgroundColor: token.colorSuccess
        },
        [`${progressCls}-text`]: {
          color: token.colorSuccess
        }
      },
      [`&${progressCls}-status-success ${progressCls}-inner:not(${progressCls}-circle-gradient)`]: {
        [`${progressCls}-circle-path`]: {
          stroke: token.colorSuccess
        }
      }
    })
  };
};
const genCircleStyle = token => {
  const {
    componentCls: progressCls,
    iconCls: iconPrefixCls
  } = token;
  return {
    [progressCls]: {
      [`${progressCls}-circle-trail`]: {
        stroke: token.remainingColor
      },
      [`&${progressCls}-circle ${progressCls}-inner`]: {
        position: 'relative',
        lineHeight: 1,
        backgroundColor: 'transparent'
      },
      [`&${progressCls}-circle ${progressCls}-text`]: {
        position: 'absolute',
        insetBlockStart: '50%',
        insetInlineStart: 0,
        width: '100%',
        margin: 0,
        padding: 0,
        color: token.circleTextColor,
        fontSize: token.circleTextFontSize,
        lineHeight: 1,
        whiteSpace: 'normal',
        textAlign: 'center',
        transform: 'translateY(-50%)',
        [iconPrefixCls]: {
          fontSize: token.circleIconFontSize
        }
      },
      [`${progressCls}-circle&-status-exception`]: {
        [`${progressCls}-text`]: {
          color: token.colorError
        }
      },
      [`${progressCls}-circle&-status-success`]: {
        [`${progressCls}-text`]: {
          color: token.colorSuccess
        }
      }
    },
    [`${progressCls}-inline-circle`]: {
      lineHeight: 1,
      [`${progressCls}-inner`]: {
        verticalAlign: 'bottom'
      }
    }
  };
};
const genStepStyle = token => {
  const {
    componentCls: progressCls
  } = token;
  return {
    [progressCls]: {
      [`${progressCls}-steps`]: {
        display: 'inline-block',
        '&-outer': {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        },
        '&-item': {
          flexShrink: 0,
          minWidth: token.progressStepMinWidth,
          marginInlineEnd: token.progressStepMarginInlineEnd,
          backgroundColor: token.remainingColor,
          transition: `all ${token.motionDurationSlow}`,
          '&-active': {
            backgroundColor: token.defaultColor
          }
        }
      }
    }
  };
};
const genSmallLine = token => {
  const {
    componentCls: progressCls,
    iconCls: iconPrefixCls
  } = token;
  return {
    [progressCls]: {
      [`${progressCls}-small&-line, ${progressCls}-small&-line ${progressCls}-text ${iconPrefixCls}`]: {
        fontSize: token.fontSizeSM
      }
    }
  };
};
const progress_style_prepareComponentToken = token => ({
  circleTextColor: token.colorText,
  defaultColor: token.colorInfo,
  remainingColor: token.colorFillSecondary,
  lineBorderRadius: 100,
  // magic for capsule shape, should be a very large number
  circleTextFontSize: '1em',
  circleIconFontSize: `${token.fontSize / token.fontSizeSM}em`
});
/* harmony default export */ var progress_style = (genStyleHooks('Progress', token => {
  const progressStepMarginInlineEnd = token.calc(token.marginXXS).div(2).equal();
  const progressToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    progressStepMarginInlineEnd,
    progressStepMinWidth: progressStepMarginInlineEnd,
    progressActiveMotionDuration: '2.4s'
  });
  return [progress_style_genBaseStyle(progressToken), genCircleStyle(progressToken), genStepStyle(progressToken), genSmallLine(progressToken)];
}, progress_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/progress/Line.js
"use client";

var Line_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






/**
 * @example
 *   {
 *     "0%": "#afc163",
 *     "75%": "#009900",
 *     "50%": "green", // ====> '#afc163 0%, #66FF00 25%, #00CC00 50%, #009900 75%, #ffffff 100%'
 *     "25%": "#66FF00",
 *     "100%": "#ffffff"
 *   }
 */
const sortGradient = gradients => {
  let tempArr = [];
  Object.keys(gradients).forEach(key => {
    const formattedKey = parseFloat(key.replace(/%/g, ''));
    if (!Number.isNaN(formattedKey)) {
      tempArr.push({
        key: formattedKey,
        value: gradients[key]
      });
    }
  });
  tempArr = tempArr.sort((a, b) => a.key - b.key);
  return tempArr.map(({
    key,
    value
  }) => `${value} ${key}%`).join(', ');
};
/**
 * Then this man came to realize the truth: Besides six pence, there is the moon. Besides bread and
 * butter, there is the bug. And... Besides women, there is the code.
 *
 * @example
 *   {
 *     "0%": "#afc163",
 *     "25%": "#66FF00",
 *     "50%": "#00CC00", // ====>  linear-gradient(to right, #afc163 0%, #66FF00 25%,
 *     "75%": "#009900", //        #00CC00 50%, #009900 75%, #ffffff 100%)
 *     "100%": "#ffffff"
 *   }
 */
const handleGradient = (strokeColor, directionConfig) => {
  const {
      from = colors_es/* presetPrimaryColors.blue */.ez.blue,
      to = colors_es/* presetPrimaryColors.blue */.ez.blue,
      direction = directionConfig === 'rtl' ? 'to left' : 'to right'
    } = strokeColor,
    rest = Line_rest(strokeColor, ["from", "to", "direction"]);
  if (Object.keys(rest).length !== 0) {
    const sortedGradients = sortGradient(rest);
    const background = `linear-gradient(${direction}, ${sortedGradients})`;
    return {
      background,
      [LineStrokeColorVar]: background
    };
  }
  const background = `linear-gradient(${direction}, ${from}, ${to})`;
  return {
    background,
    [LineStrokeColorVar]: background
  };
};
const Line = props => {
  const {
    prefixCls,
    direction: directionConfig,
    percent,
    size,
    strokeWidth,
    strokeColor,
    strokeLinecap = 'round',
    children,
    trailColor = null,
    percentPosition,
    success
  } = props;
  const {
    align: infoAlign,
    type: infoPosition
  } = percentPosition;
  const backgroundProps = strokeColor && typeof strokeColor !== 'string' ? handleGradient(strokeColor, directionConfig) : {
    [LineStrokeColorVar]: strokeColor,
    background: strokeColor
  };
  const borderRadius = strokeLinecap === 'square' || strokeLinecap === 'butt' ? 0 : undefined;
  const mergedSize = size !== null && size !== void 0 ? size : [-1, strokeWidth || (size === 'small' ? 6 : 8)];
  const [width, height] = getSize(mergedSize, 'line', {
    strokeWidth
  });
  if (false) {}
  const trailStyle = {
    backgroundColor: trailColor || undefined,
    borderRadius
  };
  const percentStyle = Object.assign(Object.assign({
    width: `${validProgress(percent)}%`,
    height,
    borderRadius
  }, backgroundProps), {
    [Percent]: validProgress(percent) / 100
  });
  const successPercent = getSuccessPercent(props);
  const successPercentStyle = {
    width: `${validProgress(successPercent)}%`,
    height,
    borderRadius,
    backgroundColor: success === null || success === void 0 ? void 0 : success.strokeColor
  };
  const outerStyle = {
    width: width < 0 ? '100%' : width
  };
  const lineInner = /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-inner`,
    style: trailStyle
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${prefixCls}-bg`, `${prefixCls}-bg-${infoPosition}`),
    style: percentStyle
  }, infoPosition === 'inner' && children), successPercent !== undefined && (/*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-success-bg`,
    style: successPercentStyle
  })));
  const isOuterStart = infoPosition === 'outer' && infoAlign === 'start';
  const isOuterEnd = infoPosition === 'outer' && infoAlign === 'end';
  return infoPosition === 'outer' && infoAlign === 'center' ? (/*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-layout-bottom`
  }, lineInner, children)) : (/*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-outer`,
    style: outerStyle
  }, isOuterStart && children, lineInner, isOuterEnd && children));
};
/* harmony default export */ var progress_Line = (Line);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/progress/Steps.js
"use client";




const Steps_Steps = props => {
  const {
    size,
    steps,
    rounding: customRounding = Math.round,
    percent = 0,
    strokeWidth = 8,
    strokeColor,
    trailColor = null,
    prefixCls,
    children
  } = props;
  const current = customRounding(steps * (percent / 100));
  const stepWidth = size === 'small' ? 2 : 14;
  const mergedSize = size !== null && size !== void 0 ? size : [stepWidth, strokeWidth];
  const [width, height] = getSize(mergedSize, 'step', {
    steps,
    strokeWidth
  });
  const unitWidth = width / steps;
  const styledSteps = Array.from({
    length: steps
  });
  for (let i = 0; i < steps; i++) {
    const color = Array.isArray(strokeColor) ? strokeColor[i] : strokeColor;
    styledSteps[i] = /*#__PURE__*/react.createElement("div", {
      key: i,
      className: classnames_default()(`${prefixCls}-steps-item`, {
        [`${prefixCls}-steps-item-active`]: i <= current - 1
      }),
      style: {
        backgroundColor: i <= current - 1 ? color : trailColor,
        width: unitWidth,
        height
      }
    });
  }
  return /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-steps-outer`
  }, styledSteps, children);
};
/* harmony default export */ var progress_Steps = (Steps_Steps);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/progress/progress.js
"use client";

var progress_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};















const ProgressTypes = (/* unused pure expression or super */ null && (['line', 'circle', 'dashboard']));
const ProgressStatuses = ['normal', 'exception', 'active', 'success'];
const progress_Progress = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      steps,
      strokeColor,
      percent = 0,
      size = 'default',
      showInfo = true,
      type = 'line',
      status,
      format,
      style,
      percentPosition = {}
    } = props,
    restProps = progress_rest(props, ["prefixCls", "className", "rootClassName", "steps", "strokeColor", "percent", "size", "showInfo", "type", "status", "format", "style", "percentPosition"]);
  const {
    align: infoAlign = 'end',
    type: infoPosition = 'outer'
  } = percentPosition;
  const strokeColorNotArray = Array.isArray(strokeColor) ? strokeColor[0] : strokeColor;
  const strokeColorNotGradient = typeof strokeColor === 'string' || Array.isArray(strokeColor) ? strokeColor : undefined;
  const strokeColorIsBright = react.useMemo(() => {
    if (strokeColorNotArray) {
      const color = typeof strokeColorNotArray === 'string' ? strokeColorNotArray : Object.values(strokeColorNotArray)[0];
      return new fast_color_es/* FastColor */.t(color).isLight();
    }
    return false;
  }, [strokeColor]);
  const percentNumber = react.useMemo(() => {
    var _a, _b;
    const successPercent = getSuccessPercent(props);
    return parseInt(successPercent !== undefined ? (_a = successPercent !== null && successPercent !== void 0 ? successPercent : 0) === null || _a === void 0 ? void 0 : _a.toString() : (_b = percent !== null && percent !== void 0 ? percent : 0) === null || _b === void 0 ? void 0 : _b.toString(), 10);
  }, [percent, props.success, props.successPercent]);
  const progressStatus = react.useMemo(() => {
    if (!ProgressStatuses.includes(status) && percentNumber >= 100) {
      return 'success';
    }
    return status || 'normal';
  }, [status, percentNumber]);
  const {
    getPrefixCls,
    direction,
    progress: progressStyle
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('progress', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = progress_style(prefixCls);
  const isLineType = type === 'line';
  const isPureLineType = isLineType && !steps;
  const progressInfo = react.useMemo(() => {
    if (!showInfo) {
      return null;
    }
    const successPercent = getSuccessPercent(props);
    let text;
    const textFormatter = format || (number => `${number}%`);
    const isBrightInnerColor = isLineType && strokeColorIsBright && infoPosition === 'inner';
    if (infoPosition === 'inner' || format || progressStatus !== 'exception' && progressStatus !== 'success') {
      text = textFormatter(validProgress(percent), validProgress(successPercent));
    } else if (progressStatus === 'exception') {
      text = isLineType ? /*#__PURE__*/react.createElement(CloseCircleFilled/* default */.Z, null) : /*#__PURE__*/react.createElement(CloseOutlined/* default */.Z, null);
    } else if (progressStatus === 'success') {
      text = isLineType ? /*#__PURE__*/react.createElement(CheckCircleFilled/* default */.Z, null) : /*#__PURE__*/react.createElement(CheckOutlined/* default */.Z, null);
    }
    return /*#__PURE__*/react.createElement("span", {
      className: classnames_default()(`${prefixCls}-text`, {
        [`${prefixCls}-text-bright`]: isBrightInnerColor,
        [`${prefixCls}-text-${infoAlign}`]: isPureLineType,
        [`${prefixCls}-text-${infoPosition}`]: isPureLineType
      }),
      title: typeof text === 'string' ? text : undefined
    }, text);
  }, [showInfo, percent, percentNumber, progressStatus, type, prefixCls, format]);
  if (false) {}
  let progress;
  // Render progress shape
  if (type === 'line') {
    progress = steps ? (/*#__PURE__*/react.createElement(progress_Steps, Object.assign({}, props, {
      strokeColor: strokeColorNotGradient,
      prefixCls: prefixCls,
      steps: typeof steps === 'object' ? steps.count : steps
    }), progressInfo)) : (/*#__PURE__*/react.createElement(progress_Line, Object.assign({}, props, {
      strokeColor: strokeColorNotArray,
      prefixCls: prefixCls,
      direction: direction,
      percentPosition: {
        align: infoAlign,
        type: infoPosition
      }
    }), progressInfo));
  } else if (type === 'circle' || type === 'dashboard') {
    progress = /*#__PURE__*/react.createElement(progress_Circle, Object.assign({}, props, {
      strokeColor: strokeColorNotArray,
      prefixCls: prefixCls,
      progressStatus: progressStatus
    }), progressInfo);
  }
  const classString = classnames_default()(prefixCls, `${prefixCls}-status-${progressStatus}`, {
    [`${prefixCls}-${type === 'dashboard' && 'circle' || type}`]: type !== 'line',
    [`${prefixCls}-inline-circle`]: type === 'circle' && getSize(size, 'circle')[0] <= 20,
    [`${prefixCls}-line`]: isPureLineType,
    [`${prefixCls}-line-align-${infoAlign}`]: isPureLineType,
    [`${prefixCls}-line-position-${infoPosition}`]: isPureLineType,
    [`${prefixCls}-steps`]: steps,
    [`${prefixCls}-show-info`]: showInfo,
    [`${prefixCls}-${size}`]: typeof size === 'string',
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, progressStyle === null || progressStyle === void 0 ? void 0 : progressStyle.className, className, rootClassName, hashId, cssVarCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", Object.assign({
    ref: ref,
    style: Object.assign(Object.assign({}, progressStyle === null || progressStyle === void 0 ? void 0 : progressStyle.style), style),
    className: classString,
    role: "progressbar",
    "aria-valuenow": percentNumber,
    "aria-valuemin": 0,
    "aria-valuemax": 100
  }, (0,omit/* default */.Z)(restProps, ['trailColor', 'strokeWidth', 'width', 'gapDegree', 'gapPosition', 'strokeLinecap', 'success', 'successPercent'])), progress));
});
if (false) {}
/* harmony default export */ var progress = (progress_Progress);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/progress/index.js
"use client";


/* harmony default export */ var es_progress = (progress);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(3422);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js

function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = (0,unsupportedIterableToArray/* default */.Z)(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}

;// CONCATENATED MODULE: ./node_modules/@rc-component/qrcode/es/libs/qrcodegen.js




var _class, _class2;
// Copyright (c) Project Nayuki. (MIT License)
// https://www.nayuki.io/page/qr-code-generator-library

// Modification with code reorder and prettier

// --------------------------------------------

// Appends the given number of low-order bits of the given value
// to the given buffer. Requires 0 <= len <= 31 and 0 <= val < 2^len.
function appendBits(val, len, bb) {
  if (len < 0 || len > 31 || val >>> len != 0) throw new RangeError('Value out of range');
  for (var i = len - 1; i >= 0; i-- // Append bit by bit
  ) bb.push(val >>> i & 1);
}

// Returns true iff the i'th bit of x is set to 1.
function getBit(x, i) {
  return (x >>> i & 1) != 0;
}

// Throws an exception if the given condition is false.
function assert(cond) {
  if (!cond) throw new Error('Assertion error');
}

/*---- Public helper enumeration ----*/
/*
 * Describes how a segment's data bits are numbererpreted. Immutable.
 */
var Mode = /*#__PURE__*/function () {
  function Mode(modeBits, numBitsCharCount) {
    (0,classCallCheck/* default */.Z)(this, Mode);
    /*-- Constructor and fields --*/
    // The mode indicator bits, which is a unumber4 value (range 0 to 15).
    (0,defineProperty/* default */.Z)(this, "modeBits", void 0);
    // Number of character count bits for three different version ranges.
    (0,defineProperty/* default */.Z)(this, "numBitsCharCount", void 0);
    this.modeBits = modeBits;
    this.numBitsCharCount = numBitsCharCount;
  }

  /*-- Method --*/

  // (Package-private) Returns the bit width of the character count field for a segment in
  // this mode in a QR Code at the given version number. The result is in the range [0, 16].
  (0,createClass/* default */.Z)(Mode, [{
    key: "numCharCountBits",
    value: function numCharCountBits(ver) {
      return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
    }
  }]);
  return Mode;
}();

/*---- Public helper enumeration ----*/

/*
 * The error correction level in a QR Code symbol. Immutable.
 */
_class = Mode;
/*-- Constants --*/
(0,defineProperty/* default */.Z)(Mode, "NUMERIC", new _class(0x1, [10, 12, 14]));
(0,defineProperty/* default */.Z)(Mode, "ALPHANUMERIC", new _class(0x2, [9, 11, 13]));
(0,defineProperty/* default */.Z)(Mode, "BYTE", new _class(0x4, [8, 16, 16]));
(0,defineProperty/* default */.Z)(Mode, "KANJI", new _class(0x8, [8, 10, 12]));
(0,defineProperty/* default */.Z)(Mode, "ECI", new _class(0x7, [0, 0, 0]));
var Ecc = /*#__PURE__*/(0,createClass/* default */.Z)(function Ecc(ordinal, formatBits) {
  (0,classCallCheck/* default */.Z)(this, Ecc);
  // The QR Code can tolerate about 30% erroneous codewords
  /*-- Constructor and fields --*/
  // In the range 0 to 3 (unsigned 2-bit numbereger).
  (0,defineProperty/* default */.Z)(this, "ordinal", void 0);
  // (Package-private) In the range 0 to 3 (unsigned 2-bit numbereger).
  (0,defineProperty/* default */.Z)(this, "formatBits", void 0);
  this.ordinal = ordinal;
  this.formatBits = formatBits;
});

/*
 * A segment of character/binary/control data in a QR Code symbol.
 * Instances of this class are immutable.
 * The mid-level way to create a segment is to take the payload data
 * and call a static factory function such as QrSegment.makeNumeric().
 * The low-level way to create a segment is to custom-make the bit buffer
 * and call the QrSegment() constructor with appropriate values.
 * This segment class imposes no length restrictions, but QR Codes have restrictions.
 * Even in the most favorable conditions, a QR Code can only hold 7089 characters of data.
 * Any segment longer than this is meaningless for the purpose of generating QR Codes.
 */
_class2 = Ecc;
/*-- Constants --*/
(0,defineProperty/* default */.Z)(Ecc, "LOW", new _class2(0, 1));
// The QR Code can tolerate about  7% erroneous codewords
(0,defineProperty/* default */.Z)(Ecc, "MEDIUM", new _class2(1, 0));
// The QR Code can tolerate about 15% erroneous codewords
(0,defineProperty/* default */.Z)(Ecc, "QUARTILE", new _class2(2, 3));
// The QR Code can tolerate about 25% erroneous codewords
(0,defineProperty/* default */.Z)(Ecc, "HIGH", new _class2(3, 2));
var QrSegment = /*#__PURE__*/function () {
  // Creates a new QR Code segment with the given attributes and data.
  // The character count (numChars) must agree with the mode and the bit buffer length,
  // but the constranumber isn't checked. The given bit buffer is cloned and stored.
  function QrSegment(mode, numChars, bitData) {
    (0,classCallCheck/* default */.Z)(this, QrSegment);
    /*-- Constructor (low level) and fields --*/
    // The mode indicator of this segment.
    (0,defineProperty/* default */.Z)(this, "mode", void 0);
    // The length of this segment's unencoded data. Measured in characters for
    // numeric/alphanumeric/kanji mode, bytes for byte mode, and 0 for ECI mode.
    // Always zero or positive. Not the same as the data's bit length.
    (0,defineProperty/* default */.Z)(this, "numChars", void 0);
    // The data bits of this segment. Accessed through getData().
    (0,defineProperty/* default */.Z)(this, "bitData", void 0);
    this.mode = mode;
    this.numChars = numChars;
    this.bitData = bitData;
    if (numChars < 0) throw new RangeError('Invalid argument');
    this.bitData = bitData.slice(); // Make defensive copy
  }

  /*-- Methods --*/

  // Returns a new copy of the data bits of this segment.
  (0,createClass/* default */.Z)(QrSegment, [{
    key: "getData",
    value: function getData() {
      return this.bitData.slice(); // Make defensive copy
    }

    // (Package-private) Calculates and returns the number of bits needed to encode the given segments at
    // the given version. The result is infinity if a segment has too many characters to fit its length field.
  }], [{
    key: "makeBytes",
    value: /*-- Static factory functions (mid level) --*/

    // Returns a segment representing the given binary data encoded in
    // byte mode. All input byte arrays are acceptable. Any text string
    // can be converted to UTF-8 bytes and encoded as a byte mode segment.
    function makeBytes(data) {
      var bb = [];
      var _iterator = _createForOfIteratorHelper(data),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var b = _step.value;
          appendBits(b, 8, bb);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return new QrSegment(Mode.BYTE, data.length, bb);
    }

    // Returns a segment representing the given string of decimal digits encoded in numeric mode.
  }, {
    key: "makeNumeric",
    value: function makeNumeric(digits) {
      if (!QrSegment.isNumeric(digits)) throw new RangeError('String contains non-numeric characters');
      var bb = [];
      for (var i = 0; i < digits.length;) {
        // Consume up to 3 digits per iteration
        var n = Math.min(digits.length - i, 3);
        appendBits(parseInt(digits.substring(i, i + n), 10), n * 3 + 1, bb);
        i += n;
      }
      return new QrSegment(Mode.NUMERIC, digits.length, bb);
    }

    // Returns a segment representing the given text string encoded in alphanumeric mode.
    // The characters allowed are: 0 to 9, A to Z (uppercase only), space,
    // dollar, percent, asterisk, plus, hyphen, period, slash, colon.
  }, {
    key: "makeAlphanumeric",
    value: function makeAlphanumeric(text) {
      if (!QrSegment.isAlphanumeric(text)) throw new RangeError('String contains unencodable characters in alphanumeric mode');
      var bb = [];
      var i;
      for (i = 0; i + 2 <= text.length; i += 2) {
        // Process groups of 2
        var temp = QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
        temp += QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
        appendBits(temp, 11, bb);
      }
      if (i < text.length)
        // 1 character remaining
        appendBits(QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
      return new QrSegment(Mode.ALPHANUMERIC, text.length, bb);
    }

    // Returns a new mutable list of zero or more segments to represent the given Unicode text string.
    // The result may use various segment modes and switch modes to optimize the length of the bit stream.
  }, {
    key: "makeSegments",
    value: function makeSegments(text) {
      // Select the most efficient segment encoding automatically
      if (text == '') return [];else if (QrSegment.isNumeric(text)) return [QrSegment.makeNumeric(text)];else if (QrSegment.isAlphanumeric(text)) return [QrSegment.makeAlphanumeric(text)];else return [QrSegment.makeBytes(QrSegment.toUtf8ByteArray(text))];
    }

    // Returns a segment representing an Extended Channel Interpretation
    // (ECI) designator with the given assignment value.
  }, {
    key: "makeEci",
    value: function makeEci(assignVal) {
      var bb = [];
      if (assignVal < 0) throw new RangeError('ECI assignment value out of range');else if (assignVal < 1 << 7) appendBits(assignVal, 8, bb);else if (assignVal < 1 << 14) {
        appendBits(2, 2, bb);
        appendBits(assignVal, 14, bb);
      } else if (assignVal < 1000000) {
        appendBits(6, 3, bb);
        appendBits(assignVal, 21, bb);
      } else throw new RangeError('ECI assignment value out of range');
      return new QrSegment(Mode.ECI, 0, bb);
    }

    // Tests whether the given string can be encoded as a segment in numeric mode.
    // A string is encodable iff each character is in the range 0 to 9.
  }, {
    key: "isNumeric",
    value: function isNumeric(text) {
      return QrSegment.NUMERIC_REGEX.test(text);
    }

    // Tests whether the given string can be encoded as a segment in alphanumeric mode.
    // A string is encodable iff each character is in the following set: 0 to 9, A to Z
    // (uppercase only), space, dollar, percent, asterisk, plus, hyphen, period, slash, colon.
  }, {
    key: "isAlphanumeric",
    value: function isAlphanumeric(text) {
      return QrSegment.ALPHANUMERIC_REGEX.test(text);
    }
  }, {
    key: "getTotalBits",
    value: function getTotalBits(segs, version) {
      var result = 0;
      var _iterator2 = _createForOfIteratorHelper(segs),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var seg = _step2.value;
          var ccbits = seg.mode.numCharCountBits(version);
          if (seg.numChars >= 1 << ccbits) return Infinity; // The segment's length doesn't fit the field's bit width
          result += 4 + ccbits + seg.bitData.length;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return result;
    }

    // Returns a new array of bytes representing the given string encoded in UTF-8.
  }, {
    key: "toUtf8ByteArray",
    value: function toUtf8ByteArray(input) {
      var str = encodeURI(input);
      var result = [];
      for (var i = 0; i < str.length; i++) {
        if (str.charAt(i) != '%') result.push(str.charCodeAt(i));else {
          result.push(parseInt(str.substring(i + 1, i + 3), 16));
          i += 2;
        }
      }
      return result;
    }

    /*-- Constants --*/

    // Describes precisely all strings that are encodable in numeric mode.
  }]);
  return QrSegment;
}();

/*
 * A QR Code symbol, which is a type of two-dimension barcode.
 * Invented by Denso Wave and described in the ISO/IEC 18004 standard.
 * Instances of this class represent an immutable square grid of dark and light cells.
 * The class provides static factory functions to create a QR Code from text or binary data.
 * The class covers the QR Code Model 2 specification, supporting all versions (sizes)
 * from 1 to 40, all 4 error correction levels, and 4 character encoding modes.
 *
 * Ways to create a QR Code object:
 * - High level: Take the payload data and call QrCode.encodeText() or QrCode.encodeBinary().
 * - Mid level: Custom-make the list of segments and call QrCode.encodeSegments().
 * - Low level: Custom-make the array of data codeword bytes (including
 *   segment headers and final padding, excluding error correction codewords),
 *   supply the appropriate version number, and call the QrCode() constructor.
 * (Note that all ways require supplying the desired error correction level.)
 */
(0,defineProperty/* default */.Z)(QrSegment, "NUMERIC_REGEX", /^[0-9]*$/);
// Describes precisely all strings that are encodable in alphanumeric mode.
(0,defineProperty/* default */.Z)(QrSegment, "ALPHANUMERIC_REGEX", /^[A-Z0-9 $%*+.\/:-]*$/);
// The set of all legal characters in alphanumeric mode,
// where each character value maps to the index in the string.
(0,defineProperty/* default */.Z)(QrSegment, "ALPHANUMERIC_CHARSET", '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:');
var QrCode = /*#__PURE__*/function () {
  // Creates a new QR Code with the given version number,
  // error correction level, data codeword bytes, and mask number.
  // This is a low-level API that most users should not use directly.
  // A mid-level API is the encodeSegments() function.
  function QrCode(
  // The version number of this QR Code, which is between 1 and 40 (inclusive).
  // This determines the size of this barcode.
  version,
  // The error correction level used in this QR Code.
  errorCorrectionLevel, dataCodewords, oriMsk) {
    (0,classCallCheck/* default */.Z)(this, QrCode);
    /*-- Fields --*/
    // The width and height of this QR Code, measured in modules, between
    // 21 and 177 (inclusive). This is equal to version * 4 + 17.
    (0,defineProperty/* default */.Z)(this, "size", void 0);
    // The index of the mask pattern used in this QR Code, which is between 0 and 7 (inclusive).
    // Even if a QR Code is created with automatic masking requested (mask = -1),
    // the resulting object still has a mask value between 0 and 7.
    (0,defineProperty/* default */.Z)(this, "mask", void 0);
    // The modules of this QR Code (false = light, true = dark).
    // Immutable after constructor finishes. Accessed through getModule().
    (0,defineProperty/* default */.Z)(this, "modules", []);
    // Indicates function modules that are not subjected to masking. Discarded when constructor finishes.
    (0,defineProperty/* default */.Z)(this, "isFunction", []);
    /*-- Constructor (low level) and fields --*/
    // The version number of this QR Code, which is between 1 and 40 (inclusive).
    // This determines the size of this barcode.
    (0,defineProperty/* default */.Z)(this, "version", void 0);
    // The error correction level used in this QR Code.
    (0,defineProperty/* default */.Z)(this, "errorCorrectionLevel", void 0);
    var msk = oriMsk;
    this.version = version;
    this.errorCorrectionLevel = errorCorrectionLevel;
    // Check scalar arguments
    if (version < QrCode.MIN_VERSION || version > QrCode.MAX_VERSION) throw new RangeError('Version value out of range');
    if (msk < -1 || msk > 7) throw new RangeError('Mask value out of range');
    this.size = version * 4 + 17;

    // Initialize both grids to be size*size arrays of Boolean false
    var row = [];
    for (var i = 0; i < this.size; i++) row.push(false);
    for (var _i = 0; _i < this.size; _i++) {
      this.modules.push(row.slice()); // Initially all light
      this.isFunction.push(row.slice());
    }

    // Compute ECC, draw modules
    this.drawFunctionPatterns();
    var allCodewords = this.addEccAndInterleave(dataCodewords);
    this.drawCodewords(allCodewords);

    // Do masking
    if (msk == -1) {
      // Automatically choose best mask
      var minPenalty = 1000000000;
      for (var _i2 = 0; _i2 < 8; _i2++) {
        this.applyMask(_i2);
        this.drawFormatBits(_i2);
        var penalty = this.getPenaltyScore();
        if (penalty < minPenalty) {
          msk = _i2;
          minPenalty = penalty;
        }
        this.applyMask(_i2); // Undoes the mask due to XOR
      }
    }
    assert(0 <= msk && msk <= 7);
    this.mask = msk;
    this.applyMask(msk); // Apply the final choice of mask
    this.drawFormatBits(msk); // Overwrite old format bits

    this.isFunction = [];
  }

  /*-- Accessor methods --*/

  // Returns the color of the module (pixel) at the given coordinates, which is false
  // for light or true for dark. The top left corner has the coordinates (x=0, y=0).
  // If the given coordinates are out of bounds, then false (light) is returned.
  (0,createClass/* default */.Z)(QrCode, [{
    key: "getModule",
    value: function getModule(x, y) {
      return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
    }

    // Modified to expose modules for easy access
  }, {
    key: "getModules",
    value: function getModules() {
      return this.modules;
    }

    /*-- Private helper methods for constructor: Drawing function modules --*/

    // Reads this object's version field, and draws and marks all function modules.
  }, {
    key: "drawFunctionPatterns",
    value: function drawFunctionPatterns() {
      // Draw horizontal and vertical timing patterns
      for (var i = 0; i < this.size; i++) {
        this.setFunctionModule(6, i, i % 2 == 0);
        this.setFunctionModule(i, 6, i % 2 == 0);
      }

      // Draw 3 finder patterns (all corners except bottom right; overwrites some timing modules)
      this.drawFinderPattern(3, 3);
      this.drawFinderPattern(this.size - 4, 3);
      this.drawFinderPattern(3, this.size - 4);

      // Draw numerous alignment patterns
      var alignPatPos = this.getAlignmentPatternPositions();
      var numAlign = alignPatPos.length;
      for (var _i3 = 0; _i3 < numAlign; _i3++) {
        for (var j = 0; j < numAlign; j++) {
          // Don't draw on the three finder corners
          if (!(_i3 == 0 && j == 0 || _i3 == 0 && j == numAlign - 1 || _i3 == numAlign - 1 && j == 0)) this.drawAlignmentPattern(alignPatPos[_i3], alignPatPos[j]);
        }
      }

      // Draw configuration data
      this.drawFormatBits(0); // Dummy mask value; overwritten later in the constructor
      this.drawVersion();
    }

    // Draws two copies of the format bits (with its own error correction code)
    // based on the given mask and this object's error correction level field.
  }, {
    key: "drawFormatBits",
    value: function drawFormatBits(mask) {
      // Calculate error correction code and pack bits
      var data = this.errorCorrectionLevel.formatBits << 3 | mask; // errCorrLvl is unumber2, mask is unumber3
      var rem = data;
      for (var i = 0; i < 10; i++) rem = rem << 1 ^ (rem >>> 9) * 0x537;
      var bits = (data << 10 | rem) ^ 0x5412; // unumber15
      assert(bits >>> 15 == 0);

      // Draw first copy
      for (var _i4 = 0; _i4 <= 5; _i4++) this.setFunctionModule(8, _i4, getBit(bits, _i4));
      this.setFunctionModule(8, 7, getBit(bits, 6));
      this.setFunctionModule(8, 8, getBit(bits, 7));
      this.setFunctionModule(7, 8, getBit(bits, 8));
      for (var _i5 = 9; _i5 < 15; _i5++) this.setFunctionModule(14 - _i5, 8, getBit(bits, _i5));

      // Draw second copy
      for (var _i6 = 0; _i6 < 8; _i6++) this.setFunctionModule(this.size - 1 - _i6, 8, getBit(bits, _i6));
      for (var _i7 = 8; _i7 < 15; _i7++) this.setFunctionModule(8, this.size - 15 + _i7, getBit(bits, _i7));
      this.setFunctionModule(8, this.size - 8, true); // Always dark
    }

    // Draws two copies of the version bits (with its own error correction code),
    // based on this object's version field, iff 7 <= version <= 40.
  }, {
    key: "drawVersion",
    value: function drawVersion() {
      if (this.version < 7) return;

      // Calculate error correction code and pack bits
      var rem = this.version; // version is unumber6, in the range [7, 40]
      for (var i = 0; i < 12; i++) rem = rem << 1 ^ (rem >>> 11) * 0x1f25;
      var bits = this.version << 12 | rem; // unumber18
      assert(bits >>> 18 == 0);

      // Draw two copies
      for (var _i8 = 0; _i8 < 18; _i8++) {
        var color = getBit(bits, _i8);
        var a = this.size - 11 + _i8 % 3;
        var b = Math.floor(_i8 / 3);
        this.setFunctionModule(a, b, color);
        this.setFunctionModule(b, a, color);
      }
    }

    // Draws a 9*9 finder pattern including the border separator,
    // with the center module at (x, y). Modules can be out of bounds.
  }, {
    key: "drawFinderPattern",
    value: function drawFinderPattern(x, y) {
      for (var dy = -4; dy <= 4; dy++) {
        for (var dx = -4; dx <= 4; dx++) {
          var dist = Math.max(Math.abs(dx), Math.abs(dy)); // Chebyshev/infinity norm
          var xx = x + dx;
          var yy = y + dy;
          if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size) this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
        }
      }
    }

    // Draws a 5*5 alignment pattern, with the center module
    // at (x, y). All modules must be in bounds.
  }, {
    key: "drawAlignmentPattern",
    value: function drawAlignmentPattern(x, y) {
      for (var dy = -2; dy <= 2; dy++) {
        for (var dx = -2; dx <= 2; dx++) this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
      }
    }

    // Sets the color of a module and marks it as a function module.
    // Only used by the constructor. Coordinates must be in bounds.
  }, {
    key: "setFunctionModule",
    value: function setFunctionModule(x, y, isDark) {
      this.modules[y][x] = isDark;
      this.isFunction[y][x] = true;
    }

    /*-- Private helper methods for constructor: Codewords and masking --*/

    // Returns a new byte string representing the given data with the appropriate error correction
    // codewords appended to it, based on this object's version and error correction level.
  }, {
    key: "addEccAndInterleave",
    value: function addEccAndInterleave(data) {
      var ver = this.version;
      var ecl = this.errorCorrectionLevel;
      if (data.length != QrCode.getNumDataCodewords(ver, ecl)) throw new RangeError('Invalid argument');

      // Calculate parameter numbers
      var numBlocks = QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
      var blockEccLen = QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
      var rawCodewords = Math.floor(QrCode.getNumRawDataModules(ver) / 8);
      var numShortBlocks = numBlocks - rawCodewords % numBlocks;
      var shortBlockLen = Math.floor(rawCodewords / numBlocks);

      // Split data numbero blocks and append ECC to each block
      var blocks = [];
      var rsDiv = QrCode.reedSolomonComputeDivisor(blockEccLen);
      for (var i = 0, k = 0; i < numBlocks; i++) {
        var dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
        k += dat.length;
        var ecc = QrCode.reedSolomonComputeRemainder(dat, rsDiv);
        if (i < numShortBlocks) dat.push(0);
        blocks.push(dat.concat(ecc));
      }

      // Interleave (not concatenate) the bytes from every block numbero a single sequence
      var result = [];
      var _loop = function _loop(_i9) {
        blocks.forEach(function (block, j) {
          // Skip the padding byte in short blocks
          if (_i9 != shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[_i9]);
        });
      };
      for (var _i9 = 0; _i9 < blocks[0].length; _i9++) {
        _loop(_i9);
      }
      assert(result.length == rawCodewords);
      return result;
    }

    // Draws the given sequence of 8-bit codewords (data and error correction) onto the entire
    // data area of this QR Code. Function modules need to be marked off before this is called.
  }, {
    key: "drawCodewords",
    value: function drawCodewords(data) {
      if (data.length != Math.floor(QrCode.getNumRawDataModules(this.version) / 8)) throw new RangeError('Invalid argument');
      var i = 0; // Bit index numbero the data
      // Do the funny zigzag scan
      for (var right = this.size - 1; right >= 1; right -= 2) {
        // Index of right column in each column pair
        if (right == 6) right = 5;
        for (var vert = 0; vert < this.size; vert++) {
          // Vertical counter
          for (var j = 0; j < 2; j++) {
            var x = right - j; // Actual x coordinate
            var upward = (right + 1 & 2) == 0;
            var y = upward ? this.size - 1 - vert : vert; // Actual y coordinate
            if (!this.isFunction[y][x] && i < data.length * 8) {
              this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
              i++;
            }
            // If this QR Code has any remainder bits (0 to 7), they were assigned as
            // 0/false/light by the constructor and are left unchanged by this method
          }
        }
      }
      assert(i == data.length * 8);
    }

    // XORs the codeword modules in this QR Code with the given mask pattern.
    // The function modules must be marked and the codeword bits must be drawn
    // before masking. Due to the arithmetic of XOR, calling applyMask() with
    // the same mask value a second time will undo the mask. A final well-formed
    // QR Code needs exactly one (not zero, two, etc.) mask applied.
  }, {
    key: "applyMask",
    value: function applyMask(mask) {
      if (mask < 0 || mask > 7) throw new RangeError('Mask value out of range');
      for (var y = 0; y < this.size; y++) {
        for (var x = 0; x < this.size; x++) {
          var invert = void 0;
          switch (mask) {
            case 0:
              invert = (x + y) % 2 == 0;
              break;
            case 1:
              invert = y % 2 == 0;
              break;
            case 2:
              invert = x % 3 == 0;
              break;
            case 3:
              invert = (x + y) % 3 == 0;
              break;
            case 4:
              invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
              break;
            case 5:
              invert = x * y % 2 + x * y % 3 == 0;
              break;
            case 6:
              invert = (x * y % 2 + x * y % 3) % 2 == 0;
              break;
            case 7:
              invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
              break;
            default:
              throw new Error('Unreachable');
          }
          if (!this.isFunction[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
        }
      }
    }

    // Calculates and returns the penalty score based on state of this QR Code's current modules.
    // This is used by the automatic mask choice algorithm to find the mask pattern that yields the lowest score.
  }, {
    key: "getPenaltyScore",
    value: function getPenaltyScore() {
      var result = 0;

      // Adjacent modules in row having same color, and finder-like patterns
      for (var y = 0; y < this.size; y++) {
        var runColor = false;
        var runX = 0;
        var runHistory = [0, 0, 0, 0, 0, 0, 0];
        for (var x = 0; x < this.size; x++) {
          if (this.modules[y][x] == runColor) {
            runX++;
            if (runX == 5) result += QrCode.PENALTY_N1;else if (runX > 5) result++;
          } else {
            this.finderPenaltyAddHistory(runX, runHistory);
            if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * QrCode.PENALTY_N3;
            runColor = this.modules[y][x];
            runX = 1;
          }
        }
        result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * QrCode.PENALTY_N3;
      }
      // Adjacent modules in column having same color, and finder-like patterns
      for (var _x = 0; _x < this.size; _x++) {
        var _runColor = false;
        var runY = 0;
        var _runHistory = [0, 0, 0, 0, 0, 0, 0];
        for (var _y = 0; _y < this.size; _y++) {
          if (this.modules[_y][_x] == _runColor) {
            runY++;
            if (runY == 5) result += QrCode.PENALTY_N1;else if (runY > 5) result++;
          } else {
            this.finderPenaltyAddHistory(runY, _runHistory);
            if (!_runColor) result += this.finderPenaltyCountPatterns(_runHistory) * QrCode.PENALTY_N3;
            _runColor = this.modules[_y][_x];
            runY = 1;
          }
        }
        result += this.finderPenaltyTerminateAndCount(_runColor, runY, _runHistory) * QrCode.PENALTY_N3;
      }

      // 2*2 blocks of modules having same color
      for (var _y2 = 0; _y2 < this.size - 1; _y2++) {
        for (var _x2 = 0; _x2 < this.size - 1; _x2++) {
          var color = this.modules[_y2][_x2];
          if (color == this.modules[_y2][_x2 + 1] && color == this.modules[_y2 + 1][_x2] && color == this.modules[_y2 + 1][_x2 + 1]) result += QrCode.PENALTY_N2;
        }
      }

      // Balance of dark and light modules
      var dark = 0;
      var _iterator3 = _createForOfIteratorHelper(this.modules),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var row = _step3.value;
          dark = row.reduce(function (sum, color) {
            return sum + (color ? 1 : 0);
          }, dark);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      var total = this.size * this.size; // Note that size is odd, so dark/total != 1/2
      // Compute the smallest numbereger k >= 0 such that (45-5k)% <= dark/total <= (55+5k)%
      var k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
      assert(0 <= k && k <= 9);
      result += k * QrCode.PENALTY_N4;
      assert(0 <= result && result <= 2568888); // Non-tight upper bound based on default values of PENALTY_N1, ..., N4
      return result;
    }

    /*-- Private helper functions --*/

    // Returns an ascending list of positions of alignment patterns for this version number.
    // Each position is in the range [0,177), and are used on both the x and y axes.
    // This could be implemented as lookup table of 40 variable-length lists of numberegers.
  }, {
    key: "getAlignmentPatternPositions",
    value: function getAlignmentPatternPositions() {
      if (this.version == 1) return [];else {
        var numAlign = Math.floor(this.version / 7) + 2;
        var step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
        var result = [6];
        for (var pos = this.size - 7; result.length < numAlign; pos -= step) result.splice(1, 0, pos);
        return result;
      }
    }

    // Returns the number of data bits that can be stored in a QR Code of the given version number, after
    // all function modules are excluded. This includes remainder bits, so it might not be a multiple of 8.
    // The result is in the range [208, 29648]. This could be implemented as a 40-entry lookup table.
  }, {
    key: "finderPenaltyCountPatterns",
    value:
    // Can only be called immediately after a light run is added, and
    // returns either 0, 1, or 2. A helper function for getPenaltyScore().
    function finderPenaltyCountPatterns(runHistory) {
      var n = runHistory[1];
      assert(n <= this.size * 3);
      var core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
      return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
    }

    // Must be called at the end of a line (row or column) of modules. A helper function for getPenaltyScore().
  }, {
    key: "finderPenaltyTerminateAndCount",
    value: function finderPenaltyTerminateAndCount(currentRunColor, oriCurrentRunLength, runHistory) {
      var currentRunLength = oriCurrentRunLength;
      if (currentRunColor) {
        // Terminate dark run
        this.finderPenaltyAddHistory(currentRunLength, runHistory);
        currentRunLength = 0;
      }
      currentRunLength += this.size; // Add light border to final run
      this.finderPenaltyAddHistory(currentRunLength, runHistory);
      return this.finderPenaltyCountPatterns(runHistory);
    }

    // Pushes the given value to the front and drops the last value. A helper function for getPenaltyScore().
  }, {
    key: "finderPenaltyAddHistory",
    value: function finderPenaltyAddHistory(oriCurrentRunLength, runHistory) {
      var currentRunLength = oriCurrentRunLength;
      if (runHistory[0] == 0) currentRunLength += this.size; // Add light border to initial run
      runHistory.pop();
      runHistory.unshift(currentRunLength);
    }

    /*-- Constants and tables --*/

    // The minimum version number supported in the QR Code Model 2 standard.
  }], [{
    key: "encodeText",
    value: /*-- Static factory functions (high level) --*/

    // Returns a QR Code representing the given Unicode text string at the given error correction level.
    // As a conservative upper bound, this function is guaranteed to succeed for strings that have 738 or fewer
    // Unicode code ponumbers (not UTF-16 code units) if the low error correction level is used. The smallest possible
    // QR Code version is automatically chosen for the output. The ECC level of the result may be higher than the
    // ecl argument if it can be done without increasing the version.
    function encodeText(text, ecl) {
      var segs = QrSegment.makeSegments(text);
      return QrCode.encodeSegments(segs, ecl);
    }

    // Returns a QR Code representing the given binary data at the given error correction level.
    // This function always encodes using the binary segment mode, not any text mode. The maximum number of
    // bytes allowed is 2953. The smallest possible QR Code version is automatically chosen for the output.
    // The ECC level of the result may be higher than the ecl argument if it can be done without increasing the version.
  }, {
    key: "encodeBinary",
    value: function encodeBinary(data, ecl) {
      var seg = QrSegment.makeBytes(data);
      return QrCode.encodeSegments([seg], ecl);
    }

    /*-- Static factory functions (mid level) --*/

    // Returns a QR Code representing the given segments with the given encoding parameters.
    // The smallest possible QR Code version within the given range is automatically
    // chosen for the output. Iff boostEcl is true, then the ECC level of the result
    // may be higher than the ecl argument if it can be done without increasing the
    // version. The mask number is either between 0 to 7 (inclusive) to force that
    // mask, or -1 to automatically choose an appropriate mask (which may be slow).
    // This function allows the user to create a custom sequence of segments that switches
    // between modes (such as alphanumeric and byte) to encode text in less space.
    // This is a mid-level API; the high-level API is encodeText() and encodeBinary().
  }, {
    key: "encodeSegments",
    value: function encodeSegments(segs, oriEcl) {
      var minVersion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var maxVersion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 40;
      var mask = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : -1;
      var boostEcl = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
      if (!(QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= QrCode.MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError('Invalid value');

      // Find the minimal version number to use
      var version;
      var dataUsedBits;
      for (version = minVersion;; version++) {
        var _dataCapacityBits = QrCode.getNumDataCodewords(version, oriEcl) * 8; // Number of data bits available
        var usedBits = QrSegment.getTotalBits(segs, version);
        if (usedBits <= _dataCapacityBits) {
          dataUsedBits = usedBits;
          break; // This version number is found to be suitable
        }
        if (version >= maxVersion)
          // All versions in the range could not fit the given data
          throw new RangeError('Data too long');
      }
      var ecl = oriEcl;
      // Increase the error correction level while the data still fits in the current version number
      for (var _i10 = 0, _arr = [Ecc.MEDIUM, Ecc.QUARTILE, Ecc.HIGH]; _i10 < _arr.length; _i10++) {
        var newEcl = _arr[_i10];
        // From low to high
        if (boostEcl && dataUsedBits <= QrCode.getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
      }

      // Concatenate all segments to create the data bit string
      var bb = [];
      var _iterator4 = _createForOfIteratorHelper(segs),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var seg = _step4.value;
          appendBits(seg.mode.modeBits, 4, bb);
          appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
          var _iterator5 = _createForOfIteratorHelper(seg.getData()),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var b = _step5.value;
              bb.push(b);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      assert(bb.length == dataUsedBits);

      // Add terminator and pad up to a byte if applicable
      var dataCapacityBits = QrCode.getNumDataCodewords(version, ecl) * 8;
      assert(bb.length <= dataCapacityBits);
      appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
      appendBits(0, (8 - bb.length % 8) % 8, bb);
      assert(bb.length % 8 == 0);

      // Pad with alternating bytes until data capacity is reached
      for (var padByte = 0xec; bb.length < dataCapacityBits; padByte ^= 0xec ^ 0x11) appendBits(padByte, 8, bb);

      // Pack bits numbero bytes in big endian
      var dataCodewords = [];
      while (dataCodewords.length * 8 < bb.length) dataCodewords.push(0);
      bb.forEach(function (b, i) {
        return dataCodewords[i >>> 3] |= b << 7 - (i & 7);
      });

      // Create the QR Code object
      return new QrCode(version, ecl, dataCodewords, mask);
    }
  }, {
    key: "getNumRawDataModules",
    value: function getNumRawDataModules(ver) {
      if (ver < QrCode.MIN_VERSION || ver > QrCode.MAX_VERSION) throw new RangeError('Version number out of range');
      var result = (16 * ver + 128) * ver + 64;
      if (ver >= 2) {
        var numAlign = Math.floor(ver / 7) + 2;
        result -= (25 * numAlign - 10) * numAlign - 55;
        if (ver >= 7) result -= 36;
      }
      assert(208 <= result && result <= 29648);
      return result;
    }

    // Returns the number of 8-bit data (i.e. not error correction) codewords contained in any
    // QR Code of the given version number and error correction level, with remainder bits discarded.
    // This stateless pure function could be implemented as a (40*4)-cell lookup table.
  }, {
    key: "getNumDataCodewords",
    value: function getNumDataCodewords(ver, ecl) {
      return Math.floor(QrCode.getNumRawDataModules(ver) / 8) - QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
    }

    // Returns a Reed-Solomon ECC generator polynomial for the given degree. This could be
    // implemented as a lookup table over all possible parameter values, instead of as an algorithm.
  }, {
    key: "reedSolomonComputeDivisor",
    value: function reedSolomonComputeDivisor(degree) {
      if (degree < 1 || degree > 255) throw new RangeError('Degree out of range');
      // Polynomial coefficients are stored from highest to lowest power, excluding the leading term which is always 1.
      // For example the polynomial x^3 + 255x^2 + 8x + 93 is stored as the unumber8 array [255, 8, 93].
      var result = [];
      for (var i = 0; i < degree - 1; i++) result.push(0);
      result.push(1); // Start off with the monomial x^0

      // Compute the product polynomial (x - r^0) * (x - r^1) * (x - r^2) * ... * (x - r^{degree-1}),
      // and drop the highest monomial term which is always 1x^degree.
      // Note that r = 0x02, which is a generator element of this field GF(2^8/0x11D).
      var root = 1;
      for (var _i11 = 0; _i11 < degree; _i11++) {
        // Multiply the current product by (x - r^i)
        for (var j = 0; j < result.length; j++) {
          result[j] = QrCode.reedSolomonMultiply(result[j], root);
          if (j + 1 < result.length) result[j] ^= result[j + 1];
        }
        root = QrCode.reedSolomonMultiply(root, 0x02);
      }
      return result;
    }

    // Returns the Reed-Solomon error correction codeword for the given data and divisor polynomials.
  }, {
    key: "reedSolomonComputeRemainder",
    value: function reedSolomonComputeRemainder(data, divisor) {
      var result = divisor.map(function () {
        return 0;
      });
      var _iterator6 = _createForOfIteratorHelper(data),
        _step6;
      try {
        var _loop2 = function _loop2() {
          var b = _step6.value;
          // Polynomial division
          var factor = b ^ result.shift();
          result.push(0);
          divisor.forEach(function (coef, i) {
            return result[i] ^= QrCode.reedSolomonMultiply(coef, factor);
          });
        };
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return result;
    }

    // Returns the product of the two given field elements modulo GF(2^8/0x11D). The arguments and result
    // are unsigned 8-bit numberegers. This could be implemented as a lookup table of 256*256 entries of unumber8.
  }, {
    key: "reedSolomonMultiply",
    value: function reedSolomonMultiply(x, y) {
      if (x >>> 8 != 0 || y >>> 8 != 0) throw new RangeError('Byte out of range');
      // Russian peasant multiplication
      var z = 0;
      for (var i = 7; i >= 0; i--) {
        z = z << 1 ^ (z >>> 7) * 0x11d;
        z ^= (y >>> i & 1) * x;
      }
      assert(z >>> 8 == 0);
      return z;
    }
  }]);
  return QrCode;
}();
(0,defineProperty/* default */.Z)(QrCode, "MIN_VERSION", 1);
// The maximum version number supported in the QR Code Model 2 standard.
(0,defineProperty/* default */.Z)(QrCode, "MAX_VERSION", 40);
// For use in getPenaltyScore(), when evaluating which mask is best.
(0,defineProperty/* default */.Z)(QrCode, "PENALTY_N1", 3);
(0,defineProperty/* default */.Z)(QrCode, "PENALTY_N2", 3);
(0,defineProperty/* default */.Z)(QrCode, "PENALTY_N3", 40);
(0,defineProperty/* default */.Z)(QrCode, "PENALTY_N4", 10);
(0,defineProperty/* default */.Z)(QrCode, "ECC_CODEWORDS_PER_BLOCK", [
// Version: (note that index 0 is for padding, and is set to an illegal value)
//0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
[-1, 7, 10, 15, 20, 26, 18, 20, 24, 30, 18, 20, 24, 26, 30, 22, 24, 28, 30, 28, 28, 28, 28, 30, 30, 26, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
// Low
[-1, 10, 16, 26, 18, 24, 16, 18, 22, 22, 26, 30, 22, 22, 24, 24, 28, 28, 26, 26, 26, 26, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28],
// Medium
[-1, 13, 22, 18, 26, 18, 24, 18, 22, 20, 24, 28, 26, 24, 20, 30, 24, 28, 28, 26, 30, 28, 30, 30, 30, 30, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
// Quartile
[-1, 17, 28, 22, 16, 22, 28, 26, 26, 24, 28, 24, 28, 22, 24, 24, 30, 28, 28, 26, 28, 30, 24, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30] // High
]);
(0,defineProperty/* default */.Z)(QrCode, "NUM_ERROR_CORRECTION_BLOCKS", [
// Version: (note that index 0 is for padding, and is set to an illegal value)
//0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
[-1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 4, 4, 4, 4, 4, 6, 6, 6, 6, 7, 8, 8, 9, 9, 10, 12, 12, 12, 13, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 24, 25],
// Low
[-1, 1, 1, 1, 2, 2, 4, 4, 4, 5, 5, 5, 8, 9, 9, 10, 10, 11, 13, 14, 16, 17, 17, 18, 20, 21, 23, 25, 26, 28, 29, 31, 33, 35, 37, 38, 40, 43, 45, 47, 49],
// Medium
[-1, 1, 1, 2, 2, 4, 4, 6, 6, 8, 8, 8, 10, 12, 16, 12, 17, 16, 18, 21, 20, 23, 23, 25, 27, 29, 34, 34, 35, 38, 40, 43, 45, 48, 51, 53, 56, 59, 62, 65, 68],
// Quartile
[-1, 1, 1, 2, 4, 4, 4, 5, 6, 8, 8, 11, 11, 16, 16, 18, 16, 19, 21, 25, 25, 25, 34, 30, 32, 35, 37, 40, 42, 45, 48, 51, 54, 57, 60, 63, 66, 70, 74, 77, 81] // High
]);
;// CONCATENATED MODULE: ./node_modules/@rc-component/qrcode/es/utils.js
// Part logic is from `qrcode.react`. (ISC License)
// https://github.com/zpao/qrcode.react

// ==========================================================



// =================== ERROR_LEVEL ==========================
var ERROR_LEVEL_MAP = {
  L: Ecc.LOW,
  M: Ecc.MEDIUM,
  Q: Ecc.QUARTILE,
  H: Ecc.HIGH
};

// =================== DEFAULT_VALUE ==========================
var DEFAULT_SIZE = 128;
var DEFAULT_LEVEL = 'L';
var DEFAULT_BACKGROUND_COLOR = '#FFFFFF';
var DEFAULT_FRONT_COLOR = '#000000';
var DEFAULT_NEED_MARGIN = false;
var DEFAULT_MINVERSION = 1;
var SPEC_MARGIN_SIZE = 4;
var DEFAULT_MARGIN_SIZE = 0;
var DEFAULT_IMG_SCALE = 0.1;

// =================== UTILS ==========================
/**
 * Generate a path string from modules
 * @param modules
 * @param margin 
 * @returns 
 */
function generatePath(modules) {
  var margin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var ops = [];
  modules.forEach(function (row, y) {
    var start = null;
    row.forEach(function (cell, x) {
      if (!cell && start !== null) {
        ops.push("M".concat(start + margin, " ").concat(y + margin, "h").concat(x - start, "v1H").concat(start + margin, "z"));
        start = null;
        return;
      }
      if (x === row.length - 1) {
        if (!cell) {
          return;
        }
        if (start === null) {
          ops.push("M".concat(x + margin, ",").concat(y + margin, " h1v1H").concat(x + margin, "z"));
        } else {
          ops.push("M".concat(start + margin, ",").concat(y + margin, " h").concat(x + 1 - start, "v1H").concat(start + margin, "z"));
        }
        return;
      }
      if (cell && start === null) {
        start = x;
      }
    });
  });
  return ops.join('');
}
/**
 * Excavate modules
 * @param modules 
 * @param excavation 
 * @returns 
 */
function excavateModules(modules, excavation) {
  return modules.slice().map(function (row, y) {
    if (y < excavation.y || y >= excavation.y + excavation.h) {
      return row;
    }
    return row.map(function (cell, x) {
      if (x < excavation.x || x >= excavation.x + excavation.w) {
        return cell;
      }
      return false;
    });
  });
}

/**
 * Get image settings
 * @param cells The modules of the QR code
 * @param size The size of the QR code
 * @param margin 
 * @param imageSettings 
 * @returns 
 */
function getImageSettings(cells, size, margin, imageSettings) {
  if (imageSettings == null) {
    return null;
  }
  var numCells = cells.length + margin * 2;
  var defaultSize = Math.floor(size * DEFAULT_IMG_SCALE);
  var scale = numCells / size;
  var w = (imageSettings.width || defaultSize) * scale;
  var h = (imageSettings.height || defaultSize) * scale;
  var x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
  var y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
  var opacity = imageSettings.opacity == null ? 1 : imageSettings.opacity;
  var excavation = null;
  if (imageSettings.excavate) {
    var floorX = Math.floor(x);
    var floorY = Math.floor(y);
    var ceilW = Math.ceil(w + x - floorX);
    var ceilH = Math.ceil(h + y - floorY);
    excavation = {
      x: floorX,
      y: floorY,
      w: ceilW,
      h: ceilH
    };
  }
  var crossOrigin = imageSettings.crossOrigin;
  return {
    x: x,
    y: y,
    h: h,
    w: w,
    excavation: excavation,
    opacity: opacity,
    crossOrigin: crossOrigin
  };
}

/**
 * Get margin size
 * @param needMargin Whether need margin
 * @param marginSize Custom margin size
 * @returns 
 */
function getMarginSize(needMargin, marginSize) {
  if (marginSize != null) {
    return Math.floor(marginSize);
  }
  return needMargin ? SPEC_MARGIN_SIZE : DEFAULT_MARGIN_SIZE;
}
/**
 * Check if Path2D is supported
 */
var isSupportPath2d = function () {
  try {
    new Path2D().addPath(new Path2D());
  } catch (e) {
    return false;
  }
  return true;
}();
;// CONCATENATED MODULE: ./node_modules/@rc-component/qrcode/es/hooks/useQRCode.js



function useQRCode(_ref) {
  var value = _ref.value,
    level = _ref.level,
    minVersion = _ref.minVersion,
    includeMargin = _ref.includeMargin,
    marginSize = _ref.marginSize,
    imageSettings = _ref.imageSettings,
    size = _ref.size;
  var qrcode = (0,react.useMemo)(function () {
    var segments = QrSegment.makeSegments(value);
    return QrCode.encodeSegments(segments, ERROR_LEVEL_MAP[level], minVersion);
  }, [value, level, minVersion]);
  var _useMemo = (0,react.useMemo)(function () {
      var cs = qrcode.getModules();
      var mg = getMarginSize(includeMargin, marginSize);
      var ncs = cs.length + mg * 2;
      var cis = getImageSettings(cs, size, mg, imageSettings);
      return {
        cells: cs,
        margin: mg,
        numCells: ncs,
        calculatedImageSettings: cis
      };
    }, [qrcode, size, imageSettings, includeMargin, marginSize]),
    cells = _useMemo.cells,
    margin = _useMemo.margin,
    numCells = _useMemo.numCells,
    calculatedImageSettings = _useMemo.calculatedImageSettings;
  return {
    qrcode: qrcode,
    margin: margin,
    cells: cells,
    numCells: numCells,
    calculatedImageSettings: calculatedImageSettings
  };
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/qrcode/es/QRCodeCanvas.js




var QRCodeCanvas_excluded = ["value", "size", "level", "bgColor", "fgColor", "includeMargin", "minVersion", "marginSize", "style", "imageSettings"];



var QRCodeCanvas = /*#__PURE__*/react.forwardRef(function QRCodeCanvas(props, forwardedRef) {
  var value = props.value,
    _props$size = props.size,
    size = _props$size === void 0 ? DEFAULT_SIZE : _props$size,
    _props$level = props.level,
    level = _props$level === void 0 ? DEFAULT_LEVEL : _props$level,
    _props$bgColor = props.bgColor,
    bgColor = _props$bgColor === void 0 ? DEFAULT_BACKGROUND_COLOR : _props$bgColor,
    _props$fgColor = props.fgColor,
    fgColor = _props$fgColor === void 0 ? DEFAULT_FRONT_COLOR : _props$fgColor,
    _props$includeMargin = props.includeMargin,
    includeMargin = _props$includeMargin === void 0 ? DEFAULT_NEED_MARGIN : _props$includeMargin,
    _props$minVersion = props.minVersion,
    minVersion = _props$minVersion === void 0 ? DEFAULT_MINVERSION : _props$minVersion,
    marginSize = props.marginSize,
    style = props.style,
    imageSettings = props.imageSettings,
    otherProps = (0,objectWithoutProperties/* default */.Z)(props, QRCodeCanvas_excluded);
  var imgSrc = imageSettings === null || imageSettings === void 0 ? void 0 : imageSettings.src;
  var _canvas = (0,react.useRef)(null);
  var _image = (0,react.useRef)(null);
  var setCanvasRef = (0,react.useCallback)(function (node) {
    _canvas.current = node;
    if (typeof forwardedRef === 'function') {
      forwardedRef(node);
    } else if (forwardedRef) {
      forwardedRef.current = node;
    }
  }, [forwardedRef]);
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    setIsImageLoaded = _useState2[1];
  var _useQRCode = useQRCode({
      value: value,
      level: level,
      minVersion: minVersion,
      includeMargin: includeMargin,
      marginSize: marginSize,
      imageSettings: imageSettings,
      size: size
    }),
    margin = _useQRCode.margin,
    cells = _useQRCode.cells,
    numCells = _useQRCode.numCells,
    calculatedImageSettings = _useQRCode.calculatedImageSettings;
  (0,react.useEffect)(function () {
    if (_canvas.current != null) {
      var canvas = _canvas.current;
      var ctx = canvas.getContext('2d');
      if (!ctx) {
        return;
      }
      var cellsToDraw = cells;
      var image = _image.current;
      var haveImageToRender = calculatedImageSettings != null && image !== null && image.complete && image.naturalHeight !== 0 && image.naturalWidth !== 0;
      if (haveImageToRender) {
        if (calculatedImageSettings.excavation != null) {
          cellsToDraw = excavateModules(cells, calculatedImageSettings.excavation);
        }
      }
      var pixelRatio = window.devicePixelRatio || 1;
      canvas.height = canvas.width = size * pixelRatio;
      var scale = size / numCells * pixelRatio;
      ctx.scale(scale, scale);
      ctx.fillStyle = bgColor;
      ctx.fillRect(0, 0, numCells, numCells);
      ctx.fillStyle = fgColor;
      if (isSupportPath2d) {
        ctx.fill(new Path2D(generatePath(cellsToDraw, margin)));
      } else {
        cells.forEach(function (row, rdx) {
          row.forEach(function (cell, cdx) {
            if (cell) {
              ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
            }
          });
        });
      }
      if (calculatedImageSettings) {
        ctx.globalAlpha = calculatedImageSettings.opacity;
      }
      if (haveImageToRender) {
        ctx.drawImage(image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
      }
    }
  });
  (0,react.useEffect)(function () {
    setIsImageLoaded(false);
  }, [imgSrc]);
  var canvasStyle = (0,objectSpread2/* default */.Z)({
    height: size,
    width: size
  }, style);
  var img = null;
  if (imgSrc != null) {
    img = /*#__PURE__*/react.createElement("img", {
      src: imgSrc,
      key: imgSrc,
      style: {
        display: 'none'
      },
      onLoad: function onLoad() {
        setIsImageLoaded(true);
      },
      ref: _image
      // when crossOrigin is not set, the image will be tainted
      // and the canvas cannot be exported to an image
      ,

      crossOrigin: calculatedImageSettings === null || calculatedImageSettings === void 0 ? void 0 : calculatedImageSettings.crossOrigin
    });
  }
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("canvas", (0,esm_extends/* default */.Z)({
    style: canvasStyle,
    height: size,
    width: size,
    ref: setCanvasRef,
    role: "img"
  }, otherProps)), img);
});
QRCodeCanvas.displayName = 'QRCodeCanvas';

;// CONCATENATED MODULE: ./node_modules/@rc-component/qrcode/es/QRCodeSVG.js


var QRCodeSVG_excluded = ["value", "size", "level", "bgColor", "fgColor", "includeMargin", "minVersion", "title", "marginSize", "imageSettings"];



var QRCodeSVG = /*#__PURE__*/react.forwardRef(function QRCodeSVG(props, forwardedRef) {
  var value = props.value,
    _props$size = props.size,
    size = _props$size === void 0 ? DEFAULT_SIZE : _props$size,
    _props$level = props.level,
    level = _props$level === void 0 ? DEFAULT_LEVEL : _props$level,
    _props$bgColor = props.bgColor,
    bgColor = _props$bgColor === void 0 ? DEFAULT_BACKGROUND_COLOR : _props$bgColor,
    _props$fgColor = props.fgColor,
    fgColor = _props$fgColor === void 0 ? DEFAULT_FRONT_COLOR : _props$fgColor,
    _props$includeMargin = props.includeMargin,
    includeMargin = _props$includeMargin === void 0 ? DEFAULT_NEED_MARGIN : _props$includeMargin,
    _props$minVersion = props.minVersion,
    minVersion = _props$minVersion === void 0 ? DEFAULT_MINVERSION : _props$minVersion,
    title = props.title,
    marginSize = props.marginSize,
    imageSettings = props.imageSettings,
    otherProps = (0,objectWithoutProperties/* default */.Z)(props, QRCodeSVG_excluded);
  var _useQRCode = useQRCode({
      value: value,
      level: level,
      minVersion: minVersion,
      includeMargin: includeMargin,
      marginSize: marginSize,
      imageSettings: imageSettings,
      size: size
    }),
    margin = _useQRCode.margin,
    cells = _useQRCode.cells,
    numCells = _useQRCode.numCells,
    calculatedImageSettings = _useQRCode.calculatedImageSettings;
  var cellsToDraw = cells;
  var image = null;
  if (imageSettings != null && calculatedImageSettings != null) {
    if (calculatedImageSettings.excavation != null) {
      cellsToDraw = excavateModules(cells, calculatedImageSettings.excavation);
    }
    image = /*#__PURE__*/react.createElement("image", {
      href: imageSettings.src,
      height: calculatedImageSettings.h,
      width: calculatedImageSettings.w,
      x: calculatedImageSettings.x + margin,
      y: calculatedImageSettings.y + margin,
      preserveAspectRatio: "none",
      opacity: calculatedImageSettings.opacity
      // when crossOrigin is not set, the image will be tainted
      // and the canvas cannot be exported to an image
      ,

      crossOrigin: calculatedImageSettings.crossOrigin
    });
  }
  var fgPath = generatePath(cellsToDraw, margin);
  return /*#__PURE__*/react.createElement("svg", (0,esm_extends/* default */.Z)({
    height: size,
    width: size,
    viewBox: "0 0 ".concat(numCells, " ").concat(numCells),
    ref: forwardedRef,
    role: "img"
  }, otherProps), !!title && /*#__PURE__*/react.createElement("title", null, title), /*#__PURE__*/react.createElement("path", {
    fill: bgColor,
    d: "M0,0 h".concat(numCells, "v").concat(numCells, "H0z"),
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/react.createElement("path", {
    fill: fgColor,
    d: fgPath,
    shapeRendering: "crispEdges"
  }), image);
});
QRCodeSVG.displayName = 'QRCodeSVG';

;// CONCATENATED MODULE: ./node_modules/@rc-component/qrcode/es/index.js



;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/ReloadOutlined.js
// This icon file is generated automatically.
var ReloadOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 00-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 01655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 01279 755.2a342.16 342.16 0 01-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 01109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z"
      }
    }]
  },
  "name": "reload",
  "theme": "outlined"
};
/* harmony default export */ var asn_ReloadOutlined = (ReloadOutlined);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/ReloadOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ReloadOutlined_ReloadOutlined = function ReloadOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_ReloadOutlined
  }));
};

/**![reload](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOS4xIDIwOS4zbC01Ni40IDQ0LjFDNzc1LjggMTU1LjEgNjU2LjIgOTIgNTIxLjkgOTIgMjkwIDkyIDEwMi4zIDI3OS41IDEwMiA1MTEuNSAxMDEuNyA3NDMuNyAyODkuOCA5MzIgNTIxLjkgOTMyYzE4MS4zIDAgMzM1LjgtMTE1IDM5NC42LTI3Ni4xIDEuNS00LjItLjctOC45LTQuOS0xMC4zbC01Ni43LTE5LjVhOCA4IDAgMDAtMTAuMSA0LjhjLTEuOCA1LTMuOCAxMC01LjkgMTQuOS0xNy4zIDQxLTQyLjEgNzcuOC03My43IDEwOS40QTM0NC43NyAzNDQuNzcgMCAwMTY1NS45IDgyOWMtNDIuMyAxNy45LTg3LjQgMjctMTMzLjggMjctNDYuNSAwLTkxLjUtOS4xLTEzMy44LTI3QTM0MS41IDM0MS41IDAgMDEyNzkgNzU1LjJhMzQyLjE2IDM0Mi4xNiAwIDAxLTczLjctMTA5LjRjLTE3LjktNDIuNC0yNy04Ny40LTI3LTEzMy45czkuMS05MS41IDI3LTEzMy45YzE3LjMtNDEgNDIuMS03Ny44IDczLjctMTA5LjQgMzEuNi0zMS42IDY4LjQtNTYuNCAxMDkuMy03My44IDQyLjMtMTcuOSA4Ny40LTI3IDEzMy44LTI3IDQ2LjUgMCA5MS41IDkuMSAxMzMuOCAyN2EzNDEuNSAzNDEuNSAwIDAxMTA5LjMgNzMuOGM5LjkgOS45IDE5LjIgMjAuNCAyNy44IDMxLjRsLTYwLjIgNDdhOCA4IDAgMDAzIDE0LjFsMTc1LjYgNDNjNSAxLjIgOS45LTIuNiA5LjktNy43bC44LTE4MC45Yy0uMS02LjYtNy44LTEwLjMtMTMtNi4yeiIgLz48L3N2Zz4=) */
var ReloadOutlined_RefIcon = /*#__PURE__*/react.forwardRef(ReloadOutlined_ReloadOutlined);
if (false) {}
/* harmony default export */ var icons_ReloadOutlined = (ReloadOutlined_RefIcon);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/qr-code/QrcodeStatus.js
"use client";





const defaultSpin = /*#__PURE__*/react.createElement(spin, null);
function QRcodeStatus({
  prefixCls,
  locale,
  onRefresh,
  statusRender,
  status
}) {
  const defaultExpiredNode = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("p", {
    className: `${prefixCls}-expired`
  }, locale === null || locale === void 0 ? void 0 : locale.expired), onRefresh && (/*#__PURE__*/react.createElement(es_button, {
    type: "link",
    icon: /*#__PURE__*/react.createElement(icons_ReloadOutlined, null),
    onClick: onRefresh
  }, locale === null || locale === void 0 ? void 0 : locale.refresh)));
  const defaultScannedNode = /*#__PURE__*/react.createElement("p", {
    className: `${prefixCls}-scanned`
  }, locale === null || locale === void 0 ? void 0 : locale.scanned);
  const defaultNodes = {
    expired: defaultExpiredNode,
    loading: defaultSpin,
    scanned: defaultScannedNode
  };
  const defaultStatusRender = info => defaultNodes[info.status];
  const mergedStatusRender = statusRender !== null && statusRender !== void 0 ? statusRender : defaultStatusRender;
  return mergedStatusRender({
    status,
    locale,
    onRefresh
  });
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/qr-code/style/index.js




const genQRCodeStyle = token => {
  const {
    componentCls,
    lineWidth,
    lineType,
    colorSplit
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: token.paddingSM,
      backgroundColor: token.colorWhite,
      borderRadius: token.borderRadiusLG,
      border: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${colorSplit}`,
      position: 'relative',
      overflow: 'hidden',
      [`& > ${componentCls}-mask`]: {
        position: 'absolute',
        insetBlockStart: 0,
        insetInlineStart: 0,
        zIndex: 10,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        color: token.colorText,
        lineHeight: token.lineHeight,
        background: token.QRCodeMaskBackgroundColor,
        textAlign: 'center',
        [`& > ${componentCls}-expired, & > ${componentCls}-scanned`]: {
          color: token.QRCodeTextColor
        }
      },
      '> canvas': {
        alignSelf: 'stretch',
        flex: 'auto',
        minWidth: 0
      },
      '&-icon': {
        marginBlockEnd: token.marginXS,
        fontSize: token.controlHeight
      }
    }),
    [`${componentCls}-borderless`]: {
      borderColor: 'transparent',
      padding: 0,
      borderRadius: 0
    }
  };
};
const qr_code_style_prepareComponentToken = token => ({
  QRCodeMaskBackgroundColor: new fast_color_es/* FastColor */.t(token.colorBgContainer).setA(0.96).toRgbString()
});
/* harmony default export */ var qr_code_style = (genStyleHooks('QRCode', token => {
  const mergedToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    QRCodeTextColor: token.colorText
  });
  return genQRCodeStyle(mergedToken);
}, qr_code_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/qr-code/index.js
"use client";

var qr_code_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};











const QRCode = props => {
  var _a, _b, _c, _d;
  const [, token] = useToken();
  const {
      value,
      type = 'canvas',
      icon = '',
      size = 160,
      iconSize,
      color = token.colorText,
      errorLevel = 'M',
      status = 'active',
      bordered = true,
      onRefresh,
      style,
      className,
      rootClassName,
      prefixCls: customizePrefixCls,
      bgColor = 'transparent',
      statusRender
    } = props,
    rest = qr_code_rest(props, ["value", "type", "icon", "size", "iconSize", "color", "errorLevel", "status", "bordered", "onRefresh", "style", "className", "rootClassName", "prefixCls", "bgColor", "statusRender"]);
  const {
    getPrefixCls
  } = (0,react.useContext)(ConfigContext);
  const prefixCls = getPrefixCls('qrcode', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = qr_code_style(prefixCls);
  const imageSettings = {
    src: icon,
    x: undefined,
    y: undefined,
    height: typeof iconSize === 'number' ? iconSize : (_a = iconSize === null || iconSize === void 0 ? void 0 : iconSize.height) !== null && _a !== void 0 ? _a : 40,
    width: typeof iconSize === 'number' ? iconSize : (_b = iconSize === null || iconSize === void 0 ? void 0 : iconSize.width) !== null && _b !== void 0 ? _b : 40,
    excavate: true,
    crossOrigin: 'anonymous'
  };
  const a11yProps = (0,pickAttrs/* default */.Z)(rest, true);
  const restProps = (0,omit/* default */.Z)(rest, Object.keys(a11yProps));
  const qrCodeProps = Object.assign({
    value,
    size,
    level: errorLevel,
    bgColor,
    fgColor: color,
    style: {
      width: style === null || style === void 0 ? void 0 : style.width,
      height: style === null || style === void 0 ? void 0 : style.height
    },
    imageSettings: icon ? imageSettings : undefined
  }, a11yProps);
  const [locale] = locale_useLocale('QRCode');
  if (false) {}
  if (!value) {
    return null;
  }
  const mergedCls = classnames_default()(prefixCls, className, rootClassName, hashId, cssVarCls, {
    [`${prefixCls}-borderless`]: !bordered
  });
  const mergedStyle = Object.assign(Object.assign({
    backgroundColor: bgColor
  }, style), {
    width: (_c = style === null || style === void 0 ? void 0 : style.width) !== null && _c !== void 0 ? _c : size,
    height: (_d = style === null || style === void 0 ? void 0 : style.height) !== null && _d !== void 0 ? _d : size
  });
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", Object.assign({}, restProps, {
    className: mergedCls,
    style: mergedStyle
  }), status !== 'active' && (/*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-mask`
  }, /*#__PURE__*/react.createElement(QRcodeStatus, {
    prefixCls: prefixCls,
    locale: locale,
    status: status,
    onRefresh: onRefresh,
    statusRender: statusRender
  }))), type === 'canvas' ? /*#__PURE__*/react.createElement(QRCodeCanvas, Object.assign({}, qrCodeProps)) : /*#__PURE__*/react.createElement(QRCodeSVG, Object.assign({}, qrCodeProps))));
};
if (false) {}
/* harmony default export */ var qr_code = (QRCode);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/radio/index.js
"use client";





const radio_Radio = radio_radio;
radio_Radio.Button = radioButton;
radio_Radio.Group = radio_group;
radio_Radio.__ANT_RADIO = true;
/* harmony default export */ var es_radio = (radio_Radio);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/StarFilled.js
// This icon file is generated automatically.
var StarFilled = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z"
      }
    }]
  },
  "name": "star",
  "theme": "filled"
};
/* harmony default export */ var asn_StarFilled = (StarFilled);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/StarFilled.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var StarFilled_StarFilled = function StarFilled(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_StarFilled
  }));
};

/**![star](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOC4xIDM1My4xbC0yNTMuOS0zNi45TDU0MC43IDg2LjFjLTMuMS02LjMtOC4yLTExLjQtMTQuNS0xNC41LTE1LjgtNy44LTM1LTEuMy00Mi45IDE0LjVMMzY5LjggMzE2LjJsLTI1My45IDM2LjljLTcgMS0xMy40IDQuMy0xOC4zIDkuM2EzMi4wNSAzMi4wNSAwIDAwLjYgNDUuM2wxODMuNyAxNzkuMS00My40IDI1Mi45YTMxLjk1IDMxLjk1IDAgMDA0Ni40IDMzLjdMNTEyIDc1NGwyMjcuMSAxMTkuNGM2LjIgMy4zIDEzLjQgNC40IDIwLjMgMy4yIDE3LjQtMyAyOS4xLTE5LjUgMjYuMS0zNi45bC00My40LTI1Mi45IDE4My43LTE3OS4xYzUtNC45IDguMy0xMS4zIDkuMy0xOC4zIDIuNy0xNy41LTkuNS0zMy43LTI3LTM2LjN6IiAvPjwvc3ZnPg==) */
var StarFilled_RefIcon = /*#__PURE__*/react.forwardRef(StarFilled_StarFilled);
if (false) {}
/* harmony default export */ var icons_StarFilled = (StarFilled_RefIcon);
;// CONCATENATED MODULE: ./node_modules/rc-rate/es/Star.js



function Star(props, ref) {
  var disabled = props.disabled,
    prefixCls = props.prefixCls,
    character = props.character,
    characterRender = props.characterRender,
    index = props.index,
    count = props.count,
    value = props.value,
    allowHalf = props.allowHalf,
    focused = props.focused,
    onHover = props.onHover,
    onClick = props.onClick;

  // =========================== Events ===========================
  var onInternalHover = function onInternalHover(e) {
    onHover(e, index);
  };
  var onInternalClick = function onInternalClick(e) {
    onClick(e, index);
  };
  var onInternalKeyDown = function onInternalKeyDown(e) {
    if (e.keyCode === KeyCode/* default.ENTER */.Z.ENTER) {
      onClick(e, index);
    }
  };

  // =========================== Render ===========================
  // >>>>> ClassName
  var starValue = index + 1;
  var classNameList = new Set([prefixCls]);

  // TODO: Current we just refactor from CC to FC. This logic seems can be optimized.
  if (value === 0 && index === 0 && focused) {
    classNameList.add("".concat(prefixCls, "-focused"));
  } else if (allowHalf && value + 0.5 >= starValue && value < starValue) {
    classNameList.add("".concat(prefixCls, "-half"));
    classNameList.add("".concat(prefixCls, "-active"));
    if (focused) {
      classNameList.add("".concat(prefixCls, "-focused"));
    }
  } else {
    if (starValue <= value) {
      classNameList.add("".concat(prefixCls, "-full"));
    } else {
      classNameList.add("".concat(prefixCls, "-zero"));
    }
    if (starValue === value && focused) {
      classNameList.add("".concat(prefixCls, "-focused"));
    }
  }

  // >>>>> Node
  var characterNode = typeof character === 'function' ? character(props) : character;
  var start = /*#__PURE__*/react.createElement("li", {
    className: classnames_default()(Array.from(classNameList)),
    ref: ref
  }, /*#__PURE__*/react.createElement("div", {
    onClick: disabled ? null : onInternalClick,
    onKeyDown: disabled ? null : onInternalKeyDown,
    onMouseMove: disabled ? null : onInternalHover,
    role: "radio",
    "aria-checked": value > index ? 'true' : 'false',
    "aria-posinset": index + 1,
    "aria-setsize": count,
    tabIndex: disabled ? -1 : 0
  }, /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-first")
  }, characterNode), /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-second")
  }, characterNode)));
  if (characterRender) {
    start = characterRender(start, props);
  }
  return start;
}
/* harmony default export */ var es_Star = (/*#__PURE__*/react.forwardRef(Star));
;// CONCATENATED MODULE: ./node_modules/rc-rate/es/useRefs.js

function useRefs() {
  var nodeRef = react.useRef({});
  function getRef(index) {
    return nodeRef.current[index];
  }
  function setRef(index) {
    return function (node) {
      nodeRef.current[index] = node;
    };
  }
  return [getRef, setRef];
}
;// CONCATENATED MODULE: ./node_modules/rc-rate/es/util.js
function util_getScroll(w) {
  var ret = w.pageXOffset;
  var method = 'scrollLeft';
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}
function getClientPosition(elem) {
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  var box = elem.getBoundingClientRect();
  x = box.left;
  y = box.top;
  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}
function getOffsetLeft(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  // Only IE use `parentWindow`
  var w = doc.defaultView || doc.parentWindow;
  pos.left += util_getScroll(w);
  return pos.left;
}
;// CONCATENATED MODULE: ./node_modules/rc-rate/es/Rate.js




var Rate_excluded = ["prefixCls", "className", "defaultValue", "value", "count", "allowHalf", "allowClear", "keyboard", "character", "characterRender", "disabled", "direction", "tabIndex", "autoFocus", "onHoverChange", "onChange", "onFocus", "onBlur", "onKeyDown", "onMouseLeave"];








function Rate(props, ref) {
  var _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-rate' : _props$prefixCls,
    className = props.className,
    defaultValue = props.defaultValue,
    propValue = props.value,
    _props$count = props.count,
    count = _props$count === void 0 ? 5 : _props$count,
    _props$allowHalf = props.allowHalf,
    allowHalf = _props$allowHalf === void 0 ? false : _props$allowHalf,
    _props$allowClear = props.allowClear,
    allowClear = _props$allowClear === void 0 ? true : _props$allowClear,
    _props$keyboard = props.keyboard,
    keyboard = _props$keyboard === void 0 ? true : _props$keyboard,
    _props$character = props.character,
    character = _props$character === void 0 ? '★' : _props$character,
    characterRender = props.characterRender,
    disabled = props.disabled,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'ltr' : _props$direction,
    _props$tabIndex = props.tabIndex,
    tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
    autoFocus = props.autoFocus,
    onHoverChange = props.onHoverChange,
    onChange = props.onChange,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onKeyDown = props.onKeyDown,
    onMouseLeave = props.onMouseLeave,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, Rate_excluded);
  var _useRefs = useRefs(),
    _useRefs2 = (0,slicedToArray/* default */.Z)(_useRefs, 2),
    getStarRef = _useRefs2[0],
    setStarRef = _useRefs2[1];
  var rateRef = react.useRef(null);

  // ============================ Ref =============================
  var triggerFocus = function triggerFocus() {
    if (!disabled) {
      var _rateRef$current;
      (_rateRef$current = rateRef.current) === null || _rateRef$current === void 0 || _rateRef$current.focus();
    }
  };
  react.useImperativeHandle(ref, function () {
    return {
      focus: triggerFocus,
      blur: function blur() {
        if (!disabled) {
          var _rateRef$current2;
          (_rateRef$current2 = rateRef.current) === null || _rateRef$current2 === void 0 || _rateRef$current2.blur();
        }
      }
    };
  });

  // =========================== Value ============================
  var _useMergedState = (0,useMergedState/* default */.Z)(defaultValue || 0, {
      value: propValue
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    value = _useMergedState2[0],
    setValue = _useMergedState2[1];
  var _useMergedState3 = (0,useMergedState/* default */.Z)(null),
    _useMergedState4 = (0,slicedToArray/* default */.Z)(_useMergedState3, 2),
    cleanedValue = _useMergedState4[0],
    setCleanedValue = _useMergedState4[1];
  var getStarValue = function getStarValue(index, x) {
    var reverse = direction === 'rtl';
    var starValue = index + 1;
    if (allowHalf) {
      var starEle = getStarRef(index);
      var leftDis = getOffsetLeft(starEle);
      var width = starEle.clientWidth;
      if (reverse && x - leftDis > width / 2) {
        starValue -= 0.5;
      } else if (!reverse && x - leftDis < width / 2) {
        starValue -= 0.5;
      }
    }
    return starValue;
  };

  // >>>>> Change
  var changeValue = function changeValue(nextValue) {
    setValue(nextValue);
    onChange === null || onChange === void 0 || onChange(nextValue);
  };

  // =========================== Focus ============================
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    focused = _React$useState2[0],
    setFocused = _React$useState2[1];
  var onInternalFocus = function onInternalFocus() {
    setFocused(true);
    onFocus === null || onFocus === void 0 || onFocus();
  };
  var onInternalBlur = function onInternalBlur() {
    setFocused(false);
    onBlur === null || onBlur === void 0 || onBlur();
  };

  // =========================== Hover ============================
  var _React$useState3 = react.useState(null),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    hoverValue = _React$useState4[0],
    setHoverValue = _React$useState4[1];
  var onHover = function onHover(event, index) {
    var nextHoverValue = getStarValue(index, event.pageX);
    if (nextHoverValue !== cleanedValue) {
      setHoverValue(nextHoverValue);
      setCleanedValue(null);
    }
    onHoverChange === null || onHoverChange === void 0 || onHoverChange(nextHoverValue);
  };
  var onMouseLeaveCallback = function onMouseLeaveCallback(event) {
    if (!disabled) {
      setHoverValue(null);
      setCleanedValue(null);
      onHoverChange === null || onHoverChange === void 0 || onHoverChange(undefined);
    }
    if (event) {
      onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave(event);
    }
  };

  // =========================== Click ============================
  var onClick = function onClick(event, index) {
    var newValue = getStarValue(index, event.pageX);
    var isReset = false;
    if (allowClear) {
      isReset = newValue === value;
    }
    onMouseLeaveCallback();
    changeValue(isReset ? 0 : newValue);
    setCleanedValue(isReset ? newValue : null);
  };
  var onInternalKeyDown = function onInternalKeyDown(event) {
    var keyCode = event.keyCode;
    var reverse = direction === 'rtl';
    var step = allowHalf ? 0.5 : 1;
    if (keyboard) {
      if (keyCode === KeyCode/* default.RIGHT */.Z.RIGHT && value < count && !reverse) {
        changeValue(value + step);
        event.preventDefault();
      } else if (keyCode === KeyCode/* default.LEFT */.Z.LEFT && value > 0 && !reverse) {
        changeValue(value - step);
        event.preventDefault();
      } else if (keyCode === KeyCode/* default.RIGHT */.Z.RIGHT && value > 0 && reverse) {
        changeValue(value - step);
        event.preventDefault();
      } else if (keyCode === KeyCode/* default.LEFT */.Z.LEFT && value < count && reverse) {
        changeValue(value + step);
        event.preventDefault();
      }
    }
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(event);
  };

  // =========================== Effect ===========================

  react.useEffect(function () {
    if (autoFocus && !disabled) {
      triggerFocus();
    }
  }, []);

  // =========================== Render ===========================
  // >>> Star
  var starNodes = new Array(count).fill(0).map(function (item, index) {
    return /*#__PURE__*/react.createElement(es_Star, {
      ref: setStarRef(index),
      index: index,
      count: count,
      disabled: disabled,
      prefixCls: "".concat(prefixCls, "-star"),
      allowHalf: allowHalf,
      value: hoverValue === null ? value : hoverValue,
      onClick: onClick,
      onHover: onHover,
      key: item || index,
      character: character,
      characterRender: characterRender,
      focused: focused
    });
  });
  var classString = classnames_default()(prefixCls, className, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-rtl"), direction === 'rtl'));

  // >>> Node
  return /*#__PURE__*/react.createElement("ul", (0,esm_extends/* default */.Z)({
    className: classString,
    onMouseLeave: onMouseLeaveCallback,
    tabIndex: disabled ? -1 : tabIndex,
    onFocus: disabled ? null : onInternalFocus,
    onBlur: disabled ? null : onInternalBlur,
    onKeyDown: disabled ? null : onInternalKeyDown,
    ref: rateRef
  }, (0,pickAttrs/* default */.Z)(restProps, {
    aria: true,
    data: true,
    attr: true
  })), starNodes);
}
/* harmony default export */ var es_Rate = (/*#__PURE__*/react.forwardRef(Rate));
;// CONCATENATED MODULE: ./node_modules/rc-rate/es/index.js

/* harmony default export */ var rc_rate_es = (es_Rate);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/rate/style/index.js



const genRateStarStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}-star`]: {
      position: 'relative',
      display: 'inline-block',
      color: 'inherit',
      cursor: 'pointer',
      '&:not(:last-child)': {
        marginInlineEnd: token.marginXS
      },
      '> div': {
        transition: `all ${token.motionDurationMid}, outline 0s`,
        '&:hover': {
          transform: token.starHoverScale
        },
        '&:focus': {
          outline: 0
        },
        '&:focus-visible': {
          outline: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} dashed ${token.starColor}`,
          transform: token.starHoverScale
        }
      },
      '&-first, &-second': {
        color: token.starBg,
        transition: `all ${token.motionDurationMid}`,
        userSelect: 'none'
      },
      '&-first': {
        position: 'absolute',
        top: 0,
        insetInlineStart: 0,
        width: '50%',
        height: '100%',
        overflow: 'hidden',
        opacity: 0
      },
      [`&-half ${componentCls}-star-first, &-half ${componentCls}-star-second`]: {
        opacity: 1
      },
      [`&-half ${componentCls}-star-first, &-full ${componentCls}-star-second`]: {
        color: 'inherit'
      }
    }
  };
};
const genRateRtlStyle = token => ({
  [`&-rtl${token.componentCls}`]: {
    direction: 'rtl'
  }
});
const genRateStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), {
      display: 'inline-block',
      margin: 0,
      padding: 0,
      color: token.starColor,
      fontSize: token.starSize,
      lineHeight: 1,
      listStyle: 'none',
      outline: 'none',
      // disable styles
      [`&-disabled${componentCls} ${componentCls}-star`]: {
        cursor: 'default',
        '> div:hover': {
          transform: 'scale(1)'
        }
      }
    }), genRateStarStyle(token)), genRateRtlStyle(token))
  };
};
// ============================== Export ==============================
const rate_style_prepareComponentToken = token => ({
  starColor: token.yellow6,
  starSize: token.controlHeightLG * 0.5,
  starHoverScale: 'scale(1.1)',
  starBg: token.colorFillContent
});
/* harmony default export */ var rate_style = (genStyleHooks('Rate', token => {
  const rateToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {});
  return genRateStyle(rateToken);
}, rate_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/rate/index.js
"use client";

var rate_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};








const rate_Rate = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls,
      className,
      rootClassName,
      style,
      tooltips,
      character = /*#__PURE__*/react.createElement(icons_StarFilled, null),
      disabled: customDisabled
    } = props,
    rest = rate_rest(props, ["prefixCls", "className", "rootClassName", "style", "tooltips", "character", "disabled"]);
  const characterRender = (node, {
    index
  }) => {
    if (!tooltips) {
      return node;
    }
    return /*#__PURE__*/react.createElement(es_tooltip, {
      title: tooltips[index]
    }, node);
  };
  const {
    getPrefixCls,
    direction,
    rate
  } = react.useContext(ConfigContext);
  const ratePrefixCls = getPrefixCls('rate', prefixCls);
  // Style
  const [wrapCSSVar, hashId, cssVarCls] = rate_style(ratePrefixCls);
  const mergedStyle = Object.assign(Object.assign({}, rate === null || rate === void 0 ? void 0 : rate.style), style);
  // ===================== Disabled =====================
  const disabled = react.useContext(config_provider_DisabledContext);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  return wrapCSSVar(/*#__PURE__*/react.createElement(rc_rate_es, Object.assign({
    ref: ref,
    character: character,
    characterRender: characterRender,
    disabled: mergedDisabled
  }, rest, {
    className: classnames_default()(className, rootClassName, hashId, cssVarCls, rate === null || rate === void 0 ? void 0 : rate.className),
    style: mergedStyle,
    prefixCls: ratePrefixCls,
    direction: direction
  })));
});
if (false) {}
/* harmony default export */ var rate = (rate_Rate);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/WarningFilled.js
// This icon file is generated automatically.
var WarningFilled = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
      }
    }]
  },
  "name": "warning",
  "theme": "filled"
};
/* harmony default export */ var asn_WarningFilled = (WarningFilled);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/WarningFilled.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var WarningFilled_WarningFilled = function WarningFilled(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_WarningFilled
  }));
};

/**![warning](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk1NS43IDg1NmwtNDE2LTcyMGMtNi4yLTEwLjctMTYuOS0xNi0yNy43LTE2cy0yMS42IDUuMy0yNy43IDE2bC00MTYgNzIwQzU2IDg3Ny40IDcxLjQgOTA0IDk2IDkwNGg4MzJjMjQuNiAwIDQwLTI2LjYgMjcuNy00OHpNNDgwIDQxNmMwLTQuNCAzLjYtOCA4LThoNDhjNC40IDAgOCAzLjYgOCA4djE4NGMwIDQuNC0zLjYgOC04IDhoLTQ4Yy00LjQgMC04LTMuNi04LThWNDE2em0zMiAzNTJhNDguMDEgNDguMDEgMCAwMTAtOTYgNDguMDEgNDguMDEgMCAwMTAgOTZ6IiAvPjwvc3ZnPg==) */
var WarningFilled_RefIcon = /*#__PURE__*/react.forwardRef(WarningFilled_WarningFilled);
if (false) {}
/* harmony default export */ var icons_WarningFilled = (WarningFilled_RefIcon);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/result/noFound.js
"use client";


const NoFound = () => (/*#__PURE__*/react.createElement("svg", {
  width: "252",
  height: "294"
}, /*#__PURE__*/react.createElement("title", null, "No Found"), /*#__PURE__*/react.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/react.createElement("circle", {
  cx: "126.75",
  cy: "128.1",
  r: "126",
  fill: "#E4EBF7"
}), /*#__PURE__*/react.createElement("circle", {
  cx: "31.55",
  cy: "130.8",
  r: "8.3",
  fill: "#FFF"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#FFF",
  d: "m37 134.3 10.5 6m.9 6.2-12.7 10.8",
  strokeWidth: "2"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M39.9 159.4a5.7 5.7 0 1 1-11.3-1.2 5.7 5.7 0 0 1 11.3 1.2m17.7-16.2a5.7 5.7 0 1 1-11.4-1.1 5.7 5.7 0 0 1 11.4 1.1M99 27h29.8a4.6 4.6 0 1 0 0-9.2H99a4.6 4.6 0 1 0 0 9.2m11.4 18.3h29.8a4.6 4.6 0 0 0 0-9.2h-29.8a4.6 4.6 0 1 0 0 9.2"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M112.8 26.9h15.8a4.6 4.6 0 1 0 0 9.1h-15.8a4.6 4.6 0 0 0 0-9.1m71.7 108.8a10 10 0 1 1-19.8-2 10 10 0 0 1 19.8 2"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#FFF",
  d: "m179.3 141.8 12.6 7.1m1.1 7.6-15.2 13",
  strokeWidth: "2"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M184.7 170a6.8 6.8 0 1 1-13.6-1.3 6.8 6.8 0 0 1 13.6 1.4m18.6-16.8a6.9 6.9 0 1 1-13.7-1.4 6.9 6.9 0 0 1 13.7 1.4"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#FFF",
  d: "M152 192.3a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.4 0zm73.3-76.2a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.5 0zm-9 35a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.5 0zM177 107.6a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm18.4-15.4a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.5 0zm6.8 88.5a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.5 0z",
  strokeWidth: "2"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#FFF",
  d: "m214.4 153.3-2 20.2-10.8 6m-28-4.7-6.3 9.8H156l-4.5 6.5m23.5-66v-15.7m46 7.8-13 8-15.2-8V94.4",
  strokeWidth: "2"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M166.6 66h-4a4.8 4.8 0 0 1-4.7-4.8 4.8 4.8 0 0 1 4.7-4.7h4a4.8 4.8 0 0 1 4.7 4.7 4.8 4.8 0 0 1-4.7 4.7"
}), /*#__PURE__*/react.createElement("circle", {
  cx: "204.3",
  cy: "30",
  r: "29.5",
  fill: "#1677ff"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M206 38.4c.5.5.7 1.1.7 2s-.2 1.4-.7 1.9a3 3 0 0 1-2 .7c-.8 0-1.5-.3-2-.8s-.8-1.1-.8-1.9.3-1.4.8-2c.5-.4 1.2-.7 2-.7.7 0 1.4.3 2 .8m4.2-19.5c1.5 1.3 2.2 3 2.2 5.2a7.2 7.2 0 0 1-1.5 4.5l-3 2.7a5 5 0 0 0-1.3 1.7 5.2 5.2 0 0 0-.6 2.4v.5h-4v-.5c0-1.4.1-2.5.6-3.5s1.9-2.5 4.2-4.5l.4-.5a4 4 0 0 0 1-2.6c0-1.2-.4-2-1-2.8-.7-.6-1.6-1-2.9-1-1.5 0-2.6.5-3.3 1.5-.4.5-.6 1-.8 1.9a2 2 0 0 1-2 1.6 2 2 0 0 1-2-2.4c.4-1.6 1-2.8 2.1-3.8a8.5 8.5 0 0 1 6.3-2.3c2.3 0 4.2.6 5.6 2"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFB594",
  d: "M52 76.1s21.8 5.4 27.3 16c5.6 10.7-6.3 9.2-15.7 5C52.8 92 39 85 52 76"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFC6A0",
  d: "m90.5 67.5-.5 2.9c-.7.5-4.7-2.7-4.7-2.7l-1.7.8-1.3-5.7s6.8-4.6 9-5c2.4-.5 9.8 1 10.6 2.3 0 0 1.3.4-2.2.6-3.6.3-5 .5-6.8 3.2l-2.4 3.6"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M128 111.4a36.7 36.7 0 0 0-8.9-15.5c-3.5-3-9.3-2.2-11.3-4.2-1.3-1.2-3.2-1.2-3.2-1.2L87.7 87c-2.3-.4-2.1-.7-6-1.4-1.6-1.9-3-1.1-3-1.1l-7-1.4c-1-1.5-2.5-1-2.5-1l-2.4-.9C65 91.2 59 95 59 95c1.8 1.1 15.7 8.3 15.7 8.3l5.1 37.1s-3.3 5.7 1.4 9.1c0 0 19.9-3.7 34.9-.3 0 0 3-2.6 1-8.8.5-3 1.4-8.3 1.7-11.6.4.7 2 1.9 3.1 3.4 0 0 9.4-7.3 11-14a17 17 0 0 1-2.2-2.4c-.5-.8-.3-2-.7-2.8-.7-1-1.8-1.3-2-1.6"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#CBD1D1",
  d: "M101 290s4.4 2 7.4 1c2.9-1 4.6.7 7.1 1.2 2.6.5 6.9 1.1 11.7-1.3 0-5.5-6.9-4-12-6.7-2.5-1.4-3.7-4.7-3.5-8.8h-9.5s-1.2 10.6-1 14.6"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#2B0849",
  d: "M101 289.8s2.5 1.3 6.8.7c3-.5 3.7.5 7.4 1 3.8.6 10.8 0 11.9-.9.4 1.1-.4 2-.4 2s-1.5.7-4.8.9c-2 .1-5.8.3-7.6-.5-1.8-1.4-5.2-1.9-5.7-.2-4 1-7.4-.3-7.4-.3l-.1-2.7z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#A4AABA",
  d: "M108.3 276h3.1s0 6.7 4.6 8.6c-4.7.6-8.6-2.3-7.7-8.6"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#CBD1D1",
  d: "M57.5 272.4s-2 7.4-4.4 12.3c-1.8 3.7-4.3 7.5 5.4 7.5 6.7 0 9-.5 7.4-6.6-1.5-6.1.3-13.2.3-13.2h-8.7z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#2B0849",
  d: "M51.5 289.8s2 1.2 6.6 1.2c6 0 8.3-1.7 8.3-1.7s.6 1.1-.7 2.2c-1 .8-3.6 1.6-7.4 1.5-4.1 0-5.8-.5-6.7-1.1-.8-.6-.7-1.6-.1-2.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#A4AABA",
  d: "M58.4 274.3s0 1.5-.3 3c-.3 1.4-1 3-1.1 4 0 1.2 4.5 1.7 5.1.1.6-1.5 1.3-6.4 2-7.2.6-.9-5-2.2-5.7.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#7BB2F9",
  d: "m99.7 278.5 13.3.1s1.3-54.5 1.9-64.4c.5-9.9 3.8-43.4 1-63.1l-12.6-.7-22.8.8-1.2 10c0 .5-.7.8-.7 1.4-.1.5.4 1.3.3 2-2.4 14-6.4 33-8.8 46.6 0 .7-1.2 1-1.4 2.7 0 .3.2 1.5 0 1.8-6.8 18.7-10.9 47.8-14.2 61.9h14.6s2.2-8.6 4-17c2.9-12.9 23.2-85 23.2-85l3-.5 1 46.3s-.2 1.2.4 2c.5.8-.6 1.1-.4 2.3l.4 1.8-1 11.8c-.4 4.8 0 39.2 0 39.2"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#648BD8",
  d: "M76 221.6c1.2.1 4.1-2 7-5m23.4 8.5s2.7-1 6-3.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#648BD8",
  d: "M107.3 222.1s2.7-1.1 6-3.9",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#648BD8",
  d: "M74.7 224.8s2.7-.6 6.5-3.4m4.8-69.8c-.2 3.1.3 8.6-4.3 9.2m22-11s0 14-1.4 15.1a15 15 0 0 1-3 2m.5-16.5s0 13-1.2 24.4m-5 1.1s7.3-1.7 9.5-1.7M74.3 206a212 212 0 0 1-1 4.5s-1.4 1.9-1 3.8c.5 2-1 2-5 15.4A353 353 0 0 0 61 257l-.2 1.2m14.9-60.5a321 321 0 0 1-.9 4.8m7.8-50.4-1.2 10.5s-1.1.1-.5 2.2c.1 1.4-2.7 15.8-5.2 30.5m-19.6 79h13.3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#192064",
  d: "M116.2 148.2s-17-3-35.9.2c.2 2.5 0 4.2 0 4.2s14.7-2.8 35.7-.3c.3-2.4.2-4 .2-4"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M106.3 151.2v-5a.8.8 0 0 0-.8-.8h-7.8a.8.8 0 0 0-.8.8v5a.8.8 0 0 0 .8.8h7.8a.8.8 0 0 0 .8-.8"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#192064",
  d: "M105.2 150.2v-3a.6.6 0 0 0-.6-.7 94.3 94.3 0 0 0-5.9 0 .7.7 0 0 0-.6.6v3.1a.6.6 0 0 0 .6.7 121.1 121.1 0 0 1 5.8 0c.4 0 .7-.3.7-.7"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#648BD8",
  d: "M100.3 275.4h12.3m-11.2-4.9.1 6.5m0-12.5a915.8 915.8 0 0 0 0 4.4m-.5-94 .9 44.7s.7 1.6-.2 2.7c-1 1.1 2.4.7.9 2.2-1.6 1.6.9 1.2 0 3.4-.6 1.5-1 21.1-1.1 35.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFC6A0",
  d: "M46.9 83.4s-.5 6 7.2 5.6c11.2-.7 9.2-9.4 31.5-21.7-.7-2.7-2.4-4.7-2.4-4.7s-11 3-22.6 8c-6.8 3-13.4 6.4-13.7 12.8m57.6 7.7.9-5.4-8.9-11.4-5 5.3-1.8 7.9a.3.3 0 0 0 .1.3c1 .8 6.5 5 14.4 3.5a.3.3 0 0 0 .3-.2"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFC6A0",
  d: "M94 79.4s-4.6-2.9-2.5-6.9c1.6-3 4.5 1.2 4.5 1.2s.5-3.7 3.1-3.7c.6-1 1.6-4.1 1.6-4.1l13.5 3c0 5.3-2.3 19.5-7.8 20-8.9.6-12.5-9.5-12.5-9.5"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#520038",
  d: "M113.9 73.4c2.6-2 3.4-9.7 3.4-9.7s-2.4-.5-6.6-2c-4.7-2.1-12.8-4.8-17.5 1-9.6 3.2-2 19.8-2 19.8l2.7-3s-4-3.3-2-6.3c2-3.5 3.8 1 3.8 1s.7-2.3 3.6-3.3c.4-.7 1-2.6 1.4-3.8a1 1 0 0 1 1.3-.7l11.4 2.6c.5.2.8.7.8 1.2l-.3 3.2z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#552950",
  d: "M105 76c-.1.7-.6 1.1-1 1-.6 0-.9-.6-.8-1.2.1-.6.6-1 1-1 .6 0 .9.7.8 1.3m7.1 1.6c0 .6-.5 1-1 1-.5-.1-.8-.7-.7-1.3 0-.6.5-1 1-1 .5.1.8.7.7 1.3"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#DB836E",
  d: "m110.1 74.8-.9 1.7-.3 4.3h-2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#5C2552",
  d: "M110.8 74.5s1.8-.7 2.6.5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#DB836E",
  d: "M92.4 74.3s.5-1.1 1.1-.7c.6.4 1.3 1.4.6 2-.8.5.1 1.6.1 1.6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#5C2552",
  d: "M103.3 73s1.8 1 4.1.9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#DB836E",
  d: "M103.7 81.8s2.2 1.2 4.4 1.2m-3.5 1.3s1 .4 1.6.3m-11.5-3.4s2.3 7.4 10.4 7.6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#E4EBF7",
  d: "M81.5 89.4s.4 5.6-5 12.8M69 82.7s-.7 9.2-8.2 14.2m68.6 26s-5.3 7.4-9.4 10.7m-.7-26.3s.5 4.4-2.1 32",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#F2D7AD",
  d: "M150 151.2h-49.8a1 1 0 0 1-1-1v-31.7c0-.5.4-1 1-1H150c.6 0 1 .5 1 1v31.7a1 1 0 0 1-1 1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#F4D19D",
  d: "M150.3 151.2h-19.9v-33.7h20.8v32.8a1 1 0 0 1-1 1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#F2D7AD",
  d: "M123.6 127.9H92.9a.5.5 0 0 1-.4-.8l6.4-9.1c.2-.3.5-.5.8-.5h31.1l-7.2 10.4z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#CC9B6E",
  d: "M123.7 128.4H99.2v-.5h24.2l7.2-10.2.4.3z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#F4D19D",
  d: "M158.3 127.9h-18.7a2 2 0 0 1-1.6-.8l-7.2-9.6h20c.5 0 1 .3 1.2.6l6.7 9a.5.5 0 0 1-.4.8"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#CC9B6E",
  d: "M157.8 128.5h-19.3l-7.9-10.5.4-.3 7.7 10.3h19.1zm-27.2 22.2v-8.2h.4v8.2zm-.1-10.9v-21.4h.4l.1 21.4zm-18.6 1.1-.5-.1 1.5-5.2.5.2zm-3.5.2-2.6-3 2.6-3.4.4.3-2.4 3.1 2.4 2.6zm8.2 0-.4-.4 2.4-2.6-2.4-3 .4-.4 2.7 3.4z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFC6A0",
  d: "m154.3 131.9-3.1-2v3.5l-1 .1a85 85 0 0 1-4.8.3c-1.9 0-2.7 2.2 2.2 2.6l-2.6-.6s-2.2 1.3.5 2.3c0 0-1.6 1.2.6 2.6-.6 3.5 5.2 4 7 3.6a6.1 6.1 0 0 0 4.6-5.2 8 8 0 0 0-3.4-7.2"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#DB836E",
  d: "M153.7 133.6s-6.5.4-8.4.3c-1.8 0-1.9 2.2 2.4 2.3 3.7.2 5.4 0 5.4 0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#DB836E",
  d: "M145.2 135.9c-1.9 1.3.5 2.3.5 2.3s3.5 1 6.8.6m-.6 2.9s-6.3.1-6.7-2.1c-.3-1.4.4-1.4.4-1.4m.5 2.7s-1 3.1 5.5 3.5m-.4-14.5v3.5M52.8 89.3a18 18 0 0 0 13.6-7.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#5BA02E",
  d: "M168.6 248.3a6.6 6.6 0 0 1-6.7-6.6v-66.5a6.6 6.6 0 1 1 13.3 0v66.5a6.6 6.6 0 0 1-6.6 6.6"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#92C110",
  d: "M176.5 247.7a6.6 6.6 0 0 1-6.6-6.7v-33.2a6.6 6.6 0 1 1 13.3 0V241a6.6 6.6 0 0 1-6.7 6.7"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#F2D7AD",
  d: "M186.4 293.6H159a3.2 3.2 0 0 1-3.2-3.2v-46.1a3.2 3.2 0 0 1 3.2-3.2h27.5a3.2 3.2 0 0 1 3.2 3.2v46.1a3.2 3.2 0 0 1-3.2 3.2"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#E4EBF7",
  d: "M89 89.5s7.8 5.4 16.6 2.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}))));
/* harmony default export */ var noFound = (NoFound);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/result/serverError.js
"use client";


const ServerError = () => (/*#__PURE__*/react.createElement("svg", {
  width: "254",
  height: "294"
}, /*#__PURE__*/react.createElement("title", null, "Server Error"), /*#__PURE__*/react.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/react.createElement("path", {
  fill: "#E4EBF7",
  d: "M0 128.1v-2C0 56.5 56.3.2 125.7.2h2.1C197.2.3 253.5 56.6 253.5 126v2.1c0 69.5-56.3 125.7-125.7 125.7h-2.1A125.7 125.7 0 0 1 0 128.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M40 132.1a8.3 8.3 0 1 1-16.6-1.7 8.3 8.3 0 0 1 16.6 1.7"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#FFF",
  d: "m37.2 135.6 10.5 6m1 6.3-12.8 10.8",
  strokeWidth: "2"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M40.1 160.8a5.7 5.7 0 1 1-11.3-1.1 5.7 5.7 0 0 1 11.3 1.1M58 144.6a5.7 5.7 0 1 1-11.4-1.2 5.7 5.7 0 0 1 11.4 1.2M99.7 27.4h30a4.6 4.6 0 1 0 0-9.2h-30a4.6 4.6 0 0 0 0 9.2M111 46h30a4.6 4.6 0 1 0 0-9.3h-30a4.6 4.6 0 1 0 0 9.3m2.5-18.6h16a4.6 4.6 0 1 0 0 9.3h-16a4.6 4.6 0 0 0 0-9.3m36.7 42.7h-4a4.8 4.8 0 0 1-4.8-4.8 4.8 4.8 0 0 1 4.8-4.8h4a4.8 4.8 0 0 1 4.7 4.8 4.8 4.8 0 0 1-4.7 4.8"
}), /*#__PURE__*/react.createElement("circle", {
  cx: "201.35",
  cy: "30.2",
  r: "29.7",
  fill: "#FF603B"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "m203.6 19.4-.7 15a1.5 1.5 0 0 1-3 0l-.7-15a2.2 2.2 0 1 1 4.4 0m-.3 19.4c.5.5.8 1.1.8 1.9s-.3 1.4-.8 1.9a3 3 0 0 1-2 .7 2.5 2.5 0 0 1-1.8-.7c-.6-.6-.8-1.2-.8-2 0-.7.2-1.3.8-1.8.5-.5 1.1-.7 1.8-.7.8 0 1.5.2 2 .7"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFB594",
  d: "M119.3 133.3c4.4-.6 3.6-1.2 4-4.8.8-5.2-3-17-8.2-25.1-1-10.7-12.6-11.3-12.6-11.3s4.3 5 4.2 16.2c1.4 5.3.8 14.5.8 14.5s5.3 11.4 11.8 10.5"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M101 91.6s1.4-.6 3.2.6c8 1.4 10.3 6.7 11.3 11.4 1.8 1.2 1.8 2.3 1.8 3.5l1.5 3s-7.2 1.7-11 6.7c-1.3-6.4-6.9-25.2-6.9-25.2"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFB594",
  d: "m94 90.5 1-5.8-9.2-11.9-5.2 5.6-2.6 9.9s8.4 5 16 2.2"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFC6A0",
  d: "M83 78.2s-4.6-2.9-2.5-6.9c1.6-3 4.5 1.2 4.5 1.2s.5-3.7 3.2-3.7c.5-1 1.5-4.2 1.5-4.2l13.6 3.2c0 5.2-2.3 19.5-7.9 20-8.9.6-12.5-9.6-12.5-9.6"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#520038",
  d: "M103 72.2c2.6-2 3.5-9.7 3.5-9.7s-2.5-.5-6.7-2c-4.7-2.2-12.9-4.9-17.6.9-9.5 4.4-2 20-2 20l2.7-3.1s-4-3.3-2.1-6.3c2.2-3.5 4 1 4 1s.6-2.3 3.5-3.3c.4-.7 1-2.7 1.5-3.8A1 1 0 0 1 91 65l11.5 2.7c.5.1.8.6.8 1.2l-.3 3.2z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#552950",
  d: "M101.2 76.5c0 .6-.6 1-1 1-.5-.1-.9-.7-.8-1.3.1-.6.6-1 1.1-1 .5.1.8.7.7 1.3m-7-1.4c0 .6-.5 1-1 1-.5-.1-.8-.7-.7-1.3 0-.6.6-1 1-1 .5.1.9.7.8 1.3"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#DB836E",
  d: "m99.2 73.6-.9 1.7-.3 4.3h-2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#5C2552",
  d: "M100 73.3s1.7-.7 2.4.5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#DB836E",
  d: "M81.4 73s.4-1 1-.6c.7.4 1.4 1.4.6 2s.2 1.6.2 1.6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#5C2552",
  d: "M92.3 71.7s1.9 1.1 4.2 1",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#DB836E",
  d: "M92.7 80.6s2.3 1.2 4.4 1.2m-3.4 1.4s1 .4 1.5.3M83.7 80s1.8 6.6 9.2 8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#E4EBF7",
  d: "M95.5 91.7s-1 2.8-8.2 2c-7.3-.6-10.3-5-10.3-5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M78.1 87.5s6.6 5 16.5 2.5c0 0 9.6 1 11.5 5.3 5.4 11.8.6 36.8 0 40 3.5 4-.4 8.4-.4 8.4-15.7-3.5-35.8-.6-35.8-.6-4.9-3.5-1.3-9-1.3-9l-6.2-23.8c-2.5-15.2.8-19.8 3.5-20.7 3-1 8-1.3 8-1.3.6 0 1.1 0 1.4-.2 2.4-1.3 2.8-.6 2.8-.6"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFC6A0",
  d: "M65.8 89.8s-6.8.5-7.6 8.2c-.4 8.8 3 11 3 11s6.1 22 16.9 22.9c8.4-2.2 4.7-6.7 4.6-11.4-.2-11.3-7-17-7-17s-4.3-13.7-9.9-13.7"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFC6A0",
  d: "M71.7 124.2s.9 11.3 9.8 6.5c4.8-2.5 7.6-13.8 9.8-22.6A201 201 0 0 0 94 96l-5-1.7s-2.4 5.6-7.7 12.3c-4.4 5.5-9.2 11.1-9.5 17.7"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#E4EBF7",
  d: "M108.5 105.2s1.7 2.7-2.4 30.5c2.4 2.2 1 6-.2 7.5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFC6A0",
  d: "M123.3 131.5s-.5 2.8-11.8 2c-15.2-1-25.3-3.2-25.3-3.2l.9-5.8s.7.2 9.7-.1c11.9-.4 18.7-6 25-1 4 3.2 1.5 8.1 1.5 8.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M70.2 91s-5.6-4.8-11 2.7c-3.3 7.2.5 15.2 2.6 19.5-.3 3.8 2.4 4.3 2.4 4.3s0 1 1.5 2.7c4-7 6.7-9.1 13.7-12.5-.3-.7-1.9-3.3-1.8-3.8.2-1.7-1.3-2.6-1.3-2.6s-.3-.2-1.2-2.8c-.8-2.3-2-5.1-4.9-7.5"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#CBD1D1",
  d: "M90.2 288s4.9 2.3 8.3 1.2c3.2-1 5.2.7 8 1.3a20 20 0 0 0 13.3-1.4c-.2-6.2-7.8-4.5-13.6-7.6-2.9-1.6-4.2-5.3-4-10H91.5s-1.5 12-1.3 16.5"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#2B0849",
  d: "M90.2 287.8s2.8 1.5 7.6.8c3.5-.5 3.3.6 7.5 1.3 4.2.6 13-.2 14.3-1.2.5 1.3-.4 2.4-.4 2.4s-1.7.6-5.4.9c-2.3.1-8.1.3-10.2-.6-2-1.6-4.9-1.5-6-.3-4.5 1.1-7.2-.3-7.2-.3l-.2-3z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#A4AABA",
  d: "M98.4 272.3h3.5s0 7.5 5.2 9.6c-5.3.7-9.7-2.6-8.7-9.6"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#CBD1D1",
  d: "M44.4 272s-2.2 7.8-4.7 13c-1.9 3.8-4.4 7.8 5.8 7.8 7 0 9.3-.5 7.7-7-1.6-6.3.3-13.8.3-13.8h-9z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#2B0849",
  d: "M38 290.3s2.3 1.2 7 1.2c6.4 0 8.7-1.7 8.7-1.7s.6 1.1-.7 2.2c-1 1-3.8 1.7-7.7 1.7-4.4 0-6.1-.6-7-1.3-1-.5-.8-1.6-.2-2.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#A4AABA",
  d: "M45.3 274s0 1.6-.3 3.1-1.1 3.3-1.2 4.4c0 1.2 4.8 1.6 5.4 0 .7-1.6 1.4-6.8 2-7.6.7-.9-5.1-2.2-5.9.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#7BB2F9",
  d: "M89.5 277.6h13.9s1.3-56.6 1.9-66.8c.6-10.3 4-45.1 1-65.6l-13-.7-23.7.8-1.3 10.4c0 .5-.7.9-.8 1.4 0 .6.5 1.4.4 2L59.6 206c-.1.7-1.3 1-1.5 2.8 0 .3.2 1.6.1 1.8-7.1 19.5-12.2 52.6-15.6 67.2h15.1L62 259c3-13.3 24-88.3 24-88.3l3.2-1-.2 48.6s-.2 1.3.4 2.1c.5.8-.6 1.2-.4 2.4l.4 1.8-1 12.4c-.4 4.9 1.2 40.7 1.2 40.7"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#648BD8",
  d: "M64.6 218.9c1.2 0 4.2-2.1 7.2-5.1m24.2 8.7s3-1.1 6.4-4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#648BD8",
  d: "M97 219.4s2.9-1.2 6.3-4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#648BD8",
  d: "M63.2 222.1s2.7-.6 6.7-3.5m5-72.4c-.3 3.2.3 8.8-4.5 9.4m22.8-11.3s.1 14.6-1.4 15.7c-2.3 1.7-3 2-3 2m.4-17s.3 13-1 25m-4.7.7s6.8-1 9.1-1M46 270l-.9 4.6m1.8-11.3-.8 4.1m16.6-64.9c-.3 1.6 0 2-.4 3.4 0 0-2.8 2-2.3 4s-.3 3.4-4.5 17.2c-1.8 5.8-4.3 19-6.2 28.3l-1.1 5.8m16-67-1 4.9m8.1-52.3-1.2 10.9s-1.2.1-.5 2.3c0 1.4-2.8 16.4-5.4 31.6m-20 82.1h13.9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#192064",
  d: "M106.2 142.1c-3-.5-18.8-2.7-36.2.2a.6.6 0 0 0-.6.7v3a.6.6 0 0 0 .8.6c3.3-.5 17-2.4 35.6-.3.4 0 .7-.2.7-.5.2-1.4.2-2.5.2-3a.6.6 0 0 0-.5-.7"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M96.4 145.3v-5.1a.8.8 0 0 0-.8-.9 114.1 114.1 0 0 0-8.1 0 .8.8 0 0 0-.9.8v5.1c0 .5.4.9.9.9h8a.8.8 0 0 0 .9-.8"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#192064",
  d: "M95.2 144.3v-3.2a.7.7 0 0 0-.6-.7h-6.1a.7.7 0 0 0-.6.7v3.2c0 .4.3.7.6.7h6c.4 0 .7-.3.7-.7"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#648BD8",
  d: "M90.1 273.5h12.8m-11.7-3.7v6.3m-.3-12.6v4.5m-.5-97.6 1 46.4s.7 1.6-.3 2.8c-.9 1.1 2.6.7 1 2.3-1.7 1.6.9 1.2 0 3.5-.6 1.6-1 22-1.2 36.5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#E4EBF7",
  d: "M73.7 98.7 76 103s2 .8 1.8 2.7l.8 2.2m-14.3 8.7c.2-1 2.2-7.1 12.6-10.5m.7-16s7.7 6 16.5 2.7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFC6A0",
  d: "M92 87s5.5-.9 7.5-4.6c1.3-.3.8 2.2-.3 3.7l-1 1.5s.2.3.2.9c0 .6-.2.6-.3 1v1l-.4 1c-.1.2 0 .6-.2.9-.2.4-1.6 1.8-2.6 2.8-3.8 3.6-5 1.7-6-.4-1-1.8-.7-5.1-.9-6.9-.3-2.9-2.6-3-2-4.4.4-.7 3 .7 3.4 1.8.7 2 2.9 1.8 2.6 1.7"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#DB836E",
  d: "M99.8 82.4c-.5.1-.3.3-1 1.3-.6 1-4.8 2.9-6.4 3.2-2.5.5-2.2-1.6-4.2-2.9-1.7-1-3.6-.6-1.4 1.4 1 1 1 1.1 1.4 3.2.3 1.5-.7 3.7.7 5.6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: ".8"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#E59788",
  d: "M79.5 108.7c-2 2.9-4.2 6.1-5.5 8.7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: ".8"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFC6A0",
  d: "M87.7 124.8s-2-2-5.1-2.8c-3-.7-3.6-.1-5.5.1-2 .3-4-.9-3.7.7.3 1.7 5 1 5.2 2.1.2 1.1-6.3 2.8-8.3 2.2-.8.8.5 1.9 2 2.2.3 1.5 2.3 1.5 2.3 1.5s.7 1 2.6 1.1c2.5 1.3 9-.7 11-1.5 2-.9-.5-5.6-.5-5.6"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#E59788",
  d: "M73.4 122.8s.7 1.2 3.2 1.4c2.3.3 2.6.6 2.6.6s-2.6 3-9.1 2.3m2.3 2.2s3.8 0 5-.7m-2.4 2.2s2 0 3.3-.6m-1 1.7s1.7 0 2.8-.5m-6.8-9s-.6-1.1 1.3-.5c1.7.5 2.8 0 5.1.1 1.4.1 3-.2 4 .2 1.6.8 3.6 2.2 3.6 2.2s10.6 1.2 19-1.1M79 108s-8.4 2.8-13.2 12.1",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: ".8"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#E4EBF7",
  d: "M109.3 112.5s3.4-3.6 7.6-4.6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#E59788",
  d: "M107.4 123s9.7-2.7 11.4-.9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: ".8"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#BFCDDD",
  d: "m194.6 83.7 4-4M187.2 91l3.7-3.6m.9-3-4.5-4.7m11.2 11.5-4.2-4.3m-65 76.3 3.7-3.7M122.3 170l3.5-3.5m.8-2.9-4.3-4.2M133 170l-4-4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#A3B4C6",
  d: "M190.2 211.8h-1.6a4 4 0 0 1-4-4v-32.1a4 4 0 0 1 4-4h1.6a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#A3B4C6",
  d: "M237.8 213a4.8 4.8 0 0 1-4.8 4.8h-86.6a4.8 4.8 0 0 1 0-9.6H233a4.8 4.8 0 0 1 4.8 4.8"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#A3B4C6",
  d: "M154.1 190.1h70.5v-84.6h-70.5z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#BFCDDD",
  d: "M225 190.1h-71.2a3.2 3.2 0 0 1-3.2-3.2v-19a3.2 3.2 0 0 1 3.2-3.2h71.1a3.2 3.2 0 0 1 3.2 3.2v19a3.2 3.2 0 0 1-3.2 3.2m0-59.3h-71.1a3.2 3.2 0 0 1-3.2-3.2v-19a3.2 3.2 0 0 1 3.2-3.2h71.1a3.2 3.2 0 0 1 3.2 3.3v19a3.2 3.2 0 0 1-3.2 3.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M159.6 120.5a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m48.1 0h-22.4a.8.8 0 0 1-.8-.8v-3.2c0-.4.3-.8.8-.8h22.4c.5 0 .8.4.8.8v3.2c0 .5-.3.8-.8.8"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#BFCDDD",
  d: "M225 160.5h-71.2a3.2 3.2 0 0 1-3.2-3.2v-19a3.2 3.2 0 0 1 3.2-3.2h71.1a3.2 3.2 0 0 1 3.2 3.2v19a3.2 3.2 0 0 1-3.2 3.2"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#7C90A5",
  d: "M173.5 130.8h49.3m-57.8 0h6m-15 0h6.7m11.1 29.8h49.3m-57.7 0h6m-15.8 0h6.7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M159.6 151a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m48.1 0h-22.4a.8.8 0 0 1-.8-.8V147c0-.4.3-.8.8-.8h22.4c.5 0 .8.4.8.8v3.2c0 .5-.3.8-.8.8m-63 29a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.5 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m48.1 0h-22.4a.8.8 0 0 1-.8-.8V176c0-.5.3-.8.8-.8h22.4c.5 0 .8.3.8.8v3.2c0 .4-.3.8-.8.8"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#BFCDDD",
  d: "M203 221.1h-27.3a2.4 2.4 0 0 1-2.4-2.4v-11.4a2.4 2.4 0 0 1 2.4-2.5H203a2.4 2.4 0 0 1 2.4 2.5v11.4a2.4 2.4 0 0 1-2.4 2.4"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#A3B4C6",
  d: "M177.3 207.2v11.5m23.8-11.5v11.5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#5BA02E",
  d: "M162.9 267.9a9.4 9.4 0 0 1-9.4-9.4v-14.8a9.4 9.4 0 0 1 18.8 0v14.8a9.4 9.4 0 0 1-9.4 9.4"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#92C110",
  d: "M171.2 267.8a9.4 9.4 0 0 1-9.4-9.4V255a9.4 9.4 0 0 1 18.8 0v3.4a9.4 9.4 0 0 1-9.4 9.4"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#F2D7AD",
  d: "M181.3 293.7h-27.7a3.2 3.2 0 0 1-3.2-3.2v-20.7a3.2 3.2 0 0 1 3.2-3.2h27.7a3.2 3.2 0 0 1 3.2 3.2v20.7a3.2 3.2 0 0 1-3.2 3.2"
}))));
/* harmony default export */ var serverError = (ServerError);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/result/style/index.js


// ============================== Styles ==============================
const result_style_genBaseStyle = token => {
  const {
    componentCls,
    lineHeightHeading3,
    iconCls,
    padding,
    paddingXL,
    paddingXS,
    paddingLG,
    marginXS,
    lineHeight
  } = token;
  return {
    // Result
    [componentCls]: {
      padding: `${(0,cssinjs_es/* unit */.bf)(token.calc(paddingLG).mul(2).equal())} ${(0,cssinjs_es/* unit */.bf)(paddingXL)}`,
      // RTL
      '&-rtl': {
        direction: 'rtl'
      }
    },
    // Exception Status image
    [`${componentCls} ${componentCls}-image`]: {
      width: token.imageWidth,
      height: token.imageHeight,
      margin: 'auto'
    },
    [`${componentCls} ${componentCls}-icon`]: {
      marginBottom: paddingLG,
      textAlign: 'center',
      [`& > ${iconCls}`]: {
        fontSize: token.iconFontSize
      }
    },
    [`${componentCls} ${componentCls}-title`]: {
      color: token.colorTextHeading,
      fontSize: token.titleFontSize,
      lineHeight: lineHeightHeading3,
      marginBlock: marginXS,
      textAlign: 'center'
    },
    [`${componentCls} ${componentCls}-subtitle`]: {
      color: token.colorTextDescription,
      fontSize: token.subtitleFontSize,
      lineHeight,
      textAlign: 'center'
    },
    [`${componentCls} ${componentCls}-content`]: {
      marginTop: paddingLG,
      padding: `${(0,cssinjs_es/* unit */.bf)(paddingLG)} ${(0,cssinjs_es/* unit */.bf)(token.calc(padding).mul(2.5).equal())}`,
      backgroundColor: token.colorFillAlter
    },
    [`${componentCls} ${componentCls}-extra`]: {
      margin: token.extraMargin,
      textAlign: 'center',
      '& > *': {
        marginInlineEnd: paddingXS,
        '&:last-child': {
          marginInlineEnd: 0
        }
      }
    }
  };
};
const genStatusIconStyle = token => {
  const {
    componentCls,
    iconCls
  } = token;
  return {
    [`${componentCls}-success ${componentCls}-icon > ${iconCls}`]: {
      color: token.resultSuccessIconColor
    },
    [`${componentCls}-error ${componentCls}-icon > ${iconCls}`]: {
      color: token.resultErrorIconColor
    },
    [`${componentCls}-info ${componentCls}-icon > ${iconCls}`]: {
      color: token.resultInfoIconColor
    },
    [`${componentCls}-warning ${componentCls}-icon > ${iconCls}`]: {
      color: token.resultWarningIconColor
    }
  };
};
const genResultStyle = token => [result_style_genBaseStyle(token), genStatusIconStyle(token)];
const result_style_getStyle = token => genResultStyle(token);
// ============================== Export ==============================
const result_style_prepareComponentToken = token => ({
  titleFontSize: token.fontSizeHeading3,
  subtitleFontSize: token.fontSize,
  iconFontSize: token.fontSizeHeading3 * 3,
  extraMargin: `${token.paddingLG}px 0 0 0`
});
/* harmony default export */ var result_style = (genStyleHooks('Result', token => {
  const resultInfoIconColor = token.colorInfo;
  const resultErrorIconColor = token.colorError;
  const resultSuccessIconColor = token.colorSuccess;
  const resultWarningIconColor = token.colorWarning;
  const resultToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    resultInfoIconColor,
    resultErrorIconColor,
    resultSuccessIconColor,
    resultWarningIconColor,
    imageWidth: 250,
    imageHeight: 295
  });
  return [result_style_getStyle(resultToken)];
}, result_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/result/unauthorized.js
"use client";


const Unauthorized = () => (/*#__PURE__*/react.createElement("svg", {
  width: "251",
  height: "294"
}, /*#__PURE__*/react.createElement("title", null, "Unauthorized"), /*#__PURE__*/react.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/react.createElement("path", {
  fill: "#E4EBF7",
  d: "M0 129v-2C0 58.3 55.6 2.7 124.2 2.7h2c68.6 0 124.2 55.6 124.2 124.1v2.1c0 68.6-55.6 124.2-124.1 124.2h-2.1A124.2 124.2 0 0 1 0 129"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M41.4 133a8.2 8.2 0 1 1-16.4-1.7 8.2 8.2 0 0 1 16.4 1.6"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#FFF",
  d: "m38.7 136.4 10.4 5.9m.9 6.2-12.6 10.7",
  strokeWidth: "2"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M41.5 161.3a5.6 5.6 0 1 1-11.2-1.2 5.6 5.6 0 0 1 11.2 1.2m17.7-16a5.7 5.7 0 1 1-11.3-1.2 5.7 5.7 0 0 1 11.3 1.2m41.2-115.8H130a4.6 4.6 0 1 0 0-9.1h-29.6a4.6 4.6 0 0 0 0 9.1m11.3 18.3h29.7a4.6 4.6 0 1 0 0-9.2h-29.7a4.6 4.6 0 1 0 0 9.2"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M114 29.5h15.8a4.6 4.6 0 1 0 0 9.1H114a4.6 4.6 0 0 0 0-9.1m71.3 108.2a10 10 0 1 1-19.8-2 10 10 0 0 1 19.8 2"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#FFF",
  d: "m180.2 143.8 12.5 7.1m1.1 7.5-15.1 13",
  strokeWidth: "2"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M185.6 172a6.8 6.8 0 1 1-13.6-1.4 6.8 6.8 0 0 1 13.5 1.3m18.6-16.6a6.8 6.8 0 1 1-13.6-1.4 6.8 6.8 0 0 1 13.6 1.4"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#FFF",
  d: "M153 194a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm73-75.8a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.4 0zm-9 34.9a2.2 2.2 0 1 1-4.3 0 2.2 2.2 0 0 1 4.4 0zm-39.2-43.3a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm18.3-15.3a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm6.7 88a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0z",
  strokeWidth: "2"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#FFF",
  d: "m215.1 155.3-1.9 20-10.8 6m-27.8-4.7-6.3 9.8H157l-4.5 6.4m23.4-65.5v-15.7m45.6 7.8-12.8 7.9-15.2-7.9V96.7",
  strokeWidth: "2"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#A26EF4",
  d: "M180.7 29.3a29.3 29.3 0 1 1 58.6 0 29.3 29.3 0 0 1-58.6 0"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "m221.4 41.7-21.5-.1a1.7 1.7 0 0 1-1.7-1.8V27.6a1.7 1.7 0 0 1 1.8-1.7h21.5c1 0 1.8.9 1.8 1.8l-.1 12.3a1.7 1.7 0 0 1-1.7 1.7"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M215.1 29.2c0 2.6-2 4.6-4.5 4.6a4.6 4.6 0 0 1-4.5-4.7v-6.9c0-2.6 2-4.6 4.6-4.6 2.5 0 4.5 2 4.4 4.7v6.9zm-4.5-14a6.9 6.9 0 0 0-7 6.8v7.3a6.9 6.9 0 0 0 13.8.1V22a6.9 6.9 0 0 0-6.8-6.9zm-43 53.2h-4a4.7 4.7 0 0 1-4.7-4.8 4.7 4.7 0 0 1 4.7-4.7h4a4.7 4.7 0 0 1 4.7 4.8 4.7 4.7 0 0 1-4.7 4.7"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#5BA02E",
  d: "M168.2 248.8a6.6 6.6 0 0 1-6.6-6.6v-66a6.6 6.6 0 0 1 13.2 0v66a6.6 6.6 0 0 1-6.6 6.6"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#92C110",
  d: "M176.1 248.2a6.6 6.6 0 0 1-6.6-6.6v-33a6.6 6.6 0 1 1 13.3 0v33a6.6 6.6 0 0 1-6.7 6.6"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#F2D7AD",
  d: "M186 293.9h-27.4a3.2 3.2 0 0 1-3.2-3.2v-45.9a3.2 3.2 0 0 1 3.2-3.1H186a3.2 3.2 0 0 1 3.2 3.1v46a3.2 3.2 0 0 1-3.2 3"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M82 147.7s6.3-1 17.5-1.3c11.8-.4 17.6 1 17.6 1s3.7-3.8 1-8.3c1.3-12.1 6-32.9.3-48.3-1.1-1.4-3.7-1.5-7.5-.6-1.4.3-7.2-.2-8-.1l-15.3-.4-8-.5c-1.6-.1-4.3-1.7-5.5-.3-.4.4-2.4 5.6-2 16l8.7 35.7s-3.2 3.6 1.2 7"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFC6A0",
  d: "m75.8 73.3-1-6.4 12-6.5s7.4-.1 8 1.2c.8 1.3-5.5 1-5.5 1s-1.9 1.4-2.6 2.5c-1.7 2.4-1 6.5-8.4 6-1.7.3-2.5 2.2-2.5 2.2"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFB594",
  d: "M52.4 77.7S66.7 87 77.4 92c1 .5-2 16.2-11.9 11.8-7.4-3.3-20.1-8.4-21.5-14.5-.7-3.2 2.6-7.6 8.4-11.7M142 80s-6.7 3-13.9 6.9c-3.9 2.1-10.1 4.7-12.3 8-6.2 9.3 3.5 11.2 13 7.5 6.6-2.7 29-12.1 13.2-22.4"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFC6A0",
  d: "m76.2 66.4 3 3.8S76.4 73 73 76c-7 6.2-12.8 14.3-16 16.4-4 2.7-9.7 3.3-12.2 0-3.5-5.1.5-14.7 31.5-26"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M64.7 85.1s-2.4 8.4-9 14.5c.7.5 18.6 10.5 22.2 10 5.2-.6 6.4-19 1.2-20.5-.8-.2-6-1.3-8.9-2.2-.9-.2-1.6-1.7-3.5-1l-2-.8zm63.7.7s5.3 2 7.3 13.8c-.6.2-17.6 12.3-21.8 7.8-6.6-7-.8-17.4 4.2-18.6 4.7-1.2 5-1.4 10.3-3"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#E4EBF7",
  d: "M78.2 94.7s.9 7.4-5 13",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#E4EBF7",
  d: "M87.4 94.7s3.1 2.6 10.3 2.6c7.1 0 9-3.5 9-3.5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: ".9"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFC6A0",
  d: "m117.2 68.6-6.8-6.1s-5.4-4.4-9.2-1c-3.9 3.5 4.4 2.2 5.6 4.2 1.2 2.1.9 1.2-2 .5-5.7-1.4-2.1.9 3 5.3 2 1.9 7 1 7 1l2.4-3.9z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFB594",
  d: "m105.3 91.3-.3-11H89l-.5 10.5c0 .4.2.8.6 1 2 1.3 9.3 5 15.8.4.2-.2.4-.5.4-.9"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#5C2552",
  d: "M107.6 74.2c.8-1.1 1-9 1-11.9a1 1 0 0 0-1-1l-4.6-.4c-7.7-1-17 .6-18.3 6.3-5.4 5.9-.4 13.3-.4 13.3s2 3.5 4.3 6.8c.8 1 .4-3.8 3-6a47.9 47.9 0 0 1 16-7"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFC6A0",
  d: "M88.4 83.2s2.7 6.2 11.6 6.5c7.8.3 9-7 7.5-17.5l-1-5.5c-6-2.9-15.4.6-15.4.6s-.6 2-.2 5.5c-2.3 2-1.8 5.6-1.8 5.6s-1-2-2-2.3c-.9-.3-2 0-2.3 2-1 4.6 3.6 5.1 3.6 5.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#DB836E",
  d: "m100.8 77.1 1.7-1-1-4.3.7-1.4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#552950",
  d: "M105.5 74c0 .8-.4 1.4-1 1.4-.4 0-.8-.7-.8-1.4s.5-1.2 1-1.2.9.6.8 1.3m-8 .2c0 .8-.4 1.3-.9 1.3s-.9-.6-.9-1.3c0-.7.5-1.3 1-1.3s1 .6.9 1.3"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#DB836E",
  d: "M91.1 86.8s5.3 5 12.7 2.3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#DB836E",
  d: "M99.8 81.9s-3.6.2-1.5-2.8c1.6-1.5 5-.4 5-.4s1 3.9-3.5 3.2"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#5C2552",
  d: "M102.9 70.6s2.5.8 3.4.7m-12.4.7s2.5-1.2 4.8-1.1",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#DB836E",
  d: "M86.3 77.4s1 .9 1.5 2c-.4.6-1 1.2-.3 1.9m11.8 2.4s2 .2 2.5-.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#E4EBF7",
  d: "m87.8 115.8 15.7-3m-3.3 3 10-2m-43.7-27s-1.6 8.8-6.7 14M128.3 88s3 4 4 11.7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#DB836E",
  d: "M64 84.8s-6 10-13.5 10",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: ".8"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFC6A0",
  d: "m112.4 66-.2 5.2 12 9.2c4.5 3.6 8.9 7.5 11 8.7 4.8 2.8 8.9 3.3 11 1.8 4.1-2.9 4.4-9.9-8.1-15.3-4.3-1.8-16.1-6.3-25.7-9.7"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#DB836E",
  d: "M130.5 85.5s4.6 5.7 11.7 6.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: ".8"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#E4EBF7",
  d: "M121.7 105.7s-.4 8.6-1.3 13.6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#648BD8",
  d: "M115.8 161.5s-3.6-1.5-2.7-7.1",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#CBD1D1",
  d: "M101.5 290.2s4.3 2.1 7.4 1c2.9-.9 4.6.7 7.2 1.3 2.5.5 6.9 1 11.7-1.3 0-5.6-7-4-12-6.8-2.6-1.4-3.8-4.7-3.6-8.8h-9.5s-1.4 10.6-1.2 14.6"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#2B0849",
  d: "M101.5 290s2.4 1.4 6.8.7c3-.4 3.7.5 7.5 1 3.7.6 10.8 0 11.9-.8.4 1-.4 2-.4 2s-1.5.7-4.8.9c-2 .1-5.8.3-7.7-.5-1.8-1.4-5.2-2-5.7-.3-4 1-7.4-.3-7.4-.3l-.2-2.6z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#A4AABA",
  d: "M108.8 276.2h3.1s0 6.7 4.6 8.6c-4.7.6-8.6-2.3-7.7-8.6"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#CBD1D1",
  d: "M57.6 272.5s-2 7.5-4.5 12.4c-1.8 3.7-4.2 7.6 5.5 7.6 6.7 0 9-.5 7.5-6.7-1.5-6.1.3-13.3.3-13.3h-8.8z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#2B0849",
  d: "M51.5 290s2.2 1.2 6.7 1.2c6.1 0 8.3-1.6 8.3-1.6s.6 1-.6 2.1c-1 .9-3.6 1.6-7.4 1.6-4.2 0-6-.6-6.8-1.2-.9-.5-.7-1.6-.2-2"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#A4AABA",
  d: "M58.5 274.4s0 1.6-.3 3-1 3.1-1.1 4.2c0 1.1 4.5 1.5 5.2 0 .6-1.6 1.3-6.5 1.9-7.3.6-.8-5-2.1-5.7.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#7BB2F9",
  d: "m100.9 277 13.3.1s1.3-54.2 1.8-64c.6-9.9 3.8-43.2 1-62.8l-12.4-.7-22.8.8-1.2 10c0 .4-.6.8-.7 1.3 0 .6.4 1.3.3 2-2.3 14-6.3 32.9-8.7 46.4-.1.6-1.2 1-1.4 2.6 0 .3.2 1.6 0 1.8-6.8 18.7-10.8 47.6-14.1 61.6h14.5s2.2-8.6 4-17a3984 3984 0 0 1 23-84.5l3-.5 1 46.1s-.2 1.2.4 2c.5.8-.6 1.1-.4 2.3l.4 1.7-1 11.9c-.4 4.6 0 39 0 39"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#648BD8",
  d: "M77.4 220.4c1.2.1 4-2 7-4.9m23.1 8.4s2.8-1 6.1-3.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#648BD8",
  d: "M108.5 221s2.7-1.2 6-4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#648BD8",
  d: "M76.1 223.6s2.6-.6 6.5-3.4m4.7-69.4c-.2 3.1.3 8.5-4.3 9m21.8-10.7s.1 14-1.3 15c-2.2 1.6-3 1.9-3 1.9m.5-16.4s0 12.8-1.2 24.3m-4.9 1s7.2-1.6 9.4-1.6m-28.6 31.5-1 4.5s-1.5 1.8-1 3.7c.4 2-1 2-5 15.3-1.7 5.6-4.4 18.5-6.3 27.5l-4 18.4M77 196.7a313.3 313.3 0 0 1-.8 4.8m7.7-50-1.2 10.3s-1 .2-.5 2.3c.1 1.3-2.6 15.6-5.1 30.2M57.6 273h13.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#192064",
  d: "M117.4 147.4s-17-3-35.7.2v4.2s14.6-2.9 35.5-.4l.2-4"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M107.5 150.4v-5a.8.8 0 0 0-.8-.7H99a.8.8 0 0 0-.7.8v4.8c0 .5.3.9.8.8a140.8 140.8 0 0 1 7.7 0 .8.8 0 0 0 .8-.7"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#192064",
  d: "M106.4 149.4v-3a.6.6 0 0 0-.6-.7 94.1 94.1 0 0 0-5.8 0 .6.6 0 0 0-.7.7v3c0 .4.3.7.7.7h5.7c.4 0 .7-.3.7-.7"
}), /*#__PURE__*/react.createElement("path", {
  stroke: "#648BD8",
  d: "M101.5 274h12.3m-11.1-5v6.5m0-12.4v4.3m-.5-93.4.9 44.4s.7 1.6-.2 2.7c-1 1.1 2.4.7.9 2.2-1.6 1.6.9 1.1 0 3.4-.6 1.5-1 21-1.1 35",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}))));
/* harmony default export */ var unauthorized = (Unauthorized);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/result/index.js
"use client";













const IconMap = {
  success: CheckCircleFilled/* default */.Z,
  error: CloseCircleFilled/* default */.Z,
  info: ExclamationCircleFilled/* default */.Z,
  warning: icons_WarningFilled
};
const ExceptionMap = {
  '404': noFound,
  '500': serverError,
  '403': unauthorized
};
// ExceptionImageMap keys
const ExceptionStatus = Object.keys(ExceptionMap);
const Icon = ({
  prefixCls,
  icon,
  status
}) => {
  const className = classnames_default()(`${prefixCls}-icon`);
  if (false) {}
  if (ExceptionStatus.includes(`${status}`)) {
    const SVGComponent = ExceptionMap[status];
    return /*#__PURE__*/react.createElement("div", {
      className: `${className} ${prefixCls}-image`
    }, /*#__PURE__*/react.createElement(SVGComponent, null));
  }
  const iconNode = /*#__PURE__*/react.createElement(IconMap[status]);
  if (icon === null || icon === false) {
    return null;
  }
  return /*#__PURE__*/react.createElement("div", {
    className: className
  }, icon || iconNode);
};
const Extra = ({
  prefixCls,
  extra
}) => {
  if (!extra) {
    return null;
  }
  return /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-extra`
  }, extra);
};
const Result = ({
  prefixCls: customizePrefixCls,
  className: customizeClassName,
  rootClassName,
  subTitle,
  title,
  style,
  children,
  status = 'info',
  icon,
  extra
}) => {
  const {
    getPrefixCls,
    direction,
    result
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('result', customizePrefixCls);
  // Style
  const [wrapCSSVar, hashId, cssVarCls] = result_style(prefixCls);
  const className = classnames_default()(prefixCls, `${prefixCls}-${status}`, customizeClassName, result === null || result === void 0 ? void 0 : result.className, rootClassName, {
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, hashId, cssVarCls);
  const mergedStyle = Object.assign(Object.assign({}, result === null || result === void 0 ? void 0 : result.style), style);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    className: className,
    style: mergedStyle
  }, /*#__PURE__*/react.createElement(Icon, {
    prefixCls: prefixCls,
    status: status,
    icon: icon
  }), /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-title`
  }, title), subTitle && /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-subtitle`
  }, subTitle), /*#__PURE__*/react.createElement(Extra, {
    prefixCls: prefixCls,
    extra: extra
  }), children && /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-content`
  }, children)));
};
Result.PRESENTED_IMAGE_403 = ExceptionMap['403'];
Result.PRESENTED_IMAGE_404 = ExceptionMap['404'];
Result.PRESENTED_IMAGE_500 = ExceptionMap['500'];
if (false) {}
/* harmony default export */ var result = (Result);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/row/index.js
"use client";


/* harmony default export */ var es_row = (row);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/statistic/Number.js
"use client";


const StatisticNumber = props => {
  const {
    value,
    formatter,
    precision,
    decimalSeparator,
    groupSeparator = '',
    prefixCls
  } = props;
  let valueNode;
  if (typeof formatter === 'function') {
    // Customize formatter
    valueNode = formatter(value);
  } else {
    // Internal formatter
    const val = String(value);
    const cells = val.match(/^(-?)(\d*)(\.(\d+))?$/);
    // Process if illegal number
    if (!cells || val === '-') {
      valueNode = val;
    } else {
      const negative = cells[1];
      let int = cells[2] || '0';
      let decimal = cells[4] || '';
      int = int.replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator);
      if (typeof precision === 'number') {
        decimal = decimal.padEnd(precision, '0').slice(0, precision > 0 ? precision : 0);
      }
      if (decimal) {
        decimal = `${decimalSeparator}${decimal}`;
      }
      valueNode = [/*#__PURE__*/react.createElement("span", {
        key: "int",
        className: `${prefixCls}-content-value-int`
      }, negative, int), decimal && (/*#__PURE__*/react.createElement("span", {
        key: "decimal",
        className: `${prefixCls}-content-value-decimal`
      }, decimal))];
    }
  }
  return /*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-content-value`
  }, valueNode);
};
/* harmony default export */ var statistic_Number = (StatisticNumber);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/statistic/style/index.js


const genStatisticStyle = token => {
  const {
    componentCls,
    marginXXS,
    padding,
    colorTextDescription,
    titleFontSize,
    colorTextHeading,
    contentFontSize,
    fontFamily
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      [`${componentCls}-title`]: {
        marginBottom: marginXXS,
        color: colorTextDescription,
        fontSize: titleFontSize
      },
      [`${componentCls}-skeleton`]: {
        paddingTop: padding
      },
      [`${componentCls}-content`]: {
        color: colorTextHeading,
        fontSize: contentFontSize,
        fontFamily,
        [`${componentCls}-content-value`]: {
          display: 'inline-block',
          direction: 'ltr'
        },
        [`${componentCls}-content-prefix, ${componentCls}-content-suffix`]: {
          display: 'inline-block'
        },
        [`${componentCls}-content-prefix`]: {
          marginInlineEnd: marginXXS
        },
        [`${componentCls}-content-suffix`]: {
          marginInlineStart: marginXXS
        }
      }
    })
  };
};
// ============================== Export ==============================
const statistic_style_prepareComponentToken = token => {
  const {
    fontSizeHeading3,
    fontSize
  } = token;
  return {
    titleFontSize: fontSize,
    contentFontSize: fontSizeHeading3
  };
};
/* harmony default export */ var statistic_style = (genStyleHooks('Statistic', token => {
  const statisticToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {});
  return genStatisticStyle(statisticToken);
}, statistic_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/statistic/Statistic.js
"use client";

var Statistic_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







const Statistic = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      style,
      valueStyle,
      value = 0,
      title,
      valueRender,
      prefix,
      suffix,
      loading = false,
      /* --- FormatConfig starts --- */
      formatter,
      precision,
      decimalSeparator = '.',
      groupSeparator = ',',
      /* --- FormatConfig starts --- */
      onMouseEnter,
      onMouseLeave
    } = props,
    rest = Statistic_rest(props, ["prefixCls", "className", "rootClassName", "style", "valueStyle", "value", "title", "valueRender", "prefix", "suffix", "loading", "formatter", "precision", "decimalSeparator", "groupSeparator", "onMouseEnter", "onMouseLeave"]);
  const {
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle
  } = useComponentConfig('statistic');
  const prefixCls = getPrefixCls('statistic', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = statistic_style(prefixCls);
  const valueNode = /*#__PURE__*/react.createElement(statistic_Number, {
    decimalSeparator: decimalSeparator,
    groupSeparator: groupSeparator,
    prefixCls: prefixCls,
    formatter: formatter,
    precision: precision,
    value: value
  });
  const cls = classnames_default()(prefixCls, {
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, contextClassName, className, rootClassName, hashId, cssVarCls);
  const internalRef = react.useRef(null);
  react.useImperativeHandle(ref, () => ({
    nativeElement: internalRef.current
  }));
  const restProps = (0,pickAttrs/* default */.Z)(rest, {
    aria: true,
    data: true
  });
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", Object.assign({}, restProps, {
    ref: internalRef,
    className: cls,
    style: Object.assign(Object.assign({}, contextStyle), style),
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }), title && /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-title`
  }, title), /*#__PURE__*/react.createElement(skeleton, {
    paragraph: false,
    loading: loading,
    className: `${prefixCls}-skeleton`
  }, /*#__PURE__*/react.createElement("div", {
    style: valueStyle,
    className: `${prefixCls}-content`
  }, prefix && /*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-content-prefix`
  }, prefix), valueRender ? valueRender(valueNode) : valueNode, suffix && /*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-content-suffix`
  }, suffix)))));
});
if (false) {}
/* harmony default export */ var statistic_Statistic = (Statistic);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/statistic/utils.js
// Countdown
const timeUnits = [['Y', 1000 * 60 * 60 * 24 * 365],
// years
['M', 1000 * 60 * 60 * 24 * 30],
// months
['D', 1000 * 60 * 60 * 24],
// days
['H', 1000 * 60 * 60],
// hours
['m', 1000 * 60],
// minutes
['s', 1000],
// seconds
['S', 1] // million seconds
];
function formatTimeStr(duration, format) {
  let leftDuration = duration;
  const escapeRegex = /\[[^\]]*]/g;
  const keepList = (format.match(escapeRegex) || []).map(str => str.slice(1, -1));
  const templateText = format.replace(escapeRegex, '[]');
  const replacedText = timeUnits.reduce((current, [name, unit]) => {
    if (current.includes(name)) {
      const value = Math.floor(leftDuration / unit);
      leftDuration -= value * unit;
      return current.replace(new RegExp(`${name}+`, 'g'), match => {
        const len = match.length;
        return value.toString().padStart(len, '0');
      });
    }
    return current;
  }, templateText);
  let index = 0;
  return replacedText.replace(escapeRegex, () => {
    const match = keepList[index];
    index += 1;
    return match;
  });
}
function formatCounter(value, config, down) {
  const {
    format = ''
  } = config;
  const target = new Date(value).getTime();
  const current = Date.now();
  const diff = down ? Math.max(target - current, 0) : Math.max(current - target, 0);
  return formatTimeStr(diff, format);
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/statistic/Timer.js
"use client";

var Timer_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






function getTime(value) {
  return new Date(value).getTime();
}
const StatisticTimer = props => {
  const {
      value,
      format = 'HH:mm:ss',
      onChange,
      onFinish,
      type
    } = props,
    rest = Timer_rest(props, ["value", "format", "onChange", "onFinish", "type"]);
  const down = type === 'countdown';
  // We reuse state here to do same as `forceUpdate`
  const [showTime, setShowTime] = react.useState(null);
  // ======================== Update ========================
  const update = (0,rc_util_es/* useEvent */.zX)(() => {
    const now = Date.now();
    const timestamp = getTime(value);
    setShowTime({});
    const timeDiff = !down ? now - timestamp : timestamp - now;
    onChange === null || onChange === void 0 ? void 0 : onChange(timeDiff);
    // Only countdown will trigger `onFinish`
    if (down && timestamp < now) {
      onFinish === null || onFinish === void 0 ? void 0 : onFinish();
      return false;
    }
    return true;
  });
  // Effect trigger
  react.useEffect(() => {
    let rafId;
    const clear = () => raf/* default.cancel */.Z.cancel(rafId);
    const rafUpdate = () => {
      rafId = (0,raf/* default */.Z)(() => {
        if (update()) {
          rafUpdate();
        }
      });
    };
    rafUpdate();
    return clear;
  }, [value, down]);
  react.useEffect(() => {
    setShowTime({});
  }, []);
  // ======================== Format ========================
  const formatter = (formatValue, config) => showTime ? formatCounter(formatValue, Object.assign(Object.assign({}, config), {
    format
  }), down) : '-';
  const valueRender = node => cloneElement(node, {
    title: undefined
  });
  // ======================== Render ========================
  return /*#__PURE__*/react.createElement(statistic_Statistic, Object.assign({}, rest, {
    value: value,
    valueRender: valueRender,
    formatter: formatter
  }));
};
/* harmony default export */ var Timer = (StatisticTimer);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/statistic/Countdown.js
"use client";




const Countdown = props => {
  if (false) {}
  return /*#__PURE__*/react.createElement(Timer, Object.assign({}, props, {
    type: "countdown"
  }));
};
/* harmony default export */ var statistic_Countdown = (/*#__PURE__*/react.memo(Countdown));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/statistic/index.js
"use client";




statistic_Statistic.Timer = Timer;
statistic_Statistic.Countdown = statistic_Countdown;
/* harmony default export */ var statistic = (statistic_Statistic);
;// CONCATENATED MODULE: ./node_modules/rc-steps/es/Step.js




var Step_excluded = ["className", "prefixCls", "style", "active", "status", "iconPrefix", "icon", "wrapperStyle", "stepNumber", "disabled", "description", "title", "subTitle", "progressDot", "stepIcon", "tailContent", "icons", "stepIndex", "onStepClick", "onClick", "render"];
/* eslint react/prop-types: 0 */



function Step_isString(str) {
  return typeof str === 'string';
}
function Step(props) {
  var _classNames2;
  var className = props.className,
    prefixCls = props.prefixCls,
    style = props.style,
    active = props.active,
    status = props.status,
    iconPrefix = props.iconPrefix,
    icon = props.icon,
    wrapperStyle = props.wrapperStyle,
    stepNumber = props.stepNumber,
    disabled = props.disabled,
    description = props.description,
    title = props.title,
    subTitle = props.subTitle,
    progressDot = props.progressDot,
    stepIcon = props.stepIcon,
    tailContent = props.tailContent,
    icons = props.icons,
    stepIndex = props.stepIndex,
    onStepClick = props.onStepClick,
    onClick = props.onClick,
    render = props.render,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, Step_excluded);

  // ========================= Click ==========================
  var clickable = !!onStepClick && !disabled;
  var accessibilityProps = {};
  if (clickable) {
    accessibilityProps.role = 'button';
    accessibilityProps.tabIndex = 0;
    accessibilityProps.onClick = function (e) {
      onClick === null || onClick === void 0 ? void 0 : onClick(e);
      onStepClick(stepIndex);
    };
    accessibilityProps.onKeyDown = function (e) {
      var which = e.which;
      if (which === KeyCode/* default.ENTER */.Z.ENTER || which === KeyCode/* default.SPACE */.Z.SPACE) {
        onStepClick(stepIndex);
      }
    };
  }

  // ========================= Render =========================
  var renderIconNode = function renderIconNode() {
    var _classNames;
    var iconNode;
    var iconClassName = classnames_default()("".concat(prefixCls, "-icon"), "".concat(iconPrefix, "icon"), (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(iconPrefix, "icon-").concat(icon), icon && Step_isString(icon)), (0,defineProperty/* default */.Z)(_classNames, "".concat(iconPrefix, "icon-check"), !icon && status === 'finish' && (icons && !icons.finish || !icons)), (0,defineProperty/* default */.Z)(_classNames, "".concat(iconPrefix, "icon-cross"), !icon && status === 'error' && (icons && !icons.error || !icons)), _classNames));
    var iconDot = /*#__PURE__*/react.createElement("span", {
      className: "".concat(prefixCls, "-icon-dot")
    });
    // `progressDot` enjoy the highest priority
    if (progressDot) {
      if (typeof progressDot === 'function') {
        iconNode = /*#__PURE__*/react.createElement("span", {
          className: "".concat(prefixCls, "-icon")
        }, progressDot(iconDot, {
          index: stepNumber - 1,
          status: status,
          title: title,
          description: description
        }));
      } else {
        iconNode = /*#__PURE__*/react.createElement("span", {
          className: "".concat(prefixCls, "-icon")
        }, iconDot);
      }
    } else if (icon && !Step_isString(icon)) {
      iconNode = /*#__PURE__*/react.createElement("span", {
        className: "".concat(prefixCls, "-icon")
      }, icon);
    } else if (icons && icons.finish && status === 'finish') {
      iconNode = /*#__PURE__*/react.createElement("span", {
        className: "".concat(prefixCls, "-icon")
      }, icons.finish);
    } else if (icons && icons.error && status === 'error') {
      iconNode = /*#__PURE__*/react.createElement("span", {
        className: "".concat(prefixCls, "-icon")
      }, icons.error);
    } else if (icon || status === 'finish' || status === 'error') {
      iconNode = /*#__PURE__*/react.createElement("span", {
        className: iconClassName
      });
    } else {
      iconNode = /*#__PURE__*/react.createElement("span", {
        className: "".concat(prefixCls, "-icon")
      }, stepNumber);
    }
    if (stepIcon) {
      iconNode = stepIcon({
        index: stepNumber - 1,
        status: status,
        title: title,
        description: description,
        node: iconNode
      });
    }
    return iconNode;
  };
  var mergedStatus = status || 'wait';
  var classString = classnames_default()("".concat(prefixCls, "-item"), "".concat(prefixCls, "-item-").concat(mergedStatus), className, (_classNames2 = {}, (0,defineProperty/* default */.Z)(_classNames2, "".concat(prefixCls, "-item-custom"), icon), (0,defineProperty/* default */.Z)(_classNames2, "".concat(prefixCls, "-item-active"), active), (0,defineProperty/* default */.Z)(_classNames2, "".concat(prefixCls, "-item-disabled"), disabled === true), _classNames2));
  var stepItemStyle = (0,objectSpread2/* default */.Z)({}, style);
  var stepNode = /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, restProps, {
    className: classString,
    style: stepItemStyle
  }), /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    onClick: onClick
  }, accessibilityProps, {
    className: "".concat(prefixCls, "-item-container")
  }), /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-item-tail")
  }, tailContent), /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-item-icon")
  }, renderIconNode()), /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-item-content")
  }, /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-item-title")
  }, title, subTitle && /*#__PURE__*/react.createElement("div", {
    title: typeof subTitle === 'string' ? subTitle : undefined,
    className: "".concat(prefixCls, "-item-subtitle")
  }, subTitle)), description && /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-item-description")
  }, description))));
  if (render) {
    stepNode = render(stepNode) || null;
  }
  return stepNode;
}
/* harmony default export */ var es_Step = (Step);
;// CONCATENATED MODULE: ./node_modules/rc-steps/es/Steps.js




var Steps_excluded = ["prefixCls", "style", "className", "children", "direction", "type", "labelPlacement", "iconPrefix", "status", "size", "current", "progressDot", "stepIcon", "initial", "icons", "onChange", "itemRender", "items"];
/* eslint react/no-did-mount-set-state: 0, react/prop-types: 0 */



function es_Steps_Steps(props) {
  var _classNames;
  var _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-steps' : _props$prefixCls,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    className = props.className,
    children = props.children,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'horizontal' : _props$direction,
    _props$type = props.type,
    type = _props$type === void 0 ? 'default' : _props$type,
    _props$labelPlacement = props.labelPlacement,
    labelPlacement = _props$labelPlacement === void 0 ? 'horizontal' : _props$labelPlacement,
    _props$iconPrefix = props.iconPrefix,
    iconPrefix = _props$iconPrefix === void 0 ? 'rc' : _props$iconPrefix,
    _props$status = props.status,
    status = _props$status === void 0 ? 'process' : _props$status,
    size = props.size,
    _props$current = props.current,
    current = _props$current === void 0 ? 0 : _props$current,
    _props$progressDot = props.progressDot,
    progressDot = _props$progressDot === void 0 ? false : _props$progressDot,
    stepIcon = props.stepIcon,
    _props$initial = props.initial,
    initial = _props$initial === void 0 ? 0 : _props$initial,
    icons = props.icons,
    onChange = props.onChange,
    itemRender = props.itemRender,
    _props$items = props.items,
    items = _props$items === void 0 ? [] : _props$items,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, Steps_excluded);
  var isNav = type === 'navigation';
  var isInline = type === 'inline';

  // inline type requires fixed progressDot direction size.
  var mergedProgressDot = isInline || progressDot;
  var mergedDirection = isInline ? 'horizontal' : direction;
  var mergedSize = isInline ? undefined : size;
  var adjustedLabelPlacement = mergedProgressDot ? 'vertical' : labelPlacement;
  var classString = classnames_default()(prefixCls, "".concat(prefixCls, "-").concat(mergedDirection), className, (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-").concat(mergedSize), mergedSize), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-label-").concat(adjustedLabelPlacement), mergedDirection === 'horizontal'), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-dot"), !!mergedProgressDot), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-navigation"), isNav), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-inline"), isInline), _classNames));
  var onStepClick = function onStepClick(next) {
    if (onChange && current !== next) {
      onChange(next);
    }
  };
  var renderStep = function renderStep(item, index) {
    var mergedItem = (0,objectSpread2/* default */.Z)({}, item);
    var stepNumber = initial + index;
    // fix tail color
    if (status === 'error' && index === current - 1) {
      mergedItem.className = "".concat(prefixCls, "-next-error");
    }
    if (!mergedItem.status) {
      if (stepNumber === current) {
        mergedItem.status = status;
      } else if (stepNumber < current) {
        mergedItem.status = 'finish';
      } else {
        mergedItem.status = 'wait';
      }
    }
    if (isInline) {
      mergedItem.icon = undefined;
      mergedItem.subTitle = undefined;
    }
    if (!mergedItem.render && itemRender) {
      mergedItem.render = function (stepItem) {
        return itemRender(mergedItem, stepItem);
      };
    }
    return /*#__PURE__*/react.createElement(es_Step, (0,esm_extends/* default */.Z)({}, mergedItem, {
      active: stepNumber === current,
      stepNumber: stepNumber + 1,
      stepIndex: stepNumber,
      key: stepNumber,
      prefixCls: prefixCls,
      iconPrefix: iconPrefix,
      wrapperStyle: style,
      progressDot: mergedProgressDot,
      stepIcon: stepIcon,
      icons: icons,
      onStepClick: onChange && onStepClick
    }));
  };
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    className: classString,
    style: style
  }, restProps), items.filter(function (item) {
    return item;
  }).map(renderStep));
}
es_Steps_Steps.Step = es_Step;
/* harmony default export */ var rc_steps_es_Steps = (es_Steps_Steps);
;// CONCATENATED MODULE: ./node_modules/rc-steps/es/index.js



/* harmony default export */ var rc_steps_es = (rc_steps_es_Steps);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/steps/style/custom-icon.js

const genStepsCustomIconStyle = token => {
  const {
    componentCls,
    customIconTop,
    customIconSize,
    customIconFontSize
  } = token;
  return {
    [`${componentCls}-item-custom`]: {
      [`> ${componentCls}-item-container > ${componentCls}-item-icon`]: {
        height: 'auto',
        background: 'none',
        border: 0,
        [`> ${componentCls}-icon`]: {
          top: customIconTop,
          width: customIconSize,
          height: customIconSize,
          fontSize: customIconFontSize,
          lineHeight: (0,cssinjs_es/* unit */.bf)(customIconSize)
        }
      }
    },
    // Only adjust horizontal customize icon width
    [`&:not(${componentCls}-vertical)`]: {
      [`${componentCls}-item-custom`]: {
        [`${componentCls}-item-icon`]: {
          width: 'auto',
          background: 'none'
        }
      }
    }
  };
};
/* harmony default export */ var custom_icon = (genStepsCustomIconStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/steps/style/horizontal.js
const horizontal_genHorizontalStyle = token => {
  const {
    componentCls
  } = token;
  const stepsItemCls = `${componentCls}-item`; // .ant-steps-item
  return {
    [`${componentCls}-horizontal`]: {
      [`${stepsItemCls}-tail`]: {
        transform: 'translateY(-50%)'
      }
    }
  };
};
/* harmony default export */ var style_horizontal = (horizontal_genHorizontalStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/steps/style/inline.js

const genStepsInlineStyle = token => {
  const {
    componentCls,
    inlineDotSize,
    inlineTitleColor,
    inlineTailColor
  } = token;
  const containerPaddingTop = token.calc(token.paddingXS).add(token.lineWidth).equal();
  const titleStyle = {
    [`${componentCls}-item-container ${componentCls}-item-content ${componentCls}-item-title`]: {
      color: inlineTitleColor
    }
  };
  return {
    [`&${componentCls}-inline`]: {
      width: 'auto',
      display: 'inline-flex',
      [`${componentCls}-item`]: {
        flex: 'none',
        '&-container': {
          padding: `${(0,cssinjs_es/* unit */.bf)(containerPaddingTop)} ${(0,cssinjs_es/* unit */.bf)(token.paddingXXS)} 0`,
          margin: `0 ${(0,cssinjs_es/* unit */.bf)(token.calc(token.marginXXS).div(2).equal())}`,
          borderRadius: token.borderRadiusSM,
          cursor: 'pointer',
          transition: `background-color ${token.motionDurationMid}`,
          '&:hover': {
            background: token.controlItemBgHover
          },
          "&[role='button']:hover": {
            opacity: 1
          }
        },
        '&-icon': {
          width: inlineDotSize,
          height: inlineDotSize,
          marginInlineStart: `calc(50% - ${(0,cssinjs_es/* unit */.bf)(token.calc(inlineDotSize).div(2).equal())})`,
          [`> ${componentCls}-icon`]: {
            top: 0
          },
          [`${componentCls}-icon-dot`]: {
            borderRadius: token.calc(token.fontSizeSM).div(4).equal(),
            '&::after': {
              display: 'none'
            }
          }
        },
        '&-content': {
          width: 'auto',
          marginTop: token.calc(token.marginXS).sub(token.lineWidth).equal()
        },
        '&-title': {
          color: inlineTitleColor,
          fontSize: token.fontSizeSM,
          lineHeight: token.lineHeightSM,
          fontWeight: 'normal',
          marginBottom: token.calc(token.marginXXS).div(2).equal()
        },
        '&-description': {
          display: 'none'
        },
        '&-tail': {
          marginInlineStart: 0,
          top: token.calc(inlineDotSize).div(2).add(containerPaddingTop).equal(),
          transform: `translateY(-50%)`,
          '&:after': {
            width: '100%',
            height: token.lineWidth,
            borderRadius: 0,
            marginInlineStart: 0,
            background: inlineTailColor
          }
        },
        [`&:first-child ${componentCls}-item-tail`]: {
          width: '50%',
          marginInlineStart: '50%'
        },
        [`&:last-child ${componentCls}-item-tail`]: {
          display: 'block',
          width: '50%'
        },
        '&-wait': Object.assign({
          [`${componentCls}-item-icon ${componentCls}-icon ${componentCls}-icon-dot`]: {
            backgroundColor: token.colorBorderBg,
            border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${inlineTailColor}`
          }
        }, titleStyle),
        '&-finish': Object.assign({
          [`${componentCls}-item-tail::after`]: {
            backgroundColor: inlineTailColor
          },
          [`${componentCls}-item-icon ${componentCls}-icon ${componentCls}-icon-dot`]: {
            backgroundColor: inlineTailColor,
            border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${inlineTailColor}`
          }
        }, titleStyle),
        '&-error': titleStyle,
        '&-active, &-process': Object.assign({
          [`${componentCls}-item-icon`]: {
            width: inlineDotSize,
            height: inlineDotSize,
            marginInlineStart: `calc(50% - ${(0,cssinjs_es/* unit */.bf)(token.calc(inlineDotSize).div(2).equal())})`,
            top: 0
          }
        }, titleStyle),
        [`&:not(${componentCls}-item-active) > ${componentCls}-item-container[role='button']:hover`]: {
          [`${componentCls}-item-title`]: {
            color: inlineTitleColor
          }
        }
      }
    }
  };
};
/* harmony default export */ var inline = (genStepsInlineStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/steps/style/label-placement.js

const genStepsLabelPlacementStyle = token => {
  const {
    componentCls,
    iconSize,
    lineHeight,
    iconSizeSM
  } = token;
  return {
    [`&${componentCls}-label-vertical`]: {
      [`${componentCls}-item`]: {
        overflow: 'visible',
        '&-tail': {
          marginInlineStart: token.calc(iconSize).div(2).add(token.controlHeightLG).equal(),
          padding: `0 ${(0,cssinjs_es/* unit */.bf)(token.paddingLG)}`
        },
        '&-content': {
          display: 'block',
          width: token.calc(iconSize).div(2).add(token.controlHeightLG).mul(2).equal(),
          marginTop: token.marginSM,
          textAlign: 'center'
        },
        '&-icon': {
          display: 'inline-block',
          marginInlineStart: token.controlHeightLG
        },
        '&-title': {
          paddingInlineEnd: 0,
          paddingInlineStart: 0,
          '&::after': {
            display: 'none'
          }
        },
        '&-subtitle': {
          display: 'block',
          marginBottom: token.marginXXS,
          marginInlineStart: 0,
          lineHeight
        }
      },
      [`&${componentCls}-small:not(${componentCls}-dot)`]: {
        [`${componentCls}-item`]: {
          '&-icon': {
            marginInlineStart: token.calc(iconSize).sub(iconSizeSM).div(2).add(token.controlHeightLG).equal()
          }
        }
      }
    }
  };
};
/* harmony default export */ var label_placement = (genStepsLabelPlacementStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/steps/style/nav.js


const genStepsNavStyle = token => {
  const {
    componentCls,
    navContentMaxWidth,
    navArrowColor,
    stepsNavActiveColor,
    motionDurationSlow
  } = token;
  return {
    [`&${componentCls}-navigation`]: {
      paddingTop: token.paddingSM,
      [`&${componentCls}-small`]: {
        [`${componentCls}-item`]: {
          '&-container': {
            marginInlineStart: token.calc(token.marginSM).mul(-1).equal()
          }
        }
      },
      [`${componentCls}-item`]: {
        overflow: 'visible',
        textAlign: 'center',
        '&-container': {
          display: 'inline-block',
          height: '100%',
          marginInlineStart: token.calc(token.margin).mul(-1).equal(),
          paddingBottom: token.paddingSM,
          textAlign: 'start',
          transition: `opacity ${motionDurationSlow}`,
          [`${componentCls}-item-content`]: {
            maxWidth: navContentMaxWidth
          },
          [`${componentCls}-item-title`]: Object.assign(Object.assign({
            maxWidth: '100%',
            paddingInlineEnd: 0
          }, textEllipsis), {
            '&::after': {
              display: 'none'
            }
          })
        },
        [`&:not(${componentCls}-item-active)`]: {
          [`${componentCls}-item-container[role='button']`]: {
            cursor: 'pointer',
            '&:hover': {
              opacity: 0.85
            }
          }
        },
        '&:last-child': {
          flex: 1,
          '&::after': {
            display: 'none'
          }
        },
        '&::after': {
          position: 'absolute',
          top: `calc(50% - ${(0,cssinjs_es/* unit */.bf)(token.calc(token.paddingSM).div(2).equal())})`,
          insetInlineStart: '100%',
          display: 'inline-block',
          width: token.fontSizeIcon,
          height: token.fontSizeIcon,
          borderTop: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${navArrowColor}`,
          borderBottom: 'none',
          borderInlineStart: 'none',
          borderInlineEnd: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${navArrowColor}`,
          transform: 'translateY(-50%) translateX(-50%) rotate(45deg)',
          content: '""'
        },
        '&::before': {
          position: 'absolute',
          bottom: 0,
          insetInlineStart: '50%',
          display: 'inline-block',
          width: 0,
          height: token.lineWidthBold,
          backgroundColor: stepsNavActiveColor,
          transition: `width ${motionDurationSlow}, inset-inline-start ${motionDurationSlow}`,
          transitionTimingFunction: 'ease-out',
          content: '""'
        }
      },
      [`${componentCls}-item${componentCls}-item-active::before`]: {
        insetInlineStart: 0,
        width: '100%'
      }
    },
    [`&${componentCls}-navigation${componentCls}-vertical`]: {
      [`> ${componentCls}-item`]: {
        marginInlineEnd: 0,
        '&::before': {
          display: 'none'
        },
        [`&${componentCls}-item-active::before`]: {
          top: 0,
          insetInlineEnd: 0,
          insetInlineStart: 'unset',
          display: 'block',
          width: token.calc(token.lineWidth).mul(3).equal(),
          height: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(token.marginLG)})`
        },
        '&::after': {
          position: 'relative',
          insetInlineStart: '50%',
          display: 'block',
          width: token.calc(token.controlHeight).mul(0.25).equal(),
          height: token.calc(token.controlHeight).mul(0.25).equal(),
          marginBottom: token.marginXS,
          textAlign: 'center',
          transform: 'translateY(-50%) translateX(-50%) rotate(135deg)'
        },
        '&:last-child': {
          '&::after': {
            display: 'none'
          }
        },
        [`> ${componentCls}-item-container > ${componentCls}-item-tail`]: {
          visibility: 'hidden'
        }
      }
    },
    [`&${componentCls}-navigation${componentCls}-horizontal`]: {
      [`> ${componentCls}-item > ${componentCls}-item-container > ${componentCls}-item-tail`]: {
        visibility: 'hidden'
      }
    }
  };
};
/* harmony default export */ var nav = (genStepsNavStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/steps/style/progress.js

const genStepsProgressStyle = token => {
  const {
    antCls,
    componentCls,
    iconSize,
    iconSizeSM,
    processIconColor,
    marginXXS,
    lineWidthBold,
    lineWidth,
    paddingXXS
  } = token;
  const progressSize = token.calc(iconSize).add(token.calc(lineWidthBold).mul(4).equal()).equal();
  const progressSizeSM = token.calc(iconSizeSM).add(token.calc(token.lineWidth).mul(4).equal()).equal();
  return {
    [`&${componentCls}-with-progress`]: {
      [`${componentCls}-item`]: {
        paddingTop: paddingXXS,
        [`&-process ${componentCls}-item-container ${componentCls}-item-icon ${componentCls}-icon`]: {
          color: processIconColor
        }
      },
      [`&${componentCls}-vertical > ${componentCls}-item `]: {
        paddingInlineStart: paddingXXS,
        [`> ${componentCls}-item-container > ${componentCls}-item-tail`]: {
          top: marginXXS,
          insetInlineStart: token.calc(iconSize).div(2).sub(lineWidth).add(paddingXXS).equal()
        }
      },
      [`&, &${componentCls}-small`]: {
        [`&${componentCls}-horizontal ${componentCls}-item:first-child`]: {
          paddingBottom: paddingXXS,
          paddingInlineStart: paddingXXS
        }
      },
      [`&${componentCls}-small${componentCls}-vertical > ${componentCls}-item > ${componentCls}-item-container > ${componentCls}-item-tail`]: {
        insetInlineStart: token.calc(iconSizeSM).div(2).sub(lineWidth).add(paddingXXS).equal()
      },
      [`&${componentCls}-label-vertical ${componentCls}-item ${componentCls}-item-tail`]: {
        top: token.calc(iconSize).div(2).add(paddingXXS).equal()
      },
      [`${componentCls}-item-icon`]: {
        position: 'relative',
        [`${antCls}-progress`]: {
          position: 'absolute',
          insetInlineStart: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          '&-inner': {
            width: `${(0,cssinjs_es/* unit */.bf)(progressSize)} !important`,
            height: `${(0,cssinjs_es/* unit */.bf)(progressSize)} !important`
          }
        }
      },
      // ============================== Small size ==============================
      [`&${componentCls}-small`]: {
        [`&${componentCls}-label-vertical ${componentCls}-item ${componentCls}-item-tail`]: {
          top: token.calc(iconSizeSM).div(2).add(paddingXXS).equal()
        },
        [`${componentCls}-item-icon ${antCls}-progress-inner`]: {
          width: `${(0,cssinjs_es/* unit */.bf)(progressSizeSM)} !important`,
          height: `${(0,cssinjs_es/* unit */.bf)(progressSizeSM)} !important`
        }
      }
    }
  };
};
/* harmony default export */ var style_progress = (genStepsProgressStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/steps/style/progress-dot.js

const genStepsProgressDotStyle = token => {
  const {
    componentCls,
    descriptionMaxWidth,
    lineHeight,
    dotCurrentSize,
    dotSize,
    motionDurationSlow
  } = token;
  return {
    [`&${componentCls}-dot, &${componentCls}-dot${componentCls}-small`]: {
      [`${componentCls}-item`]: {
        '&-title': {
          lineHeight
        },
        '&-tail': {
          // Math.floor((token.size - token.lineWidth * 3) / 2)
          top: token.calc(token.dotSize).sub(token.calc(token.lineWidth).mul(3).equal()).div(2).equal(),
          width: '100%',
          marginTop: 0,
          marginBottom: 0,
          marginInline: `${(0,cssinjs_es/* unit */.bf)(token.calc(descriptionMaxWidth).div(2).equal())} 0`,
          padding: 0,
          '&::after': {
            width: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(token.calc(token.marginSM).mul(2).equal())})`,
            height: token.calc(token.lineWidth).mul(3).equal(),
            marginInlineStart: token.marginSM
          }
        },
        '&-icon': {
          width: dotSize,
          height: dotSize,
          marginInlineStart: token.calc(token.descriptionMaxWidth).sub(dotSize).div(2).equal(),
          paddingInlineEnd: 0,
          lineHeight: (0,cssinjs_es/* unit */.bf)(dotSize),
          background: 'transparent',
          border: 0,
          [`${componentCls}-icon-dot`]: {
            position: 'relative',
            float: 'left',
            width: '100%',
            height: '100%',
            borderRadius: 100,
            // very large number
            transition: `all ${motionDurationSlow}`,
            /* expand hover area */
            '&::after': {
              position: 'absolute',
              top: token.calc(token.marginSM).mul(-1).equal(),
              insetInlineStart: token.calc(dotSize).sub(token.calc(token.controlHeightLG).mul(1.5).equal()).div(2).equal(),
              width: token.calc(token.controlHeightLG).mul(1.5).equal(),
              height: token.controlHeight,
              background: 'transparent',
              content: '""'
            }
          }
        },
        '&-content': {
          width: descriptionMaxWidth
        },
        [`&-process ${componentCls}-item-icon`]: {
          position: 'relative',
          top: token.calc(dotSize).sub(dotCurrentSize).div(2).equal(),
          width: dotCurrentSize,
          height: dotCurrentSize,
          lineHeight: (0,cssinjs_es/* unit */.bf)(dotCurrentSize),
          background: 'none',
          marginInlineStart: token.calc(token.descriptionMaxWidth).sub(dotCurrentSize).div(2).equal()
        },
        [`&-process ${componentCls}-icon`]: {
          [`&:first-child ${componentCls}-icon-dot`]: {
            insetInlineStart: 0
          }
        }
      }
    },
    [`&${componentCls}-vertical${componentCls}-dot`]: {
      [`${componentCls}-item-icon`]: {
        marginTop: token.calc(token.controlHeight).sub(dotSize).div(2).equal(),
        marginInlineStart: 0,
        background: 'none'
      },
      [`${componentCls}-item-process ${componentCls}-item-icon`]: {
        marginTop: token.calc(token.controlHeight).sub(dotCurrentSize).div(2).equal(),
        top: 0,
        insetInlineStart: token.calc(dotSize).sub(dotCurrentSize).div(2).equal(),
        marginInlineStart: 0
      },
      // https://github.com/ant-design/ant-design/issues/18354
      [`${componentCls}-item > ${componentCls}-item-container > ${componentCls}-item-tail`]: {
        top: token.calc(token.controlHeight).sub(dotSize).div(2).equal(),
        insetInlineStart: 0,
        margin: 0,
        padding: `${(0,cssinjs_es/* unit */.bf)(token.calc(dotSize).add(token.paddingXS).equal())} 0 ${(0,cssinjs_es/* unit */.bf)(token.paddingXS)}`,
        '&::after': {
          marginInlineStart: token.calc(dotSize).sub(token.lineWidth).div(2).equal()
        }
      },
      [`&${componentCls}-small`]: {
        [`${componentCls}-item-icon`]: {
          marginTop: token.calc(token.controlHeightSM).sub(dotSize).div(2).equal()
        },
        [`${componentCls}-item-process ${componentCls}-item-icon`]: {
          marginTop: token.calc(token.controlHeightSM).sub(dotCurrentSize).div(2).equal()
        },
        [`${componentCls}-item > ${componentCls}-item-container > ${componentCls}-item-tail`]: {
          top: token.calc(token.controlHeightSM).sub(dotSize).div(2).equal()
        }
      },
      [`${componentCls}-item:first-child ${componentCls}-icon-dot`]: {
        insetInlineStart: 0
      },
      [`${componentCls}-item-content`]: {
        width: 'inherit'
      }
    }
  };
};
/* harmony default export */ var progress_dot = (genStepsProgressDotStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/steps/style/rtl.js
const genStepsRTLStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`&${componentCls}-rtl`]: {
      direction: 'rtl',
      [`${componentCls}-item`]: {
        '&-subtitle': {
          float: 'left'
        }
      },
      // nav
      [`&${componentCls}-navigation`]: {
        [`${componentCls}-item::after`]: {
          transform: 'rotate(-45deg)'
        }
      },
      // vertical
      [`&${componentCls}-vertical`]: {
        [`> ${componentCls}-item`]: {
          '&::after': {
            transform: 'rotate(225deg)'
          },
          [`${componentCls}-item-icon`]: {
            float: 'right'
          }
        }
      },
      // progress-dot
      [`&${componentCls}-dot`]: {
        [`${componentCls}-item-icon ${componentCls}-icon-dot, &${componentCls}-small ${componentCls}-item-icon ${componentCls}-icon-dot`]: {
          float: 'right'
        }
      }
    }
  };
};
/* harmony default export */ var style_rtl = (genStepsRTLStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/steps/style/small.js

const genStepsSmallStyle = token => {
  const {
    componentCls,
    iconSizeSM,
    // stepsSmallIconMargin,
    fontSizeSM,
    fontSize,
    colorTextDescription
  } = token;
  return {
    [`&${componentCls}-small`]: {
      [`&${componentCls}-horizontal:not(${componentCls}-label-vertical) ${componentCls}-item`]: {
        paddingInlineStart: token.paddingSM,
        '&:first-child': {
          paddingInlineStart: 0
        }
      },
      [`${componentCls}-item-icon`]: {
        width: iconSizeSM,
        height: iconSizeSM,
        // margin: stepsSmallIconMargin,
        marginTop: 0,
        marginBottom: 0,
        marginInline: `0 ${(0,cssinjs_es/* unit */.bf)(token.marginXS)}`,
        fontSize: fontSizeSM,
        lineHeight: (0,cssinjs_es/* unit */.bf)(iconSizeSM),
        textAlign: 'center',
        borderRadius: iconSizeSM
      },
      [`${componentCls}-item-title`]: {
        paddingInlineEnd: token.paddingSM,
        fontSize,
        lineHeight: (0,cssinjs_es/* unit */.bf)(iconSizeSM),
        '&::after': {
          top: token.calc(iconSizeSM).div(2).equal()
        }
      },
      [`${componentCls}-item-description`]: {
        color: colorTextDescription,
        fontSize
      },
      [`${componentCls}-item-tail`]: {
        top: token.calc(iconSizeSM).div(2).sub(token.paddingXXS).equal()
      },
      [`${componentCls}-item-custom ${componentCls}-item-icon`]: {
        width: 'inherit',
        height: 'inherit',
        lineHeight: 'inherit',
        background: 'none',
        border: 0,
        borderRadius: 0,
        [`> ${componentCls}-icon`]: {
          fontSize: iconSizeSM,
          lineHeight: (0,cssinjs_es/* unit */.bf)(iconSizeSM),
          transform: 'none'
        }
      }
    }
  };
};
/* harmony default export */ var small = (genStepsSmallStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/steps/style/vertical.js

const genStepsVerticalStyle = token => {
  const {
    componentCls,
    iconSizeSM,
    iconSize
  } = token;
  return {
    [`&${componentCls}-vertical`]: {
      display: 'flex',
      flexDirection: 'column',
      [`> ${componentCls}-item`]: {
        display: 'block',
        flex: '1 0 auto',
        paddingInlineStart: 0,
        overflow: 'visible',
        [`${componentCls}-item-icon`]: {
          float: 'left',
          marginInlineEnd: token.margin
        },
        [`${componentCls}-item-content`]: {
          display: 'block',
          minHeight: token.calc(token.controlHeight).mul(1.5).equal(),
          overflow: 'hidden'
        },
        [`${componentCls}-item-title`]: {
          lineHeight: (0,cssinjs_es/* unit */.bf)(iconSize)
        },
        [`${componentCls}-item-description`]: {
          paddingBottom: token.paddingSM
        }
      },
      [`> ${componentCls}-item > ${componentCls}-item-container > ${componentCls}-item-tail`]: {
        position: 'absolute',
        top: 0,
        insetInlineStart: token.calc(iconSize).div(2).sub(token.lineWidth).equal(),
        width: token.lineWidth,
        height: '100%',
        padding: `${(0,cssinjs_es/* unit */.bf)(token.calc(token.marginXXS).mul(1.5).add(iconSize).equal())} 0 ${(0,cssinjs_es/* unit */.bf)(token.calc(token.marginXXS).mul(1.5).equal())}`,
        '&::after': {
          width: token.lineWidth,
          height: '100%'
        }
      },
      [`> ${componentCls}-item:not(:last-child) > ${componentCls}-item-container > ${componentCls}-item-tail`]: {
        display: 'block'
      },
      [` > ${componentCls}-item > ${componentCls}-item-container > ${componentCls}-item-content > ${componentCls}-item-title`]: {
        '&::after': {
          display: 'none'
        }
      },
      [`&${componentCls}-small ${componentCls}-item-container`]: {
        [`${componentCls}-item-tail`]: {
          position: 'absolute',
          top: 0,
          insetInlineStart: token.calc(iconSizeSM).div(2).sub(token.lineWidth).equal(),
          padding: `${(0,cssinjs_es/* unit */.bf)(token.calc(token.marginXXS).mul(1.5).add(iconSizeSM).equal())} 0 ${(0,cssinjs_es/* unit */.bf)(token.calc(token.marginXXS).mul(1.5).equal())}`
        },
        [`${componentCls}-item-title`]: {
          lineHeight: (0,cssinjs_es/* unit */.bf)(iconSizeSM)
        }
      }
    }
  };
};
/* harmony default export */ var style_vertical = (genStepsVerticalStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/steps/style/index.js













const STEP_ITEM_STATUS_WAIT = 'wait';
const STEP_ITEM_STATUS_PROCESS = 'process';
const STEP_ITEM_STATUS_FINISH = 'finish';
const STEP_ITEM_STATUS_ERROR = 'error';
const genStepsItemStatusStyle = (status, token) => {
  const prefix = `${token.componentCls}-item`;
  const iconColorKey = `${status}IconColor`;
  const titleColorKey = `${status}TitleColor`;
  const descriptionColorKey = `${status}DescriptionColor`;
  const tailColorKey = `${status}TailColor`;
  const iconBgColorKey = `${status}IconBgColor`;
  const iconBorderColorKey = `${status}IconBorderColor`;
  const dotColorKey = `${status}DotColor`;
  return {
    [`${prefix}-${status} ${prefix}-icon`]: {
      backgroundColor: token[iconBgColorKey],
      borderColor: token[iconBorderColorKey],
      [`> ${token.componentCls}-icon`]: {
        color: token[iconColorKey],
        [`${token.componentCls}-icon-dot`]: {
          background: token[dotColorKey]
        }
      }
    },
    [`${prefix}-${status}${prefix}-custom ${prefix}-icon`]: {
      [`> ${token.componentCls}-icon`]: {
        color: token[dotColorKey]
      }
    },
    [`${prefix}-${status} > ${prefix}-container > ${prefix}-content > ${prefix}-title`]: {
      color: token[titleColorKey],
      '&::after': {
        backgroundColor: token[tailColorKey]
      }
    },
    [`${prefix}-${status} > ${prefix}-container > ${prefix}-content > ${prefix}-description`]: {
      color: token[descriptionColorKey]
    },
    [`${prefix}-${status} > ${prefix}-container > ${prefix}-tail::after`]: {
      backgroundColor: token[tailColorKey]
    }
  };
};
const genStepsItemStyle = token => {
  const {
    componentCls,
    motionDurationSlow
  } = token;
  const stepsItemCls = `${componentCls}-item`; // .ant-steps-item
  const stepItemIconCls = `${stepsItemCls}-icon`;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    [stepsItemCls]: {
      position: 'relative',
      display: 'inline-block',
      flex: 1,
      overflow: 'hidden',
      verticalAlign: 'top',
      '&:last-child': {
        flex: 'none',
        [`> ${stepsItemCls}-container > ${stepsItemCls}-tail, > ${stepsItemCls}-container >  ${stepsItemCls}-content > ${stepsItemCls}-title::after`]: {
          display: 'none'
        }
      }
    },
    [`${stepsItemCls}-container`]: {
      outline: 'none',
      [`&:focus-visible ${stepItemIconCls}`]: genFocusOutline(token)
    },
    [`${stepItemIconCls}, ${stepsItemCls}-content`]: {
      display: 'inline-block',
      verticalAlign: 'top'
    },
    [stepItemIconCls]: {
      width: token.iconSize,
      height: token.iconSize,
      marginTop: 0,
      marginBottom: 0,
      marginInlineStart: 0,
      marginInlineEnd: token.marginXS,
      fontSize: token.iconFontSize,
      fontFamily: token.fontFamily,
      lineHeight: (0,cssinjs_es/* unit */.bf)(token.iconSize),
      textAlign: 'center',
      borderRadius: token.iconSize,
      border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} transparent`,
      transition: `background-color ${motionDurationSlow}, border-color ${motionDurationSlow}`,
      [`${componentCls}-icon`]: {
        position: 'relative',
        top: token.iconTop,
        color: token.colorPrimary,
        lineHeight: 1
      }
    },
    [`${stepsItemCls}-tail`]: {
      position: 'absolute',
      top: token.calc(token.iconSize).div(2).equal(),
      insetInlineStart: 0,
      width: '100%',
      '&::after': {
        display: 'inline-block',
        width: '100%',
        height: token.lineWidth,
        background: token.colorSplit,
        borderRadius: token.lineWidth,
        transition: `background ${motionDurationSlow}`,
        content: '""'
      }
    },
    [`${stepsItemCls}-title`]: {
      position: 'relative',
      display: 'inline-block',
      paddingInlineEnd: token.padding,
      color: token.colorText,
      fontSize: token.fontSizeLG,
      lineHeight: (0,cssinjs_es/* unit */.bf)(token.titleLineHeight),
      '&::after': {
        position: 'absolute',
        top: token.calc(token.titleLineHeight).div(2).equal(),
        insetInlineStart: '100%',
        display: 'block',
        width: 9999,
        height: token.lineWidth,
        background: token.processTailColor,
        content: '""'
      }
    },
    [`${stepsItemCls}-subtitle`]: {
      display: 'inline',
      marginInlineStart: token.marginXS,
      color: token.colorTextDescription,
      fontWeight: 'normal',
      fontSize: token.fontSize
    },
    [`${stepsItemCls}-description`]: {
      color: token.colorTextDescription,
      fontSize: token.fontSize
    }
  }, genStepsItemStatusStyle(STEP_ITEM_STATUS_WAIT, token)), genStepsItemStatusStyle(STEP_ITEM_STATUS_PROCESS, token)), {
    [`${stepsItemCls}-process > ${stepsItemCls}-container > ${stepsItemCls}-title`]: {
      fontWeight: token.fontWeightStrong
    }
  }), genStepsItemStatusStyle(STEP_ITEM_STATUS_FINISH, token)), genStepsItemStatusStyle(STEP_ITEM_STATUS_ERROR, token)), {
    [`${stepsItemCls}${componentCls}-next-error > ${componentCls}-item-title::after`]: {
      background: token.colorError
    },
    [`${stepsItemCls}-disabled`]: {
      cursor: 'not-allowed'
    }
  });
};
// ============================= Clickable ===========================
const genStepsClickableStyle = token => {
  const {
    componentCls,
    motionDurationSlow
  } = token;
  return {
    [`& ${componentCls}-item`]: {
      [`&:not(${componentCls}-item-active)`]: {
        [`& > ${componentCls}-item-container[role='button']`]: {
          cursor: 'pointer',
          [`${componentCls}-item`]: {
            [`&-title, &-subtitle, &-description, &-icon ${componentCls}-icon`]: {
              transition: `color ${motionDurationSlow}`
            }
          },
          '&:hover': {
            [`${componentCls}-item`]: {
              '&-title, &-subtitle, &-description': {
                color: token.colorPrimary
              }
            }
          }
        },
        [`&:not(${componentCls}-item-process)`]: {
          [`& > ${componentCls}-item-container[role='button']:hover`]: {
            [`${componentCls}-item`]: {
              '&-icon': {
                borderColor: token.colorPrimary,
                [`${componentCls}-icon`]: {
                  color: token.colorPrimary
                }
              }
            }
          }
        }
      }
    },
    [`&${componentCls}-horizontal:not(${componentCls}-label-vertical)`]: {
      [`${componentCls}-item`]: {
        paddingInlineStart: token.padding,
        whiteSpace: 'nowrap',
        '&:first-child': {
          paddingInlineStart: 0
        },
        [`&:last-child ${componentCls}-item-title`]: {
          paddingInlineEnd: 0
        },
        '&-tail': {
          display: 'none'
        },
        '&-description': {
          maxWidth: token.descriptionMaxWidth,
          whiteSpace: 'normal'
        }
      }
    }
  };
};
const genStepsStyle = token => {
  const {
    componentCls
  } = token; // .ant-steps
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), {
      display: 'flex',
      width: '100%',
      fontSize: 0,
      textAlign: 'initial'
    }), genStepsItemStyle(token)), genStepsClickableStyle(token)), custom_icon(token)), small(token)), style_vertical(token)), style_horizontal(token)), label_placement(token)), progress_dot(token)), nav(token)), style_rtl(token)), style_progress(token)), inline(token))
  };
};
// ============================== Export ==============================
const steps_style_prepareComponentToken = token => ({
  titleLineHeight: token.controlHeight,
  customIconSize: token.controlHeight,
  customIconTop: 0,
  customIconFontSize: token.controlHeightSM,
  iconSize: token.controlHeight,
  iconTop: -0.5,
  // magic for ui experience
  iconFontSize: token.fontSize,
  iconSizeSM: token.fontSizeHeading3,
  dotSize: token.controlHeight / 4,
  dotCurrentSize: token.controlHeightLG / 4,
  navArrowColor: token.colorTextDisabled,
  navContentMaxWidth: 'unset',
  descriptionMaxWidth: 140,
  waitIconColor: token.wireframe ? token.colorTextDisabled : token.colorTextLabel,
  waitIconBgColor: token.wireframe ? token.colorBgContainer : token.colorFillContent,
  waitIconBorderColor: token.wireframe ? token.colorTextDisabled : 'transparent',
  finishIconBgColor: token.wireframe ? token.colorBgContainer : token.controlItemBgActive,
  finishIconBorderColor: token.wireframe ? token.colorPrimary : token.controlItemBgActive
});
/* harmony default export */ var steps_style = (genStyleHooks('Steps', token => {
  const {
    colorTextDisabled,
    controlHeightLG,
    colorTextLightSolid,
    colorText,
    colorPrimary,
    colorTextDescription,
    colorTextQuaternary,
    colorError,
    colorBorderSecondary,
    colorSplit
  } = token;
  const stepsToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    // Steps component less variable
    processIconColor: colorTextLightSolid,
    processTitleColor: colorText,
    processDescriptionColor: colorText,
    processIconBgColor: colorPrimary,
    processIconBorderColor: colorPrimary,
    processDotColor: colorPrimary,
    processTailColor: colorSplit,
    waitTitleColor: colorTextDescription,
    waitDescriptionColor: colorTextDescription,
    waitTailColor: colorSplit,
    waitDotColor: colorTextDisabled,
    finishIconColor: colorPrimary,
    finishTitleColor: colorText,
    finishDescriptionColor: colorTextDescription,
    finishTailColor: colorPrimary,
    finishDotColor: colorPrimary,
    errorIconColor: colorTextLightSolid,
    errorTitleColor: colorError,
    errorDescriptionColor: colorError,
    errorTailColor: colorSplit,
    errorIconBgColor: colorError,
    errorIconBorderColor: colorError,
    errorDotColor: colorError,
    stepsNavActiveColor: colorPrimary,
    stepsProgressSize: controlHeightLG,
    // Steps inline variable
    inlineDotSize: 6,
    inlineTitleColor: colorTextQuaternary,
    inlineTailColor: colorBorderSecondary
  });
  return genStepsStyle(stepsToken);
}, steps_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/steps/useLegacyItems.js



function useLegacyItems_filter(items) {
  return items.filter(item => item);
}
function useLegacyItems_useLegacyItems(items, children) {
  if (false) {}
  if (items) {
    return items;
  }
  const childrenItems = (0,Children_toArray/* default */.Z)(children).map(node => {
    if (/*#__PURE__*/react.isValidElement(node)) {
      const {
        props
      } = node;
      const item = Object.assign({}, props);
      return item;
    }
    return null;
  });
  return useLegacyItems_filter(childrenItems);
}
/* harmony default export */ var steps_useLegacyItems = (useLegacyItems_useLegacyItems);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/steps/index.js
"use client";

var steps_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};












const steps_Steps = props => {
  const {
      percent,
      size: customizeSize,
      className,
      rootClassName,
      direction,
      items,
      responsive = true,
      current = 0,
      children,
      style
    } = props,
    restProps = steps_rest(props, ["percent", "size", "className", "rootClassName", "direction", "items", "responsive", "current", "children", "style"]);
  const {
    xs
  } = hooks_useBreakpoint(responsive);
  const {
    getPrefixCls,
    direction: rtlDirection,
    className: contextClassName,
    style: contextStyle
  } = useComponentConfig('steps');
  const realDirectionValue = react.useMemo(() => responsive && xs ? 'vertical' : direction, [xs, direction]);
  const size = hooks_useSize(customizeSize);
  const prefixCls = getPrefixCls('steps', props.prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = steps_style(prefixCls);
  const isInline = props.type === 'inline';
  const iconPrefix = getPrefixCls('', props.iconPrefix);
  const mergedItems = steps_useLegacyItems(items, children);
  const mergedPercent = isInline ? undefined : percent;
  const mergedStyle = Object.assign(Object.assign({}, contextStyle), style);
  const stepsClassName = classnames_default()(contextClassName, {
    [`${prefixCls}-rtl`]: rtlDirection === 'rtl',
    [`${prefixCls}-with-progress`]: mergedPercent !== undefined
  }, className, rootClassName, hashId, cssVarCls);
  const icons = {
    finish: /*#__PURE__*/react.createElement(CheckOutlined/* default */.Z, {
      className: `${prefixCls}-finish-icon`
    }),
    error: /*#__PURE__*/react.createElement(CloseOutlined/* default */.Z, {
      className: `${prefixCls}-error-icon`
    })
  };
  const stepIconRender = ({
    node,
    status
  }) => {
    if (status === 'process' && mergedPercent !== undefined) {
      // currently it's hard-coded, since we can't easily read the actually width of icon
      const progressWidth = size === 'small' ? 32 : 40;
      // iconWithProgress
      return /*#__PURE__*/react.createElement("div", {
        className: `${prefixCls}-progress-icon`
      }, /*#__PURE__*/react.createElement(es_progress, {
        type: "circle",
        percent: mergedPercent,
        size: progressWidth,
        strokeWidth: 4,
        format: () => null
      }), node);
    }
    return node;
  };
  const itemRender = (item, stepItem) => item.description ? /*#__PURE__*/react.createElement(es_tooltip, {
    title: item.description
  }, stepItem) : stepItem;
  return wrapCSSVar(/*#__PURE__*/react.createElement(rc_steps_es, Object.assign({
    icons: icons
  }, restProps, {
    style: mergedStyle,
    current: current,
    size: size,
    items: mergedItems,
    itemRender: isInline ? itemRender : undefined,
    stepIcon: stepIconRender,
    direction: realDirectionValue,
    prefixCls: prefixCls,
    iconPrefix: iconPrefix,
    className: stepsClassName
  })));
};
steps_Steps.Step = rc_steps_es.Step;
if (false) {}
/* harmony default export */ var steps = (steps_Steps);
// EXTERNAL MODULE: ./node_modules/rc-switch/es/index.js
var rc_switch_es = __webpack_require__(3659);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/switch/style/index.js




const genSwitchSmallStyle = token => {
  const {
    componentCls,
    trackHeightSM,
    trackPadding,
    trackMinWidthSM,
    innerMinMarginSM,
    innerMaxMarginSM,
    handleSizeSM,
    calc
  } = token;
  const switchInnerCls = `${componentCls}-inner`;
  const trackPaddingCalc = (0,cssinjs_es/* unit */.bf)(calc(handleSizeSM).add(calc(trackPadding).mul(2)).equal());
  const innerMaxMarginCalc = (0,cssinjs_es/* unit */.bf)(calc(innerMaxMarginSM).mul(2).equal());
  return {
    [componentCls]: {
      [`&${componentCls}-small`]: {
        minWidth: trackMinWidthSM,
        height: trackHeightSM,
        lineHeight: (0,cssinjs_es/* unit */.bf)(trackHeightSM),
        [`${componentCls}-inner`]: {
          paddingInlineStart: innerMaxMarginSM,
          paddingInlineEnd: innerMinMarginSM,
          [`${switchInnerCls}-checked, ${switchInnerCls}-unchecked`]: {
            minHeight: trackHeightSM
          },
          [`${switchInnerCls}-checked`]: {
            marginInlineStart: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`,
            marginInlineEnd: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`
          },
          [`${switchInnerCls}-unchecked`]: {
            marginTop: calc(trackHeightSM).mul(-1).equal(),
            marginInlineStart: 0,
            marginInlineEnd: 0
          }
        },
        [`${componentCls}-handle`]: {
          width: handleSizeSM,
          height: handleSizeSM
        },
        [`${componentCls}-loading-icon`]: {
          top: calc(calc(handleSizeSM).sub(token.switchLoadingIconSize)).div(2).equal(),
          fontSize: token.switchLoadingIconSize
        },
        [`&${componentCls}-checked`]: {
          [`${componentCls}-inner`]: {
            paddingInlineStart: innerMinMarginSM,
            paddingInlineEnd: innerMaxMarginSM,
            [`${switchInnerCls}-checked`]: {
              marginInlineStart: 0,
              marginInlineEnd: 0
            },
            [`${switchInnerCls}-unchecked`]: {
              marginInlineStart: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`,
              marginInlineEnd: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`
            }
          },
          [`${componentCls}-handle`]: {
            insetInlineStart: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(calc(handleSizeSM).add(trackPadding).equal())})`
          }
        },
        [`&:not(${componentCls}-disabled):active`]: {
          [`&:not(${componentCls}-checked) ${switchInnerCls}`]: {
            [`${switchInnerCls}-unchecked`]: {
              marginInlineStart: calc(token.marginXXS).div(2).equal(),
              marginInlineEnd: calc(token.marginXXS).mul(-1).div(2).equal()
            }
          },
          [`&${componentCls}-checked ${switchInnerCls}`]: {
            [`${switchInnerCls}-checked`]: {
              marginInlineStart: calc(token.marginXXS).mul(-1).div(2).equal(),
              marginInlineEnd: calc(token.marginXXS).div(2).equal()
            }
          }
        }
      }
    }
  };
};
const genSwitchLoadingStyle = token => {
  const {
    componentCls,
    handleSize,
    calc
  } = token;
  return {
    [componentCls]: {
      [`${componentCls}-loading-icon${token.iconCls}`]: {
        position: 'relative',
        top: calc(calc(handleSize).sub(token.fontSize)).div(2).equal(),
        color: token.switchLoadingIconColor,
        verticalAlign: 'top'
      },
      [`&${componentCls}-checked ${componentCls}-loading-icon`]: {
        color: token.switchColor
      }
    }
  };
};
const genSwitchHandleStyle = token => {
  const {
    componentCls,
    trackPadding,
    handleBg,
    handleShadow,
    handleSize,
    calc
  } = token;
  const switchHandleCls = `${componentCls}-handle`;
  return {
    [componentCls]: {
      [switchHandleCls]: {
        position: 'absolute',
        top: trackPadding,
        insetInlineStart: trackPadding,
        width: handleSize,
        height: handleSize,
        transition: `all ${token.switchDuration} ease-in-out`,
        '&::before': {
          position: 'absolute',
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          backgroundColor: handleBg,
          borderRadius: calc(handleSize).div(2).equal(),
          boxShadow: handleShadow,
          transition: `all ${token.switchDuration} ease-in-out`,
          content: '""'
        }
      },
      [`&${componentCls}-checked ${switchHandleCls}`]: {
        insetInlineStart: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(calc(handleSize).add(trackPadding).equal())})`
      },
      [`&:not(${componentCls}-disabled):active`]: {
        [`${switchHandleCls}::before`]: {
          insetInlineEnd: token.switchHandleActiveInset,
          insetInlineStart: 0
        },
        [`&${componentCls}-checked ${switchHandleCls}::before`]: {
          insetInlineEnd: 0,
          insetInlineStart: token.switchHandleActiveInset
        }
      }
    }
  };
};
const genSwitchInnerStyle = token => {
  const {
    componentCls,
    trackHeight,
    trackPadding,
    innerMinMargin,
    innerMaxMargin,
    handleSize,
    calc
  } = token;
  const switchInnerCls = `${componentCls}-inner`;
  const trackPaddingCalc = (0,cssinjs_es/* unit */.bf)(calc(handleSize).add(calc(trackPadding).mul(2)).equal());
  const innerMaxMarginCalc = (0,cssinjs_es/* unit */.bf)(calc(innerMaxMargin).mul(2).equal());
  return {
    [componentCls]: {
      [switchInnerCls]: {
        display: 'block',
        overflow: 'hidden',
        borderRadius: 100,
        height: '100%',
        paddingInlineStart: innerMaxMargin,
        paddingInlineEnd: innerMinMargin,
        transition: `padding-inline-start ${token.switchDuration} ease-in-out, padding-inline-end ${token.switchDuration} ease-in-out`,
        [`${switchInnerCls}-checked, ${switchInnerCls}-unchecked`]: {
          display: 'block',
          color: token.colorTextLightSolid,
          fontSize: token.fontSizeSM,
          transition: `margin-inline-start ${token.switchDuration} ease-in-out, margin-inline-end ${token.switchDuration} ease-in-out`,
          pointerEvents: 'none',
          minHeight: trackHeight
        },
        [`${switchInnerCls}-checked`]: {
          marginInlineStart: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`,
          marginInlineEnd: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`
        },
        [`${switchInnerCls}-unchecked`]: {
          marginTop: calc(trackHeight).mul(-1).equal(),
          marginInlineStart: 0,
          marginInlineEnd: 0
        }
      },
      [`&${componentCls}-checked ${switchInnerCls}`]: {
        paddingInlineStart: innerMinMargin,
        paddingInlineEnd: innerMaxMargin,
        [`${switchInnerCls}-checked`]: {
          marginInlineStart: 0,
          marginInlineEnd: 0
        },
        [`${switchInnerCls}-unchecked`]: {
          marginInlineStart: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`,
          marginInlineEnd: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`
        }
      },
      [`&:not(${componentCls}-disabled):active`]: {
        [`&:not(${componentCls}-checked) ${switchInnerCls}`]: {
          [`${switchInnerCls}-unchecked`]: {
            marginInlineStart: calc(trackPadding).mul(2).equal(),
            marginInlineEnd: calc(trackPadding).mul(-1).mul(2).equal()
          }
        },
        [`&${componentCls}-checked ${switchInnerCls}`]: {
          [`${switchInnerCls}-checked`]: {
            marginInlineStart: calc(trackPadding).mul(-1).mul(2).equal(),
            marginInlineEnd: calc(trackPadding).mul(2).equal()
          }
        }
      }
    }
  };
};
const genSwitchStyle = token => {
  const {
    componentCls,
    trackHeight,
    trackMinWidth
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), {
      position: 'relative',
      display: 'inline-block',
      boxSizing: 'border-box',
      minWidth: trackMinWidth,
      height: trackHeight,
      lineHeight: (0,cssinjs_es/* unit */.bf)(trackHeight),
      verticalAlign: 'middle',
      background: token.colorTextQuaternary,
      border: '0',
      borderRadius: 100,
      cursor: 'pointer',
      transition: `all ${token.motionDurationMid}`,
      userSelect: 'none',
      [`&:hover:not(${componentCls}-disabled)`]: {
        background: token.colorTextTertiary
      }
    }), genFocusStyle(token)), {
      [`&${componentCls}-checked`]: {
        background: token.switchColor,
        [`&:hover:not(${componentCls}-disabled)`]: {
          background: token.colorPrimaryHover
        }
      },
      [`&${componentCls}-loading, &${componentCls}-disabled`]: {
        cursor: 'not-allowed',
        opacity: token.switchDisabledOpacity,
        '*': {
          boxShadow: 'none',
          cursor: 'not-allowed'
        }
      },
      // rtl style
      [`&${componentCls}-rtl`]: {
        direction: 'rtl'
      }
    })
  };
};
// ============================== Export ==============================
const switch_style_prepareComponentToken = token => {
  const {
    fontSize,
    lineHeight,
    controlHeight,
    colorWhite
  } = token;
  const height = fontSize * lineHeight;
  const heightSM = controlHeight / 2;
  const padding = 2; // Fixed value
  const handleSize = height - padding * 2;
  const handleSizeSM = heightSM - padding * 2;
  return {
    trackHeight: height,
    trackHeightSM: heightSM,
    trackMinWidth: handleSize * 2 + padding * 4,
    trackMinWidthSM: handleSizeSM * 2 + padding * 2,
    trackPadding: padding,
    // Fixed value
    handleBg: colorWhite,
    handleSize,
    handleSizeSM,
    handleShadow: `0 2px 4px 0 ${new fast_color_es/* FastColor */.t('#00230b').setA(0.2).toRgbString()}`,
    innerMinMargin: handleSize / 2,
    innerMaxMargin: handleSize + padding + padding * 2,
    innerMinMarginSM: handleSizeSM / 2,
    innerMaxMarginSM: handleSizeSM + padding + padding * 2
  };
};
/* harmony default export */ var switch_style = (genStyleHooks('Switch', token => {
  const switchToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    switchDuration: token.motionDurationMid,
    switchColor: token.colorPrimary,
    switchDisabledOpacity: token.opacityLoading,
    switchLoadingIconSize: token.calc(token.fontSizeIcon).mul(0.75).equal(),
    switchLoadingIconColor: `rgba(0, 0, 0, ${token.opacityLoading})`,
    switchHandleActiveInset: '-30%'
  });
  return [genSwitchStyle(switchToken),
  // inner style
  genSwitchInnerStyle(switchToken),
  // handle style
  genSwitchHandleStyle(switchToken),
  // loading style
  genSwitchLoadingStyle(switchToken),
  // small style
  genSwitchSmallStyle(switchToken)];
}, switch_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/switch/index.js
"use client";

var switch_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};










const InternalSwitch = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      size: customizeSize,
      disabled: customDisabled,
      loading,
      className,
      rootClassName,
      style,
      checked: checkedProp,
      value,
      defaultChecked: defaultCheckedProp,
      defaultValue,
      onChange
    } = props,
    restProps = switch_rest(props, ["prefixCls", "size", "disabled", "loading", "className", "rootClassName", "style", "checked", "value", "defaultChecked", "defaultValue", "onChange"]);
  const [checked, setChecked] = (0,useMergedState/* default */.Z)(false, {
    value: checkedProp !== null && checkedProp !== void 0 ? checkedProp : value,
    defaultValue: defaultCheckedProp !== null && defaultCheckedProp !== void 0 ? defaultCheckedProp : defaultValue
  });
  const {
    getPrefixCls,
    direction,
    switch: SWITCH
  } = react.useContext(ConfigContext);
  // ===================== Disabled =====================
  const disabled = react.useContext(config_provider_DisabledContext);
  const mergedDisabled = (customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled) || loading;
  const prefixCls = getPrefixCls('switch', customizePrefixCls);
  const loadingIcon = /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-handle`
  }, loading && /*#__PURE__*/react.createElement(LoadingOutlined/* default */.Z, {
    className: `${prefixCls}-loading-icon`
  }));
  // Style
  const [wrapCSSVar, hashId, cssVarCls] = switch_style(prefixCls);
  const mergedSize = hooks_useSize(customizeSize);
  const classes = classnames_default()(SWITCH === null || SWITCH === void 0 ? void 0 : SWITCH.className, {
    [`${prefixCls}-small`]: mergedSize === 'small',
    [`${prefixCls}-loading`]: loading,
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, className, rootClassName, hashId, cssVarCls);
  const mergedStyle = Object.assign(Object.assign({}, SWITCH === null || SWITCH === void 0 ? void 0 : SWITCH.style), style);
  const changeHandler = (...args) => {
    setChecked(args[0]);
    onChange === null || onChange === void 0 ? void 0 : onChange.apply(void 0, args);
  };
  return wrapCSSVar(/*#__PURE__*/react.createElement(wave, {
    component: "Switch"
  }, /*#__PURE__*/react.createElement(rc_switch_es/* default */.Z, Object.assign({}, restProps, {
    checked: checked,
    onChange: changeHandler,
    prefixCls: prefixCls,
    className: classes,
    style: mergedStyle,
    disabled: mergedDisabled,
    ref: ref,
    loadingIcon: loadingIcon
  }))));
});
const Switch = InternalSwitch;
Switch.__ANT_SWITCH = true;
if (false) {}
/* harmony default export */ var es_switch = (Switch);
// EXTERNAL MODULE: ./node_modules/rc-table/es/index.js + 45 modules
var rc_table_es = __webpack_require__(78323);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/Column.js
/* istanbul ignore next */
/** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */
const Column_Column = _ => null;
/* harmony default export */ var table_Column = (Column_Column);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/ColumnGroup.js
/* istanbul ignore next */
/** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */
const ColumnGroup = _ => null;
/* harmony default export */ var table_ColumnGroup = (ColumnGroup);
// EXTERNAL MODULE: ./node_modules/rc-tree/es/util.js
var es_util = __webpack_require__(69958);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/hooks/useMultipleSelect.js

/**
 * @title multipleSelect hooks
 * @description multipleSelect by hold down shift key
 */
function useMultipleSelect(getKey) {
  const [prevSelectedIndex, setPrevSelectedIndex] = (0,react.useState)(null);
  const multipleSelect = (0,react.useCallback)((currentSelectedIndex, data, selectedKeys) => {
    const configPrevSelectedIndex = prevSelectedIndex !== null && prevSelectedIndex !== void 0 ? prevSelectedIndex : currentSelectedIndex;
    // add/delete the selected range
    const startIndex = Math.min(configPrevSelectedIndex || 0, currentSelectedIndex);
    const endIndex = Math.max(configPrevSelectedIndex || 0, currentSelectedIndex);
    const rangeKeys = data.slice(startIndex, endIndex + 1).map(item => getKey(item));
    const shouldSelected = rangeKeys.some(rangeKey => !selectedKeys.has(rangeKey));
    const changedKeys = [];
    rangeKeys.forEach(item => {
      if (shouldSelected) {
        if (!selectedKeys.has(item)) {
          changedKeys.push(item);
        }
        selectedKeys.add(item);
      } else {
        selectedKeys.delete(item);
        changedKeys.push(item);
      }
    });
    setPrevSelectedIndex(shouldSelected ? endIndex : null);
    return changedKeys;
  }, [prevSelectedIndex]);
  const updatePrevSelectedIndex = val => {
    setPrevSelectedIndex(val);
  };
  return [multipleSelect, updatePrevSelectedIndex];
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/hooks/useSelection.js
"use client";
















// TODO: warning if use ajax!!!
const SELECTION_COLUMN = {};
const SELECTION_ALL = 'SELECT_ALL';
const SELECTION_INVERT = 'SELECT_INVERT';
const SELECTION_NONE = 'SELECT_NONE';
const useSelection_EMPTY_LIST = [];
const flattenData = (childrenColumnName, data, list = []) => {
  (data || []).forEach(record => {
    list.push(record);
    if (record && typeof record === 'object' && childrenColumnName in record) {
      flattenData(childrenColumnName, record[childrenColumnName], list);
    }
  });
  return list;
};
const useSelection = (config, rowSelection) => {
  const {
    preserveSelectedRowKeys,
    selectedRowKeys,
    defaultSelectedRowKeys,
    getCheckboxProps,
    getTitleCheckboxProps,
    onChange: onSelectionChange,
    onSelect,
    onSelectAll,
    onSelectInvert,
    onSelectNone,
    onSelectMultiple,
    columnWidth: selectionColWidth,
    type: selectionType,
    selections,
    fixed,
    renderCell: customizeRenderCell,
    hideSelectAll,
    checkStrictly = true
  } = rowSelection || {};
  const {
    prefixCls,
    data,
    pageData,
    getRecordByKey,
    getRowKey,
    expandType,
    childrenColumnName,
    locale: tableLocale,
    getPopupContainer
  } = config;
  const warning = warning_devUseWarning('Table');
  // ========================= MultipleSelect =========================
  const [multipleSelect, updatePrevSelectedIndex] = useMultipleSelect(item => item);
  // ========================= Keys =========================
  const [mergedSelectedKeys, setMergedSelectedKeys] = (0,useMergedState/* default */.Z)(selectedRowKeys || defaultSelectedRowKeys || useSelection_EMPTY_LIST, {
    value: selectedRowKeys
  });
  // ======================== Caches ========================
  const preserveRecordsRef = react.useRef(new Map());
  const updatePreserveRecordsCache = (0,react.useCallback)(keys => {
    if (preserveSelectedRowKeys) {
      const newCache = new Map();
      // Keep key if mark as preserveSelectedRowKeys
      keys.forEach(key => {
        let record = getRecordByKey(key);
        if (!record && preserveRecordsRef.current.has(key)) {
          record = preserveRecordsRef.current.get(key);
        }
        newCache.set(key, record);
      });
      // Refresh to new cache
      preserveRecordsRef.current = newCache;
    }
  }, [getRecordByKey, preserveSelectedRowKeys]);
  // Update cache with selectedKeys
  react.useEffect(() => {
    updatePreserveRecordsCache(mergedSelectedKeys);
  }, [mergedSelectedKeys]);
  // Get flatten data
  const flattedData = (0,react.useMemo)(() => flattenData(childrenColumnName, pageData), [childrenColumnName, pageData]);
  const {
    keyEntities
  } = (0,react.useMemo)(() => {
    if (checkStrictly) {
      return {
        keyEntities: null
      };
    }
    let convertData = data;
    if (preserveSelectedRowKeys) {
      // use flattedData keys
      const keysSet = new Set(flattedData.map((record, index) => getRowKey(record, index)));
      // remove preserveRecords that duplicate data
      const preserveRecords = Array.from(preserveRecordsRef.current).reduce((total, [key, value]) => keysSet.has(key) ? total : total.concat(value), []);
      convertData = [].concat((0,toConsumableArray/* default */.Z)(convertData), (0,toConsumableArray/* default */.Z)(preserveRecords));
    }
    return (0,treeUtil/* convertDataToEntities */.I8)(convertData, {
      externalGetKey: getRowKey,
      childrenPropName: childrenColumnName
    });
  }, [data, getRowKey, checkStrictly, childrenColumnName, preserveSelectedRowKeys, flattedData]);
  // Get all checkbox props
  const checkboxPropsMap = (0,react.useMemo)(() => {
    const map = new Map();
    flattedData.forEach((record, index) => {
      const key = getRowKey(record, index);
      const checkboxProps = (getCheckboxProps ? getCheckboxProps(record) : null) || {};
      map.set(key, checkboxProps);
       false ? 0 : void 0;
    });
    return map;
  }, [flattedData, getRowKey, getCheckboxProps]);
  const isCheckboxDisabled = (0,react.useCallback)(r => {
    const rowKey = getRowKey(r);
    let checkboxProps;
    if (checkboxPropsMap.has(rowKey)) {
      checkboxProps = checkboxPropsMap.get(getRowKey(r));
    } else {
      checkboxProps = getCheckboxProps ? getCheckboxProps(r) : undefined;
    }
    return !!(checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.disabled);
  }, [checkboxPropsMap, getRowKey]);
  const [derivedSelectedKeys, derivedHalfSelectedKeys] = (0,react.useMemo)(() => {
    if (checkStrictly) {
      return [mergedSelectedKeys || [], []];
    }
    const {
      checkedKeys,
      halfCheckedKeys
    } = (0,conductUtil/* conductCheck */.S)(mergedSelectedKeys, true, keyEntities, isCheckboxDisabled);
    return [checkedKeys || [], halfCheckedKeys];
  }, [mergedSelectedKeys, checkStrictly, keyEntities, isCheckboxDisabled]);
  const derivedSelectedKeySet = (0,react.useMemo)(() => {
    const keys = selectionType === 'radio' ? derivedSelectedKeys.slice(0, 1) : derivedSelectedKeys;
    return new Set(keys);
  }, [derivedSelectedKeys, selectionType]);
  const derivedHalfSelectedKeySet = (0,react.useMemo)(() => selectionType === 'radio' ? new Set() : new Set(derivedHalfSelectedKeys), [derivedHalfSelectedKeys, selectionType]);
  // Reset if rowSelection reset
  react.useEffect(() => {
    if (!rowSelection) {
      setMergedSelectedKeys(useSelection_EMPTY_LIST);
    }
  }, [!!rowSelection]);
  const setSelectedKeys = (0,react.useCallback)((keys, method) => {
    let availableKeys;
    let records;
    updatePreserveRecordsCache(keys);
    if (preserveSelectedRowKeys) {
      availableKeys = keys;
      records = keys.map(key => preserveRecordsRef.current.get(key));
    } else {
      // Filter key which not exist in the `dataSource`
      availableKeys = [];
      records = [];
      keys.forEach(key => {
        const record = getRecordByKey(key);
        if (record !== undefined) {
          availableKeys.push(key);
          records.push(record);
        }
      });
    }
    setMergedSelectedKeys(availableKeys);
    onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(availableKeys, records, {
      type: method
    });
  }, [setMergedSelectedKeys, getRecordByKey, onSelectionChange, preserveSelectedRowKeys]);
  // ====================== Selections ======================
  // Trigger single `onSelect` event
  const triggerSingleSelection = (0,react.useCallback)((key, selected, keys, event) => {
    if (onSelect) {
      const rows = keys.map(k => getRecordByKey(k));
      onSelect(getRecordByKey(key), selected, rows, event);
    }
    setSelectedKeys(keys, 'single');
  }, [onSelect, getRecordByKey, setSelectedKeys]);
  const mergedSelections = (0,react.useMemo)(() => {
    if (!selections || hideSelectAll) {
      return null;
    }
    const selectionList = selections === true ? [SELECTION_ALL, SELECTION_INVERT, SELECTION_NONE] : selections;
    return selectionList.map(selection => {
      if (selection === SELECTION_ALL) {
        return {
          key: 'all',
          text: tableLocale.selectionAll,
          onSelect() {
            setSelectedKeys(data.map((record, index) => getRowKey(record, index)).filter(key => {
              const checkProps = checkboxPropsMap.get(key);
              return !(checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled) || derivedSelectedKeySet.has(key);
            }), 'all');
          }
        };
      }
      if (selection === SELECTION_INVERT) {
        return {
          key: 'invert',
          text: tableLocale.selectInvert,
          onSelect() {
            const keySet = new Set(derivedSelectedKeySet);
            pageData.forEach((record, index) => {
              const key = getRowKey(record, index);
              const checkProps = checkboxPropsMap.get(key);
              if (!(checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled)) {
                if (keySet.has(key)) {
                  keySet.delete(key);
                } else {
                  keySet.add(key);
                }
              }
            });
            const keys = Array.from(keySet);
            if (onSelectInvert) {
              warning.deprecated(false, 'onSelectInvert', 'onChange');
              onSelectInvert(keys);
            }
            setSelectedKeys(keys, 'invert');
          }
        };
      }
      if (selection === SELECTION_NONE) {
        return {
          key: 'none',
          text: tableLocale.selectNone,
          onSelect() {
            onSelectNone === null || onSelectNone === void 0 ? void 0 : onSelectNone();
            setSelectedKeys(Array.from(derivedSelectedKeySet).filter(key => {
              const checkProps = checkboxPropsMap.get(key);
              return checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled;
            }), 'none');
          }
        };
      }
      return selection;
    }).map(selection => Object.assign(Object.assign({}, selection), {
      onSelect: (...rest) => {
        var _a2;
        var _a;
        (_a = selection.onSelect) === null || _a === void 0 ? void 0 : (_a2 = _a).call.apply(_a2, [selection].concat(rest));
        updatePrevSelectedIndex(null);
      }
    }));
  }, [selections, derivedSelectedKeySet, pageData, getRowKey, onSelectInvert, setSelectedKeys]);
  // ======================= Columns ========================
  const transformColumns = (0,react.useCallback)(columns => {
    var _a;
    // >>>>>>>>>>> Skip if not exists `rowSelection`
    if (!rowSelection) {
       false ? 0 : void 0;
      return columns.filter(col => col !== SELECTION_COLUMN);
    }
    // >>>>>>>>>>> Support selection
    let cloneColumns = (0,toConsumableArray/* default */.Z)(columns);
    const keySet = new Set(derivedSelectedKeySet);
    // Record key only need check with enabled
    const recordKeys = flattedData.map(getRowKey).filter(key => !checkboxPropsMap.get(key).disabled);
    const checkedCurrentAll = recordKeys.every(key => keySet.has(key));
    const checkedCurrentSome = recordKeys.some(key => keySet.has(key));
    const onSelectAllChange = () => {
      const changeKeys = [];
      if (checkedCurrentAll) {
        recordKeys.forEach(key => {
          keySet.delete(key);
          changeKeys.push(key);
        });
      } else {
        recordKeys.forEach(key => {
          if (!keySet.has(key)) {
            keySet.add(key);
            changeKeys.push(key);
          }
        });
      }
      const keys = Array.from(keySet);
      onSelectAll === null || onSelectAll === void 0 ? void 0 : onSelectAll(!checkedCurrentAll, keys.map(k => getRecordByKey(k)), changeKeys.map(k => getRecordByKey(k)));
      setSelectedKeys(keys, 'all');
      updatePrevSelectedIndex(null);
    };
    // ===================== Render =====================
    // Title Cell
    let title;
    let columnTitleCheckbox;
    if (selectionType !== 'radio') {
      let customizeSelections;
      if (mergedSelections) {
        const menu = {
          getPopupContainer,
          items: mergedSelections.map((selection, index) => {
            const {
              key,
              text,
              onSelect: onSelectionClick
            } = selection;
            return {
              key: key !== null && key !== void 0 ? key : index,
              onClick: () => {
                onSelectionClick === null || onSelectionClick === void 0 ? void 0 : onSelectionClick(recordKeys);
              },
              label: text
            };
          })
        };
        customizeSelections = /*#__PURE__*/react.createElement("div", {
          className: `${prefixCls}-selection-extra`
        }, /*#__PURE__*/react.createElement(es_dropdown, {
          menu: menu,
          getPopupContainer: getPopupContainer
        }, /*#__PURE__*/react.createElement("span", null, /*#__PURE__*/react.createElement(DownOutlined/* default */.Z, null))));
      }
      const allDisabledData = flattedData.map((record, index) => {
        const key = getRowKey(record, index);
        const checkboxProps = checkboxPropsMap.get(key) || {};
        return Object.assign({
          checked: keySet.has(key)
        }, checkboxProps);
      }).filter(({
        disabled
      }) => disabled);
      const allDisabled = !!allDisabledData.length && allDisabledData.length === flattedData.length;
      const allDisabledAndChecked = allDisabled && allDisabledData.every(({
        checked
      }) => checked);
      const allDisabledSomeChecked = allDisabled && allDisabledData.some(({
        checked
      }) => checked);
      const customCheckboxProps = (getTitleCheckboxProps === null || getTitleCheckboxProps === void 0 ? void 0 : getTitleCheckboxProps()) || {};
      const {
        onChange,
        disabled
      } = customCheckboxProps;
      columnTitleCheckbox = /*#__PURE__*/react.createElement(es_checkbox, Object.assign({
        "aria-label": customizeSelections ? 'Custom selection' : 'Select all'
      }, customCheckboxProps, {
        checked: !allDisabled ? !!flattedData.length && checkedCurrentAll : allDisabledAndChecked,
        indeterminate: !allDisabled ? !checkedCurrentAll && checkedCurrentSome : !allDisabledAndChecked && allDisabledSomeChecked,
        onChange: e => {
          onSelectAllChange();
          onChange === null || onChange === void 0 ? void 0 : onChange(e);
        },
        disabled: disabled !== null && disabled !== void 0 ? disabled : flattedData.length === 0 || allDisabled,
        skipGroup: true
      }));
      title = !hideSelectAll && (/*#__PURE__*/react.createElement("div", {
        className: `${prefixCls}-selection`
      }, columnTitleCheckbox, customizeSelections));
    }
    // Body Cell
    let renderCell;
    if (selectionType === 'radio') {
      renderCell = (_, record, index) => {
        const key = getRowKey(record, index);
        const checked = keySet.has(key);
        const checkboxProps = checkboxPropsMap.get(key);
        return {
          node: (/*#__PURE__*/react.createElement(es_radio, Object.assign({}, checkboxProps, {
            checked: checked,
            onClick: e => {
              var _a;
              e.stopPropagation();
              (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onClick) === null || _a === void 0 ? void 0 : _a.call(checkboxProps, e);
            },
            onChange: event => {
              var _a;
              if (!keySet.has(key)) {
                triggerSingleSelection(key, true, [key], event.nativeEvent);
              }
              (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onChange) === null || _a === void 0 ? void 0 : _a.call(checkboxProps, event);
            }
          }))),
          checked
        };
      };
    } else {
      renderCell = (_, record, index) => {
        var _a;
        const key = getRowKey(record, index);
        const checked = keySet.has(key);
        const indeterminate = derivedHalfSelectedKeySet.has(key);
        const checkboxProps = checkboxPropsMap.get(key);
        let mergedIndeterminate;
        if (expandType === 'nest') {
          mergedIndeterminate = indeterminate;
           false ? 0 : void 0;
        } else {
          mergedIndeterminate = (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.indeterminate) !== null && _a !== void 0 ? _a : indeterminate;
        }
        // Record checked
        return {
          node: (/*#__PURE__*/react.createElement(es_checkbox, Object.assign({}, checkboxProps, {
            indeterminate: mergedIndeterminate,
            checked: checked,
            skipGroup: true,
            onClick: e => {
              var _a;
              e.stopPropagation();
              (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onClick) === null || _a === void 0 ? void 0 : _a.call(checkboxProps, e);
            },
            onChange: event => {
              var _a;
              const {
                nativeEvent
              } = event;
              const {
                shiftKey
              } = nativeEvent;
              const currentSelectedIndex = recordKeys.findIndex(item => item === key);
              const isMultiple = derivedSelectedKeys.some(item => recordKeys.includes(item));
              if (shiftKey && checkStrictly && isMultiple) {
                const changedKeys = multipleSelect(currentSelectedIndex, recordKeys, keySet);
                const keys = Array.from(keySet);
                onSelectMultiple === null || onSelectMultiple === void 0 ? void 0 : onSelectMultiple(!checked, keys.map(recordKey => getRecordByKey(recordKey)), changedKeys.map(recordKey => getRecordByKey(recordKey)));
                setSelectedKeys(keys, 'multiple');
              } else {
                // Single record selected
                const originCheckedKeys = derivedSelectedKeys;
                if (checkStrictly) {
                  const checkedKeys = checked ? (0,es_util/* arrDel */._5)(originCheckedKeys, key) : (0,es_util/* arrAdd */.L0)(originCheckedKeys, key);
                  triggerSingleSelection(key, !checked, checkedKeys, nativeEvent);
                } else {
                  // Always fill first
                  const result = (0,conductUtil/* conductCheck */.S)([].concat((0,toConsumableArray/* default */.Z)(originCheckedKeys), [key]), true, keyEntities, isCheckboxDisabled);
                  const {
                    checkedKeys,
                    halfCheckedKeys
                  } = result;
                  let nextCheckedKeys = checkedKeys;
                  // If remove, we do it again to correction
                  if (checked) {
                    const tempKeySet = new Set(checkedKeys);
                    tempKeySet.delete(key);
                    nextCheckedKeys = (0,conductUtil/* conductCheck */.S)(Array.from(tempKeySet), {
                      checked: false,
                      halfCheckedKeys
                    }, keyEntities, isCheckboxDisabled).checkedKeys;
                  }
                  triggerSingleSelection(key, !checked, nextCheckedKeys, nativeEvent);
                }
              }
              if (checked) {
                updatePrevSelectedIndex(null);
              } else {
                updatePrevSelectedIndex(currentSelectedIndex);
              }
              (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onChange) === null || _a === void 0 ? void 0 : _a.call(checkboxProps, event);
            }
          }))),
          checked
        };
      };
    }
    const renderSelectionCell = (_, record, index) => {
      const {
        node,
        checked
      } = renderCell(_, record, index);
      if (customizeRenderCell) {
        return customizeRenderCell(checked, record, index, node);
      }
      return node;
    };
    // Insert selection column if not exist
    if (!cloneColumns.includes(SELECTION_COLUMN)) {
      // Always after expand icon
      if (cloneColumns.findIndex(col => {
        var _a;
        return ((_a = col[rc_table_es/* INTERNAL_COL_DEFINE */.vP]) === null || _a === void 0 ? void 0 : _a.columnType) === 'EXPAND_COLUMN';
      }) === 0) {
        const [expandColumn, ...restColumns] = cloneColumns;
        cloneColumns = [expandColumn, SELECTION_COLUMN].concat((0,toConsumableArray/* default */.Z)(restColumns));
      } else {
        // Normal insert at first column
        cloneColumns = [SELECTION_COLUMN].concat((0,toConsumableArray/* default */.Z)(cloneColumns));
      }
    }
    // Deduplicate selection column
    const selectionColumnIndex = cloneColumns.indexOf(SELECTION_COLUMN);
     false ? 0 : void 0;
    cloneColumns = cloneColumns.filter((column, index) => column !== SELECTION_COLUMN || index === selectionColumnIndex);
    // Fixed column logic
    const prevCol = cloneColumns[selectionColumnIndex - 1];
    const nextCol = cloneColumns[selectionColumnIndex + 1];
    let mergedFixed = fixed;
    if (mergedFixed === undefined) {
      if ((nextCol === null || nextCol === void 0 ? void 0 : nextCol.fixed) !== undefined) {
        mergedFixed = nextCol.fixed;
      } else if ((prevCol === null || prevCol === void 0 ? void 0 : prevCol.fixed) !== undefined) {
        mergedFixed = prevCol.fixed;
      }
    }
    if (mergedFixed && prevCol && ((_a = prevCol[rc_table_es/* INTERNAL_COL_DEFINE */.vP]) === null || _a === void 0 ? void 0 : _a.columnType) === 'EXPAND_COLUMN' && prevCol.fixed === undefined) {
      prevCol.fixed = mergedFixed;
    }
    const columnCls = classnames_default()(`${prefixCls}-selection-col`, {
      [`${prefixCls}-selection-col-with-dropdown`]: selections && selectionType === 'checkbox'
    });
    const renderColumnTitle = () => {
      if (!(rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.columnTitle)) {
        return title;
      }
      if (typeof rowSelection.columnTitle === 'function') {
        return rowSelection.columnTitle(columnTitleCheckbox);
      }
      return rowSelection.columnTitle;
    };
    // Replace with real selection column
    const selectionColumn = {
      fixed: mergedFixed,
      width: selectionColWidth,
      className: `${prefixCls}-selection-column`,
      title: renderColumnTitle(),
      render: renderSelectionCell,
      onCell: rowSelection.onCell,
      align: rowSelection.align,
      [rc_table_es/* INTERNAL_COL_DEFINE */.vP]: {
        className: columnCls
      }
    };
    return cloneColumns.map(col => col === SELECTION_COLUMN ? selectionColumn : col);
  }, [getRowKey, flattedData, rowSelection, derivedSelectedKeys, derivedSelectedKeySet, derivedHalfSelectedKeySet, selectionColWidth, mergedSelections, expandType, checkboxPropsMap, onSelectMultiple, triggerSingleSelection, isCheckboxDisabled]);
  return [transformColumns, derivedSelectedKeySet];
};
/* harmony default export */ var hooks_useSelection = (useSelection);
// EXTERNAL MODULE: ./node_modules/rc-table/es/hooks/useColumns/index.js + 1 modules
var useColumns = __webpack_require__(51386);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/hooks/useProxyImperativeHandle.js
// Proxy the dom ref with `{ nativeElement, otherFn }` type
// ref: https://github.com/ant-design/ant-design/discussions/45242

function fillProxy(element, handler) {
  element._antProxy = element._antProxy || {};
  Object.keys(handler).forEach(key => {
    if (!(key in element._antProxy)) {
      const ori = element[key];
      element._antProxy[key] = ori;
      element[key] = handler[key];
    }
  });
  return element;
}
function useProxyImperativeHandle(ref, init) {
  return (0,react.useImperativeHandle)(ref, () => {
    const refObj = init();
    const {
      nativeElement
    } = refObj;
    if (typeof Proxy !== 'undefined') {
      return new Proxy(nativeElement, {
        get(obj, prop) {
          if (refObj[prop]) {
            return refObj[prop];
          }
          return Reflect.get(obj, prop);
        }
      });
    }
    // Fallback of IE
    return fillProxy(nativeElement, refObj);
  });
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/ExpandIcon.js
"use client";



function renderExpandIcon(locale) {
  return props => {
    const {
      prefixCls,
      onExpand,
      record,
      expanded,
      expandable
    } = props;
    const iconPrefix = `${prefixCls}-row-expand-icon`;
    return /*#__PURE__*/react.createElement("button", {
      type: "button",
      onClick: e => {
        onExpand(record, e);
        e.stopPropagation();
      },
      className: classnames_default()(iconPrefix, {
        [`${iconPrefix}-spaced`]: !expandable,
        [`${iconPrefix}-expanded`]: expandable && expanded,
        [`${iconPrefix}-collapsed`]: expandable && !expanded
      }),
      "aria-label": expanded ? locale.collapse : locale.expand,
      "aria-expanded": expanded
    });
  };
}
/* harmony default export */ var ExpandIcon = (renderExpandIcon);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/hooks/useContainerWidth.js
function useContainerWidth(prefixCls) {
  const getContainerWidth = (ele, width) => {
    const container = ele.querySelector(`.${prefixCls}-container`);
    let returnWidth = width;
    if (container) {
      const style = getComputedStyle(container);
      const borderLeft = parseInt(style.borderLeftWidth, 10);
      const borderRight = parseInt(style.borderRightWidth, 10);
      returnWidth = width - borderLeft - borderRight;
    }
    return returnWidth;
  };
  return getContainerWidth;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/util.js
const getColumnKey = (column, defaultKey) => {
  if ('key' in column && column.key !== undefined && column.key !== null) {
    return column.key;
  }
  if (column.dataIndex) {
    return Array.isArray(column.dataIndex) ? column.dataIndex.join('.') : column.dataIndex;
  }
  return defaultKey;
};
function getColumnPos(index, pos) {
  return pos ? `${pos}-${index}` : `${index}`;
}
const renderColumnTitle = (title, props) => {
  if (typeof title === 'function') {
    return title(props);
  }
  return title;
};
/**
 * Safe get column title
 *
 * Should filter [object Object]
 *
 * @param title
 */
const safeColumnTitle = (title, props) => {
  const res = renderColumnTitle(title, props);
  if (Object.prototype.toString.call(res) === '[object Object]') {
    return '';
  }
  return res;
};
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/FilterFilled.js + 1 modules
var FilterFilled = __webpack_require__(58032);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/hooks/useSyncState.js


function useSyncState(initialValue) {
  const ref = react.useRef(initialValue);
  const forceUpdate = useForceUpdate();
  return [() => ref.current, newValue => {
    ref.current = newValue;
    // re-render
    forceUpdate();
  }];
}
// EXTERNAL MODULE: ./node_modules/rc-tree/es/index.js + 7 modules
var rc_tree_es = __webpack_require__(54328);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/FileOutlined.js + 1 modules
var FileOutlined = __webpack_require__(7290);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/FolderOpenOutlined.js + 1 modules
var FolderOpenOutlined = __webpack_require__(11965);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/FolderOutlined.js + 1 modules
var FolderOutlined = __webpack_require__(92544);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/HolderOutlined.js + 1 modules
var HolderOutlined = __webpack_require__(84216);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tree/style/directory.js
// ============================ Directory =============================
const genDirectoryStyle = ({
  treeCls,
  treeNodeCls,
  directoryNodeSelectedBg,
  directoryNodeSelectedColor,
  motionDurationMid,
  borderRadius,
  controlItemBgHover
}) => ({
  [`${treeCls}${treeCls}-directory ${treeNodeCls}`]: {
    // >>> Title
    [`${treeCls}-node-content-wrapper`]: {
      position: 'static',
      [`&:has(${treeCls}-drop-indicator)`]: {
        position: 'relative'
      },
      [`> *:not(${treeCls}-drop-indicator)`]: {
        position: 'relative'
      },
      '&:hover': {
        background: 'transparent'
      },
      // Expand interactive area to whole line
      '&:before': {
        position: 'absolute',
        inset: 0,
        transition: `background-color ${motionDurationMid}`,
        content: '""',
        borderRadius
      },
      '&:hover:before': {
        background: controlItemBgHover
      }
    },
    [`${treeCls}-switcher, ${treeCls}-checkbox, ${treeCls}-draggable-icon`]: {
      zIndex: 1
    },
    // ============= Selected =============
    '&-selected': {
      background: directoryNodeSelectedBg,
      borderRadius,
      [`${treeCls}-switcher, ${treeCls}-draggable-icon`]: {
        color: directoryNodeSelectedColor
      },
      // >>> Title
      [`${treeCls}-node-content-wrapper`]: {
        color: directoryNodeSelectedColor,
        background: 'transparent',
        '&:before, &:hover:before': {
          background: directoryNodeSelectedBg
        }
      }
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tree/style/index.js






// ============================ Keyframes =============================
const treeNodeFX = new cssinjs_es/* Keyframes */.E4('ant-tree-node-fx-do-not-use', {
  '0%': {
    opacity: 0
  },
  '100%': {
    opacity: 1
  }
});
// ============================== Switch ==============================
const getSwitchStyle = (prefixCls, token) => ({
  [`.${prefixCls}-switcher-icon`]: {
    display: 'inline-block',
    fontSize: 10,
    verticalAlign: 'baseline',
    svg: {
      transition: `transform ${token.motionDurationSlow}`
    }
  }
});
// =============================== Drop ===============================
const getDropIndicatorStyle = (prefixCls, token) => ({
  [`.${prefixCls}-drop-indicator`]: {
    position: 'absolute',
    // it should displayed over the following node
    zIndex: 1,
    height: 2,
    backgroundColor: token.colorPrimary,
    borderRadius: 1,
    pointerEvents: 'none',
    '&:after': {
      position: 'absolute',
      top: -3,
      insetInlineStart: -6,
      width: 8,
      height: 8,
      backgroundColor: 'transparent',
      border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidthBold)} solid ${token.colorPrimary}`,
      borderRadius: '50%',
      content: '""'
    }
  }
});
const tree_style_genBaseStyle = (prefixCls, token) => {
  const {
    treeCls,
    treeNodeCls,
    treeNodePadding,
    titleHeight,
    indentSize,
    nodeSelectedBg,
    nodeHoverBg,
    colorTextQuaternary,
    controlItemBgActiveDisabled
  } = token;
  return {
    [treeCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      // fix https://github.com/ant-design/ant-design/issues/50316
      ['--rc-virtual-list-scrollbar-bg']: token.colorSplit,
      background: token.colorBgContainer,
      borderRadius: token.borderRadius,
      transition: `background-color ${token.motionDurationSlow}`,
      '&-rtl': {
        direction: 'rtl'
      },
      [`&${treeCls}-rtl ${treeCls}-switcher_close ${treeCls}-switcher-icon svg`]: {
        transform: 'rotate(90deg)'
      },
      [`&-focused:not(:hover):not(${treeCls}-active-focused)`]: genFocusOutline(token),
      // =================== Virtual List ===================
      [`${treeCls}-list-holder-inner`]: {
        alignItems: 'flex-start'
      },
      [`&${treeCls}-block-node`]: {
        [`${treeCls}-list-holder-inner`]: {
          alignItems: 'stretch',
          // >>> Title
          [`${treeCls}-node-content-wrapper`]: {
            flex: 'auto'
          },
          // >>> Drag
          [`${treeNodeCls}.dragging:after`]: {
            position: 'absolute',
            inset: 0,
            border: `1px solid ${token.colorPrimary}`,
            opacity: 0,
            animationName: treeNodeFX,
            animationDuration: token.motionDurationSlow,
            animationPlayState: 'running',
            animationFillMode: 'forwards',
            content: '""',
            pointerEvents: 'none',
            borderRadius: token.borderRadius
          }
        }
      },
      // ===================== TreeNode =====================
      [treeNodeCls]: {
        display: 'flex',
        alignItems: 'flex-start',
        marginBottom: treeNodePadding,
        lineHeight: (0,cssinjs_es/* unit */.bf)(titleHeight),
        position: 'relative',
        // 非常重要，避免 drop-indicator 在拖拽过程中闪烁
        '&:before': {
          content: '""',
          position: 'absolute',
          zIndex: 1,
          insetInlineStart: 0,
          width: '100%',
          top: '100%',
          height: treeNodePadding
        },
        // Disabled
        [`&-disabled ${treeCls}-node-content-wrapper`]: {
          color: token.colorTextDisabled,
          cursor: 'not-allowed',
          '&:hover': {
            background: 'transparent'
          }
        },
        [`${treeCls}-checkbox-disabled + ${treeCls}-node-selected,&${treeNodeCls}-disabled${treeNodeCls}-selected ${treeCls}-node-content-wrapper`]: {
          backgroundColor: controlItemBgActiveDisabled
        },
        // we can not set pointer-events to none for checkbox in tree
        // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-2605234058
        [`${treeCls}-checkbox-disabled`]: {
          pointerEvents: 'unset'
        },
        // not disable
        [`&:not(${treeNodeCls}-disabled)`]: {
          // >>> Title
          [`${treeCls}-node-content-wrapper`]: {
            '&:hover': {
              color: token.nodeHoverColor
            }
          }
        },
        [`&-active ${treeCls}-node-content-wrapper`]: {
          background: token.controlItemBgHover
        },
        [`&:not(${treeNodeCls}-disabled).filter-node ${treeCls}-title`]: {
          color: token.colorPrimary,
          fontWeight: token.fontWeightStrong
        },
        '&-draggable': {
          cursor: 'grab',
          [`${treeCls}-draggable-icon`]: {
            // https://github.com/ant-design/ant-design/issues/41915
            flexShrink: 0,
            width: titleHeight,
            textAlign: 'center',
            visibility: 'visible',
            color: colorTextQuaternary
          },
          [`&${treeNodeCls}-disabled ${treeCls}-draggable-icon`]: {
            visibility: 'hidden'
          }
        }
      },
      // >>> Indent
      [`${treeCls}-indent`]: {
        alignSelf: 'stretch',
        whiteSpace: 'nowrap',
        userSelect: 'none',
        '&-unit': {
          display: 'inline-block',
          width: indentSize
        }
      },
      // >>> Drag Handler
      [`${treeCls}-draggable-icon`]: {
        visibility: 'hidden'
      },
      // Switcher / Checkbox
      [`${treeCls}-switcher, ${treeCls}-checkbox`]: {
        marginInlineEnd: token.calc(token.calc(titleHeight).sub(token.controlInteractiveSize)).div(2).equal()
      },
      // >>> Switcher
      [`${treeCls}-switcher`]: Object.assign(Object.assign({}, getSwitchStyle(prefixCls, token)), {
        position: 'relative',
        flex: 'none',
        alignSelf: 'stretch',
        width: titleHeight,
        textAlign: 'center',
        cursor: 'pointer',
        userSelect: 'none',
        transition: `all ${token.motionDurationSlow}`,
        '&-noop': {
          cursor: 'unset'
        },
        '&:before': {
          pointerEvents: 'none',
          content: '""',
          width: titleHeight,
          height: titleHeight,
          position: 'absolute',
          left: {
            _skip_check_: true,
            value: 0
          },
          top: 0,
          borderRadius: token.borderRadius,
          transition: `all ${token.motionDurationSlow}`
        },
        [`&:not(${treeCls}-switcher-noop):hover:before`]: {
          backgroundColor: token.colorBgTextHover
        },
        [`&_close ${treeCls}-switcher-icon svg`]: {
          transform: 'rotate(-90deg)'
        },
        '&-loading-icon': {
          color: token.colorPrimary
        },
        '&-leaf-line': {
          position: 'relative',
          zIndex: 1,
          display: 'inline-block',
          width: '100%',
          height: '100%',
          // https://github.com/ant-design/ant-design/issues/31884
          '&:before': {
            position: 'absolute',
            top: 0,
            insetInlineEnd: token.calc(titleHeight).div(2).equal(),
            bottom: token.calc(treeNodePadding).mul(-1).equal(),
            marginInlineStart: -1,
            borderInlineEnd: `1px solid ${token.colorBorder}`,
            content: '""'
          },
          '&:after': {
            position: 'absolute',
            width: token.calc(token.calc(titleHeight).div(2).equal()).mul(0.8).equal(),
            height: token.calc(titleHeight).div(2).equal(),
            borderBottom: `1px solid ${token.colorBorder}`,
            content: '""'
          }
        }
      }),
      // >>> Title
      // add `${treeCls}-checkbox + span` to cover checkbox `${checkboxCls} + span`
      [`${treeCls}-node-content-wrapper`]: Object.assign(Object.assign({
        position: 'relative',
        minHeight: titleHeight,
        paddingBlock: 0,
        paddingInline: token.paddingXS,
        background: 'transparent',
        borderRadius: token.borderRadius,
        cursor: 'pointer',
        transition: `all ${token.motionDurationMid}, border 0s, line-height 0s, box-shadow 0s`
      }, getDropIndicatorStyle(prefixCls, token)), {
        '&:hover': {
          backgroundColor: nodeHoverBg
        },
        [`&${treeCls}-node-selected`]: {
          color: token.nodeSelectedColor,
          backgroundColor: nodeSelectedBg
        },
        // Icon
        [`${treeCls}-iconEle`]: {
          display: 'inline-block',
          width: titleHeight,
          height: titleHeight,
          textAlign: 'center',
          verticalAlign: 'top',
          '&:empty': {
            display: 'none'
          }
        }
      }),
      // https://github.com/ant-design/ant-design/issues/28217
      [`${treeCls}-unselectable ${treeCls}-node-content-wrapper:hover`]: {
        backgroundColor: 'transparent'
      },
      [`${treeNodeCls}.drop-container > [draggable]`]: {
        boxShadow: `0 0 0 2px ${token.colorPrimary}`
      },
      // ==================== Show Line =====================
      '&-show-line': {
        // ================ Indent lines ================
        [`${treeCls}-indent-unit`]: {
          position: 'relative',
          height: '100%',
          '&:before': {
            position: 'absolute',
            top: 0,
            insetInlineEnd: token.calc(titleHeight).div(2).equal(),
            bottom: token.calc(treeNodePadding).mul(-1).equal(),
            borderInlineEnd: `1px solid ${token.colorBorder}`,
            content: '""'
          },
          '&-end:before': {
            display: 'none'
          }
        },
        // ============== Cover Background ==============
        [`${treeCls}-switcher`]: {
          background: 'transparent',
          '&-line-icon': {
            // https://github.com/ant-design/ant-design/issues/32813
            verticalAlign: '-0.15em'
          }
        }
      },
      [`${treeNodeCls}-leaf-last ${treeCls}-switcher-leaf-line:before`]: {
        top: 'auto !important',
        bottom: 'auto !important',
        height: `${(0,cssinjs_es/* unit */.bf)(token.calc(titleHeight).div(2).equal())} !important`
      }
    })
  };
};
// ============================== Merged ==============================
const genTreeStyle = (prefixCls, token,
/**
 * @descCN 是否启用目录树样式
 * @descEN Whether to enable directory style
 * @default true
 */
enableDirectory = true) => {
  const treeCls = `.${prefixCls}`;
  const treeNodeCls = `${treeCls}-treenode`;
  const treeNodePadding = token.calc(token.paddingXS).div(2).equal();
  const treeToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    treeCls,
    treeNodeCls,
    treeNodePadding
  });
  return [
  // Basic
  tree_style_genBaseStyle(prefixCls, treeToken),
  // Directory
  enableDirectory && genDirectoryStyle(treeToken)].filter(Boolean);
};
const style_initComponentToken = token => {
  const {
    controlHeightSM,
    controlItemBgHover,
    controlItemBgActive
  } = token;
  const titleHeight = controlHeightSM;
  return {
    titleHeight,
    indentSize: titleHeight,
    nodeHoverBg: controlItemBgHover,
    nodeHoverColor: token.colorText,
    nodeSelectedBg: controlItemBgActive,
    nodeSelectedColor: token.colorText
  };
};
const tree_style_prepareComponentToken = token => {
  const {
    colorTextLightSolid,
    colorPrimary
  } = token;
  return Object.assign(Object.assign({}, style_initComponentToken(token)), {
    directoryNodeSelectedColor: colorTextLightSolid,
    directoryNodeSelectedBg: colorPrimary
  });
};
/* harmony default export */ var tree_style = (genStyleHooks('Tree', (token, {
  prefixCls
}) => [{
  [token.componentCls]: style_getStyle(`${prefixCls}-checkbox`, token)
}, genTreeStyle(prefixCls, token), collapse(token)], tree_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tree/utils/dropIndicator.js
"use client";


const offset = 4;
function dropIndicatorRender(props) {
  const {
    dropPosition,
    dropLevelOffset,
    prefixCls,
    indent,
    direction = 'ltr'
  } = props;
  const startPosition = direction === 'ltr' ? 'left' : 'right';
  const endPosition = direction === 'ltr' ? 'right' : 'left';
  const style = {
    [startPosition]: -dropLevelOffset * indent + offset,
    [endPosition]: 0
  };
  switch (dropPosition) {
    case -1:
      style.top = -3;
      break;
    case 1:
      style.bottom = -3;
      break;
    default:
      // dropPosition === 0
      style.bottom = -3;
      style[startPosition] = indent + offset;
      break;
  }
  return /*#__PURE__*/react.createElement("div", {
    style: style,
    className: `${prefixCls}-drop-indicator`
  });
}
/* harmony default export */ var dropIndicator = (dropIndicatorRender);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CaretDownFilled.js + 1 modules
var CaretDownFilled = __webpack_require__(75412);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/MinusSquareOutlined.js + 1 modules
var MinusSquareOutlined = __webpack_require__(2094);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PlusSquareOutlined.js + 1 modules
var PlusSquareOutlined = __webpack_require__(86856);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tree/utils/iconUtil.js
"use client";









const SwitcherIconCom = props => {
  var _a, _b;
  const {
    prefixCls,
    switcherIcon,
    treeNodeProps,
    showLine,
    switcherLoadingIcon
  } = props;
  const {
    isLeaf,
    expanded,
    loading
  } = treeNodeProps;
  if (loading) {
    if (/*#__PURE__*/react.isValidElement(switcherLoadingIcon)) {
      return switcherLoadingIcon;
    }
    return /*#__PURE__*/react.createElement(LoadingOutlined/* default */.Z, {
      className: `${prefixCls}-switcher-loading-icon`
    });
  }
  let showLeafIcon;
  if (showLine && typeof showLine === 'object') {
    showLeafIcon = showLine.showLeafIcon;
  }
  if (isLeaf) {
    if (!showLine) {
      return null;
    }
    if (typeof showLeafIcon !== 'boolean' && !!showLeafIcon) {
      const leafIcon = typeof showLeafIcon === 'function' ? showLeafIcon(treeNodeProps) : showLeafIcon;
      const leafCls = `${prefixCls}-switcher-line-custom-icon`;
      if (/*#__PURE__*/react.isValidElement(leafIcon)) {
        return cloneElement(leafIcon, {
          className: classnames_default()((_a = leafIcon.props) === null || _a === void 0 ? void 0 : _a.className, leafCls)
        });
      }
      return leafIcon;
    }
    return showLeafIcon ? (/*#__PURE__*/react.createElement(FileOutlined/* default */.Z, {
      className: `${prefixCls}-switcher-line-icon`
    })) : (/*#__PURE__*/react.createElement("span", {
      className: `${prefixCls}-switcher-leaf-line`
    }));
  }
  const switcherCls = `${prefixCls}-switcher-icon`;
  const switcher = typeof switcherIcon === 'function' ? switcherIcon(treeNodeProps) : switcherIcon;
  if (/*#__PURE__*/react.isValidElement(switcher)) {
    return cloneElement(switcher, {
      className: classnames_default()((_b = switcher.props) === null || _b === void 0 ? void 0 : _b.className, switcherCls)
    });
  }
  if (switcher !== undefined) {
    return switcher;
  }
  if (showLine) {
    return expanded ? (/*#__PURE__*/react.createElement(MinusSquareOutlined/* default */.Z, {
      className: `${prefixCls}-switcher-line-icon`
    })) : (/*#__PURE__*/react.createElement(PlusSquareOutlined/* default */.Z, {
      className: `${prefixCls}-switcher-line-icon`
    }));
  }
  return /*#__PURE__*/react.createElement(CaretDownFilled/* default */.Z, {
    className: switcherCls
  });
};
/* harmony default export */ var iconUtil = (SwitcherIconCom);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tree/Tree.js
"use client";











const Tree = /*#__PURE__*/react.forwardRef((props, ref) => {
  var _a;
  const {
    getPrefixCls,
    direction,
    virtual,
    tree
  } = react.useContext(ConfigContext);
  const {
    prefixCls: customizePrefixCls,
    className,
    showIcon = false,
    showLine,
    switcherIcon,
    switcherLoadingIcon,
    blockNode = false,
    children,
    checkable = false,
    selectable = true,
    draggable,
    motion: customMotion,
    style
  } = props;
  const prefixCls = getPrefixCls('tree', customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  const motion = customMotion !== null && customMotion !== void 0 ? customMotion : Object.assign(Object.assign({}, _util_motion(rootPrefixCls)), {
    motionAppear: false
  });
  const newProps = Object.assign(Object.assign({}, props), {
    checkable,
    selectable,
    showIcon,
    motion,
    blockNode,
    showLine: Boolean(showLine),
    dropIndicatorRender: dropIndicator
  });
  const [wrapCSSVar, hashId, cssVarCls] = tree_style(prefixCls);
  const [, token] = useToken();
  const itemHeight = token.paddingXS / 2 + (((_a = token.Tree) === null || _a === void 0 ? void 0 : _a.titleHeight) || token.controlHeightSM);
  const draggableConfig = react.useMemo(() => {
    if (!draggable) {
      return false;
    }
    let mergedDraggable = {};
    switch (typeof draggable) {
      case 'function':
        mergedDraggable.nodeDraggable = draggable;
        break;
      case 'object':
        mergedDraggable = Object.assign({}, draggable);
        break;
      default:
        break;
      // Do nothing
    }
    if (mergedDraggable.icon !== false) {
      mergedDraggable.icon = mergedDraggable.icon || /*#__PURE__*/react.createElement(HolderOutlined/* default */.Z, null);
    }
    return mergedDraggable;
  }, [draggable]);
  const renderSwitcherIcon = nodeProps => (/*#__PURE__*/react.createElement(iconUtil, {
    prefixCls: prefixCls,
    switcherIcon: switcherIcon,
    switcherLoadingIcon: switcherLoadingIcon,
    treeNodeProps: nodeProps,
    showLine: showLine
  }));
  return wrapCSSVar(/*#__PURE__*/
  // @ts-ignore
  react.createElement(rc_tree_es/* default */.ZP, Object.assign({
    itemHeight: itemHeight,
    ref: ref,
    virtual: virtual
  }, newProps, {
    // newProps may contain style so declare style below it
    style: Object.assign(Object.assign({}, tree === null || tree === void 0 ? void 0 : tree.style), style),
    prefixCls: prefixCls,
    className: classnames_default()({
      [`${prefixCls}-icon-hide`]: !showIcon,
      [`${prefixCls}-block-node`]: blockNode,
      [`${prefixCls}-unselectable`]: !selectable,
      [`${prefixCls}-rtl`]: direction === 'rtl'
    }, tree === null || tree === void 0 ? void 0 : tree.className, className, hashId, cssVarCls),
    direction: direction,
    checkable: checkable ? /*#__PURE__*/react.createElement("span", {
      className: `${prefixCls}-checkbox-inner`
    }) : checkable,
    selectable: selectable,
    switcherIcon: renderSwitcherIcon,
    draggable: draggableConfig
  }), children));
});
if (false) {}
/* harmony default export */ var tree_Tree = (Tree);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tree/utils/dictUtil.js


const RECORD_NONE = 0;
const RECORD_START = 1;
const RECORD_END = 2;
function traverseNodesKey(treeData, callback, fieldNames) {
  const {
    key: fieldKey,
    children: fieldChildren
  } = fieldNames;
  function processNode(dataNode) {
    const key = dataNode[fieldKey];
    const children = dataNode[fieldChildren];
    if (callback(key, dataNode) !== false) {
      traverseNodesKey(children || [], callback, fieldNames);
    }
  }
  treeData.forEach(processNode);
}
/** 计算选中范围，只考虑expanded情况以优化性能 */
function calcRangeKeys({
  treeData,
  expandedKeys,
  startKey,
  endKey,
  fieldNames
}) {
  const keys = [];
  let record = RECORD_NONE;
  if (startKey && startKey === endKey) {
    return [startKey];
  }
  if (!startKey || !endKey) {
    return [];
  }
  function matchKey(key) {
    return key === startKey || key === endKey;
  }
  traverseNodesKey(treeData, key => {
    if (record === RECORD_END) {
      return false;
    }
    if (matchKey(key)) {
      // Match test
      keys.push(key);
      if (record === RECORD_NONE) {
        record = RECORD_START;
      } else if (record === RECORD_START) {
        record = RECORD_END;
        return false;
      }
    } else if (record === RECORD_START) {
      // Append selection
      keys.push(key);
    }
    return expandedKeys.includes(key);
  }, (0,treeUtil/* fillFieldNames */.w$)(fieldNames));
  return keys;
}
function convertDirectoryKeysToNodes(treeData, keys, fieldNames) {
  const restKeys = (0,toConsumableArray/* default */.Z)(keys);
  const nodes = [];
  traverseNodesKey(treeData, (key, node) => {
    const index = restKeys.indexOf(key);
    if (index !== -1) {
      nodes.push(node);
      restKeys.splice(index, 1);
    }
    return !!restKeys.length;
  }, (0,treeUtil/* fillFieldNames */.w$)(fieldNames));
  return nodes;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tree/DirectoryTree.js
"use client";


var DirectoryTree_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};










function getIcon(props) {
  const {
    isLeaf,
    expanded
  } = props;
  if (isLeaf) {
    return /*#__PURE__*/react.createElement(FileOutlined/* default */.Z, null);
  }
  return expanded ? /*#__PURE__*/react.createElement(FolderOpenOutlined/* default */.Z, null) : /*#__PURE__*/react.createElement(FolderOutlined/* default */.Z, null);
}
function getTreeData({
  treeData,
  children
}) {
  return treeData || (0,treeUtil/* convertTreeToData */.zn)(children);
}
const DirectoryTree = (_a, ref) => {
  var {
      defaultExpandAll,
      defaultExpandParent,
      defaultExpandedKeys
    } = _a,
    props = DirectoryTree_rest(_a, ["defaultExpandAll", "defaultExpandParent", "defaultExpandedKeys"]);
  // Shift click usage
  const lastSelectedKey = react.useRef(null);
  const cachedSelectedKeys = react.useRef(null);
  const getInitExpandedKeys = () => {
    const {
      keyEntities
    } = (0,treeUtil/* convertDataToEntities */.I8)(getTreeData(props));
    let initExpandedKeys;
    // Expanded keys
    if (defaultExpandAll) {
      initExpandedKeys = Object.keys(keyEntities);
    } else if (defaultExpandParent) {
      initExpandedKeys = (0,es_util/* conductExpandParent */.r7)(props.expandedKeys || defaultExpandedKeys || [], keyEntities);
    } else {
      initExpandedKeys = props.expandedKeys || defaultExpandedKeys || [];
    }
    return initExpandedKeys;
  };
  const [selectedKeys, setSelectedKeys] = react.useState(props.selectedKeys || props.defaultSelectedKeys || []);
  const [expandedKeys, setExpandedKeys] = react.useState(() => getInitExpandedKeys());
  react.useEffect(() => {
    if ('selectedKeys' in props) {
      setSelectedKeys(props.selectedKeys);
    }
  }, [props.selectedKeys]);
  react.useEffect(() => {
    if ('expandedKeys' in props) {
      setExpandedKeys(props.expandedKeys);
    }
  }, [props.expandedKeys]);
  const onExpand = (keys, info) => {
    var _a;
    if (!('expandedKeys' in props)) {
      setExpandedKeys(keys);
    }
    // Call origin function
    return (_a = props.onExpand) === null || _a === void 0 ? void 0 : _a.call(props, keys, info);
  };
  const onSelect = (keys, event) => {
    var _a;
    const {
      multiple,
      fieldNames
    } = props;
    const {
      node,
      nativeEvent
    } = event;
    const {
      key = ''
    } = node;
    const treeData = getTreeData(props);
    // const newState: DirectoryTreeState = {};
    // We need wrap this event since some value is not same
    const newEvent = Object.assign(Object.assign({}, event), {
      selected: true
    });
    // Windows / Mac single pick
    const ctrlPick = (nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.ctrlKey) || (nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.metaKey);
    const shiftPick = nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.shiftKey;
    // Generate new selected keys
    let newSelectedKeys;
    if (multiple && ctrlPick) {
      // Control click
      newSelectedKeys = keys;
      lastSelectedKey.current = key;
      cachedSelectedKeys.current = newSelectedKeys;
      newEvent.selectedNodes = convertDirectoryKeysToNodes(treeData, newSelectedKeys, fieldNames);
    } else if (multiple && shiftPick) {
      // Shift click
      newSelectedKeys = Array.from(new Set([].concat((0,toConsumableArray/* default */.Z)(cachedSelectedKeys.current || []), (0,toConsumableArray/* default */.Z)(calcRangeKeys({
        treeData,
        expandedKeys,
        startKey: key,
        endKey: lastSelectedKey.current,
        fieldNames
      })))));
      newEvent.selectedNodes = convertDirectoryKeysToNodes(treeData, newSelectedKeys, fieldNames);
    } else {
      // Single click
      newSelectedKeys = [key];
      lastSelectedKey.current = key;
      cachedSelectedKeys.current = newSelectedKeys;
      newEvent.selectedNodes = convertDirectoryKeysToNodes(treeData, newSelectedKeys, fieldNames);
    }
    (_a = props.onSelect) === null || _a === void 0 ? void 0 : _a.call(props, newSelectedKeys, newEvent);
    if (!('selectedKeys' in props)) {
      setSelectedKeys(newSelectedKeys);
    }
  };
  const {
    getPrefixCls,
    direction
  } = react.useContext(ConfigContext);
  const {
      prefixCls: customizePrefixCls,
      className,
      showIcon = true,
      expandAction = 'click'
    } = props,
    otherProps = DirectoryTree_rest(props, ["prefixCls", "className", "showIcon", "expandAction"]);
  const prefixCls = getPrefixCls('tree', customizePrefixCls);
  const connectClassName = classnames_default()(`${prefixCls}-directory`, {
    [`${prefixCls}-directory-rtl`]: direction === 'rtl'
  }, className);
  return /*#__PURE__*/react.createElement(tree_Tree, Object.assign({
    icon: getIcon,
    ref: ref,
    blockNode: true
  }, otherProps, {
    showIcon: showIcon,
    expandAction: expandAction,
    prefixCls: prefixCls,
    className: connectClassName,
    expandedKeys: expandedKeys,
    selectedKeys: selectedKeys,
    onSelect: onSelect,
    onExpand: onExpand
  }));
};
const ForwardDirectoryTree = /*#__PURE__*/react.forwardRef(DirectoryTree);
if (false) {}
/* harmony default export */ var tree_DirectoryTree = (ForwardDirectoryTree);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tree/index.js
"use client";




const es_tree_Tree = tree_Tree;
es_tree_Tree.DirectoryTree = tree_DirectoryTree;
es_tree_Tree.TreeNode = rc_tree_es/* TreeNode */.OF;
/* harmony default export */ var tree = (es_tree_Tree);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/hooks/useFilter/FilterSearch.js
"use client";




const FilterSearch = props => {
  const {
    value,
    filterSearch,
    tablePrefixCls,
    locale,
    onChange
  } = props;
  if (!filterSearch) {
    return null;
  }
  return /*#__PURE__*/react.createElement("div", {
    className: `${tablePrefixCls}-filter-dropdown-search`
  }, /*#__PURE__*/react.createElement(input_Input, {
    prefix: /*#__PURE__*/react.createElement(SearchOutlined/* default */.Z, null),
    placeholder: locale.filterSearchPlaceholder,
    onChange: onChange,
    value: value,
    // for skip min-width of input
    htmlSize: 1,
    className: `${tablePrefixCls}-filter-dropdown-search-input`
  }));
};
/* harmony default export */ var useFilter_FilterSearch = (FilterSearch);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/hooks/useFilter/FilterWrapper.js
"use client";



const onKeyDown = event => {
  const {
    keyCode
  } = event;
  if (keyCode === KeyCode/* default.ENTER */.Z.ENTER) {
    event.stopPropagation();
  }
};
const FilterDropdownMenuWrapper = /*#__PURE__*/react.forwardRef((props, ref) => (/*#__PURE__*/react.createElement("div", {
  className: props.className,
  onClick: e => e.stopPropagation(),
  onKeyDown: onKeyDown,
  ref: ref
}, props.children)));
if (false) {}
/* harmony default export */ var FilterWrapper = (FilterDropdownMenuWrapper);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/hooks/useFilter/FilterDropdown.js
"use client";




















function flattenKeys(filters) {
  let keys = [];
  (filters || []).forEach(({
    value,
    children
  }) => {
    keys.push(value);
    if (children) {
      keys = [].concat((0,toConsumableArray/* default */.Z)(keys), (0,toConsumableArray/* default */.Z)(flattenKeys(children)));
    }
  });
  return keys;
}
function hasSubMenu(filters) {
  return filters.some(({
    children
  }) => children);
}
function searchValueMatched(searchValue, text) {
  if (typeof text === 'string' || typeof text === 'number') {
    return text === null || text === void 0 ? void 0 : text.toString().toLowerCase().includes(searchValue.trim().toLowerCase());
  }
  return false;
}
function renderFilterItems({
  filters,
  prefixCls,
  filteredKeys,
  filterMultiple,
  searchValue,
  filterSearch
}) {
  return filters.map((filter, index) => {
    const key = String(filter.value);
    if (filter.children) {
      return {
        key: key || index,
        label: filter.text,
        popupClassName: `${prefixCls}-dropdown-submenu`,
        children: renderFilterItems({
          filters: filter.children,
          prefixCls,
          filteredKeys,
          filterMultiple,
          searchValue,
          filterSearch
        })
      };
    }
    const Component = filterMultiple ? es_checkbox : es_radio;
    const item = {
      key: filter.value !== undefined ? key : index,
      label: (/*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Component, {
        checked: filteredKeys.includes(key)
      }), /*#__PURE__*/react.createElement("span", null, filter.text)))
    };
    if (searchValue.trim()) {
      if (typeof filterSearch === 'function') {
        return filterSearch(searchValue, filter) ? item : null;
      }
      return searchValueMatched(searchValue, filter.text) ? item : null;
    }
    return item;
  });
}
function wrapStringListType(keys) {
  return keys || [];
}
const FilterDropdown = props => {
  var _a, _b, _c, _d;
  const {
    tablePrefixCls,
    prefixCls,
    column,
    dropdownPrefixCls,
    columnKey,
    filterOnClose,
    filterMultiple,
    filterMode = 'menu',
    filterSearch = false,
    filterState,
    triggerFilter,
    locale,
    children,
    getPopupContainer,
    rootClassName
  } = props;
  const {
    filterResetToDefaultFilteredValue,
    defaultFilteredValue,
    filterDropdownProps = {},
    // Deprecated
    filterDropdownOpen,
    filterDropdownVisible,
    onFilterDropdownVisibleChange,
    onFilterDropdownOpenChange
  } = column;
  const [visible, setVisible] = react.useState(false);
  const filtered = !!(filterState && (((_a = filterState.filteredKeys) === null || _a === void 0 ? void 0 : _a.length) || filterState.forceFiltered));
  const triggerVisible = newVisible => {
    var _a;
    setVisible(newVisible);
    (_a = filterDropdownProps.onOpenChange) === null || _a === void 0 ? void 0 : _a.call(filterDropdownProps, newVisible);
    // deprecated
    onFilterDropdownOpenChange === null || onFilterDropdownOpenChange === void 0 ? void 0 : onFilterDropdownOpenChange(newVisible);
    onFilterDropdownVisibleChange === null || onFilterDropdownVisibleChange === void 0 ? void 0 : onFilterDropdownVisibleChange(newVisible);
  };
  // =================Warning===================
  if (false) {}
  const mergedVisible = (_d = (_c = (_b = filterDropdownProps.open) !== null && _b !== void 0 ? _b : filterDropdownOpen) !== null && _c !== void 0 ? _c : filterDropdownVisible) !== null && _d !== void 0 ? _d : visible; // inner state
  // ===================== Select Keys =====================
  const propFilteredKeys = filterState === null || filterState === void 0 ? void 0 : filterState.filteredKeys;
  const [getFilteredKeysSync, setFilteredKeysSync] = useSyncState(wrapStringListType(propFilteredKeys));
  const onSelectKeys = ({
    selectedKeys
  }) => {
    setFilteredKeysSync(selectedKeys);
  };
  const onCheck = (keys, {
    node,
    checked
  }) => {
    if (!filterMultiple) {
      onSelectKeys({
        selectedKeys: checked && node.key ? [node.key] : []
      });
    } else {
      onSelectKeys({
        selectedKeys: keys
      });
    }
  };
  react.useEffect(() => {
    if (!visible) {
      return;
    }
    onSelectKeys({
      selectedKeys: wrapStringListType(propFilteredKeys)
    });
  }, [propFilteredKeys]);
  // ====================== Open Keys ======================
  const [openKeys, setOpenKeys] = react.useState([]);
  const onOpenChange = keys => {
    setOpenKeys(keys);
  };
  // search in tree mode column filter
  const [searchValue, setSearchValue] = react.useState('');
  const onSearch = e => {
    const {
      value
    } = e.target;
    setSearchValue(value);
  };
  // clear search value after close filter dropdown
  react.useEffect(() => {
    if (!visible) {
      setSearchValue('');
    }
  }, [visible]);
  // ======================= Submit ========================
  const internalTriggerFilter = keys => {
    const mergedKeys = (keys === null || keys === void 0 ? void 0 : keys.length) ? keys : null;
    if (mergedKeys === null && (!filterState || !filterState.filteredKeys)) {
      return null;
    }
    if ((0,isEqual/* default */.Z)(mergedKeys, filterState === null || filterState === void 0 ? void 0 : filterState.filteredKeys, true)) {
      return null;
    }
    triggerFilter({
      column,
      key: columnKey,
      filteredKeys: mergedKeys
    });
  };
  const onConfirm = () => {
    triggerVisible(false);
    internalTriggerFilter(getFilteredKeysSync());
  };
  const onReset = ({
    confirm,
    closeDropdown
  } = {
    confirm: false,
    closeDropdown: false
  }) => {
    if (confirm) {
      internalTriggerFilter([]);
    }
    if (closeDropdown) {
      triggerVisible(false);
    }
    setSearchValue('');
    if (filterResetToDefaultFilteredValue) {
      setFilteredKeysSync((defaultFilteredValue || []).map(key => String(key)));
    } else {
      setFilteredKeysSync([]);
    }
  };
  const doFilter = ({
    closeDropdown
  } = {
    closeDropdown: true
  }) => {
    if (closeDropdown) {
      triggerVisible(false);
    }
    internalTriggerFilter(getFilteredKeysSync());
  };
  const onVisibleChange = (newVisible, info) => {
    if (info.source === 'trigger') {
      if (newVisible && propFilteredKeys !== undefined) {
        // Sync filteredKeys on appear in controlled mode (propFilteredKeys !== undefined)
        setFilteredKeysSync(wrapStringListType(propFilteredKeys));
      }
      triggerVisible(newVisible);
      if (!newVisible && !column.filterDropdown && filterOnClose) {
        onConfirm();
      }
    }
  };
  // ======================== Style ========================
  const dropdownMenuClass = classnames_default()({
    [`${dropdownPrefixCls}-menu-without-submenu`]: !hasSubMenu(column.filters || [])
  });
  const onCheckAll = e => {
    if (e.target.checked) {
      const allFilterKeys = flattenKeys(column === null || column === void 0 ? void 0 : column.filters).map(key => String(key));
      setFilteredKeysSync(allFilterKeys);
    } else {
      setFilteredKeysSync([]);
    }
  };
  const getTreeData = ({
    filters
  }) => (filters || []).map((filter, index) => {
    const key = String(filter.value);
    const item = {
      title: filter.text,
      key: filter.value !== undefined ? key : String(index)
    };
    if (filter.children) {
      item.children = getTreeData({
        filters: filter.children
      });
    }
    return item;
  });
  const getFilterData = node => {
    var _a;
    return Object.assign(Object.assign({}, node), {
      text: node.title,
      value: node.key,
      children: ((_a = node.children) === null || _a === void 0 ? void 0 : _a.map(item => getFilterData(item))) || []
    });
  };
  let dropdownContent;
  const {
    direction,
    renderEmpty
  } = react.useContext(ConfigContext);
  if (typeof column.filterDropdown === 'function') {
    dropdownContent = column.filterDropdown({
      prefixCls: `${dropdownPrefixCls}-custom`,
      setSelectedKeys: selectedKeys => onSelectKeys({
        selectedKeys: selectedKeys
      }),
      selectedKeys: getFilteredKeysSync(),
      confirm: doFilter,
      clearFilters: onReset,
      filters: column.filters,
      visible: mergedVisible,
      close: () => {
        triggerVisible(false);
      }
    });
  } else if (column.filterDropdown) {
    dropdownContent = column.filterDropdown;
  } else {
    const selectedKeys = getFilteredKeysSync() || [];
    const getFilterComponent = () => {
      var _a, _b;
      const empty = (_a = renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty('Table.filter')) !== null && _a !== void 0 ? _a : (/*#__PURE__*/react.createElement(es_empty, {
        image: es_empty.PRESENTED_IMAGE_SIMPLE,
        description: locale.filterEmptyText,
        styles: {
          image: {
            height: 24
          }
        },
        style: {
          margin: 0,
          padding: '16px 0'
        }
      }));
      if ((column.filters || []).length === 0) {
        return empty;
      }
      if (filterMode === 'tree') {
        return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(useFilter_FilterSearch, {
          filterSearch: filterSearch,
          value: searchValue,
          onChange: onSearch,
          tablePrefixCls: tablePrefixCls,
          locale: locale
        }), /*#__PURE__*/react.createElement("div", {
          className: `${tablePrefixCls}-filter-dropdown-tree`
        }, filterMultiple ? (/*#__PURE__*/react.createElement(es_checkbox, {
          checked: selectedKeys.length === flattenKeys(column.filters).length,
          indeterminate: selectedKeys.length > 0 && selectedKeys.length < flattenKeys(column.filters).length,
          className: `${tablePrefixCls}-filter-dropdown-checkall`,
          onChange: onCheckAll
        }, (_b = locale === null || locale === void 0 ? void 0 : locale.filterCheckall) !== null && _b !== void 0 ? _b : locale === null || locale === void 0 ? void 0 : locale.filterCheckAll)) : null, /*#__PURE__*/react.createElement(tree, {
          checkable: true,
          selectable: false,
          blockNode: true,
          multiple: filterMultiple,
          checkStrictly: !filterMultiple,
          className: `${dropdownPrefixCls}-menu`,
          onCheck: onCheck,
          checkedKeys: selectedKeys,
          selectedKeys: selectedKeys,
          showIcon: false,
          treeData: getTreeData({
            filters: column.filters
          }),
          autoExpandParent: true,
          defaultExpandAll: true,
          filterTreeNode: searchValue.trim() ? node => {
            if (typeof filterSearch === 'function') {
              return filterSearch(searchValue, getFilterData(node));
            }
            return searchValueMatched(searchValue, node.title);
          } : undefined
        })));
      }
      const items = renderFilterItems({
        filters: column.filters || [],
        filterSearch,
        prefixCls,
        filteredKeys: getFilteredKeysSync(),
        filterMultiple,
        searchValue
      });
      const isEmpty = items.every(item => item === null);
      return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(useFilter_FilterSearch, {
        filterSearch: filterSearch,
        value: searchValue,
        onChange: onSearch,
        tablePrefixCls: tablePrefixCls,
        locale: locale
      }), isEmpty ? empty : (/*#__PURE__*/react.createElement(es_menu, {
        selectable: true,
        multiple: filterMultiple,
        prefixCls: `${dropdownPrefixCls}-menu`,
        className: dropdownMenuClass,
        onSelect: onSelectKeys,
        onDeselect: onSelectKeys,
        selectedKeys: selectedKeys,
        getPopupContainer: getPopupContainer,
        openKeys: openKeys,
        onOpenChange: onOpenChange,
        items: items
      })));
    };
    const getResetDisabled = () => {
      if (filterResetToDefaultFilteredValue) {
        return (0,isEqual/* default */.Z)((defaultFilteredValue || []).map(key => String(key)), selectedKeys, true);
      }
      return selectedKeys.length === 0;
    };
    dropdownContent = /*#__PURE__*/react.createElement(react.Fragment, null, getFilterComponent(), /*#__PURE__*/react.createElement("div", {
      className: `${prefixCls}-dropdown-btns`
    }, /*#__PURE__*/react.createElement(es_button, {
      type: "link",
      size: "small",
      disabled: getResetDisabled(),
      onClick: () => onReset()
    }, locale.filterReset), /*#__PURE__*/react.createElement(es_button, {
      type: "primary",
      size: "small",
      onClick: onConfirm
    }, locale.filterConfirm)));
  }
  // We should not block customize Menu with additional props
  if (column.filterDropdown) {
    dropdownContent = /*#__PURE__*/react.createElement(OverrideProvider, {
      selectable: undefined
    }, dropdownContent);
  }
  dropdownContent = /*#__PURE__*/react.createElement(FilterWrapper, {
    className: `${prefixCls}-dropdown`
  }, dropdownContent);
  const getDropdownTrigger = () => {
    let filterIcon;
    if (typeof column.filterIcon === 'function') {
      filterIcon = column.filterIcon(filtered);
    } else if (column.filterIcon) {
      filterIcon = column.filterIcon;
    } else {
      filterIcon = /*#__PURE__*/react.createElement(FilterFilled/* default */.Z, null);
    }
    return /*#__PURE__*/react.createElement("span", {
      role: "button",
      tabIndex: -1,
      className: classnames_default()(`${prefixCls}-trigger`, {
        active: filtered
      }),
      onClick: e => {
        e.stopPropagation();
      }
    }, filterIcon);
  };
  const mergedDropdownProps = extendsObject({
    trigger: ['click'],
    placement: direction === 'rtl' ? 'bottomLeft' : 'bottomRight',
    children: getDropdownTrigger(),
    getPopupContainer
  }, Object.assign(Object.assign({}, filterDropdownProps), {
    rootClassName: classnames_default()(rootClassName, filterDropdownProps.rootClassName),
    open: mergedVisible,
    onOpenChange: onVisibleChange,
    popupRender: () => {
      if (typeof (filterDropdownProps === null || filterDropdownProps === void 0 ? void 0 : filterDropdownProps.dropdownRender) === 'function') {
        return filterDropdownProps.dropdownRender(dropdownContent);
      }
      return dropdownContent;
    }
  }));
  return /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-column`
  }, /*#__PURE__*/react.createElement("span", {
    className: `${tablePrefixCls}-column-title`
  }, children), /*#__PURE__*/react.createElement(es_dropdown, Object.assign({}, mergedDropdownProps)));
};
/* harmony default export */ var useFilter_FilterDropdown = (FilterDropdown);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/hooks/useFilter/index.js
"use client";






const collectFilterStates = (columns, init, pos) => {
  let filterStates = [];
  (columns || []).forEach((column, index) => {
    var _a;
    const columnPos = getColumnPos(index, pos);
    const filterDropdownIsDefined = column.filterDropdown !== undefined;
    if (column.filters || filterDropdownIsDefined || 'onFilter' in column) {
      if ('filteredValue' in column) {
        // Controlled
        let filteredValues = column.filteredValue;
        if (!filterDropdownIsDefined) {
          filteredValues = (_a = filteredValues === null || filteredValues === void 0 ? void 0 : filteredValues.map(String)) !== null && _a !== void 0 ? _a : filteredValues;
        }
        filterStates.push({
          column,
          key: getColumnKey(column, columnPos),
          filteredKeys: filteredValues,
          forceFiltered: column.filtered
        });
      } else {
        // Uncontrolled
        filterStates.push({
          column,
          key: getColumnKey(column, columnPos),
          filteredKeys: init && column.defaultFilteredValue ? column.defaultFilteredValue : undefined,
          forceFiltered: column.filtered
        });
      }
    }
    if ('children' in column) {
      filterStates = [].concat((0,toConsumableArray/* default */.Z)(filterStates), (0,toConsumableArray/* default */.Z)(collectFilterStates(column.children, init, columnPos)));
    }
  });
  return filterStates;
};
function injectFilter(prefixCls, dropdownPrefixCls, columns, filterStates, locale, triggerFilter, getPopupContainer, pos, rootClassName) {
  return columns.map((column, index) => {
    const columnPos = getColumnPos(index, pos);
    const {
      filterOnClose = true,
      filterMultiple = true,
      filterMode,
      filterSearch
    } = column;
    let newColumn = column;
    if (newColumn.filters || newColumn.filterDropdown) {
      const columnKey = getColumnKey(newColumn, columnPos);
      const filterState = filterStates.find(({
        key
      }) => columnKey === key);
      newColumn = Object.assign(Object.assign({}, newColumn), {
        title: renderProps => (/*#__PURE__*/react.createElement(useFilter_FilterDropdown, {
          tablePrefixCls: prefixCls,
          prefixCls: `${prefixCls}-filter`,
          dropdownPrefixCls: dropdownPrefixCls,
          column: newColumn,
          columnKey: columnKey,
          filterState: filterState,
          filterOnClose: filterOnClose,
          filterMultiple: filterMultiple,
          filterMode: filterMode,
          filterSearch: filterSearch,
          triggerFilter: triggerFilter,
          locale: locale,
          getPopupContainer: getPopupContainer,
          rootClassName: rootClassName
        }, renderColumnTitle(column.title, renderProps)))
      });
    }
    if ('children' in newColumn) {
      newColumn = Object.assign(Object.assign({}, newColumn), {
        children: injectFilter(prefixCls, dropdownPrefixCls, newColumn.children, filterStates, locale, triggerFilter, getPopupContainer, columnPos, rootClassName)
      });
    }
    return newColumn;
  });
}
const generateFilterInfo = filterStates => {
  const currentFilters = {};
  filterStates.forEach(({
    key,
    filteredKeys,
    column
  }) => {
    const keyAsString = key;
    const {
      filters,
      filterDropdown
    } = column;
    if (filterDropdown) {
      currentFilters[keyAsString] = filteredKeys || null;
    } else if (Array.isArray(filteredKeys)) {
      const keys = flattenKeys(filters);
      currentFilters[keyAsString] = keys.filter(originKey => filteredKeys.includes(String(originKey)));
    } else {
      currentFilters[keyAsString] = null;
    }
  });
  return currentFilters;
};
const getFilterData = (data, filterStates, childrenColumnName) => {
  const filterDatas = filterStates.reduce((currentData, filterState) => {
    const {
      column: {
        onFilter,
        filters
      },
      filteredKeys
    } = filterState;
    if (onFilter && filteredKeys && filteredKeys.length) {
      return currentData
      // shallow copy
      .map(record => Object.assign({}, record)).filter(record => filteredKeys.some(key => {
        const keys = flattenKeys(filters);
        const keyIndex = keys.findIndex(k => String(k) === String(key));
        const realKey = keyIndex !== -1 ? keys[keyIndex] : key;
        // filter children
        if (record[childrenColumnName]) {
          record[childrenColumnName] = getFilterData(record[childrenColumnName], filterStates, childrenColumnName);
        }
        return onFilter(realKey, record);
      }));
    }
    return currentData;
  }, data);
  return filterDatas;
};
const getMergedColumns = rawMergedColumns => rawMergedColumns.flatMap(column => {
  if ('children' in column) {
    return [column].concat((0,toConsumableArray/* default */.Z)(getMergedColumns(column.children || [])));
  }
  return [column];
});
const useFilter = props => {
  const {
    prefixCls,
    dropdownPrefixCls,
    mergedColumns: rawMergedColumns,
    onFilterChange,
    getPopupContainer,
    locale: tableLocale,
    rootClassName
  } = props;
  const warning = warning_devUseWarning('Table');
  const mergedColumns = react.useMemo(() => getMergedColumns(rawMergedColumns || []), [rawMergedColumns]);
  const [filterStates, setFilterStates] = react.useState(() => collectFilterStates(mergedColumns, true));
  const mergedFilterStates = react.useMemo(() => {
    const collectedStates = collectFilterStates(mergedColumns, false);
    if (collectedStates.length === 0) {
      return collectedStates;
    }
    let filteredKeysIsAllNotControlled = true;
    let filteredKeysIsAllControlled = true;
    collectedStates.forEach(({
      filteredKeys
    }) => {
      if (filteredKeys !== undefined) {
        filteredKeysIsAllNotControlled = false;
      } else {
        filteredKeysIsAllControlled = false;
      }
    });
    // Return if not controlled
    if (filteredKeysIsAllNotControlled) {
      // Filter column may have been removed
      const keyList = (mergedColumns || []).map((column, index) => getColumnKey(column, getColumnPos(index)));
      return filterStates.filter(({
        key
      }) => keyList.includes(key)).map(item => {
        const col = mergedColumns[keyList.findIndex(key => key === item.key)];
        return Object.assign(Object.assign({}, item), {
          column: Object.assign(Object.assign({}, item.column), col),
          forceFiltered: col.filtered
        });
      });
    }
     false ? 0 : void 0;
    return collectedStates;
  }, [mergedColumns, filterStates]);
  const filters = react.useMemo(() => generateFilterInfo(mergedFilterStates), [mergedFilterStates]);
  const triggerFilter = filterState => {
    const newFilterStates = mergedFilterStates.filter(({
      key
    }) => key !== filterState.key);
    newFilterStates.push(filterState);
    setFilterStates(newFilterStates);
    onFilterChange(generateFilterInfo(newFilterStates), newFilterStates);
  };
  const transformColumns = innerColumns => injectFilter(prefixCls, dropdownPrefixCls, innerColumns, mergedFilterStates, tableLocale, triggerFilter, getPopupContainer, undefined, rootClassName);
  return [transformColumns, mergedFilterStates, filters];
};

/* harmony default export */ var hooks_useFilter = (useFilter);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/hooks/useLazyKVMap.js

const useLazyKVMap = (data, childrenColumnName, getRowKey) => {
  const mapCacheRef = react.useRef({});
  function getRecordByKey(key) {
    var _a;
    if (!mapCacheRef.current || mapCacheRef.current.data !== data || mapCacheRef.current.childrenColumnName !== childrenColumnName || mapCacheRef.current.getRowKey !== getRowKey) {
      const kvMap = new Map();
      function dig(records) {
        records.forEach((record, index) => {
          const rowKey = getRowKey(record, index);
          kvMap.set(rowKey, record);
          if (record && typeof record === 'object' && childrenColumnName in record) {
            dig(record[childrenColumnName] || []);
          }
        });
      }
      dig(data);
      mapCacheRef.current = {
        data,
        childrenColumnName,
        kvMap,
        getRowKey
      };
    }
    return (_a = mapCacheRef.current.kvMap) === null || _a === void 0 ? void 0 : _a.get(key);
  }
  return [getRecordByKey];
};
/* harmony default export */ var hooks_useLazyKVMap = (useLazyKVMap);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/hooks/usePagination.js
var usePagination_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


const DEFAULT_PAGE_SIZE = 10;
function getPaginationParam(mergedPagination, pagination) {
  const param = {
    current: mergedPagination.current,
    pageSize: mergedPagination.pageSize
  };
  const paginationObj = pagination && typeof pagination === 'object' ? pagination : {};
  Object.keys(paginationObj).forEach(pageProp => {
    const value = mergedPagination[pageProp];
    if (typeof value !== 'function') {
      param[pageProp] = value;
    }
  });
  return param;
}
function usePagination(total, onChange, pagination) {
  const _a = pagination && typeof pagination === 'object' ? pagination : {},
    {
      total: paginationTotal = 0
    } = _a,
    paginationObj = usePagination_rest(_a, ["total"]);
  const [innerPagination, setInnerPagination] = (0,react.useState)(() => ({
    current: 'defaultCurrent' in paginationObj ? paginationObj.defaultCurrent : 1,
    pageSize: 'defaultPageSize' in paginationObj ? paginationObj.defaultPageSize : DEFAULT_PAGE_SIZE
  }));
  // ============ Basic Pagination Config ============
  const mergedPagination = extendsObject(innerPagination, paginationObj, {
    total: paginationTotal > 0 ? paginationTotal : total
  });
  // Reset `current` if data length or pageSize changed
  const maxPage = Math.ceil((paginationTotal || total) / mergedPagination.pageSize);
  if (mergedPagination.current > maxPage) {
    // Prevent a maximum page count of 0
    mergedPagination.current = maxPage || 1;
  }
  const refreshPagination = (current, pageSize) => {
    setInnerPagination({
      current: current !== null && current !== void 0 ? current : 1,
      pageSize: pageSize || mergedPagination.pageSize
    });
  };
  const onInternalChange = (current, pageSize) => {
    var _a;
    if (pagination) {
      (_a = pagination.onChange) === null || _a === void 0 ? void 0 : _a.call(pagination, current, pageSize);
    }
    refreshPagination(current, pageSize);
    onChange(current, pageSize || (mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.pageSize));
  };
  if (pagination === false) {
    return [{}, () => {}];
  }
  return [Object.assign(Object.assign({}, mergedPagination), {
    onChange: onInternalChange
  }), refreshPagination];
}
/* harmony default export */ var hooks_usePagination = (usePagination);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CaretDownOutlined.js + 1 modules
var CaretDownOutlined = __webpack_require__(9448);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CaretUpOutlined.js + 1 modules
var CaretUpOutlined = __webpack_require__(22844);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/hooks/useSorter.js
"use client";









const ASCEND = 'ascend';
const DESCEND = 'descend';
const getMultiplePriority = column => {
  if (typeof column.sorter === 'object' && typeof column.sorter.multiple === 'number') {
    return column.sorter.multiple;
  }
  return false;
};
const getSortFunction = sorter => {
  if (typeof sorter === 'function') {
    return sorter;
  }
  if (sorter && typeof sorter === 'object' && sorter.compare) {
    return sorter.compare;
  }
  return false;
};
const nextSortDirection = (sortDirections, current) => {
  if (!current) {
    return sortDirections[0];
  }
  return sortDirections[sortDirections.indexOf(current) + 1];
};
const collectSortStates = (columns, init, pos) => {
  let sortStates = [];
  const pushState = (column, columnPos) => {
    sortStates.push({
      column,
      key: getColumnKey(column, columnPos),
      multiplePriority: getMultiplePriority(column),
      sortOrder: column.sortOrder
    });
  };
  (columns || []).forEach((column, index) => {
    const columnPos = getColumnPos(index, pos);
    if (column.children) {
      if ('sortOrder' in column) {
        // Controlled
        pushState(column, columnPos);
      }
      sortStates = [].concat((0,toConsumableArray/* default */.Z)(sortStates), (0,toConsumableArray/* default */.Z)(collectSortStates(column.children, init, columnPos)));
    } else if (column.sorter) {
      if ('sortOrder' in column) {
        // Controlled
        pushState(column, columnPos);
      } else if (init && column.defaultSortOrder) {
        // Default sorter
        sortStates.push({
          column,
          key: getColumnKey(column, columnPos),
          multiplePriority: getMultiplePriority(column),
          sortOrder: column.defaultSortOrder
        });
      }
    }
  });
  return sortStates;
};
const injectSorter = (prefixCls, columns, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, pos) => {
  const finalColumns = (columns || []).map((column, index) => {
    const columnPos = getColumnPos(index, pos);
    let newColumn = column;
    if (newColumn.sorter) {
      const sortDirections = newColumn.sortDirections || defaultSortDirections;
      const showSorterTooltip = newColumn.showSorterTooltip === undefined ? tableShowSorterTooltip : newColumn.showSorterTooltip;
      const columnKey = getColumnKey(newColumn, columnPos);
      const sorterState = sorterStates.find(({
        key
      }) => key === columnKey);
      const sortOrder = sorterState ? sorterState.sortOrder : null;
      const nextSortOrder = nextSortDirection(sortDirections, sortOrder);
      let sorter;
      if (column.sortIcon) {
        sorter = column.sortIcon({
          sortOrder
        });
      } else {
        const upNode = sortDirections.includes(ASCEND) && (/*#__PURE__*/react.createElement(CaretUpOutlined/* default */.Z, {
          className: classnames_default()(`${prefixCls}-column-sorter-up`, {
            active: sortOrder === ASCEND
          })
        }));
        const downNode = sortDirections.includes(DESCEND) && (/*#__PURE__*/react.createElement(CaretDownOutlined/* default */.Z, {
          className: classnames_default()(`${prefixCls}-column-sorter-down`, {
            active: sortOrder === DESCEND
          })
        }));
        sorter = /*#__PURE__*/react.createElement("span", {
          className: classnames_default()(`${prefixCls}-column-sorter`, {
            [`${prefixCls}-column-sorter-full`]: !!(upNode && downNode)
          })
        }, /*#__PURE__*/react.createElement("span", {
          className: `${prefixCls}-column-sorter-inner`,
          "aria-hidden": "true"
        }, upNode, downNode));
      }
      const {
        cancelSort,
        triggerAsc,
        triggerDesc
      } = tableLocale || {};
      let sortTip = cancelSort;
      if (nextSortOrder === DESCEND) {
        sortTip = triggerDesc;
      } else if (nextSortOrder === ASCEND) {
        sortTip = triggerAsc;
      }
      const tooltipProps = typeof showSorterTooltip === 'object' ? Object.assign({
        title: sortTip
      }, showSorterTooltip) : {
        title: sortTip
      };
      newColumn = Object.assign(Object.assign({}, newColumn), {
        className: classnames_default()(newColumn.className, {
          [`${prefixCls}-column-sort`]: sortOrder
        }),
        title: renderProps => {
          const columnSortersClass = `${prefixCls}-column-sorters`;
          const renderColumnTitleWrapper = /*#__PURE__*/react.createElement("span", {
            className: `${prefixCls}-column-title`
          }, renderColumnTitle(column.title, renderProps));
          const renderSortTitle = /*#__PURE__*/react.createElement("div", {
            className: columnSortersClass
          }, renderColumnTitleWrapper, sorter);
          if (showSorterTooltip) {
            if (typeof showSorterTooltip !== 'boolean' && (showSorterTooltip === null || showSorterTooltip === void 0 ? void 0 : showSorterTooltip.target) === 'sorter-icon') {
              return /*#__PURE__*/react.createElement("div", {
                className: `${columnSortersClass} ${prefixCls}-column-sorters-tooltip-target-sorter`
              }, renderColumnTitleWrapper, /*#__PURE__*/react.createElement(es_tooltip, Object.assign({}, tooltipProps), sorter));
            }
            return /*#__PURE__*/react.createElement(es_tooltip, Object.assign({}, tooltipProps), renderSortTitle);
          }
          return renderSortTitle;
        },
        onHeaderCell: col => {
          var _a;
          const cell = ((_a = column.onHeaderCell) === null || _a === void 0 ? void 0 : _a.call(column, col)) || {};
          const originOnClick = cell.onClick;
          const originOKeyDown = cell.onKeyDown;
          cell.onClick = event => {
            triggerSorter({
              column,
              key: columnKey,
              sortOrder: nextSortOrder,
              multiplePriority: getMultiplePriority(column)
            });
            originOnClick === null || originOnClick === void 0 ? void 0 : originOnClick(event);
          };
          cell.onKeyDown = event => {
            if (event.keyCode === KeyCode/* default.ENTER */.Z.ENTER) {
              triggerSorter({
                column,
                key: columnKey,
                sortOrder: nextSortOrder,
                multiplePriority: getMultiplePriority(column)
              });
              originOKeyDown === null || originOKeyDown === void 0 ? void 0 : originOKeyDown(event);
            }
          };
          const renderTitle = safeColumnTitle(column.title, {});
          const displayTitle = renderTitle === null || renderTitle === void 0 ? void 0 : renderTitle.toString();
          // Inform the screen-reader so it can tell the visually impaired user which column is sorted
          if (sortOrder) {
            cell['aria-sort'] = sortOrder === 'ascend' ? 'ascending' : 'descending';
          }
          cell['aria-label'] = displayTitle || '';
          cell.className = classnames_default()(cell.className, `${prefixCls}-column-has-sorters`);
          cell.tabIndex = 0;
          if (column.ellipsis) {
            cell.title = (renderTitle !== null && renderTitle !== void 0 ? renderTitle : '').toString();
          }
          return cell;
        }
      });
    }
    if ('children' in newColumn) {
      newColumn = Object.assign(Object.assign({}, newColumn), {
        children: injectSorter(prefixCls, newColumn.children, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, columnPos)
      });
    }
    return newColumn;
  });
  return finalColumns;
};
const stateToInfo = sorterState => {
  const {
    column,
    sortOrder
  } = sorterState;
  return {
    column,
    order: sortOrder,
    field: column.dataIndex,
    columnKey: column.key
  };
};
const generateSorterInfo = sorterStates => {
  const activeSorters = sorterStates.filter(({
    sortOrder
  }) => sortOrder).map(stateToInfo);
  // =========== Legacy compatible support ===========
  // https://github.com/ant-design/ant-design/pull/19226
  if (activeSorters.length === 0 && sorterStates.length) {
    const lastIndex = sorterStates.length - 1;
    return Object.assign(Object.assign({}, stateToInfo(sorterStates[lastIndex])), {
      column: undefined,
      order: undefined,
      field: undefined,
      columnKey: undefined
    });
  }
  if (activeSorters.length <= 1) {
    return activeSorters[0] || {};
  }
  return activeSorters;
};
const getSortData = (data, sortStates, childrenColumnName) => {
  const innerSorterStates = sortStates.slice().sort((a, b) => b.multiplePriority - a.multiplePriority);
  const cloneData = data.slice();
  const runningSorters = innerSorterStates.filter(({
    column: {
      sorter
    },
    sortOrder
  }) => getSortFunction(sorter) && sortOrder);
  // Skip if no sorter needed
  if (!runningSorters.length) {
    return cloneData;
  }
  return cloneData.sort((record1, record2) => {
    for (let i = 0; i < runningSorters.length; i += 1) {
      const sorterState = runningSorters[i];
      const {
        column: {
          sorter
        },
        sortOrder
      } = sorterState;
      const compareFn = getSortFunction(sorter);
      if (compareFn && sortOrder) {
        const compareResult = compareFn(record1, record2, sortOrder);
        if (compareResult !== 0) {
          return sortOrder === ASCEND ? compareResult : -compareResult;
        }
      }
    }
    return 0;
  }).map(record => {
    const subRecords = record[childrenColumnName];
    if (subRecords) {
      return Object.assign(Object.assign({}, record), {
        [childrenColumnName]: getSortData(subRecords, sortStates, childrenColumnName)
      });
    }
    return record;
  });
};
const useFilterSorter = props => {
  const {
    prefixCls,
    mergedColumns,
    sortDirections,
    tableLocale,
    showSorterTooltip,
    onSorterChange
  } = props;
  const [sortStates, setSortStates] = react.useState(() => collectSortStates(mergedColumns, true));
  const getColumnKeys = (columns, pos) => {
    const newKeys = [];
    columns.forEach((item, index) => {
      const columnPos = getColumnPos(index, pos);
      newKeys.push(getColumnKey(item, columnPos));
      if (Array.isArray(item.children)) {
        const childKeys = getColumnKeys(item.children, columnPos);
        newKeys.push.apply(newKeys, (0,toConsumableArray/* default */.Z)(childKeys));
      }
    });
    return newKeys;
  };
  const mergedSorterStates = react.useMemo(() => {
    let validate = true;
    const collectedStates = collectSortStates(mergedColumns, false);
    // Return if not controlled
    if (!collectedStates.length) {
      const mergedColumnsKeys = getColumnKeys(mergedColumns);
      return sortStates.filter(({
        key
      }) => mergedColumnsKeys.includes(key));
    }
    const validateStates = [];
    function patchStates(state) {
      if (validate) {
        validateStates.push(state);
      } else {
        validateStates.push(Object.assign(Object.assign({}, state), {
          sortOrder: null
        }));
      }
    }
    let multipleMode = null;
    collectedStates.forEach(state => {
      if (multipleMode === null) {
        patchStates(state);
        if (state.sortOrder) {
          if (state.multiplePriority === false) {
            validate = false;
          } else {
            multipleMode = true;
          }
        }
      } else if (multipleMode && state.multiplePriority !== false) {
        patchStates(state);
      } else {
        validate = false;
        patchStates(state);
      }
    });
    return validateStates;
  }, [mergedColumns, sortStates]);
  // Get render columns title required props
  const columnTitleSorterProps = react.useMemo(() => {
    var _a, _b;
    const sortColumns = mergedSorterStates.map(({
      column,
      sortOrder
    }) => ({
      column,
      order: sortOrder
    }));
    return {
      sortColumns,
      // Legacy
      sortColumn: (_a = sortColumns[0]) === null || _a === void 0 ? void 0 : _a.column,
      sortOrder: (_b = sortColumns[0]) === null || _b === void 0 ? void 0 : _b.order
    };
  }, [mergedSorterStates]);
  const triggerSorter = sortState => {
    let newSorterStates;
    if (sortState.multiplePriority === false || !mergedSorterStates.length || mergedSorterStates[0].multiplePriority === false) {
      newSorterStates = [sortState];
    } else {
      newSorterStates = [].concat((0,toConsumableArray/* default */.Z)(mergedSorterStates.filter(({
        key
      }) => key !== sortState.key)), [sortState]);
    }
    setSortStates(newSorterStates);
    onSorterChange(generateSorterInfo(newSorterStates), newSorterStates);
  };
  const transformColumns = innerColumns => injectSorter(prefixCls, innerColumns, mergedSorterStates, triggerSorter, sortDirections, tableLocale, showSorterTooltip);
  const getSorters = () => generateSorterInfo(mergedSorterStates);
  return [transformColumns, mergedSorterStates, columnTitleSorterProps, getSorters];
};
/* harmony default export */ var useSorter = (useFilterSorter);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/hooks/useTitleColumns.js


const fillTitle = (columns, columnTitleProps) => {
  const finalColumns = columns.map(column => {
    const cloneColumn = Object.assign({}, column);
    cloneColumn.title = renderColumnTitle(column.title, columnTitleProps);
    if ('children' in cloneColumn) {
      cloneColumn.children = fillTitle(cloneColumn.children, columnTitleProps);
    }
    return cloneColumn;
  });
  return finalColumns;
};
const useTitleColumns = columnTitleProps => {
  const filledColumns = react.useCallback(columns => fillTitle(columns, columnTitleProps), [columnTitleProps]);
  return [filledColumns];
};
/* harmony default export */ var hooks_useTitleColumns = (useTitleColumns);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/RcTable/index.js
"use client";


/**
 * Same as `rc-table` but we modify trigger children update logic instead.
 */
const RcTable = (0,rc_table_es/* genTable */.Q$)((prev, next) => {
  const {
    _renderTimes: prevRenderTimes
  } = prev;
  const {
    _renderTimes: nextRenderTimes
  } = next;
  return prevRenderTimes !== nextRenderTimes;
});
/* harmony default export */ var table_RcTable = (RcTable);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/RcTable/VirtualTable.js
"use client";


/**
 * Same as `rc-table` but we modify trigger children update logic instead.
 */
const RcVirtualTable = (0,rc_table_es/* genVirtualTable */.TN)((prev, next) => {
  const {
    _renderTimes: prevRenderTimes
  } = prev;
  const {
    _renderTimes: nextRenderTimes
  } = next;
  return prevRenderTimes !== nextRenderTimes;
});
/* harmony default export */ var VirtualTable = (RcVirtualTable);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/style/bordered.js

const style_bordered_genBorderedStyle = token => {
  const {
    componentCls,
    lineWidth,
    lineType,
    tableBorderColor,
    tableHeaderBg,
    tablePaddingVertical,
    tablePaddingHorizontal,
    calc
  } = token;
  const tableBorder = `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${tableBorderColor}`;
  const getSizeBorderStyle = (size, paddingVertical, paddingHorizontal) => ({
    [`&${componentCls}-${size}`]: {
      [`> ${componentCls}-container`]: {
        [`> ${componentCls}-content, > ${componentCls}-body`]: {
          [`
            > table > tbody > tr > th,
            > table > tbody > tr > td
          `]: {
            [`> ${componentCls}-expanded-row-fixed`]: {
              margin: `${(0,cssinjs_es/* unit */.bf)(calc(paddingVertical).mul(-1).equal())}
              ${(0,cssinjs_es/* unit */.bf)(calc(calc(paddingHorizontal).add(lineWidth)).mul(-1).equal())}`
            }
          }
        }
      }
    }
  });
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}${componentCls}-bordered`]: Object.assign(Object.assign(Object.assign({
        // ============================ Title =============================
        [`> ${componentCls}-title`]: {
          border: tableBorder,
          borderBottom: 0
        },
        // ============================ Content ============================
        [`> ${componentCls}-container`]: {
          borderInlineStart: tableBorder,
          borderTop: tableBorder,
          [`
            > ${componentCls}-content,
            > ${componentCls}-header,
            > ${componentCls}-body,
            > ${componentCls}-summary
          `]: {
            '> table': {
              // ============================= Cell =============================
              [`
                > thead > tr > th,
                > thead > tr > td,
                > tbody > tr > th,
                > tbody > tr > td,
                > tfoot > tr > th,
                > tfoot > tr > td
              `]: {
                borderInlineEnd: tableBorder
              },
              // ============================ Header ============================
              '> thead': {
                '> tr:not(:last-child) > th': {
                  borderBottom: tableBorder
                },
                '> tr > th::before': {
                  backgroundColor: 'transparent !important'
                }
              },
              // Fixed right should provides additional border
              [`
                > thead > tr,
                > tbody > tr,
                > tfoot > tr
              `]: {
                [`> ${componentCls}-cell-fix-right-first::after`]: {
                  borderInlineEnd: tableBorder
                }
              },
              // ========================== Expandable ==========================
              [`
                > tbody > tr > th,
                > tbody > tr > td
              `]: {
                [`> ${componentCls}-expanded-row-fixed`]: {
                  margin: `${(0,cssinjs_es/* unit */.bf)(calc(tablePaddingVertical).mul(-1).equal())} ${(0,cssinjs_es/* unit */.bf)(calc(calc(tablePaddingHorizontal).add(lineWidth)).mul(-1).equal())}`,
                  '&::after': {
                    position: 'absolute',
                    top: 0,
                    insetInlineEnd: lineWidth,
                    bottom: 0,
                    borderInlineEnd: tableBorder,
                    content: '""'
                  }
                }
              }
            }
          }
        },
        // ============================ Scroll ============================
        [`&${componentCls}-scroll-horizontal`]: {
          [`> ${componentCls}-container > ${componentCls}-body`]: {
            '> table > tbody': {
              [`
                > tr${componentCls}-expanded-row,
                > tr${componentCls}-placeholder
              `]: {
                '> th, > td': {
                  borderInlineEnd: 0
                }
              }
            }
          }
        }
      }, getSizeBorderStyle('middle', token.tablePaddingVerticalMiddle, token.tablePaddingHorizontalMiddle)), getSizeBorderStyle('small', token.tablePaddingVerticalSmall, token.tablePaddingHorizontalSmall)), {
        // ============================ Footer ============================
        [`> ${componentCls}-footer`]: {
          border: tableBorder,
          borderTop: 0
        }
      }),
      // ============================ Nested ============================
      [`${componentCls}-cell`]: {
        [`${componentCls}-container:first-child`]: {
          // :first-child to avoid the case when bordered and title is set
          borderTop: 0
        },
        // https://github.com/ant-design/ant-design/issues/35577
        '&-scrollbar:not([rowspan])': {
          boxShadow: `0 ${(0,cssinjs_es/* unit */.bf)(lineWidth)} 0 ${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${tableHeaderBg}`
        }
      },
      [`${componentCls}-bordered ${componentCls}-cell-scrollbar`]: {
        borderInlineEnd: tableBorder
      }
    }
  };
};
/* harmony default export */ var style_bordered = (style_bordered_genBorderedStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/style/ellipsis.js

const genEllipsisStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}-cell-ellipsis`]: Object.assign(Object.assign({}, textEllipsis), {
        wordBreak: 'keep-all',
        // Fixed first or last should special process
        [`
          &${componentCls}-cell-fix-left-last,
          &${componentCls}-cell-fix-right-first
        `]: {
          overflow: 'visible',
          [`${componentCls}-cell-content`]: {
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }
        },
        [`${componentCls}-column-title`]: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          wordBreak: 'keep-all'
        }
      })
    }
  };
};
/* harmony default export */ var ellipsis = (genEllipsisStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/style/empty.js
// ========================= Placeholder ==========================
const genEmptyStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}-tbody > tr${componentCls}-placeholder`]: {
        textAlign: 'center',
        color: token.colorTextDisabled,
        [`
          &:hover > th,
          &:hover > td,
        `]: {
          background: token.colorBgContainer
        }
      }
    }
  };
};
/* harmony default export */ var style_empty = (genEmptyStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/style/expand.js


const genExpandStyle = token => {
  const {
    componentCls,
    antCls,
    motionDurationSlow,
    lineWidth,
    paddingXS,
    lineType,
    tableBorderColor,
    tableExpandIconBg,
    tableExpandColumnWidth,
    borderRadius,
    tablePaddingVertical,
    tablePaddingHorizontal,
    tableExpandedRowBg,
    paddingXXS,
    expandIconMarginTop,
    expandIconSize,
    expandIconHalfInner,
    expandIconScale,
    calc
  } = token;
  const tableBorder = `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${tableBorderColor}`;
  const expandIconLineOffset = calc(paddingXXS).sub(lineWidth).equal();
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}-expand-icon-col`]: {
        width: tableExpandColumnWidth
      },
      [`${componentCls}-row-expand-icon-cell`]: {
        textAlign: 'center',
        [`${componentCls}-row-expand-icon`]: {
          display: 'inline-flex',
          float: 'none',
          verticalAlign: 'sub'
        }
      },
      [`${componentCls}-row-indent`]: {
        height: 1,
        float: 'left'
      },
      [`${componentCls}-row-expand-icon`]: Object.assign(Object.assign({}, operationUnit(token)), {
        position: 'relative',
        float: 'left',
        width: expandIconSize,
        height: expandIconSize,
        color: 'inherit',
        lineHeight: (0,cssinjs_es/* unit */.bf)(expandIconSize),
        background: tableExpandIconBg,
        border: tableBorder,
        borderRadius,
        transform: `scale(${expandIconScale})`,
        '&:focus, &:hover, &:active': {
          borderColor: 'currentcolor'
        },
        '&::before, &::after': {
          position: 'absolute',
          background: 'currentcolor',
          transition: `transform ${motionDurationSlow} ease-out`,
          content: '""'
        },
        '&::before': {
          top: expandIconHalfInner,
          insetInlineEnd: expandIconLineOffset,
          insetInlineStart: expandIconLineOffset,
          height: lineWidth
        },
        '&::after': {
          top: expandIconLineOffset,
          bottom: expandIconLineOffset,
          insetInlineStart: expandIconHalfInner,
          width: lineWidth,
          transform: 'rotate(90deg)'
        },
        // Motion effect
        '&-collapsed::before': {
          transform: 'rotate(-180deg)'
        },
        '&-collapsed::after': {
          transform: 'rotate(0deg)'
        },
        '&-spaced': {
          '&::before, &::after': {
            display: 'none',
            content: 'none'
          },
          background: 'transparent',
          border: 0,
          visibility: 'hidden'
        }
      }),
      [`${componentCls}-row-indent + ${componentCls}-row-expand-icon`]: {
        marginTop: expandIconMarginTop,
        marginInlineEnd: paddingXS
      },
      [`tr${componentCls}-expanded-row`]: {
        '&, &:hover': {
          '> th, > td': {
            background: tableExpandedRowBg
          }
        },
        // https://github.com/ant-design/ant-design/issues/25573
        [`${antCls}-descriptions-view`]: {
          display: 'flex',
          table: {
            flex: 'auto',
            width: '100%'
          }
        }
      },
      // With fixed
      [`${componentCls}-expanded-row-fixed`]: {
        position: 'relative',
        margin: `${(0,cssinjs_es/* unit */.bf)(calc(tablePaddingVertical).mul(-1).equal())} ${(0,cssinjs_es/* unit */.bf)(calc(tablePaddingHorizontal).mul(-1).equal())}`,
        padding: `${(0,cssinjs_es/* unit */.bf)(tablePaddingVertical)} ${(0,cssinjs_es/* unit */.bf)(tablePaddingHorizontal)}`
      }
    }
  };
};
/* harmony default export */ var expand = (genExpandStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/style/filter.js


const genFilterStyle = token => {
  const {
    componentCls,
    antCls,
    iconCls,
    tableFilterDropdownWidth,
    tableFilterDropdownSearchWidth,
    paddingXXS,
    paddingXS,
    colorText,
    lineWidth,
    lineType,
    tableBorderColor,
    headerIconColor,
    fontSizeSM,
    tablePaddingHorizontal,
    borderRadius,
    motionDurationSlow,
    colorIcon,
    colorPrimary,
    tableHeaderFilterActiveBg,
    colorTextDisabled,
    tableFilterDropdownBg,
    tableFilterDropdownHeight,
    controlItemBgHover,
    controlItemBgActive,
    boxShadowSecondary,
    filterDropdownMenuBg,
    calc
  } = token;
  const dropdownPrefixCls = `${antCls}-dropdown`;
  const tableFilterDropdownPrefixCls = `${componentCls}-filter-dropdown`;
  const treePrefixCls = `${antCls}-tree`;
  const tableBorder = `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${tableBorderColor}`;
  return [{
    [`${componentCls}-wrapper`]: {
      [`${componentCls}-filter-column`]: {
        display: 'flex',
        justifyContent: 'space-between'
      },
      [`${componentCls}-filter-trigger`]: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        marginBlock: calc(paddingXXS).mul(-1).equal(),
        marginInline: `${(0,cssinjs_es/* unit */.bf)(paddingXXS)} ${(0,cssinjs_es/* unit */.bf)(calc(tablePaddingHorizontal).div(2).mul(-1).equal())}`,
        padding: `0 ${(0,cssinjs_es/* unit */.bf)(paddingXXS)}`,
        color: headerIconColor,
        fontSize: fontSizeSM,
        borderRadius,
        cursor: 'pointer',
        transition: `all ${motionDurationSlow}`,
        '&:hover': {
          color: colorIcon,
          background: tableHeaderFilterActiveBg
        },
        '&.active': {
          color: colorPrimary
        }
      }
    }
  }, {
    // Dropdown
    [`${antCls}-dropdown`]: {
      [tableFilterDropdownPrefixCls]: Object.assign(Object.assign({}, resetComponent(token)), {
        minWidth: tableFilterDropdownWidth,
        backgroundColor: tableFilterDropdownBg,
        borderRadius,
        boxShadow: boxShadowSecondary,
        overflow: 'hidden',
        // Reset menu
        [`${dropdownPrefixCls}-menu`]: {
          // https://github.com/ant-design/ant-design/issues/4916
          // https://github.com/ant-design/ant-design/issues/19542
          maxHeight: tableFilterDropdownHeight,
          overflowX: 'hidden',
          border: 0,
          boxShadow: 'none',
          borderRadius: 'unset',
          backgroundColor: filterDropdownMenuBg,
          '&:empty::after': {
            display: 'block',
            padding: `${(0,cssinjs_es/* unit */.bf)(paddingXS)} 0`,
            color: colorTextDisabled,
            fontSize: fontSizeSM,
            textAlign: 'center',
            content: '"Not Found"'
          }
        },
        [`${tableFilterDropdownPrefixCls}-tree`]: {
          paddingBlock: `${(0,cssinjs_es/* unit */.bf)(paddingXS)} 0`,
          paddingInline: paddingXS,
          [treePrefixCls]: {
            padding: 0
          },
          [`${treePrefixCls}-treenode ${treePrefixCls}-node-content-wrapper:hover`]: {
            backgroundColor: controlItemBgHover
          },
          [`${treePrefixCls}-treenode-checkbox-checked ${treePrefixCls}-node-content-wrapper`]: {
            '&, &:hover': {
              backgroundColor: controlItemBgActive
            }
          }
        },
        [`${tableFilterDropdownPrefixCls}-search`]: {
          padding: paddingXS,
          borderBottom: tableBorder,
          '&-input': {
            input: {
              minWidth: tableFilterDropdownSearchWidth
            },
            [iconCls]: {
              color: colorTextDisabled
            }
          }
        },
        [`${tableFilterDropdownPrefixCls}-checkall`]: {
          width: '100%',
          marginBottom: paddingXXS,
          marginInlineStart: paddingXXS
        },
        // Operation
        [`${tableFilterDropdownPrefixCls}-btns`]: {
          display: 'flex',
          justifyContent: 'space-between',
          padding: `${(0,cssinjs_es/* unit */.bf)(calc(paddingXS).sub(lineWidth).equal())} ${(0,cssinjs_es/* unit */.bf)(paddingXS)}`,
          overflow: 'hidden',
          borderTop: tableBorder
        }
      })
    }
  },
  // Dropdown Menu & SubMenu
  {
    // submenu of table filter dropdown
    [`${antCls}-dropdown ${tableFilterDropdownPrefixCls}, ${tableFilterDropdownPrefixCls}-submenu`]: {
      // Checkbox
      [`${antCls}-checkbox-wrapper + span`]: {
        paddingInlineStart: paddingXS,
        color: colorText
      },
      '> ul': {
        maxHeight: 'calc(100vh - 130px)',
        overflowX: 'hidden',
        overflowY: 'auto'
      }
    }
  }];
};
/* harmony default export */ var style_filter = (genFilterStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/style/fixed.js
const genFixedStyle = token => {
  const {
    componentCls,
    lineWidth,
    colorSplit,
    motionDurationSlow,
    zIndexTableFixed,
    tableBg,
    zIndexTableSticky,
    calc
  } = token;
  const shadowColor = colorSplit;
  // Follow style is magic of shadow which should not follow token:
  return {
    [`${componentCls}-wrapper`]: {
      [`
        ${componentCls}-cell-fix-left,
        ${componentCls}-cell-fix-right
      `]: {
        position: 'sticky !important',
        zIndex: zIndexTableFixed,
        background: tableBg
      },
      [`
        ${componentCls}-cell-fix-left-first::after,
        ${componentCls}-cell-fix-left-last::after
      `]: {
        position: 'absolute',
        top: 0,
        right: {
          _skip_check_: true,
          value: 0
        },
        bottom: calc(lineWidth).mul(-1).equal(),
        width: 30,
        transform: 'translateX(100%)',
        transition: `box-shadow ${motionDurationSlow}`,
        content: '""',
        pointerEvents: 'none',
        // fix issues: https://github.com/ant-design/ant-design/issues/54587
        willChange: 'transform'
      },
      [`${componentCls}-cell-fix-left-all::after`]: {
        display: 'none'
      },
      [`
        ${componentCls}-cell-fix-right-first::after,
        ${componentCls}-cell-fix-right-last::after
      `]: {
        position: 'absolute',
        top: 0,
        bottom: calc(lineWidth).mul(-1).equal(),
        left: {
          _skip_check_: true,
          value: 0
        },
        width: 30,
        transform: 'translateX(-100%)',
        transition: `box-shadow ${motionDurationSlow}`,
        content: '""',
        pointerEvents: 'none'
      },
      [`${componentCls}-container`]: {
        position: 'relative',
        '&::before, &::after': {
          position: 'absolute',
          top: 0,
          bottom: 0,
          zIndex: calc(zIndexTableSticky).add(1).equal({
            unit: false
          }),
          width: 30,
          transition: `box-shadow ${motionDurationSlow}`,
          content: '""',
          pointerEvents: 'none'
        },
        '&::before': {
          insetInlineStart: 0
        },
        '&::after': {
          insetInlineEnd: 0
        }
      },
      [`${componentCls}-ping-left`]: {
        [`&:not(${componentCls}-has-fix-left) ${componentCls}-container::before`]: {
          boxShadow: `inset 10px 0 8px -8px ${shadowColor}`
        },
        [`
          ${componentCls}-cell-fix-left-first::after,
          ${componentCls}-cell-fix-left-last::after
        `]: {
          boxShadow: `inset 10px 0 8px -8px ${shadowColor}`
        },
        [`${componentCls}-cell-fix-left-last::before`]: {
          backgroundColor: 'transparent !important'
        }
      },
      [`${componentCls}-ping-right`]: {
        [`&:not(${componentCls}-has-fix-right) ${componentCls}-container::after`]: {
          boxShadow: `inset -10px 0 8px -8px ${shadowColor}`
        },
        [`
          ${componentCls}-cell-fix-right-first::after,
          ${componentCls}-cell-fix-right-last::after
        `]: {
          boxShadow: `inset -10px 0 8px -8px ${shadowColor}`
        }
      },
      // Gapped fixed Columns do not show the shadow
      [`${componentCls}-fixed-column-gapped`]: {
        [`
        ${componentCls}-cell-fix-left-first::after,
        ${componentCls}-cell-fix-left-last::after,
        ${componentCls}-cell-fix-right-first::after,
        ${componentCls}-cell-fix-right-last::after
      `]: {
          boxShadow: 'none'
        }
      }
    }
  };
};
/* harmony default export */ var fixed = (genFixedStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/style/pagination.js

const pagination_genPaginationStyle = token => {
  const {
    componentCls,
    antCls,
    margin
  } = token;
  return {
    [`${componentCls}-wrapper`]: {
      // ========================== Pagination ==========================
      [`${componentCls}-pagination${antCls}-pagination`]: {
        margin: `${(0,cssinjs_es/* unit */.bf)(margin)} 0`
      },
      [`${componentCls}-pagination`]: {
        display: 'flex',
        flexWrap: 'wrap',
        rowGap: token.paddingXS,
        '> *': {
          flex: 'none'
        },
        '&-left': {
          justifyContent: 'flex-start'
        },
        '&-center': {
          justifyContent: 'center'
        },
        '&-right': {
          justifyContent: 'flex-end'
        }
      }
    }
  };
};
/* harmony default export */ var pagination = (pagination_genPaginationStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/style/radius.js

const radius_genRadiusStyle = token => {
  const {
    componentCls,
    tableRadius
  } = token;
  return {
    [`${componentCls}-wrapper`]: {
      [componentCls]: {
        // https://github.com/ant-design/ant-design/issues/39115#issuecomment-1362314574
        [`${componentCls}-title, ${componentCls}-header`]: {
          borderRadius: `${(0,cssinjs_es/* unit */.bf)(tableRadius)} ${(0,cssinjs_es/* unit */.bf)(tableRadius)} 0 0`
        },
        [`${componentCls}-title + ${componentCls}-container`]: {
          borderStartStartRadius: 0,
          borderStartEndRadius: 0,
          // https://github.com/ant-design/ant-design/issues/41975
          [`${componentCls}-header, table`]: {
            borderRadius: 0
          },
          'table > thead > tr:first-child': {
            'th:first-child, th:last-child, td:first-child, td:last-child': {
              borderRadius: 0
            }
          }
        },
        '&-container': {
          borderStartStartRadius: tableRadius,
          borderStartEndRadius: tableRadius,
          'table > thead > tr:first-child': {
            '> *:first-child': {
              borderStartStartRadius: tableRadius
            },
            '> *:last-child': {
              borderStartEndRadius: tableRadius
            }
          }
        },
        '&-footer': {
          borderRadius: `0 0 ${(0,cssinjs_es/* unit */.bf)(tableRadius)} ${(0,cssinjs_es/* unit */.bf)(tableRadius)}`
        }
      }
    }
  };
};
/* harmony default export */ var style_radius = (radius_genRadiusStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/style/rtl.js
const genStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}-wrapper-rtl`]: {
      direction: 'rtl',
      table: {
        direction: 'rtl'
      },
      [`${componentCls}-pagination-left`]: {
        justifyContent: 'flex-end'
      },
      [`${componentCls}-pagination-right`]: {
        justifyContent: 'flex-start'
      },
      [`${componentCls}-row-expand-icon`]: {
        float: 'right',
        '&::after': {
          transform: 'rotate(-90deg)'
        },
        '&-collapsed::before': {
          transform: 'rotate(180deg)'
        },
        '&-collapsed::after': {
          transform: 'rotate(0deg)'
        }
      },
      [`${componentCls}-container`]: {
        '&::before': {
          insetInlineStart: 'unset',
          insetInlineEnd: 0
        },
        '&::after': {
          insetInlineStart: 0,
          insetInlineEnd: 'unset'
        },
        [`${componentCls}-row-indent`]: {
          float: 'right'
        }
      }
    }
  };
};
/* harmony default export */ var table_style_rtl = (genStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/style/selection.js

const selection_genSelectionStyle = token => {
  const {
    componentCls,
    antCls,
    iconCls,
    fontSizeIcon,
    padding,
    paddingXS,
    headerIconColor,
    headerIconHoverColor,
    tableSelectionColumnWidth,
    tableSelectedRowBg,
    tableSelectedRowHoverBg,
    tableRowHoverBg,
    tablePaddingHorizontal,
    calc
  } = token;
  return {
    [`${componentCls}-wrapper`]: {
      // ========================== Selections ==========================
      [`${componentCls}-selection-col`]: {
        width: tableSelectionColumnWidth,
        [`&${componentCls}-selection-col-with-dropdown`]: {
          width: calc(tableSelectionColumnWidth).add(fontSizeIcon).add(calc(padding).div(4)).equal()
        }
      },
      [`${componentCls}-bordered ${componentCls}-selection-col`]: {
        width: calc(tableSelectionColumnWidth).add(calc(paddingXS).mul(2)).equal(),
        [`&${componentCls}-selection-col-with-dropdown`]: {
          width: calc(tableSelectionColumnWidth).add(fontSizeIcon).add(calc(padding).div(4)).add(calc(paddingXS).mul(2)).equal()
        }
      },
      [`
        table tr th${componentCls}-selection-column,
        table tr td${componentCls}-selection-column,
        ${componentCls}-selection-column
      `]: {
        paddingInlineEnd: token.paddingXS,
        paddingInlineStart: token.paddingXS,
        textAlign: 'center',
        [`${antCls}-radio-wrapper`]: {
          marginInlineEnd: 0
        }
      },
      [`table tr th${componentCls}-selection-column${componentCls}-cell-fix-left`]: {
        zIndex: calc(token.zIndexTableFixed).add(1).equal({
          unit: false
        })
      },
      [`table tr th${componentCls}-selection-column::after`]: {
        backgroundColor: 'transparent !important'
      },
      [`${componentCls}-selection`]: {
        position: 'relative',
        display: 'inline-flex',
        flexDirection: 'column'
      },
      [`${componentCls}-selection-extra`]: {
        position: 'absolute',
        top: 0,
        zIndex: 1,
        cursor: 'pointer',
        transition: `all ${token.motionDurationSlow}`,
        marginInlineStart: '100%',
        paddingInlineStart: (0,cssinjs_es/* unit */.bf)(calc(tablePaddingHorizontal).div(4).equal()),
        [iconCls]: {
          color: headerIconColor,
          fontSize: fontSizeIcon,
          verticalAlign: 'baseline',
          '&:hover': {
            color: headerIconHoverColor
          }
        }
      },
      // ============================= Rows =============================
      [`${componentCls}-tbody`]: {
        [`${componentCls}-row`]: {
          [`&${componentCls}-row-selected`]: {
            [`> ${componentCls}-cell`]: {
              background: tableSelectedRowBg,
              '&-row-hover': {
                background: tableSelectedRowHoverBg
              }
            }
          },
          [`> ${componentCls}-cell-row-hover`]: {
            background: tableRowHoverBg
          }
        }
      }
    }
  };
};
/* harmony default export */ var selection = (selection_genSelectionStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/style/size.js

const size_genSizeStyle = token => {
  const {
    componentCls,
    tableExpandColumnWidth,
    calc
  } = token;
  const getSizeStyle = (size, paddingVertical, paddingHorizontal, fontSize) => ({
    [`${componentCls}${componentCls}-${size}`]: {
      fontSize,
      [`
        ${componentCls}-title,
        ${componentCls}-footer,
        ${componentCls}-cell,
        ${componentCls}-thead > tr > th,
        ${componentCls}-tbody > tr > th,
        ${componentCls}-tbody > tr > td,
        tfoot > tr > th,
        tfoot > tr > td
      `]: {
        padding: `${(0,cssinjs_es/* unit */.bf)(paddingVertical)} ${(0,cssinjs_es/* unit */.bf)(paddingHorizontal)}`
      },
      [`${componentCls}-filter-trigger`]: {
        marginInlineEnd: (0,cssinjs_es/* unit */.bf)(calc(paddingHorizontal).div(2).mul(-1).equal())
      },
      [`${componentCls}-expanded-row-fixed`]: {
        margin: `${(0,cssinjs_es/* unit */.bf)(calc(paddingVertical).mul(-1).equal())} ${(0,cssinjs_es/* unit */.bf)(calc(paddingHorizontal).mul(-1).equal())}`
      },
      [`${componentCls}-tbody`]: {
        // ========================= Nest Table ===========================
        [`${componentCls}-wrapper:only-child ${componentCls}`]: {
          marginBlock: (0,cssinjs_es/* unit */.bf)(calc(paddingVertical).mul(-1).equal()),
          marginInline: `${(0,cssinjs_es/* unit */.bf)(calc(tableExpandColumnWidth).sub(paddingHorizontal).equal())} ${(0,cssinjs_es/* unit */.bf)(calc(paddingHorizontal).mul(-1).equal())}`
        }
      },
      // https://github.com/ant-design/ant-design/issues/35167
      [`${componentCls}-selection-extra`]: {
        paddingInlineStart: (0,cssinjs_es/* unit */.bf)(calc(paddingHorizontal).div(4).equal())
      }
    }
  });
  return {
    [`${componentCls}-wrapper`]: Object.assign(Object.assign({}, getSizeStyle('middle', token.tablePaddingVerticalMiddle, token.tablePaddingHorizontalMiddle, token.tableFontSizeMiddle)), getSizeStyle('small', token.tablePaddingVerticalSmall, token.tablePaddingHorizontalSmall, token.tableFontSizeSmall))
  };
};
/* harmony default export */ var size = (size_genSizeStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/style/sorter.js
const genSorterStyle = token => {
  const {
    componentCls,
    marginXXS,
    fontSizeIcon,
    headerIconColor,
    headerIconHoverColor
  } = token;
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}-thead th${componentCls}-column-has-sorters`]: {
        outline: 'none',
        cursor: 'pointer',
        // why left 0s? Avoid column header move with transition when left is changed
        // https://github.com/ant-design/ant-design/issues/50588
        transition: `all ${token.motionDurationSlow}, left 0s`,
        '&:hover': {
          background: token.tableHeaderSortHoverBg,
          '&::before': {
            backgroundColor: 'transparent !important'
          }
        },
        '&:focus-visible': {
          color: token.colorPrimary
        },
        // https://github.com/ant-design/ant-design/issues/30969
        [`
          &${componentCls}-cell-fix-left:hover,
          &${componentCls}-cell-fix-right:hover
        `]: {
          background: token.tableFixedHeaderSortActiveBg
        }
      },
      [`${componentCls}-thead th${componentCls}-column-sort`]: {
        background: token.tableHeaderSortBg,
        '&::before': {
          backgroundColor: 'transparent !important'
        }
      },
      [`td${componentCls}-column-sort`]: {
        background: token.tableBodySortBg
      },
      [`${componentCls}-column-title`]: {
        position: 'relative',
        zIndex: 1,
        flex: 1,
        minWidth: 0
      },
      [`${componentCls}-column-sorters`]: {
        display: 'flex',
        flex: 'auto',
        alignItems: 'center',
        justifyContent: 'space-between',
        '&::after': {
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          content: '""'
        }
      },
      [`${componentCls}-column-sorters-tooltip-target-sorter`]: {
        '&::after': {
          content: 'none'
        }
      },
      [`${componentCls}-column-sorter`]: {
        marginInlineStart: marginXXS,
        color: headerIconColor,
        fontSize: 0,
        transition: `color ${token.motionDurationSlow}`,
        '&-inner': {
          display: 'inline-flex',
          flexDirection: 'column',
          alignItems: 'center'
        },
        '&-up, &-down': {
          fontSize: fontSizeIcon,
          '&.active': {
            color: token.colorPrimary
          }
        },
        [`${componentCls}-column-sorter-up + ${componentCls}-column-sorter-down`]: {
          marginTop: '-0.3em'
        }
      },
      [`${componentCls}-column-sorters:hover ${componentCls}-column-sorter`]: {
        color: headerIconHoverColor
      }
    }
  };
};
/* harmony default export */ var sorter = (genSorterStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/style/sticky.js

const genStickyStyle = token => {
  const {
    componentCls,
    opacityLoading,
    tableScrollThumbBg,
    tableScrollThumbBgHover,
    tableScrollThumbSize,
    tableScrollBg,
    zIndexTableSticky,
    stickyScrollBarBorderRadius,
    lineWidth,
    lineType,
    tableBorderColor
  } = token;
  const tableBorder = `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${tableBorderColor}`;
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}-sticky`]: {
        '&-holder': {
          position: 'sticky',
          zIndex: zIndexTableSticky,
          background: token.colorBgContainer
        },
        '&-scroll': {
          position: 'sticky',
          bottom: 0,
          height: `${(0,cssinjs_es/* unit */.bf)(tableScrollThumbSize)} !important`,
          zIndex: zIndexTableSticky,
          display: 'flex',
          alignItems: 'center',
          background: tableScrollBg,
          borderTop: tableBorder,
          opacity: opacityLoading,
          '&:hover': {
            transformOrigin: 'center bottom'
          },
          // fake scrollbar style of sticky
          '&-bar': {
            height: tableScrollThumbSize,
            backgroundColor: tableScrollThumbBg,
            borderRadius: stickyScrollBarBorderRadius,
            transition: `all ${token.motionDurationSlow}, transform 0s`,
            position: 'absolute',
            bottom: 0,
            '&:hover, &-active': {
              backgroundColor: tableScrollThumbBgHover
            }
          }
        }
      }
    }
  };
};
/* harmony default export */ var sticky = (genStickyStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/style/summary.js

const genSummaryStyle = token => {
  const {
    componentCls,
    lineWidth,
    tableBorderColor,
    calc
  } = token;
  const tableBorder = `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${token.lineType} ${tableBorderColor}`;
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}-summary`]: {
        position: 'relative',
        zIndex: token.zIndexTableFixed,
        background: token.tableBg,
        '> tr': {
          '> th, > td': {
            borderBottom: tableBorder
          }
        }
      },
      [`div${componentCls}-summary`]: {
        boxShadow: `0 ${(0,cssinjs_es/* unit */.bf)(calc(lineWidth).mul(-1).equal())} 0 ${tableBorderColor}`
      }
    }
  };
};
/* harmony default export */ var summary = (genSummaryStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/style/virtual.js

const genVirtualStyle = token => {
  const {
    componentCls,
    motionDurationMid,
    lineWidth,
    lineType,
    tableBorderColor,
    calc
  } = token;
  const tableBorder = `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${tableBorderColor}`;
  const rowCellCls = `${componentCls}-expanded-row-cell`;
  return {
    [`${componentCls}-wrapper`]: {
      // ========================== Row ==========================
      [`${componentCls}-tbody-virtual`]: {
        [`${componentCls}-tbody-virtual-holder-inner`]: {
          [`
            & > ${componentCls}-row, 
            & > div:not(${componentCls}-row) > ${componentCls}-row
          `]: {
            display: 'flex',
            boxSizing: 'border-box',
            width: '100%'
          }
        },
        [`${componentCls}-cell`]: {
          borderBottom: tableBorder,
          transition: `background ${motionDurationMid}`
        },
        [`${componentCls}-expanded-row`]: {
          [`${rowCellCls}${rowCellCls}-fixed`]: {
            position: 'sticky',
            insetInlineStart: 0,
            overflow: 'hidden',
            width: `calc(var(--virtual-width) - ${(0,cssinjs_es/* unit */.bf)(lineWidth)})`,
            borderInlineEnd: 'none'
          }
        }
      },
      // ======================== Border =========================
      [`${componentCls}-bordered`]: {
        [`${componentCls}-tbody-virtual`]: {
          '&:after': {
            content: '""',
            insetInline: 0,
            bottom: 0,
            borderBottom: tableBorder,
            position: 'absolute'
          },
          [`${componentCls}-cell`]: {
            borderInlineEnd: tableBorder,
            [`&${componentCls}-cell-fix-right-first:before`]: {
              content: '""',
              position: 'absolute',
              insetBlock: 0,
              insetInlineStart: calc(lineWidth).mul(-1).equal(),
              borderInlineStart: tableBorder
            }
          }
        },
        // Empty placeholder
        [`&${componentCls}-virtual`]: {
          [`${componentCls}-placeholder ${componentCls}-cell`]: {
            borderInlineEnd: tableBorder,
            borderBottom: tableBorder
          }
        }
      }
    }
  };
};
/* harmony default export */ var virtual = (genVirtualStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/style/index.js



















const genTableStyle = token => {
  const {
    componentCls,
    fontWeightStrong,
    tablePaddingVertical,
    tablePaddingHorizontal,
    tableExpandColumnWidth,
    lineWidth,
    lineType,
    tableBorderColor,
    tableFontSize,
    tableBg,
    tableRadius,
    tableHeaderTextColor,
    motionDurationMid,
    tableHeaderBg,
    tableHeaderCellSplitColor,
    tableFooterTextColor,
    tableFooterBg,
    calc
  } = token;
  const tableBorder = `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${tableBorderColor}`;
  return {
    [`${componentCls}-wrapper`]: Object.assign(Object.assign({
      clear: 'both',
      maxWidth: '100%',
      // fix https://github.com/ant-design/ant-design/issues/46177
      ['--rc-virtual-list-scrollbar-bg']: token.tableScrollBg
    }, clearFix()), {
      [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
        fontSize: tableFontSize,
        background: tableBg,
        borderRadius: `${(0,cssinjs_es/* unit */.bf)(tableRadius)} ${(0,cssinjs_es/* unit */.bf)(tableRadius)} 0 0`,
        // https://github.com/ant-design/ant-design/issues/47486
        scrollbarColor: `${token.tableScrollThumbBg} ${token.tableScrollBg}`
      }),
      // https://github.com/ant-design/ant-design/issues/17611
      table: {
        width: '100%',
        textAlign: 'start',
        borderRadius: `${(0,cssinjs_es/* unit */.bf)(tableRadius)} ${(0,cssinjs_es/* unit */.bf)(tableRadius)} 0 0`,
        borderCollapse: 'separate',
        borderSpacing: 0
      },
      // ============================= Cell ==============================
      [`
          ${componentCls}-cell,
          ${componentCls}-thead > tr > th,
          ${componentCls}-tbody > tr > th,
          ${componentCls}-tbody > tr > td,
          tfoot > tr > th,
          tfoot > tr > td
        `]: {
        position: 'relative',
        padding: `${(0,cssinjs_es/* unit */.bf)(tablePaddingVertical)} ${(0,cssinjs_es/* unit */.bf)(tablePaddingHorizontal)}`,
        overflowWrap: 'break-word'
      },
      // ============================ Title =============================
      [`${componentCls}-title`]: {
        padding: `${(0,cssinjs_es/* unit */.bf)(tablePaddingVertical)} ${(0,cssinjs_es/* unit */.bf)(tablePaddingHorizontal)}`
      },
      // ============================ Header ============================
      [`${componentCls}-thead`]: {
        [`
          > tr > th,
          > tr > td
        `]: {
          position: 'relative',
          color: tableHeaderTextColor,
          fontWeight: fontWeightStrong,
          textAlign: 'start',
          background: tableHeaderBg,
          borderBottom: tableBorder,
          transition: `background ${motionDurationMid} ease`,
          "&[colspan]:not([colspan='1'])": {
            textAlign: 'center'
          },
          [`&:not(:last-child):not(${componentCls}-selection-column):not(${componentCls}-row-expand-icon-cell):not([colspan])::before`]: {
            position: 'absolute',
            top: '50%',
            insetInlineEnd: 0,
            width: 1,
            height: '1.6em',
            backgroundColor: tableHeaderCellSplitColor,
            transform: 'translateY(-50%)',
            transition: `background-color ${motionDurationMid}`,
            content: '""'
          }
        },
        '> tr:not(:last-child) > th[colspan]': {
          borderBottom: 0
        }
      },
      // ============================ Body ============================
      [`${componentCls}-tbody`]: {
        '> tr': {
          '> th, > td': {
            transition: `background ${motionDurationMid}, border-color ${motionDurationMid}`,
            borderBottom: tableBorder,
            // ========================= Nest Table ===========================
            [`
              > ${componentCls}-wrapper:only-child,
              > ${componentCls}-expanded-row-fixed > ${componentCls}-wrapper:only-child
            `]: {
              [componentCls]: {
                marginBlock: (0,cssinjs_es/* unit */.bf)(calc(tablePaddingVertical).mul(-1).equal()),
                marginInline: `${(0,cssinjs_es/* unit */.bf)(calc(tableExpandColumnWidth).sub(tablePaddingHorizontal).equal())}
                ${(0,cssinjs_es/* unit */.bf)(calc(tablePaddingHorizontal).mul(-1).equal())}`,
                [`${componentCls}-tbody > tr:last-child > td`]: {
                  borderBottomWidth: 0,
                  '&:first-child, &:last-child': {
                    borderRadius: 0
                  }
                }
              }
            }
          },
          '> th': {
            position: 'relative',
            color: tableHeaderTextColor,
            fontWeight: fontWeightStrong,
            textAlign: 'start',
            background: tableHeaderBg,
            borderBottom: tableBorder,
            transition: `background ${motionDurationMid} ease`
          }
        }
      },
      // ============================ Footer ============================
      [`${componentCls}-footer`]: {
        padding: `${(0,cssinjs_es/* unit */.bf)(tablePaddingVertical)} ${(0,cssinjs_es/* unit */.bf)(tablePaddingHorizontal)}`,
        color: tableFooterTextColor,
        background: tableFooterBg
      }
    })
  };
};
const table_style_prepareComponentToken = token => {
  const {
    colorFillAlter,
    colorBgContainer,
    colorTextHeading,
    colorFillSecondary,
    colorFillContent,
    controlItemBgActive,
    controlItemBgActiveHover,
    padding,
    paddingSM,
    paddingXS,
    colorBorderSecondary,
    borderRadiusLG,
    controlHeight,
    colorTextPlaceholder,
    fontSize,
    fontSizeSM,
    lineHeight,
    lineWidth,
    colorIcon,
    colorIconHover,
    opacityLoading,
    controlInteractiveSize
  } = token;
  const colorFillSecondarySolid = new fast_color_es/* FastColor */.t(colorFillSecondary).onBackground(colorBgContainer).toHexString();
  const colorFillContentSolid = new fast_color_es/* FastColor */.t(colorFillContent).onBackground(colorBgContainer).toHexString();
  const colorFillAlterSolid = new fast_color_es/* FastColor */.t(colorFillAlter).onBackground(colorBgContainer).toHexString();
  const baseColorAction = new fast_color_es/* FastColor */.t(colorIcon);
  const baseColorActionHover = new fast_color_es/* FastColor */.t(colorIconHover);
  const expandIconHalfInner = controlInteractiveSize / 2 - lineWidth;
  const expandIconSize = expandIconHalfInner * 2 + lineWidth * 3;
  return {
    headerBg: colorFillAlterSolid,
    headerColor: colorTextHeading,
    headerSortActiveBg: colorFillSecondarySolid,
    headerSortHoverBg: colorFillContentSolid,
    bodySortBg: colorFillAlterSolid,
    rowHoverBg: colorFillAlterSolid,
    rowSelectedBg: controlItemBgActive,
    rowSelectedHoverBg: controlItemBgActiveHover,
    rowExpandedBg: colorFillAlter,
    cellPaddingBlock: padding,
    cellPaddingInline: padding,
    cellPaddingBlockMD: paddingSM,
    cellPaddingInlineMD: paddingXS,
    cellPaddingBlockSM: paddingXS,
    cellPaddingInlineSM: paddingXS,
    borderColor: colorBorderSecondary,
    headerBorderRadius: borderRadiusLG,
    footerBg: colorFillAlterSolid,
    footerColor: colorTextHeading,
    cellFontSize: fontSize,
    cellFontSizeMD: fontSize,
    cellFontSizeSM: fontSize,
    headerSplitColor: colorBorderSecondary,
    fixedHeaderSortActiveBg: colorFillSecondarySolid,
    headerFilterHoverBg: colorFillContent,
    filterDropdownMenuBg: colorBgContainer,
    filterDropdownBg: colorBgContainer,
    expandIconBg: colorBgContainer,
    selectionColumnWidth: controlHeight,
    stickyScrollBarBg: colorTextPlaceholder,
    stickyScrollBarBorderRadius: 100,
    expandIconMarginTop: (fontSize * lineHeight - lineWidth * 3) / 2 - Math.ceil((fontSizeSM * 1.4 - lineWidth * 3) / 2),
    headerIconColor: baseColorAction.clone().setA(baseColorAction.a * opacityLoading).toRgbString(),
    headerIconHoverColor: baseColorActionHover.clone().setA(baseColorActionHover.a * opacityLoading).toRgbString(),
    expandIconHalfInner,
    expandIconSize,
    expandIconScale: controlInteractiveSize / expandIconSize
  };
};
const zIndexTableFixed = 2;
// ============================== Export ==============================
/* harmony default export */ var table_style = (genStyleHooks('Table', token => {
  const {
    colorTextHeading,
    colorSplit,
    colorBgContainer,
    controlInteractiveSize: checkboxSize,
    headerBg,
    headerColor,
    headerSortActiveBg,
    headerSortHoverBg,
    bodySortBg,
    rowHoverBg,
    rowSelectedBg,
    rowSelectedHoverBg,
    rowExpandedBg,
    cellPaddingBlock,
    cellPaddingInline,
    cellPaddingBlockMD,
    cellPaddingInlineMD,
    cellPaddingBlockSM,
    cellPaddingInlineSM,
    borderColor,
    footerBg,
    footerColor,
    headerBorderRadius,
    cellFontSize,
    cellFontSizeMD,
    cellFontSizeSM,
    headerSplitColor,
    fixedHeaderSortActiveBg,
    headerFilterHoverBg,
    filterDropdownBg,
    expandIconBg,
    selectionColumnWidth,
    stickyScrollBarBg,
    calc
  } = token;
  const tableToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    tableFontSize: cellFontSize,
    tableBg: colorBgContainer,
    tableRadius: headerBorderRadius,
    tablePaddingVertical: cellPaddingBlock,
    tablePaddingHorizontal: cellPaddingInline,
    tablePaddingVerticalMiddle: cellPaddingBlockMD,
    tablePaddingHorizontalMiddle: cellPaddingInlineMD,
    tablePaddingVerticalSmall: cellPaddingBlockSM,
    tablePaddingHorizontalSmall: cellPaddingInlineSM,
    tableBorderColor: borderColor,
    tableHeaderTextColor: headerColor,
    tableHeaderBg: headerBg,
    tableFooterTextColor: footerColor,
    tableFooterBg: footerBg,
    tableHeaderCellSplitColor: headerSplitColor,
    tableHeaderSortBg: headerSortActiveBg,
    tableHeaderSortHoverBg: headerSortHoverBg,
    tableBodySortBg: bodySortBg,
    tableFixedHeaderSortActiveBg: fixedHeaderSortActiveBg,
    tableHeaderFilterActiveBg: headerFilterHoverBg,
    tableFilterDropdownBg: filterDropdownBg,
    tableRowHoverBg: rowHoverBg,
    tableSelectedRowBg: rowSelectedBg,
    tableSelectedRowHoverBg: rowSelectedHoverBg,
    zIndexTableFixed,
    zIndexTableSticky: calc(zIndexTableFixed).add(1).equal({
      unit: false
    }),
    tableFontSizeMiddle: cellFontSizeMD,
    tableFontSizeSmall: cellFontSizeSM,
    tableSelectionColumnWidth: selectionColumnWidth,
    tableExpandIconBg: expandIconBg,
    tableExpandColumnWidth: calc(checkboxSize).add(calc(token.padding).mul(2)).equal(),
    tableExpandedRowBg: rowExpandedBg,
    // Dropdown
    tableFilterDropdownWidth: 120,
    tableFilterDropdownHeight: 264,
    tableFilterDropdownSearchWidth: 140,
    // Virtual Scroll Bar
    tableScrollThumbSize: 8,
    // Mac scroll bar size
    tableScrollThumbBg: stickyScrollBarBg,
    tableScrollThumbBgHover: colorTextHeading,
    tableScrollBg: colorSplit
  });
  return [genTableStyle(tableToken), pagination(tableToken), summary(tableToken), sorter(tableToken), style_filter(tableToken), style_bordered(tableToken), style_radius(tableToken), expand(tableToken), summary(tableToken), style_empty(tableToken), selection(tableToken), fixed(tableToken), sticky(tableToken), ellipsis(tableToken), size(tableToken), table_style_rtl(tableToken), virtual(tableToken)];
}, table_style_prepareComponentToken, {
  unitless: {
    expandIconScale: true
  }
}));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/InternalTable.js
"use client";





























const InternalTable_EMPTY_LIST = [];
const InternalTable = (props, ref) => {
  var _a, _b;
  const {
    prefixCls: customizePrefixCls,
    className,
    rootClassName,
    style,
    size: customizeSize,
    bordered,
    dropdownPrefixCls: customizeDropdownPrefixCls,
    dataSource,
    pagination,
    rowSelection,
    rowKey = 'key',
    rowClassName,
    columns,
    children,
    childrenColumnName: legacyChildrenColumnName,
    onChange,
    getPopupContainer,
    loading,
    expandIcon,
    expandable,
    expandedRowRender,
    expandIconColumnIndex,
    indentSize,
    scroll,
    sortDirections,
    locale,
    showSorterTooltip = {
      target: 'full-header'
    },
    virtual
  } = props;
  const warning = warning_devUseWarning('Table');
  if (false) {}
  const baseColumns = react.useMemo(() => columns || (0,useColumns/* convertChildrenToColumns */.L)(children), [columns, children]);
  const needResponsive = react.useMemo(() => baseColumns.some(col => col.responsive), [baseColumns]);
  const screens = hooks_useBreakpoint(needResponsive);
  const mergedColumns = react.useMemo(() => {
    const matched = new Set(Object.keys(screens).filter(m => screens[m]));
    return baseColumns.filter(c => !c.responsive || c.responsive.some(r => matched.has(r)));
  }, [baseColumns, screens]);
  const tableProps = (0,omit/* default */.Z)(props, ['className', 'style', 'columns']);
  const {
    locale: contextLocale = es_locale_en_US,
    direction,
    table,
    renderEmpty,
    getPrefixCls,
    getPopupContainer: getContextPopupContainer
  } = react.useContext(ConfigContext);
  const mergedSize = hooks_useSize(customizeSize);
  const tableLocale = Object.assign(Object.assign({}, contextLocale.Table), locale);
  const rawData = dataSource || InternalTable_EMPTY_LIST;
  const prefixCls = getPrefixCls('table', customizePrefixCls);
  const dropdownPrefixCls = getPrefixCls('dropdown', customizeDropdownPrefixCls);
  const [, token] = useToken();
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = table_style(prefixCls, rootCls);
  const mergedExpandable = Object.assign(Object.assign({
    childrenColumnName: legacyChildrenColumnName,
    expandIconColumnIndex
  }, expandable), {
    expandIcon: (_a = expandable === null || expandable === void 0 ? void 0 : expandable.expandIcon) !== null && _a !== void 0 ? _a : (_b = table === null || table === void 0 ? void 0 : table.expandable) === null || _b === void 0 ? void 0 : _b.expandIcon
  });
  const {
    childrenColumnName = 'children'
  } = mergedExpandable;
  const expandType = react.useMemo(() => {
    if (rawData.some(item => item === null || item === void 0 ? void 0 : item[childrenColumnName])) {
      return 'nest';
    }
    if (expandedRowRender || (expandable === null || expandable === void 0 ? void 0 : expandable.expandedRowRender)) {
      return 'row';
    }
    return null;
  }, [rawData]);
  const internalRefs = {
    body: react.useRef(null)
  };
  // ============================ Width =============================
  const getContainerWidth = useContainerWidth(prefixCls);
  // ============================= Refs =============================
  const rootRef = react.useRef(null);
  const tblRef = react.useRef(null);
  useProxyImperativeHandle(ref, () => Object.assign(Object.assign({}, tblRef.current), {
    nativeElement: rootRef.current
  }));
  // ============================ RowKey ============================
  const getRowKey = react.useMemo(() => {
    if (typeof rowKey === 'function') {
      return rowKey;
    }
    return record => record === null || record === void 0 ? void 0 : record[rowKey];
  }, [rowKey]);
  const [getRecordByKey] = hooks_useLazyKVMap(rawData, childrenColumnName, getRowKey);
  // ============================ Events =============================
  const changeEventInfo = {};
  const triggerOnChange = (info, action, reset = false) => {
    var _a, _b, _c, _d;
    const changeInfo = Object.assign(Object.assign({}, changeEventInfo), info);
    if (reset) {
      (_a = changeEventInfo.resetPagination) === null || _a === void 0 ? void 0 : _a.call(changeEventInfo);
      // Reset event param
      if ((_b = changeInfo.pagination) === null || _b === void 0 ? void 0 : _b.current) {
        changeInfo.pagination.current = 1;
      }
      // Trigger pagination events
      if (pagination) {
        (_c = pagination.onChange) === null || _c === void 0 ? void 0 : _c.call(pagination, 1, (_d = changeInfo.pagination) === null || _d === void 0 ? void 0 : _d.pageSize);
      }
    }
    if (scroll && scroll.scrollToFirstRowOnChange !== false && internalRefs.body.current) {
      scrollTo(0, {
        getContainer: () => internalRefs.body.current
      });
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(changeInfo.pagination, changeInfo.filters, changeInfo.sorter, {
      currentDataSource: getFilterData(getSortData(rawData, changeInfo.sorterStates, childrenColumnName), changeInfo.filterStates, childrenColumnName),
      action
    });
  };
  /**
   * Controlled state in `columns` is not a good idea that makes too many code (1000+ line?) to read
   * state out and then put it back to title render. Move these code into `hooks` but still too
   * complex. We should provides Table props like `sorter` & `filter` to handle control in next big
   * version.
   */
  // ============================ Sorter =============================
  const onSorterChange = (sorter, sorterStates) => {
    triggerOnChange({
      sorter,
      sorterStates
    }, 'sort', false);
  };
  const [transformSorterColumns, sortStates, sorterTitleProps, getSorters] = useSorter({
    prefixCls,
    mergedColumns,
    onSorterChange,
    sortDirections: sortDirections || ['ascend', 'descend'],
    tableLocale,
    showSorterTooltip
  });
  const sortedData = react.useMemo(() => getSortData(rawData, sortStates, childrenColumnName), [rawData, sortStates]);
  changeEventInfo.sorter = getSorters();
  changeEventInfo.sorterStates = sortStates;
  // ============================ Filter ============================
  const onFilterChange = (filters, filterStates) => {
    triggerOnChange({
      filters,
      filterStates
    }, 'filter', true);
  };
  const [transformFilterColumns, filterStates, filters] = hooks_useFilter({
    prefixCls,
    locale: tableLocale,
    dropdownPrefixCls,
    mergedColumns,
    onFilterChange,
    getPopupContainer: getPopupContainer || getContextPopupContainer,
    rootClassName: classnames_default()(rootClassName, rootCls)
  });
  const mergedData = getFilterData(sortedData, filterStates, childrenColumnName);
  changeEventInfo.filters = filters;
  changeEventInfo.filterStates = filterStates;
  // ============================ Column ============================
  const columnTitleProps = react.useMemo(() => {
    const mergedFilters = {};
    Object.keys(filters).forEach(filterKey => {
      if (filters[filterKey] !== null) {
        mergedFilters[filterKey] = filters[filterKey];
      }
    });
    return Object.assign(Object.assign({}, sorterTitleProps), {
      filters: mergedFilters
    });
  }, [sorterTitleProps, filters]);
  const [transformTitleColumns] = hooks_useTitleColumns(columnTitleProps);
  // ========================== Pagination ==========================
  const onPaginationChange = (current, pageSize) => {
    triggerOnChange({
      pagination: Object.assign(Object.assign({}, changeEventInfo.pagination), {
        current,
        pageSize
      })
    }, 'paginate');
  };
  const [mergedPagination, resetPagination] = hooks_usePagination(mergedData.length, onPaginationChange, pagination);
  changeEventInfo.pagination = pagination === false ? {} : getPaginationParam(mergedPagination, pagination);
  changeEventInfo.resetPagination = resetPagination;
  // ============================= Data =============================
  const pageData = react.useMemo(() => {
    if (pagination === false || !mergedPagination.pageSize) {
      return mergedData;
    }
    const {
      current = 1,
      total,
      pageSize = DEFAULT_PAGE_SIZE
    } = mergedPagination;
     false ? 0 : void 0;
    // Dynamic table data
    if (mergedData.length < total) {
      if (mergedData.length > pageSize) {
         false ? 0 : void 0;
        return mergedData.slice((current - 1) * pageSize, current * pageSize);
      }
      return mergedData;
    }
    return mergedData.slice((current - 1) * pageSize, current * pageSize);
  }, [!!pagination, mergedData, mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.current, mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.pageSize, mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.total]);
  // ========================== Selections ==========================
  const [transformSelectionColumns, selectedKeySet] = hooks_useSelection({
    prefixCls,
    data: mergedData,
    pageData,
    getRowKey,
    getRecordByKey,
    expandType,
    childrenColumnName,
    locale: tableLocale,
    getPopupContainer: getPopupContainer || getContextPopupContainer
  }, rowSelection);
  const internalRowClassName = (record, index, indent) => {
    let mergedRowClassName;
    if (typeof rowClassName === 'function') {
      mergedRowClassName = classnames_default()(rowClassName(record, index, indent));
    } else {
      mergedRowClassName = classnames_default()(rowClassName);
    }
    return classnames_default()({
      [`${prefixCls}-row-selected`]: selectedKeySet.has(getRowKey(record, index))
    }, mergedRowClassName);
  };
  // ========================== Expandable ==========================
  // Pass origin render status into `rc-table`, this can be removed when refactor with `rc-table`
  mergedExpandable.__PARENT_RENDER_ICON__ = mergedExpandable.expandIcon;
  // Customize expandable icon
  mergedExpandable.expandIcon = mergedExpandable.expandIcon || expandIcon || ExpandIcon(tableLocale);
  // Adjust expand icon index, no overwrite expandIconColumnIndex if set.
  if (expandType === 'nest' && mergedExpandable.expandIconColumnIndex === undefined) {
    mergedExpandable.expandIconColumnIndex = rowSelection ? 1 : 0;
  } else if (mergedExpandable.expandIconColumnIndex > 0 && rowSelection) {
    mergedExpandable.expandIconColumnIndex -= 1;
  }
  // Indent size
  if (typeof mergedExpandable.indentSize !== 'number') {
    mergedExpandable.indentSize = typeof indentSize === 'number' ? indentSize : 15;
  }
  // ============================ Render ============================
  const transformColumns = react.useCallback(innerColumns => transformTitleColumns(transformSelectionColumns(transformFilterColumns(transformSorterColumns(innerColumns)))), [transformSorterColumns, transformFilterColumns, transformSelectionColumns]);
  let topPaginationNode;
  let bottomPaginationNode;
  if (pagination !== false && (mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.total)) {
    let paginationSize;
    if (mergedPagination.size) {
      paginationSize = mergedPagination.size;
    } else {
      paginationSize = mergedSize === 'small' || mergedSize === 'middle' ? 'small' : undefined;
    }
    const renderPagination = position => (/*#__PURE__*/react.createElement(es_pagination, Object.assign({}, mergedPagination, {
      className: classnames_default()(`${prefixCls}-pagination ${prefixCls}-pagination-${position}`, mergedPagination.className),
      size: paginationSize
    })));
    const defaultPosition = direction === 'rtl' ? 'left' : 'right';
    const {
      position
    } = mergedPagination;
    if (position !== null && Array.isArray(position)) {
      const topPos = position.find(p => p.includes('top'));
      const bottomPos = position.find(p => p.includes('bottom'));
      const isDisable = position.every(p => `${p}` === 'none');
      if (!topPos && !bottomPos && !isDisable) {
        bottomPaginationNode = renderPagination(defaultPosition);
      }
      if (topPos) {
        topPaginationNode = renderPagination(topPos.toLowerCase().replace('top', ''));
      }
      if (bottomPos) {
        bottomPaginationNode = renderPagination(bottomPos.toLowerCase().replace('bottom', ''));
      }
    } else {
      bottomPaginationNode = renderPagination(defaultPosition);
    }
  }
  // >>>>>>>>> Spinning
  let spinProps;
  if (typeof loading === 'boolean') {
    spinProps = {
      spinning: loading
    };
  } else if (typeof loading === 'object') {
    spinProps = Object.assign({
      spinning: true
    }, loading);
  }
  const wrapperClassNames = classnames_default()(cssVarCls, rootCls, `${prefixCls}-wrapper`, table === null || table === void 0 ? void 0 : table.className, {
    [`${prefixCls}-wrapper-rtl`]: direction === 'rtl'
  }, className, rootClassName, hashId);
  const mergedStyle = Object.assign(Object.assign({}, table === null || table === void 0 ? void 0 : table.style), style);
  const emptyText = typeof (locale === null || locale === void 0 ? void 0 : locale.emptyText) !== 'undefined' ? locale.emptyText : (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty('Table')) || /*#__PURE__*/react.createElement(defaultRenderEmpty, {
    componentName: "Table"
  });
  // ========================== Render ==========================
  const TableComponent = virtual ? VirtualTable : table_RcTable;
  // >>> Virtual Table props. We set height here since it will affect height collection
  const virtualProps = {};
  const listItemHeight = react.useMemo(() => {
    const {
      fontSize,
      lineHeight,
      lineWidth,
      padding,
      paddingXS,
      paddingSM
    } = token;
    const fontHeight = Math.floor(fontSize * lineHeight);
    switch (mergedSize) {
      case 'middle':
        return paddingSM * 2 + fontHeight + lineWidth;
      case 'small':
        return paddingXS * 2 + fontHeight + lineWidth;
      default:
        return padding * 2 + fontHeight + lineWidth;
    }
  }, [token, mergedSize]);
  if (virtual) {
    virtualProps.listItemHeight = listItemHeight;
  }
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    ref: rootRef,
    className: wrapperClassNames,
    style: mergedStyle
  }, /*#__PURE__*/react.createElement(spin, Object.assign({
    spinning: false
  }, spinProps), topPaginationNode, /*#__PURE__*/react.createElement(TableComponent, Object.assign({}, virtualProps, tableProps, {
    ref: tblRef,
    columns: mergedColumns,
    direction: direction,
    expandable: mergedExpandable,
    prefixCls: prefixCls,
    className: classnames_default()({
      [`${prefixCls}-middle`]: mergedSize === 'middle',
      [`${prefixCls}-small`]: mergedSize === 'small',
      [`${prefixCls}-bordered`]: bordered,
      [`${prefixCls}-empty`]: rawData.length === 0
    }, cssVarCls, rootCls, hashId),
    data: pageData,
    rowKey: getRowKey,
    rowClassName: internalRowClassName,
    emptyText: emptyText,
    // Internal
    internalHooks: rc_table_es/* INTERNAL_HOOKS */.RQ,
    internalRefs: internalRefs,
    transformColumns: transformColumns,
    getContainerWidth: getContainerWidth
  })), bottomPaginationNode)));
};
/* harmony default export */ var table_InternalTable = (/*#__PURE__*/react.forwardRef(InternalTable));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/Table.js
"use client";







const Table = (props, ref) => {
  const renderTimesRef = react.useRef(0);
  renderTimesRef.current += 1;
  return /*#__PURE__*/react.createElement(table_InternalTable, Object.assign({}, props, {
    ref: ref,
    _renderTimes: renderTimesRef.current
  }));
};
const ForwardTable = /*#__PURE__*/react.forwardRef(Table);
ForwardTable.SELECTION_COLUMN = SELECTION_COLUMN;
ForwardTable.EXPAND_COLUMN = rc_table_es/* EXPAND_COLUMN */.w2;
ForwardTable.SELECTION_ALL = SELECTION_ALL;
ForwardTable.SELECTION_INVERT = SELECTION_INVERT;
ForwardTable.SELECTION_NONE = SELECTION_NONE;
ForwardTable.Column = table_Column;
ForwardTable.ColumnGroup = table_ColumnGroup;
ForwardTable.Summary = rc_table_es/* Summary */.ER;
if (false) {}
/* harmony default export */ var table_Table = (ForwardTable);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/table/index.js
"use client";


/* harmony default export */ var table = (table_Table);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tag/style/index.js




// ============================== Styles ==============================
const tag_style_genBaseStyle = token => {
  const {
    paddingXXS,
    lineWidth,
    tagPaddingHorizontal,
    componentCls,
    calc
  } = token;
  const paddingInline = calc(tagPaddingHorizontal).sub(lineWidth).equal();
  const iconMarginInline = calc(paddingXXS).sub(lineWidth).equal();
  return {
    // Result
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      display: 'inline-block',
      height: 'auto',
      // https://github.com/ant-design/ant-design/pull/47504
      marginInlineEnd: token.marginXS,
      paddingInline,
      fontSize: token.tagFontSize,
      lineHeight: token.tagLineHeight,
      whiteSpace: 'nowrap',
      background: token.defaultBg,
      border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
      borderRadius: token.borderRadiusSM,
      opacity: 1,
      transition: `all ${token.motionDurationMid}`,
      textAlign: 'start',
      position: 'relative',
      // RTL
      [`&${componentCls}-rtl`]: {
        direction: 'rtl'
      },
      '&, a, a:hover': {
        color: token.defaultColor
      },
      [`${componentCls}-close-icon`]: {
        marginInlineStart: iconMarginInline,
        fontSize: token.tagIconSize,
        color: token.colorIcon,
        cursor: 'pointer',
        transition: `all ${token.motionDurationMid}`,
        '&:hover': {
          color: token.colorTextHeading
        }
      },
      [`&${componentCls}-has-color`]: {
        borderColor: 'transparent',
        [`&, a, a:hover, ${token.iconCls}-close, ${token.iconCls}-close:hover`]: {
          color: token.colorTextLightSolid
        }
      },
      '&-checkable': {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        cursor: 'pointer',
        [`&:not(${componentCls}-checkable-checked):hover`]: {
          color: token.colorPrimary,
          backgroundColor: token.colorFillSecondary
        },
        '&:active, &-checked': {
          color: token.colorTextLightSolid
        },
        '&-checked': {
          backgroundColor: token.colorPrimary,
          '&:hover': {
            backgroundColor: token.colorPrimaryHover
          }
        },
        '&:active': {
          backgroundColor: token.colorPrimaryActive
        }
      },
      '&-hidden': {
        display: 'none'
      },
      // To ensure that a space will be placed between character and `Icon`.
      [`> ${token.iconCls} + span, > span + ${token.iconCls}`]: {
        marginInlineStart: paddingInline
      }
    }),
    [`${componentCls}-borderless`]: {
      borderColor: 'transparent',
      background: token.tagBorderlessBg
    }
  };
};
// ============================== Export ==============================
const tag_style_prepareToken = token => {
  const {
    lineWidth,
    fontSizeIcon,
    calc
  } = token;
  const tagFontSize = token.fontSizeSM;
  const tagToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    tagFontSize,
    tagLineHeight: (0,cssinjs_es/* unit */.bf)(calc(token.lineHeightSM).mul(tagFontSize).equal()),
    tagIconSize: calc(fontSizeIcon).sub(calc(lineWidth).mul(2)).equal(),
    // Tag icon is much smaller
    tagPaddingHorizontal: 8,
    // Fixed padding.
    tagBorderlessBg: token.defaultBg
  });
  return tagToken;
};
const tag_style_prepareComponentToken = token => ({
  defaultBg: new fast_color_es/* FastColor */.t(token.colorFillQuaternary).onBackground(token.colorBgContainer).toHexString(),
  defaultColor: token.colorText
});
/* harmony default export */ var tag_style = (genStyleHooks('Tag', token => {
  const tagToken = tag_style_prepareToken(token);
  return tag_style_genBaseStyle(tagToken);
}, tag_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tag/CheckableTag.js
"use client";

var CheckableTag_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




const CheckableTag = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      style,
      className,
      checked,
      children,
      icon,
      onChange,
      onClick
    } = props,
    restProps = CheckableTag_rest(props, ["prefixCls", "style", "className", "checked", "children", "icon", "onChange", "onClick"]);
  const {
    getPrefixCls,
    tag
  } = react.useContext(ConfigContext);
  const handleClick = e => {
    onChange === null || onChange === void 0 ? void 0 : onChange(!checked);
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  const prefixCls = getPrefixCls('tag', customizePrefixCls);
  // Style
  const [wrapCSSVar, hashId, cssVarCls] = tag_style(prefixCls);
  const cls = classnames_default()(prefixCls, `${prefixCls}-checkable`, {
    [`${prefixCls}-checkable-checked`]: checked
  }, tag === null || tag === void 0 ? void 0 : tag.className, className, hashId, cssVarCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement("span", Object.assign({}, restProps, {
    ref: ref,
    style: Object.assign(Object.assign({}, style), tag === null || tag === void 0 ? void 0 : tag.style),
    className: cls,
    onClick: handleClick
  }), icon, /*#__PURE__*/react.createElement("span", null, children)));
});
/* harmony default export */ var tag_CheckableTag = (CheckableTag);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tag/style/presetCmp.js
// Style as status component


// ============================== Preset ==============================
const genPresetStyle = token => genPresetColor_genPresetColor(token, (colorKey, {
  textColor,
  lightBorderColor,
  lightColor,
  darkColor
}) => ({
  [`${token.componentCls}${token.componentCls}-${colorKey}`]: {
    color: textColor,
    background: lightColor,
    borderColor: lightBorderColor,
    // Inverse color
    '&-inverse': {
      color: token.colorTextLightSolid,
      background: darkColor,
      borderColor: darkColor
    },
    [`&${token.componentCls}-borderless`]: {
      borderColor: 'transparent'
    }
  }
}));
// ============================== Export ==============================
/* harmony default export */ var presetCmp = (genSubStyleComponent(['Tag', 'preset'], token => {
  const tagToken = tag_style_prepareToken(token);
  return genPresetStyle(tagToken);
}, tag_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/capitalize.js
function capitalize(str) {
  if (typeof str !== 'string') {
    return str;
  }
  const ret = str.charAt(0).toUpperCase() + str.slice(1);
  return ret;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tag/style/statusCmp.js



const genTagStatusStyle = (token, status, cssVariableType) => {
  const capitalizedCssVariableType = capitalize(cssVariableType);
  return {
    [`${token.componentCls}${token.componentCls}-${status}`]: {
      color: token[`color${cssVariableType}`],
      background: token[`color${capitalizedCssVariableType}Bg`],
      borderColor: token[`color${capitalizedCssVariableType}Border`],
      [`&${token.componentCls}-borderless`]: {
        borderColor: 'transparent'
      }
    }
  };
};
// ============================== Export ==============================
/* harmony default export */ var statusCmp = (genSubStyleComponent(['Tag', 'status'], token => {
  const tagToken = tag_style_prepareToken(token);
  return [genTagStatusStyle(tagToken, 'success', 'Success'), genTagStatusStyle(tagToken, 'processing', 'Info'), genTagStatusStyle(tagToken, 'error', 'Error'), genTagStatusStyle(tagToken, 'warning', 'Warning')];
}, tag_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tag/index.js
"use client";

var tag_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};













const InternalTag = /*#__PURE__*/react.forwardRef((tagProps, ref) => {
  const {
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      style,
      children,
      icon,
      color,
      onClose,
      bordered = true,
      visible: deprecatedVisible
    } = tagProps,
    props = tag_rest(tagProps, ["prefixCls", "className", "rootClassName", "style", "children", "icon", "color", "onClose", "bordered", "visible"]);
  const {
    getPrefixCls,
    direction,
    tag: tagContext
  } = react.useContext(ConfigContext);
  const [visible, setVisible] = react.useState(true);
  const domProps = (0,omit/* default */.Z)(props, ['closeIcon', 'closable']);
  // Warning for deprecated usage
  if (false) {}
  react.useEffect(() => {
    if (deprecatedVisible !== undefined) {
      setVisible(deprecatedVisible);
    }
  }, [deprecatedVisible]);
  const isPreset = isPresetColor(color);
  const isStatus = isPresetStatusColor(color);
  const isInternalColor = isPreset || isStatus;
  const tagStyle = Object.assign(Object.assign({
    backgroundColor: color && !isInternalColor ? color : undefined
  }, tagContext === null || tagContext === void 0 ? void 0 : tagContext.style), style);
  const prefixCls = getPrefixCls('tag', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = tag_style(prefixCls);
  // Style
  const tagClassName = classnames_default()(prefixCls, tagContext === null || tagContext === void 0 ? void 0 : tagContext.className, {
    [`${prefixCls}-${color}`]: isInternalColor,
    [`${prefixCls}-has-color`]: color && !isInternalColor,
    [`${prefixCls}-hidden`]: !visible,
    [`${prefixCls}-rtl`]: direction === 'rtl',
    [`${prefixCls}-borderless`]: !bordered
  }, className, rootClassName, hashId, cssVarCls);
  const handleCloseClick = e => {
    e.stopPropagation();
    onClose === null || onClose === void 0 ? void 0 : onClose(e);
    if (e.defaultPrevented) {
      return;
    }
    setVisible(false);
  };
  const [, mergedCloseIcon] = useClosable(pickClosable(tagProps), pickClosable(tagContext), {
    closable: false,
    closeIconRender: iconNode => {
      const replacement = /*#__PURE__*/react.createElement("span", {
        className: `${prefixCls}-close-icon`,
        onClick: handleCloseClick
      }, iconNode);
      return replaceElement(iconNode, replacement, originProps => ({
        onClick: e => {
          var _a;
          (_a = originProps === null || originProps === void 0 ? void 0 : originProps.onClick) === null || _a === void 0 ? void 0 : _a.call(originProps, e);
          handleCloseClick(e);
        },
        className: classnames_default()(originProps === null || originProps === void 0 ? void 0 : originProps.className, `${prefixCls}-close-icon`)
      }));
    }
  });
  const isNeedWave = typeof props.onClick === 'function' || children && children.type === 'a';
  const iconNode = icon || null;
  const kids = iconNode ? (/*#__PURE__*/react.createElement(react.Fragment, null, iconNode, children && /*#__PURE__*/react.createElement("span", null, children))) : children;
  const tagNode = /*#__PURE__*/react.createElement("span", Object.assign({}, domProps, {
    ref: ref,
    className: tagClassName,
    style: tagStyle
  }), kids, mergedCloseIcon, isPreset && /*#__PURE__*/react.createElement(presetCmp, {
    key: "preset",
    prefixCls: prefixCls
  }), isStatus && /*#__PURE__*/react.createElement(statusCmp, {
    key: "status",
    prefixCls: prefixCls
  }));
  return wrapCSSVar(isNeedWave ? /*#__PURE__*/react.createElement(wave, {
    component: "Tag"
  }, tagNode) : tagNode);
});
const Tag = InternalTag;
if (false) {}
Tag.CheckableTag = tag_CheckableTag;
/* harmony default export */ var tag = (Tag);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/getDesignToken.js




const getDesignToken = config => {
  const theme = (config === null || config === void 0 ? void 0 : config.algorithm) ? (0,cssinjs_es/* createTheme */.jG)(config.algorithm) : default_theme;
  const mergedToken = Object.assign(Object.assign({}, seed), config === null || config === void 0 ? void 0 : config.token);
  return (0,cssinjs_es/* getComputedToken */.t2)(mergedToken, {
    override: config === null || config === void 0 ? void 0 : config.token
  }, theme, formatToken);
};
/* harmony default export */ var theme_getDesignToken = (getDesignToken);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/themes/compact/genCompactSizeMapToken.js
function genCompactSizeMapToken_genSizeMapToken(token) {
  const {
    sizeUnit,
    sizeStep
  } = token;
  const compactSizeStep = sizeStep - 2;
  return {
    sizeXXL: sizeUnit * (compactSizeStep + 10),
    sizeXL: sizeUnit * (compactSizeStep + 6),
    sizeLG: sizeUnit * (compactSizeStep + 2),
    sizeMD: sizeUnit * (compactSizeStep + 2),
    sizeMS: sizeUnit * (compactSizeStep + 1),
    size: sizeUnit * compactSizeStep,
    sizeSM: sizeUnit * compactSizeStep,
    sizeXS: sizeUnit * (compactSizeStep - 1),
    sizeXXS: sizeUnit * (compactSizeStep - 1)
  };
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/themes/compact/index.js




const compact_derivative = (token, mapToken) => {
  const mergedMapToken = mapToken !== null && mapToken !== void 0 ? mapToken : derivative(token);
  const fontSize = mergedMapToken.fontSizeSM; // Smaller size font-size as base
  const controlHeight = mergedMapToken.controlHeight - 4;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, mergedMapToken), genCompactSizeMapToken_genSizeMapToken(mapToken !== null && mapToken !== void 0 ? mapToken : token)), shared_genFontMapToken(fontSize)), {
    // controlHeight
    controlHeight
  }), shared_genControlHeight(Object.assign(Object.assign({}, mergedMapToken), {
    controlHeight
  })));
};
/* harmony default export */ var themes_compact = (compact_derivative);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/themes/dark/colorAlgorithm.js

const colorAlgorithm_getAlphaColor = (baseColor, alpha) => new fast_color_es/* FastColor */.t(baseColor).setA(alpha).toRgbString();
const colorAlgorithm_getSolidColor = (baseColor, brightness) => {
  const instance = new fast_color_es/* FastColor */.t(baseColor);
  return instance.lighten(brightness).toHexString();
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/themes/dark/colors.js


const colors_generateColorPalettes = baseColor => {
  const colors = (0,colors_es/* generate */.R_)(baseColor, {
    theme: 'dark'
  });
  return {
    1: colors[0],
    2: colors[1],
    3: colors[2],
    4: colors[3],
    5: colors[6],
    6: colors[5],
    7: colors[4],
    8: colors[6],
    9: colors[5],
    10: colors[4]
    // 8: colors[9],
    // 9: colors[8],
    // 10: colors[7],
  };
};
const colors_generateNeutralColorPalettes = (bgBaseColor, textBaseColor) => {
  const colorBgBase = bgBaseColor || '#000';
  const colorTextBase = textBaseColor || '#fff';
  return {
    colorBgBase,
    colorTextBase,
    colorText: colorAlgorithm_getAlphaColor(colorTextBase, 0.85),
    colorTextSecondary: colorAlgorithm_getAlphaColor(colorTextBase, 0.65),
    colorTextTertiary: colorAlgorithm_getAlphaColor(colorTextBase, 0.45),
    colorTextQuaternary: colorAlgorithm_getAlphaColor(colorTextBase, 0.25),
    colorFill: colorAlgorithm_getAlphaColor(colorTextBase, 0.18),
    colorFillSecondary: colorAlgorithm_getAlphaColor(colorTextBase, 0.12),
    colorFillTertiary: colorAlgorithm_getAlphaColor(colorTextBase, 0.08),
    colorFillQuaternary: colorAlgorithm_getAlphaColor(colorTextBase, 0.04),
    colorBgSolid: colorAlgorithm_getAlphaColor(colorTextBase, 0.95),
    colorBgSolidHover: colorAlgorithm_getAlphaColor(colorTextBase, 1),
    colorBgSolidActive: colorAlgorithm_getAlphaColor(colorTextBase, 0.9),
    colorBgElevated: colorAlgorithm_getSolidColor(colorBgBase, 12),
    colorBgContainer: colorAlgorithm_getSolidColor(colorBgBase, 8),
    colorBgLayout: colorAlgorithm_getSolidColor(colorBgBase, 0),
    colorBgSpotlight: colorAlgorithm_getSolidColor(colorBgBase, 26),
    colorBgBlur: colorAlgorithm_getAlphaColor(colorTextBase, 0.04),
    colorBorder: colorAlgorithm_getSolidColor(colorBgBase, 26),
    colorBorderSecondary: colorAlgorithm_getSolidColor(colorBgBase, 19)
  };
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/themes/dark/index.js





const dark_derivative = (token, mapToken) => {
  const colorPalettes = Object.keys(defaultPresetColors).map(colorKey => {
    const colors = (0,colors_es/* generate */.R_)(token[colorKey], {
      theme: 'dark'
    });
    return Array.from({
      length: 10
    }, () => 1).reduce((prev, _, i) => {
      prev[`${colorKey}-${i + 1}`] = colors[i];
      prev[`${colorKey}${i + 1}`] = colors[i];
      return prev;
    }, {});
  }).reduce((prev, cur) => {
    prev = Object.assign(Object.assign({}, prev), cur);
    return prev;
  }, {});
  const mergedMapToken = mapToken !== null && mapToken !== void 0 ? mapToken : derivative(token);
  const colorMapToken = genColorMapToken(token, {
    generateColorPalettes: colors_generateColorPalettes,
    generateNeutralColorPalettes: colors_generateNeutralColorPalettes
  });
  return Object.assign(Object.assign(Object.assign(Object.assign({}, mergedMapToken), colorPalettes), colorMapToken), {
    // Customize selected item background color
    // https://github.com/ant-design/ant-design/issues/30524#issuecomment-871961867
    colorPrimaryBg: colorMapToken.colorPrimaryBorder,
    colorPrimaryBgHover: colorMapToken.colorPrimaryBorderHover
  });
};
/* harmony default export */ var dark = (dark_derivative);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/theme/index.js
"use client";






// ZombieJ: We export as object to user but array in internal.
// This is used to minimize the bundle size for antd package but safe to refactor as object also.
// Please do not export internal `useToken` directly to avoid something export unexpected.
/** Get current context Design Token. Will be different if you are using nest theme config. */
function theme_useToken() {
  const [theme, token, hashId] = useToken();
  return {
    theme,
    token,
    hashId
  };
}
/* harmony default export */ var es_theme = ({
  /** Default seedToken */
  defaultSeed: defaultConfig.token,
  useToken: theme_useToken,
  defaultAlgorithm: derivative,
  darkAlgorithm: dark,
  compactAlgorithm: themes_compact,
  getDesignToken: theme_getDesignToken,
  /**
   * @private Private variable
   * @warring 🔥 Do not use in production. 🔥
   */
  defaultConfig: defaultConfig,
  /**
   * @private Private variable
   * @warring 🔥 Do not use in production. 🔥
   */
  _internalContext: DesignTokenContext
});
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/time-picker/index.js
"use client";

var time_picker_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





const {
  TimePicker: InternalTimePicker,
  RangePicker: InternalRangePicker
} = date_picker;
const RangePicker = /*#__PURE__*/react.forwardRef((props, ref) => (/*#__PURE__*/react.createElement(InternalRangePicker, Object.assign({}, props, {
  picker: "time",
  mode: undefined,
  ref: ref
}))));
const TimePicker = /*#__PURE__*/react.forwardRef((_a, ref) => {
  var {
      addon,
      renderExtraFooter,
      variant,
      bordered
    } = _a,
    restProps = time_picker_rest(_a, ["addon", "renderExtraFooter", "variant", "bordered"]);
  if (false) {}
  const [mergedVariant] = useVariants('timePicker', variant, bordered);
  const internalRenderExtraFooter = react.useMemo(() => {
    if (renderExtraFooter) {
      return renderExtraFooter;
    }
    if (addon) {
      return addon;
    }
    return undefined;
  }, [addon, renderExtraFooter]);
  return /*#__PURE__*/react.createElement(InternalTimePicker, Object.assign({}, restProps, {
    mode: undefined,
    ref: ref,
    renderExtraFooter: internalRenderExtraFooter,
    variant: mergedVariant
  }));
});
if (false) {}
// We don't care debug panel
/* istanbul ignore next */
const time_picker_PurePanel = _util_PurePanel(TimePicker, 'popupAlign', undefined, 'picker');
TimePicker._InternalPanelDoNotUseOrYouWillBeFired = time_picker_PurePanel;
TimePicker.RangePicker = RangePicker;
TimePicker._InternalPanelDoNotUseOrYouWillBeFired = time_picker_PurePanel;
/* harmony default export */ var time_picker = (TimePicker);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/timeline/style/index.js



const genTimelineStyle = token => {
  const {
    componentCls,
    calc
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      margin: 0,
      padding: 0,
      listStyle: 'none',
      [`${componentCls}-item`]: {
        position: 'relative',
        margin: 0,
        paddingBottom: token.itemPaddingBottom,
        fontSize: token.fontSize,
        listStyle: 'none',
        '&-tail': {
          position: 'absolute',
          insetBlockStart: token.itemHeadSize,
          insetInlineStart: calc(calc(token.itemHeadSize).sub(token.tailWidth)).div(2).equal(),
          height: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(token.itemHeadSize)})`,
          borderInlineStart: `${(0,cssinjs_es/* unit */.bf)(token.tailWidth)} ${token.lineType} ${token.tailColor}`
        },
        '&-pending': {
          [`${componentCls}-item-head`]: {
            fontSize: token.fontSizeSM,
            backgroundColor: 'transparent'
          },
          [`${componentCls}-item-tail`]: {
            display: 'none'
          }
        },
        '&-head': {
          position: 'absolute',
          width: token.itemHeadSize,
          height: token.itemHeadSize,
          backgroundColor: token.dotBg,
          border: `${(0,cssinjs_es/* unit */.bf)(token.dotBorderWidth)} ${token.lineType} transparent`,
          borderRadius: '50%',
          '&-blue': {
            color: token.colorPrimary,
            borderColor: token.colorPrimary
          },
          '&-red': {
            color: token.colorError,
            borderColor: token.colorError
          },
          '&-green': {
            color: token.colorSuccess,
            borderColor: token.colorSuccess
          },
          '&-gray': {
            color: token.colorTextDisabled,
            borderColor: token.colorTextDisabled
          }
        },
        '&-head-custom': {
          position: 'absolute',
          insetBlockStart: calc(token.itemHeadSize).div(2).equal(),
          insetInlineStart: calc(token.itemHeadSize).div(2).equal(),
          width: 'auto',
          height: 'auto',
          marginBlockStart: 0,
          paddingBlock: token.customHeadPaddingVertical,
          lineHeight: 1,
          textAlign: 'center',
          border: 0,
          borderRadius: 0,
          transform: 'translate(-50%, -50%)'
        },
        '&-content': {
          position: 'relative',
          insetBlockStart: calc(calc(token.fontSize).mul(token.lineHeight).sub(token.fontSize)).mul(-1).add(token.lineWidth).equal(),
          marginInlineStart: calc(token.margin).add(token.itemHeadSize).equal(),
          marginInlineEnd: 0,
          marginBlockStart: 0,
          marginBlockEnd: 0,
          wordBreak: 'break-word'
        },
        '&-last': {
          [`> ${componentCls}-item-tail`]: {
            display: 'none'
          },
          [`> ${componentCls}-item-content`]: {
            minHeight: calc(token.controlHeightLG).mul(1.2).equal()
          }
        }
      },
      [`&${componentCls}-alternate,
        &${componentCls}-right,
        &${componentCls}-label`]: {
        [`${componentCls}-item`]: {
          '&-tail, &-head, &-head-custom': {
            insetInlineStart: '50%'
          },
          '&-head': {
            marginInlineStart: calc(token.marginXXS).mul(-1).equal(),
            '&-custom': {
              marginInlineStart: calc(token.tailWidth).div(2).equal()
            }
          },
          '&-left': {
            [`${componentCls}-item-content`]: {
              insetInlineStart: `calc(50% - ${(0,cssinjs_es/* unit */.bf)(token.marginXXS)})`,
              width: `calc(50% - ${(0,cssinjs_es/* unit */.bf)(token.marginSM)})`,
              textAlign: 'start'
            }
          },
          '&-right': {
            [`${componentCls}-item-content`]: {
              width: `calc(50% - ${(0,cssinjs_es/* unit */.bf)(token.marginSM)})`,
              margin: 0,
              textAlign: 'end'
            }
          }
        }
      },
      [`&${componentCls}-right`]: {
        [`${componentCls}-item-right`]: {
          [`${componentCls}-item-tail,
            ${componentCls}-item-head,
            ${componentCls}-item-head-custom`]: {
            insetInlineStart: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(calc(calc(token.itemHeadSize).add(token.tailWidth)).div(2).equal())})`
          },
          [`${componentCls}-item-content`]: {
            width: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(calc(token.itemHeadSize).add(token.marginXS).equal())})`
          }
        }
      },
      [`&${componentCls}-pending
        ${componentCls}-item-last
        ${componentCls}-item-tail`]: {
        display: 'block',
        height: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(token.margin)})`,
        borderInlineStart: `${(0,cssinjs_es/* unit */.bf)(token.tailWidth)} dotted ${token.tailColor}`
      },
      [`&${componentCls}-reverse
        ${componentCls}-item-last
        ${componentCls}-item-tail`]: {
        display: 'none'
      },
      [`&${componentCls}-reverse ${componentCls}-item-pending`]: {
        [`${componentCls}-item-tail`]: {
          insetBlockStart: token.margin,
          display: 'block',
          height: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(token.margin)})`,
          borderInlineStart: `${(0,cssinjs_es/* unit */.bf)(token.tailWidth)} dotted ${token.tailColor}`
        },
        [`${componentCls}-item-content`]: {
          minHeight: calc(token.controlHeightLG).mul(1.2).equal()
        }
      },
      [`&${componentCls}-label`]: {
        [`${componentCls}-item-label`]: {
          position: 'absolute',
          insetBlockStart: calc(calc(token.fontSize).mul(token.lineHeight).sub(token.fontSize)).mul(-1).add(token.tailWidth).equal(),
          width: `calc(50% - ${(0,cssinjs_es/* unit */.bf)(token.marginSM)})`,
          textAlign: 'end'
        },
        [`${componentCls}-item-right`]: {
          [`${componentCls}-item-label`]: {
            insetInlineStart: `calc(50% + ${(0,cssinjs_es/* unit */.bf)(token.marginSM)})`,
            width: `calc(50% - ${(0,cssinjs_es/* unit */.bf)(token.marginSM)})`,
            textAlign: 'start'
          }
        }
      },
      // ====================== RTL =======================
      '&-rtl': {
        direction: 'rtl',
        [`${componentCls}-item-head-custom`]: {
          transform: `translate(50%, -50%)`
        }
      }
    })
  };
};
// ============================== Export ==============================
const timeline_style_prepareComponentToken = token => ({
  tailColor: token.colorSplit,
  tailWidth: token.lineWidthBold,
  dotBorderWidth: token.wireframe ? token.lineWidthBold : token.lineWidth * 3,
  dotBg: token.colorBgContainer,
  itemPaddingBottom: token.padding * 1.25
});
/* harmony default export */ var timeline_style = (genStyleHooks('Timeline', token => {
  const timeLineToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    itemHeadSize: 10,
    customHeadPaddingVertical: token.paddingXXS,
    paddingInlineEnd: 2
  });
  return genTimelineStyle(timeLineToken);
}, timeline_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/timeline/TimelineItem.js
"use client";

var TimelineItem_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};



const TimelineItem = _a => {
  var {
      prefixCls: customizePrefixCls,
      className,
      color = 'blue',
      dot,
      pending = false,
      position /** Dead, but do not pass in <li {...omit()} */,
      label,
      children
    } = _a,
    restProps = TimelineItem_rest(_a, ["prefixCls", "className", "color", "dot", "pending", "position", "label", "children"]);
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('timeline', customizePrefixCls);
  const itemClassName = classnames_default()(`${prefixCls}-item`, {
    [`${prefixCls}-item-pending`]: pending
  }, className);
  const customColor = /blue|red|green|gray/.test(color || '') ? undefined : color;
  const dotClassName = classnames_default()(`${prefixCls}-item-head`, {
    [`${prefixCls}-item-head-custom`]: !!dot,
    [`${prefixCls}-item-head-${color}`]: !customColor
  });
  return /*#__PURE__*/react.createElement("li", Object.assign({}, restProps, {
    className: itemClassName
  }), label && /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-item-label`
  }, label), /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-item-tail`
  }), /*#__PURE__*/react.createElement("div", {
    className: dotClassName,
    style: {
      borderColor: customColor,
      color: customColor
    }
  }, dot), /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-item-content`
  }, children));
};
/* harmony default export */ var timeline_TimelineItem = (TimelineItem);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/timeline/TimelineItemList.js
"use client";


var TimelineItemList_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




const TimelineItemList = _a => {
  var {
      prefixCls,
      className,
      pending = false,
      children,
      items,
      rootClassName,
      reverse = false,
      direction,
      hashId,
      pendingDot,
      mode = ''
    } = _a,
    restProps = TimelineItemList_rest(_a, ["prefixCls", "className", "pending", "children", "items", "rootClassName", "reverse", "direction", "hashId", "pendingDot", "mode"]);
  const getPositionCls = (position, idx) => {
    if (mode === 'alternate') {
      if (position === 'right') return `${prefixCls}-item-right`;
      if (position === 'left') return `${prefixCls}-item-left`;
      return idx % 2 === 0 ? `${prefixCls}-item-left` : `${prefixCls}-item-right`;
    }
    if (mode === 'left') return `${prefixCls}-item-left`;
    if (mode === 'right') return `${prefixCls}-item-right`;
    if (position === 'right') return `${prefixCls}-item-right`;
    return '';
  };
  const mergedItems = (0,toConsumableArray/* default */.Z)(items || []);
  const pendingNode = typeof pending === 'boolean' ? null : pending;
  if (pending) {
    mergedItems.push({
      pending: !!pending,
      dot: pendingDot || /*#__PURE__*/react.createElement(LoadingOutlined/* default */.Z, null),
      children: pendingNode
    });
  }
  if (reverse) {
    mergedItems.reverse();
  }
  const itemsCount = mergedItems.length;
  const lastCls = `${prefixCls}-item-last`;
  const itemsList = mergedItems.filter(item => !!item).map((item, idx) => {
    var _a;
    const pendingClass = idx === itemsCount - 2 ? lastCls : '';
    const readyClass = idx === itemsCount - 1 ? lastCls : '';
    const {
        className: itemClassName
      } = item,
      itemProps = TimelineItemList_rest(item, ["className"]);
    return /*#__PURE__*/react.createElement(timeline_TimelineItem, Object.assign({}, itemProps, {
      className: classnames_default()([itemClassName, !reverse && !!pending ? pendingClass : readyClass, getPositionCls((_a = item === null || item === void 0 ? void 0 : item.position) !== null && _a !== void 0 ? _a : '', idx)]),
      key: (item === null || item === void 0 ? void 0 : item.key) || idx
    }));
  });
  const hasLabelItem = mergedItems.some(item => !!(item === null || item === void 0 ? void 0 : item.label));
  const classString = classnames_default()(prefixCls, {
    [`${prefixCls}-pending`]: !!pending,
    [`${prefixCls}-reverse`]: !!reverse,
    [`${prefixCls}-${mode}`]: !!mode && !hasLabelItem,
    [`${prefixCls}-label`]: hasLabelItem,
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, className, rootClassName, hashId);
  return /*#__PURE__*/react.createElement("ol", Object.assign({}, restProps, {
    className: classString
  }), itemsList);
};
/* harmony default export */ var timeline_TimelineItemList = (TimelineItemList);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/timeline/useItems.js

function timeline_useItems_useItems(items, children) {
  if (items && Array.isArray(items)) {
    return items;
  }
  return (0,Children_toArray/* default */.Z)(children).map(ele => {
    var _a, _b;
    return Object.assign({
      children: (_b = (_a = ele === null || ele === void 0 ? void 0 : ele.props) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : ''
    }, ele.props);
  });
}
/* harmony default export */ var timeline_useItems = (timeline_useItems_useItems);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/timeline/Timeline.js
"use client";

var Timeline_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





// CSSINJS




const Timeline = props => {
  const {
    getPrefixCls,
    direction,
    timeline
  } = react.useContext(ConfigContext);
  const {
      prefixCls: customizePrefixCls,
      children,
      items,
      className,
      style
    } = props,
    restProps = Timeline_rest(props, ["prefixCls", "children", "items", "className", "style"]);
  const prefixCls = getPrefixCls('timeline', customizePrefixCls);
  // =================== Warning =====================
  if (false) {}
  // Style
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = timeline_style(prefixCls, rootCls);
  const mergedItems = timeline_useItems(items, children);
  return wrapCSSVar(/*#__PURE__*/react.createElement(timeline_TimelineItemList, Object.assign({}, restProps, {
    className: classnames_default()(timeline === null || timeline === void 0 ? void 0 : timeline.className, className, cssVarCls, rootCls),
    style: Object.assign(Object.assign({}, timeline === null || timeline === void 0 ? void 0 : timeline.style), style),
    prefixCls: prefixCls,
    direction: direction,
    items: mergedItems,
    hashId: hashId
  })));
};
Timeline.Item = timeline_TimelineItem;
if (false) {}
/* harmony default export */ var timeline_Timeline = (Timeline);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/timeline/index.js
"use client";


/* harmony default export */ var timeline = (timeline_Timeline);
// EXTERNAL MODULE: ./node_modules/@rc-component/portal/es/index.js + 6 modules
var portal_es = __webpack_require__(90604);
;// CONCATENATED MODULE: ./node_modules/@rc-component/tour/es/hooks/useClosable.js



function isConfigObj(closable) {
  return closable !== null && (0,esm_typeof/* default */.Z)(closable) === 'object';
}
/**
 * Convert `closable` to ClosableConfig.
 * When `preset` is true, will auto fill ClosableConfig with default value.
 */
function getClosableConfig(closable, closeIcon, preset) {
  if (closable === false || closeIcon === false && (!isConfigObj(closable) || !closable.closeIcon)) {
    return null;
  }
  var mergedCloseIcon = typeof closeIcon !== 'boolean' ? closeIcon : undefined;
  if (isConfigObj(closable)) {
    var _closable$closeIcon;
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, closable), {}, {
      closeIcon: (_closable$closeIcon = closable.closeIcon) !== null && _closable$closeIcon !== void 0 ? _closable$closeIcon : mergedCloseIcon
    });
  }

  // When StepClosable no need auto fill, but RootClosable need this.
  return preset || closable || closeIcon ? {
    closeIcon: mergedCloseIcon
  } : 'empty';
}
function useClosable_useClosable(stepClosable, stepCloseIcon, closable, closeIcon) {
  return react.useMemo(function () {
    var stepClosableConfig = getClosableConfig(stepClosable, stepCloseIcon, false);
    var rootClosableConfig = getClosableConfig(closable, closeIcon, true);
    if (stepClosableConfig !== 'empty') {
      return stepClosableConfig;
    }
    return rootClosableConfig;
  }, [closable, closeIcon, stepClosable, stepCloseIcon]);
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/tour/es/util.js
function isInViewPort(element) {
  var viewWidth = window.innerWidth || document.documentElement.clientWidth;
  var viewHeight = window.innerHeight || document.documentElement.clientHeight;
  var _element$getBoundingC = element.getBoundingClientRect(),
    top = _element$getBoundingC.top,
    right = _element$getBoundingC.right,
    bottom = _element$getBoundingC.bottom,
    left = _element$getBoundingC.left;
  return top >= 0 && left >= 0 && right <= viewWidth && bottom <= viewHeight;
}
function getPlacement(targetElement, placement, stepPlacement) {
  var _ref;
  return (_ref = stepPlacement !== null && stepPlacement !== void 0 ? stepPlacement : placement) !== null && _ref !== void 0 ? _ref : targetElement === null ? 'center' : 'bottom';
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/tour/es/hooks/useTarget.js





function isValidNumber(val) {
  return typeof val === 'number' && !Number.isNaN(val);
}
function useTarget(target, open, gap, scrollIntoViewOptions) {
  // ========================= Target =========================
  // We trade `undefined` as not get target by function yet.
  // `null` as empty target.
  var _useState = (0,react.useState)(undefined),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    targetElement = _useState2[0],
    setTargetElement = _useState2[1];
  (0,hooks_useLayoutEffect/* default */.Z)(function () {
    var nextElement = typeof target === 'function' ? target() : target;
    setTargetElement(nextElement || null);
  });

  // ========================= Align ==========================
  var _useState3 = (0,react.useState)(null),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    posInfo = _useState4[0],
    setPosInfo = _useState4[1];
  var updatePos = (0,hooks_useEvent/* default */.Z)(function () {
    if (targetElement) {
      // Exist target element. We should scroll and get target position
      if (!isInViewPort(targetElement) && open) {
        targetElement.scrollIntoView(scrollIntoViewOptions);
      }
      var _targetElement$getBou = targetElement.getBoundingClientRect(),
        left = _targetElement$getBou.left,
        top = _targetElement$getBou.top,
        width = _targetElement$getBou.width,
        height = _targetElement$getBou.height;
      var nextPosInfo = {
        left: left,
        top: top,
        width: width,
        height: height,
        radius: 0
      };
      setPosInfo(function (origin) {
        if (JSON.stringify(origin) !== JSON.stringify(nextPosInfo)) {
          return nextPosInfo;
        }
        return origin;
      });
    } else {
      // Not exist target which means we just show in center
      setPosInfo(null);
    }
  });
  var getGapOffset = function getGapOffset(index) {
    var _ref;
    return (_ref = Array.isArray(gap === null || gap === void 0 ? void 0 : gap.offset) ? gap === null || gap === void 0 ? void 0 : gap.offset[index] : gap === null || gap === void 0 ? void 0 : gap.offset) !== null && _ref !== void 0 ? _ref : 6;
  };
  (0,hooks_useLayoutEffect/* default */.Z)(function () {
    updatePos();
    // update when window resize
    window.addEventListener('resize', updatePos);
    return function () {
      window.removeEventListener('resize', updatePos);
    };
  }, [targetElement, open, updatePos]);

  // ======================== PosInfo =========================
  var mergedPosInfo = (0,react.useMemo)(function () {
    if (!posInfo) {
      return posInfo;
    }
    var gapOffsetX = getGapOffset(0);
    var gapOffsetY = getGapOffset(1);
    var gapRadius = isValidNumber(gap === null || gap === void 0 ? void 0 : gap.radius) ? gap === null || gap === void 0 ? void 0 : gap.radius : 2;
    return {
      left: posInfo.left - gapOffsetX,
      top: posInfo.top - gapOffsetY,
      width: posInfo.width + gapOffsetX * 2,
      height: posInfo.height + gapOffsetY * 2,
      radius: gapRadius
    };
  }, [posInfo, gap]);
  return [mergedPosInfo, targetElement];
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/tour/es/Mask.js







var COVER_PROPS = {
  fill: 'transparent',
  pointerEvents: 'auto'
};
var Mask = function Mask(props) {
  var prefixCls = props.prefixCls,
    rootClassName = props.rootClassName,
    pos = props.pos,
    showMask = props.showMask,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    _props$fill = props.fill,
    fill = _props$fill === void 0 ? "rgba(0,0,0,0.5)" : _props$fill,
    open = props.open,
    animated = props.animated,
    zIndex = props.zIndex,
    disabledInteraction = props.disabledInteraction;
  var id = (0,hooks_useId/* default */.Z)();
  var maskId = "".concat(prefixCls, "-mask-").concat(id);
  var mergedAnimated = (0,esm_typeof/* default */.Z)(animated) === 'object' ? animated === null || animated === void 0 ? void 0 : animated.placeholder : animated;
  var isSafari = typeof navigator !== 'undefined' && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  var maskRectSize = isSafari ? {
    width: '100%',
    height: '100%'
  } : {
    width: '100vw',
    height: '100vh'
  };
  return /*#__PURE__*/react.createElement(portal_es/* default */.Z, {
    open: open,
    autoLock: true
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(prefixCls, "-mask"), rootClassName),
    style: (0,objectSpread2/* default */.Z)({
      position: 'fixed',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      zIndex: zIndex,
      pointerEvents: pos && !disabledInteraction ? 'none' : 'auto'
    }, style)
  }, showMask ? /*#__PURE__*/react.createElement("svg", {
    style: {
      width: '100%',
      height: '100%'
    }
  }, /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("mask", {
    id: maskId
  }, /*#__PURE__*/react.createElement("rect", (0,esm_extends/* default */.Z)({
    x: "0",
    y: "0"
  }, maskRectSize, {
    fill: "white"
  })), pos && /*#__PURE__*/react.createElement("rect", {
    x: pos.left,
    y: pos.top,
    rx: pos.radius,
    width: pos.width,
    height: pos.height,
    fill: "black",
    className: mergedAnimated ? "".concat(prefixCls, "-placeholder-animated") : ''
  }))), /*#__PURE__*/react.createElement("rect", {
    x: "0",
    y: "0",
    width: "100%",
    height: "100%",
    fill: fill,
    mask: "url(#".concat(maskId, ")")
  }), pos && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("rect", (0,esm_extends/* default */.Z)({}, COVER_PROPS, {
    x: "0",
    y: "0",
    width: "100%",
    height: pos.top
  })), /*#__PURE__*/react.createElement("rect", (0,esm_extends/* default */.Z)({}, COVER_PROPS, {
    x: "0",
    y: "0",
    width: pos.left,
    height: "100%"
  })), /*#__PURE__*/react.createElement("rect", (0,esm_extends/* default */.Z)({}, COVER_PROPS, {
    x: "0",
    y: pos.top + pos.height,
    width: "100%",
    height: "calc(100vh - ".concat(pos.top + pos.height, "px)")
  })), /*#__PURE__*/react.createElement("rect", (0,esm_extends/* default */.Z)({}, COVER_PROPS, {
    x: pos.left + pos.width,
    y: "0",
    width: "calc(100vw - ".concat(pos.left + pos.width, "px)"),
    height: "100%"
  })))) : null));
};
/* harmony default export */ var es_Mask = (Mask);
;// CONCATENATED MODULE: ./node_modules/@rc-component/tour/es/placements.js

var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, 0];
var basePlacements = {
  left: {
    points: ['cr', 'cl'],
    offset: [-8, 0]
  },
  right: {
    points: ['cl', 'cr'],
    offset: [8, 0]
  },
  top: {
    points: ['bc', 'tc'],
    offset: [0, -8]
  },
  bottom: {
    points: ['tc', 'bc'],
    offset: [0, 8]
  },
  topLeft: {
    points: ['bl', 'tl'],
    offset: [0, -8]
  },
  leftTop: {
    points: ['tr', 'tl'],
    offset: [-8, 0]
  },
  topRight: {
    points: ['br', 'tr'],
    offset: [0, -8]
  },
  rightTop: {
    points: ['tl', 'tr'],
    offset: [8, 0]
  },
  bottomRight: {
    points: ['tr', 'br'],
    offset: [0, 8]
  },
  rightBottom: {
    points: ['bl', 'br'],
    offset: [8, 0]
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    offset: [0, 8]
  },
  leftBottom: {
    points: ['br', 'bl'],
    offset: [-8, 0]
  }
};
function placements_getPlacements() {
  var arrowPointAtCenter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var placements = {};
  Object.keys(basePlacements).forEach(function (key) {
    placements[key] = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, basePlacements[key]), {}, {
      autoArrow: arrowPointAtCenter,
      targetOffset: targetOffset
    });
  });
  return placements;
}
var placements = placements_getPlacements();
;// CONCATENATED MODULE: ./node_modules/@rc-component/tour/es/TourStep/DefaultPanel.js





function DefaultPanel(props) {
  var _closable$closeIcon;
  var prefixCls = props.prefixCls,
    current = props.current,
    total = props.total,
    title = props.title,
    description = props.description,
    onClose = props.onClose,
    onPrev = props.onPrev,
    onNext = props.onNext,
    onFinish = props.onFinish,
    className = props.className,
    closable = props.closable;
  var ariaProps = (0,pickAttrs/* default */.Z)(closable || {}, true);
  var closeIcon = (_closable$closeIcon = closable === null || closable === void 0 ? void 0 : closable.closeIcon) !== null && _closable$closeIcon !== void 0 ? _closable$closeIcon : /*#__PURE__*/react.createElement("span", {
    className: "".concat(prefixCls, "-close-x")
  }, "\xD7");
  var mergedClosable = !!closable;
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(prefixCls, "-content"), className)
  }, /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-inner")
  }, mergedClosable && /*#__PURE__*/react.createElement("button", (0,esm_extends/* default */.Z)({
    type: "button",
    onClick: onClose,
    "aria-label": "Close"
  }, ariaProps, {
    className: "".concat(prefixCls, "-close")
  }), closeIcon), /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-header")
  }, /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-title")
  }, title)), /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-description")
  }, description), /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-footer")
  }, /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-sliders")
  }, total > 1 ? (0,toConsumableArray/* default */.Z)(Array.from({
    length: total
  }).keys()).map(function (item, index) {
    return /*#__PURE__*/react.createElement("span", {
      key: item,
      className: index === current ? 'active' : ''
    });
  }) : null), /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-buttons")
  }, current !== 0 ? /*#__PURE__*/react.createElement("button", {
    className: "".concat(prefixCls, "-prev-btn"),
    onClick: onPrev
  }, "Prev") : null, current === total - 1 ? /*#__PURE__*/react.createElement("button", {
    className: "".concat(prefixCls, "-finish-btn"),
    onClick: onFinish
  }, "Finish") : /*#__PURE__*/react.createElement("button", {
    className: "".concat(prefixCls, "-next-btn"),
    onClick: onNext
  }, "Next")))));
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/tour/es/TourStep/index.js


var TourStep = function TourStep(props) {
  var current = props.current,
    renderPanel = props.renderPanel;
  return /*#__PURE__*/react.createElement(react.Fragment, null, typeof renderPanel === 'function' ? renderPanel(props, current) : /*#__PURE__*/react.createElement(DefaultPanel, props));
};
/* harmony default export */ var es_TourStep = (TourStep);
;// CONCATENATED MODULE: ./node_modules/@rc-component/tour/es/Tour.js





var Tour_excluded = ["prefixCls", "steps", "defaultCurrent", "current", "onChange", "onClose", "onFinish", "open", "mask", "arrow", "rootClassName", "placement", "renderPanel", "gap", "animated", "scrollIntoViewOptions", "zIndex", "closeIcon", "closable", "builtinPlacements", "disabledInteraction"];













var CENTER_PLACEHOLDER = {
  left: '50%',
  top: '50%',
  width: 1,
  height: 1
};
var defaultScrollIntoViewOptions = {
  block: 'center',
  inline: 'center'
};
var Tour = function Tour(props) {
  var _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-tour' : _props$prefixCls,
    _props$steps = props.steps,
    steps = _props$steps === void 0 ? [] : _props$steps,
    defaultCurrent = props.defaultCurrent,
    current = props.current,
    onChange = props.onChange,
    onClose = props.onClose,
    _onFinish = props.onFinish,
    open = props.open,
    _props$mask = props.mask,
    mask = _props$mask === void 0 ? true : _props$mask,
    _props$arrow = props.arrow,
    arrow = _props$arrow === void 0 ? true : _props$arrow,
    rootClassName = props.rootClassName,
    placement = props.placement,
    renderPanel = props.renderPanel,
    gap = props.gap,
    animated = props.animated,
    _props$scrollIntoView = props.scrollIntoViewOptions,
    scrollIntoViewOptions = _props$scrollIntoView === void 0 ? defaultScrollIntoViewOptions : _props$scrollIntoView,
    _props$zIndex = props.zIndex,
    zIndex = _props$zIndex === void 0 ? 1001 : _props$zIndex,
    closeIcon = props.closeIcon,
    closable = props.closable,
    builtinPlacements = props.builtinPlacements,
    disabledInteraction = props.disabledInteraction,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, Tour_excluded);
  var triggerRef = react.useRef();
  var _useMergedState = (0,useMergedState/* default */.Z)(0, {
      value: current,
      defaultValue: defaultCurrent
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    mergedCurrent = _useMergedState2[0],
    setMergedCurrent = _useMergedState2[1];
  var _useMergedState3 = (0,useMergedState/* default */.Z)(undefined, {
      value: open,
      postState: function postState(origin) {
        return mergedCurrent < 0 || mergedCurrent >= steps.length ? false : origin !== null && origin !== void 0 ? origin : true;
      }
    }),
    _useMergedState4 = (0,slicedToArray/* default */.Z)(_useMergedState3, 2),
    mergedOpen = _useMergedState4[0],
    setMergedOpen = _useMergedState4[1];

  // Record if already rended in the DOM to avoid `findDOMNode` issue
  var _React$useState = react.useState(mergedOpen),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    hasOpened = _React$useState2[0],
    setHasOpened = _React$useState2[1];
  var openRef = react.useRef(mergedOpen);
  (0,hooks_useLayoutEffect/* default */.Z)(function () {
    if (mergedOpen) {
      if (!openRef.current) {
        setMergedCurrent(0);
      }
      setHasOpened(true);
    }
    openRef.current = mergedOpen;
  }, [mergedOpen]);
  var _ref = steps[mergedCurrent] || {},
    target = _ref.target,
    stepPlacement = _ref.placement,
    stepStyle = _ref.style,
    stepArrow = _ref.arrow,
    stepClassName = _ref.className,
    stepMask = _ref.mask,
    _ref$scrollIntoViewOp = _ref.scrollIntoViewOptions,
    stepScrollIntoViewOptions = _ref$scrollIntoViewOp === void 0 ? defaultScrollIntoViewOptions : _ref$scrollIntoViewOp,
    stepCloseIcon = _ref.closeIcon,
    stepClosable = _ref.closable;
  var mergedClosable = useClosable_useClosable(stepClosable, stepCloseIcon, closable, closeIcon);
  var mergedMask = mergedOpen && (stepMask !== null && stepMask !== void 0 ? stepMask : mask);
  var mergedScrollIntoViewOptions = stepScrollIntoViewOptions !== null && stepScrollIntoViewOptions !== void 0 ? stepScrollIntoViewOptions : scrollIntoViewOptions;
  var _useTarget = useTarget(target, open, gap, mergedScrollIntoViewOptions),
    _useTarget2 = (0,slicedToArray/* default */.Z)(_useTarget, 2),
    posInfo = _useTarget2[0],
    targetElement = _useTarget2[1];
  var mergedPlacement = getPlacement(targetElement, placement, stepPlacement);

  // ========================= arrow =========================
  var mergedArrow = targetElement ? typeof stepArrow === 'undefined' ? arrow : stepArrow : false;
  var arrowPointAtCenter = (0,esm_typeof/* default */.Z)(mergedArrow) === 'object' ? mergedArrow.pointAtCenter : false;
  (0,hooks_useLayoutEffect/* default */.Z)(function () {
    var _triggerRef$current;
    (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.forceAlign();
  }, [arrowPointAtCenter, mergedCurrent]);

  // ========================= Change =========================
  var onInternalChange = function onInternalChange(nextCurrent) {
    setMergedCurrent(nextCurrent);
    onChange === null || onChange === void 0 ? void 0 : onChange(nextCurrent);
  };
  var mergedBuiltinPlacements = (0,react.useMemo)(function () {
    if (builtinPlacements) {
      return typeof builtinPlacements === 'function' ? builtinPlacements({
        arrowPointAtCenter: arrowPointAtCenter
      }) : builtinPlacements;
    }
    return placements_getPlacements(arrowPointAtCenter);
  }, [builtinPlacements, arrowPointAtCenter]);

  // ========================= Render =========================
  // Skip if not init yet
  if (targetElement === undefined || !hasOpened) {
    return null;
  }
  var handleClose = function handleClose() {
    setMergedOpen(false);
    onClose === null || onClose === void 0 ? void 0 : onClose(mergedCurrent);
  };
  var getPopupElement = function getPopupElement() {
    return /*#__PURE__*/react.createElement(es_TourStep, (0,esm_extends/* default */.Z)({
      arrow: mergedArrow,
      key: "content",
      prefixCls: prefixCls,
      total: steps.length,
      renderPanel: renderPanel,
      onPrev: function onPrev() {
        onInternalChange(mergedCurrent - 1);
      },
      onNext: function onNext() {
        onInternalChange(mergedCurrent + 1);
      },
      onClose: handleClose,
      current: mergedCurrent,
      onFinish: function onFinish() {
        handleClose();
        _onFinish === null || _onFinish === void 0 ? void 0 : _onFinish();
      }
    }, steps[mergedCurrent], {
      closable: mergedClosable
    }));
  };
  var mergedShowMask = typeof mergedMask === 'boolean' ? mergedMask : !!mergedMask;
  var mergedMaskStyle = typeof mergedMask === 'boolean' ? undefined : mergedMask;

  // when targetElement is not exist, use body as triggerDOMNode
  var getTriggerDOMNode = function getTriggerDOMNode(node) {
    return node || targetElement || document.body;
  };
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(es_Mask, {
    zIndex: zIndex,
    prefixCls: prefixCls,
    pos: posInfo,
    showMask: mergedShowMask,
    style: mergedMaskStyle === null || mergedMaskStyle === void 0 ? void 0 : mergedMaskStyle.style,
    fill: mergedMaskStyle === null || mergedMaskStyle === void 0 ? void 0 : mergedMaskStyle.color,
    open: mergedOpen,
    animated: animated,
    rootClassName: rootClassName,
    disabledInteraction: disabledInteraction
  }), /*#__PURE__*/react.createElement(trigger_es/* default */.Z, (0,esm_extends/* default */.Z)({}, restProps, {
    builtinPlacements: mergedBuiltinPlacements,
    ref: triggerRef,
    popupStyle: stepStyle,
    popupPlacement: mergedPlacement,
    popupVisible: mergedOpen,
    popupClassName: classnames_default()(rootClassName, stepClassName),
    prefixCls: prefixCls,
    popup: getPopupElement,
    forceRender: false,
    destroyPopupOnHide: true,
    zIndex: zIndex,
    getTriggerDOMNode: getTriggerDOMNode,
    arrow: !!mergedArrow
  }), /*#__PURE__*/react.createElement(portal_es/* default */.Z, {
    open: mergedOpen,
    autoLock: true
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(rootClassName, "".concat(prefixCls, "-target-placeholder")),
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, posInfo || CENTER_PLACEHOLDER), {}, {
      position: 'fixed',
      pointerEvents: 'none'
    })
  }))));
};
/* harmony default export */ var es_Tour = (Tour);
;// CONCATENATED MODULE: ./node_modules/@rc-component/tour/es/index.js

/* harmony default export */ var tour_es = (es_Tour);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tour/panelRender.js
"use client";









function isValidNode(node) {
  return node !== undefined && node !== null;
}
// Due to the independent design of Panel, it will be too coupled to put in rc-tour,
// so a set of Panel logic is implemented separately in antd.
const TourPanel = props => {
  var _a, _b;
  const {
    stepProps,
    current,
    type,
    indicatorsRender,
    actionsRender
  } = props;
  const {
    prefixCls,
    total = 1,
    title,
    onClose,
    onPrev,
    onNext,
    onFinish,
    cover,
    description,
    nextButtonProps,
    prevButtonProps,
    type: stepType,
    closable
  } = stepProps;
  const mergedType = stepType !== null && stepType !== void 0 ? stepType : type;
  const ariaProps = (0,pickAttrs/* default */.Z)(closable !== null && closable !== void 0 ? closable : {}, true);
  const [contextLocaleGlobal] = locale_useLocale('global', es_locale_en_US.global);
  const [contextLocaleTour] = locale_useLocale('Tour', es_locale_en_US.Tour);
  const mergedCloseIcon = /*#__PURE__*/react.createElement("button", Object.assign({
    type: "button",
    onClick: onClose,
    className: `${prefixCls}-close`,
    "aria-label": contextLocaleGlobal === null || contextLocaleGlobal === void 0 ? void 0 : contextLocaleGlobal.close
  }, ariaProps), (closable === null || closable === void 0 ? void 0 : closable.closeIcon) || /*#__PURE__*/react.createElement(CloseOutlined/* default */.Z, {
    className: `${prefixCls}-close-icon`
  }));
  const isLastStep = current === total - 1;
  const prevBtnClick = () => {
    var _a;
    onPrev === null || onPrev === void 0 ? void 0 : onPrev();
    (_a = prevButtonProps === null || prevButtonProps === void 0 ? void 0 : prevButtonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(prevButtonProps);
  };
  const nextBtnClick = () => {
    var _a;
    if (isLastStep) {
      onFinish === null || onFinish === void 0 ? void 0 : onFinish();
    } else {
      onNext === null || onNext === void 0 ? void 0 : onNext();
    }
    (_a = nextButtonProps === null || nextButtonProps === void 0 ? void 0 : nextButtonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(nextButtonProps);
  };
  const headerNode = isValidNode(title) ? (/*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-header`
  }, /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-title`
  }, title))) : null;
  const descriptionNode = isValidNode(description) ? (/*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-description`
  }, description)) : null;
  const coverNode = isValidNode(cover) ? /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-cover`
  }, cover) : null;
  let mergedIndicatorNode;
  if (indicatorsRender) {
    mergedIndicatorNode = indicatorsRender(current, total);
  } else {
    mergedIndicatorNode = (0,toConsumableArray/* default */.Z)(Array.from({
      length: total
    }).keys()).map((stepItem, index) => (/*#__PURE__*/react.createElement("span", {
      key: stepItem,
      className: classnames_default()(index === current && `${prefixCls}-indicator-active`, `${prefixCls}-indicator`)
    })));
  }
  const mainBtnType = mergedType === 'primary' ? 'default' : 'primary';
  const secondaryBtnProps = {
    type: 'default',
    ghost: mergedType === 'primary'
  };
  const defaultActionsNode = /*#__PURE__*/react.createElement(react.Fragment, null, current !== 0 ? (/*#__PURE__*/react.createElement(es_button, Object.assign({
    size: "small"
  }, secondaryBtnProps, prevButtonProps, {
    onClick: prevBtnClick,
    className: classnames_default()(`${prefixCls}-prev-btn`, prevButtonProps === null || prevButtonProps === void 0 ? void 0 : prevButtonProps.className)
  }), (_a = prevButtonProps === null || prevButtonProps === void 0 ? void 0 : prevButtonProps.children) !== null && _a !== void 0 ? _a : contextLocaleTour === null || contextLocaleTour === void 0 ? void 0 : contextLocaleTour.Previous)) : null, /*#__PURE__*/react.createElement(es_button, Object.assign({
    size: "small",
    type: mainBtnType
  }, nextButtonProps, {
    onClick: nextBtnClick,
    className: classnames_default()(`${prefixCls}-next-btn`, nextButtonProps === null || nextButtonProps === void 0 ? void 0 : nextButtonProps.className)
  }), (_b = nextButtonProps === null || nextButtonProps === void 0 ? void 0 : nextButtonProps.children) !== null && _b !== void 0 ? _b : isLastStep ? contextLocaleTour === null || contextLocaleTour === void 0 ? void 0 : contextLocaleTour.Finish : contextLocaleTour === null || contextLocaleTour === void 0 ? void 0 : contextLocaleTour.Next));
  return /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-content`
  }, /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-inner`
  }, closable && mergedCloseIcon, coverNode, headerNode, descriptionNode, /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-footer`
  }, total > 1 && /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-indicators`
  }, mergedIndicatorNode), /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-buttons`
  }, actionsRender ? actionsRender(defaultActionsNode, {
    current,
    total
  }) : defaultActionsNode))));
};
/* harmony default export */ var panelRender = (TourPanel);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tour/style/index.js






// =============================== Base ===============================
const tour_style_genBaseStyle = token => {
  const {
    componentCls,
    padding,
    paddingXS,
    borderRadius,
    borderRadiusXS,
    colorPrimary,
    colorFill,
    indicatorHeight,
    indicatorWidth,
    boxShadowTertiary,
    zIndexPopup,
    colorBgElevated,
    fontWeightStrong,
    marginXS,
    colorTextLightSolid,
    tourBorderRadius,
    colorWhite,
    primaryNextBtnHoverBg,
    closeBtnSize,
    motionDurationSlow,
    antCls,
    primaryPrevBtnBg
  } = token;
  return [{
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      position: 'absolute',
      zIndex: zIndexPopup,
      maxWidth: 'fit-content',
      visibility: 'visible',
      width: 520,
      '--antd-arrow-background-color': colorBgElevated,
      '&-pure': {
        maxWidth: '100%',
        position: 'relative'
      },
      [`&${componentCls}-hidden`]: {
        display: 'none'
      },
      // ============================= panel content ============================
      [`${componentCls}-content`]: {
        position: 'relative'
      },
      [`${componentCls}-inner`]: {
        textAlign: 'start',
        textDecoration: 'none',
        borderRadius: tourBorderRadius,
        boxShadow: boxShadowTertiary,
        position: 'relative',
        backgroundColor: colorBgElevated,
        border: 'none',
        backgroundClip: 'padding-box',
        [`${componentCls}-close`]: Object.assign({
          position: 'absolute',
          top: padding,
          insetInlineEnd: padding,
          color: token.colorIcon,
          background: 'none',
          border: 'none',
          width: closeBtnSize,
          height: closeBtnSize,
          borderRadius: token.borderRadiusSM,
          transition: `background-color ${token.motionDurationMid}, color ${token.motionDurationMid}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          '&:hover': {
            color: token.colorIconHover,
            backgroundColor: token.colorBgTextHover
          },
          '&:active': {
            backgroundColor: token.colorBgTextActive
          }
        }, genFocusStyle(token)),
        [`${componentCls}-cover`]: {
          textAlign: 'center',
          padding: `${(0,cssinjs_es/* unit */.bf)(token.calc(padding).add(closeBtnSize).add(paddingXS).equal())} ${(0,cssinjs_es/* unit */.bf)(padding)} 0`,
          img: {
            width: '100%'
          }
        },
        [`${componentCls}-header`]: {
          padding: `${(0,cssinjs_es/* unit */.bf)(padding)} ${(0,cssinjs_es/* unit */.bf)(padding)} ${(0,cssinjs_es/* unit */.bf)(paddingXS)}`,
          width: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(closeBtnSize)})`,
          wordBreak: 'break-word',
          [`${componentCls}-title`]: {
            fontWeight: fontWeightStrong
          }
        },
        [`${componentCls}-description`]: {
          padding: `0 ${(0,cssinjs_es/* unit */.bf)(padding)}`,
          wordWrap: 'break-word'
        },
        [`${componentCls}-footer`]: {
          padding: `${(0,cssinjs_es/* unit */.bf)(paddingXS)} ${(0,cssinjs_es/* unit */.bf)(padding)} ${(0,cssinjs_es/* unit */.bf)(padding)}`,
          textAlign: 'end',
          borderRadius: `0 0 ${(0,cssinjs_es/* unit */.bf)(borderRadiusXS)} ${(0,cssinjs_es/* unit */.bf)(borderRadiusXS)}`,
          display: 'flex',
          [`${componentCls}-indicators`]: {
            display: 'inline-block',
            [`${componentCls}-indicator`]: {
              width: indicatorWidth,
              height: indicatorHeight,
              display: 'inline-block',
              borderRadius: '50%',
              background: colorFill,
              '&:not(:last-child)': {
                marginInlineEnd: indicatorHeight
              },
              '&-active': {
                background: colorPrimary
              }
            }
          },
          [`${componentCls}-buttons`]: {
            marginInlineStart: 'auto',
            [`${antCls}-btn`]: {
              marginInlineStart: marginXS
            }
          }
        }
      },
      // =============================  primary type  ===========================
      // `$` for panel, `&$` for pure panel
      [`${componentCls}-primary, &${componentCls}-primary`]: {
        '--antd-arrow-background-color': colorPrimary,
        [`${componentCls}-inner`]: {
          color: colorTextLightSolid,
          textAlign: 'start',
          textDecoration: 'none',
          backgroundColor: colorPrimary,
          borderRadius,
          boxShadow: boxShadowTertiary,
          [`${componentCls}-close`]: {
            color: colorTextLightSolid
          },
          [`${componentCls}-indicators`]: {
            [`${componentCls}-indicator`]: {
              background: primaryPrevBtnBg,
              '&-active': {
                background: colorTextLightSolid
              }
            }
          },
          [`${componentCls}-prev-btn`]: {
            color: colorTextLightSolid,
            borderColor: primaryPrevBtnBg,
            backgroundColor: colorPrimary,
            '&:hover': {
              backgroundColor: primaryPrevBtnBg,
              borderColor: 'transparent'
            }
          },
          [`${componentCls}-next-btn`]: {
            color: colorPrimary,
            borderColor: 'transparent',
            background: colorWhite,
            '&:hover': {
              background: primaryNextBtnHoverBg
            }
          }
        }
      }
    }),
    // ============================= mask ===========================
    [`${componentCls}-mask`]: {
      [`${componentCls}-placeholder-animated`]: {
        transition: `all ${motionDurationSlow}`
      }
    },
    // =========== Limit left and right placement radius ==============
    [['&-placement-left', '&-placement-leftTop', '&-placement-leftBottom', '&-placement-right', '&-placement-rightTop', '&-placement-rightBottom'].join(',')]: {
      [`${componentCls}-inner`]: {
        borderRadius: token.min(tourBorderRadius, MAX_VERTICAL_CONTENT_RADIUS)
      }
    }
  },
  // ============================= Arrow ===========================
  getArrowStyle(token, 'var(--antd-arrow-background-color)')];
};
// ============================== Export ==============================
const tour_style_prepareComponentToken = token => Object.assign(Object.assign({
  zIndexPopup: token.zIndexPopupBase + 70,
  closeBtnSize: token.fontSize * token.lineHeight,
  primaryPrevBtnBg: new fast_color_es/* FastColor */.t(token.colorTextLightSolid).setA(0.15).toRgbString(),
  primaryNextBtnHoverBg: new fast_color_es/* FastColor */.t(token.colorBgTextHover).onBackground(token.colorWhite).toRgbString()
}, getArrowOffsetToken({
  contentRadius: token.borderRadiusLG,
  limitVerticalRadius: true
})), getArrowToken(token));
/* harmony default export */ var tour_style = (genStyleHooks('Tour', token => {
  const {
    borderRadiusLG
  } = token;
  const TourToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    indicatorWidth: 6,
    indicatorHeight: 6,
    tourBorderRadius: borderRadiusLG
  });
  return tour_style_genBaseStyle(TourToken);
}, tour_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tour/PurePanel.js
"use client";

var tour_PurePanel_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};









const tour_PurePanel_PurePanel = props => {
  const {
      prefixCls: customizePrefixCls,
      current = 0,
      total = 6,
      className,
      style,
      type,
      closable,
      closeIcon
    } = props,
    restProps = tour_PurePanel_rest(props, ["prefixCls", "current", "total", "className", "style", "type", "closable", "closeIcon"]);
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('tour', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = tour_style(prefixCls);
  const [mergedClosable, mergedCloseIcon] = useClosable({
    closable,
    closeIcon
  }, null, {
    closable: true,
    closeIconRender: icon => {
      var _a;
      return /*#__PURE__*/react.isValidElement(icon) ? cloneElement(icon, {
        className: classnames_default()((_a = icon.props) === null || _a === void 0 ? void 0 : _a.className, `${prefixCls}-close-icon`)
      }) : icon;
    }
  });
  return wrapCSSVar(/*#__PURE__*/react.createElement(RawPurePanel, {
    prefixCls: prefixCls,
    hashId: hashId,
    className: classnames_default()(className, `${prefixCls}-pure`, type && `${prefixCls}-${type}`, cssVarCls),
    style: style
  }, /*#__PURE__*/react.createElement(panelRender, {
    stepProps: Object.assign(Object.assign({}, restProps), {
      prefixCls,
      total,
      closable: mergedClosable ? {
        closeIcon: mergedCloseIcon
      } : undefined
    }),
    current: current,
    type: type
  })));
};
/* harmony default export */ var tour_PurePanel = (withPureRenderTheme(tour_PurePanel_PurePanel));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tour/index.js
"use client";

var tour_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};











const tour_Tour = props => {
  const {
      prefixCls: customizePrefixCls,
      type,
      rootClassName,
      indicatorsRender,
      actionsRender,
      steps,
      closeIcon
    } = props,
    restProps = tour_rest(props, ["prefixCls", "type", "rootClassName", "indicatorsRender", "actionsRender", "steps", "closeIcon"]);
  const {
    getPrefixCls,
    direction,
    tour
  } = (0,react.useContext)(ConfigContext);
  const prefixCls = getPrefixCls('tour', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = tour_style(prefixCls);
  const [, token] = useToken();
  const mergedSteps = react.useMemo(() => steps === null || steps === void 0 ? void 0 : steps.map(step => {
    var _a;
    return Object.assign(Object.assign({}, step), {
      className: classnames_default()(step.className, {
        [`${prefixCls}-primary`]: ((_a = step.type) !== null && _a !== void 0 ? _a : type) === 'primary'
      })
    });
  }), [steps, type]);
  const builtinPlacements = config => {
    var _a;
    return getPlacements({
      arrowPointAtCenter: (_a = config === null || config === void 0 ? void 0 : config.arrowPointAtCenter) !== null && _a !== void 0 ? _a : true,
      autoAdjustOverflow: true,
      offset: token.marginXXS,
      arrowWidth: token.sizePopupArrow,
      borderRadius: token.borderRadius
    });
  };
  const customClassName = classnames_default()({
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, hashId, cssVarCls, rootClassName);
  const mergedRenderPanel = (stepProps, stepCurrent) => (/*#__PURE__*/react.createElement(panelRender, {
    type: type,
    stepProps: stepProps,
    current: stepCurrent,
    indicatorsRender: indicatorsRender,
    actionsRender: actionsRender
  }));
  // ============================ zIndex ============================
  const [zIndex, contextZIndex] = useZIndex('Tour', restProps.zIndex);
  return wrapCSSVar(/*#__PURE__*/react.createElement(zindexContext.Provider, {
    value: contextZIndex
  }, /*#__PURE__*/react.createElement(tour_es, Object.assign({}, restProps, {
    closeIcon: closeIcon !== null && closeIcon !== void 0 ? closeIcon : tour === null || tour === void 0 ? void 0 : tour.closeIcon,
    zIndex: zIndex,
    rootClassName: customClassName,
    prefixCls: prefixCls,
    animated: true,
    renderPanel: mergedRenderPanel,
    builtinPlacements: builtinPlacements,
    steps: mergedSteps
  }))));
};
if (false) {}
tour_Tour._InternalPanelDoNotUseOrYouWillBeFired = tour_PurePanel;
/* harmony default export */ var tour = (tour_Tour);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/_util/transKeys.js
const groupKeysMap = keys => {
  const map = new Map();
  keys.forEach((key, index) => {
    map.set(key, index);
  });
  return map;
};
const groupDisabledKeysMap = dataSource => {
  const map = new Map();
  dataSource.forEach(({
    disabled,
    key
  }, index) => {
    if (disabled) {
      map.set(key, index);
    }
  });
  return map;
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/transfer/hooks/useData.js


const useData = (dataSource, rowKey, targetKeys) => {
  const mergedDataSource = react.useMemo(() => (dataSource || []).map(record => {
    if (rowKey) {
      return Object.assign(Object.assign({}, record), {
        key: rowKey(record)
      });
    }
    return record;
  }), [dataSource, rowKey]);
  const [leftDataSource, rightDataSource] = react.useMemo(() => {
    var _a;
    const leftData = [];
    const rightData = Array.from({
      length: (_a = targetKeys === null || targetKeys === void 0 ? void 0 : targetKeys.length) !== null && _a !== void 0 ? _a : 0
    });
    const targetKeysMap = groupKeysMap(targetKeys || []);
    mergedDataSource.forEach(record => {
      // rightData should be ordered by targetKeys
      // leftData should be ordered by dataSource
      if (targetKeysMap.has(record.key)) {
        const idx = targetKeysMap.get(record.key);
        rightData[idx] = record;
      } else {
        leftData.push(record);
      }
    });
    return [leftData, rightData];
  }, [mergedDataSource, targetKeys]);
  return [mergedDataSource, leftDataSource.filter(Boolean), rightDataSource.filter(Boolean)];
};
/* harmony default export */ var hooks_useData = (useData);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/transfer/hooks/useSelection.js



const EMPTY_KEYS = [];
function filterKeys(keys, dataKeys) {
  const filteredKeys = keys.filter(key => dataKeys.has(key));
  return keys.length === filteredKeys.length ? keys : filteredKeys;
}
function useSelection_flattenKeys(keys) {
  return Array.from(keys).join(';');
}
function useSelection_useSelection(leftDataSource, rightDataSource, selectedKeys) {
  // Prepare `dataSource` keys
  const [leftKeys, rightKeys] = react.useMemo(() => [new Set(leftDataSource.map(src => src === null || src === void 0 ? void 0 : src.key)), new Set(rightDataSource.map(src => src === null || src === void 0 ? void 0 : src.key))], [leftDataSource, rightDataSource]);
  // Selected Keys
  const [mergedSelectedKeys, setMergedSelectedKeys] = (0,rc_util_es/* useMergedState */.C8)(EMPTY_KEYS, {
    value: selectedKeys
  });
  const sourceSelectedKeys = react.useMemo(() => filterKeys(mergedSelectedKeys, leftKeys), [mergedSelectedKeys, leftKeys]);
  const targetSelectedKeys = react.useMemo(() => filterKeys(mergedSelectedKeys, rightKeys), [mergedSelectedKeys, rightKeys]);
  // // Reset when data changed
  react.useEffect(() => {
    setMergedSelectedKeys([].concat((0,toConsumableArray/* default */.Z)(filterKeys(mergedSelectedKeys, leftKeys)), (0,toConsumableArray/* default */.Z)(filterKeys(mergedSelectedKeys, rightKeys))));
  }, [useSelection_flattenKeys(leftKeys), useSelection_flattenKeys(rightKeys)]);
  // Update keys
  const setSourceSelectedKeys = (0,rc_util_es/* useEvent */.zX)(nextSrcKeys => {
    setMergedSelectedKeys([].concat((0,toConsumableArray/* default */.Z)(nextSrcKeys), (0,toConsumableArray/* default */.Z)(targetSelectedKeys)));
  });
  const setTargetSelectedKeys = (0,rc_util_es/* useEvent */.zX)(nextTargetKeys => {
    setMergedSelectedKeys([].concat((0,toConsumableArray/* default */.Z)(sourceSelectedKeys), (0,toConsumableArray/* default */.Z)(nextTargetKeys)));
  });
  return [
  // Keys
  sourceSelectedKeys, targetSelectedKeys,
  // Updater
  setSourceSelectedKeys, setTargetSelectedKeys];
}
/* harmony default export */ var transfer_hooks_useSelection = (useSelection_useSelection);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/DeleteOutlined.js + 1 modules
var DeleteOutlined = __webpack_require__(4183);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/transfer/ListItem.js
"use client";







const ListItem = props => {
  const {
    renderedText,
    renderedEl,
    item,
    checked,
    disabled,
    prefixCls,
    onClick,
    onRemove,
    showRemove
  } = props;
  const className = classnames_default()(`${prefixCls}-content-item`, {
    [`${prefixCls}-content-item-disabled`]: disabled || item.disabled,
    [`${prefixCls}-content-item-checked`]: checked && !item.disabled
  });
  let title;
  if (typeof renderedText === 'string' || typeof renderedText === 'number') {
    title = String(renderedText);
  }
  const [contextLocale] = locale_useLocale('Transfer', es_locale_en_US.Transfer);
  const liProps = {
    className,
    title
  };
  const labelNode = /*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-content-item-text`
  }, renderedEl);
  if (showRemove) {
    return /*#__PURE__*/react.createElement("li", Object.assign({}, liProps), labelNode, /*#__PURE__*/react.createElement("button", {
      type: "button",
      disabled: disabled || item.disabled,
      className: `${prefixCls}-content-item-remove`,
      "aria-label": contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.remove,
      onClick: () => onRemove === null || onRemove === void 0 ? void 0 : onRemove(item)
    }, /*#__PURE__*/react.createElement(DeleteOutlined/* default */.Z, null)));
  }
  // Default click to select
  liProps.onClick = disabled || item.disabled ? undefined : event => onClick(item, event);
  return /*#__PURE__*/react.createElement("li", Object.assign({}, liProps), /*#__PURE__*/react.createElement(es_checkbox, {
    className: `${prefixCls}-checkbox`,
    checked: checked,
    disabled: disabled || item.disabled
  }), labelNode);
};
/* harmony default export */ var transfer_ListItem = (/*#__PURE__*/react.memo(ListItem));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/transfer/ListBody.js
"use client";






const OmitProps = ['handleFilter', 'handleClear', 'checkedKeys'];
const parsePagination = pagination => {
  const defaultPagination = {
    simple: true,
    showSizeChanger: false,
    showLessItems: false
  };
  return Object.assign(Object.assign({}, defaultPagination), pagination);
};
const TransferListBody = (props, ref) => {
  const {
    prefixCls,
    filteredRenderItems,
    selectedKeys,
    disabled: globalDisabled,
    showRemove,
    pagination,
    onScroll,
    onItemSelect,
    onItemRemove
  } = props;
  const [current, setCurrent] = react.useState(1);
  const mergedPagination = react.useMemo(() => {
    if (!pagination) {
      return null;
    }
    const convertPagination = typeof pagination === 'object' ? pagination : {};
    return parsePagination(convertPagination);
  }, [pagination]);
  const [pageSize, setPageSize] = (0,useMergedState/* default */.Z)(10, {
    value: mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.pageSize
  });
  react.useEffect(() => {
    if (mergedPagination) {
      const maxPageCount = Math.ceil(filteredRenderItems.length / pageSize);
      setCurrent(Math.min(current, maxPageCount));
    }
  }, [filteredRenderItems, mergedPagination, pageSize]);
  const onInternalClick = (item, e) => {
    onItemSelect(item.key, !selectedKeys.includes(item.key), e);
  };
  const onRemove = item => {
    onItemRemove === null || onItemRemove === void 0 ? void 0 : onItemRemove([item.key]);
  };
  const onPageChange = cur => {
    setCurrent(cur);
  };
  const onSizeChange = (cur, size) => {
    setCurrent(cur);
    setPageSize(size);
  };
  const memoizedItems = react.useMemo(() => {
    const displayItems = mergedPagination ? filteredRenderItems.slice((current - 1) * pageSize, current * pageSize) : filteredRenderItems;
    return displayItems;
  }, [current, filteredRenderItems, mergedPagination, pageSize]);
  react.useImperativeHandle(ref, () => ({
    items: memoizedItems
  }));
  const paginationNode = mergedPagination ? (/*#__PURE__*/react.createElement(es_pagination, {
    size: "small",
    disabled: globalDisabled,
    simple: mergedPagination.simple,
    pageSize: pageSize,
    showLessItems: mergedPagination.showLessItems,
    showSizeChanger: mergedPagination.showSizeChanger,
    className: `${prefixCls}-pagination`,
    total: filteredRenderItems.length,
    current: current,
    onChange: onPageChange,
    onShowSizeChange: onSizeChange
  })) : null;
  const cls = classnames_default()(`${prefixCls}-content`, {
    [`${prefixCls}-content-show-remove`]: showRemove
  });
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("ul", {
    className: cls,
    onScroll: onScroll
  }, (memoizedItems || []).map(({
    renderedEl,
    renderedText,
    item
  }) => (/*#__PURE__*/react.createElement(transfer_ListItem, {
    key: item.key,
    item: item,
    renderedText: renderedText,
    renderedEl: renderedEl,
    prefixCls: prefixCls,
    showRemove: showRemove,
    onClick: onInternalClick,
    onRemove: onRemove,
    checked: selectedKeys.includes(item.key),
    disabled: globalDisabled || item.disabled
  })))), paginationNode);
};
if (false) {}
/* harmony default export */ var ListBody = (/*#__PURE__*/react.forwardRef(TransferListBody));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/transfer/search.js
"use client";




const search_Search = props => {
  const {
    placeholder = '',
    value,
    prefixCls,
    disabled,
    onChange,
    handleClear
  } = props;
  const handleChange = react.useCallback(e => {
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
    if (e.target.value === '') {
      handleClear === null || handleClear === void 0 ? void 0 : handleClear();
    }
  }, [onChange]);
  return /*#__PURE__*/react.createElement(input_Input, {
    placeholder: placeholder,
    className: prefixCls,
    value: value,
    onChange: handleChange,
    disabled: disabled,
    allowClear: true,
    prefix: /*#__PURE__*/react.createElement(SearchOutlined/* default */.Z, null)
  });
};
if (false) {}
/* harmony default export */ var transfer_search = (search_Search);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/transfer/list.js
"use client";










const list_defaultRender = () => null;
function isRenderResultPlainObject(result) {
  return !!(result && ! /*#__PURE__*/react.isValidElement(result) && Object.prototype.toString.call(result) === '[object Object]');
}
function getEnabledItemKeys(items) {
  return items.filter(data => !data.disabled).map(data => data.key);
}
const isValidIcon = icon => icon !== undefined;
const getShowSearchOption = showSearch => {
  if (showSearch && typeof showSearch === 'object') {
    return Object.assign(Object.assign({}, showSearch), {
      defaultValue: showSearch.defaultValue || ''
    });
  }
  return {
    defaultValue: '',
    placeholder: ''
  };
};
const TransferList = props => {
  const {
    prefixCls,
    dataSource = [],
    titleText = '',
    checkedKeys,
    disabled,
    showSearch = false,
    style,
    searchPlaceholder,
    notFoundContent,
    selectAll,
    deselectAll,
    selectCurrent,
    selectInvert,
    removeAll,
    removeCurrent,
    showSelectAll = true,
    showRemove,
    pagination,
    direction,
    itemsUnit,
    itemUnit,
    selectAllLabel,
    selectionsIcon,
    footer,
    renderList,
    onItemSelectAll,
    onItemRemove,
    handleFilter,
    handleClear,
    filterOption,
    render = list_defaultRender
  } = props;
  const searchOptions = getShowSearchOption(showSearch);
  const [filterValue, setFilterValue] = (0,react.useState)(searchOptions.defaultValue);
  const listBodyRef = (0,react.useRef)({});
  const internalHandleFilter = e => {
    setFilterValue(e.target.value);
    handleFilter(e);
  };
  const internalHandleClear = () => {
    setFilterValue('');
    handleClear();
  };
  const matchFilter = (text, item) => {
    if (filterOption) {
      return filterOption(filterValue, item, direction);
    }
    return text.includes(filterValue);
  };
  const renderListBody = listProps => {
    let bodyContent = renderList ? renderList(Object.assign(Object.assign({}, listProps), {
      onItemSelect: (key, check) => listProps.onItemSelect(key, check)
    })) : null;
    const customize = !!bodyContent;
    if (!customize) {
      // @ts-ignore
      bodyContent = /*#__PURE__*/react.createElement(ListBody, Object.assign({
        ref: listBodyRef
      }, listProps));
    }
    return {
      customize,
      bodyContent
    };
  };
  const renderItem = item => {
    const renderResult = render(item);
    const isRenderResultPlain = isRenderResultPlainObject(renderResult);
    return {
      item,
      renderedEl: isRenderResultPlain ? renderResult.label : renderResult,
      renderedText: isRenderResultPlain ? renderResult.value : renderResult
    };
  };
  const notFoundContentEle = (0,react.useMemo)(() => Array.isArray(notFoundContent) ? notFoundContent[direction === 'left' ? 0 : 1] : notFoundContent, [notFoundContent, direction]);
  const [filteredItems, filteredRenderItems] = (0,react.useMemo)(() => {
    const filterItems = [];
    const filterRenderItems = [];
    dataSource.forEach(item => {
      const renderedItem = renderItem(item);
      if (filterValue && !matchFilter(renderedItem.renderedText, item)) {
        return;
      }
      filterItems.push(item);
      filterRenderItems.push(renderedItem);
    });
    return [filterItems, filterRenderItems];
  }, [dataSource, filterValue]);
  const checkedActiveItems = (0,react.useMemo)(() => {
    return filteredItems.filter(item => checkedKeys.includes(item.key) && !item.disabled);
  }, [checkedKeys, filteredItems]);
  const checkStatus = (0,react.useMemo)(() => {
    if (checkedActiveItems.length === 0) {
      return 'none';
    }
    const checkedKeysMap = groupKeysMap(checkedKeys);
    if (filteredItems.every(item => checkedKeysMap.has(item.key) || !!item.disabled)) {
      return 'all';
    }
    return 'part';
  }, [checkedKeys, checkedActiveItems]);
  const listBody = (0,react.useMemo)(() => {
    const search = showSearch ? (/*#__PURE__*/react.createElement("div", {
      className: `${prefixCls}-body-search-wrapper`
    }, /*#__PURE__*/react.createElement(transfer_search, {
      prefixCls: `${prefixCls}-search`,
      onChange: internalHandleFilter,
      handleClear: internalHandleClear,
      placeholder: searchOptions.placeholder || searchPlaceholder,
      value: filterValue,
      disabled: disabled
    }))) : null;
    const {
      customize,
      bodyContent
    } = renderListBody(Object.assign(Object.assign({}, (0,omit/* default */.Z)(props, OmitProps)), {
      filteredItems,
      filteredRenderItems,
      selectedKeys: checkedKeys
    }));
    let bodyNode;
    // We should wrap customize list body in a classNamed div to use flex layout.
    if (customize) {
      bodyNode = /*#__PURE__*/react.createElement("div", {
        className: `${prefixCls}-body-customize-wrapper`
      }, bodyContent);
    } else {
      bodyNode = filteredItems.length ? bodyContent : (/*#__PURE__*/react.createElement("div", {
        className: `${prefixCls}-body-not-found`
      }, notFoundContentEle));
    }
    return /*#__PURE__*/react.createElement("div", {
      className: classnames_default()(`${prefixCls}-body`, {
        [`${prefixCls}-body-with-search`]: showSearch
      })
    }, search, bodyNode);
  }, [showSearch, prefixCls, searchPlaceholder, filterValue, disabled, checkedKeys, filteredItems, filteredRenderItems, notFoundContentEle]);
  const checkBox = /*#__PURE__*/react.createElement(es_checkbox, {
    disabled: dataSource.filter(d => !d.disabled).length === 0 || disabled,
    checked: checkStatus === 'all',
    indeterminate: checkStatus === 'part',
    className: `${prefixCls}-checkbox`,
    onChange: () => {
      // Only select enabled items
      onItemSelectAll === null || onItemSelectAll === void 0 ? void 0 : onItemSelectAll(filteredItems.filter(item => !item.disabled).map(({
        key
      }) => key), checkStatus !== 'all');
    }
  });
  const getSelectAllLabel = (selectedCount, totalCount) => {
    if (selectAllLabel) {
      return typeof selectAllLabel === 'function' ? selectAllLabel({
        selectedCount,
        totalCount
      }) : selectAllLabel;
    }
    const unit = totalCount > 1 ? itemsUnit : itemUnit;
    return /*#__PURE__*/react.createElement(react.Fragment, null, (selectedCount > 0 ? `${selectedCount}/` : '') + totalCount, " ", unit);
  };
  // Custom Layout
  const footerDom = footer && (footer.length < 2 ? footer(props) : footer(props, {
    direction
  }));
  const listCls = classnames_default()(prefixCls, {
    [`${prefixCls}-with-pagination`]: !!pagination,
    [`${prefixCls}-with-footer`]: !!footerDom
  });
  // ====================== Get filtered, checked item list ======================
  const listFooter = footerDom ? /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-footer`
  }, footerDom) : null;
  const checkAllCheckbox = !showRemove && !pagination && checkBox;
  let items;
  if (showRemove) {
    items = [/* Remove Current Page */
    pagination ? {
      key: 'removeCurrent',
      label: removeCurrent,
      onClick() {
        var _a;
        const pageKeys = getEnabledItemKeys((((_a = listBodyRef.current) === null || _a === void 0 ? void 0 : _a.items) || []).map(entity => entity.item));
        onItemRemove === null || onItemRemove === void 0 ? void 0 : onItemRemove(pageKeys);
      }
    } : null, /* Remove All */
    {
      key: 'removeAll',
      label: removeAll,
      onClick() {
        onItemRemove === null || onItemRemove === void 0 ? void 0 : onItemRemove(getEnabledItemKeys(filteredItems));
      }
    }].filter(Boolean);
  } else {
    items = [{
      key: 'selectAll',
      label: checkStatus === 'all' ? deselectAll : selectAll,
      onClick() {
        const keys = getEnabledItemKeys(filteredItems);
        onItemSelectAll === null || onItemSelectAll === void 0 ? void 0 : onItemSelectAll(keys, keys.length !== checkedKeys.length);
      }
    }, pagination ? {
      key: 'selectCurrent',
      label: selectCurrent,
      onClick() {
        var _a;
        const pageItems = ((_a = listBodyRef.current) === null || _a === void 0 ? void 0 : _a.items) || [];
        onItemSelectAll === null || onItemSelectAll === void 0 ? void 0 : onItemSelectAll(getEnabledItemKeys(pageItems.map(entity => entity.item)), true);
      }
    } : null, {
      key: 'selectInvert',
      label: selectInvert,
      onClick() {
        var _a;
        const availablePageItemKeys = getEnabledItemKeys((((_a = listBodyRef.current) === null || _a === void 0 ? void 0 : _a.items) || []).map(entity => entity.item));
        const checkedKeySet = new Set(checkedKeys);
        const newCheckedKeysSet = new Set(checkedKeySet);
        availablePageItemKeys.forEach(key => {
          if (checkedKeySet.has(key)) {
            newCheckedKeysSet.delete(key);
          } else {
            newCheckedKeysSet.add(key);
          }
        });
        onItemSelectAll === null || onItemSelectAll === void 0 ? void 0 : onItemSelectAll(Array.from(newCheckedKeysSet), 'replace');
      }
    }];
  }
  const dropdown = /*#__PURE__*/react.createElement(es_dropdown, {
    className: `${prefixCls}-header-dropdown`,
    menu: {
      items
    },
    disabled: disabled
  }, isValidIcon(selectionsIcon) ? selectionsIcon : /*#__PURE__*/react.createElement(DownOutlined/* default */.Z, null));
  return /*#__PURE__*/react.createElement("div", {
    className: listCls,
    style: style
  }, /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-header`
  }, showSelectAll ? (/*#__PURE__*/react.createElement(react.Fragment, null, checkAllCheckbox, dropdown)) : null, /*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-header-selected`
  }, getSelectAllLabel(checkedActiveItems.length, filteredItems.length)), /*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-header-title`
  }, titleText)), listBody, listFooter);
};
if (false) {}
/* harmony default export */ var transfer_list = (TransferList);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/transfer/operation.js
"use client";





const Operation = props => {
  const {
    disabled,
    moveToLeft,
    moveToRight,
    leftArrowText = '',
    rightArrowText = '',
    leftActive,
    rightActive,
    className,
    style,
    direction,
    oneWay
  } = props;
  return /*#__PURE__*/react.createElement("div", {
    className: className,
    style: style
  }, /*#__PURE__*/react.createElement(es_button, {
    type: "primary",
    size: "small",
    disabled: disabled || !rightActive,
    onClick: moveToRight,
    icon: direction !== 'rtl' ? /*#__PURE__*/react.createElement(RightOutlined/* default */.Z, null) : /*#__PURE__*/react.createElement(LeftOutlined/* default */.Z, null)
  }, rightArrowText), !oneWay && (/*#__PURE__*/react.createElement(es_button, {
    type: "primary",
    size: "small",
    disabled: disabled || !leftActive,
    onClick: moveToLeft,
    icon: direction !== 'rtl' ? /*#__PURE__*/react.createElement(LeftOutlined/* default */.Z, null) : /*#__PURE__*/react.createElement(RightOutlined/* default */.Z, null)
  }, leftArrowText)));
};
if (false) {}
/* harmony default export */ var operation = (Operation);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/transfer/style/index.js



const genTransferCustomizeStyle = token => {
  const {
    antCls,
    componentCls,
    listHeight,
    controlHeightLG
  } = token;
  const tableCls = `${antCls}-table`;
  const inputCls = `${antCls}-input`;
  return {
    [`${componentCls}-customize-list`]: {
      [`${componentCls}-list`]: {
        flex: '1 1 50%',
        width: 'auto',
        height: 'auto',
        minHeight: listHeight,
        minWidth: 0
      },
      // =================== Hook Components ===================
      [`${tableCls}-wrapper`]: {
        [`${tableCls}-small`]: {
          border: 0,
          borderRadius: 0,
          [`${tableCls}-selection-column`]: {
            width: controlHeightLG,
            minWidth: controlHeightLG
          }
        },
        [`${tableCls}-pagination${tableCls}-pagination`]: {
          margin: 0,
          padding: token.paddingXS
        }
      },
      [`${inputCls}[disabled]`]: {
        backgroundColor: 'transparent'
      }
    }
  };
};
const genTransferStatusColor = (token, color) => {
  const {
    componentCls,
    colorBorder
  } = token;
  return {
    [`${componentCls}-list`]: {
      borderColor: color,
      '&-search:not([disabled])': {
        borderColor: colorBorder
      }
    }
  };
};
const genTransferStatusStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}-status-error`]: Object.assign({}, genTransferStatusColor(token, token.colorError)),
    [`${componentCls}-status-warning`]: Object.assign({}, genTransferStatusColor(token, token.colorWarning))
  };
};
const genTransferListStyle = token => {
  const {
    componentCls,
    colorBorder,
    colorSplit,
    lineWidth,
    itemHeight,
    headerHeight,
    transferHeaderVerticalPadding,
    itemPaddingBlock,
    controlItemBgActive,
    colorTextDisabled,
    colorTextSecondary,
    listHeight,
    listWidth,
    listWidthLG,
    fontSizeIcon,
    marginXS,
    paddingSM,
    lineType,
    antCls,
    iconCls,
    motionDurationSlow,
    controlItemBgHover,
    borderRadiusLG,
    colorBgContainer,
    colorText,
    controlItemBgActiveHover
  } = token;
  const contentBorderRadius = (0,cssinjs_es/* unit */.bf)(token.calc(borderRadiusLG).sub(lineWidth).equal());
  return {
    display: 'flex',
    flexDirection: 'column',
    width: listWidth,
    height: listHeight,
    border: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${colorBorder}`,
    borderRadius: token.borderRadiusLG,
    '&-with-pagination': {
      width: listWidthLG,
      height: 'auto'
    },
    '&-search': {
      [`${iconCls}-search`]: {
        color: colorTextDisabled
      }
    },
    '&-header': {
      display: 'flex',
      flex: 'none',
      alignItems: 'center',
      height: headerHeight,
      // border-top is on the transfer dom. We should minus 1px for this
      padding: `${(0,cssinjs_es/* unit */.bf)(token.calc(transferHeaderVerticalPadding).sub(lineWidth).equal())} ${(0,cssinjs_es/* unit */.bf)(paddingSM)} ${(0,cssinjs_es/* unit */.bf)(transferHeaderVerticalPadding)}`,
      color: colorText,
      background: colorBgContainer,
      borderBottom: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${colorSplit}`,
      borderRadius: `${(0,cssinjs_es/* unit */.bf)(borderRadiusLG)} ${(0,cssinjs_es/* unit */.bf)(borderRadiusLG)} 0 0`,
      '> *:not(:last-child)': {
        marginInlineEnd: 4 // This is magic and fixed number, DO NOT use token since it may change.
      },
      '> *': {
        flex: 'none'
      },
      '&-title': Object.assign(Object.assign({}, textEllipsis), {
        flex: 'auto',
        textAlign: 'end'
      }),
      '&-dropdown': Object.assign(Object.assign({}, resetIcon()), {
        fontSize: fontSizeIcon,
        transform: 'translateY(10%)',
        cursor: 'pointer',
        '&[disabled]': {
          cursor: 'not-allowed'
        }
      })
    },
    '&-body': {
      display: 'flex',
      flex: 'auto',
      flexDirection: 'column',
      fontSize: token.fontSize,
      // https://blog.csdn.net/qq449245884/article/details/107373672/
      minHeight: 0,
      '&-search-wrapper': {
        position: 'relative',
        flex: 'none',
        padding: paddingSM
      }
    },
    '&-content': {
      flex: 'auto',
      margin: 0,
      padding: 0,
      overflow: 'auto',
      listStyle: 'none',
      borderRadius: `0 0 ${contentBorderRadius} ${contentBorderRadius}`,
      '&-item': {
        display: 'flex',
        alignItems: 'center',
        minHeight: itemHeight,
        padding: `${(0,cssinjs_es/* unit */.bf)(itemPaddingBlock)} ${(0,cssinjs_es/* unit */.bf)(paddingSM)}`,
        transition: `all ${motionDurationSlow}`,
        '> *:not(:last-child)': {
          marginInlineEnd: marginXS
        },
        '> *': {
          flex: 'none'
        },
        '&-text': Object.assign(Object.assign({}, textEllipsis), {
          flex: 'auto'
        }),
        '&-remove': Object.assign(Object.assign({}, operationUnit(token)), {
          color: colorBorder,
          '&:hover, &:focus': {
            color: colorTextSecondary
          }
        }),
        [`&:not(${componentCls}-list-content-item-disabled)`]: {
          '&:hover': {
            backgroundColor: controlItemBgHover,
            cursor: 'pointer'
          },
          [`&${componentCls}-list-content-item-checked:hover`]: {
            backgroundColor: controlItemBgActiveHover
          }
        },
        '&-checked': {
          backgroundColor: controlItemBgActive
        },
        '&-disabled': {
          color: colorTextDisabled,
          cursor: 'not-allowed'
        }
      },
      // Do not change hover style when `oneWay` mode
      [`&-show-remove ${componentCls}-list-content-item:not(${componentCls}-list-content-item-disabled):hover`]: {
        background: 'transparent',
        cursor: 'default'
      }
    },
    '&-pagination': {
      padding: token.paddingXS,
      textAlign: 'end',
      borderTop: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${colorSplit}`,
      [`${antCls}-pagination-options`]: {
        paddingInlineEnd: token.paddingXS
      }
    },
    '&-body-not-found': {
      flex: 'none',
      width: '100%',
      margin: 'auto 0',
      color: colorTextDisabled,
      textAlign: 'center'
    },
    '&-footer': {
      borderTop: `${(0,cssinjs_es/* unit */.bf)(lineWidth)} ${lineType} ${colorSplit}`
    },
    // fix: https://github.com/ant-design/ant-design/issues/44489
    '&-checkbox': {
      lineHeight: 1
    }
  };
};
const genTransferStyle = token => {
  const {
    antCls,
    iconCls,
    componentCls,
    marginXS,
    marginXXS,
    fontSizeIcon,
    colorBgContainerDisabled
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), {
      position: 'relative',
      display: 'flex',
      alignItems: 'stretch',
      [`${componentCls}-disabled`]: {
        [`${componentCls}-list`]: {
          background: colorBgContainerDisabled
        }
      },
      [`${componentCls}-list`]: genTransferListStyle(token),
      [`${componentCls}-operation`]: {
        display: 'flex',
        flex: 'none',
        flexDirection: 'column',
        alignSelf: 'center',
        margin: `0 ${(0,cssinjs_es/* unit */.bf)(marginXS)}`,
        verticalAlign: 'middle',
        gap: marginXXS,
        [`${antCls}-btn ${iconCls}`]: {
          fontSize: fontSizeIcon
        }
      }
    })
  };
};
const genTransferRTLStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}-rtl`]: {
      direction: 'rtl'
    }
  };
};
const transfer_style_prepareComponentToken = token => {
  const {
    fontSize,
    lineHeight,
    controlHeight,
    controlHeightLG,
    lineWidth
  } = token;
  const fontHeight = Math.round(fontSize * lineHeight);
  return {
    listWidth: 180,
    listHeight: 200,
    listWidthLG: 250,
    headerHeight: controlHeightLG,
    itemHeight: controlHeight,
    itemPaddingBlock: (controlHeight - fontHeight) / 2,
    transferHeaderVerticalPadding: Math.ceil((controlHeightLG - lineWidth - fontHeight) / 2)
  };
};
// ============================== Export ==============================
/* harmony default export */ var transfer_style = (genStyleHooks('Transfer', token => {
  const transferToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token);
  return [genTransferStyle(transferToken), genTransferCustomizeStyle(transferToken), genTransferStatusStyle(transferToken), genTransferRTLStyle(transferToken)];
}, transfer_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/transfer/index.js
"use client";



















const Transfer = props => {
  const {
    dataSource,
    targetKeys = [],
    selectedKeys,
    selectAllLabels = [],
    operations = [],
    style = {},
    listStyle = {},
    locale = {},
    titles,
    disabled,
    showSearch = false,
    operationStyle,
    showSelectAll,
    oneWay,
    pagination,
    status: customStatus,
    prefixCls: customizePrefixCls,
    className,
    rootClassName,
    selectionsIcon,
    filterOption,
    render,
    footer,
    children,
    rowKey,
    onScroll,
    onChange,
    onSearch,
    onSelectChange
  } = props;
  const {
    getPrefixCls,
    renderEmpty,
    direction: dir,
    transfer
  } = (0,react.useContext)(ConfigContext);
  const prefixCls = getPrefixCls('transfer', customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = transfer_style(prefixCls);
  // Fill record with `key`
  const [mergedDataSource, leftDataSource, rightDataSource] = hooks_useData(dataSource, rowKey, targetKeys);
  // Get direction selected keys
  const [
  // Keys
  sourceSelectedKeys, targetSelectedKeys,
  // Setters
  setSourceSelectedKeys, setTargetSelectedKeys] = transfer_hooks_useSelection(leftDataSource, rightDataSource, selectedKeys);
  const [leftMultipleSelect, updateLeftPrevSelectedIndex] = useMultipleSelect(item => item.key);
  const [rightMultipleSelect, updateRightPrevSelectedIndex] = useMultipleSelect(item => item.key);
  if (false) {}
  const setStateKeys = (0,react.useCallback)((direction, keys) => {
    if (direction === 'left') {
      const nextKeys = typeof keys === 'function' ? keys(sourceSelectedKeys || []) : keys;
      setSourceSelectedKeys(nextKeys);
    } else {
      const nextKeys = typeof keys === 'function' ? keys(targetSelectedKeys || []) : keys;
      setTargetSelectedKeys(nextKeys);
    }
  }, [sourceSelectedKeys, targetSelectedKeys]);
  const setPrevSelectedIndex = (direction, value) => {
    const isLeftDirection = direction === 'left';
    const updatePrevSelectedIndex = isLeftDirection ? updateLeftPrevSelectedIndex : updateRightPrevSelectedIndex;
    updatePrevSelectedIndex(value);
  };
  const handleSelectChange = (0,react.useCallback)((direction, holder) => {
    if (direction === 'left') {
      onSelectChange === null || onSelectChange === void 0 ? void 0 : onSelectChange(holder, targetSelectedKeys);
    } else {
      onSelectChange === null || onSelectChange === void 0 ? void 0 : onSelectChange(sourceSelectedKeys, holder);
    }
  }, [sourceSelectedKeys, targetSelectedKeys]);
  const getTitles = transferLocale => {
    var _a;
    return (_a = titles !== null && titles !== void 0 ? titles : transferLocale.titles) !== null && _a !== void 0 ? _a : [];
  };
  const handleLeftScroll = e => {
    onScroll === null || onScroll === void 0 ? void 0 : onScroll('left', e);
  };
  const handleRightScroll = e => {
    onScroll === null || onScroll === void 0 ? void 0 : onScroll('right', e);
  };
  const moveTo = direction => {
    const moveKeys = direction === 'right' ? sourceSelectedKeys : targetSelectedKeys;
    const dataSourceDisabledKeysMap = groupDisabledKeysMap(mergedDataSource);
    // filter the disabled options
    const newMoveKeys = moveKeys.filter(key => !dataSourceDisabledKeysMap.has(key));
    const newMoveKeysMap = groupKeysMap(newMoveKeys);
    // move items to target box
    const newTargetKeys = direction === 'right' ? newMoveKeys.concat(targetKeys) : targetKeys.filter(targetKey => !newMoveKeysMap.has(targetKey));
    // empty checked keys
    const oppositeDirection = direction === 'right' ? 'left' : 'right';
    setStateKeys(oppositeDirection, []);
    handleSelectChange(oppositeDirection, []);
    onChange === null || onChange === void 0 ? void 0 : onChange(newTargetKeys, direction, newMoveKeys);
  };
  const moveToLeft = () => {
    moveTo('left');
    setPrevSelectedIndex('left', null);
  };
  const moveToRight = () => {
    moveTo('right');
    setPrevSelectedIndex('right', null);
  };
  const onItemSelectAll = (direction, keys, checkAll) => {
    setStateKeys(direction, prevKeys => {
      let mergedCheckedKeys = [];
      if (checkAll === 'replace') {
        mergedCheckedKeys = keys;
      } else if (checkAll) {
        // Merge current keys with origin key
        mergedCheckedKeys = Array.from(new Set([].concat((0,toConsumableArray/* default */.Z)(prevKeys), (0,toConsumableArray/* default */.Z)(keys))));
      } else {
        const selectedKeysMap = groupKeysMap(keys);
        // Remove current keys from origin keys
        mergedCheckedKeys = prevKeys.filter(key => !selectedKeysMap.has(key));
      }
      handleSelectChange(direction, mergedCheckedKeys);
      return mergedCheckedKeys;
    });
    setPrevSelectedIndex(direction, null);
  };
  const onLeftItemSelectAll = (keys, checkAll) => {
    onItemSelectAll('left', keys, checkAll);
  };
  const onRightItemSelectAll = (keys, checkAll) => {
    onItemSelectAll('right', keys, checkAll);
  };
  const leftFilter = e => onSearch === null || onSearch === void 0 ? void 0 : onSearch('left', e.target.value);
  const rightFilter = e => onSearch === null || onSearch === void 0 ? void 0 : onSearch('right', e.target.value);
  const handleLeftClear = () => onSearch === null || onSearch === void 0 ? void 0 : onSearch('left', '');
  const handleRightClear = () => onSearch === null || onSearch === void 0 ? void 0 : onSearch('right', '');
  const handleSingleSelect = (direction, holder, selectedKey, checked, currentSelectedIndex) => {
    const isSelected = holder.has(selectedKey);
    if (isSelected) {
      holder.delete(selectedKey);
      setPrevSelectedIndex(direction, null);
    }
    if (checked) {
      holder.add(selectedKey);
      setPrevSelectedIndex(direction, currentSelectedIndex);
    }
  };
  const handleMultipleSelect = (direction, data, holder, currentSelectedIndex) => {
    const isLeftDirection = direction === 'left';
    const multipleSelect = isLeftDirection ? leftMultipleSelect : rightMultipleSelect;
    multipleSelect(currentSelectedIndex, data, holder);
  };
  const onItemSelect = (direction, selectedKey, checked, multiple) => {
    const isLeftDirection = direction === 'left';
    const holder = (0,toConsumableArray/* default */.Z)(isLeftDirection ? sourceSelectedKeys : targetSelectedKeys);
    const holderSet = new Set(holder);
    const data = (0,toConsumableArray/* default */.Z)(isLeftDirection ? leftDataSource : rightDataSource).filter(item => !(item === null || item === void 0 ? void 0 : item.disabled));
    const currentSelectedIndex = data.findIndex(item => item.key === selectedKey);
    // multiple select by hold down the shift key
    if (multiple && holder.length > 0) {
      handleMultipleSelect(direction, data, holderSet, currentSelectedIndex);
    } else {
      handleSingleSelect(direction, holderSet, selectedKey, checked, currentSelectedIndex);
    }
    const holderArr = Array.from(holderSet);
    handleSelectChange(direction, holderArr);
    if (!props.selectedKeys) {
      setStateKeys(direction, holderArr);
    }
  };
  const onLeftItemSelect = (selectedKey, checked, e) => {
    onItemSelect('left', selectedKey, checked, e === null || e === void 0 ? void 0 : e.shiftKey);
  };
  const onRightItemSelect = (selectedKey, checked, e) => {
    onItemSelect('right', selectedKey, checked, e === null || e === void 0 ? void 0 : e.shiftKey);
  };
  const onRightItemRemove = keys => {
    setStateKeys('right', []);
    onChange === null || onChange === void 0 ? void 0 : onChange(targetKeys.filter(key => !keys.includes(key)), 'left', (0,toConsumableArray/* default */.Z)(keys));
  };
  const handleListStyle = direction => {
    if (typeof listStyle === 'function') {
      return listStyle({
        direction
      });
    }
    return listStyle || {};
  };
  const formItemContext = (0,react.useContext)(FormItemInputContext);
  const {
    hasFeedback,
    status
  } = formItemContext;
  const getLocale = transferLocale => Object.assign(Object.assign(Object.assign({}, transferLocale), {
    notFoundContent: (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty('Transfer')) || /*#__PURE__*/react.createElement(defaultRenderEmpty, {
      componentName: "Transfer"
    })
  }), locale);
  const mergedStatus = getMergedStatus(status, customStatus);
  const mergedPagination = !children && pagination;
  const leftActive = rightDataSource.filter(d => targetSelectedKeys.includes(d.key) && !d.disabled).length > 0;
  const rightActive = leftDataSource.filter(d => sourceSelectedKeys.includes(d.key) && !d.disabled).length > 0;
  const cls = classnames_default()(prefixCls, {
    [`${prefixCls}-disabled`]: disabled,
    [`${prefixCls}-customize-list`]: !!children,
    [`${prefixCls}-rtl`]: dir === 'rtl'
  }, getStatusClassNames(prefixCls, mergedStatus, hasFeedback), transfer === null || transfer === void 0 ? void 0 : transfer.className, className, rootClassName, hashId, cssVarCls);
  const [contextLocale] = locale_useLocale('Transfer', es_locale_en_US.Transfer);
  const listLocale = getLocale(contextLocale);
  const [leftTitle, rightTitle] = getTitles(listLocale);
  const mergedSelectionsIcon = selectionsIcon !== null && selectionsIcon !== void 0 ? selectionsIcon : transfer === null || transfer === void 0 ? void 0 : transfer.selectionsIcon;
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    className: cls,
    style: Object.assign(Object.assign({}, transfer === null || transfer === void 0 ? void 0 : transfer.style), style)
  }, /*#__PURE__*/react.createElement(transfer_list, Object.assign({
    prefixCls: `${prefixCls}-list`,
    titleText: leftTitle,
    dataSource: leftDataSource,
    filterOption: filterOption,
    style: handleListStyle('left'),
    checkedKeys: sourceSelectedKeys,
    handleFilter: leftFilter,
    handleClear: handleLeftClear,
    onItemSelect: onLeftItemSelect,
    onItemSelectAll: onLeftItemSelectAll,
    render: render,
    showSearch: showSearch,
    renderList: children,
    footer: footer,
    onScroll: handleLeftScroll,
    disabled: disabled,
    direction: dir === 'rtl' ? 'right' : 'left',
    showSelectAll: showSelectAll,
    selectAllLabel: selectAllLabels[0],
    pagination: mergedPagination,
    selectionsIcon: mergedSelectionsIcon
  }, listLocale)), /*#__PURE__*/react.createElement(operation, {
    className: `${prefixCls}-operation`,
    rightActive: rightActive,
    rightArrowText: operations[0],
    moveToRight: moveToRight,
    leftActive: leftActive,
    leftArrowText: operations[1],
    moveToLeft: moveToLeft,
    style: operationStyle,
    disabled: disabled,
    direction: dir,
    oneWay: oneWay
  }), /*#__PURE__*/react.createElement(transfer_list, Object.assign({
    prefixCls: `${prefixCls}-list`,
    titleText: rightTitle,
    dataSource: rightDataSource,
    filterOption: filterOption,
    style: handleListStyle('right'),
    checkedKeys: targetSelectedKeys,
    handleFilter: rightFilter,
    handleClear: handleRightClear,
    onItemSelect: onRightItemSelect,
    onItemSelectAll: onRightItemSelectAll,
    onItemRemove: onRightItemRemove,
    render: render,
    showSearch: showSearch,
    renderList: children,
    footer: footer,
    onScroll: handleRightScroll,
    disabled: disabled,
    direction: dir === 'rtl' ? 'left' : 'right',
    showSelectAll: showSelectAll,
    selectAllLabel: selectAllLabels[1],
    showRemove: oneWay,
    pagination: mergedPagination,
    selectionsIcon: mergedSelectionsIcon
  }, listLocale))));
};
if (false) {}
Transfer.List = transfer_list;
Transfer.Search = transfer_search;
Transfer.Operation = operation;
/* harmony default export */ var transfer = (Transfer);
;// CONCATENATED MODULE: ./node_modules/rc-tree-select/es/hooks/useCache.js


/**
 * This function will try to call requestIdleCallback if available to save performance.
 * No need `getLabel` here since already fetch on `rawLabeledValue`.
 */
/* harmony default export */ var useCache = (function (values) {
  var cacheRef = react.useRef({
    valueLabels: new Map()
  });
  return react.useMemo(function () {
    var valueLabels = cacheRef.current.valueLabels;
    var valueLabelsCache = new Map();
    var filledValues = values.map(function (item) {
      var value = item.value,
        label = item.label;
      var mergedLabel = label !== null && label !== void 0 ? label : valueLabels.get(value);

      // Save in cache
      valueLabelsCache.set(value, mergedLabel);
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, item), {}, {
        label: mergedLabel
      });
    });
    cacheRef.current.valueLabels = valueLabelsCache;
    return [filledValues];
  }, [values]);
});
;// CONCATENATED MODULE: ./node_modules/rc-tree-select/es/hooks/useCheckedKeys.js



var useCheckedKeys = function useCheckedKeys(rawLabeledValues, rawHalfCheckedValues, treeConduction, keyEntities) {
  return react.useMemo(function () {
    var extractValues = function extractValues(values) {
      return values.map(function (_ref) {
        var value = _ref.value;
        return value;
      });
    };
    var checkedKeys = extractValues(rawLabeledValues);
    var halfCheckedKeys = extractValues(rawHalfCheckedValues);
    var missingValues = checkedKeys.filter(function (key) {
      return !keyEntities[key];
    });
    var finalCheckedKeys = checkedKeys;
    var finalHalfCheckedKeys = halfCheckedKeys;
    if (treeConduction) {
      var conductResult = (0,conductUtil/* conductCheck */.S)(checkedKeys, true, keyEntities);
      finalCheckedKeys = conductResult.checkedKeys;
      finalHalfCheckedKeys = conductResult.halfCheckedKeys;
    }
    return [Array.from(new Set([].concat((0,toConsumableArray/* default */.Z)(missingValues), (0,toConsumableArray/* default */.Z)(finalCheckedKeys)))), finalHalfCheckedKeys];
  }, [rawLabeledValues, rawHalfCheckedValues, treeConduction, keyEntities]);
};
/* harmony default export */ var hooks_useCheckedKeys = (useCheckedKeys);
;// CONCATENATED MODULE: ./node_modules/rc-tree-select/es/hooks/useDataEntities.js





/* harmony default export */ var useDataEntities = (function (treeData, fieldNames) {
  return react.useMemo(function () {
    var collection = (0,treeUtil/* convertDataToEntities */.I8)(treeData, {
      fieldNames: fieldNames,
      initWrapper: function initWrapper(wrapper) {
        return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, wrapper), {}, {
          valueEntities: new Map()
        });
      },
      processEntity: function processEntity(entity, wrapper) {
        var val = entity.node[fieldNames.value];

        // Check if exist same value
        if (false) { var key; }
        wrapper.valueEntities.set(val, entity);
      }
    });
    return collection;
  }, [treeData, fieldNames]);
});
;// CONCATENATED MODULE: ./node_modules/rc-tree-select/es/TreeNode.js
/* istanbul ignore file */

/** This is a placeholder, not real render in dom */
var TreeNode = function TreeNode() {
  return null;
};
/* harmony default export */ var es_TreeNode = (TreeNode);
;// CONCATENATED MODULE: ./node_modules/rc-tree-select/es/utils/legacyUtil.js


var legacyUtil_excluded = ["children", "value"];




function convertChildrenToData(nodes) {
  return (0,Children_toArray/* default */.Z)(nodes).map(function (node) {
    if (! /*#__PURE__*/react.isValidElement(node) || !node.type) {
      return null;
    }
    var _ref = node,
      key = _ref.key,
      _ref$props = _ref.props,
      children = _ref$props.children,
      value = _ref$props.value,
      restProps = (0,objectWithoutProperties/* default */.Z)(_ref$props, legacyUtil_excluded);
    var data = (0,objectSpread2/* default */.Z)({
      key: key,
      value: value
    }, restProps);
    var childData = convertChildrenToData(children);
    if (childData.length) {
      data.children = childData;
    }
    return data;
  }).filter(function (data) {
    return data;
  });
}
function fillLegacyProps(dataNode) {
  if (!dataNode) {
    return dataNode;
  }
  var cloneNode = (0,objectSpread2/* default */.Z)({}, dataNode);
  if (!('props' in cloneNode)) {
    Object.defineProperty(cloneNode, 'props', {
      get: function get() {
        (0,es_warning/* default */.ZP)(false, 'New `rc-tree-select` not support return node instance as argument anymore. Please consider to remove `props` access.');
        return cloneNode;
      }
    });
  }
  return cloneNode;
}
function fillAdditionalInfo(extra, triggerValue, checkedValues, treeData, showPosition, fieldNames) {
  var triggerNode = null;
  var nodeList = null;
  function generateMap() {
    function dig(list) {
      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';
      var parentIncluded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return list.map(function (option, index) {
        var pos = "".concat(level, "-").concat(index);
        var value = option[fieldNames.value];
        var included = checkedValues.includes(value);
        var children = dig(option[fieldNames.children] || [], pos, included);
        var node = /*#__PURE__*/react.createElement(es_TreeNode, option, children.map(function (child) {
          return child.node;
        }));

        // Link with trigger node
        if (triggerValue === value) {
          triggerNode = node;
        }
        if (included) {
          var checkedNode = {
            pos: pos,
            node: node,
            children: children
          };
          if (!parentIncluded) {
            nodeList.push(checkedNode);
          }
          return checkedNode;
        }
        return null;
      }).filter(function (node) {
        return node;
      });
    }
    if (!nodeList) {
      nodeList = [];
      dig(treeData);

      // Sort to keep the checked node length
      nodeList.sort(function (_ref2, _ref3) {
        var val1 = _ref2.node.props.value;
        var val2 = _ref3.node.props.value;
        var index1 = checkedValues.indexOf(val1);
        var index2 = checkedValues.indexOf(val2);
        return index1 - index2;
      });
    }
  }
  Object.defineProperty(extra, 'triggerNode', {
    get: function get() {
      (0,es_warning/* default */.ZP)(false, '`triggerNode` is deprecated. Please consider decoupling data with node.');
      generateMap();
      return triggerNode;
    }
  });
  Object.defineProperty(extra, 'allCheckedNodes', {
    get: function get() {
      (0,es_warning/* default */.ZP)(false, '`allCheckedNodes` is deprecated. Please consider decoupling data with node.');
      generateMap();
      if (showPosition) {
        return nodeList;
      }
      return nodeList.map(function (_ref4) {
        var node = _ref4.node;
        return node;
      });
    }
  });
}
;// CONCATENATED MODULE: ./node_modules/rc-tree-select/es/hooks/useFilterTreeData.js




var useFilterTreeData = function useFilterTreeData(treeData, searchValue, options) {
  var fieldNames = options.fieldNames,
    treeNodeFilterProp = options.treeNodeFilterProp,
    filterTreeNode = options.filterTreeNode;
  var fieldChildren = fieldNames.children;
  return react.useMemo(function () {
    if (!searchValue || filterTreeNode === false) {
      return treeData;
    }
    var filterOptionFunc = typeof filterTreeNode === 'function' ? filterTreeNode : function (_, dataNode) {
      return String(dataNode[treeNodeFilterProp]).toUpperCase().includes(searchValue.toUpperCase());
    };
    var filterTreeNodes = function filterTreeNodes(nodes) {
      var keepAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return nodes.reduce(function (filtered, node) {
        var children = node[fieldChildren];
        var isMatch = keepAll || filterOptionFunc(searchValue, fillLegacyProps(node));
        var filteredChildren = filterTreeNodes(children || [], isMatch);
        if (isMatch || filteredChildren.length) {
          filtered.push((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, node), {}, (0,defineProperty/* default */.Z)({
            isLeaf: undefined
          }, fieldChildren, filteredChildren)));
        }
        return filtered;
      }, []);
    };
    return filterTreeNodes(treeData);
  }, [treeData, searchValue, fieldChildren, treeNodeFilterProp, filterTreeNode]);
};
/* harmony default export */ var hooks_useFilterTreeData = (useFilterTreeData);
;// CONCATENATED MODULE: ./node_modules/rc-tree-select/es/hooks/useRefFunc.js


/**
 * Same as `React.useCallback` but always return a memoized function
 * but redirect to real function.
 */
function useRefFunc(callback) {
  var funcRef = react.useRef();
  funcRef.current = callback;
  var cacheFn = react.useCallback(function () {
    return funcRef.current.apply(funcRef, arguments);
  }, []);
  return cacheFn;
}
;// CONCATENATED MODULE: ./node_modules/rc-tree-select/es/hooks/useTreeData.js




function buildTreeStructure(nodes, config) {
  var id = config.id,
    pId = config.pId,
    rootPId = config.rootPId;
  var nodeMap = new Map();
  var rootNodes = [];
  nodes.forEach(function (node) {
    var nodeKey = node[id];
    var clonedNode = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, node), {}, {
      key: node.key || nodeKey
    });
    nodeMap.set(nodeKey, clonedNode);
  });
  nodeMap.forEach(function (node) {
    var parentKey = node[pId];
    var parent = nodeMap.get(parentKey);
    if (parent) {
      parent.children = parent.children || [];
      parent.children.push(node);
    } else if (parentKey === rootPId || rootPId === null) {
      rootNodes.push(node);
    }
  });
  return rootNodes;
}

/**
 * 将 `treeData` 或 `children` 转换为格式化的 `treeData`。
 * 如果 `treeData` 或 `children` 没有变化，则不会重新计算。
 */
function useTreeData(treeData, children, simpleMode) {
  return react.useMemo(function () {
    if (treeData) {
      if (simpleMode) {
        var config = (0,objectSpread2/* default */.Z)({
          id: 'id',
          pId: 'pId',
          rootPId: null
        }, (0,esm_typeof/* default */.Z)(simpleMode) === 'object' ? simpleMode : {});
        return buildTreeStructure(treeData, config);
      }
      return treeData;
    }
    return convertChildrenToData(children);
  }, [children, simpleMode, treeData]);
}
;// CONCATENATED MODULE: ./node_modules/rc-tree-select/es/LegacyContext.js

var LegacySelectContext = /*#__PURE__*/react.createContext(null);
/* harmony default export */ var LegacyContext = (LegacySelectContext);
;// CONCATENATED MODULE: ./node_modules/rc-tree-select/es/TreeSelectContext.js

var TreeSelectContext = /*#__PURE__*/react.createContext(null);
/* harmony default export */ var es_TreeSelectContext = (TreeSelectContext);
;// CONCATENATED MODULE: ./node_modules/rc-tree-select/es/utils/valueUtil.js
var valueUtil_toArray = function toArray(value) {
  return Array.isArray(value) ? value : value !== undefined ? [value] : [];
};
var valueUtil_fillFieldNames = function fillFieldNames(fieldNames) {
  var _ref = fieldNames || {},
    label = _ref.label,
    value = _ref.value,
    children = _ref.children;
  return {
    _title: label ? [label] : ['title', 'label'],
    value: value || 'value',
    key: value || 'value',
    children: children || 'children'
  };
};
var isCheckDisabled = function isCheckDisabled(node) {
  return !node || node.disabled || node.disableCheckbox || node.checkable === false;
};
var getAllKeys = function getAllKeys(treeData, fieldNames) {
  var keys = [];
  var dig = function dig(list) {
    list.forEach(function (item) {
      var children = item[fieldNames.children];
      if (children) {
        keys.push(item[fieldNames.value]);
        dig(children);
      }
    });
  };
  dig(treeData);
  return keys;
};
var isNil = function isNil(val) {
  return val === null || val === undefined;
};
;// CONCATENATED MODULE: ./node_modules/rc-tree-select/es/OptionList.js














var HIDDEN_STYLE = {
  width: 0,
  height: 0,
  display: 'flex',
  overflow: 'hidden',
  opacity: 0,
  border: 0,
  padding: 0,
  margin: 0
};
var OptionList_OptionList = function OptionList(_, ref) {
  var _useBaseProps = (0,rc_select_es/* useBaseProps */.lk)(),
    prefixCls = _useBaseProps.prefixCls,
    multiple = _useBaseProps.multiple,
    searchValue = _useBaseProps.searchValue,
    toggleOpen = _useBaseProps.toggleOpen,
    open = _useBaseProps.open,
    notFoundContent = _useBaseProps.notFoundContent;
  var _React$useContext = react.useContext(es_TreeSelectContext),
    virtual = _React$useContext.virtual,
    listHeight = _React$useContext.listHeight,
    listItemHeight = _React$useContext.listItemHeight,
    listItemScrollOffset = _React$useContext.listItemScrollOffset,
    treeData = _React$useContext.treeData,
    fieldNames = _React$useContext.fieldNames,
    onSelect = _React$useContext.onSelect,
    dropdownMatchSelectWidth = _React$useContext.dropdownMatchSelectWidth,
    treeExpandAction = _React$useContext.treeExpandAction,
    treeTitleRender = _React$useContext.treeTitleRender,
    onPopupScroll = _React$useContext.onPopupScroll,
    leftMaxCount = _React$useContext.leftMaxCount,
    leafCountOnly = _React$useContext.leafCountOnly,
    valueEntities = _React$useContext.valueEntities;
  var _React$useContext2 = react.useContext(LegacyContext),
    checkable = _React$useContext2.checkable,
    checkedKeys = _React$useContext2.checkedKeys,
    halfCheckedKeys = _React$useContext2.halfCheckedKeys,
    treeExpandedKeys = _React$useContext2.treeExpandedKeys,
    treeDefaultExpandAll = _React$useContext2.treeDefaultExpandAll,
    treeDefaultExpandedKeys = _React$useContext2.treeDefaultExpandedKeys,
    onTreeExpand = _React$useContext2.onTreeExpand,
    treeIcon = _React$useContext2.treeIcon,
    showTreeIcon = _React$useContext2.showTreeIcon,
    switcherIcon = _React$useContext2.switcherIcon,
    treeLine = _React$useContext2.treeLine,
    treeNodeFilterProp = _React$useContext2.treeNodeFilterProp,
    loadData = _React$useContext2.loadData,
    treeLoadedKeys = _React$useContext2.treeLoadedKeys,
    treeMotion = _React$useContext2.treeMotion,
    onTreeLoad = _React$useContext2.onTreeLoad,
    keyEntities = _React$useContext2.keyEntities;
  var treeRef = react.useRef();
  var memoTreeData = (0,useMemo/* default */.Z)(function () {
    return treeData;
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [open, treeData], function (prev, next) {
    return next[0] && prev[1] !== next[1];
  });

  // ========================== Values ==========================
  var mergedCheckedKeys = react.useMemo(function () {
    if (!checkable) {
      return null;
    }
    return {
      checked: checkedKeys,
      halfChecked: halfCheckedKeys
    };
  }, [checkable, checkedKeys, halfCheckedKeys]);

  // ========================== Scroll ==========================
  react.useEffect(function () {
    // Single mode should scroll to current key
    if (open && !multiple && checkedKeys.length) {
      var _treeRef$current;
      (_treeRef$current = treeRef.current) === null || _treeRef$current === void 0 || _treeRef$current.scrollTo({
        key: checkedKeys[0]
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  // ========================== Events ==========================
  var onListMouseDown = function onListMouseDown(event) {
    event.preventDefault();
  };
  var onInternalSelect = function onInternalSelect(__, info) {
    var node = info.node;
    if (checkable && isCheckDisabled(node)) {
      return;
    }
    onSelect(node.key, {
      selected: !checkedKeys.includes(node.key)
    });
    if (!multiple) {
      toggleOpen(false);
    }
  };

  // =========================== Keys ===========================
  var _React$useState = react.useState(treeDefaultExpandedKeys),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    expandedKeys = _React$useState2[0],
    setExpandedKeys = _React$useState2[1];
  var _React$useState3 = react.useState(null),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    searchExpandedKeys = _React$useState4[0],
    setSearchExpandedKeys = _React$useState4[1];
  var mergedExpandedKeys = react.useMemo(function () {
    if (treeExpandedKeys) {
      return (0,toConsumableArray/* default */.Z)(treeExpandedKeys);
    }
    return searchValue ? searchExpandedKeys : expandedKeys;
  }, [expandedKeys, searchExpandedKeys, treeExpandedKeys, searchValue]);
  var onInternalExpand = function onInternalExpand(keys) {
    setExpandedKeys(keys);
    setSearchExpandedKeys(keys);
    if (onTreeExpand) {
      onTreeExpand(keys);
    }
  };

  // ========================== Search ==========================
  var lowerSearchValue = String(searchValue).toLowerCase();
  var filterTreeNode = function filterTreeNode(treeNode) {
    if (!lowerSearchValue) {
      return false;
    }
    return String(treeNode[treeNodeFilterProp]).toLowerCase().includes(lowerSearchValue);
  };
  react.useEffect(function () {
    if (searchValue) {
      setSearchExpandedKeys(getAllKeys(treeData, fieldNames));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  // ========================= Disabled =========================
  // Cache disabled states in React state to ensure re-render when cache updates
  var _React$useState5 = react.useState(function () {
      return new Map();
    }),
    _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
    disabledCache = _React$useState6[0],
    setDisabledCache = _React$useState6[1];
  react.useEffect(function () {
    if (leftMaxCount) {
      setDisabledCache(new Map());
    }
  }, [leftMaxCount]);
  function getDisabledWithCache(node) {
    var value = node[fieldNames.value];
    if (!disabledCache.has(value)) {
      var entity = valueEntities.get(value);
      var isLeaf = (entity.children || []).length === 0;
      if (!isLeaf) {
        var checkableChildren = entity.children.filter(function (childTreeNode) {
          return !childTreeNode.node.disabled && !childTreeNode.node.disableCheckbox && !checkedKeys.includes(childTreeNode.node[fieldNames.value]);
        });
        var checkableChildrenCount = checkableChildren.length;
        disabledCache.set(value, checkableChildrenCount > leftMaxCount);
      } else {
        disabledCache.set(value, false);
      }
    }
    return disabledCache.get(value);
  }
  var nodeDisabled = (0,rc_util_es/* useEvent */.zX)(function (node) {
    var nodeValue = node[fieldNames.value];
    if (checkedKeys.includes(nodeValue)) {
      return false;
    }
    if (leftMaxCount === null) {
      return false;
    }
    if (leftMaxCount <= 0) {
      return true;
    }

    // This is a low performance calculation
    if (leafCountOnly && leftMaxCount) {
      return getDisabledWithCache(node);
    }
    return false;
  });

  // ========================== Get First Selectable Node ==========================
  var getFirstMatchingNode = function getFirstMatchingNode(nodes) {
    var _iterator = _createForOfIteratorHelper(nodes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var node = _step.value;
        if (node.disabled || node.selectable === false) {
          continue;
        }
        if (searchValue) {
          if (filterTreeNode(node)) {
            return node;
          }
        } else {
          return node;
        }
        if (node[fieldNames.children]) {
          var matchInChildren = getFirstMatchingNode(node[fieldNames.children]);
          if (matchInChildren) {
            return matchInChildren;
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return null;
  };

  // ========================== Active ==========================
  var _React$useState7 = react.useState(null),
    _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
    activeKey = _React$useState8[0],
    setActiveKey = _React$useState8[1];
  var activeEntity = keyEntities[activeKey];
  react.useEffect(function () {
    if (!open) {
      return;
    }
    var nextActiveKey = null;
    var getFirstNode = function getFirstNode() {
      var firstNode = getFirstMatchingNode(memoTreeData);
      return firstNode ? firstNode[fieldNames.value] : null;
    };

    // single mode active first checked node
    if (!multiple && checkedKeys.length && !searchValue) {
      nextActiveKey = checkedKeys[0];
    } else {
      nextActiveKey = getFirstNode();
    }
    setActiveKey(nextActiveKey);
  }, [open, searchValue]);

  // ========================= Keyboard =========================
  react.useImperativeHandle(ref, function () {
    var _treeRef$current2;
    return {
      scrollTo: (_treeRef$current2 = treeRef.current) === null || _treeRef$current2 === void 0 ? void 0 : _treeRef$current2.scrollTo,
      onKeyDown: function onKeyDown(event) {
        var _treeRef$current3;
        var which = event.which;
        switch (which) {
          // >>> Arrow keys
          case KeyCode/* default.UP */.Z.UP:
          case KeyCode/* default.DOWN */.Z.DOWN:
          case KeyCode/* default.LEFT */.Z.LEFT:
          case KeyCode/* default.RIGHT */.Z.RIGHT:
            (_treeRef$current3 = treeRef.current) === null || _treeRef$current3 === void 0 || _treeRef$current3.onKeyDown(event);
            break;

          // >>> Select item
          case KeyCode/* default.ENTER */.Z.ENTER:
            {
              if (activeEntity) {
                var isNodeDisabled = nodeDisabled(activeEntity.node);
                var _ref = (activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.node) || {},
                  selectable = _ref.selectable,
                  value = _ref.value,
                  disabled = _ref.disabled;
                if (selectable !== false && !disabled && !isNodeDisabled) {
                  onInternalSelect(null, {
                    node: {
                      key: activeKey
                    },
                    selected: !checkedKeys.includes(value)
                  });
                }
              }
              break;
            }

          // >>> Close
          case KeyCode/* default.ESC */.Z.ESC:
            {
              toggleOpen(false);
            }
        }
      },
      onKeyUp: function onKeyUp() {}
    };
  });
  var hasLoadDataFn = (0,useMemo/* default */.Z)(function () {
    return searchValue ? false : true;
  }, [searchValue, treeExpandedKeys || expandedKeys], function (_ref2, _ref3) {
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref2, 1),
      preSearchValue = _ref4[0];
    var _ref5 = (0,slicedToArray/* default */.Z)(_ref3, 2),
      nextSearchValue = _ref5[0],
      nextExcludeSearchExpandedKeys = _ref5[1];
    return preSearchValue !== nextSearchValue && !!(nextSearchValue || nextExcludeSearchExpandedKeys);
  });
  var syncLoadData = hasLoadDataFn ? loadData : null;

  // ========================== Render ==========================
  if (memoTreeData.length === 0) {
    return /*#__PURE__*/react.createElement("div", {
      role: "listbox",
      className: "".concat(prefixCls, "-empty"),
      onMouseDown: onListMouseDown
    }, notFoundContent);
  }
  var treeProps = {
    fieldNames: fieldNames
  };
  if (treeLoadedKeys) {
    treeProps.loadedKeys = treeLoadedKeys;
  }
  if (mergedExpandedKeys) {
    treeProps.expandedKeys = mergedExpandedKeys;
  }
  return /*#__PURE__*/react.createElement("div", {
    onMouseDown: onListMouseDown
  }, activeEntity && open && /*#__PURE__*/react.createElement("span", {
    style: HIDDEN_STYLE,
    "aria-live": "assertive"
  }, activeEntity.node.value), /*#__PURE__*/react.createElement(rc_tree_es/* UnstableContext.Provider */.y6.Provider, {
    value: {
      nodeDisabled: nodeDisabled
    }
  }, /*#__PURE__*/react.createElement(rc_tree_es/* default */.ZP, (0,esm_extends/* default */.Z)({
    ref: treeRef,
    focusable: false,
    prefixCls: "".concat(prefixCls, "-tree"),
    treeData: memoTreeData,
    height: listHeight,
    itemHeight: listItemHeight,
    itemScrollOffset: listItemScrollOffset,
    virtual: virtual !== false && dropdownMatchSelectWidth !== false,
    multiple: multiple,
    icon: treeIcon,
    showIcon: showTreeIcon,
    switcherIcon: switcherIcon,
    showLine: treeLine,
    loadData: syncLoadData,
    motion: treeMotion,
    activeKey: activeKey
    // We handle keys by out instead tree self
    ,

    checkable: checkable,
    checkStrictly: true,
    checkedKeys: mergedCheckedKeys,
    selectedKeys: !checkable ? checkedKeys : [],
    defaultExpandAll: treeDefaultExpandAll,
    titleRender: treeTitleRender
  }, treeProps, {
    // Proxy event out
    onActiveChange: setActiveKey,
    onSelect: onInternalSelect,
    onCheck: onInternalSelect,
    onExpand: onInternalExpand,
    onLoad: onTreeLoad,
    filterTreeNode: filterTreeNode,
    expandAction: treeExpandAction,
    onScroll: onPopupScroll
  }))));
};
var OptionList_RefOptionList = /*#__PURE__*/react.forwardRef(OptionList_OptionList);
if (false) {}
/* harmony default export */ var es_OptionList = (OptionList_RefOptionList);
;// CONCATENATED MODULE: ./node_modules/rc-tree-select/es/utils/strategyUtil.js

var SHOW_ALL = 'SHOW_ALL';
var strategyUtil_SHOW_PARENT = 'SHOW_PARENT';
var strategyUtil_SHOW_CHILD = 'SHOW_CHILD';
function strategyUtil_formatStrategyValues(values, strategy, keyEntities, fieldNames) {
  var valueSet = new Set(values);
  if (strategy === strategyUtil_SHOW_CHILD) {
    return values.filter(function (key) {
      var entity = keyEntities[key];
      return !entity || !entity.children || !entity.children.some(function (_ref) {
        var node = _ref.node;
        return valueSet.has(node[fieldNames.value]);
      }) || !entity.children.every(function (_ref2) {
        var node = _ref2.node;
        return isCheckDisabled(node) || valueSet.has(node[fieldNames.value]);
      });
    });
  }
  if (strategy === strategyUtil_SHOW_PARENT) {
    return values.filter(function (key) {
      var entity = keyEntities[key];
      var parent = entity ? entity.parent : null;
      return !parent || isCheckDisabled(parent.node) || !valueSet.has(parent.key);
    });
  }
  return values;
}
;// CONCATENATED MODULE: ./node_modules/rc-tree-select/es/utils/warningPropsUtil.js



function warningPropsUtil_warningProps(props) {
  var searchPlaceholder = props.searchPlaceholder,
    treeCheckStrictly = props.treeCheckStrictly,
    treeCheckable = props.treeCheckable,
    labelInValue = props.labelInValue,
    value = props.value,
    multiple = props.multiple,
    showCheckedStrategy = props.showCheckedStrategy,
    maxCount = props.maxCount;
  warning(!searchPlaceholder, '`searchPlaceholder` has been removed.');
  if (treeCheckStrictly && labelInValue === false) {
    warning(false, '`treeCheckStrictly` will force set `labelInValue` to `true`.');
  }
  if (labelInValue || treeCheckStrictly) {
    warning(toArray(value).every(function (val) {
      return val && _typeof(val) === 'object' && 'value' in val;
    }), 'Invalid prop `value` supplied to `TreeSelect`. You should use { label: string, value: string | number } or [{ label: string, value: string | number }] instead.');
  }
  if (treeCheckStrictly || multiple || treeCheckable) {
    warning(!value || Array.isArray(value), '`value` should be an array when `TreeSelect` is checkable or multiple.');
  } else {
    warning(!Array.isArray(value), '`value` should not be array when `TreeSelect` is single mode.');
  }
  if (maxCount && (showCheckedStrategy === 'SHOW_ALL' && !treeCheckStrictly || showCheckedStrategy === 'SHOW_PARENT')) {
    warning(false, '`maxCount` not work with `showCheckedStrategy=SHOW_ALL` (when `treeCheckStrictly=false`) or `showCheckedStrategy=SHOW_PARENT`.');
  }
}
/* harmony default export */ var utils_warningPropsUtil = ((/* unused pure expression or super */ null && (warningPropsUtil_warningProps)));
;// CONCATENATED MODULE: ./node_modules/rc-tree-select/es/TreeSelect.js






var TreeSelect_excluded = ["id", "prefixCls", "value", "defaultValue", "onChange", "onSelect", "onDeselect", "searchValue", "inputValue", "onSearch", "autoClearSearchValue", "filterTreeNode", "treeNodeFilterProp", "showCheckedStrategy", "treeNodeLabelProp", "multiple", "treeCheckable", "treeCheckStrictly", "labelInValue", "maxCount", "fieldNames", "treeDataSimpleMode", "treeData", "children", "loadData", "treeLoadedKeys", "onTreeLoad", "treeDefaultExpandAll", "treeExpandedKeys", "treeDefaultExpandedKeys", "onTreeExpand", "treeExpandAction", "virtual", "listHeight", "listItemHeight", "listItemScrollOffset", "onDropdownVisibleChange", "dropdownMatchSelectWidth", "treeLine", "treeIcon", "showTreeIcon", "switcherIcon", "treeMotion", "treeTitleRender", "onPopupScroll"];




















function isRawValue(value) {
  return !value || (0,esm_typeof/* default */.Z)(value) !== 'object';
}
var TreeSelect = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var id = props.id,
    _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-tree-select' : _props$prefixCls,
    value = props.value,
    defaultValue = props.defaultValue,
    onChange = props.onChange,
    onSelect = props.onSelect,
    onDeselect = props.onDeselect,
    searchValue = props.searchValue,
    inputValue = props.inputValue,
    onSearch = props.onSearch,
    _props$autoClearSearc = props.autoClearSearchValue,
    autoClearSearchValue = _props$autoClearSearc === void 0 ? true : _props$autoClearSearc,
    filterTreeNode = props.filterTreeNode,
    _props$treeNodeFilter = props.treeNodeFilterProp,
    treeNodeFilterProp = _props$treeNodeFilter === void 0 ? 'value' : _props$treeNodeFilter,
    showCheckedStrategy = props.showCheckedStrategy,
    treeNodeLabelProp = props.treeNodeLabelProp,
    multiple = props.multiple,
    treeCheckable = props.treeCheckable,
    treeCheckStrictly = props.treeCheckStrictly,
    labelInValue = props.labelInValue,
    maxCount = props.maxCount,
    fieldNames = props.fieldNames,
    treeDataSimpleMode = props.treeDataSimpleMode,
    treeData = props.treeData,
    children = props.children,
    loadData = props.loadData,
    treeLoadedKeys = props.treeLoadedKeys,
    onTreeLoad = props.onTreeLoad,
    treeDefaultExpandAll = props.treeDefaultExpandAll,
    treeExpandedKeys = props.treeExpandedKeys,
    treeDefaultExpandedKeys = props.treeDefaultExpandedKeys,
    onTreeExpand = props.onTreeExpand,
    treeExpandAction = props.treeExpandAction,
    virtual = props.virtual,
    _props$listHeight = props.listHeight,
    listHeight = _props$listHeight === void 0 ? 200 : _props$listHeight,
    _props$listItemHeight = props.listItemHeight,
    listItemHeight = _props$listItemHeight === void 0 ? 20 : _props$listItemHeight,
    _props$listItemScroll = props.listItemScrollOffset,
    listItemScrollOffset = _props$listItemScroll === void 0 ? 0 : _props$listItemScroll,
    onDropdownVisibleChange = props.onDropdownVisibleChange,
    _props$dropdownMatchS = props.dropdownMatchSelectWidth,
    dropdownMatchSelectWidth = _props$dropdownMatchS === void 0 ? true : _props$dropdownMatchS,
    treeLine = props.treeLine,
    treeIcon = props.treeIcon,
    showTreeIcon = props.showTreeIcon,
    switcherIcon = props.switcherIcon,
    treeMotion = props.treeMotion,
    treeTitleRender = props.treeTitleRender,
    onPopupScroll = props.onPopupScroll,
    restProps = (0,objectWithoutProperties/* default */.Z)(props, TreeSelect_excluded);
  var mergedId = (0,es_hooks_useId/* default */.ZP)(id);
  var treeConduction = treeCheckable && !treeCheckStrictly;
  var mergedCheckable = treeCheckable || treeCheckStrictly;
  var mergedLabelInValue = treeCheckStrictly || labelInValue;
  var mergedMultiple = mergedCheckable || multiple;
  var _useMergedState = (0,useMergedState/* default */.Z)(defaultValue, {
      value: value
    }),
    _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
    internalValue = _useMergedState2[0],
    setInternalValue = _useMergedState2[1];

  // `multiple` && `!treeCheckable` should be show all
  var mergedShowCheckedStrategy = react.useMemo(function () {
    if (!treeCheckable) {
      return SHOW_ALL;
    }
    return showCheckedStrategy || strategyUtil_SHOW_CHILD;
  }, [showCheckedStrategy, treeCheckable]);

  // ========================== Warning ===========================
  if (false) {}

  // ========================= FieldNames =========================
  var mergedFieldNames = react.useMemo(function () {
    return valueUtil_fillFieldNames(fieldNames);
  }, /* eslint-disable react-hooks/exhaustive-deps */
  [JSON.stringify(fieldNames)]
  /* eslint-enable react-hooks/exhaustive-deps */);

  // =========================== Search ===========================
  var _useMergedState3 = (0,useMergedState/* default */.Z)('', {
      value: searchValue !== undefined ? searchValue : inputValue,
      postState: function postState(search) {
        return search || '';
      }
    }),
    _useMergedState4 = (0,slicedToArray/* default */.Z)(_useMergedState3, 2),
    mergedSearchValue = _useMergedState4[0],
    setSearchValue = _useMergedState4[1];
  var onInternalSearch = function onInternalSearch(searchText) {
    setSearchValue(searchText);
    onSearch === null || onSearch === void 0 || onSearch(searchText);
  };

  // ============================ Data ============================
  // `useTreeData` only do convert of `children` or `simpleMode`.
  // Else will return origin `treeData` for perf consideration.
  // Do not do anything to loop the data.
  var mergedTreeData = useTreeData(treeData, children, treeDataSimpleMode);
  var _useDataEntities = useDataEntities(mergedTreeData, mergedFieldNames),
    keyEntities = _useDataEntities.keyEntities,
    valueEntities = _useDataEntities.valueEntities;

  /** Get `missingRawValues` which not exist in the tree yet */
  var splitRawValues = react.useCallback(function (newRawValues) {
    var missingRawValues = [];
    var existRawValues = [];

    // Keep missing value in the cache
    newRawValues.forEach(function (val) {
      if (valueEntities.has(val)) {
        existRawValues.push(val);
      } else {
        missingRawValues.push(val);
      }
    });
    return {
      missingRawValues: missingRawValues,
      existRawValues: existRawValues
    };
  }, [valueEntities]);

  // Filtered Tree
  var filteredTreeData = hooks_useFilterTreeData(mergedTreeData, mergedSearchValue, {
    fieldNames: mergedFieldNames,
    treeNodeFilterProp: treeNodeFilterProp,
    filterTreeNode: filterTreeNode
  });

  // =========================== Label ============================
  var getLabel = react.useCallback(function (item) {
    if (item) {
      if (treeNodeLabelProp) {
        return item[treeNodeLabelProp];
      }

      // Loop from fieldNames
      var titleList = mergedFieldNames._title;
      for (var i = 0; i < titleList.length; i += 1) {
        var title = item[titleList[i]];
        if (title !== undefined) {
          return title;
        }
      }
    }
  }, [mergedFieldNames, treeNodeLabelProp]);

  // ========================= Wrap Value =========================
  var toLabeledValues = react.useCallback(function (draftValues) {
    var values = valueUtil_toArray(draftValues);
    return values.map(function (val) {
      if (isRawValue(val)) {
        return {
          value: val
        };
      }
      return val;
    });
  }, []);
  var convert2LabelValues = react.useCallback(function (draftValues) {
    var values = toLabeledValues(draftValues);
    return values.map(function (item) {
      var rawLabel = item.label;
      var rawValue = item.value,
        rawHalfChecked = item.halfChecked;
      var rawDisabled;
      var entity = valueEntities.get(rawValue);

      // Fill missing label & status
      if (entity) {
        var _rawLabel;
        rawLabel = treeTitleRender ? treeTitleRender(entity.node) : (_rawLabel = rawLabel) !== null && _rawLabel !== void 0 ? _rawLabel : getLabel(entity.node);
        rawDisabled = entity.node.disabled;
      } else if (rawLabel === undefined) {
        // We try to find in current `labelInValue` value
        var labelInValueItem = toLabeledValues(internalValue).find(function (labeledItem) {
          return labeledItem.value === rawValue;
        });
        rawLabel = labelInValueItem.label;
      }
      return {
        label: rawLabel,
        value: rawValue,
        halfChecked: rawHalfChecked,
        disabled: rawDisabled
      };
    });
  }, [valueEntities, getLabel, toLabeledValues, internalValue]);

  // =========================== Values ===========================
  var rawMixedLabeledValues = react.useMemo(function () {
    return toLabeledValues(internalValue === null ? [] : internalValue);
  }, [toLabeledValues, internalValue]);

  // Split value into full check and half check
  var _React$useMemo = react.useMemo(function () {
      var fullCheckValues = [];
      var halfCheckValues = [];
      rawMixedLabeledValues.forEach(function (item) {
        if (item.halfChecked) {
          halfCheckValues.push(item);
        } else {
          fullCheckValues.push(item);
        }
      });
      return [fullCheckValues, halfCheckValues];
    }, [rawMixedLabeledValues]),
    _React$useMemo2 = (0,slicedToArray/* default */.Z)(_React$useMemo, 2),
    rawLabeledValues = _React$useMemo2[0],
    rawHalfLabeledValues = _React$useMemo2[1];

  // const [mergedValues] = useCache(rawLabeledValues);
  var rawValues = react.useMemo(function () {
    return rawLabeledValues.map(function (item) {
      return item.value;
    });
  }, [rawLabeledValues]);

  // Convert value to key. Will fill missed keys for conduct check.
  var _useCheckedKeys = hooks_useCheckedKeys(rawLabeledValues, rawHalfLabeledValues, treeConduction, keyEntities),
    _useCheckedKeys2 = (0,slicedToArray/* default */.Z)(_useCheckedKeys, 2),
    rawCheckedValues = _useCheckedKeys2[0],
    rawHalfCheckedValues = _useCheckedKeys2[1];

  // Convert rawCheckedKeys to check strategy related values
  var displayValues = react.useMemo(function () {
    // Collect keys which need to show
    var displayKeys = strategyUtil_formatStrategyValues(rawCheckedValues, mergedShowCheckedStrategy, keyEntities, mergedFieldNames);

    // Convert to value and filled with label
    var values = displayKeys.map(function (key) {
      var _keyEntities$key$node, _keyEntities$key;
      return (_keyEntities$key$node = (_keyEntities$key = keyEntities[key]) === null || _keyEntities$key === void 0 || (_keyEntities$key = _keyEntities$key.node) === null || _keyEntities$key === void 0 ? void 0 : _keyEntities$key[mergedFieldNames.value]) !== null && _keyEntities$key$node !== void 0 ? _keyEntities$key$node : key;
    });

    // Back fill with origin label
    var labeledValues = values.map(function (val) {
      var targetItem = rawLabeledValues.find(function (item) {
        return item.value === val;
      });
      var label = labelInValue ? targetItem === null || targetItem === void 0 ? void 0 : targetItem.label : treeTitleRender === null || treeTitleRender === void 0 ? void 0 : treeTitleRender(targetItem);
      return {
        value: val,
        label: label
      };
    });
    var rawDisplayValues = convert2LabelValues(labeledValues);
    var firstVal = rawDisplayValues[0];
    if (!mergedMultiple && firstVal && isNil(firstVal.value) && isNil(firstVal.label)) {
      return [];
    }
    return rawDisplayValues.map(function (item) {
      var _item$label;
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, item), {}, {
        label: (_item$label = item.label) !== null && _item$label !== void 0 ? _item$label : item.value
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mergedFieldNames, mergedMultiple, rawCheckedValues, rawLabeledValues, convert2LabelValues, mergedShowCheckedStrategy, keyEntities]);
  var _useCache = useCache(displayValues),
    _useCache2 = (0,slicedToArray/* default */.Z)(_useCache, 1),
    cachedDisplayValues = _useCache2[0];

  // ========================== MaxCount ==========================
  var mergedMaxCount = react.useMemo(function () {
    if (mergedMultiple && (mergedShowCheckedStrategy === 'SHOW_CHILD' || treeCheckStrictly || !treeCheckable)) {
      return maxCount;
    }
    return null;
  }, [maxCount, mergedMultiple, treeCheckStrictly, mergedShowCheckedStrategy, treeCheckable]);

  // =========================== Change ===========================
  var triggerChange = useRefFunc(function (newRawValues, extra, source) {
    var formattedKeyList = strategyUtil_formatStrategyValues(newRawValues, mergedShowCheckedStrategy, keyEntities, mergedFieldNames);

    // Not allow pass with `maxCount`
    if (mergedMaxCount && formattedKeyList.length > mergedMaxCount) {
      return;
    }
    var labeledValues = convert2LabelValues(newRawValues);
    setInternalValue(labeledValues);

    // Clean up if needed
    if (autoClearSearchValue) {
      setSearchValue('');
    }

    // Generate rest parameters is costly, so only do it when necessary
    if (onChange) {
      var eventValues = newRawValues;
      if (treeConduction) {
        eventValues = formattedKeyList.map(function (key) {
          var entity = valueEntities.get(key);
          return entity ? entity.node[mergedFieldNames.value] : key;
        });
      }
      var _ref = extra || {
          triggerValue: undefined,
          selected: undefined
        },
        triggerValue = _ref.triggerValue,
        selected = _ref.selected;
      var returnRawValues = eventValues;

      // We need fill half check back
      if (treeCheckStrictly) {
        var halfValues = rawHalfLabeledValues.filter(function (item) {
          return !eventValues.includes(item.value);
        });
        returnRawValues = [].concat((0,toConsumableArray/* default */.Z)(returnRawValues), (0,toConsumableArray/* default */.Z)(halfValues));
      }
      var returnLabeledValues = convert2LabelValues(returnRawValues);
      var additionalInfo = {
        // [Legacy] Always return as array contains label & value
        preValue: rawLabeledValues,
        triggerValue: triggerValue
      };

      // [Legacy] Fill legacy data if user query.
      // This is expansive that we only fill when user query
      // https://github.com/react-component/tree-select/blob/fe33eb7c27830c9ac70cd1fdb1ebbe7bc679c16a/src/Select.jsx
      var showPosition = true;
      if (treeCheckStrictly || source === 'selection' && !selected) {
        showPosition = false;
      }
      fillAdditionalInfo(additionalInfo, triggerValue, newRawValues, mergedTreeData, showPosition, mergedFieldNames);
      if (mergedCheckable) {
        additionalInfo.checked = selected;
      } else {
        additionalInfo.selected = selected;
      }
      var returnValues = mergedLabelInValue ? returnLabeledValues : returnLabeledValues.map(function (item) {
        return item.value;
      });
      onChange(mergedMultiple ? returnValues : returnValues[0], mergedLabelInValue ? null : returnLabeledValues.map(function (item) {
        return item.label;
      }), additionalInfo);
    }
  });

  // ========================== Options ===========================
  /** Trigger by option list */
  var onOptionSelect = react.useCallback(function (selectedKey, _ref2) {
    var _node$mergedFieldName;
    var selected = _ref2.selected,
      source = _ref2.source;
    var entity = keyEntities[selectedKey];
    var node = entity === null || entity === void 0 ? void 0 : entity.node;
    var selectedValue = (_node$mergedFieldName = node === null || node === void 0 ? void 0 : node[mergedFieldNames.value]) !== null && _node$mergedFieldName !== void 0 ? _node$mergedFieldName : selectedKey;

    // Never be falsy but keep it safe
    if (!mergedMultiple) {
      // Single mode always set value
      triggerChange([selectedValue], {
        selected: true,
        triggerValue: selectedValue
      }, 'option');
    } else {
      var newRawValues = selected ? [].concat((0,toConsumableArray/* default */.Z)(rawValues), [selectedValue]) : rawCheckedValues.filter(function (v) {
        return v !== selectedValue;
      });

      // Add keys if tree conduction
      if (treeConduction) {
        // Should keep missing values
        var _splitRawValues = splitRawValues(newRawValues),
          missingRawValues = _splitRawValues.missingRawValues,
          existRawValues = _splitRawValues.existRawValues;
        var keyList = existRawValues.map(function (val) {
          return valueEntities.get(val).key;
        });

        // Conduction by selected or not
        var checkedKeys;
        if (selected) {
          var _conductCheck = (0,conductUtil/* conductCheck */.S)(keyList, true, keyEntities);
          checkedKeys = _conductCheck.checkedKeys;
        } else {
          var _conductCheck2 = (0,conductUtil/* conductCheck */.S)(keyList, {
            checked: false,
            halfCheckedKeys: rawHalfCheckedValues
          }, keyEntities);
          checkedKeys = _conductCheck2.checkedKeys;
        }

        // Fill back of keys
        newRawValues = [].concat((0,toConsumableArray/* default */.Z)(missingRawValues), (0,toConsumableArray/* default */.Z)(checkedKeys.map(function (key) {
          return keyEntities[key].node[mergedFieldNames.value];
        })));
      }
      triggerChange(newRawValues, {
        selected: selected,
        triggerValue: selectedValue
      }, source || 'option');
    }

    // Trigger select event
    if (selected || !mergedMultiple) {
      onSelect === null || onSelect === void 0 || onSelect(selectedValue, fillLegacyProps(node));
    } else {
      onDeselect === null || onDeselect === void 0 || onDeselect(selectedValue, fillLegacyProps(node));
    }
  }, [splitRawValues, valueEntities, keyEntities, mergedFieldNames, mergedMultiple, rawValues, triggerChange, treeConduction, onSelect, onDeselect, rawCheckedValues, rawHalfCheckedValues, maxCount]);

  // ========================== Dropdown ==========================
  var onInternalDropdownVisibleChange = react.useCallback(function (open) {
    if (onDropdownVisibleChange) {
      var legacyParam = {};
      Object.defineProperty(legacyParam, 'documentClickClose', {
        get: function get() {
          (0,es_warning/* default */.ZP)(false, 'Second param of `onDropdownVisibleChange` has been removed.');
          return false;
        }
      });
      onDropdownVisibleChange(open, legacyParam);
    }
  }, [onDropdownVisibleChange]);

  // ====================== Display Change ========================
  var onDisplayValuesChange = useRefFunc(function (newValues, info) {
    var newRawValues = newValues.map(function (item) {
      return item.value;
    });
    if (info.type === 'clear') {
      triggerChange(newRawValues, {}, 'selection');
      return;
    }

    // TreeSelect only have multiple mode which means display change only has remove
    if (info.values.length) {
      onOptionSelect(info.values[0].value, {
        selected: false,
        source: 'selection'
      });
    }
  });

  // ========================== Context ===========================
  var treeSelectContext = react.useMemo(function () {
    return {
      virtual: virtual,
      dropdownMatchSelectWidth: dropdownMatchSelectWidth,
      listHeight: listHeight,
      listItemHeight: listItemHeight,
      listItemScrollOffset: listItemScrollOffset,
      treeData: filteredTreeData,
      fieldNames: mergedFieldNames,
      onSelect: onOptionSelect,
      treeExpandAction: treeExpandAction,
      treeTitleRender: treeTitleRender,
      onPopupScroll: onPopupScroll,
      leftMaxCount: maxCount === undefined ? null : maxCount - cachedDisplayValues.length,
      leafCountOnly: mergedShowCheckedStrategy === 'SHOW_CHILD' && !treeCheckStrictly && !!treeCheckable,
      valueEntities: valueEntities
    };
  }, [virtual, dropdownMatchSelectWidth, listHeight, listItemHeight, listItemScrollOffset, filteredTreeData, mergedFieldNames, onOptionSelect, treeExpandAction, treeTitleRender, onPopupScroll, maxCount, cachedDisplayValues.length, mergedShowCheckedStrategy, treeCheckStrictly, treeCheckable, valueEntities]);

  // ======================= Legacy Context =======================
  var legacyContext = react.useMemo(function () {
    return {
      checkable: mergedCheckable,
      loadData: loadData,
      treeLoadedKeys: treeLoadedKeys,
      onTreeLoad: onTreeLoad,
      checkedKeys: rawCheckedValues,
      halfCheckedKeys: rawHalfCheckedValues,
      treeDefaultExpandAll: treeDefaultExpandAll,
      treeExpandedKeys: treeExpandedKeys,
      treeDefaultExpandedKeys: treeDefaultExpandedKeys,
      onTreeExpand: onTreeExpand,
      treeIcon: treeIcon,
      treeMotion: treeMotion,
      showTreeIcon: showTreeIcon,
      switcherIcon: switcherIcon,
      treeLine: treeLine,
      treeNodeFilterProp: treeNodeFilterProp,
      keyEntities: keyEntities
    };
  }, [mergedCheckable, loadData, treeLoadedKeys, onTreeLoad, rawCheckedValues, rawHalfCheckedValues, treeDefaultExpandAll, treeExpandedKeys, treeDefaultExpandedKeys, onTreeExpand, treeIcon, treeMotion, showTreeIcon, switcherIcon, treeLine, treeNodeFilterProp, keyEntities]);

  // =========================== Render ===========================
  return /*#__PURE__*/react.createElement(es_TreeSelectContext.Provider, {
    value: treeSelectContext
  }, /*#__PURE__*/react.createElement(LegacyContext.Provider, {
    value: legacyContext
  }, /*#__PURE__*/react.createElement(rc_select_es/* BaseSelect */.Ac, (0,esm_extends/* default */.Z)({
    ref: ref
  }, restProps, {
    // >>> MISC
    id: mergedId,
    prefixCls: prefixCls,
    mode: mergedMultiple ? 'multiple' : undefined
    // >>> Display Value
    ,

    displayValues: cachedDisplayValues,
    onDisplayValuesChange: onDisplayValuesChange
    // >>> Search
    ,

    searchValue: mergedSearchValue,
    onSearch: onInternalSearch
    // >>> Options
    ,

    OptionList: es_OptionList,
    emptyOptions: !mergedTreeData.length,
    onDropdownVisibleChange: onInternalDropdownVisibleChange,
    dropdownMatchSelectWidth: dropdownMatchSelectWidth
  }))));
});

// Assign name for Debug
if (false) {}
var GenericTreeSelect = TreeSelect;
GenericTreeSelect.TreeNode = es_TreeNode;
GenericTreeSelect.SHOW_ALL = SHOW_ALL;
GenericTreeSelect.SHOW_PARENT = strategyUtil_SHOW_PARENT;
GenericTreeSelect.SHOW_CHILD = strategyUtil_SHOW_CHILD;
/* harmony default export */ var es_TreeSelect = (GenericTreeSelect);
;// CONCATENATED MODULE: ./node_modules/rc-tree-select/es/index.js




/* harmony default export */ var rc_tree_select_es = (es_TreeSelect);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tree-select/style/index.js




// =============================== Base ===============================
const tree_select_style_genBaseStyle = token => {
  const {
    componentCls,
    treePrefixCls,
    colorBgElevated
  } = token;
  const treeCls = `.${treePrefixCls}`;
  return [
  // ======================================================
  // ==                     Dropdown                     ==
  // ======================================================
  {
    [`${componentCls}-dropdown`]: [{
      padding: `${(0,cssinjs_es/* unit */.bf)(token.paddingXS)} ${(0,cssinjs_es/* unit */.bf)(token.calc(token.paddingXS).div(2).equal())}`
    },
    // ====================== Tree ======================
    genTreeStyle(treePrefixCls, (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
      colorBgContainer: colorBgElevated
    }), false), {
      [treeCls]: {
        borderRadius: 0,
        [`${treeCls}-list-holder-inner`]: {
          alignItems: 'stretch',
          [`${treeCls}-treenode`]: {
            [`${treeCls}-node-content-wrapper`]: {
              flex: 'auto'
            }
          }
        }
      }
    },
    // ==================== Checkbox ====================
    style_getStyle(`${treePrefixCls}-checkbox`, token),
    // ====================== RTL =======================
    {
      '&-rtl': {
        direction: 'rtl',
        [`${treeCls}-switcher${treeCls}-switcher_close`]: {
          [`${treeCls}-switcher-icon svg`]: {
            transform: 'rotate(90deg)'
          }
        }
      }
    }]
  }];
};
const tree_select_style_prepareComponentToken = (/* unused pure expression or super */ null && (initComponentToken));
// ============================== Export ==============================
function useTreeSelectStyle(prefixCls, treePrefixCls, rootCls) {
  return genStyleHooks('TreeSelect', token => {
    const treeSelectToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
      treePrefixCls
    });
    return tree_select_style_genBaseStyle(treeSelectToken);
  }, style_initComponentToken)(prefixCls, rootCls);
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/tree-select/index.js
"use client";

var tree_select_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


























const InternalTreeSelect = (props, ref) => {
  var _a, _b, _c, _d, _e;
  const {
      prefixCls: customizePrefixCls,
      size: customizeSize,
      disabled: customDisabled,
      bordered = true,
      style,
      className,
      rootClassName,
      treeCheckable,
      multiple,
      listHeight = 256,
      listItemHeight: customListItemHeight,
      placement,
      notFoundContent,
      switcherIcon,
      treeLine,
      getPopupContainer,
      popupClassName,
      dropdownClassName,
      treeIcon = false,
      transitionName,
      choiceTransitionName = '',
      status: customStatus,
      treeExpandAction,
      builtinPlacements,
      dropdownMatchSelectWidth,
      popupMatchSelectWidth,
      allowClear,
      variant: customVariant,
      dropdownStyle,
      dropdownRender,
      popupRender,
      onDropdownVisibleChange,
      onOpenChange,
      tagRender,
      maxCount,
      showCheckedStrategy,
      treeCheckStrictly,
      styles,
      classNames
    } = props,
    restProps = tree_select_rest(props, ["prefixCls", "size", "disabled", "bordered", "style", "className", "rootClassName", "treeCheckable", "multiple", "listHeight", "listItemHeight", "placement", "notFoundContent", "switcherIcon", "treeLine", "getPopupContainer", "popupClassName", "dropdownClassName", "treeIcon", "transitionName", "choiceTransitionName", "status", "treeExpandAction", "builtinPlacements", "dropdownMatchSelectWidth", "popupMatchSelectWidth", "allowClear", "variant", "dropdownStyle", "dropdownRender", "popupRender", "onDropdownVisibleChange", "onOpenChange", "tagRender", "maxCount", "showCheckedStrategy", "treeCheckStrictly", "styles", "classNames"]);
  const {
    getPopupContainer: getContextPopupContainer,
    getPrefixCls,
    renderEmpty,
    direction,
    virtual,
    popupMatchSelectWidth: contextPopupMatchSelectWidth,
    popupOverflow
  } = react.useContext(ConfigContext);
  const {
    styles: contextStyles,
    classNames: contextClassNames
  } = useComponentConfig('treeSelect');
  const [, token] = useToken();
  const listItemHeight = customListItemHeight !== null && customListItemHeight !== void 0 ? customListItemHeight : (token === null || token === void 0 ? void 0 : token.controlHeightSM) + (token === null || token === void 0 ? void 0 : token.paddingXXS);
  if (false) {}
  const rootPrefixCls = getPrefixCls();
  const prefixCls = getPrefixCls('select', customizePrefixCls);
  const treePrefixCls = getPrefixCls('select-tree', customizePrefixCls);
  const treeSelectPrefixCls = getPrefixCls('tree-select', customizePrefixCls);
  const {
    compactSize,
    compactItemClassnames
  } = useCompactItemContext(prefixCls, direction);
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const treeSelectRootCls = hooks_useCSSVarCls(treeSelectPrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = select_style(prefixCls, rootCls);
  const [treeSelectWrapCSSVar] = useTreeSelectStyle(treeSelectPrefixCls, treePrefixCls, treeSelectRootCls);
  const [variant, enableVariantCls] = useVariants('treeSelect', customVariant, bordered);
  const mergedPopupClassName = classnames_default()(((_a = classNames === null || classNames === void 0 ? void 0 : classNames.popup) === null || _a === void 0 ? void 0 : _a.root) || ((_b = contextClassNames === null || contextClassNames === void 0 ? void 0 : contextClassNames.popup) === null || _b === void 0 ? void 0 : _b.root) || popupClassName || dropdownClassName, `${treeSelectPrefixCls}-dropdown`, {
    [`${treeSelectPrefixCls}-dropdown-rtl`]: direction === 'rtl'
  }, rootClassName, contextClassNames.root, classNames === null || classNames === void 0 ? void 0 : classNames.root, cssVarCls, rootCls, treeSelectRootCls, hashId);
  const mergedPopupStyle = ((_c = styles === null || styles === void 0 ? void 0 : styles.popup) === null || _c === void 0 ? void 0 : _c.root) || ((_d = contextStyles === null || contextStyles === void 0 ? void 0 : contextStyles.popup) === null || _d === void 0 ? void 0 : _d.root) || dropdownStyle;
  const mergedPopupRender = select_usePopupRender(popupRender || dropdownRender);
  const mergedOnOpenChange = onOpenChange || onDropdownVisibleChange;
  const isMultiple = !!(treeCheckable || multiple);
  const mergedMaxCount = react.useMemo(() => {
    if (maxCount && (showCheckedStrategy === 'SHOW_ALL' && !treeCheckStrictly || showCheckedStrategy === 'SHOW_PARENT')) {
      return undefined;
    }
    return maxCount;
  }, [maxCount, showCheckedStrategy, treeCheckStrictly]);
  const showSuffixIcon = useShowArrow(props.suffixIcon, props.showArrow);
  const mergedPopupMatchSelectWidth = (_e = popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth) !== null && _e !== void 0 ? _e : contextPopupMatchSelectWidth;
  // ===================== Form =====================
  const {
    status: contextStatus,
    hasFeedback,
    isFormItemInput,
    feedbackIcon
  } = react.useContext(FormItemInputContext);
  const mergedStatus = getMergedStatus(contextStatus, customStatus);
  // ===================== Icons =====================
  const {
    suffixIcon,
    removeIcon,
    clearIcon
  } = useIcons(Object.assign(Object.assign({}, restProps), {
    multiple: isMultiple,
    showSuffixIcon,
    hasFeedback,
    feedbackIcon,
    prefixCls,
    componentName: 'TreeSelect'
  }));
  const mergedAllowClear = allowClear === true ? {
    clearIcon
  } : allowClear;
  // ===================== Empty =====================
  let mergedNotFound;
  if (notFoundContent !== undefined) {
    mergedNotFound = notFoundContent;
  } else {
    mergedNotFound = (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty('Select')) || /*#__PURE__*/react.createElement(defaultRenderEmpty, {
      componentName: "Select"
    });
  }
  // ==================== Render =====================
  const selectProps = (0,omit/* default */.Z)(restProps, ['suffixIcon', 'removeIcon', 'clearIcon', 'itemIcon', 'switcherIcon', 'style']);
  // ===================== Placement =====================
  const memoizedPlacement = react.useMemo(() => {
    if (placement !== undefined) {
      return placement;
    }
    return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
  }, [placement, direction]);
  const mergedSize = hooks_useSize(ctx => {
    var _a;
    return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
  });
  // ===================== Disabled =====================
  const disabled = react.useContext(config_provider_DisabledContext);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  const mergedClassName = classnames_default()(!customizePrefixCls && treeSelectPrefixCls, {
    [`${prefixCls}-lg`]: mergedSize === 'large',
    [`${prefixCls}-sm`]: mergedSize === 'small',
    [`${prefixCls}-rtl`]: direction === 'rtl',
    [`${prefixCls}-${variant}`]: enableVariantCls,
    [`${prefixCls}-in-form-item`]: isFormItemInput
  }, getStatusClassNames(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, className, rootClassName, contextClassNames.root, classNames === null || classNames === void 0 ? void 0 : classNames.root, cssVarCls, rootCls, treeSelectRootCls, hashId);
  const renderSwitcherIcon = nodeProps => (/*#__PURE__*/react.createElement(iconUtil, {
    prefixCls: treePrefixCls,
    switcherIcon: switcherIcon,
    treeNodeProps: nodeProps,
    showLine: treeLine
  }));
  // ============================ zIndex ============================
  const [zIndex] = useZIndex('SelectLike', mergedPopupStyle === null || mergedPopupStyle === void 0 ? void 0 : mergedPopupStyle.zIndex);
  const returnNode = /*#__PURE__*/react.createElement(rc_tree_select_es, Object.assign({
    virtual: virtual,
    disabled: mergedDisabled
  }, selectProps, {
    dropdownMatchSelectWidth: mergedPopupMatchSelectWidth,
    builtinPlacements: select_mergedBuiltinPlacements(builtinPlacements, popupOverflow),
    ref: ref,
    prefixCls: prefixCls,
    className: mergedClassName,
    style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.root), style),
    listHeight: listHeight,
    listItemHeight: listItemHeight,
    treeCheckable: treeCheckable ? /*#__PURE__*/react.createElement("span", {
      className: `${prefixCls}-tree-checkbox-inner`
    }) : treeCheckable,
    treeLine: !!treeLine,
    suffixIcon: suffixIcon,
    multiple: isMultiple,
    placement: memoizedPlacement,
    removeIcon: removeIcon,
    allowClear: mergedAllowClear,
    switcherIcon: renderSwitcherIcon,
    showTreeIcon: treeIcon,
    notFoundContent: mergedNotFound,
    getPopupContainer: getPopupContainer || getContextPopupContainer,
    treeMotion: null,
    dropdownClassName: mergedPopupClassName,
    dropdownStyle: Object.assign(Object.assign({}, mergedPopupStyle), {
      zIndex
    }),
    dropdownRender: mergedPopupRender,
    onDropdownVisibleChange: mergedOnOpenChange,
    choiceTransitionName: getTransitionName(rootPrefixCls, '', choiceTransitionName),
    transitionName: getTransitionName(rootPrefixCls, 'slide-up', transitionName),
    treeExpandAction: treeExpandAction,
    tagRender: isMultiple ? tagRender : undefined,
    maxCount: mergedMaxCount,
    showCheckedStrategy: showCheckedStrategy,
    treeCheckStrictly: treeCheckStrictly
  }));
  return wrapCSSVar(treeSelectWrapCSSVar(returnNode));
};
const TreeSelectRef = /*#__PURE__*/react.forwardRef(InternalTreeSelect);
const tree_select_TreeSelect = TreeSelectRef;
// We don't care debug panel
/* istanbul ignore next */
const tree_select_PurePanel = _util_PurePanel(tree_select_TreeSelect, 'dropdownAlign', props => (0,omit/* default */.Z)(props, ['visible']));
tree_select_TreeSelect.TreeNode = es_TreeNode;
tree_select_TreeSelect.SHOW_ALL = SHOW_ALL;
tree_select_TreeSelect.SHOW_PARENT = strategyUtil_SHOW_PARENT;
tree_select_TreeSelect.SHOW_CHILD = strategyUtil_SHOW_CHILD;
tree_select_TreeSelect._InternalPanelDoNotUseOrYouWillBeFired = tree_select_PurePanel;
if (false) {}

/* harmony default export */ var tree_select = (tree_select_TreeSelect);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/EditOutlined.js + 1 modules
var EditOutlined = __webpack_require__(46835);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/styleChecker.js
var styleChecker = __webpack_require__(40393);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/EnterOutlined.js + 1 modules
var EnterOutlined = __webpack_require__(54315);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/typography/style/mixins.js
/*
.typography-title(@fontSize; @fontWeight; @lineHeight; @headingColor; @headingMarginBottom;) {
 margin-bottom: @headingMarginBottom;
 color: @headingColor;
 font-weight: @fontWeight;
 fontSize: @fontSize;
 line-height: @lineHeight;
}
*/



const getTitleStyle = (fontSize, lineHeight, color, token) => {
  const {
    titleMarginBottom,
    fontWeightStrong
  } = token;
  return {
    marginBottom: titleMarginBottom,
    color,
    fontWeight: fontWeightStrong,
    fontSize,
    lineHeight
  };
};
const getTitleStyles = token => {
  const headings = [1, 2, 3, 4, 5];
  const styles = {};
  headings.forEach(headingLevel => {
    styles[`
      h${headingLevel}&,
      div&-h${headingLevel},
      div&-h${headingLevel} > textarea,
      h${headingLevel}
    `] = getTitleStyle(token[`fontSizeHeading${headingLevel}`], token[`lineHeightHeading${headingLevel}`], token.colorTextHeading, token);
  });
  return styles;
};
const getLinkStyles = token => {
  const {
    componentCls
  } = token;
  return {
    'a&, a': Object.assign(Object.assign({}, operationUnit(token)), {
      userSelect: 'text',
      [`&[disabled], &${componentCls}-disabled`]: {
        color: token.colorTextDisabled,
        cursor: 'not-allowed',
        '&:active, &:hover': {
          color: token.colorTextDisabled
        },
        '&:active': {
          pointerEvents: 'none'
        }
      }
    })
  };
};
const getResetStyles = token => ({
  code: {
    margin: '0 0.2em',
    paddingInline: '0.4em',
    paddingBlock: '0.2em 0.1em',
    fontSize: '85%',
    fontFamily: token.fontFamilyCode,
    background: 'rgba(150, 150, 150, 0.1)',
    border: '1px solid rgba(100, 100, 100, 0.2)',
    borderRadius: 3
  },
  kbd: {
    margin: '0 0.2em',
    paddingInline: '0.4em',
    paddingBlock: '0.15em 0.1em',
    fontSize: '90%',
    fontFamily: token.fontFamilyCode,
    background: 'rgba(150, 150, 150, 0.06)',
    border: '1px solid rgba(100, 100, 100, 0.2)',
    borderBottomWidth: 2,
    borderRadius: 3
  },
  mark: {
    padding: 0,
    // FIXME hardcode in v4
    backgroundColor: colors_es/* gold.2 */.EV[2]
  },
  'u, ins': {
    textDecoration: 'underline',
    textDecorationSkipInk: 'auto'
  },
  's, del': {
    textDecoration: 'line-through'
  },
  strong: {
    fontWeight: token.fontWeightStrong
  },
  // list
  'ul, ol': {
    marginInline: 0,
    marginBlock: '0 1em',
    padding: 0,
    li: {
      marginInline: '20px 0',
      marginBlock: 0,
      paddingInline: '4px 0',
      paddingBlock: 0
    }
  },
  ul: {
    listStyleType: 'circle',
    ul: {
      listStyleType: 'disc'
    }
  },
  ol: {
    listStyleType: 'decimal'
  },
  // pre & block
  'pre, blockquote': {
    margin: '1em 0'
  },
  pre: {
    padding: '0.4em 0.6em',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    background: 'rgba(150, 150, 150, 0.1)',
    border: '1px solid rgba(100, 100, 100, 0.2)',
    borderRadius: 3,
    fontFamily: token.fontFamilyCode,
    // Compatible for marked
    code: {
      display: 'inline',
      margin: 0,
      padding: 0,
      fontSize: 'inherit',
      fontFamily: 'inherit',
      background: 'transparent',
      border: 0
    }
  },
  blockquote: {
    paddingInline: '0.6em 0',
    paddingBlock: 0,
    borderInlineStart: '4px solid rgba(100, 100, 100, 0.2)',
    opacity: 0.85
  }
});
const getEditableStyles = token => {
  const {
    componentCls,
    paddingSM
  } = token;
  const inputShift = paddingSM;
  return {
    '&-edit-content': {
      position: 'relative',
      'div&': {
        insetInlineStart: token.calc(token.paddingSM).mul(-1).equal(),
        marginTop: token.calc(inputShift).mul(-1).equal(),
        marginBottom: `calc(1em - ${(0,cssinjs_es/* unit */.bf)(inputShift)})`
      },
      [`${componentCls}-edit-content-confirm`]: {
        position: 'absolute',
        insetInlineEnd: token.calc(token.marginXS).add(2).equal(),
        insetBlockEnd: token.marginXS,
        color: token.colorIcon,
        // default style
        fontWeight: 'normal',
        fontSize: token.fontSize,
        fontStyle: 'normal',
        pointerEvents: 'none'
      },
      textarea: {
        margin: '0!important',
        // Fix Editable Textarea flash in Firefox
        MozTransition: 'none',
        height: '1em'
      }
    }
  };
};
const getCopyableStyles = token => ({
  [`${token.componentCls}-copy-success`]: {
    [`
    &,
    &:hover,
    &:focus`]: {
      color: token.colorSuccess
    }
  },
  [`${token.componentCls}-copy-icon-only`]: {
    marginInlineStart: 0
  }
});
const getEllipsisStyles = () => ({
  [`
  a&-ellipsis,
  span&-ellipsis
  `]: {
    display: 'inline-block',
    maxWidth: '100%'
  },
  '&-ellipsis-single-line': {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // https://blog.csdn.net/iefreer/article/details/50421025
    'a&, span&': {
      verticalAlign: 'bottom'
    },
    '> code': {
      paddingBlock: 0,
      maxWidth: 'calc(100% - 1.2em)',
      display: 'inline-block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      verticalAlign: 'bottom',
      // https://github.com/ant-design/ant-design/issues/45953
      boxSizing: 'content-box'
    }
  },
  '&-ellipsis-multiple-line': {
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical'
  }
});
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/typography/style/index.js



const genTypographyStyle = token => {
  const {
    componentCls,
    titleMarginTop
  } = token;
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
      color: token.colorText,
      wordBreak: 'break-word',
      lineHeight: token.lineHeight,
      [`&${componentCls}-secondary`]: {
        color: token.colorTextDescription
      },
      [`&${componentCls}-success`]: {
        color: token.colorSuccessText
      },
      [`&${componentCls}-warning`]: {
        color: token.colorWarningText
      },
      [`&${componentCls}-danger`]: {
        color: token.colorErrorText,
        'a&:active, a&:focus': {
          color: token.colorErrorTextActive
        },
        'a&:hover': {
          color: token.colorErrorTextHover
        }
      },
      [`&${componentCls}-disabled`]: {
        color: token.colorTextDisabled,
        cursor: 'not-allowed',
        userSelect: 'none'
      },
      [`
        div&,
        p
      `]: {
        marginBottom: '1em'
      }
    }, getTitleStyles(token)), {
      [`
      & + h1${componentCls},
      & + h2${componentCls},
      & + h3${componentCls},
      & + h4${componentCls},
      & + h5${componentCls}
      `]: {
        marginTop: titleMarginTop
      },
      [`
      div,
      ul,
      li,
      p,
      h1,
      h2,
      h3,
      h4,
      h5`]: {
        [`
        + h1,
        + h2,
        + h3,
        + h4,
        + h5
        `]: {
          marginTop: titleMarginTop
        }
      }
    }), getResetStyles(token)), getLinkStyles(token)), {
      // Operation
      [`
        ${componentCls}-expand,
        ${componentCls}-collapse,
        ${componentCls}-edit,
        ${componentCls}-copy
      `]: Object.assign(Object.assign({}, operationUnit(token)), {
        marginInlineStart: token.marginXXS
      })
    }), getEditableStyles(token)), getCopyableStyles(token)), getEllipsisStyles()), {
      '&-rtl': {
        direction: 'rtl'
      }
    })
  };
};
const typography_style_prepareComponentToken = () => ({
  titleMarginTop: '1.2em',
  titleMarginBottom: '0.5em'
});
// ============================== Export ==============================
/* harmony default export */ var typography_style = (genStyleHooks('Typography', genTypographyStyle, typography_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/typography/Editable.js
"use client";








const Editable = props => {
  const {
    prefixCls,
    'aria-label': ariaLabel,
    className,
    style,
    direction,
    maxLength,
    autoSize = true,
    value,
    onSave,
    onCancel,
    onEnd,
    component,
    enterIcon = /*#__PURE__*/react.createElement(EnterOutlined/* default */.Z, null)
  } = props;
  const ref = react.useRef(null);
  const inComposition = react.useRef(false);
  const lastKeyCode = react.useRef(null);
  const [current, setCurrent] = react.useState(value);
  react.useEffect(() => {
    setCurrent(value);
  }, [value]);
  react.useEffect(() => {
    var _a;
    if ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) {
      const {
        textArea
      } = ref.current.resizableTextArea;
      textArea.focus();
      const {
        length
      } = textArea.value;
      textArea.setSelectionRange(length, length);
    }
  }, []);
  const onChange = ({
    target
  }) => {
    setCurrent(target.value.replace(/[\n\r]/g, ''));
  };
  const onCompositionStart = () => {
    inComposition.current = true;
  };
  const onCompositionEnd = () => {
    inComposition.current = false;
  };
  const onKeyDown = ({
    keyCode
  }) => {
    // We don't record keyCode when IME is using
    if (inComposition.current) return;
    lastKeyCode.current = keyCode;
  };
  const confirmChange = () => {
    onSave(current.trim());
  };
  const onKeyUp = ({
    keyCode,
    ctrlKey,
    altKey,
    metaKey,
    shiftKey
  }) => {
    // Check if it's a real key
    if (lastKeyCode.current !== keyCode || inComposition.current || ctrlKey || altKey || metaKey || shiftKey) {
      return;
    }
    if (keyCode === KeyCode/* default.ENTER */.Z.ENTER) {
      confirmChange();
      onEnd === null || onEnd === void 0 ? void 0 : onEnd();
    } else if (keyCode === KeyCode/* default.ESC */.Z.ESC) {
      onCancel();
    }
  };
  const onBlur = () => {
    confirmChange();
  };
  const [wrapCSSVar, hashId, cssVarCls] = typography_style(prefixCls);
  const textAreaClassName = classnames_default()(prefixCls, `${prefixCls}-edit-content`, {
    [`${prefixCls}-rtl`]: direction === 'rtl',
    [`${prefixCls}-${component}`]: !!component
  }, className, hashId, cssVarCls);
  return wrapCSSVar(/*#__PURE__*/react.createElement("div", {
    className: textAreaClassName,
    style: style
  }, /*#__PURE__*/react.createElement(input_TextArea, {
    ref: ref,
    maxLength: maxLength,
    value: current,
    onChange: onChange,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onCompositionStart: onCompositionStart,
    onCompositionEnd: onCompositionEnd,
    onBlur: onBlur,
    "aria-label": ariaLabel,
    rows: 1,
    autoSize: autoSize
  }), enterIcon !== null ? cloneElement(enterIcon, {
    className: `${prefixCls}-edit-content-confirm`
  }) : null));
};
/* harmony default export */ var typography_Editable = (Editable);
// EXTERNAL MODULE: ./node_modules/copy-to-clipboard/index.js
var copy_to_clipboard = __webpack_require__(90659);
var copy_to_clipboard_default = /*#__PURE__*/__webpack_require__.n(copy_to_clipboard);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/typography/hooks/useCopyClick.js
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};




const useCopyClick = ({
  copyConfig,
  children
}) => {
  const [copied, setCopied] = react.useState(false);
  const [copyLoading, setCopyLoading] = react.useState(false);
  const copyIdRef = react.useRef(null);
  const cleanCopyId = () => {
    if (copyIdRef.current) {
      clearTimeout(copyIdRef.current);
    }
  };
  const copyOptions = {};
  if (copyConfig.format) {
    copyOptions.format = copyConfig.format;
  }
  react.useEffect(() => cleanCopyId, []);
  // Keep copy action up to date
  const onClick = (0,hooks_useEvent/* default */.Z)(e => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    e === null || e === void 0 ? void 0 : e.preventDefault();
    e === null || e === void 0 ? void 0 : e.stopPropagation();
    setCopyLoading(true);
    try {
      const text = typeof copyConfig.text === 'function' ? yield copyConfig.text() : copyConfig.text;
      copy_to_clipboard_default()(text || _util_toList(children, true).join('') || '', copyOptions);
      setCopyLoading(false);
      setCopied(true);
      // Trigger tips update
      cleanCopyId();
      copyIdRef.current = setTimeout(() => {
        setCopied(false);
      }, 3000);
      (_a = copyConfig.onCopy) === null || _a === void 0 ? void 0 : _a.call(copyConfig, e);
    } catch (error) {
      setCopyLoading(false);
      throw error;
    }
  }));
  return {
    copied,
    copyLoading,
    onClick
  };
};
/* harmony default export */ var hooks_useCopyClick = (useCopyClick);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/typography/hooks/useMergedConfig.js

function useMergedConfig(propConfig, templateConfig) {
  return react.useMemo(() => {
    const support = !!propConfig;
    return [support, Object.assign(Object.assign({}, templateConfig), support && typeof propConfig === 'object' ? propConfig : null)];
  }, [propConfig]);
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/typography/hooks/usePrevious.js

const usePrevious = value => {
  const ref = (0,react.useRef)(undefined);
  (0,react.useEffect)(() => {
    ref.current = value;
  });
  return ref.current;
};
/* harmony default export */ var hooks_usePrevious = (usePrevious);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/typography/hooks/useTooltipProps.js

const useTooltipProps = (tooltip, editConfigText, children) => (0,react.useMemo)(() => {
  if (tooltip === true) {
    return {
      title: editConfigText !== null && editConfigText !== void 0 ? editConfigText : children
    };
  }
  if (/*#__PURE__*/(0,react.isValidElement)(tooltip)) {
    return {
      title: tooltip
    };
  }
  if (typeof tooltip === 'object') {
    return Object.assign({
      title: editConfigText !== null && editConfigText !== void 0 ? editConfigText : children
    }, tooltip);
  }
  return {
    title: tooltip
  };
}, [tooltip, editConfigText, children]);
/* harmony default export */ var hooks_useTooltipProps = (useTooltipProps);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/typography/Typography.js
"use client";

var Typography_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






const Typography = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      component: Component = 'article',
      className,
      rootClassName,
      setContentRef,
      children,
      direction: typographyDirection,
      style
    } = props,
    restProps = Typography_rest(props, ["prefixCls", "component", "className", "rootClassName", "setContentRef", "children", "direction", "style"]);
  const {
    getPrefixCls,
    direction: contextDirection,
    className: contextClassName,
    style: contextStyle
  } = useComponentConfig('typography');
  const direction = typographyDirection !== null && typographyDirection !== void 0 ? typographyDirection : contextDirection;
  const mergedRef = setContentRef ? (0,es_ref/* composeRef */.sQ)(ref, setContentRef) : ref;
  const prefixCls = getPrefixCls('typography', customizePrefixCls);
  if (false) {}
  // Style
  const [wrapCSSVar, hashId, cssVarCls] = typography_style(prefixCls);
  const componentClassName = classnames_default()(prefixCls, contextClassName, {
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, className, rootClassName, hashId, cssVarCls);
  const mergedStyle = Object.assign(Object.assign({}, contextStyle), style);
  return wrapCSSVar(/*#__PURE__*/
  // @ts-expect-error: Expression produces a union type that is too complex to represent.
  react.createElement(Component, Object.assign({
    className: componentClassName,
    style: mergedStyle,
    ref: mergedRef
  }, restProps), children));
});
if (false) {}
/* harmony default export */ var typography_Typography = (Typography);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CopyOutlined.js + 1 modules
var CopyOutlined = __webpack_require__(30376);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/typography/Base/util.js
function util_toList(val) {
  if (val === false) {
    return [false, false];
  }
  return Array.isArray(val) ? val : [val];
}
function getNode(dom, defaultNode, needDom) {
  if (dom === true || dom === undefined) {
    return defaultNode;
  }
  return dom || needDom && defaultNode;
}
/**
 * Check for element is native ellipsis
 * ref:
 * - https://github.com/ant-design/ant-design/issues/50143
 * - https://github.com/ant-design/ant-design/issues/50414
 */
function isEleEllipsis(ele) {
  // Create a new div to get the size
  const childDiv = document.createElement('em');
  ele.appendChild(childDiv);
  // For test case
  if (false) {}
  const rect = ele.getBoundingClientRect();
  const childRect = childDiv.getBoundingClientRect();
  // Reset
  ele.removeChild(childDiv);
  // Range checker
  return (
    // Horizontal out of range
    rect.left > childRect.left || childRect.right > rect.right ||
    // Vertical out of range
    rect.top > childRect.top || childRect.bottom > rect.bottom
  );
}
const isValidText = val => ['string', 'number'].includes(typeof val);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/typography/Base/CopyBtn.js
"use client";








const CopyBtn = ({
  prefixCls,
  copied,
  locale,
  iconOnly,
  tooltips,
  icon,
  tabIndex,
  onCopy,
  loading: btnLoading
}) => {
  const tooltipNodes = util_toList(tooltips);
  const iconNodes = util_toList(icon);
  const {
    copied: copiedText,
    copy: copyText
  } = locale !== null && locale !== void 0 ? locale : {};
  const systemStr = copied ? copiedText : copyText;
  const copyTitle = getNode(tooltipNodes[copied ? 1 : 0], systemStr);
  const ariaLabel = typeof copyTitle === 'string' ? copyTitle : systemStr;
  return /*#__PURE__*/react.createElement(es_tooltip, {
    title: copyTitle,
    getPopupContainer: node => node.parentNode
  }, /*#__PURE__*/react.createElement("button", {
    type: "button",
    className: classnames_default()(`${prefixCls}-copy`, {
      [`${prefixCls}-copy-success`]: copied,
      [`${prefixCls}-copy-icon-only`]: iconOnly
    }),
    onClick: onCopy,
    "aria-label": ariaLabel,
    tabIndex: tabIndex
  }, copied ? getNode(iconNodes[1], /*#__PURE__*/react.createElement(CheckOutlined/* default */.Z, null), true) : getNode(iconNodes[0], btnLoading ? /*#__PURE__*/react.createElement(LoadingOutlined/* default */.Z, null) : /*#__PURE__*/react.createElement(CopyOutlined/* default */.Z, null), true)));
};
/* harmony default export */ var Base_CopyBtn = (CopyBtn);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/typography/Base/Ellipsis.js
"use client";






const MeasureText = /*#__PURE__*/react.forwardRef(({
  style,
  children
}, ref) => {
  const spanRef = react.useRef(null);
  react.useImperativeHandle(ref, () => ({
    isExceed: () => {
      const span = spanRef.current;
      return span.scrollHeight > span.clientHeight;
    },
    getHeight: () => spanRef.current.clientHeight
  }));
  return /*#__PURE__*/react.createElement("span", {
    "aria-hidden": true,
    ref: spanRef,
    style: Object.assign({
      position: 'fixed',
      display: 'block',
      left: 0,
      top: 0,
      pointerEvents: 'none',
      backgroundColor: 'rgba(255, 0, 0, 0.65)'
    }, style)
  }, children);
});
const getNodesLen = nodeList => nodeList.reduce((totalLen, node) => totalLen + (isValidText(node) ? String(node).length : 1), 0);
function sliceNodes(nodeList, len) {
  let currLen = 0;
  const currentNodeList = [];
  for (let i = 0; i < nodeList.length; i += 1) {
    // Match to return
    if (currLen === len) {
      return currentNodeList;
    }
    const node = nodeList[i];
    const canCut = isValidText(node);
    const nodeLen = canCut ? String(node).length : 1;
    const nextLen = currLen + nodeLen;
    // Exceed but current not which means we need cut this
    // This will not happen on validate ReactElement
    if (nextLen > len) {
      const restLen = len - currLen;
      currentNodeList.push(String(node).slice(0, restLen));
      return currentNodeList;
    }
    currentNodeList.push(node);
    currLen = nextLen;
  }
  return nodeList;
}
// Measure for the `text` is exceed the `rows` or not
const STATUS_MEASURE_NONE = 0;
const STATUS_MEASURE_PREPARE = 1;
const STATUS_MEASURE_START = 2;
const STATUS_MEASURE_NEED_ELLIPSIS = 3;
const STATUS_MEASURE_NO_NEED_ELLIPSIS = 4;
const lineClipStyle = {
  display: '-webkit-box',
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical'
};
function EllipsisMeasure(props) {
  const {
    enableMeasure,
    width,
    text,
    children,
    rows,
    expanded,
    miscDeps,
    onEllipsis
  } = props;
  const nodeList = react.useMemo(() => (0,Children_toArray/* default */.Z)(text), [text]);
  const nodeLen = react.useMemo(() => getNodesLen(nodeList), [text]);
  // ========================= Full Content =========================
  // Used for measure only, which means it's always render as no need ellipsis
  const fullContent = react.useMemo(() => children(nodeList, false), [text]);
  // ========================= Cut Content ==========================
  const [ellipsisCutIndex, setEllipsisCutIndex] = react.useState(null);
  const cutMidRef = react.useRef(null);
  // ========================= NeedEllipsis =========================
  const measureWhiteSpaceRef = react.useRef(null);
  const needEllipsisRef = react.useRef(null);
  // Measure for `rows-1` height, to avoid operation exceed the line height
  const descRowsEllipsisRef = react.useRef(null);
  const symbolRowEllipsisRef = react.useRef(null);
  const [canEllipsis, setCanEllipsis] = react.useState(false);
  const [needEllipsis, setNeedEllipsis] = react.useState(STATUS_MEASURE_NONE);
  const [ellipsisHeight, setEllipsisHeight] = react.useState(0);
  const [parentWhiteSpace, setParentWhiteSpace] = react.useState(null);
  // Trigger start measure
  (0,hooks_useLayoutEffect/* default */.Z)(() => {
    if (enableMeasure && width && nodeLen) {
      setNeedEllipsis(STATUS_MEASURE_PREPARE);
    } else {
      setNeedEllipsis(STATUS_MEASURE_NONE);
    }
  }, [width, text, rows, enableMeasure, nodeList]);
  // Measure process
  (0,hooks_useLayoutEffect/* default */.Z)(() => {
    var _a, _b, _c, _d;
    if (needEllipsis === STATUS_MEASURE_PREPARE) {
      setNeedEllipsis(STATUS_MEASURE_START);
      // Parent ref `white-space`
      const nextWhiteSpace = measureWhiteSpaceRef.current && getComputedStyle(measureWhiteSpaceRef.current).whiteSpace;
      setParentWhiteSpace(nextWhiteSpace);
    } else if (needEllipsis === STATUS_MEASURE_START) {
      const isOverflow = !!((_a = needEllipsisRef.current) === null || _a === void 0 ? void 0 : _a.isExceed());
      setNeedEllipsis(isOverflow ? STATUS_MEASURE_NEED_ELLIPSIS : STATUS_MEASURE_NO_NEED_ELLIPSIS);
      setEllipsisCutIndex(isOverflow ? [0, nodeLen] : null);
      setCanEllipsis(isOverflow);
      // Get the basic height of ellipsis rows
      const baseRowsEllipsisHeight = ((_b = needEllipsisRef.current) === null || _b === void 0 ? void 0 : _b.getHeight()) || 0;
      // Get the height of `rows - 1` + symbol height
      const descRowsEllipsisHeight = rows === 1 ? 0 : ((_c = descRowsEllipsisRef.current) === null || _c === void 0 ? void 0 : _c.getHeight()) || 0;
      const symbolRowEllipsisHeight = ((_d = symbolRowEllipsisRef.current) === null || _d === void 0 ? void 0 : _d.getHeight()) || 0;
      const maxRowsHeight = Math.max(baseRowsEllipsisHeight,
      // height of rows with ellipsis
      descRowsEllipsisHeight + symbolRowEllipsisHeight);
      setEllipsisHeight(maxRowsHeight + 1);
      onEllipsis(isOverflow);
    }
  }, [needEllipsis]);
  // ========================= Cut Measure ==========================
  const cutMidIndex = ellipsisCutIndex ? Math.ceil((ellipsisCutIndex[0] + ellipsisCutIndex[1]) / 2) : 0;
  (0,hooks_useLayoutEffect/* default */.Z)(() => {
    var _a;
    const [minIndex, maxIndex] = ellipsisCutIndex || [0, 0];
    if (minIndex !== maxIndex) {
      const midHeight = ((_a = cutMidRef.current) === null || _a === void 0 ? void 0 : _a.getHeight()) || 0;
      const isOverflow = midHeight > ellipsisHeight;
      let targetMidIndex = cutMidIndex;
      if (maxIndex - minIndex === 1) {
        targetMidIndex = isOverflow ? minIndex : maxIndex;
      }
      setEllipsisCutIndex(isOverflow ? [minIndex, targetMidIndex] : [targetMidIndex, maxIndex]);
    }
  }, [ellipsisCutIndex, cutMidIndex]);
  // ========================= Text Content =========================
  const finalContent = react.useMemo(() => {
    // Skip everything if `enableMeasure` is disabled
    if (!enableMeasure) {
      return children(nodeList, false);
    }
    if (needEllipsis !== STATUS_MEASURE_NEED_ELLIPSIS || !ellipsisCutIndex || ellipsisCutIndex[0] !== ellipsisCutIndex[1]) {
      const content = children(nodeList, false);
      // Limit the max line count to avoid scrollbar blink unless no need ellipsis
      // https://github.com/ant-design/ant-design/issues/42958
      if ([STATUS_MEASURE_NO_NEED_ELLIPSIS, STATUS_MEASURE_NONE].includes(needEllipsis)) {
        return content;
      }
      return /*#__PURE__*/react.createElement("span", {
        style: Object.assign(Object.assign({}, lineClipStyle), {
          WebkitLineClamp: rows
        })
      }, content);
    }
    return children(expanded ? nodeList : sliceNodes(nodeList, ellipsisCutIndex[0]), canEllipsis);
  }, [expanded, needEllipsis, ellipsisCutIndex, nodeList].concat((0,toConsumableArray/* default */.Z)(miscDeps)));
  // ============================ Render ============================
  const measureStyle = {
    width,
    margin: 0,
    padding: 0,
    whiteSpace: parentWhiteSpace === 'nowrap' ? 'normal' : 'inherit'
  };
  return /*#__PURE__*/react.createElement(react.Fragment, null, finalContent, needEllipsis === STATUS_MEASURE_START && (/*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(MeasureText, {
    style: Object.assign(Object.assign(Object.assign({}, measureStyle), lineClipStyle), {
      WebkitLineClamp: rows
    }),
    ref: needEllipsisRef
  }, fullContent), /*#__PURE__*/react.createElement(MeasureText, {
    style: Object.assign(Object.assign(Object.assign({}, measureStyle), lineClipStyle), {
      WebkitLineClamp: rows - 1
    }),
    ref: descRowsEllipsisRef
  }, fullContent), /*#__PURE__*/react.createElement(MeasureText, {
    style: Object.assign(Object.assign(Object.assign({}, measureStyle), lineClipStyle), {
      WebkitLineClamp: 1
    }),
    ref: symbolRowEllipsisRef
  }, children([], true)))), needEllipsis === STATUS_MEASURE_NEED_ELLIPSIS && ellipsisCutIndex && ellipsisCutIndex[0] !== ellipsisCutIndex[1] && (/*#__PURE__*/react.createElement(MeasureText, {
    style: Object.assign(Object.assign({}, measureStyle), {
      top: 400
    }),
    ref: cutMidRef
  }, children(sliceNodes(nodeList, cutMidIndex), true))), needEllipsis === STATUS_MEASURE_PREPARE && (/*#__PURE__*/react.createElement("span", {
    style: {
      whiteSpace: 'inherit'
    },
    ref: measureWhiteSpaceRef
  })));
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/typography/Base/EllipsisTooltip.js
"use client";



const EllipsisTooltip = ({
  enableEllipsis,
  isEllipsis,
  children,
  tooltipProps
}) => {
  if (!(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.title) || !enableEllipsis) {
    return children;
  }
  return /*#__PURE__*/react.createElement(es_tooltip, Object.assign({
    open: isEllipsis ? undefined : false
  }, tooltipProps), children);
};
if (false) {}
/* harmony default export */ var Base_EllipsisTooltip = (EllipsisTooltip);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/typography/Base/index.js
"use client";


var Base_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};























function wrapperDecorations({
  mark,
  code,
  underline,
  delete: del,
  strong,
  keyboard,
  italic
}, content) {
  let currentContent = content;
  function wrap(tag, needed) {
    if (!needed) {
      return;
    }
    currentContent = /*#__PURE__*/react.createElement(tag, {}, currentContent);
  }
  wrap('strong', strong);
  wrap('u', underline);
  wrap('del', del);
  wrap('code', code);
  wrap('mark', mark);
  wrap('kbd', keyboard);
  wrap('i', italic);
  return currentContent;
}
const ELLIPSIS_STR = '...';
const DECORATION_PROPS = ['delete', 'mark', 'code', 'underline', 'strong', 'keyboard', 'italic'];
const Base = /*#__PURE__*/react.forwardRef((props, ref) => {
  var _a;
  const {
      prefixCls: customizePrefixCls,
      className,
      style,
      type,
      disabled,
      children,
      ellipsis,
      editable,
      copyable,
      component,
      title
    } = props,
    restProps = Base_rest(props, ["prefixCls", "className", "style", "type", "disabled", "children", "ellipsis", "editable", "copyable", "component", "title"]);
  const {
    getPrefixCls,
    direction
  } = react.useContext(ConfigContext);
  const [textLocale] = locale_useLocale('Text');
  const typographyRef = react.useRef(null);
  const editIconRef = react.useRef(null);
  // ============================ MISC ============================
  const prefixCls = getPrefixCls('typography', customizePrefixCls);
  const textProps = (0,omit/* default */.Z)(restProps, DECORATION_PROPS);
  // ========================== Editable ==========================
  const [enableEdit, editConfig] = useMergedConfig(editable);
  const [editing, setEditing] = (0,useMergedState/* default */.Z)(false, {
    value: editConfig.editing
  });
  const {
    triggerType = ['icon']
  } = editConfig;
  const triggerEdit = edit => {
    var _a;
    if (edit) {
      (_a = editConfig.onStart) === null || _a === void 0 ? void 0 : _a.call(editConfig);
    }
    setEditing(edit);
  };
  // Focus edit icon when back
  const prevEditing = hooks_usePrevious(editing);
  (0,hooks_useLayoutEffect/* default */.Z)(() => {
    var _a;
    if (!editing && prevEditing) {
      (_a = editIconRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
  }, [editing]);
  const onEditClick = e => {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    triggerEdit(true);
  };
  const onEditChange = value => {
    var _a;
    (_a = editConfig.onChange) === null || _a === void 0 ? void 0 : _a.call(editConfig, value);
    triggerEdit(false);
  };
  const onEditCancel = () => {
    var _a;
    (_a = editConfig.onCancel) === null || _a === void 0 ? void 0 : _a.call(editConfig);
    triggerEdit(false);
  };
  // ========================== Copyable ==========================
  const [enableCopy, copyConfig] = useMergedConfig(copyable);
  const {
    copied,
    copyLoading,
    onClick: onCopyClick
  } = hooks_useCopyClick({
    copyConfig,
    children
  });
  // ========================== Ellipsis ==========================
  const [isLineClampSupport, setIsLineClampSupport] = react.useState(false);
  const [isTextOverflowSupport, setIsTextOverflowSupport] = react.useState(false);
  const [isJsEllipsis, setIsJsEllipsis] = react.useState(false);
  const [isNativeEllipsis, setIsNativeEllipsis] = react.useState(false);
  const [isNativeVisible, setIsNativeVisible] = react.useState(true);
  const [enableEllipsis, ellipsisConfig] = useMergedConfig(ellipsis, {
    expandable: false,
    symbol: isExpanded => isExpanded ? textLocale === null || textLocale === void 0 ? void 0 : textLocale.collapse : textLocale === null || textLocale === void 0 ? void 0 : textLocale.expand
  });
  const [expanded, setExpanded] = (0,useMergedState/* default */.Z)(ellipsisConfig.defaultExpanded || false, {
    value: ellipsisConfig.expanded
  });
  const mergedEnableEllipsis = enableEllipsis && (!expanded || ellipsisConfig.expandable === 'collapsible');
  // Shared prop to reduce bundle size
  const {
    rows = 1
  } = ellipsisConfig;
  const needMeasureEllipsis = react.useMemo(() =>
  // Disable ellipsis
  mergedEnableEllipsis && (
  // Provide suffix
  ellipsisConfig.suffix !== undefined || ellipsisConfig.onEllipsis ||
  // Can't use css ellipsis since we need to provide the place for button
  ellipsisConfig.expandable || enableEdit || enableCopy), [mergedEnableEllipsis, ellipsisConfig, enableEdit, enableCopy]);
  (0,hooks_useLayoutEffect/* default */.Z)(() => {
    if (enableEllipsis && !needMeasureEllipsis) {
      setIsLineClampSupport((0,styleChecker/* isStyleSupport */.G)('webkitLineClamp'));
      setIsTextOverflowSupport((0,styleChecker/* isStyleSupport */.G)('textOverflow'));
    }
  }, [needMeasureEllipsis, enableEllipsis]);
  const [cssEllipsis, setCssEllipsis] = react.useState(mergedEnableEllipsis);
  const canUseCssEllipsis = react.useMemo(() => {
    if (needMeasureEllipsis) {
      return false;
    }
    if (rows === 1) {
      return isTextOverflowSupport;
    }
    return isLineClampSupport;
  }, [needMeasureEllipsis, isTextOverflowSupport, isLineClampSupport]);
  // We use effect to change from css ellipsis to js ellipsis.
  // To make SSR still can see the ellipsis.
  (0,hooks_useLayoutEffect/* default */.Z)(() => {
    setCssEllipsis(canUseCssEllipsis && mergedEnableEllipsis);
  }, [canUseCssEllipsis, mergedEnableEllipsis]);
  const isMergedEllipsis = mergedEnableEllipsis && (cssEllipsis ? isNativeEllipsis : isJsEllipsis);
  const cssTextOverflow = mergedEnableEllipsis && rows === 1 && cssEllipsis;
  const cssLineClamp = mergedEnableEllipsis && rows > 1 && cssEllipsis;
  // >>>>> Expand
  const onExpandClick = (e, info) => {
    var _a;
    setExpanded(info.expanded);
    (_a = ellipsisConfig.onExpand) === null || _a === void 0 ? void 0 : _a.call(ellipsisConfig, e, info);
  };
  const [ellipsisWidth, setEllipsisWidth] = react.useState(0);
  const onResize = ({
    offsetWidth
  }) => {
    setEllipsisWidth(offsetWidth);
  };
  // >>>>> JS Ellipsis
  const onJsEllipsis = jsEllipsis => {
    var _a;
    setIsJsEllipsis(jsEllipsis);
    // Trigger if changed
    if (isJsEllipsis !== jsEllipsis) {
      (_a = ellipsisConfig.onEllipsis) === null || _a === void 0 ? void 0 : _a.call(ellipsisConfig, jsEllipsis);
    }
  };
  // >>>>> Native ellipsis
  react.useEffect(() => {
    const textEle = typographyRef.current;
    if (enableEllipsis && cssEllipsis && textEle) {
      const currentEllipsis = isEleEllipsis(textEle);
      if (isNativeEllipsis !== currentEllipsis) {
        setIsNativeEllipsis(currentEllipsis);
      }
    }
  }, [enableEllipsis, cssEllipsis, children, cssLineClamp, isNativeVisible, ellipsisWidth]);
  // https://github.com/ant-design/ant-design/issues/36786
  // Use IntersectionObserver to check if element is invisible
  react.useEffect(() => {
    const textEle = typographyRef.current;
    if (typeof IntersectionObserver === 'undefined' || !textEle || !cssEllipsis || !mergedEnableEllipsis) {
      return;
    }
    /* eslint-disable-next-line compat/compat */
    const observer = new IntersectionObserver(() => {
      setIsNativeVisible(!!textEle.offsetParent);
    });
    observer.observe(textEle);
    return () => {
      observer.disconnect();
    };
  }, [cssEllipsis, mergedEnableEllipsis]);
  // ========================== Tooltip ===========================
  const tooltipProps = hooks_useTooltipProps(ellipsisConfig.tooltip, editConfig.text, children);
  const topAriaLabel = react.useMemo(() => {
    if (!enableEllipsis || cssEllipsis) {
      return undefined;
    }
    return [editConfig.text, children, title, tooltipProps.title].find(isValidText);
  }, [enableEllipsis, cssEllipsis, title, tooltipProps.title, isMergedEllipsis]);
  // =========================== Render ===========================
  // >>>>>>>>>>> Editing input
  if (editing) {
    return /*#__PURE__*/react.createElement(typography_Editable, {
      value: (_a = editConfig.text) !== null && _a !== void 0 ? _a : typeof children === 'string' ? children : '',
      onSave: onEditChange,
      onCancel: onEditCancel,
      onEnd: editConfig.onEnd,
      prefixCls: prefixCls,
      className: className,
      style: style,
      direction: direction,
      component: component,
      maxLength: editConfig.maxLength,
      autoSize: editConfig.autoSize,
      enterIcon: editConfig.enterIcon
    });
  }
  // >>>>>>>>>>> Typography
  // Expand
  const renderExpand = () => {
    const {
      expandable,
      symbol
    } = ellipsisConfig;
    return expandable ? (/*#__PURE__*/react.createElement("button", {
      type: "button",
      key: "expand",
      className: `${prefixCls}-${expanded ? 'collapse' : 'expand'}`,
      onClick: e => onExpandClick(e, {
        expanded: !expanded
      }),
      "aria-label": expanded ? textLocale.collapse : textLocale === null || textLocale === void 0 ? void 0 : textLocale.expand
    }, typeof symbol === 'function' ? symbol(expanded) : symbol)) : null;
  };
  // Edit
  const renderEdit = () => {
    if (!enableEdit) {
      return;
    }
    const {
      icon,
      tooltip,
      tabIndex
    } = editConfig;
    const editTitle = (0,Children_toArray/* default */.Z)(tooltip)[0] || (textLocale === null || textLocale === void 0 ? void 0 : textLocale.edit);
    const ariaLabel = typeof editTitle === 'string' ? editTitle : '';
    return triggerType.includes('icon') ? (/*#__PURE__*/react.createElement(es_tooltip, {
      key: "edit",
      title: tooltip === false ? '' : editTitle
    }, /*#__PURE__*/react.createElement("button", {
      type: "button",
      ref: editIconRef,
      className: `${prefixCls}-edit`,
      onClick: onEditClick,
      "aria-label": ariaLabel,
      tabIndex: tabIndex
    }, icon || /*#__PURE__*/react.createElement(EditOutlined/* default */.Z, {
      role: "button"
    })))) : null;
  };
  // Copy
  const renderCopy = () => {
    if (!enableCopy) {
      return null;
    }
    return /*#__PURE__*/react.createElement(Base_CopyBtn, Object.assign({
      key: "copy"
    }, copyConfig, {
      prefixCls: prefixCls,
      copied: copied,
      locale: textLocale,
      onCopy: onCopyClick,
      loading: copyLoading,
      iconOnly: children === null || children === undefined
    }));
  };
  const renderOperations = canEllipsis => [canEllipsis && renderExpand(), renderEdit(), renderCopy()];
  const renderEllipsis = canEllipsis => [canEllipsis && !expanded && (/*#__PURE__*/react.createElement("span", {
    "aria-hidden": true,
    key: "ellipsis"
  }, ELLIPSIS_STR)), ellipsisConfig.suffix, renderOperations(canEllipsis)];
  return /*#__PURE__*/react.createElement(es/* default */.Z, {
    onResize: onResize,
    disabled: !mergedEnableEllipsis
  }, resizeRef => (/*#__PURE__*/react.createElement(Base_EllipsisTooltip, {
    tooltipProps: tooltipProps,
    enableEllipsis: mergedEnableEllipsis,
    isEllipsis: isMergedEllipsis
  }, /*#__PURE__*/react.createElement(typography_Typography, Object.assign({
    className: classnames_default()({
      [`${prefixCls}-${type}`]: type,
      [`${prefixCls}-disabled`]: disabled,
      [`${prefixCls}-ellipsis`]: enableEllipsis,
      [`${prefixCls}-ellipsis-single-line`]: cssTextOverflow,
      [`${prefixCls}-ellipsis-multiple-line`]: cssLineClamp
    }, className),
    prefixCls: customizePrefixCls,
    style: Object.assign(Object.assign({}, style), {
      WebkitLineClamp: cssLineClamp ? rows : undefined
    }),
    component: component,
    ref: (0,es_ref/* composeRef */.sQ)(resizeRef, typographyRef, ref),
    direction: direction,
    onClick: triggerType.includes('text') ? onEditClick : undefined,
    "aria-label": topAriaLabel === null || topAriaLabel === void 0 ? void 0 : topAriaLabel.toString(),
    title: title
  }, textProps), /*#__PURE__*/react.createElement(EllipsisMeasure, {
    enableMeasure: mergedEnableEllipsis && !cssEllipsis,
    text: children,
    rows: rows,
    width: ellipsisWidth,
    onEllipsis: onJsEllipsis,
    expanded: expanded,
    miscDeps: [copied, expanded, copyLoading, enableEdit, enableCopy, textLocale].concat((0,toConsumableArray/* default */.Z)(DECORATION_PROPS.map(key => props[key])))
  }, (node, canEllipsis) => wrapperDecorations(props, /*#__PURE__*/react.createElement(react.Fragment, null, node.length > 0 && canEllipsis && !expanded && topAriaLabel ? (/*#__PURE__*/react.createElement("span", {
    key: "show-content",
    "aria-hidden": true
  }, node)) : node, renderEllipsis(canEllipsis))))))));
});
/* harmony default export */ var typography_Base = (Base);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/typography/Link.js
"use client";

var Link_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};



const Link = /*#__PURE__*/react.forwardRef((_a, ref) => {
  var {
      ellipsis,
      rel
    } = _a,
    restProps = Link_rest(_a, ["ellipsis", "rel"]);
  if (false) {}
  const mergedProps = Object.assign(Object.assign({}, restProps), {
    rel: rel === undefined && restProps.target === '_blank' ? 'noopener noreferrer' : rel
  });
  // @ts-expect-error: https://github.com/ant-design/ant-design/issues/26622
  delete mergedProps.navigate;
  return /*#__PURE__*/react.createElement(typography_Base, Object.assign({}, mergedProps, {
    ref: ref,
    ellipsis: !!ellipsis,
    component: "a"
  }));
});
/* harmony default export */ var typography_Link = (Link);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/typography/Paragraph.js
"use client";



const Paragraph_Paragraph = /*#__PURE__*/react.forwardRef((props, ref) => (/*#__PURE__*/react.createElement(typography_Base, Object.assign({
  ref: ref
}, props, {
  component: "div"
}))));
/* harmony default export */ var typography_Paragraph = (Paragraph_Paragraph);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/typography/Text.js
"use client";

var Text_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




const Text = (_a, ref) => {
  var {
      ellipsis
    } = _a,
    restProps = Text_rest(_a, ["ellipsis"]);
  const mergedEllipsis = react.useMemo(() => {
    if (ellipsis && typeof ellipsis === 'object') {
      return (0,omit/* default */.Z)(ellipsis, ['expandable', 'rows']);
    }
    return ellipsis;
  }, [ellipsis]);
  if (false) {}
  return /*#__PURE__*/react.createElement(typography_Base, Object.assign({
    ref: ref
  }, restProps, {
    ellipsis: mergedEllipsis,
    component: "span"
  }));
};
/* harmony default export */ var typography_Text = (/*#__PURE__*/react.forwardRef(Text));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/typography/Title.js
"use client";

var Title_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};



const TITLE_ELE_LIST = [1, 2, 3, 4, 5];
const Title_Title = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      level = 1
    } = props,
    restProps = Title_rest(props, ["level"]);
  if (false) {}
  const component = TITLE_ELE_LIST.includes(level) ? `h${level}` : `h1`;
  return /*#__PURE__*/react.createElement(typography_Base, Object.assign({
    ref: ref
  }, restProps, {
    component: component
  }));
});
/* harmony default export */ var typography_Title = (Title_Title);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/typography/index.js
"use client";






const es_typography_Typography = typography_Typography;
es_typography_Typography.Text = typography_Text;
es_typography_Typography.Link = typography_Link;
es_typography_Typography.Title = typography_Title;
es_typography_Typography.Paragraph = typography_Paragraph;
/* harmony default export */ var typography = (es_typography_Typography);
// EXTERNAL MODULE: ./node_modules/rc-upload/es/index.js + 6 modules
var rc_upload_es = __webpack_require__(3499);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/upload/style/dragger.js

const genDraggerStyle = token => {
  const {
    componentCls,
    iconCls
  } = token;
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}-drag`]: {
        position: 'relative',
        width: '100%',
        height: '100%',
        textAlign: 'center',
        background: token.colorFillAlter,
        border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} dashed ${token.colorBorder}`,
        borderRadius: token.borderRadiusLG,
        cursor: 'pointer',
        transition: `border-color ${token.motionDurationSlow}`,
        [componentCls]: {
          padding: token.padding
        },
        [`${componentCls}-btn`]: {
          display: 'table',
          width: '100%',
          height: '100%',
          outline: 'none',
          borderRadius: token.borderRadiusLG,
          '&:focus-visible': {
            outline: `${(0,cssinjs_es/* unit */.bf)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`
          }
        },
        [`${componentCls}-drag-container`]: {
          display: 'table-cell',
          verticalAlign: 'middle'
        },
        [`
          &:not(${componentCls}-disabled):hover,
          &-hover:not(${componentCls}-disabled)
        `]: {
          borderColor: token.colorPrimaryHover
        },
        [`p${componentCls}-drag-icon`]: {
          marginBottom: token.margin,
          [iconCls]: {
            color: token.colorPrimary,
            fontSize: token.uploadThumbnailSize
          }
        },
        [`p${componentCls}-text`]: {
          margin: `0 0 ${(0,cssinjs_es/* unit */.bf)(token.marginXXS)}`,
          color: token.colorTextHeading,
          fontSize: token.fontSizeLG
        },
        [`p${componentCls}-hint`]: {
          color: token.colorTextDescription,
          fontSize: token.fontSize
        },
        // ===================== Disabled =====================
        [`&${componentCls}-disabled`]: {
          [`p${componentCls}-drag-icon ${iconCls},
            p${componentCls}-text,
            p${componentCls}-hint
          `]: {
            color: token.colorTextDisabled
          }
        }
      }
    }
  };
};
/* harmony default export */ var dragger = (genDraggerStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/upload/style/list.js


const genListStyle = token => {
  const {
    componentCls,
    iconCls,
    fontSize,
    lineHeight,
    calc
  } = token;
  const itemCls = `${componentCls}-list-item`;
  const actionsCls = `${itemCls}-actions`;
  const actionCls = `${itemCls}-action`;
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}-list`]: Object.assign(Object.assign({}, clearFix()), {
        lineHeight: token.lineHeight,
        [itemCls]: {
          position: 'relative',
          height: calc(token.lineHeight).mul(fontSize).equal(),
          marginTop: token.marginXS,
          fontSize,
          display: 'flex',
          alignItems: 'center',
          transition: `background-color ${token.motionDurationSlow}`,
          borderRadius: token.borderRadiusSM,
          '&:hover': {
            backgroundColor: token.controlItemBgHover
          },
          [`${itemCls}-name`]: Object.assign(Object.assign({}, textEllipsis), {
            padding: `0 ${(0,cssinjs_es/* unit */.bf)(token.paddingXS)}`,
            lineHeight,
            flex: 'auto',
            transition: `all ${token.motionDurationSlow}`
          }),
          [actionsCls]: {
            whiteSpace: 'nowrap',
            [actionCls]: {
              opacity: 0
            },
            [iconCls]: {
              color: token.actionsColor,
              transition: `all ${token.motionDurationSlow}`
            },
            [`
              ${actionCls}:focus-visible,
              &.picture ${actionCls}
            `]: {
              opacity: 1
            }
          },
          [`${componentCls}-icon ${iconCls}`]: {
            color: token.colorIcon,
            fontSize
          },
          [`${itemCls}-progress`]: {
            position: 'absolute',
            bottom: token.calc(token.uploadProgressOffset).mul(-1).equal(),
            width: '100%',
            paddingInlineStart: calc(fontSize).add(token.paddingXS).equal(),
            fontSize,
            lineHeight: 0,
            pointerEvents: 'none',
            '> div': {
              margin: 0
            }
          }
        },
        [`${itemCls}:hover ${actionCls}`]: {
          opacity: 1
        },
        [`${itemCls}-error`]: {
          color: token.colorError,
          [`${itemCls}-name, ${componentCls}-icon ${iconCls}`]: {
            color: token.colorError
          },
          [actionsCls]: {
            [`${iconCls}, ${iconCls}:hover`]: {
              color: token.colorError
            },
            [actionCls]: {
              opacity: 1
            }
          }
        },
        [`${componentCls}-list-item-container`]: {
          transition: `opacity ${token.motionDurationSlow}, height ${token.motionDurationSlow}`,
          // For smooth removing animation
          '&::before': {
            display: 'table',
            width: 0,
            height: 0,
            content: '""'
          }
        }
      })
    }
  };
};
/* harmony default export */ var style_list = (genListStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/upload/style/motion.js


// =========================== Motion ===========================
const style_motion_genMotionStyle = token => {
  const {
    componentCls
  } = token;
  const uploadAnimateInlineIn = new cssinjs_es/* Keyframes */.E4('uploadAnimateInlineIn', {
    from: {
      width: 0,
      height: 0,
      padding: 0,
      opacity: 0,
      margin: token.calc(token.marginXS).div(-2).equal()
    }
  });
  const uploadAnimateInlineOut = new cssinjs_es/* Keyframes */.E4('uploadAnimateInlineOut', {
    to: {
      width: 0,
      height: 0,
      padding: 0,
      opacity: 0,
      margin: token.calc(token.marginXS).div(-2).equal()
    }
  });
  const inlineCls = `${componentCls}-animate-inline`;
  return [{
    [`${componentCls}-wrapper`]: {
      [`${inlineCls}-appear, ${inlineCls}-enter, ${inlineCls}-leave`]: {
        animationDuration: token.motionDurationSlow,
        animationTimingFunction: token.motionEaseInOutCirc,
        animationFillMode: 'forwards'
      },
      [`${inlineCls}-appear, ${inlineCls}-enter`]: {
        animationName: uploadAnimateInlineIn
      },
      [`${inlineCls}-leave`]: {
        animationName: uploadAnimateInlineOut
      }
    }
  }, {
    [`${componentCls}-wrapper`]: initFadeMotion(token)
  }, uploadAnimateInlineIn, uploadAnimateInlineOut];
};
/* harmony default export */ var upload_style_motion = (style_motion_genMotionStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/upload/style/picture.js



const genPictureStyle = token => {
  const {
    componentCls,
    iconCls,
    uploadThumbnailSize,
    uploadProgressOffset,
    calc
  } = token;
  const listCls = `${componentCls}-list`;
  const itemCls = `${listCls}-item`;
  return {
    [`${componentCls}-wrapper`]: {
      // ${listCls} 增加优先级
      [`
        ${listCls}${listCls}-picture,
        ${listCls}${listCls}-picture-card,
        ${listCls}${listCls}-picture-circle
      `]: {
        [itemCls]: {
          position: 'relative',
          height: calc(uploadThumbnailSize).add(calc(token.lineWidth).mul(2)).add(calc(token.paddingXS).mul(2)).equal(),
          padding: token.paddingXS,
          border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
          borderRadius: token.borderRadiusLG,
          '&:hover': {
            background: 'transparent'
          },
          [`${itemCls}-thumbnail`]: Object.assign(Object.assign({}, textEllipsis), {
            width: uploadThumbnailSize,
            height: uploadThumbnailSize,
            lineHeight: (0,cssinjs_es/* unit */.bf)(calc(uploadThumbnailSize).add(token.paddingSM).equal()),
            textAlign: 'center',
            flex: 'none',
            [iconCls]: {
              fontSize: token.fontSizeHeading2,
              color: token.colorPrimary
            },
            img: {
              display: 'block',
              width: '100%',
              height: '100%',
              overflow: 'hidden'
            }
          }),
          [`${itemCls}-progress`]: {
            bottom: uploadProgressOffset,
            width: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(calc(token.paddingSM).mul(2).equal())})`,
            marginTop: 0,
            paddingInlineStart: calc(uploadThumbnailSize).add(token.paddingXS).equal()
          }
        },
        [`${itemCls}-error`]: {
          borderColor: token.colorError,
          // Adjust the color of the error icon : https://github.com/ant-design/ant-design/pull/24160
          [`${itemCls}-thumbnail ${iconCls}`]: {
            [`svg path[fill='${colors_es/* blue.0 */.iN[0]}']`]: {
              fill: token.colorErrorBg
            },
            [`svg path[fill='${colors_es/* blue.primary */.iN.primary}']`]: {
              fill: token.colorError
            }
          }
        },
        [`${itemCls}-uploading`]: {
          borderStyle: 'dashed',
          [`${itemCls}-name`]: {
            marginBottom: uploadProgressOffset
          }
        }
      },
      [`${listCls}${listCls}-picture-circle ${itemCls}`]: {
        [`&, &::before, ${itemCls}-thumbnail`]: {
          borderRadius: '50%'
        }
      }
    }
  };
};
const genPictureCardStyle = token => {
  const {
    componentCls,
    iconCls,
    fontSizeLG,
    colorTextLightSolid,
    calc
  } = token;
  const listCls = `${componentCls}-list`;
  const itemCls = `${listCls}-item`;
  const uploadPictureCardSize = token.uploadPicCardSize;
  return {
    [`
      ${componentCls}-wrapper${componentCls}-picture-card-wrapper,
      ${componentCls}-wrapper${componentCls}-picture-circle-wrapper
    `]: Object.assign(Object.assign({}, clearFix()), {
      display: 'block',
      [`${componentCls}${componentCls}-select`]: {
        width: uploadPictureCardSize,
        height: uploadPictureCardSize,
        textAlign: 'center',
        verticalAlign: 'top',
        backgroundColor: token.colorFillAlter,
        border: `${(0,cssinjs_es/* unit */.bf)(token.lineWidth)} dashed ${token.colorBorder}`,
        borderRadius: token.borderRadiusLG,
        cursor: 'pointer',
        transition: `border-color ${token.motionDurationSlow}`,
        [`> ${componentCls}`]: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          textAlign: 'center'
        },
        [`&:not(${componentCls}-disabled):hover`]: {
          borderColor: token.colorPrimary
        }
      },
      // list
      [`${listCls}${listCls}-picture-card, ${listCls}${listCls}-picture-circle`]: {
        display: 'flex',
        flexWrap: 'wrap',
        '@supports not (gap: 1px)': {
          '& > *': {
            marginBlockEnd: token.marginXS,
            marginInlineEnd: token.marginXS
          }
        },
        '@supports (gap: 1px)': {
          gap: token.marginXS
        },
        [`${listCls}-item-container`]: {
          display: 'inline-block',
          width: uploadPictureCardSize,
          height: uploadPictureCardSize,
          verticalAlign: 'top'
        },
        '&::after': {
          display: 'none'
        },
        '&::before': {
          display: 'none'
        },
        [itemCls]: {
          height: '100%',
          margin: 0,
          '&::before': {
            position: 'absolute',
            zIndex: 1,
            width: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(calc(token.paddingXS).mul(2).equal())})`,
            height: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(calc(token.paddingXS).mul(2).equal())})`,
            backgroundColor: token.colorBgMask,
            opacity: 0,
            transition: `all ${token.motionDurationSlow}`,
            content: '" "'
          }
        },
        [`${itemCls}:hover`]: {
          [`&::before, ${itemCls}-actions`]: {
            opacity: 1
          }
        },
        [`${itemCls}-actions`]: {
          position: 'absolute',
          insetInlineStart: 0,
          zIndex: 10,
          width: '100%',
          whiteSpace: 'nowrap',
          textAlign: 'center',
          opacity: 0,
          transition: `all ${token.motionDurationSlow}`,
          [`
            ${iconCls}-eye,
            ${iconCls}-download,
            ${iconCls}-delete
          `]: {
            zIndex: 10,
            width: fontSizeLG,
            margin: `0 ${(0,cssinjs_es/* unit */.bf)(token.marginXXS)}`,
            fontSize: fontSizeLG,
            cursor: 'pointer',
            transition: `all ${token.motionDurationSlow}`,
            color: colorTextLightSolid,
            '&:hover': {
              color: colorTextLightSolid
            },
            svg: {
              verticalAlign: 'baseline'
            }
          }
        },
        [`${itemCls}-thumbnail, ${itemCls}-thumbnail img`]: {
          position: 'static',
          display: 'block',
          width: '100%',
          height: '100%',
          objectFit: 'contain'
        },
        [`${itemCls}-name`]: {
          display: 'none',
          textAlign: 'center'
        },
        [`${itemCls}-file + ${itemCls}-name`]: {
          position: 'absolute',
          bottom: token.margin,
          display: 'block',
          width: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(calc(token.paddingXS).mul(2).equal())})`
        },
        [`${itemCls}-uploading`]: {
          [`&${itemCls}`]: {
            backgroundColor: token.colorFillAlter
          },
          [`&::before, ${iconCls}-eye, ${iconCls}-download, ${iconCls}-delete`]: {
            display: 'none'
          }
        },
        [`${itemCls}-progress`]: {
          bottom: token.marginXL,
          width: `calc(100% - ${(0,cssinjs_es/* unit */.bf)(calc(token.paddingXS).mul(2).equal())})`,
          paddingInlineStart: 0
        }
      }
    }),
    [`${componentCls}-wrapper${componentCls}-picture-circle-wrapper`]: {
      [`${componentCls}${componentCls}-select`]: {
        borderRadius: '50%'
      }
    }
  };
};

;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/upload/style/rtl.js
// =========================== Motion ===========================
const rtl_genRtlStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}-rtl`]: {
      direction: 'rtl'
    }
  };
};
/* harmony default export */ var upload_style_rtl = (rtl_genRtlStyle);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/upload/style/index.js








const upload_style_genBaseStyle = token => {
  const {
    componentCls,
    colorTextDisabled
  } = token;
  return {
    [`${componentCls}-wrapper`]: Object.assign(Object.assign({}, resetComponent(token)), {
      [componentCls]: {
        outline: 0,
        "input[type='file']": {
          cursor: 'pointer'
        }
      },
      [`${componentCls}-select`]: {
        display: 'inline-block'
      },
      [`${componentCls}-hidden`]: {
        display: 'none'
      },
      [`${componentCls}-disabled`]: {
        color: colorTextDisabled,
        cursor: 'not-allowed'
      }
    })
  };
};
const upload_style_prepareComponentToken = token => ({
  actionsColor: token.colorIcon
});
// ============================== Export ==============================
/* harmony default export */ var upload_style = (genStyleHooks('Upload', token => {
  const {
    fontSizeHeading3,
    fontHeight,
    lineWidth,
    controlHeightLG,
    calc
  } = token;
  const uploadToken = (0,cssinjs_utils_es/* mergeToken */.IX)(token, {
    uploadThumbnailSize: calc(fontSizeHeading3).mul(2).equal(),
    uploadProgressOffset: calc(calc(fontHeight).div(2)).add(lineWidth).equal(),
    uploadPicCardSize: calc(controlHeightLG).mul(2.55).equal()
  });
  return [upload_style_genBaseStyle(uploadToken), dragger(uploadToken), genPictureStyle(uploadToken), genPictureCardStyle(uploadToken), style_list(uploadToken), upload_style_motion(uploadToken), upload_style_rtl(uploadToken), collapse(uploadToken)];
}, upload_style_prepareComponentToken));
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/FileTwoTone.js + 1 modules
var FileTwoTone = __webpack_require__(64204);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PaperClipOutlined.js + 1 modules
var PaperClipOutlined = __webpack_require__(31909);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PictureTwoTone.js + 1 modules
var PictureTwoTone = __webpack_require__(90396);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/upload/utils.js

function file2Obj(file) {
  return Object.assign(Object.assign({}, file), {
    lastModified: file.lastModified,
    lastModifiedDate: file.lastModifiedDate,
    name: file.name,
    size: file.size,
    type: file.type,
    uid: file.uid,
    percent: 0,
    originFileObj: file
  });
}
/** Upload fileList. Replace file if exist or just push into it. */
function updateFileList(file, fileList) {
  const nextFileList = (0,toConsumableArray/* default */.Z)(fileList);
  const fileIndex = nextFileList.findIndex(({
    uid
  }) => uid === file.uid);
  if (fileIndex === -1) {
    nextFileList.push(file);
  } else {
    nextFileList[fileIndex] = file;
  }
  return nextFileList;
}
function getFileItem(file, fileList) {
  const matchKey = file.uid !== undefined ? 'uid' : 'name';
  return fileList.filter(item => item[matchKey] === file[matchKey])[0];
}
function removeFileItem(file, fileList) {
  const matchKey = file.uid !== undefined ? 'uid' : 'name';
  const removed = fileList.filter(item => item[matchKey] !== file[matchKey]);
  if (removed.length === fileList.length) {
    return null;
  }
  return removed;
}
// ==================== Default Image Preview ====================
const extname = (url = '') => {
  const temp = url.split('/');
  const filename = temp[temp.length - 1];
  const filenameWithoutSuffix = filename.split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [''])[0];
};
const isImageFileType = type => type.indexOf('image/') === 0;
const isImageUrl = file => {
  if (file.type && !file.thumbUrl) {
    return isImageFileType(file.type);
  }
  const url = file.thumbUrl || file.url || '';
  const extension = extname(url);
  if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico|heic|heif)$/i.test(extension)) {
    return true;
  }
  if (/^data:/.test(url)) {
    // other file types of base64
    return false;
  }
  if (extension) {
    // other file types which have extension
    return false;
  }
  return true;
};
const MEASURE_SIZE = 200;
function previewImage(file) {
  return new Promise(resolve => {
    if (!file.type || !isImageFileType(file.type)) {
      resolve('');
      return;
    }
    const canvas = document.createElement('canvas');
    canvas.width = MEASURE_SIZE;
    canvas.height = MEASURE_SIZE;
    canvas.style.cssText = `position: fixed; left: 0; top: 0; width: ${MEASURE_SIZE}px; height: ${MEASURE_SIZE}px; z-index: 9999; display: none;`;
    document.body.appendChild(canvas);
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.onload = () => {
      const {
        width,
        height
      } = img;
      let drawWidth = MEASURE_SIZE;
      let drawHeight = MEASURE_SIZE;
      let offsetX = 0;
      let offsetY = 0;
      if (width > height) {
        drawHeight = height * (MEASURE_SIZE / width);
        offsetY = -(drawHeight - drawWidth) / 2;
      } else {
        drawWidth = width * (MEASURE_SIZE / height);
        offsetX = -(drawWidth - drawHeight) / 2;
      }
      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
      const dataURL = canvas.toDataURL();
      document.body.removeChild(canvas);
      window.URL.revokeObjectURL(img.src);
      resolve(dataURL);
    };
    img.crossOrigin = 'anonymous';
    if (file.type.startsWith('image/svg+xml')) {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.result && typeof reader.result === 'string') {
          img.src = reader.result;
        }
      };
      reader.readAsDataURL(file);
    } else if (file.type.startsWith('image/gif')) {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.result) {
          resolve(reader.result);
        }
      };
      reader.readAsDataURL(file);
    } else {
      img.src = window.URL.createObjectURL(file);
    }
  });
}
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/DownloadOutlined.js + 1 modules
var DownloadOutlined = __webpack_require__(84491);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/upload/UploadList/ListItem.js
"use client";










const ListItem_ListItem = /*#__PURE__*/react.forwardRef(({
  prefixCls,
  className,
  style,
  locale,
  listType,
  file,
  items,
  progress: progressProps,
  iconRender,
  actionIconRender,
  itemRender,
  isImgUrl,
  showPreviewIcon,
  showRemoveIcon,
  showDownloadIcon,
  previewIcon: customPreviewIcon,
  removeIcon: customRemoveIcon,
  downloadIcon: customDownloadIcon,
  extra: customExtra,
  onPreview,
  onDownload,
  onClose
}, ref) => {
  var _a, _b;
  // Status: which will ignore `removed` status
  const {
    status
  } = file;
  const [mergedStatus, setMergedStatus] = react.useState(status);
  react.useEffect(() => {
    if (status !== 'removed') {
      setMergedStatus(status);
    }
  }, [status]);
  // Delay to show the progress bar
  const [showProgress, setShowProgress] = react.useState(false);
  react.useEffect(() => {
    const timer = setTimeout(() => {
      setShowProgress(true);
    }, 300);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  const iconNode = iconRender(file);
  let icon = /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-icon`
  }, iconNode);
  if (listType === 'picture' || listType === 'picture-card' || listType === 'picture-circle') {
    if (mergedStatus === 'uploading' || !file.thumbUrl && !file.url) {
      const uploadingClassName = classnames_default()(`${prefixCls}-list-item-thumbnail`, {
        [`${prefixCls}-list-item-file`]: mergedStatus !== 'uploading'
      });
      icon = /*#__PURE__*/react.createElement("div", {
        className: uploadingClassName
      }, iconNode);
    } else {
      const thumbnail = (isImgUrl === null || isImgUrl === void 0 ? void 0 : isImgUrl(file)) ? (/*#__PURE__*/react.createElement("img", {
        src: file.thumbUrl || file.url,
        alt: file.name,
        className: `${prefixCls}-list-item-image`,
        crossOrigin: file.crossOrigin
      })) : iconNode;
      const aClassName = classnames_default()(`${prefixCls}-list-item-thumbnail`, {
        [`${prefixCls}-list-item-file`]: isImgUrl && !isImgUrl(file)
      });
      icon = /*#__PURE__*/react.createElement("a", {
        className: aClassName,
        onClick: e => onPreview(file, e),
        href: file.url || file.thumbUrl,
        target: "_blank",
        rel: "noopener noreferrer"
      }, thumbnail);
    }
  }
  const listItemClassName = classnames_default()(`${prefixCls}-list-item`, `${prefixCls}-list-item-${mergedStatus}`);
  const linkProps = typeof file.linkProps === 'string' ? JSON.parse(file.linkProps) : file.linkProps;
  const removeIcon = (typeof showRemoveIcon === 'function' ? showRemoveIcon(file) : showRemoveIcon) ? actionIconRender((typeof customRemoveIcon === 'function' ? customRemoveIcon(file) : customRemoveIcon) || (/*#__PURE__*/react.createElement(DeleteOutlined/* default */.Z, null)), () => onClose(file), prefixCls, locale.removeFile,
  // acceptUploadDisabled is true, only remove icon will follow Upload disabled prop
  // https://github.com/ant-design/ant-design/issues/46171
  true) : null;
  const downloadIcon = (typeof showDownloadIcon === 'function' ? showDownloadIcon(file) : showDownloadIcon) && mergedStatus === 'done' ? actionIconRender((typeof customDownloadIcon === 'function' ? customDownloadIcon(file) : customDownloadIcon) || /*#__PURE__*/react.createElement(DownloadOutlined/* default */.Z, null), () => onDownload(file), prefixCls, locale.downloadFile) : null;
  const downloadOrDelete = listType !== 'picture-card' && listType !== 'picture-circle' && (/*#__PURE__*/react.createElement("span", {
    key: "download-delete",
    className: classnames_default()(`${prefixCls}-list-item-actions`, {
      picture: listType === 'picture'
    })
  }, downloadIcon, removeIcon));
  const extraContent = typeof customExtra === 'function' ? customExtra(file) : customExtra;
  const extra = extraContent && (/*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-list-item-extra`
  }, extraContent));
  const listItemNameClass = classnames_default()(`${prefixCls}-list-item-name`);
  const fileName = file.url ? (/*#__PURE__*/react.createElement("a", Object.assign({
    key: "view",
    target: "_blank",
    rel: "noopener noreferrer",
    className: listItemNameClass,
    title: file.name
  }, linkProps, {
    href: file.url,
    onClick: e => onPreview(file, e)
  }), file.name, extra)) : (/*#__PURE__*/react.createElement("span", {
    key: "view",
    className: listItemNameClass,
    onClick: e => onPreview(file, e),
    title: file.name
  }, file.name, extra));
  const previewIcon = (typeof showPreviewIcon === 'function' ? showPreviewIcon(file) : showPreviewIcon) && (file.url || file.thumbUrl) ? (/*#__PURE__*/react.createElement("a", {
    href: file.url || file.thumbUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: e => onPreview(file, e),
    title: locale.previewFile
  }, typeof customPreviewIcon === 'function' ? customPreviewIcon(file) : customPreviewIcon || /*#__PURE__*/react.createElement(EyeOutlined/* default */.Z, null))) : null;
  const pictureCardActions = (listType === 'picture-card' || listType === 'picture-circle') && mergedStatus !== 'uploading' && (/*#__PURE__*/react.createElement("span", {
    className: `${prefixCls}-list-item-actions`
  }, previewIcon, mergedStatus === 'done' && downloadIcon, removeIcon));
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  const rootPrefixCls = getPrefixCls();
  const dom = /*#__PURE__*/react.createElement("div", {
    className: listItemClassName
  }, icon, fileName, downloadOrDelete, pictureCardActions, showProgress && (/*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, {
    motionName: `${rootPrefixCls}-fade`,
    visible: mergedStatus === 'uploading',
    motionDeadline: 2000
  }, ({
    className: motionClassName
  }) => {
    // show loading icon if upload progress listener is disabled
    const loadingProgress = 'percent' in file ? (/*#__PURE__*/react.createElement(es_progress, Object.assign({
      type: "line",
      percent: file.percent,
      "aria-label": file['aria-label'],
      "aria-labelledby": file['aria-labelledby']
    }, progressProps))) : null;
    return /*#__PURE__*/react.createElement("div", {
      className: classnames_default()(`${prefixCls}-list-item-progress`, motionClassName)
    }, loadingProgress);
  })));
  const message = file.response && typeof file.response === 'string' ? file.response : ((_a = file.error) === null || _a === void 0 ? void 0 : _a.statusText) || ((_b = file.error) === null || _b === void 0 ? void 0 : _b.message) || locale.uploadError;
  const item = mergedStatus === 'error' ? (/*#__PURE__*/react.createElement(es_tooltip, {
    title: message,
    getPopupContainer: node => node.parentNode
  }, dom)) : dom;
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${prefixCls}-list-item-container`, className),
    style: style,
    ref: ref
  }, itemRender ? itemRender(item, file, items, {
    download: onDownload.bind(null, file),
    preview: onPreview.bind(null, file),
    remove: onClose.bind(null, file)
  }) : item);
});
/* harmony default export */ var UploadList_ListItem = (ListItem_ListItem);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/upload/UploadList/index.js
"use client";

















const InternalUploadList = (props, ref) => {
  const {
    listType = 'text',
    previewFile = previewImage,
    onPreview,
    onDownload,
    onRemove,
    locale,
    iconRender,
    isImageUrl: isImgUrl = isImageUrl,
    prefixCls: customizePrefixCls,
    items = [],
    showPreviewIcon = true,
    showRemoveIcon = true,
    showDownloadIcon = false,
    removeIcon,
    previewIcon,
    downloadIcon,
    extra,
    progress = {
      size: [-1, 2],
      showInfo: false
    },
    appendAction,
    appendActionVisible = true,
    itemRender,
    disabled
  } = props;
  const forceUpdate = useForceUpdate();
  const [motionAppear, setMotionAppear] = react.useState(false);
  const isPictureCardOrCirle = ['picture-card', 'picture-circle'].includes(listType);
  // ============================= Effect =============================
  react.useEffect(() => {
    if (!listType.startsWith('picture')) {
      return;
    }
    (items || []).forEach(file => {
      if (!(file.originFileObj instanceof File || file.originFileObj instanceof Blob) || file.thumbUrl !== undefined) {
        return;
      }
      file.thumbUrl = '';
      previewFile === null || previewFile === void 0 ? void 0 : previewFile(file.originFileObj).then(previewDataUrl => {
        // Need append '' to avoid dead loop
        file.thumbUrl = previewDataUrl || '';
        forceUpdate();
      });
    });
  }, [listType, items, previewFile]);
  react.useEffect(() => {
    setMotionAppear(true);
  }, []);
  // ============================= Events =============================
  const onInternalPreview = (file, e) => {
    if (!onPreview) {
      return;
    }
    e === null || e === void 0 ? void 0 : e.preventDefault();
    return onPreview(file);
  };
  const onInternalDownload = file => {
    if (typeof onDownload === 'function') {
      onDownload(file);
    } else if (file.url) {
      window.open(file.url);
    }
  };
  const onInternalClose = file => {
    onRemove === null || onRemove === void 0 ? void 0 : onRemove(file);
  };
  const internalIconRender = file => {
    if (iconRender) {
      return iconRender(file, listType);
    }
    const isLoading = file.status === 'uploading';
    if (listType.startsWith('picture')) {
      const loadingIcon = listType === 'picture' ? /*#__PURE__*/react.createElement(LoadingOutlined/* default */.Z, null) : locale.uploading;
      const fileIcon = (isImgUrl === null || isImgUrl === void 0 ? void 0 : isImgUrl(file)) ? /*#__PURE__*/react.createElement(PictureTwoTone/* default */.Z, null) : /*#__PURE__*/react.createElement(FileTwoTone/* default */.Z, null);
      return isLoading ? loadingIcon : fileIcon;
    }
    return isLoading ? /*#__PURE__*/react.createElement(LoadingOutlined/* default */.Z, null) : /*#__PURE__*/react.createElement(PaperClipOutlined/* default */.Z, null);
  };
  const actionIconRender = (customIcon, callback, prefixCls, title, acceptUploadDisabled) => {
    const btnProps = {
      type: 'text',
      size: 'small',
      title,
      onClick: e => {
        var _a, _b;
        callback();
        if (/*#__PURE__*/react.isValidElement(customIcon)) {
          (_b = (_a = customIcon.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        }
      },
      className: `${prefixCls}-list-item-action`,
      disabled: acceptUploadDisabled ? disabled : false
    };
    return /*#__PURE__*/react.isValidElement(customIcon) ? (/*#__PURE__*/react.createElement(es_button, Object.assign({}, btnProps, {
      icon: cloneElement(customIcon, Object.assign(Object.assign({}, customIcon.props), {
        onClick: () => {}
      }))
    }))) : (/*#__PURE__*/react.createElement(es_button, Object.assign({}, btnProps), /*#__PURE__*/react.createElement("span", null, customIcon)));
  };
  // ============================== Ref ===============================
  // Test needs
  react.useImperativeHandle(ref, () => ({
    handlePreview: onInternalPreview,
    handleDownload: onInternalDownload
  }));
  const {
    getPrefixCls
  } = react.useContext(ConfigContext);
  // ============================= Render =============================
  const prefixCls = getPrefixCls('upload', customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  const listClassNames = classnames_default()(`${prefixCls}-list`, `${prefixCls}-list-${listType}`);
  const listItemMotion = react.useMemo(() => (0,omit/* default */.Z)(_util_motion(rootPrefixCls), ['onAppearEnd', 'onEnterEnd', 'onLeaveEnd']), [rootPrefixCls]);
  const motionConfig = Object.assign(Object.assign({}, isPictureCardOrCirle ? {} : listItemMotion), {
    motionDeadline: 2000,
    motionName: `${prefixCls}-${isPictureCardOrCirle ? 'animate-inline' : 'animate'}`,
    keys: (0,toConsumableArray/* default */.Z)(items.map(file => ({
      key: file.uid,
      file
    }))),
    motionAppear
  });
  return /*#__PURE__*/react.createElement("div", {
    className: listClassNames
  }, /*#__PURE__*/react.createElement(rc_motion_es/* CSSMotionList */.V4, Object.assign({}, motionConfig, {
    component: false
  }), ({
    key,
    file,
    className: motionClassName,
    style: motionStyle
  }) => (/*#__PURE__*/react.createElement(UploadList_ListItem, {
    key: key,
    locale: locale,
    prefixCls: prefixCls,
    className: motionClassName,
    style: motionStyle,
    file: file,
    items: items,
    progress: progress,
    listType: listType,
    isImgUrl: isImgUrl,
    showPreviewIcon: showPreviewIcon,
    showRemoveIcon: showRemoveIcon,
    showDownloadIcon: showDownloadIcon,
    removeIcon: removeIcon,
    previewIcon: previewIcon,
    downloadIcon: downloadIcon,
    extra: extra,
    iconRender: internalIconRender,
    actionIconRender: actionIconRender,
    itemRender: itemRender,
    onPreview: onInternalPreview,
    onDownload: onInternalDownload,
    onClose: onInternalClose
  }))), appendAction && (/*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, Object.assign({}, motionConfig, {
    visible: appendActionVisible,
    forceRender: true
  }), ({
    className: motionClassName,
    style: motionStyle
  }) => cloneElement(appendAction, oriProps => ({
    className: classnames_default()(oriProps.className, motionClassName),
    style: Object.assign(Object.assign(Object.assign({}, motionStyle), {
      // prevent the element has hover css pseudo-class that may cause animation to end prematurely.
      pointerEvents: motionClassName ? 'none' : undefined
    }), oriProps.style)
  })))));
};
const UploadList = /*#__PURE__*/react.forwardRef(InternalUploadList);
if (false) {}
/* harmony default export */ var upload_UploadList = (UploadList);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/upload/Upload.js
"use client";


var Upload_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};














const LIST_IGNORE = `__LIST_IGNORE_${Date.now()}__`;
const InternalUpload = (props, ref) => {
  const config = useComponentConfig('upload');
  const {
    fileList,
    defaultFileList,
    onRemove,
    showUploadList = true,
    listType = 'text',
    onPreview,
    onDownload,
    onChange,
    onDrop,
    previewFile,
    disabled: customDisabled,
    locale: propLocale,
    iconRender,
    isImageUrl,
    progress,
    prefixCls: customizePrefixCls,
    className,
    type = 'select',
    children,
    style,
    itemRender,
    maxCount,
    data = {},
    multiple = false,
    hasControlInside = true,
    action = '',
    accept = '',
    supportServerRender = true,
    rootClassName
  } = props;
  // ===================== Disabled =====================
  const disabled = react.useContext(config_provider_DisabledContext);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  const customRequest = props.customRequest || config.customRequest;
  const [mergedFileList, setMergedFileList] = (0,useMergedState/* default */.Z)(defaultFileList || [], {
    value: fileList,
    postState: list => list !== null && list !== void 0 ? list : []
  });
  const [dragState, setDragState] = react.useState('drop');
  const upload = react.useRef(null);
  const wrapRef = react.useRef(null);
  if (false) {}
  // Control mode will auto fill file uid if not provided
  react.useMemo(() => {
    const timestamp = Date.now();
    (fileList || []).forEach((file, index) => {
      if (!file.uid && !Object.isFrozen(file)) {
        file.uid = `__AUTO__${timestamp}_${index}__`;
      }
    });
  }, [fileList]);
  const onInternalChange = (file, changedFileList, event) => {
    let cloneList = (0,toConsumableArray/* default */.Z)(changedFileList);
    let exceedMaxCount = false;
    // Cut to match count
    if (maxCount === 1) {
      cloneList = cloneList.slice(-1);
    } else if (maxCount) {
      exceedMaxCount = cloneList.length > maxCount;
      cloneList = cloneList.slice(0, maxCount);
    }
    // Prevent React18 auto batch since input[upload] trigger process at same time
    // which makes fileList closure problem
    // eslint-disable-next-line react-dom/no-flush-sync
    (0,react_dom.flushSync)(() => {
      setMergedFileList(cloneList);
    });
    const changeInfo = {
      file: file,
      fileList: cloneList
    };
    if (event) {
      changeInfo.event = event;
    }
    if (!exceedMaxCount || file.status === 'removed' ||
    // We should ignore event if current file is exceed `maxCount`
    cloneList.some(f => f.uid === file.uid)) {
      // eslint-disable-next-line react-dom/no-flush-sync
      (0,react_dom.flushSync)(() => {
        onChange === null || onChange === void 0 ? void 0 : onChange(changeInfo);
      });
    }
  };
  const mergedBeforeUpload = (file, fileListArgs) => Upload_awaiter(void 0, void 0, void 0, function* () {
    const {
      beforeUpload,
      transformFile
    } = props;
    let parsedFile = file;
    if (beforeUpload) {
      const result = yield beforeUpload(file, fileListArgs);
      if (result === false) {
        return false;
      }
      // Hack for LIST_IGNORE, we add additional info to remove from the list
      delete file[LIST_IGNORE];
      if (result === LIST_IGNORE) {
        Object.defineProperty(file, LIST_IGNORE, {
          value: true,
          configurable: true
        });
        return false;
      }
      if (typeof result === 'object' && result) {
        parsedFile = result;
      }
    }
    if (transformFile) {
      parsedFile = yield transformFile(parsedFile);
    }
    return parsedFile;
  });
  const onBatchStart = batchFileInfoList => {
    // Skip file which marked as `LIST_IGNORE`, these file will not add to file list
    const filteredFileInfoList = batchFileInfoList.filter(info => !info.file[LIST_IGNORE]);
    // Nothing to do since no file need upload
    if (!filteredFileInfoList.length) {
      return;
    }
    const objectFileList = filteredFileInfoList.map(info => file2Obj(info.file));
    // Concat new files with prev files
    let newFileList = (0,toConsumableArray/* default */.Z)(mergedFileList);
    objectFileList.forEach(fileObj => {
      // Replace file if exist
      newFileList = updateFileList(fileObj, newFileList);
    });
    objectFileList.forEach((fileObj, index) => {
      // Repeat trigger `onChange` event for compatible
      let triggerFileObj = fileObj;
      if (!filteredFileInfoList[index].parsedFile) {
        // `beforeUpload` return false
        const {
          originFileObj
        } = fileObj;
        let clone;
        try {
          clone = new File([originFileObj], originFileObj.name, {
            type: originFileObj.type
          });
        } catch (_a) {
          clone = new Blob([originFileObj], {
            type: originFileObj.type
          });
          clone.name = originFileObj.name;
          clone.lastModifiedDate = new Date();
          clone.lastModified = new Date().getTime();
        }
        clone.uid = fileObj.uid;
        triggerFileObj = clone;
      } else {
        // Inject `uploading` status
        fileObj.status = 'uploading';
      }
      onInternalChange(triggerFileObj, newFileList);
    });
  };
  const onSuccess = (response, file, xhr) => {
    try {
      if (typeof response === 'string') {
        response = JSON.parse(response);
      }
    } catch (_a) {
      /* do nothing */
    }
    // removed
    if (!getFileItem(file, mergedFileList)) {
      return;
    }
    const targetItem = file2Obj(file);
    targetItem.status = 'done';
    targetItem.percent = 100;
    targetItem.response = response;
    targetItem.xhr = xhr;
    const nextFileList = updateFileList(targetItem, mergedFileList);
    onInternalChange(targetItem, nextFileList);
  };
  const onProgress = (e, file) => {
    // removed
    if (!getFileItem(file, mergedFileList)) {
      return;
    }
    const targetItem = file2Obj(file);
    targetItem.status = 'uploading';
    targetItem.percent = e.percent;
    const nextFileList = updateFileList(targetItem, mergedFileList);
    onInternalChange(targetItem, nextFileList, e);
  };
  const onError = (error, response, file) => {
    // removed
    if (!getFileItem(file, mergedFileList)) {
      return;
    }
    const targetItem = file2Obj(file);
    targetItem.error = error;
    targetItem.response = response;
    targetItem.status = 'error';
    const nextFileList = updateFileList(targetItem, mergedFileList);
    onInternalChange(targetItem, nextFileList);
  };
  const handleRemove = file => {
    let currentFile;
    Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then(ret => {
      var _a;
      // Prevent removing file
      if (ret === false) {
        return;
      }
      const removedFileList = removeFileItem(file, mergedFileList);
      if (removedFileList) {
        currentFile = Object.assign(Object.assign({}, file), {
          status: 'removed'
        });
        mergedFileList === null || mergedFileList === void 0 ? void 0 : mergedFileList.forEach(item => {
          const matchKey = currentFile.uid !== undefined ? 'uid' : 'name';
          if (item[matchKey] === currentFile[matchKey] && !Object.isFrozen(item)) {
            item.status = 'removed';
          }
        });
        (_a = upload.current) === null || _a === void 0 ? void 0 : _a.abort(currentFile);
        onInternalChange(currentFile, removedFileList);
      }
    });
  };
  const onFileDrop = e => {
    setDragState(e.type);
    if (e.type === 'drop') {
      onDrop === null || onDrop === void 0 ? void 0 : onDrop(e);
    }
  };
  // Test needs
  react.useImperativeHandle(ref, () => ({
    onBatchStart,
    onSuccess,
    onProgress,
    onError,
    fileList: mergedFileList,
    upload: upload.current,
    nativeElement: wrapRef.current
  }));
  const {
    getPrefixCls,
    direction,
    upload: ctxUpload
  } = react.useContext(ConfigContext);
  const prefixCls = getPrefixCls('upload', customizePrefixCls);
  const rcUploadProps = Object.assign(Object.assign({
    onBatchStart,
    onError,
    onProgress,
    onSuccess
  }, props), {
    customRequest,
    data,
    multiple,
    action,
    accept,
    supportServerRender,
    prefixCls,
    disabled: mergedDisabled,
    beforeUpload: mergedBeforeUpload,
    onChange: undefined,
    hasControlInside
  });
  delete rcUploadProps.className;
  delete rcUploadProps.style;
  // Remove id to avoid open by label when trigger is hidden
  // !children: https://github.com/ant-design/ant-design/issues/14298
  // disabled: https://github.com/ant-design/ant-design/issues/16478
  //           https://github.com/ant-design/ant-design/issues/24197
  if (!children || mergedDisabled) {
    delete rcUploadProps.id;
  }
  const wrapperCls = `${prefixCls}-wrapper`;
  const [wrapCSSVar, hashId, cssVarCls] = upload_style(prefixCls, wrapperCls);
  const [contextLocale] = locale_useLocale('Upload', es_locale_en_US.Upload);
  const {
    showRemoveIcon,
    showPreviewIcon,
    showDownloadIcon,
    removeIcon,
    previewIcon,
    downloadIcon,
    extra
  } = typeof showUploadList === 'boolean' ? {} : showUploadList;
  // use showRemoveIcon if it is specified explicitly
  const realShowRemoveIcon = typeof showRemoveIcon === 'undefined' ? !mergedDisabled : showRemoveIcon;
  const renderUploadList = (button, buttonVisible) => {
    if (!showUploadList) {
      return button;
    }
    return /*#__PURE__*/react.createElement(upload_UploadList, {
      prefixCls: prefixCls,
      listType: listType,
      items: mergedFileList,
      previewFile: previewFile,
      onPreview: onPreview,
      onDownload: onDownload,
      onRemove: handleRemove,
      showRemoveIcon: realShowRemoveIcon,
      showPreviewIcon: showPreviewIcon,
      showDownloadIcon: showDownloadIcon,
      removeIcon: removeIcon,
      previewIcon: previewIcon,
      downloadIcon: downloadIcon,
      iconRender: iconRender,
      extra: extra,
      locale: Object.assign(Object.assign({}, contextLocale), propLocale),
      isImageUrl: isImageUrl,
      progress: progress,
      appendAction: button,
      appendActionVisible: buttonVisible,
      itemRender: itemRender,
      disabled: mergedDisabled
    });
  };
  const mergedCls = classnames_default()(wrapperCls, className, rootClassName, hashId, cssVarCls, ctxUpload === null || ctxUpload === void 0 ? void 0 : ctxUpload.className, {
    [`${prefixCls}-rtl`]: direction === 'rtl',
    [`${prefixCls}-picture-card-wrapper`]: listType === 'picture-card',
    [`${prefixCls}-picture-circle-wrapper`]: listType === 'picture-circle'
  });
  const mergedStyle = Object.assign(Object.assign({}, ctxUpload === null || ctxUpload === void 0 ? void 0 : ctxUpload.style), style);
  // ======================== Render ========================
  if (type === 'drag') {
    const dragCls = classnames_default()(hashId, prefixCls, `${prefixCls}-drag`, {
      [`${prefixCls}-drag-uploading`]: mergedFileList.some(file => file.status === 'uploading'),
      [`${prefixCls}-drag-hover`]: dragState === 'dragover',
      [`${prefixCls}-disabled`]: mergedDisabled,
      [`${prefixCls}-rtl`]: direction === 'rtl'
    });
    return wrapCSSVar(/*#__PURE__*/react.createElement("span", {
      className: mergedCls,
      ref: wrapRef
    }, /*#__PURE__*/react.createElement("div", {
      className: dragCls,
      style: mergedStyle,
      onDrop: onFileDrop,
      onDragOver: onFileDrop,
      onDragLeave: onFileDrop
    }, /*#__PURE__*/react.createElement(rc_upload_es/* default */.Z, Object.assign({}, rcUploadProps, {
      ref: upload,
      className: `${prefixCls}-btn`
    }), /*#__PURE__*/react.createElement("div", {
      className: `${prefixCls}-drag-container`
    }, children))), renderUploadList()));
  }
  const uploadBtnCls = classnames_default()(prefixCls, `${prefixCls}-select`, {
    [`${prefixCls}-disabled`]: mergedDisabled,
    [`${prefixCls}-hidden`]: !children
  });
  const uploadButton = /*#__PURE__*/react.createElement("div", {
    className: uploadBtnCls,
    style: mergedStyle
  }, /*#__PURE__*/react.createElement(rc_upload_es/* default */.Z, Object.assign({}, rcUploadProps, {
    ref: upload
  })));
  if (listType === 'picture-card' || listType === 'picture-circle') {
    return wrapCSSVar(/*#__PURE__*/react.createElement("span", {
      className: mergedCls,
      ref: wrapRef
    }, renderUploadList(uploadButton, !!children)));
  }
  return wrapCSSVar(/*#__PURE__*/react.createElement("span", {
    className: mergedCls,
    ref: wrapRef
  }, uploadButton, renderUploadList()));
};
const Upload = /*#__PURE__*/react.forwardRef(InternalUpload);
if (false) {}
/* harmony default export */ var upload_Upload = (Upload);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/upload/Dragger.js
"use client";

var Dragger_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


const Dragger = /*#__PURE__*/react.forwardRef((_a, ref) => {
  var {
      style,
      height,
      hasControlInside = false
    } = _a,
    restProps = Dragger_rest(_a, ["style", "height", "hasControlInside"]);
  return /*#__PURE__*/react.createElement(upload_Upload, Object.assign({
    ref: ref,
    hasControlInside: hasControlInside
  }, restProps, {
    type: "drag",
    style: Object.assign(Object.assign({}, style), {
      height
    })
  }));
});
if (false) {}
/* harmony default export */ var upload_Dragger = (Dragger);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/upload/index.js
"use client";



const es_upload_Upload = upload_Upload;
es_upload_Upload.Dragger = upload_Dragger;
es_upload_Upload.LIST_IGNORE = LIST_IGNORE;
/* harmony default export */ var upload = (es_upload_Upload);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js
var createSuper = __webpack_require__(56302);
;// CONCATENATED MODULE: ./node_modules/@rc-component/mutate-observer/es/wrapper.js





var wrapper_DomWrapper = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(DomWrapper, _React$Component);
  var _super = (0,createSuper/* default */.Z)(DomWrapper);
  function DomWrapper() {
    (0,classCallCheck/* default */.Z)(this, DomWrapper);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(DomWrapper, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return DomWrapper;
}(react.Component);
/* harmony default export */ var wrapper = ((/* unused pure expression or super */ null && (wrapper_DomWrapper)));
;// CONCATENATED MODULE: ./node_modules/@rc-component/mutate-observer/es/useMutateObserver.js


var defaultOptions = {
  subtree: true,
  childList: true,
  attributeFilter: ['style', 'class']
};
function useMutateObserver_useMutateObserver(nodeOrList, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultOptions;
  react.useEffect(function () {
    if (!(0,canUseDom/* default */.Z)() || !nodeOrList) {
      return;
    }
    var instance;
    var nodeList = Array.isArray(nodeOrList) ? nodeOrList : [nodeOrList];
    if ('MutationObserver' in window) {
      instance = new MutationObserver(callback);
      nodeList.forEach(function (element) {
        instance.observe(element, options);
      });
    }
    return function () {
      var _instance, _instance2;
      (_instance = instance) === null || _instance === void 0 ? void 0 : _instance.takeRecords();
      (_instance2 = instance) === null || _instance2 === void 0 ? void 0 : _instance2.disconnect();
    };
  }, [options, nodeOrList]);
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/mutate-observer/es/MutateObserver.js








var MutateObserver_MutateObserver = function MutateObserver(props) {
  var children = props.children,
    options = props.options,
    _props$onMutate = props.onMutate,
    onMutate = _props$onMutate === void 0 ? function () {} : _props$onMutate;
  var callback = useEvent(onMutate);
  var wrapperRef = React.useRef(null);
  var elementRef = React.useRef(null);
  var canRef = /*#__PURE__*/React.isValidElement(children) && supportRef(children);
  var mergedRef = useComposeRef(elementRef, canRef ? children.ref : null);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    target = _React$useState2[0],
    setTarget = _React$useState2[1];
  useMutateObserver(target, callback, options);

  // =========================== Effect ===========================
  // Bind target
  useLayoutEffect(function () {
    setTarget(findDOMNode(elementRef.current) || findDOMNode(wrapperRef.current));
  });

  // =========================== Render ===========================
  if (!children) {
    if (false) {}
    return null;
  }
  return /*#__PURE__*/React.createElement(DomWrapper, {
    ref: wrapperRef
  }, canRef ? /*#__PURE__*/React.cloneElement(children, {
    ref: mergedRef
  }) : children);
};
/* harmony default export */ var es_MutateObserver = ((/* unused pure expression or super */ null && (MutateObserver_MutateObserver)));
;// CONCATENATED MODULE: ./node_modules/@rc-component/mutate-observer/es/index.js



/* harmony default export */ var mutate_observer_es = ((/* unused pure expression or super */ null && (MutateObserver)));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/watermark/useClips.js


const FontGap = 3;
const prepareCanvas = (width, height, ratio = 1) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const realWidth = width * ratio;
  const realHeight = height * ratio;
  canvas.setAttribute('width', `${realWidth}px`);
  canvas.setAttribute('height', `${realHeight}px`);
  ctx.save();
  return [ctx, canvas, realWidth, realHeight];
};
// Get boundary of rotated text
const getRotatePos = (x, y, angle) => {
  const targetX = x * Math.cos(angle) - y * Math.sin(angle);
  const targetY = x * Math.sin(angle) + y * Math.cos(angle);
  return [targetX, targetY];
};
/**
 * Get the clips of text content.
 * This is a lazy hook function since SSR no need this
 */
const useClips = () => {
  // Get single clips
  const getClips = (content, rotate, ratio, width, height, font, gapX, gapY) => {
    // ================= Text / Image =================
    const [ctx, canvas, contentWidth, contentHeight] = prepareCanvas(width, height, ratio);
    if (content instanceof HTMLImageElement) {
      // Image
      ctx.drawImage(content, 0, 0, contentWidth, contentHeight);
    } else {
      // Text
      const {
        color,
        fontSize,
        fontStyle,
        fontWeight,
        fontFamily,
        textAlign
      } = font;
      const mergedFontSize = Number(fontSize) * ratio;
      ctx.font = `${fontStyle} normal ${fontWeight} ${mergedFontSize}px/${height}px ${fontFamily}`;
      ctx.fillStyle = color;
      ctx.textAlign = textAlign;
      ctx.textBaseline = 'top';
      const contents = _util_toList(content);
      contents === null || contents === void 0 ? void 0 : contents.forEach((item, index) => {
        ctx.fillText(item !== null && item !== void 0 ? item : '', contentWidth / 2, index * (mergedFontSize + FontGap * ratio));
      });
    }
    // ==================== Rotate ====================
    const angle = Math.PI / 180 * Number(rotate);
    const maxSize = Math.max(width, height);
    const [rCtx, rCanvas, realMaxSize] = prepareCanvas(maxSize, maxSize, ratio);
    // Copy from `ctx` and rotate
    rCtx.translate(realMaxSize / 2, realMaxSize / 2);
    rCtx.rotate(angle);
    if (contentWidth > 0 && contentHeight > 0) {
      rCtx.drawImage(canvas, -contentWidth / 2, -contentHeight / 2);
    }
    let left = 0;
    let right = 0;
    let top = 0;
    let bottom = 0;
    const halfWidth = contentWidth / 2;
    const halfHeight = contentHeight / 2;
    const points = [[0 - halfWidth, 0 - halfHeight], [0 + halfWidth, 0 - halfHeight], [0 + halfWidth, 0 + halfHeight], [0 - halfWidth, 0 + halfHeight]];
    points.forEach(([x, y]) => {
      const [targetX, targetY] = getRotatePos(x, y, angle);
      left = Math.min(left, targetX);
      right = Math.max(right, targetX);
      top = Math.min(top, targetY);
      bottom = Math.max(bottom, targetY);
    });
    const cutLeft = left + realMaxSize / 2;
    const cutTop = top + realMaxSize / 2;
    const cutWidth = right - left;
    const cutHeight = bottom - top;
    // ================ Fill Alternate ================
    const realGapX = gapX * ratio;
    const realGapY = gapY * ratio;
    const filledWidth = (cutWidth + realGapX) * 2;
    const filledHeight = cutHeight + realGapY;
    const [fCtx, fCanvas] = prepareCanvas(filledWidth, filledHeight);
    const drawImg = (targetX = 0, targetY = 0) => {
      fCtx.drawImage(rCanvas, cutLeft, cutTop, cutWidth, cutHeight, targetX, targetY, cutWidth, cutHeight);
    };
    drawImg();
    drawImg(cutWidth + realGapX, -cutHeight / 2 - realGapY / 2);
    drawImg(cutWidth + realGapX, +cutHeight / 2 + realGapY / 2);
    return [fCanvas.toDataURL(), filledWidth / ratio, filledHeight / ratio];
  };
  return react.useCallback(getClips, []);
};
/* harmony default export */ var watermark_useClips = (useClips);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/watermark/useRafDebounce.js



/**
 * Callback will only execute last one for each raf
 */
function useRafDebounce(callback) {
  const executeRef = react.useRef(false);
  const rafRef = react.useRef(null);
  const wrapperCallback = (0,hooks_useEvent/* default */.Z)(callback);
  return () => {
    if (executeRef.current) {
      return;
    }
    executeRef.current = true;
    wrapperCallback();
    rafRef.current = (0,raf/* default */.Z)(() => {
      executeRef.current = false;
    });
  };
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/watermark/useSingletonCache.js


/**
 * Singleton cache will only take latest `cacheParams` as key
 * and return the result for callback matching.
 */
function useSingletonCache() {
  const cacheRef = react.useRef([null, null]);
  const getCache = (cacheKeys, callback) => {
    const filteredKeys = cacheKeys.map(item => item instanceof HTMLElement || Number.isNaN(item) ? '' : item);
    if (!(0,isEqual/* default */.Z)(cacheRef.current[0], filteredKeys)) {
      cacheRef.current = [filteredKeys, callback()];
    }
    return cacheRef.current[1];
  };
  return getCache;
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/watermark/utils.js
/** converting camel-cased strings to be lowercase and link it with Separator */
function toLowercaseSeparator(key) {
  return key.replace(/([A-Z])/g, '-$1').toLowerCase();
}
function getStyleStr(style) {
  return Object.keys(style).map(key => `${toLowercaseSeparator(key)}: ${style[key]};`).join(' ');
}
/** Returns the ratio of the device's physical pixel resolution to the css pixel resolution */
function getPixelRatio() {
  return window.devicePixelRatio || 1;
}
/** Whether to re-render the watermark */
const reRendering = (mutation, isWatermarkEle) => {
  let flag = false;
  // Whether to delete the watermark node
  if (mutation.removedNodes.length) {
    flag = Array.from(mutation.removedNodes).some(node => isWatermarkEle(node));
  }
  // Whether the watermark dom property value has been modified
  if (mutation.type === 'attributes' && isWatermarkEle(mutation.target)) {
    flag = true;
  }
  return flag;
};
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/watermark/useWatermark.js


/**
 * Base size of the canvas, 1 for parallel layout and 2 for alternate layout
 * Only alternate layout is currently supported
 */
const BaseSize = 2;
const useWatermark_FontGap = 3;
// Prevent external hidden elements from adding accent styles
const emphasizedStyle = {
  visibility: 'visible !important'
};
function useWatermark(markStyle) {
  const watermarkMap = react.useRef(new Map());
  const appendWatermark = (base64Url, markWidth, container) => {
    if (container) {
      if (!watermarkMap.current.get(container)) {
        const newWatermarkEle = document.createElement('div');
        watermarkMap.current.set(container, newWatermarkEle);
      }
      const watermarkEle = watermarkMap.current.get(container);
      watermarkEle.setAttribute('style', getStyleStr(Object.assign(Object.assign(Object.assign({}, markStyle), {
        backgroundImage: `url('${base64Url}')`,
        backgroundSize: `${Math.floor(markWidth)}px`
      }), emphasizedStyle)));
      // Prevents using the browser `Hide Element` to hide watermarks
      watermarkEle.removeAttribute('class');
      watermarkEle.removeAttribute('hidden');
      if (watermarkEle.parentElement !== container) {
        container.append(watermarkEle);
      }
    }
    return watermarkMap.current.get(container);
  };
  const removeWatermark = container => {
    const watermarkEle = watermarkMap.current.get(container);
    if (watermarkEle && container) {
      container.removeChild(watermarkEle);
    }
    watermarkMap.current.delete(container);
  };
  const isWatermarkEle = ele => Array.from(watermarkMap.current.values()).includes(ele);
  return [appendWatermark, removeWatermark, isWatermarkEle];
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/watermark/index.js
"use client";














/**
 * Only return `next` when size changed.
 * This is only used for elements compare, not a shallow equal!
 */
function getSizeDiff(prev, next) {
  return prev.size === next.size ? prev : next;
}
const DEFAULT_GAP_X = 100;
const DEFAULT_GAP_Y = 100;
const fixedStyle = {
  position: 'relative',
  overflow: 'hidden'
};
const Watermark = props => {
  var _a, _b;
  const {
    /**
     * The antd content layer zIndex is basically below 10
     * https://github.com/ant-design/ant-design/blob/6192403b2ce517c017f9e58a32d58774921c10cd/components/style/themes/default.less#L335
     */
    zIndex = 9,
    rotate = -22,
    width,
    height,
    image,
    content,
    font = {},
    style,
    className,
    rootClassName,
    gap = [DEFAULT_GAP_X, DEFAULT_GAP_Y],
    offset,
    children,
    inherit = true
  } = props;
  const mergedStyle = Object.assign(Object.assign({}, fixedStyle), style);
  const [, token] = useToken();
  const {
    color = token.colorFill,
    fontSize = token.fontSizeLG,
    fontWeight = 'normal',
    fontStyle = 'normal',
    fontFamily = 'sans-serif',
    textAlign = 'center'
  } = font;
  const [gapX = DEFAULT_GAP_X, gapY = DEFAULT_GAP_Y] = gap;
  const gapXCenter = gapX / 2;
  const gapYCenter = gapY / 2;
  const offsetLeft = (_a = offset === null || offset === void 0 ? void 0 : offset[0]) !== null && _a !== void 0 ? _a : gapXCenter;
  const offsetTop = (_b = offset === null || offset === void 0 ? void 0 : offset[1]) !== null && _b !== void 0 ? _b : gapYCenter;
  const markStyle = react.useMemo(() => {
    const mergedMarkStyle = {
      zIndex,
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
      backgroundRepeat: 'repeat'
    };
    /** Calculate the style of the offset */
    let positionLeft = offsetLeft - gapXCenter;
    let positionTop = offsetTop - gapYCenter;
    if (positionLeft > 0) {
      mergedMarkStyle.left = `${positionLeft}px`;
      mergedMarkStyle.width = `calc(100% - ${positionLeft}px)`;
      positionLeft = 0;
    }
    if (positionTop > 0) {
      mergedMarkStyle.top = `${positionTop}px`;
      mergedMarkStyle.height = `calc(100% - ${positionTop}px)`;
      positionTop = 0;
    }
    mergedMarkStyle.backgroundPosition = `${positionLeft}px ${positionTop}px`;
    return mergedMarkStyle;
  }, [zIndex, offsetLeft, gapXCenter, offsetTop, gapYCenter]);
  const [container, setContainer] = react.useState();
  // Used for nest case like Modal, Drawer
  const [subElements, setSubElements] = react.useState(() => new Set());
  // Nest elements should also support watermark
  const targetElements = react.useMemo(() => {
    const list = container ? [container] : [];
    return [].concat(list, (0,toConsumableArray/* default */.Z)(Array.from(subElements)));
  }, [container, subElements]);
  // ============================ Content =============================
  /**
   * Get the width and height of the watermark. The default values are as follows
   * Image: [120, 64]; Content: It's calculated by content;
   */
  const getMarkSize = ctx => {
    let defaultWidth = 120;
    let defaultHeight = 64;
    if (!image && ctx.measureText) {
      ctx.font = `${Number(fontSize)}px ${fontFamily}`;
      const contents = _util_toList(content);
      const sizes = contents.map(item => {
        const metrics = ctx.measureText(item);
        return [metrics.width, metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent];
      });
      defaultWidth = Math.ceil(Math.max.apply(Math, (0,toConsumableArray/* default */.Z)(sizes.map(size => size[0]))));
      defaultHeight = Math.ceil(Math.max.apply(Math, (0,toConsumableArray/* default */.Z)(sizes.map(size => size[1])))) * contents.length + (contents.length - 1) * FontGap;
    }
    return [width !== null && width !== void 0 ? width : defaultWidth, height !== null && height !== void 0 ? height : defaultHeight];
  };
  const getClips = watermark_useClips();
  const getClipsCache = useSingletonCache();
  const [watermarkInfo, setWatermarkInfo] = react.useState(null);
  // Generate new Watermark content
  const renderWatermark = () => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (ctx) {
      const ratio = getPixelRatio();
      const [markWidth, markHeight] = getMarkSize(ctx);
      const drawCanvas = drawContent => {
        const params = [drawContent || '', rotate, ratio, markWidth, markHeight, {
          color,
          fontSize,
          fontStyle,
          fontWeight,
          fontFamily,
          textAlign
        }, gapX, gapY];
        const [nextClips, clipWidth] = getClipsCache(params, () => getClips.apply(void 0, params));
        setWatermarkInfo([nextClips, clipWidth]);
      };
      if (image) {
        const img = new Image();
        img.onload = () => {
          drawCanvas(img);
        };
        img.onerror = () => {
          drawCanvas(content);
        };
        img.crossOrigin = 'anonymous';
        img.referrerPolicy = 'no-referrer';
        img.src = image;
      } else {
        drawCanvas(content);
      }
    }
  };
  const syncWatermark = useRafDebounce(renderWatermark);
  // ============================= Effect =============================
  // Append watermark to the container
  const [appendWatermark, removeWatermark, isWatermarkEle] = useWatermark(markStyle);
  (0,react.useEffect)(() => {
    if (watermarkInfo) {
      targetElements.forEach(holder => {
        appendWatermark(watermarkInfo[0], watermarkInfo[1], holder);
      });
    }
  }, [watermarkInfo, targetElements]);
  // ============================ Observe =============================
  const onMutate = (0,hooks_useEvent/* default */.Z)(mutations => {
    mutations.forEach(mutation => {
      if (reRendering(mutation, isWatermarkEle)) {
        syncWatermark();
      } else if (mutation.target === container && mutation.attributeName === 'style') {
        // We've only force container not modify.
        // Not consider nest case.
        const keyStyles = Object.keys(fixedStyle);
        for (let i = 0; i < keyStyles.length; i += 1) {
          const key = keyStyles[i];
          const oriValue = mergedStyle[key];
          const currentValue = container.style[key];
          if (oriValue && oriValue !== currentValue) {
            container.style[key] = oriValue;
          }
        }
      }
    });
  });
  useMutateObserver_useMutateObserver(targetElements, onMutate);
  (0,react.useEffect)(syncWatermark, [rotate, zIndex, width, height, image, content, color, fontSize, fontWeight, fontStyle, fontFamily, textAlign, gapX, gapY, offsetLeft, offsetTop]);
  // ============================ Context =============================
  const watermarkContext = react.useMemo(() => ({
    add: ele => {
      setSubElements(prev => {
        const clone = new Set(prev);
        clone.add(ele);
        return getSizeDiff(prev, clone);
      });
    },
    remove: ele => {
      removeWatermark(ele);
      setSubElements(prev => {
        const clone = new Set(prev);
        clone.delete(ele);
        return getSizeDiff(prev, clone);
      });
    }
  }), []);
  // ============================= Render =============================
  const childNode = inherit ? (/*#__PURE__*/react.createElement(context.Provider, {
    value: watermarkContext
  }, children)) : children;
  return /*#__PURE__*/react.createElement("div", {
    ref: setContainer,
    className: classnames_default()(className, rootClassName),
    style: mergedStyle
  }, childNode);
};
if (false) {}
/* harmony default export */ var watermark = (Watermark);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/splitter/Panel.js
"use client";



const InternalPanel = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  const {
    prefixCls,
    className,
    children,
    size,
    style = {}
  } = props;
  const panelClassName = classnames_default()(`${prefixCls}-panel`, {
    [`${prefixCls}-panel-hidden`]: size === 0
  }, className);
  const hasSize = size !== undefined;
  return /*#__PURE__*/react.createElement("div", {
    ref: ref,
    className: panelClassName,
    style: Object.assign(Object.assign({}, style), {
      // Use auto when start from ssr
      flexBasis: hasSize ? size : 'auto',
      flexGrow: hasSize ? 0 : 1
    })
  }, children);
});
if (false) {}
const Panel_Panel = () => null;
/* harmony default export */ var splitter_Panel = (Panel_Panel);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/splitter/hooks/useItems.js
var splitter_hooks_useItems_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


function getCollapsible(collapsible) {
  if (collapsible && typeof collapsible === 'object') {
    return Object.assign(Object.assign({}, collapsible), {
      showCollapsibleIcon: collapsible.showCollapsibleIcon === undefined ? 'auto' : collapsible.showCollapsibleIcon
    });
  }
  const mergedCollapsible = !!collapsible;
  return {
    start: mergedCollapsible,
    end: mergedCollapsible,
    showCollapsibleIcon: 'auto'
  };
}
/**
 * Convert `children` into `items`.
 */
function hooks_useItems_useItems(children) {
  const items = react.useMemo(() => (0,Children_toArray/* default */.Z)(children).filter(item => /*#__PURE__*/react.isValidElement(item)).map(node => {
    const {
      props
    } = node;
    const {
        collapsible
      } = props,
      restProps = splitter_hooks_useItems_rest(props, ["collapsible"]);
    return Object.assign(Object.assign({}, restProps), {
      collapsible: getCollapsible(collapsible)
    });
  }), [children]);
  return items;
}
/* harmony default export */ var hooks_useItems = (hooks_useItems_useItems);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/splitter/hooks/useResizable.js

function getShowCollapsibleIcon(prev, next) {
  if (prev.collapsible && next.collapsible) {
    if (prev.showCollapsibleIcon === true || next.showCollapsibleIcon === true) {
      return true;
    }
    if (prev.showCollapsibleIcon === 'auto' || next.showCollapsibleIcon === 'auto') {
      return 'auto';
    }
    return false;
  }
  if (prev.collapsible) {
    return prev.showCollapsibleIcon;
  }
  if (next.collapsible) {
    return next.showCollapsibleIcon;
  }
  return false;
}
function useResizable(items, pxSizes, isRTL) {
  return react.useMemo(() => {
    const resizeInfos = [];
    for (let i = 0; i < items.length - 1; i += 1) {
      const prevItem = items[i];
      const nextItem = items[i + 1];
      const prevSize = pxSizes[i];
      const nextSize = pxSizes[i + 1];
      const {
        resizable: prevResizable = true,
        min: prevMin,
        collapsible: prevCollapsible
      } = prevItem;
      const {
        resizable: nextResizable = true,
        min: nextMin,
        collapsible: nextCollapsible
      } = nextItem;
      const mergedResizable =
      // Both need to be resizable
      prevResizable && nextResizable && (
      // Prev is not collapsed and limit min size
      prevSize !== 0 || !prevMin) && (
      // Next is not collapsed and limit min size
      nextSize !== 0 || !nextMin);
      const prevEndCollapsible = !!prevCollapsible.end && prevSize > 0;
      const nextStartExpandable = !!nextCollapsible.start && nextSize === 0 && prevSize > 0;
      const startCollapsible = prevEndCollapsible || nextStartExpandable;
      const nextStartCollapsible = !!nextCollapsible.start && nextSize > 0;
      const prevEndExpandable = !!prevCollapsible.end && prevSize === 0 && nextSize > 0;
      const endCollapsible = nextStartCollapsible || prevEndExpandable;
      const showStartCollapsibleIcon = getShowCollapsibleIcon({
        collapsible: prevEndCollapsible,
        showCollapsibleIcon: prevCollapsible.showCollapsibleIcon
      }, {
        collapsible: nextStartExpandable,
        showCollapsibleIcon: nextCollapsible.showCollapsibleIcon
      });
      const showEndCollapsibleIcon = getShowCollapsibleIcon({
        collapsible: nextStartCollapsible,
        showCollapsibleIcon: nextCollapsible.showCollapsibleIcon
      }, {
        collapsible: prevEndExpandable,
        showCollapsibleIcon: prevCollapsible.showCollapsibleIcon
      });
      resizeInfos[i] = {
        resizable: mergedResizable,
        startCollapsible: !!(isRTL ? endCollapsible : startCollapsible),
        endCollapsible: !!(isRTL ? startCollapsible : endCollapsible),
        showStartCollapsibleIcon: isRTL ? showEndCollapsibleIcon : showStartCollapsibleIcon,
        showEndCollapsibleIcon: isRTL ? showStartCollapsibleIcon : showEndCollapsibleIcon
      };
    }
    return resizeInfos;
  }, [pxSizes, items]);
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/splitter/hooks/useSizes.js

function getPtg(str) {
  return Number(str.slice(0, -1)) / 100;
}
function isPtg(itemSize) {
  return typeof itemSize === 'string' && itemSize.endsWith('%');
}
/**
 * Save the size state.
 * Align the size into flex percentage base.
 */
function useSizes(items, containerSize) {
  const propSizes = items.map(item => item.size);
  const itemsCount = items.length;
  const mergedContainerSize = containerSize || 0;
  const ptg2px = ptg => ptg * mergedContainerSize;
  // We do not need care the size state match the `items` length in `useState`.
  // It will calculate later.
  const [innerSizes, setInnerSizes] = react.useState(() => items.map(item => item.defaultSize));
  const sizes = react.useMemo(() => {
    var _a;
    const mergedSizes = [];
    for (let i = 0; i < itemsCount; i += 1) {
      mergedSizes[i] = (_a = propSizes[i]) !== null && _a !== void 0 ? _a : innerSizes[i];
    }
    return mergedSizes;
  }, [itemsCount, innerSizes, propSizes]);
  // Post handle the size. Will do:
  // 1. Convert all the px into percentage if not empty.
  // 2. Get rest percentage for exist percentage.
  // 3. Fill the rest percentage into empty item.
  const postPercentSizes = react.useMemo(() => {
    let ptgList = [];
    let emptyCount = 0;
    // Fill default percentage
    for (let i = 0; i < itemsCount; i += 1) {
      const itemSize = sizes[i];
      if (isPtg(itemSize)) {
        ptgList[i] = getPtg(itemSize);
      } else if (itemSize || itemSize === 0) {
        const num = Number(itemSize);
        if (!Number.isNaN(num)) {
          ptgList[i] = num / mergedContainerSize;
        }
      } else {
        emptyCount += 1;
        ptgList[i] = undefined;
      }
    }
    const totalPtg = ptgList.reduce((acc, ptg) => acc + (ptg || 0), 0);
    if (totalPtg > 1 || !emptyCount) {
      // If total percentage is larger than 1, we will scale it down.
      const scale = 1 / totalPtg;
      ptgList = ptgList.map(ptg => ptg === undefined ? 0 : ptg * scale);
    } else {
      // If total percentage is smaller than 1, we will fill the rest.
      const avgRest = (1 - totalPtg) / emptyCount;
      ptgList = ptgList.map(ptg => ptg === undefined ? avgRest : ptg);
    }
    return ptgList;
  }, [sizes, mergedContainerSize]);
  const postPxSizes = react.useMemo(() => postPercentSizes.map(ptg2px), [postPercentSizes, mergedContainerSize]);
  const postPercentMinSizes = react.useMemo(() => items.map(item => {
    if (isPtg(item.min)) {
      return getPtg(item.min);
    }
    return (item.min || 0) / mergedContainerSize;
  }), [items, mergedContainerSize]);
  const postPercentMaxSizes = react.useMemo(() => items.map(item => {
    if (isPtg(item.max)) {
      return getPtg(item.max);
    }
    return (item.max || mergedContainerSize) / mergedContainerSize;
  }), [items, mergedContainerSize]);
  // If ssr, we will use the size from developer config first.
  const panelSizes = react.useMemo(() => containerSize ? postPxSizes : sizes, [postPxSizes, containerSize]);
  return [panelSizes, postPxSizes, postPercentSizes, postPercentMinSizes, postPercentMaxSizes, setInnerSizes];
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/splitter/hooks/useResize.js



/**
 * Handle user drag resize logic.
 */
function useResize(items, resizableInfos, percentSizes, containerSize, updateSizes, isRTL) {
  const limitSizes = items.map(item => [item.min, item.max]);
  const mergedContainerSize = containerSize || 0;
  const ptg2px = ptg => ptg * mergedContainerSize;
  // ======================== Resize ========================
  function getLimitSize(str, defaultLimit) {
    if (typeof str === 'string') {
      return ptg2px(getPtg(str));
    }
    return str !== null && str !== void 0 ? str : defaultLimit;
  }
  // Real px sizes
  const [cacheSizes, setCacheSizes] = react.useState([]);
  const cacheCollapsedSize = react.useRef([]);
  /**
   * When start drag, check the direct is `start` or `end`.
   * This will handle when 2 splitter bar are in the same position.
   */
  const [movingIndex, setMovingIndex] = react.useState(null);
  const getPxSizes = () => percentSizes.map(ptg2px);
  const onOffsetStart = index => {
    setCacheSizes(getPxSizes());
    setMovingIndex({
      index,
      confirmed: false
    });
  };
  const onOffsetUpdate = (index, offset) => {
    var _a;
    // First time trigger move index update is not sync in the state
    let confirmedIndex = null;
    // We need to know what the real index is.
    if ((!movingIndex || !movingIndex.confirmed) && offset !== 0) {
      // Search for the real index
      if (offset > 0) {
        confirmedIndex = index;
        setMovingIndex({
          index,
          confirmed: true
        });
      } else {
        for (let i = index; i >= 0; i -= 1) {
          if (cacheSizes[i] > 0 && resizableInfos[i].resizable) {
            confirmedIndex = i;
            setMovingIndex({
              index: i,
              confirmed: true
            });
            break;
          }
        }
      }
    }
    const mergedIndex = (_a = confirmedIndex !== null && confirmedIndex !== void 0 ? confirmedIndex : movingIndex === null || movingIndex === void 0 ? void 0 : movingIndex.index) !== null && _a !== void 0 ? _a : index;
    const numSizes = (0,toConsumableArray/* default */.Z)(cacheSizes);
    const nextIndex = mergedIndex + 1;
    // Get boundary
    const startMinSize = getLimitSize(limitSizes[mergedIndex][0], 0);
    const endMinSize = getLimitSize(limitSizes[nextIndex][0], 0);
    const startMaxSize = getLimitSize(limitSizes[mergedIndex][1], mergedContainerSize);
    const endMaxSize = getLimitSize(limitSizes[nextIndex][1], mergedContainerSize);
    let mergedOffset = offset;
    // Align with the boundary
    if (numSizes[mergedIndex] + mergedOffset < startMinSize) {
      mergedOffset = startMinSize - numSizes[mergedIndex];
    }
    if (numSizes[nextIndex] - mergedOffset < endMinSize) {
      mergedOffset = numSizes[nextIndex] - endMinSize;
    }
    if (numSizes[mergedIndex] + mergedOffset > startMaxSize) {
      mergedOffset = startMaxSize - numSizes[mergedIndex];
    }
    if (numSizes[nextIndex] - mergedOffset > endMaxSize) {
      mergedOffset = numSizes[nextIndex] - endMaxSize;
    }
    // Do offset
    numSizes[mergedIndex] += mergedOffset;
    numSizes[nextIndex] -= mergedOffset;
    updateSizes(numSizes);
    return numSizes;
  };
  const onOffsetEnd = () => {
    setMovingIndex(null);
  };
  // ======================= Collapse =======================
  const onCollapse = (index, type) => {
    const currentSizes = getPxSizes();
    const adjustedType = isRTL ? type === 'start' ? 'end' : 'start' : type;
    const currentIndex = adjustedType === 'start' ? index : index + 1;
    const targetIndex = adjustedType === 'start' ? index + 1 : index;
    const currentSize = currentSizes[currentIndex];
    const targetSize = currentSizes[targetIndex];
    if (currentSize !== 0 && targetSize !== 0) {
      // Collapse directly
      currentSizes[currentIndex] = 0;
      currentSizes[targetIndex] += currentSize;
      cacheCollapsedSize.current[index] = currentSize;
    } else {
      const totalSize = currentSize + targetSize;
      const currentSizeMin = getLimitSize(limitSizes[currentIndex][0], 0);
      const currentSizeMax = getLimitSize(limitSizes[currentIndex][1], mergedContainerSize);
      const targetSizeMin = getLimitSize(limitSizes[targetIndex][0], 0);
      const targetSizeMax = getLimitSize(limitSizes[targetIndex][1], mergedContainerSize);
      const limitStart = Math.max(currentSizeMin, totalSize - targetSizeMax);
      const limitEnd = Math.min(currentSizeMax, totalSize - targetSizeMin);
      const halfOffset = targetSizeMin || (limitEnd - limitStart) / 2;
      const targetCacheCollapsedSize = cacheCollapsedSize.current[index];
      const currentCacheCollapsedSize = totalSize - targetCacheCollapsedSize;
      const shouldUseCache = targetCacheCollapsedSize && targetCacheCollapsedSize <= targetSizeMax && targetCacheCollapsedSize >= targetSizeMin && currentCacheCollapsedSize <= currentSizeMax && currentCacheCollapsedSize >= currentSizeMin;
      if (shouldUseCache) {
        currentSizes[targetIndex] = targetCacheCollapsedSize;
        currentSizes[currentIndex] = currentCacheCollapsedSize;
      } else {
        currentSizes[currentIndex] -= halfOffset;
        currentSizes[targetIndex] += halfOffset;
      }
    }
    updateSizes(currentSizes);
    return currentSizes;
  };
  return [onOffsetStart, onOffsetUpdate, onOffsetEnd, onCollapse, movingIndex === null || movingIndex === void 0 ? void 0 : movingIndex.index];
}
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/splitter/SplitBar.js
"use client";









function getValidNumber(num) {
  return typeof num === 'number' && !Number.isNaN(num) ? Math.round(num) : 0;
}
const SplitBar = props => {
  const {
    prefixCls,
    vertical,
    index,
    active,
    ariaNow,
    ariaMin,
    ariaMax,
    resizable,
    startCollapsible,
    endCollapsible,
    onOffsetStart,
    onOffsetUpdate,
    onOffsetEnd,
    onCollapse,
    lazy,
    containerSize,
    showStartCollapsibleIcon,
    showEndCollapsibleIcon
  } = props;
  const splitBarPrefixCls = `${prefixCls}-bar`;
  // ======================== Resize ========================
  const [startPos, setStartPos] = (0,react.useState)(null);
  const [constrainedOffset, setConstrainedOffset] = (0,react.useState)(0);
  const constrainedOffsetX = vertical ? 0 : constrainedOffset;
  const constrainedOffsetY = vertical ? constrainedOffset : 0;
  const onMouseDown = e => {
    if (resizable && e.currentTarget) {
      setStartPos([e.pageX, e.pageY]);
      onOffsetStart(index);
    }
  };
  const onTouchStart = e => {
    if (resizable && e.touches.length === 1) {
      const touch = e.touches[0];
      setStartPos([touch.pageX, touch.pageY]);
      onOffsetStart(index);
    }
  };
  // Updated constraint calculation
  const getConstrainedOffset = rawOffset => {
    const currentPos = containerSize * ariaNow / 100;
    const newPos = currentPos + rawOffset;
    // Calculate available space
    const minAllowed = Math.max(0, containerSize * ariaMin / 100);
    const maxAllowed = Math.min(containerSize, containerSize * ariaMax / 100);
    // Constrain new position within bounds
    const clampedPos = Math.max(minAllowed, Math.min(maxAllowed, newPos));
    return clampedPos - currentPos;
  };
  const handleLazyMove = (0,hooks_useEvent/* default */.Z)((offsetX, offsetY) => {
    const constrainedOffsetValue = getConstrainedOffset(vertical ? offsetY : offsetX);
    setConstrainedOffset(constrainedOffsetValue);
  });
  const handleLazyEnd = (0,hooks_useEvent/* default */.Z)(() => {
    onOffsetUpdate(index, constrainedOffsetX, constrainedOffsetY, true);
    setConstrainedOffset(0);
    onOffsetEnd(true);
  });
  const getVisibilityClass = mode => {
    switch (mode) {
      case true:
        return `${splitBarPrefixCls}-collapse-bar-always-visible`;
      case false:
        return `${splitBarPrefixCls}-collapse-bar-always-hidden`;
      case 'auto':
        return `${splitBarPrefixCls}-collapse-bar-hover-only`;
    }
  };
  (0,hooks_useLayoutEffect/* default */.Z)(() => {
    if (!startPos) {
      return;
    }
    const onMouseMove = e => {
      const {
        pageX,
        pageY
      } = e;
      const offsetX = pageX - startPos[0];
      const offsetY = pageY - startPos[1];
      if (lazy) {
        handleLazyMove(offsetX, offsetY);
      } else {
        onOffsetUpdate(index, offsetX, offsetY);
      }
    };
    const onMouseUp = () => {
      if (lazy) {
        handleLazyEnd();
      } else {
        onOffsetEnd();
      }
      setStartPos(null);
    };
    const handleTouchMove = e => {
      if (e.touches.length === 1) {
        const touch = e.touches[0];
        const offsetX = touch.pageX - startPos[0];
        const offsetY = touch.pageY - startPos[1];
        if (lazy) {
          handleLazyMove(offsetX, offsetY);
        } else {
          onOffsetUpdate(index, offsetX, offsetY);
        }
      }
    };
    const handleTouchEnd = () => {
      if (lazy) {
        handleLazyEnd();
      } else {
        onOffsetEnd();
      }
      setStartPos(null);
    };
    const eventHandlerMap = {
      mousemove: onMouseMove,
      mouseup: onMouseUp,
      touchmove: handleTouchMove,
      touchend: handleTouchEnd
    };
    for (const [event, handler] of Object.entries(eventHandlerMap)) {
      // eslint-disable-next-line react-web-api/no-leaked-event-listener
      window.addEventListener(event, handler);
    }
    return () => {
      for (const [event, handler] of Object.entries(eventHandlerMap)) {
        window.removeEventListener(event, handler);
      }
    };
  }, [startPos, index, lazy]);
  const transformStyle = {
    [`--${splitBarPrefixCls}-preview-offset`]: `${constrainedOffset}px`
  };
  // ======================== Render ========================
  const StartIcon = vertical ? icons_UpOutlined : LeftOutlined/* default */.Z;
  const EndIcon = vertical ? DownOutlined/* default */.Z : RightOutlined/* default */.Z;
  return /*#__PURE__*/react.createElement("div", {
    className: splitBarPrefixCls,
    role: "separator",
    "aria-valuenow": getValidNumber(ariaNow),
    "aria-valuemin": getValidNumber(ariaMin),
    "aria-valuemax": getValidNumber(ariaMax)
  }, lazy && (/*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${splitBarPrefixCls}-preview`, {
      [`${splitBarPrefixCls}-preview-active`]: !!constrainedOffset
    }),
    style: transformStyle
  })), /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${splitBarPrefixCls}-dragger`, {
      [`${splitBarPrefixCls}-dragger-disabled`]: !resizable,
      [`${splitBarPrefixCls}-dragger-active`]: active
    }),
    onMouseDown: onMouseDown,
    onTouchStart: onTouchStart
  }), startCollapsible && (/*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${splitBarPrefixCls}-collapse-bar`, `${splitBarPrefixCls}-collapse-bar-start`, getVisibilityClass(showStartCollapsibleIcon)),
    onClick: () => onCollapse(index, 'start')
  }, /*#__PURE__*/react.createElement(StartIcon, {
    className: classnames_default()(`${splitBarPrefixCls}-collapse-icon`, `${splitBarPrefixCls}-collapse-start`)
  }))), endCollapsible && (/*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${splitBarPrefixCls}-collapse-bar`, `${splitBarPrefixCls}-collapse-bar-end`, getVisibilityClass(showEndCollapsibleIcon)),
    onClick: () => onCollapse(index, 'end')
  }, /*#__PURE__*/react.createElement(EndIcon, {
    className: classnames_default()(`${splitBarPrefixCls}-collapse-icon`, `${splitBarPrefixCls}-collapse-end`)
  }))));
};
/* harmony default export */ var splitter_SplitBar = (SplitBar);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/splitter/style/index.js


const splitter_style_genRtlStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`&-rtl${componentCls}-horizontal`]: {
      [`> ${componentCls}-bar`]: {
        [`${componentCls}-bar-collapse-previous`]: {
          insetInlineEnd: 0,
          insetInlineStart: 'unset'
        },
        [`${componentCls}-bar-collapse-next`]: {
          insetInlineEnd: 'unset',
          insetInlineStart: 0
        }
      }
    },
    [`&-rtl${componentCls}-vertical`]: {
      [`> ${componentCls}-bar`]: {
        [`${componentCls}-bar-collapse-previous`]: {
          insetInlineEnd: '50%',
          insetInlineStart: 'unset'
        },
        [`${componentCls}-bar-collapse-next`]: {
          insetInlineEnd: '50%',
          insetInlineStart: 'unset'
        }
      }
    }
  };
};
const centerStyle = {
  position: 'absolute',
  top: '50%',
  left: {
    _skip_check_: true,
    value: '50%'
  },
  transform: 'translate(-50%, -50%)'
};
const genSplitterStyle = token => {
  const {
    componentCls,
    colorFill,
    splitBarDraggableSize,
    splitBarSize,
    splitTriggerSize,
    controlItemBgHover,
    controlItemBgActive,
    controlItemBgActiveHover,
    prefixCls
  } = token;
  const splitBarCls = `${componentCls}-bar`;
  const splitMaskCls = `${componentCls}-mask`;
  const splitPanelCls = `${componentCls}-panel`;
  const halfTriggerSize = token.calc(splitTriggerSize).div(2).equal();
  const splitterBarPreviewOffsetVar = `${prefixCls}-bar-preview-offset`;
  const splitterBarPreviewStyle = {
    position: 'absolute',
    background: token.colorPrimary,
    opacity: 0.2,
    pointerEvents: 'none',
    transition: 'none',
    zIndex: 1,
    display: 'none'
  };
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign({}, resetComponent(token)), {
      display: 'flex',
      width: '100%',
      height: '100%',
      alignItems: 'stretch',
      // ======================== SplitBar ========================
      // Use `>` to avoid conflict with mix layout
      [`> ${splitBarCls}`]: {
        flex: 'none',
        position: 'relative',
        userSelect: 'none',
        // ======================= Dragger =======================
        [`${splitBarCls}-dragger`]: Object.assign(Object.assign({}, centerStyle), {
          zIndex: 1,
          // Hover background
          '&::before': Object.assign({
            content: '""',
            background: controlItemBgHover
          }, centerStyle),
          // Spinner
          '&::after': Object.assign({
            content: '""',
            background: colorFill
          }, centerStyle),
          // Hover
          [`&:hover:not(${splitBarCls}-dragger-active)`]: {
            '&::before': {
              background: controlItemBgActive
            }
          },
          // Active
          '&-active': {
            zIndex: 2,
            '&::before': {
              background: controlItemBgActiveHover
            }
          },
          // Disabled, not use `pointer-events: none` since still need trigger collapse
          [`&-disabled${splitBarCls}-dragger`]: {
            zIndex: 0,
            '&, &:hover, &-active': {
              cursor: 'default',
              '&::before': {
                background: controlItemBgHover
              }
            },
            '&::after': {
              display: 'none'
            }
          }
        }),
        // ======================= Collapse =======================
        [`${splitBarCls}-collapse-bar`]: Object.assign(Object.assign({}, centerStyle), {
          zIndex: token.zIndexPopupBase,
          background: controlItemBgHover,
          fontSize: token.fontSizeSM,
          borderRadius: token.borderRadiusXS,
          color: token.colorText,
          cursor: 'pointer',
          opacity: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          // Hover
          '&:hover': {
            background: controlItemBgActive
          },
          // Active
          '&:active': {
            background: controlItemBgActiveHover
          }
        }),
        '&:hover, &:active': {
          [`${splitBarCls}-collapse-bar-hover-only`]: {
            opacity: 1
          }
        },
        [`${splitBarCls}-collapse-bar-hover-only`]: {
          '@media(hover:none)': {
            opacity: 1
          }
        },
        [`${splitBarCls}-collapse-bar-always-hidden`]: {
          display: 'none'
        },
        [`${splitBarCls}-collapse-bar-always-visible`]: {
          opacity: 1
        }
      },
      // =========================== Mask =========================
      // Util dom for handle cursor
      [splitMaskCls]: {
        position: 'fixed',
        zIndex: token.zIndexPopupBase,
        inset: 0,
        '&-horizontal': {
          cursor: 'col-resize'
        },
        '&-vertical': {
          cursor: 'row-resize'
        }
      },
      // ==========================================================
      // ==                        Layout                        ==
      // ==========================================================
      '&-horizontal': {
        flexDirection: 'row',
        [`> ${splitBarCls}`]: {
          width: 0,
          // ======================= Preview =======================
          [`${splitBarCls}-preview`]: Object.assign(Object.assign({
            height: '100%',
            width: splitBarSize
          }, splitterBarPreviewStyle), {
            [`&${splitBarCls}-preview-active`]: {
              display: 'block',
              transform: `translateX(var(--${splitterBarPreviewOffsetVar}))`
            }
          }),
          // ======================= Dragger =======================
          [`${splitBarCls}-dragger`]: {
            cursor: 'col-resize',
            height: '100%',
            width: splitTriggerSize,
            '&::before': {
              height: '100%',
              width: splitBarSize
            },
            '&::after': {
              height: splitBarDraggableSize,
              width: splitBarSize
            }
          },
          // ======================= Collapse =======================
          [`${splitBarCls}-collapse-bar`]: {
            width: token.fontSizeSM,
            height: token.controlHeightSM,
            '&-start': {
              left: {
                _skip_check_: true,
                value: 'auto'
              },
              right: {
                _skip_check_: true,
                value: halfTriggerSize
              },
              transform: 'translateY(-50%)'
            },
            '&-end': {
              left: {
                _skip_check_: true,
                value: halfTriggerSize
              },
              right: {
                _skip_check_: true,
                value: 'auto'
              },
              transform: 'translateY(-50%)'
            }
          }
        }
      },
      '&-vertical': {
        flexDirection: 'column',
        [`> ${splitBarCls}`]: {
          height: 0,
          // ======================= Preview =======================
          [`${splitBarCls}-preview`]: Object.assign(Object.assign({
            height: splitBarSize,
            width: '100%'
          }, splitterBarPreviewStyle), {
            [`&${splitBarCls}-preview-active`]: {
              display: 'block',
              transform: `translateY(var(--${splitterBarPreviewOffsetVar}))`
            }
          }),
          // ======================= Dragger =======================
          [`${splitBarCls}-dragger`]: {
            cursor: 'row-resize',
            width: '100%',
            height: splitTriggerSize,
            '&::before': {
              width: '100%',
              height: splitBarSize
            },
            '&::after': {
              width: splitBarDraggableSize,
              height: splitBarSize
            }
          },
          // ======================= Collapse =======================
          [`${splitBarCls}-collapse-bar`]: {
            height: token.fontSizeSM,
            width: token.controlHeightSM,
            '&-start': {
              top: 'auto',
              bottom: halfTriggerSize,
              transform: 'translateX(-50%)'
            },
            '&-end': {
              top: halfTriggerSize,
              bottom: 'auto',
              transform: 'translateX(-50%)'
            }
          }
        }
      },
      // ========================= Panels =========================
      [splitPanelCls]: {
        overflow: 'auto',
        padding: '0 1px',
        scrollbarWidth: 'thin',
        boxSizing: 'border-box',
        '&-hidden': {
          padding: 0,
          overflow: 'hidden'
        },
        [`&:has(${componentCls}:only-child)`]: {
          overflow: 'hidden'
        }
      }
    }), splitter_style_genRtlStyle(token))
  };
};
const splitter_style_prepareComponentToken = token => {
  var _a;
  const splitBarSize = token.splitBarSize || 2;
  const splitTriggerSize = token.splitTriggerSize || 6;
  // https://github.com/ant-design/ant-design/pull/51223
  const resizeSpinnerSize = token.resizeSpinnerSize || 20;
  const splitBarDraggableSize = (_a = token.splitBarDraggableSize) !== null && _a !== void 0 ? _a : resizeSpinnerSize;
  return {
    splitBarSize,
    splitTriggerSize,
    splitBarDraggableSize,
    resizeSpinnerSize
  };
};
// ============================== Export ==============================
/* harmony default export */ var splitter_style = (genStyleHooks('Splitter', genSplitterStyle, splitter_style_prepareComponentToken));
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/splitter/Splitter.js
"use client";

/* eslint-disable react/no-array-index-key */














const Splitter = props => {
  const {
    prefixCls: customizePrefixCls,
    className,
    style,
    layout = 'horizontal',
    children,
    rootClassName,
    onResizeStart,
    onResize,
    onResizeEnd,
    lazy
  } = props;
  const {
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle
  } = useComponentConfig('splitter');
  const prefixCls = getPrefixCls('splitter', customizePrefixCls);
  const rootCls = hooks_useCSSVarCls(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = splitter_style(prefixCls, rootCls);
  // ======================== Direct ========================
  const isVertical = layout === 'vertical';
  const isRTL = direction === 'rtl';
  const reverse = !isVertical && isRTL;
  // ====================== Items Data ======================
  const items = hooks_useItems(children);
  // >>> Warning for uncontrolled
  if (false) {}
  // ====================== Container =======================
  const [containerSize, setContainerSize] = (0,react.useState)();
  const onContainerResize = size => {
    const {
      offsetWidth,
      offsetHeight
    } = size;
    const containerSize = isVertical ? offsetHeight : offsetWidth;
    // Skip when container has no size, Such as nested in a hidden tab panel
    // to fix: https://github.com/ant-design/ant-design/issues/51106
    if (containerSize === 0) {
      return;
    }
    setContainerSize(containerSize);
  };
  // ========================= Size =========================
  const [panelSizes, itemPxSizes, itemPtgSizes, itemPtgMinSizes, itemPtgMaxSizes, updateSizes] = useSizes(items, containerSize);
  // ====================== Resizable =======================
  const resizableInfos = useResizable(items, itemPxSizes, isRTL);
  const [onOffsetStart, onOffsetUpdate, onOffsetEnd, onCollapse, movingIndex] = useResize(items, resizableInfos, itemPtgSizes, containerSize, updateSizes, isRTL);
  // ======================== Events ========================
  const onInternalResizeStart = (0,hooks_useEvent/* default */.Z)(index => {
    onOffsetStart(index);
    onResizeStart === null || onResizeStart === void 0 ? void 0 : onResizeStart(itemPxSizes);
  });
  const onInternalResizeUpdate = (0,hooks_useEvent/* default */.Z)((index, offset, lazyEnd) => {
    const nextSizes = onOffsetUpdate(index, offset);
    if (lazyEnd) {
      onResizeEnd === null || onResizeEnd === void 0 ? void 0 : onResizeEnd(nextSizes);
    } else {
      onResize === null || onResize === void 0 ? void 0 : onResize(nextSizes);
    }
  });
  const onInternalResizeEnd = (0,hooks_useEvent/* default */.Z)(lazyEnd => {
    onOffsetEnd();
    if (!lazyEnd) {
      onResizeEnd === null || onResizeEnd === void 0 ? void 0 : onResizeEnd(itemPxSizes);
    }
  });
  const onInternalCollapse = (0,hooks_useEvent/* default */.Z)((index, type) => {
    const nextSizes = onCollapse(index, type);
    onResize === null || onResize === void 0 ? void 0 : onResize(nextSizes);
    onResizeEnd === null || onResizeEnd === void 0 ? void 0 : onResizeEnd(nextSizes);
  });
  // ======================== Styles ========================
  const containerClassName = classnames_default()(prefixCls, className, `${prefixCls}-${layout}`, {
    [`${prefixCls}-rtl`]: isRTL
  }, rootClassName, contextClassName, cssVarCls, rootCls, hashId);
  // ======================== Render ========================
  const maskCls = `${prefixCls}-mask`;
  const stackSizes = react.useMemo(() => {
    const mergedSizes = [];
    let stack = 0;
    for (let i = 0; i < items.length; i += 1) {
      stack += itemPtgSizes[i];
      mergedSizes.push(stack);
    }
    return mergedSizes;
  }, [itemPtgSizes]);
  const mergedStyle = Object.assign(Object.assign({}, contextStyle), style);
  return wrapCSSVar(/*#__PURE__*/react.createElement(es/* default */.Z, {
    onResize: onContainerResize
  }, /*#__PURE__*/react.createElement("div", {
    style: mergedStyle,
    className: containerClassName
  }, items.map((item, idx) => {
    // Panel
    const panel = /*#__PURE__*/react.createElement(InternalPanel, Object.assign({}, item, {
      prefixCls: prefixCls,
      size: panelSizes[idx]
    }));
    // Split Bar
    let splitBar = null;
    const resizableInfo = resizableInfos[idx];
    if (resizableInfo) {
      const ariaMinStart = (stackSizes[idx - 1] || 0) + itemPtgMinSizes[idx];
      const ariaMinEnd = (stackSizes[idx + 1] || 100) - itemPtgMaxSizes[idx + 1];
      const ariaMaxStart = (stackSizes[idx - 1] || 0) + itemPtgMaxSizes[idx];
      const ariaMaxEnd = (stackSizes[idx + 1] || 100) - itemPtgMinSizes[idx + 1];
      splitBar = /*#__PURE__*/react.createElement(splitter_SplitBar, {
        lazy: lazy,
        index: idx,
        active: movingIndex === idx,
        prefixCls: prefixCls,
        vertical: isVertical,
        resizable: resizableInfo.resizable,
        ariaNow: stackSizes[idx] * 100,
        ariaMin: Math.max(ariaMinStart, ariaMinEnd) * 100,
        ariaMax: Math.min(ariaMaxStart, ariaMaxEnd) * 100,
        startCollapsible: resizableInfo.startCollapsible,
        endCollapsible: resizableInfo.endCollapsible,
        showStartCollapsibleIcon: resizableInfo.showStartCollapsibleIcon,
        showEndCollapsibleIcon: resizableInfo.showEndCollapsibleIcon,
        onOffsetStart: onInternalResizeStart,
        onOffsetUpdate: (index, offsetX, offsetY, lazyEnd) => {
          let offset = isVertical ? offsetY : offsetX;
          if (reverse) {
            offset = -offset;
          }
          onInternalResizeUpdate(index, offset, lazyEnd);
        },
        onOffsetEnd: onInternalResizeEnd,
        onCollapse: onInternalCollapse,
        containerSize: containerSize || 0
      });
    }
    return /*#__PURE__*/react.createElement(react.Fragment, {
      key: `split-panel-${idx}`
    }, panel, splitBar);
  }), typeof movingIndex === 'number' && (/*#__PURE__*/react.createElement("div", {
    "aria-hidden": true,
    className: classnames_default()(maskCls, `${maskCls}-${layout}`)
  })))));
};
if (false) {}
/* harmony default export */ var splitter_Splitter = (Splitter);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/splitter/index.js
"use client";



const es_splitter_Splitter = splitter_Splitter;
es_splitter_Splitter.Panel = splitter_Panel;
/* harmony default export */ var splitter = (es_splitter_Splitter);
;// CONCATENATED MODULE: ./node_modules/sapp-common-package/node_modules/antd/es/index.js
"use client";










































































// TODO: Remove in v6


/***/ }),

/***/ 62732:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(44512)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _en_US = _interopRequireDefault(__webpack_require__(68908));
var _default = exports["default"] = _en_US.default;

/***/ }),

/***/ 68908:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(44512)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _en_US = _interopRequireDefault(__webpack_require__(77387));
var _en_US2 = _interopRequireDefault(__webpack_require__(65340));
// Merge into a locale object
const locale = {
  lang: Object.assign({
    placeholder: 'Select date',
    yearPlaceholder: 'Select year',
    quarterPlaceholder: 'Select quarter',
    monthPlaceholder: 'Select month',
    weekPlaceholder: 'Select week',
    rangePlaceholder: ['Start date', 'End date'],
    rangeYearPlaceholder: ['Start year', 'End year'],
    rangeQuarterPlaceholder: ['Start quarter', 'End quarter'],
    rangeMonthPlaceholder: ['Start month', 'End month'],
    rangeWeekPlaceholder: ['Start week', 'End week']
  }, _en_US.default),
  timePickerLocale: Object.assign({}, _en_US2.default)
};
// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
var _default = exports["default"] = locale;

/***/ }),

/***/ 21734:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(44512)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _en_US = _interopRequireDefault(__webpack_require__(67586));
var _en_US2 = _interopRequireDefault(__webpack_require__(62732));
var _en_US3 = _interopRequireDefault(__webpack_require__(68908));
var _en_US4 = _interopRequireDefault(__webpack_require__(65340));
const typeTemplate = '${label} is not a valid ${type}';
const localeValues = {
  locale: 'en',
  Pagination: _en_US.default,
  DatePicker: _en_US3.default,
  TimePicker: _en_US4.default,
  Calendar: _en_US2.default,
  global: {
    placeholder: 'Please select',
    close: 'Close'
  },
  Table: {
    filterTitle: 'Filter menu',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    filterEmptyText: 'No filters',
    filterCheckAll: 'Select all items',
    filterSearchPlaceholder: 'Search in filters',
    emptyText: 'No data',
    selectAll: 'Select current page',
    selectInvert: 'Invert current page',
    selectNone: 'Clear all data',
    selectionAll: 'Select all data',
    sortTitle: 'Sort',
    expand: 'Expand row',
    collapse: 'Collapse row',
    triggerDesc: 'Click to sort descending',
    triggerAsc: 'Click to sort ascending',
    cancelSort: 'Click to cancel sorting'
  },
  Tour: {
    Next: 'Next',
    Previous: 'Previous',
    Finish: 'Finish'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Cancel',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Cancel'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Search here',
    itemUnit: 'item',
    itemsUnit: 'items',
    remove: 'Remove',
    selectCurrent: 'Select current page',
    removeCurrent: 'Remove current page',
    selectAll: 'Select all data',
    deselectAll: 'Deselect all data',
    removeAll: 'Remove all data',
    selectInvert: 'Invert current page'
  },
  Upload: {
    uploading: 'Uploading...',
    removeFile: 'Remove file',
    uploadError: 'Upload error',
    previewFile: 'Preview file',
    downloadFile: 'Download file'
  },
  Empty: {
    description: 'No data'
  },
  Icon: {
    icon: 'icon'
  },
  Text: {
    edit: 'Edit',
    copy: 'Copy',
    copied: 'Copied',
    expand: 'Expand',
    collapse: 'Collapse'
  },
  Form: {
    optional: '(optional)',
    defaultValidateMessages: {
      default: 'Field validation error for ${label}',
      required: 'Please enter ${label}',
      enum: '${label} must be one of [${enum}]',
      whitespace: '${label} cannot be a blank character',
      date: {
        format: '${label} date format is invalid',
        parse: '${label} cannot be converted to a date',
        invalid: '${label} is an invalid date'
      },
      types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        boolean: typeTemplate,
        integer: typeTemplate,
        float: typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate
      },
      string: {
        len: '${label} must be ${len} characters',
        min: '${label} must be at least ${min} characters',
        max: '${label} must be up to ${max} characters',
        range: '${label} must be between ${min}-${max} characters'
      },
      number: {
        len: '${label} must be equal to ${len}',
        min: '${label} must be minimum ${min}',
        max: '${label} must be maximum ${max}',
        range: '${label} must be between ${min}-${max}'
      },
      array: {
        len: 'Must be ${len} ${label}',
        min: 'At least ${min} ${label}',
        max: 'At most ${max} ${label}',
        range: 'The amount of ${label} must be between ${min}-${max}'
      },
      pattern: {
        mismatch: '${label} does not match the pattern ${pattern}'
      }
    }
  },
  Image: {
    preview: 'Preview'
  },
  QRCode: {
    expired: 'QR code expired',
    refresh: 'Refresh',
    scanned: 'Scanned'
  },
  ColorPicker: {
    presetEmpty: 'Empty',
    transparent: 'Transparent',
    singleColor: 'Single',
    gradientColor: 'Gradient'
  }
};
var _default = exports["default"] = localeValues;

/***/ }),

/***/ 65340:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
const locale = {
  placeholder: 'Select time',
  rangePlaceholder: ['Start time', 'End time']
};
var _default = exports["default"] = locale;

/***/ }),

/***/ 93228:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(21734);

/***/ }),

/***/ 14791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "clsx": function() { return /* binding */ clsx; }
/* harmony export */ });
function r(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) (e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
/* harmony default export */ __webpack_exports__["default"] = (clsx);

/***/ }),

/***/ 41190:
/***/ (function(module) {

var camel2hyphen = function (str) {
  return str.replace(/[A-Z]/g, function (match) {
    return '-' + match.toLowerCase();
  }).toLowerCase();
};
module.exports = camel2hyphen;

/***/ }),

/***/ 36764:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
var style_to_object_1 = __importDefault(__webpack_require__(8818));
var utilities_1 = __webpack_require__(38769);
/**
 * Parses CSS inline style to JavaScript object (camelCased).
 */
function StyleToJS(style, options) {
  var output = {};
  if (!style || typeof style !== 'string') {
    return output;
  }
  (0, style_to_object_1.default)(style, function (property, value) {
    // skip CSS comment
    if (property && value) {
      output[(0, utilities_1.camelCase)(property, options)] = value;
    }
  });
  return output;
}
StyleToJS.default = StyleToJS;
module.exports = StyleToJS;

/***/ }),

/***/ 38769:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.camelCase = void 0;
var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9_-]+$/;
var HYPHEN_REGEX = /-([a-z])/g;
var NO_HYPHEN_REGEX = /^[^-]+$/;
var VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
/**
 * Checks whether to skip camelCase.
 */
var skipCamelCase = function (property) {
  return !property || NO_HYPHEN_REGEX.test(property) || CUSTOM_PROPERTY_REGEX.test(property);
};
/**
 * Replacer that capitalizes first character.
 */
var capitalize = function (match, character) {
  return character.toUpperCase();
};
/**
 * Replacer that removes beginning hyphen of vendor prefix property.
 */
var trimHyphen = function (match, prefix) {
  return "".concat(prefix, "-");
};
/**
 * CamelCases a CSS property.
 */
var camelCase = function (property, options) {
  if (options === void 0) {
    options = {};
  }
  if (skipCamelCase(property)) {
    return property;
  }
  property = property.toLowerCase();
  if (options.reactCompat) {
    // `-ms` vendor prefix should not be capitalized
    property = property.replace(MS_VENDOR_PREFIX_REGEX, trimHyphen);
  } else {
    // for non-React, remove first hyphen so vendor prefix is not capitalized
    property = property.replace(VENDOR_PREFIX_REGEX, trimHyphen);
  }
  return property.replace(HYPHEN_REGEX, capitalize);
};
exports.camelCase = camelCase;

/***/ }),

/***/ 8818:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = StyleToObject;
var inline_style_parser_1 = __importDefault(__webpack_require__(8751));
/**
 * Parses inline style to object.
 *
 * @param style - Inline style.
 * @param iterator - Iterator.
 * @returns - Style object or null.
 *
 * @example Parsing inline style to object:
 *
 * ```js
 * import parse from 'style-to-object';
 * parse('line-height: 42;'); // { 'line-height': '42' }
 * ```
 */
function StyleToObject(style, iterator) {
  var styleObject = null;
  if (!style || typeof style !== 'string') {
    return styleObject;
  }
  var declarations = (0, inline_style_parser_1.default)(style);
  var hasIterator = typeof iterator === 'function';
  declarations.forEach(function (declaration) {
    if (declaration.type !== 'declaration') {
      return;
    }
    var property = declaration.property,
      value = declaration.value;
    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      styleObject = styleObject || {};
      styleObject[property] = value;
    }
  });
  return styleObject;
}

/***/ }),

/***/ 91618:
/***/ (function(module) {

function E() {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}
E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});
    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });
    return this;
  },
  once: function (name, callback, ctx) {
    var self = this;
    function listener() {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    }
    ;
    listener._ = callback;
    return this.on(name, listener, ctx);
  },
  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;
    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }
    return this;
  },
  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];
    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    liveEvents.length ? e[name] = liveEvents : delete e[name];
    return this;
  }
};
module.exports = E;
module.exports.TinyEmitter = E;

/***/ }),

/***/ 39974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "animateFill": function() { return /* binding */ animateFill; },
  "createSingleton": function() { return /* binding */ createSingleton; },
  "default": function() { return /* binding */ tippy_esm; },
  "delegate": function() { return /* binding */ delegate; },
  "followCursor": function() { return /* binding */ followCursor; },
  "hideAll": function() { return /* binding */ hideAll; },
  "inlinePositioning": function() { return /* binding */ inlinePositioning; },
  "roundArrow": function() { return /* binding */ ROUND_ARROW; },
  "sticky": function() { return /* binding */ sticky; }
});

;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/userAgent.js
function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }
  return navigator.userAgent;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement(element) ? getWindow(element) : window,
    visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument :
  // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
    overflow = _getComputedStyle.overflow,
    overflowX = _getComputedStyle.overflowX,
    overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js








function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.

function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' ||
    // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }
  return (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot ||
    // step into the shadow DOM of the parent of a slotted node
    element.parentNode || (
    // DOM Element detected
    isShadowRoot(element) ? element.host : null) ||
    // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback
  );
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList :
  // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js







function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) ||
  // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }
  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block

function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);
    if (elementCss.position === 'fixed') {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.

function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums_top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [enums_top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }
    return pending;
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/createPopper.js









var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions,
    _generatorOptions$def = _generatorOptions.defaultModifiers,
    defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
    _generatorOptions$def2 = _generatorOptions.defaultOptions,
    defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements,
          reference = _state$elements.reference,
          popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers

        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index],
            fn = _state$orderedModifie.fn,
            _state$orderedModifie2 = _state$orderedModifie.options,
            _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
            name = _state$orderedModifie.name;
          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference, popper)) {
      return instance;
    }
    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
          _ref$options = _ref.options,
          options = _ref$options === void 0 ? {} : _ref$options,
          effect = _ref.effect;
        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });
          var noopFn = function noopFn() {};
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var createPopper = /*#__PURE__*/(/* unused pure expression or super */ null && (popperGenerator())); // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};
function effect(_ref) {
  var state = _ref.state,
    instance = _ref.instance,
    options = _ref.options;
  var _options$scroll = options.scroll,
    scroll = _options$scroll === void 0 ? true : _options$scroll,
    _options$resize = options.resize,
    resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }
  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }
  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }
    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules

/* harmony default export */ var eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
    element = _ref.element,
    placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
      default:
    }
  }
  return offsets;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js

function popperOffsets(_ref) {
  var state = _ref.state,
    name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules

/* harmony default export */ var modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
    y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper = _ref2.popper,
    popperRect = _ref2.popperRect,
    placement = _ref2.placement,
    variation = _ref2.variation,
    offsets = _ref2.offsets,
    position = _ref2.position,
    gpuAcceleration = _ref2.gpuAcceleration,
    adaptive = _ref2.adaptive,
    roundOffsets = _ref2.roundOffsets,
    isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
    x = _offsets$x === void 0 ? 0 : _offsets$x,
    _offsets$y = offsets.y,
    y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = enums_top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';
    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);
      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

    offsetParent = offsetParent;
    if (placement === enums_top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height :
      // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === enums_top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width :
      // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state,
    options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
    gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
    _options$adaptive = options.adaptive,
    adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
    _options$roundOffsets = options.roundOffsets,
    roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules

/* harmony default export */ var modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]

    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];
      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}
function applyStyles_effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules

/* harmony default export */ var modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: applyStyles_effect,
  requires: ['computeStyles']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/offset.js

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
      placement: placement
    })) : offset,
    skidding = _ref[0],
    distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state,
    options = _ref2.options,
    name = _ref2.name;
  var _options$offset = options.offset,
    offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
    x = _data$state$placement.x,
    y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules

/* harmony default export */ var modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js




function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      } // $FlowFixMe[prop-missing]: need a better way to handle this...

      next = next.parentNode || next.host;
    } while (next);
  } // Give up, the result is false

  return false;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js














function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`

function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414

  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents

function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$placement = _options.placement,
    placement = _options$placement === void 0 ? state.placement : _options$placement,
    _options$strategy = _options.strategy,
    strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
    _options$boundary = _options.boundary,
    boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
    _options$rootBoundary = _options.rootBoundary,
    rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
    _options$elementConte = _options.elementContext,
    elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
    _options$altBoundary = _options.altBoundary,
    altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
    _options$padding = _options.padding,
    padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }
  return overflowOffsets;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    placement = _options.placement,
    boundary = _options.boundary,
    rootBoundary = _options.rootBoundary,
    padding = _options.padding,
    flipVariations = _options.flipVariations,
    _options$allowedAutoP = _options.allowedAutoPlacements,
    allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...

  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
    specifiedFallbackPlacements = options.fallbackPlacements,
    padding = options.padding,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    _options$flipVariatio = options.flipVariations,
    flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
    allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];
  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : enums_top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);
        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break") break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules

/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js











function preventOverflow(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;
  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    padding = options.padding,
    _options$tether = options.tether,
    tether = _options$tether === void 0 ? true : _options$tether,
    _options$tetherOffset = options.tetherOffset,
    tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === 'y' ? enums_top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === 'x' ? enums_top : left;
    var _altSide = mainAxis === 'x' ? bottom : right;
    var _offset = popperOffsets[altAxis];
    var _len = altAxis === 'y' ? 'height' : 'width';
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [enums_top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules

/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/arrow.js








 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state,
    name = _ref.name,
    options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';
  if (!arrowElement || !popperOffsets) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function arrow_effect(_ref2) {
  var state = _ref2.state,
    options = _ref2.options;
  var _options$element = options.element,
    arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
  if (arrowElement == null) {
    return;
  } // CSS selector

  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules

/* harmony default export */ var modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/hide.js


function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [enums_top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state,
    name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules

/* harmony default export */ var modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/popper.js










var defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ./node_modules/tippy.js/dist/tippy.esm.js
/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/

var ROUND_ARROW = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var BOX_CLASS = "tippy-box";
var CONTENT_CLASS = "tippy-content";
var BACKDROP_CLASS = "tippy-backdrop";
var ARROW_CLASS = "tippy-arrow";
var SVG_ARROW_CLASS = "tippy-svg-arrow";
var TOUCH_OPTIONS = {
  passive: true,
  capture: true
};
var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
  return document.body;
};
function tippy_esm_hasOwnProperty(obj, key) {
  return {}.hasOwnProperty.call(obj, key);
}
function getValueAtIndexOrReturn(value, index, defaultValue) {
  if (Array.isArray(value)) {
    var v = value[index];
    return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
  }
  return value;
}
function isType(value, type) {
  var str = {}.toString.call(value);
  return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function invokeWithArgsOrReturn(value, args) {
  return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function tippy_esm_debounce(fn, ms) {
  // Avoid wrapping in `setTimeout` if ms is 0 anyway
  if (ms === 0) {
    return fn;
  }
  var timeout;
  return function (arg) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      fn(arg);
    }, ms);
  };
}
function removeProperties(obj, keys) {
  var clone = Object.assign({}, obj);
  keys.forEach(function (key) {
    delete clone[key];
  });
  return clone;
}
function splitBySpaces(value) {
  return value.split(/\s+/).filter(Boolean);
}
function normalizeToArray(value) {
  return [].concat(value);
}
function pushIfUnique(arr, value) {
  if (arr.indexOf(value) === -1) {
    arr.push(value);
  }
}
function unique(arr) {
  return arr.filter(function (item, index) {
    return arr.indexOf(item) === index;
  });
}
function tippy_esm_getBasePlacement(placement) {
  return placement.split('-')[0];
}
function arrayFrom(value) {
  return [].slice.call(value);
}
function removeUndefinedProps(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (obj[key] !== undefined) {
      acc[key] = obj[key];
    }
    return acc;
  }, {});
}
function div() {
  return document.createElement('div');
}
function tippy_esm_isElement(value) {
  return ['Element', 'Fragment'].some(function (type) {
    return isType(value, type);
  });
}
function isNodeList(value) {
  return isType(value, 'NodeList');
}
function isMouseEvent(value) {
  return isType(value, 'MouseEvent');
}
function isReferenceElement(value) {
  return !!(value && value._tippy && value._tippy.reference === value);
}
function getArrayOfElements(value) {
  if (tippy_esm_isElement(value)) {
    return [value];
  }
  if (isNodeList(value)) {
    return arrayFrom(value);
  }
  if (Array.isArray(value)) {
    return value;
  }
  return arrayFrom(document.querySelectorAll(value));
}
function setTransitionDuration(els, value) {
  els.forEach(function (el) {
    if (el) {
      el.style.transitionDuration = value + "ms";
    }
  });
}
function setVisibilityState(els, state) {
  els.forEach(function (el) {
    if (el) {
      el.setAttribute('data-state', state);
    }
  });
}
function getOwnerDocument(elementOrElements) {
  var _element$ownerDocumen;
  var _normalizeToArray = normalizeToArray(elementOrElements),
    element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body

  return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function isCursorOutsideInteractiveBorder(popperTreeData, event) {
  var clientX = event.clientX,
    clientY = event.clientY;
  return popperTreeData.every(function (_ref) {
    var popperRect = _ref.popperRect,
      popperState = _ref.popperState,
      props = _ref.props;
    var interactiveBorder = props.interactiveBorder;
    var basePlacement = tippy_esm_getBasePlacement(popperState.placement);
    var offsetData = popperState.modifiersData.offset;
    if (!offsetData) {
      return true;
    }
    var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
    var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
    var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
    var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
    var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
    var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
    var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
    var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
    return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
  });
}
function updateTransitionEndListener(box, action, listener) {
  var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
  // `webkitTransitionEnd`...

  ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
    box[method](event, listener);
  });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */

function actualContains(parent, child) {
  var target = child;
  while (target) {
    var _target$getRootNode;
    if (parent.contains(target)) {
      return true;
    }
    target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
  }
  return false;
}
var currentInput = {
  isTouch: false
};
var lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */

function onDocumentTouchStart() {
  if (currentInput.isTouch) {
    return;
  }
  currentInput.isTouch = true;
  if (window.performance) {
    document.addEventListener('mousemove', onDocumentMouseMove);
  }
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */

function onDocumentMouseMove() {
  var now = performance.now();
  if (now - lastMouseMoveTime < 20) {
    currentInput.isTouch = false;
    document.removeEventListener('mousemove', onDocumentMouseMove);
  }
  lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */

function onWindowBlur() {
  var activeElement = document.activeElement;
  if (isReferenceElement(activeElement)) {
    var instance = activeElement._tippy;
    if (activeElement.blur && !instance.state.isVisible) {
      activeElement.blur();
    }
  }
}
function bindGlobalEventListeners() {
  document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
  window.addEventListener('blur', onWindowBlur);
}
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var isIE11 = isBrowser ?
// @ts-ignore
!!window.msCrypto : false;
function createMemoryLeakWarning(method) {
  var txt = method === 'destroy' ? 'n already-' : ' ';
  return [method + "() was called on a" + txt + "destroyed instance. This is a no-op but", 'indicates a potential memory leak.'].join(' ');
}
function clean(value) {
  var spacesAndTabs = /[ \t]{2,}/g;
  var lineStartWithSpaces = /^[ \t]*/gm;
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}
function getDevMessage(message) {
  return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function getFormattedMessage(message) {
  return [getDevMessage(message),
  // title
  'color: #00C584; font-size: 1.3em; font-weight: bold;',
  // message
  'line-height: 1.5',
  // footer
  'color: #a6a095;'];
} // Assume warnings and errors never have the same message

var visitedMessages;
if (false) {}
function resetVisitedMessages() {
  visitedMessages = new Set();
}
function warnWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console;
    visitedMessages.add(message);
    (_console = console).warn.apply(_console, getFormattedMessage(message));
  }
}
function errorWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console2;
    visitedMessages.add(message);
    (_console2 = console).error.apply(_console2, getFormattedMessage(message));
  }
}
function validateTargets(targets) {
  var didPassFalsyValue = !targets;
  var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
  errorWhen(didPassFalsyValue, ['tippy() was passed', '`' + String(targets) + '`', 'as its targets (first) argument. Valid types are: String, Element,', 'Element[], or NodeList.'].join(' '));
  errorWhen(didPassPlainObject, ['tippy() was passed a plain object which is not supported as an argument', 'for virtual positioning. Use props.getReferenceClientRect instead.'].join(' '));
}
var pluginProps = {
  animateFill: false,
  followCursor: false,
  inlinePositioning: false,
  sticky: false
};
var renderProps = {
  allowHTML: false,
  animation: 'fade',
  arrow: true,
  content: '',
  inertia: false,
  maxWidth: 350,
  role: 'tooltip',
  theme: '',
  zIndex: 9999
};
var defaultProps = Object.assign({
  appendTo: TIPPY_DEFAULT_APPEND_TO,
  aria: {
    content: 'auto',
    expanded: 'auto'
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: true,
  ignoreAttributes: false,
  interactive: false,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: '',
  offset: [0, 10],
  onAfterUpdate: function onAfterUpdate() {},
  onBeforeUpdate: function onBeforeUpdate() {},
  onCreate: function onCreate() {},
  onDestroy: function onDestroy() {},
  onHidden: function onHidden() {},
  onHide: function onHide() {},
  onMount: function onMount() {},
  onShow: function onShow() {},
  onShown: function onShown() {},
  onTrigger: function onTrigger() {},
  onUntrigger: function onUntrigger() {},
  onClickOutside: function onClickOutside() {},
  placement: 'top',
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: false,
  touch: true,
  trigger: 'mouseenter focus',
  triggerTarget: null
}, pluginProps, renderProps);
var defaultKeys = Object.keys(defaultProps);
var setDefaultProps = function setDefaultProps(partialProps) {
  /* istanbul ignore else */
  if (false) {}
  var keys = Object.keys(partialProps);
  keys.forEach(function (key) {
    defaultProps[key] = partialProps[key];
  });
};
function getExtendedPassedProps(passedProps) {
  var plugins = passedProps.plugins || [];
  var pluginProps = plugins.reduce(function (acc, plugin) {
    var name = plugin.name,
      defaultValue = plugin.defaultValue;
    if (name) {
      var _name;
      acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
    }
    return acc;
  }, {});
  return Object.assign({}, passedProps, pluginProps);
}
function getDataAttributeProps(reference, plugins) {
  var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
    plugins: plugins
  }))) : defaultKeys;
  var props = propKeys.reduce(function (acc, key) {
    var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
    if (!valueAsString) {
      return acc;
    }
    if (key === 'content') {
      acc[key] = valueAsString;
    } else {
      try {
        acc[key] = JSON.parse(valueAsString);
      } catch (e) {
        acc[key] = valueAsString;
      }
    }
    return acc;
  }, {});
  return props;
}
function evaluateProps(reference, props) {
  var out = Object.assign({}, props, {
    content: invokeWithArgsOrReturn(props.content, [reference])
  }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
  out.aria = Object.assign({}, defaultProps.aria, out.aria);
  out.aria = {
    expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
    content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
  };
  return out;
}
function validateProps(partialProps, plugins) {
  if (partialProps === void 0) {
    partialProps = {};
  }
  if (plugins === void 0) {
    plugins = [];
  }
  var keys = Object.keys(partialProps);
  keys.forEach(function (prop) {
    var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
    var didPassUnknownProp = !tippy_esm_hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`

    if (didPassUnknownProp) {
      didPassUnknownProp = plugins.filter(function (plugin) {
        return plugin.name === prop;
      }).length === 0;
    }
    warnWhen(didPassUnknownProp, ["`" + prop + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", 'a plugin, forgot to pass it in an array as props.plugins.', '\n\n', 'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n', 'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'].join(' '));
  });
}
var innerHTML = function innerHTML() {
  return 'innerHTML';
};
function dangerouslySetInnerHTML(element, html) {
  element[innerHTML()] = html;
}
function createArrowElement(value) {
  var arrow = div();
  if (value === true) {
    arrow.className = ARROW_CLASS;
  } else {
    arrow.className = SVG_ARROW_CLASS;
    if (tippy_esm_isElement(value)) {
      arrow.appendChild(value);
    } else {
      dangerouslySetInnerHTML(arrow, value);
    }
  }
  return arrow;
}
function setContent(content, props) {
  if (tippy_esm_isElement(props.content)) {
    dangerouslySetInnerHTML(content, '');
    content.appendChild(props.content);
  } else if (typeof props.content !== 'function') {
    if (props.allowHTML) {
      dangerouslySetInnerHTML(content, props.content);
    } else {
      content.textContent = props.content;
    }
  }
}
function getChildren(popper) {
  var box = popper.firstElementChild;
  var boxChildren = arrayFrom(box.children);
  return {
    box: box,
    content: boxChildren.find(function (node) {
      return node.classList.contains(CONTENT_CLASS);
    }),
    arrow: boxChildren.find(function (node) {
      return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
    }),
    backdrop: boxChildren.find(function (node) {
      return node.classList.contains(BACKDROP_CLASS);
    })
  };
}
function render(instance) {
  var popper = div();
  var box = div();
  box.className = BOX_CLASS;
  box.setAttribute('data-state', 'hidden');
  box.setAttribute('tabindex', '-1');
  var content = div();
  content.className = CONTENT_CLASS;
  content.setAttribute('data-state', 'hidden');
  setContent(content, instance.props);
  popper.appendChild(box);
  box.appendChild(content);
  onUpdate(instance.props, instance.props);
  function onUpdate(prevProps, nextProps) {
    var _getChildren = getChildren(popper),
      box = _getChildren.box,
      content = _getChildren.content,
      arrow = _getChildren.arrow;
    if (nextProps.theme) {
      box.setAttribute('data-theme', nextProps.theme);
    } else {
      box.removeAttribute('data-theme');
    }
    if (typeof nextProps.animation === 'string') {
      box.setAttribute('data-animation', nextProps.animation);
    } else {
      box.removeAttribute('data-animation');
    }
    if (nextProps.inertia) {
      box.setAttribute('data-inertia', '');
    } else {
      box.removeAttribute('data-inertia');
    }
    box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
    if (nextProps.role) {
      box.setAttribute('role', nextProps.role);
    } else {
      box.removeAttribute('role');
    }
    if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
      setContent(content, instance.props);
    }
    if (nextProps.arrow) {
      if (!arrow) {
        box.appendChild(createArrowElement(nextProps.arrow));
      } else if (prevProps.arrow !== nextProps.arrow) {
        box.removeChild(arrow);
        box.appendChild(createArrowElement(nextProps.arrow));
      }
    } else if (arrow) {
      box.removeChild(arrow);
    }
  }
  return {
    popper: popper,
    onUpdate: onUpdate
  };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away

render.$$tippy = true;
var idCounter = 1;
var mouseMoveListeners = []; // Used by `hideAll()`

var mountedInstances = [];
function createTippy(reference, passedProps) {
  var props = evaluateProps(reference, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
  // 🔒 Private members
  // ===========================================================================

  var showTimeout;
  var hideTimeout;
  var scheduleHideAnimationFrame;
  var isVisibleFromClick = false;
  var didHideDueToDocumentMouseDown = false;
  var didTouchMove = false;
  var ignoreOnFirstUpdate = false;
  var lastTriggerEvent;
  var currentTransitionEndListener;
  var onFirstUpdate;
  var listeners = [];
  var debouncedOnMouseMove = tippy_esm_debounce(onMouseMove, props.interactiveDebounce);
  var currentTarget; // ===========================================================================
  // 🔑 Public members
  // ===========================================================================

  var id = idCounter++;
  var popperInstance = null;
  var plugins = unique(props.plugins);
  var state = {
    // Is the instance currently enabled?
    isEnabled: true,
    // Is the tippy currently showing and not transitioning out?
    isVisible: false,
    // Has the instance been destroyed?
    isDestroyed: false,
    // Is the tippy currently mounted to the DOM?
    isMounted: false,
    // Has the tippy finished transitioning in?
    isShown: false
  };
  var instance = {
    // properties
    id: id,
    reference: reference,
    popper: div(),
    popperInstance: popperInstance,
    props: props,
    state: state,
    plugins: plugins,
    // methods
    clearDelayTimeouts: clearDelayTimeouts,
    setProps: setProps,
    setContent: setContent,
    show: show,
    hide: hide,
    hideWithInteractivity: hideWithInteractivity,
    enable: enable,
    disable: disable,
    unmount: unmount,
    destroy: destroy
  }; // TODO: Investigate why this early return causes a TDZ error in the tests —
  // it doesn't seem to happen in the browser

  /* istanbul ignore if */

  if (!props.render) {
    if (false) {}
    return instance;
  } // ===========================================================================
  // Initial mutations
  // ===========================================================================

  var _props$render = props.render(instance),
    popper = _props$render.popper,
    onUpdate = _props$render.onUpdate;
  popper.setAttribute('data-tippy-root', '');
  popper.id = "tippy-" + instance.id;
  instance.popper = popper;
  reference._tippy = instance;
  popper._tippy = instance;
  var pluginsHooks = plugins.map(function (plugin) {
    return plugin.fn(instance);
  });
  var hasAriaExpanded = reference.hasAttribute('aria-expanded');
  addListeners();
  handleAriaExpandedAttribute();
  handleStyles();
  invokeHook('onCreate', [instance]);
  if (props.showOnCreate) {
    scheduleShow();
  } // Prevent a tippy with a delay from hiding if the cursor left then returned
  // before it started hiding

  popper.addEventListener('mouseenter', function () {
    if (instance.props.interactive && instance.state.isVisible) {
      instance.clearDelayTimeouts();
    }
  });
  popper.addEventListener('mouseleave', function () {
    if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) {
      getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    }
  });
  return instance; // ===========================================================================
  // 🔒 Private methods
  // ===========================================================================

  function getNormalizedTouchSettings() {
    var touch = instance.props.touch;
    return Array.isArray(touch) ? touch : [touch, 0];
  }
  function getIsCustomTouchBehavior() {
    return getNormalizedTouchSettings()[0] === 'hold';
  }
  function getIsDefaultRenderFn() {
    var _instance$props$rende;

    // @ts-ignore
    return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
  }
  function getCurrentTarget() {
    return currentTarget || reference;
  }
  function getDocument() {
    var parent = getCurrentTarget().parentNode;
    return parent ? getOwnerDocument(parent) : document;
  }
  function getDefaultTemplateChildren() {
    return getChildren(popper);
  }
  function getDelay(isShow) {
    // For touch or keyboard input, force `0` delay for UX reasons
    // Also if the instance is mounted but not visible (transitioning out),
    // ignore delay
    if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') {
      return 0;
    }
    return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
  }
  function handleStyles(fromHide) {
    if (fromHide === void 0) {
      fromHide = false;
    }
    popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
    popper.style.zIndex = "" + instance.props.zIndex;
  }
  function invokeHook(hook, args, shouldInvokePropsHook) {
    if (shouldInvokePropsHook === void 0) {
      shouldInvokePropsHook = true;
    }
    pluginsHooks.forEach(function (pluginHooks) {
      if (pluginHooks[hook]) {
        pluginHooks[hook].apply(pluginHooks, args);
      }
    });
    if (shouldInvokePropsHook) {
      var _instance$props;
      (_instance$props = instance.props)[hook].apply(_instance$props, args);
    }
  }
  function handleAriaContentAttribute() {
    var aria = instance.props.aria;
    if (!aria.content) {
      return;
    }
    var attr = "aria-" + aria.content;
    var id = popper.id;
    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      var currentValue = node.getAttribute(attr);
      if (instance.state.isVisible) {
        node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
      } else {
        var nextValue = currentValue && currentValue.replace(id, '').trim();
        if (nextValue) {
          node.setAttribute(attr, nextValue);
        } else {
          node.removeAttribute(attr);
        }
      }
    });
  }
  function handleAriaExpandedAttribute() {
    if (hasAriaExpanded || !instance.props.aria.expanded) {
      return;
    }
    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      if (instance.props.interactive) {
        node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
      } else {
        node.removeAttribute('aria-expanded');
      }
    });
  }
  function cleanupInteractiveMouseListeners() {
    getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
    mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
      return listener !== debouncedOnMouseMove;
    });
  }
  function onDocumentPress(event) {
    // Moved finger to scroll instead of an intentional tap outside
    if (currentInput.isTouch) {
      if (didTouchMove || event.type === 'mousedown') {
        return;
      }
    }
    var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper

    if (instance.props.interactive && actualContains(popper, actualTarget)) {
      return;
    } // Clicked on the event listeners target

    if (normalizeToArray(instance.props.triggerTarget || reference).some(function (el) {
      return actualContains(el, actualTarget);
    })) {
      if (currentInput.isTouch) {
        return;
      }
      if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) {
        return;
      }
    } else {
      invokeHook('onClickOutside', [instance, event]);
    }
    if (instance.props.hideOnClick === true) {
      instance.clearDelayTimeouts();
      instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
      // currentTarget. This lets a tippy with `focus` trigger know that it
      // should not show

      didHideDueToDocumentMouseDown = true;
      setTimeout(function () {
        didHideDueToDocumentMouseDown = false;
      }); // The listener gets added in `scheduleShow()`, but this may be hiding it
      // before it shows, and hide()'s early bail-out behavior can prevent it
      // from being cleaned up

      if (!instance.state.isMounted) {
        removeDocumentPress();
      }
    }
  }
  function onTouchMove() {
    didTouchMove = true;
  }
  function onTouchStart() {
    didTouchMove = false;
  }
  function addDocumentPress() {
    var doc = getDocument();
    doc.addEventListener('mousedown', onDocumentPress, true);
    doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }
  function removeDocumentPress() {
    var doc = getDocument();
    doc.removeEventListener('mousedown', onDocumentPress, true);
    doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }
  function onTransitionedOut(duration, callback) {
    onTransitionEnd(duration, function () {
      if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
        callback();
      }
    });
  }
  function onTransitionedIn(duration, callback) {
    onTransitionEnd(duration, callback);
  }
  function onTransitionEnd(duration, callback) {
    var box = getDefaultTemplateChildren().box;
    function listener(event) {
      if (event.target === box) {
        updateTransitionEndListener(box, 'remove', listener);
        callback();
      }
    } // Make callback synchronous if duration is 0
    // `transitionend` won't fire otherwise

    if (duration === 0) {
      return callback();
    }
    updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
    updateTransitionEndListener(box, 'add', listener);
    currentTransitionEndListener = listener;
  }
  function on(eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }
    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      node.addEventListener(eventType, handler, options);
      listeners.push({
        node: node,
        eventType: eventType,
        handler: handler,
        options: options
      });
    });
  }
  function addListeners() {
    if (getIsCustomTouchBehavior()) {
      on('touchstart', onTrigger, {
        passive: true
      });
      on('touchend', onMouseLeave, {
        passive: true
      });
    }
    splitBySpaces(instance.props.trigger).forEach(function (eventType) {
      if (eventType === 'manual') {
        return;
      }
      on(eventType, onTrigger);
      switch (eventType) {
        case 'mouseenter':
          on('mouseleave', onMouseLeave);
          break;
        case 'focus':
          on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
          break;
        case 'focusin':
          on('focusout', onBlurOrFocusOut);
          break;
      }
    });
  }
  function removeListeners() {
    listeners.forEach(function (_ref) {
      var node = _ref.node,
        eventType = _ref.eventType,
        handler = _ref.handler,
        options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }
  function onTrigger(event) {
    var _lastTriggerEvent;
    var shouldScheduleClickHide = false;
    if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
      return;
    }
    var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
    lastTriggerEvent = event;
    currentTarget = event.currentTarget;
    handleAriaExpandedAttribute();
    if (!instance.state.isVisible && isMouseEvent(event)) {
      // If scrolling, `mouseenter` events can be fired if the cursor lands
      // over a new target, but `mousemove` events don't get fired. This
      // causes interactive tooltips to get stuck open until the cursor is
      // moved
      mouseMoveListeners.forEach(function (listener) {
        return listener(event);
      });
    } // Toggle show/hide when clicking click-triggered tooltips

    if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
      shouldScheduleClickHide = true;
    } else {
      scheduleShow(event);
    }
    if (event.type === 'click') {
      isVisibleFromClick = !shouldScheduleClickHide;
    }
    if (shouldScheduleClickHide && !wasFocused) {
      scheduleHide(event);
    }
  }
  function onMouseMove(event) {
    var target = event.target;
    var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
    if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) {
      return;
    }
    var popperTreeData = getNestedPopperTree().concat(popper).map(function (popper) {
      var _instance$popperInsta;
      var instance = popper._tippy;
      var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
      if (state) {
        return {
          popperRect: popper.getBoundingClientRect(),
          popperState: state,
          props: props
        };
      }
      return null;
    }).filter(Boolean);
    if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
      cleanupInteractiveMouseListeners();
      scheduleHide(event);
    }
  }
  function onMouseLeave(event) {
    var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
    if (shouldBail) {
      return;
    }
    if (instance.props.interactive) {
      instance.hideWithInteractivity(event);
      return;
    }
    scheduleHide(event);
  }
  function onBlurOrFocusOut(event) {
    if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) {
      return;
    } // If focus was moved to within the popper

    if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
      return;
    }
    scheduleHide(event);
  }
  function isEventListenerStopped(event) {
    return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
  }
  function createPopperInstance() {
    destroyPopperInstance();
    var _instance$props2 = instance.props,
      popperOptions = _instance$props2.popperOptions,
      placement = _instance$props2.placement,
      offset = _instance$props2.offset,
      getReferenceClientRect = _instance$props2.getReferenceClientRect,
      moveTransition = _instance$props2.moveTransition;
    var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
    var computedReference = getReferenceClientRect ? {
      getBoundingClientRect: getReferenceClientRect,
      contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
    } : reference;
    var tippyModifier = {
      name: '$$tippy',
      enabled: true,
      phase: 'beforeWrite',
      requires: ['computeStyles'],
      fn: function fn(_ref2) {
        var state = _ref2.state;
        if (getIsDefaultRenderFn()) {
          var _getDefaultTemplateCh = getDefaultTemplateChildren(),
            box = _getDefaultTemplateCh.box;
          ['placement', 'reference-hidden', 'escaped'].forEach(function (attr) {
            if (attr === 'placement') {
              box.setAttribute('data-placement', state.placement);
            } else {
              if (state.attributes.popper["data-popper-" + attr]) {
                box.setAttribute("data-" + attr, '');
              } else {
                box.removeAttribute("data-" + attr);
              }
            }
          });
          state.attributes.popper = {};
        }
      }
    };
    var modifiers = [{
      name: 'offset',
      options: {
        offset: offset
      }
    }, {
      name: 'preventOverflow',
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: 'flip',
      options: {
        padding: 5
      }
    }, {
      name: 'computeStyles',
      options: {
        adaptive: !moveTransition
      }
    }, tippyModifier];
    if (getIsDefaultRenderFn() && arrow) {
      modifiers.push({
        name: 'arrow',
        options: {
          element: arrow,
          padding: 3
        }
      });
    }
    modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
    instance.popperInstance = popper_createPopper(computedReference, popper, Object.assign({}, popperOptions, {
      placement: placement,
      onFirstUpdate: onFirstUpdate,
      modifiers: modifiers
    }));
  }
  function destroyPopperInstance() {
    if (instance.popperInstance) {
      instance.popperInstance.destroy();
      instance.popperInstance = null;
    }
  }
  function mount() {
    var appendTo = instance.props.appendTo;
    var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
    // it's directly after the reference element so the elements inside the
    // tippy can be tabbed to
    // If there are clipping issues, the user can specify a different appendTo
    // and ensure focus management is handled correctly manually

    var node = getCurrentTarget();
    if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') {
      parentNode = node.parentNode;
    } else {
      parentNode = invokeWithArgsOrReturn(appendTo, [node]);
    } // The popper element needs to exist on the DOM before its position can be
    // updated as Popper needs to read its dimensions

    if (!parentNode.contains(popper)) {
      parentNode.appendChild(popper);
    }
    instance.state.isMounted = true;
    createPopperInstance();
    /* istanbul ignore else */

    if (false) {}
  }
  function getNestedPopperTree() {
    return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
  }
  function scheduleShow(event) {
    instance.clearDelayTimeouts();
    if (event) {
      invokeHook('onTrigger', [instance, event]);
    }
    addDocumentPress();
    var delay = getDelay(true);
    var _getNormalizedTouchSe = getNormalizedTouchSettings(),
      touchValue = _getNormalizedTouchSe[0],
      touchDelay = _getNormalizedTouchSe[1];
    if (currentInput.isTouch && touchValue === 'hold' && touchDelay) {
      delay = touchDelay;
    }
    if (delay) {
      showTimeout = setTimeout(function () {
        instance.show();
      }, delay);
    } else {
      instance.show();
    }
  }
  function scheduleHide(event) {
    instance.clearDelayTimeouts();
    invokeHook('onUntrigger', [instance, event]);
    if (!instance.state.isVisible) {
      removeDocumentPress();
      return;
    } // For interactive tippies, scheduleHide is added to a document.body handler
    // from onMouseLeave so must intercept scheduled hides from mousemove/leave
    // events when trigger contains mouseenter and click, and the tip is
    // currently shown as a result of a click.

    if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && ['mouseleave', 'mousemove'].indexOf(event.type) >= 0 && isVisibleFromClick) {
      return;
    }
    var delay = getDelay(false);
    if (delay) {
      hideTimeout = setTimeout(function () {
        if (instance.state.isVisible) {
          instance.hide();
        }
      }, delay);
    } else {
      // Fixes a `transitionend` problem when it fires 1 frame too
      // late sometimes, we don't want hide() to be called.
      scheduleHideAnimationFrame = requestAnimationFrame(function () {
        instance.hide();
      });
    }
  } // ===========================================================================
  // 🔑 Public methods
  // ===========================================================================

  function enable() {
    instance.state.isEnabled = true;
  }
  function disable() {
    // Disabling the instance should also hide it
    // https://github.com/atomiks/tippy.js-react/issues/106
    instance.hide();
    instance.state.isEnabled = false;
  }
  function clearDelayTimeouts() {
    clearTimeout(showTimeout);
    clearTimeout(hideTimeout);
    cancelAnimationFrame(scheduleHideAnimationFrame);
  }
  function setProps(partialProps) {
    /* istanbul ignore else */
    if (false) {}
    if (instance.state.isDestroyed) {
      return;
    }
    invokeHook('onBeforeUpdate', [instance, partialProps]);
    removeListeners();
    var prevProps = instance.props;
    var nextProps = evaluateProps(reference, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
      ignoreAttributes: true
    }));
    instance.props = nextProps;
    addListeners();
    if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
      cleanupInteractiveMouseListeners();
      debouncedOnMouseMove = tippy_esm_debounce(onMouseMove, nextProps.interactiveDebounce);
    } // Ensure stale aria-expanded attributes are removed

    if (prevProps.triggerTarget && !nextProps.triggerTarget) {
      normalizeToArray(prevProps.triggerTarget).forEach(function (node) {
        node.removeAttribute('aria-expanded');
      });
    } else if (nextProps.triggerTarget) {
      reference.removeAttribute('aria-expanded');
    }
    handleAriaExpandedAttribute();
    handleStyles();
    if (onUpdate) {
      onUpdate(prevProps, nextProps);
    }
    if (instance.popperInstance) {
      createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
      // and the nested ones get re-rendered first.
      // https://github.com/atomiks/tippyjs-react/issues/177
      // TODO: find a cleaner / more efficient solution(!)

      getNestedPopperTree().forEach(function (nestedPopper) {
        // React (and other UI libs likely) requires a rAF wrapper as it flushes
        // its work in one
        requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
      });
    }
    invokeHook('onAfterUpdate', [instance, partialProps]);
  }
  function setContent(content) {
    instance.setProps({
      content: content
    });
  }
  function show() {
    /* istanbul ignore else */
    if (false) {} // Early bail-out

    var isAlreadyVisible = instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);
    if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
      return;
    } // Normalize `disabled` behavior across browsers.
    // Firefox allows events on disabled elements, but Chrome doesn't.
    // Using a wrapper element (i.e. <span>) is recommended.

    if (getCurrentTarget().hasAttribute('disabled')) {
      return;
    }
    invokeHook('onShow', [instance], false);
    if (instance.props.onShow(instance) === false) {
      return;
    }
    instance.state.isVisible = true;
    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'visible';
    }
    handleStyles();
    addDocumentPress();
    if (!instance.state.isMounted) {
      popper.style.transition = 'none';
    } // If flipping to the opposite side after hiding at least once, the
    // animation will use the wrong placement without resetting the duration

    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
        box = _getDefaultTemplateCh2.box,
        content = _getDefaultTemplateCh2.content;
      setTransitionDuration([box, content], 0);
    }
    onFirstUpdate = function onFirstUpdate() {
      var _instance$popperInsta2;
      if (!instance.state.isVisible || ignoreOnFirstUpdate) {
        return;
      }
      ignoreOnFirstUpdate = true; // reflow

      void popper.offsetHeight;
      popper.style.transition = instance.props.moveTransition;
      if (getIsDefaultRenderFn() && instance.props.animation) {
        var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
          _box = _getDefaultTemplateCh3.box,
          _content = _getDefaultTemplateCh3.content;
        setTransitionDuration([_box, _content], duration);
        setVisibilityState([_box, _content], 'visible');
      }
      handleAriaContentAttribute();
      handleAriaExpandedAttribute();
      pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
      // popper has been positioned for the first time

      (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
      invokeHook('onMount', [instance]);
      if (instance.props.animation && getIsDefaultRenderFn()) {
        onTransitionedIn(duration, function () {
          instance.state.isShown = true;
          invokeHook('onShown', [instance]);
        });
      }
    };
    mount();
  }
  function hide() {
    /* istanbul ignore else */
    if (false) {} // Early bail-out

    var isAlreadyHidden = !instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);
    if (isAlreadyHidden || isDestroyed || isDisabled) {
      return;
    }
    invokeHook('onHide', [instance], false);
    if (instance.props.onHide(instance) === false) {
      return;
    }
    instance.state.isVisible = false;
    instance.state.isShown = false;
    ignoreOnFirstUpdate = false;
    isVisibleFromClick = false;
    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'hidden';
    }
    cleanupInteractiveMouseListeners();
    removeDocumentPress();
    handleStyles(true);
    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
        box = _getDefaultTemplateCh4.box,
        content = _getDefaultTemplateCh4.content;
      if (instance.props.animation) {
        setTransitionDuration([box, content], duration);
        setVisibilityState([box, content], 'hidden');
      }
    }
    handleAriaContentAttribute();
    handleAriaExpandedAttribute();
    if (instance.props.animation) {
      if (getIsDefaultRenderFn()) {
        onTransitionedOut(duration, instance.unmount);
      }
    } else {
      instance.unmount();
    }
  }
  function hideWithInteractivity(event) {
    /* istanbul ignore else */
    if (false) {}
    getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
    debouncedOnMouseMove(event);
  }
  function unmount() {
    /* istanbul ignore else */
    if (false) {}
    if (instance.state.isVisible) {
      instance.hide();
    }
    if (!instance.state.isMounted) {
      return;
    }
    destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
    // tree by default. This seems mainly for interactive tippies, but we should
    // find a workaround if possible

    getNestedPopperTree().forEach(function (nestedPopper) {
      nestedPopper._tippy.unmount();
    });
    if (popper.parentNode) {
      popper.parentNode.removeChild(popper);
    }
    mountedInstances = mountedInstances.filter(function (i) {
      return i !== instance;
    });
    instance.state.isMounted = false;
    invokeHook('onHidden', [instance]);
  }
  function destroy() {
    /* istanbul ignore else */
    if (false) {}
    if (instance.state.isDestroyed) {
      return;
    }
    instance.clearDelayTimeouts();
    instance.unmount();
    removeListeners();
    delete reference._tippy;
    instance.state.isDestroyed = true;
    invokeHook('onDestroy', [instance]);
  }
}
function tippy(targets, optionalProps) {
  if (optionalProps === void 0) {
    optionalProps = {};
  }
  var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
  /* istanbul ignore else */

  if (false) {}
  bindGlobalEventListeners();
  var passedProps = Object.assign({}, optionalProps, {
    plugins: plugins
  });
  var elements = getArrayOfElements(targets);
  /* istanbul ignore else */

  if (false) { var isMoreThanOneReferenceElement, isSingleContentElement; }
  var instances = elements.reduce(function (acc, reference) {
    var instance = reference && createTippy(reference, passedProps);
    if (instance) {
      acc.push(instance);
    }
    return acc;
  }, []);
  return tippy_esm_isElement(targets) ? instances[0] : instances;
}
tippy.defaultProps = defaultProps;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;
var hideAll = function hideAll(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    excludedReferenceOrInstance = _ref.exclude,
    duration = _ref.duration;
  mountedInstances.forEach(function (instance) {
    var isExcluded = false;
    if (excludedReferenceOrInstance) {
      isExcluded = isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
    }
    if (!isExcluded) {
      var originalDuration = instance.props.duration;
      instance.setProps({
        duration: duration
      });
      instance.hide();
      if (!instance.state.isDestroyed) {
        instance.setProps({
          duration: originalDuration
        });
      }
    }
  });
};

// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.

var applyStylesModifier = Object.assign({}, modifiers_applyStyles, {
  effect: function effect(_ref) {
    var state = _ref.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    } // intentionally return no cleanup function
    // return () => { ... }
  }
});
var createSingleton = function createSingleton(tippyInstances, optionalProps) {
  var _optionalProps$popper;
  if (optionalProps === void 0) {
    optionalProps = {};
  }

  /* istanbul ignore else */
  if (false) {}
  var individualInstances = tippyInstances;
  var references = [];
  var triggerTargets = [];
  var currentTarget;
  var overrides = optionalProps.overrides;
  var interceptSetPropsCleanups = [];
  var shownOnCreate = false;
  function setTriggerTargets() {
    triggerTargets = individualInstances.map(function (instance) {
      return normalizeToArray(instance.props.triggerTarget || instance.reference);
    }).reduce(function (acc, item) {
      return acc.concat(item);
    }, []);
  }
  function setReferences() {
    references = individualInstances.map(function (instance) {
      return instance.reference;
    });
  }
  function enableInstances(isEnabled) {
    individualInstances.forEach(function (instance) {
      if (isEnabled) {
        instance.enable();
      } else {
        instance.disable();
      }
    });
  }
  function interceptSetProps(singleton) {
    return individualInstances.map(function (instance) {
      var originalSetProps = instance.setProps;
      instance.setProps = function (props) {
        originalSetProps(props);
        if (instance.reference === currentTarget) {
          singleton.setProps(props);
        }
      };
      return function () {
        instance.setProps = originalSetProps;
      };
    });
  } // have to pass singleton, as it maybe undefined on first call

  function prepareInstance(singleton, target) {
    var index = triggerTargets.indexOf(target); // bail-out

    if (target === currentTarget) {
      return;
    }
    currentTarget = target;
    var overrideProps = (overrides || []).concat('content').reduce(function (acc, prop) {
      acc[prop] = individualInstances[index].props[prop];
      return acc;
    }, {});
    singleton.setProps(Object.assign({}, overrideProps, {
      getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function () {
        var _references$index;
        return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
      }
    }));
  }
  enableInstances(false);
  setReferences();
  setTriggerTargets();
  var plugin = {
    fn: function fn() {
      return {
        onDestroy: function onDestroy() {
          enableInstances(true);
        },
        onHidden: function onHidden() {
          currentTarget = null;
        },
        onClickOutside: function onClickOutside(instance) {
          if (instance.props.showOnCreate && !shownOnCreate) {
            shownOnCreate = true;
            currentTarget = null;
          }
        },
        onShow: function onShow(instance) {
          if (instance.props.showOnCreate && !shownOnCreate) {
            shownOnCreate = true;
            prepareInstance(instance, references[0]);
          }
        },
        onTrigger: function onTrigger(instance, event) {
          prepareInstance(instance, event.currentTarget);
        }
      };
    }
  };
  var singleton = tippy(div(), Object.assign({}, removeProperties(optionalProps, ['overrides']), {
    plugins: [plugin].concat(optionalProps.plugins || []),
    triggerTarget: triggerTargets,
    popperOptions: Object.assign({}, optionalProps.popperOptions, {
      modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [applyStylesModifier])
    })
  }));
  var originalShow = singleton.show;
  singleton.show = function (target) {
    originalShow(); // first time, showOnCreate or programmatic call with no params
    // default to showing first instance

    if (!currentTarget && target == null) {
      return prepareInstance(singleton, references[0]);
    } // triggered from event (do nothing as prepareInstance already called by onTrigger)
    // programmatic call with no params when already visible (do nothing again)

    if (currentTarget && target == null) {
      return;
    } // target is index of instance

    if (typeof target === 'number') {
      return references[target] && prepareInstance(singleton, references[target]);
    } // target is a child tippy instance

    if (individualInstances.indexOf(target) >= 0) {
      var ref = target.reference;
      return prepareInstance(singleton, ref);
    } // target is a ReferenceElement

    if (references.indexOf(target) >= 0) {
      return prepareInstance(singleton, target);
    }
  };
  singleton.showNext = function () {
    var first = references[0];
    if (!currentTarget) {
      return singleton.show(0);
    }
    var index = references.indexOf(currentTarget);
    singleton.show(references[index + 1] || first);
  };
  singleton.showPrevious = function () {
    var last = references[references.length - 1];
    if (!currentTarget) {
      return singleton.show(last);
    }
    var index = references.indexOf(currentTarget);
    var target = references[index - 1] || last;
    singleton.show(target);
  };
  var originalSetProps = singleton.setProps;
  singleton.setProps = function (props) {
    overrides = props.overrides || overrides;
    originalSetProps(props);
  };
  singleton.setInstances = function (nextInstances) {
    enableInstances(true);
    interceptSetPropsCleanups.forEach(function (fn) {
      return fn();
    });
    individualInstances = nextInstances;
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    interceptSetPropsCleanups = interceptSetProps(singleton);
    singleton.setProps({
      triggerTarget: triggerTargets
    });
  };
  interceptSetPropsCleanups = interceptSetProps(singleton);
  return singleton;
};
var BUBBLING_EVENTS_MAP = {
  mouseover: 'mouseenter',
  focusin: 'focus',
  click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */

function delegate(targets, props) {
  /* istanbul ignore else */
  if (false) {}
  var listeners = [];
  var childTippyInstances = [];
  var disabled = false;
  var target = props.target;
  var nativeProps = removeProperties(props, ['target']);
  var parentProps = Object.assign({}, nativeProps, {
    trigger: 'manual',
    touch: false
  });
  var childProps = Object.assign({
    touch: defaultProps.touch
  }, nativeProps, {
    showOnCreate: true
  });
  var returnValue = tippy(targets, parentProps);
  var normalizedReturnValue = normalizeToArray(returnValue);
  function onTrigger(event) {
    if (!event.target || disabled) {
      return;
    }
    var targetNode = event.target.closest(target);
    if (!targetNode) {
      return;
    } // Get relevant trigger with fallbacks:
    // 1. Check `data-tippy-trigger` attribute on target node
    // 2. Fallback to `trigger` passed to `delegate()`
    // 3. Fallback to `defaultProps.trigger`

    var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || defaultProps.trigger; // @ts-ignore

    if (targetNode._tippy) {
      return;
    }
    if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') {
      return;
    }
    if (event.type !== 'touchstart' && trigger.indexOf(BUBBLING_EVENTS_MAP[event.type]) < 0) {
      return;
    }
    var instance = tippy(targetNode, childProps);
    if (instance) {
      childTippyInstances = childTippyInstances.concat(instance);
    }
  }
  function on(node, eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }
    node.addEventListener(eventType, handler, options);
    listeners.push({
      node: node,
      eventType: eventType,
      handler: handler,
      options: options
    });
  }
  function addEventListeners(instance) {
    var reference = instance.reference;
    on(reference, 'touchstart', onTrigger, TOUCH_OPTIONS);
    on(reference, 'mouseover', onTrigger);
    on(reference, 'focusin', onTrigger);
    on(reference, 'click', onTrigger);
  }
  function removeEventListeners() {
    listeners.forEach(function (_ref) {
      var node = _ref.node,
        eventType = _ref.eventType,
        handler = _ref.handler,
        options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }
  function applyMutations(instance) {
    var originalDestroy = instance.destroy;
    var originalEnable = instance.enable;
    var originalDisable = instance.disable;
    instance.destroy = function (shouldDestroyChildInstances) {
      if (shouldDestroyChildInstances === void 0) {
        shouldDestroyChildInstances = true;
      }
      if (shouldDestroyChildInstances) {
        childTippyInstances.forEach(function (instance) {
          instance.destroy();
        });
      }
      childTippyInstances = [];
      removeEventListeners();
      originalDestroy();
    };
    instance.enable = function () {
      originalEnable();
      childTippyInstances.forEach(function (instance) {
        return instance.enable();
      });
      disabled = false;
    };
    instance.disable = function () {
      originalDisable();
      childTippyInstances.forEach(function (instance) {
        return instance.disable();
      });
      disabled = true;
    };
    addEventListeners(instance);
  }
  normalizedReturnValue.forEach(applyMutations);
  return returnValue;
}
var animateFill = {
  name: 'animateFill',
  defaultValue: false,
  fn: function fn(instance) {
    var _instance$props$rende;

    // @ts-ignore
    if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) {
      if (false) {}
      return {};
    }
    var _getChildren = getChildren(instance.popper),
      box = _getChildren.box,
      content = _getChildren.content;
    var backdrop = instance.props.animateFill ? createBackdropElement() : null;
    return {
      onCreate: function onCreate() {
        if (backdrop) {
          box.insertBefore(backdrop, box.firstElementChild);
          box.setAttribute('data-animatefill', '');
          box.style.overflow = 'hidden';
          instance.setProps({
            arrow: false,
            animation: 'shift-away'
          });
        }
      },
      onMount: function onMount() {
        if (backdrop) {
          var transitionDuration = box.style.transitionDuration;
          var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
          // tooltip element. `clip-path` is the other alternative but is not
          // well-supported and is buggy on some devices.

          content.style.transitionDelay = Math.round(duration / 10) + "ms";
          backdrop.style.transitionDuration = transitionDuration;
          setVisibilityState([backdrop], 'visible');
        }
      },
      onShow: function onShow() {
        if (backdrop) {
          backdrop.style.transitionDuration = '0ms';
        }
      },
      onHide: function onHide() {
        if (backdrop) {
          setVisibilityState([backdrop], 'hidden');
        }
      }
    };
  }
};
function createBackdropElement() {
  var backdrop = div();
  backdrop.className = BACKDROP_CLASS;
  setVisibilityState([backdrop], 'hidden');
  return backdrop;
}
var mouseCoords = {
  clientX: 0,
  clientY: 0
};
var activeInstances = [];
function storeMouseCoords(_ref) {
  var clientX = _ref.clientX,
    clientY = _ref.clientY;
  mouseCoords = {
    clientX: clientX,
    clientY: clientY
  };
}
function addMouseCoordsListener(doc) {
  doc.addEventListener('mousemove', storeMouseCoords);
}
function removeMouseCoordsListener(doc) {
  doc.removeEventListener('mousemove', storeMouseCoords);
}
var followCursor = {
  name: 'followCursor',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference;
    var doc = getOwnerDocument(instance.props.triggerTarget || reference);
    var isInternalUpdate = false;
    var wasFocusEvent = false;
    var isUnmounted = true;
    var prevProps = instance.props;
    function getIsInitialBehavior() {
      return instance.props.followCursor === 'initial' && instance.state.isVisible;
    }
    function addListener() {
      doc.addEventListener('mousemove', onMouseMove);
    }
    function removeListener() {
      doc.removeEventListener('mousemove', onMouseMove);
    }
    function unsetGetReferenceClientRect() {
      isInternalUpdate = true;
      instance.setProps({
        getReferenceClientRect: null
      });
      isInternalUpdate = false;
    }
    function onMouseMove(event) {
      // If the instance is interactive, avoid updating the position unless it's
      // over the reference element
      var isCursorOverReference = event.target ? reference.contains(event.target) : true;
      var followCursor = instance.props.followCursor;
      var clientX = event.clientX,
        clientY = event.clientY;
      var rect = reference.getBoundingClientRect();
      var relativeX = clientX - rect.left;
      var relativeY = clientY - rect.top;
      if (isCursorOverReference || !instance.props.interactive) {
        instance.setProps({
          // @ts-ignore - unneeded DOMRect properties
          getReferenceClientRect: function getReferenceClientRect() {
            var rect = reference.getBoundingClientRect();
            var x = clientX;
            var y = clientY;
            if (followCursor === 'initial') {
              x = rect.left + relativeX;
              y = rect.top + relativeY;
            }
            var top = followCursor === 'horizontal' ? rect.top : y;
            var right = followCursor === 'vertical' ? rect.right : x;
            var bottom = followCursor === 'horizontal' ? rect.bottom : y;
            var left = followCursor === 'vertical' ? rect.left : x;
            return {
              width: right - left,
              height: bottom - top,
              top: top,
              right: right,
              bottom: bottom,
              left: left
            };
          }
        });
      }
    }
    function create() {
      if (instance.props.followCursor) {
        activeInstances.push({
          instance: instance,
          doc: doc
        });
        addMouseCoordsListener(doc);
      }
    }
    function destroy() {
      activeInstances = activeInstances.filter(function (data) {
        return data.instance !== instance;
      });
      if (activeInstances.filter(function (data) {
        return data.doc === doc;
      }).length === 0) {
        removeMouseCoordsListener(doc);
      }
    }
    return {
      onCreate: create,
      onDestroy: destroy,
      onBeforeUpdate: function onBeforeUpdate() {
        prevProps = instance.props;
      },
      onAfterUpdate: function onAfterUpdate(_, _ref2) {
        var followCursor = _ref2.followCursor;
        if (isInternalUpdate) {
          return;
        }
        if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
          destroy();
          if (followCursor) {
            create();
            if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) {
              addListener();
            }
          } else {
            removeListener();
            unsetGetReferenceClientRect();
          }
        }
      },
      onMount: function onMount() {
        if (instance.props.followCursor && !wasFocusEvent) {
          if (isUnmounted) {
            onMouseMove(mouseCoords);
            isUnmounted = false;
          }
          if (!getIsInitialBehavior()) {
            addListener();
          }
        }
      },
      onTrigger: function onTrigger(_, event) {
        if (isMouseEvent(event)) {
          mouseCoords = {
            clientX: event.clientX,
            clientY: event.clientY
          };
        }
        wasFocusEvent = event.type === 'focus';
      },
      onHidden: function onHidden() {
        if (instance.props.followCursor) {
          unsetGetReferenceClientRect();
          removeListener();
          isUnmounted = true;
        }
      }
    };
  }
};
function getProps(props, modifier) {
  var _props$popperOptions;
  return {
    popperOptions: Object.assign({}, props.popperOptions, {
      modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function (_ref) {
        var name = _ref.name;
        return name !== modifier.name;
      }), [modifier])
    })
  };
}
var inlinePositioning = {
  name: 'inlinePositioning',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference;
    function isEnabled() {
      return !!instance.props.inlinePositioning;
    }
    var placement;
    var cursorRectIndex = -1;
    var isInternalUpdate = false;
    var triedPlacements = [];
    var modifier = {
      name: 'tippyInlinePositioning',
      enabled: true,
      phase: 'afterWrite',
      fn: function fn(_ref2) {
        var state = _ref2.state;
        if (isEnabled()) {
          if (triedPlacements.indexOf(state.placement) !== -1) {
            triedPlacements = [];
          }
          if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
            triedPlacements.push(state.placement);
            instance.setProps({
              // @ts-ignore - unneeded DOMRect properties
              getReferenceClientRect: function getReferenceClientRect() {
                return _getReferenceClientRect(state.placement);
              }
            });
          }
          placement = state.placement;
        }
      }
    };
    function _getReferenceClientRect(placement) {
      return getInlineBoundingClientRect(tippy_esm_getBasePlacement(placement), reference.getBoundingClientRect(), arrayFrom(reference.getClientRects()), cursorRectIndex);
    }
    function setInternalProps(partialProps) {
      isInternalUpdate = true;
      instance.setProps(partialProps);
      isInternalUpdate = false;
    }
    function addModifier() {
      if (!isInternalUpdate) {
        setInternalProps(getProps(instance.props, modifier));
      }
    }
    return {
      onCreate: addModifier,
      onAfterUpdate: addModifier,
      onTrigger: function onTrigger(_, event) {
        if (isMouseEvent(event)) {
          var rects = arrayFrom(instance.reference.getClientRects());
          var cursorRect = rects.find(function (rect) {
            return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
          });
          var index = rects.indexOf(cursorRect);
          cursorRectIndex = index > -1 ? index : cursorRectIndex;
        }
      },
      onHidden: function onHidden() {
        cursorRectIndex = -1;
      }
    };
  }
};
function getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
  // Not an inline element, or placement is not yet known
  if (clientRects.length < 2 || currentBasePlacement === null) {
    return boundingRect;
  } // There are two rects and they are disjoined

  if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) {
    return clientRects[cursorRectIndex] || boundingRect;
  }
  switch (currentBasePlacement) {
    case 'top':
    case 'bottom':
      {
        var firstRect = clientRects[0];
        var lastRect = clientRects[clientRects.length - 1];
        var isTop = currentBasePlacement === 'top';
        var top = firstRect.top;
        var bottom = lastRect.bottom;
        var left = isTop ? firstRect.left : lastRect.left;
        var right = isTop ? firstRect.right : lastRect.right;
        var width = right - left;
        var height = bottom - top;
        return {
          top: top,
          bottom: bottom,
          left: left,
          right: right,
          width: width,
          height: height
        };
      }
    case 'left':
    case 'right':
      {
        var minLeft = Math.min.apply(Math, clientRects.map(function (rects) {
          return rects.left;
        }));
        var maxRight = Math.max.apply(Math, clientRects.map(function (rects) {
          return rects.right;
        }));
        var measureRects = clientRects.filter(function (rect) {
          return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
        });
        var _top = measureRects[0].top;
        var _bottom = measureRects[measureRects.length - 1].bottom;
        var _left = minLeft;
        var _right = maxRight;
        var _width = _right - _left;
        var _height = _bottom - _top;
        return {
          top: _top,
          bottom: _bottom,
          left: _left,
          right: _right,
          width: _width,
          height: _height
        };
      }
    default:
      {
        return boundingRect;
      }
  }
}
var sticky = {
  name: 'sticky',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference,
      popper = instance.popper;
    function getReference() {
      return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
    }
    function shouldCheck(value) {
      return instance.props.sticky === true || instance.props.sticky === value;
    }
    var prevRefRect = null;
    var prevPopRect = null;
    function updatePosition() {
      var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
      var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
      if (currentRefRect && areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && areRectsDifferent(prevPopRect, currentPopRect)) {
        if (instance.popperInstance) {
          instance.popperInstance.update();
        }
      }
      prevRefRect = currentRefRect;
      prevPopRect = currentPopRect;
      if (instance.state.isMounted) {
        requestAnimationFrame(updatePosition);
      }
    }
    return {
      onMount: function onMount() {
        if (instance.props.sticky) {
          updatePosition();
        }
      }
    };
  }
};
function areRectsDifferent(rectA, rectB) {
  if (rectA && rectB) {
    return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
  }
  return true;
}
tippy.setDefaultProps({
  render: render
});
/* harmony default export */ var tippy_esm = (tippy);


/***/ }),

/***/ 67403:
/***/ (function(module) {

module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;
  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }
  switch (active.tagName.toUpperCase()) {
    // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;
    default:
      active = null;
      break;
  }
  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' && selection.removeAllRanges();
    if (!selection.rangeCount) {
      ranges.forEach(function (range) {
        selection.addRange(range);
      });
    }
    active && active.focus();
  };
};

/***/ }),

/***/ 51858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);

var index = react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;


/***/ }),

/***/ 28969:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var React = __webpack_require__(82684);
function is(x, y) {
  return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useState = React.useState,
  useEffect = React.useEffect,
  useLayoutEffect = React.useLayoutEffect,
  useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
  var value = getSnapshot(),
    _useState = useState({
      inst: {
        value: value,
        getSnapshot: getSnapshot
      }
    }),
    inst = _useState[0].inst,
    forceUpdate = _useState[1];
  useLayoutEffect(function () {
    inst.value = value;
    inst.getSnapshot = getSnapshot;
    checkIfSnapshotChanged(inst) && forceUpdate({
      inst: inst
    });
  }, [subscribe, value, getSnapshot]);
  useEffect(function () {
    checkIfSnapshotChanged(inst) && forceUpdate({
      inst: inst
    });
    return subscribe(function () {
      checkIfSnapshotChanged(inst) && forceUpdate({
        inst: inst
      });
    });
  }, [subscribe]);
  useDebugValue(value);
  return value;
}
function checkIfSnapshotChanged(inst) {
  var latestGetSnapshot = inst.getSnapshot;
  inst = inst.value;
  try {
    var nextValue = latestGetSnapshot();
    return !objectIs(inst, nextValue);
  } catch (error) {
    return !0;
  }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
  return getSnapshot();
}
var shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
exports.useSyncExternalStore = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;

/***/ }),

/***/ 31812:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var React = __webpack_require__(82684),
  shim = __webpack_require__(48216);
function is(x, y) {
  return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useSyncExternalStore = shim.useSyncExternalStore,
  useRef = React.useRef,
  useEffect = React.useEffect,
  useMemo = React.useMemo,
  useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function (subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
  var instRef = useRef(null);
  if (null === instRef.current) {
    var inst = {
      hasValue: !1,
      value: null
    };
    instRef.current = inst;
  } else inst = instRef.current;
  instRef = useMemo(function () {
    function memoizedSelector(nextSnapshot) {
      if (!hasMemo) {
        hasMemo = !0;
        memoizedSnapshot = nextSnapshot;
        nextSnapshot = selector(nextSnapshot);
        if (void 0 !== isEqual && inst.hasValue) {
          var currentSelection = inst.value;
          if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
        }
        return memoizedSelection = nextSnapshot;
      }
      currentSelection = memoizedSelection;
      if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
      var nextSelection = selector(nextSnapshot);
      if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
      memoizedSnapshot = nextSnapshot;
      return memoizedSelection = nextSelection;
    }
    var hasMemo = !1,
      memoizedSnapshot,
      memoizedSelection,
      maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
    return [function () {
      return memoizedSelector(getSnapshot());
    }, null === maybeGetServerSnapshot ? void 0 : function () {
      return memoizedSelector(maybeGetServerSnapshot());
    }];
  }, [getSnapshot, getServerSnapshot, selector, isEqual]);
  var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
  useEffect(function () {
    inst.hasValue = !0;
    inst.value = value;
  }, [value]);
  useDebugValue(value);
  return value;
};

/***/ }),

/***/ 48216:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(28969);
} else {}

/***/ }),

/***/ 81550:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(31812);
} else {}

/***/ }),

/***/ 55402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }
  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/validate.js

function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}
/* harmony default export */ var esm_browser_validate = (validate);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}
function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }
  return uuid;
}
/* harmony default export */ var esm_browser_stringify = (stringify);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js


function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;
    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }
    return buf;
  }
  return esm_browser_stringify(rnds);
}
/* harmony default export */ var esm_browser_v4 = (v4);

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(71470);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 86075:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/buildPolyfills/_optionalChain.js
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */
function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i];
    const fn = ops[i + 1];
    i += 2;
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
      return;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => value.call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}

// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }


// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/worldwide.js
var worldwide = __webpack_require__(23867);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/sdkMetadata.js
var sdkMetadata = __webpack_require__(17751);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/exports.js
var esm_exports = __webpack_require__(2155);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/sdk.js + 24 modules
var sdk = __webpack_require__(25169);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@sentry/react/build/esm/sdk.js




/**
 * Inits the React SDK
 */
function init(options) {
  const opts = {
    ...options
  };
  (0,sdkMetadata/* applySdkMetadata */.V)(opts, 'react');
  (0,esm_exports/* setContext */.v)('react', {
    version: react.version
  });
  return (0,sdk/* init */.S1)(opts);
}

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/build/esm/common/getVercelEnv.js
/* provided dependency */ var process = __webpack_require__(554);
/**
 * Returns an environment setting value determined by Vercel's `VERCEL_ENV` environment variable.
 *
 * @param isClient Flag to indicate whether to use the `NEXT_PUBLIC_` prefixed version of the environment variable.
 */
function getVercelEnv(isClient) {
  const vercelEnvVar = isClient ? process.env.NEXT_PUBLIC_VERCEL_ENV : process.env.VERCEL_ENV;
  return vercelEnvVar ? `vercel-${vercelEnvVar}` : undefined;
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/is.js
var is = __webpack_require__(92668);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/build/esm/common/nextNavigationErrorUtils.js


/**
 * Determines whether input is a Next.js not-found error.
 * https://beta.nextjs.org/docs/api-reference/notfound#notfound
 */
function isNotFoundNavigationError(subject) {
  return isError(subject) && ['NEXT_NOT_FOUND', 'NEXT_HTTP_ERROR_FALLBACK;404'].includes(subject.digest);
}

/**
 * Determines whether input is a Next.js redirect error.
 * https://beta.nextjs.org/docs/api-reference/redirect#redirect
 */
function isRedirectNavigationError(subject) {
  return (0,is/* isError */.VZ)(subject) && typeof subject.digest === 'string' && subject.digest.startsWith('NEXT_REDIRECT;') // a redirect digest looks like "NEXT_REDIRECT;[redirect path]"
  ;
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/time.js
var utils_hoist_time = __webpack_require__(27870);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(43384);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/semanticAttributes.js
var semanticAttributes = __webpack_require__(85535);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/browser.js
var browser = __webpack_require__(7948);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/measurement.js
var tracing_measurement = __webpack_require__(34652);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/url.js
var utils_hoist_url = __webpack_require__(95619);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/types.js
var types = __webpack_require__(72553);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/currentScopes.js
var currentScopes = __webpack_require__(97308);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/logger.js
var logger = __webpack_require__(3518);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/object.js
var object = __webpack_require__(88803);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/debug-build.js
var debug_build = __webpack_require__(30781);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/stacktrace.js
var stacktrace = __webpack_require__(93113);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/web-vitals/lib/bindReporter.js
const getRating = (value, thresholds) => {
  if (value > thresholds[1]) {
    return 'poor';
  }
  if (value > thresholds[0]) {
    return 'needs-improvement';
  }
  return 'good';
};
const bindReporter = (callback, metric, thresholds, reportAllChanges) => {
  let prevValue;
  let delta;
  return forceReport => {
    if (metric.value >= 0) {
      if (forceReport || reportAllChanges) {
        delta = metric.value - (prevValue || 0);

        // Report the metric if there's a non-zero delta or if no previous
        // value exists (which can happen in the case of the document becoming
        // hidden when the metric value is 0).
        // See: https://github.com/GoogleChrome/web-vitals/issues/14
        if (delta || prevValue === undefined) {
          prevValue = metric.value;
          metric.delta = delta;
          metric.rating = getRating(metric.value, thresholds);
          callback(metric);
        }
      }
    }
  };
};

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
const generateUniqueID = () => {
  return `v4-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/web-vitals/lib/getNavigationEntry.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// sentry-specific change:
// add optional param to not check for responseStart (see comment below)
const getNavigationEntry = (checkResponseStart = true) => {
  const navigationEntry = types/* WINDOW.performance */.m.performance && types/* WINDOW.performance.getEntriesByType */.m.performance.getEntriesByType && types/* WINDOW.performance.getEntriesByType */.m.performance.getEntriesByType('navigation')[0];
  // Check to ensure the `responseStart` property is present and valid.
  // In some cases no value is reported by the browser (for
  // privacy/security reasons), and in other cases (bugs) the value is
  // negative or is larger than the current page time. Ignore these cases:
  // https://github.com/GoogleChrome/web-vitals/issues/137
  // https://github.com/GoogleChrome/web-vitals/issues/162
  // https://github.com/GoogleChrome/web-vitals/issues/275
  if (
  // sentry-specific change:
  // We don't want to check for responseStart for our own use of `getNavigationEntry`
  !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) {
    return navigationEntry;
  }
};

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/web-vitals/lib/getActivationStart.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getActivationStart = () => {
  const navEntry = getNavigationEntry();
  return navEntry && navEntry.activationStart || 0;
};

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/web-vitals/lib/initMetric.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const initMetric = (name, value) => {
  const navEntry = getNavigationEntry();
  let navigationType = 'navigate';
  if (navEntry) {
    if (types/* WINDOW.document */.m.document && types/* WINDOW.document.prerendering */.m.document.prerendering || getActivationStart() > 0) {
      navigationType = 'prerender';
    } else if (types/* WINDOW.document */.m.document && types/* WINDOW.document.wasDiscarded */.m.document.wasDiscarded) {
      navigationType = 'restore';
    } else if (navEntry.type) {
      navigationType = navEntry.type.replace(/_/g, '-');
    }
  }

  // Use `entries` type specific for the metric.
  const entries = [];
  return {
    name,
    value: typeof value === 'undefined' ? -1 : value,
    rating: 'good',
    // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
    delta: 0,
    entries,
    id: generateUniqueID(),
    navigationType
  };
};

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/web-vitals/lib/observe.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
const observe = (type, callback, opts) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
      const po = new PerformanceObserver(list => {
        // Delay by a microtask to workaround a bug in Safari where the
        // callback is invoked immediately, rather than in a separate task.
        // See: https://github.com/GoogleChrome/web-vitals/issues/277
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(() => {
          callback(list.getEntries());
        });
      });
      po.observe(Object.assign({
        type,
        buffered: true
      }, opts || {}));
      return po;
    }
  } catch (e) {
    // Do nothing.
  }
  return;
};

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/web-vitals/lib/onHidden.js


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// Sentry-specific change:
// This function's logic was NOT updated to web-vitals 4.2.4 but we continue
// to use the web-vitals 3.5.2 due to us having stricter browser support.
// PR with context that made the changes: https://github.com/GoogleChrome/web-vitals/pull/442/files#r1530492402
// The PR removed listening to the `pagehide` event, in favour of only listening to `visibilitychange` event.
// This is "more correct" but some browsers we still support (Safari 12.1-14.0) don't fully support `visibilitychange`
// or have known bugs w.r.t the `visibilitychange` event.
// TODO (v9): If we decide to drop support for Safari 12.1-14.0, we can use the logic from web-vitals 4.2.4
// In this case, we also need to update the integration tests that currently trigger the `pagehide` event to
// simulate the page being hidden.
const onHidden = cb => {
  const onHiddenOrPageHide = event => {
    if (event.type === 'pagehide' || types/* WINDOW.document */.m.document && types/* WINDOW.document.visibilityState */.m.document.visibilityState === 'hidden') {
      cb(event);
    }
  };
  if (types/* WINDOW.document */.m.document) {
    addEventListener('visibilitychange', onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener('pagehide', onHiddenOrPageHide, true);
  }
};

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/web-vitals/lib/runOnce.js
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const runOnce = cb => {
  let called = false;
  return () => {
    if (!called) {
      cb();
      called = true;
    }
  };
};

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/web-vitals/lib/getVisibilityWatcher.js


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let firstHiddenTime = -1;
const initHiddenTime = () => {
  // If the document is hidden when this code runs, assume it was always
  // hidden and the page was loaded in the background, with the one exception
  // that visibility state is always 'hidden' during prerendering, so we have
  // to ignore that case until prerendering finishes (see: `prerenderingchange`
  // event logic below).
  return types/* WINDOW.document.visibilityState */.m.document.visibilityState === 'hidden' && !types/* WINDOW.document.prerendering */.m.document.prerendering ? 0 : Infinity;
};
const onVisibilityUpdate = event => {
  // If the document is 'hidden' and no previous hidden timestamp has been
  // set, update it based on the current event data.
  if (types/* WINDOW.document.visibilityState */.m.document.visibilityState === 'hidden' && firstHiddenTime > -1) {
    // If the event is a 'visibilitychange' event, it means the page was
    // visible prior to this change, so the event timestamp is the first
    // hidden time.
    // However, if the event is not a 'visibilitychange' event, then it must
    // be a 'prerenderingchange' event, and the fact that the document is
    // still 'hidden' from the above check means the tab was activated
    // in a background state and so has always been hidden.
    firstHiddenTime = event.type === 'visibilitychange' ? event.timeStamp : 0;

    // Remove all listeners now that a `firstHiddenTime` value has been set.
    removeChangeListeners();
  }
};
const addChangeListeners = () => {
  addEventListener('visibilitychange', onVisibilityUpdate, true);
  // IMPORTANT: when a page is prerendering, its `visibilityState` is
  // 'hidden', so in order to account for cases where this module checks for
  // visibility during prerendering, an additional check after prerendering
  // completes is also required.
  addEventListener('prerenderingchange', onVisibilityUpdate, true);
};
const removeChangeListeners = () => {
  removeEventListener('visibilitychange', onVisibilityUpdate, true);
  removeEventListener('prerenderingchange', onVisibilityUpdate, true);
};
const getVisibilityWatcher = () => {
  if (types/* WINDOW.document */.m.document && firstHiddenTime < 0) {
    // If the document is hidden when this code runs, assume it was hidden
    // since navigation start. This isn't a perfect heuristic, but it's the
    // best we can do until an API is available to support querying past
    // visibilityState.
    firstHiddenTime = initHiddenTime();
    addChangeListeners();
  }
  return {
    get firstHiddenTime() {
      return firstHiddenTime;
    }
  };
};

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/web-vitals/lib/whenActivated.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const whenActivated = callback => {
  if (types/* WINDOW.document */.m.document && types/* WINDOW.document.prerendering */.m.document.prerendering) {
    addEventListener('prerenderingchange', () => callback(), true);
  } else {
    callback();
  }
};

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/web-vitals/onFCP.js







/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */
const FCPThresholds = [1800, 3000];

/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */
const onFCP = (onReport, opts = {}) => {
  whenActivated(() => {
    const visibilityWatcher = getVisibilityWatcher();
    const metric = initMetric('FCP');
    let report;
    const handleEntries = entries => {
      entries.forEach(entry => {
        if (entry.name === 'first-contentful-paint') {
          po.disconnect();

          // Only report if the page wasn't hidden prior to the first paint.
          if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            // The activationStart reference is used because FCP should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the FCP, this time should be clamped at 0.
            metric.value = Math.max(entry.startTime - getActivationStart(), 0);
            metric.entries.push(entry);
            report(true);
          }
        }
      });
    };
    const po = observe('paint', handleEntries);
    if (po) {
      report = bindReporter(onReport, metric, FCPThresholds, opts.reportAllChanges);
    }
  });
};

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/web-vitals/getCLS.js







/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */
const CLSThresholds = [0.1, 0.25];

/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */
const onCLS = (onReport, opts = {}) => {
  // Start monitoring FCP so we can only report CLS if FCP is also reported.
  // Note: this is done to match the current behavior of CrUX.
  onFCP(runOnce(() => {
    const metric = initMetric('CLS', 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    const handleEntries = entries => {
      entries.forEach(entry => {
        // Only count layout shifts without recent user input.
        if (!entry.hadRecentInput) {
          const firstSessionEntry = sessionEntries[0];
          const lastSessionEntry = sessionEntries[sessionEntries.length - 1];

          // If the entry occurred less than 1 second after the previous entry
          // and less than 5 seconds after the first entry in the session,
          // include the entry in the current session. Otherwise, start a new
          // session.
          if (sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
            sessionValue += entry.value;
            sessionEntries.push(entry);
          } else {
            sessionValue = entry.value;
            sessionEntries = [entry];
          }
        }
      });

      // If the current session value is larger than the current CLS value,
      // update CLS and the entries contributing to it.
      if (sessionValue > metric.value) {
        metric.value = sessionValue;
        metric.entries = sessionEntries;
        report();
      }
    };
    const po = observe('layout-shift', handleEntries);
    if (po) {
      report = bindReporter(onReport, metric, CLSThresholds, opts.reportAllChanges);
      onHidden(() => {
        handleEntries(po.takeRecords());
        report(true);
      });

      // Queue a task to report (if nothing else triggers a report first).
      // This allows CLS to be reported as soon as FCP fires when
      // `reportAllChanges` is true.
      setTimeout(report, 0);
    }
  }));
};

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/web-vitals/getFID.js








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Thresholds for FID. See https://web.dev/articles/fid#what_is_a_good_fid_score */
const FIDThresholds = [100, 300];

/**
 * Calculates the [FID](https://web.dev/articles/fid) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */
const onFID = (onReport, opts = {}) => {
  whenActivated(() => {
    const visibilityWatcher = getVisibilityWatcher();
    const metric = initMetric('FID');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = entry => {
      // Only report if the page wasn't hidden prior to the first input.
      if (entry.startTime < visibilityWatcher.firstHiddenTime) {
        metric.value = entry.processingStart - entry.startTime;
        metric.entries.push(entry);
        report(true);
      }
    };
    const handleEntries = entries => {
      entries.forEach(handleEntry);
    };
    const po = observe('first-input', handleEntries);
    report = bindReporter(onReport, metric, FIDThresholds, opts.reportAllChanges);
    if (po) {
      onHidden(runOnce(() => {
        handleEntries(po.takeRecords());
        po.disconnect();
      }));
    }
  });
};

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/web-vitals/lib/polyfills/interactionCountPolyfill.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let interactionCountEstimate = 0;
let minKnownInteractionId = Infinity;
let maxKnownInteractionId = 0;
const updateEstimate = entries => {
  entries.forEach(e => {
    if (e.interactionId) {
      minKnownInteractionId = Math.min(minKnownInteractionId, e.interactionId);
      maxKnownInteractionId = Math.max(maxKnownInteractionId, e.interactionId);
      interactionCountEstimate = maxKnownInteractionId ? (maxKnownInteractionId - minKnownInteractionId) / 7 + 1 : 0;
    }
  });
};
let po;

/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */
const getInteractionCount = () => {
  return po ? interactionCountEstimate : performance.interactionCount || 0;
};

/**
 * Feature detects native support or initializes the polyfill if needed.
 */
const initInteractionCountPolyfill = () => {
  if ('interactionCount' in performance || po) return;
  po = observe('event', updateEstimate, {
    type: 'event',
    buffered: true,
    durationThreshold: 0
  });
};

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/web-vitals/lib/interactions.js


/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER long.
const longestInteractionList = [];

// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const longestInteractionMap = new Map();

// The default `durationThreshold` used across this library for observing
// `event` entries via PerformanceObserver.
const DEFAULT_DURATION_THRESHOLD = 40;

// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
let prevInteractionCount = 0;

/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */
const getInteractionCountForNavigation = () => {
  return getInteractionCount() - prevInteractionCount;
};

/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */
const estimateP98LongestInteraction = () => {
  const candidateInteractionIndex = Math.min(longestInteractionList.length - 1, Math.floor(getInteractionCountForNavigation() / 50));
  return longestInteractionList[candidateInteractionIndex];
};

// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const MAX_INTERACTIONS_TO_CONSIDER = 10;

/**
 * A list of callback functions to run before each entry is processed.
 * Exposing this list allows the attribution build to hook into the
 * entry processing pipeline.
 */
const entryPreProcessingCallbacks = [];

/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */
const processInteractionEntry = entry => {
  entryPreProcessingCallbacks.forEach(cb => cb(entry));

  // Skip further processing for entries that cannot be INP candidates.
  if (!(entry.interactionId || entry.entryType === 'first-input')) return;

  // The least-long of the 10 longest interactions.
  const minLongestInteraction = longestInteractionList[longestInteractionList.length - 1];
  const existingInteraction = longestInteractionMap.get(entry.interactionId);

  // Only process the entry if it's possibly one of the ten longest,
  // or if it's part of an existing interaction.
  if (existingInteraction || longestInteractionList.length < MAX_INTERACTIONS_TO_CONSIDER || minLongestInteraction && entry.duration > minLongestInteraction.latency) {
    // If the interaction already exists, update it. Otherwise create one.
    if (existingInteraction) {
      // If the new entry has a longer duration, replace the old entries,
      // otherwise add to the array.
      if (entry.duration > existingInteraction.latency) {
        existingInteraction.entries = [entry];
        existingInteraction.latency = entry.duration;
      } else if (entry.duration === existingInteraction.latency && entry.startTime === (existingInteraction.entries[0] && existingInteraction.entries[0].startTime)) {
        existingInteraction.entries.push(entry);
      }
    } else {
      const interaction = {
        id: entry.interactionId,
        latency: entry.duration,
        entries: [entry]
      };
      longestInteractionMap.set(interaction.id, interaction);
      longestInteractionList.push(interaction);
    }

    // Sort the entries by latency (descending) and keep only the top ten.
    longestInteractionList.sort((a, b) => b.latency - a.latency);
    if (longestInteractionList.length > MAX_INTERACTIONS_TO_CONSIDER) {
      longestInteractionList.splice(MAX_INTERACTIONS_TO_CONSIDER).forEach(i => longestInteractionMap.delete(i.id));
    }
  }
};

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/web-vitals/lib/whenIdle.js




/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Runs the passed callback during the next idle period, or immediately
 * if the browser's visibility state is (or becomes) hidden.
 */
const whenIdle = cb => {
  const rIC = types/* WINDOW.requestIdleCallback */.m.requestIdleCallback || types/* WINDOW.setTimeout */.m.setTimeout;
  let handle = -1;
  // eslint-disable-next-line no-param-reassign
  cb = runOnce(cb);
  // If the document is hidden, run the callback immediately, otherwise
  // race an idle callback with the next `visibilitychange` event.
  if (types/* WINDOW.document */.m.document && types/* WINDOW.document.visibilityState */.m.document.visibilityState === 'hidden') {
    cb();
  } else {
    handle = rIC(cb);
    onHidden(cb);
  }
  return handle;
};

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/web-vitals/getINP.js










/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */
const INPThresholds = [200, 500];

/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */
const onINP = (onReport, opts = {}) => {
  // Return if the browser doesn't support all APIs needed to measure INP.
  if (!("PerformanceEventTiming" in types/* WINDOW */.m && 'interactionId' in PerformanceEventTiming.prototype)) {
    return;
  }
  whenActivated(() => {
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    initInteractionCountPolyfill();
    const metric = initMetric('INP');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = entries => {
      // Queue the `handleEntries()` callback in the next idle task.
      // This is needed to increase the chances that all event entries that
      // occurred between the user interaction and the next paint
      // have been dispatched. Note: there is currently an experiment
      // running in Chrome (EventTimingKeypressAndCompositionInteractionId)
      // 123+ that if rolled out fully may make this no longer necessary.
      whenIdle(() => {
        entries.forEach(processInteractionEntry);
        const inp = estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
          metric.value = inp.latency;
          metric.entries = inp.entries;
          report();
        }
      });
    };
    const po = observe('event', handleEntries, {
      // Event Timing entries have their durations rounded to the nearest 8ms,
      // so a duration of 40ms would be any event that spans 2.5 or more frames
      // at 60Hz. This threshold is chosen to strike a balance between usefulness
      // and performance. Running this callback for any interaction that spans
      // just one or two frames is likely not worth the insight that could be
      // gained.
      durationThreshold: opts.durationThreshold != null ? opts.durationThreshold : DEFAULT_DURATION_THRESHOLD
    });
    report = bindReporter(onReport, metric, INPThresholds, opts.reportAllChanges);
    if (po) {
      // Also observe entries of type `first-input`. This is useful in cases
      // where the first interaction is less than the `durationThreshold`.
      po.observe({
        type: 'first-input',
        buffered: true
      });
      onHidden(() => {
        handleEntries(po.takeRecords());
        report(true);
      });
    }
  });
};

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/web-vitals/getLCP.js











/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */
const LCPThresholds = [2500, 4000];
const reportedMetricIDs = {};

/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */
const onLCP = (onReport, opts = {}) => {
  whenActivated(() => {
    const visibilityWatcher = getVisibilityWatcher();
    const metric = initMetric('LCP');
    let report;
    const handleEntries = entries => {
      // If reportAllChanges is set then call this function for each entry,
      // otherwise only consider the last one.
      if (!opts.reportAllChanges) {
        // eslint-disable-next-line no-param-reassign
        entries = entries.slice(-1);
      }
      entries.forEach(entry => {
        // Only report if the page wasn't hidden prior to LCP.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
          // The startTime attribute returns the value of the renderTime if it is
          // not 0, and the value of the loadTime otherwise. The activationStart
          // reference is used because LCP should be relative to page activation
          // rather than navigation start if the page was pre-rendered. But in cases
          // where `activationStart` occurs after the LCP, this time should be
          // clamped at 0.
          metric.value = Math.max(entry.startTime - getActivationStart(), 0);
          metric.entries = [entry];
          report();
        }
      });
    };
    const po = observe('largest-contentful-paint', handleEntries);
    if (po) {
      report = bindReporter(onReport, metric, LCPThresholds, opts.reportAllChanges);
      const stopListening = runOnce(() => {
        if (!reportedMetricIDs[metric.id]) {
          handleEntries(po.takeRecords());
          po.disconnect();
          reportedMetricIDs[metric.id] = true;
          report(true);
        }
      });

      // Stop listening after input. Note: while scrolling is an input that
      // stops LCP observation, it's unreliable since it can be programmatically
      // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
      ['keydown', 'click'].forEach(type => {
        // Wrap in a setTimeout so the callback is run in a separate task
        // to avoid extending the keyboard/click handler to reduce INP impact
        // https://github.com/GoogleChrome/web-vitals/issues/383
        if (types/* WINDOW.document */.m.document) {
          addEventListener(type, () => whenIdle(stopListening), {
            once: true,
            capture: true
          });
        }
      });
      onHidden(stopListening);
    }
  });
};

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/web-vitals/onTTFB.js







/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */
const TTFBThresholds = [800, 1800];

/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */
const whenReady = callback => {
  if (types/* WINDOW.document */.m.document && types/* WINDOW.document.prerendering */.m.document.prerendering) {
    whenActivated(() => whenReady(callback));
  } else if (types/* WINDOW.document */.m.document && types/* WINDOW.document.readyState */.m.document.readyState !== 'complete') {
    addEventListener('load', () => whenReady(callback), true);
  } else {
    // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
  }
};

/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */
const onTTFB = (onReport, opts = {}) => {
  const metric = initMetric('TTFB');
  const report = bindReporter(onReport, metric, TTFBThresholds, opts.reportAllChanges);
  whenReady(() => {
    const navigationEntry = getNavigationEntry();
    if (navigationEntry) {
      // The activationStart reference is used because TTFB should be
      // relative to page activation rather than navigation start if the
      // page was prerendered. But in cases where `activationStart` occurs
      // after the first byte is received, this time should be clamped at 0.
      metric.value = Math.max(navigationEntry.responseStart - getActivationStart(), 0);
      metric.entries = [navigationEntry];
      report(true);
    }
  });
};

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/instrument.js








const handlers = {};
const instrumented = {};
let _previousCls;
let _previousFid;
let _previousLcp;
let _previousTtfb;
let _previousInp;

/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */
function addClsInstrumentationHandler(callback, stopOnCallback = false) {
  return addMetricObserver('cls', callback, instrumentCls, _previousCls, stopOnCallback);
}

/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */
function addLcpInstrumentationHandler(callback, stopOnCallback = false) {
  return addMetricObserver('lcp', callback, instrumentLcp, _previousLcp, stopOnCallback);
}

/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addFidInstrumentationHandler(callback) {
  return addMetricObserver('fid', callback, instrumentFid, _previousFid);
}

/**
 * Add a callback that will be triggered when a FID metric is available.
 */
function addTtfbInstrumentationHandler(callback) {
  return addMetricObserver('ttfb', callback, instrumentTtfb, _previousTtfb);
}

/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addInpInstrumentationHandler(callback) {
  return addMetricObserver('inp', callback, instrumentInp, _previousInp);
}

/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addPerformanceInstrumentationHandler(type, callback) {
  addHandler(type, callback);
  if (!instrumented[type]) {
    instrumentPerformanceObserver(type);
    instrumented[type] = true;
  }
  return getCleanupCallback(type, callback);
}

/** Trigger all handlers of a given type. */
function triggerHandlers(type, data) {
  const typeHandlers = handlers[type];
  if (!typeHandlers || !typeHandlers.length) {
    return;
  }
  for (const handler of typeHandlers) {
    try {
      handler(data);
    } catch (e) {
      debug_build/* DEBUG_BUILD */.X && logger/* logger.error */.kg.error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0,stacktrace/* getFunctionName */.$P)(handler)}\nError:`, e);
    }
  }
}
function instrumentCls() {
  return onCLS(metric => {
    triggerHandlers('cls', {
      metric
    });
    _previousCls = metric;
  },
  // We want the callback to be called whenever the CLS value updates.
  // By default, the callback is only called when the tab goes to the background.
  {
    reportAllChanges: true
  });
}
function instrumentFid() {
  return onFID(metric => {
    triggerHandlers('fid', {
      metric
    });
    _previousFid = metric;
  });
}
function instrumentLcp() {
  return onLCP(metric => {
    triggerHandlers('lcp', {
      metric
    });
    _previousLcp = metric;
  },
  // We want the callback to be called whenever the LCP value updates.
  // By default, the callback is only called when the tab goes to the background.
  {
    reportAllChanges: true
  });
}
function instrumentTtfb() {
  return onTTFB(metric => {
    triggerHandlers('ttfb', {
      metric
    });
    _previousTtfb = metric;
  });
}
function instrumentInp() {
  return onINP(metric => {
    triggerHandlers('inp', {
      metric
    });
    _previousInp = metric;
  });
}
function addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
  addHandler(type, callback);
  let stopListening;
  if (!instrumented[type]) {
    stopListening = instrumentFn();
    instrumented[type] = true;
  }
  if (previousValue) {
    callback({
      metric: previousValue
    });
  }
  return getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function instrumentPerformanceObserver(type) {
  const options = {};

  // Special per-type options we want to use
  if (type === 'event') {
    options.durationThreshold = 0;
  }
  observe(type, entries => {
    triggerHandlers(type, {
      entries
    });
  }, options);
}
function addHandler(type, handler) {
  handlers[type] = handlers[type] || [];
  handlers[type].push(handler);
}

// Get a callback which can be called to remove the instrumentation handler
function getCleanupCallback(type, callback, stopListening) {
  return () => {
    if (stopListening) {
      stopListening();
    }
    const typeHandlers = handlers[type];
    if (!typeHandlers) {
      return;
    }
    const index = typeHandlers.indexOf(callback);
    if (index !== -1) {
      typeHandlers.splice(index, 1);
    }
  };
}

/**
 * Check if a PerformanceEntry is a PerformanceEventTiming by checking for the `duration` property.
 */
function isPerformanceEventTiming(entry) {
  return 'duration' in entry;
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/trace.js + 5 modules
var trace = __webpack_require__(20806);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/utils.js



/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function startAndEndSpan(parentSpan, startTimeInSeconds, endTime, {
  ...ctx
}) {
  const parentStartTime = (0,spanUtils/* spanToJSON */.XU)(parentSpan).start_timestamp;
  if (parentStartTime && parentStartTime > startTimeInSeconds) {
    // We can only do this for SentrySpans...
    if (typeof parentSpan.updateStartTime === 'function') {
      parentSpan.updateStartTime(startTimeInSeconds);
    }
  }

  // The return value only exists for tests
  return (0,trace/* withActiveSpan */._d)(parentSpan, () => {
    const span = (0,trace/* startInactiveSpan */.qp)({
      startTime: startTimeInSeconds,
      ...ctx
    });
    if (span) {
      span.end(endTime);
    }
    return span;
  });
}

/**
 * Starts an inactive, standalone span used to send web vital values to Sentry.
 * DO NOT use this for arbitrary spans, as these spans require special handling
 * during ingestion to extract metrics.
 *
 * This function adds a bunch of attributes and data to the span that's shared
 * by all web vital standalone spans. However, you need to take care of adding
 * the actual web vital value as an event to the span. Also, you need to assign
 * a transaction name and some other values that are specific to the web vital.
 *
 * Ultimately, you also need to take care of ending the span to send it off.
 *
 * @param options
 *
 * @returns an inactive, standalone and NOT YET ended span
 */
function startStandaloneWebVitalSpan(options) {
  const client = (0,currentScopes/* getClient */.s3)();
  if (!client) {
    return;
  }
  const {
    name,
    transaction,
    attributes: passedAttributes,
    startTime
  } = options;
  const {
    release,
    environment
  } = client.getOptions();
  // We need to get the replay, user, and activeTransaction from the current scope
  // so that we can associate replay id, profile id, and a user display to the span
  const replay = client.getIntegrationByName('Replay');
  const replayId = replay && replay.getReplayId();
  const scope = (0,currentScopes/* getCurrentScope */.nZ)();
  const user = scope.getUser();
  const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
  let profileId;
  try {
    // @ts-expect-error skip optional chaining to save bundle size with try catch
    profileId = scope.getScopeData().contexts.profile.profile_id;
  } catch (e) {
    // do nothing
  }
  const attributes = {
    release,
    environment,
    user: userDisplay || undefined,
    profile_id: profileId || undefined,
    replay_id: replayId || undefined,
    transaction,
    // Web vital score calculation relies on the user agent to account for different
    // browsers setting different thresholds for what is considered a good/meh/bad value.
    // For example: Chrome vs. Chrome Mobile
    'user_agent.original': types/* WINDOW.navigator */.m.navigator && types/* WINDOW.navigator.userAgent */.m.navigator.userAgent,
    ...passedAttributes
  };
  return (0,trace/* startInactiveSpan */.qp)({
    name,
    attributes,
    startTime,
    experimental: {
      standalone: true
    }
  });
}

/** Get the browser performance API. */
function getBrowserPerformanceAPI() {
  // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
  return types/* WINDOW */.m && types/* WINDOW.addEventListener */.m.addEventListener && types/* WINDOW.performance */.m.performance;
}

/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
  return time / 1000;
}

/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */
function extractNetworkProtocol(nextHopProtocol) {
  let name = 'unknown';
  let version = 'unknown';
  let _name = '';
  for (const char of nextHopProtocol) {
    // http/1.1 etc.
    if (char === '/') {
      [name, version] = nextHopProtocol.split('/');
      break;
    }
    // h2, h3 etc.
    if (!isNaN(Number(char))) {
      name = _name === 'h' ? 'http' : _name;
      version = nextHopProtocol.split(_name)[1];
      break;
    }
    _name += char;
  }
  if (_name === nextHopProtocol) {
    // webrtc, ftp, etc.
    name = _name;
  }
  return {
    name,
    version
  };
}

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/cls.js






/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop CLS measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the CLS value is sent as a standalone span and we stop
 * measuring CLS.
 */
function trackClsAsStandaloneSpan() {
  let standaloneCLsValue = 0;
  let standaloneClsEntry;
  let pageloadSpanId;
  if (!supportsLayoutShift()) {
    return;
  }
  let sentSpan = false;
  function _collectClsOnce() {
    if (sentSpan) {
      return;
    }
    sentSpan = true;
    if (pageloadSpanId) {
      sendStandaloneClsSpan(standaloneCLsValue, standaloneClsEntry, pageloadSpanId);
    }
    cleanupClsHandler();
  }
  const cleanupClsHandler = addClsInstrumentationHandler(({
    metric
  }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }
    standaloneCLsValue = metric.value;
    standaloneClsEntry = entry;
  }, true);

  // use pagehide event from web-vitals
  onHidden(() => {
    _collectClsOnce();
  });

  // Since the call chain of this function is synchronous and evaluates before the SDK client is created,
  // we need to wait with subscribing to a client hook until the client is created. Therefore, we defer
  // to the next tick after the SDK setup.
  setTimeout(() => {
    const client = (0,currentScopes/* getClient */.s3)();
    if (!client) {
      return;
    }
    const unsubscribeStartNavigation = client.on('startNavigationSpan', () => {
      _collectClsOnce();
      unsubscribeStartNavigation && unsubscribeStartNavigation();
    });
    const activeSpan = (0,spanUtils/* getActiveSpan */.HN)();
    const rootSpan = activeSpan && (0,spanUtils/* getRootSpan */.Gx)(activeSpan);
    const spanJSON = rootSpan && (0,spanUtils/* spanToJSON */.XU)(rootSpan);
    if (spanJSON && spanJSON.op === 'pageload') {
      pageloadSpanId = rootSpan.spanContext().spanId;
    }
  }, 0);
}
function sendStandaloneClsSpan(clsValue, entry, pageloadSpanId) {
  debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(`Sending CLS span (${clsValue})`);
  const startTime = msToSec((utils_hoist_time/* browserPerformanceTimeOrigin */.Z1 || 0) + (entry && entry.startTime || 0));
  const routeName = (0,currentScopes/* getCurrentScope */.nZ)().getScopeData().transactionName;
  const name = entry ? (0,browser/* htmlTreeAsString */.Rt)(entry.sources[0] && entry.sources[0].node) : 'Layout shift';
  const attributes = (0,object/* dropUndefinedKeys */.Jr)({
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.http.browser.cls',
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J]: 'ui.webvital.cls',
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME */.JQ]: entry && entry.duration || 0,
    // attach the pageload span id to the CLS span so that we can link them in the UI
    'sentry.pageload.span_id': pageloadSpanId
  });
  const span = startStandaloneWebVitalSpan({
    name,
    transaction: routeName,
    attributes,
    startTime
  });
  if (span) {
    span.addEvent('cls', {
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT */.E1]: '',
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE */.Wb]: clsValue
    });

    // LayoutShift performance entries always have a duration of 0, so we don't need to add `entry.duration` here
    // see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEntry/duration
    span.end(startTime);
  }
}
function supportsLayoutShift() {
  try {
    return PerformanceObserver.supportedEntryTypes.includes('layout-shift');
  } catch (e) {
    return false;
  }
}

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/browserMetrics.js








const MAX_INT_AS_BYTES = 2147483647;
let _performanceCursor = 0;
let _measurements = {};
let _lcpEntry;
let _clsEntry;

/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */
function startTrackingWebVitals({
  recordClsStandaloneSpans
}) {
  const performance = getBrowserPerformanceAPI();
  if (performance && utils_hoist_time/* browserPerformanceTimeOrigin */.Z1) {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    if (performance.mark) {
      types/* WINDOW.performance.mark */.m.performance.mark('sentry-tracing-init');
    }
    const fidCleanupCallback = _trackFID();
    const lcpCleanupCallback = _trackLCP();
    const ttfbCleanupCallback = _trackTtfb();
    const clsCleanupCallback = recordClsStandaloneSpans ? trackClsAsStandaloneSpan() : _trackCLS();
    return () => {
      fidCleanupCallback();
      lcpCleanupCallback();
      ttfbCleanupCallback();
      clsCleanupCallback && clsCleanupCallback();
    };
  }
  return () => undefined;
}

/**
 * Start tracking long tasks.
 */
function startTrackingLongTasks() {
  addPerformanceInstrumentationHandler('longtask', ({
    entries
  }) => {
    const parent = (0,spanUtils/* getActiveSpan */.HN)();
    if (!parent) {
      return;
    }
    const {
      op: parentOp,
      start_timestamp: parentStartTimestamp
    } = (0,spanUtils/* spanToJSON */.XU)(parent);
    for (const entry of entries) {
      const startTime = msToSec(utils_hoist_time/* browserPerformanceTimeOrigin */.Z1 + entry.startTime);
      const duration = msToSec(entry.duration);
      if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) {
        // Skip adding a span if the long task started before the navigation started.
        // `startAndEndSpan` will otherwise adjust the parent's start time to the span's start
        // time, potentially skewing the duration of the actual navigation as reported via our
        // routing instrumentations
        continue;
      }
      startAndEndSpan(parent, startTime, startTime + duration, {
        name: 'Main UI thread blocked',
        op: 'ui.long-task',
        attributes: {
          [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.ui.browser.metrics'
        }
      });
    }
  });
}

/**
 * Start tracking long animation frames.
 */
function startTrackingLongAnimationFrames() {
  // NOTE: the current web-vitals version (3.5.2) does not support long-animation-frame, so
  // we directly observe `long-animation-frame` events instead of through the web-vitals
  // `observe` helper function.
  const observer = new PerformanceObserver(list => {
    const parent = (0,spanUtils/* getActiveSpan */.HN)();
    if (!parent) {
      return;
    }
    for (const entry of list.getEntries()) {
      if (!entry.scripts[0]) {
        continue;
      }
      const startTime = msToSec(utils_hoist_time/* browserPerformanceTimeOrigin */.Z1 + entry.startTime);
      const {
        start_timestamp: parentStartTimestamp,
        op: parentOp
      } = (0,spanUtils/* spanToJSON */.XU)(parent);
      if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) {
        // Skip adding the span if the long animation frame started before the navigation started.
        // `startAndEndSpan` will otherwise adjust the parent's start time to the span's start
        // time, potentially skewing the duration of the actual navigation as reported via our
        // routing instrumentations
        continue;
      }
      const duration = msToSec(entry.duration);
      const attributes = {
        [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.ui.browser.metrics'
      };
      const initialScript = entry.scripts[0];
      const {
        invoker,
        invokerType,
        sourceURL,
        sourceFunctionName,
        sourceCharPosition
      } = initialScript;
      attributes['browser.script.invoker'] = invoker;
      attributes['browser.script.invoker_type'] = invokerType;
      if (sourceURL) {
        attributes['code.filepath'] = sourceURL;
      }
      if (sourceFunctionName) {
        attributes['code.function'] = sourceFunctionName;
      }
      if (sourceCharPosition !== -1) {
        attributes['browser.script.source_char_position'] = sourceCharPosition;
      }
      startAndEndSpan(parent, startTime, startTime + duration, {
        name: 'Main UI thread blocked',
        op: 'ui.long-animation-frame',
        attributes
      });
    }
  });
  observer.observe({
    type: 'long-animation-frame',
    buffered: true
  });
}

/**
 * Start tracking interaction events.
 */
function startTrackingInteractions() {
  addPerformanceInstrumentationHandler('event', ({
    entries
  }) => {
    const parent = (0,spanUtils/* getActiveSpan */.HN)();
    if (!parent) {
      return;
    }
    for (const entry of entries) {
      if (entry.name === 'click') {
        const startTime = msToSec(utils_hoist_time/* browserPerformanceTimeOrigin */.Z1 + entry.startTime);
        const duration = msToSec(entry.duration);
        const spanOptions = {
          name: (0,browser/* htmlTreeAsString */.Rt)(entry.target),
          op: `ui.interaction.${entry.name}`,
          startTime: startTime,
          attributes: {
            [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.ui.browser.metrics'
          }
        };
        const componentName = (0,browser/* getComponentName */.iY)(entry.target);
        if (componentName) {
          spanOptions.attributes['ui.component_name'] = componentName;
        }
        startAndEndSpan(parent, startTime, startTime + duration, spanOptions);
      }
    }
  });
}

/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value and last entry
 * to the `_measurements` object which ultimately is applied to the pageload span's measurements.
 */
function _trackCLS() {
  return addClsInstrumentationHandler(({
    metric
  }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }
    _measurements['cls'] = {
      value: metric.value,
      unit: ''
    };
    _clsEntry = entry;
  }, true);
}

/** Starts tracking the Largest Contentful Paint on the current page. */
function _trackLCP() {
  return addLcpInstrumentationHandler(({
    metric
  }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }
    _measurements['lcp'] = {
      value: metric.value,
      unit: 'millisecond'
    };
    _lcpEntry = entry;
  }, true);
}

/** Starts tracking the First Input Delay on the current page. */
function _trackFID() {
  return addFidInstrumentationHandler(({
    metric
  }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }
    const timeOrigin = msToSec(utils_hoist_time/* browserPerformanceTimeOrigin */.Z1);
    const startTime = msToSec(entry.startTime);
    _measurements['fid'] = {
      value: metric.value,
      unit: 'millisecond'
    };
    _measurements['mark.fid'] = {
      value: timeOrigin + startTime,
      unit: 'second'
    };
  });
}
function _trackTtfb() {
  return addTtfbInstrumentationHandler(({
    metric
  }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }
    _measurements['ttfb'] = {
      value: metric.value,
      unit: 'millisecond'
    };
  });
}

/** Add performance related spans to a transaction */
function addPerformanceEntries(span, options) {
  const performance = getBrowserPerformanceAPI();
  if (!performance || !performance.getEntries || !utils_hoist_time/* browserPerformanceTimeOrigin */.Z1) {
    // Gatekeeper if performance API not available
    return;
  }
  const timeOrigin = msToSec(utils_hoist_time/* browserPerformanceTimeOrigin */.Z1);
  const performanceEntries = performance.getEntries();
  const {
    op,
    start_timestamp: transactionStartTime
  } = (0,spanUtils/* spanToJSON */.XU)(span);
  performanceEntries.slice(_performanceCursor).forEach(entry => {
    const startTime = msToSec(entry.startTime);
    const duration = msToSec(
    // Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
    // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
    // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
    // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
    Math.max(0, entry.duration));
    if (op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) {
      return;
    }
    switch (entry.entryType) {
      case 'navigation':
        {
          _addNavigationSpans(span, entry, timeOrigin);
          break;
        }
      case 'mark':
      case 'paint':
      case 'measure':
        {
          _addMeasureSpans(span, entry, startTime, duration, timeOrigin);

          // capture web vitals
          const firstHidden = getVisibilityWatcher();
          // Only report if the page wasn't hidden prior to the web vital.
          const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
          if (entry.name === 'first-paint' && shouldRecord) {
            _measurements['fp'] = {
              value: entry.startTime,
              unit: 'millisecond'
            };
          }
          if (entry.name === 'first-contentful-paint' && shouldRecord) {
            _measurements['fcp'] = {
              value: entry.startTime,
              unit: 'millisecond'
            };
          }
          break;
        }
      case 'resource':
        {
          _addResourceSpans(span, entry, entry.name, startTime, duration, timeOrigin);
          break;
        }
      // Ignore other entry types.
    }
  });
  _performanceCursor = Math.max(performanceEntries.length - 1, 0);
  _trackNavigator(span);

  // Measurements are only available for pageload transactions
  if (op === 'pageload') {
    _addTtfbRequestTimeToMeasurements(_measurements);
    const fidMark = _measurements['mark.fid'];
    if (fidMark && _measurements['fid']) {
      // create span for FID
      startAndEndSpan(span, fidMark.value, fidMark.value + msToSec(_measurements['fid'].value), {
        name: 'first input delay',
        op: 'ui.action',
        attributes: {
          [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.ui.browser.metrics'
        }
      });

      // Delete mark.fid as we don't want it to be part of final payload
      delete _measurements['mark.fid'];
    }

    // If FCP is not recorded we should not record the cls value
    // according to the new definition of CLS.
    // TODO: Check if the first condition is still necessary: `onCLS` already only fires once `onFCP` was called.
    if (!('fcp' in _measurements) || !options.recordClsOnPageloadSpan) {
      delete _measurements.cls;
    }
    Object.entries(_measurements).forEach(([measurementName, measurement]) => {
      (0,tracing_measurement/* setMeasurement */.o)(measurementName, measurement.value, measurement.unit);
    });

    // Set timeOrigin which denotes the timestamp which to base the LCP/FCP/FP/TTFB measurements on
    span.setAttribute('performance.timeOrigin', timeOrigin);

    // In prerendering scenarios, where a page might be prefetched and pre-rendered before the user clicks the link,
    // the navigation starts earlier than when the user clicks it. Web Vitals should always be based on the
    // user-perceived time, so they are not reported from the actual start of the navigation, but rather from the
    // time where the user actively started the navigation, for example by clicking a link.
    // This is user action is called "activation" and the time between navigation and activation is stored in
    // the `activationStart` attribute of the "navigation" PerformanceEntry.
    span.setAttribute('performance.activationStart', getActivationStart());
    _setWebVitalAttributes(span);
  }
  _lcpEntry = undefined;
  _clsEntry = undefined;
  _measurements = {};
}

/**
 * Create measure related spans.
 * Exported only for tests.
 */
function _addMeasureSpans(span, entry, startTime, duration, timeOrigin) {
  const navEntry = getNavigationEntry(false);
  const requestTime = msToSec(navEntry ? navEntry.requestStart : 0);
  // Because performance.measure accepts arbitrary timestamps it can produce
  // spans that happen before the browser even makes a request for the page.
  //
  // An example of this is the automatically generated Next.js-before-hydration
  // spans created by the Next.js framework.
  //
  // To prevent this we will pin the start timestamp to the request start time
  // This does make duration inaccurate, so if this does happen, we will add
  // an attribute to the span
  const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
  const startTimeStamp = timeOrigin + startTime;
  const measureEndTimestamp = startTimeStamp + duration;
  const attributes = {
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.resource.browser.metrics'
  };
  if (measureStartTimestamp !== startTimeStamp) {
    attributes['sentry.browser.measure_happened_before_request'] = true;
    attributes['sentry.browser.measure_start_time'] = measureStartTimestamp;
  }
  startAndEndSpan(span, measureStartTimestamp, measureEndTimestamp, {
    name: entry.name,
    op: entry.entryType,
    attributes
  });
  return measureStartTimestamp;
}

/** Instrument navigation entries */
function _addNavigationSpans(span, entry, timeOrigin) {
  ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(event => {
    _addPerformanceNavigationTiming(span, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(span, entry, 'secureConnection', timeOrigin, 'TLS/SSL');
  _addPerformanceNavigationTiming(span, entry, 'fetch', timeOrigin, 'cache');
  _addPerformanceNavigationTiming(span, entry, 'domainLookup', timeOrigin, 'DNS');
  _addRequest(span, entry, timeOrigin);
}

/** Create performance navigation related spans */
function _addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
  const eventEnd = _getEndPropertyNameForNavigationTiming(event);
  const end = entry[eventEnd];
  const start = entry[`${event}Start`];
  if (!start || !end) {
    return;
  }
  startAndEndSpan(span, timeOrigin + msToSec(start), timeOrigin + msToSec(end), {
    op: `browser.${name}`,
    name: entry.name,
    attributes: {
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.ui.browser.metrics'
    }
  });
}
function _getEndPropertyNameForNavigationTiming(event) {
  if (event === 'secureConnection') {
    return 'connectEnd';
  }
  if (event === 'fetch') {
    return 'domainLookupStart';
  }
  return `${event}End`;
}

/** Create request and response related spans */
function _addRequest(span, entry, timeOrigin) {
  const requestStartTimestamp = timeOrigin + msToSec(entry.requestStart);
  const responseEndTimestamp = timeOrigin + msToSec(entry.responseEnd);
  const responseStartTimestamp = timeOrigin + msToSec(entry.responseStart);
  if (entry.responseEnd) {
    // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
    // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
    // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
    // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
    startAndEndSpan(span, requestStartTimestamp, responseEndTimestamp, {
      op: 'browser.request',
      name: entry.name,
      attributes: {
        [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.ui.browser.metrics'
      }
    });
    startAndEndSpan(span, responseStartTimestamp, responseEndTimestamp, {
      op: 'browser.response',
      name: entry.name,
      attributes: {
        [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.ui.browser.metrics'
      }
    });
  }
}

/**
 * Create resource-related spans.
 * Exported only for tests.
 */
function _addResourceSpans(span, entry, resourceUrl, startTime, duration, timeOrigin) {
  // we already instrument based on fetch and xhr, so we don't need to
  // duplicate spans here.
  if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
    return;
  }
  const parsedUrl = (0,utils_hoist_url/* parseUrl */.en)(resourceUrl);
  const attributes = {
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.resource.browser.metrics'
  };
  setResourceEntrySizeData(attributes, entry, 'transferSize', 'http.response_transfer_size');
  setResourceEntrySizeData(attributes, entry, 'encodedBodySize', 'http.response_content_length');
  setResourceEntrySizeData(attributes, entry, 'decodedBodySize', 'http.decoded_response_content_length');

  // `deliveryType` is experimental and does not exist everywhere
  const deliveryType = entry.deliveryType;
  if (deliveryType != null) {
    attributes['http.response_delivery_type'] = deliveryType;
  }

  // Types do not reflect this property yet
  const renderBlockingStatus = entry.renderBlockingStatus;
  if (renderBlockingStatus) {
    attributes['resource.render_blocking_status'] = renderBlockingStatus;
  }
  if (parsedUrl.protocol) {
    attributes['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
  }
  if (parsedUrl.host) {
    attributes['server.address'] = parsedUrl.host;
  }
  attributes['url.same_origin'] = resourceUrl.includes(types/* WINDOW.location.origin */.m.location.origin);
  const {
    name,
    version
  } = extractNetworkProtocol(entry.nextHopProtocol);
  attributes['network.protocol.name'] = name;
  attributes['network.protocol.version'] = version;
  const startTimestamp = timeOrigin + startTime;
  const endTimestamp = startTimestamp + duration;
  startAndEndSpan(span, startTimestamp, endTimestamp, {
    name: resourceUrl.replace(types/* WINDOW.location.origin */.m.location.origin, ''),
    op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
    attributes
  });
}

/**
 * Capture the information of the user agent.
 */
function _trackNavigator(span) {
  const navigator = types/* WINDOW.navigator */.m.navigator;
  if (!navigator) {
    return;
  }

  // track network connectivity
  const connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      span.setAttribute('effectiveConnectionType', connection.effectiveType);
    }
    if (connection.type) {
      span.setAttribute('connectionType', connection.type);
    }
    if (isMeasurementValue(connection.rtt)) {
      _measurements['connection.rtt'] = {
        value: connection.rtt,
        unit: 'millisecond'
      };
    }
  }
  if (isMeasurementValue(navigator.deviceMemory)) {
    span.setAttribute('deviceMemory', `${navigator.deviceMemory} GB`);
  }
  if (isMeasurementValue(navigator.hardwareConcurrency)) {
    span.setAttribute('hardwareConcurrency', String(navigator.hardwareConcurrency));
  }
}

/** Add LCP / CLS data to span to allow debugging */
function _setWebVitalAttributes(span) {
  if (_lcpEntry) {
    // Capture Properties of the LCP element that contributes to the LCP.

    if (_lcpEntry.element) {
      span.setAttribute('lcp.element', (0,browser/* htmlTreeAsString */.Rt)(_lcpEntry.element));
    }
    if (_lcpEntry.id) {
      span.setAttribute('lcp.id', _lcpEntry.id);
    }
    if (_lcpEntry.url) {
      // Trim URL to the first 200 characters.
      span.setAttribute('lcp.url', _lcpEntry.url.trim().slice(0, 200));
    }
    if (_lcpEntry.loadTime != null) {
      // loadTime is the time of LCP that's related to receiving the LCP element response..
      span.setAttribute('lcp.loadTime', _lcpEntry.loadTime);
    }
    if (_lcpEntry.renderTime != null) {
      // renderTime is loadTime + rendering time
      // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
      // `Timing-Allow-Origin` header.
      span.setAttribute('lcp.renderTime', _lcpEntry.renderTime);
    }
    span.setAttribute('lcp.size', _lcpEntry.size);
  }

  // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
  if (_clsEntry && _clsEntry.sources) {
    _clsEntry.sources.forEach((source, index) => span.setAttribute(`cls.source.${index + 1}`, (0,browser/* htmlTreeAsString */.Rt)(source.node)));
  }
}
function setResourceEntrySizeData(attributes, entry, key, dataKey) {
  const entryVal = entry[key];
  if (entryVal != null && entryVal < MAX_INT_AS_BYTES) {
    attributes[dataKey] = entryVal;
  }
}

/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */
function _addTtfbRequestTimeToMeasurements(_measurements) {
  const navEntry = getNavigationEntry(false);
  if (!navEntry) {
    return;
  }
  const {
    responseStart,
    requestStart
  } = navEntry;
  if (requestStart <= responseStart) {
    _measurements['ttfb.requestTime'] = {
      value: responseStart - requestStart,
      unit: 'millisecond'
    };
  }
}

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/metrics/inp.js



const LAST_INTERACTIONS = [];
const INTERACTIONS_SPAN_MAP = new Map();

/**
 * Start tracking INP webvital events.
 */
function startTrackingINP() {
  const performance = getBrowserPerformanceAPI();
  if (performance && utils_hoist_time/* browserPerformanceTimeOrigin */.Z1) {
    const inpCallback = _trackINP();
    return () => {
      inpCallback();
    };
  }
  return () => undefined;
}
const INP_ENTRY_MAP = {
  click: 'click',
  pointerdown: 'click',
  pointerup: 'click',
  mousedown: 'click',
  mouseup: 'click',
  touchstart: 'click',
  touchend: 'click',
  mouseover: 'hover',
  mouseout: 'hover',
  mouseenter: 'hover',
  mouseleave: 'hover',
  pointerover: 'hover',
  pointerout: 'hover',
  pointerenter: 'hover',
  pointerleave: 'hover',
  dragstart: 'drag',
  dragend: 'drag',
  drag: 'drag',
  dragenter: 'drag',
  dragleave: 'drag',
  dragover: 'drag',
  drop: 'drag',
  keydown: 'press',
  keyup: 'press',
  keypress: 'press',
  input: 'press'
};

/** Starts tracking the Interaction to Next Paint on the current page. */
function _trackINP() {
  return addInpInstrumentationHandler(({
    metric
  }) => {
    if (metric.value == undefined) {
      return;
    }
    const entry = metric.entries.find(entry => entry.duration === metric.value && INP_ENTRY_MAP[entry.name]);
    if (!entry) {
      return;
    }
    const {
      interactionId
    } = entry;
    const interactionType = INP_ENTRY_MAP[entry.name];

    /** Build the INP span, create an envelope from the span, and then send the envelope */
    const startTime = msToSec(utils_hoist_time/* browserPerformanceTimeOrigin */.Z1 + entry.startTime);
    const duration = msToSec(metric.value);
    const activeSpan = (0,spanUtils/* getActiveSpan */.HN)();
    const rootSpan = activeSpan ? (0,spanUtils/* getRootSpan */.Gx)(activeSpan) : undefined;

    // We first try to lookup the span from our INTERACTIONS_SPAN_MAP,
    // where we cache the route per interactionId
    const cachedSpan = interactionId != null ? INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
    const spanToUse = cachedSpan || rootSpan;

    // Else, we try to use the active span.
    // Finally, we fall back to look at the transactionName on the scope
    const routeName = spanToUse ? (0,spanUtils/* spanToJSON */.XU)(spanToUse).description : (0,currentScopes/* getCurrentScope */.nZ)().getScopeData().transactionName;
    const name = (0,browser/* htmlTreeAsString */.Rt)(entry.target);
    const attributes = (0,object/* dropUndefinedKeys */.Jr)({
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.http.browser.inp',
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J]: `ui.interaction.${interactionType}`,
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME */.JQ]: entry.duration
    });
    const span = startStandaloneWebVitalSpan({
      name,
      transaction: routeName,
      attributes,
      startTime
    });
    if (span) {
      span.addEvent('inp', {
        [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT */.E1]: 'millisecond',
        [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE */.Wb]: metric.value
      });
      span.end(startTime + duration);
    }
  });
}

/**
 * Register a listener to cache route information for INP interactions.
 * TODO(v9): `latestRoute` no longer needs to be passed in and will be removed in v9.
 */
function registerInpInteractionListener(_latestRoute) {
  const handleEntries = ({
    entries
  }) => {
    const activeSpan = (0,spanUtils/* getActiveSpan */.HN)();
    const activeRootSpan = activeSpan && (0,spanUtils/* getRootSpan */.Gx)(activeSpan);
    entries.forEach(entry => {
      if (!isPerformanceEventTiming(entry) || !activeRootSpan) {
        return;
      }
      const interactionId = entry.interactionId;
      if (interactionId == null) {
        return;
      }

      // If the interaction was already recorded before, nothing more to do
      if (INTERACTIONS_SPAN_MAP.has(interactionId)) {
        return;
      }

      // We keep max. 10 interactions in the list, then remove the oldest one & clean up
      if (LAST_INTERACTIONS.length > 10) {
        const last = LAST_INTERACTIONS.shift();
        INTERACTIONS_SPAN_MAP.delete(last);
      }

      // We add the interaction to the list of recorded interactions
      // and store the span for this interaction
      LAST_INTERACTIONS.push(interactionId);
      INTERACTIONS_SPAN_MAP.set(interactionId, activeRootSpan);
    });
  };
  addPerformanceInstrumentationHandler('event', handleEntries);
  addPerformanceInstrumentationHandler('first-input', handleEntries);
}

// EXTERNAL MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/instrument/history.js + 1 modules
var instrument_history = __webpack_require__(29465);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/debug-build.js
var esm_debug_build = __webpack_require__(27344);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/hasTracingEnabled.js
var hasTracingEnabled = __webpack_require__(68807);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanOnScope.js
var spanOnScope = __webpack_require__(14252);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/sentryNonRecordingSpan.js
var sentryNonRecordingSpan = __webpack_require__(95055);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/spanstatus.js
var spanstatus = __webpack_require__(89898);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/tracing/idleSpan.js











const TRACING_DEFAULTS = {
  idleTimeout: 1000,
  finalTimeout: 30000,
  childSpanTimeout: 15000
};
const FINISH_REASON_HEARTBEAT_FAILED = 'heartbeatFailed';
const FINISH_REASON_IDLE_TIMEOUT = 'idleTimeout';
const FINISH_REASON_FINAL_TIMEOUT = 'finalTimeout';
const FINISH_REASON_EXTERNAL_FINISH = 'externalFinish';

/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */
function startIdleSpan(startSpanOptions, options = {}) {
  // Activities store a list of active spans
  const activities = new Map();

  // We should not use heartbeat if we finished a span
  let _finished = false;

  // Timer that tracks idleTimeout
  let _idleTimeoutID;

  // The reason why the span was finished
  let _finishReason = FINISH_REASON_EXTERNAL_FINISH;
  let _autoFinishAllowed = !options.disableAutoFinish;
  const _cleanupHooks = [];
  const {
    idleTimeout = TRACING_DEFAULTS.idleTimeout,
    finalTimeout = TRACING_DEFAULTS.finalTimeout,
    childSpanTimeout = TRACING_DEFAULTS.childSpanTimeout,
    beforeSpanEnd
  } = options;
  const client = (0,currentScopes/* getClient */.s3)();
  if (!client || !(0,hasTracingEnabled/* hasTracingEnabled */.z)()) {
    return new sentryNonRecordingSpan/* SentryNonRecordingSpan */.b();
  }
  const scope = (0,currentScopes/* getCurrentScope */.nZ)();
  const previousActiveSpan = (0,spanUtils/* getActiveSpan */.HN)();
  const span = _startIdleSpan(startSpanOptions);

  // We patch span.end to ensure we can run some things before the span is ended
  // eslint-disable-next-line @typescript-eslint/unbound-method
  span.end = new Proxy(span.end, {
    apply(target, thisArg, args) {
      if (beforeSpanEnd) {
        beforeSpanEnd(span);
      }

      // Just ensuring that this keeps working, even if we ever have more arguments here
      const [definedEndTimestamp, ...rest] = args;
      const timestamp = definedEndTimestamp || (0,utils_hoist_time/* timestampInSeconds */.ph)();
      const spanEndTimestamp = (0,spanUtils/* spanTimeInputToSeconds */.$k)(timestamp);

      // Ensure we end with the last span timestamp, if possible
      const spans = (0,spanUtils/* getSpanDescendants */.Dp)(span).filter(child => child !== span);

      // If we have no spans, we just end, nothing else to do here
      if (!spans.length) {
        onIdleSpanEnded(spanEndTimestamp);
        return Reflect.apply(target, thisArg, [spanEndTimestamp, ...rest]);
      }
      const childEndTimestamps = spans.map(span => (0,spanUtils/* spanToJSON */.XU)(span).timestamp).filter(timestamp => !!timestamp);
      const latestSpanEndTimestamp = childEndTimestamps.length ? Math.max(...childEndTimestamps) : undefined;

      // In reality this should always exist here, but type-wise it may be undefined...
      const spanStartTimestamp = (0,spanUtils/* spanToJSON */.XU)(span).start_timestamp;

      // The final endTimestamp should:
      // * Never be before the span start timestamp
      // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
      // * Otherwise be the passed end timestamp
      // Final timestamp can never be after finalTimeout
      const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
      onIdleSpanEnded(endTimestamp);
      return Reflect.apply(target, thisArg, [endTimestamp, ...rest]);
    }
  });

  /**
   * Cancels the existing idle timeout, if there is one.
   */
  function _cancelIdleTimeout() {
    if (_idleTimeoutID) {
      clearTimeout(_idleTimeoutID);
      _idleTimeoutID = undefined;
    }
  }

  /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */
  function _restartIdleTimeout(endTimestamp) {
    _cancelIdleTimeout();
    _idleTimeoutID = setTimeout(() => {
      if (!_finished && activities.size === 0 && _autoFinishAllowed) {
        _finishReason = FINISH_REASON_IDLE_TIMEOUT;
        span.end(endTimestamp);
      }
    }, idleTimeout);
  }

  /**
   * Restarts child span timeout, if there is none running it will start one.
   */
  function _restartChildSpanTimeout(endTimestamp) {
    _idleTimeoutID = setTimeout(() => {
      if (!_finished && _autoFinishAllowed) {
        _finishReason = FINISH_REASON_HEARTBEAT_FAILED;
        span.end(endTimestamp);
      }
    }, childSpanTimeout);
  }

  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
  function _pushActivity(spanId) {
    _cancelIdleTimeout();
    activities.set(spanId, true);
    const endTimestamp = (0,utils_hoist_time/* timestampInSeconds */.ph)();
    // We need to add the timeout here to have the real endtimestamp of the idle span
    // Remember timestampInSeconds is in seconds, timeout is in ms
    _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
  }

  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
  function _popActivity(spanId) {
    if (activities.has(spanId)) {
      activities.delete(spanId);
    }
    if (activities.size === 0) {
      const endTimestamp = (0,utils_hoist_time/* timestampInSeconds */.ph)();
      // We need to add the timeout here to have the real endtimestamp of the idle span
      // Remember timestampInSeconds is in seconds, timeout is in ms
      _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
    }
  }
  function onIdleSpanEnded(endTimestamp) {
    _finished = true;
    activities.clear();
    _cleanupHooks.forEach(cleanup => cleanup());
    (0,spanOnScope/* _setSpanForScope */.D)(scope, previousActiveSpan);
    const spanJSON = (0,spanUtils/* spanToJSON */.XU)(span);
    const {
      start_timestamp: startTimestamp
    } = spanJSON;
    // This should never happen, but to make TS happy...
    if (!startTimestamp) {
      return;
    }
    const attributes = spanJSON.data || {};
    if (!attributes[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON */.ju]) {
      span.setAttribute(semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON */.ju, _finishReason);
    }
    logger/* logger.log */.kg.log(`[Tracing] Idle span "${spanJSON.op}" finished`);
    const childSpans = (0,spanUtils/* getSpanDescendants */.Dp)(span).filter(child => child !== span);
    let discardedSpans = 0;
    childSpans.forEach(childSpan => {
      // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
      if (childSpan.isRecording()) {
        childSpan.setStatus({
          code: spanstatus/* SPAN_STATUS_ERROR */.jt,
          message: 'cancelled'
        });
        childSpan.end(endTimestamp);
        esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('[Tracing] Cancelling span since span ended early', JSON.stringify(childSpan, undefined, 2));
      }
      const childSpanJSON = (0,spanUtils/* spanToJSON */.XU)(childSpan);
      const {
        timestamp: childEndTimestamp = 0,
        start_timestamp: childStartTimestamp = 0
      } = childSpanJSON;
      const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;

      // Add a delta with idle timeout so that we prevent false positives
      const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
      const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
      if (esm_debug_build/* DEBUG_BUILD */.X) {
        const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
        if (!spanStartedBeforeIdleSpanEnd) {
          logger/* logger.log */.kg.log('[Tracing] Discarding span since it happened after idle span was finished', stringifiedSpan);
        } else if (!spanEndedBeforeFinalTimeout) {
          logger/* logger.log */.kg.log('[Tracing] Discarding span since it finished after idle span final timeout', stringifiedSpan);
        }
      }
      if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
        (0,spanUtils/* removeChildSpanFromSpan */.ed)(span, childSpan);
        discardedSpans++;
      }
    });
    if (discardedSpans > 0) {
      span.setAttribute('sentry.idle_span_discarded_spans', discardedSpans);
    }
  }
  _cleanupHooks.push(client.on('spanStart', startedSpan => {
    // If we already finished the idle span,
    // or if this is the idle span itself being started,
    // or if the started span has already been closed,
    // we don't care about it for activity
    if (_finished || startedSpan === span || !!(0,spanUtils/* spanToJSON */.XU)(startedSpan).timestamp) {
      return;
    }
    const allSpans = (0,spanUtils/* getSpanDescendants */.Dp)(span);

    // If the span that was just started is a child of the idle span, we should track it
    if (allSpans.includes(startedSpan)) {
      _pushActivity(startedSpan.spanContext().spanId);
    }
  }));
  _cleanupHooks.push(client.on('spanEnd', endedSpan => {
    if (_finished) {
      return;
    }
    _popActivity(endedSpan.spanContext().spanId);
  }));
  _cleanupHooks.push(client.on('idleSpanEnableAutoFinish', spanToAllowAutoFinish => {
    if (spanToAllowAutoFinish === span) {
      _autoFinishAllowed = true;
      _restartIdleTimeout();
      if (activities.size) {
        _restartChildSpanTimeout();
      }
    }
  }));

  // We only start the initial idle timeout if we are not delaying the auto finish
  if (!options.disableAutoFinish) {
    _restartIdleTimeout();
  }
  setTimeout(() => {
    if (!_finished) {
      span.setStatus({
        code: spanstatus/* SPAN_STATUS_ERROR */.jt,
        message: 'deadline_exceeded'
      });
      _finishReason = FINISH_REASON_FINAL_TIMEOUT;
      span.end();
    }
  }, finalTimeout);
  return span;
}
function _startIdleSpan(options) {
  const span = (0,trace/* startInactiveSpan */.qp)(options);
  (0,spanOnScope/* _setSpanForScope */.D)((0,currentScopes/* getCurrentScope */.nZ)(), span);
  esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('[Tracing] Started span is an idle span');
  return span;
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/instrument/globalError.js
var globalError = __webpack_require__(33246);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/instrument/globalUnhandledRejection.js
var globalUnhandledRejection = __webpack_require__(80201);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/tracing/errors.js






let errorsInstrumented = false;

/**
 * Ensure that global errors automatically set the active span status.
 */
function registerSpanErrorInstrumentation() {
  if (errorsInstrumented) {
    return;
  }
  errorsInstrumented = true;
  (0,globalError/* addGlobalErrorInstrumentationHandler */.V)(errorCallback);
  (0,globalUnhandledRejection/* addGlobalUnhandledRejectionInstrumentationHandler */.h)(errorCallback);
}

/**
 * If an error or unhandled promise occurs, we mark the active root span as failed
 */
function errorCallback() {
  const activeSpan = (0,spanUtils/* getActiveSpan */.HN)();
  const rootSpan = activeSpan && (0,spanUtils/* getRootSpan */.Gx)(activeSpan);
  if (rootSpan) {
    const message = 'internal_error';
    esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(`[Tracing] Root span: ${message} -> Global error occurred`);
    rootSpan.setStatus({
      code: spanstatus/* SPAN_STATUS_ERROR */.jt,
      message
    });
  }
}

// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
errorCallback.tag = 'sentry_tracingErrorCallback';

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/tracing.js
var tracing = __webpack_require__(87763);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/dynamicSamplingContext.js
var dynamicSamplingContext = __webpack_require__(51789);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/propagationContext.js
var propagationContext = __webpack_require__(28389);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/debug-build.js
var npm_esm_debug_build = __webpack_require__(77818);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/helpers.js
var helpers = __webpack_require__(18861);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/build/npm/esm/tracing/backgroundtab.js




/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
  if (helpers/* WINDOW */.m9 && helpers/* WINDOW.document */.m9.document) {
    helpers/* WINDOW.document.addEventListener */.m9.document.addEventListener('visibilitychange', () => {
      const activeSpan = (0,spanUtils/* getActiveSpan */.HN)();
      if (!activeSpan) {
        return;
      }
      const rootSpan = (0,spanUtils/* getRootSpan */.Gx)(activeSpan);
      if (helpers/* WINDOW.document.hidden */.m9.document.hidden && rootSpan) {
        const cancelledStatus = 'cancelled';
        const {
          op,
          status
        } = (0,spanUtils/* spanToJSON */.XU)(rootSpan);
        if (npm_esm_debug_build/* DEBUG_BUILD */.X) {
          logger/* logger.log */.kg.log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
        }

        // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.
        if (!status) {
          rootSpan.setStatus({
            code: spanstatus/* SPAN_STATUS_ERROR */.jt,
            message: cancelledStatus
          });
        }
        rootSpan.setAttribute('sentry.cancellation_reason', 'document.hidden');
        rootSpan.end();
      }
    });
  } else {
    npm_esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}

// EXTERNAL MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/instrument/xhr.js
var instrument_xhr = __webpack_require__(27325);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/instrument/fetch.js
var fetch = __webpack_require__(56241);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/baggage.js
var utils_hoist_baggage = __webpack_require__(40382);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/asyncContext/index.js + 2 modules
var asyncContext = __webpack_require__(91164);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/carrier.js
var esm_carrier = __webpack_require__(17195);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils/traceData.js














/**
 * Extracts trace propagation data from the current span or from the client's scope (via transaction or propagation
 * context) and serializes it to `sentry-trace` and `baggage` values to strings. These values can be used to propagate
 * a trace via our tracing Http headers or Html `<meta>` tags.
 *
 * This function also applies some validation to the generated sentry-trace and baggage values to ensure that
 * only valid strings are returned.
 *
 * @returns an object with the tracing data values. The object keys are the name of the tracing key to be used as header
 * or meta tag name.
 */
function getTraceData(options = {}) {
  const client = (0,currentScopes/* getClient */.s3)();
  if (!(0,esm_exports/* isEnabled */._k)() || !client) {
    return {};
  }
  const carrier = (0,esm_carrier/* getMainCarrier */.c)();
  const acs = (0,asyncContext/* getAsyncContextStrategy */.G)(carrier);
  if (acs.getTraceData) {
    return acs.getTraceData(options);
  }
  const scope = (0,currentScopes/* getCurrentScope */.nZ)();
  const span = options.span || (0,spanUtils/* getActiveSpan */.HN)();
  const sentryTrace = span ? (0,spanUtils/* spanToTraceHeader */.Hb)(span) : scopeToTraceHeader(scope);
  const dsc = span ? (0,dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.jC)(span) : (0,dynamicSamplingContext/* getDynamicSamplingContextFromScope */.CG)(client, scope);
  const baggage = (0,utils_hoist_baggage/* dynamicSamplingContextToSentryBaggageHeader */.IQ)(dsc);
  const isValidSentryTraceHeader = tracing/* TRACEPARENT_REGEXP.test */.Ke.test(sentryTrace);
  if (!isValidSentryTraceHeader) {
    logger/* logger.warn */.kg.warn('Invalid sentry-trace data. Cannot generate trace data');
    return {};
  }
  return {
    'sentry-trace': sentryTrace,
    baggage
  };
}

/**
 * Get a sentry-trace header value for the given scope.
 */
function scopeToTraceHeader(scope) {
  // TODO(v9): Use generateSpanId() instead of spanId
  // eslint-disable-next-line deprecation/deprecation
  const {
    traceId,
    sampled,
    spanId
  } = scope.getPropagationContext();
  return (0,tracing/* generateSentryTraceHeader */.$p)(traceId, spanId, sampled);
}

;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/fetch.js

















/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */
function instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = 'auto.http.browser') {
  if (!handlerData.fetchData) {
    return undefined;
  }
  const shouldCreateSpanResult = (0,hasTracingEnabled/* hasTracingEnabled */.z)() && shouldCreateSpan(handlerData.fetchData.url);
  if (handlerData.endTimestamp && shouldCreateSpanResult) {
    const spanId = handlerData.fetchData.__span;
    if (!spanId) return;
    const span = spans[spanId];
    if (span) {
      endSpan(span, handlerData);

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return undefined;
  }
  const {
    method,
    url
  } = handlerData.fetchData;
  const fullUrl = getFullURL(url);
  const host = fullUrl ? (0,utils_hoist_url/* parseUrl */.en)(fullUrl).host : undefined;
  const hasParent = !!(0,spanUtils/* getActiveSpan */.HN)();
  const span = shouldCreateSpanResult && hasParent ? (0,trace/* startInactiveSpan */.qp)({
    name: `${method} ${url}`,
    attributes: {
      url,
      type: 'fetch',
      'http.method': method,
      'http.url': fullUrl,
      'server.address': host,
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: spanOrigin,
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J]: 'http.client'
    }
  }) : new sentryNonRecordingSpan/* SentryNonRecordingSpan */.b();
  handlerData.fetchData.__span = span.spanContext().spanId;
  spans[span.spanContext().spanId] = span;
  if (shouldAttachHeaders(handlerData.fetchData.url)) {
    const request = handlerData.args[0];
    const options = handlerData.args[1] || {};
    const headers = _addTracingHeadersToFetchRequest(request, options,
    // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0,hasTracingEnabled/* hasTracingEnabled */.z)() && hasParent ? span : undefined);
    if (headers) {
      // Ensure this is actually set, if no options have been passed previously
      handlerData.args[1] = options;
      options.headers = headers;
    }
  }
  return span;
}

/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 */
function _addTracingHeadersToFetchRequest(request, fetchOptionsObj, span) {
  const traceHeaders = getTraceData({
    span
  });
  const sentryTrace = traceHeaders['sentry-trace'];
  const baggage = traceHeaders.baggage;

  // Nothing to do, when we return undefined here, the original headers will be used
  if (!sentryTrace) {
    return undefined;
  }
  const headers = fetchOptionsObj.headers || (isRequest(request) ? request.headers : undefined);
  if (!headers) {
    return {
      ...traceHeaders
    };
  } else if (isHeaders(headers)) {
    const newHeaders = new Headers(headers);
    newHeaders.set('sentry-trace', sentryTrace);
    if (baggage) {
      const prevBaggageHeader = newHeaders.get('baggage');
      if (prevBaggageHeader) {
        const prevHeaderStrippedFromSentryBaggage = stripBaggageHeaderOfSentryBaggageValues(prevBaggageHeader);
        newHeaders.set('baggage',
        // If there are non-sentry entries (i.e. if the stripped string is non-empty/truthy) combine the stripped header and sentry baggage header
        // otherwise just set the sentry baggage header
        prevHeaderStrippedFromSentryBaggage ? `${prevHeaderStrippedFromSentryBaggage},${baggage}` : baggage);
      } else {
        newHeaders.set('baggage', baggage);
      }
    }
    return newHeaders;
  } else if (Array.isArray(headers)) {
    const newHeaders = [...headers
    // Remove any existing sentry-trace headers
    .filter(header => {
      return !(Array.isArray(header) && header[0] === 'sentry-trace');
    })
    // Get rid of previous sentry baggage values in baggage header
    .map(header => {
      if (Array.isArray(header) && header[0] === 'baggage' && typeof header[1] === 'string') {
        const [headerName, headerValue, ...rest] = header;
        return [headerName, stripBaggageHeaderOfSentryBaggageValues(headerValue), ...rest];
      } else {
        return header;
      }
    }),
    // Attach the new sentry-trace header
    ['sentry-trace', sentryTrace]];
    if (baggage) {
      // If there are multiple entries with the same key, the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.push(['baggage', baggage]);
    }
    return newHeaders;
  } else {
    const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
    let newBaggageHeaders = [];
    if (Array.isArray(existingBaggageHeader)) {
      newBaggageHeaders = existingBaggageHeader.map(headerItem => typeof headerItem === 'string' ? stripBaggageHeaderOfSentryBaggageValues(headerItem) : headerItem).filter(headerItem => headerItem === '');
    } else if (existingBaggageHeader) {
      newBaggageHeaders.push(stripBaggageHeaderOfSentryBaggageValues(existingBaggageHeader));
    }
    if (baggage) {
      newBaggageHeaders.push(baggage);
    }
    return {
      ...headers,
      'sentry-trace': sentryTrace,
      baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
    };
  }
}

/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 *
 * @deprecated This function will not be exported anymore in v9.
 */
function addTracingHeadersToFetchRequest(request, _client, _scope, fetchOptionsObj, span) {
  return _addTracingHeadersToFetchRequest(request, fetchOptionsObj, span);
}
function getFullURL(url) {
  try {
    const parsed = new URL(url);
    return parsed.href;
  } catch (e) {
    return undefined;
  }
}
function endSpan(span, handlerData) {
  if (handlerData.response) {
    (0,spanstatus/* setHttpStatus */.Q0)(span, handlerData.response.status);
    const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');
    if (contentLength) {
      const contentLengthNum = parseInt(contentLength);
      if (contentLengthNum > 0) {
        span.setAttribute('http.response_content_length', contentLengthNum);
      }
    }
  } else if (handlerData.error) {
    span.setStatus({
      code: spanstatus/* SPAN_STATUS_ERROR */.jt,
      message: 'internal_error'
    });
  }
  span.end();
}
function stripBaggageHeaderOfSentryBaggageValues(baggageHeader) {
  return baggageHeader.split(',')
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  .filter(baggageEntry => !baggageEntry.split('=')[0].startsWith(utils_hoist_baggage/* SENTRY_BAGGAGE_KEY_PREFIX */.lq)).join(',');
}
function isRequest(request) {
  return typeof Request !== 'undefined' && (0,is/* isInstanceOf */.V9)(request, Request);
}
function isHeaders(headers) {
  return typeof Headers !== 'undefined' && (0,is/* isInstanceOf */.V9)(headers, Headers);
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/string.js
var string = __webpack_require__(24909);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/build/npm/esm/tracing/request.js




/** Options for Request Instrumentation */

const responseToSpanId = new WeakMap();
const spanIdToEndTimestamp = new Map();
const defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  enableHTTPTimings: true,
  trackFetchStreamPerformance: false
};

/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(client, _options) {
  const {
    traceFetch,
    traceXHR,
    trackFetchStreamPerformance,
    shouldCreateSpanForRequest,
    enableHTTPTimings,
    tracePropagationTargets
  } = {
    traceFetch: defaultRequestInstrumentationOptions.traceFetch,
    traceXHR: defaultRequestInstrumentationOptions.traceXHR,
    trackFetchStreamPerformance: defaultRequestInstrumentationOptions.trackFetchStreamPerformance,
    ..._options
  };
  const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : _ => true;
  const shouldAttachHeadersWithTargets = url => shouldAttachHeaders(url, tracePropagationTargets);
  const spans = {};
  if (traceFetch) {
    // Keeping track of http requests, whose body payloads resolved later than the initial resolved request
    // e.g. streaming using server sent events (SSE)
    client.addEventProcessor(event => {
      if (event.type === 'transaction' && event.spans) {
        event.spans.forEach(span => {
          if (span.op === 'http.client') {
            const updatedTimestamp = spanIdToEndTimestamp.get(span.span_id);
            if (updatedTimestamp) {
              span.timestamp = updatedTimestamp / 1000;
              spanIdToEndTimestamp.delete(span.span_id);
            }
          }
        });
      }
      return event;
    });
    if (trackFetchStreamPerformance) {
      (0,fetch/* addFetchEndInstrumentationHandler */.cf)(handlerData => {
        if (handlerData.response) {
          const span = responseToSpanId.get(handlerData.response);
          if (span && handlerData.endTimestamp) {
            spanIdToEndTimestamp.set(span, handlerData.endTimestamp);
          }
        }
      });
    }
    (0,fetch/* addFetchInstrumentationHandler */.Uf)(handlerData => {
      const createdSpan = instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
      if (handlerData.response && handlerData.fetchData.__span) {
        responseToSpanId.set(handlerData.response, handlerData.fetchData.__span);
      }

      // We cannot use `window.location` in the generic fetch instrumentation,
      // but we need it for reliable `server.address` attribute.
      // so we extend this in here
      if (createdSpan) {
        const fullUrl = request_getFullURL(handlerData.fetchData.url);
        const host = fullUrl ? (0,utils_hoist_url/* parseUrl */.en)(fullUrl).host : undefined;
        createdSpan.setAttributes({
          'http.url': fullUrl,
          'server.address': host
        });
      }
      if (enableHTTPTimings && createdSpan) {
        addHTTPTimings(createdSpan);
      }
    });
  }
  if (traceXHR) {
    (0,instrument_xhr/* addXhrInstrumentationHandler */.UK)(handlerData => {
      const createdSpan = xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
      if (enableHTTPTimings && createdSpan) {
        addHTTPTimings(createdSpan);
      }
    });
  }
}
function isPerformanceResourceTiming(entry) {
  return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}

/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */
function addHTTPTimings(span) {
  const {
    url
  } = (0,spanUtils/* spanToJSON */.XU)(span).data || {};
  if (!url || typeof url !== 'string') {
    return;
  }
  const cleanup = addPerformanceInstrumentationHandler('resource', ({
    entries
  }) => {
    entries.forEach(entry => {
      if (isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
        const spanData = resourceTimingEntryToSpanData(entry);
        spanData.forEach(data => span.setAttribute(...data));
        // In the next tick, clean this handler up
        // We have to wait here because otherwise this cleans itself up before it is fully done
        setTimeout(cleanup);
      }
    });
  });
}
function getAbsoluteTime(time = 0) {
  return ((utils_hoist_time/* browserPerformanceTimeOrigin */.Z1 || performance.timeOrigin) + time) / 1000;
}
function resourceTimingEntryToSpanData(resourceTiming) {
  const {
    name,
    version
  } = extractNetworkProtocol(resourceTiming.nextHopProtocol);
  const timingSpanData = [];
  timingSpanData.push(['network.protocol.version', version], ['network.protocol.name', name]);
  if (!utils_hoist_time/* browserPerformanceTimeOrigin */.Z1) {
    return timingSpanData;
  }
  return [...timingSpanData, ['http.request.redirect_start', getAbsoluteTime(resourceTiming.redirectStart)], ['http.request.fetch_start', getAbsoluteTime(resourceTiming.fetchStart)], ['http.request.domain_lookup_start', getAbsoluteTime(resourceTiming.domainLookupStart)], ['http.request.domain_lookup_end', getAbsoluteTime(resourceTiming.domainLookupEnd)], ['http.request.connect_start', getAbsoluteTime(resourceTiming.connectStart)], ['http.request.secure_connection_start', getAbsoluteTime(resourceTiming.secureConnectionStart)], ['http.request.connection_end', getAbsoluteTime(resourceTiming.connectEnd)], ['http.request.request_start', getAbsoluteTime(resourceTiming.requestStart)], ['http.request.response_start', getAbsoluteTime(resourceTiming.responseStart)], ['http.request.response_end', getAbsoluteTime(resourceTiming.responseEnd)]];
}

/**
 * A function that determines whether to attach tracing headers to a request.
 * We only export this function for testing purposes.
 */
function shouldAttachHeaders(targetUrl, tracePropagationTargets) {
  // window.location.href not being defined is an edge case in the browser but we need to handle it.
  // Potentially dangerous situations where it may not be defined: Browser Extensions, Web Workers, patching of the location obj
  const href = helpers/* WINDOW.location */.m9.location && helpers/* WINDOW.location.href */.m9.location.href;
  if (!href) {
    // If there is no window.location.origin, we default to only attaching tracing headers to relative requests, i.e. ones that start with `/`
    // BIG DISCLAIMER: Users can call URLs with a double slash (fetch("//example.com/api")), this is a shorthand for "send to the same protocol",
    // so we need a to exclude those requests, because they might be cross origin.
    const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
    if (!tracePropagationTargets) {
      return isRelativeSameOriginRequest;
    } else {
      return (0,string/* stringMatchesSomePattern */.U0)(targetUrl, tracePropagationTargets);
    }
  } else {
    let resolvedUrl;
    let currentOrigin;

    // URL parsing may fail, we default to not attaching trace headers in that case.
    try {
      resolvedUrl = new URL(targetUrl, href);
      currentOrigin = new URL(href).origin;
    } catch (e) {
      return false;
    }
    const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
    if (!tracePropagationTargets) {
      return isSameOriginRequest;
    } else {
      return (0,string/* stringMatchesSomePattern */.U0)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0,string/* stringMatchesSomePattern */.U0)(resolvedUrl.pathname, tracePropagationTargets);
    }
  }
}

/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */
function xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
  const xhr = handlerData.xhr;
  const sentryXhrData = xhr && xhr[instrument_xhr/* SENTRY_XHR_DATA_KEY */.xU];
  if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) {
    return undefined;
  }
  const shouldCreateSpanResult = (0,hasTracingEnabled/* hasTracingEnabled */.z)() && shouldCreateSpan(sentryXhrData.url);

  // check first if the request has finished and is tracked by an existing span which should now end
  if (handlerData.endTimestamp && shouldCreateSpanResult) {
    const spanId = xhr.__sentry_xhr_span_id__;
    if (!spanId) return;
    const span = spans[spanId];
    if (span && sentryXhrData.status_code !== undefined) {
      (0,spanstatus/* setHttpStatus */.Q0)(span, sentryXhrData.status_code);
      span.end();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return undefined;
  }
  const fullUrl = request_getFullURL(sentryXhrData.url);
  const host = fullUrl ? (0,utils_hoist_url/* parseUrl */.en)(fullUrl).host : undefined;
  const hasParent = !!(0,spanUtils/* getActiveSpan */.HN)();
  const span = shouldCreateSpanResult && hasParent ? (0,trace/* startInactiveSpan */.qp)({
    name: `${sentryXhrData.method} ${sentryXhrData.url}`,
    attributes: {
      type: 'xhr',
      'http.method': sentryXhrData.method,
      'http.url': fullUrl,
      url: sentryXhrData.url,
      'server.address': host,
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.http.browser',
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J]: 'http.client'
    }
  }) : new sentryNonRecordingSpan/* SentryNonRecordingSpan */.b();
  xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
  spans[xhr.__sentry_xhr_span_id__] = span;
  if (shouldAttachHeaders(sentryXhrData.url)) {
    addTracingHeadersToXhrRequest(xhr,
    // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0,hasTracingEnabled/* hasTracingEnabled */.z)() && hasParent ? span : undefined);
  }
  return span;
}
function addTracingHeadersToXhrRequest(xhr, span) {
  const {
    'sentry-trace': sentryTrace,
    baggage
  } = getTraceData({
    span
  });
  if (sentryTrace) {
    setHeaderOnXhr(xhr, sentryTrace, baggage);
  }
}
function setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
    if (sentryBaggageHeader) {
      // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
      // We can therefore simply set a baggage header without checking what was there before
      // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      xhr.setRequestHeader('baggage', sentryBaggageHeader);
    }
  } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
  }
}
function request_getFullURL(url) {
  try {
    // By adding a base URL to new URL(), this will also work for relative urls
    // If `url` is a full URL, the base URL is ignored anyhow
    const parsed = new URL(url, helpers/* WINDOW.location.origin */.m9.location.origin);
    return parsed.href;
  } catch (e2) {
    return undefined;
  }
}

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/build/npm/esm/tracing/browserTracingIntegration.js







/* eslint-disable max-lines */

const BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';
const DEFAULT_BROWSER_TRACING_OPTIONS = {
  ...TRACING_DEFAULTS,
  instrumentNavigation: true,
  instrumentPageLoad: true,
  markBackgroundSpan: true,
  enableLongTask: true,
  enableLongAnimationFrame: true,
  enableInp: true,
  _experiments: {},
  ...defaultRequestInstrumentationOptions
};

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */
const browserTracingIntegration = (_options = {}) => {
  registerSpanErrorInstrumentation();
  const {
    enableInp,
    enableLongTask,
    enableLongAnimationFrame,
    _experiments: {
      enableInteractions,
      enableStandaloneClsSpans
    },
    beforeStartSpan,
    idleTimeout,
    finalTimeout,
    childSpanTimeout,
    markBackgroundSpan,
    traceFetch,
    traceXHR,
    trackFetchStreamPerformance,
    shouldCreateSpanForRequest,
    enableHTTPTimings,
    instrumentPageLoad,
    instrumentNavigation
  } = {
    ...DEFAULT_BROWSER_TRACING_OPTIONS,
    ..._options
  };
  const _collectWebVitals = startTrackingWebVitals({
    recordClsStandaloneSpans: enableStandaloneClsSpans || false
  });
  if (enableInp) {
    startTrackingINP();
  }
  if (enableLongAnimationFrame && worldwide/* GLOBAL_OBJ.PerformanceObserver */.n.PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('long-animation-frame')) {
    startTrackingLongAnimationFrames();
  } else if (enableLongTask) {
    startTrackingLongTasks();
  }
  if (enableInteractions) {
    startTrackingInteractions();
  }
  const latestRoute = {
    name: undefined,
    source: undefined
  };

  /** Create routing idle transaction. */
  function _createRouteSpan(client, startSpanOptions) {
    const isPageloadTransaction = startSpanOptions.op === 'pageload';
    const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
    const attributes = finalStartSpanOptions.attributes || {};

    // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
    // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
    if (startSpanOptions.name !== finalStartSpanOptions.name) {
      attributes[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj] = 'custom';
      finalStartSpanOptions.attributes = attributes;
    }
    latestRoute.name = finalStartSpanOptions.name;
    latestRoute.source = attributes[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj];
    const idleSpan = startIdleSpan(finalStartSpanOptions, {
      idleTimeout,
      finalTimeout,
      childSpanTimeout,
      // should wait for finish signal if it's a pageload transaction
      disableAutoFinish: isPageloadTransaction,
      beforeSpanEnd: span => {
        _collectWebVitals();
        addPerformanceEntries(span, {
          recordClsOnPageloadSpan: !enableStandaloneClsSpans
        });
      }
    });
    function emitFinish() {
      if (['interactive', 'complete'].includes(helpers/* WINDOW.document.readyState */.m9.document.readyState)) {
        client.emit('idleSpanEnableAutoFinish', idleSpan);
      }
    }
    if (isPageloadTransaction && helpers/* WINDOW.document */.m9.document) {
      helpers/* WINDOW.document.addEventListener */.m9.document.addEventListener('readystatechange', () => {
        emitFinish();
      });
      emitFinish();
    }
    return idleSpan;
  }
  return {
    name: BROWSER_TRACING_INTEGRATION_ID,
    afterAllSetup(client) {
      let activeSpan;
      let startingUrl = helpers/* WINDOW.location */.m9.location && helpers/* WINDOW.location.href */.m9.location.href;
      function maybeEndActiveSpan() {
        if (activeSpan && !(0,spanUtils/* spanToJSON */.XU)(activeSpan).timestamp) {
          npm_esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(`[Tracing] Finishing current active span with op: ${(0,spanUtils/* spanToJSON */.XU)(activeSpan).op}`);
          // If there's an open active span, we need to finish it before creating an new one.
          activeSpan.end();
        }
      }
      client.on('startNavigationSpan', startSpanOptions => {
        if ((0,currentScopes/* getClient */.s3)() !== client) {
          return;
        }
        maybeEndActiveSpan();
        activeSpan = _createRouteSpan(client, {
          op: 'navigation',
          ...startSpanOptions
        });
      });
      client.on('startPageLoadSpan', (startSpanOptions, traceOptions = {}) => {
        if ((0,currentScopes/* getClient */.s3)() !== client) {
          return;
        }
        maybeEndActiveSpan();
        const sentryTrace = traceOptions.sentryTrace || getMetaContent('sentry-trace');
        const baggage = traceOptions.baggage || getMetaContent('baggage');
        const propagationContext = (0,tracing/* propagationContextFromHeaders */.pT)(sentryTrace, baggage);
        (0,currentScopes/* getCurrentScope */.nZ)().setPropagationContext(propagationContext);
        activeSpan = _createRouteSpan(client, {
          op: 'pageload',
          ...startSpanOptions
        });
      });

      // A trace should to stay the consistent over the entire time span of one route.
      // Therefore, when the initial pageload or navigation root span ends, we update the
      // scope's propagation context to keep span-specific attributes like the `sampled` decision and
      // the dynamic sampling context valid, even after the root span has ended.
      // This ensures that the trace data is consistent for the entire duration of the route.
      client.on('spanEnd', span => {
        const op = (0,spanUtils/* spanToJSON */.XU)(span).op;
        if (span !== (0,spanUtils/* getRootSpan */.Gx)(span) || op !== 'navigation' && op !== 'pageload') {
          return;
        }
        const scope = (0,currentScopes/* getCurrentScope */.nZ)();
        const oldPropagationContext = scope.getPropagationContext();
        scope.setPropagationContext({
          ...oldPropagationContext,
          sampled: oldPropagationContext.sampled !== undefined ? oldPropagationContext.sampled : (0,spanUtils/* spanIsSampled */.Tt)(span),
          dsc: oldPropagationContext.dsc || (0,dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.jC)(span)
        });
      });
      if (helpers/* WINDOW.location */.m9.location) {
        if (instrumentPageLoad) {
          startBrowserTracingPageLoadSpan(client, {
            name: helpers/* WINDOW.location.pathname */.m9.location.pathname,
            // pageload should always start at timeOrigin (and needs to be in s, not ms)
            startTime: utils_hoist_time/* browserPerformanceTimeOrigin */.Z1 ? utils_hoist_time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
            attributes: {
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: 'url',
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.pageload.browser'
            }
          });
        }
        if (instrumentNavigation) {
          (0,instrument_history/* addHistoryInstrumentationHandler */.a)(({
            to,
            from
          }) => {
            /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */
            if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
              startingUrl = undefined;
              return;
            }
            if (from !== to) {
              startingUrl = undefined;
              startBrowserTracingNavigationSpan(client, {
                name: helpers/* WINDOW.location.pathname */.m9.location.pathname,
                attributes: {
                  [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: 'url',
                  [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.navigation.browser'
                }
              });
            }
          });
        }
      }
      if (markBackgroundSpan) {
        registerBackgroundTabDetection();
      }
      if (enableInteractions) {
        registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
      }
      if (enableInp) {
        registerInpInteractionListener();
      }
      instrumentOutgoingRequests(client, {
        traceFetch,
        traceXHR,
        trackFetchStreamPerformance,
        tracePropagationTargets: client.getOptions().tracePropagationTargets,
        shouldCreateSpanForRequest,
        enableHTTPTimings
      });
    }
  };
};

/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */
function startBrowserTracingPageLoadSpan(client, spanOptions, traceOptions) {
  client.emit('startPageLoadSpan', spanOptions, traceOptions);
  (0,currentScopes/* getCurrentScope */.nZ)().setTransactionName(spanOptions.name);
  const span = (0,spanUtils/* getActiveSpan */.HN)();
  const op = span && (0,spanUtils/* spanToJSON */.XU)(span).op;
  return op === 'pageload' ? span : undefined;
}

/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */
function startBrowserTracingNavigationSpan(client, spanOptions) {
  (0,currentScopes/* getIsolationScope */.aF)().setPropagationContext({
    traceId: (0,propagationContext/* generateTraceId */.Ht)()
  });
  (0,currentScopes/* getCurrentScope */.nZ)().setPropagationContext({
    traceId: (0,propagationContext/* generateTraceId */.Ht)()
  });
  client.emit('startNavigationSpan', spanOptions);
  (0,currentScopes/* getCurrentScope */.nZ)().setTransactionName(spanOptions.name);
  const span = (0,spanUtils/* getActiveSpan */.HN)();
  const op = span && (0,spanUtils/* spanToJSON */.XU)(span).op;
  return op === 'navigation' ? span : undefined;
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  // Can't specify generic to `getDomElement` because tracing can be used
  // in a variety of environments, have to disable `no-unsafe-member-access`
  // as a result.
  // eslint-disable-next-line deprecation/deprecation
  const metaTag = (0,browser/* getDomElement */.qT)(`meta[name=${metaName}]`);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return metaTag ? metaTag.getAttribute('content') : undefined;
}

/** Start listener for interaction transactions */
function registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
  let inflightInteractionSpan;
  const registerInteractionTransaction = () => {
    const op = 'ui.action.click';
    const activeSpan = (0,spanUtils/* getActiveSpan */.HN)();
    const rootSpan = activeSpan && (0,spanUtils/* getRootSpan */.Gx)(activeSpan);
    if (rootSpan) {
      const currentRootSpanOp = (0,spanUtils/* spanToJSON */.XU)(rootSpan).op;
      if (['navigation', 'pageload'].includes(currentRootSpanOp)) {
        npm_esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
        return undefined;
      }
    }
    if (inflightInteractionSpan) {
      inflightInteractionSpan.setAttribute(semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON */.ju, 'interactionInterrupted');
      inflightInteractionSpan.end();
      inflightInteractionSpan = undefined;
    }
    if (!latestRoute.name) {
      npm_esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
      return undefined;
    }
    inflightInteractionSpan = startIdleSpan({
      name: latestRoute.name,
      op,
      attributes: {
        [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: latestRoute.source || 'url'
      }
    }, {
      idleTimeout,
      finalTimeout,
      childSpanTimeout
    });
  };
  if (helpers/* WINDOW.document */.m9.document) {
    addEventListener('click', registerInteractionTransaction, {
      once: false,
      capture: true
    });
  }
}

;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/buildPolyfills/_nullishCoalesce.js
// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */
function _nullishCoalesce(lhs, rhsFn) {
  // by checking for loose equality to `null`, we catch both `null` and `undefined`
  return lhs != null ? lhs : rhsFn();
}

// Sucrase version:
// function _nullishCoalesce(lhs, rhsFn) {
//   if (lhs != null) {
//     return lhs;
//   } else {
//     return rhsFn();
//   }
// }


;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/build/esm/client/routing/appRouterRoutingInstrumentation.js



const INCOMPLETE_APP_ROUTER_INSTRUMENTATION_TRANSACTION_NAME = 'incomplete-app-router-transaction';

/** Instruments the Next.js app router for pageloads. */
function appRouterInstrumentPageLoad(client) {
  startBrowserTracingPageLoadSpan(client, {
    name: helpers/* WINDOW.location.pathname */.m9.location.pathname,
    // pageload should always start at timeOrigin (and needs to be in s, not ms)
    startTime: utils_hoist_time/* browserPerformanceTimeOrigin */.Z1 ? utils_hoist_time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
    attributes: {
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J]: 'pageload',
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.pageload.nextjs.app_router_instrumentation',
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: 'url'
    }
  });
}

// Yes, yes, I know we shouldn't depend on these internals. But that's where we are at. We write the ugly code, so you don't have to.
const GLOBAL_OBJ_WITH_NEXT_ROUTER = worldwide/* GLOBAL_OBJ */.n;

/*
 * The routing instrumentation needs to handle a few cases:
 * - Router operations:
 *  - router.push() (either explicitly called or implicitly through <Link /> tags)
 *  - router.replace() (either explicitly called or implicitly through <Link replace /> tags)
 *  - router.back()
 *  - router.forward()
 * - Browser operations:
 *  - native Browser-back / popstate event (implicitly called by router.back())
 *  - native Browser-forward / popstate event (implicitly called by router.forward())
 */

/** Instruments the Next.js app router for navigation. */
function appRouterInstrumentNavigation(client) {
  let currentNavigationSpan = undefined;
  helpers/* WINDOW.addEventListener */.m9.addEventListener('popstate', () => {
    if (currentNavigationSpan && currentNavigationSpan.isRecording()) {
      currentNavigationSpan.updateName(helpers/* WINDOW.location.pathname */.m9.location.pathname);
      currentNavigationSpan.setAttribute(semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, 'url');
    } else {
      currentNavigationSpan = startBrowserTracingNavigationSpan(client, {
        name: helpers/* WINDOW.location.pathname */.m9.location.pathname,
        attributes: {
          [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J]: 'navigation',
          [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.navigation.nextjs.app_router_instrumentation',
          [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: 'url',
          'navigation.type': 'browser.popstate'
        }
      });
    }
  });
  let routerPatched = false;
  let triesToFindRouter = 0;
  const MAX_TRIES_TO_FIND_ROUTER = 500;
  const ROUTER_AVAILABILITY_CHECK_INTERVAL_MS = 20;
  const checkForRouterAvailabilityInterval = setInterval(() => {
    triesToFindRouter++;
    const router = _nullishCoalesce(_optionalChain([GLOBAL_OBJ_WITH_NEXT_ROUTER, 'optionalAccess', _ => _.next, 'optionalAccess', _2 => _2.router]), () => _optionalChain([GLOBAL_OBJ_WITH_NEXT_ROUTER, 'optionalAccess', _3 => _3.nd, 'optionalAccess', _4 => _4.router]));
    if (routerPatched || triesToFindRouter > MAX_TRIES_TO_FIND_ROUTER) {
      clearInterval(checkForRouterAvailabilityInterval);
    } else if (router) {
      clearInterval(checkForRouterAvailabilityInterval);
      routerPatched = true;
      ['back', 'forward', 'push', 'replace'].forEach(routerFunctionName => {
        if (_optionalChain([router, 'optionalAccess', _5 => _5[routerFunctionName]])) {
          // @ts-expect-error Weird type error related to not knowing how to associate return values with the individual functions - we can just ignore
          router[routerFunctionName] = new Proxy(router[routerFunctionName], {
            apply(target, thisArg, argArray) {
              const span = startBrowserTracingNavigationSpan(client, {
                name: INCOMPLETE_APP_ROUTER_INSTRUMENTATION_TRANSACTION_NAME,
                attributes: {
                  [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J]: 'navigation',
                  [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.navigation.nextjs.app_router_instrumentation',
                  [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: 'url'
                }
              });
              currentNavigationSpan = span;
              if (routerFunctionName === 'push') {
                _optionalChain([span, 'optionalAccess', _6 => _6.updateName, 'call', _7 => _7(transactionNameifyRouterArgument(argArray[0]))]);
                _optionalChain([span, 'optionalAccess', _8 => _8.setAttribute, 'call', _9 => _9(semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, 'url')]);
                _optionalChain([span, 'optionalAccess', _10 => _10.setAttribute, 'call', _11 => _11('navigation.type', 'router.push')]);
              } else if (routerFunctionName === 'replace') {
                _optionalChain([span, 'optionalAccess', _12 => _12.updateName, 'call', _13 => _13(transactionNameifyRouterArgument(argArray[0]))]);
                _optionalChain([span, 'optionalAccess', _14 => _14.setAttribute, 'call', _15 => _15(semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, 'url')]);
                _optionalChain([span, 'optionalAccess', _16 => _16.setAttribute, 'call', _17 => _17('navigation.type', 'router.replace')]);
              } else if (routerFunctionName === 'back') {
                _optionalChain([span, 'optionalAccess', _18 => _18.setAttribute, 'call', _19 => _19('navigation.type', 'router.back')]);
              } else if (routerFunctionName === 'forward') {
                _optionalChain([span, 'optionalAccess', _20 => _20.setAttribute, 'call', _21 => _21('navigation.type', 'router.forward')]);
              }
              return target.apply(thisArg, argArray);
            }
          });
        }
      });
    }
  }, ROUTER_AVAILABILITY_CHECK_INTERVAL_MS);
}
function transactionNameifyRouterArgument(target) {
  try {
    // We provide an arbitrary base because we only care about the pathname and it makes URL parsing more resilient.
    return new URL(target, 'http://example.com/').pathname;
  } catch (e) {
    return '/';
  }
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(34376);
// EXTERNAL MODULE: ./node_modules/@sentry/nextjs/build/esm/common/debug-build.js
var common_debug_build = __webpack_require__(91511);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/build/esm/client/routing/pagesRouterRoutingInstrumentation.js






// next/router v10 is CJS
//
// For ESM/CJS interoperability 'reasons', depending on how this file is loaded, Router might be on the default export
const Router = router.events ? router : router["default"];
const globalObject = helpers/* WINDOW */.m9;

/**
 * Describes data located in the __NEXT_DATA__ script tag. This tag is present on every page of a Next.js app.
 */

/**
 * Every Next.js page (static and dynamic ones) comes with a script tag with the id "__NEXT_DATA__". This script tag
 * contains a JSON object with data that was either generated at build time for static pages (`getStaticProps`), or at
 * runtime with data fetchers like `getServerSideProps.`.
 *
 * We can use this information to:
 * - Always get the parameterized route we're in when loading a page.
 * - Send trace information (trace-id, baggage) from the server to the client.
 *
 * This function extracts this information.
 */
function extractNextDataTagInformation() {
  let nextData;
  // Let's be on the safe side and actually check first if there is really a __NEXT_DATA__ script tag on the page.
  // Theoretically this should always be the case though.
  const nextDataTag = globalObject.document.getElementById('__NEXT_DATA__');
  if (nextDataTag && nextDataTag.innerHTML) {
    try {
      nextData = JSON.parse(nextDataTag.innerHTML);
    } catch (e) {
      common_debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn('Could not extract __NEXT_DATA__');
    }
  }
  if (!nextData) {
    return {};
  }
  const nextDataTagInfo = {};
  const {
    page,
    query,
    props
  } = nextData;

  // `nextData.page` always contains the parameterized route - except for when an error occurs in a data fetching
  // function, then it is "/_error", but that isn't a problem since users know which route threw by looking at the
  // parent transaction
  // TODO: Actually this is a problem (even though it is not that big), because the DSC and the transaction payload will contain
  // a different transaction name. Maybe we can fix this. Idea: Also send transaction name via pageProps when available.
  nextDataTagInfo.route = page;
  nextDataTagInfo.params = query;
  if (props && props.pageProps) {
    nextDataTagInfo.sentryTrace = props.pageProps._sentryTraceData;
    nextDataTagInfo.baggage = props.pageProps._sentryBaggage;
  }
  return nextDataTagInfo;
}

/**
 * Instruments the Next.js pages router for pageloads.
 * Only supported for client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function pagesRouterInstrumentPageLoad(client) {
  const {
    route,
    params,
    sentryTrace,
    baggage
  } = extractNextDataTagInformation();
  const parsedBaggage = (0,utils_hoist_baggage/* parseBaggageHeader */.XM)(baggage);
  let name = route || globalObject.location.pathname;

  // /_error is the fallback page for all errors. If there is a transaction name for /_error, use that instead
  if (parsedBaggage && parsedBaggage['sentry-transaction'] && name === '/_error') {
    name = parsedBaggage['sentry-transaction'];
    // Strip any HTTP method from the span name
    name = name.replace(/^(GET|POST|PUT|DELETE|PATCH|HEAD|OPTIONS|TRACE|CONNECT)\s+/i, '');
  }
  startBrowserTracingPageLoadSpan(client, {
    name,
    // pageload should always start at timeOrigin (and needs to be in s, not ms)
    startTime: utils_hoist_time/* browserPerformanceTimeOrigin */.Z1 ? utils_hoist_time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
    attributes: {
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J]: 'pageload',
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.pageload.nextjs.pages_router_instrumentation',
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: route ? 'route' : 'url',
      ...(params && client.getOptions().sendDefaultPii && {
        ...params
      })
    }
  }, {
    sentryTrace,
    baggage
  });
}

/**
 * Instruments the Next.js pages router for navigation.
 * Only supported for client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function pagesRouterInstrumentNavigation(client) {
  Router.events.on('routeChangeStart', navigationTarget => {
    const strippedNavigationTarget = (0,utils_hoist_url/* stripUrlQueryAndFragment */.rt)(navigationTarget);
    const matchedRoute = getNextRouteFromPathname(strippedNavigationTarget);
    let newLocation;
    let spanSource;
    if (matchedRoute) {
      newLocation = matchedRoute;
      spanSource = 'route';
    } else {
      newLocation = strippedNavigationTarget;
      spanSource = 'url';
    }
    startBrowserTracingNavigationSpan(client, {
      name: newLocation,
      attributes: {
        [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J]: 'navigation',
        [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.navigation.nextjs.pages_router_instrumentation',
        [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: spanSource
      }
    });
  });
}
function getNextRouteFromPathname(pathname) {
  const pageRoutes = (globalObject.__BUILD_MANIFEST || {}).sortedPages;

  // Page route should in 99.999% of the cases be defined by now but just to be sure we make a check here
  if (!pageRoutes) {
    return;
  }
  return pageRoutes.find(route => {
    const routeRegExp = convertNextRouteToRegExp(route);
    return pathname.match(routeRegExp);
  });
}

/**
 * Converts a Next.js style route to a regular expression that matches on pathnames (no query params or URL fragments).
 *
 * In general this involves replacing any instances of square brackets in a route with a wildcard:
 * e.g. "/users/[id]/info" becomes /\/users\/([^/]+?)\/info/
 *
 * Some additional edgecases need to be considered:
 * - All routes have an optional slash at the end, meaning users can navigate to "/users/[id]/info" or
 *   "/users/[id]/info/" - both will be resolved to "/users/[id]/info".
 * - Non-optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[...params]").
 * - Optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[[...params]]").
 *
 * @param route A Next.js style route as it is found in `global.__BUILD_MANIFEST.sortedPages`
 */
function convertNextRouteToRegExp(route) {
  // We can assume a route is at least "/".
  const routeParts = route.split('/');
  let optionalCatchallWildcardRegex = '';
  if (_optionalChain([routeParts, 'access', _ => _[routeParts.length - 1], 'optionalAccess', _2 => _2.match, 'call', _3 => _3(/^\[\[\.\.\..+\]\]$/)])) {
    // If last route part has pattern "[[...xyz]]" we pop the latest route part to get rid of the required trailing
    // slash that would come before it if we didn't pop it.
    routeParts.pop();
    optionalCatchallWildcardRegex = '(?:/(.+?))?';
  }
  const rejoinedRouteParts = routeParts.map(routePart => routePart.replace(/^\[\.\.\..+\]$/, '(.+?)') // Replace catch all wildcard with regex wildcard
  .replace(/^\[.*\]$/, '([^/]+?)') // Replace route wildcards with lazy regex wildcards
  ).join('/');

  // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- routeParts are from the build manifest, so no raw user input
  return new RegExp(`^${rejoinedRouteParts}${optionalCatchallWildcardRegex}(?:/)?$`) // optional slash at the end
  ;
}

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/build/esm/client/routing/nextRoutingInstrumentation.js




/**
 * Instruments the Next.js Client Router for page loads.
 */
function nextRouterInstrumentPageLoad(client) {
  const isAppRouter = !helpers/* WINDOW.document.getElementById */.m9.document.getElementById('__NEXT_DATA__');
  if (isAppRouter) {
    appRouterInstrumentPageLoad(client);
  } else {
    pagesRouterInstrumentPageLoad(client);
  }
}

/**
 * Instruments the Next.js Client Router for navigation.
 */
function nextRouterInstrumentNavigation(client) {
  const isAppRouter = !helpers/* WINDOW.document.getElementById */.m9.document.getElementById('__NEXT_DATA__');
  if (isAppRouter) {
    appRouterInstrumentNavigation(client);
  } else {
    pagesRouterInstrumentNavigation(client);
  }
}

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/build/esm/client/browserTracingIntegration.js



/**
 * A custom browser tracing integration for Next.js.
 */
function browserTracingIntegration_browserTracingIntegration(options = {}) {
  const browserTracingIntegrationInstance = browserTracingIntegration({
    ...options,
    instrumentNavigation: false,
    instrumentPageLoad: false
  });
  const {
    instrumentPageLoad = true,
    instrumentNavigation = true
  } = options;
  return {
    ...browserTracingIntegrationInstance,
    afterAllSetup(client) {
      // We need to run the navigation span instrumentation before the `afterAllSetup` hook on the normal browser
      // tracing integration because we need to ensure the order of execution is as follows:
      // Instrumentation to start span on RSC fetch request runs -> Instrumentation to put tracing headers from active span on fetch runs
      // If it were the other way around, the RSC fetch request would not receive the tracing headers from the navigation transaction.
      if (instrumentNavigation) {
        nextRouterInstrumentNavigation(client);
      }
      browserTracingIntegrationInstance.afterAllSetup(client);
      if (instrumentPageLoad) {
        nextRouterInstrumentPageLoad(client);
      }
    }
  };
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/integration.js
var integration = __webpack_require__(12260);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/path.js
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  let up = 0;
  for (let i = parts.length - 1; i >= 0; i--) {
    const last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }
  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */
function splitPath(filename) {
  // Truncate files names greater than 1024 characters to avoid regex dos
  // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
  const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
  const parts = splitPathRe.exec(truncated);
  return parts ? parts.slice(1) : [];
}

// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve(...args) {
  let resolvedPath = '';
  let resolvedAbsolute = false;
  for (let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    const path = i >= 0 ? args[i] : '/';

    // Skip empty entries
    if (!path) {
      continue;
    }
    resolvedPath = `${path}/${resolvedPath}`;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(resolvedPath.split('/').filter(p => !!p), !resolvedAbsolute).join('/');
  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}

/** JSDoc */
function trim(arr) {
  let start = 0;
  for (; start < arr.length; start++) {
    if (arr[start] !== '') {
      break;
    }
  }
  let end = arr.length - 1;
  for (; end >= 0; end--) {
    if (arr[end] !== '') {
      break;
    }
  }
  if (start > end) {
    return [];
  }
  return arr.slice(start, end - start + 1);
}

// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
  /* eslint-disable no-param-reassign */
  from = resolve(from).slice(1);
  to = resolve(to).slice(1);
  /* eslint-enable no-param-reassign */

  const fromParts = trim(from.split('/'));
  const toParts = trim(to.split('/'));
  const length = Math.min(fromParts.length, toParts.length);
  let samePartsLength = length;
  for (let i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }
  let outputParts = [];
  for (let i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }
  outputParts = outputParts.concat(toParts.slice(samePartsLength));
  return outputParts.join('/');
}

// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
  const isPathAbsolute = isAbsolute(path);
  const trailingSlash = path.slice(-1) === '/';

  // Normalize the path
  let normalizedPath = normalizeArray(path.split('/').filter(p => !!p), !isPathAbsolute).join('/');
  if (!normalizedPath && !isPathAbsolute) {
    normalizedPath = '.';
  }
  if (normalizedPath && trailingSlash) {
    normalizedPath += '/';
  }
  return (isPathAbsolute ? '/' : '') + normalizedPath;
}

// posix version
/** JSDoc */
function isAbsolute(path) {
  return path.charAt(0) === '/';
}

// posix version
/** JSDoc */
function join(...args) {
  return normalizePath(args.join('/'));
}

/** JSDoc */
function dirname(path) {
  const result = splitPath(path);
  const root = result[0] || '';
  let dir = result[1];
  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }
  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
  }
  return root + dir;
}

/** JSDoc */
function basename(path, ext) {
  let f = splitPath(path)[2] || '';
  if (ext && f.slice(ext.length * -1) === ext) {
    f = f.slice(0, f.length - ext.length);
  }
  return f;
}

;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/integrations/rewriteframes.js



const INTEGRATION_NAME = 'RewriteFrames';

/**
 * Rewrite event frames paths.
 */
const rewriteFramesIntegration = (0,integration/* defineIntegration */._I)((options = {}) => {
  const root = options.root;
  const prefix = options.prefix || 'app:///';
  const isBrowser = "window" in worldwide/* GLOBAL_OBJ */.n && worldwide/* GLOBAL_OBJ.window */.n.window !== undefined;
  const iteratee = options.iteratee || generateIteratee({
    isBrowser,
    root,
    prefix
  });

  /** Process an exception event. */
  function _processExceptionsEvent(event) {
    try {
      return {
        ...event,
        exception: {
          ...event.exception,
          // The check for this is performed inside `process` call itself, safe to skip here
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          values: event.exception.values.map(value => ({
            ...value,
            ...(value.stacktrace && {
              stacktrace: _processStacktrace(value.stacktrace)
            })
          }))
        }
      };
    } catch (_oO) {
      return event;
    }
  }

  /** Process a stack trace. */
  function _processStacktrace(stacktrace) {
    return {
      ...stacktrace,
      frames: stacktrace && stacktrace.frames && stacktrace.frames.map(f => iteratee(f))
    };
  }
  return {
    name: INTEGRATION_NAME,
    processEvent(originalEvent) {
      let processedEvent = originalEvent;
      if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
        processedEvent = _processExceptionsEvent(processedEvent);
      }
      return processedEvent;
    }
  };
});

/**
 * Exported only for tests.
 */
function generateIteratee({
  isBrowser,
  root,
  prefix
}) {
  return frame => {
    if (!frame.filename) {
      return frame;
    }

    // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
    const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) ||
    // or the presence of a backslash without a forward slash (which are not allowed on Windows)
    frame.filename.includes('\\') && !frame.filename.includes('/');

    // Check if the frame filename begins with `/`
    const startsWithSlash = /^\//.test(frame.filename);
    if (isBrowser) {
      if (root) {
        const oldFilename = frame.filename;
        if (oldFilename.indexOf(root) === 0) {
          frame.filename = oldFilename.replace(root, prefix);
        }
      }
    } else {
      if (isWindowsFrame || startsWithSlash) {
        const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
        .replace(/\\/g, '/') // replace all `\\` instances with `/`
        : frame.filename;
        const base = root ? relative(root, filename) : basename(filename);
        frame.filename = `${prefix}${base}`;
      }
    }
    return frame;
  };
}

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/build/esm/client/clientNormalizationIntegration.js


const nextjsClientStackFrameNormalizationIntegration = (0,integration/* defineIntegration */._I)(({
  assetPrefixPath
}) => {
  const rewriteFramesInstance = rewriteFramesIntegration({
    // Turn `<origin>/<path>/_next/static/...` into `app:///_next/static/...`
    iteratee: frame => {
      try {
        const {
          origin
        } = new URL(frame.filename);
        frame.filename = _optionalChain([frame, 'access', _ => _.filename, 'optionalAccess', _2 => _2.replace, 'call', _3 => _3(origin, 'app://'), 'access', _4 => _4.replace, 'call', _5 => _5(assetPrefixPath, '')]);
      } catch (err) {
        // Filename wasn't a properly formed URL, so there's nothing we can do
      }

      // We need to URI-decode the filename because Next.js has wildcard routes like "/users/[id].js" which show up as "/users/%5id%5.js" in Error stacktraces.
      // The corresponding sources that Next.js generates have proper brackets so we also need proper brackets in the frame so that source map resolving works.
      if (frame.filename && frame.filename.startsWith('app:///_next')) {
        frame.filename = decodeURI(frame.filename);
      }
      if (frame.filename && frame.filename.match(/^app:\/\/\/_next\/static\/chunks\/(main-|main-app-|polyfills-|webpack-|framework-|framework\.)[0-9a-f]+\.js$/)) {
        // We don't care about these frames. It's Next.js internal code.
        frame.in_app = false;
      }
      return frame;
    }
  });
  return {
    ...rewriteFramesInstance,
    name: 'NextjsClientStackFrameNormalization'
  };
});

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/dsn.js
var dsn = __webpack_require__(88157);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/build/esm/client/tunnelRoute.js


const globalWithInjectedValues = (/* unused pure expression or super */ null && (GLOBAL_OBJ));

/**
 * Applies the `tunnel` option to the Next.js SDK options based on `withSentryConfig`'s `tunnelRoute` option.
 */
function applyTunnelRouteOption(options) {
  const tunnelRouteOption = "/monitoring" || 0;
  if (tunnelRouteOption && options.dsn) {
    const dsnComponents = (0,dsn/* dsnFromString */.U4)(options.dsn);
    if (!dsnComponents) {
      return;
    }
    const sentrySaasDsnMatch = dsnComponents.host.match(/^o(\d+)\.ingest(?:\.([a-z]{2}))?\.sentry\.io$/);
    if (sentrySaasDsnMatch) {
      const orgId = sentrySaasDsnMatch[1];
      const regionCode = sentrySaasDsnMatch[2];
      let tunnelPath = `${tunnelRouteOption}?o=${orgId}&p=${dsnComponents.projectId}`;
      if (regionCode) {
        tunnelPath += `&r=${regionCode}`;
      }
      options.tunnel = tunnelPath;
      common_debug_build/* DEBUG_BUILD */.X && logger/* logger.info */.kg.info(`Tunneling events to "${tunnelPath}"`);
    } else {
      common_debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn('Provided DSN is not a Sentry SaaS DSN. Will not tunnel events.');
    }
  }
}

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/build/esm/client/index.js


























const client_globalWithInjectedValues = worldwide/* GLOBAL_OBJ */.n;

// Treeshakable guard to remove all code related to tracing

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function client_init(options) {
  const opts = {
    environment: getVercelEnv(true) || "production",
    defaultIntegrations: getDefaultIntegrations(options),
    ...options
  };
  applyTunnelRouteOption(opts);
  (0,sdkMetadata/* applySdkMetadata */.V)(opts, 'nextjs', ['nextjs', 'react']);
  const client = init(opts);
  const filterTransactions = event => event.type === 'transaction' && event.transaction === '/404' ? null : event;
  filterTransactions.id = 'NextClient404Filter';
  (0,esm_exports/* addEventProcessor */.Qy)(filterTransactions);
  const filterIncompleteNavigationTransactions = event => event.type === 'transaction' && event.transaction === INCOMPLETE_APP_ROUTER_INSTRUMENTATION_TRANSACTION_NAME ? null : event;
  filterIncompleteNavigationTransactions.id = 'IncompleteTransactionFilter';
  (0,esm_exports/* addEventProcessor */.Qy)(filterIncompleteNavigationTransactions);
  const filterNextRedirectError = (event, hint) => isRedirectNavigationError(_optionalChain([hint, 'optionalAccess', _ => _.originalException])) ? null : event;
  filterNextRedirectError.id = 'NextRedirectErrorFilter';
  (0,esm_exports/* addEventProcessor */.Qy)(filterNextRedirectError);
  if (false) {}
  return client;
}
function getDefaultIntegrations(options) {
  const customDefaultIntegrations = (0,sdk/* getDefaultIntegrations */.nV)(options);
  // This evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false",
  // in which case everything inside will get tree-shaken away
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    customDefaultIntegrations.push(browserTracingIntegration_browserTracingIntegration());
  }

  // This value is injected at build time, based on the output directory specified in the build config. Though a default
  // is set there, we set it here as well, just in case something has gone wrong with the injection.
  const assetPrefixPath =  false || client_globalWithInjectedValues._sentryRewriteFramesAssetPrefixPath || '';
  customDefaultIntegrations.push(nextjsClientStackFrameNormalizationIntegration({
    assetPrefixPath
  }));
  return customDefaultIntegrations;
}

/**
 * Just a passthrough in case this is imported from the client.
 */
function withSentryConfig(exportedUserNextConfig) {
  return exportedUserNextConfig;
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/normalize.js + 1 modules
var normalize = __webpack_require__(9813);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/breadcrumbs.js
var breadcrumbs = __webpack_require__(5258);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/severity.js
var severity = __webpack_require__(60083);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/misc.js
var misc = __webpack_require__(27275);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils/isSentryRequestUrl.js
/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */
function isSentryRequestUrl(url, client) {
  const dsn = client && client.getDsn();
  const tunnel = client && client.getOptions().tunnel;
  return checkDsn(url, dsn) || checkTunnel(url, tunnel);
}
function checkTunnel(url, tunnel) {
  if (!tunnel) {
    return false;
  }
  return removeTrailingSlash(url) === removeTrailingSlash(tunnel);
}
function checkDsn(url, dsn) {
  return dsn ? url.includes(dsn.host) : false;
}
function removeTrailingSlash(str) {
  return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/envelope.js
var envelope = __webpack_require__(53767);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/prepareEvent.js + 3 modules
var prepareEvent = __webpack_require__(24737);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/syncpromise.js
var syncpromise = __webpack_require__(37865);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/ratelimit.js
var ratelimit = __webpack_require__(25528);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/env.js
var env = __webpack_require__(83466);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/node.js
/* provided dependency */ var node_process = __webpack_require__(554);


/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return !(0,env/* isBrowserBundle */.n)() && Object.prototype.toString.call(typeof node_process !== 'undefined' ? node_process : 0) === '[object process]';
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 * @deprecated This function will be removed in the next major version.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return mod.require(request);
}

/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @param existingModule module to use for requiring
 * @returns possibly required module
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function loadModule(moduleName, existingModule = module) {
  let mod;
  try {
    // eslint-disable-next-line deprecation/deprecation
    mod = dynamicRequire(existingModule, moduleName);
  } catch (e) {
    // no-empty
  }
  if (!mod) {
    try {
      // eslint-disable-next-line deprecation/deprecation
      const {
        cwd
      } = dynamicRequire(existingModule, 'process');
      // eslint-disable-next-line deprecation/deprecation
      mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
      // no-empty
    }
  }
  return mod;
}

;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/isBrowser.js



/**
 * Returns true if we are in the browser.
 */
function isBrowser() {
  // eslint-disable-next-line no-restricted-globals
  return typeof window !== 'undefined' && (!isNodeEnv() || isElectronNodeRenderer());
}

// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function isElectronNodeRenderer() {
  const process = worldwide/* GLOBAL_OBJ.process */.n.process;
  return !!process && process.type === 'renderer';
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/parseSampleRate.js
var parseSampleRate = __webpack_require__(86380);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/getNativeImplementation.js
var getNativeImplementation = __webpack_require__(17340);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/instrument/dom.js
var dom = __webpack_require__(30423);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/replay/build/npm/esm/index.js




// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const WINDOW = worldwide/* GLOBAL_OBJ */.n;
const REPLAY_SESSION_KEY = 'sentryReplaySession';
const REPLAY_EVENT_NAME = 'replay_event';
const UNABLE_TO_SEND_REPLAY = 'Unable to send Replay';

// The idle limit for a session after which recording is paused.
const SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms

// The idle limit for a session after which the session expires.
const SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms

/** Default flush delays */
const DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const DEFAULT_FLUSH_MAX_DELAY = 5500;

/* How long to wait for error checkouts */
const BUFFER_CHECKOUT_TIME = 60000;
const RETRY_BASE_INTERVAL = 5000;
const RETRY_MAX_COUNT = 3;

/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */
const NETWORK_BODY_MAX_SIZE = 150000;

/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */
const CONSOLE_ARG_MAX_SIZE = 5000;

/* Min. time to wait before we consider something a slow click. */
const SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */
const SLOW_CLICK_SCROLL_TIMEOUT = 300;

/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */
const REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB

/** Replays must be min. 5s long before we send them. */
const MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */
const MIN_REPLAY_DURATION_LIMIT = 15000;

/** The max. length of a replay. */
const MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;

function _nullishCoalesce$1(lhs, rhsFn) {
  if (lhs != null) {
    return lhs;
  } else {
    return rhsFn();
  }
}
function _optionalChain$5(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i];
    const fn = ops[i + 1];
    i += 2;
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => value.call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}
var NodeType$3;
(function (NodeType) {
  NodeType[NodeType["Document"] = 0] = "Document";
  NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
  NodeType[NodeType["Element"] = 2] = "Element";
  NodeType[NodeType["Text"] = 3] = "Text";
  NodeType[NodeType["CDATA"] = 4] = "CDATA";
  NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType$3 || (NodeType$3 = {}));
function isElement$1(n) {
  return n.nodeType === n.ELEMENT_NODE;
}
function isShadowRoot(n) {
  const host = _optionalChain$5([n, 'optionalAccess', _ => _.host]);
  return Boolean(_optionalChain$5([host, 'optionalAccess', _2 => _2.shadowRoot]) === n);
}
function isNativeShadowDom(shadowRoot) {
  return Object.prototype.toString.call(shadowRoot) === '[object ShadowRoot]';
}
function fixBrowserCompatibilityIssuesInCSS(cssText) {
  if (cssText.includes(' background-clip: text;') && !cssText.includes(' -webkit-background-clip: text;')) {
    cssText = cssText.replace(/\sbackground-clip:\s*text;/g, ' -webkit-background-clip: text; background-clip: text;');
  }
  return cssText;
}
function escapeImportStatement(rule) {
  const {
    cssText
  } = rule;
  if (cssText.split('"').length < 3) return cssText;
  const statement = ['@import', `url(${JSON.stringify(rule.href)})`];
  if (rule.layerName === '') {
    statement.push(`layer`);
  } else if (rule.layerName) {
    statement.push(`layer(${rule.layerName})`);
  }
  if (rule.supportsText) {
    statement.push(`supports(${rule.supportsText})`);
  }
  if (rule.media.length) {
    statement.push(rule.media.mediaText);
  }
  return statement.join(' ') + ';';
}
function stringifyStylesheet(s) {
  try {
    const rules = s.rules || s.cssRules;
    return rules ? fixBrowserCompatibilityIssuesInCSS(Array.from(rules, stringifyRule).join('')) : null;
  } catch (error) {
    return null;
  }
}
function fixAllCssProperty(rule) {
  let styles = '';
  for (let i = 0; i < rule.style.length; i++) {
    const styleDeclaration = rule.style;
    const attribute = styleDeclaration[i];
    const isImportant = styleDeclaration.getPropertyPriority(attribute);
    styles += `${attribute}:${styleDeclaration.getPropertyValue(attribute)}${isImportant ? ` !important` : ''};`;
  }
  return `${rule.selectorText} { ${styles} }`;
}
function stringifyRule(rule) {
  let importStringified;
  if (isCSSImportRule(rule)) {
    try {
      importStringified = stringifyStylesheet(rule.styleSheet) || escapeImportStatement(rule);
    } catch (error) {}
  } else if (isCSSStyleRule(rule)) {
    let cssText = rule.cssText;
    const needsSafariColonFix = rule.selectorText.includes(':');
    const needsAllFix = typeof rule.style['all'] === 'string' && rule.style['all'];
    if (needsAllFix) {
      cssText = fixAllCssProperty(rule);
    }
    if (needsSafariColonFix) {
      cssText = fixSafariColons(cssText);
    }
    if (needsSafariColonFix || needsAllFix) {
      return cssText;
    }
  }
  return importStringified || rule.cssText;
}
function fixSafariColons(cssStringified) {
  const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return cssStringified.replace(regex, '$1\\$2');
}
function isCSSImportRule(rule) {
  return 'styleSheet' in rule;
}
function isCSSStyleRule(rule) {
  return 'selectorText' in rule;
}
class Mirror {
  constructor() {
    this.idNodeMap = new Map();
    this.nodeMetaMap = new WeakMap();
  }
  getId(n) {
    if (!n) return -1;
    const id = _optionalChain$5([this, 'access', _3 => _3.getMeta, 'call', _4 => _4(n), 'optionalAccess', _5 => _5.id]);
    return _nullishCoalesce$1(id, () => -1);
  }
  getNode(id) {
    return this.idNodeMap.get(id) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(n) {
    return this.nodeMetaMap.get(n) || null;
  }
  removeNodeFromMap(n) {
    const id = this.getId(n);
    this.idNodeMap.delete(id);
    if (n.childNodes) {
      n.childNodes.forEach(childNode => this.removeNodeFromMap(childNode));
    }
  }
  has(id) {
    return this.idNodeMap.has(id);
  }
  hasNode(node) {
    return this.nodeMetaMap.has(node);
  }
  add(n, meta) {
    const id = meta.id;
    this.idNodeMap.set(id, n);
    this.nodeMetaMap.set(n, meta);
  }
  replace(id, n) {
    const oldNode = this.getNode(id);
    if (oldNode) {
      const meta = this.nodeMetaMap.get(oldNode);
      if (meta) this.nodeMetaMap.set(n, meta);
    }
    this.idNodeMap.set(id, n);
  }
  reset() {
    this.idNodeMap = new Map();
    this.nodeMetaMap = new WeakMap();
  }
}
function createMirror() {
  return new Mirror();
}
function shouldMaskInput({
  maskInputOptions,
  tagName,
  type
}) {
  if (tagName === 'OPTION') {
    tagName = 'SELECT';
  }
  return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === 'password' || tagName === 'INPUT' && !type && maskInputOptions['text']);
}
function maskInputValue({
  isMasked,
  element,
  value,
  maskInputFn
}) {
  let text = value || '';
  if (!isMasked) {
    return text;
  }
  if (maskInputFn) {
    text = maskInputFn(text, element);
  }
  return '*'.repeat(text.length);
}
function toLowerCase(str) {
  return str.toLowerCase();
}
function toUpperCase(str) {
  return str.toUpperCase();
}
const ORIGINAL_ATTRIBUTE_NAME = '__rrweb_original__';
function is2DCanvasBlank(canvas) {
  const ctx = canvas.getContext('2d');
  if (!ctx) return true;
  const chunkSize = 50;
  for (let x = 0; x < canvas.width; x += chunkSize) {
    for (let y = 0; y < canvas.height; y += chunkSize) {
      const getImageData = ctx.getImageData;
      const originalGetImageData = ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[ORIGINAL_ATTRIBUTE_NAME] : getImageData;
      const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
      if (pixelBuffer.some(pixel => pixel !== 0)) return false;
    }
  }
  return true;
}
function getInputType(element) {
  const type = element.type;
  return element.hasAttribute('data-rr-is-password') ? 'password' : type ? toLowerCase(type) : null;
}
function getInputValue(el, tagName, type) {
  if (tagName === 'INPUT' && (type === 'radio' || type === 'checkbox')) {
    return el.getAttribute('value') || '';
  }
  return el.value;
}
function extractFileExtension(path, baseURL) {
  let url;
  try {
    url = new URL(path, _nullishCoalesce$1(baseURL, () => window.location.href));
  } catch (err) {
    return null;
  }
  const regex = /\.([0-9a-z]+)(?:$)/i;
  const match = url.pathname.match(regex);
  return _nullishCoalesce$1(_optionalChain$5([match, 'optionalAccess', _6 => _6[1]]), () => null);
}
const cachedImplementations$1 = {};
function getImplementation$1(name) {
  const cached = cachedImplementations$1[name];
  if (cached) {
    return cached;
  }
  const document = window.document;
  let impl = window[name];
  if (document && typeof document.createElement === 'function') {
    try {
      const sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow[name]) {
        impl = contentWindow[name];
      }
      document.head.removeChild(sandbox);
    } catch (e) {}
  }
  return cachedImplementations$1[name] = impl.bind(window);
}
function setTimeout$2(...rest) {
  return getImplementation$1('setTimeout')(...rest);
}
function clearTimeout$2(...rest) {
  return getImplementation$1('clearTimeout')(...rest);
}
function getIframeContentDocument(iframe) {
  try {
    return iframe.contentDocument;
  } catch (e) {}
}
let _id = 1;
const tagNameRegex = new RegExp('[^a-z0-9-_:]');
const IGNORED_NODE = -2;
function genId() {
  return _id++;
}
function getValidTagName(element) {
  if (element instanceof HTMLFormElement) {
    return 'form';
  }
  const processedTagName = toLowerCase(element.tagName);
  if (tagNameRegex.test(processedTagName)) {
    return 'div';
  }
  return processedTagName;
}
function extractOrigin(url) {
  let origin = '';
  if (url.indexOf('//') > -1) {
    origin = url.split('/').slice(0, 3).join('/');
  } else {
    origin = url.split('/')[0];
  }
  origin = origin.split('?')[0];
  return origin;
}
let canvasService;
let canvasCtx;
const URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const URL_WWW_MATCH = /^www\..*/i;
const DATA_URI = /^(data:)([^,]*),(.*)/i;
function absoluteToStylesheet(cssText, href) {
  return (cssText || '').replace(URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3) => {
    const filePath = path1 || path2 || path3;
    const maybeQuote = quote1 || quote2 || '';
    if (!filePath) {
      return origin;
    }
    if (URL_PROTOCOL_MATCH.test(filePath) || URL_WWW_MATCH.test(filePath)) {
      return `url(${maybeQuote}${filePath}${maybeQuote})`;
    }
    if (DATA_URI.test(filePath)) {
      return `url(${maybeQuote}${filePath}${maybeQuote})`;
    }
    if (filePath[0] === '/') {
      return `url(${maybeQuote}${extractOrigin(href) + filePath}${maybeQuote})`;
    }
    const stack = href.split('/');
    const parts = filePath.split('/');
    stack.pop();
    for (const part of parts) {
      if (part === '.') {
        continue;
      } else if (part === '..') {
        stack.pop();
      } else {
        stack.push(part);
      }
    }
    return `url(${maybeQuote}${stack.join('/')}${maybeQuote})`;
  });
}
const SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function getAbsoluteSrcsetString(doc, attributeValue) {
  if (attributeValue.trim() === '') {
    return attributeValue;
  }
  let pos = 0;
  function collectCharacters(regEx) {
    let chars;
    const match = regEx.exec(attributeValue.substring(pos));
    if (match) {
      chars = match[0];
      pos += chars.length;
      return chars;
    }
    return '';
  }
  const output = [];
  while (true) {
    collectCharacters(SRCSET_COMMAS_OR_SPACES);
    if (pos >= attributeValue.length) {
      break;
    }
    let url = collectCharacters(SRCSET_NOT_SPACES);
    if (url.slice(-1) === ',') {
      url = absoluteToDoc(doc, url.substring(0, url.length - 1));
      output.push(url);
    } else {
      let descriptorsStr = '';
      url = absoluteToDoc(doc, url);
      let inParens = false;
      while (true) {
        const c = attributeValue.charAt(pos);
        if (c === '') {
          output.push((url + descriptorsStr).trim());
          break;
        } else if (!inParens) {
          if (c === ',') {
            pos += 1;
            output.push((url + descriptorsStr).trim());
            break;
          } else if (c === '(') {
            inParens = true;
          }
        } else {
          if (c === ')') {
            inParens = false;
          }
        }
        descriptorsStr += c;
        pos += 1;
      }
    }
  }
  return output.join(', ');
}
const cachedDocument = new WeakMap();
function absoluteToDoc(doc, attributeValue) {
  if (!attributeValue || attributeValue.trim() === '') {
    return attributeValue;
  }
  return getHref(doc, attributeValue);
}
function isSVGElement(el) {
  return Boolean(el.tagName === 'svg' || el.ownerSVGElement);
}
function getHref(doc, customHref) {
  let a = cachedDocument.get(doc);
  if (!a) {
    a = doc.createElement('a');
    cachedDocument.set(doc, a);
  }
  if (!customHref) {
    customHref = '';
  } else if (customHref.startsWith('blob:') || customHref.startsWith('data:')) {
    return customHref;
  }
  a.setAttribute('href', customHref);
  return a.href;
}
function transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
  if (!value) {
    return value;
  }
  if (name === 'src' || name === 'href' && !(tagName === 'use' && value[0] === '#')) {
    return absoluteToDoc(doc, value);
  } else if (name === 'xlink:href' && value[0] !== '#') {
    return absoluteToDoc(doc, value);
  } else if (name === 'background' && (tagName === 'table' || tagName === 'td' || tagName === 'th')) {
    return absoluteToDoc(doc, value);
  } else if (name === 'srcset') {
    return getAbsoluteSrcsetString(doc, value);
  } else if (name === 'style') {
    return absoluteToStylesheet(value, getHref(doc));
  } else if (tagName === 'object' && name === 'data') {
    return absoluteToDoc(doc, value);
  }
  if (typeof maskAttributeFn === 'function') {
    return maskAttributeFn(name, value, element);
  }
  return value;
}
function ignoreAttribute(tagName, name, _value) {
  return (tagName === 'video' || tagName === 'audio') && name === 'autoplay';
}
function _isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
  try {
    if (unblockSelector && element.matches(unblockSelector)) {
      return false;
    }
    if (typeof blockClass === 'string') {
      if (element.classList.contains(blockClass)) {
        return true;
      }
    } else {
      for (let eIndex = element.classList.length; eIndex--;) {
        const className = element.classList[eIndex];
        if (blockClass.test(className)) {
          return true;
        }
      }
    }
    if (blockSelector) {
      return element.matches(blockSelector);
    }
  } catch (e) {}
  return false;
}
function elementClassMatchesRegex(el, regex) {
  for (let eIndex = el.classList.length; eIndex--;) {
    const className = el.classList[eIndex];
    if (regex.test(className)) {
      return true;
    }
  }
  return false;
}
function distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
  if (!node) return -1;
  if (node.nodeType !== node.ELEMENT_NODE) return -1;
  if (distance > limit) return -1;
  if (matchPredicate(node)) return distance;
  return distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function createMatchPredicate(className, selector) {
  return node => {
    const el = node;
    if (el === null) return false;
    try {
      if (className) {
        if (typeof className === 'string') {
          if (el.matches(`.${className}`)) return true;
        } else if (elementClassMatchesRegex(el, className)) {
          return true;
        }
      }
      if (selector && el.matches(selector)) return true;
      return false;
    } catch (e2) {
      return false;
    }
  };
}
function needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
  try {
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    if (el === null) return false;
    if (el.tagName === 'INPUT') {
      const autocomplete = el.getAttribute('autocomplete');
      const disallowedAutocompleteValues = ['current-password', 'new-password', 'cc-number', 'cc-exp', 'cc-exp-month', 'cc-exp-year', 'cc-csc'];
      if (disallowedAutocompleteValues.includes(autocomplete)) {
        return true;
      }
    }
    let maskDistance = -1;
    let unmaskDistance = -1;
    if (maskAllText) {
      unmaskDistance = distanceToMatch(el, createMatchPredicate(unmaskTextClass, unmaskTextSelector));
      if (unmaskDistance < 0) {
        return true;
      }
      maskDistance = distanceToMatch(el, createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
    } else {
      maskDistance = distanceToMatch(el, createMatchPredicate(maskTextClass, maskTextSelector));
      if (maskDistance < 0) {
        return false;
      }
      unmaskDistance = distanceToMatch(el, createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
    }
    return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
  } catch (e) {}
  return !!maskAllText;
}
function onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
  const win = iframeEl.contentWindow;
  if (!win) {
    return;
  }
  let fired = false;
  let readyState;
  try {
    readyState = win.document.readyState;
  } catch (error) {
    return;
  }
  if (readyState !== 'complete') {
    const timer = setTimeout$2(() => {
      if (!fired) {
        listener();
        fired = true;
      }
    }, iframeLoadTimeout);
    iframeEl.addEventListener('load', () => {
      clearTimeout$2(timer);
      fired = true;
      listener();
    });
    return;
  }
  const blankUrl = 'about:blank';
  if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === '') {
    setTimeout$2(listener, 0);
    return iframeEl.addEventListener('load', listener);
  }
  iframeEl.addEventListener('load', listener);
}
function onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
  let fired = false;
  let styleSheetLoaded;
  try {
    styleSheetLoaded = link.sheet;
  } catch (error) {
    return;
  }
  if (styleSheetLoaded) return;
  const timer = setTimeout$2(() => {
    if (!fired) {
      listener();
      fired = true;
    }
  }, styleSheetLoadTimeout);
  link.addEventListener('load', () => {
    clearTimeout$2(timer);
    fired = true;
    listener();
  });
}
function serializeNode(n, options) {
  const {
    doc,
    mirror,
    blockClass,
    blockSelector,
    unblockSelector,
    maskAllText,
    maskAttributeFn,
    maskTextClass,
    unmaskTextClass,
    maskTextSelector,
    unmaskTextSelector,
    inlineStylesheet,
    maskInputOptions = {},
    maskTextFn,
    maskInputFn,
    dataURLOptions = {},
    inlineImages,
    recordCanvas,
    keepIframeSrcFn,
    newlyAddedElement = false
  } = options;
  const rootId = getRootId(doc, mirror);
  switch (n.nodeType) {
    case n.DOCUMENT_NODE:
      if (n.compatMode !== 'CSS1Compat') {
        return {
          type: NodeType$3.Document,
          childNodes: [],
          compatMode: n.compatMode
        };
      } else {
        return {
          type: NodeType$3.Document,
          childNodes: []
        };
      }
    case n.DOCUMENT_TYPE_NODE:
      return {
        type: NodeType$3.DocumentType,
        name: n.name,
        publicId: n.publicId,
        systemId: n.systemId,
        rootId
      };
    case n.ELEMENT_NODE:
      return serializeElementNode(n, {
        doc,
        blockClass,
        blockSelector,
        unblockSelector,
        inlineStylesheet,
        maskAttributeFn,
        maskInputOptions,
        maskInputFn,
        dataURLOptions,
        inlineImages,
        recordCanvas,
        keepIframeSrcFn,
        newlyAddedElement,
        rootId,
        maskAllText,
        maskTextClass,
        unmaskTextClass,
        maskTextSelector,
        unmaskTextSelector
      });
    case n.TEXT_NODE:
      return serializeTextNode(n, {
        doc,
        maskAllText,
        maskTextClass,
        unmaskTextClass,
        maskTextSelector,
        unmaskTextSelector,
        maskTextFn,
        maskInputOptions,
        maskInputFn,
        rootId
      });
    case n.CDATA_SECTION_NODE:
      return {
        type: NodeType$3.CDATA,
        textContent: '',
        rootId
      };
    case n.COMMENT_NODE:
      return {
        type: NodeType$3.Comment,
        textContent: n.textContent || '',
        rootId
      };
    default:
      return false;
  }
}
function getRootId(doc, mirror) {
  if (!mirror.hasNode(doc)) return undefined;
  const docId = mirror.getId(doc);
  return docId === 1 ? undefined : docId;
}
function serializeTextNode(n, options) {
  const {
    maskAllText,
    maskTextClass,
    unmaskTextClass,
    maskTextSelector,
    unmaskTextSelector,
    maskTextFn,
    maskInputOptions,
    maskInputFn,
    rootId
  } = options;
  const parentTagName = n.parentNode && n.parentNode.tagName;
  let textContent = n.textContent;
  const isStyle = parentTagName === 'STYLE' ? true : undefined;
  const isScript = parentTagName === 'SCRIPT' ? true : undefined;
  const isTextarea = parentTagName === 'TEXTAREA' ? true : undefined;
  if (isStyle && textContent) {
    try {
      if (n.nextSibling || n.previousSibling) {} else if (_optionalChain$5([n, 'access', _7 => _7.parentNode, 'access', _8 => _8.sheet, 'optionalAccess', _9 => _9.cssRules])) {
        textContent = stringifyStylesheet(n.parentNode.sheet);
      }
    } catch (err) {
      console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
    }
    textContent = absoluteToStylesheet(textContent, getHref(options.doc));
  }
  if (isScript) {
    textContent = 'SCRIPT_PLACEHOLDER';
  }
  const forceMask = needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
  if (!isStyle && !isScript && !isTextarea && textContent && forceMask) {
    textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, '*');
  }
  if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) {
    textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, '*');
  }
  if (parentTagName === 'OPTION' && textContent) {
    const isInputMasked = shouldMaskInput({
      type: null,
      tagName: parentTagName,
      maskInputOptions
    });
    textContent = maskInputValue({
      isMasked: needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
      element: n,
      value: textContent,
      maskInputFn
    });
  }
  return {
    type: NodeType$3.Text,
    textContent: textContent || '',
    isStyle,
    rootId
  };
}
function serializeElementNode(n, options) {
  const {
    doc,
    blockClass,
    blockSelector,
    unblockSelector,
    inlineStylesheet,
    maskInputOptions = {},
    maskAttributeFn,
    maskInputFn,
    dataURLOptions = {},
    inlineImages,
    recordCanvas,
    keepIframeSrcFn,
    newlyAddedElement = false,
    rootId,
    maskAllText,
    maskTextClass,
    unmaskTextClass,
    maskTextSelector,
    unmaskTextSelector
  } = options;
  const needBlock = _isBlockedElement(n, blockClass, blockSelector, unblockSelector);
  const tagName = getValidTagName(n);
  let attributes = {};
  const len = n.attributes.length;
  for (let i = 0; i < len; i++) {
    const attr = n.attributes[i];
    if (attr.name && !ignoreAttribute(tagName, attr.name, attr.value)) {
      attributes[attr.name] = transformAttribute(doc, tagName, toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
  }
  if (tagName === 'link' && inlineStylesheet) {
    const stylesheet = Array.from(doc.styleSheets).find(s => {
      return s.href === n.href;
    });
    let cssText = null;
    if (stylesheet) {
      cssText = stringifyStylesheet(stylesheet);
    }
    if (cssText) {
      attributes.rel = null;
      attributes.href = null;
      attributes.crossorigin = null;
      attributes._cssText = absoluteToStylesheet(cssText, stylesheet.href);
    }
  }
  if (tagName === 'style' && n.sheet && !(n.innerText || n.textContent || '').trim().length) {
    const cssText = stringifyStylesheet(n.sheet);
    if (cssText) {
      attributes._cssText = absoluteToStylesheet(cssText, getHref(doc));
    }
  }
  if (tagName === 'input' || tagName === 'textarea' || tagName === 'select' || tagName === 'option') {
    const el = n;
    const type = getInputType(el);
    const value = getInputValue(el, toUpperCase(tagName), type);
    const checked = el.checked;
    if (type !== 'submit' && type !== 'button' && value) {
      const forceMask = needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, shouldMaskInput({
        type,
        tagName: toUpperCase(tagName),
        maskInputOptions
      }));
      attributes.value = maskInputValue({
        isMasked: forceMask,
        element: el,
        value,
        maskInputFn
      });
    }
    if (checked) {
      attributes.checked = checked;
    }
  }
  if (tagName === 'option') {
    if (n.selected && !maskInputOptions['select']) {
      attributes.selected = true;
    } else {
      delete attributes.selected;
    }
  }
  if (tagName === 'canvas' && recordCanvas) {
    if (n.__context === '2d') {
      if (!is2DCanvasBlank(n)) {
        attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
      }
    } else if (!('__context' in n)) {
      const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
      const blankCanvas = doc.createElement('canvas');
      blankCanvas.width = n.width;
      blankCanvas.height = n.height;
      const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
      if (canvasDataURL !== blankCanvasDataURL) {
        attributes.rr_dataURL = canvasDataURL;
      }
    }
  }
  if (tagName === 'img' && inlineImages) {
    if (!canvasService) {
      canvasService = doc.createElement('canvas');
      canvasCtx = canvasService.getContext('2d');
    }
    const image = n;
    const imageSrc = image.currentSrc || image.getAttribute('src') || '<unknown-src>';
    const priorCrossOrigin = image.crossOrigin;
    const recordInlineImage = () => {
      image.removeEventListener('load', recordInlineImage);
      try {
        canvasService.width = image.naturalWidth;
        canvasService.height = image.naturalHeight;
        canvasCtx.drawImage(image, 0, 0);
        attributes.rr_dataURL = canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
      } catch (err) {
        if (image.crossOrigin !== 'anonymous') {
          image.crossOrigin = 'anonymous';
          if (image.complete && image.naturalWidth !== 0) recordInlineImage();else image.addEventListener('load', recordInlineImage);
          return;
        } else {
          console.warn(`Cannot inline img src=${imageSrc}! Error: ${err}`);
        }
      }
      if (image.crossOrigin === 'anonymous') {
        priorCrossOrigin ? attributes.crossOrigin = priorCrossOrigin : image.removeAttribute('crossorigin');
      }
    };
    if (image.complete && image.naturalWidth !== 0) recordInlineImage();else image.addEventListener('load', recordInlineImage);
  }
  if (tagName === 'audio' || tagName === 'video') {
    attributes.rr_mediaState = n.paused ? 'paused' : 'played';
    attributes.rr_mediaCurrentTime = n.currentTime;
  }
  if (!newlyAddedElement) {
    if (n.scrollLeft) {
      attributes.rr_scrollLeft = n.scrollLeft;
    }
    if (n.scrollTop) {
      attributes.rr_scrollTop = n.scrollTop;
    }
  }
  if (needBlock) {
    const {
      width,
      height
    } = n.getBoundingClientRect();
    attributes = {
      class: attributes.class,
      rr_width: `${width}px`,
      rr_height: `${height}px`
    };
  }
  if (tagName === 'iframe' && !keepIframeSrcFn(attributes.src)) {
    if (!needBlock && !getIframeContentDocument(n)) {
      attributes.rr_src = attributes.src;
    }
    delete attributes.src;
  }
  let isCustomElement;
  try {
    if (customElements.get(tagName)) isCustomElement = true;
  } catch (e) {}
  return {
    type: NodeType$3.Element,
    tagName,
    attributes,
    childNodes: [],
    isSVG: isSVGElement(n) || undefined,
    needBlock,
    rootId,
    isCustom: isCustomElement
  };
}
function lowerIfExists(maybeAttr) {
  if (maybeAttr === undefined || maybeAttr === null) {
    return '';
  } else {
    return maybeAttr.toLowerCase();
  }
}
function slimDOMExcluded(sn, slimDOMOptions) {
  if (slimDOMOptions.comment && sn.type === NodeType$3.Comment) {
    return true;
  } else if (sn.type === NodeType$3.Element) {
    if (slimDOMOptions.script && (sn.tagName === 'script' || sn.tagName === 'link' && (sn.attributes.rel === 'preload' || sn.attributes.rel === 'modulepreload') || sn.tagName === 'link' && sn.attributes.rel === 'prefetch' && typeof sn.attributes.href === 'string' && extractFileExtension(sn.attributes.href) === 'js')) {
      return true;
    } else if (slimDOMOptions.headFavicon && (sn.tagName === 'link' && sn.attributes.rel === 'shortcut icon' || sn.tagName === 'meta' && (lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || lowerIfExists(sn.attributes.name) === 'application-name' || lowerIfExists(sn.attributes.rel) === 'icon' || lowerIfExists(sn.attributes.rel) === 'apple-touch-icon' || lowerIfExists(sn.attributes.rel) === 'shortcut icon'))) {
      return true;
    } else if (sn.tagName === 'meta') {
      if (slimDOMOptions.headMetaDescKeywords && lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) {
        return true;
      } else if (slimDOMOptions.headMetaSocial && (lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || lowerIfExists(sn.attributes.name) === 'pinterest')) {
        return true;
      } else if (slimDOMOptions.headMetaRobots && (lowerIfExists(sn.attributes.name) === 'robots' || lowerIfExists(sn.attributes.name) === 'googlebot' || lowerIfExists(sn.attributes.name) === 'bingbot')) {
        return true;
      } else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes['http-equiv'] !== undefined) {
        return true;
      } else if (slimDOMOptions.headMetaAuthorship && (lowerIfExists(sn.attributes.name) === 'author' || lowerIfExists(sn.attributes.name) === 'generator' || lowerIfExists(sn.attributes.name) === 'framework' || lowerIfExists(sn.attributes.name) === 'publisher' || lowerIfExists(sn.attributes.name) === 'progid' || lowerIfExists(sn.attributes.property).match(/^article:/) || lowerIfExists(sn.attributes.property).match(/^product:/))) {
        return true;
      } else if (slimDOMOptions.headMetaVerification && (lowerIfExists(sn.attributes.name) === 'google-site-verification' || lowerIfExists(sn.attributes.name) === 'yandex-verification' || lowerIfExists(sn.attributes.name) === 'csrf-token' || lowerIfExists(sn.attributes.name) === 'p:domain_verify' || lowerIfExists(sn.attributes.name) === 'verify-v1' || lowerIfExists(sn.attributes.name) === 'verification' || lowerIfExists(sn.attributes.name) === 'shopify-checkout-api-token')) {
        return true;
      }
    }
  }
  return false;
}
function serializeNodeWithId(n, options) {
  const {
    doc,
    mirror,
    blockClass,
    blockSelector,
    unblockSelector,
    maskAllText,
    maskTextClass,
    unmaskTextClass,
    maskTextSelector,
    unmaskTextSelector,
    skipChild = false,
    inlineStylesheet = true,
    maskInputOptions = {},
    maskAttributeFn,
    maskTextFn,
    maskInputFn,
    slimDOMOptions,
    dataURLOptions = {},
    inlineImages = false,
    recordCanvas = false,
    onSerialize,
    onIframeLoad,
    iframeLoadTimeout = 5000,
    onStylesheetLoad,
    stylesheetLoadTimeout = 5000,
    keepIframeSrcFn = () => false,
    newlyAddedElement = false
  } = options;
  let {
    preserveWhiteSpace = true
  } = options;
  const _serializedNode = serializeNode(n, {
    doc,
    mirror,
    blockClass,
    blockSelector,
    maskAllText,
    unblockSelector,
    maskTextClass,
    unmaskTextClass,
    maskTextSelector,
    unmaskTextSelector,
    inlineStylesheet,
    maskInputOptions,
    maskAttributeFn,
    maskTextFn,
    maskInputFn,
    dataURLOptions,
    inlineImages,
    recordCanvas,
    keepIframeSrcFn,
    newlyAddedElement
  });
  if (!_serializedNode) {
    console.warn(n, 'not serialized');
    return null;
  }
  let id;
  if (mirror.hasNode(n)) {
    id = mirror.getId(n);
  } else if (slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === NodeType$3.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, '').length) {
    id = IGNORED_NODE;
  } else {
    id = genId();
  }
  const serializedNode = Object.assign(_serializedNode, {
    id
  });
  mirror.add(n, serializedNode);
  if (id === IGNORED_NODE) {
    return null;
  }
  if (onSerialize) {
    onSerialize(n);
  }
  let recordChild = !skipChild;
  if (serializedNode.type === NodeType$3.Element) {
    recordChild = recordChild && !serializedNode.needBlock;
    delete serializedNode.needBlock;
    const shadowRoot = n.shadowRoot;
    if (shadowRoot && isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
  }
  if ((serializedNode.type === NodeType$3.Document || serializedNode.type === NodeType$3.Element) && recordChild) {
    if (slimDOMOptions.headWhitespace && serializedNode.type === NodeType$3.Element && serializedNode.tagName === 'head') {
      preserveWhiteSpace = false;
    }
    const bypassOptions = {
      doc,
      mirror,
      blockClass,
      blockSelector,
      maskAllText,
      unblockSelector,
      maskTextClass,
      unmaskTextClass,
      maskTextSelector,
      unmaskTextSelector,
      skipChild,
      inlineStylesheet,
      maskInputOptions,
      maskAttributeFn,
      maskTextFn,
      maskInputFn,
      slimDOMOptions,
      dataURLOptions,
      inlineImages,
      recordCanvas,
      preserveWhiteSpace,
      onSerialize,
      onIframeLoad,
      iframeLoadTimeout,
      onStylesheetLoad,
      stylesheetLoadTimeout,
      keepIframeSrcFn
    };
    for (const childN of Array.from(n.childNodes)) {
      const serializedChildNode = serializeNodeWithId(childN, bypassOptions);
      if (serializedChildNode) {
        serializedNode.childNodes.push(serializedChildNode);
      }
    }
    if (isElement$1(n) && n.shadowRoot) {
      for (const childN of Array.from(n.shadowRoot.childNodes)) {
        const serializedChildNode = serializeNodeWithId(childN, bypassOptions);
        if (serializedChildNode) {
          isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
          serializedNode.childNodes.push(serializedChildNode);
        }
      }
    }
  }
  if (n.parentNode && isShadowRoot(n.parentNode) && isNativeShadowDom(n.parentNode)) {
    serializedNode.isShadow = true;
  }
  if (serializedNode.type === NodeType$3.Element && serializedNode.tagName === 'iframe') {
    onceIframeLoaded(n, () => {
      const iframeDoc = getIframeContentDocument(n);
      if (iframeDoc && onIframeLoad) {
        const serializedIframeNode = serializeNodeWithId(iframeDoc, {
          doc: iframeDoc,
          mirror,
          blockClass,
          blockSelector,
          unblockSelector,
          maskAllText,
          maskTextClass,
          unmaskTextClass,
          maskTextSelector,
          unmaskTextSelector,
          skipChild: false,
          inlineStylesheet,
          maskInputOptions,
          maskAttributeFn,
          maskTextFn,
          maskInputFn,
          slimDOMOptions,
          dataURLOptions,
          inlineImages,
          recordCanvas,
          preserveWhiteSpace,
          onSerialize,
          onIframeLoad,
          iframeLoadTimeout,
          onStylesheetLoad,
          stylesheetLoadTimeout,
          keepIframeSrcFn
        });
        if (serializedIframeNode) {
          onIframeLoad(n, serializedIframeNode);
        }
      }
    }, iframeLoadTimeout);
  }
  if (serializedNode.type === NodeType$3.Element && serializedNode.tagName === 'link' && typeof serializedNode.attributes.rel === 'string' && (serializedNode.attributes.rel === 'stylesheet' || serializedNode.attributes.rel === 'preload' && typeof serializedNode.attributes.href === 'string' && extractFileExtension(serializedNode.attributes.href) === 'css')) {
    onceStylesheetLoaded(n, () => {
      if (onStylesheetLoad) {
        const serializedLinkNode = serializeNodeWithId(n, {
          doc,
          mirror,
          blockClass,
          blockSelector,
          unblockSelector,
          maskAllText,
          maskTextClass,
          unmaskTextClass,
          maskTextSelector,
          unmaskTextSelector,
          skipChild: false,
          inlineStylesheet,
          maskInputOptions,
          maskAttributeFn,
          maskTextFn,
          maskInputFn,
          slimDOMOptions,
          dataURLOptions,
          inlineImages,
          recordCanvas,
          preserveWhiteSpace,
          onSerialize,
          onIframeLoad,
          iframeLoadTimeout,
          onStylesheetLoad,
          stylesheetLoadTimeout,
          keepIframeSrcFn
        });
        if (serializedLinkNode) {
          onStylesheetLoad(n, serializedLinkNode);
        }
      }
    }, stylesheetLoadTimeout);
  }
  return serializedNode;
}
function snapshot(n, options) {
  const {
    mirror = new Mirror(),
    blockClass = 'rr-block',
    blockSelector = null,
    unblockSelector = null,
    maskAllText = false,
    maskTextClass = 'rr-mask',
    unmaskTextClass = null,
    maskTextSelector = null,
    unmaskTextSelector = null,
    inlineStylesheet = true,
    inlineImages = false,
    recordCanvas = false,
    maskAllInputs = false,
    maskAttributeFn,
    maskTextFn,
    maskInputFn,
    slimDOM = false,
    dataURLOptions,
    preserveWhiteSpace,
    onSerialize,
    onIframeLoad,
    iframeLoadTimeout,
    onStylesheetLoad,
    stylesheetLoadTimeout,
    keepIframeSrcFn = () => false
  } = options || {};
  const maskInputOptions = maskAllInputs === true ? {
    color: true,
    date: true,
    'datetime-local': true,
    email: true,
    month: true,
    number: true,
    range: true,
    search: true,
    tel: true,
    text: true,
    time: true,
    url: true,
    week: true,
    textarea: true,
    select: true
  } : maskAllInputs === false ? {} : maskAllInputs;
  const slimDOMOptions = slimDOM === true || slimDOM === 'all' ? {
    script: true,
    comment: true,
    headFavicon: true,
    headWhitespace: true,
    headMetaDescKeywords: slimDOM === 'all',
    headMetaSocial: true,
    headMetaRobots: true,
    headMetaHttpEquiv: true,
    headMetaAuthorship: true,
    headMetaVerification: true
  } : slimDOM === false ? {} : slimDOM;
  return serializeNodeWithId(n, {
    doc: n,
    mirror,
    blockClass,
    blockSelector,
    unblockSelector,
    maskAllText,
    maskTextClass,
    unmaskTextClass,
    maskTextSelector,
    unmaskTextSelector,
    skipChild: false,
    inlineStylesheet,
    maskInputOptions,
    maskAttributeFn,
    maskTextFn,
    maskInputFn,
    slimDOMOptions,
    dataURLOptions,
    inlineImages,
    recordCanvas,
    preserveWhiteSpace,
    onSerialize,
    onIframeLoad,
    iframeLoadTimeout,
    onStylesheetLoad,
    stylesheetLoadTimeout,
    keepIframeSrcFn,
    newlyAddedElement: false
  });
}
function _optionalChain$4(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i];
    const fn = ops[i + 1];
    i += 2;
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => value.call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}
function on(type, fn, target = document) {
  const options = {
    capture: true,
    passive: true
  };
  target.addEventListener(type, fn, options);
  return () => target.removeEventListener(type, fn, options);
}
const DEPARTED_MIRROR_ACCESS_WARNING = 'Please stop import mirror directly. Instead of that,' + '\r\n' + 'now you can use replayer.getMirror() to access the mirror instance of a replayer,' + '\r\n' + 'or you can use record.mirror to access the mirror instance during recording.';
let _mirror = {
  map: {},
  getId() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return -1;
  },
  getNode() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return null;
  },
  removeNodeFromMap() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
  },
  has() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return false;
  },
  reset() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
  }
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) {
  _mirror = new Proxy(_mirror, {
    get(target, prop, receiver) {
      if (prop === 'map') {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
      }
      return Reflect.get(target, prop, receiver);
    }
  });
}
function throttle$1(func, wait, options = {}) {
  let timeout = null;
  let previous = 0;
  return function (...args) {
    const now = Date.now();
    if (!previous && options.leading === false) {
      previous = now;
    }
    const remaining = wait - (now - previous);
    const context = this;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout$1(timeout);
        timeout = null;
      }
      previous = now;
      func.apply(context, args);
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout$1(() => {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        func.apply(context, args);
      }, remaining);
    }
  };
}
function hookSetter(target, key, d, isRevoked, win = window) {
  const original = win.Object.getOwnPropertyDescriptor(target, key);
  win.Object.defineProperty(target, key, isRevoked ? d : {
    set(value) {
      setTimeout$1(() => {
        d.set.call(this, value);
      }, 0);
      if (original && original.set) {
        original.set.call(this, value);
      }
    }
  });
  return () => hookSetter(target, key, original || {}, true);
}
function patch(source, name, replacement) {
  try {
    if (!(name in source)) {
      return () => {};
    }
    const original = source[name];
    const wrapped = replacement(original);
    if (typeof wrapped === 'function') {
      wrapped.prototype = wrapped.prototype || {};
      Object.defineProperties(wrapped, {
        __rrweb_original__: {
          enumerable: false,
          value: original
        }
      });
    }
    source[name] = wrapped;
    return () => {
      source[name] = original;
    };
  } catch (e2) {
    return () => {};
  }
}
let nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) {
  nowTimestamp = () => new Date().getTime();
}
function getWindowScroll(win) {
  const doc = win.document;
  return {
    left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : _optionalChain$4([doc, 'optionalAccess', _ => _.documentElement, 'access', _2 => _2.scrollLeft]) || _optionalChain$4([doc, 'optionalAccess', _3 => _3.body, 'optionalAccess', _4 => _4.parentElement, 'optionalAccess', _5 => _5.scrollLeft]) || _optionalChain$4([doc, 'optionalAccess', _6 => _6.body, 'optionalAccess', _7 => _7.scrollLeft]) || 0,
    top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : _optionalChain$4([doc, 'optionalAccess', _8 => _8.documentElement, 'access', _9 => _9.scrollTop]) || _optionalChain$4([doc, 'optionalAccess', _10 => _10.body, 'optionalAccess', _11 => _11.parentElement, 'optionalAccess', _12 => _12.scrollTop]) || _optionalChain$4([doc, 'optionalAccess', _13 => _13.body, 'optionalAccess', _14 => _14.scrollTop]) || 0
  };
}
function getWindowHeight() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function getWindowWidth() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function closestElementOfNode(node) {
  if (!node) {
    return null;
  }
  const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
  return el;
}
function isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
  if (!node) {
    return false;
  }
  const el = closestElementOfNode(node);
  if (!el) {
    return false;
  }
  const blockedPredicate = createMatchPredicate(blockClass, blockSelector);
  if (!checkAncestors) {
    const isUnblocked = unblockSelector && el.matches(unblockSelector);
    return blockedPredicate(el) && !isUnblocked;
  }
  const blockDistance = distanceToMatch(el, blockedPredicate);
  let unblockDistance = -1;
  if (blockDistance < 0) {
    return false;
  }
  if (unblockSelector) {
    unblockDistance = distanceToMatch(el, createMatchPredicate(null, unblockSelector));
  }
  if (blockDistance > -1 && unblockDistance < 0) {
    return true;
  }
  return blockDistance < unblockDistance;
}
function isSerialized(n, mirror) {
  return mirror.getId(n) !== -1;
}
function isIgnored(n, mirror) {
  return mirror.getId(n) === IGNORED_NODE;
}
function isAncestorRemoved(target, mirror) {
  if (isShadowRoot(target)) {
    return false;
  }
  const id = mirror.getId(target);
  if (!mirror.has(id)) {
    return true;
  }
  if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) {
    return false;
  }
  if (!target.parentNode) {
    return true;
  }
  return isAncestorRemoved(target.parentNode, mirror);
}
function legacy_isTouchEvent(event) {
  return Boolean(event.changedTouches);
}
function polyfill(win = window) {
  if ('NodeList' in win && !win.NodeList.prototype.forEach) {
    win.NodeList.prototype.forEach = Array.prototype.forEach;
  }
  if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) {
    win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
  }
  if (!Node.prototype.contains) {
    Node.prototype.contains = (...args) => {
      let node = args[0];
      if (!(0 in args)) {
        throw new TypeError('1 argument is required');
      }
      do {
        if (this === node) {
          return true;
        }
      } while (node = node && node.parentNode);
      return false;
    };
  }
}
function isSerializedIframe(n, mirror) {
  return Boolean(n.nodeName === 'IFRAME' && mirror.getMeta(n));
}
function isSerializedStylesheet(n, mirror) {
  return Boolean(n.nodeName === 'LINK' && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute('rel') === 'stylesheet' && mirror.getMeta(n));
}
function hasShadowRoot(n) {
  return Boolean(_optionalChain$4([n, 'optionalAccess', _18 => _18.shadowRoot]));
}
class StyleSheetMirror {
  constructor() {
    this.id = 1;
    this.styleIDMap = new WeakMap();
    this.idStyleMap = new Map();
  }
  getId(stylesheet) {
    return _nullishCoalesce(this.styleIDMap.get(stylesheet), () => -1);
  }
  has(stylesheet) {
    return this.styleIDMap.has(stylesheet);
  }
  add(stylesheet, id) {
    if (this.has(stylesheet)) return this.getId(stylesheet);
    let newId;
    if (id === undefined) {
      newId = this.id++;
    } else newId = id;
    this.styleIDMap.set(stylesheet, newId);
    this.idStyleMap.set(newId, stylesheet);
    return newId;
  }
  getStyle(id) {
    return this.idStyleMap.get(id) || null;
  }
  reset() {
    this.styleIDMap = new WeakMap();
    this.idStyleMap = new Map();
    this.id = 1;
  }
  generateId() {
    return this.id++;
  }
}
function getShadowHost(n) {
  let shadowHost = null;
  if (_optionalChain$4([n, 'access', _19 => _19.getRootNode, 'optionalCall', _20 => _20(), 'optionalAccess', _21 => _21.nodeType]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
  return shadowHost;
}
function getRootShadowHost(n) {
  let rootShadowHost = n;
  let shadowHost;
  while (shadowHost = getShadowHost(rootShadowHost)) rootShadowHost = shadowHost;
  return rootShadowHost;
}
function shadowHostInDom(n) {
  const doc = n.ownerDocument;
  if (!doc) return false;
  const shadowHost = getRootShadowHost(n);
  return doc.contains(shadowHost);
}
function inDom(n) {
  const doc = n.ownerDocument;
  if (!doc) return false;
  return doc.contains(n) || shadowHostInDom(n);
}
const cachedImplementations = {};
function getImplementation(name) {
  const cached = cachedImplementations[name];
  if (cached) {
    return cached;
  }
  const document = window.document;
  let impl = window[name];
  if (document && typeof document.createElement === 'function') {
    try {
      const sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow[name]) {
        impl = contentWindow[name];
      }
      document.head.removeChild(sandbox);
    } catch (e) {}
  }
  return cachedImplementations[name] = impl.bind(window);
}
function onRequestAnimationFrame(...rest) {
  return getImplementation('requestAnimationFrame')(...rest);
}
function setTimeout$1(...rest) {
  return getImplementation('setTimeout')(...rest);
}
function clearTimeout$1(...rest) {
  return getImplementation('clearTimeout')(...rest);
}
var EventType = /* @__PURE__ */(EventType2 => {
  EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
  EventType2[EventType2["Load"] = 1] = "Load";
  EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
  EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
  EventType2[EventType2["Meta"] = 4] = "Meta";
  EventType2[EventType2["Custom"] = 5] = "Custom";
  EventType2[EventType2["Plugin"] = 6] = "Plugin";
  return EventType2;
})(EventType || {});
var IncrementalSource = /* @__PURE__ */(IncrementalSource2 => {
  IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
  IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
  IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
  IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
  IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
  IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
  IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
  IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
  IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
  IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
  IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
  IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
  IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
  IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
  IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
  IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
  IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
  return IncrementalSource2;
})(IncrementalSource || {});
var MouseInteractions = /* @__PURE__ */(MouseInteractions2 => {
  MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
  MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
  MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
  MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
  MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
  MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
  MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
  MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
  MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
  MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
  MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
  return MouseInteractions2;
})(MouseInteractions || {});
var PointerTypes = /* @__PURE__ */(PointerTypes2 => {
  PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
  PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
  PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
  return PointerTypes2;
})(PointerTypes || {});
var NodeType$1;
(function (NodeType) {
  NodeType[NodeType["Document"] = 0] = "Document";
  NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
  NodeType[NodeType["Element"] = 2] = "Element";
  NodeType[NodeType["Text"] = 3] = "Text";
  NodeType[NodeType["CDATA"] = 4] = "CDATA";
  NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType$1 || (NodeType$1 = {}));
var NodeType$2;
(function (NodeType) {
  NodeType[NodeType["PLACEHOLDER"] = 0] = "PLACEHOLDER";
  NodeType[NodeType["ELEMENT_NODE"] = 1] = "ELEMENT_NODE";
  NodeType[NodeType["ATTRIBUTE_NODE"] = 2] = "ATTRIBUTE_NODE";
  NodeType[NodeType["TEXT_NODE"] = 3] = "TEXT_NODE";
  NodeType[NodeType["CDATA_SECTION_NODE"] = 4] = "CDATA_SECTION_NODE";
  NodeType[NodeType["ENTITY_REFERENCE_NODE"] = 5] = "ENTITY_REFERENCE_NODE";
  NodeType[NodeType["ENTITY_NODE"] = 6] = "ENTITY_NODE";
  NodeType[NodeType["PROCESSING_INSTRUCTION_NODE"] = 7] = "PROCESSING_INSTRUCTION_NODE";
  NodeType[NodeType["COMMENT_NODE"] = 8] = "COMMENT_NODE";
  NodeType[NodeType["DOCUMENT_NODE"] = 9] = "DOCUMENT_NODE";
  NodeType[NodeType["DOCUMENT_TYPE_NODE"] = 10] = "DOCUMENT_TYPE_NODE";
  NodeType[NodeType["DOCUMENT_FRAGMENT_NODE"] = 11] = "DOCUMENT_FRAGMENT_NODE";
})(NodeType$2 || (NodeType$2 = {}));
function getIFrameContentDocument(iframe) {
  try {
    return iframe.contentDocument;
  } catch (e) {}
}
function getIFrameContentWindow(iframe) {
  try {
    return iframe.contentWindow;
  } catch (e) {}
}
function _optionalChain$3(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i];
    const fn = ops[i + 1];
    i += 2;
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => value.call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}
function isNodeInLinkedList(n) {
  return '__ln' in n;
}
class DoubleLinkedList {
  constructor() {
    this.length = 0;
    this.head = null;
    this.tail = null;
  }
  get(position) {
    if (position >= this.length) {
      throw new Error('Position outside of list range');
    }
    let current = this.head;
    for (let index = 0; index < position; index++) {
      current = _optionalChain$3([current, 'optionalAccess', _ => _.next]) || null;
    }
    return current;
  }
  addNode(n) {
    const node = {
      value: n,
      previous: null,
      next: null
    };
    n.__ln = node;
    if (n.previousSibling && isNodeInLinkedList(n.previousSibling)) {
      const current = n.previousSibling.__ln.next;
      node.next = current;
      node.previous = n.previousSibling.__ln;
      n.previousSibling.__ln.next = node;
      if (current) {
        current.previous = node;
      }
    } else if (n.nextSibling && isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
      const current = n.nextSibling.__ln.previous;
      node.previous = current;
      node.next = n.nextSibling.__ln;
      n.nextSibling.__ln.previous = node;
      if (current) {
        current.next = node;
      }
    } else {
      if (this.head) {
        this.head.previous = node;
      }
      node.next = this.head;
      this.head = node;
    }
    if (node.next === null) {
      this.tail = node;
    }
    this.length++;
  }
  removeNode(n) {
    const current = n.__ln;
    if (!this.head) {
      return;
    }
    if (!current.previous) {
      this.head = current.next;
      if (this.head) {
        this.head.previous = null;
      } else {
        this.tail = null;
      }
    } else {
      current.previous.next = current.next;
      if (current.next) {
        current.next.previous = current.previous;
      } else {
        this.tail = current.previous;
      }
    }
    if (n.__ln) {
      delete n.__ln;
    }
    this.length--;
  }
}
const moveKey = (id, parentId) => `${id}@${parentId}`;
class MutationBuffer {
  constructor() {
    this.frozen = false;
    this.locked = false;
    this.texts = [];
    this.attributes = [];
    this.attributeMap = new WeakMap();
    this.removes = [];
    this.mapRemoves = [];
    this.movedMap = {};
    this.addedSet = new Set();
    this.movedSet = new Set();
    this.droppedSet = new Set();
    this.processMutations = mutations => {
      mutations.forEach(this.processMutation);
      this.emit();
    };
    this.emit = () => {
      if (this.frozen || this.locked) {
        return;
      }
      const adds = [];
      const addedIds = new Set();
      const addList = new DoubleLinkedList();
      const getNextId = n => {
        let ns = n;
        let nextId = IGNORED_NODE;
        while (nextId === IGNORED_NODE) {
          ns = ns && ns.nextSibling;
          nextId = ns && this.mirror.getId(ns);
        }
        return nextId;
      };
      const pushAdd = n => {
        if (!n.parentNode || !inDom(n)) {
          return;
        }
        const parentId = isShadowRoot(n.parentNode) ? this.mirror.getId(getShadowHost(n)) : this.mirror.getId(n.parentNode);
        const nextId = getNextId(n);
        if (parentId === -1 || nextId === -1) {
          return addList.addNode(n);
        }
        const sn = serializeNodeWithId(n, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskAllText: this.maskAllText,
          unblockSelector: this.unblockSelector,
          maskTextClass: this.maskTextClass,
          unmaskTextClass: this.unmaskTextClass,
          maskTextSelector: this.maskTextSelector,
          unmaskTextSelector: this.unmaskTextSelector,
          skipChild: true,
          newlyAddedElement: true,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskAttributeFn: this.maskAttributeFn,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          onSerialize: currentN => {
            if (isSerializedIframe(currentN, this.mirror) && !isBlocked(currentN, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
              this.iframeManager.addIframe(currentN);
            }
            if (isSerializedStylesheet(currentN, this.mirror)) {
              this.stylesheetManager.trackLinkElement(currentN);
            }
            if (hasShadowRoot(n)) {
              this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
            }
          },
          onIframeLoad: (iframe, childSn) => {
            if (isBlocked(iframe, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
              return;
            }
            this.iframeManager.attachIframe(iframe, childSn);
            if (iframe.contentWindow) {
              this.canvasManager.addWindow(iframe.contentWindow);
            }
            this.shadowDomManager.observeAttachShadow(iframe);
          },
          onStylesheetLoad: (link, childSn) => {
            this.stylesheetManager.attachLinkElement(link, childSn);
          }
        });
        if (sn) {
          adds.push({
            parentId,
            nextId,
            node: sn
          });
          addedIds.add(sn.id);
        }
      };
      while (this.mapRemoves.length) {
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      }
      for (const n of this.movedSet) {
        if (isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) {
          continue;
        }
        pushAdd(n);
      }
      for (const n of this.addedSet) {
        if (!isAncestorInSet(this.droppedSet, n) && !isParentRemoved(this.removes, n, this.mirror)) {
          pushAdd(n);
        } else if (isAncestorInSet(this.movedSet, n)) {
          pushAdd(n);
        } else {
          this.droppedSet.add(n);
        }
      }
      let candidate = null;
      while (addList.length) {
        let node = null;
        if (candidate) {
          const parentId = this.mirror.getId(candidate.value.parentNode);
          const nextId = getNextId(candidate.value);
          if (parentId !== -1 && nextId !== -1) {
            node = candidate;
          }
        }
        if (!node) {
          let tailNode = addList.tail;
          while (tailNode) {
            const _node = tailNode;
            tailNode = tailNode.previous;
            if (_node) {
              const parentId = this.mirror.getId(_node.value.parentNode);
              const nextId = getNextId(_node.value);
              if (nextId === -1) continue;else if (parentId !== -1) {
                node = _node;
                break;
              } else {
                const unhandledNode = _node.value;
                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  const shadowHost = unhandledNode.parentNode.host;
                  const parentId = this.mirror.getId(shadowHost);
                  if (parentId !== -1) {
                    node = _node;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!node) {
          while (addList.head) {
            addList.removeNode(addList.head.value);
          }
          break;
        }
        candidate = node.previous;
        addList.removeNode(node.value);
        pushAdd(node.value);
      }
      const payload = {
        texts: this.texts.map(text => ({
          id: this.mirror.getId(text.node),
          value: text.value
        })).filter(text => !addedIds.has(text.id)).filter(text => this.mirror.has(text.id)),
        attributes: this.attributes.map(attribute => {
          const {
            attributes
          } = attribute;
          if (typeof attributes.style === 'string') {
            const diffAsStr = JSON.stringify(attribute.styleDiff);
            const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
            if (diffAsStr.length < attributes.style.length) {
              if ((diffAsStr + unchangedAsStr).split('var(').length === attributes.style.split('var(').length) {
                attributes.style = attribute.styleDiff;
              }
            }
          }
          return {
            id: this.mirror.getId(attribute.node),
            attributes: attributes
          };
        }).filter(attribute => !addedIds.has(attribute.id)).filter(attribute => this.mirror.has(attribute.id)),
        removes: this.removes,
        adds
      };
      if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) {
        return;
      }
      this.texts = [];
      this.attributes = [];
      this.attributeMap = new WeakMap();
      this.removes = [];
      this.addedSet = new Set();
      this.movedSet = new Set();
      this.droppedSet = new Set();
      this.movedMap = {};
      this.mutationCb(payload);
    };
    this.processMutation = m => {
      if (isIgnored(m.target, this.mirror)) {
        return;
      }
      switch (m.type) {
        case 'characterData':
          {
            const value = m.target.textContent;
            if (!isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) {
              this.texts.push({
                value: needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, closestElementOfNode(m.target)) : value.replace(/[\S]/g, '*') : value,
                node: m.target
              });
            }
            break;
          }
        case 'attributes':
          {
            const target = m.target;
            let attributeName = m.attributeName;
            let value = m.target.getAttribute(attributeName);
            if (attributeName === 'value') {
              const type = getInputType(target);
              const tagName = target.tagName;
              value = getInputValue(target, tagName, type);
              const isInputMasked = shouldMaskInput({
                maskInputOptions: this.maskInputOptions,
                tagName,
                type
              });
              const forceMask = needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
              value = maskInputValue({
                isMasked: forceMask,
                element: target,
                value,
                maskInputFn: this.maskInputFn
              });
            }
            if (isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) {
              return;
            }
            let item = this.attributeMap.get(m.target);
            if (target.tagName === 'IFRAME' && attributeName === 'src' && !this.keepIframeSrcFn(value)) {
              const iframeDoc = getIFrameContentDocument(target);
              if (!iframeDoc) {
                attributeName = 'rr_src';
              } else {
                return;
              }
            }
            if (!item) {
              item = {
                node: m.target,
                attributes: {},
                styleDiff: {},
                _unchangedStyles: {}
              };
              this.attributes.push(item);
              this.attributeMap.set(m.target, item);
            }
            if (attributeName === 'type' && target.tagName === 'INPUT' && (m.oldValue || '').toLowerCase() === 'password') {
              target.setAttribute('data-rr-is-password', 'true');
            }
            if (!ignoreAttribute(target.tagName, attributeName)) {
              item.attributes[attributeName] = transformAttribute(this.doc, toLowerCase(target.tagName), toLowerCase(attributeName), value, target, this.maskAttributeFn);
              if (attributeName === 'style') {
                if (!this.unattachedDoc) {
                  try {
                    this.unattachedDoc = document.implementation.createHTMLDocument();
                  } catch (e) {
                    this.unattachedDoc = this.doc;
                  }
                }
                const old = this.unattachedDoc.createElement('span');
                if (m.oldValue) {
                  old.setAttribute('style', m.oldValue);
                }
                for (const pname of Array.from(target.style)) {
                  const newValue = target.style.getPropertyValue(pname);
                  const newPriority = target.style.getPropertyPriority(pname);
                  if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                    if (newPriority === '') {
                      item.styleDiff[pname] = newValue;
                    } else {
                      item.styleDiff[pname] = [newValue, newPriority];
                    }
                  } else {
                    item._unchangedStyles[pname] = [newValue, newPriority];
                  }
                }
                for (const pname of Array.from(old.style)) {
                  if (target.style.getPropertyValue(pname) === '') {
                    item.styleDiff[pname] = false;
                  }
                }
              }
            }
            break;
          }
        case 'childList':
          {
            if (isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) {
              return;
            }
            m.addedNodes.forEach(n => this.genAdds(n, m.target));
            m.removedNodes.forEach(n => {
              const nodeId = this.mirror.getId(n);
              const parentId = isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
              if (isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || isIgnored(n, this.mirror) || !isSerialized(n, this.mirror)) {
                return;
              }
              if (this.addedSet.has(n)) {
                deepDelete(this.addedSet, n);
                this.droppedSet.add(n);
              } else if (this.addedSet.has(m.target) && nodeId === -1) ;else if (isAncestorRemoved(m.target, this.mirror)) ;else if (this.movedSet.has(n) && this.movedMap[moveKey(nodeId, parentId)]) {
                deepDelete(this.movedSet, n);
              } else {
                this.removes.push({
                  parentId,
                  id: nodeId,
                  isShadow: isShadowRoot(m.target) && isNativeShadowDom(m.target) ? true : undefined
                });
              }
              this.mapRemoves.push(n);
            });
            break;
          }
      }
    };
    this.genAdds = (n, target) => {
      if (this.processedNodeManager.inOtherBuffer(n, this)) return;
      if (this.addedSet.has(n) || this.movedSet.has(n)) return;
      if (this.mirror.hasNode(n)) {
        if (isIgnored(n, this.mirror)) {
          return;
        }
        this.movedSet.add(n);
        let targetId = null;
        if (target && this.mirror.hasNode(target)) {
          targetId = this.mirror.getId(target);
        }
        if (targetId && targetId !== -1) {
          this.movedMap[moveKey(this.mirror.getId(n), targetId)] = true;
        }
      } else {
        this.addedSet.add(n);
        this.droppedSet.delete(n);
      }
      if (!isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
        n.childNodes.forEach(childN => this.genAdds(childN));
        if (hasShadowRoot(n)) {
          n.shadowRoot.childNodes.forEach(childN => {
            this.processedNodeManager.add(childN, this);
            this.genAdds(childN, n);
          });
        }
      }
    };
  }
  init(options) {
    ['mutationCb', 'blockClass', 'blockSelector', 'unblockSelector', 'maskAllText', 'maskTextClass', 'unmaskTextClass', 'maskTextSelector', 'unmaskTextSelector', 'inlineStylesheet', 'maskInputOptions', 'maskAttributeFn', 'maskTextFn', 'maskInputFn', 'keepIframeSrcFn', 'recordCanvas', 'inlineImages', 'slimDOMOptions', 'dataURLOptions', 'doc', 'mirror', 'iframeManager', 'stylesheetManager', 'shadowDomManager', 'canvasManager', 'processedNodeManager'].forEach(key => {
      this[key] = options[key];
    });
  }
  freeze() {
    this.frozen = true;
    this.canvasManager.freeze();
  }
  unfreeze() {
    this.frozen = false;
    this.canvasManager.unfreeze();
    this.emit();
  }
  isFrozen() {
    return this.frozen;
  }
  lock() {
    this.locked = true;
    this.canvasManager.lock();
  }
  unlock() {
    this.locked = false;
    this.canvasManager.unlock();
    this.emit();
  }
  reset() {
    this.shadowDomManager.reset();
    this.canvasManager.reset();
  }
}
function deepDelete(addsSet, n) {
  addsSet.delete(n);
  n.childNodes.forEach(childN => deepDelete(addsSet, childN));
}
function isParentRemoved(removes, n, mirror) {
  if (removes.length === 0) return false;
  return _isParentRemoved(removes, n, mirror);
}
function _isParentRemoved(removes, n, mirror) {
  let node = n.parentNode;
  while (node) {
    const parentId = mirror.getId(node);
    if (removes.some(r => r.id === parentId)) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}
function isAncestorInSet(set, n) {
  if (set.size === 0) return false;
  return _isAncestorInSet(set, n);
}
function _isAncestorInSet(set, n) {
  const {
    parentNode
  } = n;
  if (!parentNode) {
    return false;
  }
  if (set.has(parentNode)) {
    return true;
  }
  return _isAncestorInSet(set, parentNode);
}
let errorHandler;
function registerErrorHandler(handler) {
  errorHandler = handler;
}
function unregisterErrorHandler() {
  errorHandler = undefined;
}
const callbackWrapper = cb => {
  if (!errorHandler) {
    return cb;
  }
  const rrwebWrapped = (...rest) => {
    try {
      return cb(...rest);
    } catch (error) {
      if (errorHandler && errorHandler(error) === true) {
        return () => {};
      }
      throw error;
    }
  };
  return rrwebWrapped;
};
function _optionalChain$2(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i];
    const fn = ops[i + 1];
    i += 2;
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => value.call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}
const mutationBuffers = [];
function getEventTarget(event) {
  try {
    if ('composedPath' in event) {
      const path = event.composedPath();
      if (path.length) {
        return path[0];
      }
    } else if ('path' in event && event.path.length) {
      return event.path[0];
    }
  } catch (e2) {}
  return event && event.target;
}
function initMutationObserver(options, rootEl) {
  const mutationBuffer = new MutationBuffer();
  mutationBuffers.push(mutationBuffer);
  mutationBuffer.init(options);
  let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
  const angularZoneSymbol = _optionalChain$2([window, 'optionalAccess', _ => _.Zone, 'optionalAccess', _2 => _2.__symbol__, 'optionalCall', _3 => _3('MutationObserver')]);
  if (angularZoneSymbol && window[angularZoneSymbol]) {
    mutationObserverCtor = window[angularZoneSymbol];
  }
  const observer = new mutationObserverCtor(callbackWrapper(mutations => {
    if (options.onMutation && options.onMutation(mutations) === false) {
      return;
    }
    mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
  }));
  observer.observe(rootEl, {
    attributes: true,
    attributeOldValue: true,
    characterData: true,
    characterDataOldValue: true,
    childList: true,
    subtree: true
  });
  return observer;
}
function initMoveObserver({
  mousemoveCb,
  sampling,
  doc,
  mirror
}) {
  if (sampling.mousemove === false) {
    return () => {};
  }
  const threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
  const callbackThreshold = typeof sampling.mousemoveCallback === 'number' ? sampling.mousemoveCallback : 500;
  let positions = [];
  let timeBaseline;
  const wrappedCb = throttle$1(callbackWrapper(source => {
    const totalOffset = Date.now() - timeBaseline;
    mousemoveCb(positions.map(p => {
      p.timeOffset -= totalOffset;
      return p;
    }), source);
    positions = [];
    timeBaseline = null;
  }), callbackThreshold);
  const updatePosition = callbackWrapper(throttle$1(callbackWrapper(evt => {
    const target = getEventTarget(evt);
    const {
      clientX,
      clientY
    } = legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
    if (!timeBaseline) {
      timeBaseline = nowTimestamp();
    }
    positions.push({
      x: clientX,
      y: clientY,
      id: mirror.getId(target),
      timeOffset: nowTimestamp() - timeBaseline
    });
    wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent ? IncrementalSource.Drag : evt instanceof MouseEvent ? IncrementalSource.MouseMove : IncrementalSource.TouchMove);
  }), threshold, {
    trailing: false
  }));
  const handlers = [on('mousemove', updatePosition, doc), on('touchmove', updatePosition, doc), on('drag', updatePosition, doc)];
  return callbackWrapper(() => {
    handlers.forEach(h => h());
  });
}
function initMouseInteractionObserver({
  mouseInteractionCb,
  doc,
  mirror,
  blockClass,
  blockSelector,
  unblockSelector,
  sampling
}) {
  if (sampling.mouseInteraction === false) {
    return () => {};
  }
  const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
  const handlers = [];
  let currentPointerType = null;
  const getHandler = eventKey => {
    return event => {
      const target = getEventTarget(event);
      if (isBlocked(target, blockClass, blockSelector, unblockSelector, true)) {
        return;
      }
      let pointerType = null;
      let thisEventKey = eventKey;
      if ('pointerType' in event) {
        switch (event.pointerType) {
          case 'mouse':
            pointerType = PointerTypes.Mouse;
            break;
          case 'touch':
            pointerType = PointerTypes.Touch;
            break;
          case 'pen':
            pointerType = PointerTypes.Pen;
            break;
        }
        if (pointerType === PointerTypes.Touch) {
          if (MouseInteractions[eventKey] === MouseInteractions.MouseDown) {
            thisEventKey = 'TouchStart';
          } else if (MouseInteractions[eventKey] === MouseInteractions.MouseUp) {
            thisEventKey = 'TouchEnd';
          }
        } else if (pointerType === PointerTypes.Pen) ;
      } else if (legacy_isTouchEvent(event)) {
        pointerType = PointerTypes.Touch;
      }
      if (pointerType !== null) {
        currentPointerType = pointerType;
        if (thisEventKey.startsWith('Touch') && pointerType === PointerTypes.Touch || thisEventKey.startsWith('Mouse') && pointerType === PointerTypes.Mouse) {
          pointerType = null;
        }
      } else if (MouseInteractions[eventKey] === MouseInteractions.Click) {
        pointerType = currentPointerType;
        currentPointerType = null;
      }
      const e = legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
      if (!e) {
        return;
      }
      const id = mirror.getId(target);
      const {
        clientX,
        clientY
      } = e;
      callbackWrapper(mouseInteractionCb)({
        type: MouseInteractions[thisEventKey],
        id,
        x: clientX,
        y: clientY,
        ...(pointerType !== null && {
          pointerType
        })
      });
    };
  };
  Object.keys(MouseInteractions).filter(key => Number.isNaN(Number(key)) && !key.endsWith('_Departed') && disableMap[key] !== false).forEach(eventKey => {
    let eventName = toLowerCase(eventKey);
    const handler = getHandler(eventKey);
    if (window.PointerEvent) {
      switch (MouseInteractions[eventKey]) {
        case MouseInteractions.MouseDown:
        case MouseInteractions.MouseUp:
          eventName = eventName.replace('mouse', 'pointer');
          break;
        case MouseInteractions.TouchStart:
        case MouseInteractions.TouchEnd:
          return;
      }
    }
    handlers.push(on(eventName, handler, doc));
  });
  return callbackWrapper(() => {
    handlers.forEach(h => h());
  });
}
function initScrollObserver({
  scrollCb,
  doc,
  mirror,
  blockClass,
  blockSelector,
  unblockSelector,
  sampling
}) {
  const updatePosition = callbackWrapper(throttle$1(callbackWrapper(evt => {
    const target = getEventTarget(evt);
    if (!target || isBlocked(target, blockClass, blockSelector, unblockSelector, true)) {
      return;
    }
    const id = mirror.getId(target);
    if (target === doc && doc.defaultView) {
      const scrollLeftTop = getWindowScroll(doc.defaultView);
      scrollCb({
        id,
        x: scrollLeftTop.left,
        y: scrollLeftTop.top
      });
    } else {
      scrollCb({
        id,
        x: target.scrollLeft,
        y: target.scrollTop
      });
    }
  }), sampling.scroll || 100));
  return on('scroll', updatePosition, doc);
}
function initViewportResizeObserver({
  viewportResizeCb
}, {
  win
}) {
  let lastH = -1;
  let lastW = -1;
  const updateDimension = callbackWrapper(throttle$1(callbackWrapper(() => {
    const height = getWindowHeight();
    const width = getWindowWidth();
    if (lastH !== height || lastW !== width) {
      viewportResizeCb({
        width: Number(width),
        height: Number(height)
      });
      lastH = height;
      lastW = width;
    }
  }), 200));
  return on('resize', updateDimension, win);
}
const INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];
const lastInputValueMap = new WeakMap();
function initInputObserver({
  inputCb,
  doc,
  mirror,
  blockClass,
  blockSelector,
  unblockSelector,
  ignoreClass,
  ignoreSelector,
  maskInputOptions,
  maskInputFn,
  sampling,
  userTriggeredOnInput,
  maskTextClass,
  unmaskTextClass,
  maskTextSelector,
  unmaskTextSelector
}) {
  function eventHandler(event) {
    let target = getEventTarget(event);
    const userTriggered = event.isTrusted;
    const tagName = target && toUpperCase(target.tagName);
    if (tagName === 'OPTION') target = target.parentElement;
    if (!target || !tagName || INPUT_TAGS.indexOf(tagName) < 0 || isBlocked(target, blockClass, blockSelector, unblockSelector, true)) {
      return;
    }
    const el = target;
    if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) {
      return;
    }
    const type = getInputType(target);
    let text = getInputValue(el, tagName, type);
    let isChecked = false;
    const isInputMasked = shouldMaskInput({
      maskInputOptions,
      tagName,
      type
    });
    const forceMask = needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
    if (type === 'radio' || type === 'checkbox') {
      isChecked = target.checked;
    }
    text = maskInputValue({
      isMasked: forceMask,
      element: target,
      value: text,
      maskInputFn
    });
    cbWithDedup(target, userTriggeredOnInput ? {
      text,
      isChecked,
      userTriggered
    } : {
      text,
      isChecked
    });
    const name = target.name;
    if (type === 'radio' && name && isChecked) {
      doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach(el => {
        if (el !== target) {
          const text = maskInputValue({
            isMasked: forceMask,
            element: el,
            value: getInputValue(el, tagName, type),
            maskInputFn
          });
          cbWithDedup(el, userTriggeredOnInput ? {
            text,
            isChecked: !isChecked,
            userTriggered: false
          } : {
            text,
            isChecked: !isChecked
          });
        }
      });
    }
  }
  function cbWithDedup(target, v) {
    const lastInputValue = lastInputValueMap.get(target);
    if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
      lastInputValueMap.set(target, v);
      const id = mirror.getId(target);
      callbackWrapper(inputCb)({
        ...v,
        id
      });
    }
  }
  const events = sampling.input === 'last' ? ['change'] : ['input', 'change'];
  const handlers = events.map(eventName => on(eventName, callbackWrapper(eventHandler), doc));
  const currentWindow = doc.defaultView;
  if (!currentWindow) {
    return () => {
      handlers.forEach(h => h());
    };
  }
  const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, 'value');
  const hookProperties = [[currentWindow.HTMLInputElement.prototype, 'value'], [currentWindow.HTMLInputElement.prototype, 'checked'], [currentWindow.HTMLSelectElement.prototype, 'value'], [currentWindow.HTMLTextAreaElement.prototype, 'value'], [currentWindow.HTMLSelectElement.prototype, 'selectedIndex'], [currentWindow.HTMLOptionElement.prototype, 'selected']];
  if (propertyDescriptor && propertyDescriptor.set) {
    handlers.push(...hookProperties.map(p => hookSetter(p[0], p[1], {
      set() {
        callbackWrapper(eventHandler)({
          target: this,
          isTrusted: false
        });
      }
    }, false, currentWindow)));
  }
  return callbackWrapper(() => {
    handlers.forEach(h => h());
  });
}
function getNestedCSSRulePositions(rule) {
  const positions = [];
  function recurse(childRule, pos) {
    if (hasNestedCSSRule('CSSGroupingRule') && childRule.parentRule instanceof CSSGroupingRule || hasNestedCSSRule('CSSMediaRule') && childRule.parentRule instanceof CSSMediaRule || hasNestedCSSRule('CSSSupportsRule') && childRule.parentRule instanceof CSSSupportsRule || hasNestedCSSRule('CSSConditionRule') && childRule.parentRule instanceof CSSConditionRule) {
      const rules = Array.from(childRule.parentRule.cssRules);
      const index = rules.indexOf(childRule);
      pos.unshift(index);
    } else if (childRule.parentStyleSheet) {
      const rules = Array.from(childRule.parentStyleSheet.cssRules);
      const index = rules.indexOf(childRule);
      pos.unshift(index);
    }
    return pos;
  }
  return recurse(rule, positions);
}
function getIdAndStyleId(sheet, mirror, styleMirror) {
  let id, styleId;
  if (!sheet) return {};
  if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);else styleId = styleMirror.getId(sheet);
  return {
    styleId,
    id
  };
}
function initStyleSheetObserver({
  styleSheetRuleCb,
  mirror,
  stylesheetManager
}, {
  win
}) {
  if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) {
    return () => {};
  }
  const insertRule = win.CSSStyleSheet.prototype.insertRule;
  win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
    apply: callbackWrapper((target, thisArg, argumentsList) => {
      const [rule, index] = argumentsList;
      const {
        id,
        styleId
      } = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
      if (id && id !== -1 || styleId && styleId !== -1) {
        styleSheetRuleCb({
          id,
          styleId,
          adds: [{
            rule,
            index
          }]
        });
      }
      return target.apply(thisArg, argumentsList);
    })
  });
  const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
  win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
    apply: callbackWrapper((target, thisArg, argumentsList) => {
      const [index] = argumentsList;
      const {
        id,
        styleId
      } = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
      if (id && id !== -1 || styleId && styleId !== -1) {
        styleSheetRuleCb({
          id,
          styleId,
          removes: [{
            index
          }]
        });
      }
      return target.apply(thisArg, argumentsList);
    })
  });
  let replace;
  if (win.CSSStyleSheet.prototype.replace) {
    replace = win.CSSStyleSheet.prototype.replace;
    win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
      apply: callbackWrapper((target, thisArg, argumentsList) => {
        const [text] = argumentsList;
        const {
          id,
          styleId
        } = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id,
            styleId,
            replace: text
          });
        }
        return target.apply(thisArg, argumentsList);
      })
    });
  }
  let replaceSync;
  if (win.CSSStyleSheet.prototype.replaceSync) {
    replaceSync = win.CSSStyleSheet.prototype.replaceSync;
    win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
      apply: callbackWrapper((target, thisArg, argumentsList) => {
        const [text] = argumentsList;
        const {
          id,
          styleId
        } = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id,
            styleId,
            replaceSync: text
          });
        }
        return target.apply(thisArg, argumentsList);
      })
    });
  }
  const supportedNestedCSSRuleTypes = {};
  if (canMonkeyPatchNestedCSSRule('CSSGroupingRule')) {
    supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
  } else {
    if (canMonkeyPatchNestedCSSRule('CSSMediaRule')) {
      supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
    }
    if (canMonkeyPatchNestedCSSRule('CSSConditionRule')) {
      supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
    }
    if (canMonkeyPatchNestedCSSRule('CSSSupportsRule')) {
      supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
  }
  const unmodifiedFunctions = {};
  Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type]) => {
    unmodifiedFunctions[typeKey] = {
      insertRule: type.prototype.insertRule,
      deleteRule: type.prototype.deleteRule
    };
    type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
      apply: callbackWrapper((target, thisArg, argumentsList) => {
        const [rule, index] = argumentsList;
        const {
          id,
          styleId
        } = getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id,
            styleId,
            adds: [{
              rule,
              index: [...getNestedCSSRulePositions(thisArg), index || 0]
            }]
          });
        }
        return target.apply(thisArg, argumentsList);
      })
    });
    type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
      apply: callbackWrapper((target, thisArg, argumentsList) => {
        const [index] = argumentsList;
        const {
          id,
          styleId
        } = getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id,
            styleId,
            removes: [{
              index: [...getNestedCSSRulePositions(thisArg), index]
            }]
          });
        }
        return target.apply(thisArg, argumentsList);
      })
    });
  });
  return callbackWrapper(() => {
    win.CSSStyleSheet.prototype.insertRule = insertRule;
    win.CSSStyleSheet.prototype.deleteRule = deleteRule;
    replace && (win.CSSStyleSheet.prototype.replace = replace);
    replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type]) => {
      type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
      type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
    });
  });
}
function initAdoptedStyleSheetObserver({
  mirror,
  stylesheetManager
}, host) {
  let hostId = null;
  if (host.nodeName === '#document') hostId = mirror.getId(host);else hostId = mirror.getId(host.host);
  const patchTarget = host.nodeName === '#document' ? _optionalChain$2([host, 'access', _4 => _4.defaultView, 'optionalAccess', _5 => _5.Document]) : _optionalChain$2([host, 'access', _6 => _6.ownerDocument, 'optionalAccess', _7 => _7.defaultView, 'optionalAccess', _8 => _8.ShadowRoot]);
  const originalPropertyDescriptor = _optionalChain$2([patchTarget, 'optionalAccess', _9 => _9.prototype]) ? Object.getOwnPropertyDescriptor(_optionalChain$2([patchTarget, 'optionalAccess', _10 => _10.prototype]), 'adoptedStyleSheets') : undefined;
  if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return () => {};
  Object.defineProperty(host, 'adoptedStyleSheets', {
    configurable: originalPropertyDescriptor.configurable,
    enumerable: originalPropertyDescriptor.enumerable,
    get() {
      return _optionalChain$2([originalPropertyDescriptor, 'access', _11 => _11.get, 'optionalAccess', _12 => _12.call, 'call', _13 => _13(this)]);
    },
    set(sheets) {
      const result = _optionalChain$2([originalPropertyDescriptor, 'access', _14 => _14.set, 'optionalAccess', _15 => _15.call, 'call', _16 => _16(this, sheets)]);
      if (hostId !== null && hostId !== -1) {
        try {
          stylesheetManager.adoptStyleSheets(sheets, hostId);
        } catch (e) {}
      }
      return result;
    }
  });
  return callbackWrapper(() => {
    Object.defineProperty(host, 'adoptedStyleSheets', {
      configurable: originalPropertyDescriptor.configurable,
      enumerable: originalPropertyDescriptor.enumerable,
      get: originalPropertyDescriptor.get,
      set: originalPropertyDescriptor.set
    });
  });
}
function initStyleDeclarationObserver({
  styleDeclarationCb,
  mirror,
  ignoreCSSAttributes,
  stylesheetManager
}, {
  win
}) {
  const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
  win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
    apply: callbackWrapper((target, thisArg, argumentsList) => {
      const [property, value, priority] = argumentsList;
      if (ignoreCSSAttributes.has(property)) {
        return setProperty.apply(thisArg, [property, value, priority]);
      }
      const {
        id,
        styleId
      } = getIdAndStyleId(_optionalChain$2([thisArg, 'access', _17 => _17.parentRule, 'optionalAccess', _18 => _18.parentStyleSheet]), mirror, stylesheetManager.styleMirror);
      if (id && id !== -1 || styleId && styleId !== -1) {
        styleDeclarationCb({
          id,
          styleId,
          set: {
            property,
            value,
            priority
          },
          index: getNestedCSSRulePositions(thisArg.parentRule)
        });
      }
      return target.apply(thisArg, argumentsList);
    })
  });
  const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
  win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
    apply: callbackWrapper((target, thisArg, argumentsList) => {
      const [property] = argumentsList;
      if (ignoreCSSAttributes.has(property)) {
        return removeProperty.apply(thisArg, [property]);
      }
      const {
        id,
        styleId
      } = getIdAndStyleId(_optionalChain$2([thisArg, 'access', _19 => _19.parentRule, 'optionalAccess', _20 => _20.parentStyleSheet]), mirror, stylesheetManager.styleMirror);
      if (id && id !== -1 || styleId && styleId !== -1) {
        styleDeclarationCb({
          id,
          styleId,
          remove: {
            property
          },
          index: getNestedCSSRulePositions(thisArg.parentRule)
        });
      }
      return target.apply(thisArg, argumentsList);
    })
  });
  return callbackWrapper(() => {
    win.CSSStyleDeclaration.prototype.setProperty = setProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
  });
}
function initMediaInteractionObserver({
  mediaInteractionCb,
  blockClass,
  blockSelector,
  unblockSelector,
  mirror,
  sampling,
  doc
}) {
  const handler = callbackWrapper(type => throttle$1(callbackWrapper(event => {
    const target = getEventTarget(event);
    if (!target || isBlocked(target, blockClass, blockSelector, unblockSelector, true)) {
      return;
    }
    const {
      currentTime,
      volume,
      muted,
      playbackRate
    } = target;
    mediaInteractionCb({
      type,
      id: mirror.getId(target),
      currentTime,
      volume,
      muted,
      playbackRate
    });
  }), sampling.media || 500));
  const handlers = [on('play', handler(0), doc), on('pause', handler(1), doc), on('seeked', handler(2), doc), on('volumechange', handler(3), doc), on('ratechange', handler(4), doc)];
  return callbackWrapper(() => {
    handlers.forEach(h => h());
  });
}
function initFontObserver({
  fontCb,
  doc
}) {
  const win = doc.defaultView;
  if (!win) {
    return () => {};
  }
  const handlers = [];
  const fontMap = new WeakMap();
  const originalFontFace = win.FontFace;
  win.FontFace = function FontFace(family, source, descriptors) {
    const fontFace = new originalFontFace(family, source, descriptors);
    fontMap.set(fontFace, {
      family,
      buffer: typeof source !== 'string',
      descriptors,
      fontSource: typeof source === 'string' ? source : JSON.stringify(Array.from(new Uint8Array(source)))
    });
    return fontFace;
  };
  const restoreHandler = patch(doc.fonts, 'add', function (original) {
    return function (fontFace) {
      setTimeout$1(callbackWrapper(() => {
        const p = fontMap.get(fontFace);
        if (p) {
          fontCb(p);
          fontMap.delete(fontFace);
        }
      }), 0);
      return original.apply(this, [fontFace]);
    };
  });
  handlers.push(() => {
    win.FontFace = originalFontFace;
  });
  handlers.push(restoreHandler);
  return callbackWrapper(() => {
    handlers.forEach(h => h());
  });
}
function initSelectionObserver(param) {
  const {
    doc,
    mirror,
    blockClass,
    blockSelector,
    unblockSelector,
    selectionCb
  } = param;
  let collapsed = true;
  const updateSelection = callbackWrapper(() => {
    const selection = doc.getSelection();
    if (!selection || collapsed && _optionalChain$2([selection, 'optionalAccess', _21 => _21.isCollapsed])) return;
    collapsed = selection.isCollapsed || false;
    const ranges = [];
    const count = selection.rangeCount || 0;
    for (let i = 0; i < count; i++) {
      const range = selection.getRangeAt(i);
      const {
        startContainer,
        startOffset,
        endContainer,
        endOffset
      } = range;
      const blocked = isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
      if (blocked) continue;
      ranges.push({
        start: mirror.getId(startContainer),
        startOffset,
        end: mirror.getId(endContainer),
        endOffset
      });
    }
    selectionCb({
      ranges
    });
  });
  updateSelection();
  return on('selectionchange', updateSelection);
}
function initCustomElementObserver({
  doc,
  customElementCb
}) {
  const win = doc.defaultView;
  if (!win || !win.customElements) return () => {};
  const restoreHandler = patch(win.customElements, 'define', function (original) {
    return function (name, constructor, options) {
      try {
        customElementCb({
          define: {
            name
          }
        });
      } catch (e) {}
      return original.apply(this, [name, constructor, options]);
    };
  });
  return restoreHandler;
}
function initObservers(o, _hooks = {}) {
  const currentWindow = o.doc.defaultView;
  if (!currentWindow) {
    return () => {};
  }
  let mutationObserver;
  if (o.recordDOM) {
    mutationObserver = initMutationObserver(o, o.doc);
  }
  const mousemoveHandler = initMoveObserver(o);
  const mouseInteractionHandler = initMouseInteractionObserver(o);
  const scrollHandler = initScrollObserver(o);
  const viewportResizeHandler = initViewportResizeObserver(o, {
    win: currentWindow
  });
  const inputHandler = initInputObserver(o);
  const mediaInteractionHandler = initMediaInteractionObserver(o);
  let styleSheetObserver = () => {};
  let adoptedStyleSheetObserver = () => {};
  let styleDeclarationObserver = () => {};
  let fontObserver = () => {};
  if (o.recordDOM) {
    styleSheetObserver = initStyleSheetObserver(o, {
      win: currentWindow
    });
    adoptedStyleSheetObserver = initAdoptedStyleSheetObserver(o, o.doc);
    styleDeclarationObserver = initStyleDeclarationObserver(o, {
      win: currentWindow
    });
    if (o.collectFonts) {
      fontObserver = initFontObserver(o);
    }
  }
  const selectionObserver = initSelectionObserver(o);
  const customElementObserver = initCustomElementObserver(o);
  const pluginHandlers = [];
  for (const plugin of o.plugins) {
    pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
  }
  return callbackWrapper(() => {
    mutationBuffers.forEach(b => b.reset());
    _optionalChain$2([mutationObserver, 'optionalAccess', _22 => _22.disconnect, 'call', _23 => _23()]);
    mousemoveHandler();
    mouseInteractionHandler();
    scrollHandler();
    viewportResizeHandler();
    inputHandler();
    mediaInteractionHandler();
    styleSheetObserver();
    adoptedStyleSheetObserver();
    styleDeclarationObserver();
    fontObserver();
    selectionObserver();
    customElementObserver();
    pluginHandlers.forEach(h => h());
  });
}
function hasNestedCSSRule(prop) {
  return typeof window[prop] !== 'undefined';
}
function canMonkeyPatchNestedCSSRule(prop) {
  return Boolean(typeof window[prop] !== 'undefined' && window[prop].prototype && 'insertRule' in window[prop].prototype && 'deleteRule' in window[prop].prototype);
}
class CrossOriginIframeMirror {
  constructor(generateIdFn) {
    this.generateIdFn = generateIdFn;
    this.iframeIdToRemoteIdMap = new WeakMap();
    this.iframeRemoteIdToIdMap = new WeakMap();
  }
  getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
    const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
    const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
    let id = idToRemoteIdMap.get(remoteId);
    if (!id) {
      id = this.generateIdFn();
      idToRemoteIdMap.set(remoteId, id);
      remoteIdToIdMap.set(id, remoteId);
    }
    return id;
  }
  getIds(iframe, remoteId) {
    const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
    const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
    return remoteId.map(id => this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
  }
  getRemoteId(iframe, id, map) {
    const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
    if (typeof id !== 'number') return id;
    const remoteId = remoteIdToIdMap.get(id);
    if (!remoteId) return -1;
    return remoteId;
  }
  getRemoteIds(iframe, ids) {
    const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
    return ids.map(id => this.getRemoteId(iframe, id, remoteIdToIdMap));
  }
  reset(iframe) {
    if (!iframe) {
      this.iframeIdToRemoteIdMap = new WeakMap();
      this.iframeRemoteIdToIdMap = new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(iframe);
    this.iframeRemoteIdToIdMap.delete(iframe);
  }
  getIdToRemoteIdMap(iframe) {
    let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
    if (!idToRemoteIdMap) {
      idToRemoteIdMap = new Map();
      this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
    }
    return idToRemoteIdMap;
  }
  getRemoteIdToIdMap(iframe) {
    let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
    if (!remoteIdToIdMap) {
      remoteIdToIdMap = new Map();
      this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
    }
    return remoteIdToIdMap;
  }
}
function _optionalChain$1(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i];
    const fn = ops[i + 1];
    i += 2;
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => value.call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}
class IframeManagerNoop {
  constructor() {
    this.crossOriginIframeMirror = new CrossOriginIframeMirror(genId);
    this.crossOriginIframeRootIdMap = new WeakMap();
  }
  addIframe() {}
  addLoadListener() {}
  attachIframe() {}
}
class IframeManager {
  constructor(options) {
    this.iframes = new WeakMap();
    this.crossOriginIframeMap = new WeakMap();
    this.crossOriginIframeMirror = new CrossOriginIframeMirror(genId);
    this.crossOriginIframeRootIdMap = new WeakMap();
    this.mutationCb = options.mutationCb;
    this.wrappedEmit = options.wrappedEmit;
    this.stylesheetManager = options.stylesheetManager;
    this.recordCrossOriginIframes = options.recordCrossOriginIframes;
    this.crossOriginIframeStyleMirror = new CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
    this.mirror = options.mirror;
    if (this.recordCrossOriginIframes) {
      window.addEventListener('message', this.handleMessage.bind(this));
    }
  }
  addIframe(iframeEl) {
    this.iframes.set(iframeEl, true);
    if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
  }
  addLoadListener(cb) {
    this.loadListener = cb;
  }
  attachIframe(iframeEl, childSn) {
    this.mutationCb({
      adds: [{
        parentId: this.mirror.getId(iframeEl),
        nextId: null,
        node: childSn
      }],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: true
    });
    _optionalChain$1([this, 'access', _ => _.loadListener, 'optionalCall', _2 => _2(iframeEl)]);
    const iframeDoc = getIFrameContentDocument(iframeEl);
    if (iframeDoc && iframeDoc.adoptedStyleSheets && iframeDoc.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeDoc.adoptedStyleSheets, this.mirror.getId(iframeDoc));
  }
  handleMessage(message) {
    const crossOriginMessageEvent = message;
    if (crossOriginMessageEvent.data.type !== 'rrweb' || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
    const iframeSourceWindow = message.source;
    if (!iframeSourceWindow) return;
    const iframeEl = this.crossOriginIframeMap.get(message.source);
    if (!iframeEl) return;
    const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
    if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
  }
  transformCrossOriginEvent(iframeEl, e) {
    switch (e.type) {
      case EventType.FullSnapshot:
        {
          this.crossOriginIframeMirror.reset(iframeEl);
          this.crossOriginIframeStyleMirror.reset(iframeEl);
          this.replaceIdOnNode(e.data.node, iframeEl);
          const rootId = e.data.node.id;
          this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
          this.patchRootIdOnNode(e.data.node, rootId);
          return {
            timestamp: e.timestamp,
            type: EventType.IncrementalSnapshot,
            data: {
              source: IncrementalSource.Mutation,
              adds: [{
                parentId: this.mirror.getId(iframeEl),
                nextId: null,
                node: e.data.node
              }],
              removes: [],
              texts: [],
              attributes: [],
              isAttachIframe: true
            }
          };
        }
      case EventType.Meta:
      case EventType.Load:
      case EventType.DomContentLoaded:
        {
          return false;
        }
      case EventType.Plugin:
        {
          return e;
        }
      case EventType.Custom:
        {
          this.replaceIds(e.data.payload, iframeEl, ['id', 'parentId', 'previousId', 'nextId']);
          return e;
        }
      case EventType.IncrementalSnapshot:
        {
          switch (e.data.source) {
            case IncrementalSource.Mutation:
              {
                e.data.adds.forEach(n => {
                  this.replaceIds(n, iframeEl, ['parentId', 'nextId', 'previousId']);
                  this.replaceIdOnNode(n.node, iframeEl);
                  const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                  rootId && this.patchRootIdOnNode(n.node, rootId);
                });
                e.data.removes.forEach(n => {
                  this.replaceIds(n, iframeEl, ['parentId', 'id']);
                });
                e.data.attributes.forEach(n => {
                  this.replaceIds(n, iframeEl, ['id']);
                });
                e.data.texts.forEach(n => {
                  this.replaceIds(n, iframeEl, ['id']);
                });
                return e;
              }
            case IncrementalSource.Drag:
            case IncrementalSource.TouchMove:
            case IncrementalSource.MouseMove:
              {
                e.data.positions.forEach(p => {
                  this.replaceIds(p, iframeEl, ['id']);
                });
                return e;
              }
            case IncrementalSource.ViewportResize:
              {
                return false;
              }
            case IncrementalSource.MediaInteraction:
            case IncrementalSource.MouseInteraction:
            case IncrementalSource.Scroll:
            case IncrementalSource.CanvasMutation:
            case IncrementalSource.Input:
              {
                this.replaceIds(e.data, iframeEl, ['id']);
                return e;
              }
            case IncrementalSource.StyleSheetRule:
            case IncrementalSource.StyleDeclaration:
              {
                this.replaceIds(e.data, iframeEl, ['id']);
                this.replaceStyleIds(e.data, iframeEl, ['styleId']);
                return e;
              }
            case IncrementalSource.Font:
              {
                return e;
              }
            case IncrementalSource.Selection:
              {
                e.data.ranges.forEach(range => {
                  this.replaceIds(range, iframeEl, ['start', 'end']);
                });
                return e;
              }
            case IncrementalSource.AdoptedStyleSheet:
              {
                this.replaceIds(e.data, iframeEl, ['id']);
                this.replaceStyleIds(e.data, iframeEl, ['styleIds']);
                _optionalChain$1([e, 'access', _3 => _3.data, 'access', _4 => _4.styles, 'optionalAccess', _5 => _5.forEach, 'call', _6 => _6(style => {
                  this.replaceStyleIds(style, iframeEl, ['styleId']);
                })]);
                return e;
              }
          }
        }
    }
    return false;
  }
  replace(iframeMirror, obj, iframeEl, keys) {
    for (const key of keys) {
      if (!Array.isArray(obj[key]) && typeof obj[key] !== 'number') continue;
      if (Array.isArray(obj[key])) {
        obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
      } else {
        obj[key] = iframeMirror.getId(iframeEl, obj[key]);
      }
    }
    return obj;
  }
  replaceIds(obj, iframeEl, keys) {
    return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
  }
  replaceStyleIds(obj, iframeEl, keys) {
    return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
  }
  replaceIdOnNode(node, iframeEl) {
    this.replaceIds(node, iframeEl, ['id', 'rootId']);
    if ('childNodes' in node) {
      node.childNodes.forEach(child => {
        this.replaceIdOnNode(child, iframeEl);
      });
    }
  }
  patchRootIdOnNode(node, rootId) {
    if (node.type !== NodeType$3.Document && !node.rootId) node.rootId = rootId;
    if ('childNodes' in node) {
      node.childNodes.forEach(child => {
        this.patchRootIdOnNode(child, rootId);
      });
    }
  }
}
class ShadowDomManagerNoop {
  init() {}
  addShadowRoot() {}
  observeAttachShadow() {}
  reset() {}
}
class ShadowDomManager {
  constructor(options) {
    this.shadowDoms = new WeakSet();
    this.restoreHandlers = [];
    this.mutationCb = options.mutationCb;
    this.scrollCb = options.scrollCb;
    this.bypassOptions = options.bypassOptions;
    this.mirror = options.mirror;
    this.init();
  }
  init() {
    this.reset();
    this.patchAttachShadow(Element, document);
  }
  addShadowRoot(shadowRoot, doc) {
    if (!isNativeShadowDom(shadowRoot)) return;
    if (this.shadowDoms.has(shadowRoot)) return;
    this.shadowDoms.add(shadowRoot);
    this.bypassOptions.canvasManager.addShadowRoot(shadowRoot);
    const observer = initMutationObserver({
      ...this.bypassOptions,
      doc,
      mutationCb: this.mutationCb,
      mirror: this.mirror,
      shadowDomManager: this
    }, shadowRoot);
    this.restoreHandlers.push(() => observer.disconnect());
    this.restoreHandlers.push(initScrollObserver({
      ...this.bypassOptions,
      scrollCb: this.scrollCb,
      doc: shadowRoot,
      mirror: this.mirror
    }));
    setTimeout$1(() => {
      if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
      this.restoreHandlers.push(initAdoptedStyleSheetObserver({
        mirror: this.mirror,
        stylesheetManager: this.bypassOptions.stylesheetManager
      }, shadowRoot));
    }, 0);
  }
  observeAttachShadow(iframeElement) {
    const iframeDoc = getIFrameContentDocument(iframeElement);
    const iframeWindow = getIFrameContentWindow(iframeElement);
    if (!iframeDoc || !iframeWindow) return;
    this.patchAttachShadow(iframeWindow.Element, iframeDoc);
  }
  patchAttachShadow(element, doc) {
    const manager = this;
    this.restoreHandlers.push(patch(element.prototype, 'attachShadow', function (original) {
      return function (option) {
        const shadowRoot = original.call(this, option);
        if (this.shadowRoot && inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
        return shadowRoot;
      };
    }));
  }
  reset() {
    this.restoreHandlers.forEach(handler => {
      try {
        handler();
      } catch (e) {}
    });
    this.restoreHandlers = [];
    this.shadowDoms = new WeakSet();
    this.bypassOptions.canvasManager.resetShadowRoots();
  }
}
class CanvasManagerNoop {
  reset() {}
  freeze() {}
  unfreeze() {}
  lock() {}
  unlock() {}
  snapshot() {}
  addWindow() {}
  addShadowRoot() {}
  resetShadowRoots() {}
}
class StylesheetManager {
  constructor(options) {
    this.trackedLinkElements = new WeakSet();
    this.styleMirror = new StyleSheetMirror();
    this.mutationCb = options.mutationCb;
    this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
  }
  attachLinkElement(linkEl, childSn) {
    if ('_cssText' in childSn.attributes) this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [{
        id: childSn.id,
        attributes: childSn.attributes
      }]
    });
    this.trackLinkElement(linkEl);
  }
  trackLinkElement(linkEl) {
    if (this.trackedLinkElements.has(linkEl)) return;
    this.trackedLinkElements.add(linkEl);
    this.trackStylesheetInLinkElement(linkEl);
  }
  adoptStyleSheets(sheets, hostId) {
    if (sheets.length === 0) return;
    const adoptedStyleSheetData = {
      id: hostId,
      styleIds: []
    };
    const styles = [];
    for (const sheet of sheets) {
      let styleId;
      if (!this.styleMirror.has(sheet)) {
        styleId = this.styleMirror.add(sheet);
        styles.push({
          styleId,
          rules: Array.from(sheet.rules || CSSRule, (r, index) => ({
            rule: stringifyRule(r),
            index
          }))
        });
      } else styleId = this.styleMirror.getId(sheet);
      adoptedStyleSheetData.styleIds.push(styleId);
    }
    if (styles.length > 0) adoptedStyleSheetData.styles = styles;
    this.adoptedStyleSheetCb(adoptedStyleSheetData);
  }
  reset() {
    this.styleMirror.reset();
    this.trackedLinkElements = new WeakSet();
  }
  trackStylesheetInLinkElement(linkEl) {}
}
class ProcessedNodeManager {
  constructor() {
    this.nodeMap = new WeakMap();
    this.active = false;
  }
  inOtherBuffer(node, thisBuffer) {
    const buffers = this.nodeMap.get(node);
    return buffers && Array.from(buffers).some(buffer => buffer !== thisBuffer);
  }
  add(node, buffer) {
    if (!this.active) {
      this.active = true;
      onRequestAnimationFrame(() => {
        this.nodeMap = new WeakMap();
        this.active = false;
      });
    }
    this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
  }
  destroy() {}
}
let wrappedEmit;
let _takeFullSnapshot;
try {
  if (Array.from([1], x => x * 2)[0] !== 2) {
    const cleanFrame = document.createElement('iframe');
    document.body.appendChild(cleanFrame);
    Array.from = _optionalChain([cleanFrame, 'access', _ => _.contentWindow, 'optionalAccess', _2 => _2.Array, 'access', _3 => _3.from]) || Array.from;
    document.body.removeChild(cleanFrame);
  }
} catch (err) {
  console.debug('Unable to override Array.from', err);
}
const mirror = createMirror();
function record(options = {}) {
  const {
    emit,
    checkoutEveryNms,
    checkoutEveryNth,
    blockClass = 'rr-block',
    blockSelector = null,
    unblockSelector = null,
    ignoreClass = 'rr-ignore',
    ignoreSelector = null,
    maskAllText = false,
    maskTextClass = 'rr-mask',
    unmaskTextClass = null,
    maskTextSelector = null,
    unmaskTextSelector = null,
    inlineStylesheet = true,
    maskAllInputs,
    maskInputOptions: _maskInputOptions,
    slimDOMOptions: _slimDOMOptions,
    maskAttributeFn,
    maskInputFn,
    maskTextFn,
    maxCanvasSize = null,
    packFn,
    sampling = {},
    dataURLOptions = {},
    mousemoveWait,
    recordDOM = true,
    recordCanvas = false,
    recordCrossOriginIframes = false,
    recordAfter = options.recordAfter === 'DOMContentLoaded' ? options.recordAfter : 'load',
    userTriggeredOnInput = false,
    collectFonts = false,
    inlineImages = false,
    plugins,
    keepIframeSrcFn = () => false,
    ignoreCSSAttributes = new Set([]),
    errorHandler,
    onMutation,
    getCanvasManager
  } = options;
  registerErrorHandler(errorHandler);
  const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
  let passEmitsToParent = false;
  if (!inEmittingFrame) {
    try {
      if (window.parent.document) {
        passEmitsToParent = false;
      }
    } catch (e) {
      passEmitsToParent = true;
    }
  }
  if (inEmittingFrame && !emit) {
    throw new Error('emit function is required');
  }
  if (!inEmittingFrame && !passEmitsToParent) {
    return () => {};
  }
  if (mousemoveWait !== undefined && sampling.mousemove === undefined) {
    sampling.mousemove = mousemoveWait;
  }
  mirror.reset();
  const maskInputOptions = maskAllInputs === true ? {
    color: true,
    date: true,
    'datetime-local': true,
    email: true,
    month: true,
    number: true,
    range: true,
    search: true,
    tel: true,
    text: true,
    time: true,
    url: true,
    week: true,
    textarea: true,
    select: true,
    radio: true,
    checkbox: true
  } : _maskInputOptions !== undefined ? _maskInputOptions : {};
  const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all' ? {
    script: true,
    comment: true,
    headFavicon: true,
    headWhitespace: true,
    headMetaSocial: true,
    headMetaRobots: true,
    headMetaHttpEquiv: true,
    headMetaVerification: true,
    headMetaAuthorship: _slimDOMOptions === 'all',
    headMetaDescKeywords: _slimDOMOptions === 'all'
  } : _slimDOMOptions ? _slimDOMOptions : {};
  polyfill();
  let lastFullSnapshotEvent;
  let incrementalSnapshotCount = 0;
  const eventProcessor = e => {
    for (const plugin of plugins || []) {
      if (plugin.eventProcessor) {
        e = plugin.eventProcessor(e);
      }
    }
    if (packFn && !passEmitsToParent) {
      e = packFn(e);
    }
    return e;
  };
  wrappedEmit = (r, isCheckout) => {
    const e = r;
    e.timestamp = nowTimestamp();
    if (_optionalChain([mutationBuffers, 'access', _4 => _4[0], 'optionalAccess', _5 => _5.isFrozen, 'call', _6 => _6()]) && e.type !== EventType.FullSnapshot && !(e.type === EventType.IncrementalSnapshot && e.data.source === IncrementalSource.Mutation)) {
      mutationBuffers.forEach(buf => buf.unfreeze());
    }
    if (inEmittingFrame) {
      _optionalChain([emit, 'optionalCall', _7 => _7(eventProcessor(e), isCheckout)]);
    } else if (passEmitsToParent) {
      const message = {
        type: 'rrweb',
        event: eventProcessor(e),
        origin: window.location.origin,
        isCheckout
      };
      window.parent.postMessage(message, '*');
    }
    if (e.type === EventType.FullSnapshot) {
      lastFullSnapshotEvent = e;
      incrementalSnapshotCount = 0;
    } else if (e.type === EventType.IncrementalSnapshot) {
      if (e.data.source === IncrementalSource.Mutation && e.data.isAttachIframe) {
        return;
      }
      incrementalSnapshotCount++;
      const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
      const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
      if (exceedCount || exceedTime) {
        takeFullSnapshot(true);
      }
    }
  };
  const wrappedMutationEmit = m => {
    wrappedEmit({
      type: EventType.IncrementalSnapshot,
      data: {
        source: IncrementalSource.Mutation,
        ...m
      }
    });
  };
  const wrappedScrollEmit = p => wrappedEmit({
    type: EventType.IncrementalSnapshot,
    data: {
      source: IncrementalSource.Scroll,
      ...p
    }
  });
  const wrappedCanvasMutationEmit = p => wrappedEmit({
    type: EventType.IncrementalSnapshot,
    data: {
      source: IncrementalSource.CanvasMutation,
      ...p
    }
  });
  const wrappedAdoptedStyleSheetEmit = a => wrappedEmit({
    type: EventType.IncrementalSnapshot,
    data: {
      source: IncrementalSource.AdoptedStyleSheet,
      ...a
    }
  });
  const stylesheetManager = new StylesheetManager({
    mutationCb: wrappedMutationEmit,
    adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
  });
  const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === 'boolean' && __RRWEB_EXCLUDE_IFRAME__ ? new IframeManagerNoop() : new IframeManager({
    mirror,
    mutationCb: wrappedMutationEmit,
    stylesheetManager: stylesheetManager,
    recordCrossOriginIframes,
    wrappedEmit
  });
  for (const plugin of plugins || []) {
    if (plugin.getMirror) plugin.getMirror({
      nodeMirror: mirror,
      crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
  }
  const processedNodeManager = new ProcessedNodeManager();
  const canvasManager = _getCanvasManager(getCanvasManager, {
    mirror,
    win: window,
    mutationCb: p => wrappedEmit({
      type: EventType.IncrementalSnapshot,
      data: {
        source: IncrementalSource.CanvasMutation,
        ...p
      }
    }),
    recordCanvas,
    blockClass,
    blockSelector,
    unblockSelector,
    maxCanvasSize,
    sampling: sampling['canvas'],
    dataURLOptions,
    errorHandler
  });
  const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === 'boolean' && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new ShadowDomManagerNoop() : new ShadowDomManager({
    mutationCb: wrappedMutationEmit,
    scrollCb: wrappedScrollEmit,
    bypassOptions: {
      onMutation,
      blockClass,
      blockSelector,
      unblockSelector,
      maskAllText,
      maskTextClass,
      unmaskTextClass,
      maskTextSelector,
      unmaskTextSelector,
      inlineStylesheet,
      maskInputOptions,
      dataURLOptions,
      maskAttributeFn,
      maskTextFn,
      maskInputFn,
      recordCanvas,
      inlineImages,
      sampling,
      slimDOMOptions,
      iframeManager,
      stylesheetManager,
      canvasManager,
      keepIframeSrcFn,
      processedNodeManager
    },
    mirror
  });
  const takeFullSnapshot = (isCheckout = false) => {
    if (!recordDOM) {
      return;
    }
    wrappedEmit({
      type: EventType.Meta,
      data: {
        href: window.location.href,
        width: getWindowWidth(),
        height: getWindowHeight()
      }
    }, isCheckout);
    stylesheetManager.reset();
    shadowDomManager.init();
    mutationBuffers.forEach(buf => buf.lock());
    const node = snapshot(document, {
      mirror,
      blockClass,
      blockSelector,
      unblockSelector,
      maskAllText,
      maskTextClass,
      unmaskTextClass,
      maskTextSelector,
      unmaskTextSelector,
      inlineStylesheet,
      maskAllInputs: maskInputOptions,
      maskAttributeFn,
      maskInputFn,
      maskTextFn,
      slimDOM: slimDOMOptions,
      dataURLOptions,
      recordCanvas,
      inlineImages,
      onSerialize: n => {
        if (isSerializedIframe(n, mirror)) {
          iframeManager.addIframe(n);
        }
        if (isSerializedStylesheet(n, mirror)) {
          stylesheetManager.trackLinkElement(n);
        }
        if (hasShadowRoot(n)) {
          shadowDomManager.addShadowRoot(n.shadowRoot, document);
        }
      },
      onIframeLoad: (iframe, childSn) => {
        iframeManager.attachIframe(iframe, childSn);
        if (iframe.contentWindow) {
          canvasManager.addWindow(iframe.contentWindow);
        }
        shadowDomManager.observeAttachShadow(iframe);
      },
      onStylesheetLoad: (linkEl, childSn) => {
        stylesheetManager.attachLinkElement(linkEl, childSn);
      },
      keepIframeSrcFn
    });
    if (!node) {
      return console.warn('Failed to snapshot the document');
    }
    wrappedEmit({
      type: EventType.FullSnapshot,
      data: {
        node,
        initialOffset: getWindowScroll(window)
      }
    });
    mutationBuffers.forEach(buf => buf.unlock());
    if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, mirror.getId(document));
  };
  _takeFullSnapshot = takeFullSnapshot;
  try {
    const handlers = [];
    const observe = doc => {
      return callbackWrapper(initObservers)({
        onMutation,
        mutationCb: wrappedMutationEmit,
        mousemoveCb: (positions, source) => wrappedEmit({
          type: EventType.IncrementalSnapshot,
          data: {
            source,
            positions
          }
        }),
        mouseInteractionCb: d => wrappedEmit({
          type: EventType.IncrementalSnapshot,
          data: {
            source: IncrementalSource.MouseInteraction,
            ...d
          }
        }),
        scrollCb: wrappedScrollEmit,
        viewportResizeCb: d => wrappedEmit({
          type: EventType.IncrementalSnapshot,
          data: {
            source: IncrementalSource.ViewportResize,
            ...d
          }
        }),
        inputCb: v => wrappedEmit({
          type: EventType.IncrementalSnapshot,
          data: {
            source: IncrementalSource.Input,
            ...v
          }
        }),
        mediaInteractionCb: p => wrappedEmit({
          type: EventType.IncrementalSnapshot,
          data: {
            source: IncrementalSource.MediaInteraction,
            ...p
          }
        }),
        styleSheetRuleCb: r => wrappedEmit({
          type: EventType.IncrementalSnapshot,
          data: {
            source: IncrementalSource.StyleSheetRule,
            ...r
          }
        }),
        styleDeclarationCb: r => wrappedEmit({
          type: EventType.IncrementalSnapshot,
          data: {
            source: IncrementalSource.StyleDeclaration,
            ...r
          }
        }),
        canvasMutationCb: wrappedCanvasMutationEmit,
        fontCb: p => wrappedEmit({
          type: EventType.IncrementalSnapshot,
          data: {
            source: IncrementalSource.Font,
            ...p
          }
        }),
        selectionCb: p => {
          wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: {
              source: IncrementalSource.Selection,
              ...p
            }
          });
        },
        customElementCb: c => {
          wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: {
              source: IncrementalSource.CustomElement,
              ...c
            }
          });
        },
        blockClass,
        ignoreClass,
        ignoreSelector,
        maskAllText,
        maskTextClass,
        unmaskTextClass,
        maskTextSelector,
        unmaskTextSelector,
        maskInputOptions,
        inlineStylesheet,
        sampling,
        recordDOM,
        recordCanvas,
        inlineImages,
        userTriggeredOnInput,
        collectFonts,
        doc,
        maskAttributeFn,
        maskInputFn,
        maskTextFn,
        keepIframeSrcFn,
        blockSelector,
        unblockSelector,
        slimDOMOptions,
        dataURLOptions,
        mirror,
        iframeManager,
        stylesheetManager,
        shadowDomManager,
        processedNodeManager,
        canvasManager,
        ignoreCSSAttributes,
        plugins: _optionalChain([plugins, 'optionalAccess', _8 => _8.filter, 'call', _9 => _9(p => p.observer), 'optionalAccess', _10 => _10.map, 'call', _11 => _11(p => ({
          observer: p.observer,
          options: p.options,
          callback: payload => wrappedEmit({
            type: EventType.Plugin,
            data: {
              plugin: p.name,
              payload
            }
          })
        }))]) || []
      }, {});
    };
    iframeManager.addLoadListener(iframeEl => {
      try {
        handlers.push(observe(iframeEl.contentDocument));
      } catch (error) {
        console.warn(error);
      }
    });
    const init = () => {
      takeFullSnapshot();
      handlers.push(observe(document));
    };
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      init();
    } else {
      handlers.push(on('DOMContentLoaded', () => {
        wrappedEmit({
          type: EventType.DomContentLoaded,
          data: {}
        });
        if (recordAfter === 'DOMContentLoaded') init();
      }));
      handlers.push(on('load', () => {
        wrappedEmit({
          type: EventType.Load,
          data: {}
        });
        if (recordAfter === 'load') init();
      }, window));
    }
    return () => {
      handlers.forEach(h => h());
      processedNodeManager.destroy();
      _takeFullSnapshot = undefined;
      unregisterErrorHandler();
    };
  } catch (error) {
    console.warn(error);
  }
}
function takeFullSnapshot(isCheckout) {
  if (!_takeFullSnapshot) {
    throw new Error('please take full snapshot after start recording');
  }
  _takeFullSnapshot(isCheckout);
}
record.mirror = mirror;
record.takeFullSnapshot = takeFullSnapshot;
function _getCanvasManager(getCanvasManagerFn, options) {
  try {
    return getCanvasManagerFn ? getCanvasManagerFn(options) : new CanvasManagerNoop();
  } catch (e2) {
    console.warn('Unable to initialize CanvasManager');
    return new CanvasManagerNoop();
  }
}
const ReplayEventTypeIncrementalSnapshot = 3;
const ReplayEventTypeCustom = 5;

/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */
function timestampToMs(timestamp) {
  const isMs = timestamp > 9999999999;
  return isMs ? timestamp : timestamp * 1000;
}

/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */
function timestampToS(timestamp) {
  const isMs = timestamp > 9999999999;
  return isMs ? timestamp / 1000 : timestamp;
}

/**
 * Add a breadcrumb event to replay.
 */
function addBreadcrumbEvent(replay, breadcrumb) {
  if (breadcrumb.category === 'sentry.transaction') {
    return;
  }
  if (['ui.click', 'ui.input'].includes(breadcrumb.category)) {
    replay.triggerUserActivity();
  } else {
    replay.checkAndHandleExpiredSession();
  }
  replay.addUpdate(() => {
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    replay.throttledAddEvent({
      type: EventType.Custom,
      // TODO: We were converting from ms to seconds for breadcrumbs, spans,
      // but maybe we should just keep them as milliseconds
      timestamp: (breadcrumb.timestamp || 0) * 1000,
      data: {
        tag: 'breadcrumb',
        // normalize to max. 10 depth and 1_000 properties per object
        payload: (0,normalize/* normalize */.Fv)(breadcrumb, 10, 1000)
      }
    });

    // Do not flush after console log messages
    return breadcrumb.category === 'console';
  });
}
const INTERACTIVE_SELECTOR = 'button,a';

/** Get the closest interactive parent element, or else return the given element. */
function getClosestInteractive(element) {
  const closestInteractive = element.closest(INTERACTIVE_SELECTOR);
  return closestInteractive || element;
}

/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */
function getClickTargetNode(event) {
  const target = getTargetNode(event);
  if (!target || !(target instanceof Element)) {
    return target;
  }
  return getClosestInteractive(target);
}

/** Get the event target node. */
function getTargetNode(event) {
  if (isEventWithTarget(event)) {
    return event.target;
  }
  return event;
}
function isEventWithTarget(event) {
  return typeof event === 'object' && !!event && 'target' in event;
}
let esm_handlers;

/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */
function onWindowOpen(cb) {
  // Ensure to only register this once
  if (!esm_handlers) {
    esm_handlers = [];
    monkeyPatchWindowOpen();
  }
  esm_handlers.push(cb);
  return () => {
    const pos = esm_handlers ? esm_handlers.indexOf(cb) : -1;
    if (pos > -1) {
      esm_handlers.splice(pos, 1);
    }
  };
}
function monkeyPatchWindowOpen() {
  (0,object/* fill */.hl)(WINDOW, 'open', function (originalWindowOpen) {
    return function (...args) {
      if (esm_handlers) {
        try {
          esm_handlers.forEach(handler => handler());
        } catch (e) {
          // ignore errors in here
        }
      }
      return originalWindowOpen.apply(WINDOW, args);
    };
  });
}

/** Any IncrementalSource for rrweb that we interpret as a kind of mutation. */
const IncrementalMutationSources = new Set([IncrementalSource.Mutation, IncrementalSource.StyleSheetRule, IncrementalSource.StyleDeclaration, IncrementalSource.AdoptedStyleSheet, IncrementalSource.CanvasMutation, IncrementalSource.Selection, IncrementalSource.MediaInteraction]);

/** Handle a click. */
function handleClick(clickDetector, clickBreadcrumb, node) {
  clickDetector.handleClick(clickBreadcrumb, node);
}

/** A click detector class that can be used to detect slow or rage clicks on elements. */
class ClickDetector {
  // protected for testing

  constructor(replay, slowClickConfig,
  // Just for easier testing
  _addBreadcrumbEvent = addBreadcrumbEvent) {
    this._lastMutation = 0;
    this._lastScroll = 0;
    this._clicks = [];

    // We want everything in s, but options are in ms
    this._timeout = slowClickConfig.timeout / 1000;
    this._threshold = slowClickConfig.threshold / 1000;
    this._scrollTimeout = slowClickConfig.scrollTimeout / 1000;
    this._replay = replay;
    this._ignoreSelector = slowClickConfig.ignoreSelector;
    this._addBreadcrumbEvent = _addBreadcrumbEvent;
  }

  /** Register click detection handlers on mutation or scroll. */
  addListeners() {
    const cleanupWindowOpen = onWindowOpen(() => {
      // Treat window.open as mutation
      this._lastMutation = nowInSeconds();
    });
    this._teardown = () => {
      cleanupWindowOpen();
      this._clicks = [];
      this._lastMutation = 0;
      this._lastScroll = 0;
    };
  }

  /** Clean up listeners. */
  removeListeners() {
    if (this._teardown) {
      this._teardown();
    }
    if (this._checkClickTimeout) {
      clearTimeout(this._checkClickTimeout);
    }
  }

  /** @inheritDoc */
  handleClick(breadcrumb, node) {
    if (ignoreElement(node, this._ignoreSelector) || !isClickBreadcrumb(breadcrumb)) {
      return;
    }
    const newClick = {
      timestamp: timestampToS(breadcrumb.timestamp),
      clickBreadcrumb: breadcrumb,
      // Set this to 0 so we know it originates from the click breadcrumb
      clickCount: 0,
      node
    };

    // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
    if (this._clicks.some(click => click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) {
      return;
    }
    this._clicks.push(newClick);

    // If this is the first new click, set a timeout to check for multi clicks
    if (this._clicks.length === 1) {
      this._scheduleCheckClicks();
    }
  }

  /** @inheritDoc */
  registerMutation(timestamp = Date.now()) {
    this._lastMutation = timestampToS(timestamp);
  }

  /** @inheritDoc */
  registerScroll(timestamp = Date.now()) {
    this._lastScroll = timestampToS(timestamp);
  }

  /** @inheritDoc */
  registerClick(element) {
    const node = getClosestInteractive(element);
    this._handleMultiClick(node);
  }

  /** Count multiple clicks on elements. */
  _handleMultiClick(node) {
    this._getClicks(node).forEach(click => {
      click.clickCount++;
    });
  }

  /** Get all pending clicks for a given node. */
  _getClicks(node) {
    return this._clicks.filter(click => click.node === node);
  }

  /** Check the clicks that happened. */
  _checkClicks() {
    const timedOutClicks = [];
    const now = nowInSeconds();
    this._clicks.forEach(click => {
      if (!click.mutationAfter && this._lastMutation) {
        click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
      }
      if (!click.scrollAfter && this._lastScroll) {
        click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
      }

      // All of these are in seconds!
      if (click.timestamp + this._timeout <= now) {
        timedOutClicks.push(click);
      }
    });

    // Remove "old" clicks
    for (const click of timedOutClicks) {
      const pos = this._clicks.indexOf(click);
      if (pos > -1) {
        this._generateBreadcrumbs(click);
        this._clicks.splice(pos, 1);
      }
    }

    // Trigger new check, unless no clicks left
    if (this._clicks.length) {
      this._scheduleCheckClicks();
    }
  }

  /** Generate matching breadcrumb(s) for the click. */
  _generateBreadcrumbs(click) {
    const replay = this._replay;
    const hadScroll = click.scrollAfter && click.scrollAfter <= this._scrollTimeout;
    const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
    const isSlowClick = !hadScroll && !hadMutation;
    const {
      clickCount,
      clickBreadcrumb
    } = click;

    // Slow click
    if (isSlowClick) {
      // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
      // If not, it means we just timed out without scroll & mutation
      const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
      const endReason = timeAfterClickMs < this._timeout * 1000 ? 'mutation' : 'timeout';
      const breadcrumb = {
        type: 'default',
        message: clickBreadcrumb.message,
        timestamp: clickBreadcrumb.timestamp,
        category: 'ui.slowClickDetected',
        data: {
          ...clickBreadcrumb.data,
          url: WINDOW.location.href,
          route: replay.getCurrentRoute(),
          timeAfterClickMs,
          endReason,
          // If clickCount === 0, it means multiClick was not correctly captured here
          // - we still want to send 1 in this case
          clickCount: clickCount || 1
        }
      };
      this._addBreadcrumbEvent(replay, breadcrumb);
      return;
    }

    // Multi click
    if (clickCount > 1) {
      const breadcrumb = {
        type: 'default',
        message: clickBreadcrumb.message,
        timestamp: clickBreadcrumb.timestamp,
        category: 'ui.multiClick',
        data: {
          ...clickBreadcrumb.data,
          url: WINDOW.location.href,
          route: replay.getCurrentRoute(),
          clickCount,
          metric: true
        }
      };
      this._addBreadcrumbEvent(replay, breadcrumb);
    }
  }

  /** Schedule to check current clicks. */
  _scheduleCheckClicks() {
    if (this._checkClickTimeout) {
      clearTimeout(this._checkClickTimeout);
    }
    this._checkClickTimeout = (0,getNativeImplementation/* setTimeout */.iK)(() => this._checkClicks(), 1000);
  }
}
const SLOW_CLICK_TAGS = ['A', 'BUTTON', 'INPUT'];

/** exported for tests only */
function ignoreElement(node, ignoreSelector) {
  if (!SLOW_CLICK_TAGS.includes(node.tagName)) {
    return true;
  }

  // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
  if (node.tagName === 'INPUT' && !['submit', 'button'].includes(node.getAttribute('type') || '')) {
    return true;
  }

  // If <a> tag, detect special variants that may not lead to an action
  // If target !== _self, we may open the link somewhere else, which would lead to no action
  // Also, when downloading a file, we may not leave the page, but still not trigger an action
  if (node.tagName === 'A' && (node.hasAttribute('download') || node.hasAttribute('target') && node.getAttribute('target') !== '_self')) {
    return true;
  }
  if (ignoreSelector && node.matches(ignoreSelector)) {
    return true;
  }
  return false;
}
function isClickBreadcrumb(breadcrumb) {
  return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === 'number' && breadcrumb.timestamp);
}

// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function nowInSeconds() {
  return Date.now() / 1000;
}

/** Update the click detector based on a recording event of rrweb. */
function updateClickDetectorForRecordingEvent(clickDetector, event) {
  try {
    // note: We only consider incremental snapshots here
    // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
    // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
    // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
    // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
    // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
    // But this should be more unlikely as we'd generally capture the incremental snapshot right away

    if (!isIncrementalEvent(event)) {
      return;
    }
    const {
      source
    } = event.data;
    if (IncrementalMutationSources.has(source)) {
      clickDetector.registerMutation(event.timestamp);
    }
    if (source === IncrementalSource.Scroll) {
      clickDetector.registerScroll(event.timestamp);
    }
    if (isIncrementalMouseInteraction(event)) {
      const {
        type,
        id
      } = event.data;
      const node = record.mirror.getNode(id);
      if (node instanceof HTMLElement && type === MouseInteractions.Click) {
        clickDetector.registerClick(node);
      }
    }
  } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
  }
}
function isIncrementalEvent(event) {
  return event.type === ReplayEventTypeIncrementalSnapshot;
}
function isIncrementalMouseInteraction(event) {
  return event.data.source === IncrementalSource.MouseInteraction;
}

/**
 * Create a breadcrumb for a replay.
 */
function createBreadcrumb(breadcrumb) {
  return {
    timestamp: Date.now() / 1000,
    type: 'default',
    ...breadcrumb
  };
}
var NodeType;
(function (NodeType) {
  NodeType[NodeType["Document"] = 0] = "Document";
  NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
  NodeType[NodeType["Element"] = 2] = "Element";
  NodeType[NodeType["Text"] = 3] = "Text";
  NodeType[NodeType["CDATA"] = 4] = "CDATA";
  NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType || (NodeType = {}));

// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const ATTRIBUTES_TO_RECORD = new Set(['id', 'class', 'aria-label', 'role', 'name', 'alt', 'title', 'data-test-id', 'data-testid', 'disabled', 'aria-disabled', 'data-sentry-component']);

/**
 * Inclusion list of attributes that we want to record from the DOM element
 */
function getAttributesToRecord(attributes) {
  const obj = {};
  if (!attributes['data-sentry-component'] && attributes['data-sentry-element']) {
    attributes['data-sentry-component'] = attributes['data-sentry-element'];
  }
  for (const key in attributes) {
    if (ATTRIBUTES_TO_RECORD.has(key)) {
      let normalizedKey = key;
      if (key === 'data-testid' || key === 'data-test-id') {
        normalizedKey = 'testId';
      }
      obj[normalizedKey] = attributes[key];
    }
  }
  return obj;
}
const handleDomListener = replay => {
  return handlerData => {
    if (!replay.isEnabled()) {
      return;
    }
    const result = handleDom(handlerData);
    if (!result) {
      return;
    }
    const isClick = handlerData.name === 'click';
    const event = isClick ? handlerData.event : undefined;
    // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
    if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      handleClick(replay.clickDetector, result, getClickTargetNode(handlerData.event));
    }
    addBreadcrumbEvent(replay, result);
  };
};

/** Get the base DOM breadcrumb. */
function getBaseDomBreadcrumb(target, message) {
  const nodeId = record.mirror.getId(target);
  const node = nodeId && record.mirror.getNode(nodeId);
  const meta = node && record.mirror.getMeta(node);
  const element = meta && isElement(meta) ? meta : null;
  return {
    message,
    data: element ? {
      nodeId,
      node: {
        id: nodeId,
        tagName: element.tagName,
        textContent: Array.from(element.childNodes).map(node => node.type === NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
        .map(text => text.trim()).join(''),
        attributes: getAttributesToRecord(element.attributes)
      }
    } : {}
  };
}

/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */
function handleDom(handlerData) {
  const {
    target,
    message
  } = getDomTarget(handlerData);
  return createBreadcrumb({
    category: `ui.${handlerData.name}`,
    ...getBaseDomBreadcrumb(target, message)
  });
}
function getDomTarget(handlerData) {
  const isClick = handlerData.name === 'click';
  let message;
  let target = null;

  // Accessing event.target can throw (see getsentry/raven-js#838, #768)
  try {
    target = isClick ? getClickTargetNode(handlerData.event) : getTargetNode(handlerData.event);
    message = (0,browser/* htmlTreeAsString */.Rt)(target, {
      maxStringLength: 200
    }) || '<unknown>';
  } catch (e) {
    message = '<unknown>';
  }
  return {
    target,
    message
  };
}
function isElement(node) {
  return node.type === NodeType.Element;
}

/** Handle keyboard events & create breadcrumbs. */
function handleKeyboardEvent(replay, event) {
  if (!replay.isEnabled()) {
    return;
  }

  // Update user activity, but do not restart recording as it can create
  // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
  // session with a single "keydown" breadcrumb is created)
  replay.updateUserActivity();
  const breadcrumb = getKeyboardBreadcrumb(event);
  if (!breadcrumb) {
    return;
  }
  addBreadcrumbEvent(replay, breadcrumb);
}

/** exported only for tests */
function getKeyboardBreadcrumb(event) {
  const {
    metaKey,
    shiftKey,
    ctrlKey,
    altKey,
    key,
    target
  } = event;

  // never capture for input fields
  if (!target || isInputElement(target) || !key) {
    return null;
  }

  // Note: We do not consider shift here, as that means "uppercase"
  const hasModifierKey = metaKey || ctrlKey || altKey;
  const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length

  // Do not capture breadcrumb if only a word key is pressed
  // This could leak e.g. user input
  if (!hasModifierKey && isCharacterKey) {
    return null;
  }
  const message = (0,browser/* htmlTreeAsString */.Rt)(target, {
    maxStringLength: 200
  }) || '<unknown>';
  const baseBreadcrumb = getBaseDomBreadcrumb(target, message);
  return createBreadcrumb({
    category: 'ui.keyDown',
    message,
    data: {
      ...baseBreadcrumb.data,
      metaKey,
      shiftKey,
      ctrlKey,
      altKey,
      key
    }
  });
}
function isInputElement(target) {
  return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
}

// Map entryType -> function to normalize data for event
const ENTRY_TYPES = {
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  resource: createResourceEntry,
  paint: createPaintEntry,
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  navigation: createNavigationEntry
};

/**
 * Handler creater for web vitals
 */
function webVitalHandler(getter, replay) {
  return ({
    metric
  }) => void replay.replayPerformanceEntries.push(getter(metric));
}

/**
 * Create replay performance entries from the browser performance entries.
 */
function createPerformanceEntries(entries) {
  return entries.map(createPerformanceEntry).filter(Boolean);
}
function createPerformanceEntry(entry) {
  const entryType = ENTRY_TYPES[entry.entryType];
  if (!entryType) {
    return null;
  }
  return entryType(entry);
}
function esm_getAbsoluteTime(time) {
  // browserPerformanceTimeOrigin can be undefined if `performance` or
  // `performance.now` doesn't exist, but this is already checked by this integration
  return ((utils_hoist_time/* browserPerformanceTimeOrigin */.Z1 || WINDOW.performance.timeOrigin) + time) / 1000;
}
function createPaintEntry(entry) {
  const {
    duration,
    entryType,
    name,
    startTime
  } = entry;
  const start = esm_getAbsoluteTime(startTime);
  return {
    type: entryType,
    name,
    start,
    end: start + duration,
    data: undefined
  };
}
function createNavigationEntry(entry) {
  const {
    entryType,
    name,
    decodedBodySize,
    duration,
    domComplete,
    encodedBodySize,
    domContentLoadedEventStart,
    domContentLoadedEventEnd,
    domInteractive,
    loadEventStart,
    loadEventEnd,
    redirectCount,
    startTime,
    transferSize,
    type
  } = entry;

  // Ignore entries with no duration, they do not seem to be useful and cause dupes
  if (duration === 0) {
    return null;
  }
  return {
    type: `${entryType}.${type}`,
    start: esm_getAbsoluteTime(startTime),
    end: esm_getAbsoluteTime(domComplete),
    name,
    data: {
      size: transferSize,
      decodedBodySize,
      encodedBodySize,
      duration,
      domInteractive,
      domContentLoadedEventStart,
      domContentLoadedEventEnd,
      loadEventStart,
      loadEventEnd,
      domComplete,
      redirectCount
    }
  };
}
function createResourceEntry(entry) {
  const {
    entryType,
    initiatorType,
    name,
    responseEnd,
    startTime,
    decodedBodySize,
    encodedBodySize,
    responseStatus,
    transferSize
  } = entry;

  // Core SDK handles these
  if (['fetch', 'xmlhttprequest'].includes(initiatorType)) {
    return null;
  }
  return {
    type: `${entryType}.${initiatorType}`,
    start: esm_getAbsoluteTime(startTime),
    end: esm_getAbsoluteTime(responseEnd),
    name,
    data: {
      size: transferSize,
      statusCode: responseStatus,
      decodedBodySize,
      encodedBodySize
    }
  };
}

/**
 * Add a LCP event to the replay based on a LCP metric.
 */
function getLargestContentfulPaint(metric) {
  const lastEntry = metric.entries[metric.entries.length - 1];
  const node = lastEntry && lastEntry.element ? [lastEntry.element] : undefined;
  return getWebVital(metric, 'largest-contentful-paint', node);
}
function isLayoutShift(entry) {
  return entry.sources !== undefined;
}

/**
 * Add a CLS event to the replay based on a CLS metric.
 */
function getCumulativeLayoutShift(metric) {
  const layoutShifts = [];
  const nodes = [];
  for (const entry of metric.entries) {
    if (isLayoutShift(entry)) {
      const nodeIds = [];
      for (const source of entry.sources) {
        if (source.node) {
          nodes.push(source.node);
          const nodeId = record.mirror.getId(source.node);
          if (nodeId) {
            nodeIds.push(nodeId);
          }
        }
      }
      layoutShifts.push({
        value: entry.value,
        nodeIds: nodeIds.length ? nodeIds : undefined
      });
    }
  }
  return getWebVital(metric, 'cumulative-layout-shift', nodes, layoutShifts);
}

/**
 * Add a FID event to the replay based on a FID metric.
 */
function getFirstInputDelay(metric) {
  const lastEntry = metric.entries[metric.entries.length - 1];
  const node = lastEntry && lastEntry.target ? [lastEntry.target] : undefined;
  return getWebVital(metric, 'first-input-delay', node);
}

/**
 * Add an INP event to the replay based on an INP metric.
 */
function getInteractionToNextPaint(metric) {
  const lastEntry = metric.entries[metric.entries.length - 1];
  const node = lastEntry && lastEntry.target ? [lastEntry.target] : undefined;
  return getWebVital(metric, 'interaction-to-next-paint', node);
}

/**
 * Add an web vital event to the replay based on the web vital metric.
 */
function getWebVital(metric, name, nodes, attributions) {
  const value = metric.value;
  const rating = metric.rating;
  const end = esm_getAbsoluteTime(value);
  return {
    type: 'web-vital',
    name,
    start: end,
    end,
    data: {
      value,
      size: value,
      rating,
      nodeIds: nodes ? nodes.map(node => record.mirror.getId(node)) : undefined,
      attributions
    }
  };
}

/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */
function setupPerformanceObserver(replay) {
  function addPerformanceEntry(entry) {
    // It is possible for entries to come up multiple times
    if (!replay.performanceEntries.includes(entry)) {
      replay.performanceEntries.push(entry);
    }
  }
  function onEntries({
    entries
  }) {
    entries.forEach(addPerformanceEntry);
  }
  const clearCallbacks = [];
  ['navigation', 'paint', 'resource'].forEach(type => {
    clearCallbacks.push(addPerformanceInstrumentationHandler(type, onEntries));
  });
  clearCallbacks.push(addLcpInstrumentationHandler(webVitalHandler(getLargestContentfulPaint, replay)), addClsInstrumentationHandler(webVitalHandler(getCumulativeLayoutShift, replay)), addFidInstrumentationHandler(webVitalHandler(getFirstInputDelay, replay)), addInpInstrumentationHandler(webVitalHandler(getInteractionToNextPaint, replay)));

  // A callback to cleanup all handlers
  return () => {
    clearCallbacks.forEach(clearCallback => clearCallback());
  };
}

/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD =  false || false;
const r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=A(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},U=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=x(f,15),M=b.t,E=b.l,A=x(h,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}},L=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},O=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=C[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(a[t]^a[t+1]<<A^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=U(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=U(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},j=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},q=function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&j(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}},B=function(t){return 10+(t.filename?t.filename.length+1:0)},G=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(O(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();var H=function(){function t(t,n){this.c=L(),this.v=1,G.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),G.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=O(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=L();i.p(n.dictionary),j(t,2,i.d())}}(r,this.o),this.v=0),n&&j(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),J="undefined"!=typeof TextEncoder&&new TextEncoder,K="undefined"!=typeof TextDecoder&&new TextDecoder;try{K.decode(F,{stream:!0})}catch(t){}var N=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(P(t),this.d=n||!1)},t}();function P(n,r){if(J)return J.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),a=0,s=function(t){i[a++]=t},o=0;o<e;++o){if(a+5>i.length){var f=new t(a+8+(e-o<<1));f.set(i),i=f}var h=n.charCodeAt(o);h<128||r?s(h):h<2048?(s(192|h>>6),s(128|63&h)):h>55295&&h<57344?(s(240|(h=65536+(1047552&h)|1023&n.charCodeAt(++o))>>18),s(128|h>>12&63),s(128|h>>6&63),s(128|63&h)):(s(224|h>>12),s(128|h>>6&63),s(128|63&h))}return b(i,0,a)}function Q(t){return function(t,n){n||(n={});var r=S(),e=t.length;r.p(t);var i=O(t,n,B(n),8),a=i.length;return q(i,n),j(i,a-8,r.d()),j(i,a-4,e),i}(P(t))}const R=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new H,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new N(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},V={clear:()=>{R.clear()},addEvent:t=>R.addEvent(t),finish:()=>R.finish(),compress:t=>Q(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in V&&"function"==typeof V[n])try{const t=V[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function e() {
  const e = new Blob([r]);
  return URL.createObjectURL(e);
}
const CONSOLE_LEVELS = ['info', 'warn', 'error', 'log'];
const PREFIX = '[Replay] ';
function _addBreadcrumb(message, level = 'info') {
  (0,breadcrumbs/* addBreadcrumb */.n)({
    category: 'console',
    data: {
      logger: 'replay'
    },
    level,
    message: `${PREFIX}${message}`
  }, {
    level
  });
}
function makeReplayLogger() {
  let _capture = false;
  let _trace = false;
  const _logger = {
    exception: () => undefined,
    infoTick: () => undefined,
    setConfig: opts => {
      _capture = opts.captureExceptions;
      _trace = opts.traceInternals;
    }
  };
  if (DEBUG_BUILD) {
    CONSOLE_LEVELS.forEach(name => {
      _logger[name] = (...args) => {
        logger/* logger */.kg[name](PREFIX, ...args);
        if (_trace) {
          _addBreadcrumb(args.join(''), (0,severity/* severityLevelFromString */.V)(name));
        }
      };
    });
    _logger.exception = (error, ...message) => {
      if (message.length && _logger.error) {
        _logger.error(...message);
      }
      logger/* logger.error */.kg.error(PREFIX, error);
      if (_capture) {
        (0,esm_exports/* captureException */.Tb)(error);
      } else if (_trace) {
        // No need for a breadcrumb if `_capture` is enabled since it should be
        // captured as an exception
        _addBreadcrumb(error, 'error');
      }
    };
    _logger.infoTick = (...args) => {
      logger/* logger.info */.kg.info(PREFIX, ...args);
      if (_trace) {
        // Wait a tick here to avoid race conditions for some initial logs
        // which may be added before replay is initialized
        setTimeout(() => _addBreadcrumb(args[0]), 0);
      }
    };
  } else {
    CONSOLE_LEVELS.forEach(name => {
      _logger[name] = () => undefined;
    });
  }
  return _logger;
}
const esm_logger = makeReplayLogger();

/** This error indicates that the event buffer size exceeded the limit.. */
class EventBufferSizeExceededError extends Error {
  constructor() {
    super(`Event buffer exceeded maximum size of ${REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
  }
}

/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */
class EventBufferArray {
  /** All the events that are buffered to be sent. */

  /** @inheritdoc */

  /** @inheritdoc */

  constructor() {
    this.events = [];
    this._totalSize = 0;
    this.hasCheckout = false;
    this.waitForCheckout = false;
  }

  /** @inheritdoc */
  get hasEvents() {
    return this.events.length > 0;
  }

  /** @inheritdoc */
  get type() {
    return 'sync';
  }

  /** @inheritdoc */
  destroy() {
    this.events = [];
  }

  /** @inheritdoc */
  async addEvent(event) {
    const eventSize = JSON.stringify(event).length;
    this._totalSize += eventSize;
    if (this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE) {
      throw new EventBufferSizeExceededError();
    }
    this.events.push(event);
  }

  /** @inheritdoc */
  finish() {
    return new Promise(resolve => {
      // Make a copy of the events array reference and immediately clear the
      // events member so that we do not lose new events while uploading
      // attachment.
      const eventsRet = this.events;
      this.clear();
      resolve(JSON.stringify(eventsRet));
    });
  }

  /** @inheritdoc */
  clear() {
    this.events = [];
    this._totalSize = 0;
    this.hasCheckout = false;
  }

  /** @inheritdoc */
  getEarliestTimestamp() {
    const timestamp = this.events.map(event => event.timestamp).sort()[0];
    if (!timestamp) {
      return null;
    }
    return timestampToMs(timestamp);
  }
}

/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */
class WorkerHandler {
  constructor(worker) {
    this._worker = worker;
    this._id = 0;
  }

  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */
  ensureReady() {
    // Ensure we only check once
    if (this._ensureReadyPromise) {
      return this._ensureReadyPromise;
    }
    this._ensureReadyPromise = new Promise((resolve, reject) => {
      this._worker.addEventListener('message', ({
        data
      }) => {
        if (data.success) {
          resolve();
        } else {
          reject();
        }
      }, {
        once: true
      });
      this._worker.addEventListener('error', error => {
        reject(error);
      }, {
        once: true
      });
    });
    return this._ensureReadyPromise;
  }

  /**
   * Destroy the worker.
   */
  destroy() {
    DEBUG_BUILD && esm_logger.info('Destroying compression worker');
    this._worker.terminate();
  }

  /**
   * Post message to worker and wait for response before resolving promise.
   */
  postMessage(method, arg) {
    const id = this._getAndIncrementId();
    return new Promise((resolve, reject) => {
      const listener = ({
        data
      }) => {
        const response = data;
        if (response.method !== method) {
          return;
        }

        // There can be multiple listeners for a single method, the id ensures
        // that the response matches the caller.
        if (response.id !== id) {
          return;
        }

        // At this point, we'll always want to remove listener regardless of result status
        this._worker.removeEventListener('message', listener);
        if (!response.success) {
          // TODO: Do some error handling, not sure what
          DEBUG_BUILD && esm_logger.error('Error in compression worker: ', response.response);
          reject(new Error('Error in compression worker'));
          return;
        }
        resolve(response.response);
      };

      // Note: we can't use `once` option because it's possible it needs to
      // listen to multiple messages
      this._worker.addEventListener('message', listener);
      this._worker.postMessage({
        id,
        method,
        arg
      });
    });
  }

  /** Get the current ID and increment it for the next call. */
  _getAndIncrementId() {
    return this._id++;
  }
}

/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */
class EventBufferCompressionWorker {
  /** @inheritdoc */

  /** @inheritdoc */

  constructor(worker) {
    this._worker = new WorkerHandler(worker);
    this._earliestTimestamp = null;
    this._totalSize = 0;
    this.hasCheckout = false;
    this.waitForCheckout = false;
  }

  /** @inheritdoc */
  get hasEvents() {
    return !!this._earliestTimestamp;
  }

  /** @inheritdoc */
  get type() {
    return 'worker';
  }

  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */
  ensureReady() {
    return this._worker.ensureReady();
  }

  /**
   * Destroy the event buffer.
   */
  destroy() {
    this._worker.destroy();
  }

  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully received and processed by worker.
   */
  addEvent(event) {
    const timestamp = timestampToMs(event.timestamp);
    if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) {
      this._earliestTimestamp = timestamp;
    }
    const data = JSON.stringify(event);
    this._totalSize += data.length;
    if (this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE) {
      return Promise.reject(new EventBufferSizeExceededError());
    }
    return this._sendEventToWorker(data);
  }

  /**
   * Finish the event buffer and return the compressed data.
   */
  finish() {
    return this._finishRequest();
  }

  /** @inheritdoc */
  clear() {
    this._earliestTimestamp = null;
    this._totalSize = 0;
    this.hasCheckout = false;

    // We do not wait on this, as we assume the order of messages is consistent for the worker
    this._worker.postMessage('clear').then(null, e => {
      DEBUG_BUILD && esm_logger.exception(e, 'Sending "clear" message to worker failed', e);
    });
  }

  /** @inheritdoc */
  getEarliestTimestamp() {
    return this._earliestTimestamp;
  }

  /**
   * Send the event to the worker.
   */
  _sendEventToWorker(data) {
    return this._worker.postMessage('addEvent', data);
  }

  /**
   * Finish the request and return the compressed data from the worker.
   */
  async _finishRequest() {
    const response = await this._worker.postMessage('finish');
    this._earliestTimestamp = null;
    this._totalSize = 0;
    return response;
  }
}

/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */
class EventBufferProxy {
  constructor(worker) {
    this._fallback = new EventBufferArray();
    this._compression = new EventBufferCompressionWorker(worker);
    this._used = this._fallback;
    this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
  }

  /** @inheritdoc */
  get waitForCheckout() {
    return this._used.waitForCheckout;
  }

  /** @inheritdoc */
  get type() {
    return this._used.type;
  }

  /** @inheritDoc */
  get hasEvents() {
    return this._used.hasEvents;
  }

  /** @inheritdoc */
  get hasCheckout() {
    return this._used.hasCheckout;
  }
  /** @inheritdoc */
  set hasCheckout(value) {
    this._used.hasCheckout = value;
  }

  /** @inheritdoc */
  // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
  set waitForCheckout(value) {
    this._used.waitForCheckout = value;
  }

  /** @inheritDoc */
  destroy() {
    this._fallback.destroy();
    this._compression.destroy();
  }

  /** @inheritdoc */
  clear() {
    return this._used.clear();
  }

  /** @inheritdoc */
  getEarliestTimestamp() {
    return this._used.getEarliestTimestamp();
  }

  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */
  addEvent(event) {
    return this._used.addEvent(event);
  }

  /** @inheritDoc */
  async finish() {
    // Ensure the worker is loaded, so the sent event is compressed
    await this.ensureWorkerIsLoaded();
    return this._used.finish();
  }

  /** Ensure the worker has loaded. */
  ensureWorkerIsLoaded() {
    return this._ensureWorkerIsLoadedPromise;
  }

  /** Actually check if the worker has been loaded. */
  async _ensureWorkerIsLoaded() {
    try {
      await this._compression.ensureReady();
    } catch (error) {
      // If the worker fails to load, we fall back to the simple buffer.
      // Nothing more to do from our side here
      DEBUG_BUILD && esm_logger.exception(error, 'Failed to load the compression worker, falling back to simple buffer');
      return;
    }

    // Now we need to switch over the array buffer to the compression worker
    await this._switchToCompressionWorker();
  }

  /** Switch the used buffer to the compression worker. */
  async _switchToCompressionWorker() {
    const {
      events,
      hasCheckout,
      waitForCheckout
    } = this._fallback;
    const addEventPromises = [];
    for (const event of events) {
      addEventPromises.push(this._compression.addEvent(event));
    }
    this._compression.hasCheckout = hasCheckout;
    this._compression.waitForCheckout = waitForCheckout;

    // We switch over to the new buffer immediately - any further events will be added
    // after the previously buffered ones
    this._used = this._compression;

    // Wait for original events to be re-added before resolving
    try {
      await Promise.all(addEventPromises);

      // Can now clear fallback buffer as it's no longer necessary
      this._fallback.clear();
    } catch (error) {
      DEBUG_BUILD && esm_logger.exception(error, 'Failed to add events when switching buffers.');
    }
  }
}

/**
 * Create an event buffer for replays.
 */
function createEventBuffer({
  useCompression,
  workerUrl: customWorkerUrl
}) {
  if (useCompression &&
  // eslint-disable-next-line no-restricted-globals
  window.Worker) {
    const worker = _loadWorker(customWorkerUrl);
    if (worker) {
      return worker;
    }
  }
  DEBUG_BUILD && esm_logger.info('Using simple buffer');
  return new EventBufferArray();
}
function _loadWorker(customWorkerUrl) {
  try {
    const workerUrl = customWorkerUrl || _getWorkerUrl();
    if (!workerUrl) {
      return;
    }
    DEBUG_BUILD && esm_logger.info(`Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ''}`);
    const worker = new Worker(workerUrl);
    return new EventBufferProxy(worker);
  } catch (error) {
    DEBUG_BUILD && esm_logger.exception(error, 'Failed to create compression worker');
    // Fall back to use simple event buffer array
  }
}
function _getWorkerUrl() {
  if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === 'undefined' || !__SENTRY_EXCLUDE_REPLAY_WORKER__) {
    return e();
  }
  return '';
}

/** If sessionStorage is available. */
function hasSessionStorage() {
  try {
    // This can throw, e.g. when being accessed in a sandboxed iframe
    return 'sessionStorage' in WINDOW && !!WINDOW.sessionStorage;
  } catch (e) {
    return false;
  }
}

/**
 * Removes the session from Session Storage and unsets session in replay instance
 */
function clearSession(replay) {
  deleteSession();
  replay.session = undefined;
}

/**
 * Deletes a session from storage
 */
function deleteSession() {
  if (!hasSessionStorage()) {
    return;
  }
  try {
    WINDOW.sessionStorage.removeItem(REPLAY_SESSION_KEY);
  } catch (e) {
    // Ignore potential SecurityError exceptions
  }
}

/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */
function isSampled(sampleRate) {
  if (sampleRate === undefined) {
    return false;
  }

  // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
  return Math.random() < sampleRate;
}

/**
 * Get a session with defaults & applied sampling.
 */
function makeSession(session) {
  const now = Date.now();
  const id = session.id || (0,misc/* uuid4 */.DM)();
  // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
  const started = session.started || now;
  const lastActivity = session.lastActivity || now;
  const segmentId = session.segmentId || 0;
  const sampled = session.sampled;
  const previousSessionId = session.previousSessionId;
  return {
    id,
    started,
    lastActivity,
    segmentId,
    sampled,
    previousSessionId
  };
}

/**
 * Save a session to session storage.
 */
function saveSession(session) {
  if (!hasSessionStorage()) {
    return;
  }
  try {
    WINDOW.sessionStorage.setItem(REPLAY_SESSION_KEY, JSON.stringify(session));
  } catch (e) {
    // Ignore potential SecurityError exceptions
  }
}

/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */
function getSessionSampleType(sessionSampleRate, allowBuffering) {
  return isSampled(sessionSampleRate) ? 'session' : allowBuffering ? 'buffer' : false;
}

/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */
function createSession({
  sessionSampleRate,
  allowBuffering,
  stickySession = false
}, {
  previousSessionId
} = {}) {
  const sampled = getSessionSampleType(sessionSampleRate, allowBuffering);
  const session = makeSession({
    sampled,
    previousSessionId
  });
  if (stickySession) {
    saveSession(session);
  }
  return session;
}

/**
 * Fetches a session from storage
 */
function fetchSession() {
  if (!hasSessionStorage()) {
    return null;
  }
  try {
    // This can throw if cookies are disabled
    const sessionStringFromStorage = WINDOW.sessionStorage.getItem(REPLAY_SESSION_KEY);
    if (!sessionStringFromStorage) {
      return null;
    }
    const sessionObj = JSON.parse(sessionStringFromStorage);
    DEBUG_BUILD && esm_logger.infoTick('Loading existing session');
    return makeSession(sessionObj);
  } catch (e) {
    return null;
  }
}

/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */
function isExpired(initialTime, expiry, targetTime = +new Date()) {
  // Always expired if < 0
  if (initialTime === null || expiry === undefined || expiry < 0) {
    return true;
  }

  // Never expires if == 0
  if (expiry === 0) {
    return false;
  }
  return initialTime + expiry <= targetTime;
}

/**
 * Checks to see if session is expired
 */
function isSessionExpired(session, {
  maxReplayDuration,
  sessionIdleExpire,
  targetTime = Date.now()
}) {
  return (
    // First, check that maximum session length has not been exceeded
    isExpired(session.started, maxReplayDuration, targetTime) ||
    // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    isExpired(session.lastActivity, sessionIdleExpire, targetTime)
  );
}

/** If the session should be refreshed or not. */
function shouldRefreshSession(session, {
  sessionIdleExpire,
  maxReplayDuration
}) {
  // If not expired, all good, just keep the session
  if (!isSessionExpired(session, {
    sessionIdleExpire,
    maxReplayDuration
  })) {
    return false;
  }

  // If we are buffering & haven't ever flushed yet, always continue
  if (session.sampled === 'buffer' && session.segmentId === 0) {
    return false;
  }
  return true;
}

/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */
function loadOrCreateSession({
  sessionIdleExpire,
  maxReplayDuration,
  previousSessionId
}, sessionOptions) {
  const existingSession = sessionOptions.stickySession && fetchSession();

  // No session exists yet, just create a new one
  if (!existingSession) {
    DEBUG_BUILD && esm_logger.infoTick('Creating new session');
    return createSession(sessionOptions, {
      previousSessionId
    });
  }
  if (!shouldRefreshSession(existingSession, {
    sessionIdleExpire,
    maxReplayDuration
  })) {
    return existingSession;
  }
  DEBUG_BUILD && esm_logger.infoTick('Session in sessionStorage is expired, creating new one...');
  return createSession(sessionOptions, {
    previousSessionId: existingSession.id
  });
}
function isCustomEvent(event) {
  return event.type === EventType.Custom;
}

/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */
function addEventSync(replay, event, isCheckout) {
  if (!shouldAddEvent(replay, event)) {
    return false;
  }

  // This should never reject
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  _addEvent(replay, event, isCheckout);
  return true;
}

/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */
function addEvent(replay, event, isCheckout) {
  if (!shouldAddEvent(replay, event)) {
    return Promise.resolve(null);
  }
  return _addEvent(replay, event, isCheckout);
}
async function _addEvent(replay, event, isCheckout) {
  const {
    eventBuffer
  } = replay;
  if (!eventBuffer || eventBuffer.waitForCheckout && !isCheckout) {
    return null;
  }
  const isBufferMode = replay.recordingMode === 'buffer';
  try {
    if (isCheckout && isBufferMode) {
      eventBuffer.clear();
    }
    if (isCheckout) {
      eventBuffer.hasCheckout = true;
      eventBuffer.waitForCheckout = false;
    }
    const replayOptions = replay.getOptions();
    const eventAfterPossibleCallback = maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
    if (!eventAfterPossibleCallback) {
      return;
    }
    return await eventBuffer.addEvent(eventAfterPossibleCallback);
  } catch (error) {
    const isExceeded = error && error instanceof EventBufferSizeExceededError;
    const reason = isExceeded ? 'addEventSizeExceeded' : 'addEvent';
    if (isExceeded && isBufferMode) {
      // Clear buffer and wait for next checkout
      eventBuffer.clear();
      eventBuffer.waitForCheckout = true;
      return null;
    }
    replay.handleException(error);
    await replay.stop({
      reason
    });
    const client = (0,currentScopes/* getClient */.s3)();
    if (client) {
      client.recordDroppedEvent('internal_sdk_error', 'replay');
    }
  }
}

/** Exported only for tests. */
function shouldAddEvent(replay, event) {
  if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) {
    return false;
  }
  const timestampInMs = timestampToMs(event.timestamp);

  // Throw out events that happen more than 5 minutes ago. This can happen if
  // page has been left open and idle for a long period of time and user
  // comes back to trigger a new session. The performance entries rely on
  // `performance.timeOrigin`, which is when the page first opened.
  if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) {
    return false;
  }

  // Throw out events that are +60min from the initial timestamp
  if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
    DEBUG_BUILD && esm_logger.infoTick(`Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`);
    return false;
  }
  return true;
}
function maybeApplyCallback(event, callback) {
  try {
    if (typeof callback === 'function' && isCustomEvent(event)) {
      return callback(event);
    }
  } catch (error) {
    DEBUG_BUILD && esm_logger.exception(error, 'An error occurred in the `beforeAddRecordingEvent` callback, skipping the event...');
    return null;
  }
  return event;
}

/** If the event is an error event */
function isErrorEvent(event) {
  return !event.type;
}

/** If the event is a transaction event */
function isTransactionEvent(event) {
  return event.type === 'transaction';
}

/** If the event is an replay event */
function isReplayEvent(event) {
  return event.type === 'replay_event';
}

/** If the event is a feedback event */
function isFeedbackEvent(event) {
  return event.type === 'feedback';
}

/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */
function handleAfterSendEvent(replay) {
  return (event, sendResponse) => {
    if (!replay.isEnabled() || !isErrorEvent(event) && !isTransactionEvent(event)) {
      return;
    }
    const statusCode = sendResponse && sendResponse.statusCode;

    // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
    // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
    // If we do use the base transport, we skip if we encountered an non-OK status code
    if (!statusCode || statusCode < 200 || statusCode >= 300) {
      return;
    }
    if (isTransactionEvent(event)) {
      handleTransactionEvent(replay, event);
      return;
    }
    handleErrorEvent(replay, event);
  };
}
function handleTransactionEvent(replay, event) {
  const replayContext = replay.getContext();

  // Collect traceIds in _context regardless of `recordingMode`
  // In error mode, _context gets cleared on every checkout
  // We limit to max. 100 transactions linked
  if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) {
    replayContext.traceIds.add(event.contexts.trace.trace_id);
  }
}
function handleErrorEvent(replay, event) {
  const replayContext = replay.getContext();

  // Add error to list of errorIds of replay. This is ok to do even if not
  // sampled because context will get reset at next checkout.
  // XXX: There is also a race condition where it's possible to capture an
  // error to Sentry before Replay SDK has loaded, but response returns after
  // it was loaded, and this gets called.
  // We limit to max. 100 errors linked
  if (event.event_id && replayContext.errorIds.size < 100) {
    replayContext.errorIds.add(event.event_id);
  }

  // If error event is tagged with replay id it means it was sampled (when in buffer mode)
  // Need to be very careful that this does not cause an infinite loop
  if (replay.recordingMode !== 'buffer' || !event.tags || !event.tags.replayId) {
    return;
  }
  const {
    beforeErrorSampling
  } = replay.getOptions();
  if (typeof beforeErrorSampling === 'function' && !beforeErrorSampling(event)) {
    return;
  }
  (0,getNativeImplementation/* setTimeout */.iK)(async () => {
    try {
      // Capture current event buffer as new replay
      await replay.sendBufferedReplayOrFlush();
    } catch (err) {
      replay.handleException(err);
    }
  });
}

/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */
function handleBeforeSendEvent(replay) {
  return event => {
    if (!replay.isEnabled() || !isErrorEvent(event)) {
      return;
    }
    handleHydrationError(replay, event);
  };
}
function handleHydrationError(replay, event) {
  const exceptionValue = event.exception && event.exception.values && event.exception.values[0] && event.exception.values[0].value;
  if (typeof exceptionValue !== 'string') {
    return;
  }
  if (
  // Only matches errors in production builds of react-dom
  // Example https://reactjs.org/docs/error-decoder.html?invariant=423
  // With newer React versions, the messages changed to a different website https://react.dev/errors/418
  exceptionValue.match(/(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/) ||
  // Development builds of react-dom
  // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
  // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
  exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
    const breadcrumb = createBreadcrumb({
      category: 'replay.hydrate-error',
      data: {
        url: (0,browser/* getLocationHref */.l4)()
      }
    });
    addBreadcrumbEvent(replay, breadcrumb);
  }
}

/**
 * Handle breadcrumbs that Sentry captures, and make sure to capture relevant breadcrumbs to Replay as well.
 */
function handleBreadcrumbs(replay) {
  const client = (0,currentScopes/* getClient */.s3)();
  if (!client) {
    return;
  }
  client.on('beforeAddBreadcrumb', breadcrumb => beforeAddBreadcrumb(replay, breadcrumb));
}
function beforeAddBreadcrumb(replay, breadcrumb) {
  if (!replay.isEnabled() || !isBreadcrumbWithCategory(breadcrumb)) {
    return;
  }
  const result = normalizeBreadcrumb(breadcrumb);
  if (result) {
    addBreadcrumbEvent(replay, result);
  }
}

/** Exported only for tests. */
function normalizeBreadcrumb(breadcrumb) {
  if (!isBreadcrumbWithCategory(breadcrumb) || [
  // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
  'fetch', 'xhr',
  // These two are breadcrumbs for emitted sentry events, we don't care about them
  'sentry.event', 'sentry.transaction'].includes(breadcrumb.category) ||
  // We capture UI breadcrumbs separately
  breadcrumb.category.startsWith('ui.')) {
    return null;
  }
  if (breadcrumb.category === 'console') {
    return normalizeConsoleBreadcrumb(breadcrumb);
  }
  return createBreadcrumb(breadcrumb);
}

/** exported for tests only */
function normalizeConsoleBreadcrumb(breadcrumb) {
  const args = breadcrumb.data && breadcrumb.data.arguments;
  if (!Array.isArray(args) || args.length === 0) {
    return createBreadcrumb(breadcrumb);
  }
  let isTruncated = false;

  // Avoid giant args captures
  const normalizedArgs = args.map(arg => {
    if (!arg) {
      return arg;
    }
    if (typeof arg === 'string') {
      if (arg.length > CONSOLE_ARG_MAX_SIZE) {
        isTruncated = true;
        return `${arg.slice(0, CONSOLE_ARG_MAX_SIZE)}…`;
      }
      return arg;
    }
    if (typeof arg === 'object') {
      try {
        const normalizedArg = (0,normalize/* normalize */.Fv)(arg, 7);
        const stringified = JSON.stringify(normalizedArg);
        if (stringified.length > CONSOLE_ARG_MAX_SIZE) {
          isTruncated = true;
          // We use the pretty printed JSON string here as a base
          return `${JSON.stringify(normalizedArg, null, 2).slice(0, CONSOLE_ARG_MAX_SIZE)}…`;
        }
        return normalizedArg;
      } catch (e) {
        // fall back to default
      }
    }
    return arg;
  });
  return createBreadcrumb({
    ...breadcrumb,
    data: {
      ...breadcrumb.data,
      arguments: normalizedArgs,
      ...(isTruncated ? {
        _meta: {
          warnings: ['CONSOLE_ARG_TRUNCATED']
        }
      } : {})
    }
  });
}
function isBreadcrumbWithCategory(breadcrumb) {
  return !!breadcrumb.category;
}

/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */
function isRrwebError(event, hint) {
  if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) {
    return false;
  }

  // @ts-expect-error this may be set by rrweb when it finds errors
  if (hint.originalException && hint.originalException.__rrweb__) {
    return true;
  }
  return false;
}

/**
 * Reset the `replay_id` field on the DSC.
 */
function resetReplayIdOnDynamicSamplingContext() {
  // Reset DSC on the current scope, if there is one
  const dsc = (0,currentScopes/* getCurrentScope */.nZ)().getPropagationContext().dsc;
  if (dsc) {
    delete dsc.replay_id;
  }

  // Clear it from frozen DSC on the active span
  const activeSpan = (0,spanUtils/* getActiveSpan */.HN)();
  if (activeSpan) {
    const dsc = (0,dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.jC)(activeSpan);
    delete dsc.replay_id;
  }
}

/**
 * Add a feedback breadcrumb event to replay.
 */
function addFeedbackBreadcrumb(replay, event) {
  replay.triggerUserActivity();
  replay.addUpdate(() => {
    if (!event.timestamp) {
      // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
      // Return true here so that we don't flush
      return true;
    }

    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    replay.throttledAddEvent({
      type: EventType.Custom,
      timestamp: event.timestamp * 1000,
      data: {
        tag: 'breadcrumb',
        payload: {
          timestamp: event.timestamp,
          type: 'default',
          category: 'sentry.feedback',
          data: {
            feedbackId: event.event_id
          }
        }
      }
    });
    return false;
  });
}

/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `handleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */
function shouldSampleForBufferEvent(replay, event) {
  if (replay.recordingMode !== 'buffer') {
    return false;
  }

  // ignore this error because otherwise we could loop indefinitely with
  // trying to capture replay and failing
  if (event.message === UNABLE_TO_SEND_REPLAY) {
    return false;
  }

  // Require the event to be an error event & to have an exception
  if (!event.exception || event.type) {
    return false;
  }
  return isSampled(replay.getOptions().errorSampleRate);
}

/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */
function handleGlobalEventListener(replay) {
  return Object.assign((event, hint) => {
    // Do nothing if replay has been disabled or paused
    if (!replay.isEnabled() || replay.isPaused()) {
      return event;
    }
    if (isReplayEvent(event)) {
      // Replays have separate set of breadcrumbs, do not include breadcrumbs
      // from core SDK
      delete event.breadcrumbs;
      return event;
    }

    // We only want to handle errors, transactions, and feedbacks, nothing else
    if (!isErrorEvent(event) && !isTransactionEvent(event) && !isFeedbackEvent(event)) {
      return event;
    }

    // Ensure we do not add replay_id if the session is expired
    const isSessionActive = replay.checkAndHandleExpiredSession();
    if (!isSessionActive) {
      // prevent exceeding replay durations by removing the expired replayId from the DSC
      resetReplayIdOnDynamicSamplingContext();
      return event;
    }
    if (isFeedbackEvent(event)) {
      // This should never reject
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      replay.flush();
      event.contexts.feedback.replay_id = replay.getSessionId();
      // Add a replay breadcrumb for this piece of feedback
      addFeedbackBreadcrumb(replay, event);
      return event;
    }

    // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
    // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
    if (isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
      DEBUG_BUILD && esm_logger.log('Ignoring error from rrweb internals', event);
      return null;
    }

    // When in buffer mode, we decide to sample here.
    // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
    // And convert the buffer session to a full session
    const isErrorEventSampled = shouldSampleForBufferEvent(replay, event);

    // Tag errors if it has been sampled in buffer mode, or if it is session mode
    // Only tag transactions if in session mode
    const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === 'session';
    if (shouldTagReplayId) {
      event.tags = {
        ...event.tags,
        replayId: replay.getSessionId()
      };
    }
    return event;
  }, {
    id: 'Replay'
  });
}

/**
 * Create a "span" for each performance entry.
 */
function createPerformanceSpans(replay, entries) {
  return entries.map(({
    type,
    start,
    end,
    name,
    data
  }) => {
    const response = replay.throttledAddEvent({
      type: EventType.Custom,
      timestamp: start,
      data: {
        tag: 'performanceSpan',
        payload: {
          op: type,
          description: name,
          startTimestamp: start,
          endTimestamp: end,
          data
        }
      }
    });

    // If response is a string, it means its either THROTTLED or SKIPPED
    return typeof response === 'string' ? Promise.resolve(null) : response;
  });
}
function handleHistory(handlerData) {
  const {
    from,
    to
  } = handlerData;
  const now = Date.now() / 1000;
  return {
    type: 'navigation.push',
    start: now,
    end: now,
    name: to,
    data: {
      previous: from
    }
  };
}

/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */
function handleHistorySpanListener(replay) {
  return handlerData => {
    if (!replay.isEnabled()) {
      return;
    }
    const result = handleHistory(handlerData);
    if (result === null) {
      return;
    }

    // Need to collect visited URLs
    replay.getContext().urls.push(result.name);
    replay.triggerUserActivity();
    replay.addUpdate(() => {
      createPerformanceSpans(replay, [result]);
      // Returning false to flush
      return false;
    });
  };
}

/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */
function shouldFilterRequest(replay, url) {
  // If we enabled the `traceInternals` experiment, we want to trace everything
  if (DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) {
    return false;
  }
  return isSentryRequestUrl(url, (0,currentScopes/* getClient */.s3)());
}

/** Add a performance entry breadcrumb */
function addNetworkBreadcrumb(replay, result) {
  if (!replay.isEnabled()) {
    return;
  }
  if (result === null) {
    return;
  }
  if (shouldFilterRequest(replay, result.name)) {
    return;
  }
  replay.addUpdate(() => {
    createPerformanceSpans(replay, [result]);
    // Returning true will cause `addUpdate` to not flush
    // We do not want network requests to cause a flush. This will prevent
    // recurring/polling requests from keeping the replay session alive.
    return true;
  });
}

/** Get the size of a body. */
function getBodySize(body) {
  if (!body) {
    return undefined;
  }
  const textEncoder = new TextEncoder();
  try {
    if (typeof body === 'string') {
      return textEncoder.encode(body).length;
    }
    if (body instanceof URLSearchParams) {
      return textEncoder.encode(body.toString()).length;
    }
    if (body instanceof FormData) {
      const formDataStr = _serializeFormData(body);
      return textEncoder.encode(formDataStr).length;
    }
    if (body instanceof Blob) {
      return body.size;
    }
    if (body instanceof ArrayBuffer) {
      return body.byteLength;
    }

    // Currently unhandled types: ArrayBufferView, ReadableStream
  } catch (e) {
    // just return undefined
  }
  return undefined;
}

/** Convert a Content-Length header to number/undefined.  */
function parseContentLengthHeader(header) {
  if (!header) {
    return undefined;
  }
  const size = parseInt(header, 10);
  return isNaN(size) ? undefined : size;
}

/** Get the string representation of a body. */
function getBodyString(body) {
  try {
    if (typeof body === 'string') {
      return [body];
    }
    if (body instanceof URLSearchParams) {
      return [body.toString()];
    }
    if (body instanceof FormData) {
      return [_serializeFormData(body)];
    }
    if (!body) {
      return [undefined];
    }
  } catch (error) {
    DEBUG_BUILD && esm_logger.exception(error, 'Failed to serialize body', body);
    return [undefined, 'BODY_PARSE_ERROR'];
  }
  DEBUG_BUILD && esm_logger.info('Skipping network body because of body type', body);
  return [undefined, 'UNPARSEABLE_BODY_TYPE'];
}

/** Merge a warning into an existing network request/response. */
function mergeWarning(info, warning) {
  if (!info) {
    return {
      headers: {},
      size: undefined,
      _meta: {
        warnings: [warning]
      }
    };
  }
  const newMeta = {
    ...info._meta
  };
  const existingWarnings = newMeta.warnings || [];
  newMeta.warnings = [...existingWarnings, warning];
  info._meta = newMeta;
  return info;
}

/** Convert ReplayNetworkRequestData to a PerformanceEntry. */
function makeNetworkReplayBreadcrumb(type, data) {
  if (!data) {
    return null;
  }
  const {
    startTimestamp,
    endTimestamp,
    url,
    method,
    statusCode,
    request,
    response
  } = data;
  const result = {
    type,
    start: startTimestamp / 1000,
    end: endTimestamp / 1000,
    name: url,
    data: (0,object/* dropUndefinedKeys */.Jr)({
      method,
      statusCode,
      request,
      response
    })
  };
  return result;
}

/** Build the request or response part of a replay network breadcrumb that was skipped. */
function buildSkippedNetworkRequestOrResponse(bodySize) {
  return {
    headers: {},
    size: bodySize,
    _meta: {
      warnings: ['URL_SKIPPED']
    }
  };
}

/** Build the request or response part of a replay network breadcrumb. */
function buildNetworkRequestOrResponse(headers, bodySize, body) {
  if (!bodySize && Object.keys(headers).length === 0) {
    return undefined;
  }
  if (!bodySize) {
    return {
      headers
    };
  }
  if (!body) {
    return {
      headers,
      size: bodySize
    };
  }
  const info = {
    headers,
    size: bodySize
  };
  const {
    body: normalizedBody,
    warnings
  } = normalizeNetworkBody(body);
  info.body = normalizedBody;
  if (warnings && warnings.length > 0) {
    info._meta = {
      warnings
    };
  }
  return info;
}

/** Filter a set of headers */
function getAllowedHeaders(headers, allowedHeaders) {
  return Object.entries(headers).reduce((filteredHeaders, [key, value]) => {
    const normalizedKey = key.toLowerCase();
    // Avoid putting empty strings into the headers
    if (allowedHeaders.includes(normalizedKey) && headers[key]) {
      filteredHeaders[normalizedKey] = value;
    }
    return filteredHeaders;
  }, {});
}
function _serializeFormData(formData) {
  // This is a bit simplified, but gives us a decent estimate
  // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
  // @ts-expect-error passing FormData to URLSearchParams actually works
  return new URLSearchParams(formData).toString();
}
function normalizeNetworkBody(body) {
  if (!body || typeof body !== 'string') {
    return {
      body
    };
  }
  const exceedsSizeLimit = body.length > NETWORK_BODY_MAX_SIZE;
  const isProbablyJson = _strIsProbablyJson(body);
  if (exceedsSizeLimit) {
    const truncatedBody = body.slice(0, NETWORK_BODY_MAX_SIZE);
    if (isProbablyJson) {
      return {
        body: truncatedBody,
        warnings: ['MAYBE_JSON_TRUNCATED']
      };
    }
    return {
      body: `${truncatedBody}…`,
      warnings: ['TEXT_TRUNCATED']
    };
  }
  if (isProbablyJson) {
    try {
      const jsonBody = JSON.parse(body);
      return {
        body: jsonBody
      };
    } catch (e2) {
      // fall back to just send the body as string
    }
  }
  return {
    body
  };
}
function _strIsProbablyJson(str) {
  const first = str[0];
  const last = str[str.length - 1];

  // Simple check: If this does not start & end with {} or [], it's not JSON
  return first === '[' && last === ']' || first === '{' && last === '}';
}

/** Match an URL against a list of strings/Regex. */
function urlMatches(url, urls) {
  const fullUrl = getFullUrl(url);
  return (0,string/* stringMatchesSomePattern */.U0)(fullUrl, urls);
}

/** exported for tests */
function getFullUrl(url, baseURI = WINDOW.document.baseURI) {
  // Short circuit for common cases:
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith(WINDOW.location.origin)) {
    return url;
  }
  const fixedUrl = new URL(url, baseURI);

  // If these do not match, we are not dealing with a relative URL, so just return it
  if (fixedUrl.origin !== new URL(baseURI).origin) {
    return url;
  }
  const fullUrl = fixedUrl.href;

  // Remove trailing slashes, if they don't match the original URL
  if (!url.endsWith('/') && fullUrl.endsWith('/')) {
    return fullUrl.slice(0, -1);
  }
  return fullUrl;
}

/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where appropriate).
 */
async function captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
  try {
    const data = await _prepareFetchData(breadcrumb, hint, options);

    // Create a replay performance entry from this breadcrumb
    const result = makeNetworkReplayBreadcrumb('resource.fetch', data);
    addNetworkBreadcrumb(options.replay, result);
  } catch (error) {
    DEBUG_BUILD && esm_logger.exception(error, 'Failed to capture fetch breadcrumb');
  }
}

/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */
function enrichFetchBreadcrumb(breadcrumb, hint) {
  const {
    input,
    response
  } = hint;
  const body = input ? _getFetchRequestArgBody(input) : undefined;
  const reqSize = getBodySize(body);
  const resSize = response ? parseContentLengthHeader(response.headers.get('content-length')) : undefined;
  if (reqSize !== undefined) {
    breadcrumb.data.request_body_size = reqSize;
  }
  if (resSize !== undefined) {
    breadcrumb.data.response_body_size = resSize;
  }
}
async function _prepareFetchData(breadcrumb, hint, options) {
  const now = Date.now();
  const {
    startTimestamp = now,
    endTimestamp = now
  } = hint;
  const {
    url,
    method,
    status_code: statusCode = 0,
    request_body_size: requestBodySize,
    response_body_size: responseBodySize
  } = breadcrumb.data;
  const captureDetails = urlMatches(url, options.networkDetailAllowUrls) && !urlMatches(url, options.networkDetailDenyUrls);
  const request = captureDetails ? _getRequestInfo(options, hint.input, requestBodySize) : buildSkippedNetworkRequestOrResponse(requestBodySize);
  const response = await _getResponseInfo(captureDetails, options, hint.response, responseBodySize);
  return {
    startTimestamp,
    endTimestamp,
    url,
    method,
    statusCode,
    request,
    response
  };
}
function _getRequestInfo({
  networkCaptureBodies,
  networkRequestHeaders
}, input, requestBodySize) {
  const headers = input ? getRequestHeaders(input, networkRequestHeaders) : {};
  if (!networkCaptureBodies) {
    return buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
  }

  // We only want to transmit string or string-like bodies
  const requestBody = _getFetchRequestArgBody(input);
  const [bodyStr, warning] = getBodyString(requestBody);
  const data = buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
  if (warning) {
    return mergeWarning(data, warning);
  }
  return data;
}

/** Exported only for tests. */
async function _getResponseInfo(captureDetails, {
  networkCaptureBodies,
  networkResponseHeaders
}, response, responseBodySize) {
  if (!captureDetails && responseBodySize !== undefined) {
    return buildSkippedNetworkRequestOrResponse(responseBodySize);
  }
  const headers = response ? getAllHeaders(response.headers, networkResponseHeaders) : {};
  if (!response || !networkCaptureBodies && responseBodySize !== undefined) {
    return buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
  }
  const [bodyText, warning] = await _parseFetchResponseBody(response);
  const result = getResponseData(bodyText, {
    networkCaptureBodies,
    responseBodySize,
    captureDetails,
    headers
  });
  if (warning) {
    return mergeWarning(result, warning);
  }
  return result;
}
function getResponseData(bodyText, {
  networkCaptureBodies,
  responseBodySize,
  captureDetails,
  headers
}) {
  try {
    const size = bodyText && bodyText.length && responseBodySize === undefined ? getBodySize(bodyText) : responseBodySize;
    if (!captureDetails) {
      return buildSkippedNetworkRequestOrResponse(size);
    }
    if (networkCaptureBodies) {
      return buildNetworkRequestOrResponse(headers, size, bodyText);
    }
    return buildNetworkRequestOrResponse(headers, size, undefined);
  } catch (error) {
    DEBUG_BUILD && esm_logger.exception(error, 'Failed to serialize response body');
    // fallback
    return buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
  }
}
async function _parseFetchResponseBody(response) {
  const res = _tryCloneResponse(response);
  if (!res) {
    return [undefined, 'BODY_PARSE_ERROR'];
  }
  try {
    const text = await _tryGetResponseText(res);
    return [text];
  } catch (error) {
    if (error instanceof Error && error.message.indexOf('Timeout') > -1) {
      DEBUG_BUILD && esm_logger.warn('Parsing text body from response timed out');
      return [undefined, 'BODY_PARSE_TIMEOUT'];
    }
    DEBUG_BUILD && esm_logger.exception(error, 'Failed to get text body from response');
    return [undefined, 'BODY_PARSE_ERROR'];
  }
}
function _getFetchRequestArgBody(fetchArgs = []) {
  // We only support getting the body from the fetch options
  if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== 'object') {
    return undefined;
  }
  return fetchArgs[1].body;
}
function getAllHeaders(headers, allowedHeaders) {
  const allHeaders = {};
  allowedHeaders.forEach(header => {
    if (headers.get(header)) {
      allHeaders[header] = headers.get(header);
    }
  });
  return allHeaders;
}
function getRequestHeaders(fetchArgs, allowedHeaders) {
  if (fetchArgs.length === 1 && typeof fetchArgs[0] !== 'string') {
    return getHeadersFromOptions(fetchArgs[0], allowedHeaders);
  }
  if (fetchArgs.length === 2) {
    return getHeadersFromOptions(fetchArgs[1], allowedHeaders);
  }
  return {};
}
function getHeadersFromOptions(input, allowedHeaders) {
  if (!input) {
    return {};
  }
  const headers = input.headers;
  if (!headers) {
    return {};
  }
  if (headers instanceof Headers) {
    return getAllHeaders(headers, allowedHeaders);
  }

  // We do not support this, as it is not really documented (anymore?)
  if (Array.isArray(headers)) {
    return {};
  }
  return getAllowedHeaders(headers, allowedHeaders);
}
function _tryCloneResponse(response) {
  try {
    // We have to clone this, as the body can only be read once
    return response.clone();
  } catch (error) {
    // this can throw if the response was already consumed before
    DEBUG_BUILD && esm_logger.exception(error, 'Failed to clone response body');
  }
}

/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */
function _tryGetResponseText(response) {
  return new Promise((resolve, reject) => {
    const timeout = (0,getNativeImplementation/* setTimeout */.iK)(() => reject(new Error('Timeout while trying to read response body')), 500);
    _getResponseText(response).then(txt => resolve(txt), reason => reject(reason)).finally(() => clearTimeout(timeout));
  });
}
async function _getResponseText(response) {
  // Force this to be a promise, just to be safe
  // eslint-disable-next-line no-return-await
  return await response.text();
}

/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where appropriate).
 */
async function captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
  try {
    const data = _prepareXhrData(breadcrumb, hint, options);

    // Create a replay performance entry from this breadcrumb
    const result = makeNetworkReplayBreadcrumb('resource.xhr', data);
    addNetworkBreadcrumb(options.replay, result);
  } catch (error) {
    DEBUG_BUILD && esm_logger.exception(error, 'Failed to capture xhr breadcrumb');
  }
}

/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */
function enrichXhrBreadcrumb(breadcrumb, hint) {
  const {
    xhr,
    input
  } = hint;
  if (!xhr) {
    return;
  }
  const reqSize = getBodySize(input);
  const resSize = xhr.getResponseHeader('content-length') ? parseContentLengthHeader(xhr.getResponseHeader('content-length')) : _getBodySize(xhr.response, xhr.responseType);
  if (reqSize !== undefined) {
    breadcrumb.data.request_body_size = reqSize;
  }
  if (resSize !== undefined) {
    breadcrumb.data.response_body_size = resSize;
  }
}
function _prepareXhrData(breadcrumb, hint, options) {
  const now = Date.now();
  const {
    startTimestamp = now,
    endTimestamp = now,
    input,
    xhr
  } = hint;
  const {
    url,
    method,
    status_code: statusCode = 0,
    request_body_size: requestBodySize,
    response_body_size: responseBodySize
  } = breadcrumb.data;
  if (!url) {
    return null;
  }
  if (!xhr || !urlMatches(url, options.networkDetailAllowUrls) || urlMatches(url, options.networkDetailDenyUrls)) {
    const request = buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = buildSkippedNetworkRequestOrResponse(responseBodySize);
    return {
      startTimestamp,
      endTimestamp,
      url,
      method,
      statusCode,
      request,
      response
    };
  }
  const xhrInfo = xhr[instrument_xhr/* SENTRY_XHR_DATA_KEY */.xU];
  const networkRequestHeaders = xhrInfo ? getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
  const networkResponseHeaders = getAllowedHeaders(getResponseHeaders(xhr), options.networkResponseHeaders);
  const [requestBody, requestWarning] = options.networkCaptureBodies ? getBodyString(input) : [undefined];
  const [responseBody, responseWarning] = options.networkCaptureBodies ? _getXhrResponseBody(xhr) : [undefined];
  const request = buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
  const response = buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
  return {
    startTimestamp,
    endTimestamp,
    url,
    method,
    statusCode,
    request: requestWarning ? mergeWarning(request, requestWarning) : request,
    response: responseWarning ? mergeWarning(response, responseWarning) : response
  };
}
function getResponseHeaders(xhr) {
  const headers = xhr.getAllResponseHeaders();
  if (!headers) {
    return {};
  }
  return headers.split('\r\n').reduce((acc, line) => {
    const [key, value] = line.split(': ');
    if (value) {
      acc[key.toLowerCase()] = value;
    }
    return acc;
  }, {});
}
function _getXhrResponseBody(xhr) {
  // We collect errors that happen, but only log them if we can't get any response body
  const errors = [];
  try {
    return [xhr.responseText];
  } catch (e) {
    errors.push(e);
  }

  // Try to manually parse the response body, if responseText fails
  try {
    return _parseXhrResponse(xhr.response, xhr.responseType);
  } catch (e) {
    errors.push(e);
  }
  DEBUG_BUILD && esm_logger.warn('Failed to get xhr response body', ...errors);
  return [undefined];
}

/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */
function _parseXhrResponse(body, responseType) {
  try {
    if (typeof body === 'string') {
      return [body];
    }
    if (body instanceof Document) {
      return [body.body.outerHTML];
    }
    if (responseType === 'json' && body && typeof body === 'object') {
      return [JSON.stringify(body)];
    }
    if (!body) {
      return [undefined];
    }
  } catch (error) {
    DEBUG_BUILD && esm_logger.exception(error, 'Failed to serialize body', body);
    return [undefined, 'BODY_PARSE_ERROR'];
  }
  DEBUG_BUILD && esm_logger.info('Skipping network body because of body type', body);
  return [undefined, 'UNPARSEABLE_BODY_TYPE'];
}
function _getBodySize(body, responseType) {
  try {
    const bodyStr = responseType === 'json' && body && typeof body === 'object' ? JSON.stringify(body) : body;
    return getBodySize(bodyStr);
  } catch (e2) {
    return undefined;
  }
}

/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */
function handleNetworkBreadcrumbs(replay) {
  const client = (0,currentScopes/* getClient */.s3)();
  try {
    const {
      networkDetailAllowUrls,
      networkDetailDenyUrls,
      networkCaptureBodies,
      networkRequestHeaders,
      networkResponseHeaders
    } = replay.getOptions();
    const options = {
      replay,
      networkDetailAllowUrls,
      networkDetailDenyUrls,
      networkCaptureBodies,
      networkRequestHeaders,
      networkResponseHeaders
    };
    if (client) {
      client.on('beforeAddBreadcrumb', (breadcrumb, hint) => beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
    }
  } catch (e2) {
    // Do nothing
  }
}

/** just exported for tests */
function beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
  if (!breadcrumb.data) {
    return;
  }
  try {
    if (_isXhrBreadcrumb(breadcrumb) && _isXhrHint(hint)) {
      // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
      // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
      // So any async mutations to it will not be reflected in the final breadcrumb
      enrichXhrBreadcrumb(breadcrumb, hint);

      // This call should not reject
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
    }
    if (_isFetchBreadcrumb(breadcrumb) && _isFetchHint(hint)) {
      // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
      // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
      // So any async mutations to it will not be reflected in the final breadcrumb
      enrichFetchBreadcrumb(breadcrumb, hint);

      // This call should not reject
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
    }
  } catch (e) {
    DEBUG_BUILD && esm_logger.exception(e, 'Error when enriching network breadcrumb');
  }
}
function _isXhrBreadcrumb(breadcrumb) {
  return breadcrumb.category === 'xhr';
}
function _isFetchBreadcrumb(breadcrumb) {
  return breadcrumb.category === 'fetch';
}
function _isXhrHint(hint) {
  return hint && hint.xhr;
}
function _isFetchHint(hint) {
  return hint && hint.response;
}

/**
 * Add global listeners that cannot be removed.
 */
function addGlobalListeners(replay) {
  // Listeners from core SDK //
  const client = (0,currentScopes/* getClient */.s3)();
  (0,dom/* addClickKeypressInstrumentationHandler */.O)(handleDomListener(replay));
  (0,instrument_history/* addHistoryInstrumentationHandler */.a)(handleHistorySpanListener(replay));
  handleBreadcrumbs(replay);
  handleNetworkBreadcrumbs(replay);

  // Tag all (non replay) events that get sent to Sentry with the current
  // replay ID so that we can reference them later in the UI
  const eventProcessor = handleGlobalEventListener(replay);
  (0,esm_exports/* addEventProcessor */.Qy)(eventProcessor);

  // If a custom client has no hooks yet, we continue to use the "old" implementation
  if (client) {
    client.on('beforeSendEvent', handleBeforeSendEvent(replay));
    client.on('afterSendEvent', handleAfterSendEvent(replay));
    client.on('createDsc', dsc => {
      const replayId = replay.getSessionId();
      // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
      if (replayId && replay.isEnabled() && replay.recordingMode === 'session') {
        // Ensure to check that the session is still active - it could have expired in the meanwhile
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (isSessionActive) {
          dsc.replay_id = replayId;
        }
      }
    });
    client.on('spanStart', span => {
      replay.lastActiveSpan = span;
    });

    // We may be missing the initial spanStart due to timing issues,
    // so we capture it on finish again.
    client.on('spanEnd', span => {
      replay.lastActiveSpan = span;
    });

    // We want to flush replay
    client.on('beforeSendFeedback', (feedbackEvent, options) => {
      const replayId = replay.getSessionId();
      if (options && options.includeReplay && replay.isEnabled() && replayId) {
        // This should never reject
        if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) {
          feedbackEvent.contexts.feedback.replay_id = replayId;
        }
      }
    });
  }
}

/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */
async function addMemoryEntry(replay) {
  // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
  try {
    return Promise.all(createPerformanceSpans(replay, [
    // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
    createMemoryEntry(WINDOW.performance.memory)]));
  } catch (error) {
    // Do nothing
    return [];
  }
}
function createMemoryEntry(memoryEntry) {
  const {
    jsHeapSizeLimit,
    totalJSHeapSize,
    usedJSHeapSize
  } = memoryEntry;
  // we don't want to use `getAbsoluteTime` because it adds the event time to the
  // time origin, so we get the current timestamp instead
  const time = Date.now() / 1000;
  return {
    type: 'memory',
    name: 'memory',
    start: time,
    end: time,
    data: {
      memory: {
        jsHeapSizeLimit,
        totalJSHeapSize,
        usedJSHeapSize
      }
    }
  };
}

/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */
function debounce(func, wait, options) {
  let callbackReturnValue;
  let timerId;
  let maxTimerId;
  const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
  function invokeFunc() {
    cancelTimers();
    callbackReturnValue = func();
    return callbackReturnValue;
  }
  function cancelTimers() {
    timerId !== undefined && clearTimeout(timerId);
    maxTimerId !== undefined && clearTimeout(maxTimerId);
    timerId = maxTimerId = undefined;
  }
  function flush() {
    if (timerId !== undefined || maxTimerId !== undefined) {
      return invokeFunc();
    }
    return callbackReturnValue;
  }
  function debounced() {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = (0,getNativeImplementation/* setTimeout */.iK)(invokeFunc, wait);
    if (maxWait && maxTimerId === undefined) {
      maxTimerId = (0,getNativeImplementation/* setTimeout */.iK)(invokeFunc, maxWait);
    }
    return callbackReturnValue;
  }
  debounced.cancel = cancelTimers;
  debounced.flush = flush;
  return debounced;
}
const NAVIGATOR = worldwide/* GLOBAL_OBJ.navigator */.n.navigator;

/**
 *  Disable sampling mousemove events on iOS browsers as this can cause blocking the main thread
 *  https://github.com/getsentry/sentry-javascript/issues/14534
 */
function getRecordingSamplingOptions() {
  if (/iPhone|iPad|iPod/i.test(NAVIGATOR && NAVIGATOR.userAgent || '') || /Macintosh/i.test(NAVIGATOR && NAVIGATOR.userAgent || '') && NAVIGATOR && NAVIGATOR.maxTouchPoints && NAVIGATOR.maxTouchPoints > 1) {
    return {
      sampling: {
        mousemove: false
      }
    };
  }
  return {};
}

/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */
function getHandleRecordingEmit(replay) {
  let hadFirstEvent = false;
  return (event, _isCheckout) => {
    // If this is false, it means session is expired, create and a new session and wait for checkout
    if (!replay.checkAndHandleExpiredSession()) {
      DEBUG_BUILD && esm_logger.warn('Received replay event after session expired.');
      return;
    }

    // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
    // We also want to treat the first event as a checkout, so we handle this specifically here
    const isCheckout = _isCheckout || !hadFirstEvent;
    hadFirstEvent = true;
    if (replay.clickDetector) {
      updateClickDetectorForRecordingEvent(replay.clickDetector, event);
    }

    // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
    replay.addUpdate(() => {
      // The session is always started immediately on pageload/init, but for
      // error-only replays, it should reflect the most recent checkout
      // when an error occurs. Clear any state that happens before this current
      // checkout. This needs to happen before `addEvent()` which updates state
      // dependent on this reset.
      if (replay.recordingMode === 'buffer' && isCheckout) {
        replay.setInitialState();
      }

      // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
      // Skip all further steps
      if (!addEventSync(replay, event, isCheckout)) {
        // Return true to skip scheduling a debounced flush
        return true;
      }

      // Different behavior for full snapshots (type=2), ignore other event types
      // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
      if (!isCheckout) {
        return false;
      }
      const session = replay.session;

      // Additionally, create a meta event that will capture certain SDK settings.
      // In order to handle buffer mode, this needs to either be done when we
      // receive checkout events or at flush time. We have an experimental mode
      // to perform multiple checkouts a session (the idea is to improve
      // seeking during playback), so also only include if segmentId is 0
      // (handled in `addSettingsEvent`).
      //
      // `isCheckout` is always true, but want to be explicit that it should
      // only be added for checkouts
      addSettingsEvent(replay, isCheckout);

      // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
      // this should usually be the timestamp of the checkout event, but to be safe...
      if (replay.recordingMode === 'buffer' && session && replay.eventBuffer) {
        const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
        if (earliestEvent) {
          DEBUG_BUILD && esm_logger.info(`Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`);
          session.started = earliestEvent;
          if (replay.getOptions().stickySession) {
            saveSession(session);
          }
        }
      }

      // If there is a previousSessionId after a full snapshot occurs, then
      // the replay session was started due to session expiration. The new session
      // is started before triggering a new checkout and contains the id
      // of the previous session. Do not immediately flush in this case
      // to avoid capturing only the checkout and instead the replay will
      // be captured if they perform any follow-up actions.
      if (session && session.previousSessionId) {
        return true;
      }
      if (replay.recordingMode === 'session') {
        // If the full snapshot is due to an initial load, we will not have
        // a previous session ID. In this case, we want to buffer events
        // for a set amount of time before flushing. This can help avoid
        // capturing replays of users that immediately close the window.

        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        void replay.flush();
      }
      return true;
    });
  };
}

/**
 * Exported for tests
 */
function createOptionsEvent(replay) {
  const options = replay.getOptions();
  return {
    type: EventType.Custom,
    timestamp: Date.now(),
    data: {
      tag: 'options',
      payload: {
        shouldRecordCanvas: replay.isRecordingCanvas(),
        sessionSampleRate: options.sessionSampleRate,
        errorSampleRate: options.errorSampleRate,
        useCompressionOption: options.useCompression,
        blockAllMedia: options.blockAllMedia,
        maskAllText: options.maskAllText,
        maskAllInputs: options.maskAllInputs,
        useCompression: replay.eventBuffer ? replay.eventBuffer.type === 'worker' : false,
        networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
        networkCaptureBodies: options.networkCaptureBodies,
        networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
        networkResponseHasHeaders: options.networkResponseHeaders.length > 0
      }
    }
  };
}

/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */
function addSettingsEvent(replay, isCheckout) {
  // Only need to add this event when sending the first segment
  if (!isCheckout || !replay.session || replay.session.segmentId !== 0) {
    return;
  }
  addEventSync(replay, createOptionsEvent(replay), false);
}

/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */
function createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
  return (0,envelope/* createEnvelope */.Jd)((0,envelope/* createEventEnvelopeHeaders */.Cd)(replayEvent, (0,envelope/* getSdkMetadataForEnvelopeHeader */.HY)(replayEvent), tunnel, dsn), [[{
    type: 'replay_event'
  }, replayEvent], [{
    type: 'replay_recording',
    // If string then we need to encode to UTF8, otherwise will have
    // wrong size. TextEncoder has similar browser support to
    // MutationObserver, although it does not accept IE11.
    length: typeof recordingData === 'string' ? new TextEncoder().encode(recordingData).length : recordingData.length
  }, recordingData]]);
}

/**
 * Prepare the recording data ready to be sent.
 */
function prepareRecordingData({
  recordingData,
  headers
}) {
  let payloadWithSequence;

  // XXX: newline is needed to separate sequence id from events
  const replayHeaders = `${JSON.stringify(headers)}
`;
  if (typeof recordingData === 'string') {
    payloadWithSequence = `${replayHeaders}${recordingData}`;
  } else {
    const enc = new TextEncoder();
    // XXX: newline is needed to separate sequence id from events
    const sequence = enc.encode(replayHeaders);
    // Merge the two Uint8Arrays
    payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
    payloadWithSequence.set(sequence);
    payloadWithSequence.set(recordingData, sequence.length);
  }
  return payloadWithSequence;
}

/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */
async function prepareReplayEvent({
  client,
  scope,
  replayId: event_id,
  event
}) {
  const integrations = typeof client._integrations === 'object' && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
  const eventHint = {
    event_id,
    integrations
  };
  client.emit('preprocessEvent', event, eventHint);
  const preparedEvent = await (0,prepareEvent/* prepareEvent */.R)(client.getOptions(), event, eventHint, scope, client, (0,currentScopes/* getIsolationScope */.aF)());

  // If e.g. a global event processor returned null
  if (!preparedEvent) {
    return null;
  }

  // This normally happens in browser client "_prepareEvent"
  // but since we do not use this private method from the client, but rather the plain import
  // we need to do this manually.
  preparedEvent.platform = preparedEvent.platform || 'javascript';

  // extract the SDK name because `client._prepareEvent` doesn't add it to the event
  const metadata = client.getSdkMetadata();
  const {
    name,
    version
  } = metadata && metadata.sdk || {};
  preparedEvent.sdk = {
    ...preparedEvent.sdk,
    name: name || 'sentry.javascript.unknown',
    version: version || '0.0.0'
  };
  return preparedEvent;
}

/**
 * Send replay attachment using `fetch()`
 */
async function sendReplayRequest({
  recordingData,
  replayId,
  segmentId: segment_id,
  eventContext,
  timestamp,
  session
}) {
  const preparedRecordingData = prepareRecordingData({
    recordingData,
    headers: {
      segment_id
    }
  });
  const {
    urls,
    errorIds,
    traceIds,
    initialTimestamp
  } = eventContext;
  const client = (0,currentScopes/* getClient */.s3)();
  const scope = (0,currentScopes/* getCurrentScope */.nZ)();
  const transport = client && client.getTransport();
  const dsn = client && client.getDsn();
  if (!client || !transport || !dsn || !session.sampled) {
    return (0,syncpromise/* resolvedSyncPromise */.WD)({});
  }
  const baseEvent = {
    type: REPLAY_EVENT_NAME,
    replay_start_timestamp: initialTimestamp / 1000,
    timestamp: timestamp / 1000,
    error_ids: errorIds,
    trace_ids: traceIds,
    urls,
    replay_id: replayId,
    segment_id,
    replay_type: session.sampled
  };
  const replayEvent = await prepareReplayEvent({
    scope,
    client,
    replayId,
    event: baseEvent
  });
  if (!replayEvent) {
    // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
    client.recordDroppedEvent('event_processor', 'replay', baseEvent);
    DEBUG_BUILD && esm_logger.info('An event processor returned `null`, will not send event.');
    return (0,syncpromise/* resolvedSyncPromise */.WD)({});
  }

  /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete replayEvent.sdkProcessingMetadata;
  const envelope = createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
  let response;
  try {
    response = await transport.send(envelope);
  } catch (err) {
    const error = new Error(UNABLE_TO_SEND_REPLAY);
    try {
      // In case browsers don't allow this property to be writable
      // @ts-expect-error This needs lib es2022 and newer
      error.cause = err;
    } catch (e) {
      // nothing to do
    }
    throw error;
  }

  // If the status code is invalid, we want to immediately stop & not retry
  if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) {
    throw new TransportStatusCodeError(response.statusCode);
  }
  const rateLimits = (0,ratelimit/* updateRateLimits */.WG)({}, response);
  if ((0,ratelimit/* isRateLimited */.Q)(rateLimits, 'replay')) {
    throw new RateLimitError(rateLimits);
  }
  return response;
}

/**
 * This error indicates that the transport returned an invalid status code.
 */
class TransportStatusCodeError extends Error {
  constructor(statusCode) {
    super(`Transport returned status code ${statusCode}`);
  }
}

/**
 * This error indicates that we hit a rate limit API error.
 */
class RateLimitError extends Error {
  constructor(rateLimits) {
    super('Rate limit hit');
    this.rateLimits = rateLimits;
  }
}

/**
 * Finalize and send the current replay event to Sentry
 */
async function sendReplay(replayData, retryConfig = {
  count: 0,
  interval: RETRY_BASE_INTERVAL
}) {
  const {
    recordingData,
    onError
  } = replayData;

  // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
  if (!recordingData.length) {
    return;
  }
  try {
    await sendReplayRequest(replayData);
    return true;
  } catch (err) {
    if (err instanceof TransportStatusCodeError || err instanceof RateLimitError) {
      throw err;
    }

    // Capture error for every failed replay
    (0,esm_exports/* setContext */.v)('Replays', {
      _retryCount: retryConfig.count
    });
    if (onError) {
      onError(err);
    }

    // If an error happened here, it's likely that uploading the attachment
    // failed, we'll can retry with the same events payload
    if (retryConfig.count >= RETRY_MAX_COUNT) {
      const error = new Error(`${UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
      try {
        // In case browsers don't allow this property to be writable
        // @ts-expect-error This needs lib es2022 and newer
        error.cause = err;
      } catch (e) {
        // nothing to do
      }
      throw error;
    }

    // will retry in intervals of 5, 10, 30
    retryConfig.interval *= ++retryConfig.count;
    return new Promise((resolve, reject) => {
      (0,getNativeImplementation/* setTimeout */.iK)(async () => {
        try {
          await sendReplay(replayData, retryConfig);
          resolve(true);
        } catch (err) {
          reject(err);
        }
      }, retryConfig.interval);
    });
  }
}
const THROTTLED = '__THROTTLED';
const SKIPPED = '__SKIPPED';

/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function throttle(fn, maxCount, durationSeconds) {
  const counter = new Map();
  const _cleanup = now => {
    const threshold = now - durationSeconds;
    counter.forEach((_value, key) => {
      if (key < threshold) {
        counter.delete(key);
      }
    });
  };
  const _getTotalCount = () => {
    return [...counter.values()].reduce((a, b) => a + b, 0);
  };
  let isThrottled = false;
  return (...rest) => {
    // Date in second-precision, which we use as basis for the throttling
    const now = Math.floor(Date.now() / 1000);

    // First, make sure to delete any old entries
    _cleanup(now);

    // If already over limit, do nothing
    if (_getTotalCount() >= maxCount) {
      const wasThrottled = isThrottled;
      isThrottled = true;
      return wasThrottled ? SKIPPED : THROTTLED;
    }
    isThrottled = false;
    const count = counter.get(now) || 0;
    counter.set(now, count + 1);
    return fn(...rest);
  };
}

/* eslint-disable max-lines */ // TODO: We might want to split this file up

/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */
class ReplayContainer {
  /**
   * Recording can happen in one of two modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */

  /**
   * The current or last active span.
   * This is only available when performance is enabled.
   */

  /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */

  /** The replay has to be manually started, because no sample rate (neither session or error) was provided. */

  /**
   * Options to pass to `rrweb.record()`
   */

  /**
   * Timestamp of the last user activity. This lives across sessions.
   */

  /**
   * Is the integration currently active?
   */

  /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */

  /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */

  /**
   * Function to stop recording
   */

  /**
   * Internal use for canvas recording options
   */

  constructor({
    options,
    recordingOptions
  }) {
    ReplayContainer.prototype.__init.call(this);
    ReplayContainer.prototype.__init2.call(this);
    ReplayContainer.prototype.__init3.call(this);
    ReplayContainer.prototype.__init4.call(this);
    ReplayContainer.prototype.__init5.call(this);
    ReplayContainer.prototype.__init6.call(this);
    this.eventBuffer = null;
    this.performanceEntries = [];
    this.replayPerformanceEntries = [];
    this.recordingMode = 'session';
    this.timeouts = {
      sessionIdlePause: SESSION_IDLE_PAUSE_DURATION,
      sessionIdleExpire: SESSION_IDLE_EXPIRE_DURATION
    };
    this._lastActivity = Date.now();
    this._isEnabled = false;
    this._isPaused = false;
    this._requiresManualStart = false;
    this._hasInitializedCoreListeners = false;
    this._context = {
      errorIds: new Set(),
      traceIds: new Set(),
      urls: [],
      initialTimestamp: Date.now(),
      initialUrl: ''
    };
    this._recordingOptions = recordingOptions;
    this._options = options;
    this._debouncedFlush = debounce(() => this._flush(), this._options.flushMinDelay, {
      maxWait: this._options.flushMaxDelay
    });
    this._throttledAddEvent = throttle((event, isCheckout) => addEvent(this, event, isCheckout),
    // Max 300 events...
    300,
    // ... per 5s
    5);
    const {
      slowClickTimeout,
      slowClickIgnoreSelectors
    } = this.getOptions();
    const slowClickConfig = slowClickTimeout ? {
      threshold: Math.min(SLOW_CLICK_THRESHOLD, slowClickTimeout),
      timeout: slowClickTimeout,
      scrollTimeout: SLOW_CLICK_SCROLL_TIMEOUT,
      ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(',') : ''
    } : undefined;
    if (slowClickConfig) {
      this.clickDetector = new ClickDetector(this, slowClickConfig);
    }

    // Configure replay logger w/ experimental options
    if (DEBUG_BUILD) {
      const experiments = options._experiments;
      esm_logger.setConfig({
        captureExceptions: !!experiments.captureExceptions,
        traceInternals: !!experiments.traceInternals
      });
    }
  }

  /** Get the event context. */
  getContext() {
    return this._context;
  }

  /** If recording is currently enabled. */
  isEnabled() {
    return this._isEnabled;
  }

  /** If recording is currently paused. */
  isPaused() {
    return this._isPaused;
  }

  /**
   * Determine if canvas recording is enabled
   */
  isRecordingCanvas() {
    return Boolean(this._canvas);
  }

  /** Get the replay integration options. */
  getOptions() {
    return this._options;
  }

  /** A wrapper to conditionally capture exceptions. */
  handleException(error) {
    DEBUG_BUILD && esm_logger.exception(error);
    if (this._options.onError) {
      this._options.onError(error);
    }
  }

  /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */
  initializeSampling(previousSessionId) {
    const {
      errorSampleRate,
      sessionSampleRate
    } = this._options;

    // If neither sample rate is > 0, then do nothing - user will need to call one of
    // `start()` or `startBuffering` themselves.
    const requiresManualStart = errorSampleRate <= 0 && sessionSampleRate <= 0;
    this._requiresManualStart = requiresManualStart;
    if (requiresManualStart) {
      return;
    }

    // Otherwise if there is _any_ sample rate set, try to load an existing
    // session, or create a new one.
    this._initializeSessionForSampling(previousSessionId);
    if (!this.session) {
      // This should not happen, something wrong has occurred
      DEBUG_BUILD && esm_logger.exception(new Error('Unable to initialize and create session'));
      return;
    }
    if (this.session.sampled === false) {
      // This should only occur if `errorSampleRate` is 0 and was unsampled for
      // session-based replay. In this case there is nothing to do.
      return;
    }

    // If segmentId > 0, it means we've previously already captured this session
    // In this case, we still want to continue in `session` recording mode
    this.recordingMode = this.session.sampled === 'buffer' && this.session.segmentId === 0 ? 'buffer' : 'session';
    DEBUG_BUILD && esm_logger.infoTick(`Starting replay in ${this.recordingMode} mode`);
    this._initializeRecording();
  }

  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */
  start() {
    if (this._isEnabled && this.recordingMode === 'session') {
      DEBUG_BUILD && esm_logger.info('Recording is already in progress');
      return;
    }
    if (this._isEnabled && this.recordingMode === 'buffer') {
      DEBUG_BUILD && esm_logger.info('Buffering is in progress, call `flush()` to save the replay');
      return;
    }
    DEBUG_BUILD && esm_logger.infoTick('Starting replay in session mode');

    // Required as user activity is initially set in
    // constructor, so if `start()` is called after
    // session idle expiration, a replay will not be
    // created due to an idle timeout.
    this._updateUserActivity();
    const session = loadOrCreateSession({
      maxReplayDuration: this._options.maxReplayDuration,
      sessionIdleExpire: this.timeouts.sessionIdleExpire
    }, {
      stickySession: this._options.stickySession,
      // This is intentional: create a new session-based replay when calling `start()`
      sessionSampleRate: 1,
      allowBuffering: false
    });
    this.session = session;
    this._initializeRecording();
  }

  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */
  startBuffering() {
    if (this._isEnabled) {
      DEBUG_BUILD && esm_logger.info('Buffering is in progress, call `flush()` to save the replay');
      return;
    }
    DEBUG_BUILD && esm_logger.infoTick('Starting replay in buffer mode');
    const session = loadOrCreateSession({
      sessionIdleExpire: this.timeouts.sessionIdleExpire,
      maxReplayDuration: this._options.maxReplayDuration
    }, {
      stickySession: this._options.stickySession,
      sessionSampleRate: 0,
      allowBuffering: true
    });
    this.session = session;
    this.recordingMode = 'buffer';
    this._initializeRecording();
  }

  /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */
  startRecording() {
    try {
      const canvasOptions = this._canvas;
      this._stopRecording = record({
        ...this._recordingOptions,
        // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
        // Without this, it would record forever, until an error happens, which we don't want
        // instead, we'll always keep the last 60 seconds of replay before an error happened
        ...(this.recordingMode === 'buffer' ? {
          checkoutEveryNms: BUFFER_CHECKOUT_TIME
        } :
        // Otherwise, use experimental option w/ min checkout time of 6 minutes
        // This is to improve playback seeking as there could potentially be
        // less mutations to process in the worse cases.
        //
        // checkout by "N" events is probably ideal, but means we have less
        // control about the number of checkouts we make (which generally
        // increases replay size)
        this._options._experiments.continuousCheckout && {
          // Minimum checkout time is 6 minutes
          checkoutEveryNms: Math.max(360000, this._options._experiments.continuousCheckout)
        }),
        emit: getHandleRecordingEmit(this),
        ...getRecordingSamplingOptions(),
        onMutation: this._onMutationHandler,
        ...(canvasOptions ? {
          recordCanvas: canvasOptions.recordCanvas,
          getCanvasManager: canvasOptions.getCanvasManager,
          sampling: canvasOptions.sampling,
          dataURLOptions: canvasOptions.dataURLOptions
        } : {})
      });
    } catch (err) {
      this.handleException(err);
    }
  }

  /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */
  stopRecording() {
    try {
      if (this._stopRecording) {
        this._stopRecording();
        this._stopRecording = undefined;
      }
      return true;
    } catch (err) {
      this.handleException(err);
      return false;
    }
  }

  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
  async stop({
    forceFlush = false,
    reason
  } = {}) {
    if (!this._isEnabled) {
      return;
    }

    // We can't move `_isEnabled` after awaiting a flush, otherwise we can
    // enter into an infinite loop when `stop()` is called while flushing.
    this._isEnabled = false;
    try {
      DEBUG_BUILD && esm_logger.info(`Stopping Replay${reason ? ` triggered by ${reason}` : ''}`);
      resetReplayIdOnDynamicSamplingContext();
      this._removeListeners();
      this.stopRecording();
      this._debouncedFlush.cancel();
      // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
      // `_isEnabled` state of the plugin since it was disabled above.
      if (forceFlush) {
        await this._flush({
          force: true
        });
      }

      // After flush, destroy event buffer
      this.eventBuffer && this.eventBuffer.destroy();
      this.eventBuffer = null;

      // Clear session from session storage, note this means if a new session
      // is started after, it will not have `previousSessionId`
      clearSession(this);
    } catch (err) {
      this.handleException(err);
    }
  }

  /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */
  pause() {
    if (this._isPaused) {
      return;
    }
    this._isPaused = true;
    this.stopRecording();
    DEBUG_BUILD && esm_logger.info('Pausing replay');
  }

  /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */
  resume() {
    if (!this._isPaused || !this._checkSession()) {
      return;
    }
    this._isPaused = false;
    this.startRecording();
    DEBUG_BUILD && esm_logger.info('Resuming replay');
  }

  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
  async sendBufferedReplayOrFlush({
    continueRecording = true
  } = {}) {
    if (this.recordingMode === 'session') {
      return this.flushImmediate();
    }
    const activityTime = Date.now();
    DEBUG_BUILD && esm_logger.info('Converting buffer to session');

    // Allow flush to complete before resuming as a session recording, otherwise
    // the checkout from `startRecording` may be included in the payload.
    // Prefer to keep the error replay as a separate (and smaller) segment
    // than the session replay.
    await this.flushImmediate();
    const hasStoppedRecording = this.stopRecording();
    if (!continueRecording || !hasStoppedRecording) {
      return;
    }

    // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
    if (this.recordingMode === 'session') {
      return;
    }

    // Re-start recording in session-mode
    this.recordingMode = 'session';

    // Once this session ends, we do not want to refresh it
    if (this.session) {
      this._updateUserActivity(activityTime);
      this._updateSessionActivity(activityTime);
      this._maybeSaveSession();
    }
    this.startRecording();
  }

  /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */
  addUpdate(cb) {
    // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
    const cbResult = cb();

    // If this option is turned on then we will only want to call `flush`
    // explicitly
    if (this.recordingMode === 'buffer') {
      return;
    }

    // If callback is true, we do not want to continue with flushing -- the
    // caller will need to handle it.
    if (cbResult === true) {
      return;
    }

    // addUpdate is called quite frequently - use _debouncedFlush so that it
    // respects the flush delays and does not flush immediately
    this._debouncedFlush();
  }

  /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */
  triggerUserActivity() {
    this._updateUserActivity();

    // This case means that recording was once stopped due to inactivity.
    // Ensure that recording is resumed.
    if (!this._stopRecording) {
      // Create a new session, otherwise when the user action is flushed, it
      // will get rejected due to an expired session.
      if (!this._checkSession()) {
        return;
      }

      // Note: This will cause a new DOM checkout
      this.resume();
      return;
    }

    // Otherwise... recording was never suspended, continue as normalish
    this.checkAndHandleExpiredSession();
    this._updateSessionActivity();
  }

  /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */
  updateUserActivity() {
    this._updateUserActivity();
    this._updateSessionActivity();
  }

  /**
   * Only flush if `this.recordingMode === 'session'`
   */
  conditionalFlush() {
    if (this.recordingMode === 'buffer') {
      return Promise.resolve();
    }
    return this.flushImmediate();
  }

  /**
   * Flush using debounce flush
   */
  flush() {
    return this._debouncedFlush();
  }

  /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of multiple flushes happening closely together.
   */
  flushImmediate() {
    this._debouncedFlush();
    // `.flush` is provided by the debounced function, analogously to lodash.debounce
    return this._debouncedFlush.flush();
  }

  /**
   * Cancels queued up flushes.
   */
  cancelFlush() {
    this._debouncedFlush.cancel();
  }

  /** Get the current session (=replay) ID */
  getSessionId() {
    return this.session && this.session.id;
  }

  /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */
  checkAndHandleExpiredSession() {
    // Prevent starting a new session if the last user activity is older than
    // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
    // session+recording. This creates noisy replays that do not have much
    // content in them.
    if (this._lastActivity && isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === 'session') {
      // Pause recording only for session-based replays. Otherwise, resuming
      // will create a new replay and will conflict with users who only choose
      // to record error-based replays only. (e.g. the resumed replay will not
      // contain a reference to an error)
      this.pause();
      return;
    }

    // --- There is recent user activity --- //
    // This will create a new session if expired, based on expiry length
    if (!this._checkSession()) {
      // Check session handles the refreshing itself
      return false;
    }
    return true;
  }

  /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */
  setInitialState() {
    const urlPath = `${WINDOW.location.pathname}${WINDOW.location.hash}${WINDOW.location.search}`;
    const url = `${WINDOW.location.origin}${urlPath}`;
    this.performanceEntries = [];
    this.replayPerformanceEntries = [];

    // Reset _context as well
    this._clearContext();
    this._context.initialUrl = url;
    this._context.initialTimestamp = Date.now();
    this._context.urls.push(url);
  }

  /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */
  throttledAddEvent(event, isCheckout) {
    const res = this._throttledAddEvent(event, isCheckout);

    // If this is THROTTLED, it means we have throttled the event for the first time
    // In this case, we want to add a breadcrumb indicating that something was skipped
    if (res === THROTTLED) {
      const breadcrumb = createBreadcrumb({
        category: 'replay.throttled'
      });
      this.addUpdate(() => {
        // Return `false` if the event _was_ added, as that means we schedule a flush
        return !addEventSync(this, {
          type: ReplayEventTypeCustom,
          timestamp: breadcrumb.timestamp || 0,
          data: {
            tag: 'breadcrumb',
            payload: breadcrumb,
            metric: true
          }
        });
      });
    }
    return res;
  }

  /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */
  getCurrentRoute() {
    const lastActiveSpan = this.lastActiveSpan || (0,spanUtils/* getActiveSpan */.HN)();
    const lastRootSpan = lastActiveSpan && (0,spanUtils/* getRootSpan */.Gx)(lastActiveSpan);
    const attributes = lastRootSpan && (0,spanUtils/* spanToJSON */.XU)(lastRootSpan).data || {};
    const source = attributes[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj];
    if (!lastRootSpan || !source || !['route', 'custom'].includes(source)) {
      return undefined;
    }
    return (0,spanUtils/* spanToJSON */.XU)(lastRootSpan).description;
  }

  /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */
  _initializeRecording() {
    this.setInitialState();

    // this method is generally called on page load or manually - in both cases
    // we should treat it as an activity
    this._updateSessionActivity();
    this.eventBuffer = createEventBuffer({
      useCompression: this._options.useCompression,
      workerUrl: this._options.workerUrl
    });
    this._removeListeners();
    this._addListeners();

    // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
    this._isEnabled = true;
    this._isPaused = false;
    this.startRecording();
  }

  /**
   * Loads (or refreshes) the current session.
   */
  _initializeSessionForSampling(previousSessionId) {
    // Whenever there is _any_ error sample rate, we always allow buffering
    // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
    const allowBuffering = this._options.errorSampleRate > 0;
    const session = loadOrCreateSession({
      sessionIdleExpire: this.timeouts.sessionIdleExpire,
      maxReplayDuration: this._options.maxReplayDuration,
      previousSessionId
    }, {
      stickySession: this._options.stickySession,
      sessionSampleRate: this._options.sessionSampleRate,
      allowBuffering
    });
    this.session = session;
  }

  /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */
  _checkSession() {
    // If there is no session yet, we do not want to refresh anything
    // This should generally not happen, but to be safe....
    if (!this.session) {
      return false;
    }
    const currentSession = this.session;
    if (shouldRefreshSession(currentSession, {
      sessionIdleExpire: this.timeouts.sessionIdleExpire,
      maxReplayDuration: this._options.maxReplayDuration
    })) {
      // This should never reject
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this._refreshSession(currentSession);
      return false;
    }
    return true;
  }

  /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */
  async _refreshSession(session) {
    if (!this._isEnabled) {
      return;
    }
    await this.stop({
      reason: 'refresh session'
    });
    this.initializeSampling(session.id);
  }

  /**
   * Adds listeners to record events for the replay
   */
  _addListeners() {
    try {
      WINDOW.document.addEventListener('visibilitychange', this._handleVisibilityChange);
      WINDOW.addEventListener('blur', this._handleWindowBlur);
      WINDOW.addEventListener('focus', this._handleWindowFocus);
      WINDOW.addEventListener('keydown', this._handleKeyboardEvent);
      if (this.clickDetector) {
        this.clickDetector.addListeners();
      }

      // There is no way to remove these listeners, so ensure they are only added once
      if (!this._hasInitializedCoreListeners) {
        addGlobalListeners(this);
        this._hasInitializedCoreListeners = true;
      }
    } catch (err) {
      this.handleException(err);
    }
    this._performanceCleanupCallback = setupPerformanceObserver(this);
  }

  /**
   * Cleans up listeners that were created in `_addListeners`
   */
  _removeListeners() {
    try {
      WINDOW.document.removeEventListener('visibilitychange', this._handleVisibilityChange);
      WINDOW.removeEventListener('blur', this._handleWindowBlur);
      WINDOW.removeEventListener('focus', this._handleWindowFocus);
      WINDOW.removeEventListener('keydown', this._handleKeyboardEvent);
      if (this.clickDetector) {
        this.clickDetector.removeListeners();
      }
      if (this._performanceCleanupCallback) {
        this._performanceCleanupCallback();
      }
    } catch (err) {
      this.handleException(err);
    }
  }

  /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */
  __init() {
    this._handleVisibilityChange = () => {
      if (WINDOW.document.visibilityState === 'visible') {
        this._doChangeToForegroundTasks();
      } else {
        this._doChangeToBackgroundTasks();
      }
    };
  }

  /**
   * Handle when page is blurred
   */
  __init2() {
    this._handleWindowBlur = () => {
      const breadcrumb = createBreadcrumb({
        category: 'ui.blur'
      });

      // Do not count blur as a user action -- it's part of the process of them
      // leaving the page
      this._doChangeToBackgroundTasks(breadcrumb);
    };
  }

  /**
   * Handle when page is focused
   */
  __init3() {
    this._handleWindowFocus = () => {
      const breadcrumb = createBreadcrumb({
        category: 'ui.focus'
      });

      // Do not count focus as a user action -- instead wait until they focus and
      // interactive with page
      this._doChangeToForegroundTasks(breadcrumb);
    };
  }

  /** Ensure page remains active when a key is pressed. */
  __init4() {
    this._handleKeyboardEvent = event => {
      handleKeyboardEvent(this, event);
    };
  }

  /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */
  _doChangeToBackgroundTasks(breadcrumb) {
    if (!this.session) {
      return;
    }
    const expired = isSessionExpired(this.session, {
      maxReplayDuration: this._options.maxReplayDuration,
      sessionIdleExpire: this.timeouts.sessionIdleExpire
    });
    if (expired) {
      return;
    }
    if (breadcrumb) {
      this._createCustomBreadcrumb(breadcrumb);
    }

    // Send replay when the page/tab becomes hidden. There is no reason to send
    // replay if it becomes visible, since no actions we care about were done
    // while it was hidden
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    void this.conditionalFlush();
  }

  /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */
  _doChangeToForegroundTasks(breadcrumb) {
    if (!this.session) {
      return;
    }
    const isSessionActive = this.checkAndHandleExpiredSession();
    if (!isSessionActive) {
      // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
      // ms, we will re-use the existing session, otherwise create a new
      // session
      DEBUG_BUILD && esm_logger.info('Document has become active, but session has expired');
      return;
    }
    if (breadcrumb) {
      this._createCustomBreadcrumb(breadcrumb);
    }
  }

  /**
   * Update user activity (across session lifespans)
   */
  _updateUserActivity(_lastActivity = Date.now()) {
    this._lastActivity = _lastActivity;
  }

  /**
   * Updates the session's last activity timestamp
   */
  _updateSessionActivity(_lastActivity = Date.now()) {
    if (this.session) {
      this.session.lastActivity = _lastActivity;
      this._maybeSaveSession();
    }
  }

  /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */
  _createCustomBreadcrumb(breadcrumb) {
    this.addUpdate(() => {
      // This should never reject
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.throttledAddEvent({
        type: EventType.Custom,
        timestamp: breadcrumb.timestamp || 0,
        data: {
          tag: 'breadcrumb',
          payload: breadcrumb
        }
      });
    });
  }

  /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */
  _addPerformanceEntries() {
    let performanceEntries = createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
    this.performanceEntries = [];
    this.replayPerformanceEntries = [];

    // If we are manually starting, we want to ensure we only include performance entries
    // that are after the initial timestamp
    // The reason for this is that we may have performance entries from the page load, but may decide to start
    // the replay later on, in which case we do not want to include these entries.
    // without this, manually started replays can have events long before the actual replay recording starts,
    // which messes with the timeline etc.
    if (this._requiresManualStart) {
      const initialTimestampInSeconds = this._context.initialTimestamp / 1000;
      performanceEntries = performanceEntries.filter(entry => entry.start >= initialTimestampInSeconds);
    }
    return Promise.all(createPerformanceSpans(this, performanceEntries));
  }

  /**
   * Clear _context
   */
  _clearContext() {
    // XXX: `initialTimestamp` and `initialUrl` do not get cleared
    this._context.errorIds.clear();
    this._context.traceIds.clear();
    this._context.urls = [];
  }

  /** Update the initial timestamp based on the buffer content. */
  _updateInitialTimestampFromEventBuffer() {
    const {
      session,
      eventBuffer
    } = this;
    // If replay was started manually (=no sample rate was given),
    // We do not want to back-port the initial timestamp
    if (!session || !eventBuffer || this._requiresManualStart) {
      return;
    }

    // we only ever update this on the initial segment
    if (session.segmentId) {
      return;
    }
    const earliestEvent = eventBuffer.getEarliestTimestamp();
    if (earliestEvent && earliestEvent < this._context.initialTimestamp) {
      this._context.initialTimestamp = earliestEvent;
    }
  }

  /**
   * Return and clear _context
   */
  _popEventContext() {
    const _context = {
      initialTimestamp: this._context.initialTimestamp,
      initialUrl: this._context.initialUrl,
      errorIds: Array.from(this._context.errorIds),
      traceIds: Array.from(this._context.traceIds),
      urls: this._context.urls
    };
    this._clearContext();
    return _context;
  }

  /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */
  async _runFlush() {
    const replayId = this.getSessionId();
    if (!this.session || !this.eventBuffer || !replayId) {
      DEBUG_BUILD && esm_logger.error('No session or eventBuffer found to flush.');
      return;
    }
    await this._addPerformanceEntries();

    // Check eventBuffer again, as it could have been stopped in the meanwhile
    if (!this.eventBuffer || !this.eventBuffer.hasEvents) {
      return;
    }

    // Only attach memory event if eventBuffer is not empty
    await addMemoryEntry(this);

    // Check eventBuffer again, as it could have been stopped in the meanwhile
    if (!this.eventBuffer) {
      return;
    }

    // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
    if (replayId !== this.getSessionId()) {
      return;
    }
    try {
      // This uses the data from the eventBuffer, so we need to call this before `finish()
      this._updateInitialTimestampFromEventBuffer();
      const timestamp = Date.now();

      // Check total duration again, to avoid sending outdated stuff
      // We leave 30s wiggle room to accommodate late flushing etc.
      // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
      if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) {
        throw new Error('Session is too long, not sending replay');
      }
      const eventContext = this._popEventContext();
      // Always increment segmentId regardless of outcome of sending replay
      const segmentId = this.session.segmentId++;
      this._maybeSaveSession();

      // Note this empties the event buffer regardless of outcome of sending replay
      const recordingData = await this.eventBuffer.finish();
      await sendReplay({
        replayId,
        recordingData,
        segmentId,
        eventContext,
        session: this.session,
        timestamp,
        onError: err => this.handleException(err)
      });
    } catch (err) {
      this.handleException(err);

      // This means we retried 3 times and all of them failed,
      // or we ran into a problem we don't want to retry, like rate limiting.
      // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
      // This should never reject
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.stop({
        reason: 'sendReplay'
      });
      const client = (0,currentScopes/* getClient */.s3)();
      if (client) {
        const dropReason = err instanceof RateLimitError ? 'ratelimit_backoff' : 'send_error';
        client.recordDroppedEvent(dropReason, 'replay');
      }
    }
  }

  /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */
  __init5() {
    this._flush = async ({
      force = false
    } = {}) => {
      if (!this._isEnabled && !force) {
        // This can happen if e.g. the replay was stopped because of exceeding the retry limit
        return;
      }
      if (!this.checkAndHandleExpiredSession()) {
        DEBUG_BUILD && esm_logger.error('Attempting to finish replay event after session expired.');
        return;
      }
      if (!this.session) {
        // should never happen, as we would have bailed out before
        return;
      }
      const start = this.session.started;
      const now = Date.now();
      const duration = now - start;

      // A flush is about to happen, cancel any queued flushes
      this._debouncedFlush.cancel();

      // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
      // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
      const tooShort = duration < this._options.minReplayDuration;
      const tooLong = duration > this._options.maxReplayDuration + 5000;
      if (tooShort || tooLong) {
        DEBUG_BUILD && esm_logger.info(`Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? 'short' : 'long'}, not sending replay.`);
        if (tooShort) {
          this._debouncedFlush();
        }
        return;
      }
      const eventBuffer = this.eventBuffer;
      if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) {
        DEBUG_BUILD && esm_logger.info('Flushing initial segment without checkout.');
        // TODO FN: Evaluate if we want to stop here, or remove this again?
      }
      const _flushInProgress = !!this._flushLock;

      // this._flushLock acts as a lock so that future calls to `_flush()` will
      // be blocked until current flush is finished (i.e. this promise resolves)
      if (!this._flushLock) {
        this._flushLock = this._runFlush();
      }
      try {
        await this._flushLock;
      } catch (err) {
        this.handleException(err);
      } finally {
        this._flushLock = undefined;
        if (_flushInProgress) {
          // Wait for previous flush to finish, then call the debounced
          // `_flush()`. It's possible there are other flush requests queued and
          // waiting for it to resolve. We want to reduce all outstanding
          // requests (as well as any new flush requests that occur within a
          // second of the locked flush completing) into a single flush.
          this._debouncedFlush();
        }
      }
    };
  }

  /** Save the session, if it is sticky */
  _maybeSaveSession() {
    if (this.session && this._options.stickySession) {
      saveSession(this.session);
    }
  }

  /** Handler for rrweb.record.onMutation */
  __init6() {
    this._onMutationHandler = mutations => {
      const count = mutations.length;
      const mutationLimit = this._options.mutationLimit;
      const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
      const overMutationLimit = mutationLimit && count > mutationLimit;

      // Create a breadcrumb if a lot of mutations happen at the same time
      // We can show this in the UI as an information with potential performance improvements
      if (count > mutationBreadcrumbLimit || overMutationLimit) {
        const breadcrumb = createBreadcrumb({
          category: 'replay.mutations',
          data: {
            count,
            limit: overMutationLimit
          }
        });
        this._createCustomBreadcrumb(breadcrumb);
      }

      // Stop replay if over the mutation limit
      if (overMutationLimit) {
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.stop({
          reason: 'mutationLimit',
          forceFlush: this.recordingMode === 'session'
        });
        return false;
      }

      // `true` means we use the regular mutation handling by rrweb
      return true;
    };
  }
}
function getOption(selectors, defaultSelectors) {
  return [...selectors,
  // sentry defaults
  ...defaultSelectors].join(',');
}

/**
 * Returns privacy related configuration for use in rrweb
 */
function getPrivacyOptions({
  mask,
  unmask,
  block,
  unblock,
  ignore
}) {
  const defaultBlockedElements = ['base', 'iframe[srcdoc]:not([src])'];
  const maskSelector = getOption(mask, ['.sentry-mask', '[data-sentry-mask]']);
  const unmaskSelector = getOption(unmask, []);
  const options = {
    // We are making the decision to make text and input selectors the same
    maskTextSelector: maskSelector,
    unmaskTextSelector: unmaskSelector,
    blockSelector: getOption(block, ['.sentry-block', '[data-sentry-block]', ...defaultBlockedElements]),
    unblockSelector: getOption(unblock, []),
    ignoreSelector: getOption(ignore, ['.sentry-ignore', '[data-sentry-ignore]', 'input[type="file"]'])
  };
  return options;
}

/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */
function maskAttribute({
  el,
  key,
  maskAttributes,
  maskAllText,
  privacyOptions,
  value
}) {
  // We only mask attributes if `maskAllText` is true
  if (!maskAllText) {
    return value;
  }

  // unmaskTextSelector takes precedence
  if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) {
    return value;
  }
  if (maskAttributes.includes(key) ||
  // Need to mask `value` attribute for `<input>` if it's a button-like
  // type
  key === 'value' && el.tagName === 'INPUT' && ['submit', 'button'].includes(el.getAttribute('type') || '')) {
    return value.replace(/[\S]/g, '*');
  }
  return value;
}
const MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const DEFAULT_NETWORK_HEADERS = ['content-length', 'content-type', 'accept'];
let _initialized = false;

/**
 * Sentry integration for [Session Replay](https://sentry.io/for/session-replay/).
 *
 * See the [Replay documentation](https://docs.sentry.io/platforms/javascript/guides/session-replay/) for more information.
 *
 * @example
 *
 * ```
 * Sentry.init({
 *   dsn: '__DSN__',
 *   integrations: [Sentry.replayIntegration()],
 * });
 * ```
 */
const replayIntegration = options => {
  return new Replay(options);
};

/**
 * Replay integration
 *
 * TODO: Rewrite this to be functional integration
 * Exported for tests.
 */
class Replay {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = 'Replay';
  }

  /**
   * @inheritDoc
   */

  /**
   * Options to pass to `rrweb.record()`
   */

  /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */

  constructor({
    flushMinDelay = DEFAULT_FLUSH_MIN_DELAY,
    flushMaxDelay = DEFAULT_FLUSH_MAX_DELAY,
    minReplayDuration = MIN_REPLAY_DURATION,
    maxReplayDuration = MAX_REPLAY_DURATION,
    stickySession = true,
    useCompression = true,
    workerUrl,
    _experiments = {},
    maskAllText = true,
    maskAllInputs = true,
    blockAllMedia = true,
    mutationBreadcrumbLimit = 750,
    mutationLimit = 10000,
    slowClickTimeout = 7000,
    slowClickIgnoreSelectors = [],
    networkDetailAllowUrls = [],
    networkDetailDenyUrls = [],
    networkCaptureBodies = true,
    networkRequestHeaders = [],
    networkResponseHeaders = [],
    mask = [],
    maskAttributes = ['title', 'placeholder'],
    unmask = [],
    block = [],
    unblock = [],
    ignore = [],
    maskFn,
    beforeAddRecordingEvent,
    beforeErrorSampling,
    onError
  } = {}) {
    this.name = Replay.id;
    const privacyOptions = getPrivacyOptions({
      mask,
      unmask,
      block,
      unblock,
      ignore
    });
    this._recordingOptions = {
      maskAllInputs,
      maskAllText,
      maskInputOptions: {
        password: true
      },
      maskTextFn: maskFn,
      maskInputFn: maskFn,
      maskAttributeFn: (key, value, el) => maskAttribute({
        maskAttributes,
        maskAllText,
        privacyOptions,
        key,
        value,
        el
      }),
      ...privacyOptions,
      // Our defaults
      slimDOMOptions: 'all',
      inlineStylesheet: true,
      // Disable inline images as it will increase segment/replay size
      inlineImages: false,
      // collect fonts, but be aware that `sentry.io` needs to be an allowed
      // origin for playback
      collectFonts: true,
      errorHandler: err => {
        try {
          err.__rrweb__ = true;
        } catch (error) {
          // ignore errors here
          // this can happen if the error is frozen or does not allow mutation for other reasons
        }
      }
    };
    this._initialOptions = {
      flushMinDelay,
      flushMaxDelay,
      minReplayDuration: Math.min(minReplayDuration, MIN_REPLAY_DURATION_LIMIT),
      maxReplayDuration: Math.min(maxReplayDuration, MAX_REPLAY_DURATION),
      stickySession,
      useCompression,
      workerUrl,
      blockAllMedia,
      maskAllInputs,
      maskAllText,
      mutationBreadcrumbLimit,
      mutationLimit,
      slowClickTimeout,
      slowClickIgnoreSelectors,
      networkDetailAllowUrls,
      networkDetailDenyUrls,
      networkCaptureBodies,
      networkRequestHeaders: _getMergedNetworkHeaders(networkRequestHeaders),
      networkResponseHeaders: _getMergedNetworkHeaders(networkResponseHeaders),
      beforeAddRecordingEvent,
      beforeErrorSampling,
      onError,
      _experiments
    };
    if (this._initialOptions.blockAllMedia) {
      // `blockAllMedia` is a more user friendly option to configure blocking
      // embedded media elements
      this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${MEDIA_SELECTORS}`;
    }
    if (this._isInitialized && isBrowser()) {
      throw new Error('Multiple Sentry Session Replay instances are not supported');
    }
    this._isInitialized = true;
  }

  /** If replay has already been initialized */
  get _isInitialized() {
    return _initialized;
  }

  /** Update _isInitialized */
  set _isInitialized(value) {
    _initialized = value;
  }

  /**
   * Setup and initialize replay container
   */
  afterAllSetup(client) {
    if (!isBrowser() || this._replay) {
      return;
    }
    this._setup(client);
    this._initialize(client);
  }

  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */
  start() {
    if (!this._replay) {
      return;
    }
    this._replay.start();
  }

  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */
  startBuffering() {
    if (!this._replay) {
      return;
    }
    this._replay.startBuffering();
  }

  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
  stop() {
    if (!this._replay) {
      return Promise.resolve();
    }
    return this._replay.stop({
      forceFlush: this._replay.recordingMode === 'session'
    });
  }

  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
  flush(options) {
    if (!this._replay) {
      return Promise.resolve();
    }

    // assuming a session should be recorded in this case
    if (!this._replay.isEnabled()) {
      this._replay.start();
      return Promise.resolve();
    }
    return this._replay.sendBufferedReplayOrFlush(options);
  }

  /**
   * Get the current session ID.
   */
  getReplayId() {
    if (!this._replay || !this._replay.isEnabled()) {
      return;
    }
    return this._replay.getSessionId();
  }

  /**
   * Get the current recording mode. This can be either `session` or `buffer`.
   *
   * `session`: Recording the whole session, sending it continuously
   * `buffer`: Always keeping the last 60s of recording, requires:
   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *   - or calling `flush()` to send the replay
   */
  getRecordingMode() {
    if (!this._replay || !this._replay.isEnabled()) {
      return;
    }
    return this._replay.recordingMode;
  }

  /**
   * Initializes replay.
   */
  _initialize(client) {
    if (!this._replay) {
      return;
    }
    this._maybeLoadFromReplayCanvasIntegration(client);
    this._replay.initializeSampling();
  }

  /** Setup the integration. */
  _setup(client) {
    // Client is not available in constructor, so we need to wait until setupOnce
    const finalOptions = loadReplayOptionsFromClient(this._initialOptions, client);
    this._replay = new ReplayContainer({
      options: finalOptions,
      recordingOptions: this._recordingOptions
    });
  }

  /** Get canvas options from ReplayCanvas integration, if it is also added. */
  _maybeLoadFromReplayCanvasIntegration(client) {
    // To save bundle size, we skip checking for stuff here
    // and instead just try-catch everything - as generally this should all be defined
    /* eslint-disable @typescript-eslint/no-non-null-assertion */
    try {
      const canvasIntegration = client.getIntegrationByName('ReplayCanvas');
      if (!canvasIntegration) {
        return;
      }
      this._replay['_canvas'] = canvasIntegration.getOptions();
    } catch (e) {
      // ignore errors here
    }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */
  }
}
Replay.__initStatic();

/** Parse Replay-related options from SDK options */
function loadReplayOptionsFromClient(initialOptions, client) {
  const opt = client.getOptions();
  const finalOptions = {
    sessionSampleRate: 0,
    errorSampleRate: 0,
    ...(0,object/* dropUndefinedKeys */.Jr)(initialOptions)
  };
  const replaysSessionSampleRate = (0,parseSampleRate/* parseSampleRate */.o)(opt.replaysSessionSampleRate);
  const replaysOnErrorSampleRate = (0,parseSampleRate/* parseSampleRate */.o)(opt.replaysOnErrorSampleRate);
  if (replaysSessionSampleRate == null && replaysOnErrorSampleRate == null) {
    (0,logger/* consoleSandbox */.Cf)(() => {
      // eslint-disable-next-line no-console
      console.warn('Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.');
    });
  }
  if (replaysSessionSampleRate != null) {
    finalOptions.sessionSampleRate = replaysSessionSampleRate;
  }
  if (replaysOnErrorSampleRate != null) {
    finalOptions.errorSampleRate = replaysOnErrorSampleRate;
  }
  return finalOptions;
}
function _getMergedNetworkHeaders(headers) {
  return [...DEFAULT_NETWORK_HEADERS, ...headers.map(header => header.toLowerCase())];
}

/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */
function getReplay() {
  const client = getClient();
  return client && client.getIntegrationByName('Replay');
}

;// CONCATENATED MODULE: ./sentry.client.config.ts
// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
globalThis["_sentryRewritesTunnelPath"] = "/monitoring";
globalThis["SENTRY_RELEASE"] = {
    "id": "5U-do0n6DV3oqn6oWDac_"
};
globalThis["_sentryBasePath"] = undefined;
globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";

client_init({
    dsn: "https://aa68254361ae8a52b53b16659762ad9e@o4507497737551872.ingest.us.sentry.io/4507507364265984",
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 1,
    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,
    replaysOnErrorSampleRate: 1.0,
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // You can remove this option if you're not planning to use the Sentry Session Replay feature:
    integrations: [
        replayIntegration({
            // Additional Replay configuration goes in here, for example:
            maskAllText: true,
            blockAllMedia: true
        }), 
    ]
});


/***/ }),

/***/ 34648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ ActionIcon; },
  "RV": function() { return /* binding */ ActiveIcon; },
  "DT": function() { return /* binding */ AlertCircleSharp; },
  "zM": function() { return /* binding */ AlertIcon; },
  "Wz": function() { return /* binding */ AlertInfoIcon; },
  "E5": function() { return /* binding */ AlertTriagle; },
  "uZ": function() { return /* binding */ AppleLogo; },
  "e0": function() { return /* binding */ ArrowIcon; },
  "Hf": function() { return /* binding */ ArrowUpIcon; },
  "Dk": function() { return /* binding */ BellIcon; },
  "RR": function() { return /* binding */ BookInClassIcon; },
  "PZ": function() { return /* binding */ BookMenuIcon; },
  "Xk": function() { return /* binding */ CalculatorIcon; },
  "Qu": function() { return /* binding */ CalendarIcon; },
  "nQ": function() { return /* binding */ CheckIcon; },
  "Ec": function() { return /* binding */ CheckIconV2; },
  "O7": function() { return /* binding */ CircleCloseIcon; },
  "eC": function() { return /* binding */ ClockIcon; },
  "BR": function() { return /* binding */ ClockInClassIcon; },
  "Tw": function() { return /* binding */ CloseIcon; },
  "VB": function() { return /* binding */ CloseIconNote; },
  "ce": function() { return /* binding */ CloseIconPreview; },
  "A2": function() { return /* binding */ CloseNone; },
  "oN": function() { return /* binding */ CollapseArrowIcon; },
  "q1": function() { return /* binding */ ConfirmIcon; },
  "cY": function() { return /* binding */ CursorIcon; },
  "pJ": function() { return /* binding */ DeleteIcon; },
  "_8": function() { return /* binding */ DownloadIcon; },
  "rl": function() { return /* binding */ DownloadMinimalistic; },
  "dY": function() { return /* binding */ EditIcon; },
  "K_": function() { return /* binding */ EllipsisIconV2; },
  "H8": function() { return /* binding */ EssentialIcon; },
  "uo": function() { return /* binding */ ExcelIcon; },
  "mn": function() { return /* binding */ ExhibitsIcon; },
  "tE": function() { return /* binding */ EyeIcon; },
  "$5": function() { return /* binding */ FileMenuIcon; },
  "U6": function() { return /* binding */ FlagIcon; },
  "AP": function() { return /* binding */ GeoLocationIcon; },
  "I9": function() { return /* binding */ HelpMenuIcon; },
  "Cc": function() { return /* binding */ HighlightIcon; },
  "RS": function() { return /* binding */ HomeMenuIcon; },
  "sU": function() { return /* binding */ IRibbon; },
  "BL": function() { return /* binding */ IconAccess; },
  "Ah": function() { return /* binding */ IconAnnotationGuide; },
  "K8": function() { return /* binding */ IconBuildingModify; },
  "f7": function() { return /* binding */ IconChat; },
  "bM": function() { return /* binding */ IconClose; },
  "Qc": function() { return /* binding */ IconCongrats; },
  "r2": function() { return /* binding */ IconContact; },
  "Dj": function() { return /* binding */ IconDownload; },
  "J2": function() { return /* binding */ IconEmergency; },
  "y_": function() { return /* binding */ IconFAQ; },
  "uc": function() { return /* binding */ IconLoudSpeaker; },
  "Sv": function() { return /* binding */ IconMinusSquared; },
  "q8": function() { return /* binding */ IconPlusSquared; },
  "AJ": function() { return /* binding */ IconRequestForm; },
  "h9": function() { return /* binding */ IconSend; },
  "Yq": function() { return /* binding */ IconSendHover; },
  "jz": function() { return /* binding */ IconSupportCenter; },
  "sz": function() { return /* binding */ InfoIcon; },
  "xP": function() { return /* binding */ LinkIcon; },
  "Ho": function() { return /* binding */ LoadingIcon; },
  "kh": function() { return /* binding */ LockClosedIcon; },
  "mB": function() { return /* binding */ LockIcon; },
  "wn": function() { return /* binding */ LockSectionIcon; },
  "gI": function() { return /* binding */ LogOutMenuIcon; },
  "wX": function() { return /* binding */ LoginIcon; },
  "pB": function() { return /* binding */ LogoSappIcon; },
  "k8": function() { return /* binding */ MyCalendarMenuIcon; },
  "MM": function() { return /* binding */ MyCourseTeacherIcon; },
  "sh": function() { return /* reexport */ icons_NotificationIcon; },
  "Zn": function() { return /* binding */ OutlineArchive; },
  "ZT": function() { return /* binding */ OutlineText; },
  "gV": function() { return /* binding */ OutlineVideo; },
  "Lp": function() { return /* binding */ PencilFillV2Icon; },
  "NQ": function() { return /* binding */ PencilV2Icon; },
  "P0": function() { return /* binding */ PepIconsPencil; },
  "AI": function() { return /* binding */ PhoneLogo; },
  "v3": function() { return /* binding */ Plus; },
  "pO": function() { return /* binding */ PlusIcon; },
  "A4": function() { return /* reexport */ SadIcon; },
  "N": function() { return /* binding */ SaveIcon; },
  "Cr": function() { return /* binding */ ScratchPadIcon; },
  "W1": function() { return /* binding */ SearchIcon; },
  "J8": function() { return /* binding */ SecurityIcon; },
  "FV": function() { return /* binding */ ShareLinkIcon; },
  "Cv": function() { return /* binding */ SwitcherClosed; },
  "lh": function() { return /* binding */ SwitcherExpanded; },
  "WT": function() { return /* binding */ TextSquareIcon; },
  "p$": function() { return /* binding */ ThankYouIcon; },
  "_7": function() { return /* binding */ UnHighLightIcon; },
  "QB": function() { return /* binding */ UnlockIcon; },
  "rG": function() { return /* binding */ UploadIcon; },
  "ON": function() { return /* binding */ ViewIcon; },
  "MR": function() { return /* binding */ WinDowLogo; },
  "Js": function() { return /* binding */ WordIcon; }
});

// UNUSED EXPORTS: ArrowCollapseIcon, CalenderMenuIcon, DocIcon, HelpIcon, IconCalendar, IconDownArrow, ImageIcon, VideoIcon

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(57368);
// EXTERNAL MODULE: ./node_modules/tailwindcss/tailwind.css
var tailwind = __webpack_require__(52490);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./src/hooks/useNotification.tsx
var useNotification = __webpack_require__(87177);
;// CONCATENATED MODULE: ./src/assets/icons/NotificationIcon.tsx




var NotificationIcon = function(param) {
    var className = param.className;
    var ref // Default width
     = (0,react.useState)("w-4 h-4 -top-[5px] -right-1.5"), badgeClass = ref[0], setBadgeClass = ref[1];
    var notificationUnread = (0,useNotification/* useNotification */.l)().notificationUnread;
    (0,react.useEffect)(function() {
        if (notificationUnread > 9) {
            setBadgeClass("w-6 h-6 -top-3.5 -right-3.5");
        } else {
            setBadgeClass("w-4 h-4 -top-[5px] -right-1.5") // Default width for single digits
            ;
        }
    }, [
        notificationUnread
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                className: className,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M12 1.25C7.71983 1.25 4.25004 4.71979 4.25004 9V9.7041C4.25004 10.401 4.04375 11.0824 3.65717 11.6622L2.50856 13.3851C1.17547 15.3848 2.19318 18.1028 4.51177 18.7351C5.26738 18.9412 6.02937 19.1155 6.79578 19.2581L6.79768 19.2632C7.56667 21.3151 9.62198 22.75 12 22.75C14.378 22.75 16.4333 21.3151 17.2023 19.2632L17.2042 19.2581C17.9706 19.1155 18.7327 18.9412 19.4883 18.7351C21.8069 18.1028 22.8246 15.3848 21.4915 13.3851L20.3429 11.6622C19.9563 11.0824 19.75 10.401 19.75 9.7041V9C19.75 4.71979 16.2802 1.25 12 1.25ZM15.3764 19.537C13.1335 19.805 10.8664 19.8049 8.62349 19.5369C9.33444 20.5585 10.571 21.25 12 21.25C13.4289 21.25 14.6655 20.5585 15.3764 19.537ZM5.75004 9C5.75004 5.54822 8.54826 2.75 12 2.75C15.4518 2.75 18.25 5.54822 18.25 9V9.7041C18.25 10.6972 18.544 11.668 19.0948 12.4943L20.2434 14.2172C21.0086 15.3649 20.4245 16.925 19.0936 17.288C14.4494 18.5546 9.5507 18.5546 4.90644 17.288C3.57561 16.925 2.99147 15.3649 3.75664 14.2172L4.90524 12.4943C5.45609 11.668 5.75004 10.6972 5.75004 9.7041V9Z",
                    fill: "currentColor"
                })
            }),
            notificationUnread > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,clsx/* default */.Z)("text-xs  absolute flex aspect-1  items-center justify-center rounded-full bg-[#D35563] text-white", badgeClass),
                children: notificationUnread > 99 ? "99+" : notificationUnread
            })
        ]
    });
};
/* harmony default export */ var icons_NotificationIcon = (NotificationIcon);

;// CONCATENATED MODULE: ./src/assets/icons/SadIcon.tsx


var SadIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#a)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFB800",
                        d: "M91.554 41.892c0-3.83-.46-7.55-1.32-11.115a44.833 44.833 0 0 0-9.986-13.513 47.057 47.057 0 0 0-25.937-6.636c-26.104.951-46.494 22.885-45.543 48.989.14 3.819.733 7.513 1.719 11.038a44.826 44.826 0 0 0 8.086 10.953 47.062 47.062 0 0 0 25.684 7.58c26.12 0 47.297-21.175 47.297-47.296ZM66.78 33.446a5.406 5.406 0 1 1-.001 10.811 5.406 5.406 0 0 1 0-10.811Zm-33.447 0a5.406 5.406 0 1 1 0 10.811 5.406 5.406 0 0 1 0-10.811ZM29.716 72.77l-4.268-3.318c7.244-9.317 19.39-13.776 30.942-11.362 7.183 1.503 13.633 5.538 18.161 11.362l-4.267 3.318a25.699 25.699 0 0 0-15-9.388C45.736 61.385 35.7 65.07 29.715 72.77Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#DB9800",
                        d: "M90.234 30.776a47.369 47.369 0 0 1 1.32 11.115c0 26.122-21.176 47.298-47.297 47.298a47.064 47.064 0 0 1-25.684-7.581C26.641 89.629 37.751 94.594 50 94.594c24.59 0 44.595-20.005 44.595-44.594 0-6.88-1.567-13.4-4.36-19.224Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFDA7B",
                        d: "M54.311 10.627a47.059 47.059 0 0 1 25.937 6.637C72.293 9.908 61.663 5.405 50 5.405 25.41 5.405 5.405 25.41 5.405 50c0 7.449 1.839 14.476 5.082 20.655a47.372 47.372 0 0 1-1.719-11.038c-.95-26.105 19.439-48.038 45.543-48.99Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#050505",
                        d: "M50 0C22.43 0 0 22.43 0 50s22.43 50 50 50 50-22.43 50-50S77.57 0 50 0Zm0 94.594c-12.25 0-23.36-4.964-31.427-12.986a44.836 44.836 0 0 1-8.086-10.953A44.319 44.319 0 0 1 5.405 50C5.405 25.41 25.41 5.405 50 5.405c11.663 0 22.293 4.503 30.248 11.86a44.831 44.831 0 0 1 9.986 13.512A44.328 44.328 0 0 1 94.594 50c0 24.59-20.004 44.594-44.594 44.594Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#050505",
                        d: "M55.284 63.382a25.697 25.697 0 0 1 15 9.388l4.267-3.317a31.11 31.11 0 0 0-18.16-11.362c-11.553-2.415-23.7 2.044-30.943 11.362l4.268 3.317c5.985-7.699 16.022-11.385 25.568-9.388ZM33.333 44.256a5.405 5.405 0 1 0 0-10.81 5.405 5.405 0 0 0 0 10.81ZM66.78 44.256a5.405 5.405 0 1 0 0-10.81 5.405 5.405 0 0 0 0 10.81Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h100v100H0z"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icons_SadIcon = ((/* unused pure expression or super */ null && (SadIcon)));

;// CONCATENATED MODULE: ./src/assets/icons/index.tsx

var DownloadIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "download",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.0625 10.3125L12 14.25L15.9375 10.3125",
                stroke: "#A1A1A1",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                className: "group-hover:stroke-primary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 3.75V14.25",
                stroke: "#A1A1A1",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                className: "group-hover:stroke-primary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.25 14.25V19.5C20.25 19.6989 20.171 19.8897 20.0303 20.0303C19.8897 20.171 19.6989 20.25 19.5 20.25H4.5C4.30109 20.25 4.11032 20.171 3.96967 20.0303C3.82902 19.8897 3.75 19.6989 3.75 19.5V14.25",
                stroke: "#A1A1A1",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                className: "group-hover:stroke-primary"
            })
        ]
    });
};
var EditIcon = function(param) {
    var width = param.width, height = param.height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "edit-icon",
        width: width !== null && width !== void 0 ? width : 24,
        height: height !== null && height !== void 0 ? height : 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 15H9V12L18 3L21 6L12 15Z",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.75 5.25L18.75 8.25",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.25 11.25V19.5C20.25 19.6989 20.171 19.8897 20.0303 20.0303C19.8897 20.171 19.6989 20.25 19.5 20.25H4.5C4.30109 20.25 4.11032 20.171 3.96967 20.0303C3.82902 19.8897 3.75 19.6989 3.75 19.5V4.5C3.75 4.30109 3.82902 4.11032 3.96967 3.96967C4.11032 3.82902 4.30109 3.75 4.5 3.75H12.75",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var ViewIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M9 9h6M9 12h6M9 15h3M14.69 20.25H4.5a.75.75 0 01-.75-.75v-15a.75.75 0 01.75-.75h15a.75.75 0 01.75.75v10.19a.742.742 0 01-.216.526l-4.818 4.818a.74.74 0 01-.525.216v0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M20.184 15H15v5.184"
            })
        ]
    });
};
var EyeIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z",
                fill: "currentColor"
            })
        ]
    });
};
var CloseIconPreview = function(param) {
    var width = param.width, height = param.height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width !== null && width !== void 0 ? width : 12,
        height: height !== null && height !== void 0 ? height : 12,
        viewBox: "0 0 12 12",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.40992 6L10.9999 2.44C11.1909 2.24639 11.2971 1.98486 11.2952 1.71293C11.2933 1.441 11.1835 1.18096 10.9899 0.990001C10.7963 0.799045 10.5348 0.692821 10.2628 0.694696C9.99092 0.696571 9.73088 0.806393 9.53992 1L5.99992 4.59L2.45992 1.07C2.27256 0.88375 2.0191 0.779208 1.75492 0.779208C1.49073 0.779208 1.23728 0.88375 1.04992 1.07C0.956191 1.16296 0.881796 1.27357 0.831028 1.39542C0.780259 1.51728 0.754121 1.64799 0.754121 1.78C0.754121 1.91201 0.780259 2.04272 0.831028 2.16458C0.881796 2.28644 0.956191 2.39704 1.04992 2.49L4.58992 6L0.999919 9.56C0.808963 9.75361 0.702739 10.0151 0.704614 10.2871C0.70649 10.559 0.816311 10.819 1.00992 11.01C1.20353 11.201 1.46506 11.3072 1.73699 11.3053C2.00892 11.3034 2.26896 11.1936 2.45992 11L5.99992 7.41L9.53992 10.93C9.72728 11.1163 9.98073 11.2208 10.2449 11.2208C10.5091 11.2208 10.7626 11.1163 10.9499 10.93C11.0436 10.837 11.118 10.7264 11.1688 10.6046C11.2196 10.4827 11.2457 10.352 11.2457 10.22C11.2457 10.088 11.2196 9.95728 11.1688 9.83542C11.118 9.71356 11.0436 9.60296 10.9499 9.51L7.40992 6Z",
            fill: "currentColor"
        })
    });
};
var DeleteIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "delete",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.25 5.25H3.75",
                stroke: "#A1A1A1",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.75 9.75V15.75",
                stroke: "#A1A1A1",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.25 9.75V15.75",
                stroke: "#A1A1A1",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.75 5.25V19.5C18.75 19.6989 18.671 19.8897 18.5303 20.0303C18.3897 20.171 18.1989 20.25 18 20.25H6C5.80109 20.25 5.61032 20.171 5.46967 20.0303C5.32902 19.8897 5.25 19.6989 5.25 19.5V5.25",
                stroke: "#A1A1A1",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.75 5.25V3.75C15.75 3.35218 15.592 2.97064 15.3107 2.68934C15.0294 2.40804 14.6478 2.25 14.25 2.25H9.75C9.35218 2.25 8.97064 2.40804 8.68934 2.68934C8.40804 2.97064 8.25 3.35218 8.25 3.75V5.25",
                stroke: "#A1A1A1",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var HelpIcon = function() {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("g", {
                id: "help-question-1--circle-faq-frame-help-info-mark-more-query-question",
                clipPath: "url(#clip0_4_7633)",
                children: /*#__PURE__*/ _jsxs("g", {
                    id: "help-question-1--circle-faq-frame-help-info-mark-more-query-question_2",
                    children: [
                        /*#__PURE__*/ _jsx("path", {
                            id: "Vector",
                            d: "M7.99986 15.4287C12.1026 15.4287 15.4284 12.1028 15.4284 8.00011C15.4284 3.89742 12.1026 0.571533 7.99986 0.571533C3.89718 0.571533 0.571289 3.89742 0.571289 8.00011C0.571289 12.1028 3.89718 15.4287 7.99986 15.4287Z",
                            stroke: "#404041",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            id: "Vector_2",
                            d: "M6 5.99975C6 5.60418 6.11741 5.21751 6.33737 4.88861C6.55733 4.55972 6.86998 4.30337 7.23576 4.15199C7.60154 4.00062 8.00405 3.96102 8.39235 4.03818C8.78067 4.11535 9.13736 4.30583 9.41733 4.58554C9.69728 4.86525 9.88793 5.22161 9.96518 5.60957C10.0424 5.99753 10.0028 6.39966 9.85126 6.76511C9.69975 7.13056 9.44317 7.44292 9.11397 7.66268C8.78478 7.88244 8.39774 7.99974 8.00182 7.99974V9.33306",
                            stroke: "#404041",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ _jsxs("g", {
                            id: "Group 2567",
                            children: [
                                /*#__PURE__*/ _jsx("path", {
                                    id: "Vector_3",
                                    d: "M7.99958 11.9528C7.84179 11.9528 7.71387 11.8249 7.71387 11.6671C7.71387 11.5092 7.84179 11.3813 7.99958 11.3813",
                                    stroke: "#404041",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    id: "Vector_4",
                                    d: "M8 11.9528C8.15779 11.9528 8.28571 11.8249 8.28571 11.6671C8.28571 11.5092 8.15779 11.3813 8 11.3813",
                                    stroke: "#404041",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_4_7633",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var HighlightIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_4_7599)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.57129 0.571533H2.857C2.55389 0.571533 2.26321 0.691941 2.04888 0.906268C1.83456 1.1206 1.71415 1.41128 1.71415 1.71439V12.0001L0.571289 15.4287L5.14272 14.2858H14.2856C14.5887 14.2858 14.8794 14.1654 15.0937 13.9511C15.308 13.7368 15.4284 13.446 15.4284 13.143V7.42868",
                        stroke: "#404041",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.55748 9.29949L6.12891 9.91663L6.70033 6.44235L12.1061 1.05949C12.2123 0.952372 12.3387 0.86735 12.478 0.809328C12.6172 0.751308 12.7666 0.721436 12.9175 0.721436C13.0684 0.721436 13.2178 0.751308 13.357 0.809328C13.4963 0.86735 13.6227 0.952372 13.729 1.05949L14.9404 2.27092C15.0475 2.37716 15.1325 2.50357 15.1906 2.64284C15.2485 2.78209 15.2784 2.93148 15.2784 3.08235C15.2784 3.23321 15.2485 3.3826 15.1906 3.52187C15.1325 3.66113 15.0475 3.78753 14.9404 3.89377L9.55748 9.29949Z",
                        stroke: "#404041",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4_7599",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var UnHighLightIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_6525_5668)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M9.74501 3.8434C9.54973 3.64815 9.54973 3.33155 9.74501 3.1363C9.94026 2.94105 10.2569 2.94105 10.4521 3.1363L12.8116 5.49583C13.0069 5.69108 13.0069 6.00768 12.8116 6.20293C12.714 6.30055 12.586 6.3494 12.4581 6.3494C12.3302 6.3494 12.2022 6.30055 12.1046 6.20293L9.74501 3.8434ZM16 15.4464C16 15.7225 15.7762 15.9464 15.5 15.9464C15.5 15.9464 5.64498 15.948 5.64495 15.948C5.11367 15.9481 4.58076 15.7786 4.13157 15.4983C3.93379 15.3749 3.75079 15.2274 3.58601 15.0626L0.885355 12.3619C-0.195645 11.281 -0.30152 9.62799 0.649261 8.67718L8.62542 0.701021C9.57626 -0.249792 11.2293 -0.143854 12.3102 0.937114L15.0109 3.63777C16.0919 4.71877 16.1977 6.37174 15.2469 7.32255L7.62307 14.9464H15.5C15.7762 14.9464 16 15.1702 16 15.4464ZM3.3192 7.42143L8.52651 12.6287L14.5398 6.61543C15.1007 6.05452 14.9948 5.03593 14.3037 4.34483L11.6031 1.64418C11.2106 1.25168 10.7123 1.04793 10.2524 1.04793C9.90251 1.04793 9.57482 1.16577 9.33245 1.40808L3.3192 7.42143ZM4.2931 14.3555C4.98417 15.0466 6.00273 15.1525 6.5637 14.5916L7.81945 13.3358L2.6121 8.12852L1.35635 9.38427C0.795448 9.94518 0.901355 10.9637 1.59245 11.6548L4.2931 14.3555Z",
                    fill: "#404041"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_6525_5668",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var ScratchPadIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_4_7603)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.14272 0.571533H1.71415C1.08296 0.571533 0.571289 1.08321 0.571289 1.71439V14.2858C0.571289 14.917 1.08296 15.4287 1.71415 15.4287H11.9999C12.6311 15.4287 13.1427 14.917 13.1427 14.2858V9.14296",
                        stroke: "#404041",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0.571289 12H13.1427",
                        stroke: "#404041",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4 3.42871H6.28571",
                        stroke: "#404041",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4 6.28589H5.14286",
                        stroke: "#404041",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.2792 8.57816L6.85059 9.19531L7.42201 5.72102L12.2563 0.909588C12.3625 0.80247 12.4889 0.717449 12.6283 0.659427C12.7675 0.601405 12.9168 0.571533 13.0677 0.571533C13.2187 0.571533 13.368 0.601405 13.5072 0.659427C13.6465 0.717449 13.7729 0.80247 13.8791 0.909588L15.0905 2.12102C15.1977 2.22726 15.2828 2.35366 15.3407 2.49293C15.3988 2.6322 15.4286 2.78158 15.4286 2.93245C15.4286 3.08332 15.3988 3.2327 15.3407 3.37196C15.2828 3.51122 15.1977 3.63764 15.0905 3.74388L10.2792 8.57816Z",
                        stroke: "#404041",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4_7603",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

// Import Tailwind CSS classes

var CloseIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "stroke-bw-1 " : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        className: "group select-none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 5L5 15",
                className: className,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 5L15 15",
                className: className,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var FlagIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: " http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_5553_13000",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "16",
                height: "16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M0 9.53674e-07H16V16H0V9.53674e-07Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                mask: "url(#mask0_5553_13000)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M2.84375 16V9.53674e-07H1.90625V16H2.84375Z",
                        fill: "#404041"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M2.95005 9.50628C3.50462 9.74486 4.27879 10 5.07782 10C6.32529 10 7.26324 9.49595 8.09329 9.04989L8.12325 9.03379C8.97784 8.57464 9.7244 8.18182 10.7129 8.18182C11.3226 8.18182 11.9572 8.38122 12.4592 8.59719C12.7061 8.7034 12.912 8.8097 13.0553 8.88897C13.1268 8.92852 13.1823 8.9611 13.219 8.98324C13.2374 8.9943 13.2511 9.00273 13.2597 9.00811C13.264 9.01079 13.267 9.01271 13.2687 9.01381L13.2699 9.01457L13.2701 9.01467L13.2702 9.01475L13.2704 9.01486L14 9.48569V1.12037L13.7909 0.985431L13.5304 1.36364C13.7909 0.985431 13.7908 0.985371 13.7907 0.985307L13.7905 0.985162L13.7899 0.98481L13.7884 0.983857C13.7873 0.983112 13.7858 0.98215 13.7839 0.980978C13.7802 0.978633 13.7752 0.975446 13.7688 0.971473C13.7561 0.963529 13.7381 0.952433 13.7152 0.938639C13.6694 0.911062 13.6038 0.872615 13.5213 0.826935C13.3564 0.735754 13.122 0.614778 12.8407 0.493721C12.2861 0.255141 11.5119 -2.98023e-07 10.7129 -2.98023e-07C9.46541 -2.98023e-07 8.52746 0.504049 7.69741 0.95011L7.66746 0.966208C6.81286 1.42536 6.06631 1.81818 5.07782 1.81818C4.46809 1.81818 3.83349 1.61878 3.33149 1.40281C3.08459 1.2966 2.87873 1.1903 2.7354 1.11103C2.66391 1.07148 2.60842 1.0389 2.57166 1.01676C2.55329 1.0057 2.53964 0.997265 2.53103 0.991892C2.52673 0.989207 2.5237 0.987289 2.52197 0.986193L2.52061 0.985328C2.52069 0.985378 2.52077 0.985431 2.26029 1.36364C1.99981 1.74184 1.9999 1.7419 2 1.74196L2.00078 1.74246L2.00226 1.74342C2.00343 1.74416 2.00493 1.74512 2.00678 1.74629C2.01047 1.74864 2.01552 1.75183 2.02188 1.7558C2.0346 1.76374 2.05259 1.77484 2.07549 1.78863C2.12128 1.81621 2.18686 1.85466 2.26944 1.90034C2.43429 1.99152 2.66866 2.11249 2.95005 2.23355C3.50462 2.47213 4.27879 2.72727 5.07782 2.72727C6.32529 2.72727 7.26325 2.22322 8.09329 1.77716L8.12325 1.76106C8.97784 1.30191 9.7244 0.909091 10.7129 0.909091C11.3226 0.909091 11.9572 1.10849 12.4592 1.32446C12.7061 1.43068 12.912 1.53697 13.0553 1.61625C13.0572 1.61727 13.059 1.61829 13.0608 1.61931V7.86529C12.9913 7.83276 12.9177 7.79961 12.8407 7.76645C12.2861 7.52787 11.5119 7.27273 10.7129 7.27273C9.46541 7.27273 8.52746 7.77678 7.69741 8.22284C7.68741 8.22821 7.67743 8.23358 7.66746 8.23894C6.81286 8.69809 6.06631 9.09091 5.07782 9.09091C4.46809 9.09091 3.83349 8.8915 3.33149 8.67554C3.08459 8.56932 2.87873 8.46303 2.7354 8.38375C2.66391 8.34421 2.60842 8.31163 2.57166 8.28949C2.55329 8.27843 2.53964 8.26999 2.53103 8.26462C2.52673 8.26193 2.5237 8.26002 2.52197 8.25892L2.52048 8.25797L2.52061 8.25806C2.52069 8.25811 2.52077 8.25816 2.26029 8.63636C1.99981 9.01457 1.9999 9.01463 2 9.01469L2.00078 9.01519L2.00226 9.01614C2.00343 9.01689 2.00493 9.01785 2.00678 9.01902C2.01047 9.02137 2.01552 9.02455 2.02188 9.02853C2.0346 9.03647 2.05259 9.04757 2.07549 9.06136C2.12128 9.08894 2.18686 9.12738 2.26944 9.17306C2.43429 9.26425 2.66866 9.38522 2.95005 9.50628Z",
                        fill: "#404041"
                    })
                ]
            })
        ]
    });
};
var CalculatorIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.1424 0.571533H2.85672C2.22555 0.571533 1.71387 1.08321 1.71387 1.71439V14.2858C1.71387 14.917 2.22555 15.4287 2.85672 15.4287H13.1424C13.7736 15.4287 14.2853 14.917 14.2853 14.2858V1.71439C14.2853 1.08321 13.7736 0.571533 13.1424 0.571533Z",
                stroke: "#404041",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.71387 6.28589H14.2853",
                stroke: "#404041",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.857 9.7145C4.69921 9.7145 4.57129 9.58658 4.57129 9.42878C4.57129 9.27099 4.69921 9.14307 4.857 9.14307",
                stroke: "#404041",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.85742 9.7145C5.01522 9.7145 5.14314 9.58658 5.14314 9.42878C5.14314 9.27099 5.01522 9.14307 4.85742 9.14307",
                stroke: "#404041",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.99958 9.7145C7.84179 9.7145 7.71387 9.58658 7.71387 9.42878C7.71387 9.27099 7.84179 9.14307 7.99958 9.14307",
                stroke: "#404041",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 9.7145C8.15779 9.7145 8.28571 9.58658 8.28571 9.42878C8.28571 9.27099 8.15779 9.14307 8 9.14307",
                stroke: "#404041",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.1422 9.7145C10.9844 9.7145 10.8564 9.58658 10.8564 9.42878C10.8564 9.27099 10.9844 9.14307 11.1422 9.14307",
                stroke: "#404041",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.1426 9.7145C11.3004 9.7145 11.4283 9.58658 11.4283 9.42878C11.4283 9.27099 11.3004 9.14307 11.1426 9.14307",
                stroke: "#404041",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.857 12.5714C4.69921 12.5714 4.57129 12.4435 4.57129 12.2857C4.57129 12.1279 4.69921 12 4.857 12",
                stroke: "#404041",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.85742 12.5714C5.01522 12.5714 5.14314 12.4435 5.14314 12.2857C5.14314 12.1279 5.01522 12 4.85742 12",
                stroke: "#404041",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.99958 12.5714C7.84179 12.5714 7.71387 12.4435 7.71387 12.2857C7.71387 12.1279 7.84179 12 7.99958 12",
                stroke: "#404041",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 12.5714C8.15779 12.5714 8.28571 12.4435 8.28571 12.2857C8.28571 12.1279 8.15779 12 8 12",
                stroke: "#404041",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.1422 12.5714C10.9844 12.5714 10.8564 12.4435 10.8564 12.2857C10.8564 12.1279 10.9844 12 11.1422 12",
                stroke: "#404041",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.1426 12.5714C11.3004 12.5714 11.4283 12.4435 11.4283 12.2857C11.4283 12.1279 11.3004 12 11.1426 12",
                stroke: "#404041",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.428 3.42871H10.2852",
                stroke: "#404041",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var ArrowUpIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "7",
        viewBox: "0 0 10 7",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0.667317 5.33343L5.00065 1.6001L9.33398 5.33343",
            stroke: "#404041",
            strokeLinecap: "square"
        })
    });
};
var ExhibitsIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            stroke: "#404041",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M11.43.572H1.714c-.631 0-1.143.511-1.143 1.142v9.715c0 .63.512 1.143 1.143 1.143h9.714c.632 0 1.143-.512 1.143-1.143V1.714c0-.63-.511-1.142-1.143-1.142Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M15.429 4v10.286a1.143 1.143 0 0 1-1.143 1.143H4"
                })
            ]
        })
    });
};
var TextSquareIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            stroke: "#404041",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.144 14.286.572 15.429 1.715 12V1.714A1.143 1.143 0 0 1 2.858.572h11.429a1.143 1.143 0 0 1 1.142 1.142v11.429a1.143 1.143 0 0 1-1.142 1.143H5.144ZM5.145 5.714h6.857M5.145 9.143h4.571"
            })
        })
    });
};
var WinDowLogo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_3286_4533)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M8.19375 1.71875L0 2.79625V9.60875H8.19375V1.71875ZM0 17.2437L8.19375 18.41V10.3912H0V17.2437ZM9.0975 10.4938L9.13 18.4662L20 20V10.4938H9.0975ZM20 0L9.1625 1.555V9.5725H20V0Z",
                    fill: "#A1A1A1",
                    className: "logo"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_3286_4533",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var AppleLogo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "22",
        viewBox: "0 0 18 22",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_3286_4535)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M15.0322 11.6879C15.0633 15.0172 17.9664 16.1252 17.9986 16.1393C17.9741 16.2173 17.5347 17.7181 16.4691 19.2682C15.5478 20.6085 14.5918 21.9437 13.0856 21.9714C11.6057 21.9985 11.1298 21.0979 9.43787 21.0979C7.74641 21.0979 7.21769 21.9437 5.81678 21.9985C4.36298 22.0533 3.25589 20.5494 2.32707 19.214C0.429043 16.4827 -1.02144 11.4959 0.926192 8.12967C1.89373 6.45801 3.6228 5.39945 5.49955 5.3723C6.92714 5.34519 8.27458 6.3283 9.14733 6.3283C10.0195 6.3283 11.6569 5.14603 13.3784 5.31966C14.099 5.34952 16.1219 5.60941 17.4208 7.50192C17.3161 7.56651 15.0071 8.90449 15.0322 11.6879ZM12.2509 3.51263C13.0227 2.58268 13.5422 1.2881 13.4005 0C12.2879 0.0445079 10.9426 0.737936 10.1446 1.66738C9.42947 2.49044 8.80315 3.80781 8.97214 5.07041C10.2122 5.16591 11.479 4.44317 12.2509 3.51263Z",
                    fill: "#A1A1A1",
                    className: "logo"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_3286_4535",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "22",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var SecurityIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "20",
        viewBox: "0 0 16 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.3",
                d: "M5.85 19.2291L1.26 15.4791C0.86751 15.1621 0.550722 14.7615 0.332741 14.3065C0.11476 13.8515 0.00108308 13.3536 0 12.8491V5.4991C0.000370822 4.84614 0.189308 4.20718 0.544104 3.65902C0.898899 3.11086 1.40445 2.67683 2 2.4091L6.6 0.309097C7.04251 0.106708 7.5234 0.00195312 8.01 0.00195312C8.4966 0.00195312 8.97749 0.106708 9.42 0.309097L14 2.4091C14.5955 2.67683 15.1011 3.11086 15.4559 3.65902C15.8107 4.20718 15.9996 4.84614 16 5.4991V12.8491C16.0001 13.3528 15.888 13.8502 15.6718 14.3051C15.4555 14.7601 15.1407 15.1611 14.75 15.4791L10.16 19.2291C9.55388 19.7307 8.79177 20.0052 8.005 20.0052C7.21824 20.0052 6.45612 19.7307 5.85 19.2291Z",
                fill: "#A1A1A1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.0001 12.699C9.90384 12.7 9.80835 12.6819 9.71911 12.6459C9.62987 12.6098 9.54863 12.5565 9.48008 12.489L5.48008 8.57895C5.33963 8.43833 5.26074 8.2477 5.26074 8.04895C5.26074 7.8502 5.33963 7.65958 5.48008 7.51895C5.62365 7.38026 5.81546 7.30273 6.01508 7.30273C6.2147 7.30273 6.40652 7.38026 6.55008 7.51895L10.5501 11.429C10.6905 11.5696 10.7694 11.7602 10.7694 11.959C10.7694 12.1577 10.6905 12.3483 10.5501 12.489C10.477 12.5588 10.3907 12.6133 10.2962 12.6494C10.2018 12.6854 10.1011 12.7023 10.0001 12.699Z",
                fill: "#A1A1A1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.99957 12.6993C5.89951 12.7 5.8003 12.6809 5.70764 12.6431C5.61497 12.6054 5.53067 12.5497 5.45957 12.4793C5.31912 12.3386 5.24023 12.148 5.24023 11.9493C5.24023 11.7505 5.31912 11.5599 5.45957 11.4193L9.45957 7.50927C9.52309 7.41671 9.60657 7.33958 9.70386 7.28358C9.80115 7.22758 9.90977 7.19413 10.0217 7.18571C10.1337 7.17728 10.2461 7.1941 10.3506 7.2349C10.4552 7.27571 10.5493 7.33947 10.626 7.42149C10.7026 7.50351 10.7599 7.60168 10.7935 7.70878C10.8272 7.81587 10.8363 7.92916 10.8204 8.04028C10.8044 8.15139 10.7637 8.25751 10.7013 8.35079C10.6388 8.44408 10.5562 8.52216 10.4596 8.57927L6.45957 12.4893C6.33425 12.6091 6.17218 12.6831 5.99957 12.6993Z",
                fill: "#A1A1A1"
            })
        ]
    });
};
var PhoneLogo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M20.1562 0H3.84375C3.61997 0 3.40536 0.0888948 3.24713 0.247129C3.08889 0.405362 3 0.619974 3 0.84375V23.1562C3 23.38 3.08889 23.5946 3.24713 23.7529C3.40536 23.9111 3.61997 24 3.84375 24H20.1562C20.38 24 20.5946 23.9111 20.7529 23.7529C20.9111 23.5946 21 23.38 21 23.1562V0.84375C21 0.619974 20.9111 0.405362 20.7529 0.247129C20.5946 0.0888948 20.38 0 20.1562 0V0ZM4.6875 21V3H19.3125V21H4.6875Z",
            fill: "#A1A1A1",
            className: "logo"
        })
    });
};
var AlertIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M50 9.375C27.5996 9.375 9.375 27.5996 9.375 50C9.375 72.4004 27.5996 90.625 50 90.625C72.4004 90.625 90.625 72.4004 90.625 50C90.625 27.5996 72.4004 9.375 50 9.375ZM53.9062 71.8574H46.0938V64.0449H53.9062V71.8574ZM53.125 59.375H46.875L45.7031 28.125H54.2969L53.125 59.375Z",
            fill: "#FFB800"
        })
    });
};
var AlertTriagle = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M93.5546 87.4551L52.4277 11.0625C52.294 10.814 52.0954 10.6063 51.8532 10.4616C51.6109 10.3168 51.3339 10.2404 51.0517 10.2404C50.7695 10.2404 50.4925 10.3168 50.2503 10.4616C50.008 10.6063 49.8094 10.814 49.6757 11.0625L8.54096 87.4551C8.41287 87.6932 8.34876 87.9605 8.35489 88.2308C8.36103 88.5011 8.4372 88.7652 8.57596 88.9972C8.71472 89.2293 8.91131 89.4214 9.14653 89.5547C9.38175 89.688 9.64754 89.758 9.91792 89.7578H92.1875C92.457 89.7563 92.7216 89.6851 92.9554 89.5511C93.1893 89.4171 93.3845 89.2248 93.5222 88.9931C93.6598 88.7613 93.7351 88.4978 93.7408 88.2283C93.7465 87.9589 93.6823 87.6925 93.5546 87.4551ZM54.957 80.3672H47.1445V72.5547H54.957V80.3672ZM54.1757 67.8828H47.9257L46.7539 36.6328H55.3476L54.1757 67.8828Z",
            fill: "#FFB800"
        })
    });
};
var LoginIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M84.375 15.625H37.5C36.6712 15.625 35.8763 15.9542 35.2903 16.5403C34.7042 17.1263 34.375 17.9212 34.375 18.75V46.875H64.3301L51.8301 34.375L56.25 29.9551L74.084 47.791C74.6696 48.377 74.9986 49.1716 74.9986 50C74.9986 50.8284 74.6696 51.623 74.084 52.209L56.25 70.0449L51.8301 65.625L64.3301 53.125H34.375V81.25C34.375 82.0788 34.7042 82.8737 35.2903 83.4597C35.8763 84.0458 36.6712 84.375 37.5 84.375H84.375C85.2038 84.375 85.9987 84.0458 86.5847 83.4597C87.1708 82.8737 87.5 82.0788 87.5 81.25V18.75C87.5 17.9212 87.1708 17.1263 86.5847 16.5403C85.9987 15.9542 85.2038 15.625 84.375 15.625Z",
                fill: "#FFB800"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.375 46.875H12.5V53.125H34.375V46.875Z",
                fill: "#FFB800"
            })
        ]
    });
};
var ActiveIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "164",
        height: "164",
        fill: "none",
        viewBox: "0 0 164 164",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "164",
                height: "164",
                fill: "#FFFAF0",
                rx: "82"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFB800",
                d: "M102.951 97.625H32.924l35.014-62.5 35.013 62.5z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFB800",
                d: "M97.625 63.25a31.346 31.346 0 00-6.357.656l17.138 30.664 5.198 9.305H67.813c3.992 12.666 15.845 21.875 29.812 21.875 17.23 0 31.25-14.02 31.25-31.25s-14.02-31.25-31.25-31.25z"
            })
        ]
    });
};
var ConfirmIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "124",
        height: "124",
        viewBox: "0 0 124 124",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M46.5 62L56.8333 72.3333L77.5 51.6667M108.5 62C108.5 87.6812 87.6812 108.5 62 108.5C36.3188 108.5 15.5 87.6812 15.5 62C15.5 36.3188 36.3188 15.5 62 15.5C87.6812 15.5 108.5 36.3188 108.5 62Z",
            stroke: "#FFB800",
            strokeWidth: "8",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var CloseIconNote = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        fill: "none",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "square",
            strokeLinejoin: "round",
            d: "M15 5L5 15M5 5l10 10"
        })
    });
};
var SaveIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        fill: "none",
        viewBox: "0 0 20 20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "currentColor",
                d: "M14 17v-5H6v5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "square",
                d: "M6 7h4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "currentColor",
                d: "M3 5c0-.943 0-1.414.293-1.707C3.586 3 4.057 3 5 3h8.06c.41 0 .614 0 .797.076.184.076.329.22.618.51l1.94 1.94c.288.288.433.433.509.617.076.183.076.388.076.797V15c0 .943 0 1.414-.293 1.707C16.414 17 15.943 17 15 17H5c-.943 0-1.414 0-1.707-.293C3 16.414 3 15.943 3 15V5z"
            })
        ]
    });
};
var PlusIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        fill: "none",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "square",
            strokeLinejoin: "round",
            d: "M17.071 10H2.93M10 2.929V17.07"
        })
    });
};
var WordIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        className: "word_icon",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_4134_6175)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M23.25 3.75052H13.5V1.50052C13.5 1.27702 13.401 1.06552 13.2285 0.923022C13.0575 0.780522 12.828 0.719022 12.612 0.764022L0.612 3.01402C0.2565 3.08002 0 3.38902 0 3.75052V20.2505C0 20.6105 0.2565 20.921 0.612 20.987L12.612 23.237C12.657 23.246 12.7035 23.2505 12.75 23.2505C12.924 23.2505 13.0935 23.1905 13.2285 23.078C13.401 22.9355 13.5 22.7225 13.5 22.5005V20.2505H23.25C23.664 20.2505 24 19.9145 24 19.5005V4.50052C24 4.08652 23.664 3.75052 23.25 3.75052ZM10.4955 9.08302L9.7455 15.8345C9.7065 16.178 9.4365 16.4525 9.093 16.4945C9.0615 16.499 9.0315 16.5005 9 16.5005C8.691 16.5005 8.409 16.3085 8.298 16.0145L6.75 11.8865L5.202 16.0145C5.082 16.3355 4.767 16.532 4.419 16.496C4.0785 16.46 3.8055 16.196 3.7575 15.8555L3.0075 10.6055C2.949 10.196 3.234 9.81652 3.6435 9.75802C4.0545 9.69802 4.434 9.98452 4.4925 10.394L4.827 12.74L6.0465 9.48652C6.2655 8.90152 7.2315 8.90152 7.452 9.48652L8.601 12.5495L9.0045 8.91652C9.051 8.50552 9.432 8.21152 9.8325 8.25502C10.245 8.30152 10.5405 8.67202 10.4955 9.08302ZM22.5 18.7505H13.5V17.2505H20.25C20.664 17.2505 21 16.9145 21 16.5005C21 16.0865 20.664 15.7505 20.25 15.7505H13.5V14.2505H20.25C20.664 14.2505 21 13.9145 21 13.5005C21 13.0865 20.664 12.7505 20.25 12.7505H13.5V11.2505H20.25C20.664 11.2505 21 10.9145 21 10.5005C21 10.0865 20.664 9.75052 20.25 9.75052H13.5V8.25052H20.25C20.664 8.25052 21 7.91452 21 7.50052C21 7.08652 20.664 6.75052 20.25 6.75052H13.5V5.25052H22.5V18.7505Z",
                    fill: "#295496"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4134_6175",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var ExcelIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        className: "excel_icon",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_4134_6159)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.25 3.75052H13.5V1.50052C13.5 1.27702 13.401 1.06552 13.2285 0.923022C13.0575 0.780522 12.828 0.719022 12.612 0.764022L0.612 3.01402C0.2565 3.08002 0 3.38902 0 3.75052V20.2505C0 20.6105 0.2565 20.921 0.612 20.987L12.612 23.237C12.657 23.246 12.7035 23.2505 12.75 23.2505C12.924 23.2505 13.0935 23.1905 13.2285 23.078C13.401 22.9355 13.5 22.7225 13.5 22.5005V20.2505H23.25C23.664 20.2505 24 19.9145 24 19.5005V4.50052C24 4.08652 23.664 3.75052 23.25 3.75052ZM10.314 14.507C10.587 14.8175 10.5555 15.2915 10.2435 15.5645C10.101 15.689 9.9255 15.7505 9.75 15.7505C9.5415 15.7505 9.3345 15.6635 9.186 15.494L7.005 13.0025L5.0925 15.4625C4.944 15.6515 4.722 15.7505 4.5 15.7505C4.3395 15.7505 4.1775 15.6995 4.0395 15.593C3.7125 15.338 3.654 14.867 3.9075 14.54L5.9985 11.852L3.936 9.49402C3.663 9.18352 3.6945 8.70952 4.0065 8.43652C4.317 8.16352 4.7895 8.19352 5.0655 8.50702L6.9375 10.646L9.159 7.79002C9.414 7.46452 9.885 7.40452 10.212 7.65952C10.539 7.91302 10.5975 8.38402 10.3425 8.71252L7.9425 11.7965L10.314 14.507ZM22.5 18.7505H13.5V17.2505H15.75C16.164 17.2505 16.5 16.9145 16.5 16.5005C16.5 16.0865 16.164 15.7505 15.75 15.7505H13.5V14.2505H15.75C16.164 14.2505 16.5 13.9145 16.5 13.5005C16.5 13.0865 16.164 12.7505 15.75 12.7505H13.5V11.2505H15.75C16.164 11.2505 16.5 10.9145 16.5 10.5005C16.5 10.0865 16.164 9.75052 15.75 9.75052H13.5V8.25052H15.75C16.164 8.25052 16.5 7.91452 16.5 7.50052C16.5 7.08652 16.164 6.75052 15.75 6.75052H13.5V5.25052H22.5V18.7505Z",
                        fill: "#DCDDDD"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.25 6.75049H18.75C18.336 6.75049 18 7.08649 18 7.50049C18 7.91449 18.336 8.25049 18.75 8.25049H20.25C20.664 8.25049 21 7.91449 21 7.50049C21 7.08649 20.664 6.75049 20.25 6.75049Z",
                        fill: "#DCDDDD"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.25 9.75049H18.75C18.336 9.75049 18 10.0865 18 10.5005C18 10.9145 18.336 11.2505 18.75 11.2505H20.25C20.664 11.2505 21 10.9145 21 10.5005C21 10.0865 20.664 9.75049 20.25 9.75049Z",
                        fill: "#DCDDDD"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.25 12.7505H18.75C18.336 12.7505 18 13.0865 18 13.5005C18 13.9145 18.336 14.2505 18.75 14.2505H20.25C20.664 14.2505 21 13.9145 21 13.5005C21 13.0865 20.664 12.7505 20.25 12.7505Z",
                        fill: "#DCDDDD"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.25 15.7505H18.75C18.336 15.7505 18 16.0865 18 16.5005C18 16.9145 18.336 17.2505 18.75 17.2505H20.25C20.664 17.2505 21 16.9145 21 16.5005C21 16.0865 20.664 15.7505 20.25 15.7505Z",
                        fill: "#DCDDDD"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4134_6159",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var DocIcon = function() {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "72",
        height: "72",
        viewBox: "0 0 72 72",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_4164_363)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M14.6245 63L8.98828 57.375H14.6245V63Z",
                        fill: "#1D80B2"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M57.375 63L63.0112 57.375H57.375V63Z",
                        fill: "#1D80B2"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M57.3755 14.625H48.3867V5.63623L57.3755 14.625Z",
                        fill: "#B2B2B2"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M48.375 5.625H16.4138C15.9393 5.625 15.4844 5.81346 15.1489 6.14891C14.8135 6.48437 14.625 6.93934 14.625 7.41375V64.7887C14.625 65.2642 14.8131 65.7203 15.1482 66.0576C15.4834 66.3948 15.9383 66.5858 16.4138 66.5887H55.5863C55.8265 66.5874 56.064 66.5379 56.2848 66.4433C56.5057 66.3487 56.7053 66.2108 56.872 66.0378C57.0387 65.8648 57.1691 65.6602 57.2555 65.436C57.3419 65.2118 57.3825 64.9726 57.375 64.7325V14.625H48.375V5.625Z",
                        fill: "#E9E9E0"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.125 37.125H61.875C62.1734 37.125 62.4595 37.2435 62.6705 37.4545C62.8815 37.6655 63 37.9516 63 38.25V57.375H9V38.25C9 37.9516 9.11853 37.6655 9.32951 37.4545C9.54048 37.2435 9.82663 37.125 10.125 37.125Z",
                        fill: "#2598DE"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M20.2383 14.625H41.7258",
                        stroke: "#2598DE",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M39.2383 22.061H52.2433",
                        stroke: "#2598DE",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M20.2383 22.061H35.1558",
                        stroke: "#2598DE",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M48.0469 29.4976H52.2431",
                        stroke: "#2598DE",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M20.2383 29.4976H42.682",
                        stroke: "#2598DE",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M49.1367 46.1846H47.006C46.9776 45.9658 46.9194 45.7684 46.8313 45.5922C46.7433 45.4161 46.6268 45.2655 46.4819 45.1405C46.337 45.0155 46.1651 44.9204 45.9663 44.855C45.7702 44.7868 45.5529 44.7528 45.3143 44.7528C44.891 44.7528 44.5259 44.8564 44.2191 45.0638C43.9151 45.2712 43.6808 45.5709 43.516 45.963C43.354 46.355 43.2731 46.8295 43.2731 47.3863C43.2731 47.9658 43.3555 48.4516 43.5202 48.8437C43.6879 49.2329 43.9222 49.5269 44.2234 49.7258C44.5273 49.9218 44.8867 50.0198 45.3015 50.0198C45.5344 50.0198 45.7461 49.99 45.9364 49.9303C46.1296 49.8707 46.2987 49.784 46.4435 49.6704C46.5913 49.5539 46.712 49.4133 46.8058 49.2485C46.9023 49.0809 46.9691 48.892 47.006 48.6817L49.1367 48.6945C49.0998 49.0809 48.9876 49.4616 48.8001 49.8366C48.6154 50.2116 48.3612 50.5539 48.0373 50.8635C47.7134 51.1704 47.3185 51.4147 46.8526 51.5965C46.3896 51.7783 45.8583 51.8692 45.2589 51.8692C44.4691 51.8692 43.7617 51.6959 43.1367 51.3493C42.5146 50.9999 42.0231 50.4914 41.6623 49.8238C41.3015 49.1562 41.1211 48.3437 41.1211 47.3863C41.1211 46.426 41.3043 45.6121 41.6708 44.9445C42.0373 44.2769 42.533 43.7698 43.158 43.4232C43.783 43.0766 44.4833 42.9033 45.2589 42.9033C45.7873 42.9033 46.2759 42.9772 46.7248 43.1249C47.1737 43.2698 47.5685 43.4829 47.9094 43.7641C48.2504 44.0425 48.5273 44.3849 48.7404 44.7911C48.9535 45.1974 49.0856 45.6618 49.1367 46.1846Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M39.9833 47.3863C39.9833 48.3465 39.7987 49.1604 39.4293 49.828C39.06 50.4956 38.56 51.0028 37.9293 51.3493C37.3015 51.6959 36.5969 51.8692 35.8157 51.8692C35.0316 51.8692 34.3256 51.6945 33.6978 51.3451C33.07 50.9956 32.5714 50.4885 32.2021 49.8238C31.8356 49.1562 31.6523 48.3437 31.6523 47.3863C31.6523 46.426 31.8356 45.6121 32.2021 44.9445C32.5714 44.2769 33.07 43.7698 33.6978 43.4232C34.3256 43.0766 35.0316 42.9033 35.8157 42.9033C36.5969 42.9033 37.3015 43.0766 37.9293 43.4232C38.56 43.7698 39.06 44.2769 39.4293 44.9445C39.7987 45.6121 39.9833 46.426 39.9833 47.3863ZM37.8271 47.3863C37.8271 46.8181 37.7461 46.338 37.5842 45.9459C37.4251 45.5539 37.195 45.257 36.8938 45.0553C36.5955 44.8536 36.2362 44.7528 35.8157 44.7528C35.3981 44.7528 35.0387 44.8536 34.7376 45.0553C34.4364 45.257 34.2049 45.5539 34.043 45.9459C33.8839 46.338 33.8043 46.8181 33.8043 47.3863C33.8043 47.9545 33.8839 48.4346 34.043 48.8266C34.2049 49.2187 34.4364 49.5155 34.7376 49.7172C35.0387 49.9189 35.3981 50.0198 35.8157 50.0198C36.2362 50.0198 36.5955 49.9189 36.8938 49.7172C37.195 49.5155 37.4251 49.2187 37.5842 48.8266C37.7461 48.4346 37.8271 47.9545 37.8271 47.3863Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M26.2063 51.7497H22.9805V43.0225H26.2021C27.0913 43.0225 27.8569 43.1972 28.4989 43.5466C29.1438 43.8932 29.641 44.3932 29.9904 45.0466C30.3398 45.6972 30.5146 46.4756 30.5146 47.3818C30.5146 48.2909 30.3398 49.0722 29.9904 49.7256C29.6438 50.379 29.1481 50.8804 28.5032 51.2298C27.8583 51.5764 27.0927 51.7497 26.2063 51.7497ZM25.0898 49.9514H26.1254C26.614 49.9514 27.0273 49.8691 27.3654 49.7043C27.7063 49.5367 27.9634 49.2654 28.1367 48.8904C28.3129 48.5125 28.4009 48.0097 28.4009 47.3818C28.4009 46.754 28.3129 46.254 28.1367 45.8818C27.9606 45.5068 27.7006 45.2369 27.3569 45.0722C27.016 44.9046 26.5955 44.8208 26.0955 44.8208H25.0898V49.9514Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_4164_363",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "72",
                        height: "72",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var ImageIcon = function() {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "72",
        height: "72",
        viewBox: "0 0 72 72",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M14.6245 63L8.98828 57.375H14.6245V63Z",
                fill: "#0D725A"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M57.375 63L63.0112 57.375H57.375V63Z",
                fill: "#0D725A"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M57.3755 14.625H48.3867V5.63623L57.3755 14.625Z",
                fill: "#B2B2B2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M48.375 5.625H16.4138C15.9393 5.625 15.4844 5.81346 15.1489 6.14891C14.8135 6.48437 14.625 6.93934 14.625 7.41375V64.7887C14.625 65.2642 14.8131 65.7203 15.1482 66.0576C15.4834 66.3948 15.9383 66.5858 16.4138 66.5887H55.5863C55.8265 66.5874 56.064 66.5379 56.2848 66.4433C56.5057 66.3487 56.7053 66.2108 56.872 66.0378C57.0387 65.8648 57.1691 65.6602 57.2555 65.436C57.3419 65.2118 57.3825 64.9726 57.375 64.7325V14.625H48.375V5.625Z",
                fill: "#E9E9E0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M36.3269 31.5114L27.9681 22.9727L19.6094 31.5114H36.3269Z",
                stroke: "#2A9F85",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M32.7148 27.8215L40.8261 19.564L52.3011 31.5115H36.3261L32.7148 27.8215Z",
                stroke: "#2A9F85",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M28.7125 18.675C30.1415 18.675 31.3 17.5165 31.3 16.0875C31.3 14.6585 30.1415 13.5 28.7125 13.5C27.2835 13.5 26.125 14.6585 26.125 16.0875C26.125 17.5165 27.2835 18.675 28.7125 18.675Z",
                stroke: "#2A9F85",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.125 37.125H61.875C62.1734 37.125 62.4595 37.2435 62.6705 37.4545C62.8815 37.6655 63 37.9516 63 38.25V57.375H9V38.25C9 37.9516 9.11853 37.6655 9.32951 37.4545C9.54048 37.2435 9.82663 37.125 10.125 37.125Z",
                fill: "#2A9F85"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M45.0437 45.8735C44.9954 45.6945 44.9244 45.5368 44.8306 45.4005C44.7369 45.2613 44.6218 45.1434 44.4854 45.0468C44.3491 44.9502 44.1928 44.8778 44.0167 44.8295C43.8406 44.7783 43.6474 44.7528 43.4371 44.7528C43.0138 44.7528 42.6474 44.855 42.3377 45.0596C42.0309 45.2641 41.7937 45.5624 41.6261 45.9545C41.4585 46.3437 41.3746 46.8167 41.3746 47.3735C41.3746 47.9332 41.4556 48.4104 41.6175 48.8053C41.7795 49.2002 42.0138 49.5013 42.3207 49.7087C42.6275 49.9161 42.9996 50.0198 43.4371 50.0198C43.8235 50.0198 44.1502 49.9573 44.4173 49.8323C44.6871 49.7045 44.8917 49.5241 45.0309 49.2911C45.1701 49.0581 45.2397 48.784 45.2397 48.4687L45.6317 48.5155H43.5096V46.9772H47.2724V48.132C47.2724 48.9133 47.1062 49.5823 46.7738 50.1391C46.4442 50.6959 45.9897 51.1235 45.4102 51.4218C44.8335 51.7201 44.1701 51.8692 43.4201 51.8692C42.5877 51.8692 41.8562 51.6888 41.2255 51.328C40.5948 50.9672 40.1033 50.453 39.7511 49.7854C39.3988 49.115 39.2227 48.3195 39.2227 47.3991C39.2227 46.6832 39.3292 46.0482 39.5423 45.4942C39.7553 44.9374 40.0522 44.4658 40.4329 44.0795C40.8164 43.6931 41.2596 43.4005 41.7624 43.2016C42.2681 43.0028 42.8121 42.9033 43.3945 42.9033C43.9002 42.9033 44.3704 42.9758 44.805 43.1207C45.2425 43.2655 45.6289 43.4701 45.9641 43.7343C46.3022 43.9985 46.5764 44.3124 46.7866 44.676C46.9968 45.0397 47.1275 45.4388 47.1786 45.8735H45.0437Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M28.2422 43.0225H30.8544L33.0703 48.4259H33.1726L35.3885 43.0225H38.0007V51.7497H35.9467V46.3889H35.8743L33.7777 51.6943H32.4652L30.3686 46.3591H30.2962V51.7497H28.2422V43.0225Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M26.918 43.0225V51.7497H24.8086V43.0225H26.918Z",
                fill: "white"
            })
        ]
    });
};
var VideoIcon = function() {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "72",
        height: "72",
        viewBox: "0 0 72 72",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_4164_353)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M14.6245 63L8.98828 57.375H14.6245V63Z",
                        fill: "#AD2337"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M57.375 63L63.0112 57.375H57.375V63Z",
                        fill: "#AD2337"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M57.3755 14.625H48.3867V5.63623L57.3755 14.625Z",
                        fill: "#B2B2B2"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M48.375 5.625H16.4138C15.9393 5.625 15.4844 5.81346 15.1489 6.14891C14.8135 6.48437 14.625 6.93934 14.625 7.41375V64.7887C14.625 65.2642 14.8131 65.7203 15.1482 66.0576C15.4834 66.3948 15.9383 66.5858 16.4138 66.5887H55.5863C55.8265 66.5874 56.064 66.5379 56.2848 66.4433C56.5057 66.3487 56.7053 66.2108 56.872 66.0378C57.0387 65.8648 57.1691 65.6602 57.2555 65.436C57.3419 65.2118 57.3825 64.9726 57.375 64.7325V14.625H48.375V5.625Z",
                        fill: "#E9E9E0"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.125 37.125H61.875C62.1734 37.125 62.4595 37.2435 62.6705 37.4545C62.8815 37.6655 63 37.9516 63 38.25V57.375H9V38.25C9 37.9516 9.11853 37.6655 9.32951 37.4545C9.54048 37.2435 9.82663 37.125 10.125 37.125Z",
                        fill: "#F15668"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M55.0966 47.3863C55.0966 48.3465 54.9119 49.1604 54.5426 49.828C54.1733 50.4956 53.6733 51.0028 53.0426 51.3493C52.4148 51.6959 51.7102 51.8692 50.929 51.8692C50.1449 51.8692 49.4389 51.6945 48.8111 51.3451C48.1832 50.9956 47.6847 50.4885 47.3153 49.8238C46.9489 49.1562 46.7656 48.3437 46.7656 47.3863C46.7656 46.426 46.9489 45.6121 47.3153 44.9445C47.6847 44.2769 48.1832 43.7698 48.8111 43.4232C49.4389 43.0766 50.1449 42.9033 50.929 42.9033C51.7102 42.9033 52.4148 43.0766 53.0426 43.4232C53.6733 43.7698 54.1733 44.2769 54.5426 44.9445C54.9119 45.6121 55.0966 46.426 55.0966 47.3863ZM52.9403 47.3863C52.9403 46.8181 52.8594 46.338 52.6974 45.9459C52.5384 45.5539 52.3082 45.257 52.0071 45.0553C51.7088 44.8536 51.3494 44.7528 50.929 44.7528C50.5114 44.7528 50.152 44.8536 49.8509 45.0553C49.5497 45.257 49.3182 45.5539 49.1562 45.9459C48.9972 46.338 48.9176 46.8181 48.9176 47.3863C48.9176 47.9545 48.9972 48.4346 49.1562 48.8266C49.3182 49.2187 49.5497 49.5155 49.8509 49.7172C50.152 49.9189 50.5114 50.0198 50.929 50.0198C51.3494 50.0198 51.7088 49.9189 52.0071 49.7172C52.3082 49.5155 52.5384 49.2187 52.6974 48.8266C52.8594 48.4346 52.9403 47.9545 52.9403 47.3863Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M39.4531 51.7497V43.0225H45.5384V44.7355H41.5625V46.5253H45.2273V48.2426H41.5625V50.0367H45.5384V51.7497H39.4531Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M33.9134 51.7497H30.6875V43.0225H33.9091C34.7983 43.0225 35.5639 43.1972 36.206 43.5466C36.8509 43.8932 37.348 44.3932 37.6974 45.0466C38.0469 45.6972 38.2216 46.4756 38.2216 47.3818C38.2216 48.2909 38.0469 49.0722 37.6974 49.7256C37.3509 50.379 36.8551 50.8804 36.2102 51.2298C35.5653 51.5764 34.7997 51.7497 33.9134 51.7497ZM32.7969 49.9514H33.8324C34.321 49.9514 34.7344 49.8691 35.0724 49.7043C35.4134 49.5367 35.6705 49.2654 35.8438 48.8904C36.0199 48.5125 36.108 48.0097 36.108 47.3818C36.108 46.754 36.0199 46.254 35.8438 45.8818C35.6676 45.5068 35.4077 45.2369 35.0639 45.0722C34.723 44.9046 34.3026 44.8208 33.8026 44.8208H32.7969V49.9514Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M29.3633 43.0225V51.7497H27.2539V43.0225H29.3633Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M19.978 43.0225L21.9297 49.4145H22.0021L23.9538 43.0225H26.3146L23.37 51.7497H20.5618L17.6172 43.0225H19.978Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M29.1719 16.2451V22.9726V29.6889L42.8294 22.9726L29.1719 16.2451Z",
                        stroke: "#F15668",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_4164_353",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "72",
                        height: "72",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var UploadIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_4134_12123)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0.67552 7.49928C0.595818 7.41958 0.487717 7.3748 0.375 7.3748C0.262283 7.3748 0.154182 7.41958 0.0744796 7.49928C-0.0052233 7.57899 -0.05 7.68709 -0.05 7.7998V9.6748C-0.05 10.0859 0.113303 10.4801 0.403985 10.7708C0.694666 11.0615 1.08891 11.2248 1.5 11.2248H10.5C10.9111 11.2248 11.3053 11.0615 11.596 10.7708C11.8867 10.4801 12.05 10.0859 12.05 9.6748V7.7998C12.05 7.68709 12.0052 7.57899 11.9255 7.49928C11.8458 7.41958 11.7377 7.3748 11.625 7.3748C11.5123 7.3748 11.4042 7.41958 11.3245 7.49928C11.2448 7.57899 11.2 7.68709 11.2 7.7998V9.6748C11.2 9.86046 11.1263 10.0385 10.995 10.1698C10.8637 10.3011 10.6857 10.3748 10.5 10.3748H1.5C1.31435 10.3748 1.1363 10.3011 1.00503 10.1698C0.87375 10.0385 0.8 9.86046 0.8 9.6748V7.7998C0.8 7.68709 0.755223 7.57899 0.67552 7.49928Z",
                        fill: "#404041",
                        stroke: "#404041",
                        strokeWidth: "0.1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.94962 3.67555L7.94961 3.67554L6.42547 2.15069V8.62469C6.42547 8.73741 6.3807 8.84551 6.30099 8.92521C6.22129 9.00492 6.11319 9.04969 6.00047 9.04969C5.88776 9.04969 5.77966 9.00492 5.69995 8.92521C5.62025 8.84551 5.57547 8.73741 5.57547 8.62469V2.15069L4.05134 3.67554L4.05133 3.67555C4.01182 3.71506 3.96492 3.7464 3.9133 3.76778C3.86167 3.78916 3.80635 3.80017 3.75047 3.80017C3.6946 3.80017 3.63927 3.78916 3.58765 3.76778C3.53603 3.7464 3.48913 3.71506 3.44962 3.67555C3.41011 3.63604 3.37877 3.58914 3.35739 3.53752C3.33601 3.48589 3.325 3.43057 3.325 3.37469C3.325 3.31882 3.33601 3.26349 3.35739 3.21187L3.40351 3.23098L3.35739 3.21187C3.37877 3.16025 3.41011 3.11335 3.44962 3.07384L5.69957 0.823883L7.94962 3.67555ZM7.94962 3.67555C8.02941 3.75534 8.13763 3.80017 8.25047 3.80017C8.36332 3.80017 8.47154 3.75534 8.55133 3.67555C8.63112 3.59576 8.67595 3.48754 8.67595 3.37469C8.67595 3.26185 8.63112 3.15363 8.55133 3.07384L6.30137 0.823883L7.94962 3.67555Z",
                        fill: "#404041",
                        stroke: "#404041",
                        strokeWidth: "0.1"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4134_12123",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var LinkIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "18",
        viewBox: "0 0 20 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5.61597 17.2917C4.66813 17.2919 3.7415 17.011 2.95335 16.4845C2.16519 15.958 1.55092 15.2096 1.18827 14.3338C0.825613 13.4581 0.730874 12.4945 0.916037 11.5649C1.1012 10.6353 1.55794 9.78158 2.22847 9.11165L9.29931 2.03999C9.41655 1.92274 9.57557 1.85687 9.74139 1.85687C9.9072 1.85687 10.0662 1.92274 10.1835 2.03999C10.3007 2.15724 10.3666 2.31626 10.3666 2.48207C10.3666 2.64788 10.3007 2.80691 10.1835 2.92415L3.11181 9.99499C2.76945 10.3208 2.49576 10.7118 2.30686 11.145C2.11796 11.5782 2.01768 12.0449 2.01193 12.5175C2.00617 12.99 2.09506 13.459 2.27334 13.8967C2.45163 14.3344 2.71572 14.7319 3.05004 15.066C3.38436 15.4 3.78216 15.6638 4.21999 15.8417C4.65783 16.0196 5.12685 16.1081 5.59941 16.102C6.07198 16.0958 6.53854 15.9951 6.9716 15.8059C7.40465 15.6166 7.79545 15.3426 8.12097 15L17.2543 5.86665C17.6728 5.43446 17.9047 4.85506 17.8999 4.25344C17.895 3.65183 17.6539 3.07623 17.2285 2.65081C16.8031 2.22539 16.2275 1.98425 15.6258 1.97942C15.0242 1.97459 14.4448 2.20645 14.0126 2.62499L6.64764 9.99499C6.45226 10.1904 6.3425 10.4554 6.3425 10.7317C6.3425 11.008 6.45226 11.2729 6.64764 11.4683C6.84301 11.6637 7.108 11.7735 7.38431 11.7735C7.66061 11.7735 7.9256 11.6637 8.12097 11.4683L12.8335 6.75499C12.8911 6.69527 12.96 6.64762 13.0363 6.61483C13.1125 6.58204 13.1945 6.56476 13.2775 6.564C13.3605 6.56324 13.4428 6.57901 13.5196 6.6104C13.5964 6.64179 13.6663 6.68817 13.725 6.74682C13.7837 6.80548 13.8301 6.87524 13.8616 6.95203C13.893 7.02883 13.9089 7.11112 13.9082 7.19411C13.9075 7.27709 13.8903 7.35911 13.8576 7.43538C13.8249 7.51165 13.7773 7.58064 13.7176 7.63832L9.00431 12.3525C8.57454 12.7824 7.99162 13.0239 7.38377 13.024C6.77591 13.0241 6.19293 12.7827 5.76306 12.3529C5.33318 11.9231 5.09164 11.3402 5.09156 10.7324C5.09148 10.1245 5.33288 9.54153 5.76264 9.11165L13.1293 1.74999C13.7935 1.08573 14.6943 0.712511 15.6336 0.712433C16.5729 0.712355 17.4738 1.08542 18.1381 1.74957C18.8023 2.41372 19.1755 3.31454 19.1756 4.25386C19.1757 5.19318 18.8026 6.09406 18.1385 6.75832L9.00514 15.8883C8.56103 16.3347 8.03283 16.6885 7.45109 16.9294C6.86934 17.1703 6.24561 17.2934 5.61597 17.2917Z",
            fill: "#A1A1A1",
            className: "group-hover:fill-primary"
        })
    });
};
var ShareLinkIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "17",
        height: "18",
        viewBox: "0 0 17 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.25 7.9375C3.6632 7.9375 3.1875 8.4132 3.1875 9C3.1875 9.5868 3.6632 10.0625 4.25 10.0625C4.8368 10.0625 5.3125 9.5868 5.3125 9C5.3125 8.4132 4.8368 7.9375 4.25 7.9375ZM2.125 9C2.125 7.82639 3.07639 6.875 4.25 6.875C5.4236 6.875 6.375 7.82639 6.375 9C6.375 10.1736 5.4236 11.125 4.25 11.125C3.07639 11.125 2.125 10.1736 2.125 9Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.75 3.15625C12.1632 3.15625 11.6875 3.63195 11.6875 4.21875C11.6875 4.80555 12.1632 5.28125 12.75 5.28125C13.3368 5.28125 13.8125 4.80555 13.8125 4.21875C13.8125 3.63195 13.3368 3.15625 12.75 3.15625ZM10.625 4.21875C10.625 3.04514 11.5764 2.09375 12.75 2.09375C13.9236 2.09375 14.875 3.04514 14.875 4.21875C14.875 5.39235 13.9236 6.34375 12.75 6.34375C11.5764 6.34375 10.625 5.39235 10.625 4.21875Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.75 12.7188C12.1632 12.7188 11.6875 13.1944 11.6875 13.7812C11.6875 14.3681 12.1632 14.8438 12.75 14.8438C13.3368 14.8438 13.8125 14.3681 13.8125 13.7812C13.8125 13.1944 13.3368 12.7188 12.75 12.7188ZM10.625 13.7812C10.625 12.6076 11.5764 11.6562 12.75 11.6562C13.9236 11.6562 14.875 12.6076 14.875 13.7812C14.875 14.9549 13.9236 15.9062 12.75 15.9062C11.5764 15.9062 10.625 14.9549 10.625 13.7812Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.17574 9.5209C5.31958 9.26517 5.64349 9.17448 5.89921 9.31832L11.6214 12.537C11.8772 12.6809 11.9679 13.0048 11.824 13.2605C11.6802 13.5162 11.3563 13.6069 11.1005 13.4631L5.37832 10.2444C5.1226 10.1005 5.0319 9.77662 5.17574 9.5209Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.824 4.73965C11.9679 4.99537 11.8772 5.31928 11.6214 5.46312L5.89921 8.68183C5.64349 8.82567 5.31958 8.73498 5.17574 8.47925C5.0319 8.22353 5.1226 7.89962 5.37832 7.75578L11.1005 4.53707C11.3563 4.39323 11.6802 4.48392 11.824 4.73965Z",
                fill: "white"
            })
        ]
    });
};
var IconDownload = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "17",
        height: "18",
        viewBox: "0 0 17 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.51562 6.875C4.30428 6.875 4.10159 6.95896 3.95215 7.1084C3.80271 7.25784 3.71875 7.46053 3.71875 7.67188V14.5781C3.71875 14.7895 3.80271 14.9922 3.95215 15.1416C4.10159 15.291 4.30428 15.375 4.51562 15.375H12.4844C12.6957 15.375 12.8984 15.291 13.0479 15.1416C13.1973 14.9922 13.2812 14.7895 13.2812 14.5781V7.67188C13.2812 7.46053 13.1973 7.25784 13.0479 7.1084C12.8984 6.95896 12.6957 6.875 12.4844 6.875H11.1562C10.8628 6.875 10.625 6.63715 10.625 6.34375C10.625 6.05035 10.8628 5.8125 11.1562 5.8125H12.4844C12.9775 5.8125 13.4505 6.0084 13.7992 6.3571C14.1479 6.7058 14.3438 7.17874 14.3438 7.67188V14.5781C14.3438 15.0713 14.1479 15.5442 13.7992 15.8929C13.4505 16.2416 12.9775 16.4375 12.4844 16.4375H4.51562C4.02249 16.4375 3.54955 16.2416 3.20085 15.8929C2.85215 15.5442 2.65625 15.0713 2.65625 14.5781V7.67188C2.65625 7.17874 2.85215 6.7058 3.20085 6.3571C3.54955 6.0084 4.02249 5.8125 4.51562 5.8125H5.84375C6.13715 5.8125 6.375 6.05035 6.375 6.34375C6.375 6.63715 6.13715 6.875 5.84375 6.875H4.51562Z",
                fill: "#404041"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.4681 9.1556C5.67557 8.94813 6.01193 8.94813 6.2194 9.1556L8.5 11.4362L10.7806 9.1556C10.9881 8.94813 11.3244 8.94813 11.5319 9.1556C11.7394 9.36307 11.7394 9.69943 11.5319 9.9069L8.87565 12.5632C8.66818 12.7706 8.33182 12.7706 8.12435 12.5632L5.4681 9.9069C5.26063 9.69943 5.26063 9.36307 5.4681 9.1556Z",
                fill: "#404041"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.5 1.5625C8.7934 1.5625 9.03125 1.80035 9.03125 2.09375V11.6562C9.03125 11.9497 8.7934 12.1875 8.5 12.1875C8.2066 12.1875 7.96875 11.9497 7.96875 11.6562V2.09375C7.96875 1.80035 8.2066 1.5625 8.5 1.5625Z",
                fill: "#404041"
            })
        ]
    });
};
var IconCongrats = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M50 65.625C48.9805 65.625 47.9687 65.5781 46.9707 65.4902C41.8209 65.03 36.8412 63.4148 32.4017 60.7648C27.9622 58.1148 24.1772 54.498 21.3281 50.1836L3.90625 81.25H26.3672L37.6953 100L53.8144 65.4121C52.5478 65.5531 51.2744 65.6242 50 65.625Z",
                fill: "#FFB800"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M78.7109 50.1445C74.585 56.3932 68.5408 61.1323 61.4883 63.6484L53.457 81.1523L62.3047 100L73.6328 81.25H96.0937L78.7109 50.1445Z",
                fill: "#FFB800"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M50.0039 40.625C55.1816 40.625 59.3789 36.4277 59.3789 31.25C59.3789 26.0723 55.1816 21.875 50.0039 21.875C44.8262 21.875 40.6289 26.0723 40.6289 31.25C40.6289 36.4277 44.8262 40.625 50.0039 40.625Z",
                fill: "#FFB800"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M50 3.125C34.4922 3.125 21.875 15.7422 21.875 31.25C21.875 46.7578 34.4922 59.375 50 59.375C65.5078 59.375 78.125 46.7578 78.125 31.25C78.125 15.7422 65.5078 3.125 50 3.125ZM50 46.875C46.9097 46.875 43.8887 45.9586 41.3192 44.2417C38.7497 42.5248 36.747 40.0845 35.5644 37.2294C34.3818 34.3743 34.0723 31.2327 34.6752 28.2017C35.2781 25.1708 36.7663 22.3867 38.9515 20.2015C41.1367 18.0163 43.9208 16.5281 46.9517 15.9252C49.9827 15.3223 53.1243 15.6318 55.9794 16.8144C58.8345 17.997 61.2748 19.9997 62.9917 22.5692C64.7086 25.1387 65.625 28.1597 65.625 31.25C65.6203 35.3926 63.9727 39.3642 61.0434 42.2934C58.1142 45.2227 54.1426 46.8703 50 46.875Z",
                fill: "#FFB800"
            })
        ]
    });
};
var IconLoudSpeaker = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_12751_6366)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10.4038 18.4791L9.83563 18.631C9.39969 18.7469 8.93969 18.5791 8.68376 18.211L6.25188 14.7428L10.34 15.1788L11.1159 17.0269C11.3638 17.6269 11.0319 18.311 10.4038 18.4791ZM2.51188 7.52284L1.19188 7.87878C0.335943 8.11065 -0.176245 8.99065 0.0559428 9.8469L0.89188 12.9669C1.12001 13.8228 2.00001 14.331 2.86001 14.0988L4.18001 13.7469L2.51188 7.52284ZM15.6663 13.8078L12.4303 1.7294C12.3331 1.36597 11.9016 1.21378 11.5978 1.43503L3.67032 7.2144L5.33751 13.4363L15.0925 14.4782C15.4663 14.5182 15.7638 14.1703 15.6663 13.8078ZM16.1572 3.80597C16.0659 3.80597 15.9744 3.78284 15.89 3.73409C15.6338 3.58628 15.5463 3.25878 15.6941 3.00284L16.4681 1.66253C16.6156 1.40597 16.9441 1.31847 17.1994 1.46659C17.4556 1.6144 17.5431 1.9419 17.3953 2.19784L16.6213 3.53815C16.5219 3.71003 16.3419 3.80597 16.1572 3.80597ZM16.9216 7.53378C16.685 7.53378 16.4688 7.37597 16.4047 7.1369C16.3284 6.85128 16.4978 6.55784 16.7834 6.48097L18.2784 6.08065C18.5656 6.0044 18.8578 6.17315 18.9347 6.4594C19.0109 6.74503 18.8416 7.03847 18.5559 7.11534L17.0609 7.51565C17.0138 7.52815 16.9675 7.53378 16.9216 7.53378ZM19.4641 11.9185C19.3728 11.9185 19.2813 11.8953 19.1969 11.8466L17.8566 11.0725C17.6003 10.9247 17.5128 10.5972 17.6606 10.3413C17.8084 10.0847 18.1366 9.99722 18.3919 10.1453L19.7322 10.9194C19.9884 11.0672 20.0759 11.3947 19.9281 11.6507C19.8291 11.8225 19.6488 11.9185 19.4641 11.9185Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_12751_6366",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var LockIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M82.0312 37.5H68.75V21.875C68.75 16.9022 66.7746 12.1331 63.2583 8.61675C59.7419 5.10044 54.9728 3.125 50 3.125C45.0272 3.125 40.2581 5.10044 36.7417 8.61675C33.2254 12.1331 31.25 16.9022 31.25 21.875V37.5H17.9688C17.3471 37.5 16.751 37.7469 16.3115 38.1865C15.8719 38.626 15.625 39.2221 15.625 39.8438V94.5312C15.625 95.1529 15.8719 95.749 16.3115 96.1885C16.751 96.6281 17.3471 96.875 17.9688 96.875H82.0312C82.6529 96.875 83.249 96.6281 83.6885 96.1885C84.1281 95.749 84.375 95.1529 84.375 94.5312V39.8438C84.375 39.2221 84.1281 38.626 83.6885 38.1865C83.249 37.7469 82.6529 37.5 82.0312 37.5ZM61.3281 37.5H38.6719V21.7285C38.6719 18.7241 39.8654 15.8428 41.9898 13.7183C44.1142 11.5939 46.9956 10.4004 50 10.4004C53.0044 10.4004 55.8858 11.5939 58.0102 13.7183C60.1346 15.8428 61.3281 18.7241 61.3281 21.7285V37.5Z",
            fill: "#FFB800"
        })
    });
};
var IRibbon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M50 65.625C48.9805 65.625 47.9687 65.5781 46.9707 65.4902C41.8209 65.03 36.8412 63.4148 32.4017 60.7648C27.9622 58.1148 24.1772 54.498 21.3281 50.1836L3.90625 81.25H26.3672L37.6953 100L53.8144 65.4121C52.5478 65.5531 51.2744 65.6242 50 65.625Z",
                fill: "#FFB800"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M78.7109 50.1445C74.585 56.3932 68.5408 61.1323 61.4883 63.6484L53.457 81.1523L62.3047 100L73.6328 81.25H96.0937L78.7109 50.1445Z",
                fill: "#FFB800"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M50.0039 40.625C55.1816 40.625 59.3789 36.4277 59.3789 31.25C59.3789 26.0723 55.1816 21.875 50.0039 21.875C44.8262 21.875 40.6289 26.0723 40.6289 31.25C40.6289 36.4277 44.8262 40.625 50.0039 40.625Z",
                fill: "#FFB800"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M50 3.125C34.4922 3.125 21.875 15.7422 21.875 31.25C21.875 46.7578 34.4922 59.375 50 59.375C65.5078 59.375 78.125 46.7578 78.125 31.25C78.125 15.7422 65.5078 3.125 50 3.125ZM50 46.875C46.9097 46.875 43.8887 45.9586 41.3192 44.2417C38.7497 42.5248 36.747 40.0845 35.5644 37.2294C34.3818 34.3743 34.0723 31.2327 34.6752 28.2017C35.2781 25.1708 36.7663 22.3867 38.9515 20.2015C41.1367 18.0163 43.9208 16.5281 46.9517 15.9252C49.9827 15.3223 53.1243 15.6318 55.9794 16.8144C58.8345 17.997 61.2748 19.9997 62.9917 22.5692C64.7086 25.1387 65.625 28.1597 65.625 31.25C65.6203 35.3926 63.9727 39.3642 61.0434 42.2934C58.1142 45.2227 54.1426 46.8703 50 46.875Z",
                fill: "#FFB800"
            })
        ]
    });
};
var IconSupportCenter = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "25",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onClick: onClick,
        className: "cursor-pointer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.707 14.7072C7.51947 14.8947 7.26516 15 7 15C6.73484 15 6.48053 14.8947 6.293 14.7072L2.293 10.7072C2.10553 10.5197 2.00021 10.2654 2.00021 10.0002C2.00021 9.73505 2.10553 9.48074 2.293 9.29322L6.293 5.29321C6.4816 5.11106 6.7342 5.01026 6.9964 5.01254C7.2586 5.01482 7.50941 5.11999 7.69482 5.3054C7.88023 5.4908 7.98539 5.74162 7.98767 6.00381C7.98995 6.26601 7.88916 6.51861 7.707 6.70721L5.414 9.00021L17 9.00021C17.2652 9.00021 17.5196 9.10557 17.7071 9.29311C17.8946 9.48064 18 9.735 18 10.0002C18 10.2654 17.8946 10.5198 17.7071 10.7073C17.5196 10.8949 17.2652 11.0002 17 11.0002L5.414 11.0002L7.707 13.2932C7.89447 13.4807 7.99979 13.7351 7.99979 14.0002C7.99979 14.2654 7.89447 14.5197 7.707 14.7072Z",
            fill: "#404041"
        })
    });
};
var IconRequestForm = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.9986 15.1916C24.8807 15.772 24.3553 16.1947 23.7254 16.221C23.527 16.2288 23.3581 16.3706 23.3206 16.5623C23.2804 16.754 23.3796 16.9483 23.5592 17.0297C24.1301 17.2923 24.4491 17.8805 24.3285 18.4608L24.2159 19.0123C24.0685 19.7396 23.2482 20.1939 22.5298 20.0206C22.3288 19.9734 22.1224 19.9366 21.9187 19.8972C21.6184 19.8394 21.3182 19.779 21.018 19.7213C20.6213 19.6425 20.2245 19.5664 19.8278 19.4876C19.3561 19.3957 18.8816 19.3011 18.4098 19.2092C17.8818 19.1042 17.3537 19.0018 16.8257 18.8968C16.2627 18.7865 15.6972 18.6762 15.1342 18.5633C14.5552 18.4504 13.9762 18.3348 13.3999 18.2219C12.8263 18.109 12.2553 17.9961 11.6817 17.8832C11.1349 17.7755 10.588 17.6678 10.0412 17.5602C9.53997 17.463 9.04139 17.3632 8.54013 17.2661C8.10589 17.1821 7.67164 17.0954 7.24007 17.0114C6.89428 16.9431 6.5485 16.8749 6.20003 16.8066C5.96146 16.7593 5.72287 16.712 5.48432 16.6648C5.3744 16.6438 5.26452 16.6201 5.15462 16.5991C5.14926 16.5991 5.1439 16.5965 5.13851 16.5965C5.19748 16.8696 5.17068 17.1611 5.04201 17.4341C4.77125 18.0066 4.14132 18.3059 3.53555 18.1904C3.35596 18.1563 3.16028 18.2219 3.08254 18.3847L2.84129 18.8968C2.76359 19.0595 2.84129 19.2486 2.98339 19.3615C3.01019 19.3826 22.3315 28.1084 22.3636 28.1162C22.5432 28.1504 22.7389 28.0847 22.8166 27.9219L23.0579 27.4099C23.1356 27.2471 23.0579 27.058 22.9158 26.9451C22.4333 26.5696 22.2564 25.9052 22.5271 25.3328C22.7979 24.7604 23.4278 24.461 24.0336 24.5766C24.2131 24.6107 24.4088 24.545 24.4866 24.3822L24.7278 23.8702C24.8055 23.7074 24.7278 23.5184 24.5857 23.4054C24.1032 23.0299 23.9263 22.3656 24.1971 21.7931C24.4678 21.2207 25.0977 20.9213 25.7035 21.0369C25.8831 21.071 26.0788 21.0054 26.1565 20.8426L26.3978 20.3305C26.4755 20.1677 26.3978 19.9787 26.2557 19.8657C25.7732 19.4902 25.5963 18.8259 25.867 18.2534C26.1378 17.681 26.7677 17.3817 27.3735 17.4972C27.5531 17.5313 27.7487 17.4657 27.8265 17.3029L28.0918 16.7357C28.1696 16.5729 28.0972 16.3812 27.931 16.3051L25.0441 15L24.9986 15.1916Z",
                fill: "#18355D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.13004 14.635C2.16264 14.6508 23.2998 18.75 23.3351 18.75C23.5199 18.7421 23.6991 18.6318 23.7344 18.4585L23.8485 17.907C23.8838 17.7311 23.7643 17.563 23.5959 17.4869C23.0309 17.2295 22.6967 16.6255 22.8244 16.0058C22.9521 15.386 23.5035 14.9527 24.1283 14.9265C24.3131 14.9186 24.4923 14.8083 24.5277 14.635L24.6119 14.2306L24.6418 14.0809C24.6771 13.9049 24.5575 13.7369 24.3891 13.6607C23.8241 13.4034 23.49 12.7994 23.6177 12.1796C23.7453 11.5599 24.2968 11.1266 24.9216 11.1003C25.1063 11.0924 25.2856 10.9821 25.3209 10.8088L25.435 10.2574C25.4703 10.0814 25.3508 9.91334 25.1823 9.83719C24.6173 9.57983 24.2832 8.97584 24.4109 8.35609C24.5385 7.73634 25.09 7.30305 25.7148 7.27679C25.8995 7.26891 26.0788 7.15861 26.1141 6.98529L26.2418 6.37342C26.2771 6.19748 26.1603 6.02679 25.9783 5.99265C25.9783 5.99265 4.73791 1.875 4.71618 1.875C4.55862 1.875 4.42008 1.98267 4.38748 2.13498L4.25981 2.74685C4.22449 2.92279 4.34402 3.09086 4.51244 3.16702C5.07748 3.42437 5.41161 4.02836 5.28393 4.64811C5.15626 5.26786 4.6048 5.70116 3.98001 5.72742C3.79526 5.73529 3.616 5.84559 3.58068 6.01891L3.46659 6.57038C3.43127 6.74632 3.5508 6.91439 3.71922 6.99055C4.28426 7.2479 4.61841 7.85189 4.49071 8.47164C4.36304 9.09139 3.81158 9.52469 3.18679 9.55095C3.00206 9.55882 2.82277 9.66912 2.78746 9.84244L2.67337 10.3939C2.63805 10.5699 2.75761 10.7379 2.926 10.8141C3.49106 11.0714 3.82519 11.6754 3.69749 12.2952C3.56981 12.9149 3.01836 13.3482 2.39357 13.3745C2.20884 13.3824 2.02955 13.4927 1.99424 13.666L1.88015 14.2175C1.84209 14.3934 1.96159 14.5589 2.13004 14.635ZM20.2356 7.90444C20.3089 7.54992 20.6675 7.31883 21.0342 7.38973C21.401 7.46064 21.64 7.80727 21.5667 8.16179L20.6702 12.4738L20.1188 15.1313C20.0536 15.4438 19.771 15.6592 19.4532 15.6592C19.4097 15.6592 19.3636 15.6539 19.3201 15.6461C18.9534 15.5752 18.7143 15.2285 18.7877 14.874L19.4043 11.9092L20.2356 7.90444ZM7.98955 5.52786C8.06289 5.17335 8.42147 4.94225 8.7882 5.01316C9.15493 5.08406 9.39398 5.4307 9.32064 5.78522L9.01096 7.27419L8.66055 8.96274L8.37804 10.323L7.87548 12.7548C7.81031 13.0673 7.52777 13.2826 7.20994 13.2826C7.16647 13.2826 7.12029 13.2774 7.07686 13.2695C7.05784 13.2668 7.03882 13.2616 7.02252 13.2564C6.68568 13.1618 6.47648 12.8335 6.54714 12.4974L6.64762 12.0064L6.91112 10.7353L7.98955 5.52786Z",
                fill: "#18355D"
            })
        ]
    });
};
var IconChat = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.24432 2.8125C4.79669 2.8125 2.8125 4.79669 2.8125 7.24432V22.7557C2.8125 25.2033 4.79669 27.1875 7.24432 27.1875H22.7557C25.2033 27.1875 27.1875 25.2033 27.1875 22.7557V7.24432C27.1875 4.79669 25.2033 2.8125 22.7557 2.8125H7.24432ZM12.4316 9.7624C12.4316 7.75979 14.055 6.13636 16.0575 6.13636H19.2807C19.5033 6.13636 19.6837 6.31675 19.6837 6.53926V9.7624C19.6837 9.98491 19.5033 10.1653 19.2807 10.1653H17.6692C17.0016 10.1653 16.4605 10.7064 16.4605 11.374V12.5826H19.2807C19.4048 12.5826 19.5219 12.6398 19.5983 12.7376C19.6747 12.8354 19.7017 12.9629 19.6716 13.0832L18.8658 16.3064C18.821 16.4858 18.6598 16.6115 18.475 16.6115H16.4605V23.4608C16.4605 23.6833 16.2801 23.8636 16.0575 23.8636H12.8345C12.6119 23.8636 12.4316 23.6833 12.4316 23.4608V16.6115H10.4171C10.1946 16.6115 10.0142 16.4311 10.0142 16.2087V12.9855C10.0142 12.763 10.1946 12.5826 10.4171 12.5826H12.4316V9.7624Z",
            fill: "#18355D"
        })
    });
};
var IconAccess = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.3953 12.3491C18.237 7.85013 11.7549 7.85201 11.5977 12.3492C11.7437 16.8425 18.2502 16.8407 18.3953 12.3491Z",
                fill: "#18355D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.08136 13.6614C5.45066 13.95 5.88359 14.1462 6.34408 14.2337C6.80458 14.3211 7.2793 14.2973 7.72871 14.1641C8.17813 14.031 8.58922 13.7924 8.92776 13.4682C9.2663 13.144 9.52248 12.7437 9.67497 12.3004C9.82745 11.8572 9.87183 11.384 9.8044 10.9201C9.73697 10.4563 9.55969 10.0153 9.28732 9.63379C9.01495 9.25232 8.65537 8.94146 8.23855 8.72709C7.82172 8.51272 7.3597 8.40104 6.89098 8.40137C6.28258 8.40989 5.69163 8.60596 5.1988 8.96282C4.70598 9.31968 4.33529 9.81994 4.13735 10.3953C3.9394 10.9707 3.92384 11.5931 4.0928 12.1776C4.26175 12.7622 4.60698 13.2803 5.08136 13.6614Z",
                fill: "#18355D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.19823 19.2405C8.20714 17.8576 9.15642 16.6706 10.0922 15.7713C10.3459 15.5384 10.617 15.3252 10.9032 15.1337C10.5341 14.7229 10.1021 14.3732 9.62339 14.0977C8.89689 14.8213 7.91329 15.2275 6.88793 15.2275C5.86257 15.2275 4.87898 14.8212 4.15248 14.0977C2.84636 14.8844 1.19983 16.6244 2.16474 18.2419C2.34514 18.5473 2.60233 18.8002 2.91075 18.9753C3.21917 19.1505 3.56807 19.2419 3.92276 19.2405H8.19823Z",
                fill: "#18355D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1582 11.3456C20.2867 15.235 25.9186 15.2334 26.0464 11.3455C25.9065 7.44981 20.2978 7.45004 20.1582 11.3456Z",
                fill: "#18355D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.5157 15.8831C18.3275 15.7558 18.1318 15.6399 17.9296 15.5362C17.7934 15.6623 17.6494 15.7798 17.4984 15.8878C16.6878 16.4583 15.7065 16.7345 14.7173 16.6705C13.7281 16.6066 12.7906 16.2063 12.0602 15.5361C10.6967 16.2831 9.26653 17.5977 9.13479 19.2397C9.13172 19.8645 9.37696 20.4649 9.81657 20.9089C10.2562 21.3528 10.8541 21.604 11.4789 21.6071L18.5109 21.6072C18.9156 21.6023 19.3121 21.4935 19.6627 21.2914C20.0133 21.0893 20.3061 20.8006 20.5131 20.4529C20.7201 20.1053 20.8344 19.7102 20.845 19.3057C20.8556 18.9012 20.7622 18.5008 20.5737 18.1427C20.0867 17.2298 19.3793 16.453 18.5157 15.8831Z",
                fill: "#18355D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.8741 16.2071C27.4019 15.3296 26.6982 14.5983 25.8395 14.0928C25.1134 14.8184 24.1291 15.2264 23.1026 15.2273C22.0761 15.2282 21.0912 14.8218 20.3639 14.0974C19.887 14.3757 19.4554 14.725 19.084 15.1335C19.3703 15.3249 19.6415 15.538 19.895 15.7711C20.5582 16.366 21.0995 17.0841 21.489 17.8854C21.6871 18.3097 21.7911 18.7719 21.7937 19.2402H26.0692C26.4234 19.2359 26.7705 19.1406 27.0774 18.9637C27.3842 18.7867 27.6405 18.5339 27.8216 18.2295C28.0028 17.925 28.1027 17.5792 28.1119 17.2251C28.1211 16.871 28.0392 16.5204 27.8741 16.2071Z",
                fill: "#18355D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.3142 20.7033C26.2603 20.6735 26.201 20.6546 26.1399 20.6477C26.0787 20.6408 26.0167 20.646 25.9576 20.6631C25.8984 20.6801 25.8432 20.7087 25.7951 20.7471C25.7469 20.7855 25.7068 20.833 25.6771 20.8869C21.1445 29.2462 8.85361 29.244 4.32271 20.8867C4.29294 20.8328 4.25284 20.7853 4.20471 20.7469C4.15658 20.7085 4.10135 20.68 4.04219 20.6629C3.98302 20.6458 3.92107 20.6406 3.85988 20.6475C3.79869 20.6543 3.73945 20.6732 3.68555 20.703C3.63165 20.7328 3.58414 20.7728 3.54573 20.821C3.50733 20.8691 3.47878 20.9243 3.46172 20.9835C3.44466 21.0427 3.43942 21.1046 3.44629 21.1658C3.45317 21.227 3.47204 21.2862 3.50181 21.3401C8.38231 30.3414 21.6192 30.3393 26.498 21.34C26.5277 21.2861 26.5466 21.2269 26.5534 21.1657C26.5603 21.1046 26.555 21.0427 26.538 20.9836C26.5209 20.9244 26.4924 20.8692 26.454 20.8212C26.4155 20.7731 26.368 20.733 26.3142 20.7033Z",
                fill: "#18355D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.75506 7.07225C10.4122 1.43504 19.5887 1.43563 24.2452 7.07238C24.3268 7.16399 24.4411 7.21997 24.5635 7.22831C24.6859 7.23665 24.8067 7.19668 24.9 7.11698C24.9932 7.03728 25.0515 6.9242 25.0624 6.80199C25.0733 6.67978 25.0358 6.55819 24.958 6.46329C19.9421 0.390891 10.0577 0.391335 5.04222 6.46347C4.96423 6.55834 4.92657 6.68002 4.93736 6.80236C4.94814 6.9247 5.00651 7.03792 5.0999 7.11767C5.19329 7.19743 5.31425 7.23736 5.43676 7.22886C5.55928 7.22037 5.67357 7.16413 5.75506 7.07225Z",
                fill: "#18355D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.8504 7.56056C20.9481 7.55878 21.0428 7.52671 21.1215 7.46878C21.2002 7.41085 21.259 7.32991 21.2897 7.23714C21.3204 7.14437 21.3216 7.04436 21.2931 6.9509C21.2645 6.85744 21.2076 6.77515 21.1303 6.7154C19.3547 5.40578 17.2063 4.69921 14.9999 4.69922C12.7935 4.69923 10.6451 5.40581 8.86951 6.71546C8.7724 6.79057 8.70862 6.90077 8.69188 7.02239C8.67514 7.14401 8.70677 7.26734 8.77998 7.3659C8.85318 7.46445 8.96212 7.53036 9.08339 7.54946C9.20466 7.56856 9.32859 7.53934 9.42855 7.46806C11.0424 6.27812 12.9948 5.63615 14.9999 5.63617C17.0051 5.63618 18.9575 6.27817 20.5713 7.46813C20.6519 7.52823 20.7498 7.56065 20.8504 7.56056Z",
                fill: "#18355D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.65486 20.8229C7.57668 20.7283 7.46454 20.6681 7.3425 20.6552C7.22046 20.6424 7.09824 20.6778 7.00204 20.754C6.90585 20.8302 6.84334 20.9411 6.82793 21.0628C6.81252 21.1846 6.84544 21.3075 6.91961 21.4053C10.8751 26.5909 19.1243 26.5904 23.0793 21.4051C23.1536 21.3074 23.1866 21.1844 23.1712 21.0626C23.1558 20.9408 23.0933 20.8299 22.997 20.7537C22.9007 20.6774 22.7785 20.642 22.6564 20.655C22.5343 20.6679 22.4221 20.7282 22.344 20.8229C18.748 25.5379 11.2504 25.5374 7.65486 20.8229Z",
                fill: "#18355D"
            })
        ]
    });
};
var IconContact = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M29.5174 16.0919C29.5638 17.1995 29.1689 18.2803 28.4194 19.0971C27.67 19.9139 26.6271 20.4001 25.5196 20.4489C25.4548 20.452 25.3902 20.4535 25.3256 20.4535C25.0314 20.4533 24.738 20.4214 24.4505 20.3585C23.5976 21.6754 22.4793 22.7997 21.167 23.6596C19.8546 24.5196 18.3773 25.0961 16.8294 25.3524C16.6463 25.8903 16.2811 26.3473 15.7968 26.6444C15.3125 26.9415 14.7397 27.0601 14.1772 26.9796C13.6148 26.8992 13.0982 26.6248 12.7166 26.2038C12.335 25.7828 12.1125 25.2417 12.0876 24.6741C12.0626 24.1065 12.2368 23.548 12.5799 23.0952C12.9231 22.6424 13.4137 22.3237 13.9669 22.1942C14.5201 22.0647 15.1011 22.1325 15.6096 22.386C16.1181 22.6395 16.522 23.0626 16.7516 23.5824C18.9308 23.1793 20.8995 22.0244 22.3145 20.3188C23.7296 18.6132 24.5013 16.4652 24.4951 14.249C24.4951 9.01338 20.2356 4.75391 15 4.75391C9.76431 4.75391 5.50484 9.01338 5.50484 14.249C5.50455 15.868 5.91831 17.4601 6.70677 18.8741C6.73349 18.9207 6.75355 18.9709 6.76636 19.0231C6.84252 19.2348 6.83438 19.4677 6.74362 19.6735C6.65287 19.8793 6.48645 20.0424 6.2788 20.129C5.77036 20.3429 5.22427 20.4531 4.67263 20.453C4.60771 20.453 4.54265 20.4515 4.47745 20.4485C3.37043 20.399 2.32821 19.9126 1.57932 19.0958C0.830423 18.2791 0.435979 17.1987 0.482475 16.0915C0.501166 15.65 0.490736 15.2561 0.480541 14.8752C0.471049 14.5165 0.461146 14.1456 0.477435 13.7586C0.526049 12.6776 0.991064 11.6573 1.77508 10.9114C2.5591 10.1656 3.60131 9.75204 4.68341 9.7574C6.42107 5.7817 10.391 2.99609 15 2.99609C19.6089 2.99609 23.5789 5.7817 25.3166 9.75746C26.3988 9.75129 27.4413 10.1645 28.2255 10.9103C29.0096 11.6562 29.4744 12.6768 29.5224 13.7579C29.5388 14.1455 29.5289 14.5164 29.5193 14.875C29.5092 15.256 29.4987 15.6501 29.5174 16.0919ZM22.3713 14.249C22.3709 15.3783 22.1111 16.4924 21.612 17.5055C21.1129 18.5185 20.3877 19.4033 19.4926 20.0918C18.5974 20.7802 17.556 21.2539 16.4488 21.4762C15.3416 21.6985 14.1981 21.6635 13.1066 21.374L10.1229 23.0971C9.97236 23.184 9.79941 23.2244 9.62594 23.213C9.45247 23.2017 9.28626 23.1391 9.14833 23.0333C9.01041 22.9274 8.90697 22.7831 8.8511 22.6185C8.79522 22.4538 8.78942 22.2764 8.83443 22.1084L9.59697 19.2638C8.33416 17.8989 7.63152 16.1085 7.62886 14.249C7.62886 10.1833 10.9354 6.87594 15 6.87594C19.0645 6.87594 22.3713 10.1833 22.3713 14.249ZM12.9506 14.249C12.9506 14.0159 12.858 13.7924 12.6932 13.6275C12.5284 13.4627 12.3048 13.3701 12.0717 13.3701H12.0703C11.8965 13.3704 11.7267 13.4223 11.5824 13.519C11.4381 13.6158 11.3257 13.7532 11.2594 13.9138C11.1932 14.0744 11.176 14.2511 11.2101 14.4215C11.2442 14.5919 11.328 14.7483 11.451 14.8711C11.574 14.9938 11.7306 15.0774 11.901 15.1112C12.0715 15.1449 12.2481 15.1274 12.4086 15.0609C12.5691 14.9943 12.7063 14.8816 12.8028 14.7371C12.8993 14.5926 12.9508 14.4228 12.9508 14.249H12.9506ZM15.879 14.249C15.879 14.2203 15.8774 14.1915 15.8743 14.1629C15.8716 14.1342 15.8673 14.1056 15.8615 14.0773C15.8563 14.0492 15.8492 14.0214 15.8404 13.9941C15.8322 13.9666 15.8223 13.9396 15.8117 13.9127C15.8012 13.8857 15.7883 13.8605 15.7748 13.8354C15.7614 13.81 15.7467 13.7854 15.7309 13.7615C15.7148 13.7374 15.6976 13.7142 15.6792 13.6918C15.6612 13.6694 15.6418 13.6481 15.6213 13.6279C15.6014 13.6074 15.5797 13.5881 15.5574 13.5693C15.5351 13.5518 15.5117 13.5342 15.4876 13.5184C15.4638 13.5025 15.4392 13.4878 15.4139 13.4744C15.3886 13.4609 15.3623 13.4486 15.3359 13.4375C15.3095 13.4265 15.2825 13.4169 15.2551 13.4088C15.2003 13.3912 15.1437 13.3798 15.0863 13.3748C15.0002 13.3665 14.9134 13.3707 14.8285 13.3871C14.8002 13.3929 14.7723 13.4001 14.7448 13.4088C14.7173 13.4168 14.6903 13.4264 14.6639 13.4375C14.6376 13.4486 14.6112 13.4609 14.586 13.4744C14.5608 13.4879 14.5362 13.5025 14.5121 13.5184C14.488 13.5342 14.4646 13.5518 14.443 13.5693C14.4202 13.5881 14.3991 13.6074 14.3786 13.6279C14.358 13.6481 14.3386 13.6694 14.3205 13.6918C14.3024 13.7142 14.2854 13.7374 14.2696 13.7615C14.2535 13.7854 14.2386 13.81 14.2251 13.8354C14.2115 13.8605 14.1994 13.8863 14.1887 13.9127C14.1775 13.9393 14.1678 13.9665 14.1594 13.9941C14.1512 14.0211 14.1442 14.0492 14.1383 14.0773C14.1325 14.1056 14.1282 14.1342 14.1254 14.1629C14.1225 14.1916 14.1213 14.2203 14.1213 14.249C14.1213 14.2777 14.1225 14.307 14.1254 14.3357C14.1283 14.3643 14.1326 14.3926 14.1383 14.4207C14.1442 14.4488 14.1512 14.477 14.1594 14.5045C14.1678 14.5319 14.1775 14.5589 14.1887 14.5854C14.1994 14.612 14.2115 14.638 14.2251 14.6633C14.2385 14.6885 14.2538 14.7131 14.2696 14.7371C14.2854 14.761 14.3024 14.7841 14.3205 14.8062C14.3388 14.8287 14.3581 14.8502 14.3786 14.8707C14.3991 14.8906 14.4202 14.9105 14.443 14.9287C14.4651 14.947 14.4881 14.964 14.5121 14.9797C14.5362 14.9955 14.5607 15.0107 14.586 15.0242C14.6369 15.0507 14.69 15.0727 14.7448 15.0898C14.7723 15.098 14.8004 15.1051 14.8285 15.1109C14.885 15.1225 14.9425 15.1282 15.0002 15.1279C15.233 15.1273 15.4562 15.0349 15.6213 14.8707C15.6618 14.8296 15.6985 14.7849 15.7309 14.7371C15.7467 14.7131 15.7613 14.6885 15.7748 14.6633C15.7883 14.6381 15.8006 14.6117 15.8117 14.5854C15.8228 14.559 15.8322 14.5314 15.8404 14.5045C15.8491 14.477 15.8562 14.449 15.8615 14.4207C15.8673 14.3926 15.8715 14.3643 15.8743 14.3357C15.8773 14.3069 15.8789 14.2779 15.8789 14.2489L15.879 14.249ZM18.8087 14.249C18.8087 14.0159 18.7161 13.7924 18.5513 13.6275C18.3865 13.4627 18.1629 13.3701 17.9298 13.3701H17.9281C17.7544 13.3705 17.5846 13.4223 17.4403 13.5191C17.296 13.6158 17.1836 13.7532 17.1173 13.9139C17.0511 14.0745 17.0339 14.2512 17.068 14.4215C17.1021 14.5919 17.186 14.7484 17.3089 14.8711C17.4319 14.9938 17.5885 15.0774 17.759 15.1112C17.9294 15.1449 18.1061 15.1274 18.2666 15.0609C18.4271 14.9943 18.5642 14.8816 18.6607 14.7371C18.7572 14.5926 18.8087 14.4228 18.8087 14.249Z",
            fill: "#18355D"
        })
    });
};
var IconEmergency = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.0007 15.9424L17.358 17.5857C16.7327 18.2104 15.8847 18.5617 15.0007 18.5617C14.1167 18.5617 13.2687 18.2104 12.6433 17.5857L11.0007 15.9424L2.13867 24.8044C2.40533 24.9317 2.69934 24.9997 3.00067 24.9997H27.0007C27.302 24.9997 27.596 24.9317 27.8627 24.8044L19.0007 15.9424Z",
                fill: "#18355D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M28.8054 6.1377C28.9327 6.40436 29.0007 6.69836 29.0007 6.9997V22.9997C29.0007 23.301 28.9327 23.595 28.8054 23.8617L19.9434 14.9997L28.8054 6.1377Z",
                fill: "#18355D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.19533 6.1377L10.0573 14.9997L1.19533 23.8617C1.068 23.595 1 23.301 1 22.9997C1 18.901 1 11.0984 1 6.9997C1 6.69836 1.068 6.40436 1.19533 6.1377Z",
                fill: "#18355D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M27.8627 5.19533C27.596 5.068 27.302 5 27.0007 5C21.4227 5 8.57868 5 3.00067 5C2.69934 5 2.40533 5.068 2.13867 5.19533L13.5867 16.6427C13.9613 17.018 14.47 17.2287 15.0007 17.2287C15.5313 17.2287 16.04 17.018 16.4147 16.6427L27.8627 5.19533Z",
                fill: "#18355D"
            })
        ]
    });
};
var IconClose = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_14517_6157)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M16 0C7.16667 0 0 7.16667 0 16C0 24.8333 7.16667 32 16 32C24.8333 32 32 24.8333 32 16C32 7.16667 24.8333 0 16 0ZM15.5 25.3333C15.1704 25.3333 14.8481 25.2356 14.574 25.0525C14.3 24.8693 14.0863 24.609 13.9602 24.3045C13.8341 23.9999 13.801 23.6648 13.8654 23.3415C13.9297 23.0182 14.0884 22.7212 14.3215 22.4882C14.5546 22.2551 14.8515 22.0963 15.1748 22.032C15.4982 21.9677 15.8333 22.0007 16.1378 22.1269C16.4423 22.253 16.7026 22.4666 16.8858 22.7407C17.0689 23.0148 17.1667 23.337 17.1667 23.6667C17.1667 24.1087 16.9911 24.5326 16.6785 24.8452C16.366 25.1577 15.942 25.3333 15.5 25.3333ZM18.2867 16.8333C16.9358 17.74 16.75 18.5708 16.75 19.3333C16.75 19.6428 16.6271 19.9395 16.4083 20.1583C16.1895 20.3771 15.8928 20.5 15.5833 20.5C15.2739 20.5 14.9772 20.3771 14.7584 20.1583C14.5396 19.9395 14.4167 19.6428 14.4167 19.3333C14.4167 17.5075 15.2567 16.0558 16.985 14.895C18.5917 13.8167 19.5 13.1333 19.5 11.6308C19.5 10.6092 18.9167 9.83333 17.7092 9.25917C17.425 9.12417 16.7925 8.9925 16.0142 9.00167C15.0375 9.01417 14.2792 9.2475 13.695 9.7175C12.5933 10.6042 12.5 11.5692 12.5 11.5833C12.4926 11.7365 12.4551 11.8868 12.3897 12.0255C12.3242 12.1642 12.2321 12.2887 12.1185 12.3918C12.005 12.4949 11.8722 12.5747 11.7278 12.6265C11.5835 12.6783 11.4303 12.7011 11.2771 12.6938C11.1239 12.6864 10.9736 12.6489 10.8349 12.5834C10.6962 12.518 10.5717 12.4258 10.4686 12.3123C10.3655 12.1987 10.2858 12.066 10.2339 11.9216C10.1821 11.7772 10.1593 11.624 10.1667 11.4708C10.1758 11.2683 10.3167 9.44417 12.2308 7.90417C13.2233 7.10583 14.4858 6.69083 15.9808 6.6725C17.0392 6.66 18.0333 6.83917 18.7075 7.1575C20.725 8.11167 21.8333 9.7025 21.8333 11.6308C21.8333 14.45 19.9492 15.7158 18.2867 16.8333Z",
                    fill: "#33475B"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_14517_6157",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "32",
                        height: "32",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var IconFAQ = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.8473 8.95508H21.113C21.1138 9.2807 21.1124 15.0992 21.113 15.6226C21.113 17.3026 19.5336 18.6632 17.5955 18.6632H11.698C11.2155 18.8799 10.1504 19.3327 9.66799 19.5426L9.66797 20.1857C9.66797 21.2751 10.7442 22.1632 12.0699 22.1632H17.4817L23.7423 24.8801C23.8237 24.9143 23.9135 24.9232 24 24.9055C24.0864 24.8879 24.1656 24.8446 24.227 24.7812C24.2885 24.7179 24.3294 24.6375 24.3444 24.5505C24.3594 24.4635 24.3478 24.3741 24.3111 24.2938L23.3048 22.1632C24.7734 22.2983 26.2231 21.5681 26.2492 20.1857C26.2487 18.959 26.2496 15.1655 26.2492 13.9995V10.9326C26.2492 9.82133 25.1948 8.95508 23.8473 8.95508Z",
                fill: "#18355D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5963 17.7884C19.0531 17.7884 20.2388 16.8171 20.2388 15.6227V5.24961C20.2388 4.05523 19.0531 3.08398 17.5963 3.08398H4.38813C2.90937 3.08398 1.75 4.03336 1.75 5.24961V15.6227C1.75 16.8171 2.93562 17.7884 4.38813 17.7884H5.08813L3.91563 20.2515C3.87991 20.3319 3.86899 20.4212 3.88426 20.5079C3.89952 20.5945 3.94028 20.6747 4.00133 20.7381C4.06238 20.8015 4.14095 20.8453 4.22699 20.8638C4.31303 20.8823 4.40264 20.8748 4.48438 20.8421L11.515 17.7884H17.5963ZM3.7975 13.0896V7.64711C3.7973 7.5896 3.80848 7.53262 3.8304 7.47945C3.85231 7.42628 3.88453 7.37797 3.9252 7.33731C3.96586 7.29664 4.01417 7.26442 4.06734 7.24251C4.12051 7.22059 4.17749 7.20941 4.235 7.20961H7.46375C7.57978 7.20961 7.69106 7.2557 7.77311 7.33775C7.85516 7.4198 7.90125 7.53108 7.90125 7.64711C7.90125 7.76314 7.85516 7.87442 7.77311 7.95647C7.69106 8.03852 7.57978 8.08461 7.46375 8.08461H4.6725V9.38836H6.825C6.94103 9.38836 7.05231 9.43445 7.13436 9.5165C7.21641 9.59855 7.2625 9.70983 7.2625 9.82586C7.2625 9.94189 7.21641 10.0532 7.13436 10.1352C7.05231 10.2173 6.94103 10.2634 6.825 10.2634H4.6725V13.0896C4.6708 13.2045 4.62395 13.3141 4.54209 13.3948C4.46023 13.4755 4.34992 13.5207 4.235 13.5207C4.12008 13.5207 4.00977 13.4755 3.92791 13.3948C3.84605 13.3141 3.7992 13.2045 3.7975 13.0896ZM17.92 13.1246C17.996 13.2104 18.0355 13.3225 18.0298 13.437C18.0241 13.5514 17.9739 13.6591 17.8897 13.737C17.8056 13.8148 17.6943 13.8566 17.5798 13.8533C17.4652 13.8501 17.3565 13.802 17.2769 13.7196L16.6206 13.0065C14.6144 14.2523 11.7716 12.671 11.8388 10.2895C11.8435 9.45101 12.1805 8.64855 12.7759 8.05809C13.3712 7.46762 14.1765 7.13732 15.015 7.13961C17.7691 7.10278 19.2364 10.5265 17.3118 12.4596L17.92 13.1246ZM11.1475 13.164L10.1238 10.8365L8.37375 10.8496L7.34563 13.1946C7.29748 13.2981 7.21076 13.3786 7.10401 13.419C6.99725 13.4594 6.87894 13.4564 6.77435 13.4107C6.66977 13.365 6.58723 13.2802 6.54438 13.1744C6.50152 13.0686 6.50176 12.9502 6.54503 12.8446C6.55311 12.8292 7.68734 10.2509 7.69128 10.2371L8.85503 7.59027C8.89078 7.51431 8.94741 7.4501 9.01829 7.40511C9.08917 7.36013 9.17139 7.33625 9.25534 7.33625C9.33929 7.33625 9.42151 7.36013 9.4924 7.40511C9.56328 7.4501 9.61991 7.51431 9.65566 7.59027L10.8107 10.2196L11.9657 12.8446C11.9877 12.8986 11.9988 12.9564 11.9983 13.0146C11.9978 13.0729 11.9857 13.1304 11.9627 13.184C11.9397 13.2375 11.9063 13.286 11.8645 13.3265C11.8226 13.367 11.7731 13.3987 11.7188 13.4199C11.6645 13.4411 11.6066 13.4513 11.5483 13.4498C11.4901 13.4484 11.4327 13.4354 11.3795 13.4116C11.3264 13.3878 11.2785 13.3536 11.2386 13.3111C11.1988 13.2686 11.1678 13.2186 11.1475 13.164Z",
                fill: "#18355D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.76367 9.97449L9.7393 9.96137L9.25367 8.85449L8.76367 9.97449Z",
                fill: "#18355D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.0152 8.01428C14.4118 8.01429 13.8332 8.25398 13.4065 8.68063C12.9799 9.10728 12.7402 9.68594 12.7402 10.2893C12.7402 10.8927 12.9799 11.4713 13.4066 11.898C13.8332 12.3246 14.4119 12.5643 15.0153 12.5643C15.3594 12.5658 15.6992 12.488 16.0083 12.3368L15.4308 11.7112C15.3921 11.6686 15.362 11.6189 15.3425 11.5648C15.3229 11.5107 15.3142 11.4532 15.3168 11.3957C15.3195 11.3383 15.3334 11.2818 15.3579 11.2298C15.3823 11.1777 15.4168 11.1309 15.4593 11.0921C15.5451 11.0138 15.6586 10.9728 15.7747 10.9781C15.8322 10.9807 15.8886 10.9947 15.9407 11.0191C15.9928 11.0436 16.0396 11.078 16.0783 11.1205L16.7171 11.8162C18.0638 10.4266 16.9707 7.96922 15.0152 8.01428Z",
                fill: "#18355D"
            })
        ]
    });
};
var LoadingIcon = function(param) {
    var loading = param.loading, loadingPercentage = param.loadingPercentage, stroke = param.stroke;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "loader-video absolute left-1/2 top-1/2 block -translate-x-1/2 -translate-y-1/2",
        xmlns: "http://www.w3.org/2000/svg",
        width: "85px",
        height: "85px",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "50",
                cy: "50",
                fill: "none",
                stroke: stroke,
                strokeWidth: "5",
                r: "47",
                strokeDasharray: "164.93361431346415 56.97787143782138",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    repeatCount: "indefinite",
                    dur: "0.5s",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1"
                })
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)("text", {
                x: "50%",
                y: "50%",
                textAnchor: "middle",
                fill: "#ffffff",
                fontSize: "14",
                dy: ".3em",
                children: [
                    loadingPercentage,
                    "%"
                ]
            })
        ]
    });
};
var IconAnnotationGuide = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8.99984 0.666992C4.39914 0.666992 0.666504 4.39963 0.666504 9.00033C0.666504 13.601 4.39914 17.3337 8.99984 17.3337C13.6005 17.3337 17.3332 13.601 17.3332 9.00033C17.3332 4.39963 13.6005 0.666992 8.99984 0.666992ZM9.45296 13.7746H8.14176C8.11226 13.7745 8.084 13.7627 8.06317 13.7418C8.04235 13.7209 8.03065 13.6926 8.03065 13.6631V12.3523C8.03065 12.3228 8.04235 12.2945 8.06317 12.2736C8.084 12.2527 8.11226 12.2409 8.14176 12.2408H9.45296C9.48247 12.2409 9.51073 12.2527 9.53156 12.2736C9.55238 12.2945 9.56407 12.3228 9.56407 12.3523V13.6631C9.56407 13.6926 9.55238 13.7209 9.53156 13.7418C9.51073 13.7627 9.48247 13.7745 9.45296 13.7746ZM10.1908 9.47776C9.48725 9.94998 9.39046 10.3827 9.39046 10.7798V11.2573C9.39046 11.2918 9.37674 11.3249 9.35232 11.3493C9.32791 11.3738 9.29479 11.3875 9.26025 11.3875H8.30539C8.27086 11.3875 8.23774 11.3738 8.21332 11.3493C8.1889 11.3249 8.17518 11.2918 8.17518 11.2573V10.7798C8.17518 9.82889 8.61269 9.07281 9.51286 8.46821C10.3497 7.90658 10.8228 7.55067 10.8228 6.76812C10.8228 6.236 10.5189 5.83192 9.89003 5.53288C9.74203 5.46257 9.4126 5.39399 9.00722 5.39876C8.49854 5.40527 8.10357 5.5268 7.79932 5.77159C7.22553 6.2334 7.17692 6.73644 7.17692 6.74338C7.15309 6.89092 7.1409 7.04011 7.14046 7.18956C7.14046 7.2241 7.12674 7.25721 7.10233 7.28163C7.07791 7.30605 7.04479 7.31977 7.01025 7.31977H6.08795C6.05562 7.31994 6.02439 7.30809 6.00032 7.28651C5.97626 7.26493 5.96108 7.23517 5.95774 7.20302C5.94211 7.02969 5.94342 6.85526 5.96164 6.68218C5.97119 6.57671 6.03977 5.62663 7.03673 4.82454C7.55366 4.40875 8.21121 4.1926 8.98985 4.18305C9.54107 4.17654 10.0589 4.26986 10.41 4.43566C11.4608 4.93522 12.038 5.76378 12.038 6.76812C12.038 8.23644 11.0567 8.89573 10.1908 9.47776Z",
            fill: "currentColor"
        })
    });
};
var IconSend = function(param) {
    var width = param.width, height = param.height, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: className,
        width: width !== null && width !== void 0 ? width : 16,
        height: height !== null && height !== void 0 ? height : 16,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#A1A1A1",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.5 2.62245V5.60051L9.03466 7.03059C9.03471 7.0306 9.03475 7.03061 9.0348 7.03061C10.1196 7.23634 10.1197 8.78985 9.0348 8.99557C9.03476 8.99558 9.03471 8.99559 9.03466 8.9956L1.5 10.4257V13.3752L14.499 8.01418L1.5 2.62245ZM1.54235 1.55741C0.993478 1.32506 0.5 1.79319 0.5 2.26841L0.5 5.80829C0.500177 5.98267 0.561114 6.15154 0.672329 6.28585C0.783544 6.42017 0.938087 6.51153 1.10938 6.54423L1.10989 6.54432L8.84833 8.01307L8.84843 8.01309L8.84832 8.01312L1.11031 9.48184C1.11027 9.48185 1.11024 9.48186 1.1102 9.48187C0.938628 9.51442 0.783789 9.60582 0.672391 9.74032C0.56097 9.87484 0.5 10.044 0.5 10.2187V13.7597C0.5 13.7615 0.50001 13.7633 0.50003 13.7652C0.501406 13.8899 0.534077 14.0122 0.595045 14.121C0.656014 14.2298 0.743327 14.3215 0.848973 14.3878C0.954616 14.4541 1.07521 14.4928 1.1997 14.5003C1.31908 14.5075 1.43837 14.4859 1.5475 14.4373L14.8875 8.93564C14.8899 8.93465 14.8923 8.93365 14.8947 8.93263C15.0741 8.85533 15.227 8.72716 15.3344 8.56393C15.4418 8.40071 15.4991 8.20959 15.4991 8.01419C15.4991 7.81879 15.4418 7.62767 15.3344 7.46445C15.227 7.30122 15.0741 7.17304 14.8947 7.09575C14.8926 7.09486 14.8905 7.09398 14.8884 7.09312L1.54235 1.55741Z"
        })
    });
};
var IconSendHover = function(param) {
    var width = param.width, height = param.height, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: className,
        width: width !== null && width !== void 0 ? width : 16,
        height: height !== null && height !== void 0 ? height : 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14.8934 6.09527L14.8884 6.09308L1.54219 0.557456C1.42993 0.510471 1.30778 0.492044 1.18666 0.503824C1.06554 0.515603 0.949225 0.557222 0.848125 0.624956C0.741311 0.694946 0.653573 0.790394 0.592805 0.902711C0.532037 1.01503 0.500145 1.14069 0.5 1.26839V4.80871C0.50006 4.98328 0.561019 5.15237 0.67237 5.28683C0.783722 5.42128 0.938491 5.51268 1.11 5.54527L8.38906 6.89121C8.41767 6.89663 8.44348 6.91187 8.46205 6.93429C8.48062 6.95671 8.49078 6.98491 8.49078 7.01402C8.49078 7.04313 8.48062 7.07133 8.46205 7.09375C8.44348 7.11617 8.41767 7.13141 8.38906 7.13683L1.11031 8.48277C0.938851 8.51527 0.784092 8.60655 0.67269 8.74088C0.561288 8.87522 0.500219 9.04419 0.5 9.21871V12.7596C0.499917 12.8816 0.530111 13.0016 0.587871 13.109C0.645632 13.2164 0.729152 13.3078 0.830938 13.375C0.953375 13.4563 1.09706 13.4998 1.24406 13.5C1.34626 13.4999 1.4474 13.4794 1.54156 13.4396L14.8875 7.93558L14.8934 7.93277C15.0731 7.85557 15.2262 7.72739 15.3337 7.56409C15.4413 7.4008 15.4986 7.20955 15.4986 7.01402C15.4986 6.81849 15.4413 6.62724 15.3337 6.46395C15.2262 6.30065 15.0731 6.17247 14.8934 6.09527Z",
            fill: "#FFB800"
        })
    });
};
var IconDownArrow = function() {
    return /*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "7",
        viewBox: "0 0 10 7",
        fill: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M0.667317 1.66657L5.00065 5.3999L9.33398 1.66657",
            stroke: "#404041",
            strokeLinecap: "square"
        })
    });
};
var IconCalendar = function() {
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M17.54 3.43011V1.94011C17.5196 1.77015 17.4376 1.61356 17.3095 1.49996C17.1814 1.38636 17.0162 1.32363 16.845 1.32363C16.6738 1.32363 16.5086 1.38636 16.3805 1.49996C16.2524 1.61356 16.1704 1.77015 16.15 1.94011V3.21011H15.83H12.89V1.94011C12.89 1.75446 12.8162 1.57641 12.685 1.44514C12.5537 1.31386 12.3757 1.24011 12.19 1.24011C12.0043 1.24011 11.8263 1.31386 11.695 1.44514C11.5638 1.57641 11.49 1.75446 11.49 1.94011V3.19011H8.17H7.85V1.94011C7.82958 1.77015 7.74758 1.61356 7.61951 1.49996C7.49144 1.38636 7.32619 1.32363 7.155 1.32363C6.98381 1.32363 6.81856 1.38636 6.69049 1.49996C6.56242 1.61356 6.48042 1.77015 6.46 1.94011V3.43011C5.17564 3.80058 4.04634 4.57813 3.242 5.64577C2.43766 6.71341 2.0018 8.0134 2 9.35011V16.5901C2.0053 18.2274 2.66011 19.7957 3.82068 20.9506C4.98124 22.1056 6.55269 22.7528 8.19 22.7501H15.85C17.4804 22.7422 19.0416 22.0904 20.1935 20.9366C21.3454 19.7828 21.9947 18.2205 22 16.5901V9.35011C21.9982 8.0134 21.5623 6.71341 20.758 5.64577C19.9537 4.57813 18.8244 3.80058 17.54 3.43011ZM6.46 4.90011V5.71011C6.48042 5.88008 6.56242 6.03667 6.69049 6.15027C6.81856 6.26386 6.98381 6.3266 7.155 6.3266C7.32619 6.3266 7.49144 6.26386 7.61951 6.15027C7.74758 6.03667 7.82958 5.88008 7.85 5.71011V4.61011C7.96 4.61011 8.06 4.61011 8.17 4.61011H11.49V5.71011C11.49 5.89576 11.5638 6.07381 11.695 6.20509C11.8263 6.33636 12.0043 6.41011 12.19 6.41011C12.3757 6.41011 12.5537 6.33636 12.685 6.20509C12.8162 6.07381 12.89 5.89576 12.89 5.71011V4.58011H15.83C15.94 4.58011 16.04 4.58011 16.15 4.58011V5.68011C16.1704 5.85008 16.2524 6.00667 16.3805 6.12027C16.5086 6.23386 16.6738 6.2966 16.845 6.2966C17.0162 6.2966 17.1814 6.23386 17.3095 6.12027C17.4376 6.00667 17.5196 5.85008 17.54 5.68011V4.90011C18.3259 5.2058 19.0171 5.71353 19.5439 6.37199C20.0707 7.03045 20.4143 7.8163 20.54 8.65011H3.44C3.56754 7.81409 3.91414 7.02674 4.44458 6.36808C4.97502 5.70942 5.67039 5.20294 6.46 4.90011ZM15.83 21.3601H8.17C6.90134 21.3628 5.68344 20.862 4.78355 19.9678C3.88366 19.0735 3.37529 17.8588 3.37 16.5901V10.0001H20.63V16.5501C20.6326 17.1817 20.5104 17.8075 20.2702 18.3916C20.03 18.9757 19.6767 19.5066 19.2306 19.9536C18.7845 20.4007 18.2544 20.7551 17.6708 20.9965C17.0871 21.2379 16.4616 21.3614 15.83 21.3601ZM9.59 13.8401C9.59598 14.0133 9.55008 14.1844 9.45819 14.3314C9.36629 14.4783 9.2326 14.5945 9.07425 14.665C8.91589 14.7354 8.7401 14.757 8.56941 14.7269C8.39872 14.6968 8.24091 14.6164 8.11622 14.496C7.99153 14.3756 7.90564 14.2207 7.86957 14.0512C7.8335 13.8816 7.84888 13.7052 7.91376 13.5445C7.97863 13.3838 8.09003 13.2461 8.23368 13.1491C8.37733 13.0521 8.54667 13.0002 8.72 13.0001C8.94563 13 9.16249 13.0875 9.32481 13.2442C9.48714 13.401 9.58222 13.6146 9.59 13.8401ZM12.85 13.8401C12.8579 14.0169 12.8124 14.192 12.7193 14.3425C12.6262 14.493 12.4899 14.612 12.3282 14.6838C12.1665 14.7557 11.9868 14.7771 11.8128 14.7453C11.6387 14.7135 11.4782 14.63 11.3523 14.5056C11.2264 14.3812 11.141 14.2217 11.1071 14.048C11.0733 13.8743 11.0926 13.6944 11.1625 13.5319C11.2325 13.3693 11.3498 13.2316 11.4992 13.1367C11.6486 13.0419 11.8231 12.9943 12 13.0001C12.2222 13.0051 12.434 13.0949 12.592 13.2511C12.7501 13.4073 12.8424 13.618 12.85 13.8401ZM16.13 13.8401C16.134 14.0154 16.0855 14.1878 15.9908 14.3354C15.8961 14.4829 15.7595 14.5988 15.5985 14.6682C15.4375 14.7376 15.2595 14.7573 15.0872 14.7248C14.9149 14.6923 14.7563 14.6091 14.6316 14.4859C14.5069 14.3627 14.4219 14.205 14.3874 14.0331C14.3529 13.8612 14.3706 13.6829 14.4381 13.5211C14.5056 13.3593 14.6199 13.2214 14.7664 13.125C14.9128 13.0286 15.0847 12.9782 15.26 12.9801C15.489 12.9801 15.7088 13.0704 15.8717 13.2314C16.0345 13.3924 16.1274 13.6111 16.13 13.8401ZM9.58 17.0701C9.57869 17.1831 9.55515 17.2946 9.51073 17.3985C9.4663 17.5023 9.40185 17.5964 9.32106 17.6753C9.24027 17.7542 9.14472 17.8165 9.03988 17.8585C8.93503 17.9005 8.82294 17.9214 8.71 17.9201C8.53992 17.9181 8.37426 17.8657 8.23395 17.7696C8.09364 17.6735 7.98499 17.5379 7.92174 17.38C7.85848 17.2221 7.84347 17.049 7.87859 16.8826C7.91372 16.7162 7.9974 16.5639 8.11906 16.445C8.24072 16.3262 8.39489 16.246 8.56208 16.2148C8.72928 16.1836 8.90198 16.2026 9.05835 16.2695C9.21473 16.3364 9.34775 16.4482 9.4406 16.5907C9.53346 16.7332 9.58197 16.9 9.58 17.0701ZM12.84 17.0701C12.844 17.245 12.7958 17.417 12.7015 17.5643C12.6073 17.7117 12.4713 17.8276 12.3109 17.8972C12.1504 17.9669 11.9729 17.9872 11.8009 17.9556C11.6289 17.9239 11.4702 17.8417 11.3452 17.7195C11.2201 17.5972 11.1343 17.4405 11.0987 17.2693C11.0631 17.0981 11.0793 16.9201 11.1452 16.7581C11.2112 16.5962 11.324 16.4575 11.4691 16.3599C11.6142 16.2623 11.7851 16.2102 11.96 16.2101C12.0746 16.2074 12.1886 16.2277 12.2953 16.2697C12.4019 16.3118 12.4991 16.3747 12.5811 16.4548C12.6631 16.5349 12.7282 16.6307 12.7727 16.7363C12.8171 16.842 12.84 16.9555 12.84 17.0701ZM16.12 17.0701C16.124 17.245 16.0758 17.417 15.9815 17.5643C15.8873 17.7117 15.7513 17.8276 15.5909 17.8972C15.4304 17.9669 15.2529 17.9872 15.0809 17.9556C14.9089 17.9239 14.7502 17.8417 14.6252 17.7195C14.5001 17.5972 14.4143 17.4405 14.3787 17.2693C14.3431 17.0981 14.3593 16.9201 14.4252 16.7581C14.4912 16.5962 14.604 16.4575 14.7491 16.3599C14.8942 16.2623 15.0651 16.2102 15.24 16.2101C15.3546 16.2074 15.4686 16.2277 15.5753 16.2697C15.6819 16.3118 15.7791 16.3747 15.8611 16.4548C15.9431 16.5349 16.0082 16.6307 16.0527 16.7363C16.0971 16.842 16.12 16.9555 16.12 17.0701Z",
            fill: "#9CA3AF"
        })
    });
};
var IconMinusSquared = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M15.92 2.65012C16.6331 2.65012 17.3392 2.79057 17.998 3.06346C18.6568 3.33634 19.2554 3.73631 19.7596 4.24053C20.2638 4.74475 20.6638 5.34335 20.9367 6.00215C21.2095 6.66095 21.35 7.36704 21.35 8.08012V15.9201C21.35 16.6332 21.2095 17.3393 20.9367 17.9981C20.6638 18.6569 20.2638 19.2555 19.7596 19.7597C19.2554 20.2639 18.6568 20.6639 17.998 20.9368C17.3392 21.2097 16.6331 21.3501 15.92 21.3501H8.08C6.63987 21.3501 5.25873 20.778 4.24041 19.7597C3.22209 18.7414 2.65 17.3602 2.65 15.9201V8.08012C2.65 6.64 3.22209 5.25885 4.24041 4.24053C5.25873 3.22221 6.63987 2.65012 8.08 2.65012H15.92ZM7.33 12.9301H16.67C16.9167 12.9301 17.1532 12.8321 17.3276 12.6577C17.502 12.4833 17.6 12.2468 17.6 12.0001C17.6 11.7535 17.502 11.5169 17.3276 11.3425C17.1532 11.1681 16.9167 11.0701 16.67 11.0701H7.33C7.08335 11.0701 6.8468 11.1681 6.67239 11.3425C6.49798 11.5169 6.4 11.7535 6.4 12.0001C6.4 12.2468 6.49798 12.4833 6.67239 12.6577C6.8468 12.8321 7.08335 12.9301 7.33 12.9301ZM15.92 1.25012H8.08C6.26857 1.25012 4.53133 1.96971 3.25046 3.25058C1.96959 4.53146 1.25 6.26869 1.25 8.08012V15.9201C1.25 17.7316 1.96959 19.4688 3.25046 20.7497C4.53133 22.0305 6.26857 22.7501 8.08 22.7501H15.92C17.7314 22.7501 19.4687 22.0305 20.7495 20.7497C22.0304 19.4688 22.75 17.7316 22.75 15.9201V8.08012C22.75 6.26869 22.0304 4.53146 20.7495 3.25058C19.4687 1.96971 17.7314 1.25012 15.92 1.25012Z",
            fill: "#9CA3AF"
        })
    });
};
var IconPlusSquared = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M15.92 2.65012C16.6331 2.65012 17.3392 2.79057 17.998 3.06346C18.6568 3.33634 19.2554 3.73631 19.7596 4.24053C20.2638 4.74475 20.6638 5.34335 20.9367 6.00215C21.2095 6.66095 21.35 7.36704 21.35 8.08012V15.9201C21.35 16.6332 21.2095 17.3393 20.9367 17.9981C20.6638 18.6569 20.2638 19.2555 19.7596 19.7597C19.2554 20.2639 18.6568 20.6639 17.998 20.9368C17.3392 21.2097 16.6331 21.3501 15.92 21.3501H8.08C6.63987 21.3501 5.25873 20.778 4.24041 19.7597C3.22209 18.7414 2.65 17.3602 2.65 15.9201V8.08012C2.65 6.64 3.22209 5.25885 4.24041 4.24053C5.25873 3.22221 6.63987 2.65012 8.08 2.65012H15.92ZM7.33 12.9301H11.07V16.6701C11.07 16.9168 11.168 17.1533 11.3424 17.3277C11.5168 17.5021 11.7533 17.6001 12 17.6001C12.2467 17.6001 12.4832 17.5021 12.6576 17.3277C12.832 17.1533 12.93 16.9168 12.93 16.6701V12.9301H16.67C16.9167 12.9301 17.1532 12.8321 17.3276 12.6577C17.502 12.4833 17.6 12.2468 17.6 12.0001C17.6 11.7535 17.502 11.5169 17.3276 11.3425C17.1532 11.1681 16.9167 11.0701 16.67 11.0701H12.93V7.33012C12.93 7.08347 12.832 6.84692 12.6576 6.67251C12.4832 6.4981 12.2467 6.40012 12 6.40012C11.7533 6.40012 11.5168 6.4981 11.3424 6.67251C11.168 6.84692 11.07 7.08347 11.07 7.33012V11.0701H7.33C7.08335 11.0701 6.8468 11.1681 6.67239 11.3425C6.49798 11.5169 6.4 11.7535 6.4 12.0001C6.4 12.2468 6.49798 12.4833 6.67239 12.6577C6.8468 12.8321 7.08335 12.9301 7.33 12.9301ZM15.92 1.25012H8.08C6.26857 1.25012 4.53133 1.96971 3.25046 3.25058C1.96959 4.53146 1.25 6.26869 1.25 8.08012V15.9201C1.25 17.7316 1.96959 19.4688 3.25046 20.7497C4.53133 22.0305 6.26857 22.7501 8.08 22.7501H15.92C17.7314 22.7501 19.4687 22.0305 20.7495 20.7497C22.0304 19.4688 22.75 17.7316 22.75 15.9201V8.08012C22.75 6.26869 22.0304 4.53146 20.7495 3.25058C19.4687 1.96971 17.7314 1.25012 15.92 1.25012Z",
            fill: "#FFB800"
        })
    });
};
var CursorIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.6302 20.7021L20.2615 23.0709C19.9633 23.369 19.48 23.369 19.1818 23.0709L15.1873 19.0763L13.1105 21.1339C12.5199 21.7245 11.5102 21.515 11.2244 20.7338L6.80433 8.73106C6.46141 7.81661 7.35691 6.94017 8.27137 7.26402L20.0646 11.5317C20.8456 11.8175 21.0744 12.8273 20.4838 13.4179L18.4452 15.4374L22.6302 19.6224C22.9284 19.9206 22.9284 20.4039 22.6302 20.7021Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.59248 6.13528C6.39771 6.13528 6.20555 6.04526 6.08236 5.87566L4.15742 3.22626C3.95296 2.94483 4.0154 2.55101 4.29683 2.34655C4.5779 2.14172 4.97228 2.20453 5.17655 2.48596L7.10148 5.13535C7.30594 5.41679 7.24351 5.81061 6.96207 6.01507C6.85043 6.09633 6.72071 6.13528 6.59248 6.13528Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.89033 8.47796C4.82584 8.47796 4.76024 8.46808 4.69556 8.44702L1.58096 7.43497C1.25014 7.32743 1.06898 6.97219 1.17652 6.64137C1.28406 6.31054 1.63967 6.12975 1.97012 6.23692L5.08472 7.24897C5.41555 7.35651 5.59671 7.71175 5.48917 8.04257C5.40269 8.30872 5.15573 8.47796 4.89033 8.47796Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.77536 12.386C1.50995 12.386 1.263 12.2167 1.17652 11.9506C1.06898 11.6197 1.25014 11.2645 1.58096 11.157L4.69556 10.1449C5.02601 10.037 5.38163 10.2185 5.48917 10.5494C5.59671 10.8802 5.41555 11.2354 5.08472 11.343L1.97012 12.355C1.90545 12.3761 1.83984 12.386 1.77536 12.386Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.34658 5.2405C8.99879 5.2405 8.7168 4.95851 8.7168 4.61072V1.33583C8.7168 0.988048 8.99879 0.706055 9.34658 0.706055C9.69436 0.706055 9.97635 0.988048 9.97635 1.33583V4.61072C9.97635 4.95851 9.69436 5.2405 9.34658 5.2405Z",
                fill: "white"
            })
        ]
    });
};
var Plus = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 12.6668C7.82319 12.6668 7.65362 12.5966 7.5286 12.4716C7.40357 12.3465 7.33333 12.177 7.33333 12.0002V4.00016C7.33333 3.82335 7.40357 3.65378 7.5286 3.52876C7.65362 3.40373 7.82319 3.3335 8 3.3335C8.17681 3.3335 8.34638 3.40373 8.47141 3.52876C8.59643 3.65378 8.66667 3.82335 8.66667 4.00016V12.0002C8.66667 12.177 8.59643 12.3465 8.47141 12.4716C8.34638 12.5966 8.17681 12.6668 8 12.6668Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4 8.66683C3.82319 8.66683 3.65362 8.59659 3.5286 8.47157C3.40357 8.34654 3.33333 8.17697 3.33333 8.00016C3.33333 7.82335 3.40357 7.65378 3.5286 7.52876C3.65362 7.40373 3.82319 7.3335 4 7.3335H12C12.1768 7.3335 12.3464 7.40373 12.4714 7.52876C12.5964 7.65378 12.6667 7.82335 12.6667 8.00016C12.6667 8.17697 12.5964 8.34654 12.4714 8.47157C12.3464 8.59659 12.1768 8.66683 12 8.66683H4Z",
                fill: "white"
            })
        ]
    });
};
var PepIconsPencil = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11.3 18.2998C11.3 17.902 11.458 17.5204 11.7393 17.2391C12.0206 16.9578 12.4022 16.7998 12.8 16.7998C13.1978 16.7998 13.5794 16.9578 13.8607 17.2391C14.142 17.5204 14.3 17.902 14.3 18.2998C14.3 18.6976 14.142 19.0792 13.8607 19.3605C13.5794 19.6418 13.1978 19.7998 12.8 19.7998C12.4022 19.7998 12.0206 19.6418 11.7393 19.3605C11.458 19.0792 11.3 18.6976 11.3 18.2998ZM11.3 12.2998C11.3 11.902 11.458 11.5204 11.7393 11.2391C12.0206 10.9578 12.4022 10.7998 12.8 10.7998C13.1978 10.7998 13.5794 10.9578 13.8607 11.2391C14.142 11.5204 14.3 11.902 14.3 12.2998C14.3 12.6976 14.142 13.0792 13.8607 13.3605C13.5794 13.6418 13.1978 13.7998 12.8 13.7998C12.4022 13.7998 12.0206 13.6418 11.7393 13.3605C11.458 13.0792 11.3 12.6976 11.3 12.2998ZM11.3 6.2998C11.3 5.90198 11.458 5.52045 11.7393 5.23914C12.0206 4.95784 12.4022 4.7998 12.8 4.7998C13.1978 4.7998 13.5794 4.95784 13.8607 5.23914C14.142 5.52045 14.3 5.90198 14.3 6.2998C14.3 6.69763 14.142 7.07916 13.8607 7.36046C13.5794 7.64177 13.1978 7.7998 12.8 7.7998C12.4022 7.7998 12.0206 7.64177 11.7393 7.36046C11.458 7.07916 11.3 6.69763 11.3 6.2998Z",
            fill: "#99A1B7"
        })
    });
};
var LockSectionIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "64",
        height: "64",
        viewBox: "0 0 64 64",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M23.3333 18.0002C23.3333 13.2137 27.2135 9.3335 32 9.3335C36.7864 9.3335 40.6666 13.2137 40.6666 18.0002V21.3335H23.3333V18.0002ZM19.3333 21.5207V18.0002C19.3333 11.0046 25.0044 5.3335 32 5.3335C38.9956 5.3335 44.6666 11.0046 44.6666 18.0002V21.5207C49.6017 22.4568 53.3333 26.7927 53.3333 32.0002V48.0002C53.3333 53.8912 48.5577 58.6668 42.6666 58.6668H21.3333C15.4423 58.6668 10.6666 53.8912 10.6666 48.0002V32.0002C10.6666 26.7927 14.3982 22.4568 19.3333 21.5207ZM37.3333 40.0002C37.3333 42.9457 34.9455 45.3335 32 45.3335C29.0544 45.3335 26.6666 42.9457 26.6666 40.0002C26.6666 37.0546 29.0544 34.6668 32 34.6668C34.9455 34.6668 37.3333 37.0546 37.3333 40.0002Z",
            fill: "#FFB800"
        })
    });
};
var UnlockIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "64",
        height: "64",
        viewBox: "0 0 64 64",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24.4917 13.6683C25.9932 11.0726 28.7948 9.3335 32.0002 9.3335C36.7866 9.3335 40.6668 13.2137 40.6668 18.0002V21.3335H21.3334C15.4424 21.3335 10.6667 26.1091 10.6667 32.0002V48.0002C10.6667 53.8912 15.4424 58.6668 21.3334 58.6668H42.6668C48.5578 58.6668 53.3334 53.8912 53.3334 48.0002V32.0002C53.3334 26.7927 49.6018 22.4569 44.6668 21.5207V18.0002C44.6668 11.0046 38.9958 5.3335 32.0002 5.3335C27.3092 5.3335 23.2164 7.88452 21.0293 11.6654C20.4762 12.6215 20.8029 13.845 21.7591 14.398C22.7152 14.9511 23.9386 14.6244 24.4917 13.6683ZM32.0001 35.3335C33.1047 35.3335 34.0001 36.2289 34.0001 37.3335V42.6668C34.0001 43.7714 33.1047 44.6668 32.0001 44.6668C30.8955 44.6668 30.0001 43.7714 30.0001 42.6668V37.3335C30.0001 36.2289 30.8955 35.3335 32.0001 35.3335Z",
            fill: "#FFB800"
        })
    });
};
var ThankYouIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "64",
        height: "64",
        viewBox: "0 0 64 64",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M29.3334 43.7335L16.8 31.2002L20.5334 27.4668L29.3334 36.2668L51.7334 13.8668C46.6667 8.80016 39.7334 5.3335 32 5.3335C17.3334 5.3335 5.33337 17.3335 5.33337 32.0002C5.33337 46.6668 17.3334 58.6668 32 58.6668C46.6667 58.6668 58.6667 46.6668 58.6667 32.0002C58.6667 26.9335 57.3334 22.4002 54.9334 18.4002L29.3334 43.7335Z",
            fill: "#FFB800"
        })
    });
};
var IconBuildingModify = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "64",
        height: "64",
        viewBox: "0 0 64 64",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.894 14.828H35.624C37.312 14.828 38.468 13.124 37.842 11.556L36.224 7.50395C35.862 6.59595 34.984 6.00195 34.006 6.00195H22.51C21.534 6.00195 20.654 6.59795 20.292 7.50395L18.676 11.556C18.05 13.124 19.206 14.828 20.894 14.828Z",
                fill: "#FFB800"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M56.3 37.5401C54.72 35.9801 52.18 35.9801 50.6 37.5401L48.896 39.2561L54.6 44.9401L56.3 43.2401C57.88 41.6601 57.88 39.1201 56.3 37.5401Z",
                fill: "#FFB800"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M46.78 41.3799L37.02 51.1399C36.8 51.3399 36.66 51.6199 36.62 51.9199L35.86 56.3199C35.7 57.2999 36.54 58.1399 37.52 57.9799L41.94 57.2399C42.22 57.1799 42.5 57.0399 42.7 56.8399L52.48 47.0599L46.78 41.3799Z",
                fill: "#FFB800"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M43.4 10.4199H40.618L40.628 10.4459C41.292 12.1039 41.088 13.9819 40.086 15.4619C39.084 16.9439 37.416 17.8299 35.626 17.8299H20.894C19.104 17.8299 17.436 16.9459 16.434 15.4619C15.43 13.9799 15.228 12.1039 15.89 10.4439L15.9 10.4199H13.12C9.46002 10.4199 6.52002 13.3799 6.52002 17.0199V51.3999C6.52002 55.0399 9.46002 57.9999 13.12 57.9999H33.102C32.864 57.3119 32.778 56.5739 32.898 55.8359L33.662 51.4099C33.778 50.5159 34.26 49.5899 35.002 48.9179L45.576 38.3399L48.466 35.4259C48.928 34.9699 49.45 34.6139 49.996 34.3059V17.0199C50 13.3799 47.04 10.4199 43.4 10.4199ZM18.842 43.6819H17.02C16.026 43.6819 15.22 42.8759 15.22 41.8819C15.22 40.8879 16.026 40.0819 17.02 40.0819H18.844C19.838 40.0819 20.644 40.8879 20.644 41.8819C20.644 42.8759 19.836 43.6819 18.842 43.6819ZM18.842 32.7599H17.02C16.026 32.7599 15.22 31.9539 15.22 30.9599C15.22 29.9659 16.026 29.1599 17.02 29.1599H18.844C19.838 29.1599 20.644 29.9659 20.644 30.9599C20.644 31.9539 19.836 32.7599 18.842 32.7599ZM34.962 43.6799H26.062C25.068 43.6799 24.262 42.8739 24.262 41.8799C24.262 40.8859 25.068 40.0799 26.062 40.0799H34.962C35.956 40.0799 36.762 40.8859 36.762 41.8799C36.762 42.8739 35.958 43.6799 34.962 43.6799ZM39.5 32.7599H26.058C25.064 32.7599 24.258 31.9539 24.258 30.9599C24.258 29.9659 25.064 29.1599 26.058 29.1599H39.5C40.494 29.1599 41.3 29.9659 41.3 30.9599C41.3 31.9539 40.494 32.7599 39.5 32.7599Z",
                fill: "#FFB800"
            })
        ]
    });
};
var HomeMenuIcon = function(param) {
    var selected = param.selected;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 18.1706V10.354C21 9.14308 20.4604 7.9962 19.5301 7.23023L14.5301 3.11305C13.0577 1.90059 10.9423 1.90059 9.46986 3.11305L4.46986 7.23023C3.53964 7.9962 3 9.14308 3 10.354V18.1706C3 20.398 4.79086 22.2037 7 22.2037H17C19.2091 22.2037 21 20.398 21 18.1706Z",
                stroke: selected ? "#FFB800" : "#9CA3AF",
                "stroke-width": "1.5",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 18.2037H14",
                stroke: selected ? "#FFB800" : "#9CA3AF",
                "stroke-width": "1.5",
                "stroke-linecap": "round"
            })
        ]
    });
};
var BookMenuIcon = function(param) {
    var selected = param.selected;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M11.25 4.58179C9.13095 3.12598 6.18953 2.46303 3.99433 2.21498C2.89642 2.09091 2 3.00773 2 4.13888V15.4037C2 16.5348 2.89642 17.452 3.99433 17.576C6.18953 17.8241 9.13095 18.487 11.25 19.9428V4.58179ZM12.75 19.9428C14.8691 18.487 17.8105 17.8241 20.0057 17.576C21.1036 17.452 22 16.5348 22 15.4037V4.13888C22 3.00773 21.1036 2.09091 20.0057 2.21498C17.8105 2.46303 14.8691 3.12598 12.75 4.58179V19.9428ZM4.25882 7.34367C4.32221 6.93433 4.70543 6.65389 5.11477 6.71729C6.41754 6.91904 7.88469 7.25628 9.27049 7.79217C9.65682 7.94156 9.8489 8.37586 9.6995 8.76219C9.55011 9.14852 9.11581 9.3406 8.72948 9.1912C7.47083 8.70448 6.11398 8.38991 4.8852 8.19961C4.47587 8.13622 4.19543 7.753 4.25882 7.34367ZM5.11477 10.7173C4.70543 10.6539 4.32221 10.9343 4.25882 11.3437C4.19543 11.753 4.47587 12.1362 4.8852 12.1996C5.50445 12.2955 6.15812 12.4233 6.81651 12.5894C7.21814 12.6907 7.62587 12.4473 7.7272 12.0456C7.82853 11.644 7.58509 11.2363 7.18346 11.135C6.47445 10.9561 5.7745 10.8195 5.11477 10.7173Z",
            fill: selected ? "#FFB800" : "#9CA3AF"
        })
    });
};
var FileMenuIcon = function(param) {
    var selected = param.selected;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M6.89998 3.2037C6.07155 3.2037 5.39998 3.87527 5.39998 4.7037V19.7037C5.39998 20.5321 6.07155 21.2037 6.89998 21.2037H17.1C17.9284 21.2037 18.6 20.5321 18.6 19.7037V9.2037H13.5C13.0029 9.2037 12.6 8.80076 12.6 8.3037V3.2037H6.89998ZM14.4 4.47649L17.3272 7.4037H14.4V4.47649ZM3.59998 4.7037C3.59998 2.88116 5.07744 1.4037 6.89998 1.4037H13.5C13.7387 1.4037 13.9676 1.49852 14.1364 1.66731L20.1364 7.6673C20.3052 7.83609 20.4 8.06501 20.4 8.3037V19.7037C20.4 21.5262 18.9225 23.0037 17.1 23.0037H6.89998C5.07744 23.0037 3.59998 21.5262 3.59998 19.7037V4.7037Z",
            fill: selected ? "#FFB800" : "#9CA3AF"
        })
    });
};
var BellIcon = function(param) {
    var selected = param.selected;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M5.4724 6.41462C5.76764 3.44709 8.3083 1.40372 11.2398 1.40372H12.7603C15.6917 1.40372 18.2324 3.44709 18.5276 6.41462L18.5281 6.41935L19.0361 11.8146C19.0361 11.8154 19.0362 11.8162 19.0363 11.817C19.2031 13.4886 19.9248 15.1762 21.0645 16.3868C21.6872 17.0484 21.6926 17.9649 21.451 18.6211C21.2087 19.2793 20.587 20.0037 19.6091 20.0037H15.5502C15.2646 21.7063 13.7838 23.0037 12 23.0037C10.2162 23.0037 8.73544 21.7063 8.44979 20.0037H4.39088C3.41301 20.0037 2.79133 19.2793 2.54899 18.6211C2.30737 17.9649 2.31278 17.0484 2.93555 16.3868C4.07523 15.1761 4.79691 13.4885 4.96373 11.8169L5.4724 6.41462ZM19.6091 18.2037C19.6137 18.2037 19.6149 18.2032 19.6163 18.2027C19.6189 18.2017 19.6287 18.1974 19.6442 18.1843C19.6784 18.1554 19.7268 18.0945 19.7619 17.9992C19.7967 17.9046 19.806 17.8092 19.7965 17.7347C19.7874 17.6635 19.7649 17.6324 19.7538 17.6206C18.3186 16.096 17.4472 14.0261 17.2449 11.9928L17.2444 11.9881L16.7365 6.59282C16.7364 6.59204 16.7363 6.59126 16.7362 6.59047C16.5411 4.64164 14.8665 3.20372 12.7603 3.20372H11.2398C9.13344 3.20372 7.45886 4.64169 7.26378 6.59057C7.26371 6.59132 7.26364 6.59207 7.26356 6.59282L6.75513 11.9928C6.55283 14.0261 5.68137 16.096 4.24621 17.6206C4.23511 17.6324 4.21266 17.6635 4.20354 17.7347C4.19399 17.8092 4.20331 17.9046 4.23813 17.9992C4.27324 18.0945 4.3216 18.1554 4.35579 18.1843C4.37134 18.1974 4.38101 18.2016 4.38355 18.2026C4.38505 18.2032 4.38621 18.2037 4.39088 18.2037H19.6091ZM10.3024 20.0037C10.5495 20.7028 11.2163 21.2037 12 21.2037C12.7837 21.2037 13.4505 20.7028 13.6976 20.0037H10.3024Z",
            fill: selected ? "#FFB800" : "#9CA3AF"
        })
    });
};
var CalenderMenuIcon = function(param) {
    var selected = param.selected;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M8.09995 1.4037C8.59701 1.4037 8.99995 1.80665 8.99995 2.3037V3.8037H15V2.3037C15 1.80665 15.4029 1.4037 15.9 1.4037C16.397 1.4037 16.8 1.80665 16.8 2.3037V3.8037H19.5C21.3225 3.8037 22.7999 5.28116 22.7999 7.1037V19.7037C22.7999 21.5262 21.3225 23.0037 19.5 23.0037H4.49995C2.67741 23.0037 1.19995 21.5262 1.19995 19.7037V7.1037C1.19995 5.28116 2.67741 3.8037 4.49995 3.8037H7.19995V2.3037C7.19995 1.80665 7.60289 1.4037 8.09995 1.4037ZM7.19995 5.6037H4.49995C3.67152 5.6037 2.99995 6.27527 2.99995 7.1037V9.8037H21V7.1037C21 6.27527 20.3284 5.6037 19.5 5.6037H16.8V6.5037C16.8 7.00076 16.397 7.4037 15.9 7.4037C15.4029 7.4037 15 7.00076 15 6.5037V5.6037H8.99995V6.5037C8.99995 7.00076 8.59701 7.4037 8.09995 7.4037C7.60289 7.4037 7.19995 7.00076 7.19995 6.5037V5.6037ZM21 11.6037H2.99995V19.7037C2.99995 20.5321 3.67152 21.2037 4.49995 21.2037H19.5C20.3284 21.2037 21 20.5321 21 19.7037V11.6037Z",
            fill: selected ? "#FFB800" : "#9CA3AF"
        })
    });
};
var MyCalendarMenuIcon = function(param) {
    var selected = param.selected;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.5 6.20355C22.5 5.4079 22.1839 4.64483 21.6213 4.08222C21.0587 3.51962 20.2956 3.20354 19.5 3.20354H18.75V2.47464C18.75 2.07104 18.4397 1.72464 18.0361 1.70448C17.9347 1.6996 17.8333 1.71535 17.7382 1.75079C17.6431 1.78623 17.5561 1.84061 17.4826 1.91065C17.4091 1.98069 17.3506 2.06492 17.3106 2.15823C17.2706 2.25155 17.25 2.35202 17.25 2.45354V3.20354H6.75V2.47464C6.75 2.07104 6.43969 1.72464 6.03609 1.70448C5.93469 1.6996 5.83334 1.71535 5.7382 1.75079C5.64307 1.78623 5.55611 1.84061 5.48261 1.91065C5.40911 1.98069 5.3506 2.06492 5.31062 2.15823C5.27063 2.25155 5.25001 2.35202 5.25 2.45354V3.20354H4.5C3.70435 3.20354 2.94129 3.51962 2.37868 4.08222C1.81607 4.64483 1.5 5.4079 1.5 6.20355V6.76605C1.5 6.81577 1.51975 6.86346 1.55492 6.89863C1.59008 6.93379 1.63777 6.95355 1.6875 6.95355H22.3125C22.3622 6.95355 22.4099 6.93379 22.4451 6.89863C22.4802 6.86346 22.5 6.81577 22.5 6.76605V6.20355Z",
                fill: selected ? "#FFB800" : "#9CA3AF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.5 19.7036C1.5 20.4993 1.81607 21.2623 2.37868 21.8249C2.94129 22.3875 3.70435 22.7036 4.5 22.7036H19.5C20.2956 22.7036 21.0587 22.3875 21.6213 21.8249C22.1839 21.2623 22.5 20.4993 22.5 19.7036V8.64111C22.5 8.59139 22.4802 8.54369 22.4451 8.50853C22.4099 8.47337 22.3622 8.45361 22.3125 8.45361H1.6875C1.63777 8.45361 1.59008 8.47337 1.55492 8.50853C1.51975 8.54369 1.5 8.59139 1.5 8.64111V19.7036Z",
                fill: selected ? "#FFB800" : "#9CA3AF"
            })
        ]
    });
};
var HelpMenuIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12 3.00001C7.02939 3.00001 2.99995 7.02945 2.99995 12C2.99995 16.9706 7.02939 21 12 21C16.9705 21 21 16.9706 21 12C21 7.02945 16.9705 3.00001 12 3.00001ZM1.19995 12C1.19995 6.03534 6.03528 1.20001 12 1.20001C17.9646 1.20001 22.7999 6.03534 22.7999 12C22.7999 17.9647 17.9646 22.8 12 22.8C6.03528 22.8 1.19995 17.9647 1.19995 12ZM12 7.80001C11.0058 7.80001 10.2 8.6059 10.2 9.60001C10.2 10.0971 9.79701 10.5 9.29995 10.5C8.80289 10.5 8.39995 10.0971 8.39995 9.60001C8.39995 7.61179 10.0117 6.00001 12 6.00001C13.9882 6.00001 15.6 7.61179 15.6 9.60001C15.6 11.2775 14.4527 12.687 12.9 13.0866V13.5C12.9 13.9971 12.497 14.4 12 14.4C11.5029 14.4 11.1 13.9971 11.1 13.5V12.3C11.1 11.803 11.5029 11.4 12 11.4C12.9941 11.4 13.8 10.5941 13.8 9.60001C13.8 8.6059 12.9941 7.80001 12 7.80001ZM12 15.6C12.497 15.6 12.9 16.003 12.9 16.5V17.1C12.9 17.5971 12.497 18 12 18C11.5029 18 11.1 17.5971 11.1 17.1V16.5C11.1 16.003 11.5029 15.6 12 15.6Z",
            fill: "#9CA3AF"
        })
    });
};
var LogOutMenuIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M21.3613 12.6104C21.6795 12.2657 21.6795 11.7343 21.3613 11.3895L17.7613 7.48954C17.4242 7.1243 16.8548 7.10152 16.4895 7.43866C16.1243 7.77581 16.1015 8.3452 16.4387 8.71044L18.6444 11.1L10.5 11.1C10.0029 11.1 9.59998 11.5029 9.59998 12C9.59998 12.497 10.0029 12.9 10.5 12.9L18.6444 12.9L16.4387 15.2895C16.1015 15.6548 16.1243 16.2242 16.4895 16.5613C16.8548 16.8985 17.4242 16.8757 17.7613 16.5104L21.3613 12.6104ZM12 21.9C12 21.4029 11.597 21 11.1 21L5.69997 21C4.87155 21 4.19997 20.3284 4.19997 19.5L4.19997 4.49999C4.19997 3.67156 4.87155 2.99999 5.69997 2.99999L11.1 2.99999C11.597 2.99999 12 2.59704 12 2.09999C12 1.60293 11.597 1.19999 11.1 1.19999L5.69997 1.19999C3.87744 1.19999 2.39997 2.67745 2.39997 4.49999L2.39997 19.5C2.39997 21.3225 3.87743 22.8 5.69998 22.8L11.1 22.8C11.597 22.8 12 22.397 12 21.9Z",
            fill: "#9CA3AF"
        })
    });
};
var BookInClassIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "14",
        height: "15",
        viewBox: "0 0 14 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.7575 1.94083C12.506 1.72936 12.193 1.60458 11.865 1.585C11.7971 1.57903 11.7288 1.57903 11.6608 1.585H11.5383C10.0331 1.84755 8.5858 2.37277 7.26251 3.13666C7.19063 3.17554 7.11082 3.19748 7.02918 3.20083C6.93785 3.2026 6.84821 3.17611 6.77251 3.125C5.43458 2.37504 3.96881 1.88052 2.45001 1.66666C2.23807 1.6327 2.02128 1.64539 1.81474 1.70382C1.60821 1.76225 1.41691 1.86503 1.25418 2.005C1.0857 2.14842 0.951208 2.32749 0.860412 2.52926C0.769617 2.73103 0.724791 2.95045 0.729175 3.17166V10.3467C0.7253 10.6988 0.848973 11.0404 1.07735 11.3085C1.30574 11.5765 1.6234 11.7529 1.97168 11.805C3.49975 12.0768 4.97842 12.5762 6.35834 13.2867C6.67013 13.4332 7.02437 13.4622 7.35584 13.3683C7.4681 13.3449 7.57759 13.3097 7.68251 13.2633C9.05729 12.5591 10.5333 12.073 12.0575 11.8225C12.3994 11.7619 12.7088 11.5822 12.9309 11.3153C13.153 11.0483 13.2734 10.7114 13.2708 10.3642V3.06083C13.2714 2.84812 13.2258 2.63782 13.1372 2.44446C13.0485 2.25109 12.919 2.07926 12.7575 1.94083ZM2.10584 10.9417C1.96568 10.9219 1.8375 10.8517 1.74521 10.7444C1.65291 10.6371 1.60278 10.4999 1.60418 10.3583V3.1075C1.60444 3.01734 1.62442 2.92833 1.66271 2.84671C1.701 2.76509 1.75668 2.69283 1.82584 2.635C1.93219 2.54121 2.06905 2.48937 2.21084 2.48916H2.33334C3.74284 2.70569 5.09979 3.1824 6.33501 3.895C6.41569 3.94089 6.50196 3.97618 6.59168 4V12.4175C5.17645 11.7092 3.66514 11.212 2.10584 10.9417ZM12.3958 10.3583C12.3979 10.4973 12.3502 10.6324 12.2614 10.7394C12.1727 10.8463 12.0486 10.918 11.9117 10.9417C11.4975 11.0117 11.0892 11.0992 10.6867 11.1983L10.3367 11.2975C10.0625 11.3675 9.78834 11.4433 9.52001 11.5308C9.37418 11.5775 9.23418 11.6358 9.09418 11.6883C8.86084 11.77 8.63334 11.8517 8.40584 11.945C8.17834 12.0383 8.12001 12.0733 7.97418 12.1433C7.82834 12.2133 7.61251 12.295 7.43751 12.3825V4C7.52478 3.96952 7.60881 3.93044 7.68834 3.88333C8.64202 3.35367 9.65673 2.9423 10.71 2.65833C11.0367 2.57666 11.3517 2.5125 11.6725 2.46C11.7635 2.44526 11.8567 2.45068 11.9454 2.47588C12.0341 2.50107 12.1162 2.54544 12.1858 2.60583C12.2525 2.6613 12.3059 2.73092 12.3422 2.80963C12.3785 2.88834 12.3968 2.97415 12.3958 3.06083V10.3583ZM2.75334 5.31833C2.75629 5.20323 2.80334 5.09365 2.88475 5.01224C2.96617 4.93082 3.07574 4.88378 3.19084 4.88083H4.51501C4.63104 4.88083 4.74232 4.92692 4.82437 5.00897C4.90641 5.09102 4.95251 5.2023 4.95251 5.31833C4.95251 5.43436 4.90641 5.54564 4.82437 5.62769C4.74232 5.70973 4.63104 5.75583 4.51501 5.75583H3.19084C3.07528 5.75432 2.96488 5.70774 2.88315 5.62602C2.80143 5.5443 2.75485 5.43389 2.75334 5.31833ZM5.39584 7.06833C5.39284 7.18287 5.3456 7.2918 5.26403 7.37228C5.18247 7.45276 5.07292 7.49853 4.95834 7.5H3.20834C3.09231 7.5 2.98103 7.4539 2.89898 7.37185C2.81694 7.28981 2.77084 7.17853 2.77084 7.0625C2.77084 6.94646 2.81694 6.83518 2.89898 6.75314C2.98103 6.67109 3.09231 6.625 3.20834 6.625H4.95834C5.01656 6.62576 5.07406 6.63798 5.12756 6.66096C5.18106 6.68395 5.2295 6.71725 5.27013 6.75896C5.31076 6.80067 5.34277 6.84997 5.36434 6.90406C5.38591 6.95814 5.39661 7.01594 5.39584 7.07416V7.06833Z",
            fill: "#9CA3AF"
        })
    });
};
var ClockInClassIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "14",
        height: "15",
        viewBox: "0 0 14 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M6.99996 1.22917C5.75971 1.22917 4.54731 1.59695 3.51607 2.286C2.48484 2.97505 1.68109 3.95442 1.20647 5.10026C0.731843 6.24611 0.60766 7.50696 0.849621 8.72338C1.09158 9.93981 1.68882 11.0572 2.56581 11.9342C3.44281 12.8111 4.56016 13.4084 5.77658 13.6503C6.99301 13.8923 8.25386 13.7681 9.39971 13.2935C10.5456 12.8189 11.5249 12.0151 12.214 10.9839C12.903 9.95266 13.2708 8.74026 13.2708 7.5C13.2708 5.83688 12.6101 4.24187 11.4341 3.06586C10.2581 1.88985 8.66309 1.22917 6.99996 1.22917ZM6.99996 12.8958C5.92996 12.8958 4.88402 12.5784 3.99451 11.9837C3.105 11.389 2.41191 10.5438 2.00298 9.555C1.59404 8.56622 1.48764 7.47836 1.69724 6.42909C1.90683 5.37982 2.42301 4.41632 3.18043 3.66053C3.93785 2.90475 4.90246 2.39065 5.95218 2.18332C7.0019 1.97599 8.08953 2.08475 9.07742 2.49582C10.0653 2.90689 10.909 3.60179 11.5018 4.49259C12.0946 5.38338 12.4098 6.43001 12.4075 7.5C12.4059 8.93369 11.8357 10.3082 10.8219 11.322C9.80817 12.3357 8.43365 12.906 6.99996 12.9075V12.8958ZM9.91663 7.5C9.91663 7.61449 9.87115 7.72429 9.7902 7.80524C9.70924 7.88619 9.59945 7.93167 9.48496 7.93167H6.99996C6.88548 7.93167 6.77568 7.88619 6.69473 7.80524C6.61377 7.72429 6.5683 7.61449 6.5683 7.5V3.95334C6.5683 3.83885 6.61377 3.72906 6.69473 3.6481C6.77568 3.56715 6.88548 3.52167 6.99996 3.52167C7.11445 3.52167 7.22424 3.56715 7.3052 3.6481C7.38615 3.72906 7.43163 3.83885 7.43163 3.95334V7.06834H9.50246C9.61389 7.07286 9.71924 7.12033 9.79644 7.20079C9.87365 7.28126 9.91672 7.38849 9.91663 7.5Z",
            fill: "#9CA3AF"
        })
    });
};
var GeoLocationIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.16667 1.71676C7.87162 1.86812 6.64305 2.37236 5.61506 3.17442C4.58708 3.97648 3.79919 5.04554 3.33742 6.26489C2.87565 7.48424 2.75774 8.80702 2.99656 10.0888C3.23538 11.3706 3.82175 12.5622 4.69167 13.5334L8.33333 17.5751C8.54424 17.8077 8.80149 17.9935 9.08853 18.1207C9.37557 18.2479 9.68605 18.3136 10 18.3136C10.314 18.3136 10.6244 18.2479 10.9115 18.1207C11.1985 17.9935 11.4558 17.8077 11.6667 17.5751L15.2917 13.5334C16.2507 12.4559 16.8601 11.1127 17.0393 9.68145C17.2184 8.25016 16.959 6.79819 16.2952 5.51754C15.6314 4.2369 14.5945 3.18789 13.3216 2.50923C12.0488 1.83058 10.5999 1.55424 9.16667 1.71676ZM10 11.5334C9.44291 11.5334 8.89834 11.3682 8.43514 11.0587C7.97194 10.7492 7.61092 10.3093 7.39774 9.79465C7.18455 9.27997 7.12877 8.71364 7.23745 8.16726C7.34614 7.62088 7.6144 7.11899 8.00831 6.72508C8.40223 6.33116 8.90411 6.0629 9.45049 5.95422C9.99687 5.84553 10.5632 5.90131 11.0779 6.1145C11.5926 6.32769 12.0325 6.68871 12.342 7.1519C12.6515 7.6151 12.8167 8.15968 12.8167 8.71676C12.8167 9.46379 12.5199 10.1802 11.9917 10.7084C11.4635 11.2367 10.747 11.5334 10 11.5334Z",
            fill: "#9CA3AF"
        })
    });
};
var CalendarIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M16.8917 8.39994H3.10836C2.93446 8.40645 2.77001 8.48069 2.65011 8.60682C2.53022 8.73294 2.46439 8.90094 2.46669 9.07494V13.7999C2.45898 14.3904 2.56821 14.9765 2.78809 15.5246C3.00796 16.0726 3.33413 16.5717 3.74779 16.9932C4.16145 17.4146 4.65443 17.7499 5.1983 17.9799C5.74217 18.2099 6.32619 18.33 6.91669 18.3333H13.125C14.3039 18.3049 15.4241 17.8131 16.243 16.9646C17.0619 16.1161 17.5135 14.9791 17.5 13.7999V9.07494C17.5028 8.90636 17.4415 8.74299 17.3287 8.61774C17.2158 8.4925 17.0597 8.41467 16.8917 8.39994ZM7.33336 14.8999C7.19435 14.8999 7.05843 14.8589 6.94255 14.7821C6.82667 14.7053 6.73594 14.5961 6.68167 14.4681C6.6274 14.3402 6.61199 14.199 6.63736 14.0624C6.66272 13.9257 6.72775 13.7995 6.82432 13.6995C6.9209 13.5995 7.04476 13.5302 7.18048 13.5001C7.31619 13.47 7.45776 13.4805 7.58755 13.5303C7.71734 13.5801 7.8296 13.667 7.91035 13.7801C7.99111 13.8933 8.03678 14.0277 8.04169 14.1666C8.0395 14.353 7.9639 14.5311 7.8313 14.6621C7.6987 14.7931 7.51978 14.8666 7.33336 14.8666V14.8999ZM7.33336 12.2416C7.19326 12.2416 7.05631 12.2001 6.93983 12.1222C6.82334 12.0444 6.73255 11.9338 6.67894 11.8043C6.62533 11.6749 6.6113 11.5325 6.63863 11.3951C6.66597 11.2577 6.73343 11.1315 6.83249 11.0324C6.93155 10.9333 7.05777 10.8659 7.19517 10.8385C7.33257 10.8112 7.47499 10.8252 7.60442 10.8789C7.73386 10.9325 7.84448 11.0233 7.92231 11.1397C8.00015 11.2562 8.04169 11.3932 8.04169 11.5333C8.04281 11.6266 8.02525 11.7192 7.99005 11.8057C7.95485 11.8921 7.90271 11.9706 7.83672 12.0366C7.77072 12.1026 7.69219 12.1548 7.60574 12.19C7.5193 12.2252 7.42669 12.2427 7.33336 12.2416ZM10 14.8999C9.81361 14.8956 9.63645 14.8179 9.50696 14.6837C9.37747 14.5495 9.30611 14.3697 9.30836 14.1833C9.30836 13.9976 9.38211 13.8196 9.51338 13.6883C9.64466 13.557 9.82271 13.4833 10.0084 13.4833C10.194 13.4833 10.3721 13.557 10.5033 13.6883C10.6346 13.8196 10.7084 13.9976 10.7084 14.1833C10.7062 14.3697 10.6306 14.5477 10.498 14.6788C10.3654 14.8098 10.1865 14.8833 10 14.8833V14.8999ZM10 12.2416C9.81361 12.2372 9.63645 12.1595 9.50696 12.0254C9.37747 11.8912 9.30611 11.7114 9.30836 11.5249C9.30836 11.3393 9.38211 11.1612 9.51338 11.03C9.64466 10.8987 9.82271 10.8249 10.0084 10.8249C10.194 10.8249 10.3721 10.8987 10.5033 11.03C10.6346 11.1612 10.7084 11.3393 10.7084 11.5249C10.7084 11.7114 10.6349 11.8903 10.5038 12.0229C10.3728 12.1555 10.1948 12.2311 10.0084 12.2333L10 12.2416ZM12.65 14.8999C12.4622 14.8999 12.282 14.8253 12.1492 14.6925C12.0163 14.5596 11.9417 14.3795 11.9417 14.1916C11.9417 14.0037 12.0163 13.8236 12.1492 13.6907C12.282 13.5579 12.4622 13.4833 12.65 13.4833C12.8379 13.4833 13.0181 13.5579 13.1509 13.6907C13.2837 13.8236 13.3584 14.0037 13.3584 14.1916C13.3584 14.3795 13.2837 14.5596 13.1509 14.6925C13.0181 14.8253 12.8379 14.8999 12.65 14.8999ZM12.65 12.2416C12.4622 12.2416 12.282 12.167 12.1492 12.0341C12.0163 11.9013 11.9417 11.7211 11.9417 11.5333C11.9417 11.3454 12.0163 11.1652 12.1492 11.0324C12.282 10.8996 12.4622 10.8249 12.65 10.8249C12.8379 10.8249 13.0181 10.8996 13.1509 11.0324C13.2837 11.1652 13.3584 11.3454 13.3584 11.5333C13.3584 11.7211 13.2837 11.9013 13.1509 12.0341C13.0181 12.167 12.8379 12.2416 12.65 12.2416ZM17.275 6.33327C17.3348 6.50472 17.3257 6.69269 17.2495 6.8575C17.1733 7.02232 17.036 7.15108 16.8667 7.21661C16.7944 7.24246 16.7184 7.25652 16.6417 7.25827H3.51669C3.29568 7.25827 3.08371 7.17048 2.92743 7.01419C2.77115 6.85791 2.68336 6.64595 2.68336 6.42494C2.681 6.32191 2.7009 6.21958 2.74169 6.12494C2.98601 5.52672 3.35676 4.98838 3.82853 4.54681C4.30031 4.10524 4.86197 3.77087 5.47502 3.56661V2.26661C5.47502 2.11632 5.53473 1.97218 5.641 1.86591C5.74727 1.75964 5.8914 1.69994 6.04169 1.69994C6.19198 1.69994 6.33611 1.75964 6.44238 1.86591C6.54865 1.97218 6.60836 2.11632 6.60836 2.26661V3.33327H9.56669V2.26661C9.55698 2.18699 9.56429 2.10622 9.58812 2.02964C9.61195 1.95305 9.65177 1.8824 9.70494 1.82235C9.75811 1.7623 9.82342 1.71423 9.89656 1.6813C9.96969 1.64837 10.049 1.63135 10.1292 1.63135C10.2094 1.63135 10.2887 1.64837 10.3618 1.6813C10.435 1.71423 10.5003 1.7623 10.5534 1.82235C10.6066 1.8824 10.6464 1.95305 10.6703 2.02964C10.6941 2.10622 10.7014 2.18699 10.6917 2.26661V3.33327H13.3334V2.26661C13.3236 2.18699 13.331 2.10622 13.3548 2.02964C13.3786 1.95305 13.4184 1.8824 13.4716 1.82235C13.5248 1.7623 13.5901 1.71423 13.6632 1.6813C13.7364 1.64837 13.8157 1.63135 13.8959 1.63135C13.9761 1.63135 14.0554 1.64837 14.1285 1.6813C14.2016 1.71423 14.2669 1.7623 14.3201 1.82235C14.3733 1.8824 14.4131 1.95305 14.4369 2.02964C14.4608 2.10622 14.4681 2.18699 14.4584 2.26661V3.56661C15.1076 3.78276 15.6988 4.14438 16.187 4.62387C16.6751 5.10336 17.0473 5.68803 17.275 6.33327Z",
            fill: "#9CA3AF"
        })
    });
};
var SearchIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "fe:search",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Vector",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M16.325 14.8992L21.705 20.2792C21.8941 20.4685 22.0003 20.7251 22.0002 20.9926C22.0001 21.2601 21.8937 21.5166 21.7045 21.7057C21.5153 21.8948 21.2587 22.001 20.9912 22.0009C20.7236 22.0008 20.4671 21.8945 20.278 21.7052L14.898 16.3252C13.2897 17.5709 11.2673 18.1571 9.24214 17.9646C7.21699 17.7721 5.34124 16.8153 3.99649 15.2888C2.65174 13.7624 1.939 11.781 2.00326 9.74778C2.06753 7.71451 2.90396 5.78209 4.34242 4.34364C5.78087 2.90518 7.71329 2.06875 9.74656 2.00448C11.7798 1.94022 13.7612 2.65296 15.2876 3.99771C16.814 5.34246 17.7708 7.21821 17.9634 9.24336C18.1559 11.2685 17.5697 13.2909 16.324 14.8992H16.325ZM10 16.0002C11.5913 16.0002 13.1174 15.3681 14.2427 14.2429C15.3679 13.1177 16 11.5915 16 10.0002C16 8.40893 15.3679 6.88281 14.2427 5.75759C13.1174 4.63237 11.5913 4.00023 10 4.00023C8.40871 4.00023 6.88259 4.63237 5.75737 5.75759C4.63215 6.88281 4.00001 8.40893 4.00001 10.0002C4.00001 11.5915 4.63215 13.1177 5.75737 14.2429C6.88259 15.3681 8.40871 16.0002 10 16.0002Z",
                fill: "#9CA3AF"
            })
        })
    });
};
var ArrowIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_2703_2922)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M14.94 8.69997C14.9 8.65997 14.88 8.61997 14.88 8.57997L14.76 8.45997L10.26 3.95997C10.14 3.79997 9.98 3.71997 9.78 3.71997C9.58 3.71997 9.4 3.79997 9.24 3.95997C9.08 4.11997 9 4.29997 9 4.49997C9 4.69997 9.08 4.87997 9.24 5.03997L12.48 8.21997H0.78C0.54 8.21997 0.35 8.28997 0.21 8.42997C0.07 8.56997 0 8.75997 0 8.99997C0 9.23997 0.07 9.41997 0.21 9.53997C0.35 9.65997 0.54 9.71997 0.78 9.71997H12.48L9.24 12.96C9.08 13.12 9 13.3 9 13.5C9 13.7 9.07 13.87 9.21 14.01C9.35 14.15 9.53 14.22 9.75 14.22C9.97 14.22 10.14 14.16 10.26 14.04L14.76 9.53997C14.88 9.41997 14.94 9.33997 14.94 9.29997C14.98 9.09997 14.98 8.89997 14.94 8.69997Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2703_2922",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "matrix(1 0 0 -1 0 18)"
                    })
                })
            })
        ]
    });
};
var LogoSappIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "36",
        height: "45",
        viewBox: "0 0 36 45",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.1303 35.2298C28.7336 33.2054 31.7194 30.4893 34.9069 26.8657C34.9069 26.8657 36.2742 29.6317 34.8188 31.1585C32.5671 33.4542 30.1646 35.5744 27.6297 37.5029C25.0823 39.4124 22.4105 41.1244 19.6346 42.6259C17.803 43.5806 15.8242 41.2782 15.8242 41.2782C20.083 39.2765 23.4758 37.1759 26.1303 35.2298Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.3304 38.3655C30.1496 36.9519 32.2368 35.0519 34.4648 32.5225C34.4648 32.5225 35.4207 34.4554 34.404 35.5231C32.8308 37.1272 31.1526 38.6094 29.3823 39.9582C27.6011 41.2924 25.7334 42.4892 23.7932 43.5394C22.5131 44.2067 21.1299 42.597 21.1299 42.597C24.1024 41.1947 26.475 39.7264 28.3304 38.3655Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.0126 42.5977C31.7782 42.0191 32.3931 41.3726 32.7807 40.7873L32.8433 40.7393L32.549 45L28.6973 43.8691L28.8259 43.7748C29.4734 43.576 30.247 43.1726 31.0126 42.5977Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.58622 20.4677C9.7492 23.5683 10.765 27.2833 11.668 30.1295C10.6989 30.4895 9.77828 30.7892 8.89198 31.1002C6.32384 31.9926 4.63319 32.4629 3.37775 33.41C3.19098 33.5505 2.70554 33.8737 2.55489 34.0217C1.35407 30.8825 0.495972 26.0883 0.221978 21.0313C-0.112805 14.4908 0.236955 9.17085 1.92937 5.7866C2.65709 4.33527 11.8037 -0.645453 12.15 0.0698482C13.4486 2.75293 9.13866 11.9604 9.58622 20.4677Z",
                fill: "url(#paint0_linear_10824_34983)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9427 7.6669C12.6845 4.4881 13.14 1.93318 12.836 0.236816C15.9848 0.794733 20.359 2.71728 24.5534 5.17419C27.6907 7.02417 30.954 9.0485 32.9979 10.923C32.8605 11.005 32.4349 11.2792 32.2931 11.3867C31.0377 12.3347 29.8457 13.9859 28.1991 16.2741C27.6044 17.1025 26.9374 18.174 26.2608 19.0712C24.4988 17.3155 22.173 15.2214 20.0356 13.9642C17.4631 12.4535 14.0897 11.3094 11.3242 10.6186C11.5533 9.54139 11.7154 8.64137 11.9427 7.6669Z",
                fill: "url(#paint1_linear_10824_34983)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.73682 34.8701C4.17639 32.2709 13.7591 31.3021 20.2689 26.3883C26.7787 21.4745 30.841 12.1388 33.6091 11.5583C34.3483 11.4037 36.3913 22.1615 35.779 23.6751C34.3509 27.1969 30.6727 30.797 25.6756 34.5874C20.6671 38.3571 16.2656 40.8593 12.6843 41.1175C11.146 41.2249 2.3527 35.5638 2.73682 34.8701Z",
                fill: "url(#paint2_linear_10824_34983)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.2785 19.5583C25.3833 20.334 21.9941 24.0735 19.7924 25.5804C17.5503 27.1147 13.2994 29.5556 12.392 29.0109C11.7999 28.6575 10.3454 22.5147 10.2423 20.0691C10.141 17.6386 10.6511 12.0679 11.4026 11.6014C11.9426 11.2659 16.6516 12.8351 19.2013 14.3448C21.6267 15.782 25.1128 18.3351 25.2785 19.5583Z",
                fill: "url(#paint3_linear_10824_34983)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_10824_34983",
                        x1: "6.2516",
                        y1: "0.000108707",
                        x2: "6.2516",
                        y2: "34.0255",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                "stop-color": "#FFD316"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#F9A31F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_10824_34983",
                        x1: "28.0942",
                        y1: "17.1175",
                        x2: "11.5301",
                        y2: "1.63382",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                "stop-color": "#FFD316"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#F9A31F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_10824_34983",
                        x1: "8.59112",
                        y1: "41.3324",
                        x2: "36.8309",
                        y2: "14.933",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                "stop-color": "#FFD316"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#F9A31F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_10824_34983",
                        x1: "10.2264",
                        y1: "20.3226",
                        x2: "25.2811",
                        y2: "20.3226",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                "stop-color": "#FFD316"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#F9A31F"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var CollapseArrowIcon = function(param) {
    var selected = param.selected, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0,clsx/* default */.Z)(className, {
            "-rotate-180": selected
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11.9999 17.1999C11.8683 17.2007 11.7379 17.1754 11.616 17.1257C11.4942 17.0759 11.3834 17.0026 11.2899 16.9099L5.28994 10.9099C5.1967 10.8167 5.12274 10.706 5.07228 10.5841C5.02182 10.4623 4.99585 10.3318 4.99585 10.1999C4.99585 9.93359 5.10164 9.6782 5.28994 9.48989C5.47825 9.30159 5.73364 9.1958 5.99994 9.1958C6.26624 9.1958 6.52164 9.30159 6.70994 9.48989L11.9999 14.7799L17.2899 9.48989C17.3832 9.39665 17.4939 9.32269 17.6157 9.27223C17.7375 9.22177 17.8681 9.1958 17.9999 9.1958C18.1318 9.1958 18.2624 9.22177 18.3842 9.27223C18.506 9.32269 18.6167 9.39665 18.7099 9.48989C18.8032 9.58313 18.8771 9.69382 18.9276 9.81564C18.9781 9.93747 19.004 10.068 19.004 10.1999C19.004 10.3318 18.9781 10.4623 18.9276 10.5841C18.8771 10.706 18.8032 10.8167 18.7099 10.9099L12.7099 16.9099C12.6165 17.0026 12.5057 17.0759 12.3838 17.1257C12.262 17.1754 12.1315 17.2007 11.9999 17.1999Z",
            fill: "currentColor"
        })
    });
};
var ArrowCollapseIcon = function() {
    return /*#__PURE__*/ _jsx("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("g", {
            id: "arrows",
            children: /*#__PURE__*/ _jsx("g", {
                id: "to-ight",
                children: /*#__PURE__*/ _jsx("path", {
                    id: "Vector",
                    d: "M10.0001 3.99999L3.48012 0.279993C3.21538 0.127143 2.91504 0.0467387 2.60934 0.0468752C2.30364 0.0470117 2.00337 0.127684 1.73877 0.28077C1.47416 0.433856 1.25456 0.653953 1.10207 0.9189C0.949573 1.18385 0.869572 1.48429 0.87012 1.78999V10.21C0.869572 10.5157 0.949573 10.8161 1.10207 11.0811C1.25456 11.346 1.47416 11.5661 1.73877 11.7192C2.00337 11.8723 2.30364 11.953 2.60934 11.9531C2.91504 11.9532 3.21538 11.8728 3.48012 11.72L10.0001 7.99999C10.3645 7.80825 10.6696 7.52061 10.8824 7.16814C11.0952 6.81566 11.2077 6.41174 11.2077 5.99999C11.2077 5.58825 11.0952 5.18433 10.8824 4.83185C10.6696 4.47937 10.3645 4.19173 10.0001 3.99999Z",
                    fill: "currentColor"
                })
            })
        })
    });
};
var LockClosedIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 13H8C6.89543 13 6 13.8954 6 15V21C6 22.1046 6.89543 23 8 23H18C19.1046 23 20 22.1046 20 21V15C20 13.8954 19.1046 13 18 13Z",
                stroke: "#B90E0A",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 19C13.5523 19 14 18.5523 14 18C14 17.4477 13.5523 17 13 17C12.4477 17 12 17.4477 12 18C12 18.5523 12.4477 19 13 19Z",
                stroke: "#B90E0A",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 13V9C9 7.93913 9.42143 6.92172 10.1716 6.17157C10.9217 5.42143 11.9391 5 13 5C14.0609 5 15.0783 5.42143 15.8284 6.17157C16.5786 6.92172 17 7.93913 17 9V13",
                stroke: "#B90E0A",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var InfoIcon = function(param) {
    var _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "#000" : _bgColor, _color = param.color, color = _color === void 0 ? "#000" : _color, _width = param.width, width = _width === void 0 ? "16" : _width, _height = param.height, height = _height === void 0 ? "16" : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 14 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.2",
                d: "M6.99967 14.1666C10.6816 14.1666 13.6663 11.1818 13.6663 7.49992C13.6663 3.81802 10.6816 0.833252 6.99967 0.833252C3.31778 0.833252 0.333008 3.81802 0.333008 7.49992C0.333008 11.1818 3.31778 14.1666 6.99967 14.1666Z",
                fill: bgColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.99967 6.56665C7.17649 6.56665 7.34605 6.63689 7.47108 6.76191C7.5961 6.88694 7.66634 7.05651 7.66634 7.23332V10.34C7.66634 10.5168 7.5961 10.6864 7.47108 10.8114C7.34605 10.9364 7.17649 11.0067 6.99967 11.0067C6.82286 11.0067 6.65329 10.9364 6.52827 10.8114C6.40325 10.6864 6.33301 10.5168 6.33301 10.34V7.23332C6.33301 7.05651 6.40325 6.88694 6.52827 6.76191C6.65329 6.63689 6.82286 6.56665 6.99967 6.56665Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.99935 5.65983C7.45959 5.65983 7.83268 5.28673 7.83268 4.8265C7.83268 4.36626 7.45959 3.99316 6.99935 3.99316C6.53911 3.99316 6.16602 4.36626 6.16602 4.8265C6.16602 5.28673 6.53911 5.65983 6.99935 5.65983Z",
                fill: color
            })
        ]
    });
};
var CheckIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "68" : _width, _height = param.height, height = _height === void 0 ? "68" : _height, _color = param.color, color = _color === void 0 ? "#07AF17" : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 68 68",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M31.167 46.4667L17.8503 33.15L21.817 29.1834L31.167 38.5334L54.967 14.7334C49.5837 9.35002 42.217 5.66669 34.0003 5.66669C18.417 5.66669 5.66699 18.4167 5.66699 34C5.66699 49.5834 18.417 62.3334 34.0003 62.3334C49.5837 62.3334 62.3337 49.5834 62.3337 34C62.3337 28.6167 60.917 23.8 58.367 19.55L31.167 46.4667Z",
            fill: color
        })
    });
};
var ActionIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11.2998 18.2998C11.2998 17.902 11.4578 17.5204 11.7391 17.2391C12.0204 16.9578 12.402 16.7998 12.7998 16.7998C13.1976 16.7998 13.5792 16.9578 13.8605 17.2391C14.1418 17.5204 14.2998 17.902 14.2998 18.2998C14.2998 18.6976 14.1418 19.0792 13.8605 19.3605C13.5792 19.6418 13.1976 19.7998 12.7998 19.7998C12.402 19.7998 12.0204 19.6418 11.7391 19.3605C11.4578 19.0792 11.2998 18.6976 11.2998 18.2998ZM11.2998 12.2998C11.2998 11.902 11.4578 11.5204 11.7391 11.2391C12.0204 10.9578 12.402 10.7998 12.7998 10.7998C13.1976 10.7998 13.5792 10.9578 13.8605 11.2391C14.1418 11.5204 14.2998 11.902 14.2998 12.2998C14.2998 12.6976 14.1418 13.0792 13.8605 13.3605C13.5792 13.6418 13.1976 13.7998 12.7998 13.7998C12.402 13.7998 12.0204 13.6418 11.7391 13.3605C11.4578 13.0792 11.2998 12.6976 11.2998 12.2998ZM11.2998 6.2998C11.2998 5.90198 11.4578 5.52045 11.7391 5.23914C12.0204 4.95784 12.402 4.7998 12.7998 4.7998C13.1976 4.7998 13.5792 4.95784 13.8605 5.23914C14.1418 5.52045 14.2998 5.90198 14.2998 6.2998C14.2998 6.69763 14.1418 7.07916 13.8605 7.36046C13.5792 7.64177 13.1976 7.7998 12.7998 7.7998C12.402 7.7998 12.0204 7.64177 11.7391 7.36046C11.4578 7.07916 11.2998 6.69763 11.2998 6.2998Z",
            fill: "#99A1B7"
        })
    });
};
var SwitcherExpanded = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12 16C11.6066 16 11.2361 15.8024 11 15.4667L7.25001 10.1333C6.96593 9.72931 6.92023 9.18876 7.13197 8.73705C7.34371 8.28534 7.77654 8 8.25001 8H15.75C16.2235 8 16.6563 8.28534 16.868 8.73705C17.0798 9.18876 17.0341 9.72931 16.75 10.1333L13 15.4667C12.7639 15.8024 12.3934 16 12 16Z",
            fill: "#FFB800"
        })
    });
};
var SwitcherClosed = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M8.73705 7.13197C9.18876 6.92023 9.72931 6.96593 10.1333 7.25001L15.4667 11C15.8024 11.2361 16 11.6066 16 12C16 12.3934 15.8024 12.7639 15.4667 13L10.1333 16.75C9.72931 17.0341 9.18876 17.0798 8.73705 16.868C8.28534 16.6563 8 16.2235 8 15.75V8.25001C8 7.77654 8.28534 7.34371 8.73705 7.13197Z",
            fill: "#9CA3AF"
        })
    });
};
var CircleCloseIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.35989 7.4747C8.11581 7.23062 7.72008 7.23062 7.476 7.4747C7.23192 7.71878 7.23192 8.11451 7.476 8.35859L9.1174 9.99999L7.47602 11.6414C7.23194 11.8854 7.23194 12.2812 7.47602 12.5253C7.7201 12.7693 8.11583 12.7693 8.3599 12.5253L10.0013 10.8839L11.6427 12.5252C11.8867 12.7693 12.2825 12.7693 12.5265 12.5252C12.7706 12.2812 12.7706 11.8854 12.5265 11.6414L10.8852 9.99999L12.5266 8.3586C12.7706 8.11453 12.7706 7.7188 12.5266 7.47472C12.2825 7.23064 11.8867 7.23064 11.6427 7.47472L10.0013 9.1161L8.35989 7.4747Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.0013 1.04166C5.05375 1.04166 1.04297 5.05244 1.04297 9.99999C1.04297 14.9475 5.05375 18.9583 10.0013 18.9583C14.9489 18.9583 18.9596 14.9475 18.9596 9.99999C18.9596 5.05244 14.9489 1.04166 10.0013 1.04166ZM2.29297 9.99999C2.29297 5.74279 5.74411 2.29166 10.0013 2.29166C14.2585 2.29166 17.7096 5.74279 17.7096 9.99999C17.7096 14.2572 14.2585 17.7083 10.0013 17.7083C5.74411 17.7083 2.29297 14.2572 2.29297 9.99999Z",
                fill: "currentColor"
            })
        ]
    });
};
var ClockIcon = function(param) {
    var _color = param.color, color = _color === void 0 ? "black" : _color, _size = param.size, size = _size === void 0 ? 24 : _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "currentColor",
        width: size,
        height: size,
        viewBox: "0 0 256 256",
        id: "Flat",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "SVGRepo_bgCarrier",
                "stroke-width": "0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "SVGRepo_tracerCarrier",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "SVGRepo_iconCarrier",
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M136,80v43.38116l37.56934,21.69062a8,8,0,1,1-8,13.85644l-41.56934-24c-.064-.03692-.12109-.0805-.18359-.11889-.13575-.08362-.271-.16779-.40088-.2591-.10352-.07232-.20215-.14892-.30127-.22534-.10205-.0788-.20362-.15765-.30127-.24115-.11182-.09479-.21778-.19342-.32276-.29333-.0791-.07532-.15771-.15064-.23388-.22913-.10694-.11017-.2085-.22351-.30811-.339-.06933-.08026-.13769-.16083-.2041-.24377-.0918-.1156-.1792-.23352-.26416-.35352-.06738-.09473-.1333-.19019-.19629-.2879-.07226-.11194-.14062-.22547-.207-.34058-.06592-.11438-.12988-.22986-.19043-.34778-.05322-.10418-.10352-.20941-.15186-.31561-.061-.13287-.11914-.26685-.17333-.4035-.03907-.09986-.0752-.20063-.11036-.30194-.0498-.14252-.09668-.28589-.13818-.432-.03027-.10687-.05664-.21454-.083-.32257-.0332-.13928-.06543-.27881-.09131-.42084-.02392-.12842-.0415-.25757-.05908-.38714-.0166-.12226-.0332-.244-.04394-.368-.01416-.16015-.01954-.3208-.02442-.48187C120.00879,128.14313,120,128.07269,120,128V80a8,8,0,0,1,16,0Zm91.228-27.67529a7.99962,7.99962,0,0,0-8.71826,1.73437L204.1665,68.40222l-8.28466-8.28454a95.9551,95.9551,0,1,0,0,135.76464,7.99983,7.99983,0,1,0-11.31348-11.31347,80.00009,80.00009,0,1,1,0-113.1377l8.28467,8.28467L178.50977,94.05908a7.99981,7.99981,0,0,0,5.65673,13.65674h40a7.99977,7.99977,0,0,0,8-8v-40A8.00014,8.00014,0,0,0,227.228,52.32471Z"
                    }),
                    " "
                ]
            })
        ]
    });
};
var AlertCircleSharp = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "68",
        height: "68",
        viewBox: "0 0 68 68",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M34 6.375C18.7677 6.375 6.375 18.7677 6.375 34C6.375 49.2323 18.7677 61.625 34 61.625C49.2323 61.625 61.625 49.2323 61.625 34C61.625 18.7677 49.2323 6.375 34 6.375ZM36.6562 48.863H31.3438V43.5505H36.6562V48.863ZM36.125 40.375H31.875L31.0781 19.125H36.9219L36.125 40.375Z",
            fill: "#FFB800"
        })
    });
};
var AlertInfoIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.3",
                d: "M12.0007 23.6666C18.444 23.6666 23.6673 18.4432 23.6673 11.9999C23.6673 5.5566 18.444 0.333252 12.0007 0.333252C5.55733 0.333252 0.333984 5.5566 0.333984 11.9999C0.333984 18.4432 5.55733 23.6666 12.0007 23.6666Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.0007 10.3667C12.3101 10.3667 12.6068 10.4896 12.8256 10.7084C13.0444 10.9272 13.1673 11.2239 13.1673 11.5334V16.97C13.1673 17.2795 13.0444 17.5762 12.8256 17.795C12.6068 18.0138 12.3101 18.1367 12.0007 18.1367C11.6912 18.1367 11.3945 18.0138 11.1757 17.795C10.9569 17.5762 10.834 17.2795 10.834 16.97V11.5334C10.834 11.2239 10.9569 10.9272 11.1757 10.7084C11.3945 10.4896 11.6912 10.3667 12.0007 10.3667Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.0013 8.77995C12.8067 8.77995 13.4596 8.12703 13.4596 7.32161C13.4596 6.5162 12.8067 5.86328 12.0013 5.86328C11.1959 5.86328 10.543 6.5162 10.543 7.32161C10.543 8.12703 11.1959 8.77995 12.0013 8.77995Z",
                fill: "currentColor"
            })
        ]
    });
};
var CloseNone = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 18L6 6",
                stroke: "#404041",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 18L18 6",
                stroke: "#404041",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        ]
    });
};
var OutlineVideo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.95202 1.0415H10.0477C11.9713 1.04149 13.4788 1.04148 14.6551 1.19963C15.859 1.36149 16.809 1.69928 17.5547 2.44495C18.3004 3.19063 18.6382 4.14065 18.8 5.34459C18.9582 6.52083 18.9582 8.02836 18.9582 9.95203V10.0476C18.9582 11.9713 18.9582 13.4788 18.8 14.6551C18.6382 15.859 18.3004 16.809 17.5547 17.5547C16.809 18.3004 15.859 18.6382 14.6551 18.8C13.4788 18.9582 11.9713 18.9582 10.0476 18.9582H9.95203C8.02836 18.9582 6.52083 18.9582 5.34459 18.8C4.14065 18.6382 3.19063 18.3004 2.44495 17.5547C1.69928 16.809 1.36149 15.859 1.19963 14.6551C1.04148 13.4788 1.04149 11.9713 1.0415 10.0477V9.95202C1.04149 8.02836 1.04148 6.52083 1.19963 5.34459C1.36149 4.14065 1.69928 3.19063 2.44495 2.44495C3.19063 1.69928 4.14065 1.36149 5.34459 1.19963C6.52083 1.04148 8.02836 1.04149 9.95202 1.0415ZM5.51115 2.43848C4.44582 2.58171 3.80355 2.85412 3.32883 3.32883C2.85412 3.80355 2.58171 4.44582 2.43848 5.51115C2.41585 5.67945 2.39671 5.85596 2.38051 6.0415H5.49008L7.87016 2.30138C6.9306 2.3158 6.15988 2.35126 5.51115 2.43848ZM9.33914 2.29177C9.32365 2.33541 9.30304 2.37799 9.27713 2.41872L6.97172 6.0415H10.9067L13.2656 2.33476C12.3796 2.29209 11.3121 2.2915 9.99984 2.2915C9.77236 2.2915 9.55224 2.29152 9.33914 2.29177ZM14.665 2.46399L12.3884 6.0415H17.6192C17.603 5.85596 17.5838 5.67945 17.5612 5.51115C17.418 4.44582 17.1456 3.80355 16.6708 3.32883C16.2229 2.88092 15.6259 2.61312 14.665 2.46399ZM17.6859 7.2915H11.2592C11.2526 7.29161 11.2459 7.29161 11.2393 7.2915H5.84252C5.8359 7.29161 5.82927 7.29161 5.82264 7.2915H2.31377C2.29188 8.05961 2.2915 8.95163 2.2915 9.99984C2.2915 11.9817 2.29283 13.4052 2.43848 14.4885C2.58171 15.5539 2.85412 16.1961 3.32883 16.6708C3.80355 17.1456 4.44582 17.418 5.51115 17.5612C6.59447 17.7068 8.01798 17.7082 9.99984 17.7082C11.9817 17.7082 13.4052 17.7068 14.4885 17.5612C15.5539 17.418 16.1961 17.1456 16.6708 16.6708C17.1456 16.1961 17.418 15.5539 17.5612 14.4885C17.7068 13.4052 17.7082 11.9817 17.7082 9.99984C17.7082 8.95163 17.7078 8.05961 17.6859 7.2915ZM11.14 9.9342L11.2247 9.98884C11.7412 10.322 12.1884 10.6105 12.5001 10.8862C12.8317 11.1795 13.1248 11.557 13.1248 12.0832C13.1248 12.6093 12.8317 12.9869 12.5001 13.2801C12.1884 13.5558 11.7412 13.8443 11.2247 14.1775L11.14 14.2321C10.6183 14.5689 10.1648 14.8615 9.78809 15.0288C9.39615 15.2028 8.89397 15.3282 8.41502 15.0239C7.96114 14.7355 7.82352 14.2434 7.76577 13.81C7.70812 13.3774 7.70814 12.806 7.70817 12.129V12.0374C7.70814 11.3604 7.70812 10.789 7.76577 10.3563C7.82352 9.92298 7.96114 9.4308 8.41502 9.14245C8.89397 8.83817 9.39615 8.96355 9.78809 9.13757C10.1648 9.30482 10.6183 9.59747 11.14 9.9342ZM9.0481 10.2096C9.0476 10.2089 9.05149 10.2079 9.06129 10.2085C9.05351 10.2105 9.04861 10.2102 9.0481 10.2096ZM9.08076 10.2109C9.11422 10.2166 9.17641 10.2337 9.28083 10.28C9.55715 10.4027 9.9277 10.6396 10.506 11.0127C11.0755 11.3801 11.4403 11.6176 11.672 11.8226C11.8854 12.0113 11.8757 12.0775 11.8749 12.0828C11.8757 12.0882 11.8854 12.1551 11.672 12.3438C11.4403 12.5487 11.0755 12.7862 10.506 13.1537C9.9277 13.5268 9.55715 13.7636 9.28083 13.8863C9.1764 13.9327 9.11422 13.9498 9.08075 13.9555C9.06225 13.9198 9.02997 13.8337 9.00482 13.6449C8.95952 13.305 8.95817 12.8183 8.95817 12.0832C8.95817 11.3481 8.95952 10.8614 9.00482 10.5214C9.02997 10.3327 9.06225 10.2465 9.08076 10.2109ZM9.0481 13.9568C9.04862 13.9561 9.05352 13.9558 9.06129 13.9579C9.05148 13.9585 9.04759 13.9574 9.0481 13.9568ZM9.09157 13.9733C9.09443 13.9757 9.09567 13.9774 9.09558 13.9776C9.09549 13.9778 9.09406 13.9766 9.09157 13.9733ZM9.09157 10.193C9.09406 10.1897 9.09549 10.1885 9.09558 10.1887C9.09567 10.189 9.09443 10.1906 9.09157 10.193Z",
            fill: "#1C274C"
        })
    });
};
var OutlineText = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.29315 5.20817C7.93493 5.20811 7.60004 5.20806 7.32644 5.24893C7.01736 5.2951 6.69983 5.40425 6.44602 5.68626C6.2007 5.95885 6.11408 6.28368 6.07654 6.59395C6.04145 6.88397 6.04147 7.24349 6.0415 7.64946L6.0415 8.12484C6.0415 8.47002 6.32133 8.74984 6.6665 8.74984C7.01168 8.74984 7.2915 8.47002 7.2915 8.12484V7.68502C7.2915 7.23259 7.29258 6.94993 7.31749 6.74411C7.32917 6.64755 7.34378 6.5919 7.35559 6.56002C7.36555 6.53311 7.37266 6.52522 7.37503 6.5226L7.3757 6.52182C7.37684 6.52045 7.37767 6.51944 7.38519 6.51601C7.39904 6.50968 7.43457 6.49665 7.51112 6.48521C7.68121 6.4598 7.92076 6.45817 8.33317 6.45817H9.37484V13.5415H7.9165C7.57133 13.5415 7.2915 13.8213 7.2915 14.1665C7.2915 14.5117 7.57133 14.7915 7.9165 14.7915H12.4998C12.845 14.7915 13.1248 14.5117 13.1248 14.1665C13.1248 13.8213 12.845 13.5415 12.4998 13.5415H10.6248V6.45817H11.6665C12.0789 6.45817 12.3185 6.4598 12.4886 6.48521C12.5651 6.49665 12.6006 6.50968 12.6145 6.51601C12.622 6.51944 12.6228 6.52045 12.624 6.52182L12.6245 6.52247C12.6269 6.52509 12.6341 6.53311 12.6441 6.56002C12.6559 6.5919 12.6705 6.64755 12.6822 6.74411C12.7071 6.94993 12.7082 7.23259 12.7082 7.68502V8.12484C12.7082 8.47002 12.988 8.74984 13.3332 8.74984C13.6783 8.74984 13.9582 8.47002 13.9582 8.12484L13.9582 7.64945C13.9582 7.24349 13.9582 6.88397 13.9231 6.59395C13.8856 6.28368 13.799 5.95885 13.5537 5.68626C13.2998 5.40425 12.9823 5.2951 12.6732 5.24893C12.3996 5.20806 12.0647 5.20811 11.7065 5.20817H8.29315Z",
                fill: "#1C274C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.95202 1.0415C8.02836 1.04149 6.52083 1.04148 5.34459 1.19963C4.14065 1.36149 3.19063 1.69928 2.44495 2.44495C1.69928 3.19063 1.36149 4.14065 1.19963 5.34459C1.04148 6.52083 1.04149 8.02836 1.0415 9.95202V10.0477C1.04149 11.9713 1.04148 13.4788 1.19963 14.6551C1.36149 15.859 1.69928 16.8091 2.44495 17.5547C3.19063 18.3004 4.14065 18.6382 5.34459 18.8C6.52083 18.9582 8.02836 18.9582 9.95203 18.9582H10.0476C11.9713 18.9582 13.4788 18.9582 14.6551 18.8C15.859 18.6382 16.8091 18.3004 17.5547 17.5547C18.3004 16.8091 18.6382 15.859 18.8 14.6551C18.9582 13.4788 18.9582 11.9713 18.9582 10.0476V9.95203C18.9582 8.02836 18.9582 6.52083 18.8 5.34459C18.6382 4.14065 18.3004 3.19063 17.5547 2.44495C16.8091 1.69928 15.859 1.36149 14.6551 1.19963C13.4788 1.04148 11.9713 1.04149 10.0477 1.0415H9.95202ZM3.32883 3.32883C3.80355 2.85412 4.44582 2.58171 5.51115 2.43848C6.59447 2.29283 8.01798 2.2915 9.99984 2.2915C11.9817 2.2915 13.4052 2.29283 14.4885 2.43848C15.5539 2.58171 16.1961 2.85412 16.6708 3.32883C17.1456 3.80355 17.418 4.44582 17.5612 5.51115C17.7068 6.59447 17.7082 8.01798 17.7082 9.99984C17.7082 11.9817 17.7068 13.4052 17.5612 14.4885C17.418 15.5539 17.1456 16.1961 16.6708 16.6708C16.1961 17.1456 15.5539 17.418 14.4885 17.5612C13.4052 17.7068 11.9817 17.7082 9.99984 17.7082C8.01798 17.7082 6.59447 17.7068 5.51115 17.5612C4.44582 17.418 3.80355 17.1456 3.32883 16.6708C2.85412 16.1961 2.58171 15.5539 2.43848 14.4885C2.29283 13.4052 2.2915 11.9817 2.2915 9.99984C2.2915 8.01798 2.29283 6.59447 2.43848 5.51115C2.58171 4.44582 2.85412 3.80355 3.32883 3.32883Z",
                fill: "#1C274C"
            })
        ]
    });
};
var OutlineArchive = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0,clsx/* default */.Z)(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.95526 2.25C3.97013 2.25001 3.98505 2.25001 4.00001 2.25001L20.0448 2.25C20.4776 2.24995 20.8744 2.24991 21.1972 2.29331C21.5527 2.3411 21.9284 2.45355 22.2374 2.76257C22.5465 3.07159 22.6589 3.44732 22.7067 3.8028C22.7501 4.12561 22.7501 4.52245 22.75 4.95526V5.04475C22.7501 5.47757 22.7501 5.8744 22.7067 6.19721C22.6589 6.55269 22.5465 6.92842 22.2374 7.23744C21.9437 7.53121 21.5896 7.64733 21.25 7.69914V13.0564C21.25 14.8942 21.25 16.3498 21.0969 17.489C20.9392 18.6615 20.6071 19.6104 19.8588 20.3588C19.1104 21.1071 18.1615 21.4392 16.989 21.5969C15.8498 21.75 14.3942 21.75 12.5564 21.75H11.4436C9.60583 21.75 8.1502 21.75 7.01098 21.5969C5.83856 21.4392 4.88961 21.1071 4.14125 20.3588C3.39289 19.6104 3.06077 18.6615 2.90314 17.489C2.74998 16.3498 2.74999 14.8942 2.75001 13.0564L2.75001 7.69914C2.41038 7.64733 2.05634 7.53121 1.76257 7.23744C1.45355 6.92842 1.3411 6.55269 1.29331 6.19721C1.24991 5.8744 1.24995 5.47757 1.25 5.04476C1.25001 5.02988 1.25001 5.01496 1.25001 5.00001C1.25001 4.98505 1.25001 4.97013 1.25 4.95526C1.24995 4.52244 1.24991 4.12561 1.29331 3.8028C1.3411 3.44732 1.45355 3.07159 1.76257 2.76257C2.07159 2.45355 2.44732 2.3411 2.8028 2.29331C3.12561 2.24991 3.52244 2.24995 3.95526 2.25ZM4.25001 7.75001V13C4.25001 14.9068 4.2516 16.2615 4.38977 17.2892C4.52503 18.2952 4.7787 18.8749 5.20191 19.2981C5.62512 19.7213 6.20477 19.975 7.21086 20.1102C8.23852 20.2484 9.59319 20.25 11.5 20.25H12.5C14.4068 20.25 15.7615 20.2484 16.7892 20.1102C17.7952 19.975 18.3749 19.7213 18.7981 19.2981C19.2213 18.8749 19.475 18.2952 19.6102 17.2892C19.7484 16.2615 19.75 14.9068 19.75 13V7.75001H4.25001ZM2.82324 3.82324L2.82568 3.82187C2.82761 3.82086 2.83093 3.81924 2.83597 3.81717C2.85775 3.80821 2.90611 3.79291 3.00267 3.77993C3.21339 3.7516 3.5074 3.75001 4.00001 3.75001H20C20.4926 3.75001 20.7866 3.7516 20.9973 3.77993C21.0939 3.79291 21.1423 3.80821 21.164 3.81717C21.1691 3.81924 21.1724 3.82086 21.1743 3.82187L21.1768 3.82323L21.1781 3.82568C21.1792 3.82761 21.1808 3.83093 21.1828 3.83597C21.1918 3.85775 21.2071 3.90611 21.2201 4.00267C21.2484 4.21339 21.25 4.5074 21.25 5.00001C21.25 5.49261 21.2484 5.78662 21.2201 5.99734C21.2071 6.0939 21.1918 6.14226 21.1828 6.16404C21.1808 6.16909 21.1792 6.1724 21.1781 6.17434L21.1768 6.17678L21.1743 6.17815C21.1724 6.17916 21.1691 6.18077 21.164 6.18285C21.1423 6.19181 21.0939 6.2071 20.9973 6.22008C20.7866 6.24841 20.4926 6.25001 20 6.25001H4.00001C3.5074 6.25001 3.21339 6.24841 3.00267 6.22008C2.90611 6.2071 2.85775 6.19181 2.83597 6.18285C2.83093 6.18077 2.82761 6.17916 2.82568 6.17815L2.82324 6.17677L2.82187 6.17434C2.82086 6.1724 2.81924 6.16909 2.81717 6.16404C2.80821 6.14226 2.79291 6.0939 2.77993 5.99734C2.7516 5.78662 2.75001 5.49261 2.75001 5.00001C2.75001 4.5074 2.7516 4.21339 2.77993 4.00267C2.79291 3.90611 2.80821 3.85775 2.81717 3.83597C2.81924 3.83093 2.82086 3.82761 2.82187 3.82568L2.82324 3.82324ZM2.82324 6.17677C2.82284 6.17636 2.82297 6.17644 2.82324 6.17677V6.17677ZM10.4782 9.75001H13.5218C13.736 9.74999 13.9329 9.74998 14.0982 9.76126C14.2759 9.77338 14.4712 9.80099 14.6697 9.88322C15.0985 10.0608 15.4392 10.4015 15.6168 10.8303C15.699 11.0288 15.7266 11.2242 15.7388 11.4018C15.75 11.5671 15.75 11.764 15.75 11.9782V12.0218C15.75 12.236 15.75 12.4329 15.7388 12.5982C15.7266 12.7759 15.699 12.9712 15.6168 13.1697C15.4392 13.5985 15.0985 13.9392 14.6697 14.1168C14.4712 14.199 14.2759 14.2266 14.0982 14.2388C13.9329 14.25 13.736 14.25 13.5218 14.25H10.4782C10.264 14.25 10.0671 14.25 9.9018 14.2388C9.72416 14.2266 9.52881 14.199 9.33031 14.1168C8.90151 13.9392 8.56083 13.5985 8.38322 13.1697C8.30099 12.9712 8.27338 12.7759 8.26126 12.5982C8.24998 12.4329 8.24999 12.236 8.25001 12.0218V11.9782C8.24999 11.764 8.24998 11.5671 8.26126 11.4018C8.27338 11.2242 8.30099 11.0288 8.38322 10.8303C8.56083 10.4015 8.90151 10.0608 9.33031 9.88322C9.52881 9.80099 9.72416 9.77338 9.9018 9.76126C10.0671 9.74998 10.264 9.74999 10.4782 9.75001ZM9.90131 11.2703C9.84248 11.2956 9.79559 11.3425 9.77031 11.4013C9.76844 11.4087 9.76234 11.4371 9.75778 11.5039C9.75041 11.6119 9.75001 11.7568 9.75001 12C9.75001 12.2432 9.75041 12.3881 9.75778 12.4961C9.76234 12.5629 9.76844 12.5913 9.77031 12.5987C9.79559 12.6575 9.84248 12.7044 9.90131 12.7297C9.90867 12.7316 9.93707 12.7377 10.0039 12.7422C10.1119 12.7496 10.2568 12.75 10.5 12.75H13.5C13.7432 12.75 13.8881 12.7496 13.9961 12.7422C14.0629 12.7377 14.0913 12.7316 14.0987 12.7297C14.1575 12.7044 14.2044 12.6575 14.2297 12.5987C14.2316 12.5913 14.2377 12.5629 14.2422 12.4961C14.2496 12.3881 14.25 12.2432 14.25 12C14.25 11.7568 14.2496 11.6119 14.2422 11.5039C14.2377 11.4371 14.2316 11.4087 14.2297 11.4013C14.2044 11.3425 14.1575 11.2956 14.0987 11.2703C14.0913 11.2684 14.0629 11.2623 13.9961 11.2578C13.8881 11.2504 13.7432 11.25 13.5 11.25H10.5C10.2568 11.25 10.1119 11.2504 10.0039 11.2578C9.93707 11.2623 9.90866 11.2684 9.90131 11.2703Z",
            fill: "currentColor"
        })
    });
};
var DownloadMinimalistic = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5535 14.5061C10.4114 14.6615 10.2106 14.75 10 14.75C9.78943 14.75 9.58857 14.6615 9.44648 14.5061L5.44648 10.1311C5.16698 9.82538 5.18822 9.35098 5.49392 9.07148C5.79963 8.79198 6.27402 8.81322 6.55352 9.11892L9.25 12.0682V1C9.25 0.585787 9.58579 0.25 10 0.25C10.4142 0.25 10.75 0.585787 10.75 1V12.0682L13.4465 9.11892C13.726 8.81322 14.2004 8.79198 14.5061 9.07148C14.8118 9.35098 14.833 9.82537 14.5535 10.1311L10.5535 14.5061Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.75 13C1.75 12.5858 1.41422 12.25 1 12.25C0.585788 12.25 0.250001 12.5858 0.250001 13V13.0549C0.24998 14.4225 0.249964 15.5248 0.366524 16.3918C0.487541 17.2919 0.746434 18.0497 1.34835 18.6516C1.95027 19.2536 2.70814 19.5125 3.60825 19.6335C4.47522 19.75 5.57754 19.75 6.94513 19.75H13.0549C14.4225 19.75 15.5248 19.75 16.3918 19.6335C17.2919 19.5125 18.0497 19.2536 18.6517 18.6516C19.2536 18.0497 19.5125 17.2919 19.6335 16.3918C19.75 15.5248 19.75 14.4225 19.75 13.0549V13C19.75 12.5858 19.4142 12.25 19 12.25C18.5858 12.25 18.25 12.5858 18.25 13C18.25 14.4354 18.2484 15.4365 18.1469 16.1919C18.0482 16.9257 17.8678 17.3142 17.591 17.591C17.3142 17.8678 16.9257 18.0482 16.1919 18.1469C15.4365 18.2484 14.4354 18.25 13 18.25H7C5.56459 18.25 4.56347 18.2484 3.80812 18.1469C3.07435 18.0482 2.68577 17.8678 2.40901 17.591C2.13225 17.3142 1.9518 16.9257 1.85315 16.1919C1.75159 15.4365 1.75 14.4354 1.75 13Z",
                fill: "currentColor"
            })
        ]
    });
};
var EllipsisIconV2 = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 12C7 13.1046 6.10457 14 5 14C3.89543 14 3 13.1046 3 12C3 10.8954 3.89543 10 5 10C6.10457 10 7 10.8954 7 12Z",
                fill: "#1C274C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
                fill: "#1C274C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 12C21 13.1046 20.1046 14 19 14C17.8954 14 17 13.1046 17 12C17 10.8954 17.8954 10 19 10C20.1046 10 21 10.8954 21 12Z",
                fill: "#1C274C"
            })
        ]
    });
};
var PencilV2Icon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M14.0992 2.39109C15.6207 0.869636 18.0875 0.869636 19.6089 2.39109C21.1304 3.91255 21.1304 6.37932 19.6089 7.90077L12.0149 15.4948C11.5869 15.9228 11.3255 16.1842 11.0342 16.4115C10.691 16.6792 10.3196 16.9087 9.92667 17.096C9.59315 17.2549 9.24244 17.3718 8.66818 17.5632L5.99553 18.4541L5.35386 18.668C4.77951 18.8594 4.14629 18.7099 3.7182 18.2818C3.2901 17.8537 3.14062 17.2205 3.33207 16.6462L4.43683 13.3318C4.62822 12.7576 4.7451 12.4069 4.90405 12.0734C5.09132 11.6804 5.32084 11.309 5.58856 10.9658C5.81578 10.6745 6.07719 10.4131 6.50525 9.98509L14.0992 2.39109ZM5.96092 16.8845L5.11556 16.0391L5.84398 13.8538C6.05606 13.2176 6.14366 12.9589 6.25814 12.7187C6.39854 12.4241 6.57061 12.1457 6.77132 11.8883C6.93497 11.6785 7.12718 11.4845 7.60141 11.0102L13.4924 5.11927C13.7355 5.72927 14.147 6.46549 14.8408 7.15927C15.5345 7.85306 16.2708 8.26447 16.8807 8.50764L10.9898 14.3986C10.5155 14.8728 10.3215 15.065 10.1117 15.2287C9.85436 15.4294 9.57594 15.6015 9.28134 15.7419C9.04113 15.8564 8.78244 15.944 8.14619 16.156L5.96092 16.8845ZM18.076 7.31241C17.9521 7.28522 17.7973 7.24432 17.6213 7.18325C17.1373 7.01532 16.5006 6.69778 15.9014 6.09861C15.3022 5.49944 14.9847 4.86276 14.8168 4.37873C14.7557 4.2027 14.7148 4.04787 14.6876 3.92404L15.1599 3.45175C16.0956 2.51608 17.6126 2.51608 18.5483 3.45175C19.4839 4.38742 19.4839 5.90444 18.5483 6.84011L18.076 7.31241ZM3.25002 22C3.25002 21.5858 3.58581 21.25 4.00002 21.25H20V22.75H4.00002C3.58581 22.75 3.25002 22.4142 3.25002 22Z",
            fill: "currentColor"
        })
    });
};
var PencilFillV2Icon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M2.16666 14.6667C2.16666 14.3905 2.39051 14.1667 2.66666 14.1667H13.3333C13.6095 14.1667 13.8333 14.3905 13.8333 14.6667C13.8333 14.9428 13.6095 15.1667 13.3333 15.1667H2.66666C2.39051 15.1667 2.16666 14.9428 2.16666 14.6667Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.68003 9.95263L7.68004 9.95262L11.6245 6.00816C11.0877 5.78473 10.4518 5.4177 9.85047 4.81636C9.24903 4.21492 8.88199 3.57897 8.65856 3.04208L4.71403 6.98661L4.71402 6.98662C4.40621 7.29443 4.2523 7.44834 4.11994 7.61804C3.9638 7.81823 3.82993 8.03483 3.72071 8.26401C3.62811 8.45829 3.55928 8.66478 3.42162 9.07777L2.6957 11.2555C2.62795 11.4588 2.68085 11.6828 2.83233 11.8343C2.98381 11.9858 3.20787 12.0387 3.41111 11.971L5.58889 11.245C6.00186 11.1074 6.20836 11.0385 6.40264 10.9459C6.63183 10.8367 6.84843 10.7029 7.04861 10.5467C7.21831 10.4144 7.37223 10.2604 7.68003 9.95263Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.719 4.91363C13.5381 4.09458 13.5381 2.76665 12.719 1.94761C11.9 1.12857 10.5721 1.12857 9.75303 1.94761L9.27994 2.4207C9.28642 2.44026 9.29314 2.46009 9.30011 2.48018C9.47351 2.97999 9.80068 3.6352 10.4162 4.25067C11.0316 4.86615 11.6868 5.19332 12.1866 5.36672C12.2066 5.37366 12.2264 5.38035 12.2459 5.3868L12.719 4.91363Z",
                fill: "currentColor"
            })
        ]
    });
};
var EssentialIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M22.75 7C22.75 7.41421 22.4142 7.75 22 7.75L2 7.75C1.58579 7.75 1.25 7.41421 1.25 7C1.25 6.58579 1.58579 6.25 2 6.25L22 6.25C22.4142 6.25 22.75 6.58579 22.75 7Z",
                fill: "#1C274C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M19.75 12C19.75 12.4142 19.4142 12.75 19 12.75L5 12.75C4.58579 12.75 4.25 12.4142 4.25 12C4.25 11.5858 4.58579 11.25 5 11.25L19 11.25C19.4142 11.25 19.75 11.5858 19.75 12Z",
                fill: "#1C274C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M16.75 17C16.75 17.4142 16.4142 17.75 16 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17C7.25 16.5858 7.58579 16.25 8 16.25H16C16.4142 16.25 16.75 16.5858 16.75 17Z",
                fill: "#1C274C"
            })
        ]
    });
};
var CheckIconV2 = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M17.1084 5.39155C17.3525 5.63563 17.3525 6.03136 17.1084 6.27544L9.95359 13.4302C9.05867 14.3252 7.60767 14.3252 6.71272 13.4302L3.72456 10.4421C3.48049 10.198 3.48049 9.80233 3.72456 9.55824C3.96864 9.31416 4.36437 9.31416 4.60844 9.55824L7.5966 12.5464C8.00339 12.9532 8.66292 12.9532 9.06975 12.5464L16.2246 5.39155C16.4687 5.14748 16.8643 5.14748 17.1084 5.39155Z",
            fill: "#FFB800"
        })
    });
};
var MyCourseTeacherIcon = function(param) {
    var selected = param.selected;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.217 3.70326C12.796 3.03706 11.2035 3.03706 9.78252 3.70326L5.48919 5.71607C6.27114 5.80045 6.98602 6.29301 7.31789 7.06738C7.80739 8.20955 7.2783 9.53228 6.13613 10.0218L5.06046 10.4828C4.52594 10.7119 4.22261 10.8442 4.01782 10.9492C4.0167 10.9656 4.01564 10.9824 4.01465 10.9998L9.78261 13.704C11.2036 14.3702 12.7961 14.3702 14.2171 13.704L20.9082 10.567C22.3637 9.88466 22.3637 7.52261 20.9082 6.84025L14.217 3.70326Z",
                fill: selected ? "#FFB800" : "#9CA3AF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.9998 13.1183V16.829C4.9998 17.8371 5.50331 18.7808 6.38514 19.2692C7.85351 20.0824 10.2038 21.2036 11.9998 21.2036C13.7958 21.2036 16.1461 20.0824 17.6145 19.2692C18.4963 18.7808 18.9998 17.8371 18.9998 16.829V13.1184L14.8538 15.0621C13.0294 15.9174 10.9703 15.9174 9.14588 15.0621L4.9998 13.1183Z",
                fill: selected ? "#FFB800" : "#9CA3AF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.54544 8.64316C5.92616 8.48 6.10253 8.03909 5.93936 7.65837C5.7762 7.27764 5.33529 7.10128 4.95456 7.26445L3.84318 7.74075C3.28571 7.97965 2.81328 8.1821 2.44254 8.39067C2.04805 8.61259 1.70851 8.87305 1.45419 9.25875C1.19986 9.64444 1.09421 10.0591 1.04563 10.5091C0.999964 10.9321 0.999981 11.446 1 12.0525V14.9538C1 15.368 1.33579 15.7038 1.75 15.7038C2.16422 15.7038 2.5 15.368 2.5 14.9538V12.0914C2.5 11.4356 2.50101 11.0031 2.53696 10.6702C2.57095 10.3553 2.63046 10.1997 2.70645 10.0845C2.78244 9.96924 2.90202 9.85325 3.178 9.69799C3.46985 9.5338 3.867 9.3625 4.46976 9.10417L5.54544 8.64316Z",
                fill: selected ? "#FFB800" : "#9CA3AF"
            })
        ]
    });
};




/***/ }),

/***/ 68507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);

var ErrorMessage = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "".concat(className, "  ml-4 mt-1 flex items-start gap-1.5 text-sm font-normal leading-4.5 text-state-error"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 14 14",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    className: "mt-[1px] flex-none",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M7.7 7.7H6.3V3.5H7.7M7.7 10.5H6.3V9.1H7.7M7 0C6.08075 0 5.17049 0.18106 4.32122 0.532843C3.47194 0.884626 2.70026 1.40024 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 8.85651 0.737498 10.637 2.05025 11.9497C2.70026 12.5998 3.47194 13.1154 4.32122 13.4672C5.17049 13.8189 6.08075 14 7 14C8.85651 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85651 14 7C14 6.08075 13.8189 5.17049 13.4672 4.32122C13.1154 3.47194 12.5998 2.70026 11.9497 2.05025C11.2997 1.40024 10.5281 0.884626 9.67878 0.532843C8.8295 0.18106 7.91925 0 7 0Z",
                        fill: "#D35563"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "flex-auto first-letter:uppercase",
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorMessage);


/***/ }),

/***/ 13891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var _SappIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75440);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43743);




var NoData = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        "data-aos": src_constants__WEBPACK_IMPORTED_MODULE_3__/* .ANIMATION.DATA_AOS */ .lB.DATA_AOS,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SappIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                icon: "nodata"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-base font-light text-gray-1",
                children: "No Data Found"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoData);


/***/ }),

/***/ 75440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);


var SappIcon = function(param) {
    var icon = param.icon, className = param.className;
    var SAPP_ICONS = {
        camera: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: 16,
            height: 16,
            fill: "none",
            className: className,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    fill: "#A1A1A1",
                    clipPath: "url(#a)",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1v6ZM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2Z"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "a",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h16v16H0z"
                        })
                    })
                })
            ]
        }),
        course_text: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: 16,
            height: 16,
            fill: "none",
            className: className,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: 15,
                    height: 15,
                    x: 0.5,
                    y: 0.5,
                    stroke: "#A1A1A1",
                    rx: 1.5
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#A1A1A1",
                    d: "M3.333 4.2c0-.11.09-.2.2-.2h8.934c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H3.533a.2.2 0 0 1-.2-.2v-.6ZM3.333 6.533c0-.11.09-.2.2-.2h8.934c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H3.533a.2.2 0 0 1-.2-.2v-.6ZM3.333 8.867c0-.11.09-.2.2-.2h8.934c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H3.533a.2.2 0 0 1-.2-.2v-.6ZM3.333 11.2c0-.11.09-.2.2-.2H9.8c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H3.533a.2.2 0 0 1-.2-.2v-.6Z"
                })
            ]
        }),
        course_video: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: 16,
            height: 16,
            fill: "none",
            className: className,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: 15,
                    height: 15,
                    x: 0.5,
                    y: 0.5,
                    stroke: "#A1A1A1",
                    rx: 1.5
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    stroke: "#A1A1A1",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M6 10.403V5.466a.469.469 0 0 1 .709-.4l4.228 2.457a.468.468 0 0 1 0 .812L6.71 10.803a.469.469 0 0 1-.709-.4Z"
                })
            ]
        }),
        course_quiz: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: 16,
            height: 16,
            fill: "none",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#A1A1A1",
                    stroke: "#A1A1A1",
                    strokeWidth: 0.1,
                    d: "M7.202 9.69c.005-.49.062-.884.173-1.18a1.79 1.79 0 0 1 .473-.72 3.74 3.74 0 0 1 .723-.5c.164-.09.31-.195.44-.317.13-.123.23-.264.304-.424.076-.16.115-.335.115-.53 0-.24-.063-.447-.187-.621a1.225 1.225 0 0 0-.503-.408 1.684 1.684 0 0 0-.706-.145c-.226 0-.444.043-.653.127-.207.083-.38.214-.52.393a1.12 1.12 0 0 0-.2.437c-.04.17-.183.313-.368.313h-.477c-.198 0-.366-.169-.329-.373.057-.308.172-.582.347-.82A2.25 2.25 0 0 1 6.76 4.2a3.175 3.175 0 0 1 1.274-.249c.505 0 .946.09 1.323.273.378.182.672.432.879.752.21.32.314.683.314 1.09 0 .286-.05.547-.148.78a1.9 1.9 0 0 1-.42.624M7.203 9.69l2.745-2.256M7.202 9.69c0 .053.043.096.096.096h.928a.096.096 0 0 0 .096-.096h-.05m-1.07 0h1.07m1.71-2.22-.035-.036m.036.035-.036-.035m.036.035c-.18.182-.396.343-.65.483m.614-.518a2.756 2.756 0 0 1-.637.474m.024.044-.024-.044m.024.044a2.55 2.55 0 0 0-.588.435c-.145.147-.25.322-.316.527a2.738 2.738 0 0 0-.108.777h-.05m1.062-1.74v.001l-.024-.044m0 0L8.272 9.69m-.07 2.262a.808.808 0 0 0 .295-.268.681.681 0 0 0-.127-.895.83.83 0 0 0-.574-.216.83.83 0 0 0-.573.216.681.681 0 0 0-.242.523c0 .204.082.379.242.523a.83.83 0 0 0 .573.215c.15 0 .285-.032.406-.098Z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: 15,
                    height: 15,
                    x: 0.5,
                    y: 0.5,
                    stroke: "#A1A1A1",
                    rx: 1.5
                })
            ]
        }),
        course_past_exam_analysis: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: 16,
            height: 16,
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: "24",
                    height: "24",
                    rx: "3",
                    fill: "#F1F1F2"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "5.25",
                    y: "19",
                    width: "11",
                    height: "1.5",
                    rx: "0.3",
                    transform: "rotate(-90 5.25 19)",
                    fill: "#404041"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "11.25",
                    y: "19",
                    width: "14",
                    height: "1.5",
                    rx: "0.3",
                    transform: "rotate(-90 11.25 19)",
                    fill: "#404041"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "17.25",
                    y: "19",
                    width: "9",
                    height: "1.5",
                    rx: "0.3",
                    transform: "rotate(-90 17.25 19)",
                    fill: "#404041"
                })
            ]
        }),
        course_video_timeline: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: 18,
            height: 18,
            fill: "none",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: className,
                d: "M17.438 4.219H.563v1.687h16.875V4.22ZM14.625 8.156H3.375v1.688h11.25V8.156ZM11.25 12.094h-4.5v1.687h4.5v-1.687Z"
            })
        }),
        arrow_left: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: 16,
            height: 16,
            fill: "none",
            className: className,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#404041",
                d: "M11.313 3.411V2.203a.125.125 0 0 0-.202-.098L4.067 7.606a.498.498 0 0 0 0 .786l7.044 5.502a.124.124 0 0 0 .201-.099v-1.207a.253.253 0 0 0-.095-.197L5.592 8l5.625-4.392a.253.253 0 0 0 .095-.197Z"
            })
        }),
        arrow_right: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: 16,
            height: 16,
            fill: "none",
            className: className,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#404041",
                d: "M4.688 12.59v1.207c0 .105.12.162.201.098l7.044-5.501a.497.497 0 0 0 0-.786L4.889 2.106a.124.124 0 0 0-.201.099v1.207c0 .077.035.15.095.197L10.408 8l-5.625 4.392a.253.253 0 0 0-.095.197Z"
            })
        }),
        arrow_down: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "19",
            height: "19",
            viewBox: "0 0 19 19",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: className,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M4 9L9.5 14L15 9H4Z"
            })
        }),
        x: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            className: className + " fill-gray-1",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M13.41 12L17 8.44003C17.191 8.24642 17.2972 7.98489 17.2953 7.71296C17.2934 7.44103 17.1836 7.18099 16.99 6.99003C16.7964 6.79908 16.5349 6.69285 16.2629 6.69473C15.991 6.6966 15.731 6.80642 15.54 7.00003L12 10.59L8.46 7.07003C8.27263 6.88378 8.01918 6.77924 7.755 6.77924C7.49081 6.77924 7.23736 6.88378 7.05 7.07003C6.95627 7.16299 6.88187 7.2736 6.8311 7.39546C6.78034 7.51731 6.7542 7.64802 6.7542 7.78003C6.7542 7.91204 6.78034 8.04275 6.8311 8.16461C6.88187 8.28647 6.95627 8.39707 7.05 8.49003L10.59 12L7 15.56C6.80904 15.7536 6.70282 16.0152 6.70469 16.2871C6.70657 16.559 6.81639 16.8191 7.01 17.01C7.2036 17.201 7.46514 17.3072 7.73707 17.3053C8.00899 17.3035 8.26904 17.1936 8.46 17L12 13.41L15.54 16.93C15.7274 17.1163 15.9808 17.2208 16.245 17.2208C16.5092 17.2208 16.7626 17.1163 16.95 16.93C17.0437 16.8371 17.1181 16.7265 17.1689 16.6046C17.2197 16.4827 17.2458 16.352 17.2458 16.22C17.2458 16.088 17.2197 15.9573 17.1689 15.8355C17.1181 15.7136 17.0437 15.603 16.95 15.51L13.41 12Z"
            })
        }),
        nodata: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "70",
            height: "70",
            viewBox: "0 0 70 70",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: "w-fill--available",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    clipPath: "url(#clip0_9347_5425)",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M12.9347 56.9559H57.0653C64.1791 56.9559 70 51.1634 70 44.0847C70 37.0081 64.1791 31.2156 57.0653 31.2156H56.0284C54.9981 26.8778 51.0891 23.6272 46.4122 23.6272C45.2769 23.6272 44.1262 23.8766 43.1747 24.1959C40.8887 17.7056 34.6938 13.0441 27.3919 13.0441C18.1475 13.0441 10.6509 20.5013 10.6509 29.7019C10.6509 30.2816 10.6816 30.8547 10.7384 31.4169C4.66375 32.4625 0 37.7519 0 44.0847C0 51.1656 5.82094 56.9559 12.9347 56.9559ZM10.9266 32.4931L11.9328 32.3203L11.8278 31.3031C11.7731 30.7694 11.7447 30.2291 11.7447 29.6997C11.7447 21.1181 18.7644 14.1356 27.3919 14.1356C34.02 14.1356 39.9481 18.3225 42.1422 24.5569L42.5009 25.5719L43.5225 25.2306C44.2203 24.9966 45.29 24.7188 46.4144 24.7188C50.505 24.7188 54.0203 27.4947 54.9653 31.4672L55.1644 32.3072H56.0284H57.0653C63.595 32.3072 68.9062 37.59 68.9062 44.0825C68.9062 50.5772 63.595 55.86 57.0653 55.86H12.9347C6.405 55.86 1.09375 50.5772 1.09375 44.0825C1.09375 38.3491 5.22812 33.4731 10.9266 32.4931Z",
                            fill: "#A1A1A1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M20.1532 47.3725L28.5598 38.8282L36.9642 47.3725L37.7473 46.6047L29.3276 38.045L37.7473 29.4854L36.9642 28.7197L28.5598 37.2641L20.1532 28.7197L19.3701 29.4854L27.7898 38.045L19.3701 46.6047L20.1532 47.3725Z",
                            fill: "#A1A1A1"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_9347_5425",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "70",
                            height: "70",
                            fill: "white"
                        })
                    })
                })
            ]
        }),
        closeicon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: className,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.21967 6.21967C6.51256 5.92678 6.98744 5.92678 7.28033 6.21967L17.7803 16.7197C18.0732 17.0126 18.0732 17.4874 17.7803 17.7803C17.4874 18.0732 17.0126 18.0732 16.7197 17.7803L6.21967 7.28033C5.92678 6.98744 5.92678 6.51256 6.21967 6.21967Z",
                    fill: className ? "currentColor" : "#21272A"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.7803 6.21967C18.0732 6.51256 18.0732 6.98744 17.7803 7.28033L7.28033 17.7803C6.98744 18.0732 6.51256 18.0732 6.21967 17.7803C5.92678 17.4874 5.92678 17.0126 6.21967 16.7197L16.7197 6.21967C17.0126 5.92678 17.4874 5.92678 17.7803 6.21967Z",
                    fill: className ? "currentColor" : "#21272A"
                })
            ]
        }),
        seemore: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            className: "ms-2.5 group-hover:fill-primary",
            width: "12",
            height: "7",
            viewBox: "0 0 12 7",
            fill: "#3964EA" // Original color
            ,
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8.78317 4.16666H0.666504V2.83333H8.78317L6.88319 0.933387L7.83319 5.34058e-05L11.3332 3.5L7.83311 7.00005L6.88311 6.06672L8.78317 4.16666Z",
                className: "transition-all duration-300 ease-in-out group-hover:fill-primary" // Added hover class for fill
            })
        }),
        search: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: className,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M16.9269 17.0401L20.4 20.4001M19.28 11.4401C19.28 15.77 15.7699 19.2801 11.44 19.2801C7.11009 19.2801 3.60001 15.77 3.60001 11.4401C3.60001 7.11019 7.11009 3.6001 11.44 3.6001C15.7699 3.6001 19.28 7.11019 19.28 11.4401Z",
                strokeWidth: "2",
                strokeLinecap: "round",
                className: "stroke-bw-14"
            })
        }),
        input_calendar: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.616 2.8582V1.61654C14.599 1.4749 14.5307 1.34441 14.4239 1.24974C14.3172 1.15508 14.1795 1.1028 14.0368 1.1028C13.8942 1.1028 13.7565 1.15508 13.6498 1.24974C13.543 1.34441 13.4747 1.4749 13.4577 1.61654V2.67487H13.191H10.741V1.61654C10.741 1.46183 10.6796 1.31345 10.5702 1.20406C10.4608 1.09466 10.3124 1.0332 10.1577 1.0332C10.003 1.0332 9.8546 1.09466 9.7452 1.20406C9.63581 1.31345 9.57435 1.46183 9.57435 1.61654V2.6582H6.80768H6.54102V1.61654C6.524 1.4749 6.45566 1.34441 6.34894 1.24974C6.24222 1.15508 6.10451 1.1028 5.96185 1.1028C5.81919 1.1028 5.68148 1.15508 5.57476 1.24974C5.46804 1.34441 5.3997 1.4749 5.38268 1.61654V2.8582C4.31239 3.16693 3.3713 3.81489 2.70101 4.70459C2.03073 5.59429 1.66752 6.67761 1.66602 7.79154V13.8249C1.67043 15.1893 2.21611 16.4962 3.18325 17.4586C4.15038 18.4211 5.45992 18.9604 6.82435 18.9582H13.2077C14.5663 18.9516 15.8673 18.4084 16.8273 17.4469C17.7872 16.4854 18.3283 15.1835 18.3327 13.8249V7.79154C18.3312 6.67761 17.968 5.59429 17.2977 4.70459C16.6274 3.81489 15.6863 3.16693 14.616 2.8582ZM5.38268 4.0832V4.7582C5.3997 4.89984 5.46804 5.03033 5.57476 5.125C5.68148 5.21966 5.81919 5.27194 5.96185 5.27194C6.10451 5.27194 6.24222 5.21966 6.34894 5.125C6.45566 5.03033 6.524 4.89984 6.54102 4.7582V3.84154C6.63268 3.84154 6.71602 3.84154 6.80768 3.84154H9.57435V4.7582C9.57435 4.91291 9.63581 5.06129 9.7452 5.17068C9.8546 5.28008 10.003 5.34154 10.1577 5.34154C10.3124 5.34154 10.4608 5.28008 10.5702 5.17068C10.6796 5.06129 10.741 4.91291 10.741 4.7582V3.81654H13.191C13.2827 3.81654 13.366 3.81654 13.4577 3.81654V4.7332C13.4747 4.87484 13.543 5.00533 13.6498 5.1C13.7565 5.19466 13.8942 5.24694 14.0368 5.24694C14.1795 5.24694 14.3172 5.19466 14.4239 5.1C14.5307 5.00533 14.599 4.87484 14.616 4.7332V4.0832C15.2709 4.33794 15.847 4.76105 16.2859 5.30977C16.7249 5.85849 17.0112 6.51336 17.116 7.2082H2.86602C2.9723 6.51152 3.26113 5.85539 3.70317 5.30651C4.1452 4.75763 4.72467 4.33556 5.38268 4.0832ZM13.191 17.7999H6.80768C5.75047 17.8021 4.73555 17.3848 3.98564 16.6396C3.23573 15.8944 2.81209 14.8821 2.80768 13.8249V8.3332H17.191V13.7915C17.1932 14.3178 17.0913 14.8394 16.8912 15.3261C16.691 15.8129 16.3966 16.2553 16.0249 16.6278C15.6531 17.0003 15.2113 17.2957 14.725 17.4968C14.2386 17.698 13.7173 17.801 13.191 17.7999ZM7.99102 11.5332C7.996 11.6776 7.95775 11.8201 7.88117 11.9426C7.80459 12.065 7.69318 12.1618 7.56122 12.2206C7.42926 12.2793 7.28277 12.2973 7.14053 12.2722C6.99828 12.2471 6.86678 12.1801 6.76287 12.0798C6.65896 11.9794 6.58738 11.8504 6.55732 11.7091C6.52726 11.5678 6.54008 11.4208 6.59415 11.2868C6.64821 11.1529 6.74104 11.0382 6.86075 10.9573C6.98046 10.8765 7.12158 10.8333 7.26602 10.8332C7.45404 10.8331 7.63476 10.906 7.77003 11.0366C7.9053 11.1672 7.98453 11.3453 7.99102 11.5332ZM10.7077 11.5332C10.7143 11.6805 10.6764 11.8264 10.5988 11.9519C10.5212 12.0773 10.4076 12.1764 10.2729 12.2363C10.1381 12.2962 9.98839 12.314 9.84331 12.2875C9.69823 12.261 9.56452 12.1914 9.45962 12.0877C9.35472 11.9841 9.28352 11.8512 9.2553 11.7064C9.22709 11.5617 9.24317 11.4118 9.30145 11.2763C9.35974 11.1409 9.45751 11.0261 9.58201 10.9471C9.70651 10.868 9.85195 10.8283 9.99935 10.8332C10.1845 10.8374 10.361 10.9122 10.4927 11.0423C10.6244 11.1725 10.7013 11.3481 10.7077 11.5332ZM13.441 11.5332C13.4443 11.6793 13.4039 11.823 13.325 11.9459C13.2461 12.0689 13.1323 12.1655 12.9981 12.2233C12.8639 12.2811 12.7156 12.2975 12.572 12.2705C12.4284 12.2434 12.2962 12.1741 12.1923 12.0714C12.0884 11.9687 12.0176 11.8373 11.9889 11.694C11.9601 11.5508 11.9748 11.4022 12.0311 11.2674C12.0874 11.1326 12.1826 11.0176 12.3047 10.9373C12.4267 10.857 12.5699 10.8149 12.716 10.8165C12.9069 10.8165 13.09 10.8918 13.2257 11.0259C13.3615 11.1601 13.4388 11.3424 13.441 11.5332ZM7.98268 14.2249C7.98159 14.319 7.96198 14.412 7.92495 14.4985C7.88793 14.585 7.83422 14.6634 7.7669 14.7292C7.69957 14.795 7.61995 14.8469 7.53258 14.8819C7.44521 14.9169 7.3518 14.9343 7.25768 14.9332C7.11595 14.9315 6.9779 14.8879 6.86097 14.8078C6.74405 14.7277 6.65351 14.6147 6.6008 14.4831C6.54809 14.3515 6.53557 14.2073 6.56484 14.0686C6.59411 13.9299 6.66385 13.803 6.76523 13.704C6.86661 13.6049 6.99509 13.5382 7.13442 13.5121C7.27375 13.4861 7.41767 13.5019 7.54798 13.5577C7.67829 13.6135 7.78914 13.7066 7.86652 13.8254C7.9439 13.9441 7.98432 14.0831 7.98268 14.2249ZM10.6993 14.2249C10.7027 14.3706 10.6625 14.514 10.5839 14.6367C10.5054 14.7595 10.3921 14.8561 10.2584 14.9141C10.1247 14.9722 9.97677 14.9891 9.83344 14.9628C9.69011 14.9364 9.55789 14.8679 9.45365 14.766C9.34942 14.6641 9.27791 14.5335 9.24823 14.3908C9.21856 14.2482 9.23208 14.0999 9.28706 13.9649C9.34204 13.8299 9.43599 13.7144 9.55692 13.633C9.67785 13.5517 9.82027 13.5082 9.96602 13.5082C10.0615 13.506 10.1565 13.5229 10.2454 13.5579C10.3343 13.5929 10.4153 13.6454 10.4836 13.7121C10.5519 13.7789 10.6062 13.8587 10.6432 13.9467C10.6803 14.0348 10.6994 14.1293 10.6993 14.2249ZM13.4327 14.2249C13.436 14.3706 13.3958 14.514 13.3173 14.6367C13.2387 14.7595 13.1254 14.8561 12.9917 14.9141C12.8581 14.9722 12.7101 14.9891 12.5668 14.9628C12.4234 14.9364 12.2912 14.8679 12.187 14.766C12.0828 14.6641 12.0112 14.5335 11.9816 14.3908C11.9519 14.2482 11.9654 14.0999 12.0204 13.9649C12.0754 13.8299 12.1693 13.7144 12.2903 13.633C12.4112 13.5517 12.5536 13.5082 12.6993 13.5082C12.7949 13.506 12.8898 13.5229 12.9787 13.5579C13.0676 13.5929 13.1486 13.6454 13.2169 13.7121C13.2852 13.7789 13.3395 13.8587 13.3766 13.9467C13.4136 14.0348 13.4327 14.1293 13.4327 14.2249Z",
                fill: "#99A1B7"
            })
        }),
        calendar_check: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "20",
            height: "21",
            viewBox: "0 0 20 21",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: className,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    clipPath: "url(#clip0_504_27474)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M6.75 1.5C7.16421 1.5 7.5 1.83579 7.5 2.25V3.5H12.5V2.25C12.5 1.83579 12.8358 1.5 13.25 1.5C13.6642 1.5 14 1.83579 14 2.25V3.5H16.25C17.7688 3.5 19 4.73122 19 6.25V9.25C19 9.66421 18.6642 10 18.25 10H2.5V16.75C2.5 17.4404 3.05964 18 3.75 18H8.75C9.16421 18 9.5 18.3358 9.5 18.75C9.5 19.1642 9.16421 19.5 8.75 19.5H3.75C2.23122 19.5 1 18.2688 1 16.75V6.25C1 4.73122 2.23122 3.5 3.75 3.5H6V2.25C6 1.83579 6.33579 1.5 6.75 1.5ZM6 5H3.75C3.05964 5 2.5 5.55964 2.5 6.25V8.5H17.5V6.25C17.5 5.55964 16.9404 5 16.25 5H14V5.75C14 6.16421 13.6642 6.5 13.25 6.5C12.8358 6.5 12.5 6.16421 12.5 5.75V5H7.5V5.75C7.5 6.16421 7.16421 6.5 6.75 6.5C6.33579 6.5 6 6.16421 6 5.75V5ZM19.765 13.7047C20.0661 13.9891 20.0797 14.4638 19.7953 14.765L15.5453 19.265C15.4014 19.4173 15.2005 19.5025 14.991 19.4999C14.7815 19.4974 14.5827 19.4074 14.4425 19.2517L12.1925 16.7517C11.9154 16.4438 11.9404 15.9696 12.2483 15.6925C12.5562 15.4154 13.0304 15.4404 13.3075 15.7483L15.0133 17.6436L18.7047 13.735C18.9891 13.4339 19.4638 13.4203 19.765 13.7047Z",
                        className: "fill-[#07AF17]"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_504_27474",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "20",
                            height: "20",
                            fill: "white",
                            transform: "translate(0 0.5)"
                        })
                    })
                })
            ]
        }),
        book_open: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "20",
            height: "21",
            viewBox: "0 0 20 21",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: className,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.36051 4.11971C6.37671 3.95978 5.3735 3.95977 4.38969 4.11969C4.04645 4.17549 3.70164 4.2585 2.93716 4.44368C2.81469 4.47335 2.74354 4.49072 2.69032 4.50583C2.6569 4.51532 2.64293 4.52058 2.6395 4.52196C2.6395 4.52196 2.6395 4.52196 2.6395 4.52196C2.57147 4.55542 2.52252 4.61776 2.50609 4.69125C2.50556 4.69493 2.50375 4.7097 2.5024 4.74419C2.50024 4.79939 2.50011 4.87254 2.50011 4.99846V16.3196C2.50011 16.4083 2.50015 16.4626 2.50105 16.5033C2.50163 16.5294 2.50244 16.541 2.50265 16.5437C2.52153 16.6749 2.64055 16.7691 2.7739 16.7564C2.7766 16.7559 2.78803 16.754 2.81375 16.7484C2.85362 16.7397 2.90644 16.7269 2.99264 16.706L3.00819 16.7023C3.34117 16.6216 3.52697 16.5766 3.71304 16.5384C5.13954 16.2457 6.61067 16.2457 8.03717 16.5384C8.22321 16.5766 8.40898 16.6216 8.74185 16.7022L9.25011 16.8253V4.54958L8.81305 4.44371C8.04857 4.25852 7.70375 4.1755 7.36051 4.11971ZM10.7501 4.54959V16.8253L11.2582 16.7023C11.5912 16.6216 11.777 16.5766 11.963 16.5384C13.3895 16.2457 14.8607 16.2457 16.2872 16.5384C16.4732 16.5766 16.659 16.6216 16.992 16.7023L17.0076 16.706C17.0938 16.7269 17.1466 16.7397 17.1865 16.7484C17.2256 16.757 17.2317 16.757 17.2242 16.7562C17.3584 16.7701 17.4786 16.6756 17.4976 16.5437C17.4978 16.541 17.4986 16.5294 17.4992 16.5033C17.5001 16.4626 17.5001 16.4083 17.5001 16.3196V4.99852C17.5001 4.87258 17.5 4.79943 17.4978 4.74423C17.4965 4.70973 17.4947 4.69496 17.4941 4.69129C17.4777 4.61779 17.4287 4.55545 17.3607 4.522C17.3573 4.52062 17.3433 4.51536 17.3099 4.50587C17.2567 4.49075 17.1855 4.47338 17.063 4.44372C16.2985 4.25853 15.9537 4.17551 15.6104 4.11972C14.6267 3.95981 13.6235 3.95981 12.6398 4.11972C12.2965 4.17551 11.9517 4.25853 11.1872 4.44372L10.7501 4.54959ZM4.14902 2.63913C5.29223 2.45329 6.45799 2.4533 7.6012 2.63914C8.00774 2.70523 8.41052 2.80281 9.13225 2.97765L9.80168 3.13981C9.87479 3.15752 9.91513 3.16723 9.94602 3.17381C9.97272 3.17949 9.97804 3.17967 9.97581 3.17945C9.99197 3.18102 10.0082 3.18102 10.0244 3.17945C10.0222 3.17967 10.0275 3.17949 10.0542 3.17381C10.0851 3.16723 10.1254 3.15752 10.1985 3.13982L10.868 2.97765C11.5897 2.80281 11.9925 2.70524 12.3991 2.63915C13.5423 2.45333 14.708 2.45333 15.8511 2.63915C16.2577 2.70524 16.6605 2.80281 17.3822 2.97765L17.4162 2.98588C17.4319 2.98969 17.4478 2.9935 17.4637 2.99732C17.6482 3.0417 17.8425 3.08844 18.0149 3.17215C18.4972 3.4064 18.8457 3.84888 18.9599 4.37292C19.0008 4.5602 19.0005 4.76011 19.0002 4.94971C19.0001 4.96606 19.0001 4.98234 19.0001 4.99852V16.3196C19.0001 16.3317 19.0001 16.3438 19.0001 16.3559C19.0003 16.4884 19.0004 16.6238 18.9843 16.7426C18.8576 17.6797 18.0092 18.3457 17.0693 18.2482C16.9501 18.2358 16.8185 18.2038 16.6896 18.1724C16.6779 18.1696 16.6661 18.1667 16.6544 18.1639C16.3018 18.0784 16.1428 18.04 15.9857 18.0078C14.7581 17.7559 13.4921 17.7559 12.2645 18.0078C12.1074 18.04 11.9484 18.0784 11.5958 18.1639L10.5517 18.4168C10.5427 18.4189 10.5337 18.4211 10.5246 18.4233C10.4134 18.4504 10.2943 18.4794 10.1697 18.4915C10.0569 18.5025 9.9433 18.5025 9.83048 18.4915C9.70589 18.4794 9.5868 18.4504 9.47557 18.4233C9.4665 18.4211 9.45749 18.4189 9.44854 18.4168L8.40443 18.1639C8.05182 18.0784 7.89278 18.04 7.7357 18.0078C6.50811 17.7559 5.2421 17.7559 4.01452 18.0078C3.85743 18.04 3.6984 18.0784 3.34578 18.1639C3.33408 18.1667 3.32234 18.1696 3.31058 18.1724C3.18171 18.2038 3.05015 18.2358 2.93091 18.2482C1.991 18.3457 1.14259 17.6797 1.01588 16.7426C0.999808 16.6238 0.999947 16.4883 1.00008 16.3559C1.00009 16.3438 1.00011 16.3317 1.00011 16.3196V4.99846C1.00011 4.98228 1.00008 4.966 1.00005 4.94965C0.999745 4.76006 0.999419 4.56018 1.04026 4.3729C1.15455 3.84885 1.50299 3.40636 1.98536 3.17211C2.15773 3.0884 2.35205 3.04166 2.53655 2.99729C2.55245 2.99346 2.56828 2.98965 2.58402 2.98584L2.61796 2.97762C3.3397 2.80278 3.74248 2.70521 4.14902 2.63913Z",
                className: "fill-[#025EFF]"
            })
        }),
        calendar_busy: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "20",
            height: "21",
            viewBox: "0 0 20 21",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: className,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.75 1.5C7.16421 1.5 7.5 1.83579 7.5 2.25V3.5H12.5V2.25C12.5 1.83579 12.8358 1.5 13.25 1.5C13.6642 1.5 14 1.83579 14 2.25V3.5H16.25C17.7688 3.5 19 4.73122 19 6.25V9.25C19 9.66421 18.6642 10 18.25 10H2.5V16.75C2.5 17.4404 3.05964 18 3.75 18H8.75C9.16421 18 9.5 18.3358 9.5 18.75C9.5 19.1642 9.16421 19.5 8.75 19.5H3.75C2.23122 19.5 1 18.2688 1 16.75V6.25C1 4.73122 2.23122 3.5 3.75 3.5H6V2.25C6 1.83579 6.33579 1.5 6.75 1.5ZM6 5H3.75C3.05964 5 2.5 5.55964 2.5 6.25V8.5H17.5V6.25C17.5 5.55964 16.9404 5 16.25 5H14V5.75C14 6.16421 13.6642 6.5 13.25 6.5C12.8358 6.5 12.5 6.16421 12.5 5.75V5H7.5V5.75C7.5 6.16421 7.16421 6.5 6.75 6.5C6.33579 6.5 6 6.16421 6 5.75V5ZM12 16.25C12 15.8358 12.3358 15.5 12.75 15.5H19.25C19.6642 15.5 20 15.8358 20 16.25C20 16.6642 19.6642 17 19.25 17H12.75C12.3358 17 12 16.6642 12 16.25Z",
                className: "fill-[#D20306]"
            })
        }),
        start_outline: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "20",
            height: "21",
            viewBox: "0 0 20 21",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: className,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.0928 3.02324C9.99905 2.97488 9.86181 3.00026 9.79335 3.14522L8.00799 6.92557C7.76215 7.44613 7.27807 7.82297 6.69953 7.91082L2.70736 8.51703C2.66367 8.52366 2.61758 8.54593 2.57857 8.58775C2.47149 8.70255 2.47467 8.89827 2.58316 9.00878L5.47192 11.9514C5.87611 12.3631 6.05323 12.9463 5.96057 13.5109L5.27863 17.6659C5.2674 17.7343 5.27853 17.8035 5.30766 17.8614C5.3787 18.0027 5.51526 18.0255 5.60897 17.974L9.17967 16.0123C9.69201 15.7308 10.3079 15.7308 10.8202 16.0123L14.3909 17.974C14.434 17.9977 14.48 18.0045 14.5234 17.9967C14.5864 17.9854 14.6553 17.9449 14.7056 17.8752C14.754 17.8081 14.7706 17.7347 14.7603 17.6681L14.0393 13.5109C13.9466 12.9463 14.1238 12.3631 14.5279 11.9514L17.4167 9.00878C17.4568 8.96792 17.4872 8.90957 17.4968 8.84084C17.5227 8.65465 17.3972 8.53293 17.2925 8.51703L13.3003 7.91082C12.7218 7.82297 12.2377 7.44613 11.9919 6.92557L10.2065 3.14522C10.1788 3.08657 10.1367 3.04586 10.0928 3.02324ZM8.437 2.50466C8.85086 1.62835 9.89685 1.23443 10.7804 1.6901C11.1257 1.86818 11.3985 2.15664 11.5629 2.50466L13.3482 6.28501C13.3898 6.37307 13.4613 6.41807 13.5255 6.42782L17.5177 7.03403C18.4915 7.1819 19.1133 8.10658 18.9825 9.04743C18.9296 9.42748 18.7578 9.78392 18.4871 10.0596L15.5984 13.0022C15.5379 13.0637 15.5029 13.162 15.5191 13.2656L16.2401 17.4229C16.4008 18.402 15.7151 19.307 14.788 19.4732C14.4037 19.542 14.0097 19.476 13.6686 19.2887L10.0979 17.3269C10.0354 17.2926 9.96447 17.2926 9.90194 17.3269L6.33123 19.2887C5.46031 19.7671 4.40376 19.4024 3.96767 18.5356C3.79485 18.192 3.7363 17.8015 3.79843 17.4229L4.48038 13.2679C4.49751 13.1635 4.4624 13.0642 4.40151 13.0022L1.51275 10.0596C0.840839 9.37517 0.828048 8.26534 1.48168 7.5646C1.74558 7.28168 2.09641 7.09261 2.48217 7.03403L6.47434 6.42782C6.53853 6.41807 6.61006 6.37307 6.65165 6.28501L8.437 2.50466Z",
                className: "fill-[#F57C00]"
            })
        }),
        plus: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M12 7.19995L12 16.8M16.8 12L7.2 12",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                }),
                ","
            ]
        }),
        locksection: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M12.2857 7.16699H3.71429C2.76751 7.16699 2 7.91317 2 8.83364V13.8336C2 14.754 2.76751 15.5002 3.71429 15.5002H12.2857C13.2325 15.5002 14 14.754 14 13.8336V8.83364C14 7.91317 13.2325 7.16699 12.2857 7.16699Z",
                    stroke: "#A1A1A1",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M8.00021 12.1666C8.4736 12.1666 8.85735 11.7936 8.85735 11.3333C8.85735 10.8731 8.4736 10.5 8.00021 10.5C7.52682 10.5 7.14307 10.8731 7.14307 11.3333C7.14307 11.7936 7.52682 12.1666 8.00021 12.1666Z",
                    stroke: "#A1A1A1",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M4.57153 7.16658V3.83329C4.57153 2.94925 4.93276 2.10141 5.57574 1.4763C6.21872 0.851185 7.09079 0.5 8.0001 0.5C8.90942 0.5 9.78149 0.851185 10.4245 1.4763C11.0675 2.10141 11.4287 2.94925 11.4287 3.83329V7.16658",
                    stroke: "#A1A1A1",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        }),
        calendar: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: className,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.09995 1.19995C8.59701 1.19995 8.99995 1.60289 8.99995 2.09995V3.59995H15V2.09995C15 1.60289 15.4029 1.19995 15.9 1.19995C16.397 1.19995 16.8 1.60289 16.8 2.09995V3.59995H19.5C21.3225 3.59995 22.7999 5.07741 22.7999 6.89995V19.5C22.7999 21.3225 21.3225 22.7999 19.5 22.7999H4.49995C2.67741 22.7999 1.19995 21.3225 1.19995 19.5V6.89995C1.19995 5.07741 2.67741 3.59995 4.49995 3.59995H7.19995V2.09995C7.19995 1.60289 7.60289 1.19995 8.09995 1.19995ZM7.19995 5.39995H4.49995C3.67152 5.39995 2.99995 6.07152 2.99995 6.89995V9.59995H21V6.89995C21 6.07152 20.3284 5.39995 19.5 5.39995H16.8V6.29995C16.8 6.79701 16.397 7.19995 15.9 7.19995C15.4029 7.19995 15 6.79701 15 6.29995V5.39995H8.99995V6.29995C8.99995 6.79701 8.59701 7.19995 8.09995 7.19995C7.60289 7.19995 7.19995 6.79701 7.19995 6.29995V5.39995ZM21 11.4H2.99995V19.5C2.99995 20.3284 3.67152 21 4.49995 21H19.5C20.3284 21 21 20.3284 21 19.5V11.4Z",
                className: "fill-bw-14"
            })
        }),
        calendarStudent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "24",
            height: "25",
            viewBox: "0 0 24 25",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M1.5 21.4639C1.5 21.7622 1.61853 22.0484 1.8295 22.2594C2.04048 22.4703 2.32663 22.5889 2.625 22.5889H21.375C21.6734 22.5889 21.9595 22.4703 22.1705 22.2594C22.3815 22.0484 22.5 21.7622 22.5 21.4639V8.33887H1.5V21.4639ZM16.5 10.0264C16.5 9.97664 16.5198 9.92895 16.5549 9.89378C16.5901 9.85862 16.6378 9.83887 16.6875 9.83887H18.5625C18.6122 9.83887 18.6599 9.85862 18.6951 9.89378C18.7302 9.92895 18.75 9.97664 18.75 10.0264V11.9014C18.75 11.9511 18.7302 11.9988 18.6951 12.0339C18.6599 12.0691 18.6122 12.0889 18.5625 12.0889H16.6875C16.6378 12.0889 16.5901 12.0691 16.5549 12.0339C16.5198 11.9988 16.5 11.9511 16.5 11.9014V10.0264ZM16.5 13.7764C16.5 13.7266 16.5198 13.6789 16.5549 13.6438C16.5901 13.6086 16.6378 13.5889 16.6875 13.5889H18.5625C18.6122 13.5889 18.6599 13.6086 18.6951 13.6438C18.7302 13.6789 18.75 13.7266 18.75 13.7764V15.6514C18.75 15.7011 18.7302 15.7488 18.6951 15.7839C18.6599 15.8191 18.6122 15.8389 18.5625 15.8389H16.6875C16.6378 15.8389 16.5901 15.8191 16.5549 15.7839C16.5198 15.7488 16.5 15.7011 16.5 15.6514V13.7764ZM12.75 10.0264C12.75 9.97664 12.7698 9.92895 12.8049 9.89378C12.8401 9.85862 12.8878 9.83887 12.9375 9.83887H14.8125C14.8622 9.83887 14.9099 9.85862 14.9451 9.89378C14.9802 9.92895 15 9.97664 15 10.0264V11.9014C15 11.9511 14.9802 11.9988 14.9451 12.0339C14.9099 12.0691 14.8622 12.0889 14.8125 12.0889H12.9375C12.8878 12.0889 12.8401 12.0691 12.8049 12.0339C12.7698 11.9988 12.75 11.9511 12.75 11.9014V10.0264ZM12.75 13.7764C12.75 13.7266 12.7698 13.6789 12.8049 13.6438C12.8401 13.6086 12.8878 13.5889 12.9375 13.5889H14.8125C14.8622 13.5889 14.9099 13.6086 14.9451 13.6438C14.9802 13.6789 15 13.7266 15 13.7764V15.6514C15 15.7011 14.9802 15.7488 14.9451 15.7839C14.9099 15.8191 14.8622 15.8389 14.8125 15.8389H12.9375C12.8878 15.8389 12.8401 15.8191 12.8049 15.7839C12.7698 15.7488 12.75 15.7011 12.75 15.6514V13.7764ZM12.75 17.5264C12.75 17.4766 12.7698 17.4289 12.8049 17.3938C12.8401 17.3586 12.8878 17.3389 12.9375 17.3389H14.8125C14.8622 17.3389 14.9099 17.3586 14.9451 17.3938C14.9802 17.4289 15 17.4766 15 17.5264V19.4014C15 19.4511 14.9802 19.4988 14.9451 19.5339C14.9099 19.5691 14.8622 19.5889 14.8125 19.5889H12.9375C12.8878 19.5889 12.8401 19.5691 12.8049 19.5339C12.7698 19.4988 12.75 19.4511 12.75 19.4014V17.5264ZM9 13.7764C9 13.7266 9.01975 13.6789 9.05492 13.6438C9.09008 13.6086 9.13777 13.5889 9.1875 13.5889H11.0625C11.1122 13.5889 11.1599 13.6086 11.1951 13.6438C11.2302 13.6789 11.25 13.7266 11.25 13.7764V15.6514C11.25 15.7011 11.2302 15.7488 11.1951 15.7839C11.1599 15.8191 11.1122 15.8389 11.0625 15.8389H9.1875C9.13777 15.8389 9.09008 15.8191 9.05492 15.7839C9.01975 15.7488 9 15.7011 9 15.6514V13.7764ZM9 17.5264C9 17.4766 9.01975 17.4289 9.05492 17.3938C9.09008 17.3586 9.13777 17.3389 9.1875 17.3389H11.0625C11.1122 17.3389 11.1599 17.3586 11.1951 17.3938C11.2302 17.4289 11.25 17.4766 11.25 17.5264V19.4014C11.25 19.4511 11.2302 19.4988 11.1951 19.5339C11.1599 19.5691 11.1122 19.5889 11.0625 19.5889H9.1875C9.13777 19.5889 9.09008 19.5691 9.05492 19.5339C9.01975 19.4988 9 19.4511 9 19.4014V17.5264ZM5.25 13.7764C5.25 13.7266 5.26975 13.6789 5.30492 13.6438C5.34008 13.6086 5.38777 13.5889 5.4375 13.5889H7.3125C7.36223 13.5889 7.40992 13.6086 7.44508 13.6438C7.48025 13.6789 7.5 13.7266 7.5 13.7764V15.6514C7.5 15.7011 7.48025 15.7488 7.44508 15.7839C7.40992 15.8191 7.36223 15.8389 7.3125 15.8389H5.4375C5.38777 15.8389 5.34008 15.8191 5.30492 15.7839C5.26975 15.7488 5.25 15.7011 5.25 15.6514V13.7764ZM5.25 17.5264C5.25 17.4766 5.26975 17.4289 5.30492 17.3938C5.34008 17.3586 5.38777 17.3389 5.4375 17.3389H7.3125C7.36223 17.3389 7.40992 17.3586 7.44508 17.3938C7.48025 17.4289 7.5 17.4766 7.5 17.5264V19.4014C7.5 19.4511 7.48025 19.4988 7.44508 19.5339C7.40992 19.5691 7.36223 19.5889 7.3125 19.5889H5.4375C5.38777 19.5889 5.34008 19.5691 5.30492 19.5339C5.26975 19.4988 5.25 19.4511 5.25 19.4014V17.5264Z",
                    fill: "#FFB800"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M21.375 3.08887H18.7537V1.58887H16.5037V3.08887H7.49625V1.58887H5.24625V3.08887H2.625C2.47783 3.08763 2.33186 3.11553 2.19551 3.17095C2.05917 3.22637 1.93514 3.30823 1.83057 3.4118C1.72599 3.51537 1.64295 3.63861 1.58622 3.77441C1.52948 3.91022 1.50018 4.05591 1.5 4.20309V6.83887H22.5V4.20309C22.4998 4.05591 22.4705 3.91022 22.4138 3.77441C22.357 3.63861 22.274 3.51537 22.1694 3.4118C22.0649 3.30823 21.9408 3.22637 21.8045 3.17095C21.6681 3.11553 21.5222 3.08763 21.375 3.08887Z",
                    fill: "#FFB800"
                })
            ]
        }),
        arrowUp: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.0002 6.7996C12.1318 6.7989 12.2623 6.8241 12.3841 6.8738C12.5059 6.9236 12.6167 6.9969 12.7102 7.0896L18.7102 13.0896C18.8034 13.1829 18.8774 13.2935 18.9278 13.4154C18.9783 13.5372 19.0043 13.6678 19.0043 13.7996C19.0043 14.0659 18.8985 14.3213 18.7102 14.5096C18.5219 14.6979 18.2665 14.8037 18.0002 14.8037C17.7339 14.8037 17.4785 14.6979 17.2902 14.5096L12.0002 9.2196L6.71019 14.5096C6.61695 14.6029 6.5063 14.6768 6.38444 14.7273C6.26258 14.7777 6.13203 14.8037 6.00019 14.8037C5.86835 14.8037 5.7378 14.7777 5.61594 14.7273C5.49408 14.6768 5.38343 14.6029 5.29019 14.5096C5.19695 14.4164 5.12299 14.3057 5.07253 14.1839C5.02207 14.062 4.99609 13.9315 4.99609 13.7996C4.99609 13.6678 5.02207 13.5372 5.07253 13.4154C5.12299 13.2935 5.19695 13.1829 5.29019 13.0896L11.2902 7.0896C11.3836 6.9969 11.4944 6.9236 11.6163 6.8738C11.7381 6.8241 11.8686 6.7989 12.0002 6.7996Z",
                fill: "#A1A1A1"
            })
        }),
        arrowDown: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.0002 17.1999C11.8686 17.2007 11.7381 17.1754 11.6163 17.1257C11.4944 17.0759 11.3836 17.0026 11.2902 16.9099L5.29019 10.9099C5.19695 10.8167 5.12299 10.706 5.07253 10.5841C5.02207 10.4623 4.99609 10.3318 4.99609 10.1999C4.99609 9.93359 5.10188 9.6782 5.29019 9.48989C5.47849 9.30159 5.73388 9.1958 6.00019 9.1958C6.26649 9.1958 6.52188 9.30159 6.71019 9.48989L12.0002 14.7799L17.2902 9.48989C17.3834 9.39665 17.4941 9.32269 17.6159 9.27223C17.7378 9.22177 17.8683 9.1958 18.0002 9.1958C18.132 9.1958 18.2626 9.22177 18.3844 9.27223C18.5063 9.32269 18.6169 9.39665 18.7102 9.48989C18.8034 9.58313 18.8774 9.69382 18.9278 9.81564C18.9783 9.93747 19.0043 10.068 19.0043 10.1999C19.0043 10.3318 18.9783 10.4623 18.9278 10.5841C18.8774 10.706 18.8034 10.8167 18.7102 10.9099L12.7102 16.9099C12.6167 17.0026 12.5059 17.0759 12.3841 17.1257C12.2623 17.1754 12.1318 17.2007 12.0002 17.1999Z",
                fill: "#A1A1A1"
            })
        }),
        arrowDownFull: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "10",
            height: "8",
            viewBox: "0 0 10 8",
            fill: "currentColor",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M5 8C4.60655 8 4.23607 7.80241 4 7.46667L0.250007 2.13333C-0.0340716 1.72931 -0.0797668 1.18876 0.131973 0.737049C0.343713 0.285337 0.776541 0 1.25001 0H8.74999C9.22346 0 9.65629 0.285337 9.86803 0.737049C10.0798 1.18876 10.0341 1.72931 9.74999 2.13333L6 7.46667C5.76393 7.80241 5.39345 8 5 8Z",
                fill: "#FFB800"
            })
        }),
        arrowRightFull: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "8",
            height: "10",
            viewBox: "0 0 8 10",
            fill: "currentColor",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0.737049 0.131973C1.18876 -0.0797666 1.72931 -0.0340718 2.13333 0.250007L7.46667 4C7.80241 4.23607 8 4.60655 8 5C8 5.39345 7.80241 5.76393 7.46667 6L2.13333 9.74999C1.72931 10.0341 1.18876 10.0798 0.737049 9.86803C0.285336 9.65629 0 9.22346 0 8.74999V1.25001C0 0.776541 0.285336 0.343713 0.737049 0.131973Z",
                fill: "#A1A1A1"
            })
        }),
        warningIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    opacity: "0.2",
                    d: "M8.00016 14.6663C11.6821 14.6663 14.6668 11.6816 14.6668 7.99967C14.6668 4.31778 11.6821 1.33301 8.00016 1.33301C4.31826 1.33301 1.3335 4.31778 1.3335 7.99967C1.3335 11.6816 4.31826 14.6663 8.00016 14.6663Z",
                    fill: "#F01919"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M8.00016 7.06641C8.17697 7.06641 8.34654 7.13664 8.47157 7.26167C8.59659 7.38669 8.66683 7.55626 8.66683 7.73307V10.8397C8.66683 11.0166 8.59659 11.1861 8.47157 11.3111C8.34654 11.4362 8.17697 11.5064 8.00016 11.5064C7.82335 11.5064 7.65378 11.4362 7.52876 11.3111C7.40373 11.1861 7.3335 11.0166 7.3335 10.8397V7.73307C7.3335 7.55626 7.40373 7.38669 7.52876 7.26167C7.65378 7.13664 7.82335 7.06641 8.00016 7.06641Z",
                    fill: "#F01919"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M8.00033 6.15983C8.46056 6.15983 8.83366 5.78673 8.83366 5.3265C8.83366 4.86626 8.46056 4.49316 8.00033 4.49316C7.54009 4.49316 7.16699 4.86626 7.16699 5.3265C7.16699 5.78673 7.54009 6.15983 8.00033 6.15983Z",
                    fill: "#F01919"
                })
            ]
        })
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: SAPP_ICONS[icon]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SappIcon);


/***/ }),

/***/ 15964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ SappTitleSolution; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);


var SappTitleSolution = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "text-base font-semibold text-bw-1 ",
        children: title
    });
};


/***/ }),

/***/ 45028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports DEFAULT_TOOLTIP_BG_COLOR, DEFAULT_TOOLTIP_COLOR */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73898);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93740);


var DEFAULT_TOOLTIP_BG_COLOR = "#ffffff";
var DEFAULT_TOOLTIP_COLOR = "#000000";
var Tooltip = function(param) {
    var _showTooltip = param.showTooltip, showTooltip = _showTooltip === void 0 ? true : _showTooltip, children = param.children, _color = param.color, color = _color === void 0 ? DEFAULT_TOOLTIP_BG_COLOR : _color, title = param.title, className = param.className, _placement = param.placement, placement = _placement === void 0 ? "top" : _placement, arrow = param.arrow;
    if (!showTooltip) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: className,
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
        theme: {
            token: {
                colorTextLightSolid: DEFAULT_TOOLTIP_COLOR,
                colorText: DEFAULT_TOOLTIP_COLOR
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            title: title,
            color: color,
            placement: placement,
            className: className,
            arrow: arrow,
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Tooltip);


/***/ }),

/***/ 63721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var src_redux_hook__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34705);
/* harmony import */ var _button_ButtonPrimary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15421);
/* harmony import */ var src_redux_slice_ConfirmDialog_ConfirmDialogThunk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55771);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82684);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57368);
/* harmony import */ var _button_ButtonSecondary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29798);
/* harmony import */ var _assets_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34648);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42339);









var SappDrawer = function(param) {
    var children = param.children, isOpen = param.isOpen, onClose = param.onClose, title = param.title, message = param.message, _footer = param.footer, footer = _footer === void 0 ? true : _footer, widthDrawer = param.widthDrawer, _btnSubmitTile = param.btnSubmitTile, btnSubmitTile = _btnSubmitTile === void 0 ? "Next Lesson" : _btnSubmitTile, _btnCancelTitle = param.btnCancelTitle, btnCancelTitle = _btnCancelTitle === void 0 ? "Cancel" : _btnCancelTitle, _handleSubmit = param.handleSubmit, handleSubmit = _handleSubmit === void 0 ? function() {} : _handleSubmit, _drawerSubId = param.drawerSubId, drawerSubId = _drawerSubId === void 0 ? "" : _drawerSubId, _confirmOnClose = param.confirmOnClose, confirmOnClose = _confirmOnClose === void 0 ? true : _confirmOnClose, _showSubmitButton = param.showSubmitButton, showSubmitButton = _showSubmitButton === void 0 ? true : _showSubmitButton, _showCancelButton = param.showCancelButton, showCancelButton = _showCancelButton === void 0 ? true : _showCancelButton, _heightBody = param.heightBody, heightBody = _heightBody === void 0 ? "h-[calc(100vh-80px)]" : _heightBody, _sizeTextBtn = param.sizeTextBtn, sizeTextBtn = _sizeTextBtn === void 0 ? "lager" : _sizeTextBtn, _footerClassName = param.footerClassName, footerClassName = _footerClassName === void 0 ? "" : _footerClassName, _loading = param.loading, loading = _loading === void 0 ? false : _loading, headerClassName = param.headerClassName, cancelButtonClassName = param.cancelButtonClassName, submitButtonClassName = param.submitButtonClassName, _handleClickCancelButton = param.handleClickCancelButton, handleClickCancelButton = _handleClickCancelButton === void 0 ? function() {} : _handleClickCancelButton, _isSecondaryCancelButton = param.isSecondaryCancelButton, isSecondaryCancelButton = _isSecondaryCancelButton === void 0 ? true : _isSecondaryCancelButton;
    var dispatch = (0,src_redux_hook__WEBPACK_IMPORTED_MODULE_1__/* .useAppDispatch */ .T)();
    var handleOnClose = function() {
        if (confirmOnClose) {
            dispatch(src_redux_slice_ConfirmDialog_ConfirmDialogThunk__WEBPACK_IMPORTED_MODULE_3__/* ["default"].open */ .Z.open({
                message: message,
                onConfirm: onClose
            }));
        } else {
            onClose();
        }
    };
    var handleMaskClick = function(e) {
        var ref;
        if (isOpen && (e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.closest(".custom-drawer")) === null) {
            handleOnClose();
        }
    };
    var drawerRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var drawerElement = drawerRef.current;
        if (drawerElement) {
            var hasScrollBar = drawerElement.scrollHeight > drawerElement.clientHeight;
            drawerElement.classList.toggle("px-8", !hasScrollBar);
            drawerElement.classList.toggle("pl-8", hasScrollBar);
            drawerElement.classList.toggle("pr-6", hasScrollBar);
        }
    }, [
        drawerSubId,
        heightBody,
        drawerRef,
        children
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (isOpen) {
            document.body.classList.add("overflow-y-hidden");
        } else {
            document.body.classList.remove("overflow-y-hidden");
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fixed left-0 top-0 z-[999999] h-full w-full bg-bw-5 bg-opacity-50",
                onClick: handleMaskClick
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "fixed right-0 top-0 z-[999999] h-full transform bg-white ".concat(widthDrawer !== null && widthDrawer !== void 0 ? widthDrawer : "w-screen lg:w-1/2", " ").concat(isOpen ? "translate-x-0" : "translate-x-full", " h-screen transition-transform duration-300\n        ease-in-out"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col justify-between",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("w-100 relative flex min-h-[80px] items-center justify-between border-b bg-transparent px-8 py-2 text-2xl font-medium text-white", headerClassName),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "line-clamp-3 pr-4 text-heading",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "shrink-0 cursor-pointer",
                                    onClick: handleOnClose,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_icons__WEBPACK_IMPORTED_MODULE_6__/* .CloseIcon */ .Tw, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        ref: drawerRef,
                        className: "mt-6 overflow-y-auto px-8 ".concat(heightBody),
                        id: "sapp-drawer".concat(drawerSubId),
                        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex h-full w-full items-center justify-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                tip: "Loading",
                                size: "large",
                                className: "!text-accent-warning"
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "",
                            children: children
                        })
                    }),
                    footer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("absolute bottom-0 left-0 right-0 flex h-[66px] w-full items-center justify-end border-t border-default bg-white", footerClassName),
                        children: [
                            showCancelButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_ButtonSecondary__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                isSecondaryButton: isSecondaryCancelButton,
                                title: btnCancelTitle,
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("me-[32px] rounded-md", cancelButtonClassName),
                                onClick: function(e) {
                                    handleMaskClick(e);
                                    handleClickCancelButton();
                                },
                                size: sizeTextBtn
                            }),
                            showSubmitButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_ButtonPrimary__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                title: btnSubmitTile,
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("me-[32px] rounded-md", submitButtonClassName),
                                childClass: "px-7",
                                onClick: handleSubmit,
                                size: sizeTextBtn
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SappDrawer);


/***/ }),

/***/ 9290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12691);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34376);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_common_Tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45028);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43743);





var SappBreadcrumbNotLink = function(param) {
    var paths = param.paths, _isTeacher = param.isTeacher, isTeacher = _isTeacher === void 0 ? false : _isTeacher;
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref1;
    var getCourseId = (ref1 = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.courseId) !== null && ref1 !== void 0 ? ref1 : router.query.id;
    var isShortCourse = router.pathname.startsWith(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .PageLink.SHORT_COURSE */ .H_.SHORT_COURSE);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: paths.map(function(path, index) {
            var url = "";
            if (isShortCourse) {
                url = "".concat(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .PageLink.SHORT_COURSE */ .H_.SHORT_COURSE, "/detail/").concat(getCourseId, "/activity/").concat(path === null || path === void 0 ? void 0 : path.id);
            } else {
                switch(path.type){
                    case "PART":
                        url = "".concat(isTeacher ? src_constants__WEBPACK_IMPORTED_MODULE_4__/* .PageLink.TEACHER_MY_COURSE */ .H_.TEACHER_MY_COURSE : src_constants__WEBPACK_IMPORTED_MODULE_4__/* .PageLink.COURSES */ .H_.COURSES, "/").concat(getCourseId, "/section/").concat(path === null || path === void 0 ? void 0 : path.id);
                        break;
                    case "CHAPTER":
                        var ref;
                        url = "".concat(isTeacher ? src_constants__WEBPACK_IMPORTED_MODULE_4__/* .PageLink.TEACHER_MY_COURSE */ .H_.TEACHER_MY_COURSE : src_constants__WEBPACK_IMPORTED_MODULE_4__/* .PageLink.COURSES */ .H_.COURSES, "/").concat(getCourseId, "/section/").concat(paths === null || paths === void 0 ? void 0 : (ref = paths[0]) === null || ref === void 0 ? void 0 : ref.id, "?unit_id=").concat(path === null || path === void 0 ? void 0 : path.id);
                        break;
                    case "UNIT":
                        var ref1;
                        url = "".concat(isTeacher ? src_constants__WEBPACK_IMPORTED_MODULE_4__/* .PageLink.TEACHER_MY_COURSE */ .H_.TEACHER_MY_COURSE : src_constants__WEBPACK_IMPORTED_MODULE_4__/* .PageLink.COURSES */ .H_.COURSES, "/").concat(getCourseId, "/section/").concat(paths === null || paths === void 0 ? void 0 : (ref1 = paths[0]) === null || ref1 === void 0 ? void 0 : ref1.id, "?unit_id=").concat(paths === null || paths === void 0 ? void 0 : paths[1].id);
                        break;
                    case "ACTIVITY":
                        var ref2;
                        url = "".concat(isTeacher ? src_constants__WEBPACK_IMPORTED_MODULE_4__/* .PageLink.TEACHER_MY_COURSE */ .H_.TEACHER_MY_COURSE : src_constants__WEBPACK_IMPORTED_MODULE_4__/* .PageLink.COURSES */ .H_.COURSES, "/").concat(getCourseId, "/section/").concat(paths === null || paths === void 0 ? void 0 : (ref2 = paths[0]) === null || ref2 === void 0 ? void 0 : ref2.id, "?unit_id=").concat(paths === null || paths === void 0 ? void 0 : paths[1].id);
                        break;
                }
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "flex items-center overflow-hidden text-ellipsis whitespace-nowrap",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: url,
                        className: "breadcrumbs__link",
                        scroll: false,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "inline-block w-full max-w-full cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap text-sm font-normal text-gray-1",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_common_Tooltip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                title: path === null || path === void 0 ? void 0 : path.name,
                                children: path === null || path === void 0 ? void 0 : path.name
                            })
                        })
                    }),
                    index < paths.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "inline-block overflow-hidden px-1 text-sm font-normal text-gray-1",
                        children: [
                            " ",
                            "/",
                            " "
                        ]
                    })
                ]
            }, path === null || path === void 0 ? void 0 : path.id);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SappBreadcrumbNotLink);


/***/ }),

/***/ 97181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25925);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45972);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12691);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);






var BaseButton = function(_param) {
    var children = _param.children, className = _param.className, link = _param.link, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "link"
    ]);
    var baseClassName = "!shadow-none outline-none inline-block h-fit box-border flex items-center justify-center";
    if (link) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: link,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
                className: "".concat(baseClassName, " ").concat(className),
                children: children
            }))
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        className: "".concat(baseClassName, " ").concat(className),
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseButton);


/***/ }),

/***/ 20010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21967);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _SappButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98971);



var ButtonCancelSubmit = function(param) {
    var submit = param.submit, cancel = param.cancel, _className = param.className, className = _className === void 0 ? "flex align-middle justify-between" : _className, _color = param.color, color = _color === void 0 ? "primary" : _color, _colorCancel = param.colorCancel, colorCancel = _colorCancel === void 0 ? "text" : _colorCancel, _showOkButton = param.showOkButton, showOkButton = _showOkButton === void 0 ? true : _showOkButton, _showCancelButton = param.showCancelButton, showCancelButton = _showCancelButton === void 0 ? true : _showCancelButton, _revertFunction = param.revertFunction, revertFunction = _revertFunction === void 0 ? false : _revertFunction;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        children: [
            showCancelButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SappButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                color: colorCancel
            }, !revertFunction ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, cancel) : (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, submit))),
            showOkButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SappButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                color: color
            }, !revertFunction ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, submit) : (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, cancel)))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonCancelSubmit);


/***/ }),

/***/ 15421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12691);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_helpers_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17617);




var LoadingSpinner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-100 h-100 absolute bottom-0 left-0 right-0 top-0 flex items-center justify-center space-x-2 bg-none dark:invert",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "sr-only",
                children: "Loading..."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-2 w-2 animate-bounce rounded-full bg-white [animation-delay:-0.3s]"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-2 w-2 animate-bounce rounded-full bg-white [animation-delay:-0.15s]"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-2 w-2 animate-bounce rounded-full bg-white"
            })
        ]
    });
};
var ButtonPrimary = function(param) {
    var title = param.title, onClick = param.onClick, _className = param.className, className = _className === void 0 ? "" : _className, link = param.link, _size = param.size, size = _size === void 0 ? "small" : _size, _full = param.full, full = _full === void 0 ? false : _full, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _loading = param.loading, loading = _loading === void 0 ? false : _loading, type = param.type, icon = param.icon;
    var textSizeClass = (0,_utils_helpers_button__WEBPACK_IMPORTED_MODULE_3__/* .getTextSizeClass */ .EN)(size);
    var paddingVerticalClass = (0,_utils_helpers_button__WEBPACK_IMPORTED_MODULE_3__/* .getPaddingVerticalClass */ .Pb)(size);
    var paddingHorizontalClass = (0,_utils_helpers_button__WEBPACK_IMPORTED_MODULE_3__/* .getPaddingHorizontalClass */ .qx)(size);
    var fullWidthClass = full ? "block w-full" : "inline-block";
    var disabledClass = disabled || loading ? "cursor-not-allowed opacity-60 bg-primary-2" : "cursor-pointer";
    var componentClass = [
        className,
        "relative text-center text-white",
        fullWidthClass,
        paddingVerticalClass,
        paddingHorizontalClass,
        disabledClass,
        textSizeClass,
        "font-medium bg-primary hover:bg-primary-2", 
    ].join(" ");
    if (link) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: link,
            className: componentClass,
            "aria-disabled": disabled,
            children: [
                icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mr-2",
                    children: icon
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: title
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        className: componentClass,
        type: type !== null && type !== void 0 ? type : "button",
        onClick: onClick,
        disabled: disabled || loading,
        children: [
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mr-2",
                children: icon
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: loading ? "invisible" : "",
                children: title
            }),
            loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoadingSpinner, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(ButtonPrimary));


/***/ }),

/***/ 29798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ button_ButtonSecondary; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(12691);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(41492);
;// CONCATENATED MODULE: ./src/components/base/button/SpinIcon.tsx


var SpinIcon = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-hidden": "true",
        role: "status",
        className: "me-3 inline h-4 w-4 animate-spin text-white",
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                fill: "#E5E7EB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                fill: "currentColor"
            })
        ]
    });
};
/* harmony default export */ var button_SpinIcon = (SpinIcon);

;// CONCATENATED MODULE: ./src/components/base/button/ButtonSecondary.tsx




var ButtonSecondary = function(param) {
    var title = param.title, onClick = param.onClick, _className = param.className, className = _className === void 0 ? "" : _className, link = param.link, _size = param.size, size = _size === void 0 ? "small" : _size, _full = param.full, full = _full === void 0 ? false : _full, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _isSecondaryButton = param.isSecondaryButton, isSecondaryButton = _isSecondaryButton === void 0 ? true : _isSecondaryButton;
    var isDisabled = disabled || loading;
    var textSizeClass = size === "small" ? "text-[0.875rem] leading-4" : size === "medium" ? "text-[1rem] leading-6" : "text-lg leading-6.5";
    var paddingVerticalClass = size === "small" ? "py-2" : size === "medium" ? "py-2" : "py-2.8";
    var paddingHorizontalClass = size === "small" ? "px-7" : size === "medium" ? "px-8" : "px-9";
    var fullWidthClass = full ? "block w-full" : "inline-block w-fit";
    var componentClass = "\n    text-center \n    ".concat(fullWidthClass, " \n    ").concat(paddingVerticalClass, " \n    ").concat(paddingHorizontalClass, " \n    text-bw-1 \n    ").concat(textSizeClass, " \n    font-medium \n    bg-gray-3 \n    ").concat(isDisabled ? "cursor-not-allowed opacity-60" : "cursor-pointer", " \n    ").concat(isSecondaryButton ? "secondary" : "", " \n    ").concat(className, "\n  ").trim();
    var buttonContent = loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center justify-center space-x-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_SpinIcon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Loading..."
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: title
    });
    if (link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: link,
            className: componentClass,
            "aria-disabled": isDisabled,
            children: buttonContent
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: componentClass,
        onClick: onClick,
        disabled: isDisabled,
        type: "button",
        children: buttonContent
    });
};
/* harmony default export */ var button_ButtonSecondary = (ButtonSecondary);


/***/ }),

/***/ 98971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12691);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_common_Tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45028);



var SIZES = {
    small: "text-[0.875rem] leading-4",
    medium: "text-[1rem] leading-6",
    lager: "text-lg leading-6.5",
    extra: "text-lg leading-6.5"
};
var COLORS = {
    primary: "primary",
    info: "bg-info hover:bg-info-2 disabled:bg-info-2 text-white",
    success: "bg-success hover:bg-success-2 disabled:bg-success-2 text-white",
    secondary: "bg-gray-3 hover:bg-secondary-4 disabled:bg-secondary-4 text-bw-1",
    danger: "bg-danger hover:bg-danger-2 disabled:bg-danger-2 text-white",
    warning: "bg-warning hover:bg-warning-2 disabled:bg-warning-2 text-white",
    light: "bg-light hover:bg-light-2 disabled:bg-light-2 text-white",
    dark: "bg-dark hover:bg-dark-2 disabled:bg-dark-2 text-white",
    white: "bg-white hover:bg-primary-2 disabled:bg-white text-gray-1 hover:text-white",
    outline: "bg-white border-bw-1 hover:border-gray-1 hover:text-gray-1 text-bw-1",
    text: "bg-none text-bw-1 hover:text-gray-1 disabled:text-gray-2 underline-offset-2 font-medium",
    textUnderline: "bg-none text-bw-1 hover:text-gray-1 disabled:text-gray-2 underline-offset-2 underline font-medium",
    quizActivity: "bg-gray-1 hover:bg-gray-2 disabled:bg-gray-2 text-white",
    okPopup: "bg-accent-error text-white",
    cancelPopup: "bg-gray-4 text-accent-default",
    gray: "bg-white hover:bg-primary-2 disabled:bg-white text-bw-15 hover:text-white"
};
var PADDINGS = {
    small: "px-7 h-8",
    medium: "px-8 py-2",
    lager: "px-9 py-2.8",
    extra: "px-17.5 py-2.8",
    none: ""
};
var COLOR_LOADING = {
    primary: "bg-white",
    info: "bg-white",
    success: "bg-white",
    secondary: "bg-bw-1",
    danger: "bg-white",
    warning: "bg-white",
    light: "bg-white",
    dark: "bg-white",
    white: "bg-gray-1",
    outline: "bg-gray-1",
    text: "bg-none",
    textUnderline: "bg-none",
    quizActivity: "bg-white",
    okPopup: "bg-white",
    cancelPopup: "bg-white",
    gray: "bg-transparent"
};
var SappButton = function(param) {
    var title = param.title, onClick = param.onClick, _className = param.className, className = _className === void 0 ? "" : _className, link = param.link, _size = param.size, size = _size === void 0 ? "small" : _size, _full = param.full, full = _full === void 0 ? false : _full, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _type = param.type, type = _type === void 0 ? "button" : _type, _color = param.color, color = _color === void 0 ? "primary" : _color, isUnderLine = param.isUnderLine, _isPadding = param.isPadding, isPadding = _isPadding === void 0 ? true : _isPadding, _childClass = param.childClass, childClass = _childClass === void 0 ? "" : _childClass, _classNameLoading = param.classNameLoading, classNameLoading = _classNameLoading === void 0 ? "" : _classNameLoading, _showTooltip = param.showTooltip, showTooltip = _showTooltip === void 0 ? false : _showTooltip, _toolTipTitle = param.toolTipTitle, toolTipTitle = _toolTipTitle === void 0 ? "" : _toolTipTitle;
    var isDisabled = disabled || loading;
    var paddingClass = isPadding ? PADDINGS[size] : PADDINGS.none;
    var fullWidthClass = full ? "block w-full" : "inline-block w-fit";
    var underlineClass = isUnderLine !== undefined ? isUnderLine ? "hover:underline" : "" : color === "text" ? "hover:underline" : "";
    var componentClass = "\n    ".concat(className, "\n    ").concat(COLORS[color], "\n    ").concat(SIZES[size], "\n    ").concat(paddingClass, "\n    ").concat(fullWidthClass, "\n    ").concat(underlineClass, "\n    relative text-center font-medium\n    ").concat(isDisabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer", "\n  ").trim();
    var loadingIndicator = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex items-center justify-center ".concat(classNameLoading),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "sr-only",
                children: "Loading..."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-2 w-2 animate-bounce rounded-full [animation-delay:-0.3s] ".concat(COLOR_LOADING[color])
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-2 w-2 animate-bounce rounded-full [animation-delay:-0.15s] ".concat(COLOR_LOADING[color])
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-2 w-2 animate-bounce rounded-full ".concat(COLOR_LOADING[color])
            })
        ]
    });
    var buttonContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_common_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        title: toolTipTitle,
        showTooltip: showTooltip,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "".concat(loading ? "invisible" : "", " ").concat(childClass),
            children: title
        })
    });
    // Use Next.js Link for better routing
    if (link) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: link,
            className: componentClass,
            "aria-disabled": isDisabled,
            children: loading ? loadingIndicator : buttonContent
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: type,
        className: "".concat(componentClass, " ").concat(classNameLoading),
        onClick: onClick,
        disabled: isDisabled,
        children: loading ? loadingIndicator : buttonContent
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SappButton);


/***/ }),

/***/ 57928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72760);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75367);
/* harmony import */ var src_common_ErrorMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68507);
/* harmony import */ var _SAPPCheckbox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19786);
/* harmony import */ var _tags_YourAnswer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42549);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10103);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);







var HookFormCheckBoxGroup = function(param) {
    var name = param.name, control = param.control, defaultValue = param.defaultValue, _className = param.// title,
    className, className = _className === void 0 ? "" : _className, onChange = param.onChange, // checked,
    // isWrong,
    // label,
    // required,
    disabled = param.disabled, classNameTitle = param.classNameTitle, options = param.options, _direction = param.direction, direction = _direction === void 0 ? "vertical" : _direction, gap = param.gap, justify = param.justify, _multiple = param.multiple, multiple = _multiple === void 0 ? false : _multiple, _size = param.size, size = _size === void 0 ? "small" : _size, // state,
    corrects = param.corrects, _toggle = param.toggle, toggle = _toggle === void 0 ? false : _toggle, _positionCheckBox = param.positionCheckBox, positionCheckBox = _positionCheckBox === void 0 ? "center" : _positionCheckBox, _lowerOptions = param.lowerOptions, lowerOptions = _lowerOptions === void 0 ? false : _lowerOptions, _seprateLine = param.seprateLine, seprateLine = _seprateLine === void 0 ? false : _seprateLine, _widthOptions = param.widthOptions, widthOptions = _widthOptions === void 0 ? "" : _widthOptions, _maxWidthContent = param.maxWidthContent, maxWidthContent = _maxWidthContent === void 0 ? false : _maxWidthContent;
    gap = !seprateLine ? gap ? gap : direction === "horizontal" ? "gap-6" : "gap-4" : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .Controller */ .Qr, {
        control: control,
        name: name,
        defaultValue: defaultValue,
        render: function(param) {
            var field = param.field, error = param.fieldState.error;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (direction === "horizontal" ? "_horizontal flex flex-wrap" : "_vertical flex flex-col") + " ".concat(gap, " ") + " ".concat(justify === "between" ? "justify-between" : justify == "center" ? "justify-center" : justify === "start" ? "justify-start" : "justify-end", " ").concat(seprateLine && "sapp-separateLine", " ").concat(maxWidthContent && "w-max"),
                        children: options.map(function(option, index) {
                            var ref, ref1;
                            var state;
                            var stateLabel = "";
                            var checked = multiple ? (ref = field.value) === null || ref === void 0 ? void 0 : ref.includes(option.value.toString()) : option.value.toString() === field.value;
                            // let correctCheck: boolean =
                            //   corrects?.[option.value as string] || false
                            if (!!corrects) {
                                if (corrects === null || corrects === void 0 ? void 0 : corrects[option.value]) {
                                    state = "success";
                                    stateLabel = "text-state-success";
                                } else if (checked) {
                                    state = "error";
                                    stateLabel = "text-state-error";
                                }
                            }
                            var checkHasChecked = multiple ? ((ref1 = field.value) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 : false;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                className: "flex justify-center items-".concat(positionCheckBox, " w-fit ").concat(disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer", " ").concat(corrects && "pointer-events-none", " ").concat(seprateLine && "py-2", " ").concat(widthOptions),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SAPPCheckbox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        className: "me-2 ".concat(className, " ").concat(positionCheckBox === "start" && "mt-[2px]"),
                                        checked: checked,
                                        lowerOptions: lowerOptions && !checked && checkHasChecked,
                                        onChange: function(event) {
                                            if (multiple) {
                                                var ref;
                                                var arr = [];
                                                if (((ref = field.value) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                                                    arr = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(field.value);
                                                    if (arr.includes(event.target.value)) {
                                                        var newArr = arr.filter(function(e) {
                                                            return e !== event.target.value;
                                                        });
                                                        arr = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(newArr);
                                                    } else {
                                                        arr.push(event.target.value);
                                                    }
                                                } else {
                                                    arr.push(event.target.value);
                                                }
                                                field.onChange(arr);
                                                onChange && onChange(arr);
                                            } else {
                                                if (toggle) {
                                                    if (event.target.value === field.value) {
                                                        field.onChange(undefined);
                                                        onChange && onChange(undefined);
                                                    } else {
                                                        field.onChange(event.target.value);
                                                        onChange && onChange(event.target.value);
                                                    }
                                                } else {
                                                    field.onChange(event.target.value);
                                                    onChange && onChange(event.target.value);
                                                }
                                            }
                                        },
                                        disabled: disabled,
                                        state: state,
                                        value: option.value.toString(),
                                        size: size
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "".concat(classNameTitle !== null && classNameTitle !== void 0 ? classNameTitle : "", " ").concat(stateLabel, "  form-check-label fw-semibold ").concat(lowerOptions && !checked && checkHasChecked && "text-gray-1"),
                                        children: [
                                            option.label,
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tags_YourAnswer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                show: checked && !!corrects
                                            })
                                        ]
                                    })
                                ]
                            }, (0,lodash__WEBPACK_IMPORTED_MODULE_4__.uniqueId)(option.label));
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_common_ErrorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        children: error === null || error === void 0 ? void 0 : error.message
                    })
                ]
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HookFormCheckBoxGroup);


/***/ }),

/***/ 19786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);


var STATE = {
    success: "checked:bg-state-success checked:hover:bg-state-success checked:focus:bg-state-success",
    error: "checked:bg-state-error checked:hover:bg-state-error checked:focus:bg-state-error",
    default: "checked:bg-bw-1 checked:hover:bg-bw-1 checked:focus:bg-bw-1",
    primary: "checked:bg-primary checked:hover:bg-primary checked:focus:bg-primary"
};
var SIZES = {
    small: "w-4.5 h-4.5",
    medium: "w-[24px] h-[24px]",
    lager: "w-[30px] h-[30px]"
};
var SAPPCheckbox = function(param) {
    var checked = param.checked, disabled = param.disabled, onChange = param.onChange, className = param.className, value = param.value, _state = param.state, state = _state === void 0 ? "default" : _state, _size = param.size, size = _size === void 0 ? "medium" : _size, _lowerOptions = param.lowerOptions, lowerOptions = _lowerOptions === void 0 ? false : _lowerOptions, _inputStyle = param.inputStyle, inputStyle = _inputStyle === void 0 ? "border-bw-1" : _inputStyle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "inline-block ".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
            className: "block ".concat(SIZES[size], " border-1.5 outline-none ring-0 ring-offset-0 focus:outline-none focus:ring-0 focus:ring-offset-0 ").concat(inputStyle, " ").concat(STATE[state], " ").concat(disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer", " ").concat(lowerOptions && "border-none"),
            type: "checkbox",
            checked: checked,
            onChange: onChange,
            disabled: disabled,
            value: value === null || value === void 0 ? void 0 : value.toString()
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SAPPCheckbox);


/***/ }),

/***/ 87248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);

var useClickOutside = function(param) {
    var ref = param.ref, callback = param.callback;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleClickOutside = function(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref,
        callback
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useClickOutside);


/***/ }),

/***/ 95215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ editor_EditorReader; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(51224);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(21967);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(52621);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(45332);
// EXTERNAL MODULE: ./node_modules/html-react-parser/lib/index.js
var lib = __webpack_require__(2110);
;// CONCATENATED MODULE: ./node_modules/html-react-parser/esm/index.mjs


/* harmony default export */ var esm = (lib["default"] || lib);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./src/components/base/modal/SappModalImage.tsx
var SappModalImage = __webpack_require__(44094);
// EXTERNAL MODULE: ./src/utils/constants/index.ts + 3 modules
var constants = __webpack_require__(15183);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(57368);
// EXTERNAL MODULE: ./src/components/base/video/SAPPVideo.tsx + 2 modules
var SAPPVideo = __webpack_require__(67738);
;// CONCATENATED MODULE: ./src/components/base/editor/EditorReader.tsx













var EditorReader = function(param) {
    var _text_editor_content = param.text_editor_content, text_editor_content = _text_editor_content === void 0 ? "" : _text_editor_content, _className = param.className, className = _className === void 0 ? "" : _className, extenalRef = param.extenalRef, id = param.id, onMouseUp = param.onMouseUp, highlighted = param.highlighted, options = param.options, _highlighArea = param.highlighArea, highlighArea = _highlighArea === void 0 ? "hightlight_area" : _highlighArea, pinned = param.pinned;
    var ref = (0,react.useState)(), src = ref[0], setSrc = ref[1];
    var ref1 = (0,react.useState)("VIDEO"), type = ref1[0], setType = ref1[1];
    var ref2 = (0,react.useState)(), content = ref2[0], setContent = ref2[1];
    var editorRef = (0,react.useRef)(null);
    var videoRefs = (0,react.useRef)({});
    (0,react.useEffect)(function() {
        if (highlighArea === "hightlight_area_topic") {
            (0,utils/* DeserializeHighlight */.CK)(highlighted, highlighArea);
        } else if (highlighArea === "hightlight_area_require") {
            (0,utils/* DeserializeHighlight */.CK)(highlighted, highlighArea);
        } else if (highlighArea === "hightlight_area") {
            (0,utils/* DeserializeHighlight */.CK)(highlighted);
        }
    }, [
        content,
        highlighted
    ]);
    (0,react.useEffect)(function() {
        if (text_editor_content !== content) {
            setContent(text_editor_content);
        }
    }, [
        text_editor_content
    ]);
    var convertMathToImage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(element) {
            var ref, ref1, viewer, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        viewer = com === null || com === void 0 ? void 0 : (ref = com.wiris) === null || ref === void 0 ? void 0 : (ref1 = ref.js) === null || ref1 === void 0 ? void 0 : ref1.JsPluginViewer;
                        if (!(element && viewer)) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            viewer.parseElement(element, true, function() {})
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function convertMathToImage(element) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        setTimeout(function() {
            var editor = editorRef === null || editorRef === void 0 ? void 0 : editorRef.current;
            if (editor) {
                var mfencedElements = editor === null || editor === void 0 ? void 0 : editor.querySelectorAll("mfenced");
                mfencedElements.forEach(function(el) {
                    var openAttr = el === null || el === void 0 ? void 0 : el.getAttribute("open");
                    var closeAttr = el === null || el === void 0 ? void 0 : el.getAttribute("close");
                    if (openAttr !== null && closeAttr) {
                        var replacements = {
                            "|": "|",
                            "||": "||",
                            ">": "<",
                            "}": "{",
                            "]": "[",
                            "&#62;": "&#60;"
                        };
                        if (replacements[closeAttr]) {
                            el === null || el === void 0 ? void 0 : el.setAttribute("open", replacements[closeAttr]);
                        }
                    }
                });
                // Replace quote in font family
                var mathElement = editor === null || editor === void 0 ? void 0 : editor.querySelectorAll("math");
                if (mathElement) {
                    mathElement === null || mathElement === void 0 ? void 0 : mathElement.forEach(function(el) {
                        if (el === null || el === void 0 ? void 0 : el.hasAttribute("style")) {
                            var styleValue = el === null || el === void 0 ? void 0 : el.getAttribute("style");
                            styleValue = styleValue === null || styleValue === void 0 ? void 0 : styleValue.replaceAll('"', "");
                            el === null || el === void 0 ? void 0 : el.setAttribute("style", styleValue);
                        }
                    });
                    convertMathToImage(editor);
                }
            }
        }, 100);
    });
    var handleOnclick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var target, ref, video, src, ref1, iframe, imageSrc;
            return (0,tslib_es6.__generator)(this, function(_state) {
                target = e === null || e === void 0 ? void 0 : e.target;
                if (target.className === "sapp_overlay_video") {
                    ;
                    video = target === null || target === void 0 ? void 0 : target.previousSibling;
                    src = (ref = video === null || video === void 0 ? void 0 : video.querySelector("source")) === null || ref === void 0 ? void 0 : ref.getAttribute("token");
                    if (src && src !== "null" && video.tagName === "VIDEO") {
                        ;
                        iframe = document.createElement("iframe");
                        iframe.src = "".concat(constants/* video_url */.jh).concat(src, "/iframe?autoplay=true");
                        iframe.id = video === null || video === void 0 ? void 0 : video.id;
                        iframe.className = video === null || video === void 0 ? void 0 : video.className;
                        iframe.style.cssText = video === null || video === void 0 ? void 0 : video.style.cssText;
                        iframe.allow = "accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;";
                        iframe.allowFullscreen = true;
                        video === null || video === void 0 ? void 0 : (ref1 = video.parentNode) === null || ref1 === void 0 ? void 0 : ref1.replaceChild(iframe, video);
                        target === null || target === void 0 ? void 0 : target.classList.add("hidden");
                    // target?.parentNode?.removeChild(target.nextSibling as Node)
                    }
                } else if ((target === null || target === void 0 ? void 0 : target.tagName) === "IMG") {
                    imageSrc = target === null || target === void 0 ? void 0 : target.getAttribute("src");
                    if (imageSrc) {
                        setSrc(function() {
                            setType("IMG");
                            return imageSrc;
                        });
                    }
                }
                return [
                    2
                ];
            });
        });
        return function handleOnclick(e) {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * @description add class border theo editor khi border style khác none và hidden ở lần đầu component render
   */ (0,react.useEffect)(function() {
        // Lấy tất cả các bảng trong tài liệu
        var tableElements = document === null || document === void 0 ? void 0 : document.querySelectorAll("table");
        tableElements === null || tableElements === void 0 ? void 0 : tableElements.forEach(function(tableElement) {
            if (tableElement) {
                // Lấy kiểu border của bảng hiện tại
                var style = window === null || window === void 0 ? void 0 : window.getComputedStyle(tableElement);
                var newBorderStyle = style === null || style === void 0 ? void 0 : style.borderStyle;
                // Lấy tất cả các ô (td) trong bảng hiện tại
                var tdElements = tableElement === null || tableElement === void 0 ? void 0 : tableElement.querySelectorAll("td");
                tdElements === null || tdElements === void 0 ? void 0 : tdElements.forEach(function(td) {
                    if (newBorderStyle !== "none" && newBorderStyle !== "hidden") {
                        var ref;
                        td === null || td === void 0 ? void 0 : (ref = td.classList) === null || ref === void 0 ? void 0 : ref.add("border-[1px]");
                    } else {
                        var ref1;
                        td === null || td === void 0 ? void 0 : (ref1 = td.classList) === null || ref1 === void 0 ? void 0 : ref1.remove("border-[1px]");
                    }
                });
            }
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(className, " editor-wrap mce-content-body"),
                id: id || "",
                onMouseUp: onMouseUp ? onMouseUp : function() {},
                ref: editorRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: extenalRef,
                    className: (0,clsx/* default */.Z)({
                        "pined-noti text-[14px] text-white": pinned
                    }),
                    onClick: handleOnclick,
                    translate: "no",
                    children: esm((0,utils/* replaceTextAlignCenterToWebKitCenter */.rI)(content || ""), (0,_object_spread/* default */.Z)({
                        replace: function(domNode) {
                            if (domNode.type === "tag" && domNode.name === "video") {
                                var ref;
                                var sourceChild = domNode.children.find(function(child) {
                                    return child.name === "source";
                                });
                                var videoToken = sourceChild === null || sourceChild === void 0 ? void 0 : (ref = sourceChild.attribs) === null || ref === void 0 ? void 0 : ref.token;
                                if (videoToken) {
                                    if (!videoRefs.current[videoToken]) {
                                        videoRefs.current[videoToken] = /*#__PURE__*/ react.createRef();
                                    }
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SAPPVideo/* default */.Z, {
                                        options: {
                                            onTimeUpdate: function() {},
                                            src: videoToken
                                        },
                                        streamRef: videoRefs.current[videoToken],
                                        pauseOnSeek: true,
                                        thumbnail: {
                                            "640x360": "".concat(constants/* video_url */.jh).concat(videoToken, "/thumbnails/thumbnail.jpg?time=1s&height=360"),
                                            "770x435": "".concat(constants/* video_url */.jh).concat(videoToken, "/thumbnails/thumbnail.jpg?time=1s&height=435"),
                                            "950x535": "".concat(constants/* video_url */.jh).concat(videoToken, "/thumbnails/thumbnail.jpg?time=1s&height=535")
                                        }
                                    }, videoToken);
                                }
                            }
                        }
                    }, options))
                }, content)
            }),
            type === "IMG" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SappModalImage/* default */.Z, {
                src: src,
                setSrc: setSrc
            })
        ]
    });
};
/* harmony default export */ var editor_EditorReader = (EditorReader);


/***/ }),

/***/ 33593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52621);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var src_redux_hook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34705);
/* harmony import */ var src_redux_slice_ConfirmDialog_ConfirmDialogThunk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55771);
/* harmony import */ var _button_ButtonCancelSubmit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20010);
/* harmony import */ var _assets_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34648);








/**
 * Hàm này tạo một modal component bằng React
 * @param open: boolean - biến xác định modal có được mở hay không
 * @param setOpen: function - hàm xác định modal có được mở hay không
 * @param children: ReactNode - biến chứa các phần tử con của modal
 * @param cancelButtonCaption: string - biến xác định nội dung của nút hủy
 * @param okButtonCaption: string - biến xác định nội dung của nút xác nhận
 * @param handleCancel: function - hàm xử lý khi người dùng nhấn nút hủy
 * @param handleSubmit: function - hàm xử lý khi người dùng nhấn nút xác nhận
 * @param disabled: boolean - biến xác định modal có bị vô hiệu hóa hay không
 * @param title: string - biến xác định tiêu đề của modal
 * @param showTitle: boolean - biến xác định modal có hiển thị tiêu đề hay không
 * @param customTitle: ReactNode - biến chứa phần tử tùy chỉnh cho tiêu đề
 * @param showFooter: boolean - biến xác định modal có hiển thị footer hay không
 * @param customFooter: ReactNode - biến chứa phần tử tùy chỉnh cho footer
 * @param confirmOnclose: boolean - biến xác định modal có yêu cầu xác nhận khi đóng hay không
 * @param width: number - biến xác định modal width
 */ var SappModal = function(param) {
    var open = param.open, children = param.children, _cancelButtonCaption = param.cancelButtonCaption, cancelButtonCaption = _cancelButtonCaption === void 0 ? "Cancel" : _cancelButtonCaption, _okButtonCaption = param.okButtonCaption, okButtonCaption = _okButtonCaption === void 0 ? "Submit" : _okButtonCaption, okButtonClass = param.okButtonClass, cancelButtonClass = param.cancelButtonClass, _buttonSize = param.buttonSize, buttonSize = _buttonSize === void 0 ? "medium" : _buttonSize, handleCancel = param.handleCancel, handleSubmit = param.handleSubmit, handleCloseOnly = param.handleCloseOnly, disabled = param.disabled, title = param.title, customTitle = param.customTitle, _showHeader = param.showHeader, showHeader = _showHeader === void 0 ? true : _showHeader, customHeader = param.customHeader, _showFooter = param.showFooter, showFooter = _showFooter === void 0 ? true : _showFooter, customFooter = param.customFooter, confirmOnclose = param.confirmOnclose, _size = param.size, size = _size === void 0 ? "max-w-lg" : _size, _modelClassname = param.modelClassname, modelClassname = _modelClassname === void 0 ? "" : _modelClassname, _refClass = param.refClass, refClass = _refClass === void 0 ? "md:px-6 px-5 py-5 flex flex-col animate-jump-in relative transform overflow-hidden bg-white text-left shadow-xl transition-all" : _refClass, _childClass = param.childClass, childClass = _childClass === void 0 ? "" : _childClass, _parentChildClass = param.parentChildClass, parentChildClass = _parentChildClass === void 0 ? "" : _parentChildClass, _footerButtonClassName = param.footerButtonClassName, footerButtonClassName = _footerButtonClassName === void 0 ? "justify-center sm:justify-end flex gap-3" : _footerButtonClassName, _overlayClass = param.overlayClass, overlayClass = _overlayClass === void 0 ? "" : _overlayClass, color = param.color, _colorCancel = param.colorCancel, colorCancel = _colorCancel === void 0 ? "text" : _colorCancel, _position = param.position, position = _position === void 0 ? "start" : _position, _fullWidthBtn = param.fullWidthBtn, fullWidthBtn = _fullWidthBtn === void 0 ? false : _fullWidthBtn, _isFullScreen = param.isFullScreen, isFullScreen = _isFullScreen === void 0 ? false : _isFullScreen, _isContentFull = param.isContentFull, isContentFull = _isContentFull === void 0 ? true : _isContentFull, _isInner = param.isInner, isInner = _isInner === void 0 ? false : _isInner, _isBordered = param.isBordered, isBordered = _isBordered === void 0 ? false : _isBordered, _closeAfterSubmit = param.closeAfterSubmit, closeAfterSubmit = _closeAfterSubmit === void 0 ? true : _closeAfterSubmit, _showOkButton = param.showOkButton, showOkButton = _showOkButton === void 0 ? true : _showOkButton, _showCancelButton = param.showCancelButton, showCancelButton = _showCancelButton === void 0 ? true : _showCancelButton, _zIndex = param.zIndex, zIndex = _zIndex === void 0 ? "z-[1500]" : _zIndex, _scrollbale = param.scrollbale, scrollbale = _scrollbale === void 0 ? true : _scrollbale, footerClassName = param.footerClassName, externalLoading = param.externalLoading, _revertFunction = param.revertFunction, revertFunction = _revertFunction === void 0 ? false : _revertFunction, showCloseIcon = param.showCloseIcon, _disableClickOutSide = param.disableClickOutSide, disableClickOutSide = _disableClickOutSide === void 0 ? false : _disableClickOutSide, _className = param.className, className = _className === void 0 ? "" : _className;
    var dispatch = (0,src_redux_hook__WEBPACK_IMPORTED_MODULE_2__/* .useAppDispatch */ .T)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loading = ref[0], setLoading = ref[1];
    var confirmDialogRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var confirmDialogOverLayRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isInner) {
            if (open) {
                var scrollBarWidth = window.innerWidth - document.body.clientWidth;
                setTimeout(function() {
                    document.body.style.paddingRight = scrollBarWidth + "px";
                    document.body.classList.add("overflow-hidden");
                });
            } else {
                var customModal = document.querySelectorAll(".sapp-custom-modal:not(.sapp-custom-modal-inner)");
                if (!(customModal === null || customModal === void 0 ? void 0 : customModal.length)) {
                    document.body.style.removeProperty("padding-right");
                    document.body.classList.remove("overflow-hidden");
                }
            }
        }
    }, [
        open
    ]);
    /**
   * Hàm này xử lý khi người dùng nhấn nút xác nhận
   * @return void
   */ var onOk = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            var err;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(handleSubmit && handleSubmit.constructor.name === "AsyncFunction")) return [
                            3,
                            6
                        ];
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            handleSubmit()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        if (closeAfterSubmit) {
                            CloseOnly();
                        }
                        return [
                            2
                        ];
                    case 6:
                        if (handleSubmit) {
                            handleSubmit();
                        }
                        _state.label = 7;
                    case 7:
                        if (closeAfterSubmit) {
                            CloseOnly();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onOk() {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * Hàm này xử lý khi người dùng nhấn nút hủy
   * @return void
   */ var onCancel = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            var callHandleCancel;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                callHandleCancel = function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!(handleCancel && handleCancel.constructor.name === "AsyncFunction")) return [
                                        3,
                                        2
                                    ];
                                    setLoading(true);
                                    return [
                                        4,
                                        handleCancel()
                                    ];
                                case 1:
                                    _state.sent();
                                    setLoading(false);
                                    handleClose();
                                    return [
                                        2
                                    ];
                                case 2:
                                    if (handleCancel) {
                                        handleClose();
                                    }
                                    _state.label = 3;
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function callHandleCancel() {
                        return _ref.apply(this, arguments);
                    };
                }();
                // Nếu confirmOnclose là true, thì mở một hộp thoại xác nhận
                if (confirmOnclose) {
                    dispatch(src_redux_slice_ConfirmDialog_ConfirmDialogThunk__WEBPACK_IMPORTED_MODULE_3__/* ["default"].open */ .Z.open({
                        // Nội dung của hộp thoại xác nhận
                        message: "Bạn c\xf3 chắc chắn muốn hủy kh\xf4ng?",
                        // Hàm thực thi khi người dùng xác nhận hành động
                        onConfirm: callHandleCancel
                    }));
                } else {
                    // Nếu confirmOnclose là false, thì không cần xác nhận
                    // Gọi hàm callHandleCancel
                    callHandleCancel();
                }
                return [
                    2
                ];
            });
        });
        return function onCancel() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClose = function() {
        if (confirmDialogRef.current) {
            confirmDialogRef.current.classList.add("animate-jump-out");
            confirmDialogRef.current.classList.add("pointer-events-none");
        }
        if (confirmDialogOverLayRef.current) {
            confirmDialogOverLayRef.current.classList.add("animate-fade-out-overlay");
            confirmDialogOverLayRef.current.classList.add("pointer-events-none");
        }
        setTimeout(function() {
            handleCancel && handleCancel();
        }, 50);
    };
    var CloseOnly = function() {
        if (confirmDialogRef.current) {
            confirmDialogRef.current.classList.add("animate-jump-out");
            confirmDialogRef.current.classList.add("pointer-events-none");
        }
        if (confirmDialogOverLayRef.current) {
            confirmDialogOverLayRef.current.classList.add("animate-fade-out-overlay");
            confirmDialogOverLayRef.current.classList.add("pointer-events-none");
        }
        setTimeout(function() {
            handleCloseOnly ? handleCloseOnly() : handleCancel && handleCancel();
        }, 50);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: open && // add an onClick handler to the outer div to close the popup when clicking outside
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "sapp-custom-modal ".concat(isInner ? "sapp-custom-modal-inner absolute max-h-full" : "fixed max-h-screen", " inset-0 flex w-full items-center justify-center ").concat(zIndex, " ").concat(modelClassname),
                role: "dialog",
                "aria-modal": "true",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        ref: confirmDialogOverLayRef,
                        onClick: function() {
                            if (externalLoading !== undefined) {
                                if (externalLoading) {
                                    return;
                                }
                            }
                            if (loading) {
                                return;
                            }
                            !disableClickOutSide && onCancel();
                        },
                        className: "".concat(isInner ? "absolute" : "fixed", " inset-0 animate-fade-in-overlay bg-bw-10 transition-opacity ").concat(overlayClass)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat(isFullScreen || "".concat(size, " p-4 xl:py-8"), "  inset-0 flex h-full w-full justify-center text-center items-").concat(position),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            ref: confirmDialogRef,
                            className: "max-h-full w-fit max-w-full \n                ".concat(isContentFull ? "w-full" : "w-fit", "\n                ").concat(refClass, " ").concat(className),
                            children: [
                                showHeader && (customHeader || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "relative bg-white pb-5 md:pb-5",
                                    children: [
                                        isBordered && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute bottom-0 left-0 right-0 -mx-6 border-b border-gray-2"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                customTitle || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "text-xl font-bold text-bw-1",
                                                    children: title
                                                }),
                                                showCloseIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "ml-auto cursor-pointer",
                                                    onClick: onCancel,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_icons__WEBPACK_IMPORTED_MODULE_5__/* .CloseIcon */ .Tw, {
                                                        className: "transform stroke-bw-1 transition-all duration-300 ease-in-out group-hover:stroke-primary"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat(parentChildClass, " ").concat(scrollbale && "-mr-4.5 flex-1 snap-y overflow-y-scroll bg-white"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "".concat(childClass),
                                        children: children
                                    })
                                }),
                                showFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "relative pt-5 md:pt-5 ".concat(footerClassName),
                                    children: [
                                        isBordered && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute left-0 right-0 top-0 -mx-6 border-b border-gray-2"
                                        }),
                                        customFooter || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_ButtonCancelSubmit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            revertFunction: revertFunction,
                                            className: footerButtonClassName,
                                            color: color,
                                            colorCancel: colorCancel,
                                            showOkButton: showOkButton,
                                            showCancelButton: showCancelButton,
                                            submit: {
                                                title: okButtonCaption,
                                                size: buttonSize,
                                                loading: externalLoading != undefined ? externalLoading : loading,
                                                disabled: disabled,
                                                onClick: onOk,
                                                full: fullWidthBtn,
                                                className: okButtonClass
                                            },
                                            cancel: {
                                                title: cancelButtonCaption,
                                                size: buttonSize,
                                                onClick: onCancel,
                                                loading: externalLoading != undefined ? externalLoading : loading,
                                                full: fullWidthBtn,
                                                className: cancelButtonClass
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SappModal);


/***/ }),

/***/ 44094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78903);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82684);
/* harmony import */ var _SappModalV2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89186);




function SappModalImage(param) {
    var src = param.src, setSrc = param.setSrc;
    var handleClose = function() {
        setSrc(undefined);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SappModalV2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        open: !!src,
        okButtonCaption: "Yes",
        cancelButtonCaption: "No",
        handleCancel: handleClose,
        position: "center",
        showFooter: false,
        isContentFull: false,
        title: "",
        onOk: function() {},
        classNameModal: "sapp-preview--image",
        width: "65%",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "mx-auto w-fit min-w-[100%] max-w-full md:min-h-[350px]",
            children: src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: src,
                width: "1000",
                height: "1000",
                className: "h-full max-h-[550px] w-full object-contain md:min-h-[500px] ",
                alt: "image",
                loading: "eager",
                priority: true
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SappModalImage);


/***/ }),

/***/ 89186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19888);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var _button_ButtonCancelSubmit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20010);




var SappModalV2 = function(param) {
    var children = param.children, open = param.open, title = param.title, handleCancel = param.handleCancel, _showFooter = param.showFooter, showFooter = _showFooter === void 0 ? true : _showFooter, _footerButtonClassName = param.footerButtonClassName, footerButtonClassName = _footerButtonClassName === void 0 ? "justify-between flex gap-3" : _footerButtonClassName, color = param.color, colorCancel = param.colorCancel, showOkButton = param.showOkButton, showCancelButton = param.showCancelButton, revertFunction = param.revertFunction, okButtonCaption = param.okButtonCaption, _buttonSize = param.buttonSize, buttonSize = _buttonSize === void 0 ? "small" : _buttonSize, externalLoading = param.externalLoading, loading = param.loading, disabled = param.disabled, onOk = param.onOk, fullWidthBtn = param.fullWidthBtn, okButtonClass = param.okButtonClass, cancelButtonCaption = param.cancelButtonCaption, cancelButtonClass = param.cancelButtonClass, classNameModal = param.classNameModal, _width = param.width, width = _width === void 0 ? 630 : _width, handleClose = param.handleClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        footer: false,
        title: title,
        centered: true,
        open: open,
        closeIcon: false,
        className: classNameModal !== null && classNameModal !== void 0 ? classNameModal : "sapp-modal",
        onCancel: handleClose || handleCancel,
        width: width,
        children: [
            children,
            showFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative pt-5 md:pt-9",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_ButtonCancelSubmit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    revertFunction: revertFunction,
                    className: footerButtonClassName,
                    color: color,
                    colorCancel: colorCancel,
                    showOkButton: showOkButton,
                    showCancelButton: showCancelButton,
                    submit: {
                        title: okButtonCaption,
                        size: buttonSize,
                        loading: externalLoading != undefined ? externalLoading : loading,
                        disabled: disabled,
                        onClick: onOk,
                        full: fullWidthBtn,
                        className: okButtonClass
                    },
                    cancel: {
                        title: cancelButtonCaption,
                        size: buttonSize,
                        onClick: handleCancel,
                        loading: externalLoading != undefined ? externalLoading : loading,
                        full: fullWidthBtn,
                        className: cancelButtonClass
                    }
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SappModalV2);


/***/ }),

/***/ 21849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19888);
/* harmony import */ var _button_ButtonCancelSubmit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20010);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57368);




var SappModalV3 = function(param) {
    var open = param.open, title = param.title, handleCancel = param.handleCancel, _showFooter = param.showFooter, showFooter = _showFooter === void 0 ? true : _showFooter, _footerButtonClassName = param.footerButtonClassName, footerButtonClassName = _footerButtonClassName === void 0 ? "justify-between flex gap-3 flex flex-col-reverse gap-6" : _footerButtonClassName, color = param.color, colorCancel = param.colorCancel, showOkButton = param.showOkButton, showCancelButton = param.showCancelButton, revertFunction = param.revertFunction, okButtonCaption = param.okButtonCaption, _buttonSize = param.buttonSize, buttonSize = _buttonSize === void 0 ? "small" : _buttonSize, externalLoading = param.externalLoading, loading = param.loading, disabled = param.disabled, onOk = param.onOk, fullWidthBtn = param.fullWidthBtn, okButtonClass = param.okButtonClass, cancelButtonCaption = param.cancelButtonCaption, cancelButtonClass = param.cancelButtonClass, classNameModal = param.classNameModal, _width = param.width, width = _width === void 0 ? 630 : _width, handleClose = param.handleClose, header = param.header, icon = param.icon, content = param.content, children = param.children, _isMaskClosable = param.isMaskClosable, isMaskClosable = _isMaskClosable === void 0 ? true : _isMaskClosable, headerClassName = param.headerClassName, _isClosable = param.isClosable, isClosable = _isClosable === void 0 ? false : _isClosable;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        footer: false,
        title: title,
        centered: true,
        open: open,
        closeIcon: false,
        className: classNameModal !== null && classNameModal !== void 0 ? classNameModal : "sapp-modal",
        onCancel: isClosable ? handleClose : handleClose || handleCancel,
        width: width,
        maskClosable: isMaskClosable,
        closable: isClosable,
        children: [
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-fit rounded-full bg-secondary",
                    children: icon
                })
            }),
            header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("mt-6 flex justify-center text-3xl font-semibold text-bw-1 ".concat((0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                    "mb-4": !content || !children
                })), headerClassName),
                children: header
            }),
            (content || children) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mb-12 mt-4 text-center text-medium-sm text-gray-1",
                children: content !== null && content !== void 0 ? content : children
            }),
            showFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_ButtonCancelSubmit__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    revertFunction: revertFunction,
                    className: footerButtonClassName,
                    color: color,
                    colorCancel: colorCancel,
                    showOkButton: showOkButton,
                    showCancelButton: showCancelButton,
                    submit: {
                        title: okButtonCaption,
                        size: buttonSize,
                        loading: externalLoading != undefined ? externalLoading : loading,
                        disabled: disabled,
                        onClick: onOk,
                        full: fullWidthBtn,
                        className: okButtonClass
                    },
                    cancel: {
                        title: cancelButtonCaption,
                        size: buttonSize,
                        onClick: handleCancel,
                        loading: externalLoading != undefined ? externalLoading : loading,
                        full: fullWidthBtn,
                        className: cancelButtonClass
                    }
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SappModalV3);


/***/ }),

/***/ 4633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);


var ArrowIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, iconType = param.iconType, right = param.right;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            iconType === "chervon" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                className: "".concat(className, " ").concat(right ? "rotate-180 " : ""),
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M14.5301 6.08L8.6001 12L14.5301 17.92",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            iconType === "teeny" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                className: "".concat(className, " ").concat(right ? "rotate-180 " : ""),
                width: "6",
                height: "20",
                viewBox: "0 0 8 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M7.06508 22.4001L0.998413 12.0001L7.06508 1.6001",
                    stroke: "currentColor",
                    strokeLinecap: "square"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowIcon);


/***/ }),

/***/ 52888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75367);
/* harmony import */ var src_common_ErrorMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68507);
/* harmony import */ var _SAPPRadio__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96955);
/* harmony import */ var _tags_YourAnswer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42549);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10103);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);






var HookFormRadioGroup = function(param) {
    var name = param.name, control = param.control, defaultValue = param.defaultValue, options = param.options, direction = param.direction, separator = param.separator, gap = param.gap, onChange = param.onChange, _justify = param.justify, justify = _justify === void 0 ? "between" : _justify, _labelClass = param.labelClass, labelClass = _labelClass === void 0 ? "" : _labelClass, _labelClassChecked = param.labelClassChecked, labelClassChecked = _labelClassChecked === void 0 ? "" : _labelClassChecked, disabled = param.disabled, corrects = param.corrects;
    var count_items = (options === null || options === void 0 ? void 0 : options.length) - 1;
    gap = gap ? gap : direction === "horizontal" ? "gap-6" : "gap-4";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .Controller */ .Qr, {
        control: control,
        name: name,
        defaultValue: defaultValue,
        render: function(param) {
            var field = param.field, error = param.fieldState.error;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (direction === "horizontal" ? "_horizontal flex flex-wrap" : "_vertical flex flex-col") + " ".concat(gap, " ") + " ".concat(justify === "between" ? "justify-between" : justify == "center" ? "justify-center" : justify === "start" ? "justify-start" : "justify-end"),
                        children: options.map(function(option, index) {
                            var state;
                            var stateLabel = "";
                            var checked = option.value.toString() === field.value;
                            var correctCheck = (corrects === null || corrects === void 0 ? void 0 : corrects[option.value]) || false;
                            if (!!corrects) {
                                if (corrects === null || corrects === void 0 ? void 0 : corrects[option.value]) {
                                    state = "success";
                                    stateLabel = "text-state-success";
                                } else if (checked) {
                                    state = "error";
                                    stateLabel = "text-state-error";
                                }
                            }
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "".concat(!!corrects && "pointer-events-none"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex flex-row",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                            className: "flex flex-row items-start gap-3 ".concat((option.disabled !== undefined ? option.disabled : disabled) ? "cursor-not-allowed opacity-60" : "cursor-pointer"),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SAPPRadio__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                    name: field.name,
                                                    disabled: option.disabled !== undefined ? option.disabled : disabled,
                                                    onChange: function(e) {
                                                        onChange && onChange(e);
                                                        field.onChange(e.target.value);
                                                    },
                                                    value: option.value.toString(),
                                                    checked: checked,
                                                    className: "mt-[3px] flex-none",
                                                    size: "small",
                                                    state: state
                                                }, index),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    className: "flex-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "".concat(option.value === field.value ? " ".concat(stateLabel, " ").concat(labelClassChecked ? labelClassChecked : "") : " ".concat(stateLabel, " ").concat(labelClass ? labelClass : ""), " fw-bold flex-1 text-base"),
                                                            children: [
                                                                option.label,
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tags_YourAnswer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                    show: checked && !!corrects
                                                                })
                                                            ]
                                                        }),
                                                        option.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "text-sm text-gray-500",
                                                            children: option.description
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                     false && /*#__PURE__*/ 0
                                ]
                            }, (0,lodash__WEBPACK_IMPORTED_MODULE_4__.uniqueId)("check"));
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_common_ErrorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        children: error === null || error === void 0 ? void 0 : error.message
                    })
                ]
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HookFormRadioGroup);


/***/ }),

/***/ 96955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);


var STATE = {
    success: "checked:bg-radio-success-checked checked:text-transparent checked:hover:bg-radio-success-checked checked:focus:bg-radio-success-checked",
    error: "checked:bg-radio-error-checked checked:text-transparent checked:hover:bg-radio-error-checked checked:focus:bg-radio-error-checked",
    default: "checked:bg-radio-default-checked checked:text-transparent checked:hover:bg-radio-default-checked checked:focus:bg-radio-default-checked"
};
var SIZES = {
    small: "w-4.5 h-4.5",
    medium: "w-[24px] h-[24px]",
    lager: "w-[30px] h-[30px]"
};
var SAPPRadio = function(param) {
    var name = param.name, value = param.value, ktCheck = param.ktCheck, checkTarget = param.checkTarget, checked = param.checked, onChange = param.onChange, _className = param.className, className = _className === void 0 ? "" : _className, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _state = param.state, state = _state === void 0 ? "default" : _state, _size = param.size, size = _size === void 0 ? "medium" : _size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "inline-block ".concat(SIZES[size], " ").concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
            name: name,
            className: "".concat(STATE[state], " block h-full w-full rounded-full border-0 border-transparent bg-radio-normal bg-center bg-no-repeat  outline-none ring-0 ring-offset-0 focus:outline-none focus:ring-0 focus:ring-offset-0 ").concat(disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"),
            type: "radio",
            "data-kt-check": ktCheck,
            "data-kt-check-target": checkTarget,
            checked: checked,
            onChange: onChange,
            disabled: disabled,
            value: value === null || value === void 0 ? void 0 : value.toString()
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SAPPRadio);


/***/ }),

/***/ 88012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37559);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _components_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26449);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82684);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50976);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12285);






var HookFormSelect = function(param) {
    var className = param.className, defaultValue = param.defaultValue, noOptionsMessage = param.noOptionsMessage, _required = param.required, required = _required === void 0 ? false : _required, options = param.options, _isMulti = param.isMulti, isMulti = _isMulti === void 0 ? false : _isMulti, onChange = param.onChange, placeholder = param.placeholder, value = param.value, isDisabled = param.isDisabled, onMenuScrollToBottom = param.onMenuScrollToBottom, _classParent = param.classParent, classParent = _classParent === void 0 ? "" : _classParent, _isClearable = param.isClearable, isClearable = _isClearable === void 0 ? false : _isClearable, _isSearchable = param.isSearchable, isSearchable = _isSearchable === void 0 ? true : _isSearchable, _isResultSelect = param.isResultSelect, isResultSelect = _isResultSelect === void 0 ? false : _isResultSelect, onFocus = param.onFocus, onBlur = param.onBlur, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, maxMenuHeight = param.maxMenuHeight;
    var DropdownIndicator = function(props) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_3__.c.DropdownIndicator, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                type: "arrow-bottom"
            })
        }));
    };
    var onMenuOpen = function() {
        setTimeout(function() {
            var selectedEl = document.querySelector('[aria-selected="true"]');
            if (selectedEl) {
                selectedEl.scrollIntoView({
                    behavior: "instant",
                    block: "center",
                    inline: "center"
                });
            }
        }, 15);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "select-options ".concat(classParent),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
            required: required,
            isMulti: isMulti,
            options: options,
            defaultValue: defaultValue,
            className: "".concat(isResultSelect ? "select-result" : "select-single", " ").concat(className),
            classNamePrefix: "select",
            instanceId: "selectInstanceId",
            placeholder: placeholder,
            onChange: onChange,
            value: value,
            isDisabled: isDisabled,
            onMenuScrollToBottom: onMenuScrollToBottom,
            isClearable: isClearable,
            isSearchable: isSearchable,
            components: {
                DropdownIndicator: DropdownIndicator
            },
            maxMenuHeight: maxMenuHeight,
            onMenuOpen: onMenuOpen,
            noOptionsMessage: noOptionsMessage,
            onFocus: function(e) {
                onFocus && onFocus(e);
            },
            onBlur: function(e) {
                onBlur && onBlur(e);
            },
            isLoading: isLoading
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HookFormSelect);


/***/ }),

/***/ 27869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);

var TextSkeleton = function(param) {
    var children = param.children, loading = param.loading, _length = param.length, length = _length === void 0 ? 1 : _length, widths = param.widths;
    var mockData = new Array((widths === null || widths === void 0 ? void 0 : widths.length) ? widths.length : length).fill(0);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: mockData.map(function(_, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    role: "status",
                    className: "mt-6 animate-pulse border-1.5 border-solid border-default p-6",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb-3 h-7 rounded-full bg-gray-200 dark:bg-gray-700"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "h-7 rounded-full bg-gray-200 dark:bg-gray-700"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mt-5 flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "me-3 h-6 w-20 rounded-full bg-gray-200 dark:bg-gray-700"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "me-3 h-6 w-16 rounded-full bg-gray-200 dark:bg-gray-700"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "h-6 w-16 rounded-full bg-gray-200 dark:bg-gray-700"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "sr-only",
                            children: "Loading..."
                        })
                    ]
                }, index);
            })
        }) : children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextSkeleton);


/***/ }),

/***/ 42549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);


var YourAnswer = function(param) {
    var show = param.show;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: show && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "ml-3 inline-block max-h-5.5 whitespace-nowrap rounded-sm border border-gray-2 bg-gray-4 px-2 text-ssm font-normal text-bw-1",
            children: "Your Answer"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (YourAnswer);


/***/ }),

/***/ 67738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ video_SAPPVideo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(51224);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(62691);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(21967);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(37559);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(52621);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./src/styles/components/SAPPVideo.module.scss
var SAPPVideo_module = __webpack_require__(96423);
var SAPPVideo_module_default = /*#__PURE__*/__webpack_require__.n(SAPPVideo_module);
// EXTERNAL MODULE: ./src/utils/constants/index.ts + 3 modules
var constants = __webpack_require__(15183);
// EXTERNAL MODULE: ./src/components/icons/index.tsx
var icons = __webpack_require__(26449);
// EXTERNAL MODULE: ./src/utils/helpers/index.ts
var helpers = __webpack_require__(71836);
// EXTERNAL MODULE: ./src/components/base/clickoutside/HookClick.tsx
var HookClick = __webpack_require__(87248);
// EXTERNAL MODULE: ./src/components/base/pagination/ArrowIcon.tsx
var ArrowIcon = __webpack_require__(4633);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(60071);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./node_modules/@cloudflare/stream-react/dist/stream-react.esm.js

var sdkScriptLocation = "https://embed.cloudflarestream.com/embed/sdk.latest.js"; // This needs to be wrapped as such for two reasons:
// - Stream is a function, and useState invokes functions immediately and uses the return value.
// - We need to check typeof on window to ensure safety for server side rendering.

var safelyAccessStreamSDK = function safelyAccessStreamSDK() {
  if (typeof window === "undefined") return undefined;
  return window.Stream;
};
function useStreamSDK() {
  var _useState = (0,react.useState)(safelyAccessStreamSDK),
    streamSdk = _useState[0],
    setStreamSdk = _useState[1];
  (0,react.useEffect)(function () {
    if (!streamSdk) {
      var existingScript = document.querySelector("script[src='" + sdkScriptLocation + "']");
      var script = existingScript !== null && existingScript !== void 0 ? existingScript : document.createElement("script");
      script.addEventListener("load", function () {
        setStreamSdk(safelyAccessStreamSDK);
      });
      if (!existingScript) {
        script.src = sdkScriptLocation;
        document.head.appendChild(script);
      }
    }
  }, [streamSdk]);
  return streamSdk;
}
function useIframeSrc(src, _ref) {
  var muted = _ref.muted,
    preload = _ref.preload,
    loop = _ref.loop,
    autoplay = _ref.autoplay,
    controls = _ref.controls,
    poster = _ref.poster,
    primaryColor = _ref.primaryColor,
    letterboxColor = _ref.letterboxColor,
    adUrl = _ref.adUrl,
    startTime = _ref.startTime,
    defaultTextTrack = _ref.defaultTextTrack,
    customerCode = _ref.customerCode;
  var paramString = [poster && "poster=" + encodeURIComponent(poster), adUrl && "ad-url=" + encodeURIComponent(adUrl), defaultTextTrack && "defaultTextTrack=" + encodeURIComponent(defaultTextTrack), primaryColor && "primaryColor=" + encodeURIComponent(primaryColor), letterboxColor && "letterboxColor=" + encodeURIComponent(letterboxColor), startTime && "startTime=" + startTime, muted && "muted=true", preload && "preload=" + preload, loop && "loop=true", autoplay && "autoplay=true", !controls && "controls=false"].filter(Boolean).join("&");
  var iframeSrc = (0,react.useMemo)(function () {
    return customerCode ? "https://customer-" + customerCode + ".cloudflarestream.com/" + src + "/iframe?" + paramString : "https://iframe.cloudflarestream.com/" + src + "?" + paramString;
  },
  // we intentionally do NOT include paramString here because we want
  // to avoid changing the URL when these options change. Changes to
  // these options will instead be handled separately via the SDK.
  []);
  return iframeSrc;
}
function validSrcUrl(str) {
  try {
    var url = new URL(str);
    return url.hostname.endsWith("videodelivery.net") || url.hostname.endsWith("cloudflarestream.com");
  } catch (_unused) {
    return false;
  }
}

/**
 * Hook for syncing properties to the SDK api when they change
 */

function useProperty(name, ref, value) {
  (0,react.useEffect)(function () {
    if (!ref.current || value === undefined) return;
    var el = ref.current;
    el[name] = value;
  }, [name, value, ref]);
}
/**
 * Hook for binding event listeners to the player.
 */

function useEvent(event, ref, callback) {
  if (callback === void 0) {
    callback = noop;
  }
  (0,react.useEffect)(function () {
    if (!ref.current) return;
    var el = ref.current;
    el.addEventListener(event, callback); // clean up

    return function () {
      return el.removeEventListener(event, callback);
    };
  }, [callback, event, ref]);
} // Declaring a single noop function that will retain object
// identity across renders and prevent unnecessary rebinding
// when no callback is provided

var noop = function noop() {};
var Stream = function Stream(props) {
  var streamSdk = useStreamSDK();
  return streamSdk ? react.createElement(StreamEmbed, Object.assign({}, props)) : null;
};
var responsiveIframeStyles = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  height: "100%",
  width: "100%"
};
var Container = function Container(_ref) {
  var children = _ref.children,
    responsive = _ref.responsive,
    className = _ref.className,
    videoDimensions = _ref.videoDimensions;
  var videoHeight = videoDimensions.videoHeight,
    videoWidth = videoDimensions.videoWidth;
  var responsiveStyles = (0,react.useMemo)(function () {
    return {
      position: "relative",
      paddingTop: videoWidth > 0 ? videoHeight / videoWidth * 100 + "%" : undefined
    };
  }, [videoWidth, videoHeight]);
  return react.createElement("div", {
    className: className,
    style: responsive ? responsiveStyles : undefined
  }, children);
};
var StreamEmbed = function StreamEmbed(_ref2) {
  var src = _ref2.src,
    customerCode = _ref2.customerCode,
    adUrl = _ref2.adUrl,
    _ref2$controls = _ref2.controls,
    controls = _ref2$controls === void 0 ? false : _ref2$controls,
    _ref2$muted = _ref2.muted,
    muted = _ref2$muted === void 0 ? false : _ref2$muted,
    _ref2$autoplay = _ref2.autoplay,
    autoplay = _ref2$autoplay === void 0 ? false : _ref2$autoplay,
    _ref2$loop = _ref2.loop,
    loop = _ref2$loop === void 0 ? false : _ref2$loop,
    _ref2$preload = _ref2.preload,
    preload = _ref2$preload === void 0 ? "metadata" : _ref2$preload,
    primaryColor = _ref2.primaryColor,
    letterboxColor = _ref2.letterboxColor,
    defaultTextTrack = _ref2.defaultTextTrack,
    height = _ref2.height,
    width = _ref2.width,
    poster = _ref2.poster,
    currentTime = _ref2.currentTime,
    _ref2$volume = _ref2.volume,
    volume = _ref2$volume === void 0 ? 1 : _ref2$volume,
    _ref2$playbackRate = _ref2.playbackRate,
    playbackRate = _ref2$playbackRate === void 0 ? 1 : _ref2$playbackRate,
    startTime = _ref2.startTime,
    streamRef = _ref2.streamRef,
    _ref2$responsive = _ref2.responsive,
    responsive = _ref2$responsive === void 0 ? true : _ref2$responsive,
    className = _ref2.className,
    title = _ref2.title,
    onAbort = _ref2.onAbort,
    onCanPlay = _ref2.onCanPlay,
    onCanPlayThrough = _ref2.onCanPlayThrough,
    onDurationChange = _ref2.onDurationChange,
    onEnded = _ref2.onEnded,
    onError = _ref2.onError,
    onLoadedData = _ref2.onLoadedData,
    onLoadedMetaData = _ref2.onLoadedMetaData,
    onLoadStart = _ref2.onLoadStart,
    onPause = _ref2.onPause,
    onPlay = _ref2.onPlay,
    onPlaying = _ref2.onPlaying,
    onProgress = _ref2.onProgress,
    onRateChange = _ref2.onRateChange,
    onResize = _ref2.onResize,
    onSeeked = _ref2.onSeeked,
    onSeeking = _ref2.onSeeking,
    onStalled = _ref2.onStalled,
    onSuspend = _ref2.onSuspend,
    onTimeUpdate = _ref2.onTimeUpdate,
    onVolumeChange = _ref2.onVolumeChange,
    onWaiting = _ref2.onWaiting,
    onStreamAdStart = _ref2.onStreamAdStart,
    onStreamAdEnd = _ref2.onStreamAdEnd,
    onStreamAdTimeout = _ref2.onStreamAdTimeout;
  var internalRef = (0,react.useRef)();
  var ref = streamRef !== null && streamRef !== void 0 ? streamRef : internalRef;
  var _useState = (0,react.useState)({
      videoHeight: 0,
      videoWidth: 0
    }),
    videoDimensions = _useState[0],
    setVideoDimensions = _useState[1];
  var iframeRef = (0,react.useRef)(null);
  var computedSrc = useIframeSrc(src, {
    customerCode: customerCode,
    muted: muted,
    preload: preload,
    loop: loop,
    autoplay: autoplay,
    controls: controls,
    poster: poster,
    primaryColor: primaryColor,
    letterboxColor: letterboxColor,
    adUrl: adUrl,
    defaultTextTrack: defaultTextTrack,
    startTime: startTime
  }); // While it's easier for most consumers to simply provide the video UID
  // or signed token and have us compute the iframe's src for them, some
  // consumers may need to manually specify the iframe's src.

  var iframeSrc = validSrcUrl(src) ? src : computedSrc;
  useProperty("muted", ref, muted);
  useProperty("controls", ref, controls);
  useProperty("src", ref, src);
  useProperty("autoplay", ref, autoplay);
  useProperty("currentTime", ref, currentTime);
  useProperty("loop", ref, loop);
  useProperty("preload", ref, preload);
  useProperty("primaryColor", ref, primaryColor);
  useProperty("letterboxColor", ref, letterboxColor);
  useProperty("volume", ref, volume);
  useProperty("playbackRate", ref, playbackRate); // instantiate API after properties are bound because we want undefined
  // values to be set before defining the properties

  (0,react.useEffect)(function () {
    var Stream = safelyAccessStreamSDK();
    if (iframeRef.current && Stream) {
      var api = Stream(iframeRef.current);
      ref.current = api;
      var videoHeight = api.videoHeight,
        videoWidth = api.videoWidth;
      if (videoHeight && videoWidth) setVideoDimensions({
        videoHeight: videoHeight,
        videoWidth: videoWidth
      });
    }
  }, []); // bind events

  useEvent("abort", ref, onAbort);
  useEvent("canplay", ref, onCanPlay);
  useEvent("canplaythrough", ref, onCanPlayThrough);
  useEvent("durationchange", ref, onDurationChange);
  useEvent("ended", ref, onEnded);
  useEvent("error", ref, onError);
  useEvent("loadeddata", ref, onLoadedData);
  useEvent("loadedmetadata", ref, onLoadedMetaData);
  useEvent("loadstart", ref, onLoadStart);
  useEvent("pause", ref, onPause);
  useEvent("play", ref, onPlay);
  useEvent("playing", ref, onPlaying);
  useEvent("progress", ref, onProgress);
  useEvent("ratechange", ref, onRateChange);
  useEvent("seeked", ref, onSeeked);
  useEvent("seeking", ref, onSeeking);
  useEvent("stalled", ref, onStalled);
  useEvent("suspend", ref, onSuspend);
  useEvent("timeupdate", ref, onTimeUpdate);
  useEvent("volumechange", ref, onVolumeChange);
  useEvent("waiting", ref, onWaiting);
  useEvent("stream-adstart", ref, onStreamAdStart);
  useEvent("stream-adend", ref, onStreamAdEnd);
  useEvent("stream-adtimeout", ref, onStreamAdTimeout);
  useEvent("resize", ref, function (e) {
    if (ref.current) {
      var _ref$current = ref.current,
        videoHeight = _ref$current.videoHeight,
        videoWidth = _ref$current.videoWidth;
      setVideoDimensions({
        videoHeight: videoHeight,
        videoWidth: videoWidth
      });
      onResize && onResize(e);
    }
  });
  return react.createElement(Container, {
    className: className,
    responsive: responsive,
    videoDimensions: videoDimensions
  }, react.createElement("iframe", {
    ref: iframeRef,
    src: iframeSrc,
    title: title,
    style: responsive ? responsiveIframeStyles : undefined,
    frameBorder: 0,
    height: height,
    width: width,
    allow: "accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;",
    allowFullScreen: true
  }));
};

// EXTERNAL MODULE: ./src/services/requestV2.ts
var requestV2 = __webpack_require__(91002);
// EXTERNAL MODULE: ./src/assets/icons/index.tsx + 2 modules
var assets_icons = __webpack_require__(34648);
// EXTERNAL MODULE: ./src/components/mycourses/activity/documents/QuizComponent.tsx
var QuizComponent = __webpack_require__(78047);
// EXTERNAL MODULE: ./src/components/v2/base/button/ButtonCancelSubmit.tsx
var ButtonCancelSubmit = __webpack_require__(75729);
// EXTERNAL MODULE: ./src/constants/index.ts + 4 modules
var src_constants = __webpack_require__(43743);
;// CONCATENATED MODULE: ./src/components/mycourses/activity/documents/FullScreenQuizComponent.tsx





var FullScreenQuizComponent = function(param) {
    var modalOpen = param.modalOpen, finishAll = param.finishAll, isConfirmQuestion = param.isConfirmQuestion, activityId = param.activityId, tabId = param.tabId, quizId = param.quizId, questionRef = param.questionRef, activeQuestion = param.activeQuestion, document_id = param.document_id, grading_preference = param.grading_preference, handleSubmitQuestion = param.handleSubmitQuestion, handleCancelQuestion = param.handleCancelQuestion;
    var modalRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var handleClickOutside = function(event) {
            if (modalRef.current && !modalRef.current.contains(event.target) && handleCancelQuestion) {
                handleCancelQuestion();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        handleCancelQuestion
    ]);
    if (!modalOpen) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "absolute bottom-0 left-0 right-0 top-0 z-50 flex items-center justify-center bg-overlay-control",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: modalRef,
            className: "rounded-lg bg-white p-6 shadow-lg",
            style: {
                width: src_constants/* QUIZ_MODAL_WIDTH */.cx
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuizComponent/* default */.Z, {
                        activityId: activityId,
                        tabId: tabId,
                        quizId: quizId,
                        ref: questionRef,
                        activeQuestion: activeQuestion,
                        showCorrect: true,
                        document_id: document_id,
                        grading_preference: grading_preference
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-6 md:pt-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCancelSubmit/* default */.Z, {
                            className: "flex flex-row-reverse justify-between",
                            submit: {
                                title: finishAll ? "Finish" : !isConfirmQuestion ? "Submit" : "Finish",
                                className: "!h-9.5",
                                onClick: handleSubmitQuestion
                            },
                            cancel: {
                                title: finishAll ? "" : !isConfirmQuestion ? "Skip" : "",
                                className: "!h-9.5",
                                onClick: handleCancelQuestion,
                                isUnderLine: false
                            }
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var documents_FullScreenQuizComponent = (FullScreenQuizComponent);

;// CONCATENATED MODULE: ./src/components/base/video/SAPPVideo.tsx



















var SAPPVideo = function(param) {
    var options = param.options, _pauseOnSeek = param.pauseOnSeek, pauseOnSeek = _pauseOnSeek === void 0 ? false : _pauseOnSeek, streamRef = param.streamRef, _hideVideo = param.hideVideo, hideVideo = _hideVideo === void 0 ? false : _hideVideo, _openQuestion = param.openQuestion, openQuestion = _openQuestion === void 0 ? false : _openQuestion, timeQuiz = param.timeQuiz, thumbnail = param.thumbnail, children = param.children, modalOpen = param.modalOpen, finishAll = param.finishAll, isConfirmQuestion = param.isConfirmQuestion, activityId = param.activityId, tabId = param.tabId, quizId = param.quizId, questionRef = param.questionRef, activeQuestion = param.activeQuestion, document_id = param.document_id, grading_preference = param.grading_preference, handleCancelQuestion = param.handleCancelQuestion, handleSubmitQuestion = param.handleSubmitQuestion;
    var resetStreamHandlers = // Time and btn will be reset to its original state
    function resetStreamHandlers() {
        var ref, ref1;
        if (timeElapsedRef.current) {
            timeElapsedRef.current.innerText = "00:00";
        }
        var playIcon = playButtonRef === null || playButtonRef === void 0 ? void 0 : (ref = playButtonRef.current) === null || ref === void 0 ? void 0 : ref.querySelector(".play");
        var pauseIcon = playButtonRef === null || playButtonRef === void 0 ? void 0 : (ref1 = playButtonRef.current) === null || ref1 === void 0 ? void 0 : ref1.querySelector(".pause");
        if (playIcon && pauseIcon) {
            var ref2, ref3, ref4;
            playButtonRef === null || playButtonRef === void 0 ? void 0 : (ref2 = playButtonRef.current) === null || ref2 === void 0 ? void 0 : ref2.setAttribute("data-title", "Play");
            playIcon === null || playIcon === void 0 ? void 0 : (ref3 = playIcon.classList) === null || ref3 === void 0 ? void 0 : ref3.remove("hidden");
            pauseIcon === null || pauseIcon === void 0 ? void 0 : (ref4 = pauseIcon.classList) === null || ref4 === void 0 ? void 0 : ref4.add("hidden");
        }
    };
    var togglePlay = // togglePlay toggles the playback state of the video.
    // If the video playback is paused or ended, the video is played
    // otherwise, the video is paused
    function togglePlay() {
        var ref, ref1;
        if ((streamRef === null || streamRef === void 0 ? void 0 : (ref = streamRef.current) === null || ref === void 0 ? void 0 : ref.paused) || (streamRef === null || streamRef === void 0 ? void 0 : (ref1 = streamRef.current) === null || ref1 === void 0 ? void 0 : ref1.ended)) {
            var ref2;
            (ref2 = streamRef.current) === null || ref2 === void 0 ? void 0 : ref2.play();
        } else {
            var ref3;
            (ref3 = streamRef.current) === null || ref3 === void 0 ? void 0 : ref3.pause();
        }
    };
    var updatePlayButton = // updatePlayButton updates the playback icon and tooltip
    // depending on the playback state
    function updatePlayButton() {
        var ref, ref1, ref2;
        var playIcon = playButtonRef === null || playButtonRef === void 0 ? void 0 : (ref = playButtonRef.current) === null || ref === void 0 ? void 0 : ref.querySelector(".play");
        var pauseIcon = playButtonRef === null || playButtonRef === void 0 ? void 0 : (ref1 = playButtonRef.current) === null || ref1 === void 0 ? void 0 : ref1.querySelector(".pause");
        if (streamRef === null || streamRef === void 0 ? void 0 : (ref2 = streamRef.current) === null || ref2 === void 0 ? void 0 : ref2.paused) {
            var ref3, ref4, ref5;
            playButtonRef === null || playButtonRef === void 0 ? void 0 : (ref3 = playButtonRef.current) === null || ref3 === void 0 ? void 0 : ref3.setAttribute("data-title", "Play");
            playIcon === null || playIcon === void 0 ? void 0 : (ref4 = playIcon.classList) === null || ref4 === void 0 ? void 0 : ref4.remove("hidden");
            pauseIcon === null || pauseIcon === void 0 ? void 0 : (ref5 = pauseIcon.classList) === null || ref5 === void 0 ? void 0 : ref5.add("hidden");
        } else {
            var ref6, ref7, ref8;
            playButtonRef === null || playButtonRef === void 0 ? void 0 : (ref6 = playButtonRef.current) === null || ref6 === void 0 ? void 0 : ref6.setAttribute("data-title", "Pause");
            playIcon === null || playIcon === void 0 ? void 0 : (ref7 = playIcon.classList) === null || ref7 === void 0 ? void 0 : ref7.add("hidden");
            pauseIcon === null || pauseIcon === void 0 ? void 0 : (ref8 = pauseIcon.classList) === null || ref8 === void 0 ? void 0 : ref8.remove("hidden");
        }
    };
    var initializeVideo = // initializeVideo sets the video duration, and maximum value of the
    // progressBar
    function initializeVideo() {
        var ref, ref1, ref2, ref3;
        var videoDuration = Math.round(streamRef === null || streamRef === void 0 ? void 0 : (ref = streamRef.current) === null || ref === void 0 ? void 0 : ref.duration);
        seekRef === null || seekRef === void 0 ? void 0 : (ref1 = seekRef.current) === null || ref1 === void 0 ? void 0 : ref1.setAttribute("max", String(videoDuration));
        progressBarRef === null || progressBarRef === void 0 ? void 0 : (ref2 = progressBarRef.current) === null || ref2 === void 0 ? void 0 : ref2.setAttribute("max", String(videoDuration));
        var time = (0,helpers/* formatTimeToHourMinuteSecond */.aK)(videoDuration);
        if (durationRef === null || durationRef === void 0 ? void 0 : durationRef.current) {
            durationRef.current.innerText = "".concat(time.hours !== "00" ? time.hours + ":" : "").concat(time.minutes, ":").concat(time.seconds);
            durationRef.current.setAttribute("datetime", "".concat(time.hours !== "00" ? time.hours + "h " : "").concat(time.minutes, "m ").concat(time.seconds, "s"));
        }
        var markers = (ref3 = videoControlsRef.current) === null || ref3 === void 0 ? void 0 : ref3.querySelectorAll(".marker");
        // Loop through each marker in the array
        if (timeQuiz && markers) {
            timeQuiz.forEach(function(marker, index) {
                var ref;
                var percentage = Number((ref = marker[0]) === null || ref === void 0 ? void 0 : ref.time) / videoDuration * 100;
                var leftStyle = "".concat(percentage, "%");
                var markerElement = markers[index];
                // Thêm style left vào marker
                markerElement.style.left = leftStyle;
            });
        }
    };
    var updateTimeElapsed = // updateTimeElapsed indicates how far through the video
    // the current playback is by updating the timeElapsed element
    function updateTimeElapsed() {
        var ref;
        if ((streamRef === null || streamRef === void 0 ? void 0 : streamRef.current) && (streamRef === null || streamRef === void 0 ? void 0 : (ref = streamRef.current) === null || ref === void 0 ? void 0 : ref.readyState)) {
            var ref1;
            var time = (0,helpers/* formatTimeToHourMinuteSecond */.aK)(Math.round(((ref1 = streamRef.current) === null || ref1 === void 0 ? void 0 : ref1.currentTime) || 0));
            if (timeElapsedRef.current) {
                timeElapsedRef.current.innerText = "".concat(time.hours !== "00" ? time.hours + ":" : "").concat(time.minutes, ":").concat(time.seconds);
                timeElapsedRef.current.setAttribute("datetime", "".concat(time.hours !== "00" ? time.hours + "h " : "").concat(time.minutes, "m ").concat(time.seconds, "s"));
            }
        }
    };
    var updateProgress = // updateProgress indicates how far through the video
    // the current playback is by updating the progress bar
    function updateProgress() {
        var ref;
        var currentTime = Math.round((streamRef === null || streamRef === void 0 ? void 0 : (ref = streamRef.current) === null || ref === void 0 ? void 0 : ref.currentTime) || 0);
        if (seekRef === null || seekRef === void 0 ? void 0 : seekRef.current) {
            seekRef.current.value = String(currentTime);
        }
        if (progressBarRef === null || progressBarRef === void 0 ? void 0 : progressBarRef.current) {
            progressBarRef.current.value = currentTime;
        }
    };
    var updateSeekTooltip = // updateSeekTooltip uses the position of the mouse on the progress bar to
    // roughly work out what point in the video the user will skip to if
    // the progress bar is clicked at that point
    function updateSeekTooltip(event) {
        var skipTo = Math.round(event.offsetX / event.target.clientWidth * parseInt(event.target.getAttribute("max") || "0", 10));
        var t = (0,helpers/* formatTimeToHourMinuteSecond */.aK)(skipTo);
        if ((progressBarRef === null || progressBarRef === void 0 ? void 0 : progressBarRef.current) && (seekRef === null || seekRef === void 0 ? void 0 : seekRef.current) && (seekTooltipRef === null || seekTooltipRef === void 0 ? void 0 : seekTooltipRef.current)) {
            var rect = progressBarRef.current.getBoundingClientRect();
            seekRef.current.setAttribute("data-seek", String(skipTo));
            seekTooltipRef.current.textContent = "".concat(t.hours !== "00" ? t.hours + ":" : "").concat(t.minutes, ":").concat(t.seconds);
            seekTooltipRef.current.style.left = "".concat(event.pageX - rect.left, "px");
        }
    };
    var skipAhead = // skipAhead jumps to a different point in the video when the progress bar
    // is clicked
    function skipAhead(event) {
        var skipTo = (0,_instanceof/* default */.Z)(event.target, HTMLInputElement) ? event.target.value : "0";
        streamRef.current.currentTime = parseInt(skipTo, 10);
        if (progressBarRef === null || progressBarRef === void 0 ? void 0 : progressBarRef.current) {
            progressBarRef.current.value = Number(skipTo);
        }
        if (seekRef === null || seekRef === void 0 ? void 0 : seekRef.current) {
            seekRef.current.value = skipTo;
        }
    };
    var updateVolume = // updateVolume updates the video's volume
    // and disables the muted state if active
    function updateVolume() {
        var ref;
        if (streamRef === null || streamRef === void 0 ? void 0 : (ref = streamRef.current) === null || ref === void 0 ? void 0 : ref.muted) {
            streamRef.current.muted = false;
        }
        if (volumeRef === null || volumeRef === void 0 ? void 0 : volumeRef.current) {
            streamRef.current.volume = Number(volumeRef.current.value);
            setValueVolume(Number(volumeRef.current.value));
        }
    };
    var updateVolumeIcon = // updateVolumeIcon updates the volume icon so that it correctly reflects
    // the volume of the video
    function updateVolumeIcon() {
        if (!volumeButtonRef.current) return;
        var volumeMute = volumeButtonRef.current.querySelector(".volume-mute");
        var volumeLow = volumeButtonRef.current.querySelector(".volume-low");
        var volumeHigh = volumeButtonRef.current.querySelector(".volume-high");
        if (!volumeMute || !volumeLow || !volumeHigh) return;
        var isMuted = streamRef.current.muted || streamRef.current.volume === 0;
        var isLowVolume = streamRef.current.volume > 0 && streamRef.current.volume <= 0.5;
        volumeButtonRef.current.setAttribute("data-title", isMuted ? "Unmute" : "Mute");
        volumeMute.classList.toggle("hidden", !isMuted);
        volumeLow.classList.toggle("hidden", isMuted || !isLowVolume);
        volumeHigh.classList.toggle("hidden", isMuted || isLowVolume);
    };
    var toggleMute = // toggleMute mutes or unmutes the video when executed
    // When the video is unmuted, the volume is returned to the value
    // it was set to before the video was muted
    function toggleMute() {
        if (streamRef === null || streamRef === void 0 ? void 0 : streamRef.current) {
            streamRef.current.muted = !streamRef.current.muted;
            if (streamRef.current.muted && volumeRef.current) {
                volumeRef.current.setAttribute("data-volume", volumeRef.current.value);
                volumeRef.current.value = "0";
                setValueVolume(0);
            } else if (volumeRef.current) {
                volumeRef.current.value = String(volumeRef.current.dataset.volume);
                setValueVolume(Number(volumeRef.current.dataset.volume));
            }
        }
    };
    var animatePlayback = // animatePlayback displays an animation when
    // the video is played or paused
    function animatePlayback() {
        var ref, ref1;
        var playIcon = playbackAnimationRef === null || playbackAnimationRef === void 0 ? void 0 : (ref = playbackAnimationRef.current) === null || ref === void 0 ? void 0 : ref.querySelector(".play");
        var pauseIcon = playbackAnimationRef === null || playbackAnimationRef === void 0 ? void 0 : (ref1 = playbackAnimationRef.current) === null || ref1 === void 0 ? void 0 : ref1.querySelector(".pause");
        if (playIcon && pauseIcon) {
            playIcon.classList.toggle("hidden");
            pauseIcon.classList.toggle("hidden");
        }
        if (playbackAnimationRef === null || playbackAnimationRef === void 0 ? void 0 : playbackAnimationRef.current) {
            playbackAnimationRef.current.animate([
                {
                    opacity: 1,
                    transform: "scale(1)"
                },
                {
                    opacity: 0,
                    transform: "scale(1.3)"
                }, 
            ], {
                duration: 500
            });
        }
    };
    var toggleFullScreen = // toggleFullScreen toggles the full screen state of the video
    // If the browser is currently in fullscreen mode,
    // then it should exit and vice versa.
    function toggleFullScreen() {
        var ref;
        if (document === null || document === void 0 ? void 0 : document.fullscreenElement) {
            document.exitFullscreen();
        } else if ((videoContainerRef === null || videoContainerRef === void 0 ? void 0 : videoContainerRef.current) && (videoContainerRef === null || videoContainerRef === void 0 ? void 0 : (ref = videoContainerRef.current) === null || ref === void 0 ? void 0 : ref.requestFullscreen)) {
            var ref1;
            videoContainerRef === null || videoContainerRef === void 0 ? void 0 : (ref1 = videoContainerRef.current) === null || ref1 === void 0 ? void 0 : ref1.requestFullscreen();
        }
    };
    var updateFullscreenButton = // updateFullscreenButton changes the icon of the full screen button
    // and tooltip to reflect the current full screen state of the video
    function updateFullscreenButton() {
        var ref, ref1;
        var fullScreenIcon = fullscreenButtonRef === null || fullscreenButtonRef === void 0 ? void 0 : (ref = fullscreenButtonRef.current) === null || ref === void 0 ? void 0 : ref.querySelector(".fullscreen");
        var fullScreenExitIcon = fullscreenButtonRef === null || fullscreenButtonRef === void 0 ? void 0 : (ref1 = fullscreenButtonRef.current) === null || ref1 === void 0 ? void 0 : ref1.querySelector(".fullscreen-exit");
        if ((fullscreenButtonRef === null || fullscreenButtonRef === void 0 ? void 0 : fullscreenButtonRef.current) && fullScreenIcon && fullScreenExitIcon) {
            var isFullScreen = document.fullscreenElement !== null;
            setIsFullscreen(isFullScreen);
            fullscreenButtonRef.current.setAttribute("data-title", "".concat(isFullScreen ? "Exit" : "Enter", " full screen"));
            fullScreenIcon.classList.toggle("hidden", isFullScreen);
            fullScreenExitIcon.classList.toggle("hidden", !isFullScreen);
        }
    };
    var hideControls = // hideControls hides the video controls when not in use
    // if the video is paused, the controls must remain visible
    function hideControls() {
        var ref;
        if (streamRef === null || streamRef === void 0 ? void 0 : (ref = streamRef.current) === null || ref === void 0 ? void 0 : ref.paused) {
            return;
        }
        if (videoControlsRef === null || videoControlsRef === void 0 ? void 0 : videoControlsRef.current) {
            videoControlsRef.current.classList.add("hide");
        }
    };
    var showControls = // showControls displays the video controls
    function showControls() {
        if (videoControlsRef.current) {
            videoControlsRef.current.classList.remove("hide");
            clearTimeout(hideTimerRef.current);
            hideTimerRef.current = setTimeout(hideControls, 3000);
        }
    };
    var ref = (0,react.useState)(), playerFunction = ref[0], setPlayerFunction = ref[1];
    var ref1 = (0,react.useState)(1), valueVolume = ref1[0], setValueVolume = ref1[1];
    var ref2 = (0,react.useState)(1), playbackRate = ref2[0], setPlaybackRate = ref2[1];
    var ref3 = (0,react.useState)(0), playbackQuality = ref3[0], setPlaybackQuality = ref3[1];
    var ref4 = (0,react.useState)([]), listQualitys = ref4[0], setListQualitys = ref4[1];
    var ref5 = (0,react.useState)([]), listCaptions = ref5[0], setlistCaptions = ref5[1];
    var ref6 = (0,react.useState)(false), activeCC = ref6[0], setActiveCC = ref6[1];
    var ref7 = (0,react.useState)(0), playbackCC = ref7[0], setPlaybackCC = ref7[1];
    var ref8 = (0,react.useState)(false), activeSettings = ref8[0], setActiveSettings = ref8[1];
    var ref9 = (0,react.useState)(false), activeQuality = ref9[0], setActiveQuality = ref9[1];
    var ref10 = (0,react.useState)(false), activeSpeed = ref10[0], setActiveSpeed = ref10[1];
    var ref11 = (0,react.useState)(true), loading = ref11[0], setLoading = ref11[1];
    var ref12 = (0,react.useState)(false), canPlay = ref12[0], setCanPlay = ref12[1];
    var ref13 = (0,react.useState)(0), loadingPercentage = ref13[0], setLoadingPercentage = ref13[1];
    var ref14 = (0,react.useState)(false), cloudflarePlayer = ref14[0], setCloudflarePlayer = ref14[1];
    var ref15 = (0,react.useState)(false), isFullscreen = ref15[0], setIsFullscreen = ref15[1];
    var playbackAnimationRef = (0,react.useRef)(null);
    var videoControlsRef = (0,react.useRef)(null);
    var playButtonRef = (0,react.useRef)(null);
    var seekRef = (0,react.useRef)(null);
    var seekTooltipRef = (0,react.useRef)(null);
    var volumeButtonRef = (0,react.useRef)(null);
    var volumeRef = (0,react.useRef)(null);
    var fullscreenButtonRef = (0,react.useRef)(null);
    var videoContainerRef = (0,react.useRef)(null);
    var progressBarRef = (0,react.useRef)(null);
    var timeElapsedRef = (0,react.useRef)(null);
    var durationRef = (0,react.useRef)(null);
    var listSettingsRef = (0,react.useRef)(null);
    var hideTimerRef = (0,react.useRef)(null);
    var playbackSpeeds = [
        {
            value: "0.25",
            label: "0.25"
        },
        {
            value: "0.5",
            label: "0.5"
        },
        {
            value: "0.75",
            label: "0.75"
        },
        {
            value: "1",
            label: "Normal"
        },
        {
            value: "1.25",
            label: "1.25"
        },
        {
            value: "1.5",
            label: "1.5"
        },
        {
            value: "1.75",
            label: "1.75"
        },
        {
            value: "2",
            label: "2"
        }, 
    ];
    var ref16 = (0,react.useState)(false), seeking = ref16[0], setSeeking = ref16[1];
    var dashjs;
    (0,react.useEffect)(function() {
        var player;
        var initTerminal = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, audioVideoSettings;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(options === null || options === void 0 ? void 0 : options.src)) return [
                                3,
                                6
                            ];
                            return [
                                4,
                                __webpack_require__.e(/* import() */ 7679).then(__webpack_require__.t.bind(__webpack_require__, 51295, 23))
                            ];
                        case 1:
                            dashjs = _state.sent();
                            if (!dashjs) return [
                                3,
                                5
                            ];
                            if (!((dashjs === null || dashjs === void 0 ? void 0 : dashjs.supportsMediaSource()) || !(0,helpers/* isMobileOrTablet */.ic)())) return [
                                3,
                                3
                            ];
                            player = dashjs.MediaPlayer().create();
                            audioVideoSettings = (ref = player.getSettings()) === null || ref === void 0 ? void 0 : (ref1 = ref.streaming) === null || ref1 === void 0 ? void 0 : ref1.abr;
                            audioVideoSettings.autoSwitchBitrate.video = false;
                            player.initialize(streamRef.current, "".concat(constants/* video_url */.jh).concat(options === null || options === void 0 ? void 0 : options.src, "/manifest/video.mpd"), false);
                            return [
                                4,
                                fetchCaptions("".concat(constants/* video_url */.jh).concat(options === null || options === void 0 ? void 0 : options.src, "/manifest/video.mpd"))
                            ];
                        case 2:
                            _state.sent();
                            player.updateSettings({
                                streaming: {
                                    abr: audioVideoSettings,
                                    buffer: {
                                        stableBufferTime: 30,
                                        bufferTimeAtTopQuality: 60,
                                        bufferTimeAtTopQualityLongForm: 120
                                    }
                                }
                            });
                            player.on(dashjs.MediaPlayer.events.STREAM_INITIALIZED, function() {
                                setTimeout(function() {
                                    var ref, ref1;
                                    var currentVideoQualityIndex = player.getQualityFor("video");
                                    var getListBit = player.getBitrateInfoListFor("video");
                                    player.setQualityFor("video", getListBit === null || getListBit === void 0 ? void 0 : (ref = getListBit[currentVideoQualityIndex]) === null || ref === void 0 ? void 0 : ref.qualityIndex, true);
                                    setListQualitys(getListBit);
                                    setPlaybackQuality(getListBit === null || getListBit === void 0 ? void 0 : (ref1 = getListBit[currentVideoQualityIndex]) === null || ref1 === void 0 ? void 0 : ref1.bitrate);
                                }, 1000);
                                setPlayerFunction(player);
                            });
                            player.on(dashjs.MediaPlayer.events.BUFFER_LOADED, function() {
                                setCanPlay(true);
                                setCloudflarePlayer(false);
                            });
                            player.on(dashjs.MediaPlayer.events.PLAYBACK_SEEKING, function() {
                                setSeeking(true);
                            });
                            player.on(dashjs.MediaPlayer.events.PLAYBACK_SEEKED, function() {
                                setSeeking(false);
                            });
                            return [
                                3,
                                4
                            ];
                        case 3:
                            setCanPlay(true);
                            setCloudflarePlayer(true);
                            _state.label = 4;
                        case 4:
                            return [
                                3,
                                6
                            ];
                        case 5:
                            setCanPlay(true);
                            setCloudflarePlayer(true);
                            _state.label = 6;
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function initTerminal() {
                return _ref.apply(this, arguments);
            };
        }();
        initTerminal();
        return function() {
            if (player) {
                player.reset();
                player.off(dashjs.MediaPlayer.events.PLAYBACK_SEEKING, function() {
                    return setSeeking(true);
                });
                player.off(dashjs.MediaPlayer.events.PLAYBACK_SEEKED, function() {
                    return setSeeking(false);
                });
            }
        };
    }, [
        options === null || options === void 0 ? void 0 : options.src
    ]);
    // Get list captions of video
    var fetchCaptions = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(url) {
            var response, parser, xmlDoc, adaptationSets, captions, i, mimeType, newlistCaptions, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,requestV2/* fetcher */._i)(url)
                        ];
                    case 1:
                        response = _state.sent();
                        parser = new DOMParser();
                        xmlDoc = parser.parseFromString(response, "text/xml");
                        adaptationSets = xmlDoc.getElementsByTagName("AdaptationSet");
                        captions = [];
                        for(i = 0; i < adaptationSets.length; i++){
                            mimeType = adaptationSets[i].getAttribute("mimeType");
                            if (mimeType === "text/vtt") {
                                captions.push(adaptationSets[i]);
                            }
                        }
                        newlistCaptions = captions.map(function(caption, index) {
                            var lang = caption.getAttribute("lang");
                            return {
                                lang: lang,
                                index: index
                            };
                        });
                        setlistCaptions(newlistCaptions);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchCaptions(url) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        // Add eventlisteners
        if (options === null || options === void 0 ? void 0 : options.src) {
            var ref;
            if (streamRef.current) {
                resetStreamHandlers();
                streamRef.current.addEventListener("play", updatePlayButton);
                streamRef.current.addEventListener("pause", updatePlayButton);
                streamRef.current.addEventListener("loadedmetadata", initializeVideo);
                streamRef.current.addEventListener("timeupdate", updateTimeElapsed);
                streamRef.current.addEventListener("timeupdate", updateProgress);
                streamRef.current.addEventListener("volumechange", updateVolumeIcon);
                streamRef.current.addEventListener("click", togglePlay);
                streamRef.current.addEventListener("click", animatePlayback);
                streamRef.current.addEventListener("mousemove", showControls);
                streamRef.current.addEventListener("mouseleave", hideControls);
            }
            if (videoControlsRef.current) {
                videoControlsRef.current.addEventListener("mousemove", showControls);
                videoControlsRef.current.addEventListener("mouseleave", hideControls);
            }
            if (seekRef.current) {
                seekRef.current.addEventListener("mousemove", updateSeekTooltip);
                seekRef.current.addEventListener("input", skipAhead);
            }
            if (volumeRef.current) {
                volumeRef.current.addEventListener("input", updateVolume);
            }
            if (videoContainerRef.current) {
                videoContainerRef.current.addEventListener("fullscreenchange", updateFullscreenButton);
            }
            var videoWorks = !!((ref = streamRef.current) === null || ref === void 0 ? void 0 : ref.canPlayType);
            if (videoWorks && videoControlsRef.current) {
                streamRef.current.controls = false;
                videoControlsRef.current.classList.remove("hidden");
            }
        }
        return function() {
            if (options === null || options === void 0 ? void 0 : options.src) {
                if (streamRef.current) {
                    streamRef.current.removeEventListener("play", updatePlayButton);
                    streamRef.current.removeEventListener("pause", updatePlayButton);
                    streamRef.current.removeEventListener("loadedmetadata", initializeVideo);
                    streamRef.current.removeEventListener("timeupdate", updateTimeElapsed);
                    streamRef.current.removeEventListener("timeupdate", updateProgress);
                    streamRef.current.removeEventListener("volumechange", updateVolumeIcon);
                    streamRef.current.removeEventListener("click", togglePlay);
                    streamRef.current.removeEventListener("click", animatePlayback);
                    streamRef.current.removeEventListener("mouseenter", showControls);
                    streamRef.current.removeEventListener("mouseleave", hideControls);
                }
                if (videoControlsRef.current) {
                    videoControlsRef.current.removeEventListener("mouseenter", showControls);
                    videoControlsRef.current.removeEventListener("mouseleave", hideControls);
                }
                if (seekRef.current) {
                    seekRef.current.removeEventListener("mousemove", updateSeekTooltip);
                    seekRef.current.removeEventListener("input", skipAhead);
                }
                if (volumeRef.current) {
                    volumeRef.current.removeEventListener("input", updateVolume);
                }
                if (videoContainerRef.current) {
                    videoContainerRef.current.removeEventListener("fullscreenchange", updateFullscreenButton);
                }
            }
        };
    }, [
        options === null || options === void 0 ? void 0 : options.src,
        streamRef === null || streamRef === void 0 ? void 0 : streamRef.current,
        playbackAnimationRef === null || playbackAnimationRef === void 0 ? void 0 : playbackAnimationRef.current
    ]);
    (0,react.useEffect)(function() {
        var interval;
        var delayTimeout;
        var updateLoadingPercentage = function() {
            setLoadingPercentage(function(prev) {
                if (prev < 90) {
                    return prev + 18;
                } else {
                    clearInterval(interval);
                    return prev;
                }
            });
        };
        interval = setInterval(updateLoadingPercentage, 500);
        delayTimeout = setTimeout(function() {
            clearInterval(interval);
            if (loadingPercentage <= 90) {
                setLoadingPercentage(91);
            }
        }, 3000);
        return function() {
            clearInterval(interval);
            clearTimeout(delayTimeout);
        };
    }, [
        loadingPercentage
    ]);
    (0,react.useEffect)(function() {
        if (canPlay) {
            setLoadingPercentage(100);
            setLoading(false);
        }
    }, [
        canPlay
    ]);
    // Event handler for changing video speed
    var handlePlaybackRateChange = function(event) {
        var ref;
        var target = event.target;
        var selectedSpeed = target === null || target === void 0 ? void 0 : (ref = target.dataset) === null || ref === void 0 ? void 0 : ref.speed;
        if (selectedSpeed) {
            var ref1;
            var newPlaybackRate = parseFloat(selectedSpeed);
            setPlaybackRate(newPlaybackRate);
            if (streamRef === null || streamRef === void 0 ? void 0 : (ref1 = streamRef.current) === null || ref1 === void 0 ? void 0 : ref1.playbackRate) {
                streamRef.current.playbackRate = newPlaybackRate;
            }
        }
    };
    var handleLanguageChange = function(event) {
        var ref;
        var target = event.target;
        var selectedCC = target === null || target === void 0 ? void 0 : (ref = target.dataset) === null || ref === void 0 ? void 0 : ref.cc;
        setPlaybackCC(Number(selectedCC));
        updatePlayButton();
        setTimeout(function() {
            if (playerFunction) {
                playerFunction.setTextTrack(Number(selectedCC));
                updatePlayButton();
            } else {
            // console.error("Player function is not initialized yet.");
            }
        }, 500);
    };
    // Function to change the video quality based on the selected option
    var changeQuality = function(number, bit) {
        updatePlayButton();
        setTimeout(function() {
            if (number === "auto") {
                playerFunction.updateSettings({
                    streaming: {
                        abr: {
                            autoSwitchBitrate: {
                                video: true
                            }
                        }
                    }
                });
            } else {
                playerFunction.updateSettings({
                    streaming: {
                        abr: {
                            autoSwitchBitrate: {
                                video: false
                            }
                        }
                    }
                });
                playerFunction.setQualityFor("video", number, true);
            }
            updatePlayButton();
        }, 1000);
        setPlaybackQuality(bit);
    };
    // Hook to handle clicks outside of the settings panel to close it
    var toggleSettings = function() {
        setActiveSettings(!activeSettings);
    };
    // Hook to handle clicks outside of the settings panel to close it
    (0,HookClick/* default */.Z)({
        ref: listSettingsRef,
        callback: function() {
            return setActiveSettings(false);
        }
    });
    // Filter function to remove duplicate resolutions from the qualities list
    var filterUniqueResolutions = function(qualities) {
        var resolutionMap = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = qualities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var quality = _step.value;
                var resolution = (0,helpers/* getResolution */.uG)(quality.bitrate);
                resolutionMap[resolution] = quality;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return Object.values(resolutionMap).filter(function(quality) {
            return quality !== undefined;
        });
    };
    var questionConditions = activityId && document_id && grading_preference;
    var ref17, ref18;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(loading ? "visible" : "hidden", " flex-center relative h-full w-full pt-[56.26%]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute bottom-0 left-0 right-0 top-0 h-full w-full",
                        children: thumbnail && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: (ref17 = thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail["950x535"]) !== null && ref17 !== void 0 ? ref17 : "/assets/images/default_thumbnail_video.png",
                            alt: "Thumbnail image",
                            className: "h-full w-full object-contain",
                            width: 952,
                            height: 535.5,
                            priority: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute bottom-0 left-0 right-0 top-0 h-full w-full bg-overlay-loading opacity-80 transition-opacity",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(assets_icons/* LoadingIcon */.Ho, {
                            loading: loading,
                            loadingPercentage: loadingPercentage,
                            stroke: "#ffffff"
                        })
                    })
                ]
            }),
            (options === null || options === void 0 ? void 0 : options.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: cloudflarePlayer ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "group ".concat(!hideVideo ? (SAPPVideo_module_default()).wrapper : (SAPPVideo_module_default()).hideWrapper, " ").concat(loading ? "hidden" : ""),
                    children: [
                        !isFullscreen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "popup-question",
                            children: children
                        }),
                        /*#__PURE__*/ (0,react.createElement)(Stream, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                            key: options === null || options === void 0 ? void 0 : options.src,
                            streamRef: streamRef,
                            controls: true,
                            responsive: false,
                            className: "".concat((SAPPVideo_module_default()).content),
                            onSeeking: function() {
                                if (streamRef.current && pauseOnSeek) {
                                    streamRef.current.pause();
                                }
                            },
                            autoplay: false
                        }))
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "sapp-video-custom video-container group ".concat(!hideVideo ? (SAPPVideo_module_default()).wrapper : (SAPPVideo_module_default()).hideWrapper, " ").concat(loading ? "hidden" : ""),
                    ref: videoContainerRef,
                    children: [
                        !isFullscreen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "popup-question",
                            children: children
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "playback-animation flex-center",
                            ref: playbackAnimationRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                className: "icon-svg playback-icons h-6 w-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        className: "play hidden",
                                        d: "M8.016 5.016l10.969 6.984-10.969 6.984v-13.969z"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        className: "pause",
                                        d: "M14.016 5.016h3.984v13.969h-3.984v-13.969zM6 18.984v-13.969h3.984v13.969h-3.984z"
                                    })
                                ]
                            })
                        }),
                        seeking && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "loadingOverlay",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(assets_icons/* LoadingIcon */.Ho, {
                                stroke: "#404041"
                            })
                        }),
                        /*#__PURE__*/ (0,react.createElement)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                            key: options.src,
                            ref: streamRef,
                            controls: false,
                            className: "".concat((SAPPVideo_module_default()).content),
                            poster: (ref18 = thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail["950x535"]) !== null && ref18 !== void 0 ? ref18 : "/assets/images/default_thumbnail_video.png",
                            onSeeking: function() {
                                if ((streamRef === null || streamRef === void 0 ? void 0 : streamRef.current) && pauseOnSeek && openQuestion) {
                                    streamRef.current.pause();
                                }
                            },
                            autoPlay: false,
                            disablePictureInPicture: true,
                            controlsList: "nodownload"
                        })),
                        isFullscreen && questionConditions && /*#__PURE__*/ (0,jsx_runtime.jsx)(documents_FullScreenQuizComponent, {
                            finishAll: finishAll,
                            isConfirmQuestion: isConfirmQuestion,
                            modalOpen: modalOpen,
                            activityId: activityId,
                            tabId: tabId || "",
                            quizId: quizId || "",
                            questionRef: questionRef,
                            activeQuestion: activeQuestion,
                            document_id: document_id,
                            grading_preference: grading_preference,
                            handleSubmitQuestion: handleSubmitQuestion,
                            handleCancelQuestion: handleCancelQuestion
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "video-controls flex-center absolute bottom-0 left-0 right-0 hidden h-14 w-full px-4 py-3",
                            ref: videoControlsRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-center w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "left-controls flex items-center text-white",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "btn-video mr-4 flex h-8 w-8 items-center justify-center bg-overlay-play before:-right-4",
                                                "data-title": "Play",
                                                ref: playButtonRef,
                                                onClick: function() {
                                                    togglePlay();
                                                    animatePlayback();
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                    className: "icon-svg playback-icons h-6 w-6",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            className: "play",
                                                            d: "M8.016 5.016l10.969 6.984-10.969 6.984v-13.969z"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            className: "pause hidden",
                                                            d: "M14.016 5.016h3.984v13.969h-3.984v-13.969zM6 18.984v-13.969h3.984v13.969h-3.984z"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "time flex-center mr-4 gap-1 text-xsm font-normal leading-normal text-gray-7",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                                        ref: timeElapsedRef,
                                                        children: "00:00"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: " / "
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                                        ref: durationRef,
                                                        children: "00:00"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative h-1.5 w-full text-justify",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("progress", {
                                                className: "pointer-events-none absolute top-0 h-1.5 w-full",
                                                ref: progressBarRef
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                className: "seek absolute top-0 z-10 m-0 w-full cursor-pointer",
                                                min: "0",
                                                type: "range",
                                                step: "1",
                                                ref: seekRef,
                                                defaultValue: "0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "seek-tooltip absolute top-[-50px] -ml-5 hidden bg-overlay-dark p-1 text-xsm font-semibold text-white",
                                                ref: seekTooltipRef,
                                                children: "00:00"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: timeQuiz && timeQuiz.map(function(e, i) {
                                                    var ref, ref1;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "marker absolute top-0 z-[5] h-1.5 w-1.5 bg-primary",
                                                        title: (ref = e[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.question_topic) === null || ref1 === void 0 ? void 0 : ref1.name
                                                    }, i);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "right-controls flex-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "volume-controls relative flex h-8 w-8 items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        "data-title": "Mute",
                                                        className: "btn-video volume-button",
                                                        ref: volumeButtonRef,
                                                        onClick: toggleMute,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                className: "icon-svg volume-mute ml-3 hidden h-5.5 w-5.5 scale-[0.8]",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M12 3.984v4.219l-2.109-2.109zM4.266 3l16.734 16.734-1.266 1.266-2.063-2.063q-1.547 1.313-3.656 1.828v-2.063q1.172-0.328 2.25-1.172l-4.266-4.266v6.75l-5.016-5.016h-3.984v-6h4.734l-4.734-4.734zM18.984 12q0-2.391-1.383-4.219t-3.586-2.484v-2.063q3.047 0.656 5.016 3.117t1.969 5.648q0 2.203-1.031 4.172l-1.5-1.547q0.516-1.266 0.516-2.625zM16.5 12q0 0.422-0.047 0.609l-2.438-2.438v-2.203q1.031 0.516 1.758 1.688t0.727 2.344z"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                className: "icon-svg volume-low ml-3 hidden h-6 w-5.5",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M5.016 9h3.984l5.016-5.016v16.031l-5.016-5.016h-3.984v-6zM18.516 12q0 2.766-2.531 4.031v-8.063q1.031 0.516 1.781 1.711t0.75 2.32z"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.ZP, {
                                                                type: "volume",
                                                                className: "icon-svg volume-high ml-4 text-white"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "volume-process",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            ref: volumeRef,
                                                            className: "volume w-full opacity-100",
                                                            defaultValue: valueVolume,
                                                            type: "range",
                                                            max: "1",
                                                            min: "0",
                                                            step: "0.01"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "settings-control icon-svg relative ml-4 text-white ".concat(activeSettings ? "active" : ""),
                                                ref: listSettingsRef,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        viewBox: "0 0 256 256",
                                                        onClick: function() {
                                                            return toggleSettings();
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "currentColor",
                                                            strokeMiterlimit: "10",
                                                            strokeWidth: "1",
                                                            d: "M52.1 90H37.9a5.206 5.206 0 01-5.2-5.2v-2.114c0-.329-.191-.634-.454-.725a38.833 38.833 0 01-4.375-1.816c-.246-.118-.576-.046-.802.18l-1.516 1.516a5.165 5.165 0 01-3.677 1.523 5.163 5.163 0 01-3.677-1.524L8.16 71.799a5.207 5.207 0 010-7.354l1.516-1.516c.223-.223.299-.56.181-.8a38.922 38.922 0 01-1.818-4.377c-.092-.262-.396-.452-.725-.452H5.2A5.206 5.206 0 010 52.1V37.9c0-2.867 2.333-5.2 5.2-5.2h2.115c.329 0 .633-.19.724-.454a39.153 39.153 0 011.817-4.374c.12-.246.046-.576-.181-.802L8.16 25.555a5.207 5.207 0 010-7.354L18.201 8.159a5.165 5.165 0 013.677-1.522 5.17 5.17 0 013.677 1.522l1.516 1.517c.224.223.559.3.801.18a39.096 39.096 0 014.375-1.818c.263-.091.453-.395.453-.724V5.2c0-2.867 2.333-5.2 5.2-5.2h14.2c2.867 0 5.2 2.333 5.2 5.2v2.115c0 .329.19.633.453.724a39.111 39.111 0 014.375 1.818c.247.118.575.045.802-.181l1.516-1.516a5.207 5.207 0 017.354 0L81.84 18.2a5.207 5.207 0 010 7.354l-1.516 1.516c-.227.227-.301.556-.181.802a38.6 38.6 0 011.818 4.376c.09.262.395.452.724.452H84.8c2.867 0 5.2 2.333 5.2 5.2v14.2c0 2.867-2.333 5.2-5.2 5.2h-2.114c-.329 0-.634.19-.725.454a39.153 39.153 0 01-1.815 4.373c-.119.244-.044.58.179.803l1.516 1.516a5.207 5.207 0 010 7.354L71.799 81.84a5.166 5.166 0 01-3.677 1.523 5.165 5.165 0 01-3.678-1.525l-1.514-1.513c-.228-.226-.557-.302-.803-.182a38.6 38.6 0 01-4.376 1.818c-.262.09-.452.395-.452.724V84.8A5.205 5.205 0 0152.1 90zm-12.4-7h10.6v-.314c0-3.322 2.076-6.272 5.167-7.34a31.94 31.94 0 003.588-1.491c2.936-1.434 6.481-.822 8.824 1.521l.243.242 7.495-7.495-.242-.243c-2.345-2.344-2.955-5.891-1.519-8.825a31.997 31.997 0 001.488-3.585c1.068-3.093 4.019-5.169 7.341-5.169H83V39.7h-.314c-3.322 0-6.272-2.076-7.34-5.167a31.94 31.94 0 00-1.491-3.588c-1.434-2.936-.823-6.482 1.521-8.825l.242-.243-7.495-7.495-.243.243c-2.344 2.344-5.89 2.953-8.824 1.52a32.08 32.08 0 00-3.587-1.491c-3.091-1.067-5.168-4.017-5.168-7.34V7H39.7v.314c0 3.323-2.077 6.272-5.168 7.34-1.217.42-2.424.922-3.587 1.491-2.936 1.434-6.481.823-8.825-1.52l-.243-.243-7.495 7.495.243.243c2.343 2.344 2.954 5.89 1.52 8.825a31.98 31.98 0 00-1.49 3.587c-1.068 3.092-4.018 5.168-7.34 5.168H7v10.6h.314c3.323 0 6.272 2.077 7.34 5.168a31.985 31.985 0 001.491 3.588c1.435 2.933.824 6.479-1.52 8.823l-.243.243 7.496 7.495.242-.242c2.344-2.346 5.891-2.954 8.826-1.52a31.99 31.99 0 003.585 1.489c3.092 1.068 5.168 4.019 5.168 7.341V83zm5.328-12.598a25.41 25.41 0 01-17.991-7.439c-5.265-5.265-7.947-12.561-7.359-20.016.97-12.296 10.974-22.3 23.27-23.27 7.457-.588 14.751 2.095 20.016 7.359 5.265 5.266 7.947 12.561 7.36 20.017-.971 12.297-10.975 22.3-23.271 23.27-.677.053-1.352.079-2.025.079zm-.059-43.804c-.489 0-.979.02-1.471.058-8.899.702-16.14 7.943-16.842 16.843-.427 5.41 1.516 10.7 5.331 14.515s9.1 5.761 14.516 5.331c8.899-.701 16.141-7.941 16.843-16.842a18.442 18.442 0 00-5.331-14.516 18.427 18.427 0 00-13.046-5.389z",
                                                            transform: "matrix(2.81 0 0 2.81 1.407 1.407)"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "settings-control-popup absolute -right-8 bottom-5 hidden w-44 rounded bg-overlay-control py-1 text-center text-white",
                                                            children: [
                                                                !activeQuality && !activeSpeed && !activeCC && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "px-4 py-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "flex items-center justify-between",
                                                                            onClick: function() {
                                                                                return setActiveQuality(true);
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "block w-16 text-left text-sm font-semibold",
                                                                                    children: "Quality:"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    className: "flex items-center justify-between gap-1 text-xsm font-medium",
                                                                                    children: [
                                                                                        playbackQuality === "Auto" ? "Auto" : (0,helpers/* getResolution */.uG)(Number(playbackQuality)),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon/* default */.Z, {
                                                                                            className: "h-4 w-3",
                                                                                            right: true,
                                                                                            iconType: "chervon"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "flex items-center justify-between",
                                                                            onClick: function() {
                                                                                return setActiveSpeed(true);
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "block w-16 text-left text-sm font-semibold",
                                                                                    children: "Speed:"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    className: "flex items-center justify-between gap-1 text-xsm font-medium",
                                                                                    children: [
                                                                                        playbackRate === 1 ? "Normal" : playbackRate,
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon/* default */.Z, {
                                                                                            className: "h-4 w-3",
                                                                                            right: true,
                                                                                            iconType: "chervon"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        listCaptions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "flex items-center justify-between",
                                                                            onClick: function() {
                                                                                return setActiveCC(true);
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "block w-16 text-left text-sm font-semibold",
                                                                                    children: "CC:"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    className: "flex items-center justify-between gap-1 text-xsm font-medium",
                                                                                    children: [
                                                                                        playbackCC === -1 ? "Off" : listCaptions[playbackCC].lang,
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon/* default */.Z, {
                                                                                            className: "h-4 w-3",
                                                                                            right: true,
                                                                                            iconType: "chervon"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                activeQuality && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                                                            className: "relative px-1.5 text-base font-semibold",
                                                                            onClick: function() {
                                                                                return setActiveQuality(false);
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon/* default */.Z, {
                                                                                    className: "absolute left-1 top-1 h-4 w-4",
                                                                                    iconType: "chervon"
                                                                                }),
                                                                                "Quality"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                            className: "quality-options text-ssm font-normal",
                                                                            onClick: function() {
                                                                                return setActiveQuality(false);
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                    onClick: function() {
                                                                                        return changeQuality("auto", "Auto");
                                                                                    },
                                                                                    className: "text-xsm hover:bg-white hover:text-black ".concat("Auto" === playbackQuality ? "bg-white text-black" : ""),
                                                                                    children: "Auto"
                                                                                }, "auto-switch"),
                                                                                filterUniqueResolutions(listQualitys).map(function(quality) {
                                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                                                        onClick: function() {
                                                                                            return changeQuality(parseFloat(quality === null || quality === void 0 ? void 0 : quality.qualityIndex), quality === null || quality === void 0 ? void 0 : quality.bitrate);
                                                                                        },
                                                                                        className: "text-xsm hover:bg-white hover:text-black ".concat((quality === null || quality === void 0 ? void 0 : quality.bitrate) === playbackQuality ? "bg-white text-black" : ""),
                                                                                        children: (0,helpers/* getResolution */.uG)((quality === null || quality === void 0 ? void 0 : quality.bitrate) || 0)
                                                                                    }, quality === null || quality === void 0 ? void 0 : quality.qualityIndex);
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                activeSpeed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                                                            className: "relative px-1.5 text-base font-semibold",
                                                                            onClick: function() {
                                                                                return setActiveSpeed(false);
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon/* default */.Z, {
                                                                                    className: "absolute left-1 top-1 h-4 w-4",
                                                                                    iconType: "chervon"
                                                                                }),
                                                                                "Speed"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                            className: "speed-options text-ssm font-normal",
                                                                            onClick: function() {
                                                                                return setActiveSpeed(false);
                                                                            },
                                                                            children: playbackSpeeds.map(function(speed) {
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                    onClick: handlePlaybackRateChange,
                                                                                    "data-speed": speed.value,
                                                                                    className: "text-xsm hover:bg-white hover:text-black ".concat(parseFloat(speed.value) === playbackRate ? "bg-white text-black" : ""),
                                                                                    children: speed.label
                                                                                }, speed.value);
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                activeCC && listCaptions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                                                            className: "relative px-1.5 text-base font-semibold",
                                                                            onClick: function() {
                                                                                return setActiveCC(false);
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon/* default */.Z, {
                                                                                    className: "absolute left-1 top-1 h-4 w-4",
                                                                                    iconType: "chervon"
                                                                                }),
                                                                                "CC"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                            className: "cc-options text-ssm font-normal",
                                                                            onClick: function() {
                                                                                return setActiveCC(false);
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                    onClick: handleLanguageChange,
                                                                                    "data-cc": -1,
                                                                                    className: "text-xsm hover:bg-white hover:text-black ".concat(-1 === playbackCC ? "bg-white text-black" : ""),
                                                                                    children: "Off"
                                                                                }, -1),
                                                                                listCaptions.map(function(cc) {
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                        onClick: handleLanguageChange,
                                                                                        "data-cc": cc.index,
                                                                                        className: "text-xsm hover:bg-white hover:text-black ".concat(cc.index === playbackCC ? "bg-white text-black" : ""),
                                                                                        children: cc.lang
                                                                                    }, cc.index);
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                ref: fullscreenButtonRef,
                                                "data-title": "Full screen",
                                                className: "btn-video fullscreen-button",
                                                onClick: toggleFullScreen,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.ZP, {
                                                        type: "fullscreen",
                                                        className: "icon-svg fullscreen ml-4 text-white"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        className: "icon-svg fullscreen-exit ml-3 hidden h-6 w-5.5",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M15.984 8.016h3v1.969h-4.969v-4.969h1.969v3zM14.016 18.984v-4.969h4.969v1.969h-3v3h-1.969zM8.016 8.016v-3h1.969v4.969h-4.969v-1.969h3zM5.016 15.984v-1.969h4.969v4.969h-1.969v-3h-3z"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var video_SAPPVideo = (SAPPVideo);


/***/ }),

/***/ 26449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SA": function() { return /* binding */ VerifiedIcon; },
/* harmony export */   "Ts": function() { return /* binding */ CloseIconV2; },
/* harmony export */   "ZP": function() { return /* binding */ Icon; },
/* harmony export */   "up": function() { return /* binding */ NoDataIconV2; },
/* harmony export */   "ve": function() { return /* binding */ ArrowDownIcon; },
/* harmony export */   "wZ": function() { return /* binding */ TimeIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);

function Icon(param) {
    var type = param.type, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            type === "check" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                width: "13",
                height: "14",
                viewBox: "0 0 13 14",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "".concat(className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        id: "yes 1",
                        clipPath: "url(#clip0_108_2114)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                id: "Vector",
                                d: "M6.50001 13.2835C9.9702 13.2835 12.7833 10.4703 12.7833 7.00013C12.7833 3.52994 9.9702 0.716797 6.50001 0.716797C3.02982 0.716797 0.216675 3.52994 0.216675 7.00013C0.216675 10.4703 3.02982 13.2835 6.50001 13.2835Z",
                                fill: "#404041"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                id: "Vector_2",
                                d: "M5.25678 9.61512L3.78345 8.17602C3.75158 8.14505 3.72625 8.10799 3.70895 8.06706C3.69165 8.02612 3.68274 7.98213 3.68274 7.93769C3.68274 7.89324 3.69165 7.84925 3.70895 7.80832C3.72625 7.76738 3.75158 7.73033 3.78345 7.69935L4.27203 7.22269C4.33755 7.1592 4.4252 7.1237 4.51643 7.1237C4.60766 7.1237 4.69531 7.1592 4.76083 7.22269L5.6379 8.08004L8.09772 4.34037C8.14847 4.26491 8.22658 4.21214 8.31553 4.19322C8.40448 4.17429 8.49731 4.1907 8.57438 4.23897L9.15592 4.60427C9.1939 4.62763 9.22681 4.65837 9.25268 4.69468C9.27856 4.73099 9.29688 4.77213 9.30656 4.81566C9.31624 4.85919 9.31708 4.90421 9.30903 4.94807C9.30098 4.99192 9.2842 5.03372 9.2597 5.07097L6.34705 9.5005C6.28869 9.58721 6.21202 9.66006 6.12246 9.71393C6.0329 9.7678 5.93261 9.80138 5.82867 9.81231C5.72473 9.82324 5.61965 9.81125 5.52085 9.77718C5.42204 9.74311 5.3319 9.68779 5.25678 9.61512Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                            id: "clip0_108_2114",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                width: "13",
                                height: "13",
                                fill: "white",
                                transform: "translate(0 0.5)"
                            })
                        })
                    })
                ]
            }),
            type === "global" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "".concat(className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        clipPath: "url(#clip0_5_16315)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M8 0.5C6.51664 0.5 5.0666 0.939867 3.83323 1.76398C2.59986 2.58809 1.63856 3.75943 1.07091 5.12987C0.50325 6.50032 0.354725 8.00832 0.644114 9.46318C0.933503 10.918 1.64781 12.2544 2.6967 13.3033C3.7456 14.3522 5.08197 15.0665 6.53683 15.3559C7.99168 15.6453 9.49968 15.4968 10.8701 14.9291C12.2406 14.3614 13.4119 13.4001 14.236 12.1668C15.0601 10.9334 15.5 9.48336 15.5 8C15.4976 6.01163 14.7066 4.1054 13.3006 2.6994C11.8946 1.29341 9.98837 0.502448 8 0.5ZM1.26 6.11L1.54 6.52C1.5527 6.5381 1.55796 6.56038 1.55471 6.58224C1.55145 6.60411 1.53992 6.62389 1.5225 6.6375L1.2375 6.855C1.17175 6.90471 1.12641 6.97672 1.11 7.0575L1.02 7.4875C1.05215 7.02127 1.13258 6.55963 1.26 6.11ZM13.525 5.2475C13.5924 5.25067 13.6574 5.27407 13.7113 5.31465C13.7653 5.35522 13.8057 5.4111 13.8275 5.475L13.84 5.51C13.865 5.58638 13.9136 5.6529 13.9787 5.70004C14.0438 5.74718 14.1221 5.77255 14.2025 5.7725H14.635C14.6945 5.94232 14.7454 6.11504 14.7875 6.29L14.375 6.7025C14.3678 6.70968 14.3592 6.71537 14.3497 6.71923C14.3403 6.72309 14.3302 6.72505 14.32 6.725H13.705C13.6949 6.72501 13.685 6.72299 13.6757 6.71906C13.6664 6.71514 13.6581 6.70939 13.6511 6.70216C13.6441 6.69493 13.6386 6.68636 13.635 6.67697C13.6314 6.66758 13.6297 6.65756 13.63 6.6475C13.6301 6.58557 13.6125 6.52491 13.5793 6.47265C13.5461 6.42038 13.4986 6.3787 13.4425 6.3525C13.3867 6.32522 13.3241 6.31471 13.2625 6.32226C13.2008 6.3298 13.1426 6.35507 13.095 6.395L11.95 7.325C11.7494 7.48697 11.5878 7.69192 11.477 7.92471C11.3663 8.1575 11.3092 8.4122 11.31 8.67V9.5675C11.31 9.6102 11.3183 9.65249 11.3346 9.69195C11.3509 9.73142 11.3748 9.76728 11.405 9.7975L12.1975 10.5925C12.2598 10.6531 12.3431 10.6871 12.43 10.6875H12.73C12.8709 10.6878 13.0088 10.6471 13.1269 10.5703C13.245 10.4935 13.3382 10.3839 13.395 10.255L14.1725 11.3025C13.5741 12.4193 12.684 13.353 11.5971 14.0041C10.5102 14.6552 9.26703 14.9994 8 15C7.965 15 7.9325 15 7.8975 14.9975V14.9325C7.8975 14.8861 7.91594 14.8416 7.94876 14.8088C7.98158 14.7759 8.02609 14.7575 8.0725 14.7575C8.21088 14.7568 8.34339 14.7016 8.44124 14.6037C8.53909 14.5059 8.59435 14.3734 8.595 14.235V13.7725C8.59493 13.7284 8.61172 13.686 8.64194 13.6539C8.67216 13.6219 8.71351 13.6026 8.7575 13.6C8.84661 13.5939 8.93146 13.5596 8.99977 13.5021C9.06809 13.4445 9.11633 13.3668 9.1375 13.28C9.16123 13.1935 9.15627 13.1017 9.12336 13.0183C9.09045 12.9349 9.03137 12.8645 8.955 12.8175L7.6225 11.9675C7.59768 11.9518 7.5773 11.93 7.5633 11.9042C7.54929 11.8783 7.54213 11.8494 7.5425 11.82V11.5725C7.54184 11.4602 7.49677 11.3528 7.41714 11.2736C7.33751 11.1944 7.22979 11.15 7.1175 11.15H6.9025C6.77364 11.1493 6.65029 11.0977 6.5594 11.0063C6.46852 10.915 6.4175 10.7914 6.4175 10.6625C6.4175 10.6067 6.40651 10.5514 6.38515 10.4999C6.36379 10.4483 6.33249 10.4014 6.29302 10.362C6.25356 10.3225 6.20671 10.2912 6.15514 10.2699C6.10358 10.2485 6.04831 10.2375 5.9925 10.2375H4.0425C3.93022 10.2382 3.82276 10.2832 3.7436 10.3629C3.66443 10.4425 3.62 10.5502 3.62 10.6625V10.7925C3.62001 10.8347 3.60494 10.8755 3.5775 10.9075L3.135 11.425C3.07631 11.4936 3.04123 11.5792 3.03493 11.6692C3.02862 11.7593 3.05144 11.8489 3.1 11.925L3.39 12.3925C3.41131 12.4291 3.4393 12.4613 3.4725 12.4875L4.5325 13.4125C4.55106 13.4293 4.56597 13.4497 4.57629 13.4725C4.58662 13.4953 4.59213 13.52 4.5925 13.545V14.1125C3.50372 13.5058 2.59669 12.6193 1.96513 11.5447C1.33357 10.4701 1.00039 9.24643 1 8C1 7.9675 1 7.9325 1.0025 7.9C1.08816 8.35651 1.35049 8.76079 1.7325 9.025L3.3975 10.275C3.41944 10.2906 3.44557 10.2994 3.4725 10.3C3.49454 10.2996 3.51609 10.2935 3.53503 10.2822C3.55397 10.2709 3.56964 10.2549 3.58049 10.2357C3.59135 10.2165 3.59701 10.1948 3.59692 10.1728C3.59684 10.1507 3.59101 10.1291 3.58 10.11L2.82 8.8425C2.8075 8.8175 2.8075 8.8075 2.805 8.8075C2.81505 8.79644 2.82688 8.78714 2.84 8.78L3.0475 8.665C3.06732 8.65325 3.0836 8.63636 3.0946 8.61611C3.1056 8.59587 3.11092 8.57302 3.11 8.55C3.10914 8.52743 3.10217 8.50551 3.08984 8.48659C3.07752 8.46766 3.0603 8.45242 3.04 8.4425L2.5225 8.1925C2.50736 8.18493 2.49479 8.17307 2.48634 8.1584C2.47789 8.14373 2.47395 8.12689 2.475 8.11L2.4875 7.81C2.48754 7.79862 2.49001 7.78737 2.49475 7.77702C2.4995 7.76667 2.5064 7.75746 2.515 7.75C2.53228 7.73494 2.55459 7.72691 2.5775 7.7275L3.2125 7.755C3.22394 7.7547 3.23529 7.75703 3.24569 7.7618C3.25609 7.76656 3.26526 7.77364 3.2725 7.7825L3.825 8.3825C3.86882 8.43221 3.92671 8.46744 3.991 8.48351C4.05529 8.49958 4.12295 8.49574 4.185 8.4725C4.24835 8.45019 4.3036 8.40948 4.34368 8.35559C4.38376 8.30171 4.40685 8.23709 4.41 8.17L4.4225 7.835C4.42284 7.82367 4.42545 7.81252 4.43017 7.80221C4.4349 7.79191 4.44164 7.78265 4.45 7.775L5.26 7.03C5.27865 7.0153 5.30131 7.00659 5.325 7.005L5.9275 7.0325C6.01584 7.03564 6.10192 7.00425 6.1675 6.945C6.20022 6.91538 6.22677 6.8796 6.24565 6.8397C6.26452 6.79981 6.27535 6.75658 6.2775 6.7125L6.2925 6.3575C6.29258 6.34648 6.29509 6.33562 6.29984 6.32568C6.30459 6.31575 6.31148 6.30698 6.32 6.3L7.015 5.66C7.07773 5.60033 7.11529 5.51895 7.12 5.4325L7.155 4.845C7.1625 4.6775 7.0375 4.4175 6.8325 4.4075L6.1375 4.3825C6.09102 4.38146 6.0448 4.38977 6.00159 4.40692C5.95838 4.42408 5.91905 4.44974 5.88595 4.48239C5.85284 4.51503 5.82662 4.55399 5.80885 4.59695C5.79108 4.63991 5.78212 4.68601 5.7825 4.7325C5.78139 4.74216 5.77782 4.75137 5.77213 4.75924C5.76644 4.76712 5.75882 4.77341 5.75 4.7775C5.73309 4.78731 5.71414 4.79309 5.69463 4.79439C5.67512 4.79569 5.65557 4.79248 5.6375 4.785C5.4575 4.7 5.3875 4.395 5.3425 4.195L5.32 4.11C5.31706 4.09699 5.31711 4.08348 5.32014 4.07049C5.32317 4.0575 5.32911 4.04537 5.3375 4.035C5.34608 4.02415 5.35715 4.01553 5.36977 4.00988C5.3824 4.00422 5.3962 4.00169 5.41 4.0025L6.4675 4.0475C6.56697 4.05226 6.66639 4.03722 6.76 4.00325C6.85361 3.96928 6.93953 3.91705 7.01279 3.84961C7.08606 3.78216 7.14519 3.70083 7.18677 3.61035C7.22835 3.51986 7.25154 3.42202 7.255 3.3225L7.285 2.615C7.28839 2.52589 7.25637 2.43906 7.19595 2.37348C7.13552 2.3079 7.05159 2.2689 6.9625 2.265L6.635 2.2525C6.6137 2.25203 6.59336 2.24352 6.57806 2.22868C6.56276 2.21385 6.55363 2.19378 6.5525 2.1725C6.5525 1.5675 6.2425 1.4875 6.11 1.4825C5.90077 1.48252 5.69916 1.56103 5.545 1.7025C5.45669 1.79394 5.33696 1.84844 5.21 1.855C5.16255 1.85352 5.11647 1.83866 5.0771 1.81212C5.03773 1.78557 5.00667 1.74844 4.9875 1.705C4.985 1.7 4.9825 1.6925 4.98 1.6875C5.92177 1.23303 6.95431 0.997969 8 1C8.14 1 8.2775 1.005 8.415 1.015L8.5975 1.495C8.62545 1.56732 8.67447 1.62957 8.73821 1.6737C8.80195 1.71783 8.87748 1.7418 8.955 1.7425H9.9C9.93108 1.74158 9.96139 1.75228 9.985 1.7725L10.6425 2.31C10.6596 2.32419 10.6728 2.34241 10.6811 2.363C10.6894 2.3836 10.6925 2.40593 10.69 2.42799C10.6875 2.45005 10.6796 2.47115 10.6669 2.48939C10.6543 2.50763 10.6373 2.52245 10.6175 2.5325L10.5425 2.575C10.4956 2.59982 10.4544 2.63423 10.4217 2.67602C10.3889 2.7178 10.3654 2.76601 10.3525 2.8175C10.3393 2.86903 10.3369 2.92274 10.3456 2.97524C10.3542 3.02773 10.3736 3.07787 10.4025 3.1225L10.8725 3.8325C10.912 3.89235 10.9674 3.93997 11.0325 3.97L11.5175 4.19C11.5407 4.20096 11.5603 4.2183 11.574 4.23999C11.5878 4.26168 11.595 4.28683 11.595 4.3125V5.1825C11.5952 5.23931 11.6078 5.29538 11.632 5.34678C11.6562 5.39818 11.6913 5.44365 11.735 5.48C11.7497 5.49057 11.7619 5.50417 11.7709 5.51987C11.7798 5.53557 11.7853 5.55301 11.787 5.57102C11.7887 5.58902 11.7864 5.60717 11.7805 5.62425C11.7745 5.64132 11.765 5.65693 11.7525 5.67L11.2775 6.2125C11.1996 6.30218 11.1588 6.41824 11.1637 6.53696C11.1685 6.65567 11.2185 6.76805 11.3035 6.85109C11.3884 6.93414 11.5019 6.98158 11.6207 6.9837C11.7395 6.98582 11.8546 6.94246 11.9425 6.8625L12.995 5.905C13.0479 5.85667 13.0863 5.79467 13.1062 5.72585C13.126 5.65703 13.1265 5.58406 13.1075 5.515C13.102 5.49628 13.0986 5.47699 13.0975 5.4575C13.0978 5.42845 13.1039 5.39975 13.1155 5.37312C13.1271 5.34649 13.1439 5.32247 13.165 5.3025C13.2086 5.26227 13.2657 5.23995 13.325 5.24L13.525 5.2475Z",
                                fill: "currentColor"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M9.02761 2.2725H8.45761C8.4431 2.27266 8.42868 2.27012 8.41511 2.265L7.89761 2.105C7.87893 2.10003 7.85939 2.09925 7.84037 2.1027C7.82136 2.10616 7.80334 2.11377 7.78761 2.125C7.77144 2.1362 7.75823 2.15115 7.74909 2.16856C7.73995 2.18597 7.73515 2.20534 7.73511 2.225V2.56C7.73583 2.58941 7.73917 2.61869 7.74511 2.6475L8.09011 4.1825C8.10653 4.25648 8.14371 4.32423 8.19729 4.37782C8.25087 4.4314 8.31863 4.46858 8.39261 4.485C8.42068 4.48987 8.44911 4.49238 8.47761 4.4925C8.539 4.49253 8.59954 4.47805 8.65428 4.45024C8.70902 4.42244 8.75641 4.3821 8.79261 4.3325L9.34511 3.5925C9.3962 3.52378 9.4242 3.44063 9.42511 3.355V2.6675C9.42471 2.56243 9.38262 2.46181 9.30809 2.38775C9.23356 2.31369 9.13268 2.27224 9.02761 2.2725Z",
                                fill: "currentColor"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                            id: "clip0_5_16315",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                width: "16",
                                height: "16",
                                fill: "white"
                            })
                        })
                    })
                ]
            }),
            type === "pencil" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "".concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M10 18.5C10 18.1022 10.158 17.7206 10.4393 17.4393C10.7206 17.158 11.1022 17 11.5 17C11.8978 17 12.2794 17.158 12.5607 17.4393C12.842 17.7206 13 18.1022 13 18.5C13 18.8978 12.842 19.2794 12.5607 19.5607C12.2794 19.842 11.8978 20 11.5 20C11.1022 20 10.7206 19.842 10.4393 19.5607C10.158 19.2794 10 18.8978 10 18.5ZM10 12.5C10 12.1022 10.158 11.7206 10.4393 11.4393C10.7206 11.158 11.1022 11 11.5 11C11.8978 11 12.2794 11.158 12.5607 11.4393C12.842 11.7206 13 12.1022 13 12.5C13 12.8978 12.842 13.2794 12.5607 13.5607C12.2794 13.842 11.8978 14 11.5 14C11.1022 14 10.7206 13.842 10.4393 13.5607C10.158 13.2794 10 12.8978 10 12.5ZM10 6.5C10 6.10218 10.158 5.72064 10.4393 5.43934C10.7206 5.15804 11.1022 5 11.5 5C11.8978 5 12.2794 5.15804 12.5607 5.43934C12.842 5.72064 13 6.10218 13 6.5C13 6.89782 12.842 7.27936 12.5607 7.56066C12.2794 7.84196 11.8978 8 11.5 8C11.1022 8 10.7206 7.84196 10.4393 7.56066C10.158 7.27936 10 6.89782 10 6.5Z",
                    fill: "currentColor"
                })
            }),
            type === "ant-right" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "".concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "ant-design:left-outlined",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        id: "Vector",
                        d: "M4.68748 12.5888L4.68748 13.7966C4.68748 13.9013 4.80779 13.9591 4.88904 13.8951L11.9328 8.3935C11.9926 8.34696 12.0411 8.28736 12.0744 8.21926C12.1077 8.15115 12.125 8.07634 12.125 8.00053C12.125 7.92472 12.1077 7.8499 12.0744 7.7818C12.0411 7.7137 11.9926 7.6541 11.9328 7.60756L4.88904 2.106C4.80623 2.04194 4.68748 2.09975 4.68748 2.20444L4.68748 3.41225C4.68748 3.48881 4.72341 3.56225 4.78279 3.60912L10.4078 7.99975L4.78279 12.3919C4.72341 12.4388 4.68748 12.5122 4.68748 12.5888Z",
                        fill: "currentColor"
                    })
                })
            }),
            type === "ant-left" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "".concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M11.3125 3.41119V2.20338C11.3125 2.09869 11.1922 2.04088 11.111 2.10494L4.06721 7.6065C4.00736 7.65304 3.95894 7.71264 3.92563 7.78074C3.89232 7.84885 3.875 7.92366 3.875 7.99947C3.875 8.07528 3.89232 8.1501 3.92563 8.2182C3.95894 8.2863 4.00736 8.3459 4.06721 8.39244L11.111 13.894C11.1938 13.9581 11.3125 13.9003 11.3125 13.7956V12.5878C11.3125 12.5112 11.2766 12.4378 11.2172 12.3909L5.59221 8.00025L11.2172 3.60807C11.2766 3.56119 11.3125 3.48775 11.3125 3.41119Z",
                    fill: "currentColor"
                })
            }),
            type === "arrows" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "12",
                height: "12",
                viewBox: "0 0 12 12",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "".concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "arrows",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        id: "cross",
                        d: "M7.40992 5.99967L10.9999 2.43966C11.1909 2.24606 11.2971 1.98452 11.2952 1.71259C11.2933 1.44067 11.1835 1.18062 10.9899 0.989665C10.7963 0.798709 10.5348 0.692485 10.2628 0.69436C9.99092 0.696236 9.73088 0.806057 9.53992 0.999665L5.99992 4.58967L2.45992 1.06967C2.27256 0.883415 2.0191 0.778873 1.75492 0.778873C1.49073 0.778873 1.23728 0.883415 1.04992 1.06967C0.956191 1.16263 0.881796 1.27323 0.831028 1.39509C0.780259 1.51695 0.754121 1.64765 0.754121 1.77967C0.754121 1.91168 0.780259 2.04238 0.831028 2.16424C0.881796 2.2861 0.956191 2.3967 1.04992 2.48967L4.58992 5.99967L0.999919 9.55967C0.808963 9.75327 0.702739 10.0148 0.704614 10.2867C0.70649 10.5587 0.816311 10.8187 1.00992 11.0097C1.20353 11.2006 1.46506 11.3068 1.73699 11.305C2.00892 11.3031 2.26896 11.1933 2.45992 10.9997L5.99992 7.40967L9.53992 10.9297C9.72728 11.1159 9.98073 11.2205 10.2449 11.2205C10.5091 11.2205 10.7626 11.1159 10.9499 10.9297C11.0436 10.8367 11.118 10.7261 11.1688 10.6042C11.2196 10.4824 11.2457 10.3517 11.2457 10.2197C11.2457 10.0877 11.2196 9.95695 11.1688 9.83509C11.118 9.71323 11.0436 9.60263 10.9499 9.50967L7.40992 5.99967Z",
                        fill: "currentColor"
                    })
                })
            }),
            type === "group-empty" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "18",
                height: "18",
                viewBox: "0 0 18 18",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "".concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "Group 628893",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        id: "Rectangle 1175",
                        x: "0.75",
                        y: "0.75",
                        width: "16.5",
                        height: "16.5",
                        stroke: "currentColor",
                        strokeWidth: "1.5"
                    })
                })
            }),
            type === "group-fill" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "18",
                height: "18",
                viewBox: "0 0 18 18",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "".concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    id: "Group 628892",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            id: "Rectangle 1175",
                            width: "18",
                            height: "18",
                            fill: "currentColor"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            id: "Vector",
                            d: "M14.6705 6.61306L8.73563 13.1375C8.29615 13.6208 7.58324 13.6208 7.14334 13.1375L4.07974 9.76908C3.64009 9.28581 3.64009 8.50193 4.07974 8.01856C4.51947 7.53511 5.23232 7.53511 5.67186 8.01838L7.93972 10.5118L13.0781 4.86245C13.5178 4.379 14.2307 4.37937 14.6703 4.86245C15.1099 5.34582 15.1099 6.12943 14.6705 6.61306Z",
                            fill: "white"
                        })
                    ]
                })
            }),
            type === "ellip" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "8",
                height: "8",
                viewBox: "0 0 8 8",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "".concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "4",
                    cy: "4",
                    r: "4",
                    fill: "currentColor"
                })
            }),
            type === "cross" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "".concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M13.4099 12L16.9999 8.44003C17.1909 8.24642 17.2971 7.98489 17.2952 7.71296C17.2933 7.44103 17.1835 7.18099 16.9899 6.99003C16.7963 6.79908 16.5348 6.69285 16.2628 6.69473C15.9909 6.6966 15.7309 6.80642 15.5399 7.00003L11.9999 10.59L8.45992 7.07003C8.27256 6.88378 8.0191 6.77924 7.75492 6.77924C7.49073 6.77924 7.23728 6.88378 7.04992 7.07003C6.95619 7.16299 6.8818 7.2736 6.83103 7.39546C6.78026 7.51731 6.75412 7.64802 6.75412 7.78003C6.75412 7.91204 6.78026 8.04275 6.83103 8.16461C6.8818 8.28647 6.95619 8.39707 7.04992 8.49003L10.5899 12L6.99992 15.56C6.80896 15.7536 6.70274 16.0152 6.70461 16.2871C6.70649 16.559 6.81631 16.8191 7.00992 17.01C7.20353 17.201 7.46506 17.3072 7.73699 17.3053C8.00892 17.3035 8.26896 17.1936 8.45992 17L11.9999 13.41L15.5399 16.93C15.7273 17.1163 15.9807 17.2208 16.2449 17.2208C16.5091 17.2208 16.7626 17.1163 16.9499 16.93C17.0436 16.8371 17.118 16.7265 17.1688 16.6046C17.2196 16.4827 17.2457 16.352 17.2457 16.22C17.2457 16.088 17.2196 15.9573 17.1688 15.8355C17.118 15.7136 17.0436 15.603 16.9499 15.51L13.4099 12Z",
                    fill: "currentColor"
                })
            }),
            type === "like" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                width: "13",
                height: "14",
                viewBox: "0 0 13 14",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "".concat(className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M0 5.375V11.875C0 12.3237 0.363751 12.6875 0.8125 12.6875H3.25V4.5625H0.8125C0.363751 4.5625 0 4.92625 0 5.375Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M11.4996 5.37494H9.09937C8.8895 5.37494 8.78437 5.2349 8.74906 5.1746C8.71375 5.11469 8.64234 4.95481 8.7439 4.77152L9.59012 3.24768C9.77579 2.91403 9.79483 2.52167 9.64288 2.17136C9.49094 1.82065 9.19101 1.56635 8.82006 1.47391L8.22338 1.32474C8.07818 1.28824 7.92425 1.33466 7.82309 1.44693L4.5834 5.04605C4.24738 5.42017 4.0625 5.90259 4.0625 6.40485V10.6562C4.0625 11.7762 4.97378 12.6874 6.09375 12.6874L10.1352 12.687C11.0477 12.687 11.8535 12.0725 12.0943 11.193L12.9615 7.21298C12.9869 7.10229 13 6.98882 13 6.87536C13 6.04818 12.3268 5.37494 11.4996 5.37494Z",
                        fill: "currentColor"
                    })
                ]
            }),
            type === "time" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                width: "13",
                height: "14",
                viewBox: "0 0 13 14",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "".concat(className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        id: "time 1",
                        clipPath: "url(#clip0_108_2203)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                id: "Group",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        id: "Vector",
                                        d: "M6.88086 6.84693L7.34845 7.33387C8.0241 6.77312 8.89126 6.43552 9.83585 6.43552C10.1286 6.43552 10.4139 6.46818 10.6884 6.52965C10.4676 4.55096 8.87164 2.98189 6.88086 2.80273V6.84693Z",
                                        fill: "currentColor"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        id: "Vector_2",
                                        d: "M6.81208 7.87507L6.11914 7.15344V2.80273C5.24251 2.88162 4.44245 3.22991 3.80258 3.76415L4.43498 4.39655L3.89637 4.93517L3.26397 4.30276C2.72972 4.94263 2.38144 5.74269 2.30255 6.61933H3.19879V7.38104H2.30255C2.38144 8.25768 2.72972 9.05774 3.26397 9.69761L3.87093 9.09065L4.40954 9.62926L3.80258 10.2362C4.42056 10.7522 5.18794 11.0947 6.02944 11.1886C5.96799 10.9141 5.93532 10.6288 5.93532 10.336C5.93534 9.40369 6.26433 8.54683 6.81208 7.87507Z",
                                        fill: "currentColor"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        id: "Vector_3",
                                        d: "M6.29561 11.972C3.64594 11.8644 1.52344 9.67561 1.52344 7C1.52344 4.25591 3.75591 2.02344 6.5 2.02344C9.17561 2.02344 11.3644 4.14594 11.472 6.79561C12.0471 7.06244 12.5465 7.46526 12.929 7.96263C12.9762 7.64528 13 7.32368 13 7C13 5.26379 12.3239 3.6315 11.0962 2.40379C9.8685 1.17613 8.23621 0.5 6.5 0.5C4.76379 0.5 3.1315 1.17613 1.90379 2.40379C0.676127 3.6315 0 5.26379 0 7C0 8.73621 0.676127 10.3685 1.90379 11.5962C3.1315 12.8239 4.76379 13.5 6.5 13.5C6.82368 13.5 7.14525 13.4761 7.46261 13.429C6.96526 13.0465 6.56244 12.547 6.29561 11.972Z",
                                        fill: "currentColor"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                id: "Group_2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    id: "Vector_4",
                                    d: "M9.83584 7.17188C8.0911 7.17188 6.67166 8.59134 6.67166 10.3361C6.67166 12.0808 8.0911 13.5002 9.83584 13.5002C11.5806 13.5002 13 12.0808 13 10.3361C13 8.59134 11.5806 7.17188 9.83584 7.17188ZM9.83582 12.1232C9.58706 12.1232 9.38541 11.9216 9.38541 11.6728C9.38541 11.4241 9.58706 11.2224 9.83582 11.2224C10.0846 11.2224 10.2862 11.4241 10.2862 11.6728C10.2862 11.9216 10.0846 12.1232 9.83582 12.1232ZM10.1517 10.683H9.51998L9.36205 8.35495H10.3096L10.1517 10.683Z",
                                    fill: "currentColor"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                            id: "clip0_108_2203",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                width: "13",
                                height: "13",
                                fill: "white",
                                transform: "translate(0 0.5)"
                            })
                        })
                    })
                ]
            }),
            type === "hour" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                width: "13",
                height: "14",
                viewBox: "0 0 13 14",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "".concat(className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        id: "hour-glass 1",
                        clipPath: "url(#clip0_108_2138)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            id: "Vector",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M4.88519 7.88978C5.42946 7.40183 5.42946 6.59817 4.88519 6.11021L4.81082 6.04359C3.41574 4.79348 2.33807 3.82816 2.01322 1.80476C1.89828 1.09129 2.54934 0.5 3.33292 0.5H6.49997H9.66712C10.4507 0.5 11.1017 1.09129 10.9868 1.80476C10.662 3.82816 9.58425 4.79348 8.18919 6.04359L8.11484 6.11021C7.57055 6.59817 7.57055 7.40183 8.11484 7.88978L8.18919 7.95641C9.58425 9.20655 10.662 10.1719 10.9868 12.1953C11.1017 12.9087 10.4507 13.5 9.66712 13.5H6.49997H3.33292C2.54934 13.5 1.89828 12.9087 2.01322 12.1953C2.33807 10.1719 3.41574 9.20655 4.81082 7.95641L4.88519 7.88978ZM5.35808 8.99322L5.35303 8.99732C4.2899 9.88983 3.49889 10.5543 3.39579 12.1976C3.38937 12.2987 3.43602 12.3895 3.51208 12.4496C3.57124 12.4967 3.64864 12.525 3.73315 12.525H6.49997H9.26648C9.36624 12.525 9.45617 12.4855 9.518 12.4224C9.5758 12.3637 9.60931 12.2845 9.60384 12.1976C9.50076 10.5543 8.70973 9.88983 7.64698 8.99732C7.36569 8.76124 7.06551 8.50917 6.75418 8.21881C6.61392 8.08797 6.38574 8.08797 6.24548 8.21881C5.93581 8.50748 5.63736 8.75838 5.35808 8.99322Z",
                            fill: "currentColor"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                            id: "clip0_108_2138",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                width: "13",
                                height: "13",
                                fill: "white",
                                transform: "translate(0 0.5)"
                            })
                        })
                    })
                ]
            }),
            type === "completed" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "14",
                height: "14",
                fill: "none",
                viewBox: "0 0 13 14",
                className: "top-1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        clipPath: "url(#clip0_5_9473)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "currentColor",
                                d: "M6.5 13.284A6.283 6.283 0 106.5.716a6.283 6.283 0 000 12.566z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#fff",
                                d: "M5.257 9.615L3.783 8.176a.332.332 0 010-.477l.489-.476a.351.351 0 01.489 0l.877.857 2.46-3.74a.35.35 0 01.476-.101l.582.365a.333.333 0 01.104.467l-2.913 4.43a.715.715 0 01-1.09.114z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                            id: "clip0_5_9473",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                width: "14",
                                height: "14",
                                fill: "#fff",
                                d: "M0 0H13V13H0z",
                                transform: "translate(0 .5)"
                            })
                        })
                    })
                ]
            }),
            type === "expired" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "13",
                height: "14",
                fill: "none",
                viewBox: "0 0 13 14",
                className: "".concat(className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        fill: "currentColor",
                        clipPath: "url(#clip0_5_9451)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M6.88 6.847l.468.487a3.883 3.883 0 013.34-.804 4.222 4.222 0 00-3.807-3.727v4.044zM6.812 7.875l-.693-.722v-4.35a4.196 4.196 0 00-2.316.961l.632.633-.539.538-.632-.632a4.196 4.196 0 00-.962 2.316H3.2v.762h-.897c.08.877.428 1.677.962 2.317l.607-.607.538.538-.606.607a4.197 4.197 0 002.226.953 3.9 3.9 0 01.783-3.314z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M6.296 11.972A4.982 4.982 0 011.523 7 4.982 4.982 0 016.5 2.023a4.982 4.982 0 014.972 4.773c.575.266 1.075.67 1.457 1.167.047-.318.071-.64.071-.963a6.457 6.457 0 00-1.904-4.596A6.458 6.458 0 006.5.5a6.458 6.458 0 00-4.596 1.904A6.458 6.458 0 000 7c0 1.736.676 3.368 1.904 4.596A6.457 6.457 0 006.5 13.5c.324 0 .645-.024.963-.071a3.925 3.925 0 01-1.167-1.457z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M9.836 7.172a3.168 3.168 0 00-3.164 3.164A3.168 3.168 0 009.836 13.5 3.168 3.168 0 0013 10.336a3.168 3.168 0 00-3.164-3.164zm0 4.951a.45.45 0 110-.9.45.45 0 010 .9zm.316-1.44H9.52l-.158-2.328h.947l-.157 2.328z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                            id: "clip0_5_9451",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#fff",
                                d: "M0 0H13V13H0z",
                                transform: "translate(0 .5)"
                            })
                        })
                    })
                ]
            }),
            type === "search" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "".concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.325 14.8992L21.705 20.2792C21.8941 20.4685 22.0003 20.7251 22.0002 20.9926C22.0001 21.2601 21.8937 21.5166 21.7045 21.7057C21.5153 21.8948 21.2587 22.001 20.9912 22.0009C20.7236 22.0008 20.4671 21.8945 20.278 21.7052L14.898 16.3252C13.2897 17.5709 11.2673 18.1571 9.24214 17.9646C7.21699 17.7721 5.34124 16.8153 3.99649 15.2888C2.65174 13.7624 1.939 11.781 2.00326 9.74778C2.06753 7.71451 2.90396 5.78209 4.34242 4.34364C5.78087 2.90518 7.71329 2.06875 9.74656 2.00448C11.7798 1.94022 13.7612 2.65296 15.2876 3.99771C16.814 5.34246 17.7708 7.21821 17.9634 9.24336C18.1559 11.2685 17.5697 13.2909 16.324 14.8992H16.325ZM10 16.0002C11.5913 16.0002 13.1174 15.3681 14.2427 14.2429C15.3679 13.1177 16 11.5915 16 10.0002C16 8.40893 15.3679 6.88281 14.2427 5.75759C13.1174 4.63237 11.5913 4.00023 10 4.00023C8.40871 4.00023 6.88259 4.63237 5.75737 5.75759C4.63215 6.88281 4.00001 8.40893 4.00001 10.0002C4.00001 11.5915 4.63215 13.1177 5.75737 14.2429C6.88259 15.3681 8.40871 16.0002 10 16.0002Z",
                    fill: "currentColor"
                })
            }),
            type === "play-circle-sharp" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "100",
                height: "100",
                fill: "none",
                viewBox: "0 0 100 100",
                className: "".concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "currentColor",
                        d: "M50 9.375C27.6 9.375 9.375 27.6 9.375 50S27.6 90.625 50 90.625 90.625 72.4 90.625 50 72.4 9.375 50 9.375zM39.062 67.188V32.812L67.189 50 39.061 67.188z"
                    })
                })
            }),
            type === "learning-resource" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                fill: "none",
                viewBox: "0 0 24 24",
                className: "".concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "currentColor",
                    d: "M21.938 2.25H2.063a.563.563 0 00-.563.563v2.624c0 .311.252.563.563.563h19.875c.31 0 .562-.252.562-.563V2.813a.562.562 0 00-.563-.562zM3 7.5v13.125a1.125 1.125 0 001.125 1.125h15.75A1.125 1.125 0 0021 20.625V7.5H3zm9 10.81l-4.063-4.06L9 13.187l2.25 2.252V9.75h1.5v5.69l2.253-2.254 1.06 1.061L12 18.311z"
                })
            }),
            type === "entrance-test" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "".concat(className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M7.5 11.25H14.408L11.408 8.25L12.4688 7.18922L17.2795 12L12.4688 16.8108L11.408 15.75L14.408 12.75H7.5V19.6875C7.5 19.8367 7.55926 19.9798 7.66475 20.0852C7.77024 20.1907 7.91332 20.25 8.0625 20.25H21.9375C22.0867 20.25 22.2298 20.1907 22.3352 20.0852C22.4407 19.9798 22.5 19.8367 22.5 19.6875V4.3125C22.5 4.16332 22.4407 4.02024 22.3352 3.91475C22.2298 3.80926 22.0867 3.75 21.9375 3.75H8.0625C7.91332 3.75 7.77024 3.80926 7.66475 3.91475C7.55926 4.02024 7.5 4.16332 7.5 4.3125V11.25Z",
                        fill: "currentColor",
                        className: "group-resource"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M7.5 11.25H1.5V12.75H7.5V11.25Z",
                        fill: "currentColor",
                        className: "group-resource"
                    })
                ]
            }),
            type === "event-test" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "".concat(className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        className: "group-resource",
                        d: "M3.75 1.5L0.75 7.5H14.302L18.0623 1.5H3.75Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        className: "group-resource",
                        d: "M23.2501 6.75L19.8751 1.5L13.9689 10.8319C12.6938 10.3889 11.3065 10.3889 10.0314 10.8319L8.88436 9H2.0542L6.11639 15.323C5.94174 16.1936 5.96253 17.0922 6.17725 17.9538C6.39197 18.8155 6.79528 19.6187 7.35806 20.3056C7.92085 20.9925 8.62909 21.5459 9.43168 21.9259C10.2343 22.3059 11.1112 22.503 11.9992 22.503C12.8872 22.503 13.7641 22.3059 14.5667 21.9259C15.3693 21.5459 16.0775 20.9925 16.6403 20.3056C17.2031 19.6187 17.6064 18.8155 17.8212 17.9538C18.0359 17.0922 18.0567 16.1936 17.882 15.323L23.2501 6.75ZM12.0001 19.7812C11.3512 19.7812 10.7168 19.5888 10.1772 19.2283C9.63757 18.8677 9.21701 18.3552 8.96866 17.7557C8.72031 17.1561 8.65533 16.4964 8.78194 15.8599C8.90854 15.2234 9.22105 14.6387 9.67994 14.1798C10.1388 13.7209 10.7235 13.4084 11.36 13.2818C11.9965 13.1552 12.6562 13.2202 13.2558 13.4685C13.8554 13.7169 14.3678 14.1374 14.7284 14.677C15.0889 15.2166 15.2814 15.851 15.2814 16.5C15.2804 17.3699 14.9344 18.204 14.3192 18.8191C13.7041 19.4342 12.8701 19.7803 12.0001 19.7812Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        className: "group-resource",
                        d: "M12 18C12.8284 18 13.5 17.3284 13.5 16.5C13.5 15.6716 12.8284 15 12 15C11.1716 15 10.5 15.6716 10.5 16.5C10.5 17.3284 11.1716 18 12 18Z",
                        fill: "currentColor"
                    })
                ]
            }),
            type === "circle" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                className: "".concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "8",
                    cy: "8",
                    r: "8",
                    fill: "currentColor"
                })
            }),
            type === "arrow-bottom" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                fill: "none",
                viewBox: "0 0 24 24",
                className: "".concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    stroke: "currentColor",
                    strokeLinecap: "square",
                    strokeLinejoin: "round",
                    strokeWidth: "1.5",
                    d: "M19 9.391l-7 7.305L5 9.39"
                })
            }),
            type === "volume" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                fill: "none",
                viewBox: "0 0 16 16",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        fill: "#fff",
                        clipPath: "url(#clip0_246_5900)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M9.298.586a.532.532 0 00-.564.064L3.546 4.8h-2.48C.48 4.8 0 5.28 0 5.867v4.267c0 .588.479 1.066 1.067 1.066h2.479l5.187 4.15a.539.539 0 00.565.064.532.532 0 00.302-.48V1.067a.535.535 0 00-.302-.481zM12.3 4.229a.535.535 0 00-.75.759A4.197 4.197 0 0112.8 8a4.197 4.197 0 01-1.25 3.013.534.534 0 10.75.757A5.246 5.246 0 0013.867 8 5.254 5.254 0 0012.3 4.23z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M13.805 2.726a.534.534 0 00-.752.757A6.315 6.315 0 0114.933 8c0 1.711-.668 3.314-1.88 4.517a.536.536 0 00-.004.755.536.536 0 00.756.002A7.367 7.367 0 0016 8c0-1.998-.779-3.87-2.195-5.274z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                            id: "clip0_246_5900",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#fff",
                                d: "M0 0H16V16H0z"
                            })
                        })
                    })
                ]
            }),
            type === "fullscreen" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M5.45457 16H0.363649C0.162648 16 0 15.8374 0 15.6364V10.5455C0 10.3445 0.162648 10.1818 0.363649 10.1818H1.09091C1.29191 10.1818 1.45456 10.3445 1.45456 10.5455V14.5454H5.45457C5.65557 14.5454 5.81822 14.7081 5.81822 14.9091V15.6364C5.81822 15.8374 5.65557 16 5.45457 16Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M15.6364 16H10.5455C10.3445 16 10.1818 15.8374 10.1818 15.6364V14.9091C10.1818 14.7081 10.3445 14.5454 10.5455 14.5454H14.5454V10.5455C14.5454 10.3445 14.7081 10.1818 14.9091 10.1818H15.6364C15.8374 10.1818 16 10.3445 16 10.5455V15.6364C16 15.8374 15.8374 16 15.6364 16Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M15.6364 5.81819H14.9091C14.7081 5.81819 14.5455 5.65554 14.5455 5.45454V1.45456H10.5455C10.3445 1.45456 10.1818 1.29191 10.1818 1.09091V0.363648C10.1818 0.162648 10.3445 0 10.5455 0H15.6364C15.8374 0 16 0.162648 16 0.363648V5.45457C16 5.65557 15.8374 5.81819 15.6364 5.81819Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M5.45457 1.45455H1.45456V5.45457C1.45456 5.65557 1.29191 5.81822 1.09091 5.81822H0.363649C0.162648 5.81819 0 5.65557 0 5.45457V0.363682C0 0.162682 0.162648 3.37299e-05 0.363649 3.37299e-05H5.45457C5.65557 3.37299e-05 5.81822 0.162682 5.81822 0.363682V1.09094C5.81822 1.29191 5.65557 1.45455 5.45457 1.45455Z",
                        fill: "currentColor"
                    })
                ]
            }),
            type === "my-profile" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                className: "".concat(className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M8.25 9C8.25 6.92893 9.92893 5.25 12 5.25C14.0711 5.25 15.75 6.92893 15.75 9C15.75 11.0711 14.0711 12.75 12 12.75C9.92893 12.75 8.25 11.0711 8.25 9ZM12 6.75C10.7574 6.75 9.75 7.75736 9.75 9C9.75 10.2426 10.7574 11.25 12 11.25C13.2426 11.25 14.25 10.2426 14.25 9C14.25 7.75736 13.2426 6.75 12 6.75Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 14.5456 3.77827 16.851 5.4421 18.5235C5.6225 17.5504 5.97694 16.6329 6.68837 15.8951C7.75252 14.7915 9.45416 14.25 12 14.25C14.5457 14.25 16.2474 14.7915 17.3115 15.8951C18.023 16.6329 18.3774 17.5505 18.5578 18.5236C20.2217 16.8511 21.25 14.5456 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM17.1937 19.6554C17.0918 18.4435 16.8286 17.5553 16.2318 16.9363C15.5823 16.2628 14.3789 15.75 12 15.75C9.62099 15.75 8.41761 16.2628 7.76815 16.9363C7.17127 17.5553 6.90811 18.4434 6.80622 19.6553C8.28684 20.6618 10.0747 21.25 12 21.25C13.9252 21.25 15.7131 20.6618 17.1937 19.6554Z",
                        fill: "currentColor"
                    })
                ]
            }),
            type === "certificates" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                className: "".concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.94513 1.25H16.0549C17.4225 1.24998 18.5248 1.24996 19.3918 1.36652C20.2919 1.48754 21.0497 1.74643 21.6517 2.34835C22.2536 2.95027 22.5125 3.70814 22.6335 4.60825C22.75 5.47522 22.75 6.57754 22.75 7.94513V12.0549C22.75 13.4225 22.75 14.5248 22.6335 15.3918C22.5125 16.2919 22.2536 17.0497 21.6517 17.6516C21.1537 18.1496 20.5469 18.4146 19.8361 18.5593C19.4739 18.6331 19.0724 18.6779 18.6302 18.7053C18.6324 18.7104 18.6347 18.7155 18.6369 18.7207C18.9098 19.361 18.6769 20.1059 18.057 20.4572C17.8707 20.5629 17.6702 20.6009 17.5301 20.6227C17.3836 20.6454 17.2006 20.6633 16.9974 20.6832L16.9776 20.6851C16.8468 20.6979 16.7726 20.7053 16.7175 20.7132C16.6924 20.7168 16.6791 20.7194 16.6739 20.7206C16.6583 20.7267 16.6477 20.7343 16.6409 20.7408C16.6358 20.7457 16.6321 20.7506 16.6294 20.7557C16.6282 20.7613 16.6265 20.7704 16.6244 20.7839C16.6166 20.8342 16.6091 20.903 16.5957 21.0292L16.5935 21.0498C16.5729 21.2432 16.554 21.421 16.5298 21.5641C16.5066 21.702 16.4648 21.9054 16.3486 22.0938C15.9743 22.7006 15.2273 22.8883 14.6126 22.6475C14.4208 22.5723 14.2668 22.4498 14.1557 22.3543C14.0419 22.2565 13.9078 22.1279 13.7577 21.984L12 20.2989L10.2424 21.984C10.0922 22.1279 9.95813 22.2565 9.84431 22.3543C9.73321 22.4498 9.57925 22.5723 9.38737 22.6475C8.77269 22.8883 8.02567 22.7006 7.6514 22.0938C7.53523 21.9054 7.49345 21.702 7.47018 21.5641C7.44605 21.421 7.42711 21.2431 7.40651 21.0497L7.40432 21.0292C7.39088 20.903 7.38336 20.8342 7.37555 20.7839C7.37346 20.7704 7.37178 20.7613 7.37065 20.7557C7.36789 20.7506 7.36415 20.7457 7.35908 20.7408C7.35227 20.7343 7.34174 20.7267 7.32614 20.7206C7.32086 20.7194 7.30762 20.7168 7.28255 20.7132C7.22741 20.7053 7.15319 20.6979 7.02244 20.6851L7.00262 20.6832C6.79938 20.6633 6.61637 20.6454 6.46992 20.6227C6.32977 20.6009 6.12935 20.5629 5.94298 20.4572C5.32307 20.1059 5.09019 19.361 5.36311 18.7207C5.36532 18.7155 5.36757 18.7104 5.36985 18.7052C4.97118 18.6805 4.60714 18.6418 4.27635 18.5811C3.51836 18.4418 2.87328 18.1766 2.34835 17.6517C1.74643 17.0497 1.48754 16.2919 1.36652 15.3918C1.24996 14.5248 1.24998 13.4225 1.25 12.0549V7.94513C1.24998 6.57754 1.24996 5.47522 1.36652 4.60825C1.48754 3.70814 1.74643 2.95027 2.34835 2.34835C2.95027 1.74643 3.70814 1.48754 4.60825 1.36652C5.47522 1.24996 6.57754 1.24998 7.94513 1.25ZM6.7329 17.2462L7.5487 16.4641L8.25788 15.7549C8.38413 13.7981 10.0113 12.25 12 12.25C13.9887 12.25 15.6159 13.7981 15.7421 15.7549L16.4513 16.4641L17.3122 17.2894L17.3117 17.2458C18.2984 17.2353 19.0017 17.1984 19.5368 17.0895C20.0513 16.9847 20.359 16.8229 20.591 16.591C20.8678 16.3142 21.0482 15.9257 21.1469 15.1919C21.2484 14.4365 21.25 13.4354 21.25 12V8C21.25 6.56458 21.2484 5.56347 21.1469 4.80812C21.0482 4.07435 20.8678 3.68577 20.591 3.40901C20.3142 3.13225 19.9257 2.9518 19.1919 2.85315C18.4365 2.75159 17.4354 2.75 16 2.75H8C6.56458 2.75 5.56347 2.75159 4.80812 2.85315C4.07435 2.9518 3.68577 3.13225 3.40901 3.40901C3.13225 3.68577 2.9518 4.07435 2.85315 4.80812C2.75159 5.56347 2.75 6.56459 2.75 8V12C2.75 13.4354 2.75159 14.4365 2.85315 15.1919C2.9518 15.9257 3.13225 16.3142 3.40901 16.591C3.65246 16.8344 3.98054 17.0016 4.54735 17.1057C5.08573 17.2046 5.78062 17.2368 6.7329 17.2462ZM15.4159 17.5495C15.0094 18.4444 14.2614 19.1513 13.3384 19.5041L14.7819 20.888C14.9099 21.0107 15.0009 21.0977 15.0719 21.1622C15.081 21.0864 15.0912 20.9919 15.1041 20.8702C15.1059 20.8537 15.1076 20.8368 15.1094 20.8197C15.1285 20.636 15.1511 20.4185 15.2269 20.2221C15.3949 19.7871 15.7449 19.4585 16.1765 19.3054C16.3708 19.2364 16.5859 19.2158 16.7795 19.1973C16.7969 19.1956 16.8143 19.1939 16.8314 19.1922C16.9388 19.1817 17.0267 19.1731 17.1 19.1652C17.043 19.1094 16.973 19.0423 16.8857 18.9586L15.4159 17.5495ZM12.0301 18.2498L12 18.2209L11.9699 18.2498C10.7411 18.2337 9.75 17.2326 9.75 16C9.75 14.7574 10.7574 13.75 12 13.75C13.2426 13.75 14.25 14.7574 14.25 16C14.25 17.2326 13.2589 18.2337 12.0301 18.2498ZM10.6616 19.5041L9.21809 20.888C9.09009 21.0107 8.99913 21.0977 8.92814 21.1622C8.91902 21.0864 8.90885 20.9919 8.89588 20.8702C8.89412 20.8537 8.89237 20.8368 8.89059 20.8197C8.87152 20.636 8.84895 20.4185 8.7731 20.2221C8.60513 19.7871 8.25507 19.4585 7.82352 19.3054C7.62918 19.2364 7.41411 19.2158 7.22052 19.1973C7.20304 19.1956 7.18573 19.1939 7.16863 19.1922C7.0612 19.1817 6.97333 19.1731 6.90005 19.1652C6.95701 19.1094 7.02695 19.0423 7.11427 18.9586L8.58407 17.5495C8.99065 18.4444 9.73856 19.1513 10.6616 19.5041ZM8.25 6C8.25 5.58579 8.58579 5.25 9 5.25H15C15.4142 5.25 15.75 5.58579 15.75 6C15.75 6.41421 15.4142 6.75 15 6.75H9C8.58579 6.75 8.25 6.41421 8.25 6ZM6.25 9.5C6.25 9.08579 6.58579 8.75 7 8.75H17C17.4142 8.75 17.75 9.08579 17.75 9.5C17.75 9.91422 17.4142 10.25 17 10.25H7C6.58579 10.25 6.25 9.91422 6.25 9.5Z",
                    fill: "currentColor"
                })
            }),
            type === "setting" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                className: "".concat(className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M11.9985 8.25C9.92747 8.25 8.24854 9.92893 8.24854 12C8.24854 14.0711 9.92747 15.75 11.9985 15.75C14.0696 15.75 15.7485 14.0711 15.7485 12C15.7485 9.92893 14.0696 8.25 11.9985 8.25ZM9.74854 12C9.74854 10.7574 10.7559 9.75 11.9985 9.75C13.2412 9.75 14.2485 10.7574 14.2485 12C14.2485 13.2426 13.2412 14.25 11.9985 14.25C10.7559 14.25 9.74854 13.2426 9.74854 12Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M11.9733 1.25C11.5288 1.24999 11.1578 1.24999 10.8532 1.27077C10.5361 1.29241 10.2365 1.33905 9.94615 1.45933C9.27232 1.73844 8.73697 2.27379 8.45786 2.94762C8.31255 3.29842 8.2732 3.66812 8.25817 4.06996C8.2461 4.39299 8.08307 4.66251 7.84249 4.80141C7.6019 4.94031 7.28698 4.94673 7.0012 4.79568C6.64567 4.60777 6.30582 4.45699 5.92937 4.40743C5.20626 4.31223 4.47496 4.50819 3.89633 4.95219C3.64696 5.14353 3.45681 5.3796 3.27952 5.6434C3.10921 5.89681 2.9237 6.21815 2.70148 6.60307L2.67622 6.64681C2.45399 7.03172 2.26846 7.35304 2.13416 7.62723C1.99434 7.91267 1.88497 8.19539 1.84395 8.50701C1.74875 9.23012 1.9447 9.96142 2.3887 10.5401C2.61982 10.8412 2.92026 11.0602 3.2607 11.2741C3.53448 11.4461 3.68641 11.7221 3.6864 12C3.68638 12.2778 3.53446 12.5538 3.26071 12.7258C2.92023 12.9397 2.61974 13.1587 2.3886 13.4599C1.9446 14.0385 1.74865 14.7698 1.84385 15.4929C1.88488 15.8045 1.99425 16.0873 2.13406 16.3727C2.26836 16.6469 2.45388 16.9682 2.67611 17.3531L2.70138 17.3969C2.9236 17.7818 3.10912 18.1031 3.27942 18.3565C3.45671 18.6203 3.64687 18.8564 3.89623 19.0477C4.47486 19.4917 5.20616 19.6877 5.92927 19.5925C6.3057 19.5429 6.64553 19.3922 7.00104 19.2043C7.28686 19.0532 7.60182 19.0596 7.84244 19.1986C8.08305 19.3375 8.24609 19.607 8.25818 19.9301C8.27321 20.3319 8.31256 20.7016 8.45786 21.0524C8.73697 21.7262 9.27232 22.2616 9.94615 22.5407C10.2365 22.661 10.5361 22.7076 10.8532 22.7292C11.1578 22.75 11.5288 22.75 11.9733 22.75H12.0238C12.4682 22.75 12.8393 22.75 13.1439 22.7292C13.461 22.7076 13.7605 22.661 14.0509 22.5407C14.7247 22.2616 15.2601 21.7262 15.5392 21.0524C15.6845 20.7016 15.7239 20.3319 15.7389 19.93C15.751 19.607 15.914 19.3375 16.1546 19.1985C16.3952 19.0596 16.7101 19.0532 16.996 19.2042C17.3514 19.3921 17.6913 19.5429 18.0677 19.5924C18.7908 19.6876 19.5221 19.4917 20.1007 19.0477C20.3501 18.8563 20.5402 18.6203 20.7175 18.3565C20.8878 18.1031 21.0733 17.7818 21.2955 17.3969L21.3208 17.3531C21.543 16.9682 21.7286 16.6468 21.8629 16.3726C22.0027 16.0872 22.1121 15.8045 22.1531 15.4929C22.2483 14.7697 22.0524 14.0384 21.6084 13.4598C21.3772 13.1586 21.0768 12.9397 20.7363 12.7258C20.4625 12.5538 20.3106 12.2778 20.3107 11.9999C20.3107 11.7221 20.4626 11.4462 20.7363 11.2742C21.0768 11.0603 21.3773 10.8414 21.6085 10.5401C22.0524 9.96149 22.2484 9.23019 22.1532 8.50708C22.1122 8.19546 22.0028 7.91274 21.863 7.6273C21.7287 7.35313 21.5432 7.03183 21.321 6.64695L21.2957 6.60318C21.0735 6.21825 20.8879 5.89688 20.7176 5.64347C20.5403 5.37967 20.3502 5.1436 20.1008 4.95225C19.5222 4.50826 18.7909 4.3123 18.0678 4.4075C17.6913 4.45706 17.3515 4.60782 16.996 4.79572C16.7102 4.94679 16.3952 4.94036 16.1546 4.80144C15.914 4.66253 15.751 4.39297 15.7389 4.06991C15.7238 3.66808 15.6845 3.2984 15.5392 2.94762C15.2601 2.27379 14.7247 1.73844 14.0509 1.45933C13.7605 1.33905 13.461 1.29241 13.1439 1.27077C12.8393 1.24999 12.4682 1.24999 12.0238 1.25H11.9733ZM10.5202 2.84515C10.5973 2.81319 10.7145 2.78372 10.9553 2.76729C11.2027 2.75041 11.5223 2.75 11.9985 2.75C12.4747 2.75 12.7943 2.75041 13.0418 2.76729C13.2825 2.78372 13.3997 2.81319 13.4769 2.84515C13.7832 2.97202 14.0265 3.21536 14.1534 3.52165C14.1934 3.61826 14.2266 3.76887 14.2399 4.12597C14.2696 4.91835 14.6785 5.68129 15.4046 6.10048C16.1307 6.51968 16.9959 6.4924 17.6969 6.12188C18.0129 5.9549 18.1599 5.90832 18.2636 5.89467C18.5923 5.8514 18.9247 5.94047 19.1877 6.14228C19.2539 6.19312 19.3381 6.27989 19.4727 6.48016C19.611 6.68603 19.7712 6.9626 20.0093 7.375C20.2474 7.78741 20.4068 8.06438 20.5159 8.28713C20.6221 8.50382 20.6551 8.62007 20.666 8.70287C20.7093 9.03155 20.6202 9.36397 20.4184 9.62698C20.3548 9.70995 20.2409 9.81399 19.9383 10.0041C19.2669 10.426 18.8107 11.1616 18.8107 11.9999C18.8106 12.8383 19.2668 13.574 19.9383 13.9959C20.2408 14.186 20.3547 14.29 20.4183 14.373C20.6201 14.636 20.7092 14.9684 20.6659 15.2971C20.655 15.3799 20.622 15.4961 20.5158 15.7128C20.4067 15.9355 20.2473 16.2125 20.0092 16.6249C19.7711 17.0373 19.6109 17.3139 19.4726 17.5198C19.338 17.72 19.2538 17.8068 19.1876 17.8576C18.9246 18.0595 18.5922 18.1485 18.2635 18.1053C18.1598 18.0916 18.0128 18.045 17.6969 17.8781C16.9958 17.5075 16.1305 17.4803 15.4045 17.8995C14.6785 18.3187 14.2696 19.0816 14.2399 19.874C14.2266 20.2311 14.1934 20.3817 14.1534 20.4784C14.0265 20.7846 13.7832 21.028 13.4769 21.1549C13.3997 21.1868 13.2825 21.2163 13.0418 21.2327C12.7943 21.2496 12.4747 21.25 11.9985 21.25C11.5223 21.25 11.2027 21.2496 10.9553 21.2327C10.7145 21.2163 10.5973 21.1868 10.5202 21.1549C10.2139 21.028 9.97054 20.7846 9.84368 20.4784C9.80366 20.3817 9.77048 20.2311 9.75713 19.874C9.72749 19.0817 9.3185 18.3187 8.59244 17.8995C7.86637 17.4803 7.00115 17.5076 6.30012 17.8781C5.98418 18.0451 5.83716 18.0917 5.73348 18.1053C5.4048 18.1486 5.07238 18.0595 4.80937 17.8577C4.74312 17.8069 4.65898 17.7201 4.52439 17.5198C4.38604 17.314 4.22589 17.0374 3.98779 16.625C3.74969 16.2126 3.59025 15.9356 3.48114 15.7129C3.375 15.4962 3.34192 15.3799 3.33102 15.2971C3.28775 14.9684 3.37681 14.636 3.57863 14.373C3.64229 14.2901 3.75614 14.186 4.05873 13.9959C4.73012 13.5741 5.18635 12.8384 5.1864 12.0001C5.18644 11.1616 4.73019 10.4259 4.05875 10.004C3.75622 9.81389 3.64238 9.70987 3.57873 9.62691C3.37691 9.3639 3.28784 9.03149 3.33112 8.7028C3.34202 8.62001 3.3751 8.50375 3.48123 8.28707C3.59034 8.06431 3.74979 7.78734 3.98789 7.37493C4.22599 6.96253 4.38614 6.68596 4.52449 6.48009C4.65908 6.27983 4.74322 6.19305 4.80947 6.14222C5.07248 5.9404 5.40489 5.85133 5.73358 5.8946C5.83727 5.90825 5.9843 5.95483 6.30027 6.12184C7.00127 6.49235 7.86645 6.51962 8.59248 6.10045C9.31852 5.68128 9.7275 4.91837 9.75713 4.12602C9.77048 3.76889 9.80366 3.61827 9.84368 3.52165C9.97054 3.21536 10.2139 2.97202 10.5202 2.84515Z",
                        fill: "currentColor"
                    })
                ]
            }),
            type === "sercurity" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12.4489 6.77754C11.6708 6.68322 10.8555 6.83147 10.1253 7.25308C8.33189 8.28848 7.71744 10.5816 8.75284 12.375C9.31127 13.3422 10.2356 13.9665 11.25 14.174V16.5002C11.25 16.9145 11.5858 17.2502 12 17.2502C12.4142 17.2502 12.75 16.9145 12.75 16.5002V14.175C13.1356 14.0963 13.5152 13.955 13.8748 13.7474C14.605 13.3258 15.141 12.6939 15.4484 11.9728C15.8943 10.927 15.8608 9.68827 15.2472 8.62549C14.6336 7.56272 13.5776 6.91434 12.4489 6.77754ZM10.8753 8.55212C11.3146 8.29848 11.8017 8.21007 12.2684 8.26664C12.9489 8.34912 13.5804 8.73856 13.9481 9.37549C14.3159 10.0124 14.3374 10.754 14.0686 11.3846C13.8842 11.817 13.5641 12.1947 13.1248 12.4484C12.0488 13.0695 10.6731 12.7009 10.0519 11.625C9.43069 10.5491 9.79933 9.1733 10.8753 8.55212Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12 1.25C11.0625 1.25 10.1673 1.55658 8.72339 2.05112L7.99595 2.30014C6.51462 2.8072 5.3714 3.19852 4.55303 3.53099C4.14078 3.69846 3.78637 3.86067 3.50098 4.02641C3.22634 4.1859 2.95082 4.38484 2.76363 4.65154C2.5786 4.91516 2.48293 5.23924 2.42281 5.55122C2.36031 5.87556 2.32262 6.26464 2.2983 6.71136C2.25 7.59836 2.25 8.81351 2.25 10.3896V11.9914C2.25 18.0924 6.85803 21.0175 9.59833 22.2146L9.62543 22.2264C9.96523 22.3749 10.2846 22.5144 10.6516 22.6084C11.0391 22.7076 11.4507 22.75 12 22.75C12.5493 22.75 12.9609 22.7076 13.3484 22.6084C13.7154 22.5144 14.0348 22.3749 14.3745 22.2264L14.4017 22.2146C17.142 21.0175 21.75 18.0924 21.75 11.9914V10.3898C21.75 8.81361 21.75 7.5984 21.7017 6.71136C21.6774 6.26464 21.6397 5.87556 21.5772 5.55122C21.5171 5.23924 21.4214 4.91516 21.2364 4.65154C21.0492 4.38484 20.7737 4.1859 20.499 4.02641C20.2136 3.86067 19.8592 3.69846 19.447 3.53099C18.6286 3.19852 17.4854 2.8072 16.004 2.30013L15.2766 2.05112C13.8327 1.55658 12.9375 1.25 12 1.25ZM9.08062 3.5143C10.6951 2.96164 11.3423 2.75 12 2.75C12.6577 2.75 13.3049 2.96164 14.9194 3.5143L15.4922 3.71037C17.0048 4.22814 18.1079 4.60605 18.8824 4.92069C19.269 5.07774 19.5491 5.20935 19.7457 5.32353C19.8428 5.3799 19.9097 5.42642 19.9543 5.46273C19.9922 5.49349 20.0066 5.51092 20.0087 5.51348C20.0106 5.5166 20.0231 5.53737 20.0406 5.58654C20.0606 5.64265 20.0827 5.72309 20.1043 5.83506C20.148 6.06169 20.1811 6.37301 20.2039 6.79292C20.2497 7.63411 20.25 8.80833 20.25 10.4167V11.9914C20.25 17.1665 16.3801 19.7135 13.8012 20.84C13.4297 21.0023 13.2152 21.0941 12.9764 21.1552C12.7483 21.2136 12.47 21.25 12 21.25C11.53 21.25 11.2517 21.2136 11.0236 21.1552C10.7848 21.0941 10.5703 21.0023 10.1988 20.84C7.6199 19.7135 3.75 17.1665 3.75 11.9914V10.4167C3.75 8.80833 3.75028 7.63411 3.79608 6.79292C3.81894 6.37301 3.85204 6.06169 3.89571 5.83506C3.91729 5.72309 3.93944 5.64265 3.95943 5.58654C3.97693 5.5374 3.98936 5.51663 3.99129 5.51349C3.99336 5.51095 4.0078 5.49351 4.04567 5.46273C4.09034 5.42642 4.15722 5.3799 4.25429 5.32353C4.4509 5.20935 4.731 5.07774 5.11759 4.92069C5.8921 4.60605 6.99521 4.22814 8.5078 3.71037L9.08062 3.5143Z",
                        fill: "currentColor"
                    })
                ]
            }),
            type === "logout" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                className: "".concat(className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M14.9453 1.25C13.5778 1.24998 12.4754 1.24996 11.6085 1.36652C10.7084 1.48754 9.95048 1.74643 9.34857 2.34835C8.82363 2.87328 8.55839 3.51836 8.41916 4.27635C8.28387 5.01291 8.25799 5.9143 8.25196 6.99583C8.24966 7.41003 8.58357 7.74768 8.99778 7.74999C9.41199 7.7523 9.74964 7.41838 9.75194 7.00418C9.75803 5.91068 9.78643 5.1356 9.89448 4.54735C9.99859 3.98054 10.1658 3.65246 10.4092 3.40901C10.686 3.13225 11.0746 2.9518 11.8083 2.85315C12.5637 2.75159 13.5648 2.75 15.0002 2.75H16.0002C17.4356 2.75 18.4367 2.75159 19.1921 2.85315C19.9259 2.9518 20.3144 3.13225 20.5912 3.40901C20.868 3.68577 21.0484 4.07435 21.1471 4.80812C21.2486 5.56347 21.2502 6.56459 21.2502 8V16C21.2502 17.4354 21.2486 18.4365 21.1471 19.1919C21.0484 19.9257 20.868 20.3142 20.5912 20.591C20.3144 20.8678 19.9259 21.0482 19.1921 21.1469C18.4367 21.2484 17.4356 21.25 16.0002 21.25H15.0002C13.5648 21.25 12.5637 21.2484 11.8083 21.1469C11.0746 21.0482 10.686 20.8678 10.4092 20.591C10.1658 20.3475 9.99859 20.0195 9.89448 19.4527C9.78643 18.8644 9.75803 18.0893 9.75194 16.9958C9.74964 16.5816 9.41199 16.2477 8.99778 16.25C8.58357 16.2523 8.24966 16.59 8.25196 17.0042C8.25799 18.0857 8.28387 18.9871 8.41916 19.7236C8.55839 20.4816 8.82363 21.1267 9.34857 21.6517C9.95048 22.2536 10.7084 22.5125 11.6085 22.6335C12.4754 22.75 13.5778 22.75 14.9453 22.75H16.0551C17.4227 22.75 18.525 22.75 19.392 22.6335C20.2921 22.5125 21.0499 22.2536 21.6519 21.6517C22.2538 21.0497 22.5127 20.2919 22.6337 19.3918C22.7503 18.5248 22.7502 17.4225 22.7502 16.0549V7.94513C22.7502 6.57754 22.7503 5.47522 22.6337 4.60825C22.5127 3.70814 22.2538 2.95027 21.6519 2.34835C21.0499 1.74643 20.2921 1.48754 19.392 1.36652C18.525 1.24996 17.4227 1.24998 16.0551 1.25H14.9453Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M15 11.25C15.4142 11.25 15.75 11.5858 15.75 12C15.75 12.4142 15.4142 12.75 15 12.75H4.02744L5.98809 14.4306C6.30259 14.7001 6.33901 15.1736 6.06944 15.4881C5.79988 15.8026 5.3264 15.839 5.01191 15.5694L1.51191 12.5694C1.34567 12.427 1.25 12.2189 1.25 12C1.25 11.7811 1.34567 11.573 1.51191 11.4306L5.01191 8.43056C5.3264 8.16099 5.79988 8.19741 6.06944 8.51191C6.33901 8.8264 6.30259 9.29988 5.98809 9.56944L4.02744 11.25H15Z",
                        fill: "currentColor"
                    })
                ]
            }),
            type === "phone-ring" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                className: "".concat(className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M13.2596 1.87983C13.3258 1.47094 13.7124 1.19357 14.1212 1.25976C14.1466 1.26461 14.228 1.27983 14.2707 1.28933C14.356 1.30834 14.475 1.33759 14.6234 1.38082C14.9202 1.46726 15.3348 1.60967 15.8324 1.8378C16.8287 2.29456 18.1545 3.09356 19.5303 4.46936C20.9061 5.84516 21.7051 7.17097 22.1619 8.16725C22.39 8.66487 22.5324 9.07947 22.6188 9.37625C22.6621 9.52466 22.6913 9.64369 22.7103 9.72901C22.7198 9.77168 22.7268 9.80594 22.7316 9.83125L22.7374 9.86245C22.8036 10.2713 22.5287 10.6739 22.1198 10.7401C21.7121 10.8061 21.328 10.53 21.2602 10.1231C21.2581 10.1121 21.2524 10.0828 21.2462 10.0551C21.2339 9.9997 21.2125 9.91188 21.1787 9.79572C21.111 9.56339 20.9935 9.21806 20.7983 8.79238C20.4085 7.94207 19.7075 6.76789 18.4696 5.53002C17.2318 4.29216 16.0576 3.59117 15.2073 3.20134C14.7816 3.00618 14.4363 2.88865 14.2039 2.82097C14.0878 2.78714 13.9418 2.75363 13.8864 2.7413C13.4794 2.67347 13.1936 2.28755 13.2596 1.87983Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M13.4859 5.3293C13.5997 4.93102 14.0148 4.7004 14.413 4.81419L14.207 5.53534C14.413 4.81419 14.413 4.81419 14.413 4.81419L14.4145 4.81461L14.416 4.81505L14.4194 4.81602L14.4271 4.81834L14.4469 4.8245C14.462 4.82932 14.4808 4.8356 14.5033 4.84357C14.5482 4.85951 14.6075 4.88217 14.6803 4.91337C14.826 4.97581 15.0251 5.07223 15.2696 5.21694C15.7591 5.50662 16.4272 5.9878 17.2122 6.77277C17.9972 7.55775 18.4784 8.22593 18.768 8.7154C18.9128 8.95991 19.0092 9.15897 19.0716 9.30466C19.1028 9.37746 19.1255 9.43682 19.1414 9.48173C19.1494 9.50418 19.1557 9.52301 19.1605 9.53809L19.1666 9.55788L19.169 9.56563L19.1699 9.56896L19.1704 9.5705C19.1704 9.5705 19.1708 9.57194 18.4496 9.77798L19.1708 9.57194C19.2846 9.97021 19.054 10.3853 18.6557 10.4991C18.2608 10.6119 17.8493 10.3862 17.7315 9.99413L17.7278 9.98335C17.7224 9.96832 17.7114 9.93874 17.6929 9.89554C17.6559 9.8092 17.5888 9.66797 17.4772 9.47938C17.2542 9.10264 16.8515 8.53339 16.1516 7.83343C15.4516 7.13348 14.8823 6.73078 14.5056 6.50781C14.317 6.39619 14.1758 6.32909 14.0894 6.29209C14.0462 6.27358 14.0167 6.26254 14.0016 6.25721L13.9909 6.25352C13.5988 6.13564 13.373 5.72419 13.4859 5.3293Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M5.00745 4.40659C6.68752 2.72653 9.52266 2.85424 10.6925 4.95037L11.3415 6.1133C12.1054 7.48212 11.7799 9.2092 10.6616 10.3412C10.6467 10.3616 10.5677 10.4765 10.5579 10.6773C10.5454 10.9336 10.6364 11.5264 11.5548 12.4448C12.4729 13.363 13.0656 13.4542 13.3221 13.4418C13.5231 13.432 13.6381 13.353 13.6585 13.3381C14.7905 12.2198 16.5176 11.8943 17.8864 12.6582L19.0493 13.3072C21.1454 14.477 21.2731 17.3121 19.5931 18.9922C18.6944 19.8909 17.4995 20.6894 16.0953 20.7426C14.0144 20.8215 10.5591 20.2841 7.13735 16.8623C3.71556 13.4405 3.17818 9.9853 3.25706 7.90437C3.3103 6.50017 4.10879 5.30525 5.00745 4.40659ZM9.38265 5.68136C8.78363 4.60802 7.17394 4.36142 6.06811 5.46725C5.29276 6.2426 4.7887 7.09842 4.75599 7.96119C4.6902 9.69653 5.11864 12.7223 8.19801 15.8017C11.2774 18.881 14.3031 19.3095 16.0385 19.2437C16.9013 19.211 17.7571 18.7069 18.5324 17.9316C19.6382 16.8257 19.3916 15.216 18.3183 14.617L17.1554 13.968C16.432 13.5643 15.4158 13.702 14.7025 14.4153C14.6325 14.4853 14.1864 14.9015 13.395 14.94C12.5847 14.9794 11.604 14.6153 10.4942 13.5055C9.38395 12.3953 9.02003 11.4143 9.0597 10.604C9.09846 9.81245 9.51468 9.36685 9.58432 9.29719C10.2976 8.58387 10.4354 7.5677 10.0317 6.84429L9.38265 5.68136Z",
                        fill: "currentColor"
                    })
                ]
            }),
            type === "email" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                className: "".concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.94358 3.25H14.0564C15.8942 3.24998 17.3498 3.24997 18.489 3.40314C19.6614 3.56076 20.6104 3.89288 21.3588 4.64124C22.1071 5.38961 22.4392 6.33856 22.5969 7.51098C22.75 8.65019 22.75 10.1058 22.75 11.9436V12.0564C22.75 13.8942 22.75 15.3498 22.5969 16.489C22.4392 17.6614 22.1071 18.6104 21.3588 19.3588C20.6104 20.1071 19.6614 20.4392 18.489 20.5969C17.3498 20.75 15.8942 20.75 14.0564 20.75H9.94359C8.10583 20.75 6.65019 20.75 5.51098 20.5969C4.33856 20.4392 3.38961 20.1071 2.64124 19.3588C1.89288 18.6104 1.56076 17.6614 1.40314 16.489C1.24997 15.3498 1.24998 13.8942 1.25 12.0564V11.9436C1.24998 10.1058 1.24997 8.65019 1.40314 7.51098C1.56076 6.33856 1.89288 5.38961 2.64124 4.64124C3.38961 3.89288 4.33856 3.56076 5.51098 3.40314C6.65019 3.24997 8.10582 3.24998 9.94358 3.25ZM5.71085 4.88976C4.70476 5.02502 4.12511 5.27869 3.7019 5.7019C3.27869 6.12511 3.02502 6.70476 2.88976 7.71085C2.75159 8.73851 2.75 10.0932 2.75 12C2.75 13.9068 2.75159 15.2615 2.88976 16.2892C3.02502 17.2952 3.27869 17.8749 3.7019 18.2981C4.12511 18.7213 4.70476 18.975 5.71085 19.1102C6.73851 19.2484 8.09318 19.25 10 19.25H14C15.9068 19.25 17.2615 19.2484 18.2892 19.1102C19.2952 18.975 19.8749 18.7213 20.2981 18.2981C20.7213 17.8749 20.975 17.2952 21.1102 16.2892C21.2484 15.2615 21.25 13.9068 21.25 12C21.25 10.0932 21.2484 8.73851 21.1102 7.71085C20.975 6.70476 20.7213 6.12511 20.2981 5.7019C19.8749 5.27869 19.2952 5.02502 18.2892 4.88976C17.2615 4.75159 15.9068 4.75 14 4.75H10C8.09318 4.75 6.73851 4.75159 5.71085 4.88976ZM5.42383 7.51986C5.68901 7.20165 6.16193 7.15866 6.48014 7.42383L8.63903 9.22291C9.57199 10.0004 10.2197 10.5384 10.7666 10.8901C11.2959 11.2306 11.6549 11.3449 12 11.3449C12.3451 11.3449 12.7041 11.2306 13.2334 10.8901C13.7803 10.5384 14.428 10.0004 15.361 9.22291L17.5199 7.42383C17.8381 7.15866 18.311 7.20165 18.5762 7.51986C18.8413 7.83807 18.7983 8.31099 18.4801 8.57617L16.2836 10.4066C15.3973 11.1452 14.6789 11.7439 14.0448 12.1517C13.3843 12.5765 12.7411 12.8449 12 12.8449C11.2589 12.8449 10.6157 12.5765 9.95518 12.1517C9.32112 11.7439 8.60272 11.1452 7.71636 10.4066L5.51986 8.57617C5.20165 8.31099 5.15866 7.83807 5.42383 7.51986Z",
                    fill: "currentColor"
                })
            }),
            type === "contact" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                className: "".concat(className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9 6.25C7.48122 6.25 6.25 7.48122 6.25 9C6.25 10.5188 7.48122 11.75 9 11.75C10.5188 11.75 11.75 10.5188 11.75 9C11.75 7.48122 10.5188 6.25 9 6.25ZM7.75 9C7.75 8.30965 8.30965 7.75 9 7.75C9.69036 7.75 10.25 8.30965 10.25 9C10.25 9.69036 9.69036 10.25 9 10.25C8.30965 10.25 7.75 9.69036 7.75 9Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9 12.25C7.80424 12.25 6.68461 12.4907 5.83616 12.915C5.03258 13.3168 4.25 14.0106 4.25 15L4.24987 15.0625C4.24834 15.5728 4.24576 16.4322 5.06023 17.0218C5.43818 17.2953 5.9369 17.4698 6.55469 17.581C7.1782 17.6932 7.97721 17.75 9 17.75C10.0228 17.75 10.8218 17.6932 11.4453 17.581C12.0631 17.4698 12.5618 17.2953 12.9398 17.0218C13.7542 16.4322 13.7517 15.5728 13.7501 15.0625L13.75 15C13.75 14.0106 12.9674 13.3168 12.1638 12.915C11.3154 12.4907 10.1958 12.25 9 12.25ZM5.75 15C5.75 14.8848 5.86285 14.5787 6.50698 14.2566C7.10625 13.957 7.98662 13.75 9 13.75C10.0134 13.75 10.8937 13.957 11.493 14.2566C12.1371 14.5787 12.25 14.8848 12.25 15C12.25 15.6045 12.2115 15.6972 12.0602 15.8067C11.9382 15.895 11.6869 16.0134 11.1797 16.1047C10.6782 16.1949 9.97721 16.25 9 16.25C8.02279 16.25 7.3218 16.1949 6.82031 16.1047C6.31311 16.0134 6.06182 15.895 5.93977 15.8067C5.78849 15.6972 5.75 15.6045 5.75 15Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M19 12.75C19.4142 12.75 19.75 12.4142 19.75 12C19.75 11.5858 19.4142 11.25 19 11.25H15C14.5858 11.25 14.25 11.5858 14.25 12C14.25 12.4142 14.5858 12.75 15 12.75H19Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M19.75 9C19.75 9.41422 19.4142 9.75 19 9.75H14C13.5858 9.75 13.25 9.41422 13.25 9C13.25 8.58579 13.5858 8.25 14 8.25H19C19.4142 8.25 19.75 8.58579 19.75 9Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M19 15.75C19.4142 15.75 19.75 15.4142 19.75 15C19.75 14.5858 19.4142 14.25 19 14.25H16C15.5858 14.25 15.25 14.5858 15.25 15C15.25 15.4142 15.5858 15.75 16 15.75H19Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.94358 3.25H14.0564C15.8942 3.24998 17.3498 3.24997 18.489 3.40314C19.6614 3.56076 20.6104 3.89288 21.3588 4.64124C22.1071 5.38961 22.4392 6.33856 22.5969 7.51098C22.75 8.65018 22.75 10.1058 22.75 11.9435V12.0564C22.75 13.8942 22.75 15.3498 22.5969 16.489C22.4392 17.6614 22.1071 18.6104 21.3588 19.3588C20.6104 20.1071 19.6614 20.4392 18.489 20.5969C17.3498 20.75 15.8942 20.75 14.0565 20.75H9.94359C8.10585 20.75 6.65018 20.75 5.51098 20.5969C4.33856 20.4392 3.38961 20.1071 2.64124 19.3588C1.89288 18.6104 1.56076 17.6614 1.40314 16.489C1.24997 15.3498 1.24998 13.8942 1.25 12.0564V11.9436C1.24998 10.1058 1.24997 8.65019 1.40314 7.51098C1.56076 6.33856 1.89288 5.38961 2.64124 4.64124C3.38961 3.89288 4.33856 3.56076 5.51098 3.40314C6.65019 3.24997 8.10583 3.24998 9.94358 3.25ZM5.71085 4.88976C4.70476 5.02503 4.12511 5.27869 3.7019 5.7019C3.27869 6.12511 3.02503 6.70476 2.88976 7.71085C2.75159 8.73851 2.75 10.0932 2.75 12C2.75 13.9068 2.75159 15.2615 2.88976 16.2892C3.02503 17.2952 3.27869 17.8749 3.7019 18.2981C4.12511 18.7213 4.70476 18.975 5.71085 19.1102C6.73851 19.2484 8.09318 19.25 10 19.25H14C15.9068 19.25 17.2615 19.2484 18.2892 19.1102C19.2952 18.975 19.8749 18.7213 20.2981 18.2981C20.7213 17.8749 20.975 17.2952 21.1102 16.2892C21.2484 15.2615 21.25 13.9068 21.25 12C21.25 10.0932 21.2484 8.73851 21.1102 7.71085C20.975 6.70476 20.7213 6.12511 20.2981 5.7019C19.8749 5.27869 19.2952 5.02503 18.2892 4.88976C17.2615 4.75159 15.9068 4.75 14 4.75H10C8.09318 4.75 6.73851 4.75159 5.71085 4.88976Z",
                        fill: "currentColor"
                    })
                ]
            }),
            type === "edit" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "22",
                height: "22",
                viewBox: "0 0 24 24",
                fill: "none",
                className: "".concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.0992 2.39109C15.6207 0.869636 18.0875 0.869636 19.6089 2.39109C21.1304 3.91255 21.1304 6.37932 19.6089 7.90077L12.0149 15.4948C11.5869 15.9228 11.3255 16.1842 11.0342 16.4115C10.691 16.6792 10.3196 16.9087 9.92667 17.096C9.59315 17.2549 9.24244 17.3718 8.66818 17.5632L5.99553 18.4541L5.35386 18.668C4.77951 18.8594 4.14629 18.7099 3.7182 18.2818C3.2901 17.8537 3.14062 17.2205 3.33207 16.6462L4.43683 13.3318C4.62822 12.7576 4.7451 12.4069 4.90405 12.0734C5.09132 11.6804 5.32084 11.309 5.58856 10.9658C5.81578 10.6745 6.07719 10.4131 6.50525 9.98509L14.0992 2.39109ZM5.96092 16.8845L5.11556 16.0391L5.84398 13.8538C6.05606 13.2176 6.14366 12.9589 6.25814 12.7187C6.39854 12.4241 6.57061 12.1457 6.77132 11.8883C6.93497 11.6785 7.12718 11.4845 7.60141 11.0102L13.4924 5.11927C13.7355 5.72927 14.147 6.46549 14.8408 7.15927C15.5345 7.85306 16.2708 8.26447 16.8807 8.50764L10.9898 14.3986C10.5155 14.8728 10.3215 15.065 10.1117 15.2287C9.85436 15.4294 9.57594 15.6015 9.28134 15.7419C9.04113 15.8564 8.78244 15.944 8.14619 16.156L5.96092 16.8845ZM18.076 7.31241C17.9521 7.28522 17.7973 7.24432 17.6213 7.18325C17.1373 7.01532 16.5006 6.69778 15.9014 6.09861C15.3022 5.49944 14.9847 4.86276 14.8168 4.37873C14.7557 4.2027 14.7148 4.04787 14.6876 3.92404L15.1599 3.45175C16.0956 2.51608 17.6126 2.51608 18.5483 3.45175C19.4839 4.38742 19.4839 5.90444 18.5483 6.84011L18.076 7.31241ZM3.25002 22C3.25002 21.5858 3.58581 21.25 4.00002 21.25H20V22.75H4.00002C3.58581 22.75 3.25002 22.4142 3.25002 22Z",
                    fill: "currentColor"
                })
            }),
            type === "share" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                className: "".concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.5 2.25C14.7051 2.25 13.25 3.70507 13.25 5.5C13.25 5.69591 13.2673 5.88776 13.3006 6.07412L8.56991 9.38558C8.54587 9.4024 8.52312 9.42038 8.50168 9.43939C7.94993 9.00747 7.25503 8.75 6.5 8.75C4.70507 8.75 3.25 10.2051 3.25 12C3.25 13.7949 4.70507 15.25 6.5 15.25C7.25503 15.25 7.94993 14.9925 8.50168 14.5606C8.52312 14.5796 8.54587 14.5976 8.56991 14.6144L13.3006 17.9259C13.2673 18.1122 13.25 18.3041 13.25 18.5C13.25 20.2949 14.7051 21.75 16.5 21.75C18.2949 21.75 19.75 20.2949 19.75 18.5C19.75 16.7051 18.2949 15.25 16.5 15.25C15.4472 15.25 14.5113 15.7506 13.9174 16.5267L9.43806 13.3911C9.63809 12.9694 9.75 12.4978 9.75 12C9.75 11.5022 9.63809 11.0306 9.43806 10.6089L13.9174 7.4733C14.5113 8.24942 15.4472 8.75 16.5 8.75C18.2949 8.75 19.75 7.29493 19.75 5.5C19.75 3.70507 18.2949 2.25 16.5 2.25ZM14.75 5.5C14.75 4.5335 15.5335 3.75 16.5 3.75C17.4665 3.75 18.25 4.5335 18.25 5.5C18.25 6.4665 17.4665 7.25 16.5 7.25C15.5335 7.25 14.75 6.4665 14.75 5.5ZM6.5 10.25C5.5335 10.25 4.75 11.0335 4.75 12C4.75 12.9665 5.5335 13.75 6.5 13.75C7.4665 13.75 8.25 12.9665 8.25 12C8.25 11.0335 7.4665 10.25 6.5 10.25ZM16.5 16.75C15.5335 16.75 14.75 17.5335 14.75 18.5C14.75 19.4665 15.5335 20.25 16.5 20.25C17.4665 20.25 18.25 19.4665 18.25 18.5C18.25 17.5335 17.4665 16.75 16.5 16.75Z",
                    fill: "currentColor"
                })
            }),
            type === "shield-warning" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                className: "".concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 10.4167C3 7.21907 3 5.62028 3.37752 5.08241C3.75503 4.54454 5.25832 4.02996 8.26491 3.00079L8.83772 2.80472C10.405 2.26824 11.1886 2 12 2C12.8114 2 13.595 2.26824 15.1623 2.80472L15.7351 3.00079C18.7417 4.02996 20.245 4.54454 20.6225 5.08241C21 5.62028 21 7.21907 21 10.4167V11.9914C21 17.6294 16.761 20.3655 14.1014 21.5273C13.38 21.8424 13.0193 22 12 22C10.9807 22 10.62 21.8424 9.89856 21.5273C7.23896 20.3655 3 17.6294 3 11.9914V10.4167ZM12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V12C12.75 12.4142 12.4142 12.75 12 12.75C11.5858 12.75 11.25 12.4142 11.25 12V8C11.25 7.58579 11.5858 7.25 12 7.25ZM12 16C12.5523 16 13 15.5523 13 15C13 14.4477 12.5523 14 12 14C11.4477 14 11 14.4477 11 15C11 15.5523 11.4477 16 12 16Z",
                    fill: "currentColor"
                })
            }),
            type === "delete" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                className: "".concat(className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M10.3094 2.25002H13.6908C13.9072 2.24988 14.0957 2.24976 14.2737 2.27819C14.977 2.39049 15.5856 2.82915 15.9146 3.46084C15.9978 3.62073 16.0573 3.79961 16.1256 4.00494L16.2373 4.33984C16.2562 4.39653 16.2616 4.41258 16.2661 4.42522C16.4413 4.90933 16.8953 5.23659 17.4099 5.24964C17.4235 5.24998 17.44 5.25004 17.5001 5.25004H20.5001C20.9143 5.25004 21.2501 5.58582 21.2501 6.00004C21.2501 6.41425 20.9143 6.75004 20.5001 6.75004H3.5C3.08579 6.75004 2.75 6.41425 2.75 6.00004C2.75 5.58582 3.08579 5.25004 3.5 5.25004H6.50008C6.56013 5.25004 6.5767 5.24998 6.59023 5.24964C7.10488 5.23659 7.55891 4.90936 7.73402 4.42524C7.73863 4.41251 7.74392 4.39681 7.76291 4.33984L7.87452 4.00496C7.94281 3.79964 8.00233 3.62073 8.08559 3.46084C8.41453 2.82915 9.02313 2.39049 9.72643 2.27819C9.90445 2.24976 10.093 2.24988 10.3094 2.25002ZM9.00815 5.25004C9.05966 5.14902 9.10531 5.04404 9.14458 4.93548C9.1565 4.90251 9.1682 4.86742 9.18322 4.82234L9.28302 4.52292C9.37419 4.24941 9.39519 4.19363 9.41601 4.15364C9.52566 3.94307 9.72853 3.79686 9.96296 3.75942C10.0075 3.75231 10.067 3.75004 10.3553 3.75004H13.6448C13.9331 3.75004 13.9927 3.75231 14.0372 3.75942C14.2716 3.79686 14.4745 3.94307 14.5842 4.15364C14.605 4.19363 14.626 4.2494 14.7171 4.52292L14.8169 4.82216L14.8556 4.9355C14.8949 5.04405 14.9405 5.14902 14.992 5.25004H9.00815Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M5.91509 8.45015C5.88754 8.03685 5.53016 7.72415 5.11686 7.7517C4.70357 7.77925 4.39086 8.13663 4.41841 8.54993L4.88186 15.5017C4.96736 16.7844 5.03642 17.8205 5.19839 18.6336C5.36679 19.4789 5.65321 20.185 6.2448 20.7385C6.8364 21.2919 7.55995 21.5308 8.4146 21.6425C9.23662 21.7501 10.275 21.7501 11.5606 21.75H12.4395C13.7251 21.7501 14.7635 21.7501 15.5856 21.6425C16.4402 21.5308 17.1638 21.2919 17.7554 20.7385C18.347 20.185 18.6334 19.4789 18.8018 18.6336C18.9638 17.8206 19.0328 16.7844 19.1183 15.5017L19.5818 8.54993C19.6093 8.13663 19.2966 7.77925 18.8833 7.7517C18.47 7.72415 18.1126 8.03685 18.0851 8.45015L17.6251 15.3493C17.5353 16.6971 17.4713 17.6349 17.3307 18.3406C17.1943 19.025 17.004 19.3873 16.7306 19.6431C16.4572 19.8989 16.083 20.0647 15.391 20.1552C14.6776 20.2485 13.7376 20.25 12.3868 20.25H11.6134C10.2626 20.25 9.32255 20.2485 8.60915 20.1552C7.91715 20.0647 7.54299 19.8989 7.26958 19.6431C6.99617 19.3873 6.80583 19.025 6.66948 18.3406C6.52892 17.6349 6.46489 16.6971 6.37503 15.3493L5.91509 8.45015Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M9.42546 10.2538C9.83762 10.2125 10.2052 10.5133 10.2464 10.9254L10.7464 15.9254C10.7876 16.3376 10.4869 16.7051 10.0747 16.7463C9.66256 16.7875 9.29503 16.4868 9.25381 16.0747L8.75381 11.0747C8.7126 10.6625 9.01331 10.295 9.42546 10.2538Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M14.5747 10.2538C14.9869 10.295 15.2876 10.6625 15.2464 11.0747L14.7464 16.0747C14.7052 16.4868 14.3376 16.7875 13.9255 16.7463C13.5133 16.7051 13.2126 16.3376 13.2538 15.9254L13.7538 10.9254C13.795 10.5133 14.1626 10.2125 14.5747 10.2538Z",
                        fill: "currentColor"
                    })
                ]
            }),
            type === "download" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "22",
                height: "22",
                viewBox: "0 0 24 24",
                fill: "none",
                className: "".concat(className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12.5535 16.5061C12.4114 16.6615 12.2106 16.75 12 16.75C11.7894 16.75 11.5886 16.6615 11.4465 16.5061L7.44648 12.1311C7.16698 11.8254 7.18822 11.351 7.49392 11.0715C7.79963 10.792 8.27402 10.8132 8.55352 11.1189L11.25 14.0682V3C11.25 2.58579 11.5858 2.25 12 2.25C12.4142 2.25 12.75 2.58579 12.75 3V14.0682L15.4465 11.1189C15.726 10.8132 16.2004 10.792 16.5061 11.0715C16.8118 11.351 16.833 11.8254 16.5535 12.1311L12.5535 16.5061Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M3.75 15C3.75 14.5858 3.41422 14.25 3 14.25C2.58579 14.25 2.25 14.5858 2.25 15V15.0549C2.24998 16.4225 2.24996 17.5248 2.36652 18.3918C2.48754 19.2919 2.74643 20.0497 3.34835 20.6516C3.95027 21.2536 4.70814 21.5125 5.60825 21.6335C6.47522 21.75 7.57754 21.75 8.94513 21.75H15.0549C16.4225 21.75 17.5248 21.75 18.3918 21.6335C19.2919 21.5125 20.0497 21.2536 20.6517 20.6516C21.2536 20.0497 21.5125 19.2919 21.6335 18.3918C21.75 17.5248 21.75 16.4225 21.75 15.0549V15C21.75 14.5858 21.4142 14.25 21 14.25C20.5858 14.25 20.25 14.5858 20.25 15C20.25 16.4354 20.2484 17.4365 20.1469 18.1919C20.0482 18.9257 19.8678 19.3142 19.591 19.591C19.3142 19.8678 18.9257 20.0482 18.1919 20.1469C17.4365 20.2484 16.4354 20.25 15 20.25H9C7.56459 20.25 6.56347 20.2484 5.80812 20.1469C5.07435 20.0482 4.68577 19.8678 4.40901 19.591C4.13225 19.3142 3.9518 18.9257 3.85315 18.1919C3.75159 17.4365 3.75 16.4354 3.75 15Z",
                        fill: "currentColor"
                    })
                ]
            }),
            type === "eye-view" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "22",
                height: "22",
                viewBox: "0 0 24 24",
                fill: "none",
                className: "".concat(className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z",
                        fill: "currentColor"
                    })
                ]
            })
        ]
    });
}
var TimeIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "100",
        height: "100",
        viewBox: "0 0 164 164",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "100",
                height: "100",
                rx: "82",
                fill: "#FFFAF0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M84.9184 53.0586H79.0938C78.5609 53.0586 78.125 53.4945 78.125 54.0274V87.3645C78.125 87.6793 78.2703 87.9699 78.5246 88.1516L98.5414 102.768C98.9773 103.082 99.5828 102.998 99.8977 102.562L103.361 97.8391C103.688 97.391 103.591 96.7856 103.155 96.4828L85.8871 83.9981V54.0274C85.8871 53.4945 85.4512 53.0586 84.9184 53.0586ZM111.535 62.1649L130.522 66.8027C131.128 66.9481 131.721 66.4879 131.721 65.8703L131.818 46.3137C131.818 45.5024 130.886 45.0422 130.256 45.5508L111.171 60.4574C111.027 60.569 110.917 60.719 110.855 60.8903C110.792 61.0615 110.779 61.2469 110.817 61.4253C110.855 61.6036 110.942 61.7677 111.069 61.8985C111.196 62.0293 111.358 62.1217 111.535 62.1649ZM131.842 98.6262L124.976 96.2649C124.737 96.1828 124.475 96.1977 124.246 96.3063C124.018 96.4149 123.841 96.6087 123.753 96.8461C123.523 97.4637 123.281 98.0692 123.027 98.6746C120.871 103.773 117.783 108.362 113.836 112.298C109.932 116.214 105.305 119.335 100.213 121.489C94.9368 123.719 89.2658 124.864 83.5379 124.855C77.7496 124.855 72.143 123.729 66.8633 121.489C61.7706 119.335 57.1441 116.214 53.2402 112.298C49.3047 108.362 46.2168 103.773 44.0492 98.6746C41.831 93.3959 40.6945 87.7258 40.707 82C40.707 76.2117 41.8332 70.593 44.0734 65.3133C46.2289 60.2153 49.3168 55.6258 53.2645 51.6903C57.1683 47.7743 61.7948 44.653 66.8875 42.4992C72.143 40.259 77.7617 39.1328 83.55 39.1328C89.3383 39.1328 94.9449 40.259 100.225 42.4992C105.317 44.653 109.944 47.7743 113.848 51.6903C115.083 52.9375 116.245 54.2332 117.311 55.6016L124.552 49.9344C115.022 37.7524 100.188 29.9176 83.5258 29.9297C54.5117 29.9418 31.2133 53.5067 31.5039 82.5328C31.7945 111.05 54.984 134.07 83.55 134.07C106.013 134.07 125.146 119.83 132.436 99.8856C132.617 99.377 132.351 98.8078 131.842 98.6262Z",
                fill: "#FFB800"
            })
        ]
    });
};
var VerifiedIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "verified 1",
                clipPath: "url(#clip0_12314_6902)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    id: "Group",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            id: "Vector",
                            d: "M7 13.5625C10.6244 13.5625 13.5625 10.6244 13.5625 7C13.5625 3.37563 10.6244 0.4375 7 0.4375C3.37563 0.4375 0.4375 3.37563 0.4375 7C0.4375 10.6244 3.37563 13.5625 7 13.5625Z",
                            fill: "#FFB800"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            id: "Vector_2",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M3.13154 7.30932C2.83896 7.01674 2.83896 6.54235 3.13154 6.24977C3.42412 5.95719 3.89851 5.95719 4.19109 6.24977L6.04718 8.10587L9.81096 4.30454C10.1019 4.01196 10.575 4.01065 10.8676 4.30161C11.1602 4.59258 11.1615 5.06565 10.8705 5.35823C9.43994 6.8031 8.01549 8.25899 6.57811 9.69637C6.28553 9.98895 5.81115 9.98895 5.51857 9.69637L3.13154 7.30932Z",
                            fill: "white"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_12314_6902",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var ArrowDownIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11.8906 17.2401C11.759 17.2408 11.6285 17.2156 11.5067 17.1658C11.3848 17.1161 11.274 17.0427 11.1806 16.9501L5.18056 10.9501C5.08684 10.8571 5.01244 10.7465 4.96167 10.6246C4.9109 10.5028 4.88477 10.3721 4.88477 10.2401C4.88477 10.108 4.9109 9.97733 4.96167 9.85547C5.01244 9.73361 5.08684 9.62301 5.18056 9.53005C5.36793 9.3438 5.62138 9.23926 5.88556 9.23926C6.14975 9.23926 6.4032 9.3438 6.59056 9.53005L11.8906 14.8301L17.1806 9.53005C17.3679 9.3438 17.6214 9.23926 17.8856 9.23926C18.1498 9.23926 18.4032 9.3438 18.5906 9.53005C18.6843 9.62301 18.7587 9.73361 18.8095 9.85547C18.8602 9.97733 18.8864 10.108 18.8864 10.2401C18.8864 10.3721 18.8602 10.5028 18.8095 10.6246C18.7587 10.7465 18.6843 10.8571 18.5906 10.9501L12.5906 16.9501C12.4043 17.1348 12.1529 17.2389 11.8906 17.2401Z",
            fill: "#7E8299"
        })
    });
};
var NoDataIconV2 = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "203",
        height: "203",
        viewBox: "0 0 203 203",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M107.681 165.699C143.206 165.699 172.007 136.898 172.007 101.246C172.007 65.5946 143.206 36.7939 107.681 36.7939C72.1561 36.7939 43.3555 65.5946 43.3555 101.246C43.3555 136.898 72.1561 165.699 107.681 165.699Z",
                fill: "#F1F3FA"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                filter: "url(#filter0_d_3282_84073)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M167.31 75.4912H57.3098C54.8992 75.4912 52.9961 73.5881 52.9961 71.1774V46.4368C52.9961 44.0262 54.8992 42.123 57.3098 42.123H167.184C169.594 42.123 171.497 44.0262 171.497 46.4368V71.1774C171.624 73.5881 169.594 75.4912 167.31 75.4912Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M79.6406 58.7441C79.6406 61.5354 78.3719 64.0729 76.4687 65.8491C74.8194 67.3716 72.5356 68.2598 70.125 68.2598C67.7144 68.2598 65.4306 67.3716 63.7813 65.8491C61.7513 64.0729 60.6094 61.5354 60.6094 58.7441C60.6094 53.5423 64.9231 49.2285 70.125 49.2285C75.3269 49.2285 79.6406 53.5423 79.6406 58.7441Z",
                fill: "#D5DAE5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M110.852 55.9519H86.4916C85.8572 55.9519 85.4766 55.4444 85.4766 54.9369V51.765C85.4766 51.1306 85.9841 50.75 86.4916 50.75H110.852C111.486 50.75 111.867 51.2575 111.867 51.765V54.9369C111.867 55.5713 111.486 55.9519 110.852 55.9519Z",
                fill: "#D5DAE5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M139.779 66.7361H86.4916C85.8572 66.7361 85.4766 66.2286 85.4766 65.7211V62.5492C85.4766 61.9148 85.9841 61.5342 86.4916 61.5342H139.779C140.413 61.5342 140.794 62.0417 140.794 62.5492V65.7211C140.794 66.3554 140.287 66.7361 139.779 66.7361Z",
                fill: "#D5DAE5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                filter: "url(#filter1_d_3282_84073)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M167.31 158.721H57.3098C54.8992 158.721 52.9961 156.818 52.9961 154.407V129.666C52.9961 127.256 54.8992 125.353 57.3098 125.353H167.184C169.594 125.353 171.497 127.256 171.497 129.666V154.407C171.624 156.818 169.594 158.721 167.31 158.721Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M79.6406 141.974C79.6406 144.765 78.3719 147.302 76.4687 149.079C74.8194 150.601 72.5356 151.489 70.125 151.489C67.7144 151.489 65.4306 150.601 63.7813 149.079C61.7513 147.302 60.6094 144.765 60.6094 141.974C60.6094 136.772 64.9231 132.458 70.125 132.458C75.3269 132.458 79.6406 136.772 79.6406 141.974Z",
                fill: "#D5DAE5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M110.852 139.308H86.4916C85.8572 139.308 85.4766 138.801 85.4766 138.293V135.121C85.4766 134.487 85.9841 134.106 86.4916 134.106H110.852C111.486 134.106 111.867 134.614 111.867 135.121V138.293C111.867 138.801 111.486 139.308 110.852 139.308Z",
                fill: "#D5DAE5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M139.779 150.093H86.4916C85.8572 150.093 85.4766 149.585 85.4766 149.078V145.906C85.4766 145.271 85.9841 144.891 86.4916 144.891H139.779C140.413 144.891 140.794 145.398 140.794 145.906V149.078C140.794 149.585 140.287 150.093 139.779 150.093Z",
                fill: "#D5DAE5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                filter: "url(#filter2_d_3282_84073)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M148.66 117.105H38.7864C36.3758 117.105 34.4727 115.202 34.4727 112.792V88.0511C34.4727 85.6404 36.3758 83.7373 38.7864 83.7373H148.66C151.071 83.7373 152.974 85.6404 152.974 88.0511V112.792C153.101 115.202 151.071 117.105 148.66 117.105Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M92.3281 97.5671H67.9681C67.3337 97.5671 66.9531 97.0596 66.9531 96.5521V93.3802C66.9531 92.7459 67.4606 92.3652 67.9681 92.3652H92.3281C92.9625 92.3652 93.3431 92.8727 93.3431 93.3802V96.5521C93.3431 97.1865 92.9625 97.5671 92.3281 97.5671Z",
                fill: "#D5DAE5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M121.256 108.478H67.9681C67.3337 108.478 66.9531 107.971 66.9531 107.463V104.291C66.9531 103.657 67.4606 103.276 67.9681 103.276H121.129C121.763 103.276 122.144 103.784 122.144 104.291V107.463C122.271 107.971 121.763 108.478 121.256 108.478Z",
                fill: "#D5DAE5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M61.2441 100.358C61.2441 103.023 60.1022 105.433 58.3259 107.21C58.1991 107.337 58.1991 107.337 58.0722 107.463C56.4228 108.986 54.1391 109.874 51.7284 109.874C49.3178 109.874 47.1609 108.986 45.5116 107.59C45.5116 107.59 45.5116 107.59 45.3847 107.59C43.3547 105.814 42.0859 103.277 42.0859 100.358C42.0859 95.1565 46.3997 90.8428 51.6016 90.8428C56.9303 90.8428 61.2441 95.1565 61.2441 100.358Z",
                fill: "#D5DAE5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_d_3282_84073",
                        x: "43.9961",
                        y: "38.123",
                        width: "136.508",
                        height: "51.3682",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "5"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "4.5"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_3282_84073"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_3282_84073",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_d_3282_84073",
                        x: "43.9961",
                        y: "121.353",
                        width: "136.508",
                        height: "51.3682",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "5"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "4.5"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_3282_84073"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_3282_84073",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter2_d_3282_84073",
                        x: "25.4727",
                        y: "79.7373",
                        width: "136.508",
                        height: "51.3682",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "5"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "4.5"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_3282_84073"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_3282_84073",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var CloseIconV2 = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18 18L6 6",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6 18L18 6",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};


/***/ }),

/***/ 78047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(72760);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(52621);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _components_base_clickoutside_HookClick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87248);
/* harmony import */ var _components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95215);
/* harmony import */ var _components_questionType_ConstructedQuestion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92937);
/* harmony import */ var _components_questionType_DragNDrop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20709);
/* harmony import */ var _components_questionType_FillText__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23396);
/* harmony import */ var _components_questionType_MatchingQuestion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54580);
/* harmony import */ var _components_questionType_MultipleChoiceQuestion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20093);
/* harmony import */ var _components_questionType_OneChoiceQuestion__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94229);
/* harmony import */ var _components_questionType_SelectQuestion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52178);
/* harmony import */ var _components_uploadFile_ModalUploadFile_ModalUploadFile__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17792);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10103);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(82684);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(75367);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(72808);
/* harmony import */ var src_common_SappIcon__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(75440);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(43743);
/* harmony import */ var src_constants_attempt__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(52880);
/* harmony import */ var src_redux_hook__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(34705);
/* harmony import */ var src_redux_slice_Course_MyCourse_Activity_ActivityQuiz__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(3679);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(55402);


























var QuizComponent = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_12__.forwardRef)(function(param, ref) {
    var activeQuestion = param.activeQuestion, showCorrect = param.showCorrect, document_id = param.document_id, activityId = param.activityId, tabId = param.tabId, quizId = param.quizId, setOpenFile = param.setOpenFile, grading_preference = param.grading_preference, _showQuestionContent = param.showQuestionContent, showQuestionContent = _showQuestionContent === void 0 ? true : _showQuestionContent, _isHideExhibit = param.isHideExhibit, isHideExhibit = _isHideExhibit === void 0 ? true : _isHideExhibit, saveAnswer = param.saveAnswer, _exhibitText = param.exhibitText, exhibitText = _exhibitText === void 0 ? "Exhibit" : _exhibitText;
    var _$ref, _$ref1, _$ref2, _$ref3, _$ref4;
    var questionRef = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)(null);
    var dispatch = (0,src_redux_hook__WEBPACK_IMPORTED_MODULE_17__/* .useAppDispatch */ .T)();
    var _$ref5 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_19__/* .useForm */ .cI)({}), controlAnswer = _$ref5.control, setValue = _$ref5.setValue, watch = _$ref5.watch, reset = _$ref5.reset, getValues = _$ref5.getValues, resetField = _$ref5.resetField;
    var DragDropRef = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)(null);
    var _$ref6 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false), showListRequirement = _$ref6[0], setShowListRequirement = _$ref6[1];
    var listRequirementRef = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)(null);
    var _$ref7 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(), exhibitData = _$ref7[0], setExhibitData = _$ref7[1];
    var _$ref8 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false), isChange = _$ref8[0], setIsChange = _$ref8[1];
    var _$ref9 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false), isUploadFile = _$ref9[0], setIsUploadFile = _$ref9[1];
    var _$ref10 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(), essayData = _$ref10[0], setEssayData = _$ref10[1];
    (0,_components_base_clickoutside_HookClick__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        ref: listRequirementRef,
        callback: function() {
            return setShowListRequirement(false);
        }
    });
    var _$ref11 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(), showRequirement = _$ref11[0], setShowRequirement = _$ref11[1];
    var _$ref12 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)({
        requirement_id: undefined,
        question_id: undefined,
        status: false
    }), openUpload = _$ref12[0], setOpenUpload = _$ref12[1];
    var _$ref13 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(), openPdf = _$ref13[0], setOpenPdf = _$ref13[1];
    var refEditor = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)(null);
    var handleResetEssay = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(function(name, defaultValue) {
            var _$ref, _$ref1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_21__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!((activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.response_option) === src_constants__WEBPACK_IMPORTED_MODULE_15__/* .RESPONSE_OPTION.WORD */ .Cj.WORD)) return [
                            3,
                            2
                        ];
                        onResetFormatEssay(name, defaultValue !== null && defaultValue !== void 0 ? defaultValue : src_constants_attempt__WEBPACK_IMPORTED_MODULE_16__/* .DEFAULT_EDITOR_VALUE */ .kO);
                        refEditor === null || refEditor === void 0 ? void 0 : (_$ref = refEditor.current) === null || _$ref === void 0 ? void 0 : _$ref.reset(defaultValue);
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, 10);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        if ((activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.response_option) === src_constants__WEBPACK_IMPORTED_MODULE_15__/* .RESPONSE_OPTION.SHEET */ .Cj.SHEET) {
                            ;
                            onResetFormatEssay(name, defaultValue !== null && defaultValue !== void 0 ? defaultValue : src_constants_attempt__WEBPACK_IMPORTED_MODULE_16__/* .defaultSheetData */ .ej);
                            refEditor === null || refEditor === void 0 ? void 0 : (_$ref1 = refEditor.current) === null || _$ref1 === void 0 ? void 0 : _$ref1.resetSheet();
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleResetEssay(name, defaultValue) {
            return _ref.apply(this, arguments);
        };
    }();
    var onResetWord = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(function(name, response_option, defaultValue) {
            var _$ref;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_21__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(response_option === src_constants__WEBPACK_IMPORTED_MODULE_15__/* .RESPONSE_OPTION.WORD */ .Cj.WORD)) return [
                            3,
                            2
                        ];
                        onResetFormatEssay(name, defaultValue !== null && defaultValue !== void 0 ? defaultValue : src_constants_attempt__WEBPACK_IMPORTED_MODULE_16__/* .DEFAULT_EDITOR_VALUE */ .kO);
                        refEditor === null || refEditor === void 0 ? void 0 : (_$ref = refEditor.current) === null || _$ref === void 0 ? void 0 : _$ref.reset(defaultValue);
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, 10);
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onResetWord(name, response_option, defaultValue) {
            return _ref.apply(this, arguments);
        };
    }();
    var onResetWordOnly = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(function(response_option, defaultValue) {
            var _$ref;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_21__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(response_option === src_constants__WEBPACK_IMPORTED_MODULE_15__/* .RESPONSE_OPTION.WORD */ .Cj.WORD)) return [
                            3,
                            2
                        ];
                        refEditor === null || refEditor === void 0 ? void 0 : (_$ref = refEditor.current) === null || _$ref === void 0 ? void 0 : _$ref.reset(defaultValue);
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, 10);
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onResetWordOnly(response_option, defaultValue) {
            return _ref.apply(this, arguments);
        };
    }();
    var onResetSheet = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(function(response_option) {
            var _$ref;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_21__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(response_option === src_constants__WEBPACK_IMPORTED_MODULE_15__/* .RESPONSE_OPTION.SHEET */ .Cj.SHEET)) return [
                            3,
                            2
                        ];
                        refEditor === null || refEditor === void 0 ? void 0 : (_$ref = refEditor.current) === null || _$ref === void 0 ? void 0 : _$ref.resetSheet();
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, 10);
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onResetSheet(response_option) {
            return _ref.apply(this, arguments);
        };
    }();
    var onResetFormatEssay = function(key, value) {
        resetField(key, {
            defaultValue: value,
            keepDirty: false,
            keepTouched: false,
            keepError: false
        }) // reset riêng field đó
        ;
        setValue(key, value, {
            shouldDirty: false,
            shouldTouch: false,
            shouldValidate: true
        }) // cập nhật lại giá trị
        ;
    // reset()
    };
    var handleShowRequirement = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(function(data) {
            var _$ref, _$ref1, name, _$ref2, _$ref3, defaultValue;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_21__.__generator)(this, function(_state) {
                saveAnswer && saveAnswer();
                setShowListRequirement(false);
                setShowRequirement(data);
                name = "".concat(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id, "_").concat(data === null || data === void 0 ? void 0 : data.id, "_essay");
                defaultValue = (_$ref3 = (_$ref2 = watch(name)) !== null && _$ref2 !== void 0 ? _$ref2 : activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref = activeQuestion.myAnswers) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref[data.index - 1]) === null || _$ref1 === void 0 ? void 0 : _$ref1.short_answer) !== null && _$ref3 !== void 0 ? _$ref3 : null;
                setValue(name, defaultValue);
                handleResetEssay(name, defaultValue);
                setEssayData({
                    req: data,
                    index: data.index - 1
                });
                return [
                    2
                ];
            });
        });
        return function handleShowRequirement(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var getValueFillText = function() {
        var value = [];
        var inputs = document === null || document === void 0 ? void 0 : document.querySelectorAll('input[stringHTML="true"]');
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e = _step.value;
                value === null || value === void 0 ? void 0 : value.push(e === null || e === void 0 ? void 0 : e.value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return value;
    };
    var getAnswerMatching = function() {
        var _$ref;
        var value = [];
        var inputs = questionRef === null || questionRef === void 0 ? void 0 : (_$ref = questionRef.current) === null || _$ref === void 0 ? void 0 : _$ref.querySelectorAll(".sapp-match-result");
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e = _step.value;
                var childId = e === null || e === void 0 ? void 0 : e.querySelector(".sapp-notched-container");
                value.push({
                    question_id: e === null || e === void 0 ? void 0 : e.id,
                    answer_id: childId === null || childId === void 0 ? void 0 : childId.id
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return value;
    };
    var getAnswerDragNDrop = function() {
        var _$ref;
        var value = [];
        var inputs = questionRef === null || questionRef === void 0 ? void 0 : (_$ref = questionRef.current) === null || _$ref === void 0 ? void 0 : _$ref.querySelectorAll(".sapp-input-dragNDrop");
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e = _step.value;
                var idAnswer = e === null || e === void 0 ? void 0 : e.querySelector("span");
                value.push({
                    id: e === null || e === void 0 ? void 0 : e.id,
                    value: e === null || e === void 0 ? void 0 : e.innerText,
                    idAnswer: idAnswer === null || idAnswer === void 0 ? void 0 : idAnswer.id
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return value;
    };
    var handleResponseResults = function() {
        if (activeQuestion) {
            if (!(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.confirmed) && !activeQuestion.isDrafAnswer) {
                return;
            }
            setTimeout(function() {
                switch(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.qType){
                    case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.ONE_CHOICE */ .YU.ONE_CHOICE:
                    case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.TRUE_FALSE */ .YU.TRUE_FALSE:
                        {
                            setValue && setValue("".concat(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id, "_").concat(document_id, "_answer"), activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.defaultValue);
                            break;
                        }
                    case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.MULTIPLE_CHOICE */ .YU.MULTIPLE_CHOICE:
                        {
                            setValue && setValue("".concat(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id, "_").concat(document_id, "_answer"), activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.defaultValue);
                            break;
                        }
                    case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.ESSAY */ .YU.ESSAY:
                        {
                            var _$ref;
                            activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref = activeQuestion.myAnswers) === null || _$ref === void 0 ? void 0 : _$ref.map(function(ans) {
                                var _requirement_id;
                                (ans === null || ans === void 0 ? void 0 : ans.short_answer) && setValue("".concat(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id, "_").concat((_requirement_id = ans.requirement_id) !== null && _requirement_id !== void 0 ? _requirement_id : document_id, "_essay"), ans === null || ans === void 0 ? void 0 : ans.short_answer);
                            });
                        }
                }
            });
        }
    };
    // Lift onSubmit using useImperativeHandle
    (0,react__WEBPACK_IMPORTED_MODULE_12__.useImperativeHandle)(ref, function() {
        return {
            onSubmit: onSubmit,
            reset: reset,
            onSaveAnswer: handleGetAnswer,
            onResetWord: onResetWord,
            onResetSheet: onResetSheet,
            watch: watch,
            getValues: getValues,
            onResetFormatEssay: onResetFormatEssay,
            onResetWordOnly: onResetWordOnly
        };
    });
    var handleGetAnswer = function(activeQuestion) {
        switch(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.qType){
            case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.ONE_CHOICE */ .YU.ONE_CHOICE:
            case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.TRUE_FALSE */ .YU.TRUE_FALSE:
                return getValues("".concat(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id, "_").concat(document_id, "_answer"));
            case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.MULTIPLE_CHOICE */ .YU.MULTIPLE_CHOICE:
                return getValues("".concat(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id, "_").concat(document_id, "_answer"));
            case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.FILL_WORD */ .YU.FILL_WORD:
                return getValueFillText();
            case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.SELECT_WORD */ .YU.SELECT_WORD:
                return getValues("".concat(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id, "_").concat(document_id, "_answer"));
            case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.MATCHING */ .YU.MATCHING:
                return getAnswerMatching();
            case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.DRAG_DROP */ .YU.DRAG_DROP:
                return getAnswerDragNDrop();
            case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.ESSAY */ .YU.ESSAY:
                var _$ref;
                var value = getValues("".concat(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id, "_").concat(document_id, "_essay"));
                var isSubmitted = function() {
                    if ((activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.response_option) === src_constants__WEBPACK_IMPORTED_MODULE_15__/* .RESPONSE_OPTION.SHEET */ .Cj.SHEET) {
                        if (isChange || isUploadFile && grading_preference === "AFTER_ALL_QUESTIONS") {
                            return true;
                        } else if (value) {
                            var data = JSON.parse(value);
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var e = _step.value;
                                    var _$ref;
                                    if ((e === null || e === void 0 ? void 0 : e.celldata) && (e === null || e === void 0 ? void 0 : (_$ref = e.celldata) === null || _$ref === void 0 ? void 0 : _$ref.length) > 0) {
                                        return true;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        return false;
                    } else {
                        if (value !== undefined && value !== "" || isChange || isUploadFile && grading_preference === "AFTER_ALL_QUESTIONS") {
                            return true;
                        }
                        return false;
                    }
                }();
                var active = "UNFINISHED";
                if (isSubmitted || (activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.answer_file)) {
                    active = "SUBMITED";
                }
                if (activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref = activeQuestion.requirements) === null || _$ref === void 0 ? void 0 : _$ref.length) {
                    var _$ref1;
                    var answers = activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref1 = activeQuestion.requirements) === null || _$ref1 === void 0 ? void 0 : _$ref1.map(function(req) {
                        var answer = getValues("".concat(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id, "_").concat(req.id, "_essay"));
                        return {
                            question_id: activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id,
                            answer_file: req === null || req === void 0 ? void 0 : req.answer_file,
                            short_answer: !(0,lodash__WEBPACK_IMPORTED_MODULE_11__.isUndefined)(answer) && !(0,lodash__WEBPACK_IMPORTED_MODULE_11__.isEmpty)(answer) ? String(answer).trim() : "",
                            response_option: (activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.response_option) ? activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.response_option : "WORD",
                            requirement_id: req === null || req === void 0 ? void 0 : req.id,
                            active: active
                        };
                    });
                    return answers;
                } else {
                    var _$ref2;
                    var answer = getValues("".concat(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id, "_").concat((activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref2 = activeQuestion.requirements) === null || _$ref2 === void 0 ? void 0 : _$ref2.length) ? showRequirement === null || showRequirement === void 0 ? void 0 : showRequirement.id : document_id, "_essay"));
                    return [
                        {
                            question_id: activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id,
                            answer_file: activeQuestion.answer_file,
                            short_answer: !(0,lodash__WEBPACK_IMPORTED_MODULE_11__.isUndefined)(answer) && !(0,lodash__WEBPACK_IMPORTED_MODULE_11__.isEmpty)(answer) ? String(answer).trim() : "",
                            response_option: (activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.response_option) ? activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.response_option : "WORD",
                            requirement_id: null,
                            active: active
                        }, 
                    ];
                }
            default:
                break;
        }
    };
    var onSubmit = function(param) {
        var activityId = param.activityId, tabId = param.tabId, quizId = param.quizId, time_spent = param.time_spent, then = param.then, onError = param.onError, onFinally = param.onFinally;
        if (activeQuestion) {
            var _$ref;
            var myAnswers = handleGetAnswer(activeQuestion);
            DragDropRef === null || DragDropRef === void 0 ? void 0 : (_$ref = DragDropRef.current) === null || _$ref === void 0 ? void 0 : _$ref.handleReset();
            try {
                dispatch((0,src_redux_slice_Course_MyCourse_Activity_ActivityQuiz__WEBPACK_IMPORTED_MODULE_18__/* .confirmQuestion */ .Lq)({
                    activityId: activityId,
                    tabId: tabId,
                    quizId: quizId,
                    questionId: (activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id) || "",
                    myAnswers: myAnswers,
                    time_spent: time_spent
                })).unwrap().then(function(e) {
                    then && then(e);
                }).catch(function(e) {
                    react_hot_toast__WEBPACK_IMPORTED_MODULE_13__/* ["default"].error */ .ZP.error("C\xf3 lỗi xảy ra xin vui l\xf2ng thử lại!");
                    onError && onError(e);
                });
            } catch (error) {
                react_hot_toast__WEBPACK_IMPORTED_MODULE_13__/* ["default"].error */ .ZP.error("C\xf3 lỗi xảy ra xin vui l\xf2ng thử lại!");
                onError && onError(error);
            } finally{
                onFinally && onFinally();
            }
        }
    };
    var handleSaveFileEssay = function(file, question_id, topic_id, requirement_id) {
        try {
            var _$ref;
            dispatch((0,src_redux_slice_Course_MyCourse_Activity_ActivityQuiz__WEBPACK_IMPORTED_MODULE_18__/* .saveFileEssay */ .wr)({
                activityId: activityId,
                tabId: tabId,
                quizId: quizId,
                question_id: question_id,
                file: file,
                topic_id: topic_id,
                requirement_id: requirement_id,
                requirements: activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref = activeQuestion.requirements) === null || _$ref === void 0 ? void 0 : _$ref.map(function(item) {
                    if ((item === null || item === void 0 ? void 0 : item.id) === (showRequirement === null || showRequirement === void 0 ? void 0 : showRequirement.id)) {
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({}, item), {
                            answer_file: {
                                file_key: file.file_key,
                                file_name: file.name
                            }
                        });
                    }
                    return item;
                })
            }));
            setIsUploadFile(true);
        } catch (error) {
            react_hot_toast__WEBPACK_IMPORTED_MODULE_13__/* ["default"].error */ .ZP.error("C\xf3 lỗi xảy ra xin vui l\xf2ng thử lại!");
        }
    };
    var renderQuestion = function() {
        switch(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.qType){
            case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.ONE_CHOICE */ .YU.ONE_CHOICE:
            case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.TRUE_FALSE */ .YU.TRUE_FALSE:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_questionType_OneChoiceQuestion__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    data: activeQuestion,
                    control: controlAnswer,
                    corrects: showCorrect ? activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.corrects : undefined,
                    setValue: setValue,
                    setOpenFile: setOpenFile,
                    isHideExhibit: isHideExhibit,
                    name: "".concat(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id, "_").concat(document_id, "_answer"),
                    solution: activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.solution,
                    exhibitText: exhibitText
                });
            case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.MULTIPLE_CHOICE */ .YU.MULTIPLE_CHOICE:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_questionType_MultipleChoiceQuestion__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    data: activeQuestion,
                    control: controlAnswer,
                    corrects: showCorrect ? activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.corrects : undefined,
                    setValue: setValue,
                    setOpenFile: setOpenFile,
                    isHideExhibit: isHideExhibit,
                    name: "".concat(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id, "_").concat(document_id, "_answer"),
                    solution: activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.solution,
                    exhibitText: exhibitText
                });
            case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.MATCHING */ .YU.MATCHING:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_questionType_MatchingQuestion__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    data: activeQuestion,
                    action: getAnswerMatching,
                    defaultAnswer: activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.defaultValue,
                    corrects: showCorrect ? activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.corrects : undefined,
                    setOpenFile: setOpenFile,
                    isHideExhibit: isHideExhibit,
                    uuid: "_" + (0,uuid__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)().replaceAll("-", "_"),
                    solution: activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.solution,
                    exhibitText: exhibitText
                });
            case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.FILL_WORD */ .YU.FILL_WORD:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_questionType_FillText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    data: activeQuestion,
                    action: getValueFillText,
                    defaultAnswer: activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.defaultValue,
                    setOpenFile: setOpenFile,
                    isHideExhibit: isHideExhibit,
                    corrects: showCorrect ? activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.corrects : undefined,
                    solution: activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.solution,
                    exhibitText: exhibitText
                });
            case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.DRAG_DROP */ .YU.DRAG_DROP:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_questionType_DragNDrop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    data: activeQuestion,
                    action: getAnswerDragNDrop,
                    defaultAnswer: activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.defaultValue,
                    corrects: showCorrect ? activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.corrects : undefined,
                    resetDefaultAnswer: false,
                    setOpenFile: setOpenFile,
                    ref: DragDropRef,
                    isHideExhibit: isHideExhibit,
                    uuid: "_" + (0,uuid__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)().replaceAll("-", "_"),
                    solution: activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.solution,
                    exhibitText: exhibitText
                });
            case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.SELECT_WORD */ .YU.SELECT_WORD:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_questionType_SelectQuestion__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    onChange: function(value) {
                        return setValue === null || setValue === void 0 ? void 0 : setValue("".concat(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id, "_").concat(document_id, "_answer"), value);
                    },
                    data: activeQuestion,
                    defaultAnswer: activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.defaultValue,
                    setOpenFile: setOpenFile,
                    isHideExhibit: isHideExhibit,
                    corrects: showCorrect ? activeQuestion.corrects : undefined,
                    solution: activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.solution,
                    exhibitText: exhibitText
                });
            case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.ESSAY */ .YU.ESSAY:
                var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5, _$ref6, _$ref7;
                var getDefaultValue = function() {
                    switch(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.response_option){
                        case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .RESPONSE_OPTION.WORD */ .Cj.WORD:
                            var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5, _$ref6;
                            var _$ref7, _$ref8, _$ref9;
                            return (_$ref9 = (_$ref8 = watch("".concat(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id, "_").concat((activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref = activeQuestion.requirements) === null || _$ref === void 0 ? void 0 : _$ref.length) ? activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref1 = activeQuestion.requirements) === null || _$ref1 === void 0 ? void 0 : (_$ref2 = _$ref1[(_$ref7 = essayData === null || essayData === void 0 ? void 0 : essayData.index) !== null && _$ref7 !== void 0 ? _$ref7 : 0]) === null || _$ref2 === void 0 ? void 0 : _$ref2.id : document_id, "_essay"))) !== null && _$ref8 !== void 0 ? _$ref8 : (_$ref4 = activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref3 = activeQuestion.myAnswers) === null || _$ref3 === void 0 ? void 0 : _$ref3.find(function(ans) {
                                var _$ref, _$ref1;
                                var _$ref2;
                                if (ans.requirement_id === (activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref = activeQuestion.requirements) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref[(_$ref2 = essayData === null || essayData === void 0 ? void 0 : essayData.index) !== null && _$ref2 !== void 0 ? _$ref2 : 0]) === null || _$ref1 === void 0 ? void 0 : _$ref1.id)) {
                                    return ans;
                                }
                            })) === null || _$ref4 === void 0 ? void 0 : _$ref4.short_answer) !== null && _$ref9 !== void 0 ? _$ref9 : activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref5 = activeQuestion.myAnswers) === null || _$ref5 === void 0 ? void 0 : (_$ref6 = _$ref5[0]) === null || _$ref6 === void 0 ? void 0 : _$ref6.short_answer;
                            break;
                        case src_constants__WEBPACK_IMPORTED_MODULE_15__/* .RESPONSE_OPTION.SHEET */ .Cj.SHEET:
                            var // getValues(
                            //   `${activeQuestion?.id}_${activeQuestion?.requirements?.length ? activeQuestion?.requirements?.[essayData?.index ?? 0]?.id : document_id}_essay`,
                            // ) ??
                            _$ref10, _$ref11, _$ref12, _$ref13;
                            var _$ref14;
                            return (_$ref14 = (_$ref11 = activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref10 = activeQuestion.myAnswers) === null || _$ref10 === void 0 ? void 0 : _$ref10.find(function(ans) {
                                var _$ref, _$ref1;
                                var _$ref2;
                                if (ans.requirement_id === (activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref = activeQuestion.requirements) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref[(_$ref2 = essayData === null || essayData === void 0 ? void 0 : essayData.index) !== null && _$ref2 !== void 0 ? _$ref2 : 0]) === null || _$ref1 === void 0 ? void 0 : _$ref1.id)) {
                                    return ans;
                                }
                            })) === null || _$ref11 === void 0 ? void 0 : _$ref11.short_answer) !== null && _$ref14 !== void 0 ? _$ref14 : activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref12 = activeQuestion.myAnswers) === null || _$ref12 === void 0 ? void 0 : (_$ref13 = _$ref12[0]) === null || _$ref13 === void 0 ? void 0 : _$ref13.short_answer;
                            break;
                    }
                };
                var _$ref8, _$ref9, _$ref10;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            className: "editor-wrap mt-1.5",
                                            text_editor_content: activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.question_content
                                        })
                                    })
                                }),
                                !!(activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref = activeQuestion.requirements) === null || _$ref === void 0 ? void 0 : _$ref.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "my-6 border border-b-gray-2"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex cursor-pointer select-none items-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "relative",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "group flex items-center hover:text-primary",
                                                            onClick: function() {
                                                                return setShowListRequirement(true);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "font-semibold",
                                                                    children: [
                                                                        "Requirement ",
                                                                        showRequirement === null || showRequirement === void 0 ? void 0 : showRequirement.index,
                                                                        "/",
                                                                        (activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref1 = activeQuestion.requirements) === null || _$ref1 === void 0 ? void 0 : _$ref1.length) || 0
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_common_SappIcon__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                                        className: "-mt-1 ml-2 fill-bw-1 group-hover:fill-primary",
                                                                        icon: "arrow_down"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        showListRequirement && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            ref: listRequirementRef,
                                                            className: "text-over absolute bottom-0 left-0 z-[201] w-max max-w-md translate-y-full bg-white py-1 shadow-md",
                                                            children: activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref2 = activeQuestion.requirements) === null || _$ref2 === void 0 ? void 0 : _$ref2.map(function(e, i) {
                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    onClick: function() {
                                                                        handleShowRequirement({
                                                                            id: e.id,
                                                                            description: e === null || e === void 0 ? void 0 : e.description,
                                                                            index: i + 1,
                                                                            name: e === null || e === void 0 ? void 0 : e.name,
                                                                            files: e === null || e === void 0 ? void 0 : e.files
                                                                        });
                                                                    },
                                                                    className: "truncate px-3 py-1.5 font-semibold hover:text-primary",
                                                                    children: "Requirement ".concat(i + 1, ": ").concat(e === null || e === void 0 ? void 0 : e.name)
                                                                }, e.id);
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "ml-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "text-state-error",
                                                            children: "* "
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            className: "text-gray-1",
                                                            children: [
                                                                "You must finished",
                                                                " ",
                                                                (activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref3 = activeQuestion.requirements) === null || _$ref3 === void 0 ? void 0 : _$ref3.length) || 0,
                                                                " ",
                                                                "requirements to complete this question (Your answer is auto save)"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                exhibitData && (exhibitData === null || exhibitData === void 0 ? void 0 : exhibitData.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "my-6 border border-b-gray-2"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "mb-4 flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "font-semibold",
                                                    children: [
                                                        exhibitText,
                                                        "s (",
                                                        (exhibitData === null || exhibitData === void 0 ? void 0 : exhibitData.length) || 0,
                                                        ")"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "ml-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "text-state-error",
                                                            children: "* "
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "text-gray-1",
                                                            children: "Click to view"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex flex-col gap-2",
                                            children: exhibitData === null || exhibitData === void 0 ? void 0 : exhibitData.map(function(e, i) {
                                                var _$ref;
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "cursor-pointer hover:text-primary",
                                                    onClick: function(event) {
                                                        setOpenFile && setOpenFile({
                                                            type: "exhibits",
                                                            description: e === null || e === void 0 ? void 0 : e.description,
                                                            name: e === null || e === void 0 ? void 0 : e.name,
                                                            index: i,
                                                            files: e === null || e === void 0 ? void 0 : e.files
                                                        }, null, null, event);
                                                    },
                                                    children: [
                                                        exhibitText,
                                                        " ",
                                                        i + 1,
                                                        ": ",
                                                        e === null || e === void 0 ? void 0 : e.name
                                                    ]
                                                }, (_$ref = e === null || e === void 0 ? void 0 : e.id) !== null && _$ref !== void 0 ? _$ref : i);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "my-6"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_questionType_ConstructedQuestion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            defaultValue: getDefaultValue(),
                            data: activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref4 = activeQuestion.requirements) === null || _$ref4 === void 0 ? void 0 : _$ref4[(_$ref8 = essayData === null || essayData === void 0 ? void 0 : essayData.index) !== null && _$ref8 !== void 0 ? _$ref8 : 0],
                            question_content: activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.question_content,
                            index: essayData === null || essayData === void 0 ? void 0 : essayData.index,
                            question_data: activeQuestion,
                            control: controlAnswer,
                            setValue: setValue,
                            handleSaveHighLight: function() {},
                            forCaseStudy: true,
                            name: "".concat(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id, "_").concat((activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref5 = activeQuestion.requirements) === null || _$ref5 === void 0 ? void 0 : _$ref5.length) ? activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref6 = activeQuestion.requirements) === null || _$ref6 === void 0 ? void 0 : (_$ref7 = _$ref6[(_$ref9 = essayData === null || essayData === void 0 ? void 0 : essayData.index) !== null && _$ref9 !== void 0 ? _$ref9 : 0]) === null || _$ref7 === void 0 ? void 0 : _$ref7.id : document_id, "_essay"),
                            fullData: {
                                data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({}, activeQuestion),
                                solution: (_$ref10 = activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.solution) !== null && _$ref10 !== void 0 ? _$ref10 : ""
                            },
                            openChooseFile: function(e) {
                                return setOpenUpload({
                                    status: true,
                                    question_id: activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id,
                                    requirement_id: showRequirement === null || showRequirement === void 0 ? void 0 : showRequirement.id
                                });
                            },
                            handleClearFile: function() {
                                var _$ref;
                                dispatch((0,src_redux_slice_Course_MyCourse_Activity_ActivityQuiz__WEBPACK_IMPORTED_MODULE_18__/* .clearFileEssay */ .s1)({
                                    activityId: activityId,
                                    tabId: tabId,
                                    quizId: quizId,
                                    question_id: activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id,
                                    requirement_id: showRequirement === null || showRequirement === void 0 ? void 0 : showRequirement.id,
                                    requirements: activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref = activeQuestion.requirements) === null || _$ref === void 0 ? void 0 : _$ref.map(function(item) {
                                        if ((item === null || item === void 0 ? void 0 : item.id) === (showRequirement === null || showRequirement === void 0 ? void 0 : showRequirement.id)) {
                                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({}, item), {
                                                answer_file: null
                                            });
                                        }
                                        return item;
                                    })
                                }));
                            },
                            handleChange: function() {
                                !isChange && setIsChange(true);
                            },
                            isShowContent: showQuestionContent,
                            externalRef: refEditor
                        })
                    ]
                });
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
        }
    };
    var handleDefaultRequirement = function() {
        var _$ref;
        var defaultRequirement = activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref = activeQuestion.requirements) === null || _$ref === void 0 ? void 0 : _$ref[0];
        if (defaultRequirement === null || defaultRequirement === void 0 ? void 0 : defaultRequirement.id) {
            setShowRequirement({
                name: defaultRequirement === null || defaultRequirement === void 0 ? void 0 : defaultRequirement.name,
                id: defaultRequirement === null || defaultRequirement === void 0 ? void 0 : defaultRequirement.id,
                description: defaultRequirement === null || defaultRequirement === void 0 ? void 0 : defaultRequirement.description,
                files: defaultRequirement === null || defaultRequirement === void 0 ? void 0 : defaultRequirement.files,
                index: 1
            });
        } else {
            setShowRequirement(null);
        }
    };
    var handleGetExhibit = function() {
        var _$ref, _$ref1, _$ref2, _$ref3;
        if (activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.requirements) {
            var _$ref4;
            setEssayData({
                req: activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref4 = activeQuestion.requirements) === null || _$ref4 === void 0 ? void 0 : _$ref4[0],
                index: 0
            });
        }
        var exhibitOption = [];
        if ((activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref = activeQuestion.exhibits) === null || _$ref === void 0 ? void 0 : _$ref.length) && 0 < (activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref1 = activeQuestion.exhibits) === null || _$ref1 === void 0 ? void 0 : _$ref1.length)) {
            var _exhibitOption;
            (_exhibitOption = exhibitOption).push.apply(_exhibitOption, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)(activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.exhibits));
        }
        if (activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref2 = activeQuestion.question_topic) === null || _$ref2 === void 0 ? void 0 : (_$ref3 = _$ref2.exhibits) === null || _$ref3 === void 0 ? void 0 : _$ref3.length) {
            var _exhibitOption1;
            var _$ref5;
            exhibitOption === null || exhibitOption === void 0 ? void 0 : (_exhibitOption1 = exhibitOption).push.apply(_exhibitOption1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)(activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref5 = activeQuestion.question_topic) === null || _$ref5 === void 0 ? void 0 : _$ref5.exhibits));
        }
        setExhibitData(exhibitOption);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(function() {
        handleDefaultRequirement();
        handleGetExhibit();
        if ((activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.qType) === src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.ONE_CHOICE */ .YU.ONE_CHOICE || (activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.qType) === src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.TRUE_FALSE */ .YU.TRUE_FALSE || (activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.qType) === src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.MULTIPLE_CHOICE */ .YU.MULTIPLE_CHOICE || (activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.qType) === src_constants__WEBPACK_IMPORTED_MODULE_15__/* .QUESTION_TYPES.ESSAY */ .YU.ESSAY) {
            handleResponseResults();
        }
    }, [
        activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.id
    ]);
    var _$ref14, _$ref15;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                ref: questionRef,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        text_editor_content: activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref = activeQuestion.question_topic) === null || _$ref === void 0 ? void 0 : _$ref.description,
                        className: "sapp-questions"
                    }),
                    (activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref1 = activeQuestion.question_topic) === null || _$ref1 === void 0 ? void 0 : (_$ref2 = _$ref1.files) === null || _$ref2 === void 0 ? void 0 : _$ref2.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-2",
                        children: [
                            !!(activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref3 = activeQuestion.question_topic) === null || _$ref3 === void 0 ? void 0 : _$ref3.description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "my-6 border border-b-gray-2"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-2 font-semibold",
                                children: "Topic Resource:"
                            }),
                            activeQuestion === null || activeQuestion === void 0 ? void 0 : (_$ref4 = activeQuestion.question_topic) === null || _$ref4 === void 0 ? void 0 : _$ref4.files.map(function(e, index) {
                                var _$ref;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "cursor-pointer text-state-info hover:underline",
                                    onClick: function() {
                                        var _$ref, _$ref1;
                                        setOpenFile && setOpenFile({
                                            type: "file"
                                        }, e === null || e === void 0 ? void 0 : (_$ref = e.resource) === null || _$ref === void 0 ? void 0 : _$ref.url, e === null || e === void 0 ? void 0 : (_$ref1 = e.resource) === null || _$ref1 === void 0 ? void 0 : _$ref1.name);
                                    },
                                    children: e === null || e === void 0 ? void 0 : (_$ref = e.resource) === null || _$ref === void 0 ? void 0 : _$ref.name
                                }, index);
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "my-6 border border-b-gray-2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_12__.Fragment, {
                        children: renderQuestion()
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uploadFile_ModalUploadFile_ModalUploadFile__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                open: openUpload.status,
                isMultiple: false,
                handleClose: function() {
                    setOpenUpload({
                        status: false,
                        question_id: undefined,
                        requirement_id: undefined
                    });
                },
                overlayClass: "!h-screen",
                className: "!overflow-auto",
                fileType: "ESSAY",
                location: "question-answer/".concat(openUpload.question_id),
                setSelectedFile: function(e) {
                    return handleSaveFileEssay(e === null || e === void 0 ? void 0 : e[0], (_$ref14 = openUpload === null || openUpload === void 0 ? void 0 : openUpload.question_id) !== null && _$ref14 !== void 0 ? _$ref14 : "", "", (_$ref15 = showRequirement === null || showRequirement === void 0 ? void 0 : showRequirement.id) !== null && _$ref15 !== void 0 ? _$ref15 : "");
                }
            })
        ]
    });
});
QuizComponent.displayName = "QuizComponent";
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_12__.memo)(QuizComponent));


/***/ }),

/***/ 92937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ConstructedQuestion; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(51224);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(21967);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(37559);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(52621);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 10 modules
var es_skeleton = __webpack_require__(44755);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(75367);
// EXTERNAL MODULE: ./src/common/ErrorMessage.tsx
var ErrorMessage = __webpack_require__(68507);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js + 5 modules
var spin = __webpack_require__(42339);
// EXTERNAL MODULE: ./src/constants/index.ts + 4 modules
var constants = __webpack_require__(43743);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(18473);
// EXTERNAL MODULE: ./src/pages/api/upload/index.ts
var upload = __webpack_require__(95986);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(68582);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(72808);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(45332);
;// CONCATENATED MODULE: ./src/utils/helpers/tiptap.ts







// Hàm chuyển base64 thành File
function base64ToFile(base64String) {
    var fileName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "image.png";
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)(base64String.split(","), 2), header = ref1[0], base64Data = ref1[1];
    var mimeType = (ref = header.match(/data:(.*);base64/)) === null || ref === void 0 ? void 0 : ref[1];
    var byteString = atob(base64Data);
    var arrayBuffer = new ArrayBuffer(byteString.length);
    var uint8Array = new Uint8Array(arrayBuffer);
    for(var i = 0; i < byteString.length; i++){
        uint8Array[i] = byteString.charCodeAt(i);
    }
    return new File([
        arrayBuffer
    ], fileName, {
        type: mimeType || "image/png"
    });
}
//  // Chuyển base64 thành File để tải lên S3
//  const convertedFile = base64ToFile(base64String as string, 'image.png')
/**
 * @param description Hàm xử lý tải ảnh lên và nhận URL từ API S3
 * @param {File} convertedFile - File đã được chuyển đổi.
 * @param {string} location - Vị trí lưu trữ file trên S3 (mặc định là 'library-editor').
 * @param {function} getProgress - Hàm callback để cập nhật tiến trình tải lên (không bắt buộc).
 * @param {AbortSignal} abortSignal - Signal để hủy tải lên (không bắt buộc).
 * @returns {Promise<{ url: string } | undefined>} - Promise trả về URL của file sau khi tải lên hoặc undefined nếu tải lên thất bại.
 */ var handleUploadFileToS3 = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(convertedFile, location, getProgress, abortSignal) {
        var source, ref, response, uploadUrlRes, uploadError;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    source = axios/* default.CancelToken.source */.Z.CancelToken.source();
                    // Nếu signal bị abort thì cancel axios
                    abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.addEventListener("abort", function() {
                        source.cancel("Upload cancelled");
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        upload/* UploadAPI.startUpload */.h.startUpload({
                            content_type: convertedFile.type,
                            blob: convertedFile,
                            size: convertedFile.size.toString(),
                            description: "",
                            name: (0,utils/* convertHumanReadableToSnakeCase */.Z9)(convertedFile.name),
                            getProgress: getProgress ? getProgress : function() {},
                            location: location
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        4,
                        upload/* UploadAPI.getUrlFile */.h.getUrlFile(response.data.file_key)
                    ];
                case 3:
                    uploadUrlRes = _state.sent();
                    return [
                        2,
                        {
                            url: (ref = uploadUrlRes.data) === null || ref === void 0 ? void 0 : ref.url
                        }
                    ];
                case 4:
                    uploadError = _state.sent();
                    if (axios/* default.isCancel */.Z.isCancel(uploadError)) {
                        dist/* default.error */.ZP.error("Upload cancelled");
                    } else {
                        dist/* default.error */.ZP.error(uploadError);
                    }
                    throw uploadError;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function handleUploadFileToS3(convertedFile, location, getProgress, abortSignal) {
        return _ref.apply(this, arguments);
    };
}();
// Hàm chuyển file thành base64
function fileToBase64(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function() {
            return resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

;// CONCATENATED MODULE: ./src/hooks/useSappEditorImageUpload.ts



var useSappEditorImageUpload = function() {
    var handleImageUpload = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(file, location) {
            var base64String, convertedFile, response, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fileToBase64(file)
                        ];
                    case 1:
                        base64String = _state.sent();
                        convertedFile = base64ToFile(base64String, file.name || "image.png");
                        return [
                            4,
                            handleUploadFileToS3(convertedFile, location)
                        ];
                    case 2:
                        response = _state.sent();
                        if (!(response === null || response === void 0 ? void 0 : response.url)) {
                            throw new Error("Upload failed: No URL returned");
                        }
                        return [
                            2,
                            response.url
                        ];
                    case 3:
                        err = _state.sent();
                        throw err;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleImageUpload(file, location) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        handleImageUpload: handleImageUpload
    };
};

// EXTERNAL MODULE: ./node_modules/sapp-common-package/dist/index.js
var sapp_common_package_dist = __webpack_require__(97438);
;// CONCATENATED MODULE: ./src/components/form/editor.tsx








var Editor = function(param) {
    var onChange = param.onChange, valueText = param.valueText, _className = param.className, className = _className === void 0 ? "" : _className, height = param.height, math = param.math, placeholder = param.placeholder, getContent = param.getContent, _acceptFiles = param.acceptFiles, acceptFiles = _acceptFiles === void 0 ? constants/* VALID_UPLOAD_EDITOR */.Bm : _acceptFiles, disabled = param.disabled, key = param.key, editorRef = param.editorRef;
    var handleImageUpload = useSappEditorImageUpload().handleImageUpload;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
            spinning: loading,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sapp_common_package_dist/* SAPPEditor */.Ad, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: editorRef
            }, key && {
                key: key
            }), {
                content: valueText,
                onChange: onChange,
                handleImageUpload: function(file) {
                    return handleImageUpload(file, "lms/library-editor");
                },
                placeholder: placeholder,
                disabled: disabled
            }))
        })
    }, key);
};
/* harmony default export */ var editor = (Editor);

// EXTERNAL MODULE: ./src/constants/attempt.ts
var attempt = __webpack_require__(52880);
;// CONCATENATED MODULE: ./src/components/base/editor/HookFormEditorV2.tsx






var HookFormEditorV2 = function(param) {
    var name = param.name, control = param.control, _defaultValue = param.defaultValue, defaultValue = _defaultValue === void 0 ? attempt/* DEFAULT_EDITOR_VALUE */.kO : _defaultValue, className = param.className, height = param.height, skeleton = param.skeleton, math = param.math, placeholder = param.placeholder, label = param.label, required = param.required, guideline = param.guideline, handleChange = param.handleChange, // labelClass = 'd-flex align-items-center fs-6 fw-bold form-label',
    disabled = param.disabled, editorRef = param.editorRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: name,
        control: control,
        defaultValue: defaultValue,
        render: function(param) {
            var _field = param.field, onChange = _field.onChange, value = _field.value, error = param.fieldState.error;
            var ref;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "mb-2 block text-base font-medium",
                        children: [
                            label,
                            " ",
                            "".concat(required ? "*" : "")
                        ]
                    }),
                    " ",
                    !skeleton ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(editor, {
                                onChange: function(e) {
                                    onChange(e);
                                    handleChange && handleChange(e);
                                },
                                // key={key}
                                valueText: defaultValue,
                                className: "".concat(className, " ").concat(error ? "tox-tinymce_error" : ""),
                                height: height,
                                math: math,
                                placeholder: placeholder,
                                disabled: disabled,
                                editorRef: editorRef
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage/* default */.Z, {
                                    children: (ref = error === null || error === void 0 ? void 0 : error.message) !== null && ref !== void 0 ? ref : ""
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(es_skeleton/* default.Input */.Z.Input, {
                        size: "large",
                        active: true,
                        className: "hook-form-editors_skeleton"
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var editor_HookFormEditorV2 = (HookFormEditorV2);

// EXTERNAL MODULE: ./src/components/base/editor/EditorReader.tsx + 1 modules
var EditorReader = __webpack_require__(95215);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(10103);
// EXTERNAL MODULE: ./src/assets/icons/index.tsx + 2 modules
var icons = __webpack_require__(34648);
// EXTERNAL MODULE: ./src/redux/hook.ts
var hook = __webpack_require__(34705);
// EXTERNAL MODULE: ./src/redux/slice/Login/Login.tsx
var Login = __webpack_require__(31518);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(57368);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(72760);
// EXTERNAL MODULE: ./node_modules/@fortune-sheet/react/dist/index.esm.js + 23 modules
var dist_index_esm = __webpack_require__(46137);
;// CONCATENATED MODULE: ./src/components/base/textfield/HookFormExcel.tsx






var HookFormExcel = function(param) {
    var index = param.index, value = param.value, defaultValue = param.defaultValue, onChange = param.onChange, fullData = param.fullData, ignoreStructOpsRef = param.ignoreStructOpsRef, refSheet = param.refSheet, sheetsSnapshotRef = param.sheetsSnapshotRef, onOp = param.onOp, question_data = param.question_data;
    var ref = (0,react.useState)(function() {
        try {
            return defaultValue && String(defaultValue).trim() !== "" ? JSON.parse(defaultValue) : [
                {
                    name: "Sheet1",
                    id: (0,attempt/* generateSheetId */.eq)(),
                    status: 1,
                    data: [
                        []
                    ],
                    celldata: []
                }, 
            ];
        } catch (e) {
            return [
                {
                    name: "Sheet1",
                    id: (0,attempt/* generateSheetId */.eq)(),
                    status: 1,
                    data: [
                        []
                    ],
                    celldata: []
                }, 
            ];
        }
    }), initialData = ref[0];
    // nếu value thay đổi từ ngoài (ví dụ load form mới) → chỉ setData lúc đầu, không push liên tục
    // useEffect(() => {
    //     if (
    //         refSheet &&
    //         refSheet.current &&
    //         Number(index) <= question_data?.requirements?.length
    //     ) {
    //         if (
    //             defaultValue === undefined ||
    //             defaultValue === null ||
    //             String(defaultValue).trim() === ''
    //         ) {
    //             const emptySheets = refSheet.current
    //                 ?.getAllSheets()
    //                 .map((sheet: SheetData) => ({
    //                     ...sheet,
    //                     celldata: [],
    //                     data: Array(sheet.row || 100)
    //                         .fill(null)
    //                         .map(() => Array(sheet.column || 50).fill(null)),
    //                 }))
    //             emptySheets.forEach((sheet: SheetData) => {
    //                 refSheet.current?.updateSheet(JSON.parse(JSON.stringify([sheet])))
    //             })
    //         } else {
    //             const sheetData =
    //                 defaultValue && String(defaultValue).trim() !== ''
    //                     ? JSON.parse(defaultValue)
    //                     : [
    //                         {
    //                             name: 'Sheet1',
    //                             id: generateSheetId(),
    //                             status: 1,
    //                             data: [[]],
    //                             celldata: [],
    //                         },
    //                     ]
    //             // Convert sheetData to constructor with id of refSheet.current
    //             const currentSheets = refSheet.current.getAllSheets()
    //             const updatedSheetData = sheetData.map(
    //                 (sheet: SheetData, index: number) => ({
    //                     ...sheet,
    //                     id: currentSheets[index]?.id || '',
    //                 }),
    //             )
    //             const emptySheets = currentSheets.map((sheet: SheetData) => ({
    //                 ...sheet,
    //                 celldata: [],
    //                 data: Array(sheet.row || 100)
    //                     .fill(null)
    //                     .map(() => Array(sheet.column || 50).fill(null)),
    //             }))
    //             emptySheets.forEach((sheet: SheetData, index: number) => {
    //                 if (sheet?.name === sheetData[index]?.name) {
    //                     refSheet.current?.updateSheet(
    //                         JSON.parse(JSON.stringify([updatedSheetData[index]])),
    //                     )
    //                 } else {
    //                     refSheet.current?.updateSheet(JSON.parse(JSON.stringify([sheet])))
    //                 }
    //             })
    //         }
    //     }
    // }, [defaultValue, index])
    var handleWorkbookChange = (0,react.useCallback)(function() {
        if (ignoreStructOpsRef.current) return;
        if (!(fullData === null || fullData === void 0 ? void 0 : fullData.is_viewed_answer) && !(fullData === null || fullData === void 0 ? void 0 : fullData.confirmed)) {
            var ref;
            var currentSheet = (ref = refSheet.current) === null || ref === void 0 ? void 0 : ref.getSheet();
            if (!(currentSheet === null || currentSheet === void 0 ? void 0 : currentSheet.id)) return;
            if (value) {
                var old = (0,_to_consumable_array/* default */.Z)(JSON.parse(value));
                var index = old === null || old === void 0 ? void 0 : old.findIndex(function(e) {
                    return (e === null || e === void 0 ? void 0 : e.id) === (currentSheet === null || currentSheet === void 0 ? void 0 : currentSheet.id);
                });
                if (index >= 0) {
                    old.splice(index, 1, currentSheet);
                } else {
                    old.push(currentSheet);
                }
                sheetsSnapshotRef.current = old;
                onChange(JSON.stringify(old));
            } else {
                var newData = [
                    currentSheet
                ];
                sheetsSnapshotRef.current = newData;
                onChange(JSON.stringify(newData));
            }
        }
    }, [
        onChange,
        fullData
    ]);
    var isValid = function(value) {
        try {
            if (!value || (0,lodash.isEmpty)(value) || (0,lodash.isUndefined)(value) || (0,lodash.isNull)(value)) return false;
            JSON.parse(value);
            return true;
        } catch (e) {
            return false;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Workbook */.I, {
        // data={defaultValue && isValid(defaultValue) ? JSON.parse(defaultValue) : [
        //     {
        //         name: 'Sheet1',
        //         // config: {
        //         //   authority: {
        //         //     sheet: true, //If it is 1 or true, the worksheet is protected; if it is 0 or false, the worksheet is not protected.
        //         //   },
        //         // },
        //     },
        // ]}
        data: initialData,
        ref: refSheet,
        onChange: handleWorkbookChange,
        onOp: onOp
    });
};
/* harmony default export */ var textfield_HookFormExcel = (/*#__PURE__*/(0,react.memo)(HookFormExcel));

;// CONCATENATED MODULE: ./src/components/questionType/ConstructedQuestion.tsx








// import SpreadsheetEditor from '@components/base/spreadSheet/SpreadSheetEditor'












var EssayQuestionPreview = function(param) {
    var data = param.data, question_content = param.question_content, index = param.index, question_data = param.question_data, control = param.control, _handleSaveHighLight = param.handleSaveHighLight, handleSaveHighLight = _handleSaveHighLight === void 0 ? function() {} : _handleSaveHighLight, highlighted = param.highlighted, removeHighlight = param.removeHighlight, allowHighLight = param.allowHighLight, _forCaseStudy = param.forCaseStudy, forCaseStudy = _forCaseStudy === void 0 ? false : _forCaseStudy, solution = param.solution, name = param.name, setValue = param.setValue, defaultValue = param.defaultValue, response_option_custom = param.response_option_custom, externalRef = param.externalRef, fullData = param.fullData, openChooseFile = param.openChooseFile, handleClearFile = param.handleClearFile, setOpenPdf = param.setOpenPdf, allowUnHighLight = param.allowUnHighLight, _handleSaveHighLightRequirement = param.handleSaveHighLightRequirement, handleSaveHighLightRequirement = _handleSaveHighLightRequirement === void 0 ? function() {} : _handleSaveHighLightRequirement, setUnsavedChanges = param.setUnsavedChanges, handleChange = param.handleChange, _isShowContent = param.isShowContent, isShowContent = _isShowContent === void 0 ? true : _isShowContent, _showRequiment = param.showRequiment, showRequiment = _showRequiment === void 0 ? false : _showRequiment, _isInTest = param.isInTest, isInTest = _isInTest === void 0 ? false : _isInTest;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
    var dispatch = (0,hook/* useAppDispatch */.T)();
    var refSheet = (0,react.useRef)(null);
    var ref23 = (0,react.useState)("1"), key = ref23[0], setKey = ref23[1];
    var editorRef = (0,react.useRef)(null);
    // Cờ chặn tạm thời onChange trong lúc đang thực hiện các thao tác cấu trúc
    // (thêm/xóa/undo/redo/di chuyển/sao chép sheet) của Fortune Sheet.
    // Mục đích: tránh serialize trạng thái trung gian gây lỗi "sheet not found".
    var ignoreStructOpsRef = (0,react.useRef)(false);
    // Lưu snapshot sheets gần nhất (đầy đủ celldata) để không mất dữ liệu các sheet khác khi đổi sheet
    var sheetsSnapshotRef = (0,react.useRef)(null);
    // Đồng bộ Controller với các thay đổi cấu trúc của Fortune Sheet
    // - Bật cờ ignoreStructOpsRef khi thao tác cấu trúc đang diễn ra để onChange không chạy
    // - Sau khi thao tác hoàn tất, đồng bộ toàn bộ danh sách sheets vào Controller rồi tắt cờ
    var handleOp = function(ops) {
        if (!setValue) return;
        var shouldSync = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ops[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var op = _step.value;
                if ((op === null || op === void 0 ? void 0 : op.op) === "addSheet" || (op === null || op === void 0 ? void 0 : op.op) === "deleteSheet" || (op === null || op === void 0 ? void 0 : op.op) === "undo" || (op === null || op === void 0 ? void 0 : op.op) === "redo" || (op === null || op === void 0 ? void 0 : op.op) === "moveSheet" || (op === null || op === void 0 ? void 0 : op.op) === "copySheet") {
                    shouldSync = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (shouldSync) {
            // Avoid onChange processing while structural ops are applying
            ignoreStructOpsRef.current = true;
            // Defer to let Fortune Sheet finish applying the operation
            setTimeout(function() {
                if (refSheet === null || refSheet === void 0 ? void 0 : refSheet.current) {
                    var ref;
                    var workbook = refSheet.current;
                    var sheetsNow = ((ref = workbook.getAllSheets) === null || ref === void 0 ? void 0 : ref.call(workbook)) || [];
                    // Base: ưu tiên snapshot hiện tại nếu có, để giữ celldata của các sheet cũ
                    var base = Array.isArray(sheetsSnapshotRef.current) ? sheetsSnapshotRef.current : [];
                    if (!Array.isArray(base) || base.length === 0) {
                        var ref1;
                        // Fallback: nếu chưa có snapshot, tạo từ getAllSheets (celldata có thể rỗng với sheet không active)
                        base = sheetsNow.map(function(s) {
                            return {
                                id: s === null || s === void 0 ? void 0 : s.id,
                                name: s === null || s === void 0 ? void 0 : s.name,
                                status: s === null || s === void 0 ? void 0 : s.status,
                                row: s === null || s === void 0 ? void 0 : s.row,
                                column: s === null || s === void 0 ? void 0 : s.column,
                                celldata: Array.isArray(s === null || s === void 0 ? void 0 : s.celldata) ? s.celldata : [],
                                data: (ref1 = s === null || s === void 0 ? void 0 : s.data) !== null && ref1 !== void 0 ? ref1 : []
                            };
                        });
                    }
                    // Merge theo id: giữ dữ liệu cũ nếu sheet còn tồn tại; thêm sheet mới nếu có
                    var byId = new Map();
                    base.forEach(function(s) {
                        if (s === null || s === void 0 ? void 0 : s.id) byId.set(s.id, s);
                    });
                    sheetsNow.forEach(function(s) {
                        if (s === null || s === void 0 ? void 0 : s.id) {
                            if (!byId.has(s.id)) {
                                var ref;
                                byId.set(s.id, {
                                    id: s === null || s === void 0 ? void 0 : s.id,
                                    name: s === null || s === void 0 ? void 0 : s.name,
                                    status: s === null || s === void 0 ? void 0 : s.status,
                                    row: s === null || s === void 0 ? void 0 : s.row,
                                    column: s === null || s === void 0 ? void 0 : s.column,
                                    celldata: Array.isArray(s === null || s === void 0 ? void 0 : s.celldata) ? s.celldata : [],
                                    data: (ref = s === null || s === void 0 ? void 0 : s.data) !== null && ref !== void 0 ? ref : []
                                });
                            } else {
                                // Cập nhật meta (name/status/row/column) theo cấu trúc mới, giữ celldata/data cũ
                                var prev = byId.get(s.id);
                                byId.set(s.id, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                    name: s === null || s === void 0 ? void 0 : s.name,
                                    status: s === null || s === void 0 ? void 0 : s.status,
                                    row: s === null || s === void 0 ? void 0 : s.row,
                                    column: s === null || s === void 0 ? void 0 : s.column
                                }));
                            }
                        }
                    });
                    // Loại bỏ sheet đã bị xóa (có trong base nhưng không còn trong sheetsNow)
                    var nowIds = new Set(sheetsNow.map(function(s) {
                        return s === null || s === void 0 ? void 0 : s.id;
                    }).filter(Boolean));
                    Array.from(byId.keys()).forEach(function(id) {
                        if (!nowIds.has(id)) byId.delete(id);
                    });
                    var merged = sheetsNow.map(function(s) {
                        return byId.get(s === null || s === void 0 ? void 0 : s.id);
                    }).filter(Boolean);
                    sheetsSnapshotRef.current = merged;
                    setValue(name, JSON.stringify(merged));
                }
                // Re-enable onChange handling
                ignoreStructOpsRef.current = false;
            }, 0);
        }
    };
    var fileData = {
        name: (fullData === null || fullData === void 0 ? void 0 : (ref = fullData.data) === null || ref === void 0 ? void 0 : (ref1 = ref.requirements) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[index !== null && index !== void 0 ? index : 0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.answer_file) === null || ref3 === void 0 ? void 0 : ref3.file_name) || (fullData === null || fullData === void 0 ? void 0 : (ref4 = fullData.answer_file) === null || ref4 === void 0 ? void 0 : ref4.file_name) || (fullData === null || fullData === void 0 ? void 0 : (ref5 = fullData.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.answer_file) === null || ref6 === void 0 ? void 0 : ref6.file_name),
        key: (fullData === null || fullData === void 0 ? void 0 : (ref7 = fullData.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.requirements) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[index !== null && index !== void 0 ? index : 0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.answer_file) === null || ref10 === void 0 ? void 0 : ref10.file_key) || (fullData === null || fullData === void 0 ? void 0 : (ref11 = fullData.answer_file) === null || ref11 === void 0 ? void 0 : ref11.file_key) || (fullData === null || fullData === void 0 ? void 0 : (ref12 = fullData.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.answer_file) === null || ref13 === void 0 ? void 0 : ref13.file_key)
    };
    if (externalRef) {
        externalRef.current = {
            reset: function(templateValue) {
                var // editorRef.current?.moveSelectionOutOfTable()
                ref;
                (ref = editorRef.current) === null || ref === void 0 ? void 0 : ref.resetContentSafe(templateValue !== undefined ? templateValue : defaultValue || attempt/* DEFAULT_EDITOR_VALUE */.kO);
            },
            resetSheet: function() {
                setKey(function(prev) {
                    var newKey = (0,lodash.uniqueId)("key");
                    return newKey;
                });
            },
            clear: function(templateValue) {
                if (refSheet.current) {
                    try {
                        // Nếu có templateValue, update sheet với giá trị đó
                        var currentSheets = refSheet.current.getAllSheets();
                        var _status, _row, _column;
                        // function tạo sheet trống an toàn
                        var makeEmptySheet = function(base) {
                            return {
                                id: base.id,
                                name: base.name,
                                status: (_status = base.status) !== null && _status !== void 0 ? _status : 1,
                                row: (_row = base.row) !== null && _row !== void 0 ? _row : 100,
                                column: (_column = base.column) !== null && _column !== void 0 ? _column : 50,
                                celldata: [],
                                data: Array(base.row || 100).fill(null).map(function() {
                                    return Array(base.column || 50).fill(null);
                                })
                            };
                        };
                        if (templateValue === null || templateValue === void 0 ? void 0 : templateValue.trim()) {
                            var sheetData = JSON.parse(templateValue) || [
                                {
                                    name: "Sheet1",
                                    id: (0,attempt/* generateSheetId */.eq)(),
                                    status: 1,
                                    data: [
                                        []
                                    ],
                                    celldata: []
                                }, 
                            ];
                            var updatedSheetData = sheetData.map(function(sheet, index) {
                                var base = currentSheets[index] || {};
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, makeEmptySheet(base), (0,lodash.cloneDeep)(sheet)), {
                                    id: (base === null || base === void 0 ? void 0 : base.id) || sheet.id || ""
                                });
                            });
                            // update tất cả một lần
                            refSheet.current.updateSheet(updatedSheetData.map(lodash.cloneDeep));
                        }
                    } catch (error) {
                        dist/* default.error */.ZP.error("Error reset sheet data:");
                    }
                }
            }
        };
    }
    (0,react.useEffect)(function() {
        var ref;
        if (refSheet && refSheet.current && Number(index) <= (question_data === null || question_data === void 0 ? void 0 : (ref = question_data.requirements) === null || ref === void 0 ? void 0 : ref.length)) {
            if (defaultValue === undefined || defaultValue === null || String(defaultValue).trim() === "") {
                var ref1;
                var emptySheets = (ref1 = refSheet.current) === null || ref1 === void 0 ? void 0 : ref1.getAllSheets().map(function(sheet) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sheet), {
                        celldata: [],
                        data: Array(sheet.row || 100).fill(null).map(function() {
                            return Array(sheet.column || 50).fill(null);
                        })
                    });
                });
                emptySheets.forEach(function(sheet) {
                    var ref;
                    (ref = refSheet.current) === null || ref === void 0 ? void 0 : ref.updateSheet(JSON.parse(JSON.stringify([
                        sheet
                    ])));
                });
            } else {
                var sheetData = defaultValue && String(defaultValue).trim() !== "" ? JSON.parse(defaultValue) : [
                    {
                        name: "Sheet1",
                        id: (0,attempt/* generateSheetId */.eq)(),
                        status: 1,
                        data: [
                            []
                        ],
                        celldata: []
                    }, 
                ];
                // Convert sheetData to constructor with id of refSheet.current
                var currentSheets = refSheet.current.getAllSheets();
                var updatedSheetData = sheetData.map(function(sheet, index) {
                    var ref;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sheet), {
                        id: ((ref = currentSheets[index]) === null || ref === void 0 ? void 0 : ref.id) || ""
                    });
                });
                var emptySheets1 = currentSheets.map(function(sheet) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sheet), {
                        celldata: [],
                        data: Array(sheet.row || 100).fill(null).map(function() {
                            return Array(sheet.column || 50).fill(null);
                        })
                    });
                });
                emptySheets1.forEach(function(sheet, index) {
                    var ref;
                    if ((sheet === null || sheet === void 0 ? void 0 : sheet.name) === ((ref = sheetData[index]) === null || ref === void 0 ? void 0 : ref.name)) {
                        var ref1;
                        (ref1 = refSheet.current) === null || ref1 === void 0 ? void 0 : ref1.updateSheet(JSON.parse(JSON.stringify([
                            updatedSheetData[index]
                        ])));
                    } else {
                        var ref2;
                        (ref2 = refSheet.current) === null || ref2 === void 0 ? void 0 : ref2.updateSheet(JSON.parse(JSON.stringify([
                            sheet
                        ])));
                    }
                });
            }
        }
    }, [
        defaultValue,
        index
    ]);
    var handleDownload = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setUnsavedChanges && setUnsavedChanges(false);
                        dispatch((0,Login/* disableUnsavedChange */.a1)());
                        return [
                            4,
                            upload/* UploadAPI.downloadFile */.h.downloadFile(data)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setUnsavedChanges && setUnsavedChanges(true);
                        dispatch(Login/* loginSlice.actions.enableUnsavedChange */.zb.actions.enableUnsavedChange());
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDownload(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var stableDataId = (0,react.useMemo)(function() {
        // Chỉ return khi data hợp lệ
        if (data && data.id && typeof data.id === "string" && isInTest) {
            return data.id;
        }
        return null;
    }, [
        data === null || data === void 0 ? void 0 : data.id
    ]);
    var renderSheetEditor = (0,react.useCallback)(function(param) {
        var onChange = param.onChange;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(textfield_HookFormExcel, {
            question_data: question_data,
            defaultValue: defaultValue,
            index: index,
            onChange: function(val) {
                onChange(val);
                handleChange && handleChange(data === null || data === void 0 ? void 0 : data.id);
            },
            fullData: fullData,
            ignoreStructOpsRef: ignoreStructOpsRef,
            refSheet: refSheet,
            sheetsSnapshotRef: sheetsSnapshotRef,
            onOp: handleOp
        });
    }, [
        key,
        stableDataId
    ]);
    var renderWordEditor = (0,react.useMemo)(function() {
        var ref, ref1;
        (ref = editorRef.current) === null || ref === void 0 ? void 0 : ref.resetContentSafe(defaultValue);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(editor_HookFormEditorV2, {
            control: control,
            name: name,
            math: true,
            height: 500,
            placeholder: "Your answer here",
            defaultValue: defaultValue,
            disabled: (fullData === null || fullData === void 0 ? void 0 : fullData.confirmed) || (fullData === null || fullData === void 0 ? void 0 : (ref1 = fullData.data) === null || ref1 === void 0 ? void 0 : ref1.confirmed) || (fullData === null || fullData === void 0 ? void 0 : fullData.is_viewed_answer),
            handleChange: function() {
                return handleChange && handleChange(data === null || data === void 0 ? void 0 : data.id);
            },
            // externalRef={externalRef}
            editorRef: editorRef
        });
    }, [
        name
    ]);
    var ref24, ref25, ref26;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            background: "white"
        },
        children: [
            question_content && isShowContent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "hightlight_area",
                onMouseUp: function(e) {
                    var ref, ref1, ref2, ref3;
                    if ((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.tagName) === null || ref1 === void 0 ? void 0 : ref1.charAt(0)) !== "m" && (e === null || e === void 0 ? void 0 : (ref2 = e.target) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.firstChild) === null || ref3 === void 0 ? void 0 : ref3.tagName) !== "math") {
                        if (e) {
                            if (allowHighLight) {
                                (0,utils/* runHighlight */.x4)(handleSaveHighLight, allowHighLight || false, "hightlight_area");
                            } else if (allowUnHighLight) {
                                (0,utils/* runHighlight */.x4)(handleSaveHighLight, allowUnHighLight || false, "hightlight_area", {
                                    color: "white"
                                });
                            }
                        }
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorReader/* default */.Z, {
                    className: "sapp-questions",
                    text_editor_content: question_content,
                    highlighted: highlighted
                })
            }),
            data && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "hightlight_area_require",
                        onMouseUp: function(e) {
                            var ref;
                            if (e.target.tagName.charAt(0) !== "m" && ((ref = e.target.firstChild) === null || ref === void 0 ? void 0 : ref.tagName) !== "math") {
                                if (e) {
                                    if (allowHighLight) {
                                        (0,utils/* runHighlight */.x4)(handleSaveHighLightRequirement, allowHighLight || false, "hightlight_area_require");
                                    } else if (allowUnHighLight) {
                                        (0,utils/* runHighlight */.x4)(handleSaveHighLightRequirement, allowUnHighLight || false, "hightlight_area_require", {
                                            color: "white"
                                        });
                                    }
                                }
                            }
                        },
                        children: [
                            (data === null || data === void 0 ? void 0 : data.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sapp-questions-essay",
                                children: index !== undefined ? "Requirement ".concat(index + 1, ": ").concat(data === null || data === void 0 ? void 0 : data.name) : "Requirement: ".concat(data === null || data === void 0 ? void 0 : data.name)
                            }),
                            (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorReader/* default */.Z, {
                                className: "editor-wrap mb-4",
                                text_editor_content: data === null || data === void 0 ? void 0 : data.description,
                                highlighted: question_data === null || question_data === void 0 ? void 0 : (ref14 = question_data.requirements) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[index || 0]) === null || ref15 === void 0 ? void 0 : ref15.highlighted,
                                highlighArea: "hightlight_area_require"
                            }),
                            (data === null || data === void 0 ? void 0 : (ref16 = data.files) === null || ref16 === void 0 ? void 0 : ref16.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-4",
                                children: data === null || data === void 0 ? void 0 : (ref17 = data.files) === null || ref17 === void 0 ? void 0 : ref17.map(function(e, index) {
                                    var ref;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mb-1 w-fit cursor-pointer text-state-info hover:underline",
                                        onClick: function() {
                                            var ref, ref1;
                                            setOpenPdf && setOpenPdf("file", e === null || e === void 0 ? void 0 : (ref = e.resource) === null || ref === void 0 ? void 0 : ref.url, e === null || e === void 0 ? void 0 : (ref1 = e.resource) === null || ref1 === void 0 ? void 0 : ref1.name);
                                        },
                                        children: e === null || e === void 0 ? void 0 : (ref = e.resource) === null || ref === void 0 ? void 0 : ref.name
                                    }, index);
                                })
                            })
                        ]
                    }),
                    question_data.display_type === constants/* DISPLAY_TYPE.VERTICAL */.Qs.VERTICAL && !forCaseStudy && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sapp-seprate-line-preview"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    question_data.assignment_type !== "TEXT" ? !(0,lodash.isNull)(fileData.key) && !(0,lodash.isUndefined)(fileData.key) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "sapp-upload-file-preview",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-base font-semibold",
                                        children: fullData.done ? "Your Answer File:" : "Upload file to submit"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cursor-pointer text-state-info hover:underline",
                                        onClick: function() {
                                            return handleDownload({
                                                files: [
                                                    {
                                                        name: fileData === null || fileData === void 0 ? void 0 : fileData.name,
                                                        file_key: fileData === null || fileData === void 0 ? void 0 : fileData.key
                                                    }, 
                                                ]
                                            });
                                        },
                                        children: fileData.name
                                    }),
                                    !(fullData === null || fullData === void 0 ? void 0 : fullData.confirmed) && !fullData.data.confirmed && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return handleClearFile(index);
                                        },
                                        className: "cursor-pointer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {})
                                    })
                                ]
                            }),
                            question_data.display_type === constants/* DISPLAY_TYPE.VERTICAL */.Qs.VERTICAL && !forCaseStudy && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sapp-seprate-line-preview"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx/* default */.Z)("sapp-upload-file-preview", data ? "" : "w-fit flex-col !items-start justify-start !pt-0 font-semibold"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,clsx/* default */.Z)(data ? "" : "text-left", "text-base font-semibold"),
                                        children: "Upload file to submit:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "sapp-upload-button-preview",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* UploadIcon */.rG, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "title-btn-preview",
                                                onClick: function() {
                                                    var ref;
                                                    return !((fullData === null || fullData === void 0 ? void 0 : fullData.confirmed) || (fullData === null || fullData === void 0 ? void 0 : (ref = fullData.data) === null || ref === void 0 ? void 0 : ref.confirmed) || (fullData === null || fullData === void 0 ? void 0 : fullData.is_viewed_answer)) && openChooseFile(true);
                                                },
                                                children: "Choose file to upload"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (question_data === null || question_data === void 0 ? void 0 : question_data.display_type) === constants/* DISPLAY_TYPE.VERTICAL */.Qs.VERTICAL && !forCaseStudy && data && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sapp-seprate-line-preview"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: (question_data === null || question_data === void 0 ? void 0 : question_data.display_type) === constants/* DISPLAY_TYPE.VERTICAL */.Qs.VERTICAL || forCaseStudy ? {
                            width: "100%"
                        } : {
                            width: "100%",
                            marginTop: "10px"
                        },
                        className: "".concat(showRequiment ? "pointer-events-none" : ""),
                        children: [
                            (question_data === null || question_data === void 0 ? void 0 : question_data.response_option) === constants/* RESPONSE_OPTION.WORD */.Cj.WORD ? renderWordEditor : question_data.response_option === constants/* RESPONSE_OPTION.SHEET */.Cj.SHEET ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((fullData === null || fullData === void 0 ? void 0 : fullData.is_viewed_answer) || (fullData === null || fullData === void 0 ? void 0 : fullData.confirmed) || (fullData === null || fullData === void 0 ? void 0 : (ref18 = fullData.data) === null || ref18 === void 0 ? void 0 : ref18.confirmed) ? "pointer-events-none opacity-100" : "", " h-[500px] w-full border"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                    name: name,
                                    control: control,
                                    defaultValue: defaultValue,
                                    render: function(param) {
                                        var _field = param.field, onChange = _field.onChange, value = _field.value;
                                        // const isValid = (value?: string) => {
                                        //   try {
                                        //     if (
                                        //       !value ||
                                        //       isEmpty(value) ||
                                        //       isUndefined(value) ||
                                        //       isNull(value)
                                        //     )
                                        //       return false
                                        //     JSON.parse(value)
                                        //     return true
                                        //   } catch {
                                        //     return false
                                        //   }
                                        // }
                                        return renderSheetEditor({
                                            onChange: onChange
                                        });
                                    }
                                }, key)
                            }) : response_option_custom === 0 ? renderWordEditor : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((fullData === null || fullData === void 0 ? void 0 : fullData.is_viewed_answer) || (fullData === null || fullData === void 0 ? void 0 : fullData.confirmed) || (fullData === null || fullData === void 0 ? void 0 : (ref19 = fullData.data) === null || ref19 === void 0 ? void 0 : ref19.confirmed) ? "pointer-events-none opacity-100" : "", " h-[500px] w-full border"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                    name: name,
                                    control: control,
                                    defaultValue: defaultValue,
                                    render: function(param) {
                                        var _field = param.field, onChange = _field.onChange, value = _field.value;
                                        return renderSheetEditor({
                                            onChange: onChange
                                        });
                                    }
                                }, key)
                            }),
                            ((fullData === null || fullData === void 0 ? void 0 : fullData.confirmed) || (fullData === null || fullData === void 0 ? void 0 : fullData.done) || (fullData === null || fullData === void 0 ? void 0 : (ref20 = fullData.data) === null || ref20 === void 0 ? void 0 : ref20.confirmed)) && ((fullData === null || fullData === void 0 ? void 0 : fullData.solution) || (data === null || data === void 0 ? void 0 : (ref21 = data.explanation) === null || ref21 === void 0 ? void 0 : ref21.trim())) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-11 mt-8 bg-gray-4 p-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-semibold",
                                        children: "Solution"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorReader/* default */.Z, {
                                        text_editor_content: (ref26 = (ref25 = (ref24 = data === null || data === void 0 ? void 0 : data.explanation) !== null && ref24 !== void 0 ? ref24 : fullData === null || fullData === void 0 ? void 0 : fullData.solution) !== null && ref25 !== void 0 ? ref25 : fullData === null || fullData === void 0 ? void 0 : (ref22 = fullData.data) === null || ref22 === void 0 ? void 0 : ref22.solution) !== null && ref26 !== void 0 ? ref26 : "",
                                        className: "mt-4"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ConstructedQuestion = (/*#__PURE__*/(0,react.memo)(EssayQuestionPreview));


/***/ }),

/***/ 20709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95215);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45332);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10103);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82684);
/* harmony import */ var src_common_SappTitleSolution__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15964);
/* harmony import */ var src_constants_lang__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66190);







var dragParentIdRef;
var DragNDropPreivew = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.forwardRef)(function(param, ref) {
    var data = param.data, action = param.action, handleSaveHighLight = param.handleSaveHighLight, highlighted = param.highlighted, removeHighlight = param.removeHighlight, allowHighLight = param.allowHighLight, defaultAnswer = param.defaultAnswer, extenalRef = param.extenalRef, corrects = param.corrects, solution = param.solution, _resetDefaultAnswer = param.resetDefaultAnswer, resetDefaultAnswer = _resetDefaultAnswer === void 0 ? false : _resetDefaultAnswer, allowUnHighLight = param.allowUnHighLight, uuid = param.uuid, setOpenFile = param.setOpenFile, _isHideExhibit = param.isHideExhibit, isHideExhibit = _isHideExhibit === void 0 ? true : _isHideExhibit, exhibitText = param.exhibitText, handleGetData = param.handleGetData;
    var allowDrop = function allowDrop(ev) {
        ev.preventDefault();
        // Lấy tọa độ của sự kiện kéo
        var x = ev.clientX // Tọa độ ngang
        ;
        var y = ev.clientY // Tọa độ dọc
        ;
        // Giới hạn tọa độ tối đa
        var maxX = 535;
        var maxY = 160;
        // Kiểm tra tọa độ có trong giới hạn
        if (x <= maxX && y <= maxY) {} else {
            ev.stopPropagation() // Ngăn sự kiện nếu không chấp thuận
            ;
        }
    };
    var drag = function drag(ev) {
        var _$ref, _$ref1, _$ref2;
        ev === null || ev === void 0 ? void 0 : (_$ref = ev.dataTransfer) === null || _$ref === void 0 ? void 0 : _$ref.setData("text", ev === null || ev === void 0 ? void 0 : (_$ref1 = ev.target) === null || _$ref1 === void 0 ? void 0 : _$ref1.id);
        ev === null || ev === void 0 ? void 0 : (_$ref2 = ev.dataTransfer) === null || _$ref2 === void 0 ? void 0 : _$ref2.setData("questionId", data === null || data === void 0 ? void 0 : data.id);
        if (uuid) {
            var _$ref3, _$ref4;
            dragParentIdRef = (_$ref4 = ev === null || ev === void 0 ? void 0 : (_$ref3 = ev.target) === null || _$ref3 === void 0 ? void 0 : _$ref3.closest("#".concat(uuid))) === null || _$ref4 === void 0 ? void 0 : _$ref4.id;
        }
    };
    var drop = function drop(ev, dropId, dropItem) {
        var _$ref;
        ev.preventDefault();
        setIsDopEnd(crypto.randomUUID());
        var slotElement = ev === null || ev === void 0 ? void 0 : ev.target;
        if (uuid && (!dragParentIdRef || dragParentIdRef !== uuid)) {
            return;
        }
        dragParentIdRef = "";
        var questionId = ev === null || ev === void 0 ? void 0 : (_$ref = ev.dataTransfer) === null || _$ref === void 0 ? void 0 : _$ref.getData("questionId");
        var storage;
        if (uuid) {
            var _$ref1;
            storage = (_$ref1 = slotElement === null || slotElement === void 0 ? void 0 : slotElement.closest("#".concat(uuid))) === null || _$ref1 === void 0 ? void 0 : _$ref1.querySelector(".".concat(storageId));
        } else {
            storage = document === null || document === void 0 ? void 0 : document.querySelector(".".concat(storageId));
        }
        if (questionId === dropId) {
            var _$ref2, _$ref3, _$ref4;
            var data = ev.dataTransfer.getData("text");
            var draggingItem;
            if (uuid) {
                var _$ref5;
                draggingItem = (_$ref5 = slotElement === null || slotElement === void 0 ? void 0 : slotElement.closest("#".concat(uuid))) === null || _$ref5 === void 0 ? void 0 : _$ref5.querySelector('[id="'.concat(data, '"]'));
            } else {
                draggingItem = document === null || document === void 0 ? void 0 : document.getElementById(data);
            }
            if ((slotElement === null || slotElement === void 0 ? void 0 : (_$ref2 = slotElement.children) === null || _$ref2 === void 0 ? void 0 : _$ref2.length) === 0 && (ev === null || ev === void 0 ? void 0 : (_$ref3 = ev.target) === null || _$ref3 === void 0 ? void 0 : (_$ref4 = _$ref3.classList) === null || _$ref4 === void 0 ? void 0 : _$ref4.contains("dropable")) && !dropItem) {
                var _$ref6;
                ev === null || ev === void 0 ? void 0 : (_$ref6 = ev.target) === null || _$ref6 === void 0 ? void 0 : _$ref6.appendChild(draggingItem);
            } else if (dropItem) {
                var _$ref7;
                var parent = ev === null || ev === void 0 ? void 0 : (_$ref7 = ev.target) === null || _$ref7 === void 0 ? void 0 : _$ref7.parentNode;
                storage === null || storage === void 0 ? void 0 : storage.appendChild(ev === null || ev === void 0 ? void 0 : ev.target);
                parent.appendChild(draggingItem);
                return;
            }
        } else return;
    };
    var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5, _$ref6, _$ref7, _$ref8, _$ref9, _$ref10, _$ref11, _$ref12;
    var storageId = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.uniqueId)("storage");
    var _$ref13 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]), answered = _$ref13[0], setAnswered = _$ref13[1];
    var _$ref14 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), isDropEnd = _$ref14[0], setIsDopEnd = _$ref14[1];
    var isSelfReflection = data === null || data === void 0 ? void 0 : data.is_self_reflection;
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var answerOfStudent = action ? action() : defaultAnswer;
        var filledAnswered = answerOfStudent && (answerOfStudent === null || answerOfStudent === void 0 ? void 0 : answerOfStudent.length) ? answerOfStudent : defaultAnswer;
        setAnswered(filledAnswered);
    }, [
        defaultAnswer
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (isDropEnd) {
            handleGetData === null || handleGetData === void 0 ? void 0 : handleGetData(action());
        } else {}
    }, [
        isDropEnd
    ]);
    var handleStorage = function(event1, id) {
        var _$ref, _$ref1;
        // prevent the default behavior of the drop event
        event1.preventDefault();
        // get the id of the dragged piece from the dataTransfer object
        var pieceId = event1 === null || event1 === void 0 ? void 0 : (_$ref = event1.dataTransfer) === null || _$ref === void 0 ? void 0 : _$ref.getData("text");
        var questId = event1 === null || event1 === void 0 ? void 0 : (_$ref1 = event1.dataTransfer) === null || _$ref1 === void 0 ? void 0 : _$ref1.getData("questionId");
        // get the storage element from the DOM
        var storage;
        if (uuid) {
            var _$ref2, _$ref3;
            storage = (_$ref3 = event1 === null || event1 === void 0 ? void 0 : (_$ref2 = event1.target) === null || _$ref2 === void 0 ? void 0 : _$ref2.closest("#".concat(uuid))) === null || _$ref3 === void 0 ? void 0 : _$ref3.querySelector(".".concat(storageId));
        } else {
            storage = document === null || document === void 0 ? void 0 : document.querySelector(".".concat(storageId));
        }
        // append the piece element to the storage element
        if ((event1 === null || event1 === void 0 ? void 0 : event1.target) === storage && questId === id) {
            if (uuid) {
                var _$ref4, _$ref5;
                storage === null || storage === void 0 ? void 0 : storage.appendChild((_$ref5 = event1 === null || event1 === void 0 ? void 0 : (_$ref4 = event1.target) === null || _$ref4 === void 0 ? void 0 : _$ref4.closest("#".concat(uuid))) === null || _$ref5 === void 0 ? void 0 : _$ref5.querySelector('[id="'.concat(pieceId, '"]')));
            } else {
                storage === null || storage === void 0 ? void 0 : storage.appendChild(document === null || document === void 0 ? void 0 : document.getElementById(pieceId));
            }
        } else return;
    };
    var str = data === null || data === void 0 ? void 0 : data.question_content;
    var parser = new DOMParser();
    var _$ref15 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(), questionContent = _$ref15[0], setQuestionContent = _$ref15[1];
    var _$ref16 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(), answerContent = _$ref16[0], setAnswerContent = _$ref16[1];
    var _$ref17 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(1), key = _$ref17[0], setKey = _$ref17[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useImperativeHandle)(ref, function() {
        return {
            handleReset: function handleReset() {
                setKey(function(prev) {
                    var newKey = prev + 1;
                    return newKey;
                });
            }
        };
    });
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var doc = parser === null || parser === void 0 ? void 0 : parser.parseFromString(str, "text/html");
        var doc2 = parser === null || parser === void 0 ? void 0 : parser.parseFromString(str, "text/html");
        // if (refContent?.current) {
        var elements = doc === null || doc === void 0 ? void 0 : doc.querySelectorAll(".question-content-tag");
        var elementsCorrects = doc2 === null || doc2 === void 0 ? void 0 : doc2.querySelectorAll(".question-content-tag");
        if (corrects) {
            elementsCorrects.forEach(function(element, index) {
                element.outerHTML = '<span id="'.concat(element === null || element === void 0 ? void 0 : element.id, '" class="sapp-input-dragNDrop-answer corrects ">\n        <span id="').concat(corrects[index].id, '" class="flex justify-center w-full">').concat(corrects[index].answer, "</span>\n        </span>");
            });
            elements.forEach(function(element, index) {
                if ((defaultAnswer === null || defaultAnswer === void 0 ? void 0 : defaultAnswer.length) > 0) {
                    var _$ref;
                    if ((defaultAnswer === null || defaultAnswer === void 0 ? void 0 : (_$ref = defaultAnswer[index]) === null || _$ref === void 0 ? void 0 : _$ref.value) !== "") {
                        var _$ref1, _$ref2, _$ref3, _$ref4;
                        element.outerHTML = '<span  id="'.concat(element === null || element === void 0 ? void 0 : element.id, '" class="sapp-input-dragNDrop-answer  ').concat((defaultAnswer === null || defaultAnswer === void 0 ? void 0 : (_$ref1 = defaultAnswer[index]) === null || _$ref1 === void 0 ? void 0 : _$ref1.idAnswer) === (corrects === null || corrects === void 0 ? void 0 : (_$ref2 = corrects[index]) === null || _$ref2 === void 0 ? void 0 : _$ref2.id) || isSelfReflection === true ? "corrects" : "wrongs", '">\n            <span id="').concat(defaultAnswer === null || defaultAnswer === void 0 ? void 0 : (_$ref3 = defaultAnswer[index]) === null || _$ref3 === void 0 ? void 0 : _$ref3.idAnswer, '" class="flex justify-center w-full min-w-[100px]">').concat(defaultAnswer === null || defaultAnswer === void 0 ? void 0 : (_$ref4 = defaultAnswer[index]) === null || _$ref4 === void 0 ? void 0 : _$ref4.value, "</span>\n            </span>");
                    } else {
                        element.outerHTML = '<span id="'.concat(element === null || element === void 0 ? void 0 : element.id, '" class= "sapp-input-dragNDrop-answer min-w-[100px] ').concat(isSelfReflection === true ? "corrects" : "wrongs", '">\n              <span class="sapp-input-dragNDrop-empty"></span>\n            </span>');
                    //   })
                    }
                } else {
                    element.outerHTML = '<span id="'.concat(element === null || element === void 0 ? void 0 : element.id, '" class= "sapp-input-dragNDrop-answer ').concat(isSelfReflection === true ? "corrects" : "wrongs", '">\n            <span class="sapp-input-dragNDrop-empty"></span>\n          </span>');
                }
            });
            setAnswerContent(doc2);
            setQuestionContent(doc);
        } else {
            elements.forEach(function(element, index) {
                if ((defaultAnswer === null || defaultAnswer === void 0 ? void 0 : defaultAnswer.length) > 0) {
                    var _$ref;
                    if ((defaultAnswer === null || defaultAnswer === void 0 ? void 0 : (_$ref = defaultAnswer[index]) === null || _$ref === void 0 ? void 0 : _$ref.value) !== "") {
                        var _$ref1, _$ref2;
                        element.outerHTML = '<span id="'.concat(element === null || element === void 0 ? void 0 : element.id, '" class="sapp-input-dragNDrop" indexBox="').concat(index + 1, '">\n                <span class="answer-box" id="').concat(defaultAnswer === null || defaultAnswer === void 0 ? void 0 : (_$ref1 = defaultAnswer[index]) === null || _$ref1 === void 0 ? void 0 : _$ref1.idAnswer, '">').concat(defaultAnswer === null || defaultAnswer === void 0 ? void 0 : (_$ref2 = defaultAnswer[index]) === null || _$ref2 === void 0 ? void 0 : _$ref2.value, "</span>\n               </span>\n              ");
                    } else {
                        element.outerHTML = '<span id="'.concat(element === null || element === void 0 ? void 0 : element.id, '" class="sapp-input-dragNDrop" indexBox="').concat(index + 1, '"> </span>');
                    }
                } else {
                    element.outerHTML = '<span id="'.concat(element === null || element === void 0 ? void 0 : element.id, '" class="sapp-input-dragNDrop" indexBox="').concat(index + 1, '"> </span>');
                }
            });
            setQuestionContent(doc);
        }
    // }
    }, [
        defaultAnswer,
        corrects,
        str
    ]);
    var options = {
        replace: function replace(domNode) {
            var _$ref, _$ref1;
            if ((domNode === null || domNode === void 0 ? void 0 : domNode.attribs) && (domNode === null || domNode === void 0 ? void 0 : (_$ref = domNode.attribs) === null || _$ref === void 0 ? void 0 : _$ref.class) === "sapp-input-dragNDrop") {
                if (domNode.children.length > 1) {
                    var _$ref2, _$ref3, _$ref4, _$ref5, _$ref6, _$ref7, _$ref8;
                    var children = domNode === null || domNode === void 0 ? void 0 : (_$ref2 = domNode.children) === null || _$ref2 === void 0 ? void 0 : _$ref2[1];
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        id: domNode === null || domNode === void 0 ? void 0 : (_$ref3 = domNode.attribs) === null || _$ref3 === void 0 ? void 0 : _$ref3.id,
                        className: "sapp-input-dragNDrop dropable",
                        onDrop: function() {
                            return drop(event, data === null || data === void 0 ? void 0 : data.id);
                        },
                        onDragOver: allowDrop,
                        indexBox: domNode === null || domNode === void 0 ? void 0 : (_$ref4 = domNode.attribs) === null || _$ref4 === void 0 ? void 0 : _$ref4.indexbox,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            id: children === null || children === void 0 ? void 0 : (_$ref5 = children.attribs) === null || _$ref5 === void 0 ? void 0 : _$ref5.id,
                            className: children === null || children === void 0 ? void 0 : (_$ref6 = children.attribs) === null || _$ref6 === void 0 ? void 0 : _$ref6.class,
                            onDrop: function() {
                                return drop(event, data === null || data === void 0 ? void 0 : data.id, true);
                            },
                            onDragOver: allowDrop,
                            draggable: "true",
                            onDragStart: drag,
                            children: children === null || children === void 0 ? void 0 : (_$ref7 = children.children) === null || _$ref7 === void 0 ? void 0 : (_$ref8 = _$ref7[0]) === null || _$ref8 === void 0 ? void 0 : _$ref8.data
                        })
                    });
                } else {
                    var _$ref9, _$ref10;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        id: domNode === null || domNode === void 0 ? void 0 : (_$ref9 = domNode.attribs) === null || _$ref9 === void 0 ? void 0 : _$ref9.id,
                        className: "sapp-input-dragNDrop dropable",
                        onDrop: function() {
                            return drop(event, data === null || data === void 0 ? void 0 : data.id);
                        },
                        onDragOver: allowDrop,
                        indexBox: domNode === null || domNode === void 0 ? void 0 : (_$ref10 = domNode.attribs) === null || _$ref10 === void 0 ? void 0 : _$ref10.indexbox,
                        style: {
                            height: "60px"
                        }
                    });
                }
            }
            if ((domNode === null || domNode === void 0 ? void 0 : domNode.attribs) && (domNode === null || domNode === void 0 ? void 0 : (_$ref1 = domNode.attribs) === null || _$ref1 === void 0 ? void 0 : _$ref1.class) === "answer-box") {
                var _$ref11, _$ref12, _$ref13;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    id: domNode === null || domNode === void 0 ? void 0 : (_$ref11 = domNode.attribs) === null || _$ref11 === void 0 ? void 0 : _$ref11.id,
                    className: domNode === null || domNode === void 0 ? void 0 : (_$ref12 = domNode.attribs) === null || _$ref12 === void 0 ? void 0 : _$ref12.class,
                    onDrop: function() {
                        return drop(event, data === null || data === void 0 ? void 0 : data.id);
                    },
                    onDragOver: allowDrop,
                    draggable: "true",
                    indexBox: domNode === null || domNode === void 0 ? void 0 : (_$ref13 = domNode.attribs) === null || _$ref13 === void 0 ? void 0 : _$ref13.indexbox,
                    children: domNode === null || domNode === void 0 ? void 0 : domNode.data
                });
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "body-modal-white -mt-2",
        ref: extenalRef || null,
        id: "".concat(uuid),
        children: [
            questionContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        id: "hightlight_area",
                        onMouseUp: function(e) {
                            var _$ref, _$ref1, _$ref2, _$ref3;
                            if ((e === null || e === void 0 ? void 0 : (_$ref = e.target) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.tagName) === null || _$ref1 === void 0 ? void 0 : _$ref1.charAt(0)) !== "m" && (e === null || e === void 0 ? void 0 : (_$ref2 = e.target) === null || _$ref2 === void 0 ? void 0 : (_$ref3 = _$ref2.firstChild) === null || _$ref3 === void 0 ? void 0 : _$ref3.tagName) !== "math") {
                                if (e) {
                                    if (allowHighLight) {
                                        (0,_utils_index__WEBPACK_IMPORTED_MODULE_2__/* .runHighlight */ .x4)(handleSaveHighLight, allowHighLight || false, "hightlight_area");
                                    } else if (allowUnHighLight) {
                                        (0,_utils_index__WEBPACK_IMPORTED_MODULE_2__/* .runHighlight */ .x4)(handleSaveHighLight, allowUnHighLight || false, "hightlight_area", {
                                            color: "white"
                                        });
                                    }
                                }
                            }
                        },
                        children: [
                            (data === null || data === void 0 ? void 0 : (_$ref = data.question_topic) === null || _$ref === void 0 ? void 0 : _$ref.exhibits) && !isHideExhibit && (data === null || data === void 0 ? void 0 : (_$ref1 = data.question_topic) === null || _$ref1 === void 0 ? void 0 : (_$ref2 = _$ref1.exhibits) === null || _$ref2 === void 0 ? void 0 : _$ref2.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    (data === null || data === void 0 ? void 0 : (_$ref3 = data.question_topic) === null || _$ref3 === void 0 ? void 0 : _$ref3.description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "my-6 border border-b-gray-2"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "mb-4 flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "font-semibold",
                                                children: [
                                                    exhibitText ? exhibitText + "s" : "Exhibits",
                                                    " (",
                                                    (data === null || data === void 0 ? void 0 : (_$ref4 = data.question_topic) === null || _$ref4 === void 0 ? void 0 : (_$ref5 = _$ref4.exhibits) === null || _$ref5 === void 0 ? void 0 : _$ref5.length) || 0,
                                                    ")"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "ml-4",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "text-state-error",
                                                        children: "* "
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "text-gray-1",
                                                        children: "Click to view"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex flex-col gap-2",
                                        children: data === null || data === void 0 ? void 0 : (_$ref6 = data.question_topic) === null || _$ref6 === void 0 ? void 0 : (_$ref7 = _$ref6.exhibits) === null || _$ref7 === void 0 ? void 0 : _$ref7.map(function(e, i) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "cursor-pointer hover:text-primary",
                                                onClick: function(event1) {
                                                    setOpenFile && setOpenFile({
                                                        type: "exhibits",
                                                        description: e === null || e === void 0 ? void 0 : e.description,
                                                        name: e === null || e === void 0 ? void 0 : e.name,
                                                        index: i,
                                                        files: e === null || e === void 0 ? void 0 : e.files
                                                    }, null, null, event1);
                                                },
                                                children: [
                                                    exhibitText || "Exhibit",
                                                    " ",
                                                    i + 1,
                                                    ": ",
                                                    e === null || e === void 0 ? void 0 : e.name
                                                ]
                                            }, e.id);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "my-6 border border-b-gray-2"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                className: "questions",
                                text_editor_content: ((_$ref9 = questionContent === null || questionContent === void 0 ? void 0 : (_$ref8 = questionContent.documentElement) === null || _$ref8 === void 0 ? void 0 : _$ref8.querySelector("body")) === null || _$ref9 === void 0 ? void 0 : _$ref9.innerHTML) || "",
                                options: options,
                                highlighted: highlighted
                            })
                        ]
                    }),
                    !corrects && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "answer-area",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "sapp-store flex min-h-large w-full flex-wrap gap-5 border p-5 ".concat(storageId),
                            onDrop: function(ev) {
                                return handleStorage(ev, data === null || data === void 0 ? void 0 : data.id);
                            },
                            onDragOver: allowDrop,
                            id: "storage",
                            children: data === null || data === void 0 ? void 0 : (_$ref10 = data.answers) === null || _$ref10 === void 0 ? void 0 : _$ref10.map(function(e) {
                                if (answered) {
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = answered[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var as = _step.value;
                                            if ((as === null || as === void 0 ? void 0 : as.idAnswer) === (e === null || e === void 0 ? void 0 : e.id)) {
                                                return null;
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                }
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "answer-box",
                                    id: e === null || e === void 0 ? void 0 : e.id,
                                    draggable: "true",
                                    onDragStart: drag,
                                    onDrop: function() {
                                        return drop(event, data === null || data === void 0 ? void 0 : data.id, true);
                                    },
                                    children: e === null || e === void 0 ? void 0 : e.answer
                                }, e === null || e === void 0 ? void 0 : e.id);
                            })
                        })
                    })
                ]
            }),
            answerContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pt-[31px] text-base font-semibold",
                        children: "Correct Answer"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        className: "questions mt-2",
                        text_editor_content: ((_$ref12 = answerContent === null || answerContent === void 0 ? void 0 : (_$ref11 = answerContent.documentElement) === null || _$ref11 === void 0 ? void 0 : _$ref11.querySelector("body")) === null || _$ref12 === void 0 ? void 0 : _$ref12.innerHTML) || ""
                    })
                ]
            }),
            solution && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-6 bg-gray-4 p-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_common_SappTitleSolution__WEBPACK_IMPORTED_MODULE_5__/* .SappTitleSolution */ .b, {
                        title: src_constants_lang__WEBPACK_IMPORTED_MODULE_6__/* .MY_COURSES.explanations */ .EQ.explanations
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        className: "mt-4",
                        text_editor_content: solution
                    })
                ]
            })
        ]
    }, key);
});
DragNDropPreivew.displayName = "DragNDropPreivew";
/* harmony default export */ __webpack_exports__["Z"] = (DragNDropPreivew);


/***/ }),

/***/ 23396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95215);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45332);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10103);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82684);
/* harmony import */ var src_common_SappTitleSolution__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15964);
/* harmony import */ var src_constants_lang__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66190);







var AddWordPreview = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.forwardRef)(function(param, ref) {
    var data = param.data, action = param.action, handleSaveHighLight = param.handleSaveHighLight, highlighted = param.highlighted, removeHighlight = param.removeHighlight, allowHighLight = param.allowHighLight, defaultAnswer = param.defaultAnswer, corrects = param.corrects, extenalRef = param.extenalRef, solution = param.solution, allowUnHighLight = param.allowUnHighLight, setOpenFile = param.setOpenFile, _isHideExhibit = param.isHideExhibit, isHideExhibit = _isHideExhibit === void 0 ? true : _isHideExhibit, _exhibitText = param.exhibitText, exhibitText = _exhibitText === void 0 ? "Exhibit" : _exhibitText;
    var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5, _$ref6, _$ref7, _$ref8, _$ref9, _$ref10, _$ref11;
    var refEditor = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    var _$ref12 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(), questionContent = _$ref12[0], setQuestionContent = _$ref12[1];
    var _$ref13 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(), answerContent = _$ref13[0], setAnswerContent = _$ref13[1];
    var str = data === null || data === void 0 ? void 0 : data.question_content;
    var parser = new DOMParser();
    var isSelfReflection = data === null || data === void 0 ? void 0 : data.is_self_reflection;
    var _$ref14 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)((0,lodash__WEBPACK_IMPORTED_MODULE_3__.uniqueId)("key")), key = _$ref14[0], setKey = _$ref14[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useImperativeHandle)(ref, function() {
        return {
            handleReset: function handleReset() {
                // setAnswered([])
                setKey(function(prev) {
                    var newKey = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.uniqueId)("key");
                    return newKey;
                });
            // setAnswered()
            },
            handleGetResult: function handleGetResult() {
            // action()
            }
        };
    });
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var doc = parser === null || parser === void 0 ? void 0 : parser.parseFromString(str, "text/html");
        var elements = doc === null || doc === void 0 ? void 0 : doc.querySelectorAll(".question-content-tag");
        var doc2 = parser === null || parser === void 0 ? void 0 : parser.parseFromString(str, "text/html");
        var elementCorrects = doc2 === null || doc2 === void 0 ? void 0 : doc2.querySelectorAll(".question-content-tag");
        elements.forEach(function(element, index) {
            var inputId = element === null || element === void 0 ? void 0 : element.id;
            var inputValue = (defaultAnswer === null || defaultAnswer === void 0 ? void 0 : defaultAnswer[index]) || "";
            var inputClass;
            if (corrects) {
                var correctAnswer = corrects === null || corrects === void 0 ? void 0 : corrects.find(function(ans) {
                    var _$ref, _$ref1, _$ref2;
                    return (ans === null || ans === void 0 ? void 0 : ans.answer_position) === index + 1 && ((_$ref1 = ans === null || ans === void 0 ? void 0 : (_$ref = ans.answer) === null || _$ref === void 0 ? void 0 : _$ref.trim()) === null || _$ref1 === void 0 ? void 0 : _$ref1.toLowerCase()) === ((_$ref2 = inputValue === null || inputValue === void 0 ? void 0 : inputValue.trim()) === null || _$ref2 === void 0 ? void 0 : _$ref2.toLowerCase());
                });
                inputClass = correctAnswer || isSelfReflection === true ? "!border-success text-state-success text-center !font-normal" : "!border-danger text-danger text center !font-normal";
            }
            element.outerHTML = "\n        <span>\n          <input ".concat(corrects ? "disabled" : "", ' type="text" id="').concat(inputId, '" class="sapp-input-preview ').concat(inputClass, '" stringHTML="true" value="').concat(inputValue, '" />\n        </span>\n      ');
        });
        if (corrects) {
            elementCorrects === null || elementCorrects === void 0 ? void 0 : elementCorrects.forEach(function(element, index) {
                var inputId = element === null || element === void 0 ? void 0 : element.id;
                var inputValue = (defaultAnswer === null || defaultAnswer === void 0 ? void 0 : defaultAnswer[index]) || "";
                var inputClass;
                // if (corrects) {
                var correctAnswer = corrects === null || corrects === void 0 ? void 0 : corrects.filter(function(ans) {
                    return (ans === null || ans === void 0 ? void 0 : ans.answer_position) === index + 1;
                });
                if (correctAnswer) {
                    inputClass = "text-base font-semibold text-state-success";
                    // }
                    element.outerHTML = '\n                <span>\n                <span id="'.concat(inputId, '" class = "').concat(inputClass, '">').concat(correctAnswer === null || correctAnswer === void 0 ? void 0 : correctAnswer.map(function(e, i) {
                        if (i < correctAnswer.length - 1) {
                            return (e === null || e === void 0 ? void 0 : e.answer) + " / ";
                        } else return e === null || e === void 0 ? void 0 : e.answer;
                    }).join(""), " <span/>\n                </span>\n                ");
                }
            });
            setAnswerContent(doc2);
        }
        setQuestionContent(doc);
    }, [
        defaultAnswer
    ]);
    // const checkError = () => {
    //   const data = getValueFillText()
    //   const answerMap = Object.fromEntries(
    //     activeQuestion?.answers?.map((item) => [
    //       `${item.answer_position}:${item.answer?.trim()}`,
    //       item.is_correct,
    //     ]) || [],
    //   )
    //   const elements = data?.map(
    //     (element) => answerMap[`${1}:${element?.trim()}`] || false,
    //   )
    //   const corrects = questionRef?.current?.querySelectorAll(
    //     '.sapp-input-preview',
    //   )
    //   if (corrects) {
    //     corrects.forEach((element, index) => {
    //       const isCorrect = elements?.[index]
    //       if (element instanceof HTMLElement) {
    //         element.classList.add(isCorrect ? 'border-success' : 'border-error')
    //       }
    //       element.classList.add('pointer-events-none')
    //     })
    //   }
    // }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        ref: extenalRef,
        children: [
            (data === null || data === void 0 ? void 0 : (_$ref = data.question_topic) === null || _$ref === void 0 ? void 0 : _$ref.exhibits) && !isHideExhibit && (data === null || data === void 0 ? void 0 : (_$ref1 = data.question_topic) === null || _$ref1 === void 0 ? void 0 : (_$ref2 = _$ref1.exhibits) === null || _$ref2 === void 0 ? void 0 : _$ref2.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    !!(data === null || data === void 0 ? void 0 : (_$ref3 = data.question_topic) === null || _$ref3 === void 0 ? void 0 : _$ref3.description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "my-6 border border-b-gray-2"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-4 flex items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "font-semibold",
                                children: [
                                    exhibitText,
                                    "s (",
                                    (data === null || data === void 0 ? void 0 : (_$ref4 = data.question_topic) === null || _$ref4 === void 0 ? void 0 : (_$ref5 = _$ref4.exhibits) === null || _$ref5 === void 0 ? void 0 : _$ref5.length) || 0,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "ml-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-state-error",
                                        children: "* "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-gray-1",
                                        children: "Click to view"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col gap-2",
                        children: data === null || data === void 0 ? void 0 : (_$ref6 = data.question_topic) === null || _$ref6 === void 0 ? void 0 : (_$ref7 = _$ref6.exhibits) === null || _$ref7 === void 0 ? void 0 : _$ref7.map(function(e, i) {
                            var _$ref;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "cursor-pointer hover:text-primary",
                                onClick: function(event) {
                                    setOpenFile && setOpenFile({
                                        type: "exhibits",
                                        description: e === null || e === void 0 ? void 0 : e.description,
                                        name: e === null || e === void 0 ? void 0 : e.name,
                                        index: i,
                                        files: e === null || e === void 0 ? void 0 : e.files
                                    }, null, null, event);
                                },
                                children: [
                                    exhibitText,
                                    " ",
                                    i + 1,
                                    ": ",
                                    e === null || e === void 0 ? void 0 : e.name
                                ]
                            }, (_$ref = e === null || e === void 0 ? void 0 : e.id) !== null && _$ref !== void 0 ? _$ref : i);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "my-6 border border-b-gray-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                id: "hightlight_area",
                onMouseUp: function(e) {
                    var _$ref, _$ref1, _$ref2, _$ref3;
                    if ((e === null || e === void 0 ? void 0 : (_$ref = e.target) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.tagName) === null || _$ref1 === void 0 ? void 0 : _$ref1.charAt(0)) !== "m" && (e === null || e === void 0 ? void 0 : (_$ref2 = e.target) === null || _$ref2 === void 0 ? void 0 : (_$ref3 = _$ref2.firstChild) === null || _$ref3 === void 0 ? void 0 : _$ref3.tagName) !== "math") {
                        if (e) {
                            if (allowHighLight) {
                                (0,_utils_index__WEBPACK_IMPORTED_MODULE_2__/* .runHighlight */ .x4)(handleSaveHighLight, allowHighLight || false, "hightlight_area");
                            } else if (allowUnHighLight) {
                                (0,_utils_index__WEBPACK_IMPORTED_MODULE_2__/* .runHighlight */ .x4)(handleSaveHighLight, allowUnHighLight || false, "hightlight_area", {
                                    color: "white"
                                });
                            }
                        }
                    }
                },
                extenalRef: refEditor,
                className: "sapp-questions",
                text_editor_content: ((_$ref9 = questionContent === null || questionContent === void 0 ? void 0 : (_$ref8 = questionContent.documentElement) === null || _$ref8 === void 0 ? void 0 : _$ref8.querySelector("body")) === null || _$ref9 === void 0 ? void 0 : _$ref9.innerHTML) || "",
                highlighted: highlighted
            }, key),
            answerContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pt-[22px] text-base font-semibold",
                        children: "Correct Answer"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        className: "questions mt-2",
                        text_editor_content: ((_$ref11 = answerContent === null || answerContent === void 0 ? void 0 : (_$ref10 = answerContent.documentElement) === null || _$ref10 === void 0 ? void 0 : _$ref10.querySelector("body")) === null || _$ref11 === void 0 ? void 0 : _$ref11.innerHTML) || ""
                    })
                ]
            }),
            solution && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-6 bg-gray-4 p-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_common_SappTitleSolution__WEBPACK_IMPORTED_MODULE_5__/* .SappTitleSolution */ .b, {
                        title: src_constants_lang__WEBPACK_IMPORTED_MODULE_6__/* .MY_COURSES.explanations */ .EQ.explanations
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        className: "mt-4",
                        text_editor_content: solution
                    })
                ]
            })
        ]
    });
});
AddWordPreview.displayName = "AddWordPreview";
/* harmony default export */ __webpack_exports__["Z"] = (AddWordPreview);


/***/ }),

/***/ 54580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95215);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45332);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10103);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82684);
/* harmony import */ var src_common_SappTitleSolution__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15964);
/* harmony import */ var src_constants_lang__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66190);







var dragParentIdRef;
var MatchingQuestion = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.forwardRef)(function(param, ref) {
    var data = param.data, action = param.action, handleSaveHighLight = param.handleSaveHighLight, highlighted = param.highlighted, removeHighlight = param.removeHighlight, allowHighLight = param.allowHighLight, defaultAnswer = param.defaultAnswer, done = param.done, extenalRef = param.extenalRef, corrects = param.corrects, solution = param.solution, allowUnHighLight = param.allowUnHighLight, uuid = param.uuid, setOpenFile = param.setOpenFile, _isHideExhibit = param.isHideExhibit, isHideExhibit = _isHideExhibit === void 0 ? true : _isHideExhibit, _isAlwaysShowAnswer = param.isAlwaysShowAnswer, isAlwaysShowAnswer = _isAlwaysShowAnswer === void 0 ? false : _isAlwaysShowAnswer, _exhibitText = param.exhibitText, exhibitText = _exhibitText === void 0 ? "Exhibit" : _exhibitText;
    var allowDrop = function allowDrop(ev) {
        var _$ref;
        ev === null || ev === void 0 ? void 0 : ev.preventDefault();
        var slotElement = ev === null || ev === void 0 ? void 0 : ev.target;
        slotElement === null || slotElement === void 0 ? void 0 : (_$ref = slotElement.classList) === null || _$ref === void 0 ? void 0 : _$ref.add("dragging");
        var matchingQuestion = matchingQuestionRef === null || matchingQuestionRef === void 0 ? void 0 : matchingQuestionRef.current;
        if (!matchingQuestion) return;
        var rect = matchingQuestion === null || matchingQuestion === void 0 ? void 0 : matchingQuestion.getBoundingClientRect();
        // Lấy chiều dài của phần tử matchingQuestion
        var matchingQuestionHeight = matchingQuestion === null || matchingQuestion === void 0 ? void 0 : matchingQuestion.clientHeight;
        // Lấy tọa độ y của con trỏ chuột tính từ đỉnh của phần tử matchingQuestion
        var mouseY = (ev === null || ev === void 0 ? void 0 : ev.clientY) - (rect === null || rect === void 0 ? void 0 : rect.top);
        // Thiết lập ngưỡng cho việc cuộn
        var threshold = 200;
        // Kiểm tra nếu con trỏ chuột nằm ở phía trên ngưỡng
        if (mouseY < threshold) {
            matchingQuestion === null || matchingQuestion === void 0 ? void 0 : matchingQuestion.scrollBy(0, -10);
        }
        // Kiểm tra nếu con trỏ chuột nằm ở phía dưới ngưỡng
        if (mouseY > matchingQuestionHeight - threshold) {
            matchingQuestion === null || matchingQuestion === void 0 ? void 0 : matchingQuestion.scrollBy(0, 10);
        }
    };
    var allowDropStorage = function allowDropStorage(ev) {
        var _$ref, _$ref1;
        if (ev === null || ev === void 0 ? void 0 : (_$ref = ev.target) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.classList) === null || _$ref1 === void 0 ? void 0 : _$ref1.contains("dropable")) {
            ev === null || ev === void 0 ? void 0 : ev.preventDefault();
        } else {
            return;
        }
    };
    var drag = function drag(ev) {
        var _$ref, _$ref1;
        ev === null || ev === void 0 ? void 0 : (_$ref = ev.dataTransfer) === null || _$ref === void 0 ? void 0 : _$ref.setData("text", ev.target.id);
        ev === null || ev === void 0 ? void 0 : (_$ref1 = ev.dataTransfer) === null || _$ref1 === void 0 ? void 0 : _$ref1.setData("questionId", data.id);
        if (uuid) {
            var _$ref2, _$ref3;
            dragParentIdRef = (_$ref3 = ev === null || ev === void 0 ? void 0 : (_$ref2 = ev.target) === null || _$ref2 === void 0 ? void 0 : _$ref2.closest("#".concat(uuid))) === null || _$ref3 === void 0 ? void 0 : _$ref3.id;
        }
    };
    var drop = function drop(ev, dropId, dropItem) {
        var _$ref, _$ref1;
        ev.preventDefault();
        var slotElement = ev === null || ev === void 0 ? void 0 : ev.target;
        slotElement === null || slotElement === void 0 ? void 0 : (_$ref = slotElement.classList) === null || _$ref === void 0 ? void 0 : _$ref.remove("dragging");
        if (uuid && (!dragParentIdRef || dragParentIdRef !== uuid)) {
            return;
        }
        dragParentIdRef = "";
        var questionId = ev === null || ev === void 0 ? void 0 : ev.dataTransfer.getData("questionId");
        var data = ev === null || ev === void 0 ? void 0 : (_$ref1 = ev.dataTransfer) === null || _$ref1 === void 0 ? void 0 : _$ref1.getData("text");
        var draggingItem;
        if (uuid) {
            var _$ref2;
            draggingItem = (_$ref2 = slotElement.closest("#".concat(uuid))) === null || _$ref2 === void 0 ? void 0 : _$ref2.querySelector('[id="'.concat(data, '"]'));
        } else {
            draggingItem = document === null || document === void 0 ? void 0 : document.getElementById(data);
        }
        var oldParent = draggingItem === null || draggingItem === void 0 ? void 0 : draggingItem.parentNode;
        if (questionId === dropId) {
            var _$ref3, _$ref4, _$ref5;
            if ((slotElement === null || slotElement === void 0 ? void 0 : (_$ref3 = slotElement.children) === null || _$ref3 === void 0 ? void 0 : _$ref3.length) === 0 && (ev === null || ev === void 0 ? void 0 : (_$ref4 = ev.target) === null || _$ref4 === void 0 ? void 0 : (_$ref5 = _$ref4.classList) === null || _$ref5 === void 0 ? void 0 : _$ref5.contains("dropable")) && !dropItem) {
                var _$ref6;
                ev === null || ev === void 0 ? void 0 : (_$ref6 = ev.target) === null || _$ref6 === void 0 ? void 0 : _$ref6.appendChild(draggingItem);
            } else if (dropItem) {
                var _$ref7;
                var parent = ev === null || ev === void 0 ? void 0 : (_$ref7 = ev.target) === null || _$ref7 === void 0 ? void 0 : _$ref7.parentNode;
                oldParent === null || oldParent === void 0 ? void 0 : oldParent.appendChild(ev === null || ev === void 0 ? void 0 : ev.target);
                parent.appendChild(draggingItem);
                return;
            }
        } else return;
    };
    var shuffleArray = // useEffect(() => {
    //   if (data) {
    //     DeserializeHighlight(highlighted)
    //   }
    // }, [data])
    function shuffleArray(array) {
        var currentIndex = array === null || array === void 0 ? void 0 : array.length, randomIndex;
        // While there remain elements to shuffle
        while(currentIndex > 0){
            // Pick a remaining element
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;
            var _$ref;
            _$ref = [
                array[randomIndex],
                array[currentIndex], 
            ], array[currentIndex] = _$ref[0], array[randomIndex] = _$ref[1], _$ref;
        }
        return array;
    };
    var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5, _$ref6, _$ref7, _$ref8, _$ref9;
    var _$ref10 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(), defaultValue = _$ref10[0], setDefaultValue = _$ref10[1];
    var _$ref11 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(), answers = _$ref11[0], setAnswers = _$ref11[1];
    var _$ref12 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(), correctAnswer = _$ref12[0], setCorrectAnswer = _$ref12[1];
    var _$ref13 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)((0,lodash__WEBPACK_IMPORTED_MODULE_3__.uniqueId)("storage")), storageId = _$ref13[0], setStoreId = _$ref13[1];
    var matchingQuestionRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    var isSelfReflection = data === null || data === void 0 ? void 0 : data.is_self_reflection;
    var handleStorage = function(event1, id) {
        // prevent the default behavior of the drop event
        event1.preventDefault();
        // get the id of the dragged piece from the dataTransfer object
        var pieceId = event1 === null || event1 === void 0 ? void 0 : event1.dataTransfer.getData("text");
        var questId = event1 === null || event1 === void 0 ? void 0 : event1.dataTransfer.getData("questionId");
        // get the storage element from the DOM
        var storage;
        if (uuid) {
            var _$ref, _$ref1;
            storage = (_$ref1 = event1 === null || event1 === void 0 ? void 0 : (_$ref = event1.target) === null || _$ref === void 0 ? void 0 : _$ref.closest("#".concat(uuid))) === null || _$ref1 === void 0 ? void 0 : _$ref1.querySelector(".".concat(storageId));
        } else {
            storage = document.querySelector(".".concat(storageId));
        }
        // append the piece element to the storage element
        if (event1.target === storage && questId === id) {
            if (uuid) {
                var _$ref2;
                storage === null || storage === void 0 ? void 0 : storage.appendChild((_$ref2 = event1 === null || event1 === void 0 ? void 0 : event1.target.closest("#".concat(uuid))) === null || _$ref2 === void 0 ? void 0 : _$ref2.querySelector('[id="'.concat(pieceId, '"]')));
            } else {
                storage === null || storage === void 0 ? void 0 : storage.appendChild(document.getElementById(pieceId));
            }
        } else return;
    };
    var _$ref14 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("1"), key = _$ref14[0], setKey = _$ref14[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useImperativeHandle)(ref, function() {
        return {
            handleReset: function handleReset() {
                // setAnswered([])
                setKey(function(prev) {
                    var newKey = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.uniqueId)("key");
                    return newKey;
                });
            // setAnswered()
            },
            handleGetResult: function handleGetResult() {
            // action()
            }
        };
    });
    var QuestionCard = function(param) {
        var value = param.value, _className = param.className, className = _className === void 0 ? "sapp-arrowed-container" : _className;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat(className),
            children: value
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var obj = {};
        var objCorrect = {};
        var arr = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var quest = _step.value;
                arr.push(quest === null || quest === void 0 ? void 0 : quest.answer);
                if (defaultAnswer) {
                    obj[quest === null || quest === void 0 ? void 0 : quest.id] = data === null || data === void 0 ? void 0 : data.question_matchings.find(function(el) {
                        var _$ref, _$ref1;
                        return (el === null || el === void 0 ? void 0 : (_$ref = el.answer) === null || _$ref === void 0 ? void 0 : _$ref.id) === ((_$ref1 = defaultAnswer.find(function(e) {
                            return (e === null || e === void 0 ? void 0 : e.question_id) === (quest === null || quest === void 0 ? void 0 : quest.id);
                        })) === null || _$ref1 === void 0 ? void 0 : _$ref1.answer_id);
                    });
                }
            };
            for(var _iterator = (data === null || data === void 0 ? void 0 : data.question_matchings)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        shuffleArray(arr);
        if (corrects) {
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = corrects[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var correct = _step1.value;
                    if (defaultAnswer || isAlwaysShowAnswer) {
                        objCorrect[correct === null || correct === void 0 ? void 0 : correct.id] = correct === null || correct === void 0 ? void 0 : correct.answer;
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            setCorrectAnswer(objCorrect);
        }
        if (defaultAnswer) {
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                var _loop1 = function() {
                    var e = _step2.value;
                    arr = arr === null || arr === void 0 ? void 0 : arr.filter(function(el) {
                        return (el === null || el === void 0 ? void 0 : el.id) !== (e === null || e === void 0 ? void 0 : e.answer_id);
                    });
                };
                for(var _iterator2 = defaultAnswer[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true)_loop1();
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
        setAnswers(arr);
        setDefaultValue(obj);
    }, [
        defaultAnswer,
        data === null || data === void 0 ? void 0 : data.question_matchings
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        ref: extenalRef,
        id: "".concat(uuid),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                id: "hightlight_area",
                onMouseUp: function(e) {
                    var _$ref, _$ref1, _$ref2, _$ref3;
                    if ((e === null || e === void 0 ? void 0 : (_$ref = e.target) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.tagName) === null || _$ref1 === void 0 ? void 0 : _$ref1.charAt(0)) !== "m" && (e === null || e === void 0 ? void 0 : (_$ref2 = e.target) === null || _$ref2 === void 0 ? void 0 : (_$ref3 = _$ref2.firstChild) === null || _$ref3 === void 0 ? void 0 : _$ref3.tagName) !== "math") {
                        // if(e){
                        if (allowHighLight) {
                            (0,_utils_index__WEBPACK_IMPORTED_MODULE_2__/* .runHighlight */ .x4)(handleSaveHighLight, allowHighLight || false, "hightlight_area");
                        } else if (allowUnHighLight) {
                            (0,_utils_index__WEBPACK_IMPORTED_MODULE_2__/* .runHighlight */ .x4)(handleSaveHighLight, allowUnHighLight || false, "hightlight_area", {
                                color: "white"
                            });
                        }
                    // }
                    }
                },
                children: [
                    (data === null || data === void 0 ? void 0 : (_$ref = data.question_topic) === null || _$ref === void 0 ? void 0 : _$ref.exhibits) && !isHideExhibit && (data === null || data === void 0 ? void 0 : (_$ref1 = data.question_topic) === null || _$ref1 === void 0 ? void 0 : (_$ref2 = _$ref1.exhibits) === null || _$ref2 === void 0 ? void 0 : _$ref2.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            !!(data === null || data === void 0 ? void 0 : (_$ref3 = data.question_topic) === null || _$ref3 === void 0 ? void 0 : _$ref3.description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "my-6 border border-b-gray-2"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mb-4 flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "font-semibold",
                                        children: [
                                            exhibitText ? exhibitText + "s" : "Exhibits",
                                            " (",
                                            (data === null || data === void 0 ? void 0 : (_$ref4 = data.question_topic) === null || _$ref4 === void 0 ? void 0 : (_$ref5 = _$ref4.exhibits) === null || _$ref5 === void 0 ? void 0 : _$ref5.length) || 0,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "ml-4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-state-error",
                                                children: "* "
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-gray-1",
                                                children: "Click to view"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-col gap-2",
                                children: data === null || data === void 0 ? void 0 : (_$ref6 = data.question_topic) === null || _$ref6 === void 0 ? void 0 : (_$ref7 = _$ref6.exhibits) === null || _$ref7 === void 0 ? void 0 : _$ref7.map(function(e, i) {
                                    var _$ref;
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "cursor-pointer hover:text-primary",
                                        onClick: function(event1) {
                                            setOpenFile && setOpenFile({
                                                type: "exhibits",
                                                description: e === null || e === void 0 ? void 0 : e.description,
                                                name: e === null || e === void 0 ? void 0 : e.name,
                                                index: i,
                                                files: e === null || e === void 0 ? void 0 : e.files
                                            }, null, null, event1);
                                        },
                                        children: [
                                            exhibitText,
                                            " ",
                                            i + 1,
                                            ": ",
                                            e === null || e === void 0 ? void 0 : e.name
                                        ]
                                    }, (_$ref = e === null || e === void 0 ? void 0 : e.id) !== null && _$ref !== void 0 ? _$ref : i);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "my-6 border border-b-gray-2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        className: "sapp-questions !mb-[32px]",
                        text_editor_content: data === null || data === void 0 ? void 0 : data.question_content,
                        highlighted: highlighted
                    })
                ]
            }),
            !corrects ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col gap-y-5 px-19",
                ref: matchingQuestionRef,
                children: [
                    data === null || data === void 0 ? void 0 : (_$ref8 = data.question_matchings) === null || _$ref8 === void 0 ? void 0 : _$ref8.map(function(e) {
                        var _$ref, _$ref1, _$ref2, _$ref3, _$ref4;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-nowrap gap-x-20 ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QuestionCard, {
                                    value: e === null || e === void 0 ? void 0 : e.content
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    id: e === null || e === void 0 ? void 0 : e.id,
                                    className: "sapp-match-result dropable flex-1",
                                    onDrop: function() {
                                        return drop(event, data === null || data === void 0 ? void 0 : data.id);
                                    },
                                    onDragOver: function() {
                                        return allowDrop(event);
                                    },
                                    children: (defaultValue === null || defaultValue === void 0 ? void 0 : (_$ref = defaultValue[e === null || e === void 0 ? void 0 : e.id]) === null || _$ref === void 0 ? void 0 : _$ref.id) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        // className="w-fit"
                                        className: "sapp-notched-container min-w-132px",
                                        id: (_$ref1 = defaultValue[e === null || e === void 0 ? void 0 : e.id]) === null || _$ref1 === void 0 ? void 0 : (_$ref2 = _$ref1.answer) === null || _$ref2 === void 0 ? void 0 : _$ref2.id,
                                        draggable: "true",
                                        onDragStart: drag,
                                        onDrop: function() {
                                            return drop(event, data === null || data === void 0 ? void 0 : data.id, true);
                                        },
                                        onDragOver: function() {
                                            return allowDrop(event);
                                        },
                                        children: (_$ref3 = defaultValue[e === null || e === void 0 ? void 0 : e.id]) === null || _$ref3 === void 0 ? void 0 : (_$ref4 = _$ref3.answer) === null || _$ref4 === void 0 ? void 0 : _$ref4.answer
                                    })
                                })
                            ]
                        }, e === null || e === void 0 ? void 0 : e.id);
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "sapp-store dropable flex min-h-large flex-wrap gap-5 overflow-hidden border p-5 ".concat(storageId),
                        onDrop: function(ev) {
                            return handleStorage(ev, data === null || data === void 0 ? void 0 : data.id);
                        },
                        onDragOver: allowDropStorage,
                        id: "storage",
                        children: answers === null || answers === void 0 ? void 0 : answers.map(function(answer) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "sapp-notched-container min-w-fit",
                                id: answer === null || answer === void 0 ? void 0 : answer.id,
                                draggable: "true",
                                onDragStart: drag,
                                onDrop: function() {
                                    return drop(event, data === null || data === void 0 ? void 0 : data.id, true);
                                },
                                onDragOver: function() {
                                    return allowDrop(event);
                                },
                                children: answer === null || answer === void 0 ? void 0 : answer.answer
                            }, answer === null || answer === void 0 ? void 0 : answer.id);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col gap-y-5 px-[123px]",
                        children: data === null || data === void 0 ? void 0 : data.question_matchings.map(function(e, index) {
                            var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5, _$ref6, _$ref7, _$ref8;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-nowrap justify-between",
                                children: (defaultValue === null || defaultValue === void 0 ? void 0 : (_$ref = defaultValue[e === null || e === void 0 ? void 0 : e.id]) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.answer) === null || _$ref1 === void 0 ? void 0 : _$ref1.id) === (correctAnswer === null || correctAnswer === void 0 ? void 0 : (_$ref2 = correctAnswer[e === null || e === void 0 ? void 0 : e.id]) === null || _$ref2 === void 0 ? void 0 : _$ref2.id) || isSelfReflection === true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QuestionCard, {
                                            value: e === null || e === void 0 ? void 0 : e.content,
                                            className: "sapp-arrowed-container-corrects !border-gray-6 before:!border-gray-6"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            // id={e?.id}
                                            className: "sapp-match-result flex-1",
                                            children: (defaultValue === null || defaultValue === void 0 ? void 0 : (_$ref3 = defaultValue[e === null || e === void 0 ? void 0 : e.id]) === null || _$ref3 === void 0 ? void 0 : _$ref3.id) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                // className="w-fit"
                                                className: "sapp-notched-container-corrects min-w-132px !border-gray-6 before:!border-gray-6",
                                                children: (_$ref4 = defaultValue[e === null || e === void 0 ? void 0 : e.id]) === null || _$ref4 === void 0 ? void 0 : (_$ref5 = _$ref4.answer) === null || _$ref5 === void 0 ? void 0 : _$ref5.answer
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QuestionCard, {
                                            value: e === null || e === void 0 ? void 0 : e.content,
                                            className: "sapp-arrowed-container-incorrects text-state-error"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            // id={e?.id}
                                            className: "sapp-match-result flex-1",
                                            children: (defaultValue === null || defaultValue === void 0 ? void 0 : (_$ref6 = defaultValue[e === null || e === void 0 ? void 0 : e.id]) === null || _$ref6 === void 0 ? void 0 : _$ref6.id) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                // className="w-fit"
                                                className: "sapp-notched-container-incorrects min-w-132px text-state-error",
                                                children: (_$ref7 = defaultValue[e === null || e === void 0 ? void 0 : e.id]) === null || _$ref7 === void 0 ? void 0 : (_$ref8 = _$ref7.answer) === null || _$ref8 === void 0 ? void 0 : _$ref8.answer
                                            })
                                        })
                                    ]
                                })
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col gap-y-5 pt-[42px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: " text-base font-semibold",
                                children: "Correct Answer"
                            }),
                            data === null || data === void 0 ? void 0 : (_$ref9 = data.question_matchings) === null || _$ref9 === void 0 ? void 0 : _$ref9.map(function(e, index) {
                                var _$ref, _$ref1;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-nowrap justify-between px-[123px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QuestionCard, {
                                            value: e === null || e === void 0 ? void 0 : e.content,
                                            className: "sapp-arrowed-container-corrects text-state-success"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "sapp-match-result flex-1",
                                            children: (correctAnswer === null || correctAnswer === void 0 ? void 0 : (_$ref = correctAnswer[e === null || e === void 0 ? void 0 : e.id]) === null || _$ref === void 0 ? void 0 : _$ref.id) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                // className="w-fit"
                                                className: "sapp-notched-container-corrects min-w-132px text-state-success",
                                                children: correctAnswer === null || correctAnswer === void 0 ? void 0 : (_$ref1 = correctAnswer[e === null || e === void 0 ? void 0 : e.id]) === null || _$ref1 === void 0 ? void 0 : _$ref1.answer
                                            })
                                        })
                                    ]
                                }, index);
                            })
                        ]
                    })
                ]
            }),
            solution && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-6 bg-gray-4 p-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_common_SappTitleSolution__WEBPACK_IMPORTED_MODULE_5__/* .SappTitleSolution */ .b, {
                        title: src_constants_lang__WEBPACK_IMPORTED_MODULE_6__/* .MY_COURSES.explanations */ .EQ.explanations
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        className: "mt-4 ",
                        text_editor_content: solution
                    })
                ]
            })
        ]
    }, key);
});
MatchingQuestion.displayName = "MatchingQuestion";
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(MatchingQuestion));


/***/ }),

/***/ 20093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72760);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _components_base_checkbox_HookFormCheckBoxGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57928);
/* harmony import */ var _components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95215);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45332);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82684);
/* harmony import */ var src_constants_lang__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66190);
/* harmony import */ var src_common_SappTitleSolution__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15964);








var MultiChoiceQuestion = function(param) {
    var data = param.data, control = param.control, corrects = param.corrects, name = param.name, setValue = param.setValue, handleSaveHighLight = param.handleSaveHighLight, highlighted = param.highlighted, allowHighLight = param.allowHighLight, solution = param.solution, allowUnHighLight = param.allowUnHighLight, defaultValues = param.defaultValues, setOpenFile = param.setOpenFile, _isHideExhibit = param.isHideExhibit, isHideExhibit = _isHideExhibit === void 0 ? true : _isHideExhibit, getValue = param.getValue, tabs = param.tabs, currentPage = param.currentPage, _exhibitText = param.exhibitText, exhibitText = _exhibitText === void 0 ? "Exhibit" : _exhibitText;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var convertAnswer = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        var answers = [];
        var number = 0;
        if (data === null || data === void 0 ? void 0 : data.answers) {
            var oldData = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(data === null || data === void 0 ? void 0 : data.answers);
            var sorted = oldData === null || oldData === void 0 ? void 0 : oldData.sort(function(a, b) {
                return (a === null || a === void 0 ? void 0 : a.answer_position) - (b === null || b === void 0 ? void 0 : b.answer_position);
            });
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = sorted[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var e = _step.value;
                    number++;
                    answers.push({
                        label: "".concat((0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .getUppercaseByNumber */ .eX)(number), ". ").concat(e === null || e === void 0 ? void 0 : e.answer),
                        value: e === null || e === void 0 ? void 0 : e.id
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        return answers;
    }, [
        data
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var tab_current = tabs === null || tabs === void 0 ? void 0 : tabs.find(function(e) {
            return e.id === currentPage;
        });
        if (tab_current && Array.isArray(getValue(name))) {
            var ref, ref1, ref2;
            var answer_ids = tab_current === null || tab_current === void 0 ? void 0 : (ref = tab_current.data) === null || ref === void 0 ? void 0 : (ref1 = ref.answers) === null || ref1 === void 0 ? void 0 : ref1.map(function(e) {
                return e.id;
            });
            var filteredData = (ref2 = getValue(name)) === null || ref2 === void 0 ? void 0 : ref2.filter(function(e) {
                return answer_ids === null || answer_ids === void 0 ? void 0 : answer_ids.includes(e);
            });
            // Cập nhật lại giá trị sau khi lọc
            setValue(name, filteredData) // Cần hàm `setValue` để thay đổi giá trị getValue(name)
            ;
        }
    }, [
        tabs,
        currentPage,
        getValue,
        name,
        setValue
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                id: "hightlight_area",
                onMouseUp: function(e) {
                    var ref, ref1, ref2, ref3;
                    if ((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.tagName) === null || ref1 === void 0 ? void 0 : ref1.charAt(0)) !== "m" && (e === null || e === void 0 ? void 0 : (ref2 = e.target) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.firstChild) === null || ref3 === void 0 ? void 0 : ref3.tagName) !== "math") {
                        if (e) {
                            if (allowHighLight) {
                                (0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .runHighlight */ .x4)(handleSaveHighLight, allowHighLight || false, "hightlight_area");
                            } else if (allowUnHighLight) {
                                (0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .runHighlight */ .x4)(handleSaveHighLight, allowUnHighLight || false, "hightlight_area", {
                                    color: "white"
                                });
                            }
                        }
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        text_editor_content: data === null || data === void 0 ? void 0 : data.question_content,
                        className: "sapp-questions",
                        highlighted: highlighted
                    }),
                    (data === null || data === void 0 ? void 0 : (ref = data.question_topic) === null || ref === void 0 ? void 0 : ref.exhibits) && !isHideExhibit && (data === null || data === void 0 ? void 0 : (ref1 = data.question_topic) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.exhibits) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "my-6 border border-b-gray-2"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mb-4 flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "font-semibold",
                                        children: [
                                            exhibitText ? exhibitText + "s" : "Exhibits",
                                            " (",
                                            (data === null || data === void 0 ? void 0 : (ref3 = data.question_topic) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.exhibits) === null || ref4 === void 0 ? void 0 : ref4.length) || 0,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "ml-4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-state-error",
                                                children: "* "
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-gray-1",
                                                children: "Click to view"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-col gap-2",
                                children: data === null || data === void 0 ? void 0 : (ref5 = data.question_topic) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.exhibits) === null || ref6 === void 0 ? void 0 : ref6.map(function(e, i) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "cursor-pointer hover:text-primary",
                                        onClick: function(event) {
                                            setOpenFile && setOpenFile({
                                                type: "exhibits",
                                                description: e === null || e === void 0 ? void 0 : e.description,
                                                name: e === null || e === void 0 ? void 0 : e.name,
                                                index: i,
                                                files: e === null || e === void 0 ? void 0 : e.files
                                            }, null, null, event);
                                        },
                                        children: [
                                            exhibitText || "Exhibit",
                                            " ",
                                            i + 1,
                                            ": ",
                                            e.name
                                        ]
                                    }, e.id);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "my-6 border border-b-gray-2"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "sapp-answer-wrapper",
                style: {
                    flexDirection: "column"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_checkbox_HookFormCheckBoxGroup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    options: convertAnswer || [],
                    control: control,
                    name: name || "multiples",
                    multiple: true,
                    corrects: corrects,
                    defaultValue: defaultValues || "",
                    // justify='start'
                    positionCheckBox: "start"
                })
            }),
            solution && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-6 bg-gray-4 p-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_common_SappTitleSolution__WEBPACK_IMPORTED_MODULE_6__/* .SappTitleSolution */ .b, {
                        title: src_constants_lang__WEBPACK_IMPORTED_MODULE_5__/* .MY_COURSES.explanations */ .EQ.explanations
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: "mt-4",
                        text_editor_content: solution
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MultiChoiceQuestion);


/***/ }),

/***/ 94229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72760);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95215);
/* harmony import */ var _components_base_radiobutton_HookFormRadioGroup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52888);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45332);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82684);
/* harmony import */ var src_common_SappTitleSolution__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15964);
/* harmony import */ var src_constants_lang__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66190);








var OneChoiceQuestion = function(param) {
    var data = param.data, control = param.control, corrects = param.corrects, name = param.name, defaultValues = param.defaultValues, setValue = param.setValue, handleSaveHighLight = param.handleSaveHighLight, highlighted = param.highlighted, removeHighlight = param.removeHighlight, allowHighLight = param.allowHighLight, solution = param.solution, allowUnHighLight = param.allowUnHighLight, setOpenFile = param.setOpenFile, _isHideExhibit = param.isHideExhibit, isHideExhibit = _isHideExhibit === void 0 ? true : _isHideExhibit, _exhibitText = param.exhibitText, exhibitText = _exhibitText === void 0 ? "Exhibit" : _exhibitText;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (defaultValues) {
            setValue(name, defaultValues);
        } else {
            setValue(name, "");
        }
    }, [
        defaultValues,
        name
    ]);
    var convertAnswer = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        var answers = [];
        var number = 0;
        if (data === null || data === void 0 ? void 0 : data.answers) {
            var dataAnswers = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(data === null || data === void 0 ? void 0 : data.answers);
            dataAnswers.sort(function(a, b) {
                return (a === null || a === void 0 ? void 0 : a.answer_position) - (b === null || b === void 0 ? void 0 : b.answer_position);
            });
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = dataAnswers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var e = _step.value;
                    number++;
                    answers.push({
                        label: "".concat((0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .getUppercaseByNumber */ .eX)(number), ". ").concat(e === null || e === void 0 ? void 0 : e.answer),
                        value: e === null || e === void 0 ? void 0 : e.id
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        return answers;
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "hightlight_area",
                onMouseUp: function(e) {
                    var ref, ref1, ref2, ref3;
                    if ((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.tagName) === null || ref1 === void 0 ? void 0 : ref1.charAt(0)) !== "m" && (e === null || e === void 0 ? void 0 : (ref2 = e.target) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.firstChild) === null || ref3 === void 0 ? void 0 : ref3.tagName) !== "math") {
                        if (e) {
                            if (allowHighLight) {
                                (0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .runHighlight */ .x4)(handleSaveHighLight, allowHighLight || false, "hightlight_area");
                            } else if (allowUnHighLight) {
                                (0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .runHighlight */ .x4)(handleSaveHighLight, allowUnHighLight || false, "hightlight_area", {
                                    color: "white"
                                });
                            }
                        // runHighlight(handleSaveHighLight, allowHighLight || false, "hightlight_area")
                        }
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    text_editor_content: data === null || data === void 0 ? void 0 : data.question_content,
                    className: "sapp-questions",
                    highlighted: highlighted
                })
            }),
            (data === null || data === void 0 ? void 0 : (ref = data.question_topic) === null || ref === void 0 ? void 0 : ref.exhibits) && !isHideExhibit && (data === null || data === void 0 ? void 0 : (ref1 = data.question_topic) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.exhibits) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    !!(data === null || data === void 0 ? void 0 : (ref3 = data.question_topic) === null || ref3 === void 0 ? void 0 : ref3.description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "my-6 border border-b-gray-2"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-4 flex items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "font-semibold",
                                children: [
                                    exhibitText ? exhibitText + "s" : "Exhibits",
                                    " (",
                                    (data === null || data === void 0 ? void 0 : (ref4 = data.question_topic) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.exhibits) === null || ref5 === void 0 ? void 0 : ref5.length) || 0,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "ml-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-state-error",
                                        children: "* "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-gray-1",
                                        children: "Click to view"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col gap-2",
                        children: data === null || data === void 0 ? void 0 : (ref6 = data.question_topic) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.exhibits) === null || ref7 === void 0 ? void 0 : ref7.map(function(e, i) {
                            var ref;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "cursor-pointer hover:text-primary",
                                onClick: function(event) {
                                    setOpenFile && setOpenFile({
                                        type: "exhibits",
                                        description: e === null || e === void 0 ? void 0 : e.description,
                                        name: e === null || e === void 0 ? void 0 : e.name,
                                        index: i,
                                        files: e === null || e === void 0 ? void 0 : e.files
                                    }, null, null, event);
                                },
                                children: [
                                    exhibitText || "Exhibit",
                                    " ",
                                    i + 1,
                                    ": ",
                                    e === null || e === void 0 ? void 0 : e.name
                                ]
                            }, (ref = e === null || e === void 0 ? void 0 : e.id) !== null && ref !== void 0 ? ref : i);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "my-6 border border-b-gray-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "sapp-answer-wrapper",
                style: {
                    flexDirection: "column"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_radiobutton_HookFormRadioGroup__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    options: convertAnswer || [],
                    control: control,
                    name: name || "answer",
                    corrects: corrects,
                    defaultValue: defaultValues
                })
            }),
            solution && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-6 bg-gray-4 p-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_common_SappTitleSolution__WEBPACK_IMPORTED_MODULE_5__/* .SappTitleSolution */ .b, {
                        title: src_constants_lang__WEBPACK_IMPORTED_MODULE_6__/* .MY_COURSES.explanations */ .EQ.explanations
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        className: "mt-4",
                        text_editor_content: solution
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OneChoiceQuestion);


/***/ }),

/***/ 52178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67796);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72760);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95215);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45332);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10103);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82684);
/* harmony import */ var src_common_SappTitleSolution__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15964);
/* harmony import */ var src_constants_lang__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66190);











// Constants
var baseBox = "border rounded border-gray-15 rounded-lg";
var sizeBox = "w-[200px] min-w-[200px] max-w-[400px]";
var DROPDOWN_STYLES = {
    container: "sapp-select--question relative inline-block ".concat(sizeBox, " ").concat(baseBox, " cursor-pointer"),
    selectedText: "px-3 py-2 flex items-center justify-between",
    options: "absolute !top-[44px] !left-0 -translate-x-px z-[9] ".concat(sizeBox, " bg-white ").concat(baseBox, " shadow-lg max-h-[300px] overflow-y-auto p-2"),
    option: "px-3 py-2 cursor-pointer rounded",
    icon: "ml-2 text-gray-500 min-w-[24px]"
};
var SelectWord = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.forwardRef)(function(param, ref) {
    var data = param.data, handleSaveHighLight = param.handleSaveHighLight, highlighted = param.highlighted, allowHighLight = param.allowHighLight, defaultAnswer = param.defaultAnswer, corrects = param.corrects, extenalRef = param.extenalRef, solution = param.solution, allowUnHighLight = param.allowUnHighLight, setOpenFile = param.setOpenFile, _isHideExhibit = param.isHideExhibit, isHideExhibit = _isHideExhibit === void 0 ? true : _isHideExhibit, exhibitText = param.exhibitText, onChange = param.onChange;
    var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5, _$ref6, _$ref7, _$ref8, _$ref9, _$ref10, _$ref11, _$ref12;
    // Refs and State
    var refEditor = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    var _$ref13 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(), questionContent = _$ref13[0], setQuestionContent = _$ref13[1];
    var _$ref14 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(), answerContent = _$ref14[0], setAnswerContent = _$ref14[1];
    var _$ref15 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)((0,lodash__WEBPACK_IMPORTED_MODULE_3__.uniqueId)("key")), key = _$ref15[0], setKey = _$ref15[1];
    var componentId = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)((0,lodash__WEBPACK_IMPORTED_MODULE_3__.uniqueId)("select-question-"));
    var isSelfReflection = data === null || data === void 0 ? void 0 : data.is_self_reflection;
    var str = (0,_utils_index__WEBPACK_IMPORTED_MODULE_2__/* .replaceWhiteSpacePreWrapToNormal */ .vZ)(data === null || data === void 0 ? void 0 : data.question_content);
    var _$ref16 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({}), selectedValues = _$ref16[0], setSelectedValues = _$ref16[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (onChange) {
            // Lấy ra mảng với format mới: answer_id và answer_position
            var values = Object.keys(selectedValues).sort(function(a, b) {
                return Number(a) - Number(b);
            }).map(function(k) {
                return {
                    answer_id: selectedValues[Number(k)],
                    answer_position: Number(k) + 1
                };
            }).filter(function(item) {
                return item.answer_id;
            }) // Chỉ lấy những item có answer_id
            ;
            onChange(values);
        }
    }, [
        selectedValues
    ]);
    // Đồng bộ selectedValues với defaultAnswer khi defaultAnswer thay đổi
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (defaultAnswer && Array.isArray(defaultAnswer)) {
            var newSelected = {};
            defaultAnswer.forEach(function(item) {
                if (item.answer_id && item.answer_position) {
                    newSelected[item.answer_position - 1] = item.answer_id;
                }
            });
            setSelectedValues(newSelected);
        }
    }, [
        defaultAnswer
    ]);
    // Methods
    var formatAnswer = function(data) {
        var _$ref;
        var objAnswer = {};
        data === null || data === void 0 ? void 0 : (_$ref = data.answers) === null || _$ref === void 0 ? void 0 : _$ref.forEach(function(answer) {
            if (!(objAnswer === null || objAnswer === void 0 ? void 0 : objAnswer[answer === null || answer === void 0 ? void 0 : answer.answer_position])) {
                objAnswer[answer === null || answer === void 0 ? void 0 : answer.answer_position] = [];
            }
            objAnswer[answer === null || answer === void 0 ? void 0 : answer.answer_position].push({
                label: answer === null || answer === void 0 ? void 0 : answer.answer,
                value: answer === null || answer === void 0 ? void 0 : answer.id,
                result: answer === null || answer === void 0 ? void 0 : answer.is_correct
            });
        });
        return objAnswer;
    };
    var answerObj = formatAnswer(data);
    var createDropdownHTML = function(index, defaultAnswerValue) {
        var isCorrect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var _$ref, _$ref1, _$ref2;
        var selectedAnswer = answerObj === null || answerObj === void 0 ? void 0 : (_$ref = answerObj[+index + 1]) === null || _$ref === void 0 ? void 0 : _$ref.find(function(e) {
            return (e === null || e === void 0 ? void 0 : e.value) === defaultAnswerValue;
        });
        var disabledClass = !(corrects === null || corrects === void 0 ? void 0 : corrects.length) ? "" : "cursor-not-allowed pointer-events-none";
        return '\n        <div class="selected-text '.concat(DROPDOWN_STYLES.selectedText, " ").concat(disabledClass, '" data-component-id="').concat(componentId.current, '">\n          <span class="truncate">').concat((selectedAnswer === null || selectedAnswer === void 0 ? void 0 : selectedAnswer.label) || "Choose", '</span>\n            <svg class="').concat(DROPDOWN_STYLES.icon, ' icon-dropdown" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.43057 8.51192C4.70014 8.19743 5.17361 8.161 5.48811 8.43057L12 14.0122L18.5119 8.43057C18.8264 8.16101 19.2999 8.19743 19.5695 8.51192C19.839 8.82642 19.8026 9.29989 19.4881 9.56946L12.4881 15.5695C12.2072 15.8102 11.7928 15.8102 11.5119 15.5695L4.51192 9.56946C4.19743 9.29989 4.161 8.82641 4.43057 8.51192Z" fill="#1C274C"/>\n            </svg>\n        </div>\n        <div class="dropdown-options ').concat(DROPDOWN_STYLES.options, '" style="display: none;" data-component-id="').concat(componentId.current, '">\n          ').concat((answerObj === null || answerObj === void 0 ? void 0 : (_$ref1 = answerObj[+index + 1]) === null || _$ref1 === void 0 ? void 0 : _$ref1.length) ? answerObj === null || answerObj === void 0 ? void 0 : (_$ref2 = answerObj[+index + 1]) === null || _$ref2 === void 0 ? void 0 : _$ref2.map(function(e) {
            var _$ref;
            if ((e === null || e === void 0 ? void 0 : (_$ref = e.label) === null || _$ref === void 0 ? void 0 : _$ref.length) > 100) {
                return '\n                <div class="option '.concat(DROPDOWN_STYLES.option, " ").concat((e === null || e === void 0 ? void 0 : e.value) === defaultAnswerValue ? "bg-[#e5e5e5]" : "", '" \n                     data-value="').concat(e === null || e === void 0 ? void 0 : e.value, '" data-component-id="').concat(componentId.current, '">\n                  ').concat(e.label, "\n                </div>\n              ");
            }
            return '\n              <div class="option '.concat(DROPDOWN_STYLES.option, " ").concat((e === null || e === void 0 ? void 0 : e.value) === defaultAnswerValue ? "bg-[#e5e5e5]" : "", '" \n                   data-value="').concat(e === null || e === void 0 ? void 0 : e.value, '" data-component-id="').concat(componentId.current, '">\n                ').concat(e === null || e === void 0 ? void 0 : e.label, "\n              </div>\n            ");
        }).join("") : '<div class="option '.concat(DROPDOWN_STYLES.option, '" data-component-id="').concat(componentId.current, '">No options available</div>'), "\n        </div>\n      ");
    };
    // Imperative Handle
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useImperativeHandle)(ref, function() {
        return {
            handleReset: function handleReset() {
                var dropdowns = document === null || document === void 0 ? void 0 : document.querySelectorAll('.sapp-select--question[data-component-id="'.concat(componentId.current, '"]'));
                dropdowns.forEach(function(dropdown) {
                    dropdown.setAttribute("data-value", "");
                    var selectedText = dropdown.querySelector('.selected-text[data-component-id="'.concat(componentId.current, '"]'));
                    if (selectedText) {
                        selectedText.textContent = "Choose";
                    }
                });
                // Reset selectedValues state
                setSelectedValues({});
            },
            handleGetResult: function handleGetResult() {
            // action()
            }
        };
    });
    var handleChangeElement = function(event, select) {
        if (event.target) {
            var _$ref, _$ref1;
            var sibling = select.previousElementSibling;
            var answer = ((_$ref1 = data === null || data === void 0 ? void 0 : (_$ref = data.answers) === null || _$ref === void 0 ? void 0 : _$ref.find(function(item) {
                var _$ref, _$ref1;
                return ((_$ref = event === null || event === void 0 ? void 0 : event.target) === null || _$ref === void 0 ? void 0 : _$ref.value) && item.id === ((_$ref1 = event === null || event === void 0 ? void 0 : event.target) === null || _$ref1 === void 0 ? void 0 : _$ref1.value);
            })) === null || _$ref1 === void 0 ? void 0 : _$ref1.answer) || "";
            if (sibling) {
                sibling.innerHTML = answer || "";
                if (!!answer && answer.length > 18) {
                    sibling.classList.remove("hidden");
                    sibling.classList.add("block");
                } else {
                    sibling.classList.remove("block");
                    sibling.classList.add("hidden");
                }
            }
        }
    };
    // Effects
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var parser = new DOMParser();
        var doc = parser === null || parser === void 0 ? void 0 : parser.parseFromString(str, "text/html");
        var elements = doc === null || doc === void 0 ? void 0 : doc.querySelectorAll(".question-content-tag");
        var doc2 = parser === null || parser === void 0 ? void 0 : parser.parseFromString(str, "text/html");
        var elementCorrects = doc2 === null || doc2 === void 0 ? void 0 : doc2.querySelectorAll(".question-content-tag");
        // Process question content
        elements.forEach(function(element, index) {
            var _ref;
            var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5;
            var dropdownContainer = document === null || document === void 0 ? void 0 : document.createElement("div");
            (_$ref = dropdownContainer.classList) === null || _$ref === void 0 ? void 0 : (_ref = _$ref).add.apply(_ref, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(DROPDOWN_STYLES.container.split(" ")));
            dropdownContainer.id = element === null || element === void 0 ? void 0 : element.id;
            dropdownContainer.setAttribute("data-value", "");
            dropdownContainer.setAttribute("data-component-id", componentId.current);
            var defaultAnswerValue = ((_$ref1 = defaultAnswer === null || defaultAnswer === void 0 ? void 0 : defaultAnswer.find(function(item) {
                return item.answer_position === index + 1;
            })) === null || _$ref1 === void 0 ? void 0 : _$ref1.answer_id) || "";
            if (corrects) {
                var _$ref6;
                var isCorrect = corrects === null || corrects === void 0 ? void 0 : corrects.some(function(correct) {
                    return (correct === null || correct === void 0 ? void 0 : correct.answer_position) === index + 1 && (correct === null || correct === void 0 ? void 0 : correct.id) === defaultAnswerValue && (correct === null || correct === void 0 ? void 0 : correct.is_correct);
                });
                dropdownContainer === null || dropdownContainer === void 0 ? void 0 : (_$ref6 = dropdownContainer.classList) === null || _$ref6 === void 0 ? void 0 : _$ref6.add(isCorrect || isSelfReflection ? "!border-success" : "!border-danger", "sapp-select-confirmed");
                dropdownContainer === null || dropdownContainer === void 0 ? void 0 : dropdownContainer.setAttribute("disabled", "true");
            }
            // Xử lý default của câu trả lời
            dropdownContainer.setAttribute("data-value", defaultAnswerValue !== null && defaultAnswerValue !== void 0 ? defaultAnswerValue : "");
            dropdownContainer.innerHTML = createDropdownHTML(index, defaultAnswerValue, corrects === null || corrects === void 0 ? void 0 : corrects.some(function(correct) {
                return (correct === null || correct === void 0 ? void 0 : correct.answer_position) === index + 1 && (correct === null || correct === void 0 ? void 0 : correct.id) === defaultAnswerValue && (correct === null || correct === void 0 ? void 0 : correct.is_correct);
            }));
            // Xử lý hiện tooltip sẽ thêm vào mỗi select
            var tooltip = document.createElement("div");
            tooltip.classList.add("tooltip-container");
            tooltip.setAttribute("data-component-id", componentId.current);
            var answer = ((_$ref3 = (_$ref2 = data.answers) === null || _$ref2 === void 0 ? void 0 : _$ref2.find(function(answer) {
                var _$ref, _$ref1, _$ref2;
                return !(0,lodash__WEBPACK_IMPORTED_MODULE_3__.isUndefined)((_$ref = defaultAnswer === null || defaultAnswer === void 0 ? void 0 : defaultAnswer.find(function(item) {
                    return item.answer_position === index + 1;
                })) === null || _$ref === void 0 ? void 0 : _$ref.answer_id) && !(0,lodash__WEBPACK_IMPORTED_MODULE_3__.isNull)((_$ref1 = defaultAnswer === null || defaultAnswer === void 0 ? void 0 : defaultAnswer.find(function(item) {
                    return item.answer_position === index + 1;
                })) === null || _$ref1 === void 0 ? void 0 : _$ref1.answer_id) && (answer === null || answer === void 0 ? void 0 : answer.id) === ((_$ref2 = defaultAnswer === null || defaultAnswer === void 0 ? void 0 : defaultAnswer.find(function(item) {
                    return item.answer_position === index + 1;
                })) === null || _$ref2 === void 0 ? void 0 : _$ref2.answer_id);
            })) === null || _$ref3 === void 0 ? void 0 : _$ref3.answer) || "";
            var selectedAnswer = selectedValues[index] ? (_$ref5 = (_$ref4 = data.answers) === null || _$ref4 === void 0 ? void 0 : _$ref4.find(function(answer) {
                return (answer === null || answer === void 0 ? void 0 : answer.id) === selectedValues[index];
            })) === null || _$ref5 === void 0 ? void 0 : _$ref5.answer : "";
            tooltip.innerHTML = '\n  <div class="tooltip-text '.concat(!!answer && answer.length > 18 || !!selectedAnswer && selectedAnswer.length > 18 ? "block" : "hidden", '" data-component-id="').concat(componentId.current, '">').concat(selectedAnswer || answer, "</div>\n");
            tooltip.appendChild(dropdownContainer);
            element.replaceWith(tooltip);
        });
        // Process correct answers
        if (corrects) {
            elementCorrects.forEach(function(element, index) {
                var correctAnswer = corrects === null || corrects === void 0 ? void 0 : corrects.find(function(ans) {
                    return (ans === null || ans === void 0 ? void 0 : ans.answer_position) === index + 1 && (ans === null || ans === void 0 ? void 0 : ans.is_correct);
                });
                if (correctAnswer) {
                    element.outerHTML = '\n              <span>\n                <span id="'.concat(element === null || element === void 0 ? void 0 : element.id, '" class="font-semibold text-state-success">\n                  ').concat(correctAnswer === null || correctAnswer === void 0 ? void 0 : correctAnswer.answer, "\n                </span>\n              </span>\n            ");
                }
            });
            setAnswerContent(doc2);
        }
        setQuestionContent(doc);
    }, [
        defaultAnswer,
        data
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var updateTooltips = function() {
            var dropdowns = document.querySelectorAll('.sapp-select--question[data-component-id="'.concat(componentId.current, '"]'));
            dropdowns.forEach(function(dropdown) {
                var dropdownIndex = Array.from(document.querySelectorAll('.sapp-select--question[data-component-id="'.concat(componentId.current, '"]'))).indexOf(dropdown);
                var tooltipContainer = dropdown.closest('.tooltip-container[data-component-id="'.concat(componentId.current, '"]'));
                if (tooltipContainer) {
                    var tooltipText = tooltipContainer.querySelector('.tooltip-text[data-component-id="'.concat(componentId.current, '"]'));
                    if (tooltipText) {
                        var selectedValue = selectedValues[dropdownIndex];
                        if (selectedValue) {
                            var _$ref, _$ref1;
                            var answer = ((_$ref1 = (_$ref = data.answers) === null || _$ref === void 0 ? void 0 : _$ref.find(function(answer) {
                                return (answer === null || answer === void 0 ? void 0 : answer.id) === selectedValue;
                            })) === null || _$ref1 === void 0 ? void 0 : _$ref1.answer) || "";
                            var isOpen = dropdown.getAttribute("data-open") === "true";
                            if (!isOpen) {
                                tooltipText.textContent = answer;
                                tooltipText.classList.toggle("block", answer.length > 18);
                                tooltipText.classList.toggle("hidden", answer.length <= 18);
                            } else {
                                tooltipText.classList.add("hidden");
                                tooltipText.classList.remove("block");
                            }
                        }
                    }
                }
            });
        };
        // Tạo MutationObserver để theo dõi sự thay đổi của data-open
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === "attributes" && mutation.attributeName === "data-open") {
                    var target = mutation.target;
                    updateTooltips();
                }
            });
        });
        // Theo dõi tất cả các dropdown
        var dropdowns = document.querySelectorAll('.sapp-select--question[data-component-id="'.concat(componentId.current, '"]'));
        dropdowns.forEach(function(dropdown) {
            observer.observe(dropdown, {
                attributes: true,
                attributeFilter: [
                    "data-open"
                ]
            });
        });
        // Initial update
        updateTooltips();
        // Cleanup
        return function() {
            observer.disconnect();
        };
    }, [
        selectedValues,
        data.answers
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var setupDropdownListeners = function() {
            var dropdowns = document.querySelectorAll('.sapp-select--question[data-component-id="'.concat(componentId.current, '"]'));
            dropdowns.forEach(function(dropdown) {
                if (!dropdown.getAttribute("data-listener-attached")) {
                    var selectedText = dropdown.querySelector('.selected-text[data-component-id="'.concat(componentId.current, '"]'));
                    var options = dropdown.querySelector('.dropdown-options[data-component-id="'.concat(componentId.current, '"]'));
                    var iconDropDown = dropdown.querySelector(".icon-dropdown");
                    // Toggle dropdown on click
                    selectedText === null || selectedText === void 0 ? void 0 : selectedText.addEventListener("click", function() {
                        if (!dropdown.getAttribute("disabled")) {
                            var isNowOpen = !(dropdown.getAttribute("data-open") === "true");
                            dropdown.setAttribute("data-open", isNowOpen.toString());
                            if (options) {
                                if (isNowOpen) {
                                    // Calculate dropdown position
                                    var dropdownRect = dropdown.getBoundingClientRect();
                                    var windowWidth = window.innerWidth;
                                    var windowHeight = window.innerHeight;
                                    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                                    var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
                                    // Default position
                                    options.style.top = "".concat(dropdownRect.bottom + scrollTop + 4, "px");
                                    options.style.left = "".concat(dropdownRect.left + scrollLeft, "px");
                                    // Adjust to prevent overflow
                                    if (dropdownRect.left + options.offsetWidth > windowWidth) {
                                        options.style.left = "".concat(windowWidth - options.offsetWidth - 16, "px");
                                    }
                                    if (dropdownRect.bottom + 300 + 4 > windowHeight) {
                                        options.style.top = "".concat(dropdownRect.top + scrollTop - 300 - 4, "px");
                                    }
                                    // Clear highlights
                                    options.querySelectorAll('.option[data-component-id="'.concat(componentId.current, '"]')).forEach(function(option) {
                                        option.classList.remove("bg-[#e5e7eb]", "selected");
                                    });
                                    options.style.display = "block";
                                } else {
                                    options.style.display = "none";
                                }
                                // Toggle UI styles
                                dropdown.classList.toggle("border-gray-200", isNowOpen);
                                iconDropDown === null || iconDropDown === void 0 ? void 0 : iconDropDown.classList.toggle("rotate-180", isNowOpen);
                            }
                        }
                    });
                    // Hover effect on options
                    options === null || options === void 0 ? void 0 : options.querySelectorAll('.option[data-component-id="'.concat(componentId.current, '"]')).forEach(function(option) {
                        option.addEventListener("mouseenter", function() {
                            options.querySelectorAll('.option[data-component-id="'.concat(componentId.current, '"]')).forEach(function(opt) {
                                return opt.classList.remove("bg-[#e5e7eb]", "selected");
                            });
                            option.classList.add("bg-[#e5e7eb]", "selected");
                        });
                    });
                    // Option selection
                    options === null || options === void 0 ? void 0 : options.querySelectorAll('.option[data-component-id="'.concat(componentId.current, '"]')).forEach(function(option) {
                        option.addEventListener("click", function() {
                            var _$ref;
                            var value = option.getAttribute("data-value");
                            var label = (_$ref = option.textContent) === null || _$ref === void 0 ? void 0 : _$ref.trim();
                            if (value && label) {
                                var dropdownIndex = Array.from(document.querySelectorAll('.sapp-select--question[data-component-id="'.concat(componentId.current, '"]'))).indexOf(dropdown);
                                dropdown.setAttribute("data-value", value);
                                dropdown.setAttribute("data-text", label);
                                setSelectedValues(function(prev) {
                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, dropdownIndex, value));
                                });
                                var span = selectedText === null || selectedText === void 0 ? void 0 : selectedText.querySelector("span");
                                if (span) {
                                    span.textContent = label.length > 50 ? label.slice(0, 50) + "..." : label;
                                }
                                // Highlight selected option
                                options.querySelectorAll('.option[data-component-id="'.concat(componentId.current, '"]')).forEach(function(opt) {
                                    opt.classList.toggle("bg-[#e5e7eb]", opt.getAttribute("data-value") === value);
                                });
                                options.style.display = "none";
                                dropdown.setAttribute("data-open", "false");
                                iconDropDown === null || iconDropDown === void 0 ? void 0 : iconDropDown.classList.remove("rotate-180");
                                dropdown.classList.remove("border-gray-200");
                            }
                        });
                    });
                    // Close dropdown when clicking outside
                    document.addEventListener("click", function(e) {
                        if (!dropdown.contains(e.target)) {
                            dropdown.setAttribute("data-open", "false");
                            if (options) {
                                options.style.display = "none";
                                // Restore selected option highlight
                                var selectedValue = dropdown.getAttribute("data-value");
                                options.querySelectorAll('.option[data-component-id="'.concat(componentId.current, '"]')).forEach(function(option) {
                                    option.classList.toggle("bg-[#e5e7eb]", option.getAttribute("data-value") === selectedValue);
                                });
                            }
                            iconDropDown === null || iconDropDown === void 0 ? void 0 : iconDropDown.classList.remove("rotate-180");
                            dropdown.classList.remove("border-gray-200");
                        }
                    });
                    dropdown.setAttribute("data-listener-attached", "true");
                }
            });
        };
        // Observe new dropdowns being added to the DOM
        var observer = new MutationObserver(setupDropdownListeners);
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        // Initial setup
        setupDropdownListeners();
        return function() {
            return observer.disconnect();
        };
    }, [
        data,
        defaultAnswer
    ]);
    // handle phần hiển thị tooltip khi lựa chọn câu trả lời
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var setupSelectListeners = function() {
            var selectList = document.querySelectorAll('select.sapp-select--question[data-component-id="'.concat(componentId.current, '"]'));
            selectList.forEach(function(element) {
                var htmlSelect = element;
                if (!htmlSelect.dataset.listenerAttached) {
                    htmlSelect.addEventListener("change", function(event) {
                        return handleChangeElement(event, htmlSelect);
                    });
                    htmlSelect.dataset.listenerAttached = "true";
                }
            });
        };
        var observer = new MutationObserver(function() {
            setupSelectListeners();
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        setupSelectListeners();
        return function() {
            observer.disconnect();
        };
    }, [
        data
    ]);
    var _$ref17;
    // Render
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        ref: extenalRef,
        children: [
            (data === null || data === void 0 ? void 0 : (_$ref = data.question_topic) === null || _$ref === void 0 ? void 0 : _$ref.exhibits) && !isHideExhibit && (data === null || data === void 0 ? void 0 : (_$ref1 = data.question_topic) === null || _$ref1 === void 0 ? void 0 : (_$ref2 = _$ref1.exhibits) === null || _$ref2 === void 0 ? void 0 : _$ref2.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    (data === null || data === void 0 ? void 0 : (_$ref3 = data.question_topic) === null || _$ref3 === void 0 ? void 0 : _$ref3.description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "my-6 border border-b-gray-2",
                        children: data === null || data === void 0 ? void 0 : (_$ref4 = data.question_topic) === null || _$ref4 === void 0 ? void 0 : _$ref4.id
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-4 flex items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "font-semibold",
                                children: [
                                    exhibitText ? exhibitText + "s" : "Exhibits",
                                    " (",
                                    (data === null || data === void 0 ? void 0 : (_$ref5 = data.question_topic) === null || _$ref5 === void 0 ? void 0 : (_$ref6 = _$ref5.exhibits) === null || _$ref6 === void 0 ? void 0 : _$ref6.length) || 0,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "ml-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-state-error",
                                        children: "* "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-gray-1",
                                        children: "Click to view"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col gap-2",
                        children: data === null || data === void 0 ? void 0 : (_$ref7 = data.question_topic) === null || _$ref7 === void 0 ? void 0 : (_$ref8 = _$ref7.exhibits) === null || _$ref8 === void 0 ? void 0 : _$ref8.map(function(e, i) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "cursor-pointer hover:text-primary",
                                onClick: function(event) {
                                    setOpenFile === null || setOpenFile === void 0 ? void 0 : setOpenFile({
                                        type: "exhibits",
                                        description: e === null || e === void 0 ? void 0 : e.description,
                                        name: e === null || e === void 0 ? void 0 : e.name,
                                        index: i,
                                        files: e === null || e === void 0 ? void 0 : e.files
                                    }, null, null, event);
                                },
                                children: [
                                    exhibitText || "Exhibit",
                                    " ",
                                    i + 1,
                                    ": ",
                                    e === null || e === void 0 ? void 0 : e.name
                                ]
                            }, (_$ref17 = e === null || e === void 0 ? void 0 : e.id) !== null && _$ref17 !== void 0 ? _$ref17 : i);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "my-6 border border-b-gray-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                extenalRef: refEditor,
                className: "sapp-questions",
                text_editor_content: ((_$ref10 = questionContent === null || questionContent === void 0 ? void 0 : (_$ref9 = questionContent.documentElement) === null || _$ref9 === void 0 ? void 0 : _$ref9.querySelector("body")) === null || _$ref10 === void 0 ? void 0 : _$ref10.innerHTML) || "",
                id: "hightlight_area",
                onMouseUp: function(e) {
                    var _$ref, _$ref1, _$ref2, _$ref3;
                    if ((e === null || e === void 0 ? void 0 : (_$ref = e.target) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.tagName) === null || _$ref1 === void 0 ? void 0 : _$ref1.charAt(0)) !== "m" && (e === null || e === void 0 ? void 0 : (_$ref2 = e.target) === null || _$ref2 === void 0 ? void 0 : (_$ref3 = _$ref2.firstChild) === null || _$ref3 === void 0 ? void 0 : _$ref3.tagName) !== "math") {
                        if (e) {
                            if (allowHighLight) {
                                (0,_utils_index__WEBPACK_IMPORTED_MODULE_2__/* .runHighlight */ .x4)(handleSaveHighLight, allowHighLight || false, "hightlight_area");
                            } else if (allowUnHighLight) {
                                (0,_utils_index__WEBPACK_IMPORTED_MODULE_2__/* .runHighlight */ .x4)(handleSaveHighLight, allowUnHighLight || false, "hightlight_area", {
                                    color: "white"
                                });
                            }
                        }
                    }
                },
                highlighted: highlighted
            }, key),
            answerContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pt-[18px] text-base font-semibold",
                        children: "Correct Answer"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        className: "questions mt-2",
                        text_editor_content: ((_$ref12 = answerContent === null || answerContent === void 0 ? void 0 : (_$ref11 = answerContent.documentElement) === null || _$ref11 === void 0 ? void 0 : _$ref11.querySelector("body")) === null || _$ref12 === void 0 ? void 0 : _$ref12.innerHTML) || ""
                    })
                ]
            }),
            solution && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-6 bg-gray-4 p-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_common_SappTitleSolution__WEBPACK_IMPORTED_MODULE_5__/* .SappTitleSolution */ .b, {
                        title: src_constants_lang__WEBPACK_IMPORTED_MODULE_6__/* .MY_COURSES.explanations */ .EQ.explanations
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_editor_EditorReader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        className: "mt-4",
                        text_editor_content: solution
                    })
                ]
            })
        ]
    });
});
SelectWord.displayName = "SelectWord";
/* harmony default export */ __webpack_exports__["Z"] = (SelectWord);


/***/ }),

/***/ 17792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ModalUploadFile_ModalUploadFile; }
});

// UNUSED EXPORTS: initCompleteModal

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_async_iterator.mjs
function _asyncIterator(iterable) {
  var method,
    async,
    sync,
    retry = 2;
  for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) {
    if (async && null != (method = iterable[async])) return method.call(iterable);
    if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable));
    async = "@@asyncIterator", sync = "@@iterator";
  }
  throw new TypeError("Object is not async iterable");
}
function AsyncFromSyncIterator(s) {
  function AsyncFromSyncIteratorContinuation(r) {
    if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
    var done = r.done;
    return Promise.resolve(r.value).then(function (value) {
      return {
        value: value,
        done: done
      };
    });
  }
  return AsyncFromSyncIterator = function (s) {
    this.s = s, this.n = s.next;
  }, AsyncFromSyncIterator.prototype = {
    s: null,
    n: null,
    next: function () {
      return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
    },
    return: function (value) {
      var ret = this.s.return;
      return void 0 === ret ? Promise.resolve({
        value: value,
        done: !0
      }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
    },
    throw: function (value) {
      var thr = this.s.return;
      return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
    }
  }, new AsyncFromSyncIterator(s);
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(51224);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67796);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(21967);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(37559);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(18473);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(52621);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
// EXTERNAL MODULE: ./src/components/base/modal/SappModalV3.tsx
var SappModalV3 = __webpack_require__(21849);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(68582);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(10103);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(72808);
// EXTERNAL MODULE: ./src/pages/api/upload/index.ts
var upload = __webpack_require__(95986);
// EXTERNAL MODULE: ./node_modules/antd/es/progress/index.js + 6 modules
var es_progress = __webpack_require__(64611);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(51774);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/pages/api/test/index.ts
var test = __webpack_require__(97590);
;// CONCATENATED MODULE: ./src/utils/upload.ts




var mergeImageToEditor = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
        var div, media, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, src, ref, res, source, linkVideo, iframe, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    div = document.createElement("div");
                    div.innerHTML = data || "";
                    media = div.querySelectorAll("img, video source, video[poster]");
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = media[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    element = _step.value;
                    src = element.getAttribute("resource_id");
                    if (!(src && element.tagName === "VIDEO")) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        test/* TestAPI.getResource */.a.getResource(src)
                    ];
                case 3:
                    res = _state.sent();
                    source = element.querySelector("source");
                    linkVideo = source === null || source === void 0 ? void 0 : source.getAttribute("src");
                    iframe = document.createElement("iframe");
                    iframe.src = res.data.url.replace("/manifest/video.m3u8", "/iframe?poster:".concat(res.data.thumbnail));
                    iframe.id = element.id;
                    iframe.className = element.className;
                    iframe.style.cssText = element.style.cssText;
                    iframe.allow = "accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;";
                    iframe.allowFullscreen = true;
                    element === null || element === void 0 ? void 0 : (ref = element.parentNode) === null || ref === void 0 ? void 0 : ref.replaceChild(iframe, element);
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2,
                        div.innerHTML
                    ];
            }
        });
    });
    return function mergeImageToEditor(data) {
        return _ref.apply(this, arguments);
    };
}();
var validateFile = function(file, acceptFiles, toastId) {
    var ref;
    var fileType = file.contentType || file.type;
    var fileSize = file.size;
    if (!acceptFiles) return true;
    var acceptedTypes = acceptFiles.map(function(file) {
        return file.type;
    });
    if (acceptedTypes.length > 0) {
        if (!acceptedTypes.some(function(type) {
            return (type === null || type === void 0 ? void 0 : type.endsWith("*")) ? fileType.startsWith(type.split("/")[0]) : fileType === type;
        })) {
            dist/* default.error */.ZP.error("File kh\xf4ng hỗ trợ");
            return false;
        }
    }
    var maxFileSize = ((ref = acceptFiles.find(function(acceptFile) {
        var ref;
        return (acceptFile === null || acceptFile === void 0 ? void 0 : (ref = acceptFile.type) === null || ref === void 0 ? void 0 : ref.endsWith("*")) ? fileType.startsWith(acceptFile.type.split("/")[0]) : fileType === acceptFile.type;
    })) === null || ref === void 0 ? void 0 : ref.size) || 0;
    if (maxFileSize > 0 && fileSize > maxFileSize) {
        dist/* default.error */.ZP.error("File qu\xe1 lớn");
        return false;
    }
    return true;
};

// EXTERNAL MODULE: ./src/components/uploadFile/ModalUploadFile/UploadFileInterface.ts + 4 modules
var UploadFileInterface = __webpack_require__(69542);
// EXTERNAL MODULE: ./src/components/base/button/ButtonPrimary.tsx
var ButtonPrimary = __webpack_require__(15421);
;// CONCATENATED MODULE: ./src/components/uploadFile/ModalUploadFile/UploadFileHandle.tsx







// import Dragger from 'antd/es/upload/Dragger'



// import ButtonIconOnly from '../../button/ButtonIconOnly'
// import ButtonPrimary from '../../button/ButtonPrimary'


var Dragger = dynamic_default()(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    __webpack_require__.e(/* import() */ 3890).then(__webpack_require__.bind(__webpack_require__, 53890))
                ];
            case 1:
                return [
                    2,
                    _state.sent()
                ];
        }
    });
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53890)
            ];
        }
    },
    ssr: false
});
var UploadFileHandle = function(param) {
    var uploadFile = param.uploadFile, setUploadFile = param.setUploadFile, progress = param.progress, loading = param.loading, // handleCancel,
    fileType = param.fileType, icon = param.icon, isMultiple = param.isMultiple, customValidate = param.customValidate, maxCount = param.maxCount;
    var ref, ref1, ref2;
    var findIconByJpg = function(extension) {
        for(var key in UploadFileInterface/* UPLOAD_TYPE */.DZ){
            if (key === "ALL" || key === "ALL_RESOURCE") continue;
            var support = UploadFileInterface/* UPLOAD_TYPE */.DZ[key].extension;
            if (support.includes(extension.toUpperCase()) || support.includes(extension)) {
                return UploadFileInterface/* UPLOAD_TYPE */.DZ[key].icon;
            }
        }
        return "";
    };
    var itemRender = function(_originNode, _file, _fileList, actions) {
        var ref;
        var extension = "";
        var newIcon = icon;
        if (fileType === "ALL" || fileType === "ALL_RESOURCE") {
            extension = _file.name.split(".").slice(-1).join();
            newIcon = findIconByJpg(extension);
        }
        var percent;
        var strokeColor;
        if (_file.status === "done") {
            percent = 100;
            strokeColor = "#FFB800";
        } else if (_file.status === "error") {
            strokeColor = "#D35563";
            percent = 100;
        } else {
            percent = progress[_file.uid];
            strokeColor = "#FFB800";
        }
        var ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sapp-upload-file-progress mt-2 items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-100 sapp-upload-file-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sapp-upload-file-name",
                            children: (ref1 = _file === null || _file === void 0 ? void 0 : _file.name) !== null && ref1 !== void 0 ? ref1 : _file === null || _file === void 0 ? void 0 : (ref = _file.originFileObj) === null || ref === void 0 ? void 0 : ref.name
                        }),
                        loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(es_progress/* default */.Z, {
                            percent: percent,
                            status: "active",
                            strokeColor: strokeColor,
                            className: "m-0"
                        })
                    ]
                })
            })
        });
    };
    var handleChangeUpload = function(e) {
        var ref, ref1;
        var length = (e === null || e === void 0 ? void 0 : (ref = e.fileList) === null || ref === void 0 ? void 0 : ref.length) || 0;
        e.fileList = e === null || e === void 0 ? void 0 : (ref1 = e.fileList) === null || ref1 === void 0 ? void 0 : ref1.filter(function(f, i) {
            if (f === null || f === void 0 ? void 0 : f.resource_id) {
                return true;
            }
            if (maxCount && length > maxCount && i >= maxCount) {
                dist/* default.error */.ZP.error("Upload giới hạn " + maxCount + " files", {
                    id: "upload_toast_max_count"
                });
                return false;
            }
            if (customValidate && customValidate(f, e.fileList, i)) {
                return false;
            }
            if (validateFile(f, UploadFileInterface/* UPLOAD_TYPE */.DZ[fileType].acceptFiles, "upload_toast_" + i)) {
                return true;
            }
            return false;
        });
        setUploadFile(e.fileList);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dragger, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            beforeUpload: function() {
                return false;
            },
            itemRender: itemRender,
            onChange: handleChangeUpload,
            disabled: loading,
            fileList: uploadFile,
            multiple: isMultiple,
            accept: (ref = UploadFileInterface/* UPLOAD_TYPE */.DZ[fileType]) === null || ref === void 0 ? void 0 : ref.accept
        }, !isMultiple && {
            maxCount: 1
        }), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "scroll-y px-lg-15 px-10 pb-10 pt-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-3 flex justify-center",
                            children: typeof icon === "object" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                width: 64,
                                height: 64,
                                src: icon.src,
                                alt: "Icon"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "d-flex justify-content-center align-items-center gap-5",
                                children: icon === null || icon === void 0 ? void 0 : icon.map(function(e, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        width: 64,
                                        height: 64,
                                        src: e.src,
                                        alt: "Icon"
                                    }, i);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Drag & Drop your file here"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "or"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonPrimary/* default */.Z, {
                            disabled: loading,
                            title: "Browse",
                            className: "mb-10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mx-auto my-0 flex w-fit",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-left",
                                    children: " File support:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "ms-2",
                                    children: (ref1 = UploadFileInterface/* UPLOAD_TYPE */.DZ[fileType]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.note) === null || ref2 === void 0 ? void 0 : ref2.map(function(e, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-left",
                                            children: e
                                        }, i);
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        }))
    });
};
/* harmony default export */ var ModalUploadFile_UploadFileHandle = (UploadFileHandle);

;// CONCATENATED MODULE: ./src/components/uploadFile/ModalUploadFile/ModalUploadFile.tsx

















var initCompleteModal = {
    open: false,
    errorRows: 0,
    totalRows: 0,
    fileName: ""
};
var ModalUploadFile = function(param) {
    var open = param.open, handleClose = param.handleClose, setSelectedFile = param.setSelectedFile, fileType = param.fileType, isMultiple = param.isMultiple, title = param.title, customValidate = param.customValidate, maxCount = param.maxCount, location = param.location;
    var ref;
    var sourceRef = (0,react.useRef)();
    var isCancel = (0,react.useRef)();
    var ref1 = (0,react.useState)(), uploadFile = ref1[0], setUploadFile = ref1[1];
    var ref2 = (0,react.useState)({}), progress = ref2[0], setProgress = ref2[1];
    var ref3 = (0,react.useState)(false), loadingUpload = ref3[0], setLoadingUpload = ref3[1];
    var ref4 = (0,react.useState)(false), disabled = ref4[0], setDisabled = ref4[1];
    var handleCancel = function() {
        var closeModal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, removedUid = arguments.length > 1 ? arguments[1] : void 0;
        if (sourceRef.current) {
            sourceRef.current.cancel();
            isCancel.current = true;
        }
        if (removedUid) {
            setUploadFile(function(e) {
                return e === null || e === void 0 ? void 0 : e.filter(function(f) {
                    return f.uid !== removedUid;
                });
            });
            setProgress(function(e) {
                delete e[removedUid];
                return e;
            });
        } else {
            setUploadFile(undefined);
            setProgress({});
        }
        if (closeModal) {
            handleClose();
        }
    };
    (0,react.useEffect)(function() {
        return function() {
            handleCancel();
        };
    }, []);
    var getProgress = function(percent, index) {
        if (percent < 7) {
            percent = 7;
        }
        setProgress(function(progress) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, progress), (0,_define_property/* default */.Z)({}, index, percent));
        });
    };
    function handleUploadFile() {
        return _handleUploadFile.apply(this, arguments);
    }
    function _handleUploadFile() {
        _handleUploadFile = (0,_async_to_generator/* default */.Z)(function() {
            var responseUploadedFiles, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, err, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(uploadFile === null || uploadFile === void 0 ? void 0 : uploadFile.length)) {
                            dist/* default.error */.ZP.error("Before uploading, please choose the file in the format of ".concat(UploadFileInterface/* UPLOAD_TYPE */.DZ[fileType].extension, "."));
                            return [
                                2
                            ];
                        }
                        setDisabled(true);
                        sourceRef.current = axios/* default.CancelToken.source */.Z.CancelToken.source();
                        isCancel.current = false;
                        setUploadFile(function(e) {
                            return e.map(function(f) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, f), {
                                    status: "uploading"
                                });
                            });
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            15,
                            16,
                            17
                        ]);
                        setLoadingUpload(true);
                        setProgress({});
                        responseUploadedFiles = [];
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            8,
                            9,
                            14
                        ]);
                        _loop = function() {
                            var _value, __value, index, u, ref, ref1, ref2, response, error;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _value = _step.value;
                                        __value = (0,_sliced_to_array/* default */.Z)(_value, 2), index = __value[0], u = __value[1];
                                        if (!u.originFileObj) {
                                            return [
                                                2,
                                                "continue"
                                            ];
                                        }
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        getProgress(7, u.uid);
                                        return [
                                            4,
                                            upload/* UploadAPI.startUpload */.h.startUpload({
                                                content_type: u === null || u === void 0 ? void 0 : (ref = u.originFileObj) === null || ref === void 0 ? void 0 : ref.type,
                                                blob: u === null || u === void 0 ? void 0 : u.originFileObj,
                                                size: ((ref1 = u === null || u === void 0 ? void 0 : u.originFileObj.size) === null || ref1 === void 0 ? void 0 : ref1.toString()) || "",
                                                description: "",
                                                name: (u === null || u === void 0 ? void 0 : (ref2 = u.originFileObj) === null || ref2 === void 0 ? void 0 : ref2.name) || "undefined",
                                                getProgress: function(percent) {
                                                    return getProgress(percent, u === null || u === void 0 ? void 0 : u.uid);
                                                },
                                                location: location
                                            })
                                        ];
                                    case 2:
                                        response = _state.sent();
                                        if (response) {
                                            responseUploadedFiles.push(response.data);
                                            setUploadFile(function(e) {
                                                var ref, ref1;
                                                e[index] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, e === null || e === void 0 ? void 0 : e[index]), {
                                                    status: "done",
                                                    fileName: response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.name,
                                                    file_key: response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.file_key
                                                });
                                                return e;
                                            });
                                        }
                                        return [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        error = _state.sent();
                                        setUploadFile(function(e) {
                                            return e === null || e === void 0 ? void 0 : e.map(function(f, i) {
                                                if (i === index) {
                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, f), {
                                                        status: "error"
                                                    });
                                                } else {
                                                    return f;
                                                }
                                            });
                                        });
                                        return [
                                            3,
                                            4
                                        ];
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _iterator = _asyncIterator(uploadFile.entries());
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            _iterator.next()
                        ];
                    case 4:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        return [
                            5,
                            (0,tslib_es6.__values)(_loop())
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            _iterator.return()
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        setSelectedFile && setSelectedFile(responseUploadedFiles);
                        dist/* default.success */.ZP.success("Upload completed!");
                        return [
                            3,
                            17
                        ];
                    case 15:
                        error = _state.sent();
                        if (isCancel.current) {
                            dist/* default.success */.ZP.success("Cancel successfully!");
                            return [
                                2
                            ];
                        }
                        dist/* default.error */.ZP.error("An error occurred during the upload process!");
                        setUploadFile(function(e) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, e), {
                                status: "error"
                            });
                        });
                        return [
                            3,
                            17
                        ];
                    case 16:
                        setTimeout(function() {
                            handleCancel();
                            setLoadingUpload(false);
                            setDisabled(false);
                        }, 1000);
                        return [
                            7
                        ];
                    case 17:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleUploadFile.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SappModalV3/* default */.Z, {
            open: open,
            title: title || "Add ".concat((0,lodash.capitalize)(UploadFileInterface/* UPLOAD_TYPE */.DZ[fileType].type.toLocaleLowerCase())),
            cancelButtonCaption: "Cancel",
            okButtonCaption: "Upload",
            handleCancel: handleCancel,
            externalLoading: disabled,
            size: "max-w-xl",
            scrollbale: false,
            onOk: handleUploadFile,
            icon: undefined,
            header: "",
            fullWidthBtn: true,
            buttonSize: "extra",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUploadFile_UploadFileHandle, {
                uploadFile: uploadFile,
                setUploadFile: setUploadFile,
                progress: progress,
                loading: loadingUpload,
                handleCancel: handleCancel,
                fileType: fileType,
                icon: (ref = UploadFileInterface/* UPLOAD_TYPE */.DZ[fileType]) === null || ref === void 0 ? void 0 : ref.icon,
                isMultiple: isMultiple,
                customValidate: customValidate,
                maxCount: maxCount
            })
        })
    });
};
/* harmony default export */ var ModalUploadFile_ModalUploadFile = (ModalUploadFile);


/***/ }),

/***/ 69542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nz": function() { return /* binding */ SUFFIX_TYPE; },
  "DZ": function() { return /* binding */ UPLOAD_TYPE; }
});

// UNUSED EXPORTS: RESOURCE_LOCATION

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(72760);
;// CONCATENATED MODULE: ./src/assets/images/document-icon.svg
/* harmony default export */ var document_icon = ({"src":"/_next/static/media/document-icon.a005fb9b.svg","height":72,"width":72});
;// CONCATENATED MODULE: ./src/assets/images/image-icon.svg
/* harmony default export */ var image_icon = ({"src":"/_next/static/media/image-icon.7b492790.svg","height":72,"width":72});
;// CONCATENATED MODULE: ./src/assets/images/video-icon.svg
/* harmony default export */ var video_icon = ({"src":"/_next/static/media/video-icon.222f493d.svg","height":72,"width":72});
;// CONCATENATED MODULE: ./src/constants/upload.ts
var MAX_UPLOAD_SIZE = 20 * 1024 * 1024;
var MAX_UPLOAD_VIDEO_SIZE = 20 * 1024 * 1024 * 1024;
var VALID_UPLOAD_EDITOR = [
    {
        type: "image/*",
        size: MAX_UPLOAD_SIZE
    },
    {
        type: "video/*",
        size: MAX_UPLOAD_VIDEO_SIZE
    }, 
];
var VALID_UPLOAD_EDITOR_VIDEO = [
    {
        type: "video/*",
        size: MAX_UPLOAD_VIDEO_SIZE
    }, 
];
var VALID_UPLOAD_EDITOR_IMAGE = [
    {
        type: "image/*",
        size: MAX_UPLOAD_SIZE
    }, 
];
var VALID_UPLOAD_FILES = [
    {
        type: "application/pdf",
        size: MAX_UPLOAD_SIZE
    },
    {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        size: MAX_UPLOAD_SIZE
    },
    {
        type: "application/msword",
        size: MAX_UPLOAD_SIZE
    },
    {
        type: "application/vnd.ms-excel",
        size: MAX_UPLOAD_SIZE
    },
    {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        size: MAX_UPLOAD_SIZE
    },
    {
        type: "text/csv",
        size: MAX_UPLOAD_SIZE
    },
    {
        type: "text/plain",
        size: MAX_UPLOAD_SIZE
    },
    {
        type: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        size: MAX_UPLOAD_SIZE
    },
    {
        type: "application/vnd.ms-powerpoint",
        size: MAX_UPLOAD_SIZE
    },
    {
        type: "application/zip",
        size: MAX_UPLOAD_SIZE
    },
    {
        type: "application/x-zip-compressed",
        size: MAX_UPLOAD_SIZE
    }, 
];

;// CONCATENATED MODULE: ./src/components/uploadFile/ModalUploadFile/UploadFileInterface.ts





var RESOURCE_LOCATION;
(function(RESOURCE_LOCATION) {
    RESOURCE_LOCATION["topic"] = "topic";
    RESOURCE_LOCATION["question"] = "question";
    RESOURCE_LOCATION["activity"] = "activity";
    RESOURCE_LOCATION["story"] = "story";
    RESOURCE_LOCATION["course"] = "course";
    RESOURCE_LOCATION["resource"] = "resource";
    RESOURCE_LOCATION["root"] = "";
    RESOURCE_LOCATION["mail"] = "mail";
    RESOURCE_LOCATION["certificate"] = "certificate";
    RESOURCE_LOCATION["essay"] = "essay";
})(RESOURCE_LOCATION || (RESOURCE_LOCATION = {}));
var SUFFIX_TYPE;
(function(SUFFIX_TYPE) {
    SUFFIX_TYPE["FOLDER"] = "FOLDER";
    SUFFIX_TYPE["GENERAL_FILE"] = "GENERAL_FILE";
    SUFFIX_TYPE["IMAGE"] = "IMAGE";
    SUFFIX_TYPE["VIDEO"] = "VIDEO";
    SUFFIX_TYPE["POWER_POINT"] = "POWER_POINT";
    SUFFIX_TYPE["PDF"] = "PDF";
    SUFFIX_TYPE["DOCUMENT_VIEWER"] = "DOCUMENT_VIEWER";
    SUFFIX_TYPE["WORD_DOCUMENT"] = "WORD_DOCUMENT";
    SUFFIX_TYPE["SHEET"] = "SHEET";
    SUFFIX_TYPE["NOT_A_FILE"] = "NOT_A_FILE";
    SUFFIX_TYPE["TEXT"] = "TEXT";
    SUFFIX_TYPE["ZIP"] = "ZIP";
})(SUFFIX_TYPE || (SUFFIX_TYPE = {}));
var UPLOAD_TYPE = {
    VIDEO: {
        type: "VIDEO",
        icon: video_icon,
        accept: ".mp4",
        extension: "MP4",
        note: [
            "MP4"
        ],
        acceptFiles: [
            {
                type: "video/mp4",
                size: MAX_UPLOAD_VIDEO_SIZE
            }
        ],
        suffixType: "VIDEO"
    },
    IMAGE: {
        type: "IMAGE",
        icon: image_icon,
        accept: "image/*",
        extension: ".jpg, .jpeg, .png, .gif, .webp",
        note: [
            ".jpg, .jpeg, .png, .gif, .webp"
        ],
        acceptFiles: [
            {
                type: "image/*",
                size: MAX_UPLOAD_SIZE
            }
        ],
        suffixType: "IMAGE"
    },
    DOCUMENT: {
        type: "DOCUMENT",
        icon: document_icon,
        accept: ".pdf,.docx,.doc,.xls,.xlsx,.csv,.txt,.ppt,.pptx",
        extension: ".pdf, .docx, .doc, .xls, .xlsx, .csv, .txt, .ppt, .pptx",
        note: [
            ".pdf, .docx, .doc, .xls, .xlsx, .csv, .txt, .ppt, .pptx",
            "v\xe0 dung lượng tối đa mỗi file l\xe0 20MB.", 
        ],
        acceptFiles: VALID_UPLOAD_FILES,
        suffixType: "".concat(SUFFIX_TYPE.PDF, ",").concat(SUFFIX_TYPE.WORD_DOCUMENT, ",").concat(SUFFIX_TYPE.DOCUMENT_VIEWER, ",").concat(SUFFIX_TYPE.SHEET, ",").concat(SUFFIX_TYPE.POWER_POINT, ",").concat(SUFFIX_TYPE.TEXT)
    },
    ESSAY: {
        type: "DOCUMENT",
        icon: document_icon,
        accept: ".pdf,.docx,.doc,.xls,.xlsx,.csv,.ppt,.pptx,.zip",
        extension: ".pdf, .docx, .doc, .xls, .xlsx, .csv, .ppt, .pptx, .zip",
        note: [
            ".pdf, .docx, .doc, .xls, .xlsx, .csv, .ppt, .pptx, .zip",
            "v\xe0 dung lượng tối đa mỗi file l\xe0 20MB.", 
        ],
        acceptFiles: VALID_UPLOAD_FILES,
        suffixType: "".concat(SUFFIX_TYPE.PDF, ",").concat(SUFFIX_TYPE.WORD_DOCUMENT, ",").concat(SUFFIX_TYPE.DOCUMENT_VIEWER, ",").concat(SUFFIX_TYPE.SHEET, ",").concat(SUFFIX_TYPE.POWER_POINT, ",").concat(SUFFIX_TYPE.TEXT, " ").concat(SUFFIX_TYPE.ZIP)
    },
    ALL: {
        type: "ALL",
        icon: [
            document_icon,
            video_icon,
            image_icon
        ],
        accept: "image/*,.mp4,.pdf,.docx,.xls,.xlsx,.csv,.txt",
        extension: ".jpg, .jpeg, .png, .gif, .webp, .mp4, .pdf, .docx, .doc, .xls, .xlsx, .csv, .txt, .ppt, .pptx",
        note: [
            ".jpg, .jpeg, .png, .gif, .webp, .mp4, .pdf, .docx, .doc, .xls, .xlsx, .csv, .txt, .ppt, .pptx", 
        ],
        acceptFiles: (0,_to_consumable_array/* default */.Z)(VALID_UPLOAD_FILES).concat([
            {
                type: "video/mp4",
                size: MAX_UPLOAD_VIDEO_SIZE
            },
            {
                type: "image/*",
                size: MAX_UPLOAD_SIZE
            }, 
        ]),
        suffixType: ""
    },
    ALL_RESOURCE: {
        type: "ALL_RESOURCE",
        icon: [
            document_icon,
            video_icon,
            image_icon
        ],
        accept: "image/*,.mp4, .pdf, .docx, .doc, .xls, .xlsx, .csv, .txt, .ppt, .pptx",
        extension: ".jpg, .jpeg, .png, .gif, .webp, .mp4, .pdf, .docx, .doc, .xls, .xlsx, .csv, .txt, .ppt, .pptx",
        note: [
            ".jpg, .jpeg, .png, .gif, .webp, .mp4, .pdf, .docx, .doc, .xls, .xlsx, .csv, .txt, .ppt, .pptx",
            "K\xedch thước tối đa của file l\xe0 20MB, video l\xe0 20GB", 
        ],
        acceptFiles: (0,_to_consumable_array/* default */.Z)(VALID_UPLOAD_FILES).concat([
            {
                type: "video/mp4",
                size: MAX_UPLOAD_VIDEO_SIZE
            },
            {
                type: "image/*",
                size: MAX_UPLOAD_SIZE
            },
            {
                type: "application/vnd.ms-powerpoint",
                size: MAX_UPLOAD_SIZE
            },
            {
                type: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                size: MAX_UPLOAD_SIZE
            }, 
        ]),
        suffixType: ""
    }
};


/***/ }),

/***/ 75729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21967);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _ButtonPrimary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38865);
/* harmony import */ var _ButtonText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32174);




var ButtonCancelSubmit = function(param) {
    var submit = param.submit, cancel = param.cancel, _className = param.className, className = _className === void 0 ? "flex align-middle justify-between" : _className, _showOkButton = param.showOkButton, showOkButton = _showOkButton === void 0 ? true : _showOkButton, _showCancelButton = param.showCancelButton, showCancelButton = _showCancelButton === void 0 ? true : _showCancelButton, _revertFunction = param.revertFunction, revertFunction = _revertFunction === void 0 ? false : _revertFunction;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        children: [
            showOkButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ButtonPrimary__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, !revertFunction ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, submit) : (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, cancel))),
            showCancelButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ButtonText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, !revertFunction ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, cancel) : (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, submit)))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonCancelSubmit);


/***/ }),

/***/ 38865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25925);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57368);
/* harmony import */ var _components_base_button_BaseButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97181);






var ButtonPrimary = function(_param) {
    var title = _param.title, onClick = _param.onClick, _className = _param.className, className = _className === void 0 ? "" : _className, link = _param.link, _size = _param.size, size = _size === void 0 ? "small" : _size, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, startIcon = _param.startIcon, endIcon = _param.endIcon, _full = _param.full, full = _full === void 0 ? false : _full, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "title",
        "onClick",
        "className",
        "link",
        "size",
        "disabled",
        "startIcon",
        "endIcon",
        "full",
        "children"
    ]);
    var textSizeClass = size === "small" ? "text-sm" : size === "medium" ? "text-sm md:text-base" : "text-sm md:text-lg";
    var padding = size === "small" ? "py-2 px-4" : size === "medium" ? "py-2 px-4 md:py-3 md:px-6" : "py-2 px-4 md:py-4 md:px-8";
    // let fullWidthClass = full ? 'block w-full' : 'inline-block'
    // let disabledClass = disabled
    //   ? 'cursor-not-allowed !bg-gray-100 !text-gray-400 hover:!bg-gray-100 hover:!text-gray-400 hover:!border-gray-100'
    //   : 'cursor-pointer'
    var componentClass = (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("text-center font-medium border-none ".concat(padding, " ").concat(textSizeClass), className, {
        "cursor-not-allowed !bg-gray-100 !text-gray-400 hover:!bg-gray-100 hover:!text-gray-400 hover:!border-gray-100": disabled,
        "cursor-pointer text-white bg-secondary-v2-600 hover:!text-white hover:!bg-secondary-v2-DEFAULT": !disabled,
        "block w-full": full,
        "inline-block": !full
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_button_BaseButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: componentClass,
        onClick: onClick,
        disabled: disabled,
        link: link
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-center gap-2.5",
            children: [
                startIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-full",
                    children: startIcon
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-full",
                    children: title || children
                }),
                endIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-full",
                    children: endIcon
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonPrimary);


/***/ }),

/***/ 32174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25925);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var _components_base_button_BaseButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97181);






var ButtonText = function(_param) {
    var title = _param.title, onClick = _param.onClick, _className = _param.className, className = _className === void 0 ? "" : _className, link = _param.link, _size = _param.size, size = _size === void 0 ? "small" : _size, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, startIcon = _param.startIcon, endIcon = _param.endIcon, _full = _param.full, full = _full === void 0 ? false : _full, _isUnderLine = _param.isUnderLine, isUnderLine = _isUnderLine === void 0 ? true : _isUnderLine, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "title",
        "onClick",
        "className",
        "link",
        "size",
        "disabled",
        "startIcon",
        "endIcon",
        "full",
        "isUnderLine",
        "children"
    ]);
    var textSizeClass = size === "small" ? "text-sm" : size === "medium" ? "text-sm md:text-base" : "text-sm md:text-lg";
    var fullWidthClass = full ? "block w-full" : "inline-block w-fit";
    var disabledClass = disabled ? "cursor-not-allowed !bg-transparent !text-secondary-v2-100 hover:!text-secondary-v2-100" : "cursor-pointer";
    var isUnderline = isUnderLine ? "underline" : "";
    var componentClass = "\n    p-0\n    text-center \n    font-medium\n    !border-none\n    text-gray-v2-800\n    hover:text-primary\n    ".concat(isUnderline, "\n    ").concat(fullWidthClass, " \n    ").concat(disabledClass, " \n    ").concat(textSizeClass, " \n    ").concat(className, " \n  ");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_button_BaseButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: componentClass,
        onClick: onClick,
        disabled: disabled,
        link: link
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                startIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-full",
                    children: startIcon
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-full",
                    children: title || children
                }),
                endIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-full",
                    children: endIcon
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonText);


/***/ }),

/***/ 52880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ej": function() { return /* binding */ defaultSheetData; },
/* harmony export */   "eq": function() { return /* binding */ generateSheetId; },
/* harmony export */   "kO": function() { return /* binding */ DEFAULT_EDITOR_VALUE; },
/* harmony export */   "m": function() { return /* binding */ EAttemptStatus; }
/* harmony export */ });
var EAttemptStatus;
(function(EAttemptStatus) {
    EAttemptStatus["UN_SUBMITTED"] = "UN_SUBMITTED";
    EAttemptStatus["SUBMITTED"] = "SUBMITTED";
    EAttemptStatus["UN_FINISHED"] = "UN_FINISHED";
    EAttemptStatus["IN_PROGRESS"] = "IN_PROGRESS";
})(EAttemptStatus || (EAttemptStatus = {}));
// Generate unique ID for sheets
var generateSheetId = function() {
    return "sheet_".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 9));
};
var defaultSheetData = JSON.stringify([
    {
        name: "Sheet1",
        id: generateSheetId(),
        status: 1,
        data: [
            []
        ],
        celldata: []
    }, 
]);
var DEFAULT_EDITOR_VALUE = "<p></p>";


/***/ }),

/***/ 38483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B8": function() { return /* binding */ DEFAULT_PAGESIZE; },
/* harmony export */   "EV": function() { return /* binding */ COURSES_STATUS_BADGE; },
/* harmony export */   "Tu": function() { return /* binding */ DEFAULT_TOOLTIP_BG_COLOR; },
/* harmony export */   "Z6": function() { return /* binding */ ROUTES; },
/* harmony export */   "cx": function() { return /* binding */ QUIZ_MODAL_WIDTH; },
/* harmony export */   "mj": function() { return /* binding */ COURSES_STATUS_LABEL; },
/* harmony export */   "oX": function() { return /* binding */ DEFAULT_TOOLTIP_COLOR; }
/* harmony export */ });
/* unused harmony exports COURSES_STATUS, GRADING_PREFERENCE */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67796);

var COURSES_STATUS;
(function(COURSES_STATUS) {
    COURSES_STATUS["RECEIVED"] = "RECEIVED";
    COURSES_STATUS["PROCESSING"] = "PROCESSING";
    COURSES_STATUS["SUCCESS"] = "SUCCESS";
    COURSES_STATUS["FAILURE"] = "FAILURE";
    COURSES_STATUS["LEARNING"] = "LEARNING";
    COURSES_STATUS["FINISH"] = "FINISH";
})(COURSES_STATUS || (COURSES_STATUS = {}));
var _obj;
var COURSES_STATUS_BADGE = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, COURSES_STATUS.RECEIVED, "active"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, COURSES_STATUS.PROCESSING, "pending"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, COURSES_STATUS.SUCCESS, "approved"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, COURSES_STATUS.FAILURE, "reject"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, COURSES_STATUS.LEARNING, "learning"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, COURSES_STATUS.FINISH, "finished"), _obj);
var _obj1;
var COURSES_STATUS_LABEL = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, COURSES_STATUS.RECEIVED, "Received"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, COURSES_STATUS.PROCESSING, "Processing"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, COURSES_STATUS.SUCCESS, "Success"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, COURSES_STATUS.FAILURE, "Failure"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, COURSES_STATUS.LEARNING, "Learning"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, COURSES_STATUS.FINISH, "Finished"), _obj1);
var DEFAULT_TOOLTIP_BG_COLOR = "#ffffff";
var DEFAULT_TOOLTIP_COLOR = "#000000";
var ROUTES = {
    MY_COURSES: "/short-course/my-course/",
    COURSE_DETAIL: function(id) {
        return "/short-course/detail/".concat(id);
    },
    ACTIVITY: function(course_id, course_section_id) {
        return "/short-course/detail/".concat(course_id, "/activity/").concat(course_section_id);
    }
};
var DEFAULT_PAGESIZE = 18;
var GRADING_PREFERENCE;
(function(GRADING_PREFERENCE) {
    GRADING_PREFERENCE["AFTER_EACH_QUESTION"] = "AFTER_EACH_QUESTION";
    GRADING_PREFERENCE["AFTER_ALL_QUESTIONS"] = "AFTER_ALL_QUESTIONS";
})(GRADING_PREFERENCE || (GRADING_PREFERENCE = {}));
var QUIZ_MODAL_WIDTH = 560;


/***/ }),

/***/ 43743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "RB": function() { return /* reexport */ ACTIVE_TABS; },
  "lB": function() { return /* binding */ ANIMATION; },
  "C0": function() { return /* binding */ ANT_THEME_CONFIG; },
  "KL": function() { return /* binding */ BUTTON_STATUS; },
  "Ld": function() { return /* binding */ CALENDAR_COLOR_TYPES; },
  "ut": function() { return /* binding */ CALENDAR_FILTER_TYPE; },
  "VE": function() { return /* binding */ CALENDAR_SIDEBAR_CANCEL_BUTTON; },
  "HF": function() { return /* binding */ CALENDAR_SIDEBAR_EVENT_FORM; },
  "z7": function() { return /* binding */ CALENDAR_SIDEBAR_SAVE_BUTTON; },
  "Du": function() { return /* binding */ CALENDAR_SIDEBAR_TITLE; },
  "pP": function() { return /* binding */ CALENDAR_TYPE; },
  "JJ": function() { return /* binding */ CERTIFICATE_DETAIL; },
  "RS": function() { return /* binding */ CLASS_STATUS; },
  "jQ": function() { return /* binding */ CLASS_USER_TYPES; },
  "Vp": function() { return /* binding */ COMMON_TEXT_ENUM; },
  "dS": function() { return /* binding */ CONFIRM_CANCEL; },
  "$e": function() { return /* binding */ CONFIRM_DELETE; },
  "s_": function() { return /* binding */ COOKIE_INFO; },
  "ID": function() { return /* binding */ COURSE_STATUS; },
  "R3": function() { return /* binding */ COURSE_TYPE; },
  "zT": function() { return /* binding */ DATE_FORMAT; },
  "tD": function() { return /* reexport */ DATE_FORMAT_DMY; },
  "eK": function() { return /* reexport */ DATE_FORMAT_HM; },
  "He": function() { return /* reexport */ DATE_FORMAT_YMD; },
  "a1": function() { return /* reexport */ DATE_TIME_FORMAT; },
  "ib": function() { return /* reexport */ DATE_TIME_FORMAT_DMY; },
  "NA": function() { return /* reexport */ DAYS_IN_WEEK; },
  "B8": function() { return /* reexport */ courses/* DEFAULT_PAGESIZE */.B8; },
  "Kp": function() { return /* binding */ DEFAULT_PAGE_NUMBER; },
  "L8": function() { return /* binding */ DEFAULT_PAGE_SIZE; },
  "qq": function() { return /* binding */ DEFAULT_SELECT_SECTION; },
  "_l": function() { return /* binding */ DEFAULT_SELECT_SECTION_NAME; },
  "M_": function() { return /* binding */ DELAY_TIME_DISPLAY_POPUP; },
  "Qs": function() { return /* binding */ DISPLAY_TYPE; },
  "WD": function() { return /* binding */ ENTRANCE_TEST_RESULT; },
  "IO": function() { return /* binding */ ENTRANCE_TEST_TABLE_RESULT; },
  "JW": function() { return /* binding */ ESSAY_TYPE; },
  "dJ": function() { return /* binding */ EVENT_REPEAT_LABEL; },
  "mO": function() { return /* binding */ EVENT_REPEAT_TYPES; },
  "E_": function() { return /* binding */ EVENT_TYPES; },
  "gu": function() { return /* binding */ EVENT_TYPES_LABEL; },
  "X1": function() { return /* binding */ EVENT_TYPES_RESPONSE; },
  "Un": function() { return /* binding */ EVENT_TYPE_OPTIONS; },
  "nY": function() { return /* binding */ EXHIBIT_TEXT_REPLACE; },
  "W1": function() { return /* binding */ FINISHED_TEST_TITLE; },
  "XA": function() { return /* binding */ FREQUENCY_OPTIONS; },
  "jE": function() { return /* binding */ FREQUENCY_OPTIONS_PLURAL; },
  "Aj": function() { return /* binding */ FREQUENCY_UNITS; },
  "$V": function() { return /* binding */ FREQUENCY_UNITS_LIMIT; },
  "rn": function() { return /* binding */ GRADE_STATUS; },
  "mW": function() { return /* binding */ GRADING_METHOD; },
  "j$": function() { return /* binding */ LABEL_MAX_LENGTH; },
  "dE": function() { return /* binding */ LEARNING_USER_STATUS; },
  "dA": function() { return /* reexport */ LOCAL_STORAGE_KEYS; },
  "Up": function() { return /* binding */ OFFICE_VIEWER_URL; },
  "dX": function() { return /* binding */ POPUP_EVENT_DETAILS; },
  "x2": function() { return /* binding */ PROGRAM; },
  "H_": function() { return /* binding */ PageLink; },
  "YU": function() { return /* binding */ QUESTION_TYPES; },
  "bl": function() { return /* binding */ QUIZ_ATTEMPT_STATUS_AUTO; },
  "cx": function() { return /* reexport */ courses/* QUIZ_MODAL_WIDTH */.cx; },
  "Zc": function() { return /* binding */ REPEAT_ON; },
  "vE": function() { return /* binding */ REPEAT_ON_MAPPED; },
  "PX": function() { return /* binding */ REPEAT_ON_MAPPED_PAYLOAD; },
  "J_": function() { return /* reexport */ request/* REQUEST_STATUS */.J_; },
  "XN": function() { return /* reexport */ request/* REQUEST_TYPE */.XN; },
  "Cj": function() { return /* binding */ RESPONSE_OPTION; },
  "Z6": function() { return /* reexport */ courses/* ROUTES */.Z6; },
  "Xv": function() { return /* binding */ SOCIAL_LINK; },
  "QH": function() { return /* reexport */ SOCKET_EVENTS; },
  "az": function() { return /* binding */ TEST_ATTEMPT_TYPE; },
  "LB": function() { return /* binding */ TEST_TYPE; },
  "ci": function() { return /* binding */ TitleSidebar; },
  "lN": function() { return /* binding */ TitleTeacherSidebar; },
  "EB": function() { return /* binding */ UserGuide; },
  "Bm": function() { return /* binding */ VALID_UPLOAD_EDITOR; },
  "H7": function() { return /* binding */ defaultStatusCourse; },
  "mn": function() { return /* binding */ defaultStatusDetail; },
  "nm": function() { return /* binding */ defaultStatusEnstraceTest; },
  "RF": function() { return /* binding */ defaultStatusEventTest; },
  "_U": function() { return /* reexport */ request/* requestStatusToBadge */._U; },
  "GS": function() { return /* reexport */ request/* requestStatusToTitle */.GS; },
  "Nc": function() { return /* reexport */ request/* requestTypeToTitle */.Nc; }
});

// UNUSED EXPORTS: BADGE_TYPES, CALENDAR_FILTER_TYPE_LABEL, COURSES_STATUS, COURSES_STATUS_BADGE, COURSES_STATUS_LABEL, DEFAULT_SELECT, DEFAULT_TOOLTIP_BG_COLOR, DEFAULT_TOOLTIP_COLOR, DRAWER_REQUEST_TYPE, ERROR_MESSAGE_TRIAL, EVENT_TYPES_ARRAY, FREQUENCY_UNITS_OBJECT, GRADING_PREFERENCE, GUIDELINE_PASSWORD, MAX_UPLOAD_SIZE, MAX_UPLOAD_VIDEO_SIZE, OPTIONS_PERSONAL_SCHEDULE_REQUEST_TYPE, OPTIONS_REQUEST_STATUS, OPTIONS_TIME_OFF_REQUEST_TYPE, PDF_VIEWER_URL, PRIMARY_COLOR, QUIZ_ATTEMPT_GRADING_STATUS, QUIZ_ATTEMPT_STATUS, SEARCH_EVENT_PLACEHOLDER

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67796);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(18473);
;// CONCATENATED MODULE: ./src/constants/common.ts
var BADGE_TYPES;
(function(BADGE_TYPES) {
    BADGE_TYPES["error"] = "error";
    BADGE_TYPES["warning"] = "warning";
    BADGE_TYPES["info"] = "info";
    BADGE_TYPES["success"] = "success";
    BADGE_TYPES["default"] = "default";
})(BADGE_TYPES || (BADGE_TYPES = {}));
var DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm";
var DATE_FORMAT_YMD = "YYYY-MM-DD";
var DATE_FORMAT_DMY = "DD/MM/YYYY";
var DATE_TIME_FORMAT_DMY = "DD/MM/YYYY | HH:mm";
var DATE_FORMAT_HM = "HH:mm";
var DAYS_IN_WEEK = 7;

;// CONCATENATED MODULE: ./src/constants/socketEvents.ts
// src/constants/socketEvents.ts
var SOCKET_EVENTS;
(function(SOCKET_EVENTS) {
    SOCKET_EVENTS["NOTIFICATION_UNREAD"] = "NOTIFICATION_UNREAD";
    SOCKET_EVENTS["STUDENT_COMPLETE_COURSE"] = "STUDENT_COMPLETE_COURSE";
})(SOCKET_EVENTS || (SOCKET_EVENTS = {}));

;// CONCATENATED MODULE: ./src/constants/localStorageKeys.ts
var LOCAL_STORAGE_KEYS;
(function(LOCAL_STORAGE_KEYS) {
    LOCAL_STORAGE_KEYS["NOTIFICATION_COUNT"] = "notification-count";
})(LOCAL_STORAGE_KEYS || (LOCAL_STORAGE_KEYS = {}));

// EXTERNAL MODULE: ./src/constants/request.ts
var request = __webpack_require__(4522);
;// CONCATENATED MODULE: ./src/constants/courses3level/activity.ts
var ACTIVE_TABS = {
    LEARNING: "learning",
    CONTENT: "content",
    RESOURCE: "resource",
    ADD_NOTE: "add-note",
    NOTE_LIST: "note-list"
};

// EXTERNAL MODULE: ./src/constants/courses3level/courses.ts
var courses = __webpack_require__(38483);
;// CONCATENATED MODULE: ./src/constants/index.ts


var PageLink = {
    HOME: "/",
    COURSES: "/courses",
    COURSE_NEW: "/courses/new-courses",
    TOPICS: "/topics",
    CASE_STUDY: "/casestudy",
    TEACHERS: "/teachers",
    STUDENTS: "/students",
    TEACHER_MY_CLASS: "/teachers/my-class",
    TEACHER_MY_COURSE: "/teachers/courses",
    TEACHER_MY_REQUEST: "/teachers/my-request",
    TEACHER_CHAPTER_TEST: "/teachers/my-class/chapter-test",
    TEACHER_CASE_STUDY: "/teachers/case-study",
    TEACHER_TEST: "/teachers/test",
    TEACHER_EXPLANATION: "/teachers/explanation",
    TEACHER_MY_PROFILE: "/teachers/overview",
    AUTH_LOGIN: "/auth/login",
    AUTH_FORGOT_PASSWORD: "/auth/forgot-password",
    AUTH_FORGOT_PASSWORD_RECOVER: "/auth/forgot-password/recover",
    AUTH_CHANGE_PASSWORD: "/auth/change-password",
    AUTH_CHANGE_PASSWORD_SUCCESS: "/auth/change-password/change-password-success",
    NOTIFICATION: "/notifications",
    ENTRANCE_TEST: "/entrance-test",
    MYPROFILE: "/overview",
    PAGE_NOT_FOUND: "/404",
    COURSE_DETAIL: "/courses/my-course/[courseId]",
    TEACHER_COURSE_DETAIL_ID: "/teachers/courses/my-course/[courseId]",
    COURSE_PART_DETAIL: "/courses/[id]/section/[course_section_id]",
    TEACHER_COURSE_PART_DETAIL: "/teachers/courses/[id]/section/[course_section_id]",
    COURSE_ACTIVITY: "/courses/[id]/activity/[activityId]",
    TEACHER_COURSE_ACTIVITY: "/teachers/courses/[id]/activity/[activityId]",
    TEST_RESULT: "/courses/test/test-result/[id]",
    USERPAGE: "/[page]",
    EVENT_TEST: "/event-test",
    RESULTS: "/courses/my-course/[courseId]/results",
    MY_CALENDAR: "/teachers/my-calendar",
    REQUEST: "/request",
    MY_REQUEST: "/teachers/my-request",
    DASHBOARD: "/courses/my-course/[courseId]/dashboard",
    COURSE_CONTENT: "/courses/my-course",
    CALENDAR: "/calendar",
    SHORT_COURSE: "/short-course",
    SHORT_COURSE_DETAIL: "/short-course/detail",
    SHORT_COURSE_PROFILE: "/short-course/profile"
};
var TitleSidebar = {
    DASHBOARD: "Dashboard",
    COURSES: "My Course",
    RESOURCES: "Resources",
    COURSE_NEW: "Course new",
    COURSE_LIST: "Course list",
    CASE_STUDY: "Case Study",
    TOPICS: "Topics",
    TOPICS_LIST: "Topics list",
    TEACHER: "Teacher",
    NOTIFICATION: "Notifications",
    RESULTS: "Results",
    EXAM_INFORMATION: "Exam Information",
    COURSE_CONTENT: "Course Content",
    NOTES_LIST: "Notes List",
    NEW_NOTE: "New Note",
    ADD_NOTE: "Add Note",
    CALCULATOR: "Calculator",
    ENTRANCE_TEST: "Entrance Test",
    MY_CALENDAR: "My Calendar",
    MY_REQUEST: "My Request",
    CALENDAR: "Calendar",
    COURSE_RESOURCES: "Course Resource"
};
var TitleTeacherSidebar = {
    DASHBOARD: "Dashboard",
    MYCLASS: "My Class",
    MYCALENDAR: "My Calendar",
    MYREQUEST: "My Request",
    NOTIFICATIONS: "Notifications"
};
var GUIDELINE_PASSWORD = (/* unused pure expression or super */ null && ([
    "Tối thiểu 8 k\xfd tự, \xedt nhất 1 k\xfd tự hoa, 1 k\xfd tự số", 
]));
var QUESTION_TYPES;
(function(QUESTION_TYPES) {
    QUESTION_TYPES["TRUE_FALSE"] = "TRUE_FALSE";
    QUESTION_TYPES["ONE_CHOICE"] = "ONE_CHOICE";
    QUESTION_TYPES["MULTIPLE_CHOICE"] = "MULTIPLE_CHOICE";
    QUESTION_TYPES["MATCHING"] = "MATCHING";
    QUESTION_TYPES["SELECT_WORD"] = "SELECT_WORD";
    QUESTION_TYPES["FILL_WORD"] = "FILL_WORD";
    QUESTION_TYPES["DRAG_DROP"] = "DRAG_DROP";
    QUESTION_TYPES["ESSAY"] = "ESSAY";
})(QUESTION_TYPES || (QUESTION_TYPES = {}));
var TEST_TYPE;
(function(TEST_TYPE) {
    TEST_TYPE["QUIZ"] = "QUIZ";
    TEST_TYPE["MID_TERM_TEST"] = "MID_TERM_TEST";
    TEST_TYPE["FINAL_TEST"] = "FINAL_TEST";
    TEST_TYPE["MOCK_TEST"] = "MOCK_TEST";
    TEST_TYPE["ENTRANCE_TEST"] = "ENTRANCE_TEST";
    TEST_TYPE[// STORY = 'STORY',
    "TOPIC_TEST"] = "TOPIC_TEST";
    TEST_TYPE["CHAPTER_TEST"] = "CHAPTER_TEST";
    TEST_TYPE["PART_TEST"] = "PART_TEST";
    TEST_TYPE["EVENT_TEST"] = "EVENT_TEST";
    TEST_TYPE["ACTIVITY"] = "ACTIVITY";
})(TEST_TYPE || (TEST_TYPE = {}));
var COURSE_TYPE;
(function(COURSE_TYPE) {
    COURSE_TYPE["FOUNDATION_COURSE"] = "FOUNDATION_COURSE";
    COURSE_TYPE["NORMAL_COURSE"] = "NORMAL_COURSE";
    COURSE_TYPE["PRACTICE_COURSE"] = "PRACTICE_COURSE";
})(COURSE_TYPE || (COURSE_TYPE = {}));
var DISPLAY_TYPE;
(function(DISPLAY_TYPE) {
    DISPLAY_TYPE["VERTICAL"] = "VERTICAL";
    DISPLAY_TYPE["HORIZONTAL"] = "HORIZONTAL";
})(DISPLAY_TYPE || (DISPLAY_TYPE = {}));
var RESPONSE_OPTION;
(function(RESPONSE_OPTION) {
    RESPONSE_OPTION["WORD"] = "WORD";
    RESPONSE_OPTION["SHEET"] = "SHEET";
})(RESPONSE_OPTION || (RESPONSE_OPTION = {}));
var MAX_UPLOAD_SIZE = 20 * 1024 * 1024;
var MAX_UPLOAD_VIDEO_SIZE = 20 * 1024 * 1024 * 1024;
var DEFAULT_PAGE_SIZE = 10;
var DEFAULT_PAGE_NUMBER = 1;
var VALID_UPLOAD_EDITOR = [
    {
        type: "image/*",
        size: MAX_UPLOAD_SIZE
    },
    {
        type: "video/*",
        size: MAX_UPLOAD_VIDEO_SIZE
    }, 
];
var UserGuide = {
    TITLE_WELCOME: "Welcome to SAPP LMS",
    CONTENT_WELCOME: "Let’s start with a quick product tour!",
    CONTENT_BUTTON: "Start Tour",
    CONTENT_STEP_1: "The search box is located in the upper corner of the website. Simply enter the course name and press Enter to search.",
    CONTENT_STEP_2: "The left menu bar is divided into two sections. The upper section consists of the SAPP logo, dashboard, your enrolled courses, and the entrance test you have registered for.",
    CONTENT_STEP_3: "The lower section of the menu consists of notifications and your profile, which includes personal information, certificates, settings, and the option to log out.",
    CONTENT_STEP_4: "This is the welcome section! You will find information about your location here, and take a moment to familiarize yourself with the features and possibilities that await you on this page.",
    CONTENT_STEP_5: "This is a course you have enrolled in. It provides details about the class it belongs to, the remaining study days, a brief course description, as well as the status and progress you have made so far.",
    CONTENT_STEP_6: "The filter section allows you to filter courses by curriculum and course status."
};
var defaultStatusCourse = [
    {
        label: "All",
        value: ""
    },
    {
        label: "Ready To Learn",
        value: "READY_TO_LEARN"
    },
    {
        label: "In Progress",
        value: "IN_PROGRESS"
    },
    {
        label: "Completed",
        value: "COMPLETED"
    },
    {
        label: "Expired",
        value: "CANCELED"
    }, 
];
var defaultStatusDetail = [
    {
        label: "All",
        value: ""
    },
    {
        label: "Ready To Learn",
        value: "READY_TO_LEARN"
    },
    {
        label: "In Progress",
        value: "IN_PROGRESS"
    },
    {
        label: "Completed",
        value: "COMPLETED"
    }, 
];
var defaultStatusEnstraceTest = [
    {
        label: "All",
        value: ""
    },
    {
        label: "Submitted",
        value: "SUBMITTED"
    },
    {
        label: "Unsubmitted",
        value: "UN_SUBMITTED"
    }, 
];
var defaultStatusEventTest = [
    {
        label: "All",
        value: ""
    },
    {
        label: "Completed",
        value: "SUBMITTED"
    },
    {
        label: "Uncompleted",
        value: "UN_SUBMITTED"
    }, 
];
var QUIZ_ATTEMPT_STATUS_AUTO = [
    {
        label: "Unsubmitted",
        value: "UN_SUBMITTED"
    },
    {
        label: "Submitted",
        value: "SUBMITTED"
    }, 
];
var DEFAULT_SELECT = [
    {
        label: "All",
        value: ""
    }
];
var DEFAULT_SELECT_SECTION_NAME = "All Section";
var DEFAULT_SELECT_SECTION = [
    {
        label: "All Section",
        value: "",
        name: DEFAULT_SELECT_SECTION_NAME
    }, 
];
var COURSE_STATUS = {
    PUBLISH: "PUBLISH",
    LOCK: "LOCK",
    DRAFT: "DRAFT",
    BLOCK: "BLOCK"
};
var CLASS_STATUS = {
    PUBLIC: "PUBLIC",
    DRAFT: "DRAFT",
    BLOCK: "BLOCK",
    ENDED: "ENDED"
};
var CLASS_USER_TYPES = {
    NORMAL: "NORMAL",
    RESERVED: "RESERVED",
    REASSIGNED: "REASSIGNED",
    RETOOK: "RETOOK",
    RETAKING: "RETAKING",
    MOVED_OUT: "MOVED_OUT",
    MOVED_IN: "MOVED_IN",
    TRANSFERED_TO: "TRANSFERED_TO",
    TRANSFERRED: "BE_TRANSFERRED",
    CANCELED: "CANCELED"
};
var BUTTON_STATUS = {
    Active: "Active",
    Begin: "Begin",
    Resume: "Resume",
    Review: "Review",
    Extend: "Extend",
    Hidden: "Hidden",
    Disabled: "Disabled"
};
var ANIMATION = {
    DURATION: 500,
    DATA_AOS: "fade-up"
};
var SOCIAL_LINK = {
    FACEBOOK: "https://www.facebook.com/sapp.edu.vn"
};
var ESSAY_TYPE = {
    WORD: "WORD",
    SHEET: "SHEET"
};
var GRADE_STATUS = {
    AWAITING_GRADING: "AWAITING_GRADING",
    FINISHED_GRADING: "FINISHED_GRADING"
};
var GRADING_METHOD = {
    MANUAL: "MANUAL",
    AUTO: "AUTO"
};
var FINISHED_TEST_TITLE = "Submitted Successfully";
var COMMON_TEXT_ENUM = {
    SUBMITED: "SUBMITED"
};
var CERTIFICATE_DETAIL = "/certificates/[id]";
var ENTRANCE_TEST_RESULT = "/entrance-test/test-result/[id]";
var ENTRANCE_TEST_TABLE_RESULT = "/entrance-test/table-result/[id]";
var SEARCH_EVENT_PLACEHOLDER = "Event name";
var PRIMARY_COLOR = "#FFB800";
var ANT_THEME_CONFIG = {
    token: {
        colorPrimary: PRIMARY_COLOR
    }
};
var POPUP_EVENT_DETAILS = {
    TITLE: "Event name",
    TIME: "Time",
    TYPE: "Event type",
    REPEAT: "Repeat",
    CLASSROOM_NAME: "Classroom name",
    CLASSROOM_ADDRESS: "Classroom address",
    MEETING_LINK: "Meeting link",
    DESCRIPTION: "Description"
};
var CALENDAR_SIDEBAR_TITLE = "Add Busy Schedule";
var CALENDAR_SIDEBAR_EVENT_FORM = {
    EVENT_NAME: "Event name",
    EVENT_TIME: "Start Time - end time",
    REPEAT: "Repeat",
    DESCRIPTION: "Description"
};
var EVENT_TYPES = {
    TEACHING: "TEACHING",
    BUSY: "BUSY",
    HOLIDAY: "HOLIDAY",
    OTHER: "OTHER",
    LIVE_ONLINE: "LIVE_ONLINE",
    INACTIVE: "INACTIVE"
};
var EVENT_TYPES_RESPONSE = {
    TEACHING: "TEACHING",
    BUSY: "BUSY",
    HOLIDAY: "HOLIDAY",
    OTHER: "OTHER",
    LIVE_ONLINE: "LIVE_ONLINE"
};
var EVENT_TYPES_ARRAY = Object.values(EVENT_TYPES);
var _obj;
var EVENT_TYPES_LABEL = (_obj = {}, (0,_define_property/* default */.Z)(_obj, EVENT_TYPES.TEACHING, "Teaching schedule"), (0,_define_property/* default */.Z)(_obj, EVENT_TYPES.BUSY, "Busy schedule"), (0,_define_property/* default */.Z)(_obj, EVENT_TYPES.HOLIDAY, "Holiday schedule"), (0,_define_property/* default */.Z)(_obj, EVENT_TYPES.OTHER, "Other calendar"), (0,_define_property/* default */.Z)(_obj, EVENT_TYPES.LIVE_ONLINE, ""), (0,_define_property/* default */.Z)(_obj, EVENT_TYPES.INACTIVE, ""), _obj);
var EVENT_TYPE_OPTIONS = Object.entries(EVENT_TYPES_LABEL).filter(function(param) {
    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], label = _param[1];
    return key !== EVENT_TYPES.LIVE_ONLINE;
}).map(function(param) {
    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
    return {
        value: key,
        label: value
    };
});
var EVENT_REPEAT_TYPES = {
    NO_REPEAT: "NO_REPEAT",
    DAILY: "DAILY",
    WEEKLY: "WEEKLY",
    MONTHLY: "MONTHLY",
    ANNUALLY: "ANNUALLY",
    EVERY_WEEKDAY: "EVERY_WEEKDAY",
    CUSTOM: "CUSTOM",
    CHOSEN_PATTERN: "CHOSEN_PATTERN"
};
var _obj1;
var EVENT_REPEAT_LABEL = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, EVENT_REPEAT_TYPES.NO_REPEAT, "Does not repeat"), (0,_define_property/* default */.Z)(_obj1, EVENT_REPEAT_TYPES.DAILY, "Daily"), (0,_define_property/* default */.Z)(_obj1, EVENT_REPEAT_TYPES.EVERY_WEEKDAY, "Every weekday (Monday to Friday)"), (0,_define_property/* default */.Z)(_obj1, EVENT_REPEAT_TYPES.CUSTOM, "Custom"), (0,_define_property/* default */.Z)(_obj1, EVENT_REPEAT_TYPES.WEEKLY, "Weekly"), (0,_define_property/* default */.Z)(_obj1, EVENT_REPEAT_TYPES.MONTHLY, "Monthly"), (0,_define_property/* default */.Z)(_obj1, EVENT_REPEAT_TYPES.ANNUALLY, "Annually"), _obj1);
var FREQUENCY_UNITS;
(function(FREQUENCY_UNITS) {
    FREQUENCY_UNITS["DAY"] = "days";
    FREQUENCY_UNITS["WEEK"] = "weeks";
    FREQUENCY_UNITS["MONTH"] = "months";
    FREQUENCY_UNITS["YEAR"] = "years";
})(FREQUENCY_UNITS || (FREQUENCY_UNITS = {}));
var FREQUENCY_UNITS_LABEL;
(function(FREQUENCY_UNITS_LABEL) {
    FREQUENCY_UNITS_LABEL["days"] = "Day";
    FREQUENCY_UNITS_LABEL["weeks"] = "Week";
    FREQUENCY_UNITS_LABEL["months"] = "Month";
    FREQUENCY_UNITS_LABEL["years"] = "Year";
})(FREQUENCY_UNITS_LABEL || (FREQUENCY_UNITS_LABEL = {}));
var FREQUENCY_UNITS_LABEL_PLURAL;
(function(FREQUENCY_UNITS_LABEL_PLURAL) {
    FREQUENCY_UNITS_LABEL_PLURAL["days"] = "Days";
    FREQUENCY_UNITS_LABEL_PLURAL["weeks"] = "Weeks";
    FREQUENCY_UNITS_LABEL_PLURAL["months"] = "Months";
    FREQUENCY_UNITS_LABEL_PLURAL["years"] = "Years";
})(FREQUENCY_UNITS_LABEL_PLURAL || (FREQUENCY_UNITS_LABEL_PLURAL = {}));
var _obj2;
var FREQUENCY_UNITS_OBJECT = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, FREQUENCY_UNITS.DAY, {
    label: FREQUENCY_UNITS.DAY,
    max: 365
}), (0,_define_property/* default */.Z)(_obj2, FREQUENCY_UNITS.WEEK, {
    label: FREQUENCY_UNITS.WEEK,
    max: 52
}), (0,_define_property/* default */.Z)(_obj2, FREQUENCY_UNITS.MONTH, {
    label: FREQUENCY_UNITS.MONTH,
    max: 12
}), (0,_define_property/* default */.Z)(_obj2, FREQUENCY_UNITS.YEAR, {
    label: FREQUENCY_UNITS.YEAR,
    max: 1
}), _obj2);
var FREQUENCY_OPTIONS = Object.entries(FREQUENCY_UNITS).map(function(param) {
    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
    return {
        value: value,
        label: FREQUENCY_UNITS_LABEL[value]
    };
});
var FREQUENCY_OPTIONS_PLURAL = Object.entries(FREQUENCY_UNITS).map(function(param) {
    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
    return {
        value: value,
        label: FREQUENCY_UNITS_LABEL_PLURAL[value]
    };
});
var _obj3;
var FREQUENCY_UNITS_LIMIT = {
    MIN: 1,
    MAX: (_obj3 = {}, (0,_define_property/* default */.Z)(_obj3, FREQUENCY_UNITS.DAY, 365), (0,_define_property/* default */.Z)(_obj3, FREQUENCY_UNITS.WEEK, 52), (0,_define_property/* default */.Z)(_obj3, FREQUENCY_UNITS.MONTH, 12), (0,_define_property/* default */.Z)(_obj3, FREQUENCY_UNITS.YEAR, 1), _obj3)
};
var REPEAT_ON = [
    "T2",
    "T3",
    "T4",
    "T5",
    "T6",
    "T7",
    "CN"
];
var REPEAT_ON_MAPPED = [
    "CN",
    "T2",
    "T3",
    "T4",
    "T5",
    "T6",
    "T7", 
];
var REPEAT_ON_MAPPED_PAYLOAD = {
    T2: 0,
    T3: 1,
    T4: 2,
    T5: 3,
    T6: 4,
    T7: 5,
    CN: 6
};
var CONFIRM_CANCEL = "Are you sure you want to cancel?";
var CONFIRM_DELETE = "Are you sure you want to delete?";
var CALENDAR_SIDEBAR_SAVE_BUTTON = "Save";
var CALENDAR_SIDEBAR_CANCEL_BUTTON = "Cancel";
var PROGRAM;
(function(PROGRAM) {
    PROGRAM["ACCA"] = "ACCA";
    PROGRAM["CFA"] = "CFA";
    PROGRAM["CMA"] = "CMA";
})(PROGRAM || (PROGRAM = {}));
var EXHIBIT_TEXT_REPLACE;
(function(EXHIBIT_TEXT_REPLACE) {
    EXHIBIT_TEXT_REPLACE["EXHIBIT"] = "Exhibit";
    EXHIBIT_TEXT_REPLACE["EXHIBIT_REPLACE"] = "Time Value Table";
})(EXHIBIT_TEXT_REPLACE || (EXHIBIT_TEXT_REPLACE = {}));
var ERROR_MESSAGE_TRIAL = "Sorry, you do not have access to this content";
var TEST_ATTEMPT_TYPE;
(function(TEST_ATTEMPT_TYPE) {
    TEST_ATTEMPT_TYPE["MID_TERM_TEST"] = "MID_TERM_TEST";
    TEST_ATTEMPT_TYPE["FINAL_TEST"] = "FINAL_TEST";
    TEST_ATTEMPT_TYPE["MOCK_TEST"] = "MOCK_TEST";
    TEST_ATTEMPT_TYPE["TOPIC_TEST"] = "TOPIC_TEST";
    TEST_ATTEMPT_TYPE["CHAPTER_TEST"] = "CHAPTER_TEST";
    TEST_ATTEMPT_TYPE["ENTRANCE_TEST"] = "ENTRANCE_TEST";
})(TEST_ATTEMPT_TYPE || (TEST_ATTEMPT_TYPE = {}));
var CALENDAR_COLOR_TYPES;
(function(CALENDAR_COLOR_TYPES) {
    CALENDAR_COLOR_TYPES["BLUE_COLOR"] = "TEACHING";
    CALENDAR_COLOR_TYPES["RED_COLOR"] = "BUSY";
    CALENDAR_COLOR_TYPES["YELLOW_COLOR"] = "HOLIDAY";
    CALENDAR_COLOR_TYPES["GREEN_COLOR"] = "OTHER";
    CALENDAR_COLOR_TYPES["PURPLE_COLOR"] = "LIVE_ONLINE";
})(CALENDAR_COLOR_TYPES || (CALENDAR_COLOR_TYPES = {}));
var CALENDAR_FILTER_TYPE;
(function(CALENDAR_FILTER_TYPE) {
    CALENDAR_FILTER_TYPE["HOLIDAY"] = "HOLIDAY";
    CALENDAR_FILTER_TYPE["OVERDUE"] = "OVERDUE";
    CALENDAR_FILTER_TYPE["ONLINE"] = "ONLINE";
    CALENDAR_FILTER_TYPE["LIVE_ONLINE"] = "LIVE_ONLINE";
    CALENDAR_FILTER_TYPE["OFFLINE"] = "OFFLINE";
    CALENDAR_FILTER_TYPE["CASE_STUDY"] = "CASE_STUDY";
    CALENDAR_FILTER_TYPE["KEY_BEFORE_CONTENT"] = "KEY_BEFORE_CONTENT";
    CALENDAR_FILTER_TYPE["TEST"] = "TEST";
})(CALENDAR_FILTER_TYPE || (CALENDAR_FILTER_TYPE = {}));
var _obj4;
var CALENDAR_FILTER_TYPE_LABEL = (_obj4 = {}, (0,_define_property/* default */.Z)(_obj4, CALENDAR_FILTER_TYPE.HOLIDAY, "Holiday"), (0,_define_property/* default */.Z)(_obj4, CALENDAR_FILTER_TYPE.OVERDUE, "Overdue"), (0,_define_property/* default */.Z)(_obj4, CALENDAR_FILTER_TYPE.ONLINE, "Online"), (0,_define_property/* default */.Z)(_obj4, CALENDAR_FILTER_TYPE.LIVE_ONLINE, "Live Online"), (0,_define_property/* default */.Z)(_obj4, CALENDAR_FILTER_TYPE.OFFLINE, "Offline"), (0,_define_property/* default */.Z)(_obj4, CALENDAR_FILTER_TYPE.CASE_STUDY, "Case Study"), (0,_define_property/* default */.Z)(_obj4, CALENDAR_FILTER_TYPE.KEY_BEFORE_CONTENT, "Key Before Content"), (0,_define_property/* default */.Z)(_obj4, CALENDAR_FILTER_TYPE.TEST, "Test"), _obj4);
var LEARNING_USER_STATUS = {
    READY_TO_LEARN: "READY_TO_LEARN",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETED: "COMPLETED"
};
var CALENDAR_TYPE = {
    LMS: "LMS",
    OPS: "OPS"
};
var PDF_VIEWER_URL = "https://mozilla.github.io/pdf.js/web/viewer.html";
var OFFICE_VIEWER_URL = "https://view.officeapps.live.com/op/embed.aspx";

var QUIZ_ATTEMPT_STATUS;
(function(QUIZ_ATTEMPT_STATUS) {
    QUIZ_ATTEMPT_STATUS["SUBMITTED"] = "SUBMITTED";
    QUIZ_ATTEMPT_STATUS["UN_SUBMITTED"] = "UN_SUBMITTED";
    QUIZ_ATTEMPT_STATUS["IN_PROGRESS"] = "IN_PROGRESS";
})(QUIZ_ATTEMPT_STATUS || (QUIZ_ATTEMPT_STATUS = {}));
var QUIZ_ATTEMPT_GRADING_STATUS;
(function(QUIZ_ATTEMPT_GRADING_STATUS) {
    QUIZ_ATTEMPT_GRADING_STATUS["DRAFT"] = "DRAFT";
    QUIZ_ATTEMPT_GRADING_STATUS["FINISHED"] = "FINISHED";
    QUIZ_ATTEMPT_GRADING_STATUS["UN_FINISHED"] = "UN_FINISHED";
    QUIZ_ATTEMPT_GRADING_STATUS["AWAITING_GRADING"] = "AWAITING_GRADING";
    QUIZ_ATTEMPT_GRADING_STATUS["FINISHED_GRADING"] = "FINISHED_GRADING";
})(QUIZ_ATTEMPT_GRADING_STATUS || (QUIZ_ATTEMPT_GRADING_STATUS = {}));
var DATE_FORMAT;
(function(DATE_FORMAT) {
    DATE_FORMAT["DATE_TIME"] = "HH:mm | DD/MM/YYYY";
    DATE_FORMAT["DATE_TIME_DASH"] = "HH:mm - DD/MM/YYYY";
    DATE_FORMAT["DATE"] = "DD/MM/YYYY";
})(DATE_FORMAT || (DATE_FORMAT = {}));
var COOKIE_INFO = {
    SESSION_ID: "sessionId",
    KEYCLOAK_USER_ID: "keycloakUserId",
    KEYCLOAK_TOKEN: "keycloakToken",
    KEYCLOAK_REFRESH_TOKEN: "keycloakRefreshToken"
};
var LABEL_MAX_LENGTH = 12;
var DELAY_TIME_DISPLAY_POPUP = 2000 // 2s
;








/***/ }),

/***/ 66190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EQ": function() { return /* binding */ MY_COURSES; },
/* harmony export */   "ZD": function() { return /* binding */ LANG_SIGNIN; }
/* harmony export */ });
/* unused harmony exports DESCRIPTION_POPUPCONFIRM, DELETE_POPUPCONFIRM, DUPLICATE_POPUPCONFIRM, CONFIRM_STATUS_CHANGE, ACTIVE_POPUPCONFIRM, DEACTIVE_POPUPCONFIRM, REFRESH_POPUPCONFIRM */
var LANG_SIGNIN = {
    signIn: "Sign In",
    SAPPAcademy: "SAPP Academy Operations",
    signInGoogle: "Sign in with Google",
    signInApple: "Sign in with Apple",
    orWithEmail: "Or with email",
    email: "Email",
    password: "Password",
    forgotPassword: "Forgot password ?",
    notMember: "Not a Member yet?",
    signUp: "Sign up",
    english: "English",
    japanese: "Japanese",
    german: "German",
    spanish: "Spanish",
    french: "French",
    terms: "Terms",
    plans: "Plans",
    contactUs: "Contact Us",
    eventTest: "Event Test"
};
var MY_COURSES = {
    explanations: "Explanations",
    hotline: "19002225",
    placeholderSearch: "Search for your course here",
    placeholderSearch3Level: "Enter name of course..."
};
var DESCRIPTION_POPUPCONFIRM = "Bạn c\xf3 chắc chắn muốn hủy kh\xf4ng?";
var DELETE_POPUPCONFIRM = "Bạn c\xf3 chắc chắn muốn x\xf3a kh\xf4ng?";
var DUPLICATE_POPUPCONFIRM = "Bạn c\xf3 chắc chắn muốn sao ch\xe9p kh\xf4ng?";
var CONFIRM_STATUS_CHANGE = "Bạn c\xf3 chắc chắn muốn đổi trạng th\xe1i kh\xf4ng?";
var ACTIVE_POPUPCONFIRM = "Bạn c\xf3 muốn k\xedch hoạt chức năng kh\xf4ng?";
var DEACTIVE_POPUPCONFIRM = "Bạn c\xf3 muốn dừng k\xedch hoạt chức năng kh\xf4ng?";
var REFRESH_POPUPCONFIRM = "Bạn c\xf3 muốn l\xe0m mới chức năng kh\xf4ng?";


/***/ }),

/***/ 4522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GS": function() { return /* binding */ requestStatusToTitle; },
/* harmony export */   "J_": function() { return /* binding */ REQUEST_STATUS; },
/* harmony export */   "Nc": function() { return /* binding */ requestTypeToTitle; },
/* harmony export */   "V5": function() { return /* binding */ OPTIONS_REQUEST_STATUS; },
/* harmony export */   "XN": function() { return /* binding */ REQUEST_TYPE; },
/* harmony export */   "XO": function() { return /* binding */ OPTIONS_PERSONAL_SCHEDULE_REQUEST_TYPE; },
/* harmony export */   "_U": function() { return /* binding */ requestStatusToBadge; },
/* harmony export */   "pF": function() { return /* binding */ OPTIONS_TIME_OFF_REQUEST_TYPE; }
/* harmony export */ });
/* unused harmony export DRAWER_REQUEST_TYPE */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67796);

var DRAWER_REQUEST_TYPE;
(function(DRAWER_REQUEST_TYPE) {
    DRAWER_REQUEST_TYPE["PERSONAL_SCHEDULE"] = "PERSONAL_SCHEDULE";
    DRAWER_REQUEST_TYPE["TIMEOFF"] = "TIMEOFF";
})(DRAWER_REQUEST_TYPE || (DRAWER_REQUEST_TYPE = {}));
var REQUEST_TYPE;
(function(REQUEST_TYPE) {
    REQUEST_TYPE["TEACHING_MODE"] = "TEACHING_MODE";
    REQUEST_TYPE["TEACHER_SCHEDULE_BUSY"] = "TEACHER_SCHEDULE_BUSY";
    REQUEST_TYPE["TEACHER_SCHEDULE_TIME_OFF"] = "TEACHER_SCHEDULE_TIME_OFF";
    REQUEST_TYPE["TEACHER_OTHER"] = "TEACHER_OTHER";
    REQUEST_TYPE["TEACHER_WEEKLY_NORMS"] = "TEACHER_WEEKLY_NORMS";
})(REQUEST_TYPE || (REQUEST_TYPE = {}));
var REQUEST_STATUS;
(function(REQUEST_STATUS) {
    REQUEST_STATUS["PENDING"] = "PENDING";
    REQUEST_STATUS["REJECT"] = "REJECT";
    REQUEST_STATUS["CANCEL"] = "CANCEL";
    REQUEST_STATUS["APPROVED"] = "APPROVED";
})(REQUEST_STATUS || (REQUEST_STATUS = {}));
var _obj;
var requestStatusToTitle = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, REQUEST_STATUS.APPROVED, "Approved"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, REQUEST_STATUS.PENDING, "Pending"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, REQUEST_STATUS.REJECT, "Rejected"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, REQUEST_STATUS.CANCEL, "Canceled"), _obj);
var _obj1;
var requestTypeToTitle = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, REQUEST_TYPE.TEACHING_MODE, "Xin đổi h\xecnh thức"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, REQUEST_TYPE.TEACHER_SCHEDULE_BUSY, "Busy schedule"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, REQUEST_TYPE.TEACHER_SCHEDULE_TIME_OFF, "Xin nghỉ"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, REQUEST_TYPE.TEACHER_WEEKLY_NORMS, "Weekly norm"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, REQUEST_TYPE.TEACHER_OTHER, "Lịch kh\xe1c"), _obj1);
var _obj2;
var requestStatusToBadge = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, REQUEST_STATUS.APPROVED, {
    type: "success",
    label: requestStatusToTitle[REQUEST_STATUS.APPROVED]
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, REQUEST_STATUS.PENDING, {
    type: "warning",
    label: requestStatusToTitle[REQUEST_STATUS.PENDING]
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, REQUEST_STATUS.REJECT, {
    type: "error",
    label: requestStatusToTitle[REQUEST_STATUS.REJECT]
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, REQUEST_STATUS.CANCEL, {
    type: "default",
    label: requestStatusToTitle[REQUEST_STATUS.CANCEL]
}), _obj2);
var OPTIONS_PERSONAL_SCHEDULE_REQUEST_TYPE = [
    {
        label: "Busy schedule",
        value: REQUEST_TYPE.TEACHER_SCHEDULE_BUSY
    },
    {
        label: "Weekly norm",
        value: REQUEST_TYPE.TEACHER_WEEKLY_NORMS
    }, 
];
var OPTIONS_TIME_OFF_REQUEST_TYPE = [
    {
        label: "Timeoff",
        value: REQUEST_TYPE.TEACHER_SCHEDULE_TIME_OFF
    },
    {
        label: "Teaching mode change",
        value: REQUEST_TYPE.TEACHING_MODE
    }, 
];
var OPTIONS_REQUEST_STATUS = [
    {
        label: requestStatusToTitle[REQUEST_STATUS.PENDING],
        value: REQUEST_STATUS.PENDING
    },
    {
        label: requestStatusToTitle[REQUEST_STATUS.REJECT],
        value: REQUEST_STATUS.REJECT
    },
    {
        label: requestStatusToTitle[REQUEST_STATUS.APPROVED],
        value: REQUEST_STATUS.APPROVED
    },
    {
        label: requestStatusToTitle[REQUEST_STATUS.CANCEL],
        value: REQUEST_STATUS.CANCEL
    }, 
];


/***/ }),

/***/ 66268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePinnedNotifyContext; },
/* harmony export */   "r": function() { return /* binding */ PinnedNotifyProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52621);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15183);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71836);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45332);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34376);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82684);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43743);
/* harmony import */ var src_redux_services_User_user__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39421);











// initContext
var initContext = {
    openPinned: true,
    setOpenPinned: function() {
        return true;
    },
    pinnedNotifications: {
        data: {
            action: "",
            content: "",
            created_at: "",
            created_by: "",
            created_from: "",
            deleted_at: "",
            id: "",
            mode: "",
            send_finish_time: "",
            send_time: "",
            status: "",
            title: "",
            type: "",
            updated_at: ""
        }
    },
    getPinnedData: function() {}
};
var PinnedNotifyContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_5__.createContext)(initContext);
function PinnedNotifyProvider(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(true), openPinned = ref[0], setOpenPinned = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)({
        data: {
            action: "",
            content: "",
            created_at: "",
            created_by: "",
            created_from: "",
            deleted_at: "",
            id: "",
            mode: "",
            send_finish_time: "",
            send_time: "",
            status: "",
            title: "",
            type: "",
            updated_at: ""
        }
    }), pinnedNotifications = ref1[0], setPinnedNotifications = ref1[1];
    var getPinnedData = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var ref, res, oldPinnedId, oldPinnedFlag, ref1, ref2, pin_start, unix_pin_start, pin_end, unix_pin_end, now, unix_now, ref3, ref4;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            src_redux_services_User_user__WEBPACK_IMPORTED_MODULE_7__/* ["default"].getPinnedNotifications */ .Z.getPinnedNotifications()
                        ];
                    case 1:
                        res = _state.sent();
                        oldPinnedId = (0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .getLocalStorageItem */ .le)("pinnedId");
                        oldPinnedFlag = (0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .getLocalStorageItem */ .le)("openPinned");
                        if (oldPinnedId !== (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.id) || Boolean(oldPinnedFlag === "true")) {
                            ;
                            pin_start = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .convertUTCToLocalTime */ .FK)(res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.send_time);
                            unix_pin_start = pin_start.getTime();
                            pin_end = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .convertUTCToLocalTime */ .FK)(res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : ref2.send_finish_time);
                            unix_pin_end = pin_end.getTime();
                            now = new Date();
                            unix_now = now.getTime();
                            // * Kiểm tra thời gian pin có hợp lệ để show cho client
                            if (unix_pin_start <= unix_now && unix_now <= unix_pin_end) {
                                ;
                                setPinnedNotifications(res);
                                setOpenPinned(true);
                                (0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .setLocalStorageItem */ .D$)("pinnedId", res === null || res === void 0 ? void 0 : (ref3 = res.data) === null || ref3 === void 0 ? void 0 : ref3.id);
                                (0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .setLocalStorageItem */ .D$)("openPinned", "true");
                                (0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .setLocalStorageItem */ .D$)("pinnedStatus", res === null || res === void 0 ? void 0 : (ref4 = res.data) === null || ref4 === void 0 ? void 0 : ref4.status);
                            }
                        } else {
                            if (Boolean(oldPinnedFlag === "false")) {
                                setOpenPinned(false);
                            } else {
                                setOpenPinned(true);
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function getPinnedData() {
            return _ref.apply(this, arguments);
        };
    }();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (![
            src_constants__WEBPACK_IMPORTED_MODULE_6__/* .ENTRANCE_TEST_TABLE_RESULT */ .IO,
            src_constants__WEBPACK_IMPORTED_MODULE_6__/* .ENTRANCE_TEST_RESULT */ .WD,
            _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .CERTIFICATE_DETAIL */ .JJ, 
        ].includes(router.pathname)) {
            getPinnedData();
        }
    }, [
        router.pathname
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PinnedNotifyContext.Provider, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        value: {
            openPinned: openPinned,
            setOpenPinned: setOpenPinned,
            pinnedNotifications: pinnedNotifications,
            getPinnedData: getPinnedData
        }
    }, props));
}
function usePinnedNotifyContext() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(PinnedNotifyContext);
    if (!context) {
        throw new Error("Error!");
    }
    return context;
}


/***/ }),

/***/ 56074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useStaticModalContext; },
/* harmony export */   "g": function() { return /* binding */ StaticModalProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21967);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);



var StaticModalContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var StaticModalProvider = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isVisibleGotoModal = ref[0], setVisibleGotoModal = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isVisibleRedirectModal = ref1[0], setVisibleRedirectModal = ref1[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StaticModalContext.Provider, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        value: {
            isVisibleGotoModal: isVisibleGotoModal,
            setVisibleGotoModal: setVisibleGotoModal,
            isVisibleRedirectModal: isVisibleRedirectModal,
            setVisibleRedirectModal: setVisibleRedirectModal
        }
    }, props));
};
var useStaticModalContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(StaticModalContext);
    if (!context) {
        throw new Error("Error!");
    }
    return context;
};


/***/ }),

/***/ 44446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ CourseProvider; },
/* harmony export */   "Y": function() { return /* binding */ useCourseContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52621);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34376);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82684);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43743);
/* harmony import */ var src_pages_api_event_test__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80926);








// initContext
var initContext = {
    openPopupCongrats: false,
    setOpenPopupCongrats: function() {},
    courseType: "",
    setCourseType: function() {},
    scoreQuestion: 0,
    setScoreQuestion: function() {},
    submitTest: false,
    setSubmitTest: function() {},
    submitEventTest: false,
    setSubmitEventTest: function() {},
    showPinnedTrial: false,
    setShowPinnedTrial: function() {},
    openPopupCTA: {
        lockSection: false,
        ctaUpgrade: false,
        thankYou: false,
        thankYouLater: false
    },
    setOpenPopupCTA: function() {},
    isOpenSidebar: false,
    setOpenSidebar: function() {}
};
var CourseContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)(initContext);
function CourseProvider(props) {
    /**
   * @description state này để xác định mở popup khi làm xong bài Final Test
   */ var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), openPopupCongrats = ref[0], setOpenPopupCongrats = ref[1];
    /**
   * @description state này để xác định type của khóa học
   */ var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), courseType = ref1[0], setCourseType = ref1[1];
    /**
   * @description state này lưu điểm của của bài Final Test
   */ var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), scoreQuestion = ref2[0], setScoreQuestion = ref2[1];
    /**
   * @description state này bằng true khi submit bài test
   */ var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), submitTest = ref3[0], setSubmitTest = ref3[1];
    /**
   * @description state này bằng true khi submit bài test
   */ var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), submitEventTest = ref4[0], setSubmitEventTest = ref4[1];
    /**
   * @description state này bằng true khi hiển thị form hubspot
   */ var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showPinnedTrial = ref5[0], setShowPinnedTrial = ref5[1];
    /**
   * @description state này bằng true khi hiển thị form hubspot
   */ var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        lockSection: false,
        ctaUpgrade: false,
        thankYou: false,
        thankYouLater: false
    }), openPopupCTA = ref6[0], setOpenPopupCTA = ref6[1];
    /**
   * @description state này bằng true khi hiển thị form hubspot
   */ var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpenSidebar = ref7[0], setOpenSidebar = ref7[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    function fetchEventTest() {
        return _fetchEventTest.apply(this, arguments);
    }
    function _fetchEventTest() {
        _fetchEventTest = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
            var res, ref;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            src_pages_api_event_test__WEBPACK_IMPORTED_MODULE_4__/* .EventTestAPI.get */ .H.get({})
                        ];
                    case 1:
                        res = _state.sent();
                        if (res.success) {
                            ;
                            localStorage.setItem("countEvent", res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.length);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _fetchEventTest.apply(this, arguments);
    }
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (![
            src_constants__WEBPACK_IMPORTED_MODULE_3__/* .ENTRANCE_TEST_RESULT */ .WD,
            src_constants__WEBPACK_IMPORTED_MODULE_3__/* .CERTIFICATE_DETAIL */ .JJ,
            src_constants__WEBPACK_IMPORTED_MODULE_3__/* .ENTRANCE_TEST_TABLE_RESULT */ .IO, 
        ].includes(router.pathname)) {
            fetchEventTest();
        }
    }, []);
    var contextValue = react__WEBPACK_IMPORTED_MODULE_2__.useMemo(function() {
        return {
            openPopupCongrats: openPopupCongrats,
            setOpenPopupCongrats: setOpenPopupCongrats,
            setCourseType: setCourseType,
            courseType: courseType,
            scoreQuestion: scoreQuestion,
            setScoreQuestion: setScoreQuestion,
            setSubmitTest: setSubmitTest,
            submitTest: submitTest,
            submitEventTest: submitEventTest,
            setSubmitEventTest: setSubmitEventTest,
            setShowPinnedTrial: setShowPinnedTrial,
            showPinnedTrial: showPinnedTrial,
            openPopupCTA: openPopupCTA,
            setOpenPopupCTA: setOpenPopupCTA,
            isOpenSidebar: isOpenSidebar,
            setOpenSidebar: setOpenSidebar
        };
    }, [
        openPopupCongrats,
        setOpenPopupCongrats,
        setCourseType,
        courseType,
        scoreQuestion,
        setScoreQuestion,
        setSubmitTest,
        submitTest,
        submitEventTest,
        setSubmitEventTest,
        setShowPinnedTrial,
        showPinnedTrial,
        openPopupCTA,
        setOpenPopupCTA,
        isOpenSidebar,
        setOpenSidebar, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CourseContext.Provider, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        value: contextValue
    }, props));
}
function useCourseContext() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(CourseContext);
    if (!context) {
        throw new Error("Error!");
    }
    return context;
}


/***/ }),

/***/ 79350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34376);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);




var useDynamicLoading = function(getData, pageSize) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(pageSize), page = ref1[0], setPage = ref1[1];
    var loadMoreOptions = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                if (isLoading) return [
                    2
                ];
                setIsLoading(true);
                try {
                    // Fetch additional items from the API with an increased page_size
                    getData(page);
                    setPage(page + pageSize);
                } catch (error) {} finally{
                    setIsLoading(false);
                }
                return [
                    2
                ];
            });
        });
        return function loadMoreOptions() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleMenuScrollToBottom = function(param) {
        var target = param.target;
        // Check if the user has scrolled to the bottom of the menu
        if (target.scrollHeight - target.scrollTop === target.clientHeight) {
            // Load more options when scrolling to the bottom
            loadMoreOptions();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // Load initial options when the component mounts
        if (router.query.courseId || router.query.id) {
            loadMoreOptions();
        }
    }, []);
    return {
        isLoading: isLoading,
        handleMenuScrollToBottom: handleMenuScrollToBottom,
        setPage: setPage
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useDynamicLoading);


/***/ }),

/***/ 87177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ useNotification; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52621);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34376);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_pages_api_notification__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18015);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10103);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43743);
/* harmony import */ var src_redux_hook__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34705);
/* harmony import */ var src_redux_slice_Notification_Notification__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9747);
/* harmony import */ var src_hooks_useTailwindBreakpoint__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8543);











var useNotification = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var dispatch = (0,src_redux_hook__WEBPACK_IMPORTED_MODULE_5__/* .useAppDispatch */ .T)();
    var notifyDetail = (0,src_redux_hook__WEBPACK_IMPORTED_MODULE_5__/* .useAppSelector */ .C)(function(state) {
        return state.notificationReducer;
    });
    var notifyLists = (0,src_redux_hook__WEBPACK_IMPORTED_MODULE_5__/* .useAppSelector */ .C)(function(state) {
        return state.notificationReducer.list_notifications;
    });
    var pagination = (0,src_redux_hook__WEBPACK_IMPORTED_MODULE_5__/* .useAppSelector */ .C)(function(state) {
        return state.notificationReducer.meta;
    });
    var isAlwaysShowSidebar = (0,src_hooks_useTailwindBreakpoint__WEBPACK_IMPORTED_MODULE_7__/* .useTailwindBreakpoint */ ._)().isAlwaysShowSidebar;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isDesktopView = ref[0], setIsDesktopView = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isViewDetail = ref1[0], setIsViewDetail = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), openNotification = ref2[0], setOpenNotification = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(1), selectedTab = ref3[0], setSelectedTab = ref3[1];
    var storedCount = localStorage.getItem(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .LOCAL_STORAGE_KEYS.NOTIFICATION_COUNT */ .dA.NOTIFICATION_COUNT);
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function() {
        return parseInt(storedCount !== null && storedCount !== void 0 ? storedCount : "0", 10);
    }), notificationUnread = ref4[0], setNotificationUnread = ref4[1];
    var scrollRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var isFetching = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var refreshNotification = function() {
        var isRefresh = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var getNotifications = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(params) {
                var _tmp, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            _tmp = isRefresh;
                            if (!_tmp) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                dispatch((0,src_redux_slice_Notification_Notification__WEBPACK_IMPORTED_MODULE_6__/* .getCountUnRead */ .xU)())
                            ];
                        case 1:
                            _tmp = _state.sent();
                            _state.label = 2;
                        case 2:
                            _tmp;
                            return [
                                4,
                                dispatch((0,src_redux_slice_Notification_Notification__WEBPACK_IMPORTED_MODULE_6__/* .getNotification */ .v6)(params))
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 4:
                            error = _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getNotifications(params) {
                return _ref.apply(this, arguments);
            };
        }();
        getNotifications((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
            page_index: 1,
            page_size: 10
        }, selectedTab === 2 && {
            is_read: false
        }));
    };
    var countNotificationsUnRead = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            dispatch((0,src_redux_slice_Notification_Notification__WEBPACK_IMPORTED_MODULE_6__/* .getCountUnRead */ .xU)())
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function countNotificationsUnRead() {
            return _ref.apply(this, arguments);
        };
    }();
    var markAllRead = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            dispatch((0,src_redux_slice_Notification_Notification__WEBPACK_IMPORTED_MODULE_6__/* .markAllNotifications */ .yu)())
                        ];
                    case 1:
                        _state.sent();
                        dispatch((0,src_redux_slice_Notification_Notification__WEBPACK_IMPORTED_MODULE_6__/* .updateStatusAll */ .Zw)());
                        return [
                            4,
                            countNotificationsUnRead()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function markAllRead() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleMarkAll = function() {
        setOpenNotification(false);
        markAllRead();
    };
    var handleMarkById = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(ids) {
            var res, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            src_pages_api_notification__WEBPACK_IMPORTED_MODULE_2__/* .NotificationAPI.markById */ .T.markById(ids, true)
                        ];
                    case 1:
                        res = _state.sent();
                        if (!(res === null || res === void 0 ? void 0 : res.data)) {
                            return [
                                2
                            ];
                        }
                        refreshNotification(true);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleMarkById(ids) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUnMarkById = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(ids) {
            var res, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            src_pages_api_notification__WEBPACK_IMPORTED_MODULE_2__/* .NotificationAPI.markById */ .T.markById(ids, false)
                        ];
                    case 1:
                        res = _state.sent();
                        if (!(res === null || res === void 0 ? void 0 : res.data)) {
                            return [
                                2
                            ];
                        }
                        refreshNotification(true);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleUnMarkById(ids) {
            return _ref.apply(this, arguments);
        };
    }();
    var getApiNotificationDetail = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(id, redirect, content) {
            var res, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        if (!(id !== (notifyDetail === null || notifyDetail === void 0 ? void 0 : notifyDetail.id))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            dispatch((0,src_redux_slice_Notification_Notification__WEBPACK_IMPORTED_MODULE_6__/* .getNotificationDetail */ .uy)(id))
                        ];
                    case 1:
                        res = _state.sent();
                        if (!res) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            countNotificationsUnRead()
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        if (!(0,lodash__WEBPACK_IMPORTED_MODULE_3__.isEmpty)(redirect)) {
                            router.replace("/".concat(content));
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function getApiNotificationDetail(id, redirect, content) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleViewDetail = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(id, redirect, content, tag) {
            var regexTagA, containsAnchorTag;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getApiNotificationDetail(id, redirect !== null && redirect !== void 0 ? redirect : null, content !== null && content !== void 0 ? content : "")
                        ];
                    case 1:
                        _state.sent();
                        regexTagA = /<a\b[^>]*>(.*?)<\/a>/;
                        containsAnchorTag = regexTagA.test(content !== null && content !== void 0 ? content : "");
                        if (containsAnchorTag && tag === "STRONG") {
                            setIsViewDetail(false);
                        } else if (!(0,lodash__WEBPACK_IMPORTED_MODULE_3__.isEmpty)(redirect)) {
                            setOpenNotification(false);
                        } else if ((0,lodash__WEBPACK_IMPORTED_MODULE_3__.isEmpty)(redirect)) {
                            setIsViewDetail(function(prev) {
                                return !prev;
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleViewDetail(id, redirect, content, tag) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleBack = function() {
        if (isDesktopView) {
            setIsViewDetail(false);
            refreshNotification(true);
        } else {
            if (isViewDetail) {
                setIsViewDetail(false);
            } else {
                setOpenNotification(false);
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (openNotification) refreshNotification(false);
    }, [
        selectedTab
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleScroll = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                var scrollEl, scrollTop, scrollHeight, clientHeight, page_index, page_size, total_pages, err;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            scrollEl = scrollRef.current;
                            if (!scrollEl) return [
                                3,
                                6
                            ];
                            scrollTop = scrollEl.scrollTop, scrollHeight = scrollEl.scrollHeight, clientHeight = scrollEl.clientHeight;
                            if (!(scrollTop + clientHeight + 200 >= scrollHeight)) return [
                                3,
                                6
                            ];
                            page_index = pagination.page_index, page_size = pagination.page_size, total_pages = pagination.total_pages;
                            if (page_index >= total_pages || isFetching.current) return [
                                2
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                5,
                                6
                            ]);
                            isFetching.current = true;
                            return [
                                4,
                                dispatch((0,src_redux_slice_Notification_Notification__WEBPACK_IMPORTED_MODULE_6__/* .loadMoreNotification */ .hj)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                                    page_index: page_index + 1,
                                    page_size: page_size
                                }, selectedTab === 2 && {
                                    is_read: false
                                })))
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                countNotificationsUnRead()
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                6
                            ];
                        case 4:
                            err = _state.sent();
                            return [
                                3,
                                6
                            ];
                        case 5:
                            isFetching.current = false;
                            return [
                                7
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function handleScroll() {
                return _ref.apply(this, arguments);
            };
        }();
        var scrollEl = scrollRef.current;
        scrollEl === null || scrollEl === void 0 ? void 0 : scrollEl.addEventListener("scroll", handleScroll);
        return function() {
            scrollEl === null || scrollEl === void 0 ? void 0 : scrollEl.removeEventListener("scroll", handleScroll);
        };
    }, [
        pagination
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isAlwaysShowSidebar) setIsDesktopView(true);
    }, [
        isAlwaysShowSidebar
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        window.addEventListener("storage", function(e) {
            var count = localStorage.getItem(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .LOCAL_STORAGE_KEYS.NOTIFICATION_COUNT */ .dA.NOTIFICATION_COUNT);
            setNotificationUnread(parseInt(count !== null && count !== void 0 ? count : "0", 10));
        });
        return function() {
            return window.removeEventListener("storage", function() {});
        };
    }, []);
    return {
        isViewDetail: isViewDetail,
        openNotification: openNotification,
        setOpenNotification: setOpenNotification,
        selectedTab: selectedTab,
        setSelectedTab: setSelectedTab,
        notifyDetail: notifyDetail,
        notifyLists: notifyLists,
        scrollRef: scrollRef,
        notificationUnread: notificationUnread,
        handleMarkAll: handleMarkAll,
        handleMarkById: handleMarkById,
        handleUnMarkById: handleUnMarkById,
        handleViewDetail: handleViewDetail,
        handleBack: handleBack,
        refreshNotification: refreshNotification,
        isDesktopView: isDesktopView
    };
};


/***/ }),

/***/ 8543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useTailwindBreakpoint; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);

var TAILWIND_BREAKPOINTS = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    "2xl": 1536,
    "3xl": 1728,
    "4xl": 1920
};
var useTailwindBreakpoint = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("base"), breakpoint = ref[0], setBreakpoint = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleResize = function() {
            var width = window.innerWidth;
            if (width >= TAILWIND_BREAKPOINTS["4xl"]) setBreakpoint("4xl");
            else if (width >= TAILWIND_BREAKPOINTS["3xl"]) setBreakpoint("3xl");
            else if (width >= TAILWIND_BREAKPOINTS["2xl"]) setBreakpoint("2xl");
            else if (width >= TAILWIND_BREAKPOINTS["xl"]) setBreakpoint("xl");
            else if (width >= TAILWIND_BREAKPOINTS["lg"]) setBreakpoint("lg");
            else if (width >= TAILWIND_BREAKPOINTS["md"]) setBreakpoint("md");
            else if (width >= TAILWIND_BREAKPOINTS["sm"]) setBreakpoint("sm");
            else setBreakpoint("base");
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    var isAlwaysShowSidebar = [
        "lg",
        "xl",
        "2xl",
        "3xl",
        "4xl"
    ].includes(breakpoint);
    var isShowMenuContent = [
        "base",
        "sm",
        "md"
    ].includes(breakpoint);
    var isMobileView = [
        "base",
        "sm"
    ].includes(breakpoint);
    var isTabletView = [
        "md"
    ].includes(breakpoint);
    return {
        isAlwaysShowSidebar: isAlwaysShowSidebar,
        isShowMenuContent: isShowMenuContent,
        breakpoint: breakpoint,
        isMobileView: isMobileView,
        isTabletView: isTabletView
    };
};


/***/ }),

/***/ 71470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; },
  "excludedPathsHelp": function() { return /* binding */ excludedPathsHelp; }
});

// NAMESPACE OBJECT: ./node_modules/socket.io-parser/build/esm/index.js
var socket_io_parser_build_esm_namespaceObject = {};
__webpack_require__.r(socket_io_parser_build_esm_namespaceObject);
__webpack_require__.d(socket_io_parser_build_esm_namespaceObject, {
  "Decoder": function() { return Decoder; },
  "Encoder": function() { return Encoder; },
  "PacketType": function() { return PacketType; },
  "protocol": function() { return build_esm_protocol; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(21967);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
// EXTERNAL MODULE: ./src/utils/google-analytics.ts
var google_analytics = __webpack_require__(72158);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./src/components/BackToTop.tsx
/* eslint-disable */ 


var BackToTop = function() {
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    (0,react.useEffect)(function() {
        /**
     * @description Listen to scroll events
     */ window.addEventListener("scroll", handleScroll);
        /**
     * @description Remove event listener on cleanup
     */ return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    /**
   * @description Function to handle scroll event
   */ var handleScroll = function() {
        var scrollY = window.scrollY;
        /**
     * @description Set visibility based on scroll position
     */ if (scrollY > 50) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };
    /**
   * @description Function to scroll back to top
   */ var scrollToTop = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        (0,google_analytics/* trackGAEvent */.wu)("Click Button Back To Top");
    };
    (0,react.useEffect)(function() {
        if (window.scrollY === 0) {
            setIsVisible(false);
        }
    }, [
        window.scrollY
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "back-to-top",
        className: "fixed bottom-[160px] right-[27px] rounded-[50%] text-white ".concat(isVisible ? "visible " : "hidden", " cursor-pointer"),
        onClick: scrollToTop,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex h-[40px] w-[40px] items-center justify-center self-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "48",
                height: "48",
                viewBox: "0 0 48 48",
                fill: "#33475B",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M34.9991 10.0005H12.9997C12.8658 9.99637 12.7325 10.0192 12.6076 10.0676C12.4827 10.116 12.3688 10.189 12.2726 10.2822C12.1765 10.3755 12.1001 10.4871 12.0479 10.6104C11.9956 10.7338 11.9688 10.8664 11.9688 11.0003C11.9688 11.1343 11.9956 11.2668 12.0479 11.3902C12.1001 11.5135 12.1765 11.6251 12.2726 11.7184C12.3688 11.8116 12.4827 11.8846 12.6076 11.933C12.7325 11.9814 12.8658 12.0043 12.9997 12.0002H34.9991C35.1329 12.0043 35.2663 11.9814 35.3912 11.933C35.5161 11.8846 35.6299 11.8116 35.7261 11.7184C35.8222 11.6251 35.8987 11.5135 35.9509 11.3902C36.0031 11.2668 36.03 11.1343 36.03 11.0003C36.03 10.8664 36.0031 10.7338 35.9509 10.6104C35.8987 10.4871 35.8222 10.3755 35.7261 10.2822C35.6299 10.189 35.5161 10.116 35.3912 10.0676C35.2663 10.0192 35.1329 9.99637 34.9991 10.0005Z",
                        fill: "#33475B"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M24.8126 17.42C24.7203 17.2904 24.5984 17.1847 24.457 17.1116C24.3156 17.0386 24.1589 17.0003 23.9998 17C23.847 17 23.6963 17.0351 23.5593 17.1026C23.4223 17.17 23.3026 17.268 23.2094 17.3891L17.7063 22.8931C17.5188 23.0811 17.4137 23.3358 17.4141 23.6013C17.4144 23.8668 17.5202 24.1213 17.7082 24.3088C17.8962 24.4962 18.1509 24.6013 18.4164 24.601C18.6819 24.6006 18.9363 24.4948 19.1238 24.3069L23.0013 20.4294L22.9844 33.0003C22.9843 33.1317 23.0101 33.2618 23.0602 33.3832C23.1104 33.5046 23.184 33.6149 23.2768 33.7079C23.3696 33.8009 23.4798 33.8747 23.6011 33.9251C23.7224 33.9754 23.8524 34.0014 23.9838 34.0016C24.2494 34.0016 24.504 33.8961 24.6918 33.7083C24.8796 33.5205 24.9851 33.2659 24.9851 33.0003L24.9963 20.4312L28.8569 24.2919C29.0448 24.4795 29.2995 24.5848 29.5649 24.5846C29.8304 24.5844 30.085 24.4788 30.2726 24.2909C30.4602 24.1031 30.5655 23.8484 30.5653 23.5829C30.5651 23.3174 30.4595 23.0629 30.2716 22.8753L24.8126 17.42Z",
                        fill: "#33475B"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_BackToTop = (BackToTop);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(18473);
// EXTERNAL MODULE: ./src/assets/icons/index.tsx + 2 modules
var icons = __webpack_require__(34648);
// EXTERNAL MODULE: ./node_modules/antd/es/popover/index.js + 3 modules
var popover = __webpack_require__(71772);
// EXTERNAL MODULE: ./src/common/Tooltip.tsx
var Tooltip = __webpack_require__(45028);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(45332);
;// CONCATENATED MODULE: ./src/components/PopupSupportCenter.tsx
/* eslint-disable */ 



var PopupSupportCenter = function(param) {
    var setVisible = param.setVisible, visible = param.visible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconSupportCenter */.jz, {
                        onClick: function() {
                            return setVisible(!visible);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ms-2 text-base font-semibold text-bw-1",
                        children: "Support Center"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-4 mt-3 text-ssm text-bw-1",
                children: "Trong qu\xe1 tr\xecnh học tập, nếu c\xf3 c\xe1c vấn đề cần hỗ trợ, bạn h\xe3y kết nối với bộ phận Hỗ trợ học vi\xean qua c\xe1c k\xeanh li\xean hệ sau:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return (0,utils/* onLinkSocial */.jL)("https://knowledge.sapp.edu.vn/knowledge");
                },
                className: "relative mt-3 hover:cursor-pointer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-3 flex h-14 cursor-pointer border-[1px] border-solid border-gray-3 px-3.5 py-2.5 hover:bg-primary",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "z-[999] flex h-full w-full hover:hidden",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconFAQ */.y_, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "ms-3 text-[11px] text-bw-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Tra cứu c\xe1c vấn đề thường gặp v\xe0 t\xe0i liệu học tập qua trong th\xf4ng tin"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-bold",
                                            children: "Knowledge Base"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " absolute left-0 top-0 flex h-full w-full items-center justify-center text-ssm hover:z-[1000] hover:bg-primary hover:text-white",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-white",
                                children: "Tra cứu tại đ\xe2y"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return (0,utils/* onLinkSocial */.jL)("https://sapp.edu.vn/dich-vu-cham-soc-hoc-vien-sapp-academy");
                },
                className: "relative mt-3 hover:cursor-pointer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-3 flex h-14 cursor-pointer border-[1px] border-solid border-gray-3 px-3.5 py-2.5 hover:bg-primary",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "z-[999] flex h-full w-full hover:hidden",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconRequestForm */.AJ, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "ms-3 text-[11px] text-bw-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Gửi"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-bold",
                                            children: "Phiếu y\xeau cầu dịch vụ "
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "để hỗ trợ giải quyết c\xe1c vấn đề về dịch vụ kh\xf3a học"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " absolute left-0 top-0 flex h-full w-full items-center justify-center text-ssm hover:z-[1000] hover:bg-primary hover:text-white",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-white",
                                children: "Gửi phiếu tại đ\xe2y"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return (0,utils/* onLinkSocial */.jL)("https://www.facebook.com/ServiceofSAPP");
                },
                className: "relative mt-3 hover:cursor-pointer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-3 flex h-14 cursor-pointer border-[1px] border-solid border-gray-3 px-3.5 py-2.5 hover:bg-primary",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "z-[999] flex h-full w-full hover:hidden",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconChat */.f7, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "ms-3 text-[11px] text-bw-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Nhắn tin qua"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-bold",
                                            children: "Fanpage"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "để được giải đ\xe1p kiến thức c\xf9ng bộ phận chuy\xean m\xf4n."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " absolute left-0 top-0 flex h-full w-full items-center justify-center text-ssm hover:z-[1000] hover:bg-primary hover:text-white",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-white",
                                children: "Chat c\xf9ng SAPP"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return (0,utils/* onLinkSocial */.jL)("https://www.facebook.com/groups/everydaywithsapp");
                },
                className: "relative mt-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-3 flex h-14 border-[1px] border-solid border-gray-3 px-3.5 py-2.5 hover:bg-primary hover:text-primary",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "z-[2] flex h-full w-full hover:hidden",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconAccess */.BL, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "ms-3 text-[11px] text-bw-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "",
                                            children: "Tham gia"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-bold",
                                            children: '"Everyday with SAPP"'
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "",
                                            children: "- cộng đồng học tập d\xe0nh cho học vi\xean"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " absolute left-0 top-0 flex h-full w-full items-center justify-center text-ssm hover:z-10 hover:bg-primary hover:text-white",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-white",
                                children: "Truy Cập Ngay"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative mt-3 hover:cursor-pointer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-3 flex h-14 border-[1px] border-solid border-gray-3 px-3.5 py-2.5 hover:bg-primary",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "z-[999] flex h-full w-full hover:hidden hover:bg-primary",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconContact */.r2, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "ms-3 text-[11px] text-bw-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-bold",
                                            children: "Li\xean hệ Hotline: 19002225 (nhấn ph\xedm 2)"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Tvới t\xecnh huống cần hỗ trợ khẩn cấp."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " absolute left-0 top-0 flex h-full w-full items-center justify-center text-ssm hover:z-[1000] hover:bg-primary hover:text-white",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-white",
                                children: "Gọi Khẩn Cấp"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative mt-3 hover:cursor-pointer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-3 flex h-14 border-[1px] border-solid border-gray-3 px-3.5 py-2.5 hover:bg-primary",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "z-[999] flex h-full w-full hover:hidden",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconEmergency */.J2, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "ms-3 text-[11px] text-bw-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Li\xean hệ trao đổi qua email hỗ trợ ch\xednh thức:"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-bold",
                                            children: "support@sapp.edu.vn"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " absolute left-0 top-0 flex h-full w-full items-center justify-center text-ssm hover:z-[1000] hover:bg-primary hover:text-white",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-white",
                                children: "Gọi Khẩn Cấp"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-4 text-center text-ssm italic text-bw-1",
                children: "Ch\xfang t\xf4i cam kết phản hồi trong 4 giờ l\xe0m việc (trừ Thứ 7, Chủ nhật v\xe0 c\xe1c ng\xe0y lễ)"
            })
        ]
    });
};
var Infomation = function(param) {
    var title = param.title;
    return /*#__PURE__*/ _jsx("div", {
        className: "flex w-full items-center justify-center text-ssm text-white",
        children: title
    });
};
/* harmony default export */ var components_PopupSupportCenter = (PopupSupportCenter);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(34376);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
;// CONCATENATED MODULE: ./src/components/Help.tsx
/* eslint-disable react-hooks/rules-of-hooks */ 








var Help = function(param) {
    var showHelp = param.showHelp;
    // All hooks need to be at the top level, before any conditional returns
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var router = (0,next_router.useRouter)();
    var scriptRef = (0,react.useRef)(null);
    var asPath = router.asPath;
    var ref1 = (0,_sliced_to_array/* default */.Z)([
        "/teachers",
        "/test",
        "/case-study",
        "/activity", 
    ].map(function(p) {
        return asPath.includes(p);
    }), 4), isTeacherPage = ref1[0], isTestPage = ref1[1], isCaseStudyPage = ref1[2], isActivityPage = ref1[3];
    var hiddenChatbot = excludedPathsHelp.some(function(path) {
        return router.pathname.includes(path);
    }) || isTeacherPage;
    // Handle visibility changes
    var handleVisibleChange = function(newVisible) {
        if (newVisible) {
            setVisible(true);
        }
    };
    var handleButtonClick = function() {
        setVisible(!visible);
    };
    // Effect for teacher pages cleanup
    (0,react.useEffect)(function() {
        if (hiddenChatbot) {
            var ref;
            var hsScript = document.getElementById("hs-script-loader");
            if (hsScript) document === null || document === void 0 ? void 0 : (ref = document.head) === null || ref === void 0 ? void 0 : ref.removeChild(hsScript);
            // Also clean up HubSpot containers if they exist
            var container = document.getElementById("hubspot-messages-iframe-container");
            if (container) {
                container.style.display = "none";
                if (container.classList.contains("show")) {
                    container.classList.remove("show");
                }
                container.classList.add("hide");
            }
            var conversationsContainer = document.getElementById("hubspot-conversations-iframe");
            if (conversationsContainer) conversationsContainer.style.display = "none";
        }
    }, [
        hiddenChatbot
    ]);
    // Effect for script creation
    (0,react.useEffect)(function() {
        var scriptElement = document.getElementById("hs-script-loader");
        if (showHelp && !hiddenChatbot) {
            if (!scriptElement) {
                scriptElement = document.createElement("script");
                scriptElement.type = "text/javascript";
                scriptElement.id = "hs-script-loader";
                scriptElement.async = true;
                scriptElement.defer = true;
                scriptElement.src = "//js.hs-scripts.com/1774127.js";
                scriptRef.current = scriptElement;
                document.head.appendChild(scriptElement);
            }
            // Hiển thị các container chat nếu có
            var container = document.getElementById("hubspot-messages-iframe-container");
            if (container) {
                container.style.display = "";
                container.classList.remove("hide");
                container.classList.add("show");
            }
            var conversationsContainer = document.getElementById("hubspot-conversations-iframe");
            if (conversationsContainer) conversationsContainer.style.display = "";
        } else {
            // Xóa script và ẩn chat nếu không thỏa điều kiện
            if (scriptElement) {
                document.head.removeChild(scriptElement);
                scriptRef.current = null;
            }
            // Ẩn các container chat nếu có
            var container1 = document.getElementById("hubspot-messages-iframe-container");
            if (container1) {
                container1.style.display = "none";
                container1.classList.remove("show");
                container1.classList.add("hide");
            }
            var conversationsContainer1 = document.getElementById("hubspot-conversations-iframe");
            if (conversationsContainer1) conversationsContainer1.style.display = "none";
        }
    }, [
        showHelp,
        hiddenChatbot
    ]);
    // Effect for container visibility
    (0,react.useEffect)(function() {
        var container = document.getElementById("hubspot-messages-iframe-container");
        if (container && visible) {
            container.classList.add("visible-icon");
        } else {
            if (container && !visible) {
                container.classList.remove("visible-icon");
            }
        }
    }, [
        visible
    ]);
    // Early return after all hooks are declared
    if (isTeacherPage || isTestPage || isCaseStudyPage || isActivityPage) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: showHelp && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cursor-pointer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* default */.Z, {
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PopupSupportCenter, {
                    visible: visible,
                    setVisible: setVisible
                }),
                trigger: "click",
                open: visible,
                onOpenChange: handleVisibleChange,
                placement: "topLeft",
                arrow: false,
                children: visible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "floating-button",
                    onClick: handleButtonClick,
                    className: "".concat(visible ? "clicked bottom-5" : "bottom-[90px]", " right-[16px]"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "plus flex items-center justify-center rounded-full bg-white transition delay-300 hover:opacity-100",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "60",
                            height: "60",
                            viewBox: "0 0 34 34",
                            fill: "#33475B",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M22.3033 11.6969C22.5962 11.9897 22.5962 12.4646 22.3033 12.7575L18.0607 17.0002L22.3033 21.2428C22.5962 21.5357 22.5962 22.0106 22.3033 22.3035C22.0104 22.5964 21.5355 22.5963 21.2426 22.3035L17 18.0608L12.7574 22.3035C12.4645 22.5963 11.9896 22.5964 11.6967 22.3035C11.4038 22.0106 11.4038 21.5357 11.6967 21.2428L15.9393 17.0002L11.6967 12.7575C11.4038 12.4646 11.4038 11.9897 11.6967 11.6969C11.9896 11.404 12.4645 11.404 12.7574 11.6969L17 15.9395L21.2426 11.6969C21.5355 11.404 22.0104 11.404 22.3033 11.6969Z",
                                fill: "#33475B"
                            })
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                    title: "Support Center",
                    placement: "left",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "floating-button",
                        onClick: handleButtonClick,
                        className: "".concat(visible ? "clicked bottom-5" : "bottom-[90px]", " right-[16px]"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "plus flex items-center justify-center delay-300 hover:rounded-full hover:opacity-100",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconClose */.bM, {})
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var components_Help = (Help);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(51224);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(52621);
// EXTERNAL MODULE: ./src/utils/constants/index.ts + 3 modules
var constants = __webpack_require__(15183);
// EXTERNAL MODULE: ./src/constants/index.ts + 4 modules
var src_constants = __webpack_require__(43743);
// EXTERNAL MODULE: ./src/redux/hook.ts
var hook = __webpack_require__(34705);
// EXTERNAL MODULE: ./src/redux/slice/User/User.tsx
var User = __webpack_require__(85195);
;// CONCATENATED MODULE: ./src/components/auth/RouteGuard.tsx










var RouteGuard = function(param) {
    var children = param.children;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), authorized = ref[0], setAuthorized = ref[1];
    var dispatch = (0,hook/* useAppDispatch */.T)();
    var userSlice = (0,hook/* useAppSelector */.C)(User/* userReducer */.M3);
    // First useEffect for getMe
    (0,react.useEffect)(function() {
        callGetMe();
    }, [
        router.pathname,
        userSlice.user.keycloak_user_id
    ]);
    var callGetMe = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _keycloak_user_id, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (userSlice.user.id || userSlice.user.keycloak_user_id || [
                            constants/* CERTIFICATE_DETAIL */.JJ,
                            src_constants/* ENTRANCE_TEST_RESULT */.WD,
                            src_constants/* ENTRANCE_TEST_TABLE_RESULT */.IO
                        ].includes(router.pathname)) {
                            setAuthorized(true);
                            ;
                            (0,utils/* setCookie */.d8)(src_constants/* COOKIE_INFO.KEYCLOAK_USER_ID */.s_.KEYCLOAK_USER_ID, (_keycloak_user_id = userSlice.user.keycloak_user_id) !== null && _keycloak_user_id !== void 0 ? _keycloak_user_id : "");
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            dispatch((0,User/* getMe */.jo)()).unwrap()
                        ];
                    case 2:
                        _state.sent();
                        setAuthorized(true);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function callGetMe() {
            return _ref.apply(this, arguments);
        };
    }();
    return authorized ? children : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};

// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/index.js + 9 modules
var config_provider = __webpack_require__(73898);
;// CONCATENATED MODULE: ./src/components/base/Provider/AntConfigProvider.tsx


var AntConfigProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(config_provider/* default */.ZP, {
        theme: {
            token: {
                fontFamily: "Roboto, sans-serif"
            },
            components: {
                Input: {
                    colorPrimaryHover: "#ffb800",
                    colorPrimary: "#ffb800",
                    colorTextPlaceholder: "#9CA3AF",
                    controlOutlineWidth: 0,
                    colorTextDisabled: "#99A1B7",
                    colorBgContainerDisabled: "#ffffff"
                },
                Select: {
                    colorPrimaryHover: "#ffb800",
                    colorPrimary: "#ffb800",
                    colorTextPlaceholder: "#9CA3AF",
                    controlOutlineWidth: 0,
                    optionSelectedBg: "#ffbb0012",
                    optionSelectedColor: "#ffb800",
                    controlItemBgHover: "#ffbb0012",
                    colorPrimaryTextHover: "#ffb800",
                    colorTextDisabled: "#99A1B7",
                    colorBgContainerDisabled: "#ffffff"
                },
                DatePicker: {
                    colorPrimaryHover: "#ffb800",
                    colorPrimary: "#ffb800",
                    colorTextPlaceholder: "#9CA3AF",
                    controlOutlineWidth: 0
                },
                Button: {
                    controlOutlineWidth: 0,
                    colorBorder: "transparent"
                }
            }
        },
        children: children
    });
};
/* harmony default export */ var Provider_AntConfigProvider = (AntConfigProvider);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(9616);
// EXTERNAL MODULE: ./src/redux/slice/ConfirmDialog/ConfirmDialogSlice.ts
var ConfirmDialogSlice = __webpack_require__(35392);
// EXTERNAL MODULE: ./src/components/base/modal/SappModal.tsx
var SappModal = __webpack_require__(33593);
;// CONCATENATED MODULE: ./src/components/base/confirm-dialog/SappConfirmDialog.tsx
// ConfirmDialog.tsx







// create the confirm dialog component
var SappConfirmDialog = function(param) {
    var open = param.open, message = param.message, okButtonTitle = param.okButtonTitle, cancelButtonTitle = param.cancelButtonTitle, onCancel = param.onCancel, onConfirm = param.onConfirm, closeConfirmation = param.closeConfirmation;
    var handleCancel = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = onCancel;
                        if (!_tmp) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            onCancel()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        _state.label = 2;
                    case 2:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCancel() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onConfirm()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        // on route change start - hide dialog
        if (open) {
            router_default().events.on("routeChangeComplete", closeConfirmation);
        } else {
            router_default().events.off("routeChangeComplete", closeConfirmation);
        }
        // unsubscribe from events in useEffect return function
        return function() {
            router_default().events.off("routeChangeComplete", closeConfirmation);
        };
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SappModal/* default */.Z, {
            open: open,
            okButtonCaption: okButtonTitle || "Yes",
            cancelButtonCaption: cancelButtonTitle || "No",
            handleCancel: handleCancel,
            handleSubmit: handleConfirm,
            setOpen: closeConfirmation,
            // refClass="md:p-8 p-5 flex flex-col animate-jump-in relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8"
            footerButtonClassName: "justify-center flex flex-row-reverse gap-4",
            color: "okPopup",
            colorCancel: "cancelPopup",
            showHeader: false,
            zIndex: "z-[9999999]",
            position: "center",
            className: "rounded-lg !p-8",
            okButtonClass: "rounded-md h-[45px]",
            cancelButtonClass: "rounded-md h-[45px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex h-[100px] w-[100px] items-center justify-center rounded-full bg-secondary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AlertCircleSharp */.DT, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-3 mt-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-center text-sm font-medium text-bw-11",
                            children: message
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var confirm_dialog_SappConfirmDialog = (SappConfirmDialog);

;// CONCATENATED MODULE: ./src/components/base/confirm-dialog/SappConfirmDialogContainer.tsx
// ConfirmDialogContainer.tsx
// react


// redux

// actions and selectors

// component

// define the props from the state
var mapStateToProps = function(state) {
    return (0,_object_spread/* default */.Z)({}, (0,ConfirmDialogSlice/* confirmDialogReducer */.mj)(state));
};
// create the connector
var connector = (0,es/* connect */.$j)(mapStateToProps, ConfirmDialogSlice/* confirmDialogActions */.fW);
// create the container component
var SappConfirmDialogContainer = function(props) {
    // render the confirm dialog component with the props from the state and dispatch
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(confirm_dialog_SappConfirmDialog, (0,_object_spread/* default */.Z)({}, props));
};
/* harmony default export */ var confirm_dialog_SappConfirmDialogContainer = (connector(SappConfirmDialogContainer));

;// CONCATENATED MODULE: ./src/components/common/Metadata.tsx


var Metadata = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                httpEquiv: "X-UA-Compatible",
                content: "IE=edge,chrome=1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "analytics",
                content: "G-HRLKW6S3X0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "csrf-token",
                content: "Hl4U5KjkBFkHN2m2ptOE1L8QbTGV19yrEINaOrsd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1, shrink-to-fit=no"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "author",
                content: "SAPP Academy"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: "Hệ thống Quản l\xfd học v\xe0 thi ACCA, CFA, CMA trực tuyến SAPP Academy"
            }, "title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: "Hệ thống Nền tảng Học v\xe0 Thi trực tuyến được SAPP Academy x\xe2y dựng nhằm mục đ\xedch cung cấp trải nghiệm học tập hiện đại, c\xe1 nh\xe2n h\xf3a, gi\xfap học vi\xean tối ưu kết quả học tập ACCA, CFA, CMA"
            }, "desc"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:description",
                content: "Hệ thống Nền tảng Học v\xe0 Thi trực tuyến được SAPP Academy x\xe2y dựng nhằm mục đ\xedch cung cấp trải nghiệm học tập hiện đại, c\xe1 nh\xe2n h\xf3a, gi\xfap học vi\xean tối ưu kết quả học tập ACCA, CFA, CMA"
            }, "description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: "https://sapp-lms-fe-prod.vercel.app/thumbnail.webp"
            }, "image"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:url",
                content: "https://lms-pro.sapp.edu.vn"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "keywords",
                content: "sapp, lms, acca, ACCA, CFA, CMA, Big4, 3P, SAPP Academy"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: "Hệ thống Quản l\xfd học v\xe0 thi ACCA, CFA, CMA trực tuyến SAPP Academy"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: "Hệ thống Nền tảng Học v\xe0 Thi trực tuyến được SAPP Academy x\xe2y dựng nhằm mục đ\xedch cung cấp trải nghiệm học tập hiện đại, c\xe1 nh\xe2n h\xf3a, gi\xfap học vi\xean tối ưu kết quả học tập ACCA, CFA, CMA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: "https://sapp-lms-fe-prod.vercel.app/thumbnail.webp"
            })
        ]
    });
};
/* harmony default export */ var common_Metadata = (Metadata);

// EXTERNAL MODULE: ./src/components/base/editor/EditorReader.tsx + 1 modules
var EditorReader = __webpack_require__(95215);
// EXTERNAL MODULE: ./src/contexts/PinnedNotifyContext.tsx
var PinnedNotifyContext = __webpack_require__(66268);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js + 2 modules
var row = __webpack_require__(39996);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js + 1 modules
var col = __webpack_require__(96519);
// EXTERNAL MODULE: ./node_modules/react-fast-marquee/dist/index.js
var dist = __webpack_require__(8467);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(57368);
;// CONCATENATED MODULE: ./src/components/layout/PinnedNotifications/index.tsx










function PinnedNotifications() {
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var ref4 = (0,PinnedNotifyContext/* usePinnedNotifyContext */.Z)(), openPinned = ref4.openPinned, setOpenPinned = ref4.setOpenPinned, pinnedNotifications = ref4.pinnedNotifications;
    var handleClosePinned = function() {
        localStorage.setItem("openPinned", "false");
        setOpenPinned(false);
    };
    var showPinNoti = (pinnedNotifications === null || pinnedNotifications === void 0 ? void 0 : (ref = pinnedNotifications.data) === null || ref === void 0 ? void 0 : (ref1 = ref.content) === null || ref1 === void 0 ? void 0 : ref1.length) < 200;
    var isEnablePinnedPages = [
        src_constants/* PageLink.COURSES */.H_.COURSES,
        src_constants/* PageLink.USERPAGE */.H_.USERPAGE,
        src_constants/* PageLink.COURSE_DETAIL */.H_.COURSE_DETAIL,
        src_constants/* PageLink.COURSE_PART_DETAIL */.H_.COURSE_PART_DETAIL,
        src_constants/* PageLink.COURSE_ACTIVITY */.H_.COURSE_ACTIVITY, 
    ].includes(router.pathname);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: isEnablePinnedPages && openPinned && (pinnedNotifications === null || pinnedNotifications === void 0 ? void 0 : (ref2 = pinnedNotifications.data) === null || ref2 === void 0 ? void 0 : ref2.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed top-0 z-50 h-12 w-full bg-support-1 text-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                    className: "flex h-12 flex-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            span: 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            span: 22,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex h-12 flex-row justify-items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-auto flex flex-row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex content-center items-center text-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconLoudSpeaker */.uc, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex w-[225px] flex-row content-center items-center lg:w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                gradient: false,
                                                speed: showPinNoti ? 0 : 50,
                                                pauseOnHover: true,
                                                className: (0,clsx/* default */.Z)({
                                                    "leading-5": showPinNoti
                                                }),
                                                delay: 2,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorReader/* default */.Z, {
                                                    text_editor_content: pinnedNotifications === null || pinnedNotifications === void 0 ? void 0 : (ref3 = pinnedNotifications.data) === null || ref3 === void 0 ? void 0 : ref3.content,
                                                    pinned: true,
                                                    className: "me-60 ml-3"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            span: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: handleClosePinned,
                                className: "float-right flex h-full cursor-pointer content-center items-center pr-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIconNote */.VB, {})
                            })
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ var layout_PinnedNotifications = (PinnedNotifications);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(72760);
// EXTERNAL MODULE: ./src/contexts/index.tsx
var contexts = __webpack_require__(44446);
// EXTERNAL MODULE: ./src/components/base/modal/SappModalV3.tsx
var SappModalV3 = __webpack_require__(21849);
// EXTERNAL MODULE: ./src/pages/api/courses/index.ts
var courses = __webpack_require__(38916);
;// CONCATENATED MODULE: ./src/components/mycourses/hubspot/PopupLockContent.tsx








var MODAL_CONTENT = {
    lockSection: {
        header: "This content is locked",
        content: "Sorry, you do not have access to this content. Click ‘Upgrade Now’ to receive a personalized learning consultation call from our admissions conslutant.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* LockSectionIcon */.wn, {})
    },
    ctaUpgrade: {
        header: "Unlock Your Learning Journey",
        content: "Click 'Upgrade Now' to receive a personalized learning consultation call from our admissions conslutant.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* UnlockIcon */.QB, {})
    },
    thankYou: {
        header: "Thank you!",
        content: "We'll contact you within 24 hours to unlock your full trial experience!",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ThankYouIcon */.p$, {})
    },
    thankYouLater: {
        header: "Thank you!",
        content: "We've already received your request. Our team will be in touch within 24 hours.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ThankYouIcon */.p$, {})
    }
};
var PopupLockContent = function(param) {
    var showForm = param.showForm, setShowForm = param.setShowForm;
    var router = (0,next_router.useRouter)();
    /**
   * Xử lý đóng modal bằng cách reset tất cả các trạng thái về false
   * Được gọi khi người dùng click nút đóng hoặc click bên ngoài modal
   */ var handleClose = function() {
        setShowForm({
            lockSection: false,
            ctaUpgrade: false,
            thankYou: false,
            thankYouLater: false
        });
    };
    /**
   * Lấy nội dung hiển thị cho modal dựa trên trạng thái hiện tại
   * Ưu tiên theo thứ tự: lockSection > ctaUpgrade > thankYouLater > thankYou
   * @returns {Object} Object chứa header, content và icon tương ứng với trạng thái
   */ var getModalContent = function() {
        if (showForm.lockSection) return MODAL_CONTENT.lockSection;
        if (showForm.ctaUpgrade) return MODAL_CONTENT.ctaUpgrade;
        if (showForm.thankYouLater) return MODAL_CONTENT.thankYouLater;
        return MODAL_CONTENT.thankYou;
    };
    /**
   * Xử lý khi người dùng click nút "Upgrade Now"
   * Gọi API để nâng cấp tài khoản trial
   * Dựa vào kết quả API để hiển thị thông báo thank you phù hợp
   */ var handleUpgrade = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var res, ref, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            courses/* CoursesAPI.upgradeNowTrial */.tB.upgradeNowTrial(router.query.courseId || router.query.id)
                        ];
                    case 1:
                        res = _state.sent();
                        if (res.success) {
                            ;
                            setShowForm({
                                lockSection: false,
                                ctaUpgrade: false,
                                thankYou: !!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.upgrade_now_available),
                                thankYouLater: !(res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.upgrade_now_available)
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleUpgrade() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref = getModalContent(), header = ref.header, content = ref.content, icon = ref.icon;
    var showFooter = showForm.ctaUpgrade || showForm.lockSection;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SappModalV3/* default */.Z, {
        open: showForm.ctaUpgrade || showForm.lockSection || (showForm === null || showForm === void 0 ? void 0 : showForm.thankYou) || (showForm === null || showForm === void 0 ? void 0 : showForm.thankYouLater),
        handleCancel: handleClose,
        onOk: handleUpgrade,
        handleClose: showFooter ? handleClose : undefined,
        icon: icon,
        header: header,
        content: content,
        showFooter: showFooter,
        okButtonCaption: "Upgrade Now",
        cancelButtonCaption: "Skip",
        showCancelButton: showFooter,
        fullWidthBtn: true,
        buttonSize: "extra",
        isClosable: showFooter
    });
};
/* harmony default export */ var hubspot_PopupLockContent = (PopupLockContent);

;// CONCATENATED MODULE: ./src/components/layout/PinnedNotifications/CtaTrial.tsx










var ENABLED_PINNED_PAGES = [
    src_constants/* PageLink.COURSE_DETAIL */.H_.COURSE_DETAIL,
    src_constants/* PageLink.COURSE_PART_DETAIL */.H_.COURSE_PART_DETAIL,
    src_constants/* PageLink.COURSE_ACTIVITY */.H_.COURSE_ACTIVITY,
    src_constants/* PageLink.TEACHER_COURSE_DETAIL_ID */.H_.TEACHER_COURSE_DETAIL_ID,
    src_constants/* PageLink.TEACHER_COURSE_PART_DETAIL */.H_.TEACHER_COURSE_PART_DETAIL,
    src_constants/* PageLink.TEACHER_COURSE_ACTIVITY */.H_.TEACHER_COURSE_ACTIVITY, 
];
var ENABLED_PINNED_NOTI_PAGES = [
    src_constants/* PageLink.COURSES */.H_.COURSES,
    src_constants/* PageLink.TEACHERS */.H_.TEACHERS,
    src_constants/* PageLink.USERPAGE */.H_.USERPAGE, 
].concat((0,_to_consumable_array/* default */.Z)(ENABLED_PINNED_PAGES));
function CtaTrial() {
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,contexts/* useCourseContext */.Y)(), setShowPinnedTrial = ref1.setShowPinnedTrial, showPinnedTrial = ref1.showPinnedTrial, openPopupCTA = ref1.openPopupCTA, setOpenPopupCTA = ref1.setOpenPopupCTA;
    var ref2 = (0,PinnedNotifyContext/* usePinnedNotifyContext */.Z)(), openPinned = ref2.openPinned, pinnedNotifications = ref2.pinnedNotifications;
    var isEnablePinnedPages = ENABLED_PINNED_PAGES.includes(router.pathname);
    var isEnablePinnedNotiPages = ENABLED_PINNED_NOTI_PAGES.includes(router.pathname);
    (0,react.useLayoutEffect)(function() {
        setShowPinnedTrial(localStorage.getItem("showPinTrial") === "true" && isEnablePinnedPages);
    }, [
        router,
        isEnablePinnedPages,
        setShowPinnedTrial
    ]);
    var handleClose = function() {
        localStorage.setItem("showPinTrial", "false");
        setShowPinnedTrial(false);
    };
    var handleUpgrade = function() {
        setOpenPopupCTA({
            lockSection: false,
            ctaUpgrade: true,
            thankYou: false,
            thankYouLater: false
        });
    };
    if (!isEnablePinnedPages || !showPinnedTrial) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hubspot_PopupLockContent, {
                showForm: openPopupCTA,
                setShowForm: setOpenPopupCTA
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed z-50 h-[54px] w-full bg-primary text-white ".concat(isEnablePinnedNotiPages && openPinned && (pinnedNotifications === null || pinnedNotifications === void 0 ? void 0 : (ref = pinnedNotifications.data) === null || ref === void 0 ? void 0 : ref.content) ? "top-12" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                    className: "flex h-[54px] w-[225px] flex-row content-center items-center justify-center lg:w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            span: 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                            span: 22,
                            className: "flex h-full items-center justify-center font-sans",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "text-base",
                                    children: [
                                        "You have",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-base font-semibold",
                                            children: localStorage.getItem("daysDifference")
                                        }),
                                        " ",
                                        "days left on your free trial.",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-lg font-semibold",
                                            children: "Upgrade"
                                        }),
                                        " today to unlock the full course."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "ms-8 h-[32px] bg-white px-4 text-[14px] font-medium leading-[17px] text-primary",
                                    onClick: handleUpgrade,
                                    children: "Upgrade Now"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "ms-1.5 mt-5 flex h-full items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CursorIcon */.cY, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            span: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: handleClose,
                                className: "float-right flex h-full cursor-pointer content-center items-center pr-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIconNote */.VB, {})
                            })
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var PinnedNotifications_CtaTrial = (CtaTrial);

// EXTERNAL MODULE: ./src/components/base/SappDrawer.tsx
var SappDrawer = __webpack_require__(63721);
// EXTERNAL MODULE: ./src/components/base/breadcrumb/SappBreadcrumbNotLink.tsx
var SappBreadcrumbNotLink = __webpack_require__(9290);
// EXTERNAL MODULE: ./src/components/base/select/HookFormSelect.tsx
var HookFormSelect = __webpack_require__(88012);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(55514);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./src/hooks/use-dynamic.tsx
var use_dynamic = __webpack_require__(79350);
// EXTERNAL MODULE: ./src/redux/slice/Course/NotesList.tsx
var NotesList = __webpack_require__(92231);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var react_hot_toast_dist = __webpack_require__(72808);
// EXTERNAL MODULE: ./node_modules/date-fns/format.mjs + 17 modules
var format = __webpack_require__(39866);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(55402);
// EXTERNAL MODULE: ./src/components/base/skeleton/TextSkeleton.tsx
var TextSkeleton = __webpack_require__(27869);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(12691);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(10103);
// EXTERNAL MODULE: ./src/common/NoData.tsx
var NoData = __webpack_require__(13891);
// EXTERNAL MODULE: ./src/redux/types/User/urser.ts
var urser = __webpack_require__(7847);
;// CONCATENATED MODULE: ./src/components/mycourses/LearningNotesList.tsx















var publicRuntimeConfig = config_default()().publicRuntimeConfig;
var apiURL = publicRuntimeConfig.apiURL;











var DEFAULT_PAGESIZE = 20;
var LearningNotesList = function() {
    var ref;
    var notesListStatus = (0,hook/* useAppSelector */.C)(function(state) {
        var ref;
        return (ref = state.notesListReducer) === null || ref === void 0 ? void 0 : ref.status;
    });
    var getNotesData = (0,hook/* useAppSelector */.C)(function(state) {
        var ref;
        return (ref = state.notesListReducer) === null || ref === void 0 ? void 0 : ref.note_data;
    });
    var userType = (0,hook/* useAppSelector */.C)(User/* userReducer */.M3).user.type;
    var dispatch = (0,hook/* useAppDispatch */.T)();
    var ref1 = (0,react.useState)(), notesListData = ref1[0], setNotesListData = ref1[1];
    var router = (0,next_router.useRouter)();
    var courseId = router.query.courseId;
    var queryId = router.query.id;
    var activityId = router.query.activityId;
    var courseSectionId = router.query.course_section_id;
    var ref2 = (0,react.useState)(null), selectedSection = ref2[0], setSelectedSection = ref2[1];
    var ref3 = (0,react.useState)(null), selectedSubsection = ref3[0], setSelectedSubsection = ref3[1];
    var ref4 = (0,react.useState)(null), selectedUnit = ref4[0], setSelectedUnit = ref4[1];
    var ref5 = (0,react.useState)(null), selectedActivity = ref5[0], setSelectedActivity = ref5[1];
    var ref6 = (0,react.useState)([]), sections = ref6[0], setSections = ref6[1];
    var ref7 = (0,react.useState)([]), subSections = ref7[0], setSubsections = ref7[1];
    var ref8 = (0,react.useState)([]), unit = ref8[0], setUnit = ref8[1];
    var ref9 = (0,react.useState)([]), activity = ref9[0], setActivity = ref9[1];
    var ref10 = (0,react.useState)(DEFAULT_PAGESIZE), pageIndex = ref10[0], setPageIndex = ref10[1];
    var ref11 = (0,react.useState)(false), firstLoadActity = ref11[0], setFirstLoadActity = ref11[1];
    var ref12 = (0,react.useState)([]), expandedNotes = ref12[0], setExpandedNotes = ref12[1];
    var ref13 = (0,react.useState)(false), loading = ref13[0], setLoading = ref13[1];
    var toggleExpand = function(noteId) {
        setExpandedNotes(function(prevExpanded) {
            if (prevExpanded === null || prevExpanded === void 0 ? void 0 : prevExpanded.includes(noteId)) {
                // Nếu noteId đã trong mảng, loại bỏ nó
                return prevExpanded === null || prevExpanded === void 0 ? void 0 : prevExpanded.filter(function(id) {
                    return id !== noteId;
                });
            } else {
                // Nếu noteId chưa có trong mảng, thêm nó vào
                return (0,_to_consumable_array/* default */.Z)(prevExpanded).concat([
                    noteId
                ]);
            }
        });
    };
    // Set default change section all
    (0,react.useEffect)(function() {
        if ((selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.value) === "") {
            setSelectedSubsection(null);
            setSelectedUnit(null);
            setSelectedActivity(null);
        }
    }, [
        selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.value
    ]);
    //Change dropdown
    (0,react.useEffect)(function() {
        if ((courseId || queryId) && notesListStatus) {
            getCourseSections(DEFAULT_PAGESIZE);
        }
    }, [
        notesListStatus
    ]);
    (0,react.useEffect)(function() {
        if ((selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.value) !== "" && notesListStatus) {
            getCourseSubsections(DEFAULT_PAGESIZE);
        }
    }, [
        selectedSection
    ]);
    (0,react.useEffect)(function() {
        if (notesListStatus) {
            getCourseUnit();
        }
    }, [
        selectedSubsection
    ]);
    (0,react.useEffect)(function() {
        if (notesListStatus) {
            getCourseActivity(DEFAULT_PAGESIZE);
        }
    }, [
        selectedUnit
    ]);
    var params = (0,utils/* cleanParamsAPI */.Vg)({
        class_id: courseId || queryId,
        course_section_id: (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.value) || (selectedUnit === null || selectedUnit === void 0 ? void 0 : selectedUnit.value) || (selectedSubsection === null || selectedSubsection === void 0 ? void 0 : selectedSubsection.value) || (selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.value) || ""
    });
    // Lấy danh sách notes và fill tự động activity khi lần đầu mở trong activity
    (0,react.useEffect)(function() {
        var ref, ref1;
        var objectParams = (0,utils/* cleanParamsAPI */.Vg)({
            class_id: courseId || queryId,
            course_section_id: activityId || courseSectionId || ""
        });
        if ((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.activityId) || (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.course_section_id) && notesListStatus) {
            setLoading(true);
            courses/* CoursesAPI.getCourseNotesList */.tB.getCourseNotesList(DEFAULT_PAGESIZE, objectParams).then(function(res) {
                var ref, ref1, ref2;
                setNotesListData(res === null || res === void 0 ? void 0 : res.data);
                var course_section_path = res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.notes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.course_section_path;
                if (res && (course_section_path === null || course_section_path === void 0 ? void 0 : course_section_path.length) > 0) {
                    setSelectedSection(defaultValueActivity(course_section_path, "PART"));
                    setSelectedSubsection(defaultValueActivity(course_section_path, "CHAPTER"));
                    // Hiệu ứng fill data vào ô select
                    setTimeout(function() {
                        setSelectedUnit(defaultValueActivity(course_section_path, "UNIT"));
                    }, 500);
                    setTimeout(function() {
                        setSelectedActivity(defaultValueActivity(course_section_path, "ACTIVITY"));
                        setFirstLoadActity(true);
                    }, 1000);
                }
            }).catch(function(err) {}).finally(function() {
                setTimeout(function() {
                    setLoading(false);
                }, 500);
            });
        } else if (notesListStatus) {
            setFirstLoadActity(true);
        }
    }, [
        notesListStatus
    ]);
    // Lấy danh sách notes khi có sự thay đổi trong notesListStatus, selectedSection, selectedSubsection, selectedUnit, selectedActivity
    (0,react.useEffect)(function() {
        if (notesListStatus && (courseId || queryId) && firstLoadActity) {
            setLoading(true);
            courses/* CoursesAPI.getCourseNotesList */.tB.getCourseNotesList(DEFAULT_PAGESIZE, params).then(function(res) {
                setNotesListData(res === null || res === void 0 ? void 0 : res.data);
            }).catch(function(err) {}).finally(function() {
                setTimeout(function() {
                    setLoading(false);
                }, 500);
            });
        }
    }, [
        notesListStatus,
        selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.value,
        selectedSubsection === null || selectedSubsection === void 0 ? void 0 : selectedSubsection.value,
        selectedUnit === null || selectedUnit === void 0 ? void 0 : selectedUnit.value,
        selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.value,
        firstLoadActity, 
    ]);
    // Attach a scroll event listener to fetch more data when scrolling to the bottom
    (0,react.useEffect)(function() {
        var containerDiv = document.getElementById("sapp-drawer-notes-list") // Replace 'your-container-id' with the actual ID of your container div
        ;
        var handleScroll = function() {
            if (containerDiv && containerDiv.clientHeight + containerDiv.scrollTop === containerDiv.scrollHeight && (courseId || queryId) && notesListStatus) {
                var ref;
                (notesListData === null || notesListData === void 0 ? void 0 : (ref = notesListData.meta) === null || ref === void 0 ? void 0 : ref.total_records) > pageIndex && fetchData(params);
            }
        };
        containerDiv === null || containerDiv === void 0 ? void 0 : containerDiv.addEventListener("scroll", handleScroll);
        return function() {
            return containerDiv === null || containerDiv === void 0 ? void 0 : containerDiv.removeEventListener("scroll", handleScroll);
        };
    }, [
        pageIndex
    ]);
    var ref14 = (0,use_dynamic/* default */.Z)(getCourseSections, DEFAULT_PAGESIZE), handleMenuScrollToSections = ref14.handleMenuScrollToBottom, setPageSection = ref14.setPage;
    var ref15 = (0,use_dynamic/* default */.Z)(getCourseSubsections, DEFAULT_PAGESIZE), handleMenuScrollToSubsections = ref15.handleMenuScrollToBottom, setPageSubsection = ref15.setPage;
    var ref16 = (0,use_dynamic/* default */.Z)(getCourseUnit, DEFAULT_PAGESIZE), handleMenuScrollToUnit = ref16.handleMenuScrollToBottom, setPageUnit = ref16.setPage;
    var ref17 = (0,use_dynamic/* default */.Z)(getCourseActivity, DEFAULT_PAGESIZE), handleMenuScrollToActivity = ref17.handleMenuScrollToBottom, setPageActivity = ref17.setPage;
    var handleDropdownChange = function(selectedOption, setFunction, resetFunction) {
        setFunction(selectedOption);
        // Reset the downstream dropdowns if a reset function is provided
        if (resetFunction) {
            resetFunction(null);
        }
    };
    var onClose = function() {
        document.body.style.overflow = "auto";
        dispatch((0,NotesList/* resetNotesList */.ZT)());
        setSelectedSubsection(null);
        setSelectedUnit(null);
        setSelectedActivity(null);
        setSelectedSection(null);
        var pageStateVariables = [
            setPageSection,
            setPageSubsection,
            setPageUnit,
            setPageActivity, 
        ];
        pageStateVariables.forEach(function(setPageVariable) {
            setPageVariable(DEFAULT_PAGESIZE * 2);
        });
        setFirstLoadActity(false);
    };
    var defaultValueActivity = function(course_section_path, type) {
        var value = course_section_path.find(function(item) {
            return (item === null || item === void 0 ? void 0 : item.type) === type;
        });
        var responce = {
            value: value.id,
            label: value.name
        };
        return responce;
    };
    function getCourseSections(page_size) {
        return _getCourseSections.apply(this, arguments);
    }
    function _getCourseSections() {
        _getCourseSections = (0,_async_to_generator/* default */.Z)(function(page_size) {
            var ref, res, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!(!sections.length && notesListStatus)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            courses/* CoursesAPI.getCourseSectionList */.tB.getCourseSectionList(courseId || queryId, page_size || DEFAULT_PAGESIZE)
                        ];
                    case 1:
                        res = _state.sent();
                        setSections((0,_to_consumable_array/* default */.Z)(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.sections).reverse());
                        setSelectedSubsection(null);
                        setSelectedUnit(null);
                        setSelectedActivity(null);
                        _state.label = 2;
                    case 2:
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _getCourseSections.apply(this, arguments);
    }
    function getCourseSubsections(page_size) {
        return _getCourseSubsections.apply(this, arguments);
    }
    function _getCourseSubsections() {
        _getCourseSubsections = (0,_async_to_generator/* default */.Z)(function(page_size) {
            var ref, class_id, res, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        class_id = courseId || queryId;
                        return [
                            4,
                            courses/* CoursesAPI.getCourseSubsectionList */.tB.getCourseSubsectionList(page_size, "CHAPTER", selectedSection.value, class_id)
                        ];
                    case 1:
                        res = _state.sent();
                        setSubsections((0,_to_consumable_array/* default */.Z)(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.sections).reverse());
                        setSelectedUnit(null);
                        setSelectedActivity(null);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _getCourseSubsections.apply(this, arguments);
    }
    function getCourseUnit() {
        return _getCourseUnit.apply(this, arguments);
    }
    function _getCourseUnit() {
        _getCourseUnit = (0,_async_to_generator/* default */.Z)(function() {
            var ref, class_id, res, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        class_id = courseId || queryId;
                        return [
                            4,
                            courses/* CoursesAPI.getCourseSubsectionList */.tB.getCourseSubsectionList(DEFAULT_PAGESIZE, "UNIT", selectedSubsection.value, class_id)
                        ];
                    case 1:
                        res = _state.sent();
                        setUnit((0,_to_consumable_array/* default */.Z)(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.sections).reverse());
                        setSelectedActivity(null);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        setSelectedUnit(null);
                        setSelectedActivity(null);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _getCourseUnit.apply(this, arguments);
    }
    function getCourseActivity(page_size) {
        return _getCourseActivity.apply(this, arguments);
    }
    function _getCourseActivity() {
        _getCourseActivity = (0,_async_to_generator/* default */.Z)(function(page_size) {
            var ref, class_id, res, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        class_id = courseId || queryId;
                        return [
                            4,
                            courses/* CoursesAPI.getCourseSubsectionList */.tB.getCourseSubsectionList(page_size, "ACTIVITY", selectedUnit.value, class_id)
                        ];
                    case 1:
                        res = _state.sent();
                        setActivity((0,_to_consumable_array/* default */.Z)(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.sections).reverse());
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        setSelectedActivity(null);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _getCourseActivity.apply(this, arguments);
    }
    var fetchData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(params) {
            var res, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            courses/* CoursesAPI.getCourseNotesList */.tB.getCourseNotesList(pageIndex, params)
                        ];
                    case 2:
                        res = _state.sent();
                        setNotesListData(res === null || res === void 0 ? void 0 : res.data);
                        setPageIndex(function(prevPageIndex) {
                            return prevPageIndex + DEFAULT_PAGESIZE;
                        });
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setTimeout(function() {
                            setLoading(false);
                        }, 500);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData(params) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDelete = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var res, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            courses/* CoursesAPI.deleteCourseNoteList */.tB.deleteCourseNoteList(id)
                        ];
                    case 1:
                        res = _state.sent();
                        fetchData(params);
                        react_hot_toast_dist/* default.success */.ZP.success("X\xf3a th\xe0nh c\xf4ng!");
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDelete(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleEditNote = function(id, description, index) {
        var note = {
            uuid: (0,v4/* default */.Z)(),
            id: id,
            name: "Note",
            description: description
        };
        dispatch((0,NotesList/* pushNotes */.xT)(note));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SappDrawer/* default */.Z, {
        isOpen: notesListStatus,
        message: "Bạn c\xf3 chắc ch\xe1n muốn hủy kh\xf4ng?",
        onClose: onClose,
        title: "Notes List",
        footer: false,
        drawerSubId: "-notes-list",
        confirmOnClose: false,
        heightBody: "h-[calc(100vh-112px)]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-2 grid grid-cols-2 gap-4 md:gap-6 xl:grid-cols-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HookFormSelect/* default */.Z, {
                        classParent: "w-full md:max-w-full",
                        placeholder: "Section",
                        isClearable: true,
                        value: selectedSection,
                        onChange: function(selectedOption) {
                            return handleDropdownChange(selectedOption, setSelectedSection, setSelectedSubsection);
                        },
                        options: sections && src_constants/* DEFAULT_SELECT_SECTION.concat */.qq.concat(sections === null || sections === void 0 ? void 0 : sections.map(function(section) {
                            return {
                                label: section.name,
                                value: section.id
                            };
                        })),
                        onMenuScrollToBottom: handleMenuScrollToSections
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HookFormSelect/* default */.Z, {
                        classParent: "w-full md:max-w-full",
                        placeholder: "Subsection",
                        isClearable: true,
                        value: selectedSubsection,
                        onChange: function(selectedOption) {
                            return handleDropdownChange(selectedOption, setSelectedSubsection, setSelectedUnit);
                        },
                        options: selectedSection ? subSections === null || subSections === void 0 ? void 0 : subSections.map(function(section) {
                            return {
                                label: section.name,
                                value: section.id
                            };
                        }) : [],
                        isDisabled: (selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.value) === "",
                        onMenuScrollToBottom: handleMenuScrollToSubsections
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HookFormSelect/* default */.Z, {
                        classParent: "w-full md:max-w-full",
                        placeholder: "Unit",
                        isClearable: true,
                        value: selectedUnit,
                        onChange: function(selectedOption) {
                            return handleDropdownChange(selectedOption, setSelectedUnit, setSelectedActivity);
                        },
                        options: selectedSubsection ? unit === null || unit === void 0 ? void 0 : unit.map(function(section) {
                            return {
                                label: section.name,
                                value: section.id
                            };
                        }) : [],
                        isDisabled: (selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.value) === "",
                        onMenuScrollToBottom: handleMenuScrollToUnit
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HookFormSelect/* default */.Z, {
                        classParent: "w-full md:max-w-full",
                        placeholder: "Activity",
                        isClearable: true,
                        value: selectedActivity,
                        onChange: function(selectedOption) {
                            return handleDropdownChange(selectedOption, setSelectedActivity, null);
                        },
                        options: selectedUnit ? activity === null || activity === void 0 ? void 0 : activity.map(function(section) {
                            return {
                                label: section.name,
                                value: section.id
                            };
                        }) : [],
                        isDisabled: (selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.value) === "",
                        onMenuScrollToBottom: handleMenuScrollToActivity
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: !(0,lodash.isEmpty)(notesListData === null || notesListData === void 0 ? void 0 : notesListData.notes) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* default */.Z, {
                    loading: loading,
                    length: 10,
                    children: notesListData === null || notesListData === void 0 ? void 0 : (ref = notesListData.notes) === null || ref === void 0 ? void 0 : ref.map(function(note, index) {
                        var ref, ref1;
                        var isExpanded = expandedNotes.includes(note === null || note === void 0 ? void 0 : note.id);
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-6 border border-default p-6 last:mb-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-1.5 flex items-center pb-px",
                                    onClick: function() {
                                        return onClose();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SappBreadcrumbNotLink/* default */.Z, {
                                        isTeacher: userType === urser/* UserType.TEACHER */.F.TEACHER,
                                        paths: (0,_to_consumable_array/* default */.Z)(note === null || note === void 0 ? void 0 : note.course_section_path).reverse()
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-base font-normal text-bw-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "whitespace-pre-wrap break-all ".concat(isExpanded ? "" : "line-clamp-3"),
                                            children: note === null || note === void 0 ? void 0 : note.description
                                        }),
                                        !isExpanded && (note === null || note === void 0 ? void 0 : (ref = note.description) === null || ref === void 0 ? void 0 : ref.length) > 230 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "block text-base font-normal text-gray-1",
                                            onClick: function() {
                                                return toggleExpand(note === null || note === void 0 ? void 0 : note.id);
                                            },
                                            children: "Show more"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: (note === null || note === void 0 ? void 0 : (ref1 = note.description) === null || ref1 === void 0 ? void 0 : ref1.length) > 230 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "block text-base font-normal text-gray-1",
                                                onClick: function() {
                                                    return toggleExpand(note === null || note === void 0 ? void 0 : note.id);
                                                },
                                                children: "Show less"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-5 flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-sm font-normal text-gray-1",
                                            children: (0,format/* format */.WU)(note === null || note === void 0 ? void 0 : note.updated_at, "dd/MM/yyyy HH:mm")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "relative cursor-pointer",
                                                    children: activityId === (note === null || note === void 0 ? void 0 : note.course_section_id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "notes-list-icon",
                                                        onClick: function() {
                                                            if (!getNotesData.some(function(item) {
                                                                return item.id.includes(note === null || note === void 0 ? void 0 : note.id);
                                                            })) {
                                                                handleEditNote(note === null || note === void 0 ? void 0 : note.id, note === null || note === void 0 ? void 0 : note.description, index);
                                                                onClose();
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EditIcon */.dY, {})
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: queryId || courseId ? "".concat(userType === urser/* UserType.TEACHER */.F.TEACHER ? src_constants/* PageLink.TEACHER_MY_COURSE */.H_.TEACHER_MY_COURSE : src_constants/* PageLink.COURSES */.H_.COURSES, "/").concat(queryId || courseId, "/activity/").concat(note === null || note === void 0 ? void 0 : note.course_section_id, "?note_id=").concat(note === null || note === void 0 ? void 0 : note.id) : "#",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "notes-list-icon",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ViewIcon */.ON, {})
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "ms-4 cursor-pointer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        onClick: function() {
                                                            handleDelete(note === null || note === void 0 ? void 0 : note.id);
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DeleteIcon */.pJ, {})
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, note === null || note === void 0 ? void 0 : note.id);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex min-h-[calc(100vh-12rem)] items-center justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoData/* default */.Z, {})
                })
            })
        ]
    });
};
/* harmony default export */ var mycourses_LearningNotesList = (LearningNotesList);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(41492);
// EXTERNAL MODULE: ./src/components/base/modal/SappModalV2.tsx
var SappModalV2 = __webpack_require__(89186);
// EXTERNAL MODULE: ./src/redux/slice/Popup/Result-test.ts
var Result_test = __webpack_require__(72215);
;// CONCATENATED MODULE: ./src/components/mycourses/PopupCompletedCourse.tsx







var PopupCert = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var dispatch = (0,hook/* useAppDispatch */.T)();
    var selector = (0,hook/* useAppSelector */.C)(function(state) {
        return state.popupReducer;
    });
    var onClickBackCourse = function() {
        dispatch({
            type: Result_test/* hidePopup */.hj
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SappModalV2/* default */.Z, {
        title: undefined,
        open: selector.is_open,
        handleCancel: onClickBackCourse,
        onOk: onClickBackCourse,
        // showCancelButton={true}
        size: "max-w-[646px]",
        footerButtonClassName: "flex flex-col-reverse gap-8",
        position: "center",
        fullWidthBtn: true,
        closeAfterSubmit: true,
        buttonSize: "extra",
        scrollbale: false,
        confirmOnclose: false,
        okButtonCaption: "Back",
        // cancelButtonCaption="Back"
        handleClose: onClickBackCourse,
        showOkButton: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto mb-6 flex w-max items-center justify-center rounded-full bg-secondary p-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IRibbon */.sU, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center text-2xl font-semibold text-bw-1 md:text-4xl",
                children: "Congratulations"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorReader/* default */.Z, {
                text_editor_content: selector === null || selector === void 0 ? void 0 : selector.content,
                className: "content-course mt-4 px-1 text-center text-medium-sm text-gray-1"
            })
        ]
    });
};
/* harmony default export */ var PopupCompletedCourse = (PopupCert);

;// CONCATENATED MODULE: ./src/contexts/SocketContext.tsx
// context/SocketContext.tsx

var SocketContext = /*#__PURE__*/ (0,react.createContext)(undefined);

// EXTERNAL MODULE: ./node_modules/@fortune-sheet/react/dist/index.css
var react_dist = __webpack_require__(44462);
// EXTERNAL MODULE: ./src/styles/globals.scss
var globals = __webpack_require__(83272);
// EXTERNAL MODULE: ./node_modules/aos/dist/aos.js
var aos = __webpack_require__(20372);
var aos_default = /*#__PURE__*/__webpack_require__.n(aos);
// EXTERNAL MODULE: ./node_modules/aos/dist/aos.css
var dist_aos = __webpack_require__(66130);
// EXTERNAL MODULE: ./node_modules/react-gtm-module/dist/index.js
var react_gtm_module_dist = __webpack_require__(11598);
var react_gtm_module_dist_default = /*#__PURE__*/__webpack_require__.n(react_gtm_module_dist);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(97478);
;// CONCATENATED MODULE: ./node_modules/engine.io-parser/build/esm/commons.js
const PACKET_TYPES = Object.create(null); // no Map = no polyfill
PACKET_TYPES["open"] = "0";
PACKET_TYPES["close"] = "1";
PACKET_TYPES["ping"] = "2";
PACKET_TYPES["pong"] = "3";
PACKET_TYPES["message"] = "4";
PACKET_TYPES["upgrade"] = "5";
PACKET_TYPES["noop"] = "6";
const PACKET_TYPES_REVERSE = Object.create(null);
Object.keys(PACKET_TYPES).forEach(key => {
  PACKET_TYPES_REVERSE[PACKET_TYPES[key]] = key;
});
const ERROR_PACKET = {
  type: "error",
  data: "parser error"
};

;// CONCATENATED MODULE: ./node_modules/engine.io-parser/build/esm/encodePacket.browser.js

const withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const isView = obj => {
  return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const encodePacket = ({
  type,
  data
}, supportsBinary, callback) => {
  if (withNativeBlob && data instanceof Blob) {
    if (supportsBinary) {
      return callback(data);
    } else {
      return encodeBlobAsBase64(data, callback);
    }
  } else if (withNativeArrayBuffer && (data instanceof ArrayBuffer || isView(data))) {
    if (supportsBinary) {
      return callback(data);
    } else {
      return encodeBlobAsBase64(new Blob([data]), callback);
    }
  }
  // plain string
  return callback(PACKET_TYPES[type] + (data || ""));
};
const encodeBlobAsBase64 = (data, callback) => {
  const fileReader = new FileReader();
  fileReader.onload = function () {
    const content = fileReader.result.split(",")[1];
    callback("b" + (content || ""));
  };
  return fileReader.readAsDataURL(data);
};
function toArray(data) {
  if (data instanceof Uint8Array) {
    return data;
  } else if (data instanceof ArrayBuffer) {
    return new Uint8Array(data);
  } else {
    return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
  }
}
let TEXT_ENCODER;
function encodePacketToBinary(packet, callback) {
  if (withNativeBlob && packet.data instanceof Blob) {
    return packet.data.arrayBuffer().then(toArray).then(callback);
  } else if (withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || isView(packet.data))) {
    return callback(toArray(packet.data));
  }
  encodePacket(packet, false, encoded => {
    if (!TEXT_ENCODER) {
      TEXT_ENCODER = new TextEncoder();
    }
    callback(TEXT_ENCODER.encode(encoded));
  });
}

;// CONCATENATED MODULE: ./node_modules/engine.io-parser/build/esm/contrib/base64-arraybuffer.js
// imported from https://github.com/socketio/base64-arraybuffer
const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for (let i = 0; i < chars.length; i++) {
  lookup[chars.charCodeAt(i)] = i;
}
const encode = arraybuffer => {
  let bytes = new Uint8Array(arraybuffer),
    i,
    len = bytes.length,
    base64 = '';
  for (i = 0; i < len; i += 3) {
    base64 += chars[bytes[i] >> 2];
    base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
    base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
    base64 += chars[bytes[i + 2] & 63];
  }
  if (len % 3 === 2) {
    base64 = base64.substring(0, base64.length - 1) + '=';
  } else if (len % 3 === 1) {
    base64 = base64.substring(0, base64.length - 2) + '==';
  }
  return base64;
};
const decode = base64 => {
  let bufferLength = base64.length * 0.75,
    len = base64.length,
    i,
    p = 0,
    encoded1,
    encoded2,
    encoded3,
    encoded4;
  if (base64[base64.length - 1] === '=') {
    bufferLength--;
    if (base64[base64.length - 2] === '=') {
      bufferLength--;
    }
  }
  const arraybuffer = new ArrayBuffer(bufferLength),
    bytes = new Uint8Array(arraybuffer);
  for (i = 0; i < len; i += 4) {
    encoded1 = lookup[base64.charCodeAt(i)];
    encoded2 = lookup[base64.charCodeAt(i + 1)];
    encoded3 = lookup[base64.charCodeAt(i + 2)];
    encoded4 = lookup[base64.charCodeAt(i + 3)];
    bytes[p++] = encoded1 << 2 | encoded2 >> 4;
    bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
    bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
  }
  return arraybuffer;
};
;// CONCATENATED MODULE: ./node_modules/engine.io-parser/build/esm/decodePacket.browser.js


const decodePacket_browser_withNativeArrayBuffer = typeof ArrayBuffer === "function";
const decodePacket = (encodedPacket, binaryType) => {
  if (typeof encodedPacket !== "string") {
    return {
      type: "message",
      data: mapBinary(encodedPacket, binaryType)
    };
  }
  const type = encodedPacket.charAt(0);
  if (type === "b") {
    return {
      type: "message",
      data: decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
  }
  const packetType = PACKET_TYPES_REVERSE[type];
  if (!packetType) {
    return ERROR_PACKET;
  }
  return encodedPacket.length > 1 ? {
    type: PACKET_TYPES_REVERSE[type],
    data: encodedPacket.substring(1)
  } : {
    type: PACKET_TYPES_REVERSE[type]
  };
};
const decodeBase64Packet = (data, binaryType) => {
  if (decodePacket_browser_withNativeArrayBuffer) {
    const decoded = decode(data);
    return mapBinary(decoded, binaryType);
  } else {
    return {
      base64: true,
      data
    }; // fallback for old browsers
  }
};
const mapBinary = (data, binaryType) => {
  switch (binaryType) {
    case "blob":
      if (data instanceof Blob) {
        // from WebSocket + binaryType "blob"
        return data;
      } else {
        // from HTTP long-polling or WebTransport
        return new Blob([data]);
      }
    case "arraybuffer":
    default:
      if (data instanceof ArrayBuffer) {
        // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
        return data;
      } else {
        // from WebTransport (Uint8Array)
        return data.buffer;
      }
  }
};
;// CONCATENATED MODULE: ./node_modules/engine.io-parser/build/esm/index.js



const SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const encodePayload = (packets, callback) => {
  // some packets may be added to the array while encoding, so the initial length must be saved
  const length = packets.length;
  const encodedPackets = new Array(length);
  let count = 0;
  packets.forEach((packet, i) => {
    // force base64 encoding for binary packets
    encodePacket(packet, false, encodedPacket => {
      encodedPackets[i] = encodedPacket;
      if (++count === length) {
        callback(encodedPackets.join(SEPARATOR));
      }
    });
  });
};
const decodePayload = (encodedPayload, binaryType) => {
  const encodedPackets = encodedPayload.split(SEPARATOR);
  const packets = [];
  for (let i = 0; i < encodedPackets.length; i++) {
    const decodedPacket = decodePacket(encodedPackets[i], binaryType);
    packets.push(decodedPacket);
    if (decodedPacket.type === "error") {
      break;
    }
  }
  return packets;
};
function createPacketEncoderStream() {
  return new TransformStream({
    transform(packet, controller) {
      encodePacketToBinary(packet, encodedPacket => {
        const payloadLength = encodedPacket.length;
        let header;
        // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
        if (payloadLength < 126) {
          header = new Uint8Array(1);
          new DataView(header.buffer).setUint8(0, payloadLength);
        } else if (payloadLength < 65536) {
          header = new Uint8Array(3);
          const view = new DataView(header.buffer);
          view.setUint8(0, 126);
          view.setUint16(1, payloadLength);
        } else {
          header = new Uint8Array(9);
          const view = new DataView(header.buffer);
          view.setUint8(0, 127);
          view.setBigUint64(1, BigInt(payloadLength));
        }
        // first bit indicates whether the payload is plain text (0) or binary (1)
        if (packet.data && typeof packet.data !== "string") {
          header[0] |= 0x80;
        }
        controller.enqueue(header);
        controller.enqueue(encodedPacket);
      });
    }
  });
}
let TEXT_DECODER;
function totalLength(chunks) {
  return chunks.reduce((acc, chunk) => acc + chunk.length, 0);
}
function concatChunks(chunks, size) {
  if (chunks[0].length === size) {
    return chunks.shift();
  }
  const buffer = new Uint8Array(size);
  let j = 0;
  for (let i = 0; i < size; i++) {
    buffer[i] = chunks[0][j++];
    if (j === chunks[0].length) {
      chunks.shift();
      j = 0;
    }
  }
  if (chunks.length && j < chunks[0].length) {
    chunks[0] = chunks[0].slice(j);
  }
  return buffer;
}
function createPacketDecoderStream(maxPayload, binaryType) {
  if (!TEXT_DECODER) {
    TEXT_DECODER = new TextDecoder();
  }
  const chunks = [];
  let state = 0 /* State.READ_HEADER */;
  let expectedLength = -1;
  let isBinary = false;
  return new TransformStream({
    transform(chunk, controller) {
      chunks.push(chunk);
      while (true) {
        if (state === 0 /* State.READ_HEADER */) {
          if (totalLength(chunks) < 1) {
            break;
          }
          const header = concatChunks(chunks, 1);
          isBinary = (header[0] & 0x80) === 0x80;
          expectedLength = header[0] & 0x7f;
          if (expectedLength < 126) {
            state = 3 /* State.READ_PAYLOAD */;
          } else if (expectedLength === 126) {
            state = 1 /* State.READ_EXTENDED_LENGTH_16 */;
          } else {
            state = 2 /* State.READ_EXTENDED_LENGTH_64 */;
          }
        } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */) {
          if (totalLength(chunks) < 2) {
            break;
          }
          const headerArray = concatChunks(chunks, 2);
          expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
          state = 3 /* State.READ_PAYLOAD */;
        } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */) {
          if (totalLength(chunks) < 8) {
            break;
          }
          const headerArray = concatChunks(chunks, 8);
          const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
          const n = view.getUint32(0);
          if (n > Math.pow(2, 53 - 32) - 1) {
            // the maximum safe integer in JavaScript is 2^53 - 1
            controller.enqueue(ERROR_PACKET);
            break;
          }
          expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
          state = 3 /* State.READ_PAYLOAD */;
        } else {
          if (totalLength(chunks) < expectedLength) {
            break;
          }
          const data = concatChunks(chunks, expectedLength);
          controller.enqueue(decodePacket(isBinary ? data : TEXT_DECODER.decode(data), binaryType));
          state = 0 /* State.READ_HEADER */;
        }
        if (expectedLength === 0 || expectedLength > maxPayload) {
          controller.enqueue(ERROR_PACKET);
          break;
        }
      }
    }
  });
}
const protocol = 4;

;// CONCATENATED MODULE: ./node_modules/@socket.io/component-emitter/lib/esm/index.js
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on = Emitter.prototype.addEventListener = function (event, fn) {
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function (event, fn) {
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }
  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function (event, fn) {
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }

  // Remove event specific arrays for event types that no
  // one is subscribed for to avoid memory leak.
  if (callbacks.length === 0) {
    delete this._callbacks['$' + event];
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function (event) {
  this._callbacks = this._callbacks || {};
  var args = new Array(arguments.length - 1),
    callbacks = this._callbacks['$' + event];
  for (var i = 1; i < arguments.length; i++) {
    args[i - 1] = arguments[i];
  }
  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }
  return this;
};

// alias used for reserved events (protected method)
Emitter.prototype.emitReserved = Emitter.prototype.emit;

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function (event) {
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function (event) {
  return !!this.listeners(event).length;
};
;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/globals.js
const nextTick = (() => {
  const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
  if (isPromiseAvailable) {
    return cb => Promise.resolve().then(cb);
  } else {
    return (cb, setTimeoutFn) => setTimeoutFn(cb, 0);
  }
})();
const globalThisShim = (() => {
  if (typeof self !== "undefined") {
    return self;
  } else if (typeof window !== "undefined") {
    return window;
  } else {
    return Function("return this")();
  }
})();
const defaultBinaryType = "arraybuffer";
function createCookieJar() {}
;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/util.js

function pick(obj, ...attr) {
  return attr.reduce((acc, k) => {
    if (obj.hasOwnProperty(k)) {
      acc[k] = obj[k];
    }
    return acc;
  }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const NATIVE_SET_TIMEOUT = globalThisShim.setTimeout;
const NATIVE_CLEAR_TIMEOUT = globalThisShim.clearTimeout;
function installTimerFunctions(obj, opts) {
  if (opts.useNativeTimers) {
    obj.setTimeoutFn = NATIVE_SET_TIMEOUT.bind(globalThisShim);
    obj.clearTimeoutFn = NATIVE_CLEAR_TIMEOUT.bind(globalThisShim);
  } else {
    obj.setTimeoutFn = globalThisShim.setTimeout.bind(globalThisShim);
    obj.clearTimeoutFn = globalThisShim.clearTimeout.bind(globalThisShim);
  }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const BASE64_OVERHEAD = 1.33;
// we could also have used `new Blob([obj]).size`, but it isn't supported in IE9
function byteLength(obj) {
  if (typeof obj === "string") {
    return utf8Length(obj);
  }
  // arraybuffer or blob
  return Math.ceil((obj.byteLength || obj.size) * BASE64_OVERHEAD);
}
function utf8Length(str) {
  let c = 0,
    length = 0;
  for (let i = 0, l = str.length; i < l; i++) {
    c = str.charCodeAt(i);
    if (c < 0x80) {
      length += 1;
    } else if (c < 0x800) {
      length += 2;
    } else if (c < 0xd800 || c >= 0xe000) {
      length += 3;
    } else {
      i++;
      length += 4;
    }
  }
  return length;
}
/**
 * Generates a random 8-characters string.
 */
function randomString() {
  return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}
;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/contrib/parseqs.js
// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */
function parseqs_encode(obj) {
  let str = '';
  for (let i in obj) {
    if (obj.hasOwnProperty(i)) {
      if (str.length) str += '&';
      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
  }
  return str;
}
/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */
function parseqs_decode(qs) {
  let qry = {};
  let pairs = qs.split('&');
  for (let i = 0, l = pairs.length; i < l; i++) {
    let pair = pairs[i].split('=');
    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return qry;
}
;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/transport.js




class TransportError extends Error {
  constructor(reason, description, context) {
    super(reason);
    this.description = description;
    this.context = context;
    this.type = "TransportError";
  }
}
class Transport extends Emitter {
  /**
   * Transport abstract constructor.
   *
   * @param {Object} opts - options
   * @protected
   */
  constructor(opts) {
    super();
    this.writable = false;
    installTimerFunctions(this, opts);
    this.opts = opts;
    this.query = opts.query;
    this.socket = opts.socket;
    this.supportsBinary = !opts.forceBase64;
  }
  /**
   * Emits an error.
   *
   * @param {String} reason
   * @param description
   * @param context - the error context
   * @return {Transport} for chaining
   * @protected
   */
  onError(reason, description, context) {
    super.emitReserved("error", new TransportError(reason, description, context));
    return this;
  }
  /**
   * Opens the transport.
   */
  open() {
    this.readyState = "opening";
    this.doOpen();
    return this;
  }
  /**
   * Closes the transport.
   */
  close() {
    if (this.readyState === "opening" || this.readyState === "open") {
      this.doClose();
      this.onClose();
    }
    return this;
  }
  /**
   * Sends multiple packets.
   *
   * @param {Array} packets
   */
  send(packets) {
    if (this.readyState === "open") {
      this.write(packets);
    } else {
      // this might happen if the transport was silently closed in the beforeunload event handler
    }
  }
  /**
   * Called upon open
   *
   * @protected
   */
  onOpen() {
    this.readyState = "open";
    this.writable = true;
    super.emitReserved("open");
  }
  /**
   * Called with data.
   *
   * @param {String} data
   * @protected
   */
  onData(data) {
    const packet = decodePacket(data, this.socket.binaryType);
    this.onPacket(packet);
  }
  /**
   * Called with a decoded packet.
   *
   * @protected
   */
  onPacket(packet) {
    super.emitReserved("packet", packet);
  }
  /**
   * Called upon close.
   *
   * @protected
   */
  onClose(details) {
    this.readyState = "closed";
    super.emitReserved("close", details);
  }
  /**
   * Pauses the transport, in order not to lose packets during an upgrade.
   *
   * @param onPause
   */
  pause(onPause) {}
  createUri(schema, query = {}) {
    return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
  }
  _hostname() {
    const hostname = this.opts.hostname;
    return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
  }
  _port() {
    if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) {
      return ":" + this.opts.port;
    } else {
      return "";
    }
  }
  _query(query) {
    const encodedQuery = parseqs_encode(query);
    return encodedQuery.length ? "?" + encodedQuery : "";
  }
}
;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/transports/polling.js



class polling_Polling extends Transport {
  constructor() {
    super(...arguments);
    this._polling = false;
  }
  get name() {
    return "polling";
  }
  /**
   * Opens the socket (triggers polling). We write a PING message to determine
   * when the transport is open.
   *
   * @protected
   */
  doOpen() {
    this._poll();
  }
  /**
   * Pauses polling.
   *
   * @param {Function} onPause - callback upon buffers are flushed and transport is paused
   * @package
   */
  pause(onPause) {
    this.readyState = "pausing";
    const pause = () => {
      this.readyState = "paused";
      onPause();
    };
    if (this._polling || !this.writable) {
      let total = 0;
      if (this._polling) {
        total++;
        this.once("pollComplete", function () {
          --total || pause();
        });
      }
      if (!this.writable) {
        total++;
        this.once("drain", function () {
          --total || pause();
        });
      }
    } else {
      pause();
    }
  }
  /**
   * Starts polling cycle.
   *
   * @private
   */
  _poll() {
    this._polling = true;
    this.doPoll();
    this.emitReserved("poll");
  }
  /**
   * Overloads onData to detect payloads.
   *
   * @protected
   */
  onData(data) {
    const callback = packet => {
      // if its the first message we consider the transport open
      if ("opening" === this.readyState && packet.type === "open") {
        this.onOpen();
      }
      // if its a close packet, we close the ongoing requests
      if ("close" === packet.type) {
        this.onClose({
          description: "transport closed by the server"
        });
        return false;
      }
      // otherwise bypass onData and handle the message
      this.onPacket(packet);
    };
    // decode payload
    decodePayload(data, this.socket.binaryType).forEach(callback);
    // if an event did not trigger closing
    if ("closed" !== this.readyState) {
      // if we got data we're not polling
      this._polling = false;
      this.emitReserved("pollComplete");
      if ("open" === this.readyState) {
        this._poll();
      } else {}
    }
  }
  /**
   * For polling, send a close packet.
   *
   * @protected
   */
  doClose() {
    const close = () => {
      this.write([{
        type: "close"
      }]);
    };
    if ("open" === this.readyState) {
      close();
    } else {
      // in case we're trying to close while
      // handshaking is in progress (GH-164)
      this.once("open", close);
    }
  }
  /**
   * Writes a packets payload.
   *
   * @param {Array} packets - data packets
   * @protected
   */
  write(packets) {
    this.writable = false;
    encodePayload(packets, data => {
      this.doWrite(data, () => {
        this.writable = true;
        this.emitReserved("drain");
      });
    });
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const schema = this.opts.secure ? "https" : "http";
    const query = this.query || {};
    // cache busting is forced
    if (false !== this.opts.timestampRequests) {
      query[this.opts.timestampParam] = randomString();
    }
    if (!this.supportsBinary && !query.sid) {
      query.b64 = 1;
    }
    return this.createUri(schema, query);
  }
}
;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/contrib/has-cors.js
// imported from https://github.com/component/has-cors
let value = false;
try {
  value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
  // if XMLHttp support is disabled in IE then it will throw
  // when trying to create
}
const hasCORS = value;
;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/transports/polling-xhr.js





function empty() {}
class BaseXHR extends polling_Polling {
  /**
   * XHR Polling constructor.
   *
   * @param {Object} opts
   * @package
   */
  constructor(opts) {
    super(opts);
    if (typeof location !== "undefined") {
      const isSSL = "https:" === location.protocol;
      let port = location.port;
      // some user agents have empty `location.port`
      if (!port) {
        port = isSSL ? "443" : "80";
      }
      this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
    }
  }
  /**
   * Sends data.
   *
   * @param {String} data to send.
   * @param {Function} called upon flush.
   * @private
   */
  doWrite(data, fn) {
    const req = this.request({
      method: "POST",
      data: data
    });
    req.on("success", fn);
    req.on("error", (xhrStatus, context) => {
      this.onError("xhr post error", xhrStatus, context);
    });
  }
  /**
   * Starts a poll cycle.
   *
   * @private
   */
  doPoll() {
    const req = this.request();
    req.on("data", this.onData.bind(this));
    req.on("error", (xhrStatus, context) => {
      this.onError("xhr poll error", xhrStatus, context);
    });
    this.pollXhr = req;
  }
}
class Request extends Emitter {
  /**
   * Request constructor
   *
   * @param {Object} options
   * @package
   */
  constructor(createRequest, uri, opts) {
    super();
    this.createRequest = createRequest;
    installTimerFunctions(this, opts);
    this._opts = opts;
    this._method = opts.method || "GET";
    this._uri = uri;
    this._data = undefined !== opts.data ? opts.data : null;
    this._create();
  }
  /**
   * Creates the XHR object and sends the request.
   *
   * @private
   */
  _create() {
    var _a;
    const opts = pick(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
    opts.xdomain = !!this._opts.xd;
    const xhr = this._xhr = this.createRequest(opts);
    try {
      xhr.open(this._method, this._uri, true);
      try {
        if (this._opts.extraHeaders) {
          // @ts-ignore
          xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
          for (let i in this._opts.extraHeaders) {
            if (this._opts.extraHeaders.hasOwnProperty(i)) {
              xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
            }
          }
        }
      } catch (e) {}
      if ("POST" === this._method) {
        try {
          xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        } catch (e) {}
      }
      try {
        xhr.setRequestHeader("Accept", "*/*");
      } catch (e) {}
      (_a = this._opts.cookieJar) === null || _a === void 0 ? void 0 : _a.addCookies(xhr);
      // ie6 check
      if ("withCredentials" in xhr) {
        xhr.withCredentials = this._opts.withCredentials;
      }
      if (this._opts.requestTimeout) {
        xhr.timeout = this._opts.requestTimeout;
      }
      xhr.onreadystatechange = () => {
        var _a;
        if (xhr.readyState === 3) {
          (_a = this._opts.cookieJar) === null || _a === void 0 ? void 0 : _a.parseCookies(
          // @ts-ignore
          xhr.getResponseHeader("set-cookie"));
        }
        if (4 !== xhr.readyState) return;
        if (200 === xhr.status || 1223 === xhr.status) {
          this._onLoad();
        } else {
          // make sure the `error` event handler that's user-set
          // does not throw in the same tick and gets caught here
          this.setTimeoutFn(() => {
            this._onError(typeof xhr.status === "number" ? xhr.status : 0);
          }, 0);
        }
      };
      xhr.send(this._data);
    } catch (e) {
      // Need to defer since .create() is called directly from the constructor
      // and thus the 'error' event can only be only bound *after* this exception
      // occurs.  Therefore, also, we cannot throw here at all.
      this.setTimeoutFn(() => {
        this._onError(e);
      }, 0);
      return;
    }
    if (typeof document !== "undefined") {
      this._index = Request.requestsCount++;
      Request.requests[this._index] = this;
    }
  }
  /**
   * Called upon error.
   *
   * @private
   */
  _onError(err) {
    this.emitReserved("error", err, this._xhr);
    this._cleanup(true);
  }
  /**
   * Cleans up house.
   *
   * @private
   */
  _cleanup(fromError) {
    if ("undefined" === typeof this._xhr || null === this._xhr) {
      return;
    }
    this._xhr.onreadystatechange = empty;
    if (fromError) {
      try {
        this._xhr.abort();
      } catch (e) {}
    }
    if (typeof document !== "undefined") {
      delete Request.requests[this._index];
    }
    this._xhr = null;
  }
  /**
   * Called upon load.
   *
   * @private
   */
  _onLoad() {
    const data = this._xhr.responseText;
    if (data !== null) {
      this.emitReserved("data", data);
      this.emitReserved("success");
      this._cleanup();
    }
  }
  /**
   * Aborts the request.
   *
   * @package
   */
  abort() {
    this._cleanup();
  }
}
Request.requestsCount = 0;
Request.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */
if (typeof document !== "undefined") {
  // @ts-ignore
  if (typeof attachEvent === "function") {
    // @ts-ignore
    attachEvent("onunload", unloadHandler);
  } else if (typeof addEventListener === "function") {
    const terminationEvent = "onpagehide" in globalThisShim ? "pagehide" : "unload";
    addEventListener(terminationEvent, unloadHandler, false);
  }
}
function unloadHandler() {
  for (let i in Request.requests) {
    if (Request.requests.hasOwnProperty(i)) {
      Request.requests[i].abort();
    }
  }
}
const hasXHR2 = function () {
  const xhr = newRequest({
    xdomain: false
  });
  return xhr && xhr.responseType !== null;
}();
/**
 * HTTP long-polling based on the built-in `XMLHttpRequest` object.
 *
 * Usage: browser
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest
 */
class XHR extends BaseXHR {
  constructor(opts) {
    super(opts);
    const forceBase64 = opts && opts.forceBase64;
    this.supportsBinary = hasXHR2 && !forceBase64;
  }
  request(opts = {}) {
    Object.assign(opts, {
      xd: this.xd
    }, this.opts);
    return new Request(newRequest, this.uri(), opts);
  }
}
function newRequest(opts) {
  const xdomain = opts.xdomain;
  // XMLHttpRequest can be disabled on IE
  try {
    if ("undefined" !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
      return new XMLHttpRequest();
    }
  } catch (e) {}
  if (!xdomain) {
    try {
      return new globalThisShim[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
  }
}
;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/transports/websocket.js




// detect ReactNative environment
const isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class BaseWS extends Transport {
  get name() {
    return "websocket";
  }
  doOpen() {
    const uri = this.uri();
    const protocols = this.opts.protocols;
    // React Native only supports the 'headers' option, and will print a warning if anything else is passed
    const opts = isReactNative ? {} : pick(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
    if (this.opts.extraHeaders) {
      opts.headers = this.opts.extraHeaders;
    }
    try {
      this.ws = this.createSocket(uri, protocols, opts);
    } catch (err) {
      return this.emitReserved("error", err);
    }
    this.ws.binaryType = this.socket.binaryType;
    this.addEventListeners();
  }
  /**
   * Adds event listeners to the socket
   *
   * @private
   */
  addEventListeners() {
    this.ws.onopen = () => {
      if (this.opts.autoUnref) {
        this.ws._socket.unref();
      }
      this.onOpen();
    };
    this.ws.onclose = closeEvent => this.onClose({
      description: "websocket connection closed",
      context: closeEvent
    });
    this.ws.onmessage = ev => this.onData(ev.data);
    this.ws.onerror = e => this.onError("websocket error", e);
  }
  write(packets) {
    this.writable = false;
    // encodePacket efficient as it uses WS framing
    // no need for encodePayload
    for (let i = 0; i < packets.length; i++) {
      const packet = packets[i];
      const lastPacket = i === packets.length - 1;
      encodePacket(packet, this.supportsBinary, data => {
        // Sometimes the websocket has already been closed but the browser didn't
        // have a chance of informing us about it yet, in that case send will
        // throw an error
        try {
          this.doWrite(packet, data);
        } catch (e) {}
        if (lastPacket) {
          // fake drain
          // defer to next tick to allow Socket to clear writeBuffer
          nextTick(() => {
            this.writable = true;
            this.emitReserved("drain");
          }, this.setTimeoutFn);
        }
      });
    }
  }
  doClose() {
    if (typeof this.ws !== "undefined") {
      this.ws.onerror = () => {};
      this.ws.close();
      this.ws = null;
    }
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const schema = this.opts.secure ? "wss" : "ws";
    const query = this.query || {};
    // append timestamp to URI
    if (this.opts.timestampRequests) {
      query[this.opts.timestampParam] = randomString();
    }
    // communicate binary support capabilities
    if (!this.supportsBinary) {
      query.b64 = 1;
    }
    return this.createUri(schema, query);
  }
}
const WebSocketCtor = globalThisShim.WebSocket || globalThisShim.MozWebSocket;
/**
 * WebSocket transport based on the built-in `WebSocket` object.
 *
 * Usage: browser, Node.js (since v21), Deno, Bun
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket
 * @see https://caniuse.com/mdn-api_websocket
 * @see https://nodejs.org/api/globals.html#websocket
 */
class WS extends BaseWS {
  createSocket(uri, protocols, opts) {
    return !isReactNative ? protocols ? new WebSocketCtor(uri, protocols) : new WebSocketCtor(uri) : new WebSocketCtor(uri, protocols, opts);
  }
  doWrite(_packet, data) {
    this.ws.send(data);
  }
}
;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/transports/webtransport.js



/**
 * WebTransport transport based on the built-in `WebTransport` object.
 *
 * Usage: browser, Node.js (with the `@fails-components/webtransport` package)
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/WebTransport
 * @see https://caniuse.com/webtransport
 */
class WT extends Transport {
  get name() {
    return "webtransport";
  }
  doOpen() {
    try {
      // @ts-ignore
      this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
    } catch (err) {
      return this.emitReserved("error", err);
    }
    this._transport.closed.then(() => {
      this.onClose();
    }).catch(err => {
      this.onError("webtransport error", err);
    });
    // note: we could have used async/await, but that would require some additional polyfills
    this._transport.ready.then(() => {
      this._transport.createBidirectionalStream().then(stream => {
        const decoderStream = createPacketDecoderStream(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
        const reader = stream.readable.pipeThrough(decoderStream).getReader();
        const encoderStream = createPacketEncoderStream();
        encoderStream.readable.pipeTo(stream.writable);
        this._writer = encoderStream.writable.getWriter();
        const read = () => {
          reader.read().then(({
            done,
            value
          }) => {
            if (done) {
              return;
            }
            this.onPacket(value);
            read();
          }).catch(err => {});
        };
        read();
        const packet = {
          type: "open"
        };
        if (this.query.sid) {
          packet.data = `{"sid":"${this.query.sid}"}`;
        }
        this._writer.write(packet).then(() => this.onOpen());
      });
    });
  }
  write(packets) {
    this.writable = false;
    for (let i = 0; i < packets.length; i++) {
      const packet = packets[i];
      const lastPacket = i === packets.length - 1;
      this._writer.write(packet).then(() => {
        if (lastPacket) {
          nextTick(() => {
            this.writable = true;
            this.emitReserved("drain");
          }, this.setTimeoutFn);
        }
      });
    }
  }
  doClose() {
    var _a;
    (_a = this._transport) === null || _a === void 0 ? void 0 : _a.close();
  }
}
;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/transports/index.js



const transports = {
  websocket: WS,
  webtransport: WT,
  polling: XHR
};
;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/contrib/parseuri.js
// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */
const re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const parts = ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'];
function parse(str) {
  if (str.length > 8000) {
    throw "URI too long";
  }
  const src = str,
    b = str.indexOf('['),
    e = str.indexOf(']');
  if (b != -1 && e != -1) {
    str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
  }
  let m = re.exec(str || ''),
    uri = {},
    i = 14;
  while (i--) {
    uri[parts[i]] = m[i] || '';
  }
  if (b != -1 && e != -1) {
    uri.source = src;
    uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
    uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
    uri.ipv6uri = true;
  }
  uri.pathNames = pathNames(uri, uri['path']);
  uri.queryKey = queryKey(uri, uri['query']);
  return uri;
}
function pathNames(obj, path) {
  const regx = /\/{2,9}/g,
    names = path.replace(regx, "/").split("/");
  if (path.slice(0, 1) == '/' || path.length === 0) {
    names.splice(0, 1);
  }
  if (path.slice(-1) == '/') {
    names.splice(names.length - 1, 1);
  }
  return names;
}
function queryKey(uri, query) {
  const data = {};
  query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function ($0, $1, $2) {
    if ($1) {
      data[$1] = $2;
    }
  });
  return data;
}
;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/socket.js







const withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
const OFFLINE_EVENT_LISTENERS = [];
if (withEventListeners) {
  // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
  // script, so we create one single event listener here which will forward the event to the socket instances
  addEventListener("offline", () => {
    OFFLINE_EVENT_LISTENERS.forEach(listener => listener());
  }, false);
}
/**
 * This class provides a WebSocket-like interface to connect to an Engine.IO server. The connection will be established
 * with one of the available low-level transports, like HTTP long-polling, WebSocket or WebTransport.
 *
 * This class comes without upgrade mechanism, which means that it will keep the first low-level transport that
 * successfully establishes the connection.
 *
 * In order to allow tree-shaking, there are no transports included, that's why the `transports` option is mandatory.
 *
 * @example
 * import { SocketWithoutUpgrade, WebSocket } from "engine.io-client";
 *
 * const socket = new SocketWithoutUpgrade({
 *   transports: [WebSocket]
 * });
 *
 * socket.on("open", () => {
 *   socket.send("hello");
 * });
 *
 * @see SocketWithUpgrade
 * @see Socket
 */
class SocketWithoutUpgrade extends Emitter {
  /**
   * Socket constructor.
   *
   * @param {String|Object} uri - uri or options
   * @param {Object} opts - options
   */
  constructor(uri, opts) {
    super();
    this.binaryType = defaultBinaryType;
    this.writeBuffer = [];
    this._prevBufferLen = 0;
    this._pingInterval = -1;
    this._pingTimeout = -1;
    this._maxPayload = -1;
    /**
     * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
     * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
     */
    this._pingTimeoutTime = Infinity;
    if (uri && "object" === typeof uri) {
      opts = uri;
      uri = null;
    }
    if (uri) {
      const parsedUri = parse(uri);
      opts.hostname = parsedUri.host;
      opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
      opts.port = parsedUri.port;
      if (parsedUri.query) opts.query = parsedUri.query;
    } else if (opts.host) {
      opts.hostname = parse(opts.host).host;
    }
    installTimerFunctions(this, opts);
    this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
    if (opts.hostname && !opts.port) {
      // if no port is specified manually, use the protocol default
      opts.port = this.secure ? "443" : "80";
    }
    this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
    this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
    this.transports = [];
    this._transportsByName = {};
    opts.transports.forEach(t => {
      const transportName = t.prototype.name;
      this.transports.push(transportName);
      this._transportsByName[transportName] = t;
    });
    this.opts = Object.assign({
      path: "/engine.io",
      agent: false,
      withCredentials: false,
      upgrade: true,
      timestampParam: "t",
      rememberUpgrade: false,
      addTrailingSlash: true,
      rejectUnauthorized: true,
      perMessageDeflate: {
        threshold: 1024
      },
      transportOptions: {},
      closeOnBeforeunload: false
    }, opts);
    this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
    if (typeof this.opts.query === "string") {
      this.opts.query = parseqs_decode(this.opts.query);
    }
    if (withEventListeners) {
      if (this.opts.closeOnBeforeunload) {
        // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
        // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
        // closed/reloaded)
        this._beforeunloadEventListener = () => {
          if (this.transport) {
            // silently close the transport
            this.transport.removeAllListeners();
            this.transport.close();
          }
        };
        addEventListener("beforeunload", this._beforeunloadEventListener, false);
      }
      if (this.hostname !== "localhost") {
        this._offlineEventListener = () => {
          this._onClose("transport close", {
            description: "network connection lost"
          });
        };
        OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
      }
    }
    if (this.opts.withCredentials) {
      this._cookieJar = createCookieJar();
    }
    this._open();
  }
  /**
   * Creates transport of the given type.
   *
   * @param {String} name - transport name
   * @return {Transport}
   * @private
   */
  createTransport(name) {
    const query = Object.assign({}, this.opts.query);
    // append engine.io protocol identifier
    query.EIO = protocol;
    // transport name
    query.transport = name;
    // session id if we already have one
    if (this.id) query.sid = this.id;
    const opts = Object.assign({}, this.opts, {
      query,
      socket: this,
      hostname: this.hostname,
      secure: this.secure,
      port: this.port
    }, this.opts.transportOptions[name]);
    return new this._transportsByName[name](opts);
  }
  /**
   * Initializes transport to use and starts probe.
   *
   * @private
   */
  _open() {
    if (this.transports.length === 0) {
      // Emit error on next tick so it can be listened to
      this.setTimeoutFn(() => {
        this.emitReserved("error", "No transports available");
      }, 0);
      return;
    }
    const transportName = this.opts.rememberUpgrade && SocketWithoutUpgrade.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
    this.readyState = "opening";
    const transport = this.createTransport(transportName);
    transport.open();
    this.setTransport(transport);
  }
  /**
   * Sets the current transport. Disables the existing one (if any).
   *
   * @private
   */
  setTransport(transport) {
    if (this.transport) {
      this.transport.removeAllListeners();
    }
    // set up transport
    this.transport = transport;
    // set up transport listeners
    transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", reason => this._onClose("transport close", reason));
  }
  /**
   * Called when connection is deemed open.
   *
   * @private
   */
  onOpen() {
    this.readyState = "open";
    SocketWithoutUpgrade.priorWebsocketSuccess = "websocket" === this.transport.name;
    this.emitReserved("open");
    this.flush();
  }
  /**
   * Handles a packet.
   *
   * @private
   */
  _onPacket(packet) {
    if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
      this.emitReserved("packet", packet);
      // Socket is live - any packet counts
      this.emitReserved("heartbeat");
      switch (packet.type) {
        case "open":
          this.onHandshake(JSON.parse(packet.data));
          break;
        case "ping":
          this._sendPacket("pong");
          this.emitReserved("ping");
          this.emitReserved("pong");
          this._resetPingTimeout();
          break;
        case "error":
          const err = new Error("server error");
          // @ts-ignore
          err.code = packet.data;
          this._onError(err);
          break;
        case "message":
          this.emitReserved("data", packet.data);
          this.emitReserved("message", packet.data);
          break;
      }
    } else {}
  }
  /**
   * Called upon handshake completion.
   *
   * @param {Object} data - handshake obj
   * @private
   */
  onHandshake(data) {
    this.emitReserved("handshake", data);
    this.id = data.sid;
    this.transport.query.sid = data.sid;
    this._pingInterval = data.pingInterval;
    this._pingTimeout = data.pingTimeout;
    this._maxPayload = data.maxPayload;
    this.onOpen();
    // In case open handler closes socket
    if ("closed" === this.readyState) return;
    this._resetPingTimeout();
  }
  /**
   * Sets and resets ping timeout timer based on server pings.
   *
   * @private
   */
  _resetPingTimeout() {
    this.clearTimeoutFn(this._pingTimeoutTimer);
    const delay = this._pingInterval + this._pingTimeout;
    this._pingTimeoutTime = Date.now() + delay;
    this._pingTimeoutTimer = this.setTimeoutFn(() => {
      this._onClose("ping timeout");
    }, delay);
    if (this.opts.autoUnref) {
      this._pingTimeoutTimer.unref();
    }
  }
  /**
   * Called on `drain` event
   *
   * @private
   */
  _onDrain() {
    this.writeBuffer.splice(0, this._prevBufferLen);
    // setting prevBufferLen = 0 is very important
    // for example, when upgrading, upgrade packet is sent over,
    // and a nonzero prevBufferLen could cause problems on `drain`
    this._prevBufferLen = 0;
    if (0 === this.writeBuffer.length) {
      this.emitReserved("drain");
    } else {
      this.flush();
    }
  }
  /**
   * Flush write buffers.
   *
   * @private
   */
  flush() {
    if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
      const packets = this._getWritablePackets();
      this.transport.send(packets);
      // keep track of current length of writeBuffer
      // splice writeBuffer and callbackBuffer on `drain`
      this._prevBufferLen = packets.length;
      this.emitReserved("flush");
    }
  }
  /**
   * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
   * long-polling)
   *
   * @private
   */
  _getWritablePackets() {
    const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
    if (!shouldCheckPayloadSize) {
      return this.writeBuffer;
    }
    let payloadSize = 1; // first packet type
    for (let i = 0; i < this.writeBuffer.length; i++) {
      const data = this.writeBuffer[i].data;
      if (data) {
        payloadSize += byteLength(data);
      }
      if (i > 0 && payloadSize > this._maxPayload) {
        return this.writeBuffer.slice(0, i);
      }
      payloadSize += 2; // separator + packet type
    }
    return this.writeBuffer;
  }
  /**
   * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
   *
   * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
   * `write()` method then the message would not be buffered by the Socket.IO client.
   *
   * @return {boolean}
   * @private
   */
  /* private */
  _hasPingExpired() {
    if (!this._pingTimeoutTime) return true;
    const hasExpired = Date.now() > this._pingTimeoutTime;
    if (hasExpired) {
      this._pingTimeoutTime = 0;
      nextTick(() => {
        this._onClose("ping timeout");
      }, this.setTimeoutFn);
    }
    return hasExpired;
  }
  /**
   * Sends a message.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  write(msg, options, fn) {
    this._sendPacket("message", msg, options, fn);
    return this;
  }
  /**
   * Sends a message. Alias of {@link Socket#write}.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  send(msg, options, fn) {
    this._sendPacket("message", msg, options, fn);
    return this;
  }
  /**
   * Sends a packet.
   *
   * @param {String} type: packet type.
   * @param {String} data.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @private
   */
  _sendPacket(type, data, options, fn) {
    if ("function" === typeof data) {
      fn = data;
      data = undefined;
    }
    if ("function" === typeof options) {
      fn = options;
      options = null;
    }
    if ("closing" === this.readyState || "closed" === this.readyState) {
      return;
    }
    options = options || {};
    options.compress = false !== options.compress;
    const packet = {
      type: type,
      data: data,
      options: options
    };
    this.emitReserved("packetCreate", packet);
    this.writeBuffer.push(packet);
    if (fn) this.once("flush", fn);
    this.flush();
  }
  /**
   * Closes the connection.
   */
  close() {
    const close = () => {
      this._onClose("forced close");
      this.transport.close();
    };
    const cleanupAndClose = () => {
      this.off("upgrade", cleanupAndClose);
      this.off("upgradeError", cleanupAndClose);
      close();
    };
    const waitForUpgrade = () => {
      // wait for upgrade to finish since we can't send packets while pausing a transport
      this.once("upgrade", cleanupAndClose);
      this.once("upgradeError", cleanupAndClose);
    };
    if ("opening" === this.readyState || "open" === this.readyState) {
      this.readyState = "closing";
      if (this.writeBuffer.length) {
        this.once("drain", () => {
          if (this.upgrading) {
            waitForUpgrade();
          } else {
            close();
          }
        });
      } else if (this.upgrading) {
        waitForUpgrade();
      } else {
        close();
      }
    }
    return this;
  }
  /**
   * Called upon transport error
   *
   * @private
   */
  _onError(err) {
    SocketWithoutUpgrade.priorWebsocketSuccess = false;
    if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
      this.transports.shift();
      return this._open();
    }
    this.emitReserved("error", err);
    this._onClose("transport error", err);
  }
  /**
   * Called upon transport close.
   *
   * @private
   */
  _onClose(reason, description) {
    if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
      // clear timers
      this.clearTimeoutFn(this._pingTimeoutTimer);
      // stop event from firing again for transport
      this.transport.removeAllListeners("close");
      // ensure transport won't stay open
      this.transport.close();
      // ignore further transport communication
      this.transport.removeAllListeners();
      if (withEventListeners) {
        if (this._beforeunloadEventListener) {
          removeEventListener("beforeunload", this._beforeunloadEventListener, false);
        }
        if (this._offlineEventListener) {
          const i = OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
          if (i !== -1) {
            OFFLINE_EVENT_LISTENERS.splice(i, 1);
          }
        }
      }
      // set ready state
      this.readyState = "closed";
      // clear session id
      this.id = null;
      // emit close event
      this.emitReserved("close", reason, description);
      // clean buffers after, so users can still
      // grab the buffers on `close` event
      this.writeBuffer = [];
      this._prevBufferLen = 0;
    }
  }
}
SocketWithoutUpgrade.protocol = protocol;
/**
 * This class provides a WebSocket-like interface to connect to an Engine.IO server. The connection will be established
 * with one of the available low-level transports, like HTTP long-polling, WebSocket or WebTransport.
 *
 * This class comes with an upgrade mechanism, which means that once the connection is established with the first
 * low-level transport, it will try to upgrade to a better transport.
 *
 * In order to allow tree-shaking, there are no transports included, that's why the `transports` option is mandatory.
 *
 * @example
 * import { SocketWithUpgrade, WebSocket } from "engine.io-client";
 *
 * const socket = new SocketWithUpgrade({
 *   transports: [WebSocket]
 * });
 *
 * socket.on("open", () => {
 *   socket.send("hello");
 * });
 *
 * @see SocketWithoutUpgrade
 * @see Socket
 */
class SocketWithUpgrade extends SocketWithoutUpgrade {
  constructor() {
    super(...arguments);
    this._upgrades = [];
  }
  onOpen() {
    super.onOpen();
    if ("open" === this.readyState && this.opts.upgrade) {
      for (let i = 0; i < this._upgrades.length; i++) {
        this._probe(this._upgrades[i]);
      }
    }
  }
  /**
   * Probes a transport.
   *
   * @param {String} name - transport name
   * @private
   */
  _probe(name) {
    let transport = this.createTransport(name);
    let failed = false;
    SocketWithoutUpgrade.priorWebsocketSuccess = false;
    const onTransportOpen = () => {
      if (failed) return;
      transport.send([{
        type: "ping",
        data: "probe"
      }]);
      transport.once("packet", msg => {
        if (failed) return;
        if ("pong" === msg.type && "probe" === msg.data) {
          this.upgrading = true;
          this.emitReserved("upgrading", transport);
          if (!transport) return;
          SocketWithoutUpgrade.priorWebsocketSuccess = "websocket" === transport.name;
          this.transport.pause(() => {
            if (failed) return;
            if ("closed" === this.readyState) return;
            cleanup();
            this.setTransport(transport);
            transport.send([{
              type: "upgrade"
            }]);
            this.emitReserved("upgrade", transport);
            transport = null;
            this.upgrading = false;
            this.flush();
          });
        } else {
          const err = new Error("probe error");
          // @ts-ignore
          err.transport = transport.name;
          this.emitReserved("upgradeError", err);
        }
      });
    };
    function freezeTransport() {
      if (failed) return;
      // Any callback called by transport should be ignored since now
      failed = true;
      cleanup();
      transport.close();
      transport = null;
    }
    // Handle any error that happens while probing
    const onerror = err => {
      const error = new Error("probe error: " + err);
      // @ts-ignore
      error.transport = transport.name;
      freezeTransport();
      this.emitReserved("upgradeError", error);
    };
    function onTransportClose() {
      onerror("transport closed");
    }
    // When the socket is closed while we're probing
    function onclose() {
      onerror("socket closed");
    }
    // When the socket is upgraded while we're probing
    function onupgrade(to) {
      if (transport && to.name !== transport.name) {
        freezeTransport();
      }
    }
    // Remove all listeners on the transport and on self
    const cleanup = () => {
      transport.removeListener("open", onTransportOpen);
      transport.removeListener("error", onerror);
      transport.removeListener("close", onTransportClose);
      this.off("close", onclose);
      this.off("upgrading", onupgrade);
    };
    transport.once("open", onTransportOpen);
    transport.once("error", onerror);
    transport.once("close", onTransportClose);
    this.once("close", onclose);
    this.once("upgrading", onupgrade);
    if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") {
      // favor WebTransport
      this.setTimeoutFn(() => {
        if (!failed) {
          transport.open();
        }
      }, 200);
    } else {
      transport.open();
    }
  }
  onHandshake(data) {
    this._upgrades = this._filterUpgrades(data.upgrades);
    super.onHandshake(data);
  }
  /**
   * Filters upgrades, returning only those matching client transports.
   *
   * @param {Array} upgrades - server upgrades
   * @private
   */
  _filterUpgrades(upgrades) {
    const filteredUpgrades = [];
    for (let i = 0; i < upgrades.length; i++) {
      if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
    }
    return filteredUpgrades;
  }
}
/**
 * This class provides a WebSocket-like interface to connect to an Engine.IO server. The connection will be established
 * with one of the available low-level transports, like HTTP long-polling, WebSocket or WebTransport.
 *
 * This class comes with an upgrade mechanism, which means that once the connection is established with the first
 * low-level transport, it will try to upgrade to a better transport.
 *
 * @example
 * import { Socket } from "engine.io-client";
 *
 * const socket = new Socket();
 *
 * socket.on("open", () => {
 *   socket.send("hello");
 * });
 *
 * @see SocketWithoutUpgrade
 * @see SocketWithUpgrade
 */
class Socket extends SocketWithUpgrade {
  constructor(uri, opts = {}) {
    const o = typeof uri === "object" ? uri : opts;
    if (!o.transports || o.transports && typeof o.transports[0] === "string") {
      o.transports = (o.transports || ["polling", "websocket", "webtransport"]).map(transportName => transports[transportName]).filter(t => !!t);
    }
    super(uri, o);
  }
}
;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/transports/polling-fetch.js

/**
 * HTTP long-polling based on the built-in `fetch()` method.
 *
 * Usage: browser, Node.js (since v18), Deno, Bun
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/fetch
 * @see https://caniuse.com/fetch
 * @see https://nodejs.org/api/globals.html#fetch
 */
class Fetch extends (/* unused pure expression or super */ null && (Polling)) {
  doPoll() {
    this._fetch().then(res => {
      if (!res.ok) {
        return this.onError("fetch read error", res.status, res);
      }
      res.text().then(data => this.onData(data));
    }).catch(err => {
      this.onError("fetch read error", err);
    });
  }
  doWrite(data, callback) {
    this._fetch(data).then(res => {
      if (!res.ok) {
        return this.onError("fetch write error", res.status, res);
      }
      callback();
    }).catch(err => {
      this.onError("fetch write error", err);
    });
  }
  _fetch(data) {
    var _a;
    const isPost = data !== undefined;
    const headers = new Headers(this.opts.extraHeaders);
    if (isPost) {
      headers.set("content-type", "text/plain;charset=UTF-8");
    }
    (_a = this.socket._cookieJar) === null || _a === void 0 ? void 0 : _a.appendCookies(headers);
    return fetch(this.uri(), {
      method: isPost ? "POST" : "GET",
      body: isPost ? data : null,
      headers,
      credentials: this.opts.withCredentials ? "include" : "omit"
    }).then(res => {
      var _a;
      // @ts-ignore getSetCookie() was added in Node.js v19.7.0
      (_a = this.socket._cookieJar) === null || _a === void 0 ? void 0 : _a.parseCookies(res.headers.getSetCookie());
      return res;
    });
  }
}
;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/index.js



const esm_protocol = Socket.protocol;











;// CONCATENATED MODULE: ./node_modules/socket.io-client/build/esm/url.js

/**
 * URL parser.
 *
 * @param uri - url
 * @param path - the request path of the connection
 * @param loc - An object meant to mimic window.location.
 *        Defaults to window.location.
 * @public
 */
function url(uri, path = "", loc) {
  let obj = uri;
  // default to window.location
  loc = loc || typeof location !== "undefined" && location;
  if (null == uri) uri = loc.protocol + "//" + loc.host;
  // relative path support
  if (typeof uri === "string") {
    if ("/" === uri.charAt(0)) {
      if ("/" === uri.charAt(1)) {
        uri = loc.protocol + uri;
      } else {
        uri = loc.host + uri;
      }
    }
    if (!/^(https?|wss?):\/\//.test(uri)) {
      if ("undefined" !== typeof loc) {
        uri = loc.protocol + "//" + uri;
      } else {
        uri = "https://" + uri;
      }
    }
    // parse
    obj = parse(uri);
  }
  // make sure we treat `localhost:80` and `localhost` equally
  if (!obj.port) {
    if (/^(http|ws)$/.test(obj.protocol)) {
      obj.port = "80";
    } else if (/^(http|ws)s$/.test(obj.protocol)) {
      obj.port = "443";
    }
  }
  obj.path = obj.path || "/";
  const ipv6 = obj.host.indexOf(":") !== -1;
  const host = ipv6 ? "[" + obj.host + "]" : obj.host;
  // define unique id
  obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
  // define href
  obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
  return obj;
}
;// CONCATENATED MODULE: ./node_modules/socket.io-parser/build/esm/is-binary.js
const is_binary_withNativeArrayBuffer = typeof ArrayBuffer === "function";
const is_binary_isView = obj => {
  return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const is_binary_toString = Object.prototype.toString;
const is_binary_withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && is_binary_toString.call(Blob) === "[object BlobConstructor]";
const withNativeFile = typeof File === "function" || typeof File !== "undefined" && is_binary_toString.call(File) === "[object FileConstructor]";
/**
 * Returns true if obj is a Buffer, an ArrayBuffer, a Blob or a File.
 *
 * @private
 */
function isBinary(obj) {
  return is_binary_withNativeArrayBuffer && (obj instanceof ArrayBuffer || is_binary_isView(obj)) || is_binary_withNativeBlob && obj instanceof Blob || withNativeFile && obj instanceof File;
}
function hasBinary(obj, toJSON) {
  if (!obj || typeof obj !== "object") {
    return false;
  }
  if (Array.isArray(obj)) {
    for (let i = 0, l = obj.length; i < l; i++) {
      if (hasBinary(obj[i])) {
        return true;
      }
    }
    return false;
  }
  if (isBinary(obj)) {
    return true;
  }
  if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) {
    return hasBinary(obj.toJSON(), true);
  }
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
      return true;
    }
  }
  return false;
}
;// CONCATENATED MODULE: ./node_modules/socket.io-parser/build/esm/binary.js

/**
 * Replaces every Buffer | ArrayBuffer | Blob | File in packet with a numbered placeholder.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @public
 */
function deconstructPacket(packet) {
  const buffers = [];
  const packetData = packet.data;
  const pack = packet;
  pack.data = _deconstructPacket(packetData, buffers);
  pack.attachments = buffers.length; // number of binary 'attachments'
  return {
    packet: pack,
    buffers: buffers
  };
}
function _deconstructPacket(data, buffers) {
  if (!data) return data;
  if (isBinary(data)) {
    const placeholder = {
      _placeholder: true,
      num: buffers.length
    };
    buffers.push(data);
    return placeholder;
  } else if (Array.isArray(data)) {
    const newData = new Array(data.length);
    for (let i = 0; i < data.length; i++) {
      newData[i] = _deconstructPacket(data[i], buffers);
    }
    return newData;
  } else if (typeof data === "object" && !(data instanceof Date)) {
    const newData = {};
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        newData[key] = _deconstructPacket(data[key], buffers);
      }
    }
    return newData;
  }
  return data;
}
/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @public
 */
function reconstructPacket(packet, buffers) {
  packet.data = _reconstructPacket(packet.data, buffers);
  delete packet.attachments; // no longer useful
  return packet;
}
function _reconstructPacket(data, buffers) {
  if (!data) return data;
  if (data && data._placeholder === true) {
    const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
    if (isIndexValid) {
      return buffers[data.num]; // appropriate buffer (should be natural order anyway)
    } else {
      throw new Error("illegal attachments");
    }
  } else if (Array.isArray(data)) {
    for (let i = 0; i < data.length; i++) {
      data[i] = _reconstructPacket(data[i], buffers);
    }
  } else if (typeof data === "object") {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        data[key] = _reconstructPacket(data[key], buffers);
      }
    }
  }
  return data;
}
;// CONCATENATED MODULE: ./node_modules/socket.io-parser/build/esm/index.js



/**
 * These strings must not be used as event names, as they have a special meaning.
 */
const RESERVED_EVENTS = ["connect", "connect_error", "disconnect", "disconnecting", "newListener", "removeListener" // used by the Node.js EventEmitter
];
/**
 * Protocol version.
 *
 * @public
 */
const build_esm_protocol = 5;
var PacketType;
(function (PacketType) {
  PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
  PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
  PacketType[PacketType["EVENT"] = 2] = "EVENT";
  PacketType[PacketType["ACK"] = 3] = "ACK";
  PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
  PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
  PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})(PacketType || (PacketType = {}));
/**
 * A socket.io Encoder instance
 */
class Encoder {
  /**
   * Encoder constructor
   *
   * @param {function} replacer - custom replacer to pass down to JSON.parse
   */
  constructor(replacer) {
    this.replacer = replacer;
  }
  /**
   * Encode a packet as a single string if non-binary, or as a
   * buffer sequence, depending on packet type.
   *
   * @param {Object} obj - packet object
   */
  encode(obj) {
    if (obj.type === PacketType.EVENT || obj.type === PacketType.ACK) {
      if (hasBinary(obj)) {
        return this.encodeAsBinary({
          type: obj.type === PacketType.EVENT ? PacketType.BINARY_EVENT : PacketType.BINARY_ACK,
          nsp: obj.nsp,
          data: obj.data,
          id: obj.id
        });
      }
    }
    return [this.encodeAsString(obj)];
  }
  /**
   * Encode packet as string.
   */
  encodeAsString(obj) {
    // first is type
    let str = "" + obj.type;
    // attachments if we have them
    if (obj.type === PacketType.BINARY_EVENT || obj.type === PacketType.BINARY_ACK) {
      str += obj.attachments + "-";
    }
    // if we have a namespace other than `/`
    // we append it followed by a comma `,`
    if (obj.nsp && "/" !== obj.nsp) {
      str += obj.nsp + ",";
    }
    // immediately followed by the id
    if (null != obj.id) {
      str += obj.id;
    }
    // json data
    if (null != obj.data) {
      str += JSON.stringify(obj.data, this.replacer);
    }
    return str;
  }
  /**
   * Encode packet as 'buffer sequence' by removing blobs, and
   * deconstructing packet into object with placeholders and
   * a list of buffers.
   */
  encodeAsBinary(obj) {
    const deconstruction = deconstructPacket(obj);
    const pack = this.encodeAsString(deconstruction.packet);
    const buffers = deconstruction.buffers;
    buffers.unshift(pack); // add packet info to beginning of data list
    return buffers; // write all the buffers
  }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function isObject(value) {
  return Object.prototype.toString.call(value) === "[object Object]";
}
/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 */
class Decoder extends Emitter {
  /**
   * Decoder constructor
   *
   * @param {function} reviver - custom reviver to pass down to JSON.stringify
   */
  constructor(reviver) {
    super();
    this.reviver = reviver;
  }
  /**
   * Decodes an encoded packet string into packet JSON.
   *
   * @param {String} obj - encoded packet
   */
  add(obj) {
    let packet;
    if (typeof obj === "string") {
      if (this.reconstructor) {
        throw new Error("got plaintext data when reconstructing a packet");
      }
      packet = this.decodeString(obj);
      const isBinaryEvent = packet.type === PacketType.BINARY_EVENT;
      if (isBinaryEvent || packet.type === PacketType.BINARY_ACK) {
        packet.type = isBinaryEvent ? PacketType.EVENT : PacketType.ACK;
        // binary packet's json
        this.reconstructor = new BinaryReconstructor(packet);
        // no attachments, labeled binary but no binary data to follow
        if (packet.attachments === 0) {
          super.emitReserved("decoded", packet);
        }
      } else {
        // non-binary full packet
        super.emitReserved("decoded", packet);
      }
    } else if (isBinary(obj) || obj.base64) {
      // raw binary data
      if (!this.reconstructor) {
        throw new Error("got binary data when not reconstructing a packet");
      } else {
        packet = this.reconstructor.takeBinaryData(obj);
        if (packet) {
          // received final buffer
          this.reconstructor = null;
          super.emitReserved("decoded", packet);
        }
      }
    } else {
      throw new Error("Unknown type: " + obj);
    }
  }
  /**
   * Decode a packet String (JSON data)
   *
   * @param {String} str
   * @return {Object} packet
   */
  decodeString(str) {
    let i = 0;
    // look up type
    const p = {
      type: Number(str.charAt(0))
    };
    if (PacketType[p.type] === undefined) {
      throw new Error("unknown packet type " + p.type);
    }
    // look up attachments if type binary
    if (p.type === PacketType.BINARY_EVENT || p.type === PacketType.BINARY_ACK) {
      const start = i + 1;
      while (str.charAt(++i) !== "-" && i != str.length) {}
      const buf = str.substring(start, i);
      if (buf != Number(buf) || str.charAt(i) !== "-") {
        throw new Error("Illegal attachments");
      }
      p.attachments = Number(buf);
    }
    // look up namespace (if any)
    if ("/" === str.charAt(i + 1)) {
      const start = i + 1;
      while (++i) {
        const c = str.charAt(i);
        if ("," === c) break;
        if (i === str.length) break;
      }
      p.nsp = str.substring(start, i);
    } else {
      p.nsp = "/";
    }
    // look up id
    const next = str.charAt(i + 1);
    if ("" !== next && Number(next) == next) {
      const start = i + 1;
      while (++i) {
        const c = str.charAt(i);
        if (null == c || Number(c) != c) {
          --i;
          break;
        }
        if (i === str.length) break;
      }
      p.id = Number(str.substring(start, i + 1));
    }
    // look up json data
    if (str.charAt(++i)) {
      const payload = this.tryParse(str.substr(i));
      if (Decoder.isPayloadValid(p.type, payload)) {
        p.data = payload;
      } else {
        throw new Error("invalid payload");
      }
    }
    return p;
  }
  tryParse(str) {
    try {
      return JSON.parse(str, this.reviver);
    } catch (e) {
      return false;
    }
  }
  static isPayloadValid(type, payload) {
    switch (type) {
      case PacketType.CONNECT:
        return isObject(payload);
      case PacketType.DISCONNECT:
        return payload === undefined;
      case PacketType.CONNECT_ERROR:
        return typeof payload === "string" || isObject(payload);
      case PacketType.EVENT:
      case PacketType.BINARY_EVENT:
        return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && RESERVED_EVENTS.indexOf(payload[0]) === -1);
      case PacketType.ACK:
      case PacketType.BINARY_ACK:
        return Array.isArray(payload);
    }
  }
  /**
   * Deallocates a parser's resources
   */
  destroy() {
    if (this.reconstructor) {
      this.reconstructor.finishedReconstruction();
      this.reconstructor = null;
    }
  }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */
class BinaryReconstructor {
  constructor(packet) {
    this.packet = packet;
    this.buffers = [];
    this.reconPack = packet;
  }
  /**
   * Method to be called when binary data received from connection
   * after a BINARY_EVENT packet.
   *
   * @param {Buffer | ArrayBuffer} binData - the raw binary data received
   * @return {null | Object} returns null if more binary data is expected or
   *   a reconstructed packet object if all buffers have been received.
   */
  takeBinaryData(binData) {
    this.buffers.push(binData);
    if (this.buffers.length === this.reconPack.attachments) {
      // done with buffer list
      const packet = reconstructPacket(this.reconPack, this.buffers);
      this.finishedReconstruction();
      return packet;
    }
    return null;
  }
  /**
   * Cleans up binary packet reconstruction variables.
   */
  finishedReconstruction() {
    this.reconPack = null;
    this.buffers = [];
  }
}
;// CONCATENATED MODULE: ./node_modules/socket.io-client/build/esm/on.js
function on(obj, ev, fn) {
  obj.on(ev, fn);
  return function subDestroy() {
    obj.off(ev, fn);
  };
}
;// CONCATENATED MODULE: ./node_modules/socket.io-client/build/esm/socket.js



/**
 * Internal events.
 * These events can't be emitted by the user.
 */
const socket_RESERVED_EVENTS = Object.freeze({
  connect: 1,
  connect_error: 1,
  disconnect: 1,
  disconnecting: 1,
  // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
  newListener: 1,
  removeListener: 1
});
/**
 * A Socket is the fundamental class for interacting with the server.
 *
 * A Socket belongs to a certain Namespace (by default /) and uses an underlying {@link Manager} to communicate.
 *
 * @example
 * const socket = io();
 *
 * socket.on("connect", () => {
 *   console.log("connected");
 * });
 *
 * // send an event to the server
 * socket.emit("foo", "bar");
 *
 * socket.on("foobar", () => {
 *   // an event was received from the server
 * });
 *
 * // upon disconnection
 * socket.on("disconnect", (reason) => {
 *   console.log(`disconnected due to ${reason}`);
 * });
 */
class socket_Socket extends Emitter {
  /**
   * `Socket` constructor.
   */
  constructor(io, nsp, opts) {
    super();
    /**
     * Whether the socket is currently connected to the server.
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.connected); // true
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.connected); // false
     * });
     */
    this.connected = false;
    /**
     * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
     * be transmitted by the server.
     */
    this.recovered = false;
    /**
     * Buffer for packets received before the CONNECT packet
     */
    this.receiveBuffer = [];
    /**
     * Buffer for packets that will be sent once the socket is connected
     */
    this.sendBuffer = [];
    /**
     * The queue of packets to be sent with retry in case of failure.
     *
     * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
     * @private
     */
    this._queue = [];
    /**
     * A sequence to generate the ID of the {@link QueuedPacket}.
     * @private
     */
    this._queueSeq = 0;
    this.ids = 0;
    /**
     * A map containing acknowledgement handlers.
     *
     * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
     *
     * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
     * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
     * - `const value = await socket.emitWithAck("test")`
     *
     * From those that don't:
     *
     * - `socket.emit("test", (value) => { ... });`
     *
     * In the first case, the handlers will be called with an error when:
     *
     * - the timeout is reached
     * - the socket gets disconnected
     *
     * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
     * an acknowledgement from the server.
     *
     * @private
     */
    this.acks = {};
    this.flags = {};
    this.io = io;
    this.nsp = nsp;
    if (opts && opts.auth) {
      this.auth = opts.auth;
    }
    this._opts = Object.assign({}, opts);
    if (this.io._autoConnect) this.open();
  }
  /**
   * Whether the socket is currently disconnected
   *
   * @example
   * const socket = io();
   *
   * socket.on("connect", () => {
   *   console.log(socket.disconnected); // false
   * });
   *
   * socket.on("disconnect", () => {
   *   console.log(socket.disconnected); // true
   * });
   */
  get disconnected() {
    return !this.connected;
  }
  /**
   * Subscribe to open, close and packet events
   *
   * @private
   */
  subEvents() {
    if (this.subs) return;
    const io = this.io;
    this.subs = [on(io, "open", this.onopen.bind(this)), on(io, "packet", this.onpacket.bind(this)), on(io, "error", this.onerror.bind(this)), on(io, "close", this.onclose.bind(this))];
  }
  /**
   * Whether the Socket will try to reconnect when its Manager connects or reconnects.
   *
   * @example
   * const socket = io();
   *
   * console.log(socket.active); // true
   *
   * socket.on("disconnect", (reason) => {
   *   if (reason === "io server disconnect") {
   *     // the disconnection was initiated by the server, you need to manually reconnect
   *     console.log(socket.active); // false
   *   }
   *   // else the socket will automatically try to reconnect
   *   console.log(socket.active); // true
   * });
   */
  get active() {
    return !!this.subs;
  }
  /**
   * "Opens" the socket.
   *
   * @example
   * const socket = io({
   *   autoConnect: false
   * });
   *
   * socket.connect();
   */
  connect() {
    if (this.connected) return this;
    this.subEvents();
    if (!this.io["_reconnecting"]) this.io.open(); // ensure open
    if ("open" === this.io._readyState) this.onopen();
    return this;
  }
  /**
   * Alias for {@link connect()}.
   */
  open() {
    return this.connect();
  }
  /**
   * Sends a `message` event.
   *
   * This method mimics the WebSocket.send() method.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
   *
   * @example
   * socket.send("hello");
   *
   * // this is equivalent to
   * socket.emit("message", "hello");
   *
   * @return self
   */
  send(...args) {
    args.unshift("message");
    this.emit.apply(this, args);
    return this;
  }
  /**
   * Override `emit`.
   * If the event is in `events`, it's emitted normally.
   *
   * @example
   * socket.emit("hello", "world");
   *
   * // all serializable datastructures are supported (no need to call JSON.stringify)
   * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
   *
   * // with an acknowledgement from the server
   * socket.emit("hello", "world", (val) => {
   *   // ...
   * });
   *
   * @return self
   */
  emit(ev, ...args) {
    var _a, _b, _c;
    if (socket_RESERVED_EVENTS.hasOwnProperty(ev)) {
      throw new Error('"' + ev.toString() + '" is a reserved event name');
    }
    args.unshift(ev);
    if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
      this._addToQueue(args);
      return this;
    }
    const packet = {
      type: PacketType.EVENT,
      data: args
    };
    packet.options = {};
    packet.options.compress = this.flags.compress !== false;
    // event ack callback
    if ("function" === typeof args[args.length - 1]) {
      const id = this.ids++;
      const ack = args.pop();
      this._registerAckCallback(id, ack);
      packet.id = id;
    }
    const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
    const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
    const discardPacket = this.flags.volatile && !isTransportWritable;
    if (discardPacket) {} else if (isConnected) {
      this.notifyOutgoingListeners(packet);
      this.packet(packet);
    } else {
      this.sendBuffer.push(packet);
    }
    this.flags = {};
    return this;
  }
  /**
   * @private
   */
  _registerAckCallback(id, ack) {
    var _a;
    const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
    if (timeout === undefined) {
      this.acks[id] = ack;
      return;
    }
    // @ts-ignore
    const timer = this.io.setTimeoutFn(() => {
      delete this.acks[id];
      for (let i = 0; i < this.sendBuffer.length; i++) {
        if (this.sendBuffer[i].id === id) {
          this.sendBuffer.splice(i, 1);
        }
      }
      ack.call(this, new Error("operation has timed out"));
    }, timeout);
    const fn = (...args) => {
      // @ts-ignore
      this.io.clearTimeoutFn(timer);
      ack.apply(this, args);
    };
    fn.withError = true;
    this.acks[id] = fn;
  }
  /**
   * Emits an event and waits for an acknowledgement
   *
   * @example
   * // without timeout
   * const response = await socket.emitWithAck("hello", "world");
   *
   * // with a specific timeout
   * try {
   *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
   * } catch (err) {
   *   // the server did not acknowledge the event in the given delay
   * }
   *
   * @return a Promise that will be fulfilled when the server acknowledges the event
   */
  emitWithAck(ev, ...args) {
    return new Promise((resolve, reject) => {
      const fn = (arg1, arg2) => {
        return arg1 ? reject(arg1) : resolve(arg2);
      };
      fn.withError = true;
      args.push(fn);
      this.emit(ev, ...args);
    });
  }
  /**
   * Add the packet to the queue.
   * @param args
   * @private
   */
  _addToQueue(args) {
    let ack;
    if (typeof args[args.length - 1] === "function") {
      ack = args.pop();
    }
    const packet = {
      id: this._queueSeq++,
      tryCount: 0,
      pending: false,
      args,
      flags: Object.assign({
        fromQueue: true
      }, this.flags)
    };
    args.push((err, ...responseArgs) => {
      if (packet !== this._queue[0]) {
        // the packet has already been acknowledged
        return;
      }
      const hasError = err !== null;
      if (hasError) {
        if (packet.tryCount > this._opts.retries) {
          this._queue.shift();
          if (ack) {
            ack(err);
          }
        }
      } else {
        this._queue.shift();
        if (ack) {
          ack(null, ...responseArgs);
        }
      }
      packet.pending = false;
      return this._drainQueue();
    });
    this._queue.push(packet);
    this._drainQueue();
  }
  /**
   * Send the first packet of the queue, and wait for an acknowledgement from the server.
   * @param force - whether to resend a packet that has not been acknowledged yet
   *
   * @private
   */
  _drainQueue(force = false) {
    if (!this.connected || this._queue.length === 0) {
      return;
    }
    const packet = this._queue[0];
    if (packet.pending && !force) {
      return;
    }
    packet.pending = true;
    packet.tryCount++;
    this.flags = packet.flags;
    this.emit.apply(this, packet.args);
  }
  /**
   * Sends a packet.
   *
   * @param packet
   * @private
   */
  packet(packet) {
    packet.nsp = this.nsp;
    this.io._packet(packet);
  }
  /**
   * Called upon engine `open`.
   *
   * @private
   */
  onopen() {
    if (typeof this.auth == "function") {
      this.auth(data => {
        this._sendConnectPacket(data);
      });
    } else {
      this._sendConnectPacket(this.auth);
    }
  }
  /**
   * Sends a CONNECT packet to initiate the Socket.IO session.
   *
   * @param data
   * @private
   */
  _sendConnectPacket(data) {
    this.packet({
      type: PacketType.CONNECT,
      data: this._pid ? Object.assign({
        pid: this._pid,
        offset: this._lastOffset
      }, data) : data
    });
  }
  /**
   * Called upon engine or manager `error`.
   *
   * @param err
   * @private
   */
  onerror(err) {
    if (!this.connected) {
      this.emitReserved("connect_error", err);
    }
  }
  /**
   * Called upon engine `close`.
   *
   * @param reason
   * @param description
   * @private
   */
  onclose(reason, description) {
    this.connected = false;
    delete this.id;
    this.emitReserved("disconnect", reason, description);
    this._clearAcks();
  }
  /**
   * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
   * the server.
   *
   * @private
   */
  _clearAcks() {
    Object.keys(this.acks).forEach(id => {
      const isBuffered = this.sendBuffer.some(packet => String(packet.id) === id);
      if (!isBuffered) {
        // note: handlers that do not accept an error as first argument are ignored here
        const ack = this.acks[id];
        delete this.acks[id];
        if (ack.withError) {
          ack.call(this, new Error("socket has been disconnected"));
        }
      }
    });
  }
  /**
   * Called with socket packet.
   *
   * @param packet
   * @private
   */
  onpacket(packet) {
    const sameNamespace = packet.nsp === this.nsp;
    if (!sameNamespace) return;
    switch (packet.type) {
      case PacketType.CONNECT:
        if (packet.data && packet.data.sid) {
          this.onconnect(packet.data.sid, packet.data.pid);
        } else {
          this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
        }
        break;
      case PacketType.EVENT:
      case PacketType.BINARY_EVENT:
        this.onevent(packet);
        break;
      case PacketType.ACK:
      case PacketType.BINARY_ACK:
        this.onack(packet);
        break;
      case PacketType.DISCONNECT:
        this.ondisconnect();
        break;
      case PacketType.CONNECT_ERROR:
        this.destroy();
        const err = new Error(packet.data.message);
        // @ts-ignore
        err.data = packet.data.data;
        this.emitReserved("connect_error", err);
        break;
    }
  }
  /**
   * Called upon a server event.
   *
   * @param packet
   * @private
   */
  onevent(packet) {
    const args = packet.data || [];
    if (null != packet.id) {
      args.push(this.ack(packet.id));
    }
    if (this.connected) {
      this.emitEvent(args);
    } else {
      this.receiveBuffer.push(Object.freeze(args));
    }
  }
  emitEvent(args) {
    if (this._anyListeners && this._anyListeners.length) {
      const listeners = this._anyListeners.slice();
      for (const listener of listeners) {
        listener.apply(this, args);
      }
    }
    super.emit.apply(this, args);
    if (this._pid && args.length && typeof args[args.length - 1] === "string") {
      this._lastOffset = args[args.length - 1];
    }
  }
  /**
   * Produces an ack callback to emit with an event.
   *
   * @private
   */
  ack(id) {
    const self = this;
    let sent = false;
    return function (...args) {
      // prevent double callbacks
      if (sent) return;
      sent = true;
      self.packet({
        type: PacketType.ACK,
        id: id,
        data: args
      });
    };
  }
  /**
   * Called upon a server acknowledgement.
   *
   * @param packet
   * @private
   */
  onack(packet) {
    const ack = this.acks[packet.id];
    if (typeof ack !== "function") {
      return;
    }
    delete this.acks[packet.id];
    // @ts-ignore FIXME ack is incorrectly inferred as 'never'
    if (ack.withError) {
      packet.data.unshift(null);
    }
    // @ts-ignore
    ack.apply(this, packet.data);
  }
  /**
   * Called upon server connect.
   *
   * @private
   */
  onconnect(id, pid) {
    this.id = id;
    this.recovered = pid && this._pid === pid;
    this._pid = pid; // defined only if connection state recovery is enabled
    this.connected = true;
    this.emitBuffered();
    this.emitReserved("connect");
    this._drainQueue(true);
  }
  /**
   * Emit buffered events (received and emitted).
   *
   * @private
   */
  emitBuffered() {
    this.receiveBuffer.forEach(args => this.emitEvent(args));
    this.receiveBuffer = [];
    this.sendBuffer.forEach(packet => {
      this.notifyOutgoingListeners(packet);
      this.packet(packet);
    });
    this.sendBuffer = [];
  }
  /**
   * Called upon server disconnect.
   *
   * @private
   */
  ondisconnect() {
    this.destroy();
    this.onclose("io server disconnect");
  }
  /**
   * Called upon forced client/server side disconnections,
   * this method ensures the manager stops tracking us and
   * that reconnections don't get triggered for this.
   *
   * @private
   */
  destroy() {
    if (this.subs) {
      // clean subscriptions to avoid reconnections
      this.subs.forEach(subDestroy => subDestroy());
      this.subs = undefined;
    }
    this.io["_destroy"](this);
  }
  /**
   * Disconnects the socket manually. In that case, the socket will not try to reconnect.
   *
   * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
   *
   * @example
   * const socket = io();
   *
   * socket.on("disconnect", (reason) => {
   *   // console.log(reason); prints "io client disconnect"
   * });
   *
   * socket.disconnect();
   *
   * @return self
   */
  disconnect() {
    if (this.connected) {
      this.packet({
        type: PacketType.DISCONNECT
      });
    }
    // remove socket from pool
    this.destroy();
    if (this.connected) {
      // fire events
      this.onclose("io client disconnect");
    }
    return this;
  }
  /**
   * Alias for {@link disconnect()}.
   *
   * @return self
   */
  close() {
    return this.disconnect();
  }
  /**
   * Sets the compress flag.
   *
   * @example
   * socket.compress(false).emit("hello");
   *
   * @param compress - if `true`, compresses the sending data
   * @return self
   */
  compress(compress) {
    this.flags.compress = compress;
    return this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
   * ready to send messages.
   *
   * @example
   * socket.volatile.emit("hello"); // the server may or may not receive it
   *
   * @returns self
   */
  get volatile() {
    this.flags.volatile = true;
    return this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
   * given number of milliseconds have elapsed without an acknowledgement from the server:
   *
   * @example
   * socket.timeout(5000).emit("my-event", (err) => {
   *   if (err) {
   *     // the server did not acknowledge the event in the given delay
   *   }
   * });
   *
   * @returns self
   */
  timeout(timeout) {
    this.flags.timeout = timeout;
    return this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * @example
   * socket.onAny((event, ...args) => {
   *   console.log(`got ${event}`);
   * });
   *
   * @param listener
   */
  onAny(listener) {
    this._anyListeners = this._anyListeners || [];
    this._anyListeners.push(listener);
    return this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * @example
   * socket.prependAny((event, ...args) => {
   *   console.log(`got event ${event}`);
   * });
   *
   * @param listener
   */
  prependAny(listener) {
    this._anyListeners = this._anyListeners || [];
    this._anyListeners.unshift(listener);
    return this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`got event ${event}`);
   * }
   *
   * socket.onAny(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAny(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAny();
   *
   * @param listener
   */
  offAny(listener) {
    if (!this._anyListeners) {
      return this;
    }
    if (listener) {
      const listeners = this._anyListeners;
      for (let i = 0; i < listeners.length; i++) {
        if (listener === listeners[i]) {
          listeners.splice(i, 1);
          return this;
        }
      }
    } else {
      this._anyListeners = [];
    }
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAny() {
    return this._anyListeners || [];
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.onAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  onAnyOutgoing(listener) {
    this._anyOutgoingListeners = this._anyOutgoingListeners || [];
    this._anyOutgoingListeners.push(listener);
    return this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.prependAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  prependAnyOutgoing(listener) {
    this._anyOutgoingListeners = this._anyOutgoingListeners || [];
    this._anyOutgoingListeners.unshift(listener);
    return this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`sent event ${event}`);
   * }
   *
   * socket.onAnyOutgoing(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAnyOutgoing(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAnyOutgoing();
   *
   * @param [listener] - the catch-all listener (optional)
   */
  offAnyOutgoing(listener) {
    if (!this._anyOutgoingListeners) {
      return this;
    }
    if (listener) {
      const listeners = this._anyOutgoingListeners;
      for (let i = 0; i < listeners.length; i++) {
        if (listener === listeners[i]) {
          listeners.splice(i, 1);
          return this;
        }
      }
    } else {
      this._anyOutgoingListeners = [];
    }
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAnyOutgoing() {
    return this._anyOutgoingListeners || [];
  }
  /**
   * Notify the listeners for each packet sent
   *
   * @param packet
   *
   * @private
   */
  notifyOutgoingListeners(packet) {
    if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
      const listeners = this._anyOutgoingListeners.slice();
      for (const listener of listeners) {
        listener.apply(this, packet.data);
      }
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/socket.io-client/build/esm/contrib/backo2.js
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */
function Backoff(opts) {
  opts = opts || {};
  this.ms = opts.min || 100;
  this.max = opts.max || 10000;
  this.factor = opts.factor || 2;
  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
  this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */
Backoff.prototype.duration = function () {
  var ms = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var rand = Math.random();
    var deviation = Math.floor(rand * this.jitter * ms);
    ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
  }
  return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */
Backoff.prototype.reset = function () {
  this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */
Backoff.prototype.setMin = function (min) {
  this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */
Backoff.prototype.setMax = function (max) {
  this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */
Backoff.prototype.setJitter = function (jitter) {
  this.jitter = jitter;
};
;// CONCATENATED MODULE: ./node_modules/socket.io-client/build/esm/manager.js






class Manager extends Emitter {
  constructor(uri, opts) {
    var _a;
    super();
    this.nsps = {};
    this.subs = [];
    if (uri && "object" === typeof uri) {
      opts = uri;
      uri = undefined;
    }
    opts = opts || {};
    opts.path = opts.path || "/socket.io";
    this.opts = opts;
    installTimerFunctions(this, opts);
    this.reconnection(opts.reconnection !== false);
    this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
    this.reconnectionDelay(opts.reconnectionDelay || 1000);
    this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
    this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
    this.backoff = new Backoff({
      min: this.reconnectionDelay(),
      max: this.reconnectionDelayMax(),
      jitter: this.randomizationFactor()
    });
    this.timeout(null == opts.timeout ? 20000 : opts.timeout);
    this._readyState = "closed";
    this.uri = uri;
    const _parser = opts.parser || socket_io_parser_build_esm_namespaceObject;
    this.encoder = new _parser.Encoder();
    this.decoder = new _parser.Decoder();
    this._autoConnect = opts.autoConnect !== false;
    if (this._autoConnect) this.open();
  }
  reconnection(v) {
    if (!arguments.length) return this._reconnection;
    this._reconnection = !!v;
    if (!v) {
      this.skipReconnect = true;
    }
    return this;
  }
  reconnectionAttempts(v) {
    if (v === undefined) return this._reconnectionAttempts;
    this._reconnectionAttempts = v;
    return this;
  }
  reconnectionDelay(v) {
    var _a;
    if (v === undefined) return this._reconnectionDelay;
    this._reconnectionDelay = v;
    (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setMin(v);
    return this;
  }
  randomizationFactor(v) {
    var _a;
    if (v === undefined) return this._randomizationFactor;
    this._randomizationFactor = v;
    (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setJitter(v);
    return this;
  }
  reconnectionDelayMax(v) {
    var _a;
    if (v === undefined) return this._reconnectionDelayMax;
    this._reconnectionDelayMax = v;
    (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setMax(v);
    return this;
  }
  timeout(v) {
    if (!arguments.length) return this._timeout;
    this._timeout = v;
    return this;
  }
  /**
   * Starts trying to reconnect if reconnection is enabled and we have not
   * started reconnecting yet
   *
   * @private
   */
  maybeReconnectOnOpen() {
    // Only try to reconnect if it's the first time we're connecting
    if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) {
      // keeps reconnection from firing twice for the same reconnection loop
      this.reconnect();
    }
  }
  /**
   * Sets the current transport `socket`.
   *
   * @param {Function} fn - optional, callback
   * @return self
   * @public
   */
  open(fn) {
    if (~this._readyState.indexOf("open")) return this;
    this.engine = new Socket(this.uri, this.opts);
    const socket = this.engine;
    const self = this;
    this._readyState = "opening";
    this.skipReconnect = false;
    // emit `open`
    const openSubDestroy = on(socket, "open", function () {
      self.onopen();
      fn && fn();
    });
    const onError = err => {
      this.cleanup();
      this._readyState = "closed";
      this.emitReserved("error", err);
      if (fn) {
        fn(err);
      } else {
        // Only do this if there is no fn to handle the error
        this.maybeReconnectOnOpen();
      }
    };
    // emit `error`
    const errorSub = on(socket, "error", onError);
    if (false !== this._timeout) {
      const timeout = this._timeout;
      // set timer
      const timer = this.setTimeoutFn(() => {
        openSubDestroy();
        onError(new Error("timeout"));
        socket.close();
      }, timeout);
      if (this.opts.autoUnref) {
        timer.unref();
      }
      this.subs.push(() => {
        this.clearTimeoutFn(timer);
      });
    }
    this.subs.push(openSubDestroy);
    this.subs.push(errorSub);
    return this;
  }
  /**
   * Alias for open()
   *
   * @return self
   * @public
   */
  connect(fn) {
    return this.open(fn);
  }
  /**
   * Called upon transport open.
   *
   * @private
   */
  onopen() {
    // clear old subs
    this.cleanup();
    // mark as open
    this._readyState = "open";
    this.emitReserved("open");
    // add new subs
    const socket = this.engine;
    this.subs.push(on(socket, "ping", this.onping.bind(this)), on(socket, "data", this.ondata.bind(this)), on(socket, "error", this.onerror.bind(this)), on(socket, "close", this.onclose.bind(this)),
    // @ts-ignore
    on(this.decoder, "decoded", this.ondecoded.bind(this)));
  }
  /**
   * Called upon a ping.
   *
   * @private
   */
  onping() {
    this.emitReserved("ping");
  }
  /**
   * Called with data.
   *
   * @private
   */
  ondata(data) {
    try {
      this.decoder.add(data);
    } catch (e) {
      this.onclose("parse error", e);
    }
  }
  /**
   * Called when parser fully decodes a packet.
   *
   * @private
   */
  ondecoded(packet) {
    // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
    nextTick(() => {
      this.emitReserved("packet", packet);
    }, this.setTimeoutFn);
  }
  /**
   * Called upon socket error.
   *
   * @private
   */
  onerror(err) {
    this.emitReserved("error", err);
  }
  /**
   * Creates a new socket for the given `nsp`.
   *
   * @return {Socket}
   * @public
   */
  socket(nsp, opts) {
    let socket = this.nsps[nsp];
    if (!socket) {
      socket = new socket_Socket(this, nsp, opts);
      this.nsps[nsp] = socket;
    } else if (this._autoConnect && !socket.active) {
      socket.connect();
    }
    return socket;
  }
  /**
   * Called upon a socket close.
   *
   * @param socket
   * @private
   */
  _destroy(socket) {
    const nsps = Object.keys(this.nsps);
    for (const nsp of nsps) {
      const socket = this.nsps[nsp];
      if (socket.active) {
        return;
      }
    }
    this._close();
  }
  /**
   * Writes a packet.
   *
   * @param packet
   * @private
   */
  _packet(packet) {
    const encodedPackets = this.encoder.encode(packet);
    for (let i = 0; i < encodedPackets.length; i++) {
      this.engine.write(encodedPackets[i], packet.options);
    }
  }
  /**
   * Clean up transport subscriptions and packet buffer.
   *
   * @private
   */
  cleanup() {
    this.subs.forEach(subDestroy => subDestroy());
    this.subs.length = 0;
    this.decoder.destroy();
  }
  /**
   * Close the current socket.
   *
   * @private
   */
  _close() {
    this.skipReconnect = true;
    this._reconnecting = false;
    this.onclose("forced close");
  }
  /**
   * Alias for close()
   *
   * @private
   */
  disconnect() {
    return this._close();
  }
  /**
   * Called when:
   *
   * - the low-level engine is closed
   * - the parser encountered a badly formatted packet
   * - all sockets are disconnected
   *
   * @private
   */
  onclose(reason, description) {
    var _a;
    this.cleanup();
    (_a = this.engine) === null || _a === void 0 ? void 0 : _a.close();
    this.backoff.reset();
    this._readyState = "closed";
    this.emitReserved("close", reason, description);
    if (this._reconnection && !this.skipReconnect) {
      this.reconnect();
    }
  }
  /**
   * Attempt a reconnection.
   *
   * @private
   */
  reconnect() {
    if (this._reconnecting || this.skipReconnect) return this;
    const self = this;
    if (this.backoff.attempts >= this._reconnectionAttempts) {
      this.backoff.reset();
      this.emitReserved("reconnect_failed");
      this._reconnecting = false;
    } else {
      const delay = this.backoff.duration();
      this._reconnecting = true;
      const timer = this.setTimeoutFn(() => {
        if (self.skipReconnect) return;
        this.emitReserved("reconnect_attempt", self.backoff.attempts);
        // check again for the case socket closed in above events
        if (self.skipReconnect) return;
        self.open(err => {
          if (err) {
            self._reconnecting = false;
            self.reconnect();
            this.emitReserved("reconnect_error", err);
          } else {
            self.onreconnect();
          }
        });
      }, delay);
      if (this.opts.autoUnref) {
        timer.unref();
      }
      this.subs.push(() => {
        this.clearTimeoutFn(timer);
      });
    }
  }
  /**
   * Called upon successful reconnect.
   *
   * @private
   */
  onreconnect() {
    const attempt = this.backoff.attempts;
    this._reconnecting = false;
    this.backoff.reset();
    this.emitReserved("reconnect", attempt);
  }
}
;// CONCATENATED MODULE: ./node_modules/socket.io-client/build/esm/index.js



/**
 * Managers cache.
 */
const cache = {};
function esm_lookup(uri, opts) {
  if (typeof uri === "object") {
    opts = uri;
    uri = undefined;
  }
  opts = opts || {};
  const parsed = url(uri, opts.path || "/socket.io");
  const source = parsed.source;
  const id = parsed.id;
  const path = parsed.path;
  const sameNamespace = cache[id] && path in cache[id]["nsps"];
  const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
  let io;
  if (newConnection) {
    io = new Manager(source, opts);
  } else {
    if (!cache[id]) {
      cache[id] = new Manager(source, opts);
    }
    io = cache[id];
  }
  if (parsed.query && !opts.query) {
    opts.query = parsed.queryKey;
  }
  return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign(esm_lookup, {
  Manager: Manager,
  Socket: socket_Socket,
  io: esm_lookup,
  connect: esm_lookup
});
/**
 * Protocol version.
 *
 * @public
 */

/**
 * Expose constructors for standalone build.
 *
 * @public
 */


// EXTERNAL MODULE: ./src/redux/services/httpService.ts
var httpService = __webpack_require__(92816);
// EXTERNAL MODULE: ./src/redux/slice/Notification/Notification.ts
var Notification = __webpack_require__(9747);
// EXTERNAL MODULE: ./src/utils/firebase.ts + 13 modules
var firebase = __webpack_require__(83509);
// EXTERNAL MODULE: ./src/utils/helpers/keycloak.ts + 6 modules
var keycloak = __webpack_require__(3787);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 2 modules
var redux_toolkit_esm = __webpack_require__(2249);
;// CONCATENATED MODULE: ./node_modules/next-redux-wrapper/es6/index.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};



/**
 * Quick note on Next.js return types:
 *
 * Page.getInitialProps https://nextjs.org/docs/api-reference/data-fetching/getInitialProps
 * as-is
 *
 * App.getInitialProps: AppInitialProps https://nextjs.org/docs/advanced-features/custom-app
 * {pageProps: any}
 *
 * getStaticProps https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
 * {props: any}
 *
 * getServerSideProps https://nextjs.org/docs/basic-features/data-fetching#getserversideprops-server-side-rendering
 * {props: any}
 */
var HYDRATE = '__NEXT_REDUX_WRAPPER_HYDRATE__';
var getIsServer = function () {
  return typeof window === 'undefined';
};
var getDeserializedState = function (initialState, _a) {
  var _b = _a === void 0 ? {} : _a,
    deserializeState = _b.deserializeState;
  return deserializeState ? deserializeState(initialState) : initialState;
};
var getSerializedState = function (state, _a) {
  var _b = _a === void 0 ? {} : _a,
    serializeState = _b.serializeState;
  return serializeState ? serializeState(state) : state;
};
var sharedClientStore;
var initStore = function (_a) {
  var _b, _c, _d;
  var makeStore = _a.makeStore,
    _e = _a.context,
    context = _e === void 0 ? {} : _e;
  var createStore = function () {
    return makeStore(context);
  };
  if (getIsServer()) {
    var req = ((_b = context) === null || _b === void 0 ? void 0 : _b.req) || ((_d = (_c = context) === null || _c === void 0 ? void 0 : _c.ctx) === null || _d === void 0 ? void 0 : _d.req);
    if (req) {
      // ATTENTION! THIS IS INTERNAL, DO NOT ACCESS DIRECTLY ANYWHERE ELSE
      // @see https://github.com/kirill-konshin/next-redux-wrapper/pull/196#issuecomment-611673546
      if (!req.__nextReduxWrapperStore) {
        req.__nextReduxWrapperStore = createStore(); // Used in GIP/GSSP
      }
      return req.__nextReduxWrapperStore;
    }
    return createStore();
  }
  // Memoize the store if we're on the client
  if (!sharedClientStore) {
    sharedClientStore = createStore();
  }
  return sharedClientStore;
};
var createWrapper = function (makeStore, config) {
  if (config === void 0) {
    config = {};
  }
  var makeProps = function (_a) {
    var callback = _a.callback,
      context = _a.context,
      _b = _a.addStoreToContext,
      addStoreToContext = _b === void 0 ? false : _b;
    return __awaiter(void 0, void 0, void 0, function () {
      var store, nextCallback, initialProps, _c, state;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            store = initStore({
              context: context,
              makeStore: makeStore
            });
            if (config.debug) {
              console.log("1. getProps created store with state", store.getState());
            }
            // Legacy stuff - put store in context
            if (addStoreToContext) {
              if (context.ctx) {
                context.ctx.store = store;
              } else {
                context.store = store;
              }
            }
            nextCallback = callback && callback(store);
            _c = nextCallback;
            if (!_c) return [3 /*break*/, 2];
            return [4 /*yield*/, nextCallback(context)];
          case 1:
            _c = _d.sent();
            _d.label = 2;
          case 2:
            initialProps = _c || {};
            if (config.debug) {
              console.log("3. getProps after dispatches has store state", store.getState());
            }
            state = store.getState();
            return [2 /*return*/, {
              initialProps: initialProps,
              initialState: getIsServer() ? getSerializedState(state, config) : state
            }];
        }
      });
    });
  };
  var getInitialPageProps = function (callback) {
    return function (context) {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              // context is store — avoid double-wrapping
              if ('getState' in context) {
                return [2 /*return*/, callback && callback(context)];
              }
              return [4 /*yield*/, makeProps({
                callback: callback,
                context: context,
                addStoreToContext: true
              })];
            case 1:
              return [2 /*return*/, _a.sent()];
          }
        });
      });
    };
  };
  var getInitialAppProps = function (callback) {
    return function (context) {
      return __awaiter(void 0, void 0, void 0, function () {
        var _a, initialProps, initialState;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4 /*yield*/, makeProps({
                callback: callback,
                context: context,
                addStoreToContext: true
              })];
            case 1:
              _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
              return [2 /*return*/, __assign(__assign({}, initialProps), {
                initialState: initialState
              })];
          }
        });
      });
    };
  };
  var getStaticProps = function (callback) {
    return function (context) {
      return __awaiter(void 0, void 0, void 0, function () {
        var _a, initialProps, initialState;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4 /*yield*/, makeProps({
                callback: callback,
                context: context
              })];
            case 1:
              _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
              return [2 /*return*/, __assign(__assign({}, initialProps), {
                props: __assign(__assign({}, initialProps.props), {
                  initialState: initialState
                })
              })];
          }
        });
      });
    };
  };
  var getServerSideProps = function (callback) {
    return function (context) {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, getStaticProps(callback)(context)];
            case 1:
              return [2 /*return*/, _a.sent()];
          }
        });
      });
    };
  }; // just not to repeat myself
  var hydrate = function (store, state) {
    if (!state) {
      return;
    }
    store.dispatch({
      type: HYDRATE,
      payload: getDeserializedState(state, config)
    });
  };
  var hydrateOrchestrator = function (store, giapState, gspState, gsspState, gippState) {
    var _a;
    if (gspState) {
      // If GSP has run, then gspState will _not_ contain the data from GIP (if it exists), because GSP is run at build time,
      // and GIP runs at request time. So we have to hydrate the GIP data first, and then do another hydrate on the gspState.
      hydrate(store, giapState);
      hydrate(store, gspState);
    } else if (gsspState || gippState || giapState) {
      // If GSSP has run, then gsspState _will_ contain the data from GIP (if there is a GIP) and the GSSP data combined
      // (see https://github.com/kirill-konshin/next-redux-wrapper/pull/499#discussion_r1014500941).
      // If there is no GSP or GSSP for this page, but there is a GIP on page level (not _app), then we use the gippState.
      // If there is no GSP or GSSP and no GIP on page level for this page, but there is a GIP on _app level, then we use the giapState.
      hydrate(store, (_a = gsspState !== null && gsspState !== void 0 ? gsspState : gippState) !== null && _a !== void 0 ? _a : giapState);
    }
  };
  var useHybridHydrate = function (store, giapState, gspState, gsspState, gippState) {
    var events = (0,next_router.useRouter)().events;
    var shouldHydrate = (0,react.useRef)(true);
    // We should only hydrate when the router has changed routes
    (0,react.useEffect)(function () {
      var handleStart = function () {
        shouldHydrate.current = true;
      };
      events === null || events === void 0 ? void 0 : events.on('routeChangeStart', handleStart);
      return function () {
        events === null || events === void 0 ? void 0 : events.off('routeChangeStart', handleStart);
      };
    }, [events]);
    // useMemo so that when we navigate client side, we always synchronously hydrate the state before the new page
    // components are mounted. This means we hydrate while the previous page components are still mounted.
    // You might think that might cause issues because the selectors on the previous page (still mounted) will suddenly
    // contain other data, and maybe even nested properties, causing null reference exceptions.
    // But that's not the case.
    // Hydrating in useMemo will not trigger a rerender of the still mounted page component. So if your selectors do have
    // some initial state values causing them to rerun after hydration, and you're accessing deeply nested values inside your
    // components, you still wouldn't get errors, because there's no rerender.
    // Instead, React will render the new page components straight away, which will have selectors with the correct data.
    (0,react.useMemo)(function () {
      if (shouldHydrate.current) {
        hydrateOrchestrator(store, giapState, gspState, gsspState, gippState);
        shouldHydrate.current = false;
      }
    }, [store, giapState, gspState, gsspState, gippState]);
  };
  // giapState stands for getInitialAppProps state
  var useWrappedStore = function (_a, displayName) {
    var _b, _c, _d, _e, _f, _g;
    if (displayName === void 0) {
      displayName = 'useWrappedStore';
    }
    var giapState = _a.initialState,
      initialProps = _a.initialProps,
      props = __rest(_a, ["initialState", "initialProps"]);
    // getStaticProps state
    var gspState = (props === null || props === void 0 ? void 0 : props.__N_SSG) ? (_b = props === null || props === void 0 ? void 0 : props.pageProps) === null || _b === void 0 ? void 0 : _b.initialState : null;
    // getServerSideProps state
    var gsspState = (props === null || props === void 0 ? void 0 : props.__N_SSP) ? (_c = props === null || props === void 0 ? void 0 : props.pageProps) === null || _c === void 0 ? void 0 : _c.initialState : null;
    // getInitialPageProps state
    var gippState = !gspState && !gsspState ? (_e = (_d = props === null || props === void 0 ? void 0 : props.pageProps) === null || _d === void 0 ? void 0 : _d.initialState) !== null && _e !== void 0 ? _e : null : null;
    if (config.debug) {
      console.log('4.', displayName, 'created new store with', {
        giapState: giapState,
        gspState: gspState,
        gsspState: gsspState,
        gippState: gippState
      });
    }
    var store = (0,react.useMemo)(function () {
      return initStore({
        makeStore: makeStore
      });
    }, []);
    useHybridHydrate(store, giapState, gspState, gsspState, gippState);
    var resultProps = props;
    // order is important! Next.js overwrites props from pages/_app with getStaticProps from page
    // @see https://github.com/zeit/next.js/issues/11648
    if (initialProps && initialProps.pageProps) {
      resultProps.pageProps = __assign(__assign({}, initialProps.pageProps), props.pageProps);
    }
    // just some cleanup to prevent passing it as props, we need to clone props to safely delete initialState
    if ((_f = props === null || props === void 0 ? void 0 : props.pageProps) === null || _f === void 0 ? void 0 : _f.initialState) {
      resultProps = __assign(__assign({}, props), {
        pageProps: __assign({}, props.pageProps)
      });
      delete resultProps.pageProps.initialState;
    }
    // unwrap getInitialPageProps
    if ((_g = resultProps === null || resultProps === void 0 ? void 0 : resultProps.pageProps) === null || _g === void 0 ? void 0 : _g.initialProps) {
      resultProps.pageProps = __assign(__assign({}, resultProps.pageProps), resultProps.pageProps.initialProps);
      delete resultProps.pageProps.initialProps;
    }
    return {
      store: store,
      props: __assign(__assign({}, initialProps), resultProps)
    };
  };
  var withRedux = function (Component) {
    console.warn('/!\\ You are using legacy implementation. Please update your code: use createWrapper() and wrapper.useWrappedStore().');
    //TODO Check if pages/_app was wrapped so there's no need to wrap a page itself
    var WrappedComponent = function (props) {
      var _a = useWrappedStore(props, WrappedComponent.displayName),
        store = _a.store,
        combinedProps = _a.props;
      return react.createElement(es/* Provider */.zt, {
        store: store
      }, react.createElement(Component, __assign({}, combinedProps)));
    };
    WrappedComponent.displayName = "withRedux(".concat(Component.displayName || Component.name || 'Component', ")");
    if ('getInitialProps' in Component) {
      WrappedComponent.getInitialProps = Component.getInitialProps;
    }
    return WrappedComponent;
  };
  return {
    getServerSideProps: getServerSideProps,
    getStaticProps: getStaticProps,
    getInitialAppProps: getInitialAppProps,
    getInitialPageProps: getInitialPageProps,
    withRedux: withRedux,
    useWrappedStore: useWrappedStore
  };
};
// Legacy
// eslint-disable-next-line import/no-anonymous-default-export
/* harmony default export */ var es6 = (function (makeStore, config) {
  if (config === void 0) {
    config = {};
  }
  console.warn('/!\\ You are using legacy implementation. Please update your code: use createWrapper() and wrapper.withRedux().');
  return createWrapper(makeStore, config).withRedux;
});
// EXTERNAL MODULE: ./src/redux/slice/Login/Login.tsx
var Login = __webpack_require__(31518);
// EXTERNAL MODULE: ./src/redux/slice/Course/MyCourse/Activity/Activity.ts
var Activity = __webpack_require__(57304);
// EXTERNAL MODULE: ./src/redux/slice/Course/ShortCourse/Activity/Activity.ts
var Activity_Activity = __webpack_require__(34674);
// EXTERNAL MODULE: ./src/redux/slice/Course/MyCourse/Activity/ActivityQuiz.ts
var ActivityQuiz = __webpack_require__(3679);
// EXTERNAL MODULE: ./src/redux/slice/Course/UserGuide.tsx
var UserGuide = __webpack_require__(87642);
// EXTERNAL MODULE: ./src/redux/slice/Course/MyCourse/Case-study/CaseStudy.ts + 1 modules
var CaseStudy = __webpack_require__(81209);
// EXTERNAL MODULE: ./src/redux/slice/EntranceTest/EntranceTest.tsx
var EntranceTest = __webpack_require__(95290);
// EXTERNAL MODULE: ./src/redux/slice/Course/ShortCourse/NoteList/ShortNoteList.tsx
var ShortNoteList = __webpack_require__(79639);
;// CONCATENATED MODULE: ./src/redux/store.ts















var store = (0,redux_toolkit_esm/* configureStore */.xC)({
    reducer: {
        loginReducer: Login/* default */.ZP,
        userReducer: User/* default */.ZP,
        confirmDialogReducer: ConfirmDialogSlice/* default */.ZP,
        courseActivityReducer: Activity/* default */.ZP,
        shortCourseActivityReducer: Activity_Activity/* default */.ZP,
        notificationReducer: Notification/* default */.ZP,
        popupReducer: Result_test/* default */.ZP,
        courseActivityQuizReducer: ActivityQuiz/* default */.ZP,
        userGuideReducer: UserGuide/* default */.ZP,
        caseStudyTestReducer: CaseStudy/* default */.ZP,
        entranceTestReducer: EntranceTest/* default */.ZP,
        notesListReducer: NotesList/* default */.ZP,
        shortNotesListReducer: ShortNoteList/* default */.ZP
    },
    middleware: function(getDefaultMiddleware) {
        return getDefaultMiddleware({
            serializableCheck: false
        });
    }
});
var makeStore = function() {
    return store;
};
var wrapper = createWrapper(makeStore);

// EXTERNAL MODULE: ./src/contexts/StaticModalContext.tsx
var StaticModalContext = __webpack_require__(56074);
// EXTERNAL MODULE: ./node_modules/sapp-common-package/dist/sapp-editor.css
var sapp_editor = __webpack_require__(77086);
// EXTERNAL MODULE: ./node_modules/sapp-common-package/dist/index.css
var sapp_common_package_dist = __webpack_require__(48609);
// EXTERNAL MODULE: ./node_modules/preview-part/dist/index.css
var preview_part_dist = __webpack_require__(60010);
// EXTERNAL MODULE: ./node_modules/sapp-notification/dist/index.css
var sapp_notification_dist = __webpack_require__(67782);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/currentScopes.js
var currentScopes = __webpack_require__(97308);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/sdk.js + 24 modules
var sdk = __webpack_require__(25169);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/logger.js
var logger = __webpack_require__(3518);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(89483);
;// CONCATENATED MODULE: ./node_modules/@sentry/react/build/esm/debug-build.js
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD =  false || false;

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/exports.js
var esm_exports = __webpack_require__(2155);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/is.js
var is = __webpack_require__(92668);
;// CONCATENATED MODULE: ./node_modules/@sentry/react/build/esm/error.js




/**
 * See if React major version is 17+ by parsing version string.
 */
function isAtLeastReact17(reactVersion) {
  const reactMajor = reactVersion.match(/^([^.]+)/);
  return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}

/**
 * Recurse through `error.cause` chain to set cause on an error.
 */
function setCause(error, cause) {
  const seenErrors = new WeakSet();
  function recurse(error, cause) {
    // If we've already seen the error, there is a recursive loop somewhere in the error's
    // cause chain. Let's just bail out then to prevent a stack overflow.
    if (seenErrors.has(error)) {
      return;
    }
    if (error.cause) {
      seenErrors.add(error);
      return recurse(error.cause, cause);
    }
    error.cause = cause;
  }
  recurse(error, cause);
}

/**
 * Captures an error that was thrown by a React ErrorBoundary or React root.
 *
 * @param error The error to capture.
 * @param errorInfo The errorInfo provided by React.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */
function captureReactException(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, {
  componentStack
}, hint) {
  // If on React version >= 17, create stack trace from componentStack param and links
  // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
  // Linking errors requires the `LinkedErrors` integration be enabled.
  // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
  //
  // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
  // with non-error objects. This is why we need to check if the error is an error-like object.
  // See: https://github.com/getsentry/sentry-javascript/issues/6167
  if (isAtLeastReact17(react.version) && (0,is/* isError */.VZ)(error) && componentStack) {
    const errorBoundaryError = new Error(error.message);
    errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
    errorBoundaryError.stack = componentStack;

    // Using the `LinkedErrors` integration to link the errors together.
    setCause(error, errorBoundaryError);
  }
  return (0,esm_exports/* captureException */.Tb)(error, {
    ...hint,
    captureContext: {
      contexts: {
        react: {
          componentStack
        }
      }
    }
  });
}

/**
 * Creates an error handler that can be used with the `onCaughtError`, `onUncaughtError`,
 * and `onRecoverableError` options in `createRoot` and `hydrateRoot` React DOM methods.
 *
 * @param callback An optional callback that will be called after the error is captured.
 * Use this to add custom handling for errors.
 *
 * @example
 *
 * ```JavaScript
 * const root = createRoot(container, {
 *  onCaughtError: Sentry.reactErrorHandler(),
 *  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
 *    console.warn('Caught error', error, errorInfo.componentStack);
 *  });
 * });
 * ```
 */
function reactErrorHandler(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (error, errorInfo) => {
    const eventId = captureReactException(error, errorInfo);
    if (callback) {
      callback(error, errorInfo, eventId);
    }
  };
}

;// CONCATENATED MODULE: ./node_modules/@sentry/react/build/esm/errorboundary.js






const UNKNOWN_COMPONENT = 'unknown';
const INITIAL_STATE = {
  componentStack: null,
  error: null,
  eventId: null
};

/**
 * A ErrorBoundary component that logs errors to Sentry.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */
class ErrorBoundary extends react.Component {
  constructor(props) {
    super(props);
    ErrorBoundary.prototype.__init.call(this);
    this.state = INITIAL_STATE;
    this._openFallbackReportDialog = true;
    const client = (0,currentScopes/* getClient */.s3)();
    if (client && props.showDialog) {
      this._openFallbackReportDialog = false;
      this._cleanupHook = client.on('afterSendEvent', event => {
        if (!event.type && this._lastEventId && event.event_id === this._lastEventId) {
          (0,sdk/* showReportDialog */.jp)({
            ...props.dialogOptions,
            eventId: this._lastEventId
          });
        }
      });
    }
  }
  componentDidCatch(error, errorInfo) {
    const {
      componentStack
    } = errorInfo;
    // TODO(v9): Remove this check and type `componentStack` to be React.ErrorInfo['componentStack'].
    const passedInComponentStack = componentStack == null ? undefined : componentStack;
    const {
      beforeCapture,
      onError,
      showDialog,
      dialogOptions
    } = this.props;
    (0,currentScopes/* withScope */.$e)(scope => {
      if (beforeCapture) {
        beforeCapture(scope, error, passedInComponentStack);
      }
      const handled = this.props.handled != null ? this.props.handled : !!this.props.fallback;
      const eventId = captureReactException(error, errorInfo, {
        mechanism: {
          handled
        }
      });
      if (onError) {
        onError(error, passedInComponentStack, eventId);
      }
      if (showDialog) {
        this._lastEventId = eventId;
        if (this._openFallbackReportDialog) {
          (0,sdk/* showReportDialog */.jp)({
            ...dialogOptions,
            eventId
          });
        }
      }

      // componentDidCatch is used over getDerivedStateFromError
      // so that componentStack is accessible through state.
      this.setState({
        error,
        componentStack,
        eventId
      });
    });
  }
  componentDidMount() {
    const {
      onMount
    } = this.props;
    if (onMount) {
      onMount();
    }
  }
  componentWillUnmount() {
    const {
      error,
      componentStack,
      eventId
    } = this.state;
    const {
      onUnmount
    } = this.props;
    if (onUnmount) {
      onUnmount(error, componentStack, eventId);
    }
    if (this._cleanupHook) {
      this._cleanupHook();
      this._cleanupHook = undefined;
    }
  }
  __init() {
    this.resetErrorBoundary = () => {
      const {
        onReset
      } = this.props;
      const {
        error,
        componentStack,
        eventId
      } = this.state;
      if (onReset) {
        onReset(error, componentStack, eventId);
      }
      this.setState(INITIAL_STATE);
    };
  }
  render() {
    const {
      fallback,
      children
    } = this.props;
    const state = this.state;
    if (state.error) {
      let element = undefined;
      if (typeof fallback === 'function') {
        element = react.createElement(fallback, {
          error: state.error,
          componentStack: state.componentStack,
          resetError: this.resetErrorBoundary,
          eventId: state.eventId
        });
      } else {
        element = fallback;
      }
      if (react.isValidElement(element)) {
        return element;
      }
      if (fallback) {
        DEBUG_BUILD && logger/* logger.warn */.kg.warn('fallback did not produce a valid ReactElement');
      }

      // Fail gracefully if no fallback provided or is not valid
      return null;
    }
    if (typeof children === 'function') {
      return children();
    }
    return children;
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withErrorBoundary(WrappedComponent, errorBoundaryOptions) {
  const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;
  const Wrapped = props => React.createElement(ErrorBoundary, {
    ...errorBoundaryOptions
  }, React.createElement(WrappedComponent, {
    ...props
  }));
  Wrapped.displayName = `errorBoundary(${componentDisplayName})`;

  // Copy over static methods from Wrapped component to Profiler HOC
  // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
  hoistNonReactStatics(Wrapped, WrappedComponent);
  return Wrapped;
}

// EXTERNAL MODULE: ./src/pages/error-redirect/index.tsx + 1 modules
var error_redirect = __webpack_require__(46675);
;// CONCATENATED MODULE: ./src/pages/_app.tsx











































var excludedPathsHelp = [
    "/test/[id]",
    "/case-study/[id]",
    "/certificates/[id]",
    "/case-study/result/[id]",
    "/teachers", 
];
function MyApp(param) {
    var Component = param.Component, pageProps = param.pageProps;
    (0,httpService/* injectStore */.ni)(store);
    var router = (0,next_router.useRouter)();
    var dispatch = (0,hook/* useAppDispatch */.T)();
    var queryClient = new react_query_es.QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 3000000,
                refetchOnWindowFocus: false
            }
        }
    });
    // Check if URL contains '/teachers'
    var isTeacherPage = router.asPath.includes("/teachers");
    (0,react.useEffect)(function() {
        (0,firebase/* onMessageListener */.L)().then(function(data) {
            dispatch((0,Notification/* showNotification */.c0)());
        });
    });
    (0,react.useEffect)(function() {
        aos_default().init({
            duration: src_constants/* ANIMATION.DURATION */.lB.DURATION,
            once: true
        });
    });
    /**
   * @description Sử dụng useEffect để thực hiện các tác vụ liên quan đến việc theo dõi thay đổi trong route của ứng dụng để check GA
   */ (0,react.useEffect)(function() {
        var handleRouteChange = function(url) {
            (0,utils/* pageview */.LV)(url);
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        router.events
    ]);
    var ref = (0,react.useState)(null), socket = ref[0], setSocket = ref[1];
    var authenticationManager = new keycloak/* AuthenticationManager */.E();
    (0,react.useEffect)(function() {
        var token = authenticationManager.getToken();
        if (token !== "") {
            var newSocket = esm_lookup("".concat("https://socket-be.sapp.edu.vn"), {
                extraHeaders: {
                    authorization: token
                }
            });
            setSocket(newSocket);
            return function() {
                newSocket.disconnect();
            };
        }
    }, [
        authenticationManager
    ]) // reconnect khi authToken thay đổi
    ;
    (0,react.useEffect)(function() {
        if (socket) {
            socket.on("connect", function() {});
            socket.on("disconnect", function() {});
            socket === null || socket === void 0 ? void 0 : socket.on(src_constants/* SOCKET_EVENTS.NOTIFICATION_UNREAD */.QH.NOTIFICATION_UNREAD, function(data) {
                localStorage.setItem(src_constants/* LOCAL_STORAGE_KEYS.NOTIFICATION_COUNT */.dA.NOTIFICATION_COUNT, data.payload.data.unread);
                window.dispatchEvent(new Event("storage"));
            });
            return function() {
                socket === null || socket === void 0 ? void 0 : socket.off(src_constants/* SOCKET_EVENTS.NOTIFICATION_UNREAD */.QH.NOTIFICATION_UNREAD);
            };
        }
    }, [
        socket
    ]);
    var gtmId = "GTM-P6FDFP8M" || 0;
    var tagManagerArgs = {
        gtmId: gtmId
    };
    (0,react.useEffect)(function() {
        react_gtm_module_dist_default().initialize(tagManagerArgs);
    }, []);
    (0,react.useEffect)(function() {
        if (!window.GA_INITIALIZED) {
            (0,google_analytics/* default */.ZP)();
            window.GA_INITIALIZED = true;
        }
    }, []);
    var showHelp = !excludedPathsHelp.some(function(path) {
        return router.pathname.includes(path);
    }) && !isTeacherPage // Add condition to hide help on teacher pages
    ;
    var hiddenChatbot = excludedPathsHelp.some(function(path) {
        return router.pathname.includes(path);
    }) || isTeacherPage;
    // Handle HubSpot widget visibility based on URL
    (0,react.useEffect)(function() {
        var hideHubspotWidget = function() {
            // Target specific elements from the DOM structure we observed
            var container = document.getElementById("hubspot-messages-iframe-container");
            var chatFrame = document.getElementById("hubspot-messages-iframe");
            var widgetContainer = document.querySelector(".hs-shadow-container");
            if (hiddenChatbot) {
                // Hide HubSpot chat widget on teacher pages and other excluded paths
                if (container) {
                    container.classList.add("visible-icon");
                    // Add additional inline styles for redundancy
                    container.style.display = "none";
                }
                if (chatFrame) {
                    chatFrame.style.display = "none";
                }
                if (widgetContainer) {
                    widgetContainer.classList.add("visible-icon");
                }
                // Add CSS rule to ensure it stays hidden
                var style = document.createElement("style");
                style.id = "hubspot-hide-style";
                style.innerHTML = "\n          #hubspot-messages-iframe-container, \n          #hubspot-messages-iframe,\n          .hs-shadow-container { \n            display: none !important; \n            visibility: hidden !important; \n          }\n        ";
                // Only add if it doesn't exist already
                if (!document.getElementById("hubspot-hide-style")) {
                    document.head.appendChild(style);
                }
            } else {
                // Remove the style tag if path doesn't contain '/teachers'
                var styleTag = document.getElementById("hubspot-hide-style");
                if (styleTag) {
                    document.head.removeChild(styleTag);
                }
                // Only show if not in excluded paths
                if (showHelp) {
                    if (container) {
                        container.classList.remove("visible-icon");
                        container.style.display = "";
                    }
                    if (chatFrame) {
                        chatFrame.style.display = "";
                    }
                    if (widgetContainer) {
                        widgetContainer.classList.remove("visible-icon");
                    }
                }
            }
        };
        // Initial run
        hideHubspotWidget();
        // Set up an observer to handle dynamically loaded HubSpot elements
        var observer = new MutationObserver(function(mutations) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var mutation = _step.value;
                    if (mutation.addedNodes.length > 0) {
                        // If HubSpot elements are dynamically added, hide them if needed
                        hideHubspotWidget();
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        // Start observing the document body for changes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        // Also listen for route changes
        var handleRouteChange = function() {
            setTimeout(hideHubspotWidget, 300) // Short delay to ensure DOM is updated
            ;
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            observer.disconnect();
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        router,
        showHelp,
        hiddenChatbot
    ]);
    (0,react.useEffect)(function() {
        if (![
            src_constants/* ENTRANCE_TEST_TABLE_RESULT */.IO,
            src_constants/* ENTRANCE_TEST_RESULT */.WD,
            constants/* CERTIFICATE_DETAIL */.JJ, 
        ].includes(router.pathname)) {
            try {
                dispatch((0,Notification/* getCountUnRead */.xU)());
            } catch (error) {}
        }
    }, []);
    (0,react.useEffect)(function() {
        var handleRouteChange = function() {
            // Lưu URL hiện tại vào localStorage trước khi đổi sang URL mới
            localStorage.setItem("previousUrl", router.asPath);
            if (router.asPath.includes("courses") && !router.asPath.includes("your-answers-detail")) {
                localStorage.setItem("previousCourseUrl", router.asPath);
            }
        };
        // Lắng nghe sự kiện chuyển route
        router.events.on("routeChangeStart", handleRouteChange);
        // Cleanup listener
        return function() {
            router.events.off("routeChangeStart", handleRouteChange);
        };
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(error_redirect["default"], {}),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Metadata, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Provider_AntConfigProvider, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PinnedNotifyContext/* PinnedNotifyProvider */.r, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contexts/* CourseProvider */.N, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticModalContext/* StaticModalProvider */.g, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_query_es.QueryClientProvider, {
                                    client: queryClient,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SocketContext.Provider, {
                                        value: socket,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_hot_toast_dist/* Toaster */.x7, {
                                                toastOptions: {
                                                    style: {
                                                        maxWidth: "400px"
                                                    }
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(confirm_dialog_SappConfirmDialogContainer, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RouteGuard, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "relative",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_PinnedNotifications, {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PinnedNotifications_CtaTrial, {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
                                                            ]
                                                        }),
                                                        showHelp && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BackToTop, {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Help, {
                                                                    showHelp: showHelp
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(mycourses_LearningNotesList, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupCompletedCourse, {})
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var _app = (wrapper.withRedux(MyApp));


/***/ }),

/***/ 44474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ ActivityAPI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73782);
/* harmony import */ var _services_requestV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91002);


var ActivityAPI = /*#__PURE__*/ function() {
    "use strict";
    function ActivityAPI() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, ActivityAPI);
    }
    /**
   * @description Tạo mới một cuộc thảo luận.
   * @async
   * @param {ICreateDiscussionRequest} request - Dữ liệu yêu cầu tạo cuộc thảo luận.
   * @returns {Promise<IResponse<IDiscussion>>} - Dữ liệu cuộc thảo luận đã tạo.
   */ ActivityAPI.createDiscussionComment = function createDiscussionComment(request) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("course-discussions", {
            data: request,
            method: "POST"
        });
    };
    ActivityAPI.getQuizAttemptsAnswer = function getQuizAttemptsAnswer(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("quiz-attempts/answers/".concat(id));
    };
    /**
   * @description Lấy danh sách câu hỏi của một bài kiểm tra.
   * @async
   * @param {string} id - ID của bài kiểm tra.
   * @returns {Promise<IResponse<{ questions: IQuestion[] }>>} - Dữ liệu câu hỏi.
   */ ActivityAPI.getQuestions = function getQuestions(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("quiz/".concat(id, "/questions?page_index=1&page_size=99999"));
    };
    /**
   * @description Phản ứng vào một cuộc thảo luận.
   * @async
   * @param {ICreateDiscussionResReact} request - Dữ liệu yêu cầu phản ứng.
   * @returns {Promise<IResponse<ICreateDiscussionRepReact>>} - Dữ liệu phản ứng.
   */ ActivityAPI.reactDiscussion = function reactDiscussion(data) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("course-discussions/react", {
            data: data
        });
    };
    /**
   * Kết thúc tiến độ cho một phần của khóa học cụ thể.
   *
   * @param {string} courseId - id của khóa học.
   * @param {string} sectionId - id của section.
   * @returns {Promise<IResponse<any>>} Một Promise nhận phản hồi về tiến độ.
   */ ActivityAPI.finishedCourseSectionProgress = function finishedCourseSectionProgress(courseId, sectionId) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("course-sections/course/".concat(courseId, "/section/").concat(sectionId, "/progress"), {
            params: {
                status: "FINISHED"
            }
        });
    };
    /**
   * @description Cập nhật một cuộc thảo luận.
   * @async
   */ ActivityAPI.updateDiscussionComment = function updateDiscussionComment(id, params) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("course-discussions/".concat(id), {
            data: params,
            method: "PUT"
        });
    };
    /**
   * @description Xóa cuộc thảo luận.
   * @async
   */ ActivityAPI.deleteDiscussion = function deleteDiscussion(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("course-discussions/".concat(id), {
            method: "DELETE"
        });
    };
    return ActivityAPI;
} /**
 * @description upload ảnh cho cuộc thảo luận.
 * @async
 * @param {ICreateDiscussionUploadRequest} request - Dữ liệu yêu cầu upload cuộc thảo luận.
 * @returns {Promise<IResponse<IDiscussion>>} - Dữ liệu cuộc thảo luận đã upload.
 */  // export const downloadResource = async (data: {
 //   files: { name: string; file_key: string }[]
 // }): Promise<any> => {
 //   const res = await fetcher(`resource/get-token-download`, {
 //     method: 'POST',
 //     data: data,
 //   })
 //   if (res?.success) {
 //     const link = document.createElement('a')
 //     link.href = `resource/download?token=${res?.data}`
 //     link.download = data.files[0].name
 //     link.style.display = 'none'
 //     document.body.appendChild(link)
 //     link.click()
 //     document.body.removeChild(link)
 //   }
 // }
();
ActivityAPI.uploadImageDiscussion = function(param) {
    var discussion_id = param.discussion_id, new_discussion_file = param.new_discussion_file, discussion_file_ids = param.discussion_file_ids;
    var formData = new FormData();
    formData.append("discussion_id", discussion_id);
    new_discussion_file === null || new_discussion_file === void 0 ? void 0 : new_discussion_file.forEach(function(file, index) {
        formData.append("discussion_images[".concat(index, "]"), file);
    });
    discussion_file_ids === null || discussion_file_ids === void 0 ? void 0 : discussion_file_ids.forEach(function(discussion_file_id, index) {
        formData.append("discussion_file_ids[".concat(index, "]"), discussion_file_id);
    });
    return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("course-discussions/detail/upload", {
        headers: {
            "Content-Type": "multipart/form-data"
        },
        data: formData,
        method: "POST"
    });
};


/***/ }),

/***/ 38916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j7": function() { return /* binding */ getActivityById; },
/* harmony export */   "qe": function() { return /* binding */ submitQuizTest; },
/* harmony export */   "tB": function() { return /* binding */ CoursesAPI; }
/* harmony export */ });
/* unused harmony export getQuestionsById */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73782);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52621);
/* harmony import */ var _services_requestV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91002);
/* harmony import */ var src_redux_services_Course_MyCourse_Test_url__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25292);
/* harmony import */ var src_redux_services_httpService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92816);








var CoursesAPI = /*#__PURE__*/ function() {
    "use strict";
    function CoursesAPI() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, CoursesAPI);
        this.CACHE_GET_COURSE_ACTIVITY_TAP_BY_ID = {};
    }
    CoursesAPI.getNoteDetail = function getNoteDetail(course_section_id, course_id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("course-section-notes/".concat(course_section_id), {
            params: {
                course_id: course_id
            }
        });
    };
    CoursesAPI.createNote = function createNote(params) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("course-section-notes", {
            method: "POST",
            data: params
        });
    };
    CoursesAPI.activeCourse = function activeCourse(params) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("courses/active", {
            method: "POST",
            data: params
        });
    };
    CoursesAPI.extendCourse = function extendCourse(params) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("courses/extend", {
            method: "POST",
            data: params
        });
    };
    CoursesAPI.caseStudyProgress = function caseStudyProgress(course_id, section_id, caseStudyId) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("course-sections/course/".concat(course_id, "/section/").concat(section_id, "/progress?story_topic_id=").concat(caseStudyId));
    };
    CoursesAPI.userGuideActive = function userGuideActive() {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("guide-active");
    };
    CoursesAPI.deleteCourseNoteList = function deleteCourseNoteList(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("course-section-notes/".concat(id), {
            method: "DELETE"
        });
    };
    CoursesAPI.get = function get(page_index, page_size, params) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("courses?page_index=".concat(page_index, "&page_size=").concat(page_size), {
            params: params
        });
    };
    CoursesAPI.getCourseDetail = function getCourseDetail(id, page_index, page_size, params) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("courses/".concat(id, "?page_index=").concat(page_index, "&page_size=").concat(page_size), {
            params: params
        });
    };
    CoursesAPI.getShortCourseDetail = function getShortCourseDetail(id, page_index, page_size, params) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("courses/".concat(id, "?page_index=").concat(page_index, "&page_size=").concat(page_size), {
            params: params
        });
    };
    CoursesAPI.getCourseDetailActivity = function getCourseDetailActivity(id, course_section_id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("/course-sections/learning-structure/".concat(id, "?course_section_id=").concat(course_section_id));
    };
    CoursesAPI.getQuestionTabsById = function getQuestionTabsById(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(src_redux_services_Course_MyCourse_Test_url__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getQuestionTabs */ .Z.getQuestionTabs, "/").concat(id, "/shuffle"));
    };
    CoursesAPI.getDetailQuizById = function getDetailQuizById(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(src_redux_services_Course_MyCourse_Test_url__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getQuestionTabs */ .Z.getQuestionTabs, "/").concat(id));
    };
    CoursesAPI.createQuizAttempt = function createQuizAttempt(id, class_user_id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(src_redux_services_Course_MyCourse_Test_url__WEBPACK_IMPORTED_MODULE_1__/* ["default"].createQuizAttemp */ .Z.createQuizAttemp), {
            method: "POST",
            data: {
                quiz_id: id,
                class_user_id: class_user_id || undefined
            }
        });
    };
    CoursesAPI.getTopicDescription = function getTopicDescription(id, quiz_id) {
        var cache = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
            var uri, _;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        uri = src_redux_services_Course_MyCourse_Test_url__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getTopicDescription */ .Z.getTopicDescription + "/".concat(id, "?quiz_id=").concat(quiz_id, "&include_questions=false");
                        if (!cache) return [
                            2,
                            (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)(uri)
                        ];
                        if (!!_this.CACHE_GET_TOPIC_DESCRIPTION[uri]) return [
                            3,
                            2
                        ];
                        _ = _this.CACHE_GET_TOPIC_DESCRIPTION;
                        return [
                            4,
                            (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)(uri)
                        ];
                    case 1:
                        _[uri] = _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2,
                            _this.CACHE_GET_TOPIC_DESCRIPTION[uri]
                        ];
                }
            });
        })();
    };
    CoursesAPI.startCourseSectionProgress = function startCourseSectionProgress(courseId, sectionId) {
        var uri = "/course-sections/course/".concat(courseId, "/section/").concat(sectionId, "/progress");
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(uri));
    };
    CoursesAPI.startShortCourseSectionProgress = function startShortCourseSectionProgress(courseId, sectionId) {
        var uri = "/course-sections/course/".concat(courseId, "/section/").concat(sectionId, "/progress?is_progress_sc=true");
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(uri));
    };
    CoursesAPI.learningOutcomeProgress = function learningOutcomeProgress(course_id, section_id, params) {
        var uri = "course-sections/course/".concat(course_id, "/section/").concat(section_id, "/progress");
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(uri), {
            params: params
        });
    };
    /**
   * @deprecated use QuestionAPI.getQuestionDetail (cached api)
   */ CoursesAPI.getQuestionsDetail = function getQuestionsDetail(id) {
        var uri = src_redux_services_Course_MyCourse_Test_url__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getQuestionDetail */ .Z.getQuestionDetail;
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(uri), {
            params: {
                question_ids: id
            }
        });
    };
    CoursesAPI.getQuizAttemptsChartData = function getQuizAttemptsChartData(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(src_redux_services_Course_MyCourse_Test_url__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getQuizAttemptsChartData */ .Z.getQuizAttemptsChartData, "/").concat(id));
    };
    CoursesAPI.getQuizAttemptsEntranceTestChartData = function getQuizAttemptsEntranceTestChartData(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(src_redux_services_httpService__WEBPACK_IMPORTED_MODULE_2__/* .apiURL */ .QH, "/entrance-test/chart-data/").concat(id));
    };
    CoursesAPI.getPartDetail = function getPartDetail(id, course_section_id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("/course-sections/".concat(id, "?course_section_id=").concat(course_section_id));
    };
    CoursesAPI.getQuizAttemptsTable = function getQuizAttemptsTable(id, param) {
        var page_index = param.page_index, page_size = param.page_size, no_group_view = param.no_group_view;
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("/quiz-attempts/".concat(id, "/answers"), {
            params: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                page_index: page_index || 1,
                page_size: page_size || 10
            }, no_group_view && {
                no_group_view: no_group_view
            })
        });
    };
    CoursesAPI.getQuizAttemptsTableEntranceTest = function getQuizAttemptsTableEntranceTest(id, param) {
        var page_index = param.page_index, page_size = param.page_size;
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(src_redux_services_httpService__WEBPACK_IMPORTED_MODULE_2__/* .apiURL */ .QH, "/entrance-test/quiz-attempts/").concat(id, "/answers"), {
            params: {
                page_index: page_index || 1,
                page_size: page_size || 10
            }
        });
    };
    CoursesAPI.getQuizAttempts = function getQuizAttempts(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(src_redux_services_Course_MyCourse_Test_url__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getQuizAttempts */ .Z.getQuizAttempts, "/").concat(id));
    };
    //get answer a question
    CoursesAPI.getAnswersSubmitted = function getAnswersSubmitted(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(src_redux_services_Course_MyCourse_Test_url__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getQuizAttempts */ .Z.getQuizAttempts, "/user-answers/").concat(id));
    };
    CoursesAPI.submitAllQuestion = function submitAllQuestion(id, data) {
        //is submit test
        var uri = src_redux_services_Course_MyCourse_Test_url__WEBPACK_IMPORTED_MODULE_1__/* ["default"].submitQuestion */ .Z.submitQuestion + "/".concat(id) + "/submit";
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(uri), {
            data: data,
            method: "POST"
        });
    };
    CoursesAPI.submitAnswer = function submitAnswer(id, data) {
        var uri = src_redux_services_Course_MyCourse_Test_url__WEBPACK_IMPORTED_MODULE_1__/* ["default"].submitQuestion */ .Z.submitQuestion + "/".concat(id) + "/submit-answer";
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(uri), {
            data: data,
            method: "POST"
        });
    };
    CoursesAPI.submitCaseStudy = function submitCaseStudy(id, data) {
        var uri = src_redux_services_Course_MyCourse_Test_url__WEBPACK_IMPORTED_MODULE_1__/* ["default"].submitCaseStudy */ .Z.submitCaseStudy + "/".concat(id) + "/submit";
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(uri), {
            data: data,
            method: "POST"
        });
    };
    CoursesAPI.getCaseStudyAttemptsTable = function getCaseStudyAttemptsTable(id, page_index, page_size) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("quiz-attempts/case-study/table/".concat(id, "?page_index=").concat(page_index, "&page_size=").concat(page_size));
    };
    CoursesAPI.getTopicAttemptsDetail = function getTopicAttemptsDetail(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("quiz-attempts/topic/".concat(id, "/score"));
    };
    /**
   * @description Lấy thông tin cuộc thảo luận theo ID.
   * @async
   * @param {string} id - ID của cuộc thảo luận.
   * @returns {Promise<IResponseMeta<IDiscussion, 'discussions'>>} - Dữ liệu cuộc thảo luận.
   */ CoursesAPI.getDiscussion = function getDiscussion(class_id, course_section_id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("course-discussions", {
            params: {
                page_index: 1,
                page_size: 9999,
                class_id: class_id,
                course_section_id: course_section_id
            }
        });
    };
    CoursesAPI.getDiscussionStudentInfo = function getDiscussionStudentInfo(course_section_id, class_id, user_id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(src_redux_services_Course_MyCourse_Test_url__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getDiscussionStudentInfo */ .Z.getDiscussionStudentInfo), {
            params: {
                course_section_id: course_section_id,
                class_id: class_id,
                user_id: user_id
            }
        });
    };
    /**
   * @description Lấy thông tin tab hoạt động theo ID.
   * @async
   * @param {string} id - ID của tab.
   * @returns {Promise<IResponse<ITab>>} - Dữ liệu tab.
   */ CoursesAPI.getCourseActivityTapById = function getCourseActivityTapById(courseId, id) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
            var _;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!_this.CACHE_GET_TOPIC_DESCRIPTION[id]) return [
                            3,
                            2
                        ];
                        _ = _this.CACHE_GET_TOPIC_DESCRIPTION;
                        return [
                            4,
                            (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("course-sections/".concat(courseId, "/tab/").concat(id))
                        ];
                    case 1:
                        _[id] = _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2,
                            _this.CACHE_GET_TOPIC_DESCRIPTION[id]
                        ];
                }
            });
        })();
    };
    /**
   * @description Lấy kết quả câu hỏi theo ID.
   * @async
   * @param {string} id - ID của câu hỏi.
   * @returns {Promise<IResponse<IQuestion[]>>} - Dữ liệu kết quả câu hỏi.
   * @deprecated replace by replace by QuestionAPI.getQuestionDetail with query after-test = true
   */ CoursesAPI.getQuestionResults = function getQuestionResults(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("question/results?question_ids=".concat(id));
    };
    CoursesAPI.getCourseLearningOutcome = function getCourseLearningOutcome(id, class_id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("course_learning_outcomes/".concat(id, "/class/").concat(class_id));
    };
    CoursesAPI.getCourse = function getCourse(page_size, queryString) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("courses?page_index=1&page_size=".concat(page_size).concat(queryString));
    };
    CoursesAPI.getCourseSectionList = function getCourseSectionList(id, page_size, page_index) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("course-sections/short/list?page_index=".concat(page_index ? page_index : 1, "&page_size=").concat(page_size, "&classId=").concat(id, "&type=PART"));
    };
    CoursesAPI.getCourseSubsectionList = function getCourseSubsectionList(page_size, type, parentId, classId, page_index, params) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("course-sections/short/list?page_index=".concat(page_index ? page_index : 1, "&page_size=").concat(page_size || 10, "&type=").concat(type, "&parentId=").concat(parentId !== null && parentId !== void 0 ? parentId : "").concat(classId ? "&classId=".concat(classId) : ""), {
            params: params
        });
    };
    CoursesAPI.getCourseResource = function getCourseResource(id, params) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("courses/".concat(id, "/resources?&attachment_type=attached"), {
            params: params
        });
    };
    CoursesAPI.getCourseResults = function getCourseResults(id, page_index, page_size, params) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("courses/".concat(id, "/quizzes?page_index=").concat(page_index, "&page_size=").concat(page_size), {
            params: params
        });
    };
    CoursesAPI.getCourseNotesList = function getCourseNotesList(page_size, params) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("course-section-notes?page_index=1&page_size=".concat(page_size), {
            params: params
        });
    };
    CoursesAPI.updateCourseNotesList = function updateCourseNotesList(id, params) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("course-section-notes/".concat(id), {
            data: params,
            method: "PUT"
        });
    };
    /**
   * @description Lấy thông tin của breadcrumb
   * @async
   * @param {string | string[] | undefined} id - truyền class_id.
   * @param {string | string[] | undefined} course_section_id - truyền activity_id.
   */ CoursesAPI.getBreadcumb = function getBreadcumb(id, course_section_id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("courses/".concat(id, "/section/").concat(course_section_id, "/breadcumb"));
    };
    /**
   * @description lấy thông tin Certificate
   */ CoursesAPI.getCertificate = function getCertificate(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("certificate/public/".concat(id));
    };
    CoursesAPI.getResource = function getResource(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("/resource/".concat(id));
    };
    CoursesAPI.getQuizAttempt = function getQuizAttempt(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("/quiz-attempts/answers/".concat(id));
    };
    CoursesAPI.upgradeNowTrial = function upgradeNowTrial(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("courses/".concat(id, "/trial/upgrade-now"), {
            method: "POST"
        });
    };
    CoursesAPI.changeSurvey = function changeSurvey(class_id, data) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("/courses/".concat(class_id, "/change-survey-popup-status"), {
            method: "POST",
            data: data
        });
    };
    CoursesAPI.skipFoundation = function skipFoundation(class_id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("courses/".concat(class_id, "/skip-foundation"), {
            method: "PUT"
        });
    };
    CoursesAPI.updateFlagInQuestion = function updateFlagInQuestion(quiz_attempt_id, payload) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("quiz/".concat(quiz_attempt_id, "/flag"), {
            data: payload,
            method: "PUT"
        });
    };
    return CoursesAPI;
}();
CoursesAPI.CACHE_GET_TOPIC_DESCRIPTION = {};
/**
 * @deprecated
 */ var getQuestionsById = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(question_ids) {
        var ref, response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("question?question_ids=".concat(question_ids === null || question_ids === void 0 ? void 0 : question_ids.join(",")))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, response), {
                            data: (ref = response.data) === null || ref === void 0 ? void 0 : ref.map(function(e) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, e), {
                                    quiz_position_mapping: [
                                        {
                                            question_id: e.id
                                        }, 
                                    ]
                                });
                            })
                        })
                    ];
            }
        });
    });
    return function getQuestionsById(question_ids) {
        return _ref.apply(this, arguments);
    };
}();
//Hiện đang dùng để submit cho bài test trong activity
var submitQuizTest = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(id, data, class_user_id) {
        var ref, quizAttemptResponse, quizAttemptId, ref1, uri, response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        CoursesAPI.createQuizAttempt(id, class_user_id)
                    ];
                case 1:
                    quizAttemptResponse = _state.sent();
                    quizAttemptId = (ref = quizAttemptResponse.data) === null || ref === void 0 ? void 0 : ref.id;
                    if (!quizAttemptId) return [
                        3,
                        3
                    ];
                    uri = "/quiz" + "/".concat(quizAttemptId) + "/submit-with-all-answer";
                    return [
                        4,
                        (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(uri), {
                            data: data,
                            method: "POST"
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, response), {
                            quizAttemptId: quizAttemptId,
                            progress: quizAttemptResponse === null || quizAttemptResponse === void 0 ? void 0 : (ref1 = quizAttemptResponse.data) === null || ref1 === void 0 ? void 0 : ref1.progress
                        })
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function submitQuizTest(id, data, class_user_id) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * @description Lấy thông tin hoạt động bằng ID.
 * @async
 * @param {string} id - ID của hoạt động.
 * @param {string} accessToken - Token truy cập của người dùng.
 * @returns {Promise<IActivity>} - Dữ liệu hoạt động.
 */ var getActivityById = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(id, course_id) {
        var ref, responseActivity, responseTabs, promises, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("courses/".concat(course_id, "/activity/").concat(id))
                    ];
                case 1:
                    responseActivity = _state.sent();
                    return [
                        4,
                        (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("course-sections/activity/".concat(id, "/tabs"))
                    ];
                case 2:
                    responseTabs = _state.sent();
                    if ((responseActivity === null || responseActivity === void 0 ? void 0 : responseActivity.data) && !(responseTabs === null || responseTabs === void 0 ? void 0 : (ref = responseTabs.data) === null || ref === void 0 ? void 0 : ref.length)) {
                        return [
                            2,
                            responseActivity.data
                        ];
                    }
                    responseActivity.data.tabs = [];
                    promises = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        _loop = function() {
                            var tab = _step.value;
                            promises.push(new Promise(function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(resolve, reject) {
                                    var responseTab;
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("course-sections/".concat(course_id, "/tab/").concat(tab.id))
                                                ];
                                            case 1:
                                                responseTab = _state.sent();
                                                if (responseTab === null || responseTab === void 0 ? void 0 : responseTab.data) {
                                                    return [
                                                        2,
                                                        resolve(responseTab.data)
                                                    ];
                                                }
                                                return [
                                                    2,
                                                    reject("Tab Not Found")
                                                ];
                                        }
                                    });
                                });
                                return function(resolve, reject) {
                                    return _ref.apply(this, arguments);
                                };
                            }()));
                        };
                        for(_iterator = responseTabs.data[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    _ = responseActivity.data;
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 3:
                    _.tabs = _state.sent();
                    return [
                        2,
                        responseActivity.data
                    ];
            }
        });
    });
    return function getActivityById(id, course_id) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 81482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ EntranceTestAPI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73782);
/* harmony import */ var _services_requestV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91002);


var EntranceTestAPI = /*#__PURE__*/ function() {
    "use strict";
    function EntranceTestAPI() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, EntranceTestAPI);
    }
    EntranceTestAPI.get = function get(params) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("entrance-test", {
            params: params
        });
    };
    EntranceTestAPI.getListUnivers = function getListUnivers() {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("universities");
    };
    EntranceTestAPI.getListUniversProgram = function getListUniversProgram() {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("university-programs");
    };
    EntranceTestAPI.getListMajors = function getListMajors() {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("majors");
    };
    EntranceTestAPI.getListEngLevel = function getListEngLevel() {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("english-levels");
    };
    EntranceTestAPI.getEntranceCount = function getEntranceCount() {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("users/entrance-test/count");
    };
    EntranceTestAPI.getListEntranceTestLogin = function getListEntranceTestLogin() {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("entrance-test");
    };
    EntranceTestAPI.putLevel = function putLevel(data) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("users/input-level", {
            method: "PUT",
            data: data
        });
    };
    return EntranceTestAPI;
}();


/***/ }),

/***/ 80926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ EventTestAPI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73782);
/* harmony import */ var _services_requestV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91002);


var EventTestAPI = /*#__PURE__*/ function() {
    "use strict";
    function EventTestAPI() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, EventTestAPI);
    }
    EventTestAPI.get = function get(params) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("event-tests", {
            params: params
        });
    };
    EventTestAPI.getCount = function getCount() {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("event-tests/count");
    };
    return EventTestAPI;
}();


/***/ }),

/***/ 18015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ NotificationAPI; }
/* harmony export */ });
/* unused harmony export apiURL */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73782);
/* harmony import */ var _services_requestV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91002);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55514);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);



var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_1___default()().publicRuntimeConfig;
var apiURL = publicRuntimeConfig.apiURL;
var NotificationAPI = /*#__PURE__*/ function() {
    "use strict";
    function NotificationAPI() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, NotificationAPI);
    }
    NotificationAPI.getCountUnRead = function getCountUnRead() {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(apiURL, "/notifications/count-unread"));
    };
    NotificationAPI.getNotification = function getNotification(params) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(apiURL, "/notifications"), {
            params: params
        });
    };
    NotificationAPI.getDetail = function getDetail(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(apiURL, "/notifications/").concat(id));
    };
    NotificationAPI.markAll = function markAll() {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(apiURL, "/notifications/mark-all-read"), {
            method: "POST"
        });
    };
    NotificationAPI.markById = function markById(ids, markRead) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(apiURL, "/notifications/mark-read"), {
            method: "POST",
            data: {
                notification_ids: ids,
                mark_read: markRead
            }
        });
    };
    return NotificationAPI;
}();


/***/ }),

/***/ 36174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ AuthAPI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73782);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52621);
/* harmony import */ var _services_requestV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91002);
/* harmony import */ var src_redux_services_httpService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92816);





var MyProfileAPI = {
    getProfile: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("/users/profile")
            ];
        });
    }),
    getSubjectOfhubspot: function(courseCategoryName) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("/users/subject-of-hubspot?course_category_name=".concat(courseCategoryName, "&sort=name%3DASC"));
    },
    getExamBySubjectId: function(param) {
        var pageIndex = param.pageIndex, pageSize = param.pageSize, params = param.params;
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("/users/examination-subjects?page_index=".concat(pageIndex, "&page_size=").concat(pageSize), {
            params: params
        });
    },
    updateProgram: function(data) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("/users/programs", {
            data: data,
            method: "PUT"
        });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (MyProfileAPI);
var AuthAPI = /*#__PURE__*/ function() {
    "use strict";
    function AuthAPI() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, AuthAPI);
    }
    AuthAPI.getProfile = function getProfile() {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(src_redux_services_httpService__WEBPACK_IMPORTED_MODULE_1__/* .apiURL */ .QH, "/users/profile"));
    };
    AuthAPI.me = function me() {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("me");
    };
    AuthAPI.sendEmail = function sendEmail(request) {
        var ref;
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("auth/forgot-password", {
            method: "POST",
            data: {
                email: (ref = request.email) === null || ref === void 0 ? void 0 : ref.trim()
            }
        });
    };
    AuthAPI.verifyOtp = function verifyOtp(data) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("auth/forgot-password/verify-otp", {
            method: "POST",
            data: data
        });
    };
    AuthAPI.resetPassword = function resetPassword(data) {
        var ref;
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("auth/reset-password", {
            method: "POST",
            data: {
                new_password: (ref = data.new_password) === null || ref === void 0 ? void 0 : ref.trim()
            }
        });
    };
    AuthAPI.changePassword = function changePassword(data) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("changepassword", {
            method: "POST",
            data: data
        });
    };
    AuthAPI.getUserInformation = function getUserInformation() {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("users/course-certificate/count");
    };
    AuthAPI.updateUser = function updateUser(full_name, avatar) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("users", {
            method: "PUT",
            data: {
                full_name: full_name,
                avatar: avatar
            }
        });
    };
    AuthAPI.makeContactDefault = function makeContactDefault(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("users/contacts/".concat(id, "/make-this-default"), {
            method: "POST"
        });
    };
    AuthAPI.getListDevices = function getListDevices() {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("users/devices");
    };
    AuthAPI.getListHistory = function getListHistory(params) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("users/activities", {
            params: params
        });
    };
    AuthAPI.getCertificate = function getCertificate(pageSize, pageIndex) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("certificate?page_size=".concat(pageIndex, "&page_index=").concat(pageSize));
    };
    AuthAPI.changeUserPassword = function changeUserPassword(current_password) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("users/change-password/send-otp", {
            data: {
                type: "CHANGE_PASSWORD",
                current_password: current_password
            },
            method: "POST"
        });
    };
    AuthAPI.verifyOTPPassword = function verifyOTPPassword(current_password, new_password, otp_code) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("users/change-password", {
            data: {
                current_password: current_password,
                new_password: new_password,
                otp_code: otp_code
            },
            method: "POST"
        });
    };
    AuthAPI.getPinnedNotifications = function getPinnedNotifications() {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("notifications/pinned");
    };
    return AuthAPI;
}();


/***/ }),

/***/ 40431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ QuestionAPI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73782);
/* harmony import */ var _services_requestV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91002);


var baseURL = "question";
var QuestionAPI = /*#__PURE__*/ function() {
    "use strict";
    function QuestionAPI() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, QuestionAPI);
    }
    QuestionAPI.getQuestionDetail = function getQuestionDetail(questionId, query) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(baseURL, "/").concat(questionId), {
            params: query
        });
    };
    return QuestionAPI;
}();


/***/ }),

/***/ 97590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ TestAPI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73782);
/* harmony import */ var _services_requestV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91002);


var TestAPI = /*#__PURE__*/ function() {
    "use strict";
    function TestAPI() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, TestAPI);
    }
    TestAPI.createTopicAttempt = function createTopicAttempt(quiz_id, question_topic_id, class_user_id, story_topic_id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("quiz/case-study/topic-attempt", {
            method: "POST",
            data: {
                quiz_id: quiz_id,
                question_topic_id: question_topic_id,
                class_user_id: class_user_id,
                story_topic_id: story_topic_id
            }
        });
    };
    TestAPI.getQuestionAnswer = function getQuestionAnswer(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("question/results", {
            params: {
                question_ids: id
            }
        });
    };
    TestAPI.getResource = function getResource(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("resource/".concat(id));
    };
    return TestAPI;
}();


/***/ }),

/***/ 95986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ UploadAPI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73782);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72760);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52621);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68582);
/* harmony import */ var _services_requestV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91002);








var UploadAPI = /*#__PURE__*/ function() {
    "use strict";
    function UploadAPI() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, UploadAPI);
    }
    UploadAPI.startUpload = function startUpload(param) {
        var content_type = param.content_type, name = param.name, size = param.size, blob = param.blob, description = param.description, getProgress = param.getProgress, location = param.location;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            var responsePreUpload, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            preUpload({
                                content_type: content_type,
                                name: name || "",
                                location: location || "",
                                size: size
                            })
                        ];
                    case 1:
                        responsePreUpload = _state.sent();
                        return [
                            4,
                            uploadFile({
                                upload_url: responsePreUpload.data.upload_url,
                                file_key: responsePreUpload.data.file_key,
                                type: responsePreUpload.data.type,
                                contentType: content_type,
                                blob: blob
                            }, getProgress)
                        ];
                    case 2:
                        _state.sent();
                        // const response = await addFileResource({
                        //   name,
                        //   file_key: responsePreUpload.data.file_key,
                        //   location: location || '',
                        //   description,
                        //   size,
                        //   parent_id: null,
                        // })
                        // return response?.data?.[0]?.id
                        return [
                            2,
                            responsePreUpload
                        ];
                    case 3:
                        error = _state.sent();
                        throw error;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return UploadAPI;
}();
UploadAPI.downloadFile = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(data) {
        var ref, responseToken, ref1, link, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("resource/get-token-download", {
                            data: data,
                            method: "POST"
                        })
                    ];
                case 1:
                    responseToken = _state.sent();
                    if (responseToken === null || responseToken === void 0 ? void 0 : (ref = responseToken.data) === null || ref === void 0 ? void 0 : ref.success) {
                        ;
                        link = document.createElement("a");
                        link.href = "".concat((0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .getBaseUrl */ .SV)(), "/resource/download?token=").concat(responseToken === null || responseToken === void 0 ? void 0 : (ref1 = responseToken.data) === null || ref1 === void 0 ? void 0 : ref1.data);
                        link.download = data.files[0].name;
                        link.style.display = "none";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
UploadAPI.getUrlFile = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(file_key) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("resource/pre-upload/url", {
                    params: {
                        file_key: file_key
                    }
                })
            ];
        });
    });
    return function(file_key) {
        return _ref.apply(this, arguments);
    };
}();
var preUpload = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var content_type, name, location, size;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            content_type = param.content_type, name = param.name, location = param.location, size = param.size;
            return [
                2,
                (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("resource/pre-upload/metadata", {
                    params: {
                        content_type: content_type,
                        name: name,
                        location: location,
                        size: size
                    }
                })
            ];
        });
    });
    return function preUpload(_) {
        return _ref.apply(this, arguments);
    };
}();
var percent = 0;
var uploadFile = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(file, getProgress) {
        var fileBlob, onUploadProgress, error, startResp, startMultipartResponse, uploadId, metadata, parts, batchSize, uploadPartsArray, error1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    fileBlob = file.blob;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        ,
                        11
                    ]);
                    if (!(file.type === "SINGLE_PART")) return [
                        3,
                        6
                    ];
                    onUploadProgress = function(progressEvent) {
                        var percent = Math.round(progressEvent.loaded * 100 / progressEvent.total);
                        if (getProgress) {
                            getProgress(percent);
                        }
                    };
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].put */ .Z.put(file.upload_url, fileBlob, {
                            headers: {
                                "Content-Type": fileBlob.type
                            },
                            onUploadProgress: onUploadProgress
                        })
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    throw error;
                case 5:
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        _services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/resources/upload/start", {
                            file_key: file.file_key,
                            content_type: fileBlob.type,
                            size: fileBlob.size
                        })
                    ];
                case 7:
                    startResp = _state.sent();
                    startMultipartResponse = startResp.data.data;
                    uploadId = startMultipartResponse.uploadId, metadata = startMultipartResponse.metadata, parts = startMultipartResponse.parts;
                    batchSize = 2;
                    percent = 0;
                    return [
                        4,
                        uploadMultipart((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                            batchSize: batchSize,
                            chunkSize: metadata.partSize,
                            fileBlob: fileBlob,
                            numberOfChunks: metadata.numberOfParts,
                            parts: parts
                        }, getProgress ? {
                            getProgress: getProgress
                        } : {
                            getProgress: function() {}
                        }))
                    ];
                case 8:
                    uploadPartsArray = _state.sent();
                    return [
                        4,
                        _services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/resources/upload/complete", {
                            file_key: file.file_key,
                            parts: uploadPartsArray,
                            uploadId: uploadId
                        })
                    ];
                case 9:
                    _state.sent();
                    return [
                        3,
                        11
                    ];
                case 10:
                    error1 = _state.sent();
                    throw error1;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
    return function uploadFile(file, getProgress) {
        return _ref.apply(this, arguments);
    };
}();
function uploadMultipart(params, source) {
    return _uploadMultipart.apply(this, arguments);
}
function _uploadMultipart() {
    _uploadMultipart = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(params, source) {
        var chunkSize, numberOfChunks, fileBlob, batchSize, parts, getProgress, index, partNumbers, batchUploadPromises, batchElementIndex, batchUploadResults, partsUploadResults, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, result, _value, response, part_number, nextPartsUploadResults;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    chunkSize = params.chunkSize, numberOfChunks = params.numberOfChunks, fileBlob = params.fileBlob, batchSize = params.batchSize, parts = params.parts, getProgress = params.getProgress;
                    index = params.index === undefined ? 0 : params.index;
                    partNumbers = parts.map(function(part) {
                        return part.part_number;
                    });
                    batchUploadPromises = [];
                    batchElementIndex = 0;
                    while(batchElementIndex < batchSize && index < numberOfChunks){
                        var ref;
                        index += 1;
                        batchElementIndex += 1;
                        var start = (index - 1) * chunkSize;
                        var end = index * chunkSize;
                        var blob = index < numberOfChunks ? fileBlob.slice(start, end) : fileBlob.slice(start);
                        var uploadUrl = (ref = parts[partNumbers.indexOf(index)]) === null || ref === void 0 ? void 0 : ref.upload_url;
                        try {
                            var uploadPromise = getUploadPromise({
                                blob: blob,
                                contentType: fileBlob.type,
                                index: index,
                                uploadUrl: uploadUrl,
                                fileSize: fileBlob.size,
                                chunkSize: blob.size,
                                getProgress: getProgress
                            }, source);
                            batchUploadPromises.push(uploadPromise);
                        } catch (error) {
                            throw error;
                        }
                    }
                    return [
                        4,
                        Promise.allSettled(batchUploadPromises)
                    ];
                case 1:
                    batchUploadResults = _state.sent();
                    partsUploadResults = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = batchUploadResults[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            result = _step.value;
                            if (result.status === "fulfilled") {
                                _value = result.value, response = _value.response, part_number = _value.index;
                                partsUploadResults.push({
                                    eTag: response.headers.etag,
                                    part_number: part_number
                                });
                            } else {
                                throw new Error("One request failed: " + result.reason);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (!(index < numberOfChunks)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        uploadMultipart((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params), {
                            index: index
                        }))
                    ];
                case 2:
                    nextPartsUploadResults = _state.sent();
                    return [
                        2,
                        (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(partsUploadResults).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(nextPartsUploadResults))
                    ];
                case 3:
                    return [
                        2,
                        partsUploadResults
                    ];
            }
        });
    });
    return _uploadMultipart.apply(this, arguments);
}
function getUploadPromise(params, source) {
    var blob = params.blob, index = params.index, uploadUrl = params.uploadUrl, contentType = params.contentType, getProgress = params.getProgress, fileSize = params.fileSize, chunkSize = params.chunkSize;
    return new Promise(function(resolve, reject) {
        if (!uploadUrl) {
            reject("Upload url is empty at part_number: " + index);
        } else {
            axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].put */ .Z.put(uploadUrl, blob, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                headers: {
                    "Content-Type": contentType
                }
            }, source && {
                cancelToken: source.token
            })).then(function(response) {
                var percentCompleted = Math.round(chunkSize / fileSize * 100);
                percent += percentCompleted;
                getProgress(percent >= 100 ? 100 : percent);
                resolve({
                    response: response,
                    index: index
                });
            }).catch(function(error) {
                source && source.cancel("One request failed, canceling all the others");
                getProgress(100);
                reject(error);
            });
        }
    });
}


/***/ }),

/***/ 59211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ UserApi; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73782);
/* harmony import */ var _services_requestV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91002);
/* harmony import */ var src_redux_services_httpService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92816);



var UserApi = /*#__PURE__*/ function() {
    "use strict";
    function UserApi() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, UserApi);
    }
    UserApi.getExamination = function getExamination(page_index, page_size) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("".concat(src_redux_services_httpService__WEBPACK_IMPORTED_MODULE_1__/* .apiURL */ .QH, "/users/examination?page_index=").concat(page_index, "&page_size=").concat(page_size));
    };
    UserApi.getUserPrograms = function getUserPrograms(course_category_id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("users/programs?course_category_id=".concat(course_category_id));
    };
    /**
   * Gửi yêu cầu đăng xuất người dùng thông qua refresh token.
   *
   * Hàm này gọi API `auth/logout` với phương thức POST và gửi refresh token
   * để yêu cầu hệ thống hủy phiên đăng nhập hiện tại. Sau khi logout thành công,
   * API sẽ trả về `user_id_init` — ID của người dùng đã khởi tạo phiên đăng nhập.
   *
   * @param {string} refresh_token - Refresh token của người dùng dùng để xác thực và hủy phiên.
   * @returns {Promise<{user_id_init: string}>} - Trả về Promise chứa ID người dùng đã đăng xuất.
   *
   * @example
   * AuthService.logout('your-refresh-token')
   *   .then(response => console.log(response.user_id_init))
   *   .catch(error => console.error(error));
   */ UserApi.logout = function logout(session_id, keycloak_user_id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("auth/logout", {
            method: "POST",
            data: {
                session_id: session_id,
                keycloak_user_id: keycloak_user_id
            }
        });
    };
    return UserApi;
}();


/***/ }),

/***/ 46675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ error_redirect; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
// EXTERNAL MODULE: ./src/components/base/button/SappButton.tsx
var SappButton = __webpack_require__(98971);
// EXTERNAL MODULE: ./src/utils/constants/index.ts + 3 modules
var constants = __webpack_require__(15183);
;// CONCATENATED MODULE: ./src/assets/images/Oops.svg
/* harmony default export */ var Oops = ({"src":"/_next/static/media/Oops.bb40318e.svg","height":145,"width":322});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(60071);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/pages/error-redirect/index.tsx





var ErrorRedirectPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex h-screen flex-col flex-nowrap items-center justify-center gap-6 p-4 text-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: Oops,
                alt: "SAPP Oops",
                width: 321,
                height: 142,
                priority: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-center font-inter text-3xl font-semibold text-bw-11",
                children: "Oops!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-center font-inter text-lg font-normal text-gray-9",
                children: "Something went wrong. Please try again."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SappButton/* default */.Z, {
                title: "Back to Home Page",
                full: false,
                className: "rounded-2.5 !px-6 py-4 font-inter text-sm !leading-4",
                size: "lager",
                onClick: function() {
                    if (true) {
                        window.location.href = "/";
                    }
                }
            })
        ]
    });
};
/* harmony default export */ var error_redirect = (ErrorRedirectPage);
ErrorRedirectPage.layout = constants/* LAYOUT.ERROR_LAYOUT */._.ERROR_LAYOUT;


/***/ }),

/***/ 34705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useAppSelector; },
/* harmony export */   "T": function() { return /* binding */ useAppDispatch; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9616);

// Use throughout your app instead of plain `useDispatch` and `useSelector`
var useAppDispatch = function() {
    return (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
};
var useAppSelector = react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9;


/***/ }),

/***/ 92337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _services_requestV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91002);

/**
 * @description CourseActivityApi cung cấp các phương thức để tương tác với các hoạt động khóa học.
 * @namespace CourseActivityApi
 */ var CourseActivityApi = {
    /**
   * @description upload ảnh cho cuộc thảo luận.
   * @async
   * @param {ICreateDiscussionUploadRequest} request - Dữ liệu yêu cầu upload cuộc thảo luận.
   * @returns {Promise<IResponse<IDiscussion>>} - Dữ liệu cuộc thảo luận đã upload.
   */ uploadImagesDiscussion: function(param) {
        var discussion_id = param.discussion_id, new_discussion_file = param.new_discussion_file, discussion_file_ids = param.discussion_file_ids;
        var formData = new FormData();
        formData.append("discussion_id", discussion_id);
        new_discussion_file === null || new_discussion_file === void 0 ? void 0 : new_discussion_file.forEach(function(file, index) {
            formData.append("discussion_images[".concat(index, "]"), file);
        });
        discussion_file_ids === null || discussion_file_ids === void 0 ? void 0 : discussion_file_ids.forEach(function(discussion_file_id, index) {
            formData.append("discussion_file_ids[".concat(index, "]"), discussion_file_id);
        });
        // Sử dụng httpService để gửi yêu cầu POST_FORM_DATA
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetchFormData */ .Ji)({
            url: "/course-discussions/detail/upload",
            formData: formData
        });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (CourseActivityApi);


/***/ }),

/***/ 25292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export url */
var url = {
    getQuestionTabs: "/quiz",
    getCaseStudyQuizes: "/quiz/case-study",
    getTopicQuiz: "/question-topic",
    getQuestionDetail: "/question",
    getQuestionResult: "/question/results",
    getTopicDescription: "/question-topic",
    submitQuestion: "/quiz",
    submitCaseStudy: "/quiz/case-study",
    getResource: "/resource",
    getQuizAttempts: "/quiz-attempts",
    createQuizAttemp: "/quiz/quiz-attempt",
    getQuizAttemptsTable: "/quiz-attempts/table",
    getCaseStudyAttmptsTable: "/quiz-attempts/case-study/table",
    getQuizAttemptsChartData: "/quiz-attempts/chart-data",
    createTopicAttempt: "/quiz/case-study/topic-attempt",
    getAnswer: "quiz-attempts/answers",
    getTopicAttemptDetail: "/quiz-attempts/topic/",
    getDiscussionStudentInfo: "/course-discussions/student-info"
};
/* harmony default export */ __webpack_exports__["Z"] = (url);


/***/ }),

/***/ 39421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ user; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(51224);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(52621);
// EXTERNAL MODULE: ./src/redux/services/httpService.ts
var httpService = __webpack_require__(92816);
;// CONCATENATED MODULE: ./src/redux/services/User/url.ts
var url = {
    me: "/me",
    user: "/users",
    coursesAndCertificates: "/users/course-certificate/count",
    userAvatar: "/users/avatar",
    makeContactDefault: "/users/contacts",
    devices: "/users/devices",
    history: "/users/activities"
};
/* harmony default export */ var User_url = (url);

// EXTERNAL MODULE: ./src/pages/api/profile/index.ts
var profile = __webpack_require__(36174);
// EXTERNAL MODULE: ./src/services/requestV2.ts
var requestV2 = __webpack_require__(91002);
;// CONCATENATED MODULE: ./src/redux/services/User/user.ts






var UserApi = {
    /**
   * Một hàm để lấy thông tin của người dùng hiện tại
   * @returns {Promise<IUser>} Một promise chứa đối tượng IUser
   */ getMe: function() {
        // Đường dẫn api để lấy thông tin người dùng
        // Sử dụng httpService để gửi yêu cầu GET
        return profile/* AuthAPI.me */.u.me();
    },
    /**
   * Một hàm để lấy khóa học và certificate của người dùng hiện tại
   */ getUserInformation: function() {
        // Đường dẫn api để lấy khóa học và certificate của người dùng người dùng
        var uri = User_url.coursesAndCertificates;
        // Sử dụng httpService để gửi yêu cầu GET
        return profile/* AuthAPI.getUserInformation */.u.getUserInformation();
    },
    /**
   * Một hàm để cập nhật thông tin của người dùng
   * @param {string} full_name - Tên đầy đủ của người dùng
   * @param {{[key: string]: string} | null} avatar - Đối tượng chứa thông tin avatar của người dùng
   * @returns {Promise<IResponse<{message: string}>>} Một promise chứa đối tượng IResponse
   */ updateUser: function(full_name, avatar) {
        // Sử dụng httpService để gửi yêu cầu PUT
        return profile/* AuthAPI.updateUser */.u.updateUser(full_name, avatar);
    },
    /**
   * Một hàm để cập nhật avatar của người dùng
   * @param {File} avatar - File ảnh của avatar
   * @returns {Promise<any>} Một promise chứa dữ liệu trả về từ api
   */ updateUserAvatar: function(avatar) {
        // Tạo một đối tượng formData để chứa file ảnh
        var formData = new FormData();
        formData.append("avatar", avatar);
        // Sử dụng httpService để gửi yêu cầu POST_FORM_DATA
        return (0,requestV2/* fetchFormData */.Ji)({
            url: "".concat(httpService/* apiURL */.QH, "/users/avatar"),
            formData: formData
        });
    },
    getListDevices: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                profile/* AuthAPI.getListDevices */.u.getListDevices()
            ];
        });
    }),
    getListDevicesV2: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                profile/* AuthAPI.getListDevices */.u.getListDevices()
            ];
        });
    }),
    getListHistory: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var page_index, page_size, type;
            return (0,tslib_es6.__generator)(this, function(_state) {
                page_index = param.page_index, page_size = param.page_size, type = param.type;
                return [
                    2,
                    profile/* AuthAPI.getListHistory */.u.getListHistory({
                        page_index: page_index,
                        page_size: page_size,
                        type: type
                    })
                ];
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(),
    /**
   * Một hàm để lấy Pinned Notification
   *
   */ getPinnedNotifications: function() {
        // Đường dẫn api Pinned Notification
        // Sử dụng httpService để gửi yêu cầu GET
        return profile/* AuthAPI.getPinnedNotifications */.u.getPinnedNotifications();
    }
};
/* harmony default export */ var user = (UserApi);


/***/ }),

/***/ 92816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QH": function() { return /* binding */ apiURL; },
/* harmony export */   "ni": function() { return /* binding */ injectStore; }
/* harmony export */ });
/* unused harmony exports getBaseUrl, axiosInstance */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52621);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68582);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55514);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_services_en_exceptions_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20959);
/* harmony import */ var _utils_helpers_keycloak__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3787);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72808);








var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_0___default()().publicRuntimeConfig;
var apiURL = publicRuntimeConfig.apiURL;
var store;
var injectStore = function(_store) {
    store = _store;
};
var getBaseUrl = function() {
    if (true) {
        return "https://lms-be.sapp.edu.vn/api/v1";
    }
};
var axiosInstance = axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].create */ .Z.create({
    baseURL: getBaseUrl()
});
// Add a request interceptor to the Axios instance
axiosInstance.interceptors.request.use(function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(config) {
        var authenticationManager;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authenticationManager = new _utils_helpers_keycloak__WEBPACK_IMPORTED_MODULE_2__/* .AuthenticationManager */ .E();
                    if (authenticationManager.getToken() !== "") {
                        config.headers = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                            Authorization: "Bearer " + authenticationManager.getToken()
                        }, config.headers);
                        return [
                            2,
                            config
                        ];
                    }
                    return [
                        4,
                        new Promise(function(resolve) {
                            var interval = null;
                            interval = setInterval(function() {
                                if (authenticationManager.getToken()) {
                                    config.headers = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                        Authorization: "Bearer " + authenticationManager.getToken()
                                    }, config.headers);
                                    clearInterval(interval);
                                    resolve(config);
                                }
                            }, 100);
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        config
                    ];
            }
        });
    });
    return function(config) {
        return _ref.apply(this, arguments);
    };
}(), function(error) {
    // If there is an error, return the Promise.reject() method
    return Promise.reject(error);
});
// Add a response interceptor to the Axios instance
axiosInstance.interceptors.response.use(function(response) {
    // If the response is successful,
    return response;
}, function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(error) {
        var originalRequest, authenticationManager;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    originalRequest = error.config;
                    if (error.response && error.response.status !== 401) {
                        return [
                            2,
                            Promise.reject(error)
                        ];
                    }
                    if (!(error.response && error.response.status === 401)) return [
                        3,
                        2
                    ];
                    authenticationManager = new _utils_helpers_keycloak__WEBPACK_IMPORTED_MODULE_2__/* .AuthenticationManager */ .E();
                    return [
                        4,
                        authenticationManager.refreshToken()
                    ];
                case 1:
                    _state.sent();
                    originalRequest.headers["Authorization"] = "Bearer " + authenticationManager.getToken();
                    return [
                        2,
                        (0,axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(originalRequest)
                    ];
                case 2:
                    return [
                        2,
                        Promise.reject(error)
                    ];
            }
        });
    });
    return function(error) {
        return _ref.apply(this, arguments);
    };
}());
var toastException = [
    "400|060915",
    "400|060904",
    "403|000010",
    "400|010833",
    "400|010433",
    "400|010008", 
];
var formatedExceptions = src_services_en_exceptions_json__WEBPACK_IMPORTED_MODULE_1__.reduce(function(acc, param) {
    var code = param.code, message = param.message;
    acc[code] = message;
    return acc;
}, {});
axiosInstance.interceptors.response.use(function(response) {
    return response;
}, function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(error) {
        var ref, ref1, ref2, errorCode, errorMessage, ref3;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            errorCode = error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.error) === null || ref2 === void 0 ? void 0 : ref2.code;
            errorMessage = formatedExceptions[errorCode];
            if (!toastException.includes(errorCode)) {
                ;
                react_hot_toast__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .ZP.error(errorMessage || (error === null || error === void 0 ? void 0 : (ref3 = error.response) === null || ref3 === void 0 ? void 0 : ref3.statusText) || (error === null || error === void 0 ? void 0 : error.message) || "Unknown error!");
            }
            return [
                2,
                Promise.reject(error)
            ];
        });
    });
    return function(error) {
        return _ref.apply(this, arguments);
    };
}());


/***/ }),

/***/ 35392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fW": function() { return /* binding */ confirmDialogActions; },
/* harmony export */   "mj": function() { return /* binding */ confirmDialogReducer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21967);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2249);


var initialState = {
    open: false,
    message: "",
    cancelButtonTitle: "No",
    okButtonTitle: "Yes",
    onCancel: function() {},
    onConfirm: function() {}
};
var confirmDialogSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "confirmDialog",
    initialState: initialState,
    reducers: {
        /**
     * Một action để yêu cầu một xác nhận với tiêu đề, nội dung và các hàm gọi lại đã cho
     * @param {ConfirmDialogState} state - Trạng thái hiện tại của hộp thoại xác nhận
     * @param {PayloadAction<ConfirmDialogState>} action - Hành động có chứa các thông tin cần thiết cho hộp thoại xác nhận
     */ requestConfirmation: function(state, action) {
            var _payload = action.payload, message = _payload.message, onCancel = _payload.onCancel, onConfirm = _payload.onConfirm, okButtonTitle = _payload.okButtonTitle, cancelButtonTitle = _payload.cancelButtonTitle;
            state.open = true;
            state.message = message;
            state.cancelButtonTitle = cancelButtonTitle;
            state.okButtonTitle = okButtonTitle;
            state.onCancel = onCancel;
            state.onConfirm = onConfirm;
        },
        /**
     * Một action để đóng hộp thoại xác nhận và khôi phục trạng thái ban đầu
     */ closeConfirmation: function() {
            return initialState;
        },
        /**
     * Một action để đặt trạng thái loading thành true
     * @param {ConfirmDialogState} state - Trạng thái hiện tại của hộp thoại xác nhận
     */ setLoadingTrue: function(state) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, state);
        }
    }
});
var confirmDialogActions = confirmDialogSlice.actions;
var confirmDialogReducer = function(state) {
    return state.confirmDialogReducer;
};
/* harmony default export */ __webpack_exports__["ZP"] = (confirmDialogSlice.reducer);


/***/ }),

/***/ 55771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52621);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2249);
/* harmony import */ var _ConfirmDialogSlice__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35392);




// định nghĩa các hành động thunk cho hộp thoại xác nhận
var confirmDialog = {
    /**
   * Một hàm tạo ra một thunk trả về một promise giải quyết thành một giá trị boolean
   * cho biết người dùng đã xác nhận hay hủy bỏ hành động
   * @param {object} arg - Đối tượng đối số cho thunk
   * @param {string} arg.title - Tiêu đề của hộp thoại xác nhận
   * @param {string} arg.message - Nội dung của hộp thoại xác nhận
   * @param {function} arg.onConfirm - Hàm thực thi khi người dùng xác nhận hành động
   * @param {function} arg.onCancel - Hàm thực thi khi người dùng hủy bỏ hành động
   * @returns {Promise<boolean>} Một promise giải quyết thành một giá trị boolean
   */ open: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAsyncThunk */ .hg)("confirmDialog/open", function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param, param1) {
            var message, onConfirm, onCancel, dispatch, rejectWithValue, fulfillWithValue;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                message = param.message, onConfirm = param.onConfirm, onCancel = param.onCancel, dispatch = param1.dispatch, rejectWithValue = param1.rejectWithValue, fulfillWithValue = param1.fulfillWithValue;
                try {
                    dispatch(_ConfirmDialogSlice__WEBPACK_IMPORTED_MODULE_0__/* .confirmDialogActions.requestConfirmation */ .fW.requestConfirmation({
                        message: message,
                        // Hàm này được gọi khi người dùng nhấn nút hủy
                        onCancel: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                            var _tmp;
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _tmp = onCancel;
                                        if (!_tmp) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            onCancel()
                                        ];
                                    case 1:
                                        _tmp = _state.sent();
                                        _state.label = 2;
                                    case 2:
                                        _tmp;
                                        dispatch(_ConfirmDialogSlice__WEBPACK_IMPORTED_MODULE_0__/* .confirmDialogActions.closeConfirmation */ .fW.closeConfirmation());
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        // Hàm này được gọi khi người dùng nhấn nút xác nhận
                        onConfirm: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            onConfirm()
                                        ];
                                    case 1:
                                        _state.sent();
                                        dispatch(_ConfirmDialogSlice__WEBPACK_IMPORTED_MODULE_0__/* .confirmDialogActions.closeConfirmation */ .fW.closeConfirmation());
                                        return [
                                            2
                                        ];
                                }
                            });
                        })
                    }));
                    return [
                        2,
                        fulfillWithValue(true)
                    ];
                } catch (error) {
                    // xử lý lỗi
                    return [
                        2,
                        rejectWithValue(error)
                    ];
                }
                return [
                    2
                ];
            });
        });
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
/* harmony default export */ __webpack_exports__["Z"] = (confirmDialog);


/***/ }),

/***/ 57304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AK": function() { return /* binding */ closeCalculator; },
/* harmony export */   "DG": function() { return /* binding */ getDiscussion; },
/* harmony export */   "Gp": function() { return /* binding */ openCalculator; },
/* harmony export */   "Hi": function() { return /* binding */ getCourseActivityTapById; },
/* harmony export */   "Iy": function() { return /* binding */ courseActivityReducer; },
/* harmony export */   "PK": function() { return /* binding */ reactDiscussion; },
/* harmony export */   "_X": function() { return /* binding */ courseActivityAction; },
/* harmony export */   "eT": function() { return /* binding */ uploadImagesDiscussion; },
/* harmony export */   "vv": function() { return /* binding */ createDiscussion; }
/* harmony export */ });
/* unused harmony export courseActivitySlice */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52621);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2249);
/* harmony import */ var src_redux_services_Course_MyCourse_Activity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92337);
/* harmony import */ var _pages_api_courses_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38916);
/* harmony import */ var src_pages_api_activity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44474);








var initialState = {
    loading: false,
    loadingDiscussion: false,
    currentTabId: "",
    calculator_status: false,
    id: "",
    created_at: "",
    updated_at: "",
    deleted_at: null,
    course_id: "",
    name: "",
    code: "",
    description: "",
    status: "",
    is_public: false,
    duration: 0,
    is_peer_review: false,
    is_graded: false,
    course_section_type: "",
    course_section_notes: [],
    activity_type: "",
    position: "",
    parent_id: "",
    display_icon: "",
    total_activity: 0,
    course_outcomes: [],
    course_learning_outcome: {
        id: "",
        created_at: "",
        updated_at: "",
        deleted_at: "",
        name: "",
        description: ""
    },
    files: [],
    discussion: undefined,
    breadcumb: [],
    user_course_section_progress: []
};
var getCourseActivityTapById = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("courseActivityReducer/getTapById", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param, thunkAPI) {
        var courseId, id, res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    courseId = param.courseId, id = param.id;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        _pages_api_courses_index__WEBPACK_IMPORTED_MODULE_1__/* .CoursesAPI.getCourseActivityTapById */ .tB.getCourseActivityTapById(courseId, id)
                    ];
                case 2:
                    res = _state.sent();
                    if (!(res === null || res === void 0 ? void 0 : res.data)) {
                        return [
                            2
                        ];
                    }
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, res.data)
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        thunkAPI.rejectWithValue(error)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var getDiscussion = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("courseActivityReducer/getDiscussion", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param, thunkAPI) {
        var id, sectionId, res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    id = param.id, sectionId = param.sectionId;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        _pages_api_courses_index__WEBPACK_IMPORTED_MODULE_1__/* .CoursesAPI.getDiscussion */ .tB.getDiscussion(id, sectionId)
                    ];
                case 2:
                    res = _state.sent();
                    if (!(res === null || res === void 0 ? void 0 : res.data)) {
                        return [
                            2
                        ];
                    }
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, res.data)
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        thunkAPI.rejectWithValue(error)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var createDiscussion = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("courseActivityReducer/createDiscussion", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(data, thunkAPI) {
        var res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        src_pages_api_activity__WEBPACK_IMPORTED_MODULE_2__/* .ActivityAPI.createDiscussionComment */ .J.createDiscussionComment(data)
                    ];
                case 1:
                    res = _state.sent();
                    if (!(res === null || res === void 0 ? void 0 : res.data)) {
                        return [
                            2
                        ];
                    }
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, res.data)
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        thunkAPI.rejectWithValue(error)
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function(data, thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var uploadImagesDiscussion = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("courseActivityReducer/uploadImagesDiscussion", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(data, thunkAPI) {
        var res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        src_redux_services_Course_MyCourse_Activity__WEBPACK_IMPORTED_MODULE_0__/* ["default"].uploadImagesDiscussion */ .Z.uploadImagesDiscussion(data)
                    ];
                case 1:
                    res = _state.sent();
                    if (!(res === null || res === void 0 ? void 0 : res.data)) {
                        return [
                            2
                        ];
                    }
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, res.data)
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        thunkAPI.rejectWithValue(error)
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function(data, thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var reactDiscussion = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("courseActivityReducer/reactDiscussion", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(data, thunkAPI) {
        var res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        src_pages_api_activity__WEBPACK_IMPORTED_MODULE_2__/* .ActivityAPI.reactDiscussion */ .J.reactDiscussion(data)
                    ];
                case 1:
                    res = _state.sent();
                    if (!(res === null || res === void 0 ? void 0 : res.data)) {
                        return [
                            2
                        ];
                    }
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, res.data)
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        thunkAPI.rejectWithValue(error)
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function(data, thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var courseActivitySlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "courseActivityReducer",
    initialState: initialState,
    reducers: {
        setActivityState: function(state, action) {
            var ref, ref1, ref2, ref3;
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state, action.payload), {
                tabs: action === null || action === void 0 ? void 0 : (ref = action.payload) === null || ref === void 0 ? void 0 : ref.tabs,
                currentTabId: (ref1 = action.payload) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.tabs) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.id
            });
        },
        resetActivity: function() {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, initialState);
        },
        openCalculator: function(state) {
            state.calculator_status = true;
        },
        closeCalculator: function(state) {
            state.calculator_status = false;
        }
    },
    extraReducers: function(builder) {
        builder.addCase(getCourseActivityTapById.pending, function(state) {
            state.loading = true;
        });
        builder.addCase(getCourseActivityTapById.fulfilled, function(state, action) {
            var ref, ref1;
            state.loading = false;
            state.currentTabId = (ref = action.payload) === null || ref === void 0 ? void 0 : ref.id;
            state.tabs = (ref1 = state.tabs) === null || ref1 === void 0 ? void 0 : ref1.map(function(e) {
                var ref;
                if (e.id === ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.id)) {
                    return action.payload;
                }
                return e;
            });
        });
        builder.addCase(getCourseActivityTapById.rejected, function(state) {
            state.loading = false;
        });
        builder.addCase(createDiscussion.pending, function(state) {
            state.loadingDiscussion = true;
        });
        builder.addCase(createDiscussion.fulfilled, function(state, action) {
            state.loadingDiscussion = false;
        });
        builder.addCase(createDiscussion.rejected, function(state) {
            state.loadingDiscussion = false;
        });
        builder.addCase(getDiscussion.pending, function(state) {
            state.loadingDiscussion = true;
        });
        builder.addCase(getDiscussion.fulfilled, function(state, action) {
            var ref, ref1;
            state.loadingDiscussion = false;
            state.discussion = (ref = action.payload) === null || ref === void 0 ? void 0 : ref.discussions;
            state.userInDiscussion = (ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.user;
        });
        builder.addCase(getDiscussion.rejected, function(state) {
            state.loadingDiscussion = false;
        });
        builder.addCase(reactDiscussion.pending, function(state) {
            state.loadingDiscussion = true;
        });
        builder.addCase(reactDiscussion.fulfilled, function(state, action) {
            state.loadingDiscussion = false;
        });
        builder.addCase(reactDiscussion.rejected, function(state) {
            state.loadingDiscussion = false;
        });
        builder.addCase(uploadImagesDiscussion.pending, function(state) {
            state.loadingDiscussion = true;
        });
        builder.addCase(uploadImagesDiscussion.fulfilled, function(state, action) {
            state.loadingDiscussion = false;
        });
        builder.addCase(uploadImagesDiscussion.rejected, function(state) {
            state.loadingDiscussion = false;
        });
    }
});
// export const selectAuthUser = (state: RootState) => state.loginReducer.authUser;
var courseActivityReducer = function(state) {
    return state.courseActivityReducer;
};
var courseActivityAction = courseActivitySlice.actions;
var _actions = courseActivitySlice.actions;
var openCalculator = _actions.openCalculator, closeCalculator = _actions.closeCalculator;
/* harmony default export */ __webpack_exports__["ZP"] = (courseActivitySlice.reducer);


/***/ }),

/***/ 3679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E4": function() { return /* binding */ selectQuestions; },
/* harmony export */   "Fl": function() { return /* binding */ removeQuizFinished; },
/* harmony export */   "GT": function() { return /* binding */ submitQuiz; },
/* harmony export */   "Hy": function() { return /* binding */ fetchQuestionById; },
/* harmony export */   "Lq": function() { return /* binding */ confirmQuestion; },
/* harmony export */   "Vi": function() { return /* binding */ resetQuizActivity; },
/* harmony export */   "ee": function() { return /* binding */ saveAnswer; },
/* harmony export */   "jW": function() { return /* binding */ courseActivityQuizReducer; },
/* harmony export */   "s1": function() { return /* binding */ clearFileEssay; },
/* harmony export */   "wr": function() { return /* binding */ saveFileEssay; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72760);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52621);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2249);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43743);
/* harmony import */ var src_pages_api_question__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40431);
/* harmony import */ var _pages_api_courses_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38916);









/**
 * Async thunk để fetch thông tin câu hỏi dựa trên ID.
 * @type {AsyncThunk}
 */ var fetchQuestionById = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("quiz/fetchQuestionById", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param, param1) {
        var activityId, tabId, quizId, questionId, rejectWithValue, getState, ref, ref1, ref2, ref3, state, existingQuestion, result, response, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    activityId = param.activityId, tabId = param.tabId, quizId = param.quizId, questionId = param.questionId, rejectWithValue = param1.rejectWithValue, getState = param1.getState;
                    state = getState();
                    existingQuestion = (((ref = state["courseActivityQuizReducer"]) === null || ref === void 0 ? void 0 : (ref1 = ref[activityId]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[tabId]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[quizId]) === null || ref3 === void 0 ? void 0 : ref3.questions) || []).find(function(question) {
                        return question.id === questionId;
                    });
                    result = {
                        activityId: activityId,
                        tabId: tabId,
                        quizId: quizId
                    };
                    if (existingQuestion) {
                        return [
                            2,
                            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, result), {
                                question: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, existingQuestion), {
                                    quiz_position_mapping: [
                                        {
                                            question_id: existingQuestion.id,
                                            answers: existingQuestion === null || existingQuestion === void 0 ? void 0 : existingQuestion.answers
                                        }
                                    ]
                                })
                            })
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        src_pages_api_question__WEBPACK_IMPORTED_MODULE_1__/* .QuestionAPI.getQuestionDetail */ .a.getQuestionDetail(questionId)
                    ];
                case 2:
                    response = _state.sent();
                    if (response.success) {
                        // Đảm bảo đối tượng trả về khớp với kiểu hành động đã được fulfill dự kiến
                        return [
                            2,
                            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, result), {
                                question: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, response.data), {
                                    time_spent: 0,
                                    myAnswers: [],
                                    quiz_position_mapping: [
                                        {
                                            question_id: questionId
                                        }
                                    ]
                                })
                            })
                        ];
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        rejectWithValue(error)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
/**
 * Async thunk để xác nhận một câu hỏi trong bài kiểm tra.
 * @type {AsyncThunk}
 */ var confirmQuestion = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("quiz/confirmQuestion", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param, param1) {
        var activityId, tabId, quizId, questionId, myAnswers, time_spent, rejectWithValue, result, question, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    activityId = param.activityId, tabId = param.tabId, quizId = param.quizId, questionId = param.questionId, myAnswers = param.myAnswers, time_spent = param.time_spent, rejectWithValue = param1.rejectWithValue;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    result = {
                        activityId: activityId,
                        tabId: tabId,
                        quizId: quizId,
                        myAnswers: myAnswers,
                        time_spent: time_spent
                    };
                    return [
                        4,
                        src_pages_api_question__WEBPACK_IMPORTED_MODULE_1__/* .QuestionAPI.getQuestionDetail */ .a.getQuestionDetail(questionId, {
                            after_test: true
                        })
                    ];
                case 2:
                    question = _state.sent();
                    if (question === null || question === void 0 ? void 0 : question.data) {
                        return [
                            2,
                            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, result), {
                                question: question.data
                            })
                        ];
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        rejectWithValue(error)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
/**
 * Async thunk để xác nhận một câu hỏi trong bài kiểm tra.
 * @type {AsyncThunk}
 */ //Hiện đang dùng để submit cho bài test trong activity
var submitQuiz = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("quiz/submitQuiz", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param, param1) {
        var id, data, class_user_id, rejectWithValue, ref, result, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    id = param.id, data = param.data, class_user_id = param.class_user_id, rejectWithValue = param1.rejectWithValue;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_pages_api_courses_index__WEBPACK_IMPORTED_MODULE_2__/* .submitQuizTest */ .qe)(id, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, data), {
                            answers: ((ref = (data.answers || []).map(function(e) {
                                var value = (e === null || e === void 0 ? void 0 : e[0]) || e;
                                return value;
                            })) === null || ref === void 0 ? void 0 : ref.filter(function(e) {
                                return e.answer || e.question_answer_id || e.short_answer || e.answer_file;
                            })) || undefined
                        }), class_user_id)
                    ];
                case 2:
                    result = _state.sent();
                    if (result === null || result === void 0 ? void 0 : result.success) {
                        return [
                            2,
                            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, result)
                        ];
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        rejectWithValue(error)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
/**
 * Selector để lấy ra danh sách câu hỏi từ Redux state.
 * @function
 * @param {ActivityQuizRootState} state - Trạng thái toàn bộ Redux store.
 * @param {string} activityId - ID của hoạt động.
 * @param {string} tabId - ID của tab.
 * @param {string} quizId - ID của bài kiểm tra.
 * @returns {IActivityStateQuestion[]} - Danh sách câu hỏi.
 */ var selectQuestions = function(state, activityId, tabId, quizId) {
    var ref, ref1, ref2;
    return state === null || state === void 0 ? void 0 : (ref = state[activityId]) === null || ref === void 0 ? void 0 : (ref1 = ref[tabId]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[quizId]) === null || ref2 === void 0 ? void 0 : ref2.questions;
};
/**
 * Redux slice để xử lý các câu hỏi trong Redux store.
 * @type {Slice}
 */ var quizSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "quiz",
    initialState: {},
    reducers: {
        removeQuizFinished: function(state, action) {
            var ref, ref1;
            var _payload = action.payload, activityId = _payload.activityId, tabId = _payload.tabId, quizId = _payload.quizId;
            if ((ref = state[activityId]) === null || ref === void 0 ? void 0 : (ref1 = ref[tabId]) === null || ref1 === void 0 ? void 0 : ref1[quizId]) {
                var ref2, ref3, ref4, ref5;
                (ref2 = state[activityId]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[tabId]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[quizId]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.questions) === null || ref5 === void 0 ? void 0 : ref5.forEach(function(element, i) {
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
                    if (element) {
                        element.time_spent = 0;
                    }
                    (ref3 = (ref = state[activityId]) === null || ref === void 0 ? void 0 : (ref1 = ref[tabId]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[quizId]) === null || ref2 === void 0 ? void 0 : ref2.questions[i]) === null || ref3 === void 0 ? void 0 : delete ref3.corrects;
                    (ref7 = (ref4 = state[activityId]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[tabId]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[quizId]) === null || ref6 === void 0 ? void 0 : ref6.questions[i]) === null || ref7 === void 0 ? void 0 : delete ref7.myAnswers;
                    (ref11 = (ref8 = state[activityId]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[tabId]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[quizId]) === null || ref10 === void 0 ? void 0 : ref10.questions[i]) === null || ref11 === void 0 ? void 0 : delete ref11.confirmed;
                    (ref15 = (ref12 = state[activityId]) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[tabId]) === null || ref13 === void 0 ? void 0 : (ref14 = ref13[quizId]) === null || ref14 === void 0 ? void 0 : ref14.questions[i]) === null || ref15 === void 0 ? void 0 : delete ref15.defaultValue;
                    (ref19 = (ref16 = state[activityId]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16[tabId]) === null || ref17 === void 0 ? void 0 : (ref18 = ref17[quizId]) === null || ref18 === void 0 ? void 0 : ref18.questions[i]) === null || ref19 === void 0 ? void 0 : delete ref19.solution;
                    var requirements = (ref23 = (ref20 = state[activityId]) === null || ref20 === void 0 ? void 0 : (ref21 = ref20[tabId]) === null || ref21 === void 0 ? void 0 : (ref22 = ref21[quizId]) === null || ref22 === void 0 ? void 0 : ref22.questions[i]) === null || ref23 === void 0 ? void 0 : ref23.requirements;
                    if (requirements.length) {
                        requirements.map(function(req) {
                            return req.answer_file = null;
                        });
                    } else {
                        var ref24, ref25, ref26, ref27;
                        (ref27 = (ref24 = state[activityId]) === null || ref24 === void 0 ? void 0 : (ref25 = ref24[tabId]) === null || ref25 === void 0 ? void 0 : (ref26 = ref25[quizId]) === null || ref26 === void 0 ? void 0 : ref26.questions[i]) === null || ref27 === void 0 ? void 0 : delete ref27.answer_file;
                    }
                });
            }
        },
        resetQuizActivity: function(state, _action) {
            state = undefined;
            return {};
        },
        saveFileEssay: function(state, action) {
            var ref, ref1, ref2;
            var _payload = action.payload, activityId = _payload.activityId, tabId = _payload.tabId, quizId = _payload.quizId, question_id = _payload.question_id, file = _payload.file, requirement_id = _payload.requirement_id, requirements = _payload.requirements;
            var existingQuestion = state === null || state === void 0 ? void 0 : (ref = state[activityId]) === null || ref === void 0 ? void 0 : (ref1 = ref[tabId]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[quizId]) === null || ref2 === void 0 ? void 0 : ref2.questions.find(function(q) {
                return q.id === question_id;
            });
            if (existingQuestion) {
                var fileData = {
                    file_key: file.file_key,
                    file_name: file.name
                };
                if (requirement_id) {
                    existingQuestion.requirements = requirements;
                } else {
                    existingQuestion.answer_file = fileData;
                }
            }
        },
        clearFileEssay: function(state, action) {
            var ref, ref1, ref2;
            var _payload = action.payload, activityId = _payload.activityId, tabId = _payload.tabId, quizId = _payload.quizId, question_id = _payload.question_id, file = _payload.file, requirements = _payload.requirements, requirement_id = _payload.requirement_id;
            var existingQuestion = state === null || state === void 0 ? void 0 : (ref = state[activityId]) === null || ref === void 0 ? void 0 : (ref1 = ref[tabId]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[quizId]) === null || ref2 === void 0 ? void 0 : ref2.questions.find(function(q) {
                return q.id === question_id;
            });
            if (requirement_id) {
                existingQuestion.requirements = requirements;
            } else {
                existingQuestion.answer_file = null;
            }
        },
        /**
     * action: Xử lý mapping đáp án cho từng dạng câu hỏi
     */ saveAnswer: function(state, action) {
            var ref, ref1, ref2;
            var payload = action.payload;
            var questions = (ref = state[payload.activityId]) === null || ref === void 0 ? void 0 : (ref1 = ref[payload.tabId]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[payload.quizId]) === null || ref2 === void 0 ? void 0 : ref2.questions;
            var questionToUpdate;
            if (questions) {
                questionToUpdate = questions && (questions === null || questions === void 0 ? void 0 : questions.find(function(question) {
                    var ref;
                    return question.id === ((ref = payload.question) === null || ref === void 0 ? void 0 : ref.id);
                }));
                if (questionToUpdate) {
                    var ref3, ref4;
                    questionToUpdate.isDrafAnswer = true;
                    questionToUpdate.defaultValue = payload.myAnswers;
                    questionToUpdate.time_spent = payload.time_spent;
                    questionToUpdate.quiz_position_mapping = (questionToUpdate === null || questionToUpdate === void 0 ? void 0 : questionToUpdate.quiz_position_mapping) && (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((questionToUpdate === null || questionToUpdate === void 0 ? void 0 : (ref3 = questionToUpdate.quiz_position_mapping) === null || ref3 === void 0 ? void 0 : ref3.filter(function(q) {
                        return q.question_id !== payload.question.id;
                    })) || []).concat([
                        {
                            question_id: payload.question.id,
                            answers: (ref4 = payload.question) === null || ref4 === void 0 ? void 0 : ref4.answers
                        }, 
                    ]);
                    switch(payload.question.qType){
                        case src_constants__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.ONE_CHOICE */ .YU.ONE_CHOICE:
                        case src_constants__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.TRUE_FALSE */ .YU.TRUE_FALSE:
                            var ref5;
                            questionToUpdate.myAnswers = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(((ref5 = questionToUpdate.myAnswers) === null || ref5 === void 0 ? void 0 : ref5.filter(function(q) {
                                return q.question_id !== payload.question.id;
                            })) || []).concat([
                                {
                                    question_id: payload.question.id,
                                    question_answer_id: payload.myAnswers,
                                    time_spent: payload.time_spent
                                }, 
                            ]);
                            break;
                        case src_constants__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.MULTIPLE_CHOICE */ .YU.MULTIPLE_CHOICE:
                            var ref6, ref7;
                            questionToUpdate.myAnswers = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(((ref6 = questionToUpdate.myAnswers) === null || ref6 === void 0 ? void 0 : ref6.filter(function(q) {
                                return q.question_id !== payload.question.id;
                            })) || []).concat([
                                {
                                    question_id: payload.question.id,
                                    answer: (ref7 = payload.myAnswers || []) === null || ref7 === void 0 ? void 0 : ref7.map(function(e) {
                                        return {
                                            answer_id: e
                                        };
                                    }),
                                    time_spent: payload.time_spent
                                }, 
                            ]);
                            break;
                        case src_constants__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.FILL_WORD */ .YU.FILL_WORD:
                            var ref8, ref9;
                            questionToUpdate.myAnswers = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(((ref8 = questionToUpdate.myAnswers) === null || ref8 === void 0 ? void 0 : ref8.filter(function(q) {
                                return q.question_id !== payload.question.id;
                            })) || []).concat([
                                {
                                    question_id: payload.question.id,
                                    answer: (ref9 = payload.myAnswers || []) === null || ref9 === void 0 ? void 0 : ref9.map(function(e, i) {
                                        return {
                                            answer_text: e,
                                            answer_position: i + 1
                                        };
                                    }),
                                    time_spent: payload.time_spent
                                }, 
                            ]);
                            break;
                        case src_constants__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.SELECT_WORD */ .YU.SELECT_WORD:
                            var ref10;
                            questionToUpdate.myAnswers = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(((ref10 = questionToUpdate.myAnswers) === null || ref10 === void 0 ? void 0 : ref10.filter(function(q) {
                                return q.question_id !== payload.question.id;
                            })) || []).concat([
                                {
                                    question_id: payload.question.id,
                                    answer: payload.myAnswers || [],
                                    time_spent: payload.time_spent
                                }, 
                            ]);
                            break;
                        case src_constants__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.MATCHING */ .YU.MATCHING:
                            var ref11, ref12;
                            questionToUpdate.myAnswers = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(((ref11 = questionToUpdate.myAnswers) === null || ref11 === void 0 ? void 0 : ref11.filter(function(q) {
                                return q.question_id !== payload.question.id;
                            })) || []).concat([
                                {
                                    question_id: payload.question.id,
                                    answer: Array.isArray(payload.myAnswers) && ((ref12 = payload.myAnswers || []) === null || ref12 === void 0 ? void 0 : ref12.map(function(e) {
                                        return {
                                            question_id: e.question_id,
                                            answer_id: e.answer_id
                                        };
                                    })),
                                    time_spent: payload.time_spent
                                }, 
                            ]);
                            break;
                        case src_constants__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.DRAG_DROP */ .YU.DRAG_DROP:
                            var ref13, ref14;
                            questionToUpdate.myAnswers = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(((ref13 = questionToUpdate.myAnswers) === null || ref13 === void 0 ? void 0 : ref13.filter(function(q) {
                                return q.question_id !== payload.question.id;
                            })) || []).concat([
                                {
                                    question_id: payload.question.id,
                                    answer: (ref14 = payload.myAnswers || []) === null || ref14 === void 0 ? void 0 : ref14.map(function(e, i) {
                                        return {
                                            answer_id: e.idAnswer,
                                            answer_position: i + 1
                                        };
                                    }),
                                    time_spent: payload.time_spent
                                }, 
                            ]);
                            break;
                        case src_constants__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.ESSAY */ .YU.ESSAY:
                            var ref15;
                            var answers = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(((ref15 = questionToUpdate.myAnswers) === null || ref15 === void 0 ? void 0 : ref15.filter(function(q) {
                                var ref;
                                return q.question_id !== (payload === null || payload === void 0 ? void 0 : (ref = payload.question) === null || ref === void 0 ? void 0 : ref.id);
                            })) || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((payload === null || payload === void 0 ? void 0 : payload.myAnswers) || {})).map(function(item) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, item), {
                                    time_spent: payload.time_spent
                                });
                            });
                            questionToUpdate.myAnswers = answers;
                            break;
                        default:
                            break;
                    }
                }
            }
        }
    },
    extraReducers: function(builder) {
        builder.addCase(fetchQuestionById.fulfilled, /**
         * Reducer cho trường hợp câu hỏi đã được fetch thành công.
         * @param {ActivityQuizRootState} state - Trạng thái Redux hiện tại.
         * @param {ReturnType<typeof fetchQuestionById.fulfilled>} action - Hành động được kích hoạt khi fetch thành công.
         */ function(state, action) {
            var _payload = action.payload, activityId = _payload.activityId, tabId = _payload.tabId, quizId = _payload.quizId, question = _payload.question;
            state[activityId] = state[activityId] || {};
            state[activityId][tabId] = state[activityId][tabId] || {};
            state[activityId][tabId][quizId] = state[activityId][tabId][quizId] || {
                questions: []
            };
            var existingQuestion = state[activityId][tabId][quizId].questions.find(function(q) {
                return q.id === question.id;
            });
            if (!existingQuestion) {
                state[activityId][tabId][quizId].questions.push(question);
            }
        }).addCase(confirmQuestion.fulfilled, /**
         * Reducer cho trường hợp câu hỏi đã được xác nhận thành công.
         * @param {ActivityQuizRootState} state - Trạng thái Redux hiện tại.
         * @param {ReturnType<typeof confirmQuestion.fulfilled>} action - Hành động được kích hoạt khi xác nhận thành công.
         */ function(state, action) {
            var ref, ref1, ref2;
            // Sử dụng action.payload để lấy kết quả của hàm thunk
            var payload = action.payload;
            var questions = (ref = state[payload.activityId]) === null || ref === void 0 ? void 0 : (ref1 = ref[payload.tabId]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[payload.quizId]) === null || ref2 === void 0 ? void 0 : ref2.questions;
            var questionToUpdate;
            if (questions) {
                questionToUpdate = questions.find(function(question) {
                    return question.id === payload.question.id;
                });
                if (questionToUpdate) {
                    var ref3, ref4, ref5;
                    questionToUpdate.confirmed = true;
                    questionToUpdate.solution = payload.question.solution;
                    questionToUpdate.defaultValue = payload.myAnswers;
                    questionToUpdate.requirements = questionToUpdate === null || questionToUpdate === void 0 ? void 0 : (ref3 = questionToUpdate.requirements) === null || ref3 === void 0 ? void 0 : ref3.map(function(req, index) {
                        var ref, ref1, ref2;
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, req), {
                            explanation: (ref = payload.question) === null || ref === void 0 ? void 0 : (ref1 = ref.requirements) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[index]) === null || ref2 === void 0 ? void 0 : ref2.explanation
                        });
                    });
                    questionToUpdate.quiz_position_mapping = (questionToUpdate === null || questionToUpdate === void 0 ? void 0 : questionToUpdate.quiz_position_mapping) && (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((questionToUpdate === null || questionToUpdate === void 0 ? void 0 : (ref4 = questionToUpdate.quiz_position_mapping) === null || ref4 === void 0 ? void 0 : ref4.filter(function(q) {
                        return q.question_id !== payload.question.id;
                    })) || []).concat([
                        {
                            question_id: payload.question.id,
                            answers: (ref5 = payload.question) === null || ref5 === void 0 ? void 0 : ref5.answers,
                            time_spent: payload.time_spent
                        }, 
                    ]);
                    switch(payload.question.qType){
                        case src_constants__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.ONE_CHOICE */ .YU.ONE_CHOICE:
                        case src_constants__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.TRUE_FALSE */ .YU.TRUE_FALSE:
                            var ref6;
                            questionToUpdate.myAnswers = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(((ref6 = questionToUpdate.myAnswers) === null || ref6 === void 0 ? void 0 : ref6.filter(function(q) {
                                return q.question_id !== payload.question.id;
                            })) || []).concat([
                                {
                                    question_id: payload.question.id,
                                    question_answer_id: payload.myAnswers,
                                    time_spent: payload.time_spent
                                }, 
                            ]);
                            questionToUpdate.corrects = Object.fromEntries((payload.question.answers || []).map(function(originalAnswer) {
                                return [
                                    originalAnswer.id,
                                    originalAnswer.is_correct, 
                                ];
                            }));
                            break;
                        case src_constants__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.MULTIPLE_CHOICE */ .YU.MULTIPLE_CHOICE:
                            var ref7, ref8;
                            questionToUpdate.myAnswers = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(((ref7 = questionToUpdate.myAnswers) === null || ref7 === void 0 ? void 0 : ref7.filter(function(q) {
                                return q.question_id !== payload.question.id;
                            })) || []).concat([
                                {
                                    question_id: payload.question.id,
                                    answer: (ref8 = payload.myAnswers || []) === null || ref8 === void 0 ? void 0 : ref8.map(function(e) {
                                        return {
                                            answer_id: e
                                        };
                                    }),
                                    time_spent: payload.time_spent
                                }, 
                            ]);
                            questionToUpdate.corrects = Object.fromEntries((payload.question.answers || []).map(function(originalAnswer) {
                                return [
                                    originalAnswer.id,
                                    originalAnswer.is_correct, 
                                ];
                            }));
                            break;
                        case src_constants__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.FILL_WORD */ .YU.FILL_WORD:
                            var ref9, ref10;
                            questionToUpdate.myAnswers = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(((ref9 = questionToUpdate.myAnswers) === null || ref9 === void 0 ? void 0 : ref9.filter(function(q) {
                                return q.question_id !== payload.question.id;
                            })) || []).concat([
                                {
                                    question_id: payload.question.id,
                                    answer: (ref10 = payload.myAnswers || []) === null || ref10 === void 0 ? void 0 : ref10.map(function(e, i) {
                                        return {
                                            answer_text: e,
                                            answer_position: i + 1
                                        };
                                    }),
                                    time_spent: payload.time_spent
                                }, 
                            ]);
                            questionToUpdate.corrects = payload.question.answers;
                            break;
                        case src_constants__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.SELECT_WORD */ .YU.SELECT_WORD:
                            var ref11;
                            questionToUpdate.myAnswers = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(((ref11 = questionToUpdate.myAnswers) === null || ref11 === void 0 ? void 0 : ref11.filter(function(q) {
                                return q.question_id !== payload.question.id;
                            })) || []).concat([
                                {
                                    question_id: payload.question.id,
                                    answer: payload.myAnswers,
                                    time_spent: payload.time_spent
                                }, 
                            ]);
                            questionToUpdate.corrects = payload.question.answers;
                            break;
                        case src_constants__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.MATCHING */ .YU.MATCHING:
                            var ref12, ref13;
                            questionToUpdate.myAnswers = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(((ref12 = questionToUpdate.myAnswers) === null || ref12 === void 0 ? void 0 : ref12.filter(function(q) {
                                return q.question_id !== payload.question.id;
                            })) || []).concat([
                                {
                                    question_id: payload.question.id,
                                    answer: Array.isArray(payload.myAnswers) && ((ref13 = payload.myAnswers || []) === null || ref13 === void 0 ? void 0 : ref13.map(function(e) {
                                        return {
                                            question_id: e.question_id,
                                            answer_id: e.answer_id
                                        };
                                    })),
                                    time_spent: payload.time_spent
                                }, 
                            ]);
                            questionToUpdate.corrects = payload.question.question_matchings;
                            break;
                        case src_constants__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.DRAG_DROP */ .YU.DRAG_DROP:
                            var ref14, ref15;
                            questionToUpdate.myAnswers = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(((ref14 = questionToUpdate.myAnswers) === null || ref14 === void 0 ? void 0 : ref14.filter(function(q) {
                                return q.question_id !== payload.question.id;
                            })) || []).concat([
                                {
                                    question_id: payload.question.id,
                                    answer: (ref15 = payload.myAnswers || []) === null || ref15 === void 0 ? void 0 : ref15.map(function(e, i) {
                                        return {
                                            answer_id: e.idAnswer,
                                            answer_position: i + 1
                                        };
                                    }),
                                    time_spent: payload.time_spent
                                }, 
                            ]);
                            var corrects = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(payload.question.answers || []);
                            questionToUpdate.corrects = corrects.sort(function(a, b) {
                                return a.answer_position - b.answer_position;
                            });
                            break;
                        case src_constants__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.ESSAY */ .YU.ESSAY:
                            var ref16;
                            questionToUpdate.myAnswers = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(((ref16 = questionToUpdate.myAnswers) === null || ref16 === void 0 ? void 0 : ref16.filter(function(q) {
                                return q.question_id !== payload.question.id;
                            })) || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((payload.myAnswers || {}).map(function(item) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, item), {
                                    time_spent: payload.time_spent
                                });
                            })));
                            break;
                        default:
                            break;
                    }
                }
            }
        });
        builder.addCase(submitQuiz.pending, function(state) {
        // state.loading = true
        });
        builder.addCase(submitQuiz.fulfilled, function(state, action) {
            // state.loading = false
            return state;
        });
        builder.addCase(submitQuiz.rejected, function(state) {
        // state.loading = false
        });
    }
});
/* harmony default export */ __webpack_exports__["ZP"] = (quizSlice.reducer);
/**
 * Selector để lấy trạng thái `courseActivityQuizReducer` từ Redux store.
 * @function
 * @param {RootState} state - Trạng thái toàn bộ Redux store.
 * @returns {ActivityQuizRootState} - Trạng thái của `courseActivityQuizReducer`.
 */ var courseActivityQuizReducer = function(state) {
    return state.courseActivityQuizReducer;
};
var _actions = quizSlice.actions, removeQuizFinished = _actions.removeQuizFinished, resetQuizActivity = _actions.resetQuizActivity, saveFileEssay = _actions.saveFileEssay, clearFileEssay = _actions.clearFileEssay, saveAnswer = _actions.saveAnswer;



/***/ }),

/***/ 81209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s1": function() { return /* binding */ clearFileEssay; },
  "ZP": function() { return /* binding */ CaseStudy; },
  "$y": function() { return /* binding */ getTopicsCaseStudy; },
  "JI": function() { return /* binding */ loadMoreQuestion; },
  "wr": function() { return /* binding */ saveFileEssay; }
});

// UNUSED EXPORTS: caseStudyTestAction, caseStudyTestReducer, caseStudyTestSlice

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(51224);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67796);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(21967);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(37559);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(72760);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(52621);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 2 modules
var redux_toolkit_esm = __webpack_require__(2249);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(73782);
// EXTERNAL MODULE: ./src/services/requestV2.ts
var requestV2 = __webpack_require__(91002);
;// CONCATENATED MODULE: ./src/pages/api/case-study/index.ts


var CaseStudyAPI = /*#__PURE__*/ function() {
    "use strict";
    function CaseStudyAPI() {
        (0,_class_call_check/* default */.Z)(this, CaseStudyAPI);
    }
    CaseStudyAPI.getTopicQuiz = function getTopicQuiz(id, quiz_id) {
        return (0,requestV2/* fetcher */._i)("question-topic/".concat(id, "?quiz_id=").concat(quiz_id));
    };
    return CaseStudyAPI;
}();

;// CONCATENATED MODULE: ./src/redux/slice/Course/MyCourse/Case-study/CaseStudy.ts








var initialState = {
    loading: false,
    loadingTest: false,
    topics: [],
    listFullQuestions: [],
    listQuestions: [],
    topicsShow: []
};
var getTopicsCaseStudy = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("caseStudyTestReducer/getTopicsCaseStudy", function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param, thunkAPI) {
        var id, quiz_id, res, arr2, j, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    id = param.id, quiz_id = param.quiz_id;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        CaseStudyAPI.getTopicQuiz(id, quiz_id)
                    ];
                case 2:
                    res = _state.sent();
                    arr2 = [];
                    for(j = 0; j < res.data.questions.length; j++){
                        arr2.push((0,_define_property/* default */.Z)({}, res.data.id, res.data.questions[j]));
                    }
                    return [
                        2,
                        {
                            data: (0,_object_spread/* default */.Z)({}, res.data),
                            listFullQuestions: arr2,
                            listQuestions: arr2.slice(0, 25)
                        }
                    ];
                case 3:
                    err = _state.sent();
                    return [
                        2,
                        thunkAPI.rejectWithValue(err)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var caseStudyTestSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "caseStudyTestReducer",
    initialState: initialState,
    reducers: {
        loadMoreQuestion: function(state, action) {
            if (state.listQuestions.length < state.listFullQuestions.length) {
                var arr = (0,_to_consumable_array/* default */.Z)(state.listQuestions);
                for(var j = state.listQuestions.length; j < state.listFullQuestions.length; j++){
                    if (j <= 5 + state.listQuestions.length) {
                        arr.push(state.listFullQuestions[j]);
                    }
                }
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    listQuestions: (0,_to_consumable_array/* default */.Z)(arr)
                });
            }
        },
        saveFileEssay: function(state, action) {
            var _payload = action.payload, question_id = _payload.question_id, file = _payload.file, topic_id = _payload.topic_id, requirement_id = _payload.requirement_id;
            var arr = (0,_to_consumable_array/* default */.Z)(state.listQuestions);
            var newData = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    if (question_id === item[topic_id].id) {
                        if (requirement_id) {
                            var newItem = (0,_define_property/* default */.Z)({}, topic_id, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item[topic_id]), {
                                requirements: (item[topic_id].requirements || []).map(function(req, idx) {
                                    if (req.id === requirement_id) {
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, req), {
                                            answer_file: {
                                                file_key: file === null || file === void 0 ? void 0 : file.file_key,
                                                file_name: file === null || file === void 0 ? void 0 : file.name
                                            }
                                        });
                                    }
                                    return req;
                                })
                            }));
                            newData.push(newItem);
                        } else {
                            var newItem = (0,_define_property/* default */.Z)({}, topic_id, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item[topic_id]), {
                                answer_file: {
                                    file_key: file === null || file === void 0 ? void 0 : file.file_key,
                                    file_name: file === null || file === void 0 ? void 0 : file.name
                                }
                            }));
                            newData.push(newItem);
                        }
                    } else {
                        newData.push(item);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                listQuestions: (0,_to_consumable_array/* default */.Z)(newData)
            });
        },
        clearFileEssay: function(state, action) {
            var _payload = action.payload, question_id = _payload.question_id, topic_id = _payload.topic_id, requirement_id = _payload.requirement_id;
            var arr = (0,_to_consumable_array/* default */.Z)(state.listQuestions);
            var newData = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    var ref;
                    if (question_id === ((ref = item[topic_id]) === null || ref === void 0 ? void 0 : ref.id)) {
                        if (requirement_id) {
                            var newItem = (0,_define_property/* default */.Z)({}, topic_id, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item[topic_id]), {
                                requirements: (item[topic_id].requirements || []).map(function(req, idx) {
                                    if (req.id === requirement_id) {
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, req), {
                                            answer_file: undefined
                                        });
                                    }
                                    return req;
                                })
                            }));
                            newData.push(newItem);
                        } else {
                            var newItem = (0,_define_property/* default */.Z)({}, topic_id, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item[topic_id]), {
                                answer_file: undefined
                            }));
                            newData.push(newItem);
                        }
                    } else {
                        newData.push(item);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                listQuestions: (0,_to_consumable_array/* default */.Z)(newData)
            });
        }
    },
    extraReducers: function(builder) {
        builder.addCase(getTopicsCaseStudy.pending, function(state) {
            state.loading = true;
        });
        builder.addCase(getTopicsCaseStudy.fulfilled, function(state, action) {
            var ref, ref1, ref2;
            state.loading = false;
            state.topics = (ref = action.payload) === null || ref === void 0 ? void 0 : ref.data;
            state.listFullQuestions = (ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.listFullQuestions;
            state.listQuestions = (ref2 = action.payload) === null || ref2 === void 0 ? void 0 : ref2.listQuestions;
        });
        builder.addCase(getTopicsCaseStudy.rejected, function(state) {
            state.loading = false;
        });
    }
});
var caseStudyTestReducer = function(state) {
    return state.caseStudyTestReducer;
};
var caseStudyTestAction = caseStudyTestSlice.actions;
var _actions = caseStudyTestSlice.actions;
var loadMoreQuestion = _actions.loadMoreQuestion, saveFileEssay = _actions.saveFileEssay, clearFileEssay = _actions.clearFileEssay;
/* harmony default export */ var CaseStudy = (caseStudyTestSlice.reducer);


/***/ }),

/***/ 92231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZT": function() { return /* binding */ resetNotesList; },
/* harmony export */   "dR": function() { return /* binding */ clearNote; },
/* harmony export */   "pD": function() { return /* binding */ activeNotesList; },
/* harmony export */   "qg": function() { return /* binding */ closeNote; },
/* harmony export */   "xT": function() { return /* binding */ pushNotes; }
/* harmony export */ });
/* unused harmony exports notesListSlice, notesListReducer */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2249);

var initialState = {
    status: false,
    note_data: []
};
var notesListSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "notesListReducer",
    initialState: initialState,
    reducers: {
        activeNotesList: function(state) {
            // Active khi action 'active' được gọi
            state.status = true;
        },
        resetNotesList: function(state) {
            // Đặt giá trị khi action 'reset' được gọi
            state.status = false;
        },
        pushNotes: function(state, action) {
            // Thêm dữ liệu mới vào mảng note_data khi gọi action pushNotes
            state.note_data.push(action.payload) // Assumed action.payload is the new data to be added
            ;
        },
        closeNote: function(state, action) {
            var indexToDelete = action.payload;
            // Filter out the note with the matching index or ID
            var updatedNoteData = state.note_data.filter(function(item) {
                return item.uuid !== indexToDelete;
            });
            // Update the state with the modified note_data array
            state.note_data = updatedNoteData;
        },
        clearNote: function() {
            // Đặt giá trị khi action 'clearNote' được gọi
            return initialState;
        }
    }
});
var _actions = notesListSlice.actions;
var activeNotesList = _actions.activeNotesList, resetNotesList = _actions.resetNotesList, pushNotes = _actions.pushNotes, closeNote = _actions.closeNote, clearNote = _actions.clearNote;
var notesListReducer = function(state) {
    return state.notesListReducer;
};
/* harmony default export */ __webpack_exports__["ZP"] = (notesListSlice.reducer);


/***/ }),

/***/ 34674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AK": function() { return /* binding */ closeCalculator; },
/* harmony export */   "Gp": function() { return /* binding */ openCalculator; },
/* harmony export */   "Tm": function() { return /* binding */ shortCourseActivityReducer; },
/* harmony export */   "_X": function() { return /* binding */ courseActivityAction; }
/* harmony export */ });
/* unused harmony exports getCourseActivityTapById, courseActivitySlice */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52621);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2249);
/* harmony import */ var _pages_api_courses_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38916);





var initialState = {
    loading: false,
    currentTabId: "",
    calculator_status: false,
    id: "",
    created_at: "",
    updated_at: "",
    deleted_at: null,
    course_id: "",
    name: "",
    code: "",
    description: "",
    status: "",
    is_public: false,
    duration: 0,
    is_peer_review: false,
    is_graded: false,
    course_section_type: "ACTIVITY",
    course_section_notes: [],
    activity_type: "",
    position: "",
    parent_id: "",
    display_icon: "TEXT",
    total_activity: 0,
    course_outcomes: [],
    files: [],
    breadcumb: [],
    user_course_section_progress: [],
    activity_count: 0,
    learning_progress: {
        duration: 0,
        time_spent: 0,
        total_course_sections: 0,
        total_course_sections_completed: 0
    },
    type: "text",
    quiz: {
        id: "",
        attempt: [],
        quiz_timed: 0,
        required_percent_score: 0,
        is_limited: false,
        limit_count: 0,
        grading_method: "",
        is_graded: false
    },
    course_tab_documents: [],
    next_activity: {
        id: "",
        display_icon: "",
        name: ""
    },
    previous_activity: {
        id: "",
        display_icon: "",
        name: ""
    }
};
var getCourseActivityTapById = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAsyncThunk */ .hg)("shortCourseActivityReducer/getTapById", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param, thunkAPI) {
        var courseId, id, res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    courseId = param.courseId, id = param.id;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        _pages_api_courses_index__WEBPACK_IMPORTED_MODULE_0__/* .CoursesAPI.getCourseActivityTapById */ .tB.getCourseActivityTapById(courseId, id)
                    ];
                case 2:
                    res = _state.sent();
                    if (!(res === null || res === void 0 ? void 0 : res.data)) {
                        return [
                            2
                        ];
                    }
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, res.data)
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        thunkAPI.rejectWithValue(error)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var courseActivitySlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
    name: "shortCourseActivityReducer",
    initialState: initialState,
    reducers: {
        setActivityState: function(state, action) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state, action.payload);
        },
        resetActivity: function() {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, initialState);
        },
        openCalculator: function(state) {
            state.calculator_status = true;
        },
        closeCalculator: function(state) {
            state.calculator_status = false;
        }
    },
    extraReducers: function(builder) {
        builder.addCase(getCourseActivityTapById.pending, function(state) {
            state.loading = true;
        });
        builder.addCase(getCourseActivityTapById.fulfilled, function(state, action) {
            var ref;
            state.loading = false;
            state.currentTabId = (ref = action.payload) === null || ref === void 0 ? void 0 : ref.id;
        });
        builder.addCase(getCourseActivityTapById.rejected, function(state) {
            state.loading = false;
        });
    }
});
// export const selectAuthUser = (state: RootState) => state.loginReducer.authUser;
var shortCourseActivityReducer = function(state) {
    return state.shortCourseActivityReducer;
};
var courseActivityAction = courseActivitySlice.actions;
var _actions = courseActivitySlice.actions;
var openCalculator = _actions.openCalculator, closeCalculator = _actions.closeCalculator;
/* harmony default export */ __webpack_exports__["ZP"] = (courseActivitySlice.reducer);


/***/ }),

/***/ 79639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZT": function() { return /* binding */ resetNotesList; },
/* harmony export */   "pD": function() { return /* binding */ activeNotesList; },
/* harmony export */   "qg": function() { return /* binding */ closeNote; },
/* harmony export */   "xT": function() { return /* binding */ pushNotes; }
/* harmony export */ });
/* unused harmony exports shortNotesListSlice, clearNote, shortNotesListReducer */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2249);

var initialState = {
    status: false,
    note_data: []
};
var shortNotesListSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "shortNotesListReducer",
    initialState: initialState,
    reducers: {
        activeNotesList: function(state) {
            // Active khi action 'active' được gọi
            state.status = true;
        },
        resetNotesList: function(state) {
            // Đặt giá trị khi action 'reset' được gọi
            state.status = false;
        },
        pushNotes: function(state, action) {
            // Thêm dữ liệu mới vào mảng note_data khi gọi action pushNotes
            state.note_data.push(action.payload) // Assumed action.payload is the new data to be added
            ;
        },
        closeNote: function(state, action) {
            var indexToDelete = action.payload;
            // Filter out the note with the matching index or ID
            var updatedNoteData = state.note_data.filter(function(item) {
                return item.uuid !== indexToDelete;
            });
            // Update the state with the modified note_data array
            state.note_data = updatedNoteData;
        },
        clearNote: function() {
            // Đặt giá trị khi action 'clearNote' được gọi
            return initialState;
        }
    }
});
var _actions = shortNotesListSlice.actions;
var activeNotesList = _actions.activeNotesList, resetNotesList = _actions.resetNotesList, pushNotes = _actions.pushNotes, closeNote = _actions.closeNote, clearNote = _actions.clearNote;
var shortNotesListReducer = function(state) {
    return state.shortNotesListReducer;
};
/* harmony default export */ __webpack_exports__["ZP"] = (shortNotesListSlice.reducer);


/***/ }),

/***/ 87642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mj": function() { return /* binding */ decrement; },
/* harmony export */   "bB": function() { return /* binding */ active; },
/* harmony export */   "mc": function() { return /* binding */ reset; },
/* harmony export */   "nP": function() { return /* binding */ increment; }
/* harmony export */ });
/* unused harmony exports userGuideSlice, clearGuideState, userGuideReducer */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2249);

var initialState = {
    status: false,
    step: 0,
    isActive: false
};
var userGuideSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "userGuideReducer",
    initialState: initialState,
    reducers: {
        active: function(state) {
            // Active user guide khi action 'active' được gọi
            state.status = true;
        },
        increment: function(state) {
            // Tăng giá trị lên 1 khi action 'increment' được gọi
            state.step += 1;
        },
        decrement: function(state) {
            // Tăng giá trị lên 1 khi action 'increment' được gọi
            if (state.step > 1) {
                state.step -= 1;
            }
        },
        reset: function(state) {
            state.isActive = true;
            state.status = false;
        },
        clearGuideState: function() {
            // Đặt giá trị khi action 'reset' được gọi
            return initialState;
        }
    }
});
var _actions = userGuideSlice.actions;
var increment = _actions.increment, decrement = _actions.decrement, active = _actions.active, reset = _actions.reset, clearGuideState = _actions.clearGuideState;
var userGuideReducer = function(state) {
    return state.userGuideReducer;
};
/* harmony default export */ __webpack_exports__["ZP"] = (userGuideSlice.reducer);


/***/ }),

/***/ 95290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iy": function() { return /* binding */ closeShowRemind; },
/* harmony export */   "P2": function() { return /* binding */ getEntranceCount; },
/* harmony export */   "nx": function() { return /* binding */ entranceTestReducer; }
/* harmony export */ });
/* unused harmony exports entranceTestSlice, active */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41492);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52621);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2249);
/* harmony import */ var src_pages_api_entrance_test__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81482);





var initialState = {
    status: false,
    count: 0,
    shouldShowRemind: undefined
};
var getEntranceCount = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAsyncThunk */ .hg)("entranceTestReducer/getEntranceCount", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param, thunkAPI) {
        var param, res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        src_pages_api_entrance_test__WEBPACK_IMPORTED_MODULE_0__/* .EntranceTestAPI.getEntranceCount */ .e.getEntranceCount()
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        thunkAPI.rejectWithValue(error)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var entranceTestSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
    name: "entranceTestReducer",
    initialState: initialState,
    reducers: {
        active: function(state) {
            // Active user guide khi action 'active' được gọi
            state.status = true;
        },
        closeShowRemind: function(state) {
            state.shouldShowRemind = false;
        }
    },
    extraReducers: function(builder) {
        builder.addCase(getEntranceCount.pending, function(state) {
        // state.loading = true
        });
        builder.addCase(getEntranceCount.fulfilled, function(state, action) {
            state.count = action.payload.data.count;
            if (action.payload.data.count >= 1) {
                state.shouldShowRemind = true;
            }
        });
        builder.addCase(getEntranceCount.rejected, function(state, action) {});
    }
});
var _actions = entranceTestSlice.actions;
var active = _actions.active, closeShowRemind = _actions.closeShowRemind;
var entranceTestReducer = function(state) {
    return state.entranceTestReducer;
};
/* harmony default export */ __webpack_exports__["ZP"] = (entranceTestSlice.reducer);


/***/ }),

/***/ 31518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a1": function() { return /* binding */ disableUnsavedChange; },
/* harmony export */   "pW": function() { return /* binding */ getLogoutUser; },
/* harmony export */   "zb": function() { return /* binding */ loginSlice; }
/* harmony export */ });
/* unused harmony exports changePassword, loginReducer */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41492);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52621);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2249);
/* harmony import */ var _utils_helpers_keycloak__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3787);
/* harmony import */ var src_pages_api_profile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36174);







var initialState = {
    accessToken: "",
    loading: false,
    changePass: false,
    errors: {},
    user: {
        email: "",
        username: ""
    },
    unsavedChange: false
};
var getLogoutUser = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createAsyncThunk */ .hg)("loginReducer/handleLogout", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param, thunkAPI) {
        var param, authenticationManager, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    authenticationManager = new _utils_helpers_keycloak__WEBPACK_IMPORTED_MODULE_0__/* .AuthenticationManager */ .E();
                    return [
                        4,
                        authenticationManager.logout()
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        {}
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        thunkAPI.rejectWithValue(error)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var changePassword = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createAsyncThunk */ .hg)("loginReducer/changePassword", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(body, thunkAPI) {
        var res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        src_pages_api_profile__WEBPACK_IMPORTED_MODULE_1__/* .AuthAPI.changePassword */ .u.changePassword(body)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, res)
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        thunkAPI.rejectWithValue(error)
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function(body, thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var disableUnsavedChange = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createAsyncThunk */ .hg)("loginReducer/disableUnsavedChange", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param, thunkAPI) {
        var param;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
            return [
                2,
                false
            ];
        });
    });
    return function(_, thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var loginSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSlice */ .oM)({
    name: "loginReducer",
    initialState: initialState,
    reducers: {
        resetLoginState: function(state) {
            state.errors = {};
            state.loading = false;
        },
        resetAuthUserState: function(state, action) {},
        enableUnsavedChange: function(state) {
            state.unsavedChange = true;
        }
    },
    extraReducers: function(builder) {
        builder.addCase(disableUnsavedChange.fulfilled, function(state, action) {
            state.unsavedChange = false;
        });
        builder.addCase(getLogoutUser.pending, function(state) {
            state.loading = true;
        });
        builder.addCase(getLogoutUser.fulfilled, function(state, action) {
            state.accessToken = "";
            state.loading = false;
            state.changePass = false;
            state.errors = {};
            state.user = {
                email: "",
                username: ""
            };
        });
        builder.addCase(getLogoutUser.rejected, function(state, action) {
            state.accessToken = "";
            state.loading = false;
            state.changePass = false;
            state.errors = {};
            state.user = {
                email: "",
                username: ""
            };
        });
        builder.addCase(changePassword.pending, function(state) {
            state.loading = true;
        });
        builder.addCase(changePassword.fulfilled, function(state, action) {
            state.loading = false;
            if (action.payload.code === 200) {
                state.changePass = true;
            }
        });
        builder.addCase(changePassword.rejected, function(state, action) {
            state.loading = false;
        });
    }
});
// export const selectAuthUser = (state: RootState) => state.loginReducer.authUser;
var loginReducer = function(state) {
    return state.loginReducer;
};
/* harmony default export */ __webpack_exports__["ZP"] = (loginSlice.reducer);


/***/ }),

/***/ 9747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$f": function() { return /* binding */ notificationSlice; },
/* harmony export */   "Nf": function() { return /* binding */ updateStatus; },
/* harmony export */   "Zw": function() { return /* binding */ updateStatusAll; },
/* harmony export */   "c0": function() { return /* binding */ showNotification; },
/* harmony export */   "hj": function() { return /* binding */ loadMoreNotification; },
/* harmony export */   "uy": function() { return /* binding */ getNotificationDetail; },
/* harmony export */   "v6": function() { return /* binding */ getNotification; },
/* harmony export */   "xU": function() { return /* binding */ getCountUnRead; },
/* harmony export */   "yu": function() { return /* binding */ markAllNotifications; }
/* harmony export */ });
/* unused harmony exports hideNotification, notificationReducer */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41492);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72760);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52621);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2249);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43743);
/* harmony import */ var src_pages_api_notification__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18015);









var initialState = {
    loading: false,
    meta: {
        total_records: 0,
        total_pages: 1,
        page_index: 1,
        page_size: 10
    },
    list_notifications: [],
    id: "",
    created_at: "",
    updated_at: "",
    deleted_at: null,
    title: "",
    type: "",
    mode: "",
    status: "",
    action: "",
    content: "",
    send_time: "",
    created_by: "",
    created_from: "",
    files: [],
    total_records: 0,
    notification_status: false,
    avatar: {}
};
var getCountUnRead = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createAsyncThunk */ .hg)("notificationReducer/getCountUnRead", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var param, res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        src_pages_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .NotificationAPI.getCountUnRead */ .T.getCountUnRead()
                    ];
                case 2:
                    res = _state.sent();
                    if (!(res === null || res === void 0 ? void 0 : res.data)) {
                        return [
                            2
                        ];
                    }
                    if (res.data.total_records !== undefined && res.data.total_records !== null) {
                        localStorage.setItem(src_constants__WEBPACK_IMPORTED_MODULE_0__/* .LOCAL_STORAGE_KEYS.NOTIFICATION_COUNT */ .dA.NOTIFICATION_COUNT, res.data.total_records.toString());
                        window.dispatchEvent(new Event("storage"));
                    }
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, res.data)
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_) {
        return _ref.apply(this, arguments);
    };
}());
var getNotification = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createAsyncThunk */ .hg)("notificationReducer/getNotification", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(params, thunkAPI) {
        var res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        src_pages_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .NotificationAPI.getNotification */ .T.getNotification(params)
                    ];
                case 1:
                    res = _state.sent();
                    if (!(res === null || res === void 0 ? void 0 : res.data)) {
                        return [
                            2
                        ];
                    }
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, res.data)
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        thunkAPI.rejectWithValue(error)
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function(params, thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var loadMoreNotification = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createAsyncThunk */ .hg)("notificationReducer/loadMoreNotification", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(params, thunkAPI) {
        var res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        src_pages_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .NotificationAPI.getNotification */ .T.getNotification(params)
                    ];
                case 1:
                    res = _state.sent();
                    if (!(res === null || res === void 0 ? void 0 : res.data)) {
                        return [
                            2
                        ];
                    }
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, res.data)
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        thunkAPI.rejectWithValue(error)
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function(params, thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var getNotificationDetail = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createAsyncThunk */ .hg)("courseActivityReducer/getNotificationDetail", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(id, thunkAPI) {
        var res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        src_pages_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .NotificationAPI.getDetail */ .T.getDetail(id)
                    ];
                case 1:
                    res = _state.sent();
                    if (!(res === null || res === void 0 ? void 0 : res.data)) {
                        return [
                            2
                        ];
                    }
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, res.data)
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        thunkAPI.rejectWithValue(error)
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function(id, thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var markAllNotifications = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createAsyncThunk */ .hg)("notificationReducer/markAll", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(thunkAPI) {
        var res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        src_pages_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .NotificationAPI.markAll */ .T.markAll()
                    ];
                case 1:
                    res = _state.sent();
                    if (!(res === null || res === void 0 ? void 0 : res.data)) {
                        return [
                            2
                        ];
                    }
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, res.data)
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function(thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var notificationSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSlice */ .oM)({
    name: "notificationReducer",
    initialState: initialState,
    reducers: {
        setState: function(state, action) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state, action.payload);
        },
        updateStatus: function(state, action) {
            var new_list_notifications = [];
            new_list_notifications = state.list_notifications.map(function(e) {
                if (e.id == action.payload.id) {
                    var obj = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, e.notification_user_instances), {
                        is_read: true
                    });
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, e), {
                        notification_user_instances: obj
                    });
                }
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, e);
            });
            state.list_notifications = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(new_list_notifications);
        },
        updateStatusAll: function(state) {
            var new_list_notifications = [];
            new_list_notifications = state.list_notifications.map(function(e) {
                var obj = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, e.notification_user_instances), {
                    is_read: true
                });
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, e), {
                    notification_user_instances: obj
                });
            });
            state.list_notifications = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(new_list_notifications);
        },
        showNotification: function(state) {
            state.notification_status = true;
        },
        hideNotification: function(state) {
            state.notification_status = false;
        },
        updateTotalUnread: function(state, action) {
            state.total_records = action.payload;
        }
    },
    extraReducers: function(builder) {
        builder.addCase(getCountUnRead.pending, function(state) {
            state.loading = true;
        });
        builder.addCase(getCountUnRead.fulfilled, function(state, action) {
            state.loading = false;
            if (typeof action.payload === "object" && action.payload !== null) {
                var ref;
                state.total_records = (ref = action.payload) === null || ref === void 0 ? void 0 : ref.total_records;
            }
        });
        builder.addCase(getCountUnRead.rejected, function(state) {
            state.loading = false;
        });
        builder.addCase(getNotification.pending, function(state) {
            state.loading = true;
        });
        builder.addCase(getNotification.fulfilled, function(state, action) {
            var ref, ref1;
            state.loading = false;
            state.meta = (ref = action.payload) === null || ref === void 0 ? void 0 : ref.meta;
            state.list_notifications = (ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.notifications;
        });
        builder.addCase(loadMoreNotification.pending, function(state) {
            state.loading = true;
        });
        builder.addCase(loadMoreNotification.fulfilled, function(state, action) {
            var ref, ref1;
            state.loading = false;
            state.meta = (ref = action.payload) === null || ref === void 0 ? void 0 : ref.meta;
            state.list_notifications = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(state.list_notifications).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(((ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.notifications) || []));
        });
        builder.addCase(loadMoreNotification.rejected, function(state) {
            state.loading = false;
        });
        builder.addCase(getNotificationDetail.pending, function(state) {
            state.loading = true;
        });
        builder.addCase(getNotificationDetail.fulfilled, function(state, action) {
            state.loading = false;
            if (action.payload) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
                state.id = (ref = action.payload) === null || ref === void 0 ? void 0 : ref.id;
                state.created_at = (ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.created_at;
                state.updated_at = (ref2 = action.payload) === null || ref2 === void 0 ? void 0 : ref2.updated_at;
                state.deleted_at = (ref3 = action.payload) === null || ref3 === void 0 ? void 0 : ref3.deleted_at;
                state.title = (ref4 = action.payload) === null || ref4 === void 0 ? void 0 : ref4.title;
                state.type = (ref5 = action.payload) === null || ref5 === void 0 ? void 0 : ref5.type;
                state.mode = (ref6 = action.payload) === null || ref6 === void 0 ? void 0 : ref6.mode;
                state.status = (ref7 = action.payload) === null || ref7 === void 0 ? void 0 : ref7.status;
                state.action = (ref8 = action.payload) === null || ref8 === void 0 ? void 0 : ref8.action;
                state.content = (ref9 = action.payload) === null || ref9 === void 0 ? void 0 : ref9.content;
                state.send_time = (ref10 = action.payload) === null || ref10 === void 0 ? void 0 : ref10.send_time;
                state.created_by = (ref11 = action.payload) === null || ref11 === void 0 ? void 0 : ref11.created_by;
                state.created_from = (ref12 = action.payload) === null || ref12 === void 0 ? void 0 : ref12.created_from;
                state.files = (ref13 = action.payload) === null || ref13 === void 0 ? void 0 : ref13.files;
            }
        });
        builder.addCase(getNotificationDetail.rejected, function(state) {
            state.loading = false;
        });
        builder.addCase(markAllNotifications.pending, function(state) {
            state.loading = true;
        });
        builder.addCase(markAllNotifications.fulfilled, function(state, action) {
            state.loading = false;
        });
        builder.addCase(markAllNotifications.rejected, function(state) {
            state.loading = false;
        });
    // builder.addCase(getDeviceToken.pending, (state) => {
    //   state.loading = true
    // })
    // builder.addCase(getDeviceToken.fulfilled, (state, action) => {
    //   state.loading = false
    // })
    // builder.addCase(getDeviceToken.rejected, (state) => {
    //   state.loading = false
    // })
    }
});
var _actions = notificationSlice.actions;
var updateStatus = _actions.updateStatus, updateStatusAll = _actions.updateStatusAll, showNotification = _actions.showNotification, hideNotification = _actions.hideNotification;
var notificationReducer = function(state) {
    return state.notificationReducer;
};
/* harmony default export */ __webpack_exports__["ZP"] = (notificationSlice.reducer);


/***/ }),

/***/ 72215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KK": function() { return /* binding */ showPopupCompletedCourse; },
/* harmony export */   "hj": function() { return /* binding */ hidePopup; }
/* harmony export */ });
/* unused harmony exports popupSlice, notificationReducer */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2249);

var initialState = {
    is_open: false,
    content: ""
};
var popupSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "popupReducer",
    initialState: initialState,
    reducers: {
        showPopupCompletedCourse: function(state, action) {
            state.is_open = true;
            state.content = action.payload;
        },
        hidePopup: function(state) {
            state.is_open = false;
        }
    }
});
var _actions = popupSlice.actions;
var showPopupCompletedCourse = _actions.showPopupCompletedCourse, hidePopup = _actions.hidePopup;
var notificationReducer = function(state) {
    return state.notificationReducer;
};
/* harmony default export */ __webpack_exports__["ZP"] = (popupSlice.reducer);


/***/ }),

/***/ 85195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BA": function() { return /* binding */ updateUserAvatar; },
/* harmony export */   "Iq": function() { return /* binding */ makeContactDefault; },
/* harmony export */   "M3": function() { return /* binding */ userReducer; },
/* harmony export */   "Nq": function() { return /* binding */ updateUser; },
/* harmony export */   "Pe": function() { return /* binding */ loadMoreLoginHistory; },
/* harmony export */   "gR": function() { return /* binding */ getUserInformation; },
/* harmony export */   "jo": function() { return /* binding */ getMe; },
/* harmony export */   "oY": function() { return /* binding */ getLoginHistory; }
/* harmony export */ });
/* unused harmony export userSlice */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41492);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52621);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2249);
/* harmony import */ var _utils_constants_User__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10848);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72808);
/* harmony import */ var src_redux_services_User_user__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39421);
/* harmony import */ var _pages_api_profile_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36174);









var initialState = {
    loading: false,
    loadingEditName: false,
    loadingEditAvatar: false,
    errors: {},
    user: {
        id: "",
        created_at: "",
        updated_at: "",
        deleted_at: "",
        key: "",
        invite_id: "",
        code: "",
        username: "",
        nick_name: "",
        type: _utils_constants_User__WEBPACK_IMPORTED_MODULE_0__/* .USER_TYPE.STUDENT.key */ .$A.STUDENT.key,
        status: _utils_constants_User__WEBPACK_IMPORTED_MODULE_0__/* .USER_STATUS.ACTIVE.key */ .iy.ACTIVE.key,
        ekyc_status: "",
        approved_date: "",
        reject_reason: "",
        confirmation_status: "",
        detail_id: "",
        detail: {
            id: "",
            created_at: "",
            updated_at: "",
            deleted_at: "",
            country_code: "",
            email: "",
            phone: "",
            firstName: "",
            lastName: "",
            full_name: "",
            address: "",
            major: {},
            level: "",
            university: {},
            provinceCode: "",
            districtCode: "",
            wardCode: "",
            dob: "",
            avatar: {},
            sex: "",
            permanent_address: "",
            identity_card: "",
            date_of_issue: "",
            place_of_issue: "",
            identity_card_image_front: {},
            identity_card_image_back: {},
            tax_code: "",
            note: "",
            is_verify: false,
            is_default: false,
            learning_purpose: "",
            contact_detail: "",
            special_note: "",
            classification: "",
            company_type: "",
            company_position: "",
            company_rank: "",
            settings: null
        },
        user_hubspot_program_infos: [],
        course_tab_groups: {},
        user_contacts: [],
        certificates: 0,
        courses: 0,
        keycloak_user_id: ""
    },
    loginHistory: {
        meta: {},
        userActivities: []
    },
    loadHistory: false
};
var getMe = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("userReducer/getMe", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param, thunkAPI) {
        var param, res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        src_redux_services_User_user__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getMe */ .Z.getMe()
                    ];
                case 2:
                    res = _state.sent();
                    if (!res) {
                        // toast.error(res.error.message)
                        return [
                            2
                        ];
                    }
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, res)
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        thunkAPI.rejectWithValue(error)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var getUserInformation = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("userReducer/getUserInformation", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param, thunkAPI) {
        var param, res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        src_redux_services_User_user__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getUserInformation */ .Z.getUserInformation()
                    ];
                case 2:
                    res = _state.sent();
                    if (!res) {
                        // toast.error(res.error.message)
                        return [
                            2
                        ];
                    }
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, res.data.data)
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        thunkAPI.rejectWithValue(error)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var updateUser = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("userReducer/updateUser", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param, thunkAPI) {
        var full_name, avatar, ref, res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    full_name = param.full_name, avatar = param.avatar;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        src_redux_services_User_user__WEBPACK_IMPORTED_MODULE_2__/* ["default"].updateUser */ .Z.updateUser(full_name === null || full_name === void 0 ? void 0 : full_name.trim(), avatar)
                    ];
                case 2:
                    res = _state.sent();
                    if (!res) {
                        // toast.error(res.error.message)
                        return [
                            2
                        ];
                    }
                    if (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.message) {
                        react_hot_toast__WEBPACK_IMPORTED_MODULE_1__/* ["default"].success */ .ZP.success(res.data.message, {
                            id: "update_user_toast"
                        });
                    }
                    return [
                        2,
                        {
                            full_name: full_name
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        thunkAPI.rejectWithValue(error)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var updateUserAvatar = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("userReducer/updateUserAvatar", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(avatar, thunkAPI) {
        var ref, res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        src_redux_services_User_user__WEBPACK_IMPORTED_MODULE_2__/* ["default"].updateUserAvatar */ .Z.updateUserAvatar(avatar)
                    ];
                case 1:
                    res = _state.sent();
                    if (!res) {
                        return [
                            2
                        ];
                    }
                    if (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.message) {
                        react_hot_toast__WEBPACK_IMPORTED_MODULE_1__/* ["default"].success */ .ZP.success(res.data.message, {
                            id: "update_user_toast"
                        });
                    }
                    return [
                        2,
                        {
                            avatar: avatar
                        }
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        thunkAPI.rejectWithValue(error)
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function(avatar, thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var makeContactDefault = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("userReducer/makeContactDefault", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(id, thunkAPI) {
        var res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _pages_api_profile_index__WEBPACK_IMPORTED_MODULE_3__/* .AuthAPI.makeContactDefault */ .u.makeContactDefault(id)
                    ];
                case 1:
                    res = _state.sent();
                    if (!res) {
                        return [
                            2
                        ];
                    }
                    react_hot_toast__WEBPACK_IMPORTED_MODULE_1__/* ["default"].success */ .ZP.success("Cập nhật li\xean hệ mặc định th\xe0nh c\xf4ng!");
                    return [
                        2,
                        {}
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        thunkAPI.rejectWithValue(error)
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function(id, thunkAPI) {
        return _ref.apply(this, arguments);
    };
}());
var getLoginHistory = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("userReducer/getListHistory", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param, thunkApi) {
        var page_index, page_size, type, res, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    page_index = param.page_index, page_size = param.page_size, type = param.type;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        src_redux_services_User_user__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getListHistory */ .Z.getListHistory({
                            page_index: page_index,
                            page_size: page_size,
                            type: type
                        })
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
                case 3:
                    err = _state.sent();
                    thunkApi.rejectWithValue(err);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, thunkApi) {
        return _ref.apply(this, arguments);
    };
}());
var loadMoreLoginHistory = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("userReducer/loadMoreHistory", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param, thunkApi) {
        var page_index, page_size, type, res, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    page_index = param.page_index, page_size = param.page_size, type = param.type;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        src_redux_services_User_user__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getListHistory */ .Z.getListHistory({
                            page_index: page_index,
                            page_size: page_size,
                            type: type
                        })
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
                case 3:
                    err = _state.sent();
                    thunkApi.rejectWithValue(err);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, thunkApi) {
        return _ref.apply(this, arguments);
    };
}());
var userSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    name: "userReducer",
    initialState: initialState,
    reducers: {},
    extraReducers: function(builder) {
        builder.addCase(getMe.pending, function(state) {
            state.loading = true;
        });
        builder.addCase(getMe.fulfilled, function(state, action) {
            state.loading = false;
            if (action.payload) {
                state.user = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.user, action.payload);
            }
        });
        builder.addCase(getMe.rejected, function(state) {
            state.loading = false;
        });
        builder.addCase(getUserInformation.pending, function(state) {
            state.loading = true;
        });
        builder.addCase(getUserInformation.fulfilled, function(state, action) {
            state.loading = false;
            if (action.payload) {
                state.user.courses = action.payload.courses;
                state.user.certificates = action.payload.certificates;
            }
        });
        builder.addCase(getUserInformation.rejected, function(state) {
            state.loading = false;
        });
        builder.addCase(updateUser.pending, function(state) {
            state.loadingEditName = true;
        });
        builder.addCase(updateUser.fulfilled, function(state) {
            state.loadingEditName = false;
        });
        builder.addCase(updateUser.rejected, function(state) {
            state.loadingEditName = false;
        });
        builder.addCase(updateUserAvatar.pending, function(state) {
            state.loadingEditAvatar = true;
        });
        builder.addCase(updateUserAvatar.fulfilled, function(state) {
            state.loadingEditAvatar = false;
        });
        builder.addCase(updateUserAvatar.rejected, function(state) {
            state.loadingEditAvatar = false;
        });
        builder.addCase(makeContactDefault.pending, function(state) {
            state.loading = true;
        });
        builder.addCase(makeContactDefault.fulfilled, function(state) {
            state.loading = false;
        });
        builder.addCase(makeContactDefault.rejected, function(state) {
            state.loading = false;
        });
        builder.addCase(getLoginHistory.pending, function(state) {
            state.loadHistory = true;
        });
        builder.addCase(getLoginHistory.fulfilled, function(state, action) {
            state.loginHistory = action.payload;
            state.loadHistory = false;
        });
        builder.addCase(getLoginHistory.rejected, function(state) {
            state.loadHistory = false;
        });
        builder.addCase(loadMoreLoginHistory.pending, function(state) {
            state.loadHistory = true;
        });
        builder.addCase(loadMoreLoginHistory.fulfilled, function(state, action) {
            var obj = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.loginHistory);
            obj.meta = action.payload.meta;
            obj.userActivities = obj.userActivities.concat(action.payload.userActivities);
            state.loginHistory = obj;
            state.loadHistory = false;
        });
        builder.addCase(loadMoreLoginHistory.rejected, function(state) {
            state.loadHistory = false;
        });
    }
});
// export const selectAuthUser = (state: RootState) => state.loginReducer.authUser;
var userReducer = function(state) {
    return state.userReducer;
};
/* harmony default export */ __webpack_exports__["ZP"] = (userSlice.reducer);


/***/ }),

/***/ 7847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ UserType; }
/* harmony export */ });
/* unused harmony export IUserStatus */
var UserType;
(function(UserType) {
    UserType["STUDENT"] = "STUDENT";
    UserType["TEACHER"] = "TEACHER";
})(UserType || (UserType = {}));
var IUserStatus;
(function(IUserStatus) {
    IUserStatus["ACTIVE"] = "ACTIVE";
})(IUserStatus || (IUserStatus = {}));


/***/ }),

/***/ 91002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ji": function() { return /* binding */ fetchFormData; },
/* harmony export */   "SV": function() { return /* binding */ getBaseUrl; },
/* harmony export */   "_i": function() { return /* binding */ fetcher; }
/* harmony export */ });
/* unused harmony export request */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(72760);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52621);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68582);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72808);
/* harmony import */ var _en_exceptions_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20959);
/* harmony import */ var _utils_helpers_keycloak__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3787);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34376);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43743);
/* harmony import */ var src_redux_services_httpService__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92816);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45332);












var getBaseUrl = function() {
    if (true) {
        return "https://lms-be.sapp.edu.vn/api/v1";
    }
};
// Initialize Axios instance
var request = axios__WEBPACK_IMPORTED_MODULE_7__/* ["default"].create */ .Z.create({
    baseURL: getBaseUrl(),
    headers: {
        "Content-Type": "application/json"
    }
});
var fetcher = function(url) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return request(url, config).then(function(res) {
        return res === null || res === void 0 ? void 0 : res.data;
    }).catch(function(err) {
        throw err;
    });
};
// Request Interceptor
request.interceptors.request.use(function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(config) {
        var ref, ref1, authenticationManager, checkRouteCertificate;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authenticationManager = new _utils_helpers_keycloak__WEBPACK_IMPORTED_MODULE_2__/* .AuthenticationManager */ .E();
                    checkRouteCertificate = [
                        src_constants__WEBPACK_IMPORTED_MODULE_4__/* .ENTRANCE_TEST_RESULT */ .WD,
                        src_constants__WEBPACK_IMPORTED_MODULE_4__/* .CERTIFICATE_DETAIL */ .JJ,
                        src_constants__WEBPACK_IMPORTED_MODULE_4__/* .ENTRANCE_TEST_TABLE_RESULT */ .IO
                    ].includes((ref = (next_router__WEBPACK_IMPORTED_MODULE_3___default()) === null || (next_router__WEBPACK_IMPORTED_MODULE_3___default()) === void 0 ? void 0 : (next_router__WEBPACK_IMPORTED_MODULE_3___default().router)) === null || ref === void 0 ? void 0 : (ref1 = ref.state) === null || ref1 === void 0 ? void 0 : ref1.pathname);
                    if (authenticationManager.getToken() || checkRouteCertificate) {
                        config.headers = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                            Authorization: "Bearer " + authenticationManager.getToken()
                        }, config.headers);
                        return [
                            2,
                            config
                        ];
                    }
                    return [
                        4,
                        new Promise(function(resolve) {
                            var interval = null;
                            interval = setInterval(function() {
                                if (authenticationManager.getToken() || checkRouteCertificate) {
                                    config.headers = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                                        Authorization: "Bearer " + authenticationManager.getToken()
                                    }, config.headers);
                                    clearInterval(interval);
                                    resolve(config);
                                }
                            }, 100);
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        config
                    ];
            }
        });
    });
    return function(config) {
        return _ref.apply(this, arguments);
    };
}());
// Variable to track whether the refresh token API has been called
var isRefreshing = false;
var refreshSubscribers = [];
// Response Interceptor
request.interceptors.response.use(function(response) {
    return response;
}, function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(error) {
        var originalRequest, ref, retryOriginalRequest;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            originalRequest = error.config;
            // Handle token expiration (401 error)
            if (error.response && error.response.status === 401) {
                if (!isRefreshing) {
                    isRefreshing = true;
                    ;
                    (0,axios__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("".concat(src_redux_services_httpService__WEBPACK_IMPORTED_MODULE_5__/* .apiURL */ .QH, "/auth/refresh-token"), {
                        method: "POST",
                        headers: {
                            Authorization: "Bearer " + (0,_utils_index__WEBPACK_IMPORTED_MODULE_6__/* .getCookie */ .ej)(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIE_INFO.KEYCLOAK_TOKEN */ .s_.KEYCLOAK_TOKEN)
                        },
                        data: {
                            refresh_token: (ref = (0,_utils_index__WEBPACK_IMPORTED_MODULE_6__/* .getCookie */ .ej)(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIE_INFO.KEYCLOAK_REFRESH_TOKEN */ .s_.KEYCLOAK_REFRESH_TOKEN)) !== null && ref !== void 0 ? ref : ""
                        }
                    }).then(function(res) {
                        var userInfo = res === null || res === void 0 ? void 0 : res.data;
                        (0,_utils_index__WEBPACK_IMPORTED_MODULE_6__/* .setCookie */ .d8)(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIE_INFO.KEYCLOAK_TOKEN */ .s_.KEYCLOAK_TOKEN, userInfo === null || userInfo === void 0 ? void 0 : userInfo.access_token);
                        (0,_utils_index__WEBPACK_IMPORTED_MODULE_6__/* .setCookie */ .d8)(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIE_INFO.KEYCLOAK_REFRESH_TOKEN */ .s_.KEYCLOAK_REFRESH_TOKEN, userInfo === null || userInfo === void 0 ? void 0 : userInfo.refresh_token);
                        var ref;
                        (0,_utils_index__WEBPACK_IMPORTED_MODULE_6__/* .setCookie */ .d8)(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIE_INFO.SESSION_ID */ .s_.SESSION_ID, (ref = userInfo === null || userInfo === void 0 ? void 0 : userInfo.session_state) !== null && ref !== void 0 ? ref : "");
                        var ref1;
                        // update new token to axios
                        request.defaults.headers.common["Authorization"] = "Bearer ".concat((ref1 = (0,_utils_index__WEBPACK_IMPORTED_MODULE_6__/* .getCookie */ .ej)(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIE_INFO.KEYCLOAK_TOKEN */ .s_.KEYCLOAK_TOKEN)) !== null && ref1 !== void 0 ? ref1 : "");
                        var ref2;
                        // Callback to unauth API calls
                        refreshSubscribers.forEach(function(callback) {
                            return callback((ref2 = (0,_utils_index__WEBPACK_IMPORTED_MODULE_6__/* .getCookie */ .ej)(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIE_INFO.KEYCLOAK_TOKEN */ .s_.KEYCLOAK_TOKEN)) !== null && ref2 !== void 0 ? ref2 : "");
                        });
                        refreshSubscribers = [];
                        isRefreshing = false;
                    }).catch(function() {
                        (0,_utils_index__WEBPACK_IMPORTED_MODULE_6__/* .deleteCookie */ .kT)(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIE_INFO.KEYCLOAK_TOKEN */ .s_.KEYCLOAK_TOKEN);
                        (0,_utils_index__WEBPACK_IMPORTED_MODULE_6__/* .deleteCookie */ .kT)(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIE_INFO.KEYCLOAK_REFRESH_TOKEN */ .s_.KEYCLOAK_REFRESH_TOKEN);
                        (0,_utils_index__WEBPACK_IMPORTED_MODULE_6__/* .deleteCookie */ .kT)(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIE_INFO.KEYCLOAK_USER_ID */ .s_.KEYCLOAK_USER_ID);
                        (0,_utils_index__WEBPACK_IMPORTED_MODULE_6__/* .deleteCookie */ .kT)(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIE_INFO.SESSION_ID */ .s_.SESSION_ID);
                        window.location.reload();
                    });
                }
                retryOriginalRequest = new Promise(function(resolve) {
                    var subscribeTokenRefresh = function(token) {
                        originalRequest.headers["Authorization"] = "Bearer ".concat(token);
                        resolve((0,axios__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(originalRequest));
                    };
                    refreshSubscribers.push(subscribeTokenRefresh);
                });
                return [
                    2,
                    retryOriginalRequest
                ];
            }
            // Handle other errors
            return [
                2,
                Promise.reject(error)
            ];
        });
    });
    return function(error) {
        return _ref.apply(this, arguments);
    };
}());
// Toast for specific exceptions
var toastExceptions = [
    "400|060915",
    "400|060904",
    "403|000010",
    "400|010833",
    "400|010433",
    "400|010008", 
];
// Map exceptions
var formattedExceptions = _en_exceptions_json__WEBPACK_IMPORTED_MODULE_1__.reduce(function(acc, param) {
    var code = param.code, message = param.message;
    acc[code] = message;
    return acc;
}, {});
// Global error handler
request.interceptors.response.use(function(response) {
    return response;
}, function(error) {
    var ref, ref1, ref2, ref3;
    var errorCode = error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.error) === null || ref2 === void 0 ? void 0 : ref2.code;
    var errorMessage = formattedExceptions[errorCode] || (error === null || error === void 0 ? void 0 : (ref3 = error.response) === null || ref3 === void 0 ? void 0 : ref3.statusText) || (error === null || error === void 0 ? void 0 : error.message) || "Unknown error!";
    if (!toastExceptions.includes(errorCode)) {
        react_hot_toast__WEBPACK_IMPORTED_MODULE_0__/* .toast.error */ .Am.error(errorMessage);
    }
    if (errorCode === null || errorCode === void 0 ? void 0 : errorCode.startsWith("403") // Forbidden các loại
    ) {
        next_router__WEBPACK_IMPORTED_MODULE_3___default().replace("/");
    }
    return Promise.reject(error);
});
var fetchFormData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(param) {
        var url, formData, _method, method;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            url = param.url, formData = param.formData, _method = param.method, method = _method === void 0 ? "POST" : _method;
            if (!formData || (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(formData.entries()).length === 0) {
                throw new Error("FormData cannot be empty.");
            }
            return [
                2,
                request({
                    url: url,
                    method: method,
                    data: formData,
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
            ];
        });
    });
    return function fetchFormData(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["ZP"] = (request);


/***/ }),

/***/ 10212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CS": function() { return /* binding */ getDayIndex; },
/* harmony export */   "Gr": function() { return /* binding */ formatDateTimeWithTimeZone; },
/* harmony export */   "bJ": function() { return /* binding */ reverseDaysOfWeek; },
/* harmony export */   "dm": function() { return /* binding */ cleanParams; },
/* harmony export */   "iZ": function() { return /* binding */ convertLocalWeekDaysToUTC; },
/* harmony export */   "mr": function() { return /* binding */ formatTime; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18473);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72760);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79555);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43743);




var formatDate = function(date) {
    var formatStr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "DD/MM/YYYY";
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).format(formatStr);
};
var formatTime = function(date) {
    var formatStr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "HH:mm";
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).format(formatStr);
};
var cleanParams = function(params) {
    var result = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(params)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_step.value, 2), key = _value[0], value = _value[1];
            if (![
                null,
                undefined,
                ""
            ].includes(value) || Array.isArray(value) && value.length) {
                result[key] = value;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
};
/**
 * Returns the index of the weekday for a given date, adjusted for UTC.
 *
 * @param {Date} startDate - The date for which the weekday index is calculated.
 * @param {boolean} isUTC - Whether to use UTC time.
 * @returns {number} - The index of the weekday, where 0 is Monday and 6 is Sunday.
 */ var getDayIndex = function(startDate) {
    var isUTC = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var day = isUTC ? dayjs__WEBPACK_IMPORTED_MODULE_0___default()(startDate).utc().day() : dayjs__WEBPACK_IMPORTED_MODULE_0___default()(startDate).day();
    return (day + src_constants__WEBPACK_IMPORTED_MODULE_1__/* .DAYS_IN_WEEK */ .NA - 1) % src_constants__WEBPACK_IMPORTED_MODULE_1__/* .DAYS_IN_WEEK */ .NA;
};
var reverseDaysOfWeek = function(startDate, daysOfWeek) {
    var dayOfWeek = getDayIndex(startDate) + 1 // Convert start day of week from 0 to 1
    ;
    var dayIndex = daysOfWeek.indexOf(dayOfWeek);
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(daysOfWeek.slice(dayIndex)).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(daysOfWeek.slice(0, dayIndex)));
};
var convertLocalWeekDaysToUTC = function(startDate, localDaysOfWeek) {
    // start of week with startDate hour and minute
    var startOfWeek = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(startDate).startOf("week").hour(startDate.getHours()).minute(startDate.getMinutes());
    return localDaysOfWeek.map(function(num) {
        return getDayIndex(startOfWeek.add(num, "day").toDate()) + 1;
    }) // Convert start day of week from 0 to 1
    ;
};
/**
 *
 * @param date - Don't use formatDateTimeWithTimeZone(new Date('DD/MM/YYYY'), 'HH:mm') instead of formatDateTimeWithTimeZone('DD/MM/YYYY', 'HH:mm')
 * @param time
 * @returns
 */ var formatDateTimeWithTimeZone = function(date, time) {
    if (typeof date === "string") {
        return new Date("".concat(date, "T").concat(time, "Z"));
    }
    var startDayjs = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).startOf("day");
    var formattedDate = startDayjs.format("YYYY-MM-DD");
    var tmpStartDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(formattedDate + "T" + time + "Z");
    return startDayjs.set("hour", tmpStartDate.get("hour")) // Avoid time has UTC issue
    .set("minute", tmpStartDate.get("minute")).toDate();
};


/***/ }),

/***/ 10848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ USER_TYPE; },
/* harmony export */   "$q": function() { return /* binding */ PROFILE_PAGES; },
/* harmony export */   "VD": function() { return /* binding */ SECURITY_TREE; },
/* harmony export */   "iy": function() { return /* binding */ USER_STATUS; },
/* harmony export */   "kw": function() { return /* binding */ MYPROFILE_TREE; }
/* harmony export */ });
/* unused harmony export MYCOURSE_PAGES */
var PROFILE_PAGES = {
    MYPROFILE: {
        label: "My Profile",
        children: [
            {
                OVERVIEW: {
                    label: "Overview"
                }
            },
            {
                CMA: {
                    label: "CMA"
                }
            },
            {
                CFA: {
                    label: "CFA"
                }
            },
            {
                ACCA: {
                    label: "ACCA"
                }
            }, 
        ]
    },
    CERTIFICATES: {
        label: "Certificates",
        children: []
    },
    EXAM_INFORMATION: {
        label: "Exam Information",
        children: []
    },
    SETTINGS: {
        label: "Settings",
        children: []
    },
    SECURITY: {
        label: "Security",
        children: [
            {
                DEVICES: {
                    label: "Devices"
                }
            },
            {
                LOGIN_HISTORY: {
                    label: "Login History"
                }
            },
            {
                CHANGE_PASSWORD: {
                    label: "Change Password"
                }
            }, 
        ]
    }
};
var MYCOURSE_PAGES = {
    ALL: {
        label: "All"
    },
    CFA: {
        label: "Cfa"
    },
    ACCA: {
        label: "Acca"
    },
    CMA: {
        label: "Cma"
    }
};
var USER_TYPE = {
    STUDENT: {
        key: "STUDENT",
        label: "Học vi\xean"
    },
    TEACHER: {
        key: "TEACHER",
        label: "Gi\xe1o vi\xean"
    }
};
var USER_STATUS = {
    ACTIVE: {
        key: "ACTIVE",
        label: "Active",
        color: "text-state-success"
    }
};
var SECURITY_TREE = [
    "devices",
    "login_history",
    "change_password"
];
var MYPROFILE_TREE = [
    "overview",
    "cfa",
    "cma",
    "acca"
];


/***/ }),

/***/ 15183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Cq": function() { return /* binding */ CERTIFICATE; },
  "JJ": function() { return /* binding */ CERTIFICATE_DETAIL; },
  "hi": function() { return /* binding */ CLASS_TEACHER_STATUS; },
  "DO": function() { return /* reexport */ CourseSectionType; },
  "Vj": function() { return /* binding */ FLEXIBLE; },
  "u9": function() { return /* binding */ FOUNDATION; },
  "QS": function() { return /* binding */ F_LOW_CODES; },
  "s6": function() { return /* reexport */ GradingMethod; },
  "_": function() { return /* binding */ LAYOUT; },
  "iN": function() { return /* binding */ QUIZ_GRADING_METHOD; },
  "LB": function() { return /* binding */ TEST_TYPE; },
  "cH": function() { return /* binding */ TEST_TYPE_ENUM; },
  "jh": function() { return /* binding */ video_url; }
});

// UNUSED EXPORTS: F_HIGH_CODES, localStorageKeys

;// CONCATENATED MODULE: ./src/utils/constants/Course.ts
var CourseSectionType;
(function(CourseSectionType) {
    CourseSectionType["PART"] = "PART";
    CourseSectionType["CHAPTER"] = "CHAPTER";
    CourseSectionType["UNIT"] = "UNIT";
    CourseSectionType["ACTIVITY"] = "ACTIVITY";
})(CourseSectionType || (CourseSectionType = {}));

;// CONCATENATED MODULE: ./src/utils/constants/LocalStorageKey.ts
var localStorageKeys = {
    REDIRECT_AFTER_LOGIN: "redirectAfterLogin",
    ENTRANCE_TEST: "entranceTest"
};

;// CONCATENATED MODULE: ./src/utils/constants/Test.ts
var GradingMethod;
(function(GradingMethod) {
    GradingMethod["AUTO"] = "AUTO";
    GradingMethod["MANUAL"] = "MANUAL";
})(GradingMethod || (GradingMethod = {}));

;// CONCATENATED MODULE: ./src/utils/constants/index.ts
var LAYOUT = {
    DEFAULT_LAYOUT: "DEFAULT_LAYOUT",
    ERROR_LAYOUT: "ERROR_LAYOUT",
    SINGLE_DIALOG_LAYOUT: "SINGLE_DIALOG_LAYOUT",
    FULLSCREEN_LAYOUT: "FULLSCREEN_LAYOUT",
    SINGLE_PAGE_LAYOUT: "SINGLE_PAGE_LAYOUT"
};
var TEST_TYPE = {
    QUIZ: "Quiz",
    MID_TERM_TEST: "Midterm Test",
    FINAL_TEST: "Final Test",
    MOCK_TEST: "Mock Test",
    ENTRANCE_TEST: "Entrance Test",
    // STORY = 'STORY',
    TOPIC_TEST: "Part/Topic Test",
    CHAPTER_TEST: "Chapter/Module Test",
    ACTIVITY: "Quiz"
};
var TEST_TYPE_ENUM;
(function(TEST_TYPE_ENUM) {
    TEST_TYPE_ENUM["QUIZ"] = "QUIZ";
    TEST_TYPE_ENUM["MID_TERM_TEST"] = "MID_TERM_TEST";
    TEST_TYPE_ENUM["FINAL_TEST"] = "FINAL_TEST";
    TEST_TYPE_ENUM["MOCK_TEST"] = "MOCK_TEST";
    TEST_TYPE_ENUM[// ENTRANCE_TEST = 'ENTRANCE_TEST',
    // STORY = 'STORY',
    "TOPIC_TEST"] = "TOPIC_TEST";
    TEST_TYPE_ENUM["CHAPTER_TEST"] = "CHAPTER_TEST";
    TEST_TYPE_ENUM["PART_TEST"] = "PART_TEST";
    TEST_TYPE_ENUM[// EVENT_TEST = 'EVENT_TEST',
    "PART"] = "PART";
    TEST_TYPE_ENUM["CHAPTER"] = "CHAPTER";
    TEST_TYPE_ENUM["ACTIVITY"] = "ACTIVITY";
})(TEST_TYPE_ENUM || (TEST_TYPE_ENUM = {}));
var QUIZ_GRADING_METHOD = [
    {
        label: "Yes",
        value: "MANUAL"
    },
    {
        label: "No",
        value: "AUTO"
    }, 
];
var FOUNDATION = "Foundation";
var CLASS_TEACHER_STATUS = {
    NOT_STARTED: "NOT_STARTED",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETED: "COMPLETED"
};
var FLEXIBLE = "FLEXIBLE";
// Danh sách F thấp (< F4)
var F_LOW_CODES = [
    "F1",
    "F2",
    "F3",
    "F4"
];
var F_HIGH_CODES = (/* unused pure expression or super */ null && ([
    "F5",
    "F6"
]));
var video_url = "https://customer-yamew980vfq5r6ry.cloudflarestream.com/";
var CERTIFICATE_DETAIL = "/certificates/[id]";
var CERTIFICATE = "certificates";





/***/ }),

/***/ 83509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ getMessagingToken; },
  "L": function() { return /* binding */ onMessageListener; }
});

// NAMESPACE OBJECT: ./node_modules/@firebase/app/dist/esm/index.esm2017.js
var app_dist_esm_index_esm2017_namespaceObject = {};
__webpack_require__.r(app_dist_esm_index_esm2017_namespaceObject);
__webpack_require__.d(app_dist_esm_index_esm2017_namespaceObject, {
  "FirebaseError": function() { return FirebaseError; },
  "SDK_VERSION": function() { return SDK_VERSION; },
  "_DEFAULT_ENTRY_NAME": function() { return index_esm2017_DEFAULT_ENTRY_NAME; },
  "_addComponent": function() { return _addComponent; },
  "_addOrOverwriteComponent": function() { return _addOrOverwriteComponent; },
  "_apps": function() { return _apps; },
  "_clearComponents": function() { return _clearComponents; },
  "_components": function() { return _components; },
  "_getProvider": function() { return index_esm2017_getProvider; },
  "_isFirebaseApp": function() { return _isFirebaseApp; },
  "_isFirebaseServerApp": function() { return _isFirebaseServerApp; },
  "_registerComponent": function() { return _registerComponent; },
  "_removeServiceInstance": function() { return _removeServiceInstance; },
  "_serverApps": function() { return _serverApps; },
  "deleteApp": function() { return deleteApp; },
  "getApp": function() { return index_esm2017_getApp; },
  "getApps": function() { return getApps; },
  "initializeApp": function() { return initializeApp; },
  "initializeServerApp": function() { return initializeServerApp; },
  "onLog": function() { return onLog; },
  "registerVersion": function() { return registerVersion; },
  "setLogLevel": function() { return index_esm2017_setLogLevel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(51224);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(52621);
;// CONCATENATED MODULE: ./node_modules/@firebase/util/dist/index.esm2017.js
/* provided dependency */ var process = __webpack_require__(554);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
const CONSTANTS = {
  /**
   * @define {boolean} Whether this is the client Node.js SDK.
   */
  NODE_CLIENT: false,
  /**
   * @define {boolean} Whether this is the Admin Node.js SDK.
   */
  NODE_ADMIN: false,
  /**
   * Firebase SDK Version
   */
  SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 */
const assert = function (assertion, message) {
  if (!assertion) {
    throw assertionError(message);
  }
};
/**
 * Returns an Error object suitable for throwing.
 */
const assertionError = function (message) {
  return new Error('Firebase Database (' + CONSTANTS.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const stringToByteArray$1 = function (str) {
  // TODO(user): Use native implementations if/when available
  const out = [];
  let p = 0;
  for (let i = 0; i < str.length; i++) {
    let c = str.charCodeAt(i);
    if (c < 128) {
      out[p++] = c;
    } else if (c < 2048) {
      out[p++] = c >> 6 | 192;
      out[p++] = c & 63 | 128;
    } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
      // Surrogate Pair
      c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
      out[p++] = c >> 18 | 240;
      out[p++] = c >> 12 & 63 | 128;
      out[p++] = c >> 6 & 63 | 128;
      out[p++] = c & 63 | 128;
    } else {
      out[p++] = c >> 12 | 224;
      out[p++] = c >> 6 & 63 | 128;
      out[p++] = c & 63 | 128;
    }
  }
  return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */
const byteArrayToString = function (bytes) {
  // TODO(user): Use native implementations if/when available
  const out = [];
  let pos = 0,
    c = 0;
  while (pos < bytes.length) {
    const c1 = bytes[pos++];
    if (c1 < 128) {
      out[c++] = String.fromCharCode(c1);
    } else if (c1 > 191 && c1 < 224) {
      const c2 = bytes[pos++];
      out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
    } else if (c1 > 239 && c1 < 365) {
      // Surrogate Pair
      const c2 = bytes[pos++];
      const c3 = bytes[pos++];
      const c4 = bytes[pos++];
      const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
      out[c++] = String.fromCharCode(0xd800 + (u >> 10));
      out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
    } else {
      const c2 = bytes[pos++];
      const c3 = bytes[pos++];
      out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
    }
  }
  return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const base64 = {
  /**
   * Maps bytes to characters.
   */
  byteToCharMap_: null,
  /**
   * Maps characters to bytes.
   */
  charToByteMap_: null,
  /**
   * Maps bytes to websafe characters.
   * @private
   */
  byteToCharMapWebSafe_: null,
  /**
   * Maps websafe characters to bytes.
   * @private
   */
  charToByteMapWebSafe_: null,
  /**
   * Our default alphabet, shared between
   * ENCODED_VALS and ENCODED_VALS_WEBSAFE
   */
  ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
  /**
   * Our default alphabet. Value 64 (=) is special; it means "nothing."
   */
  get ENCODED_VALS() {
    return this.ENCODED_VALS_BASE + '+/=';
  },
  /**
   * Our websafe alphabet.
   */
  get ENCODED_VALS_WEBSAFE() {
    return this.ENCODED_VALS_BASE + '-_.';
  },
  /**
   * Whether this browser supports the atob and btoa functions. This extension
   * started at Mozilla but is now implemented by many browsers. We use the
   * ASSUME_* variables to avoid pulling in the full useragent detection library
   * but still allowing the standard per-browser compilations.
   *
   */
  HAS_NATIVE_SUPPORT: typeof atob === 'function',
  /**
   * Base64-encode an array of bytes.
   *
   * @param input An array of bytes (numbers with
   *     value in [0, 255]) to encode.
   * @param webSafe Boolean indicating we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeByteArray(input, webSafe) {
    if (!Array.isArray(input)) {
      throw Error('encodeByteArray takes an array as a parameter');
    }
    this.init_();
    const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
    const output = [];
    for (let i = 0; i < input.length; i += 3) {
      const byte1 = input[i];
      const haveByte2 = i + 1 < input.length;
      const byte2 = haveByte2 ? input[i + 1] : 0;
      const haveByte3 = i + 2 < input.length;
      const byte3 = haveByte3 ? input[i + 2] : 0;
      const outByte1 = byte1 >> 2;
      const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
      let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
      let outByte4 = byte3 & 0x3f;
      if (!haveByte3) {
        outByte4 = 64;
        if (!haveByte2) {
          outByte3 = 64;
        }
      }
      output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
    }
    return output.join('');
  },
  /**
   * Base64-encode a string.
   *
   * @param input A string to encode.
   * @param webSafe If true, we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeString(input, webSafe) {
    // Shortcut for Mozilla browsers that implement
    // a native base64 encoder in the form of "btoa/atob"
    if (this.HAS_NATIVE_SUPPORT && !webSafe) {
      return btoa(input);
    }
    return this.encodeByteArray(stringToByteArray$1(input), webSafe);
  },
  /**
   * Base64-decode a string.
   *
   * @param input to decode.
   * @param webSafe True if we should use the
   *     alternative alphabet.
   * @return string representing the decoded value.
   */
  decodeString(input, webSafe) {
    // Shortcut for Mozilla browsers that implement
    // a native base64 encoder in the form of "btoa/atob"
    if (this.HAS_NATIVE_SUPPORT && !webSafe) {
      return atob(input);
    }
    return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
  },
  /**
   * Base64-decode a string.
   *
   * In base-64 decoding, groups of four characters are converted into three
   * bytes.  If the encoder did not apply padding, the input length may not
   * be a multiple of 4.
   *
   * In this case, the last group will have fewer than 4 characters, and
   * padding will be inferred.  If the group has one or two characters, it decodes
   * to one byte.  If the group has three characters, it decodes to two bytes.
   *
   * @param input Input to decode.
   * @param webSafe True if we should use the web-safe alphabet.
   * @return bytes representing the decoded value.
   */
  decodeStringToByteArray(input, webSafe) {
    this.init_();
    const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
    const output = [];
    for (let i = 0; i < input.length;) {
      const byte1 = charToByteMap[input.charAt(i++)];
      const haveByte2 = i < input.length;
      const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
      ++i;
      const haveByte3 = i < input.length;
      const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
      ++i;
      const haveByte4 = i < input.length;
      const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
      ++i;
      if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
        throw new DecodeBase64StringError();
      }
      const outByte1 = byte1 << 2 | byte2 >> 4;
      output.push(outByte1);
      if (byte3 !== 64) {
        const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
        output.push(outByte2);
        if (byte4 !== 64) {
          const outByte3 = byte3 << 6 & 0xc0 | byte4;
          output.push(outByte3);
        }
      }
    }
    return output;
  },
  /**
   * Lazy static initialization function. Called before
   * accessing any of the static map variables.
   * @private
   */
  init_() {
    if (!this.byteToCharMap_) {
      this.byteToCharMap_ = {};
      this.charToByteMap_ = {};
      this.byteToCharMapWebSafe_ = {};
      this.charToByteMapWebSafe_ = {};
      // We want quick mappings back and forth, so we precompute two maps.
      for (let i = 0; i < this.ENCODED_VALS.length; i++) {
        this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
        this.charToByteMap_[this.byteToCharMap_[i]] = i;
        this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
        this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
        // Be forgiving when decoding and correctly decode both encodings.
        if (i >= this.ENCODED_VALS_BASE.length) {
          this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
          this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
        }
      }
    }
  }
};
/**
 * An error encountered while decoding base64 string.
 */
class DecodeBase64StringError extends Error {
  constructor() {
    super(...arguments);
    this.name = 'DecodeBase64StringError';
  }
}
/**
 * URL-safe base64 encoding
 */
const base64Encode = function (str) {
  const utf8Bytes = stringToByteArray$1(str);
  return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */
const base64urlEncodeWithoutPadding = function (str) {
  // Use base64url encoding and remove padding in the end (dot characters).
  return base64Encode(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */
const base64Decode = function (str) {
  try {
    return base64.decodeString(str, true);
  } catch (e) {
    console.error('base64Decode failed: ', e);
  }
  return null;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
  return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */
function deepExtend(target, source) {
  if (!(source instanceof Object)) {
    return source;
  }
  switch (source.constructor) {
    case Date:
      // Treat Dates like scalars; if the target date object had any child
      // properties - they will be lost!
      const dateValue = source;
      return new Date(dateValue.getTime());
    case Object:
      if (target === undefined) {
        target = {};
      }
      break;
    case Array:
      // Always copy the array source and overwrite the target.
      target = [];
      break;
    default:
      // Not a plain Object - treat it as a scalar.
      return source;
  }
  for (const prop in source) {
    // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
    if (!source.hasOwnProperty(prop) || !isValidKey(prop)) {
      continue;
    }
    target[prop] = deepExtend(target[prop], source[prop]);
  }
  return target;
}
function isValidKey(key) {
  return key !== '__proto__';
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */
function getGlobal() {
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof __webpack_require__.g !== 'undefined') {
    return __webpack_require__.g;
  }
  throw new Error('Unable to locate global object.');
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const getDefaultsFromGlobal = () => getGlobal().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */
const getDefaultsFromEnvVariable = () => {
  if (typeof process === 'undefined' || typeof process.env === 'undefined') {
    return;
  }
  const defaultsJsonString = process.env.__FIREBASE_DEFAULTS__;
  if (defaultsJsonString) {
    return JSON.parse(defaultsJsonString);
  }
};
const getDefaultsFromCookie = () => {
  if (typeof document === 'undefined') {
    return;
  }
  let match;
  try {
    match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
  } catch (e) {
    // Some environments such as Angular Universal SSR have a
    // `document` object but error on accessing `document.cookie`.
    return;
  }
  const decoded = match && base64Decode(match[1]);
  return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */
const getDefaults = () => {
  try {
    return getDefaultsFromGlobal() || getDefaultsFromEnvVariable() || getDefaultsFromCookie();
  } catch (e) {
    /**
     * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
     * to any environment case we have not accounted for. Log to
     * info instead of swallowing so we can find these unknown cases
     * and add paths for them if needed.
     */
    console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
    return;
  }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */
const getDefaultEmulatorHost = productName => {
  var _a, _b;
  return (_b = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */
const getDefaultEmulatorHostnameAndPort = productName => {
  const host = getDefaultEmulatorHost(productName);
  if (!host) {
    return undefined;
  }
  const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
  if (separatorIndex <= 0 || separatorIndex + 1 === host.length) {
    throw new Error(`Invalid host ${host} with no separate hostname and port!`);
  }
  // eslint-disable-next-line no-restricted-globals
  const port = parseInt(host.substring(separatorIndex + 1), 10);
  if (host[0] === '[') {
    // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [host.substring(1, separatorIndex - 1), port];
  } else {
    return [host.substring(0, separatorIndex), port];
  }
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */
const getDefaultAppConfig = () => {
  var _a;
  return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */
const getExperimentalSetting = name => {
  var _a;
  return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Deferred {
  constructor() {
    this.reject = () => {};
    this.resolve = () => {};
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
  /**
   * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
   * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
   * and returns a node-style callback which will resolve or reject the Deferred's promise.
   */
  wrapCallback(callback) {
    return (error, value) => {
      if (error) {
        this.reject(error);
      } else {
        this.resolve(value);
      }
      if (typeof callback === 'function') {
        // Attaching noop handler just in case developer wasn't expecting
        // promises
        this.promise.catch(() => {});
        // Some of our callbacks don't expect a value and our own tests
        // assert that the parameter length is 1
        if (callback.length === 1) {
          callback(error);
        } else {
          callback(error, value);
        }
      }
    };
  }
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createMockUserToken(token, projectId) {
  if (token.uid) {
    throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
  }
  // Unsecured JWTs use "none" as the algorithm.
  const header = {
    alg: 'none',
    type: 'JWT'
  };
  const project = projectId || 'demo-project';
  const iat = token.iat || 0;
  const sub = token.sub || token.user_id;
  if (!sub) {
    throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
  }
  const payload = Object.assign({
    // Set all required fields to decent defaults
    iss: `https://securetoken.google.com/${project}`,
    aud: project,
    iat,
    exp: iat + 3600,
    auth_time: iat,
    sub,
    user_id: sub,
    firebase: {
      sign_in_provider: 'custom',
      identities: {}
    }
  }, token);
  // Unsecured JWTs use the empty string as a signature.
  const signature = '';
  return [base64urlEncodeWithoutPadding(JSON.stringify(header)), base64urlEncodeWithoutPadding(JSON.stringify(payload)), signature].join('.');
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */
function getUA() {
  if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') {
    return navigator['userAgent'];
  } else {
    return '';
  }
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */
function isMobileCordova() {
  return typeof window !== 'undefined' &&
  // @ts-ignore Setting up an broadly applicable index signature for Window
  // just to deal with this case would probably be a bad idea.
  !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */
// Node detection logic from: https://github.com/iliakan/detect-node/
function isNode() {
  var _a;
  const forceEnvironment = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
  if (forceEnvironment === 'node') {
    return true;
  } else if (forceEnvironment === 'browser') {
    return false;
  }
  try {
    return Object.prototype.toString.call(__webpack_require__.g.process) === '[object process]';
  } catch (e) {
    return false;
  }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */
function isBrowser() {
  return typeof window !== 'undefined' || isWebWorker();
}
/**
 * Detect Web Worker context.
 */
function isWebWorker() {
  return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */
function isCloudflareWorker() {
  return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function isBrowserExtension() {
  const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
  return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */
function isReactNative() {
  return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */
function isElectron() {
  return getUA().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */
function isIE() {
  const ua = getUA();
  return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */
function isUWP() {
  return getUA().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */
function isNodeSdk() {
  return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */
function isSafari() {
  return !isNode() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */
function index_esm2017_isIndexedDBAvailable() {
  try {
    return typeof indexedDB === 'object';
  } catch (e) {
    return false;
  }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */
function index_esm2017_validateIndexedDBOpenable() {
  return new Promise((resolve, reject) => {
    try {
      let preExist = true;
      const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
      const request = self.indexedDB.open(DB_CHECK_NAME);
      request.onsuccess = () => {
        request.result.close();
        // delete database only when it doesn't pre-exist
        if (!preExist) {
          self.indexedDB.deleteDatabase(DB_CHECK_NAME);
        }
        resolve(true);
      };
      request.onupgradeneeded = () => {
        preExist = false;
      };
      request.onerror = () => {
        var _a;
        reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
      };
    } catch (error) {
      reject(error);
    }
  });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */
function index_esm2017_areCookiesEnabled() {
  if (typeof navigator === 'undefined' || !navigator.cookieEnabled) {
    return false;
  }
  return true;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */
const ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class FirebaseError extends Error {
  constructor(/** The error code for this error. */
  code, message, /** Custom data for this error. */
  customData) {
    super(message);
    this.code = code;
    this.customData = customData;
    /** The custom name for all FirebaseErrors. */
    this.name = ERROR_NAME;
    // Fix For ES5
    // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, FirebaseError.prototype);
    // Maintains proper stack trace for where our error was thrown.
    // Only available on V8.
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ErrorFactory.prototype.create);
    }
  }
}
class ErrorFactory {
  constructor(service, serviceName, errors) {
    this.service = service;
    this.serviceName = serviceName;
    this.errors = errors;
  }
  create(code, ...data) {
    const customData = data[0] || {};
    const fullCode = `${this.service}/${code}`;
    const template = this.errors[code];
    const message = template ? replaceTemplate(template, customData) : 'Error';
    // Service Name: Error message (service/code).
    const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
    const error = new FirebaseError(fullCode, fullMessage, customData);
    return error;
  }
}
function replaceTemplate(template, data) {
  return template.replace(PATTERN, (_, key) => {
    const value = data[key];
    return value != null ? String(value) : `<${key}?>`;
  });
}
const PATTERN = /\{\$([^}]+)}/g;

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
  return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
  return JSON.stringify(data);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const decode = function (token) {
  let header = {},
    claims = {},
    data = {},
    signature = '';
  try {
    const parts = token.split('.');
    header = jsonEval(base64Decode(parts[0]) || '');
    claims = jsonEval(base64Decode(parts[1]) || '');
    signature = parts[2];
    data = claims['d'] || {};
    delete claims['d'];
  } catch (e) {}
  return {
    header,
    claims,
    data,
    signature
  };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isValidTimestamp = function (token) {
  const claims = decode(token).claims;
  const now = Math.floor(new Date().getTime() / 1000);
  let validSince = 0,
    validUntil = 0;
  if (typeof claims === 'object') {
    if (claims.hasOwnProperty('nbf')) {
      validSince = claims['nbf'];
    } else if (claims.hasOwnProperty('iat')) {
      validSince = claims['iat'];
    }
    if (claims.hasOwnProperty('exp')) {
      validUntil = claims['exp'];
    } else {
      // token will expire after 24h by default
      validUntil = validSince + 86400;
    }
  }
  return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const issuedAtTime = function (token) {
  const claims = decode(token).claims;
  if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
    return claims['iat'];
  }
  return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isValidFormat = function (token) {
  const decoded = decode(token),
    claims = decoded.claims;
  return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isAdmin = function (token) {
  const claims = decode(token).claims;
  return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}
function safeGet(obj, key) {
  if (Object.prototype.hasOwnProperty.call(obj, key)) {
    return obj[key];
  } else {
    return undefined;
  }
}
function isEmpty(obj) {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      return false;
    }
  }
  return true;
}
function map(obj, fn, contextObj) {
  const res = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      res[key] = fn.call(contextObj, obj[key], key, obj);
    }
  }
  return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);
  for (const k of aKeys) {
    if (!bKeys.includes(k)) {
      return false;
    }
    const aProp = a[k];
    const bProp = b[k];
    if (isObject(aProp) && isObject(bProp)) {
      if (!deepEqual(aProp, bProp)) {
        return false;
      }
    } else if (aProp !== bProp) {
      return false;
    }
  }
  for (const k of bKeys) {
    if (!aKeys.includes(k)) {
      return false;
    }
  }
  return true;
}
function isObject(thing) {
  return thing !== null && typeof thing === 'object';
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */
function promiseWithTimeout(promise, timeInMS = 2000) {
  const deferredPromise = new Deferred();
  setTimeout(() => deferredPromise.reject('timeout!'), timeInMS);
  promise.then(deferredPromise.resolve, deferredPromise.reject);
  return deferredPromise.promise;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */
function querystring(querystringParams) {
  const params = [];
  for (const [key, value] of Object.entries(querystringParams)) {
    if (Array.isArray(value)) {
      value.forEach(arrayVal => {
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
      });
    } else {
      params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    }
  }
  return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */
function querystringDecode(querystring) {
  const obj = {};
  const tokens = querystring.replace(/^\?/, '').split('&');
  tokens.forEach(token => {
    if (token) {
      const [key, value] = token.split('=');
      obj[decodeURIComponent(key)] = decodeURIComponent(value);
    }
  });
  return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */
function extractQuerystring(url) {
  const queryStart = url.indexOf('?');
  if (!queryStart) {
    return '';
  }
  const fragmentStart = url.indexOf('#', queryStart);
  return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */
class Sha1 {
  constructor() {
    /**
     * Holds the previous values of accumulated variables a-e in the compress_
     * function.
     * @private
     */
    this.chain_ = [];
    /**
     * A buffer holding the partially computed hash result.
     * @private
     */
    this.buf_ = [];
    /**
     * An array of 80 bytes, each a part of the message to be hashed.  Referred to
     * as the message schedule in the docs.
     * @private
     */
    this.W_ = [];
    /**
     * Contains data needed to pad messages less than 64 bytes.
     * @private
     */
    this.pad_ = [];
    /**
     * @private {number}
     */
    this.inbuf_ = 0;
    /**
     * @private {number}
     */
    this.total_ = 0;
    this.blockSize = 512 / 8;
    this.pad_[0] = 128;
    for (let i = 1; i < this.blockSize; ++i) {
      this.pad_[i] = 0;
    }
    this.reset();
  }
  reset() {
    this.chain_[0] = 0x67452301;
    this.chain_[1] = 0xefcdab89;
    this.chain_[2] = 0x98badcfe;
    this.chain_[3] = 0x10325476;
    this.chain_[4] = 0xc3d2e1f0;
    this.inbuf_ = 0;
    this.total_ = 0;
  }
  /**
   * Internal compress helper function.
   * @param buf Block to compress.
   * @param offset Offset of the block in the buffer.
   * @private
   */
  compress_(buf, offset) {
    if (!offset) {
      offset = 0;
    }
    const W = this.W_;
    // get 16 big endian words
    if (typeof buf === 'string') {
      for (let i = 0; i < 16; i++) {
        // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
        // have a bug that turns the post-increment ++ operator into pre-increment
        // during JIT compilation.  We have code that depends heavily on SHA-1 for
        // correctness and which is affected by this bug, so I've removed all uses
        // of post-increment ++ in which the result value is used.  We can revert
        // this change once the Safari bug
        // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
        // most clients have been updated.
        W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
        offset += 4;
      }
    } else {
      for (let i = 0; i < 16; i++) {
        W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
        offset += 4;
      }
    }
    // expand to 80 words
    for (let i = 16; i < 80; i++) {
      const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
      W[i] = (t << 1 | t >>> 31) & 0xffffffff;
    }
    let a = this.chain_[0];
    let b = this.chain_[1];
    let c = this.chain_[2];
    let d = this.chain_[3];
    let e = this.chain_[4];
    let f, k;
    // TODO(user): Try to unroll this loop to speed up the computation.
    for (let i = 0; i < 80; i++) {
      if (i < 40) {
        if (i < 20) {
          f = d ^ b & (c ^ d);
          k = 0x5a827999;
        } else {
          f = b ^ c ^ d;
          k = 0x6ed9eba1;
        }
      } else {
        if (i < 60) {
          f = b & c | d & (b | c);
          k = 0x8f1bbcdc;
        } else {
          f = b ^ c ^ d;
          k = 0xca62c1d6;
        }
      }
      const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
      e = d;
      d = c;
      c = (b << 30 | b >>> 2) & 0xffffffff;
      b = a;
      a = t;
    }
    this.chain_[0] = this.chain_[0] + a & 0xffffffff;
    this.chain_[1] = this.chain_[1] + b & 0xffffffff;
    this.chain_[2] = this.chain_[2] + c & 0xffffffff;
    this.chain_[3] = this.chain_[3] + d & 0xffffffff;
    this.chain_[4] = this.chain_[4] + e & 0xffffffff;
  }
  update(bytes, length) {
    // TODO(johnlenz): tighten the function signature and remove this check
    if (bytes == null) {
      return;
    }
    if (length === undefined) {
      length = bytes.length;
    }
    const lengthMinusBlock = length - this.blockSize;
    let n = 0;
    // Using local instead of member variables gives ~5% speedup on Firefox 16.
    const buf = this.buf_;
    let inbuf = this.inbuf_;
    // The outer while loop should execute at most twice.
    while (n < length) {
      // When we have no data in the block to top up, we can directly process the
      // input buffer (assuming it contains sufficient data). This gives ~25%
      // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
      // the data is provided in large chunks (or in multiples of 64 bytes).
      if (inbuf === 0) {
        while (n <= lengthMinusBlock) {
          this.compress_(bytes, n);
          n += this.blockSize;
        }
      }
      if (typeof bytes === 'string') {
        while (n < length) {
          buf[inbuf] = bytes.charCodeAt(n);
          ++inbuf;
          ++n;
          if (inbuf === this.blockSize) {
            this.compress_(buf);
            inbuf = 0;
            // Jump to the outer loop so we use the full-block optimization.
            break;
          }
        }
      } else {
        while (n < length) {
          buf[inbuf] = bytes[n];
          ++inbuf;
          ++n;
          if (inbuf === this.blockSize) {
            this.compress_(buf);
            inbuf = 0;
            // Jump to the outer loop so we use the full-block optimization.
            break;
          }
        }
      }
    }
    this.inbuf_ = inbuf;
    this.total_ += length;
  }
  /** @override */
  digest() {
    const digest = [];
    let totalBits = this.total_ * 8;
    // Add pad 0x80 0x00*.
    if (this.inbuf_ < 56) {
      this.update(this.pad_, 56 - this.inbuf_);
    } else {
      this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
    }
    // Add # bits.
    for (let i = this.blockSize - 1; i >= 56; i--) {
      this.buf_[i] = totalBits & 255;
      totalBits /= 256; // Don't use bit-shifting here!
    }
    this.compress_(this.buf_);
    let n = 0;
    for (let i = 0; i < 5; i++) {
      for (let j = 24; j >= 0; j -= 8) {
        digest[n] = this.chain_[i] >> j & 255;
        ++n;
      }
    }
    return digest;
  }
}

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
  const proxy = new ObserverProxy(executor, onNoObservers);
  return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
class ObserverProxy {
  /**
   * @param executor Function which can make calls to a single Observer
   *     as a proxy.
   * @param onNoObservers Callback when count of Observers goes to zero.
   */
  constructor(executor, onNoObservers) {
    this.observers = [];
    this.unsubscribes = [];
    this.observerCount = 0;
    // Micro-task scheduling by calling task.then().
    this.task = Promise.resolve();
    this.finalized = false;
    this.onNoObservers = onNoObservers;
    // Call the executor asynchronously so subscribers that are called
    // synchronously after the creation of the subscribe function
    // can still receive the very first value generated in the executor.
    this.task.then(() => {
      executor(this);
    }).catch(e => {
      this.error(e);
    });
  }
  next(value) {
    this.forEachObserver(observer => {
      observer.next(value);
    });
  }
  error(error) {
    this.forEachObserver(observer => {
      observer.error(error);
    });
    this.close(error);
  }
  complete() {
    this.forEachObserver(observer => {
      observer.complete();
    });
    this.close();
  }
  /**
   * Subscribe function that can be used to add an Observer to the fan-out list.
   *
   * - We require that no event is sent to a subscriber synchronously to their
   *   call to subscribe().
   */
  subscribe(nextOrObserver, error, complete) {
    let observer;
    if (nextOrObserver === undefined && error === undefined && complete === undefined) {
      throw new Error('Missing Observer.');
    }
    // Assemble an Observer object when passed as callback functions.
    if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
      observer = nextOrObserver;
    } else {
      observer = {
        next: nextOrObserver,
        error,
        complete
      };
    }
    if (observer.next === undefined) {
      observer.next = noop;
    }
    if (observer.error === undefined) {
      observer.error = noop;
    }
    if (observer.complete === undefined) {
      observer.complete = noop;
    }
    const unsub = this.unsubscribeOne.bind(this, this.observers.length);
    // Attempt to subscribe to a terminated Observable - we
    // just respond to the Observer with the final error or complete
    // event.
    if (this.finalized) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.task.then(() => {
        try {
          if (this.finalError) {
            observer.error(this.finalError);
          } else {
            observer.complete();
          }
        } catch (e) {
          // nothing
        }
        return;
      });
    }
    this.observers.push(observer);
    return unsub;
  }
  // Unsubscribe is synchronous - we guarantee that no events are sent to
  // any unsubscribed Observer.
  unsubscribeOne(i) {
    if (this.observers === undefined || this.observers[i] === undefined) {
      return;
    }
    delete this.observers[i];
    this.observerCount -= 1;
    if (this.observerCount === 0 && this.onNoObservers !== undefined) {
      this.onNoObservers(this);
    }
  }
  forEachObserver(fn) {
    if (this.finalized) {
      // Already closed by previous event....just eat the additional values.
      return;
    }
    // Since sendOne calls asynchronously - there is no chance that
    // this.observers will become undefined.
    for (let i = 0; i < this.observers.length; i++) {
      this.sendOne(i, fn);
    }
  }
  // Call the Observer via one of it's callback function. We are careful to
  // confirm that the observe has not been unsubscribed since this asynchronous
  // function had been queued.
  sendOne(i, fn) {
    // Execute the callback asynchronously
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.task.then(() => {
      if (this.observers !== undefined && this.observers[i] !== undefined) {
        try {
          fn(this.observers[i]);
        } catch (e) {
          // Ignore exceptions raised in Observers or missing methods of an
          // Observer.
          // Log error to console. b/31404806
          if (typeof console !== 'undefined' && console.error) {
            console.error(e);
          }
        }
      }
    });
  }
  close(err) {
    if (this.finalized) {
      return;
    }
    this.finalized = true;
    if (err !== undefined) {
      this.finalError = err;
    }
    // Proxy is no longer needed - garbage collect references
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.task.then(() => {
      this.observers = undefined;
      this.onNoObservers = undefined;
    });
  }
}
/** Turn synchronous function into one called asynchronously. */
// eslint-disable-next-line @typescript-eslint/ban-types
function index_esm2017_async(fn, onError) {
  return (...args) => {
    Promise.resolve(true).then(() => {
      fn(...args);
    }).catch(error => {
      if (onError) {
        onError(error);
      }
    });
  };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
  if (typeof obj !== 'object' || obj === null) {
    return false;
  }
  for (const method of methods) {
    if (method in obj && typeof obj[method] === 'function') {
      return true;
    }
  }
  return false;
}
function noop() {
  // do nothing
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */
const validateArgCount = function (fnName, minCount, maxCount, argCount) {
  let argError;
  if (argCount < minCount) {
    argError = 'at least ' + minCount;
  } else if (argCount > maxCount) {
    argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
  }
  if (argError) {
    const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
    throw new Error(error);
  }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argName) {
  return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */
function validateNamespace(fnName, namespace, optional) {
  if (optional && !namespace) {
    return;
  }
  if (typeof namespace !== 'string') {
    //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error(errorPrefix(fnName, 'namespace') + 'must be a valid firebase namespace.');
  }
}
function validateCallback(fnName, argumentName,
// eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
  if (optional && !callback) {
    return;
  }
  if (typeof callback !== 'function') {
    throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid function.');
  }
}
function validateContextObject(fnName, argumentName, context, optional) {
  if (optional && !context) {
    return;
  }
  if (typeof context !== 'object' || context === null) {
    throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid context object.');
  }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
const stringToByteArray = function (str) {
  const out = [];
  let p = 0;
  for (let i = 0; i < str.length; i++) {
    let c = str.charCodeAt(i);
    // Is this the lead surrogate in a surrogate pair?
    if (c >= 0xd800 && c <= 0xdbff) {
      const high = c - 0xd800; // the high 10 bits.
      i++;
      assert(i < str.length, 'Surrogate pair missing trail surrogate.');
      const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
      c = 0x10000 + (high << 10) + low;
    }
    if (c < 128) {
      out[p++] = c;
    } else if (c < 2048) {
      out[p++] = c >> 6 | 192;
      out[p++] = c & 63 | 128;
    } else if (c < 65536) {
      out[p++] = c >> 12 | 224;
      out[p++] = c >> 6 & 63 | 128;
      out[p++] = c & 63 | 128;
    } else {
      out[p++] = c >> 18 | 240;
      out[p++] = c >> 12 & 63 | 128;
      out[p++] = c >> 6 & 63 | 128;
      out[p++] = c & 63 | 128;
    }
  }
  return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
const stringLength = function (str) {
  let p = 0;
  for (let i = 0; i < str.length; i++) {
    const c = str.charCodeAt(i);
    if (c < 128) {
      p++;
    } else if (c < 2048) {
      p += 2;
    } else if (c >= 0xd800 && c <= 0xdbff) {
      // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
      p += 4;
      i++; // skip trail surrogate.
    } else {
      p += 3;
    }
  }
  return p;
};

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */
const uuidv4 = function () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0,
      v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The amount of milliseconds to exponentially increase.
 */
const DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */
const DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */
const MAX_VALUE_MILLIS = (/* unused pure expression or super */ null && (4 * 60 * 60 * 1000)); // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */
const RANDOM_FACTOR = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */
function calculateBackoffMillis(backoffCount, intervalMillis = DEFAULT_INTERVAL_MILLIS, backoffFactor = DEFAULT_BACKOFF_FACTOR) {
  // Calculates an exponentially increasing value.
  // Deviation: calculates value from count and a constant interval, so we only need to save value
  // and count to restore state.
  const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
  // A random "fuzz" to avoid waves of retries.
  // Deviation: randomFactor is required.
  const randomWait = Math.round(
  // A fraction of the backoff value to add/subtract.
  // Deviation: changes multiplication order to improve readability.
  RANDOM_FACTOR * currBaseValue * (
  // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
  // if we add or subtract.
  Math.random() - 0.5) * 2);
  // Limits backoff to max to avoid effectively permanent backoff.
  return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provide English ordinal letters after a number
 */
function ordinal(i) {
  if (!Number.isFinite(i)) {
    return `${i}`;
  }
  return i + indicator(i);
}
function indicator(i) {
  i = Math.abs(i);
  const cent = i % 100;
  if (cent >= 10 && cent <= 20) {
    return 'th';
  }
  const dec = i % 10;
  if (dec === 1) {
    return 'st';
  }
  if (dec === 2) {
    return 'nd';
  }
  if (dec === 3) {
    return 'rd';
  }
  return 'th';
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function index_esm2017_getModularInstance(service) {
  if (service && service._delegate) {
    return service._delegate;
  } else {
    return service;
  }
}

;// CONCATENATED MODULE: ./node_modules/@firebase/component/dist/esm/index.esm2017.js


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */
class Component {
  /**
   *
   * @param name The public service name, e.g. app, auth, firestore, database
   * @param instanceFactory Service factory responsible for creating the public interface
   * @param type whether the service provided by the component is public or private
   */
  constructor(name, instanceFactory, type) {
    this.name = name;
    this.instanceFactory = instanceFactory;
    this.type = type;
    this.multipleInstances = false;
    /**
     * Properties to be added to the service namespace
     */
    this.serviceProps = {};
    this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */;
    this.onInstanceCreated = null;
  }
  setInstantiationMode(mode) {
    this.instantiationMode = mode;
    return this;
  }
  setMultipleInstances(multipleInstances) {
    this.multipleInstances = multipleInstances;
    return this;
  }
  setServiceProps(props) {
    this.serviceProps = props;
    return this;
  }
  setInstanceCreatedCallback(callback) {
    this.onInstanceCreated = callback;
    return this;
  }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ENTRY_NAME = '[DEFAULT]';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */
class Provider {
  constructor(name, container) {
    this.name = name;
    this.container = container;
    this.component = null;
    this.instances = new Map();
    this.instancesDeferred = new Map();
    this.instancesOptions = new Map();
    this.onInitCallbacks = new Map();
  }
  /**
   * @param identifier A provider can provide multiple instances of a service
   * if this.component.multipleInstances is true.
   */
  get(identifier) {
    // if multipleInstances is not supported, use the default name
    const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
    if (!this.instancesDeferred.has(normalizedIdentifier)) {
      const deferred = new Deferred();
      this.instancesDeferred.set(normalizedIdentifier, deferred);
      if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) {
        // initialize the service if it can be auto-initialized
        try {
          const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier
          });
          if (instance) {
            deferred.resolve(instance);
          }
        } catch (e) {
          // when the instance factory throws an exception during get(), it should not cause
          // a fatal error. We just return the unresolved promise in this case.
        }
      }
    }
    return this.instancesDeferred.get(normalizedIdentifier).promise;
  }
  getImmediate(options) {
    var _a;
    // if multipleInstances is not supported, use the default name
    const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
    const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
    if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) {
      try {
        return this.getOrInitializeService({
          instanceIdentifier: normalizedIdentifier
        });
      } catch (e) {
        if (optional) {
          return null;
        } else {
          throw e;
        }
      }
    } else {
      // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
      if (optional) {
        return null;
      } else {
        throw Error(`Service ${this.name} is not available`);
      }
    }
  }
  getComponent() {
    return this.component;
  }
  setComponent(component) {
    if (component.name !== this.name) {
      throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
    }
    if (this.component) {
      throw Error(`Component for ${this.name} has already been provided`);
    }
    this.component = component;
    // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
    if (!this.shouldAutoInitialize()) {
      return;
    }
    // if the service is eager, initialize the default instance
    if (isComponentEager(component)) {
      try {
        this.getOrInitializeService({
          instanceIdentifier: DEFAULT_ENTRY_NAME
        });
      } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
      }
    }
    // Create service instances for the pending promises and resolve them
    // NOTE: if this.multipleInstances is false, only the default instance will be created
    // and all promises with resolve with it regardless of the identifier.
    for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()) {
      const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
      try {
        // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
        const instance = this.getOrInitializeService({
          instanceIdentifier: normalizedIdentifier
        });
        instanceDeferred.resolve(instance);
      } catch (e) {
        // when the instance factory throws an exception, it should not cause
        // a fatal error. We just leave the promise unresolved.
      }
    }
  }
  clearInstance(identifier = DEFAULT_ENTRY_NAME) {
    this.instancesDeferred.delete(identifier);
    this.instancesOptions.delete(identifier);
    this.instances.delete(identifier);
  }
  // app.delete() will call this method on every provider to delete the services
  // TODO: should we mark the provider as deleted?
  async delete() {
    const services = Array.from(this.instances.values());
    await Promise.all([...services.filter(service => 'INTERNAL' in service) // legacy services
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(service => service.INTERNAL.delete()), ...services.filter(service => '_delete' in service) // modularized services
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(service => service._delete())]);
  }
  isComponentSet() {
    return this.component != null;
  }
  isInitialized(identifier = DEFAULT_ENTRY_NAME) {
    return this.instances.has(identifier);
  }
  getOptions(identifier = DEFAULT_ENTRY_NAME) {
    return this.instancesOptions.get(identifier) || {};
  }
  initialize(opts = {}) {
    const {
      options = {}
    } = opts;
    const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
    if (this.isInitialized(normalizedIdentifier)) {
      throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
    }
    if (!this.isComponentSet()) {
      throw Error(`Component ${this.name} has not been registered yet`);
    }
    const instance = this.getOrInitializeService({
      instanceIdentifier: normalizedIdentifier,
      options
    });
    // resolve any pending promise waiting for the service instance
    for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()) {
      const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
      if (normalizedIdentifier === normalizedDeferredIdentifier) {
        instanceDeferred.resolve(instance);
      }
    }
    return instance;
  }
  /**
   *
   * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
   * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
   *
   * @param identifier An optional instance identifier
   * @returns a function to unregister the callback
   */
  onInit(callback, identifier) {
    var _a;
    const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
    const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
    existingCallbacks.add(callback);
    this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
    const existingInstance = this.instances.get(normalizedIdentifier);
    if (existingInstance) {
      callback(existingInstance, normalizedIdentifier);
    }
    return () => {
      existingCallbacks.delete(callback);
    };
  }
  /**
   * Invoke onInit callbacks synchronously
   * @param instance the service instance`
   */
  invokeOnInitCallbacks(instance, identifier) {
    const callbacks = this.onInitCallbacks.get(identifier);
    if (!callbacks) {
      return;
    }
    for (const callback of callbacks) {
      try {
        callback(instance, identifier);
      } catch (_a) {
        // ignore errors in the onInit callback
      }
    }
  }
  getOrInitializeService({
    instanceIdentifier,
    options = {}
  }) {
    let instance = this.instances.get(instanceIdentifier);
    if (!instance && this.component) {
      instance = this.component.instanceFactory(this.container, {
        instanceIdentifier: normalizeIdentifierForFactory(instanceIdentifier),
        options
      });
      this.instances.set(instanceIdentifier, instance);
      this.instancesOptions.set(instanceIdentifier, options);
      /**
       * Invoke onInit listeners.
       * Note this.component.onInstanceCreated is different, which is used by the component creator,
       * while onInit listeners are registered by consumers of the provider.
       */
      this.invokeOnInitCallbacks(instance, instanceIdentifier);
      /**
       * Order is important
       * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
       * makes `isInitialized()` return true.
       */
      if (this.component.onInstanceCreated) {
        try {
          this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
        } catch (_a) {
          // ignore errors in the onInstanceCreatedCallback
        }
      }
    }
    return instance || null;
  }
  normalizeInstanceIdentifier(identifier = DEFAULT_ENTRY_NAME) {
    if (this.component) {
      return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
    } else {
      return identifier; // assume multiple instances are supported before the component is provided.
    }
  }
  shouldAutoInitialize() {
    return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */;
  }
}
// undefined should be passed to the service factory for the default instance
function normalizeIdentifierForFactory(identifier) {
  return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function isComponentEager(component) {
  return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */
class ComponentContainer {
  constructor(name) {
    this.name = name;
    this.providers = new Map();
  }
  /**
   *
   * @param component Component being added
   * @param overwrite When a component with the same name has already been registered,
   * if overwrite is true: overwrite the existing component with the new component and create a new
   * provider with the new component. It can be useful in tests where you want to use different mocks
   * for different tests.
   * if overwrite is false: throw an exception
   */
  addComponent(component) {
    const provider = this.getProvider(component.name);
    if (provider.isComponentSet()) {
      throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
    }
    provider.setComponent(component);
  }
  addOrOverwriteComponent(component) {
    const provider = this.getProvider(component.name);
    if (provider.isComponentSet()) {
      // delete the existing provider from the container, so we can register the new component
      this.providers.delete(component.name);
    }
    this.addComponent(component);
  }
  /**
   * getProvider provides a type safe interface where it can only be called with a field name
   * present in NameServiceMapping interface.
   *
   * Firebase SDKs providing services should extend NameServiceMapping interface to register
   * themselves.
   */
  getProvider(name) {
    if (this.providers.has(name)) {
      return this.providers.get(name);
    }
    // create a Provider for a service that hasn't registered with Firebase
    const provider = new Provider(name, this);
    this.providers.set(name, provider);
    return provider;
  }
  getProviders() {
    return Array.from(this.providers.values());
  }
}

;// CONCATENATED MODULE: ./node_modules/@firebase/logger/dist/esm/index.esm2017.js
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A container for all of the Logger instances
 */
const instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
  LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
  LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
  LogLevel[LogLevel["INFO"] = 2] = "INFO";
  LogLevel[LogLevel["WARN"] = 3] = "WARN";
  LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
  LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
const levelStringToEnum = {
  'debug': LogLevel.DEBUG,
  'verbose': LogLevel.VERBOSE,
  'info': LogLevel.INFO,
  'warn': LogLevel.WARN,
  'error': LogLevel.ERROR,
  'silent': LogLevel.SILENT
};
/**
 * The default log level
 */
const defaultLogLevel = LogLevel.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */
const ConsoleMethod = {
  [LogLevel.DEBUG]: 'log',
  [LogLevel.VERBOSE]: 'log',
  [LogLevel.INFO]: 'info',
  [LogLevel.WARN]: 'warn',
  [LogLevel.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
const defaultLogHandler = (instance, logType, ...args) => {
  if (logType < instance.logLevel) {
    return;
  }
  const now = new Date().toISOString();
  const method = ConsoleMethod[logType];
  if (method) {
    console[method](`[${now}]  ${instance.name}:`, ...args);
  } else {
    throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
  }
};
class Logger {
  /**
   * Gives you an instance of a Logger to capture messages according to
   * Firebase's logging scheme.
   *
   * @param name The name that the logs will be associated with
   */
  constructor(name) {
    this.name = name;
    /**
     * The log level of the given Logger instance.
     */
    this._logLevel = defaultLogLevel;
    /**
     * The main (internal) log handler for the Logger instance.
     * Can be set to a new function in internal package code but not by user.
     */
    this._logHandler = defaultLogHandler;
    /**
     * The optional, additional, user-defined log handler for the Logger instance.
     */
    this._userLogHandler = null;
    /**
     * Capture the current instance for later use
     */
    instances.push(this);
  }
  get logLevel() {
    return this._logLevel;
  }
  set logLevel(val) {
    if (!(val in LogLevel)) {
      throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
    }
    this._logLevel = val;
  }
  // Workaround for setter/getter having to be the same type.
  setLogLevel(val) {
    this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
  }
  get logHandler() {
    return this._logHandler;
  }
  set logHandler(val) {
    if (typeof val !== 'function') {
      throw new TypeError('Value assigned to `logHandler` must be a function');
    }
    this._logHandler = val;
  }
  get userLogHandler() {
    return this._userLogHandler;
  }
  set userLogHandler(val) {
    this._userLogHandler = val;
  }
  /**
   * The functions below are all based on the `console` interface
   */
  debug(...args) {
    this._userLogHandler && this._userLogHandler(this, LogLevel.DEBUG, ...args);
    this._logHandler(this, LogLevel.DEBUG, ...args);
  }
  log(...args) {
    this._userLogHandler && this._userLogHandler(this, LogLevel.VERBOSE, ...args);
    this._logHandler(this, LogLevel.VERBOSE, ...args);
  }
  info(...args) {
    this._userLogHandler && this._userLogHandler(this, LogLevel.INFO, ...args);
    this._logHandler(this, LogLevel.INFO, ...args);
  }
  warn(...args) {
    this._userLogHandler && this._userLogHandler(this, LogLevel.WARN, ...args);
    this._logHandler(this, LogLevel.WARN, ...args);
  }
  error(...args) {
    this._userLogHandler && this._userLogHandler(this, LogLevel.ERROR, ...args);
    this._logHandler(this, LogLevel.ERROR, ...args);
  }
}
function setLogLevel(level) {
  instances.forEach(inst => {
    inst.setLogLevel(level);
  });
}
function setUserLogHandler(logCallback, options) {
  for (const instance of instances) {
    let customLogLevel = null;
    if (options && options.level) {
      customLogLevel = levelStringToEnum[options.level];
    }
    if (logCallback === null) {
      instance.userLogHandler = null;
    } else {
      instance.userLogHandler = (instance, level, ...args) => {
        const message = args.map(arg => {
          if (arg == null) {
            return null;
          } else if (typeof arg === 'string') {
            return arg;
          } else if (typeof arg === 'number' || typeof arg === 'boolean') {
            return arg.toString();
          } else if (arg instanceof Error) {
            return arg.message;
          } else {
            try {
              return JSON.stringify(arg);
            } catch (ignored) {
              return null;
            }
          }
        }).filter(arg => arg).join(' ');
        if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) {
          logCallback({
            level: LogLevel[level].toLowerCase(),
            message,
            args,
            type: instance.name
          });
        }
      };
    }
  }
}

;// CONCATENATED MODULE: ./node_modules/idb/build/wrap-idb-value.js
const instanceOfAny = (object, constructors) => constructors.some(c => object instanceof c);
let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
  return idbProxyableTypes || (idbProxyableTypes = [IDBDatabase, IDBObjectStore, IDBIndex, IDBCursor, IDBTransaction]);
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
  return cursorAdvanceMethods || (cursorAdvanceMethods = [IDBCursor.prototype.advance, IDBCursor.prototype.continue, IDBCursor.prototype.continuePrimaryKey]);
}
const cursorRequestMap = new WeakMap();
const transactionDoneMap = new WeakMap();
const transactionStoreNamesMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
  const promise = new Promise((resolve, reject) => {
    const unlisten = () => {
      request.removeEventListener('success', success);
      request.removeEventListener('error', error);
    };
    const success = () => {
      resolve(wrap(request.result));
      unlisten();
    };
    const error = () => {
      reject(request.error);
      unlisten();
    };
    request.addEventListener('success', success);
    request.addEventListener('error', error);
  });
  promise.then(value => {
    // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
    // (see wrapFunction).
    if (value instanceof IDBCursor) {
      cursorRequestMap.set(value, request);
    }
    // Catching to avoid "Uncaught Promise exceptions"
  }).catch(() => {});
  // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
  // is because we create many promises from a single IDBRequest.
  reverseTransformCache.set(promise, request);
  return promise;
}
function cacheDonePromiseForTransaction(tx) {
  // Early bail if we've already created a done promise for this transaction.
  if (transactionDoneMap.has(tx)) return;
  const done = new Promise((resolve, reject) => {
    const unlisten = () => {
      tx.removeEventListener('complete', complete);
      tx.removeEventListener('error', error);
      tx.removeEventListener('abort', error);
    };
    const complete = () => {
      resolve();
      unlisten();
    };
    const error = () => {
      reject(tx.error || new DOMException('AbortError', 'AbortError'));
      unlisten();
    };
    tx.addEventListener('complete', complete);
    tx.addEventListener('error', error);
    tx.addEventListener('abort', error);
  });
  // Cache it for later retrieval.
  transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
  get(target, prop, receiver) {
    if (target instanceof IDBTransaction) {
      // Special handling for transaction.done.
      if (prop === 'done') return transactionDoneMap.get(target);
      // Polyfill for objectStoreNames because of Edge.
      if (prop === 'objectStoreNames') {
        return target.objectStoreNames || transactionStoreNamesMap.get(target);
      }
      // Make tx.store return the only store in the transaction, or undefined if there are many.
      if (prop === 'store') {
        return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
      }
    }
    // Else transform whatever we get back.
    return wrap(target[prop]);
  },
  set(target, prop, value) {
    target[prop] = value;
    return true;
  },
  has(target, prop) {
    if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) {
      return true;
    }
    return prop in target;
  }
};
function replaceTraps(callback) {
  idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
  // Due to expected object equality (which is enforced by the caching in `wrap`), we
  // only create one new func per func.
  // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
  if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) {
    return function (storeNames, ...args) {
      const tx = func.call(unwrap(this), storeNames, ...args);
      transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [storeNames]);
      return wrap(tx);
    };
  }
  // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
  // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
  // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
  // with real promises, so each advance methods returns a new promise for the cursor object, or
  // undefined if the end of the cursor has been reached.
  if (getCursorAdvanceMethods().includes(func)) {
    return function (...args) {
      // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
      // the original object.
      func.apply(unwrap(this), args);
      return wrap(cursorRequestMap.get(this));
    };
  }
  return function (...args) {
    // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
    // the original object.
    return wrap(func.apply(unwrap(this), args));
  };
}
function transformCachableValue(value) {
  if (typeof value === 'function') return wrapFunction(value);
  // This doesn't return, it just creates a 'done' promise for the transaction,
  // which is later returned for transaction.done (see idbObjectHandler).
  if (value instanceof IDBTransaction) cacheDonePromiseForTransaction(value);
  if (instanceOfAny(value, getIdbProxyableTypes())) return new Proxy(value, idbProxyTraps);
  // Return the same value back if we're not going to transform it.
  return value;
}
function wrap(value) {
  // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
  // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
  if (value instanceof IDBRequest) return promisifyRequest(value);
  // If we've already transformed this value before, reuse the transformed value.
  // This is faster, but it also provides object equality.
  if (transformCache.has(value)) return transformCache.get(value);
  const newValue = transformCachableValue(value);
  // Not all types are transformed.
  // These may be primitive types, so they can't be WeakMap keys.
  if (newValue !== value) {
    transformCache.set(value, newValue);
    reverseTransformCache.set(newValue, value);
  }
  return newValue;
}
const unwrap = value => reverseTransformCache.get(value);

;// CONCATENATED MODULE: ./node_modules/idb/build/index.js



/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */
function openDB(name, version, {
  blocked,
  upgrade,
  blocking,
  terminated
} = {}) {
  const request = indexedDB.open(name, version);
  const openPromise = wrap(request);
  if (upgrade) {
    request.addEventListener('upgradeneeded', event => {
      upgrade(wrap(request.result), event.oldVersion, event.newVersion, wrap(request.transaction), event);
    });
  }
  if (blocked) {
    request.addEventListener('blocked', event => blocked(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    event.oldVersion, event.newVersion, event));
  }
  openPromise.then(db => {
    if (terminated) db.addEventListener('close', () => terminated());
    if (blocking) {
      db.addEventListener('versionchange', event => blocking(event.oldVersion, event.newVersion, event));
    }
  }).catch(() => {});
  return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */
function deleteDB(name, {
  blocked
} = {}) {
  const request = indexedDB.deleteDatabase(name);
  if (blocked) {
    request.addEventListener('blocked', event => blocked(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    event.oldVersion, event));
  }
  return wrap(request).then(() => undefined);
}
const readMethods = ['get', 'getKey', 'getAll', 'getAllKeys', 'count'];
const writeMethods = ['put', 'add', 'delete', 'clear'];
const cachedMethods = new Map();
function getMethod(target, prop) {
  if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) {
    return;
  }
  if (cachedMethods.get(prop)) return cachedMethods.get(prop);
  const targetFuncName = prop.replace(/FromIndex$/, '');
  const useIndex = prop !== targetFuncName;
  const isWrite = writeMethods.includes(targetFuncName);
  if (
  // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
  !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || readMethods.includes(targetFuncName))) {
    return;
  }
  const method = async function (storeName, ...args) {
    // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
    const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
    let target = tx.store;
    if (useIndex) target = target.index(args.shift());
    // Must reject if op rejects.
    // If it's a write operation, must reject if tx.done rejects.
    // Must reject with op rejection first.
    // Must resolve with op value.
    // Must handle both promises (no unhandled rejections)
    return (await Promise.all([target[targetFuncName](...args), isWrite && tx.done]))[0];
  };
  cachedMethods.set(prop, method);
  return method;
}
replaceTraps(oldTraps => ({
  ...oldTraps,
  get: (target, prop, receiver) => getMethod(target, prop) || oldTraps.get(target, prop, receiver),
  has: (target, prop) => !!getMethod(target, prop) || oldTraps.has(target, prop)
}));

;// CONCATENATED MODULE: ./node_modules/@firebase/app/dist/esm/index.esm2017.js






/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PlatformLoggerServiceImpl {
  constructor(container) {
    this.container = container;
  }
  // In initial implementation, this will be called by installations on
  // auth token refresh, and installations will send this string.
  getPlatformInfoString() {
    const providers = this.container.getProviders();
    // Loop through providers and get library/version pairs from any that are
    // version components.
    return providers.map(provider => {
      if (isVersionServiceProvider(provider)) {
        const service = provider.getImmediate();
        return `${service.library}/${service.version}`;
      } else {
        return null;
      }
    }).filter(logString => logString).join(' ');
  }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */
function isVersionServiceProvider(provider) {
  const component = provider.getComponent();
  return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */;
}
const name$q = "@firebase/app";
const version$1 = "0.10.13";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const logger = new Logger('@firebase/app');
const name$p = "@firebase/app-compat";
const name$o = "@firebase/analytics-compat";
const name$n = "@firebase/analytics";
const name$m = "@firebase/app-check-compat";
const name$l = "@firebase/app-check";
const name$k = "@firebase/auth";
const name$j = "@firebase/auth-compat";
const name$i = "@firebase/database";
const name$h = "@firebase/data-connect";
const name$g = "@firebase/database-compat";
const name$f = "@firebase/functions";
const name$e = "@firebase/functions-compat";
const name$d = "@firebase/installations";
const name$c = "@firebase/installations-compat";
const name$b = "@firebase/messaging";
const name$a = "@firebase/messaging-compat";
const name$9 = "@firebase/performance";
const name$8 = "@firebase/performance-compat";
const name$7 = "@firebase/remote-config";
const name$6 = "@firebase/remote-config-compat";
const name$5 = "@firebase/storage";
const name$4 = "@firebase/storage-compat";
const name$3 = "@firebase/firestore";
const name$2 = "@firebase/vertexai-preview";
const name$1 = "@firebase/firestore-compat";
const index_esm2017_name = "firebase";
const version = "10.14.1";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The default app name
 *
 * @internal
 */
const index_esm2017_DEFAULT_ENTRY_NAME = '[DEFAULT]';
const PLATFORM_LOG_STRING = {
  [name$q]: 'fire-core',
  [name$p]: 'fire-core-compat',
  [name$n]: 'fire-analytics',
  [name$o]: 'fire-analytics-compat',
  [name$l]: 'fire-app-check',
  [name$m]: 'fire-app-check-compat',
  [name$k]: 'fire-auth',
  [name$j]: 'fire-auth-compat',
  [name$i]: 'fire-rtdb',
  [name$h]: 'fire-data-connect',
  [name$g]: 'fire-rtdb-compat',
  [name$f]: 'fire-fn',
  [name$e]: 'fire-fn-compat',
  [name$d]: 'fire-iid',
  [name$c]: 'fire-iid-compat',
  [name$b]: 'fire-fcm',
  [name$a]: 'fire-fcm-compat',
  [name$9]: 'fire-perf',
  [name$8]: 'fire-perf-compat',
  [name$7]: 'fire-rc',
  [name$6]: 'fire-rc-compat',
  [name$5]: 'fire-gcs',
  [name$4]: 'fire-gcs-compat',
  [name$3]: 'fire-fst',
  [name$1]: 'fire-fst-compat',
  [name$2]: 'fire-vertex',
  'fire-js': 'fire-js',
  [index_esm2017_name]: 'fire-js-all'
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @internal
 */
const _apps = new Map();
/**
 * @internal
 */
const _serverApps = new Map();
/**
 * Registered components.
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _components = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */
function _addComponent(app, component) {
  try {
    app.container.addComponent(component);
  } catch (e) {
    logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
  }
}
/**
 *
 * @internal
 */
function _addOrOverwriteComponent(app, component) {
  app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */
function _registerComponent(component) {
  const componentName = component.name;
  if (_components.has(componentName)) {
    logger.debug(`There were multiple attempts to register component ${componentName}.`);
    return false;
  }
  _components.set(componentName, component);
  // add the component to existing app instances
  for (const app of _apps.values()) {
    _addComponent(app, component);
  }
  for (const serverApp of _serverApps.values()) {
    _addComponent(serverApp, component);
  }
  return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */
function index_esm2017_getProvider(app, name) {
  const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
    optional: true
  });
  if (heartbeatController) {
    void heartbeatController.triggerHeartbeat();
  }
  return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */
function _removeServiceInstance(app, name, instanceIdentifier = index_esm2017_DEFAULT_ENTRY_NAME) {
  index_esm2017_getProvider(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */
function _isFirebaseApp(obj) {
  return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */
function _isFirebaseServerApp(obj) {
  return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */
function _clearComponents() {
  _components.clear();
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERRORS = {
  ["no-app" /* AppError.NO_APP */]: "No Firebase App '{$appName}' has been created - " + 'call initializeApp() first',
  ["bad-app-name" /* AppError.BAD_APP_NAME */]: "Illegal App name: '{$appName}'",
  ["duplicate-app" /* AppError.DUPLICATE_APP */]: "Firebase App named '{$appName}' already exists with different options or config",
  ["app-deleted" /* AppError.APP_DELETED */]: "Firebase App named '{$appName}' already deleted",
  ["server-app-deleted" /* AppError.SERVER_APP_DELETED */]: 'Firebase Server App has been deleted',
  ["no-options" /* AppError.NO_OPTIONS */]: 'Need to provide options, when not being deployed to hosting via source.',
  ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */]: 'firebase.{$appName}() takes either no argument or a ' + 'Firebase App instance.',
  ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */]: 'First argument to `onLog` must be null or a function.',
  ["idb-open" /* AppError.IDB_OPEN */]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
  ["idb-get" /* AppError.IDB_GET */]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
  ["idb-set" /* AppError.IDB_WRITE */]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
  ["idb-delete" /* AppError.IDB_DELETE */]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
  ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
  ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */]: 'FirebaseServerApp is not for use in browser environments.'
};
const ERROR_FACTORY = new ErrorFactory('app', 'Firebase', ERRORS);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FirebaseAppImpl {
  constructor(options, config, container) {
    this._isDeleted = false;
    this._options = Object.assign({}, options);
    this._config = Object.assign({}, config);
    this._name = config.name;
    this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
    this._container = container;
    this.container.addComponent(new Component('app', () => this, "PUBLIC" /* ComponentType.PUBLIC */));
  }
  get automaticDataCollectionEnabled() {
    this.checkDestroyed();
    return this._automaticDataCollectionEnabled;
  }
  set automaticDataCollectionEnabled(val) {
    this.checkDestroyed();
    this._automaticDataCollectionEnabled = val;
  }
  get name() {
    this.checkDestroyed();
    return this._name;
  }
  get options() {
    this.checkDestroyed();
    return this._options;
  }
  get config() {
    this.checkDestroyed();
    return this._config;
  }
  get container() {
    return this._container;
  }
  get isDeleted() {
    return this._isDeleted;
  }
  set isDeleted(val) {
    this._isDeleted = val;
  }
  /**
   * This function will throw an Error if the App has already been deleted -
   * use before performing API actions on the App.
   */
  checkDestroyed() {
    if (this.isDeleted) {
      throw ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */, {
        appName: this._name
      });
    }
  }
}

/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FirebaseServerAppImpl extends FirebaseAppImpl {
  constructor(options, serverConfig, name, container) {
    // Build configuration parameters for the FirebaseAppImpl base class.
    const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : false;
    // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
    const config = {
      name,
      automaticDataCollectionEnabled
    };
    if (options.apiKey !== undefined) {
      // Construct the parent FirebaseAppImp object.
      super(options, config, container);
    } else {
      const appImpl = options;
      super(appImpl.options, config, container);
    }
    // Now construct the data for the FirebaseServerAppImpl.
    this._serverConfig = Object.assign({
      automaticDataCollectionEnabled
    }, serverConfig);
    this._finalizationRegistry = null;
    if (typeof FinalizationRegistry !== 'undefined') {
      this._finalizationRegistry = new FinalizationRegistry(() => {
        this.automaticCleanup();
      });
    }
    this._refCount = 0;
    this.incRefCount(this._serverConfig.releaseOnDeref);
    // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
    // will never trigger.
    this._serverConfig.releaseOnDeref = undefined;
    serverConfig.releaseOnDeref = undefined;
    registerVersion(name$q, version$1, 'serverapp');
  }
  toJSON() {
    return undefined;
  }
  get refCount() {
    return this._refCount;
  }
  // Increment the reference count of this server app. If an object is provided, register it
  // with the finalization registry.
  incRefCount(obj) {
    if (this.isDeleted) {
      return;
    }
    this._refCount++;
    if (obj !== undefined && this._finalizationRegistry !== null) {
      this._finalizationRegistry.register(obj, this);
    }
  }
  // Decrement the reference count.
  decRefCount() {
    if (this.isDeleted) {
      return 0;
    }
    return --this._refCount;
  }
  // Invoked by the FinalizationRegistry callback to note that this app should go through its
  // reference counts and delete itself if no reference count remain. The coordinating logic that
  // handles this is in deleteApp(...).
  automaticCleanup() {
    void deleteApp(this);
  }
  get settings() {
    this.checkDestroyed();
    return this._serverConfig;
  }
  /**
   * This function will throw an Error if the App has already been deleted -
   * use before performing API actions on the App.
   */
  checkDestroyed() {
    if (this.isDeleted) {
      throw ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */);
    }
  }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The current SDK version.
 *
 * @public
 */
const SDK_VERSION = version;
function initializeApp(_options, rawConfig = {}) {
  let options = _options;
  if (typeof rawConfig !== 'object') {
    const name = rawConfig;
    rawConfig = {
      name
    };
  }
  const config = Object.assign({
    name: index_esm2017_DEFAULT_ENTRY_NAME,
    automaticDataCollectionEnabled: false
  }, rawConfig);
  const name = config.name;
  if (typeof name !== 'string' || !name) {
    throw ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */, {
      appName: String(name)
    });
  }
  options || (options = getDefaultAppConfig());
  if (!options) {
    throw ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */);
  }
  const existingApp = _apps.get(name);
  if (existingApp) {
    // return the existing app if options and config deep equal the ones in the existing app.
    if (deepEqual(options, existingApp.options) && deepEqual(config, existingApp.config)) {
      return existingApp;
    } else {
      throw ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */, {
        appName: name
      });
    }
  }
  const container = new ComponentContainer(name);
  for (const component of _components.values()) {
    container.addComponent(component);
  }
  const newApp = new FirebaseAppImpl(options, config, container);
  _apps.set(name, newApp);
  return newApp;
}
function initializeServerApp(_options, _serverAppConfig) {
  if (isBrowser() && !isWebWorker()) {
    // FirebaseServerApp isn't designed to be run in browsers.
    throw ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */);
  }
  if (_serverAppConfig.automaticDataCollectionEnabled === undefined) {
    _serverAppConfig.automaticDataCollectionEnabled = false;
  }
  let appOptions;
  if (_isFirebaseApp(_options)) {
    appOptions = _options.options;
  } else {
    appOptions = _options;
  }
  // Build an app name based on a hash of the configuration options.
  const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
  // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
  // construction of FirebaseServerApp instances. For example, if the object is the request headers.
  if (nameObj.releaseOnDeref !== undefined) {
    delete nameObj.releaseOnDeref;
  }
  const hashCode = s => {
    return [...s].reduce((hash, c) => Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
  };
  if (_serverAppConfig.releaseOnDeref !== undefined) {
    if (typeof FinalizationRegistry === 'undefined') {
      throw ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */, {});
    }
  }
  const nameString = '' + hashCode(JSON.stringify(nameObj));
  const existingApp = _serverApps.get(nameString);
  if (existingApp) {
    existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
    return existingApp;
  }
  const container = new ComponentContainer(nameString);
  for (const component of _components.values()) {
    container.addComponent(component);
  }
  const newApp = new FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
  _serverApps.set(nameString, newApp);
  return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */
function index_esm2017_getApp(name = index_esm2017_DEFAULT_ENTRY_NAME) {
  const app = _apps.get(name);
  if (!app && name === index_esm2017_DEFAULT_ENTRY_NAME && getDefaultAppConfig()) {
    return initializeApp();
  }
  if (!app) {
    throw ERROR_FACTORY.create("no-app" /* AppError.NO_APP */, {
      appName: name
    });
  }
  return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */
function getApps() {
  return Array.from(_apps.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */
async function deleteApp(app) {
  let cleanupProviders = false;
  const name = app.name;
  if (_apps.has(name)) {
    cleanupProviders = true;
    _apps.delete(name);
  } else if (_serverApps.has(name)) {
    const firebaseServerApp = app;
    if (firebaseServerApp.decRefCount() <= 0) {
      _serverApps.delete(name);
      cleanupProviders = true;
    }
  }
  if (cleanupProviders) {
    await Promise.all(app.container.getProviders().map(provider => provider.delete()));
    app.isDeleted = true;
  }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */
function registerVersion(libraryKeyOrName, version, variant) {
  var _a;
  // TODO: We can use this check to whitelist strings when/if we set up
  // a good whitelist system.
  let library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
  if (variant) {
    library += `-${variant}`;
  }
  const libraryMismatch = library.match(/\s|\//);
  const versionMismatch = version.match(/\s|\//);
  if (libraryMismatch || versionMismatch) {
    const warning = [`Unable to register library "${library}" with version "${version}":`];
    if (libraryMismatch) {
      warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
    }
    if (libraryMismatch && versionMismatch) {
      warning.push('and');
    }
    if (versionMismatch) {
      warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
    }
    logger.warn(warning.join(' '));
    return;
  }
  _registerComponent(new Component(`${library}-version`, () => ({
    library,
    version
  }), "VERSION" /* ComponentType.VERSION */));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */
function onLog(logCallback, options) {
  if (logCallback !== null && typeof logCallback !== 'function') {
    throw ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */);
  }
  setUserLogHandler(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */
function index_esm2017_setLogLevel(logLevel) {
  setLogLevel(logLevel);
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DB_NAME = 'firebase-heartbeat-database';
const DB_VERSION = 1;
const STORE_NAME = 'firebase-heartbeat-store';
let dbPromise = null;
function getDbPromise() {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade: (db, oldVersion) => {
        // We don't use 'break' in this switch statement, the fall-through
        // behavior is what we want, because if there are multiple versions between
        // the old version and the current version, we want ALL the migrations
        // that correspond to those versions to run, not only the last one.
        // eslint-disable-next-line default-case
        switch (oldVersion) {
          case 0:
            try {
              db.createObjectStore(STORE_NAME);
            } catch (e) {
              // Safari/iOS browsers throw occasional exceptions on
              // db.createObjectStore() that may be a bug. Avoid blocking
              // the rest of the app functionality.
              console.warn(e);
            }
        }
      }
    }).catch(e => {
      throw ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */, {
        originalErrorMessage: e.message
      });
    });
  }
  return dbPromise;
}
async function readHeartbeatsFromIndexedDB(app) {
  try {
    const db = await getDbPromise();
    const tx = db.transaction(STORE_NAME);
    const result = await tx.objectStore(STORE_NAME).get(computeKey(app));
    // We already have the value but tx.done can throw,
    // so we need to await it here to catch errors
    await tx.done;
    return result;
  } catch (e) {
    if (e instanceof FirebaseError) {
      logger.warn(e.message);
    } else {
      const idbGetError = ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */, {
        originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
      });
      logger.warn(idbGetError.message);
    }
  }
}
async function writeHeartbeatsToIndexedDB(app, heartbeatObject) {
  try {
    const db = await getDbPromise();
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const objectStore = tx.objectStore(STORE_NAME);
    await objectStore.put(heartbeatObject, computeKey(app));
    await tx.done;
  } catch (e) {
    if (e instanceof FirebaseError) {
      logger.warn(e.message);
    } else {
      const idbGetError = ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */, {
        originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
      });
      logger.warn(idbGetError.message);
    }
  }
}
function computeKey(app) {
  return `${app.name}!${app.options.appId}`;
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const MAX_HEADER_BYTES = 1024;
// 30 days
const STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 30 * 24 * 60 * 60 * 1000;
class HeartbeatServiceImpl {
  constructor(container) {
    this.container = container;
    /**
     * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
     * the header string.
     * Stores one record per date. This will be consolidated into the standard
     * format of one record per user agent string before being sent as a header.
     * Populated from indexedDB when the controller is instantiated and should
     * be kept in sync with indexedDB.
     * Leave public for easier testing.
     */
    this._heartbeatsCache = null;
    const app = this.container.getProvider('app').getImmediate();
    this._storage = new HeartbeatStorageImpl(app);
    this._heartbeatsCachePromise = this._storage.read().then(result => {
      this._heartbeatsCache = result;
      return result;
    });
  }
  /**
   * Called to report a heartbeat. The function will generate
   * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
   * to IndexedDB.
   * Note that we only store one heartbeat per day. So if a heartbeat for today is
   * already logged, subsequent calls to this function in the same day will be ignored.
   */
  async triggerHeartbeat() {
    var _a, _b;
    try {
      const platformLogger = this.container.getProvider('platform-logger').getImmediate();
      // This is the "Firebase user agent" string from the platform logger
      // service, not the browser user agent.
      const agent = platformLogger.getPlatformInfoString();
      const date = getUTCDateString();
      if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
        this._heartbeatsCache = await this._heartbeatsCachePromise;
        // If we failed to construct a heartbeats cache, then return immediately.
        if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) {
          return;
        }
      }
      // Do not store a heartbeat if one is already stored for this day
      // or if a header has already been sent today.
      if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some(singleDateHeartbeat => singleDateHeartbeat.date === date)) {
        return;
      } else {
        // There is no entry for this date. Create one.
        this._heartbeatsCache.heartbeats.push({
          date,
          agent
        });
      }
      // Remove entries older than 30 days.
      this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter(singleDateHeartbeat => {
        const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
        const now = Date.now();
        return now - hbTimestamp <= STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
      });
      return this._storage.overwrite(this._heartbeatsCache);
    } catch (e) {
      logger.warn(e);
    }
  }
  /**
   * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
   * It also clears all heartbeats from memory as well as in IndexedDB.
   *
   * NOTE: Consuming product SDKs should not send the header if this method
   * returns an empty string.
   */
  async getHeartbeatsHeader() {
    var _a;
    try {
      if (this._heartbeatsCache === null) {
        await this._heartbeatsCachePromise;
      }
      // If it's still null or the array is empty, there is no data to send.
      if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) {
        return '';
      }
      const date = getUTCDateString();
      // Extract as many heartbeats from the cache as will fit under the size limit.
      const {
        heartbeatsToSend,
        unsentEntries
      } = extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
      const headerString = base64urlEncodeWithoutPadding(JSON.stringify({
        version: 2,
        heartbeats: heartbeatsToSend
      }));
      // Store last sent date to prevent another being logged/sent for the same day.
      this._heartbeatsCache.lastSentHeartbeatDate = date;
      if (unsentEntries.length > 0) {
        // Store any unsent entries if they exist.
        this._heartbeatsCache.heartbeats = unsentEntries;
        // This seems more likely than emptying the array (below) to lead to some odd state
        // since the cache isn't empty and this will be called again on the next request,
        // and is probably safest if we await it.
        await this._storage.overwrite(this._heartbeatsCache);
      } else {
        this._heartbeatsCache.heartbeats = [];
        // Do not wait for this, to reduce latency.
        void this._storage.overwrite(this._heartbeatsCache);
      }
      return headerString;
    } catch (e) {
      logger.warn(e);
      return '';
    }
  }
}
function getUTCDateString() {
  const today = new Date();
  // Returns date format 'YYYY-MM-DD'
  return today.toISOString().substring(0, 10);
}
function extractHeartbeatsForHeader(heartbeatsCache, maxSize = MAX_HEADER_BYTES) {
  // Heartbeats grouped by user agent in the standard format to be sent in
  // the header.
  const heartbeatsToSend = [];
  // Single date format heartbeats that are not sent.
  let unsentEntries = heartbeatsCache.slice();
  for (const singleDateHeartbeat of heartbeatsCache) {
    // Look for an existing entry with the same user agent.
    const heartbeatEntry = heartbeatsToSend.find(hb => hb.agent === singleDateHeartbeat.agent);
    if (!heartbeatEntry) {
      // If no entry for this user agent exists, create one.
      heartbeatsToSend.push({
        agent: singleDateHeartbeat.agent,
        dates: [singleDateHeartbeat.date]
      });
      if (countBytes(heartbeatsToSend) > maxSize) {
        // If the header would exceed max size, remove the added heartbeat
        // entry and stop adding to the header.
        heartbeatsToSend.pop();
        break;
      }
    } else {
      heartbeatEntry.dates.push(singleDateHeartbeat.date);
      // If the header would exceed max size, remove the added date
      // and stop adding to the header.
      if (countBytes(heartbeatsToSend) > maxSize) {
        heartbeatEntry.dates.pop();
        break;
      }
    }
    // Pop unsent entry from queue. (Skipped if adding the entry exceeded
    // quota and the loop breaks early.)
    unsentEntries = unsentEntries.slice(1);
  }
  return {
    heartbeatsToSend,
    unsentEntries
  };
}
class HeartbeatStorageImpl {
  constructor(app) {
    this.app = app;
    this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
  }
  async runIndexedDBEnvironmentCheck() {
    if (!index_esm2017_isIndexedDBAvailable()) {
      return false;
    } else {
      return index_esm2017_validateIndexedDBOpenable().then(() => true).catch(() => false);
    }
  }
  /**
   * Read all heartbeats.
   */
  async read() {
    const canUseIndexedDB = await this._canUseIndexedDBPromise;
    if (!canUseIndexedDB) {
      return {
        heartbeats: []
      };
    } else {
      const idbHeartbeatObject = await readHeartbeatsFromIndexedDB(this.app);
      if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) {
        return idbHeartbeatObject;
      } else {
        return {
          heartbeats: []
        };
      }
    }
  }
  // overwrite the storage with the provided heartbeats
  async overwrite(heartbeatsObject) {
    var _a;
    const canUseIndexedDB = await this._canUseIndexedDBPromise;
    if (!canUseIndexedDB) {
      return;
    } else {
      const existingHeartbeatsObject = await this.read();
      return writeHeartbeatsToIndexedDB(this.app, {
        lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
        heartbeats: heartbeatsObject.heartbeats
      });
    }
  }
  // add heartbeats
  async add(heartbeatsObject) {
    var _a;
    const canUseIndexedDB = await this._canUseIndexedDBPromise;
    if (!canUseIndexedDB) {
      return;
    } else {
      const existingHeartbeatsObject = await this.read();
      return writeHeartbeatsToIndexedDB(this.app, {
        lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
        heartbeats: [...existingHeartbeatsObject.heartbeats, ...heartbeatsObject.heartbeats]
      });
    }
  }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */
function countBytes(heartbeatsCache) {
  // base64 has a restricted set of characters, all of which should be 1 byte.
  return base64urlEncodeWithoutPadding(
  // heartbeatsCache wrapper properties
  JSON.stringify({
    version: 2,
    heartbeats: heartbeatsCache
  })).length;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerCoreComponents(variant) {
  _registerComponent(new Component('platform-logger', container => new PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */));
  _registerComponent(new Component('heartbeat', container => new HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */));
  // Register `app` package.
  registerVersion(name$q, version$1, variant);
  // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
  registerVersion(name$q, version$1, 'esm2017');
  // Register platform SDK identifier (no version).
  registerVersion('fire-js', '');
}

/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */
registerCoreComponents('');

;// CONCATENATED MODULE: ./node_modules/@firebase/app-compat/dist/esm/index.esm2017.js






/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 *
 * marked as internal because it references internal types exported from @firebase/app
 * @internal
 */
class index_esm2017_FirebaseAppImpl {
  constructor(_delegate, firebase) {
    this._delegate = _delegate;
    this.firebase = firebase;
    // add itself to container
    _addComponent(_delegate, new Component('app-compat', () => this, "PUBLIC" /* ComponentType.PUBLIC */));
    this.container = _delegate.container;
  }
  get automaticDataCollectionEnabled() {
    return this._delegate.automaticDataCollectionEnabled;
  }
  set automaticDataCollectionEnabled(val) {
    this._delegate.automaticDataCollectionEnabled = val;
  }
  get name() {
    return this._delegate.name;
  }
  get options() {
    return this._delegate.options;
  }
  delete() {
    return new Promise(resolve => {
      this._delegate.checkDestroyed();
      resolve();
    }).then(() => {
      this.firebase.INTERNAL.removeApp(this.name);
      return deleteApp(this._delegate);
    });
  }
  /**
   * Return a service instance associated with this app (creating it
   * on demand), identified by the passed instanceIdentifier.
   *
   * NOTE: Currently storage and functions are the only ones that are leveraging this
   * functionality. They invoke it by calling:
   *
   * ```javascript
   * firebase.app().storage('STORAGE BUCKET ID')
   * ```
   *
   * The service name is passed to this already
   * @internal
   */
  _getService(name, instanceIdentifier = index_esm2017_DEFAULT_ENTRY_NAME) {
    var _a;
    this._delegate.checkDestroyed();
    // Initialize instance if InstantiationMode is `EXPLICIT`.
    const provider = this._delegate.container.getProvider(name);
    if (!provider.isInitialized() && ((_a = provider.getComponent()) === null || _a === void 0 ? void 0 : _a.instantiationMode) === "EXPLICIT" /* InstantiationMode.EXPLICIT */) {
      provider.initialize();
    }
    // getImmediate will always succeed because _getService is only called for registered components.
    return provider.getImmediate({
      identifier: instanceIdentifier
    });
  }
  /**
   * Remove a service instance from the cache, so we will create a new instance for this service
   * when people try to get it again.
   *
   * NOTE: currently only firestore uses this functionality to support firestore shutdown.
   *
   * @param name The service name
   * @param instanceIdentifier instance identifier in case multiple instances are allowed
   * @internal
   */
  _removeServiceInstance(name, instanceIdentifier = index_esm2017_DEFAULT_ENTRY_NAME) {
    this._delegate.container
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .getProvider(name).clearInstance(instanceIdentifier);
  }
  /**
   * @param component the component being added to this app's container
   * @internal
   */
  _addComponent(component) {
    _addComponent(this._delegate, component);
  }
  _addOrOverwriteComponent(component) {
    _addOrOverwriteComponent(this._delegate, component);
  }
  toJSON() {
    return {
      name: this.name,
      automaticDataCollectionEnabled: this.automaticDataCollectionEnabled,
      options: this.options
    };
  }
}
// TODO: investigate why the following needs to be commented out
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
// (FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
//   FirebaseAppImpl.prototype.delete ||
//   console.log('dc');

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const index_esm2017_ERRORS = {
  ["no-app" /* AppError.NO_APP */]: "No Firebase App '{$appName}' has been created - " + 'call Firebase App.initializeApp()',
  ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */]: 'firebase.{$appName}() takes either no argument or a ' + 'Firebase App instance.'
};
const index_esm2017_ERROR_FACTORY = new ErrorFactory('app-compat', 'Firebase', index_esm2017_ERRORS);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Because auth can't share code with other components, we attach the utility functions
 * in an internal namespace to share code.
 * This function return a firebase namespace object without
 * any utility functions, so it can be shared between the regular firebaseNamespace and
 * the lite version.
 */
function createFirebaseNamespaceCore(firebaseAppImpl) {
  const apps = {};
  // // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // const components = new Map<string, Component<any>>();
  // A namespace is a plain JavaScript Object.
  const namespace = {
    // Hack to prevent Babel from modifying the object returned
    // as the firebase namespace.
    // @ts-ignore
    __esModule: true,
    initializeApp: initializeAppCompat,
    // @ts-ignore
    app,
    registerVersion: registerVersion,
    setLogLevel: index_esm2017_setLogLevel,
    onLog: onLog,
    // @ts-ignore
    apps: null,
    SDK_VERSION: SDK_VERSION,
    INTERNAL: {
      registerComponent: registerComponentCompat,
      removeApp,
      useAsService,
      modularAPIs: app_dist_esm_index_esm2017_namespaceObject
    }
  };
  // Inject a circular default export to allow Babel users who were previously
  // using:
  //
  //   import firebase from 'firebase';
  //   which becomes: var firebase = require('firebase').default;
  //
  // instead of
  //
  //   import * as firebase from 'firebase';
  //   which becomes: var firebase = require('firebase');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  namespace['default'] = namespace;
  // firebase.apps is a read-only getter.
  Object.defineProperty(namespace, 'apps', {
    get: getApps
  });
  /**
   * Called by App.delete() - but before any services associated with the App
   * are deleted.
   */
  function removeApp(name) {
    delete apps[name];
  }
  /**
   * Get the App object for a given name (or DEFAULT).
   */
  function app(name) {
    name = name || index_esm2017_DEFAULT_ENTRY_NAME;
    if (!contains(apps, name)) {
      throw index_esm2017_ERROR_FACTORY.create("no-app" /* AppError.NO_APP */, {
        appName: name
      });
    }
    return apps[name];
  }
  // @ts-ignore
  app['App'] = firebaseAppImpl;
  /**
   * Create a new App instance (name must be unique).
   *
   * This function is idempotent. It can be called more than once and return the same instance using the same options and config.
   */
  function initializeAppCompat(options, rawConfig = {}) {
    const app = initializeApp(options, rawConfig);
    if (contains(apps, app.name)) {
      return apps[app.name];
    }
    const appCompat = new firebaseAppImpl(app, namespace);
    apps[app.name] = appCompat;
    return appCompat;
  }
  /*
   * Return an array of all the non-deleted FirebaseApps.
   */
  function getApps() {
    // Make a copy so caller cannot mutate the apps list.
    return Object.keys(apps).map(name => apps[name]);
  }
  function registerComponentCompat(component) {
    const componentName = component.name;
    const componentNameWithoutCompat = componentName.replace('-compat', '');
    if (_registerComponent(component) && component.type === "PUBLIC" /* ComponentType.PUBLIC */) {
      // create service namespace for public components
      // The Service namespace is an accessor function ...
      const serviceNamespace = (appArg = app()) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (typeof appArg[componentNameWithoutCompat] !== 'function') {
          // Invalid argument.
          // This happens in the following case: firebase.storage('gs:/')
          throw index_esm2017_ERROR_FACTORY.create("invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */, {
            appName: componentName
          });
        }
        // Forward service instance lookup to the FirebaseApp.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return appArg[componentNameWithoutCompat]();
      };
      // ... and a container for service-level properties.
      if (component.serviceProps !== undefined) {
        deepExtend(serviceNamespace, component.serviceProps);
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      namespace[componentNameWithoutCompat] = serviceNamespace;
      // Patch the FirebaseAppImpl prototype
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      firebaseAppImpl.prototype[componentNameWithoutCompat] =
      // TODO: The eslint disable can be removed and the 'ignoreRestArgs'
      // option added to the no-explicit-any rule when ESlint releases it.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      function (...args) {
        const serviceFxn = this._getService.bind(this, componentName);
        return serviceFxn.apply(this, component.multipleInstances ? args : []);
      };
    }
    return component.type === "PUBLIC" /* ComponentType.PUBLIC */ ?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    namespace[componentNameWithoutCompat] : null;
  }
  // Map the requested service to a registered service name
  // (used to map auth to serverAuth service when needed).
  function useAsService(app, name) {
    if (name === 'serverAuth') {
      return null;
    }
    const useService = name;
    return useService;
  }
  return namespace;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
  const namespace = createFirebaseNamespaceCore(index_esm2017_FirebaseAppImpl);
  namespace.INTERNAL = Object.assign(Object.assign({}, namespace.INTERNAL), {
    createFirebaseNamespace,
    extendNamespace,
    createSubscribe: createSubscribe,
    ErrorFactory: ErrorFactory,
    deepExtend: deepExtend
  });
  /**
   * Patch the top-level firebase namespace with additional properties.
   *
   * firebase.INTERNAL.extendNamespace()
   */
  function extendNamespace(props) {
    deepExtend(namespace, props);
  }
  return namespace;
}
const firebase$1 = createFirebaseNamespace();

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const index_esm2017_logger = new Logger('@firebase/app-compat');
const esm_index_esm2017_name = "@firebase/app-compat";
const index_esm2017_version = "0.2.43";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function index_esm2017_registerCoreComponents(variant) {
  // Register `app` package.
  registerVersion(esm_index_esm2017_name, index_esm2017_version, variant);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
try {
  const globals = getGlobal();
  // Firebase Lite detection
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (globals.firebase !== undefined) {
    index_esm2017_logger.warn(`
      Warning: Firebase is already defined in the global scope. Please make sure
      Firebase library is only loaded once.
    `);
    // eslint-disable-next-line
    const sdkVersion = globals.firebase.SDK_VERSION;
    if (sdkVersion && sdkVersion.indexOf('LITE') >= 0) {
      index_esm2017_logger.warn(`
        Warning: You are trying to load Firebase while using Firebase Performance standalone script.
        You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.
        `);
    }
  }
} catch (_a) {
  // ignore errors thrown by getGlobal
}
const firebase = firebase$1;
index_esm2017_registerCoreComponents();

;// CONCATENATED MODULE: ./node_modules/firebase/compat/app/dist/esm/index.esm.js


var index_esm_name = "firebase";
var index_esm_version = "10.14.1";

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
firebase.registerVersion(index_esm_name, index_esm_version, 'app-compat');
;// CONCATENATED MODULE: ./node_modules/@firebase/installations/dist/esm/index.esm2017.js




const dist_esm_index_esm2017_name = "@firebase/installations";
const esm_index_esm2017_version = "0.6.9";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const PENDING_TIMEOUT_MS = 10000;
const PACKAGE_VERSION = `w:${esm_index_esm2017_version}`;
const INTERNAL_AUTH_VERSION = 'FIS_v2';
const INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const TOKEN_EXPIRATION_BUFFER = 60 * 60 * 1000; // One hour
const SERVICE = 'installations';
const SERVICE_NAME = 'Installations';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERROR_DESCRIPTION_MAP = {
  ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */]: 'Missing App configuration value: "{$valueName}"',
  ["not-registered" /* ErrorCode.NOT_REGISTERED */]: 'Firebase Installation is not registered.',
  ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */]: 'Firebase Installation not found.',
  ["request-failed" /* ErrorCode.REQUEST_FAILED */]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
  ["app-offline" /* ErrorCode.APP_OFFLINE */]: 'Could not process request. Application offline.',
  ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */]: "Can't delete installation while there is a pending registration request."
};
const esm_index_esm2017_ERROR_FACTORY = new ErrorFactory(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */
function isServerError(error) {
  return error instanceof FirebaseError && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getInstallationsEndpoint({
  projectId
}) {
  return `${INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function extractAuthTokenInfoFromResponse(response) {
  return {
    token: response.token,
    requestStatus: 2 /* RequestStatus.COMPLETED */,
    expiresIn: getExpiresInFromResponseExpiresIn(response.expiresIn),
    creationTime: Date.now()
  };
}
async function getErrorFromResponse(requestName, response) {
  const responseJson = await response.json();
  const errorData = responseJson.error;
  return esm_index_esm2017_ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */, {
    requestName,
    serverCode: errorData.code,
    serverMessage: errorData.message,
    serverStatus: errorData.status
  });
}
function getHeaders({
  apiKey
}) {
  return new Headers({
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'x-goog-api-key': apiKey
  });
}
function getHeadersWithAuth(appConfig, {
  refreshToken
}) {
  const headers = getHeaders(appConfig);
  headers.append('Authorization', getAuthorizationHeader(refreshToken));
  return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */
async function retryIfServerError(fn) {
  const result = await fn();
  if (result.status >= 500 && result.status < 600) {
    // Internal Server Error. Retry request.
    return fn();
  }
  return result;
}
function getExpiresInFromResponseExpiresIn(responseExpiresIn) {
  // This works because the server will never respond with fractions of a second.
  return Number(responseExpiresIn.replace('s', '000'));
}
function getAuthorizationHeader(refreshToken) {
  return `${INTERNAL_AUTH_VERSION} ${refreshToken}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function createInstallationRequest({
  appConfig,
  heartbeatServiceProvider
}, {
  fid
}) {
  const endpoint = getInstallationsEndpoint(appConfig);
  const headers = getHeaders(appConfig);
  // If heartbeat service exists, add the heartbeat string to the header.
  const heartbeatService = heartbeatServiceProvider.getImmediate({
    optional: true
  });
  if (heartbeatService) {
    const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
    if (heartbeatsHeader) {
      headers.append('x-firebase-client', heartbeatsHeader);
    }
  }
  const body = {
    fid,
    authVersion: INTERNAL_AUTH_VERSION,
    appId: appConfig.appId,
    sdkVersion: PACKAGE_VERSION
  };
  const request = {
    method: 'POST',
    headers,
    body: JSON.stringify(body)
  };
  const response = await retryIfServerError(() => fetch(endpoint, request));
  if (response.ok) {
    const responseValue = await response.json();
    const registeredInstallationEntry = {
      fid: responseValue.fid || fid,
      registrationStatus: 2 /* RequestStatus.COMPLETED */,
      refreshToken: responseValue.refreshToken,
      authToken: extractAuthTokenInfoFromResponse(responseValue.authToken)
    };
    return registeredInstallationEntry;
  } else {
    throw await getErrorFromResponse('Create Installation', response);
  }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a promise that resolves after given time passes. */
function sleep(ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bufferToBase64UrlSafe(array) {
  const b64 = btoa(String.fromCharCode(...array));
  return b64.replace(/\+/g, '-').replace(/\//g, '_');
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */
function generateFid() {
  try {
    // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
    // bytes. our implementation generates a 17 byte array instead.
    const fidByteArray = new Uint8Array(17);
    const crypto = self.crypto || self.msCrypto;
    crypto.getRandomValues(fidByteArray);
    // Replace the first 4 random bits with the constant FID header of 0b0111.
    fidByteArray[0] = 0b01110000 + fidByteArray[0] % 0b00010000;
    const fid = encode(fidByteArray);
    return VALID_FID_PATTERN.test(fid) ? fid : INVALID_FID;
  } catch (_a) {
    // FID generation errored
    return INVALID_FID;
  }
}
/** Converts a FID Uint8Array to a base64 string representation. */
function encode(fidByteArray) {
  const b64String = bufferToBase64UrlSafe(fidByteArray);
  // Remove the 23rd character that was added because of the extra 4 bits at the
  // end of our 17 byte array, and the '=' padding.
  return b64String.substr(0, 22);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a string key that can be used to identify the app. */
function getKey(appConfig) {
  return `${appConfig.appName}!${appConfig.appId}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */
function fidChanged(appConfig, fid) {
  const key = getKey(appConfig);
  callFidChangeCallbacks(key, fid);
  broadcastFidChange(key, fid);
}
function addCallback(appConfig, callback) {
  // Open the broadcast channel if it's not already open,
  // to be able to listen to change events from other tabs.
  getBroadcastChannel();
  const key = getKey(appConfig);
  let callbackSet = fidChangeCallbacks.get(key);
  if (!callbackSet) {
    callbackSet = new Set();
    fidChangeCallbacks.set(key, callbackSet);
  }
  callbackSet.add(callback);
}
function removeCallback(appConfig, callback) {
  const key = getKey(appConfig);
  const callbackSet = fidChangeCallbacks.get(key);
  if (!callbackSet) {
    return;
  }
  callbackSet.delete(callback);
  if (callbackSet.size === 0) {
    fidChangeCallbacks.delete(key);
  }
  // Close broadcast channel if there are no more callbacks.
  closeBroadcastChannel();
}
function callFidChangeCallbacks(key, fid) {
  const callbacks = fidChangeCallbacks.get(key);
  if (!callbacks) {
    return;
  }
  for (const callback of callbacks) {
    callback(fid);
  }
}
function broadcastFidChange(key, fid) {
  const channel = getBroadcastChannel();
  if (channel) {
    channel.postMessage({
      key,
      fid
    });
  }
  closeBroadcastChannel();
}
let broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */
function getBroadcastChannel() {
  if (!broadcastChannel && 'BroadcastChannel' in self) {
    broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
    broadcastChannel.onmessage = e => {
      callFidChangeCallbacks(e.data.key, e.data.fid);
    };
  }
  return broadcastChannel;
}
function closeBroadcastChannel() {
  if (fidChangeCallbacks.size === 0 && broadcastChannel) {
    broadcastChannel.close();
    broadcastChannel = null;
  }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DATABASE_NAME = 'firebase-installations-database';
const DATABASE_VERSION = 1;
const OBJECT_STORE_NAME = 'firebase-installations-store';
let index_esm2017_dbPromise = null;
function index_esm2017_getDbPromise() {
  if (!index_esm2017_dbPromise) {
    index_esm2017_dbPromise = openDB(DATABASE_NAME, DATABASE_VERSION, {
      upgrade: (db, oldVersion) => {
        // We don't use 'break' in this switch statement, the fall-through
        // behavior is what we want, because if there are multiple versions between
        // the old version and the current version, we want ALL the migrations
        // that correspond to those versions to run, not only the last one.
        // eslint-disable-next-line default-case
        switch (oldVersion) {
          case 0:
            db.createObjectStore(OBJECT_STORE_NAME);
        }
      }
    });
  }
  return index_esm2017_dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */
async function set(appConfig, value) {
  const key = getKey(appConfig);
  const db = await index_esm2017_getDbPromise();
  const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
  const objectStore = tx.objectStore(OBJECT_STORE_NAME);
  const oldValue = await objectStore.get(key);
  await objectStore.put(value, key);
  await tx.done;
  if (!oldValue || oldValue.fid !== value.fid) {
    fidChanged(appConfig, value.fid);
  }
  return value;
}
/** Removes record(s) from the objectStore that match the given key. */
async function remove(appConfig) {
  const key = getKey(appConfig);
  const db = await index_esm2017_getDbPromise();
  const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
  await tx.objectStore(OBJECT_STORE_NAME).delete(key);
  await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */
async function update(appConfig, updateFn) {
  const key = getKey(appConfig);
  const db = await index_esm2017_getDbPromise();
  const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
  const store = tx.objectStore(OBJECT_STORE_NAME);
  const oldValue = await store.get(key);
  const newValue = updateFn(oldValue);
  if (newValue === undefined) {
    await store.delete(key);
  } else {
    await store.put(newValue, key);
  }
  await tx.done;
  if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) {
    fidChanged(appConfig, newValue.fid);
  }
  return newValue;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */
async function getInstallationEntry(installations) {
  let registrationPromise;
  const installationEntry = await update(installations.appConfig, oldEntry => {
    const installationEntry = updateOrCreateInstallationEntry(oldEntry);
    const entryWithPromise = triggerRegistrationIfNecessary(installations, installationEntry);
    registrationPromise = entryWithPromise.registrationPromise;
    return entryWithPromise.installationEntry;
  });
  if (installationEntry.fid === INVALID_FID) {
    // FID generation failed. Waiting for the FID from the server.
    return {
      installationEntry: await registrationPromise
    };
  }
  return {
    installationEntry,
    registrationPromise
  };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */
function updateOrCreateInstallationEntry(oldEntry) {
  const entry = oldEntry || {
    fid: generateFid(),
    registrationStatus: 0 /* RequestStatus.NOT_STARTED */
  };
  return clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */
function triggerRegistrationIfNecessary(installations, installationEntry) {
  if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
    if (!navigator.onLine) {
      // Registration required but app is offline.
      const registrationPromiseWithError = Promise.reject(esm_index_esm2017_ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */));
      return {
        installationEntry,
        registrationPromise: registrationPromiseWithError
      };
    }
    // Try registering. Change status to IN_PROGRESS.
    const inProgressEntry = {
      fid: installationEntry.fid,
      registrationStatus: 1 /* RequestStatus.IN_PROGRESS */,
      registrationTime: Date.now()
    };
    const registrationPromise = registerInstallation(installations, inProgressEntry);
    return {
      installationEntry: inProgressEntry,
      registrationPromise
    };
  } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
    return {
      installationEntry,
      registrationPromise: waitUntilFidRegistration(installations)
    };
  } else {
    return {
      installationEntry
    };
  }
}
/** This will be executed only once for each new Firebase Installation. */
async function registerInstallation(installations, installationEntry) {
  try {
    const registeredInstallationEntry = await createInstallationRequest(installations, installationEntry);
    return set(installations.appConfig, registeredInstallationEntry);
  } catch (e) {
    if (isServerError(e) && e.customData.serverCode === 409) {
      // Server returned a "FID cannot be used" error.
      // Generate a new ID next time.
      await remove(installations.appConfig);
    } else {
      // Registration failed. Set FID as not registered.
      await set(installations.appConfig, {
        fid: installationEntry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */
      });
    }
    throw e;
  }
}
/** Call if FID registration is pending in another request. */
async function waitUntilFidRegistration(installations) {
  // Unfortunately, there is no way of reliably observing when a value in
  // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
  // so we need to poll.
  let entry = await updateInstallationRequest(installations.appConfig);
  while (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
    // createInstallation request still in progress.
    await sleep(100);
    entry = await updateInstallationRequest(installations.appConfig);
  }
  if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
    // The request timed out or failed in a different call. Try again.
    const {
      installationEntry,
      registrationPromise
    } = await getInstallationEntry(installations);
    if (registrationPromise) {
      return registrationPromise;
    } else {
      // if there is no registrationPromise, entry is registered.
      return installationEntry;
    }
  }
  return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */
function updateInstallationRequest(appConfig) {
  return update(appConfig, oldEntry => {
    if (!oldEntry) {
      throw esm_index_esm2017_ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */);
    }
    return clearTimedOutRequest(oldEntry);
  });
}
function clearTimedOutRequest(entry) {
  if (hasInstallationRequestTimedOut(entry)) {
    return {
      fid: entry.fid,
      registrationStatus: 0 /* RequestStatus.NOT_STARTED */
    };
  }
  return entry;
}
function hasInstallationRequestTimedOut(installationEntry) {
  return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ && installationEntry.registrationTime + PENDING_TIMEOUT_MS < Date.now();
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function generateAuthTokenRequest({
  appConfig,
  heartbeatServiceProvider
}, installationEntry) {
  const endpoint = getGenerateAuthTokenEndpoint(appConfig, installationEntry);
  const headers = getHeadersWithAuth(appConfig, installationEntry);
  // If heartbeat service exists, add the heartbeat string to the header.
  const heartbeatService = heartbeatServiceProvider.getImmediate({
    optional: true
  });
  if (heartbeatService) {
    const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
    if (heartbeatsHeader) {
      headers.append('x-firebase-client', heartbeatsHeader);
    }
  }
  const body = {
    installation: {
      sdkVersion: PACKAGE_VERSION,
      appId: appConfig.appId
    }
  };
  const request = {
    method: 'POST',
    headers,
    body: JSON.stringify(body)
  };
  const response = await retryIfServerError(() => fetch(endpoint, request));
  if (response.ok) {
    const responseValue = await response.json();
    const completedAuthToken = extractAuthTokenInfoFromResponse(responseValue);
    return completedAuthToken;
  } else {
    throw await getErrorFromResponse('Generate Auth Token', response);
  }
}
function getGenerateAuthTokenEndpoint(appConfig, {
  fid
}) {
  return `${getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */
async function refreshAuthToken(installations, forceRefresh = false) {
  let tokenPromise;
  const entry = await update(installations.appConfig, oldEntry => {
    if (!isEntryRegistered(oldEntry)) {
      throw esm_index_esm2017_ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */);
    }
    const oldAuthToken = oldEntry.authToken;
    if (!forceRefresh && isAuthTokenValid(oldAuthToken)) {
      // There is a valid token in the DB.
      return oldEntry;
    } else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */) {
      // There already is a token request in progress.
      tokenPromise = waitUntilAuthTokenRequest(installations, forceRefresh);
      return oldEntry;
    } else {
      // No token or token expired.
      if (!navigator.onLine) {
        throw esm_index_esm2017_ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */);
      }
      const inProgressEntry = makeAuthTokenRequestInProgressEntry(oldEntry);
      tokenPromise = fetchAuthTokenFromServer(installations, inProgressEntry);
      return inProgressEntry;
    }
  });
  const authToken = tokenPromise ? await tokenPromise : entry.authToken;
  return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */
async function waitUntilAuthTokenRequest(installations, forceRefresh) {
  // Unfortunately, there is no way of reliably observing when a value in
  // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
  // so we need to poll.
  let entry = await updateAuthTokenRequest(installations.appConfig);
  while (entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */) {
    // generateAuthToken still in progress.
    await sleep(100);
    entry = await updateAuthTokenRequest(installations.appConfig);
  }
  const authToken = entry.authToken;
  if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */) {
    // The request timed out or failed in a different call. Try again.
    return refreshAuthToken(installations, forceRefresh);
  } else {
    return authToken;
  }
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */
function updateAuthTokenRequest(appConfig) {
  return update(appConfig, oldEntry => {
    if (!isEntryRegistered(oldEntry)) {
      throw esm_index_esm2017_ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */);
    }
    const oldAuthToken = oldEntry.authToken;
    if (hasAuthTokenRequestTimedOut(oldAuthToken)) {
      return Object.assign(Object.assign({}, oldEntry), {
        authToken: {
          requestStatus: 0 /* RequestStatus.NOT_STARTED */
        }
      });
    }
    return oldEntry;
  });
}
async function fetchAuthTokenFromServer(installations, installationEntry) {
  try {
    const authToken = await generateAuthTokenRequest(installations, installationEntry);
    const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
      authToken
    });
    await set(installations.appConfig, updatedInstallationEntry);
    return authToken;
  } catch (e) {
    if (isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) {
      // Server returned a "FID not found" or a "Invalid authentication" error.
      // Generate a new ID next time.
      await remove(installations.appConfig);
    } else {
      const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
        authToken: {
          requestStatus: 0 /* RequestStatus.NOT_STARTED */
        }
      });
      await set(installations.appConfig, updatedInstallationEntry);
    }
    throw e;
  }
}
function isEntryRegistered(installationEntry) {
  return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */;
}
function isAuthTokenValid(authToken) {
  return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */ && !isAuthTokenExpired(authToken);
}
function isAuthTokenExpired(authToken) {
  const now = Date.now();
  return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */
function makeAuthTokenRequestInProgressEntry(oldEntry) {
  const inProgressAuthToken = {
    requestStatus: 1 /* RequestStatus.IN_PROGRESS */,
    requestTime: Date.now()
  };
  return Object.assign(Object.assign({}, oldEntry), {
    authToken: inProgressAuthToken
  });
}
function hasAuthTokenRequestTimedOut(authToken) {
  return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ && authToken.requestTime + PENDING_TIMEOUT_MS < Date.now();
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */
async function getId(installations) {
  const installationsImpl = installations;
  const {
    installationEntry,
    registrationPromise
  } = await getInstallationEntry(installationsImpl);
  if (registrationPromise) {
    registrationPromise.catch(console.error);
  } else {
    // If the installation is already registered, update the authentication
    // token if needed.
    refreshAuthToken(installationsImpl).catch(console.error);
  }
  return installationEntry.fid;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */
async function getToken(installations, forceRefresh = false) {
  const installationsImpl = installations;
  await completeInstallationRegistration(installationsImpl);
  // At this point we either have a Registered Installation in the DB, or we've
  // already thrown an error.
  const authToken = await refreshAuthToken(installationsImpl, forceRefresh);
  return authToken.token;
}
async function completeInstallationRegistration(installations) {
  const {
    registrationPromise
  } = await getInstallationEntry(installations);
  if (registrationPromise) {
    // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
  }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function deleteInstallationRequest(appConfig, installationEntry) {
  const endpoint = getDeleteEndpoint(appConfig, installationEntry);
  const headers = getHeadersWithAuth(appConfig, installationEntry);
  const request = {
    method: 'DELETE',
    headers
  };
  const response = await retryIfServerError(() => fetch(endpoint, request));
  if (!response.ok) {
    throw await getErrorFromResponse('Delete Installation', response);
  }
}
function getDeleteEndpoint(appConfig, {
  fid
}) {
  return `${getInstallationsEndpoint(appConfig)}/${fid}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */
async function deleteInstallations(installations) {
  const {
    appConfig
  } = installations;
  const entry = await update(appConfig, oldEntry => {
    if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
      // Delete the unregistered entry without sending a deleteInstallation request.
      return undefined;
    }
    return oldEntry;
  });
  if (entry) {
    if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
      // Can't delete while trying to register.
      throw esm_index_esm2017_ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */);
    } else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */) {
      if (!navigator.onLine) {
        throw esm_index_esm2017_ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */);
      } else {
        await deleteInstallationRequest(appConfig, entry);
        await remove(appConfig);
      }
    }
  }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */
function onIdChange(installations, callback) {
  const {
    appConfig
  } = installations;
  addCallback(appConfig, callback);
  return () => {
    removeCallback(appConfig, callback);
  };
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */
function getInstallations(app = getApp()) {
  const installationsImpl = _getProvider(app, 'installations').getImmediate();
  return installationsImpl;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig(app) {
  if (!app || !app.options) {
    throw getMissingValueError('App Configuration');
  }
  if (!app.name) {
    throw getMissingValueError('App Name');
  }
  // Required app config keys
  const configKeys = ['projectId', 'apiKey', 'appId'];
  for (const keyName of configKeys) {
    if (!app.options[keyName]) {
      throw getMissingValueError(keyName);
    }
  }
  return {
    appName: app.name,
    projectId: app.options.projectId,
    apiKey: app.options.apiKey,
    appId: app.options.appId
  };
}
function getMissingValueError(valueName) {
  return esm_index_esm2017_ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */, {
    valueName
  });
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const INSTALLATIONS_NAME = 'installations';
const INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const publicFactory = container => {
  const app = container.getProvider('app').getImmediate();
  // Throws if app isn't configured properly.
  const appConfig = extractAppConfig(app);
  const heartbeatServiceProvider = index_esm2017_getProvider(app, 'heartbeat');
  const installationsImpl = {
    app,
    appConfig,
    heartbeatServiceProvider,
    _delete: () => Promise.resolve()
  };
  return installationsImpl;
};
const internalFactory = container => {
  const app = container.getProvider('app').getImmediate();
  // Internal FIS instance relies on public FIS instance.
  const installations = index_esm2017_getProvider(app, INSTALLATIONS_NAME).getImmediate();
  const installationsInternal = {
    getId: () => getId(installations),
    getToken: forceRefresh => getToken(installations, forceRefresh)
  };
  return installationsInternal;
};
function registerInstallations() {
  _registerComponent(new Component(INSTALLATIONS_NAME, publicFactory, "PUBLIC" /* ComponentType.PUBLIC */));
  _registerComponent(new Component(INSTALLATIONS_NAME_INTERNAL, internalFactory, "PRIVATE" /* ComponentType.PRIVATE */));
}

/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */
registerInstallations();
registerVersion(dist_esm_index_esm2017_name, esm_index_esm2017_version);
// BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
registerVersion(dist_esm_index_esm2017_name, esm_index_esm2017_version, 'esm2017');

;// CONCATENATED MODULE: ./node_modules/@firebase/messaging/dist/esm/index.esm2017.js






/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_SW_PATH = '/firebase-messaging-sw.js';
const DEFAULT_SW_SCOPE = '/firebase-cloud-messaging-push-scope';
const DEFAULT_VAPID_KEY = 'BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4';
const ENDPOINT = 'https://fcmregistrations.googleapis.com/v1';
const CONSOLE_CAMPAIGN_ID = 'google.c.a.c_id';
const CONSOLE_CAMPAIGN_NAME = 'google.c.a.c_l';
const CONSOLE_CAMPAIGN_TIME = 'google.c.a.ts';
/** Set to '1' if Analytics is enabled for the campaign */
const CONSOLE_CAMPAIGN_ANALYTICS_ENABLED = 'google.c.a.e';
var MessageType$1;
(function (MessageType) {
  MessageType[MessageType["DATA_MESSAGE"] = 1] = "DATA_MESSAGE";
  MessageType[MessageType["DISPLAY_NOTIFICATION"] = 3] = "DISPLAY_NOTIFICATION";
})(MessageType$1 || (MessageType$1 = {}));

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */
var MessageType;
(function (MessageType) {
  MessageType["PUSH_RECEIVED"] = "push-received";
  MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
})(MessageType || (MessageType = {}));

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function arrayToBase64(array) {
  const uint8Array = new Uint8Array(array);
  const base64String = btoa(String.fromCharCode(...uint8Array));
  return base64String.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function base64ToArray(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const OLD_DB_NAME = 'fcm_token_details_db';
/**
 * The last DB version of 'fcm_token_details_db' was 4. This is one higher, so that the upgrade
 * callback is called for all versions of the old DB.
 */
const OLD_DB_VERSION = 5;
const OLD_OBJECT_STORE_NAME = 'fcm_token_object_Store';
async function migrateOldDatabase(senderId) {
  if ('databases' in indexedDB) {
    // indexedDb.databases() is an IndexedDB v3 API and does not exist in all browsers. TODO: Remove
    // typecast when it lands in TS types.
    const databases = await indexedDB.databases();
    const dbNames = databases.map(db => db.name);
    if (!dbNames.includes(OLD_DB_NAME)) {
      // old DB didn't exist, no need to open.
      return null;
    }
  }
  let tokenDetails = null;
  const db = await openDB(OLD_DB_NAME, OLD_DB_VERSION, {
    upgrade: async (db, oldVersion, newVersion, upgradeTransaction) => {
      var _a;
      if (oldVersion < 2) {
        // Database too old, skip migration.
        return;
      }
      if (!db.objectStoreNames.contains(OLD_OBJECT_STORE_NAME)) {
        // Database did not exist. Nothing to do.
        return;
      }
      const objectStore = upgradeTransaction.objectStore(OLD_OBJECT_STORE_NAME);
      const value = await objectStore.index('fcmSenderId').get(senderId);
      await objectStore.clear();
      if (!value) {
        // No entry in the database, nothing to migrate.
        return;
      }
      if (oldVersion === 2) {
        const oldDetails = value;
        if (!oldDetails.auth || !oldDetails.p256dh || !oldDetails.endpoint) {
          return;
        }
        tokenDetails = {
          token: oldDetails.fcmToken,
          createTime: (_a = oldDetails.createTime) !== null && _a !== void 0 ? _a : Date.now(),
          subscriptionOptions: {
            auth: oldDetails.auth,
            p256dh: oldDetails.p256dh,
            endpoint: oldDetails.endpoint,
            swScope: oldDetails.swScope,
            vapidKey: typeof oldDetails.vapidKey === 'string' ? oldDetails.vapidKey : arrayToBase64(oldDetails.vapidKey)
          }
        };
      } else if (oldVersion === 3) {
        const oldDetails = value;
        tokenDetails = {
          token: oldDetails.fcmToken,
          createTime: oldDetails.createTime,
          subscriptionOptions: {
            auth: arrayToBase64(oldDetails.auth),
            p256dh: arrayToBase64(oldDetails.p256dh),
            endpoint: oldDetails.endpoint,
            swScope: oldDetails.swScope,
            vapidKey: arrayToBase64(oldDetails.vapidKey)
          }
        };
      } else if (oldVersion === 4) {
        const oldDetails = value;
        tokenDetails = {
          token: oldDetails.fcmToken,
          createTime: oldDetails.createTime,
          subscriptionOptions: {
            auth: arrayToBase64(oldDetails.auth),
            p256dh: arrayToBase64(oldDetails.p256dh),
            endpoint: oldDetails.endpoint,
            swScope: oldDetails.swScope,
            vapidKey: arrayToBase64(oldDetails.vapidKey)
          }
        };
      }
    }
  });
  db.close();
  // Delete all old databases.
  await deleteDB(OLD_DB_NAME);
  await deleteDB('fcm_vapid_details_db');
  await deleteDB('undefined');
  return checkTokenDetails(tokenDetails) ? tokenDetails : null;
}
function checkTokenDetails(tokenDetails) {
  if (!tokenDetails || !tokenDetails.subscriptionOptions) {
    return false;
  }
  const {
    subscriptionOptions
  } = tokenDetails;
  return typeof tokenDetails.createTime === 'number' && tokenDetails.createTime > 0 && typeof tokenDetails.token === 'string' && tokenDetails.token.length > 0 && typeof subscriptionOptions.auth === 'string' && subscriptionOptions.auth.length > 0 && typeof subscriptionOptions.p256dh === 'string' && subscriptionOptions.p256dh.length > 0 && typeof subscriptionOptions.endpoint === 'string' && subscriptionOptions.endpoint.length > 0 && typeof subscriptionOptions.swScope === 'string' && subscriptionOptions.swScope.length > 0 && typeof subscriptionOptions.vapidKey === 'string' && subscriptionOptions.vapidKey.length > 0;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Exported for tests.
const index_esm2017_DATABASE_NAME = 'firebase-messaging-database';
const index_esm2017_DATABASE_VERSION = 1;
const index_esm2017_OBJECT_STORE_NAME = 'firebase-messaging-store';
let esm_index_esm2017_dbPromise = null;
function esm_index_esm2017_getDbPromise() {
  if (!esm_index_esm2017_dbPromise) {
    esm_index_esm2017_dbPromise = openDB(index_esm2017_DATABASE_NAME, index_esm2017_DATABASE_VERSION, {
      upgrade: (upgradeDb, oldVersion) => {
        // We don't use 'break' in this switch statement, the fall-through behavior is what we want,
        // because if there are multiple versions between the old version and the current version, we
        // want ALL the migrations that correspond to those versions to run, not only the last one.
        // eslint-disable-next-line default-case
        switch (oldVersion) {
          case 0:
            upgradeDb.createObjectStore(index_esm2017_OBJECT_STORE_NAME);
        }
      }
    });
  }
  return esm_index_esm2017_dbPromise;
}
/** Gets record(s) from the objectStore that match the given key. */
async function dbGet(firebaseDependencies) {
  const key = index_esm2017_getKey(firebaseDependencies);
  const db = await esm_index_esm2017_getDbPromise();
  const tokenDetails = await db.transaction(index_esm2017_OBJECT_STORE_NAME).objectStore(index_esm2017_OBJECT_STORE_NAME).get(key);
  if (tokenDetails) {
    return tokenDetails;
  } else {
    // Check if there is a tokenDetails object in the old DB.
    const oldTokenDetails = await migrateOldDatabase(firebaseDependencies.appConfig.senderId);
    if (oldTokenDetails) {
      await dbSet(firebaseDependencies, oldTokenDetails);
      return oldTokenDetails;
    }
  }
}
/** Assigns or overwrites the record for the given key with the given value. */
async function dbSet(firebaseDependencies, tokenDetails) {
  const key = index_esm2017_getKey(firebaseDependencies);
  const db = await esm_index_esm2017_getDbPromise();
  const tx = db.transaction(index_esm2017_OBJECT_STORE_NAME, 'readwrite');
  await tx.objectStore(index_esm2017_OBJECT_STORE_NAME).put(tokenDetails, key);
  await tx.done;
  return tokenDetails;
}
/** Removes record(s) from the objectStore that match the given key. */
async function dbRemove(firebaseDependencies) {
  const key = index_esm2017_getKey(firebaseDependencies);
  const db = await esm_index_esm2017_getDbPromise();
  const tx = db.transaction(index_esm2017_OBJECT_STORE_NAME, 'readwrite');
  await tx.objectStore(index_esm2017_OBJECT_STORE_NAME).delete(key);
  await tx.done;
}
function index_esm2017_getKey({
  appConfig
}) {
  return appConfig.appId;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERROR_MAP = {
  ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */]: 'Missing App configuration value: "{$valueName}"',
  ["only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */]: 'This method is available in a Window context.',
  ["only-available-in-sw" /* ErrorCode.AVAILABLE_IN_SW */]: 'This method is available in a service worker context.',
  ["permission-default" /* ErrorCode.PERMISSION_DEFAULT */]: 'The notification permission was not granted and dismissed instead.',
  ["permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */]: 'The notification permission was not granted and blocked instead.',
  ["unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */]: "This browser doesn't support the API's required to use the Firebase SDK.",
  ["indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */]: "This browser doesn't support indexedDb.open() (ex. Safari iFrame, Firefox Private Browsing, etc)",
  ["failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */]: 'We are unable to register the default service worker. {$browserErrorMessage}',
  ["token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */]: 'A problem occurred while subscribing the user to FCM: {$errorInfo}',
  ["token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */]: 'FCM returned no token when subscribing the user to push.',
  ["token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */]: 'A problem occurred while unsubscribing the ' + 'user from FCM: {$errorInfo}',
  ["token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */]: 'A problem occurred while updating the user from FCM: {$errorInfo}',
  ["token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */]: 'FCM returned no token when updating the user to push.',
  ["use-sw-after-get-token" /* ErrorCode.USE_SW_AFTER_GET_TOKEN */]: 'The useServiceWorker() method may only be called once and must be ' + 'called before calling getToken() to ensure your service worker is used.',
  ["invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */]: 'The input to useServiceWorker() must be a ServiceWorkerRegistration.',
  ["invalid-bg-handler" /* ErrorCode.INVALID_BG_HANDLER */]: 'The input to setBackgroundMessageHandler() must be a function.',
  ["invalid-vapid-key" /* ErrorCode.INVALID_VAPID_KEY */]: 'The public VAPID key must be a string.',
  ["use-vapid-key-after-get-token" /* ErrorCode.USE_VAPID_KEY_AFTER_GET_TOKEN */]: 'The usePublicVapidKey() method may only be called once and must be ' + 'called before calling getToken() to ensure your VAPID key is used.'
};
const dist_esm_index_esm2017_ERROR_FACTORY = new ErrorFactory('messaging', 'Messaging', ERROR_MAP);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function requestGetToken(firebaseDependencies, subscriptionOptions) {
  const headers = await index_esm2017_getHeaders(firebaseDependencies);
  const body = getBody(subscriptionOptions);
  const subscribeOptions = {
    method: 'POST',
    headers,
    body: JSON.stringify(body)
  };
  let responseData;
  try {
    const response = await fetch(getEndpoint(firebaseDependencies.appConfig), subscribeOptions);
    responseData = await response.json();
  } catch (err) {
    throw dist_esm_index_esm2017_ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */, {
      errorInfo: err === null || err === void 0 ? void 0 : err.toString()
    });
  }
  if (responseData.error) {
    const message = responseData.error.message;
    throw dist_esm_index_esm2017_ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */, {
      errorInfo: message
    });
  }
  if (!responseData.token) {
    throw dist_esm_index_esm2017_ERROR_FACTORY.create("token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */);
  }
  return responseData.token;
}
async function requestUpdateToken(firebaseDependencies, tokenDetails) {
  const headers = await index_esm2017_getHeaders(firebaseDependencies);
  const body = getBody(tokenDetails.subscriptionOptions);
  const updateOptions = {
    method: 'PATCH',
    headers,
    body: JSON.stringify(body)
  };
  let responseData;
  try {
    const response = await fetch(`${getEndpoint(firebaseDependencies.appConfig)}/${tokenDetails.token}`, updateOptions);
    responseData = await response.json();
  } catch (err) {
    throw dist_esm_index_esm2017_ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */, {
      errorInfo: err === null || err === void 0 ? void 0 : err.toString()
    });
  }
  if (responseData.error) {
    const message = responseData.error.message;
    throw dist_esm_index_esm2017_ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */, {
      errorInfo: message
    });
  }
  if (!responseData.token) {
    throw dist_esm_index_esm2017_ERROR_FACTORY.create("token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */);
  }
  return responseData.token;
}
async function requestDeleteToken(firebaseDependencies, token) {
  const headers = await index_esm2017_getHeaders(firebaseDependencies);
  const unsubscribeOptions = {
    method: 'DELETE',
    headers
  };
  try {
    const response = await fetch(`${getEndpoint(firebaseDependencies.appConfig)}/${token}`, unsubscribeOptions);
    const responseData = await response.json();
    if (responseData.error) {
      const message = responseData.error.message;
      throw dist_esm_index_esm2017_ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */, {
        errorInfo: message
      });
    }
  } catch (err) {
    throw dist_esm_index_esm2017_ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */, {
      errorInfo: err === null || err === void 0 ? void 0 : err.toString()
    });
  }
}
function getEndpoint({
  projectId
}) {
  return `${ENDPOINT}/projects/${projectId}/registrations`;
}
async function index_esm2017_getHeaders({
  appConfig,
  installations
}) {
  const authToken = await installations.getToken();
  return new Headers({
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'x-goog-api-key': appConfig.apiKey,
    'x-goog-firebase-installations-auth': `FIS ${authToken}`
  });
}
function getBody({
  p256dh,
  auth,
  endpoint,
  vapidKey
}) {
  const body = {
    web: {
      endpoint,
      auth,
      p256dh
    }
  };
  if (vapidKey !== DEFAULT_VAPID_KEY) {
    body.web.applicationPubKey = vapidKey;
  }
  return body;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// UpdateRegistration will be called once every week.
const TOKEN_EXPIRATION_MS = 7 * 24 * 60 * 60 * 1000; // 7 days
async function getTokenInternal(messaging) {
  const pushSubscription = await getPushSubscription(messaging.swRegistration, messaging.vapidKey);
  const subscriptionOptions = {
    vapidKey: messaging.vapidKey,
    swScope: messaging.swRegistration.scope,
    endpoint: pushSubscription.endpoint,
    auth: arrayToBase64(pushSubscription.getKey('auth')),
    p256dh: arrayToBase64(pushSubscription.getKey('p256dh'))
  };
  const tokenDetails = await dbGet(messaging.firebaseDependencies);
  if (!tokenDetails) {
    // No token, get a new one.
    return getNewToken(messaging.firebaseDependencies, subscriptionOptions);
  } else if (!isTokenValid(tokenDetails.subscriptionOptions, subscriptionOptions)) {
    // Invalid token, get a new one.
    try {
      await requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
    } catch (e) {
      // Suppress errors because of #2364
      console.warn(e);
    }
    return getNewToken(messaging.firebaseDependencies, subscriptionOptions);
  } else if (Date.now() >= tokenDetails.createTime + TOKEN_EXPIRATION_MS) {
    // Weekly token refresh
    return updateToken(messaging, {
      token: tokenDetails.token,
      createTime: Date.now(),
      subscriptionOptions
    });
  } else {
    // Valid token, nothing to do.
    return tokenDetails.token;
  }
}
/**
 * This method deletes the token from the database, unsubscribes the token from FCM, and unregisters
 * the push subscription if it exists.
 */
async function deleteTokenInternal(messaging) {
  const tokenDetails = await dbGet(messaging.firebaseDependencies);
  if (tokenDetails) {
    await requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
    await dbRemove(messaging.firebaseDependencies);
  }
  // Unsubscribe from the push subscription.
  const pushSubscription = await messaging.swRegistration.pushManager.getSubscription();
  if (pushSubscription) {
    return pushSubscription.unsubscribe();
  }
  // If there's no SW, consider it a success.
  return true;
}
async function updateToken(messaging, tokenDetails) {
  try {
    const updatedToken = await requestUpdateToken(messaging.firebaseDependencies, tokenDetails);
    const updatedTokenDetails = Object.assign(Object.assign({}, tokenDetails), {
      token: updatedToken,
      createTime: Date.now()
    });
    await dbSet(messaging.firebaseDependencies, updatedTokenDetails);
    return updatedToken;
  } catch (e) {
    throw e;
  }
}
async function getNewToken(firebaseDependencies, subscriptionOptions) {
  const token = await requestGetToken(firebaseDependencies, subscriptionOptions);
  const tokenDetails = {
    token,
    createTime: Date.now(),
    subscriptionOptions
  };
  await dbSet(firebaseDependencies, tokenDetails);
  return tokenDetails.token;
}
/**
 * Gets a PushSubscription for the current user.
 */
async function getPushSubscription(swRegistration, vapidKey) {
  const subscription = await swRegistration.pushManager.getSubscription();
  if (subscription) {
    return subscription;
  }
  return swRegistration.pushManager.subscribe({
    userVisibleOnly: true,
    // Chrome <= 75 doesn't support base64-encoded VAPID key. For backward compatibility, VAPID key
    // submitted to pushManager#subscribe must be of type Uint8Array.
    applicationServerKey: base64ToArray(vapidKey)
  });
}
/**
 * Checks if the saved tokenDetails object matches the configuration provided.
 */
function isTokenValid(dbOptions, currentOptions) {
  const isVapidKeyEqual = currentOptions.vapidKey === dbOptions.vapidKey;
  const isEndpointEqual = currentOptions.endpoint === dbOptions.endpoint;
  const isAuthEqual = currentOptions.auth === dbOptions.auth;
  const isP256dhEqual = currentOptions.p256dh === dbOptions.p256dh;
  return isVapidKeyEqual && isEndpointEqual && isAuthEqual && isP256dhEqual;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function externalizePayload(internalPayload) {
  const payload = {
    from: internalPayload.from,
    // eslint-disable-next-line camelcase
    collapseKey: internalPayload.collapse_key,
    // eslint-disable-next-line camelcase
    messageId: internalPayload.fcmMessageId
  };
  propagateNotificationPayload(payload, internalPayload);
  propagateDataPayload(payload, internalPayload);
  propagateFcmOptions(payload, internalPayload);
  return payload;
}
function propagateNotificationPayload(payload, messagePayloadInternal) {
  if (!messagePayloadInternal.notification) {
    return;
  }
  payload.notification = {};
  const title = messagePayloadInternal.notification.title;
  if (!!title) {
    payload.notification.title = title;
  }
  const body = messagePayloadInternal.notification.body;
  if (!!body) {
    payload.notification.body = body;
  }
  const image = messagePayloadInternal.notification.image;
  if (!!image) {
    payload.notification.image = image;
  }
  const icon = messagePayloadInternal.notification.icon;
  if (!!icon) {
    payload.notification.icon = icon;
  }
}
function propagateDataPayload(payload, messagePayloadInternal) {
  if (!messagePayloadInternal.data) {
    return;
  }
  payload.data = messagePayloadInternal.data;
}
function propagateFcmOptions(payload, messagePayloadInternal) {
  var _a, _b, _c, _d, _e;
  // fcmOptions.link value is written into notification.click_action. see more in b/232072111
  if (!messagePayloadInternal.fcmOptions && !((_a = messagePayloadInternal.notification) === null || _a === void 0 ? void 0 : _a.click_action)) {
    return;
  }
  payload.fcmOptions = {};
  const link = (_c = (_b = messagePayloadInternal.fcmOptions) === null || _b === void 0 ? void 0 : _b.link) !== null && _c !== void 0 ? _c : (_d = messagePayloadInternal.notification) === null || _d === void 0 ? void 0 : _d.click_action;
  if (!!link) {
    payload.fcmOptions.link = link;
  }
  // eslint-disable-next-line camelcase
  const analyticsLabel = (_e = messagePayloadInternal.fcmOptions) === null || _e === void 0 ? void 0 : _e.analytics_label;
  if (!!analyticsLabel) {
    payload.fcmOptions.analyticsLabel = analyticsLabel;
  }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isConsoleMessage(data) {
  // This message has a campaign ID, meaning it was sent using the Firebase Console.
  return typeof data === 'object' && !!data && CONSOLE_CAMPAIGN_ID in data;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
_mergeStrings('AzSCbw63g1R0nCw85jG8', 'Iaya3yLKwmgvh7cF0q4');
function _mergeStrings(s1, s2) {
  const resultArray = [];
  for (let i = 0; i < s1.length; i++) {
    resultArray.push(s1.charAt(i));
    if (i < s2.length) {
      resultArray.push(s2.charAt(i));
    }
  }
  return resultArray.join('');
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function index_esm2017_extractAppConfig(app) {
  if (!app || !app.options) {
    throw index_esm2017_getMissingValueError('App Configuration Object');
  }
  if (!app.name) {
    throw index_esm2017_getMissingValueError('App Name');
  }
  // Required app config keys
  const configKeys = ['projectId', 'apiKey', 'appId', 'messagingSenderId'];
  const {
    options
  } = app;
  for (const keyName of configKeys) {
    if (!options[keyName]) {
      throw index_esm2017_getMissingValueError(keyName);
    }
  }
  return {
    appName: app.name,
    projectId: options.projectId,
    apiKey: options.apiKey,
    appId: options.appId,
    senderId: options.messagingSenderId
  };
}
function index_esm2017_getMissingValueError(valueName) {
  return dist_esm_index_esm2017_ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */, {
    valueName
  });
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MessagingService {
  constructor(app, installations, analyticsProvider) {
    // logging is only done with end user consent. Default to false.
    this.deliveryMetricsExportedToBigQueryEnabled = false;
    this.onBackgroundMessageHandler = null;
    this.onMessageHandler = null;
    this.logEvents = [];
    this.isLogServiceStarted = false;
    const appConfig = index_esm2017_extractAppConfig(app);
    this.firebaseDependencies = {
      app,
      appConfig,
      installations,
      analyticsProvider
    };
  }
  _delete() {
    return Promise.resolve();
  }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function registerDefaultSw(messaging) {
  try {
    messaging.swRegistration = await navigator.serviceWorker.register(DEFAULT_SW_PATH, {
      scope: DEFAULT_SW_SCOPE
    });
    // The timing when browser updates sw when sw has an update is unreliable from experiment. It
    // leads to version conflict when the SDK upgrades to a newer version in the main page, but sw
    // is stuck with the old version. For example,
    // https://github.com/firebase/firebase-js-sdk/issues/2590 The following line reliably updates
    // sw if there was an update.
    messaging.swRegistration.update().catch(() => {
      /* it is non blocking and we don't care if it failed */
    });
  } catch (e) {
    throw dist_esm_index_esm2017_ERROR_FACTORY.create("failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */, {
      browserErrorMessage: e === null || e === void 0 ? void 0 : e.message
    });
  }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function updateSwReg(messaging, swRegistration) {
  if (!swRegistration && !messaging.swRegistration) {
    await registerDefaultSw(messaging);
  }
  if (!swRegistration && !!messaging.swRegistration) {
    return;
  }
  if (!(swRegistration instanceof ServiceWorkerRegistration)) {
    throw dist_esm_index_esm2017_ERROR_FACTORY.create("invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */);
  }
  messaging.swRegistration = swRegistration;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function updateVapidKey(messaging, vapidKey) {
  if (!!vapidKey) {
    messaging.vapidKey = vapidKey;
  } else if (!messaging.vapidKey) {
    messaging.vapidKey = DEFAULT_VAPID_KEY;
  }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function getToken$1(messaging, options) {
  if (!navigator) {
    throw dist_esm_index_esm2017_ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */);
  }
  if (Notification.permission === 'default') {
    await Notification.requestPermission();
  }
  if (Notification.permission !== 'granted') {
    throw dist_esm_index_esm2017_ERROR_FACTORY.create("permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */);
  }
  await updateVapidKey(messaging, options === null || options === void 0 ? void 0 : options.vapidKey);
  await updateSwReg(messaging, options === null || options === void 0 ? void 0 : options.serviceWorkerRegistration);
  return getTokenInternal(messaging);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function logToScion(messaging, messageType, data) {
  const eventType = getEventType(messageType);
  const analytics = await messaging.firebaseDependencies.analyticsProvider.get();
  analytics.logEvent(eventType, {
    /* eslint-disable camelcase */
    message_id: data[CONSOLE_CAMPAIGN_ID],
    message_name: data[CONSOLE_CAMPAIGN_NAME],
    message_time: data[CONSOLE_CAMPAIGN_TIME],
    message_device_time: Math.floor(Date.now() / 1000)
    /* eslint-enable camelcase */
  });
}
function getEventType(messageType) {
  switch (messageType) {
    case MessageType.NOTIFICATION_CLICKED:
      return 'notification_open';
    case MessageType.PUSH_RECEIVED:
      return 'notification_foreground';
    default:
      throw new Error();
  }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function messageEventListener(messaging, event) {
  const internalPayload = event.data;
  if (!internalPayload.isFirebaseMessaging) {
    return;
  }
  if (messaging.onMessageHandler && internalPayload.messageType === MessageType.PUSH_RECEIVED) {
    if (typeof messaging.onMessageHandler === 'function') {
      messaging.onMessageHandler(externalizePayload(internalPayload));
    } else {
      messaging.onMessageHandler.next(externalizePayload(internalPayload));
    }
  }
  // Log to Scion if applicable
  const dataPayload = internalPayload.data;
  if (isConsoleMessage(dataPayload) && dataPayload[CONSOLE_CAMPAIGN_ANALYTICS_ENABLED] === '1') {
    await logToScion(messaging, internalPayload.messageType, dataPayload);
  }
}
const messaging_dist_esm_index_esm2017_name = "@firebase/messaging";
const dist_esm_index_esm2017_version = "0.12.12";

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const WindowMessagingFactory = container => {
  const messaging = new MessagingService(container.getProvider('app').getImmediate(), container.getProvider('installations-internal').getImmediate(), container.getProvider('analytics-internal'));
  navigator.serviceWorker.addEventListener('message', e => messageEventListener(messaging, e));
  return messaging;
};
const WindowMessagingInternalFactory = container => {
  const messaging = container.getProvider('messaging').getImmediate();
  const messagingInternal = {
    getToken: options => getToken$1(messaging, options)
  };
  return messagingInternal;
};
function registerMessagingInWindow() {
  _registerComponent(new Component('messaging', WindowMessagingFactory, "PUBLIC" /* ComponentType.PUBLIC */));
  _registerComponent(new Component('messaging-internal', WindowMessagingInternalFactory, "PRIVATE" /* ComponentType.PRIVATE */));
  registerVersion(messaging_dist_esm_index_esm2017_name, dist_esm_index_esm2017_version);
  // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
  registerVersion(messaging_dist_esm_index_esm2017_name, dist_esm_index_esm2017_version, 'esm2017');
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Checks if all required APIs exist in the browser.
 * @returns a Promise that resolves to a boolean.
 *
 * @public
 */
async function isWindowSupported() {
  try {
    // This throws if open() is unsupported, so adding it to the conditional
    // statement below can cause an uncaught error.
    await validateIndexedDBOpenable();
  } catch (e) {
    return false;
  }
  // firebase-js-sdk/issues/2393 reveals that idb#open in Safari iframe and Firefox private browsing
  // might be prohibited to run. In these contexts, an error would be thrown during the messaging
  // instantiating phase, informing the developers to import/call isSupported for special handling.
  return typeof window !== 'undefined' && isIndexedDBAvailable() && areCookiesEnabled() && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window && 'fetch' in window && ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') && PushSubscription.prototype.hasOwnProperty('getKey');
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function deleteToken$1(messaging) {
  if (!navigator) {
    throw dist_esm_index_esm2017_ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */);
  }
  if (!messaging.swRegistration) {
    await registerDefaultSw(messaging);
  }
  return deleteTokenInternal(messaging);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function onMessage$1(messaging, nextOrObserver) {
  if (!navigator) {
    throw dist_esm_index_esm2017_ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */);
  }
  messaging.onMessageHandler = nextOrObserver;
  return () => {
    messaging.onMessageHandler = null;
  };
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Retrieves a Firebase Cloud Messaging instance.
 *
 * @returns The Firebase Cloud Messaging instance associated with the provided firebase app.
 *
 * @public
 */
function getMessagingInWindow(app = getApp()) {
  // Conscious decision to make this async check non-blocking during the messaging instance
  // initialization phase for performance consideration. An error would be thrown latter for
  // developer's information. Developers can then choose to import and call `isSupported` for
  // special handling.
  isWindowSupported().then(isSupported => {
    // If `isWindowSupported()` resolved, but returned false.
    if (!isSupported) {
      throw dist_esm_index_esm2017_ERROR_FACTORY.create("unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */);
    }
  }, _ => {
    // If `isWindowSupported()` rejected.
    throw dist_esm_index_esm2017_ERROR_FACTORY.create("indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */);
  });
  return _getProvider(getModularInstance(app), 'messaging').getImmediate();
}
/**
 * Subscribes the {@link Messaging} instance to push notifications. Returns a Firebase Cloud
 * Messaging registration token that can be used to send push messages to that {@link Messaging}
 * instance.
 *
 * If notification permission isn't already granted, this method asks the user for permission. The
 * returned promise rejects if the user does not allow the app to show notifications.
 *
 * @param messaging - The {@link Messaging} instance.
 * @param options - Provides an optional vapid key and an optional service worker registration.
 *
 * @returns The promise resolves with an FCM registration token.
 *
 * @public
 */
async function index_esm2017_getToken(messaging, options) {
  messaging = index_esm2017_getModularInstance(messaging);
  return getToken$1(messaging, options);
}
/**
 * Deletes the registration token associated with this {@link Messaging} instance and unsubscribes
 * the {@link Messaging} instance from the push subscription.
 *
 * @param messaging - The {@link Messaging} instance.
 *
 * @returns The promise resolves when the token has been successfully deleted.
 *
 * @public
 */
function deleteToken(messaging) {
  messaging = index_esm2017_getModularInstance(messaging);
  return deleteToken$1(messaging);
}
/**
 * When a push message is received and the user is currently on a page for your origin, the
 * message is passed to the page and an `onMessage()` event is dispatched with the payload of
 * the push message.
 *
 *
 * @param messaging - The {@link Messaging} instance.
 * @param nextOrObserver - This function, or observer object with `next` defined,
 *     is called when a message is received and the user is currently viewing your page.
 * @returns To stop listening for messages execute this returned function.
 *
 * @public
 */
function onMessage(messaging, nextOrObserver) {
  messaging = index_esm2017_getModularInstance(messaging);
  return onMessage$1(messaging, nextOrObserver);
}

/**
 * The Firebase Cloud Messaging Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */
registerMessagingInWindow();

;// CONCATENATED MODULE: ./node_modules/@firebase/messaging/dist/esm/index.sw.esm2017.js






/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const index_sw_esm2017_DEFAULT_VAPID_KEY = 'BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4';
const index_sw_esm2017_ENDPOINT = 'https://fcmregistrations.googleapis.com/v1';
/** Key of FCM Payload in Notification's data field. */
const FCM_MSG = 'FCM_MSG';
const index_sw_esm2017_CONSOLE_CAMPAIGN_ID = 'google.c.a.c_id';
// Defined as in proto/messaging_event.proto. Neglecting fields that are supported.
const SDK_PLATFORM_WEB = 3;
const EVENT_MESSAGE_DELIVERED = 1;
var index_sw_esm2017_MessageType$1;
(function (MessageType) {
  MessageType[MessageType["DATA_MESSAGE"] = 1] = "DATA_MESSAGE";
  MessageType[MessageType["DISPLAY_NOTIFICATION"] = 3] = "DISPLAY_NOTIFICATION";
})(index_sw_esm2017_MessageType$1 || (index_sw_esm2017_MessageType$1 = {}));

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */
var index_sw_esm2017_MessageType;
(function (MessageType) {
  MessageType["PUSH_RECEIVED"] = "push-received";
  MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
})(index_sw_esm2017_MessageType || (index_sw_esm2017_MessageType = {}));

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function index_sw_esm2017_arrayToBase64(array) {
  const uint8Array = new Uint8Array(array);
  const base64String = btoa(String.fromCharCode(...uint8Array));
  return base64String.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function index_sw_esm2017_base64ToArray(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const index_sw_esm2017_OLD_DB_NAME = 'fcm_token_details_db';
/**
 * The last DB version of 'fcm_token_details_db' was 4. This is one higher, so that the upgrade
 * callback is called for all versions of the old DB.
 */
const index_sw_esm2017_OLD_DB_VERSION = 5;
const index_sw_esm2017_OLD_OBJECT_STORE_NAME = 'fcm_token_object_Store';
async function index_sw_esm2017_migrateOldDatabase(senderId) {
  if ('databases' in indexedDB) {
    // indexedDb.databases() is an IndexedDB v3 API and does not exist in all browsers. TODO: Remove
    // typecast when it lands in TS types.
    const databases = await indexedDB.databases();
    const dbNames = databases.map(db => db.name);
    if (!dbNames.includes(index_sw_esm2017_OLD_DB_NAME)) {
      // old DB didn't exist, no need to open.
      return null;
    }
  }
  let tokenDetails = null;
  const db = await openDB(index_sw_esm2017_OLD_DB_NAME, index_sw_esm2017_OLD_DB_VERSION, {
    upgrade: async (db, oldVersion, newVersion, upgradeTransaction) => {
      var _a;
      if (oldVersion < 2) {
        // Database too old, skip migration.
        return;
      }
      if (!db.objectStoreNames.contains(index_sw_esm2017_OLD_OBJECT_STORE_NAME)) {
        // Database did not exist. Nothing to do.
        return;
      }
      const objectStore = upgradeTransaction.objectStore(index_sw_esm2017_OLD_OBJECT_STORE_NAME);
      const value = await objectStore.index('fcmSenderId').get(senderId);
      await objectStore.clear();
      if (!value) {
        // No entry in the database, nothing to migrate.
        return;
      }
      if (oldVersion === 2) {
        const oldDetails = value;
        if (!oldDetails.auth || !oldDetails.p256dh || !oldDetails.endpoint) {
          return;
        }
        tokenDetails = {
          token: oldDetails.fcmToken,
          createTime: (_a = oldDetails.createTime) !== null && _a !== void 0 ? _a : Date.now(),
          subscriptionOptions: {
            auth: oldDetails.auth,
            p256dh: oldDetails.p256dh,
            endpoint: oldDetails.endpoint,
            swScope: oldDetails.swScope,
            vapidKey: typeof oldDetails.vapidKey === 'string' ? oldDetails.vapidKey : index_sw_esm2017_arrayToBase64(oldDetails.vapidKey)
          }
        };
      } else if (oldVersion === 3) {
        const oldDetails = value;
        tokenDetails = {
          token: oldDetails.fcmToken,
          createTime: oldDetails.createTime,
          subscriptionOptions: {
            auth: index_sw_esm2017_arrayToBase64(oldDetails.auth),
            p256dh: index_sw_esm2017_arrayToBase64(oldDetails.p256dh),
            endpoint: oldDetails.endpoint,
            swScope: oldDetails.swScope,
            vapidKey: index_sw_esm2017_arrayToBase64(oldDetails.vapidKey)
          }
        };
      } else if (oldVersion === 4) {
        const oldDetails = value;
        tokenDetails = {
          token: oldDetails.fcmToken,
          createTime: oldDetails.createTime,
          subscriptionOptions: {
            auth: index_sw_esm2017_arrayToBase64(oldDetails.auth),
            p256dh: index_sw_esm2017_arrayToBase64(oldDetails.p256dh),
            endpoint: oldDetails.endpoint,
            swScope: oldDetails.swScope,
            vapidKey: index_sw_esm2017_arrayToBase64(oldDetails.vapidKey)
          }
        };
      }
    }
  });
  db.close();
  // Delete all old databases.
  await deleteDB(index_sw_esm2017_OLD_DB_NAME);
  await deleteDB('fcm_vapid_details_db');
  await deleteDB('undefined');
  return index_sw_esm2017_checkTokenDetails(tokenDetails) ? tokenDetails : null;
}
function index_sw_esm2017_checkTokenDetails(tokenDetails) {
  if (!tokenDetails || !tokenDetails.subscriptionOptions) {
    return false;
  }
  const {
    subscriptionOptions
  } = tokenDetails;
  return typeof tokenDetails.createTime === 'number' && tokenDetails.createTime > 0 && typeof tokenDetails.token === 'string' && tokenDetails.token.length > 0 && typeof subscriptionOptions.auth === 'string' && subscriptionOptions.auth.length > 0 && typeof subscriptionOptions.p256dh === 'string' && subscriptionOptions.p256dh.length > 0 && typeof subscriptionOptions.endpoint === 'string' && subscriptionOptions.endpoint.length > 0 && typeof subscriptionOptions.swScope === 'string' && subscriptionOptions.swScope.length > 0 && typeof subscriptionOptions.vapidKey === 'string' && subscriptionOptions.vapidKey.length > 0;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Exported for tests.
const index_sw_esm2017_DATABASE_NAME = 'firebase-messaging-database';
const index_sw_esm2017_DATABASE_VERSION = 1;
const index_sw_esm2017_OBJECT_STORE_NAME = 'firebase-messaging-store';
let index_sw_esm2017_dbPromise = null;
function index_sw_esm2017_getDbPromise() {
  if (!index_sw_esm2017_dbPromise) {
    index_sw_esm2017_dbPromise = openDB(index_sw_esm2017_DATABASE_NAME, index_sw_esm2017_DATABASE_VERSION, {
      upgrade: (upgradeDb, oldVersion) => {
        // We don't use 'break' in this switch statement, the fall-through behavior is what we want,
        // because if there are multiple versions between the old version and the current version, we
        // want ALL the migrations that correspond to those versions to run, not only the last one.
        // eslint-disable-next-line default-case
        switch (oldVersion) {
          case 0:
            upgradeDb.createObjectStore(index_sw_esm2017_OBJECT_STORE_NAME);
        }
      }
    });
  }
  return index_sw_esm2017_dbPromise;
}
/** Gets record(s) from the objectStore that match the given key. */
async function index_sw_esm2017_dbGet(firebaseDependencies) {
  const key = index_sw_esm2017_getKey(firebaseDependencies);
  const db = await index_sw_esm2017_getDbPromise();
  const tokenDetails = await db.transaction(index_sw_esm2017_OBJECT_STORE_NAME).objectStore(index_sw_esm2017_OBJECT_STORE_NAME).get(key);
  if (tokenDetails) {
    return tokenDetails;
  } else {
    // Check if there is a tokenDetails object in the old DB.
    const oldTokenDetails = await index_sw_esm2017_migrateOldDatabase(firebaseDependencies.appConfig.senderId);
    if (oldTokenDetails) {
      await index_sw_esm2017_dbSet(firebaseDependencies, oldTokenDetails);
      return oldTokenDetails;
    }
  }
}
/** Assigns or overwrites the record for the given key with the given value. */
async function index_sw_esm2017_dbSet(firebaseDependencies, tokenDetails) {
  const key = index_sw_esm2017_getKey(firebaseDependencies);
  const db = await index_sw_esm2017_getDbPromise();
  const tx = db.transaction(index_sw_esm2017_OBJECT_STORE_NAME, 'readwrite');
  await tx.objectStore(index_sw_esm2017_OBJECT_STORE_NAME).put(tokenDetails, key);
  await tx.done;
  return tokenDetails;
}
/** Removes record(s) from the objectStore that match the given key. */
async function index_sw_esm2017_dbRemove(firebaseDependencies) {
  const key = index_sw_esm2017_getKey(firebaseDependencies);
  const db = await index_sw_esm2017_getDbPromise();
  const tx = db.transaction(index_sw_esm2017_OBJECT_STORE_NAME, 'readwrite');
  await tx.objectStore(index_sw_esm2017_OBJECT_STORE_NAME).delete(key);
  await tx.done;
}
function index_sw_esm2017_getKey({
  appConfig
}) {
  return appConfig.appId;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const index_sw_esm2017_ERROR_MAP = {
  ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */]: 'Missing App configuration value: "{$valueName}"',
  ["only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */]: 'This method is available in a Window context.',
  ["only-available-in-sw" /* ErrorCode.AVAILABLE_IN_SW */]: 'This method is available in a service worker context.',
  ["permission-default" /* ErrorCode.PERMISSION_DEFAULT */]: 'The notification permission was not granted and dismissed instead.',
  ["permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */]: 'The notification permission was not granted and blocked instead.',
  ["unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */]: "This browser doesn't support the API's required to use the Firebase SDK.",
  ["indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */]: "This browser doesn't support indexedDb.open() (ex. Safari iFrame, Firefox Private Browsing, etc)",
  ["failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */]: 'We are unable to register the default service worker. {$browserErrorMessage}',
  ["token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */]: 'A problem occurred while subscribing the user to FCM: {$errorInfo}',
  ["token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */]: 'FCM returned no token when subscribing the user to push.',
  ["token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */]: 'A problem occurred while unsubscribing the ' + 'user from FCM: {$errorInfo}',
  ["token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */]: 'A problem occurred while updating the user from FCM: {$errorInfo}',
  ["token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */]: 'FCM returned no token when updating the user to push.',
  ["use-sw-after-get-token" /* ErrorCode.USE_SW_AFTER_GET_TOKEN */]: 'The useServiceWorker() method may only be called once and must be ' + 'called before calling getToken() to ensure your service worker is used.',
  ["invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */]: 'The input to useServiceWorker() must be a ServiceWorkerRegistration.',
  ["invalid-bg-handler" /* ErrorCode.INVALID_BG_HANDLER */]: 'The input to setBackgroundMessageHandler() must be a function.',
  ["invalid-vapid-key" /* ErrorCode.INVALID_VAPID_KEY */]: 'The public VAPID key must be a string.',
  ["use-vapid-key-after-get-token" /* ErrorCode.USE_VAPID_KEY_AFTER_GET_TOKEN */]: 'The usePublicVapidKey() method may only be called once and must be ' + 'called before calling getToken() to ensure your VAPID key is used.'
};
const index_sw_esm2017_ERROR_FACTORY = new ErrorFactory('messaging', 'Messaging', index_sw_esm2017_ERROR_MAP);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function index_sw_esm2017_requestGetToken(firebaseDependencies, subscriptionOptions) {
  const headers = await index_sw_esm2017_getHeaders(firebaseDependencies);
  const body = index_sw_esm2017_getBody(subscriptionOptions);
  const subscribeOptions = {
    method: 'POST',
    headers,
    body: JSON.stringify(body)
  };
  let responseData;
  try {
    const response = await fetch(index_sw_esm2017_getEndpoint(firebaseDependencies.appConfig), subscribeOptions);
    responseData = await response.json();
  } catch (err) {
    throw index_sw_esm2017_ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */, {
      errorInfo: err === null || err === void 0 ? void 0 : err.toString()
    });
  }
  if (responseData.error) {
    const message = responseData.error.message;
    throw index_sw_esm2017_ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */, {
      errorInfo: message
    });
  }
  if (!responseData.token) {
    throw index_sw_esm2017_ERROR_FACTORY.create("token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */);
  }
  return responseData.token;
}
async function index_sw_esm2017_requestUpdateToken(firebaseDependencies, tokenDetails) {
  const headers = await index_sw_esm2017_getHeaders(firebaseDependencies);
  const body = index_sw_esm2017_getBody(tokenDetails.subscriptionOptions);
  const updateOptions = {
    method: 'PATCH',
    headers,
    body: JSON.stringify(body)
  };
  let responseData;
  try {
    const response = await fetch(`${index_sw_esm2017_getEndpoint(firebaseDependencies.appConfig)}/${tokenDetails.token}`, updateOptions);
    responseData = await response.json();
  } catch (err) {
    throw index_sw_esm2017_ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */, {
      errorInfo: err === null || err === void 0 ? void 0 : err.toString()
    });
  }
  if (responseData.error) {
    const message = responseData.error.message;
    throw index_sw_esm2017_ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */, {
      errorInfo: message
    });
  }
  if (!responseData.token) {
    throw index_sw_esm2017_ERROR_FACTORY.create("token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */);
  }
  return responseData.token;
}
async function index_sw_esm2017_requestDeleteToken(firebaseDependencies, token) {
  const headers = await index_sw_esm2017_getHeaders(firebaseDependencies);
  const unsubscribeOptions = {
    method: 'DELETE',
    headers
  };
  try {
    const response = await fetch(`${index_sw_esm2017_getEndpoint(firebaseDependencies.appConfig)}/${token}`, unsubscribeOptions);
    const responseData = await response.json();
    if (responseData.error) {
      const message = responseData.error.message;
      throw index_sw_esm2017_ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */, {
        errorInfo: message
      });
    }
  } catch (err) {
    throw index_sw_esm2017_ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */, {
      errorInfo: err === null || err === void 0 ? void 0 : err.toString()
    });
  }
}
function index_sw_esm2017_getEndpoint({
  projectId
}) {
  return `${index_sw_esm2017_ENDPOINT}/projects/${projectId}/registrations`;
}
async function index_sw_esm2017_getHeaders({
  appConfig,
  installations
}) {
  const authToken = await installations.getToken();
  return new Headers({
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'x-goog-api-key': appConfig.apiKey,
    'x-goog-firebase-installations-auth': `FIS ${authToken}`
  });
}
function index_sw_esm2017_getBody({
  p256dh,
  auth,
  endpoint,
  vapidKey
}) {
  const body = {
    web: {
      endpoint,
      auth,
      p256dh
    }
  };
  if (vapidKey !== index_sw_esm2017_DEFAULT_VAPID_KEY) {
    body.web.applicationPubKey = vapidKey;
  }
  return body;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// UpdateRegistration will be called once every week.
const index_sw_esm2017_TOKEN_EXPIRATION_MS = 7 * 24 * 60 * 60 * 1000; // 7 days
async function index_sw_esm2017_getTokenInternal(messaging) {
  const pushSubscription = await index_sw_esm2017_getPushSubscription(messaging.swRegistration, messaging.vapidKey);
  const subscriptionOptions = {
    vapidKey: messaging.vapidKey,
    swScope: messaging.swRegistration.scope,
    endpoint: pushSubscription.endpoint,
    auth: index_sw_esm2017_arrayToBase64(pushSubscription.getKey('auth')),
    p256dh: index_sw_esm2017_arrayToBase64(pushSubscription.getKey('p256dh'))
  };
  const tokenDetails = await index_sw_esm2017_dbGet(messaging.firebaseDependencies);
  if (!tokenDetails) {
    // No token, get a new one.
    return index_sw_esm2017_getNewToken(messaging.firebaseDependencies, subscriptionOptions);
  } else if (!index_sw_esm2017_isTokenValid(tokenDetails.subscriptionOptions, subscriptionOptions)) {
    // Invalid token, get a new one.
    try {
      await index_sw_esm2017_requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
    } catch (e) {
      // Suppress errors because of #2364
      console.warn(e);
    }
    return index_sw_esm2017_getNewToken(messaging.firebaseDependencies, subscriptionOptions);
  } else if (Date.now() >= tokenDetails.createTime + index_sw_esm2017_TOKEN_EXPIRATION_MS) {
    // Weekly token refresh
    return index_sw_esm2017_updateToken(messaging, {
      token: tokenDetails.token,
      createTime: Date.now(),
      subscriptionOptions
    });
  } else {
    // Valid token, nothing to do.
    return tokenDetails.token;
  }
}
/**
 * This method deletes the token from the database, unsubscribes the token from FCM, and unregisters
 * the push subscription if it exists.
 */
async function index_sw_esm2017_deleteTokenInternal(messaging) {
  const tokenDetails = await index_sw_esm2017_dbGet(messaging.firebaseDependencies);
  if (tokenDetails) {
    await index_sw_esm2017_requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
    await index_sw_esm2017_dbRemove(messaging.firebaseDependencies);
  }
  // Unsubscribe from the push subscription.
  const pushSubscription = await messaging.swRegistration.pushManager.getSubscription();
  if (pushSubscription) {
    return pushSubscription.unsubscribe();
  }
  // If there's no SW, consider it a success.
  return true;
}
async function index_sw_esm2017_updateToken(messaging, tokenDetails) {
  try {
    const updatedToken = await index_sw_esm2017_requestUpdateToken(messaging.firebaseDependencies, tokenDetails);
    const updatedTokenDetails = Object.assign(Object.assign({}, tokenDetails), {
      token: updatedToken,
      createTime: Date.now()
    });
    await index_sw_esm2017_dbSet(messaging.firebaseDependencies, updatedTokenDetails);
    return updatedToken;
  } catch (e) {
    throw e;
  }
}
async function index_sw_esm2017_getNewToken(firebaseDependencies, subscriptionOptions) {
  const token = await index_sw_esm2017_requestGetToken(firebaseDependencies, subscriptionOptions);
  const tokenDetails = {
    token,
    createTime: Date.now(),
    subscriptionOptions
  };
  await index_sw_esm2017_dbSet(firebaseDependencies, tokenDetails);
  return tokenDetails.token;
}
/**
 * Gets a PushSubscription for the current user.
 */
async function index_sw_esm2017_getPushSubscription(swRegistration, vapidKey) {
  const subscription = await swRegistration.pushManager.getSubscription();
  if (subscription) {
    return subscription;
  }
  return swRegistration.pushManager.subscribe({
    userVisibleOnly: true,
    // Chrome <= 75 doesn't support base64-encoded VAPID key. For backward compatibility, VAPID key
    // submitted to pushManager#subscribe must be of type Uint8Array.
    applicationServerKey: index_sw_esm2017_base64ToArray(vapidKey)
  });
}
/**
 * Checks if the saved tokenDetails object matches the configuration provided.
 */
function index_sw_esm2017_isTokenValid(dbOptions, currentOptions) {
  const isVapidKeyEqual = currentOptions.vapidKey === dbOptions.vapidKey;
  const isEndpointEqual = currentOptions.endpoint === dbOptions.endpoint;
  const isAuthEqual = currentOptions.auth === dbOptions.auth;
  const isP256dhEqual = currentOptions.p256dh === dbOptions.p256dh;
  return isVapidKeyEqual && isEndpointEqual && isAuthEqual && isP256dhEqual;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function index_sw_esm2017_externalizePayload(internalPayload) {
  const payload = {
    from: internalPayload.from,
    // eslint-disable-next-line camelcase
    collapseKey: internalPayload.collapse_key,
    // eslint-disable-next-line camelcase
    messageId: internalPayload.fcmMessageId
  };
  index_sw_esm2017_propagateNotificationPayload(payload, internalPayload);
  index_sw_esm2017_propagateDataPayload(payload, internalPayload);
  index_sw_esm2017_propagateFcmOptions(payload, internalPayload);
  return payload;
}
function index_sw_esm2017_propagateNotificationPayload(payload, messagePayloadInternal) {
  if (!messagePayloadInternal.notification) {
    return;
  }
  payload.notification = {};
  const title = messagePayloadInternal.notification.title;
  if (!!title) {
    payload.notification.title = title;
  }
  const body = messagePayloadInternal.notification.body;
  if (!!body) {
    payload.notification.body = body;
  }
  const image = messagePayloadInternal.notification.image;
  if (!!image) {
    payload.notification.image = image;
  }
  const icon = messagePayloadInternal.notification.icon;
  if (!!icon) {
    payload.notification.icon = icon;
  }
}
function index_sw_esm2017_propagateDataPayload(payload, messagePayloadInternal) {
  if (!messagePayloadInternal.data) {
    return;
  }
  payload.data = messagePayloadInternal.data;
}
function index_sw_esm2017_propagateFcmOptions(payload, messagePayloadInternal) {
  var _a, _b, _c, _d, _e;
  // fcmOptions.link value is written into notification.click_action. see more in b/232072111
  if (!messagePayloadInternal.fcmOptions && !((_a = messagePayloadInternal.notification) === null || _a === void 0 ? void 0 : _a.click_action)) {
    return;
  }
  payload.fcmOptions = {};
  const link = (_c = (_b = messagePayloadInternal.fcmOptions) === null || _b === void 0 ? void 0 : _b.link) !== null && _c !== void 0 ? _c : (_d = messagePayloadInternal.notification) === null || _d === void 0 ? void 0 : _d.click_action;
  if (!!link) {
    payload.fcmOptions.link = link;
  }
  // eslint-disable-next-line camelcase
  const analyticsLabel = (_e = messagePayloadInternal.fcmOptions) === null || _e === void 0 ? void 0 : _e.analytics_label;
  if (!!analyticsLabel) {
    payload.fcmOptions.analyticsLabel = analyticsLabel;
  }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function index_sw_esm2017_isConsoleMessage(data) {
  // This message has a campaign ID, meaning it was sent using the Firebase Console.
  return typeof data === 'object' && !!data && index_sw_esm2017_CONSOLE_CAMPAIGN_ID in data;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a promise that resolves after given time passes. */
function index_sw_esm2017_sleep(ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
index_sw_esm2017_mergeStrings('AzSCbw63g1R0nCw85jG8', 'Iaya3yLKwmgvh7cF0q4');
async function stageLog(messaging, internalPayload) {
  const fcmEvent = createFcmEvent(internalPayload, await messaging.firebaseDependencies.installations.getId());
  createAndEnqueueLogEvent(messaging, fcmEvent, internalPayload.productId);
}
function createFcmEvent(internalPayload, fid) {
  var _a, _b;
  const fcmEvent = {};
  /* eslint-disable camelcase */
  // some fields should always be non-null. Still check to ensure.
  if (!!internalPayload.from) {
    fcmEvent.project_number = internalPayload.from;
  }
  if (!!internalPayload.fcmMessageId) {
    fcmEvent.message_id = internalPayload.fcmMessageId;
  }
  fcmEvent.instance_id = fid;
  if (!!internalPayload.notification) {
    fcmEvent.message_type = index_sw_esm2017_MessageType$1.DISPLAY_NOTIFICATION.toString();
  } else {
    fcmEvent.message_type = index_sw_esm2017_MessageType$1.DATA_MESSAGE.toString();
  }
  fcmEvent.sdk_platform = SDK_PLATFORM_WEB.toString();
  fcmEvent.package_name = self.origin.replace(/(^\w+:|^)\/\//, '');
  if (!!internalPayload.collapse_key) {
    fcmEvent.collapse_key = internalPayload.collapse_key;
  }
  fcmEvent.event = EVENT_MESSAGE_DELIVERED.toString();
  if (!!((_a = internalPayload.fcmOptions) === null || _a === void 0 ? void 0 : _a.analytics_label)) {
    fcmEvent.analytics_label = (_b = internalPayload.fcmOptions) === null || _b === void 0 ? void 0 : _b.analytics_label;
  }
  /* eslint-enable camelcase */
  return fcmEvent;
}
function createAndEnqueueLogEvent(messaging, fcmEvent, productId) {
  const logEvent = {};
  /* eslint-disable camelcase */
  logEvent.event_time_ms = Math.floor(Date.now()).toString();
  logEvent.source_extension_json_proto3 = JSON.stringify({
    messaging_client_event: fcmEvent
  });
  if (!!productId) {
    logEvent.compliance_data = buildComplianceData(productId);
  }
  // eslint-disable-next-line camelcase
  messaging.logEvents.push(logEvent);
}
function buildComplianceData(productId) {
  const complianceData = {
    privacy_context: {
      prequest: {
        origin_associated_product_id: productId
      }
    }
  };
  return complianceData;
}
function index_sw_esm2017_mergeStrings(s1, s2) {
  const resultArray = [];
  for (let i = 0; i < s1.length; i++) {
    resultArray.push(s1.charAt(i));
    if (i < s2.length) {
      resultArray.push(s2.charAt(i));
    }
  }
  return resultArray.join('');
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function onSubChange(event, messaging) {
  var _a, _b;
  const {
    newSubscription
  } = event;
  if (!newSubscription) {
    // Subscription revoked, delete token
    await index_sw_esm2017_deleteTokenInternal(messaging);
    return;
  }
  const tokenDetails = await index_sw_esm2017_dbGet(messaging.firebaseDependencies);
  await index_sw_esm2017_deleteTokenInternal(messaging);
  messaging.vapidKey = (_b = (_a = tokenDetails === null || tokenDetails === void 0 ? void 0 : tokenDetails.subscriptionOptions) === null || _a === void 0 ? void 0 : _a.vapidKey) !== null && _b !== void 0 ? _b : index_sw_esm2017_DEFAULT_VAPID_KEY;
  await index_sw_esm2017_getTokenInternal(messaging);
}
async function onPush(event, messaging) {
  const internalPayload = getMessagePayloadInternal(event);
  if (!internalPayload) {
    // Failed to get parsed MessagePayload from the PushEvent. Skip handling the push.
    return;
  }
  // log to Firelog with user consent
  if (messaging.deliveryMetricsExportedToBigQueryEnabled) {
    await stageLog(messaging, internalPayload);
  }
  // foreground handling: eventually passed to onMessage hook
  const clientList = await getClientList();
  if (hasVisibleClients(clientList)) {
    return sendMessagePayloadInternalToWindows(clientList, internalPayload);
  }
  // background handling: display if possible and pass to onBackgroundMessage hook
  if (!!internalPayload.notification) {
    await showNotification(wrapInternalPayload(internalPayload));
  }
  if (!messaging) {
    return;
  }
  if (!!messaging.onBackgroundMessageHandler) {
    const payload = index_sw_esm2017_externalizePayload(internalPayload);
    if (typeof messaging.onBackgroundMessageHandler === 'function') {
      await messaging.onBackgroundMessageHandler(payload);
    } else {
      messaging.onBackgroundMessageHandler.next(payload);
    }
  }
}
async function onNotificationClick(event) {
  var _a, _b;
  const internalPayload = (_b = (_a = event.notification) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[FCM_MSG];
  if (!internalPayload) {
    return;
  } else if (event.action) {
    // User clicked on an action button. This will allow developers to act on action button clicks
    // by using a custom onNotificationClick listener that they define.
    return;
  }
  // Prevent other listeners from receiving the event
  event.stopImmediatePropagation();
  event.notification.close();
  // Note clicking on a notification with no link set will focus the Chrome's current tab.
  const link = getLink(internalPayload);
  if (!link) {
    return;
  }
  // FM should only open/focus links from app's origin.
  const url = new URL(link, self.location.href);
  const originUrl = new URL(self.location.origin);
  if (url.host !== originUrl.host) {
    return;
  }
  let client = await getWindowClient(url);
  if (!client) {
    client = await self.clients.openWindow(link);
    // Wait three seconds for the client to initialize and set up the message handler so that it
    // can receive the message.
    await index_sw_esm2017_sleep(3000);
  } else {
    client = await client.focus();
  }
  if (!client) {
    // Window Client will not be returned if it's for a third party origin.
    return;
  }
  internalPayload.messageType = index_sw_esm2017_MessageType.NOTIFICATION_CLICKED;
  internalPayload.isFirebaseMessaging = true;
  return client.postMessage(internalPayload);
}
function wrapInternalPayload(internalPayload) {
  const wrappedInternalPayload = Object.assign({}, internalPayload.notification);
  // Put the message payload under FCM_MSG name so we can identify the notification as being an FCM
  // notification vs a notification from somewhere else (i.e. normal web push or developer generated
  // notification).
  wrappedInternalPayload.data = {
    [FCM_MSG]: internalPayload
  };
  return wrappedInternalPayload;
}
function getMessagePayloadInternal({
  data
}) {
  if (!data) {
    return null;
  }
  try {
    return data.json();
  } catch (err) {
    // Not JSON so not an FCM message.
    return null;
  }
}
/**
 * @param url The URL to look for when focusing a client.
 * @return Returns an existing window client or a newly opened WindowClient.
 */
async function getWindowClient(url) {
  const clientList = await getClientList();
  for (const client of clientList) {
    const clientUrl = new URL(client.url, self.location.href);
    if (url.host === clientUrl.host) {
      return client;
    }
  }
  return null;
}
/**
 * @returns If there is currently a visible WindowClient, this method will resolve to true,
 * otherwise false.
 */
function hasVisibleClients(clientList) {
  return clientList.some(client => client.visibilityState === 'visible' &&
  // Ignore chrome-extension clients as that matches the background pages of extensions, which
  // are always considered visible for some reason.
  !client.url.startsWith('chrome-extension://'));
}
function sendMessagePayloadInternalToWindows(clientList, internalPayload) {
  internalPayload.isFirebaseMessaging = true;
  internalPayload.messageType = index_sw_esm2017_MessageType.PUSH_RECEIVED;
  for (const client of clientList) {
    client.postMessage(internalPayload);
  }
}
function getClientList() {
  return self.clients.matchAll({
    type: 'window',
    includeUncontrolled: true
    // TS doesn't know that "type: 'window'" means it'll return WindowClient[]
  });
}
function showNotification(notificationPayloadInternal) {
  var _a;
  // Note: Firefox does not support the maxActions property.
  // https://developer.mozilla.org/en-US/docs/Web/API/notification/maxActions
  const {
    actions
  } = notificationPayloadInternal;
  const {
    maxActions
  } = Notification;
  if (actions && maxActions && actions.length > maxActions) {
    console.warn(`This browser only supports ${maxActions} actions. The remaining actions will not be displayed.`);
  }
  return self.registration.showNotification(/* title= */(_a = notificationPayloadInternal.title) !== null && _a !== void 0 ? _a : '', notificationPayloadInternal);
}
function getLink(payload) {
  var _a, _b, _c;
  // eslint-disable-next-line camelcase
  const link = (_b = (_a = payload.fcmOptions) === null || _a === void 0 ? void 0 : _a.link) !== null && _b !== void 0 ? _b : (_c = payload.notification) === null || _c === void 0 ? void 0 : _c.click_action;
  if (link) {
    return link;
  }
  if (index_sw_esm2017_isConsoleMessage(payload.data)) {
    // Notification created in the Firebase Console. Redirect to origin.
    return self.location.origin;
  } else {
    return null;
  }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function index_sw_esm2017_extractAppConfig(app) {
  if (!app || !app.options) {
    throw index_sw_esm2017_getMissingValueError('App Configuration Object');
  }
  if (!app.name) {
    throw index_sw_esm2017_getMissingValueError('App Name');
  }
  // Required app config keys
  const configKeys = ['projectId', 'apiKey', 'appId', 'messagingSenderId'];
  const {
    options
  } = app;
  for (const keyName of configKeys) {
    if (!options[keyName]) {
      throw index_sw_esm2017_getMissingValueError(keyName);
    }
  }
  return {
    appName: app.name,
    projectId: options.projectId,
    apiKey: options.apiKey,
    appId: options.appId,
    senderId: options.messagingSenderId
  };
}
function index_sw_esm2017_getMissingValueError(valueName) {
  return index_sw_esm2017_ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */, {
    valueName
  });
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class index_sw_esm2017_MessagingService {
  constructor(app, installations, analyticsProvider) {
    // logging is only done with end user consent. Default to false.
    this.deliveryMetricsExportedToBigQueryEnabled = false;
    this.onBackgroundMessageHandler = null;
    this.onMessageHandler = null;
    this.logEvents = [];
    this.isLogServiceStarted = false;
    const appConfig = index_sw_esm2017_extractAppConfig(app);
    this.firebaseDependencies = {
      app,
      appConfig,
      installations,
      analyticsProvider
    };
  }
  _delete() {
    return Promise.resolve();
  }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const SwMessagingFactory = container => {
  const messaging = new index_sw_esm2017_MessagingService(container.getProvider('app').getImmediate(), container.getProvider('installations-internal').getImmediate(), container.getProvider('analytics-internal'));
  self.addEventListener('push', e => {
    e.waitUntil(onPush(e, messaging));
  });
  self.addEventListener('pushsubscriptionchange', e => {
    e.waitUntil(onSubChange(e, messaging));
  });
  self.addEventListener('notificationclick', e => {
    e.waitUntil(onNotificationClick(e));
  });
  return messaging;
};
/**
 * The messaging instance registered in sw is named differently than that of in client. This is
 * because both `registerMessagingInWindow` and `registerMessagingInSw` would be called in
 * `messaging-compat` and component with the same name can only be registered once.
 */
function registerMessagingInSw() {
  _registerComponent(new Component('messaging-sw', SwMessagingFactory, "PUBLIC" /* ComponentType.PUBLIC */));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Checks whether all required APIs exist within SW Context
 * @returns a Promise that resolves to a boolean.
 *
 * @public
 */
async function isSwSupported() {
  // firebase-js-sdk/issues/2393 reveals that idb#open in Safari iframe and Firefox private browsing
  // might be prohibited to run. In these contexts, an error would be thrown during the messaging
  // instantiating phase, informing the developers to import/call isSupported for special handling.
  return isIndexedDBAvailable() && (await validateIndexedDBOpenable()) && 'PushManager' in self && 'Notification' in self && ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') && PushSubscription.prototype.hasOwnProperty('getKey');
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function onBackgroundMessage$1(messaging, nextOrObserver) {
  if (self.document !== undefined) {
    throw index_sw_esm2017_ERROR_FACTORY.create("only-available-in-sw" /* ErrorCode.AVAILABLE_IN_SW */);
  }
  messaging.onBackgroundMessageHandler = nextOrObserver;
  return () => {
    messaging.onBackgroundMessageHandler = null;
  };
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _setDeliveryMetricsExportedToBigQueryEnabled(messaging, enable) {
  messaging.deliveryMetricsExportedToBigQueryEnabled = enable;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Retrieves a Firebase Cloud Messaging instance.
 *
 * @returns The Firebase Cloud Messaging instance associated with the provided firebase app.
 *
 * @public
 */
function getMessagingInSw(app = getApp()) {
  // Conscious decision to make this async check non-blocking during the messaging instance
  // initialization phase for performance consideration. An error would be thrown latter for
  // developer's information. Developers can then choose to import and call `isSupported` for
  // special handling.
  isSwSupported().then(isSupported => {
    // If `isSwSupported()` resolved, but returned false.
    if (!isSupported) {
      throw index_sw_esm2017_ERROR_FACTORY.create("unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */);
    }
  }, _ => {
    // If `isSwSupported()` rejected.
    throw index_sw_esm2017_ERROR_FACTORY.create("indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */);
  });
  return _getProvider(getModularInstance(app), 'messaging-sw').getImmediate();
}
/**
 * Called when a message is received while the app is in the background. An app is considered to be
 * in the background if no active window is displayed.
 *
 * @param messaging - The {@link Messaging} instance.
 * @param nextOrObserver - This function, or observer object with `next` defined, is called when a
 * message is received and the app is currently in the background.
 *
 * @returns To stop listening for messages execute this returned function
 *
 * @public
 */
function onBackgroundMessage(messaging, nextOrObserver) {
  messaging = index_esm2017_getModularInstance(messaging);
  return onBackgroundMessage$1(messaging, nextOrObserver);
}
/**
 * Enables or disables Firebase Cloud Messaging message delivery metrics export to BigQuery. By
 * default, message delivery metrics are not exported to BigQuery. Use this method to enable or
 * disable the export at runtime.
 *
 * @param messaging - The `FirebaseMessaging` instance.
 * @param enable - Whether Firebase Cloud Messaging should export message delivery metrics to
 * BigQuery.
 *
 * @public
 */
function experimentalSetDeliveryMetricsExportedToBigQueryEnabled(messaging, enable) {
  messaging = getModularInstance(messaging);
  return _setDeliveryMetricsExportedToBigQueryEnabled(messaging, enable);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
registerMessagingInSw();

;// CONCATENATED MODULE: ./node_modules/@firebase/messaging-compat/dist/esm/index.esm2017.js





const messaging_compat_dist_esm_index_esm2017_name = "@firebase/messaging-compat";
const messaging_compat_dist_esm_index_esm2017_version = "0.2.12";

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isSupported() {
  if (self && 'ServiceWorkerGlobalScope' in self) {
    // Running in ServiceWorker context
    return index_esm2017_isSwSupported();
  } else {
    // Assume we are in the window context.
    return index_esm2017_isWindowSupported();
  }
}
/**
 * Checks to see if the required APIs exist.
 * Unlike the modular version, it does not check if IndexedDB.open() is allowed
 * in order to keep isSupported() synchronous and maintain v8 compatibility.
 */
function index_esm2017_isWindowSupported() {
  return typeof window !== 'undefined' && index_esm2017_isIndexedDBAvailable() && index_esm2017_areCookiesEnabled() && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window && 'fetch' in window && ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') && PushSubscription.prototype.hasOwnProperty('getKey');
}
/**
 * Checks to see if the required APIs exist within SW Context.
 */
function index_esm2017_isSwSupported() {
  return index_esm2017_isIndexedDBAvailable() && 'PushManager' in self && 'Notification' in self && ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') && PushSubscription.prototype.hasOwnProperty('getKey');
}
class MessagingCompatImpl {
  constructor(app, _delegate) {
    this.app = app;
    this._delegate = _delegate;
    this.app = app;
    this._delegate = _delegate;
  }
  async getToken(options) {
    return index_esm2017_getToken(this._delegate, options);
  }
  async deleteToken() {
    return deleteToken(this._delegate);
  }
  onMessage(nextOrObserver) {
    return onMessage(this._delegate, nextOrObserver);
  }
  onBackgroundMessage(nextOrObserver) {
    return onBackgroundMessage(this._delegate, nextOrObserver);
  }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const messagingCompatFactory = container => {
  if (self && 'ServiceWorkerGlobalScope' in self) {
    // in sw
    return new MessagingCompatImpl(container.getProvider('app-compat').getImmediate(), container.getProvider('messaging-sw').getImmediate());
  } else {
    // in window
    return new MessagingCompatImpl(container.getProvider('app-compat').getImmediate(), container.getProvider('messaging').getImmediate());
  }
};
const NAMESPACE_EXPORTS = {
  isSupported
};
function registerMessagingCompat() {
  firebase.INTERNAL.registerComponent(new Component('messaging-compat', messagingCompatFactory, "PUBLIC" /* ComponentType.PUBLIC */).setServiceProps(NAMESPACE_EXPORTS));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
registerMessagingCompat();
firebase.registerVersion(messaging_compat_dist_esm_index_esm2017_name, messaging_compat_dist_esm_index_esm2017_version);
;// CONCATENATED MODULE: ./node_modules/firebase/compat/messaging/dist/esm/index.esm.js

;// CONCATENATED MODULE: ./src/utils/firebase.ts




var firebaseConfig = {
    apiKey: "AIzaSyAdYm6q8ULxD_fwl50Tw38iwt-iB8BSTeA",
    authDomain: "sapp-production.firebaseapp.com",
    projectId: "sapp-production",
    storageBucket: "sapp-production.appspot.com",
    messagingSenderId: "449510795495",
    appId: "1:449510795495:web:21518f2471e79446bb1a42"
};
if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
} else {
    firebase.app() // if already initialized, use that one
    ;
}
var messaging;
if (true) {
    if (firebase.messaging.isSupported()) {
        messaging = firebase.messaging();
    }
}
var getMessagingToken = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var currentToken;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    currentToken = "";
                    if (!messaging) return [
                        2
                    ];
                    return [
                        4,
                        messaging.getToken({
                            vapidKey: "BKzrvNvUJCjO3NXN4AJZVEmEebVryxkD8moFIYyb9A68ArcN1Hcl3DpsgTbWycwpZLVRsm"
                        })
                    ];
                case 1:
                    currentToken = _state.sent();
                    return [
                        2,
                        currentToken
                    ];
            }
        });
    });
    return function getMessagingToken() {
        return _ref.apply(this, arguments);
    };
}();
var onMessageListener = function() {
    return new Promise(function(resolve) {
        messaging.onMessage(function(payload) {
            resolve(payload);
        });
    });
};


/***/ }),

/***/ 72158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wu": function() { return /* binding */ trackGAEvent; }
/* harmony export */ });
/* unused harmony export initializeGA */
/* harmony import */ var react_ga4__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57604);

var initializeGA = function() {
    // Replace with your Measurement ID
    // It ideally comes from an environment variable
    react_ga4__WEBPACK_IMPORTED_MODULE_0__/* ["default"].initialize */ .ZP.initialize("G-6KFGPZK0M8" || 0);
// Don't forget to remove the console.log() statements
// when you are done
};
var trackGAEvent = function(action) {
    // Send GA4 Event
    react_ga4__WEBPACK_IMPORTED_MODULE_0__/* ["default"].event */ .ZP.event({
        category: action,
        action: action,
        label: action
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (initializeGA);



/***/ }),

/***/ 17617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EN": function() { return /* binding */ getTextSizeClass; },
/* harmony export */   "Pb": function() { return /* binding */ getPaddingVerticalClass; },
/* harmony export */   "qx": function() { return /* binding */ getPaddingHorizontalClass; }
/* harmony export */ });
var getTextSizeClass = function(size) {
    switch(size){
        case "small":
            return "text-[0.875rem] leading-4";
        case "medium":
            return "text-[1rem] leading-6";
        default:
            return "text-lg leading-6.5";
    }
};
var getPaddingVerticalClass = function(size) {
    return size === "large" ? "py-2.8" : "py-2";
};
var getPaddingHorizontalClass = function(size) {
    switch(size){
        case "small":
            return "px-7";
        case "medium":
            return "px-8";
        default:
            return "px-9";
    }
};


/***/ }),

/***/ 71836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C_": function() { return /* binding */ isPdfFile; },
/* harmony export */   "Ds": function() { return /* binding */ debounce; },
/* harmony export */   "Dw": function() { return /* binding */ getUserPrefix; },
/* harmony export */   "FK": function() { return /* binding */ convertUTCToLocalTime; },
/* harmony export */   "Fp": function() { return /* binding */ calculatePercentage; },
/* harmony export */   "KI": function() { return /* binding */ calculateTimeAgo; },
/* harmony export */   "O3": function() { return /* binding */ isMobileExtensive; },
/* harmony export */   "QV": function() { return /* binding */ roundNumber; },
/* harmony export */   "_F": function() { return /* binding */ convertLocalTimeToUTC; },
/* harmony export */   "aK": function() { return /* binding */ formatTimeToHourMinuteSecond; },
/* harmony export */   "ic": function() { return /* binding */ isMobileOrTablet; },
/* harmony export */   "ju": function() { return /* binding */ formatTimeOnlyHourMinute; },
/* harmony export */   "jw": function() { return /* binding */ getSelectOptions; },
/* harmony export */   "nx": function() { return /* binding */ convertSecondsToMinutesSeconds; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "qi": function() { return /* binding */ makeMenuLevel; },
/* harmony export */   "uG": function() { return /* binding */ getResolution; },
/* harmony export */   "wi": function() { return /* binding */ convertHourToDayLeft; }
/* harmony export */ });
/* unused harmony exports isMobile, formatPhoneNumber, percentConversion, isAppleDevice, isSafari */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72760);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10103);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79555);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43743);







function isMobile() {
    var toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i, 
    ];
    return toMatch.some(function(toMatchItem) {
        return navigator.userAgent.match(toMatchItem);
    });
}
function isMobileExtensive() {
    var check = false;
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substring(0, 4))) check = true;
    })(navigator.userAgent || window.opera);
    return check;
}
/**
 * Hàm này định dạng một chuỗi ngày giờ theo định dạng dd/mm/yyyy hh:mm
 * Ví dụ: 2023-11-01T03:50:32.094Z -> 12/10/2023 11:04
 * @param {string} dateString - Chuỗi ngày giờ đầu vào
 * @return {string} - Chuỗi ngày giờ đã định dạng hoặc - nếu không hợp lệ
 */ var formatDate = function(dateString, withoutTime) {
    // Kiểm tra nếu dateString không có hoặc không phải date
    if (!dateString || isNaN(Date.parse(dateString))) {
        // Trả về -
        return "-";
    }
    // Tạo một đối tượng Date từ chuỗi đầu vào
    var date = new Date(dateString);
    // Lấy các thành phần ngày, tháng, năm, giờ và phút từ đối tượng Date
    var day = date.getDate();
    var month = date.getMonth() + 1 // Tháng bắt đầu từ 0
    ;
    var year = date.getFullYear();
    var hour = date.getHours();
    var minute = date.getMinutes();
    // Định dạng các thành phần thành chuỗi hai chữ số
    var dayStr = day < 10 ? "0" + day : day;
    var monthStr = month < 10 ? "0" + month : month;
    var hourStr = hour < 10 ? "0" + hour : hour;
    var minuteStr = minute < 10 ? "0" + minute : minute;
    // Trả về chuỗi định dạng mong muốn
    if (withoutTime === true) {
        return "".concat(dayStr, "/").concat(monthStr, "/").concat(year);
    }
    return "".concat(dayStr, "/").concat(monthStr, "/").concat(year, " ").concat(hourStr, ":").concat(minuteStr);
};
/**
 * Hàm này chuyển đổi một số điện thoại thành định dạng phù hợp với số lượng chữ số
 * Ví dụ: xxxxxxxxxx -> xxxx xxx xxx
 * @param {string} phoneNumber - Số điện thoại đầu vào
 * @return {string} - Số điện thoại đã chuyển đổi hoặc - nếu không hợp lệ
 */ var formatPhoneNumber = function(phoneNumber) {
    // Kiểm tra nếu phoneNumber không có hoặc không phải số
    if (!phoneNumber || isNaN(Number(phoneNumber))) {
        // Trả về -
        return "-";
    }
    // Loại bỏ các ký tự không phải số từ phoneNumber
    phoneNumber = phoneNumber.replace(/\D/g, "");
    // Cắt chuỗi từ cuối trước 3 số cho 1 group, 2 group 3 số và 1 group x số
    var part1 = phoneNumber.slice(-3) // Lấy 3 ký tự cuối cùng
    ;
    var part2 = phoneNumber.slice(-6, -3) // Lấy 3 ký tự trước đó
    ;
    var part3 = phoneNumber.slice(0, -6) // Lấy phần còn lại
    ;
    // Trả về số điện thoại đã định dạng
    return "".concat(part3, " ").concat(part2, " ").concat(part1);
};
/**
 * Hàm này tính thời gian chênh lệch giữa thời gian hiện tại và một dấu thời gian cho trước,
 * và trả về một chuỗi định dạng người đọc có thể hiểu được, thể hiện khoảng thời gian trước đó.
 * @param {string} date - Dấu thời gian cần so sánh với thời gian hiện tại
 * @return {string} - Một chuỗi đã định dạng thể hiện sự chênh lệch thời gian
 */ var calculateTimeAgo = function(date) {
    if (!date) {
        return "";
    }
    var currentDateTime = new Date();
    var updatedDateTime = new Date(date);
    var currentUtcTime = Date.UTC(currentDateTime.getUTCFullYear(), currentDateTime.getUTCMonth(), currentDateTime.getUTCDate(), currentDateTime.getUTCHours(), currentDateTime.getUTCMinutes(), currentDateTime.getUTCSeconds(), currentDateTime.getUTCMilliseconds());
    var timeDifference = currentUtcTime - updatedDateTime.getTime();
    var secondsAgo = Math.floor(timeDifference / 1000);
    if (secondsAgo < 60) {
        return secondsAgo <= 0 ? "just now" : "".concat(secondsAgo, " seconds ago");
    }
    var minutesAgo = Math.floor(secondsAgo / 60);
    if (minutesAgo < 60) {
        return minutesAgo === 1 ? "1 min ago" : "".concat(minutesAgo, " mins ago");
    }
    var hoursAgo = Math.floor(minutesAgo / 60);
    if (hoursAgo < 24) {
        return hoursAgo === 1 ? "1 hour ago" : "".concat(hoursAgo, " hours ago");
    }
    var daysAgo = Math.floor(hoursAgo / 24);
    if (daysAgo >= 1) {
        var formatter = new Intl.DateTimeFormat("en-GB", {
            day: "numeric",
            month: "numeric",
            year: "numeric"
        });
        return "".concat(formatter.format(updatedDateTime));
    }
    return "";
};
/**
 * Hàm debounce giúp trì hoãn thực thi một hàm cho đến khi không có lời gọi mới sau một khoảng thời gian.
 *
 * @template T Loại hàm cần debounce.
 * @param {T} func Hàm cần được debounce.
 * @param {number} delay Thời gian trễ (milliseconds) trước khi hàm được thực thi sau lời gọi cuối cùng.
 * @returns {(...args: Parameters<T>) => void} Hàm debounce đã được tạo ra.
 */ var debounce = function(func, delay) {
    var timeoutId;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function() {
            return func.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(args));
        }, delay);
    };
};
/**
 * @description Return number percent with type: 80.99
 * @param {number} num: number
 * @return {*} The percentage value of num relative to total. Returns 0 if total is 0.
 */ var percentConversion = function(num) {
    return Math.round(num * 10000) / 100;
};
/**
 * @description Return number percent with type: 80
 * @param {number} num: number
 * @return {*}
 */ var roundNumber = function(num) {
    return Math.round(num * 100) / 100;
};
/**
 * @description Return number percent with type: 80
 * @param {number} num
 * @param {number} total
 * @return {number} The percentage value of num relative to total. Returns 0 if total is 0.
 */ var calculatePercentage = function(num, total) {
    if (total === 0) {
        return 0;
    }
    return (0,lodash__WEBPACK_IMPORTED_MODULE_0__.round)(num / total * 100, 2);
};
/**
 * @description Return number mm:ss
 * @param {number} num: number
 * @return {*}
 */ var convertSecondsToMinutesSeconds = function(seconds) {
    var minutes = Math.floor(seconds / 60);
    var remainingSeconds = seconds % 60;
    var formattedMinutes = String(minutes).padStart(2, "0");
    var formattedSeconds = String(remainingSeconds).padStart(2, "0");
    return "".concat(formattedMinutes, ":").concat(formattedSeconds);
};
var convertLocalTimeToUTC = function(currentTime) {
    var offsetMinutes = currentTime.getTimezoneOffset();
    var utcTime = new Date(currentTime.getTime() + offsetMinutes * 60 * 1000);
    return utcTime;
};
var convertUTCToLocalTime = function(utc_time) {
    return new Date(utc_time);
};
var convertHourToDayLeft = function(hours) {
    if (hours <= 0) {
        return 0;
    }
    var days = Math.ceil(hours / 24);
    return days;
};
// formatTime takes a time length in seconds and returns the time in
// minutes and seconds
var formatTimeToHourMinuteSecond = function(timeInSeconds) {
    var hours = Math.floor(timeInSeconds / 3600);
    var minutes = Math.floor(timeInSeconds % 3600 / 60);
    var seconds = Math.floor(timeInSeconds % 60);
    var formattedHours = String(hours).padStart(2, "0");
    var formattedMinutes = String(minutes).padStart(2, "0");
    var formattedSeconds = String(seconds).padStart(2, "0");
    return {
        hours: formattedHours,
        minutes: formattedMinutes,
        seconds: formattedSeconds
    };
};
var getResolution = function(bitrate) {
    switch(true){
        case bitrate <= 135440:
            return "144p";
        case bitrate <= 200792:
            return "240p";
        case bitrate <= 282126:
            return "360p";
        case bitrate <= 400000:
            return "480p";
        case bitrate <= 700000:
            return "720p";
        case bitrate <= 1000000:
            return "900p";
        case bitrate <= 1500000:
            return "1080p";
        case bitrate <= 2000000:
            return "1440p";
        case bitrate <= 3000000:
            return "2k";
        case bitrate <= 4000000:
            return "2k+";
        case bitrate <= 6000000:
            return "4k";
        default:
            return "4k+";
    }
};
var isAppleDevice = function() {
    return /Mac|iPod|iPhone|iPad/.test(navigator.platform);
};
var isSafari = function() {
    var userAgent = navigator.userAgent;
    var vendor = navigator.vendor;
    return /Safari/.test(userAgent) && /Apple Computer/.test(vendor) && !/Chrome/.test(userAgent);
};
var isMobileOrTablet = function() {
    return /Mobi|Tablet|iPad|iPhone/.test(navigator.userAgent);
};
var getSelectOptions = function(options, existedOption) {
    var key = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "value";
    return lodash__WEBPACK_IMPORTED_MODULE_0___default().chain([
        existedOption
    ]).compact() // loại bỏ undefined/null
    .concat(options !== null && options !== void 0 ? options : []) // gộp với options
    .filter(function(item) {
        return item[key];
    }) // lọc item có key
    .uniqBy(key) // loại trùng theo key
    .value();
};
var isPdfFile = function(fileName) {
    return fileName.toLowerCase().endsWith(".pdf");
};
/**
 * Hàm phân tích chuỗi thời gian thành đối tượng thời gian.
 *
 * @param {string} timeStr - Chuỗi thời gian cần phân tích.
 * @returns {dayjs} - Đối tượng thời gian sau khi phân tích.
 */ var parseTime = function(timeStr) {
    /**
   * Kiểm tra định dạng chuỗi thời gian.
   *
   * @param {string} timeStr - Chuỗi thời gian cần kiểm tra.
   * @returns {boolean} - True nếu chuỗi thời gian hợp lệ, false ngược lại.
   */ if (/^\d{2}:\d{2}$/.test(timeStr)) {
        /**
     * Chuỗi thời gian có định dạng HH:mm.
     *
     * @param {string} timeStr - Chuỗi thời gian cần phân tích.
     * @param {string} format - Định dạng chuỗi thời gian.
     * @returns {dayjs} - Đối tượng thời gian sau khi phân tích.
     */ return dayjs__WEBPACK_IMPORTED_MODULE_1___default()(timeStr, "HH:mm");
    } else if (/^\d{2}:\d{2}:\d{2}$/.test(timeStr)) {
        /**
     * Chuỗi thời gian có định dạng HH:mm:ss.
     *
     * @param {string} timeStr - Chuỗi thời gian cần phân tích.
     * @param {string} format - Định dạng chuỗi thời gian.
     * @returns {dayjs} - Đối tượng thời gian sau khi phân tích.
     */ return dayjs__WEBPACK_IMPORTED_MODULE_1___default()(timeStr, "HH:mm:ss");
    }
    /**
   * Chuỗi thời gian không hợp lệ.
   *
   * @returns {dayjs} - Đối tượng thời gian không hợp lệ.
   */ return dayjs__WEBPACK_IMPORTED_MODULE_1___default()(NaN);
};
/**
 * Hàm định dạng thời gian chỉ gồm giờ và phút.
 *
 * @param {string} rawTime - Thời gian nguyên thủy dưới dạng chuỗi.
 * @returns {string} - Thời gian định dạng chỉ gồm giờ và phút.
 */ var formatTimeOnlyHourMinute = function(rawTime) {
    /**
   * Sử dụng thư viện dayjs để định dạng thời gian.
   *
   * @param {string} rawTime - Thời gian nguyên thủy dưới dạng chuỗi.
   * @param {string} format - Định dạng thời gian.
   * @returns {string} - Thời gian định dạng.
   */ return dayjs__WEBPACK_IMPORTED_MODULE_1___default()(parseTime(rawTime)).format("HH:mm");
};
function makeMenuLevel(options) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return options.map(function(option, idx) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, option), {
            id: depth === 0 ? idx.toString() : "".concat(depth, ".").concat(idx),
            depth: depth,
            subItems: option.subItems && option.subItems.length > 0 ? makeMenuLevel(option.subItems, depth + 1) : undefined
        });
    });
}
var getUserPrefix = function(isTeacher) {
    return isTeacher ? src_constants__WEBPACK_IMPORTED_MODULE_2__/* .PageLink.TEACHERS */ .H_.TEACHERS : "";
};


/***/ }),

/***/ 3787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ AuthenticationManager; }
});

// UNUSED EXPORTS: setDeviceFirebaseToSession

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(51224);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(73782);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(52621);
// EXTERNAL MODULE: ./src/pages/api/user/index.ts
var user = __webpack_require__(59211);
// EXTERNAL MODULE: ./node_modules/merge-options/index.js
var merge_options = __webpack_require__(96359);
;// CONCATENATED MODULE: ./node_modules/merge-options/index.mjs
/**
 * Thin ESM wrapper for CJS named exports.
 *
 * Ref: https://redfin.engineering/node-modules-at-war-why-commonjs-and-es-modules-cant-get-along-9617135eeca1
 */


/* harmony default export */ var node_modules_merge_options = (merge_options);
;// CONCATENATED MODULE: ./node_modules/@react-native-async-storage/async-storage/lib/module/AsyncStorage.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// eslint-disable-next-line @typescript-eslint/ban-types

// eslint-disable-next-line @typescript-eslint/ban-types

const merge = node_modules_merge_options.bind({
  concatArrays: true,
  ignoreUndefined: true
});
function mergeLocalStorageItem(key, value) {
  const oldValue = window.localStorage.getItem(key);
  if (oldValue) {
    const oldObject = JSON.parse(oldValue);
    const newObject = JSON.parse(value);
    const nextValue = JSON.stringify(merge(oldObject, newObject));
    window.localStorage.setItem(key, nextValue);
  } else {
    window.localStorage.setItem(key, value);
  }
}
function createPromise(getValue, callback) {
  return new Promise((resolve, reject) => {
    try {
      const value = getValue();
      callback === null || callback === void 0 ? void 0 : callback(null, value);
      resolve(value);
    } catch (err) {
      callback === null || callback === void 0 ? void 0 : callback(err);
      reject(err);
    }
  });
}
function createPromiseAll(promises, callback, processResult) {
  return Promise.all(promises).then(result => {
    const value = (processResult === null || processResult === void 0 ? void 0 : processResult(result)) ?? null;
    callback === null || callback === void 0 ? void 0 : callback(null, value);
    return Promise.resolve(value);
  }, errors => {
    callback === null || callback === void 0 ? void 0 : callback(errors);
    return Promise.reject(errors);
  });
}
const AsyncStorage_AsyncStorage = {
  /**
   * Fetches `key` value.
   */
  getItem: (key, callback) => {
    return createPromise(() => window.localStorage.getItem(key), callback);
  },
  /**
   * Sets `value` for `key`.
   */
  setItem: (key, value, callback) => {
    return createPromise(() => window.localStorage.setItem(key, value), callback);
  },
  /**
   * Removes a `key`
   */
  removeItem: (key, callback) => {
    return createPromise(() => window.localStorage.removeItem(key), callback);
  },
  /**
   * Merges existing value with input value, assuming they are stringified JSON.
   */
  mergeItem: (key, value, callback) => {
    return createPromise(() => mergeLocalStorageItem(key, value), callback);
  },
  /**
   * Erases *all* AsyncStorage for the domain.
   */
  clear: callback => {
    return createPromise(() => window.localStorage.clear(), callback);
  },
  /**
   * Gets *all* keys known to the app, for all callers, libraries, etc.
   */
  getAllKeys: callback => {
    return createPromise(() => {
      const numberOfKeys = window.localStorage.length;
      const keys = [];
      for (let i = 0; i < numberOfKeys; i += 1) {
        const key = window.localStorage.key(i) || "";
        keys.push(key);
      }
      return keys;
    }, callback);
  },
  /**
   * (stub) Flushes any pending requests using a single batch call to get the data.
   */
  flushGetRequests: () => undefined,
  /**
   * multiGet resolves to an array of key-value pair arrays that matches the
   * input format of multiSet.
   *
   *   multiGet(['k1', 'k2']) -> [['k1', 'val1'], ['k2', 'val2']]
   */
  multiGet: (keys, callback) => {
    const promises = keys.map(key => AsyncStorage_AsyncStorage.getItem(key));
    const processResult = result => result.map((value, i) => [keys[i], value]);
    return createPromiseAll(promises, callback, processResult);
  },
  /**
   * Takes an array of key-value array pairs.
   *   multiSet([['k1', 'val1'], ['k2', 'val2']])
   */
  multiSet: (keyValuePairs, callback) => {
    const promises = keyValuePairs.map(item => AsyncStorage_AsyncStorage.setItem(item[0], item[1]));
    return createPromiseAll(promises, callback);
  },
  /**
   * Delete all the keys in the `keys` array.
   */
  multiRemove: (keys, callback) => {
    const promises = keys.map(key => AsyncStorage_AsyncStorage.removeItem(key));
    return createPromiseAll(promises, callback);
  },
  /**
   * Takes an array of key-value array pairs and merges them with existing
   * values, assuming they are stringified JSON.
   *
   *   multiMerge([['k1', 'val1'], ['k2', 'val2']])
   */
  multiMerge: (keyValuePairs, callback) => {
    const promises = keyValuePairs.map(item => AsyncStorage_AsyncStorage.mergeItem(item[0], item[1]));
    return createPromiseAll(promises, callback);
  }
};
/* harmony default export */ var module_AsyncStorage = (AsyncStorage_AsyncStorage);
;// CONCATENATED MODULE: ./node_modules/@react-native-async-storage/async-storage/lib/module/hooks.js

function useAsyncStorage(key) {
  return {
    getItem: (...args) => AsyncStorage.getItem(key, ...args),
    setItem: (...args) => AsyncStorage.setItem(key, ...args),
    mergeItem: (...args) => AsyncStorage.mergeItem(key, ...args),
    removeItem: (...args) => AsyncStorage.removeItem(key, ...args)
  };
}
;// CONCATENATED MODULE: ./node_modules/@react-native-async-storage/async-storage/lib/module/index.js


/* harmony default export */ var lib_module = (module_AsyncStorage);
// EXTERNAL MODULE: ./src/services/requestV2.ts
var requestV2 = __webpack_require__(91002);
// EXTERNAL MODULE: ./src/utils/constants/index.ts + 3 modules
var constants = __webpack_require__(15183);
// EXTERNAL MODULE: ./src/utils/firebase.ts + 13 modules
var firebase = __webpack_require__(83509);
// EXTERNAL MODULE: ./node_modules/js-sha256/src/sha256.js
var sha256 = __webpack_require__(47097);
;// CONCATENATED MODULE: ./node_modules/jwt-decode/build/esm/index.js
class InvalidTokenError extends Error {}
InvalidTokenError.prototype.name = "InvalidTokenError";
function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, (m, p) => {
    let code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = "0" + code;
    }
    return "%" + code;
  }));
}
function base64UrlDecode(str) {
  let output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return b64DecodeUnicode(output);
  } catch (err) {
    return atob(output);
  }
}
function jwtDecode(token, options) {
  if (typeof token !== "string") {
    throw new InvalidTokenError("Invalid token specified: must be a string");
  }
  options || (options = {});
  const pos = options.header === true ? 0 : 1;
  const part = token.split(".")[pos];
  if (typeof part !== "string") {
    throw new InvalidTokenError(`Invalid token specified: missing part #${pos + 1}`);
  }
  let decoded;
  try {
    decoded = base64UrlDecode(part);
  } catch (e) {
    throw new InvalidTokenError(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
  }
  try {
    return JSON.parse(decoded);
  } catch (e) {
    throw new InvalidTokenError(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
  }
}
;// CONCATENATED MODULE: ./node_modules/keycloak-js/dist/keycloak.mjs



/*
 * Copyright 2016 Red Hat, Inc. and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

if (typeof Promise === 'undefined') {
  throw Error('Keycloak requires an environment that supports Promises. Make sure that you include the appropriate polyfill.');
}
function Keycloak(config) {
  if (!(this instanceof Keycloak)) {
    throw new Error("The 'Keycloak' constructor must be invoked with 'new'.");
  }
  var kc = this;
  var adapter;
  var refreshQueue = [];
  var callbackStorage;
  var loginIframe = {
    enable: true,
    callbackList: [],
    interval: 5
  };
  var scripts = document.getElementsByTagName('script');
  for (var i = 0; i < scripts.length; i++) {
    if ((scripts[i].src.indexOf('keycloak.js') !== -1 || scripts[i].src.indexOf('keycloak.min.js') !== -1) && scripts[i].src.indexOf('version=') !== -1) {
      kc.iframeVersion = scripts[i].src.substring(scripts[i].src.indexOf('version=') + 8).split('&')[0];
    }
  }
  var useNonce = true;
  var logInfo = createLogger(console.info);
  var logWarn = createLogger(console.warn);
  kc.init = function (initOptions) {
    if (kc.didInitialize) {
      throw new Error("A 'Keycloak' instance can only be initialized once.");
    }
    kc.didInitialize = true;
    kc.authenticated = false;
    callbackStorage = createCallbackStorage();
    var adapters = ['default', 'cordova', 'cordova-native'];
    if (initOptions && adapters.indexOf(initOptions.adapter) > -1) {
      adapter = loadAdapter(initOptions.adapter);
    } else if (initOptions && typeof initOptions.adapter === "object") {
      adapter = initOptions.adapter;
    } else {
      if (window.Cordova || window.cordova) {
        adapter = loadAdapter('cordova');
      } else {
        adapter = loadAdapter();
      }
    }
    if (initOptions) {
      if (typeof initOptions.useNonce !== 'undefined') {
        useNonce = initOptions.useNonce;
      }
      if (typeof initOptions.checkLoginIframe !== 'undefined') {
        loginIframe.enable = initOptions.checkLoginIframe;
      }
      if (initOptions.checkLoginIframeInterval) {
        loginIframe.interval = initOptions.checkLoginIframeInterval;
      }
      if (initOptions.onLoad === 'login-required') {
        kc.loginRequired = true;
      }
      if (initOptions.responseMode) {
        if (initOptions.responseMode === 'query' || initOptions.responseMode === 'fragment') {
          kc.responseMode = initOptions.responseMode;
        } else {
          throw 'Invalid value for responseMode';
        }
      }
      if (initOptions.flow) {
        switch (initOptions.flow) {
          case 'standard':
            kc.responseType = 'code';
            break;
          case 'implicit':
            kc.responseType = 'id_token token';
            break;
          case 'hybrid':
            kc.responseType = 'code id_token token';
            break;
          default:
            throw 'Invalid value for flow';
        }
        kc.flow = initOptions.flow;
      }
      if (initOptions.timeSkew != null) {
        kc.timeSkew = initOptions.timeSkew;
      }
      if (initOptions.redirectUri) {
        kc.redirectUri = initOptions.redirectUri;
      }
      if (initOptions.silentCheckSsoRedirectUri) {
        kc.silentCheckSsoRedirectUri = initOptions.silentCheckSsoRedirectUri;
      }
      if (typeof initOptions.silentCheckSsoFallback === 'boolean') {
        kc.silentCheckSsoFallback = initOptions.silentCheckSsoFallback;
      } else {
        kc.silentCheckSsoFallback = true;
      }
      if (typeof initOptions.pkceMethod !== "undefined") {
        if (initOptions.pkceMethod !== "S256" && initOptions.pkceMethod !== false) {
          throw new TypeError(`Invalid value for pkceMethod', expected 'S256' or false but got ${initOptions.pkceMethod}.`);
        }
        kc.pkceMethod = initOptions.pkceMethod;
      } else {
        kc.pkceMethod = "S256";
      }
      if (typeof initOptions.enableLogging === 'boolean') {
        kc.enableLogging = initOptions.enableLogging;
      } else {
        kc.enableLogging = false;
      }
      if (initOptions.logoutMethod === 'POST') {
        kc.logoutMethod = 'POST';
      } else {
        kc.logoutMethod = 'GET';
      }
      if (typeof initOptions.scope === 'string') {
        kc.scope = initOptions.scope;
      }
      if (typeof initOptions.acrValues === 'string') {
        kc.acrValues = initOptions.acrValues;
      }
      if (typeof initOptions.messageReceiveTimeout === 'number' && initOptions.messageReceiveTimeout > 0) {
        kc.messageReceiveTimeout = initOptions.messageReceiveTimeout;
      } else {
        kc.messageReceiveTimeout = 10000;
      }
    }
    if (!kc.responseMode) {
      kc.responseMode = 'fragment';
    }
    if (!kc.responseType) {
      kc.responseType = 'code';
      kc.flow = 'standard';
    }
    var promise = createPromise();
    var initPromise = createPromise();
    initPromise.promise.then(function () {
      kc.onReady && kc.onReady(kc.authenticated);
      promise.setSuccess(kc.authenticated);
    }).catch(function (error) {
      promise.setError(error);
    });
    var configPromise = loadConfig();
    function onLoad() {
      var doLogin = function (prompt) {
        if (!prompt) {
          options.prompt = 'none';
        }
        if (initOptions && initOptions.locale) {
          options.locale = initOptions.locale;
        }
        kc.login(options).then(function () {
          initPromise.setSuccess();
        }).catch(function (error) {
          initPromise.setError(error);
        });
      };
      var checkSsoSilently = function () {
        var ifrm = document.createElement("iframe");
        var src = kc.createLoginUrl({
          prompt: 'none',
          redirectUri: kc.silentCheckSsoRedirectUri
        });
        ifrm.setAttribute("src", src);
        ifrm.setAttribute("sandbox", "allow-storage-access-by-user-activation allow-scripts allow-same-origin");
        ifrm.setAttribute("title", "keycloak-silent-check-sso");
        ifrm.style.display = "none";
        document.body.appendChild(ifrm);
        var messageCallback = function (event) {
          if (event.origin !== window.location.origin || ifrm.contentWindow !== event.source) {
            return;
          }
          var oauth = parseCallback(event.data);
          processCallback(oauth, initPromise);
          document.body.removeChild(ifrm);
          window.removeEventListener("message", messageCallback);
        };
        window.addEventListener("message", messageCallback);
      };
      var options = {};
      switch (initOptions.onLoad) {
        case 'check-sso':
          if (loginIframe.enable) {
            setupCheckLoginIframe().then(function () {
              checkLoginIframe().then(function (unchanged) {
                if (!unchanged) {
                  kc.silentCheckSsoRedirectUri ? checkSsoSilently() : doLogin(false);
                } else {
                  initPromise.setSuccess();
                }
              }).catch(function (error) {
                initPromise.setError(error);
              });
            });
          } else {
            kc.silentCheckSsoRedirectUri ? checkSsoSilently() : doLogin(false);
          }
          break;
        case 'login-required':
          doLogin(true);
          break;
        default:
          throw 'Invalid value for onLoad';
      }
    }
    function processInit() {
      var callback = parseCallback(window.location.href);
      if (callback) {
        window.history.replaceState(window.history.state, null, callback.newUrl);
      }
      if (callback && callback.valid) {
        return setupCheckLoginIframe().then(function () {
          processCallback(callback, initPromise);
        }).catch(function (error) {
          initPromise.setError(error);
        });
      } else if (initOptions) {
        if (initOptions.token && initOptions.refreshToken) {
          setToken(initOptions.token, initOptions.refreshToken, initOptions.idToken);
          if (loginIframe.enable) {
            setupCheckLoginIframe().then(function () {
              checkLoginIframe().then(function (unchanged) {
                if (unchanged) {
                  kc.onAuthSuccess && kc.onAuthSuccess();
                  initPromise.setSuccess();
                  scheduleCheckIframe();
                } else {
                  initPromise.setSuccess();
                }
              }).catch(function (error) {
                initPromise.setError(error);
              });
            });
          } else {
            kc.updateToken(-1).then(function () {
              kc.onAuthSuccess && kc.onAuthSuccess();
              initPromise.setSuccess();
            }).catch(function (error) {
              kc.onAuthError && kc.onAuthError();
              if (initOptions.onLoad) {
                onLoad();
              } else {
                initPromise.setError(error);
              }
            });
          }
        } else if (initOptions.onLoad) {
          onLoad();
        } else {
          initPromise.setSuccess();
        }
      } else {
        initPromise.setSuccess();
      }
    }
    function domReady() {
      var promise = createPromise();
      var checkReadyState = function () {
        if (document.readyState === 'interactive' || document.readyState === 'complete') {
          document.removeEventListener('readystatechange', checkReadyState);
          promise.setSuccess();
        }
      };
      document.addEventListener('readystatechange', checkReadyState);
      checkReadyState(); // just in case the event was already fired and we missed it (in case the init is done later than at the load time, i.e. it's done from code)

      return promise.promise;
    }
    configPromise.then(function () {
      domReady().then(check3pCookiesSupported).then(processInit).catch(function (error) {
        promise.setError(error);
      });
    });
    configPromise.catch(function (error) {
      promise.setError(error);
    });
    return promise.promise;
  };
  kc.login = function (options) {
    return adapter.login(options);
  };
  function generateRandomData(len) {
    // use web crypto APIs if possible
    var array = null;
    var crypto = window.crypto || window.msCrypto;
    if (crypto && crypto.getRandomValues && window.Uint8Array) {
      array = new Uint8Array(len);
      crypto.getRandomValues(array);
      return array;
    }

    // fallback to Math random
    array = new Array(len);
    for (var j = 0; j < array.length; j++) {
      array[j] = Math.floor(256 * Math.random());
    }
    return array;
  }
  function generateCodeVerifier(len) {
    return generateRandomString(len, 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789');
  }
  function generateRandomString(len, alphabet) {
    var randomData = generateRandomData(len);
    var chars = new Array(len);
    for (var i = 0; i < len; i++) {
      chars[i] = alphabet.charCodeAt(randomData[i] % alphabet.length);
    }
    return String.fromCharCode.apply(null, chars);
  }
  function generatePkceChallenge(pkceMethod, codeVerifier) {
    if (pkceMethod !== "S256") {
      throw new TypeError(`Invalid value for 'pkceMethod', expected 'S256' but got '${pkceMethod}'.`);
    }

    // hash codeVerifier, then encode as url-safe base64 without padding
    const hashBytes = new Uint8Array(sha256.arrayBuffer(codeVerifier));
    const encodedHash = bytesToBase64(hashBytes).replace(/\+/g, '-').replace(/\//g, '_').replace(/\=/g, '');
    return encodedHash;
  }
  function buildClaimsParameter(requestedAcr) {
    var claims = {
      id_token: {
        acr: requestedAcr
      }
    };
    return JSON.stringify(claims);
  }
  kc.createLoginUrl = function (options) {
    var state = createUUID();
    var nonce = createUUID();
    var redirectUri = adapter.redirectUri(options);
    var callbackState = {
      state: state,
      nonce: nonce,
      redirectUri: encodeURIComponent(redirectUri),
      loginOptions: options
    };
    if (options && options.prompt) {
      callbackState.prompt = options.prompt;
    }
    var baseUrl;
    if (options && options.action == 'register') {
      baseUrl = kc.endpoints.register();
    } else {
      baseUrl = kc.endpoints.authorize();
    }
    var scope = options && options.scope || kc.scope;
    if (!scope) {
      // if scope is not set, default to "openid"
      scope = "openid";
    } else if (scope.indexOf("openid") === -1) {
      // if openid scope is missing, prefix the given scopes with it
      scope = "openid " + scope;
    }
    var url = baseUrl + '?client_id=' + encodeURIComponent(kc.clientId) + '&redirect_uri=' + encodeURIComponent(redirectUri) + '&state=' + encodeURIComponent(state) + '&response_mode=' + encodeURIComponent(kc.responseMode) + '&response_type=' + encodeURIComponent(kc.responseType) + '&scope=' + encodeURIComponent(scope);
    if (useNonce) {
      url = url + '&nonce=' + encodeURIComponent(nonce);
    }
    if (options && options.prompt) {
      url += '&prompt=' + encodeURIComponent(options.prompt);
    }
    if (options && options.maxAge) {
      url += '&max_age=' + encodeURIComponent(options.maxAge);
    }
    if (options && options.loginHint) {
      url += '&login_hint=' + encodeURIComponent(options.loginHint);
    }
    if (options && options.idpHint) {
      url += '&kc_idp_hint=' + encodeURIComponent(options.idpHint);
    }
    if (options && options.action && options.action != 'register') {
      url += '&kc_action=' + encodeURIComponent(options.action);
    }
    if (options && options.locale) {
      url += '&ui_locales=' + encodeURIComponent(options.locale);
    }
    if (options && options.acr) {
      var claimsParameter = buildClaimsParameter(options.acr);
      url += '&claims=' + encodeURIComponent(claimsParameter);
    }
    if (options && options.acrValues || kc.acrValues) {
      url += '&acr_values=' + encodeURIComponent(options.acrValues || kc.acrValues);
    }
    if (kc.pkceMethod) {
      var codeVerifier = generateCodeVerifier(96);
      callbackState.pkceCodeVerifier = codeVerifier;
      var pkceChallenge = generatePkceChallenge(kc.pkceMethod, codeVerifier);
      url += '&code_challenge=' + pkceChallenge;
      url += '&code_challenge_method=' + kc.pkceMethod;
    }
    callbackStorage.add(callbackState);
    return url;
  };
  kc.logout = function (options) {
    return adapter.logout(options);
  };
  kc.createLogoutUrl = function (options) {
    const logoutMethod = options?.logoutMethod ?? kc.logoutMethod;
    if (logoutMethod === 'POST') {
      return kc.endpoints.logout();
    }
    var url = kc.endpoints.logout() + '?client_id=' + encodeURIComponent(kc.clientId) + '&post_logout_redirect_uri=' + encodeURIComponent(adapter.redirectUri(options, false));
    if (kc.idToken) {
      url += '&id_token_hint=' + encodeURIComponent(kc.idToken);
    }
    return url;
  };
  kc.register = function (options) {
    return adapter.register(options);
  };
  kc.createRegisterUrl = function (options) {
    if (!options) {
      options = {};
    }
    options.action = 'register';
    return kc.createLoginUrl(options);
  };
  kc.createAccountUrl = function (options) {
    var realm = getRealmUrl();
    var url = undefined;
    if (typeof realm !== 'undefined') {
      url = realm + '/account' + '?referrer=' + encodeURIComponent(kc.clientId) + '&referrer_uri=' + encodeURIComponent(adapter.redirectUri(options));
    }
    return url;
  };
  kc.accountManagement = function () {
    return adapter.accountManagement();
  };
  kc.hasRealmRole = function (role) {
    var access = kc.realmAccess;
    return !!access && access.roles.indexOf(role) >= 0;
  };
  kc.hasResourceRole = function (role, resource) {
    if (!kc.resourceAccess) {
      return false;
    }
    var access = kc.resourceAccess[resource || kc.clientId];
    return !!access && access.roles.indexOf(role) >= 0;
  };
  kc.loadUserProfile = function () {
    var url = getRealmUrl() + '/account';
    var req = new XMLHttpRequest();
    req.open('GET', url, true);
    req.setRequestHeader('Accept', 'application/json');
    req.setRequestHeader('Authorization', 'bearer ' + kc.token);
    var promise = createPromise();
    req.onreadystatechange = function () {
      if (req.readyState == 4) {
        if (req.status == 200) {
          kc.profile = JSON.parse(req.responseText);
          promise.setSuccess(kc.profile);
        } else {
          promise.setError();
        }
      }
    };
    req.send();
    return promise.promise;
  };
  kc.loadUserInfo = function () {
    var url = kc.endpoints.userinfo();
    var req = new XMLHttpRequest();
    req.open('GET', url, true);
    req.setRequestHeader('Accept', 'application/json');
    req.setRequestHeader('Authorization', 'bearer ' + kc.token);
    var promise = createPromise();
    req.onreadystatechange = function () {
      if (req.readyState == 4) {
        if (req.status == 200) {
          kc.userInfo = JSON.parse(req.responseText);
          promise.setSuccess(kc.userInfo);
        } else {
          promise.setError();
        }
      }
    };
    req.send();
    return promise.promise;
  };
  kc.isTokenExpired = function (minValidity) {
    if (!kc.tokenParsed || !kc.refreshToken && kc.flow != 'implicit') {
      throw 'Not authenticated';
    }
    if (kc.timeSkew == null) {
      logInfo('[KEYCLOAK] Unable to determine if token is expired as timeskew is not set');
      return true;
    }
    var expiresIn = kc.tokenParsed['exp'] - Math.ceil(new Date().getTime() / 1000) + kc.timeSkew;
    if (minValidity) {
      if (isNaN(minValidity)) {
        throw 'Invalid minValidity';
      }
      expiresIn -= minValidity;
    }
    return expiresIn < 0;
  };
  kc.updateToken = function (minValidity) {
    var promise = createPromise();
    if (!kc.refreshToken) {
      promise.setError();
      return promise.promise;
    }
    minValidity = minValidity || 5;
    var exec = function () {
      var refreshToken = false;
      if (minValidity == -1) {
        refreshToken = true;
        logInfo('[KEYCLOAK] Refreshing token: forced refresh');
      } else if (!kc.tokenParsed || kc.isTokenExpired(minValidity)) {
        refreshToken = true;
        logInfo('[KEYCLOAK] Refreshing token: token expired');
      }
      if (!refreshToken) {
        promise.setSuccess(false);
      } else {
        var params = 'grant_type=refresh_token&' + 'refresh_token=' + kc.refreshToken;
        var url = kc.endpoints.token();
        refreshQueue.push(promise);
        if (refreshQueue.length == 1) {
          var req = new XMLHttpRequest();
          req.open('POST', url, true);
          req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
          req.withCredentials = true;
          params += '&client_id=' + encodeURIComponent(kc.clientId);
          var timeLocal = new Date().getTime();
          req.onreadystatechange = function () {
            if (req.readyState == 4) {
              if (req.status == 200) {
                logInfo('[KEYCLOAK] Token refreshed');
                timeLocal = (timeLocal + new Date().getTime()) / 2;
                var tokenResponse = JSON.parse(req.responseText);
                setToken(tokenResponse['access_token'], tokenResponse['refresh_token'], tokenResponse['id_token'], timeLocal);
                kc.onAuthRefreshSuccess && kc.onAuthRefreshSuccess();
                for (var p = refreshQueue.pop(); p != null; p = refreshQueue.pop()) {
                  p.setSuccess(true);
                }
              } else {
                logWarn('[KEYCLOAK] Failed to refresh token');
                if (req.status == 400) {
                  kc.clearToken();
                }
                kc.onAuthRefreshError && kc.onAuthRefreshError();
                for (var p = refreshQueue.pop(); p != null; p = refreshQueue.pop()) {
                  p.setError(true);
                }
              }
            }
          };
          req.send(params);
        }
      }
    };
    if (loginIframe.enable) {
      var iframePromise = checkLoginIframe();
      iframePromise.then(function () {
        exec();
      }).catch(function (error) {
        promise.setError(error);
      });
    } else {
      exec();
    }
    return promise.promise;
  };
  kc.clearToken = function () {
    if (kc.token) {
      setToken(null, null, null);
      kc.onAuthLogout && kc.onAuthLogout();
      if (kc.loginRequired) {
        kc.login();
      }
    }
  };
  function getRealmUrl() {
    if (typeof kc.authServerUrl !== 'undefined') {
      if (kc.authServerUrl.charAt(kc.authServerUrl.length - 1) == '/') {
        return kc.authServerUrl + 'realms/' + encodeURIComponent(kc.realm);
      } else {
        return kc.authServerUrl + '/realms/' + encodeURIComponent(kc.realm);
      }
    } else {
      return undefined;
    }
  }
  function getOrigin() {
    if (!window.location.origin) {
      return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    } else {
      return window.location.origin;
    }
  }
  function processCallback(oauth, promise) {
    var code = oauth.code;
    var error = oauth.error;
    var prompt = oauth.prompt;
    var timeLocal = new Date().getTime();
    if (oauth['kc_action_status']) {
      kc.onActionUpdate && kc.onActionUpdate(oauth['kc_action_status']);
    }
    if (error) {
      if (prompt != 'none') {
        if (oauth.error_description && oauth.error_description === "authentication_expired") {
          kc.login(oauth.loginOptions);
        } else {
          var errorData = {
            error: error,
            error_description: oauth.error_description
          };
          kc.onAuthError && kc.onAuthError(errorData);
          promise && promise.setError(errorData);
        }
      } else {
        promise && promise.setSuccess();
      }
      return;
    } else if (kc.flow != 'standard' && (oauth.access_token || oauth.id_token)) {
      authSuccess(oauth.access_token, null, oauth.id_token, true);
    }
    if (kc.flow != 'implicit' && code) {
      var params = 'code=' + code + '&grant_type=authorization_code';
      var url = kc.endpoints.token();
      var req = new XMLHttpRequest();
      req.open('POST', url, true);
      req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      params += '&client_id=' + encodeURIComponent(kc.clientId);
      params += '&redirect_uri=' + oauth.redirectUri;
      if (oauth.pkceCodeVerifier) {
        params += '&code_verifier=' + oauth.pkceCodeVerifier;
      }
      req.withCredentials = true;
      req.onreadystatechange = function () {
        if (req.readyState == 4) {
          if (req.status == 200) {
            var tokenResponse = JSON.parse(req.responseText);
            authSuccess(tokenResponse['access_token'], tokenResponse['refresh_token'], tokenResponse['id_token'], kc.flow === 'standard');
            scheduleCheckIframe();
          } else {
            kc.onAuthError && kc.onAuthError();
            promise && promise.setError();
          }
        }
      };
      req.send(params);
    }
    function authSuccess(accessToken, refreshToken, idToken, fulfillPromise) {
      timeLocal = (timeLocal + new Date().getTime()) / 2;
      setToken(accessToken, refreshToken, idToken, timeLocal);
      if (useNonce && kc.idTokenParsed && kc.idTokenParsed.nonce != oauth.storedNonce) {
        logInfo('[KEYCLOAK] Invalid nonce, clearing token');
        kc.clearToken();
        promise && promise.setError();
      } else {
        if (fulfillPromise) {
          kc.onAuthSuccess && kc.onAuthSuccess();
          promise && promise.setSuccess();
        }
      }
    }
  }
  function loadConfig(url) {
    var promise = createPromise();
    var configUrl;
    if (!config) {
      configUrl = 'keycloak.json';
    } else if (typeof config === 'string') {
      configUrl = config;
    }
    function setupOidcEndoints(oidcConfiguration) {
      if (!oidcConfiguration) {
        kc.endpoints = {
          authorize: function () {
            return getRealmUrl() + '/protocol/openid-connect/auth';
          },
          token: function () {
            return getRealmUrl() + '/protocol/openid-connect/token';
          },
          logout: function () {
            return getRealmUrl() + '/protocol/openid-connect/logout';
          },
          checkSessionIframe: function () {
            var src = getRealmUrl() + '/protocol/openid-connect/login-status-iframe.html';
            if (kc.iframeVersion) {
              src = src + '?version=' + kc.iframeVersion;
            }
            return src;
          },
          thirdPartyCookiesIframe: function () {
            var src = getRealmUrl() + '/protocol/openid-connect/3p-cookies/step1.html';
            if (kc.iframeVersion) {
              src = src + '?version=' + kc.iframeVersion;
            }
            return src;
          },
          register: function () {
            return getRealmUrl() + '/protocol/openid-connect/registrations';
          },
          userinfo: function () {
            return getRealmUrl() + '/protocol/openid-connect/userinfo';
          }
        };
      } else {
        kc.endpoints = {
          authorize: function () {
            return oidcConfiguration.authorization_endpoint;
          },
          token: function () {
            return oidcConfiguration.token_endpoint;
          },
          logout: function () {
            if (!oidcConfiguration.end_session_endpoint) {
              throw "Not supported by the OIDC server";
            }
            return oidcConfiguration.end_session_endpoint;
          },
          checkSessionIframe: function () {
            if (!oidcConfiguration.check_session_iframe) {
              throw "Not supported by the OIDC server";
            }
            return oidcConfiguration.check_session_iframe;
          },
          register: function () {
            throw 'Redirection to "Register user" page not supported in standard OIDC mode';
          },
          userinfo: function () {
            if (!oidcConfiguration.userinfo_endpoint) {
              throw "Not supported by the OIDC server";
            }
            return oidcConfiguration.userinfo_endpoint;
          }
        };
      }
    }
    if (configUrl) {
      var req = new XMLHttpRequest();
      req.open('GET', configUrl, true);
      req.setRequestHeader('Accept', 'application/json');
      req.onreadystatechange = function () {
        if (req.readyState == 4) {
          if (req.status == 200 || fileLoaded(req)) {
            var config = JSON.parse(req.responseText);
            kc.authServerUrl = config['auth-server-url'];
            kc.realm = config['realm'];
            kc.clientId = config['resource'];
            setupOidcEndoints(null);
            promise.setSuccess();
          } else {
            promise.setError();
          }
        }
      };
      req.send();
    } else {
      if (!config.clientId) {
        throw 'clientId missing';
      }
      kc.clientId = config.clientId;
      var oidcProvider = config['oidcProvider'];
      if (!oidcProvider) {
        if (!config['url']) {
          var scripts = document.getElementsByTagName('script');
          for (var i = 0; i < scripts.length; i++) {
            if (scripts[i].src.match(/.*keycloak\.js/)) {
              config.url = scripts[i].src.substr(0, scripts[i].src.indexOf('/js/keycloak.js'));
              break;
            }
          }
        }
        if (!config.realm) {
          throw 'realm missing';
        }
        kc.authServerUrl = config.url;
        kc.realm = config.realm;
        setupOidcEndoints(null);
        promise.setSuccess();
      } else {
        if (typeof oidcProvider === 'string') {
          var oidcProviderConfigUrl;
          if (oidcProvider.charAt(oidcProvider.length - 1) == '/') {
            oidcProviderConfigUrl = oidcProvider + '.well-known/openid-configuration';
          } else {
            oidcProviderConfigUrl = oidcProvider + '/.well-known/openid-configuration';
          }
          var req = new XMLHttpRequest();
          req.open('GET', oidcProviderConfigUrl, true);
          req.setRequestHeader('Accept', 'application/json');
          req.onreadystatechange = function () {
            if (req.readyState == 4) {
              if (req.status == 200 || fileLoaded(req)) {
                var oidcProviderConfig = JSON.parse(req.responseText);
                setupOidcEndoints(oidcProviderConfig);
                promise.setSuccess();
              } else {
                promise.setError();
              }
            }
          };
          req.send();
        } else {
          setupOidcEndoints(oidcProvider);
          promise.setSuccess();
        }
      }
    }
    return promise.promise;
  }
  function fileLoaded(xhr) {
    return xhr.status == 0 && xhr.responseText && xhr.responseURL.startsWith('file:');
  }
  function setToken(token, refreshToken, idToken, timeLocal) {
    if (kc.tokenTimeoutHandle) {
      clearTimeout(kc.tokenTimeoutHandle);
      kc.tokenTimeoutHandle = null;
    }
    if (refreshToken) {
      kc.refreshToken = refreshToken;
      kc.refreshTokenParsed = jwtDecode(refreshToken);
    } else {
      delete kc.refreshToken;
      delete kc.refreshTokenParsed;
    }
    if (idToken) {
      kc.idToken = idToken;
      kc.idTokenParsed = jwtDecode(idToken);
    } else {
      delete kc.idToken;
      delete kc.idTokenParsed;
    }
    if (token) {
      kc.token = token;
      kc.tokenParsed = jwtDecode(token);
      kc.sessionId = kc.tokenParsed.sid;
      kc.authenticated = true;
      kc.subject = kc.tokenParsed.sub;
      kc.realmAccess = kc.tokenParsed.realm_access;
      kc.resourceAccess = kc.tokenParsed.resource_access;
      if (timeLocal) {
        kc.timeSkew = Math.floor(timeLocal / 1000) - kc.tokenParsed.iat;
      }
      if (kc.timeSkew != null) {
        logInfo('[KEYCLOAK] Estimated time difference between browser and server is ' + kc.timeSkew + ' seconds');
        if (kc.onTokenExpired) {
          var expiresIn = (kc.tokenParsed['exp'] - new Date().getTime() / 1000 + kc.timeSkew) * 1000;
          logInfo('[KEYCLOAK] Token expires in ' + Math.round(expiresIn / 1000) + ' s');
          if (expiresIn <= 0) {
            kc.onTokenExpired();
          } else {
            kc.tokenTimeoutHandle = setTimeout(kc.onTokenExpired, expiresIn);
          }
        }
      }
    } else {
      delete kc.token;
      delete kc.tokenParsed;
      delete kc.subject;
      delete kc.realmAccess;
      delete kc.resourceAccess;
      kc.authenticated = false;
    }
  }
  function createUUID() {
    var hexDigits = '0123456789abcdef';
    var s = generateRandomString(36, hexDigits).split("");
    s[14] = '4';
    s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = '-';
    var uuid = s.join('');
    return uuid;
  }
  function parseCallback(url) {
    var oauth = parseCallbackUrl(url);
    if (!oauth) {
      return;
    }
    var oauthState = callbackStorage.get(oauth.state);
    if (oauthState) {
      oauth.valid = true;
      oauth.redirectUri = oauthState.redirectUri;
      oauth.storedNonce = oauthState.nonce;
      oauth.prompt = oauthState.prompt;
      oauth.pkceCodeVerifier = oauthState.pkceCodeVerifier;
      oauth.loginOptions = oauthState.loginOptions;
    }
    return oauth;
  }
  function parseCallbackUrl(url) {
    var supportedParams;
    switch (kc.flow) {
      case 'standard':
        supportedParams = ['code', 'state', 'session_state', 'kc_action_status', 'iss'];
        break;
      case 'implicit':
        supportedParams = ['access_token', 'token_type', 'id_token', 'state', 'session_state', 'expires_in', 'kc_action_status', 'iss'];
        break;
      case 'hybrid':
        supportedParams = ['access_token', 'token_type', 'id_token', 'code', 'state', 'session_state', 'expires_in', 'kc_action_status', 'iss'];
        break;
    }
    supportedParams.push('error');
    supportedParams.push('error_description');
    supportedParams.push('error_uri');
    var queryIndex = url.indexOf('?');
    var fragmentIndex = url.indexOf('#');
    var newUrl;
    var parsed;
    if (kc.responseMode === 'query' && queryIndex !== -1) {
      newUrl = url.substring(0, queryIndex);
      parsed = parseCallbackParams(url.substring(queryIndex + 1, fragmentIndex !== -1 ? fragmentIndex : url.length), supportedParams);
      if (parsed.paramsString !== '') {
        newUrl += '?' + parsed.paramsString;
      }
      if (fragmentIndex !== -1) {
        newUrl += url.substring(fragmentIndex);
      }
    } else if (kc.responseMode === 'fragment' && fragmentIndex !== -1) {
      newUrl = url.substring(0, fragmentIndex);
      parsed = parseCallbackParams(url.substring(fragmentIndex + 1), supportedParams);
      if (parsed.paramsString !== '') {
        newUrl += '#' + parsed.paramsString;
      }
    }
    if (parsed && parsed.oauthParams) {
      if (kc.flow === 'standard' || kc.flow === 'hybrid') {
        if ((parsed.oauthParams.code || parsed.oauthParams.error) && parsed.oauthParams.state) {
          parsed.oauthParams.newUrl = newUrl;
          return parsed.oauthParams;
        }
      } else if (kc.flow === 'implicit') {
        if ((parsed.oauthParams.access_token || parsed.oauthParams.error) && parsed.oauthParams.state) {
          parsed.oauthParams.newUrl = newUrl;
          return parsed.oauthParams;
        }
      }
    }
  }
  function parseCallbackParams(paramsString, supportedParams) {
    var p = paramsString.split('&');
    var result = {
      paramsString: '',
      oauthParams: {}
    };
    for (var i = 0; i < p.length; i++) {
      var split = p[i].indexOf("=");
      var key = p[i].slice(0, split);
      if (supportedParams.indexOf(key) !== -1) {
        result.oauthParams[key] = p[i].slice(split + 1);
      } else {
        if (result.paramsString !== '') {
          result.paramsString += '&';
        }
        result.paramsString += p[i];
      }
    }
    return result;
  }
  function createPromise() {
    // Need to create a native Promise which also preserves the
    // interface of the custom promise type previously used by the API
    var p = {
      setSuccess: function (result) {
        p.resolve(result);
      },
      setError: function (result) {
        p.reject(result);
      }
    };
    p.promise = new Promise(function (resolve, reject) {
      p.resolve = resolve;
      p.reject = reject;
    });
    return p;
  }

  // Function to extend existing native Promise with timeout
  function applyTimeoutToPromise(promise, timeout, errorMessage) {
    var timeoutHandle = null;
    var timeoutPromise = new Promise(function (resolve, reject) {
      timeoutHandle = setTimeout(function () {
        reject({
          "error": errorMessage
        });
      }, timeout);
    });
    return Promise.race([promise, timeoutPromise]).finally(function () {
      clearTimeout(timeoutHandle);
    });
  }
  function setupCheckLoginIframe() {
    var promise = createPromise();
    if (!loginIframe.enable) {
      promise.setSuccess();
      return promise.promise;
    }
    if (loginIframe.iframe) {
      promise.setSuccess();
      return promise.promise;
    }
    var iframe = document.createElement('iframe');
    loginIframe.iframe = iframe;
    iframe.onload = function () {
      var authUrl = kc.endpoints.authorize();
      if (authUrl.charAt(0) === '/') {
        loginIframe.iframeOrigin = getOrigin();
      } else {
        loginIframe.iframeOrigin = authUrl.substring(0, authUrl.indexOf('/', 8));
      }
      promise.setSuccess();
    };
    var src = kc.endpoints.checkSessionIframe();
    iframe.setAttribute('src', src);
    iframe.setAttribute('sandbox', 'allow-storage-access-by-user-activation allow-scripts allow-same-origin');
    iframe.setAttribute('title', 'keycloak-session-iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var messageCallback = function (event) {
      if (event.origin !== loginIframe.iframeOrigin || loginIframe.iframe.contentWindow !== event.source) {
        return;
      }
      if (!(event.data == 'unchanged' || event.data == 'changed' || event.data == 'error')) {
        return;
      }
      if (event.data != 'unchanged') {
        kc.clearToken();
      }
      var callbacks = loginIframe.callbackList.splice(0, loginIframe.callbackList.length);
      for (var i = callbacks.length - 1; i >= 0; --i) {
        var promise = callbacks[i];
        if (event.data == 'error') {
          promise.setError();
        } else {
          promise.setSuccess(event.data == 'unchanged');
        }
      }
    };
    window.addEventListener('message', messageCallback, false);
    return promise.promise;
  }
  function scheduleCheckIframe() {
    if (loginIframe.enable) {
      if (kc.token) {
        setTimeout(function () {
          checkLoginIframe().then(function (unchanged) {
            if (unchanged) {
              scheduleCheckIframe();
            }
          });
        }, loginIframe.interval * 1000);
      }
    }
  }
  function checkLoginIframe() {
    var promise = createPromise();
    if (loginIframe.iframe && loginIframe.iframeOrigin) {
      var msg = kc.clientId + ' ' + (kc.sessionId ? kc.sessionId : '');
      loginIframe.callbackList.push(promise);
      var origin = loginIframe.iframeOrigin;
      if (loginIframe.callbackList.length == 1) {
        loginIframe.iframe.contentWindow.postMessage(msg, origin);
      }
    } else {
      promise.setSuccess();
    }
    return promise.promise;
  }
  function check3pCookiesSupported() {
    var promise = createPromise();
    if (loginIframe.enable || kc.silentCheckSsoRedirectUri) {
      var iframe = document.createElement('iframe');
      iframe.setAttribute('src', kc.endpoints.thirdPartyCookiesIframe());
      iframe.setAttribute('sandbox', 'allow-storage-access-by-user-activation allow-scripts allow-same-origin');
      iframe.setAttribute('title', 'keycloak-3p-check-iframe');
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
      var messageCallback = function (event) {
        if (iframe.contentWindow !== event.source) {
          return;
        }
        if (event.data !== "supported" && event.data !== "unsupported") {
          return;
        } else if (event.data === "unsupported") {
          logWarn("[KEYCLOAK] Your browser is blocking access to 3rd-party cookies, this means:\n\n" + " - It is not possible to retrieve tokens without redirecting to the Keycloak server (a.k.a. no support for silent authentication).\n" + " - It is not possible to automatically detect changes to the session status (such as the user logging out in another tab).\n\n" + "For more information see: https://www.keycloak.org/docs/latest/securing_apps/#_modern_browsers");
          loginIframe.enable = false;
          if (kc.silentCheckSsoFallback) {
            kc.silentCheckSsoRedirectUri = false;
          }
        }
        document.body.removeChild(iframe);
        window.removeEventListener("message", messageCallback);
        promise.setSuccess();
      };
      window.addEventListener('message', messageCallback, false);
    } else {
      promise.setSuccess();
    }
    return applyTimeoutToPromise(promise.promise, kc.messageReceiveTimeout, "Timeout when waiting for 3rd party check iframe message.");
  }
  function loadAdapter(type) {
    if (!type || type == 'default') {
      return {
        login: function (options) {
          window.location.assign(kc.createLoginUrl(options));
          return createPromise().promise;
        },
        logout: async function (options) {
          const logoutMethod = options?.logoutMethod ?? kc.logoutMethod;
          if (logoutMethod === "GET") {
            window.location.replace(kc.createLogoutUrl(options));
            return;
          }
          const logoutUrl = kc.createLogoutUrl(options);
          const response = await fetch(logoutUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            },
            body: new URLSearchParams({
              id_token_hint: kc.idToken,
              client_id: kc.clientId,
              post_logout_redirect_uri: adapter.redirectUri(options, false)
            })
          });
          if (response.redirected) {
            window.location.href = response.url;
            return;
          }
          if (response.ok) {
            window.location.reload();
            return;
          }
          throw new Error("Logout failed, request returned an error code.");
        },
        register: function (options) {
          window.location.assign(kc.createRegisterUrl(options));
          return createPromise().promise;
        },
        accountManagement: function () {
          var accountUrl = kc.createAccountUrl();
          if (typeof accountUrl !== 'undefined') {
            window.location.href = accountUrl;
          } else {
            throw "Not supported by the OIDC server";
          }
          return createPromise().promise;
        },
        redirectUri: function (options, encodeHash) {
          if (options && options.redirectUri) {
            return options.redirectUri;
          } else if (kc.redirectUri) {
            return kc.redirectUri;
          } else {
            return location.href;
          }
        }
      };
    }
    if (type == 'cordova') {
      loginIframe.enable = false;
      var cordovaOpenWindowWrapper = function (loginUrl, target, options) {
        if (window.cordova && window.cordova.InAppBrowser) {
          // Use inappbrowser for IOS and Android if available
          return window.cordova.InAppBrowser.open(loginUrl, target, options);
        } else {
          return window.open(loginUrl, target, options);
        }
      };
      var shallowCloneCordovaOptions = function (userOptions) {
        if (userOptions && userOptions.cordovaOptions) {
          return Object.keys(userOptions.cordovaOptions).reduce(function (options, optionName) {
            options[optionName] = userOptions.cordovaOptions[optionName];
            return options;
          }, {});
        } else {
          return {};
        }
      };
      var formatCordovaOptions = function (cordovaOptions) {
        return Object.keys(cordovaOptions).reduce(function (options, optionName) {
          options.push(optionName + "=" + cordovaOptions[optionName]);
          return options;
        }, []).join(",");
      };
      var createCordovaOptions = function (userOptions) {
        var cordovaOptions = shallowCloneCordovaOptions(userOptions);
        cordovaOptions.location = 'no';
        if (userOptions && userOptions.prompt == 'none') {
          cordovaOptions.hidden = 'yes';
        }
        return formatCordovaOptions(cordovaOptions);
      };
      var getCordovaRedirectUri = function () {
        return kc.redirectUri || 'http://localhost';
      };
      return {
        login: function (options) {
          var promise = createPromise();
          var cordovaOptions = createCordovaOptions(options);
          var loginUrl = kc.createLoginUrl(options);
          var ref = cordovaOpenWindowWrapper(loginUrl, '_blank', cordovaOptions);
          var completed = false;
          var closed = false;
          var closeBrowser = function () {
            closed = true;
            ref.close();
          };
          ref.addEventListener('loadstart', function (event) {
            if (event.url.indexOf(getCordovaRedirectUri()) == 0) {
              var callback = parseCallback(event.url);
              processCallback(callback, promise);
              closeBrowser();
              completed = true;
            }
          });
          ref.addEventListener('loaderror', function (event) {
            if (!completed) {
              if (event.url.indexOf(getCordovaRedirectUri()) == 0) {
                var callback = parseCallback(event.url);
                processCallback(callback, promise);
                closeBrowser();
                completed = true;
              } else {
                promise.setError();
                closeBrowser();
              }
            }
          });
          ref.addEventListener('exit', function (event) {
            if (!closed) {
              promise.setError({
                reason: "closed_by_user"
              });
            }
          });
          return promise.promise;
        },
        logout: function (options) {
          var promise = createPromise();
          var logoutUrl = kc.createLogoutUrl(options);
          var ref = cordovaOpenWindowWrapper(logoutUrl, '_blank', 'location=no,hidden=yes,clearcache=yes');
          var error;
          ref.addEventListener('loadstart', function (event) {
            if (event.url.indexOf(getCordovaRedirectUri()) == 0) {
              ref.close();
            }
          });
          ref.addEventListener('loaderror', function (event) {
            if (event.url.indexOf(getCordovaRedirectUri()) == 0) {
              ref.close();
            } else {
              error = true;
              ref.close();
            }
          });
          ref.addEventListener('exit', function (event) {
            if (error) {
              promise.setError();
            } else {
              kc.clearToken();
              promise.setSuccess();
            }
          });
          return promise.promise;
        },
        register: function (options) {
          var promise = createPromise();
          var registerUrl = kc.createRegisterUrl();
          var cordovaOptions = createCordovaOptions(options);
          var ref = cordovaOpenWindowWrapper(registerUrl, '_blank', cordovaOptions);
          ref.addEventListener('loadstart', function (event) {
            if (event.url.indexOf(getCordovaRedirectUri()) == 0) {
              ref.close();
              var oauth = parseCallback(event.url);
              processCallback(oauth, promise);
            }
          });
          return promise.promise;
        },
        accountManagement: function () {
          var accountUrl = kc.createAccountUrl();
          if (typeof accountUrl !== 'undefined') {
            var ref = cordovaOpenWindowWrapper(accountUrl, '_blank', 'location=no');
            ref.addEventListener('loadstart', function (event) {
              if (event.url.indexOf(getCordovaRedirectUri()) == 0) {
                ref.close();
              }
            });
          } else {
            throw "Not supported by the OIDC server";
          }
        },
        redirectUri: function (options) {
          return getCordovaRedirectUri();
        }
      };
    }
    if (type == 'cordova-native') {
      loginIframe.enable = false;
      return {
        login: function (options) {
          var promise = createPromise();
          var loginUrl = kc.createLoginUrl(options);
          universalLinks.subscribe('keycloak', function (event) {
            universalLinks.unsubscribe('keycloak');
            window.cordova.plugins.browsertab.close();
            var oauth = parseCallback(event.url);
            processCallback(oauth, promise);
          });
          window.cordova.plugins.browsertab.openUrl(loginUrl);
          return promise.promise;
        },
        logout: function (options) {
          var promise = createPromise();
          var logoutUrl = kc.createLogoutUrl(options);
          universalLinks.subscribe('keycloak', function (event) {
            universalLinks.unsubscribe('keycloak');
            window.cordova.plugins.browsertab.close();
            kc.clearToken();
            promise.setSuccess();
          });
          window.cordova.plugins.browsertab.openUrl(logoutUrl);
          return promise.promise;
        },
        register: function (options) {
          var promise = createPromise();
          var registerUrl = kc.createRegisterUrl(options);
          universalLinks.subscribe('keycloak', function (event) {
            universalLinks.unsubscribe('keycloak');
            window.cordova.plugins.browsertab.close();
            var oauth = parseCallback(event.url);
            processCallback(oauth, promise);
          });
          window.cordova.plugins.browsertab.openUrl(registerUrl);
          return promise.promise;
        },
        accountManagement: function () {
          var accountUrl = kc.createAccountUrl();
          if (typeof accountUrl !== 'undefined') {
            window.cordova.plugins.browsertab.openUrl(accountUrl);
          } else {
            throw "Not supported by the OIDC server";
          }
        },
        redirectUri: function (options) {
          if (options && options.redirectUri) {
            return options.redirectUri;
          } else if (kc.redirectUri) {
            return kc.redirectUri;
          } else {
            return "http://localhost";
          }
        }
      };
    }
    throw 'invalid adapter type: ' + type;
  }
  var LocalStorage = function () {
    if (!(this instanceof LocalStorage)) {
      return new LocalStorage();
    }
    localStorage.setItem('kc-test', 'test');
    localStorage.removeItem('kc-test');
    var cs = this;
    function clearExpired() {
      var time = new Date().getTime();
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (key && key.indexOf('kc-callback-') == 0) {
          var value = localStorage.getItem(key);
          if (value) {
            try {
              var expires = JSON.parse(value).expires;
              if (!expires || expires < time) {
                localStorage.removeItem(key);
              }
            } catch (err) {
              localStorage.removeItem(key);
            }
          }
        }
      }
    }
    cs.get = function (state) {
      if (!state) {
        return;
      }
      var key = 'kc-callback-' + state;
      var value = localStorage.getItem(key);
      if (value) {
        localStorage.removeItem(key);
        value = JSON.parse(value);
      }
      clearExpired();
      return value;
    };
    cs.add = function (state) {
      clearExpired();
      var key = 'kc-callback-' + state.state;
      state.expires = new Date().getTime() + 60 * 60 * 1000;
      localStorage.setItem(key, JSON.stringify(state));
    };
  };
  var CookieStorage = function () {
    if (!(this instanceof CookieStorage)) {
      return new CookieStorage();
    }
    var cs = this;
    cs.get = function (state) {
      if (!state) {
        return;
      }
      var value = getCookie('kc-callback-' + state);
      setCookie('kc-callback-' + state, '', cookieExpiration(-100));
      if (value) {
        return JSON.parse(value);
      }
    };
    cs.add = function (state) {
      setCookie('kc-callback-' + state.state, JSON.stringify(state), cookieExpiration(60));
    };
    cs.removeItem = function (key) {
      setCookie(key, '', cookieExpiration(-100));
    };
    var cookieExpiration = function (minutes) {
      var exp = new Date();
      exp.setTime(exp.getTime() + minutes * 60 * 1000);
      return exp;
    };
    var getCookie = function (key) {
      var name = key + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    };
    var setCookie = function (key, value, expirationDate) {
      var cookie = key + '=' + value + '; ' + 'expires=' + expirationDate.toUTCString() + '; ';
      document.cookie = cookie;
    };
  };
  function createCallbackStorage() {
    try {
      return new LocalStorage();
    } catch (err) {}
    return new CookieStorage();
  }
  function createLogger(fn) {
    return function () {
      if (kc.enableLogging) {
        fn.apply(console, Array.prototype.slice.call(arguments));
      }
    };
  }
}

// See: https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
function bytesToBase64(bytes) {
  const binString = String.fromCodePoint(...bytes);
  return btoa(binString);
}

// EXTERNAL MODULE: ./src/constants/index.ts + 4 modules
var src_constants = __webpack_require__(43743);
// EXTERNAL MODULE: ./src/pages/api/entrance-test/index.ts
var entrance_test = __webpack_require__(81482);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(45332);
;// CONCATENATED MODULE: ./src/utils/helpers/keycloak.ts
/* eslint-disable react-hooks/rules-of-hooks */ 











var handleFirebaseToken = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, accessDeviceToken, ref6, ref7, token;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        lib_module.getItem("firebaseDeviceToken")
                    ];
                case 1:
                    accessDeviceToken = _state.sent();
                    if (!!accessDeviceToken) return [
                        3,
                        6
                    ];
                    if (!((window === null || window === void 0 ? void 0 : (ref6 = window.Notification) === null || ref6 === void 0 ? void 0 : ref6.permission) !== "denied")) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0,firebase/* getMessagingToken */.M)()
                    ];
                case 2:
                    token = (ref7 = _state.sent()) !== null && ref7 !== void 0 ? ref7 : "";
                    if (!(token !== "")) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        lib_module.setItem("firebaseDeviceToken", token)
                    ];
                case 3:
                    _state.sent();
                    return [
                        4,
                        setDeviceFirebaseToSession(token !== null && token !== void 0 ? token : "")
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    return [
                        2
                    ];
                case 6:
                    if (!(((ref1 = (ref = window.location.pathname) === null || ref === void 0 ? void 0 : ref.split("/")) === null || ref1 === void 0 ? void 0 : ref1[1]) !== constants/* CERTIFICATE */.Cq && ((ref3 = (ref2 = window.location.pathname) === null || ref2 === void 0 ? void 0 : ref2.split("test-result/")) === null || ref3 === void 0 ? void 0 : ref3[0]) !== "/entrance-test/" && ((ref5 = (ref4 = window.location.pathname) === null || ref4 === void 0 ? void 0 : ref4.split("table-result/")) === null || ref5 === void 0 ? void 0 : ref5[0]) !== "/entrance-test/")) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        setDeviceFirebaseToSession(accessDeviceToken !== null && accessDeviceToken !== void 0 ? accessDeviceToken : "")
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function handleFirebaseToken() {
        return _ref.apply(this, arguments);
    };
}();
var AuthenticationManager = /*#__PURE__*/ function() {
    "use strict";
    function AuthenticationManager() {
        (0,_class_call_check/* default */.Z)(this, AuthenticationManager);
        this.keyCloak = null;
        if (AuthenticationManager.instance) {
            return AuthenticationManager.instance;
        }
        this.initKeyCloakConnect();
        AuthenticationManager.instance = this;
    }
    var _proto = AuthenticationManager.prototype;
    _proto.initKeyCloakConnect = function initKeyCloakConnect() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, _NEXT_PUBLIC_KEYCLOAK_URL, _NEXT_PUBLIC_KEYCLOAK_REALM, _NEXT_PUBLIC_KEYCLOAK_CLIENT_ID, keycloakConfig, existingToken, existingRefreshToken, isFirstLogin, pathname, authenticated, token, refreshToken, _sessionId, res, ref3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (false) {} // Chạy client-side thôi
                        keycloakConfig = {
                            url: (_NEXT_PUBLIC_KEYCLOAK_URL = "https://accounts.sapp.edu.vn") !== null && _NEXT_PUBLIC_KEYCLOAK_URL !== void 0 ? _NEXT_PUBLIC_KEYCLOAK_URL : "",
                            realm: (_NEXT_PUBLIC_KEYCLOAK_REALM = "lms-production") !== null && _NEXT_PUBLIC_KEYCLOAK_REALM !== void 0 ? _NEXT_PUBLIC_KEYCLOAK_REALM : "",
                            clientId: (_NEXT_PUBLIC_KEYCLOAK_CLIENT_ID = "lms-frontend") !== null && _NEXT_PUBLIC_KEYCLOAK_CLIENT_ID !== void 0 ? _NEXT_PUBLIC_KEYCLOAK_CLIENT_ID : ""
                        };
                        existingToken = (0,utils/* getCookie */.ej)("keycloakToken");
                        existingRefreshToken = (0,utils/* getCookie */.ej)("keycloakRefreshToken");
                        isFirstLogin = false;
                        _this.keyCloak = new Keycloak(keycloakConfig);
                        if (existingToken && existingRefreshToken) {
                            _this.keyCloak.token = existingToken;
                            _this.keyCloak.refreshToken = existingRefreshToken;
                            return [
                                2
                            ];
                        }
                        pathname = window.location.pathname;
                        if (!(((ref = pathname.split("/")) === null || ref === void 0 ? void 0 : ref[1]) !== constants/* CERTIFICATE */.Cq && ((ref1 = pathname.split("test-result/")) === null || ref1 === void 0 ? void 0 : ref1[0]) !== "/entrance-test/" && ((ref2 = pathname.split("table-result/")) === null || ref2 === void 0 ? void 0 : ref2[0]) !== "/entrance-test/")) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            _this.keyCloak.init({
                                onLoad: "login-required"
                            })
                        ];
                    case 1:
                        authenticated = _state.sent();
                        if (!authenticated) return [
                            3,
                            5
                        ];
                        token = _this.keyCloak.token;
                        refreshToken = _this.keyCloak.refreshToken;
                        (0,utils/* setCookie */.d8)(src_constants/* COOKIE_INFO.KEYCLOAK_TOKEN */.s_.KEYCLOAK_TOKEN, token !== null && token !== void 0 ? token : "");
                        (0,utils/* setCookie */.d8)(src_constants/* COOKIE_INFO.KEYCLOAK_REFRESH_TOKEN */.s_.KEYCLOAK_REFRESH_TOKEN, refreshToken !== null && refreshToken !== void 0 ? refreshToken : "");
                        (0,utils/* setCookie */.d8)(src_constants/* COOKIE_INFO.SESSION_ID */.s_.SESSION_ID, (_sessionId = _this.keyCloak.sessionId) !== null && _sessionId !== void 0 ? _sessionId : "");
                        if (!!localStorage.getItem("hasLoggedInBefore")) return [
                            3,
                            3
                        ];
                        isFirstLogin = true;
                        localStorage.setItem("hasLoggedInBefore", "true");
                        return [
                            4,
                            entrance_test/* EntranceTestAPI.getEntranceCount */.e.getEntranceCount()
                        ];
                    case 2:
                        res = _state.sent();
                        if (isFirstLogin) {
                            ;
                            localStorage.setItem("enstranceTest", "true");
                            if ((res === null || res === void 0 ? void 0 : (ref3 = res.data) === null || ref3 === void 0 ? void 0 : ref3.count) > 0) {
                                window.location.href = "".concat("https://lms-pro.sapp.edu.vn").concat(src_constants/* PageLink.ENTRANCE_TEST */.H_.ENTRANCE_TEST);
                            } else {
                                window.location.href = "".concat("https://lms-pro.sapp.edu.vn");
                            }
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleFirebaseToken()
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.getToken = function getToken() {
        var ref;
        var ref1;
        return (ref1 = (ref = this.keyCloak) === null || ref === void 0 ? void 0 : ref.token) !== null && ref1 !== void 0 ? ref1 : "";
    };
    /**
   * Làm mới token nếu token còn dưới 30s
   *
   * @returns {Promise<string | null>} - Token mới, nếu không thể làm mới sẽ trả về null
   */ _proto.refreshToken = function refreshToken() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, refreshed, error, ref2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            5
                        ]);
                        if (!((ref = _this.keyCloak) === null || ref === void 0 ? void 0 : ref.token)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (ref1 = _this.keyCloak) === null || ref1 === void 0 ? void 0 : ref1.updateToken(30)
                        ];
                    case 1:
                        refreshed = _state.sent();
                        if (refreshed) {
                            return [
                                2,
                                _this.keyCloak.token
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        // Nếu xảy ra lỗi, thử lại bằng cách login
                        return [
                            4,
                            (ref2 = _this.keyCloak) === null || ref2 === void 0 ? void 0 : ref2.login()
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2,
                            null
                        ];
                }
            });
        })();
    };
    _proto.logout = function logout() {
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, sessionId, ref1, ref2, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        sessionId = (0,utils/* getSessionIdFromToken */.d$)((ref = (0,utils/* getCookie */.ej)(src_constants/* COOKIE_INFO.KEYCLOAK_TOKEN */.s_.KEYCLOAK_TOKEN)) !== null && ref !== void 0 ? ref : "");
                        return [
                            4,
                            user/* UserApi.logout */.W.logout((ref1 = sessionId !== null && sessionId !== void 0 ? sessionId : (0,utils/* getCookie */.ej)(src_constants/* COOKIE_INFO.SESSION_ID */.s_.SESSION_ID)) !== null && ref1 !== void 0 ? ref1 : "", (ref2 = (0,utils/* getCookie */.ej)(src_constants/* COOKIE_INFO.KEYCLOAK_USER_ID */.s_.KEYCLOAK_USER_ID)) !== null && ref2 !== void 0 ? ref2 : "")
                        ];
                    case 1:
                        res = _state.sent();
                        if (res === null || res === void 0 ? void 0 : res.success) {
                            localStorage.clear();
                            (0,utils/* deleteCookie */.kT)(src_constants/* COOKIE_INFO.KEYCLOAK_TOKEN */.s_.KEYCLOAK_TOKEN);
                            (0,utils/* deleteCookie */.kT)(src_constants/* COOKIE_INFO.KEYCLOAK_REFRESH_TOKEN */.s_.KEYCLOAK_REFRESH_TOKEN);
                            (0,utils/* deleteCookie */.kT)(src_constants/* COOKIE_INFO.SESSION_ID */.s_.SESSION_ID);
                            (0,utils/* deleteCookie */.kT)(src_constants/* COOKIE_INFO.KEYCLOAK_USER_ID */.s_.KEYCLOAK_USER_ID);
                            window.location.reload();
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return AuthenticationManager;
}();
function setDeviceFirebaseToSession(token) {
    return _setDeviceFirebaseToSession.apply(this, arguments);
}
function _setDeviceFirebaseToSession() {
    _setDeviceFirebaseToSession = (0,_async_to_generator/* default */.Z)(function(token) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                (0,requestV2/* fetcher */._i)("".concat("https://accounts.sapp.edu.vn", "/realms/").concat("lms-production", "/user-session-provider/sessions/device"), {
                    method: "POST",
                    data: {
                        device_id: token
                    }
                })
            ];
        });
    });
    return _setDeviceFirebaseToSession.apply(this, arguments);
}


/***/ }),

/***/ 45332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$f": function() { return /* binding */ convertQuizType; },
/* harmony export */   "CK": function() { return /* binding */ DeserializeHighlight; },
/* harmony export */   "Ct": function() { return /* binding */ formatDateFromUTC; },
/* harmony export */   "D$": function() { return /* binding */ setLocalStorageItem; },
/* harmony export */   "Gr": function() { return /* reexport safe */ _common__WEBPACK_IMPORTED_MODULE_6__.Gr; },
/* harmony export */   "IQ": function() { return /* binding */ removeHtmlTags; },
/* harmony export */   "Ie": function() { return /* binding */ buildQueryString; },
/* harmony export */   "LV": function() { return /* binding */ pageview; },
/* harmony export */   "Ov": function() { return /* binding */ buildOneChoiceQueryString; },
/* harmony export */   "S1": function() { return /* binding */ clearStylesHtml; },
/* harmony export */   "Vg": function() { return /* binding */ cleanParamsAPI; },
/* harmony export */   "WW": function() { return /* binding */ containsKeyword; },
/* harmony export */   "Z9": function() { return /* binding */ convertHumanReadableToSnakeCase; },
/* harmony export */   "Zm": function() { return /* binding */ useGetDataQuery; },
/* harmony export */   "aK": function() { return /* binding */ formatPathWithQueryParams; },
/* harmony export */   "aS": function() { return /* binding */ truncateString; },
/* harmony export */   "d$": function() { return /* binding */ getSessionIdFromToken; },
/* harmony export */   "d8": function() { return /* binding */ setCookie; },
/* harmony export */   "e8": function() { return /* binding */ removeLocalStorageItem; },
/* harmony export */   "eX": function() { return /* binding */ getUppercaseByNumber; },
/* harmony export */   "ej": function() { return /* binding */ getCookie; },
/* harmony export */   "fm": function() { return /* binding */ capitalizeFirstLetter; },
/* harmony export */   "fr": function() { return /* binding */ sappFormatDate; },
/* harmony export */   "gv": function() { return /* binding */ bytesToKilobyte; },
/* harmony export */   "jL": function() { return /* binding */ onLinkSocial; },
/* harmony export */   "kT": function() { return /* binding */ deleteCookie; },
/* harmony export */   "le": function() { return /* binding */ getLocalStorageItem; },
/* harmony export */   "mq": function() { return /* binding */ convertSlugToTitle; },
/* harmony export */   "mr": function() { return /* binding */ formatTime; },
/* harmony export */   "oq": function() { return /* binding */ formatNotificationHTML; },
/* harmony export */   "p6": function() { return /* reexport safe */ _common__WEBPACK_IMPORTED_MODULE_6__.p6; },
/* harmony export */   "rI": function() { return /* binding */ replaceTextAlignCenterToWebKitCenter; },
/* harmony export */   "tK": function() { return /* binding */ truncateHTML; },
/* harmony export */   "vZ": function() { return /* binding */ replaceWhiteSpacePreWrapToNormal; },
/* harmony export */   "x4": function() { return /* binding */ runHighlight; },
/* harmony export */   "yZ": function() { return /* binding */ getTimeFromInput; },
/* harmony export */   "yo": function() { return /* binding */ convertSnakeCaseToHumanReadable; },
/* harmony export */   "zI": function() { return /* binding */ truncateBySpace; }
/* harmony export */ });
/* unused harmony exports getLocalStorgeActToken, getLocalStorgeRefreshToken, countWords, parseHTMLToString, useGetData, convertFractionToPercentage, removeStyleAttributes, truncateTextOnly */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18473);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52621);
/* harmony import */ var _node_modules_funktechno_texthighlighter_lib_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45898);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79555);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_weekday__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91884);
/* harmony import */ var dayjs_plugin_weekday__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_weekday__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78321);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10103);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97478);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10212);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62911);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43743);













dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_7___default()));
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_weekday__WEBPACK_IMPORTED_MODULE_2___default()));
var getLocalStorgeActToken = function() {
    return "";
};
var getLocalStorgeRefreshToken = function() {
    return localStorage.getItem("refreshToken") || "";
};
function truncateString(str, maxLength) {
    if ((str === null || str === void 0 ? void 0 : str.length) <= maxLength) {
        return str;
    } else {
        return (str === null || str === void 0 ? void 0 : str.slice(0, maxLength)) + " ..." // Add ellipsis to indicate truncation
        ;
    }
}
function runHighlight(handleSaveHighLight, allowHighLight) {
    var elementID = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "hightlight_area", options = arguments.length > 3 ? arguments[3] : void 0;
    // run mobile a bit
    var domEle = document.getElementById(elementID);
    if (domEle && allowHighLight) {
        (0,_node_modules_funktechno_texthighlighter_lib_index__WEBPACK_IMPORTED_MODULE_0__/* .doHighlight */ .Zp)(domEle, false, options);
        handleSaveHighLight((0,_node_modules_funktechno_texthighlighter_lib_index__WEBPACK_IMPORTED_MODULE_0__/* .serializeHighlights */ .IT)(domEle));
    }
}
function DeserializeHighlight(highlighted) {
    var elementID = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "hightlight_area";
    var domEle = document.getElementById(elementID);
    (0,_node_modules_funktechno_texthighlighter_lib_index__WEBPACK_IMPORTED_MODULE_0__/* .removeHighlights */ .Au)(domEle);
    (0,_node_modules_funktechno_texthighlighter_lib_index__WEBPACK_IMPORTED_MODULE_0__/* .deserializeHighlights */ .pt)(domEle, highlighted);
}
var formatTime = function(minutes) {
    var hours = Math.floor(minutes / 60);
    var remainingMinutes = minutes % 60;
    var formattedHours = hours > 0 ? "".concat(hours, "h") : "";
    var formattedMinutes = remainingMinutes > 0 ? "".concat(remainingMinutes, "m") : "";
    return formattedHours + formattedMinutes || "0h0m";
};
/**
 * Convert millisecond/seconds to readable hh:mm:ss
 *
 * @param   totalTime  time in milliseconds/seconds
 * @param   unit       'milliseconds'(default) | 'seconds'
 * @returns hh:mm:ss
 */ var getTimeFromInput = function(totalTime) {
    var unit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "milliseconds";
    if (totalTime || totalTime === 0) {
        var totalSeconds;
        if (unit === "milliseconds") {
            totalSeconds = Math.floor(totalTime / 1000);
        } else {
            totalSeconds = totalTime;
        }
        var totalMinutes = Math.floor(totalSeconds / 60);
        var totalHours = Math.floor(totalMinutes / 60);
        var formattedHours = totalHours > 0 ? ("0" + totalHours).slice(-2) + ":" : "";
        var formattedMinutes = ("0" + totalMinutes % 60).slice(-2);
        var formattedSeconds = ("0" + totalSeconds % 60).slice(-2);
        return "".concat(formattedHours).concat(formattedMinutes, ":").concat(formattedSeconds);
    }
    return "-";
};
var countWords = function(text) {
    var words = text.trim().split(/\s+/);
    return words.length;
};
var convertSnakeCaseToHumanReadable = function(str) {
    var words = str.toLowerCase().split("_").map(function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    });
    return words.join(" ");
};
var convertHumanReadableToSnakeCase = function(str) {
    var words = str.toLowerCase().split(" ").map(function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    });
    return words.join("_");
};
var buildQueryString = function(params) {
    var queryParams = Object.entries(params).filter(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(param, 2), _ = _param[0], value = _param[1];
        return value !== "" && value !== undefined;
    }) // Exclude empty parameters
    .map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
    }).join("&");
    return queryParams ? "&".concat(queryParams) : "";
};
var bytesToKilobyte = function(bytes) {
    var suffix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Kb";
    return "".concat((bytes / 1024).toFixed(2)).concat(suffix) // 1 kilobyte = 1024 bytes
    ;
};
var cleanParamsAPI = function(params) {
    return Object.fromEntries(Object.entries(params).filter(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(param, 2), _ = _param[0], value = _param[1];
        return value !== null && value !== "";
    }));
};
var buildOneChoiceQueryString = function(params) {
    var queryParams = Object.entries(params).filter(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(param, 2), _ = _param[0], value = _param[1];
        return value !== "" && value !== undefined;
    }) // Exclude empty parameters
    .map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
    }).join("&");
    return queryParams ? "".concat(queryParams) : "";
};
var parseHTMLToString = function(htmlContent) {
    var tempElement = document.createElement("div");
    tempElement.innerHTML = DOMPurify.sanitize(htmlContent);
    return tempElement.textContent || tempElement.innerText;
};
// Hàm thay thế style text-align: center thành style text-align: -webkit-center trong chuỗi HTML
var replaceTextAlignCenterToWebKitCenter = function(htmlString) {
    // Sử dụng biểu thức chính quy để thay thế
    return htmlString.replace(/text-align:\s*center/g, "text-align: -webkit-center");
};
// Hàm thay thế style white-space: pre-wrap thành style white-space: normal trong chuỗi HTML
var replaceWhiteSpacePreWrapToNormal = function(htmlString) {
    // Sử dụng biểu thức chính quy để thay thế
    return htmlString.replace(/white-space:\s*pre-wrap/g, "white-space: normal");
};
var useGetData = function(queryKey, params, fetchData) {
    return useQuery([
        queryKey,
        params
    ], function() {
        return fetchData(params);
    }, {
        retry: false
    });
};
var useGetDataQuery = function(queryKey, params, fetchFunction, enabled, onError) {
    var fetchData = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
            var data;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchFunction()
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_5__.useQuery)([
        queryKey,
        params
    ], fetchData, {
        enabled: enabled,
        onError: onError,
        retry: false
    });
};
var convertFractionToPercentage = function(fraction) {
    var ref = _sliced_to_array(fraction.split("/").map(Number), 2), numerator = ref[0], denominator = ref[1];
    if (denominator === 0) return 0 // Tránh chia cho 0
    ;
    var percentage = numerator / denominator * 100;
    return percentage;
};
// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
var pageview = function(url) {
    // @ts-ignore: Unreachable code error
    window.gtag("config", "".concat("G-6KFGPZK0M8"), {
        page_path: url
    });
};
/**
 * @description function này để link social
 */ var onLinkSocial = function(link) {
    window.open(link, "_blank");
};
var getUppercaseByNumber = function(num) {
    var result = "";
    while(num > 0){
        var remainder = num % 26;
        if (remainder === 0) {
            remainder = 26;
            num--;
        }
        var char = String.fromCharCode(remainder + 64);
        result = char + result;
        num = Math.floor(num / 26);
    }
    return result;
};
var removeLocalStorageItem = function(item) {
    localStorage.removeItem(item);
};
var getLocalStorageItem = function(name) {
    return localStorage.getItem(name) || "";
};
var setLocalStorageItem = function(name, value) {
    localStorage.setItem(name, value);
};
var removeStyleAttributes = function(htmlString) {
    if (!htmlString) return;
    var parser = new DOMParser();
    var doc = parser.parseFromString(htmlString, "text/html");
    var elementsWithStyle = doc.querySelectorAll("[style]");
    elementsWithStyle.forEach(function(element) {
        element.removeAttribute("style");
    });
    return doc.body.innerHTML;
};
var capitalizeFirstLetter = function(str) {
    if (!str) return;
    str = str === null || str === void 0 ? void 0 : str.toLocaleLowerCase();
    return str.split(" ").map(function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(" ");
};
var truncateBySpace = function(text, maxWords) {
    var isSlash = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if ((0,lodash__WEBPACK_IMPORTED_MODULE_4__.isEmpty)(text) || (0,lodash__WEBPACK_IMPORTED_MODULE_4__.isUndefined)(text) || (0,lodash__WEBPACK_IMPORTED_MODULE_4__.isNull)(text)) return "";
    var words = text === null || text === void 0 ? void 0 : text.split(" ");
    if ((words === null || words === void 0 ? void 0 : words.length) <= maxWords) {
        return text + (isSlash ? " /" : "");
    }
    return (words === null || words === void 0 ? void 0 : words.slice(0, maxWords).join(" ")) + "...".concat(isSlash ? "/" : "");
};
var truncateTextOnly = function(htmlString, limit) {
    if (isEmpty(htmlString) || isUndefined(htmlString) || isNull(htmlString)) return;
    var div = document.createElement("div");
    div.innerHTML = htmlString;
    var totalTextLength = 0;
    var truncatedText = "";
    var lastSpacePosition = -1;
    function walkNodes(node) {
        if (totalTextLength >= limit) return;
        if (node.nodeType === Node.TEXT_NODE) {
            var text = node.nodeValue;
            for(var i = 0; i < text.length; i++){
                if (totalTextLength >= limit) break;
                truncatedText += text[i];
                totalTextLength++;
                if (text[i] === " ") {
                    lastSpacePosition = truncatedText.length;
                }
            }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            truncatedText += "<".concat(node.nodeName.toLowerCase(), ">");
            for(var i1 = 0; i1 < node.childNodes.length; i1++){
                walkNodes(node.childNodes[i1]);
                if (totalTextLength >= limit) break;
            }
            truncatedText += "</".concat(node.nodeName.toLowerCase(), ">");
        }
    }
    walkNodes(div);
    if (lastSpacePosition !== -1) {
        truncatedText = truncatedText.substring(0, lastSpacePosition) + "...";
    }
    return truncatedText;
};
var truncateHTML = function(limit, html) {
    if (!html) return "";
    var div = document.createElement("div");
    div.innerHTML = html;
    var wordCount = 0;
    function traverse(node) {
        var nodeType = node.nodeType;
        if (wordCount >= limit) {
            return "";
        }
        if (nodeType === Node.TEXT_NODE) {
            var text = node.textContent || "";
            var words = text.split(/(\s+)/);
            var truncatedText = "";
            for(var i = 0; i < words.length && wordCount < limit; i++){
                if (/\S/.test(words[i])) {
                    truncatedText += words[i];
                    wordCount++;
                } else {
                    truncatedText += words[i];
                }
            }
            return truncatedText + (wordCount >= limit ? "..." : "");
        } else if (nodeType === Node.ELEMENT_NODE) {
            var tagName = node.tagName.toLowerCase();
            var attributes = Array.from(node.attributes).map(function(attr) {
                return "".concat(attr.name, '="').concat(attr.value, '"');
            }).join(" ");
            var openTag = "<".concat(tagName).concat(attributes ? " " + attributes : "", ">");
            var closeTag = "</".concat(tagName, ">");
            var childNodes = Array.from(node.childNodes);
            var innerHTML = "";
            childNodes.forEach(function(child) {
                if (wordCount < limit) {
                    var childContent = traverse(child);
                    if ((child === null || child === void 0 ? void 0 : child.nodeType) === Node.ELEMENT_NODE && innerHTML && !/\s$/.test(innerHTML)) {
                        innerHTML += " " + childContent;
                    } else {
                        innerHTML += childContent;
                    }
                }
            });
            return "".concat(openTag).concat(innerHTML).concat(closeTag);
        }
        return "";
    }
    return traverse(div);
};
var removeHtmlTags = function(htmlString) {
    if (!htmlString) return "";
    return htmlString.replace(/<[^>]*>/g, "") // Xóa tất cả thẻ HTML
    ;
};
/**
 * @description Chuyển đổi một chuỗi ngày thành chuỗi ngày được định dạng.
 * @param {string} date - Chuỗi ngày cần chuyển đổi.
 * @param {string} [format='DD/MM/YYYY'] - Định dạng của chuỗi ngày trả về.
 * @return {string} - Chuỗi ngày đã được định dạng.
 */ var sappFormatDate = function(date) {
    var format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "DD/MM/YYYY";
    return date ? dayjs__WEBPACK_IMPORTED_MODULE_1___default()(date).format(format) : undefined;
};
/**
 * @description Chuyển đổi một chuỗi ngày UTC thành chuỗi ngày địa phương được định dạng.
 * @param {string} date - Chuỗi ngày UTC cần chuyển đổi.
 * @param {string} [format='DD/MM/YYYY'] - Định dạng của chuỗi ngày địa phương trả về.
 * @return {string} - Chuỗi ngày địa phương đã được định dạng.
 */ var formatDateFromUTC = function(date) {
    var format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : src_constants__WEBPACK_IMPORTED_MODULE_8__/* .DATE_FORMAT.DATE */ .zT.DATE;
    if (date && dayjs__WEBPACK_IMPORTED_MODULE_1___default().utc(date).isValid()) {
        return dayjs__WEBPACK_IMPORTED_MODULE_1___default().utc(date).local().format(format);
    }
    return "-";
};
/**
 * @description Chuyển đổi giá trị enum của loại bài kiểm tra thành chuỗi dễ đọc.
 * @param {string} quizType - Giá trị enum của loại bài kiểm tra.
 * @return {string} - Chuỗi mô tả loại bài kiểm tra dễ đọc.
 */ var convertQuizType = function(quizType) {
    return quizType.split("_").map(function(word, index) {
        return index === 0 ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(" ");
};

var containsKeyword = function(input, keyword) {
    if (typeof input !== "string") return false;
    return input.includes(keyword !== null && keyword !== void 0 ? keyword : "data-time=");
};
/**
 * @description Chuyển đổi chuỗi HTML chứa thẻ <strong> với thuộc tính data-time thành định dạng ngày tháng có thể đọc được.
 * @param {string} input - Chuỗi HTML đầu vào.
 * @return {string} - Chuỗi HTML đã được định dạng lại với ngày tháng hiển thị theo định dạng DD/MM/YYYY.
 */ var formatNotificationHTML = function(input) {
    return input.replace(/<strong\s+data-time\s*=\s*["']([^"']+)["']\s*><\/strong>/g, function(match, dateTime) {
        var formattedDate = dayjs__WEBPACK_IMPORTED_MODULE_1___default().utc(dateTime).local().format(src_constants__WEBPACK_IMPORTED_MODULE_8__/* .DATE_FORMAT.DATE */ .zT.DATE);
        return "<strong>".concat(formattedDate, "</strong>");
    });
};
var clearStylesHtml = function(htmlContent) {
    if (htmlContent) {
        // Loại bỏ các thẻ <style> và thuộc tính style inline
        return htmlContent.replace(/<style.*?>.*?<\/style>/gi, "") // Xóa các thẻ style
        .replace(/\sstyle=".*?"/gi, "") // Xóa các thuộc tính inline style
        ;
    }
    return "";
};
function convertSlugToTitle(slug) {
    if (!slug) return "";
    return slug.replace(/-/g, " ") // thay dấu - thành dấu cách
    .replace(/\s+/g, " ") // gộp các khoảng trắng thừa
    .trim() // xoá khoảng trắng 2 đầu
    .split(" ") // tách từ
    .map(function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }) // viết hoa chữ cái đầu
    .join(" ") // ghép lại
    ;
}
function setCookie(name, value) {
    var days = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 7;
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = "".concat(name, "=").concat(encodeURIComponent(value), "; expires=").concat(expires, "; path=/");
}
function getCookie(name) {
    var ref;
    return ((ref = document.cookie.split("; ").find(function(row) {
        return row.startsWith(name + "=");
    })) === null || ref === void 0 ? void 0 : ref.split("=")[1]) || null;
}
function deleteCookie(name) {
    document.cookie = "".concat(name, "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/");
}
function parseJwt(token) {
    try {
        var base64Payload = token.split(".")[1];
        var payload = atob(base64Payload) // decode base64
        ;
        return JSON.parse(payload);
    } catch (error) {
        return null;
    }
}
function getSessionIdFromToken(token) {
    var decoded = parseJwt(token);
    return typeof (decoded === null || decoded === void 0 ? void 0 : decoded.session_state) === "string" ? decoded.session_state : null;
}
var formatPathWithQueryParams = function(pathname, params) {
    var cleanedParams = (0,_common__WEBPACK_IMPORTED_MODULE_6__/* .cleanParams */ .dm)(params);
    var queryString = new URLSearchParams(cleanedParams).toString();
    return queryString ? "".concat(pathname, "?").concat(queryString) : pathname;
};


/***/ }),

/***/ 96423:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SAPPVideo_wrapper___EhGW","hideWrapper":"SAPPVideo_hideWrapper__l48rL","content":"SAPPVideo_content__FC9Oj"};

/***/ }),

/***/ 44462:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 66130:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 60010:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 48609:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77086:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 67782:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 52490:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 83272:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 51371:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 96127:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 60148:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var state = __webpack_require__(96297);
var view = __webpack_require__(40585);
var keymap = __webpack_require__(72222);
var model = __webpack_require__(37480);
var transform = __webpack_require__(78879);
var commands$1 = __webpack_require__(99549);
var schemaList = __webpack_require__(61818);

/**
 * Takes a Transaction & Editor State and turns it into a chainable state object
 * @param config The transaction and state to create the chainable state from
 * @returns A chainable Editor state object
 */
function createChainableState(config) {
    const { state, transaction } = config;
    let { selection } = transaction;
    let { doc } = transaction;
    let { storedMarks } = transaction;
    return {
        ...state,
        apply: state.apply.bind(state),
        applyTransaction: state.applyTransaction.bind(state),
        plugins: state.plugins,
        schema: state.schema,
        reconfigure: state.reconfigure.bind(state),
        toJSON: state.toJSON.bind(state),
        get storedMarks() {
            return storedMarks;
        },
        get selection() {
            return selection;
        },
        get doc() {
            return doc;
        },
        get tr() {
            selection = transaction.selection;
            doc = transaction.doc;
            storedMarks = transaction.storedMarks;
            return transaction;
        },
    };
}

class CommandManager {
    constructor(props) {
        this.editor = props.editor;
        this.rawCommands = this.editor.extensionManager.commands;
        this.customState = props.state;
    }
    get hasCustomState() {
        return !!this.customState;
    }
    get state() {
        return this.customState || this.editor.state;
    }
    get commands() {
        const { rawCommands, editor, state } = this;
        const { view } = editor;
        const { tr } = state;
        const props = this.buildProps(tr);
        return Object.fromEntries(Object.entries(rawCommands).map(([name, command]) => {
            const method = (...args) => {
                const callback = command(...args)(props);
                if (!tr.getMeta('preventDispatch') && !this.hasCustomState) {
                    view.dispatch(tr);
                }
                return callback;
            };
            return [name, method];
        }));
    }
    get chain() {
        return () => this.createChain();
    }
    get can() {
        return () => this.createCan();
    }
    createChain(startTr, shouldDispatch = true) {
        const { rawCommands, editor, state } = this;
        const { view } = editor;
        const callbacks = [];
        const hasStartTransaction = !!startTr;
        const tr = startTr || state.tr;
        const run = () => {
            if (!hasStartTransaction
                && shouldDispatch
                && !tr.getMeta('preventDispatch')
                && !this.hasCustomState) {
                view.dispatch(tr);
            }
            return callbacks.every(callback => callback === true);
        };
        const chain = {
            ...Object.fromEntries(Object.entries(rawCommands).map(([name, command]) => {
                const chainedCommand = (...args) => {
                    const props = this.buildProps(tr, shouldDispatch);
                    const callback = command(...args)(props);
                    callbacks.push(callback);
                    return chain;
                };
                return [name, chainedCommand];
            })),
            run,
        };
        return chain;
    }
    createCan(startTr) {
        const { rawCommands, state } = this;
        const dispatch = false;
        const tr = startTr || state.tr;
        const props = this.buildProps(tr, dispatch);
        const formattedCommands = Object.fromEntries(Object.entries(rawCommands).map(([name, command]) => {
            return [name, (...args) => command(...args)({ ...props, dispatch: undefined })];
        }));
        return {
            ...formattedCommands,
            chain: () => this.createChain(tr, dispatch),
        };
    }
    buildProps(tr, shouldDispatch = true) {
        const { rawCommands, editor, state } = this;
        const { view } = editor;
        const props = {
            tr,
            editor,
            view,
            state: createChainableState({
                state,
                transaction: tr,
            }),
            dispatch: shouldDispatch ? () => undefined : undefined,
            chain: () => this.createChain(tr, shouldDispatch),
            can: () => this.createCan(tr),
            get commands() {
                return Object.fromEntries(Object.entries(rawCommands).map(([name, command]) => {
                    return [name, (...args) => command(...args)(props)];
                }));
            },
        };
        return props;
    }
}

class EventEmitter {
    constructor() {
        this.callbacks = {};
    }
    on(event, fn) {
        if (!this.callbacks[event]) {
            this.callbacks[event] = [];
        }
        this.callbacks[event].push(fn);
        return this;
    }
    emit(event, ...args) {
        const callbacks = this.callbacks[event];
        if (callbacks) {
            callbacks.forEach(callback => callback.apply(this, args));
        }
        return this;
    }
    off(event, fn) {
        const callbacks = this.callbacks[event];
        if (callbacks) {
            if (fn) {
                this.callbacks[event] = callbacks.filter(callback => callback !== fn);
            }
            else {
                delete this.callbacks[event];
            }
        }
        return this;
    }
    once(event, fn) {
        const onceFn = (...args) => {
            this.off(event, onceFn);
            fn.apply(this, args);
        };
        return this.on(event, onceFn);
    }
    removeAllListeners() {
        this.callbacks = {};
    }
}

/**
 * Returns a field from an extension
 * @param extension The Tiptap extension
 * @param field The field, for example `renderHTML` or `priority`
 * @param context The context object that should be passed as `this` into the function
 * @returns The field value
 */
function getExtensionField(extension, field, context) {
    if (extension.config[field] === undefined && extension.parent) {
        return getExtensionField(extension.parent, field, context);
    }
    if (typeof extension.config[field] === 'function') {
        const value = extension.config[field].bind({
            ...context,
            parent: extension.parent
                ? getExtensionField(extension.parent, field, context)
                : null,
        });
        return value;
    }
    return extension.config[field];
}

function splitExtensions(extensions) {
    const baseExtensions = extensions.filter(extension => extension.type === 'extension');
    const nodeExtensions = extensions.filter(extension => extension.type === 'node');
    const markExtensions = extensions.filter(extension => extension.type === 'mark');
    return {
        baseExtensions,
        nodeExtensions,
        markExtensions,
    };
}

/**
 * Get a list of all extension attributes defined in `addAttribute` and `addGlobalAttribute`.
 * @param extensions List of extensions
 */
function getAttributesFromExtensions(extensions) {
    const extensionAttributes = [];
    const { nodeExtensions, markExtensions } = splitExtensions(extensions);
    const nodeAndMarkExtensions = [...nodeExtensions, ...markExtensions];
    const defaultAttribute = {
        default: null,
        rendered: true,
        renderHTML: null,
        parseHTML: null,
        keepOnSplit: true,
        isRequired: false,
    };
    extensions.forEach(extension => {
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            extensions: nodeAndMarkExtensions,
        };
        const addGlobalAttributes = getExtensionField(extension, 'addGlobalAttributes', context);
        if (!addGlobalAttributes) {
            return;
        }
        const globalAttributes = addGlobalAttributes();
        globalAttributes.forEach(globalAttribute => {
            globalAttribute.types.forEach(type => {
                Object
                    .entries(globalAttribute.attributes)
                    .forEach(([name, attribute]) => {
                    extensionAttributes.push({
                        type,
                        name,
                        attribute: {
                            ...defaultAttribute,
                            ...attribute,
                        },
                    });
                });
            });
        });
    });
    nodeAndMarkExtensions.forEach(extension => {
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
        };
        const addAttributes = getExtensionField(extension, 'addAttributes', context);
        if (!addAttributes) {
            return;
        }
        // TODO: remove `as Attributes`
        const attributes = addAttributes();
        Object
            .entries(attributes)
            .forEach(([name, attribute]) => {
            const mergedAttr = {
                ...defaultAttribute,
                ...attribute,
            };
            if (typeof (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === 'function') {
                mergedAttr.default = mergedAttr.default();
            }
            if ((mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.isRequired) && (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === undefined) {
                delete mergedAttr.default;
            }
            extensionAttributes.push({
                type: extension.name,
                name,
                attribute: mergedAttr,
            });
        });
    });
    return extensionAttributes;
}

function getNodeType(nameOrType, schema) {
    if (typeof nameOrType === 'string') {
        if (!schema.nodes[nameOrType]) {
            throw Error(`There is no node type named '${nameOrType}'. Maybe you forgot to add the extension?`);
        }
        return schema.nodes[nameOrType];
    }
    return nameOrType;
}

function mergeAttributes(...objects) {
    return objects
        .filter(item => !!item)
        .reduce((items, item) => {
        const mergedAttributes = { ...items };
        Object.entries(item).forEach(([key, value]) => {
            const exists = mergedAttributes[key];
            if (!exists) {
                mergedAttributes[key] = value;
                return;
            }
            if (key === 'class') {
                const valueClasses = value ? String(value).split(' ') : [];
                const existingClasses = mergedAttributes[key] ? mergedAttributes[key].split(' ') : [];
                const insertClasses = valueClasses.filter(valueClass => !existingClasses.includes(valueClass));
                mergedAttributes[key] = [...existingClasses, ...insertClasses].join(' ');
            }
            else if (key === 'style') {
                const newStyles = value ? value.split(';').map((style) => style.trim()).filter(Boolean) : [];
                const existingStyles = mergedAttributes[key] ? mergedAttributes[key].split(';').map((style) => style.trim()).filter(Boolean) : [];
                const styleMap = new Map();
                existingStyles.forEach(style => {
                    const [property, val] = style.split(':').map(part => part.trim());
                    styleMap.set(property, val);
                });
                newStyles.forEach(style => {
                    const [property, val] = style.split(':').map(part => part.trim());
                    styleMap.set(property, val);
                });
                mergedAttributes[key] = Array.from(styleMap.entries()).map(([property, val]) => `${property}: ${val}`).join('; ');
            }
            else {
                mergedAttributes[key] = value;
            }
        });
        return mergedAttributes;
    }, {});
}

function getRenderedAttributes(nodeOrMark, extensionAttributes) {
    return extensionAttributes
        .filter(attribute => attribute.type === nodeOrMark.type.name)
        .filter(item => item.attribute.rendered)
        .map(item => {
        if (!item.attribute.renderHTML) {
            return {
                [item.name]: nodeOrMark.attrs[item.name],
            };
        }
        return item.attribute.renderHTML(nodeOrMark.attrs) || {};
    })
        .reduce((attributes, attribute) => mergeAttributes(attributes, attribute), {});
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function isFunction(value) {
    return typeof value === 'function';
}

/**
 * Optionally calls `value` as a function.
 * Otherwise it is returned directly.
 * @param value Function or any value.
 * @param context Optional context to bind to function.
 * @param props Optional props to pass to function.
 */
function callOrReturn(value, context = undefined, ...props) {
    if (isFunction(value)) {
        if (context) {
            return value.bind(context)(...props);
        }
        return value(...props);
    }
    return value;
}

function isEmptyObject(value = {}) {
    return Object.keys(value).length === 0 && value.constructor === Object;
}

function fromString(value) {
    if (typeof value !== 'string') {
        return value;
    }
    if (value.match(/^[+-]?(?:\d*\.)?\d+$/)) {
        return Number(value);
    }
    if (value === 'true') {
        return true;
    }
    if (value === 'false') {
        return false;
    }
    return value;
}

/**
 * This function merges extension attributes into parserule attributes (`attrs` or `getAttrs`).
 * Cancels when `getAttrs` returned `false`.
 * @param parseRule ProseMirror ParseRule
 * @param extensionAttributes List of attributes to inject
 */
function injectExtensionAttributesToParseRule(parseRule, extensionAttributes) {
    if ('style' in parseRule) {
        return parseRule;
    }
    return {
        ...parseRule,
        getAttrs: (node) => {
            const oldAttributes = parseRule.getAttrs ? parseRule.getAttrs(node) : parseRule.attrs;
            if (oldAttributes === false) {
                return false;
            }
            const newAttributes = extensionAttributes.reduce((items, item) => {
                const value = item.attribute.parseHTML
                    ? item.attribute.parseHTML(node)
                    : fromString((node).getAttribute(item.name));
                if (value === null || value === undefined) {
                    return items;
                }
                return {
                    ...items,
                    [item.name]: value,
                };
            }, {});
            return { ...oldAttributes, ...newAttributes };
        },
    };
}

function cleanUpSchemaItem(data) {
    return Object.fromEntries(
    // @ts-ignore
    Object.entries(data).filter(([key, value]) => {
        if (key === 'attrs' && isEmptyObject(value)) {
            return false;
        }
        return value !== null && value !== undefined;
    }));
}
/**
 * Creates a new Prosemirror schema based on the given extensions.
 * @param extensions An array of Tiptap extensions
 * @param editor The editor instance
 * @returns A Prosemirror schema
 */
function getSchemaByResolvedExtensions(extensions, editor) {
    var _a;
    const allAttributes = getAttributesFromExtensions(extensions);
    const { nodeExtensions, markExtensions } = splitExtensions(extensions);
    const topNode = (_a = nodeExtensions.find(extension => getExtensionField(extension, 'topNode'))) === null || _a === void 0 ? void 0 : _a.name;
    const nodes = Object.fromEntries(nodeExtensions.map(extension => {
        const extensionAttributes = allAttributes.filter(attribute => attribute.type === extension.name);
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            editor,
        };
        const extraNodeFields = extensions.reduce((fields, e) => {
            const extendNodeSchema = getExtensionField(e, 'extendNodeSchema', context);
            return {
                ...fields,
                ...(extendNodeSchema ? extendNodeSchema(extension) : {}),
            };
        }, {});
        const schema = cleanUpSchemaItem({
            ...extraNodeFields,
            content: callOrReturn(getExtensionField(extension, 'content', context)),
            marks: callOrReturn(getExtensionField(extension, 'marks', context)),
            group: callOrReturn(getExtensionField(extension, 'group', context)),
            inline: callOrReturn(getExtensionField(extension, 'inline', context)),
            atom: callOrReturn(getExtensionField(extension, 'atom', context)),
            selectable: callOrReturn(getExtensionField(extension, 'selectable', context)),
            draggable: callOrReturn(getExtensionField(extension, 'draggable', context)),
            code: callOrReturn(getExtensionField(extension, 'code', context)),
            whitespace: callOrReturn(getExtensionField(extension, 'whitespace', context)),
            linebreakReplacement: callOrReturn(getExtensionField(extension, 'linebreakReplacement', context)),
            defining: callOrReturn(getExtensionField(extension, 'defining', context)),
            isolating: callOrReturn(getExtensionField(extension, 'isolating', context)),
            attrs: Object.fromEntries(extensionAttributes.map(extensionAttribute => {
                var _a;
                return [extensionAttribute.name, { default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default }];
            })),
        });
        const parseHTML = callOrReturn(getExtensionField(extension, 'parseHTML', context));
        if (parseHTML) {
            schema.parseDOM = parseHTML.map(parseRule => injectExtensionAttributesToParseRule(parseRule, extensionAttributes));
        }
        const renderHTML = getExtensionField(extension, 'renderHTML', context);
        if (renderHTML) {
            schema.toDOM = node => renderHTML({
                node,
                HTMLAttributes: getRenderedAttributes(node, extensionAttributes),
            });
        }
        const renderText = getExtensionField(extension, 'renderText', context);
        if (renderText) {
            schema.toText = renderText;
        }
        return [extension.name, schema];
    }));
    const marks = Object.fromEntries(markExtensions.map(extension => {
        const extensionAttributes = allAttributes.filter(attribute => attribute.type === extension.name);
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            editor,
        };
        const extraMarkFields = extensions.reduce((fields, e) => {
            const extendMarkSchema = getExtensionField(e, 'extendMarkSchema', context);
            return {
                ...fields,
                ...(extendMarkSchema ? extendMarkSchema(extension) : {}),
            };
        }, {});
        const schema = cleanUpSchemaItem({
            ...extraMarkFields,
            inclusive: callOrReturn(getExtensionField(extension, 'inclusive', context)),
            excludes: callOrReturn(getExtensionField(extension, 'excludes', context)),
            group: callOrReturn(getExtensionField(extension, 'group', context)),
            spanning: callOrReturn(getExtensionField(extension, 'spanning', context)),
            code: callOrReturn(getExtensionField(extension, 'code', context)),
            attrs: Object.fromEntries(extensionAttributes.map(extensionAttribute => {
                var _a;
                return [extensionAttribute.name, { default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default }];
            })),
        });
        const parseHTML = callOrReturn(getExtensionField(extension, 'parseHTML', context));
        if (parseHTML) {
            schema.parseDOM = parseHTML.map(parseRule => injectExtensionAttributesToParseRule(parseRule, extensionAttributes));
        }
        const renderHTML = getExtensionField(extension, 'renderHTML', context);
        if (renderHTML) {
            schema.toDOM = mark => renderHTML({
                mark,
                HTMLAttributes: getRenderedAttributes(mark, extensionAttributes),
            });
        }
        return [extension.name, schema];
    }));
    return new model.Schema({
        topNode,
        nodes,
        marks,
    });
}

/**
 * Tries to get a node or mark type by its name.
 * @param name The name of the node or mark type
 * @param schema The Prosemiror schema to search in
 * @returns The node or mark type, or null if it doesn't exist
 */
function getSchemaTypeByName(name, schema) {
    return schema.nodes[name] || schema.marks[name] || null;
}

function isExtensionRulesEnabled(extension, enabled) {
    if (Array.isArray(enabled)) {
        return enabled.some(enabledExtension => {
            const name = typeof enabledExtension === 'string'
                ? enabledExtension
                : enabledExtension.name;
            return name === extension.name;
        });
    }
    return enabled;
}

function getHTMLFromFragment(fragment, schema) {
    const documentFragment = model.DOMSerializer.fromSchema(schema).serializeFragment(fragment);
    const temporaryDocument = document.implementation.createHTMLDocument();
    const container = temporaryDocument.createElement('div');
    container.appendChild(documentFragment);
    return container.innerHTML;
}

/**
 * Returns the text content of a resolved prosemirror position
 * @param $from The resolved position to get the text content from
 * @param maxMatch The maximum number of characters to match
 * @returns The text content
 */
const getTextContentFromNodes = ($from, maxMatch = 500) => {
    let textBefore = '';
    const sliceEndPos = $from.parentOffset;
    $from.parent.nodesBetween(Math.max(0, sliceEndPos - maxMatch), sliceEndPos, (node, pos, parent, index) => {
        var _a, _b;
        const chunk = ((_b = (_a = node.type.spec).toText) === null || _b === void 0 ? void 0 : _b.call(_a, {
            node,
            pos,
            parent,
            index,
        }))
            || node.textContent
            || '%leaf%';
        textBefore += node.isAtom && !node.isText ? chunk : chunk.slice(0, Math.max(0, sliceEndPos - pos));
    });
    return textBefore;
};

function isRegExp(value) {
    return Object.prototype.toString.call(value) === '[object RegExp]';
}

class InputRule {
    constructor(config) {
        this.find = config.find;
        this.handler = config.handler;
    }
}
const inputRuleMatcherHandler = (text, find) => {
    if (isRegExp(find)) {
        return find.exec(text);
    }
    const inputRuleMatch = find(text);
    if (!inputRuleMatch) {
        return null;
    }
    const result = [inputRuleMatch.text];
    result.index = inputRuleMatch.index;
    result.input = text;
    result.data = inputRuleMatch.data;
    if (inputRuleMatch.replaceWith) {
        if (!inputRuleMatch.text.includes(inputRuleMatch.replaceWith)) {
            console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".');
        }
        result.push(inputRuleMatch.replaceWith);
    }
    return result;
};
function run$1(config) {
    var _a;
    const { editor, from, to, text, rules, plugin, } = config;
    const { view } = editor;
    if (view.composing) {
        return false;
    }
    const $from = view.state.doc.resolve(from);
    if (
    // check for code node
    $from.parent.type.spec.code
        // check for code mark
        || !!((_a = ($from.nodeBefore || $from.nodeAfter)) === null || _a === void 0 ? void 0 : _a.marks.find(mark => mark.type.spec.code))) {
        return false;
    }
    let matched = false;
    const textBefore = getTextContentFromNodes($from) + text;
    rules.forEach(rule => {
        if (matched) {
            return;
        }
        const match = inputRuleMatcherHandler(textBefore, rule.find);
        if (!match) {
            return;
        }
        const tr = view.state.tr;
        const state = createChainableState({
            state: view.state,
            transaction: tr,
        });
        const range = {
            from: from - (match[0].length - text.length),
            to,
        };
        const { commands, chain, can } = new CommandManager({
            editor,
            state,
        });
        const handler = rule.handler({
            state,
            range,
            match,
            commands,
            chain,
            can,
        });
        // stop if there are no changes
        if (handler === null || !tr.steps.length) {
            return;
        }
        // store transform as meta data
        // so we can undo input rules within the `undoInputRules` command
        tr.setMeta(plugin, {
            transform: tr,
            from,
            to,
            text,
        });
        view.dispatch(tr);
        matched = true;
    });
    return matched;
}
/**
 * Create an input rules plugin. When enabled, it will cause text
 * input that matches any of the given rules to trigger the rule’s
 * action.
 */
function inputRulesPlugin(props) {
    const { editor, rules } = props;
    const plugin = new state.Plugin({
        state: {
            init() {
                return null;
            },
            apply(tr, prev, state) {
                const stored = tr.getMeta(plugin);
                if (stored) {
                    return stored;
                }
                // if InputRule is triggered by insertContent()
                const simulatedInputMeta = tr.getMeta('applyInputRules');
                const isSimulatedInput = !!simulatedInputMeta;
                if (isSimulatedInput) {
                    setTimeout(() => {
                        let { text } = simulatedInputMeta;
                        if (typeof text === 'string') {
                            text = text;
                        }
                        else {
                            text = getHTMLFromFragment(model.Fragment.from(text), state.schema);
                        }
                        const { from } = simulatedInputMeta;
                        const to = from + text.length;
                        run$1({
                            editor,
                            from,
                            to,
                            text,
                            rules,
                            plugin,
                        });
                    });
                }
                return tr.selectionSet || tr.docChanged ? null : prev;
            },
        },
        props: {
            handleTextInput(view, from, to, text) {
                return run$1({
                    editor,
                    from,
                    to,
                    text,
                    rules,
                    plugin,
                });
            },
            handleDOMEvents: {
                compositionend: view => {
                    setTimeout(() => {
                        const { $cursor } = view.state.selection;
                        if ($cursor) {
                            run$1({
                                editor,
                                from: $cursor.pos,
                                to: $cursor.pos,
                                text: '',
                                rules,
                                plugin,
                            });
                        }
                    });
                    return false;
                },
            },
            // add support for input rules to trigger on enter
            // this is useful for example for code blocks
            handleKeyDown(view, event) {
                if (event.key !== 'Enter') {
                    return false;
                }
                const { $cursor } = view.state.selection;
                if ($cursor) {
                    return run$1({
                        editor,
                        from: $cursor.pos,
                        to: $cursor.pos,
                        text: '\n',
                        rules,
                        plugin,
                    });
                }
                return false;
            },
        },
        // @ts-ignore
        isInputRules: true,
    });
    return plugin;
}

// see: https://github.com/mesqueeb/is-what/blob/88d6e4ca92fb2baab6003c54e02eedf4e729e5ab/src/index.ts
function getType(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
function isPlainObject(value) {
    if (getType(value) !== 'Object') {
        return false;
    }
    return value.constructor === Object && Object.getPrototypeOf(value) === Object.prototype;
}

function mergeDeep(target, source) {
    const output = { ...target };
    if (isPlainObject(target) && isPlainObject(source)) {
        Object.keys(source).forEach(key => {
            if (isPlainObject(source[key]) && isPlainObject(target[key])) {
                output[key] = mergeDeep(target[key], source[key]);
            }
            else {
                output[key] = source[key];
            }
        });
    }
    return output;
}

/**
 * The Mark class is used to create custom mark extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */
class Mark {
    constructor(config = {}) {
        this.type = 'mark';
        this.name = 'mark';
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {},
        };
        this.config = {
            ...this.config,
            ...config,
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        }
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) {
            this.options = callOrReturn(getExtensionField(this, 'addOptions', {
                name: this.name,
            }));
        }
        this.storage = callOrReturn(getExtensionField(this, 'addStorage', {
            name: this.name,
            options: this.options,
        })) || {};
    }
    static create(config = {}) {
        return new Mark(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: () => {
                return mergeDeep(this.options, options);
            },
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new Mark(extendedConfig);
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        }
        extension.options = callOrReturn(getExtensionField(extension, 'addOptions', {
            name: extension.name,
        }));
        extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
            name: extension.name,
            options: extension.options,
        }));
        return extension;
    }
    static handleExit({ editor, mark }) {
        const { tr } = editor.state;
        const currentPos = editor.state.selection.$from;
        const isAtEnd = currentPos.pos === currentPos.end();
        if (isAtEnd) {
            const currentMarks = currentPos.marks();
            const isInMark = !!currentMarks.find(m => (m === null || m === void 0 ? void 0 : m.type.name) === mark.name);
            if (!isInMark) {
                return false;
            }
            const removeMark = currentMarks.find(m => (m === null || m === void 0 ? void 0 : m.type.name) === mark.name);
            if (removeMark) {
                tr.removeStoredMark(removeMark);
            }
            tr.insertText(' ', currentPos.pos);
            editor.view.dispatch(tr);
            return true;
        }
        return false;
    }
}

function isNumber(value) {
    return typeof value === 'number';
}

/**
 * Paste rules are used to react to pasted content.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */
class PasteRule {
    constructor(config) {
        this.find = config.find;
        this.handler = config.handler;
    }
}
const pasteRuleMatcherHandler = (text, find, event) => {
    if (isRegExp(find)) {
        return [...text.matchAll(find)];
    }
    const matches = find(text, event);
    if (!matches) {
        return [];
    }
    return matches.map(pasteRuleMatch => {
        const result = [pasteRuleMatch.text];
        result.index = pasteRuleMatch.index;
        result.input = text;
        result.data = pasteRuleMatch.data;
        if (pasteRuleMatch.replaceWith) {
            if (!pasteRuleMatch.text.includes(pasteRuleMatch.replaceWith)) {
                console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".');
            }
            result.push(pasteRuleMatch.replaceWith);
        }
        return result;
    });
};
function run(config) {
    const { editor, state, from, to, rule, pasteEvent, dropEvent, } = config;
    const { commands, chain, can } = new CommandManager({
        editor,
        state,
    });
    const handlers = [];
    state.doc.nodesBetween(from, to, (node, pos) => {
        if (!node.isTextblock || node.type.spec.code) {
            return;
        }
        const resolvedFrom = Math.max(from, pos);
        const resolvedTo = Math.min(to, pos + node.content.size);
        const textToMatch = node.textBetween(resolvedFrom - pos, resolvedTo - pos, undefined, '\ufffc');
        const matches = pasteRuleMatcherHandler(textToMatch, rule.find, pasteEvent);
        matches.forEach(match => {
            if (match.index === undefined) {
                return;
            }
            const start = resolvedFrom + match.index + 1;
            const end = start + match[0].length;
            const range = {
                from: state.tr.mapping.map(start),
                to: state.tr.mapping.map(end),
            };
            const handler = rule.handler({
                state,
                range,
                match,
                commands,
                chain,
                can,
                pasteEvent,
                dropEvent,
            });
            handlers.push(handler);
        });
    });
    const success = handlers.every(handler => handler !== null);
    return success;
}
// When dragging across editors, must get another editor instance to delete selection content.
let tiptapDragFromOtherEditor = null;
const createClipboardPasteEvent = (text) => {
    var _a;
    const event = new ClipboardEvent('paste', {
        clipboardData: new DataTransfer(),
    });
    (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.setData('text/html', text);
    return event;
};
/**
 * Create an paste rules plugin. When enabled, it will cause pasted
 * text that matches any of the given rules to trigger the rule’s
 * action.
 */
function pasteRulesPlugin(props) {
    const { editor, rules } = props;
    let dragSourceElement = null;
    let isPastedFromProseMirror = false;
    let isDroppedFromProseMirror = false;
    let pasteEvent = typeof ClipboardEvent !== 'undefined' ? new ClipboardEvent('paste') : null;
    let dropEvent;
    try {
        dropEvent = typeof DragEvent !== 'undefined' ? new DragEvent('drop') : null;
    }
    catch {
        dropEvent = null;
    }
    const processEvent = ({ state, from, to, rule, pasteEvt, }) => {
        const tr = state.tr;
        const chainableState = createChainableState({
            state,
            transaction: tr,
        });
        const handler = run({
            editor,
            state: chainableState,
            from: Math.max(from - 1, 0),
            to: to.b - 1,
            rule,
            pasteEvent: pasteEvt,
            dropEvent,
        });
        if (!handler || !tr.steps.length) {
            return;
        }
        try {
            dropEvent = typeof DragEvent !== 'undefined' ? new DragEvent('drop') : null;
        }
        catch {
            dropEvent = null;
        }
        pasteEvent = typeof ClipboardEvent !== 'undefined' ? new ClipboardEvent('paste') : null;
        return tr;
    };
    const plugins = rules.map(rule => {
        return new state.Plugin({
            // we register a global drag handler to track the current drag source element
            view(view) {
                const handleDragstart = (event) => {
                    var _a;
                    dragSourceElement = ((_a = view.dom.parentElement) === null || _a === void 0 ? void 0 : _a.contains(event.target))
                        ? view.dom.parentElement
                        : null;
                    if (dragSourceElement) {
                        tiptapDragFromOtherEditor = editor;
                    }
                };
                const handleDragend = () => {
                    if (tiptapDragFromOtherEditor) {
                        tiptapDragFromOtherEditor = null;
                    }
                };
                window.addEventListener('dragstart', handleDragstart);
                window.addEventListener('dragend', handleDragend);
                return {
                    destroy() {
                        window.removeEventListener('dragstart', handleDragstart);
                        window.removeEventListener('dragend', handleDragend);
                    },
                };
            },
            props: {
                handleDOMEvents: {
                    drop: (view, event) => {
                        isDroppedFromProseMirror = dragSourceElement === view.dom.parentElement;
                        dropEvent = event;
                        if (!isDroppedFromProseMirror) {
                            const dragFromOtherEditor = tiptapDragFromOtherEditor;
                            if (dragFromOtherEditor === null || dragFromOtherEditor === void 0 ? void 0 : dragFromOtherEditor.isEditable) {
                                // setTimeout to avoid the wrong content after drop, timeout arg can't be empty or 0
                                setTimeout(() => {
                                    const selection = dragFromOtherEditor.state.selection;
                                    if (selection) {
                                        dragFromOtherEditor.commands.deleteRange({ from: selection.from, to: selection.to });
                                    }
                                }, 10);
                            }
                        }
                        return false;
                    },
                    paste: (_view, event) => {
                        var _a;
                        const html = (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.getData('text/html');
                        pasteEvent = event;
                        isPastedFromProseMirror = !!(html === null || html === void 0 ? void 0 : html.includes('data-pm-slice'));
                        return false;
                    },
                },
            },
            appendTransaction: (transactions, oldState, state) => {
                const transaction = transactions[0];
                const isPaste = transaction.getMeta('uiEvent') === 'paste' && !isPastedFromProseMirror;
                const isDrop = transaction.getMeta('uiEvent') === 'drop' && !isDroppedFromProseMirror;
                // if PasteRule is triggered by insertContent()
                const simulatedPasteMeta = transaction.getMeta('applyPasteRules');
                const isSimulatedPaste = !!simulatedPasteMeta;
                if (!isPaste && !isDrop && !isSimulatedPaste) {
                    return;
                }
                // Handle simulated paste
                if (isSimulatedPaste) {
                    let { text } = simulatedPasteMeta;
                    if (typeof text === 'string') {
                        text = text;
                    }
                    else {
                        text = getHTMLFromFragment(model.Fragment.from(text), state.schema);
                    }
                    const { from } = simulatedPasteMeta;
                    const to = from + text.length;
                    const pasteEvt = createClipboardPasteEvent(text);
                    return processEvent({
                        rule,
                        state,
                        from,
                        to: { b: to },
                        pasteEvt,
                    });
                }
                // handle actual paste/drop
                const from = oldState.doc.content.findDiffStart(state.doc.content);
                const to = oldState.doc.content.findDiffEnd(state.doc.content);
                // stop if there is no changed range
                if (!isNumber(from) || !to || from === to.b) {
                    return;
                }
                return processEvent({
                    rule,
                    state,
                    from,
                    to,
                    pasteEvt: pasteEvent,
                });
            },
        });
    });
    return plugins;
}

function findDuplicates(items) {
    const filtered = items.filter((el, index) => items.indexOf(el) !== index);
    return Array.from(new Set(filtered));
}

class ExtensionManager {
    constructor(extensions, editor) {
        this.splittableMarks = [];
        this.editor = editor;
        this.extensions = ExtensionManager.resolve(extensions);
        this.schema = getSchemaByResolvedExtensions(this.extensions, editor);
        this.setupExtensions();
    }
    /**
     * Returns a flattened and sorted extension list while
     * also checking for duplicated extensions and warns the user.
     * @param extensions An array of Tiptap extensions
     * @returns An flattened and sorted array of Tiptap extensions
     */
    static resolve(extensions) {
        const resolvedExtensions = ExtensionManager.sort(ExtensionManager.flatten(extensions));
        const duplicatedNames = findDuplicates(resolvedExtensions.map(extension => extension.name));
        if (duplicatedNames.length) {
            console.warn(`[tiptap warn]: Duplicate extension names found: [${duplicatedNames
                .map(item => `'${item}'`)
                .join(', ')}]. This can lead to issues.`);
        }
        return resolvedExtensions;
    }
    /**
     * Create a flattened array of extensions by traversing the `addExtensions` field.
     * @param extensions An array of Tiptap extensions
     * @returns A flattened array of Tiptap extensions
     */
    static flatten(extensions) {
        return (extensions
            .map(extension => {
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
            };
            const addExtensions = getExtensionField(extension, 'addExtensions', context);
            if (addExtensions) {
                return [extension, ...this.flatten(addExtensions())];
            }
            return extension;
        })
            // `Infinity` will break TypeScript so we set a number that is probably high enough
            .flat(10));
    }
    /**
     * Sort extensions by priority.
     * @param extensions An array of Tiptap extensions
     * @returns A sorted array of Tiptap extensions by priority
     */
    static sort(extensions) {
        const defaultPriority = 100;
        return extensions.sort((a, b) => {
            const priorityA = getExtensionField(a, 'priority') || defaultPriority;
            const priorityB = getExtensionField(b, 'priority') || defaultPriority;
            if (priorityA > priorityB) {
                return -1;
            }
            if (priorityA < priorityB) {
                return 1;
            }
            return 0;
        });
    }
    /**
     * Get all commands from the extensions.
     * @returns An object with all commands where the key is the command name and the value is the command function
     */
    get commands() {
        return this.extensions.reduce((commands, extension) => {
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: this.editor,
                type: getSchemaTypeByName(extension.name, this.schema),
            };
            const addCommands = getExtensionField(extension, 'addCommands', context);
            if (!addCommands) {
                return commands;
            }
            return {
                ...commands,
                ...addCommands(),
            };
        }, {});
    }
    /**
     * Get all registered Prosemirror plugins from the extensions.
     * @returns An array of Prosemirror plugins
     */
    get plugins() {
        const { editor } = this;
        // With ProseMirror, first plugins within an array are executed first.
        // In Tiptap, we provide the ability to override plugins,
        // so it feels more natural to run plugins at the end of an array first.
        // That’s why we have to reverse the `extensions` array and sort again
        // based on the `priority` option.
        const extensions = ExtensionManager.sort([...this.extensions].reverse());
        const inputRules = [];
        const pasteRules = [];
        const allPlugins = extensions
            .map(extension => {
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor,
                type: getSchemaTypeByName(extension.name, this.schema),
            };
            const plugins = [];
            const addKeyboardShortcuts = getExtensionField(extension, 'addKeyboardShortcuts', context);
            let defaultBindings = {};
            // bind exit handling
            if (extension.type === 'mark' && getExtensionField(extension, 'exitable', context)) {
                defaultBindings.ArrowRight = () => Mark.handleExit({ editor, mark: extension });
            }
            if (addKeyboardShortcuts) {
                const bindings = Object.fromEntries(Object.entries(addKeyboardShortcuts()).map(([shortcut, method]) => {
                    return [shortcut, () => method({ editor })];
                }));
                defaultBindings = { ...defaultBindings, ...bindings };
            }
            const keyMapPlugin = keymap.keymap(defaultBindings);
            plugins.push(keyMapPlugin);
            const addInputRules = getExtensionField(extension, 'addInputRules', context);
            if (isExtensionRulesEnabled(extension, editor.options.enableInputRules) && addInputRules) {
                inputRules.push(...addInputRules());
            }
            const addPasteRules = getExtensionField(extension, 'addPasteRules', context);
            if (isExtensionRulesEnabled(extension, editor.options.enablePasteRules) && addPasteRules) {
                pasteRules.push(...addPasteRules());
            }
            const addProseMirrorPlugins = getExtensionField(extension, 'addProseMirrorPlugins', context);
            if (addProseMirrorPlugins) {
                const proseMirrorPlugins = addProseMirrorPlugins();
                plugins.push(...proseMirrorPlugins);
            }
            return plugins;
        })
            .flat();
        return [
            inputRulesPlugin({
                editor,
                rules: inputRules,
            }),
            ...pasteRulesPlugin({
                editor,
                rules: pasteRules,
            }),
            ...allPlugins,
        ];
    }
    /**
     * Get all attributes from the extensions.
     * @returns An array of attributes
     */
    get attributes() {
        return getAttributesFromExtensions(this.extensions);
    }
    /**
     * Get all node views from the extensions.
     * @returns An object with all node views where the key is the node name and the value is the node view function
     */
    get nodeViews() {
        const { editor } = this;
        const { nodeExtensions } = splitExtensions(this.extensions);
        return Object.fromEntries(nodeExtensions
            .filter(extension => !!getExtensionField(extension, 'addNodeView'))
            .map(extension => {
            const extensionAttributes = this.attributes.filter(attribute => attribute.type === extension.name);
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor,
                type: getNodeType(extension.name, this.schema),
            };
            const addNodeView = getExtensionField(extension, 'addNodeView', context);
            if (!addNodeView) {
                return [];
            }
            const nodeview = (node, view, getPos, decorations, innerDecorations) => {
                const HTMLAttributes = getRenderedAttributes(node, extensionAttributes);
                return addNodeView()({
                    // pass-through
                    node,
                    view,
                    getPos: getPos,
                    decorations,
                    innerDecorations,
                    // tiptap-specific
                    editor,
                    extension,
                    HTMLAttributes,
                });
            };
            return [extension.name, nodeview];
        }));
    }
    /**
     * Go through all extensions, create extension storages & setup marks
     * & bind editor event listener.
     */
    setupExtensions() {
        this.extensions.forEach(extension => {
            var _a;
            // store extension storage in editor
            this.editor.extensionStorage[extension.name] = extension.storage;
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: this.editor,
                type: getSchemaTypeByName(extension.name, this.schema),
            };
            if (extension.type === 'mark') {
                const keepOnSplit = (_a = callOrReturn(getExtensionField(extension, 'keepOnSplit', context))) !== null && _a !== void 0 ? _a : true;
                if (keepOnSplit) {
                    this.splittableMarks.push(extension.name);
                }
            }
            const onBeforeCreate = getExtensionField(extension, 'onBeforeCreate', context);
            const onCreate = getExtensionField(extension, 'onCreate', context);
            const onUpdate = getExtensionField(extension, 'onUpdate', context);
            const onSelectionUpdate = getExtensionField(extension, 'onSelectionUpdate', context);
            const onTransaction = getExtensionField(extension, 'onTransaction', context);
            const onFocus = getExtensionField(extension, 'onFocus', context);
            const onBlur = getExtensionField(extension, 'onBlur', context);
            const onDestroy = getExtensionField(extension, 'onDestroy', context);
            if (onBeforeCreate) {
                this.editor.on('beforeCreate', onBeforeCreate);
            }
            if (onCreate) {
                this.editor.on('create', onCreate);
            }
            if (onUpdate) {
                this.editor.on('update', onUpdate);
            }
            if (onSelectionUpdate) {
                this.editor.on('selectionUpdate', onSelectionUpdate);
            }
            if (onTransaction) {
                this.editor.on('transaction', onTransaction);
            }
            if (onFocus) {
                this.editor.on('focus', onFocus);
            }
            if (onBlur) {
                this.editor.on('blur', onBlur);
            }
            if (onDestroy) {
                this.editor.on('destroy', onDestroy);
            }
        });
    }
}

/**
 * The Extension class is the base class for all extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */
class Extension {
    constructor(config = {}) {
        this.type = 'extension';
        this.name = 'extension';
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {},
        };
        this.config = {
            ...this.config,
            ...config,
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        }
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) {
            this.options = callOrReturn(getExtensionField(this, 'addOptions', {
                name: this.name,
            }));
        }
        this.storage = callOrReturn(getExtensionField(this, 'addStorage', {
            name: this.name,
            options: this.options,
        })) || {};
    }
    static create(config = {}) {
        return new Extension(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: () => {
                return mergeDeep(this.options, options);
            },
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new Extension({ ...this.config, ...extendedConfig });
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        }
        extension.options = callOrReturn(getExtensionField(extension, 'addOptions', {
            name: extension.name,
        }));
        extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
            name: extension.name,
            options: extension.options,
        }));
        return extension;
    }
}

/**
 * Gets the text between two positions in a Prosemirror node
 * and serializes it using the given text serializers and block separator (see getText)
 * @param startNode The Prosemirror node to start from
 * @param range The range of the text to get
 * @param options Options for the text serializer & block separator
 * @returns The text between the two positions
 */
function getTextBetween(startNode, range, options) {
    const { from, to } = range;
    const { blockSeparator = '\n\n', textSerializers = {} } = options || {};
    let text = '';
    startNode.nodesBetween(from, to, (node, pos, parent, index) => {
        var _a;
        if (node.isBlock && pos > from) {
            text += blockSeparator;
        }
        const textSerializer = textSerializers === null || textSerializers === void 0 ? void 0 : textSerializers[node.type.name];
        if (textSerializer) {
            if (parent) {
                text += textSerializer({
                    node,
                    pos,
                    parent,
                    index,
                    range,
                });
            }
            // do not descend into child nodes when there exists a serializer
            return false;
        }
        if (node.isText) {
            text += (_a = node === null || node === void 0 ? void 0 : node.text) === null || _a === void 0 ? void 0 : _a.slice(Math.max(from, pos) - pos, to - pos); // eslint-disable-line
        }
    });
    return text;
}

/**
 * Find text serializers `toText` in a Prosemirror schema
 * @param schema The Prosemirror schema to search in
 * @returns A record of text serializers by node name
 */
function getTextSerializersFromSchema(schema) {
    return Object.fromEntries(Object.entries(schema.nodes)
        .filter(([, node]) => node.spec.toText)
        .map(([name, node]) => [name, node.spec.toText]));
}

const ClipboardTextSerializer = Extension.create({
    name: 'clipboardTextSerializer',
    addOptions() {
        return {
            blockSeparator: undefined,
        };
    },
    addProseMirrorPlugins() {
        return [
            new state.Plugin({
                key: new state.PluginKey('clipboardTextSerializer'),
                props: {
                    clipboardTextSerializer: () => {
                        const { editor } = this;
                        const { state, schema } = editor;
                        const { doc, selection } = state;
                        const { ranges } = selection;
                        const from = Math.min(...ranges.map(range => range.$from.pos));
                        const to = Math.max(...ranges.map(range => range.$to.pos));
                        const textSerializers = getTextSerializersFromSchema(schema);
                        const range = { from, to };
                        return getTextBetween(doc, range, {
                            ...(this.options.blockSeparator !== undefined
                                ? { blockSeparator: this.options.blockSeparator }
                                : {}),
                            textSerializers,
                        });
                    },
                },
            }),
        ];
    },
});

const blur = () => ({ editor, view }) => {
    requestAnimationFrame(() => {
        var _a;
        if (!editor.isDestroyed) {
            view.dom.blur();
            // Browsers should remove the caret on blur but safari does not.
            // See: https://github.com/ueberdosis/tiptap/issues/2405
            (_a = window === null || window === void 0 ? void 0 : window.getSelection()) === null || _a === void 0 ? void 0 : _a.removeAllRanges();
        }
    });
    return true;
};

const clearContent = (emitUpdate = false) => ({ commands }) => {
    return commands.setContent('', emitUpdate);
};

const clearNodes = () => ({ state, tr, dispatch }) => {
    const { selection } = tr;
    const { ranges } = selection;
    if (!dispatch) {
        return true;
    }
    ranges.forEach(({ $from, $to }) => {
        state.doc.nodesBetween($from.pos, $to.pos, (node, pos) => {
            if (node.type.isText) {
                return;
            }
            const { doc, mapping } = tr;
            const $mappedFrom = doc.resolve(mapping.map(pos));
            const $mappedTo = doc.resolve(mapping.map(pos + node.nodeSize));
            const nodeRange = $mappedFrom.blockRange($mappedTo);
            if (!nodeRange) {
                return;
            }
            const targetLiftDepth = transform.liftTarget(nodeRange);
            if (node.type.isTextblock) {
                const { defaultType } = $mappedFrom.parent.contentMatchAt($mappedFrom.index());
                tr.setNodeMarkup(nodeRange.start, defaultType);
            }
            if (targetLiftDepth || targetLiftDepth === 0) {
                tr.lift(nodeRange, targetLiftDepth);
            }
        });
    });
    return true;
};

const command = fn => props => {
    return fn(props);
};

const createParagraphNear = () => ({ state, dispatch }) => {
    return commands$1.createParagraphNear(state, dispatch);
};

const cut = (originRange, targetPos) => ({ editor, tr }) => {
    const { state: state$1 } = editor;
    const contentSlice = state$1.doc.slice(originRange.from, originRange.to);
    tr.deleteRange(originRange.from, originRange.to);
    const newPos = tr.mapping.map(targetPos);
    tr.insert(newPos, contentSlice.content);
    tr.setSelection(new state.TextSelection(tr.doc.resolve(Math.max(newPos - 1, 0))));
    return true;
};

const deleteCurrentNode = () => ({ tr, dispatch }) => {
    const { selection } = tr;
    const currentNode = selection.$anchor.node();
    // if there is content inside the current node, break out of this command
    if (currentNode.content.size > 0) {
        return false;
    }
    const $pos = tr.selection.$anchor;
    for (let depth = $pos.depth; depth > 0; depth -= 1) {
        const node = $pos.node(depth);
        if (node.type === currentNode.type) {
            if (dispatch) {
                const from = $pos.before(depth);
                const to = $pos.after(depth);
                tr.delete(from, to).scrollIntoView();
            }
            return true;
        }
    }
    return false;
};

const deleteNode = typeOrName => ({ tr, state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    const $pos = tr.selection.$anchor;
    for (let depth = $pos.depth; depth > 0; depth -= 1) {
        const node = $pos.node(depth);
        if (node.type === type) {
            if (dispatch) {
                const from = $pos.before(depth);
                const to = $pos.after(depth);
                tr.delete(from, to).scrollIntoView();
            }
            return true;
        }
    }
    return false;
};

const deleteRange = range => ({ tr, dispatch }) => {
    const { from, to } = range;
    if (dispatch) {
        tr.delete(from, to);
    }
    return true;
};

const deleteSelection = () => ({ state, dispatch }) => {
    return commands$1.deleteSelection(state, dispatch);
};

const enter = () => ({ commands }) => {
    return commands.keyboardShortcut('Enter');
};

const exitCode = () => ({ state, dispatch }) => {
    return commands$1.exitCode(state, dispatch);
};

/**
 * Check if object1 includes object2
 * @param object1 Object
 * @param object2 Object
 */
function objectIncludes(object1, object2, options = { strict: true }) {
    const keys = Object.keys(object2);
    if (!keys.length) {
        return true;
    }
    return keys.every(key => {
        if (options.strict) {
            return object2[key] === object1[key];
        }
        if (isRegExp(object2[key])) {
            return object2[key].test(object1[key]);
        }
        return object2[key] === object1[key];
    });
}

function findMarkInSet(marks, type, attributes = {}) {
    return marks.find(item => {
        return (item.type === type
            && objectIncludes(
            // Only check equality for the attributes that are provided
            Object.fromEntries(Object.keys(attributes).map(k => [k, item.attrs[k]])), attributes));
    });
}
function isMarkInSet(marks, type, attributes = {}) {
    return !!findMarkInSet(marks, type, attributes);
}
/**
 * Get the range of a mark at a resolved position.
 */
function getMarkRange(
/**
 * The position to get the mark range for.
 */
$pos, 
/**
 * The mark type to get the range for.
 */
type, 
/**
 * The attributes to match against.
 * If not provided, only the first mark at the position will be matched.
 */
attributes) {
    var _a;
    if (!$pos || !type) {
        return;
    }
    let start = $pos.parent.childAfter($pos.parentOffset);
    // If the cursor is at the start of a text node that does not have the mark, look backward
    if (!start.node || !start.node.marks.some(mark => mark.type === type)) {
        start = $pos.parent.childBefore($pos.parentOffset);
    }
    // If there is no text node with the mark even backward, return undefined
    if (!start.node || !start.node.marks.some(mark => mark.type === type)) {
        return;
    }
    // Default to only matching against the first mark's attributes
    attributes = attributes || ((_a = start.node.marks[0]) === null || _a === void 0 ? void 0 : _a.attrs);
    // We now know that the cursor is either at the start, middle or end of a text node with the specified mark
    // so we can look it up on the targeted mark
    const mark = findMarkInSet([...start.node.marks], type, attributes);
    if (!mark) {
        return;
    }
    let startIndex = start.index;
    let startPos = $pos.start() + start.offset;
    let endIndex = startIndex + 1;
    let endPos = startPos + start.node.nodeSize;
    while (startIndex > 0
        && isMarkInSet([...$pos.parent.child(startIndex - 1).marks], type, attributes)) {
        startIndex -= 1;
        startPos -= $pos.parent.child(startIndex).nodeSize;
    }
    while (endIndex < $pos.parent.childCount
        && isMarkInSet([...$pos.parent.child(endIndex).marks], type, attributes)) {
        endPos += $pos.parent.child(endIndex).nodeSize;
        endIndex += 1;
    }
    return {
        from: startPos,
        to: endPos,
    };
}

function getMarkType(nameOrType, schema) {
    if (typeof nameOrType === 'string') {
        if (!schema.marks[nameOrType]) {
            throw Error(`There is no mark type named '${nameOrType}'. Maybe you forgot to add the extension?`);
        }
        return schema.marks[nameOrType];
    }
    return nameOrType;
}

const extendMarkRange = (typeOrName, attributes = {}) => ({ tr, state: state$1, dispatch }) => {
    const type = getMarkType(typeOrName, state$1.schema);
    const { doc, selection } = tr;
    const { $from, from, to } = selection;
    if (dispatch) {
        const range = getMarkRange($from, type, attributes);
        if (range && range.from <= from && range.to >= to) {
            const newSelection = state.TextSelection.create(doc, range.from, range.to);
            tr.setSelection(newSelection);
        }
    }
    return true;
};

const first = commands => props => {
    const items = typeof commands === 'function'
        ? commands(props)
        : commands;
    for (let i = 0; i < items.length; i += 1) {
        if (items[i](props)) {
            return true;
        }
    }
    return false;
};

function isTextSelection(value) {
    return value instanceof state.TextSelection;
}

function minMax(value = 0, min = 0, max = 0) {
    return Math.min(Math.max(value, min), max);
}

function resolveFocusPosition(doc, position = null) {
    if (!position) {
        return null;
    }
    const selectionAtStart = state.Selection.atStart(doc);
    const selectionAtEnd = state.Selection.atEnd(doc);
    if (position === 'start' || position === true) {
        return selectionAtStart;
    }
    if (position === 'end') {
        return selectionAtEnd;
    }
    const minPos = selectionAtStart.from;
    const maxPos = selectionAtEnd.to;
    if (position === 'all') {
        return state.TextSelection.create(doc, minMax(0, minPos, maxPos), minMax(doc.content.size, minPos, maxPos));
    }
    return state.TextSelection.create(doc, minMax(position, minPos, maxPos), minMax(position, minPos, maxPos));
}

function isAndroid() {
    return navigator.platform === 'Android' || /android/i.test(navigator.userAgent);
}

function isiOS() {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
    ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
}

const focus = (position = null, options = {}) => ({ editor, view, tr, dispatch, }) => {
    options = {
        scrollIntoView: true,
        ...options,
    };
    const delayedFocus = () => {
        // focus within `requestAnimationFrame` breaks focus on iOS and Android
        // so we have to call this
        if (isiOS() || isAndroid()) {
            view.dom.focus();
        }
        // For React we have to focus asynchronously. Otherwise wild things happen.
        // see: https://github.com/ueberdosis/tiptap/issues/1520
        requestAnimationFrame(() => {
            if (!editor.isDestroyed) {
                view.focus();
                if (options === null || options === void 0 ? void 0 : options.scrollIntoView) {
                    editor.commands.scrollIntoView();
                }
            }
        });
    };
    if ((view.hasFocus() && position === null) || position === false) {
        return true;
    }
    // we don’t try to resolve a NodeSelection or CellSelection
    if (dispatch && position === null && !isTextSelection(editor.state.selection)) {
        delayedFocus();
        return true;
    }
    // pass through tr.doc instead of editor.state.doc
    // since transactions could change the editors state before this command has been run
    const selection = resolveFocusPosition(tr.doc, position) || editor.state.selection;
    const isSameSelection = editor.state.selection.eq(selection);
    if (dispatch) {
        if (!isSameSelection) {
            tr.setSelection(selection);
        }
        // `tr.setSelection` resets the stored marks
        // so we’ll restore them if the selection is the same as before
        if (isSameSelection && tr.storedMarks) {
            tr.setStoredMarks(tr.storedMarks);
        }
        delayedFocus();
    }
    return true;
};

const forEach = (items, fn) => props => {
    return items.every((item, index) => fn(item, { ...props, index }));
};

const insertContent = (value, options) => ({ tr, commands }) => {
    return commands.insertContentAt({ from: tr.selection.from, to: tr.selection.to }, value, options);
};

const removeWhitespaces = (node) => {
    const children = node.childNodes;
    for (let i = children.length - 1; i >= 0; i -= 1) {
        const child = children[i];
        if (child.nodeType === 3 && child.nodeValue && /^(\n\s\s|\n)$/.test(child.nodeValue)) {
            node.removeChild(child);
        }
        else if (child.nodeType === 1) {
            removeWhitespaces(child);
        }
    }
    return node;
};
function elementFromString(value) {
    // add a wrapper to preserve leading and trailing whitespace
    const wrappedValue = `<body>${value}</body>`;
    const html = new window.DOMParser().parseFromString(wrappedValue, 'text/html').body;
    return removeWhitespaces(html);
}

/**
 * Takes a JSON or HTML content and creates a Prosemirror node or fragment from it.
 * @param content The JSON or HTML content to create the node from
 * @param schema The Prosemirror schema to use for the node
 * @param options Options for the parser
 * @returns The created Prosemirror node or fragment
 */
function createNodeFromContent(content, schema, options) {
    if (content instanceof model.Node || content instanceof model.Fragment) {
        return content;
    }
    options = {
        slice: true,
        parseOptions: {},
        ...options,
    };
    const isJSONContent = typeof content === 'object' && content !== null;
    const isTextContent = typeof content === 'string';
    if (isJSONContent) {
        try {
            const isArrayContent = Array.isArray(content) && content.length > 0;
            // if the JSON Content is an array of nodes, create a fragment for each node
            if (isArrayContent) {
                return model.Fragment.fromArray(content.map(item => schema.nodeFromJSON(item)));
            }
            const node = schema.nodeFromJSON(content);
            if (options.errorOnInvalidContent) {
                node.check();
            }
            return node;
        }
        catch (error) {
            if (options.errorOnInvalidContent) {
                throw new Error('[tiptap error]: Invalid JSON content', { cause: error });
            }
            console.warn('[tiptap warn]: Invalid content.', 'Passed value:', content, 'Error:', error);
            return createNodeFromContent('', schema, options);
        }
    }
    if (isTextContent) {
        // Check for invalid content
        if (options.errorOnInvalidContent) {
            let hasInvalidContent = false;
            let invalidContent = '';
            // A copy of the current schema with a catch-all node at the end
            const contentCheckSchema = new model.Schema({
                topNode: schema.spec.topNode,
                marks: schema.spec.marks,
                // Prosemirror's schemas are executed such that: the last to execute, matches last
                // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
                nodes: schema.spec.nodes.append({
                    __tiptap__private__unknown__catch__all__node: {
                        content: 'inline*',
                        group: 'block',
                        parseDOM: [
                            {
                                tag: '*',
                                getAttrs: e => {
                                    // If this is ever called, we know that the content has something that we don't know how to handle in the schema
                                    hasInvalidContent = true;
                                    // Try to stringify the element for a more helpful error message
                                    invalidContent = typeof e === 'string' ? e : e.outerHTML;
                                    return null;
                                },
                            },
                        ],
                    },
                }),
            });
            if (options.slice) {
                model.DOMParser.fromSchema(contentCheckSchema).parseSlice(elementFromString(content), options.parseOptions);
            }
            else {
                model.DOMParser.fromSchema(contentCheckSchema).parse(elementFromString(content), options.parseOptions);
            }
            if (options.errorOnInvalidContent && hasInvalidContent) {
                throw new Error('[tiptap error]: Invalid HTML content', { cause: new Error(`Invalid element found: ${invalidContent}`) });
            }
        }
        const parser = model.DOMParser.fromSchema(schema);
        if (options.slice) {
            return parser.parseSlice(elementFromString(content), options.parseOptions).content;
        }
        return parser.parse(elementFromString(content), options.parseOptions);
    }
    return createNodeFromContent('', schema, options);
}

// source: https://github.com/ProseMirror/prosemirror-state/blob/master/src/selection.js#L466
function selectionToInsertionEnd(tr, startLen, bias) {
    const last = tr.steps.length - 1;
    if (last < startLen) {
        return;
    }
    const step = tr.steps[last];
    if (!(step instanceof transform.ReplaceStep || step instanceof transform.ReplaceAroundStep)) {
        return;
    }
    const map = tr.mapping.maps[last];
    let end = 0;
    map.forEach((_from, _to, _newFrom, newTo) => {
        if (end === 0) {
            end = newTo;
        }
    });
    tr.setSelection(state.Selection.near(tr.doc.resolve(end), bias));
}

const isFragment = (nodeOrFragment) => {
    return !('type' in nodeOrFragment);
};
const insertContentAt = (position, value, options) => ({ tr, dispatch, editor }) => {
    var _a;
    if (dispatch) {
        options = {
            parseOptions: editor.options.parseOptions,
            updateSelection: true,
            applyInputRules: false,
            applyPasteRules: false,
            ...options,
        };
        let content;
        const emitContentError = (error) => {
            editor.emit('contentError', {
                editor,
                error,
                disableCollaboration: () => {
                    if (editor.storage.collaboration) {
                        editor.storage.collaboration.isDisabled = true;
                    }
                },
            });
        };
        const parseOptions = {
            preserveWhitespace: 'full',
            ...options.parseOptions,
        };
        // If `emitContentError` is enabled, we want to check the content for errors
        // but ignore them (do not remove the invalid content from the document)
        if (!options.errorOnInvalidContent && !editor.options.enableContentCheck && editor.options.emitContentError) {
            try {
                createNodeFromContent(value, editor.schema, {
                    parseOptions,
                    errorOnInvalidContent: true,
                });
            }
            catch (e) {
                emitContentError(e);
            }
        }
        try {
            content = createNodeFromContent(value, editor.schema, {
                parseOptions,
                errorOnInvalidContent: (_a = options.errorOnInvalidContent) !== null && _a !== void 0 ? _a : editor.options.enableContentCheck,
            });
        }
        catch (e) {
            emitContentError(e);
            return false;
        }
        let { from, to } = typeof position === 'number' ? { from: position, to: position } : { from: position.from, to: position.to };
        let isOnlyTextContent = true;
        let isOnlyBlockContent = true;
        const nodes = isFragment(content) ? content : [content];
        nodes.forEach(node => {
            // check if added node is valid
            node.check();
            isOnlyTextContent = isOnlyTextContent ? node.isText && node.marks.length === 0 : false;
            isOnlyBlockContent = isOnlyBlockContent ? node.isBlock : false;
        });
        // check if we can replace the wrapping node by
        // the newly inserted content
        // example:
        // replace an empty paragraph by an inserted image
        // instead of inserting the image below the paragraph
        if (from === to && isOnlyBlockContent) {
            const { parent } = tr.doc.resolve(from);
            const isEmptyTextBlock = parent.isTextblock && !parent.type.spec.code && !parent.childCount;
            if (isEmptyTextBlock) {
                from -= 1;
                to += 1;
            }
        }
        let newContent;
        // if there is only plain text we have to use `insertText`
        // because this will keep the current marks
        if (isOnlyTextContent) {
            // if value is string, we can use it directly
            // otherwise if it is an array, we have to join it
            if (Array.isArray(value)) {
                newContent = value.map(v => v.text || '').join('');
            }
            else if (value instanceof model.Fragment) {
                let text = '';
                value.forEach(node => {
                    if (node.text) {
                        text += node.text;
                    }
                });
                newContent = text;
            }
            else if (typeof value === 'object' && !!value && !!value.text) {
                newContent = value.text;
            }
            else {
                newContent = value;
            }
            tr.insertText(newContent, from, to);
        }
        else {
            newContent = content;
            tr.replaceWith(from, to, newContent);
        }
        // set cursor at end of inserted content
        if (options.updateSelection) {
            selectionToInsertionEnd(tr, tr.steps.length - 1, -1);
        }
        if (options.applyInputRules) {
            tr.setMeta('applyInputRules', { from, text: newContent });
        }
        if (options.applyPasteRules) {
            tr.setMeta('applyPasteRules', { from, text: newContent });
        }
    }
    return true;
};

const joinUp = () => ({ state, dispatch }) => {
    return commands$1.joinUp(state, dispatch);
};
const joinDown = () => ({ state, dispatch }) => {
    return commands$1.joinDown(state, dispatch);
};
const joinBackward = () => ({ state, dispatch }) => {
    return commands$1.joinBackward(state, dispatch);
};
const joinForward = () => ({ state, dispatch }) => {
    return commands$1.joinForward(state, dispatch);
};

const joinItemBackward = () => ({ state, dispatch, tr, }) => {
    try {
        const point = transform.joinPoint(state.doc, state.selection.$from.pos, -1);
        if (point === null || point === undefined) {
            return false;
        }
        tr.join(point, 2);
        if (dispatch) {
            dispatch(tr);
        }
        return true;
    }
    catch {
        return false;
    }
};

const joinItemForward = () => ({ state, dispatch, tr, }) => {
    try {
        const point = transform.joinPoint(state.doc, state.selection.$from.pos, +1);
        if (point === null || point === undefined) {
            return false;
        }
        tr.join(point, 2);
        if (dispatch) {
            dispatch(tr);
        }
        return true;
    }
    catch {
        return false;
    }
};

const joinTextblockBackward = () => ({ state, dispatch }) => {
    return commands$1.joinTextblockBackward(state, dispatch);
};

const joinTextblockForward = () => ({ state, dispatch }) => {
    return commands$1.joinTextblockForward(state, dispatch);
};

function isMacOS() {
    return typeof navigator !== 'undefined'
        ? /Mac/.test(navigator.platform)
        : false;
}

function normalizeKeyName(name) {
    const parts = name.split(/-(?!$)/);
    let result = parts[parts.length - 1];
    if (result === 'Space') {
        result = ' ';
    }
    let alt;
    let ctrl;
    let shift;
    let meta;
    for (let i = 0; i < parts.length - 1; i += 1) {
        const mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) {
            meta = true;
        }
        else if (/^a(lt)?$/i.test(mod)) {
            alt = true;
        }
        else if (/^(c|ctrl|control)$/i.test(mod)) {
            ctrl = true;
        }
        else if (/^s(hift)?$/i.test(mod)) {
            shift = true;
        }
        else if (/^mod$/i.test(mod)) {
            if (isiOS() || isMacOS()) {
                meta = true;
            }
            else {
                ctrl = true;
            }
        }
        else {
            throw new Error(`Unrecognized modifier name: ${mod}`);
        }
    }
    if (alt) {
        result = `Alt-${result}`;
    }
    if (ctrl) {
        result = `Ctrl-${result}`;
    }
    if (meta) {
        result = `Meta-${result}`;
    }
    if (shift) {
        result = `Shift-${result}`;
    }
    return result;
}
const keyboardShortcut = name => ({ editor, view, tr, dispatch, }) => {
    const keys = normalizeKeyName(name).split(/-(?!$)/);
    const key = keys.find(item => !['Alt', 'Ctrl', 'Meta', 'Shift'].includes(item));
    const event = new KeyboardEvent('keydown', {
        key: key === 'Space'
            ? ' '
            : key,
        altKey: keys.includes('Alt'),
        ctrlKey: keys.includes('Ctrl'),
        metaKey: keys.includes('Meta'),
        shiftKey: keys.includes('Shift'),
        bubbles: true,
        cancelable: true,
    });
    const capturedTransaction = editor.captureTransaction(() => {
        view.someProp('handleKeyDown', f => f(view, event));
    });
    capturedTransaction === null || capturedTransaction === void 0 ? void 0 : capturedTransaction.steps.forEach(step => {
        const newStep = step.map(tr.mapping);
        if (newStep && dispatch) {
            tr.maybeStep(newStep);
        }
    });
    return true;
};

function isNodeActive(state, typeOrName, attributes = {}) {
    const { from, to, empty } = state.selection;
    const type = typeOrName ? getNodeType(typeOrName, state.schema) : null;
    const nodeRanges = [];
    state.doc.nodesBetween(from, to, (node, pos) => {
        if (node.isText) {
            return;
        }
        const relativeFrom = Math.max(from, pos);
        const relativeTo = Math.min(to, pos + node.nodeSize);
        nodeRanges.push({
            node,
            from: relativeFrom,
            to: relativeTo,
        });
    });
    const selectionRange = to - from;
    const matchedNodeRanges = nodeRanges
        .filter(nodeRange => {
        if (!type) {
            return true;
        }
        return type.name === nodeRange.node.type.name;
    })
        .filter(nodeRange => objectIncludes(nodeRange.node.attrs, attributes, { strict: false }));
    if (empty) {
        return !!matchedNodeRanges.length;
    }
    const range = matchedNodeRanges.reduce((sum, nodeRange) => sum + nodeRange.to - nodeRange.from, 0);
    return range >= selectionRange;
}

const lift = (typeOrName, attributes = {}) => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    const isActive = isNodeActive(state, type, attributes);
    if (!isActive) {
        return false;
    }
    return commands$1.lift(state, dispatch);
};

const liftEmptyBlock = () => ({ state, dispatch }) => {
    return commands$1.liftEmptyBlock(state, dispatch);
};

const liftListItem = typeOrName => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    return schemaList.liftListItem(type)(state, dispatch);
};

const newlineInCode = () => ({ state, dispatch }) => {
    return commands$1.newlineInCode(state, dispatch);
};

/**
 * Get the type of a schema item by its name.
 * @param name The name of the schema item
 * @param schema The Prosemiror schema to search in
 * @returns The type of the schema item (`node` or `mark`), or null if it doesn't exist
 */
function getSchemaTypeNameByName(name, schema) {
    if (schema.nodes[name]) {
        return 'node';
    }
    if (schema.marks[name]) {
        return 'mark';
    }
    return null;
}

/**
 * Remove a property or an array of properties from an object
 * @param obj Object
 * @param key Key to remove
 */
function deleteProps(obj, propOrProps) {
    const props = typeof propOrProps === 'string'
        ? [propOrProps]
        : propOrProps;
    return Object
        .keys(obj)
        .reduce((newObj, prop) => {
        if (!props.includes(prop)) {
            newObj[prop] = obj[prop];
        }
        return newObj;
    }, {});
}

const resetAttributes = (typeOrName, attributes) => ({ tr, state, dispatch }) => {
    let nodeType = null;
    let markType = null;
    const schemaType = getSchemaTypeNameByName(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);
    if (!schemaType) {
        return false;
    }
    if (schemaType === 'node') {
        nodeType = getNodeType(typeOrName, state.schema);
    }
    if (schemaType === 'mark') {
        markType = getMarkType(typeOrName, state.schema);
    }
    if (dispatch) {
        tr.selection.ranges.forEach(range => {
            state.doc.nodesBetween(range.$from.pos, range.$to.pos, (node, pos) => {
                if (nodeType && nodeType === node.type) {
                    tr.setNodeMarkup(pos, undefined, deleteProps(node.attrs, attributes));
                }
                if (markType && node.marks.length) {
                    node.marks.forEach(mark => {
                        if (markType === mark.type) {
                            tr.addMark(pos, pos + node.nodeSize, markType.create(deleteProps(mark.attrs, attributes)));
                        }
                    });
                }
            });
        });
    }
    return true;
};

const scrollIntoView = () => ({ tr, dispatch }) => {
    if (dispatch) {
        tr.scrollIntoView();
    }
    return true;
};

const selectAll = () => ({ tr, dispatch }) => {
    if (dispatch) {
        const selection = new state.AllSelection(tr.doc);
        tr.setSelection(selection);
    }
    return true;
};

const selectNodeBackward = () => ({ state, dispatch }) => {
    return commands$1.selectNodeBackward(state, dispatch);
};

const selectNodeForward = () => ({ state, dispatch }) => {
    return commands$1.selectNodeForward(state, dispatch);
};

const selectParentNode = () => ({ state, dispatch }) => {
    return commands$1.selectParentNode(state, dispatch);
};

// @ts-ignore
// TODO: add types to @types/prosemirror-commands
const selectTextblockEnd = () => ({ state, dispatch }) => {
    return commands$1.selectTextblockEnd(state, dispatch);
};

// @ts-ignore
// TODO: add types to @types/prosemirror-commands
const selectTextblockStart = () => ({ state, dispatch }) => {
    return commands$1.selectTextblockStart(state, dispatch);
};

/**
 * Create a new Prosemirror document node from content.
 * @param content The JSON or HTML content to create the document from
 * @param schema The Prosemirror schema to use for the document
 * @param parseOptions Options for the parser
 * @returns The created Prosemirror document node
 */
function createDocument(content, schema, parseOptions = {}, options = {}) {
    return createNodeFromContent(content, schema, {
        slice: false,
        parseOptions,
        errorOnInvalidContent: options.errorOnInvalidContent,
    });
}

const setContent = (content, emitUpdate = false, parseOptions = {}, options = {}) => ({ editor, tr, dispatch, commands, }) => {
    var _a, _b;
    const { doc } = tr;
    // This is to keep backward compatibility with the previous behavior
    // TODO remove this in the next major version
    if (parseOptions.preserveWhitespace !== 'full') {
        const document = createDocument(content, editor.schema, parseOptions, {
            errorOnInvalidContent: (_a = options.errorOnInvalidContent) !== null && _a !== void 0 ? _a : editor.options.enableContentCheck,
        });
        if (dispatch) {
            tr.replaceWith(0, doc.content.size, document).setMeta('preventUpdate', !emitUpdate);
        }
        return true;
    }
    if (dispatch) {
        tr.setMeta('preventUpdate', !emitUpdate);
    }
    return commands.insertContentAt({ from: 0, to: doc.content.size }, content, {
        parseOptions,
        errorOnInvalidContent: (_b = options.errorOnInvalidContent) !== null && _b !== void 0 ? _b : editor.options.enableContentCheck,
    });
};

function getMarkAttributes(state, typeOrName) {
    const type = getMarkType(typeOrName, state.schema);
    const { from, to, empty } = state.selection;
    const marks = [];
    if (empty) {
        if (state.storedMarks) {
            marks.push(...state.storedMarks);
        }
        marks.push(...state.selection.$head.marks());
    }
    else {
        state.doc.nodesBetween(from, to, node => {
            marks.push(...node.marks);
        });
    }
    const mark = marks.find(markItem => markItem.type.name === type.name);
    if (!mark) {
        return {};
    }
    return { ...mark.attrs };
}

/**
 * Returns a new `Transform` based on all steps of the passed transactions.
 * @param oldDoc The Prosemirror node to start from
 * @param transactions The transactions to combine
 * @returns A new `Transform` with all steps of the passed transactions
 */
function combineTransactionSteps(oldDoc, transactions) {
    const transform$1 = new transform.Transform(oldDoc);
    transactions.forEach(transaction => {
        transaction.steps.forEach(step => {
            transform$1.step(step);
        });
    });
    return transform$1;
}

/**
 * Gets the default block type at a given match
 * @param match The content match to get the default block type from
 * @returns The default block type or null
 */
function defaultBlockAt(match) {
    for (let i = 0; i < match.edgeCount; i += 1) {
        const { type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) {
            return type;
        }
    }
    return null;
}

/**
 * Find children inside a Prosemirror node that match a predicate.
 * @param node The Prosemirror node to search in
 * @param predicate The predicate to match
 * @returns An array of nodes with their positions
 */
function findChildren(node, predicate) {
    const nodesWithPos = [];
    node.descendants((child, pos) => {
        if (predicate(child)) {
            nodesWithPos.push({
                node: child,
                pos,
            });
        }
    });
    return nodesWithPos;
}

/**
 * Same as `findChildren` but searches only within a `range`.
 * @param node The Prosemirror node to search in
 * @param range The range to search in
 * @param predicate The predicate to match
 * @returns An array of nodes with their positions
 */
function findChildrenInRange(node, range, predicate) {
    const nodesWithPos = [];
    // if (range.from === range.to) {
    //   const nodeAt = node.nodeAt(range.from)
    //   if (nodeAt) {
    //     nodesWithPos.push({
    //       node: nodeAt,
    //       pos: range.from,
    //     })
    //   }
    // }
    node.nodesBetween(range.from, range.to, (child, pos) => {
        if (predicate(child)) {
            nodesWithPos.push({
                node: child,
                pos,
            });
        }
    });
    return nodesWithPos;
}

/**
 * Finds the closest parent node to a resolved position that matches a predicate.
 * @param $pos The resolved position to search from
 * @param predicate The predicate to match
 * @returns The closest parent node to the resolved position that matches the predicate
 * @example ```js
 * findParentNodeClosestToPos($from, node => node.type.name === 'paragraph')
 * ```
 */
function findParentNodeClosestToPos($pos, predicate) {
    for (let i = $pos.depth; i > 0; i -= 1) {
        const node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node,
            };
        }
    }
}

/**
 * Finds the closest parent node to the current selection that matches a predicate.
 * @param predicate The predicate to match
 * @returns A command that finds the closest parent node to the current selection that matches the predicate
 * @example ```js
 * findParentNode(node => node.type.name === 'paragraph')
 * ```
 */
function findParentNode(predicate) {
    return (selection) => findParentNodeClosestToPos(selection.$from, predicate);
}

function getSchema(extensions, editor) {
    const resolvedExtensions = ExtensionManager.resolve(extensions);
    return getSchemaByResolvedExtensions(resolvedExtensions, editor);
}

/**
 * Generate HTML from a JSONContent
 * @param doc The JSONContent to generate HTML from
 * @param extensions The extensions to use for the schema
 * @returns The generated HTML
 */
function generateHTML(doc, extensions) {
    const schema = getSchema(extensions);
    const contentNode = model.Node.fromJSON(schema, doc);
    return getHTMLFromFragment(contentNode.content, schema);
}

/**
 * Generate JSONContent from HTML
 * @param html The HTML to generate JSONContent from
 * @param extensions The extensions to use for the schema
 * @returns The generated JSONContent
 */
function generateJSON(html, extensions) {
    const schema = getSchema(extensions);
    const dom = elementFromString(html);
    return model.DOMParser.fromSchema(schema).parse(dom).toJSON();
}

/**
 * Gets the text of a Prosemirror node
 * @param node The Prosemirror node
 * @param options Options for the text serializer & block separator
 * @returns The text of the node
 * @example ```js
 * const text = getText(node, { blockSeparator: '\n' })
 * ```
 */
function getText(node, options) {
    const range = {
        from: 0,
        to: node.content.size,
    };
    return getTextBetween(node, range, options);
}

/**
 * Generate raw text from a JSONContent
 * @param doc The JSONContent to generate text from
 * @param extensions The extensions to use for the schema
 * @param options Options for the text generation f.e. blockSeparator or textSerializers
 * @returns The generated text
 */
function generateText(doc, extensions, options) {
    const { blockSeparator = '\n\n', textSerializers = {} } = options || {};
    const schema = getSchema(extensions);
    const contentNode = model.Node.fromJSON(schema, doc);
    return getText(contentNode, {
        blockSeparator,
        textSerializers: {
            ...getTextSerializersFromSchema(schema),
            ...textSerializers,
        },
    });
}

function getNodeAttributes(state, typeOrName) {
    const type = getNodeType(typeOrName, state.schema);
    const { from, to } = state.selection;
    const nodes = [];
    state.doc.nodesBetween(from, to, node => {
        nodes.push(node);
    });
    const node = nodes.reverse().find(nodeItem => nodeItem.type.name === type.name);
    if (!node) {
        return {};
    }
    return { ...node.attrs };
}

/**
 * Get node or mark attributes by type or name on the current editor state
 * @param state The current editor state
 * @param typeOrName The node or mark type or name
 * @returns The attributes of the node or mark or an empty object
 */
function getAttributes(state, typeOrName) {
    const schemaType = getSchemaTypeNameByName(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);
    if (schemaType === 'node') {
        return getNodeAttributes(state, typeOrName);
    }
    if (schemaType === 'mark') {
        return getMarkAttributes(state, typeOrName);
    }
    return {};
}

/**
 * Removes duplicated values within an array.
 * Supports numbers, strings and objects.
 */
function removeDuplicates(array, by = JSON.stringify) {
    const seen = {};
    return array.filter(item => {
        const key = by(item);
        return Object.prototype.hasOwnProperty.call(seen, key)
            ? false
            : (seen[key] = true);
    });
}

/**
 * Removes duplicated ranges and ranges that are
 * fully captured by other ranges.
 */
function simplifyChangedRanges(changes) {
    const uniqueChanges = removeDuplicates(changes);
    return uniqueChanges.length === 1
        ? uniqueChanges
        : uniqueChanges.filter((change, index) => {
            const rest = uniqueChanges.filter((_, i) => i !== index);
            return !rest.some(otherChange => {
                return change.oldRange.from >= otherChange.oldRange.from
                    && change.oldRange.to <= otherChange.oldRange.to
                    && change.newRange.from >= otherChange.newRange.from
                    && change.newRange.to <= otherChange.newRange.to;
            });
        });
}
/**
 * Returns a list of changed ranges
 * based on the first and last state of all steps.
 */
function getChangedRanges(transform) {
    const { mapping, steps } = transform;
    const changes = [];
    mapping.maps.forEach((stepMap, index) => {
        const ranges = [];
        // This accounts for step changes where no range was actually altered
        // e.g. when setting a mark, node attribute, etc.
        // @ts-ignore
        if (!stepMap.ranges.length) {
            const { from, to } = steps[index];
            if (from === undefined || to === undefined) {
                return;
            }
            ranges.push({ from, to });
        }
        else {
            stepMap.forEach((from, to) => {
                ranges.push({ from, to });
            });
        }
        ranges.forEach(({ from, to }) => {
            const newStart = mapping.slice(index).map(from, -1);
            const newEnd = mapping.slice(index).map(to);
            const oldStart = mapping.invert().map(newStart, -1);
            const oldEnd = mapping.invert().map(newEnd);
            changes.push({
                oldRange: {
                    from: oldStart,
                    to: oldEnd,
                },
                newRange: {
                    from: newStart,
                    to: newEnd,
                },
            });
        });
    });
    return simplifyChangedRanges(changes);
}

function getDebugJSON(node, startOffset = 0) {
    const isTopNode = node.type === node.type.schema.topNodeType;
    const increment = isTopNode ? 0 : 1;
    const from = startOffset;
    const to = from + node.nodeSize;
    const marks = node.marks.map(mark => {
        const output = {
            type: mark.type.name,
        };
        if (Object.keys(mark.attrs).length) {
            output.attrs = { ...mark.attrs };
        }
        return output;
    });
    const attrs = { ...node.attrs };
    const output = {
        type: node.type.name,
        from,
        to,
    };
    if (Object.keys(attrs).length) {
        output.attrs = attrs;
    }
    if (marks.length) {
        output.marks = marks;
    }
    if (node.content.childCount) {
        output.content = [];
        node.forEach((child, offset) => {
            var _a;
            (_a = output.content) === null || _a === void 0 ? void 0 : _a.push(getDebugJSON(child, startOffset + offset + increment));
        });
    }
    if (node.text) {
        output.text = node.text;
    }
    return output;
}

function getMarksBetween(from, to, doc) {
    const marks = [];
    // get all inclusive marks on empty selection
    if (from === to) {
        doc
            .resolve(from)
            .marks()
            .forEach(mark => {
            const $pos = doc.resolve(from);
            const range = getMarkRange($pos, mark.type);
            if (!range) {
                return;
            }
            marks.push({
                mark,
                ...range,
            });
        });
    }
    else {
        doc.nodesBetween(from, to, (node, pos) => {
            if (!node || (node === null || node === void 0 ? void 0 : node.nodeSize) === undefined) {
                return;
            }
            marks.push(...node.marks.map(mark => ({
                from: pos,
                to: pos + node.nodeSize,
                mark,
            })));
        });
    }
    return marks;
}

/**
 * Finds the first node of a given type or name in the current selection.
 * @param state The editor state.
 * @param typeOrName The node type or name.
 * @param pos The position to start searching from.
 * @param maxDepth The maximum depth to search.
 * @returns The node and the depth as an array.
 */
const getNodeAtPosition = (state, typeOrName, pos, maxDepth = 20) => {
    const $pos = state.doc.resolve(pos);
    let currentDepth = maxDepth;
    let node = null;
    while (currentDepth > 0 && node === null) {
        const currentNode = $pos.node(currentDepth);
        if ((currentNode === null || currentNode === void 0 ? void 0 : currentNode.type.name) === typeOrName) {
            node = currentNode;
        }
        else {
            currentDepth -= 1;
        }
    }
    return [node, currentDepth];
};

/**
 * Return attributes of an extension that should be splitted by keepOnSplit flag
 * @param extensionAttributes Array of extension attributes
 * @param typeName The type of the extension
 * @param attributes The attributes of the extension
 * @returns The splitted attributes
 */
function getSplittedAttributes(extensionAttributes, typeName, attributes) {
    return Object.fromEntries(Object
        .entries(attributes)
        .filter(([name]) => {
        const extensionAttribute = extensionAttributes.find(item => {
            return item.type === typeName && item.name === name;
        });
        if (!extensionAttribute) {
            return false;
        }
        return extensionAttribute.attribute.keepOnSplit;
    }));
}

function isMarkActive(state, typeOrName, attributes = {}) {
    const { empty, ranges } = state.selection;
    const type = typeOrName ? getMarkType(typeOrName, state.schema) : null;
    if (empty) {
        return !!(state.storedMarks || state.selection.$from.marks())
            .filter(mark => {
            if (!type) {
                return true;
            }
            return type.name === mark.type.name;
        })
            .find(mark => objectIncludes(mark.attrs, attributes, { strict: false }));
    }
    let selectionRange = 0;
    const markRanges = [];
    ranges.forEach(({ $from, $to }) => {
        const from = $from.pos;
        const to = $to.pos;
        state.doc.nodesBetween(from, to, (node, pos) => {
            if (!node.isText && !node.marks.length) {
                return;
            }
            const relativeFrom = Math.max(from, pos);
            const relativeTo = Math.min(to, pos + node.nodeSize);
            const range = relativeTo - relativeFrom;
            selectionRange += range;
            markRanges.push(...node.marks.map(mark => ({
                mark,
                from: relativeFrom,
                to: relativeTo,
            })));
        });
    });
    if (selectionRange === 0) {
        return false;
    }
    // calculate range of matched mark
    const matchedRange = markRanges
        .filter(markRange => {
        if (!type) {
            return true;
        }
        return type.name === markRange.mark.type.name;
    })
        .filter(markRange => objectIncludes(markRange.mark.attrs, attributes, { strict: false }))
        .reduce((sum, markRange) => sum + markRange.to - markRange.from, 0);
    // calculate range of marks that excludes the searched mark
    // for example `code` doesn’t allow any other marks
    const excludedRange = markRanges
        .filter(markRange => {
        if (!type) {
            return true;
        }
        return markRange.mark.type !== type && markRange.mark.type.excludes(type);
    })
        .reduce((sum, markRange) => sum + markRange.to - markRange.from, 0);
    // we only include the result of `excludedRange`
    // if there is a match at all
    const range = matchedRange > 0 ? matchedRange + excludedRange : matchedRange;
    return range >= selectionRange;
}

function isActive(state, name, attributes = {}) {
    if (!name) {
        return isNodeActive(state, null, attributes) || isMarkActive(state, null, attributes);
    }
    const schemaType = getSchemaTypeNameByName(name, state.schema);
    if (schemaType === 'node') {
        return isNodeActive(state, name, attributes);
    }
    if (schemaType === 'mark') {
        return isMarkActive(state, name, attributes);
    }
    return false;
}

const isAtEndOfNode = (state, nodeType) => {
    const { $from, $to, $anchor } = state.selection;
    if (nodeType) {
        const parentNode = findParentNode(node => node.type.name === nodeType)(state.selection);
        if (!parentNode) {
            return false;
        }
        const $parentPos = state.doc.resolve(parentNode.pos + 1);
        if ($anchor.pos + 1 === $parentPos.end()) {
            return true;
        }
        return false;
    }
    if ($to.parentOffset < $to.parent.nodeSize - 2 || $from.pos !== $to.pos) {
        return false;
    }
    return true;
};

const isAtStartOfNode = (state) => {
    const { $from, $to } = state.selection;
    if ($from.parentOffset > 0 || $from.pos !== $to.pos) {
        return false;
    }
    return true;
};

function isList(name, extensions) {
    const { nodeExtensions } = splitExtensions(extensions);
    const extension = nodeExtensions.find(item => item.name === name);
    if (!extension) {
        return false;
    }
    const context = {
        name: extension.name,
        options: extension.options,
        storage: extension.storage,
    };
    const group = callOrReturn(getExtensionField(extension, 'group', context));
    if (typeof group !== 'string') {
        return false;
    }
    return group.split(' ').includes('list');
}

/**
 * Returns true if the given prosemirror node is empty.
 */
function isNodeEmpty(node, { checkChildren = true, ignoreWhitespace = false, } = {}) {
    var _a;
    if (ignoreWhitespace) {
        if (node.type.name === 'hardBreak') {
            // Hard breaks are considered empty
            return true;
        }
        if (node.isText) {
            return /^\s*$/m.test((_a = node.text) !== null && _a !== void 0 ? _a : '');
        }
    }
    if (node.isText) {
        return !node.text;
    }
    if (node.isAtom || node.isLeaf) {
        return false;
    }
    if (node.content.childCount === 0) {
        return true;
    }
    if (checkChildren) {
        let isContentEmpty = true;
        node.content.forEach(childNode => {
            if (isContentEmpty === false) {
                // Exit early for perf
                return;
            }
            if (!isNodeEmpty(childNode, { ignoreWhitespace, checkChildren })) {
                isContentEmpty = false;
            }
        });
        return isContentEmpty;
    }
    return false;
}

function isNodeSelection(value) {
    return value instanceof state.NodeSelection;
}

function posToDOMRect(view, from, to) {
    const minPos = 0;
    const maxPos = view.state.doc.content.size;
    const resolvedFrom = minMax(from, minPos, maxPos);
    const resolvedEnd = minMax(to, minPos, maxPos);
    const start = view.coordsAtPos(resolvedFrom);
    const end = view.coordsAtPos(resolvedEnd, -1);
    const top = Math.min(start.top, end.top);
    const bottom = Math.max(start.bottom, end.bottom);
    const left = Math.min(start.left, end.left);
    const right = Math.max(start.right, end.right);
    const width = right - left;
    const height = bottom - top;
    const x = left;
    const y = top;
    const data = {
        top,
        bottom,
        left,
        right,
        width,
        height,
        x,
        y,
    };
    return {
        ...data,
        toJSON: () => data,
    };
}

/**
 * The actual implementation of the rewriteUnknownContent function
 */
function rewriteUnknownContentInner({ json, validMarks, validNodes, options, rewrittenContent = [], }) {
    if (json.marks && Array.isArray(json.marks)) {
        json.marks = json.marks.filter(mark => {
            const name = typeof mark === 'string' ? mark : mark.type;
            if (validMarks.has(name)) {
                return true;
            }
            rewrittenContent.push({
                original: JSON.parse(JSON.stringify(mark)),
                unsupported: name,
            });
            // Just ignore any unknown marks
            return false;
        });
    }
    if (json.content && Array.isArray(json.content)) {
        json.content = json.content
            .map(value => rewriteUnknownContentInner({
            json: value,
            validMarks,
            validNodes,
            options,
            rewrittenContent,
        }).json)
            .filter(a => a !== null && a !== undefined);
    }
    if (json.type && !validNodes.has(json.type)) {
        rewrittenContent.push({
            original: JSON.parse(JSON.stringify(json)),
            unsupported: json.type,
        });
        if (json.content && Array.isArray(json.content) && ((options === null || options === void 0 ? void 0 : options.fallbackToParagraph) !== false)) {
            // Just treat it like a paragraph and hope for the best
            json.type = 'paragraph';
            return {
                json,
                rewrittenContent,
            };
        }
        // or just omit it entirely
        return {
            json: null,
            rewrittenContent,
        };
    }
    return { json, rewrittenContent };
}
/**
 * Rewrite unknown nodes and marks within JSON content
 * Allowing for user within the editor
 */
function rewriteUnknownContent(
/**
 * The JSON content to clean of unknown nodes and marks
 */
json, 
/**
 * The schema to use for validation
 */
schema, 
/**
 * Options for the cleaning process
 */
options) {
    return rewriteUnknownContentInner({
        json,
        validNodes: new Set(Object.keys(schema.nodes)),
        validMarks: new Set(Object.keys(schema.marks)),
        options,
    });
}

function canSetMark(state, tr, newMarkType) {
    var _a;
    const { selection } = tr;
    let cursor = null;
    if (isTextSelection(selection)) {
        cursor = selection.$cursor;
    }
    if (cursor) {
        const currentMarks = (_a = state.storedMarks) !== null && _a !== void 0 ? _a : cursor.marks();
        // There can be no current marks that exclude the new mark
        return (!!newMarkType.isInSet(currentMarks)
            || !currentMarks.some(mark => mark.type.excludes(newMarkType)));
    }
    const { ranges } = selection;
    return ranges.some(({ $from, $to }) => {
        let someNodeSupportsMark = $from.depth === 0
            ? state.doc.inlineContent && state.doc.type.allowsMarkType(newMarkType)
            : false;
        state.doc.nodesBetween($from.pos, $to.pos, (node, _pos, parent) => {
            // If we already found a mark that we can enable, return false to bypass the remaining search
            if (someNodeSupportsMark) {
                return false;
            }
            if (node.isInline) {
                const parentAllowsMarkType = !parent || parent.type.allowsMarkType(newMarkType);
                const currentMarksAllowMarkType = !!newMarkType.isInSet(node.marks)
                    || !node.marks.some(otherMark => otherMark.type.excludes(newMarkType));
                someNodeSupportsMark = parentAllowsMarkType && currentMarksAllowMarkType;
            }
            return !someNodeSupportsMark;
        });
        return someNodeSupportsMark;
    });
}
const setMark = (typeOrName, attributes = {}) => ({ tr, state, dispatch }) => {
    const { selection } = tr;
    const { empty, ranges } = selection;
    const type = getMarkType(typeOrName, state.schema);
    if (dispatch) {
        if (empty) {
            const oldAttributes = getMarkAttributes(state, type);
            tr.addStoredMark(type.create({
                ...oldAttributes,
                ...attributes,
            }));
        }
        else {
            ranges.forEach(range => {
                const from = range.$from.pos;
                const to = range.$to.pos;
                state.doc.nodesBetween(from, to, (node, pos) => {
                    const trimmedFrom = Math.max(pos, from);
                    const trimmedTo = Math.min(pos + node.nodeSize, to);
                    const someHasMark = node.marks.find(mark => mark.type === type);
                    // if there is already a mark of this type
                    // we know that we have to merge its attributes
                    // otherwise we add a fresh new mark
                    if (someHasMark) {
                        node.marks.forEach(mark => {
                            if (type === mark.type) {
                                tr.addMark(trimmedFrom, trimmedTo, type.create({
                                    ...mark.attrs,
                                    ...attributes,
                                }));
                            }
                        });
                    }
                    else {
                        tr.addMark(trimmedFrom, trimmedTo, type.create(attributes));
                    }
                });
            });
        }
    }
    return canSetMark(state, tr, type);
};

const setMeta = (key, value) => ({ tr }) => {
    tr.setMeta(key, value);
    return true;
};

const setNode = (typeOrName, attributes = {}) => ({ state, dispatch, chain }) => {
    const type = getNodeType(typeOrName, state.schema);
    let attributesToCopy;
    if (state.selection.$anchor.sameParent(state.selection.$head)) {
        // only copy attributes if the selection is pointing to a node of the same type
        attributesToCopy = state.selection.$anchor.parent.attrs;
    }
    // TODO: use a fallback like insertContent?
    if (!type.isTextblock) {
        console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.');
        return false;
    }
    return (chain()
        // try to convert node to default node if needed
        .command(({ commands }) => {
        const canSetBlock = commands$1.setBlockType(type, { ...attributesToCopy, ...attributes })(state);
        if (canSetBlock) {
            return true;
        }
        return commands.clearNodes();
    })
        .command(({ state: updatedState }) => {
        return commands$1.setBlockType(type, { ...attributesToCopy, ...attributes })(updatedState, dispatch);
    })
        .run());
};

const setNodeSelection = position => ({ tr, dispatch }) => {
    if (dispatch) {
        const { doc } = tr;
        const from = minMax(position, 0, doc.content.size);
        const selection = state.NodeSelection.create(doc, from);
        tr.setSelection(selection);
    }
    return true;
};

const setTextSelection = position => ({ tr, dispatch }) => {
    if (dispatch) {
        const { doc } = tr;
        const { from, to } = typeof position === 'number' ? { from: position, to: position } : position;
        const minPos = state.TextSelection.atStart(doc).from;
        const maxPos = state.TextSelection.atEnd(doc).to;
        const resolvedFrom = minMax(from, minPos, maxPos);
        const resolvedEnd = minMax(to, minPos, maxPos);
        const selection = state.TextSelection.create(doc, resolvedFrom, resolvedEnd);
        tr.setSelection(selection);
    }
    return true;
};

const sinkListItem = typeOrName => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    return schemaList.sinkListItem(type)(state, dispatch);
};

function ensureMarks(state, splittableMarks) {
    const marks = state.storedMarks || (state.selection.$to.parentOffset && state.selection.$from.marks());
    if (marks) {
        const filteredMarks = marks.filter(mark => splittableMarks === null || splittableMarks === void 0 ? void 0 : splittableMarks.includes(mark.type.name));
        state.tr.ensureMarks(filteredMarks);
    }
}
const splitBlock = ({ keepMarks = true } = {}) => ({ tr, state: state$1, dispatch, editor, }) => {
    const { selection, doc } = tr;
    const { $from, $to } = selection;
    const extensionAttributes = editor.extensionManager.attributes;
    const newAttributes = getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs);
    if (selection instanceof state.NodeSelection && selection.node.isBlock) {
        if (!$from.parentOffset || !transform.canSplit(doc, $from.pos)) {
            return false;
        }
        if (dispatch) {
            if (keepMarks) {
                ensureMarks(state$1, editor.extensionManager.splittableMarks);
            }
            tr.split($from.pos).scrollIntoView();
        }
        return true;
    }
    if (!$from.parent.isBlock) {
        return false;
    }
    const atEnd = $to.parentOffset === $to.parent.content.size;
    const deflt = $from.depth === 0
        ? undefined
        : defaultBlockAt($from.node(-1).contentMatchAt($from.indexAfter(-1)));
    let types = atEnd && deflt
        ? [
            {
                type: deflt,
                attrs: newAttributes,
            },
        ]
        : undefined;
    let can = transform.canSplit(tr.doc, tr.mapping.map($from.pos), 1, types);
    if (!types
        && !can
        && transform.canSplit(tr.doc, tr.mapping.map($from.pos), 1, deflt ? [{ type: deflt }] : undefined)) {
        can = true;
        types = deflt
            ? [
                {
                    type: deflt,
                    attrs: newAttributes,
                },
            ]
            : undefined;
    }
    if (dispatch) {
        if (can) {
            if (selection instanceof state.TextSelection) {
                tr.deleteSelection();
            }
            tr.split(tr.mapping.map($from.pos), 1, types);
            if (deflt && !atEnd && !$from.parentOffset && $from.parent.type !== deflt) {
                const first = tr.mapping.map($from.before());
                const $first = tr.doc.resolve(first);
                if ($from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt)) {
                    tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
                }
            }
        }
        if (keepMarks) {
            ensureMarks(state$1, editor.extensionManager.splittableMarks);
        }
        tr.scrollIntoView();
    }
    return can;
};

const splitListItem = (typeOrName, overrideAttrs = {}) => ({ tr, state: state$1, dispatch, editor, }) => {
    var _a;
    const type = getNodeType(typeOrName, state$1.schema);
    const { $from, $to } = state$1.selection;
    // @ts-ignore
    // eslint-disable-next-line
    const node = state$1.selection.node;
    if ((node && node.isBlock) || $from.depth < 2 || !$from.sameParent($to)) {
        return false;
    }
    const grandParent = $from.node(-1);
    if (grandParent.type !== type) {
        return false;
    }
    const extensionAttributes = editor.extensionManager.attributes;
    if ($from.parent.content.size === 0 && $from.node(-1).childCount === $from.indexAfter(-1)) {
        // In an empty block. If this is a nested list, the wrapping
        // list item should be split. Otherwise, bail out and let next
        // command handle lifting.
        if ($from.depth === 2
            || $from.node(-3).type !== type
            || $from.index(-2) !== $from.node(-2).childCount - 1) {
            return false;
        }
        if (dispatch) {
            let wrap = model.Fragment.empty;
            // eslint-disable-next-line
            const depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3;
            // Build a fragment containing empty versions of the structure
            // from the outer list item to the parent node of the cursor
            for (let d = $from.depth - depthBefore; d >= $from.depth - 3; d -= 1) {
                wrap = model.Fragment.from($from.node(d).copy(wrap));
            }
            // eslint-disable-next-line
            const depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1 : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3;
            // Add a second list item with an empty default start node
            const newNextTypeAttributes = {
                ...getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs),
                ...overrideAttrs,
            };
            const nextType = ((_a = type.contentMatch.defaultType) === null || _a === void 0 ? void 0 : _a.createAndFill(newNextTypeAttributes)) || undefined;
            wrap = wrap.append(model.Fragment.from(type.createAndFill(null, nextType) || undefined));
            const start = $from.before($from.depth - (depthBefore - 1));
            tr.replace(start, $from.after(-depthAfter), new model.Slice(wrap, 4 - depthBefore, 0));
            let sel = -1;
            tr.doc.nodesBetween(start, tr.doc.content.size, (n, pos) => {
                if (sel > -1) {
                    return false;
                }
                if (n.isTextblock && n.content.size === 0) {
                    sel = pos + 1;
                }
            });
            if (sel > -1) {
                tr.setSelection(state.TextSelection.near(tr.doc.resolve(sel)));
            }
            tr.scrollIntoView();
        }
        return true;
    }
    const nextType = $to.pos === $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
    const newTypeAttributes = {
        ...getSplittedAttributes(extensionAttributes, grandParent.type.name, grandParent.attrs),
        ...overrideAttrs,
    };
    const newNextTypeAttributes = {
        ...getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs),
        ...overrideAttrs,
    };
    tr.delete($from.pos, $to.pos);
    const types = nextType
        ? [
            { type, attrs: newTypeAttributes },
            { type: nextType, attrs: newNextTypeAttributes },
        ]
        : [{ type, attrs: newTypeAttributes }];
    if (!transform.canSplit(tr.doc, $from.pos, 2)) {
        return false;
    }
    if (dispatch) {
        const { selection, storedMarks } = state$1;
        const { splittableMarks } = editor.extensionManager;
        const marks = storedMarks || (selection.$to.parentOffset && selection.$from.marks());
        tr.split($from.pos, 2, types).scrollIntoView();
        if (!marks || !dispatch) {
            return true;
        }
        const filteredMarks = marks.filter(mark => splittableMarks.includes(mark.type.name));
        tr.ensureMarks(filteredMarks);
    }
    return true;
};

const joinListBackwards = (tr, listType) => {
    const list = findParentNode(node => node.type === listType)(tr.selection);
    if (!list) {
        return true;
    }
    const before = tr.doc.resolve(Math.max(0, list.pos - 1)).before(list.depth);
    if (before === undefined) {
        return true;
    }
    const nodeBefore = tr.doc.nodeAt(before);
    const canJoinBackwards = list.node.type === (nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.type) && transform.canJoin(tr.doc, list.pos);
    if (!canJoinBackwards) {
        return true;
    }
    tr.join(list.pos);
    return true;
};
const joinListForwards = (tr, listType) => {
    const list = findParentNode(node => node.type === listType)(tr.selection);
    if (!list) {
        return true;
    }
    const after = tr.doc.resolve(list.start).after(list.depth);
    if (after === undefined) {
        return true;
    }
    const nodeAfter = tr.doc.nodeAt(after);
    const canJoinForwards = list.node.type === (nodeAfter === null || nodeAfter === void 0 ? void 0 : nodeAfter.type) && transform.canJoin(tr.doc, after);
    if (!canJoinForwards) {
        return true;
    }
    tr.join(after);
    return true;
};
const toggleList = (listTypeOrName, itemTypeOrName, keepMarks, attributes = {}) => ({ editor, tr, state, dispatch, chain, commands, can, }) => {
    const { extensions, splittableMarks } = editor.extensionManager;
    const listType = getNodeType(listTypeOrName, state.schema);
    const itemType = getNodeType(itemTypeOrName, state.schema);
    const { selection, storedMarks } = state;
    const { $from, $to } = selection;
    const range = $from.blockRange($to);
    const marks = storedMarks || (selection.$to.parentOffset && selection.$from.marks());
    if (!range) {
        return false;
    }
    const parentList = findParentNode(node => isList(node.type.name, extensions))(selection);
    if (range.depth >= 1 && parentList && range.depth - parentList.depth <= 1) {
        // remove list
        if (parentList.node.type === listType) {
            return commands.liftListItem(itemType);
        }
        // change list type
        if (isList(parentList.node.type.name, extensions)
            && listType.validContent(parentList.node.content)
            && dispatch) {
            return chain()
                .command(() => {
                tr.setNodeMarkup(parentList.pos, listType);
                return true;
            })
                .command(() => joinListBackwards(tr, listType))
                .command(() => joinListForwards(tr, listType))
                .run();
        }
    }
    if (!keepMarks || !marks || !dispatch) {
        return chain()
            // try to convert node to default node if needed
            .command(() => {
            const canWrapInList = can().wrapInList(listType, attributes);
            if (canWrapInList) {
                return true;
            }
            return commands.clearNodes();
        })
            .wrapInList(listType, attributes)
            .command(() => joinListBackwards(tr, listType))
            .command(() => joinListForwards(tr, listType))
            .run();
    }
    return (chain()
        // try to convert node to default node if needed
        .command(() => {
        const canWrapInList = can().wrapInList(listType, attributes);
        const filteredMarks = marks.filter(mark => splittableMarks.includes(mark.type.name));
        tr.ensureMarks(filteredMarks);
        if (canWrapInList) {
            return true;
        }
        return commands.clearNodes();
    })
        .wrapInList(listType, attributes)
        .command(() => joinListBackwards(tr, listType))
        .command(() => joinListForwards(tr, listType))
        .run());
};

const toggleMark = (typeOrName, attributes = {}, options = {}) => ({ state, commands }) => {
    const { extendEmptyMarkRange = false } = options;
    const type = getMarkType(typeOrName, state.schema);
    const isActive = isMarkActive(state, type, attributes);
    if (isActive) {
        return commands.unsetMark(type, { extendEmptyMarkRange });
    }
    return commands.setMark(type, attributes);
};

const toggleNode = (typeOrName, toggleTypeOrName, attributes = {}) => ({ state, commands }) => {
    const type = getNodeType(typeOrName, state.schema);
    const toggleType = getNodeType(toggleTypeOrName, state.schema);
    const isActive = isNodeActive(state, type, attributes);
    let attributesToCopy;
    if (state.selection.$anchor.sameParent(state.selection.$head)) {
        // only copy attributes if the selection is pointing to a node of the same type
        attributesToCopy = state.selection.$anchor.parent.attrs;
    }
    if (isActive) {
        return commands.setNode(toggleType, attributesToCopy);
    }
    // If the node is not active, we want to set the new node type with the given attributes
    // Copying over the attributes from the current node if the selection is pointing to a node of the same type
    return commands.setNode(type, { ...attributesToCopy, ...attributes });
};

const toggleWrap = (typeOrName, attributes = {}) => ({ state, commands }) => {
    const type = getNodeType(typeOrName, state.schema);
    const isActive = isNodeActive(state, type, attributes);
    if (isActive) {
        return commands.lift(type);
    }
    return commands.wrapIn(type, attributes);
};

const undoInputRule = () => ({ state, dispatch }) => {
    const plugins = state.plugins;
    for (let i = 0; i < plugins.length; i += 1) {
        const plugin = plugins[i];
        let undoable;
        // @ts-ignore
        // eslint-disable-next-line
        if (plugin.spec.isInputRules && (undoable = plugin.getState(state))) {
            if (dispatch) {
                const tr = state.tr;
                const toUndo = undoable.transform;
                for (let j = toUndo.steps.length - 1; j >= 0; j -= 1) {
                    tr.step(toUndo.steps[j].invert(toUndo.docs[j]));
                }
                if (undoable.text) {
                    const marks = tr.doc.resolve(undoable.from).marks();
                    tr.replaceWith(undoable.from, undoable.to, state.schema.text(undoable.text, marks));
                }
                else {
                    tr.delete(undoable.from, undoable.to);
                }
            }
            return true;
        }
    }
    return false;
};

const unsetAllMarks = () => ({ tr, dispatch }) => {
    const { selection } = tr;
    const { empty, ranges } = selection;
    if (empty) {
        return true;
    }
    if (dispatch) {
        ranges.forEach(range => {
            tr.removeMark(range.$from.pos, range.$to.pos);
        });
    }
    return true;
};

const unsetMark = (typeOrName, options = {}) => ({ tr, state, dispatch }) => {
    var _a;
    const { extendEmptyMarkRange = false } = options;
    const { selection } = tr;
    const type = getMarkType(typeOrName, state.schema);
    const { $from, empty, ranges } = selection;
    if (!dispatch) {
        return true;
    }
    if (empty && extendEmptyMarkRange) {
        let { from, to } = selection;
        const attrs = (_a = $from.marks().find(mark => mark.type === type)) === null || _a === void 0 ? void 0 : _a.attrs;
        const range = getMarkRange($from, type, attrs);
        if (range) {
            from = range.from;
            to = range.to;
        }
        tr.removeMark(from, to, type);
    }
    else {
        ranges.forEach(range => {
            tr.removeMark(range.$from.pos, range.$to.pos, type);
        });
    }
    tr.removeStoredMark(type);
    return true;
};

const updateAttributes = (typeOrName, attributes = {}) => ({ tr, state, dispatch }) => {
    let nodeType = null;
    let markType = null;
    const schemaType = getSchemaTypeNameByName(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);
    if (!schemaType) {
        return false;
    }
    if (schemaType === 'node') {
        nodeType = getNodeType(typeOrName, state.schema);
    }
    if (schemaType === 'mark') {
        markType = getMarkType(typeOrName, state.schema);
    }
    if (dispatch) {
        tr.selection.ranges.forEach((range) => {
            const from = range.$from.pos;
            const to = range.$to.pos;
            let lastPos;
            let lastNode;
            let trimmedFrom;
            let trimmedTo;
            if (tr.selection.empty) {
                state.doc.nodesBetween(from, to, (node, pos) => {
                    if (nodeType && nodeType === node.type) {
                        trimmedFrom = Math.max(pos, from);
                        trimmedTo = Math.min(pos + node.nodeSize, to);
                        lastPos = pos;
                        lastNode = node;
                    }
                });
            }
            else {
                state.doc.nodesBetween(from, to, (node, pos) => {
                    if (pos < from && nodeType && nodeType === node.type) {
                        trimmedFrom = Math.max(pos, from);
                        trimmedTo = Math.min(pos + node.nodeSize, to);
                        lastPos = pos;
                        lastNode = node;
                    }
                    if (pos >= from && pos <= to) {
                        if (nodeType && nodeType === node.type) {
                            tr.setNodeMarkup(pos, undefined, {
                                ...node.attrs,
                                ...attributes,
                            });
                        }
                        if (markType && node.marks.length) {
                            node.marks.forEach((mark) => {
                                if (markType === mark.type) {
                                    const trimmedFrom2 = Math.max(pos, from);
                                    const trimmedTo2 = Math.min(pos + node.nodeSize, to);
                                    tr.addMark(trimmedFrom2, trimmedTo2, markType.create({
                                        ...mark.attrs,
                                        ...attributes,
                                    }));
                                }
                            });
                        }
                    }
                });
            }
            if (lastNode) {
                if (lastPos !== undefined) {
                    tr.setNodeMarkup(lastPos, undefined, {
                        ...lastNode.attrs,
                        ...attributes,
                    });
                }
                if (markType && lastNode.marks.length) {
                    lastNode.marks.forEach((mark) => {
                        if (markType === mark.type) {
                            tr.addMark(trimmedFrom, trimmedTo, markType.create({
                                ...mark.attrs,
                                ...attributes,
                            }));
                        }
                    });
                }
            }
        });
    }
    return true;
};

const wrapIn = (typeOrName, attributes = {}) => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    return commands$1.wrapIn(type, attributes)(state, dispatch);
};

const wrapInList = (typeOrName, attributes = {}) => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    return schemaList.wrapInList(type, attributes)(state, dispatch);
};

var commands = /*#__PURE__*/Object.freeze({
  __proto__: null,
  blur: blur,
  clearContent: clearContent,
  clearNodes: clearNodes,
  command: command,
  createParagraphNear: createParagraphNear,
  cut: cut,
  deleteCurrentNode: deleteCurrentNode,
  deleteNode: deleteNode,
  deleteRange: deleteRange,
  deleteSelection: deleteSelection,
  enter: enter,
  exitCode: exitCode,
  extendMarkRange: extendMarkRange,
  first: first,
  focus: focus,
  forEach: forEach,
  insertContent: insertContent,
  insertContentAt: insertContentAt,
  joinBackward: joinBackward,
  joinDown: joinDown,
  joinForward: joinForward,
  joinItemBackward: joinItemBackward,
  joinItemForward: joinItemForward,
  joinTextblockBackward: joinTextblockBackward,
  joinTextblockForward: joinTextblockForward,
  joinUp: joinUp,
  keyboardShortcut: keyboardShortcut,
  lift: lift,
  liftEmptyBlock: liftEmptyBlock,
  liftListItem: liftListItem,
  newlineInCode: newlineInCode,
  resetAttributes: resetAttributes,
  scrollIntoView: scrollIntoView,
  selectAll: selectAll,
  selectNodeBackward: selectNodeBackward,
  selectNodeForward: selectNodeForward,
  selectParentNode: selectParentNode,
  selectTextblockEnd: selectTextblockEnd,
  selectTextblockStart: selectTextblockStart,
  setContent: setContent,
  setMark: setMark,
  setMeta: setMeta,
  setNode: setNode,
  setNodeSelection: setNodeSelection,
  setTextSelection: setTextSelection,
  sinkListItem: sinkListItem,
  splitBlock: splitBlock,
  splitListItem: splitListItem,
  toggleList: toggleList,
  toggleMark: toggleMark,
  toggleNode: toggleNode,
  toggleWrap: toggleWrap,
  undoInputRule: undoInputRule,
  unsetAllMarks: unsetAllMarks,
  unsetMark: unsetMark,
  updateAttributes: updateAttributes,
  wrapIn: wrapIn,
  wrapInList: wrapInList
});

const Commands = Extension.create({
    name: 'commands',
    addCommands() {
        return {
            ...commands,
        };
    },
});

const Drop = Extension.create({
    name: 'drop',
    addProseMirrorPlugins() {
        return [
            new state.Plugin({
                key: new state.PluginKey('tiptapDrop'),
                props: {
                    handleDrop: (_, e, slice, moved) => {
                        this.editor.emit('drop', {
                            editor: this.editor,
                            event: e,
                            slice,
                            moved,
                        });
                    },
                },
            }),
        ];
    },
});

const Editable = Extension.create({
    name: 'editable',
    addProseMirrorPlugins() {
        return [
            new state.Plugin({
                key: new state.PluginKey('editable'),
                props: {
                    editable: () => this.editor.options.editable,
                },
            }),
        ];
    },
});

const focusEventsPluginKey = new state.PluginKey('focusEvents');
const FocusEvents = Extension.create({
    name: 'focusEvents',
    addProseMirrorPlugins() {
        const { editor } = this;
        return [
            new state.Plugin({
                key: focusEventsPluginKey,
                props: {
                    handleDOMEvents: {
                        focus: (view, event) => {
                            editor.isFocused = true;
                            const transaction = editor.state.tr
                                .setMeta('focus', { event })
                                .setMeta('addToHistory', false);
                            view.dispatch(transaction);
                            return false;
                        },
                        blur: (view, event) => {
                            editor.isFocused = false;
                            const transaction = editor.state.tr
                                .setMeta('blur', { event })
                                .setMeta('addToHistory', false);
                            view.dispatch(transaction);
                            return false;
                        },
                    },
                },
            }),
        ];
    },
});

const Keymap = Extension.create({
    name: 'keymap',
    addKeyboardShortcuts() {
        const handleBackspace = () => this.editor.commands.first(({ commands }) => [
            () => commands.undoInputRule(),
            // maybe convert first text block node to default node
            () => commands.command(({ tr }) => {
                const { selection, doc } = tr;
                const { empty, $anchor } = selection;
                const { pos, parent } = $anchor;
                const $parentPos = $anchor.parent.isTextblock && pos > 0 ? tr.doc.resolve(pos - 1) : $anchor;
                const parentIsIsolating = $parentPos.parent.type.spec.isolating;
                const parentPos = $anchor.pos - $anchor.parentOffset;
                const isAtStart = (parentIsIsolating && $parentPos.parent.childCount === 1)
                    ? parentPos === $anchor.pos
                    : state.Selection.atStart(doc).from === pos;
                if (!empty
                    || !parent.type.isTextblock
                    || parent.textContent.length
                    || !isAtStart
                    || (isAtStart && $anchor.parent.type.name === 'paragraph') // prevent clearNodes when no nodes to clear, otherwise history stack is appended
                ) {
                    return false;
                }
                return commands.clearNodes();
            }),
            () => commands.deleteSelection(),
            () => commands.joinBackward(),
            () => commands.selectNodeBackward(),
        ]);
        const handleDelete = () => this.editor.commands.first(({ commands }) => [
            () => commands.deleteSelection(),
            () => commands.deleteCurrentNode(),
            () => commands.joinForward(),
            () => commands.selectNodeForward(),
        ]);
        const handleEnter = () => this.editor.commands.first(({ commands }) => [
            () => commands.newlineInCode(),
            () => commands.createParagraphNear(),
            () => commands.liftEmptyBlock(),
            () => commands.splitBlock(),
        ]);
        const baseKeymap = {
            Enter: handleEnter,
            'Mod-Enter': () => this.editor.commands.exitCode(),
            Backspace: handleBackspace,
            'Mod-Backspace': handleBackspace,
            'Shift-Backspace': handleBackspace,
            Delete: handleDelete,
            'Mod-Delete': handleDelete,
            'Mod-a': () => this.editor.commands.selectAll(),
        };
        const pcKeymap = {
            ...baseKeymap,
        };
        const macKeymap = {
            ...baseKeymap,
            'Ctrl-h': handleBackspace,
            'Alt-Backspace': handleBackspace,
            'Ctrl-d': handleDelete,
            'Ctrl-Alt-Backspace': handleDelete,
            'Alt-Delete': handleDelete,
            'Alt-d': handleDelete,
            'Ctrl-a': () => this.editor.commands.selectTextblockStart(),
            'Ctrl-e': () => this.editor.commands.selectTextblockEnd(),
        };
        if (isiOS() || isMacOS()) {
            return macKeymap;
        }
        return pcKeymap;
    },
    addProseMirrorPlugins() {
        return [
            // With this plugin we check if the whole document was selected and deleted.
            // In this case we will additionally call `clearNodes()` to convert e.g. a heading
            // to a paragraph if necessary.
            // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
            // with many other commands.
            new state.Plugin({
                key: new state.PluginKey('clearDocument'),
                appendTransaction: (transactions, oldState, newState) => {
                    if (transactions.some(tr => tr.getMeta('composition'))) {
                        return;
                    }
                    const docChanges = transactions.some(transaction => transaction.docChanged)
                        && !oldState.doc.eq(newState.doc);
                    const ignoreTr = transactions.some(transaction => transaction.getMeta('preventClearDocument'));
                    if (!docChanges || ignoreTr) {
                        return;
                    }
                    const { empty, from, to } = oldState.selection;
                    const allFrom = state.Selection.atStart(oldState.doc).from;
                    const allEnd = state.Selection.atEnd(oldState.doc).to;
                    const allWasSelected = from === allFrom && to === allEnd;
                    if (empty || !allWasSelected) {
                        return;
                    }
                    const isEmpty = isNodeEmpty(newState.doc);
                    if (!isEmpty) {
                        return;
                    }
                    const tr = newState.tr;
                    const state$1 = createChainableState({
                        state: newState,
                        transaction: tr,
                    });
                    const { commands } = new CommandManager({
                        editor: this.editor,
                        state: state$1,
                    });
                    commands.clearNodes();
                    if (!tr.steps.length) {
                        return;
                    }
                    return tr;
                },
            }),
        ];
    },
});

const Paste = Extension.create({
    name: 'paste',
    addProseMirrorPlugins() {
        return [
            new state.Plugin({
                key: new state.PluginKey('tiptapPaste'),
                props: {
                    handlePaste: (_view, e, slice) => {
                        this.editor.emit('paste', {
                            editor: this.editor,
                            event: e,
                            slice,
                        });
                    },
                },
            }),
        ];
    },
});

const Tabindex = Extension.create({
    name: 'tabindex',
    addProseMirrorPlugins() {
        return [
            new state.Plugin({
                key: new state.PluginKey('tabindex'),
                props: {
                    attributes: () => (this.editor.isEditable ? { tabindex: '0' } : {}),
                },
            }),
        ];
    },
});

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ClipboardTextSerializer: ClipboardTextSerializer,
  Commands: Commands,
  Drop: Drop,
  Editable: Editable,
  FocusEvents: FocusEvents,
  Keymap: Keymap,
  Paste: Paste,
  Tabindex: Tabindex,
  focusEventsPluginKey: focusEventsPluginKey
});

class NodePos {
    get name() {
        return this.node.type.name;
    }
    constructor(pos, editor, isBlock = false, node = null) {
        this.currentNode = null;
        this.actualDepth = null;
        this.isBlock = isBlock;
        this.resolvedPos = pos;
        this.editor = editor;
        this.currentNode = node;
    }
    get node() {
        return this.currentNode || this.resolvedPos.node();
    }
    get element() {
        return this.editor.view.domAtPos(this.pos).node;
    }
    get depth() {
        var _a;
        return (_a = this.actualDepth) !== null && _a !== void 0 ? _a : this.resolvedPos.depth;
    }
    get pos() {
        return this.resolvedPos.pos;
    }
    get content() {
        return this.node.content;
    }
    set content(content) {
        let from = this.from;
        let to = this.to;
        if (this.isBlock) {
            if (this.content.size === 0) {
                console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
                return;
            }
            from = this.from + 1;
            to = this.to - 1;
        }
        this.editor.commands.insertContentAt({ from, to }, content);
    }
    get attributes() {
        return this.node.attrs;
    }
    get textContent() {
        return this.node.textContent;
    }
    get size() {
        return this.node.nodeSize;
    }
    get from() {
        if (this.isBlock) {
            return this.pos;
        }
        return this.resolvedPos.start(this.resolvedPos.depth);
    }
    get range() {
        return {
            from: this.from,
            to: this.to,
        };
    }
    get to() {
        if (this.isBlock) {
            return this.pos + this.size;
        }
        return this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
    }
    get parent() {
        if (this.depth === 0) {
            return null;
        }
        const parentPos = this.resolvedPos.start(this.resolvedPos.depth - 1);
        const $pos = this.resolvedPos.doc.resolve(parentPos);
        return new NodePos($pos, this.editor);
    }
    get before() {
        let $pos = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
        if ($pos.depth !== this.depth) {
            $pos = this.resolvedPos.doc.resolve(this.from - 3);
        }
        return new NodePos($pos, this.editor);
    }
    get after() {
        let $pos = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
        if ($pos.depth !== this.depth) {
            $pos = this.resolvedPos.doc.resolve(this.to + 3);
        }
        return new NodePos($pos, this.editor);
    }
    get children() {
        const children = [];
        this.node.content.forEach((node, offset) => {
            const isBlock = node.isBlock && !node.isTextblock;
            const isNonTextAtom = node.isAtom && !node.isText;
            const targetPos = this.pos + offset + (isNonTextAtom ? 0 : 1);
            // Check if targetPos is within valid document range
            if (targetPos < 0 || targetPos > this.resolvedPos.doc.nodeSize - 2) {
                return;
            }
            const $pos = this.resolvedPos.doc.resolve(targetPos);
            if (!isBlock && $pos.depth <= this.depth) {
                return;
            }
            const childNodePos = new NodePos($pos, this.editor, isBlock, isBlock ? node : null);
            if (isBlock) {
                childNodePos.actualDepth = this.depth + 1;
            }
            children.push(new NodePos($pos, this.editor, isBlock, isBlock ? node : null));
        });
        return children;
    }
    get firstChild() {
        return this.children[0] || null;
    }
    get lastChild() {
        const children = this.children;
        return children[children.length - 1] || null;
    }
    closest(selector, attributes = {}) {
        let node = null;
        let currentNode = this.parent;
        while (currentNode && !node) {
            if (currentNode.node.type.name === selector) {
                if (Object.keys(attributes).length > 0) {
                    const nodeAttributes = currentNode.node.attrs;
                    const attrKeys = Object.keys(attributes);
                    for (let index = 0; index < attrKeys.length; index += 1) {
                        const key = attrKeys[index];
                        if (nodeAttributes[key] !== attributes[key]) {
                            break;
                        }
                    }
                }
                else {
                    node = currentNode;
                }
            }
            currentNode = currentNode.parent;
        }
        return node;
    }
    querySelector(selector, attributes = {}) {
        return this.querySelectorAll(selector, attributes, true)[0] || null;
    }
    querySelectorAll(selector, attributes = {}, firstItemOnly = false) {
        let nodes = [];
        if (!this.children || this.children.length === 0) {
            return nodes;
        }
        const attrKeys = Object.keys(attributes);
        /**
         * Finds all children recursively that match the selector and attributes
         * If firstItemOnly is true, it will return the first item found
         */
        this.children.forEach(childPos => {
            // If we already found a node and we only want the first item, we dont need to keep going
            if (firstItemOnly && nodes.length > 0) {
                return;
            }
            if (childPos.node.type.name === selector) {
                const doesAllAttributesMatch = attrKeys.every(key => attributes[key] === childPos.node.attrs[key]);
                if (doesAllAttributesMatch) {
                    nodes.push(childPos);
                }
            }
            // If we already found a node and we only want the first item, we can stop here and skip the recursion
            if (firstItemOnly && nodes.length > 0) {
                return;
            }
            nodes = nodes.concat(childPos.querySelectorAll(selector, attributes, firstItemOnly));
        });
        return nodes;
    }
    setAttribute(attributes) {
        const { tr } = this.editor.state;
        tr.setNodeMarkup(this.from, undefined, {
            ...this.node.attrs,
            ...attributes,
        });
        this.editor.view.dispatch(tr);
    }
}

const style = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;

function createStyleTag(style, nonce, suffix) {
    const tiptapStyleTag = document.querySelector(`style[data-tiptap-style${suffix ? `-${suffix}` : ''}]`);
    if (tiptapStyleTag !== null) {
        return tiptapStyleTag;
    }
    const styleNode = document.createElement('style');
    if (nonce) {
        styleNode.setAttribute('nonce', nonce);
    }
    styleNode.setAttribute(`data-tiptap-style${suffix ? `-${suffix}` : ''}`, '');
    styleNode.innerHTML = style;
    document.getElementsByTagName('head')[0].appendChild(styleNode);
    return styleNode;
}

class Editor extends EventEmitter {
    constructor(options = {}) {
        super();
        this.isFocused = false;
        /**
         * The editor is considered initialized after the `create` event has been emitted.
         */
        this.isInitialized = false;
        this.extensionStorage = {};
        this.options = {
            element: document.createElement('div'),
            content: '',
            injectCSS: true,
            injectNonce: undefined,
            extensions: [],
            autofocus: false,
            editable: true,
            editorProps: {},
            parseOptions: {},
            coreExtensionOptions: {},
            enableInputRules: true,
            enablePasteRules: true,
            enableCoreExtensions: true,
            enableContentCheck: false,
            emitContentError: false,
            onBeforeCreate: () => null,
            onCreate: () => null,
            onUpdate: () => null,
            onSelectionUpdate: () => null,
            onTransaction: () => null,
            onFocus: () => null,
            onBlur: () => null,
            onDestroy: () => null,
            onContentError: ({ error }) => { throw error; },
            onPaste: () => null,
            onDrop: () => null,
        };
        this.isCapturingTransaction = false;
        this.capturedTransaction = null;
        this.setOptions(options);
        this.createExtensionManager();
        this.createCommandManager();
        this.createSchema();
        this.on('beforeCreate', this.options.onBeforeCreate);
        this.emit('beforeCreate', { editor: this });
        this.on('contentError', this.options.onContentError);
        this.createView();
        this.injectCSS();
        this.on('create', this.options.onCreate);
        this.on('update', this.options.onUpdate);
        this.on('selectionUpdate', this.options.onSelectionUpdate);
        this.on('transaction', this.options.onTransaction);
        this.on('focus', this.options.onFocus);
        this.on('blur', this.options.onBlur);
        this.on('destroy', this.options.onDestroy);
        this.on('drop', ({ event, slice, moved }) => this.options.onDrop(event, slice, moved));
        this.on('paste', ({ event, slice }) => this.options.onPaste(event, slice));
        window.setTimeout(() => {
            if (this.isDestroyed) {
                return;
            }
            this.commands.focus(this.options.autofocus);
            this.emit('create', { editor: this });
            this.isInitialized = true;
        }, 0);
    }
    /**
     * Returns the editor storage.
     */
    get storage() {
        return this.extensionStorage;
    }
    /**
     * An object of all registered commands.
     */
    get commands() {
        return this.commandManager.commands;
    }
    /**
     * Create a command chain to call multiple commands at once.
     */
    chain() {
        return this.commandManager.chain();
    }
    /**
     * Check if a command or a command chain can be executed. Without executing it.
     */
    can() {
        return this.commandManager.can();
    }
    /**
     * Inject CSS styles.
     */
    injectCSS() {
        if (this.options.injectCSS && document) {
            this.css = createStyleTag(style, this.options.injectNonce);
        }
    }
    /**
     * Update editor options.
     *
     * @param options A list of options
     */
    setOptions(options = {}) {
        this.options = {
            ...this.options,
            ...options,
        };
        if (!this.view || !this.state || this.isDestroyed) {
            return;
        }
        if (this.options.editorProps) {
            this.view.setProps(this.options.editorProps);
        }
        this.view.updateState(this.state);
    }
    /**
     * Update editable state of the editor.
     */
    setEditable(editable, emitUpdate = true) {
        this.setOptions({ editable });
        if (emitUpdate) {
            this.emit('update', { editor: this, transaction: this.state.tr });
        }
    }
    /**
     * Returns whether the editor is editable.
     */
    get isEditable() {
        // since plugins are applied after creating the view
        // `editable` is always `true` for one tick.
        // that’s why we also have to check for `options.editable`
        return this.options.editable && this.view && this.view.editable;
    }
    /**
     * Returns the editor state.
     */
    get state() {
        return this.view.state;
    }
    /**
     * Register a ProseMirror plugin.
     *
     * @param plugin A ProseMirror plugin
     * @param handlePlugins Control how to merge the plugin into the existing plugins.
     * @returns The new editor state
     */
    registerPlugin(plugin, handlePlugins) {
        const plugins = isFunction(handlePlugins)
            ? handlePlugins(plugin, [...this.state.plugins])
            : [...this.state.plugins, plugin];
        const state = this.state.reconfigure({ plugins });
        this.view.updateState(state);
        return state;
    }
    /**
     * Unregister a ProseMirror plugin.
     *
     * @param nameOrPluginKeyToRemove The plugins name
     * @returns The new editor state or undefined if the editor is destroyed
     */
    unregisterPlugin(nameOrPluginKeyToRemove) {
        if (this.isDestroyed) {
            return undefined;
        }
        const prevPlugins = this.state.plugins;
        let plugins = prevPlugins;
        [].concat(nameOrPluginKeyToRemove).forEach(nameOrPluginKey => {
            // @ts-ignore
            const name = typeof nameOrPluginKey === 'string' ? `${nameOrPluginKey}$` : nameOrPluginKey.key;
            // @ts-ignore
            plugins = plugins.filter(plugin => !plugin.key.startsWith(name));
        });
        if (prevPlugins.length === plugins.length) {
            // No plugin was removed, so we don’t need to update the state
            return undefined;
        }
        const state = this.state.reconfigure({
            plugins,
        });
        this.view.updateState(state);
        return state;
    }
    /**
     * Creates an extension manager.
     */
    createExtensionManager() {
        var _a, _b;
        const coreExtensions = this.options.enableCoreExtensions ? [
            Editable,
            ClipboardTextSerializer.configure({
                blockSeparator: (_b = (_a = this.options.coreExtensionOptions) === null || _a === void 0 ? void 0 : _a.clipboardTextSerializer) === null || _b === void 0 ? void 0 : _b.blockSeparator,
            }),
            Commands,
            FocusEvents,
            Keymap,
            Tabindex,
            Drop,
            Paste,
        ].filter(ext => {
            if (typeof this.options.enableCoreExtensions === 'object') {
                return this.options.enableCoreExtensions[ext.name] !== false;
            }
            return true;
        }) : [];
        const allExtensions = [...coreExtensions, ...this.options.extensions].filter(extension => {
            return ['extension', 'node', 'mark'].includes(extension === null || extension === void 0 ? void 0 : extension.type);
        });
        this.extensionManager = new ExtensionManager(allExtensions, this);
    }
    /**
     * Creates an command manager.
     */
    createCommandManager() {
        this.commandManager = new CommandManager({
            editor: this,
        });
    }
    /**
     * Creates a ProseMirror schema.
     */
    createSchema() {
        this.schema = this.extensionManager.schema;
    }
    /**
     * Creates a ProseMirror view.
     */
    createView() {
        var _a;
        let doc;
        try {
            doc = createDocument(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
        }
        catch (e) {
            if (!(e instanceof Error) || !['[tiptap error]: Invalid JSON content', '[tiptap error]: Invalid HTML content'].includes(e.message)) {
                // Not the content error we were expecting
                throw e;
            }
            this.emit('contentError', {
                editor: this,
                error: e,
                disableCollaboration: () => {
                    if (this.storage.collaboration) {
                        this.storage.collaboration.isDisabled = true;
                    }
                    // To avoid syncing back invalid content, reinitialize the extensions without the collaboration extension
                    this.options.extensions = this.options.extensions.filter(extension => extension.name !== 'collaboration');
                    // Restart the initialization process by recreating the extension manager with the new set of extensions
                    this.createExtensionManager();
                },
            });
            // Content is invalid, but attempt to create it anyway, stripping out the invalid parts
            doc = createDocument(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: false });
        }
        const selection = resolveFocusPosition(doc, this.options.autofocus);
        this.view = new view.EditorView(this.options.element, {
            ...this.options.editorProps,
            attributes: {
                // add `role="textbox"` to the editor element
                role: 'textbox',
                ...(_a = this.options.editorProps) === null || _a === void 0 ? void 0 : _a.attributes,
            },
            dispatchTransaction: this.dispatchTransaction.bind(this),
            state: state.EditorState.create({
                doc,
                selection: selection || undefined,
            }),
        });
        // `editor.view` is not yet available at this time.
        // Therefore we will add all plugins and node views directly afterwards.
        const newState = this.state.reconfigure({
            plugins: this.extensionManager.plugins,
        });
        this.view.updateState(newState);
        this.createNodeViews();
        this.prependClass();
        // Let’s store the editor instance in the DOM element.
        // So we’ll have access to it for tests.
        // @ts-ignore
        const dom = this.view.dom;
        dom.editor = this;
    }
    /**
     * Creates all node views.
     */
    createNodeViews() {
        if (this.view.isDestroyed) {
            return;
        }
        this.view.setProps({
            nodeViews: this.extensionManager.nodeViews,
        });
    }
    /**
     * Prepend class name to element.
     */
    prependClass() {
        this.view.dom.className = `tiptap ${this.view.dom.className}`;
    }
    captureTransaction(fn) {
        this.isCapturingTransaction = true;
        fn();
        this.isCapturingTransaction = false;
        const tr = this.capturedTransaction;
        this.capturedTransaction = null;
        return tr;
    }
    /**
     * The callback over which to send transactions (state updates) produced by the view.
     *
     * @param transaction An editor state transaction
     */
    dispatchTransaction(transaction) {
        // if the editor / the view of the editor was destroyed
        // the transaction should not be dispatched as there is no view anymore.
        if (this.view.isDestroyed) {
            return;
        }
        if (this.isCapturingTransaction) {
            if (!this.capturedTransaction) {
                this.capturedTransaction = transaction;
                return;
            }
            transaction.steps.forEach(step => { var _a; return (_a = this.capturedTransaction) === null || _a === void 0 ? void 0 : _a.step(step); });
            return;
        }
        const state = this.state.apply(transaction);
        const selectionHasChanged = !this.state.selection.eq(state.selection);
        this.emit('beforeTransaction', {
            editor: this,
            transaction,
            nextState: state,
        });
        this.view.updateState(state);
        this.emit('transaction', {
            editor: this,
            transaction,
        });
        if (selectionHasChanged) {
            this.emit('selectionUpdate', {
                editor: this,
                transaction,
            });
        }
        const focus = transaction.getMeta('focus');
        const blur = transaction.getMeta('blur');
        if (focus) {
            this.emit('focus', {
                editor: this,
                event: focus.event,
                transaction,
            });
        }
        if (blur) {
            this.emit('blur', {
                editor: this,
                event: blur.event,
                transaction,
            });
        }
        if (!transaction.docChanged || transaction.getMeta('preventUpdate')) {
            return;
        }
        this.emit('update', {
            editor: this,
            transaction,
        });
    }
    /**
     * Get attributes of the currently selected node or mark.
     */
    getAttributes(nameOrType) {
        return getAttributes(this.state, nameOrType);
    }
    isActive(nameOrAttributes, attributesOrUndefined) {
        const name = typeof nameOrAttributes === 'string' ? nameOrAttributes : null;
        const attributes = typeof nameOrAttributes === 'string' ? attributesOrUndefined : nameOrAttributes;
        return isActive(this.state, name, attributes);
    }
    /**
     * Get the document as JSON.
     */
    getJSON() {
        return this.state.doc.toJSON();
    }
    /**
     * Get the document as HTML.
     */
    getHTML() {
        return getHTMLFromFragment(this.state.doc.content, this.schema);
    }
    /**
     * Get the document as text.
     */
    getText(options) {
        const { blockSeparator = '\n\n', textSerializers = {} } = options || {};
        return getText(this.state.doc, {
            blockSeparator,
            textSerializers: {
                ...getTextSerializersFromSchema(this.schema),
                ...textSerializers,
            },
        });
    }
    /**
     * Check if there is no content.
     */
    get isEmpty() {
        return isNodeEmpty(this.state.doc);
    }
    /**
     * Get the number of characters for the current document.
     *
     * @deprecated
     */
    getCharacterCount() {
        console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.');
        return this.state.doc.content.size - 2;
    }
    /**
     * Destroy the editor.
     */
    destroy() {
        this.emit('destroy');
        if (this.view) {
            // Cleanup our reference to prevent circular references which caused memory leaks
            // @ts-ignore
            const dom = this.view.dom;
            if (dom && dom.editor) {
                delete dom.editor;
            }
            this.view.destroy();
        }
        this.removeAllListeners();
    }
    /**
     * Check if the editor is already destroyed.
     */
    get isDestroyed() {
        var _a;
        // @ts-ignore
        return !((_a = this.view) === null || _a === void 0 ? void 0 : _a.docView);
    }
    $node(selector, attributes) {
        var _a;
        return ((_a = this.$doc) === null || _a === void 0 ? void 0 : _a.querySelector(selector, attributes)) || null;
    }
    $nodes(selector, attributes) {
        var _a;
        return ((_a = this.$doc) === null || _a === void 0 ? void 0 : _a.querySelectorAll(selector, attributes)) || null;
    }
    $pos(pos) {
        const $pos = this.state.doc.resolve(pos);
        return new NodePos($pos, this);
    }
    get $doc() {
        return this.$pos(0);
    }
}

/**
 * Build an input rule that adds a mark when the
 * matched text is typed into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */
function markInputRule(config) {
    return new InputRule({
        find: config.find,
        handler: ({ state, range, match }) => {
            const attributes = callOrReturn(config.getAttributes, undefined, match);
            if (attributes === false || attributes === null) {
                return null;
            }
            const { tr } = state;
            const captureGroup = match[match.length - 1];
            const fullMatch = match[0];
            if (captureGroup) {
                const startSpaces = fullMatch.search(/\S/);
                const textStart = range.from + fullMatch.indexOf(captureGroup);
                const textEnd = textStart + captureGroup.length;
                const excludedMarks = getMarksBetween(range.from, range.to, state.doc)
                    .filter(item => {
                    // @ts-ignore
                    const excluded = item.mark.type.excluded;
                    return excluded.find(type => type === config.type && type !== item.mark.type);
                })
                    .filter(item => item.to > textStart);
                if (excludedMarks.length) {
                    return null;
                }
                if (textEnd < range.to) {
                    tr.delete(textEnd, range.to);
                }
                if (textStart > range.from) {
                    tr.delete(range.from + startSpaces, textStart);
                }
                const markEnd = range.from + startSpaces + captureGroup.length;
                tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
                tr.removeStoredMark(config.type);
            }
        },
    });
}

/**
 * Build an input rule that adds a node when the
 * matched text is typed into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */
function nodeInputRule(config) {
    return new InputRule({
        find: config.find,
        handler: ({ state, range, match }) => {
            const attributes = callOrReturn(config.getAttributes, undefined, match) || {};
            const { tr } = state;
            const start = range.from;
            let end = range.to;
            const newNode = config.type.create(attributes);
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                let matchStart = start + offset;
                if (matchStart > end) {
                    matchStart = end;
                }
                else {
                    end = matchStart + match[1].length;
                }
                // insert last typed character
                const lastChar = match[0][match[0].length - 1];
                tr.insertText(lastChar, start + match[0].length - 1);
                // insert node from input rule
                tr.replaceWith(matchStart, end, newNode);
            }
            else if (match[0]) {
                const insertionStart = config.type.isInline ? start : start - 1;
                tr.insert(insertionStart, config.type.create(attributes)).delete(tr.mapping.map(start), tr.mapping.map(end));
            }
            tr.scrollIntoView();
        },
    });
}

/**
 * Build an input rule that changes the type of a textblock when the
 * matched text is typed into it. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */
function textblockTypeInputRule(config) {
    return new InputRule({
        find: config.find,
        handler: ({ state, range, match }) => {
            const $start = state.doc.resolve(range.from);
            const attributes = callOrReturn(config.getAttributes, undefined, match) || {};
            if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), config.type)) {
                return null;
            }
            state.tr
                .delete(range.from, range.to)
                .setBlockType(range.from, range.from, config.type, attributes);
        },
    });
}

/**
 * Build an input rule that replaces text when the
 * matched text is typed into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */
function textInputRule(config) {
    return new InputRule({
        find: config.find,
        handler: ({ state, range, match }) => {
            let insert = config.replace;
            let start = range.from;
            const end = range.to;
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                insert += match[0].slice(offset + match[1].length);
                start += offset;
                const cutOff = start - end;
                if (cutOff > 0) {
                    insert = match[0].slice(offset - cutOff, offset) + insert;
                    start = end;
                }
            }
            state.tr.insertText(insert, start, end);
        },
    });
}

/**
 * Build an input rule for automatically wrapping a textblock when a
 * given string is typed. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 *
 * `type` is the type of node to wrap in.
 *
 * By default, if there’s a node with the same type above the newly
 * wrapped node, the rule will try to join those
 * two nodes. You can pass a join predicate, which takes a regular
 * expression match and the node before the wrapped node, and can
 * return a boolean to indicate whether a join should happen.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */
function wrappingInputRule(config) {
    return new InputRule({
        find: config.find,
        handler: ({ state, range, match, chain, }) => {
            const attributes = callOrReturn(config.getAttributes, undefined, match) || {};
            const tr = state.tr.delete(range.from, range.to);
            const $start = tr.doc.resolve(range.from);
            const blockRange = $start.blockRange();
            const wrapping = blockRange && transform.findWrapping(blockRange, config.type, attributes);
            if (!wrapping) {
                return null;
            }
            tr.wrap(blockRange, wrapping);
            if (config.keepMarks && config.editor) {
                const { selection, storedMarks } = state;
                const { splittableMarks } = config.editor.extensionManager;
                const marks = storedMarks || (selection.$to.parentOffset && selection.$from.marks());
                if (marks) {
                    const filteredMarks = marks.filter(mark => splittableMarks.includes(mark.type.name));
                    tr.ensureMarks(filteredMarks);
                }
            }
            if (config.keepAttributes) {
                /** If the nodeType is `bulletList` or `orderedList` set the `nodeType` as `listItem` */
                const nodeType = config.type.name === 'bulletList' || config.type.name === 'orderedList' ? 'listItem' : 'taskList';
                chain().updateAttributes(nodeType, attributes).run();
            }
            const before = tr.doc.resolve(range.from - 1).nodeBefore;
            if (before
                && before.type === config.type
                && transform.canJoin(tr.doc, range.from - 1)
                && (!config.joinPredicate || config.joinPredicate(match, before))) {
                tr.join(range.from - 1);
            }
        },
    });
}

/**
 * The Node class is used to create custom node extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */
class Node {
    constructor(config = {}) {
        this.type = 'node';
        this.name = 'node';
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {},
        };
        this.config = {
            ...this.config,
            ...config,
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        }
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) {
            this.options = callOrReturn(getExtensionField(this, 'addOptions', {
                name: this.name,
            }));
        }
        this.storage = callOrReturn(getExtensionField(this, 'addStorage', {
            name: this.name,
            options: this.options,
        })) || {};
    }
    static create(config = {}) {
        return new Node(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: () => {
                return mergeDeep(this.options, options);
            },
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new Node(extendedConfig);
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        }
        extension.options = callOrReturn(getExtensionField(extension, 'addOptions', {
            name: extension.name,
        }));
        extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
            name: extension.name,
            options: extension.options,
        }));
        return extension;
    }
}

/**
 * Node views are used to customize the rendered DOM structure of a node.
 * @see https://tiptap.dev/guide/node-views
 */
class NodeView {
    constructor(component, props, options) {
        this.isDragging = false;
        this.component = component;
        this.editor = props.editor;
        this.options = {
            stopEvent: null,
            ignoreMutation: null,
            ...options,
        };
        this.extension = props.extension;
        this.node = props.node;
        this.decorations = props.decorations;
        this.innerDecorations = props.innerDecorations;
        this.view = props.view;
        this.HTMLAttributes = props.HTMLAttributes;
        this.getPos = props.getPos;
        this.mount();
    }
    mount() {
        // eslint-disable-next-line
        return;
    }
    get dom() {
        return this.editor.view.dom;
    }
    get contentDOM() {
        return null;
    }
    onDragStart(event) {
        var _a, _b, _c, _d, _e, _f, _g;
        const { view } = this.editor;
        const target = event.target;
        // get the drag handle element
        // `closest` is not available for text nodes so we may have to use its parent
        const dragHandle = target.nodeType === 3
            ? (_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.closest('[data-drag-handle]')
            : target.closest('[data-drag-handle]');
        if (!this.dom || ((_b = this.contentDOM) === null || _b === void 0 ? void 0 : _b.contains(target)) || !dragHandle) {
            return;
        }
        let x = 0;
        let y = 0;
        // calculate offset for drag element if we use a different drag handle element
        if (this.dom !== dragHandle) {
            const domBox = this.dom.getBoundingClientRect();
            const handleBox = dragHandle.getBoundingClientRect();
            // In React, we have to go through nativeEvent to reach offsetX/offsetY.
            const offsetX = (_c = event.offsetX) !== null && _c !== void 0 ? _c : (_d = event.nativeEvent) === null || _d === void 0 ? void 0 : _d.offsetX;
            const offsetY = (_e = event.offsetY) !== null && _e !== void 0 ? _e : (_f = event.nativeEvent) === null || _f === void 0 ? void 0 : _f.offsetY;
            x = handleBox.x - domBox.x + offsetX;
            y = handleBox.y - domBox.y + offsetY;
        }
        const clonedNode = this.dom.cloneNode(true);
        (_g = event.dataTransfer) === null || _g === void 0 ? void 0 : _g.setDragImage(clonedNode, x, y);
        const pos = this.getPos();
        if (typeof pos !== 'number') {
            return;
        }
        // we need to tell ProseMirror that we want to move the whole node
        // so we create a NodeSelection
        const selection = state.NodeSelection.create(view.state.doc, pos);
        const transaction = view.state.tr.setSelection(selection);
        view.dispatch(transaction);
    }
    stopEvent(event) {
        var _a;
        if (!this.dom) {
            return false;
        }
        if (typeof this.options.stopEvent === 'function') {
            return this.options.stopEvent({ event });
        }
        const target = event.target;
        const isInElement = this.dom.contains(target) && !((_a = this.contentDOM) === null || _a === void 0 ? void 0 : _a.contains(target));
        // any event from child nodes should be handled by ProseMirror
        if (!isInElement) {
            return false;
        }
        const isDragEvent = event.type.startsWith('drag');
        const isDropEvent = event.type === 'drop';
        const isInput = ['INPUT', 'BUTTON', 'SELECT', 'TEXTAREA'].includes(target.tagName) || target.isContentEditable;
        // any input event within node views should be ignored by ProseMirror
        if (isInput && !isDropEvent && !isDragEvent) {
            return true;
        }
        const { isEditable } = this.editor;
        const { isDragging } = this;
        const isDraggable = !!this.node.type.spec.draggable;
        const isSelectable = state.NodeSelection.isSelectable(this.node);
        const isCopyEvent = event.type === 'copy';
        const isPasteEvent = event.type === 'paste';
        const isCutEvent = event.type === 'cut';
        const isClickEvent = event.type === 'mousedown';
        // ProseMirror tries to drag selectable nodes
        // even if `draggable` is set to `false`
        // this fix prevents that
        if (!isDraggable && isSelectable && isDragEvent && event.target === this.dom) {
            event.preventDefault();
        }
        if (isDraggable && isDragEvent && !isDragging && event.target === this.dom) {
            event.preventDefault();
            return false;
        }
        // we have to store that dragging started
        if (isDraggable && isEditable && !isDragging && isClickEvent) {
            const dragHandle = target.closest('[data-drag-handle]');
            const isValidDragHandle = dragHandle && (this.dom === dragHandle || this.dom.contains(dragHandle));
            if (isValidDragHandle) {
                this.isDragging = true;
                document.addEventListener('dragend', () => {
                    this.isDragging = false;
                }, { once: true });
                document.addEventListener('drop', () => {
                    this.isDragging = false;
                }, { once: true });
                document.addEventListener('mouseup', () => {
                    this.isDragging = false;
                }, { once: true });
            }
        }
        // these events are handled by prosemirror
        if (isDragging
            || isDropEvent
            || isCopyEvent
            || isPasteEvent
            || isCutEvent
            || (isClickEvent && isSelectable)) {
            return false;
        }
        return true;
    }
    /**
     * Called when a DOM [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver) or a selection change happens within the view.
     * @return `false` if the editor should re-read the selection or re-parse the range around the mutation
     * @return `true` if it can safely be ignored.
     */
    ignoreMutation(mutation) {
        if (!this.dom || !this.contentDOM) {
            return true;
        }
        if (typeof this.options.ignoreMutation === 'function') {
            return this.options.ignoreMutation({ mutation });
        }
        // a leaf/atom node is like a black box for ProseMirror
        // and should be fully handled by the node view
        if (this.node.isLeaf || this.node.isAtom) {
            return true;
        }
        // ProseMirror should handle any selections
        if (mutation.type === 'selection') {
            return false;
        }
        // try to prevent a bug on iOS and Android that will break node views on enter
        // this is because ProseMirror can’t preventDispatch on enter
        // this will lead to a re-render of the node view on enter
        // see: https://github.com/ueberdosis/tiptap/issues/1214
        // see: https://github.com/ueberdosis/tiptap/issues/2534
        if (this.dom.contains(mutation.target)
            && mutation.type === 'childList'
            && (isiOS() || isAndroid())
            && this.editor.isFocused) {
            const changedNodes = [
                ...Array.from(mutation.addedNodes),
                ...Array.from(mutation.removedNodes),
            ];
            // we’ll check if every changed node is contentEditable
            // to make sure it’s probably mutated by ProseMirror
            if (changedNodes.every(node => node.isContentEditable)) {
                return false;
            }
        }
        // we will allow mutation contentDOM with attributes
        // so we can for example adding classes within our node view
        if (this.contentDOM === mutation.target && mutation.type === 'attributes') {
            return true;
        }
        // ProseMirror should handle any changes within contentDOM
        if (this.contentDOM.contains(mutation.target)) {
            return false;
        }
        return true;
    }
    /**
     * Update the attributes of the prosemirror node.
     */
    updateAttributes(attributes) {
        this.editor.commands.command(({ tr }) => {
            const pos = this.getPos();
            if (typeof pos !== 'number') {
                return false;
            }
            tr.setNodeMarkup(pos, undefined, {
                ...this.node.attrs,
                ...attributes,
            });
            return true;
        });
    }
    /**
     * Delete the node.
     */
    deleteNode() {
        const from = this.getPos();
        if (typeof from !== 'number') {
            return;
        }
        const to = from + this.node.nodeSize;
        this.editor.commands.deleteRange({ from, to });
    }
}

/**
 * Build an paste rule that adds a mark when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */
function markPasteRule(config) {
    return new PasteRule({
        find: config.find,
        handler: ({ state, range, match, pasteEvent, }) => {
            const attributes = callOrReturn(config.getAttributes, undefined, match, pasteEvent);
            if (attributes === false || attributes === null) {
                return null;
            }
            const { tr } = state;
            const captureGroup = match[match.length - 1];
            const fullMatch = match[0];
            let markEnd = range.to;
            if (captureGroup) {
                const startSpaces = fullMatch.search(/\S/);
                const textStart = range.from + fullMatch.indexOf(captureGroup);
                const textEnd = textStart + captureGroup.length;
                const excludedMarks = getMarksBetween(range.from, range.to, state.doc)
                    .filter(item => {
                    // @ts-ignore
                    const excluded = item.mark.type.excluded;
                    return excluded.find(type => type === config.type && type !== item.mark.type);
                })
                    .filter(item => item.to > textStart);
                if (excludedMarks.length) {
                    return null;
                }
                if (textEnd < range.to) {
                    tr.delete(textEnd, range.to);
                }
                if (textStart > range.from) {
                    tr.delete(range.from + startSpaces, textStart);
                }
                markEnd = range.from + startSpaces + captureGroup.length;
                tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
                tr.removeStoredMark(config.type);
            }
        },
    });
}

function canInsertNode(state$1, nodeType) {
    const { selection } = state$1;
    const { $from } = selection;
    // Special handling for NodeSelection
    if (selection instanceof state.NodeSelection) {
        const index = $from.index();
        const parent = $from.parent;
        // Can we replace the selected node with the horizontal rule?
        return parent.canReplaceWith(index, index + 1, nodeType);
    }
    // Default: check if we can insert at the current position
    let depth = $from.depth;
    while (depth >= 0) {
        const index = $from.index(depth);
        const parent = $from.node(depth);
        const match = parent.contentMatchAt(index);
        if (match.matchType(nodeType)) {
            return true;
        }
        depth -= 1;
    }
    return false;
}

// source: https://stackoverflow.com/a/6969486
function escapeForRegEx(string) {
    return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}

function isString(value) {
    return typeof value === 'string';
}

/**
 * Build an paste rule that adds a node when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */
function nodePasteRule(config) {
    return new PasteRule({
        find: config.find,
        handler({ match, chain, range, pasteEvent, }) {
            const attributes = callOrReturn(config.getAttributes, undefined, match, pasteEvent);
            const content = callOrReturn(config.getContent, undefined, attributes);
            if (attributes === false || attributes === null) {
                return null;
            }
            const node = { type: config.type.name, attrs: attributes };
            if (content) {
                node.content = content;
            }
            if (match.input) {
                chain().deleteRange(range).insertContentAt(range.from, node);
            }
        },
    });
}

/**
 * Build an paste rule that replaces text when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */
function textPasteRule(config) {
    return new PasteRule({
        find: config.find,
        handler: ({ state, range, match }) => {
            let insert = config.replace;
            let start = range.from;
            const end = range.to;
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                insert += match[0].slice(offset + match[1].length);
                start += offset;
                const cutOff = start - end;
                if (cutOff > 0) {
                    insert = match[0].slice(offset - cutOff, offset) + insert;
                    start = end;
                }
            }
            state.tr.insertText(insert, start, end);
        },
    });
}

class Tracker {
    constructor(transaction) {
        this.transaction = transaction;
        this.currentStep = this.transaction.steps.length;
    }
    map(position) {
        let deleted = false;
        const mappedPosition = this.transaction.steps
            .slice(this.currentStep)
            .reduce((newPosition, step) => {
            const mapResult = step.getMap().mapResult(newPosition);
            if (mapResult.deleted) {
                deleted = true;
            }
            return mapResult.pos;
        }, position);
        return {
            position: mappedPosition,
            deleted,
        };
    }
}

exports.CommandManager = CommandManager;
exports.Editor = Editor;
exports.Extension = Extension;
exports.InputRule = InputRule;
exports.Mark = Mark;
exports.Node = Node;
exports.NodePos = NodePos;
exports.NodeView = NodeView;
exports.PasteRule = PasteRule;
exports.Tracker = Tracker;
exports.callOrReturn = callOrReturn;
exports.canInsertNode = canInsertNode;
exports.combineTransactionSteps = combineTransactionSteps;
exports.createChainableState = createChainableState;
exports.createDocument = createDocument;
exports.createNodeFromContent = createNodeFromContent;
exports.createStyleTag = createStyleTag;
exports.defaultBlockAt = defaultBlockAt;
exports.deleteProps = deleteProps;
exports.elementFromString = elementFromString;
exports.escapeForRegEx = escapeForRegEx;
exports.extensions = index;
exports.findChildren = findChildren;
exports.findChildrenInRange = findChildrenInRange;
exports.findDuplicates = findDuplicates;
exports.findParentNode = findParentNode;
exports.findParentNodeClosestToPos = findParentNodeClosestToPos;
exports.fromString = fromString;
exports.generateHTML = generateHTML;
exports.generateJSON = generateJSON;
exports.generateText = generateText;
exports.getAttributes = getAttributes;
exports.getAttributesFromExtensions = getAttributesFromExtensions;
exports.getChangedRanges = getChangedRanges;
exports.getDebugJSON = getDebugJSON;
exports.getExtensionField = getExtensionField;
exports.getHTMLFromFragment = getHTMLFromFragment;
exports.getMarkAttributes = getMarkAttributes;
exports.getMarkRange = getMarkRange;
exports.getMarkType = getMarkType;
exports.getMarksBetween = getMarksBetween;
exports.getNodeAtPosition = getNodeAtPosition;
exports.getNodeAttributes = getNodeAttributes;
exports.getNodeType = getNodeType;
exports.getRenderedAttributes = getRenderedAttributes;
exports.getSchema = getSchema;
exports.getSchemaByResolvedExtensions = getSchemaByResolvedExtensions;
exports.getSchemaTypeByName = getSchemaTypeByName;
exports.getSchemaTypeNameByName = getSchemaTypeNameByName;
exports.getSplittedAttributes = getSplittedAttributes;
exports.getText = getText;
exports.getTextBetween = getTextBetween;
exports.getTextContentFromNodes = getTextContentFromNodes;
exports.getTextSerializersFromSchema = getTextSerializersFromSchema;
exports.injectExtensionAttributesToParseRule = injectExtensionAttributesToParseRule;
exports.inputRulesPlugin = inputRulesPlugin;
exports.isActive = isActive;
exports.isAtEndOfNode = isAtEndOfNode;
exports.isAtStartOfNode = isAtStartOfNode;
exports.isEmptyObject = isEmptyObject;
exports.isExtensionRulesEnabled = isExtensionRulesEnabled;
exports.isFunction = isFunction;
exports.isList = isList;
exports.isMacOS = isMacOS;
exports.isMarkActive = isMarkActive;
exports.isNodeActive = isNodeActive;
exports.isNodeEmpty = isNodeEmpty;
exports.isNodeSelection = isNodeSelection;
exports.isNumber = isNumber;
exports.isPlainObject = isPlainObject;
exports.isRegExp = isRegExp;
exports.isString = isString;
exports.isTextSelection = isTextSelection;
exports.isiOS = isiOS;
exports.markInputRule = markInputRule;
exports.markPasteRule = markPasteRule;
exports.mergeAttributes = mergeAttributes;
exports.mergeDeep = mergeDeep;
exports.minMax = minMax;
exports.nodeInputRule = nodeInputRule;
exports.nodePasteRule = nodePasteRule;
exports.objectIncludes = objectIncludes;
exports.pasteRulesPlugin = pasteRulesPlugin;
exports.posToDOMRect = posToDOMRect;
exports.removeDuplicates = removeDuplicates;
exports.resolveFocusPosition = resolveFocusPosition;
exports.rewriteUnknownContent = rewriteUnknownContent;
exports.selectionToInsertionEnd = selectionToInsertionEnd;
exports.splitExtensions = splitExtensions;
exports.textInputRule = textInputRule;
exports.textPasteRule = textPasteRule;
exports.textblockTypeInputRule = textblockTypeInputRule;
exports.wrappingInputRule = wrappingInputRule;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 32707:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * Matches a blockquote to a `>` as input.
 */
const inputRegex = /^\s*>\s$/;
/**
 * This extension allows you to create blockquotes.
 * @see https://tiptap.dev/api/nodes/blockquote
 */
const Blockquote = core.Node.create({
    name: 'blockquote',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    content: 'block+',
    group: 'block',
    defining: true,
    parseHTML() {
        return [
            { tag: 'blockquote' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['blockquote', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setBlockquote: () => ({ commands }) => {
                return commands.wrapIn(this.name);
            },
            toggleBlockquote: () => ({ commands }) => {
                return commands.toggleWrap(this.name);
            },
            unsetBlockquote: () => ({ commands }) => {
                return commands.lift(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-b': () => this.editor.commands.toggleBlockquote(),
        };
    },
    addInputRules() {
        return [
            core.wrappingInputRule({
                find: inputRegex,
                type: this.type,
            }),
        ];
    },
});

exports.Blockquote = Blockquote;
exports["default"] = Blockquote;
exports.inputRegex = inputRegex;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 65208:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * Matches bold text via `**` as input.
 */
const starInputRegex = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/;
/**
 * Matches bold text via `**` while pasting.
 */
const starPasteRegex = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g;
/**
 * Matches bold text via `__` as input.
 */
const underscoreInputRegex = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/;
/**
 * Matches bold text via `__` while pasting.
 */
const underscorePasteRegex = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g;
/**
 * This extension allows you to mark text as bold.
 * @see https://tiptap.dev/api/marks/bold
 */
const Bold = core.Mark.create({
    name: 'bold',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 'strong',
            },
            {
                tag: 'b',
                getAttrs: node => node.style.fontWeight !== 'normal' && null,
            },
            {
                style: 'font-weight=400',
                clearMark: mark => mark.type.name === this.name,
            },
            {
                style: 'font-weight',
                getAttrs: value => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['strong', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setBold: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleBold: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetBold: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-b': () => this.editor.commands.toggleBold(),
            'Mod-B': () => this.editor.commands.toggleBold(),
        };
    },
    addInputRules() {
        return [
            core.markInputRule({
                find: starInputRegex,
                type: this.type,
            }),
            core.markInputRule({
                find: underscoreInputRegex,
                type: this.type,
            }),
        ];
    },
    addPasteRules() {
        return [
            core.markPasteRule({
                find: starPasteRegex,
                type: this.type,
            }),
            core.markPasteRule({
                find: underscorePasteRegex,
                type: this.type,
            }),
        ];
    },
});

exports.Bold = Bold;
exports["default"] = Bold;
exports.starInputRegex = starInputRegex;
exports.starPasteRegex = starPasteRegex;
exports.underscoreInputRegex = underscoreInputRegex;
exports.underscorePasteRegex = underscorePasteRegex;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 9330:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);
var state = __webpack_require__(96297);
var tippy = __webpack_require__(39974);

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var tippy__default = /*#__PURE__*/_interopDefaultCompat(tippy);

class BubbleMenuView {
    constructor({ editor, element, view, tippyOptions = {}, updateDelay = 250, shouldShow, }) {
        this.preventHide = false;
        this.shouldShow = ({ view, state, from, to, }) => {
            const { doc, selection } = state;
            const { empty } = selection;
            // Sometime check for `empty` is not enough.
            // Doubleclick an empty paragraph returns a node size of 2.
            // So we check also for an empty text size.
            const isEmptyTextBlock = !doc.textBetween(from, to).length && core.isTextSelection(state.selection);
            // When clicking on a element inside the bubble menu the editor "blur" event
            // is called and the bubble menu item is focussed. In this case we should
            // consider the menu as part of the editor and keep showing the menu
            const isChildOfMenu = this.element.contains(document.activeElement);
            const hasEditorFocus = view.hasFocus() || isChildOfMenu;
            if (!hasEditorFocus || empty || isEmptyTextBlock || !this.editor.isEditable) {
                return false;
            }
            return true;
        };
        this.mousedownHandler = () => {
            this.preventHide = true;
        };
        this.dragstartHandler = () => {
            this.hide();
        };
        this.focusHandler = () => {
            // we use `setTimeout` to make sure `selection` is already updated
            setTimeout(() => this.update(this.editor.view));
        };
        this.blurHandler = ({ event }) => {
            var _a;
            if (this.preventHide) {
                this.preventHide = false;
                return;
            }
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget) && ((_a = this.element.parentNode) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) {
                return;
            }
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget) === this.editor.view.dom) {
                return;
            }
            this.hide();
        };
        this.tippyBlurHandler = (event) => {
            this.blurHandler({ event });
        };
        this.handleDebouncedUpdate = (view, oldState) => {
            const selectionChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.selection.eq(view.state.selection));
            const docChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.doc.eq(view.state.doc));
            if (!selectionChanged && !docChanged) {
                return;
            }
            if (this.updateDebounceTimer) {
                clearTimeout(this.updateDebounceTimer);
            }
            this.updateDebounceTimer = window.setTimeout(() => {
                this.updateHandler(view, selectionChanged, docChanged, oldState);
            }, this.updateDelay);
        };
        this.updateHandler = (view, selectionChanged, docChanged, oldState) => {
            var _a, _b, _c;
            const { state, composing } = view;
            const { selection } = state;
            const isSame = !selectionChanged && !docChanged;
            if (composing || isSame) {
                return;
            }
            this.createTooltip();
            // support for CellSelections
            const { ranges } = selection;
            const from = Math.min(...ranges.map(range => range.$from.pos));
            const to = Math.max(...ranges.map(range => range.$to.pos));
            const shouldShow = (_a = this.shouldShow) === null || _a === void 0 ? void 0 : _a.call(this, {
                editor: this.editor,
                element: this.element,
                view,
                state,
                oldState,
                from,
                to,
            });
            if (!shouldShow) {
                this.hide();
                return;
            }
            (_b = this.tippy) === null || _b === void 0 ? void 0 : _b.setProps({
                getReferenceClientRect: ((_c = this.tippyOptions) === null || _c === void 0 ? void 0 : _c.getReferenceClientRect)
                    || (() => {
                        if (core.isNodeSelection(state.selection)) {
                            let node = view.nodeDOM(from);
                            if (node) {
                                const nodeViewWrapper = node.dataset.nodeViewWrapper ? node : node.querySelector('[data-node-view-wrapper]');
                                if (nodeViewWrapper) {
                                    node = nodeViewWrapper.firstChild;
                                }
                                if (node) {
                                    return node.getBoundingClientRect();
                                }
                            }
                        }
                        return core.posToDOMRect(view, from, to);
                    }),
            });
            this.show();
        };
        this.editor = editor;
        this.element = element;
        this.view = view;
        this.updateDelay = updateDelay;
        if (shouldShow) {
            this.shouldShow = shouldShow;
        }
        this.element.addEventListener('mousedown', this.mousedownHandler, { capture: true });
        this.view.dom.addEventListener('dragstart', this.dragstartHandler);
        this.editor.on('focus', this.focusHandler);
        this.editor.on('blur', this.blurHandler);
        this.tippyOptions = tippyOptions;
        // Detaches menu content from its current parent
        this.element.remove();
        this.element.style.visibility = 'visible';
    }
    createTooltip() {
        const { element: editorElement } = this.editor.options;
        const editorIsAttached = !!editorElement.parentElement;
        this.element.tabIndex = 0;
        if (this.tippy || !editorIsAttached) {
            return;
        }
        this.tippy = tippy__default.default(editorElement, {
            duration: 0,
            getReferenceClientRect: null,
            content: this.element,
            interactive: true,
            trigger: 'manual',
            placement: 'top',
            hideOnClick: 'toggle',
            ...this.tippyOptions,
        });
        // maybe we have to hide tippy on its own blur event as well
        if (this.tippy.popper.firstChild) {
            this.tippy.popper.firstChild.addEventListener('blur', this.tippyBlurHandler);
        }
    }
    update(view, oldState) {
        const { state } = view;
        const hasValidSelection = state.selection.from !== state.selection.to;
        if (this.updateDelay > 0 && hasValidSelection) {
            this.handleDebouncedUpdate(view, oldState);
            return;
        }
        const selectionChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.selection.eq(view.state.selection));
        const docChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.doc.eq(view.state.doc));
        this.updateHandler(view, selectionChanged, docChanged, oldState);
    }
    show() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.show();
    }
    hide() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.hide();
    }
    destroy() {
        var _a, _b;
        if ((_a = this.tippy) === null || _a === void 0 ? void 0 : _a.popper.firstChild) {
            this.tippy.popper.firstChild.removeEventListener('blur', this.tippyBlurHandler);
        }
        (_b = this.tippy) === null || _b === void 0 ? void 0 : _b.destroy();
        this.element.removeEventListener('mousedown', this.mousedownHandler, { capture: true });
        this.view.dom.removeEventListener('dragstart', this.dragstartHandler);
        this.editor.off('focus', this.focusHandler);
        this.editor.off('blur', this.blurHandler);
    }
}
const BubbleMenuPlugin = (options) => {
    return new state.Plugin({
        key: typeof options.pluginKey === 'string' ? new state.PluginKey(options.pluginKey) : options.pluginKey,
        view: view => new BubbleMenuView({ view, ...options }),
    });
};

/**
 * This extension allows you to create a bubble menu.
 * @see https://tiptap.dev/api/extensions/bubble-menu
 */
const BubbleMenu = core.Extension.create({
    name: 'bubbleMenu',
    addOptions() {
        return {
            element: null,
            tippyOptions: {},
            pluginKey: 'bubbleMenu',
            updateDelay: undefined,
            shouldShow: null,
        };
    },
    addProseMirrorPlugins() {
        if (!this.options.element) {
            return [];
        }
        return [
            BubbleMenuPlugin({
                pluginKey: this.options.pluginKey,
                editor: this.editor,
                element: this.options.element,
                tippyOptions: this.options.tippyOptions,
                updateDelay: this.options.updateDelay,
                shouldShow: this.options.shouldShow,
            }),
        ];
    },
});

exports.BubbleMenu = BubbleMenu;
exports.BubbleMenuPlugin = BubbleMenuPlugin;
exports.BubbleMenuView = BubbleMenuView;
exports["default"] = BubbleMenu;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 74053:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

const ListItemName = 'listItem';
const TextStyleName = 'textStyle';
/**
 * Matches a bullet list to a dash or asterisk.
 */
const inputRegex = /^\s*([-+*])\s$/;
/**
 * This extension allows you to create bullet lists.
 * This requires the ListItem extension
 * @see https://tiptap.dev/api/nodes/bullet-list
 * @see https://tiptap.dev/api/nodes/list-item.
 */
const BulletList = core.Node.create({
    name: 'bulletList',
    addOptions() {
        return {
            itemTypeName: 'listItem',
            HTMLAttributes: {},
            keepMarks: false,
            keepAttributes: false,
        };
    },
    group: 'block list',
    content() {
        return `${this.options.itemTypeName}+`;
    },
    parseHTML() {
        return [
            { tag: 'ul' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['ul', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            toggleBulletList: () => ({ commands, chain }) => {
                if (this.options.keepAttributes) {
                    return chain().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(ListItemName, this.editor.getAttributes(TextStyleName)).run();
                }
                return commands.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-8': () => this.editor.commands.toggleBulletList(),
        };
    },
    addInputRules() {
        let inputRule = core.wrappingInputRule({
            find: inputRegex,
            type: this.type,
        });
        if (this.options.keepMarks || this.options.keepAttributes) {
            inputRule = core.wrappingInputRule({
                find: inputRegex,
                type: this.type,
                keepMarks: this.options.keepMarks,
                keepAttributes: this.options.keepAttributes,
                getAttributes: () => { return this.editor.getAttributes(TextStyleName); },
                editor: this.editor,
            });
        }
        return [
            inputRule,
        ];
    },
});

exports.BulletList = BulletList;
exports["default"] = BulletList;
exports.inputRegex = inputRegex;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 74582:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);
var state = __webpack_require__(96297);

/**
 * Matches a code block with backticks.
 */
const backtickInputRegex = /^```([a-z]+)?[\s\n]$/;
/**
 * Matches a code block with tildes.
 */
const tildeInputRegex = /^~~~([a-z]+)?[\s\n]$/;
/**
 * This extension allows you to create code blocks.
 * @see https://tiptap.dev/api/nodes/code-block
 */
const CodeBlock = core.Node.create({
    name: 'codeBlock',
    addOptions() {
        return {
            languageClassPrefix: 'language-',
            exitOnTripleEnter: true,
            exitOnArrowDown: true,
            defaultLanguage: null,
            HTMLAttributes: {},
        };
    },
    content: 'text*',
    marks: '',
    group: 'block',
    code: true,
    defining: true,
    addAttributes() {
        return {
            language: {
                default: this.options.defaultLanguage,
                parseHTML: element => {
                    var _a;
                    const { languageClassPrefix } = this.options;
                    const classNames = [...(((_a = element.firstElementChild) === null || _a === void 0 ? void 0 : _a.classList) || [])];
                    const languages = classNames
                        .filter(className => className.startsWith(languageClassPrefix))
                        .map(className => className.replace(languageClassPrefix, ''));
                    const language = languages[0];
                    if (!language) {
                        return null;
                    }
                    return language;
                },
                rendered: false,
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'pre',
                preserveWhitespace: 'full',
            },
        ];
    },
    renderHTML({ node, HTMLAttributes }) {
        return [
            'pre',
            core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
            [
                'code',
                {
                    class: node.attrs.language
                        ? this.options.languageClassPrefix + node.attrs.language
                        : null,
                },
                0,
            ],
        ];
    },
    addCommands() {
        return {
            setCodeBlock: attributes => ({ commands }) => {
                return commands.setNode(this.name, attributes);
            },
            toggleCodeBlock: attributes => ({ commands }) => {
                return commands.toggleNode(this.name, 'paragraph', attributes);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Alt-c': () => this.editor.commands.toggleCodeBlock(),
            // remove code block when at start of document or code block is empty
            Backspace: () => {
                const { empty, $anchor } = this.editor.state.selection;
                const isAtStart = $anchor.pos === 1;
                if (!empty || $anchor.parent.type.name !== this.name) {
                    return false;
                }
                if (isAtStart || !$anchor.parent.textContent.length) {
                    return this.editor.commands.clearNodes();
                }
                return false;
            },
            // exit node on triple enter
            Enter: ({ editor }) => {
                if (!this.options.exitOnTripleEnter) {
                    return false;
                }
                const { state } = editor;
                const { selection } = state;
                const { $from, empty } = selection;
                if (!empty || $from.parent.type !== this.type) {
                    return false;
                }
                const isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;
                const endsWithDoubleNewline = $from.parent.textContent.endsWith('\n\n');
                if (!isAtEnd || !endsWithDoubleNewline) {
                    return false;
                }
                return editor
                    .chain()
                    .command(({ tr }) => {
                    tr.delete($from.pos - 2, $from.pos);
                    return true;
                })
                    .exitCode()
                    .run();
            },
            // exit node on arrow down
            ArrowDown: ({ editor }) => {
                if (!this.options.exitOnArrowDown) {
                    return false;
                }
                const { state: state$1 } = editor;
                const { selection, doc } = state$1;
                const { $from, empty } = selection;
                if (!empty || $from.parent.type !== this.type) {
                    return false;
                }
                const isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;
                if (!isAtEnd) {
                    return false;
                }
                const after = $from.after();
                if (after === undefined) {
                    return false;
                }
                const nodeAfter = doc.nodeAt(after);
                if (nodeAfter) {
                    return editor.commands.command(({ tr }) => {
                        tr.setSelection(state.Selection.near(doc.resolve(after)));
                        return true;
                    });
                }
                return editor.commands.exitCode();
            },
        };
    },
    addInputRules() {
        return [
            core.textblockTypeInputRule({
                find: backtickInputRegex,
                type: this.type,
                getAttributes: match => ({
                    language: match[1],
                }),
            }),
            core.textblockTypeInputRule({
                find: tildeInputRegex,
                type: this.type,
                getAttributes: match => ({
                    language: match[1],
                }),
            }),
        ];
    },
    addProseMirrorPlugins() {
        return [
            // this plugin creates a code block for pasted content from VS Code
            // we can also detect the copied code language
            new state.Plugin({
                key: new state.PluginKey('codeBlockVSCodeHandler'),
                props: {
                    handlePaste: (view, event) => {
                        if (!event.clipboardData) {
                            return false;
                        }
                        // don’t create a new code block within code blocks
                        if (this.editor.isActive(this.type.name)) {
                            return false;
                        }
                        const text = event.clipboardData.getData('text/plain');
                        const vscode = event.clipboardData.getData('vscode-editor-data');
                        const vscodeData = vscode ? JSON.parse(vscode) : undefined;
                        const language = vscodeData === null || vscodeData === void 0 ? void 0 : vscodeData.mode;
                        if (!text || !language) {
                            return false;
                        }
                        const { tr, schema } = view.state;
                        // prepare a text node
                        // strip carriage return chars from text pasted as code
                        // see: https://github.com/ProseMirror/prosemirror-view/commit/a50a6bcceb4ce52ac8fcc6162488d8875613aacd
                        const textNode = schema.text(text.replace(/\r\n?/g, '\n'));
                        // create a code block with the text node
                        // replace selection with the code block
                        tr.replaceSelectionWith(this.type.create({ language }, textNode));
                        if (tr.selection.$from.parent.type !== this.type) {
                            // put cursor inside the newly created code block
                            tr.setSelection(state.TextSelection.near(tr.doc.resolve(Math.max(0, tr.selection.from - 2))));
                        }
                        // store meta information
                        // this is useful for other plugins that depends on the paste event
                        // like the paste rule plugin
                        tr.setMeta('paste', true);
                        view.dispatch(tr);
                        return true;
                    },
                },
            }),
        ];
    },
});

exports.CodeBlock = CodeBlock;
exports.backtickInputRegex = backtickInputRegex;
exports["default"] = CodeBlock;
exports.tildeInputRegex = tildeInputRegex;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 40669:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * Regular expressions to match inline code blocks enclosed in backticks.
 *  It matches:
 *     - An opening backtick, followed by
 *     - Any text that doesn't include a backtick (captured for marking), followed by
 *     - A closing backtick.
 *  This ensures that any text between backticks is formatted as code,
 *  regardless of the surrounding characters (exception being another backtick).
 */
const inputRegex = /(^|[^`])`([^`]+)`(?!`)/;
/**
 * Matches inline code while pasting.
 */
const pasteRegex = /(^|[^`])`([^`]+)`(?!`)/g;
/**
 * This extension allows you to mark text as inline code.
 * @see https://tiptap.dev/api/marks/code
 */
const Code = core.Mark.create({
    name: 'code',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    excludes: '_',
    code: true,
    exitable: true,
    parseHTML() {
        return [
            { tag: 'code' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['code', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setCode: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleCode: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetCode: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-e': () => this.editor.commands.toggleCode(),
        };
    },
    addInputRules() {
        return [
            core.markInputRule({
                find: inputRegex,
                type: this.type,
            }),
        ];
    },
    addPasteRules() {
        return [
            core.markPasteRule({
                find: pasteRegex,
                type: this.type,
            }),
        ];
    },
});

exports.Code = Code;
exports["default"] = Code;
exports.inputRegex = inputRegex;
exports.pasteRegex = pasteRegex;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 10934:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

__webpack_require__(4412);
var core = __webpack_require__(60148);

/**
 * This extension allows you to color your text.
 * @see https://tiptap.dev/api/extensions/color
 */
const Color = core.Extension.create({
    name: 'color',
    addOptions() {
        return {
            types: ['textStyle'],
        };
    },
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    color: {
                        default: null,
                        parseHTML: element => { var _a; return (_a = element.style.color) === null || _a === void 0 ? void 0 : _a.replace(/['"]+/g, ''); },
                        renderHTML: attributes => {
                            if (!attributes.color) {
                                return {};
                            }
                            return {
                                style: `color: ${attributes.color}`,
                            };
                        },
                    },
                },
            },
        ];
    },
    addCommands() {
        return {
            setColor: color => ({ chain }) => {
                return chain()
                    .setMark('textStyle', { color })
                    .run();
            },
            unsetColor: () => ({ chain }) => {
                return chain()
                    .setMark('textStyle', { color: null })
                    .removeEmptyTextStyle()
                    .run();
            },
        };
    },
});

exports.Color = Color;
exports["default"] = Color;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 92419:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * The default document node which represents the top level node of the editor.
 * @see https://tiptap.dev/api/nodes/document
 */
const Document = core.Node.create({
    name: 'doc',
    topNode: true,
    content: 'block+',
});

exports.Document = Document;
exports["default"] = Document;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 16000:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);
var dropcursor = __webpack_require__(42199);

/**
 * This extension allows you to add a drop cursor to your editor.
 * A drop cursor is a line that appears when you drag and drop content
 * inbetween nodes.
 * @see https://tiptap.dev/api/extensions/dropcursor
 */
const Dropcursor = core.Extension.create({
    name: 'dropCursor',
    addOptions() {
        return {
            color: 'currentColor',
            width: 1,
            class: undefined,
        };
    },
    addProseMirrorPlugins() {
        return [
            dropcursor.dropCursor(this.options),
        ];
    },
});

exports.Dropcursor = Dropcursor;
exports["default"] = Dropcursor;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 66836:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);
var state = __webpack_require__(96297);
var tippy = __webpack_require__(39974);

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var tippy__default = /*#__PURE__*/_interopDefaultCompat(tippy);

class FloatingMenuView {
    getTextContent(node) {
        return core.getText(node, { textSerializers: core.getTextSerializersFromSchema(this.editor.schema) });
    }
    constructor({ editor, element, view, tippyOptions = {}, shouldShow, }) {
        this.preventHide = false;
        this.shouldShow = ({ view, state }) => {
            const { selection } = state;
            const { $anchor, empty } = selection;
            const isRootDepth = $anchor.depth === 1;
            const isEmptyTextBlock = $anchor.parent.isTextblock && !$anchor.parent.type.spec.code && !$anchor.parent.textContent && $anchor.parent.childCount === 0 && !this.getTextContent($anchor.parent);
            if (!view.hasFocus()
                || !empty
                || !isRootDepth
                || !isEmptyTextBlock
                || !this.editor.isEditable) {
                return false;
            }
            return true;
        };
        this.mousedownHandler = () => {
            this.preventHide = true;
        };
        this.focusHandler = () => {
            // we use `setTimeout` to make sure `selection` is already updated
            setTimeout(() => this.update(this.editor.view));
        };
        this.blurHandler = ({ event }) => {
            var _a;
            if (this.preventHide) {
                this.preventHide = false;
                return;
            }
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget) && ((_a = this.element.parentNode) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) {
                return;
            }
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget) === this.editor.view.dom) {
                return;
            }
            this.hide();
        };
        this.tippyBlurHandler = (event) => {
            this.blurHandler({ event });
        };
        this.editor = editor;
        this.element = element;
        this.view = view;
        if (shouldShow) {
            this.shouldShow = shouldShow;
        }
        this.element.addEventListener('mousedown', this.mousedownHandler, { capture: true });
        this.editor.on('focus', this.focusHandler);
        this.editor.on('blur', this.blurHandler);
        this.tippyOptions = tippyOptions;
        // Detaches menu content from its current parent
        this.element.remove();
        this.element.style.visibility = 'visible';
    }
    createTooltip() {
        const { element: editorElement } = this.editor.options;
        const editorIsAttached = !!editorElement.parentElement;
        this.element.tabIndex = 0;
        if (this.tippy || !editorIsAttached) {
            return;
        }
        this.tippy = tippy__default.default(editorElement, {
            duration: 0,
            getReferenceClientRect: null,
            content: this.element,
            interactive: true,
            trigger: 'manual',
            placement: 'right',
            hideOnClick: 'toggle',
            ...this.tippyOptions,
        });
        // maybe we have to hide tippy on its own blur event as well
        if (this.tippy.popper.firstChild) {
            this.tippy.popper.firstChild.addEventListener('blur', this.tippyBlurHandler);
        }
    }
    update(view, oldState) {
        var _a, _b, _c;
        const { state } = view;
        const { doc, selection } = state;
        const { from, to } = selection;
        const isSame = oldState && oldState.doc.eq(doc) && oldState.selection.eq(selection);
        if (isSame) {
            return;
        }
        this.createTooltip();
        const shouldShow = (_a = this.shouldShow) === null || _a === void 0 ? void 0 : _a.call(this, {
            editor: this.editor,
            view,
            state,
            oldState,
        });
        if (!shouldShow) {
            this.hide();
            return;
        }
        (_b = this.tippy) === null || _b === void 0 ? void 0 : _b.setProps({
            getReferenceClientRect: ((_c = this.tippyOptions) === null || _c === void 0 ? void 0 : _c.getReferenceClientRect) || (() => core.posToDOMRect(view, from, to)),
        });
        this.show();
    }
    show() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.show();
    }
    hide() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.hide();
    }
    destroy() {
        var _a, _b;
        if ((_a = this.tippy) === null || _a === void 0 ? void 0 : _a.popper.firstChild) {
            this.tippy.popper.firstChild.removeEventListener('blur', this.tippyBlurHandler);
        }
        (_b = this.tippy) === null || _b === void 0 ? void 0 : _b.destroy();
        this.element.removeEventListener('mousedown', this.mousedownHandler, { capture: true });
        this.editor.off('focus', this.focusHandler);
        this.editor.off('blur', this.blurHandler);
    }
}
const FloatingMenuPlugin = (options) => {
    return new state.Plugin({
        key: typeof options.pluginKey === 'string' ? new state.PluginKey(options.pluginKey) : options.pluginKey,
        view: view => new FloatingMenuView({ view, ...options }),
    });
};

/**
 * This extension allows you to create a floating menu.
 * @see https://tiptap.dev/api/extensions/floating-menu
 */
const FloatingMenu = core.Extension.create({
    name: 'floatingMenu',
    addOptions() {
        return {
            element: null,
            tippyOptions: {},
            pluginKey: 'floatingMenu',
            shouldShow: null,
        };
    },
    addProseMirrorPlugins() {
        if (!this.options.element) {
            return [];
        }
        return [
            FloatingMenuPlugin({
                pluginKey: this.options.pluginKey,
                editor: this.editor,
                element: this.options.element,
                tippyOptions: this.options.tippyOptions,
                shouldShow: this.options.shouldShow,
            }),
        ];
    },
});

exports.FloatingMenu = FloatingMenu;
exports.FloatingMenuPlugin = FloatingMenuPlugin;
exports.FloatingMenuView = FloatingMenuView;
exports["default"] = FloatingMenu;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 24724:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

__webpack_require__(4412);
var core = __webpack_require__(60148);

/**
 * This extension allows you to set a font family for text.
 * @see https://www.tiptap.dev/api/extensions/font-family
 */
const FontFamily = core.Extension.create({
    name: 'fontFamily',
    addOptions() {
        return {
            types: ['textStyle'],
        };
    },
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    fontFamily: {
                        default: null,
                        parseHTML: element => element.style.fontFamily,
                        renderHTML: attributes => {
                            if (!attributes.fontFamily) {
                                return {};
                            }
                            return {
                                style: `font-family: ${attributes.fontFamily}`,
                            };
                        },
                    },
                },
            },
        ];
    },
    addCommands() {
        return {
            setFontFamily: fontFamily => ({ chain }) => {
                return chain()
                    .setMark('textStyle', { fontFamily })
                    .run();
            },
            unsetFontFamily: () => ({ chain }) => {
                return chain()
                    .setMark('textStyle', { fontFamily: null })
                    .removeEmptyTextStyle()
                    .run();
            },
        };
    },
});

exports.FontFamily = FontFamily;
exports["default"] = FontFamily;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 64485:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);
var gapcursor = __webpack_require__(36116);

/**
 * This extension allows you to add a gap cursor to your editor.
 * A gap cursor is a cursor that appears when you click on a place
 * where no content is present, for example inbetween nodes.
 * @see https://tiptap.dev/api/extensions/gapcursor
 */
const Gapcursor = core.Extension.create({
    name: 'gapCursor',
    addProseMirrorPlugins() {
        return [
            gapcursor.gapCursor(),
        ];
    },
    extendNodeSchema(extension) {
        var _a;
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
        };
        return {
            allowGapCursor: (_a = core.callOrReturn(core.getExtensionField(extension, 'allowGapCursor', context))) !== null && _a !== void 0 ? _a : null,
        };
    },
});

exports.Gapcursor = Gapcursor;
exports["default"] = Gapcursor;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 46959:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * This extension allows you to insert hard breaks.
 * @see https://www.tiptap.dev/api/nodes/hard-break
 */
const HardBreak = core.Node.create({
    name: 'hardBreak',
    addOptions() {
        return {
            keepMarks: true,
            HTMLAttributes: {},
        };
    },
    inline: true,
    group: 'inline',
    selectable: false,
    linebreakReplacement: true,
    parseHTML() {
        return [
            { tag: 'br' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['br', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
    },
    renderText() {
        return '\n';
    },
    addCommands() {
        return {
            setHardBreak: () => ({ commands, chain, state, editor, }) => {
                return commands.first([
                    () => commands.exitCode(),
                    () => commands.command(() => {
                        const { selection, storedMarks } = state;
                        if (selection.$from.parent.type.spec.isolating) {
                            return false;
                        }
                        const { keepMarks } = this.options;
                        const { splittableMarks } = editor.extensionManager;
                        const marks = storedMarks
                            || (selection.$to.parentOffset && selection.$from.marks());
                        return chain()
                            .insertContent({ type: this.name })
                            .command(({ tr, dispatch }) => {
                            if (dispatch && marks && keepMarks) {
                                const filteredMarks = marks
                                    .filter(mark => splittableMarks.includes(mark.type.name));
                                tr.ensureMarks(filteredMarks);
                            }
                            return true;
                        })
                            .run();
                    }),
                ]);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Enter': () => this.editor.commands.setHardBreak(),
            'Shift-Enter': () => this.editor.commands.setHardBreak(),
        };
    },
});

exports.HardBreak = HardBreak;
exports["default"] = HardBreak;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 58071:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * This extension allows you to create headings.
 * @see https://www.tiptap.dev/api/nodes/heading
 */
const Heading = core.Node.create({
    name: 'heading',
    addOptions() {
        return {
            levels: [1, 2, 3, 4, 5, 6],
            HTMLAttributes: {},
        };
    },
    content: 'inline*',
    group: 'block',
    defining: true,
    addAttributes() {
        return {
            level: {
                default: 1,
                rendered: false,
            },
        };
    },
    parseHTML() {
        return this.options.levels
            .map((level) => ({
            tag: `h${level}`,
            attrs: { level },
        }));
    },
    renderHTML({ node, HTMLAttributes }) {
        const hasLevel = this.options.levels.includes(node.attrs.level);
        const level = hasLevel
            ? node.attrs.level
            : this.options.levels[0];
        return [`h${level}`, core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setHeading: attributes => ({ commands }) => {
                if (!this.options.levels.includes(attributes.level)) {
                    return false;
                }
                return commands.setNode(this.name, attributes);
            },
            toggleHeading: attributes => ({ commands }) => {
                if (!this.options.levels.includes(attributes.level)) {
                    return false;
                }
                return commands.toggleNode(this.name, 'paragraph', attributes);
            },
        };
    },
    addKeyboardShortcuts() {
        return this.options.levels.reduce((items, level) => ({
            ...items,
            ...{
                [`Mod-Alt-${level}`]: () => this.editor.commands.toggleHeading({ level }),
            },
        }), {});
    },
    addInputRules() {
        return this.options.levels.map(level => {
            return core.textblockTypeInputRule({
                find: new RegExp(`^(#{${Math.min(...this.options.levels)},${level}})\\s$`),
                type: this.type,
                getAttributes: {
                    level,
                },
            });
        });
    },
});

exports.Heading = Heading;
exports["default"] = Heading;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 81800:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * Matches a highlight to a ==highlight== on input.
 */
const inputRegex = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))$/;
/**
 * Matches a highlight to a ==highlight== on paste.
 */
const pasteRegex = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))/g;
/**
 * This extension allows you to highlight text.
 * @see https://www.tiptap.dev/api/marks/highlight
 */
const Highlight = core.Mark.create({
    name: 'highlight',
    addOptions() {
        return {
            multicolor: false,
            HTMLAttributes: {},
        };
    },
    addAttributes() {
        if (!this.options.multicolor) {
            return {};
        }
        return {
            color: {
                default: null,
                parseHTML: element => element.getAttribute('data-color') || element.style.backgroundColor,
                renderHTML: attributes => {
                    if (!attributes.color) {
                        return {};
                    }
                    return {
                        'data-color': attributes.color,
                        style: `background-color: ${attributes.color}; color: inherit`,
                    };
                },
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'mark',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['mark', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setHighlight: attributes => ({ commands }) => {
                return commands.setMark(this.name, attributes);
            },
            toggleHighlight: attributes => ({ commands }) => {
                return commands.toggleMark(this.name, attributes);
            },
            unsetHighlight: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-h': () => this.editor.commands.toggleHighlight(),
        };
    },
    addInputRules() {
        return [
            core.markInputRule({
                find: inputRegex,
                type: this.type,
            }),
        ];
    },
    addPasteRules() {
        return [
            core.markPasteRule({
                find: pasteRegex,
                type: this.type,
            }),
        ];
    },
});

exports.Highlight = Highlight;
exports["default"] = Highlight;
exports.inputRegex = inputRegex;
exports.pasteRegex = pasteRegex;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 9044:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);
var history = __webpack_require__(21858);

/**
 * This extension allows you to undo and redo recent changes.
 * @see https://www.tiptap.dev/api/extensions/history
 *
 * **Important**: If the `@tiptap/extension-collaboration` package is used, make sure to remove
 * the `history` extension, as it is not compatible with the `collaboration` extension.
 *
 * `@tiptap/extension-collaboration` uses its own history implementation.
 */
const History = core.Extension.create({
    name: 'history',
    addOptions() {
        return {
            depth: 100,
            newGroupDelay: 500,
        };
    },
    addCommands() {
        return {
            undo: () => ({ state, dispatch }) => {
                return history.undo(state, dispatch);
            },
            redo: () => ({ state, dispatch }) => {
                return history.redo(state, dispatch);
            },
        };
    },
    addProseMirrorPlugins() {
        return [
            history.history(this.options),
        ];
    },
    addKeyboardShortcuts() {
        return {
            'Mod-z': () => this.editor.commands.undo(),
            'Shift-Mod-z': () => this.editor.commands.redo(),
            'Mod-y': () => this.editor.commands.redo(),
            // Russian keyboard layouts
            'Mod-я': () => this.editor.commands.undo(),
            'Shift-Mod-я': () => this.editor.commands.redo(),
        };
    },
});

exports.History = History;
exports["default"] = History;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 57705:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);
var state = __webpack_require__(96297);

/**
 * This extension allows you to insert horizontal rules.
 * @see https://www.tiptap.dev/api/nodes/horizontal-rule
 */
const HorizontalRule = core.Node.create({
    name: 'horizontalRule',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    group: 'block',
    parseHTML() {
        return [{ tag: 'hr' }];
    },
    renderHTML({ HTMLAttributes }) {
        return ['hr', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
    },
    addCommands() {
        return {
            setHorizontalRule: () => ({ chain, state: state$1 }) => {
                // Check if we can insert the node at the current selection
                if (!core.canInsertNode(state$1, state$1.schema.nodes[this.name])) {
                    return false;
                }
                const { selection } = state$1;
                const { $from: $originFrom, $to: $originTo } = selection;
                const currentChain = chain();
                if ($originFrom.parentOffset === 0) {
                    currentChain.insertContentAt({
                        from: Math.max($originFrom.pos - 1, 0),
                        to: $originTo.pos,
                    }, {
                        type: this.name,
                    });
                }
                else if (core.isNodeSelection(selection)) {
                    currentChain.insertContentAt($originTo.pos, {
                        type: this.name,
                    });
                }
                else {
                    currentChain.insertContent({ type: this.name });
                }
                return (currentChain
                    // set cursor after horizontal rule
                    .command(({ tr, dispatch }) => {
                    var _a;
                    if (dispatch) {
                        const { $to } = tr.selection;
                        const posAfter = $to.end();
                        if ($to.nodeAfter) {
                            if ($to.nodeAfter.isTextblock) {
                                tr.setSelection(state.TextSelection.create(tr.doc, $to.pos + 1));
                            }
                            else if ($to.nodeAfter.isBlock) {
                                tr.setSelection(state.NodeSelection.create(tr.doc, $to.pos));
                            }
                            else {
                                tr.setSelection(state.TextSelection.create(tr.doc, $to.pos));
                            }
                        }
                        else {
                            // add node after horizontal rule if it’s the end of the document
                            const node = (_a = $to.parent.type.contentMatch.defaultType) === null || _a === void 0 ? void 0 : _a.create();
                            if (node) {
                                tr.insert(posAfter, node);
                                tr.setSelection(state.TextSelection.create(tr.doc, posAfter + 1));
                            }
                        }
                        tr.scrollIntoView();
                    }
                    return true;
                })
                    .run());
            },
        };
    },
    addInputRules() {
        return [
            core.nodeInputRule({
                find: /^(?:---|—-|___\s|\*\*\*\s)$/,
                type: this.type,
            }),
        ];
    },
});

exports.HorizontalRule = HorizontalRule;
exports["default"] = HorizontalRule;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 32795:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * Matches an italic to a *italic* on input.
 */
const starInputRegex = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/;
/**
 * Matches an italic to a *italic* on paste.
 */
const starPasteRegex = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g;
/**
 * Matches an italic to a _italic_ on input.
 */
const underscoreInputRegex = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/;
/**
 * Matches an italic to a _italic_ on paste.
 */
const underscorePasteRegex = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g;
/**
 * This extension allows you to create italic text.
 * @see https://www.tiptap.dev/api/marks/italic
 */
const Italic = core.Mark.create({
    name: 'italic',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 'em',
            },
            {
                tag: 'i',
                getAttrs: node => node.style.fontStyle !== 'normal' && null,
            },
            {
                style: 'font-style=normal',
                clearMark: mark => mark.type.name === this.name,
            },
            {
                style: 'font-style=italic',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['em', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setItalic: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleItalic: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetItalic: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-i': () => this.editor.commands.toggleItalic(),
            'Mod-I': () => this.editor.commands.toggleItalic(),
        };
    },
    addInputRules() {
        return [
            core.markInputRule({
                find: starInputRegex,
                type: this.type,
            }),
            core.markInputRule({
                find: underscoreInputRegex,
                type: this.type,
            }),
        ];
    },
    addPasteRules() {
        return [
            core.markPasteRule({
                find: starPasteRegex,
                type: this.type,
            }),
            core.markPasteRule({
                find: underscorePasteRegex,
                type: this.type,
            }),
        ];
    },
});

exports.Italic = Italic;
exports["default"] = Italic;
exports.starInputRegex = starInputRegex;
exports.starPasteRegex = starPasteRegex;
exports.underscoreInputRegex = underscoreInputRegex;
exports.underscorePasteRegex = underscorePasteRegex;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 84961:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);
var linkifyjs = __webpack_require__(93268);
var state = __webpack_require__(96297);

// From DOMPurify
// https://github.com/cure53/DOMPurify/blob/main/src/regexp.ts
const UNICODE_WHITESPACE_PATTERN = '[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]';
const UNICODE_WHITESPACE_REGEX = new RegExp(UNICODE_WHITESPACE_PATTERN);
const UNICODE_WHITESPACE_REGEX_END = new RegExp(`${UNICODE_WHITESPACE_PATTERN}$`);
const UNICODE_WHITESPACE_REGEX_GLOBAL = new RegExp(UNICODE_WHITESPACE_PATTERN, 'g');

/**
 * Check if the provided tokens form a valid link structure, which can either be a single link token
 * or a link token surrounded by parentheses or square brackets.
 *
 * This ensures that only complete and valid text is hyperlinked, preventing cases where a valid
 * top-level domain (TLD) is immediately followed by an invalid character, like a number. For
 * example, with the `find` method from Linkify, entering `example.com1` would result in
 * `example.com` being linked and the trailing `1` left as plain text. By using the `tokenize`
 * method, we can perform more comprehensive validation on the input text.
 */
function isValidLinkStructure(tokens) {
    if (tokens.length === 1) {
        return tokens[0].isLink;
    }
    if (tokens.length === 3 && tokens[1].isLink) {
        return ['()', '[]'].includes(tokens[0].value + tokens[2].value);
    }
    return false;
}
/**
 * This plugin allows you to automatically add links to your editor.
 * @param options The plugin options
 * @returns The plugin instance
 */
function autolink(options) {
    return new state.Plugin({
        key: new state.PluginKey('autolink'),
        appendTransaction: (transactions, oldState, newState) => {
            /**
             * Does the transaction change the document?
             */
            const docChanges = transactions.some(transaction => transaction.docChanged) && !oldState.doc.eq(newState.doc);
            /**
             * Prevent autolink if the transaction is not a document change or if the transaction has the meta `preventAutolink`.
             */
            const preventAutolink = transactions.some(transaction => transaction.getMeta('preventAutolink'));
            /**
             * Prevent autolink if the transaction is not a document change
             * or if the transaction has the meta `preventAutolink`.
             */
            if (!docChanges || preventAutolink) {
                return;
            }
            const { tr } = newState;
            const transform = core.combineTransactionSteps(oldState.doc, [...transactions]);
            const changes = core.getChangedRanges(transform);
            changes.forEach(({ newRange }) => {
                // Now let’s see if we can add new links.
                const nodesInChangedRanges = core.findChildrenInRange(newState.doc, newRange, node => node.isTextblock);
                let textBlock;
                let textBeforeWhitespace;
                if (nodesInChangedRanges.length > 1) {
                    // Grab the first node within the changed ranges (ex. the first of two paragraphs when hitting enter).
                    textBlock = nodesInChangedRanges[0];
                    textBeforeWhitespace = newState.doc.textBetween(textBlock.pos, textBlock.pos + textBlock.node.nodeSize, undefined, ' ');
                }
                else if (nodesInChangedRanges.length) {
                    const endText = newState.doc.textBetween(newRange.from, newRange.to, ' ', ' ');
                    if (!UNICODE_WHITESPACE_REGEX_END.test(endText)) {
                        return;
                    }
                    textBlock = nodesInChangedRanges[0];
                    textBeforeWhitespace = newState.doc.textBetween(textBlock.pos, newRange.to, undefined, ' ');
                }
                if (textBlock && textBeforeWhitespace) {
                    const wordsBeforeWhitespace = textBeforeWhitespace.split(UNICODE_WHITESPACE_REGEX).filter(Boolean);
                    if (wordsBeforeWhitespace.length <= 0) {
                        return false;
                    }
                    const lastWordBeforeSpace = wordsBeforeWhitespace[wordsBeforeWhitespace.length - 1];
                    const lastWordAndBlockOffset = textBlock.pos + textBeforeWhitespace.lastIndexOf(lastWordBeforeSpace);
                    if (!lastWordBeforeSpace) {
                        return false;
                    }
                    const linksBeforeSpace = linkifyjs.tokenize(lastWordBeforeSpace).map(t => t.toObject(options.defaultProtocol));
                    if (!isValidLinkStructure(linksBeforeSpace)) {
                        return false;
                    }
                    linksBeforeSpace
                        .filter(link => link.isLink)
                        // Calculate link position.
                        .map(link => ({
                        ...link,
                        from: lastWordAndBlockOffset + link.start + 1,
                        to: lastWordAndBlockOffset + link.end + 1,
                    }))
                        // ignore link inside code mark
                        .filter(link => {
                        if (!newState.schema.marks.code) {
                            return true;
                        }
                        return !newState.doc.rangeHasMark(link.from, link.to, newState.schema.marks.code);
                    })
                        // validate link
                        .filter(link => options.validate(link.value))
                        // check whether should autolink
                        .filter(link => options.shouldAutoLink(link.value))
                        // Add link mark.
                        .forEach(link => {
                        if (core.getMarksBetween(link.from, link.to, newState.doc).some(item => item.mark.type === options.type)) {
                            return;
                        }
                        tr.addMark(link.from, link.to, options.type.create({
                            href: link.href,
                        }));
                    });
                }
            });
            if (!tr.steps.length) {
                return;
            }
            return tr;
        },
    });
}

function clickHandler(options) {
    return new state.Plugin({
        key: new state.PluginKey('handleClickLink'),
        props: {
            handleClick: (view, pos, event) => {
                var _a, _b;
                if (event.button !== 0) {
                    return false;
                }
                if (!view.editable) {
                    return false;
                }
                let a = event.target;
                const els = [];
                while (a.nodeName !== 'DIV') {
                    els.push(a);
                    a = a.parentNode;
                }
                if (!els.find(value => value.nodeName === 'A')) {
                    return false;
                }
                const attrs = core.getAttributes(view.state, options.type.name);
                const link = event.target;
                const href = (_a = link === null || link === void 0 ? void 0 : link.href) !== null && _a !== void 0 ? _a : attrs.href;
                const target = (_b = link === null || link === void 0 ? void 0 : link.target) !== null && _b !== void 0 ? _b : attrs.target;
                if (link && href) {
                    window.open(href, target);
                    return true;
                }
                return false;
            },
        },
    });
}

function pasteHandler(options) {
    return new state.Plugin({
        key: new state.PluginKey('handlePasteLink'),
        props: {
            handlePaste: (view, event, slice) => {
                const { state } = view;
                const { selection } = state;
                const { empty } = selection;
                if (empty) {
                    return false;
                }
                let textContent = '';
                slice.content.forEach(node => {
                    textContent += node.textContent;
                });
                const link = linkifyjs.find(textContent, { defaultProtocol: options.defaultProtocol }).find(item => item.isLink && item.value === textContent);
                if (!textContent || !link) {
                    return false;
                }
                return options.editor.commands.setMark(options.type, {
                    href: link.href,
                });
            },
        },
    });
}

const pasteRegex = /https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z]{2,}\b(?:[-a-zA-Z0-9@:%._+~#=?!&/]*)(?:[-a-zA-Z0-9@:%._+~#=?!&/]*)/gi;
function isAllowedUri(uri, protocols) {
    const allowedProtocols = [
        'http',
        'https',
        'ftp',
        'ftps',
        'mailto',
        'tel',
        'callto',
        'sms',
        'cid',
        'xmpp',
    ];
    if (protocols) {
        protocols.forEach(protocol => {
            const nextProtocol = typeof protocol === 'string' ? protocol : protocol.scheme;
            if (nextProtocol) {
                allowedProtocols.push(nextProtocol);
            }
        });
    }
    return (!uri
        || uri.replace(UNICODE_WHITESPACE_REGEX_GLOBAL, '').match(new RegExp(
        // eslint-disable-next-line no-useless-escape
        `^(?:(?:${allowedProtocols.join('|')}):|[^a-z]|[a-z0-9+.\-]+(?:[^a-z+.\-:]|$))`, 'i')));
}
/**
 * This extension allows you to create links.
 * @see https://www.tiptap.dev/api/marks/link
 */
const Link = core.Mark.create({
    name: 'link',
    priority: 1000,
    keepOnSplit: false,
    exitable: true,
    onCreate() {
        if (this.options.validate && !this.options.shouldAutoLink) {
            // Copy the validate function to the shouldAutoLink option
            this.options.shouldAutoLink = this.options.validate;
            console.warn('The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.');
        }
        this.options.protocols.forEach(protocol => {
            if (typeof protocol === 'string') {
                linkifyjs.registerCustomProtocol(protocol);
                return;
            }
            linkifyjs.registerCustomProtocol(protocol.scheme, protocol.optionalSlashes);
        });
    },
    onDestroy() {
        linkifyjs.reset();
    },
    inclusive() {
        return this.options.autolink;
    },
    addOptions() {
        return {
            openOnClick: true,
            linkOnPaste: true,
            autolink: true,
            protocols: [],
            defaultProtocol: 'http',
            HTMLAttributes: {
                target: '_blank',
                rel: 'noopener noreferrer nofollow',
                class: null,
            },
            isAllowedUri: (url, ctx) => !!isAllowedUri(url, ctx.protocols),
            validate: url => !!url,
            shouldAutoLink: url => !!url,
        };
    },
    addAttributes() {
        return {
            href: {
                default: null,
                parseHTML(element) {
                    return element.getAttribute('href');
                },
            },
            target: {
                default: this.options.HTMLAttributes.target,
            },
            rel: {
                default: this.options.HTMLAttributes.rel,
            },
            class: {
                default: this.options.HTMLAttributes.class,
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'a[href]',
                getAttrs: dom => {
                    const href = dom.getAttribute('href');
                    // prevent XSS attacks
                    if (!href
                        || !this.options.isAllowedUri(href, {
                            defaultValidate: url => !!isAllowedUri(url, this.options.protocols),
                            protocols: this.options.protocols,
                            defaultProtocol: this.options.defaultProtocol,
                        })) {
                        return false;
                    }
                    return null;
                },
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        // prevent XSS attacks
        if (!this.options.isAllowedUri(HTMLAttributes.href, {
            defaultValidate: href => !!isAllowedUri(href, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol,
        })) {
            // strip out the href
            return [
                'a',
                core.mergeAttributes(this.options.HTMLAttributes, { ...HTMLAttributes, href: '' }),
                0,
            ];
        }
        return ['a', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setLink: attributes => ({ chain }) => {
                const { href } = attributes;
                if (!this.options.isAllowedUri(href, {
                    defaultValidate: url => !!isAllowedUri(url, this.options.protocols),
                    protocols: this.options.protocols,
                    defaultProtocol: this.options.defaultProtocol,
                })) {
                    return false;
                }
                return chain().setMark(this.name, attributes).setMeta('preventAutolink', true).run();
            },
            toggleLink: attributes => ({ chain }) => {
                const { href } = attributes;
                if (!this.options.isAllowedUri(href, {
                    defaultValidate: url => !!isAllowedUri(url, this.options.protocols),
                    protocols: this.options.protocols,
                    defaultProtocol: this.options.defaultProtocol,
                })) {
                    return false;
                }
                return chain()
                    .toggleMark(this.name, attributes, { extendEmptyMarkRange: true })
                    .setMeta('preventAutolink', true)
                    .run();
            },
            unsetLink: () => ({ chain }) => {
                return chain()
                    .unsetMark(this.name, { extendEmptyMarkRange: true })
                    .setMeta('preventAutolink', true)
                    .run();
            },
        };
    },
    addPasteRules() {
        return [
            core.markPasteRule({
                find: text => {
                    const foundLinks = [];
                    if (text) {
                        const { protocols, defaultProtocol } = this.options;
                        const links = linkifyjs.find(text).filter(item => item.isLink
                            && this.options.isAllowedUri(item.value, {
                                defaultValidate: href => !!isAllowedUri(href, protocols),
                                protocols,
                                defaultProtocol,
                            }));
                        if (links.length) {
                            links.forEach(link => foundLinks.push({
                                text: link.value,
                                data: {
                                    href: link.href,
                                },
                                index: link.start,
                            }));
                        }
                    }
                    return foundLinks;
                },
                type: this.type,
                getAttributes: match => {
                    var _a;
                    return {
                        href: (_a = match.data) === null || _a === void 0 ? void 0 : _a.href,
                    };
                },
            }),
        ];
    },
    addProseMirrorPlugins() {
        const plugins = [];
        const { protocols, defaultProtocol } = this.options;
        if (this.options.autolink) {
            plugins.push(autolink({
                type: this.type,
                defaultProtocol: this.options.defaultProtocol,
                validate: url => this.options.isAllowedUri(url, {
                    defaultValidate: href => !!isAllowedUri(href, protocols),
                    protocols,
                    defaultProtocol,
                }),
                shouldAutoLink: this.options.shouldAutoLink,
            }));
        }
        if (this.options.openOnClick === true) {
            plugins.push(clickHandler({
                type: this.type,
            }));
        }
        if (this.options.linkOnPaste) {
            plugins.push(pasteHandler({
                editor: this.editor,
                defaultProtocol: this.options.defaultProtocol,
                type: this.type,
            }));
        }
        return plugins;
    },
});

exports.Link = Link;
exports["default"] = Link;
exports.isAllowedUri = isAllowedUri;
exports.pasteRegex = pasteRegex;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 42384:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * This extension allows you to create list items.
 * @see https://www.tiptap.dev/api/nodes/list-item
 */
const ListItem = core.Node.create({
    name: 'listItem',
    addOptions() {
        return {
            HTMLAttributes: {},
            bulletListTypeName: 'bulletList',
            orderedListTypeName: 'orderedList',
        };
    },
    content: 'paragraph block*',
    defining: true,
    parseHTML() {
        return [
            {
                tag: 'li',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['li', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addKeyboardShortcuts() {
        return {
            Enter: () => this.editor.commands.splitListItem(this.name),
            Tab: () => this.editor.commands.sinkListItem(this.name),
            'Shift-Tab': () => this.editor.commands.liftListItem(this.name),
        };
    },
});

exports.ListItem = ListItem;
exports["default"] = ListItem;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 25089:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

const ListItemName = 'listItem';
const TextStyleName = 'textStyle';
/**
 * Matches an ordered list to a 1. on input (or any number followed by a dot).
 */
const inputRegex = /^(\d+)\.\s$/;
/**
 * This extension allows you to create ordered lists.
 * This requires the ListItem extension
 * @see https://www.tiptap.dev/api/nodes/ordered-list
 * @see https://www.tiptap.dev/api/nodes/list-item
 */
const OrderedList = core.Node.create({
    name: 'orderedList',
    addOptions() {
        return {
            itemTypeName: 'listItem',
            HTMLAttributes: {},
            keepMarks: false,
            keepAttributes: false,
        };
    },
    group: 'block list',
    content() {
        return `${this.options.itemTypeName}+`;
    },
    addAttributes() {
        return {
            start: {
                default: 1,
                parseHTML: element => {
                    return element.hasAttribute('start')
                        ? parseInt(element.getAttribute('start') || '', 10)
                        : 1;
                },
            },
            type: {
                default: null,
                parseHTML: element => element.getAttribute('type'),
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'ol',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        const { start, ...attributesWithoutStart } = HTMLAttributes;
        return start === 1
            ? ['ol', core.mergeAttributes(this.options.HTMLAttributes, attributesWithoutStart), 0]
            : ['ol', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            toggleOrderedList: () => ({ commands, chain }) => {
                if (this.options.keepAttributes) {
                    return chain().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(ListItemName, this.editor.getAttributes(TextStyleName)).run();
                }
                return commands.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-7': () => this.editor.commands.toggleOrderedList(),
        };
    },
    addInputRules() {
        let inputRule = core.wrappingInputRule({
            find: inputRegex,
            type: this.type,
            getAttributes: match => ({ start: +match[1] }),
            joinPredicate: (match, node) => node.childCount + node.attrs.start === +match[1],
        });
        if (this.options.keepMarks || this.options.keepAttributes) {
            inputRule = core.wrappingInputRule({
                find: inputRegex,
                type: this.type,
                keepMarks: this.options.keepMarks,
                keepAttributes: this.options.keepAttributes,
                getAttributes: match => ({ start: +match[1], ...this.editor.getAttributes(TextStyleName) }),
                joinPredicate: (match, node) => node.childCount + node.attrs.start === +match[1],
                editor: this.editor,
            });
        }
        return [
            inputRule,
        ];
    },
});

exports.OrderedList = OrderedList;
exports["default"] = OrderedList;
exports.inputRegex = inputRegex;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 48150:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * This extension allows you to create paragraphs.
 * @see https://www.tiptap.dev/api/nodes/paragraph
 */
const Paragraph = core.Node.create({
    name: 'paragraph',
    priority: 1000,
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    group: 'block',
    content: 'inline*',
    parseHTML() {
        return [
            { tag: 'p' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['p', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setParagraph: () => ({ commands }) => {
                return commands.setNode(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Alt-0': () => this.editor.commands.setParagraph(),
        };
    },
});

exports.Paragraph = Paragraph;
exports["default"] = Paragraph;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 48299:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);
var state = __webpack_require__(96297);
var view = __webpack_require__(40585);

/**
 * This extension allows you to add a placeholder to your editor.
 * A placeholder is a text that appears when the editor or a node is empty.
 * @see https://www.tiptap.dev/api/extensions/placeholder
 */
const Placeholder = core.Extension.create({
    name: 'placeholder',
    addOptions() {
        return {
            emptyEditorClass: 'is-editor-empty',
            emptyNodeClass: 'is-empty',
            placeholder: 'Write something …',
            showOnlyWhenEditable: true,
            showOnlyCurrent: true,
            includeChildren: false,
        };
    },
    addProseMirrorPlugins() {
        return [
            new state.Plugin({
                key: new state.PluginKey('placeholder'),
                props: {
                    decorations: ({ doc, selection }) => {
                        const active = this.editor.isEditable || !this.options.showOnlyWhenEditable;
                        const { anchor } = selection;
                        const decorations = [];
                        if (!active) {
                            return null;
                        }
                        const isEmptyDoc = this.editor.isEmpty;
                        doc.descendants((node, pos) => {
                            const hasAnchor = anchor >= pos && anchor <= pos + node.nodeSize;
                            const isEmpty = !node.isLeaf && core.isNodeEmpty(node);
                            if ((hasAnchor || !this.options.showOnlyCurrent) && isEmpty) {
                                const classes = [this.options.emptyNodeClass];
                                if (isEmptyDoc) {
                                    classes.push(this.options.emptyEditorClass);
                                }
                                const decoration = view.Decoration.node(pos, pos + node.nodeSize, {
                                    class: classes.join(' '),
                                    'data-placeholder': typeof this.options.placeholder === 'function'
                                        ? this.options.placeholder({
                                            editor: this.editor,
                                            node,
                                            pos,
                                            hasAnchor,
                                        })
                                        : this.options.placeholder,
                                });
                                decorations.push(decoration);
                            }
                            return this.options.includeChildren;
                        });
                        return view.DecorationSet.create(doc, decorations);
                    },
                },
            }),
        ];
    },
});

exports.Placeholder = Placeholder;
exports["default"] = Placeholder;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 13228:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * Matches a strike to a ~~strike~~ on input.
 */
const inputRegex = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/;
/**
 * Matches a strike to a ~~strike~~ on paste.
 */
const pasteRegex = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g;
/**
 * This extension allows you to create strike text.
 * @see https://www.tiptap.dev/api/marks/strike
 */
const Strike = core.Mark.create({
    name: 'strike',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 's',
            },
            {
                tag: 'del',
            },
            {
                tag: 'strike',
            },
            {
                style: 'text-decoration',
                consuming: false,
                getAttrs: style => (style.includes('line-through') ? {} : false),
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['s', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setStrike: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleStrike: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetStrike: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-s': () => this.editor.commands.toggleStrike(),
        };
    },
    addInputRules() {
        return [
            core.markInputRule({
                find: inputRegex,
                type: this.type,
            }),
        ];
    },
    addPasteRules() {
        return [
            core.markPasteRule({
                find: pasteRegex,
                type: this.type,
            }),
        ];
    },
});

exports.Strike = Strike;
exports["default"] = Strike;
exports.inputRegex = inputRegex;
exports.pasteRegex = pasteRegex;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 60692:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * This extension allows you to create subscript text.
 * @see https://www.tiptap.dev/api/marks/subscript
 */
const Subscript = core.Mark.create({
    name: 'subscript',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 'sub',
            },
            {
                style: 'vertical-align',
                getAttrs(value) {
                    // Don’t match this rule if the vertical align isn’t sub.
                    if (value !== 'sub') {
                        return false;
                    }
                    // If it falls through we’ll match, and this mark will be applied.
                    return null;
                },
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['sub', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setSubscript: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleSubscript: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetSubscript: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-,': () => this.editor.commands.toggleSubscript(),
        };
    },
});

exports.Subscript = Subscript;
exports["default"] = Subscript;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 5046:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * This extension allows you to create superscript text.
 * @see https://www.tiptap.dev/api/marks/superscript
 */
const Superscript = core.Mark.create({
    name: 'superscript',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 'sup',
            },
            {
                style: 'vertical-align',
                getAttrs(value) {
                    // Don’t match this rule if the vertical align isn’t super.
                    if (value !== 'super') {
                        return false;
                    }
                    // If it falls through we’ll match, and this mark will be applied.
                    return null;
                },
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['sup', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setSuperscript: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleSuperscript: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetSuperscript: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-.': () => this.editor.commands.toggleSuperscript(),
        };
    },
});

exports.Superscript = Superscript;
exports["default"] = Superscript;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 9799:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * This extension allows you to create table cells.
 * @see https://www.tiptap.dev/api/nodes/table-cell
 */
const TableCell = core.Node.create({
    name: 'tableCell',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    content: 'block+',
    addAttributes() {
        return {
            colspan: {
                default: 1,
            },
            rowspan: {
                default: 1,
            },
            colwidth: {
                default: null,
                parseHTML: element => {
                    const colwidth = element.getAttribute('colwidth');
                    const value = colwidth
                        ? colwidth.split(',').map(width => parseInt(width, 10))
                        : null;
                    return value;
                },
            },
        };
    },
    tableRole: 'cell',
    isolating: true,
    parseHTML() {
        return [
            { tag: 'td' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['td', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
});

exports.TableCell = TableCell;
exports["default"] = TableCell;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 92008:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * This extension allows you to create table headers.
 * @see https://www.tiptap.dev/api/nodes/table-header
 */
const TableHeader = core.Node.create({
    name: 'tableHeader',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    content: 'block+',
    addAttributes() {
        return {
            colspan: {
                default: 1,
            },
            rowspan: {
                default: 1,
            },
            colwidth: {
                default: null,
                parseHTML: element => {
                    const colwidth = element.getAttribute('colwidth');
                    const value = colwidth
                        ? colwidth.split(',').map(width => parseInt(width, 10))
                        : null;
                    return value;
                },
            },
        };
    },
    tableRole: 'header_cell',
    isolating: true,
    parseHTML() {
        return [
            { tag: 'th' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['th', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
});

exports.TableHeader = TableHeader;
exports["default"] = TableHeader;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 15201:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * This extension allows you to create table rows.
 * @see https://www.tiptap.dev/api/nodes/table-row
 */
const TableRow = core.Node.create({
    name: 'tableRow',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    content: '(tableCell | tableHeader)*',
    tableRole: 'row',
    parseHTML() {
        return [
            { tag: 'tr' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['tr', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
});

exports.TableRow = TableRow;
exports["default"] = TableRow;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 60152:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);
var state = __webpack_require__(96297);
var tables = __webpack_require__(26575);

function getColStyleDeclaration(minWidth, width) {
    if (width) {
        // apply the stored width unless it is below the configured minimum cell width
        return ['width', `${Math.max(width, minWidth)}px`];
    }
    // set the minimum with on the column if it has no stored width
    return ['min-width', `${minWidth}px`];
}

function updateColumns(node, colgroup, // <colgroup> has the same prototype as <col>
table, cellMinWidth, overrideCol, overrideValue) {
    var _a;
    let totalWidth = 0;
    let fixedWidth = true;
    let nextDOM = colgroup.firstChild;
    const row = node.firstChild;
    if (row !== null) {
        for (let i = 0, col = 0; i < row.childCount; i += 1) {
            const { colspan, colwidth } = row.child(i).attrs;
            for (let j = 0; j < colspan; j += 1, col += 1) {
                const hasWidth = overrideCol === col ? overrideValue : (colwidth && colwidth[j]);
                const cssWidth = hasWidth ? `${hasWidth}px` : '';
                totalWidth += hasWidth || cellMinWidth;
                if (!hasWidth) {
                    fixedWidth = false;
                }
                if (!nextDOM) {
                    const colElement = document.createElement('col');
                    const [propertyKey, propertyValue] = getColStyleDeclaration(cellMinWidth, hasWidth);
                    colElement.style.setProperty(propertyKey, propertyValue);
                    colgroup.appendChild(colElement);
                }
                else {
                    if (nextDOM.style.width !== cssWidth) {
                        const [propertyKey, propertyValue] = getColStyleDeclaration(cellMinWidth, hasWidth);
                        nextDOM.style.setProperty(propertyKey, propertyValue);
                    }
                    nextDOM = nextDOM.nextSibling;
                }
            }
        }
    }
    while (nextDOM) {
        const after = nextDOM.nextSibling;
        (_a = nextDOM.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(nextDOM);
        nextDOM = after;
    }
    if (fixedWidth) {
        table.style.width = `${totalWidth}px`;
        table.style.minWidth = '';
    }
    else {
        table.style.width = '';
        table.style.minWidth = `${totalWidth}px`;
    }
}
class TableView {
    constructor(node, cellMinWidth) {
        this.node = node;
        this.cellMinWidth = cellMinWidth;
        this.dom = document.createElement('div');
        this.dom.className = 'tableWrapper';
        this.table = this.dom.appendChild(document.createElement('table'));
        this.colgroup = this.table.appendChild(document.createElement('colgroup'));
        updateColumns(node, this.colgroup, this.table, cellMinWidth);
        this.contentDOM = this.table.appendChild(document.createElement('tbody'));
    }
    update(node) {
        if (node.type !== this.node.type) {
            return false;
        }
        this.node = node;
        updateColumns(node, this.colgroup, this.table, this.cellMinWidth);
        return true;
    }
    ignoreMutation(mutation) {
        return (mutation.type === 'attributes'
            && (mutation.target === this.table || this.colgroup.contains(mutation.target)));
    }
}

function createColGroup(node, cellMinWidth, overrideCol, overrideValue) {
    let totalWidth = 0;
    let fixedWidth = true;
    const cols = [];
    const row = node.firstChild;
    if (!row) {
        return {};
    }
    for (let i = 0, col = 0; i < row.childCount; i += 1) {
        const { colspan, colwidth } = row.child(i).attrs;
        for (let j = 0; j < colspan; j += 1, col += 1) {
            const hasWidth = overrideCol === col ? overrideValue : colwidth && colwidth[j];
            totalWidth += hasWidth || cellMinWidth;
            if (!hasWidth) {
                fixedWidth = false;
            }
            const [property, value] = getColStyleDeclaration(cellMinWidth, hasWidth);
            cols.push([
                'col',
                { style: `${property}: ${value}` },
            ]);
        }
    }
    const tableWidth = fixedWidth ? `${totalWidth}px` : '';
    const tableMinWidth = fixedWidth ? '' : `${totalWidth}px`;
    const colgroup = ['colgroup', {}, ...cols];
    return { colgroup, tableWidth, tableMinWidth };
}

function createCell(cellType, cellContent) {
    if (cellContent) {
        return cellType.createChecked(null, cellContent);
    }
    return cellType.createAndFill();
}

function getTableNodeTypes(schema) {
    if (schema.cached.tableNodeTypes) {
        return schema.cached.tableNodeTypes;
    }
    const roles = {};
    Object.keys(schema.nodes).forEach(type => {
        const nodeType = schema.nodes[type];
        if (nodeType.spec.tableRole) {
            roles[nodeType.spec.tableRole] = nodeType;
        }
    });
    schema.cached.tableNodeTypes = roles;
    return roles;
}

function createTable(schema, rowsCount, colsCount, withHeaderRow, cellContent) {
    const types = getTableNodeTypes(schema);
    const headerCells = [];
    const cells = [];
    for (let index = 0; index < colsCount; index += 1) {
        const cell = createCell(types.cell, cellContent);
        if (cell) {
            cells.push(cell);
        }
        if (withHeaderRow) {
            const headerCell = createCell(types.header_cell, cellContent);
            if (headerCell) {
                headerCells.push(headerCell);
            }
        }
    }
    const rows = [];
    for (let index = 0; index < rowsCount; index += 1) {
        rows.push(types.row.createChecked(null, withHeaderRow && index === 0 ? headerCells : cells));
    }
    return types.table.createChecked(null, rows);
}

function isCellSelection(value) {
    return value instanceof tables.CellSelection;
}

const deleteTableWhenAllCellsSelected = ({ editor }) => {
    const { selection } = editor.state;
    if (!isCellSelection(selection)) {
        return false;
    }
    let cellCount = 0;
    const table = core.findParentNodeClosestToPos(selection.ranges[0].$from, node => {
        return node.type.name === 'table';
    });
    table === null || table === void 0 ? void 0 : table.node.descendants(node => {
        if (node.type.name === 'table') {
            return false;
        }
        if (['tableCell', 'tableHeader'].includes(node.type.name)) {
            cellCount += 1;
        }
    });
    const allCellsSelected = cellCount === selection.ranges.length;
    if (!allCellsSelected) {
        return false;
    }
    editor.commands.deleteTable();
    return true;
};

/**
 * This extension allows you to create tables.
 * @see https://www.tiptap.dev/api/nodes/table
 */
const Table = core.Node.create({
    name: 'table',
    // @ts-ignore
    addOptions() {
        return {
            HTMLAttributes: {},
            resizable: false,
            handleWidth: 5,
            cellMinWidth: 25,
            // TODO: fix
            View: TableView,
            lastColumnResizable: true,
            allowTableNodeSelection: false,
        };
    },
    content: 'tableRow+',
    tableRole: 'table',
    isolating: true,
    group: 'block',
    parseHTML() {
        return [{ tag: 'table' }];
    },
    renderHTML({ node, HTMLAttributes }) {
        const { colgroup, tableWidth, tableMinWidth } = createColGroup(node, this.options.cellMinWidth);
        const table = [
            'table',
            core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
                style: tableWidth
                    ? `width: ${tableWidth}`
                    : `min-width: ${tableMinWidth}`,
            }),
            colgroup,
            ['tbody', 0],
        ];
        return table;
    },
    addCommands() {
        return {
            insertTable: ({ rows = 3, cols = 3, withHeaderRow = true } = {}) => ({ tr, dispatch, editor }) => {
                const node = createTable(editor.schema, rows, cols, withHeaderRow);
                if (dispatch) {
                    const offset = tr.selection.from + 1;
                    tr.replaceSelectionWith(node)
                        .scrollIntoView()
                        .setSelection(state.TextSelection.near(tr.doc.resolve(offset)));
                }
                return true;
            },
            addColumnBefore: () => ({ state, dispatch }) => {
                return tables.addColumnBefore(state, dispatch);
            },
            addColumnAfter: () => ({ state, dispatch }) => {
                return tables.addColumnAfter(state, dispatch);
            },
            deleteColumn: () => ({ state, dispatch }) => {
                return tables.deleteColumn(state, dispatch);
            },
            addRowBefore: () => ({ state, dispatch }) => {
                return tables.addRowBefore(state, dispatch);
            },
            addRowAfter: () => ({ state, dispatch }) => {
                return tables.addRowAfter(state, dispatch);
            },
            deleteRow: () => ({ state, dispatch }) => {
                return tables.deleteRow(state, dispatch);
            },
            deleteTable: () => ({ state, dispatch }) => {
                return tables.deleteTable(state, dispatch);
            },
            mergeCells: () => ({ state, dispatch }) => {
                return tables.mergeCells(state, dispatch);
            },
            splitCell: () => ({ state, dispatch }) => {
                return tables.splitCell(state, dispatch);
            },
            toggleHeaderColumn: () => ({ state, dispatch }) => {
                return tables.toggleHeader('column')(state, dispatch);
            },
            toggleHeaderRow: () => ({ state, dispatch }) => {
                return tables.toggleHeader('row')(state, dispatch);
            },
            toggleHeaderCell: () => ({ state, dispatch }) => {
                return tables.toggleHeaderCell(state, dispatch);
            },
            mergeOrSplit: () => ({ state, dispatch }) => {
                if (tables.mergeCells(state, dispatch)) {
                    return true;
                }
                return tables.splitCell(state, dispatch);
            },
            setCellAttribute: (name, value) => ({ state, dispatch }) => {
                return tables.setCellAttr(name, value)(state, dispatch);
            },
            goToNextCell: () => ({ state, dispatch }) => {
                return tables.goToNextCell(1)(state, dispatch);
            },
            goToPreviousCell: () => ({ state, dispatch }) => {
                return tables.goToNextCell(-1)(state, dispatch);
            },
            fixTables: () => ({ state, dispatch }) => {
                if (dispatch) {
                    tables.fixTables(state);
                }
                return true;
            },
            setCellSelection: position => ({ tr, dispatch }) => {
                if (dispatch) {
                    const selection = tables.CellSelection.create(tr.doc, position.anchorCell, position.headCell);
                    // @ts-ignore
                    tr.setSelection(selection);
                }
                return true;
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            Tab: () => {
                if (this.editor.commands.goToNextCell()) {
                    return true;
                }
                if (!this.editor.can().addRowAfter()) {
                    return false;
                }
                return this.editor.chain().addRowAfter().goToNextCell().run();
            },
            'Shift-Tab': () => this.editor.commands.goToPreviousCell(),
            Backspace: deleteTableWhenAllCellsSelected,
            'Mod-Backspace': deleteTableWhenAllCellsSelected,
            Delete: deleteTableWhenAllCellsSelected,
            'Mod-Delete': deleteTableWhenAllCellsSelected,
        };
    },
    addProseMirrorPlugins() {
        const isResizable = this.options.resizable && this.editor.isEditable;
        return [
            ...(isResizable
                ? [
                    tables.columnResizing({
                        handleWidth: this.options.handleWidth,
                        cellMinWidth: this.options.cellMinWidth,
                        defaultCellMinWidth: this.options.cellMinWidth,
                        View: this.options.View,
                        lastColumnResizable: this.options.lastColumnResizable,
                    }),
                ]
                : []),
            tables.tableEditing({
                allowTableNodeSelection: this.options.allowTableNodeSelection,
            }),
        ];
    },
    extendNodeSchema(extension) {
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
        };
        return {
            tableRole: core.callOrReturn(core.getExtensionField(extension, 'tableRole', context)),
        };
    },
});

exports.Table = Table;
exports.TableView = TableView;
exports.createColGroup = createColGroup;
exports.createTable = createTable;
exports["default"] = Table;
exports.updateColumns = updateColumns;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 15791:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * Matches a task item to a - [ ] on input.
 */
const inputRegex = /^\s*(\[([( |x])?\])\s$/;
/**
 * This extension allows you to create task items.
 * @see https://www.tiptap.dev/api/nodes/task-item
 */
const TaskItem = core.Node.create({
    name: 'taskItem',
    addOptions() {
        return {
            nested: false,
            HTMLAttributes: {},
            taskListTypeName: 'taskList',
            a11y: undefined,
        };
    },
    content() {
        return this.options.nested ? 'paragraph block*' : 'paragraph+';
    },
    defining: true,
    addAttributes() {
        return {
            checked: {
                default: false,
                keepOnSplit: false,
                parseHTML: element => {
                    const dataChecked = element.getAttribute('data-checked');
                    return dataChecked === '' || dataChecked === 'true';
                },
                renderHTML: attributes => ({
                    'data-checked': attributes.checked,
                }),
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: `li[data-type="${this.name}"]`,
                priority: 51,
            },
        ];
    },
    renderHTML({ node, HTMLAttributes }) {
        return [
            'li',
            core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
                'data-type': this.name,
            }),
            [
                'label',
                [
                    'input',
                    {
                        type: 'checkbox',
                        checked: node.attrs.checked ? 'checked' : null,
                    },
                ],
                ['span'],
            ],
            ['div', 0],
        ];
    },
    addKeyboardShortcuts() {
        const shortcuts = {
            Enter: () => this.editor.commands.splitListItem(this.name),
            'Shift-Tab': () => this.editor.commands.liftListItem(this.name),
        };
        if (!this.options.nested) {
            return shortcuts;
        }
        return {
            ...shortcuts,
            Tab: () => this.editor.commands.sinkListItem(this.name),
        };
    },
    addNodeView() {
        return ({ node, HTMLAttributes, getPos, editor, }) => {
            const listItem = document.createElement('li');
            const checkboxWrapper = document.createElement('label');
            const checkboxStyler = document.createElement('span');
            const checkbox = document.createElement('input');
            const content = document.createElement('div');
            const updateA11Y = () => {
                var _a, _b;
                checkbox.ariaLabel = ((_b = (_a = this.options.a11y) === null || _a === void 0 ? void 0 : _a.checkboxLabel) === null || _b === void 0 ? void 0 : _b.call(_a, node, checkbox.checked))
                    || `Task item checkbox for ${node.textContent || 'empty task item'}`;
            };
            updateA11Y();
            checkboxWrapper.contentEditable = 'false';
            checkbox.type = 'checkbox';
            checkbox.addEventListener('mousedown', event => event.preventDefault());
            checkbox.addEventListener('change', event => {
                // if the editor isn’t editable and we don't have a handler for
                // readonly checks we have to undo the latest change
                if (!editor.isEditable && !this.options.onReadOnlyChecked) {
                    checkbox.checked = !checkbox.checked;
                    return;
                }
                const { checked } = event.target;
                if (editor.isEditable && typeof getPos === 'function') {
                    editor
                        .chain()
                        .focus(undefined, { scrollIntoView: false })
                        .command(({ tr }) => {
                        const position = getPos();
                        if (typeof position !== 'number') {
                            return false;
                        }
                        const currentNode = tr.doc.nodeAt(position);
                        tr.setNodeMarkup(position, undefined, {
                            ...currentNode === null || currentNode === void 0 ? void 0 : currentNode.attrs,
                            checked,
                        });
                        return true;
                    })
                        .run();
                }
                if (!editor.isEditable && this.options.onReadOnlyChecked) {
                    // Reset state if onReadOnlyChecked returns false
                    if (!this.options.onReadOnlyChecked(node, checked)) {
                        checkbox.checked = !checkbox.checked;
                    }
                }
            });
            Object.entries(this.options.HTMLAttributes).forEach(([key, value]) => {
                listItem.setAttribute(key, value);
            });
            listItem.dataset.checked = node.attrs.checked;
            checkbox.checked = node.attrs.checked;
            checkboxWrapper.append(checkbox, checkboxStyler);
            listItem.append(checkboxWrapper, content);
            Object.entries(HTMLAttributes).forEach(([key, value]) => {
                listItem.setAttribute(key, value);
            });
            return {
                dom: listItem,
                contentDOM: content,
                update: updatedNode => {
                    if (updatedNode.type !== this.type) {
                        return false;
                    }
                    listItem.dataset.checked = updatedNode.attrs.checked;
                    checkbox.checked = updatedNode.attrs.checked;
                    updateA11Y();
                    return true;
                },
            };
        };
    },
    addInputRules() {
        return [
            core.wrappingInputRule({
                find: inputRegex,
                type: this.type,
                getAttributes: match => ({
                    checked: match[match.length - 1] === 'x',
                }),
            }),
        ];
    },
});

exports.TaskItem = TaskItem;
exports["default"] = TaskItem;
exports.inputRegex = inputRegex;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 55931:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * This extension allows you to create task lists.
 * @see https://www.tiptap.dev/api/nodes/task-list
 */
const TaskList = core.Node.create({
    name: 'taskList',
    addOptions() {
        return {
            itemTypeName: 'taskItem',
            HTMLAttributes: {},
        };
    },
    group: 'block list',
    content() {
        return `${this.options.itemTypeName}+`;
    },
    parseHTML() {
        return [
            {
                tag: `ul[data-type="${this.name}"]`,
                priority: 51,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['ul', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { 'data-type': this.name }), 0];
    },
    addCommands() {
        return {
            toggleTaskList: () => ({ commands }) => {
                return commands.toggleList(this.name, this.options.itemTypeName);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-9': () => this.editor.commands.toggleTaskList(),
        };
    },
});

exports.TaskList = TaskList;
exports["default"] = TaskList;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 78956:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * This extension allows you to align text.
 * @see https://www.tiptap.dev/api/extensions/text-align
 */
const TextAlign = core.Extension.create({
    name: 'textAlign',
    addOptions() {
        return {
            types: [],
            alignments: ['left', 'center', 'right', 'justify'],
            defaultAlignment: null,
        };
    },
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    textAlign: {
                        default: this.options.defaultAlignment,
                        parseHTML: element => {
                            const alignment = element.style.textAlign;
                            return this.options.alignments.includes(alignment) ? alignment : this.options.defaultAlignment;
                        },
                        renderHTML: attributes => {
                            if (!attributes.textAlign) {
                                return {};
                            }
                            return { style: `text-align: ${attributes.textAlign}` };
                        },
                    },
                },
            },
        ];
    },
    addCommands() {
        return {
            setTextAlign: (alignment) => ({ commands }) => {
                if (!this.options.alignments.includes(alignment)) {
                    return false;
                }
                return this.options.types
                    .map(type => commands.updateAttributes(type, { textAlign: alignment }))
                    .every(response => response);
            },
            unsetTextAlign: () => ({ commands }) => {
                return this.options.types
                    .map(type => commands.resetAttributes(type, 'textAlign'))
                    .every(response => response);
            },
            toggleTextAlign: alignment => ({ editor, commands }) => {
                if (!this.options.alignments.includes(alignment)) {
                    return false;
                }
                if (editor.isActive({ textAlign: alignment })) {
                    return commands.unsetTextAlign();
                }
                return commands.setTextAlign(alignment);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-l': () => this.editor.commands.setTextAlign('left'),
            'Mod-Shift-e': () => this.editor.commands.setTextAlign('center'),
            'Mod-Shift-r': () => this.editor.commands.setTextAlign('right'),
            'Mod-Shift-j': () => this.editor.commands.setTextAlign('justify'),
        };
    },
});

exports.TextAlign = TextAlign;
exports["default"] = TextAlign;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 4412:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

const mergeNestedSpanStyles = (element) => {
    if (!element.children.length) {
        return;
    }
    const childSpans = element.querySelectorAll('span');
    if (!childSpans) {
        return;
    }
    childSpans.forEach(childSpan => {
        var _a, _b;
        const childStyle = childSpan.getAttribute('style');
        const closestParentSpanStyleOfChild = (_b = (_a = childSpan.parentElement) === null || _a === void 0 ? void 0 : _a.closest('span')) === null || _b === void 0 ? void 0 : _b.getAttribute('style');
        childSpan.setAttribute('style', `${closestParentSpanStyleOfChild};${childStyle}`);
    });
};
/**
 * This extension allows you to create text styles. It is required by default
 * for the `textColor` and `backgroundColor` extensions.
 * @see https://www.tiptap.dev/api/marks/text-style
 */
const TextStyle = core.Mark.create({
    name: 'textStyle',
    priority: 101,
    addOptions() {
        return {
            HTMLAttributes: {},
            mergeNestedSpanStyles: false,
        };
    },
    parseHTML() {
        return [
            {
                tag: 'span',
                getAttrs: element => {
                    const hasStyles = element.hasAttribute('style');
                    if (!hasStyles) {
                        return false;
                    }
                    if (this.options.mergeNestedSpanStyles) {
                        mergeNestedSpanStyles(element);
                    }
                    return {};
                },
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['span', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            removeEmptyTextStyle: () => ({ tr }) => {
                const { selection } = tr;
                // Gather all of the nodes within the selection range.
                // We would need to go through each node individually
                // to check if it has any inline style attributes.
                // Otherwise, calling commands.unsetMark(this.name)
                // removes everything from all the nodes
                // within the selection range.
                tr.doc.nodesBetween(selection.from, selection.to, (node, pos) => {
                    // Check if it's a paragraph element, if so, skip this node as we apply
                    // the text style to inline text nodes only (span).
                    if (node.isTextblock) {
                        return true;
                    }
                    // Check if the node has no inline style attributes.
                    // Filter out non-`textStyle` marks.
                    if (!node.marks.filter(mark => mark.type === this.type).some(mark => Object.values(mark.attrs).some(value => !!value))) {
                        // Proceed with the removal of the `textStyle` mark for this node only
                        tr.removeMark(pos, pos + node.nodeSize, this.type);
                    }
                });
                return true;
            },
        };
    },
});

exports.TextStyle = TextStyle;
exports["default"] = TextStyle;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 76727:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * This extension allows you to create text nodes.
 * @see https://www.tiptap.dev/api/nodes/text
 */
const Text = core.Node.create({
    name: 'text',
    group: 'inline',
});

exports.Text = Text;
exports["default"] = Text;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 24545:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

const emDash = (override) => core.textInputRule({
    find: /--$/,
    replace: override !== null && override !== void 0 ? override : '—',
});
const ellipsis = (override) => core.textInputRule({
    find: /\.\.\.$/,
    replace: override !== null && override !== void 0 ? override : '…',
});
const openDoubleQuote = (override) => core.textInputRule({
    find: /(?:^|[\s{[(<'"\u2018\u201C])(")$/,
    replace: override !== null && override !== void 0 ? override : '“',
});
const closeDoubleQuote = (override) => core.textInputRule({
    find: /"$/,
    replace: override !== null && override !== void 0 ? override : '”',
});
const openSingleQuote = (override) => core.textInputRule({
    find: /(?:^|[\s{[(<'"\u2018\u201C])(')$/,
    replace: override !== null && override !== void 0 ? override : '‘',
});
const closeSingleQuote = (override) => core.textInputRule({
    find: /'$/,
    replace: override !== null && override !== void 0 ? override : '’',
});
const leftArrow = (override) => core.textInputRule({
    find: /<-$/,
    replace: override !== null && override !== void 0 ? override : '←',
});
const rightArrow = (override) => core.textInputRule({
    find: /->$/,
    replace: override !== null && override !== void 0 ? override : '→',
});
const copyright = (override) => core.textInputRule({
    find: /\(c\)$/,
    replace: override !== null && override !== void 0 ? override : '©',
});
const trademark = (override) => core.textInputRule({
    find: /\(tm\)$/,
    replace: override !== null && override !== void 0 ? override : '™',
});
const servicemark = (override) => core.textInputRule({
    find: /\(sm\)$/,
    replace: override !== null && override !== void 0 ? override : '℠',
});
const registeredTrademark = (override) => core.textInputRule({
    find: /\(r\)$/,
    replace: override !== null && override !== void 0 ? override : '®',
});
const oneHalf = (override) => core.textInputRule({
    find: /(?:^|\s)(1\/2)\s$/,
    replace: override !== null && override !== void 0 ? override : '½',
});
const plusMinus = (override) => core.textInputRule({
    find: /\+\/-$/,
    replace: override !== null && override !== void 0 ? override : '±',
});
const notEqual = (override) => core.textInputRule({
    find: /!=$/,
    replace: override !== null && override !== void 0 ? override : '≠',
});
const laquo = (override) => core.textInputRule({
    find: /<<$/,
    replace: override !== null && override !== void 0 ? override : '«',
});
const raquo = (override) => core.textInputRule({
    find: />>$/,
    replace: override !== null && override !== void 0 ? override : '»',
});
const multiplication = (override) => core.textInputRule({
    find: /\d+\s?([*x])\s?\d+$/,
    replace: override !== null && override !== void 0 ? override : '×',
});
const superscriptTwo = (override) => core.textInputRule({
    find: /\^2$/,
    replace: override !== null && override !== void 0 ? override : '²',
});
const superscriptThree = (override) => core.textInputRule({
    find: /\^3$/,
    replace: override !== null && override !== void 0 ? override : '³',
});
const oneQuarter = (override) => core.textInputRule({
    find: /(?:^|\s)(1\/4)\s$/,
    replace: override !== null && override !== void 0 ? override : '¼',
});
const threeQuarters = (override) => core.textInputRule({
    find: /(?:^|\s)(3\/4)\s$/,
    replace: override !== null && override !== void 0 ? override : '¾',
});
/**
 * This extension allows you to add typography replacements for specific characters.
 * @see https://www.tiptap.dev/api/extensions/typography
 */
const Typography = core.Extension.create({
    name: 'typography',
    addOptions() {
        return {
            closeDoubleQuote: '”',
            closeSingleQuote: '’',
            copyright: '©',
            ellipsis: '…',
            emDash: '—',
            laquo: '«',
            leftArrow: '←',
            multiplication: '×',
            notEqual: '≠',
            oneHalf: '½',
            oneQuarter: '¼',
            openDoubleQuote: '“',
            openSingleQuote: '‘',
            plusMinus: '±',
            raquo: '»',
            registeredTrademark: '®',
            rightArrow: '→',
            servicemark: '℠',
            superscriptThree: '³',
            superscriptTwo: '²',
            threeQuarters: '¾',
            trademark: '™',
        };
    },
    addInputRules() {
        const rules = [];
        if (this.options.emDash !== false) {
            rules.push(emDash(this.options.emDash));
        }
        if (this.options.ellipsis !== false) {
            rules.push(ellipsis(this.options.ellipsis));
        }
        if (this.options.openDoubleQuote !== false) {
            rules.push(openDoubleQuote(this.options.openDoubleQuote));
        }
        if (this.options.closeDoubleQuote !== false) {
            rules.push(closeDoubleQuote(this.options.closeDoubleQuote));
        }
        if (this.options.openSingleQuote !== false) {
            rules.push(openSingleQuote(this.options.openSingleQuote));
        }
        if (this.options.closeSingleQuote !== false) {
            rules.push(closeSingleQuote(this.options.closeSingleQuote));
        }
        if (this.options.leftArrow !== false) {
            rules.push(leftArrow(this.options.leftArrow));
        }
        if (this.options.rightArrow !== false) {
            rules.push(rightArrow(this.options.rightArrow));
        }
        if (this.options.copyright !== false) {
            rules.push(copyright(this.options.copyright));
        }
        if (this.options.trademark !== false) {
            rules.push(trademark(this.options.trademark));
        }
        if (this.options.servicemark !== false) {
            rules.push(servicemark(this.options.servicemark));
        }
        if (this.options.registeredTrademark !== false) {
            rules.push(registeredTrademark(this.options.registeredTrademark));
        }
        if (this.options.oneHalf !== false) {
            rules.push(oneHalf(this.options.oneHalf));
        }
        if (this.options.plusMinus !== false) {
            rules.push(plusMinus(this.options.plusMinus));
        }
        if (this.options.notEqual !== false) {
            rules.push(notEqual(this.options.notEqual));
        }
        if (this.options.laquo !== false) {
            rules.push(laquo(this.options.laquo));
        }
        if (this.options.raquo !== false) {
            rules.push(raquo(this.options.raquo));
        }
        if (this.options.multiplication !== false) {
            rules.push(multiplication(this.options.multiplication));
        }
        if (this.options.superscriptTwo !== false) {
            rules.push(superscriptTwo(this.options.superscriptTwo));
        }
        if (this.options.superscriptThree !== false) {
            rules.push(superscriptThree(this.options.superscriptThree));
        }
        if (this.options.oneQuarter !== false) {
            rules.push(oneQuarter(this.options.oneQuarter));
        }
        if (this.options.threeQuarters !== false) {
            rules.push(threeQuarters(this.options.threeQuarters));
        }
        return rules;
    },
});

exports.Typography = Typography;
exports.closeDoubleQuote = closeDoubleQuote;
exports.closeSingleQuote = closeSingleQuote;
exports.copyright = copyright;
exports["default"] = Typography;
exports.ellipsis = ellipsis;
exports.emDash = emDash;
exports.laquo = laquo;
exports.leftArrow = leftArrow;
exports.multiplication = multiplication;
exports.notEqual = notEqual;
exports.oneHalf = oneHalf;
exports.oneQuarter = oneQuarter;
exports.openDoubleQuote = openDoubleQuote;
exports.openSingleQuote = openSingleQuote;
exports.plusMinus = plusMinus;
exports.raquo = raquo;
exports.registeredTrademark = registeredTrademark;
exports.rightArrow = rightArrow;
exports.servicemark = servicemark;
exports.superscriptThree = superscriptThree;
exports.superscriptTwo = superscriptTwo;
exports.threeQuarters = threeQuarters;
exports.trademark = trademark;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 12545:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);

/**
 * This extension allows you to create underline text.
 * @see https://www.tiptap.dev/api/marks/underline
 */
const Underline = core.Mark.create({
    name: 'underline',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 'u',
            },
            {
                style: 'text-decoration',
                consuming: false,
                getAttrs: style => (style.includes('underline') ? {} : false),
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['u', core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setUnderline: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleUnderline: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetUnderline: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-u': () => this.editor.commands.toggleUnderline(),
            'Mod-U': () => this.editor.commands.toggleUnderline(),
        };
    },
});

exports.Underline = Underline;
exports["default"] = Underline;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 99549:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true})); function _createStarExport(obj) { Object.keys(obj) .filter((key) => key !== "default" && key !== "__esModule") .forEach((key) => { if (exports.hasOwnProperty(key)) { return; } Object.defineProperty(exports, key, {enumerable: true, configurable: true, get: () => obj[key]}); }); }// commands/index.ts
var _prosemirrorcommands = __webpack_require__(49270); _createStarExport(_prosemirrorcommands);


/***/ }),

/***/ 42199:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true})); function _createStarExport(obj) { Object.keys(obj) .filter((key) => key !== "default" && key !== "__esModule") .forEach((key) => { if (exports.hasOwnProperty(key)) { return; } Object.defineProperty(exports, key, {enumerable: true, configurable: true, get: () => obj[key]}); }); }// dropcursor/index.ts
var _prosemirrordropcursor = __webpack_require__(31588); _createStarExport(_prosemirrordropcursor);


/***/ }),

/***/ 36116:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true})); function _createStarExport(obj) { Object.keys(obj) .filter((key) => key !== "default" && key !== "__esModule") .forEach((key) => { if (exports.hasOwnProperty(key)) { return; } Object.defineProperty(exports, key, {enumerable: true, configurable: true, get: () => obj[key]}); }); }// gapcursor/index.ts
var _prosemirrorgapcursor = __webpack_require__(81634); _createStarExport(_prosemirrorgapcursor);


/***/ }),

/***/ 21858:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true})); function _createStarExport(obj) { Object.keys(obj) .filter((key) => key !== "default" && key !== "__esModule") .forEach((key) => { if (exports.hasOwnProperty(key)) { return; } Object.defineProperty(exports, key, {enumerable: true, configurable: true, get: () => obj[key]}); }); }// history/index.ts
var _prosemirrorhistory = __webpack_require__(98638); _createStarExport(_prosemirrorhistory);


/***/ }),

/***/ 72222:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true})); function _createStarExport(obj) { Object.keys(obj) .filter((key) => key !== "default" && key !== "__esModule") .forEach((key) => { if (exports.hasOwnProperty(key)) { return; } Object.defineProperty(exports, key, {enumerable: true, configurable: true, get: () => obj[key]}); }); }// keymap/index.ts
var _prosemirrorkeymap = __webpack_require__(97354); _createStarExport(_prosemirrorkeymap);


/***/ }),

/***/ 37480:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true})); function _createStarExport(obj) { Object.keys(obj) .filter((key) => key !== "default" && key !== "__esModule") .forEach((key) => { if (exports.hasOwnProperty(key)) { return; } Object.defineProperty(exports, key, {enumerable: true, configurable: true, get: () => obj[key]}); }); }// model/index.ts
var _prosemirrormodel = __webpack_require__(19443); _createStarExport(_prosemirrormodel);


/***/ }),

/***/ 61818:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true})); function _createStarExport(obj) { Object.keys(obj) .filter((key) => key !== "default" && key !== "__esModule") .forEach((key) => { if (exports.hasOwnProperty(key)) { return; } Object.defineProperty(exports, key, {enumerable: true, configurable: true, get: () => obj[key]}); }); }// schema-list/index.ts
var _prosemirrorschemalist = __webpack_require__(74032); _createStarExport(_prosemirrorschemalist);


/***/ }),

/***/ 96297:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true})); function _createStarExport(obj) { Object.keys(obj) .filter((key) => key !== "default" && key !== "__esModule") .forEach((key) => { if (exports.hasOwnProperty(key)) { return; } Object.defineProperty(exports, key, {enumerable: true, configurable: true, get: () => obj[key]}); }); }// state/index.ts
var _prosemirrorstate = __webpack_require__(42391); _createStarExport(_prosemirrorstate);


/***/ }),

/***/ 26575:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true})); function _createStarExport(obj) { Object.keys(obj) .filter((key) => key !== "default" && key !== "__esModule") .forEach((key) => { if (exports.hasOwnProperty(key)) { return; } Object.defineProperty(exports, key, {enumerable: true, configurable: true, get: () => obj[key]}); }); }// tables/index.ts
var _prosemirrortables = __webpack_require__(31640); _createStarExport(_prosemirrortables);


/***/ }),

/***/ 78879:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true})); function _createStarExport(obj) { Object.keys(obj) .filter((key) => key !== "default" && key !== "__esModule") .forEach((key) => { if (exports.hasOwnProperty(key)) { return; } Object.defineProperty(exports, key, {enumerable: true, configurable: true, get: () => obj[key]}); }); }// transform/index.ts
var _prosemirrortransform = __webpack_require__(92843); _createStarExport(_prosemirrortransform);


/***/ }),

/***/ 40585:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true})); function _createStarExport(obj) { Object.keys(obj) .filter((key) => key !== "default" && key !== "__esModule") .forEach((key) => { if (exports.hasOwnProperty(key)) { return; } Object.defineProperty(exports, key, {enumerable: true, configurable: true, get: () => obj[key]}); }); }// view/index.ts
var _prosemirrorview = __webpack_require__(9222); _createStarExport(_prosemirrorview);


/***/ }),

/***/ 36179:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var extensionBubbleMenu = __webpack_require__(9330);
var React = __webpack_require__(82684);
var ReactDOM = __webpack_require__(85202);
var core = __webpack_require__(60148);
var extensionFloatingMenu = __webpack_require__(66836);

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var ReactDOM__default = /*#__PURE__*/_interopDefaultCompat(ReactDOM);

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var shim = {exports: {}};

var useSyncExternalStoreShim_production_min = {};

/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredUseSyncExternalStoreShim_production_min;

function requireUseSyncExternalStoreShim_production_min () {
	if (hasRequiredUseSyncExternalStoreShim_production_min) return useSyncExternalStoreShim_production_min;
	hasRequiredUseSyncExternalStoreShim_production_min = 1;
var e=React__default.default;function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c});},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c});})},[a]);p(d);return d}
	function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return !k(a,d)}catch(f){return !0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;useSyncExternalStoreShim_production_min.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;
	return useSyncExternalStoreShim_production_min;
}

var useSyncExternalStoreShim_development = {};

/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredUseSyncExternalStoreShim_development;

function requireUseSyncExternalStoreShim_development () {
	if (hasRequiredUseSyncExternalStoreShim_development) return useSyncExternalStoreShim_development;
	hasRequiredUseSyncExternalStoreShim_development = 1;

	if (false) {}
	return useSyncExternalStoreShim_development;
}

if (true) {
  shim.exports = requireUseSyncExternalStoreShim_production_min();
} else {}

var shimExports = shim.exports;

const mergeRefs = (...refs) => {
    return (node) => {
        refs.forEach(ref => {
            if (typeof ref === 'function') {
                ref(node);
            }
            else if (ref) {
                ref.current = node;
            }
        });
    };
};
/**
 * This component renders all of the editor's node views.
 */
const Portals = ({ contentComponent, }) => {
    // For performance reasons, we render the node view portals on state changes only
    const renderers = shimExports.useSyncExternalStore(contentComponent.subscribe, contentComponent.getSnapshot, contentComponent.getServerSnapshot);
    // This allows us to directly render the portals without any additional wrapper
    return (React__default.default.createElement(React__default.default.Fragment, null, Object.values(renderers)));
};
function getInstance() {
    const subscribers = new Set();
    let renderers = {};
    return {
        /**
         * Subscribe to the editor instance's changes.
         */
        subscribe(callback) {
            subscribers.add(callback);
            return () => {
                subscribers.delete(callback);
            };
        },
        getSnapshot() {
            return renderers;
        },
        getServerSnapshot() {
            return renderers;
        },
        /**
         * Adds a new NodeView Renderer to the editor.
         */
        setRenderer(id, renderer) {
            renderers = {
                ...renderers,
                [id]: ReactDOM__default.default.createPortal(renderer.reactElement, renderer.element, id),
            };
            subscribers.forEach(subscriber => subscriber());
        },
        /**
         * Removes a NodeView Renderer from the editor.
         */
        removeRenderer(id) {
            const nextRenderers = { ...renderers };
            delete nextRenderers[id];
            renderers = nextRenderers;
            subscribers.forEach(subscriber => subscriber());
        },
    };
}
class PureEditorContent extends React__default.default.Component {
    constructor(props) {
        var _a;
        super(props);
        this.editorContentRef = React__default.default.createRef();
        this.initialized = false;
        this.state = {
            hasContentComponentInitialized: Boolean((_a = props.editor) === null || _a === void 0 ? void 0 : _a.contentComponent),
        };
    }
    componentDidMount() {
        this.init();
    }
    componentDidUpdate() {
        this.init();
    }
    init() {
        const editor = this.props.editor;
        if (editor && !editor.isDestroyed && editor.options.element) {
            if (editor.contentComponent) {
                return;
            }
            const element = this.editorContentRef.current;
            element.append(...editor.options.element.childNodes);
            editor.setOptions({
                element,
            });
            editor.contentComponent = getInstance();
            // Has the content component been initialized?
            if (!this.state.hasContentComponentInitialized) {
                // Subscribe to the content component
                this.unsubscribeToContentComponent = editor.contentComponent.subscribe(() => {
                    this.setState(prevState => {
                        if (!prevState.hasContentComponentInitialized) {
                            return {
                                hasContentComponentInitialized: true,
                            };
                        }
                        return prevState;
                    });
                    // Unsubscribe to previous content component
                    if (this.unsubscribeToContentComponent) {
                        this.unsubscribeToContentComponent();
                    }
                });
            }
            editor.createNodeViews();
            this.initialized = true;
        }
    }
    componentWillUnmount() {
        const editor = this.props.editor;
        if (!editor) {
            return;
        }
        this.initialized = false;
        if (!editor.isDestroyed) {
            editor.view.setProps({
                nodeViews: {},
            });
        }
        if (this.unsubscribeToContentComponent) {
            this.unsubscribeToContentComponent();
        }
        editor.contentComponent = null;
        if (!editor.options.element.firstChild) {
            return;
        }
        const newElement = document.createElement('div');
        newElement.append(...editor.options.element.childNodes);
        editor.setOptions({
            element: newElement,
        });
    }
    render() {
        const { editor, innerRef, ...rest } = this.props;
        return (React__default.default.createElement(React__default.default.Fragment, null,
            React__default.default.createElement("div", { ref: mergeRefs(innerRef, this.editorContentRef), ...rest }),
            (editor === null || editor === void 0 ? void 0 : editor.contentComponent) && React__default.default.createElement(Portals, { contentComponent: editor.contentComponent })));
    }
}
// EditorContent should be re-created whenever the Editor instance changes
const EditorContentWithKey = React.forwardRef((props, ref) => {
    const key = React__default.default.useMemo(() => {
        return Math.floor(Math.random() * 0xffffffff).toString();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.editor]);
    // Can't use JSX here because it conflicts with the type definition of Vue's JSX, so use createElement
    return React__default.default.createElement(PureEditorContent, {
        key,
        innerRef: ref,
        ...props,
    });
});
const EditorContent = React__default.default.memo(EditorContentWithKey);

var react = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }


    if ((a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      for (i of a.entries())
        if (!equal(i[1], b.get(i[0]))) return false;
      return true;
    }

    if ((a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      return true;
    }

    if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }


    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        continue;
      }

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

var deepEqual = /*@__PURE__*/getDefaultExportFromCjs(react);

var withSelector = {exports: {}};

var withSelector_production_min = {};

/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredWithSelector_production_min;

function requireWithSelector_production_min () {
	if (hasRequiredWithSelector_production_min) return withSelector_production_min;
	hasRequiredWithSelector_production_min = 1;
var h=React__default.default,n=shimExports;function p(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var q="function"===typeof Object.is?Object.is:p,r=n.useSyncExternalStore,t=h.useRef,u=h.useEffect,v=h.useMemo,w=h.useDebugValue;
	withSelector_production_min.useSyncExternalStoreWithSelector=function(a,b,e,l,g){var c=t(null);if(null===c.current){var f={hasValue:!1,value:null};c.current=f;}else f=c.current;c=v(function(){function a(a){if(!c){c=!0;d=a;a=l(a);if(void 0!==g&&f.hasValue){var b=f.value;if(g(b,a))return k=b}return k=a}b=k;if(q(d,a))return b;var e=l(a);if(void 0!==g&&g(b,e))return b;d=a;return k=e}var c=!1,d,k,m=void 0===e?null:e;return [function(){return a(b())},null===m?void 0:function(){return a(m())}]},[b,e,l,g]);var d=r(a,c[0],c[1]);
	u(function(){f.hasValue=!0;f.value=d;},[d]);w(d);return d};
	return withSelector_production_min;
}

var withSelector_development = {};

/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredWithSelector_development;

function requireWithSelector_development () {
	if (hasRequiredWithSelector_development) return withSelector_development;
	hasRequiredWithSelector_development = 1;

	if (false) {}
	return withSelector_development;
}

if (true) {
  withSelector.exports = requireWithSelector_production_min();
} else {}

var withSelectorExports = withSelector.exports;

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
/**
 * To synchronize the editor instance with the component state,
 * we need to create a separate instance that is not affected by the component re-renders.
 */
class EditorStateManager {
    constructor(initialEditor) {
        this.transactionNumber = 0;
        this.lastTransactionNumber = 0;
        this.subscribers = new Set();
        this.editor = initialEditor;
        this.lastSnapshot = { editor: initialEditor, transactionNumber: 0 };
        this.getSnapshot = this.getSnapshot.bind(this);
        this.getServerSnapshot = this.getServerSnapshot.bind(this);
        this.watch = this.watch.bind(this);
        this.subscribe = this.subscribe.bind(this);
    }
    /**
     * Get the current editor instance.
     */
    getSnapshot() {
        if (this.transactionNumber === this.lastTransactionNumber) {
            return this.lastSnapshot;
        }
        this.lastTransactionNumber = this.transactionNumber;
        this.lastSnapshot = { editor: this.editor, transactionNumber: this.transactionNumber };
        return this.lastSnapshot;
    }
    /**
     * Always disable the editor on the server-side.
     */
    getServerSnapshot() {
        return { editor: null, transactionNumber: 0 };
    }
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(callback) {
        this.subscribers.add(callback);
        return () => {
            this.subscribers.delete(callback);
        };
    }
    /**
     * Watch the editor instance for changes.
     */
    watch(nextEditor) {
        this.editor = nextEditor;
        if (this.editor) {
            /**
             * This will force a re-render when the editor state changes.
             * This is to support things like `editor.can().toggleBold()` in components that `useEditor`.
             * This could be more efficient, but it's a good trade-off for now.
             */
            const fn = () => {
                this.transactionNumber += 1;
                this.subscribers.forEach(callback => callback());
            };
            const currentEditor = this.editor;
            currentEditor.on('transaction', fn);
            return () => {
                currentEditor.off('transaction', fn);
            };
        }
        return undefined;
    }
}
/**
 * This hook allows you to watch for changes on the editor instance.
 * It will allow you to select a part of the editor state and re-render the component when it changes.
 * @example
 * ```tsx
 * const editor = useEditor({...options})
 * const { currentSelection } = useEditorState({
 *  editor,
 *  selector: snapshot => ({ currentSelection: snapshot.editor.state.selection }),
 * })
 */
function useEditorState(options) {
    var _a;
    const [editorStateManager] = React.useState(() => new EditorStateManager(options.editor));
    // Using the `useSyncExternalStore` hook to sync the editor instance with the component state
    const selectedState = withSelectorExports.useSyncExternalStoreWithSelector(editorStateManager.subscribe, editorStateManager.getSnapshot, editorStateManager.getServerSnapshot, options.selector, (_a = options.equalityFn) !== null && _a !== void 0 ? _a : deepEqual);
    useIsomorphicLayoutEffect(() => {
        return editorStateManager.watch(options.editor);
    }, [options.editor, editorStateManager]);
    React.useDebugValue(selectedState);
    return selectedState;
}

const isDev = "production" !== 'production';
const isSSR = typeof window === 'undefined';
const isNext = isSSR || Boolean(typeof window !== 'undefined' && window.next);
/**
 * This class handles the creation, destruction, and re-creation of the editor instance.
 */
class EditorInstanceManager {
    constructor(options) {
        /**
         * The current editor instance.
         */
        this.editor = null;
        /**
         * The subscriptions to notify when the editor instance
         * has been created or destroyed.
         */
        this.subscriptions = new Set();
        /**
         * Whether the editor has been mounted.
         */
        this.isComponentMounted = false;
        /**
         * The most recent dependencies array.
         */
        this.previousDeps = null;
        /**
         * The unique instance ID. This is used to identify the editor instance. And will be re-generated for each new instance.
         */
        this.instanceId = '';
        this.options = options;
        this.subscriptions = new Set();
        this.setEditor(this.getInitialEditor());
        this.scheduleDestroy();
        this.getEditor = this.getEditor.bind(this);
        this.getServerSnapshot = this.getServerSnapshot.bind(this);
        this.subscribe = this.subscribe.bind(this);
        this.refreshEditorInstance = this.refreshEditorInstance.bind(this);
        this.scheduleDestroy = this.scheduleDestroy.bind(this);
        this.onRender = this.onRender.bind(this);
        this.createEditor = this.createEditor.bind(this);
    }
    setEditor(editor) {
        this.editor = editor;
        this.instanceId = Math.random().toString(36).slice(2, 9);
        // Notify all subscribers that the editor instance has been created
        this.subscriptions.forEach(cb => cb());
    }
    getInitialEditor() {
        if (this.options.current.immediatelyRender === undefined) {
            if (isSSR || isNext) {
                // TODO in the next major release, we should throw an error here
                if (isDev) {
                    /**
                     * Throw an error in development, to make sure the developer is aware that tiptap cannot be SSR'd
                     * and that they need to set `immediatelyRender` to `false` to avoid hydration mismatches.
                     */
                    console.warn('Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches.');
                }
                // Best faith effort in production, run the code in the legacy mode to avoid hydration mismatches and errors in production
                return null;
            }
            // Default to immediately rendering when client-side rendering
            return this.createEditor();
        }
        if (this.options.current.immediatelyRender && isSSR && isDev) {
            // Warn in development, to make sure the developer is aware that tiptap cannot be SSR'd, set `immediatelyRender` to `false` to avoid hydration mismatches.
            throw new Error('Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches.');
        }
        if (this.options.current.immediatelyRender) {
            return this.createEditor();
        }
        return null;
    }
    /**
     * Create a new editor instance. And attach event listeners.
     */
    createEditor() {
        const optionsToApply = {
            ...this.options.current,
            // Always call the most recent version of the callback function by default
            onBeforeCreate: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onBeforeCreate) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onBlur: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onBlur) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onCreate: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onCreate) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onDestroy: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onDestroy) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onFocus: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onFocus) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onSelectionUpdate: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onSelectionUpdate) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onTransaction: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onTransaction) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onUpdate: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onUpdate) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onContentError: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onContentError) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onDrop: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onDrop) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onPaste: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onPaste) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
        };
        const editor = new core.Editor(optionsToApply);
        // no need to keep track of the event listeners, they will be removed when the editor is destroyed
        return editor;
    }
    /**
     * Get the current editor instance.
     */
    getEditor() {
        return this.editor;
    }
    /**
     * Always disable the editor on the server-side.
     */
    getServerSnapshot() {
        return null;
    }
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(onStoreChange) {
        this.subscriptions.add(onStoreChange);
        return () => {
            this.subscriptions.delete(onStoreChange);
        };
    }
    static compareOptions(a, b) {
        return Object.keys(a).every(key => {
            if (['onCreate', 'onBeforeCreate', 'onDestroy', 'onUpdate', 'onTransaction', 'onFocus', 'onBlur', 'onSelectionUpdate', 'onContentError', 'onDrop', 'onPaste'].includes(key)) {
                // we don't want to compare callbacks, they are always different and only registered once
                return true;
            }
            // We often encourage putting extensions inlined in the options object, so we will do a slightly deeper comparison here
            if (key === 'extensions' && a.extensions && b.extensions) {
                if (a.extensions.length !== b.extensions.length) {
                    return false;
                }
                return a.extensions.every((extension, index) => {
                    var _a;
                    if (extension !== ((_a = b.extensions) === null || _a === void 0 ? void 0 : _a[index])) {
                        return false;
                    }
                    return true;
                });
            }
            if (a[key] !== b[key]) {
                // if any of the options have changed, we should update the editor options
                return false;
            }
            return true;
        });
    }
    /**
     * On each render, we will create, update, or destroy the editor instance.
     * @param deps The dependencies to watch for changes
     * @returns A cleanup function
     */
    onRender(deps) {
        // The returned callback will run on each render
        return () => {
            this.isComponentMounted = true;
            // Cleanup any scheduled destructions, since we are currently rendering
            clearTimeout(this.scheduledDestructionTimeout);
            if (this.editor && !this.editor.isDestroyed && deps.length === 0) {
                // if the editor does exist & deps are empty, we don't need to re-initialize the editor generally
                if (!EditorInstanceManager.compareOptions(this.options.current, this.editor.options)) {
                    // But, the options are different, so we need to update the editor options
                    // Still, this is faster than re-creating the editor
                    this.editor.setOptions({
                        ...this.options.current,
                        editable: this.editor.isEditable,
                    });
                }
            }
            else {
                // When the editor:
                // - does not yet exist
                // - is destroyed
                // - the deps array changes
                // We need to destroy the editor instance and re-initialize it
                this.refreshEditorInstance(deps);
            }
            return () => {
                this.isComponentMounted = false;
                this.scheduleDestroy();
            };
        };
    }
    /**
     * Recreate the editor instance if the dependencies have changed.
     */
    refreshEditorInstance(deps) {
        if (this.editor && !this.editor.isDestroyed) {
            // Editor instance already exists
            if (this.previousDeps === null) {
                // If lastDeps has not yet been initialized, reuse the current editor instance
                this.previousDeps = deps;
                return;
            }
            const depsAreEqual = this.previousDeps.length === deps.length
                && this.previousDeps.every((dep, index) => dep === deps[index]);
            if (depsAreEqual) {
                // deps exist and are equal, no need to recreate
                return;
            }
        }
        if (this.editor && !this.editor.isDestroyed) {
            // Destroy the editor instance if it exists
            this.editor.destroy();
        }
        this.setEditor(this.createEditor());
        // Update the lastDeps to the current deps
        this.previousDeps = deps;
    }
    /**
     * Schedule the destruction of the editor instance.
     * This will only destroy the editor if it was not mounted on the next tick.
     * This is to avoid destroying the editor instance when it's actually still mounted.
     */
    scheduleDestroy() {
        const currentInstanceId = this.instanceId;
        const currentEditor = this.editor;
        // Wait two ticks to see if the component is still mounted
        this.scheduledDestructionTimeout = setTimeout(() => {
            if (this.isComponentMounted && this.instanceId === currentInstanceId) {
                // If still mounted on the following tick, with the same instanceId, do not destroy the editor
                if (currentEditor) {
                    // just re-apply options as they might have changed
                    currentEditor.setOptions(this.options.current);
                }
                return;
            }
            if (currentEditor && !currentEditor.isDestroyed) {
                currentEditor.destroy();
                if (this.instanceId === currentInstanceId) {
                    this.setEditor(null);
                }
            }
            // This allows the effect to run again between ticks
            // which may save us from having to re-create the editor
        }, 1);
    }
}
function useEditor(options = {}, deps = []) {
    const mostRecentOptions = React.useRef(options);
    mostRecentOptions.current = options;
    const [instanceManager] = React.useState(() => new EditorInstanceManager(mostRecentOptions));
    const editor = shimExports.useSyncExternalStore(instanceManager.subscribe, instanceManager.getEditor, instanceManager.getServerSnapshot);
    React.useDebugValue(editor);
    // This effect will handle creating/updating the editor instance
    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(instanceManager.onRender(deps));
    // The default behavior is to re-render on each transaction
    // This is legacy behavior that will be removed in future versions
    useEditorState({
        editor,
        selector: ({ transactionNumber }) => {
            if (options.shouldRerenderOnTransaction === false) {
                // This will prevent the editor from re-rendering on each transaction
                return null;
            }
            // This will avoid re-rendering on the first transaction when `immediatelyRender` is set to `true`
            if (options.immediatelyRender && transactionNumber === 0) {
                return 0;
            }
            return transactionNumber + 1;
        },
    });
    return editor;
}

const EditorContext = React.createContext({
    editor: null,
});
const EditorConsumer = EditorContext.Consumer;
/**
 * A hook to get the current editor instance.
 */
const useCurrentEditor = () => React.useContext(EditorContext);
/**
 * This is the provider component for the editor.
 * It allows the editor to be accessible across the entire component tree
 * with `useCurrentEditor`.
 */
function EditorProvider({ children, slotAfter, slotBefore, editorContainerProps = {}, ...editorOptions }) {
    const editor = useEditor(editorOptions);
    if (!editor) {
        return null;
    }
    return (React__default.default.createElement(EditorContext.Provider, { value: { editor } },
        slotBefore,
        React__default.default.createElement(EditorConsumer, null, ({ editor: currentEditor }) => (React__default.default.createElement(EditorContent, { editor: currentEditor, ...editorContainerProps }))),
        children,
        slotAfter));
}

const BubbleMenu = (props) => {
    const [element, setElement] = React.useState(null);
    const { editor: currentEditor } = useCurrentEditor();
    React.useEffect(() => {
        var _a;
        if (!element) {
            return;
        }
        if (((_a = props.editor) === null || _a === void 0 ? void 0 : _a.isDestroyed) || (currentEditor === null || currentEditor === void 0 ? void 0 : currentEditor.isDestroyed)) {
            return;
        }
        const { pluginKey = 'bubbleMenu', editor, tippyOptions = {}, updateDelay, shouldShow = null, } = props;
        const menuEditor = editor || currentEditor;
        if (!menuEditor) {
            console.warn('BubbleMenu component is not rendered inside of an editor component or does not have editor prop.');
            return;
        }
        const plugin = extensionBubbleMenu.BubbleMenuPlugin({
            updateDelay,
            editor: menuEditor,
            element,
            pluginKey,
            shouldShow,
            tippyOptions,
        });
        menuEditor.registerPlugin(plugin);
        return () => { menuEditor.unregisterPlugin(pluginKey); };
    }, [props.editor, currentEditor, element]);
    return (React__default.default.createElement("div", { ref: setElement, className: props.className, style: { visibility: 'hidden' } }, props.children));
};

const FloatingMenu = (props) => {
    const [element, setElement] = React.useState(null);
    const { editor: currentEditor } = useCurrentEditor();
    React.useEffect(() => {
        var _a;
        if (!element) {
            return;
        }
        if (((_a = props.editor) === null || _a === void 0 ? void 0 : _a.isDestroyed) || (currentEditor === null || currentEditor === void 0 ? void 0 : currentEditor.isDestroyed)) {
            return;
        }
        const { pluginKey = 'floatingMenu', editor, tippyOptions = {}, shouldShow = null, } = props;
        const menuEditor = editor || currentEditor;
        if (!menuEditor) {
            console.warn('FloatingMenu component is not rendered inside of an editor component or does not have editor prop.');
            return;
        }
        const plugin = extensionFloatingMenu.FloatingMenuPlugin({
            pluginKey,
            editor: menuEditor,
            element,
            tippyOptions,
            shouldShow,
        });
        menuEditor.registerPlugin(plugin);
        return () => { menuEditor.unregisterPlugin(pluginKey); };
    }, [
        props.editor,
        currentEditor,
        element,
    ]);
    return (React__default.default.createElement("div", { ref: setElement, className: props.className, style: { visibility: 'hidden' } }, props.children));
};

const ReactNodeViewContext = React.createContext({
    onDragStart: undefined,
});
const useReactNodeView = () => React.useContext(ReactNodeViewContext);

const NodeViewContent = props => {
    const Tag = props.as || 'div';
    const { nodeViewContentRef } = useReactNodeView();
    return (
    // @ts-ignore
    React__default.default.createElement(Tag, { ...props, ref: nodeViewContentRef, "data-node-view-content": "", style: {
            whiteSpace: 'pre-wrap',
            ...props.style,
        } }));
};

const NodeViewWrapper = React__default.default.forwardRef((props, ref) => {
    const { onDragStart } = useReactNodeView();
    const Tag = props.as || 'div';
    return (
    // @ts-ignore
    React__default.default.createElement(Tag, { ...props, ref: ref, "data-node-view-wrapper": "", onDragStart: onDragStart, style: {
            whiteSpace: 'normal',
            ...props.style,
        } }));
});

/**
 * Check if a component is a class component.
 * @param Component
 * @returns {boolean}
 */
function isClassComponent(Component) {
    return !!(typeof Component === 'function'
        && Component.prototype
        && Component.prototype.isReactComponent);
}
/**
 * Check if a component is a forward ref component.
 * @param Component
 * @returns {boolean}
 */
function isForwardRefComponent(Component) {
    return !!(typeof Component === 'object'
        && Component.$$typeof
        && (Component.$$typeof.toString() === 'Symbol(react.forward_ref)'
            || Component.$$typeof.description === 'react.forward_ref'));
}
/**
 * Check if a component is a memoized component.
 * @param Component
 * @returns {boolean}
 */
function isMemoComponent(Component) {
    return !!(typeof Component === 'object'
        && Component.$$typeof
        && (Component.$$typeof.toString() === 'Symbol(react.memo)' || Component.$$typeof.description === 'react.memo'));
}
/**
 * Check if a component can safely receive a ref prop.
 * This includes class components, forwardRef components, and memoized components
 * that wrap forwardRef or class components.
 * @param Component
 * @returns {boolean}
 */
function canReceiveRef(Component) {
    // Check if it's a class component
    if (isClassComponent(Component)) {
        return true;
    }
    // Check if it's a forwardRef component
    if (isForwardRefComponent(Component)) {
        return true;
    }
    // Check if it's a memoized component
    if (isMemoComponent(Component)) {
        // For memoized components, check the wrapped component
        const wrappedComponent = Component.type;
        if (wrappedComponent) {
            return isClassComponent(wrappedComponent) || isForwardRefComponent(wrappedComponent);
        }
    }
    return false;
}
/**
 * Check if we're running React 19+ by detecting if function components support ref props
 * @returns {boolean}
 */
function isReact19Plus() {
    // React 19 is detected by checking React version if available
    // In practice, we'll use a more conservative approach and assume React 18 behavior
    // unless we can definitively detect React 19
    try {
        // @ts-ignore
        if (React.version) {
            const majorVersion = parseInt(React.version.split('.')[0], 10);
            return majorVersion >= 19;
        }
    }
    catch {
        // Fallback to React 18 behavior if we can't determine version
    }
    return false;
}
/**
 * The ReactRenderer class. It's responsible for rendering React components inside the editor.
 * @example
 * new ReactRenderer(MyComponent, {
 *   editor,
 *   props: {
 *     foo: 'bar',
 *   },
 *   as: 'span',
 * })
*/
class ReactRenderer {
    /**
     * Immediately creates element and renders the provided React component.
     */
    constructor(component, { editor, props = {}, as = 'div', className = '', }) {
        this.ref = null;
        this.id = Math.floor(Math.random() * 0xFFFFFFFF).toString();
        this.component = component;
        this.editor = editor;
        this.props = props;
        this.element = document.createElement(as);
        this.element.classList.add('react-renderer');
        if (className) {
            this.element.classList.add(...className.split(' '));
        }
        // If the editor is already initialized, we will need to
        // synchronously render the component to ensure it renders
        // together with Prosemirror's rendering.
        if (this.editor.isInitialized) {
            ReactDOM.flushSync(() => {
                this.render();
            });
        }
        else {
            queueMicrotask(() => {
                this.render();
            });
        }
    }
    /**
     * Render the React component.
     */
    render() {
        var _a;
        const Component = this.component;
        const props = this.props;
        const editor = this.editor;
        // Handle ref forwarding with React 18/19 compatibility
        const isReact19 = isReact19Plus();
        const componentCanReceiveRef = canReceiveRef(Component);
        const elementProps = { ...props };
        // Always remove ref if the component cannot receive it (unless React 19+)
        if (elementProps.ref && !(isReact19 || componentCanReceiveRef)) {
            delete elementProps.ref;
        }
        // Only assign our own ref if allowed
        if (!elementProps.ref && (isReact19 || componentCanReceiveRef)) {
            // @ts-ignore - Setting ref prop for compatible components
            elementProps.ref = (ref) => {
                this.ref = ref;
            };
        }
        this.reactElement = React__default.default.createElement(Component, { ...elementProps });
        (_a = editor === null || editor === void 0 ? void 0 : editor.contentComponent) === null || _a === void 0 ? void 0 : _a.setRenderer(this.id, this);
    }
    /**
     * Re-renders the React component with new props.
     */
    updateProps(props = {}) {
        this.props = {
            ...this.props,
            ...props,
        };
        this.render();
    }
    /**
     * Destroy the React component.
     */
    destroy() {
        var _a;
        const editor = this.editor;
        (_a = editor === null || editor === void 0 ? void 0 : editor.contentComponent) === null || _a === void 0 ? void 0 : _a.removeRenderer(this.id);
    }
    /**
     * Update the attributes of the element that holds the React component.
     */
    updateAttributes(attributes) {
        Object.keys(attributes).forEach(key => {
            this.element.setAttribute(key, attributes[key]);
        });
    }
}

class ReactNodeView extends core.NodeView {
    constructor(component, props, options) {
        super(component, props, options);
        if (!this.node.isLeaf) {
            if (this.options.contentDOMElementTag) {
                this.contentDOMElement = document.createElement(this.options.contentDOMElementTag);
            }
            else {
                this.contentDOMElement = document.createElement(this.node.isInline ? 'span' : 'div');
            }
            this.contentDOMElement.dataset.nodeViewContentReact = '';
            this.contentDOMElement.dataset.nodeViewWrapper = '';
            // For some reason the whiteSpace prop is not inherited properly in Chrome and Safari
            // With this fix it seems to work fine
            // See: https://github.com/ueberdosis/tiptap/issues/1197
            this.contentDOMElement.style.whiteSpace = 'inherit';
            const contentTarget = this.dom.querySelector('[data-node-view-content]');
            if (!contentTarget) {
                return;
            }
            contentTarget.appendChild(this.contentDOMElement);
        }
    }
    /**
     * Setup the React component.
     * Called on initialization.
     */
    mount() {
        const props = {
            editor: this.editor,
            node: this.node,
            decorations: this.decorations,
            innerDecorations: this.innerDecorations,
            view: this.view,
            selected: false,
            extension: this.extension,
            HTMLAttributes: this.HTMLAttributes,
            getPos: () => this.getPos(),
            updateAttributes: (attributes = {}) => this.updateAttributes(attributes),
            deleteNode: () => this.deleteNode(),
            ref: React.createRef(),
        };
        if (!this.component.displayName) {
            const capitalizeFirstChar = (string) => {
                return string.charAt(0).toUpperCase() + string.substring(1);
            };
            this.component.displayName = capitalizeFirstChar(this.extension.name);
        }
        const onDragStart = this.onDragStart.bind(this);
        const nodeViewContentRef = element => {
            if (element && this.contentDOMElement && element.firstChild !== this.contentDOMElement) {
                // remove the nodeViewWrapper attribute from the element
                if (element.hasAttribute('data-node-view-wrapper')) {
                    element.removeAttribute('data-node-view-wrapper');
                }
                element.appendChild(this.contentDOMElement);
            }
        };
        const context = { onDragStart, nodeViewContentRef };
        const Component = this.component;
        // For performance reasons, we memoize the provider component
        // And all of the things it requires are declared outside of the component, so it doesn't need to re-render
        const ReactNodeViewProvider = React.memo(componentProps => {
            return (React__default.default.createElement(ReactNodeViewContext.Provider, { value: context }, React.createElement(Component, componentProps)));
        });
        ReactNodeViewProvider.displayName = 'ReactNodeView';
        let as = this.node.isInline ? 'span' : 'div';
        if (this.options.as) {
            as = this.options.as;
        }
        const { className = '' } = this.options;
        this.handleSelectionUpdate = this.handleSelectionUpdate.bind(this);
        this.renderer = new ReactRenderer(ReactNodeViewProvider, {
            editor: this.editor,
            props,
            as,
            className: `node-${this.node.type.name} ${className}`.trim(),
        });
        this.editor.on('selectionUpdate', this.handleSelectionUpdate);
        this.updateElementAttributes();
    }
    /**
     * Return the DOM element.
     * This is the element that will be used to display the node view.
     */
    get dom() {
        var _a;
        if (this.renderer.element.firstElementChild
            && !((_a = this.renderer.element.firstElementChild) === null || _a === void 0 ? void 0 : _a.hasAttribute('data-node-view-wrapper'))) {
            throw Error('Please use the NodeViewWrapper component for your node view.');
        }
        return this.renderer.element;
    }
    /**
     * Return the content DOM element.
     * This is the element that will be used to display the rich-text content of the node.
     */
    get contentDOM() {
        if (this.node.isLeaf) {
            return null;
        }
        return this.contentDOMElement;
    }
    /**
     * On editor selection update, check if the node is selected.
     * If it is, call `selectNode`, otherwise call `deselectNode`.
     */
    handleSelectionUpdate() {
        const { from, to } = this.editor.state.selection;
        const pos = this.getPos();
        if (typeof pos !== 'number') {
            return;
        }
        if (from <= pos && to >= pos + this.node.nodeSize) {
            if (this.renderer.props.selected) {
                return;
            }
            this.selectNode();
        }
        else {
            if (!this.renderer.props.selected) {
                return;
            }
            this.deselectNode();
        }
    }
    /**
     * On update, update the React component.
     * To prevent unnecessary updates, the `update` option can be used.
     */
    update(node, decorations, innerDecorations) {
        const rerenderComponent = (props) => {
            this.renderer.updateProps(props);
            if (typeof this.options.attrs === 'function') {
                this.updateElementAttributes();
            }
        };
        if (node.type !== this.node.type) {
            return false;
        }
        if (typeof this.options.update === 'function') {
            const oldNode = this.node;
            const oldDecorations = this.decorations;
            const oldInnerDecorations = this.innerDecorations;
            this.node = node;
            this.decorations = decorations;
            this.innerDecorations = innerDecorations;
            return this.options.update({
                oldNode,
                oldDecorations,
                newNode: node,
                newDecorations: decorations,
                oldInnerDecorations,
                innerDecorations,
                updateProps: () => rerenderComponent({ node, decorations, innerDecorations }),
            });
        }
        if (node === this.node
            && this.decorations === decorations
            && this.innerDecorations === innerDecorations) {
            return true;
        }
        this.node = node;
        this.decorations = decorations;
        this.innerDecorations = innerDecorations;
        rerenderComponent({ node, decorations, innerDecorations });
        return true;
    }
    /**
     * Select the node.
     * Add the `selected` prop and the `ProseMirror-selectednode` class.
     */
    selectNode() {
        this.renderer.updateProps({
            selected: true,
        });
        this.renderer.element.classList.add('ProseMirror-selectednode');
    }
    /**
     * Deselect the node.
     * Remove the `selected` prop and the `ProseMirror-selectednode` class.
     */
    deselectNode() {
        this.renderer.updateProps({
            selected: false,
        });
        this.renderer.element.classList.remove('ProseMirror-selectednode');
    }
    /**
     * Destroy the React component instance.
     */
    destroy() {
        this.renderer.destroy();
        this.editor.off('selectionUpdate', this.handleSelectionUpdate);
        this.contentDOMElement = null;
    }
    /**
     * Update the attributes of the top-level element that holds the React component.
     * Applying the attributes defined in the `attrs` option.
     */
    updateElementAttributes() {
        if (this.options.attrs) {
            let attrsObj = {};
            if (typeof this.options.attrs === 'function') {
                const extensionAttributes = this.editor.extensionManager.attributes;
                const HTMLAttributes = core.getRenderedAttributes(this.node, extensionAttributes);
                attrsObj = this.options.attrs({ node: this.node, HTMLAttributes });
            }
            else {
                attrsObj = this.options.attrs;
            }
            this.renderer.updateAttributes(attrsObj);
        }
    }
}
/**
 * Create a React node view renderer.
 */
function ReactNodeViewRenderer(component, options) {
    return props => {
        // try to get the parent component
        // this is important for vue devtools to show the component hierarchy correctly
        // maybe it’s `undefined` because <editor-content> isn’t rendered yet
        if (!props.editor.contentComponent) {
            return {};
        }
        return new ReactNodeView(component, props, options);
    };
}

exports.BubbleMenu = BubbleMenu;
exports.EditorConsumer = EditorConsumer;
exports.EditorContent = EditorContent;
exports.EditorContext = EditorContext;
exports.EditorProvider = EditorProvider;
exports.FloatingMenu = FloatingMenu;
exports.NodeViewContent = NodeViewContent;
exports.NodeViewWrapper = NodeViewWrapper;
exports.PureEditorContent = PureEditorContent;
exports.ReactNodeView = ReactNodeView;
exports.ReactNodeViewContext = ReactNodeViewContext;
exports.ReactNodeViewRenderer = ReactNodeViewRenderer;
exports.ReactRenderer = ReactRenderer;
exports.useCurrentEditor = useCurrentEditor;
exports.useEditor = useEditor;
exports.useEditorState = useEditorState;
exports.useReactNodeView = useReactNodeView;
Object.keys(core).forEach(function (k) {
	if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
		enumerable: true,
		get: function () { return core[k]; }
	});
});
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 65988:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var core = __webpack_require__(60148);
var extensionBlockquote = __webpack_require__(32707);
var extensionBold = __webpack_require__(65208);
var extensionBulletList = __webpack_require__(74053);
var extensionCode = __webpack_require__(40669);
var extensionCodeBlock = __webpack_require__(74582);
var extensionDocument = __webpack_require__(92419);
var extensionDropcursor = __webpack_require__(16000);
var extensionGapcursor = __webpack_require__(64485);
var extensionHardBreak = __webpack_require__(46959);
var extensionHeading = __webpack_require__(58071);
var extensionHistory = __webpack_require__(9044);
var extensionHorizontalRule = __webpack_require__(57705);
var extensionItalic = __webpack_require__(32795);
var extensionListItem = __webpack_require__(42384);
var extensionOrderedList = __webpack_require__(25089);
var extensionParagraph = __webpack_require__(48150);
var extensionStrike = __webpack_require__(13228);
var extensionText = __webpack_require__(76727);

/**
 * The starter kit is a collection of essential editor extensions.
 *
 * It’s a good starting point for building your own editor.
 */
const StarterKit = core.Extension.create({
    name: 'starterKit',
    addExtensions() {
        const extensions = [];
        if (this.options.bold !== false) {
            extensions.push(extensionBold.Bold.configure(this.options.bold));
        }
        if (this.options.blockquote !== false) {
            extensions.push(extensionBlockquote.Blockquote.configure(this.options.blockquote));
        }
        if (this.options.bulletList !== false) {
            extensions.push(extensionBulletList.BulletList.configure(this.options.bulletList));
        }
        if (this.options.code !== false) {
            extensions.push(extensionCode.Code.configure(this.options.code));
        }
        if (this.options.codeBlock !== false) {
            extensions.push(extensionCodeBlock.CodeBlock.configure(this.options.codeBlock));
        }
        if (this.options.document !== false) {
            extensions.push(extensionDocument.Document.configure(this.options.document));
        }
        if (this.options.dropcursor !== false) {
            extensions.push(extensionDropcursor.Dropcursor.configure(this.options.dropcursor));
        }
        if (this.options.gapcursor !== false) {
            extensions.push(extensionGapcursor.Gapcursor.configure(this.options.gapcursor));
        }
        if (this.options.hardBreak !== false) {
            extensions.push(extensionHardBreak.HardBreak.configure(this.options.hardBreak));
        }
        if (this.options.heading !== false) {
            extensions.push(extensionHeading.Heading.configure(this.options.heading));
        }
        if (this.options.history !== false) {
            extensions.push(extensionHistory.History.configure(this.options.history));
        }
        if (this.options.horizontalRule !== false) {
            extensions.push(extensionHorizontalRule.HorizontalRule.configure(this.options.horizontalRule));
        }
        if (this.options.italic !== false) {
            extensions.push(extensionItalic.Italic.configure(this.options.italic));
        }
        if (this.options.listItem !== false) {
            extensions.push(extensionListItem.ListItem.configure(this.options.listItem));
        }
        if (this.options.orderedList !== false) {
            extensions.push(extensionOrderedList.OrderedList.configure(this.options.orderedList));
        }
        if (this.options.paragraph !== false) {
            extensions.push(extensionParagraph.Paragraph.configure(this.options.paragraph));
        }
        if (this.options.strike !== false) {
            extensions.push(extensionStrike.Strike.configure(this.options.strike));
        }
        if (this.options.text !== false) {
            extensions.push(extensionText.Text.configure(this.options.text));
        }
        return extensions;
    },
});

exports.StarterKit = StarterKit;
exports["default"] = StarterKit;
//# sourceMappingURL=index.cjs.map


/***/ }),

/***/ 86939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(58692);
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 44512:
/***/ (function(module) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 28440:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(86939);
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 61929:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(57288)["default"]);
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 58692:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(57288)["default"]);
var toPrimitive = __webpack_require__(61929);
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 57288:
/***/ (function(module) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 68925:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
  'use strict';

  var hasOwn = {}.hasOwnProperty;
  function classNames() {
    var classes = '';
    for (var i = 0; i < arguments.length; i++) {
      var arg = arguments[i];
      if (arg) {
        classes = appendClass(classes, parseValue(arg));
      }
    }
    return classes;
  }
  function parseValue(arg) {
    if (typeof arg === 'string' || typeof arg === 'number') {
      return arg;
    }
    if (typeof arg !== 'object') {
      return '';
    }
    if (Array.isArray(arg)) {
      return classNames.apply(null, arg);
    }
    if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
      return arg.toString();
    }
    var classes = '';
    for (var key in arg) {
      if (hasOwn.call(arg, key) && arg[key]) {
        classes = appendClass(classes, key);
      }
    }
    return classes;
  }
  function appendClass(value, newClass) {
    if (!newClass) {
      return value;
    }
    if (value) {
      return value + ' ' + newClass;
    }
    return value + newClass;
  }
  if ( true && module.exports) {
    classNames.default = classNames;
    module.exports = classNames;
  } else if (true) {
    // register as 'classnames', consistent with npm package name
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return classNames;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})();

/***/ }),

/***/ 36586:
/***/ (function(module) {

"use strict";


// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function OrderedMap(content) {
  this.content = content;
}

OrderedMap.prototype = {
  constructor: OrderedMap,

  find: function(key) {
    for (var i = 0; i < this.content.length; i += 2)
      if (this.content[i] === key) return i
    return -1
  },

  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(key) {
    var found = this.find(key);
    return found == -1 ? undefined : this.content[found + 1]
  },

  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(key, value, newKey) {
    var self = newKey && newKey != key ? this.remove(newKey) : this;
    var found = self.find(key), content = self.content.slice();
    if (found == -1) {
      content.push(newKey || key, value);
    } else {
      content[found + 1] = value;
      if (newKey) content[found] = newKey;
    }
    return new OrderedMap(content)
  },

  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(key) {
    var found = this.find(key);
    if (found == -1) return this
    var content = this.content.slice();
    content.splice(found, 2);
    return new OrderedMap(content)
  },

  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(key, value) {
    return new OrderedMap([key, value].concat(this.remove(key).content))
  },

  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(key, value) {
    var content = this.remove(key).content.slice();
    content.push(key, value);
    return new OrderedMap(content)
  },

  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(place, key, value) {
    var without = this.remove(key), content = without.content.slice();
    var found = without.find(place);
    content.splice(found == -1 ? content.length : found, 0, key, value);
    return new OrderedMap(content)
  },

  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(f) {
    for (var i = 0; i < this.content.length; i += 2)
      f(this.content[i], this.content[i + 1]);
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(map) {
    map = OrderedMap.from(map);
    if (!map.size) return this
    return new OrderedMap(map.content.concat(this.subtract(map).content))
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(map) {
    map = OrderedMap.from(map);
    if (!map.size) return this
    return new OrderedMap(this.subtract(map).content.concat(map.content))
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(map) {
    var result = this;
    map = OrderedMap.from(map);
    for (var i = 0; i < map.content.length; i += 2)
      result = result.remove(map.content[i]);
    return result
  },

  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var result = {};
    this.forEach(function(key, value) { result[key] = value; });
    return result
  },

  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1
  }
};

// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
OrderedMap.from = function(value) {
  if (value instanceof OrderedMap) return value
  var content = [];
  if (value) for (var prop in value) content.push(prop, value[prop]);
  return new OrderedMap(content)
};

module.exports = OrderedMap;


/***/ }),

/***/ 49270:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var prosemirrorTransform = __webpack_require__(92843);
var prosemirrorModel = __webpack_require__(19443);
var prosemirrorState = __webpack_require__(42391);
var deleteSelection = function deleteSelection(state, dispatch) {
  if (state.selection.empty) return false;
  if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
  return true;
};
function atBlockStart(state, view) {
  var $cursor = state.selection.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
  return $cursor;
}
var joinBackward = function joinBackward(state, dispatch, view) {
  var $cursor = atBlockStart(state, view);
  if (!$cursor) return false;
  var $cut = findCutBefore($cursor);
  if (!$cut) {
    var range = $cursor.blockRange(),
      target = range && prosemirrorTransform.liftTarget(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
  }
  var before = $cut.nodeBefore;
  if (deleteBarrier(state, $cut, dispatch, -1)) return true;
  if ($cursor.parent.content.size == 0 && (textblockAt(before, "end") || prosemirrorState.NodeSelection.isSelectable(before))) {
    for (var depth = $cursor.depth;; depth--) {
      var delStep = prosemirrorTransform.replaceStep(state.doc, $cursor.before(depth), $cursor.after(depth), prosemirrorModel.Slice.empty);
      if (delStep && delStep.slice.size < delStep.to - delStep.from) {
        if (dispatch) {
          var tr = state.tr.step(delStep);
          tr.setSelection(textblockAt(before, "end") ? prosemirrorState.Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : prosemirrorState.NodeSelection.create(tr.doc, $cut.pos - before.nodeSize));
          dispatch(tr.scrollIntoView());
        }
        return true;
      }
      if (depth == 1 || $cursor.node(depth - 1).childCount > 1) break;
    }
  }
  if (before.isAtom && $cut.depth == $cursor.depth - 1) {
    if (dispatch) dispatch(state.tr["delete"]($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
    return true;
  }
  return false;
};
var joinTextblockBackward = function joinTextblockBackward(state, dispatch, view) {
  var $cursor = atBlockStart(state, view);
  if (!$cursor) return false;
  var $cut = findCutBefore($cursor);
  return $cut ? joinTextblocksAround(state, $cut, dispatch) : false;
};
var joinTextblockForward = function joinTextblockForward(state, dispatch, view) {
  var $cursor = atBlockEnd(state, view);
  if (!$cursor) return false;
  var $cut = findCutAfter($cursor);
  return $cut ? joinTextblocksAround(state, $cut, dispatch) : false;
};
function joinTextblocksAround(state, $cut, dispatch) {
  var before = $cut.nodeBefore,
    beforeText = before,
    beforePos = $cut.pos - 1;
  for (; !beforeText.isTextblock; beforePos--) {
    if (beforeText.type.spec.isolating) return false;
    var child = beforeText.lastChild;
    if (!child) return false;
    beforeText = child;
  }
  var after = $cut.nodeAfter,
    afterText = after,
    afterPos = $cut.pos + 1;
  for (; !afterText.isTextblock; afterPos++) {
    if (afterText.type.spec.isolating) return false;
    var _child = afterText.firstChild;
    if (!_child) return false;
    afterText = _child;
  }
  var step = prosemirrorTransform.replaceStep(state.doc, beforePos, afterPos, prosemirrorModel.Slice.empty);
  if (!step || step.from != beforePos || step instanceof prosemirrorTransform.ReplaceStep && step.slice.size >= afterPos - beforePos) return false;
  if (dispatch) {
    var tr = state.tr.step(step);
    tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, beforePos));
    dispatch(tr.scrollIntoView());
  }
  return true;
}
function textblockAt(node, side) {
  var only = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  for (var scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild) {
    if (scan.isTextblock) return true;
    if (only && scan.childCount != 1) return false;
  }
  return false;
}
var selectNodeBackward = function selectNodeBackward(state, dispatch, view) {
  var _state$selection = state.selection,
    $head = _state$selection.$head,
    empty = _state$selection.empty,
    $cut = $head;
  if (!empty) return false;
  if ($head.parent.isTextblock) {
    if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
    $cut = findCutBefore($head);
  }
  var node = $cut && $cut.nodeBefore;
  if (!node || !prosemirrorState.NodeSelection.isSelectable(node)) return false;
  if (dispatch) dispatch(state.tr.setSelection(prosemirrorState.NodeSelection.create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
  return true;
};
function findCutBefore($pos) {
  if (!$pos.parent.type.spec.isolating) for (var i = $pos.depth - 1; i >= 0; i--) {
    if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
    if ($pos.node(i).type.spec.isolating) break;
  }
  return null;
}
function atBlockEnd(state, view) {
  var $cursor = state.selection.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
  return $cursor;
}
var joinForward = function joinForward(state, dispatch, view) {
  var $cursor = atBlockEnd(state, view);
  if (!$cursor) return false;
  var $cut = findCutAfter($cursor);
  if (!$cut) return false;
  var after = $cut.nodeAfter;
  if (deleteBarrier(state, $cut, dispatch, 1)) return true;
  if ($cursor.parent.content.size == 0 && (textblockAt(after, "start") || prosemirrorState.NodeSelection.isSelectable(after))) {
    var delStep = prosemirrorTransform.replaceStep(state.doc, $cursor.before(), $cursor.after(), prosemirrorModel.Slice.empty);
    if (delStep && delStep.slice.size < delStep.to - delStep.from) {
      if (dispatch) {
        var tr = state.tr.step(delStep);
        tr.setSelection(textblockAt(after, "start") ? prosemirrorState.Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : prosemirrorState.NodeSelection.create(tr.doc, tr.mapping.map($cut.pos)));
        dispatch(tr.scrollIntoView());
      }
      return true;
    }
  }
  if (after.isAtom && $cut.depth == $cursor.depth - 1) {
    if (dispatch) dispatch(state.tr["delete"]($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
    return true;
  }
  return false;
};
var selectNodeForward = function selectNodeForward(state, dispatch, view) {
  var _state$selection2 = state.selection,
    $head = _state$selection2.$head,
    empty = _state$selection2.empty,
    $cut = $head;
  if (!empty) return false;
  if ($head.parent.isTextblock) {
    if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
    $cut = findCutAfter($head);
  }
  var node = $cut && $cut.nodeAfter;
  if (!node || !prosemirrorState.NodeSelection.isSelectable(node)) return false;
  if (dispatch) dispatch(state.tr.setSelection(prosemirrorState.NodeSelection.create(state.doc, $cut.pos)).scrollIntoView());
  return true;
};
function findCutAfter($pos) {
  if (!$pos.parent.type.spec.isolating) for (var i = $pos.depth - 1; i >= 0; i--) {
    var parent = $pos.node(i);
    if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
    if (parent.type.spec.isolating) break;
  }
  return null;
}
var joinUp = function joinUp(state, dispatch) {
  var sel = state.selection,
    nodeSel = sel instanceof prosemirrorState.NodeSelection,
    point;
  if (nodeSel) {
    if (sel.node.isTextblock || !prosemirrorTransform.canJoin(state.doc, sel.from)) return false;
    point = sel.from;
  } else {
    point = prosemirrorTransform.joinPoint(state.doc, sel.from, -1);
    if (point == null) return false;
  }
  if (dispatch) {
    var tr = state.tr.join(point);
    if (nodeSel) tr.setSelection(prosemirrorState.NodeSelection.create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
    dispatch(tr.scrollIntoView());
  }
  return true;
};
var joinDown = function joinDown(state, dispatch) {
  var sel = state.selection,
    point;
  if (sel instanceof prosemirrorState.NodeSelection) {
    if (sel.node.isTextblock || !prosemirrorTransform.canJoin(state.doc, sel.to)) return false;
    point = sel.to;
  } else {
    point = prosemirrorTransform.joinPoint(state.doc, sel.to, 1);
    if (point == null) return false;
  }
  if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
  return true;
};
var lift = function lift(state, dispatch) {
  var _state$selection3 = state.selection,
    $from = _state$selection3.$from,
    $to = _state$selection3.$to;
  var range = $from.blockRange($to),
    target = range && prosemirrorTransform.liftTarget(range);
  if (target == null) return false;
  if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
  return true;
};
var newlineInCode = function newlineInCode(state, dispatch) {
  var _state$selection4 = state.selection,
    $head = _state$selection4.$head,
    $anchor = _state$selection4.$anchor;
  if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
  if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
  return true;
};
function defaultBlockAt(match) {
  for (var i = 0; i < match.edgeCount; i++) {
    var _match$edge = match.edge(i),
      type = _match$edge.type;
    if (type.isTextblock && !type.hasRequiredAttrs()) return type;
  }
  return null;
}
var exitCode = function exitCode(state, dispatch) {
  var _state$selection5 = state.selection,
    $head = _state$selection5.$head,
    $anchor = _state$selection5.$anchor;
  if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
  var above = $head.node(-1),
    after = $head.indexAfter(-1),
    type = defaultBlockAt(above.contentMatchAt(after));
  if (!type || !above.canReplaceWith(after, after, type)) return false;
  if (dispatch) {
    var pos = $head.after(),
      tr = state.tr.replaceWith(pos, pos, type.createAndFill());
    tr.setSelection(prosemirrorState.Selection.near(tr.doc.resolve(pos), 1));
    dispatch(tr.scrollIntoView());
  }
  return true;
};
var createParagraphNear = function createParagraphNear(state, dispatch) {
  var sel = state.selection,
    $from = sel.$from,
    $to = sel.$to;
  if (sel instanceof prosemirrorState.AllSelection || $from.parent.inlineContent || $to.parent.inlineContent) return false;
  var type = defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
  if (!type || !type.isTextblock) return false;
  if (dispatch) {
    var side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
    var tr = state.tr.insert(side, type.createAndFill());
    tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, side + 1));
    dispatch(tr.scrollIntoView());
  }
  return true;
};
var liftEmptyBlock = function liftEmptyBlock(state, dispatch) {
  var $cursor = state.selection.$cursor;
  if (!$cursor || $cursor.parent.content.size) return false;
  if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
    var before = $cursor.before();
    if (prosemirrorTransform.canSplit(state.doc, before)) {
      if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
      return true;
    }
  }
  var range = $cursor.blockRange(),
    target = range && prosemirrorTransform.liftTarget(range);
  if (target == null) return false;
  if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
  return true;
};
function splitBlockAs(splitNode) {
  return function (state, dispatch) {
    var _state$selection6 = state.selection,
      $from = _state$selection6.$from,
      $to = _state$selection6.$to;
    if (state.selection instanceof prosemirrorState.NodeSelection && state.selection.node.isBlock) {
      if (!$from.parentOffset || !prosemirrorTransform.canSplit(state.doc, $from.pos)) return false;
      if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
      return true;
    }
    if (!$from.depth) return false;
    var types = [];
    var splitDepth,
      deflt,
      atEnd = false,
      atStart = false;
    for (var d = $from.depth;; d--) {
      var node = $from.node(d);
      if (node.isBlock) {
        atEnd = $from.end(d) == $from.pos + ($from.depth - d);
        atStart = $from.start(d) == $from.pos - ($from.depth - d);
        deflt = defaultBlockAt($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
        var splitType = splitNode && splitNode($to.parent, atEnd, $from);
        types.unshift(splitType || (atEnd && deflt ? {
          type: deflt
        } : null));
        splitDepth = d;
        break;
      } else {
        if (d == 1) return false;
        types.unshift(null);
      }
    }
    var tr = state.tr;
    if (state.selection instanceof prosemirrorState.TextSelection || state.selection instanceof prosemirrorState.AllSelection) tr.deleteSelection();
    var splitPos = tr.mapping.map($from.pos);
    var can = prosemirrorTransform.canSplit(tr.doc, splitPos, types.length, types);
    if (!can) {
      types[0] = deflt ? {
        type: deflt
      } : null;
      can = prosemirrorTransform.canSplit(tr.doc, splitPos, types.length, types);
    }
    if (!can) return false;
    tr.split(splitPos, types.length, types);
    if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
      var first = tr.mapping.map($from.before(splitDepth)),
        $first = tr.doc.resolve(first);
      if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before(splitDepth)), deflt);
    }
    if (dispatch) dispatch(tr.scrollIntoView());
    return true;
  };
}
var splitBlock = splitBlockAs();
var splitBlockKeepMarks = function splitBlockKeepMarks(state, dispatch) {
  return splitBlock(state, dispatch && function (tr) {
    var marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
    if (marks) tr.ensureMarks(marks);
    dispatch(tr);
  });
};
var selectParentNode = function selectParentNode(state, dispatch) {
  var _state$selection7 = state.selection,
    $from = _state$selection7.$from,
    to = _state$selection7.to,
    pos;
  var same = $from.sharedDepth(to);
  if (same == 0) return false;
  pos = $from.before(same);
  if (dispatch) dispatch(state.tr.setSelection(prosemirrorState.NodeSelection.create(state.doc, pos)));
  return true;
};
var selectAll = function selectAll(state, dispatch) {
  if (dispatch) dispatch(state.tr.setSelection(new prosemirrorState.AllSelection(state.doc)));
  return true;
};
function joinMaybeClear(state, $pos, dispatch) {
  var before = $pos.nodeBefore,
    after = $pos.nodeAfter,
    index = $pos.index();
  if (!before || !after || !before.type.compatibleContent(after.type)) return false;
  if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
    if (dispatch) dispatch(state.tr["delete"]($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
    return true;
  }
  if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || prosemirrorTransform.canJoin(state.doc, $pos.pos))) return false;
  if (dispatch) dispatch(state.tr.join($pos.pos).scrollIntoView());
  return true;
}
function deleteBarrier(state, $cut, dispatch, dir) {
  var before = $cut.nodeBefore,
    after = $cut.nodeAfter,
    conn,
    match;
  var isolated = before.type.spec.isolating || after.type.spec.isolating;
  if (!isolated && joinMaybeClear(state, $cut, dispatch)) return true;
  var canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
  if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
    if (dispatch) {
      var end = $cut.pos + after.nodeSize,
        wrap = prosemirrorModel.Fragment.empty;
      for (var i = conn.length - 1; i >= 0; i--) wrap = prosemirrorModel.Fragment.from(conn[i].create(null, wrap));
      wrap = prosemirrorModel.Fragment.from(before.copy(wrap));
      var tr = state.tr.step(new prosemirrorTransform.ReplaceAroundStep($cut.pos - 1, end, $cut.pos, end, new prosemirrorModel.Slice(wrap, 1, 0), conn.length, true));
      var $joinAt = tr.doc.resolve(end + 2 * conn.length);
      if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type && prosemirrorTransform.canJoin(tr.doc, $joinAt.pos)) tr.join($joinAt.pos);
      dispatch(tr.scrollIntoView());
    }
    return true;
  }
  var selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : prosemirrorState.Selection.findFrom($cut, 1);
  var range = selAfter && selAfter.$from.blockRange(selAfter.$to),
    target = range && prosemirrorTransform.liftTarget(range);
  if (target != null && target >= $cut.depth) {
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
  }
  if (canDelAfter && textblockAt(after, "start", true) && textblockAt(before, "end")) {
    var at = before,
      _wrap = [];
    for (;;) {
      _wrap.push(at);
      if (at.isTextblock) break;
      at = at.lastChild;
    }
    var afterText = after,
      afterDepth = 1;
    for (; !afterText.isTextblock; afterText = afterText.firstChild) afterDepth++;
    if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
      if (dispatch) {
        var _end = prosemirrorModel.Fragment.empty;
        for (var _i = _wrap.length - 1; _i >= 0; _i--) _end = prosemirrorModel.Fragment.from(_wrap[_i].copy(_end));
        var _tr = state.tr.step(new prosemirrorTransform.ReplaceAroundStep($cut.pos - _wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new prosemirrorModel.Slice(_end, _wrap.length, 0), 0, true));
        dispatch(_tr.scrollIntoView());
      }
      return true;
    }
  }
  return false;
}
function selectTextblockSide(side) {
  return function (state, dispatch) {
    var sel = state.selection,
      $pos = side < 0 ? sel.$from : sel.$to;
    var depth = $pos.depth;
    while ($pos.node(depth).isInline) {
      if (!depth) return false;
      depth--;
    }
    if (!$pos.node(depth).isTextblock) return false;
    if (dispatch) dispatch(state.tr.setSelection(prosemirrorState.TextSelection.create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
    return true;
  };
}
var selectTextblockStart = selectTextblockSide(-1);
var selectTextblockEnd = selectTextblockSide(1);
function wrapIn(nodeType) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return function (state, dispatch) {
    var _state$selection8 = state.selection,
      $from = _state$selection8.$from,
      $to = _state$selection8.$to;
    var range = $from.blockRange($to),
      wrapping = range && prosemirrorTransform.findWrapping(range, nodeType, attrs);
    if (!wrapping) return false;
    if (dispatch) dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
    return true;
  };
}
function setBlockType(nodeType) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return function (state, dispatch) {
    var applicable = false;
    for (var i = 0; i < state.selection.ranges.length && !applicable; i++) {
      var _state$selection$rang = state.selection.ranges[i],
        from = _state$selection$rang.$from.pos,
        to = _state$selection$rang.$to.pos;
      state.doc.nodesBetween(from, to, function (node, pos) {
        if (applicable) return false;
        if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
        if (node.type == nodeType) {
          applicable = true;
        } else {
          var $pos = state.doc.resolve(pos),
            index = $pos.index();
          applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
        }
      });
    }
    if (!applicable) return false;
    if (dispatch) {
      var tr = state.tr;
      for (var _i2 = 0; _i2 < state.selection.ranges.length; _i2++) {
        var _state$selection$rang2 = state.selection.ranges[_i2],
          _from = _state$selection$rang2.$from.pos,
          _to = _state$selection$rang2.$to.pos;
        tr.setBlockType(_from, _to, nodeType, attrs);
      }
      dispatch(tr.scrollIntoView());
    }
    return true;
  };
}
function markApplies(doc, ranges, type, enterAtoms) {
  var _loop = function _loop() {
      var _ranges$i = ranges[i],
        $from = _ranges$i.$from,
        $to = _ranges$i.$to;
      var can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
      doc.nodesBetween($from.pos, $to.pos, function (node, pos) {
        if (can || !enterAtoms && node.isAtom && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) return false;
        can = node.inlineContent && node.type.allowsMarkType(type);
      });
      if (can) return {
        v: true
      };
    },
    _ret;
  for (var i = 0; i < ranges.length; i++) {
    _ret = _loop();
    if (_ret) return _ret.v;
  }
  return false;
}
function removeInlineAtoms(ranges) {
  var result = [];
  var _loop2 = function _loop2() {
    var _ranges$i2 = ranges[i],
      $from = _ranges$i2.$from,
      $to = _ranges$i2.$to;
    $from.doc.nodesBetween($from.pos, $to.pos, function (node, pos) {
      if (node.isAtom && node.content.size && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) {
        if (pos + 1 > $from.pos) result.push(new prosemirrorState.SelectionRange($from, $from.doc.resolve(pos + 1)));
        $from = $from.doc.resolve(pos + 1 + node.content.size);
        return false;
      }
    });
    if ($from.pos < $to.pos) result.push(new prosemirrorState.SelectionRange($from, $to));
  };
  for (var i = 0; i < ranges.length; i++) {
    _loop2();
  }
  return result;
}
function toggleMark(markType) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var removeWhenPresent = (options && options.removeWhenPresent) !== false;
  var enterAtoms = (options && options.enterInlineAtoms) !== false;
  var dropSpace = !(options && options.includeWhitespace);
  return function (state, dispatch) {
    var _state$selection9 = state.selection,
      empty = _state$selection9.empty,
      $cursor = _state$selection9.$cursor,
      ranges = _state$selection9.ranges;
    if (empty && !$cursor || !markApplies(state.doc, ranges, markType, enterAtoms)) return false;
    if (dispatch) {
      if ($cursor) {
        if (markType.isInSet(state.storedMarks || $cursor.marks())) dispatch(state.tr.removeStoredMark(markType));else dispatch(state.tr.addStoredMark(markType.create(attrs)));
      } else {
        var add,
          tr = state.tr;
        if (!enterAtoms) ranges = removeInlineAtoms(ranges);
        if (removeWhenPresent) {
          add = !ranges.some(function (r) {
            return state.doc.rangeHasMark(r.$from.pos, r.$to.pos, markType);
          });
        } else {
          add = !ranges.every(function (r) {
            var missing = false;
            tr.doc.nodesBetween(r.$from.pos, r.$to.pos, function (node, pos, parent) {
              if (missing) return false;
              missing = !markType.isInSet(node.marks) && !!parent && parent.type.allowsMarkType(markType) && !(node.isText && /^\s*$/.test(node.textBetween(Math.max(0, r.$from.pos - pos), Math.min(node.nodeSize, r.$to.pos - pos))));
            });
            return !missing;
          });
        }
        for (var i = 0; i < ranges.length; i++) {
          var _ranges$i3 = ranges[i],
            $from = _ranges$i3.$from,
            $to = _ranges$i3.$to;
          if (!add) {
            tr.removeMark($from.pos, $to.pos, markType);
          } else {
            var from = $from.pos,
              to = $to.pos,
              start = $from.nodeAfter,
              end = $to.nodeBefore;
            var spaceStart = dropSpace && start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
            var spaceEnd = dropSpace && end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
            if (from + spaceStart < to) {
              from += spaceStart;
              to -= spaceEnd;
            }
            tr.addMark(from, to, markType.create(attrs));
          }
        }
        dispatch(tr.scrollIntoView());
      }
    }
    return true;
  };
}
function wrapDispatchForJoin(dispatch, isJoinable) {
  return function (tr) {
    if (!tr.isGeneric) return dispatch(tr);
    var ranges = [];
    for (var i = 0; i < tr.mapping.maps.length; i++) {
      var map = tr.mapping.maps[i];
      for (var j = 0; j < ranges.length; j++) ranges[j] = map.map(ranges[j]);
      map.forEach(function (_s, _e, from, to) {
        return ranges.push(from, to);
      });
    }
    var joinable = [];
    for (var _i3 = 0; _i3 < ranges.length; _i3 += 2) {
      var from = ranges[_i3],
        to = ranges[_i3 + 1];
      var $from = tr.doc.resolve(from),
        depth = $from.sharedDepth(to),
        parent = $from.node(depth);
      for (var index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index) {
        var after = parent.maybeChild(index);
        if (!after) break;
        if (index && joinable.indexOf(pos) == -1) {
          var before = parent.child(index - 1);
          if (before.type == after.type && isJoinable(before, after)) joinable.push(pos);
        }
        pos += after.nodeSize;
      }
    }
    joinable.sort(function (a, b) {
      return a - b;
    });
    for (var _i4 = joinable.length - 1; _i4 >= 0; _i4--) {
      if (prosemirrorTransform.canJoin(tr.doc, joinable[_i4])) tr.join(joinable[_i4]);
    }
    dispatch(tr);
  };
}
function autoJoin(command, isJoinable) {
  var canJoin = Array.isArray(isJoinable) ? function (node) {
    return isJoinable.indexOf(node.type.name) > -1;
  } : isJoinable;
  return function (state, dispatch, view) {
    return command(state, dispatch && wrapDispatchForJoin(dispatch, canJoin), view);
  };
}
function chainCommands() {
  for (var _len = arguments.length, commands = new Array(_len), _key = 0; _key < _len; _key++) {
    commands[_key] = arguments[_key];
  }
  return function (state, dispatch, view) {
    for (var i = 0; i < commands.length; i++) if (commands[i](state, dispatch, view)) return true;
    return false;
  };
}
var backspace = chainCommands(deleteSelection, joinBackward, selectNodeBackward);
var del = chainCommands(deleteSelection, joinForward, selectNodeForward);
var pcBaseKeymap = {
  "Enter": chainCommands(newlineInCode, createParagraphNear, liftEmptyBlock, splitBlock),
  "Mod-Enter": exitCode,
  "Backspace": backspace,
  "Mod-Backspace": backspace,
  "Shift-Backspace": backspace,
  "Delete": del,
  "Mod-Delete": del,
  "Mod-a": selectAll
};
var macBaseKeymap = {
  "Ctrl-h": pcBaseKeymap["Backspace"],
  "Alt-Backspace": pcBaseKeymap["Mod-Backspace"],
  "Ctrl-d": pcBaseKeymap["Delete"],
  "Ctrl-Alt-Backspace": pcBaseKeymap["Mod-Delete"],
  "Alt-Delete": pcBaseKeymap["Mod-Delete"],
  "Alt-d": pcBaseKeymap["Mod-Delete"],
  "Ctrl-a": selectTextblockStart,
  "Ctrl-e": selectTextblockEnd
};
for (var key in pcBaseKeymap) macBaseKeymap[key] = pcBaseKeymap[key];
var mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
var baseKeymap = mac ? macBaseKeymap : pcBaseKeymap;
exports.autoJoin = autoJoin;
exports.baseKeymap = baseKeymap;
exports.chainCommands = chainCommands;
exports.createParagraphNear = createParagraphNear;
exports.deleteSelection = deleteSelection;
exports.exitCode = exitCode;
exports.joinBackward = joinBackward;
exports.joinDown = joinDown;
exports.joinForward = joinForward;
exports.joinTextblockBackward = joinTextblockBackward;
exports.joinTextblockForward = joinTextblockForward;
exports.joinUp = joinUp;
exports.lift = lift;
exports.liftEmptyBlock = liftEmptyBlock;
exports.macBaseKeymap = macBaseKeymap;
exports.newlineInCode = newlineInCode;
exports.pcBaseKeymap = pcBaseKeymap;
exports.selectAll = selectAll;
exports.selectNodeBackward = selectNodeBackward;
exports.selectNodeForward = selectNodeForward;
exports.selectParentNode = selectParentNode;
exports.selectTextblockEnd = selectTextblockEnd;
exports.selectTextblockStart = selectTextblockStart;
exports.setBlockType = setBlockType;
exports.splitBlock = splitBlock;
exports.splitBlockAs = splitBlockAs;
exports.splitBlockKeepMarks = splitBlockKeepMarks;
exports.toggleMark = toggleMark;
exports.wrapIn = wrapIn;


/***/ }),

/***/ 31588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var prosemirrorState = __webpack_require__(42391);
var prosemirrorTransform = __webpack_require__(92843);
function dropCursor() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new prosemirrorState.Plugin({
    view: function view(editorView) {
      return new DropCursorView(editorView, options);
    }
  });
}
var DropCursorView = function () {
  function DropCursorView(editorView, options) {
    var _this = this;
    _classCallCheck(this, DropCursorView);
    var _a;
    this.editorView = editorView;
    this.cursorPos = null;
    this.element = null;
    this.timeout = -1;
    this.width = (_a = options.width) !== null && _a !== void 0 ? _a : 1;
    this.color = options.color === false ? undefined : options.color || "black";
    this["class"] = options["class"];
    this.handlers = ["dragover", "dragend", "drop", "dragleave"].map(function (name) {
      var handler = function handler(e) {
        _this[name](e);
      };
      editorView.dom.addEventListener(name, handler);
      return {
        name: name,
        handler: handler
      };
    });
  }
  _createClass(DropCursorView, [{
    key: "destroy",
    value: function destroy() {
      var _this2 = this;
      this.handlers.forEach(function (_ref) {
        var name = _ref.name,
          handler = _ref.handler;
        return _this2.editorView.dom.removeEventListener(name, handler);
      });
    }
  }, {
    key: "update",
    value: function update(editorView, prevState) {
      if (this.cursorPos != null && prevState.doc != editorView.state.doc) {
        if (this.cursorPos > editorView.state.doc.content.size) this.setCursor(null);else this.updateOverlay();
      }
    }
  }, {
    key: "setCursor",
    value: function setCursor(pos) {
      if (pos == this.cursorPos) return;
      this.cursorPos = pos;
      if (pos == null) {
        this.element.parentNode.removeChild(this.element);
        this.element = null;
      } else {
        this.updateOverlay();
      }
    }
  }, {
    key: "updateOverlay",
    value: function updateOverlay() {
      var $pos = this.editorView.state.doc.resolve(this.cursorPos);
      var isBlock = !$pos.parent.inlineContent,
        rect;
      var editorDOM = this.editorView.dom,
        editorRect = editorDOM.getBoundingClientRect();
      var scaleX = editorRect.width / editorDOM.offsetWidth,
        scaleY = editorRect.height / editorDOM.offsetHeight;
      if (isBlock) {
        var before = $pos.nodeBefore,
          after = $pos.nodeAfter;
        if (before || after) {
          var node = this.editorView.nodeDOM(this.cursorPos - (before ? before.nodeSize : 0));
          if (node) {
            var nodeRect = node.getBoundingClientRect();
            var top = before ? nodeRect.bottom : nodeRect.top;
            if (before && after) top = (top + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2;
            var halfWidth = this.width / 2 * scaleY;
            rect = {
              left: nodeRect.left,
              right: nodeRect.right,
              top: top - halfWidth,
              bottom: top + halfWidth
            };
          }
        }
      }
      if (!rect) {
        var coords = this.editorView.coordsAtPos(this.cursorPos);
        var _halfWidth = this.width / 2 * scaleX;
        rect = {
          left: coords.left - _halfWidth,
          right: coords.left + _halfWidth,
          top: coords.top,
          bottom: coords.bottom
        };
      }
      var parent = this.editorView.dom.offsetParent;
      if (!this.element) {
        this.element = parent.appendChild(document.createElement("div"));
        if (this["class"]) this.element.className = this["class"];
        this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;";
        if (this.color) {
          this.element.style.backgroundColor = this.color;
        }
      }
      this.element.classList.toggle("prosemirror-dropcursor-block", isBlock);
      this.element.classList.toggle("prosemirror-dropcursor-inline", !isBlock);
      var parentLeft, parentTop;
      if (!parent || parent == document.body && getComputedStyle(parent).position == "static") {
        parentLeft = -pageXOffset;
        parentTop = -pageYOffset;
      } else {
        var _rect = parent.getBoundingClientRect();
        var parentScaleX = _rect.width / parent.offsetWidth,
          parentScaleY = _rect.height / parent.offsetHeight;
        parentLeft = _rect.left - parent.scrollLeft * parentScaleX;
        parentTop = _rect.top - parent.scrollTop * parentScaleY;
      }
      this.element.style.left = (rect.left - parentLeft) / scaleX + "px";
      this.element.style.top = (rect.top - parentTop) / scaleY + "px";
      this.element.style.width = (rect.right - rect.left) / scaleX + "px";
      this.element.style.height = (rect.bottom - rect.top) / scaleY + "px";
    }
  }, {
    key: "scheduleRemoval",
    value: function scheduleRemoval(timeout) {
      var _this3 = this;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        return _this3.setCursor(null);
      }, timeout);
    }
  }, {
    key: "dragover",
    value: function dragover(event) {
      if (!this.editorView.editable) return;
      var pos = this.editorView.posAtCoords({
        left: event.clientX,
        top: event.clientY
      });
      var node = pos && pos.inside >= 0 && this.editorView.state.doc.nodeAt(pos.inside);
      var disableDropCursor = node && node.type.spec.disableDropCursor;
      var disabled = typeof disableDropCursor == "function" ? disableDropCursor(this.editorView, pos, event) : disableDropCursor;
      if (pos && !disabled) {
        var target = pos.pos;
        if (this.editorView.dragging && this.editorView.dragging.slice) {
          var point = prosemirrorTransform.dropPoint(this.editorView.state.doc, target, this.editorView.dragging.slice);
          if (point != null) target = point;
        }
        this.setCursor(target);
        this.scheduleRemoval(5000);
      }
    }
  }, {
    key: "dragend",
    value: function dragend() {
      this.scheduleRemoval(20);
    }
  }, {
    key: "drop",
    value: function drop() {
      this.scheduleRemoval(20);
    }
  }, {
    key: "dragleave",
    value: function dragleave(event) {
      if (!this.editorView.dom.contains(event.relatedTarget)) this.setCursor(null);
    }
  }]);
  return DropCursorView;
}();
exports.dropCursor = dropCursor;


/***/ }),

/***/ 81634:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var prosemirrorKeymap = __webpack_require__(97354);

var prosemirrorState = __webpack_require__(42391);

var prosemirrorModel = __webpack_require__(19443);

var prosemirrorView = __webpack_require__(9222);

var GapCursor = function (_prosemirrorState$Sel) {
  _inherits(GapCursor, _prosemirrorState$Sel);

  var _super = _createSuper(GapCursor);

  function GapCursor($pos) {
    _classCallCheck(this, GapCursor);

    return _super.call(this, $pos, $pos);
  }

  _createClass(GapCursor, [{
    key: "map",
    value: function map(doc, mapping) {
      var $pos = doc.resolve(mapping.map(this.head));
      return GapCursor.valid($pos) ? new GapCursor($pos) : prosemirrorState.Selection.near($pos);
    }
  }, {
    key: "content",
    value: function content() {
      return prosemirrorModel.Slice.empty;
    }
  }, {
    key: "eq",
    value: function eq(other) {
      return other instanceof GapCursor && other.head == this.head;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        type: "gapcursor",
        pos: this.head
      };
    }
  }, {
    key: "getBookmark",
    value: function getBookmark() {
      return new GapBookmark(this.anchor);
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(doc, json) {
      if (typeof json.pos != "number") throw new RangeError("Invalid input for GapCursor.fromJSON");
      return new GapCursor(doc.resolve(json.pos));
    }
  }, {
    key: "valid",
    value: function valid($pos) {
      var parent = $pos.parent;
      if (parent.isTextblock || !closedBefore($pos) || !closedAfter($pos)) return false;
      var override = parent.type.spec.allowGapCursor;
      if (override != null) return override;
      var deflt = parent.contentMatchAt($pos.index()).defaultType;
      return deflt && deflt.isTextblock;
    }
  }, {
    key: "findGapCursorFrom",
    value: function findGapCursorFrom($pos, dir) {
      var mustMove = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      search: for (;;) {
        if (!mustMove && GapCursor.valid($pos)) return $pos;
        var pos = $pos.pos,
            next = null;

        for (var d = $pos.depth;; d--) {
          var parent = $pos.node(d);

          if (dir > 0 ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
            next = parent.child(dir > 0 ? $pos.indexAfter(d) : $pos.index(d) - 1);
            break;
          } else if (d == 0) {
            return null;
          }

          pos += dir;
          var $cur = $pos.doc.resolve(pos);
          if (GapCursor.valid($cur)) return $cur;
        }

        for (;;) {
          var inside = dir > 0 ? next.firstChild : next.lastChild;

          if (!inside) {
            if (next.isAtom && !next.isText && !prosemirrorState.NodeSelection.isSelectable(next)) {
              $pos = $pos.doc.resolve(pos + next.nodeSize * dir);
              mustMove = false;
              continue search;
            }

            break;
          }

          next = inside;
          pos += dir;

          var _$cur = $pos.doc.resolve(pos);

          if (GapCursor.valid(_$cur)) return _$cur;
        }

        return null;
      }
    }
  }]);

  return GapCursor;
}(prosemirrorState.Selection);

GapCursor.prototype.visible = false;
GapCursor.findFrom = GapCursor.findGapCursorFrom;
prosemirrorState.Selection.jsonID("gapcursor", GapCursor);

var GapBookmark = function () {
  function GapBookmark(pos) {
    _classCallCheck(this, GapBookmark);

    this.pos = pos;
  }

  _createClass(GapBookmark, [{
    key: "map",
    value: function map(mapping) {
      return new GapBookmark(mapping.map(this.pos));
    }
  }, {
    key: "resolve",
    value: function resolve(doc) {
      var $pos = doc.resolve(this.pos);
      return GapCursor.valid($pos) ? new GapCursor($pos) : prosemirrorState.Selection.near($pos);
    }
  }]);

  return GapBookmark;
}();

function closedBefore($pos) {
  for (var d = $pos.depth; d >= 0; d--) {
    var index = $pos.index(d),
        parent = $pos.node(d);

    if (index == 0) {
      if (parent.type.spec.isolating) return true;
      continue;
    }

    for (var before = parent.child(index - 1);; before = before.lastChild) {
      if (before.childCount == 0 && !before.inlineContent || before.isAtom || before.type.spec.isolating) return true;
      if (before.inlineContent) return false;
    }
  }

  return true;
}

function closedAfter($pos) {
  for (var d = $pos.depth; d >= 0; d--) {
    var index = $pos.indexAfter(d),
        parent = $pos.node(d);

    if (index == parent.childCount) {
      if (parent.type.spec.isolating) return true;
      continue;
    }

    for (var after = parent.child(index);; after = after.firstChild) {
      if (after.childCount == 0 && !after.inlineContent || after.isAtom || after.type.spec.isolating) return true;
      if (after.inlineContent) return false;
    }
  }

  return true;
}

function gapCursor() {
  return new prosemirrorState.Plugin({
    props: {
      decorations: drawGapCursor,
      createSelectionBetween: function createSelectionBetween(_view, $anchor, $head) {
        return $anchor.pos == $head.pos && GapCursor.valid($head) ? new GapCursor($head) : null;
      },
      handleClick: handleClick,
      handleKeyDown: handleKeyDown,
      handleDOMEvents: {
        beforeinput: beforeinput
      }
    }
  });
}

var handleKeyDown = prosemirrorKeymap.keydownHandler({
  "ArrowLeft": arrow("horiz", -1),
  "ArrowRight": arrow("horiz", 1),
  "ArrowUp": arrow("vert", -1),
  "ArrowDown": arrow("vert", 1)
});

function arrow(axis, dir) {
  var dirStr = axis == "vert" ? dir > 0 ? "down" : "up" : dir > 0 ? "right" : "left";
  return function (state, dispatch, view) {
    var sel = state.selection;
    var $start = dir > 0 ? sel.$to : sel.$from,
        mustMove = sel.empty;

    if (sel instanceof prosemirrorState.TextSelection) {
      if (!view.endOfTextblock(dirStr) || $start.depth == 0) return false;
      mustMove = false;
      $start = state.doc.resolve(dir > 0 ? $start.after() : $start.before());
    }

    var $found = GapCursor.findGapCursorFrom($start, dir, mustMove);
    if (!$found) return false;
    if (dispatch) dispatch(state.tr.setSelection(new GapCursor($found)));
    return true;
  };
}

function handleClick(view, pos, event) {
  if (!view || !view.editable) return false;
  var $pos = view.state.doc.resolve(pos);
  if (!GapCursor.valid($pos)) return false;
  var clickPos = view.posAtCoords({
    left: event.clientX,
    top: event.clientY
  });
  if (clickPos && clickPos.inside > -1 && prosemirrorState.NodeSelection.isSelectable(view.state.doc.nodeAt(clickPos.inside))) return false;
  view.dispatch(view.state.tr.setSelection(new GapCursor($pos)));
  return true;
}

function beforeinput(view, event) {
  if (event.inputType != "insertCompositionText" || !(view.state.selection instanceof GapCursor)) return false;
  var $from = view.state.selection.$from;
  var insert = $from.parent.contentMatchAt($from.index()).findWrapping(view.state.schema.nodes.text);
  if (!insert) return false;
  var frag = prosemirrorModel.Fragment.empty;

  for (var i = insert.length - 1; i >= 0; i--) {
    frag = prosemirrorModel.Fragment.from(insert[i].createAndFill(null, frag));
  }

  var tr = view.state.tr.replace($from.pos, $from.pos, new prosemirrorModel.Slice(frag, 0, 0));
  tr.setSelection(prosemirrorState.TextSelection.near(tr.doc.resolve($from.pos + 1)));
  view.dispatch(tr);
  return false;
}

function drawGapCursor(state) {
  if (!(state.selection instanceof GapCursor)) return null;
  var node = document.createElement("div");
  node.className = "ProseMirror-gapcursor";
  return prosemirrorView.DecorationSet.create(state.doc, [prosemirrorView.Decoration.widget(state.selection.head, node, {
    key: "gapcursor"
  })]);
}

exports.GapCursor = GapCursor;
exports.gapCursor = gapCursor;


/***/ }),

/***/ 98638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var RopeSequence = __webpack_require__(63958);
var prosemirrorTransform = __webpack_require__(92843);
var prosemirrorState = __webpack_require__(42391);
var max_empty_items = 500;
var Branch = function () {
  function Branch(items, eventCount) {
    _classCallCheck(this, Branch);
    this.items = items;
    this.eventCount = eventCount;
  }
  _createClass(Branch, [{
    key: "popEvent",
    value: function popEvent(state, preserveItems) {
      var _this = this;
      if (this.eventCount == 0) return null;
      var end = this.items.length;
      for (;; end--) {
        var next = this.items.get(end - 1);
        if (next.selection) {
          --end;
          break;
        }
      }
      var remap, mapFrom;
      if (preserveItems) {
        remap = this.remapping(end, this.items.length);
        mapFrom = remap.maps.length;
      }
      var transform = state.tr;
      var selection, remaining;
      var addAfter = [],
        addBefore = [];
      this.items.forEach(function (item, i) {
        if (!item.step) {
          if (!remap) {
            remap = _this.remapping(end, i + 1);
            mapFrom = remap.maps.length;
          }
          mapFrom--;
          addBefore.push(item);
          return;
        }
        if (remap) {
          addBefore.push(new Item(item.map));
          var step = item.step.map(remap.slice(mapFrom)),
            map;
          if (step && transform.maybeStep(step).doc) {
            map = transform.mapping.maps[transform.mapping.maps.length - 1];
            addAfter.push(new Item(map, undefined, undefined, addAfter.length + addBefore.length));
          }
          mapFrom--;
          if (map) remap.appendMap(map, mapFrom);
        } else {
          transform.maybeStep(item.step);
        }
        if (item.selection) {
          selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
          remaining = new Branch(_this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), _this.eventCount - 1);
          return false;
        }
      }, this.items.length, 0);
      return {
        remaining: remaining,
        transform: transform,
        selection: selection
      };
    }
  }, {
    key: "addTransform",
    value: function addTransform(transform, selection, histOptions, preserveItems) {
      var newItems = [],
        eventCount = this.eventCount;
      var oldItems = this.items,
        lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
      for (var i = 0; i < transform.steps.length; i++) {
        var step = transform.steps[i].invert(transform.docs[i]);
        var item = new Item(transform.mapping.maps[i], step, selection),
          merged = void 0;
        if (merged = lastItem && lastItem.merge(item)) {
          item = merged;
          if (i) newItems.pop();else oldItems = oldItems.slice(0, oldItems.length - 1);
        }
        newItems.push(item);
        if (selection) {
          eventCount++;
          selection = undefined;
        }
        if (!preserveItems) lastItem = item;
      }
      var overflow = eventCount - histOptions.depth;
      if (overflow > DEPTH_OVERFLOW) {
        oldItems = cutOffEvents(oldItems, overflow);
        eventCount -= overflow;
      }
      return new Branch(oldItems.append(newItems), eventCount);
    }
  }, {
    key: "remapping",
    value: function remapping(from, to) {
      var maps = new prosemirrorTransform.Mapping();
      this.items.forEach(function (item, i) {
        var mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from ? maps.maps.length - item.mirrorOffset : undefined;
        maps.appendMap(item.map, mirrorPos);
      }, from, to);
      return maps;
    }
  }, {
    key: "addMaps",
    value: function addMaps(array) {
      if (this.eventCount == 0) return this;
      return new Branch(this.items.append(array.map(function (map) {
        return new Item(map);
      })), this.eventCount);
    }
  }, {
    key: "rebased",
    value: function rebased(rebasedTransform, rebasedCount) {
      if (!this.eventCount) return this;
      var rebasedItems = [],
        start = Math.max(0, this.items.length - rebasedCount);
      var mapping = rebasedTransform.mapping;
      var newUntil = rebasedTransform.steps.length;
      var eventCount = this.eventCount;
      this.items.forEach(function (item) {
        if (item.selection) eventCount--;
      }, start);
      var iRebased = rebasedCount;
      this.items.forEach(function (item) {
        var pos = mapping.getMirror(--iRebased);
        if (pos == null) return;
        newUntil = Math.min(newUntil, pos);
        var map = mapping.maps[pos];
        if (item.step) {
          var step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
          var selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
          if (selection) eventCount++;
          rebasedItems.push(new Item(map, step, selection));
        } else {
          rebasedItems.push(new Item(map));
        }
      }, start);
      var newMaps = [];
      for (var i = rebasedCount; i < newUntil; i++) newMaps.push(new Item(mapping.maps[i]));
      var items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
      var branch = new Branch(items, eventCount);
      if (branch.emptyItemCount() > max_empty_items) branch = branch.compress(this.items.length - rebasedItems.length);
      return branch;
    }
  }, {
    key: "emptyItemCount",
    value: function emptyItemCount() {
      var count = 0;
      this.items.forEach(function (item) {
        if (!item.step) count++;
      });
      return count;
    }
  }, {
    key: "compress",
    value: function compress() {
      var upto = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.items.length;
      var remap = this.remapping(0, upto),
        mapFrom = remap.maps.length;
      var items = [],
        events = 0;
      this.items.forEach(function (item, i) {
        if (i >= upto) {
          items.push(item);
          if (item.selection) events++;
        } else if (item.step) {
          var step = item.step.map(remap.slice(mapFrom)),
            map = step && step.getMap();
          mapFrom--;
          if (map) remap.appendMap(map, mapFrom);
          if (step) {
            var selection = item.selection && item.selection.map(remap.slice(mapFrom));
            if (selection) events++;
            var newItem = new Item(map.invert(), step, selection),
              merged,
              last = items.length - 1;
            if (merged = items.length && items[last].merge(newItem)) items[last] = merged;else items.push(newItem);
          }
        } else if (item.map) {
          mapFrom--;
        }
      }, this.items.length, 0);
      return new Branch(RopeSequence.from(items.reverse()), events);
    }
  }]);
  return Branch;
}();
Branch.empty = new Branch(RopeSequence.empty, 0);
function cutOffEvents(items, n) {
  var cutPoint;
  items.forEach(function (item, i) {
    if (item.selection && n-- == 0) {
      cutPoint = i;
      return false;
    }
  });
  return items.slice(cutPoint);
}
var Item = function () {
  function Item(map, step, selection, mirrorOffset) {
    _classCallCheck(this, Item);
    this.map = map;
    this.step = step;
    this.selection = selection;
    this.mirrorOffset = mirrorOffset;
  }
  _createClass(Item, [{
    key: "merge",
    value: function merge(other) {
      if (this.step && other.step && !other.selection) {
        var step = other.step.merge(this.step);
        if (step) return new Item(step.getMap().invert(), step, this.selection);
      }
    }
  }]);
  return Item;
}();
var HistoryState = _createClass(function HistoryState(done, undone, prevRanges, prevTime, prevComposition) {
  _classCallCheck(this, HistoryState);
  this.done = done;
  this.undone = undone;
  this.prevRanges = prevRanges;
  this.prevTime = prevTime;
  this.prevComposition = prevComposition;
});
var DEPTH_OVERFLOW = 20;
function applyTransaction(history, state, tr, options) {
  var historyTr = tr.getMeta(historyKey),
    rebased;
  if (historyTr) return historyTr.historyState;
  if (tr.getMeta(closeHistoryKey)) history = new HistoryState(history.done, history.undone, null, 0, -1);
  var appended = tr.getMeta("appendedTransaction");
  if (tr.steps.length == 0) {
    return history;
  } else if (appended && appended.getMeta(historyKey)) {
    if (appended.getMeta(historyKey).redo) return new HistoryState(history.done.addTransform(tr, undefined, options, mustPreserveItems(state)), history.undone, rangesFor(tr.mapping.maps), history.prevTime, history.prevComposition);else return new HistoryState(history.done, history.undone.addTransform(tr, undefined, options, mustPreserveItems(state)), null, history.prevTime, history.prevComposition);
  } else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
    var composition = tr.getMeta("composition");
    var newGroup = history.prevTime == 0 || !appended && history.prevComposition != composition && (history.prevTime < (tr.time || 0) - options.newGroupDelay || !isAdjacentTo(tr, history.prevRanges));
    var prevRanges = appended ? mapRanges(history.prevRanges, tr.mapping) : rangesFor(tr.mapping.maps);
    return new HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : undefined, options, mustPreserveItems(state)), Branch.empty, prevRanges, tr.time, composition == null ? history.prevComposition : composition);
  } else if (rebased = tr.getMeta("rebased")) {
    return new HistoryState(history.done.rebased(tr, rebased), history.undone.rebased(tr, rebased), mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
  } else {
    return new HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
  }
}
function isAdjacentTo(transform, prevRanges) {
  if (!prevRanges) return false;
  if (!transform.docChanged) return true;
  var adjacent = false;
  transform.mapping.maps[0].forEach(function (start, end) {
    for (var i = 0; i < prevRanges.length; i += 2) if (start <= prevRanges[i + 1] && end >= prevRanges[i]) adjacent = true;
  });
  return adjacent;
}
function rangesFor(maps) {
  var result = [];
  for (var i = maps.length - 1; i >= 0 && result.length == 0; i--) maps[i].forEach(function (_from, _to, from, to) {
    return result.push(from, to);
  });
  return result;
}
function mapRanges(ranges, mapping) {
  if (!ranges) return null;
  var result = [];
  for (var i = 0; i < ranges.length; i += 2) {
    var from = mapping.map(ranges[i], 1),
      to = mapping.map(ranges[i + 1], -1);
    if (from <= to) result.push(from, to);
  }
  return result;
}
function histTransaction(history, state, redo) {
  var preserveItems = mustPreserveItems(state);
  var histOptions = historyKey.get(state).spec.config;
  var pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
  if (!pop) return null;
  var selection = pop.selection.resolve(pop.transform.doc);
  var added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
  var newHist = new HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1);
  return pop.transform.setSelection(selection).setMeta(historyKey, {
    redo: redo,
    historyState: newHist
  });
}
var cachedPreserveItems = false,
  cachedPreserveItemsPlugins = null;
function mustPreserveItems(state) {
  var plugins = state.plugins;
  if (cachedPreserveItemsPlugins != plugins) {
    cachedPreserveItems = false;
    cachedPreserveItemsPlugins = plugins;
    for (var i = 0; i < plugins.length; i++) if (plugins[i].spec.historyPreserveItems) {
      cachedPreserveItems = true;
      break;
    }
  }
  return cachedPreserveItems;
}
function closeHistory(tr) {
  return tr.setMeta(closeHistoryKey, true);
}
var historyKey = new prosemirrorState.PluginKey("history");
var closeHistoryKey = new prosemirrorState.PluginKey("closeHistory");
function history() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  config = {
    depth: config.depth || 100,
    newGroupDelay: config.newGroupDelay || 500
  };
  return new prosemirrorState.Plugin({
    key: historyKey,
    state: {
      init: function init() {
        return new HistoryState(Branch.empty, Branch.empty, null, 0, -1);
      },
      apply: function apply(tr, hist, state) {
        return applyTransaction(hist, state, tr, config);
      }
    },
    config: config,
    props: {
      handleDOMEvents: {
        beforeinput: function beforeinput(view, e) {
          var inputType = e.inputType;
          var command = inputType == "historyUndo" ? undo : inputType == "historyRedo" ? redo : null;
          if (!command) return false;
          e.preventDefault();
          return command(view.state, view.dispatch);
        }
      }
    }
  });
}
function buildCommand(redo, scroll) {
  return function (state, dispatch) {
    var hist = historyKey.getState(state);
    if (!hist || (redo ? hist.undone : hist.done).eventCount == 0) return false;
    if (dispatch) {
      var tr = histTransaction(hist, state, redo);
      if (tr) dispatch(scroll ? tr.scrollIntoView() : tr);
    }
    return true;
  };
}
var undo = buildCommand(false, true);
var redo = buildCommand(true, true);
var undoNoScroll = buildCommand(false, false);
var redoNoScroll = buildCommand(true, false);
function undoDepth(state) {
  var hist = historyKey.getState(state);
  return hist ? hist.done.eventCount : 0;
}
function redoDepth(state) {
  var hist = historyKey.getState(state);
  return hist ? hist.undone.eventCount : 0;
}
exports.closeHistory = closeHistory;
exports.history = history;
exports.redo = redo;
exports.redoDepth = redoDepth;
exports.redoNoScroll = redoNoScroll;
exports.undo = undo;
exports.undoDepth = undoDepth;
exports.undoNoScroll = undoNoScroll;


/***/ }),

/***/ 97354:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var w3cKeyname = __webpack_require__(26691);
var prosemirrorState = __webpack_require__(42391);
var mac = typeof navigator != "undefined" && /Mac|iP(hone|[oa]d)/.test(navigator.platform);
var windows = typeof navigator != "undefined" && /Win/.test(navigator.platform);
function normalizeKeyName(name) {
  var parts = name.split(/-(?!$)/),
    result = parts[parts.length - 1];
  if (result == "Space") result = " ";
  var alt, ctrl, shift, meta;
  for (var i = 0; i < parts.length - 1; i++) {
    var mod = parts[i];
    if (/^(cmd|meta|m)$/i.test(mod)) meta = true;else if (/^a(lt)?$/i.test(mod)) alt = true;else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;else if (/^s(hift)?$/i.test(mod)) shift = true;else if (/^mod$/i.test(mod)) {
      if (mac) meta = true;else ctrl = true;
    } else throw new Error("Unrecognized modifier name: " + mod);
  }
  if (alt) result = "Alt-" + result;
  if (ctrl) result = "Ctrl-" + result;
  if (meta) result = "Meta-" + result;
  if (shift) result = "Shift-" + result;
  return result;
}
function normalize(map) {
  var copy = Object.create(null);
  for (var prop in map) copy[normalizeKeyName(prop)] = map[prop];
  return copy;
}
function modifiers(name, event) {
  var shift = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (event.altKey) name = "Alt-" + name;
  if (event.ctrlKey) name = "Ctrl-" + name;
  if (event.metaKey) name = "Meta-" + name;
  if (shift && event.shiftKey) name = "Shift-" + name;
  return name;
}
function keymap(bindings) {
  return new prosemirrorState.Plugin({
    props: {
      handleKeyDown: keydownHandler(bindings)
    }
  });
}
function keydownHandler(bindings) {
  var map = normalize(bindings);
  return function (view, event) {
    var name = w3cKeyname.keyName(event),
      baseName,
      direct = map[modifiers(name, event)];
    if (direct && direct(view.state, view.dispatch, view)) return true;
    if (name.length == 1 && name != " ") {
      if (event.shiftKey) {
        var noShift = map[modifiers(name, event, false)];
        if (noShift && noShift(view.state, view.dispatch, view)) return true;
      }
      if ((event.altKey || event.metaKey || event.ctrlKey) && !(windows && event.ctrlKey && event.altKey) && (baseName = w3cKeyname.base[event.keyCode]) && baseName != name) {
        var fromCode = map[modifiers(baseName, event)];
        if (fromCode && fromCode(view.state, view.dispatch, view)) return true;
      }
    }
    return false;
  };
}
exports.keydownHandler = keydownHandler;
exports.keymap = keymap;


/***/ }),

/***/ 19443:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var OrderedMap = __webpack_require__(36586);
function _findDiffStart(a, b, pos) {
  for (var i = 0;; i++) {
    if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
    var childA = a.child(i),
      childB = b.child(i);
    if (childA == childB) {
      pos += childA.nodeSize;
      continue;
    }
    if (!childA.sameMarkup(childB)) return pos;
    if (childA.isText && childA.text != childB.text) {
      for (var j = 0; childA.text[j] == childB.text[j]; j++) pos++;
      return pos;
    }
    if (childA.content.size || childB.content.size) {
      var inner = _findDiffStart(childA.content, childB.content, pos + 1);
      if (inner != null) return inner;
    }
    pos += childA.nodeSize;
  }
}
function _findDiffEnd(a, b, posA, posB) {
  for (var iA = a.childCount, iB = b.childCount;;) {
    if (iA == 0 || iB == 0) return iA == iB ? null : {
      a: posA,
      b: posB
    };
    var childA = a.child(--iA),
      childB = b.child(--iB),
      size = childA.nodeSize;
    if (childA == childB) {
      posA -= size;
      posB -= size;
      continue;
    }
    if (!childA.sameMarkup(childB)) return {
      a: posA,
      b: posB
    };
    if (childA.isText && childA.text != childB.text) {
      var same = 0,
        minSize = Math.min(childA.text.length, childB.text.length);
      while (same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]) {
        same++;
        posA--;
        posB--;
      }
      return {
        a: posA,
        b: posB
      };
    }
    if (childA.content.size || childB.content.size) {
      var inner = _findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
      if (inner) return inner;
    }
    posA -= size;
    posB -= size;
  }
}
var Fragment = function () {
  function Fragment(content, size) {
    _classCallCheck(this, Fragment);
    this.content = content;
    this.size = size || 0;
    if (size == null) for (var i = 0; i < content.length; i++) this.size += content[i].nodeSize;
  }
  _createClass(Fragment, [{
    key: "nodesBetween",
    value: function nodesBetween(from, to, f) {
      var nodeStart = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var parent = arguments.length > 4 ? arguments[4] : undefined;
      for (var i = 0, pos = 0; pos < to; i++) {
        var child = this.content[i],
          end = pos + child.nodeSize;
        if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
          var start = pos + 1;
          child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
        }
        pos = end;
      }
    }
  }, {
    key: "descendants",
    value: function descendants(f) {
      this.nodesBetween(0, this.size, f);
    }
  }, {
    key: "textBetween",
    value: function textBetween(from, to, blockSeparator, leafText) {
      var text = "",
        first = true;
      this.nodesBetween(from, to, function (node, pos) {
        var nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
        if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
          if (first) first = false;else text += blockSeparator;
        }
        text += nodeText;
      }, 0);
      return text;
    }
  }, {
    key: "append",
    value: function append(other) {
      if (!other.size) return this;
      if (!this.size) return other;
      var last = this.lastChild,
        first = other.firstChild,
        content = this.content.slice(),
        i = 0;
      if (last.isText && last.sameMarkup(first)) {
        content[content.length - 1] = last.withText(last.text + first.text);
        i = 1;
      }
      for (; i < other.content.length; i++) content.push(other.content[i]);
      return new Fragment(content, this.size + other.size);
    }
  }, {
    key: "cut",
    value: function cut(from) {
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.size;
      if (from == 0 && to == this.size) return this;
      var result = [],
        size = 0;
      if (to > from) for (var i = 0, pos = 0; pos < to; i++) {
        var child = this.content[i],
          end = pos + child.nodeSize;
        if (end > from) {
          if (pos < from || end > to) {
            if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
          }
          result.push(child);
          size += child.nodeSize;
        }
        pos = end;
      }
      return new Fragment(result, size);
    }
  }, {
    key: "cutByIndex",
    value: function cutByIndex(from, to) {
      if (from == to) return Fragment.empty;
      if (from == 0 && to == this.content.length) return this;
      return new Fragment(this.content.slice(from, to));
    }
  }, {
    key: "replaceChild",
    value: function replaceChild(index, node) {
      var current = this.content[index];
      if (current == node) return this;
      var copy = this.content.slice();
      var size = this.size + node.nodeSize - current.nodeSize;
      copy[index] = node;
      return new Fragment(copy, size);
    }
  }, {
    key: "addToStart",
    value: function addToStart(node) {
      return new Fragment([node].concat(this.content), this.size + node.nodeSize);
    }
  }, {
    key: "addToEnd",
    value: function addToEnd(node) {
      return new Fragment(this.content.concat(node), this.size + node.nodeSize);
    }
  }, {
    key: "eq",
    value: function eq(other) {
      if (this.content.length != other.content.length) return false;
      for (var i = 0; i < this.content.length; i++) if (!this.content[i].eq(other.content[i])) return false;
      return true;
    }
  }, {
    key: "firstChild",
    get: function get() {
      return this.content.length ? this.content[0] : null;
    }
  }, {
    key: "lastChild",
    get: function get() {
      return this.content.length ? this.content[this.content.length - 1] : null;
    }
  }, {
    key: "childCount",
    get: function get() {
      return this.content.length;
    }
  }, {
    key: "child",
    value: function child(index) {
      var found = this.content[index];
      if (!found) throw new RangeError("Index " + index + " out of range for " + this);
      return found;
    }
  }, {
    key: "maybeChild",
    value: function maybeChild(index) {
      return this.content[index] || null;
    }
  }, {
    key: "forEach",
    value: function forEach(f) {
      for (var i = 0, p = 0; i < this.content.length; i++) {
        var child = this.content[i];
        f(child, p, i);
        p += child.nodeSize;
      }
    }
  }, {
    key: "findDiffStart",
    value: function findDiffStart(other) {
      var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return _findDiffStart(this, other, pos);
    }
  }, {
    key: "findDiffEnd",
    value: function findDiffEnd(other) {
      var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.size;
      var otherPos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : other.size;
      return _findDiffEnd(this, other, pos, otherPos);
    }
  }, {
    key: "findIndex",
    value: function findIndex(pos) {
      if (pos == 0) return retIndex(0, pos);
      if (pos == this.size) return retIndex(this.content.length, pos);
      if (pos > this.size || pos < 0) throw new RangeError("Position ".concat(pos, " outside of fragment (").concat(this, ")"));
      for (var i = 0, curPos = 0;; i++) {
        var cur = this.child(i),
          end = curPos + cur.nodeSize;
        if (end >= pos) {
          if (end == pos) return retIndex(i + 1, end);
          return retIndex(i, curPos);
        }
        curPos = end;
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      return "<" + this.toStringInner() + ">";
    }
  }, {
    key: "toStringInner",
    value: function toStringInner() {
      return this.content.join(", ");
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.content.length ? this.content.map(function (n) {
        return n.toJSON();
      }) : null;
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(schema, value) {
      if (!value) return Fragment.empty;
      if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
      return new Fragment(value.map(schema.nodeFromJSON));
    }
  }, {
    key: "fromArray",
    value: function fromArray(array) {
      if (!array.length) return Fragment.empty;
      var joined,
        size = 0;
      for (var i = 0; i < array.length; i++) {
        var node = array[i];
        size += node.nodeSize;
        if (i && node.isText && array[i - 1].sameMarkup(node)) {
          if (!joined) joined = array.slice(0, i);
          joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
        } else if (joined) {
          joined.push(node);
        }
      }
      return new Fragment(joined || array, size);
    }
  }, {
    key: "from",
    value: function from(nodes) {
      if (!nodes) return Fragment.empty;
      if (nodes instanceof Fragment) return nodes;
      if (Array.isArray(nodes)) return this.fromArray(nodes);
      if (nodes.attrs) return new Fragment([nodes], nodes.nodeSize);
      throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
  }]);
  return Fragment;
}();
Fragment.empty = new Fragment([], 0);
var found = {
  index: 0,
  offset: 0
};
function retIndex(index, offset) {
  found.index = index;
  found.offset = offset;
  return found;
}
function compareDeep(a, b) {
  if (a === b) return true;
  if (!(a && _typeof(a) == "object") || !(b && _typeof(b) == "object")) return false;
  var array = Array.isArray(a);
  if (Array.isArray(b) != array) return false;
  if (array) {
    if (a.length != b.length) return false;
    for (var i = 0; i < a.length; i++) if (!compareDeep(a[i], b[i])) return false;
  } else {
    for (var p in a) if (!(p in b) || !compareDeep(a[p], b[p])) return false;
    for (var _p in b) if (!(_p in a)) return false;
  }
  return true;
}
var Mark = function () {
  function Mark(type, attrs) {
    _classCallCheck(this, Mark);
    this.type = type;
    this.attrs = attrs;
  }
  _createClass(Mark, [{
    key: "addToSet",
    value: function addToSet(set) {
      var copy,
        placed = false;
      for (var i = 0; i < set.length; i++) {
        var other = set[i];
        if (this.eq(other)) return set;
        if (this.type.excludes(other.type)) {
          if (!copy) copy = set.slice(0, i);
        } else if (other.type.excludes(this.type)) {
          return set;
        } else {
          if (!placed && other.type.rank > this.type.rank) {
            if (!copy) copy = set.slice(0, i);
            copy.push(this);
            placed = true;
          }
          if (copy) copy.push(other);
        }
      }
      if (!copy) copy = set.slice();
      if (!placed) copy.push(this);
      return copy;
    }
  }, {
    key: "removeFromSet",
    value: function removeFromSet(set) {
      for (var i = 0; i < set.length; i++) if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
      return set;
    }
  }, {
    key: "isInSet",
    value: function isInSet(set) {
      for (var i = 0; i < set.length; i++) if (this.eq(set[i])) return true;
      return false;
    }
  }, {
    key: "eq",
    value: function eq(other) {
      return this == other || this.type == other.type && compareDeep(this.attrs, other.attrs);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var obj = {
        type: this.type.name
      };
      for (var _ in this.attrs) {
        obj.attrs = this.attrs;
        break;
      }
      return obj;
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(schema, json) {
      if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
      var type = schema.marks[json.type];
      if (!type) throw new RangeError("There is no mark type ".concat(json.type, " in this schema"));
      var mark = type.create(json.attrs);
      type.checkAttrs(mark.attrs);
      return mark;
    }
  }, {
    key: "sameSet",
    value: function sameSet(a, b) {
      if (a == b) return true;
      if (a.length != b.length) return false;
      for (var i = 0; i < a.length; i++) if (!a[i].eq(b[i])) return false;
      return true;
    }
  }, {
    key: "setFrom",
    value: function setFrom(marks) {
      if (!marks || Array.isArray(marks) && marks.length == 0) return Mark.none;
      if (marks instanceof Mark) return [marks];
      var copy = marks.slice();
      copy.sort(function (a, b) {
        return a.type.rank - b.type.rank;
      });
      return copy;
    }
  }]);
  return Mark;
}();
Mark.none = [];
var ReplaceError = function (_Error) {
  _inherits(ReplaceError, _Error);
  var _super = _createSuper(ReplaceError);
  function ReplaceError() {
    _classCallCheck(this, ReplaceError);
    return _super.apply(this, arguments);
  }
  return _createClass(ReplaceError);
}(_wrapNativeSuper(Error));
var Slice = function () {
  function Slice(content, openStart, openEnd) {
    _classCallCheck(this, Slice);
    this.content = content;
    this.openStart = openStart;
    this.openEnd = openEnd;
  }
  _createClass(Slice, [{
    key: "size",
    get: function get() {
      return this.content.size - this.openStart - this.openEnd;
    }
  }, {
    key: "insertAt",
    value: function insertAt(pos, fragment) {
      var content = insertInto(this.content, pos + this.openStart, fragment);
      return content && new Slice(content, this.openStart, this.openEnd);
    }
  }, {
    key: "removeBetween",
    value: function removeBetween(from, to) {
      return new Slice(removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
  }, {
    key: "eq",
    value: function eq(other) {
      return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      if (!this.content.size) return null;
      var json = {
        content: this.content.toJSON()
      };
      if (this.openStart > 0) json.openStart = this.openStart;
      if (this.openEnd > 0) json.openEnd = this.openEnd;
      return json;
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(schema, json) {
      if (!json) return Slice.empty;
      var openStart = json.openStart || 0,
        openEnd = json.openEnd || 0;
      if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
      return new Slice(Fragment.fromJSON(schema, json.content), openStart, openEnd);
    }
  }, {
    key: "maxOpen",
    value: function maxOpen(fragment) {
      var openIsolating = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var openStart = 0,
        openEnd = 0;
      for (var n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild) openStart++;
      for (var _n = fragment.lastChild; _n && !_n.isLeaf && (openIsolating || !_n.type.spec.isolating); _n = _n.lastChild) openEnd++;
      return new Slice(fragment, openStart, openEnd);
    }
  }]);
  return Slice;
}();
Slice.empty = new Slice(Fragment.empty, 0, 0);
function removeRange(content, from, to) {
  var _content$findIndex = content.findIndex(from),
    index = _content$findIndex.index,
    offset = _content$findIndex.offset,
    child = content.maybeChild(index);
  var _content$findIndex2 = content.findIndex(to),
    indexTo = _content$findIndex2.index,
    offsetTo = _content$findIndex2.offset;
  if (offset == from || child.isText) {
    if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
    return content.cut(0, from).append(content.cut(to));
  }
  if (index != indexTo) throw new RangeError("Removing non-flat range");
  return content.replaceChild(index, child.copy(removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function insertInto(content, dist, insert, parent) {
  var _content$findIndex3 = content.findIndex(dist),
    index = _content$findIndex3.index,
    offset = _content$findIndex3.offset,
    child = content.maybeChild(index);
  if (offset == dist || child.isText) {
    if (parent && !parent.canReplace(index, index, insert)) return null;
    return content.cut(0, dist).append(insert).append(content.cut(dist));
  }
  var inner = insertInto(child.content, dist - offset - 1, insert, child);
  return inner && content.replaceChild(index, child.copy(inner));
}
function _replace($from, $to, slice) {
  if (slice.openStart > $from.depth) throw new ReplaceError("Inserted content deeper than insertion position");
  if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new ReplaceError("Inconsistent open depths");
  return replaceOuter($from, $to, slice, 0);
}
function replaceOuter($from, $to, slice, depth) {
  var index = $from.index(depth),
    node = $from.node(depth);
  if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
    var inner = replaceOuter($from, $to, slice, depth + 1);
    return node.copy(node.content.replaceChild(index, inner));
  } else if (!slice.content.size) {
    return close(node, replaceTwoWay($from, $to, depth));
  } else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
    var parent = $from.parent,
      content = parent.content;
    return close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
  } else {
    var _prepareSliceForRepla = prepareSliceForReplace(slice, $from),
      start = _prepareSliceForRepla.start,
      end = _prepareSliceForRepla.end;
    return close(node, replaceThreeWay($from, start, end, $to, depth));
  }
}
function checkJoin(main, sub) {
  if (!sub.type.compatibleContent(main.type)) throw new ReplaceError("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function joinable($before, $after, depth) {
  var node = $before.node(depth);
  checkJoin(node, $after.node(depth));
  return node;
}
function addNode(child, target) {
  var last = target.length - 1;
  if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);else target.push(child);
}
function addRange($start, $end, depth, target) {
  var node = ($end || $start).node(depth);
  var startIndex = 0,
    endIndex = $end ? $end.index(depth) : node.childCount;
  if ($start) {
    startIndex = $start.index(depth);
    if ($start.depth > depth) {
      startIndex++;
    } else if ($start.textOffset) {
      addNode($start.nodeAfter, target);
      startIndex++;
    }
  }
  for (var i = startIndex; i < endIndex; i++) addNode(node.child(i), target);
  if ($end && $end.depth == depth && $end.textOffset) addNode($end.nodeBefore, target);
}
function close(node, content) {
  node.type.checkContent(content);
  return node.copy(content);
}
function replaceThreeWay($from, $start, $end, $to, depth) {
  var openStart = $from.depth > depth && joinable($from, $start, depth + 1);
  var openEnd = $to.depth > depth && joinable($end, $to, depth + 1);
  var content = [];
  addRange(null, $from, depth, content);
  if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
    checkJoin(openStart, openEnd);
    addNode(close(openStart, replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
  } else {
    if (openStart) addNode(close(openStart, replaceTwoWay($from, $start, depth + 1)), content);
    addRange($start, $end, depth, content);
    if (openEnd) addNode(close(openEnd, replaceTwoWay($end, $to, depth + 1)), content);
  }
  addRange($to, null, depth, content);
  return new Fragment(content);
}
function replaceTwoWay($from, $to, depth) {
  var content = [];
  addRange(null, $from, depth, content);
  if ($from.depth > depth) {
    var type = joinable($from, $to, depth + 1);
    addNode(close(type, replaceTwoWay($from, $to, depth + 1)), content);
  }
  addRange($to, null, depth, content);
  return new Fragment(content);
}
function prepareSliceForReplace(slice, $along) {
  var extra = $along.depth - slice.openStart,
    parent = $along.node(extra);
  var node = parent.copy(slice.content);
  for (var i = extra - 1; i >= 0; i--) node = $along.node(i).copy(Fragment.from(node));
  return {
    start: node.resolveNoCache(slice.openStart + extra),
    end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
  };
}
var ResolvedPos = function () {
  function ResolvedPos(pos, path, parentOffset) {
    _classCallCheck(this, ResolvedPos);
    this.pos = pos;
    this.path = path;
    this.parentOffset = parentOffset;
    this.depth = path.length / 3 - 1;
  }
  _createClass(ResolvedPos, [{
    key: "resolveDepth",
    value: function resolveDepth(val) {
      if (val == null) return this.depth;
      if (val < 0) return this.depth + val;
      return val;
    }
  }, {
    key: "parent",
    get: function get() {
      return this.node(this.depth);
    }
  }, {
    key: "doc",
    get: function get() {
      return this.node(0);
    }
  }, {
    key: "node",
    value: function node(depth) {
      return this.path[this.resolveDepth(depth) * 3];
    }
  }, {
    key: "index",
    value: function index(depth) {
      return this.path[this.resolveDepth(depth) * 3 + 1];
    }
  }, {
    key: "indexAfter",
    value: function indexAfter(depth) {
      depth = this.resolveDepth(depth);
      return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
  }, {
    key: "start",
    value: function start(depth) {
      depth = this.resolveDepth(depth);
      return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
  }, {
    key: "end",
    value: function end(depth) {
      depth = this.resolveDepth(depth);
      return this.start(depth) + this.node(depth).content.size;
    }
  }, {
    key: "before",
    value: function before(depth) {
      depth = this.resolveDepth(depth);
      if (!depth) throw new RangeError("There is no position before the top-level node");
      return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
  }, {
    key: "after",
    value: function after(depth) {
      depth = this.resolveDepth(depth);
      if (!depth) throw new RangeError("There is no position after the top-level node");
      return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
  }, {
    key: "textOffset",
    get: function get() {
      return this.pos - this.path[this.path.length - 1];
    }
  }, {
    key: "nodeAfter",
    get: function get() {
      var parent = this.parent,
        index = this.index(this.depth);
      if (index == parent.childCount) return null;
      var dOff = this.pos - this.path[this.path.length - 1],
        child = parent.child(index);
      return dOff ? parent.child(index).cut(dOff) : child;
    }
  }, {
    key: "nodeBefore",
    get: function get() {
      var index = this.index(this.depth);
      var dOff = this.pos - this.path[this.path.length - 1];
      if (dOff) return this.parent.child(index).cut(0, dOff);
      return index == 0 ? null : this.parent.child(index - 1);
    }
  }, {
    key: "posAtIndex",
    value: function posAtIndex(index, depth) {
      depth = this.resolveDepth(depth);
      var node = this.path[depth * 3],
        pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
      for (var i = 0; i < index; i++) pos += node.child(i).nodeSize;
      return pos;
    }
  }, {
    key: "marks",
    value: function marks() {
      var parent = this.parent,
        index = this.index();
      if (parent.content.size == 0) return Mark.none;
      if (this.textOffset) return parent.child(index).marks;
      var main = parent.maybeChild(index - 1),
        other = parent.maybeChild(index);
      if (!main) {
        var tmp = main;
        main = other;
        other = tmp;
      }
      var marks = main.marks;
      for (var i = 0; i < marks.length; i++) if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
      return marks;
    }
  }, {
    key: "marksAcross",
    value: function marksAcross($end) {
      var after = this.parent.maybeChild(this.index());
      if (!after || !after.isInline) return null;
      var marks = after.marks,
        next = $end.parent.maybeChild($end.index());
      for (var i = 0; i < marks.length; i++) if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
      return marks;
    }
  }, {
    key: "sharedDepth",
    value: function sharedDepth(pos) {
      for (var depth = this.depth; depth > 0; depth--) if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
      return 0;
    }
  }, {
    key: "blockRange",
    value: function blockRange() {
      var other = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;
      var pred = arguments.length > 1 ? arguments[1] : undefined;
      if (other.pos < this.pos) return other.blockRange(this);
      for (var d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--) if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new NodeRange(this, other, d);
      return null;
    }
  }, {
    key: "sameParent",
    value: function sameParent(other) {
      return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
  }, {
    key: "max",
    value: function max(other) {
      return other.pos > this.pos ? other : this;
    }
  }, {
    key: "min",
    value: function min(other) {
      return other.pos < this.pos ? other : this;
    }
  }, {
    key: "toString",
    value: function toString() {
      var str = "";
      for (var i = 1; i <= this.depth; i++) str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
      return str + ":" + this.parentOffset;
    }
  }], [{
    key: "resolve",
    value: function resolve(doc, pos) {
      if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
      var path = [];
      var start = 0,
        parentOffset = pos;
      for (var node = doc;;) {
        var _node$content$findInd = node.content.findIndex(parentOffset),
          index = _node$content$findInd.index,
          offset = _node$content$findInd.offset;
        var rem = parentOffset - offset;
        path.push(node, index, start + offset);
        if (!rem) break;
        node = node.child(index);
        if (node.isText) break;
        parentOffset = rem - 1;
        start += offset + 1;
      }
      return new ResolvedPos(pos, path, parentOffset);
    }
  }, {
    key: "resolveCached",
    value: function resolveCached(doc, pos) {
      var cache = resolveCache.get(doc);
      if (cache) {
        for (var i = 0; i < cache.elts.length; i++) {
          var elt = cache.elts[i];
          if (elt.pos == pos) return elt;
        }
      } else {
        resolveCache.set(doc, cache = new ResolveCache());
      }
      var result = cache.elts[cache.i] = ResolvedPos.resolve(doc, pos);
      cache.i = (cache.i + 1) % resolveCacheSize;
      return result;
    }
  }]);
  return ResolvedPos;
}();
var ResolveCache = _createClass(function ResolveCache() {
  _classCallCheck(this, ResolveCache);
  this.elts = [];
  this.i = 0;
});
var resolveCacheSize = 12,
  resolveCache = new WeakMap();
var NodeRange = function () {
  function NodeRange($from, $to, depth) {
    _classCallCheck(this, NodeRange);
    this.$from = $from;
    this.$to = $to;
    this.depth = depth;
  }
  _createClass(NodeRange, [{
    key: "start",
    get: function get() {
      return this.$from.before(this.depth + 1);
    }
  }, {
    key: "end",
    get: function get() {
      return this.$to.after(this.depth + 1);
    }
  }, {
    key: "parent",
    get: function get() {
      return this.$from.node(this.depth);
    }
  }, {
    key: "startIndex",
    get: function get() {
      return this.$from.index(this.depth);
    }
  }, {
    key: "endIndex",
    get: function get() {
      return this.$to.indexAfter(this.depth);
    }
  }]);
  return NodeRange;
}();
var emptyAttrs = Object.create(null);
var Node = function () {
  function Node(type, attrs, content) {
    var marks = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Mark.none;
    _classCallCheck(this, Node);
    this.type = type;
    this.attrs = attrs;
    this.marks = marks;
    this.content = content || Fragment.empty;
  }
  _createClass(Node, [{
    key: "children",
    get: function get() {
      return this.content.content;
    }
  }, {
    key: "nodeSize",
    get: function get() {
      return this.isLeaf ? 1 : 2 + this.content.size;
    }
  }, {
    key: "childCount",
    get: function get() {
      return this.content.childCount;
    }
  }, {
    key: "child",
    value: function child(index) {
      return this.content.child(index);
    }
  }, {
    key: "maybeChild",
    value: function maybeChild(index) {
      return this.content.maybeChild(index);
    }
  }, {
    key: "forEach",
    value: function forEach(f) {
      this.content.forEach(f);
    }
  }, {
    key: "nodesBetween",
    value: function nodesBetween(from, to, f) {
      var startPos = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      this.content.nodesBetween(from, to, f, startPos, this);
    }
  }, {
    key: "descendants",
    value: function descendants(f) {
      this.nodesBetween(0, this.content.size, f);
    }
  }, {
    key: "textContent",
    get: function get() {
      return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
  }, {
    key: "textBetween",
    value: function textBetween(from, to, blockSeparator, leafText) {
      return this.content.textBetween(from, to, blockSeparator, leafText);
    }
  }, {
    key: "firstChild",
    get: function get() {
      return this.content.firstChild;
    }
  }, {
    key: "lastChild",
    get: function get() {
      return this.content.lastChild;
    }
  }, {
    key: "eq",
    value: function eq(other) {
      return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
  }, {
    key: "sameMarkup",
    value: function sameMarkup(other) {
      return this.hasMarkup(other.type, other.attrs, other.marks);
    }
  }, {
    key: "hasMarkup",
    value: function hasMarkup(type, attrs, marks) {
      return this.type == type && compareDeep(this.attrs, attrs || type.defaultAttrs || emptyAttrs) && Mark.sameSet(this.marks, marks || Mark.none);
    }
  }, {
    key: "copy",
    value: function copy() {
      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (content == this.content) return this;
      return new Node(this.type, this.attrs, content, this.marks);
    }
  }, {
    key: "mark",
    value: function mark(marks) {
      return marks == this.marks ? this : new Node(this.type, this.attrs, this.content, marks);
    }
  }, {
    key: "cut",
    value: function cut(from) {
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.content.size;
      if (from == 0 && to == this.content.size) return this;
      return this.copy(this.content.cut(from, to));
    }
  }, {
    key: "slice",
    value: function slice(from) {
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.content.size;
      var includeParents = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (from == to) return Slice.empty;
      var $from = this.resolve(from),
        $to = this.resolve(to);
      var depth = includeParents ? 0 : $from.sharedDepth(to);
      var start = $from.start(depth),
        node = $from.node(depth);
      var content = node.content.cut($from.pos - start, $to.pos - start);
      return new Slice(content, $from.depth - depth, $to.depth - depth);
    }
  }, {
    key: "replace",
    value: function replace(from, to, slice) {
      return _replace(this.resolve(from), this.resolve(to), slice);
    }
  }, {
    key: "nodeAt",
    value: function nodeAt(pos) {
      for (var node = this;;) {
        var _node$content$findInd2 = node.content.findIndex(pos),
          index = _node$content$findInd2.index,
          offset = _node$content$findInd2.offset;
        node = node.maybeChild(index);
        if (!node) return null;
        if (offset == pos || node.isText) return node;
        pos -= offset + 1;
      }
    }
  }, {
    key: "childAfter",
    value: function childAfter(pos) {
      var _this$content$findInd = this.content.findIndex(pos),
        index = _this$content$findInd.index,
        offset = _this$content$findInd.offset;
      return {
        node: this.content.maybeChild(index),
        index: index,
        offset: offset
      };
    }
  }, {
    key: "childBefore",
    value: function childBefore(pos) {
      if (pos == 0) return {
        node: null,
        index: 0,
        offset: 0
      };
      var _this$content$findInd2 = this.content.findIndex(pos),
        index = _this$content$findInd2.index,
        offset = _this$content$findInd2.offset;
      if (offset < pos) return {
        node: this.content.child(index),
        index: index,
        offset: offset
      };
      var node = this.content.child(index - 1);
      return {
        node: node,
        index: index - 1,
        offset: offset - node.nodeSize
      };
    }
  }, {
    key: "resolve",
    value: function resolve(pos) {
      return ResolvedPos.resolveCached(this, pos);
    }
  }, {
    key: "resolveNoCache",
    value: function resolveNoCache(pos) {
      return ResolvedPos.resolve(this, pos);
    }
  }, {
    key: "rangeHasMark",
    value: function rangeHasMark(from, to, type) {
      var found = false;
      if (to > from) this.nodesBetween(from, to, function (node) {
        if (type.isInSet(node.marks)) found = true;
        return !found;
      });
      return found;
    }
  }, {
    key: "isBlock",
    get: function get() {
      return this.type.isBlock;
    }
  }, {
    key: "isTextblock",
    get: function get() {
      return this.type.isTextblock;
    }
  }, {
    key: "inlineContent",
    get: function get() {
      return this.type.inlineContent;
    }
  }, {
    key: "isInline",
    get: function get() {
      return this.type.isInline;
    }
  }, {
    key: "isText",
    get: function get() {
      return this.type.isText;
    }
  }, {
    key: "isLeaf",
    get: function get() {
      return this.type.isLeaf;
    }
  }, {
    key: "isAtom",
    get: function get() {
      return this.type.isAtom;
    }
  }, {
    key: "toString",
    value: function toString() {
      if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
      var name = this.type.name;
      if (this.content.size) name += "(" + this.content.toStringInner() + ")";
      return wrapMarks(this.marks, name);
    }
  }, {
    key: "contentMatchAt",
    value: function contentMatchAt(index) {
      var match = this.type.contentMatch.matchFragment(this.content, 0, index);
      if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
      return match;
    }
  }, {
    key: "canReplace",
    value: function canReplace(from, to) {
      var replacement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Fragment.empty;
      var start = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var end = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : replacement.childCount;
      var one = this.contentMatchAt(from).matchFragment(replacement, start, end);
      var two = one && one.matchFragment(this.content, to);
      if (!two || !two.validEnd) return false;
      for (var i = start; i < end; i++) if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
      return true;
    }
  }, {
    key: "canReplaceWith",
    value: function canReplaceWith(from, to, type, marks) {
      if (marks && !this.type.allowsMarks(marks)) return false;
      var start = this.contentMatchAt(from).matchType(type);
      var end = start && start.matchFragment(this.content, to);
      return end ? end.validEnd : false;
    }
  }, {
    key: "canAppend",
    value: function canAppend(other) {
      if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);else return this.type.compatibleContent(other.type);
    }
  }, {
    key: "check",
    value: function check() {
      this.type.checkContent(this.content);
      this.type.checkAttrs(this.attrs);
      var copy = Mark.none;
      for (var i = 0; i < this.marks.length; i++) {
        var mark = this.marks[i];
        mark.type.checkAttrs(mark.attrs);
        copy = mark.addToSet(copy);
      }
      if (!Mark.sameSet(copy, this.marks)) throw new RangeError("Invalid collection of marks for node ".concat(this.type.name, ": ").concat(this.marks.map(function (m) {
        return m.type.name;
      })));
      this.content.forEach(function (node) {
        return node.check();
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var obj = {
        type: this.type.name
      };
      for (var _ in this.attrs) {
        obj.attrs = this.attrs;
        break;
      }
      if (this.content.size) obj.content = this.content.toJSON();
      if (this.marks.length) obj.marks = this.marks.map(function (n) {
        return n.toJSON();
      });
      return obj;
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(schema, json) {
      if (!json) throw new RangeError("Invalid input for Node.fromJSON");
      var marks = undefined;
      if (json.marks) {
        if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
        marks = json.marks.map(schema.markFromJSON);
      }
      if (json.type == "text") {
        if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
        return schema.text(json.text, marks);
      }
      var content = Fragment.fromJSON(schema, json.content);
      var node = schema.nodeType(json.type).create(json.attrs, content, marks);
      node.type.checkAttrs(node.attrs);
      return node;
    }
  }]);
  return Node;
}();
Node.prototype.text = undefined;
var TextNode = function (_Node) {
  _inherits(TextNode, _Node);
  var _super2 = _createSuper(TextNode);
  function TextNode(type, attrs, content, marks) {
    var _this;
    _classCallCheck(this, TextNode);
    _this = _super2.call(this, type, attrs, null, marks);
    if (!content) throw new RangeError("Empty text nodes are not allowed");
    _this.text = content;
    return _this;
  }
  _createClass(TextNode, [{
    key: "toString",
    value: function toString() {
      if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
      return wrapMarks(this.marks, JSON.stringify(this.text));
    }
  }, {
    key: "textContent",
    get: function get() {
      return this.text;
    }
  }, {
    key: "textBetween",
    value: function textBetween(from, to) {
      return this.text.slice(from, to);
    }
  }, {
    key: "nodeSize",
    get: function get() {
      return this.text.length;
    }
  }, {
    key: "mark",
    value: function mark(marks) {
      return marks == this.marks ? this : new TextNode(this.type, this.attrs, this.text, marks);
    }
  }, {
    key: "withText",
    value: function withText(text) {
      if (text == this.text) return this;
      return new TextNode(this.type, this.attrs, text, this.marks);
    }
  }, {
    key: "cut",
    value: function cut() {
      var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.text.length;
      if (from == 0 && to == this.text.length) return this;
      return this.withText(this.text.slice(from, to));
    }
  }, {
    key: "eq",
    value: function eq(other) {
      return this.sameMarkup(other) && this.text == other.text;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var base = _get(_getPrototypeOf(TextNode.prototype), "toJSON", this).call(this);
      base.text = this.text;
      return base;
    }
  }]);
  return TextNode;
}(Node);
function wrapMarks(marks, str) {
  for (var i = marks.length - 1; i >= 0; i--) str = marks[i].type.name + "(" + str + ")";
  return str;
}
var ContentMatch = function () {
  function ContentMatch(validEnd) {
    _classCallCheck(this, ContentMatch);
    this.validEnd = validEnd;
    this.next = [];
    this.wrapCache = [];
  }
  _createClass(ContentMatch, [{
    key: "matchType",
    value: function matchType(type) {
      for (var i = 0; i < this.next.length; i++) if (this.next[i].type == type) return this.next[i].next;
      return null;
    }
  }, {
    key: "matchFragment",
    value: function matchFragment(frag) {
      var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : frag.childCount;
      var cur = this;
      for (var i = start; cur && i < end; i++) cur = cur.matchType(frag.child(i).type);
      return cur;
    }
  }, {
    key: "inlineContent",
    get: function get() {
      return this.next.length != 0 && this.next[0].type.isInline;
    }
  }, {
    key: "defaultType",
    get: function get() {
      for (var i = 0; i < this.next.length; i++) {
        var type = this.next[i].type;
        if (!(type.isText || type.hasRequiredAttrs())) return type;
      }
      return null;
    }
  }, {
    key: "compatible",
    value: function compatible(other) {
      for (var i = 0; i < this.next.length; i++) for (var j = 0; j < other.next.length; j++) if (this.next[i].type == other.next[j].type) return true;
      return false;
    }
  }, {
    key: "fillBefore",
    value: function fillBefore(after) {
      var toEnd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var startIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var seen = [this];
      function search(match, types) {
        var finished = match.matchFragment(after, startIndex);
        if (finished && (!toEnd || finished.validEnd)) return Fragment.from(types.map(function (tp) {
          return tp.createAndFill();
        }));
        for (var i = 0; i < match.next.length; i++) {
          var _match$next$i = match.next[i],
            type = _match$next$i.type,
            next = _match$next$i.next;
          if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
            seen.push(next);
            var _found = search(next, types.concat(type));
            if (_found) return _found;
          }
        }
        return null;
      }
      return search(this, []);
    }
  }, {
    key: "findWrapping",
    value: function findWrapping(target) {
      for (var i = 0; i < this.wrapCache.length; i += 2) if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
      var computed = this.computeWrapping(target);
      this.wrapCache.push(target, computed);
      return computed;
    }
  }, {
    key: "computeWrapping",
    value: function computeWrapping(target) {
      var seen = Object.create(null),
        active = [{
          match: this,
          type: null,
          via: null
        }];
      while (active.length) {
        var current = active.shift(),
          match = current.match;
        if (match.matchType(target)) {
          var result = [];
          for (var obj = current; obj.type; obj = obj.via) result.push(obj.type);
          return result.reverse();
        }
        for (var i = 0; i < match.next.length; i++) {
          var _match$next$i2 = match.next[i],
            type = _match$next$i2.type,
            next = _match$next$i2.next;
          if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
            active.push({
              match: type.contentMatch,
              type: type,
              via: current
            });
            seen[type.name] = true;
          }
        }
      }
      return null;
    }
  }, {
    key: "edgeCount",
    get: function get() {
      return this.next.length;
    }
  }, {
    key: "edge",
    value: function edge(n) {
      if (n >= this.next.length) throw new RangeError("There's no ".concat(n, "th edge in this content match"));
      return this.next[n];
    }
  }, {
    key: "toString",
    value: function toString() {
      var seen = [];
      function scan(m) {
        seen.push(m);
        for (var i = 0; i < m.next.length; i++) if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
      }
      scan(this);
      return seen.map(function (m, i) {
        var out = i + (m.validEnd ? "*" : " ") + " ";
        for (var _i = 0; _i < m.next.length; _i++) out += (_i ? ", " : "") + m.next[_i].type.name + "->" + seen.indexOf(m.next[_i].next);
        return out;
      }).join("\n");
    }
  }], [{
    key: "parse",
    value: function parse(string, nodeTypes) {
      var stream = new TokenStream(string, nodeTypes);
      if (stream.next == null) return ContentMatch.empty;
      var expr = parseExpr(stream);
      if (stream.next) stream.err("Unexpected trailing text");
      var match = dfa(nfa(expr));
      checkForDeadEnds(match, stream);
      return match;
    }
  }]);
  return ContentMatch;
}();
ContentMatch.empty = new ContentMatch(true);
var TokenStream = function () {
  function TokenStream(string, nodeTypes) {
    _classCallCheck(this, TokenStream);
    this.string = string;
    this.nodeTypes = nodeTypes;
    this.inline = null;
    this.pos = 0;
    this.tokens = string.split(/\s*(?=\b|\W|$)/);
    if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
    if (this.tokens[0] == "") this.tokens.shift();
  }
  _createClass(TokenStream, [{
    key: "next",
    get: function get() {
      return this.tokens[this.pos];
    }
  }, {
    key: "eat",
    value: function eat(tok) {
      return this.next == tok && (this.pos++ || true);
    }
  }, {
    key: "err",
    value: function err(str) {
      throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
  }]);
  return TokenStream;
}();
function parseExpr(stream) {
  var exprs = [];
  do {
    exprs.push(parseExprSeq(stream));
  } while (stream.eat("|"));
  return exprs.length == 1 ? exprs[0] : {
    type: "choice",
    exprs: exprs
  };
}
function parseExprSeq(stream) {
  var exprs = [];
  do {
    exprs.push(parseExprSubscript(stream));
  } while (stream.next && stream.next != ")" && stream.next != "|");
  return exprs.length == 1 ? exprs[0] : {
    type: "seq",
    exprs: exprs
  };
}
function parseExprSubscript(stream) {
  var expr = parseExprAtom(stream);
  for (;;) {
    if (stream.eat("+")) expr = {
      type: "plus",
      expr: expr
    };else if (stream.eat("*")) expr = {
      type: "star",
      expr: expr
    };else if (stream.eat("?")) expr = {
      type: "opt",
      expr: expr
    };else if (stream.eat("{")) expr = parseExprRange(stream, expr);else break;
  }
  return expr;
}
function parseNum(stream) {
  if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
  var result = Number(stream.next);
  stream.pos++;
  return result;
}
function parseExprRange(stream, expr) {
  var min = parseNum(stream),
    max = min;
  if (stream.eat(",")) {
    if (stream.next != "}") max = parseNum(stream);else max = -1;
  }
  if (!stream.eat("}")) stream.err("Unclosed braced range");
  return {
    type: "range",
    min: min,
    max: max,
    expr: expr
  };
}
function resolveName(stream, name) {
  var types = stream.nodeTypes,
    type = types[name];
  if (type) return [type];
  var result = [];
  for (var typeName in types) {
    var _type = types[typeName];
    if (_type.isInGroup(name)) result.push(_type);
  }
  if (result.length == 0) stream.err("No node type or group '" + name + "' found");
  return result;
}
function parseExprAtom(stream) {
  if (stream.eat("(")) {
    var expr = parseExpr(stream);
    if (!stream.eat(")")) stream.err("Missing closing paren");
    return expr;
  } else if (!/\W/.test(stream.next)) {
    var exprs = resolveName(stream, stream.next).map(function (type) {
      if (stream.inline == null) stream.inline = type.isInline;else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
      return {
        type: "name",
        value: type
      };
    });
    stream.pos++;
    return exprs.length == 1 ? exprs[0] : {
      type: "choice",
      exprs: exprs
    };
  } else {
    stream.err("Unexpected token '" + stream.next + "'");
  }
}
function nfa(expr) {
  var nfa = [[]];
  connect(compile(expr, 0), node());
  return nfa;
  function node() {
    return nfa.push([]) - 1;
  }
  function edge(from, to, term) {
    var edge = {
      term: term,
      to: to
    };
    nfa[from].push(edge);
    return edge;
  }
  function connect(edges, to) {
    edges.forEach(function (edge) {
      return edge.to = to;
    });
  }
  function compile(expr, from) {
    if (expr.type == "choice") {
      return expr.exprs.reduce(function (out, expr) {
        return out.concat(compile(expr, from));
      }, []);
    } else if (expr.type == "seq") {
      for (var i = 0;; i++) {
        var next = compile(expr.exprs[i], from);
        if (i == expr.exprs.length - 1) return next;
        connect(next, from = node());
      }
    } else if (expr.type == "star") {
      var loop = node();
      edge(from, loop);
      connect(compile(expr.expr, loop), loop);
      return [edge(loop)];
    } else if (expr.type == "plus") {
      var _loop = node();
      connect(compile(expr.expr, from), _loop);
      connect(compile(expr.expr, _loop), _loop);
      return [edge(_loop)];
    } else if (expr.type == "opt") {
      return [edge(from)].concat(compile(expr.expr, from));
    } else if (expr.type == "range") {
      var cur = from;
      for (var _i2 = 0; _i2 < expr.min; _i2++) {
        var _next = node();
        connect(compile(expr.expr, cur), _next);
        cur = _next;
      }
      if (expr.max == -1) {
        connect(compile(expr.expr, cur), cur);
      } else {
        for (var _i3 = expr.min; _i3 < expr.max; _i3++) {
          var _next2 = node();
          edge(cur, _next2);
          connect(compile(expr.expr, cur), _next2);
          cur = _next2;
        }
      }
      return [edge(cur)];
    } else if (expr.type == "name") {
      return [edge(from, undefined, expr.value)];
    } else {
      throw new Error("Unknown expr type");
    }
  }
}
function cmp(a, b) {
  return b - a;
}
function nullFrom(nfa, node) {
  var result = [];
  scan(node);
  return result.sort(cmp);
  function scan(node) {
    var edges = nfa[node];
    if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
    result.push(node);
    for (var i = 0; i < edges.length; i++) {
      var _edges$i = edges[i],
        term = _edges$i.term,
        to = _edges$i.to;
      if (!term && result.indexOf(to) == -1) scan(to);
    }
  }
}
function dfa(nfa) {
  var labeled = Object.create(null);
  return explore(nullFrom(nfa, 0));
  function explore(states) {
    var out = [];
    states.forEach(function (node) {
      nfa[node].forEach(function (_ref) {
        var term = _ref.term,
          to = _ref.to;
        if (!term) return;
        var set;
        for (var i = 0; i < out.length; i++) if (out[i][0] == term) set = out[i][1];
        nullFrom(nfa, to).forEach(function (node) {
          if (!set) out.push([term, set = []]);
          if (set.indexOf(node) == -1) set.push(node);
        });
      });
    });
    var state = labeled[states.join(",")] = new ContentMatch(states.indexOf(nfa.length - 1) > -1);
    for (var i = 0; i < out.length; i++) {
      var _states = out[i][1].sort(cmp);
      state.next.push({
        type: out[i][0],
        next: labeled[_states.join(",")] || explore(_states)
      });
    }
    return state;
  }
}
function checkForDeadEnds(match, stream) {
  for (var i = 0, work = [match]; i < work.length; i++) {
    var state = work[i],
      dead = !state.validEnd,
      nodes = [];
    for (var j = 0; j < state.next.length; j++) {
      var _state$next$j = state.next[j],
        type = _state$next$j.type,
        next = _state$next$j.next;
      nodes.push(type.name);
      if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
      if (work.indexOf(next) == -1) work.push(next);
    }
    if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function defaultAttrs(attrs) {
  var defaults = Object.create(null);
  for (var attrName in attrs) {
    var attr = attrs[attrName];
    if (!attr.hasDefault) return null;
    defaults[attrName] = attr["default"];
  }
  return defaults;
}
function _computeAttrs(attrs, value) {
  var built = Object.create(null);
  for (var name in attrs) {
    var given = value && value[name];
    if (given === undefined) {
      var attr = attrs[name];
      if (attr.hasDefault) given = attr["default"];else throw new RangeError("No value supplied for attribute " + name);
    }
    built[name] = given;
  }
  return built;
}
function _checkAttrs(attrs, values, type, name) {
  for (var _name in values) if (!(_name in attrs)) throw new RangeError("Unsupported attribute ".concat(_name, " for ").concat(type, " of type ").concat(_name));
  for (var _name2 in attrs) {
    var attr = attrs[_name2];
    if (attr.validate) attr.validate(values[_name2]);
  }
}
function initAttrs(typeName, attrs) {
  var result = Object.create(null);
  if (attrs) for (var name in attrs) result[name] = new Attribute(typeName, name, attrs[name]);
  return result;
}
var NodeType = function () {
  function NodeType(name, schema, spec) {
    _classCallCheck(this, NodeType);
    this.name = name;
    this.schema = schema;
    this.spec = spec;
    this.markSet = null;
    this.groups = spec.group ? spec.group.split(" ") : [];
    this.attrs = initAttrs(name, spec.attrs);
    this.defaultAttrs = defaultAttrs(this.attrs);
    this.contentMatch = null;
    this.inlineContent = null;
    this.isBlock = !(spec.inline || name == "text");
    this.isText = name == "text";
  }
  _createClass(NodeType, [{
    key: "isInline",
    get: function get() {
      return !this.isBlock;
    }
  }, {
    key: "isTextblock",
    get: function get() {
      return this.isBlock && this.inlineContent;
    }
  }, {
    key: "isLeaf",
    get: function get() {
      return this.contentMatch == ContentMatch.empty;
    }
  }, {
    key: "isAtom",
    get: function get() {
      return this.isLeaf || !!this.spec.atom;
    }
  }, {
    key: "isInGroup",
    value: function isInGroup(group) {
      return this.groups.indexOf(group) > -1;
    }
  }, {
    key: "whitespace",
    get: function get() {
      return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
  }, {
    key: "hasRequiredAttrs",
    value: function hasRequiredAttrs() {
      for (var n in this.attrs) if (this.attrs[n].isRequired) return true;
      return false;
    }
  }, {
    key: "compatibleContent",
    value: function compatibleContent(other) {
      return this == other || this.contentMatch.compatible(other.contentMatch);
    }
  }, {
    key: "computeAttrs",
    value: function computeAttrs(attrs) {
      if (!attrs && this.defaultAttrs) return this.defaultAttrs;else return _computeAttrs(this.attrs, attrs);
    }
  }, {
    key: "create",
    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var content = arguments.length > 1 ? arguments[1] : undefined;
      var marks = arguments.length > 2 ? arguments[2] : undefined;
      if (this.isText) throw new Error("NodeType.create can't construct text nodes");
      return new Node(this, this.computeAttrs(attrs), Fragment.from(content), Mark.setFrom(marks));
    }
  }, {
    key: "createChecked",
    value: function createChecked() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var content = arguments.length > 1 ? arguments[1] : undefined;
      var marks = arguments.length > 2 ? arguments[2] : undefined;
      content = Fragment.from(content);
      this.checkContent(content);
      return new Node(this, this.computeAttrs(attrs), content, Mark.setFrom(marks));
    }
  }, {
    key: "createAndFill",
    value: function createAndFill() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var content = arguments.length > 1 ? arguments[1] : undefined;
      var marks = arguments.length > 2 ? arguments[2] : undefined;
      attrs = this.computeAttrs(attrs);
      content = Fragment.from(content);
      if (content.size) {
        var before = this.contentMatch.fillBefore(content);
        if (!before) return null;
        content = before.append(content);
      }
      var matched = this.contentMatch.matchFragment(content);
      var after = matched && matched.fillBefore(Fragment.empty, true);
      if (!after) return null;
      return new Node(this, attrs, content.append(after), Mark.setFrom(marks));
    }
  }, {
    key: "validContent",
    value: function validContent(content) {
      var result = this.contentMatch.matchFragment(content);
      if (!result || !result.validEnd) return false;
      for (var i = 0; i < content.childCount; i++) if (!this.allowsMarks(content.child(i).marks)) return false;
      return true;
    }
  }, {
    key: "checkContent",
    value: function checkContent(content) {
      if (!this.validContent(content)) throw new RangeError("Invalid content for node ".concat(this.name, ": ").concat(content.toString().slice(0, 50)));
    }
  }, {
    key: "checkAttrs",
    value: function checkAttrs(attrs) {
      _checkAttrs(this.attrs, attrs, "node", this.name);
    }
  }, {
    key: "allowsMarkType",
    value: function allowsMarkType(markType) {
      return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
  }, {
    key: "allowsMarks",
    value: function allowsMarks(marks) {
      if (this.markSet == null) return true;
      for (var i = 0; i < marks.length; i++) if (!this.allowsMarkType(marks[i].type)) return false;
      return true;
    }
  }, {
    key: "allowedMarks",
    value: function allowedMarks(marks) {
      if (this.markSet == null) return marks;
      var copy;
      for (var i = 0; i < marks.length; i++) {
        if (!this.allowsMarkType(marks[i].type)) {
          if (!copy) copy = marks.slice(0, i);
        } else if (copy) {
          copy.push(marks[i]);
        }
      }
      return !copy ? marks : copy.length ? copy : Mark.none;
    }
  }], [{
    key: "compile",
    value: function compile(nodes, schema) {
      var result = Object.create(null);
      nodes.forEach(function (name, spec) {
        return result[name] = new NodeType(name, schema, spec);
      });
      var topType = schema.spec.topNode || "doc";
      if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
      if (!result.text) throw new RangeError("Every schema needs a 'text' type");
      for (var _ in result.text.attrs) throw new RangeError("The text node type should not have attributes");
      return result;
    }
  }]);
  return NodeType;
}();
function validateType(typeName, attrName, type) {
  var types = type.split("|");
  return function (value) {
    var name = value === null ? "null" : _typeof(value);
    if (types.indexOf(name) < 0) throw new RangeError("Expected value of type ".concat(types, " for attribute ").concat(attrName, " on type ").concat(typeName, ", got ").concat(name));
  };
}
var Attribute = function () {
  function Attribute(typeName, attrName, options) {
    _classCallCheck(this, Attribute);
    this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
    this["default"] = options["default"];
    this.validate = typeof options.validate == "string" ? validateType(typeName, attrName, options.validate) : options.validate;
  }
  _createClass(Attribute, [{
    key: "isRequired",
    get: function get() {
      return !this.hasDefault;
    }
  }]);
  return Attribute;
}();
var MarkType = function () {
  function MarkType(name, rank, schema, spec) {
    _classCallCheck(this, MarkType);
    this.name = name;
    this.rank = rank;
    this.schema = schema;
    this.spec = spec;
    this.attrs = initAttrs(name, spec.attrs);
    this.excluded = null;
    var defaults = defaultAttrs(this.attrs);
    this.instance = defaults ? new Mark(this, defaults) : null;
  }
  _createClass(MarkType, [{
    key: "create",
    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!attrs && this.instance) return this.instance;
      return new Mark(this, _computeAttrs(this.attrs, attrs));
    }
  }, {
    key: "removeFromSet",
    value: function removeFromSet(set) {
      for (var i = 0; i < set.length; i++) if (set[i].type == this) {
        set = set.slice(0, i).concat(set.slice(i + 1));
        i--;
      }
      return set;
    }
  }, {
    key: "isInSet",
    value: function isInSet(set) {
      for (var i = 0; i < set.length; i++) if (set[i].type == this) return set[i];
    }
  }, {
    key: "checkAttrs",
    value: function checkAttrs(attrs) {
      _checkAttrs(this.attrs, attrs, "mark", this.name);
    }
  }, {
    key: "excludes",
    value: function excludes(other) {
      return this.excluded.indexOf(other) > -1;
    }
  }], [{
    key: "compile",
    value: function compile(marks, schema) {
      var result = Object.create(null),
        rank = 0;
      marks.forEach(function (name, spec) {
        return result[name] = new MarkType(name, rank++, schema, spec);
      });
      return result;
    }
  }]);
  return MarkType;
}();
var Schema = function () {
  function Schema(spec) {
    var _this2 = this;
    _classCallCheck(this, Schema);
    this.linebreakReplacement = null;
    this.cached = Object.create(null);
    var instanceSpec = this.spec = {};
    for (var prop in spec) instanceSpec[prop] = spec[prop];
    instanceSpec.nodes = OrderedMap.from(spec.nodes), instanceSpec.marks = OrderedMap.from(spec.marks || {}), this.nodes = NodeType.compile(this.spec.nodes, this);
    this.marks = MarkType.compile(this.spec.marks, this);
    var contentExprCache = Object.create(null);
    for (var _prop in this.nodes) {
      if (_prop in this.marks) throw new RangeError(_prop + " can not be both a node and a mark");
      var type = this.nodes[_prop],
        contentExpr = type.spec.content || "",
        markExpr = type.spec.marks;
      type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = ContentMatch.parse(contentExpr, this.nodes));
      type.inlineContent = type.contentMatch.inlineContent;
      if (type.spec.linebreakReplacement) {
        if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
        if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = type;
      }
      type.markSet = markExpr == "_" ? null : markExpr ? gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
    }
    for (var _prop2 in this.marks) {
      var _type2 = this.marks[_prop2],
        excl = _type2.spec.excludes;
      _type2.excluded = excl == null ? [_type2] : excl == "" ? [] : gatherMarks(this, excl.split(" "));
    }
    this.nodeFromJSON = function (json) {
      return Node.fromJSON(_this2, json);
    };
    this.markFromJSON = function (json) {
      return Mark.fromJSON(_this2, json);
    };
    this.topNodeType = this.nodes[this.spec.topNode || "doc"];
    this.cached.wrappings = Object.create(null);
  }
  _createClass(Schema, [{
    key: "node",
    value: function node(type) {
      var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var content = arguments.length > 2 ? arguments[2] : undefined;
      var marks = arguments.length > 3 ? arguments[3] : undefined;
      if (typeof type == "string") type = this.nodeType(type);else if (!(type instanceof NodeType)) throw new RangeError("Invalid node type: " + type);else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
      return type.createChecked(attrs, content, marks);
    }
  }, {
    key: "text",
    value: function text(_text, marks) {
      var type = this.nodes.text;
      return new TextNode(type, type.defaultAttrs, _text, Mark.setFrom(marks));
    }
  }, {
    key: "mark",
    value: function mark(type, attrs) {
      if (typeof type == "string") type = this.marks[type];
      return type.create(attrs);
    }
  }, {
    key: "nodeType",
    value: function nodeType(name) {
      var found = this.nodes[name];
      if (!found) throw new RangeError("Unknown node type: " + name);
      return found;
    }
  }]);
  return Schema;
}();
function gatherMarks(schema, marks) {
  var found = [];
  for (var i = 0; i < marks.length; i++) {
    var name = marks[i],
      mark = schema.marks[name],
      ok = mark;
    if (mark) {
      found.push(mark);
    } else {
      for (var prop in schema.marks) {
        var _mark = schema.marks[prop];
        if (name == "_" || _mark.spec.group && _mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = _mark);
      }
    }
    if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
  }
  return found;
}
function isTagRule(rule) {
  return rule.tag != null;
}
function isStyleRule(rule) {
  return rule.style != null;
}
var DOMParser = function () {
  function DOMParser(schema, rules) {
    var _this3 = this;
    _classCallCheck(this, DOMParser);
    this.schema = schema;
    this.rules = rules;
    this.tags = [];
    this.styles = [];
    var matchedStyles = this.matchedStyles = [];
    rules.forEach(function (rule) {
      if (isTagRule(rule)) {
        _this3.tags.push(rule);
      } else if (isStyleRule(rule)) {
        var prop = /[^=]*/.exec(rule.style)[0];
        if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
        _this3.styles.push(rule);
      }
    });
    this.normalizeLists = !this.tags.some(function (r) {
      if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
      var node = schema.nodes[r.node];
      return node.contentMatch.matchType(node);
    });
  }
  _createClass(DOMParser, [{
    key: "parse",
    value: function parse(dom) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var context = new ParseContext(this, options, false);
      context.addAll(dom, Mark.none, options.from, options.to);
      return context.finish();
    }
  }, {
    key: "parseSlice",
    value: function parseSlice(dom) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var context = new ParseContext(this, options, true);
      context.addAll(dom, Mark.none, options.from, options.to);
      return Slice.maxOpen(context.finish());
    }
  }, {
    key: "matchTag",
    value: function matchTag(dom, context, after) {
      for (var i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++) {
        var rule = this.tags[i];
        if (matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
          if (rule.getAttrs) {
            var result = rule.getAttrs(dom);
            if (result === false) continue;
            rule.attrs = result || undefined;
          }
          return rule;
        }
      }
    }
  }, {
    key: "matchStyle",
    value: function matchStyle(prop, value, context, after) {
      for (var i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++) {
        var rule = this.styles[i],
          style = rule.style;
        if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
        if (rule.getAttrs) {
          var result = rule.getAttrs(value);
          if (result === false) continue;
          rule.attrs = result || undefined;
        }
        return rule;
      }
    }
  }], [{
    key: "schemaRules",
    value: function schemaRules(schema) {
      var result = [];
      function insert(rule) {
        var priority = rule.priority == null ? 50 : rule.priority,
          i = 0;
        for (; i < result.length; i++) {
          var next = result[i],
            nextPriority = next.priority == null ? 50 : next.priority;
          if (nextPriority < priority) break;
        }
        result.splice(i, 0, rule);
      }
      var _loop2 = function _loop2(name) {
        var rules = schema.marks[name].spec.parseDOM;
        if (rules) rules.forEach(function (rule) {
          insert(rule = copy(rule));
          if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
        });
      };
      for (var name in schema.marks) {
        _loop2(name);
      }
      var _loop3 = function _loop3(_name3) {
        var rules = schema.nodes[_name3].spec.parseDOM;
        if (rules) rules.forEach(function (rule) {
          insert(rule = copy(rule));
          if (!(rule.node || rule.ignore || rule.mark)) rule.node = _name3;
        });
      };
      for (var _name3 in schema.nodes) {
        _loop3(_name3);
      }
      return result;
    }
  }, {
    key: "fromSchema",
    value: function fromSchema(schema) {
      return schema.cached.domParser || (schema.cached.domParser = new DOMParser(schema, DOMParser.schemaRules(schema)));
    }
  }]);
  return DOMParser;
}();
var blockTags = {
  address: true,
  article: true,
  aside: true,
  blockquote: true,
  canvas: true,
  dd: true,
  div: true,
  dl: true,
  fieldset: true,
  figcaption: true,
  figure: true,
  footer: true,
  form: true,
  h1: true,
  h2: true,
  h3: true,
  h4: true,
  h5: true,
  h6: true,
  header: true,
  hgroup: true,
  hr: true,
  li: true,
  noscript: true,
  ol: true,
  output: true,
  p: true,
  pre: true,
  section: true,
  table: true,
  tfoot: true,
  ul: true
};
var ignoreTags = {
  head: true,
  noscript: true,
  object: true,
  script: true,
  style: true,
  title: true
};
var listTags = {
  ol: true,
  ul: true
};
var OPT_PRESERVE_WS = 1,
  OPT_PRESERVE_WS_FULL = 2,
  OPT_OPEN_LEFT = 4;
function wsOptionsFor(type, preserveWhitespace, base) {
  if (preserveWhitespace != null) return (preserveWhitespace ? OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? OPT_PRESERVE_WS_FULL : 0);
  return type && type.whitespace == "pre" ? OPT_PRESERVE_WS | OPT_PRESERVE_WS_FULL : base & ~OPT_OPEN_LEFT;
}
var NodeContext = function () {
  function NodeContext(type, attrs, marks, solid, match, options) {
    _classCallCheck(this, NodeContext);
    this.type = type;
    this.attrs = attrs;
    this.marks = marks;
    this.solid = solid;
    this.options = options;
    this.content = [];
    this.activeMarks = Mark.none;
    this.match = match || (options & OPT_OPEN_LEFT ? null : type.contentMatch);
  }
  _createClass(NodeContext, [{
    key: "findWrapping",
    value: function findWrapping(node) {
      if (!this.match) {
        if (!this.type) return [];
        var fill = this.type.contentMatch.fillBefore(Fragment.from(node));
        if (fill) {
          this.match = this.type.contentMatch.matchFragment(fill);
        } else {
          var start = this.type.contentMatch,
            wrap;
          if (wrap = start.findWrapping(node.type)) {
            this.match = start;
            return wrap;
          } else {
            return null;
          }
        }
      }
      return this.match.findWrapping(node.type);
    }
  }, {
    key: "finish",
    value: function finish(openEnd) {
      if (!(this.options & OPT_PRESERVE_WS)) {
        var last = this.content[this.content.length - 1],
          m;
        if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
          var text = last;
          if (last.text.length == m[0].length) this.content.pop();else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
        }
      }
      var content = Fragment.from(this.content);
      if (!openEnd && this.match) content = content.append(this.match.fillBefore(Fragment.empty, true));
      return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
  }, {
    key: "inlineContext",
    value: function inlineContext(node) {
      if (this.type) return this.type.inlineContent;
      if (this.content.length) return this.content[0].isInline;
      return node.parentNode && !blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
  }]);
  return NodeContext;
}();
var ParseContext = function () {
  function ParseContext(parser, options, isOpen) {
    _classCallCheck(this, ParseContext);
    this.parser = parser;
    this.options = options;
    this.isOpen = isOpen;
    this.open = 0;
    this.localPreserveWS = false;
    var topNode = options.topNode,
      topContext;
    var topOptions = wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? OPT_OPEN_LEFT : 0);
    if (topNode) topContext = new NodeContext(topNode.type, topNode.attrs, Mark.none, true, options.topMatch || topNode.type.contentMatch, topOptions);else if (isOpen) topContext = new NodeContext(null, null, Mark.none, true, null, topOptions);else topContext = new NodeContext(parser.schema.topNodeType, null, Mark.none, true, null, topOptions);
    this.nodes = [topContext];
    this.find = options.findPositions;
    this.needsBlock = false;
  }
  _createClass(ParseContext, [{
    key: "top",
    get: function get() {
      return this.nodes[this.open];
    }
  }, {
    key: "addDOM",
    value: function addDOM(dom, marks) {
      if (dom.nodeType == 3) this.addTextNode(dom, marks);else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
  }, {
    key: "addTextNode",
    value: function addTextNode(dom, marks) {
      var value = dom.nodeValue;
      var top = this.top,
        preserveWS = top.options & OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & OPT_PRESERVE_WS) > 0;
      if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
        if (!preserveWS) {
          value = value.replace(/[ \t\r\n\u000c]+/g, " ");
          if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
            var nodeBefore = top.content[top.content.length - 1];
            var domNodeBefore = dom.previousSibling;
            if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
          }
        } else if (preserveWS !== "full") {
          value = value.replace(/\r?\n|\r/g, " ");
        } else {
          value = value.replace(/\r\n?/g, "\n");
        }
        if (value) this.insertNode(this.parser.schema.text(value), marks, !/\S/.test(value));
        this.findInText(dom);
      } else {
        this.findInside(dom);
      }
    }
  }, {
    key: "addElement",
    value: function addElement(dom, marks, matchAfter) {
      var outerWS = this.localPreserveWS,
        top = this.top;
      if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
      var name = dom.nodeName.toLowerCase(),
        ruleID;
      if (listTags.hasOwnProperty(name) && this.parser.normalizeLists) normalizeList(dom);
      var rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
      out: if (rule ? rule.ignore : ignoreTags.hasOwnProperty(name)) {
        this.findInside(dom);
        this.ignoreFallback(dom, marks);
      } else if (!rule || rule.skip || rule.closeParent) {
        if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);else if (rule && rule.skip.nodeType) dom = rule.skip;
        var sync,
          oldNeedsBlock = this.needsBlock;
        if (blockTags.hasOwnProperty(name)) {
          if (top.content.length && top.content[0].isInline && this.open) {
            this.open--;
            top = this.top;
          }
          sync = true;
          if (!top.type) this.needsBlock = true;
        } else if (!dom.firstChild) {
          this.leafFallback(dom, marks);
          break out;
        }
        var innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
        if (innerMarks) this.addAll(dom, innerMarks);
        if (sync) this.sync(top);
        this.needsBlock = oldNeedsBlock;
      } else {
        var _innerMarks = this.readStyles(dom, marks);
        if (_innerMarks) this.addElementByRule(dom, rule, _innerMarks, rule.consuming === false ? ruleID : undefined);
      }
      this.localPreserveWS = outerWS;
    }
  }, {
    key: "leafFallback",
    value: function leafFallback(dom, marks) {
      if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
  }, {
    key: "ignoreFallback",
    value: function ignoreFallback(dom, marks) {
      if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks, true);
    }
  }, {
    key: "readStyles",
    value: function readStyles(dom, marks) {
      var _this4 = this;
      var styles = dom.style;
      if (styles && styles.length) for (var i = 0; i < this.parser.matchedStyles.length; i++) {
        var name = this.parser.matchedStyles[i],
          value = styles.getPropertyValue(name);
        if (value) {
          var _loop4 = function _loop4(_after) {
              var rule = _this4.parser.matchStyle(name, value, _this4, _after);
              if (!rule) {
                after = _after;
                return 0;
              }
              if (rule.ignore) return {
                v: null
              };
              if (rule.clearMark) marks = marks.filter(function (m) {
                return !rule.clearMark(m);
              });else marks = marks.concat(_this4.parser.schema.marks[rule.mark].create(rule.attrs));
              if (rule.consuming === false) _after = rule;else {
                after = _after;
                return 0;
              }
              after = _after;
            },
            _ret;
          for (var after = undefined;;) {
            _ret = _loop4(after);
            if (_ret === 0) break;
            if (_ret) return _ret.v;
          }
        }
      }
      return marks;
    }
  }, {
    key: "addElementByRule",
    value: function addElementByRule(dom, rule, marks, continueAfter) {
      var _this5 = this;
      var sync, nodeType;
      if (rule.node) {
        nodeType = this.parser.schema.nodes[rule.node];
        if (!nodeType.isLeaf) {
          var inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
          if (inner) {
            sync = true;
            marks = inner;
          }
        } else if (!this.insertNode(nodeType.create(rule.attrs), marks, dom.nodeName == "BR")) {
          this.leafFallback(dom, marks);
        }
      } else {
        var markType = this.parser.schema.marks[rule.mark];
        marks = marks.concat(markType.create(rule.attrs));
      }
      var startIn = this.top;
      if (nodeType && nodeType.isLeaf) {
        this.findInside(dom);
      } else if (continueAfter) {
        this.addElement(dom, marks, continueAfter);
      } else if (rule.getContent) {
        this.findInside(dom);
        rule.getContent(dom, this.parser.schema).forEach(function (node) {
          return _this5.insertNode(node, marks, false);
        });
      } else {
        var contentDOM = dom;
        if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);else if (rule.contentElement) contentDOM = rule.contentElement;
        this.findAround(dom, contentDOM, true);
        this.addAll(contentDOM, marks);
        this.findAround(dom, contentDOM, false);
      }
      if (sync && this.sync(startIn)) this.open--;
    }
  }, {
    key: "addAll",
    value: function addAll(parent, marks, startIndex, endIndex) {
      var index = startIndex || 0;
      for (var dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index) {
        this.findAtPoint(parent, index);
        this.addDOM(dom, marks);
      }
      this.findAtPoint(parent, index);
    }
  }, {
    key: "findPlace",
    value: function findPlace(node, marks, cautious) {
      var route, sync;
      for (var depth = this.open, penalty = 0; depth >= 0; depth--) {
        var cx = this.nodes[depth];
        var _found2 = cx.findWrapping(node);
        if (_found2 && (!route || route.length > _found2.length + penalty)) {
          route = _found2;
          sync = cx;
          if (!_found2.length) break;
        }
        if (cx.solid) {
          if (cautious) break;
          penalty += 2;
        }
      }
      if (!route) return null;
      this.sync(sync);
      for (var i = 0; i < route.length; i++) marks = this.enterInner(route[i], null, marks, false);
      return marks;
    }
  }, {
    key: "insertNode",
    value: function insertNode(node, marks, cautious) {
      if (node.isInline && this.needsBlock && !this.top.type) {
        var block = this.textblockFromContext();
        if (block) marks = this.enterInner(block, null, marks);
      }
      var innerMarks = this.findPlace(node, marks, cautious);
      if (innerMarks) {
        this.closeExtra();
        var top = this.top;
        if (top.match) top.match = top.match.matchType(node.type);
        var nodeMarks = Mark.none;
        var _iterator = _createForOfIteratorHelper(innerMarks.concat(node.marks)),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var m = _step.value;
            if (top.type ? top.type.allowsMarkType(m.type) : markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        top.content.push(node.mark(nodeMarks));
        return true;
      }
      return false;
    }
  }, {
    key: "enter",
    value: function enter(type, attrs, marks, preserveWS) {
      var innerMarks = this.findPlace(type.create(attrs), marks, false);
      if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
      return innerMarks;
    }
  }, {
    key: "enterInner",
    value: function enterInner(type, attrs, marks) {
      var solid = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var preserveWS = arguments.length > 4 ? arguments[4] : undefined;
      this.closeExtra();
      var top = this.top;
      top.match = top.match && top.match.matchType(type);
      var options = wsOptionsFor(type, preserveWS, top.options);
      if (top.options & OPT_OPEN_LEFT && top.content.length == 0) options |= OPT_OPEN_LEFT;
      var applyMarks = Mark.none;
      marks = marks.filter(function (m) {
        if (top.type ? top.type.allowsMarkType(m.type) : markMayApply(m.type, type)) {
          applyMarks = m.addToSet(applyMarks);
          return false;
        }
        return true;
      });
      this.nodes.push(new NodeContext(type, attrs, applyMarks, solid, null, options));
      this.open++;
      return marks;
    }
  }, {
    key: "closeExtra",
    value: function closeExtra() {
      var openEnd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var i = this.nodes.length - 1;
      if (i > this.open) {
        for (; i > this.open; i--) this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
        this.nodes.length = this.open + 1;
      }
    }
  }, {
    key: "finish",
    value: function finish() {
      this.open = 0;
      this.closeExtra(this.isOpen);
      return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
  }, {
    key: "sync",
    value: function sync(to) {
      for (var i = this.open; i >= 0; i--) {
        if (this.nodes[i] == to) {
          this.open = i;
          return true;
        } else if (this.localPreserveWS) {
          this.nodes[i].options |= OPT_PRESERVE_WS;
        }
      }
      return false;
    }
  }, {
    key: "currentPos",
    get: function get() {
      this.closeExtra();
      var pos = 0;
      for (var i = this.open; i >= 0; i--) {
        var content = this.nodes[i].content;
        for (var j = content.length - 1; j >= 0; j--) pos += content[j].nodeSize;
        if (i) pos++;
      }
      return pos;
    }
  }, {
    key: "findAtPoint",
    value: function findAtPoint(parent, offset) {
      if (this.find) for (var i = 0; i < this.find.length; i++) {
        if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
      }
    }
  }, {
    key: "findInside",
    value: function findInside(parent) {
      if (this.find) for (var i = 0; i < this.find.length; i++) {
        if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
      }
    }
  }, {
    key: "findAround",
    value: function findAround(parent, content, before) {
      if (parent != content && this.find) for (var i = 0; i < this.find.length; i++) {
        if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
          var pos = content.compareDocumentPosition(this.find[i].node);
          if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
        }
      }
    }
  }, {
    key: "findInText",
    value: function findInText(textNode) {
      if (this.find) for (var i = 0; i < this.find.length; i++) {
        if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
      }
    }
  }, {
    key: "matchesContext",
    value: function matchesContext(context) {
      var _this6 = this;
      if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
      var parts = context.split("/");
      var option = this.options.context;
      var useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
      var minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
      var match = function match(i, depth) {
        for (; i >= 0; i--) {
          var part = parts[i];
          if (part == "") {
            if (i == parts.length - 1 || i == 0) continue;
            for (; depth >= minDepth; depth--) if (match(i - 1, depth)) return true;
            return false;
          } else {
            var next = depth > 0 || depth == 0 && useRoot ? _this6.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
            if (!next || next.name != part && !next.isInGroup(part)) return false;
            depth--;
          }
        }
        return true;
      };
      return match(parts.length - 1, this.open);
    }
  }, {
    key: "textblockFromContext",
    value: function textblockFromContext() {
      var $context = this.options.context;
      if ($context) for (var d = $context.depth; d >= 0; d--) {
        var deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
        if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
      }
      for (var name in this.parser.schema.nodes) {
        var type = this.parser.schema.nodes[name];
        if (type.isTextblock && type.defaultAttrs) return type;
      }
    }
  }]);
  return ParseContext;
}();
function normalizeList(dom) {
  for (var child = dom.firstChild, prevItem = null; child; child = child.nextSibling) {
    var name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
    if (name && listTags.hasOwnProperty(name) && prevItem) {
      prevItem.appendChild(child);
      child = prevItem;
    } else if (name == "li") {
      prevItem = child;
    } else if (name) {
      prevItem = null;
    }
  }
}
function matches(dom, selector) {
  return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function copy(obj) {
  var copy = {};
  for (var prop in obj) copy[prop] = obj[prop];
  return copy;
}
function markMayApply(markType, nodeType) {
  var nodes = nodeType.schema.nodes;
  var _loop5 = function _loop5() {
      var parent = nodes[name];
      if (!parent.allowsMarkType(markType)) return 0;
      var seen = [],
        scan = function scan(match) {
          seen.push(match);
          for (var i = 0; i < match.edgeCount; i++) {
            var _match$edge = match.edge(i),
              type = _match$edge.type,
              next = _match$edge.next;
            if (type == nodeType) return true;
            if (seen.indexOf(next) < 0 && scan(next)) return true;
          }
        };
      if (scan(parent.contentMatch)) return {
        v: true
      };
    },
    _ret2;
  for (var name in nodes) {
    _ret2 = _loop5();
    if (_ret2 === 0) continue;
    if (_ret2) return _ret2.v;
  }
}
var DOMSerializer = function () {
  function DOMSerializer(nodes, marks) {
    _classCallCheck(this, DOMSerializer);
    this.nodes = nodes;
    this.marks = marks;
  }
  _createClass(DOMSerializer, [{
    key: "serializeFragment",
    value: function serializeFragment(fragment) {
      var _this7 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var target = arguments.length > 2 ? arguments[2] : undefined;
      if (!target) target = doc(options).createDocumentFragment();
      var top = target,
        active = [];
      fragment.forEach(function (node) {
        if (active.length || node.marks.length) {
          var keep = 0,
            rendered = 0;
          while (keep < active.length && rendered < node.marks.length) {
            var next = node.marks[rendered];
            if (!_this7.marks[next.type.name]) {
              rendered++;
              continue;
            }
            if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
            keep++;
            rendered++;
          }
          while (keep < active.length) top = active.pop()[1];
          while (rendered < node.marks.length) {
            var add = node.marks[rendered++];
            var markDOM = _this7.serializeMark(add, node.isInline, options);
            if (markDOM) {
              active.push([add, top]);
              top.appendChild(markDOM.dom);
              top = markDOM.contentDOM || markDOM.dom;
            }
          }
        }
        top.appendChild(_this7.serializeNodeInner(node, options));
      });
      return target;
    }
  }, {
    key: "serializeNodeInner",
    value: function serializeNodeInner(node, options) {
      var _renderSpec2 = _renderSpec(doc(options), this.nodes[node.type.name](node), null, node.attrs),
        dom = _renderSpec2.dom,
        contentDOM = _renderSpec2.contentDOM;
      if (contentDOM) {
        if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
        this.serializeFragment(node.content, options, contentDOM);
      }
      return dom;
    }
  }, {
    key: "serializeNode",
    value: function serializeNode(node) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var dom = this.serializeNodeInner(node, options);
      for (var i = node.marks.length - 1; i >= 0; i--) {
        var wrap = this.serializeMark(node.marks[i], node.isInline, options);
        if (wrap) {
          (wrap.contentDOM || wrap.dom).appendChild(dom);
          dom = wrap.dom;
        }
      }
      return dom;
    }
  }, {
    key: "serializeMark",
    value: function serializeMark(mark, inline) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var toDOM = this.marks[mark.type.name];
      return toDOM && _renderSpec(doc(options), toDOM(mark, inline), null, mark.attrs);
    }
  }], [{
    key: "renderSpec",
    value: function renderSpec(doc, structure) {
      var xmlNS = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var blockArraysIn = arguments.length > 3 ? arguments[3] : undefined;
      return _renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
  }, {
    key: "fromSchema",
    value: function fromSchema(schema) {
      return schema.cached.domSerializer || (schema.cached.domSerializer = new DOMSerializer(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
  }, {
    key: "nodesFromSchema",
    value: function nodesFromSchema(schema) {
      var result = gatherToDOM(schema.nodes);
      if (!result.text) result.text = function (node) {
        return node.text;
      };
      return result;
    }
  }, {
    key: "marksFromSchema",
    value: function marksFromSchema(schema) {
      return gatherToDOM(schema.marks);
    }
  }]);
  return DOMSerializer;
}();
function gatherToDOM(obj) {
  var result = {};
  for (var name in obj) {
    var toDOM = obj[name].spec.toDOM;
    if (toDOM) result[name] = toDOM;
  }
  return result;
}
function doc(options) {
  return options.document || window.document;
}
var suspiciousAttributeCache = new WeakMap();
function suspiciousAttributes(attrs) {
  var value = suspiciousAttributeCache.get(attrs);
  if (value === undefined) suspiciousAttributeCache.set(attrs, value = suspiciousAttributesInner(attrs));
  return value;
}
function suspiciousAttributesInner(attrs) {
  var result = null;
  function scan(value) {
    if (value && _typeof(value) == "object") {
      if (Array.isArray(value)) {
        if (typeof value[0] == "string") {
          if (!result) result = [];
          result.push(value);
        } else {
          for (var i = 0; i < value.length; i++) scan(value[i]);
        }
      } else {
        for (var prop in value) scan(value[prop]);
      }
    }
  }
  scan(attrs);
  return result;
}
function _renderSpec(doc, structure, xmlNS, blockArraysIn) {
  if (typeof structure == "string") return {
    dom: doc.createTextNode(structure)
  };
  if (structure.nodeType != null) return {
    dom: structure
  };
  if (structure.dom && structure.dom.nodeType != null) return structure;
  var tagName = structure[0],
    suspicious;
  if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
  if (blockArraysIn && (suspicious = suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  var space = tagName.indexOf(" ");
  if (space > 0) {
    xmlNS = tagName.slice(0, space);
    tagName = tagName.slice(space + 1);
  }
  var contentDOM;
  var dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
  var attrs = structure[1],
    start = 1;
  if (attrs && _typeof(attrs) == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
    start = 2;
    for (var name in attrs) if (attrs[name] != null) {
      var _space = name.indexOf(" ");
      if (_space > 0) dom.setAttributeNS(name.slice(0, _space), name.slice(_space + 1), attrs[name]);else if (name == "style" && dom.style) dom.style.cssText = attrs[name];else dom.setAttribute(name, attrs[name]);
    }
  }
  for (var i = start; i < structure.length; i++) {
    var child = structure[i];
    if (child === 0) {
      if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
      return {
        dom: dom,
        contentDOM: dom
      };
    } else {
      var _renderSpec3 = _renderSpec(doc, child, xmlNS, blockArraysIn),
        inner = _renderSpec3.dom,
        innerContent = _renderSpec3.contentDOM;
      dom.appendChild(inner);
      if (innerContent) {
        if (contentDOM) throw new RangeError("Multiple content holes");
        contentDOM = innerContent;
      }
    }
  }
  return {
    dom: dom,
    contentDOM: contentDOM
  };
}
exports.ContentMatch = ContentMatch;
exports.DOMParser = DOMParser;
exports.DOMSerializer = DOMSerializer;
exports.Fragment = Fragment;
exports.Mark = Mark;
exports.MarkType = MarkType;
exports.Node = Node;
exports.NodeRange = NodeRange;
exports.NodeType = NodeType;
exports.ReplaceError = ReplaceError;
exports.ResolvedPos = ResolvedPos;
exports.Schema = Schema;
exports.Slice = Slice;


/***/ }),

/***/ 74032:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var prosemirrorTransform = __webpack_require__(92843);
var prosemirrorModel = __webpack_require__(19443);
var prosemirrorState = __webpack_require__(42391);
var olDOM = ["ol", 0],
  ulDOM = ["ul", 0],
  liDOM = ["li", 0];
var orderedList = {
  attrs: {
    order: {
      "default": 1,
      validate: "number"
    }
  },
  parseDOM: [{
    tag: "ol",
    getAttrs: function getAttrs(dom) {
      return {
        order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1
      };
    }
  }],
  toDOM: function toDOM(node) {
    return node.attrs.order == 1 ? olDOM : ["ol", {
      start: node.attrs.order
    }, 0];
  }
};
var bulletList = {
  parseDOM: [{
    tag: "ul"
  }],
  toDOM: function toDOM() {
    return ulDOM;
  }
};
var listItem = {
  parseDOM: [{
    tag: "li"
  }],
  toDOM: function toDOM() {
    return liDOM;
  },
  defining: true
};
function add(obj, props) {
  var copy = {};
  for (var prop in obj) copy[prop] = obj[prop];
  for (var _prop in props) copy[_prop] = props[_prop];
  return copy;
}
function addListNodes(nodes, itemContent, listGroup) {
  return nodes.append({
    ordered_list: add(orderedList, {
      content: "list_item+",
      group: listGroup
    }),
    bullet_list: add(bulletList, {
      content: "list_item+",
      group: listGroup
    }),
    list_item: add(listItem, {
      content: itemContent
    })
  });
}
function wrapInList(listType) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return function (state, dispatch) {
    var _state$selection = state.selection,
      $from = _state$selection.$from,
      $to = _state$selection.$to;
    var range = $from.blockRange($to);
    if (!range) return false;
    var tr = dispatch ? state.tr : null;
    if (!wrapRangeInList(tr, range, listType, attrs)) return false;
    if (dispatch) dispatch(tr.scrollIntoView());
    return true;
  };
}
function wrapRangeInList(tr, range, listType) {
  var attrs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var doJoin = false,
    outerRange = range,
    doc = range.$from.doc;
  if (range.depth >= 2 && range.$from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex == 0) {
    if (range.$from.index(range.depth - 1) == 0) return false;
    var $insert = doc.resolve(range.start - 2);
    outerRange = new prosemirrorModel.NodeRange($insert, $insert, range.depth);
    if (range.endIndex < range.parent.childCount) range = new prosemirrorModel.NodeRange(range.$from, doc.resolve(range.$to.end(range.depth)), range.depth);
    doJoin = true;
  }
  var wrap = prosemirrorTransform.findWrapping(outerRange, listType, attrs, range);
  if (!wrap) return false;
  if (tr) doWrapInList(tr, range, wrap, doJoin, listType);
  return true;
}
function doWrapInList(tr, range, wrappers, joinBefore, listType) {
  var content = prosemirrorModel.Fragment.empty;
  for (var i = wrappers.length - 1; i >= 0; i--) content = prosemirrorModel.Fragment.from(wrappers[i].type.create(wrappers[i].attrs, content));
  tr.step(new prosemirrorTransform.ReplaceAroundStep(range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end, new prosemirrorModel.Slice(content, 0, 0), wrappers.length, true));
  var found = 0;
  for (var _i = 0; _i < wrappers.length; _i++) if (wrappers[_i].type == listType) found = _i + 1;
  var splitDepth = wrappers.length - found;
  var splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0),
    parent = range.parent;
  for (var _i2 = range.startIndex, e = range.endIndex, first = true; _i2 < e; _i2++, first = false) {
    if (!first && prosemirrorTransform.canSplit(tr.doc, splitPos, splitDepth)) {
      tr.split(splitPos, splitDepth);
      splitPos += 2 * splitDepth;
    }
    splitPos += parent.child(_i2).nodeSize;
  }
  return tr;
}
function splitListItem(itemType, itemAttrs) {
  return function (state, dispatch) {
    var _state$selection2 = state.selection,
      $from = _state$selection2.$from,
      $to = _state$selection2.$to,
      node = _state$selection2.node;
    if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) return false;
    var grandParent = $from.node(-1);
    if (grandParent.type != itemType) return false;
    if ($from.parent.content.size == 0 && $from.node(-1).childCount == $from.indexAfter(-1)) {
      if ($from.depth == 3 || $from.node(-3).type != itemType || $from.index(-2) != $from.node(-2).childCount - 1) return false;
      if (dispatch) {
        var wrap = prosemirrorModel.Fragment.empty;
        var depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3;
        for (var d = $from.depth - depthBefore; d >= $from.depth - 3; d--) wrap = prosemirrorModel.Fragment.from($from.node(d).copy(wrap));
        var depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1 : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3;
        wrap = wrap.append(prosemirrorModel.Fragment.from(itemType.createAndFill()));
        var start = $from.before($from.depth - (depthBefore - 1));
        var _tr = state.tr.replace(start, $from.after(-depthAfter), new prosemirrorModel.Slice(wrap, 4 - depthBefore, 0));
        var sel = -1;
        _tr.doc.nodesBetween(start, _tr.doc.content.size, function (node, pos) {
          if (sel > -1) return false;
          if (node.isTextblock && node.content.size == 0) sel = pos + 1;
        });
        if (sel > -1) _tr.setSelection(prosemirrorState.Selection.near(_tr.doc.resolve(sel)));
        dispatch(_tr.scrollIntoView());
      }
      return true;
    }
    var nextType = $to.pos == $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
    var tr = state.tr["delete"]($from.pos, $to.pos);
    var types = nextType ? [itemAttrs ? {
      type: itemType,
      attrs: itemAttrs
    } : null, {
      type: nextType
    }] : undefined;
    if (!prosemirrorTransform.canSplit(tr.doc, $from.pos, 2, types)) return false;
    if (dispatch) dispatch(tr.split($from.pos, 2, types).scrollIntoView());
    return true;
  };
}
function splitListItemKeepMarks(itemType, itemAttrs) {
  var split = splitListItem(itemType, itemAttrs);
  return function (state, dispatch) {
    return split(state, dispatch && function (tr) {
      var marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
      if (marks) tr.ensureMarks(marks);
      dispatch(tr);
    });
  };
}
function liftListItem(itemType) {
  return function (state, dispatch) {
    var _state$selection3 = state.selection,
      $from = _state$selection3.$from,
      $to = _state$selection3.$to;
    var range = $from.blockRange($to, function (node) {
      return node.childCount > 0 && node.firstChild.type == itemType;
    });
    if (!range) return false;
    if (!dispatch) return true;
    if ($from.node(range.depth - 1).type == itemType) return liftToOuterList(state, dispatch, itemType, range);else return liftOutOfList(state, dispatch, range);
  };
}
function liftToOuterList(state, dispatch, itemType, range) {
  var tr = state.tr,
    end = range.end,
    endOfList = range.$to.end(range.depth);
  if (end < endOfList) {
    tr.step(new prosemirrorTransform.ReplaceAroundStep(end - 1, endOfList, end, endOfList, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
    range = new prosemirrorModel.NodeRange(tr.doc.resolve(range.$from.pos), tr.doc.resolve(endOfList), range.depth);
  }
  var target = prosemirrorTransform.liftTarget(range);
  if (target == null) return false;
  tr.lift(range, target);
  var $after = tr.doc.resolve(tr.mapping.map(end, -1) - 1);
  if (prosemirrorTransform.canJoin(tr.doc, $after.pos) && $after.nodeBefore.type == $after.nodeAfter.type) tr.join($after.pos);
  dispatch(tr.scrollIntoView());
  return true;
}
function liftOutOfList(state, dispatch, range) {
  var tr = state.tr,
    list = range.parent;
  for (var pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--) {
    pos -= list.child(i).nodeSize;
    tr["delete"](pos - 1, pos + 1);
  }
  var $start = tr.doc.resolve(range.start),
    item = $start.nodeAfter;
  if (tr.mapping.map(range.end) != range.start + $start.nodeAfter.nodeSize) return false;
  var atStart = range.startIndex == 0,
    atEnd = range.endIndex == list.childCount;
  var parent = $start.node(-1),
    indexBefore = $start.index(-1);
  if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1, item.content.append(atEnd ? prosemirrorModel.Fragment.empty : prosemirrorModel.Fragment.from(list)))) return false;
  var start = $start.pos,
    end = start + item.nodeSize;
  tr.step(new prosemirrorTransform.ReplaceAroundStep(start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1, new prosemirrorModel.Slice((atStart ? prosemirrorModel.Fragment.empty : prosemirrorModel.Fragment.from(list.copy(prosemirrorModel.Fragment.empty))).append(atEnd ? prosemirrorModel.Fragment.empty : prosemirrorModel.Fragment.from(list.copy(prosemirrorModel.Fragment.empty))), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
  dispatch(tr.scrollIntoView());
  return true;
}
function sinkListItem(itemType) {
  return function (state, dispatch) {
    var _state$selection4 = state.selection,
      $from = _state$selection4.$from,
      $to = _state$selection4.$to;
    var range = $from.blockRange($to, function (node) {
      return node.childCount > 0 && node.firstChild.type == itemType;
    });
    if (!range) return false;
    var startIndex = range.startIndex;
    if (startIndex == 0) return false;
    var parent = range.parent,
      nodeBefore = parent.child(startIndex - 1);
    if (nodeBefore.type != itemType) return false;
    if (dispatch) {
      var nestedBefore = nodeBefore.lastChild && nodeBefore.lastChild.type == parent.type;
      var inner = prosemirrorModel.Fragment.from(nestedBefore ? itemType.create() : null);
      var slice = new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(itemType.create(null, prosemirrorModel.Fragment.from(parent.type.create(null, inner)))), nestedBefore ? 3 : 1, 0);
      var before = range.start,
        after = range.end;
      dispatch(state.tr.step(new prosemirrorTransform.ReplaceAroundStep(before - (nestedBefore ? 3 : 1), after, before, after, slice, 1, true)).scrollIntoView());
    }
    return true;
  };
}
exports.addListNodes = addListNodes;
exports.bulletList = bulletList;
exports.liftListItem = liftListItem;
exports.listItem = listItem;
exports.orderedList = orderedList;
exports.sinkListItem = sinkListItem;
exports.splitListItem = splitListItem;
exports.splitListItemKeepMarks = splitListItemKeepMarks;
exports.wrapInList = wrapInList;
exports.wrapRangeInList = wrapRangeInList;


/***/ }),

/***/ 42391:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var prosemirrorModel = __webpack_require__(19443);

var prosemirrorTransform = __webpack_require__(92843);

var classesById = Object.create(null);

var Selection = function () {
  function Selection($anchor, $head, ranges) {
    _classCallCheck(this, Selection);

    this.$anchor = $anchor;
    this.$head = $head;
    this.ranges = ranges || [new SelectionRange($anchor.min($head), $anchor.max($head))];
  }

  _createClass(Selection, [{
    key: "anchor",
    get: function get() {
      return this.$anchor.pos;
    }
  }, {
    key: "head",
    get: function get() {
      return this.$head.pos;
    }
  }, {
    key: "from",
    get: function get() {
      return this.$from.pos;
    }
  }, {
    key: "to",
    get: function get() {
      return this.$to.pos;
    }
  }, {
    key: "$from",
    get: function get() {
      return this.ranges[0].$from;
    }
  }, {
    key: "$to",
    get: function get() {
      return this.ranges[0].$to;
    }
  }, {
    key: "empty",
    get: function get() {
      var ranges = this.ranges;

      for (var i = 0; i < ranges.length; i++) {
        if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
      }

      return true;
    }
  }, {
    key: "content",
    value: function content() {
      return this.$from.doc.slice(this.from, this.to, true);
    }
  }, {
    key: "replace",
    value: function replace(tr) {
      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prosemirrorModel.Slice.empty;
      var lastNode = content.content.lastChild,
          lastParent = null;

      for (var i = 0; i < content.openEnd; i++) {
        lastParent = lastNode;
        lastNode = lastNode.lastChild;
      }

      var mapFrom = tr.steps.length,
          ranges = this.ranges;

      for (var _i = 0; _i < ranges.length; _i++) {
        var _ranges$_i = ranges[_i],
            $from = _ranges$_i.$from,
            $to = _ranges$_i.$to,
            mapping = tr.mapping.slice(mapFrom);
        tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), _i ? prosemirrorModel.Slice.empty : content);
        if (_i == 0) selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
      }
    }
  }, {
    key: "replaceWith",
    value: function replaceWith(tr, node) {
      var mapFrom = tr.steps.length,
          ranges = this.ranges;

      for (var i = 0; i < ranges.length; i++) {
        var _ranges$i = ranges[i],
            $from = _ranges$i.$from,
            $to = _ranges$i.$to,
            mapping = tr.mapping.slice(mapFrom);
        var from = mapping.map($from.pos),
            to = mapping.map($to.pos);

        if (i) {
          tr.deleteRange(from, to);
        } else {
          tr.replaceRangeWith(from, to, node);
          selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
        }
      }
    }
  }, {
    key: "getBookmark",
    value: function getBookmark() {
      return TextSelection.between(this.$anchor, this.$head).getBookmark();
    }
  }], [{
    key: "findFrom",
    value: function findFrom($pos, dir) {
      var textOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var inner = $pos.parent.inlineContent ? new TextSelection($pos) : findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
      if (inner) return inner;

      for (var depth = $pos.depth - 1; depth >= 0; depth--) {
        var found = dir < 0 ? findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
        if (found) return found;
      }

      return null;
    }
  }, {
    key: "near",
    value: function near($pos) {
      var bias = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new AllSelection($pos.node(0));
    }
  }, {
    key: "atStart",
    value: function atStart(doc) {
      return findSelectionIn(doc, doc, 0, 0, 1) || new AllSelection(doc);
    }
  }, {
    key: "atEnd",
    value: function atEnd(doc) {
      return findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new AllSelection(doc);
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(doc, json) {
      if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
      var cls = classesById[json.type];
      if (!cls) throw new RangeError("No selection type ".concat(json.type, " defined"));
      return cls.fromJSON(doc, json);
    }
  }, {
    key: "jsonID",
    value: function jsonID(id, selectionClass) {
      if (id in classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
      classesById[id] = selectionClass;
      selectionClass.prototype.jsonID = id;
      return selectionClass;
    }
  }]);

  return Selection;
}();

Selection.prototype.visible = true;

var SelectionRange = _createClass(function SelectionRange($from, $to) {
  _classCallCheck(this, SelectionRange);

  this.$from = $from;
  this.$to = $to;
});

var warnedAboutTextSelection = false;

function checkTextSelection($pos) {
  if (!warnedAboutTextSelection && !$pos.parent.inlineContent) {
    warnedAboutTextSelection = true;
    console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
  }
}

var TextSelection = function (_Selection) {
  _inherits(TextSelection, _Selection);

  var _super = _createSuper(TextSelection);

  function TextSelection($anchor) {
    var $head = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $anchor;

    _classCallCheck(this, TextSelection);

    checkTextSelection($anchor);
    checkTextSelection($head);
    return _super.call(this, $anchor, $head);
  }

  _createClass(TextSelection, [{
    key: "$cursor",
    get: function get() {
      return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
  }, {
    key: "map",
    value: function map(doc, mapping) {
      var $head = doc.resolve(mapping.map(this.head));
      if (!$head.parent.inlineContent) return Selection.near($head);
      var $anchor = doc.resolve(mapping.map(this.anchor));
      return new TextSelection($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
  }, {
    key: "replace",
    value: function replace(tr) {
      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prosemirrorModel.Slice.empty;

      _get(_getPrototypeOf(TextSelection.prototype), "replace", this).call(this, tr, content);

      if (content == prosemirrorModel.Slice.empty) {
        var marks = this.$from.marksAcross(this.$to);
        if (marks) tr.ensureMarks(marks);
      }
    }
  }, {
    key: "eq",
    value: function eq(other) {
      return other instanceof TextSelection && other.anchor == this.anchor && other.head == this.head;
    }
  }, {
    key: "getBookmark",
    value: function getBookmark() {
      return new TextBookmark(this.anchor, this.head);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        type: "text",
        anchor: this.anchor,
        head: this.head
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(doc, json) {
      if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
      return new TextSelection(doc.resolve(json.anchor), doc.resolve(json.head));
    }
  }, {
    key: "create",
    value: function create(doc, anchor) {
      var head = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : anchor;
      var $anchor = doc.resolve(anchor);
      return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
  }, {
    key: "between",
    value: function between($anchor, $head, bias) {
      var dPos = $anchor.pos - $head.pos;
      if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;

      if (!$head.parent.inlineContent) {
        var found = Selection.findFrom($head, bias, true) || Selection.findFrom($head, -bias, true);
        if (found) $head = found.$head;else return Selection.near($head, bias);
      }

      if (!$anchor.parent.inlineContent) {
        if (dPos == 0) {
          $anchor = $head;
        } else {
          $anchor = (Selection.findFrom($anchor, -bias, true) || Selection.findFrom($anchor, bias, true)).$anchor;
          if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
        }
      }

      return new TextSelection($anchor, $head);
    }
  }]);

  return TextSelection;
}(Selection);

Selection.jsonID("text", TextSelection);

var TextBookmark = function () {
  function TextBookmark(anchor, head) {
    _classCallCheck(this, TextBookmark);

    this.anchor = anchor;
    this.head = head;
  }

  _createClass(TextBookmark, [{
    key: "map",
    value: function map(mapping) {
      return new TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
  }, {
    key: "resolve",
    value: function resolve(doc) {
      return TextSelection.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
  }]);

  return TextBookmark;
}();

var NodeSelection = function (_Selection2) {
  _inherits(NodeSelection, _Selection2);

  var _super2 = _createSuper(NodeSelection);

  function NodeSelection($pos) {
    var _this;

    _classCallCheck(this, NodeSelection);

    var node = $pos.nodeAfter;
    var $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
    _this = _super2.call(this, $pos, $end);
    _this.node = node;
    return _this;
  }

  _createClass(NodeSelection, [{
    key: "map",
    value: function map(doc, mapping) {
      var _mapping$mapResult = mapping.mapResult(this.anchor),
          deleted = _mapping$mapResult.deleted,
          pos = _mapping$mapResult.pos;

      var $pos = doc.resolve(pos);
      if (deleted) return Selection.near($pos);
      return new NodeSelection($pos);
    }
  }, {
    key: "content",
    value: function content() {
      return new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(this.node), 0, 0);
    }
  }, {
    key: "eq",
    value: function eq(other) {
      return other instanceof NodeSelection && other.anchor == this.anchor;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        type: "node",
        anchor: this.anchor
      };
    }
  }, {
    key: "getBookmark",
    value: function getBookmark() {
      return new NodeBookmark(this.anchor);
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(doc, json) {
      if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
      return new NodeSelection(doc.resolve(json.anchor));
    }
  }, {
    key: "create",
    value: function create(doc, from) {
      return new NodeSelection(doc.resolve(from));
    }
  }, {
    key: "isSelectable",
    value: function isSelectable(node) {
      return !node.isText && node.type.spec.selectable !== false;
    }
  }]);

  return NodeSelection;
}(Selection);

NodeSelection.prototype.visible = false;
Selection.jsonID("node", NodeSelection);

var NodeBookmark = function () {
  function NodeBookmark(anchor) {
    _classCallCheck(this, NodeBookmark);

    this.anchor = anchor;
  }

  _createClass(NodeBookmark, [{
    key: "map",
    value: function map(mapping) {
      var _mapping$mapResult2 = mapping.mapResult(this.anchor),
          deleted = _mapping$mapResult2.deleted,
          pos = _mapping$mapResult2.pos;

      return deleted ? new TextBookmark(pos, pos) : new NodeBookmark(pos);
    }
  }, {
    key: "resolve",
    value: function resolve(doc) {
      var $pos = doc.resolve(this.anchor),
          node = $pos.nodeAfter;
      if (node && NodeSelection.isSelectable(node)) return new NodeSelection($pos);
      return Selection.near($pos);
    }
  }]);

  return NodeBookmark;
}();

var AllSelection = function (_Selection3) {
  _inherits(AllSelection, _Selection3);

  var _super3 = _createSuper(AllSelection);

  function AllSelection(doc) {
    _classCallCheck(this, AllSelection);

    return _super3.call(this, doc.resolve(0), doc.resolve(doc.content.size));
  }

  _createClass(AllSelection, [{
    key: "replace",
    value: function replace(tr) {
      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prosemirrorModel.Slice.empty;

      if (content == prosemirrorModel.Slice.empty) {
        tr["delete"](0, tr.doc.content.size);
        var sel = Selection.atStart(tr.doc);
        if (!sel.eq(tr.selection)) tr.setSelection(sel);
      } else {
        _get(_getPrototypeOf(AllSelection.prototype), "replace", this).call(this, tr, content);
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        type: "all"
      };
    }
  }, {
    key: "map",
    value: function map(doc) {
      return new AllSelection(doc);
    }
  }, {
    key: "eq",
    value: function eq(other) {
      return other instanceof AllSelection;
    }
  }, {
    key: "getBookmark",
    value: function getBookmark() {
      return AllBookmark;
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(doc) {
      return new AllSelection(doc);
    }
  }]);

  return AllSelection;
}(Selection);

Selection.jsonID("all", AllSelection);
var AllBookmark = {
  map: function map() {
    return this;
  },
  resolve: function resolve(doc) {
    return new AllSelection(doc);
  }
};

function findSelectionIn(doc, node, pos, index, dir) {
  var text = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  if (node.inlineContent) return TextSelection.create(doc, pos);

  for (var i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir) {
    var child = node.child(i);

    if (!child.isAtom) {
      var inner = findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
      if (inner) return inner;
    } else if (!text && NodeSelection.isSelectable(child)) {
      return NodeSelection.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
    }

    pos += child.nodeSize * dir;
  }

  return null;
}

function selectionToInsertionEnd(tr, startLen, bias) {
  var last = tr.steps.length - 1;
  if (last < startLen) return;
  var step = tr.steps[last];
  if (!(step instanceof prosemirrorTransform.ReplaceStep || step instanceof prosemirrorTransform.ReplaceAroundStep)) return;
  var map = tr.mapping.maps[last],
      end;
  map.forEach(function (_from, _to, _newFrom, newTo) {
    if (end == null) end = newTo;
  });
  tr.setSelection(Selection.near(tr.doc.resolve(end), bias));
}

var UPDATED_SEL = 1,
    UPDATED_MARKS = 2,
    UPDATED_SCROLL = 4;

var Transaction = function (_prosemirrorTransform) {
  _inherits(Transaction, _prosemirrorTransform);

  var _super4 = _createSuper(Transaction);

  function Transaction(state) {
    var _this2;

    _classCallCheck(this, Transaction);

    _this2 = _super4.call(this, state.doc);
    _this2.curSelectionFor = 0;
    _this2.updated = 0;
    _this2.meta = Object.create(null);
    _this2.time = Date.now();
    _this2.curSelection = state.selection;
    _this2.storedMarks = state.storedMarks;
    return _this2;
  }

  _createClass(Transaction, [{
    key: "selection",
    get: function get() {
      if (this.curSelectionFor < this.steps.length) {
        this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
        this.curSelectionFor = this.steps.length;
      }

      return this.curSelection;
    }
  }, {
    key: "setSelection",
    value: function setSelection(selection) {
      if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
      this.curSelection = selection;
      this.curSelectionFor = this.steps.length;
      this.updated = (this.updated | UPDATED_SEL) & ~UPDATED_MARKS;
      this.storedMarks = null;
      return this;
    }
  }, {
    key: "selectionSet",
    get: function get() {
      return (this.updated & UPDATED_SEL) > 0;
    }
  }, {
    key: "setStoredMarks",
    value: function setStoredMarks(marks) {
      this.storedMarks = marks;
      this.updated |= UPDATED_MARKS;
      return this;
    }
  }, {
    key: "ensureMarks",
    value: function ensureMarks(marks) {
      if (!prosemirrorModel.Mark.sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
      return this;
    }
  }, {
    key: "addStoredMark",
    value: function addStoredMark(mark) {
      return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
  }, {
    key: "removeStoredMark",
    value: function removeStoredMark(mark) {
      return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
  }, {
    key: "storedMarksSet",
    get: function get() {
      return (this.updated & UPDATED_MARKS) > 0;
    }
  }, {
    key: "addStep",
    value: function addStep(step, doc) {
      _get(_getPrototypeOf(Transaction.prototype), "addStep", this).call(this, step, doc);

      this.updated = this.updated & ~UPDATED_MARKS;
      this.storedMarks = null;
    }
  }, {
    key: "setTime",
    value: function setTime(time) {
      this.time = time;
      return this;
    }
  }, {
    key: "replaceSelection",
    value: function replaceSelection(slice) {
      this.selection.replace(this, slice);
      return this;
    }
  }, {
    key: "replaceSelectionWith",
    value: function replaceSelectionWith(node) {
      var inheritMarks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var selection = this.selection;
      if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || prosemirrorModel.Mark.none));
      selection.replaceWith(this, node);
      return this;
    }
  }, {
    key: "deleteSelection",
    value: function deleteSelection() {
      this.selection.replace(this);
      return this;
    }
  }, {
    key: "insertText",
    value: function insertText(text, from, to) {
      var schema = this.doc.type.schema;

      if (from == null) {
        if (!text) return this.deleteSelection();
        return this.replaceSelectionWith(schema.text(text), true);
      } else {
        if (to == null) to = from;
        to = to == null ? from : to;
        if (!text) return this.deleteRange(from, to);
        var marks = this.storedMarks;

        if (!marks) {
          var $from = this.doc.resolve(from);
          marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
        }

        this.replaceRangeWith(from, to, schema.text(text, marks));
        if (!this.selection.empty) this.setSelection(Selection.near(this.selection.$to));
        return this;
      }
    }
  }, {
    key: "setMeta",
    value: function setMeta(key, value) {
      this.meta[typeof key == "string" ? key : key.key] = value;
      return this;
    }
  }, {
    key: "getMeta",
    value: function getMeta(key) {
      return this.meta[typeof key == "string" ? key : key.key];
    }
  }, {
    key: "isGeneric",
    get: function get() {
      for (var _ in this.meta) {
        return false;
      }

      return true;
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView() {
      this.updated |= UPDATED_SCROLL;
      return this;
    }
  }, {
    key: "scrolledIntoView",
    get: function get() {
      return (this.updated & UPDATED_SCROLL) > 0;
    }
  }]);

  return Transaction;
}(prosemirrorTransform.Transform);

function bind(f, self) {
  return !self || !f ? f : f.bind(self);
}

var FieldDesc = _createClass(function FieldDesc(name, desc, self) {
  _classCallCheck(this, FieldDesc);

  this.name = name;
  this.init = bind(desc.init, self);
  this.apply = bind(desc.apply, self);
});

var baseFields = [new FieldDesc("doc", {
  init: function init(config) {
    return config.doc || config.schema.topNodeType.createAndFill();
  },
  apply: function apply(tr) {
    return tr.doc;
  }
}), new FieldDesc("selection", {
  init: function init(config, instance) {
    return config.selection || Selection.atStart(instance.doc);
  },
  apply: function apply(tr) {
    return tr.selection;
  }
}), new FieldDesc("storedMarks", {
  init: function init(config) {
    return config.storedMarks || null;
  },
  apply: function apply(tr, _marks, _old, state) {
    return state.selection.$cursor ? tr.storedMarks : null;
  }
}), new FieldDesc("scrollToSelection", {
  init: function init() {
    return 0;
  },
  apply: function apply(tr, prev) {
    return tr.scrolledIntoView ? prev + 1 : prev;
  }
})];

var Configuration = _createClass(function Configuration(schema, plugins) {
  var _this3 = this;

  _classCallCheck(this, Configuration);

  this.schema = schema;
  this.plugins = [];
  this.pluginsByKey = Object.create(null);
  this.fields = baseFields.slice();
  if (plugins) plugins.forEach(function (plugin) {
    if (_this3.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");

    _this3.plugins.push(plugin);

    _this3.pluginsByKey[plugin.key] = plugin;
    if (plugin.spec.state) _this3.fields.push(new FieldDesc(plugin.key, plugin.spec.state, plugin));
  });
});

var EditorState = function () {
  function EditorState(config) {
    _classCallCheck(this, EditorState);

    this.config = config;
  }

  _createClass(EditorState, [{
    key: "schema",
    get: function get() {
      return this.config.schema;
    }
  }, {
    key: "plugins",
    get: function get() {
      return this.config.plugins;
    }
  }, {
    key: "apply",
    value: function apply(tr) {
      return this.applyTransaction(tr).state;
    }
  }, {
    key: "filterTransaction",
    value: function filterTransaction(tr) {
      var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

      for (var i = 0; i < this.config.plugins.length; i++) {
        if (i != ignore) {
          var plugin = this.config.plugins[i];
          if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
      }

      return true;
    }
  }, {
    key: "applyTransaction",
    value: function applyTransaction(rootTr) {
      if (!this.filterTransaction(rootTr)) return {
        state: this,
        transactions: []
      };
      var trs = [rootTr],
          newState = this.applyInner(rootTr),
          seen = null;

      for (;;) {
        var haveNew = false;

        for (var i = 0; i < this.config.plugins.length; i++) {
          var plugin = this.config.plugins[i];

          if (plugin.spec.appendTransaction) {
            var n = seen ? seen[i].n : 0,
                oldState = seen ? seen[i].state : this;
            var tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);

            if (tr && newState.filterTransaction(tr, i)) {
              tr.setMeta("appendedTransaction", rootTr);

              if (!seen) {
                seen = [];

                for (var j = 0; j < this.config.plugins.length; j++) {
                  seen.push(j < i ? {
                    state: newState,
                    n: trs.length
                  } : {
                    state: this,
                    n: 0
                  });
                }
              }

              trs.push(tr);
              newState = newState.applyInner(tr);
              haveNew = true;
            }

            if (seen) seen[i] = {
              state: newState,
              n: trs.length
            };
          }
        }

        if (!haveNew) return {
          state: newState,
          transactions: trs
        };
      }
    }
  }, {
    key: "applyInner",
    value: function applyInner(tr) {
      if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
      var newInstance = new EditorState(this.config),
          fields = this.config.fields;

      for (var i = 0; i < fields.length; i++) {
        var field = fields[i];
        newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
      }

      return newInstance;
    }
  }, {
    key: "tr",
    get: function get() {
      return new Transaction(this);
    }
  }, {
    key: "reconfigure",
    value: function reconfigure(config) {
      var $config = new Configuration(this.schema, config.plugins);
      var fields = $config.fields,
          instance = new EditorState($config);

      for (var i = 0; i < fields.length; i++) {
        var name = fields[i].name;
        instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
      }

      return instance;
    }
  }, {
    key: "toJSON",
    value: function toJSON(pluginFields) {
      var result = {
        doc: this.doc.toJSON(),
        selection: this.selection.toJSON()
      };
      if (this.storedMarks) result.storedMarks = this.storedMarks.map(function (m) {
        return m.toJSON();
      });
      if (pluginFields && _typeof(pluginFields) == 'object') for (var prop in pluginFields) {
        if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        var plugin = pluginFields[prop],
            state = plugin.spec.state;
        if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
      }
      return result;
    }
  }], [{
    key: "create",
    value: function create(config) {
      var $config = new Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
      var instance = new EditorState($config);

      for (var i = 0; i < $config.fields.length; i++) {
        instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
      }

      return instance;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(config, json, pluginFields) {
      if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
      if (!config.schema) throw new RangeError("Required config field 'schema' missing");
      var $config = new Configuration(config.schema, config.plugins);
      var instance = new EditorState($config);
      $config.fields.forEach(function (field) {
        if (field.name == "doc") {
          instance.doc = prosemirrorModel.Node.fromJSON(config.schema, json.doc);
        } else if (field.name == "selection") {
          instance.selection = Selection.fromJSON(instance.doc, json.selection);
        } else if (field.name == "storedMarks") {
          if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
        } else {
          if (pluginFields) for (var prop in pluginFields) {
            var plugin = pluginFields[prop],
                state = plugin.spec.state;

            if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
              instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
              return;
            }
          }
          instance[field.name] = field.init(config, instance);
        }
      });
      return instance;
    }
  }]);

  return EditorState;
}();

function bindProps(obj, self, target) {
  for (var prop in obj) {
    var val = obj[prop];
    if (val instanceof Function) val = val.bind(self);else if (prop == "handleDOMEvents") val = bindProps(val, self, {});
    target[prop] = val;
  }

  return target;
}

var Plugin = function () {
  function Plugin(spec) {
    _classCallCheck(this, Plugin);

    this.spec = spec;
    this.props = {};
    if (spec.props) bindProps(spec.props, this, this.props);
    this.key = spec.key ? spec.key.key : createKey("plugin");
  }

  _createClass(Plugin, [{
    key: "getState",
    value: function getState(state) {
      return state[this.key];
    }
  }]);

  return Plugin;
}();

var keys = Object.create(null);

function createKey(name) {
  if (name in keys) return name + "$" + ++keys[name];
  keys[name] = 0;
  return name + "$";
}

var PluginKey = function () {
  function PluginKey() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "key";

    _classCallCheck(this, PluginKey);

    this.key = createKey(name);
  }

  _createClass(PluginKey, [{
    key: "get",
    value: function get(state) {
      return state.config.pluginsByKey[this.key];
    }
  }, {
    key: "getState",
    value: function getState(state) {
      return state[this.key];
    }
  }]);

  return PluginKey;
}();

exports.AllSelection = AllSelection;
exports.EditorState = EditorState;
exports.NodeSelection = NodeSelection;
exports.Plugin = Plugin;
exports.PluginKey = PluginKey;
exports.Selection = Selection;
exports.SelectionRange = SelectionRange;
exports.TextSelection = TextSelection;
exports.Transaction = Transaction;


/***/ }),

/***/ 31640:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  CellBookmark: () => CellBookmark,
  CellSelection: () => CellSelection,
  ResizeState: () => ResizeState,
  TableMap: () => TableMap,
  TableView: () => TableView,
  __clipCells: () => clipCells,
  __insertCells: () => insertCells,
  __pastedCells: () => pastedCells,
  addColSpan: () => addColSpan,
  addColumn: () => addColumn,
  addColumnAfter: () => addColumnAfter,
  addColumnBefore: () => addColumnBefore,
  addRow: () => addRow,
  addRowAfter: () => addRowAfter,
  addRowBefore: () => addRowBefore,
  cellAround: () => cellAround,
  cellNear: () => cellNear,
  colCount: () => colCount,
  columnIsHeader: () => columnIsHeader,
  columnResizing: () => columnResizing,
  columnResizingPluginKey: () => columnResizingPluginKey,
  deleteCellSelection: () => deleteCellSelection,
  deleteColumn: () => deleteColumn,
  deleteRow: () => deleteRow,
  deleteTable: () => deleteTable,
  findCell: () => findCell,
  fixTables: () => fixTables,
  fixTablesKey: () => fixTablesKey,
  goToNextCell: () => goToNextCell,
  handlePaste: () => handlePaste,
  inSameTable: () => inSameTable,
  isInTable: () => isInTable,
  mergeCells: () => mergeCells,
  moveCellForward: () => moveCellForward,
  nextCell: () => nextCell,
  pointsAtCell: () => pointsAtCell,
  removeColSpan: () => removeColSpan,
  removeColumn: () => removeColumn,
  removeRow: () => removeRow,
  rowIsHeader: () => rowIsHeader,
  selectedRect: () => selectedRect,
  selectionCell: () => selectionCell,
  setCellAttr: () => setCellAttr,
  splitCell: () => splitCell,
  splitCellWithType: () => splitCellWithType,
  tableEditing: () => tableEditing,
  tableEditingKey: () => tableEditingKey,
  tableNodeTypes: () => tableNodeTypes,
  tableNodes: () => tableNodes,
  toggleHeader: () => toggleHeader,
  toggleHeaderCell: () => toggleHeaderCell,
  toggleHeaderColumn: () => toggleHeaderColumn,
  toggleHeaderRow: () => toggleHeaderRow,
  updateColumnsOnResize: () => updateColumnsOnResize
});
module.exports = __toCommonJS(index_exports);
var import_prosemirror_state7 = __webpack_require__(42391);

// src/cellselection.ts
var import_prosemirror_model = __webpack_require__(19443);
var import_prosemirror_state2 = __webpack_require__(42391);
var import_prosemirror_view = __webpack_require__(9222);

// src/tablemap.ts
var readFromCache;
var addToCache;
if (typeof WeakMap != "undefined") {
  let cache = /* @__PURE__ */ new WeakMap();
  readFromCache = (key) => cache.get(key);
  addToCache = (key, value) => {
    cache.set(key, value);
    return value;
  };
} else {
  const cache = [];
  const cacheSize = 10;
  let cachePos = 0;
  readFromCache = (key) => {
    for (let i = 0; i < cache.length; i += 2)
      if (cache[i] == key) return cache[i + 1];
  };
  addToCache = (key, value) => {
    if (cachePos == cacheSize) cachePos = 0;
    cache[cachePos++] = key;
    return cache[cachePos++] = value;
  };
}
var TableMap = class {
  constructor(width, height, map, problems) {
    this.width = width;
    this.height = height;
    this.map = map;
    this.problems = problems;
  }
  // Find the dimensions of the cell at the given position.
  findCell(pos) {
    for (let i = 0; i < this.map.length; i++) {
      const curPos = this.map[i];
      if (curPos != pos) continue;
      const left = i % this.width;
      const top = i / this.width | 0;
      let right = left + 1;
      let bottom = top + 1;
      for (let j = 1; right < this.width && this.map[i + j] == curPos; j++) {
        right++;
      }
      for (let j = 1; bottom < this.height && this.map[i + this.width * j] == curPos; j++) {
        bottom++;
      }
      return { left, top, right, bottom };
    }
    throw new RangeError(`No cell with offset ${pos} found`);
  }
  // Find the left side of the cell at the given position.
  colCount(pos) {
    for (let i = 0; i < this.map.length; i++) {
      if (this.map[i] == pos) {
        return i % this.width;
      }
    }
    throw new RangeError(`No cell with offset ${pos} found`);
  }
  // Find the next cell in the given direction, starting from the cell
  // at `pos`, if any.
  nextCell(pos, axis, dir) {
    const { left, right, top, bottom } = this.findCell(pos);
    if (axis == "horiz") {
      if (dir < 0 ? left == 0 : right == this.width) return null;
      return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
    } else {
      if (dir < 0 ? top == 0 : bottom == this.height) return null;
      return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
    }
  }
  // Get the rectangle spanning the two given cells.
  rectBetween(a, b) {
    const {
      left: leftA,
      right: rightA,
      top: topA,
      bottom: bottomA
    } = this.findCell(a);
    const {
      left: leftB,
      right: rightB,
      top: topB,
      bottom: bottomB
    } = this.findCell(b);
    return {
      left: Math.min(leftA, leftB),
      top: Math.min(topA, topB),
      right: Math.max(rightA, rightB),
      bottom: Math.max(bottomA, bottomB)
    };
  }
  // Return the position of all cells that have the top left corner in
  // the given rectangle.
  cellsInRect(rect) {
    const result = [];
    const seen = {};
    for (let row = rect.top; row < rect.bottom; row++) {
      for (let col = rect.left; col < rect.right; col++) {
        const index = row * this.width + col;
        const pos = this.map[index];
        if (seen[pos]) continue;
        seen[pos] = true;
        if (col == rect.left && col && this.map[index - 1] == pos || row == rect.top && row && this.map[index - this.width] == pos) {
          continue;
        }
        result.push(pos);
      }
    }
    return result;
  }
  // Return the position at which the cell at the given row and column
  // starts, or would start, if a cell started there.
  positionAt(row, col, table) {
    for (let i = 0, rowStart = 0; ; i++) {
      const rowEnd = rowStart + table.child(i).nodeSize;
      if (i == row) {
        let index = col + row * this.width;
        const rowEndIndex = (row + 1) * this.width;
        while (index < rowEndIndex && this.map[index] < rowStart) index++;
        return index == rowEndIndex ? rowEnd - 1 : this.map[index];
      }
      rowStart = rowEnd;
    }
  }
  // Find the table map for the given table node.
  static get(table) {
    return readFromCache(table) || addToCache(table, computeMap(table));
  }
};
function computeMap(table) {
  if (table.type.spec.tableRole != "table")
    throw new RangeError("Not a table node: " + table.type.name);
  const width = findWidth(table), height = table.childCount;
  const map = [];
  let mapPos = 0;
  let problems = null;
  const colWidths = [];
  for (let i = 0, e = width * height; i < e; i++) map[i] = 0;
  for (let row = 0, pos = 0; row < height; row++) {
    const rowNode = table.child(row);
    pos++;
    for (let i = 0; ; i++) {
      while (mapPos < map.length && map[mapPos] != 0) mapPos++;
      if (i == rowNode.childCount) break;
      const cellNode = rowNode.child(i);
      const { colspan, rowspan, colwidth } = cellNode.attrs;
      for (let h = 0; h < rowspan; h++) {
        if (h + row >= height) {
          (problems || (problems = [])).push({
            type: "overlong_rowspan",
            pos,
            n: rowspan - h
          });
          break;
        }
        const start = mapPos + h * width;
        for (let w = 0; w < colspan; w++) {
          if (map[start + w] == 0) map[start + w] = pos;
          else
            (problems || (problems = [])).push({
              type: "collision",
              row,
              pos,
              n: colspan - w
            });
          const colW = colwidth && colwidth[w];
          if (colW) {
            const widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
            if (prev == null || prev != colW && colWidths[widthIndex + 1] == 1) {
              colWidths[widthIndex] = colW;
              colWidths[widthIndex + 1] = 1;
            } else if (prev == colW) {
              colWidths[widthIndex + 1]++;
            }
          }
        }
      }
      mapPos += colspan;
      pos += cellNode.nodeSize;
    }
    const expectedPos = (row + 1) * width;
    let missing = 0;
    while (mapPos < expectedPos) if (map[mapPos++] == 0) missing++;
    if (missing)
      (problems || (problems = [])).push({ type: "missing", row, n: missing });
    pos++;
  }
  if (width === 0 || height === 0)
    (problems || (problems = [])).push({ type: "zero_sized" });
  const tableMap = new TableMap(width, height, map, problems);
  let badWidths = false;
  for (let i = 0; !badWidths && i < colWidths.length; i += 2)
    if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
  if (badWidths) findBadColWidths(tableMap, colWidths, table);
  return tableMap;
}
function findWidth(table) {
  let width = -1;
  let hasRowSpan = false;
  for (let row = 0; row < table.childCount; row++) {
    const rowNode = table.child(row);
    let rowWidth = 0;
    if (hasRowSpan)
      for (let j = 0; j < row; j++) {
        const prevRow = table.child(j);
        for (let i = 0; i < prevRow.childCount; i++) {
          const cell = prevRow.child(i);
          if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
        }
      }
    for (let i = 0; i < rowNode.childCount; i++) {
      const cell = rowNode.child(i);
      rowWidth += cell.attrs.colspan;
      if (cell.attrs.rowspan > 1) hasRowSpan = true;
    }
    if (width == -1) width = rowWidth;
    else if (width != rowWidth) width = Math.max(width, rowWidth);
  }
  return width;
}
function findBadColWidths(map, colWidths, table) {
  if (!map.problems) map.problems = [];
  const seen = {};
  for (let i = 0; i < map.map.length; i++) {
    const pos = map.map[i];
    if (seen[pos]) continue;
    seen[pos] = true;
    const node = table.nodeAt(pos);
    if (!node) {
      throw new RangeError(`No cell with offset ${pos} found`);
    }
    let updated = null;
    const attrs = node.attrs;
    for (let j = 0; j < attrs.colspan; j++) {
      const col = (i + j) % map.width;
      const colWidth = colWidths[col * 2];
      if (colWidth != null && (!attrs.colwidth || attrs.colwidth[j] != colWidth))
        (updated || (updated = freshColWidth(attrs)))[j] = colWidth;
    }
    if (updated)
      map.problems.unshift({
        type: "colwidth mismatch",
        pos,
        colwidth: updated
      });
  }
}
function freshColWidth(attrs) {
  if (attrs.colwidth) return attrs.colwidth.slice();
  const result = [];
  for (let i = 0; i < attrs.colspan; i++) result.push(0);
  return result;
}

// src/util.ts
var import_prosemirror_state = __webpack_require__(42391);

// src/schema.ts
function getCellAttrs(dom, extraAttrs) {
  if (typeof dom === "string") {
    return {};
  }
  const widthAttr = dom.getAttribute("data-colwidth");
  const widths = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(",").map((s) => Number(s)) : null;
  const colspan = Number(dom.getAttribute("colspan") || 1);
  const result = {
    colspan,
    rowspan: Number(dom.getAttribute("rowspan") || 1),
    colwidth: widths && widths.length == colspan ? widths : null
  };
  for (const prop in extraAttrs) {
    const getter = extraAttrs[prop].getFromDOM;
    const value = getter && getter(dom);
    if (value != null) {
      result[prop] = value;
    }
  }
  return result;
}
function setCellAttrs(node, extraAttrs) {
  const attrs = {};
  if (node.attrs.colspan != 1) attrs.colspan = node.attrs.colspan;
  if (node.attrs.rowspan != 1) attrs.rowspan = node.attrs.rowspan;
  if (node.attrs.colwidth)
    attrs["data-colwidth"] = node.attrs.colwidth.join(",");
  for (const prop in extraAttrs) {
    const setter = extraAttrs[prop].setDOMAttr;
    if (setter) setter(node.attrs[prop], attrs);
  }
  return attrs;
}
function validateColwidth(value) {
  if (value === null) {
    return;
  }
  if (!Array.isArray(value)) {
    throw new TypeError("colwidth must be null or an array");
  }
  for (const item of value) {
    if (typeof item !== "number") {
      throw new TypeError("colwidth must be null or an array of numbers");
    }
  }
}
function tableNodes(options) {
  const extraAttrs = options.cellAttributes || {};
  const cellAttrs = {
    colspan: { default: 1, validate: "number" },
    rowspan: { default: 1, validate: "number" },
    colwidth: { default: null, validate: validateColwidth }
  };
  for (const prop in extraAttrs)
    cellAttrs[prop] = {
      default: extraAttrs[prop].default,
      validate: extraAttrs[prop].validate
    };
  return {
    table: {
      content: "table_row+",
      tableRole: "table",
      isolating: true,
      group: options.tableGroup,
      parseDOM: [{ tag: "table" }],
      toDOM() {
        return ["table", ["tbody", 0]];
      }
    },
    table_row: {
      content: "(table_cell | table_header)*",
      tableRole: "row",
      parseDOM: [{ tag: "tr" }],
      toDOM() {
        return ["tr", 0];
      }
    },
    table_cell: {
      content: options.cellContent,
      attrs: cellAttrs,
      tableRole: "cell",
      isolating: true,
      parseDOM: [
        { tag: "td", getAttrs: (dom) => getCellAttrs(dom, extraAttrs) }
      ],
      toDOM(node) {
        return ["td", setCellAttrs(node, extraAttrs), 0];
      }
    },
    table_header: {
      content: options.cellContent,
      attrs: cellAttrs,
      tableRole: "header_cell",
      isolating: true,
      parseDOM: [
        { tag: "th", getAttrs: (dom) => getCellAttrs(dom, extraAttrs) }
      ],
      toDOM(node) {
        return ["th", setCellAttrs(node, extraAttrs), 0];
      }
    }
  };
}
function tableNodeTypes(schema) {
  let result = schema.cached.tableNodeTypes;
  if (!result) {
    result = schema.cached.tableNodeTypes = {};
    for (const name in schema.nodes) {
      const type = schema.nodes[name], role = type.spec.tableRole;
      if (role) result[role] = type;
    }
  }
  return result;
}

// src/util.ts
var tableEditingKey = new import_prosemirror_state.PluginKey("selectingCells");
function cellAround($pos) {
  for (let d = $pos.depth - 1; d > 0; d--)
    if ($pos.node(d).type.spec.tableRole == "row")
      return $pos.node(0).resolve($pos.before(d + 1));
  return null;
}
function cellWrapping($pos) {
  for (let d = $pos.depth; d > 0; d--) {
    const role = $pos.node(d).type.spec.tableRole;
    if (role === "cell" || role === "header_cell") return $pos.node(d);
  }
  return null;
}
function isInTable(state) {
  const $head = state.selection.$head;
  for (let d = $head.depth; d > 0; d--)
    if ($head.node(d).type.spec.tableRole == "row") return true;
  return false;
}
function selectionCell(state) {
  const sel = state.selection;
  if ("$anchorCell" in sel && sel.$anchorCell) {
    return sel.$anchorCell.pos > sel.$headCell.pos ? sel.$anchorCell : sel.$headCell;
  } else if ("node" in sel && sel.node && sel.node.type.spec.tableRole == "cell") {
    return sel.$anchor;
  }
  const $cell = cellAround(sel.$head) || cellNear(sel.$head);
  if ($cell) {
    return $cell;
  }
  throw new RangeError(`No cell found around position ${sel.head}`);
}
function cellNear($pos) {
  for (let after = $pos.nodeAfter, pos = $pos.pos; after; after = after.firstChild, pos++) {
    const role = after.type.spec.tableRole;
    if (role == "cell" || role == "header_cell") return $pos.doc.resolve(pos);
  }
  for (let before = $pos.nodeBefore, pos = $pos.pos; before; before = before.lastChild, pos--) {
    const role = before.type.spec.tableRole;
    if (role == "cell" || role == "header_cell")
      return $pos.doc.resolve(pos - before.nodeSize);
  }
}
function pointsAtCell($pos) {
  return $pos.parent.type.spec.tableRole == "row" && !!$pos.nodeAfter;
}
function moveCellForward($pos) {
  return $pos.node(0).resolve($pos.pos + $pos.nodeAfter.nodeSize);
}
function inSameTable($cellA, $cellB) {
  return $cellA.depth == $cellB.depth && $cellA.pos >= $cellB.start(-1) && $cellA.pos <= $cellB.end(-1);
}
function findCell($pos) {
  return TableMap.get($pos.node(-1)).findCell($pos.pos - $pos.start(-1));
}
function colCount($pos) {
  return TableMap.get($pos.node(-1)).colCount($pos.pos - $pos.start(-1));
}
function nextCell($pos, axis, dir) {
  const table = $pos.node(-1);
  const map = TableMap.get(table);
  const tableStart = $pos.start(-1);
  const moved = map.nextCell($pos.pos - tableStart, axis, dir);
  return moved == null ? null : $pos.node(0).resolve(tableStart + moved);
}
function removeColSpan(attrs, pos, n = 1) {
  const result = { ...attrs, colspan: attrs.colspan - n };
  if (result.colwidth) {
    result.colwidth = result.colwidth.slice();
    result.colwidth.splice(pos, n);
    if (!result.colwidth.some((w) => w > 0)) result.colwidth = null;
  }
  return result;
}
function addColSpan(attrs, pos, n = 1) {
  const result = { ...attrs, colspan: attrs.colspan + n };
  if (result.colwidth) {
    result.colwidth = result.colwidth.slice();
    for (let i = 0; i < n; i++) result.colwidth.splice(pos, 0, 0);
  }
  return result;
}
function columnIsHeader(map, table, col) {
  const headerCell = tableNodeTypes(table.type.schema).header_cell;
  for (let row = 0; row < map.height; row++)
    if (table.nodeAt(map.map[col + row * map.width]).type != headerCell)
      return false;
  return true;
}

// src/cellselection.ts
var CellSelection = class _CellSelection extends import_prosemirror_state2.Selection {
  // A table selection is identified by its anchor and head cells. The
  // positions given to this constructor should point _before_ two
  // cells in the same table. They may be the same, to select a single
  // cell.
  constructor($anchorCell, $headCell = $anchorCell) {
    const table = $anchorCell.node(-1);
    const map = TableMap.get(table);
    const tableStart = $anchorCell.start(-1);
    const rect = map.rectBetween(
      $anchorCell.pos - tableStart,
      $headCell.pos - tableStart
    );
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p) => p != $headCell.pos - tableStart);
    cells.unshift($headCell.pos - tableStart);
    const ranges = cells.map((pos) => {
      const cell = table.nodeAt(pos);
      if (!cell) {
        throw RangeError(`No cell with offset ${pos} found`);
      }
      const from = tableStart + pos + 1;
      return new import_prosemirror_state2.SelectionRange(
        doc.resolve(from),
        doc.resolve(from + cell.content.size)
      );
    });
    super(ranges[0].$from, ranges[0].$to, ranges);
    this.$anchorCell = $anchorCell;
    this.$headCell = $headCell;
  }
  map(doc, mapping) {
    const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
    const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
    if (pointsAtCell($anchorCell) && pointsAtCell($headCell) && inSameTable($anchorCell, $headCell)) {
      const tableChanged = this.$anchorCell.node(-1) != $anchorCell.node(-1);
      if (tableChanged && this.isRowSelection())
        return _CellSelection.rowSelection($anchorCell, $headCell);
      else if (tableChanged && this.isColSelection())
        return _CellSelection.colSelection($anchorCell, $headCell);
      else return new _CellSelection($anchorCell, $headCell);
    }
    return import_prosemirror_state2.TextSelection.between($anchorCell, $headCell);
  }
  // Returns a rectangular slice of table rows containing the selected
  // cells.
  content() {
    const table = this.$anchorCell.node(-1);
    const map = TableMap.get(table);
    const tableStart = this.$anchorCell.start(-1);
    const rect = map.rectBetween(
      this.$anchorCell.pos - tableStart,
      this.$headCell.pos - tableStart
    );
    const seen = {};
    const rows = [];
    for (let row = rect.top; row < rect.bottom; row++) {
      const rowContent = [];
      for (let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++) {
        const pos = map.map[index];
        if (seen[pos]) continue;
        seen[pos] = true;
        const cellRect = map.findCell(pos);
        let cell = table.nodeAt(pos);
        if (!cell) {
          throw RangeError(`No cell with offset ${pos} found`);
        }
        const extraLeft = rect.left - cellRect.left;
        const extraRight = cellRect.right - rect.right;
        if (extraLeft > 0 || extraRight > 0) {
          let attrs = cell.attrs;
          if (extraLeft > 0) {
            attrs = removeColSpan(attrs, 0, extraLeft);
          }
          if (extraRight > 0) {
            attrs = removeColSpan(
              attrs,
              attrs.colspan - extraRight,
              extraRight
            );
          }
          if (cellRect.left < rect.left) {
            cell = cell.type.createAndFill(attrs);
            if (!cell) {
              throw RangeError(
                `Could not create cell with attrs ${JSON.stringify(attrs)}`
              );
            }
          } else {
            cell = cell.type.create(attrs, cell.content);
          }
        }
        if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
          const attrs = {
            ...cell.attrs,
            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
          };
          if (cellRect.top < rect.top) {
            cell = cell.type.createAndFill(attrs);
          } else {
            cell = cell.type.create(attrs, cell.content);
          }
        }
        rowContent.push(cell);
      }
      rows.push(table.child(row).copy(import_prosemirror_model.Fragment.from(rowContent)));
    }
    const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
    return new import_prosemirror_model.Slice(import_prosemirror_model.Fragment.from(fragment), 1, 1);
  }
  replace(tr, content = import_prosemirror_model.Slice.empty) {
    const mapFrom = tr.steps.length, ranges = this.ranges;
    for (let i = 0; i < ranges.length; i++) {
      const { $from, $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
      tr.replace(
        mapping.map($from.pos),
        mapping.map($to.pos),
        i ? import_prosemirror_model.Slice.empty : content
      );
    }
    const sel = import_prosemirror_state2.Selection.findFrom(
      tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)),
      -1
    );
    if (sel) tr.setSelection(sel);
  }
  replaceWith(tr, node) {
    this.replace(tr, new import_prosemirror_model.Slice(import_prosemirror_model.Fragment.from(node), 0, 0));
  }
  forEachCell(f) {
    const table = this.$anchorCell.node(-1);
    const map = TableMap.get(table);
    const tableStart = this.$anchorCell.start(-1);
    const cells = map.cellsInRect(
      map.rectBetween(
        this.$anchorCell.pos - tableStart,
        this.$headCell.pos - tableStart
      )
    );
    for (let i = 0; i < cells.length; i++) {
      f(table.nodeAt(cells[i]), tableStart + cells[i]);
    }
  }
  // True if this selection goes all the way from the top to the
  // bottom of the table.
  isColSelection() {
    const anchorTop = this.$anchorCell.index(-1);
    const headTop = this.$headCell.index(-1);
    if (Math.min(anchorTop, headTop) > 0) return false;
    const anchorBottom = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
    const headBottom = headTop + this.$headCell.nodeAfter.attrs.rowspan;
    return Math.max(anchorBottom, headBottom) == this.$headCell.node(-1).childCount;
  }
  // Returns the smallest column selection that covers the given anchor
  // and head cell.
  static colSelection($anchorCell, $headCell = $anchorCell) {
    const table = $anchorCell.node(-1);
    const map = TableMap.get(table);
    const tableStart = $anchorCell.start(-1);
    const anchorRect = map.findCell($anchorCell.pos - tableStart);
    const headRect = map.findCell($headCell.pos - tableStart);
    const doc = $anchorCell.node(0);
    if (anchorRect.top <= headRect.top) {
      if (anchorRect.top > 0)
        $anchorCell = doc.resolve(tableStart + map.map[anchorRect.left]);
      if (headRect.bottom < map.height)
        $headCell = doc.resolve(
          tableStart + map.map[map.width * (map.height - 1) + headRect.right - 1]
        );
    } else {
      if (headRect.top > 0)
        $headCell = doc.resolve(tableStart + map.map[headRect.left]);
      if (anchorRect.bottom < map.height)
        $anchorCell = doc.resolve(
          tableStart + map.map[map.width * (map.height - 1) + anchorRect.right - 1]
        );
    }
    return new _CellSelection($anchorCell, $headCell);
  }
  // True if this selection goes all the way from the left to the
  // right of the table.
  isRowSelection() {
    const table = this.$anchorCell.node(-1);
    const map = TableMap.get(table);
    const tableStart = this.$anchorCell.start(-1);
    const anchorLeft = map.colCount(this.$anchorCell.pos - tableStart);
    const headLeft = map.colCount(this.$headCell.pos - tableStart);
    if (Math.min(anchorLeft, headLeft) > 0) return false;
    const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
    const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
    return Math.max(anchorRight, headRight) == map.width;
  }
  eq(other) {
    return other instanceof _CellSelection && other.$anchorCell.pos == this.$anchorCell.pos && other.$headCell.pos == this.$headCell.pos;
  }
  // Returns the smallest row selection that covers the given anchor
  // and head cell.
  static rowSelection($anchorCell, $headCell = $anchorCell) {
    const table = $anchorCell.node(-1);
    const map = TableMap.get(table);
    const tableStart = $anchorCell.start(-1);
    const anchorRect = map.findCell($anchorCell.pos - tableStart);
    const headRect = map.findCell($headCell.pos - tableStart);
    const doc = $anchorCell.node(0);
    if (anchorRect.left <= headRect.left) {
      if (anchorRect.left > 0)
        $anchorCell = doc.resolve(
          tableStart + map.map[anchorRect.top * map.width]
        );
      if (headRect.right < map.width)
        $headCell = doc.resolve(
          tableStart + map.map[map.width * (headRect.top + 1) - 1]
        );
    } else {
      if (headRect.left > 0)
        $headCell = doc.resolve(tableStart + map.map[headRect.top * map.width]);
      if (anchorRect.right < map.width)
        $anchorCell = doc.resolve(
          tableStart + map.map[map.width * (anchorRect.top + 1) - 1]
        );
    }
    return new _CellSelection($anchorCell, $headCell);
  }
  toJSON() {
    return {
      type: "cell",
      anchor: this.$anchorCell.pos,
      head: this.$headCell.pos
    };
  }
  static fromJSON(doc, json) {
    return new _CellSelection(doc.resolve(json.anchor), doc.resolve(json.head));
  }
  static create(doc, anchorCell, headCell = anchorCell) {
    return new _CellSelection(doc.resolve(anchorCell), doc.resolve(headCell));
  }
  getBookmark() {
    return new CellBookmark(this.$anchorCell.pos, this.$headCell.pos);
  }
};
CellSelection.prototype.visible = false;
import_prosemirror_state2.Selection.jsonID("cell", CellSelection);
var CellBookmark = class _CellBookmark {
  constructor(anchor, head) {
    this.anchor = anchor;
    this.head = head;
  }
  map(mapping) {
    return new _CellBookmark(mapping.map(this.anchor), mapping.map(this.head));
  }
  resolve(doc) {
    const $anchorCell = doc.resolve(this.anchor), $headCell = doc.resolve(this.head);
    if ($anchorCell.parent.type.spec.tableRole == "row" && $headCell.parent.type.spec.tableRole == "row" && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && inSameTable($anchorCell, $headCell))
      return new CellSelection($anchorCell, $headCell);
    else return import_prosemirror_state2.Selection.near($headCell, 1);
  }
};
function drawCellSelection(state) {
  if (!(state.selection instanceof CellSelection)) return null;
  const cells = [];
  state.selection.forEachCell((node, pos) => {
    cells.push(
      import_prosemirror_view.Decoration.node(pos, pos + node.nodeSize, { class: "selectedCell" })
    );
  });
  return import_prosemirror_view.DecorationSet.create(state.doc, cells);
}
function isCellBoundarySelection({ $from, $to }) {
  if ($from.pos == $to.pos || $from.pos < $to.pos - 6) return false;
  let afterFrom = $from.pos;
  let beforeTo = $to.pos;
  let depth = $from.depth;
  for (; depth >= 0; depth--, afterFrom++)
    if ($from.after(depth + 1) < $from.end(depth)) break;
  for (let d = $to.depth; d >= 0; d--, beforeTo--)
    if ($to.before(d + 1) > $to.start(d)) break;
  return afterFrom == beforeTo && /row|table/.test($from.node(depth).type.spec.tableRole);
}
function isTextSelectionAcrossCells({ $from, $to }) {
  let fromCellBoundaryNode;
  let toCellBoundaryNode;
  for (let i = $from.depth; i > 0; i--) {
    const node = $from.node(i);
    if (node.type.spec.tableRole === "cell" || node.type.spec.tableRole === "header_cell") {
      fromCellBoundaryNode = node;
      break;
    }
  }
  for (let i = $to.depth; i > 0; i--) {
    const node = $to.node(i);
    if (node.type.spec.tableRole === "cell" || node.type.spec.tableRole === "header_cell") {
      toCellBoundaryNode = node;
      break;
    }
  }
  return fromCellBoundaryNode !== toCellBoundaryNode && $to.parentOffset === 0;
}
function normalizeSelection(state, tr, allowTableNodeSelection) {
  const sel = (tr || state).selection;
  const doc = (tr || state).doc;
  let normalize;
  let role;
  if (sel instanceof import_prosemirror_state2.NodeSelection && (role = sel.node.type.spec.tableRole)) {
    if (role == "cell" || role == "header_cell") {
      normalize = CellSelection.create(doc, sel.from);
    } else if (role == "row") {
      const $cell = doc.resolve(sel.from + 1);
      normalize = CellSelection.rowSelection($cell, $cell);
    } else if (!allowTableNodeSelection) {
      const map = TableMap.get(sel.node);
      const start = sel.from + 1;
      const lastCell = start + map.map[map.width * map.height - 1];
      normalize = CellSelection.create(doc, start + 1, lastCell);
    }
  } else if (sel instanceof import_prosemirror_state2.TextSelection && isCellBoundarySelection(sel)) {
    normalize = import_prosemirror_state2.TextSelection.create(doc, sel.from);
  } else if (sel instanceof import_prosemirror_state2.TextSelection && isTextSelectionAcrossCells(sel)) {
    normalize = import_prosemirror_state2.TextSelection.create(doc, sel.$from.start(), sel.$from.end());
  }
  if (normalize) (tr || (tr = state.tr)).setSelection(normalize);
  return tr;
}

// src/fixtables.ts
var import_prosemirror_state3 = __webpack_require__(42391);
var fixTablesKey = new import_prosemirror_state3.PluginKey("fix-tables");
function changedDescendants(old, cur, offset, f) {
  const oldSize = old.childCount, curSize = cur.childCount;
  outer: for (let i = 0, j = 0; i < curSize; i++) {
    const child = cur.child(i);
    for (let scan = j, e = Math.min(oldSize, i + 3); scan < e; scan++) {
      if (old.child(scan) == child) {
        j = scan + 1;
        offset += child.nodeSize;
        continue outer;
      }
    }
    f(child, offset);
    if (j < oldSize && old.child(j).sameMarkup(child))
      changedDescendants(old.child(j), child, offset + 1, f);
    else child.nodesBetween(0, child.content.size, f, offset + 1);
    offset += child.nodeSize;
  }
}
function fixTables(state, oldState) {
  let tr;
  const check = (node, pos) => {
    if (node.type.spec.tableRole == "table")
      tr = fixTable(state, node, pos, tr);
  };
  if (!oldState) state.doc.descendants(check);
  else if (oldState.doc != state.doc)
    changedDescendants(oldState.doc, state.doc, 0, check);
  return tr;
}
function fixTable(state, table, tablePos, tr) {
  const map = TableMap.get(table);
  if (!map.problems) return tr;
  if (!tr) tr = state.tr;
  const mustAdd = [];
  for (let i = 0; i < map.height; i++) mustAdd.push(0);
  for (let i = 0; i < map.problems.length; i++) {
    const prob = map.problems[i];
    if (prob.type == "collision") {
      const cell = table.nodeAt(prob.pos);
      if (!cell) continue;
      const attrs = cell.attrs;
      for (let j = 0; j < attrs.rowspan; j++) mustAdd[prob.row + j] += prob.n;
      tr.setNodeMarkup(
        tr.mapping.map(tablePos + 1 + prob.pos),
        null,
        removeColSpan(attrs, attrs.colspan - prob.n, prob.n)
      );
    } else if (prob.type == "missing") {
      mustAdd[prob.row] += prob.n;
    } else if (prob.type == "overlong_rowspan") {
      const cell = table.nodeAt(prob.pos);
      if (!cell) continue;
      tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, {
        ...cell.attrs,
        rowspan: cell.attrs.rowspan - prob.n
      });
    } else if (prob.type == "colwidth mismatch") {
      const cell = table.nodeAt(prob.pos);
      if (!cell) continue;
      tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, {
        ...cell.attrs,
        colwidth: prob.colwidth
      });
    } else if (prob.type == "zero_sized") {
      const pos = tr.mapping.map(tablePos);
      tr.delete(pos, pos + table.nodeSize);
    }
  }
  let first, last;
  for (let i = 0; i < mustAdd.length; i++)
    if (mustAdd[i]) {
      if (first == null) first = i;
      last = i;
    }
  for (let i = 0, pos = tablePos + 1; i < map.height; i++) {
    const row = table.child(i);
    const end = pos + row.nodeSize;
    const add = mustAdd[i];
    if (add > 0) {
      let role = "cell";
      if (row.firstChild) {
        role = row.firstChild.type.spec.tableRole;
      }
      const nodes = [];
      for (let j = 0; j < add; j++) {
        const node = tableNodeTypes(state.schema)[role].createAndFill();
        if (node) nodes.push(node);
      }
      const side = (i == 0 || first == i - 1) && last == i ? pos + 1 : end - 1;
      tr.insert(tr.mapping.map(side), nodes);
    }
    pos = end;
  }
  return tr.setMeta(fixTablesKey, { fixTables: true });
}

// src/input.ts
var import_prosemirror_keymap = __webpack_require__(97354);
var import_prosemirror_model4 = __webpack_require__(19443);
var import_prosemirror_state5 = __webpack_require__(42391);

// src/commands.ts
var import_prosemirror_model2 = __webpack_require__(19443);
var import_prosemirror_state4 = __webpack_require__(42391);
function selectedRect(state) {
  const sel = state.selection;
  const $pos = selectionCell(state);
  const table = $pos.node(-1);
  const tableStart = $pos.start(-1);
  const map = TableMap.get(table);
  const rect = sel instanceof CellSelection ? map.rectBetween(
    sel.$anchorCell.pos - tableStart,
    sel.$headCell.pos - tableStart
  ) : map.findCell($pos.pos - tableStart);
  return { ...rect, tableStart, map, table };
}
function addColumn(tr, { map, tableStart, table }, col) {
  let refColumn = col > 0 ? -1 : 0;
  if (columnIsHeader(map, table, col + refColumn)) {
    refColumn = col == 0 || col == map.width ? null : 0;
  }
  for (let row = 0; row < map.height; row++) {
    const index = row * map.width + col;
    if (col > 0 && col < map.width && map.map[index - 1] == map.map[index]) {
      const pos = map.map[index];
      const cell = table.nodeAt(pos);
      tr.setNodeMarkup(
        tr.mapping.map(tableStart + pos),
        null,
        addColSpan(cell.attrs, col - map.colCount(pos))
      );
      row += cell.attrs.rowspan - 1;
    } else {
      const type = refColumn == null ? tableNodeTypes(table.type.schema).cell : table.nodeAt(map.map[index + refColumn]).type;
      const pos = map.positionAt(row, col, table);
      tr.insert(tr.mapping.map(tableStart + pos), type.createAndFill());
    }
  }
  return tr;
}
function addColumnBefore(state, dispatch) {
  if (!isInTable(state)) return false;
  if (dispatch) {
    const rect = selectedRect(state);
    dispatch(addColumn(state.tr, rect, rect.left));
  }
  return true;
}
function addColumnAfter(state, dispatch) {
  if (!isInTable(state)) return false;
  if (dispatch) {
    const rect = selectedRect(state);
    dispatch(addColumn(state.tr, rect, rect.right));
  }
  return true;
}
function removeColumn(tr, { map, table, tableStart }, col) {
  const mapStart = tr.mapping.maps.length;
  for (let row = 0; row < map.height; ) {
    const index = row * map.width + col;
    const pos = map.map[index];
    const cell = table.nodeAt(pos);
    const attrs = cell.attrs;
    if (col > 0 && map.map[index - 1] == pos || col < map.width - 1 && map.map[index + 1] == pos) {
      tr.setNodeMarkup(
        tr.mapping.slice(mapStart).map(tableStart + pos),
        null,
        removeColSpan(attrs, col - map.colCount(pos))
      );
    } else {
      const start = tr.mapping.slice(mapStart).map(tableStart + pos);
      tr.delete(start, start + cell.nodeSize);
    }
    row += attrs.rowspan;
  }
}
function deleteColumn(state, dispatch) {
  if (!isInTable(state)) return false;
  if (dispatch) {
    const rect = selectedRect(state);
    const tr = state.tr;
    if (rect.left == 0 && rect.right == rect.map.width) return false;
    for (let i = rect.right - 1; ; i--) {
      removeColumn(tr, rect, i);
      if (i == rect.left) break;
      const table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;
      if (!table) {
        throw RangeError("No table found");
      }
      rect.table = table;
      rect.map = TableMap.get(table);
    }
    dispatch(tr);
  }
  return true;
}
function rowIsHeader(map, table, row) {
  var _a;
  const headerCell = tableNodeTypes(table.type.schema).header_cell;
  for (let col = 0; col < map.width; col++)
    if (((_a = table.nodeAt(map.map[col + row * map.width])) == null ? void 0 : _a.type) != headerCell)
      return false;
  return true;
}
function addRow(tr, { map, tableStart, table }, row) {
  var _a;
  let rowPos = tableStart;
  for (let i = 0; i < row; i++) rowPos += table.child(i).nodeSize;
  const cells = [];
  let refRow = row > 0 ? -1 : 0;
  if (rowIsHeader(map, table, row + refRow))
    refRow = row == 0 || row == map.height ? null : 0;
  for (let col = 0, index = map.width * row; col < map.width; col++, index++) {
    if (row > 0 && row < map.height && map.map[index] == map.map[index - map.width]) {
      const pos = map.map[index];
      const attrs = table.nodeAt(pos).attrs;
      tr.setNodeMarkup(tableStart + pos, null, {
        ...attrs,
        rowspan: attrs.rowspan + 1
      });
      col += attrs.colspan - 1;
    } else {
      const type = refRow == null ? tableNodeTypes(table.type.schema).cell : (_a = table.nodeAt(map.map[index + refRow * map.width])) == null ? void 0 : _a.type;
      const node = type == null ? void 0 : type.createAndFill();
      if (node) cells.push(node);
    }
  }
  tr.insert(rowPos, tableNodeTypes(table.type.schema).row.create(null, cells));
  return tr;
}
function addRowBefore(state, dispatch) {
  if (!isInTable(state)) return false;
  if (dispatch) {
    const rect = selectedRect(state);
    dispatch(addRow(state.tr, rect, rect.top));
  }
  return true;
}
function addRowAfter(state, dispatch) {
  if (!isInTable(state)) return false;
  if (dispatch) {
    const rect = selectedRect(state);
    dispatch(addRow(state.tr, rect, rect.bottom));
  }
  return true;
}
function removeRow(tr, { map, table, tableStart }, row) {
  let rowPos = 0;
  for (let i = 0; i < row; i++) rowPos += table.child(i).nodeSize;
  const nextRow = rowPos + table.child(row).nodeSize;
  const mapFrom = tr.mapping.maps.length;
  tr.delete(rowPos + tableStart, nextRow + tableStart);
  const seen = /* @__PURE__ */ new Set();
  for (let col = 0, index = row * map.width; col < map.width; col++, index++) {
    const pos = map.map[index];
    if (seen.has(pos)) continue;
    seen.add(pos);
    if (row > 0 && pos == map.map[index - map.width]) {
      const attrs = table.nodeAt(pos).attrs;
      tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + tableStart), null, {
        ...attrs,
        rowspan: attrs.rowspan - 1
      });
      col += attrs.colspan - 1;
    } else if (row < map.height && pos == map.map[index + map.width]) {
      const cell = table.nodeAt(pos);
      const attrs = cell.attrs;
      const copy = cell.type.create(
        { ...attrs, rowspan: cell.attrs.rowspan - 1 },
        cell.content
      );
      const newPos = map.positionAt(row + 1, col, table);
      tr.insert(tr.mapping.slice(mapFrom).map(tableStart + newPos), copy);
      col += attrs.colspan - 1;
    }
  }
}
function deleteRow(state, dispatch) {
  if (!isInTable(state)) return false;
  if (dispatch) {
    const rect = selectedRect(state), tr = state.tr;
    if (rect.top == 0 && rect.bottom == rect.map.height) return false;
    for (let i = rect.bottom - 1; ; i--) {
      removeRow(tr, rect, i);
      if (i == rect.top) break;
      const table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;
      if (!table) {
        throw RangeError("No table found");
      }
      rect.table = table;
      rect.map = TableMap.get(rect.table);
    }
    dispatch(tr);
  }
  return true;
}
function isEmpty(cell) {
  const c = cell.content;
  return c.childCount == 1 && c.child(0).isTextblock && c.child(0).childCount == 0;
}
function cellsOverlapRectangle({ width, height, map }, rect) {
  let indexTop = rect.top * width + rect.left, indexLeft = indexTop;
  let indexBottom = (rect.bottom - 1) * width + rect.left, indexRight = indexTop + (rect.right - rect.left - 1);
  for (let i = rect.top; i < rect.bottom; i++) {
    if (rect.left > 0 && map[indexLeft] == map[indexLeft - 1] || rect.right < width && map[indexRight] == map[indexRight + 1])
      return true;
    indexLeft += width;
    indexRight += width;
  }
  for (let i = rect.left; i < rect.right; i++) {
    if (rect.top > 0 && map[indexTop] == map[indexTop - width] || rect.bottom < height && map[indexBottom] == map[indexBottom + width])
      return true;
    indexTop++;
    indexBottom++;
  }
  return false;
}
function mergeCells(state, dispatch) {
  const sel = state.selection;
  if (!(sel instanceof CellSelection) || sel.$anchorCell.pos == sel.$headCell.pos)
    return false;
  const rect = selectedRect(state), { map } = rect;
  if (cellsOverlapRectangle(map, rect)) return false;
  if (dispatch) {
    const tr = state.tr;
    const seen = {};
    let content = import_prosemirror_model2.Fragment.empty;
    let mergedPos;
    let mergedCell;
    for (let row = rect.top; row < rect.bottom; row++) {
      for (let col = rect.left; col < rect.right; col++) {
        const cellPos = map.map[row * map.width + col];
        const cell = rect.table.nodeAt(cellPos);
        if (seen[cellPos] || !cell) continue;
        seen[cellPos] = true;
        if (mergedPos == null) {
          mergedPos = cellPos;
          mergedCell = cell;
        } else {
          if (!isEmpty(cell)) content = content.append(cell.content);
          const mapped = tr.mapping.map(cellPos + rect.tableStart);
          tr.delete(mapped, mapped + cell.nodeSize);
        }
      }
    }
    if (mergedPos == null || mergedCell == null) {
      return true;
    }
    tr.setNodeMarkup(mergedPos + rect.tableStart, null, {
      ...addColSpan(
        mergedCell.attrs,
        mergedCell.attrs.colspan,
        rect.right - rect.left - mergedCell.attrs.colspan
      ),
      rowspan: rect.bottom - rect.top
    });
    if (content.size) {
      const end = mergedPos + 1 + mergedCell.content.size;
      const start = isEmpty(mergedCell) ? mergedPos + 1 : end;
      tr.replaceWith(start + rect.tableStart, end + rect.tableStart, content);
    }
    tr.setSelection(
      new CellSelection(tr.doc.resolve(mergedPos + rect.tableStart))
    );
    dispatch(tr);
  }
  return true;
}
function splitCell(state, dispatch) {
  const nodeTypes = tableNodeTypes(state.schema);
  return splitCellWithType(({ node }) => {
    return nodeTypes[node.type.spec.tableRole];
  })(state, dispatch);
}
function splitCellWithType(getCellType) {
  return (state, dispatch) => {
    var _a;
    const sel = state.selection;
    let cellNode;
    let cellPos;
    if (!(sel instanceof CellSelection)) {
      cellNode = cellWrapping(sel.$from);
      if (!cellNode) return false;
      cellPos = (_a = cellAround(sel.$from)) == null ? void 0 : _a.pos;
    } else {
      if (sel.$anchorCell.pos != sel.$headCell.pos) return false;
      cellNode = sel.$anchorCell.nodeAfter;
      cellPos = sel.$anchorCell.pos;
    }
    if (cellNode == null || cellPos == null) {
      return false;
    }
    if (cellNode.attrs.colspan == 1 && cellNode.attrs.rowspan == 1) {
      return false;
    }
    if (dispatch) {
      let baseAttrs = cellNode.attrs;
      const attrs = [];
      const colwidth = baseAttrs.colwidth;
      if (baseAttrs.rowspan > 1) baseAttrs = { ...baseAttrs, rowspan: 1 };
      if (baseAttrs.colspan > 1) baseAttrs = { ...baseAttrs, colspan: 1 };
      const rect = selectedRect(state), tr = state.tr;
      for (let i = 0; i < rect.right - rect.left; i++)
        attrs.push(
          colwidth ? {
            ...baseAttrs,
            colwidth: colwidth && colwidth[i] ? [colwidth[i]] : null
          } : baseAttrs
        );
      let lastCell;
      for (let row = rect.top; row < rect.bottom; row++) {
        let pos = rect.map.positionAt(row, rect.left, rect.table);
        if (row == rect.top) pos += cellNode.nodeSize;
        for (let col = rect.left, i = 0; col < rect.right; col++, i++) {
          if (col == rect.left && row == rect.top) continue;
          tr.insert(
            lastCell = tr.mapping.map(pos + rect.tableStart, 1),
            getCellType({ node: cellNode, row, col }).createAndFill(attrs[i])
          );
        }
      }
      tr.setNodeMarkup(
        cellPos,
        getCellType({ node: cellNode, row: rect.top, col: rect.left }),
        attrs[0]
      );
      if (sel instanceof CellSelection)
        tr.setSelection(
          new CellSelection(
            tr.doc.resolve(sel.$anchorCell.pos),
            lastCell ? tr.doc.resolve(lastCell) : void 0
          )
        );
      dispatch(tr);
    }
    return true;
  };
}
function setCellAttr(name, value) {
  return function(state, dispatch) {
    if (!isInTable(state)) return false;
    const $cell = selectionCell(state);
    if ($cell.nodeAfter.attrs[name] === value) return false;
    if (dispatch) {
      const tr = state.tr;
      if (state.selection instanceof CellSelection)
        state.selection.forEachCell((node, pos) => {
          if (node.attrs[name] !== value)
            tr.setNodeMarkup(pos, null, {
              ...node.attrs,
              [name]: value
            });
        });
      else
        tr.setNodeMarkup($cell.pos, null, {
          ...$cell.nodeAfter.attrs,
          [name]: value
        });
      dispatch(tr);
    }
    return true;
  };
}
function deprecated_toggleHeader(type) {
  return function(state, dispatch) {
    if (!isInTable(state)) return false;
    if (dispatch) {
      const types = tableNodeTypes(state.schema);
      const rect = selectedRect(state), tr = state.tr;
      const cells = rect.map.cellsInRect(
        type == "column" ? {
          left: rect.left,
          top: 0,
          right: rect.right,
          bottom: rect.map.height
        } : type == "row" ? {
          left: 0,
          top: rect.top,
          right: rect.map.width,
          bottom: rect.bottom
        } : rect
      );
      const nodes = cells.map((pos) => rect.table.nodeAt(pos));
      for (let i = 0; i < cells.length; i++)
        if (nodes[i].type == types.header_cell)
          tr.setNodeMarkup(
            rect.tableStart + cells[i],
            types.cell,
            nodes[i].attrs
          );
      if (tr.steps.length == 0)
        for (let i = 0; i < cells.length; i++)
          tr.setNodeMarkup(
            rect.tableStart + cells[i],
            types.header_cell,
            nodes[i].attrs
          );
      dispatch(tr);
    }
    return true;
  };
}
function isHeaderEnabledByType(type, rect, types) {
  const cellPositions = rect.map.cellsInRect({
    left: 0,
    top: 0,
    right: type == "row" ? rect.map.width : 1,
    bottom: type == "column" ? rect.map.height : 1
  });
  for (let i = 0; i < cellPositions.length; i++) {
    const cell = rect.table.nodeAt(cellPositions[i]);
    if (cell && cell.type !== types.header_cell) {
      return false;
    }
  }
  return true;
}
function toggleHeader(type, options) {
  options = options || { useDeprecatedLogic: false };
  if (options.useDeprecatedLogic) return deprecated_toggleHeader(type);
  return function(state, dispatch) {
    if (!isInTable(state)) return false;
    if (dispatch) {
      const types = tableNodeTypes(state.schema);
      const rect = selectedRect(state), tr = state.tr;
      const isHeaderRowEnabled = isHeaderEnabledByType("row", rect, types);
      const isHeaderColumnEnabled = isHeaderEnabledByType(
        "column",
        rect,
        types
      );
      const isHeaderEnabled = type === "column" ? isHeaderRowEnabled : type === "row" ? isHeaderColumnEnabled : false;
      const selectionStartsAt = isHeaderEnabled ? 1 : 0;
      const cellsRect = type == "column" ? {
        left: 0,
        top: selectionStartsAt,
        right: 1,
        bottom: rect.map.height
      } : type == "row" ? {
        left: selectionStartsAt,
        top: 0,
        right: rect.map.width,
        bottom: 1
      } : rect;
      const newType = type == "column" ? isHeaderColumnEnabled ? types.cell : types.header_cell : type == "row" ? isHeaderRowEnabled ? types.cell : types.header_cell : types.cell;
      rect.map.cellsInRect(cellsRect).forEach((relativeCellPos) => {
        const cellPos = relativeCellPos + rect.tableStart;
        const cell = tr.doc.nodeAt(cellPos);
        if (cell) {
          tr.setNodeMarkup(cellPos, newType, cell.attrs);
        }
      });
      dispatch(tr);
    }
    return true;
  };
}
var toggleHeaderRow = toggleHeader("row", {
  useDeprecatedLogic: true
});
var toggleHeaderColumn = toggleHeader("column", {
  useDeprecatedLogic: true
});
var toggleHeaderCell = toggleHeader("cell", {
  useDeprecatedLogic: true
});
function findNextCell($cell, dir) {
  if (dir < 0) {
    const before = $cell.nodeBefore;
    if (before) return $cell.pos - before.nodeSize;
    for (let row = $cell.index(-1) - 1, rowEnd = $cell.before(); row >= 0; row--) {
      const rowNode = $cell.node(-1).child(row);
      const lastChild = rowNode.lastChild;
      if (lastChild) {
        return rowEnd - 1 - lastChild.nodeSize;
      }
      rowEnd -= rowNode.nodeSize;
    }
  } else {
    if ($cell.index() < $cell.parent.childCount - 1) {
      return $cell.pos + $cell.nodeAfter.nodeSize;
    }
    const table = $cell.node(-1);
    for (let row = $cell.indexAfter(-1), rowStart = $cell.after(); row < table.childCount; row++) {
      const rowNode = table.child(row);
      if (rowNode.childCount) return rowStart + 1;
      rowStart += rowNode.nodeSize;
    }
  }
  return null;
}
function goToNextCell(direction) {
  return function(state, dispatch) {
    if (!isInTable(state)) return false;
    const cell = findNextCell(selectionCell(state), direction);
    if (cell == null) return false;
    if (dispatch) {
      const $cell = state.doc.resolve(cell);
      dispatch(
        state.tr.setSelection(import_prosemirror_state4.TextSelection.between($cell, moveCellForward($cell))).scrollIntoView()
      );
    }
    return true;
  };
}
function deleteTable(state, dispatch) {
  const $pos = state.selection.$anchor;
  for (let d = $pos.depth; d > 0; d--) {
    const node = $pos.node(d);
    if (node.type.spec.tableRole == "table") {
      if (dispatch)
        dispatch(
          state.tr.delete($pos.before(d), $pos.after(d)).scrollIntoView()
        );
      return true;
    }
  }
  return false;
}
function deleteCellSelection(state, dispatch) {
  const sel = state.selection;
  if (!(sel instanceof CellSelection)) return false;
  if (dispatch) {
    const tr = state.tr;
    const baseContent = tableNodeTypes(state.schema).cell.createAndFill().content;
    sel.forEachCell((cell, pos) => {
      if (!cell.content.eq(baseContent))
        tr.replace(
          tr.mapping.map(pos + 1),
          tr.mapping.map(pos + cell.nodeSize - 1),
          new import_prosemirror_model2.Slice(baseContent, 0, 0)
        );
    });
    if (tr.docChanged) dispatch(tr);
  }
  return true;
}

// src/copypaste.ts
var import_prosemirror_model3 = __webpack_require__(19443);
var import_prosemirror_transform = __webpack_require__(92843);
function pastedCells(slice) {
  if (!slice.size) return null;
  let { content, openStart, openEnd } = slice;
  while (content.childCount == 1 && (openStart > 0 && openEnd > 0 || content.child(0).type.spec.tableRole == "table")) {
    openStart--;
    openEnd--;
    content = content.child(0).content;
  }
  const first = content.child(0);
  const role = first.type.spec.tableRole;
  const schema = first.type.schema, rows = [];
  if (role == "row") {
    for (let i = 0; i < content.childCount; i++) {
      let cells = content.child(i).content;
      const left = i ? 0 : Math.max(0, openStart - 1);
      const right = i < content.childCount - 1 ? 0 : Math.max(0, openEnd - 1);
      if (left || right)
        cells = fitSlice(
          tableNodeTypes(schema).row,
          new import_prosemirror_model3.Slice(cells, left, right)
        ).content;
      rows.push(cells);
    }
  } else if (role == "cell" || role == "header_cell") {
    rows.push(
      openStart || openEnd ? fitSlice(
        tableNodeTypes(schema).row,
        new import_prosemirror_model3.Slice(content, openStart, openEnd)
      ).content : content
    );
  } else {
    return null;
  }
  return ensureRectangular(schema, rows);
}
function ensureRectangular(schema, rows) {
  const widths = [];
  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];
    for (let j = row.childCount - 1; j >= 0; j--) {
      const { rowspan, colspan } = row.child(j).attrs;
      for (let r = i; r < i + rowspan; r++)
        widths[r] = (widths[r] || 0) + colspan;
    }
  }
  let width = 0;
  for (let r = 0; r < widths.length; r++) width = Math.max(width, widths[r]);
  for (let r = 0; r < widths.length; r++) {
    if (r >= rows.length) rows.push(import_prosemirror_model3.Fragment.empty);
    if (widths[r] < width) {
      const empty = tableNodeTypes(schema).cell.createAndFill();
      const cells = [];
      for (let i = widths[r]; i < width; i++) {
        cells.push(empty);
      }
      rows[r] = rows[r].append(import_prosemirror_model3.Fragment.from(cells));
    }
  }
  return { height: rows.length, width, rows };
}
function fitSlice(nodeType, slice) {
  const node = nodeType.createAndFill();
  const tr = new import_prosemirror_transform.Transform(node).replace(0, node.content.size, slice);
  return tr.doc;
}
function clipCells({ width, height, rows }, newWidth, newHeight) {
  if (width != newWidth) {
    const added = [];
    const newRows = [];
    for (let row = 0; row < rows.length; row++) {
      const frag = rows[row], cells = [];
      for (let col = added[row] || 0, i = 0; col < newWidth; i++) {
        let cell = frag.child(i % frag.childCount);
        if (col + cell.attrs.colspan > newWidth)
          cell = cell.type.createChecked(
            removeColSpan(
              cell.attrs,
              cell.attrs.colspan,
              col + cell.attrs.colspan - newWidth
            ),
            cell.content
          );
        cells.push(cell);
        col += cell.attrs.colspan;
        for (let j = 1; j < cell.attrs.rowspan; j++)
          added[row + j] = (added[row + j] || 0) + cell.attrs.colspan;
      }
      newRows.push(import_prosemirror_model3.Fragment.from(cells));
    }
    rows = newRows;
    width = newWidth;
  }
  if (height != newHeight) {
    const newRows = [];
    for (let row = 0, i = 0; row < newHeight; row++, i++) {
      const cells = [], source = rows[i % height];
      for (let j = 0; j < source.childCount; j++) {
        let cell = source.child(j);
        if (row + cell.attrs.rowspan > newHeight)
          cell = cell.type.create(
            {
              ...cell.attrs,
              rowspan: Math.max(1, newHeight - cell.attrs.rowspan)
            },
            cell.content
          );
        cells.push(cell);
      }
      newRows.push(import_prosemirror_model3.Fragment.from(cells));
    }
    rows = newRows;
    height = newHeight;
  }
  return { width, height, rows };
}
function growTable(tr, map, table, start, width, height, mapFrom) {
  const schema = tr.doc.type.schema;
  const types = tableNodeTypes(schema);
  let empty;
  let emptyHead;
  if (width > map.width) {
    for (let row = 0, rowEnd = 0; row < map.height; row++) {
      const rowNode = table.child(row);
      rowEnd += rowNode.nodeSize;
      const cells = [];
      let add;
      if (rowNode.lastChild == null || rowNode.lastChild.type == types.cell)
        add = empty || (empty = types.cell.createAndFill());
      else add = emptyHead || (emptyHead = types.header_cell.createAndFill());
      for (let i = map.width; i < width; i++) cells.push(add);
      tr.insert(tr.mapping.slice(mapFrom).map(rowEnd - 1 + start), cells);
    }
  }
  if (height > map.height) {
    const cells = [];
    for (let i = 0, start2 = (map.height - 1) * map.width; i < Math.max(map.width, width); i++) {
      const header = i >= map.width ? false : table.nodeAt(map.map[start2 + i]).type == types.header_cell;
      cells.push(
        header ? emptyHead || (emptyHead = types.header_cell.createAndFill()) : empty || (empty = types.cell.createAndFill())
      );
    }
    const emptyRow = types.row.create(null, import_prosemirror_model3.Fragment.from(cells)), rows = [];
    for (let i = map.height; i < height; i++) rows.push(emptyRow);
    tr.insert(tr.mapping.slice(mapFrom).map(start + table.nodeSize - 2), rows);
  }
  return !!(empty || emptyHead);
}
function isolateHorizontal(tr, map, table, start, left, right, top, mapFrom) {
  if (top == 0 || top == map.height) return false;
  let found = false;
  for (let col = left; col < right; col++) {
    const index = top * map.width + col, pos = map.map[index];
    if (map.map[index - map.width] == pos) {
      found = true;
      const cell = table.nodeAt(pos);
      const { top: cellTop, left: cellLeft } = map.findCell(pos);
      tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + start), null, {
        ...cell.attrs,
        rowspan: top - cellTop
      });
      tr.insert(
        tr.mapping.slice(mapFrom).map(map.positionAt(top, cellLeft, table)),
        cell.type.createAndFill({
          ...cell.attrs,
          rowspan: cellTop + cell.attrs.rowspan - top
        })
      );
      col += cell.attrs.colspan - 1;
    }
  }
  return found;
}
function isolateVertical(tr, map, table, start, top, bottom, left, mapFrom) {
  if (left == 0 || left == map.width) return false;
  let found = false;
  for (let row = top; row < bottom; row++) {
    const index = row * map.width + left, pos = map.map[index];
    if (map.map[index - 1] == pos) {
      found = true;
      const cell = table.nodeAt(pos);
      const cellLeft = map.colCount(pos);
      const updatePos = tr.mapping.slice(mapFrom).map(pos + start);
      tr.setNodeMarkup(
        updatePos,
        null,
        removeColSpan(
          cell.attrs,
          left - cellLeft,
          cell.attrs.colspan - (left - cellLeft)
        )
      );
      tr.insert(
        updatePos + cell.nodeSize,
        cell.type.createAndFill(
          removeColSpan(cell.attrs, 0, left - cellLeft)
        )
      );
      row += cell.attrs.rowspan - 1;
    }
  }
  return found;
}
function insertCells(state, dispatch, tableStart, rect, cells) {
  let table = tableStart ? state.doc.nodeAt(tableStart - 1) : state.doc;
  if (!table) {
    throw new Error("No table found");
  }
  let map = TableMap.get(table);
  const { top, left } = rect;
  const right = left + cells.width, bottom = top + cells.height;
  const tr = state.tr;
  let mapFrom = 0;
  function recomp() {
    table = tableStart ? tr.doc.nodeAt(tableStart - 1) : tr.doc;
    if (!table) {
      throw new Error("No table found");
    }
    map = TableMap.get(table);
    mapFrom = tr.mapping.maps.length;
  }
  if (growTable(tr, map, table, tableStart, right, bottom, mapFrom)) recomp();
  if (isolateHorizontal(tr, map, table, tableStart, left, right, top, mapFrom))
    recomp();
  if (isolateHorizontal(tr, map, table, tableStart, left, right, bottom, mapFrom))
    recomp();
  if (isolateVertical(tr, map, table, tableStart, top, bottom, left, mapFrom))
    recomp();
  if (isolateVertical(tr, map, table, tableStart, top, bottom, right, mapFrom))
    recomp();
  for (let row = top; row < bottom; row++) {
    const from = map.positionAt(row, left, table), to = map.positionAt(row, right, table);
    tr.replace(
      tr.mapping.slice(mapFrom).map(from + tableStart),
      tr.mapping.slice(mapFrom).map(to + tableStart),
      new import_prosemirror_model3.Slice(cells.rows[row - top], 0, 0)
    );
  }
  recomp();
  tr.setSelection(
    new CellSelection(
      tr.doc.resolve(tableStart + map.positionAt(top, left, table)),
      tr.doc.resolve(tableStart + map.positionAt(bottom - 1, right - 1, table))
    )
  );
  dispatch(tr);
}

// src/input.ts
var handleKeyDown = (0, import_prosemirror_keymap.keydownHandler)({
  ArrowLeft: arrow("horiz", -1),
  ArrowRight: arrow("horiz", 1),
  ArrowUp: arrow("vert", -1),
  ArrowDown: arrow("vert", 1),
  "Shift-ArrowLeft": shiftArrow("horiz", -1),
  "Shift-ArrowRight": shiftArrow("horiz", 1),
  "Shift-ArrowUp": shiftArrow("vert", -1),
  "Shift-ArrowDown": shiftArrow("vert", 1),
  Backspace: deleteCellSelection,
  "Mod-Backspace": deleteCellSelection,
  Delete: deleteCellSelection,
  "Mod-Delete": deleteCellSelection
});
function maybeSetSelection(state, dispatch, selection) {
  if (selection.eq(state.selection)) return false;
  if (dispatch) dispatch(state.tr.setSelection(selection).scrollIntoView());
  return true;
}
function arrow(axis, dir) {
  return (state, dispatch, view) => {
    if (!view) return false;
    const sel = state.selection;
    if (sel instanceof CellSelection) {
      return maybeSetSelection(
        state,
        dispatch,
        import_prosemirror_state5.Selection.near(sel.$headCell, dir)
      );
    }
    if (axis != "horiz" && !sel.empty) return false;
    const end = atEndOfCell(view, axis, dir);
    if (end == null) return false;
    if (axis == "horiz") {
      return maybeSetSelection(
        state,
        dispatch,
        import_prosemirror_state5.Selection.near(state.doc.resolve(sel.head + dir), dir)
      );
    } else {
      const $cell = state.doc.resolve(end);
      const $next = nextCell($cell, axis, dir);
      let newSel;
      if ($next) newSel = import_prosemirror_state5.Selection.near($next, 1);
      else if (dir < 0)
        newSel = import_prosemirror_state5.Selection.near(state.doc.resolve($cell.before(-1)), -1);
      else newSel = import_prosemirror_state5.Selection.near(state.doc.resolve($cell.after(-1)), 1);
      return maybeSetSelection(state, dispatch, newSel);
    }
  };
}
function shiftArrow(axis, dir) {
  return (state, dispatch, view) => {
    if (!view) return false;
    const sel = state.selection;
    let cellSel;
    if (sel instanceof CellSelection) {
      cellSel = sel;
    } else {
      const end = atEndOfCell(view, axis, dir);
      if (end == null) return false;
      cellSel = new CellSelection(state.doc.resolve(end));
    }
    const $head = nextCell(cellSel.$headCell, axis, dir);
    if (!$head) return false;
    return maybeSetSelection(
      state,
      dispatch,
      new CellSelection(cellSel.$anchorCell, $head)
    );
  };
}
function handleTripleClick(view, pos) {
  const doc = view.state.doc, $cell = cellAround(doc.resolve(pos));
  if (!$cell) return false;
  view.dispatch(view.state.tr.setSelection(new CellSelection($cell)));
  return true;
}
function handlePaste(view, _, slice) {
  if (!isInTable(view.state)) return false;
  let cells = pastedCells(slice);
  const sel = view.state.selection;
  if (sel instanceof CellSelection) {
    if (!cells)
      cells = {
        width: 1,
        height: 1,
        rows: [
          import_prosemirror_model4.Fragment.from(
            fitSlice(tableNodeTypes(view.state.schema).cell, slice)
          )
        ]
      };
    const table = sel.$anchorCell.node(-1);
    const start = sel.$anchorCell.start(-1);
    const rect = TableMap.get(table).rectBetween(
      sel.$anchorCell.pos - start,
      sel.$headCell.pos - start
    );
    cells = clipCells(cells, rect.right - rect.left, rect.bottom - rect.top);
    insertCells(view.state, view.dispatch, start, rect, cells);
    return true;
  } else if (cells) {
    const $cell = selectionCell(view.state);
    const start = $cell.start(-1);
    insertCells(
      view.state,
      view.dispatch,
      start,
      TableMap.get($cell.node(-1)).findCell($cell.pos - start),
      cells
    );
    return true;
  } else {
    return false;
  }
}
function handleMouseDown(view, startEvent) {
  var _a;
  if (startEvent.ctrlKey || startEvent.metaKey) return;
  const startDOMCell = domInCell(view, startEvent.target);
  let $anchor;
  if (startEvent.shiftKey && view.state.selection instanceof CellSelection) {
    setCellSelection(view.state.selection.$anchorCell, startEvent);
    startEvent.preventDefault();
  } else if (startEvent.shiftKey && startDOMCell && ($anchor = cellAround(view.state.selection.$anchor)) != null && ((_a = cellUnderMouse(view, startEvent)) == null ? void 0 : _a.pos) != $anchor.pos) {
    setCellSelection($anchor, startEvent);
    startEvent.preventDefault();
  } else if (!startDOMCell) {
    return;
  }
  function setCellSelection($anchor2, event) {
    let $head = cellUnderMouse(view, event);
    const starting = tableEditingKey.getState(view.state) == null;
    if (!$head || !inSameTable($anchor2, $head)) {
      if (starting) $head = $anchor2;
      else return;
    }
    const selection = new CellSelection($anchor2, $head);
    if (starting || !view.state.selection.eq(selection)) {
      const tr = view.state.tr.setSelection(selection);
      if (starting) tr.setMeta(tableEditingKey, $anchor2.pos);
      view.dispatch(tr);
    }
  }
  function stop() {
    view.root.removeEventListener("mouseup", stop);
    view.root.removeEventListener("dragstart", stop);
    view.root.removeEventListener("mousemove", move);
    if (tableEditingKey.getState(view.state) != null)
      view.dispatch(view.state.tr.setMeta(tableEditingKey, -1));
  }
  function move(_event) {
    const event = _event;
    const anchor = tableEditingKey.getState(view.state);
    let $anchor2;
    if (anchor != null) {
      $anchor2 = view.state.doc.resolve(anchor);
    } else if (domInCell(view, event.target) != startDOMCell) {
      $anchor2 = cellUnderMouse(view, startEvent);
      if (!$anchor2) return stop();
    }
    if ($anchor2) setCellSelection($anchor2, event);
  }
  view.root.addEventListener("mouseup", stop);
  view.root.addEventListener("dragstart", stop);
  view.root.addEventListener("mousemove", move);
}
function atEndOfCell(view, axis, dir) {
  if (!(view.state.selection instanceof import_prosemirror_state5.TextSelection)) return null;
  const { $head } = view.state.selection;
  for (let d = $head.depth - 1; d >= 0; d--) {
    const parent = $head.node(d), index = dir < 0 ? $head.index(d) : $head.indexAfter(d);
    if (index != (dir < 0 ? 0 : parent.childCount)) return null;
    if (parent.type.spec.tableRole == "cell" || parent.type.spec.tableRole == "header_cell") {
      const cellPos = $head.before(d);
      const dirStr = axis == "vert" ? dir > 0 ? "down" : "up" : dir > 0 ? "right" : "left";
      return view.endOfTextblock(dirStr) ? cellPos : null;
    }
  }
  return null;
}
function domInCell(view, dom) {
  for (; dom && dom != view.dom; dom = dom.parentNode) {
    if (dom.nodeName == "TD" || dom.nodeName == "TH") {
      return dom;
    }
  }
  return null;
}
function cellUnderMouse(view, event) {
  const mousePos = view.posAtCoords({
    left: event.clientX,
    top: event.clientY
  });
  if (!mousePos) return null;
  return mousePos ? cellAround(view.state.doc.resolve(mousePos.pos)) : null;
}

// src/columnresizing.ts
var import_prosemirror_state6 = __webpack_require__(42391);
var import_prosemirror_view2 = __webpack_require__(9222);

// src/tableview.ts
var TableView = class {
  constructor(node, defaultCellMinWidth) {
    this.node = node;
    this.defaultCellMinWidth = defaultCellMinWidth;
    this.dom = document.createElement("div");
    this.dom.className = "tableWrapper";
    this.table = this.dom.appendChild(document.createElement("table"));
    this.table.style.setProperty(
      "--default-cell-min-width",
      `${defaultCellMinWidth}px`
    );
    this.colgroup = this.table.appendChild(document.createElement("colgroup"));
    updateColumnsOnResize(node, this.colgroup, this.table, defaultCellMinWidth);
    this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(node) {
    if (node.type != this.node.type) return false;
    this.node = node;
    updateColumnsOnResize(
      node,
      this.colgroup,
      this.table,
      this.defaultCellMinWidth
    );
    return true;
  }
  ignoreMutation(record) {
    return record.type == "attributes" && (record.target == this.table || this.colgroup.contains(record.target));
  }
};
function updateColumnsOnResize(node, colgroup, table, defaultCellMinWidth, overrideCol, overrideValue) {
  var _a;
  let totalWidth = 0;
  let fixedWidth = true;
  let nextDOM = colgroup.firstChild;
  const row = node.firstChild;
  if (!row) return;
  for (let i = 0, col = 0; i < row.childCount; i++) {
    const { colspan, colwidth } = row.child(i).attrs;
    for (let j = 0; j < colspan; j++, col++) {
      const hasWidth = overrideCol == col ? overrideValue : colwidth && colwidth[j];
      const cssWidth = hasWidth ? hasWidth + "px" : "";
      totalWidth += hasWidth || defaultCellMinWidth;
      if (!hasWidth) fixedWidth = false;
      if (!nextDOM) {
        const col2 = document.createElement("col");
        col2.style.width = cssWidth;
        colgroup.appendChild(col2);
      } else {
        if (nextDOM.style.width != cssWidth) {
          nextDOM.style.width = cssWidth;
        }
        nextDOM = nextDOM.nextSibling;
      }
    }
  }
  while (nextDOM) {
    const after = nextDOM.nextSibling;
    (_a = nextDOM.parentNode) == null ? void 0 : _a.removeChild(nextDOM);
    nextDOM = after;
  }
  if (fixedWidth) {
    table.style.width = totalWidth + "px";
    table.style.minWidth = "";
  } else {
    table.style.width = "";
    table.style.minWidth = totalWidth + "px";
  }
}

// src/columnresizing.ts
var columnResizingPluginKey = new import_prosemirror_state6.PluginKey(
  "tableColumnResizing"
);
function columnResizing({
  handleWidth = 5,
  cellMinWidth = 25,
  defaultCellMinWidth = 100,
  View = TableView,
  lastColumnResizable = true
} = {}) {
  const plugin = new import_prosemirror_state6.Plugin({
    key: columnResizingPluginKey,
    state: {
      init(_, state) {
        var _a, _b;
        const nodeViews = (_b = (_a = plugin.spec) == null ? void 0 : _a.props) == null ? void 0 : _b.nodeViews;
        const tableName = tableNodeTypes(state.schema).table.name;
        if (View && nodeViews) {
          nodeViews[tableName] = (node, view) => {
            return new View(node, defaultCellMinWidth, view);
          };
        }
        return new ResizeState(-1, false);
      },
      apply(tr, prev) {
        return prev.apply(tr);
      }
    },
    props: {
      attributes: (state) => {
        const pluginState = columnResizingPluginKey.getState(state);
        return pluginState && pluginState.activeHandle > -1 ? { class: "resize-cursor" } : {};
      },
      handleDOMEvents: {
        mousemove: (view, event) => {
          handleMouseMove(view, event, handleWidth, lastColumnResizable);
        },
        mouseleave: (view) => {
          handleMouseLeave(view);
        },
        mousedown: (view, event) => {
          handleMouseDown2(view, event, cellMinWidth, defaultCellMinWidth);
        }
      },
      decorations: (state) => {
        const pluginState = columnResizingPluginKey.getState(state);
        if (pluginState && pluginState.activeHandle > -1) {
          return handleDecorations(state, pluginState.activeHandle);
        }
      },
      nodeViews: {}
    }
  });
  return plugin;
}
var ResizeState = class _ResizeState {
  constructor(activeHandle, dragging) {
    this.activeHandle = activeHandle;
    this.dragging = dragging;
  }
  apply(tr) {
    const state = this;
    const action = tr.getMeta(columnResizingPluginKey);
    if (action && action.setHandle != null)
      return new _ResizeState(action.setHandle, false);
    if (action && action.setDragging !== void 0)
      return new _ResizeState(state.activeHandle, action.setDragging);
    if (state.activeHandle > -1 && tr.docChanged) {
      let handle = tr.mapping.map(state.activeHandle, -1);
      if (!pointsAtCell(tr.doc.resolve(handle))) {
        handle = -1;
      }
      return new _ResizeState(handle, state.dragging);
    }
    return state;
  }
};
function handleMouseMove(view, event, handleWidth, lastColumnResizable) {
  if (!view.editable) return;
  const pluginState = columnResizingPluginKey.getState(view.state);
  if (!pluginState) return;
  if (!pluginState.dragging) {
    const target = domCellAround(event.target);
    let cell = -1;
    if (target) {
      const { left, right } = target.getBoundingClientRect();
      if (event.clientX - left <= handleWidth)
        cell = edgeCell(view, event, "left", handleWidth);
      else if (right - event.clientX <= handleWidth)
        cell = edgeCell(view, event, "right", handleWidth);
    }
    if (cell != pluginState.activeHandle) {
      if (!lastColumnResizable && cell !== -1) {
        const $cell = view.state.doc.resolve(cell);
        const table = $cell.node(-1);
        const map = TableMap.get(table);
        const tableStart = $cell.start(-1);
        const col = map.colCount($cell.pos - tableStart) + $cell.nodeAfter.attrs.colspan - 1;
        if (col == map.width - 1) {
          return;
        }
      }
      updateHandle(view, cell);
    }
  }
}
function handleMouseLeave(view) {
  if (!view.editable) return;
  const pluginState = columnResizingPluginKey.getState(view.state);
  if (pluginState && pluginState.activeHandle > -1 && !pluginState.dragging)
    updateHandle(view, -1);
}
function handleMouseDown2(view, event, cellMinWidth, defaultCellMinWidth) {
  var _a;
  if (!view.editable) return false;
  const win = (_a = view.dom.ownerDocument.defaultView) != null ? _a : window;
  const pluginState = columnResizingPluginKey.getState(view.state);
  if (!pluginState || pluginState.activeHandle == -1 || pluginState.dragging)
    return false;
  const cell = view.state.doc.nodeAt(pluginState.activeHandle);
  const width = currentColWidth(view, pluginState.activeHandle, cell.attrs);
  view.dispatch(
    view.state.tr.setMeta(columnResizingPluginKey, {
      setDragging: { startX: event.clientX, startWidth: width }
    })
  );
  function finish(event2) {
    win.removeEventListener("mouseup", finish);
    win.removeEventListener("mousemove", move);
    const pluginState2 = columnResizingPluginKey.getState(view.state);
    if (pluginState2 == null ? void 0 : pluginState2.dragging) {
      updateColumnWidth(
        view,
        pluginState2.activeHandle,
        draggedWidth(pluginState2.dragging, event2, cellMinWidth)
      );
      view.dispatch(
        view.state.tr.setMeta(columnResizingPluginKey, { setDragging: null })
      );
    }
  }
  function move(event2) {
    if (!event2.which) return finish(event2);
    const pluginState2 = columnResizingPluginKey.getState(view.state);
    if (!pluginState2) return;
    if (pluginState2.dragging) {
      const dragged = draggedWidth(pluginState2.dragging, event2, cellMinWidth);
      displayColumnWidth(
        view,
        pluginState2.activeHandle,
        dragged,
        defaultCellMinWidth
      );
    }
  }
  displayColumnWidth(
    view,
    pluginState.activeHandle,
    width,
    defaultCellMinWidth
  );
  win.addEventListener("mouseup", finish);
  win.addEventListener("mousemove", move);
  event.preventDefault();
  return true;
}
function currentColWidth(view, cellPos, { colspan, colwidth }) {
  const width = colwidth && colwidth[colwidth.length - 1];
  if (width) return width;
  const dom = view.domAtPos(cellPos);
  const node = dom.node.childNodes[dom.offset];
  let domWidth = node.offsetWidth, parts = colspan;
  if (colwidth) {
    for (let i = 0; i < colspan; i++)
      if (colwidth[i]) {
        domWidth -= colwidth[i];
        parts--;
      }
  }
  return domWidth / parts;
}
function domCellAround(target) {
  while (target && target.nodeName != "TD" && target.nodeName != "TH")
    target = target.classList && target.classList.contains("ProseMirror") ? null : target.parentNode;
  return target;
}
function edgeCell(view, event, side, handleWidth) {
  const offset = side == "right" ? -handleWidth : handleWidth;
  const found = view.posAtCoords({
    left: event.clientX + offset,
    top: event.clientY
  });
  if (!found) return -1;
  const { pos } = found;
  const $cell = cellAround(view.state.doc.resolve(pos));
  if (!$cell) return -1;
  if (side == "right") return $cell.pos;
  const map = TableMap.get($cell.node(-1)), start = $cell.start(-1);
  const index = map.map.indexOf($cell.pos - start);
  return index % map.width == 0 ? -1 : start + map.map[index - 1];
}
function draggedWidth(dragging, event, resizeMinWidth) {
  const offset = event.clientX - dragging.startX;
  return Math.max(resizeMinWidth, dragging.startWidth + offset);
}
function updateHandle(view, value) {
  view.dispatch(
    view.state.tr.setMeta(columnResizingPluginKey, { setHandle: value })
  );
}
function updateColumnWidth(view, cell, width) {
  const $cell = view.state.doc.resolve(cell);
  const table = $cell.node(-1), map = TableMap.get(table), start = $cell.start(-1);
  const col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
  const tr = view.state.tr;
  for (let row = 0; row < map.height; row++) {
    const mapIndex = row * map.width + col;
    if (row && map.map[mapIndex] == map.map[mapIndex - map.width]) continue;
    const pos = map.map[mapIndex];
    const attrs = table.nodeAt(pos).attrs;
    const index = attrs.colspan == 1 ? 0 : col - map.colCount(pos);
    if (attrs.colwidth && attrs.colwidth[index] == width) continue;
    const colwidth = attrs.colwidth ? attrs.colwidth.slice() : zeroes(attrs.colspan);
    colwidth[index] = width;
    tr.setNodeMarkup(start + pos, null, { ...attrs, colwidth });
  }
  if (tr.docChanged) view.dispatch(tr);
}
function displayColumnWidth(view, cell, width, defaultCellMinWidth) {
  const $cell = view.state.doc.resolve(cell);
  const table = $cell.node(-1), start = $cell.start(-1);
  const col = TableMap.get(table).colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
  let dom = view.domAtPos($cell.start(-1)).node;
  while (dom && dom.nodeName != "TABLE") {
    dom = dom.parentNode;
  }
  if (!dom) return;
  updateColumnsOnResize(
    table,
    dom.firstChild,
    dom,
    defaultCellMinWidth,
    col,
    width
  );
}
function zeroes(n) {
  return Array(n).fill(0);
}
function handleDecorations(state, cell) {
  var _a;
  const decorations = [];
  const $cell = state.doc.resolve(cell);
  const table = $cell.node(-1);
  if (!table) {
    return import_prosemirror_view2.DecorationSet.empty;
  }
  const map = TableMap.get(table);
  const start = $cell.start(-1);
  const col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
  for (let row = 0; row < map.height; row++) {
    const index = col + row * map.width;
    if ((col == map.width - 1 || map.map[index] != map.map[index + 1]) && (row == 0 || map.map[index] != map.map[index - map.width])) {
      const cellPos = map.map[index];
      const pos = start + cellPos + table.nodeAt(cellPos).nodeSize - 1;
      const dom = document.createElement("div");
      dom.className = "column-resize-handle";
      if ((_a = columnResizingPluginKey.getState(state)) == null ? void 0 : _a.dragging) {
        decorations.push(
          import_prosemirror_view2.Decoration.node(
            start + cellPos,
            start + cellPos + table.nodeAt(cellPos).nodeSize,
            {
              class: "column-resize-dragging"
            }
          )
        );
      }
      decorations.push(import_prosemirror_view2.Decoration.widget(pos, dom));
    }
  }
  return import_prosemirror_view2.DecorationSet.create(state.doc, decorations);
}

// src/index.ts
function tableEditing({
  allowTableNodeSelection = false
} = {}) {
  return new import_prosemirror_state7.Plugin({
    key: tableEditingKey,
    // This piece of state is used to remember when a mouse-drag
    // cell-selection is happening, so that it can continue even as
    // transactions (which might move its anchor cell) come in.
    state: {
      init() {
        return null;
      },
      apply(tr, cur) {
        const set = tr.getMeta(tableEditingKey);
        if (set != null) return set == -1 ? null : set;
        if (cur == null || !tr.docChanged) return cur;
        const { deleted, pos } = tr.mapping.mapResult(cur);
        return deleted ? null : pos;
      }
    },
    props: {
      decorations: drawCellSelection,
      handleDOMEvents: {
        mousedown: handleMouseDown
      },
      createSelectionBetween(view) {
        return tableEditingKey.getState(view.state) != null ? view.state.selection : null;
      },
      handleTripleClick,
      handleKeyDown,
      handlePaste
    },
    appendTransaction(_, oldState, state) {
      return normalizeSelection(
        state,
        fixTables(state, oldState),
        allowTableNodeSelection
      );
    }
  });
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 92843:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var prosemirrorModel = __webpack_require__(19443);
var lower16 = 0xffff;
var factor16 = Math.pow(2, 16);
function makeRecover(index, offset) {
  return index + offset * factor16;
}
function recoverIndex(value) {
  return value & lower16;
}
function recoverOffset(value) {
  return (value - (value & lower16)) / factor16;
}
var DEL_BEFORE = 1,
  DEL_AFTER = 2,
  DEL_ACROSS = 4,
  DEL_SIDE = 8;
var MapResult = function () {
  function MapResult(pos, delInfo, recover) {
    _classCallCheck(this, MapResult);
    this.pos = pos;
    this.delInfo = delInfo;
    this.recover = recover;
  }
  _createClass(MapResult, [{
    key: "deleted",
    get: function get() {
      return (this.delInfo & DEL_SIDE) > 0;
    }
  }, {
    key: "deletedBefore",
    get: function get() {
      return (this.delInfo & (DEL_BEFORE | DEL_ACROSS)) > 0;
    }
  }, {
    key: "deletedAfter",
    get: function get() {
      return (this.delInfo & (DEL_AFTER | DEL_ACROSS)) > 0;
    }
  }, {
    key: "deletedAcross",
    get: function get() {
      return (this.delInfo & DEL_ACROSS) > 0;
    }
  }]);
  return MapResult;
}();
var StepMap = function () {
  function StepMap(ranges) {
    var inverted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    _classCallCheck(this, StepMap);
    this.ranges = ranges;
    this.inverted = inverted;
    if (!ranges.length && StepMap.empty) return StepMap.empty;
  }
  _createClass(StepMap, [{
    key: "recover",
    value: function recover(value) {
      var diff = 0,
        index = recoverIndex(value);
      if (!this.inverted) for (var i = 0; i < index; i++) diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
      return this.ranges[index * 3] + diff + recoverOffset(value);
    }
  }, {
    key: "mapResult",
    value: function mapResult(pos) {
      var assoc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return this._map(pos, assoc, false);
    }
  }, {
    key: "map",
    value: function map(pos) {
      var assoc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return this._map(pos, assoc, true);
    }
  }, {
    key: "_map",
    value: function _map(pos, assoc, simple) {
      var diff = 0,
        oldIndex = this.inverted ? 2 : 1,
        newIndex = this.inverted ? 1 : 2;
      for (var i = 0; i < this.ranges.length; i += 3) {
        var start = this.ranges[i] - (this.inverted ? diff : 0);
        if (start > pos) break;
        var oldSize = this.ranges[i + oldIndex],
          newSize = this.ranges[i + newIndex],
          end = start + oldSize;
        if (pos <= end) {
          var side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
          var result = start + diff + (side < 0 ? 0 : newSize);
          if (simple) return result;
          var recover = pos == (assoc < 0 ? start : end) ? null : makeRecover(i / 3, pos - start);
          var del = pos == start ? DEL_AFTER : pos == end ? DEL_BEFORE : DEL_ACROSS;
          if (assoc < 0 ? pos != start : pos != end) del |= DEL_SIDE;
          return new MapResult(result, del, recover);
        }
        diff += newSize - oldSize;
      }
      return simple ? pos + diff : new MapResult(pos + diff, 0, null);
    }
  }, {
    key: "touches",
    value: function touches(pos, recover) {
      var diff = 0,
        index = recoverIndex(recover);
      var oldIndex = this.inverted ? 2 : 1,
        newIndex = this.inverted ? 1 : 2;
      for (var i = 0; i < this.ranges.length; i += 3) {
        var start = this.ranges[i] - (this.inverted ? diff : 0);
        if (start > pos) break;
        var oldSize = this.ranges[i + oldIndex],
          end = start + oldSize;
        if (pos <= end && i == index * 3) return true;
        diff += this.ranges[i + newIndex] - oldSize;
      }
      return false;
    }
  }, {
    key: "forEach",
    value: function forEach(f) {
      var oldIndex = this.inverted ? 2 : 1,
        newIndex = this.inverted ? 1 : 2;
      for (var i = 0, diff = 0; i < this.ranges.length; i += 3) {
        var start = this.ranges[i],
          oldStart = start - (this.inverted ? diff : 0),
          newStart = start + (this.inverted ? 0 : diff);
        var oldSize = this.ranges[i + oldIndex],
          newSize = this.ranges[i + newIndex];
        f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
        diff += newSize - oldSize;
      }
    }
  }, {
    key: "invert",
    value: function invert() {
      return new StepMap(this.ranges, !this.inverted);
    }
  }, {
    key: "toString",
    value: function toString() {
      return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
  }], [{
    key: "offset",
    value: function offset(n) {
      return n == 0 ? StepMap.empty : new StepMap(n < 0 ? [0, -n, 0] : [0, 0, n]);
    }
  }]);
  return StepMap;
}();
StepMap.empty = new StepMap([]);
var Mapping = function () {
  function Mapping(maps, mirror) {
    var from = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var to = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : maps ? maps.length : 0;
    _classCallCheck(this, Mapping);
    this.mirror = mirror;
    this.from = from;
    this.to = to;
    this._maps = maps || [];
    this.ownData = !(maps || mirror);
  }
  _createClass(Mapping, [{
    key: "maps",
    get: function get() {
      return this._maps;
    }
  }, {
    key: "slice",
    value: function slice() {
      var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.maps.length;
      return new Mapping(this._maps, this.mirror, from, to);
    }
  }, {
    key: "appendMap",
    value: function appendMap(map, mirrors) {
      if (!this.ownData) {
        this._maps = this._maps.slice();
        this.mirror = this.mirror && this.mirror.slice();
        this.ownData = true;
      }
      this.to = this._maps.push(map);
      if (mirrors != null) this.setMirror(this._maps.length - 1, mirrors);
    }
  }, {
    key: "appendMapping",
    value: function appendMapping(mapping) {
      for (var i = 0, startSize = this._maps.length; i < mapping._maps.length; i++) {
        var mirr = mapping.getMirror(i);
        this.appendMap(mapping._maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
      }
    }
  }, {
    key: "getMirror",
    value: function getMirror(n) {
      if (this.mirror) for (var i = 0; i < this.mirror.length; i++) if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
    }
  }, {
    key: "setMirror",
    value: function setMirror(n, m) {
      if (!this.mirror) this.mirror = [];
      this.mirror.push(n, m);
    }
  }, {
    key: "appendMappingInverted",
    value: function appendMappingInverted(mapping) {
      for (var i = mapping.maps.length - 1, totalSize = this._maps.length + mapping._maps.length; i >= 0; i--) {
        var mirr = mapping.getMirror(i);
        this.appendMap(mapping._maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
      }
    }
  }, {
    key: "invert",
    value: function invert() {
      var inverse = new Mapping();
      inverse.appendMappingInverted(this);
      return inverse;
    }
  }, {
    key: "map",
    value: function map(pos) {
      var assoc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      if (this.mirror) return this._map(pos, assoc, true);
      for (var i = this.from; i < this.to; i++) pos = this._maps[i].map(pos, assoc);
      return pos;
    }
  }, {
    key: "mapResult",
    value: function mapResult(pos) {
      var assoc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return this._map(pos, assoc, false);
    }
  }, {
    key: "_map",
    value: function _map(pos, assoc, simple) {
      var delInfo = 0;
      for (var i = this.from; i < this.to; i++) {
        var map = this._maps[i],
          result = map.mapResult(pos, assoc);
        if (result.recover != null) {
          var corr = this.getMirror(i);
          if (corr != null && corr > i && corr < this.to) {
            i = corr;
            pos = this._maps[corr].recover(result.recover);
            continue;
          }
        }
        delInfo |= result.delInfo;
        pos = result.pos;
      }
      return simple ? pos : new MapResult(pos, delInfo, null);
    }
  }]);
  return Mapping;
}();
var stepsByID = Object.create(null);
var Step = function () {
  function Step() {
    _classCallCheck(this, Step);
  }
  _createClass(Step, [{
    key: "getMap",
    value: function getMap() {
      return StepMap.empty;
    }
  }, {
    key: "merge",
    value: function merge(other) {
      return null;
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(schema, json) {
      if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
      var type = stepsByID[json.stepType];
      if (!type) throw new RangeError("No step type ".concat(json.stepType, " defined"));
      return type.fromJSON(schema, json);
    }
  }, {
    key: "jsonID",
    value: function jsonID(id, stepClass) {
      if (id in stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
      stepsByID[id] = stepClass;
      stepClass.prototype.jsonID = id;
      return stepClass;
    }
  }]);
  return Step;
}();
var StepResult = function () {
  function StepResult(doc, failed) {
    _classCallCheck(this, StepResult);
    this.doc = doc;
    this.failed = failed;
  }
  _createClass(StepResult, null, [{
    key: "ok",
    value: function ok(doc) {
      return new StepResult(doc, null);
    }
  }, {
    key: "fail",
    value: function fail(message) {
      return new StepResult(null, message);
    }
  }, {
    key: "fromReplace",
    value: function fromReplace(doc, from, to, slice) {
      try {
        return StepResult.ok(doc.replace(from, to, slice));
      } catch (e) {
        if (e instanceof prosemirrorModel.ReplaceError) return StepResult.fail(e.message);
        throw e;
      }
    }
  }]);
  return StepResult;
}();
function mapFragment(fragment, f, parent) {
  var mapped = [];
  for (var i = 0; i < fragment.childCount; i++) {
    var child = fragment.child(i);
    if (child.content.size) child = child.copy(mapFragment(child.content, f, child));
    if (child.isInline) child = f(child, parent, i);
    mapped.push(child);
  }
  return prosemirrorModel.Fragment.fromArray(mapped);
}
var AddMarkStep = function (_Step) {
  _inherits(AddMarkStep, _Step);
  var _super = _createSuper(AddMarkStep);
  function AddMarkStep(from, to, mark) {
    var _this;
    _classCallCheck(this, AddMarkStep);
    _this = _super.call(this);
    _this.from = from;
    _this.to = to;
    _this.mark = mark;
    return _this;
  }
  _createClass(AddMarkStep, [{
    key: "apply",
    value: function apply(doc) {
      var _this2 = this;
      var oldSlice = doc.slice(this.from, this.to),
        $from = doc.resolve(this.from);
      var parent = $from.node($from.sharedDepth(this.to));
      var slice = new prosemirrorModel.Slice(mapFragment(oldSlice.content, function (node, parent) {
        if (!node.isAtom || !parent.type.allowsMarkType(_this2.mark.type)) return node;
        return node.mark(_this2.mark.addToSet(node.marks));
      }, parent), oldSlice.openStart, oldSlice.openEnd);
      return StepResult.fromReplace(doc, this.from, this.to, slice);
    }
  }, {
    key: "invert",
    value: function invert() {
      return new RemoveMarkStep(this.from, this.to, this.mark);
    }
  }, {
    key: "map",
    value: function map(mapping) {
      var from = mapping.mapResult(this.from, 1),
        to = mapping.mapResult(this.to, -1);
      if (from.deleted && to.deleted || from.pos >= to.pos) return null;
      return new AddMarkStep(from.pos, to.pos, this.mark);
    }
  }, {
    key: "merge",
    value: function merge(other) {
      if (other instanceof AddMarkStep && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new AddMarkStep(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
      return null;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        stepType: "addMark",
        mark: this.mark.toJSON(),
        from: this.from,
        to: this.to
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(schema, json) {
      if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
      return new AddMarkStep(json.from, json.to, schema.markFromJSON(json.mark));
    }
  }]);
  return AddMarkStep;
}(Step);
Step.jsonID("addMark", AddMarkStep);
var RemoveMarkStep = function (_Step2) {
  _inherits(RemoveMarkStep, _Step2);
  var _super2 = _createSuper(RemoveMarkStep);
  function RemoveMarkStep(from, to, mark) {
    var _this3;
    _classCallCheck(this, RemoveMarkStep);
    _this3 = _super2.call(this);
    _this3.from = from;
    _this3.to = to;
    _this3.mark = mark;
    return _this3;
  }
  _createClass(RemoveMarkStep, [{
    key: "apply",
    value: function apply(doc) {
      var _this4 = this;
      var oldSlice = doc.slice(this.from, this.to);
      var slice = new prosemirrorModel.Slice(mapFragment(oldSlice.content, function (node) {
        return node.mark(_this4.mark.removeFromSet(node.marks));
      }, doc), oldSlice.openStart, oldSlice.openEnd);
      return StepResult.fromReplace(doc, this.from, this.to, slice);
    }
  }, {
    key: "invert",
    value: function invert() {
      return new AddMarkStep(this.from, this.to, this.mark);
    }
  }, {
    key: "map",
    value: function map(mapping) {
      var from = mapping.mapResult(this.from, 1),
        to = mapping.mapResult(this.to, -1);
      if (from.deleted && to.deleted || from.pos >= to.pos) return null;
      return new RemoveMarkStep(from.pos, to.pos, this.mark);
    }
  }, {
    key: "merge",
    value: function merge(other) {
      if (other instanceof RemoveMarkStep && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new RemoveMarkStep(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
      return null;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        stepType: "removeMark",
        mark: this.mark.toJSON(),
        from: this.from,
        to: this.to
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(schema, json) {
      if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
      return new RemoveMarkStep(json.from, json.to, schema.markFromJSON(json.mark));
    }
  }]);
  return RemoveMarkStep;
}(Step);
Step.jsonID("removeMark", RemoveMarkStep);
var AddNodeMarkStep = function (_Step3) {
  _inherits(AddNodeMarkStep, _Step3);
  var _super3 = _createSuper(AddNodeMarkStep);
  function AddNodeMarkStep(pos, mark) {
    var _this5;
    _classCallCheck(this, AddNodeMarkStep);
    _this5 = _super3.call(this);
    _this5.pos = pos;
    _this5.mark = mark;
    return _this5;
  }
  _createClass(AddNodeMarkStep, [{
    key: "apply",
    value: function apply(doc) {
      var node = doc.nodeAt(this.pos);
      if (!node) return StepResult.fail("No node at mark step's position");
      var updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
      return StepResult.fromReplace(doc, this.pos, this.pos + 1, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(updated), 0, node.isLeaf ? 0 : 1));
    }
  }, {
    key: "invert",
    value: function invert(doc) {
      var node = doc.nodeAt(this.pos);
      if (node) {
        var newSet = this.mark.addToSet(node.marks);
        if (newSet.length == node.marks.length) {
          for (var i = 0; i < node.marks.length; i++) if (!node.marks[i].isInSet(newSet)) return new AddNodeMarkStep(this.pos, node.marks[i]);
          return new AddNodeMarkStep(this.pos, this.mark);
        }
      }
      return new RemoveNodeMarkStep(this.pos, this.mark);
    }
  }, {
    key: "map",
    value: function map(mapping) {
      var pos = mapping.mapResult(this.pos, 1);
      return pos.deletedAfter ? null : new AddNodeMarkStep(pos.pos, this.mark);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        stepType: "addNodeMark",
        pos: this.pos,
        mark: this.mark.toJSON()
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(schema, json) {
      if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
      return new AddNodeMarkStep(json.pos, schema.markFromJSON(json.mark));
    }
  }]);
  return AddNodeMarkStep;
}(Step);
Step.jsonID("addNodeMark", AddNodeMarkStep);
var RemoveNodeMarkStep = function (_Step4) {
  _inherits(RemoveNodeMarkStep, _Step4);
  var _super4 = _createSuper(RemoveNodeMarkStep);
  function RemoveNodeMarkStep(pos, mark) {
    var _this6;
    _classCallCheck(this, RemoveNodeMarkStep);
    _this6 = _super4.call(this);
    _this6.pos = pos;
    _this6.mark = mark;
    return _this6;
  }
  _createClass(RemoveNodeMarkStep, [{
    key: "apply",
    value: function apply(doc) {
      var node = doc.nodeAt(this.pos);
      if (!node) return StepResult.fail("No node at mark step's position");
      var updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
      return StepResult.fromReplace(doc, this.pos, this.pos + 1, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(updated), 0, node.isLeaf ? 0 : 1));
    }
  }, {
    key: "invert",
    value: function invert(doc) {
      var node = doc.nodeAt(this.pos);
      if (!node || !this.mark.isInSet(node.marks)) return this;
      return new AddNodeMarkStep(this.pos, this.mark);
    }
  }, {
    key: "map",
    value: function map(mapping) {
      var pos = mapping.mapResult(this.pos, 1);
      return pos.deletedAfter ? null : new RemoveNodeMarkStep(pos.pos, this.mark);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        stepType: "removeNodeMark",
        pos: this.pos,
        mark: this.mark.toJSON()
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(schema, json) {
      if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
      return new RemoveNodeMarkStep(json.pos, schema.markFromJSON(json.mark));
    }
  }]);
  return RemoveNodeMarkStep;
}(Step);
Step.jsonID("removeNodeMark", RemoveNodeMarkStep);
var ReplaceStep = function (_Step5) {
  _inherits(ReplaceStep, _Step5);
  var _super5 = _createSuper(ReplaceStep);
  function ReplaceStep(from, to, slice) {
    var _this7;
    var structure = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    _classCallCheck(this, ReplaceStep);
    _this7 = _super5.call(this);
    _this7.from = from;
    _this7.to = to;
    _this7.slice = slice;
    _this7.structure = structure;
    return _this7;
  }
  _createClass(ReplaceStep, [{
    key: "apply",
    value: function apply(doc) {
      if (this.structure && contentBetween(doc, this.from, this.to)) return StepResult.fail("Structure replace would overwrite content");
      return StepResult.fromReplace(doc, this.from, this.to, this.slice);
    }
  }, {
    key: "getMap",
    value: function getMap() {
      return new StepMap([this.from, this.to - this.from, this.slice.size]);
    }
  }, {
    key: "invert",
    value: function invert(doc) {
      return new ReplaceStep(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
  }, {
    key: "map",
    value: function map(mapping) {
      var from = mapping.mapResult(this.from, 1),
        to = mapping.mapResult(this.to, -1);
      if (from.deletedAcross && to.deletedAcross) return null;
      return new ReplaceStep(from.pos, Math.max(from.pos, to.pos), this.slice, this.structure);
    }
  }, {
    key: "merge",
    value: function merge(other) {
      if (!(other instanceof ReplaceStep) || other.structure || this.structure) return null;
      if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
        var slice = this.slice.size + other.slice.size == 0 ? prosemirrorModel.Slice.empty : new prosemirrorModel.Slice(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
        return new ReplaceStep(this.from, this.to + (other.to - other.from), slice, this.structure);
      } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
        var _slice = this.slice.size + other.slice.size == 0 ? prosemirrorModel.Slice.empty : new prosemirrorModel.Slice(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
        return new ReplaceStep(other.from, this.to, _slice, this.structure);
      } else {
        return null;
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = {
        stepType: "replace",
        from: this.from,
        to: this.to
      };
      if (this.slice.size) json.slice = this.slice.toJSON();
      if (this.structure) json.structure = true;
      return json;
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(schema, json) {
      if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
      return new ReplaceStep(json.from, json.to, prosemirrorModel.Slice.fromJSON(schema, json.slice), !!json.structure);
    }
  }]);
  return ReplaceStep;
}(Step);
Step.jsonID("replace", ReplaceStep);
var ReplaceAroundStep = function (_Step6) {
  _inherits(ReplaceAroundStep, _Step6);
  var _super6 = _createSuper(ReplaceAroundStep);
  function ReplaceAroundStep(from, to, gapFrom, gapTo, slice, insert) {
    var _this8;
    var structure = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    _classCallCheck(this, ReplaceAroundStep);
    _this8 = _super6.call(this);
    _this8.from = from;
    _this8.to = to;
    _this8.gapFrom = gapFrom;
    _this8.gapTo = gapTo;
    _this8.slice = slice;
    _this8.insert = insert;
    _this8.structure = structure;
    return _this8;
  }
  _createClass(ReplaceAroundStep, [{
    key: "apply",
    value: function apply(doc) {
      if (this.structure && (contentBetween(doc, this.from, this.gapFrom) || contentBetween(doc, this.gapTo, this.to))) return StepResult.fail("Structure gap-replace would overwrite content");
      var gap = doc.slice(this.gapFrom, this.gapTo);
      if (gap.openStart || gap.openEnd) return StepResult.fail("Gap is not a flat range");
      var inserted = this.slice.insertAt(this.insert, gap.content);
      if (!inserted) return StepResult.fail("Content does not fit in gap");
      return StepResult.fromReplace(doc, this.from, this.to, inserted);
    }
  }, {
    key: "getMap",
    value: function getMap() {
      return new StepMap([this.from, this.gapFrom - this.from, this.insert, this.gapTo, this.to - this.gapTo, this.slice.size - this.insert]);
    }
  }, {
    key: "invert",
    value: function invert(doc) {
      var gap = this.gapTo - this.gapFrom;
      return new ReplaceAroundStep(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
  }, {
    key: "map",
    value: function map(mapping) {
      var from = mapping.mapResult(this.from, 1),
        to = mapping.mapResult(this.to, -1);
      var gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
      var gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
      if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
      return new ReplaceAroundStep(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = {
        stepType: "replaceAround",
        from: this.from,
        to: this.to,
        gapFrom: this.gapFrom,
        gapTo: this.gapTo,
        insert: this.insert
      };
      if (this.slice.size) json.slice = this.slice.toJSON();
      if (this.structure) json.structure = true;
      return json;
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(schema, json) {
      if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
      return new ReplaceAroundStep(json.from, json.to, json.gapFrom, json.gapTo, prosemirrorModel.Slice.fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
  }]);
  return ReplaceAroundStep;
}(Step);
Step.jsonID("replaceAround", ReplaceAroundStep);
function contentBetween(doc, from, to) {
  var $from = doc.resolve(from),
    dist = to - from,
    depth = $from.depth;
  while (dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount) {
    depth--;
    dist--;
  }
  if (dist > 0) {
    var next = $from.node(depth).maybeChild($from.indexAfter(depth));
    while (dist > 0) {
      if (!next || next.isLeaf) return true;
      next = next.firstChild;
      dist--;
    }
  }
  return false;
}
function _addMark(tr, from, to, mark) {
  var removed = [],
    added = [];
  var removing, adding;
  tr.doc.nodesBetween(from, to, function (node, pos, parent) {
    if (!node.isInline) return;
    var marks = node.marks;
    if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
      var start = Math.max(pos, from),
        end = Math.min(pos + node.nodeSize, to);
      var newSet = mark.addToSet(marks);
      for (var i = 0; i < marks.length; i++) {
        if (!marks[i].isInSet(newSet)) {
          if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;else removed.push(removing = new RemoveMarkStep(start, end, marks[i]));
        }
      }
      if (adding && adding.to == start) adding.to = end;else added.push(adding = new AddMarkStep(start, end, mark));
    }
  });
  removed.forEach(function (s) {
    return tr.step(s);
  });
  added.forEach(function (s) {
    return tr.step(s);
  });
}
function _removeMark(tr, from, to, mark) {
  var matched = [],
    step = 0;
  tr.doc.nodesBetween(from, to, function (node, pos) {
    if (!node.isInline) return;
    step++;
    var toRemove = null;
    if (mark instanceof prosemirrorModel.MarkType) {
      var set = node.marks,
        found;
      while (found = mark.isInSet(set)) {
        (toRemove || (toRemove = [])).push(found);
        set = found.removeFromSet(set);
      }
    } else if (mark) {
      if (mark.isInSet(node.marks)) toRemove = [mark];
    } else {
      toRemove = node.marks;
    }
    if (toRemove && toRemove.length) {
      var end = Math.min(pos + node.nodeSize, to);
      for (var i = 0; i < toRemove.length; i++) {
        var style = toRemove[i],
          _found = void 0;
        for (var j = 0; j < matched.length; j++) {
          var m = matched[j];
          if (m.step == step - 1 && style.eq(matched[j].style)) _found = m;
        }
        if (_found) {
          _found.to = end;
          _found.step = step;
        } else {
          matched.push({
            style: style,
            from: Math.max(pos, from),
            to: end,
            step: step
          });
        }
      }
    }
  });
  matched.forEach(function (m) {
    return tr.step(new RemoveMarkStep(m.from, m.to, m.style));
  });
}
function _clearIncompatible(tr, pos, parentType) {
  var match = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : parentType.contentMatch;
  var clearNewlines = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var node = tr.doc.nodeAt(pos);
  var replSteps = [],
    cur = pos + 1;
  for (var i = 0; i < node.childCount; i++) {
    var child = node.child(i),
      end = cur + child.nodeSize;
    var allowed = match.matchType(child.type);
    if (!allowed) {
      replSteps.push(new ReplaceStep(cur, end, prosemirrorModel.Slice.empty));
    } else {
      match = allowed;
      for (var j = 0; j < child.marks.length; j++) if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new RemoveMarkStep(cur, end, child.marks[j]));
      if (clearNewlines && child.isText && parentType.whitespace != "pre") {
        var m = void 0,
          newline = /\r?\n|\r/g,
          slice = void 0;
        while (m = newline.exec(child.text)) {
          if (!slice) slice = new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
          replSteps.push(new ReplaceStep(cur + m.index, cur + m.index + m[0].length, slice));
        }
      }
    }
    cur = end;
  }
  if (!match.validEnd) {
    var fill = match.fillBefore(prosemirrorModel.Fragment.empty, true);
    tr.replace(cur, cur, new prosemirrorModel.Slice(fill, 0, 0));
  }
  for (var _i = replSteps.length - 1; _i >= 0; _i--) tr.step(replSteps[_i]);
}
function canCut(node, start, end) {
  return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
function liftTarget(range) {
  var parent = range.parent;
  var content = parent.content.cutByIndex(range.startIndex, range.endIndex);
  for (var depth = range.depth;; --depth) {
    var node = range.$from.node(depth);
    var index = range.$from.index(depth),
      endIndex = range.$to.indexAfter(depth);
    if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
    if (depth == 0 || node.type.spec.isolating || !canCut(node, index, endIndex)) break;
  }
  return null;
}
function _lift(tr, range, target) {
  var $from = range.$from,
    $to = range.$to,
    depth = range.depth;
  var gapStart = $from.before(depth + 1),
    gapEnd = $to.after(depth + 1);
  var start = gapStart,
    end = gapEnd;
  var before = prosemirrorModel.Fragment.empty,
    openStart = 0;
  for (var d = depth, splitting = false; d > target; d--) if (splitting || $from.index(d) > 0) {
    splitting = true;
    before = prosemirrorModel.Fragment.from($from.node(d).copy(before));
    openStart++;
  } else {
    start--;
  }
  var after = prosemirrorModel.Fragment.empty,
    openEnd = 0;
  for (var _d = depth, _splitting = false; _d > target; _d--) if (_splitting || $to.after(_d + 1) < $to.end(_d)) {
    _splitting = true;
    after = prosemirrorModel.Fragment.from($to.node(_d).copy(after));
    openEnd++;
  } else {
    end++;
  }
  tr.step(new ReplaceAroundStep(start, end, gapStart, gapEnd, new prosemirrorModel.Slice(before.append(after), openStart, openEnd), before.size - openStart, true));
}
function findWrapping(range, nodeType) {
  var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var innerRange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : range;
  var around = findWrappingOutside(range, nodeType);
  var inner = around && findWrappingInside(innerRange, nodeType);
  if (!inner) return null;
  return around.map(withAttrs).concat({
    type: nodeType,
    attrs: attrs
  }).concat(inner.map(withAttrs));
}
function withAttrs(type) {
  return {
    type: type,
    attrs: null
  };
}
function findWrappingOutside(range, type) {
  var parent = range.parent,
    startIndex = range.startIndex,
    endIndex = range.endIndex;
  var around = parent.contentMatchAt(startIndex).findWrapping(type);
  if (!around) return null;
  var outer = around.length ? around[0] : type;
  return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function findWrappingInside(range, type) {
  var parent = range.parent,
    startIndex = range.startIndex,
    endIndex = range.endIndex;
  var inner = parent.child(startIndex);
  var inside = type.contentMatch.findWrapping(inner.type);
  if (!inside) return null;
  var lastType = inside.length ? inside[inside.length - 1] : type;
  var innerMatch = lastType.contentMatch;
  for (var i = startIndex; innerMatch && i < endIndex; i++) innerMatch = innerMatch.matchType(parent.child(i).type);
  if (!innerMatch || !innerMatch.validEnd) return null;
  return inside;
}
function _wrap2(tr, range, wrappers) {
  var content = prosemirrorModel.Fragment.empty;
  for (var i = wrappers.length - 1; i >= 0; i--) {
    if (content.size) {
      var match = wrappers[i].type.contentMatch.matchFragment(content);
      if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    content = prosemirrorModel.Fragment.from(wrappers[i].type.create(wrappers[i].attrs, content));
  }
  var start = range.start,
    end = range.end;
  tr.step(new ReplaceAroundStep(start, end, start, end, new prosemirrorModel.Slice(content, 0, 0), wrappers.length, true));
}
function _setBlockType(tr, from, to, type, attrs) {
  if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
  var mapFrom = tr.steps.length;
  tr.doc.nodesBetween(from, to, function (node, pos) {
    var attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
    if (node.isTextblock && !node.hasMarkup(type, attrsHere) && canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
      var convertNewlines = null;
      if (type.schema.linebreakReplacement) {
        var pre = type.whitespace == "pre",
          supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;else if (!pre && supportLinebreak) convertNewlines = true;
      }
      if (convertNewlines === false) replaceLinebreaks(tr, node, pos, mapFrom);
      _clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
      var mapping = tr.mapping.slice(mapFrom);
      var startM = mapping.map(pos, 1),
        endM = mapping.map(pos + node.nodeSize, 1);
      tr.step(new ReplaceAroundStep(startM, endM, startM + 1, endM - 1, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
      if (convertNewlines === true) replaceNewlines(tr, node, pos, mapFrom);
      return false;
    }
  });
}
function replaceNewlines(tr, node, pos, mapFrom) {
  node.forEach(function (child, offset) {
    if (child.isText) {
      var m,
        newline = /\r?\n|\r/g;
      while (m = newline.exec(child.text)) {
        var start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
        tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function replaceLinebreaks(tr, node, pos, mapFrom) {
  node.forEach(function (child, offset) {
    if (child.type == child.type.schema.linebreakReplacement) {
      var start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
      tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
    }
  });
}
function canChangeType(doc, pos, type) {
  var $pos = doc.resolve(pos),
    index = $pos.index();
  return $pos.parent.canReplaceWith(index, index + 1, type);
}
function _setNodeMarkup(tr, pos, type, attrs, marks) {
  var node = tr.doc.nodeAt(pos);
  if (!node) throw new RangeError("No node at given position");
  if (!type) type = node.type;
  var newNode = type.create(attrs, null, marks || node.marks);
  if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
  if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
  tr.step(new ReplaceAroundStep(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(newNode), 0, 0), 1, true));
}
function canSplit(doc, pos) {
  var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var typesAfter = arguments.length > 3 ? arguments[3] : undefined;
  var $pos = doc.resolve(pos),
    base = $pos.depth - depth;
  var innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
  if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
  for (var d = $pos.depth - 1, i = depth - 2; d > base; d--, i--) {
    var node = $pos.node(d),
      _index = $pos.index(d);
    if (node.type.spec.isolating) return false;
    var rest = node.content.cutByIndex(_index, node.childCount);
    var overrideChild = typesAfter && typesAfter[i + 1];
    if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
    var after = typesAfter && typesAfter[i] || node;
    if (!node.canReplace(_index + 1, node.childCount) || !after.type.validContent(rest)) return false;
  }
  var index = $pos.indexAfter(base);
  var baseType = typesAfter && typesAfter[0];
  return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function _split(tr, pos) {
  var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var typesAfter = arguments.length > 3 ? arguments[3] : undefined;
  var $pos = tr.doc.resolve(pos),
    before = prosemirrorModel.Fragment.empty,
    after = prosemirrorModel.Fragment.empty;
  for (var d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--) {
    before = prosemirrorModel.Fragment.from($pos.node(d).copy(before));
    var typeAfter = typesAfter && typesAfter[i];
    after = prosemirrorModel.Fragment.from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
  }
  tr.step(new ReplaceStep(pos, pos, new prosemirrorModel.Slice(before.append(after), depth, depth), true));
}
function canJoin(doc, pos) {
  var $pos = doc.resolve(pos),
    index = $pos.index();
  return joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function canAppendWithSubstitutedLinebreaks(a, b) {
  if (!b.content.size) a.type.compatibleContent(b.type);
  var match = a.contentMatchAt(a.childCount);
  var linebreakReplacement = a.type.schema.linebreakReplacement;
  for (var i = 0; i < b.childCount; i++) {
    var child = b.child(i);
    var type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
    match = match.matchType(type);
    if (!match) return false;
    if (!a.type.allowsMarks(child.marks)) return false;
  }
  return match.validEnd;
}
function joinable(a, b) {
  return !!(a && b && !a.isLeaf && canAppendWithSubstitutedLinebreaks(a, b));
}
function joinPoint(doc, pos) {
  var dir = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
  var $pos = doc.resolve(pos);
  for (var d = $pos.depth;; d--) {
    var before = void 0,
      after = void 0,
      index = $pos.index(d);
    if (d == $pos.depth) {
      before = $pos.nodeBefore;
      after = $pos.nodeAfter;
    } else if (dir > 0) {
      before = $pos.node(d + 1);
      index++;
      after = $pos.node(d).maybeChild(index);
    } else {
      before = $pos.node(d).maybeChild(index - 1);
      after = $pos.node(d + 1);
    }
    if (before && !before.isTextblock && joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
    if (d == 0) break;
    pos = dir < 0 ? $pos.before(d) : $pos.after(d);
  }
}
function _join(tr, pos, depth) {
  var convertNewlines = null;
  var linebreakReplacement = tr.doc.type.schema.linebreakReplacement;
  var $before = tr.doc.resolve(pos - depth),
    beforeType = $before.node().type;
  if (linebreakReplacement && beforeType.inlineContent) {
    var pre = beforeType.whitespace == "pre";
    var supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
    if (pre && !supportLinebreak) convertNewlines = false;else if (!pre && supportLinebreak) convertNewlines = true;
  }
  var mapFrom = tr.steps.length;
  if (convertNewlines === false) {
    var $after = tr.doc.resolve(pos + depth);
    replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
  }
  if (beforeType.inlineContent) _clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
  var mapping = tr.mapping.slice(mapFrom),
    start = mapping.map(pos - depth);
  tr.step(new ReplaceStep(start, mapping.map(pos + depth, -1), prosemirrorModel.Slice.empty, true));
  if (convertNewlines === true) {
    var $full = tr.doc.resolve(start);
    replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
  }
  return tr;
}
function insertPoint(doc, pos, nodeType) {
  var $pos = doc.resolve(pos);
  if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
  if ($pos.parentOffset == 0) for (var d = $pos.depth - 1; d >= 0; d--) {
    var index = $pos.index(d);
    if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
    if (index > 0) return null;
  }
  if ($pos.parentOffset == $pos.parent.content.size) for (var _d2 = $pos.depth - 1; _d2 >= 0; _d2--) {
    var _index2 = $pos.indexAfter(_d2);
    if ($pos.node(_d2).canReplaceWith(_index2, _index2, nodeType)) return $pos.after(_d2 + 1);
    if (_index2 < $pos.node(_d2).childCount) return null;
  }
  return null;
}
function dropPoint(doc, pos, slice) {
  var $pos = doc.resolve(pos);
  if (!slice.content.size) return pos;
  var content = slice.content;
  for (var i = 0; i < slice.openStart; i++) content = content.firstChild.content;
  for (var pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++) {
    for (var d = $pos.depth; d >= 0; d--) {
      var bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
      var insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
      var parent = $pos.node(d),
        fits = false;
      if (pass == 1) {
        fits = parent.canReplace(insertPos, insertPos, content);
      } else {
        var wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
        fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
      }
      if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
  }
  return null;
}
function replaceStep(doc, from) {
  var to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : from;
  var slice = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : prosemirrorModel.Slice.empty;
  if (from == to && !slice.size) return null;
  var $from = doc.resolve(from),
    $to = doc.resolve(to);
  if (fitsTrivially($from, $to, slice)) return new ReplaceStep(from, to, slice);
  return new Fitter($from, $to, slice).fit();
}
function fitsTrivially($from, $to, slice) {
  return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
var Fitter = function () {
  function Fitter($from, $to, unplaced) {
    _classCallCheck(this, Fitter);
    this.$from = $from;
    this.$to = $to;
    this.unplaced = unplaced;
    this.frontier = [];
    this.placed = prosemirrorModel.Fragment.empty;
    for (var i = 0; i <= $from.depth; i++) {
      var node = $from.node(i);
      this.frontier.push({
        type: node.type,
        match: node.contentMatchAt($from.indexAfter(i))
      });
    }
    for (var _i2 = $from.depth; _i2 > 0; _i2--) this.placed = prosemirrorModel.Fragment.from($from.node(_i2).copy(this.placed));
  }
  _createClass(Fitter, [{
    key: "depth",
    get: function get() {
      return this.frontier.length - 1;
    }
  }, {
    key: "fit",
    value: function fit() {
      while (this.unplaced.size) {
        var fit = this.findFittable();
        if (fit) this.placeNodes(fit);else this.openMore() || this.dropNode();
      }
      var moveInline = this.mustMoveInline(),
        placedSize = this.placed.size - this.depth - this.$from.depth;
      var $from = this.$from,
        $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
      if (!$to) return null;
      var content = this.placed,
        openStart = $from.depth,
        openEnd = $to.depth;
      while (openStart && openEnd && content.childCount == 1) {
        content = content.firstChild.content;
        openStart--;
        openEnd--;
      }
      var slice = new prosemirrorModel.Slice(content, openStart, openEnd);
      if (moveInline > -1) return new ReplaceAroundStep($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
      if (slice.size || $from.pos != this.$to.pos) return new ReplaceStep($from.pos, $to.pos, slice);
      return null;
    }
  }, {
    key: "findFittable",
    value: function findFittable() {
      var startDepth = this.unplaced.openStart;
      for (var cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++) {
        var node = cur.firstChild;
        if (cur.childCount > 1) openEnd = 0;
        if (node.type.spec.isolating && openEnd <= d) {
          startDepth = d;
          break;
        }
        cur = node.content;
      }
      for (var pass = 1; pass <= 2; pass++) {
        for (var sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--) {
          var fragment = void 0,
            parent = null;
          if (sliceDepth) {
            parent = contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
            fragment = parent.content;
          } else {
            fragment = this.unplaced.content;
          }
          var first = fragment.firstChild;
          for (var frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--) {
            var _this$frontier$fronti = this.frontier[frontierDepth],
              type = _this$frontier$fronti.type,
              match = _this$frontier$fronti.match,
              _wrap = void 0,
              inject = null;
            if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore(prosemirrorModel.Fragment.from(first), false)) : parent && type.compatibleContent(parent.type))) return {
              sliceDepth: sliceDepth,
              frontierDepth: frontierDepth,
              parent: parent,
              inject: inject
            };else if (pass == 2 && first && (_wrap = match.findWrapping(first.type))) return {
              sliceDepth: sliceDepth,
              frontierDepth: frontierDepth,
              parent: parent,
              wrap: _wrap
            };
            if (parent && match.matchType(parent.type)) break;
          }
        }
      }
    }
  }, {
    key: "openMore",
    value: function openMore() {
      var _this$unplaced = this.unplaced,
        content = _this$unplaced.content,
        openStart = _this$unplaced.openStart,
        openEnd = _this$unplaced.openEnd;
      var inner = contentAt(content, openStart);
      if (!inner.childCount || inner.firstChild.isLeaf) return false;
      this.unplaced = new prosemirrorModel.Slice(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
      return true;
    }
  }, {
    key: "dropNode",
    value: function dropNode() {
      var _this$unplaced2 = this.unplaced,
        content = _this$unplaced2.content,
        openStart = _this$unplaced2.openStart,
        openEnd = _this$unplaced2.openEnd;
      var inner = contentAt(content, openStart);
      if (inner.childCount <= 1 && openStart > 0) {
        var openAtEnd = content.size - openStart <= openStart + inner.size;
        this.unplaced = new prosemirrorModel.Slice(dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
      } else {
        this.unplaced = new prosemirrorModel.Slice(dropFromFragment(content, openStart, 1), openStart, openEnd);
      }
    }
  }, {
    key: "placeNodes",
    value: function placeNodes(_ref) {
      var sliceDepth = _ref.sliceDepth,
        frontierDepth = _ref.frontierDepth,
        parent = _ref.parent,
        inject = _ref.inject,
        wrap = _ref.wrap;
      while (this.depth > frontierDepth) this.closeFrontierNode();
      if (wrap) for (var i = 0; i < wrap.length; i++) this.openFrontierNode(wrap[i]);
      var slice = this.unplaced,
        fragment = parent ? parent.content : slice.content;
      var openStart = slice.openStart - sliceDepth;
      var taken = 0,
        add = [];
      var _this$frontier$fronti2 = this.frontier[frontierDepth],
        match = _this$frontier$fronti2.match,
        type = _this$frontier$fronti2.type;
      if (inject) {
        for (var _i3 = 0; _i3 < inject.childCount; _i3++) add.push(inject.child(_i3));
        match = match.matchFragment(inject);
      }
      var openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
      while (taken < fragment.childCount) {
        var next = fragment.child(taken),
          matches = match.matchType(next.type);
        if (!matches) break;
        taken++;
        if (taken > 1 || openStart == 0 || next.content.size) {
          match = matches;
          add.push(closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
        }
      }
      var toEnd = taken == fragment.childCount;
      if (!toEnd) openEndCount = -1;
      this.placed = addToFragment(this.placed, frontierDepth, prosemirrorModel.Fragment.from(add));
      this.frontier[frontierDepth].match = match;
      if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
      for (var _i4 = 0, cur = fragment; _i4 < openEndCount; _i4++) {
        var node = cur.lastChild;
        this.frontier.push({
          type: node.type,
          match: node.contentMatchAt(node.childCount)
        });
        cur = node.content;
      }
      this.unplaced = !toEnd ? new prosemirrorModel.Slice(dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? prosemirrorModel.Slice.empty : new prosemirrorModel.Slice(dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
  }, {
    key: "mustMoveInline",
    value: function mustMoveInline() {
      if (!this.$to.parent.isTextblock) return -1;
      var top = this.frontier[this.depth],
        level;
      if (!top.type.isTextblock || !contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
      var depth = this.$to.depth,
        after = this.$to.after(depth);
      while (depth > 1 && after == this.$to.end(--depth)) ++after;
      return after;
    }
  }, {
    key: "findCloseLevel",
    value: function findCloseLevel($to) {
      scan: for (var i = Math.min(this.depth, $to.depth); i >= 0; i--) {
        var _this$frontier$i = this.frontier[i],
          match = _this$frontier$i.match,
          type = _this$frontier$i.type;
        var dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
        var fit = contentAfterFits($to, i, type, match, dropInner);
        if (!fit) continue;
        for (var d = i - 1; d >= 0; d--) {
          var _this$frontier$d = this.frontier[d],
            _match = _this$frontier$d.match,
            _type = _this$frontier$d.type;
          var matches = contentAfterFits($to, d, _type, _match, true);
          if (!matches || matches.childCount) continue scan;
        }
        return {
          depth: i,
          fit: fit,
          move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
        };
      }
    }
  }, {
    key: "close",
    value: function close($to) {
      var close = this.findCloseLevel($to);
      if (!close) return null;
      while (this.depth > close.depth) this.closeFrontierNode();
      if (close.fit.childCount) this.placed = addToFragment(this.placed, close.depth, close.fit);
      $to = close.move;
      for (var d = close.depth + 1; d <= $to.depth; d++) {
        var node = $to.node(d),
          add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
        this.openFrontierNode(node.type, node.attrs, add);
      }
      return $to;
    }
  }, {
    key: "openFrontierNode",
    value: function openFrontierNode(type) {
      var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var content = arguments.length > 2 ? arguments[2] : undefined;
      var top = this.frontier[this.depth];
      top.match = top.match.matchType(type);
      this.placed = addToFragment(this.placed, this.depth, prosemirrorModel.Fragment.from(type.create(attrs, content)));
      this.frontier.push({
        type: type,
        match: type.contentMatch
      });
    }
  }, {
    key: "closeFrontierNode",
    value: function closeFrontierNode() {
      var open = this.frontier.pop();
      var add = open.match.fillBefore(prosemirrorModel.Fragment.empty, true);
      if (add.childCount) this.placed = addToFragment(this.placed, this.frontier.length, add);
    }
  }]);
  return Fitter;
}();
function dropFromFragment(fragment, depth, count) {
  if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
  return fragment.replaceChild(0, fragment.firstChild.copy(dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function addToFragment(fragment, depth, content) {
  if (depth == 0) return fragment.append(content);
  return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy(addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function contentAt(fragment, depth) {
  for (var i = 0; i < depth; i++) fragment = fragment.firstChild.content;
  return fragment;
}
function closeNodeStart(node, openStart, openEnd) {
  if (openStart <= 0) return node;
  var frag = node.content;
  if (openStart > 1) frag = frag.replaceChild(0, closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
  if (openStart > 0) {
    frag = node.type.contentMatch.fillBefore(frag).append(frag);
    if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore(prosemirrorModel.Fragment.empty, true));
  }
  return node.copy(frag);
}
function contentAfterFits($to, depth, type, match, open) {
  var node = $to.node(depth),
    index = open ? $to.indexAfter(depth) : $to.index(depth);
  if (index == node.childCount && !type.compatibleContent(node.type)) return null;
  var fit = match.fillBefore(node.content, true, index);
  return fit && !invalidMarks(type, node.content, index) ? fit : null;
}
function invalidMarks(type, fragment, start) {
  for (var i = start; i < fragment.childCount; i++) if (!type.allowsMarks(fragment.child(i).marks)) return true;
  return false;
}
function definesContent(type) {
  return type.spec.defining || type.spec.definingForContent;
}
function _replaceRange(tr, from, to, slice) {
  if (!slice.size) return tr.deleteRange(from, to);
  var $from = tr.doc.resolve(from),
    $to = tr.doc.resolve(to);
  if (fitsTrivially($from, $to, slice)) return tr.step(new ReplaceStep(from, to, slice));
  var targetDepths = coveredDepths($from, tr.doc.resolve(to));
  if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
  var preferredTarget = -($from.depth + 1);
  targetDepths.unshift(preferredTarget);
  for (var d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--) {
    var spec = $from.node(d).type.spec;
    if (spec.defining || spec.definingAsContext || spec.isolating) break;
    if (targetDepths.indexOf(d) > -1) preferredTarget = d;else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
  }
  var preferredTargetIndex = targetDepths.indexOf(preferredTarget);
  var leftNodes = [],
    preferredDepth = slice.openStart;
  for (var content = slice.content, i = 0;; i++) {
    var node = content.firstChild;
    leftNodes.push(node);
    if (i == slice.openStart) break;
    content = node.content;
  }
  for (var _d3 = preferredDepth - 1; _d3 >= 0; _d3--) {
    var leftNode = leftNodes[_d3],
      def = definesContent(leftNode.type);
    if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = _d3;else if (def || !leftNode.type.isTextblock) break;
  }
  for (var j = slice.openStart; j >= 0; j--) {
    var openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
    var insert = leftNodes[openDepth];
    if (!insert) continue;
    for (var _i5 = 0; _i5 < targetDepths.length; _i5++) {
      var targetDepth = targetDepths[(_i5 + preferredTargetIndex) % targetDepths.length],
        expand = true;
      if (targetDepth < 0) {
        expand = false;
        targetDepth = -targetDepth;
      }
      var parent = $from.node(targetDepth - 1),
        index = $from.index(targetDepth - 1);
      if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new prosemirrorModel.Slice(closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
    }
  }
  var startSteps = tr.steps.length;
  for (var _i6 = targetDepths.length - 1; _i6 >= 0; _i6--) {
    tr.replace(from, to, slice);
    if (tr.steps.length > startSteps) break;
    var depth = targetDepths[_i6];
    if (depth < 0) continue;
    from = $from.before(depth);
    to = $to.after(depth);
  }
}
function closeFragment(fragment, depth, oldOpen, newOpen, parent) {
  if (depth < oldOpen) {
    var first = fragment.firstChild;
    fragment = fragment.replaceChild(0, first.copy(closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
  }
  if (depth > newOpen) {
    var match = parent.contentMatchAt(0);
    var start = match.fillBefore(fragment).append(fragment);
    fragment = start.append(match.matchFragment(start).fillBefore(prosemirrorModel.Fragment.empty, true));
  }
  return fragment;
}
function _replaceRangeWith(tr, from, to, node) {
  if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
    var point = insertPoint(tr.doc, from, node.type);
    if (point != null) from = to = point;
  }
  tr.replaceRange(from, to, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(node), 0, 0));
}
function _deleteRange(tr, from, to) {
  var $from = tr.doc.resolve(from),
    $to = tr.doc.resolve(to);
  var covered = coveredDepths($from, $to);
  for (var i = 0; i < covered.length; i++) {
    var depth = covered[i],
      last = i == covered.length - 1;
    if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr["delete"]($from.start(depth), $to.end(depth));
    if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr["delete"]($from.before(depth), $to.after(depth));
  }
  for (var d = 1; d <= $from.depth && d <= $to.depth; d++) {
    if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr["delete"]($from.before(d), to);
  }
  tr["delete"](from, to);
}
function coveredDepths($from, $to) {
  var result = [],
    minDepth = Math.min($from.depth, $to.depth);
  for (var d = minDepth; d >= 0; d--) {
    var start = $from.start(d);
    if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
    if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
  }
  return result;
}
var AttrStep = function (_Step7) {
  _inherits(AttrStep, _Step7);
  var _super7 = _createSuper(AttrStep);
  function AttrStep(pos, attr, value) {
    var _this9;
    _classCallCheck(this, AttrStep);
    _this9 = _super7.call(this);
    _this9.pos = pos;
    _this9.attr = attr;
    _this9.value = value;
    return _this9;
  }
  _createClass(AttrStep, [{
    key: "apply",
    value: function apply(doc) {
      var node = doc.nodeAt(this.pos);
      if (!node) return StepResult.fail("No node at attribute step's position");
      var attrs = Object.create(null);
      for (var name in node.attrs) attrs[name] = node.attrs[name];
      attrs[this.attr] = this.value;
      var updated = node.type.create(attrs, null, node.marks);
      return StepResult.fromReplace(doc, this.pos, this.pos + 1, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(updated), 0, node.isLeaf ? 0 : 1));
    }
  }, {
    key: "getMap",
    value: function getMap() {
      return StepMap.empty;
    }
  }, {
    key: "invert",
    value: function invert(doc) {
      return new AttrStep(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
  }, {
    key: "map",
    value: function map(mapping) {
      var pos = mapping.mapResult(this.pos, 1);
      return pos.deletedAfter ? null : new AttrStep(pos.pos, this.attr, this.value);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        stepType: "attr",
        pos: this.pos,
        attr: this.attr,
        value: this.value
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(schema, json) {
      if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
      return new AttrStep(json.pos, json.attr, json.value);
    }
  }]);
  return AttrStep;
}(Step);
Step.jsonID("attr", AttrStep);
var DocAttrStep = function (_Step8) {
  _inherits(DocAttrStep, _Step8);
  var _super8 = _createSuper(DocAttrStep);
  function DocAttrStep(attr, value) {
    var _this10;
    _classCallCheck(this, DocAttrStep);
    _this10 = _super8.call(this);
    _this10.attr = attr;
    _this10.value = value;
    return _this10;
  }
  _createClass(DocAttrStep, [{
    key: "apply",
    value: function apply(doc) {
      var attrs = Object.create(null);
      for (var name in doc.attrs) attrs[name] = doc.attrs[name];
      attrs[this.attr] = this.value;
      var updated = doc.type.create(attrs, doc.content, doc.marks);
      return StepResult.ok(updated);
    }
  }, {
    key: "getMap",
    value: function getMap() {
      return StepMap.empty;
    }
  }, {
    key: "invert",
    value: function invert(doc) {
      return new DocAttrStep(this.attr, doc.attrs[this.attr]);
    }
  }, {
    key: "map",
    value: function map(mapping) {
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        stepType: "docAttr",
        attr: this.attr,
        value: this.value
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(schema, json) {
      if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
      return new DocAttrStep(json.attr, json.value);
    }
  }]);
  return DocAttrStep;
}(Step);
Step.jsonID("docAttr", DocAttrStep);
exports.TransformError = function (_Error) {
  _inherits(TransformError, _Error);
  var _super9 = _createSuper(TransformError);
  function TransformError() {
    _classCallCheck(this, TransformError);
    return _super9.apply(this, arguments);
  }
  return _createClass(TransformError);
}(_wrapNativeSuper(Error));
exports.TransformError = function TransformError(message) {
  var err = Error.call(this, message);
  err.__proto__ = TransformError.prototype;
  return err;
};
exports.TransformError.prototype = Object.create(Error.prototype);
exports.TransformError.prototype.constructor = exports.TransformError;
exports.TransformError.prototype.name = "TransformError";
var Transform = function () {
  function Transform(doc) {
    _classCallCheck(this, Transform);
    this.doc = doc;
    this.steps = [];
    this.docs = [];
    this.mapping = new Mapping();
  }
  _createClass(Transform, [{
    key: "before",
    get: function get() {
      return this.docs.length ? this.docs[0] : this.doc;
    }
  }, {
    key: "step",
    value: function step(_step) {
      var result = this.maybeStep(_step);
      if (result.failed) throw new exports.TransformError(result.failed);
      return this;
    }
  }, {
    key: "maybeStep",
    value: function maybeStep(step) {
      var result = step.apply(this.doc);
      if (!result.failed) this.addStep(step, result.doc);
      return result;
    }
  }, {
    key: "docChanged",
    get: function get() {
      return this.steps.length > 0;
    }
  }, {
    key: "addStep",
    value: function addStep(step, doc) {
      this.docs.push(this.doc);
      this.steps.push(step);
      this.mapping.appendMap(step.getMap());
      this.doc = doc;
    }
  }, {
    key: "replace",
    value: function replace(from) {
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : from;
      var slice = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : prosemirrorModel.Slice.empty;
      var step = replaceStep(this.doc, from, to, slice);
      if (step) this.step(step);
      return this;
    }
  }, {
    key: "replaceWith",
    value: function replaceWith(from, to, content) {
      return this.replace(from, to, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(content), 0, 0));
    }
  }, {
    key: "delete",
    value: function _delete(from, to) {
      return this.replace(from, to, prosemirrorModel.Slice.empty);
    }
  }, {
    key: "insert",
    value: function insert(pos, content) {
      return this.replaceWith(pos, pos, content);
    }
  }, {
    key: "replaceRange",
    value: function replaceRange(from, to, slice) {
      _replaceRange(this, from, to, slice);
      return this;
    }
  }, {
    key: "replaceRangeWith",
    value: function replaceRangeWith(from, to, node) {
      _replaceRangeWith(this, from, to, node);
      return this;
    }
  }, {
    key: "deleteRange",
    value: function deleteRange(from, to) {
      _deleteRange(this, from, to);
      return this;
    }
  }, {
    key: "lift",
    value: function lift(range, target) {
      _lift(this, range, target);
      return this;
    }
  }, {
    key: "join",
    value: function join(pos) {
      var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      _join(this, pos, depth);
      return this;
    }
  }, {
    key: "wrap",
    value: function wrap(range, wrappers) {
      _wrap2(this, range, wrappers);
      return this;
    }
  }, {
    key: "setBlockType",
    value: function setBlockType(from) {
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : from;
      var type = arguments.length > 2 ? arguments[2] : undefined;
      var attrs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      _setBlockType(this, from, to, type, attrs);
      return this;
    }
  }, {
    key: "setNodeMarkup",
    value: function setNodeMarkup(pos, type) {
      var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var marks = arguments.length > 3 ? arguments[3] : undefined;
      _setNodeMarkup(this, pos, type, attrs, marks);
      return this;
    }
  }, {
    key: "setNodeAttribute",
    value: function setNodeAttribute(pos, attr, value) {
      this.step(new AttrStep(pos, attr, value));
      return this;
    }
  }, {
    key: "setDocAttribute",
    value: function setDocAttribute(attr, value) {
      this.step(new DocAttrStep(attr, value));
      return this;
    }
  }, {
    key: "addNodeMark",
    value: function addNodeMark(pos, mark) {
      this.step(new AddNodeMarkStep(pos, mark));
      return this;
    }
  }, {
    key: "removeNodeMark",
    value: function removeNodeMark(pos, mark) {
      var node = this.doc.nodeAt(pos);
      if (!node) throw new RangeError("No node at position " + pos);
      if (mark instanceof prosemirrorModel.Mark) {
        if (mark.isInSet(node.marks)) this.step(new RemoveNodeMarkStep(pos, mark));
      } else {
        var set = node.marks,
          found,
          steps = [];
        while (found = mark.isInSet(set)) {
          steps.push(new RemoveNodeMarkStep(pos, found));
          set = found.removeFromSet(set);
        }
        for (var i = steps.length - 1; i >= 0; i--) this.step(steps[i]);
      }
      return this;
    }
  }, {
    key: "split",
    value: function split(pos) {
      var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var typesAfter = arguments.length > 2 ? arguments[2] : undefined;
      _split(this, pos, depth, typesAfter);
      return this;
    }
  }, {
    key: "addMark",
    value: function addMark(from, to, mark) {
      _addMark(this, from, to, mark);
      return this;
    }
  }, {
    key: "removeMark",
    value: function removeMark(from, to, mark) {
      _removeMark(this, from, to, mark);
      return this;
    }
  }, {
    key: "clearIncompatible",
    value: function clearIncompatible(pos, parentType, match) {
      _clearIncompatible(this, pos, parentType, match);
      return this;
    }
  }]);
  return Transform;
}();
exports.AddMarkStep = AddMarkStep;
exports.AddNodeMarkStep = AddNodeMarkStep;
exports.AttrStep = AttrStep;
exports.DocAttrStep = DocAttrStep;
exports.MapResult = MapResult;
exports.Mapping = Mapping;
exports.RemoveMarkStep = RemoveMarkStep;
exports.RemoveNodeMarkStep = RemoveNodeMarkStep;
exports.ReplaceAroundStep = ReplaceAroundStep;
exports.ReplaceStep = ReplaceStep;
exports.Step = Step;
exports.StepMap = StepMap;
exports.StepResult = StepResult;
exports.Transform = Transform;
exports.canJoin = canJoin;
exports.canSplit = canSplit;
exports.dropPoint = dropPoint;
exports.findWrapping = findWrapping;
exports.insertPoint = insertPoint;
exports.joinPoint = joinPoint;
exports.liftTarget = liftTarget;
exports.replaceStep = replaceStep;


/***/ }),

/***/ 9222:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var prosemirrorState = __webpack_require__(42391);
var prosemirrorModel = __webpack_require__(19443);
var prosemirrorTransform = __webpack_require__(92843);
var domIndex = function domIndex(node) {
  for (var index = 0;; index++) {
    node = node.previousSibling;
    if (!node) return index;
  }
};
var parentNode = function parentNode(node) {
  var parent = node.assignedSlot || node.parentNode;
  return parent && parent.nodeType == 11 ? parent.host : parent;
};
var reusedRange = null;
var textRange = function textRange(node, from, to) {
  var range = reusedRange || (reusedRange = document.createRange());
  range.setEnd(node, to == null ? node.nodeValue.length : to);
  range.setStart(node, from || 0);
  return range;
};
var clearReusedRange = function clearReusedRange() {
  reusedRange = null;
};
var isEquivalentPosition = function isEquivalentPosition(node, off, targetNode, targetOff) {
  return targetNode && (scanFor(node, off, targetNode, targetOff, -1) || scanFor(node, off, targetNode, targetOff, 1));
};
var atomElements = /^(img|br|input|textarea|hr)$/i;
function scanFor(node, off, targetNode, targetOff, dir) {
  var _a;
  for (;;) {
    if (node == targetNode && off == targetOff) return true;
    if (off == (dir < 0 ? 0 : nodeSize(node))) {
      var parent = node.parentNode;
      if (!parent || parent.nodeType != 1 || hasBlockDesc(node) || atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
      off = domIndex(node) + (dir < 0 ? 0 : 1);
      node = parent;
    } else if (node.nodeType == 1) {
      var child = node.childNodes[off + (dir < 0 ? -1 : 0)];
      if (child.nodeType == 1 && child.contentEditable == "false") {
        if ((_a = child.pmViewDesc) === null || _a === void 0 ? void 0 : _a.ignoreForSelection) off += dir;else return false;
      } else {
        node = child;
        off = dir < 0 ? nodeSize(node) : 0;
      }
    } else {
      return false;
    }
  }
}
function nodeSize(node) {
  return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function textNodeBefore$1(node, offset) {
  for (;;) {
    if (node.nodeType == 3 && offset) return node;
    if (node.nodeType == 1 && offset > 0) {
      if (node.contentEditable == "false") return null;
      node = node.childNodes[offset - 1];
      offset = nodeSize(node);
    } else if (node.parentNode && !hasBlockDesc(node)) {
      offset = domIndex(node);
      node = node.parentNode;
    } else {
      return null;
    }
  }
}
function textNodeAfter$1(node, offset) {
  for (;;) {
    if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
    if (node.nodeType == 1 && offset < node.childNodes.length) {
      if (node.contentEditable == "false") return null;
      node = node.childNodes[offset];
      offset = 0;
    } else if (node.parentNode && !hasBlockDesc(node)) {
      offset = domIndex(node) + 1;
      node = node.parentNode;
    } else {
      return null;
    }
  }
}
function isOnEdge(node, offset, parent) {
  for (var atStart = offset == 0, atEnd = offset == nodeSize(node); atStart || atEnd;) {
    if (node == parent) return true;
    var index = domIndex(node);
    node = node.parentNode;
    if (!node) return false;
    atStart = atStart && index == 0;
    atEnd = atEnd && index == nodeSize(node);
  }
}
function hasBlockDesc(dom) {
  var desc;
  for (var cur = dom; cur; cur = cur.parentNode) if (desc = cur.pmViewDesc) break;
  return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
var selectionCollapsed = function selectionCollapsed(domSel) {
  return domSel.focusNode && isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function keyEvent(keyCode, key) {
  var event = document.createEvent("Event");
  event.initEvent("keydown", true, true);
  event.keyCode = keyCode;
  event.key = event.code = key;
  return event;
}
function deepActiveElement(doc) {
  var elt = doc.activeElement;
  while (elt && elt.shadowRoot) elt = elt.shadowRoot.activeElement;
  return elt;
}
function caretFromPoint(doc, x, y) {
  if (doc.caretPositionFromPoint) {
    try {
      var pos = doc.caretPositionFromPoint(x, y);
      if (pos) return {
        node: pos.offsetNode,
        offset: Math.min(nodeSize(pos.offsetNode), pos.offset)
      };
    } catch (_) {}
  }
  if (doc.caretRangeFromPoint) {
    var range = doc.caretRangeFromPoint(x, y);
    if (range) return {
      node: range.startContainer,
      offset: Math.min(nodeSize(range.startContainer), range.startOffset)
    };
  }
}
var nav = typeof navigator != "undefined" ? navigator : null;
var doc = typeof document != "undefined" ? document : null;
var agent = nav && nav.userAgent || "";
var ie_edge = /Edge\/(\d+)/.exec(agent);
var ie_upto10 = /MSIE \d/.exec(agent);
var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(agent);
var ie = !!(ie_upto10 || ie_11up || ie_edge);
var ie_version = ie_upto10 ? document.documentMode : ie_11up ? +ie_11up[1] : ie_edge ? +ie_edge[1] : 0;
var gecko = !ie && /gecko\/(\d+)/i.test(agent);
gecko && +(/Firefox\/(\d+)/.exec(agent) || [0, 0])[1];
var _chrome = !ie && /Chrome\/(\d+)/.exec(agent);
var chrome = !!_chrome;
var chrome_version = _chrome ? +_chrome[1] : 0;
var safari = !ie && !!nav && /Apple Computer/.test(nav.vendor);
var ios = safari && (/Mobile\/\w+/.test(agent) || !!nav && nav.maxTouchPoints > 2);
var mac = ios || (nav ? /Mac/.test(nav.platform) : false);
var windows = nav ? /Win/.test(nav.platform) : false;
var android = /Android \d/.test(agent);
var webkit = !!doc && "webkitFontSmoothing" in doc.documentElement.style;
var webkit_version = webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function windowRect(doc) {
  var vp = doc.defaultView && doc.defaultView.visualViewport;
  if (vp) return {
    left: 0,
    right: vp.width,
    top: 0,
    bottom: vp.height
  };
  return {
    left: 0,
    right: doc.documentElement.clientWidth,
    top: 0,
    bottom: doc.documentElement.clientHeight
  };
}
function getSide(value, side) {
  return typeof value == "number" ? value : value[side];
}
function clientRect(node) {
  var rect = node.getBoundingClientRect();
  var scaleX = rect.width / node.offsetWidth || 1;
  var scaleY = rect.height / node.offsetHeight || 1;
  return {
    left: rect.left,
    right: rect.left + node.clientWidth * scaleX,
    top: rect.top,
    bottom: rect.top + node.clientHeight * scaleY
  };
}
function scrollRectIntoView(view, rect, startDOM) {
  var scrollThreshold = view.someProp("scrollThreshold") || 0,
    scrollMargin = view.someProp("scrollMargin") || 5;
  var doc = view.dom.ownerDocument;
  for (var parent = startDOM || view.dom;;) {
    if (!parent) break;
    if (parent.nodeType != 1) {
      parent = parentNode(parent);
      continue;
    }
    var elt = parent;
    var atTop = elt == doc.body;
    var bounding = atTop ? windowRect(doc) : clientRect(elt);
    var moveX = 0,
      moveY = 0;
    if (rect.top < bounding.top + getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + getSide(scrollMargin, "top"));else if (rect.bottom > bounding.bottom - getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + getSide(scrollMargin, "bottom");
    if (rect.left < bounding.left + getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + getSide(scrollMargin, "left"));else if (rect.right > bounding.right - getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + getSide(scrollMargin, "right");
    if (moveX || moveY) {
      if (atTop) {
        doc.defaultView.scrollBy(moveX, moveY);
      } else {
        var startX = elt.scrollLeft,
          startY = elt.scrollTop;
        if (moveY) elt.scrollTop += moveY;
        if (moveX) elt.scrollLeft += moveX;
        var dX = elt.scrollLeft - startX,
          dY = elt.scrollTop - startY;
        rect = {
          left: rect.left - dX,
          top: rect.top - dY,
          right: rect.right - dX,
          bottom: rect.bottom - dY
        };
      }
    }
    var pos = atTop ? "fixed" : getComputedStyle(parent).position;
    if (/^(fixed|sticky)$/.test(pos)) break;
    parent = pos == "absolute" ? parent.offsetParent : parentNode(parent);
  }
}
function storeScrollPos(view) {
  var rect = view.dom.getBoundingClientRect(),
    startY = Math.max(0, rect.top);
  var refDOM, refTop;
  for (var x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5) {
    var dom = view.root.elementFromPoint(x, y);
    if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
    var localRect = dom.getBoundingClientRect();
    if (localRect.top >= startY - 20) {
      refDOM = dom;
      refTop = localRect.top;
      break;
    }
  }
  return {
    refDOM: refDOM,
    refTop: refTop,
    stack: scrollStack(view.dom)
  };
}
function scrollStack(dom) {
  var stack = [],
    doc = dom.ownerDocument;
  for (var cur = dom; cur; cur = parentNode(cur)) {
    stack.push({
      dom: cur,
      top: cur.scrollTop,
      left: cur.scrollLeft
    });
    if (dom == doc) break;
  }
  return stack;
}
function resetScrollPos(_ref) {
  var refDOM = _ref.refDOM,
    refTop = _ref.refTop,
    stack = _ref.stack;
  var newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
  restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function restoreScrollStack(stack, dTop) {
  for (var i = 0; i < stack.length; i++) {
    var _stack$i = stack[i],
      dom = _stack$i.dom,
      top = _stack$i.top,
      left = _stack$i.left;
    if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
    if (dom.scrollLeft != left) dom.scrollLeft = left;
  }
}
var preventScrollSupported = null;
function focusPreventScroll(dom) {
  if (dom.setActive) return dom.setActive();
  if (preventScrollSupported) return dom.focus(preventScrollSupported);
  var stored = scrollStack(dom);
  dom.focus(preventScrollSupported == null ? {
    get preventScroll() {
      preventScrollSupported = {
        preventScroll: true
      };
      return true;
    }
  } : undefined);
  if (!preventScrollSupported) {
    preventScrollSupported = false;
    restoreScrollStack(stored, 0);
  }
}
function findOffsetInNode(node, coords) {
  var closest,
    dxClosest = 2e8,
    coordsClosest,
    offset = 0;
  var rowBot = coords.top,
    rowTop = coords.top;
  var firstBelow, coordsBelow;
  for (var child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++) {
    var rects = void 0;
    if (child.nodeType == 1) rects = child.getClientRects();else if (child.nodeType == 3) rects = textRange(child).getClientRects();else continue;
    for (var i = 0; i < rects.length; i++) {
      var rect = rects[i];
      if (rect.top <= rowBot && rect.bottom >= rowTop) {
        rowBot = Math.max(rect.bottom, rowBot);
        rowTop = Math.min(rect.top, rowTop);
        var dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
        if (dx < dxClosest) {
          closest = child;
          dxClosest = dx;
          coordsClosest = dx && closest.nodeType == 3 ? {
            left: rect.right < coords.left ? rect.right : rect.left,
            top: coords.top
          } : coords;
          if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
          continue;
        }
      } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
        firstBelow = child;
        coordsBelow = {
          left: Math.max(rect.left, Math.min(rect.right, coords.left)),
          top: rect.top
        };
      }
      if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
    }
  }
  if (!closest && firstBelow) {
    closest = firstBelow;
    coordsClosest = coordsBelow;
    dxClosest = 0;
  }
  if (closest && closest.nodeType == 3) return findOffsetInText(closest, coordsClosest);
  if (!closest || dxClosest && closest.nodeType == 1) return {
    node: node,
    offset: offset
  };
  return findOffsetInNode(closest, coordsClosest);
}
function findOffsetInText(node, coords) {
  var len = node.nodeValue.length;
  var range = document.createRange();
  for (var i = 0; i < len; i++) {
    range.setEnd(node, i + 1);
    range.setStart(node, i);
    var rect = singleRect(range, 1);
    if (rect.top == rect.bottom) continue;
    if (inRect(coords, rect)) return {
      node: node,
      offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
    };
  }
  return {
    node: node,
    offset: 0
  };
}
function inRect(coords, rect) {
  return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function targetKludge(dom, coords) {
  var parent = dom.parentNode;
  if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
  return dom;
}
function posFromElement(view, elt, coords) {
  var _findOffsetInNode = findOffsetInNode(elt, coords),
    node = _findOffsetInNode.node,
    offset = _findOffsetInNode.offset,
    bias = -1;
  if (node.nodeType == 1 && !node.firstChild) {
    var rect = node.getBoundingClientRect();
    bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
  }
  return view.docView.posFromDOM(node, offset, bias);
}
function posFromCaret(view, node, offset, coords) {
  var outsideBlock = -1;
  for (var cur = node, sawBlock = false;;) {
    if (cur == view.dom) break;
    var desc = view.docView.nearestDesc(cur, true),
      rect = void 0;
    if (!desc) return null;
    if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) && ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
      if (desc.node.isBlock && desc.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(desc.dom.nodeName)) {
        if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
        sawBlock = true;
      }
      if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
        var before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
        return before ? desc.posBefore : desc.posAfter;
      }
    }
    cur = desc.dom.parentNode;
  }
  return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function elementFromPoint(element, coords, box) {
  var len = element.childNodes.length;
  if (len && box.top < box.bottom) {
    for (var startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;) {
      var child = element.childNodes[i];
      if (child.nodeType == 1) {
        var rects = child.getClientRects();
        for (var j = 0; j < rects.length; j++) {
          var rect = rects[j];
          if (inRect(coords, rect)) return elementFromPoint(child, coords, rect);
        }
      }
      if ((i = (i + 1) % len) == startI) break;
    }
  }
  return element;
}
function _posAtCoords(view, coords) {
  var doc = view.dom.ownerDocument,
    node,
    offset = 0;
  var caret = caretFromPoint(doc, coords.left, coords.top);
  if (caret) {
    node = caret.node;
    offset = caret.offset;
  }
  var elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
  var pos;
  if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
    var box = view.dom.getBoundingClientRect();
    if (!inRect(coords, box)) return null;
    elt = elementFromPoint(view.dom, coords, box);
    if (!elt) return null;
  }
  if (safari) {
    for (var p = elt; node && p; p = parentNode(p)) if (p.draggable) node = undefined;
  }
  elt = targetKludge(elt, coords);
  if (node) {
    if (gecko && node.nodeType == 1) {
      offset = Math.min(offset, node.childNodes.length);
      if (offset < node.childNodes.length) {
        var next = node.childNodes[offset],
          _box;
        if (next.nodeName == "IMG" && (_box = next.getBoundingClientRect()).right <= coords.left && _box.bottom > coords.top) offset++;
      }
    }
    var prev;
    if (webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
    if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = posFromCaret(view, node, offset, coords);
  }
  if (pos == null) pos = posFromElement(view, elt, coords);
  var desc = view.docView.nearestDesc(elt, true);
  return {
    pos: pos,
    inside: desc ? desc.posAtStart - desc.border : -1
  };
}
function nonZero(rect) {
  return rect.top < rect.bottom || rect.left < rect.right;
}
function singleRect(target, bias) {
  var rects = target.getClientRects();
  if (rects.length) {
    var first = rects[bias < 0 ? 0 : rects.length - 1];
    if (nonZero(first)) return first;
  }
  return Array.prototype.find.call(rects, nonZero) || target.getBoundingClientRect();
}
var BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function _coordsAtPos(view, pos, side) {
  var _view$docView$domFrom = view.docView.domFromPos(pos, side < 0 ? -1 : 1),
    node = _view$docView$domFrom.node,
    offset = _view$docView$domFrom.offset,
    atom = _view$docView$domFrom.atom;
  var supportEmptyRange = webkit || gecko;
  if (node.nodeType == 3) {
    if (supportEmptyRange && (BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
      var rect = singleRect(textRange(node, offset, offset), side);
      if (gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
        var rectBefore = singleRect(textRange(node, offset - 1, offset - 1), -1);
        if (rectBefore.top == rect.top) {
          var rectAfter = singleRect(textRange(node, offset, offset + 1), -1);
          if (rectAfter.top != rect.top) return flattenV(rectAfter, rectAfter.left < rectBefore.left);
        }
      }
      return rect;
    } else {
      var from = offset,
        to = offset,
        takeSide = side < 0 ? 1 : -1;
      if (side < 0 && !offset) {
        to++;
        takeSide = -1;
      } else if (side >= 0 && offset == node.nodeValue.length) {
        from--;
        takeSide = 1;
      } else if (side < 0) {
        from--;
      } else {
        to++;
      }
      return flattenV(singleRect(textRange(node, from, to), takeSide), takeSide < 0);
    }
  }
  var $dom = view.state.doc.resolve(pos - (atom || 0));
  if (!$dom.parent.inlineContent) {
    if (atom == null && offset && (side < 0 || offset == nodeSize(node))) {
      var before = node.childNodes[offset - 1];
      if (before.nodeType == 1) return flattenH(before.getBoundingClientRect(), false);
    }
    if (atom == null && offset < nodeSize(node)) {
      var after = node.childNodes[offset];
      if (after.nodeType == 1) return flattenH(after.getBoundingClientRect(), true);
    }
    return flattenH(node.getBoundingClientRect(), side >= 0);
  }
  if (atom == null && offset && (side < 0 || offset == nodeSize(node))) {
    var _before = node.childNodes[offset - 1];
    var target = _before.nodeType == 3 ? textRange(_before, nodeSize(_before) - (supportEmptyRange ? 0 : 1)) : _before.nodeType == 1 && (_before.nodeName != "BR" || !_before.nextSibling) ? _before : null;
    if (target) return flattenV(singleRect(target, 1), false);
  }
  if (atom == null && offset < nodeSize(node)) {
    var _after = node.childNodes[offset];
    while (_after.pmViewDesc && _after.pmViewDesc.ignoreForCoords) _after = _after.nextSibling;
    var _target = !_after ? null : _after.nodeType == 3 ? textRange(_after, 0, supportEmptyRange ? 0 : 1) : _after.nodeType == 1 ? _after : null;
    if (_target) return flattenV(singleRect(_target, -1), true);
  }
  return flattenV(singleRect(node.nodeType == 3 ? textRange(node) : node, -side), side >= 0);
}
function flattenV(rect, left) {
  if (rect.width == 0) return rect;
  var x = left ? rect.left : rect.right;
  return {
    top: rect.top,
    bottom: rect.bottom,
    left: x,
    right: x
  };
}
function flattenH(rect, top) {
  if (rect.height == 0) return rect;
  var y = top ? rect.top : rect.bottom;
  return {
    top: y,
    bottom: y,
    left: rect.left,
    right: rect.right
  };
}
function withFlushedState(view, state, f) {
  var viewState = view.state,
    active = view.root.activeElement;
  if (viewState != state) view.updateState(state);
  if (active != view.dom) view.focus();
  try {
    return f();
  } finally {
    if (viewState != state) view.updateState(viewState);
    if (active != view.dom && active) active.focus();
  }
}
function endOfTextblockVertical(view, state, dir) {
  var sel = state.selection;
  var $pos = dir == "up" ? sel.$from : sel.$to;
  return withFlushedState(view, state, function () {
    var _view$docView$domFrom2 = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1),
      dom = _view$docView$domFrom2.node;
    for (;;) {
      var nearest = view.docView.nearestDesc(dom, true);
      if (!nearest) break;
      if (nearest.node.isBlock) {
        dom = nearest.contentDOM || nearest.dom;
        break;
      }
      dom = nearest.dom.parentNode;
    }
    var coords = _coordsAtPos(view, $pos.pos, 1);
    for (var child = dom.firstChild; child; child = child.nextSibling) {
      var boxes = void 0;
      if (child.nodeType == 1) boxes = child.getClientRects();else if (child.nodeType == 3) boxes = textRange(child, 0, child.nodeValue.length).getClientRects();else continue;
      for (var i = 0; i < boxes.length; i++) {
        var box = boxes[i];
        if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
      }
    }
    return true;
  });
}
var maybeRTL = /[\u0590-\u08ac]/;
function endOfTextblockHorizontal(view, state, dir) {
  var $head = state.selection.$head;
  if (!$head.parent.isTextblock) return false;
  var offset = $head.parentOffset,
    atStart = !offset,
    atEnd = offset == $head.parent.content.size;
  var sel = view.domSelection();
  if (!sel) return $head.pos == $head.start() || $head.pos == $head.end();
  if (!maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
  return withFlushedState(view, state, function () {
    var _view$domSelectionRan = view.domSelectionRange(),
      oldNode = _view$domSelectionRan.focusNode,
      oldOff = _view$domSelectionRan.focusOffset,
      anchorNode = _view$domSelectionRan.anchorNode,
      anchorOffset = _view$domSelectionRan.anchorOffset;
    var oldBidiLevel = sel.caretBidiLevel;
    sel.modify("move", dir, "character");
    var parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
    var _view$domSelectionRan2 = view.domSelectionRange(),
      newNode = _view$domSelectionRan2.focusNode,
      newOff = _view$domSelectionRan2.focusOffset;
    var result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
    try {
      sel.collapse(anchorNode, anchorOffset);
      if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
    } catch (_) {}
    if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
    return result;
  });
}
var cachedState = null;
var cachedDir = null;
var cachedResult = false;
function _endOfTextblock(view, state, dir) {
  if (cachedState == state && cachedDir == dir) return cachedResult;
  cachedState = state;
  cachedDir = dir;
  return cachedResult = dir == "up" || dir == "down" ? endOfTextblockVertical(view, state, dir) : endOfTextblockHorizontal(view, state, dir);
}
var NOT_DIRTY = 0,
  CHILD_DIRTY = 1,
  CONTENT_DIRTY = 2,
  NODE_DIRTY = 3;
var ViewDesc = function () {
  function ViewDesc(parent, children, dom, contentDOM) {
    _classCallCheck(this, ViewDesc);
    this.parent = parent;
    this.children = children;
    this.dom = dom;
    this.contentDOM = contentDOM;
    this.dirty = NOT_DIRTY;
    dom.pmViewDesc = this;
  }
  _createClass(ViewDesc, [{
    key: "matchesWidget",
    value: function matchesWidget(widget) {
      return false;
    }
  }, {
    key: "matchesMark",
    value: function matchesMark(mark) {
      return false;
    }
  }, {
    key: "matchesNode",
    value: function matchesNode(node, outerDeco, innerDeco) {
      return false;
    }
  }, {
    key: "matchesHack",
    value: function matchesHack(nodeName) {
      return false;
    }
  }, {
    key: "parseRule",
    value: function parseRule() {
      return null;
    }
  }, {
    key: "stopEvent",
    value: function stopEvent(event) {
      return false;
    }
  }, {
    key: "size",
    get: function get() {
      var size = 0;
      for (var i = 0; i < this.children.length; i++) size += this.children[i].size;
      return size;
    }
  }, {
    key: "border",
    get: function get() {
      return 0;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.parent = undefined;
      if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
      for (var i = 0; i < this.children.length; i++) this.children[i].destroy();
    }
  }, {
    key: "posBeforeChild",
    value: function posBeforeChild(child) {
      for (var i = 0, pos = this.posAtStart;; i++) {
        var cur = this.children[i];
        if (cur == child) return pos;
        pos += cur.size;
      }
    }
  }, {
    key: "posBefore",
    get: function get() {
      return this.parent.posBeforeChild(this);
    }
  }, {
    key: "posAtStart",
    get: function get() {
      return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
  }, {
    key: "posAfter",
    get: function get() {
      return this.posBefore + this.size;
    }
  }, {
    key: "posAtEnd",
    get: function get() {
      return this.posAtStart + this.size - 2 * this.border;
    }
  }, {
    key: "localPosFromDOM",
    value: function localPosFromDOM(dom, offset, bias) {
      if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
        if (bias < 0) {
          var domBefore, desc;
          if (dom == this.contentDOM) {
            domBefore = dom.childNodes[offset - 1];
          } else {
            while (dom.parentNode != this.contentDOM) dom = dom.parentNode;
            domBefore = dom.previousSibling;
          }
          while (domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this)) domBefore = domBefore.previousSibling;
          return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
        } else {
          var domAfter, _desc;
          if (dom == this.contentDOM) {
            domAfter = dom.childNodes[offset];
          } else {
            while (dom.parentNode != this.contentDOM) dom = dom.parentNode;
            domAfter = dom.nextSibling;
          }
          while (domAfter && !((_desc = domAfter.pmViewDesc) && _desc.parent == this)) domAfter = domAfter.nextSibling;
          return domAfter ? this.posBeforeChild(_desc) : this.posAtEnd;
        }
      }
      var atEnd;
      if (dom == this.dom && this.contentDOM) {
        atEnd = offset > domIndex(this.contentDOM);
      } else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) {
        atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
      } else if (this.dom.firstChild) {
        if (offset == 0) for (var search = dom;; search = search.parentNode) {
          if (search == this.dom) {
            atEnd = false;
            break;
          }
          if (search.previousSibling) break;
        }
        if (atEnd == null && offset == dom.childNodes.length) for (var _search = dom;; _search = _search.parentNode) {
          if (_search == this.dom) {
            atEnd = true;
            break;
          }
          if (_search.nextSibling) break;
        }
      }
      return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
  }, {
    key: "nearestDesc",
    value: function nearestDesc(dom) {
      var onlyNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      for (var first = true, cur = dom; cur; cur = cur.parentNode) {
        var desc = this.getDesc(cur),
          nodeDOM = void 0;
        if (desc && (!onlyNodes || desc.node)) {
          if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;else return desc;
        }
      }
    }
  }, {
    key: "getDesc",
    value: function getDesc(dom) {
      var desc = dom.pmViewDesc;
      for (var cur = desc; cur; cur = cur.parent) if (cur == this) return desc;
    }
  }, {
    key: "posFromDOM",
    value: function posFromDOM(dom, offset, bias) {
      for (var scan = dom; scan; scan = scan.parentNode) {
        var desc = this.getDesc(scan);
        if (desc) return desc.localPosFromDOM(dom, offset, bias);
      }
      return -1;
    }
  }, {
    key: "descAt",
    value: function descAt(pos) {
      for (var i = 0, offset = 0; i < this.children.length; i++) {
        var child = this.children[i],
          end = offset + child.size;
        if (offset == pos && end != offset) {
          while (!child.border && child.children.length) {
            for (var _i = 0; _i < child.children.length; _i++) {
              var inner = child.children[_i];
              if (inner.size) {
                child = inner;
                break;
              }
            }
          }
          return child;
        }
        if (pos < end) return child.descAt(pos - offset - child.border);
        offset = end;
      }
    }
  }, {
    key: "domFromPos",
    value: function domFromPos(pos, side) {
      if (!this.contentDOM) return {
        node: this.dom,
        offset: 0,
        atom: pos + 1
      };
      var i = 0,
        offset = 0;
      for (var curPos = 0; i < this.children.length; i++) {
        var child = this.children[i],
          end = curPos + child.size;
        if (end > pos || child instanceof TrailingHackViewDesc) {
          offset = pos - curPos;
          break;
        }
        curPos = end;
      }
      if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
      for (var prev; i && !(prev = this.children[i - 1]).size && prev instanceof WidgetViewDesc && prev.side >= 0; i--) {}
      if (side <= 0) {
        var _prev,
          enter = true;
        for (;; i--, enter = false) {
          _prev = i ? this.children[i - 1] : null;
          if (!_prev || _prev.dom.parentNode == this.contentDOM) break;
        }
        if (_prev && side && enter && !_prev.border && !_prev.domAtom) return _prev.domFromPos(_prev.size, side);
        return {
          node: this.contentDOM,
          offset: _prev ? domIndex(_prev.dom) + 1 : 0
        };
      } else {
        var next,
          _enter = true;
        for (;; i++, _enter = false) {
          next = i < this.children.length ? this.children[i] : null;
          if (!next || next.dom.parentNode == this.contentDOM) break;
        }
        if (next && _enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
        return {
          node: this.contentDOM,
          offset: next ? domIndex(next.dom) : this.contentDOM.childNodes.length
        };
      }
    }
  }, {
    key: "parseRange",
    value: function parseRange(from, to) {
      var base = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      if (this.children.length == 0) return {
        node: this.contentDOM,
        from: from,
        to: to,
        fromOffset: 0,
        toOffset: this.contentDOM.childNodes.length
      };
      var fromOffset = -1,
        toOffset = -1;
      for (var offset = base, i = 0;; i++) {
        var child = this.children[i],
          end = offset + child.size;
        if (fromOffset == -1 && from <= end) {
          var childBase = offset + child.border;
          if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
          from = offset;
          for (var j = i; j > 0; j--) {
            var prev = this.children[j - 1];
            if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
              fromOffset = domIndex(prev.dom) + 1;
              break;
            }
            from -= prev.size;
          }
          if (fromOffset == -1) fromOffset = 0;
        }
        if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
          to = end;
          for (var _j = i + 1; _j < this.children.length; _j++) {
            var next = this.children[_j];
            if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
              toOffset = domIndex(next.dom);
              break;
            }
            to += next.size;
          }
          if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
          break;
        }
        offset = end;
      }
      return {
        node: this.contentDOM,
        from: from,
        to: to,
        fromOffset: fromOffset,
        toOffset: toOffset
      };
    }
  }, {
    key: "emptyChildAt",
    value: function emptyChildAt(side) {
      if (this.border || !this.contentDOM || !this.children.length) return false;
      var child = this.children[side < 0 ? 0 : this.children.length - 1];
      return child.size == 0 || child.emptyChildAt(side);
    }
  }, {
    key: "domAfterPos",
    value: function domAfterPos(pos) {
      var _this$domFromPos = this.domFromPos(pos, 0),
        node = _this$domFromPos.node,
        offset = _this$domFromPos.offset;
      if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
      return node.childNodes[offset];
    }
  }, {
    key: "setSelection",
    value: function setSelection(anchor, head, view) {
      var force = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var from = Math.min(anchor, head),
        to = Math.max(anchor, head);
      for (var i = 0, offset = 0; i < this.children.length; i++) {
        var child = this.children[i],
          end = offset + child.size;
        if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, view, force);
        offset = end;
      }
      var anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
      var headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
      var domSel = view.root.getSelection();
      var selRange = view.domSelectionRange();
      var brKludge = false;
      if ((gecko || safari) && anchor == head) {
        var _anchorDOM = anchorDOM,
          node = _anchorDOM.node,
          _offset = _anchorDOM.offset;
        if (node.nodeType == 3) {
          brKludge = !!(_offset && node.nodeValue[_offset - 1] == "\n");
          if (brKludge && _offset == node.nodeValue.length) {
            for (var scan = node, after; scan; scan = scan.parentNode) {
              if (after = scan.nextSibling) {
                if (after.nodeName == "BR") anchorDOM = headDOM = {
                  node: after.parentNode,
                  offset: domIndex(after) + 1
                };
                break;
              }
              var desc = scan.pmViewDesc;
              if (desc && desc.node && desc.node.isBlock) break;
            }
          }
        } else {
          var prev = node.childNodes[_offset - 1];
          brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
        }
      }
      if (gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
        var _after2 = selRange.focusNode.childNodes[selRange.focusOffset];
        if (_after2 && _after2.contentEditable == "false") force = true;
      }
      if (!(force || brKludge && safari) && isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) && isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset)) return;
      var domSelExtended = false;
      if ((domSel.extend || anchor == head) && !brKludge) {
        domSel.collapse(anchorDOM.node, anchorDOM.offset);
        try {
          if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
          domSelExtended = true;
        } catch (_) {}
      }
      if (!domSelExtended) {
        if (anchor > head) {
          var tmp = anchorDOM;
          anchorDOM = headDOM;
          headDOM = tmp;
        }
        var range = document.createRange();
        range.setEnd(headDOM.node, headDOM.offset);
        range.setStart(anchorDOM.node, anchorDOM.offset);
        domSel.removeAllRanges();
        domSel.addRange(range);
      }
    }
  }, {
    key: "ignoreMutation",
    value: function ignoreMutation(mutation) {
      return !this.contentDOM && mutation.type != "selection";
    }
  }, {
    key: "contentLost",
    get: function get() {
      return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
  }, {
    key: "markDirty",
    value: function markDirty(from, to) {
      for (var offset = 0, i = 0; i < this.children.length; i++) {
        var child = this.children[i],
          end = offset + child.size;
        if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
          var startInside = offset + child.border,
            endInside = end - child.border;
          if (from >= startInside && to <= endInside) {
            this.dirty = from == offset || to == end ? CONTENT_DIRTY : CHILD_DIRTY;
            if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = NODE_DIRTY;else child.markDirty(from - startInside, to - startInside);
            return;
          } else {
            child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? CONTENT_DIRTY : NODE_DIRTY;
          }
        }
        offset = end;
      }
      this.dirty = CONTENT_DIRTY;
    }
  }, {
    key: "markParentsDirty",
    value: function markParentsDirty() {
      var level = 1;
      for (var node = this.parent; node; node = node.parent, level++) {
        var dirty = level == 1 ? CONTENT_DIRTY : CHILD_DIRTY;
        if (node.dirty < dirty) node.dirty = dirty;
      }
    }
  }, {
    key: "domAtom",
    get: function get() {
      return false;
    }
  }, {
    key: "ignoreForCoords",
    get: function get() {
      return false;
    }
  }, {
    key: "ignoreForSelection",
    get: function get() {
      return false;
    }
  }, {
    key: "isText",
    value: function isText(text) {
      return false;
    }
  }]);
  return ViewDesc;
}();
var WidgetViewDesc = function (_ViewDesc) {
  _inherits(WidgetViewDesc, _ViewDesc);
  var _super = _createSuper(WidgetViewDesc);
  function WidgetViewDesc(parent, widget, view, pos) {
    var _this;
    _classCallCheck(this, WidgetViewDesc);
    var self,
      dom = widget.type.toDOM;
    if (typeof dom == "function") dom = dom(view, function () {
      if (!self) return pos;
      if (self.parent) return self.parent.posBeforeChild(self);
    });
    if (!widget.type.spec.raw) {
      if (dom.nodeType != 1) {
        var wrap = document.createElement("span");
        wrap.appendChild(dom);
        dom = wrap;
      }
      dom.contentEditable = "false";
      dom.classList.add("ProseMirror-widget");
    }
    _this = _super.call(this, parent, [], dom, null);
    _this.widget = widget;
    _this.widget = widget;
    self = _assertThisInitialized(_this);
    return _this;
  }
  _createClass(WidgetViewDesc, [{
    key: "matchesWidget",
    value: function matchesWidget(widget) {
      return this.dirty == NOT_DIRTY && widget.type.eq(this.widget.type);
    }
  }, {
    key: "parseRule",
    value: function parseRule() {
      return {
        ignore: true
      };
    }
  }, {
    key: "stopEvent",
    value: function stopEvent(event) {
      var stop = this.widget.spec.stopEvent;
      return stop ? stop(event) : false;
    }
  }, {
    key: "ignoreMutation",
    value: function ignoreMutation(mutation) {
      return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.widget.type.destroy(this.dom);
      _get(_getPrototypeOf(WidgetViewDesc.prototype), "destroy", this).call(this);
    }
  }, {
    key: "domAtom",
    get: function get() {
      return true;
    }
  }, {
    key: "ignoreForSelection",
    get: function get() {
      return !!this.widget.type.spec.relaxedSide;
    }
  }, {
    key: "side",
    get: function get() {
      return this.widget.type.side;
    }
  }]);
  return WidgetViewDesc;
}(ViewDesc);
var CompositionViewDesc = function (_ViewDesc2) {
  _inherits(CompositionViewDesc, _ViewDesc2);
  var _super2 = _createSuper(CompositionViewDesc);
  function CompositionViewDesc(parent, dom, textDOM, text) {
    var _this2;
    _classCallCheck(this, CompositionViewDesc);
    _this2 = _super2.call(this, parent, [], dom, null);
    _this2.textDOM = textDOM;
    _this2.text = text;
    return _this2;
  }
  _createClass(CompositionViewDesc, [{
    key: "size",
    get: function get() {
      return this.text.length;
    }
  }, {
    key: "localPosFromDOM",
    value: function localPosFromDOM(dom, offset) {
      if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
      return this.posAtStart + offset;
    }
  }, {
    key: "domFromPos",
    value: function domFromPos(pos) {
      return {
        node: this.textDOM,
        offset: pos
      };
    }
  }, {
    key: "ignoreMutation",
    value: function ignoreMutation(mut) {
      return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue;
    }
  }]);
  return CompositionViewDesc;
}(ViewDesc);
var MarkViewDesc = function (_ViewDesc3) {
  _inherits(MarkViewDesc, _ViewDesc3);
  var _super3 = _createSuper(MarkViewDesc);
  function MarkViewDesc(parent, mark, dom, contentDOM, spec) {
    var _this3;
    _classCallCheck(this, MarkViewDesc);
    _this3 = _super3.call(this, parent, [], dom, contentDOM);
    _this3.mark = mark;
    _this3.spec = spec;
    return _this3;
  }
  _createClass(MarkViewDesc, [{
    key: "parseRule",
    value: function parseRule() {
      if (this.dirty & NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
      return {
        mark: this.mark.type.name,
        attrs: this.mark.attrs,
        contentElement: this.contentDOM
      };
    }
  }, {
    key: "matchesMark",
    value: function matchesMark(mark) {
      return this.dirty != NODE_DIRTY && this.mark.eq(mark);
    }
  }, {
    key: "markDirty",
    value: function markDirty(from, to) {
      _get(_getPrototypeOf(MarkViewDesc.prototype), "markDirty", this).call(this, from, to);
      if (this.dirty != NOT_DIRTY) {
        var parent = this.parent;
        while (!parent.node) parent = parent.parent;
        if (parent.dirty < this.dirty) parent.dirty = this.dirty;
        this.dirty = NOT_DIRTY;
      }
    }
  }, {
    key: "slice",
    value: function slice(from, to, view) {
      var copy = MarkViewDesc.create(this.parent, this.mark, true, view);
      var nodes = this.children,
        size = this.size;
      if (to < size) nodes = replaceNodes(nodes, to, size, view);
      if (from > 0) nodes = replaceNodes(nodes, 0, from, view);
      for (var i = 0; i < nodes.length; i++) nodes[i].parent = copy;
      copy.children = nodes;
      return copy;
    }
  }, {
    key: "ignoreMutation",
    value: function ignoreMutation(mutation) {
      return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : _get(_getPrototypeOf(MarkViewDesc.prototype), "ignoreMutation", this).call(this, mutation);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.spec.destroy) this.spec.destroy();
      _get(_getPrototypeOf(MarkViewDesc.prototype), "destroy", this).call(this);
    }
  }], [{
    key: "create",
    value: function create(parent, mark, inline, view) {
      var custom = view.nodeViews[mark.type.name];
      var spec = custom && custom(mark, view, inline);
      if (!spec || !spec.dom) spec = prosemirrorModel.DOMSerializer.renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
      return new MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom, spec);
    }
  }]);
  return MarkViewDesc;
}(ViewDesc);
var NodeViewDesc = function (_ViewDesc4) {
  _inherits(NodeViewDesc, _ViewDesc4);
  var _super4 = _createSuper(NodeViewDesc);
  function NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos) {
    var _this4;
    _classCallCheck(this, NodeViewDesc);
    _this4 = _super4.call(this, parent, [], dom, contentDOM);
    _this4.node = node;
    _this4.outerDeco = outerDeco;
    _this4.innerDeco = innerDeco;
    _this4.nodeDOM = nodeDOM;
    return _this4;
  }
  _createClass(NodeViewDesc, [{
    key: "parseRule",
    value: function parseRule() {
      var _this5 = this;
      if (this.node.type.spec.reparseInView) return null;
      var rule = {
        node: this.node.type.name,
        attrs: this.node.attrs
      };
      if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
      if (!this.contentDOM) {
        rule.getContent = function () {
          return _this5.node.content;
        };
      } else if (!this.contentLost) {
        rule.contentElement = this.contentDOM;
      } else {
        for (var i = this.children.length - 1; i >= 0; i--) {
          var child = this.children[i];
          if (this.dom.contains(child.dom.parentNode)) {
            rule.contentElement = child.dom.parentNode;
            break;
          }
        }
        if (!rule.contentElement) rule.getContent = function () {
          return prosemirrorModel.Fragment.empty;
        };
      }
      return rule;
    }
  }, {
    key: "matchesNode",
    value: function matchesNode(node, outerDeco, innerDeco) {
      return this.dirty == NOT_DIRTY && node.eq(this.node) && sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
  }, {
    key: "size",
    get: function get() {
      return this.node.nodeSize;
    }
  }, {
    key: "border",
    get: function get() {
      return this.node.isLeaf ? 0 : 1;
    }
  }, {
    key: "updateChildren",
    value: function updateChildren(view, pos) {
      var _this6 = this;
      var inline = this.node.inlineContent,
        off = pos;
      var composition = view.composing ? this.localCompositionInfo(view, pos) : null;
      var localComposition = composition && composition.pos > -1 ? composition : null;
      var compositionInChild = composition && composition.pos < 0;
      var updater = new ViewTreeUpdater(this, localComposition && localComposition.node, view);
      iterDeco(this.node, this.innerDeco, function (widget, i, insideNode) {
        if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view);else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == _this6.node.childCount ? prosemirrorModel.Mark.none : _this6.node.child(i).marks, inline, view);
        updater.placeWidget(widget, view, off);
      }, function (child, outerDeco, innerDeco, i) {
        updater.syncToMarks(child.marks, inline, view);
        var compIndex;
        if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;else {
          updater.addNode(child, outerDeco, innerDeco, view, off);
        }
        off += child.nodeSize;
      });
      updater.syncToMarks([], inline, view);
      if (this.node.isTextblock) updater.addTextblockHacks();
      updater.destroyRest();
      if (updater.changed || this.dirty == CONTENT_DIRTY) {
        if (localComposition) this.protectLocalComposition(view, localComposition);
        renderDescs(this.contentDOM, this.children, view);
        if (ios) iosHacks(this.dom);
      }
    }
  }, {
    key: "localCompositionInfo",
    value: function localCompositionInfo(view, pos) {
      var _view$state$selection = view.state.selection,
        from = _view$state$selection.from,
        to = _view$state$selection.to;
      if (!(view.state.selection instanceof prosemirrorState.TextSelection) || from < pos || to > pos + this.node.content.size) return null;
      var textNode = view.input.compositionNode;
      if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
      if (this.node.inlineContent) {
        var text = textNode.nodeValue;
        var textPos = findTextInFragment(this.node.content, text, from - pos, to - pos);
        return textPos < 0 ? null : {
          node: textNode,
          pos: textPos,
          text: text
        };
      } else {
        return {
          node: textNode,
          pos: -1,
          text: ""
        };
      }
    }
  }, {
    key: "protectLocalComposition",
    value: function protectLocalComposition(view, _ref2) {
      var node = _ref2.node,
        pos = _ref2.pos,
        text = _ref2.text;
      if (this.getDesc(node)) return;
      var topNode = node;
      for (;; topNode = topNode.parentNode) {
        if (topNode.parentNode == this.contentDOM) break;
        while (topNode.previousSibling) topNode.parentNode.removeChild(topNode.previousSibling);
        while (topNode.nextSibling) topNode.parentNode.removeChild(topNode.nextSibling);
        if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
      }
      var desc = new CompositionViewDesc(this, topNode, node, text);
      view.input.compositionNodes.push(desc);
      this.children = replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
  }, {
    key: "update",
    value: function update(node, outerDeco, innerDeco, view) {
      if (this.dirty == NODE_DIRTY || !node.sameMarkup(this.node)) return false;
      this.updateInner(node, outerDeco, innerDeco, view);
      return true;
    }
  }, {
    key: "updateInner",
    value: function updateInner(node, outerDeco, innerDeco, view) {
      this.updateOuterDeco(outerDeco);
      this.node = node;
      this.innerDeco = innerDeco;
      if (this.contentDOM) this.updateChildren(view, this.posAtStart);
      this.dirty = NOT_DIRTY;
    }
  }, {
    key: "updateOuterDeco",
    value: function updateOuterDeco(outerDeco) {
      if (sameOuterDeco(outerDeco, this.outerDeco)) return;
      var needsWrap = this.nodeDOM.nodeType != 1;
      var oldDOM = this.dom;
      this.dom = patchOuterDeco(this.dom, this.nodeDOM, computeOuterDeco(this.outerDeco, this.node, needsWrap), computeOuterDeco(outerDeco, this.node, needsWrap));
      if (this.dom != oldDOM) {
        oldDOM.pmViewDesc = undefined;
        this.dom.pmViewDesc = this;
      }
      this.outerDeco = outerDeco;
    }
  }, {
    key: "selectNode",
    value: function selectNode() {
      if (this.nodeDOM.nodeType == 1) this.nodeDOM.classList.add("ProseMirror-selectednode");
      if (this.contentDOM || !this.node.type.spec.draggable) this.dom.draggable = true;
    }
  }, {
    key: "deselectNode",
    value: function deselectNode() {
      if (this.nodeDOM.nodeType == 1) {
        this.nodeDOM.classList.remove("ProseMirror-selectednode");
        if (this.contentDOM || !this.node.type.spec.draggable) this.dom.removeAttribute("draggable");
      }
    }
  }, {
    key: "domAtom",
    get: function get() {
      return this.node.isAtom;
    }
  }], [{
    key: "create",
    value: function create(parent, node, outerDeco, innerDeco, view, pos) {
      var custom = view.nodeViews[node.type.name],
        descObj;
      var spec = custom && custom(node, view, function () {
        if (!descObj) return pos;
        if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
      }, outerDeco, innerDeco);
      var dom = spec && spec.dom,
        contentDOM = spec && spec.contentDOM;
      if (node.isText) {
        if (!dom) dom = document.createTextNode(node.text);else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
      } else if (!dom) {
        var _spec = prosemirrorModel.DOMSerializer.renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
        dom = _spec.dom;
        contentDOM = _spec.contentDOM;
      }
      if (!contentDOM && !node.isText && dom.nodeName != "BR") {
        if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
        if (node.type.spec.draggable) dom.draggable = true;
      }
      var nodeDOM = dom;
      dom = applyOuterDeco(dom, outerDeco, node);
      if (spec) return descObj = new CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);else if (node.isText) return new TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);else return new NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
  }]);
  return NodeViewDesc;
}(ViewDesc);
function docViewDesc(doc, outerDeco, innerDeco, dom, view) {
  applyOuterDeco(dom, outerDeco, doc);
  var docView = new NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
  if (docView.contentDOM) docView.updateChildren(view, 0);
  return docView;
}
var TextViewDesc = function (_NodeViewDesc) {
  _inherits(TextViewDesc, _NodeViewDesc);
  var _super5 = _createSuper(TextViewDesc);
  function TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view) {
    _classCallCheck(this, TextViewDesc);
    return _super5.call(this, parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
  }
  _createClass(TextViewDesc, [{
    key: "parseRule",
    value: function parseRule() {
      var skip = this.nodeDOM.parentNode;
      while (skip && skip != this.dom && !skip.pmIsDeco) skip = skip.parentNode;
      return {
        skip: skip || true
      };
    }
  }, {
    key: "update",
    value: function update(node, outerDeco, innerDeco, view) {
      if (this.dirty == NODE_DIRTY || this.dirty != NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
      this.updateOuterDeco(outerDeco);
      if ((this.dirty != NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
        this.nodeDOM.nodeValue = node.text;
        if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
      }
      this.node = node;
      this.dirty = NOT_DIRTY;
      return true;
    }
  }, {
    key: "inParent",
    value: function inParent() {
      var parentDOM = this.parent.contentDOM;
      for (var n = this.nodeDOM; n; n = n.parentNode) if (n == parentDOM) return true;
      return false;
    }
  }, {
    key: "domFromPos",
    value: function domFromPos(pos) {
      return {
        node: this.nodeDOM,
        offset: pos
      };
    }
  }, {
    key: "localPosFromDOM",
    value: function localPosFromDOM(dom, offset, bias) {
      if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
      return _get(_getPrototypeOf(TextViewDesc.prototype), "localPosFromDOM", this).call(this, dom, offset, bias);
    }
  }, {
    key: "ignoreMutation",
    value: function ignoreMutation(mutation) {
      return mutation.type != "characterData" && mutation.type != "selection";
    }
  }, {
    key: "slice",
    value: function slice(from, to, view) {
      var node = this.node.cut(from, to),
        dom = document.createTextNode(node.text);
      return new TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
  }, {
    key: "markDirty",
    value: function markDirty(from, to) {
      _get(_getPrototypeOf(TextViewDesc.prototype), "markDirty", this).call(this, from, to);
      if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = NODE_DIRTY;
    }
  }, {
    key: "domAtom",
    get: function get() {
      return false;
    }
  }, {
    key: "isText",
    value: function isText(text) {
      return this.node.text == text;
    }
  }]);
  return TextViewDesc;
}(NodeViewDesc);
var TrailingHackViewDesc = function (_ViewDesc5) {
  _inherits(TrailingHackViewDesc, _ViewDesc5);
  var _super6 = _createSuper(TrailingHackViewDesc);
  function TrailingHackViewDesc() {
    _classCallCheck(this, TrailingHackViewDesc);
    return _super6.apply(this, arguments);
  }
  _createClass(TrailingHackViewDesc, [{
    key: "parseRule",
    value: function parseRule() {
      return {
        ignore: true
      };
    }
  }, {
    key: "matchesHack",
    value: function matchesHack(nodeName) {
      return this.dirty == NOT_DIRTY && this.dom.nodeName == nodeName;
    }
  }, {
    key: "domAtom",
    get: function get() {
      return true;
    }
  }, {
    key: "ignoreForCoords",
    get: function get() {
      return this.dom.nodeName == "IMG";
    }
  }]);
  return TrailingHackViewDesc;
}(ViewDesc);
var CustomNodeViewDesc = function (_NodeViewDesc2) {
  _inherits(CustomNodeViewDesc, _NodeViewDesc2);
  var _super7 = _createSuper(CustomNodeViewDesc);
  function CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos) {
    var _this7;
    _classCallCheck(this, CustomNodeViewDesc);
    _this7 = _super7.call(this, parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
    _this7.spec = spec;
    return _this7;
  }
  _createClass(CustomNodeViewDesc, [{
    key: "update",
    value: function update(node, outerDeco, innerDeco, view) {
      if (this.dirty == NODE_DIRTY) return false;
      if (this.spec.update && (this.node.type == node.type || this.spec.multiType)) {
        var result = this.spec.update(node, outerDeco, innerDeco);
        if (result) this.updateInner(node, outerDeco, innerDeco, view);
        return result;
      } else if (!this.contentDOM && !node.isLeaf) {
        return false;
      } else {
        return _get(_getPrototypeOf(CustomNodeViewDesc.prototype), "update", this).call(this, node, outerDeco, innerDeco, view);
      }
    }
  }, {
    key: "selectNode",
    value: function selectNode() {
      this.spec.selectNode ? this.spec.selectNode() : _get(_getPrototypeOf(CustomNodeViewDesc.prototype), "selectNode", this).call(this);
    }
  }, {
    key: "deselectNode",
    value: function deselectNode() {
      this.spec.deselectNode ? this.spec.deselectNode() : _get(_getPrototypeOf(CustomNodeViewDesc.prototype), "deselectNode", this).call(this);
    }
  }, {
    key: "setSelection",
    value: function setSelection(anchor, head, view, force) {
      this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root) : _get(_getPrototypeOf(CustomNodeViewDesc.prototype), "setSelection", this).call(this, anchor, head, view, force);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.spec.destroy) this.spec.destroy();
      _get(_getPrototypeOf(CustomNodeViewDesc.prototype), "destroy", this).call(this);
    }
  }, {
    key: "stopEvent",
    value: function stopEvent(event) {
      return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
  }, {
    key: "ignoreMutation",
    value: function ignoreMutation(mutation) {
      return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : _get(_getPrototypeOf(CustomNodeViewDesc.prototype), "ignoreMutation", this).call(this, mutation);
    }
  }]);
  return CustomNodeViewDesc;
}(NodeViewDesc);
function renderDescs(parentDOM, descs, view) {
  var dom = parentDOM.firstChild,
    written = false;
  for (var i = 0; i < descs.length; i++) {
    var desc = descs[i],
      childDOM = desc.dom;
    if (childDOM.parentNode == parentDOM) {
      while (childDOM != dom) {
        dom = rm(dom);
        written = true;
      }
      dom = dom.nextSibling;
    } else {
      written = true;
      parentDOM.insertBefore(childDOM, dom);
    }
    if (desc instanceof MarkViewDesc) {
      var pos = dom ? dom.previousSibling : parentDOM.lastChild;
      renderDescs(desc.contentDOM, desc.children, view);
      dom = pos ? pos.nextSibling : parentDOM.firstChild;
    }
  }
  while (dom) {
    dom = rm(dom);
    written = true;
  }
  if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
var OuterDecoLevel = function OuterDecoLevel(nodeName) {
  if (nodeName) this.nodeName = nodeName;
};
OuterDecoLevel.prototype = Object.create(null);
var noDeco = [new OuterDecoLevel()];
function computeOuterDeco(outerDeco, node, needsWrap) {
  if (outerDeco.length == 0) return noDeco;
  var top = needsWrap ? noDeco[0] : new OuterDecoLevel(),
    result = [top];
  for (var i = 0; i < outerDeco.length; i++) {
    var attrs = outerDeco[i].type.attrs;
    if (!attrs) continue;
    if (attrs.nodeName) result.push(top = new OuterDecoLevel(attrs.nodeName));
    for (var name in attrs) {
      var val = attrs[name];
      if (val == null) continue;
      if (needsWrap && result.length == 1) result.push(top = new OuterDecoLevel(node.isInline ? "span" : "div"));
      if (name == "class") top["class"] = (top["class"] ? top["class"] + " " : "") + val;else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;else if (name != "nodeName") top[name] = val;
    }
  }
  return result;
}
function patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
  if (prevComputed == noDeco && curComputed == noDeco) return nodeDOM;
  var curDOM = nodeDOM;
  for (var i = 0; i < curComputed.length; i++) {
    var deco = curComputed[i],
      prev = prevComputed[i];
    if (i) {
      var parent = void 0;
      if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) {
        curDOM = parent;
      } else {
        parent = document.createElement(deco.nodeName);
        parent.pmIsDeco = true;
        parent.appendChild(curDOM);
        prev = noDeco[0];
        curDOM = parent;
      }
    }
    patchAttributes(curDOM, prev || noDeco[0], deco);
  }
  return curDOM;
}
function patchAttributes(dom, prev, cur) {
  for (var name in prev) if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
  for (var _name in cur) if (_name != "class" && _name != "style" && _name != "nodeName" && cur[_name] != prev[_name]) dom.setAttribute(_name, cur[_name]);
  if (prev["class"] != cur["class"]) {
    var prevList = prev["class"] ? prev["class"].split(" ").filter(Boolean) : [];
    var curList = cur["class"] ? cur["class"].split(" ").filter(Boolean) : [];
    for (var i = 0; i < prevList.length; i++) if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
    for (var _i2 = 0; _i2 < curList.length; _i2++) if (prevList.indexOf(curList[_i2]) == -1) dom.classList.add(curList[_i2]);
    if (dom.classList.length == 0) dom.removeAttribute("class");
  }
  if (prev.style != cur.style) {
    if (prev.style) {
      var prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g,
        m;
      while (m = prop.exec(prev.style)) dom.style.removeProperty(m[1]);
    }
    if (cur.style) dom.style.cssText += cur.style;
  }
}
function applyOuterDeco(dom, deco, node) {
  return patchOuterDeco(dom, dom, noDeco, computeOuterDeco(deco, node, dom.nodeType != 1));
}
function sameOuterDeco(a, b) {
  if (a.length != b.length) return false;
  for (var i = 0; i < a.length; i++) if (!a[i].type.eq(b[i].type)) return false;
  return true;
}
function rm(dom) {
  var next = dom.nextSibling;
  dom.parentNode.removeChild(dom);
  return next;
}
var ViewTreeUpdater = function () {
  function ViewTreeUpdater(top, lock, view) {
    _classCallCheck(this, ViewTreeUpdater);
    this.lock = lock;
    this.view = view;
    this.index = 0;
    this.stack = [];
    this.changed = false;
    this.top = top;
    this.preMatch = preMatch(top.node.content, top);
  }
  _createClass(ViewTreeUpdater, [{
    key: "destroyBetween",
    value: function destroyBetween(start, end) {
      if (start == end) return;
      for (var i = start; i < end; i++) this.top.children[i].destroy();
      this.top.children.splice(start, end - start);
      this.changed = true;
    }
  }, {
    key: "destroyRest",
    value: function destroyRest() {
      this.destroyBetween(this.index, this.top.children.length);
    }
  }, {
    key: "syncToMarks",
    value: function syncToMarks(marks, inline, view) {
      var keep = 0,
        depth = this.stack.length >> 1;
      var maxKeep = Math.min(depth, marks.length);
      while (keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false) keep++;
      while (keep < depth) {
        this.destroyRest();
        this.top.dirty = NOT_DIRTY;
        this.index = this.stack.pop();
        this.top = this.stack.pop();
        depth--;
      }
      while (depth < marks.length) {
        this.stack.push(this.top, this.index + 1);
        var found = -1;
        for (var i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++) {
          var next = this.top.children[i];
          if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
            found = i;
            break;
          }
        }
        if (found > -1) {
          if (found > this.index) {
            this.changed = true;
            this.destroyBetween(this.index, found);
          }
          this.top = this.top.children[this.index];
        } else {
          var markDesc = MarkViewDesc.create(this.top, marks[depth], inline, view);
          this.top.children.splice(this.index, 0, markDesc);
          this.top = markDesc;
          this.changed = true;
        }
        this.index = 0;
        depth++;
      }
    }
  }, {
    key: "findNodeMatch",
    value: function findNodeMatch(node, outerDeco, innerDeco, index) {
      var found = -1,
        targetDesc;
      if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) {
        found = this.top.children.indexOf(targetDesc, this.index);
      } else {
        for (var i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++) {
          var child = this.top.children[i];
          if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
            found = i;
            break;
          }
        }
      }
      if (found < 0) return false;
      this.destroyBetween(this.index, found);
      this.index++;
      return true;
    }
  }, {
    key: "updateNodeAt",
    value: function updateNodeAt(node, outerDeco, innerDeco, index, view) {
      var child = this.top.children[index];
      if (child.dirty == NODE_DIRTY && child.dom == child.contentDOM) child.dirty = CONTENT_DIRTY;
      if (!child.update(node, outerDeco, innerDeco, view)) return false;
      this.destroyBetween(this.index, index);
      this.index++;
      return true;
    }
  }, {
    key: "findIndexWithChild",
    value: function findIndexWithChild(domNode) {
      for (;;) {
        var parent = domNode.parentNode;
        if (!parent) return -1;
        if (parent == this.top.contentDOM) {
          var desc = domNode.pmViewDesc;
          if (desc) for (var i = this.index; i < this.top.children.length; i++) {
            if (this.top.children[i] == desc) return i;
          }
          return -1;
        }
        domNode = parent;
      }
    }
  }, {
    key: "updateNextNode",
    value: function updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
      for (var i = this.index; i < this.top.children.length; i++) {
        var next = this.top.children[i];
        if (next instanceof NodeViewDesc) {
          var _preMatch = this.preMatch.matched.get(next);
          if (_preMatch != null && _preMatch != index) return false;
          var nextDOM = next.dom,
            updated = void 0;
          var locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != NODE_DIRTY && sameOuterDeco(outerDeco, next.outerDeco));
          if (!locked && next.update(node, outerDeco, innerDeco, view)) {
            this.destroyBetween(this.index, i);
            if (next.dom != nextDOM) this.changed = true;
            this.index++;
            return true;
          } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
            this.destroyBetween(this.index, i);
            this.top.children[this.index] = updated;
            if (updated.contentDOM) {
              updated.dirty = CONTENT_DIRTY;
              updated.updateChildren(view, pos + 1);
              updated.dirty = NOT_DIRTY;
            }
            this.changed = true;
            this.index++;
            return true;
          }
          break;
        }
      }
      return false;
    }
  }, {
    key: "recreateWrapper",
    value: function recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
      if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content) || !sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco)) return null;
      var wrapper = NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
      if (wrapper.contentDOM) {
        wrapper.children = next.children;
        next.children = [];
        var _iterator = _createForOfIteratorHelper(wrapper.children),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var ch = _step.value;
            ch.parent = wrapper;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      next.destroy();
      return wrapper;
    }
  }, {
    key: "addNode",
    value: function addNode(node, outerDeco, innerDeco, view, pos) {
      var desc = NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
      if (desc.contentDOM) desc.updateChildren(view, pos + 1);
      this.top.children.splice(this.index++, 0, desc);
      this.changed = true;
    }
  }, {
    key: "placeWidget",
    value: function placeWidget(widget, view, pos) {
      var next = this.index < this.top.children.length ? this.top.children[this.index] : null;
      if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) {
        this.index++;
      } else {
        var desc = new WidgetViewDesc(this.top, widget, view, pos);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
      }
    }
  }, {
    key: "addTextblockHacks",
    value: function addTextblockHacks() {
      var lastChild = this.top.children[this.index - 1],
        parent = this.top;
      while (lastChild instanceof MarkViewDesc) {
        parent = lastChild;
        lastChild = parent.children[parent.children.length - 1];
      }
      if (!lastChild || !(lastChild instanceof TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
        if ((safari || chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
        this.addHackNode("BR", this.top);
      }
    }
  }, {
    key: "addHackNode",
    value: function addHackNode(nodeName, parent) {
      if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) {
        this.index++;
      } else {
        var dom = document.createElement(nodeName);
        if (nodeName == "IMG") {
          dom.className = "ProseMirror-separator";
          dom.alt = "";
        }
        if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
        var hack = new TrailingHackViewDesc(this.top, [], dom, null);
        if (parent != this.top) parent.children.push(hack);else parent.children.splice(this.index++, 0, hack);
        this.changed = true;
      }
    }
  }, {
    key: "isLocked",
    value: function isLocked(node) {
      return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
  }]);
  return ViewTreeUpdater;
}();
function preMatch(frag, parentDesc) {
  var curDesc = parentDesc,
    descI = curDesc.children.length;
  var fI = frag.childCount,
    matched = new Map(),
    matches = [];
  outer: while (fI > 0) {
    var desc = void 0;
    for (;;) {
      if (descI) {
        var next = curDesc.children[descI - 1];
        if (next instanceof MarkViewDesc) {
          curDesc = next;
          descI = next.children.length;
        } else {
          desc = next;
          descI--;
          break;
        }
      } else if (curDesc == parentDesc) {
        break outer;
      } else {
        descI = curDesc.parent.children.indexOf(curDesc);
        curDesc = curDesc.parent;
      }
    }
    var node = desc.node;
    if (!node) continue;
    if (node != frag.child(fI - 1)) break;
    --fI;
    matched.set(desc, fI);
    matches.push(desc);
  }
  return {
    index: fI,
    matched: matched,
    matches: matches.reverse()
  };
}
function compareSide(a, b) {
  return a.type.side - b.type.side;
}
function iterDeco(parent, deco, onWidget, onNode) {
  var locals = deco.locals(parent),
    offset = 0;
  if (locals.length == 0) {
    for (var i = 0; i < parent.childCount; i++) {
      var child = parent.child(i);
      onNode(child, locals, deco.forChild(offset, child), i);
      offset += child.nodeSize;
    }
    return;
  }
  var decoIndex = 0,
    active = [],
    restNode = null;
  for (var parentIndex = 0;;) {
    var widget = void 0,
      widgets = void 0;
    while (decoIndex < locals.length && locals[decoIndex].to == offset) {
      var next = locals[decoIndex++];
      if (next.widget) {
        if (!widget) widget = next;else (widgets || (widgets = [widget])).push(next);
      }
    }
    if (widget) {
      if (widgets) {
        widgets.sort(compareSide);
        for (var _i3 = 0; _i3 < widgets.length; _i3++) onWidget(widgets[_i3], parentIndex, !!restNode);
      } else {
        onWidget(widget, parentIndex, !!restNode);
      }
    }
    var _child = void 0,
      index = void 0;
    if (restNode) {
      index = -1;
      _child = restNode;
      restNode = null;
    } else if (parentIndex < parent.childCount) {
      index = parentIndex;
      _child = parent.child(parentIndex++);
    } else {
      break;
    }
    for (var _i4 = 0; _i4 < active.length; _i4++) if (active[_i4].to <= offset) active.splice(_i4--, 1);
    while (decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset) active.push(locals[decoIndex++]);
    var end = offset + _child.nodeSize;
    if (_child.isText) {
      var cutAt = end;
      if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
      for (var _i5 = 0; _i5 < active.length; _i5++) if (active[_i5].to < cutAt) cutAt = active[_i5].to;
      if (cutAt < end) {
        restNode = _child.cut(cutAt - offset);
        _child = _child.cut(0, cutAt - offset);
        end = cutAt;
        index = -1;
      }
    } else {
      while (decoIndex < locals.length && locals[decoIndex].to < end) decoIndex++;
    }
    var outerDeco = _child.isInline && !_child.isLeaf ? active.filter(function (d) {
      return !d.inline;
    }) : active.slice();
    onNode(_child, outerDeco, deco.forChild(offset, _child), index);
    offset = end;
  }
}
function iosHacks(dom) {
  if (dom.nodeName == "UL" || dom.nodeName == "OL") {
    var oldCSS = dom.style.cssText;
    dom.style.cssText = oldCSS + "; list-style: square !important";
    window.getComputedStyle(dom).listStyle;
    dom.style.cssText = oldCSS;
  }
}
function findTextInFragment(frag, text, from, to) {
  for (var i = 0, pos = 0; i < frag.childCount && pos <= to;) {
    var child = frag.child(i++),
      childStart = pos;
    pos += child.nodeSize;
    if (!child.isText) continue;
    var str = child.text;
    while (i < frag.childCount) {
      var next = frag.child(i++);
      pos += next.nodeSize;
      if (!next.isText) break;
      str += next.text;
    }
    if (pos >= from) {
      if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
      var found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
      if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
      if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
    }
  }
  return -1;
}
function replaceNodes(nodes, from, to, view, replacement) {
  var result = [];
  for (var i = 0, off = 0; i < nodes.length; i++) {
    var child = nodes[i],
      start = off,
      end = off += child.size;
    if (start >= to || end <= from) {
      result.push(child);
    } else {
      if (start < from) result.push(child.slice(0, from - start, view));
      if (replacement) {
        result.push(replacement);
        replacement = undefined;
      }
      if (end > to) result.push(child.slice(to - start, child.size, view));
    }
  }
  return result;
}
function selectionFromDOM(view) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var domSel = view.domSelectionRange(),
    doc = view.state.doc;
  if (!domSel.focusNode) return null;
  var nearestDesc = view.docView.nearestDesc(domSel.focusNode),
    inWidget = nearestDesc && nearestDesc.size == 0;
  var head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
  if (head < 0) return null;
  var $head = doc.resolve(head),
    anchor,
    selection;
  if (selectionCollapsed(domSel)) {
    anchor = head;
    while (nearestDesc && !nearestDesc.node) nearestDesc = nearestDesc.parent;
    var nearestDescNode = nearestDesc.node;
    if (nearestDesc && nearestDescNode.isAtom && prosemirrorState.NodeSelection.isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
      var pos = nearestDesc.posBefore;
      selection = new prosemirrorState.NodeSelection(head == pos ? $head : doc.resolve(pos));
    }
  } else {
    if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
      var min = head,
        max = head;
      for (var i = 0; i < domSel.rangeCount; i++) {
        var range = domSel.getRangeAt(i);
        min = Math.min(min, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
        max = Math.max(max, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
      }
      if (min < 0) return null;
      var _ref3 = max == view.state.selection.anchor ? [max, min] : [min, max];
      var _ref4 = _slicedToArray(_ref3, 2);
      anchor = _ref4[0];
      head = _ref4[1];
      $head = doc.resolve(head);
    } else {
      anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
    }
    if (anchor < 0) return null;
  }
  var $anchor = doc.resolve(anchor);
  if (!selection) {
    var bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
    selection = selectionBetween(view, $anchor, $head, bias);
  }
  return selection;
}
function editorOwnsSelection(view) {
  return view.editable ? view.hasFocus() : hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function selectionToDOM(view) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var sel = view.state.selection;
  syncNodeSelection(view, sel);
  if (!editorOwnsSelection(view)) return;
  if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && chrome) {
    var domSel = view.domSelectionRange(),
      curSel = view.domObserver.currentSelection;
    if (domSel.anchorNode && curSel.anchorNode && isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
      view.input.mouseDown.delayedSelectionSync = true;
      view.domObserver.setCurSelection();
      return;
    }
  }
  view.domObserver.disconnectSelection();
  if (view.cursorWrapper) {
    selectCursorWrapper(view);
  } else {
    var anchor = sel.anchor,
      head = sel.head,
      resetEditableFrom,
      resetEditableTo;
    if (brokenSelectBetweenUneditable && !(sel instanceof prosemirrorState.TextSelection)) {
      if (!sel.$from.parent.inlineContent) resetEditableFrom = temporarilyEditableNear(view, sel.from);
      if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = temporarilyEditableNear(view, sel.to);
    }
    view.docView.setSelection(anchor, head, view, force);
    if (brokenSelectBetweenUneditable) {
      if (resetEditableFrom) resetEditable(resetEditableFrom);
      if (resetEditableTo) resetEditable(resetEditableTo);
    }
    if (sel.visible) {
      view.dom.classList.remove("ProseMirror-hideselection");
    } else {
      view.dom.classList.add("ProseMirror-hideselection");
      if ("onselectionchange" in document) removeClassOnSelectionChange(view);
    }
  }
  view.domObserver.setCurSelection();
  view.domObserver.connectSelection();
}
var brokenSelectBetweenUneditable = safari || chrome && chrome_version < 63;
function temporarilyEditableNear(view, pos) {
  var _view$docView$domFrom3 = view.docView.domFromPos(pos, 0),
    node = _view$docView$domFrom3.node,
    offset = _view$docView$domFrom3.offset;
  var after = offset < node.childNodes.length ? node.childNodes[offset] : null;
  var before = offset ? node.childNodes[offset - 1] : null;
  if (safari && after && after.contentEditable == "false") return setEditable(after);
  if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
    if (after) return setEditable(after);else if (before) return setEditable(before);
  }
}
function setEditable(element) {
  element.contentEditable = "true";
  if (safari && element.draggable) {
    element.draggable = false;
    element.wasDraggable = true;
  }
  return element;
}
function resetEditable(element) {
  element.contentEditable = "false";
  if (element.wasDraggable) {
    element.draggable = true;
    element.wasDraggable = null;
  }
}
function removeClassOnSelectionChange(view) {
  var doc = view.dom.ownerDocument;
  doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
  var domSel = view.domSelectionRange();
  var node = domSel.anchorNode,
    offset = domSel.anchorOffset;
  doc.addEventListener("selectionchange", view.input.hideSelectionGuard = function () {
    if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
      doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
      setTimeout(function () {
        if (!editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
      }, 20);
    }
  });
}
function selectCursorWrapper(view) {
  var domSel = view.domSelection(),
    range = document.createRange();
  if (!domSel) return;
  var node = view.cursorWrapper.dom,
    img = node.nodeName == "IMG";
  if (img) range.setStart(node.parentNode, domIndex(node) + 1);else range.setStart(node, 0);
  range.collapse(true);
  domSel.removeAllRanges();
  domSel.addRange(range);
  if (!img && !view.state.selection.visible && ie && ie_version <= 11) {
    node.disabled = true;
    node.disabled = false;
  }
}
function syncNodeSelection(view, sel) {
  if (sel instanceof prosemirrorState.NodeSelection) {
    var desc = view.docView.descAt(sel.from);
    if (desc != view.lastSelectedViewDesc) {
      clearNodeSelection(view);
      if (desc) desc.selectNode();
      view.lastSelectedViewDesc = desc;
    }
  } else {
    clearNodeSelection(view);
  }
}
function clearNodeSelection(view) {
  if (view.lastSelectedViewDesc) {
    if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
    view.lastSelectedViewDesc = undefined;
  }
}
function selectionBetween(view, $anchor, $head, bias) {
  return view.someProp("createSelectionBetween", function (f) {
    return f(view, $anchor, $head);
  }) || prosemirrorState.TextSelection.between($anchor, $head, bias);
}
function hasFocusAndSelection(view) {
  if (view.editable && !view.hasFocus()) return false;
  return hasSelection(view);
}
function hasSelection(view) {
  var sel = view.domSelectionRange();
  if (!sel.anchorNode) return false;
  try {
    return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
  } catch (_) {
    return false;
  }
}
function anchorInRightPlace(view) {
  var anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
  var domSel = view.domSelectionRange();
  return isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function moveSelectionBlock(state, dir) {
  var _state$selection = state.selection,
    $anchor = _state$selection.$anchor,
    $head = _state$selection.$head;
  var $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
  var $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
  return $start && prosemirrorState.Selection.findFrom($start, dir);
}
function apply(view, sel) {
  view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
  return true;
}
function selectHorizontally(view, dir, mods) {
  var sel = view.state.selection;
  if (sel instanceof prosemirrorState.TextSelection) {
    if (mods.indexOf("s") > -1) {
      var $head = sel.$head,
        node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
      if (!node || node.isText || !node.isLeaf) return false;
      var $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
      return apply(view, new prosemirrorState.TextSelection(sel.$anchor, $newHead));
    } else if (!sel.empty) {
      return false;
    } else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
      var next = moveSelectionBlock(view.state, dir);
      if (next && next instanceof prosemirrorState.NodeSelection) return apply(view, next);
      return false;
    } else if (!(mac && mods.indexOf("m") > -1)) {
      var _$head = sel.$head,
        _node = _$head.textOffset ? null : dir < 0 ? _$head.nodeBefore : _$head.nodeAfter,
        desc;
      if (!_node || _node.isText) return false;
      var nodePos = dir < 0 ? _$head.pos - _node.nodeSize : _$head.pos;
      if (!(_node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
      if (prosemirrorState.NodeSelection.isSelectable(_node)) {
        return apply(view, new prosemirrorState.NodeSelection(dir < 0 ? view.state.doc.resolve(_$head.pos - _node.nodeSize) : _$head));
      } else if (webkit) {
        return apply(view, new prosemirrorState.TextSelection(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + _node.nodeSize)));
      } else {
        return false;
      }
    }
  } else if (sel instanceof prosemirrorState.NodeSelection && sel.node.isInline) {
    return apply(view, new prosemirrorState.TextSelection(dir > 0 ? sel.$to : sel.$from));
  } else {
    var _next = moveSelectionBlock(view.state, dir);
    if (_next) return apply(view, _next);
    return false;
  }
}
function nodeLen(node) {
  return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function isIgnorable(dom, dir) {
  var desc = dom.pmViewDesc;
  return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function skipIgnoredNodes(view, dir) {
  return dir < 0 ? skipIgnoredNodesBefore(view) : skipIgnoredNodesAfter(view);
}
function skipIgnoredNodesBefore(view) {
  var sel = view.domSelectionRange();
  var node = sel.focusNode,
    offset = sel.focusOffset;
  if (!node) return;
  var moveNode,
    moveOffset,
    force = false;
  if (gecko && node.nodeType == 1 && offset < nodeLen(node) && isIgnorable(node.childNodes[offset], -1)) force = true;
  for (;;) {
    if (offset > 0) {
      if (node.nodeType != 1) {
        break;
      } else {
        var before = node.childNodes[offset - 1];
        if (isIgnorable(before, -1)) {
          moveNode = node;
          moveOffset = --offset;
        } else if (before.nodeType == 3) {
          node = before;
          offset = node.nodeValue.length;
        } else break;
      }
    } else if (isBlockNode(node)) {
      break;
    } else {
      var prev = node.previousSibling;
      while (prev && isIgnorable(prev, -1)) {
        moveNode = node.parentNode;
        moveOffset = domIndex(prev);
        prev = prev.previousSibling;
      }
      if (!prev) {
        node = node.parentNode;
        if (node == view.dom) break;
        offset = 0;
      } else {
        node = prev;
        offset = nodeLen(node);
      }
    }
  }
  if (force) setSelFocus(view, node, offset);else if (moveNode) setSelFocus(view, moveNode, moveOffset);
}
function skipIgnoredNodesAfter(view) {
  var sel = view.domSelectionRange();
  var node = sel.focusNode,
    offset = sel.focusOffset;
  if (!node) return;
  var len = nodeLen(node);
  var moveNode, moveOffset;
  for (;;) {
    if (offset < len) {
      if (node.nodeType != 1) break;
      var after = node.childNodes[offset];
      if (isIgnorable(after, 1)) {
        moveNode = node;
        moveOffset = ++offset;
      } else break;
    } else if (isBlockNode(node)) {
      break;
    } else {
      var next = node.nextSibling;
      while (next && isIgnorable(next, 1)) {
        moveNode = next.parentNode;
        moveOffset = domIndex(next) + 1;
        next = next.nextSibling;
      }
      if (!next) {
        node = node.parentNode;
        if (node == view.dom) break;
        offset = len = 0;
      } else {
        node = next;
        offset = 0;
        len = nodeLen(node);
      }
    }
  }
  if (moveNode) setSelFocus(view, moveNode, moveOffset);
}
function isBlockNode(dom) {
  var desc = dom.pmViewDesc;
  return desc && desc.node && desc.node.isBlock;
}
function textNodeAfter(node, offset) {
  while (node && offset == node.childNodes.length && !hasBlockDesc(node)) {
    offset = domIndex(node) + 1;
    node = node.parentNode;
  }
  while (node && offset < node.childNodes.length) {
    var next = node.childNodes[offset];
    if (next.nodeType == 3) return next;
    if (next.nodeType == 1 && next.contentEditable == "false") break;
    node = next;
    offset = 0;
  }
}
function textNodeBefore(node, offset) {
  while (node && !offset && !hasBlockDesc(node)) {
    offset = domIndex(node);
    node = node.parentNode;
  }
  while (node && offset) {
    var next = node.childNodes[offset - 1];
    if (next.nodeType == 3) return next;
    if (next.nodeType == 1 && next.contentEditable == "false") break;
    node = next;
    offset = node.childNodes.length;
  }
}
function setSelFocus(view, node, offset) {
  if (node.nodeType != 3) {
    var before, after;
    if (after = textNodeAfter(node, offset)) {
      node = after;
      offset = 0;
    } else if (before = textNodeBefore(node, offset)) {
      node = before;
      offset = before.nodeValue.length;
    }
  }
  var sel = view.domSelection();
  if (!sel) return;
  if (selectionCollapsed(sel)) {
    var range = document.createRange();
    range.setEnd(node, offset);
    range.setStart(node, offset);
    sel.removeAllRanges();
    sel.addRange(range);
  } else if (sel.extend) {
    sel.extend(node, offset);
  }
  view.domObserver.setCurSelection();
  var state = view.state;
  setTimeout(function () {
    if (view.state == state) selectionToDOM(view);
  }, 50);
}
function findDirection(view, pos) {
  var $pos = view.state.doc.resolve(pos);
  if (!(chrome || windows) && $pos.parent.inlineContent) {
    var coords = view.coordsAtPos(pos);
    if (pos > $pos.start()) {
      var before = view.coordsAtPos(pos - 1);
      var mid = (before.top + before.bottom) / 2;
      if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
    }
    if (pos < $pos.end()) {
      var after = view.coordsAtPos(pos + 1);
      var _mid = (after.top + after.bottom) / 2;
      if (_mid > coords.top && _mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
    }
  }
  var computed = getComputedStyle(view.dom).direction;
  return computed == "rtl" ? "rtl" : "ltr";
}
function selectVertically(view, dir, mods) {
  var sel = view.state.selection;
  if (sel instanceof prosemirrorState.TextSelection && !sel.empty || mods.indexOf("s") > -1) return false;
  if (mac && mods.indexOf("m") > -1) return false;
  var $from = sel.$from,
    $to = sel.$to;
  if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
    var next = moveSelectionBlock(view.state, dir);
    if (next && next instanceof prosemirrorState.NodeSelection) return apply(view, next);
  }
  if (!$from.parent.inlineContent) {
    var side = dir < 0 ? $from : $to;
    var beyond = sel instanceof prosemirrorState.AllSelection ? prosemirrorState.Selection.near(side, dir) : prosemirrorState.Selection.findFrom(side, dir);
    return beyond ? apply(view, beyond) : false;
  }
  return false;
}
function stopNativeHorizontalDelete(view, dir) {
  if (!(view.state.selection instanceof prosemirrorState.TextSelection)) return true;
  var _view$state$selection2 = view.state.selection,
    $head = _view$state$selection2.$head,
    $anchor = _view$state$selection2.$anchor,
    empty = _view$state$selection2.empty;
  if (!$head.sameParent($anchor)) return true;
  if (!empty) return false;
  if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
  var nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
  if (nextNode && !nextNode.isText) {
    var tr = view.state.tr;
    if (dir < 0) tr["delete"]($head.pos - nextNode.nodeSize, $head.pos);else tr["delete"]($head.pos, $head.pos + nextNode.nodeSize);
    view.dispatch(tr);
    return true;
  }
  return false;
}
function switchEditable(view, node, state) {
  view.domObserver.stop();
  node.contentEditable = state;
  view.domObserver.start();
}
function safariDownArrowBug(view) {
  if (!safari || view.state.selection.$head.parentOffset > 0) return false;
  var _view$domSelectionRan3 = view.domSelectionRange(),
    focusNode = _view$domSelectionRan3.focusNode,
    focusOffset = _view$domSelectionRan3.focusOffset;
  if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
    var child = focusNode.firstChild;
    switchEditable(view, child, "true");
    setTimeout(function () {
      return switchEditable(view, child, "false");
    }, 20);
  }
  return false;
}
function getMods(event) {
  var result = "";
  if (event.ctrlKey) result += "c";
  if (event.metaKey) result += "m";
  if (event.altKey) result += "a";
  if (event.shiftKey) result += "s";
  return result;
}
function captureKeyDown(view, event) {
  var code = event.keyCode,
    mods = getMods(event);
  if (code == 8 || mac && code == 72 && mods == "c") {
    return stopNativeHorizontalDelete(view, -1) || skipIgnoredNodes(view, -1);
  } else if (code == 46 && !event.shiftKey || mac && code == 68 && mods == "c") {
    return stopNativeHorizontalDelete(view, 1) || skipIgnoredNodes(view, 1);
  } else if (code == 13 || code == 27) {
    return true;
  } else if (code == 37 || mac && code == 66 && mods == "c") {
    var dir = code == 37 ? findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return selectHorizontally(view, dir, mods) || skipIgnoredNodes(view, dir);
  } else if (code == 39 || mac && code == 70 && mods == "c") {
    var _dir = code == 39 ? findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return selectHorizontally(view, _dir, mods) || skipIgnoredNodes(view, _dir);
  } else if (code == 38 || mac && code == 80 && mods == "c") {
    return selectVertically(view, -1, mods) || skipIgnoredNodes(view, -1);
  } else if (code == 40 || mac && code == 78 && mods == "c") {
    return safariDownArrowBug(view) || selectVertically(view, 1, mods) || skipIgnoredNodes(view, 1);
  } else if (mods == (mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) {
    return true;
  }
  return false;
}
function _serializeForClipboard(view, slice) {
  view.someProp("transformCopied", function (f) {
    slice = f(slice, view);
  });
  var context = [],
    _slice = slice,
    content = _slice.content,
    openStart = _slice.openStart,
    openEnd = _slice.openEnd;
  while (openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1) {
    openStart--;
    openEnd--;
    var node = content.firstChild;
    context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
    content = node.content;
  }
  var serializer = view.someProp("clipboardSerializer") || prosemirrorModel.DOMSerializer.fromSchema(view.state.schema);
  var doc = detachedDoc(),
    wrap = doc.createElement("div");
  wrap.appendChild(serializer.serializeFragment(content, {
    document: doc
  }));
  var firstChild = wrap.firstChild,
    needsWrap,
    wrappers = 0;
  while (firstChild && firstChild.nodeType == 1 && (needsWrap = wrapMap[firstChild.nodeName.toLowerCase()])) {
    for (var i = needsWrap.length - 1; i >= 0; i--) {
      var wrapper = doc.createElement(needsWrap[i]);
      while (wrap.firstChild) wrapper.appendChild(wrap.firstChild);
      wrap.appendChild(wrapper);
      wrappers++;
    }
    firstChild = wrap.firstChild;
  }
  if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", "".concat(openStart, " ").concat(openEnd).concat(wrappers ? " -".concat(wrappers) : "", " ").concat(JSON.stringify(context)));
  var text = view.someProp("clipboardTextSerializer", function (f) {
    return f(slice, view);
  }) || slice.content.textBetween(0, slice.content.size, "\n\n");
  return {
    dom: wrap,
    text: text,
    slice: slice
  };
}
function parseFromClipboard(view, text, html, plainText, $context) {
  var inCode = $context.parent.type.spec.code;
  var dom, slice;
  if (!html && !text) return null;
  var asText = text && (plainText || inCode || !html);
  if (asText) {
    view.someProp("transformPastedText", function (f) {
      text = f(text, inCode || plainText, view);
    });
    if (inCode) return text ? new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0) : prosemirrorModel.Slice.empty;
    var parsed = view.someProp("clipboardTextParser", function (f) {
      return f(text, $context, plainText, view);
    });
    if (parsed) {
      slice = parsed;
    } else {
      var marks = $context.marks();
      var schema = view.state.schema,
        serializer = prosemirrorModel.DOMSerializer.fromSchema(schema);
      dom = document.createElement("div");
      text.split(/(?:\r\n?|\n)+/).forEach(function (block) {
        var p = dom.appendChild(document.createElement("p"));
        if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
      });
    }
  } else {
    view.someProp("transformPastedHTML", function (f) {
      html = f(html, view);
    });
    dom = readHTML(html);
    if (webkit) restoreReplacedSpaces(dom);
  }
  var contextNode = dom && dom.querySelector("[data-pm-slice]");
  var sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
  if (sliceData && sliceData[3]) for (var i = +sliceData[3]; i > 0; i--) {
    var child = dom.firstChild;
    while (child && child.nodeType != 1) child = child.nextSibling;
    if (!child) break;
    dom = child;
  }
  if (!slice) {
    var parser = view.someProp("clipboardParser") || view.someProp("domParser") || prosemirrorModel.DOMParser.fromSchema(view.state.schema);
    slice = parser.parseSlice(dom, {
      preserveWhitespace: !!(asText || sliceData),
      context: $context,
      ruleFromNode: function ruleFromNode(dom) {
        if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !inlineParents.test(dom.parentNode.nodeName)) return {
          ignore: true
        };
        return null;
      }
    });
  }
  if (sliceData) {
    slice = addContext(closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
  } else {
    slice = prosemirrorModel.Slice.maxOpen(normalizeSiblings(slice.content, $context), true);
    if (slice.openStart || slice.openEnd) {
      var openStart = 0,
        openEnd = 0;
      for (var node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild) {}
      for (var _node2 = slice.content.lastChild; openEnd < slice.openEnd && !_node2.type.spec.isolating; openEnd++, _node2 = _node2.lastChild) {}
      slice = closeSlice(slice, openStart, openEnd);
    }
  }
  view.someProp("transformPasted", function (f) {
    slice = f(slice, view);
  });
  return slice;
}
var inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function normalizeSiblings(fragment, $context) {
  if (fragment.childCount < 2) return fragment;
  var _loop = function _loop() {
      var parent = $context.node(d);
      var match = parent.contentMatchAt($context.index(d));
      var lastWrap,
        result = [];
      fragment.forEach(function (node) {
        if (!result) return;
        var wrap = match.findWrapping(node.type),
          inLast;
        if (!wrap) return result = null;
        if (inLast = result.length && lastWrap.length && addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) {
          result[result.length - 1] = inLast;
        } else {
          if (result.length) result[result.length - 1] = closeRight(result[result.length - 1], lastWrap.length);
          var wrapped = withWrappers(node, wrap);
          result.push(wrapped);
          match = match.matchType(wrapped.type);
          lastWrap = wrap;
        }
      });
      if (result) return {
        v: prosemirrorModel.Fragment.from(result)
      };
    },
    _ret;
  for (var d = $context.depth; d >= 0; d--) {
    _ret = _loop();
    if (_ret) return _ret.v;
  }
  return fragment;
}
function withWrappers(node, wrap) {
  var from = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  for (var i = wrap.length - 1; i >= from; i--) node = wrap[i].create(null, prosemirrorModel.Fragment.from(node));
  return node;
}
function addToSibling(wrap, lastWrap, node, sibling, depth) {
  if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
    var inner = addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
    if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
    var match = sibling.contentMatchAt(sibling.childCount);
    if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append(prosemirrorModel.Fragment.from(withWrappers(node, wrap, depth + 1))));
  }
}
function closeRight(node, depth) {
  if (depth == 0) return node;
  var fragment = node.content.replaceChild(node.childCount - 1, closeRight(node.lastChild, depth - 1));
  var fill = node.contentMatchAt(node.childCount).fillBefore(prosemirrorModel.Fragment.empty, true);
  return node.copy(fragment.append(fill));
}
function closeRange(fragment, side, from, to, depth, openEnd) {
  var node = side < 0 ? fragment.firstChild : fragment.lastChild,
    inner = node.content;
  if (fragment.childCount > 1) openEnd = 0;
  if (depth < to - 1) inner = closeRange(inner, side, from, to, depth + 1, openEnd);
  if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore(prosemirrorModel.Fragment.empty, true));
  return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function closeSlice(slice, openStart, openEnd) {
  if (openStart < slice.openStart) slice = new prosemirrorModel.Slice(closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
  if (openEnd < slice.openEnd) slice = new prosemirrorModel.Slice(closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
  return slice;
}
var wrapMap = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
var _detachedDoc = null;
function detachedDoc() {
  return _detachedDoc || (_detachedDoc = document.implementation.createHTMLDocument("title"));
}
var _policy = null;
function maybeWrapTrusted(html) {
  var trustedTypes = window.trustedTypes;
  if (!trustedTypes) return html;
  if (!_policy) _policy = trustedTypes.defaultPolicy || trustedTypes.createPolicy("ProseMirrorClipboard", {
    createHTML: function createHTML(s) {
      return s;
    }
  });
  return _policy.createHTML(html);
}
function readHTML(html) {
  var metas = /^(\s*<meta [^>]*>)*/.exec(html);
  if (metas) html = html.slice(metas[0].length);
  var elt = detachedDoc().createElement("div");
  var firstTag = /<([a-z][^>\s]+)/i.exec(html),
    wrap;
  if (wrap = firstTag && wrapMap[firstTag[1].toLowerCase()]) html = wrap.map(function (n) {
    return "<" + n + ">";
  }).join("") + html + wrap.map(function (n) {
    return "</" + n + ">";
  }).reverse().join("");
  elt.innerHTML = maybeWrapTrusted(html);
  if (wrap) for (var i = 0; i < wrap.length; i++) elt = elt.querySelector(wrap[i]) || elt;
  return elt;
}
function restoreReplacedSpaces(dom) {
  var nodes = dom.querySelectorAll(chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (var i = 0; i < nodes.length; i++) {
    var node = nodes[i];
    if (node.childNodes.length == 1 && node.textContent == "\xA0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
  }
}
function addContext(slice, context) {
  if (!slice.size) return slice;
  var schema = slice.content.firstChild.type.schema,
    array;
  try {
    array = JSON.parse(context);
  } catch (e) {
    return slice;
  }
  var content = slice.content,
    openStart = slice.openStart,
    openEnd = slice.openEnd;
  for (var i = array.length - 2; i >= 0; i -= 2) {
    var type = schema.nodes[array[i]];
    if (!type || type.hasRequiredAttrs()) break;
    content = prosemirrorModel.Fragment.from(type.create(array[i + 1], content));
    openStart++;
    openEnd++;
  }
  return new prosemirrorModel.Slice(content, openStart, openEnd);
}
var handlers = {};
var editHandlers = {};
var passiveHandlers = {
  touchstart: true,
  touchmove: true
};
var InputState = _createClass(function InputState() {
  _classCallCheck(this, InputState);
  this.shiftKey = false;
  this.mouseDown = null;
  this.lastKeyCode = null;
  this.lastKeyCodeTime = 0;
  this.lastClick = {
    time: 0,
    x: 0,
    y: 0,
    type: "",
    button: 0
  };
  this.lastSelectionOrigin = null;
  this.lastSelectionTime = 0;
  this.lastIOSEnter = 0;
  this.lastIOSEnterFallbackTimeout = -1;
  this.lastFocus = 0;
  this.lastTouch = 0;
  this.lastChromeDelete = 0;
  this.composing = false;
  this.compositionNode = null;
  this.composingTimeout = -1;
  this.compositionNodes = [];
  this.compositionEndedAt = -2e8;
  this.compositionID = 1;
  this.compositionPendingChanges = 0;
  this.domChangeCount = 0;
  this.eventHandlers = Object.create(null);
  this.hideSelectionGuard = null;
});
function initInput(view) {
  var _loop2 = function _loop2() {
    var handler = handlers[event];
    view.dom.addEventListener(event, view.input.eventHandlers[event] = function (event) {
      if (eventBelongsToView(view, event) && !runCustomHandler(view, event) && (view.editable || !(event.type in editHandlers))) handler(view, event);
    }, passiveHandlers[event] ? {
      passive: true
    } : undefined);
  };
  for (var event in handlers) {
    _loop2();
  }
  if (safari) view.dom.addEventListener("input", function () {
    return null;
  });
  ensureListeners(view);
}
function setSelectionOrigin(view, origin) {
  view.input.lastSelectionOrigin = origin;
  view.input.lastSelectionTime = Date.now();
}
function destroyInput(view) {
  view.domObserver.stop();
  for (var type in view.input.eventHandlers) view.dom.removeEventListener(type, view.input.eventHandlers[type]);
  clearTimeout(view.input.composingTimeout);
  clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function ensureListeners(view) {
  view.someProp("handleDOMEvents", function (currentHandlers) {
    for (var type in currentHandlers) if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = function (event) {
      return runCustomHandler(view, event);
    });
  });
}
function runCustomHandler(view, event) {
  return view.someProp("handleDOMEvents", function (handlers) {
    var handler = handlers[event.type];
    return handler ? handler(view, event) || event.defaultPrevented : false;
  });
}
function eventBelongsToView(view, event) {
  if (!event.bubbles) return true;
  if (event.defaultPrevented) return false;
  for (var node = event.target; node != view.dom; node = node.parentNode) if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
  return true;
}
function _dispatchEvent(view, event) {
  if (!runCustomHandler(view, event) && handlers[event.type] && (view.editable || !(event.type in editHandlers))) handlers[event.type](view, event);
}
editHandlers.keydown = function (view, _event) {
  var event = _event;
  view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
  if (inOrNearComposition(view, event)) return;
  view.input.lastKeyCode = event.keyCode;
  view.input.lastKeyCodeTime = Date.now();
  if (android && chrome && event.keyCode == 13) return;
  if (event.keyCode != 229) view.domObserver.forceFlush();
  if (ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
    var now = Date.now();
    view.input.lastIOSEnter = now;
    view.input.lastIOSEnterFallbackTimeout = setTimeout(function () {
      if (view.input.lastIOSEnter == now) {
        view.someProp("handleKeyDown", function (f) {
          return f(view, keyEvent(13, "Enter"));
        });
        view.input.lastIOSEnter = 0;
      }
    }, 200);
  } else if (view.someProp("handleKeyDown", function (f) {
    return f(view, event);
  }) || captureKeyDown(view, event)) {
    event.preventDefault();
  } else {
    setSelectionOrigin(view, "key");
  }
};
editHandlers.keyup = function (view, event) {
  if (event.keyCode == 16) view.input.shiftKey = false;
};
editHandlers.keypress = function (view, _event) {
  var event = _event;
  if (inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || mac && event.metaKey) return;
  if (view.someProp("handleKeyPress", function (f) {
    return f(view, event);
  })) {
    event.preventDefault();
    return;
  }
  var sel = view.state.selection;
  if (!(sel instanceof prosemirrorState.TextSelection) || !sel.$from.sameParent(sel.$to)) {
    var text = String.fromCharCode(event.charCode);
    var deflt = function deflt() {
      return view.state.tr.insertText(text).scrollIntoView();
    };
    if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", function (f) {
      return f(view, sel.$from.pos, sel.$to.pos, text, deflt);
    })) view.dispatch(deflt());
    event.preventDefault();
  }
};
function eventCoords(event) {
  return {
    left: event.clientX,
    top: event.clientY
  };
}
function isNear(event, click) {
  var dx = click.x - event.clientX,
    dy = click.y - event.clientY;
  return dx * dx + dy * dy < 100;
}
function runHandlerOnContext(view, propName, pos, inside, event) {
  if (inside == -1) return false;
  var $pos = view.state.doc.resolve(inside);
  var _loop3 = function _loop3(i) {
      if (view.someProp(propName, function (f) {
        return i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false);
      })) return {
        v: true
      };
    },
    _ret2;
  for (var i = $pos.depth + 1; i > 0; i--) {
    _ret2 = _loop3(i);
    if (_ret2) return _ret2.v;
  }
  return false;
}
function updateSelection(view, selection, origin) {
  if (!view.focused) view.focus();
  if (view.state.selection.eq(selection)) return;
  var tr = view.state.tr.setSelection(selection);
  if (origin == "pointer") tr.setMeta("pointer", true);
  view.dispatch(tr);
}
function selectClickedLeaf(view, inside) {
  if (inside == -1) return false;
  var $pos = view.state.doc.resolve(inside),
    node = $pos.nodeAfter;
  if (node && node.isAtom && prosemirrorState.NodeSelection.isSelectable(node)) {
    updateSelection(view, new prosemirrorState.NodeSelection($pos), "pointer");
    return true;
  }
  return false;
}
function selectClickedNode(view, inside) {
  if (inside == -1) return false;
  var sel = view.state.selection,
    selectedNode,
    selectAt;
  if (sel instanceof prosemirrorState.NodeSelection) selectedNode = sel.node;
  var $pos = view.state.doc.resolve(inside);
  for (var i = $pos.depth + 1; i > 0; i--) {
    var node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
    if (prosemirrorState.NodeSelection.isSelectable(node)) {
      if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);else selectAt = $pos.before(i);
      break;
    }
  }
  if (selectAt != null) {
    updateSelection(view, prosemirrorState.NodeSelection.create(view.state.doc, selectAt), "pointer");
    return true;
  } else {
    return false;
  }
}
function handleSingleClick(view, pos, inside, event, selectNode) {
  return runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", function (f) {
    return f(view, pos, event);
  }) || (selectNode ? selectClickedNode(view, inside) : selectClickedLeaf(view, inside));
}
function handleDoubleClick(view, pos, inside, event) {
  return runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", function (f) {
    return f(view, pos, event);
  });
}
function handleTripleClick(view, pos, inside, event) {
  return runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", function (f) {
    return f(view, pos, event);
  }) || defaultTripleClick(view, inside, event);
}
function defaultTripleClick(view, inside, event) {
  if (event.button != 0) return false;
  var doc = view.state.doc;
  if (inside == -1) {
    if (doc.inlineContent) {
      updateSelection(view, prosemirrorState.TextSelection.create(doc, 0, doc.content.size), "pointer");
      return true;
    }
    return false;
  }
  var $pos = doc.resolve(inside);
  for (var i = $pos.depth + 1; i > 0; i--) {
    var node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
    var nodePos = $pos.before(i);
    if (node.inlineContent) updateSelection(view, prosemirrorState.TextSelection.create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");else if (prosemirrorState.NodeSelection.isSelectable(node)) updateSelection(view, prosemirrorState.NodeSelection.create(doc, nodePos), "pointer");else continue;
    return true;
  }
}
function forceDOMFlush(view) {
  return endComposition(view);
}
var selectNodeModifier = mac ? "metaKey" : "ctrlKey";
handlers.mousedown = function (view, _event) {
  var event = _event;
  view.input.shiftKey = event.shiftKey;
  var flushed = forceDOMFlush(view);
  var now = Date.now(),
    type = "singleClick";
  if (now - view.input.lastClick.time < 500 && isNear(event, view.input.lastClick) && !event[selectNodeModifier] && view.input.lastClick.button == event.button) {
    if (view.input.lastClick.type == "singleClick") type = "doubleClick";else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
  }
  view.input.lastClick = {
    time: now,
    x: event.clientX,
    y: event.clientY,
    type: type,
    button: event.button
  };
  var pos = view.posAtCoords(eventCoords(event));
  if (!pos) return;
  if (type == "singleClick") {
    if (view.input.mouseDown) view.input.mouseDown.done();
    view.input.mouseDown = new MouseDown(view, pos, event, !!flushed);
  } else if ((type == "doubleClick" ? handleDoubleClick : handleTripleClick)(view, pos.pos, pos.inside, event)) {
    event.preventDefault();
  } else {
    setSelectionOrigin(view, "pointer");
  }
};
var MouseDown = function () {
  function MouseDown(view, pos, event, flushed) {
    var _this8 = this;
    _classCallCheck(this, MouseDown);
    this.view = view;
    this.pos = pos;
    this.event = event;
    this.flushed = flushed;
    this.delayedSelectionSync = false;
    this.mightDrag = null;
    this.startDoc = view.state.doc;
    this.selectNode = !!event[selectNodeModifier];
    this.allowDefault = event.shiftKey;
    var targetNode, targetPos;
    if (pos.inside > -1) {
      targetNode = view.state.doc.nodeAt(pos.inside);
      targetPos = pos.inside;
    } else {
      var $pos = view.state.doc.resolve(pos.pos);
      targetNode = $pos.parent;
      targetPos = $pos.depth ? $pos.before() : 0;
    }
    var target = flushed ? null : event.target;
    var targetDesc = target ? view.docView.nearestDesc(target, true) : null;
    this.target = targetDesc && targetDesc.dom.nodeType == 1 ? targetDesc.dom : null;
    var selection = view.state.selection;
    if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof prosemirrorState.NodeSelection && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
      node: targetNode,
      pos: targetPos,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && gecko && !this.target.hasAttribute("contentEditable"))
    };
    if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
      this.view.domObserver.stop();
      if (this.mightDrag.addAttr) this.target.draggable = true;
      if (this.mightDrag.setUneditable) setTimeout(function () {
        if (_this8.view.input.mouseDown == _this8) _this8.target.setAttribute("contentEditable", "false");
      }, 20);
      this.view.domObserver.start();
    }
    view.root.addEventListener("mouseup", this.up = this.up.bind(this));
    view.root.addEventListener("mousemove", this.move = this.move.bind(this));
    setSelectionOrigin(view, "pointer");
  }
  _createClass(MouseDown, [{
    key: "done",
    value: function done() {
      var _this9 = this;
      this.view.root.removeEventListener("mouseup", this.up);
      this.view.root.removeEventListener("mousemove", this.move);
      if (this.mightDrag && this.target) {
        this.view.domObserver.stop();
        if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
        if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
        this.view.domObserver.start();
      }
      if (this.delayedSelectionSync) setTimeout(function () {
        return selectionToDOM(_this9.view);
      });
      this.view.input.mouseDown = null;
    }
  }, {
    key: "up",
    value: function up(event) {
      this.done();
      if (!this.view.dom.contains(event.target)) return;
      var pos = this.pos;
      if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords(eventCoords(event));
      this.updateAllowDefault(event);
      if (this.allowDefault || !pos) {
        setSelectionOrigin(this.view, "pointer");
      } else if (handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) {
        event.preventDefault();
      } else if (event.button == 0 && (this.flushed || safari && this.mightDrag && !this.mightDrag.node.isAtom || chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
        updateSelection(this.view, prosemirrorState.Selection.near(this.view.state.doc.resolve(pos.pos)), "pointer");
        event.preventDefault();
      } else {
        setSelectionOrigin(this.view, "pointer");
      }
    }
  }, {
    key: "move",
    value: function move(event) {
      this.updateAllowDefault(event);
      setSelectionOrigin(this.view, "pointer");
      if (event.buttons == 0) this.done();
    }
  }, {
    key: "updateAllowDefault",
    value: function updateAllowDefault(event) {
      if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
    }
  }]);
  return MouseDown;
}();
handlers.touchstart = function (view) {
  view.input.lastTouch = Date.now();
  forceDOMFlush(view);
  setSelectionOrigin(view, "pointer");
};
handlers.touchmove = function (view) {
  view.input.lastTouch = Date.now();
  setSelectionOrigin(view, "pointer");
};
handlers.contextmenu = function (view) {
  return forceDOMFlush(view);
};
function inOrNearComposition(view, event) {
  if (view.composing) return true;
  if (safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
    view.input.compositionEndedAt = -2e8;
    return true;
  }
  return false;
}
var timeoutComposition = android ? 5000 : -1;
editHandlers.compositionstart = editHandlers.compositionupdate = function (view) {
  if (!view.composing) {
    view.domObserver.flush();
    var state = view.state,
      $pos = state.selection.$to;
    if (state.selection instanceof prosemirrorState.TextSelection && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some(function (m) {
      return m.type.spec.inclusive === false;
    }))) {
      view.markCursor = view.state.storedMarks || $pos.marks();
      endComposition(view, true);
      view.markCursor = null;
    } else {
      endComposition(view, !state.selection.empty);
      if (gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
        var sel = view.domSelectionRange();
        for (var node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;) {
          var before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
          if (!before) break;
          if (before.nodeType == 3) {
            var _sel = view.domSelection();
            if (_sel) _sel.collapse(before, before.nodeValue.length);
            break;
          } else {
            node = before;
            offset = -1;
          }
        }
      }
    }
    view.input.composing = true;
  }
  scheduleComposeEnd(view, timeoutComposition);
};
editHandlers.compositionend = function (view, event) {
  if (view.composing) {
    view.input.composing = false;
    view.input.compositionEndedAt = event.timeStamp;
    view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
    view.input.compositionNode = null;
    if (view.input.compositionPendingChanges) Promise.resolve().then(function () {
      return view.domObserver.flush();
    });
    view.input.compositionID++;
    scheduleComposeEnd(view, 20);
  }
};
function scheduleComposeEnd(view, delay) {
  clearTimeout(view.input.composingTimeout);
  if (delay > -1) view.input.composingTimeout = setTimeout(function () {
    return endComposition(view);
  }, delay);
}
function clearComposition(view) {
  if (view.composing) {
    view.input.composing = false;
    view.input.compositionEndedAt = timestampFromCustomEvent();
  }
  while (view.input.compositionNodes.length > 0) view.input.compositionNodes.pop().markParentsDirty();
}
function findCompositionNode(view) {
  var sel = view.domSelectionRange();
  if (!sel.focusNode) return null;
  var textBefore = textNodeBefore$1(sel.focusNode, sel.focusOffset);
  var textAfter = textNodeAfter$1(sel.focusNode, sel.focusOffset);
  if (textBefore && textAfter && textBefore != textAfter) {
    var descAfter = textAfter.pmViewDesc,
      lastChanged = view.domObserver.lastChangedTextNode;
    if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
    if (!descAfter || !descAfter.isText(textAfter.nodeValue)) {
      return textAfter;
    } else if (view.input.compositionNode == textAfter) {
      var descBefore = textBefore.pmViewDesc;
      if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
    }
  }
  return textBefore || textAfter;
}
function timestampFromCustomEvent() {
  var event = document.createEvent("Event");
  event.initEvent("event", true, true);
  return event.timeStamp;
}
function endComposition(view) {
  var restarting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (android && view.domObserver.flushingSoon >= 0) return;
  view.domObserver.forceFlush();
  clearComposition(view);
  if (restarting || view.docView && view.docView.dirty) {
    var sel = selectionFromDOM(view),
      cur = view.state.selection;
    if (sel && !sel.eq(cur)) view.dispatch(view.state.tr.setSelection(sel));else if ((view.markCursor || restarting) && !cur.$from.node(cur.$from.sharedDepth(cur.to)).inlineContent) view.dispatch(view.state.tr.deleteSelection());else view.updateState(view.state);
    return true;
  }
  return false;
}
function captureCopy(view, dom) {
  if (!view.dom.parentNode) return;
  var wrap = view.dom.parentNode.appendChild(document.createElement("div"));
  wrap.appendChild(dom);
  wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
  var sel = getSelection(),
    range = document.createRange();
  range.selectNodeContents(dom);
  view.dom.blur();
  sel.removeAllRanges();
  sel.addRange(range);
  setTimeout(function () {
    if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
    view.focus();
  }, 50);
}
var brokenClipboardAPI = ie && ie_version < 15 || ios && webkit_version < 604;
handlers.copy = editHandlers.cut = function (view, _event) {
  var event = _event;
  var sel = view.state.selection,
    cut = event.type == "cut";
  if (sel.empty) return;
  var data = brokenClipboardAPI ? null : event.clipboardData;
  var slice = sel.content(),
    _serializeForClipboar = _serializeForClipboard(view, slice),
    dom = _serializeForClipboar.dom,
    text = _serializeForClipboar.text;
  if (data) {
    event.preventDefault();
    data.clearData();
    data.setData("text/html", dom.innerHTML);
    data.setData("text/plain", text);
  } else {
    captureCopy(view, dom);
  }
  if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function sliceSingleNode(slice) {
  return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function capturePaste(view, event) {
  if (!view.dom.parentNode) return;
  var plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
  var target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
  if (!plainText) target.contentEditable = "true";
  target.style.cssText = "position: fixed; left: -10000px; top: 10px";
  target.focus();
  var plain = view.input.shiftKey && view.input.lastKeyCode != 45;
  setTimeout(function () {
    view.focus();
    if (target.parentNode) target.parentNode.removeChild(target);
    if (plainText) doPaste(view, target.value, null, plain, event);else doPaste(view, target.textContent, target.innerHTML, plain, event);
  }, 50);
}
function doPaste(view, text, html, preferPlain, event) {
  var slice = parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
  if (view.someProp("handlePaste", function (f) {
    return f(view, event, slice || prosemirrorModel.Slice.empty);
  })) return true;
  if (!slice) return false;
  var singleNode = sliceSingleNode(slice);
  var tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
  view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
  return true;
}
function getText(clipboardData) {
  var text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
  if (text) return text;
  var uris = clipboardData.getData("text/uri-list");
  return uris ? uris.replace(/\r?\n/g, " ") : "";
}
editHandlers.paste = function (view, _event) {
  var event = _event;
  if (view.composing && !android) return;
  var data = brokenClipboardAPI ? null : event.clipboardData;
  var plain = view.input.shiftKey && view.input.lastKeyCode != 45;
  if (data && doPaste(view, getText(data), data.getData("text/html"), plain, event)) event.preventDefault();else capturePaste(view, event);
};
var Dragging = _createClass(function Dragging(slice, move, node) {
  _classCallCheck(this, Dragging);
  this.slice = slice;
  this.move = move;
  this.node = node;
});
var dragCopyModifier = mac ? "altKey" : "ctrlKey";
function dragMoves(view, event) {
  var moves = view.someProp("dragCopies", function (test) {
    return !test(event);
  });
  return moves != null ? moves : !event[dragCopyModifier];
}
handlers.dragstart = function (view, _event) {
  var event = _event;
  var mouseDown = view.input.mouseDown;
  if (mouseDown) mouseDown.done();
  if (!event.dataTransfer) return;
  var sel = view.state.selection;
  var pos = sel.empty ? null : view.posAtCoords(eventCoords(event));
  var node;
  if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof prosemirrorState.NodeSelection ? sel.to - 1 : sel.to)) ;else if (mouseDown && mouseDown.mightDrag) {
    node = prosemirrorState.NodeSelection.create(view.state.doc, mouseDown.mightDrag.pos);
  } else if (event.target && event.target.nodeType == 1) {
    var desc = view.docView.nearestDesc(event.target, true);
    if (desc && desc.node.type.spec.draggable && desc != view.docView) node = prosemirrorState.NodeSelection.create(view.state.doc, desc.posBefore);
  }
  var draggedSlice = (node || view.state.selection).content();
  var _serializeForClipboar2 = _serializeForClipboard(view, draggedSlice),
    dom = _serializeForClipboar2.dom,
    text = _serializeForClipboar2.text,
    slice = _serializeForClipboar2.slice;
  if (!event.dataTransfer.files.length || !chrome || chrome_version > 120) event.dataTransfer.clearData();
  event.dataTransfer.setData(brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
  event.dataTransfer.effectAllowed = "copyMove";
  if (!brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
  view.dragging = new Dragging(slice, dragMoves(view, event), node);
};
handlers.dragend = function (view) {
  var dragging = view.dragging;
  window.setTimeout(function () {
    if (view.dragging == dragging) view.dragging = null;
  }, 50);
};
editHandlers.dragover = editHandlers.dragenter = function (_, e) {
  return e.preventDefault();
};
editHandlers.drop = function (view, _event) {
  var event = _event;
  var dragging = view.dragging;
  view.dragging = null;
  if (!event.dataTransfer) return;
  var eventPos = view.posAtCoords(eventCoords(event));
  if (!eventPos) return;
  var $mouse = view.state.doc.resolve(eventPos.pos);
  var slice = dragging && dragging.slice;
  if (slice) {
    view.someProp("transformPasted", function (f) {
      slice = f(slice, view);
    });
  } else {
    slice = parseFromClipboard(view, getText(event.dataTransfer), brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
  }
  var move = !!(dragging && dragMoves(view, event));
  if (view.someProp("handleDrop", function (f) {
    return f(view, event, slice || prosemirrorModel.Slice.empty, move);
  })) {
    event.preventDefault();
    return;
  }
  if (!slice) return;
  event.preventDefault();
  var insertPos = slice ? prosemirrorTransform.dropPoint(view.state.doc, $mouse.pos, slice) : $mouse.pos;
  if (insertPos == null) insertPos = $mouse.pos;
  var tr = view.state.tr;
  if (move) {
    var node = dragging.node;
    if (node) node.replace(tr);else tr.deleteSelection();
  }
  var pos = tr.mapping.map(insertPos);
  var isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
  var beforeInsert = tr.doc;
  if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);else tr.replaceRange(pos, pos, slice);
  if (tr.doc.eq(beforeInsert)) return;
  var $pos = tr.doc.resolve(pos);
  if (isNode && prosemirrorState.NodeSelection.isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) {
    tr.setSelection(new prosemirrorState.NodeSelection($pos));
  } else {
    var end = tr.mapping.map(insertPos);
    tr.mapping.maps[tr.mapping.maps.length - 1].forEach(function (_from, _to, _newFrom, newTo) {
      return end = newTo;
    });
    tr.setSelection(selectionBetween(view, $pos, tr.doc.resolve(end)));
  }
  view.focus();
  view.dispatch(tr.setMeta("uiEvent", "drop"));
};
handlers.focus = function (view) {
  view.input.lastFocus = Date.now();
  if (!view.focused) {
    view.domObserver.stop();
    view.dom.classList.add("ProseMirror-focused");
    view.domObserver.start();
    view.focused = true;
    setTimeout(function () {
      if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) selectionToDOM(view);
    }, 20);
  }
};
handlers.blur = function (view, _event) {
  var event = _event;
  if (view.focused) {
    view.domObserver.stop();
    view.dom.classList.remove("ProseMirror-focused");
    view.domObserver.start();
    if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
    view.focused = false;
  }
};
handlers.beforeinput = function (view, _event) {
  var event = _event;
  if (chrome && android && event.inputType == "deleteContentBackward") {
    view.domObserver.flushSoon();
    var domChangeCount = view.input.domChangeCount;
    setTimeout(function () {
      if (view.input.domChangeCount != domChangeCount) return;
      view.dom.blur();
      view.focus();
      if (view.someProp("handleKeyDown", function (f) {
        return f(view, keyEvent(8, "Backspace"));
      })) return;
      var $cursor = view.state.selection.$cursor;
      if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr["delete"]($cursor.pos - 1, $cursor.pos).scrollIntoView());
    }, 50);
  }
};
for (var prop in editHandlers) handlers[prop] = editHandlers[prop];
function compareObjs(a, b) {
  if (a == b) return true;
  for (var p in a) if (a[p] !== b[p]) return false;
  for (var _p in b) if (!(_p in a)) return false;
  return true;
}
var WidgetType = function () {
  function WidgetType(toDOM, spec) {
    _classCallCheck(this, WidgetType);
    this.toDOM = toDOM;
    this.spec = spec || noSpec;
    this.side = this.spec.side || 0;
  }
  _createClass(WidgetType, [{
    key: "map",
    value: function map(mapping, span, offset, oldOffset) {
      var _mapping$mapResult = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1),
        pos = _mapping$mapResult.pos,
        deleted = _mapping$mapResult.deleted;
      return deleted ? null : new Decoration(pos - offset, pos - offset, this);
    }
  }, {
    key: "valid",
    value: function valid() {
      return true;
    }
  }, {
    key: "eq",
    value: function eq(other) {
      return this == other || other instanceof WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && compareObjs(this.spec, other.spec));
    }
  }, {
    key: "destroy",
    value: function destroy(node) {
      if (this.spec.destroy) this.spec.destroy(node);
    }
  }]);
  return WidgetType;
}();
var InlineType = function () {
  function InlineType(attrs, spec) {
    _classCallCheck(this, InlineType);
    this.attrs = attrs;
    this.spec = spec || noSpec;
  }
  _createClass(InlineType, [{
    key: "map",
    value: function map(mapping, span, offset, oldOffset) {
      var from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
      var to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
      return from >= to ? null : new Decoration(from, to, this);
    }
  }, {
    key: "valid",
    value: function valid(_, span) {
      return span.from < span.to;
    }
  }, {
    key: "eq",
    value: function eq(other) {
      return this == other || other instanceof InlineType && compareObjs(this.attrs, other.attrs) && compareObjs(this.spec, other.spec);
    }
  }, {
    key: "destroy",
    value: function destroy() {}
  }], [{
    key: "is",
    value: function is(span) {
      return span.type instanceof InlineType;
    }
  }]);
  return InlineType;
}();
var NodeType = function () {
  function NodeType(attrs, spec) {
    _classCallCheck(this, NodeType);
    this.attrs = attrs;
    this.spec = spec || noSpec;
  }
  _createClass(NodeType, [{
    key: "map",
    value: function map(mapping, span, offset, oldOffset) {
      var from = mapping.mapResult(span.from + oldOffset, 1);
      if (from.deleted) return null;
      var to = mapping.mapResult(span.to + oldOffset, -1);
      if (to.deleted || to.pos <= from.pos) return null;
      return new Decoration(from.pos - offset, to.pos - offset, this);
    }
  }, {
    key: "valid",
    value: function valid(node, span) {
      var _node$content$findInd = node.content.findIndex(span.from),
        index = _node$content$findInd.index,
        offset = _node$content$findInd.offset,
        child;
      return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
  }, {
    key: "eq",
    value: function eq(other) {
      return this == other || other instanceof NodeType && compareObjs(this.attrs, other.attrs) && compareObjs(this.spec, other.spec);
    }
  }, {
    key: "destroy",
    value: function destroy() {}
  }]);
  return NodeType;
}();
var Decoration = function () {
  function Decoration(from, to, type) {
    _classCallCheck(this, Decoration);
    this.from = from;
    this.to = to;
    this.type = type;
  }
  _createClass(Decoration, [{
    key: "copy",
    value: function copy(from, to) {
      return new Decoration(from, to, this.type);
    }
  }, {
    key: "eq",
    value: function eq(other) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
  }, {
    key: "map",
    value: function map(mapping, offset, oldOffset) {
      return this.type.map(mapping, this, offset, oldOffset);
    }
  }, {
    key: "spec",
    get: function get() {
      return this.type.spec;
    }
  }, {
    key: "inline",
    get: function get() {
      return this.type instanceof InlineType;
    }
  }, {
    key: "widget",
    get: function get() {
      return this.type instanceof WidgetType;
    }
  }], [{
    key: "widget",
    value: function widget(pos, toDOM, spec) {
      return new Decoration(pos, pos, new WidgetType(toDOM, spec));
    }
  }, {
    key: "inline",
    value: function inline(from, to, attrs, spec) {
      return new Decoration(from, to, new InlineType(attrs, spec));
    }
  }, {
    key: "node",
    value: function node(from, to, attrs, spec) {
      return new Decoration(from, to, new NodeType(attrs, spec));
    }
  }]);
  return Decoration;
}();
var none = [],
  noSpec = {};
var DecorationSet = function () {
  function DecorationSet(local, children) {
    _classCallCheck(this, DecorationSet);
    this.local = local.length ? local : none;
    this.children = children.length ? children : none;
  }
  _createClass(DecorationSet, [{
    key: "find",
    value: function find(start, end, predicate) {
      var result = [];
      this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
      return result;
    }
  }, {
    key: "findInner",
    value: function findInner(start, end, result, offset, predicate) {
      for (var i = 0; i < this.local.length; i++) {
        var span = this.local[i];
        if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
      }
      for (var _i6 = 0; _i6 < this.children.length; _i6 += 3) {
        if (this.children[_i6] < end && this.children[_i6 + 1] > start) {
          var childOff = this.children[_i6] + 1;
          this.children[_i6 + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
        }
      }
    }
  }, {
    key: "map",
    value: function map(mapping, doc, options) {
      if (this == empty || mapping.maps.length == 0) return this;
      return this.mapInner(mapping, doc, 0, 0, options || noSpec);
    }
  }, {
    key: "mapInner",
    value: function mapInner(mapping, node, offset, oldOffset, options) {
      var newLocal;
      for (var i = 0; i < this.local.length; i++) {
        var mapped = this.local[i].map(mapping, offset, oldOffset);
        if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);else if (options.onRemove) options.onRemove(this.local[i].spec);
      }
      if (this.children.length) return mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);else return newLocal ? new DecorationSet(newLocal.sort(byPos), none) : empty;
    }
  }, {
    key: "add",
    value: function add(doc, decorations) {
      if (!decorations.length) return this;
      if (this == empty) return DecorationSet.create(doc, decorations);
      return this.addInner(doc, decorations, 0);
    }
  }, {
    key: "addInner",
    value: function addInner(doc, decorations, offset) {
      var _this10 = this;
      var children,
        childIndex = 0;
      doc.forEach(function (childNode, childOffset) {
        var baseOffset = childOffset + offset,
          found;
        if (!(found = takeSpansForNode(decorations, childNode, baseOffset))) return;
        if (!children) children = _this10.children.slice();
        while (childIndex < children.length && children[childIndex] < childOffset) childIndex += 3;
        if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, buildTree(found, childNode, baseOffset + 1, noSpec));
        childIndex += 3;
      });
      var local = moveSpans(childIndex ? withoutNulls(decorations) : decorations, -offset);
      for (var i = 0; i < local.length; i++) if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
      return new DecorationSet(local.length ? this.local.concat(local).sort(byPos) : this.local, children || this.children);
    }
  }, {
    key: "remove",
    value: function remove(decorations) {
      if (decorations.length == 0 || this == empty) return this;
      return this.removeInner(decorations, 0);
    }
  }, {
    key: "removeInner",
    value: function removeInner(decorations, offset) {
      var children = this.children,
        local = this.local;
      for (var i = 0; i < children.length; i += 3) {
        var found = void 0;
        var from = children[i] + offset,
          to = children[i + 1] + offset;
        for (var j = 0, span; j < decorations.length; j++) if (span = decorations[j]) {
          if (span.from > from && span.to < to) {
            decorations[j] = null;
            (found || (found = [])).push(span);
          }
        }
        if (!found) continue;
        if (children == this.children) children = this.children.slice();
        var removed = children[i + 2].removeInner(found, from + 1);
        if (removed != empty) {
          children[i + 2] = removed;
        } else {
          children.splice(i, 3);
          i -= 3;
        }
      }
      if (local.length) for (var _i7 = 0, _span; _i7 < decorations.length; _i7++) if (_span = decorations[_i7]) {
        for (var _j2 = 0; _j2 < local.length; _j2++) if (local[_j2].eq(_span, offset)) {
          if (local == this.local) local = this.local.slice();
          local.splice(_j2--, 1);
        }
      }
      if (children == this.children && local == this.local) return this;
      return local.length || children.length ? new DecorationSet(local, children) : empty;
    }
  }, {
    key: "forChild",
    value: function forChild(offset, node) {
      if (this == empty) return this;
      if (node.isLeaf) return DecorationSet.empty;
      var child, local;
      for (var i = 0; i < this.children.length; i += 3) if (this.children[i] >= offset) {
        if (this.children[i] == offset) child = this.children[i + 2];
        break;
      }
      var start = offset + 1,
        end = start + node.content.size;
      for (var _i8 = 0; _i8 < this.local.length; _i8++) {
        var dec = this.local[_i8];
        if (dec.from < end && dec.to > start && dec.type instanceof InlineType) {
          var from = Math.max(start, dec.from) - start,
            to = Math.min(end, dec.to) - start;
          if (from < to) (local || (local = [])).push(dec.copy(from, to));
        }
      }
      if (local) {
        var localSet = new DecorationSet(local.sort(byPos), none);
        return child ? new DecorationGroup([localSet, child]) : localSet;
      }
      return child || empty;
    }
  }, {
    key: "eq",
    value: function eq(other) {
      if (this == other) return true;
      if (!(other instanceof DecorationSet) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
      for (var i = 0; i < this.local.length; i++) if (!this.local[i].eq(other.local[i])) return false;
      for (var _i9 = 0; _i9 < this.children.length; _i9 += 3) if (this.children[_i9] != other.children[_i9] || this.children[_i9 + 1] != other.children[_i9 + 1] || !this.children[_i9 + 2].eq(other.children[_i9 + 2])) return false;
      return true;
    }
  }, {
    key: "locals",
    value: function locals(node) {
      return removeOverlap(this.localsInner(node));
    }
  }, {
    key: "localsInner",
    value: function localsInner(node) {
      if (this == empty) return none;
      if (node.inlineContent || !this.local.some(InlineType.is)) return this.local;
      var result = [];
      for (var i = 0; i < this.local.length; i++) {
        if (!(this.local[i].type instanceof InlineType)) result.push(this.local[i]);
      }
      return result;
    }
  }, {
    key: "forEachSet",
    value: function forEachSet(f) {
      f(this);
    }
  }], [{
    key: "create",
    value: function create(doc, decorations) {
      return decorations.length ? buildTree(decorations, doc, 0, noSpec) : empty;
    }
  }]);
  return DecorationSet;
}();
DecorationSet.empty = new DecorationSet([], []);
DecorationSet.removeOverlap = removeOverlap;
var empty = DecorationSet.empty;
var DecorationGroup = function () {
  function DecorationGroup(members) {
    _classCallCheck(this, DecorationGroup);
    this.members = members;
  }
  _createClass(DecorationGroup, [{
    key: "map",
    value: function map(mapping, doc) {
      var mappedDecos = this.members.map(function (member) {
        return member.map(mapping, doc, noSpec);
      });
      return DecorationGroup.from(mappedDecos);
    }
  }, {
    key: "forChild",
    value: function forChild(offset, child) {
      if (child.isLeaf) return DecorationSet.empty;
      var found = [];
      for (var i = 0; i < this.members.length; i++) {
        var result = this.members[i].forChild(offset, child);
        if (result == empty) continue;
        if (result instanceof DecorationGroup) found = found.concat(result.members);else found.push(result);
      }
      return DecorationGroup.from(found);
    }
  }, {
    key: "eq",
    value: function eq(other) {
      if (!(other instanceof DecorationGroup) || other.members.length != this.members.length) return false;
      for (var i = 0; i < this.members.length; i++) if (!this.members[i].eq(other.members[i])) return false;
      return true;
    }
  }, {
    key: "locals",
    value: function locals(node) {
      var result,
        sorted = true;
      for (var i = 0; i < this.members.length; i++) {
        var locals = this.members[i].localsInner(node);
        if (!locals.length) continue;
        if (!result) {
          result = locals;
        } else {
          if (sorted) {
            result = result.slice();
            sorted = false;
          }
          for (var j = 0; j < locals.length; j++) result.push(locals[j]);
        }
      }
      return result ? removeOverlap(sorted ? result : result.sort(byPos)) : none;
    }
  }, {
    key: "forEachSet",
    value: function forEachSet(f) {
      for (var i = 0; i < this.members.length; i++) this.members[i].forEachSet(f);
    }
  }], [{
    key: "from",
    value: function from(members) {
      switch (members.length) {
        case 0:
          return empty;
        case 1:
          return members[0];
        default:
          return new DecorationGroup(members.every(function (m) {
            return m instanceof DecorationSet;
          }) ? members : members.reduce(function (r, m) {
            return r.concat(m instanceof DecorationSet ? m : m.members);
          }, []));
      }
    }
  }]);
  return DecorationGroup;
}();
function mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
  var children = oldChildren.slice();
  var _loop4 = function _loop4(_baseOffset) {
    var moved = 0;
    mapping.maps[i].forEach(function (oldStart, oldEnd, newStart, newEnd) {
      var dSize = newEnd - newStart - (oldEnd - oldStart);
      for (var _i13 = 0; _i13 < children.length; _i13 += 3) {
        var end = children[_i13 + 1];
        if (end < 0 || oldStart > end + _baseOffset - moved) continue;
        var start = children[_i13] + _baseOffset - moved;
        if (oldEnd >= start) {
          children[_i13 + 1] = oldStart <= start ? -2 : -1;
        } else if (oldStart >= _baseOffset && dSize) {
          children[_i13] += dSize;
          children[_i13 + 1] += dSize;
        }
      }
      moved += dSize;
    });
    _baseOffset = mapping.maps[i].map(_baseOffset, -1);
    baseOffset = _baseOffset;
  };
  for (var i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++) {
    _loop4(baseOffset);
  }
  var mustRebuild = false;
  for (var _i10 = 0; _i10 < children.length; _i10 += 3) if (children[_i10 + 1] < 0) {
    if (children[_i10 + 1] == -2) {
      mustRebuild = true;
      children[_i10 + 1] = -1;
      continue;
    }
    var from = mapping.map(oldChildren[_i10] + oldOffset),
      fromLocal = from - offset;
    if (fromLocal < 0 || fromLocal >= node.content.size) {
      mustRebuild = true;
      continue;
    }
    var to = mapping.map(oldChildren[_i10 + 1] + oldOffset, -1),
      toLocal = to - offset;
    var _node$content$findInd2 = node.content.findIndex(fromLocal),
      index = _node$content$findInd2.index,
      childOffset = _node$content$findInd2.offset;
    var childNode = node.maybeChild(index);
    if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
      var mapped = children[_i10 + 2].mapInner(mapping, childNode, from + 1, oldChildren[_i10] + oldOffset + 1, options);
      if (mapped != empty) {
        children[_i10] = fromLocal;
        children[_i10 + 1] = toLocal;
        children[_i10 + 2] = mapped;
      } else {
        children[_i10 + 1] = -2;
        mustRebuild = true;
      }
    } else {
      mustRebuild = true;
    }
  }
  if (mustRebuild) {
    var decorations = mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
    var built = buildTree(decorations, node, 0, options);
    newLocal = built.local;
    for (var _i11 = 0; _i11 < children.length; _i11 += 3) if (children[_i11 + 1] < 0) {
      children.splice(_i11, 3);
      _i11 -= 3;
    }
    for (var _i12 = 0, j = 0; _i12 < built.children.length; _i12 += 3) {
      var _from2 = built.children[_i12];
      while (j < children.length && children[j] < _from2) j += 3;
      children.splice(j, 0, built.children[_i12], built.children[_i12 + 1], built.children[_i12 + 2]);
    }
  }
  return new DecorationSet(newLocal.sort(byPos), children);
}
function moveSpans(spans, offset) {
  if (!offset || !spans.length) return spans;
  var result = [];
  for (var i = 0; i < spans.length; i++) {
    var span = spans[i];
    result.push(new Decoration(span.from + offset, span.to + offset, span.type));
  }
  return result;
}
function mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
  function gather(set, oldOffset) {
    for (var i = 0; i < set.local.length; i++) {
      var mapped = set.local[i].map(mapping, offset, oldOffset);
      if (mapped) decorations.push(mapped);else if (options.onRemove) options.onRemove(set.local[i].spec);
    }
    for (var _i14 = 0; _i14 < set.children.length; _i14 += 3) gather(set.children[_i14 + 2], set.children[_i14] + oldOffset + 1);
  }
  for (var i = 0; i < children.length; i += 3) if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
  return decorations;
}
function takeSpansForNode(spans, node, offset) {
  if (node.isLeaf) return null;
  var end = offset + node.nodeSize,
    found = null;
  for (var i = 0, span; i < spans.length; i++) {
    if ((span = spans[i]) && span.from > offset && span.to < end) {
      (found || (found = [])).push(span);
      spans[i] = null;
    }
  }
  return found;
}
function withoutNulls(array) {
  var result = [];
  for (var i = 0; i < array.length; i++) if (array[i] != null) result.push(array[i]);
  return result;
}
function buildTree(spans, node, offset, options) {
  var children = [],
    hasNulls = false;
  node.forEach(function (childNode, localStart) {
    var found = takeSpansForNode(spans, childNode, localStart + offset);
    if (found) {
      hasNulls = true;
      var subtree = buildTree(found, childNode, offset + localStart + 1, options);
      if (subtree != empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
    }
  });
  var locals = moveSpans(hasNulls ? withoutNulls(spans) : spans, -offset).sort(byPos);
  for (var i = 0; i < locals.length; i++) if (!locals[i].type.valid(node, locals[i])) {
    if (options.onRemove) options.onRemove(locals[i].spec);
    locals.splice(i--, 1);
  }
  return locals.length || children.length ? new DecorationSet(locals, children) : empty;
}
function byPos(a, b) {
  return a.from - b.from || a.to - b.to;
}
function removeOverlap(spans) {
  var working = spans;
  for (var i = 0; i < working.length - 1; i++) {
    var span = working[i];
    if (span.from != span.to) for (var j = i + 1; j < working.length; j++) {
      var next = working[j];
      if (next.from == span.from) {
        if (next.to != span.to) {
          if (working == spans) working = spans.slice();
          working[j] = next.copy(next.from, span.to);
          insertAhead(working, j + 1, next.copy(span.to, next.to));
        }
        continue;
      } else {
        if (next.from < span.to) {
          if (working == spans) working = spans.slice();
          working[i] = span.copy(span.from, next.from);
          insertAhead(working, j, span.copy(next.from, span.to));
        }
        break;
      }
    }
  }
  return working;
}
function insertAhead(array, i, deco) {
  while (i < array.length && byPos(deco, array[i]) > 0) i++;
  array.splice(i, 0, deco);
}
function viewDecorations(view) {
  var found = [];
  view.someProp("decorations", function (f) {
    var result = f(view.state);
    if (result && result != empty) found.push(result);
  });
  if (view.cursorWrapper) found.push(DecorationSet.create(view.state.doc, [view.cursorWrapper.deco]));
  return DecorationGroup.from(found);
}
var observeOptions = {
  childList: true,
  characterData: true,
  characterDataOldValue: true,
  attributes: true,
  attributeOldValue: true,
  subtree: true
};
var useCharData = ie && ie_version <= 11;
var SelectionState = function () {
  function SelectionState() {
    _classCallCheck(this, SelectionState);
    this.anchorNode = null;
    this.anchorOffset = 0;
    this.focusNode = null;
    this.focusOffset = 0;
  }
  _createClass(SelectionState, [{
    key: "set",
    value: function set(sel) {
      this.anchorNode = sel.anchorNode;
      this.anchorOffset = sel.anchorOffset;
      this.focusNode = sel.focusNode;
      this.focusOffset = sel.focusOffset;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.anchorNode = this.focusNode = null;
    }
  }, {
    key: "eq",
    value: function eq(sel) {
      return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
  }]);
  return SelectionState;
}();
var DOMObserver = function () {
  function DOMObserver(view, handleDOMChange) {
    var _this11 = this;
    _classCallCheck(this, DOMObserver);
    this.view = view;
    this.handleDOMChange = handleDOMChange;
    this.queue = [];
    this.flushingSoon = -1;
    this.observer = null;
    this.currentSelection = new SelectionState();
    this.onCharData = null;
    this.suppressingSelectionUpdates = false;
    this.lastChangedTextNode = null;
    this.observer = window.MutationObserver && new window.MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) _this11.queue.push(mutations[i]);
      if (ie && ie_version <= 11 && mutations.some(function (m) {
        return m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length;
      })) _this11.flushSoon();else _this11.flush();
    });
    if (useCharData) {
      this.onCharData = function (e) {
        _this11.queue.push({
          target: e.target,
          type: "characterData",
          oldValue: e.prevValue
        });
        _this11.flushSoon();
      };
    }
    this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  _createClass(DOMObserver, [{
    key: "flushSoon",
    value: function flushSoon() {
      var _this12 = this;
      if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(function () {
        _this12.flushingSoon = -1;
        _this12.flush();
      }, 20);
    }
  }, {
    key: "forceFlush",
    value: function forceFlush() {
      if (this.flushingSoon > -1) {
        window.clearTimeout(this.flushingSoon);
        this.flushingSoon = -1;
        this.flush();
      }
    }
  }, {
    key: "start",
    value: function start() {
      if (this.observer) {
        this.observer.takeRecords();
        this.observer.observe(this.view.dom, observeOptions);
      }
      if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
      this.connectSelection();
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this13 = this;
      if (this.observer) {
        var take = this.observer.takeRecords();
        if (take.length) {
          for (var i = 0; i < take.length; i++) this.queue.push(take[i]);
          window.setTimeout(function () {
            return _this13.flush();
          }, 20);
        }
        this.observer.disconnect();
      }
      if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
      this.disconnectSelection();
    }
  }, {
    key: "connectSelection",
    value: function connectSelection() {
      this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
  }, {
    key: "disconnectSelection",
    value: function disconnectSelection() {
      this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
  }, {
    key: "suppressSelectionUpdates",
    value: function suppressSelectionUpdates() {
      var _this14 = this;
      this.suppressingSelectionUpdates = true;
      setTimeout(function () {
        return _this14.suppressingSelectionUpdates = false;
      }, 50);
    }
  }, {
    key: "onSelectionChange",
    value: function onSelectionChange() {
      if (!hasFocusAndSelection(this.view)) return;
      if (this.suppressingSelectionUpdates) return selectionToDOM(this.view);
      if (ie && ie_version <= 11 && !this.view.state.selection.empty) {
        var sel = this.view.domSelectionRange();
        if (sel.focusNode && isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
      }
      this.flush();
    }
  }, {
    key: "setCurSelection",
    value: function setCurSelection() {
      this.currentSelection.set(this.view.domSelectionRange());
    }
  }, {
    key: "ignoreSelectionChange",
    value: function ignoreSelectionChange(sel) {
      if (!sel.focusNode) return true;
      var ancestors = new Set(),
        container;
      for (var scan = sel.focusNode; scan; scan = parentNode(scan)) ancestors.add(scan);
      for (var _scan = sel.anchorNode; _scan; _scan = parentNode(_scan)) if (ancestors.has(_scan)) {
        container = _scan;
        break;
      }
      var desc = container && this.view.docView.nearestDesc(container);
      if (desc && desc.ignoreMutation({
        type: "selection",
        target: container.nodeType == 3 ? container.parentNode : container
      })) {
        this.setCurSelection();
        return true;
      }
    }
  }, {
    key: "pendingRecords",
    value: function pendingRecords() {
      if (this.observer) {
        var _iterator2 = _createForOfIteratorHelper(this.observer.takeRecords()),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var mut = _step2.value;
            this.queue.push(mut);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      return this.queue;
    }
  }, {
    key: "flush",
    value: function flush() {
      var view = this.view;
      if (!view.docView || this.flushingSoon > -1) return;
      var mutations = this.pendingRecords();
      if (mutations.length) this.queue = [];
      var sel = view.domSelectionRange();
      var newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
      var from = -1,
        to = -1,
        typeOver = false,
        added = [];
      if (view.editable) {
        for (var i = 0; i < mutations.length; i++) {
          var result = this.registerMutation(mutations[i], added);
          if (result) {
            from = from < 0 ? result.from : Math.min(result.from, from);
            to = to < 0 ? result.to : Math.max(result.to, to);
            if (result.typeOver) typeOver = true;
          }
        }
      }
      if (gecko && added.length) {
        var brs = added.filter(function (n) {
          return n.nodeName == "BR";
        });
        if (brs.length == 2) {
          var _brs = _slicedToArray(brs, 2),
            a = _brs[0],
            b = _brs[1];
          if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();else a.remove();
        } else {
          var focusNode = this.currentSelection.focusNode;
          var _iterator3 = _createForOfIteratorHelper(brs),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var br = _step3.value;
              var parent = br.parentNode;
              if (parent && parent.nodeName == "LI" && (!focusNode || blockParent(view, focusNode) != parent)) br.remove();
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      }
      var readSel = null;
      if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && selectionCollapsed(sel) && (readSel = selectionFromDOM(view)) && readSel.eq(prosemirrorState.Selection.near(view.state.doc.resolve(0), 1))) {
        view.input.lastFocus = 0;
        selectionToDOM(view);
        this.currentSelection.set(sel);
        view.scrollToSelection();
      } else if (from > -1 || newSel) {
        if (from > -1) {
          view.docView.markDirty(from, to);
          checkCSS(view);
        }
        this.handleDOMChange(from, to, typeOver, added);
        if (view.docView && view.docView.dirty) view.updateState(view.state);else if (!this.currentSelection.eq(sel)) selectionToDOM(view);
        this.currentSelection.set(sel);
      }
    }
  }, {
    key: "registerMutation",
    value: function registerMutation(mut, added) {
      if (added.indexOf(mut.target) > -1) return null;
      var desc = this.view.docView.nearestDesc(mut.target);
      if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
      if (!desc || desc.ignoreMutation(mut)) return null;
      if (mut.type == "childList") {
        for (var i = 0; i < mut.addedNodes.length; i++) {
          var node = mut.addedNodes[i];
          added.push(node);
          if (node.nodeType == 3) this.lastChangedTextNode = node;
        }
        if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
          from: desc.posBefore,
          to: desc.posAfter
        };
        var prev = mut.previousSibling,
          next = mut.nextSibling;
        if (ie && ie_version <= 11 && mut.addedNodes.length) {
          for (var _i15 = 0; _i15 < mut.addedNodes.length; _i15++) {
            var _mut$addedNodes$_i = mut.addedNodes[_i15],
              previousSibling = _mut$addedNodes$_i.previousSibling,
              nextSibling = _mut$addedNodes$_i.nextSibling;
            if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
            if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
          }
        }
        var fromOffset = prev && prev.parentNode == mut.target ? domIndex(prev) + 1 : 0;
        var from = desc.localPosFromDOM(mut.target, fromOffset, -1);
        var toOffset = next && next.parentNode == mut.target ? domIndex(next) : mut.target.childNodes.length;
        var to = desc.localPosFromDOM(mut.target, toOffset, 1);
        return {
          from: from,
          to: to
        };
      } else if (mut.type == "attributes") {
        return {
          from: desc.posAtStart - desc.border,
          to: desc.posAtEnd + desc.border
        };
      } else {
        this.lastChangedTextNode = mut.target;
        return {
          from: desc.posAtStart,
          to: desc.posAtEnd,
          typeOver: mut.target.nodeValue == mut.oldValue
        };
      }
    }
  }]);
  return DOMObserver;
}();
var cssChecked = new WeakMap();
var cssCheckWarned = false;
function checkCSS(view) {
  if (cssChecked.has(view)) return;
  cssChecked.set(view, null);
  if (['normal', 'nowrap', 'pre-line'].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
    view.requiresGeckoHackNode = gecko;
    if (cssCheckWarned) return;
    console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
    cssCheckWarned = true;
  }
}
function rangeToSelectionRange(view, range) {
  var anchorNode = range.startContainer,
    anchorOffset = range.startOffset;
  var focusNode = range.endContainer,
    focusOffset = range.endOffset;
  var currentAnchor = view.domAtPos(view.state.selection.anchor);
  if (isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) {
    var _ref5 = [focusNode, focusOffset, anchorNode, anchorOffset];
    anchorNode = _ref5[0];
    anchorOffset = _ref5[1];
    focusNode = _ref5[2];
    focusOffset = _ref5[3];
  }
  return {
    anchorNode: anchorNode,
    anchorOffset: anchorOffset,
    focusNode: focusNode,
    focusOffset: focusOffset
  };
}
function safariShadowSelectionRange(view, selection) {
  if (selection.getComposedRanges) {
    var range = selection.getComposedRanges(view.root)[0];
    if (range) return rangeToSelectionRange(view, range);
  }
  var found;
  function read(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    found = event.getTargetRanges()[0];
  }
  view.dom.addEventListener("beforeinput", read, true);
  document.execCommand("indent");
  view.dom.removeEventListener("beforeinput", read, true);
  return found ? rangeToSelectionRange(view, found) : null;
}
function blockParent(view, node) {
  for (var p = node.parentNode; p && p != view.dom; p = p.parentNode) {
    var desc = view.docView.nearestDesc(p, true);
    if (desc && desc.node.isBlock) return p;
  }
  return null;
}
function parseBetween(view, from_, to_) {
  var _view$docView$parseRa = view.docView.parseRange(from_, to_),
    parent = _view$docView$parseRa.node,
    fromOffset = _view$docView$parseRa.fromOffset,
    toOffset = _view$docView$parseRa.toOffset,
    from = _view$docView$parseRa.from,
    to = _view$docView$parseRa.to;
  var domSel = view.domSelectionRange();
  var find;
  var anchor = domSel.anchorNode;
  if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
    find = [{
      node: anchor,
      offset: domSel.anchorOffset
    }];
    if (!selectionCollapsed(domSel)) find.push({
      node: domSel.focusNode,
      offset: domSel.focusOffset
    });
  }
  if (chrome && view.input.lastKeyCode === 8) {
    for (var off = toOffset; off > fromOffset; off--) {
      var node = parent.childNodes[off - 1],
        desc = node.pmViewDesc;
      if (node.nodeName == "BR" && !desc) {
        toOffset = off;
        break;
      }
      if (!desc || desc.size) break;
    }
  }
  var startDoc = view.state.doc;
  var parser = view.someProp("domParser") || prosemirrorModel.DOMParser.fromSchema(view.state.schema);
  var $from = startDoc.resolve(from);
  var sel = null,
    doc = parser.parse(parent, {
      topNode: $from.parent,
      topMatch: $from.parent.contentMatchAt($from.index()),
      topOpen: true,
      from: fromOffset,
      to: toOffset,
      preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
      findPositions: find,
      ruleFromNode: ruleFromNode,
      context: $from
    });
  if (find && find[0].pos != null) {
    var _anchor = find[0].pos,
      head = find[1] && find[1].pos;
    if (head == null) head = _anchor;
    sel = {
      anchor: _anchor + from,
      head: head + from
    };
  }
  return {
    doc: doc,
    sel: sel,
    from: from,
    to: to
  };
}
function ruleFromNode(dom) {
  var desc = dom.pmViewDesc;
  if (desc) {
    return desc.parseRule();
  } else if (dom.nodeName == "BR" && dom.parentNode) {
    if (safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
      var skip = document.createElement("div");
      skip.appendChild(document.createElement("li"));
      return {
        skip: skip
      };
    } else if (dom.parentNode.lastChild == dom || safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) {
      return {
        ignore: true
      };
    }
  } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) {
    return {
      ignore: true
    };
  }
  return null;
}
var isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function readDOMChange(view, from, to, typeOver, addedNodes) {
  var compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
  view.input.compositionPendingChanges = 0;
  if (from < 0) {
    var origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
    var newSel = selectionFromDOM(view, origin);
    if (newSel && !view.state.selection.eq(newSel)) {
      if (chrome && android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", function (f) {
        return f(view, keyEvent(13, "Enter"));
      })) return;
      var tr = view.state.tr.setSelection(newSel);
      if (origin == "pointer") tr.setMeta("pointer", true);else if (origin == "key") tr.scrollIntoView();
      if (compositionID) tr.setMeta("composition", compositionID);
      view.dispatch(tr);
    }
    return;
  }
  var $before = view.state.doc.resolve(from);
  var shared = $before.sharedDepth(to);
  from = $before.before(shared + 1);
  to = view.state.doc.resolve(to).after(shared + 1);
  var sel = view.state.selection;
  var parse = parseBetween(view, from, to);
  var doc = view.state.doc,
    compare = doc.slice(parse.from, parse.to);
  var preferredPos, preferredSide;
  if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
    preferredPos = view.state.selection.to;
    preferredSide = "end";
  } else {
    preferredPos = view.state.selection.from;
    preferredSide = "start";
  }
  view.input.lastKeyCode = null;
  var change = findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
  if (change) view.input.domChangeCount++;
  if ((ios && view.input.lastIOSEnter > Date.now() - 225 || android) && addedNodes.some(function (n) {
    return n.nodeType == 1 && !isInline.test(n.nodeName);
  }) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", function (f) {
    return f(view, keyEvent(13, "Enter"));
  })) {
    view.input.lastIOSEnter = 0;
    return;
  }
  if (!change) {
    if (typeOver && sel instanceof prosemirrorState.TextSelection && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) {
      change = {
        start: sel.from,
        endA: sel.to,
        endB: sel.to
      };
    } else {
      if (parse.sel) {
        var _sel2 = resolveSelection(view, view.state.doc, parse.sel);
        if (_sel2 && !_sel2.eq(view.state.selection)) {
          var _tr = view.state.tr.setSelection(_sel2);
          if (compositionID) _tr.setMeta("composition", compositionID);
          view.dispatch(_tr);
        }
      }
      return;
    }
  }
  if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof prosemirrorState.TextSelection) {
    if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) {
      change.start = view.state.selection.from;
    } else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
      change.endB += view.state.selection.to - change.endA;
      change.endA = view.state.selection.to;
    }
  }
  if (ie && ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \xA0") {
    change.start--;
    change.endA--;
    change.endB--;
  }
  var $from = parse.doc.resolveNoCache(change.start - parse.from);
  var $to = parse.doc.resolveNoCache(change.endB - parse.from);
  var $fromA = doc.resolve(change.start);
  var inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
  var nextSel;
  if ((ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some(function (n) {
    return n.nodeName == "DIV" || n.nodeName == "P";
  })) || !inlineChange && $from.pos < parse.doc.content.size && (!$from.sameParent($to) || !$from.parent.inlineContent) && !/\S/.test(parse.doc.textBetween($from.pos, $to.pos, "", "")) && (nextSel = prosemirrorState.Selection.findFrom(parse.doc.resolve($from.pos + 1), 1, true)) && nextSel.head > $from.pos) && view.someProp("handleKeyDown", function (f) {
    return f(view, keyEvent(13, "Enter"));
  })) {
    view.input.lastIOSEnter = 0;
    return;
  }
  if (view.state.selection.anchor > change.start && looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", function (f) {
    return f(view, keyEvent(8, "Backspace"));
  })) {
    if (android && chrome) view.domObserver.suppressSelectionUpdates();
    return;
  }
  if (chrome && change.endB == change.start) view.input.lastChromeDelete = Date.now();
  if (android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
    change.endB -= 2;
    $to = parse.doc.resolveNoCache(change.endB - parse.from);
    setTimeout(function () {
      view.someProp("handleKeyDown", function (f) {
        return f(view, keyEvent(13, "Enter"));
      });
    }, 20);
  }
  var chFrom = change.start,
    chTo = change.endA;
  var mkTr = function mkTr(base) {
    var tr = base || view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
    if (parse.sel) {
      var _sel3 = resolveSelection(view, tr.doc, parse.sel);
      if (_sel3 && !(chrome && view.composing && _sel3.empty && (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) && (_sel3.head == chFrom || _sel3.head == tr.mapping.map(chTo) - 1) || ie && _sel3.empty && _sel3.head == chFrom)) tr.setSelection(_sel3);
    }
    if (compositionID) tr.setMeta("composition", compositionID);
    return tr.scrollIntoView();
  };
  var markChange;
  if (inlineChange) {
    if ($from.pos == $to.pos) {
      if (ie && ie_version <= 11 && $from.parentOffset == 0) {
        view.domObserver.suppressSelectionUpdates();
        setTimeout(function () {
          return selectionToDOM(view);
        }, 20);
      }
      var _tr2 = mkTr(view.state.tr["delete"](chFrom, chTo));
      var marks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
      if (marks) _tr2.ensureMarks(marks);
      view.dispatch(_tr2);
    } else if (change.endA == change.endB && (markChange = isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
      var _tr3 = mkTr(view.state.tr);
      if (markChange.type == "add") _tr3.addMark(chFrom, chTo, markChange.mark);else _tr3.removeMark(chFrom, chTo, markChange.mark);
      view.dispatch(_tr3);
    } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
      var text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
      var deflt = function deflt() {
        return mkTr(view.state.tr.insertText(text, chFrom, chTo));
      };
      if (!view.someProp("handleTextInput", function (f) {
        return f(view, chFrom, chTo, text, deflt);
      })) view.dispatch(deflt());
    }
  } else {
    view.dispatch(mkTr());
  }
}
function resolveSelection(view, doc, parsedSel) {
  if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
  return selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
function isMarkChange(cur, prev) {
  var curMarks = cur.firstChild.marks,
    prevMarks = prev.firstChild.marks;
  var added = curMarks,
    removed = prevMarks,
    type,
    mark,
    update;
  for (var i = 0; i < prevMarks.length; i++) added = prevMarks[i].removeFromSet(added);
  for (var _i16 = 0; _i16 < curMarks.length; _i16++) removed = curMarks[_i16].removeFromSet(removed);
  if (added.length == 1 && removed.length == 0) {
    mark = added[0];
    type = "add";
    update = function update(node) {
      return node.mark(mark.addToSet(node.marks));
    };
  } else if (added.length == 0 && removed.length == 1) {
    mark = removed[0];
    type = "remove";
    update = function update(node) {
      return node.mark(mark.removeFromSet(node.marks));
    };
  } else {
    return null;
  }
  var updated = [];
  for (var _i17 = 0; _i17 < prev.childCount; _i17++) updated.push(update(prev.child(_i17)));
  if (prosemirrorModel.Fragment.from(updated).eq(cur)) return {
    mark: mark,
    type: type
  };
}
function looksLikeBackspace(old, start, end, $newStart, $newEnd) {
  if (end - start <= $newEnd.pos - $newStart.pos || skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
  var $start = old.resolve(start);
  if (!$newStart.parent.isTextblock) {
    var after = $start.nodeAfter;
    return after != null && end == start + after.nodeSize;
  }
  if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
  var $next = old.resolve(skipClosingAndOpening($start, true, true));
  if (!$next.parent.isTextblock || $next.pos > end || skipClosingAndOpening($next, true, false) < end) return false;
  return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function skipClosingAndOpening($pos, fromEnd, mayOpen) {
  var depth = $pos.depth,
    end = fromEnd ? $pos.end() : $pos.pos;
  while (depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)) {
    depth--;
    end++;
    fromEnd = false;
  }
  if (mayOpen) {
    var next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
    while (next && !next.isLeaf) {
      next = next.firstChild;
      end++;
    }
  }
  return end;
}
function findDiff(a, b, pos, preferredPos, preferredSide) {
  var start = a.findDiffStart(b, pos);
  if (start == null) return null;
  var _a$findDiffEnd = a.findDiffEnd(b, pos + a.size, pos + b.size),
    endA = _a$findDiffEnd.a,
    endB = _a$findDiffEnd.b;
  if (preferredSide == "end") {
    var adjust = Math.max(0, start - Math.min(endA, endB));
    preferredPos -= endA + adjust - start;
  }
  if (endA < start && a.size < b.size) {
    var move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
    start -= move;
    if (start && start < b.size && isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
    endB = start + (endB - endA);
    endA = start;
  } else if (endB < start) {
    var _move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
    start -= _move;
    if (start && start < a.size && isSurrogatePair(a.textBetween(start - 1, start + 1))) start += _move ? 1 : -1;
    endA = start + (endA - endB);
    endB = start;
  }
  return {
    start: start,
    endA: endA,
    endB: endB
  };
}
function isSurrogatePair(str) {
  if (str.length != 2) return false;
  var a = str.charCodeAt(0),
    b = str.charCodeAt(1);
  return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}
var __parseFromClipboard = parseFromClipboard;
var __endComposition = endComposition;
var EditorView = function () {
  function EditorView(place, props) {
    var _this15 = this;
    _classCallCheck(this, EditorView);
    this._root = null;
    this.focused = false;
    this.trackWrites = null;
    this.mounted = false;
    this.markCursor = null;
    this.cursorWrapper = null;
    this.lastSelectedViewDesc = undefined;
    this.input = new InputState();
    this.prevDirectPlugins = [];
    this.pluginViews = [];
    this.requiresGeckoHackNode = false;
    this.dragging = null;
    this._props = props;
    this.state = props.state;
    this.directPlugins = props.plugins || [];
    this.directPlugins.forEach(checkStateComponent);
    this.dispatch = this.dispatch.bind(this);
    this.dom = place && place.mount || document.createElement("div");
    if (place) {
      if (place.appendChild) place.appendChild(this.dom);else if (typeof place == "function") place(this.dom);else if (place.mount) this.mounted = true;
    }
    this.editable = getEditable(this);
    updateCursorWrapper(this);
    this.nodeViews = buildNodeViews(this);
    this.docView = docViewDesc(this.state.doc, computeDocDeco(this), viewDecorations(this), this.dom, this);
    this.domObserver = new DOMObserver(this, function (from, to, typeOver, added) {
      return readDOMChange(_this15, from, to, typeOver, added);
    });
    this.domObserver.start();
    initInput(this);
    this.updatePluginViews();
  }
  _createClass(EditorView, [{
    key: "composing",
    get: function get() {
      return this.input.composing;
    }
  }, {
    key: "props",
    get: function get() {
      if (this._props.state != this.state) {
        var prev = this._props;
        this._props = {};
        for (var name in prev) this._props[name] = prev[name];
        this._props.state = this.state;
      }
      return this._props;
    }
  }, {
    key: "update",
    value: function update(props) {
      if (props.handleDOMEvents != this._props.handleDOMEvents) ensureListeners(this);
      var prevProps = this._props;
      this._props = props;
      if (props.plugins) {
        props.plugins.forEach(checkStateComponent);
        this.directPlugins = props.plugins;
      }
      this.updateStateInner(props.state, prevProps);
    }
  }, {
    key: "setProps",
    value: function setProps(props) {
      var updated = {};
      for (var name in this._props) updated[name] = this._props[name];
      updated.state = this.state;
      for (var _name2 in props) updated[_name2] = props[_name2];
      this.update(updated);
    }
  }, {
    key: "updateState",
    value: function updateState(state) {
      this.updateStateInner(state, this._props);
    }
  }, {
    key: "updateStateInner",
    value: function updateStateInner(state, prevProps) {
      var _a;
      var prev = this.state,
        redraw = false,
        updateSel = false;
      if (state.storedMarks && this.composing) {
        clearComposition(this);
        updateSel = true;
      }
      this.state = state;
      var pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
      if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
        var nodeViews = buildNodeViews(this);
        if (changedNodeViews(nodeViews, this.nodeViews)) {
          this.nodeViews = nodeViews;
          redraw = true;
        }
      }
      if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) {
        ensureListeners(this);
      }
      this.editable = getEditable(this);
      updateCursorWrapper(this);
      var innerDeco = viewDecorations(this),
        outerDeco = computeDocDeco(this);
      var scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
      var updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
      if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
      var oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && storeScrollPos(this);
      if (updateSel) {
        this.domObserver.stop();
        var forceSelUpdate = updateDoc && (ie || chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && selectionContextChanged(prev.selection, state.selection);
        if (updateDoc) {
          var chromeKludge = chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
          if (this.composing) this.input.compositionNode = findCompositionNode(this);
          if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
            this.docView.updateOuterDeco(outerDeco);
            this.docView.destroy();
            this.docView = docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
          }
          if (chromeKludge && !this.trackWrites) forceSelUpdate = true;
        }
        if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && anchorInRightPlace(this))) {
          selectionToDOM(this, forceSelUpdate);
        } else {
          syncNodeSelection(this, state.selection);
          this.domObserver.setCurSelection();
        }
        this.domObserver.start();
      }
      this.updatePluginViews(prev);
      if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
      if (scroll == "reset") {
        this.dom.scrollTop = 0;
      } else if (scroll == "to selection") {
        this.scrollToSelection();
      } else if (oldScrollPos) {
        resetScrollPos(oldScrollPos);
      }
    }
  }, {
    key: "scrollToSelection",
    value: function scrollToSelection() {
      var _this16 = this;
      var startDOM = this.domSelectionRange().focusNode;
      if (!startDOM || !this.dom.contains(startDOM.nodeType == 1 ? startDOM : startDOM.parentNode)) ;else if (this.someProp("handleScrollToSelection", function (f) {
        return f(_this16);
      })) ;else if (this.state.selection instanceof prosemirrorState.NodeSelection) {
        var target = this.docView.domAfterPos(this.state.selection.from);
        if (target.nodeType == 1) scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
      } else {
        scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
      }
    }
  }, {
    key: "destroyPluginViews",
    value: function destroyPluginViews() {
      var view;
      while (view = this.pluginViews.pop()) if (view.destroy) view.destroy();
    }
  }, {
    key: "updatePluginViews",
    value: function updatePluginViews(prevState) {
      if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
        this.prevDirectPlugins = this.directPlugins;
        this.destroyPluginViews();
        for (var i = 0; i < this.directPlugins.length; i++) {
          var plugin = this.directPlugins[i];
          if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
        }
        for (var _i18 = 0; _i18 < this.state.plugins.length; _i18++) {
          var _plugin = this.state.plugins[_i18];
          if (_plugin.spec.view) this.pluginViews.push(_plugin.spec.view(this));
        }
      } else {
        for (var _i19 = 0; _i19 < this.pluginViews.length; _i19++) {
          var pluginView = this.pluginViews[_i19];
          if (pluginView.update) pluginView.update(this, prevState);
        }
      }
    }
  }, {
    key: "updateDraggedNode",
    value: function updateDraggedNode(dragging, prev) {
      var sel = dragging.node,
        found = -1;
      if (this.state.doc.nodeAt(sel.from) == sel.node) {
        found = sel.from;
      } else {
        var movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
        var moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
        if (moved == sel.node) found = movedPos;
      }
      this.dragging = new Dragging(dragging.slice, dragging.move, found < 0 ? undefined : prosemirrorState.NodeSelection.create(this.state.doc, found));
    }
  }, {
    key: "someProp",
    value: function someProp(propName, f) {
      var prop = this._props && this._props[propName],
        value;
      if (prop != null && (value = f ? f(prop) : prop)) return value;
      for (var i = 0; i < this.directPlugins.length; i++) {
        var _prop = this.directPlugins[i].props[propName];
        if (_prop != null && (value = f ? f(_prop) : _prop)) return value;
      }
      var plugins = this.state.plugins;
      if (plugins) for (var _i20 = 0; _i20 < plugins.length; _i20++) {
        var _prop2 = plugins[_i20].props[propName];
        if (_prop2 != null && (value = f ? f(_prop2) : _prop2)) return value;
      }
    }
  }, {
    key: "hasFocus",
    value: function hasFocus() {
      if (ie) {
        var node = this.root.activeElement;
        if (node == this.dom) return true;
        if (!node || !this.dom.contains(node)) return false;
        while (node && this.dom != node && this.dom.contains(node)) {
          if (node.contentEditable == 'false') return false;
          node = node.parentElement;
        }
        return true;
      }
      return this.root.activeElement == this.dom;
    }
  }, {
    key: "focus",
    value: function focus() {
      this.domObserver.stop();
      if (this.editable) focusPreventScroll(this.dom);
      selectionToDOM(this);
      this.domObserver.start();
    }
  }, {
    key: "root",
    get: function get() {
      var _this17 = this;
      var cached = this._root;
      if (cached == null) {
        var _loop5 = function _loop5(search) {
            if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
              if (!search.getSelection) Object.getPrototypeOf(search).getSelection = function () {
                return search.ownerDocument.getSelection();
              };
              return {
                v: _this17._root = search
              };
            }
          },
          _ret3;
        for (var search = this.dom.parentNode; search; search = search.parentNode) {
          _ret3 = _loop5(search);
          if (_ret3) return _ret3.v;
        }
      }
      return cached || document;
    }
  }, {
    key: "updateRoot",
    value: function updateRoot() {
      this._root = null;
    }
  }, {
    key: "posAtCoords",
    value: function posAtCoords(coords) {
      return _posAtCoords(this, coords);
    }
  }, {
    key: "coordsAtPos",
    value: function coordsAtPos(pos) {
      var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return _coordsAtPos(this, pos, side);
    }
  }, {
    key: "domAtPos",
    value: function domAtPos(pos) {
      var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.docView.domFromPos(pos, side);
    }
  }, {
    key: "nodeDOM",
    value: function nodeDOM(pos) {
      var desc = this.docView.descAt(pos);
      return desc ? desc.nodeDOM : null;
    }
  }, {
    key: "posAtDOM",
    value: function posAtDOM(node, offset) {
      var bias = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      var pos = this.docView.posFromDOM(node, offset, bias);
      if (pos == null) throw new RangeError("DOM position not inside the editor");
      return pos;
    }
  }, {
    key: "endOfTextblock",
    value: function endOfTextblock(dir, state) {
      return _endOfTextblock(this, state || this.state, dir);
    }
  }, {
    key: "pasteHTML",
    value: function pasteHTML(html, event) {
      return doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
  }, {
    key: "pasteText",
    value: function pasteText(text, event) {
      return doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
  }, {
    key: "serializeForClipboard",
    value: function serializeForClipboard(slice) {
      return _serializeForClipboard(this, slice);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (!this.docView) return;
      destroyInput(this);
      this.destroyPluginViews();
      if (this.mounted) {
        this.docView.update(this.state.doc, [], viewDecorations(this), this);
        this.dom.textContent = "";
      } else if (this.dom.parentNode) {
        this.dom.parentNode.removeChild(this.dom);
      }
      this.docView.destroy();
      this.docView = null;
      clearReusedRange();
    }
  }, {
    key: "isDestroyed",
    get: function get() {
      return this.docView == null;
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      return _dispatchEvent(this, event);
    }
  }, {
    key: "domSelectionRange",
    value: function domSelectionRange() {
      var sel = this.domSelection();
      if (!sel) return {
        focusNode: null,
        focusOffset: 0,
        anchorNode: null,
        anchorOffset: 0
      };
      return safari && this.root.nodeType === 11 && deepActiveElement(this.dom.ownerDocument) == this.dom && safariShadowSelectionRange(this, sel) || sel;
    }
  }, {
    key: "domSelection",
    value: function domSelection() {
      return this.root.getSelection();
    }
  }]);
  return EditorView;
}();
EditorView.prototype.dispatch = function (tr) {
  var dispatchTransaction = this._props.dispatchTransaction;
  if (dispatchTransaction) dispatchTransaction.call(this, tr);else this.updateState(this.state.apply(tr));
};
function computeDocDeco(view) {
  var attrs = Object.create(null);
  attrs["class"] = "ProseMirror";
  attrs.contenteditable = String(view.editable);
  view.someProp("attributes", function (value) {
    if (typeof value == "function") value = value(view.state);
    if (value) for (var attr in value) {
      if (attr == "class") attrs["class"] += " " + value[attr];else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
    }
  });
  if (!attrs.translate) attrs.translate = "no";
  return [Decoration.node(0, view.state.doc.content.size, attrs)];
}
function updateCursorWrapper(view) {
  if (view.markCursor) {
    var dom = document.createElement("img");
    dom.className = "ProseMirror-separator";
    dom.setAttribute("mark-placeholder", "true");
    dom.setAttribute("alt", "");
    view.cursorWrapper = {
      dom: dom,
      deco: Decoration.widget(view.state.selection.from, dom, {
        raw: true,
        marks: view.markCursor
      })
    };
  } else {
    view.cursorWrapper = null;
  }
}
function getEditable(view) {
  return !view.someProp("editable", function (value) {
    return value(view.state) === false;
  });
}
function selectionContextChanged(sel1, sel2) {
  var depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
  return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function buildNodeViews(view) {
  var result = Object.create(null);
  function add(obj) {
    for (var _prop3 in obj) if (!Object.prototype.hasOwnProperty.call(result, _prop3)) result[_prop3] = obj[_prop3];
  }
  view.someProp("nodeViews", add);
  view.someProp("markViews", add);
  return result;
}
function changedNodeViews(a, b) {
  var nA = 0,
    nB = 0;
  for (var _prop4 in a) {
    if (a[_prop4] != b[_prop4]) return true;
    nA++;
  }
  for (var _ in b) nB++;
  return nA != nB;
}
function checkStateComponent(plugin) {
  if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}
exports.Decoration = Decoration;
exports.DecorationSet = DecorationSet;
exports.EditorView = EditorView;
exports.__endComposition = __endComposition;
exports.__parseFromClipboard = __parseFromClipboard;


/***/ }),

/***/ 63958:
/***/ (function(module) {

"use strict";


var GOOD_LEAF_SIZE = 200;

// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var RopeSequence = function RopeSequence () {};

RopeSequence.prototype.append = function append (other) {
  if (!other.length) { return this }
  other = RopeSequence.from(other);

  return (!this.length && other) ||
    (other.length < GOOD_LEAF_SIZE && this.leafAppend(other)) ||
    (this.length < GOOD_LEAF_SIZE && other.leafPrepend(this)) ||
    this.appendInner(other)
};

// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
RopeSequence.prototype.prepend = function prepend (other) {
  if (!other.length) { return this }
  return RopeSequence.from(other).append(this)
};

RopeSequence.prototype.appendInner = function appendInner (other) {
  return new Append(this, other)
};

// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
RopeSequence.prototype.slice = function slice (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  if (from >= to) { return RopeSequence.empty }
  return this.sliceInner(Math.max(0, from), Math.min(this.length, to))
};

// :: (number) → T
// Retrieve the element at the given position from this rope.
RopeSequence.prototype.get = function get (i) {
  if (i < 0 || i >= this.length) { return undefined }
  return this.getInner(i)
};

// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
RopeSequence.prototype.forEach = function forEach (f, from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  if (from <= to)
    { this.forEachInner(f, from, to, 0); }
  else
    { this.forEachInvertedInner(f, from, to, 0); }
};

// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
RopeSequence.prototype.map = function map (f, from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  var result = [];
  this.forEach(function (elt, i) { return result.push(f(elt, i)); }, from, to);
  return result
};

// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
RopeSequence.from = function from (values) {
  if (values instanceof RopeSequence) { return values }
  return values && values.length ? new Leaf(values) : RopeSequence.empty
};

var Leaf = /*@__PURE__*/(function (RopeSequence) {
  function Leaf(values) {
    RopeSequence.call(this);
    this.values = values;
  }

  if ( RopeSequence ) Leaf.__proto__ = RopeSequence;
  Leaf.prototype = Object.create( RopeSequence && RopeSequence.prototype );
  Leaf.prototype.constructor = Leaf;

  var prototypeAccessors = { length: { configurable: true },depth: { configurable: true } };

  Leaf.prototype.flatten = function flatten () {
    return this.values
  };

  Leaf.prototype.sliceInner = function sliceInner (from, to) {
    if (from == 0 && to == this.length) { return this }
    return new Leaf(this.values.slice(from, to))
  };

  Leaf.prototype.getInner = function getInner (i) {
    return this.values[i]
  };

  Leaf.prototype.forEachInner = function forEachInner (f, from, to, start) {
    for (var i = from; i < to; i++)
      { if (f(this.values[i], start + i) === false) { return false } }
  };

  Leaf.prototype.forEachInvertedInner = function forEachInvertedInner (f, from, to, start) {
    for (var i = from - 1; i >= to; i--)
      { if (f(this.values[i], start + i) === false) { return false } }
  };

  Leaf.prototype.leafAppend = function leafAppend (other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE)
      { return new Leaf(this.values.concat(other.flatten())) }
  };

  Leaf.prototype.leafPrepend = function leafPrepend (other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE)
      { return new Leaf(other.flatten().concat(this.values)) }
  };

  prototypeAccessors.length.get = function () { return this.values.length };

  prototypeAccessors.depth.get = function () { return 0 };

  Object.defineProperties( Leaf.prototype, prototypeAccessors );

  return Leaf;
}(RopeSequence));

// :: RopeSequence
// The empty rope sequence.
RopeSequence.empty = new Leaf([]);

var Append = /*@__PURE__*/(function (RopeSequence) {
  function Append(left, right) {
    RopeSequence.call(this);
    this.left = left;
    this.right = right;
    this.length = left.length + right.length;
    this.depth = Math.max(left.depth, right.depth) + 1;
  }

  if ( RopeSequence ) Append.__proto__ = RopeSequence;
  Append.prototype = Object.create( RopeSequence && RopeSequence.prototype );
  Append.prototype.constructor = Append;

  Append.prototype.flatten = function flatten () {
    return this.left.flatten().concat(this.right.flatten())
  };

  Append.prototype.getInner = function getInner (i) {
    return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length)
  };

  Append.prototype.forEachInner = function forEachInner (f, from, to, start) {
    var leftLen = this.left.length;
    if (from < leftLen &&
        this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false)
      { return false }
    if (to > leftLen &&
        this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false)
      { return false }
  };

  Append.prototype.forEachInvertedInner = function forEachInvertedInner (f, from, to, start) {
    var leftLen = this.left.length;
    if (from > leftLen &&
        this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false)
      { return false }
    if (to < leftLen &&
        this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false)
      { return false }
  };

  Append.prototype.sliceInner = function sliceInner (from, to) {
    if (from == 0 && to == this.length) { return this }
    var leftLen = this.left.length;
    if (to <= leftLen) { return this.left.slice(from, to) }
    if (from >= leftLen) { return this.right.slice(from - leftLen, to - leftLen) }
    return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen))
  };

  Append.prototype.leafAppend = function leafAppend (other) {
    var inner = this.right.leafAppend(other);
    if (inner) { return new Append(this.left, inner) }
  };

  Append.prototype.leafPrepend = function leafPrepend (other) {
    var inner = this.left.leafPrepend(other);
    if (inner) { return new Append(inner, this.right) }
  };

  Append.prototype.appendInner = function appendInner (other) {
    if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1)
      { return new Append(this.left, new Append(this.right, other)) }
    return new Append(this, other)
  };

  return Append;
}(RopeSequence));

module.exports = RopeSequence;


/***/ }),

/***/ 26691:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var base = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
};

var shift = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: "\""
};

var mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);

// Fill in the digit keys
for (var i = 0; i < 10; i++) base[48 + i] = base[96 + i] = String(i);

// The function keys
for (var i = 1; i <= 24; i++) base[i + 111] = "F" + i;

// And the alphabetic keys
for (var i = 65; i <= 90; i++) {
  base[i] = String.fromCharCode(i + 32);
  shift[i] = String.fromCharCode(i);
}

// For each code that doesn't have a shift-equivalent, copy the base name
for (var code in base) if (!shift.hasOwnProperty(code)) shift[code] = base[code];

function keyName(event) {
  // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
  // On IE, shift effect is never included in `.key`.
  var ignoreKey = mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey ||
      ie && event.shiftKey && event.key && event.key.length == 1 ||
      event.key == "Unidentified";
  var name = (!ignoreKey && event.key) ||
    (event.shiftKey ? shift : base)[event.keyCode] ||
    event.key || "Unidentified";
  // Edge sometimes produces wrong names (Issue #3)
  if (name == "Esc") name = "Escape";
  if (name == "Del") name = "Delete";
  // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
  if (name == "Left") name = "ArrowLeft";
  if (name == "Up") name = "ArrowUp";
  if (name == "Right") name = "ArrowRight";
  if (name == "Down") name = "ArrowDown";
  return name
}

exports.base = base;
exports.keyName = keyName;
exports.shift = shift;


/***/ }),

/***/ 78668:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}


/***/ }),

/***/ 80325:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}


/***/ }),

/***/ 88569:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),

/***/ 2456:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}


/***/ }),

/***/ 43889:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _callSuper; }
/* harmony export */ });
/* harmony import */ var _getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63382);
/* harmony import */ var _isNativeReflectConstruct_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77536);
/* harmony import */ var _possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58783);



function _callSuper(t, o, e) {
  return o = (0,_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o), (0,_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(t, (0,_isNativeReflectConstruct_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)() ? Reflect.construct(o, e || [], (0,_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(t).constructor) : o.apply(t, e));
}


/***/ }),

/***/ 6223:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


/***/ }),

/***/ 79427:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11241);

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}


/***/ }),

/***/ 56302:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createSuper; }
/* harmony export */ });
/* harmony import */ var _getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63382);
/* harmony import */ var _isNativeReflectConstruct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77536);
/* harmony import */ var _possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58783);



function _createSuper(t) {
  var r = (0,_isNativeReflectConstruct_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
  return function () {
    var e,
      o = (0,_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(t);
    if (r) {
      var s = (0,_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return (0,_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, e);
  };
}


/***/ }),

/***/ 57024:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11241);

function _defineProperty(e, r, t) {
  return (r = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),

/***/ 65260:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 63382:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}


/***/ }),

/***/ 34766:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87806);

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(t, e);
}


/***/ }),

/***/ 76282:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87806);

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(t, o);
}


/***/ }),

/***/ 77536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _isNativeReflectConstruct; }
/* harmony export */ });
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}


/***/ }),

/***/ 81828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}


/***/ }),

/***/ 66025:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 56717:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread2; }
/* harmony export */ });
/* harmony import */ var _defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57024);

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0,_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}


/***/ }),

/***/ 91032:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutProperties; }
/* harmony export */ });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38);

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = (0,_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}


/***/ }),

/***/ 38:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),

/***/ 58783:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45827);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88569);


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == (0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(t);
}


/***/ }),

/***/ 8662:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _regeneratorRuntime; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/OverloadYield.js
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/regeneratorDefine.js
function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine = function regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine(e, r, n, t);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/regenerator.js

function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function () {
    return this;
  }), _regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/regeneratorAsyncIterator.js


function AsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (_regeneratorDefine(AsyncIterator.prototype), _regeneratorDefine(AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), _regeneratorDefine(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/regeneratorAsyncGen.js


function _regeneratorAsyncGen(r, e, t, o, n) {
  return new AsyncIterator(_regenerator().w(r, e, t, o), n || Promise);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/regeneratorAsync.js

function _regeneratorAsync(n, e, r, t, o) {
  var a = _regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/regeneratorKeys.js
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/regeneratorValues.js

function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable");
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js







function _regeneratorRuntime() {
  "use strict";

  var r = _regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    "throw": 1,
    "return": 2,
    "break": 3,
    "continue": 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        "catch": function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, _regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new _OverloadYield(r, e);
      },
      AsyncIterator: AsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}


/***/ }),

/***/ 87806:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),

/***/ 40656:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(80325);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(3422);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(66025);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return (0,arrayWithHoles/* default */.Z)(r) || _iterableToArrayLimit(r, e) || (0,unsupportedIterableToArray/* default */.Z)(r, e) || (0,nonIterableRest/* default */.Z)();
}


/***/ }),

/***/ 75574:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80325);
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81828);
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3422);
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66025);




function _toArray(r) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(r) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(r) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 83889:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(78668);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return (0,arrayLikeToArray/* default */.Z)(r);
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(81828);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(3422);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || (0,iterableToArray/* default */.Z)(r) || (0,unsupportedIterableToArray/* default */.Z)(r) || _nonIterableSpread();
}


/***/ }),

/***/ 11241:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ toPropertyKey; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(45827);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != (0,esm_typeof/* default */.Z)(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != (0,esm_typeof/* default */.Z)(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == (0,esm_typeof/* default */.Z)(i) ? i : i + "";
}


/***/ }),

/***/ 45827:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),

/***/ 3422:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78668);

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a) : void 0;
  }
}


/***/ }),

/***/ 45959:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x7": function() { return /* binding */ floating_ui_dom_arrow; },
  "X5": function() { return /* binding */ floating_ui_dom_autoPlacement; },
  "Me": function() { return /* binding */ autoUpdate; },
  "oo": function() { return /* binding */ floating_ui_dom_computePosition; },
  "US": function() { return /* binding */ floating_ui_dom_detectOverflow; },
  "RR": function() { return /* binding */ floating_ui_dom_flip; },
  "Cp": function() { return /* binding */ floating_ui_dom_hide; },
  "Qo": function() { return /* binding */ floating_ui_dom_inline; },
  "dr": function() { return /* binding */ floating_ui_dom_limitShift; },
  "cv": function() { return /* binding */ floating_ui_dom_offset; },
  "Jv": function() { return /* binding */ platform; },
  "uY": function() { return /* binding */ floating_ui_dom_shift; },
  "dp": function() { return /* binding */ floating_ui_dom_size; }
});

// UNUSED EXPORTS: getOverflowAncestors

// EXTERNAL MODULE: ./node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var floating_ui_utils = __webpack_require__(95653);
;// CONCATENATED MODULE: ./node_modules/@floating-ui/core/dist/floating-ui.core.mjs


function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = (0,floating_ui_utils/* getSideAxis */.Qq)(placement);
  const alignmentAxis = (0,floating_ui_utils/* getAlignmentAxis */.Wh)(placement);
  const alignLength = (0,floating_ui_utils/* getAxisLength */.I4)(alignmentAxis);
  const side = (0,floating_ui_utils/* getSide */.k3)(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch ((0,floating_ui_utils/* getAlignment */.hp)(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = (0,floating_ui_utils/* evaluate */.ku)(options, state);
  const paddingObject = (0,floating_ui_utils/* getPaddingObject */.yd)(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = (0,floating_ui_utils/* rectToClientRect */.JB)(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = (0,floating_ui_utils/* rectToClientRect */.JB)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements,
      middlewareData
    } = state;
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = (0,floating_ui_utils/* evaluate */.ku)(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = (0,floating_ui_utils/* getPaddingObject */.yd)(padding);
    const coords = {
      x,
      y
    };
    const axis = (0,floating_ui_utils/* getAlignmentAxis */.Wh)(placement);
    const length = (0,floating_ui_utils/* getAxisLength */.I4)(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = (0,floating_ui_utils/* min */.VV)(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = (0,floating_ui_utils/* min */.VV)(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min$1 = minPadding;
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = (0,floating_ui_utils/* clamp */.uZ)(min$1, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. To ensure `shift()` continues to take action,
    // a single reset is performed when this is true.
    const shouldAddOffset = !middlewareData.arrow && (0,floating_ui_utils/* getAlignment */.hp)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset - alignmentOffset,
        ...(shouldAddOffset && {
          alignmentOffset
        })
      },
      reset: shouldAddOffset
    };
  }
});
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter(placement => (0,floating_ui_utils/* getAlignment */.hp)(placement) === alignment), ...allowedPlacements.filter(placement => (0,floating_ui_utils/* getAlignment */.hp)(placement) !== alignment)] : allowedPlacements.filter(placement => (0,floating_ui_utils/* getSide */.k3)(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter(placement => {
    if (alignment) {
      return (0,floating_ui_utils/* getAlignment */.hp)(placement) === alignment || (autoAlignment ? (0,floating_ui_utils/* getOppositeAlignmentPlacement */.Go)(placement) !== placement : false);
    }
    return true;
  });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'autoPlacement',
    options,
    async fn(state) {
      var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
      const {
        rects,
        middlewareData,
        placement,
        platform,
        elements
      } = state;
      const {
        crossAxis = false,
        alignment,
        allowedPlacements = floating_ui_utils/* placements */.Ct,
        autoAlignment = true,
        ...detectOverflowOptions
      } = (0,floating_ui_utils/* evaluate */.ku)(options, state);
      const placements$1 = alignment !== undefined || allowedPlacements === floating_ui_utils/* placements */.Ct ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
      const currentPlacement = placements$1[currentIndex];
      if (currentPlacement == null) {
        return {};
      }
      const alignmentSides = (0,floating_ui_utils/* getAlignmentSides */.i8)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));

      // Make `computeCoords` start from the right place.
      if (placement !== currentPlacement) {
        return {
          reset: {
            placement: placements$1[0]
          }
        };
      }
      const currentOverflows = [overflow[(0,floating_ui_utils/* getSide */.k3)(currentPlacement)], overflow[alignmentSides[0]], overflow[alignmentSides[1]]];
      const allOverflows = [...(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []), {
        placement: currentPlacement,
        overflows: currentOverflows
      }];
      const nextPlacement = placements$1[currentIndex + 1];

      // There are more placements to check.
      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: nextPlacement
          }
        };
      }
      const placementsSortedByMostSpace = allOverflows.map(d => {
        const alignment = (0,floating_ui_utils/* getAlignment */.hp)(d.placement);
        return [d.placement, alignment && crossAxis ?
        // Check along the mainAxis and main crossAxis side.
        d.overflows.slice(0, 2).reduce((acc, v) => acc + v, 0) :
        // Check only the mainAxis.
        d.overflows[0], d.overflows];
      }).sort((a, b) => a[1] - b[1]);
      const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(d => d[2].slice(0,
      // Aligned placements should not check their opposite crossAxis
      // side.
      (0,floating_ui_utils/* getAlignment */.hp)(d[0]) ? 2 : 3).every(v => v <= 0));
      const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
      if (resetPlacement !== placement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: resetPlacement
          }
        };
      }
      return {};
    }
  };
};

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = (0,floating_ui_utils/* evaluate */.ku)(options, state);

      // If a reset by the arrow was caused due to an alignment offset being
      // added, we should skip any logic now since `flip()` has already done its
      // work.
      // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = (0,floating_ui_utils/* getSide */.k3)(placement);
      const initialSideAxis = (0,floating_ui_utils/* getSideAxis */.Qq)(initialPlacement);
      const isBasePlacement = (0,floating_ui_utils/* getSide */.k3)(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [(0,floating_ui_utils/* getOppositePlacement */.pw)(initialPlacement)] : (0,floating_ui_utils/* getExpandedPlacements */.gy)(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...(0,floating_ui_utils/* getOppositeAxisPlacements */.KX)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = (0,floating_ui_utils/* getAlignmentSides */.i8)(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0,floating_ui_utils/* getSideAxis */.Qq)(nextPlacement) : false;
          if (!ignoreCrossAxisOverflow ||
          // We leave the current main axis only if every placement on that axis
          // overflows the main axis.
          overflowsData.every(d => (0,floating_ui_utils/* getSideAxis */.Qq)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) {
            // Try next placement and re-run the lifecycle.
            return {
              data: {
                index: nextIndex,
                overflows: overflowsData
              },
              reset: {
                placement: nextPlacement
              }
            };
          }
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$filter2;
                const placement = (_overflowsData$filter2 = overflowsData.filter(d => {
                  if (hasFallbackAxisSideDirection) {
                    const currentSideAxis = (0,floating_ui_utils/* getSideAxis */.Qq)(d.placement);
                    return currentSideAxis === initialSideAxis ||
                    // Create a bias to the `y` side axis due to horizontal
                    // reading directions favoring greater width.
                    currentSideAxis === 'y';
                  }
                  return true;
                }).map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return floating_ui_utils/* sides.some */.mA.some(side => overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'hide',
    options,
    async fn(state) {
      const {
        rects
      } = state;
      const {
        strategy = 'referenceHidden',
        ...detectOverflowOptions
      } = (0,floating_ui_utils/* evaluate */.ku)(options, state);
      switch (strategy) {
        case 'referenceHidden':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              elementContext: 'reference'
            });
            const offsets = getSideOffsets(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped(offsets)
              }
            };
          }
        case 'escaped':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              altBoundary: true
            });
            const offsets = getSideOffsets(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped(offsets)
              }
            };
          }
        default:
          {
            return {};
          }
      }
    }
  };
};
function getBoundingRect(rects) {
  const minX = (0,floating_ui_utils/* min */.VV)(...rects.map(rect => rect.left));
  const minY = (0,floating_ui_utils/* min */.VV)(...rects.map(rect => rect.top));
  const maxX = (0,floating_ui_utils/* max */.Fp)(...rects.map(rect => rect.right));
  const maxY = (0,floating_ui_utils/* max */.Fp)(...rects.map(rect => rect.bottom));
  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY
  };
}
function getRectsByLine(rects) {
  const sortedRects = rects.slice().sort((a, b) => a.y - b.y);
  const groups = [];
  let prevRect = null;
  for (let i = 0; i < sortedRects.length; i++) {
    const rect = sortedRects[i];
    if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) {
      groups.push([rect]);
    } else {
      groups[groups.length - 1].push(rect);
    }
    prevRect = rect;
  }
  return groups.map(rect => (0,floating_ui_utils/* rectToClientRect */.JB)(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const inline = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'inline',
    options,
    async fn(state) {
      const {
        placement,
        elements,
        rects,
        platform,
        strategy
      } = state;
      // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
      // ClientRect's bounds, despite the event listener being triggered. A
      // padding of 2 seems to handle this issue.
      const {
        padding = 2,
        x,
        y
      } = (0,floating_ui_utils/* evaluate */.ku)(options, state);
      const nativeClientRects = Array.from((await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference))) || []);
      const clientRects = getRectsByLine(nativeClientRects);
      const fallback = (0,floating_ui_utils/* rectToClientRect */.JB)(getBoundingRect(nativeClientRects));
      const paddingObject = (0,floating_ui_utils/* getPaddingObject */.yd)(padding);
      function getBoundingClientRect() {
        // There are two rects and they are disjoined.
        if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) {
          // Find the first rect in which the point is fully inside.
          return clientRects.find(rect => x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
        }

        // There are 2 or more connected rects.
        if (clientRects.length >= 2) {
          if ((0,floating_ui_utils/* getSideAxis */.Qq)(placement) === 'y') {
            const firstRect = clientRects[0];
            const lastRect = clientRects[clientRects.length - 1];
            const isTop = (0,floating_ui_utils/* getSide */.k3)(placement) === 'top';
            const top = firstRect.top;
            const bottom = lastRect.bottom;
            const left = isTop ? firstRect.left : lastRect.left;
            const right = isTop ? firstRect.right : lastRect.right;
            const width = right - left;
            const height = bottom - top;
            return {
              top,
              bottom,
              left,
              right,
              width,
              height,
              x: left,
              y: top
            };
          }
          const isLeftSide = (0,floating_ui_utils/* getSide */.k3)(placement) === 'left';
          const maxRight = (0,floating_ui_utils/* max */.Fp)(...clientRects.map(rect => rect.right));
          const minLeft = (0,floating_ui_utils/* min */.VV)(...clientRects.map(rect => rect.left));
          const measureRects = clientRects.filter(rect => isLeftSide ? rect.left === minLeft : rect.right === maxRight);
          const top = measureRects[0].top;
          const bottom = measureRects[measureRects.length - 1].bottom;
          const left = minLeft;
          const right = maxRight;
          const width = right - left;
          const height = bottom - top;
          return {
            top,
            bottom,
            left,
            right,
            width,
            height,
            x: left,
            y: top
          };
        }
        return fallback;
      }
      const resetRects = await platform.getElementRects({
        reference: {
          getBoundingClientRect
        },
        floating: elements.floating,
        strategy
      });
      if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) {
        return {
          reset: {
            rects: resetRects
          }
        };
      }
      return {};
    }
  };
};
const originSides = /*#__PURE__*/new Set(['left', 'top']);

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.

async function convertValueToCoords(state, options) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = (0,floating_ui_utils/* getSide */.k3)(placement);
  const alignment = (0,floating_ui_utils/* getAlignment */.hp)(placement);
  const isVertical = (0,floating_ui_utils/* getSideAxis */.Qq)(placement) === 'y';
  const mainAxisMulti = originSides.has(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = (0,floating_ui_utils/* evaluate */.ku)(options, state);

  // eslint-disable-next-line prefer-const
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);

      // If the placement is the same and the arrow caused an alignment offset
      // then we don't need to change the positioning coordinates.
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = (0,floating_ui_utils/* evaluate */.ku)(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = (0,floating_ui_utils/* getSideAxis */.Qq)((0,floating_ui_utils/* getSide */.k3)(placement));
      const mainAxis = (0,floating_ui_utils/* getOppositeAxis */.Rn)(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = (0,floating_ui_utils/* clamp */.uZ)(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = (0,floating_ui_utils/* clamp */.uZ)(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(state) {
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = (0,floating_ui_utils/* evaluate */.ku)(options, state);
      const coords = {
        x,
        y
      };
      const crossAxis = (0,floating_ui_utils/* getSideAxis */.Qq)(placement);
      const mainAxis = (0,floating_ui_utils/* getOppositeAxis */.Rn)(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = (0,floating_ui_utils/* evaluate */.ku)(offset, state);
      const computedOffset = typeof rawOffset === 'number' ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === 'y' ? 'height' : 'width';
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === 'y' ? 'width' : 'height';
        const isOriginSide = originSides.has((0,floating_ui_utils/* getSide */.k3)(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'size',
    options,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const {
        placement,
        rects,
        platform,
        elements
      } = state;
      const {
        apply = () => {},
        ...detectOverflowOptions
      } = (0,floating_ui_utils/* evaluate */.ku)(options, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = (0,floating_ui_utils/* getSide */.k3)(placement);
      const alignment = (0,floating_ui_utils/* getAlignment */.hp)(placement);
      const isYAxis = (0,floating_ui_utils/* getSideAxis */.Qq)(placement) === 'y';
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === 'top' || side === 'bottom') {
        heightSide = side;
        widthSide = alignment === ((await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))) ? 'start' : 'end') ? 'left' : 'right';
      } else {
        widthSide = side;
        heightSide = alignment === 'end' ? 'top' : 'bottom';
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = (0,floating_ui_utils/* min */.VV)(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = (0,floating_ui_utils/* min */.VV)(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = (0,floating_ui_utils/* max */.Fp)(overflow.left, 0);
        const xMax = (0,floating_ui_utils/* max */.Fp)(overflow.right, 0);
        const yMin = (0,floating_ui_utils/* max */.Fp)(overflow.top, 0);
        const yMax = (0,floating_ui_utils/* max */.Fp)(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0,floating_ui_utils/* max */.Fp)(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0,floating_ui_utils/* max */.Fp)(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};

// EXTERNAL MODULE: ./node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
var floating_ui_utils_dom = __webpack_require__(68504);
;// CONCATENATED MODULE: ./node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs




function getCssDimensions(element) {
  const css = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = (0,floating_ui_utils_dom/* isHTMLElement */.Re)(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = (0,floating_ui_utils/* round */.NM)(width) !== offsetWidth || (0,floating_ui_utils/* round */.NM)(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !(0,floating_ui_utils_dom/* isElement */.kK)(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!(0,floating_ui_utils_dom/* isHTMLElement */.Re)(domElement)) {
    return (0,floating_ui_utils/* createCoords */.ze)(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? (0,floating_ui_utils/* round */.NM)(rect.width) : rect.width) / width;
  let y = ($ ? (0,floating_ui_utils/* round */.NM)(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}
const noOffsets = /*#__PURE__*/(0,floating_ui_utils/* createCoords */.ze)(0);
function getVisualOffsets(element) {
  const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(element);
  if (!(0,floating_ui_utils_dom/* isWebKit */.Pf)() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0,floating_ui_utils_dom/* getWindow */.Jj)(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = (0,floating_ui_utils/* createCoords */.ze)(1);
  if (includeScale) {
    if (offsetParent) {
      if ((0,floating_ui_utils_dom/* isElement */.kK)(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : (0,floating_ui_utils/* createCoords */.ze)(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(domElement);
    const offsetWin = offsetParent && (0,floating_ui_utils_dom/* isElement */.kK)(offsetParent) ? (0,floating_ui_utils_dom/* getWindow */.Jj)(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = (0,floating_ui_utils_dom/* getFrameElement */.wK)(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = (0,floating_ui_utils_dom/* getWindow */.Jj)(currentIFrame);
      currentIFrame = (0,floating_ui_utils_dom/* getFrameElement */.wK)(currentWin);
    }
  }
  return (0,floating_ui_utils/* rectToClientRect */.JB)({
    width,
    height,
    x,
    y
  });
}

// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
  const leftScroll = (0,floating_ui_utils_dom/* getNodeScroll */.Lw)(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect((0,floating_ui_utils_dom/* getDocumentElement */.tF)(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
  if (ignoreScrollbarX === void 0) {
    ignoreScrollbarX = false;
  }
  const htmlRect = documentElement.getBoundingClientRect();
  const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 :
  // RTL <body> scrollbar.
  getWindowScrollBarX(documentElement, htmlRect));
  const y = htmlRect.top + scroll.scrollTop;
  return {
    x,
    y
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === 'fixed';
  const documentElement = (0,floating_ui_utils_dom/* getDocumentElement */.tF)(offsetParent);
  const topLayer = elements ? (0,floating_ui_utils_dom/* isTopLayer */.tR)(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = (0,floating_ui_utils/* createCoords */.ze)(1);
  const offsets = (0,floating_ui_utils/* createCoords */.ze)(0);
  const isOffsetParentAnElement = (0,floating_ui_utils_dom/* isHTMLElement */.Re)(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if ((0,floating_ui_utils_dom/* getNodeName */.wk)(offsetParent) !== 'body' || (0,floating_ui_utils_dom/* isOverflowElement */.ao)(documentElement)) {
      scroll = (0,floating_ui_utils_dom/* getNodeScroll */.Lw)(offsetParent);
    }
    if ((0,floating_ui_utils_dom/* isHTMLElement */.Re)(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll, true) : (0,floating_ui_utils/* createCoords */.ze)(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = (0,floating_ui_utils_dom/* getDocumentElement */.tF)(element);
  const scroll = (0,floating_ui_utils_dom/* getNodeScroll */.Lw)(element);
  const body = element.ownerDocument.body;
  const width = (0,floating_ui_utils/* max */.Fp)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = (0,floating_ui_utils/* max */.Fp)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if ((0,floating_ui_utils_dom/* getComputedStyle */.Dx)(body).direction === 'rtl') {
    x += (0,floating_ui_utils/* max */.Fp)(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getViewportRect(element, strategy) {
  const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(element);
  const html = (0,floating_ui_utils_dom/* getDocumentElement */.tF)(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = (0,floating_ui_utils_dom/* isWebKit */.Pf)();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}
const absoluteOrFixed = /*#__PURE__*/new Set(['absolute', 'fixed']);
// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = (0,floating_ui_utils_dom/* isHTMLElement */.Re)(element) ? getScale(element) : (0,floating_ui_utils/* createCoords */.ze)(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect((0,floating_ui_utils_dom/* getDocumentElement */.tF)(element));
  } else if ((0,floating_ui_utils_dom/* isElement */.kK)(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return (0,floating_ui_utils/* rectToClientRect */.JB)(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = (0,floating_ui_utils_dom/* getParentNode */.Ow)(element);
  if (parentNode === stopNode || !(0,floating_ui_utils_dom/* isElement */.kK)(parentNode) || (0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(parentNode)) {
    return false;
  }
  return (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = (0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(element, [], false).filter(el => (0,floating_ui_utils_dom/* isElement */.kK)(el) && (0,floating_ui_utils_dom/* getNodeName */.wk)(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element).position === 'fixed';
  let currentNode = elementIsFixed ? (0,floating_ui_utils_dom/* getParentNode */.Ow)(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while ((0,floating_ui_utils_dom/* isElement */.kK)(currentNode) && !(0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(currentNode)) {
    const computedStyle = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(currentNode);
    const currentNodeIsContaining = (0,floating_ui_utils_dom/* isContainingBlock */.hT)(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || (0,floating_ui_utils_dom/* isOverflowElement */.ao)(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = (0,floating_ui_utils_dom/* getParentNode */.Ow)(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? (0,floating_ui_utils_dom/* isTopLayer */.tR)(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = (0,floating_ui_utils/* max */.Fp)(rect.top, accRect.top);
    accRect.right = (0,floating_ui_utils/* min */.VV)(rect.right, accRect.right);
    accRect.bottom = (0,floating_ui_utils/* min */.VV)(rect.bottom, accRect.bottom);
    accRect.left = (0,floating_ui_utils/* max */.Fp)(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = (0,floating_ui_utils_dom/* isHTMLElement */.Re)(offsetParent);
  const documentElement = (0,floating_ui_utils_dom/* getDocumentElement */.tF)(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = (0,floating_ui_utils/* createCoords */.ze)(0);

  // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
  // Firefox with layout.scrollbar.side = 3 in about:config to test this.
  function setLeftRTLScrollbarOffset() {
    offsets.x = getWindowScrollBarX(documentElement);
  }
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if ((0,floating_ui_utils_dom/* getNodeName */.wk)(offsetParent) !== 'body' || (0,floating_ui_utils_dom/* isOverflowElement */.ao)(documentElement)) {
      scroll = (0,floating_ui_utils_dom/* getNodeScroll */.Lw)(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      setLeftRTLScrollbarOffset();
    }
  }
  if (isFixed && !isOffsetParentAnElement && documentElement) {
    setLeftRTLScrollbarOffset();
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : (0,floating_ui_utils/* createCoords */.ze)(0);
  const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element).position === 'static';
}
function getTrueOffsetParent(element, polyfill) {
  if (!(0,floating_ui_utils_dom/* isHTMLElement */.Re)(element) || (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;

  // Firefox returns the <html> element as the offsetParent if it's non-static,
  // while Chrome and Safari return the <body> element. The <body> element must
  // be used to perform the correct calculations even if the <html> element is
  // non-static.
  if ((0,floating_ui_utils_dom/* getDocumentElement */.tF)(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(element);
  if ((0,floating_ui_utils_dom/* isTopLayer */.tR)(element)) {
    return win;
  }
  if (!(0,floating_ui_utils_dom/* isHTMLElement */.Re)(element)) {
    let svgOffsetParent = (0,floating_ui_utils_dom/* getParentNode */.Ow)(element);
    while (svgOffsetParent && !(0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(svgOffsetParent)) {
      if ((0,floating_ui_utils_dom/* isElement */.kK)(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = (0,floating_ui_utils_dom/* getParentNode */.Ow)(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && (0,floating_ui_utils_dom/* isTableElement */.Ze)(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && (0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(offsetParent) && isStaticPositioned(offsetParent) && !(0,floating_ui_utils_dom/* isContainingBlock */.hT)(offsetParent)) {
    return win;
  }
  return offsetParent || (0,floating_ui_utils_dom/* getContainingBlock */.gQ)(element) || win;
}
const getElementRects = async function (data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element) {
  return (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element).direction === 'rtl';
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement: floating_ui_utils_dom/* getDocumentElement */.tF,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: floating_ui_utils_dom/* isElement */.kK,
  isRTL
};
function rectsAreEqual(a, b) {
  return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = (0,floating_ui_utils_dom/* getDocumentElement */.tF)(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left,
      top,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = (0,floating_ui_utils/* floor */.GW)(top);
    const insetRight = (0,floating_ui_utils/* floor */.GW)(root.clientWidth - (left + width));
    const insetBottom = (0,floating_ui_utils/* floor */.GW)(root.clientHeight - (top + height));
    const insetLeft = (0,floating_ui_utils/* floor */.GW)(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: (0,floating_ui_utils/* max */.Fp)(0, (0,floating_ui_utils/* min */.VV)(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          // If the reference is clipped, the ratio is 0. Throttle the refresh
          // to prevent an infinite loop of updates.
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1000);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        // It's possible that even though the ratio is reported as 1, the
        // element is not actually fully within the IntersectionObserver's root
        // area anymore. This can happen under performance constraints. This may
        // be a bug in the browser's IntersectionObserver implementation. To
        // work around this, we compare the element's bounding rect now with
        // what it was at the time we created the IntersectionObserver. If they
        // are not equal then the element moved, so we refresh.
        refresh();
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (_e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? (0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(referenceEl) : []), ...(0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
const floating_ui_dom_detectOverflow = detectOverflow;

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const floating_ui_dom_offset = offset;

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const floating_ui_dom_autoPlacement = autoPlacement;

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const floating_ui_dom_shift = shift;

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const floating_ui_dom_flip = flip;

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const floating_ui_dom_size = size;

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const floating_ui_dom_hide = hide;

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const floating_ui_dom_arrow = arrow;

/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const floating_ui_dom_inline = inline;

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const floating_ui_dom_limitShift = limitShift;

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */
const floating_ui_dom_computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};


/***/ }),

/***/ 68504:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ getComputedStyle; },
/* harmony export */   "Jj": function() { return /* binding */ getWindow; },
/* harmony export */   "Kx": function() { return /* binding */ getOverflowAncestors; },
/* harmony export */   "Lw": function() { return /* binding */ getNodeScroll; },
/* harmony export */   "Ow": function() { return /* binding */ getParentNode; },
/* harmony export */   "Pf": function() { return /* binding */ isWebKit; },
/* harmony export */   "Py": function() { return /* binding */ isLastTraversableNode; },
/* harmony export */   "Re": function() { return /* binding */ isHTMLElement; },
/* harmony export */   "UG": function() { return /* binding */ isNode; },
/* harmony export */   "Ze": function() { return /* binding */ isTableElement; },
/* harmony export */   "Zq": function() { return /* binding */ isShadowRoot; },
/* harmony export */   "ao": function() { return /* binding */ isOverflowElement; },
/* harmony export */   "gQ": function() { return /* binding */ getContainingBlock; },
/* harmony export */   "hT": function() { return /* binding */ isContainingBlock; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "tF": function() { return /* binding */ getDocumentElement; },
/* harmony export */   "tR": function() { return /* binding */ isTopLayer; },
/* harmony export */   "wK": function() { return /* binding */ getFrameElement; },
/* harmony export */   "wk": function() { return /* binding */ getNodeName; }
/* harmony export */ });
/* unused harmony export getNearestOverflowAncestor */
function hasWindow() {
  return typeof window !== 'undefined';
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
const invalidOverflowDisplayValues = /*#__PURE__*/new Set(['inline', 'contents']);
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !invalidOverflowDisplayValues.has(display);
}
const tableElements = /*#__PURE__*/new Set(['table', 'td', 'th']);
function isTableElement(element) {
  return tableElements.has(getNodeName(element));
}
const topLayerSelectors = [':popover-open', ':modal'];
function isTopLayer(element) {
  return topLayerSelectors.some(selector => {
    try {
      return element.matches(selector);
    } catch (_e) {
      return false;
    }
  });
}
const transformProperties = ['transform', 'translate', 'scale', 'rotate', 'perspective'];
const willChangeValues = ['transform', 'translate', 'scale', 'rotate', 'perspective', 'filter'];
const containValues = ['paint', 'layout', 'strict', 'content'];
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  // https://drafts.csswg.org/css-transforms-2/#individual-transforms
  return transformProperties.some(value => css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || willChangeValues.some(value => (css.willChange || '').includes(value)) || containValues.some(value => (css.contain || '').includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
const lastTraversableNodeNames = /*#__PURE__*/new Set(['html', 'body', '#document']);
function isLastTraversableNode(node) {
  return lastTraversableNodeNames.has(getNodeName(node));
}
function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


/***/ }),

/***/ 95653:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ct": function() { return /* binding */ placements; },
/* harmony export */   "Fp": function() { return /* binding */ max; },
/* harmony export */   "GW": function() { return /* binding */ floor; },
/* harmony export */   "Go": function() { return /* binding */ getOppositeAlignmentPlacement; },
/* harmony export */   "I4": function() { return /* binding */ getAxisLength; },
/* harmony export */   "JB": function() { return /* binding */ rectToClientRect; },
/* harmony export */   "KX": function() { return /* binding */ getOppositeAxisPlacements; },
/* harmony export */   "NM": function() { return /* binding */ round; },
/* harmony export */   "Qq": function() { return /* binding */ getSideAxis; },
/* harmony export */   "Rn": function() { return /* binding */ getOppositeAxis; },
/* harmony export */   "VV": function() { return /* binding */ min; },
/* harmony export */   "Wh": function() { return /* binding */ getAlignmentAxis; },
/* harmony export */   "gy": function() { return /* binding */ getExpandedPlacements; },
/* harmony export */   "hp": function() { return /* binding */ getAlignment; },
/* harmony export */   "i8": function() { return /* binding */ getAlignmentSides; },
/* harmony export */   "k3": function() { return /* binding */ getSide; },
/* harmony export */   "ku": function() { return /* binding */ evaluate; },
/* harmony export */   "mA": function() { return /* binding */ sides; },
/* harmony export */   "pw": function() { return /* binding */ getOppositePlacement; },
/* harmony export */   "uZ": function() { return /* binding */ clamp; },
/* harmony export */   "yd": function() { return /* binding */ getPaddingObject; },
/* harmony export */   "ze": function() { return /* binding */ createCoords; }
/* harmony export */ });
/* unused harmony exports alignments, expandPaddingObject */
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const sides = ['top', 'right', 'bottom', 'left'];
const alignments = ['start', 'end'];
const placements = /*#__PURE__*/sides.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
  return placement.split('-')[0];
}
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
const yAxisSides = /*#__PURE__*/new Set(['top', 'bottom']);
function getSideAxis(placement) {
  return yAxisSides.has(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
const lrPlacement = ['left', 'right'];
const rlPlacement = ['right', 'left'];
const tbPlacement = ['top', 'bottom'];
const btPlacement = ['bottom', 'top'];
function getSideList(side, isStart, rtl) {
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rlPlacement : lrPlacement;
      return isStart ? lrPlacement : rlPlacement;
    case 'left':
    case 'right':
      return isStart ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}


/***/ }),

/***/ 30781:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD =  false || false;


/***/ }),

/***/ 17340:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L2": function() { return /* binding */ getNativeImplementation; },
/* harmony export */   "_6": function() { return /* binding */ clearCachedImplementation; },
/* harmony export */   "iK": function() { return /* binding */ setTimeout; }
/* harmony export */ });
/* unused harmony export fetch */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92049);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3518);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30781);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72553);




/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */

const cachedImplementations = {};

/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */
function getNativeImplementation(name) {
  const cached = cachedImplementations[name];
  if (cached) {
    return cached;
  }
  let impl = _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW */ .m[name];

  // Fast path to avoid DOM I/O
  if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .isNativeFunction */ .QC)(impl)) {
    return cachedImplementations[name] = impl.bind(_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW */ .m);
  }
  const document = _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document */ .m.document;
  // eslint-disable-next-line deprecation/deprecation
  if (document && typeof document.createElement === 'function') {
    try {
      const sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow[name]) {
        impl = contentWindow[name];
      }
      document.head.removeChild(sandbox);
    } catch (e) {
      // Could not create sandbox iframe, just use window.xxx
      _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
  }

  // Sanity check: This _should_ not happen, but if it does, we just skip caching...
  // This can happen e.g. in tests where fetch may not be available in the env, or similar.
  if (!impl) {
    return impl;
  }
  return cachedImplementations[name] = impl.bind(_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW */ .m);
}

/** Clear a cached implementation. */
function clearCachedImplementation(name) {
  cachedImplementations[name] = undefined;
}

/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function fetch(...rest) {
  return getNativeImplementation('fetch')(...rest);
}

/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */
function setTimeout(...rest) {
  return getNativeImplementation('setTimeout')(...rest);
}


/***/ }),

/***/ 30423:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ addClickKeypressInstrumentationHandler; }
/* harmony export */ });
/* unused harmony export instrumentDOM */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29862);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88803);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27275);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72553);


const DEBOUNCE_DURATION = 1000;
let debounceTimerID;
let lastCapturedEventType;
let lastCapturedEventTargetId;

/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addClickKeypressInstrumentationHandler(handler) {
  const type = 'dom';
  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .addHandler */ .Hj)(type, handler);
  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .maybeInstrument */ .D2)(type, instrumentDOM);
}

/** Exported for tests only. */
function instrumentDOM() {
  if (!_types_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW.document */ .m.document) {
    return;
  }

  // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
  // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
  // we instrument `addEventListener` so that we don't end up attaching this handler twice.
  const triggerDOMHandler = _sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers.bind */ .rK.bind(null, 'dom');
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  _types_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW.document.addEventListener */ .m.document.addEventListener('click', globalDOMEventHandler, false);
  _types_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW.document.addEventListener */ .m.document.addEventListener('keypress', globalDOMEventHandler, false);

  // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
  // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
  // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
  // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
  // guaranteed to fire at least once.)
  ['EventTarget', 'Node'].forEach(target => {
    const globalObject = _types_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW */ .m;
    const targetObj = globalObject[target];
    const proto = targetObj && targetObj.prototype;

    // eslint-disable-next-line no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(proto, 'addEventListener', function (originalAddEventListener) {
      return function (type, listener, options) {
        if (type === 'click' || type == 'keypress') {
          try {
            const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
            const handlerForType = handlers[type] = handlers[type] || {
              refCount: 0
            };
            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }
            handlerForType.refCount++;
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListeners` calls with no proper `this` context.
          }
        }
        return originalAddEventListener.call(this, type, listener, options);
      };
    });
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(proto, 'removeEventListener', function (originalRemoveEventListener) {
      return function (type, listener, options) {
        if (type === 'click' || type == 'keypress') {
          try {
            const handlers = this.__sentry_instrumentation_handlers__ || {};
            const handlerForType = handlers[type];
            if (handlerForType) {
              handlerForType.refCount--;
              // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
              if (handlerForType.refCount <= 0) {
                originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                handlerForType.handler = undefined;
                delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
              }

              // If there are no longer any custom handlers of any type on this element, cleanup everything.
              if (Object.keys(handlers).length === 0) {
                delete this.__sentry_instrumentation_handlers__;
              }
            }
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListeners` calls with no proper `this` context.
          }
        }
        return originalRemoveEventListener.call(this, type, listener, options);
      };
    });
  });
}

/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */
function isSimilarToLastCapturedEvent(event) {
  // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
  if (event.type !== lastCapturedEventType) {
    return false;
  }
  try {
    // If both events have the same type, it's still possible that actions were performed on different targets.
    // e.g. 2 clicks on different buttons.
    if (!event.target || event.target._sentryId !== lastCapturedEventTargetId) {
      return false;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
  // to which an event listener was attached), we treat them as the same action, as we want to capture
  // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
  return true;
}

/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(eventType, target) {
  // We are only interested in filtering `keypress` events for now.
  if (eventType !== 'keypress') {
    return false;
  }
  if (!target || !target.tagName) {
    return true;
  }

  // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
  // e.g.tabbing through elements, hotkeys, etc.
  if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
    return false;
  }
  return true;
}

/**
 * Wraps addEventListener to capture UI breadcrumbs
 */
function makeDOMEventHandler(handler, globalListener = false) {
  return event => {
    // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors).
    // Ignore if we've already captured that event.
    if (!event || event['_sentryCaptured']) {
      return;
    }
    const target = getEventTarget(event);

    // We always want to skip _some_ events.
    if (shouldSkipDOMEvent(event.type, target)) {
      return;
    }

    // Mark event as "seen"
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .addNonEnumerableProperty */ .xp)(event, '_sentryCaptured', true);
    if (target && !target._sentryId) {
      // Add UUID to event target so we can identify if
      (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .addNonEnumerableProperty */ .xp)(target, '_sentryId', (0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .uuid4 */ .DM)());
    }
    const name = event.type === 'keypress' ? 'input' : event.type;

    // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
    // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
    // If that's the case, emit the previous event and store locally the newly-captured DOM event.
    if (!isSimilarToLastCapturedEvent(event)) {
      const handlerData = {
        event,
        name,
        global: globalListener
      };
      handler(handlerData);
      lastCapturedEventType = event.type;
      lastCapturedEventTargetId = target ? target._sentryId : undefined;
    }

    // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
    clearTimeout(debounceTimerID);
    debounceTimerID = _types_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW.setTimeout */ .m.setTimeout(() => {
      lastCapturedEventTargetId = undefined;
      lastCapturedEventType = undefined;
    }, DEBOUNCE_DURATION);
  };
}
function getEventTarget(event) {
  try {
    return event.target;
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    return null;
  }
}


/***/ }),

/***/ 29465:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ addHistoryInstrumentationHandler; }
});

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/instrument/handlers.js
var handlers = __webpack_require__(29862);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/worldwide.js
var worldwide = __webpack_require__(23867);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/vendor/supportsHistory.js


// Based on https://github.com/angular/angular.js/pull/13945/files
// The MIT License

const WINDOW = worldwide/* GLOBAL_OBJ */.n;

/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  // TODO(v9): Remove this custom check, it is pretty old and likely not needed anymore
  const chromeVar = WINDOW.chrome;
  const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
  const hasHistoryApi = 'history' in WINDOW && !!WINDOW.history.pushState && !!WINDOW.history.replaceState;
  return !isChromePackagedApp && hasHistoryApi;
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/object.js
var object = __webpack_require__(88803);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/types.js
var types = __webpack_require__(72553);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/instrument/history.js


let lastHref;

/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addHistoryInstrumentationHandler(handler) {
  const type = 'history';
  (0,handlers/* addHandler */.Hj)(type, handler);
  (0,handlers/* maybeInstrument */.D2)(type, instrumentHistory);
}
function instrumentHistory() {
  if (!supportsHistory()) {
    return;
  }
  const oldOnPopState = types/* WINDOW.onpopstate */.m.onpopstate;
  types/* WINDOW.onpopstate */.m.onpopstate = function (...args) {
    const to = types/* WINDOW.location.href */.m.location.href;
    // keep track of the current URL state, as we always receive only the updated state
    const from = lastHref;
    lastHref = to;
    const handlerData = {
      from,
      to
    };
    (0,handlers/* triggerHandlers */.rK)('history', handlerData);
    if (oldOnPopState) {
      // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
      // https://github.com/getsentry/sentry-javascript/issues/3344
      // https://github.com/bugsnag/bugsnag-js/issues/469
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
        // no-empty
      }
    }
  };
  function historyReplacementFunction(originalHistoryFunction) {
    return function (...args) {
      const url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        const from = lastHref;
        const to = String(url);
        // keep track of the current URL state, as we always receive only the updated state
        lastHref = to;
        const handlerData = {
          from,
          to
        };
        (0,handlers/* triggerHandlers */.rK)('history', handlerData);
      }
      return originalHistoryFunction.apply(this, args);
    };
  }
  (0,object/* fill */.hl)(types/* WINDOW.history */.m.history, 'pushState', historyReplacementFunction);
  (0,object/* fill */.hl)(types/* WINDOW.history */.m.history, 'replaceState', historyReplacementFunction);
}


/***/ }),

/***/ 27325:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UK": function() { return /* binding */ addXhrInstrumentationHandler; },
/* harmony export */   "xU": function() { return /* binding */ SENTRY_XHR_DATA_KEY; }
/* harmony export */ });
/* unused harmony export instrumentXHR */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29862);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27870);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92668);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72553);


const SENTRY_XHR_DATA_KEY = '__sentry_xhr_v3__';

/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addXhrInstrumentationHandler(handler) {
  const type = 'xhr';
  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .addHandler */ .Hj)(type, handler);
  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .maybeInstrument */ .D2)(type, instrumentXHR);
}

/** Exported only for tests. */
function instrumentXHR() {
  if (!_types_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW.XMLHttpRequest */ .m.XMLHttpRequest) {
    return;
  }
  const xhrproto = XMLHttpRequest.prototype;

  // eslint-disable-next-line @typescript-eslint/unbound-method
  xhrproto.open = new Proxy(xhrproto.open, {
    apply(originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
      // NOTE: If you are a Sentry user, and you are seeing this stack frame,
      //       it means the error, that was caused by your XHR call did not
      //       have a stack trace. If you are using HttpClient integration,
      //       this is the expected behavior, as we are using this virtual error to capture
      //       the location of your XHR call, and group your HttpClient events accordingly.
      const virtualError = new Error();
      const startTimestamp = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .timestampInSeconds */ .ph)() * 1000;

      // open() should always be called with two or more arguments
      // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
      const method = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
      const url = parseUrl(xhrOpenArgArray[1]);
      if (!method || !url) {
        return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
      }
      xhrOpenThisArg[SENTRY_XHR_DATA_KEY] = {
        method,
        url,
        request_headers: {}
      };

      // if Sentry key appears in URL, don't capture it as a request
      if (method === 'POST' && url.match(/sentry_key/)) {
        xhrOpenThisArg.__sentry_own_request__ = true;
      }
      const onreadystatechangeHandler = () => {
        // For whatever reason, this is not the same instance here as from the outer method
        const xhrInfo = xhrOpenThisArg[SENTRY_XHR_DATA_KEY];
        if (!xhrInfo) {
          return;
        }
        if (xhrOpenThisArg.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            xhrInfo.status_code = xhrOpenThisArg.status;
          } catch (e) {
            /* do nothing */
          }
          const handlerData = {
            endTimestamp: (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .timestampInSeconds */ .ph)() * 1000,
            startTimestamp,
            xhr: xhrOpenThisArg,
            virtualError
          };
          (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)('xhr', handlerData);
        }
      };
      if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') {
        xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
          apply(originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
            onreadystatechangeHandler();
            return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
          }
        });
      } else {
        xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      // Intercepting `setRequestHeader` to access the request headers of XHR instance.
      // This will only work for user/library defined headers, not for the default/browser-assigned headers.
      // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
      xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
        apply(originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
          const [header, value] = setRequestHeaderArgArray;
          const xhrInfo = setRequestHeaderThisArg[SENTRY_XHR_DATA_KEY];
          if (xhrInfo && (0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD)(header) && (0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD)(value)) {
            xhrInfo.request_headers[header.toLowerCase()] = value;
          }
          return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
        }
      });
      return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
    }
  });

  // eslint-disable-next-line @typescript-eslint/unbound-method
  xhrproto.send = new Proxy(xhrproto.send, {
    apply(originalSend, sendThisArg, sendArgArray) {
      const sentryXhrData = sendThisArg[SENTRY_XHR_DATA_KEY];
      if (!sentryXhrData) {
        return originalSend.apply(sendThisArg, sendArgArray);
      }
      if (sendArgArray[0] !== undefined) {
        sentryXhrData.body = sendArgArray[0];
      }
      const handlerData = {
        startTimestamp: (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .timestampInSeconds */ .ph)() * 1000,
        xhr: sendThisArg
      };
      (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)('xhr', handlerData);
      return originalSend.apply(sendThisArg, sendArgArray);
    }
  });
}
function parseUrl(url) {
  if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD)(url)) {
    return url;
  }
  try {
    // url can be a string or URL
    // but since URL is not available in IE11, we do not check for it,
    // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
    // If that fails, we just return undefined
    return url.toString();
  } catch (e2) {} // eslint-disable-line no-empty

  return undefined;
}


/***/ }),

/***/ 72553:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ WINDOW; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23867);

const WINDOW = _sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n;


/***/ }),

/***/ 77818:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD =  false || false;


/***/ }),

/***/ 18861:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wz": function() { return /* binding */ shouldIgnoreOnError; },
/* harmony export */   "m9": function() { return /* binding */ WINDOW; },
/* harmony export */   "re": function() { return /* binding */ wrap; }
/* harmony export */ });
/* unused harmony export ignoreNextOnError */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23867);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88803);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97308);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27275);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2155);

const WINDOW = _sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n;
let ignoreOnError = 0;

/**
 * @hidden
 */
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}

/**
 * @hidden
 */
function ignoreNextOnError() {
  // onerror should trigger before setTimeout
  ignoreOnError++;
  setTimeout(() => {
    ignoreOnError--;
  });
}

// eslint-disable-next-line @typescript-eslint/ban-types

/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options = {}) {
  // for future readers what this does is wrap a function and then create
  // a bi-directional wrapping between them.
  //
  // example: wrapped = wrap(original);
  //  original.__sentry_wrapped__ -> wrapped
  //  wrapped.__sentry_original__ -> original

  function isFunction(fn) {
    return typeof fn === 'function';
  }
  if (!isFunction(fn)) {
    return fn;
  }
  try {
    // if we're dealing with a function that was previously wrapped, return
    // the original wrapper.
    const wrapper = fn.__sentry_wrapped__;
    if (wrapper) {
      if (typeof wrapper === 'function') {
        return wrapper;
      } else {
        // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
        // that something messed with it. In that case we want to return the originally passed function.
        return fn;
      }
    }

    // We don't wanna wrap it twice
    if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getOriginalFunction */ .HK)(fn)) {
      return fn;
    }
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    // Bail on wrapping and return the function as-is (defers to window.onerror).
    return fn;
  }

  // Wrap the function itself
  // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
  const sentryWrapped = function (...args) {
    try {
      // Also wrap arguments that are themselves functions
      const wrappedArguments = args.map(arg => wrap(arg, options));

      // Attempt to invoke user-land function
      // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
      //       means the sentry.javascript SDK caught an error invoking your application code. This
      //       is expected behavior and NOT indicative of a bug with sentry.javascript.
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();
      (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .withScope */ .$e)(scope => {
        scope.addEventProcessor(event => {
          if (options.mechanism) {
            (0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionTypeValue */ .Db)(event, undefined, undefined);
            (0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionMechanism */ .EG)(event, options.mechanism);
          }
          event.extra = {
            ...event.extra,
            arguments: args
          };
          return event;
        });
        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb)(ex);
      });
      throw ex;
    }
  };

  // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
  try {
    for (const property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch (e2) {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
  }

  // Signal that this function has been wrapped/filled already
  // for both debugging and to prevent it to being wrapped/filled twice
  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .markFunctionWrapped */ .$Q)(sentryWrapped, fn);
  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(fn, '__sentry_wrapped__', sentryWrapped);

  // Restore original function name (not all browsers allow that)
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, 'name', {
        get() {
          return fn.name;
        }
      });
    }
  } catch (e3) {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
  }
  return sentryWrapped;
}


/***/ }),

/***/ 25169:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nV": function() { return /* binding */ getDefaultIntegrations; },
  "S1": function() { return /* binding */ init; },
  "jp": function() { return /* binding */ showReportDialog; }
});

// UNUSED EXPORTS: captureUserFeedback, forceLoad, onLoad

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/debug-build.js
var debug_build = __webpack_require__(27344);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/integration.js
var esm_integration = __webpack_require__(12260);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/logger.js
var logger = __webpack_require__(3518);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/misc.js
var misc = __webpack_require__(27275);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/string.js
var string = __webpack_require__(24909);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/integrations/inboundfilters.js






// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/, /^ResizeObserver loop completed with undelivered notifications.$/,
// The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
/^Cannot redefine property: googletag$/,
// This is thrown when google tag manager is used in combination with an ad blocker
"undefined is not an object (evaluating 'a.L')",
// Random error that happens but not actionable or noticeable to end-users.
'can\'t redefine non-configurable property "solana"',
// Probably a browser extension or custom browser (Brave) throwing this error
"vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
// Error thrown by GTM, seemingly not affecting end-users
"Can't find variable: _AutofillCallbackHandler",
// Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
/^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/ // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
];

/** Options for the InboundFilters integration */

const INTEGRATION_NAME = 'InboundFilters';
const _inboundFiltersIntegration = (options = {}) => {
  return {
    name: INTEGRATION_NAME,
    processEvent(event, _hint, client) {
      const clientOptions = client.getOptions();
      const mergedOptions = _mergeOptions(options, clientOptions);
      return _shouldDropEvent(event, mergedOptions) ? null : event;
    }
  };
};
const inboundFiltersIntegration = (0,esm_integration/* defineIntegration */._I)(_inboundFiltersIntegration);
function _mergeOptions(internalOptions = {}, clientOptions = {}) {
  return {
    allowUrls: [...(internalOptions.allowUrls || []), ...(clientOptions.allowUrls || [])],
    denyUrls: [...(internalOptions.denyUrls || []), ...(clientOptions.denyUrls || [])],
    ignoreErrors: [...(internalOptions.ignoreErrors || []), ...(clientOptions.ignoreErrors || []), ...(internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS)],
    ignoreTransactions: [...(internalOptions.ignoreTransactions || []), ...(clientOptions.ignoreTransactions || [])],
    ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
  };
}
function _shouldDropEvent(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`);
    return true;
  }
  if (_isIgnoredError(event, options.ignoreErrors)) {
    debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`);
    return true;
  }
  if (_isUselessError(event)) {
    debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`);
    return true;
  }
  if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
    debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`);
    return true;
  }
  if (_isDeniedUrl(event, options.denyUrls)) {
    debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}.\nUrl: ${_getEventFilterUrl(event)}`);
    return true;
  }
  if (!_isAllowedUrl(event, options.allowUrls)) {
    debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}.\nUrl: ${_getEventFilterUrl(event)}`);
    return true;
  }
  return false;
}
function _isIgnoredError(event, ignoreErrors) {
  // If event.type, this is not an error
  if (event.type || !ignoreErrors || !ignoreErrors.length) {
    return false;
  }
  return _getPossibleEventMessages(event).some(message => (0,string/* stringMatchesSomePattern */.U0)(message, ignoreErrors));
}
function _isIgnoredTransaction(event, ignoreTransactions) {
  if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) {
    return false;
  }
  const name = event.transaction;
  return name ? (0,string/* stringMatchesSomePattern */.U0)(name, ignoreTransactions) : false;
}
function _isDeniedUrl(event, denyUrls) {
  // TODO: Use Glob instead?
  if (!denyUrls || !denyUrls.length) {
    return false;
  }
  const url = _getEventFilterUrl(event);
  return !url ? false : (0,string/* stringMatchesSomePattern */.U0)(url, denyUrls);
}
function _isAllowedUrl(event, allowUrls) {
  // TODO: Use Glob instead?
  if (!allowUrls || !allowUrls.length) {
    return true;
  }
  const url = _getEventFilterUrl(event);
  return !url ? true : (0,string/* stringMatchesSomePattern */.U0)(url, allowUrls);
}
function _getPossibleEventMessages(event) {
  const possibleMessages = [];
  if (event.message) {
    possibleMessages.push(event.message);
  }
  let lastException;
  try {
    // @ts-expect-error Try catching to save bundle size
    lastException = event.exception.values[event.exception.values.length - 1];
  } catch (e) {
    // try catching to save bundle size checking existence of variables
  }
  if (lastException) {
    if (lastException.value) {
      possibleMessages.push(lastException.value);
      if (lastException.type) {
        possibleMessages.push(`${lastException.type}: ${lastException.value}`);
      }
    }
  }
  return possibleMessages;
}
function _isSentryError(event) {
  try {
    // @ts-expect-error can't be a sentry error if undefined
    return event.exception.values[0].type === 'SentryError';
  } catch (e) {
    // ignore
  }
  return false;
}
function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    const frame = frames[i];
    if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
      return frame.filename || null;
    }
  }
  return null;
}
function _getEventFilterUrl(event) {
  try {
    let frames;
    try {
      // @ts-expect-error we only care about frames if the whole thing here is defined
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {
      // ignore
    }
    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    debug_build/* DEBUG_BUILD */.X && logger/* logger.error */.kg.error(`Cannot extract url for event ${(0,misc/* getEventDescription */.jH)(event)}`);
    return null;
  }
}
function _isUselessError(event) {
  if (event.type) {
    // event is not an error
    return false;
  }

  // We only want to consider events for dropping that actually have recorded exception values.
  if (!event.exception || !event.exception.values || event.exception.values.length === 0) {
    return false;
  }
  return (
    // No top-level message
    !event.message &&
    // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some(value => value.stacktrace || value.type && value.type !== 'Error' || value.value)
  );
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/currentScopes.js
var currentScopes = __webpack_require__(97308);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/object.js
var object = __webpack_require__(88803);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/integrations/functiontostring.js



let originalFunctionToString;
const functiontostring_INTEGRATION_NAME = 'FunctionToString';
const SETUP_CLIENTS = new WeakMap();
const _functionToStringIntegration = () => {
  return {
    name: functiontostring_INTEGRATION_NAME,
    setupOnce() {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      originalFunctionToString = Function.prototype.toString;

      // intrinsics (like Function.prototype) might be immutable in some environments
      // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
      try {
        Function.prototype.toString = function (...args) {
          const originalFunction = (0,object/* getOriginalFunction */.HK)(this);
          const context = SETUP_CLIENTS.has((0,currentScopes/* getClient */.s3)()) && originalFunction !== undefined ? originalFunction : this;
          return originalFunctionToString.apply(context, args);
        };
      } catch (e) {
        // ignore errors here, just don't patch this
      }
    },
    setup(client) {
      SETUP_CLIENTS.set(client, true);
    }
  };
};

/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */
const functionToStringIntegration = (0,esm_integration/* defineIntegration */._I)(_functionToStringIntegration);

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/stacktrace.js
var stacktrace = __webpack_require__(93113);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/integrations/dedupe.js




const dedupe_INTEGRATION_NAME = 'Dedupe';
const _dedupeIntegration = () => {
  let previousEvent;
  return {
    name: dedupe_INTEGRATION_NAME,
    processEvent(currentEvent) {
      // We want to ignore any non-error type events, e.g. transactions or replays
      // These should never be deduped, and also not be compared against as _previousEvent.
      if (currentEvent.type) {
        return currentEvent;
      }

      // Juuust in case something goes wrong
      try {
        if (dedupe_shouldDropEvent(currentEvent, previousEvent)) {
          debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn('Event dropped due to being a duplicate of previously captured event.');
          return null;
        }
      } catch (_oO) {} // eslint-disable-line no-empty

      return previousEvent = currentEvent;
    }
  };
};

/**
 * Deduplication filter.
 */
const dedupeIntegration = (0,esm_integration/* defineIntegration */._I)(_dedupeIntegration);

/** only exported for tests. */
function dedupe_shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }
  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }
  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }
  return false;
}
function _isSameMessageEvent(currentEvent, previousEvent) {
  const currentMessage = currentEvent.message;
  const previousMessage = previousEvent.message;

  // If neither event has a message property, they were both exceptions, so bail out
  if (!currentMessage && !previousMessage) {
    return false;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if (currentMessage && !previousMessage || !currentMessage && previousMessage) {
    return false;
  }
  if (currentMessage !== previousMessage) {
    return false;
  }
  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }
  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }
  return true;
}
function _isSameExceptionEvent(currentEvent, previousEvent) {
  const previousException = _getExceptionFromEvent(previousEvent);
  const currentException = _getExceptionFromEvent(currentEvent);
  if (!previousException || !currentException) {
    return false;
  }
  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }
  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }
  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }
  return true;
}
function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = (0,stacktrace/* getFramesFromEvent */.Fr)(currentEvent);
  let previousFrames = (0,stacktrace/* getFramesFromEvent */.Fr)(previousEvent);

  // If neither event has a stacktrace, they are assumed to be the same
  if (!currentFrames && !previousFrames) {
    return true;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if (currentFrames && !previousFrames || !currentFrames && previousFrames) {
    return false;
  }
  currentFrames = currentFrames;
  previousFrames = previousFrames;

  // If number of frames differ, they are not the same
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }

  // Otherwise, compare the two
  for (let i = 0; i < previousFrames.length; i++) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const frameA = previousFrames[i];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const frameB = currentFrames[i];
    if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) {
      return false;
    }
  }
  return true;
}
function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;

  // If neither event has a fingerprint, they are assumed to be the same
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }

  // If only one event has a fingerprint, but not the other one, they are not the same
  if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) {
    return false;
  }
  currentFingerprint = currentFingerprint;
  previousFingerprint = previousFingerprint;

  // Otherwise, compare the two
  try {
    return !!(currentFingerprint.join('') === previousFingerprint.join(''));
  } catch (_oO) {
    return false;
  }
}
function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/supports.js
var supports = __webpack_require__(92049);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/sdk.js




/** A class object that can instantiate Client objects. */

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(clientClass, options) {
  if (options.debug === true) {
    if (debug_build/* DEBUG_BUILD */.X) {
      logger/* logger.enable */.kg.enable();
    } else {
      // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
      (0,logger/* consoleSandbox */.Cf)(() => {
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
      });
    }
  }
  const scope = (0,currentScopes/* getCurrentScope */.nZ)();
  scope.update(options.initialScope);
  const client = new clientClass(options);
  setCurrentClient(client);
  client.init();
  return client;
}

/**
 * Make the given client the current client.
 */
function setCurrentClient(client) {
  (0,currentScopes/* getCurrentScope */.nZ)().setClient(client);
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/exports.js
var esm_exports = __webpack_require__(2155);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/dsn.js
var utils_hoist_dsn = __webpack_require__(88157);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/api.js

const SENTRY_API_VERSION = '7';

/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
  const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
  const port = dsn.port ? `:${dsn.port}` : '';
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}

/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}

/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn, sdkInfo) {
  const params = {
    sentry_version: SENTRY_API_VERSION
  };
  if (dsn.publicKey) {
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
  }
  if (sdkInfo) {
    params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
  }
  return new URLSearchParams(params).toString();
}

/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel, sdkInfo) {
  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}

/** Returns the url to the report dialog endpoint. */
function getReportDialogEndpoint(dsnLike, dialogOptions) {
  const dsn = (0,utils_hoist_dsn/* makeDsn */.vK)(dsnLike);
  if (!dsn) {
    return '';
  }
  const endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;
  let encodedOptions = `dsn=${(0,utils_hoist_dsn/* dsnToString */.RA)(dsn)}`;
  for (const key in dialogOptions) {
    if (key === 'dsn') {
      continue;
    }
    if (key === 'onClose') {
      continue;
    }
    if (key === 'user') {
      const user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
  }
  return `${endpoint}?${encodedOptions}`;
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/envelope.js
var envelope = __webpack_require__(27662);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/session.js
var esm_session = __webpack_require__(48258);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/dynamicSamplingContext.js
var tracing_dynamicSamplingContext = __webpack_require__(51789);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/envelope.js
var utils_hoist_envelope = __webpack_require__(53767);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/time.js
var time = __webpack_require__(27870);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/clientreport.js



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(discarded_events, dsn, timestamp) {
  const clientReportItem = [{
    type: 'client_report'
  }, {
    timestamp: timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
    discarded_events
  }];
  return (0,utils_hoist_envelope/* createEnvelope */.Jd)(dsn ? {
    dsn
  } : {}, [clientReportItem]);
}

;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/error.js
/** An error emitted by Sentry SDKs and related utilities. */
class SentryError extends Error {
  constructor(message, logLevel = 'warn') {
    super(message);
    this.message = message;
    this.logLevel = logLevel;
  }
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/is.js
var is = __webpack_require__(92668);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/syncpromise.js
var syncpromise = __webpack_require__(37865);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/parseSampleRate.js
var parseSampleRate = __webpack_require__(86380);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/prepareEvent.js + 3 modules
var prepareEvent = __webpack_require__(24737);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(43384);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/baseclient.js


















const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
class BaseClient {
  /** Options passed to the SDK. */

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */

  /** Array of set up integrations. */

  /** Number of calls being processed */

  /** Holds flushable  */

  // eslint-disable-next-line @typescript-eslint/ban-types

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  constructor(options) {
    this._options = options;
    this._integrations = {};
    this._numProcessing = 0;
    this._outcomes = {};
    this._hooks = {};
    this._eventProcessors = [];
    if (options.dsn) {
      this._dsn = (0,utils_hoist_dsn/* makeDsn */.vK)(options.dsn);
    } else {
      debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn('No DSN provided, client will not send events.');
    }
    if (this._dsn) {
      const url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
      this._transport = options.transport({
        tunnel: this._options.tunnel,
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url
      });
    }

    // TODO(v9): Remove this deprecation warning
    const tracingOptions = ['enableTracing', 'tracesSampleRate', 'tracesSampler'];
    const undefinedOption = tracingOptions.find(option => option in options && options[option] == undefined);
    if (undefinedOption) {
      (0,logger/* consoleSandbox */.Cf)(() => {
        // eslint-disable-next-line no-console
        console.warn(`[Sentry] Deprecation warning: \`${undefinedOption}\` is set to undefined, which leads to tracing being enabled. In v9, a value of \`undefined\` will result in tracing being disabled.`);
      });
    }
  }

  /**
   * @inheritDoc
   */
  captureException(exception, hint, scope) {
    const eventId = (0,misc/* uuid4 */.DM)();

    // ensure we haven't captured this very object before
    if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
      debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return eventId;
    }
    const hintWithEventId = {
      event_id: eventId,
      ...hint
    };
    this._process(this.eventFromException(exception, hintWithEventId).then(event => this._captureEvent(event, hintWithEventId, scope)));
    return hintWithEventId.event_id;
  }

  /**
   * @inheritDoc
   */
  captureMessage(message, level, hint, currentScope) {
    const hintWithEventId = {
      event_id: (0,misc/* uuid4 */.DM)(),
      ...hint
    };
    const eventMessage = (0,is/* isParameterizedString */.Le)(message) ? message : String(message);
    const promisedEvent = (0,is/* isPrimitive */.pt)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
    this._process(promisedEvent.then(event => this._captureEvent(event, hintWithEventId, currentScope)));
    return hintWithEventId.event_id;
  }

  /**
   * @inheritDoc
   */
  captureEvent(event, hint, currentScope) {
    const eventId = (0,misc/* uuid4 */.DM)();

    // ensure we haven't captured this very object before
    if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
      debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return eventId;
    }
    const hintWithEventId = {
      event_id: eventId,
      ...hint
    };
    const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
    const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
    this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope));
    return hintWithEventId.event_id;
  }

  /**
   * @inheritDoc
   */
  captureSession(session) {
    if (!(typeof session.release === 'string')) {
      debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn('Discarded session because of missing or non-string release');
    } else {
      this.sendSession(session);
      // After sending, we set init false to indicate it's not the first occurrence
      (0,esm_session/* updateSession */.CT)(session, {
        init: false
      });
    }
  }

  /**
   * @inheritDoc
   */
  getDsn() {
    return this._dsn;
  }

  /**
   * @inheritDoc
   */
  getOptions() {
    return this._options;
  }

  /**
   * @see SdkMetadata
   *
   * @return The metadata of the SDK
   */
  getSdkMetadata() {
    return this._options._metadata;
  }

  /**
   * @inheritDoc
   */
  getTransport() {
    return this._transport;
  }

  /**
   * @inheritDoc
   */
  flush(timeout) {
    const transport = this._transport;
    if (transport) {
      this.emit('flush');
      return this._isClientDoneProcessing(timeout).then(clientFinished => {
        return transport.flush(timeout).then(transportFlushed => clientFinished && transportFlushed);
      });
    } else {
      return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    }
  }

  /**
   * @inheritDoc
   */
  close(timeout) {
    return this.flush(timeout).then(result => {
      this.getOptions().enabled = false;
      this.emit('close');
      return result;
    });
  }

  /** Get all installed event processors. */
  getEventProcessors() {
    return this._eventProcessors;
  }

  /** @inheritDoc */
  addEventProcessor(eventProcessor) {
    this._eventProcessors.push(eventProcessor);
  }

  /** @inheritdoc */
  init() {
    if (this._isEnabled() ||
    // Force integrations to be setup even if no DSN was set when we have
    // Spotlight enabled. This is particularly important for browser as we
    // don't support the `spotlight` option there and rely on the users
    // adding the `spotlightBrowserIntegration()` to their integrations which
    // wouldn't get initialized with the check below when there's no DSN set.
    this._options.integrations.some(({
      name
    }) => name.startsWith('Spotlight'))) {
      this._setupIntegrations();
    }
  }

  /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */
  getIntegrationByName(integrationName) {
    return this._integrations[integrationName];
  }

  /**
   * @inheritDoc
   */
  addIntegration(integration) {
    const isAlreadyInstalled = this._integrations[integration.name];

    // This hook takes care of only installing if not already installed
    (0,esm_integration/* setupIntegration */.m7)(this, integration, this._integrations);
    // Here we need to check manually to make sure to not run this multiple times
    if (!isAlreadyInstalled) {
      (0,esm_integration/* afterSetupIntegrations */.uf)(this, [integration]);
    }
  }

  /**
   * @inheritDoc
   */
  sendEvent(event, hint = {}) {
    this.emit('beforeSendEvent', event, hint);
    let env = (0,envelope/* createEventEnvelope */.Mq)(event, this._dsn, this._options._metadata, this._options.tunnel);
    for (const attachment of hint.attachments || []) {
      env = (0,utils_hoist_envelope/* addItemToEnvelope */.BO)(env, (0,utils_hoist_envelope/* createAttachmentEnvelopeItem */.zQ)(attachment));
    }
    const promise = this.sendEnvelope(env);
    if (promise) {
      promise.then(sendResponse => this.emit('afterSendEvent', event, sendResponse), null);
    }
  }

  /**
   * @inheritDoc
   */
  sendSession(session) {
    const env = (0,envelope/* createSessionEnvelope */.Q3)(session, this._dsn, this._options._metadata, this._options.tunnel);

    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.sendEnvelope(env);
  }

  /**
   * @inheritDoc
   */
  recordDroppedEvent(reason, category, eventOrCount) {
    if (this._options.sendClientReports) {
      // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
      // If event is passed as third argument, we assume this is a count of 1
      const count = typeof eventOrCount === 'number' ? eventOrCount : 1;

      // We want to track each category (error, transaction, session, replay_event) separately
      // but still keep the distinction between different type of outcomes.
      // We could use nested maps, but it's much easier to read and type this way.
      // A correct type for map-based implementation if we want to go that route
      // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
      // With typescript 4.1 we could even use template literal types
      const key = `${reason}:${category}`;
      debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
      this._outcomes[key] = (this._outcomes[key] || 0) + count;
    }
  }

  // Keep on() & emit() signatures in sync with types' client.ts interface
  /* eslint-disable @typescript-eslint/unified-signatures */

  /** @inheritdoc */

  /** @inheritdoc */
  on(hook, callback) {
    const hooks = this._hooks[hook] = this._hooks[hook] || [];

    // @ts-expect-error We assume the types are correct
    hooks.push(callback);

    // This function returns a callback execution handler that, when invoked,
    // deregisters a callback. This is crucial for managing instances where callbacks
    // need to be unregistered to prevent self-referencing in callback closures,
    // ensuring proper garbage collection.
    return () => {
      // @ts-expect-error We assume the types are correct
      const cbIndex = hooks.indexOf(callback);
      if (cbIndex > -1) {
        hooks.splice(cbIndex, 1);
      }
    };
  }

  /** @inheritdoc */

  /** @inheritdoc */
  emit(hook, ...rest) {
    const callbacks = this._hooks[hook];
    if (callbacks) {
      callbacks.forEach(callback => callback(...rest));
    }
  }

  /**
   * @inheritdoc
   */
  sendEnvelope(envelope) {
    this.emit('beforeEnvelope', envelope);
    if (this._isEnabled() && this._transport) {
      return this._transport.send(envelope).then(null, reason => {
        debug_build/* DEBUG_BUILD */.X && logger/* logger.error */.kg.error('Error while sending envelope:', reason);
        return reason;
      });
    }
    debug_build/* DEBUG_BUILD */.X && logger/* logger.error */.kg.error('Transport disabled');
    return (0,syncpromise/* resolvedSyncPromise */.WD)({});
  }

  /* eslint-enable @typescript-eslint/unified-signatures */

  /** Setup integrations for this client. */
  _setupIntegrations() {
    const {
      integrations
    } = this._options;
    this._integrations = (0,esm_integration/* setupIntegrations */.q4)(this, integrations);
    (0,esm_integration/* afterSetupIntegrations */.uf)(this, integrations);
  }

  /** Updates existing session based on the provided event */
  _updateSessionFromEvent(session, event) {
    let crashed = event.level === 'fatal';
    let errored = false;
    const exceptions = event.exception && event.exception.values;
    if (exceptions) {
      errored = true;
      for (const ex of exceptions) {
        const mechanism = ex.mechanism;
        if (mechanism && mechanism.handled === false) {
          crashed = true;
          break;
        }
      }
    }

    // A session is updated and that session update is sent in only one of the two following scenarios:
    // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
    // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
    const sessionNonTerminal = session.status === 'ok';
    const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
    if (shouldUpdateAndSend) {
      (0,esm_session/* updateSession */.CT)(session, {
        ...(crashed && {
          status: 'crashed'
        }),
        errors: session.errors || Number(errored || crashed)
      });
      this.captureSession(session);
    }
  }

  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
  _isClientDoneProcessing(timeout) {
    return new syncpromise/* SyncPromise */.cW(resolve => {
      let ticked = 0;
      const tick = 1;
      const interval = setInterval(() => {
        if (this._numProcessing == 0) {
          clearInterval(interval);
          resolve(true);
        } else {
          ticked += tick;
          if (timeout && ticked >= timeout) {
            clearInterval(interval);
            resolve(false);
          }
        }
      }, tick);
    });
  }

  /** Determines whether this SDK is enabled and a transport is present. */
  _isEnabled() {
    return this.getOptions().enabled !== false && this._transport !== undefined;
  }

  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */
  _prepareEvent(event, hint, currentScope = (0,currentScopes/* getCurrentScope */.nZ)(), isolationScope = (0,currentScopes/* getIsolationScope */.aF)()) {
    const options = this.getOptions();
    const integrations = Object.keys(this._integrations);
    if (!hint.integrations && integrations.length > 0) {
      hint.integrations = integrations;
    }
    this.emit('preprocessEvent', event, hint);
    if (!event.type) {
      isolationScope.setLastEventId(event.event_id || hint.event_id);
    }
    return (0,prepareEvent/* prepareEvent */.R)(options, event, hint, currentScope, this, isolationScope).then(evt => {
      if (evt === null) {
        return evt;
      }
      evt.contexts = {
        trace: (0,currentScopes/* getTraceContextFromScope */.XX)(currentScope),
        ...evt.contexts
      };
      const dynamicSamplingContext = (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromScope */.CG)(this, currentScope);
      evt.sdkProcessingMetadata = {
        dynamicSamplingContext,
        ...evt.sdkProcessingMetadata
      };
      return evt;
    });
  }

  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
  _captureEvent(event, hint = {}, scope) {
    return this._processEvent(event, hint, scope).then(finalEvent => {
      return finalEvent.event_id;
    }, reason => {
      if (debug_build/* DEBUG_BUILD */.X) {
        // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
        // control flow, log just the message (no stack) as a log-level log.
        if (reason instanceof SentryError && reason.logLevel === 'log') {
          logger/* logger.log */.kg.log(reason.message);
        } else {
          logger/* logger.warn */.kg.warn(reason);
        }
      }
      return undefined;
    });
  }

  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
  _processEvent(event, hint, currentScope) {
    const options = this.getOptions();
    const {
      sampleRate
    } = options;
    const isTransaction = isTransactionEvent(event);
    const isError = isErrorEvent(event);
    const eventType = event.type || 'error';
    const beforeSendLabel = `before send for type \`${eventType}\``;

    // 1.0 === 100% events are sent
    // 0.0 === 0% events are sent
    // Sampling for transaction happens somewhere else
    const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0,parseSampleRate/* parseSampleRate */.o)(sampleRate);
    if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
      this.recordDroppedEvent('sample_rate', 'error', event);
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
    }
    const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
    const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
    const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
    return this._prepareEvent(event, hint, currentScope, capturedSpanIsolationScope).then(prepared => {
      if (prepared === null) {
        this.recordDroppedEvent('event_processor', dataCategory, event);
        throw new SentryError('An event processor returned `null`, will not send event.', 'log');
      }
      const isInternalException = hint.data && hint.data.__sentry__ === true;
      if (isInternalException) {
        return prepared;
      }
      const result = processBeforeSend(this, options, prepared, hint);
      return _validateBeforeSendResult(result, beforeSendLabel);
    }).then(processedEvent => {
      if (processedEvent === null) {
        this.recordDroppedEvent('before_send', dataCategory, event);
        if (isTransaction) {
          const spans = event.spans || [];
          // the transaction itself counts as one span, plus all the child spans that are added
          const spanCount = 1 + spans.length;
          this.recordDroppedEvent('before_send', 'span', spanCount);
        }
        throw new SentryError(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
      }
      const session = currentScope && currentScope.getSession();
      if (!isTransaction && session) {
        this._updateSessionFromEvent(session, processedEvent);
      }
      if (isTransaction) {
        const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
        const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
        const droppedSpanCount = spanCountBefore - spanCountAfter;
        if (droppedSpanCount > 0) {
          this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
        }
      }

      // None of the Sentry built event processor will update transaction name,
      // so if the transaction name has been changed by an event processor, we know
      // it has to come from custom event processor added by a user
      const transactionInfo = processedEvent.transaction_info;
      if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
        const source = 'custom';
        processedEvent.transaction_info = {
          ...transactionInfo,
          source
        };
      }
      this.sendEvent(processedEvent, hint);
      return processedEvent;
    }).then(null, reason => {
      if (reason instanceof SentryError) {
        throw reason;
      }
      this.captureException(reason, {
        data: {
          __sentry__: true
        },
        originalException: reason
      });
      throw new SentryError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
    });
  }

  /**
   * Occupies the client with processing and event
   */
  _process(promise) {
    this._numProcessing++;
    void promise.then(value => {
      this._numProcessing--;
      return value;
    }, reason => {
      this._numProcessing--;
      return reason;
    });
  }

  /**
   * Clears outcomes on this client and returns them.
   */
  _clearOutcomes() {
    const outcomes = this._outcomes;
    this._outcomes = {};
    return Object.entries(outcomes).map(([key, quantity]) => {
      const [reason, category] = key.split(':');
      return {
        reason,
        category,
        quantity
      };
    });
  }

  /**
   * Sends client reports as an envelope.
   */
  _flushOutcomes() {
    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('Flushing outcomes...');
    const outcomes = this._clearOutcomes();
    if (outcomes.length === 0) {
      debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('No outcomes to send');
      return;
    }

    // This is really the only place where we want to check for a DSN and only send outcomes then
    if (!this._dsn) {
      debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('No dsn provided, will not send outcomes');
      return;
    }
    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('Sending outcomes:', outcomes);
    const envelope = createClientReportEnvelope(outcomes, this._options.tunnel && (0,utils_hoist_dsn/* dsnToString */.RA)(this._dsn));

    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.sendEnvelope(envelope);
  }

  /**
   * @inheritDoc
   */
}

/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */
function _validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
  const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
  if ((0,is/* isThenable */.J8)(beforeSendResult)) {
    return beforeSendResult.then(event => {
      if (!(0,is/* isPlainObject */.PO)(event) && event !== null) {
        throw new SentryError(invalidValueError);
      }
      return event;
    }, e => {
      throw new SentryError(`${beforeSendLabel} rejected with ${e}`);
    });
  } else if (!(0,is/* isPlainObject */.PO)(beforeSendResult) && beforeSendResult !== null) {
    throw new SentryError(invalidValueError);
  }
  return beforeSendResult;
}

/**
 * Process the matching `beforeSendXXX` callback.
 */
function processBeforeSend(client, options, event, hint) {
  const {
    beforeSend,
    beforeSendTransaction,
    beforeSendSpan
  } = options;
  if (isErrorEvent(event) && beforeSend) {
    return beforeSend(event, hint);
  }
  if (isTransactionEvent(event)) {
    if (event.spans && beforeSendSpan) {
      const processedSpans = [];
      for (const span of event.spans) {
        const processedSpan = beforeSendSpan(span);
        if (processedSpan) {
          processedSpans.push(processedSpan);
        } else {
          (0,spanUtils/* showSpanDropWarning */.R6)();
          client.recordDroppedEvent('before_send', 'span');
        }
      }
      event.spans = processedSpans;
    }
    if (beforeSendTransaction) {
      if (event.spans) {
        // We store the # of spans before processing in SDK metadata,
        // so we can compare it afterwards to determine how many spans were dropped
        const spanCountBefore = event.spans.length;
        event.sdkProcessingMetadata = {
          ...event.sdkProcessingMetadata,
          spanCountBeforeProcessing: spanCountBefore
        };
      }
      return beforeSendTransaction(event, hint);
    }
  }
  return event;
}
function isErrorEvent(event) {
  return event.type === undefined;
}
function isTransactionEvent(event) {
  return event.type === 'transaction';
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/env.js
var env = __webpack_require__(83466);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/sdkMetadata.js
var sdkMetadata = __webpack_require__(17751);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/debug-build.js
var esm_debug_build = __webpack_require__(77818);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/normalize.js + 1 modules
var normalize = __webpack_require__(9813);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/build/npm/esm/eventbuilder.js


/**
 * This function creates an exception from a JavaScript Error
 */
function exceptionFromError(stackParser, ex) {
  // Get the frames first since Opera can lose the stack if we touch anything else first
  const frames = parseStackFrames(stackParser, ex);
  const exception = {
    type: extractType(ex),
    value: extractMessage(ex)
  };
  if (frames.length) {
    exception.stacktrace = {
      frames
    };
  }
  if (exception.type === undefined && exception.value === '') {
    exception.value = 'Unrecoverable error caught';
  }
  return exception;
}
function eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
  const client = (0,currentScopes/* getClient */.s3)();
  const normalizeDepth = client && client.getOptions().normalizeDepth;

  // If we can, we extract an exception from the object properties
  const errorFromProp = getErrorPropertyFromObject(exception);
  const extra = {
    __serialized__: (0,normalize/* normalizeToSize */.Qy)(exception, normalizeDepth)
  };
  if (errorFromProp) {
    return {
      exception: {
        values: [exceptionFromError(stackParser, errorFromProp)]
      },
      extra
    };
  }
  const event = {
    exception: {
      values: [{
        type: (0,is/* isEvent */.cO)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
        value: getNonErrorObjectExceptionValue(exception, {
          isUnhandledRejection
        })
      }]
    },
    extra
  };
  if (syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      // event.exception.values[0] has been set above
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      event.exception.values[0].stacktrace = {
        frames
      };
    }
  }
  return event;
}
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)]
    }
  };
}

/** Parses stack frames from an error */
function parseStackFrames(stackParser, ex) {
  // Access and store the stacktrace property before doing ANYTHING
  // else to it because Opera is not very good at providing it
  // reliably in other circumstances.
  const stacktrace = ex.stacktrace || ex.stack || '';
  const skipLines = getSkipFirstStackStringLines(ex);
  const framesToPop = getPopFirstTopFrames(ex);
  try {
    return stackParser(stacktrace, skipLines, framesToPop);
  } catch (e) {
    // no-empty
  }
  return [];
}

// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const reactMinifiedRegexp = /Minified React error #\d+;/i;

/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */
function getSkipFirstStackStringLines(ex) {
  if (ex && reactMinifiedRegexp.test(ex.message)) {
    return 1;
  }
  return 0;
}

/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */
function getPopFirstTopFrames(ex) {
  if (typeof ex.framesToPop === 'number') {
    return ex.framesToPop;
  }
  return 0;
}

// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function isWebAssemblyException(exception) {
  // Check for support
  // @ts-expect-error - WebAssembly.Exception is a valid class
  if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') {
    // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
  } else {
    return false;
  }
}

/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */
function extractType(ex) {
  const name = ex && ex.name;

  // The name for WebAssembly.Exception Errors needs to be extracted differently.
  // Context: https://github.com/getsentry/sentry-javascript/issues/13787
  if (!name && isWebAssemblyException(ex)) {
    // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
    const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
    return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
  }
  return name;
}

/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
  const message = ex && ex.message;
  if (!message) {
    return 'No error message';
  }
  if (message.error && typeof message.error.message === 'string') {
    return message.error.message;
  }

  // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
  if (isWebAssemblyException(ex) && Array.isArray(ex.message) && ex.message.length == 2) {
    return ex.message[1];
  }
  return message;
}

/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(stackParser, exception, hint, attachStacktrace) {
  const syntheticException = hint && hint.syntheticException || undefined;
  const event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  (0,misc/* addExceptionMechanism */.EG)(event); // defaults to { type: 'generic', handled: true }
  event.level = 'error';
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(stackParser, message, level = 'info', hint, attachStacktrace) {
  const syntheticException = hint && hint.syntheticException || undefined;
  const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * @hidden
 */
function eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
  let event;
  if ((0,is/* isErrorEvent */.VW)(exception) && exception.error) {
    // If it is an ErrorEvent with `error` property, extract it to get actual Error
    const errorEvent = exception;
    return eventFromError(stackParser, errorEvent.error);
  }

  // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
  // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
  // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
  //
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
  // https://webidl.spec.whatwg.org/#es-DOMException-specialness
  if ((0,is/* isDOMError */.TX)(exception) || (0,is/* isDOMException */.fm)(exception)) {
    const domException = exception;
    if ('stack' in exception) {
      event = eventFromError(stackParser, exception);
    } else {
      const name = domException.name || ((0,is/* isDOMError */.TX)(domException) ? 'DOMError' : 'DOMException');
      const message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      (0,misc/* addExceptionTypeValue */.Db)(event, message);
    }
    if ('code' in domException) {
      // eslint-disable-next-line deprecation/deprecation
      event.tags = {
        ...event.tags,
        'DOMException.code': `${domException.code}`
      };
    }
    return event;
  }
  if ((0,is/* isError */.VZ)(exception)) {
    // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
  }
  if ((0,is/* isPlainObject */.PO)(exception) || (0,is/* isEvent */.cO)(exception)) {
    // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
    // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
    // group on any key/value change.
    const objectException = exception;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    (0,misc/* addExceptionMechanism */.EG)(event, {
      synthetic: true
    });
    return event;
  }

  // If none of previous checks were valid, then it means that it's not:
  // - an instance of DOMError
  // - an instance of DOMException
  // - an instance of Event
  // - an instance of Error
  // - a valid ErrorEvent (one with an error property)
  // - a plain Object
  //
  // So bail out and capture it as a simple message:
  event = eventFromString(stackParser, exception, syntheticException, attachStacktrace);
  (0,misc/* addExceptionTypeValue */.Db)(event, `${exception}`, undefined);
  (0,misc/* addExceptionMechanism */.EG)(event, {
    synthetic: true
  });
  return event;
}
function eventFromString(stackParser, message, syntheticException, attachStacktrace) {
  const event = {};
  if (attachStacktrace && syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{
          value: message,
          stacktrace: {
            frames
          }
        }]
      };
    }
    (0,misc/* addExceptionMechanism */.EG)(event, {
      synthetic: true
    });
  }
  if ((0,is/* isParameterizedString */.Le)(message)) {
    const {
      __sentry_template_string__,
      __sentry_template_values__
    } = message;
    event.logentry = {
      message: __sentry_template_string__,
      params: __sentry_template_values__
    };
    return event;
  }
  event.message = message;
  return event;
}
function getNonErrorObjectExceptionValue(exception, {
  isUnhandledRejection
}) {
  const keys = (0,object/* extractExceptionKeysForMessage */.zf)(exception);
  const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';

  // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
  // We still want to try to get a decent message for these cases
  if ((0,is/* isErrorEvent */.VW)(exception)) {
    return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
  }
  if ((0,is/* isEvent */.cO)(exception)) {
    const className = getObjectClassName(exception);
    return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
  }
  return `Object captured as ${captureType} with keys: ${keys}`;
}
function getObjectClassName(obj) {
  try {
    const prototype = Object.getPrototypeOf(obj);
    return prototype ? prototype.constructor.name : undefined;
  } catch (e) {
    // ignore errors here
  }
}

/** If a plain object has a property that is an `Error`, return this error. */
function getErrorPropertyFromObject(obj) {
  for (const prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      const value = obj[prop];
      if (value instanceof Error) {
        return value;
      }
    }
  }
  return undefined;
}

// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/helpers.js
var helpers = __webpack_require__(18861);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/build/npm/esm/userfeedback.js


/**
 * Creates an envelope from a user feedback.
 */
function createUserFeedbackEnvelope(feedback, {
  metadata,
  tunnel,
  dsn
}) {
  const headers = {
    event_id: feedback.event_id,
    sent_at: new Date().toISOString(),
    ...(metadata && metadata.sdk && {
      sdk: {
        name: metadata.sdk.name,
        version: metadata.sdk.version
      }
    }),
    ...(!!tunnel && !!dsn && {
      dsn: (0,utils_hoist_dsn/* dsnToString */.RA)(dsn)
    })
  };
  const item = createUserFeedbackEnvelopeItem(feedback);
  return (0,utils_hoist_envelope/* createEnvelope */.Jd)(headers, [item]);
}
function createUserFeedbackEnvelopeItem(feedback) {
  const feedbackHeaders = {
    type: 'user_report'
  };
  return [feedbackHeaders, feedback];
}

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/build/npm/esm/client.js






/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/core Options for more information.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
class BrowserClient extends BaseClient {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  constructor(options) {
    const opts = {
      // We default this to true, as it is the safer scenario
      parentSpanIsAlwaysRootSpan: true,
      ...options
    };
    const sdkSource = helpers/* WINDOW.SENTRY_SDK_SOURCE */.m9.SENTRY_SDK_SOURCE || (0,env/* getSDKSource */.S)();
    (0,sdkMetadata/* applySdkMetadata */.V)(opts, 'browser', ['browser'], sdkSource);
    super(opts);
    if (opts.sendClientReports && helpers/* WINDOW.document */.m9.document) {
      helpers/* WINDOW.document.addEventListener */.m9.document.addEventListener('visibilitychange', () => {
        if (helpers/* WINDOW.document.visibilityState */.m9.document.visibilityState === 'hidden') {
          this._flushOutcomes();
        }
      });
    }
  }

  /**
   * @inheritDoc
   */
  eventFromException(exception, hint) {
    return eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
  eventFromMessage(message, level = 'info', hint) {
    return eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }

  /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */
  captureUserFeedback(feedback) {
    if (!this._isEnabled()) {
      esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn('SDK not enabled, will not capture user feedback.');
      return;
    }
    const envelope = createUserFeedbackEnvelope(feedback, {
      metadata: this.getSdkMetadata(),
      dsn: this.getDsn(),
      tunnel: this.getOptions().tunnel
    });

    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.sendEnvelope(envelope);
  }

  /**
   * @inheritDoc
   */
  _prepareEvent(event, hint, scope) {
    event.platform = event.platform || 'javascript';
    return super._prepareEvent(event, hint, scope);
  }
}

// EXTERNAL MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/instrument/dom.js
var dom = __webpack_require__(30423);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/instrument/xhr.js
var xhr = __webpack_require__(27325);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/instrument/history.js + 1 modules
var instrument_history = __webpack_require__(29465);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/worldwide.js
var worldwide = __webpack_require__(23867);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/instrument/handlers.js
var handlers = __webpack_require__(29862);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/instrument/console.js





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addConsoleInstrumentationHandler(handler) {
  const type = 'console';
  (0,handlers/* addHandler */.Hj)(type, handler);
  (0,handlers/* maybeInstrument */.D2)(type, instrumentConsole);
}
function instrumentConsole() {
  if (!("console" in worldwide/* GLOBAL_OBJ */.n)) {
    return;
  }
  logger/* CONSOLE_LEVELS.forEach */.RU.forEach(function (level) {
    if (!(level in worldwide/* GLOBAL_OBJ.console */.n.console)) {
      return;
    }
    (0,object/* fill */.hl)(worldwide/* GLOBAL_OBJ.console */.n.console, level, function (originalConsoleMethod) {
      logger/* originalConsoleMethods */.LD[level] = originalConsoleMethod;
      return function (...args) {
        const handlerData = {
          args,
          level
        };
        (0,handlers/* triggerHandlers */.rK)('console', handlerData);
        const log = logger/* originalConsoleMethods */.LD[level];
        log && log.apply(worldwide/* GLOBAL_OBJ.console */.n.console, args);
      };
    });
  });
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/instrument/fetch.js
var fetch = __webpack_require__(56241);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/breadcrumbs.js
var breadcrumbs = __webpack_require__(5258);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/browser.js
var browser = __webpack_require__(7948);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/severity.js
var severity = __webpack_require__(60083);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/breadcrumb-log-level.js
/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */
function getBreadcrumbLogLevelFromHttpStatusCode(statusCode) {
  // NOTE: undefined defaults to 'info' in Sentry
  if (statusCode === undefined) {
    return undefined;
  } else if (statusCode >= 400 && statusCode < 500) {
    return 'warning';
  } else if (statusCode >= 500) {
    return 'error';
  } else {
    return undefined;
  }
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/url.js
var url = __webpack_require__(95619);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/build/npm/esm/integrations/breadcrumbs.js





/* eslint-disable max-lines */

/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */
const MAX_ALLOWED_STRING_LENGTH = 1024;
const breadcrumbs_INTEGRATION_NAME = 'Breadcrumbs';
const _breadcrumbsIntegration = (options = {}) => {
  const _options = {
    console: true,
    dom: true,
    fetch: true,
    history: true,
    sentry: true,
    xhr: true,
    ...options
  };
  return {
    name: breadcrumbs_INTEGRATION_NAME,
    setup(client) {
      if (_options.console) {
        addConsoleInstrumentationHandler(_getConsoleBreadcrumbHandler(client));
      }
      if (_options.dom) {
        (0,dom/* addClickKeypressInstrumentationHandler */.O)(_getDomBreadcrumbHandler(client, _options.dom));
      }
      if (_options.xhr) {
        (0,xhr/* addXhrInstrumentationHandler */.UK)(_getXhrBreadcrumbHandler(client));
      }
      if (_options.fetch) {
        (0,fetch/* addFetchInstrumentationHandler */.Uf)(_getFetchBreadcrumbHandler(client));
      }
      if (_options.history) {
        (0,instrument_history/* addHistoryInstrumentationHandler */.a)(_getHistoryBreadcrumbHandler(client));
      }
      if (_options.sentry) {
        client.on('beforeSendEvent', _getSentryBreadcrumbHandler(client));
      }
    }
  };
};
const breadcrumbsIntegration = (0,esm_integration/* defineIntegration */._I)(_breadcrumbsIntegration);

/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */
function _getSentryBreadcrumbHandler(client) {
  return function addSentryBreadcrumb(event) {
    if ((0,currentScopes/* getClient */.s3)() !== client) {
      return;
    }
    (0,breadcrumbs/* addBreadcrumb */.n)({
      category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
      event_id: event.event_id,
      level: event.level,
      message: (0,misc/* getEventDescription */.jH)(event)
    }, {
      event
    });
  };
}

/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
function _getDomBreadcrumbHandler(client, dom) {
  return function _innerDomBreadcrumb(handlerData) {
    if ((0,currentScopes/* getClient */.s3)() !== client) {
      return;
    }
    let target;
    let componentName;
    let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
    let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
    if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
      esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn(`\`dom.maxStringLength\` cannot exceed ${MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${MAX_ALLOWED_STRING_LENGTH} instead.`);
      maxStringLength = MAX_ALLOWED_STRING_LENGTH;
    }
    if (typeof keyAttrs === 'string') {
      keyAttrs = [keyAttrs];
    }

    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
      const event = handlerData.event;
      const element = _isEvent(event) ? event.target : event;
      target = (0,browser/* htmlTreeAsString */.Rt)(element, {
        keyAttrs,
        maxStringLength
      });
      componentName = (0,browser/* getComponentName */.iY)(element);
    } catch (e) {
      target = '<unknown>';
    }
    if (target.length === 0) {
      return;
    }
    const breadcrumb = {
      category: `ui.${handlerData.name}`,
      message: target
    };
    if (componentName) {
      breadcrumb.data = {
        'ui.component_name': componentName
      };
    }
    (0,breadcrumbs/* addBreadcrumb */.n)(breadcrumb, {
      event: handlerData.event,
      name: handlerData.name,
      global: handlerData.global
    });
  };
}

/**
 * Creates breadcrumbs from console API calls
 */
function _getConsoleBreadcrumbHandler(client) {
  return function _consoleBreadcrumb(handlerData) {
    if ((0,currentScopes/* getClient */.s3)() !== client) {
      return;
    }
    const breadcrumb = {
      category: 'console',
      data: {
        arguments: handlerData.args,
        logger: 'console'
      },
      level: (0,severity/* severityLevelFromString */.V)(handlerData.level),
      message: (0,string/* safeJoin */.nK)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
      if (handlerData.args[0] === false) {
        breadcrumb.message = `Assertion failed: ${(0,string/* safeJoin */.nK)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
        breadcrumb.data.arguments = handlerData.args.slice(1);
      } else {
        // Don't capture a breadcrumb for passed assertions
        return;
      }
    }
    (0,breadcrumbs/* addBreadcrumb */.n)(breadcrumb, {
      input: handlerData.args,
      level: handlerData.level
    });
  };
}

/**
 * Creates breadcrumbs from XHR API calls
 */
function _getXhrBreadcrumbHandler(client) {
  return function _xhrBreadcrumb(handlerData) {
    if ((0,currentScopes/* getClient */.s3)() !== client) {
      return;
    }
    const {
      startTimestamp,
      endTimestamp
    } = handlerData;
    const sentryXhrData = handlerData.xhr[xhr/* SENTRY_XHR_DATA_KEY */.xU];

    // We only capture complete, non-sentry requests
    if (!startTimestamp || !endTimestamp || !sentryXhrData) {
      return;
    }
    const {
      method,
      url,
      status_code,
      body
    } = sentryXhrData;
    const data = {
      method,
      url,
      status_code
    };
    const hint = {
      xhr: handlerData.xhr,
      input: body,
      startTimestamp,
      endTimestamp
    };
    const level = getBreadcrumbLogLevelFromHttpStatusCode(status_code);
    (0,breadcrumbs/* addBreadcrumb */.n)({
      category: 'xhr',
      data,
      type: 'http',
      level
    }, hint);
  };
}

/**
 * Creates breadcrumbs from fetch API calls
 */
function _getFetchBreadcrumbHandler(client) {
  return function _fetchBreadcrumb(handlerData) {
    if ((0,currentScopes/* getClient */.s3)() !== client) {
      return;
    }
    const {
      startTimestamp,
      endTimestamp
    } = handlerData;

    // We only capture complete fetch requests
    if (!endTimestamp) {
      return;
    }
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
      // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
      return;
    }
    if (handlerData.error) {
      const data = handlerData.fetchData;
      const hint = {
        data: handlerData.error,
        input: handlerData.args,
        startTimestamp,
        endTimestamp
      };
      (0,breadcrumbs/* addBreadcrumb */.n)({
        category: 'fetch',
        data,
        level: 'error',
        type: 'http'
      }, hint);
    } else {
      const response = handlerData.response;
      const data = {
        ...handlerData.fetchData,
        status_code: response && response.status
      };
      const hint = {
        input: handlerData.args,
        response,
        startTimestamp,
        endTimestamp
      };
      const level = getBreadcrumbLogLevelFromHttpStatusCode(data.status_code);
      (0,breadcrumbs/* addBreadcrumb */.n)({
        category: 'fetch',
        data,
        type: 'http',
        level
      }, hint);
    }
  };
}

/**
 * Creates breadcrumbs from history API calls
 */
function _getHistoryBreadcrumbHandler(client) {
  return function _historyBreadcrumb(handlerData) {
    if ((0,currentScopes/* getClient */.s3)() !== client) {
      return;
    }
    let from = handlerData.from;
    let to = handlerData.to;
    const parsedLoc = (0,url/* parseUrl */.en)(helpers/* WINDOW.location.href */.m9.location.href);
    let parsedFrom = from ? (0,url/* parseUrl */.en)(from) : undefined;
    const parsedTo = (0,url/* parseUrl */.en)(to);

    // Initial pushState doesn't provide `from` information
    if (!parsedFrom || !parsedFrom.path) {
      parsedFrom = parsedLoc;
    }

    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
      to = parsedTo.relative;
    }
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
      from = parsedFrom.relative;
    }
    (0,breadcrumbs/* addBreadcrumb */.n)({
      category: 'navigation',
      data: {
        from,
        to
      }
    });
  };
}
function _isEvent(event) {
  return !!event && !!event.target;
}

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/build/npm/esm/integrations/browserapierrors.js


const DEFAULT_EVENT_TARGET = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'BroadcastChannel', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'SharedWorker', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
const browserapierrors_INTEGRATION_NAME = 'BrowserApiErrors';
const _browserApiErrorsIntegration = (options = {}) => {
  const _options = {
    XMLHttpRequest: true,
    eventTarget: true,
    requestAnimationFrame: true,
    setInterval: true,
    setTimeout: true,
    ...options
  };
  return {
    name: browserapierrors_INTEGRATION_NAME,
    // TODO: This currently only works for the first client this is setup
    // We may want to adjust this to check for client etc.
    setupOnce() {
      if (_options.setTimeout) {
        (0,object/* fill */.hl)(helpers/* WINDOW */.m9, 'setTimeout', _wrapTimeFunction);
      }
      if (_options.setInterval) {
        (0,object/* fill */.hl)(helpers/* WINDOW */.m9, 'setInterval', _wrapTimeFunction);
      }
      if (_options.requestAnimationFrame) {
        (0,object/* fill */.hl)(helpers/* WINDOW */.m9, 'requestAnimationFrame', _wrapRAF);
      }
      if (_options.XMLHttpRequest && "XMLHttpRequest" in helpers/* WINDOW */.m9) {
        (0,object/* fill */.hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
      }
      const eventTargetOption = _options.eventTarget;
      if (eventTargetOption) {
        const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
        eventTarget.forEach(_wrapEventTarget);
      }
    }
  };
};

/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */
const browserApiErrorsIntegration = (0,esm_integration/* defineIntegration */._I)(_browserApiErrorsIntegration);
function _wrapTimeFunction(original) {
  return function (...args) {
    const originalCallback = args[0];
    args[0] = (0,helpers/* wrap */.re)(originalCallback, {
      mechanism: {
        data: {
          function: (0,stacktrace/* getFunctionName */.$P)(original)
        },
        handled: false,
        type: 'instrument'
      }
    });
    return original.apply(this, args);
  };
}
function _wrapRAF(original) {
  return function (callback) {
    return original.apply(this, [(0,helpers/* wrap */.re)(callback, {
      mechanism: {
        data: {
          function: 'requestAnimationFrame',
          handler: (0,stacktrace/* getFunctionName */.$P)(original)
        },
        handled: false,
        type: 'instrument'
      }
    })]);
  };
}
function _wrapXHR(originalSend) {
  return function (...args) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const xhr = this;
    const xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
    xmlHttpRequestProps.forEach(prop => {
      if (prop in xhr && typeof xhr[prop] === 'function') {
        (0,object/* fill */.hl)(xhr, prop, function (original) {
          const wrapOptions = {
            mechanism: {
              data: {
                function: prop,
                handler: (0,stacktrace/* getFunctionName */.$P)(original)
              },
              handled: false,
              type: 'instrument'
            }
          };

          // If Instrument integration has been called before BrowserApiErrors, get the name of original function
          const originalFunction = (0,object/* getOriginalFunction */.HK)(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = (0,stacktrace/* getFunctionName */.$P)(originalFunction);
          }

          // Otherwise wrap directly
          return (0,helpers/* wrap */.re)(original, wrapOptions);
        });
      }
    });
    return originalSend.apply(this, args);
  };
}
function _wrapEventTarget(target) {
  const globalObject = helpers/* WINDOW */.m9;
  const targetObj = globalObject[target];
  const proto = targetObj && targetObj.prototype;

  // eslint-disable-next-line no-prototype-builtins
  if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
    return;
  }
  (0,object/* fill */.hl)(proto, 'addEventListener', function (original) {
    return function (eventName, fn, options) {
      try {
        if (isEventListenerObject(fn)) {
          // ESlint disable explanation:
          //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
          //  introduce a bug here, because bind returns a new function that doesn't have our
          //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
          //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
          // eslint-disable-next-line @typescript-eslint/unbound-method
          fn.handleEvent = (0,helpers/* wrap */.re)(fn.handleEvent, {
            mechanism: {
              data: {
                function: 'handleEvent',
                handler: (0,stacktrace/* getFunctionName */.$P)(fn),
                target
              },
              handled: false,
              type: 'instrument'
            }
          });
        }
      } catch (e2) {
        // can sometimes get 'Permission denied to access property "handle Event'
      }
      return original.apply(this, [eventName, (0,helpers/* wrap */.re)(fn, {
        mechanism: {
          data: {
            function: 'addEventListener',
            handler: (0,stacktrace/* getFunctionName */.$P)(fn),
            target
          },
          handled: false,
          type: 'instrument'
        }
      }), options]);
    };
  });
  (0,object/* fill */.hl)(proto, 'removeEventListener', function (originalRemoveEventListener) {
    return function (eventName, fn, options) {
      /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */
      try {
        const originalEventHandler = fn.__sentry_wrapped__;
        if (originalEventHandler) {
          originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
        }
      } catch (e) {
        // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
      }
      return originalRemoveEventListener.call(this, eventName, fn, options);
    };
  });
}
function isEventListenerObject(obj) {
  return typeof obj.handleEvent === 'function';
}

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/build/npm/esm/integrations/browsersession.js





/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */
const browserSessionIntegration = (0,esm_integration/* defineIntegration */._I)(() => {
  return {
    name: 'BrowserSession',
    setupOnce() {
      if (typeof helpers/* WINDOW.document */.m9.document === 'undefined') {
        esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
        return;
      }

      // The session duration for browser sessions does not track a meaningful
      // concept that can be used as a metric.
      // Automatically captured sessions are akin to page views, and thus we
      // discard their duration.
      (0,esm_exports/* startSession */.yj)({
        ignoreDuration: true
      });
      (0,esm_exports/* captureSession */.cg)();

      // We want to create a session for every navigation as well
      (0,instrument_history/* addHistoryInstrumentationHandler */.a)(({
        from,
        to
      }) => {
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
          (0,esm_exports/* startSession */.yj)({
            ignoreDuration: true
          });
          (0,esm_exports/* captureSession */.cg)();
        }
      });
    }
  };
});

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/instrument/globalError.js
var globalError = __webpack_require__(33246);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/instrument/globalUnhandledRejection.js
var globalUnhandledRejection = __webpack_require__(80201);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/build/npm/esm/integrations/globalhandlers.js




const globalhandlers_INTEGRATION_NAME = 'GlobalHandlers';
const _globalHandlersIntegration = (options = {}) => {
  const _options = {
    onerror: true,
    onunhandledrejection: true,
    ...options
  };
  return {
    name: globalhandlers_INTEGRATION_NAME,
    setupOnce() {
      Error.stackTraceLimit = 50;
    },
    setup(client) {
      if (_options.onerror) {
        _installGlobalOnErrorHandler(client);
        globalHandlerLog('onerror');
      }
      if (_options.onunhandledrejection) {
        _installGlobalOnUnhandledRejectionHandler(client);
        globalHandlerLog('onunhandledrejection');
      }
    }
  };
};
const globalHandlersIntegration = (0,esm_integration/* defineIntegration */._I)(_globalHandlersIntegration);
function _installGlobalOnErrorHandler(client) {
  (0,globalError/* addGlobalErrorInstrumentationHandler */.V)(data => {
    const {
      stackParser,
      attachStacktrace
    } = getOptions();
    if ((0,currentScopes/* getClient */.s3)() !== client || (0,helpers/* shouldIgnoreOnError */.Wz)()) {
      return;
    }
    const {
      msg,
      url,
      line,
      column,
      error
    } = data;
    const event = _enhanceEventWithInitialFrame(eventFromUnknownInput(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
    event.level = 'error';
    (0,esm_exports/* captureEvent */.eN)(event, {
      originalException: error,
      mechanism: {
        handled: false,
        type: 'onerror'
      }
    });
  });
}
function _installGlobalOnUnhandledRejectionHandler(client) {
  (0,globalUnhandledRejection/* addGlobalUnhandledRejectionInstrumentationHandler */.h)(e => {
    const {
      stackParser,
      attachStacktrace
    } = getOptions();
    if ((0,currentScopes/* getClient */.s3)() !== client || (0,helpers/* shouldIgnoreOnError */.Wz)()) {
      return;
    }
    const error = _getUnhandledRejectionError(e);
    const event = (0,is/* isPrimitive */.pt)(error) ? _eventFromRejectionWithPrimitive(error) : eventFromUnknownInput(stackParser, error, undefined, attachStacktrace, true);
    event.level = 'error';
    (0,esm_exports/* captureEvent */.eN)(event, {
      originalException: error,
      mechanism: {
        handled: false,
        type: 'onunhandledrejection'
      }
    });
  });
}
function _getUnhandledRejectionError(error) {
  if ((0,is/* isPrimitive */.pt)(error)) {
    return error;
  }

  // dig the object of the rejection out of known event types
  try {
    // PromiseRejectionEvents store the object of the rejection under 'reason'
    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
    if ('reason' in error) {
      return error.reason;
    }

    // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
    // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
    // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
    // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
    // https://github.com/getsentry/sentry-javascript/issues/2380
    if ('detail' in error && 'reason' in error.detail) {
      return error.detail.reason;
    }
  } catch (e2) {} // eslint-disable-line no-empty

  return error;
}

/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [{
        type: 'UnhandledRejection',
        // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
        value: `Non-Error promise rejection captured with value: ${String(reason)}`
      }]
    }
  };
}
function _enhanceEventWithInitialFrame(event, url, line, column) {
  // event.exception
  const e = event.exception = event.exception || {};
  // event.exception.values
  const ev = e.values = e.values || [];
  // event.exception.values[0]
  const ev0 = ev[0] = ev[0] || {};
  // event.exception.values[0].stacktrace
  const ev0s = ev0.stacktrace = ev0.stacktrace || {};
  // event.exception.values[0].stacktrace.frames
  const ev0sf = ev0s.frames = ev0s.frames || [];
  const colno = column;
  const lineno = line;
  const filename = (0,is/* isString */.HD)(url) && url.length > 0 ? url : (0,browser/* getLocationHref */.l4)();

  // event.exception.values[0].stacktrace.frames
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: stacktrace/* UNKNOWN_FUNCTION */.Fi,
      in_app: true,
      lineno
    });
  }
  return event;
}
function globalHandlerLog(type) {
  esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(`Global Handler attached: ${type}`);
}
function getOptions() {
  const client = (0,currentScopes/* getClient */.s3)();
  const options = client && client.getOptions() || {
    stackParser: () => [],
    attachStacktrace: false
  };
  return options;
}

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/build/npm/esm/integrations/httpcontext.js



/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */
const httpContextIntegration = (0,esm_integration/* defineIntegration */._I)(() => {
  return {
    name: 'HttpContext',
    preprocessEvent(event) {
      // if none of the information we want exists, don't bother
      if (!helpers/* WINDOW.navigator */.m9.navigator && !helpers/* WINDOW.location */.m9.location && !helpers/* WINDOW.document */.m9.document) {
        return;
      }

      // grab as much info as exists and add it to the event
      const url = event.request && event.request.url || helpers/* WINDOW.location */.m9.location && helpers/* WINDOW.location.href */.m9.location.href;
      const {
        referrer
      } = helpers/* WINDOW.document */.m9.document || {};
      const {
        userAgent
      } = helpers/* WINDOW.navigator */.m9.navigator || {};
      const headers = {
        ...(event.request && event.request.headers),
        ...(referrer && {
          Referer: referrer
        }),
        ...(userAgent && {
          'User-Agent': userAgent
        })
      };
      const request = {
        ...event.request,
        ...(url && {
          url
        }),
        headers
      };
      event.request = request;
    }
  };
});

;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/aggregate-errors.js



/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */
function applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
  if (!event.exception || !event.exception.values || !hint || !(0,is/* isInstanceOf */.V9)(hint.originalException, Error)) {
    return;
  }

  // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
  const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;

  // We only create exception grouping if there is an exception in the event.
  if (originalException) {
    event.exception.values = truncateAggregateExceptions(aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
  }
}
function aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
  if (prevExceptions.length >= limit + 1) {
    return prevExceptions;
  }
  let newExceptions = [...prevExceptions];

  // Recursively call this function in order to walk down a chain of errors
  if ((0,is/* isInstanceOf */.V9)(error[key], Error)) {
    applyExceptionGroupFieldsForParentException(exception, exceptionId);
    const newException = exceptionFromErrorImplementation(parser, error[key]);
    const newExceptionId = newExceptions.length;
    applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
    newExceptions = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [newException, ...newExceptions], newException, newExceptionId);
  }

  // This will create exception grouping for AggregateErrors
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
  if (Array.isArray(error.errors)) {
    error.errors.forEach((childError, i) => {
      if ((0,is/* isInstanceOf */.V9)(childError, Error)) {
        applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, childError);
        const newExceptionId = newExceptions.length;
        applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
        newExceptions = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [newException, ...newExceptions], newException, newExceptionId);
      }
    });
  }
  return newExceptions;
}
function applyExceptionGroupFieldsForParentException(exception, exceptionId) {
  // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
  exception.mechanism = exception.mechanism || {
    type: 'generic',
    handled: true
  };
  exception.mechanism = {
    ...exception.mechanism,
    ...(exception.type === 'AggregateError' && {
      is_exception_group: true
    }),
    exception_id: exceptionId
  };
}
function applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
  // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
  exception.mechanism = exception.mechanism || {
    type: 'generic',
    handled: true
  };
  exception.mechanism = {
    ...exception.mechanism,
    type: 'chained',
    source,
    exception_id: exceptionId,
    parent_id: parentId
  };
}

/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */
function truncateAggregateExceptions(exceptions, maxValueLength) {
  return exceptions.map(exception => {
    if (exception.value) {
      exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
    }
    return exception;
  });
}

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/build/npm/esm/integrations/linkederrors.js


const DEFAULT_KEY = 'cause';
const DEFAULT_LIMIT = 5;
const linkederrors_INTEGRATION_NAME = 'LinkedErrors';
const _linkedErrorsIntegration = (options = {}) => {
  const limit = options.limit || DEFAULT_LIMIT;
  const key = options.key || DEFAULT_KEY;
  return {
    name: linkederrors_INTEGRATION_NAME,
    preprocessEvent(event, hint, client) {
      const options = client.getOptions();
      applyAggregateErrorsToEvent(
      // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
      exceptionFromError, options.stackParser, options.maxValueLength, key, limit, event, hint);
    }
  };
};

/**
 * Aggregrate linked errors in an event.
 */
const linkedErrorsIntegration = (0,esm_integration/* defineIntegration */._I)(_linkedErrorsIntegration);

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/build/npm/esm/stack-parsers.js


// This was originally forked from https://github.com/csnover/TraceKit, and was largely
// re - written as part of raven - js.
//
// This code was later copied to the JavaScript mono - repo and further modified and
// refactored over the years.

const OPERA10_PRIORITY = 10;
const OPERA11_PRIORITY = 20;
const CHROME_PRIORITY = 30;
const WINJS_PRIORITY = 40;
const GECKO_PRIORITY = 50;
function createFrame(filename, func, lineno, colno) {
  const frame = {
    filename,
    function: func === '<anonymous>' ? stacktrace/* UNKNOWN_FUNCTION */.Fi : func,
    in_app: true // All browser frames are considered in_app
  };
  if (lineno !== undefined) {
    frame.lineno = lineno;
  }
  if (colno !== undefined) {
    frame.colno = colno;
  }
  return frame;
}

// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;

// This regex matches all the frames that have a function name.
const chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;

// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const chromeStackParserFn = line => {
  // If the stack line has no function name, we need to parse it differently
  const noFnParts = chromeRegexNoFnName.exec(line);
  if (noFnParts) {
    const [, filename, line, col] = noFnParts;
    return createFrame(filename, stacktrace/* UNKNOWN_FUNCTION */.Fi, +line, +col);
  }
  const parts = chromeRegex.exec(line);
  if (parts) {
    const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

    if (isEval) {
      const subMatch = chromeEvalRegex.exec(parts[2]);
      if (subMatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = subMatch[1]; // url
        parts[3] = subMatch[2]; // line
        parts[4] = subMatch[3]; // column
      }
    }

    // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
    // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
    const [func, filename] = extractSafariExtensionDetails(parts[1] || stacktrace/* UNKNOWN_FUNCTION */.Fi, parts[2]);
    return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
  }
  return;
};
const chromeStackLineParser = [CHROME_PRIORITY, chromeStackParserFn];

// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const gecko = line => {
  const parts = geckoREgex.exec(line);
  if (parts) {
    const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    if (isEval) {
      const subMatch = geckoEvalRegex.exec(parts[3]);
      if (subMatch) {
        // throw out eval line/column and use top-most line number
        parts[1] = parts[1] || 'eval';
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = ''; // no column when eval
      }
    }
    let filename = parts[3];
    let func = parts[1] || stacktrace/* UNKNOWN_FUNCTION */.Fi;
    [func, filename] = extractSafariExtensionDetails(func, filename);
    return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
  }
  return;
};
const geckoStackLineParser = [GECKO_PRIORITY, gecko];
const winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const winjs = line => {
  const parts = winjsRegex.exec(line);
  return parts ? createFrame(parts[2], parts[1] || stacktrace/* UNKNOWN_FUNCTION */.Fi, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const winjsStackLineParser = [WINJS_PRIORITY, winjs];
const opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const opera10 = line => {
  const parts = opera10Regex.exec(line);
  return parts ? createFrame(parts[2], parts[3] || stacktrace/* UNKNOWN_FUNCTION */.Fi, +parts[1]) : undefined;
};
const opera10StackLineParser = [OPERA10_PRIORITY, opera10];
const opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const opera11 = line => {
  const parts = opera11Regex.exec(line);
  return parts ? createFrame(parts[5], parts[3] || parts[4] || stacktrace/* UNKNOWN_FUNCTION */.Fi, +parts[1], +parts[2]) : undefined;
};
const opera11StackLineParser = [OPERA11_PRIORITY, opera11];
const defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser];
const defaultStackParser = (0,stacktrace/* createStackParser */.pE)(...defaultStackLineParsers);

/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
const extractSafariExtensionDetails = (func, filename) => {
  const isSafariExtension = func.indexOf('safari-extension') !== -1;
  const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
  return isSafariExtension || isSafariWebExtension ? [func.indexOf('@') !== -1 ? func.split('@')[0] : stacktrace/* UNKNOWN_FUNCTION */.Fi, isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`] : [func, filename];
};

// EXTERNAL MODULE: ./node_modules/@sentry-internal/browser-utils/build/esm/getNativeImplementation.js
var getNativeImplementation = __webpack_require__(17340);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/promisebuffer.js



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
  const buffer = [];
  function isReady() {
    return limit === undefined || buffer.length < limit;
  }

  /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */
  function remove(task) {
    return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
  }

  /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */
  function add(taskProducer) {
    if (!isReady()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('Not adding Promise because buffer limit was reached.'));
    }

    // start the task and add its promise to the queue
    const task = taskProducer();
    if (buffer.indexOf(task) === -1) {
      buffer.push(task);
    }
    void task.then(() => remove(task))
    // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
    // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
    // have promises, so TS has to polyfill when down-compiling.)
    .then(null, () => remove(task).then(null, () => {
      // We have to add another catch here because `remove()` starts a new promise chain.
    }));
    return task;
  }

  /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */
  function drain(timeout) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      let counter = buffer.length;
      if (!counter) {
        return resolve(true);
      }

      // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
      const capturedSetTimeout = setTimeout(() => {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);

      // if all promises resolve in time, cancel the timer and resolve to `true`
      buffer.forEach(item => {
        void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(() => {
          if (! --counter) {
            clearTimeout(capturedSetTimeout);
            resolve(true);
          }
        }, reject);
      });
    });
  }
  return {
    $: buffer,
    add,
    drain
  };
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/ratelimit.js
var ratelimit = __webpack_require__(25528);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/transports/base.js







const DEFAULT_TRANSPORT_BUFFER_SIZE = 64;

/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(options, makeRequest, buffer = makePromiseBuffer(options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE)) {
  let rateLimits = {};
  const flush = timeout => buffer.drain(timeout);
  function send(envelope) {
    const filteredEnvelopeItems = [];

    // Drop rate limited items from envelope
    (0,utils_hoist_envelope/* forEachEnvelopeItem */.gv)(envelope, (item, type) => {
      const dataCategory = (0,utils_hoist_envelope/* envelopeItemTypeToDataCategory */.mL)(type);
      if ((0,ratelimit/* isRateLimited */.Q)(rateLimits, dataCategory)) {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });

    // Skip sending if envelope is empty after filtering out rate limited events
    if (filteredEnvelopeItems.length === 0) {
      return (0,syncpromise/* resolvedSyncPromise */.WD)({});
    }
    const filteredEnvelope = (0,utils_hoist_envelope/* createEnvelope */.Jd)(envelope[0], filteredEnvelopeItems);

    // Creates client report for each item in an envelope
    const recordEnvelopeLoss = reason => {
      (0,utils_hoist_envelope/* forEachEnvelopeItem */.gv)(filteredEnvelope, (item, type) => {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent(reason, (0,utils_hoist_envelope/* envelopeItemTypeToDataCategory */.mL)(type), event);
      });
    };
    const requestTask = () => makeRequest({
      body: (0,utils_hoist_envelope/* serializeEnvelope */.V$)(filteredEnvelope)
    }).then(response => {
      // We don't want to throw on NOK responses, but we want to at least log them
      if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
        debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
      }
      rateLimits = (0,ratelimit/* updateRateLimits */.WG)(rateLimits, response);
      return response;
    }, error => {
      recordEnvelopeLoss('network_error');
      throw error;
    });
    return buffer.add(requestTask).then(result => result, error => {
      if (error instanceof SentryError) {
        debug_build/* DEBUG_BUILD */.X && logger/* logger.error */.kg.error('Skipped sending event because buffer is full.');
        recordEnvelopeLoss('queue_overflow');
        return (0,syncpromise/* resolvedSyncPromise */.WD)({});
      } else {
        throw error;
      }
    });
  }
  return {
    send,
    flush
  };
}
function getEventForEnvelopeItem(item, type) {
  if (type !== 'event' && type !== 'transaction') {
    return undefined;
  }
  return Array.isArray(item) ? item[1] : undefined;
}

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/build/npm/esm/transports/fetch.js



/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeFetchTransport(options, nativeFetch = (0,getNativeImplementation/* getNativeImplementation */.L2)('fetch')) {
  let pendingBodySize = 0;
  let pendingCount = 0;
  function makeRequest(request) {
    const requestSize = request.body.length;
    pendingBodySize += requestSize;
    pendingCount++;
    const requestOptions = {
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: pendingBodySize <= 60000 && pendingCount < 15,
      ...options.fetchOptions
    };
    if (!nativeFetch) {
      (0,getNativeImplementation/* clearCachedImplementation */._6)('fetch');
      return (0,syncpromise/* rejectedSyncPromise */.$2)('No fetch implementation available');
    }
    try {
      // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
      return nativeFetch(options.url, requestOptions).then(response => {
        pendingBodySize -= requestSize;
        pendingCount--;
        return {
          statusCode: response.status,
          headers: {
            'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
            'retry-after': response.headers.get('Retry-After')
          }
        };
      });
    } catch (e) {
      (0,getNativeImplementation/* clearCachedImplementation */._6)('fetch');
      pendingBodySize -= requestSize;
      pendingCount--;
      return (0,syncpromise/* rejectedSyncPromise */.$2)(e);
    }
  }
  return createTransport(options, makeRequest);
}

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/build/npm/esm/sdk.js













/** Get the default integrations for the browser SDK. */
function getDefaultIntegrations(options) {
  /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */
  const integrations = [inboundFiltersIntegration(), functionToStringIntegration(), browserApiErrorsIntegration(), breadcrumbsIntegration(), globalHandlersIntegration(), linkedErrorsIntegration(), dedupeIntegration(), httpContextIntegration()];

  // eslint-disable-next-line deprecation/deprecation
  if (options.autoSessionTracking !== false) {
    integrations.push(browserSessionIntegration());
  }
  return integrations;
}
function applyDefaultOptions(optionsArg = {}) {
  const defaultOptions = {
    defaultIntegrations: getDefaultIntegrations(optionsArg),
    release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
    ? __SENTRY_RELEASE__ : helpers/* WINDOW.SENTRY_RELEASE */.m9.SENTRY_RELEASE && helpers/* WINDOW.SENTRY_RELEASE.id */.m9.SENTRY_RELEASE.id // This supports the variable that sentry-webpack-plugin injects
    ? helpers/* WINDOW.SENTRY_RELEASE.id */.m9.SENTRY_RELEASE.id : undefined,
    autoSessionTracking: true,
    sendClientReports: true
  };

  // TODO: Instead of dropping just `defaultIntegrations`, we should simply
  // call `dropUndefinedKeys` on the entire `optionsArg`.
  // However, for this to work we need to adjust the `hasTracingEnabled()` logic
  // first as it differentiates between `undefined` and the key not being in the object.
  if (optionsArg.defaultIntegrations == null) {
    delete optionsArg.defaultIntegrations;
  }
  return {
    ...defaultOptions,
    ...optionsArg
  };
}
function shouldShowBrowserExtensionError() {
  const windowWithMaybeExtension = typeof helpers/* WINDOW.window */.m9.window !== 'undefined' && helpers/* WINDOW */.m9;
  if (!windowWithMaybeExtension) {
    // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
  }
  const extensionKey = windowWithMaybeExtension.chrome ? 'chrome' : 'browser';
  const extensionObject = windowWithMaybeExtension[extensionKey];
  const runtimeId = extensionObject && extensionObject.runtime && extensionObject.runtime.id;
  const href = helpers/* WINDOW.location */.m9.location && helpers/* WINDOW.location.href */.m9.location.href || '';
  const extensionProtocols = ['chrome-extension:', 'moz-extension:', 'ms-browser-extension:', 'safari-web-extension:'];

  // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
  const isDedicatedExtensionPage = !!runtimeId && helpers/* WINDOW */.m9 === helpers/* WINDOW.top */.m9.top && extensionProtocols.some(protocol => href.startsWith(`${protocol}//`));

  // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
  // see: https://github.com/getsentry/sentry-javascript/issues/12668
  const isNWjs = typeof windowWithMaybeExtension.nw !== 'undefined';
  return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}

/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(browserOptions = {}) {
  const options = applyDefaultOptions(browserOptions);
  if (!options.skipBrowserExtensionCheck && shouldShowBrowserExtensionError()) {
    (0,logger/* consoleSandbox */.Cf)(() => {
      // eslint-disable-next-line no-console
      console.error('[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
    });
    return;
  }
  if (esm_debug_build/* DEBUG_BUILD */.X) {
    if (!(0,supports/* supportsFetch */.Ak)()) {
      logger/* logger.warn */.kg.warn('No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.');
    }
  }
  const clientOptions = {
    ...options,
    stackParser: (0,stacktrace/* stackParserFromStackParserOptions */.Sq)(options.stackParser || defaultStackParser),
    integrations: (0,esm_integration/* getIntegrationsToSetup */.m8)(options),
    transport: options.transport || makeFetchTransport
  };
  return initAndBind(BrowserClient, clientOptions);
}

/**
 * All properties the report dialog supports
 */

/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options = {}) {
  // doesn't work without a document (React Native)
  if (!helpers/* WINDOW.document */.m9.document) {
    esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.error */.kg.error('Global document not defined in showReportDialog call');
    return;
  }
  const scope = (0,currentScopes/* getCurrentScope */.nZ)();
  const client = scope.getClient();
  const dsn = client && client.getDsn();
  if (!dsn) {
    esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.error */.kg.error('DSN not configured for showReportDialog call');
    return;
  }
  if (scope) {
    options.user = {
      ...scope.getUser(),
      ...options.user
    };
  }
  if (!options.eventId) {
    const eventId = (0,esm_exports/* lastEventId */.eW)();
    if (eventId) {
      options.eventId = eventId;
    }
  }
  const script = helpers/* WINDOW.document.createElement */.m9.document.createElement('script');
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.src = getReportDialogEndpoint(dsn, options);
  if (options.onLoad) {
    script.onload = options.onLoad;
  }
  const {
    onClose
  } = options;
  if (onClose) {
    const reportDialogClosedMessageHandler = event => {
      if (event.data === '__sentry_reportdialog_closed__') {
        try {
          onClose();
        } finally {
          helpers/* WINDOW.removeEventListener */.m9.removeEventListener('message', reportDialogClosedMessageHandler);
        }
      }
    };
    helpers/* WINDOW.addEventListener */.m9.addEventListener('message', reportDialogClosedMessageHandler);
  }
  const injectionPoint = helpers/* WINDOW.document.head */.m9.document.head || helpers/* WINDOW.document.body */.m9.document.body;
  if (injectionPoint) {
    injectionPoint.appendChild(script);
  } else {
    esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.error */.kg.error('Not injecting report dialog. No injection point found in HTML');
  }
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
  // Noop
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
  callback();
}

/**
 * Captures user feedback and sends it to Sentry.
 *
 * @deprecated Use `captureFeedback` instead.
 */
function captureUserFeedback(feedback) {
  const client = getClient();
  if (client) {
    // eslint-disable-next-line deprecation/deprecation
    client.captureUserFeedback(feedback);
  }
}


/***/ }),

/***/ 91164:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ getAsyncContextStrategy; }
});

// UNUSED EXPORTS: setAsyncContextStrategy

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/carrier.js
var esm_carrier = __webpack_require__(17195);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/scope.js
var esm_scope = __webpack_require__(4443);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/worldwide.js
var worldwide = __webpack_require__(23867);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/defaultScopes.js



/** Get the default current scope. */
function getDefaultCurrentScope() {
  return (0,worldwide/* getGlobalSingleton */.Y)('defaultCurrentScope', () => new esm_scope/* Scope */.s());
}

/** Get the default isolation scope. */
function getDefaultIsolationScope() {
  return (0,worldwide/* getGlobalSingleton */.Y)('defaultIsolationScope', () => new esm_scope/* Scope */.s());
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/is.js
var is = __webpack_require__(92668);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/asyncContext/stackStrategy.js





/**
 * This is an object that holds a stack of scopes.
 */
class AsyncContextStack {
  constructor(scope, isolationScope) {
    let assignedScope;
    if (!scope) {
      assignedScope = new esm_scope/* Scope */.s();
    } else {
      assignedScope = scope;
    }
    let assignedIsolationScope;
    if (!isolationScope) {
      assignedIsolationScope = new esm_scope/* Scope */.s();
    } else {
      assignedIsolationScope = isolationScope;
    }

    // scope stack for domains or the process
    this._stack = [{
      scope: assignedScope
    }];
    this._isolationScope = assignedIsolationScope;
  }

  /**
   * Fork a scope for the stack.
   */
  withScope(callback) {
    const scope = this._pushScope();
    let maybePromiseResult;
    try {
      maybePromiseResult = callback(scope);
    } catch (e) {
      this._popScope();
      throw e;
    }
    if ((0,is/* isThenable */.J8)(maybePromiseResult)) {
      // @ts-expect-error - isThenable returns the wrong type
      return maybePromiseResult.then(res => {
        this._popScope();
        return res;
      }, e => {
        this._popScope();
        throw e;
      });
    }
    this._popScope();
    return maybePromiseResult;
  }

  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }

  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }

  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }

  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    // We want to clone the content of prev scope
    const scope = this.getScope().clone();
    this._stack.push({
      client: this.getClient(),
      scope
    });
    return scope;
  }

  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    if (this._stack.length <= 1) return false;
    return !!this._stack.pop();
  }
}

/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */
function getAsyncContextStack() {
  const registry = (0,esm_carrier/* getMainCarrier */.c)();
  const sentry = (0,esm_carrier/* getSentryCarrier */.q)(registry);
  return sentry.stack = sentry.stack || new AsyncContextStack(getDefaultCurrentScope(), getDefaultIsolationScope());
}
function withScope(callback) {
  return getAsyncContextStack().withScope(callback);
}
function withSetScope(scope, callback) {
  const stack = getAsyncContextStack();
  return stack.withScope(() => {
    stack.getStackTop().scope = scope;
    return callback(scope);
  });
}
function withIsolationScope(callback) {
  return getAsyncContextStack().withScope(() => {
    return callback(getAsyncContextStack().getIsolationScope());
  });
}

/**
 * Get the stack-based async context strategy.
 */
function getStackAsyncContextStrategy() {
  return {
    withIsolationScope,
    withScope,
    withSetScope,
    withSetIsolationScope: (_isolationScope, callback) => {
      return withIsolationScope(callback);
    },
    getCurrentScope: () => getAsyncContextStack().getScope(),
    getIsolationScope: () => getAsyncContextStack().getIsolationScope()
  };
}

;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/asyncContext/index.js



/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */
function setAsyncContextStrategy(strategy) {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();
  const sentry = getSentryCarrier(registry);
  sentry.acs = strategy;
}

/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */
function getAsyncContextStrategy(carrier) {
  const sentry = (0,esm_carrier/* getSentryCarrier */.q)(carrier);
  if (sentry.acs) {
    return sentry.acs;
  }

  // Otherwise, use the default one (stack)
  return getStackAsyncContextStrategy();
}


/***/ }),

/***/ 5258:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ addBreadcrumb; }
/* harmony export */ });
/* harmony import */ var _currentScopes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97308);
/* harmony import */ var _utils_hoist_logger_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3518);
/* harmony import */ var _utils_hoist_time_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27870);




/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const DEFAULT_BREADCRUMBS = 100;

/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */
function addBreadcrumb(breadcrumb, hint) {
  const client = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .s3)();
  const isolationScope = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
  if (!client) return;
  const {
    beforeBreadcrumb = null,
    maxBreadcrumbs = DEFAULT_BREADCRUMBS
  } = client.getOptions();
  if (maxBreadcrumbs <= 0) return;
  const timestamp = (0,_utils_hoist_time_js__WEBPACK_IMPORTED_MODULE_1__/* .dateTimestampInSeconds */ .yW)();
  const mergedBreadcrumb = {
    timestamp,
    ...breadcrumb
  };
  const finalBreadcrumb = beforeBreadcrumb ? (0,_utils_hoist_logger_js__WEBPACK_IMPORTED_MODULE_2__/* .consoleSandbox */ .Cf)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
  if (finalBreadcrumb === null) return;
  if (client.emit) {
    client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
  }
  isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}


/***/ }),

/***/ 17195:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getMainCarrier; },
/* harmony export */   "q": function() { return /* binding */ getSentryCarrier; }
/* harmony export */ });
/* harmony import */ var _utils_hoist_version_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58077);
/* harmony import */ var _utils_hoist_worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23867);



/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  // This ensures a Sentry carrier exists
  getSentryCarrier(_utils_hoist_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n);
  return _utils_hoist_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n;
}

/** Will either get the existing sentry carrier, or create a new one. */
function getSentryCarrier(carrier) {
  const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};

  // For now: First SDK that sets the .version property wins
  __SENTRY__.version = __SENTRY__.version || _utils_hoist_version_js__WEBPACK_IMPORTED_MODULE_1__/* .SDK_VERSION */ .J;

  // Intentionally populating and returning the version of "this" SDK instance
  // rather than what's set in .version so that "this" SDK always gets its carrier
  return __SENTRY__[_utils_hoist_version_js__WEBPACK_IMPORTED_MODULE_1__/* .SDK_VERSION */ .J] = __SENTRY__[_utils_hoist_version_js__WEBPACK_IMPORTED_MODULE_1__/* .SDK_VERSION */ .J] || {};
}


/***/ }),

/***/ 95931:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ DEFAULT_ENVIRONMENT; }
/* harmony export */ });
const DEFAULT_ENVIRONMENT = 'production';


/***/ }),

/***/ 97308:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ withScope; },
/* harmony export */   "XX": function() { return /* binding */ getTraceContextFromScope; },
/* harmony export */   "aF": function() { return /* binding */ getIsolationScope; },
/* harmony export */   "lW": function() { return /* binding */ getGlobalScope; },
/* harmony export */   "nZ": function() { return /* binding */ getCurrentScope; },
/* harmony export */   "s3": function() { return /* binding */ getClient; }
/* harmony export */ });
/* unused harmony export withIsolationScope */
/* harmony import */ var _asyncContext_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91164);
/* harmony import */ var _carrier_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17195);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4443);
/* harmony import */ var _utils_hoist_object_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88803);
/* harmony import */ var _utils_hoist_worldwide_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23867);






/**
 * Get the currently active scope.
 */
function getCurrentScope() {
  const carrier = (0,_carrier_js__WEBPACK_IMPORTED_MODULE_0__/* .getMainCarrier */ .c)();
  const acs = (0,_asyncContext_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getAsyncContextStrategy */ .G)(carrier);
  return acs.getCurrentScope();
}

/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */
function getIsolationScope() {
  const carrier = (0,_carrier_js__WEBPACK_IMPORTED_MODULE_0__/* .getMainCarrier */ .c)();
  const acs = (0,_asyncContext_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getAsyncContextStrategy */ .G)(carrier);
  return acs.getIsolationScope();
}

/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */
function getGlobalScope() {
  return (0,_utils_hoist_worldwide_js__WEBPACK_IMPORTED_MODULE_2__/* .getGlobalSingleton */ .Y)('globalScope', () => new _scope_js__WEBPACK_IMPORTED_MODULE_3__/* .Scope */ .s());
}

/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */

/**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */
function withScope(...rest) {
  const carrier = (0,_carrier_js__WEBPACK_IMPORTED_MODULE_0__/* .getMainCarrier */ .c)();
  const acs = (0,_asyncContext_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getAsyncContextStrategy */ .G)(carrier);

  // If a scope is defined, we want to make this the active scope instead of the default one
  if (rest.length === 2) {
    const [scope, callback] = rest;
    if (!scope) {
      return acs.withScope(callback);
    }
    return acs.withSetScope(scope, callback);
  }
  return acs.withScope(rest[0]);
}

/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */

/**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */
function withIsolationScope(...rest) {
  const carrier = getMainCarrier();
  const acs = getAsyncContextStrategy(carrier);

  // If a scope is defined, we want to make this the active scope instead of the default one
  if (rest.length === 2) {
    const [isolationScope, callback] = rest;
    if (!isolationScope) {
      return acs.withIsolationScope(callback);
    }
    return acs.withSetIsolationScope(isolationScope, callback);
  }
  return acs.withIsolationScope(rest[0]);
}

/**
 * Get the currently active client.
 */
function getClient() {
  return getCurrentScope().getClient();
}

/**
 * Get a trace context for the given scope.
 */
function getTraceContextFromScope(scope) {
  const propagationContext = scope.getPropagationContext();

  // TODO(v9): Use generateSpanId() instead of spanId
  // eslint-disable-next-line deprecation/deprecation
  const {
    traceId,
    spanId,
    parentSpanId
  } = propagationContext;
  const traceContext = (0,_utils_hoist_object_js__WEBPACK_IMPORTED_MODULE_4__/* .dropUndefinedKeys */ .Jr)({
    trace_id: traceId,
    span_id: spanId,
    parent_span_id: parentSpanId
  });
  return traceContext;
}


/***/ }),

/***/ 27344:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD =  false || false;


/***/ }),

/***/ 27662:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mq": function() { return /* binding */ createEventEnvelope; },
/* harmony export */   "Q3": function() { return /* binding */ createSessionEnvelope; },
/* harmony export */   "uE": function() { return /* binding */ createSpanEnvelope; }
/* harmony export */ });
/* harmony import */ var _tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51789);
/* harmony import */ var _utils_hoist_dsn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88157);
/* harmony import */ var _utils_hoist_envelope_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53767);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43384);







/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [...(event.sdk.integrations || []), ...(sdkInfo.integrations || [])];
  event.sdk.packages = [...(event.sdk.packages || []), ...(sdkInfo.packages || [])];
  return event;
}

/** Creates an envelope from a Session */
function createSessionEnvelope(session, dsn, metadata, tunnel) {
  const sdkInfo = (0,_utils_hoist_envelope_js__WEBPACK_IMPORTED_MODULE_0__/* .getSdkMetadataForEnvelopeHeader */ .HY)(metadata);
  const envelopeHeaders = {
    sent_at: new Date().toISOString(),
    ...(sdkInfo && {
      sdk: sdkInfo
    }),
    ...(!!tunnel && dsn && {
      dsn: (0,_utils_hoist_dsn_js__WEBPACK_IMPORTED_MODULE_1__/* .dsnToString */ .RA)(dsn)
    })
  };
  const envelopeItem = 'aggregates' in session ? [{
    type: 'sessions'
  }, session] : [{
    type: 'session'
  }, session.toJSON()];
  return (0,_utils_hoist_envelope_js__WEBPACK_IMPORTED_MODULE_0__/* .createEnvelope */ .Jd)(envelopeHeaders, [envelopeItem]);
}

/**
 * Create an Envelope from an event.
 */
function createEventEnvelope(event, dsn, metadata, tunnel) {
  const sdkInfo = (0,_utils_hoist_envelope_js__WEBPACK_IMPORTED_MODULE_0__/* .getSdkMetadataForEnvelopeHeader */ .HY)(metadata);

  /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */
  const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
  const envelopeHeaders = (0,_utils_hoist_envelope_js__WEBPACK_IMPORTED_MODULE_0__/* .createEventEnvelopeHeaders */ .Cd)(event, sdkInfo, tunnel, dsn);

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete event.sdkProcessingMetadata;
  const eventItem = [{
    type: eventType
  }, event];
  return (0,_utils_hoist_envelope_js__WEBPACK_IMPORTED_MODULE_0__/* .createEnvelope */ .Jd)(envelopeHeaders, [eventItem]);
}

/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */
function createSpanEnvelope(spans, client) {
  function dscHasRequiredProps(dsc) {
    return !!dsc.trace_id && !!dsc.public_key;
  }

  // For the moment we'll obtain the DSC from the first span in the array
  // This might need to be changed if we permit sending multiple spans from
  // different segments in one envelope
  const dsc = (0,_tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_2__/* .getDynamicSamplingContextFromSpan */ .jC)(spans[0]);
  const dsn = client && client.getDsn();
  const tunnel = client && client.getOptions().tunnel;
  const headers = {
    sent_at: new Date().toISOString(),
    ...(dscHasRequiredProps(dsc) && {
      trace: dsc
    }),
    ...(!!tunnel && dsn && {
      dsn: (0,_utils_hoist_dsn_js__WEBPACK_IMPORTED_MODULE_1__/* .dsnToString */ .RA)(dsn)
    })
  };
  const beforeSendSpan = client && client.getOptions().beforeSendSpan;
  const convertToSpanJSON = beforeSendSpan ? span => {
    const spanJson = beforeSendSpan((0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(span));
    if (!spanJson) {
      (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .showSpanDropWarning */ .R6)();
    }
    return spanJson;
  } : span => (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(span);
  const items = [];
  for (const span of spans) {
    const spanJson = convertToSpanJSON(span);
    if (spanJson) {
      items.push((0,_utils_hoist_envelope_js__WEBPACK_IMPORTED_MODULE_0__/* .createSpanEnvelopeItem */ .KQ)(spanJson));
    }
  }
  return (0,_utils_hoist_envelope_js__WEBPACK_IMPORTED_MODULE_0__/* .createEnvelope */ .Jd)(headers, items);
}


/***/ }),

/***/ 2155:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qy": function() { return /* binding */ addEventProcessor; },
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "_k": function() { return /* binding */ isEnabled; },
/* harmony export */   "cg": function() { return /* binding */ captureSession; },
/* harmony export */   "eN": function() { return /* binding */ captureEvent; },
/* harmony export */   "eW": function() { return /* binding */ lastEventId; },
/* harmony export */   "v": function() { return /* binding */ setContext; },
/* harmony export */   "yj": function() { return /* binding */ startSession; },
/* harmony export */   "yl": function() { return /* binding */ flush; }
/* harmony export */ });
/* unused harmony exports captureCheckIn, captureMessage, close, endSession, isInitialized, setExtra, setExtras, setTag, setTags, setUser, withMonitor */
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95931);
/* harmony import */ var _currentScopes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97308);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27344);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48258);
/* harmony import */ var _utils_hoist_logger_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3518);
/* harmony import */ var _utils_hoist_worldwide_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23867);
/* harmony import */ var _utils_prepareEvent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24737);











/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */
function captureException(exception, hint) {
  return (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentScope */ .nZ)().captureException(exception, (0,_utils_prepareEvent_js__WEBPACK_IMPORTED_MODULE_1__/* .parseEventHintOrCaptureContext */ .U0)(hint));
}

/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */
function captureMessage(message, captureContext) {
  // This is necessary to provide explicit scopes upgrade, without changing the original
  // arity of the `captureMessage(message, level)` method.
  const level = typeof captureContext === 'string' ? captureContext : undefined;
  const context = typeof captureContext !== 'string' ? {
    captureContext
  } : undefined;
  return getCurrentScope().captureMessage(message, level, context);
}

/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */
function captureEvent(event, hint) {
  return (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentScope */ .nZ)().captureEvent(event, hint);
}

/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
function setContext(name, context) {
  (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)().setContext(name, context);
}

/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
  getIsolationScope().setExtras(extras);
}

/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
  getIsolationScope().setExtra(key, extra);
}

/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
  getIsolationScope().setTags(tags);
}

/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
  getIsolationScope().setTag(key, value);
}

/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
  getIsolationScope().setUser(user);
}

/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */
function lastEventId() {
  return (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)().lastEventId();
}

/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */
function captureCheckIn(checkIn, upsertMonitorConfig) {
  const scope = getCurrentScope();
  const client = getClient();
  if (!client) {
    DEBUG_BUILD && logger.warn('Cannot capture check-in. No client defined.');
  } else if (!client.captureCheckIn) {
    DEBUG_BUILD && logger.warn('Cannot capture check-in. Client does not support sending check-ins.');
  } else {
    return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
  }
  return uuid4();
}

/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */
function withMonitor(monitorSlug, callback, upsertMonitorConfig) {
  const checkInId = captureCheckIn({
    monitorSlug,
    status: 'in_progress'
  }, upsertMonitorConfig);
  const now = timestampInSeconds();
  function finishCheckIn(status) {
    captureCheckIn({
      monitorSlug,
      status,
      checkInId,
      duration: timestampInSeconds() - now
    });
  }
  return withIsolationScope(() => {
    let maybePromiseResult;
    try {
      maybePromiseResult = callback();
    } catch (e) {
      finishCheckIn('error');
      throw e;
    }
    if (isThenable(maybePromiseResult)) {
      Promise.resolve(maybePromiseResult).then(() => {
        finishCheckIn('ok');
      }, e => {
        finishCheckIn('error');
        throw e;
      });
    } else {
      finishCheckIn('ok');
    }
    return maybePromiseResult;
  });
}

/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
async function flush(timeout) {
  const client = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .s3)();
  if (client) {
    return client.flush(timeout);
  }
  _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _utils_hoist_logger_js__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn('Cannot flush events. No client defined.');
  return Promise.resolve(false);
}

/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
async function close(timeout) {
  const client = getClient();
  if (client) {
    return client.close(timeout);
  }
  DEBUG_BUILD && logger.warn('Cannot flush events and disable SDK. No client defined.');
  return Promise.resolve(false);
}

/**
 * Returns true if Sentry has been properly initialized.
 */
function isInitialized() {
  return !!getClient();
}

/** If the SDK is initialized & enabled. */
function isEnabled() {
  const client = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .s3)();
  return !!client && client.getOptions().enabled !== false && !!client.getTransport();
}

/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */
function addEventProcessor(callback) {
  (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)().addEventProcessor(callback);
}

/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */
function startSession(context) {
  const client = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .s3)();
  const isolationScope = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
  const currentScope = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentScope */ .nZ)();
  const {
    release,
    environment = _constants_js__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_ENVIRONMENT */ .J
  } = client && client.getOptions() || {};

  // Will fetch userAgent if called from browser sdk
  const {
    userAgent
  } = _utils_hoist_worldwide_js__WEBPACK_IMPORTED_MODULE_5__/* .GLOBAL_OBJ.navigator */ .n.navigator || {};
  const session = (0,_session_js__WEBPACK_IMPORTED_MODULE_6__/* .makeSession */ .Hv)({
    release,
    environment,
    user: currentScope.getUser() || isolationScope.getUser(),
    ...(userAgent && {
      userAgent
    }),
    ...context
  });

  // End existing session if there's one
  const currentSession = isolationScope.getSession();
  if (currentSession && currentSession.status === 'ok') {
    (0,_session_js__WEBPACK_IMPORTED_MODULE_6__/* .updateSession */ .CT)(currentSession, {
      status: 'exited'
    });
  }
  endSession();

  // Afterwards we set the new session on the scope
  isolationScope.setSession(session);

  // TODO (v8): Remove this and only use the isolation scope(?).
  // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
  currentScope.setSession(session);
  return session;
}

/**
 * End the session on the current isolation scope.
 */
function endSession() {
  const isolationScope = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
  const currentScope = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentScope */ .nZ)();
  const session = currentScope.getSession() || isolationScope.getSession();
  if (session) {
    (0,_session_js__WEBPACK_IMPORTED_MODULE_6__/* .closeSession */ .RJ)(session);
  }
  _sendSessionUpdate();

  // the session is over; take it off of the scope
  isolationScope.setSession();

  // TODO (v8): Remove this and only use the isolation scope(?).
  // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
  currentScope.setSession();
}

/**
 * Sends the current Session on the scope
 */
function _sendSessionUpdate() {
  const isolationScope = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
  const currentScope = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentScope */ .nZ)();
  const client = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .s3)();
  // TODO (v8): Remove currentScope and only use the isolation scope(?).
  // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
  const session = currentScope.getSession() || isolationScope.getSession();
  if (session && client) {
    client.captureSession(session);
  }
}

/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */
function captureSession(end = false) {
  // both send the update and pull the session from the scope
  if (end) {
    endSession();
    return;
  }

  // only send the update
  _sendSessionUpdate();
}


/***/ }),

/***/ 12260:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_I": function() { return /* binding */ defineIntegration; },
/* harmony export */   "m7": function() { return /* binding */ setupIntegration; },
/* harmony export */   "m8": function() { return /* binding */ getIntegrationsToSetup; },
/* harmony export */   "q4": function() { return /* binding */ setupIntegrations; },
/* harmony export */   "uf": function() { return /* binding */ afterSetupIntegrations; }
/* harmony export */ });
/* unused harmony exports addIntegration, installedIntegrations */
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27344);
/* harmony import */ var _utils_hoist_logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3518);



const installedIntegrations = [];

/** Map of integrations assigned to a client */

/**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */
function filterDuplicates(integrations) {
  const integrationsByName = {};
  integrations.forEach(currentInstance => {
    const {
      name
    } = currentInstance;
    const existingInstance = integrationsByName[name];

    // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
    // default instance to overwrite an existing user instance
    if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
      return;
    }
    integrationsByName[name] = currentInstance;
  });
  return Object.values(integrationsByName);
}

/** Gets integrations to install */
function getIntegrationsToSetup(options) {
  const defaultIntegrations = options.defaultIntegrations || [];
  const userIntegrations = options.integrations;

  // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
  defaultIntegrations.forEach(integration => {
    integration.isDefaultInstance = true;
  });
  let integrations;
  if (Array.isArray(userIntegrations)) {
    integrations = [...defaultIntegrations, ...userIntegrations];
  } else if (typeof userIntegrations === 'function') {
    const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
    integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [resolvedUserIntegrations];
  } else {
    integrations = defaultIntegrations;
  }
  const finalIntegrations = filterDuplicates(integrations);

  // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
  // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
  // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
  // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
  const debugIndex = finalIntegrations.findIndex(integration => integration.name === 'Debug');
  if (debugIndex > -1) {
    const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
    finalIntegrations.push(debugInstance);
  }
  return finalIntegrations;
}

/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(client, integrations) {
  const integrationIndex = {};
  integrations.forEach(integration => {
    // guard against empty provided integrations
    if (integration) {
      setupIntegration(client, integration, integrationIndex);
    }
  });
  return integrationIndex;
}

/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */
function afterSetupIntegrations(client, integrations) {
  for (const integration of integrations) {
    // guard against empty provided integrations
    if (integration && integration.afterAllSetup) {
      integration.afterAllSetup(client);
    }
  }
}

/** Setup a single integration.  */
function setupIntegration(client, integration, integrationIndex) {
  if (integrationIndex[integration.name]) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .X && _utils_hoist_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.log */ .kg.log(`Integration skipped because it was already installed: ${integration.name}`);
    return;
  }
  integrationIndex[integration.name] = integration;

  // `setupOnce` is only called the first time
  if (installedIntegrations.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
    integration.setupOnce();
    installedIntegrations.push(integration.name);
  }

  // `setup` is run for each client
  if (integration.setup && typeof integration.setup === 'function') {
    integration.setup(client);
  }
  if (typeof integration.preprocessEvent === 'function') {
    const callback = integration.preprocessEvent.bind(integration);
    client.on('preprocessEvent', (event, hint) => callback(event, hint, client));
  }
  if (typeof integration.processEvent === 'function') {
    const callback = integration.processEvent.bind(integration);
    const processor = Object.assign((event, hint) => callback(event, hint, client), {
      id: integration.name
    });
    client.addEventProcessor(processor);
  }
  _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .X && _utils_hoist_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.log */ .kg.log(`Integration installed: ${integration.name}`);
}

/** Add an integration to the current scope's client. */
function addIntegration(integration) {
  const client = getClient();
  if (!client) {
    DEBUG_BUILD && logger.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
    return;
  }
  client.addIntegration(integration);
}

/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */
function defineIntegration(fn) {
  return fn;
}


/***/ }),

/***/ 17333:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ getMetricSummaryJsonForSpan; }
/* harmony export */ });
/* unused harmony export updateMetricSummaryOnSpan */
/* harmony import */ var _utils_hoist_object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88803);


/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */

const METRICS_SPAN_FIELD = '_sentryMetrics';

/**
 * Fetches the metric summary if it exists for the passed span
 */
function getMetricSummaryJsonForSpan(span) {
  const storage = span[METRICS_SPAN_FIELD];
  if (!storage) {
    return undefined;
  }
  const output = {};
  for (const [, [exportKey, summary]] of storage) {
    const arr = output[exportKey] || (output[exportKey] = []);
    arr.push((0,_utils_hoist_object_js__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)(summary));
  }
  return output;
}

/**
 * Updates the metric summary on a span.
 */
function updateMetricSummaryOnSpan(span, metricType, sanitizedName, value, unit, tags, bucketKey) {
  const existingStorage = span[METRICS_SPAN_FIELD];
  const storage = existingStorage || (span[METRICS_SPAN_FIELD] = new Map());
  const exportKey = `${metricType}:${sanitizedName}@${unit}`;
  const bucketItem = storage.get(bucketKey);
  if (bucketItem) {
    const [, summary] = bucketItem;
    storage.set(bucketKey, [exportKey, {
      min: Math.min(summary.min, value),
      max: Math.max(summary.max, value),
      count: summary.count += 1,
      sum: summary.sum += value,
      tags: summary.tags
    }]);
  } else {
    storage.set(bucketKey, [exportKey, {
      min: value,
      max: value,
      count: 1,
      sum: value,
      tags
    }]);
  }
}


/***/ }),

/***/ 4443:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ Scope; }
/* harmony export */ });
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48258);
/* harmony import */ var _utils_hoist_is_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92668);
/* harmony import */ var _utils_hoist_logger_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3518);
/* harmony import */ var _utils_hoist_misc_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27275);
/* harmony import */ var _utils_hoist_propagationContext_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28389);
/* harmony import */ var _utils_hoist_time_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27870);
/* harmony import */ var _utils_merge_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57104);
/* harmony import */ var _utils_spanOnScope_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14252);









/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const DEFAULT_MAX_BREADCRUMBS = 100;

/**
 * Holds additional event information.
 */
class ScopeClass {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called during event processing. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /** Propagation Context for distributed tracing */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */

  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */

  /** Session */

  /** Request Mode Session Status */
  // eslint-disable-next-line deprecation/deprecation

  /** The client on this scope */

  /** Contains the last event id of a captured event.  */

  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.

  constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
    this._propagationContext = {
      traceId: (0,_utils_hoist_propagationContext_js__WEBPACK_IMPORTED_MODULE_0__/* .generateTraceId */ .Ht)(),
      spanId: (0,_utils_hoist_propagationContext_js__WEBPACK_IMPORTED_MODULE_0__/* .generateSpanId */ .M)()
    };
  }

  /**
   * @inheritDoc
   */
  clone() {
    const newScope = new ScopeClass();
    newScope._breadcrumbs = [...this._breadcrumbs];
    newScope._tags = {
      ...this._tags
    };
    newScope._extra = {
      ...this._extra
    };
    newScope._contexts = {
      ...this._contexts
    };
    if (this._contexts.flags) {
      // We need to copy the `values` array so insertions on a cloned scope
      // won't affect the original array.
      newScope._contexts.flags = {
        values: [...this._contexts.flags.values]
      };
    }
    newScope._user = this._user;
    newScope._level = this._level;
    newScope._session = this._session;
    newScope._transactionName = this._transactionName;
    newScope._fingerprint = this._fingerprint;
    newScope._eventProcessors = [...this._eventProcessors];
    newScope._requestSession = this._requestSession;
    newScope._attachments = [...this._attachments];
    newScope._sdkProcessingMetadata = {
      ...this._sdkProcessingMetadata
    };
    newScope._propagationContext = {
      ...this._propagationContext
    };
    newScope._client = this._client;
    newScope._lastEventId = this._lastEventId;
    (0,_utils_spanOnScope_js__WEBPACK_IMPORTED_MODULE_1__/* ._setSpanForScope */ .D)(newScope, (0,_utils_spanOnScope_js__WEBPACK_IMPORTED_MODULE_1__/* ._getSpanForScope */ .Y)(this));
    return newScope;
  }

  /**
   * @inheritDoc
   */
  setClient(client) {
    this._client = client;
  }

  /**
   * @inheritDoc
   */
  setLastEventId(lastEventId) {
    this._lastEventId = lastEventId;
  }

  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }

  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
  addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
  addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
  setUser(user) {
    // If null is passed we want to unset everything, but still define keys,
    // so that later down in the pipeline any existing values are cleared.
    this._user = user || {
      email: undefined,
      id: undefined,
      ip_address: undefined,
      username: undefined
    };
    if (this._session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_2__/* .updateSession */ .CT)(this._session, {
        user
      });
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
  getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
  setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
  setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
  setTag(key, value) {
    this._tags = {
      ...this._tags,
      [key]: value
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
  setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
  setExtra(key, extra) {
    this._extra = {
      ...this._extra,
      [key]: extra
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
  setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
  setLevel(level) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */
  setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
  setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
  setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
  update(captureContext) {
    if (!captureContext) {
      return this;
    }
    const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
    const [scopeInstance, requestSession] = scopeToMerge instanceof Scope ?
    // eslint-disable-next-line deprecation/deprecation
    [scopeToMerge.getScopeData(), scopeToMerge.getRequestSession()] : (0,_utils_hoist_is_js__WEBPACK_IMPORTED_MODULE_3__/* .isPlainObject */ .PO)(scopeToMerge) ? [captureContext, captureContext.requestSession] : [];
    const {
      tags,
      extra,
      user,
      contexts,
      level,
      fingerprint = [],
      propagationContext
    } = scopeInstance || {};
    this._tags = {
      ...this._tags,
      ...tags
    };
    this._extra = {
      ...this._extra,
      ...extra
    };
    this._contexts = {
      ...this._contexts,
      ...contexts
    };
    if (user && Object.keys(user).length) {
      this._user = user;
    }
    if (level) {
      this._level = level;
    }
    if (fingerprint.length) {
      this._fingerprint = fingerprint;
    }
    if (propagationContext) {
      this._propagationContext = propagationContext;
    }
    if (requestSession) {
      this._requestSession = requestSession;
    }
    return this;
  }

  /**
   * @inheritDoc
   */
  clear() {
    // client is not cleared here on purpose!
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._session = undefined;
    (0,_utils_spanOnScope_js__WEBPACK_IMPORTED_MODULE_1__/* ._setSpanForScope */ .D)(this, undefined);
    this._attachments = [];
    this.setPropagationContext({
      traceId: (0,_utils_hoist_propagationContext_js__WEBPACK_IMPORTED_MODULE_0__/* .generateTraceId */ .Ht)()
    });
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
  addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }
    const mergedBreadcrumb = {
      timestamp: (0,_utils_hoist_time_js__WEBPACK_IMPORTED_MODULE_4__/* .dateTimestampInSeconds */ .yW)(),
      ...breadcrumb
    };
    this._breadcrumbs.push(mergedBreadcrumb);
    if (this._breadcrumbs.length > maxCrumbs) {
      this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
      if (this._client) {
        this._client.recordDroppedEvent('buffer_overflow', 'log_item');
      }
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }

  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
  addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   */
  clearAttachments() {
    this._attachments = [];
    return this;
  }

  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: (0,_utils_spanOnScope_js__WEBPACK_IMPORTED_MODULE_1__/* ._getSpanForScope */ .Y)(this)
    };
  }

  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = (0,_utils_merge_js__WEBPACK_IMPORTED_MODULE_5__/* .merge */ .T)(this._sdkProcessingMetadata, newData, 2);
    return this;
  }

  /**
   * @inheritDoc
   */
  setPropagationContext(context) {
    this._propagationContext = {
      // eslint-disable-next-line deprecation/deprecation
      spanId: (0,_utils_hoist_propagationContext_js__WEBPACK_IMPORTED_MODULE_0__/* .generateSpanId */ .M)(),
      ...context
    };
    return this;
  }

  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }

  /**
   * @inheritDoc
   */
  captureException(exception, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_utils_hoist_misc_js__WEBPACK_IMPORTED_MODULE_6__/* .uuid4 */ .DM)();
    if (!this._client) {
      _utils_hoist_logger_js__WEBPACK_IMPORTED_MODULE_7__/* .logger.warn */ .kg.warn('No client configured on scope - will not capture exception!');
      return eventId;
    }
    const syntheticException = new Error('Sentry syntheticException');
    this._client.captureException(exception, {
      originalException: exception,
      syntheticException,
      ...hint,
      event_id: eventId
    }, this);
    return eventId;
  }

  /**
   * @inheritDoc
   */
  captureMessage(message, level, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_utils_hoist_misc_js__WEBPACK_IMPORTED_MODULE_6__/* .uuid4 */ .DM)();
    if (!this._client) {
      _utils_hoist_logger_js__WEBPACK_IMPORTED_MODULE_7__/* .logger.warn */ .kg.warn('No client configured on scope - will not capture message!');
      return eventId;
    }
    const syntheticException = new Error(message);
    this._client.captureMessage(message, level, {
      originalException: message,
      syntheticException,
      ...hint,
      event_id: eventId
    }, this);
    return eventId;
  }

  /**
   * @inheritDoc
   */
  captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_utils_hoist_misc_js__WEBPACK_IMPORTED_MODULE_6__/* .uuid4 */ .DM)();
    if (!this._client) {
      _utils_hoist_logger_js__WEBPACK_IMPORTED_MODULE_7__/* .logger.warn */ .kg.warn('No client configured on scope - will not capture event!');
      return eventId;
    }
    this._client.captureEvent(event, {
      ...hint,
      event_id: eventId
    }, this);
    return eventId;
  }

  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }
}

/**
 * Holds additional event information.
 */
const Scope = ScopeClass;

/**
 * Holds additional event information.
 */



/***/ }),

/***/ 85535:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$J": function() { return /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_OP; },
/* harmony export */   "E1": function() { return /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT; },
/* harmony export */   "JQ": function() { return /* binding */ SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME; },
/* harmony export */   "S3": function() { return /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN; },
/* harmony export */   "TE": function() { return /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE; },
/* harmony export */   "Wb": function() { return /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE; },
/* harmony export */   "Zj": function() { return /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_SOURCE; },
/* harmony export */   "ju": function() { return /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON; },
/* harmony export */   "p6": function() { return /* binding */ SEMANTIC_ATTRIBUTE_PROFILE_ID; },
/* harmony export */   "xF": function() { return /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME; }
/* harmony export */ });
/* unused harmony exports SEMANTIC_ATTRIBUTE_CACHE_HIT, SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE, SEMANTIC_ATTRIBUTE_CACHE_KEY, SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD, SEMANTIC_ATTRIBUTE_URL_FULL */
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */
const SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = 'sentry.source';

/**
 * Use this attribute to represent the sample rate used for a span.
 */
const SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = 'sentry.sample_rate';

/**
 * Use this attribute to represent the operation of a span.
 */
const SEMANTIC_ATTRIBUTE_SENTRY_OP = 'sentry.op';

/**
 * Use this attribute to represent the origin of a span.
 */
const SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = 'sentry.origin';

/** The reason why an idle span finished. */
const SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = 'sentry.idle_span_finish_reason';

/** The unit of a measurement, which may be stored as a TimedEvent. */
const SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = 'sentry.measurement_unit';

/** The value of a measurement, which may be stored as a TimedEvent. */
const SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = 'sentry.measurement_value';

/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */
const SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = 'sentry.custom_span_name';

/**
 * The id of the profile that this span occurred in.
 */
const SEMANTIC_ATTRIBUTE_PROFILE_ID = 'sentry.profile_id';
const SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = 'sentry.exclusive_time';
const SEMANTIC_ATTRIBUTE_CACHE_HIT = 'cache.hit';
const SEMANTIC_ATTRIBUTE_CACHE_KEY = 'cache.key';
const SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = 'cache.item_size';

/** TODO: Remove these once we update to latest semantic conventions */
const SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = 'http.request.method';
const SEMANTIC_ATTRIBUTE_URL_FULL = 'url.full';


/***/ }),

/***/ 48258:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ updateSession; },
/* harmony export */   "Hv": function() { return /* binding */ makeSession; },
/* harmony export */   "RJ": function() { return /* binding */ closeSession; }
/* harmony export */ });
/* harmony import */ var _utils_hoist_object_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88803);
/* harmony import */ var _utils_hoist_time_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27870);
/* harmony import */ var _utils_hoist_misc_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27275);







/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  const startingTime = (0,_utils_hoist_time_js__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();
  const session = {
    sid: (0,_utils_hoist_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session)
  };
  if (context) {
    updateSession(session, context);
  }
  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
// eslint-disable-next-line complexity
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }
    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }
  session.timestamp = context.timestamp || (0,_utils_hoist_time_js__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();
  if (context.abnormal_mechanism) {
    session.abnormal_mechanism = context.abnormal_mechanism;
  }
  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0,_utils_hoist_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = {
      status
    };
  } else if (session.status === 'ok') {
    context = {
      status: 'exited'
    };
  }
  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return (0,_utils_hoist_object_js__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    abnormal_mechanism: session.abnormal_mechanism,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent
    }
  });
}


/***/ }),

/***/ 51789:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CG": function() { return /* binding */ getDynamicSamplingContextFromScope; },
/* harmony export */   "Lh": function() { return /* binding */ freezeDscOnSpan; },
/* harmony export */   "jC": function() { return /* binding */ getDynamicSamplingContextFromSpan; }
/* harmony export */ });
/* unused harmony exports getDynamicSamplingContextFromClient, spanToBaggageHeader */
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95931);
/* harmony import */ var _currentScopes_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97308);
/* harmony import */ var _semanticAttributes_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85535);
/* harmony import */ var _utils_hoist_baggage_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40382);
/* harmony import */ var _utils_hoist_object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88803);
/* harmony import */ var _utils_hasTracingEnabled_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68807);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43384);








/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */
const FROZEN_DSC_FIELD = '_frozenDsc';

/**
 * Freeze the given DSC on the given span.
 */
function freezeDscOnSpan(span, dsc) {
  const spanWithMaybeDsc = span;
  (0,_utils_hoist_object_js__WEBPACK_IMPORTED_MODULE_0__/* .addNonEnumerableProperty */ .xp)(spanWithMaybeDsc, FROZEN_DSC_FIELD, dsc);
}

/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */
function getDynamicSamplingContextFromClient(trace_id, client) {
  const options = client.getOptions();
  const {
    publicKey: public_key
  } = client.getDsn() || {};
  const dsc = (0,_utils_hoist_object_js__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)({
    environment: options.environment || _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_ENVIRONMENT */ .J,
    release: options.release,
    public_key,
    trace_id
  });
  client.emit('createDsc', dsc);
  return dsc;
}

/**
 * Get the dynamic sampling context for the currently active scopes.
 */
function getDynamicSamplingContextFromScope(client, scope) {
  const propagationContext = scope.getPropagationContext();
  return propagationContext.dsc || getDynamicSamplingContextFromClient(propagationContext.traceId, client);
}

/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */
function getDynamicSamplingContextFromSpan(span) {
  const client = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_2__/* .getClient */ .s3)();
  if (!client) {
    return {};
  }
  const rootSpan = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .getRootSpan */ .Gx)(span);

  // For core implementation, we freeze the DSC onto the span as a non-enumerable property
  const frozenDsc = rootSpan[FROZEN_DSC_FIELD];
  if (frozenDsc) {
    return frozenDsc;
  }

  // For OpenTelemetry, we freeze the DSC on the trace state
  const traceState = rootSpan.spanContext().traceState;
  const traceStateDsc = traceState && traceState.get('sentry.dsc');

  // If the span has a DSC, we want it to take precedence
  const dscOnTraceState = traceStateDsc && (0,_utils_hoist_baggage_js__WEBPACK_IMPORTED_MODULE_4__/* .baggageHeaderToDynamicSamplingContext */ .EN)(traceStateDsc);
  if (dscOnTraceState) {
    return dscOnTraceState;
  }

  // Else, we generate it from the span
  const dsc = getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
  const jsonSpan = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(rootSpan);
  const attributes = jsonSpan.data || {};
  const maybeSampleRate = attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_5__/* .SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */ .TE];
  if (maybeSampleRate != null) {
    dsc.sample_rate = `${maybeSampleRate}`;
  }

  // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
  const source = attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_5__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .Zj];

  // after JSON conversion, txn.name becomes jsonSpan.description
  const name = jsonSpan.description;
  if (source !== 'url' && name) {
    dsc.transaction = name;
  }

  // How can we even land here with hasTracingEnabled() returning false?
  // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
  // So we end up with an active span that is not sampled (neither positively nor negatively)
  if ((0,_utils_hasTracingEnabled_js__WEBPACK_IMPORTED_MODULE_6__/* .hasTracingEnabled */ .z)()) {
    dsc.sampled = String((0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanIsSampled */ .Tt)(rootSpan));
  }
  client.emit('createDsc', dsc, rootSpan);
  return dsc;
}

/**
 * Convert a Span to a baggage header.
 */
function spanToBaggageHeader(span) {
  const dsc = getDynamicSamplingContextFromSpan(span);
  return dynamicSamplingContextToSentryBaggageHeader(dsc);
}


/***/ }),

/***/ 34652:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ timedEventsToMeasurements; },
/* harmony export */   "o": function() { return /* binding */ setMeasurement; }
/* harmony export */ });
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27344);
/* harmony import */ var _semanticAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85535);
/* harmony import */ var _utils_hoist_logger_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3518);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43384);





/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */
function setMeasurement(name, value, unit, activeSpan = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getActiveSpan */ .HN)()) {
  const rootSpan = activeSpan && (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRootSpan */ .Gx)(activeSpan);
  if (rootSpan) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X && _utils_hoist_logger_js__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
    rootSpan.addEvent(name, {
      [_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_3__/* .SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE */ .Wb]: value,
      [_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_3__/* .SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT */ .E1]: unit
    });
  }
}

/**
 * Convert timed events to measurements.
 */
function timedEventsToMeasurements(events) {
  if (!events || events.length === 0) {
    return undefined;
  }
  const measurements = {};
  events.forEach(event => {
    const attributes = event.attributes || {};
    const unit = attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_3__/* .SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT */ .E1];
    const value = attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_3__/* .SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE */ .Wb];
    if (typeof unit === 'string' && typeof value === 'number') {
      measurements[event.name] = {
        value,
        unit
      };
    }
  });
  return measurements;
}


/***/ }),

/***/ 95055:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ SentryNonRecordingSpan; }
/* harmony export */ });
/* harmony import */ var _utils_hoist_propagationContext_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28389);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43384);



/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */
class SentryNonRecordingSpan {
  constructor(spanContext = {}) {
    this._traceId = spanContext.traceId || (0,_utils_hoist_propagationContext_js__WEBPACK_IMPORTED_MODULE_0__/* .generateTraceId */ .Ht)();
    this._spanId = spanContext.spanId || (0,_utils_hoist_propagationContext_js__WEBPACK_IMPORTED_MODULE_0__/* .generateSpanId */ .M)();
  }

  /** @inheritdoc */
  spanContext() {
    return {
      spanId: this._spanId,
      traceId: this._traceId,
      traceFlags: _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .TRACE_FLAG_NONE */ .ve
    };
  }

  /** @inheritdoc */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  end(_timestamp) {}

  /** @inheritdoc */
  setAttribute(_key, _value) {
    return this;
  }

  /** @inheritdoc */
  setAttributes(_values) {
    return this;
  }

  /** @inheritdoc */
  setStatus(_status) {
    return this;
  }

  /** @inheritdoc */
  updateName(_name) {
    return this;
  }

  /** @inheritdoc */
  isRecording() {
    return false;
  }

  /** @inheritdoc */
  addEvent(_name, _attributesOrStartTime, _startTime) {
    return this;
  }

  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  addLink(_link) {
    return this;
  }

  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  addLinks(_links) {
    return this;
  }

  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  recordException(_exception, _time) {
    // noop
  }
}


/***/ }),

/***/ 89898:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OP": function() { return /* binding */ SPAN_STATUS_OK; },
/* harmony export */   "Q0": function() { return /* binding */ setHttpStatus; },
/* harmony export */   "jt": function() { return /* binding */ SPAN_STATUS_ERROR; },
/* harmony export */   "pq": function() { return /* binding */ SPAN_STATUS_UNSET; }
/* harmony export */ });
/* unused harmony export getSpanStatusFromHttpCode */
const SPAN_STATUS_UNSET = 0;
const SPAN_STATUS_OK = 1;
const SPAN_STATUS_ERROR = 2;

/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
// https://develop.sentry.dev/sdk/event-payloads/span/
function getSpanStatusFromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return {
      code: SPAN_STATUS_OK
    };
  }
  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return {
          code: SPAN_STATUS_ERROR,
          message: 'unauthenticated'
        };
      case 403:
        return {
          code: SPAN_STATUS_ERROR,
          message: 'permission_denied'
        };
      case 404:
        return {
          code: SPAN_STATUS_ERROR,
          message: 'not_found'
        };
      case 409:
        return {
          code: SPAN_STATUS_ERROR,
          message: 'already_exists'
        };
      case 413:
        return {
          code: SPAN_STATUS_ERROR,
          message: 'failed_precondition'
        };
      case 429:
        return {
          code: SPAN_STATUS_ERROR,
          message: 'resource_exhausted'
        };
      case 499:
        return {
          code: SPAN_STATUS_ERROR,
          message: 'cancelled'
        };
      default:
        return {
          code: SPAN_STATUS_ERROR,
          message: 'invalid_argument'
        };
    }
  }
  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return {
          code: SPAN_STATUS_ERROR,
          message: 'unimplemented'
        };
      case 503:
        return {
          code: SPAN_STATUS_ERROR,
          message: 'unavailable'
        };
      case 504:
        return {
          code: SPAN_STATUS_ERROR,
          message: 'deadline_exceeded'
        };
      default:
        return {
          code: SPAN_STATUS_ERROR,
          message: 'internal_error'
        };
    }
  }
  return {
    code: SPAN_STATUS_ERROR,
    message: 'unknown_error'
  };
}

/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */
function setHttpStatus(span, httpStatus) {
  span.setAttribute('http.response.status_code', httpStatus);
  const spanStatus = getSpanStatusFromHttpCode(httpStatus);
  if (spanStatus.message !== 'unknown_error') {
    span.setStatus(spanStatus);
  }
}


/***/ }),

/***/ 20806:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qp": function() { return /* binding */ startInactiveSpan; },
  "GK": function() { return /* binding */ startSpan; },
  "_d": function() { return /* binding */ withActiveSpan; }
});

// UNUSED EXPORTS: continueTrace, startNewTrace, startSpanManual, suppressTracing

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/carrier.js
var esm_carrier = __webpack_require__(17195);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/currentScopes.js
var currentScopes = __webpack_require__(97308);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/asyncContext/index.js + 2 modules
var asyncContext = __webpack_require__(91164);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/semanticAttributes.js
var semanticAttributes = __webpack_require__(85535);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/is.js
var is = __webpack_require__(92668);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils/handleCallbackErrors.js


/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */
function handleCallbackErrors_handleCallbackErrors(fn, onError,
// eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = () => {}) {
  let maybePromiseResult;
  try {
    maybePromiseResult = fn();
  } catch (e) {
    onError(e);
    onFinally();
    throw e;
  }
  return maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}

/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */
function maybeHandlePromiseRejection(value, onError, onFinally) {
  if ((0,is/* isThenable */.J8)(value)) {
    // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then(res => {
      onFinally();
      return res;
    }, e => {
      onError(e);
      onFinally();
      throw e;
    });
  }
  onFinally();
  return value;
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/hasTracingEnabled.js
var hasTracingEnabled = __webpack_require__(68807);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanOnScope.js
var spanOnScope = __webpack_require__(14252);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(43384);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/dynamicSamplingContext.js
var dynamicSamplingContext = __webpack_require__(51789);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/debug-build.js
var debug_build = __webpack_require__(27344);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/logger.js
var utils_hoist_logger = __webpack_require__(3518);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/tracing/logSpans.js




/**
 * Print a log message for a started span.
 */
function logSpanStart(span) {
  if (!debug_build/* DEBUG_BUILD */.X) return;
  const {
    description = '< unknown name >',
    op = '< unknown op >',
    parent_span_id: parentSpanId
  } = (0,spanUtils/* spanToJSON */.XU)(span);
  const {
    spanId
  } = span.spanContext();
  const sampled = (0,spanUtils/* spanIsSampled */.Tt)(span);
  const rootSpan = (0,spanUtils/* getRootSpan */.Gx)(span);
  const isRootSpan = rootSpan === span;
  const header = `[Tracing] Starting ${sampled ? 'sampled' : 'unsampled'} ${isRootSpan ? 'root ' : ''}span`;
  const infoParts = [`op: ${op}`, `name: ${description}`, `ID: ${spanId}`];
  if (parentSpanId) {
    infoParts.push(`parent ID: ${parentSpanId}`);
  }
  if (!isRootSpan) {
    const {
      op,
      description
    } = (0,spanUtils/* spanToJSON */.XU)(rootSpan);
    infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
    if (op) {
      infoParts.push(`root op: ${op}`);
    }
    if (description) {
      infoParts.push(`root description: ${description}`);
    }
  }
  utils_hoist_logger/* logger.log */.kg.log(`${header}
  ${infoParts.join('\n  ')}`);
}

/**
 * Print a log message for an ended span.
 */
function logSpanEnd(span) {
  if (!debug_build/* DEBUG_BUILD */.X) return;
  const {
    description = '< unknown name >',
    op = '< unknown op >'
  } = (0,spanUtils/* spanToJSON */.XU)(span);
  const {
    spanId
  } = span.spanContext();
  const rootSpan = (0,spanUtils/* getRootSpan */.Gx)(span);
  const isRootSpan = rootSpan === span;
  const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? 'root ' : ''}span "${description}" with ID ${spanId}`;
  utils_hoist_logger/* logger.log */.kg.log(msg);
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/parseSampleRate.js
var parseSampleRate = __webpack_require__(86380);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/tracing/sampling.js






/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */
function sampleSpan(options, samplingContext) {
  // nothing to do if tracing is not enabled
  if (!(0,hasTracingEnabled/* hasTracingEnabled */.z)(options)) {
    return [false];
  }

  // Casting this from unknown, as the type of `sdkProcessingMetadata` is only changed in v9 and `normalizedRequest` is set in SentryHttpInstrumentation
  const normalizedRequest = (0,currentScopes/* getIsolationScope */.aF)().getScopeData().sdkProcessingMetadata.normalizedRequest;
  const enhancedSamplingContext = {
    ...samplingContext,
    normalizedRequest: samplingContext.normalizedRequest || normalizedRequest
  };

  // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
  // work; prefer the hook if so
  let sampleRate;
  if (typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler(enhancedSamplingContext);
  } else if (enhancedSamplingContext.parentSampled !== undefined) {
    sampleRate = enhancedSamplingContext.parentSampled;
  } else if (typeof options.tracesSampleRate !== 'undefined') {
    sampleRate = options.tracesSampleRate;
  } else {
    // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
  }

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
  // (The only valid values are booleans or numbers between 0 and 1.)
  const parsedSampleRate = (0,parseSampleRate/* parseSampleRate */.o)(sampleRate);
  if (parsedSampleRate === undefined) {
    debug_build/* DEBUG_BUILD */.X && utils_hoist_logger/* logger.warn */.kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
    return [false];
  }

  // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
  if (!parsedSampleRate) {
    debug_build/* DEBUG_BUILD */.X && utils_hoist_logger/* logger.log */.kg.log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
    return [false, parsedSampleRate];
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  const shouldSample = Math.random() < parsedSampleRate;

  // if we're not going to keep it, we're done
  if (!shouldSample) {
    debug_build/* DEBUG_BUILD */.X && utils_hoist_logger/* logger.log */.kg.log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [false, parsedSampleRate];
  }
  return [true, parsedSampleRate];
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/sentryNonRecordingSpan.js
var sentryNonRecordingSpan = __webpack_require__(95055);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/envelope.js
var envelope = __webpack_require__(27662);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/metrics/metric-summary.js
var metric_summary = __webpack_require__(17333);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/object.js
var object = __webpack_require__(88803);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/propagationContext.js
var propagationContext = __webpack_require__(28389);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/time.js
var utils_hoist_time = __webpack_require__(27870);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/measurement.js
var measurement = __webpack_require__(34652);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/tracing/utils.js

const SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';

/** Store the scope & isolation scope for a span, which can the be used when it is finished. */
function setCapturedScopesOnSpan(span, scope, isolationScope) {
  if (span) {
    (0,object/* addNonEnumerableProperty */.xp)(span, ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
    (0,object/* addNonEnumerableProperty */.xp)(span, SCOPE_ON_START_SPAN_FIELD, scope);
  }
}

/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */
function getCapturedScopesOnSpan(span) {
  return {
    scope: span[SCOPE_ON_START_SPAN_FIELD],
    isolationScope: span[ISOLATION_SCOPE_ON_START_SPAN_FIELD]
  };
}

;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/tracing/sentrySpan.js














const MAX_SPAN_COUNT = 1000;

/**
 * Span contains all data about a span
 */
class SentrySpan {
  /** Epoch timestamp in seconds when the span started. */

  /** Epoch timestamp in seconds when the span ended. */

  /** Internal keeper of the status */

  /** The timed events added to this span. */

  /** if true, treat span as a standalone span (not part of a transaction) */

  /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */
  constructor(spanContext = {}) {
    this._traceId = spanContext.traceId || (0,propagationContext/* generateTraceId */.Ht)();
    this._spanId = spanContext.spanId || (0,propagationContext/* generateSpanId */.M)();
    this._startTime = spanContext.startTimestamp || (0,utils_hoist_time/* timestampInSeconds */.ph)();
    this._attributes = {};
    this.setAttributes({
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'manual',
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J]: spanContext.op,
      ...spanContext.attributes
    });
    this._name = spanContext.name;
    if (spanContext.parentSpanId) {
      this._parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this._sampled = spanContext.sampled;
    }
    if (spanContext.endTimestamp) {
      this._endTime = spanContext.endTimestamp;
    }
    this._events = [];
    this._isStandaloneSpan = spanContext.isStandalone;

    // If the span is already ended, ensure we finalize the span immediately
    if (this._endTime) {
      this._onSpanEnded();
    }
  }

  /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  addLink(_link) {
    return this;
  }

  /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  addLinks(_links) {
    return this;
  }

  /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  recordException(_exception, _time) {
    // noop
  }

  /** @inheritdoc */
  spanContext() {
    const {
      _spanId: spanId,
      _traceId: traceId,
      _sampled: sampled
    } = this;
    return {
      spanId,
      traceId,
      traceFlags: sampled ? spanUtils/* TRACE_FLAG_SAMPLED */.i0 : spanUtils/* TRACE_FLAG_NONE */.ve
    };
  }

  /** @inheritdoc */
  setAttribute(key, value) {
    if (value === undefined) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._attributes[key];
    } else {
      this._attributes[key] = value;
    }
    return this;
  }

  /** @inheritdoc */
  setAttributes(attributes) {
    Object.keys(attributes).forEach(key => this.setAttribute(key, attributes[key]));
    return this;
  }

  /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */
  updateStartTime(timeInput) {
    this._startTime = (0,spanUtils/* spanTimeInputToSeconds */.$k)(timeInput);
  }

  /**
   * @inheritDoc
   */
  setStatus(value) {
    this._status = value;
    return this;
  }

  /**
   * @inheritDoc
   */
  updateName(name) {
    this._name = name;
    this.setAttribute(semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, 'custom');
    return this;
  }

  /** @inheritdoc */
  end(endTimestamp) {
    // If already ended, skip
    if (this._endTime) {
      return;
    }
    this._endTime = (0,spanUtils/* spanTimeInputToSeconds */.$k)(endTimestamp);
    logSpanEnd(this);
    this._onSpanEnded();
  }

  /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */
  getSpanJSON() {
    return (0,object/* dropUndefinedKeys */.Jr)({
      data: this._attributes,
      description: this._name,
      op: this._attributes[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J],
      parent_span_id: this._parentSpanId,
      span_id: this._spanId,
      start_timestamp: this._startTime,
      status: (0,spanUtils/* getStatusMessage */._4)(this._status),
      timestamp: this._endTime,
      trace_id: this._traceId,
      origin: this._attributes[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3],
      _metrics_summary: (0,metric_summary/* getMetricSummaryJsonForSpan */.y)(this),
      profile_id: this._attributes[semanticAttributes/* SEMANTIC_ATTRIBUTE_PROFILE_ID */.p6],
      exclusive_time: this._attributes[semanticAttributes/* SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME */.JQ],
      measurements: (0,measurement/* timedEventsToMeasurements */.l)(this._events),
      is_segment: this._isStandaloneSpan && (0,spanUtils/* getRootSpan */.Gx)(this) === this || undefined,
      segment_id: this._isStandaloneSpan ? (0,spanUtils/* getRootSpan */.Gx)(this).spanContext().spanId : undefined
    });
  }

  /** @inheritdoc */
  isRecording() {
    return !this._endTime && !!this._sampled;
  }

  /**
   * @inheritdoc
   */
  addEvent(name, attributesOrStartTime, startTime) {
    debug_build/* DEBUG_BUILD */.X && utils_hoist_logger/* logger.log */.kg.log('[Tracing] Adding an event to span:', name);
    const time = isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0,utils_hoist_time/* timestampInSeconds */.ph)();
    const attributes = isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
    const event = {
      name,
      time: (0,spanUtils/* spanTimeInputToSeconds */.$k)(time),
      attributes
    };
    this._events.push(event);
    return this;
  }

  /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */
  isStandaloneSpan() {
    return !!this._isStandaloneSpan;
  }

  /** Emit `spanEnd` when the span is ended. */
  _onSpanEnded() {
    const client = (0,currentScopes/* getClient */.s3)();
    if (client) {
      client.emit('spanEnd', this);
    }

    // A segment span is basically the root span of a local span tree.
    // So for now, this is either what we previously refer to as the root span,
    // or a standalone span.
    const isSegmentSpan = this._isStandaloneSpan || this === (0,spanUtils/* getRootSpan */.Gx)(this);
    if (!isSegmentSpan) {
      return;
    }

    // if this is a standalone span, we send it immediately
    if (this._isStandaloneSpan) {
      if (this._sampled) {
        sendSpanEnvelope((0,envelope/* createSpanEnvelope */.uE)([this], client));
      } else {
        debug_build/* DEBUG_BUILD */.X && utils_hoist_logger/* logger.log */.kg.log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
        if (client) {
          client.recordDroppedEvent('sample_rate', 'span');
        }
      }
      return;
    }
    const transactionEvent = this._convertSpanToTransaction();
    if (transactionEvent) {
      const scope = getCapturedScopesOnSpan(this).scope || (0,currentScopes/* getCurrentScope */.nZ)();
      scope.captureEvent(transactionEvent);
    }
  }

  /**
   * Finish the transaction & prepare the event to send to Sentry.
   */
  _convertSpanToTransaction() {
    // We can only convert finished spans
    if (!isFullFinishedSpan((0,spanUtils/* spanToJSON */.XU)(this))) {
      return undefined;
    }
    if (!this._name) {
      debug_build/* DEBUG_BUILD */.X && utils_hoist_logger/* logger.warn */.kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
      this._name = '<unlabeled transaction>';
    }
    const {
      scope: capturedSpanScope,
      isolationScope: capturedSpanIsolationScope
    } = getCapturedScopesOnSpan(this);
    const scope = capturedSpanScope || (0,currentScopes/* getCurrentScope */.nZ)();
    const client = scope.getClient() || (0,currentScopes/* getClient */.s3)();
    if (this._sampled !== true) {
      // At this point if `sampled !== true` we want to discard the transaction.
      debug_build/* DEBUG_BUILD */.X && utils_hoist_logger/* logger.log */.kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
      if (client) {
        client.recordDroppedEvent('sample_rate', 'transaction');
      }
      return undefined;
    }

    // The transaction span itself as well as any potential standalone spans should be filtered out
    const finishedSpans = (0,spanUtils/* getSpanDescendants */.Dp)(this).filter(span => span !== this && !isStandaloneSpan(span));
    const spans = finishedSpans.map(span => (0,spanUtils/* spanToJSON */.XU)(span)).filter(isFullFinishedSpan);
    const source = this._attributes[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj];

    // remove internal root span attributes we don't need to send.
    /* eslint-disable @typescript-eslint/no-dynamic-delete */
    delete this._attributes[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME */.xF];
    spans.forEach(span => {
      span.data && delete span.data[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME */.xF];
    });
    // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete

    const transaction = {
      contexts: {
        trace: (0,spanUtils/* spanToTransactionTraceContext */.HR)(this)
      },
      spans:
      // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
      // we do not use spans anymore after this point
      spans.length > MAX_SPAN_COUNT ? spans.sort((a, b) => a.start_timestamp - b.start_timestamp).slice(0, MAX_SPAN_COUNT) : spans,
      start_timestamp: this._startTime,
      timestamp: this._endTime,
      transaction: this._name,
      type: 'transaction',
      sdkProcessingMetadata: {
        capturedSpanScope,
        capturedSpanIsolationScope,
        ...(0,object/* dropUndefinedKeys */.Jr)({
          dynamicSamplingContext: (0,dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.jC)(this)
        })
      },
      _metrics_summary: (0,metric_summary/* getMetricSummaryJsonForSpan */.y)(this),
      ...(source && {
        transaction_info: {
          source
        }
      })
    };
    const measurements = (0,measurement/* timedEventsToMeasurements */.l)(this._events);
    const hasMeasurements = measurements && Object.keys(measurements).length;
    if (hasMeasurements) {
      debug_build/* DEBUG_BUILD */.X && utils_hoist_logger/* logger.log */.kg.log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
      transaction.measurements = measurements;
    }
    return transaction;
  }
}
function isSpanTimeInput(value) {
  return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}

// We want to filter out any incomplete SpanJSON objects
function isFullFinishedSpan(input) {
  return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}

/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */
function isStandaloneSpan(span) {
  return span instanceof SentrySpan && span.isStandaloneSpan();
}

/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */
function sendSpanEnvelope(envelope) {
  const client = (0,currentScopes/* getClient */.s3)();
  if (!client) {
    return;
  }
  const spanItems = envelope[1];
  if (!spanItems || spanItems.length === 0) {
    client.recordDroppedEvent('before_send', 'span');
    return;
  }

  // sendEnvelope should not throw
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  client.sendEnvelope(envelope);
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/spanstatus.js
var spanstatus = __webpack_require__(89898);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/tracing/trace.js



















const SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';

/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */
function startSpan(options, callback) {
  const acs = getAcs();
  if (acs.startSpan) {
    return acs.startSpan(options, callback);
  }
  const spanArguments = parseSentrySpanArguments(options);
  const {
    forceTransaction,
    parentSpan: customParentSpan
  } = options;
  return (0,currentScopes/* withScope */.$e)(options.scope, () => {
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = getActiveSpanWrapper(customParentSpan);
    return wrapper(() => {
      const scope = (0,currentScopes/* getCurrentScope */.nZ)();
      const parentSpan = getParentSpan(scope);
      const shouldSkipSpan = options.onlyIfParent && !parentSpan;
      const activeSpan = shouldSkipSpan ? new sentryNonRecordingSpan/* SentryNonRecordingSpan */.b() : createChildOrRootSpan({
        parentSpan,
        spanArguments,
        forceTransaction,
        scope
      });
      (0,spanOnScope/* _setSpanForScope */.D)(scope, activeSpan);
      return handleCallbackErrors_handleCallbackErrors(() => callback(activeSpan), () => {
        // Only update the span status if it hasn't been changed yet, and the span is not yet finished
        const {
          status
        } = (0,spanUtils/* spanToJSON */.XU)(activeSpan);
        if (activeSpan.isRecording() && (!status || status === 'ok')) {
          activeSpan.setStatus({
            code: spanstatus/* SPAN_STATUS_ERROR */.jt,
            message: 'internal_error'
          });
        }
      }, () => activeSpan.end());
    });
  });
}

/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */
function startSpanManual(options, callback) {
  const acs = getAcs();
  if (acs.startSpanManual) {
    return acs.startSpanManual(options, callback);
  }
  const spanArguments = parseSentrySpanArguments(options);
  const {
    forceTransaction,
    parentSpan: customParentSpan
  } = options;
  return withScope(options.scope, () => {
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = getActiveSpanWrapper(customParentSpan);
    return wrapper(() => {
      const scope = getCurrentScope();
      const parentSpan = getParentSpan(scope);
      const shouldSkipSpan = options.onlyIfParent && !parentSpan;
      const activeSpan = shouldSkipSpan ? new SentryNonRecordingSpan() : createChildOrRootSpan({
        parentSpan,
        spanArguments,
        forceTransaction,
        scope
      });
      _setSpanForScope(scope, activeSpan);
      function finishAndSetSpan() {
        activeSpan.end();
      }
      return handleCallbackErrors(() => callback(activeSpan, finishAndSetSpan), () => {
        // Only update the span status if it hasn't been changed yet, and the span is not yet finished
        const {
          status
        } = spanToJSON(activeSpan);
        if (activeSpan.isRecording() && (!status || status === 'ok')) {
          activeSpan.setStatus({
            code: SPAN_STATUS_ERROR,
            message: 'internal_error'
          });
        }
      });
    });
  });
}

/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */
function startInactiveSpan(options) {
  const acs = getAcs();
  if (acs.startInactiveSpan) {
    return acs.startInactiveSpan(options);
  }
  const spanArguments = parseSentrySpanArguments(options);
  const {
    forceTransaction,
    parentSpan: customParentSpan
  } = options;

  // If `options.scope` is defined, we use this as as a wrapper,
  // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
  const wrapper = options.scope ? callback => (0,currentScopes/* withScope */.$e)(options.scope, callback) : customParentSpan !== undefined ? callback => withActiveSpan(customParentSpan, callback) : callback => callback();
  return wrapper(() => {
    const scope = (0,currentScopes/* getCurrentScope */.nZ)();
    const parentSpan = getParentSpan(scope);
    const shouldSkipSpan = options.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) {
      return new sentryNonRecordingSpan/* SentryNonRecordingSpan */.b();
    }
    return createChildOrRootSpan({
      parentSpan,
      spanArguments,
      forceTransaction,
      scope
    });
  });
}

/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */
const continueTrace = (options, callback) => {
  const carrier = getMainCarrier();
  const acs = getAsyncContextStrategy(carrier);
  if (acs.continueTrace) {
    return acs.continueTrace(options, callback);
  }
  const {
    sentryTrace,
    baggage
  } = options;
  return withScope(scope => {
    const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
    scope.setPropagationContext(propagationContext);
    return callback();
  });
};

/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */
function withActiveSpan(span, callback) {
  const acs = getAcs();
  if (acs.withActiveSpan) {
    return acs.withActiveSpan(span, callback);
  }
  return (0,currentScopes/* withScope */.$e)(scope => {
    (0,spanOnScope/* _setSpanForScope */.D)(scope, span || undefined);
    return callback(scope);
  });
}

/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */
function suppressTracing(callback) {
  const acs = getAcs();
  if (acs.suppressTracing) {
    return acs.suppressTracing(callback);
  }
  return withScope(scope => {
    scope.setSDKProcessingMetadata({
      [SUPPRESS_TRACING_KEY]: true
    });
    return callback();
  });
}

/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */
function startNewTrace(callback) {
  return withScope(scope => {
    scope.setPropagationContext({
      traceId: generateTraceId()
    });
    DEBUG_BUILD && logger.info(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
    return withActiveSpan(null, callback);
  });
}
function createChildOrRootSpan({
  parentSpan,
  spanArguments,
  forceTransaction,
  scope
}) {
  if (!(0,hasTracingEnabled/* hasTracingEnabled */.z)()) {
    return new sentryNonRecordingSpan/* SentryNonRecordingSpan */.b();
  }
  const isolationScope = (0,currentScopes/* getIsolationScope */.aF)();
  let span;
  if (parentSpan && !forceTransaction) {
    span = _startChildSpan(parentSpan, scope, spanArguments);
    (0,spanUtils/* addChildSpanToSpan */.j5)(parentSpan, span);
  } else if (parentSpan) {
    // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
    const dsc = (0,dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.jC)(parentSpan);
    const {
      traceId,
      spanId: parentSpanId
    } = parentSpan.spanContext();
    const parentSampled = (0,spanUtils/* spanIsSampled */.Tt)(parentSpan);
    span = _startRootSpan({
      traceId,
      parentSpanId,
      ...spanArguments
    }, scope, parentSampled);
    (0,dynamicSamplingContext/* freezeDscOnSpan */.Lh)(span, dsc);
  } else {
    const {
      traceId,
      dsc,
      parentSpanId,
      sampled: parentSampled
    } = {
      ...isolationScope.getPropagationContext(),
      ...scope.getPropagationContext()
    };
    span = _startRootSpan({
      traceId,
      parentSpanId,
      ...spanArguments
    }, scope, parentSampled);
    if (dsc) {
      (0,dynamicSamplingContext/* freezeDscOnSpan */.Lh)(span, dsc);
    }
  }
  logSpanStart(span);
  setCapturedScopesOnSpan(span, scope, isolationScope);
  return span;
}

/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */
function parseSentrySpanArguments(options) {
  const exp = options.experimental || {};
  const initialCtx = {
    isStandalone: exp.standalone,
    ...options
  };
  if (options.startTime) {
    const ctx = {
      ...initialCtx
    };
    ctx.startTimestamp = (0,spanUtils/* spanTimeInputToSeconds */.$k)(options.startTime);
    delete ctx.startTime;
    return ctx;
  }
  return initialCtx;
}
function getAcs() {
  const carrier = (0,esm_carrier/* getMainCarrier */.c)();
  return (0,asyncContext/* getAsyncContextStrategy */.G)(carrier);
}
function _startRootSpan(spanArguments, scope, parentSampled) {
  const client = (0,currentScopes/* getClient */.s3)();
  const options = client && client.getOptions() || {};
  const {
    name = '',
    attributes
  } = spanArguments;
  const [sampled, sampleRate] = scope.getScopeData().sdkProcessingMetadata[SUPPRESS_TRACING_KEY] ? [false] : sampleSpan(options, {
    name,
    parentSampled,
    attributes,
    transactionContext: {
      name,
      parentSampled
    }
  });
  const rootSpan = new SentrySpan({
    ...spanArguments,
    attributes: {
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: 'custom',
      ...spanArguments.attributes
    },
    sampled
  });
  if (sampleRate !== undefined) {
    rootSpan.setAttribute(semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */.TE, sampleRate);
  }
  if (client) {
    client.emit('spanStart', rootSpan);
  }
  return rootSpan;
}

/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */
function _startChildSpan(parentSpan, scope, spanArguments) {
  const {
    spanId,
    traceId
  } = parentSpan.spanContext();
  const sampled = scope.getScopeData().sdkProcessingMetadata[SUPPRESS_TRACING_KEY] ? false : (0,spanUtils/* spanIsSampled */.Tt)(parentSpan);
  const childSpan = sampled ? new SentrySpan({
    ...spanArguments,
    parentSpanId: spanId,
    traceId,
    sampled
  }) : new sentryNonRecordingSpan/* SentryNonRecordingSpan */.b({
    traceId
  });
  (0,spanUtils/* addChildSpanToSpan */.j5)(parentSpan, childSpan);
  const client = (0,currentScopes/* getClient */.s3)();
  if (client) {
    client.emit('spanStart', childSpan);
    // If it has an endTimestamp, it's already ended
    if (spanArguments.endTimestamp) {
      client.emit('spanEnd', childSpan);
    }
  }
  return childSpan;
}
function getParentSpan(scope) {
  const span = (0,spanOnScope/* _getSpanForScope */.Y)(scope);
  if (!span) {
    return undefined;
  }
  const client = (0,currentScopes/* getClient */.s3)();
  const options = client ? client.getOptions() : {};
  if (options.parentSpanIsAlwaysRootSpan) {
    return (0,spanUtils/* getRootSpan */.Gx)(span);
  }
  return span;
}
function getActiveSpanWrapper(parentSpan) {
  return parentSpan !== undefined ? callback => {
    return withActiveSpan(parentSpan, callback);
  } : callback => callback();
}


/***/ }),

/***/ 40382:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EN": function() { return /* binding */ baggageHeaderToDynamicSamplingContext; },
/* harmony export */   "IQ": function() { return /* binding */ dynamicSamplingContextToSentryBaggageHeader; },
/* harmony export */   "XM": function() { return /* binding */ parseBaggageHeader; },
/* harmony export */   "lq": function() { return /* binding */ SENTRY_BAGGAGE_KEY_PREFIX; }
/* harmony export */ });
/* unused harmony exports BAGGAGE_HEADER_NAME, MAX_BAGGAGE_STRING_LENGTH, SENTRY_BAGGAGE_KEY_PREFIX_REGEX */
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38674);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92668);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3518);




/**
 * @deprecated Use a `"baggage"` string directly
 */
const BAGGAGE_HEADER_NAME = 'baggage';
const SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';
const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
const MAX_BAGGAGE_STRING_LENGTH = 8192;

/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */
function baggageHeaderToDynamicSamplingContext(
// Very liberal definition of what any incoming header might look like
baggageHeader) {
  const baggageObject = parseBaggageHeader(baggageHeader);
  if (!baggageObject) {
    return undefined;
  }

  // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
    if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
      const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
      acc[nonPrefixedKey] = value;
    }
    return acc;
  }, {});

  // Only return a dynamic sampling context object if there are keys in it.
  // A keyless object means there were no sentry values on the header, which means that there is no DSC.
  if (Object.keys(dynamicSamplingContext).length > 0) {
    return dynamicSamplingContext;
  } else {
    return undefined;
  }
}

/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */
function dynamicSamplingContextToSentryBaggageHeader(
// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
  if (!dynamicSamplingContext) {
    return undefined;
  }

  // Prefix all DSC keys with "sentry-" and put them into a new object
  const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue]) => {
    if (dscValue) {
      acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
    }
    return acc;
  }, {});
  return objectToBaggageHeader(sentryPrefixedDSC);
}

/**
 * Take a baggage header and parse it into an object.
 */
function parseBaggageHeader(baggageHeader) {
  if (!baggageHeader || !(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(baggageHeader) && !Array.isArray(baggageHeader)) {
    return undefined;
  }
  if (Array.isArray(baggageHeader)) {
    // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr) => {
      const currBaggageObject = baggageHeaderToObject(curr);
      Object.entries(currBaggageObject).forEach(([key, value]) => {
        acc[key] = value;
      });
      return acc;
    }, {});
  }
  return baggageHeaderToObject(baggageHeader);
}

/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */
function baggageHeaderToObject(baggageHeader) {
  return baggageHeader.split(',').map(baggageEntry => baggageEntry.split('=').map(keyOrValue => decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value]) => {
    if (key && value) {
      acc[key] = value;
    }
    return acc;
  }, {});
}

/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */
function objectToBaggageHeader(object) {
  if (Object.keys(object).length === 0) {
    // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
  }
  return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex) => {
    const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
    const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
    if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X && _logger_js__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
      return baggageHeader;
    } else {
      return newBaggageHeader;
    }
  }, '');
}


/***/ }),

/***/ 7948:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rt": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "iY": function() { return /* binding */ getComponentName; },
/* harmony export */   "l4": function() { return /* binding */ getLocationHref; },
/* harmony export */   "qT": function() { return /* binding */ getDomElement; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92668);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23867);


const WINDOW = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n;
const DEFAULT_MAX_STRING_LENGTH = 80;

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem, options = {}) {
  if (!elem) {
    return '<unknown>';
  }

  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = ' > ';
    const sepLength = separator.length;
    let nextStr;
    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
    const maxStringLength = !Array.isArray(options) && options.maxStringLength || DEFAULT_MAX_STRING_LENGTH;
    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds maxStringLength
      //   (ignore this limit if we are on the first iteration)
      if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) {
        break;
      }
      out.push(nextStr);
      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }
    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
  const elem = el;
  const out = [];
  if (!elem || !elem.tagName) {
    return '';
  }

  // @ts-expect-error WINDOW has HTMLElement
  if (WINDOW.HTMLElement) {
    // If using the component name annotation plugin, this value may be available on the DOM node
    if (elem instanceof HTMLElement && elem.dataset) {
      if (elem.dataset['sentryComponent']) {
        return elem.dataset['sentryComponent'];
      }
      if (elem.dataset['sentryElement']) {
        return elem.dataset['sentryElement'];
      }
    }
  }
  out.push(elem.tagName.toLowerCase());

  // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
  const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(keyAttr => elem.getAttribute(keyAttr)).map(keyAttr => [keyAttr, elem.getAttribute(keyAttr)]) : null;
  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach(keyAttrPair => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }
    const className = elem.className;
    if (className && (0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(className)) {
      const classes = className.split(/\s+/);
      for (const c of classes) {
        out.push(`.${c}`);
      }
    }
  }
  const allowedAttrs = ['aria-label', 'type', 'name', 'title', 'alt'];
  for (const k of allowedAttrs) {
    const attr = elem.getAttribute(k);
    if (attr) {
      out.push(`[${k}="${attr}"]`);
    }
  }
  return out.join('');
}

/**
 * A safe form of location.href
 */
function getLocationHref() {
  try {
    return WINDOW.document.location.href;
  } catch (oO) {
    return '';
  }
}

/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existence of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 *
 * @deprecated This method is deprecated and will be removed in the next major version.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector) {
  if (WINDOW.document && WINDOW.document.querySelector) {
    return WINDOW.document.querySelector(selector);
  }
  return null;
}

/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */
function getComponentName(elem) {
  // @ts-expect-error WINDOW has HTMLElement
  if (!WINDOW.HTMLElement) {
    return null;
  }
  let currentElem = elem;
  const MAX_TRAVERSE_HEIGHT = 5;
  for (let i = 0; i < MAX_TRAVERSE_HEIGHT; i++) {
    if (!currentElem) {
      return null;
    }
    if (currentElem instanceof HTMLElement) {
      if (currentElem.dataset['sentryComponent']) {
        return currentElem.dataset['sentryComponent'];
      }
      if (currentElem.dataset['sentryElement']) {
        return currentElem.dataset['sentryElement'];
      }
    }
    currentElem = currentElem.parentNode;
  }
  return null;
}


/***/ }),

/***/ 38674:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD =  false || false;


/***/ }),

/***/ 88157:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RA": function() { return /* binding */ dsnToString; },
/* harmony export */   "U4": function() { return /* binding */ dsnFromString; },
/* harmony export */   "vK": function() { return /* binding */ makeDsn; }
/* harmony export */ });
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38674);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3518);



/** Regular expression used to parse a Dsn. */
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsnToString(dsn, withPassword = false) {
  const {
    host,
    path,
    pass,
    port,
    projectId,
    protocol,
    publicKey
  } = dsn;
  return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */
function dsnFromString(str) {
  const match = DSN_REGEX.exec(str);
  if (!match) {
    // This should be logged to the console
    (0,_logger_js__WEBPACK_IMPORTED_MODULE_0__/* .consoleSandbox */ .Cf)(() => {
      // eslint-disable-next-line no-console
      console.error(`Invalid Sentry Dsn: ${str}`);
    });
    return undefined;
  }
  const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
  let path = '';
  let projectId = lastPath;
  const split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop();
  }
  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }
  return dsnFromComponents({
    host,
    pass,
    path,
    projectId,
    port,
    protocol: protocol,
    publicKey
  });
}
function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId
  };
}
function validateDsn(dsn) {
  if (!_debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X) {
    return true;
  }
  const {
    port,
    projectId,
    protocol
  } = dsn;
  const requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  const hasMissingRequiredComponent = requiredComponents.find(component => {
    if (!dsn[component]) {
      _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: ${component} missing`);
      return true;
    }
    return false;
  });
  if (hasMissingRequiredComponent) {
    return false;
  }
  if (!projectId.match(/^\d+$/)) {
    _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
    return false;
  }
  if (!isValidProtocol(protocol)) {
    _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
    return false;
  }
  if (port && isNaN(parseInt(port, 10))) {
    _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: Invalid port ${port}`);
    return false;
  }
  return true;
}

/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */
function makeDsn(from) {
  const components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
  if (!components || !validateDsn(components)) {
    return undefined;
  }
  return components;
}


/***/ }),

/***/ 83466:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getSDKSource; },
/* harmony export */   "n": function() { return /* binding */ isBrowserBundle; }
/* harmony export */ });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

/**
 * Get source of SDK.
 */
function getSDKSource() {
  // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
  /* __SENTRY_SDK_SOURCE__ */
  return 'npm';
}


/***/ }),

/***/ 53767:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BO": function() { return /* binding */ addItemToEnvelope; },
/* harmony export */   "Cd": function() { return /* binding */ createEventEnvelopeHeaders; },
/* harmony export */   "HY": function() { return /* binding */ getSdkMetadataForEnvelopeHeader; },
/* harmony export */   "Jd": function() { return /* binding */ createEnvelope; },
/* harmony export */   "KQ": function() { return /* binding */ createSpanEnvelopeItem; },
/* harmony export */   "V$": function() { return /* binding */ serializeEnvelope; },
/* harmony export */   "gv": function() { return /* binding */ forEachEnvelopeItem; },
/* harmony export */   "mL": function() { return /* binding */ envelopeItemTypeToDataCategory; },
/* harmony export */   "zQ": function() { return /* binding */ createAttachmentEnvelopeItem; }
/* harmony export */ });
/* unused harmony exports envelopeContainsItemType, parseEnvelope */
/* harmony import */ var _dsn_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88157);
/* harmony import */ var _normalize_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9813);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88803);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23867);





/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items = []) {
  return [headers, items];
}

/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]];
}

/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */
function forEachEnvelopeItem(envelope, callback) {
  const envelopeItems = envelope[1];
  for (const envelopeItem of envelopeItems) {
    const envelopeItemType = envelopeItem[0].type;
    const result = callback(envelopeItem, envelopeItemType);
    if (result) {
      return true;
    }
  }
  return false;
}

/**
 * Returns true if the envelope contains any of the given envelope item types
 */
function envelopeContainsItemType(envelope, types) {
  return forEachEnvelopeItem(envelope, (_, type) => types.includes(type));
}

/**
 * Encode a string to UTF8 array.
 */
function encodeUTF8(input) {
  return _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.__SENTRY__ */ .n.__SENTRY__ && _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.__SENTRY__.encodePolyfill */ .n.__SENTRY__.encodePolyfill ? _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.__SENTRY__.encodePolyfill */ .n.__SENTRY__.encodePolyfill(input) : new TextEncoder().encode(input);
}

/**
 * Decode a UTF8 array to string.
 */
function decodeUTF8(input) {
  return GLOBAL_OBJ.__SENTRY__ && GLOBAL_OBJ.__SENTRY__.decodePolyfill ? GLOBAL_OBJ.__SENTRY__.decodePolyfill(input) : new TextDecoder().decode(input);
}

/**
 * Serializes an envelope.
 */
function serializeEnvelope(envelope) {
  const [envHeaders, items] = envelope;

  // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
  let parts = JSON.stringify(envHeaders);
  function append(next) {
    if (typeof parts === 'string') {
      parts = typeof next === 'string' ? parts + next : [encodeUTF8(parts), next];
    } else {
      parts.push(typeof next === 'string' ? encodeUTF8(next) : next);
    }
  }
  for (const item of items) {
    const [itemHeaders, payload] = item;
    append(`\n${JSON.stringify(itemHeaders)}\n`);
    if (typeof payload === 'string' || payload instanceof Uint8Array) {
      append(payload);
    } else {
      let stringifiedPayload;
      try {
        stringifiedPayload = JSON.stringify(payload);
      } catch (e) {
        // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
        // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
        // performance impact but in this case a performance hit is better than throwing.
        stringifiedPayload = JSON.stringify((0,_normalize_js__WEBPACK_IMPORTED_MODULE_1__/* .normalize */ .Fv)(payload));
      }
      append(stringifiedPayload);
    }
  }
  return typeof parts === 'string' ? parts : concatBuffers(parts);
}
function concatBuffers(buffers) {
  const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);
  const merged = new Uint8Array(totalLength);
  let offset = 0;
  for (const buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }
  return merged;
}

/**
 * Parses an envelope
 */
function parseEnvelope(env) {
  let buffer = typeof env === 'string' ? encodeUTF8(env) : env;
  function readBinary(length) {
    const bin = buffer.subarray(0, length);
    // Replace the buffer with the remaining data excluding trailing newline
    buffer = buffer.subarray(length + 1);
    return bin;
  }
  function readJson() {
    let i = buffer.indexOf(0xa);
    // If we couldn't find a newline, we must have found the end of the buffer
    if (i < 0) {
      i = buffer.length;
    }
    return JSON.parse(decodeUTF8(readBinary(i)));
  }
  const envelopeHeader = readJson();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const items = [];
  while (buffer.length) {
    const itemHeader = readJson();
    const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
    items.push([itemHeader, binaryLength ? readBinary(binaryLength) : readJson()]);
  }
  return [envelopeHeader, items];
}

/**
 * Creates envelope item for a single span
 */
function createSpanEnvelopeItem(spanJson) {
  const spanHeaders = {
    type: 'span'
  };
  return [spanHeaders, spanJson];
}

/**
 * Creates attachment envelope items
 */
function createAttachmentEnvelopeItem(attachment) {
  const buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data) : attachment.data;
  return [(0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
    type: 'attachment',
    length: buffer.length,
    filename: attachment.filename,
    content_type: attachment.contentType,
    attachment_type: attachment.attachmentType
  }), buffer];
}
const ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
  session: 'session',
  sessions: 'session',
  attachment: 'attachment',
  transaction: 'transaction',
  event: 'error',
  client_report: 'internal',
  user_report: 'default',
  profile: 'profile',
  profile_chunk: 'profile',
  replay_event: 'replay',
  replay_recording: 'replay',
  check_in: 'monitor',
  feedback: 'feedback',
  span: 'span',
  statsd: 'metric_bucket',
  raw_security: 'security'
};

/**
 * Maps the type of an envelope item to a data category.
 */
function envelopeItemTypeToDataCategory(type) {
  return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}

/** Extracts the minimal SDK info from the metadata or an events */
function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
  if (!metadataOrEvent || !metadataOrEvent.sdk) {
    return;
  }
  const {
    name,
    version
  } = metadataOrEvent.sdk;
  return {
    name,
    version
  };
}

/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */
function createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn) {
  const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: event.event_id,
    sent_at: new Date().toISOString(),
    ...(sdkInfo && {
      sdk: sdkInfo
    }),
    ...(!!tunnel && dsn && {
      dsn: (0,_dsn_js__WEBPACK_IMPORTED_MODULE_3__/* .dsnToString */ .RA)(dsn)
    }),
    ...(dynamicSamplingContext && {
      trace: (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
        ...dynamicSamplingContext
      })
    })
  };
}


/***/ }),

/***/ 56241:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Uf": function() { return /* binding */ addFetchInstrumentationHandler; },
/* harmony export */   "cf": function() { return /* binding */ addFetchEndInstrumentationHandler; }
/* harmony export */ });
/* unused harmony export parseFetchArgs */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92668);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88803);
/* harmony import */ var _supports_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92049);
/* harmony import */ var _time_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27870);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23867);
/* harmony import */ var _handlers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29862);







/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
  const type = 'fetch';
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .addHandler */ .Hj)(type, handler);
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .maybeInstrument */ .D2)(type, () => instrumentFetch(undefined, skipNativeFetchCheck));
}

/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */
function addFetchEndInstrumentationHandler(handler) {
  const type = 'fetch-body-resolved';
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .addHandler */ .Hj)(type, handler);
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .maybeInstrument */ .D2)(type, () => instrumentFetch(streamHandler));
}
function instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
  if (skipNativeFetchCheck && !(0,_supports_js__WEBPACK_IMPORTED_MODULE_1__/* .supportsNativeFetch */ .t$)()) {
    return;
  }
  (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(_worldwide_js__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_OBJ */ .n, 'fetch', function (originalFetch) {
    return function (...args) {
      // We capture the error right here and not in the Promise error callback because Safari (and probably other
      // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.

      // NOTE: If you are a Sentry user, and you are seeing this stack frame,
      //       it means the error, that was caused by your fetch call did not
      //       have a stack trace, so the SDK backfilled the stack trace so
      //       you can see which fetch call failed.
      const virtualError = new Error();
      const {
        method,
        url
      } = parseFetchArgs(args);
      const handlerData = {
        args,
        fetchData: {
          method,
          url
        },
        startTimestamp: (0,_time_js__WEBPACK_IMPORTED_MODULE_4__/* .timestampInSeconds */ .ph)() * 1000,
        // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
        virtualError
      };

      // if there is no callback, fetch is instrumented directly
      if (!onFetchResolved) {
        (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)('fetch', {
          ...handlerData
        });
      }

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return originalFetch.apply(_worldwide_js__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_OBJ */ .n, args).then(async response => {
        if (onFetchResolved) {
          onFetchResolved(response);
        } else {
          (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)('fetch', {
            ...handlerData,
            endTimestamp: (0,_time_js__WEBPACK_IMPORTED_MODULE_4__/* .timestampInSeconds */ .ph)() * 1000,
            response
          });
        }
        return response;
      }, error => {
        (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)('fetch', {
          ...handlerData,
          endTimestamp: (0,_time_js__WEBPACK_IMPORTED_MODULE_4__/* .timestampInSeconds */ .ph)() * 1000,
          error
        });
        if ((0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isError */ .VZ)(error) && error.stack === undefined) {
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the error, that was caused by your fetch call did not
          //       have a stack trace, so the SDK backfilled the stack trace so
          //       you can see which fetch call failed.
          error.stack = virtualError.stack;
          (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .addNonEnumerableProperty */ .xp)(error, 'framesToPop', 1);
        }

        // NOTE: If you are a Sentry user, and you are seeing this stack frame,
        //       it means the sentry.javascript SDK caught an error invoking your application code.
        //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
        throw error;
      });
    };
  });
}
async function resolveResponse(res, onFinishedResolving) {
  if (res && res.body) {
    const body = res.body;
    const responseReader = body.getReader();

    // Define a maximum duration after which we just cancel
    const maxFetchDurationTimeout = setTimeout(() => {
      body.cancel().then(null, () => {
        // noop
      });
    }, 90 * 1000 // 90s
    );
    let readingActive = true;
    while (readingActive) {
      let chunkTimeout;
      try {
        // abort reading if read op takes more than 5s
        chunkTimeout = setTimeout(() => {
          body.cancel().then(null, () => {
            // noop on error
          });
        }, 5000);

        // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
        const {
          done
        } = await responseReader.read();
        clearTimeout(chunkTimeout);
        if (done) {
          onFinishedResolving();
          readingActive = false;
        }
      } catch (error) {
        readingActive = false;
      } finally {
        clearTimeout(chunkTimeout);
      }
    }
    clearTimeout(maxFetchDurationTimeout);
    responseReader.releaseLock();
    body.cancel().then(null, () => {
      // noop on error
    });
  }
}
function streamHandler(response) {
  // clone response for awaiting stream
  let clonedResponseForResolving;
  try {
    clonedResponseForResolving = response.clone();
  } catch (e) {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  resolveResponse(clonedResponseForResolving, () => {
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)('fetch-body-resolved', {
      endTimestamp: (0,_time_js__WEBPACK_IMPORTED_MODULE_4__/* .timestampInSeconds */ .ph)() * 1000,
      response
    });
  });
}
function hasProp(obj, prop) {
  return !!obj && typeof obj === 'object' && !!obj[prop];
}
function getUrlFromResource(resource) {
  if (typeof resource === 'string') {
    return resource;
  }
  if (!resource) {
    return '';
  }
  if (hasProp(resource, 'url')) {
    return resource.url;
  }
  if (resource.toString) {
    return resource.toString();
  }
  return '';
}

/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */
function parseFetchArgs(fetchArgs) {
  if (fetchArgs.length === 0) {
    return {
      method: 'GET',
      url: ''
    };
  }
  if (fetchArgs.length === 2) {
    const [url, options] = fetchArgs;
    return {
      url: getUrlFromResource(url),
      method: hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
    };
  }
  const arg = fetchArgs[0];
  return {
    url: getUrlFromResource(arg),
    method: hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
  };
}


/***/ }),

/***/ 33246:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ addGlobalErrorInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23867);
/* harmony import */ var _handlers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29862);


let _oldOnErrorHandler = null;

/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addGlobalErrorInstrumentationHandler(handler) {
  const type = 'error';
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .addHandler */ .Hj)(type, handler);
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .maybeInstrument */ .D2)(type, instrumentError);
}
function instrumentError() {
  _oldOnErrorHandler = _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.onerror */ .n.onerror;

  // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
  // is that we are using this handler in the Loader Script, to handle buffered errors consistently
  _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.onerror */ .n.onerror = function (msg, url, line, column, error) {
    const handlerData = {
      column,
      error,
      line,
      msg,
      url
    };
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)('error', handlerData);
    if (_oldOnErrorHandler) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnErrorHandler.apply(this, arguments);
    }
    return false;
  };
  _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ */ .n.onerror.__SENTRY_INSTRUMENTED__ = true;
}


/***/ }),

/***/ 80201:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ addGlobalUnhandledRejectionInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23867);
/* harmony import */ var _handlers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29862);


let _oldOnUnhandledRejectionHandler = null;

/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addGlobalUnhandledRejectionInstrumentationHandler(handler) {
  const type = 'unhandledrejection';
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .addHandler */ .Hj)(type, handler);
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .maybeInstrument */ .D2)(type, instrumentUnhandledRejection);
}
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.onunhandledrejection */ .n.onunhandledrejection;

  // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
  // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
  _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.onunhandledrejection */ .n.onunhandledrejection = function (e) {
    const handlerData = e;
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)('unhandledrejection', handlerData);
    if (_oldOnUnhandledRejectionHandler) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }
    return true;
  };
  _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ */ .n.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}


/***/ }),

/***/ 29862:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D2": function() { return /* binding */ maybeInstrument; },
/* harmony export */   "Hj": function() { return /* binding */ addHandler; },
/* harmony export */   "rK": function() { return /* binding */ triggerHandlers; }
/* harmony export */ });
/* unused harmony export resetInstrumentationHandlers */
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38674);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3518);
/* harmony import */ var _stacktrace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93113);




// We keep the handlers globally
const handlers = {};
const instrumented = {};

/** Add a handler function. */
function addHandler(type, handler) {
  handlers[type] = handlers[type] || [];
  handlers[type].push(handler);
}

/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */
function resetInstrumentationHandlers() {
  Object.keys(handlers).forEach(key => {
    handlers[key] = undefined;
  });
}

/** Maybe run an instrumentation function, unless it was already called. */
function maybeInstrument(type, instrumentFn) {
  if (!instrumented[type]) {
    instrumented[type] = true;
    try {
      instrumentFn();
    } catch (e) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .X && _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .kg.error(`Error while instrumenting ${type}`, e);
    }
  }
}

/** Trigger handlers for a given instrumentation type. */
function triggerHandlers(type, data) {
  const typeHandlers = type && handlers[type];
  if (!typeHandlers) {
    return;
  }
  for (const handler of typeHandlers) {
    try {
      handler(data);
    } catch (e) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .X && _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .kg.error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0,_stacktrace_js__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(handler)}\nError:`, e);
    }
  }
}


/***/ }),

/***/ 92668:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "Le": function() { return /* binding */ isParameterizedString; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; },
/* harmony export */   "y1": function() { return /* binding */ isVueViewModel; }
/* harmony export */ });
// eslint-disable-next-line @typescript-eslint/unbound-method
const objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
    case '[object WebAssembly.Exception]':
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isParameterizedString(wat) {
  return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
  return wat === null || isParameterizedString(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}

/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}

/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isVueViewModel(wat) {
  // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
  return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}


/***/ }),

/***/ 3518:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "LD": function() { return /* binding */ originalConsoleMethods; },
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38674);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23867);



/** Prefix for logging strings */
const PREFIX = 'Sentry Logger ';
const CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'];

/** This may be mutated by the console instrumentation. */
const originalConsoleMethods = {};

/** JSDoc */

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!("console" in _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n)) {
    return callback();
  }
  const console = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n.console;
  const wrappedFuncs = {};
  const wrappedLevels = Object.keys(originalConsoleMethods);

  // Restore all wrapped console methods
  wrappedLevels.forEach(level => {
    const originalConsoleMethod = originalConsoleMethods[level];
    wrappedFuncs[level] = console[level];
    console[level] = originalConsoleMethod;
  });
  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    wrappedLevels.forEach(level => {
      console[level] = wrappedFuncs[level];
    });
  }
}
function makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
    isEnabled: () => enabled
  };
  if (_debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X) {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }
  return logger;
}

/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */
const logger = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .Y)('logger', makeLogger);


/***/ }),

/***/ 27275:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; }
/* harmony export */ });
/* unused harmony exports addContextToFrame, arrayify, parseSemver */
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88803);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23867);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  const gbl = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n;
  const crypto = gbl.crypto || gbl.msCrypto;
  let getRandomByte = () => Math.random() * 16;
  try {
    if (crypto && crypto.randomUUID) {
      return crypto.randomUUID().replace(/-/g, '');
    }
    if (crypto && crypto.getRandomValues) {
      getRandomByte = () => {
        // crypto.getRandomValues might return undefined instead of the typed array
        // in old Chromium versions (e.g. 23.0.1235.0 (151422))
        // However, `typedArray` is still filled in-place.
        // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
        const typedArray = new Uint8Array(1);
        crypto.getRandomValues(typedArray);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return typedArray[0];
      };
    }
  } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
  }

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return ([1e7] + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
  // eslint-disable-next-line no-bitwise
  (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const {
    message,
    event_id: eventId
  } = event;
  if (message) {
    return message;
  }
  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  const exception = event.exception = event.exception || {};
  const values = exception.values = exception.values || [];
  const firstException = values[0] = values[0] || {};
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }
  const defaultMechanism = {
    type: 'generic',
    handled: true
  };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = {
    ...defaultMechanism,
    ...currentMechanism,
    ...newMechanism
  };
  if (newMechanism && 'data' in newMechanism) {
    const mergedData = {
      ...(currentMechanism && currentMechanism.data),
      ...newMechanism.data
    };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

function _parseInt(input) {
  return parseInt(input || '', 10);
}

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  const match = input.match(SEMVER_REGEXP) || [];
  const major = _parseInt(match[1]);
  const minor = _parseInt(match[2]);
  const patch = _parseInt(match[3]);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4]
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
  if (frame.lineno === undefined) {
    return;
  }
  const maxLines = lines.length;
  const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
  frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(line => snipLine(line, 0));

  // We guard here to ensure this is not larger than the existing number of lines
  const lineIndex = Math.min(maxLines - 1, sourceLine);

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  frame.context_line = snipLine(lines[lineIndex], frame.colno || 0);
  frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(line => snipLine(line, 0));
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
  if (isAlreadyCaptured(exception)) {
    return true;
  }
  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(exception, '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }
  return false;
}
function isAlreadyCaptured(exception) {
  try {
    return exception.__sentry_captured__;
  } catch (e) {} // eslint-disable-line no-empty
}

/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 *
 * @deprecated This function has been deprecated and will not be replaced.
 */
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}


/***/ }),

/***/ 9813:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fv": function() { return /* binding */ normalize; },
  "Qy": function() { return /* binding */ normalizeToSize; }
});

// UNUSED EXPORTS: normalizeUrlToBase

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/is.js
var is = __webpack_require__(92668);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Helper to decycle json objects
 *
 * @deprecated This function is deprecated and will be removed in the next major version.
 */
// TODO(v9): Move this function into normalize() directly
function memoBuilder() {
  const hasWeakSet = typeof WeakSet === 'function';
  const inner = hasWeakSet ? new WeakSet() : [];
  function memoize(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < inner.length; i++) {
      const value = inner[i];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }
  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i = 0; i < inner.length; i++) {
        if (inner[i] === obj) {
          inner.splice(i, 1);
          break;
        }
      }
    }
  }
  return [memoize, unmemoize];
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/object.js
var object = __webpack_require__(88803);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/stacktrace.js
var stacktrace = __webpack_require__(93113);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input, depth = 100, maxProperties = +Infinity) {
  try {
    // since we're at the outermost level, we don't provide a key
    return visit('', input, depth, maxProperties);
  } catch (err) {
    return {
      ERROR: `**non-serializable** (${err})`
    };
  }
}

/** JSDoc */
function normalizeToSize(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
object,
// Default Node.js REPL depth
depth = 3,
// 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 100 * 1024) {
  const normalized = normalize(object, depth);
  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }
  return normalized;
}

/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(key, value, depth = +Infinity, maxProperties = +Infinity,
// eslint-disable-next-line deprecation/deprecation
memo = memoBuilder()) {
  const [memoize, unmemoize] = memo;

  // Get the simple cases out of the way first
  if (value == null ||
  // this matches null and undefined -> eqeq not eqeqeq
  ['boolean', 'string'].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  const stringified = stringifyValue(key, value);

  // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
  // Everything else will have already been serialized, so if we don't see that pattern, we're done.
  if (!stringified.startsWith('[object ')) {
    return stringified;
  }

  // From here on, we can assert that `value` is either an object or an array.

  // Do not normalize objects that we know have already been normalized. As a general rule, the
  // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
  // have already been normalized.
  if (value['__sentry_skip_normalization__']) {
    return value;
  }

  // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
  // We keep a certain amount of depth.
  // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
  const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;

  // We're also done if we've reached the max depth
  if (remainingDepth === 0) {
    // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
  }

  // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
  if (memoize(value)) {
    return '[Circular ~]';
  }

  // If the value has a `toJSON` method, we call it to extract more information
  const valueWithToJSON = value;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
    try {
      const jsonValue = valueWithToJSON.toJSON();
      // We need to normalize the return value of `.toJSON()` in case it has circular references
      return visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
      // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
  }

  // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
  // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
  // property/entry, and keep track of the number of items we add to it.
  const normalized = Array.isArray(value) ? [] : {};
  let numAdded = 0;

  // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
  // properties are non-enumerable and otherwise would get missed.
  const visitable = (0,object/* convertToPlainObject */.Sh)(value);
  for (const visitKey in visitable) {
    // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }
    if (numAdded >= maxProperties) {
      normalized[visitKey] = '[MaxProperties ~]';
      break;
    }

    // Recursively visit all the child nodes
    const visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
    numAdded++;
  }

  // Once we've visited all the branches, remove the parent from memo storage
  unmemoize(value);

  // Return accumulated values
  return normalized;
}

/* eslint-disable complexity */
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(key,
// this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
  try {
    if (key === 'domain' && value && typeof value === 'object' && value._events) {
      return '[Domain]';
    }
    if (key === 'domainEmitter') {
      return '[DomainEmitter]';
    }

    // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.

    if (typeof global !== 'undefined' && value === global) {
      return '[Global]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof window !== 'undefined' && value === window) {
      return '[Window]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof document !== 'undefined' && value === document) {
      return '[Document]';
    }
    if ((0,is/* isVueViewModel */.y1)(value)) {
      return '[VueViewModel]';
    }

    // React's SyntheticEvent thingy
    if ((0,is/* isSyntheticEvent */.Cy)(value)) {
      return '[SyntheticEvent]';
    }
    if (typeof value === 'number' && !Number.isFinite(value)) {
      return `[${value}]`;
    }
    if (typeof value === 'function') {
      return `[Function: ${(0,stacktrace/* getFunctionName */.$P)(value)}]`;
    }
    if (typeof value === 'symbol') {
      return `[${String(value)}]`;
    }

    // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
    if (typeof value === 'bigint') {
      return `[BigInt: ${String(value)}]`;
    }

    // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
    // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
    // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
    // we can make sure that only plain objects come out that way.
    const objName = getConstructorName(value);

    // Handle HTML Elements
    if (/^HTML(\w*)Element$/.test(objName)) {
      return `[HTMLElement: ${objName}]`;
    }
    return `[object ${objName}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}
/* eslint-enable complexity */

function getConstructorName(value) {
  const prototype = Object.getPrototypeOf(value);
  return prototype ? prototype.constructor.name : 'null prototype';
}

/** Calculates bytes size of input string */
function utf8Length(value) {
  // eslint-disable-next-line no-bitwise
  return ~-encodeURI(value).split(/%..|./).length;
}

/** Calculates bytes size of input object */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}

/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */
function normalizeUrlToBase(url, basePath) {
  const escapedBase = basePath
  // Backslash to forward
  .replace(/\\/g, '/')
  // Escape RegExp special characters
  .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
  let newUrl = url;
  try {
    newUrl = decodeURI(url);
  } catch (_Oo) {
    // Sometime this breaks
  }
  return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
  // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
  .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}


/***/ }),

/***/ 88803:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; }
/* harmony export */ });
/* unused harmony exports objectify, urlEncode */
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7948);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38674);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92668);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3518);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24909);






/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }
  const original = source[name];
  const wrapped = replacementFactory(original);

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    markFunctionWrapped(wrapped, original);
  }
  try {
    source[name] = wrapped;
  } catch (e) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .X && _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.log */ .kg.log(`Failed to replace method "${name}" in object`, source);
  }
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
  try {
    Object.defineProperty(obj, name, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: value,
      writable: true,
      configurable: true
    });
  } catch (o_O) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .X && _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.log */ .kg.log(`Failed to add non-enumerable property "${name}" to object`, obj);
  }
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  try {
    const proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, '__sentry_original__', original);
  } catch (o_O) {} // eslint-disable-line no-empty
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 *
 * @deprecated This function is deprecated and will be removed in the next major version of the SDK.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function urlEncode(object) {
  return Object.entries(object).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(value) {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isError */ .VZ)(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value)
    };
  } else if ((0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isEvent */ .cO)(value)) {
    const newObj = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value)
    };
    if (typeof CustomEvent !== 'undefined' && (0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
      newObj.detail = value.detail;
    }
    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return (0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isElement */ .kK)(target) ? (0,_browser_js__WEBPACK_IMPORTED_MODULE_3__/* .htmlTreeAsString */ .Rt)(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = obj[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();
  const firstKey = keys[0];
  if (!firstKey) {
    return '[object has no keys]';
  }
  if (firstKey.length >= maxLength) {
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_4__/* .truncate */ .$G)(firstKey, maxLength);
  }
  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_4__/* .truncate */ .$G)(serialized, maxLength);
  }
  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  const memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}
function _dropUndefinedKeys(inputValue, memoizationMap) {
  if (isPojo(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal;
    }
    const returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);
    for (const key of Object.getOwnPropertyNames(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }
    return returnValue;
  }
  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal;
    }
    const returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);
    inputValue.forEach(item => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });
    return returnValue;
  }
  return inputValue;
}
function isPojo(input) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isPlainObject */ .PO)(input)) {
    return false;
  }
  try {
    const name = Object.getPrototypeOf(input).constructor.name;
    return !name || name === 'Object';
  } catch (e2) {
    return true;
  }
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    // this will catch both undefined and null
    case wat == undefined:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      objectified = new wat.constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


/***/ }),

/***/ 28389:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ht": function() { return /* binding */ generateTraceId; },
/* harmony export */   "M": function() { return /* binding */ generateSpanId; }
/* harmony export */ });
/* unused harmony export generatePropagationContext */
/* harmony import */ var _misc_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27275);


/**
 * Returns a new minimal propagation context.
 *
 * @deprecated Use `generateTraceId` and `generateSpanId` instead.
 */
function generatePropagationContext() {
  return {
    traceId: generateTraceId(),
    spanId: generateSpanId()
  };
}

/**
 * Generate a random, valid trace ID.
 */
function generateTraceId() {
  return (0,_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)();
}

/**
 * Generate a random, valid span ID.
 */
function generateSpanId() {
  return (0,_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)().substring(16);
}


/***/ }),

/***/ 25528:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ isRateLimited; },
/* harmony export */   "WG": function() { return /* binding */ updateRateLimits; }
/* harmony export */ });
/* unused harmony exports DEFAULT_RETRY_AFTER, disabledUntil, parseRetryAfterHeader */
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

const DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds

/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now = Date.now()) {
  const headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1000;
  }
  const headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }
  return DEFAULT_RETRY_AFTER;
}

/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */
function disabledUntil(limits, dataCategory) {
  return limits[dataCategory] || limits.all || 0;
}

/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, dataCategory, now = Date.now()) {
  return disabledUntil(limits, dataCategory) > now;
}

/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */
function updateRateLimits(limits, {
  statusCode,
  headers
}, now = Date.now()) {
  const updatedRateLimits = {
    ...limits
  };

  // "The name is case-insensitive."
  // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
  const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
  const retryAfterHeader = headers && headers['retry-after'];
  if (rateLimitHeader) {
    /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */
    for (const limit of rateLimitHeader.trim().split(',')) {
      const [retryAfter, categories,,, namespaces] = limit.split(':', 5);
      const headerDelay = parseInt(retryAfter, 10);
      const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (const category of categories.split(';')) {
          if (category === 'metric_bucket') {
            // namespaces will be present when category === 'metric_bucket'
            if (!namespaces || namespaces.split(';').includes('custom')) {
              updatedRateLimits[category] = now + delay;
            }
          } else {
            updatedRateLimits[category] = now + delay;
          }
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1000;
  }
  return updatedRateLimits;
}


/***/ }),

/***/ 60083:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ severityLevelFromString; }
/* harmony export */ });
/* unused harmony export validSeverityLevels */
/**
 * @deprecated This variable has been deprecated and will be removed in the next major version.
 */
const validSeverityLevels = (/* unused pure expression or super */ null && (['fatal', 'error', 'warning', 'log', 'info', 'debug']));

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */
function severityLevelFromString(level) {
  return level === 'warn' ? 'warning' : ['fatal', 'error', 'warning', 'log', 'info', 'debug'].includes(level) ? level : 'log';
}


/***/ }),

/***/ 93113:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "Fi": function() { return /* binding */ UNKNOWN_FUNCTION; },
/* harmony export */   "Fr": function() { return /* binding */ getFramesFromEvent; },
/* harmony export */   "Sq": function() { return /* binding */ stackParserFromStackParserOptions; },
/* harmony export */   "pE": function() { return /* binding */ createStackParser; }
/* harmony export */ });
/* unused harmony export stripSentryFramesAndReverse */
const STACKTRACE_FRAME_LIMIT = 50;
const UNKNOWN_FUNCTION = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const STRIP_FRAME_REGEXP = /captureMessage|captureException/;

/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser(...parsers) {
  const sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map(p => p[1]);
  return (stack, skipFirstLines = 0, framesToPop = 0) => {
    const frames = [];
    const lines = stack.split('\n');
    for (let i = skipFirstLines; i < lines.length; i++) {
      const line = lines[i];
      // Ignore lines over 1kb as they are unlikely to be stack frames.
      // Many of the regular expressions use backtracking which results in run time that increases exponentially with
      // input size. Huge strings can result in hangs/Denial of Service:
      // https://github.com/getsentry/sentry-javascript/issues/2286
      if (line.length > 1024) {
        continue;
      }

      // https://github.com/getsentry/sentry-javascript/issues/5459
      // Remove webpack (error: *) wrappers
      const cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, '$1') : line;

      // https://github.com/getsentry/sentry-javascript/issues/7813
      // Skip Error: lines
      if (cleanedLine.match(/\S*Error: /)) {
        continue;
      }
      for (const parser of sortedParsers) {
        const frame = parser(cleanedLine);
        if (frame) {
          frames.push(frame);
          break;
        }
      }
      if (frames.length >= STACKTRACE_FRAME_LIMIT + framesToPop) {
        break;
      }
    }
    return stripSentryFramesAndReverse(frames.slice(framesToPop));
  };
}

/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}

/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }
  const localStack = Array.from(stack);

  // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
  if (/sentryWrapped/.test(getLastStackFrame(localStack).function || '')) {
    localStack.pop();
  }

  // Reversing in the middle of the procedure allows us to just pop the values off the stack
  localStack.reverse();

  // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
  if (STRIP_FRAME_REGEXP.test(getLastStackFrame(localStack).function || '')) {
    localStack.pop();

    // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
    // is produced within the hub itself, making it:
    //
    //   Sentry.captureException()
    //   getCurrentHub().captureException()
    //
    // instead of just the top `Sentry` call itself.
    // This forces us to possibly strip an additional frame in the exact same was as above.
    if (STRIP_FRAME_REGEXP.test(getLastStackFrame(localStack).function || '')) {
      localStack.pop();
    }
  }
  return localStack.slice(0, STACKTRACE_FRAME_LIMIT).map(frame => ({
    ...frame,
    filename: frame.filename || getLastStackFrame(localStack).filename,
    function: frame.function || UNKNOWN_FUNCTION
  }));
}
function getLastStackFrame(arr) {
  return arr[arr.length - 1] || {};
}
const defaultFunctionName = '<anonymous>';

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */
function getFramesFromEvent(event) {
  const exception = event.exception;
  if (exception) {
    const frames = [];
    try {
      // @ts-expect-error Object could be undefined
      exception.values.forEach(value => {
        // @ts-expect-error Value could be undefined
        if (value.stacktrace.frames) {
          // @ts-expect-error Value could be undefined
          frames.push(...value.stacktrace.frames);
        }
      });
      return frames;
    } catch (_oO) {
      return undefined;
    }
  }
  return undefined;
}


/***/ }),

/***/ 24909:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "U0": function() { return /* binding */ stringMatchesSomePattern; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; }
/* harmony export */ });
/* unused harmony exports isMatchingPattern, snipLine */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92668);


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max = 0) {
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.slice(0, max)}...`;
}

/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
  let newLine = line;
  const lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
    // eslint-disable-next-line no-param-reassign
    colno = lineLength;
  }
  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }
  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }
  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += ' {snip}';
  }
  return newLine;
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }
  const output = [];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < input.length; i++) {
    const value = input[i];
    try {
      // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
      // console warnings. This happens when a Vue template is rendered with
      // an undeclared variable, which we try to stringify, ultimately causing
      // Vue to issue another warning which repeats indefinitely.
      // see: https://github.com/getsentry/sentry-javascript/pull/8981
      if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isVueViewModel */ .y1)(value)) {
        output.push('[VueViewModel]');
      } else {
        output.push(String(value));
      }
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }
  return output.join(delimiter);
}

/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */
function isMatchingPattern(value, pattern, requireExactStringMatch = false) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
    return false;
  }
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
    return pattern.test(value);
  }
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(pattern)) {
    return requireExactStringMatch ? value === pattern : value.includes(pattern);
  }
  return false;
}

/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */
function stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
  return patterns.some(pattern => isMatchingPattern(testString, pattern, requireExactStringMatch));
}


/***/ }),

/***/ 92049:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": function() { return /* binding */ supportsFetch; },
/* harmony export */   "QC": function() { return /* binding */ isNativeFunction; },
/* harmony export */   "t$": function() { return /* binding */ supportsNativeFetch; }
/* harmony export */ });
/* unused harmony exports supportsDOMError, supportsDOMException, supportsErrorEvent, supportsReferrerPolicy, supportsReportingObserver */
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38674);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3518);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23867);



const WINDOW = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n;

/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
  try {
    new ErrorEvent('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
  try {
    // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
    // 1 argument required, but only 0 present.
    // @ts-expect-error It really needs 1 argument, not 0.
    new DOMError('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
  try {
    new DOMException('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
  if (!('fetch' in WINDOW)) {
    return false;
  }
  try {
    new Headers();
    new Request('http://www.example.com');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * isNative checks if the given function is a native implementation
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFunction(func) {
  return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}

/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
  if (typeof EdgeRuntime === 'string') {
    return true;
  }
  if (!supportsFetch()) {
    return false;
  }

  // Fast path to avoid DOM I/O
  // eslint-disable-next-line @typescript-eslint/unbound-method
  if (isNativeFunction(WINDOW.fetch)) {
    return true;
  }

  // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch
  let result = false;
  const doc = WINDOW.document;
  // eslint-disable-next-line deprecation/deprecation
  if (doc && typeof doc.createElement === 'function') {
    try {
      const sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFunction(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X && _logger_js__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }
  return result;
}

/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
  return 'ReportingObserver' in WINDOW;
}

/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
  // (see https://caniuse.com/#feat=referrer-policy),
  // it doesn't. And it throws an exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233

  if (!supportsFetch()) {
    return false;
  }
  try {
    new Request('_', {
      referrerPolicy: 'origin'
    });
    return true;
  } catch (e) {
    return false;
  }
}


/***/ }),

/***/ 37865:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92668);


/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */

/** SyncPromise internal states */
var States;
(function (States) {
  /** Pending */
  const PENDING = 0;
  States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  const RESOLVED = 1;
  States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  const REJECTED = 2;
  States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {
  constructor(executor) {
    SyncPromise.prototype.__init.call(this);
    SyncPromise.prototype.__init2.call(this);
    SyncPromise.prototype.__init3.call(this);
    SyncPromise.prototype.__init4.call(this);
    this._state = States.PENDING;
    this._handlers = [];
    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
  then(onfulfilled, onrejected) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([false, result => {
        if (!onfulfilled) {
          // TODO: ¯\_(ツ)_/¯
          // TODO: FIXME
          resolve(result);
        } else {
          try {
            resolve(onfulfilled(result));
          } catch (e) {
            reject(e);
          }
        }
      }, reason => {
        if (!onrejected) {
          reject(reason);
        } else {
          try {
            resolve(onrejected(reason));
          } catch (e) {
            reject(e);
          }
        }
      }]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
  catch(onrejected) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
  finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;
      return this.then(value => {
        isRejected = false;
        val = value;
        if (onfinally) {
          onfinally();
        }
      }, reason => {
        isRejected = true;
        val = reason;
        if (onfinally) {
          onfinally();
        }
      }).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }
        resolve(val);
      });
    });
  }

  /** JSDoc */
  __init() {
    this._resolve = value => {
      this._setResult(States.RESOLVED, value);
    };
  }

  /** JSDoc */
  __init2() {
    this._reject = reason => {
      this._setResult(States.REJECTED, reason);
    };
  }

  /** JSDoc */
  __init3() {
    this._setResult = (state, value) => {
      if (this._state !== States.PENDING) {
        return;
      }
      if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
        void value.then(this._resolve, this._reject);
        return;
      }
      this._state = state;
      this._value = value;
      this._executeHandlers();
    };
  }

  /** JSDoc */
  __init4() {
    this._executeHandlers = () => {
      if (this._state === States.PENDING) {
        return;
      }
      const cachedHandlers = this._handlers.slice();
      this._handlers = [];
      cachedHandlers.forEach(handler => {
        if (handler[0]) {
          return;
        }
        if (this._state === States.RESOLVED) {
          handler[1](this._value);
        }
        if (this._state === States.REJECTED) {
          handler[2](this._value);
        }
        handler[0] = true;
      });
    };
  }
}


/***/ }),

/***/ 27870:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony export _browserPerformanceTimeOriginMode */
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23867);

const ONE_SECOND_IN_MS = 1000;

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */
function dateTimestampInSeconds() {
  return Date.now() / ONE_SECOND_IN_MS;
}

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function createUnixTimestampInSecondsFunc() {
  const {
    performance
  } = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n;
  if (!performance || !performance.now) {
    return dateTimestampInSeconds;
  }

  // Some browser and environments don't have a timeOrigin, so we fallback to
  // using Date.now() to compute the starting time.
  const approxStartingTimeOrigin = Date.now() - performance.now();
  const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;

  // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
  // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
  //
  // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
  // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
  // correct for this.
  // See: https://github.com/getsentry/sentry-javascript/issues/2590
  // See: https://github.com/mdn/content/issues/4713
  // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
  return () => {
    return (timeOrigin + performance.now()) / ONE_SECOND_IN_MS;
  };
}

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
const timestampInSeconds = createUnixTimestampInSecondsFunc();

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 *
 * @deprecated This variable will be removed in the next major version.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
const browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const {
    performance
  } = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n;
  if (!performance || !performance.now) {
    // eslint-disable-next-line deprecation/deprecation
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }
  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;
  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      // eslint-disable-next-line deprecation/deprecation
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      // eslint-disable-next-line deprecation/deprecation
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  // eslint-disable-next-line deprecation/deprecation
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


/***/ }),

/***/ 87763:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$p": function() { return /* binding */ generateSentryTraceHeader; },
/* harmony export */   "Ke": function() { return /* binding */ TRACEPARENT_REGEXP; },
/* harmony export */   "pT": function() { return /* binding */ propagationContextFromHeaders; }
/* harmony export */ });
/* unused harmony export extractTraceparentData */
/* harmony import */ var _baggage_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40382);
/* harmony import */ var _propagationContext_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28389);



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const TRACEPARENT_REGEXP = new RegExp('^[ \\t]*' +
// whitespace
'([0-9a-f]{32})?' +
// trace_id
'-?([0-9a-f]{16})?' +
// span_id
'-?([01])?' +
// sampled
'[ \\t]*$') // whitespace
;

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
  if (!traceparent) {
    return undefined;
  }
  const matches = traceparent.match(TRACEPARENT_REGEXP);
  if (!matches) {
    return undefined;
  }
  let parentSampled;
  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }
  return {
    traceId: matches[1],
    parentSampled,
    parentSpanId: matches[2]
  };
}

/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */
function propagationContextFromHeaders(sentryTrace, baggage) {
  const traceparentData = extractTraceparentData(sentryTrace);
  const dynamicSamplingContext = (0,_baggage_js__WEBPACK_IMPORTED_MODULE_0__/* .baggageHeaderToDynamicSamplingContext */ .EN)(baggage);
  if (!traceparentData || !traceparentData.traceId) {
    return {
      traceId: (0,_propagationContext_js__WEBPACK_IMPORTED_MODULE_1__/* .generateTraceId */ .Ht)(),
      spanId: (0,_propagationContext_js__WEBPACK_IMPORTED_MODULE_1__/* .generateSpanId */ .M)()
    };
  }
  const {
    traceId,
    parentSpanId,
    parentSampled
  } = traceparentData;
  const virtualSpanId = (0,_propagationContext_js__WEBPACK_IMPORTED_MODULE_1__/* .generateSpanId */ .M)();
  return {
    traceId,
    parentSpanId,
    spanId: virtualSpanId,
    sampled: parentSampled,
    dsc: dynamicSamplingContext || {} // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
  };
}

/**
 * Create sentry-trace header from span context values.
 */
function generateSentryTraceHeader(traceId = (0,_propagationContext_js__WEBPACK_IMPORTED_MODULE_1__/* .generateTraceId */ .Ht)(), spanId = (0,_propagationContext_js__WEBPACK_IMPORTED_MODULE_1__/* .generateSpanId */ .M)(), sampled) {
  let sampledString = '';
  if (sampled !== undefined) {
    sampledString = sampled ? '-1' : '-0';
  }
  return `${traceId}-${spanId}${sampledString}`;
}


/***/ }),

/***/ 95619:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "en": function() { return /* binding */ parseUrl; },
/* harmony export */   "rt": function() { return /* binding */ stripUrlQueryAndFragment; }
/* harmony export */ });
/* unused harmony exports getNumberOfUrlSegments, getSanitizedUrlString */
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
  if (!url) {
    return {};
  }
  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  const query = match[6] || '';
  const fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    search: query,
    hash: fragment,
    relative: match[5] + query + fragment // everything minus origin
  };
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
  return urlPath.split(/[?#]/, 1)[0];
}

/**
 * Returns number of URL segments of a passed string URL.
 *
 * @deprecated This function will be removed in the next major version.
 */
// TODO(v9): Hoist this function into the places where we use it. (as it stands only react router v6 instrumentation)
function getNumberOfUrlSegments(url) {
  // split at '/' or at '\/' to split regex urls correctly
  return url.split(/\\?\//).filter(s => s.length > 0 && s !== ',').length;
}

/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */
function getSanitizedUrlString(url) {
  const {
    protocol,
    host,
    path
  } = url;
  const filteredHost = host && host
  // Always filter out authority
  .replace(/^.*@/, '[filtered]:[filtered]@')
  // Don't show standard :80 (http) and :443 (https) ports to reduce the noise
  // TODO: Use new URL global if it exists
  .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
  return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}


/***/ }),

/***/ 58077:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SDK_VERSION; }
/* harmony export */ });
// This is a magic string replaced by rollup

const SDK_VERSION = "8.55.0";


/***/ }),

/***/ 23867:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/* harmony import */ var _version_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58077);


/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ = globalThis;

/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  const gbl = obj || GLOBAL_OBJ;
  const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
  const versionedCarrier = __SENTRY__[_version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .J] = __SENTRY__[_version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .J] || {};
  return versionedCarrier[name] || (versionedCarrier[name] = creator());
}


/***/ }),

/***/ 68807:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ hasTracingEnabled; }
/* harmony export */ });
/* harmony import */ var _currentScopes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97308);


// Treeshakable guard to remove all code related to tracing

/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(maybeOptions) {
  if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) {
    return false;
  }
  const client = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .s3)();
  const options = maybeOptions || client && client.getOptions();
  // eslint-disable-next-line deprecation/deprecation
  return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}


/***/ }),

/***/ 57104:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ merge; }
/* harmony export */ });
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */
function merge(initialObj, mergeObj, levels = 2) {
  // If the merge value is not an object, or we have no merge levels left,
  // we just set the value to the merge value
  if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) {
    return mergeObj;
  }

  // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
  if (initialObj && mergeObj && Object.keys(mergeObj).length === 0) {
    return initialObj;
  }

  // Clone object
  const output = {
    ...initialObj
  };

  // Merge values into output, resursively
  for (const key in mergeObj) {
    if (Object.prototype.hasOwnProperty.call(mergeObj, key)) {
      output[key] = merge(output[key], mergeObj[key], levels - 1);
    }
  }
  return output;
}


/***/ }),

/***/ 86380:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ parseSampleRate; }
/* harmony export */ });
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27344);
/* harmony import */ var _utils_hoist_logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3518);



/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */
function parseSampleRate(sampleRate) {
  if (typeof sampleRate === 'boolean') {
    return Number(sampleRate);
  }
  const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
  if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .X && _utils_hoist_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
    return undefined;
  }
  return rate;
}


/***/ }),

/***/ 24737:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U0": function() { return /* binding */ parseEventHintOrCaptureContext; },
  "R": function() { return /* binding */ prepareEvent; }
});

// UNUSED EXPORTS: applyClientOptions, applyDebugIds, applyDebugMeta

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/constants.js
var constants = __webpack_require__(95931);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/currentScopes.js
var currentScopes = __webpack_require__(97308);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/debug-build.js
var debug_build = __webpack_require__(27344);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/is.js
var is = __webpack_require__(92668);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/logger.js
var logger = __webpack_require__(3518);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/syncpromise.js
var syncpromise = __webpack_require__(37865);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/eventProcessors.js





/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */
function notifyEventProcessors(processors, event, hint, index = 0) {
  return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
    const processor = processors[index];
    if (event === null || typeof processor !== 'function') {
      resolve(event);
    } else {
      const result = processor({
        ...event
      }, hint);
      debug_build/* DEBUG_BUILD */.X && processor.id && result === null && logger/* logger.log */.kg.log(`Event processor "${processor.id}" dropped event`);
      if ((0,is/* isThenable */.J8)(result)) {
        void result.then(final => notifyEventProcessors(processors, final, hint, index + 1).then(resolve)).then(null, reject);
      } else {
        void notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
      }
    }
  });
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/scope.js
var esm_scope = __webpack_require__(4443);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/worldwide.js
var worldwide = __webpack_require__(23867);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/debug-ids.js

let parsedStackResults;
let lastKeysCount;
let cachedFilenameDebugIds;

/**
 * Returns a map of filenames to debug identifiers.
 */
function getFilenameToDebugIdMap(stackParser) {
  const debugIdMap = worldwide/* GLOBAL_OBJ._sentryDebugIds */.n._sentryDebugIds;
  if (!debugIdMap) {
    return {};
  }
  const debugIdKeys = Object.keys(debugIdMap);

  // If the count of registered globals hasn't changed since the last call, we
  // can just return the cached result.
  if (cachedFilenameDebugIds && debugIdKeys.length === lastKeysCount) {
    return cachedFilenameDebugIds;
  }
  lastKeysCount = debugIdKeys.length;

  // Build a map of filename -> debug_id.
  cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey) => {
    if (!parsedStackResults) {
      parsedStackResults = {};
    }
    const result = parsedStackResults[stackKey];
    if (result) {
      acc[result[0]] = result[1];
    } else {
      const parsedStack = stackParser(stackKey);
      for (let i = parsedStack.length - 1; i >= 0; i--) {
        const stackFrame = parsedStack[i];
        const filename = stackFrame && stackFrame.filename;
        const debugId = debugIdMap[stackKey];
        if (filename && debugId) {
          acc[filename] = debugId;
          parsedStackResults[stackKey] = [filename, debugId];
          break;
        }
      }
    }
    return acc;
  }, {});
  return cachedFilenameDebugIds;
}

/**
 * Returns a list of debug images for the given resources.
 */
function getDebugImagesForResources(stackParser, resource_paths) {
  const filenameDebugIdMap = getFilenameToDebugIdMap(stackParser);
  if (!filenameDebugIdMap) {
    return [];
  }
  const images = [];
  for (const path of resource_paths) {
    if (path && filenameDebugIdMap[path]) {
      images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
      });
    }
  }
  return images;
}

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/misc.js
var misc = __webpack_require__(27275);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/normalize.js + 1 modules
var normalize = __webpack_require__(9813);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/string.js
var string = __webpack_require__(24909);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/time.js
var time = __webpack_require__(27870);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/dynamicSamplingContext.js
var dynamicSamplingContext = __webpack_require__(51789);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils-hoist/object.js
var object = __webpack_require__(88803);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/merge.js
var merge = __webpack_require__(57104);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(43384);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils/applyScopeDataToEvent.js





/**
 * Applies data from the scope to the event and runs all event processors on it.
 */
function applyScopeDataToEvent(event, data) {
  const {
    fingerprint,
    span,
    breadcrumbs,
    sdkProcessingMetadata
  } = data;

  // Apply general data
  applyDataToEvent(event, data);

  // We want to set the trace context for normal events only if there isn't already
  // a trace context on the event. There is a product feature in place where we link
  // errors with transaction and it relies on that.
  if (span) {
    applySpanToEvent(event, span);
  }
  applyFingerprintToEvent(event, fingerprint);
  applyBreadcrumbsToEvent(event, breadcrumbs);
  applySdkMetadataToEvent(event, sdkProcessingMetadata);
}

/** Merge data of two scopes together. */
function mergeScopeData(data, mergeData) {
  const {
    extra,
    tags,
    user,
    contexts,
    level,
    sdkProcessingMetadata,
    breadcrumbs,
    fingerprint,
    eventProcessors,
    attachments,
    propagationContext,
    transactionName,
    span
  } = mergeData;
  mergeAndOverwriteScopeData(data, 'extra', extra);
  mergeAndOverwriteScopeData(data, 'tags', tags);
  mergeAndOverwriteScopeData(data, 'user', user);
  mergeAndOverwriteScopeData(data, 'contexts', contexts);
  data.sdkProcessingMetadata = (0,merge/* merge */.T)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
  if (level) {
    data.level = level;
  }
  if (transactionName) {
    data.transactionName = transactionName;
  }
  if (span) {
    data.span = span;
  }
  if (breadcrumbs.length) {
    data.breadcrumbs = [...data.breadcrumbs, ...breadcrumbs];
  }
  if (fingerprint.length) {
    data.fingerprint = [...data.fingerprint, ...fingerprint];
  }
  if (eventProcessors.length) {
    data.eventProcessors = [...data.eventProcessors, ...eventProcessors];
  }
  if (attachments.length) {
    data.attachments = [...data.attachments, ...attachments];
  }
  data.propagationContext = {
    ...data.propagationContext,
    ...propagationContext
  };
}

/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */
function mergeAndOverwriteScopeData(data, prop, mergeVal) {
  data[prop] = (0,merge/* merge */.T)(data[prop], mergeVal, 1);
}
function applyDataToEvent(event, data) {
  const {
    extra,
    tags,
    user,
    contexts,
    level,
    transactionName
  } = data;
  const cleanedExtra = (0,object/* dropUndefinedKeys */.Jr)(extra);
  if (cleanedExtra && Object.keys(cleanedExtra).length) {
    event.extra = {
      ...cleanedExtra,
      ...event.extra
    };
  }
  const cleanedTags = (0,object/* dropUndefinedKeys */.Jr)(tags);
  if (cleanedTags && Object.keys(cleanedTags).length) {
    event.tags = {
      ...cleanedTags,
      ...event.tags
    };
  }
  const cleanedUser = (0,object/* dropUndefinedKeys */.Jr)(user);
  if (cleanedUser && Object.keys(cleanedUser).length) {
    event.user = {
      ...cleanedUser,
      ...event.user
    };
  }
  const cleanedContexts = (0,object/* dropUndefinedKeys */.Jr)(contexts);
  if (cleanedContexts && Object.keys(cleanedContexts).length) {
    event.contexts = {
      ...cleanedContexts,
      ...event.contexts
    };
  }
  if (level) {
    event.level = level;
  }

  // transaction events get their `transaction` from the root span name
  if (transactionName && event.type !== 'transaction') {
    event.transaction = transactionName;
  }
}
function applyBreadcrumbsToEvent(event, breadcrumbs) {
  const mergedBreadcrumbs = [...(event.breadcrumbs || []), ...breadcrumbs];
  event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function applySdkMetadataToEvent(event, sdkProcessingMetadata) {
  event.sdkProcessingMetadata = {
    ...event.sdkProcessingMetadata,
    ...sdkProcessingMetadata
  };
}
function applySpanToEvent(event, span) {
  event.contexts = {
    trace: (0,spanUtils/* spanToTraceContext */.wy)(span),
    ...event.contexts
  };
  event.sdkProcessingMetadata = {
    dynamicSamplingContext: (0,dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.jC)(span),
    ...event.sdkProcessingMetadata
  };
  const rootSpan = (0,spanUtils/* getRootSpan */.Gx)(span);
  const transactionName = (0,spanUtils/* spanToJSON */.XU)(rootSpan).description;
  if (transactionName && !event.transaction && event.type === 'transaction') {
    event.transaction = transactionName;
  }
}

/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */
function applyFingerprintToEvent(event, fingerprint) {
  // Make sure it's an array first and we actually have something in place
  event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [event.fingerprint] : [];

  // If we have something on the scope, then merge it with event
  if (fingerprint) {
    event.fingerprint = event.fingerprint.concat(fingerprint);
  }

  // If we have no data at all, remove empty array default
  if (event.fingerprint && !event.fingerprint.length) {
    delete event.fingerprint;
  }
}

;// CONCATENATED MODULE: ./node_modules/@sentry/core/build/esm/utils/prepareEvent.js











/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */

/**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */
function prepareEvent(options, event, hint, scope, client, isolationScope) {
  const {
    normalizeDepth = 3,
    normalizeMaxBreadth = 1000
  } = options;
  const prepared = {
    ...event,
    event_id: event.event_id || hint.event_id || (0,misc/* uuid4 */.DM)(),
    timestamp: event.timestamp || (0,time/* dateTimestampInSeconds */.yW)()
  };
  const integrations = hint.integrations || options.integrations.map(i => i.name);
  applyClientOptions(prepared, options);
  applyIntegrationsMetadata(prepared, integrations);
  if (client) {
    client.emit('applyFrameMetadata', event);
  }

  // Only put debug IDs onto frames for error events.
  if (event.type === undefined) {
    applyDebugIds(prepared, options.stackParser);
  }

  // If we have scope given to us, use it as the base for further modifications.
  // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
  const finalScope = getFinalScope(scope, hint.captureContext);
  if (hint.mechanism) {
    (0,misc/* addExceptionMechanism */.EG)(prepared, hint.mechanism);
  }
  const clientEventProcessors = client ? client.getEventProcessors() : [];

  // This should be the last thing called, since we want that
  // {@link Scope.addEventProcessor} gets the finished prepared event.
  // Merge scope data together
  const data = (0,currentScopes/* getGlobalScope */.lW)().getScopeData();
  if (isolationScope) {
    const isolationData = isolationScope.getScopeData();
    mergeScopeData(data, isolationData);
  }
  if (finalScope) {
    const finalScopeData = finalScope.getScopeData();
    mergeScopeData(data, finalScopeData);
  }
  const attachments = [...(hint.attachments || []), ...data.attachments];
  if (attachments.length) {
    hint.attachments = attachments;
  }
  applyScopeDataToEvent(prepared, data);
  const eventProcessors = [...clientEventProcessors,
  // Run scope event processors _after_ all other processors
  ...data.eventProcessors];
  const result = notifyEventProcessors(eventProcessors, prepared, hint);
  return result.then(evt => {
    if (evt) {
      // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
      // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
      // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
      // any new data
      applyDebugMeta(evt);
    }
    if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
      return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
    }
    return evt;
  });
}

/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */
function applyClientOptions(event, options) {
  const {
    environment,
    release,
    dist,
    maxValueLength = 250
  } = options;

  // empty strings do not make sense for environment, release, and dist
  // so we handle them the same as if they were not provided
  event.environment = event.environment || environment || constants/* DEFAULT_ENVIRONMENT */.J;
  if (!event.release && release) {
    event.release = release;
  }
  if (!event.dist && dist) {
    event.dist = dist;
  }
  if (event.message) {
    event.message = (0,string/* truncate */.$G)(event.message, maxValueLength);
  }
  const exception = event.exception && event.exception.values && event.exception.values[0];
  if (exception && exception.value) {
    exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
  }
  const request = event.request;
  if (request && request.url) {
    request.url = (0,string/* truncate */.$G)(request.url, maxValueLength);
  }
}

/**
 * Puts debug IDs into the stack frames of an error event.
 */
function applyDebugIds(event, stackParser) {
  // Build a map of filename -> debug_id
  const filenameDebugIdMap = getFilenameToDebugIdMap(stackParser);
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      exception.stacktrace.frames.forEach(frame => {
        if (filenameDebugIdMap && frame.filename) {
          frame.debug_id = filenameDebugIdMap[frame.filename];
        }
      });
    });
  } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }
}

/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */
function applyDebugMeta(event) {
  // Extract debug IDs and filenames from the stack frames on the event.
  const filenameDebugIdMap = {};
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      exception.stacktrace.frames.forEach(frame => {
        if (frame.debug_id) {
          if (frame.abs_path) {
            filenameDebugIdMap[frame.abs_path] = frame.debug_id;
          } else if (frame.filename) {
            filenameDebugIdMap[frame.filename] = frame.debug_id;
          }
          delete frame.debug_id;
        }
      });
    });
  } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }
  if (Object.keys(filenameDebugIdMap).length === 0) {
    return;
  }

  // Fill debug_meta information
  event.debug_meta = event.debug_meta || {};
  event.debug_meta.images = event.debug_meta.images || [];
  const images = event.debug_meta.images;
  Object.entries(filenameDebugIdMap).forEach(([filename, debug_id]) => {
    images.push({
      type: 'sourcemap',
      code_file: filename,
      debug_id
    });
  });
}

/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */
function applyIntegrationsMetadata(event, integrationNames) {
  if (integrationNames.length > 0) {
    event.sdk = event.sdk || {};
    event.sdk.integrations = [...(event.sdk.integrations || []), ...integrationNames];
  }
}

/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */
function normalizeEvent(event, depth, maxBreadth) {
  if (!event) {
    return null;
  }
  const normalized = {
    ...event,
    ...(event.breadcrumbs && {
      breadcrumbs: event.breadcrumbs.map(b => ({
        ...b,
        ...(b.data && {
          data: (0,normalize/* normalize */.Fv)(b.data, depth, maxBreadth)
        })
      }))
    }),
    ...(event.user && {
      user: (0,normalize/* normalize */.Fv)(event.user, depth, maxBreadth)
    }),
    ...(event.contexts && {
      contexts: (0,normalize/* normalize */.Fv)(event.contexts, depth, maxBreadth)
    }),
    ...(event.extra && {
      extra: (0,normalize/* normalize */.Fv)(event.extra, depth, maxBreadth)
    })
  };

  // event.contexts.trace stores information about a Transaction. Similarly,
  // event.spans[] stores information about child Spans. Given that a
  // Transaction is conceptually a Span, normalization should apply to both
  // Transactions and Spans consistently.
  // For now the decision is to skip normalization of Transactions and Spans,
  // so this block overwrites the normalized event to add back the original
  // Transaction information prior to normalization.
  if (event.contexts && event.contexts.trace && normalized.contexts) {
    normalized.contexts.trace = event.contexts.trace;

    // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
    if (event.contexts.trace.data) {
      normalized.contexts.trace.data = (0,normalize/* normalize */.Fv)(event.contexts.trace.data, depth, maxBreadth);
    }
  }

  // event.spans[].data may contain circular/dangerous data so we need to normalize it
  if (event.spans) {
    normalized.spans = event.spans.map(span => {
      return {
        ...span,
        ...(span.data && {
          data: (0,normalize/* normalize */.Fv)(span.data, depth, maxBreadth)
        })
      };
    });
  }

  // event.contexts.flags (FeatureFlagContext) stores context for our feature
  // flag integrations. It has a greater nesting depth than our other typed
  // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
  // to skip this in case of conflicting, user-provided context.
  if (event.contexts && event.contexts.flags && normalized.contexts) {
    normalized.contexts.flags = (0,normalize/* normalize */.Fv)(event.contexts.flags, 3, maxBreadth);
  }
  return normalized;
}
function getFinalScope(scope, captureContext) {
  if (!captureContext) {
    return scope;
  }
  const finalScope = scope ? scope.clone() : new esm_scope/* Scope */.s();
  finalScope.update(captureContext);
  return finalScope;
}

/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */
function parseEventHintOrCaptureContext(hint) {
  if (!hint) {
    return undefined;
  }

  // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
  if (hintIsScopeOrFunction(hint)) {
    return {
      captureContext: hint
    };
  }
  if (hintIsScopeContext(hint)) {
    return {
      captureContext: hint
    };
  }
  return hint;
}
function hintIsScopeOrFunction(hint) {
  return hint instanceof esm_scope/* Scope */.s || typeof hint === 'function';
}
const captureContextKeys = ['user', 'level', 'extra', 'contexts', 'tags', 'fingerprint', 'requestSession', 'propagationContext'];
function hintIsScopeContext(hint) {
  return Object.keys(hint).some(key => captureContextKeys.includes(key));
}


/***/ }),

/***/ 17751:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ applySdkMetadata; }
/* harmony export */ });
/* harmony import */ var _utils_hoist_version_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58077);


/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */
function applySdkMetadata(options, name, names = [name], source = 'npm') {
  const metadata = options._metadata || {};
  if (!metadata.sdk) {
    metadata.sdk = {
      name: `sentry.javascript.${name}`,
      packages: names.map(name => ({
        name: `${source}:@sentry/${name}`,
        version: _utils_hoist_version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .J
      })),
      version: _utils_hoist_version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .J
    };
  }
  options._metadata = metadata;
}


/***/ }),

/***/ 14252:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ _setSpanForScope; },
/* harmony export */   "Y": function() { return /* binding */ _getSpanForScope; }
/* harmony export */ });
/* harmony import */ var _utils_hoist_object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88803);

const SCOPE_SPAN_FIELD = '_sentrySpan';

/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */
function _setSpanForScope(scope, span) {
  if (span) {
    (0,_utils_hoist_object_js__WEBPACK_IMPORTED_MODULE_0__/* .addNonEnumerableProperty */ .xp)(scope, SCOPE_SPAN_FIELD, span);
  } else {
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[SCOPE_SPAN_FIELD];
  }
}

/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */
function _getSpanForScope(scope) {
  return scope[SCOPE_SPAN_FIELD];
}


/***/ }),

/***/ 43384:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$k": function() { return /* binding */ spanTimeInputToSeconds; },
/* harmony export */   "Dp": function() { return /* binding */ getSpanDescendants; },
/* harmony export */   "Gx": function() { return /* binding */ getRootSpan; },
/* harmony export */   "HN": function() { return /* binding */ getActiveSpan; },
/* harmony export */   "HR": function() { return /* binding */ spanToTransactionTraceContext; },
/* harmony export */   "Hb": function() { return /* binding */ spanToTraceHeader; },
/* harmony export */   "R6": function() { return /* binding */ showSpanDropWarning; },
/* harmony export */   "Tt": function() { return /* binding */ spanIsSampled; },
/* harmony export */   "XU": function() { return /* binding */ spanToJSON; },
/* harmony export */   "_4": function() { return /* binding */ getStatusMessage; },
/* harmony export */   "ed": function() { return /* binding */ removeChildSpanFromSpan; },
/* harmony export */   "i0": function() { return /* binding */ TRACE_FLAG_SAMPLED; },
/* harmony export */   "j5": function() { return /* binding */ addChildSpanToSpan; },
/* harmony export */   "ve": function() { return /* binding */ TRACE_FLAG_NONE; },
/* harmony export */   "wy": function() { return /* binding */ spanToTraceContext; }
/* harmony export */ });
/* unused harmony exports updateMetricSummaryOnActiveSpan, updateSpanName */
/* harmony import */ var _asyncContext_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91164);
/* harmony import */ var _carrier_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17195);
/* harmony import */ var _currentScopes_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97308);
/* harmony import */ var _metrics_metric_summary_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17333);
/* harmony import */ var _semanticAttributes_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85535);
/* harmony import */ var _tracing_spanstatus_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89898);
/* harmony import */ var _utils_hoist_logger_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3518);
/* harmony import */ var _utils_hoist_object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88803);
/* harmony import */ var _utils_hoist_propagationContext_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28389);
/* harmony import */ var _utils_hoist_time_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27870);
/* harmony import */ var _utils_hoist_tracing_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87763);
/* harmony import */ var _spanOnScope_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14252);













// These are aligned with OpenTelemetry trace flags
const TRACE_FLAG_NONE = 0x0;
const TRACE_FLAG_SAMPLED = 0x1;

// todo(v9): Remove this once we've stopped dropping spans via `beforeSendSpan`
let hasShownSpanDropWarning = false;

/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */
function spanToTransactionTraceContext(span) {
  const {
    spanId: span_id,
    traceId: trace_id
  } = span.spanContext();
  const {
    data,
    op,
    parent_span_id,
    status,
    origin
  } = spanToJSON(span);
  return (0,_utils_hoist_object_js__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)({
    parent_span_id,
    span_id,
    trace_id,
    data,
    op,
    status,
    origin
  });
}

/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */
function spanToTraceContext(span) {
  const {
    spanId,
    traceId: trace_id,
    isRemote
  } = span.spanContext();

  // If the span is remote, we use a random/virtual span as span_id to the trace context,
  // and the remote span as parent_span_id
  const parent_span_id = isRemote ? spanId : spanToJSON(span).parent_span_id;
  const span_id = isRemote ? (0,_utils_hoist_propagationContext_js__WEBPACK_IMPORTED_MODULE_1__/* .generateSpanId */ .M)() : spanId;
  return (0,_utils_hoist_object_js__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)({
    parent_span_id,
    span_id,
    trace_id
  });
}

/**
 * Convert a Span to a Sentry trace header.
 */
function spanToTraceHeader(span) {
  const {
    traceId,
    spanId
  } = span.spanContext();
  const sampled = spanIsSampled(span);
  return (0,_utils_hoist_tracing_js__WEBPACK_IMPORTED_MODULE_2__/* .generateSentryTraceHeader */ .$p)(traceId, spanId, sampled);
}

/**
 * Convert a span time input into a timestamp in seconds.
 */
function spanTimeInputToSeconds(input) {
  if (typeof input === 'number') {
    return ensureTimestampInSeconds(input);
  }
  if (Array.isArray(input)) {
    // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
  }
  if (input instanceof Date) {
    return ensureTimestampInSeconds(input.getTime());
  }
  return (0,_utils_hoist_time_js__WEBPACK_IMPORTED_MODULE_3__/* .timestampInSeconds */ .ph)();
}

/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */
function ensureTimestampInSeconds(timestamp) {
  const isMs = timestamp > 9999999999;
  return isMs ? timestamp / 1000 : timestamp;
}

/**
 * Convert a span to a JSON representation.
 */
// Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function spanToJSON(span) {
  if (spanIsSentrySpan(span)) {
    return span.getSpanJSON();
  }
  try {
    const {
      spanId: span_id,
      traceId: trace_id
    } = span.spanContext();

    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if (spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
      const {
        attributes,
        startTime,
        name,
        endTime,
        parentSpanId,
        status
      } = span;
      return (0,_utils_hoist_object_js__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)({
        span_id,
        trace_id,
        data: attributes,
        description: name,
        parent_span_id: parentSpanId,
        start_timestamp: spanTimeInputToSeconds(startTime),
        // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
        timestamp: spanTimeInputToSeconds(endTime) || undefined,
        status: getStatusMessage(status),
        op: attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_4__/* .SEMANTIC_ATTRIBUTE_SENTRY_OP */ .$J],
        origin: attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_4__/* .SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */ .S3],
        _metrics_summary: (0,_metrics_metric_summary_js__WEBPACK_IMPORTED_MODULE_5__/* .getMetricSummaryJsonForSpan */ .y)(span)
      });
    }

    // Finally, at least we have `spanContext()`....
    return {
      span_id,
      trace_id
    };
  } catch (e) {
    return {};
  }
}
function spanIsOpenTelemetrySdkTraceBaseSpan(span) {
  const castSpan = span;
  return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}

/** Exported only for tests. */

/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */
function spanIsSentrySpan(span) {
  return typeof span.getSpanJSON === 'function';
}

/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */
function spanIsSampled(span) {
  // We align our trace flags with the ones OpenTelemetry use
  // So we also check for sampled the same way they do.
  const {
    traceFlags
  } = span.spanContext();
  return traceFlags === TRACE_FLAG_SAMPLED;
}

/** Get the status message to use for a JSON representation of a span. */
function getStatusMessage(status) {
  if (!status || status.code === _tracing_spanstatus_js__WEBPACK_IMPORTED_MODULE_6__/* .SPAN_STATUS_UNSET */ .pq) {
    return undefined;
  }
  if (status.code === _tracing_spanstatus_js__WEBPACK_IMPORTED_MODULE_6__/* .SPAN_STATUS_OK */ .OP) {
    return 'ok';
  }
  return status.message || 'unknown_error';
}
const CHILD_SPANS_FIELD = '_sentryChildSpans';
const ROOT_SPAN_FIELD = '_sentryRootSpan';

/**
 * Adds an opaque child span reference to a span.
 */
function addChildSpanToSpan(span, childSpan) {
  // We store the root span reference on the child span
  // We need this for `getRootSpan()` to work
  const rootSpan = span[ROOT_SPAN_FIELD] || span;
  (0,_utils_hoist_object_js__WEBPACK_IMPORTED_MODULE_0__/* .addNonEnumerableProperty */ .xp)(childSpan, ROOT_SPAN_FIELD, rootSpan);

  // We store a list of child spans on the parent span
  // We need this for `getSpanDescendants()` to work
  if (span[CHILD_SPANS_FIELD]) {
    span[CHILD_SPANS_FIELD].add(childSpan);
  } else {
    (0,_utils_hoist_object_js__WEBPACK_IMPORTED_MODULE_0__/* .addNonEnumerableProperty */ .xp)(span, CHILD_SPANS_FIELD, new Set([childSpan]));
  }
}

/** This is only used internally by Idle Spans. */
function removeChildSpanFromSpan(span, childSpan) {
  if (span[CHILD_SPANS_FIELD]) {
    span[CHILD_SPANS_FIELD].delete(childSpan);
  }
}

/**
 * Returns an array of the given span and all of its descendants.
 */
function getSpanDescendants(span) {
  const resultSet = new Set();
  function addSpanChildren(span) {
    // This exit condition is required to not infinitely loop in case of a circular dependency.
    if (resultSet.has(span)) {
      return;
      // We want to ignore unsampled spans (e.g. non recording spans)
    } else if (spanIsSampled(span)) {
      resultSet.add(span);
      const childSpans = span[CHILD_SPANS_FIELD] ? Array.from(span[CHILD_SPANS_FIELD]) : [];
      for (const childSpan of childSpans) {
        addSpanChildren(childSpan);
      }
    }
  }
  addSpanChildren(span);
  return Array.from(resultSet);
}

/**
 * Returns the root span of a given span.
 */
function getRootSpan(span) {
  return span[ROOT_SPAN_FIELD] || span;
}

/**
 * Returns the currently active span.
 */
function getActiveSpan() {
  const carrier = (0,_carrier_js__WEBPACK_IMPORTED_MODULE_7__/* .getMainCarrier */ .c)();
  const acs = (0,_asyncContext_index_js__WEBPACK_IMPORTED_MODULE_8__/* .getAsyncContextStrategy */ .G)(carrier);
  if (acs.getActiveSpan) {
    return acs.getActiveSpan();
  }
  return (0,_spanOnScope_js__WEBPACK_IMPORTED_MODULE_9__/* ._getSpanForScope */ .Y)((0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_10__/* .getCurrentScope */ .nZ)());
}

/**
 * Updates the metric summary on the currently active span
 */
function updateMetricSummaryOnActiveSpan(metricType, sanitizedName, value, unit, tags, bucketKey) {
  const span = getActiveSpan();
  if (span) {
    updateMetricSummaryOnSpan(span, metricType, sanitizedName, value, unit, tags, bucketKey);
  }
}

/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 *
 * todo(v9): Remove this once we've stopped dropping spans via `beforeSendSpan`.
 */
function showSpanDropWarning() {
  if (!hasShownSpanDropWarning) {
    (0,_utils_hoist_logger_js__WEBPACK_IMPORTED_MODULE_11__/* .consoleSandbox */ .Cf)(() => {
      // eslint-disable-next-line no-console
      console.warn('[Sentry] Deprecation warning: Returning null from `beforeSendSpan` will be disallowed from SDK version 9.0.0 onwards. The callback will only support mutating spans. To drop certain spans, configure the respective integrations directly.');
    });
    hasShownSpanDropWarning = true;
  }
}

/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */
function updateSpanName(span, name) {
  span.updateName(name);
  span.setAttributes({
    [SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'custom',
    [SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME]: name
  });
}


/***/ }),

/***/ 91511:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD =  false || false;


/***/ }),

/***/ 91135:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),

/***/ 51224:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

/***/ }),

/***/ 73782:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 67796:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),

/***/ 62691:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 69471:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),

/***/ 21967:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67796);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }
  return target;
}

/***/ }),

/***/ 37559:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpreadProps(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),

/***/ 25925:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),

/***/ 18473:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(69471);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(28712);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 41492:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
  throw e;
}

/***/ }),

/***/ 72760:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(91135);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(69471);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(28712);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 28712:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91135);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 68582:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lib_axios; }
});

// NAMESPACE OBJECT: ./node_modules/axios/lib/platform/common/utils.js
var common_utils_namespaceObject = {};
__webpack_require__.r(common_utils_namespaceObject);
__webpack_require__.d(common_utils_namespaceObject, {
  "hasBrowserEnv": function() { return hasBrowserEnv; },
  "hasStandardBrowserEnv": function() { return hasStandardBrowserEnv; },
  "hasStandardBrowserWebWorkerEnv": function() { return hasStandardBrowserWebWorkerEnv; },
  "navigator": function() { return _navigator; },
  "origin": function() { return origin; }
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/bind.js


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/utils.js
/* provided dependency */ var process = __webpack_require__(554);




// utils is a library of generic helper functions non-specific to axios

const {
  toString: utils_toString
} = Object.prototype;
const {
  getPrototypeOf
} = Object;
const {
  iterator,
  toStringTag
} = Symbol;
const kindOf = (cache => thing => {
  const str = utils_toString.call(thing);
  return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));
const kindOfTest = type => {
  type = type.toLowerCase();
  return thing => kindOf(thing) === type;
};
const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {
  isArray
} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = thing => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = val => {
  if (kindOf(val) !== 'object') {
    return false;
  }
  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(toStringTag in val) && !(iterator in val);
};

/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */
const isEmptyObject = val => {
  // Early return for non-objects or Buffers to prevent RangeError
  if (!isObject(val) || isBuffer(val)) {
    return false;
  }
  try {
    return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
  } catch (e) {
    // Fallback for any other objects that might cause RangeError with Object.keys()
    return false;
  }
};

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = val => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = thing => {
  let kind;
  return thing && (typeof FormData === 'function' && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === 'formdata' ||
  // detect form-data instance
  kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');
const [isReadableStream, isRequest, isResponse, isHeaders] = ['ReadableStream', 'Request', 'Response', 'Headers'].map(kindOfTest);

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = str => str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {
  allOwnKeys = false
} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }
  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }
  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Buffer check
    if (isBuffer(obj)) {
      return;
    }

    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;
    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}
function findKey(obj, key) {
  if (isBuffer(obj)) {
    return null;
  }
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}
const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : global;
})();
const isContextDefined = context => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */
) {
  const {
    caseless
  } = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  };
  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {
  allOwnKeys
} = {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {
    allOwnKeys
  });
  return a;
};

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = content => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
};

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};
  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;
  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
  return destObj;
};

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};

/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = thing => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[iterator];
  const _iterator = generator.call(obj);
  let result;
  while ((result = _iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];
  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }
  return arr;
};

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');
const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
    return p1.toUpperCase() + p2;
  });
};

/* Creating a function that will check if an object has a property. */
const utils_hasOwnProperty = (({
  hasOwnProperty
}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');
const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};
  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });
  Object.defineProperties(obj, reducedDescriptors);
};

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = obj => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }
    const value = obj[name];
    if (!isFunction(value)) return;
    descriptor.enumerable = false;
    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }
    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
};
const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};
  const define = arr => {
    arr.forEach(value => {
      obj[value] = true;
    });
  };
  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
  return obj;
};
const noop = () => {};
const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[toStringTag] === 'FormData' && thing[iterator]);
}
const toJSONObject = obj => {
  const stack = new Array(10);
  const visit = (source, i) => {
    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      //Buffer check
      if (isBuffer(source)) {
        return source;
      }
      if (!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};
        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });
        stack[i] = undefined;
        return target;
      }
    }
    return source;
  };
  return visit(obj, 0);
};
const isAsyncFn = kindOfTest('AsyncFunction');
const isThenable = thing => thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34

const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }
  return postMessageSupported ? ((token, callbacks) => {
    _global.addEventListener("message", ({
      source,
      data
    }) => {
      if (source === _global && data === token) {
        callbacks.length && callbacks.shift()();
      }
    }, false);
    return cb => {
      callbacks.push(cb);
      _global.postMessage(token, "*");
    };
  })(`axios@${Math.random()}`, []) : cb => setTimeout(cb);
})(typeof setImmediate === 'function', isFunction(_global.postMessage));
const asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind(_global) : typeof process !== 'undefined' && process.nextTick || _setImmediate;

// *********************

const isIterable = thing => thing != null && isFunction(thing[iterator]);
/* harmony default export */ var utils = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isEmptyObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: utils_hasOwnProperty,
  hasOwnProp: utils_hasOwnProperty,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap,
  isIterable
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosError.js




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = new Error().stack;
  }
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  if (response) {
    this.response = response;
    this.status = response.status ? response.status : null;
  }
}
utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const AxiosError_prototype = AxiosError.prototype;
const descriptors = {};
['ERR_BAD_OPTION_VALUE', 'ERR_BAD_OPTION', 'ECONNABORTED', 'ETIMEDOUT', 'ERR_NETWORK', 'ERR_FR_TOO_MANY_REDIRECTS', 'ERR_DEPRECATED', 'ERR_BAD_RESPONSE', 'ERR_BAD_REQUEST', 'ERR_CANCELED', 'ERR_NOT_SUPPORT', 'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {
    value: code
  };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(AxiosError_prototype, 'isAxiosError', {
  value: true
});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(AxiosError_prototype);
  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });
  AxiosError.call(axiosError, error.message, code, config, request, response);
  axiosError.cause = error;
  axiosError.name = error.name;
  customProps && Object.assign(axiosError, customProps);
  return axiosError;
};
/* harmony default export */ var core_AxiosError = (AxiosError);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/null.js
// eslint-disable-next-line strict
/* harmony default export */ var helpers_null = (null);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toFormData.js
/* provided dependency */ var Buffer = __webpack_require__(80365)["lW"];




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}
const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (helpers_null || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });
  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);
  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }
  function convertValue(value) {
    if (value === null) return '';
    if (utils.isDate(value)) {
      return value.toISOString();
    }
    if (utils.isBoolean(value)) {
      return value.toString();
    }
    if (!useBlob && utils.isBlob(value)) {
      throw new core_AxiosError('Blob is not supported. Use a Buffer instead.');
    }
    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }
    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;
    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (utils.isArray(value) && isFlatArray(value) || (utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value))) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);
        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
          // eslint-disable-next-line no-nested-ternary
          indexes === true ? renderKey([key], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
        });
        return false;
      }
    }
    if (isVisitable(value)) {
      return true;
    }
    formData.append(renderKey(path, key, dots), convertValue(value));
    return false;
  }
  const stack = [];
  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });
  function build(value, path) {
    if (utils.isUndefined(value)) return;
    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }
    stack.push(value);
    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers);
      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });
    stack.pop();
  }
  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }
  build(obj);
  return formData;
}
/* harmony default export */ var helpers_toFormData = (toFormData);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];
  params && helpers_toFormData(params, this, options);
}
const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;
AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};
AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder ? function (value) {
    return encoder.call(this, value, encode);
  } : encode;
  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};
/* harmony default export */ var helpers_AxiosURLSearchParams = (AxiosURLSearchParams);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?(object|Function)} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  const _encode = options && options.encode || buildURL_encode;
  if (utils.isFunction(options)) {
    options = {
      serialize: options
    };
  }
  const serializeFn = options && options.serialize;
  let serializedParams;
  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ? params.toString() : new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }
  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }
  return url;
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/InterceptorManager.js



class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}
/* harmony default export */ var core_InterceptorManager = (InterceptorManager);
;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ var defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ var classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);
;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ var classes_FormData = (typeof FormData !== 'undefined' ? FormData : null);
;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/Blob.js


/* harmony default export */ var classes_Blob = (typeof Blob !== 'undefined' ? Blob : null);
;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/index.js



/* harmony default export */ var browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: classes_FormData,
    Blob: classes_Blob
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/common/utils.js
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';
const _navigator = typeof navigator === 'object' && navigator || undefined;

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || ['ReactNative', 'NativeScript', 'NS'].indexOf(_navigator.product) < 0);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return typeof WorkerGlobalScope !== 'undefined' &&
  // eslint-disable-next-line no-undef
  self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const origin = hasBrowserEnv && window.location.href || 'http://localhost';

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/index.js


/* harmony default export */ var platform = ({
  ...common_utils_namespaceObject,
  ...browser
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toURLEncodedForm.js





function toURLEncodedForm(data, options) {
  return helpers_toFormData(data, new platform.classes.URLSearchParams(), {
    visitor: function (value, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }
      return helpers.defaultVisitor.apply(this, arguments);
    },
    ...options
  });
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/formDataToJSON.js




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    if (name === '__proto__') return true;
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;
    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }
      return !isNumericKey;
    }
    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }
    const result = buildPath(path, value, target[name], index);
    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }
    return !isNumericKey;
  }
  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};
    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });
    return obj;
  }
  return null;
}
/* harmony default export */ var helpers_formDataToJSON = (formDataToJSON);
;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/index.js










/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
  transitional: defaults_transitional,
  adapter: ['xhr', 'http', 'fetch'],
  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);
    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }
    const isFormData = utils.isFormData(data);
    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
    }
    if (utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data) || utils.isReadableStream(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }
    let isFileList;
    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }
      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;
        return helpers_toFormData(isFileList ? {
          'files[]': data
        } : data, _FormData && new _FormData(), this.formSerializer);
      }
    }
    if (isObjectPayload || hasJSONContentType) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }
    return data;
  }],
  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';
    if (utils.isResponse(data) || utils.isReadableStream(data)) {
      return data;
    }
    if (data && utils.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw core_AxiosError.from(e, core_AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }
    return data;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};
utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], method => {
  defaults.headers[method] = {};
});
/* harmony default export */ var lib_defaults = (defaults);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet(['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent']);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ var parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;
  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();
    if (!key || parsed[key] && ignoreDuplicateOf[key]) {
      return;
    }
    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });
  return parsed;
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosHeaders.js




const $internals = Symbol('internals');
function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }
  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;
  while (match = tokensRE.exec(str)) {
    tokens[match[1]] = match[2];
  }
  return tokens;
}
const isValidHeaderName = str => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }
  if (isHeaderNameFilter) {
    value = header;
  }
  if (!utils.isString(value)) return;
  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }
  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}
function formatHeader(header) {
  return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
    return char.toUpperCase() + str;
  });
}
function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);
  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function (arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}
class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }
  set(header, valueOrRewrite, rewrite) {
    const self = this;
    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);
      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }
      const key = utils.findKey(self, lHeader);
      if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) {
        self[key || _header] = normalizeValue(_value);
      }
    }
    const setHeaders = (headers, _rewrite) => utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));
    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if (utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else if (utils.isObject(header) && utils.isIterable(header)) {
      let obj = {},
        dest,
        key;
      for (const entry of header) {
        if (!utils.isArray(entry)) {
          throw TypeError('Object iterator must return a key-value pair');
        }
        obj[key = entry[0]] = (dest = obj[key]) ? utils.isArray(dest) ? [...dest, entry[1]] : [dest, entry[1]] : entry[1];
      }
      setHeaders(obj, valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }
    return this;
  }
  get(header, parser) {
    header = normalizeHeader(header);
    if (header) {
      const key = utils.findKey(this, header);
      if (key) {
        const value = this[key];
        if (!parser) {
          return value;
        }
        if (parser === true) {
          return parseTokens(value);
        }
        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }
        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }
        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }
  has(header, matcher) {
    header = normalizeHeader(header);
    if (header) {
      const key = utils.findKey(this, header);
      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }
    return false;
  }
  delete(header, matcher) {
    const self = this;
    let deleted = false;
    function deleteHeader(_header) {
      _header = normalizeHeader(_header);
      if (_header) {
        const key = utils.findKey(self, _header);
        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];
          deleted = true;
        }
      }
    }
    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }
    return deleted;
  }
  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;
    while (i--) {
      const key = keys[i];
      if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }
    return deleted;
  }
  normalize(format) {
    const self = this;
    const headers = {};
    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);
      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }
      const normalized = format ? formatHeader(header) : String(header).trim();
      if (normalized !== header) {
        delete self[header];
      }
      self[normalized] = normalizeValue(value);
      headers[normalized] = true;
    });
    return this;
  }
  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }
  toJSON(asStrings) {
    const obj = Object.create(null);
    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });
    return obj;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }
  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }
  static concat(first, ...targets) {
    const computed = new this(first);
    targets.forEach(target => computed.set(target));
    return computed;
  }
  static accessor(header) {
    const internals = this[$internals] = this[$internals] = {
      accessors: {}
    };
    const accessors = internals.accessors;
    const prototype = this.prototype;
    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);
      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }
    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
    return this;
  }
}
AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils.reduceDescriptors(AxiosHeaders.prototype, ({
  value
}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  };
});
utils.freezeMethods(AxiosHeaders);
/* harmony default export */ var core_AxiosHeaders = (AxiosHeaders);
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;
  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });
  headers.normalize();
  return data;
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CanceledError.js





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  core_AxiosError.call(this, message == null ? 'canceled' : message, core_AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}
utils.inherits(CanceledError, core_AxiosError, {
  __CANCEL__: true
});
/* harmony default export */ var cancel_CanceledError = (CanceledError);
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new core_AxiosError('Request failed with status code ' + response.status, [core_AxiosError.ERR_BAD_REQUEST, core_AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4], response.config, response.request, response));
  }
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;
  min = min !== undefined ? min : 1000;
  return function push(chunkLength) {
    const now = Date.now();
    const startedAt = timestamps[tail];
    if (!firstSampleTS) {
      firstSampleTS = now;
    }
    bytes[head] = chunkLength;
    timestamps[head] = now;
    let i = tail;
    let bytesCount = 0;
    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }
    head = (head + 1) % samplesCount;
    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }
    if (now - firstSampleTS < min) {
      return;
    }
    const passed = startedAt && now - startedAt;
    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}
/* harmony default export */ var helpers_speedometer = (speedometer);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/throttle.js
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */
function throttle(fn, freq) {
  let timestamp = 0;
  let threshold = 1000 / freq;
  let lastArgs;
  let timer;
  const invoke = (args, now = Date.now()) => {
    timestamp = now;
    lastArgs = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    fn(...args);
  };
  const throttled = (...args) => {
    const now = Date.now();
    const passed = now - timestamp;
    if (passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(lastArgs);
        }, threshold - passed);
      }
    }
  };
  const flush = () => lastArgs && invoke(lastArgs);
  return [throttled, flush];
}
/* harmony default export */ var helpers_throttle = (throttle);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/progressEventReducer.js



const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = helpers_speedometer(50, 250);
  return helpers_throttle(e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;
    bytesNotified = loaded;
    const data = {
      loaded,
      total,
      progress: total ? loaded / total : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e,
      lengthComputable: total != null,
      [isDownloadStream ? 'download' : 'upload']: true
    };
    listener(data);
  }, freq);
};
const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;
  return [loaded => throttled[0]({
    lengthComputable,
    total,
    loaded
  }), throttled[1]];
};
const asyncDecorator = fn => (...args) => utils.asap(() => fn(...args));
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isURLSameOrigin.js

/* harmony default export */ var isURLSameOrigin = (platform.hasStandardBrowserEnv ? ((origin, isMSIE) => url => {
  url = new URL(url, platform.origin);
  return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
})(new URL(platform.origin), platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent)) : () => true);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/cookies.js


/* harmony default export */ var cookies = (platform.hasStandardBrowserEnv ?
// Standard browser envs support document.cookie
{
  write(name, value, expires, path, domain, secure) {
    const cookie = [name + '=' + encodeURIComponent(value)];
    utils.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
    utils.isString(path) && cookie.push('path=' + path);
    utils.isString(domain) && cookie.push('domain=' + domain);
    secure === true && cookie.push('secure');
    document.cookie = cookie.join('; ');
  },
  read(name) {
    const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
    return match ? decodeURIComponent(match[3]) : null;
  },
  remove(name) {
    this.write(name, '', Date.now() - 86400000);
  }
} :
// Non-standard browser env (web workers, react-native) lack needed support.
{
  write() {},
  read() {
    return null;
  },
  remove() {}
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls) {
  let isRelativeUrl = !isAbsoluteURL(requestedURL);
  if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/mergeConfig.js




const headersToObject = thing => thing instanceof core_AxiosHeaders ? {
  ...thing
} : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};
  function getMergedValue(target, source, prop, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({
        caseless
      }, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, prop, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, prop, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, prop, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }
  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b, prop) => mergeDeepProperties(headersToObject(a), headersToObject(b), prop, true)
  };
  utils.forEach(Object.keys({
    ...config1,
    ...config2
  }), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    utils.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/resolveConfig.js








/* harmony default export */ var resolveConfig = (config => {
  const newConfig = mergeConfig({}, config);
  let {
    data,
    withXSRFToken,
    xsrfHeaderName,
    xsrfCookieName,
    headers,
    auth
  } = newConfig;
  newConfig.headers = headers = core_AxiosHeaders.from(headers);
  newConfig.url = buildURL(buildFullPath(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);

  // HTTP basic authentication
  if (auth) {
    headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
  }
  let contentType;
  if (utils.isFormData(data)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(undefined); // Let the browser set it
    } else if ((contentType = headers.getContentType()) !== false) {
      // fix semicolon duplication issue for ReactNative FormData implementation
      const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
      headers.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
    }
  }

  // Add xsrf header
  // This is only done if running in a standard browser environment.
  // Specifically not if we're in a web worker, or react-native.

  if (platform.hasStandardBrowserEnv) {
    withXSRFToken && utils.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
    if (withXSRFToken || withXSRFToken !== false && isURLSameOrigin(newConfig.url)) {
      // Add xsrf header
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);
      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }
  return newConfig;
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/xhr.js










const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
/* harmony default export */ var xhr = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    const _config = resolveConfig(config);
    let requestData = _config.data;
    const requestHeaders = core_AxiosHeaders.from(_config.headers).normalize();
    let {
      responseType,
      onUploadProgress,
      onDownloadProgress
    } = _config;
    let onCanceled;
    let uploadThrottled, downloadThrottled;
    let flushUpload, flushDownload;
    function done() {
      flushUpload && flushUpload(); // flush events
      flushDownload && flushDownload(); // flush events

      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
      _config.signal && _config.signal.removeEventListener('abort', onCanceled);
    }
    let request = new XMLHttpRequest();
    request.open(_config.method.toUpperCase(), _config.url, true);

    // Set the request timeout in MS
    request.timeout = _config.timeout;
    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = core_AxiosHeaders.from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };
      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }
    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }
      reject(new core_AxiosError('Request aborted', core_AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = _config.transitional || defaults_transitional;
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject(new core_AxiosError(timeoutErrorMessage, transitional.clarifyTimeoutError ? core_AxiosError.ETIMEDOUT : core_AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = _config.responseType;
    }

    // Handle progress if needed
    if (onDownloadProgress) {
      [downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true);
      request.addEventListener('progress', downloadThrottled);
    }

    // Not all browsers support upload events
    if (onUploadProgress && request.upload) {
      [uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress);
      request.upload.addEventListener('progress', uploadThrottled);
      request.upload.addEventListener('loadend', flushUpload);
    }
    if (_config.cancelToken || _config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };
      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
      }
    }
    const protocol = parseProtocol(_config.url);
    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new core_AxiosError('Unsupported protocol ' + protocol + ':', core_AxiosError.ERR_BAD_REQUEST, config));
      return;
    }

    // Send the request
    request.send(requestData || null);
  });
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/composeSignals.js



const composeSignals = (signals, timeout) => {
  const {
    length
  } = signals = signals ? signals.filter(Boolean) : [];
  if (timeout || length) {
    let controller = new AbortController();
    let aborted;
    const onabort = function (reason) {
      if (!aborted) {
        aborted = true;
        unsubscribe();
        const err = reason instanceof Error ? reason : this.reason;
        controller.abort(err instanceof core_AxiosError ? err : new cancel_CanceledError(err instanceof Error ? err.message : err));
      }
    };
    let timer = timeout && setTimeout(() => {
      timer = null;
      onabort(new core_AxiosError(`timeout ${timeout} of ms exceeded`, core_AxiosError.ETIMEDOUT));
    }, timeout);
    const unsubscribe = () => {
      if (signals) {
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach(signal => {
          signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
      }
    };
    signals.forEach(signal => signal.addEventListener('abort', onabort));
    const {
      signal
    } = controller;
    signal.unsubscribe = () => utils.asap(unsubscribe);
    return signal;
  }
};
/* harmony default export */ var helpers_composeSignals = (composeSignals);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/trackStream.js
const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;
  if (!chunkSize || len < chunkSize) {
    yield chunk;
    return;
  }
  let pos = 0;
  let end;
  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
};
const readBytes = async function* (iterable, chunkSize) {
  for await (const chunk of readStream(iterable)) {
    yield* streamChunk(chunk, chunkSize);
  }
};
const readStream = async function* (stream) {
  if (stream[Symbol.asyncIterator]) {
    yield* stream;
    return;
  }
  const reader = stream.getReader();
  try {
    for (;;) {
      const {
        done,
        value
      } = await reader.read();
      if (done) {
        break;
      }
      yield value;
    }
  } finally {
    await reader.cancel();
  }
};
const trackStream = (stream, chunkSize, onProgress, onFinish) => {
  const iterator = readBytes(stream, chunkSize);
  let bytes = 0;
  let done;
  let _onFinish = e => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  };
  return new ReadableStream({
    async pull(controller) {
      try {
        const {
          done,
          value
        } = await iterator.next();
        if (done) {
          _onFinish();
          controller.close();
          return;
        }
        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  });
};
;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/fetch.js









const isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === 'function';

// used only inside the fetch adapter
const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? (encoder => str => encoder.encode(str))(new TextEncoder()) : async str => new Uint8Array(await new Response(str).arrayBuffer()));
const test = (fn, ...args) => {
  try {
    return !!fn(...args);
  } catch (e) {
    return false;
  }
};
const supportsRequestStream = isReadableStreamSupported && test(() => {
  let duplexAccessed = false;
  const hasContentType = new Request(platform.origin, {
    body: new ReadableStream(),
    method: 'POST',
    get duplex() {
      duplexAccessed = true;
      return 'half';
    }
  }).headers.has('Content-Type');
  return duplexAccessed && !hasContentType;
});
const DEFAULT_CHUNK_SIZE = 64 * 1024;
const supportsResponseStream = isReadableStreamSupported && test(() => utils.isReadableStream(new Response('').body));
const resolvers = {
  stream: supportsResponseStream && (res => res.body)
};
isFetchSupported && (res => {
  ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach(type => {
    !resolvers[type] && (resolvers[type] = utils.isFunction(res[type]) ? res => res[type]() : (_, config) => {
      throw new core_AxiosError(`Response type '${type}' is not supported`, core_AxiosError.ERR_NOT_SUPPORT, config);
    });
  });
})(new Response());
const getBodyLength = async body => {
  if (body == null) {
    return 0;
  }
  if (utils.isBlob(body)) {
    return body.size;
  }
  if (utils.isSpecCompliantForm(body)) {
    const _request = new Request(platform.origin, {
      method: 'POST',
      body
    });
    return (await _request.arrayBuffer()).byteLength;
  }
  if (utils.isArrayBufferView(body) || utils.isArrayBuffer(body)) {
    return body.byteLength;
  }
  if (utils.isURLSearchParams(body)) {
    body = body + '';
  }
  if (utils.isString(body)) {
    return (await encodeText(body)).byteLength;
  }
};
const resolveBodyLength = async (headers, body) => {
  const length = utils.toFiniteNumber(headers.getContentLength());
  return length == null ? getBodyLength(body) : length;
};
/* harmony default export */ var adapters_fetch = (isFetchSupported && (async config => {
  let {
    url,
    method,
    data,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = 'same-origin',
    fetchOptions
  } = resolveConfig(config);
  responseType = responseType ? (responseType + '').toLowerCase() : 'text';
  let composedSignal = helpers_composeSignals([signal, cancelToken && cancelToken.toAbortSignal()], timeout);
  let request;
  const unsubscribe = composedSignal && composedSignal.unsubscribe && (() => {
    composedSignal.unsubscribe();
  });
  let requestContentLength;
  try {
    if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
      let _request = new Request(url, {
        method: 'POST',
        body: data,
        duplex: "half"
      });
      let contentTypeHeader;
      if (utils.isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) {
        headers.setContentType(contentTypeHeader);
      }
      if (_request.body) {
        const [onProgress, flush] = progressEventDecorator(requestContentLength, progressEventReducer(asyncDecorator(onUploadProgress)));
        data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
      }
    }
    if (!utils.isString(withCredentials)) {
      withCredentials = withCredentials ? 'include' : 'omit';
    }

    // Cloudflare Workers throws when credentials are defined
    // see https://github.com/cloudflare/workerd/issues/902
    const isCredentialsSupported = "credentials" in Request.prototype;
    request = new Request(url, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data,
      duplex: "half",
      credentials: isCredentialsSupported ? withCredentials : undefined
    });
    let response = await fetch(request, fetchOptions);
    const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
    if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
      const options = {};
      ['status', 'statusText', 'headers'].forEach(prop => {
        options[prop] = response[prop];
      });
      const responseContentLength = utils.toFiniteNumber(response.headers.get('content-length'));
      const [onProgress, flush] = onDownloadProgress && progressEventDecorator(responseContentLength, progressEventReducer(asyncDecorator(onDownloadProgress), true)) || [];
      response = new Response(trackStream(response.body, DEFAULT_CHUNK_SIZE, onProgress, () => {
        flush && flush();
        unsubscribe && unsubscribe();
      }), options);
    }
    responseType = responseType || 'text';
    let responseData = await resolvers[utils.findKey(resolvers, responseType) || 'text'](response, config);
    !isStreamResponse && unsubscribe && unsubscribe();
    return await new Promise((resolve, reject) => {
      settle(resolve, reject, {
        data: responseData,
        headers: core_AxiosHeaders.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      });
    });
  } catch (err) {
    unsubscribe && unsubscribe();
    if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
      throw Object.assign(new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request), {
        cause: err.cause || err
      });
    }
    throw core_AxiosError.from(err, err && err.code, config, request);
  }
}));
;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/adapters.js





const knownAdapters = {
  http: helpers_null,
  xhr: xhr,
  fetch: adapters_fetch
};
utils.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {
        value
      });
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {
      value
    });
  }
});
const renderReason = reason => `- ${reason}`;
const isResolvedHandle = adapter => utils.isFunction(adapter) || adapter === null || adapter === false;
/* harmony default export */ var adapters = ({
  getAdapter: adapters => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];
    const {
      length
    } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;
      adapter = nameOrAdapter;
      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
        if (adapter === undefined) {
          throw new core_AxiosError(`Unknown adapter '${id}'`);
        }
      }
      if (adapter) {
        break;
      }
      rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
      const reasons = Object.entries(rejectedReasons).map(([id, state]) => `adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
      let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0]) : 'as no adapter specified';
      throw new core_AxiosError(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
  },
  adapters: knownAdapters
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/dispatchRequest.js









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(config, config.transformRequest);
  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }
  const adapter = adapters.getAdapter(config.adapter || lib_defaults.adapter);
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(config, config.transformResponse, response);
    response.headers = core_AxiosHeaders.from(response.headers);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(config, config.transformResponse, reason.response);
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }
    return Promise.reject(reason);
  });
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/env/data.js
const VERSION = "1.11.0";
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/validator.js




const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});
const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new core_AxiosError(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), core_AxiosError.ERR_DEPRECATED);
    }
    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
    }
    return validator ? validator(value, opt, opts) : true;
  };
};
validators.spelling = function spelling(correctSpelling) {
  return (value, opt) => {
    // eslint-disable-next-line no-console
    console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
    return true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new core_AxiosError('options must be an object', core_AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new core_AxiosError('option ' + opt + ' must be ' + result, core_AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new core_AxiosError('Unknown option ' + opt, core_AxiosError.ERR_BAD_OPTION);
    }
  }
}
/* harmony default export */ var validator = ({
  assertOptions,
  validators
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/Axios.js










const Axios_validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig || {};
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy = {};
        Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();

        // slice off the Error: ... line
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
        try {
          if (!err.stack) {
            err.stack = stack;
            // match without the 2 top stack lines
          } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
            err.stack += '\n' + stack;
          }
        } catch (e) {
          // ignore the case where "stack" is an un-writable property
        }
      }
      throw err;
    }
  }
  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }
    config = mergeConfig(this.defaults, config);
    const {
      transitional,
      paramsSerializer,
      headers
    } = config;
    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
      }, false);
    }
    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: Axios_validators.function,
          serialize: Axios_validators.function
        }, true);
      }
    }

    // Set config.allowAbsoluteUrls
    if (config.allowAbsoluteUrls !== undefined) {
      // do nothing
    } else if (this.defaults.allowAbsoluteUrls !== undefined) {
      config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
    } else {
      config.allowAbsoluteUrls = true;
    }
    validator.assertOptions(config, {
      baseUrl: Axios_validators.spelling('baseURL'),
      withXsrfToken: Axios_validators.spelling('withXSRFToken')
    }, true);

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils.merge(headers.common, headers[config.method]);
    headers && utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], method => {
      delete headers[method];
    });
    config.headers = core_AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }
      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    let promise;
    let i = 0;
    let len;
    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift(...requestInterceptorChain);
      chain.push(...responseInterceptorChain);
      len = chain.length;
      promise = Promise.resolve(config);
      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }
      return promise;
    }
    len = requestInterceptorChain.length;
    let newConfig = config;
    i = 0;
    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }
    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }
    i = 0;
    len = responseInterceptorChain.length;
    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }
    return promise;
  }
  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url, config.allowAbsoluteUrls);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }
  Axios.prototype[method] = generateHTTPMethod();
  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
/* harmony default export */ var core_Axios = (Axios);
;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }
    let resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });
    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;
      let i = token._listeners.length;
      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);
      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };
      return promise;
    };
    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }
      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }
    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }
  toAbortSignal() {
    const controller = new AbortController();
    const abort = err => {
      controller.abort(err);
    };
    this.subscribe(abort);
    controller.signal.unsubscribe = () => this.unsubscribe(abort);
    return controller.signal;
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}
/* harmony default export */ var cancel_CancelToken = (CancelToken);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && payload.isAxiosError === true;
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/HttpStatusCode.js
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});
/* harmony default export */ var helpers_HttpStatusCode = (HttpStatusCode);
;// CONCATENATED MODULE: ./node_modules/axios/lib/axios.js




















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = bind(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, core_Axios.prototype, context, {
    allOwnKeys: true
  });

  // Copy context to instance
  utils.extend(instance, context, null, {
    allOwnKeys: true
  });

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };
  return instance;
}

// Create the default instance to be exported
const axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = helpers_toFormData;

// Expose AxiosError class
axios.AxiosError = core_AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;
axios.AxiosHeaders = core_AxiosHeaders;
axios.formToJSON = thing => helpers_formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = adapters.getAdapter;
axios.HttpStatusCode = helpers_HttpStatusCode;
axios.default = axios;

// this module should only have a default export
/* harmony default export */ var lib_axios = (axios);

/***/ }),

/***/ 57368:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clsx */
function r(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  } else for (f in e) e[f] && (n && (n += " "), n += f);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
/* harmony default export */ __webpack_exports__["Z"] = (clsx);

/***/ }),

/***/ 26233:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getDefaultOptions; }
/* harmony export */ });
/* unused harmony export setDefaultOptions */
let defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

/***/ }),

/***/ 66598:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getTimezoneOffsetInMilliseconds; }
/* harmony export */ });
/* harmony import */ var _toDate_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82070);


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  const _date = (0,_toDate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .toDate */ .Q)(date);
  const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}

/***/ }),

/***/ 27555:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H_": function() { return /* binding */ minutesInDay; },
/* harmony export */   "dP": function() { return /* binding */ millisecondsInDay; },
/* harmony export */   "fH": function() { return /* binding */ minutesInMonth; },
/* harmony export */   "jE": function() { return /* binding */ millisecondsInWeek; },
/* harmony export */   "vh": function() { return /* binding */ millisecondsInHour; },
/* harmony export */   "yJ": function() { return /* binding */ millisecondsInMinute; }
/* harmony export */ });
/* unused harmony exports daysInWeek, daysInYear, maxTime, minTime, millisecondsInSecond, minutesInYear, minutesInHour, monthsInQuarter, monthsInYear, quartersInYear, secondsInHour, secondsInMinute, secondsInDay, secondsInWeek, secondsInYear, secondsInMonth, secondsInQuarter */
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */

/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */
const daysInWeek = 7;

/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */
const daysInYear = 365.2425;

/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "./constants/date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */
const maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;

/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "./constants/date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */
const minTime = -maxTime;

/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */
const millisecondsInWeek = 604800000;

/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */
const millisecondsInDay = 86400000;

/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */
const millisecondsInMinute = 60000;

/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */
const millisecondsInHour = 3600000;

/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */
const millisecondsInSecond = 1000;

/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */
const minutesInYear = 525600;

/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */
const minutesInMonth = 43200;

/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */
const minutesInDay = 1440;

/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */
const minutesInHour = 60;

/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */
const monthsInQuarter = 3;

/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */
const monthsInYear = 12;

/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */
const quartersInYear = 4;

/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */
const secondsInHour = 3600;

/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */
const secondsInMinute = 60;

/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */
const secondsInDay = secondsInHour * 24;

/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */
const secondsInWeek = secondsInDay * 7;

/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */
const secondsInYear = secondsInDay * daysInYear;

/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */
const secondsInMonth = secondsInYear / 12;

/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */
const secondsInQuarter = secondsInMonth * 3;

/***/ }),

/***/ 23102:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ constructFrom; }
/* harmony export */ });
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */
function constructFrom(date, value) {
  if (date instanceof Date) {
    return new date.constructor(value);
  } else {
    return new Date(value);
  }
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (constructFrom)));

/***/ }),

/***/ 21093:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ differenceInCalendarDays; }
/* harmony export */ });
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27555);
/* harmony import */ var _startOfDay_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62478);
/* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66598);




/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dateLeft, dateRight) {
  const startOfDayLeft = (0,_startOfDay_mjs__WEBPACK_IMPORTED_MODULE_0__/* .startOfDay */ .b)(dateLeft);
  const startOfDayRight = (0,_startOfDay_mjs__WEBPACK_IMPORTED_MODULE_0__/* .startOfDay */ .b)(dateRight);
  const timestampLeft = +startOfDayLeft - (0,_lib_getTimezoneOffsetInMilliseconds_mjs__WEBPACK_IMPORTED_MODULE_1__/* .getTimezoneOffsetInMilliseconds */ .D)(startOfDayLeft);
  const timestampRight = +startOfDayRight - (0,_lib_getTimezoneOffsetInMilliseconds_mjs__WEBPACK_IMPORTED_MODULE_1__/* .getTimezoneOffsetInMilliseconds */ .D)(startOfDayRight);

  // Round the number of days to the nearest integer because the number of
  // milliseconds in a day is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round((timestampLeft - timestampRight) / _constants_mjs__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInDay */ .dP);
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (differenceInCalendarDays)));

/***/ }),

/***/ 39866:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WU": function() { return /* binding */ format; }
});

// UNUSED EXPORTS: default, formatDate, formatters, longFormatters

// EXTERNAL MODULE: ./node_modules/date-fns/locale/en-US.mjs + 9 modules
var en_US = __webpack_require__(1456);
// EXTERNAL MODULE: ./node_modules/date-fns/_lib/defaultOptions.mjs
var _lib_defaultOptions = __webpack_require__(26233);
// EXTERNAL MODULE: ./node_modules/date-fns/differenceInCalendarDays.mjs
var differenceInCalendarDays = __webpack_require__(21093);
// EXTERNAL MODULE: ./node_modules/date-fns/toDate.mjs
var toDate = __webpack_require__(82070);
// EXTERNAL MODULE: ./node_modules/date-fns/constructFrom.mjs
var constructFrom = __webpack_require__(23102);
;// CONCATENATED MODULE: ./node_modules/date-fns/startOfYear.mjs



/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(date) {
  const cleanDate = (0,toDate/* toDate */.Q)(date);
  const _date = (0,constructFrom/* constructFrom */.L)(date, 0);
  _date.setFullYear(cleanDate.getFullYear(), 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfYear = ((/* unused pure expression or super */ null && (startOfYear)));
;// CONCATENATED MODULE: ./node_modules/date-fns/getDayOfYear.mjs




/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear(date) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const diff = (0,differenceInCalendarDays/* differenceInCalendarDays */.w)(_date, startOfYear(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getDayOfYear = ((/* unused pure expression or super */ null && (getDayOfYear)));
// EXTERNAL MODULE: ./node_modules/date-fns/constants.mjs
var constants = __webpack_require__(27555);
;// CONCATENATED MODULE: ./node_modules/date-fns/startOfWeek.mjs



/**
 * The {@link startOfWeek} function options.
 */

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(date, options) {
  const defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
  const _date = (0,toDate/* toDate */.Q)(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfWeek = ((/* unused pure expression or super */ null && (startOfWeek)));
;// CONCATENATED MODULE: ./node_modules/date-fns/startOfISOWeek.mjs


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(date) {
  return startOfWeek(date, {
    weekStartsOn: 1
  });
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfISOWeek = ((/* unused pure expression or super */ null && (startOfISOWeek)));
;// CONCATENATED MODULE: ./node_modules/date-fns/getISOWeekYear.mjs




/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(date) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const year = _date.getFullYear();
  const fourthOfJanuaryOfNextYear = (0,constructFrom/* constructFrom */.L)(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  const fourthOfJanuaryOfThisYear = (0,constructFrom/* constructFrom */.L)(date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getISOWeekYear = ((/* unused pure expression or super */ null && (getISOWeekYear)));
;// CONCATENATED MODULE: ./node_modules/date-fns/startOfISOWeekYear.mjs




/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(date) {
  const year = getISOWeekYear(date);
  const fourthOfJanuary = (0,constructFrom/* constructFrom */.L)(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek(fourthOfJanuary);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfISOWeekYear = ((/* unused pure expression or super */ null && (startOfISOWeekYear)));
;// CONCATENATED MODULE: ./node_modules/date-fns/getISOWeek.mjs





/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(date) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const diff = +startOfISOWeek(_date) - +startOfISOWeekYear(_date);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / constants/* millisecondsInWeek */.jE) + 1;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getISOWeek = ((/* unused pure expression or super */ null && (getISOWeek)));
;// CONCATENATED MODULE: ./node_modules/date-fns/getWeekYear.mjs





/**
 * The {@link getWeekYear} function options.
 */

/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */
function getWeekYear(date, options) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const year = _date.getFullYear();
  const defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
  const firstWeekOfNextYear = (0,constructFrom/* constructFrom */.L)(date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  const firstWeekOfThisYear = (0,constructFrom/* constructFrom */.L)(date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek(firstWeekOfThisYear, options);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getWeekYear = ((/* unused pure expression or super */ null && (getWeekYear)));
;// CONCATENATED MODULE: ./node_modules/date-fns/startOfWeekYear.mjs





/**
 * The {@link startOfWeekYear} function options.
 */

/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfWeekYear(date, options) {
  const defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
  const year = getWeekYear(date, options);
  const firstWeek = (0,constructFrom/* constructFrom */.L)(date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek(firstWeek, options);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfWeekYear = ((/* unused pure expression or super */ null && (startOfWeekYear)));
;// CONCATENATED MODULE: ./node_modules/date-fns/getWeek.mjs





/**
 * The {@link getWeek} function options.
 */

/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek(date, options) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const diff = +startOfWeek(_date, options) - +startOfWeekYear(_date, options);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / constants/* millisecondsInWeek */.jE) + 1;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getWeek = ((/* unused pure expression or super */ null && (getWeek)));
;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/addLeadingZeros.mjs
function addLeadingZeros(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign + output;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/format/lightFormatters.mjs


/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

const lightFormatters = {
  // Year
  y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    const signedYear = date.getFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },
  // Month
  M(date, token) {
    const month = date.getMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d(date, token) {
    return addLeadingZeros(date.getDate(), token.length);
  },
  // AM or PM
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(date, token) {
    return addLeadingZeros(date.getHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H(date, token) {
    return addLeadingZeros(date.getHours(), token.length);
  },
  // Minute
  m(date, token) {
    return addLeadingZeros(date.getMinutes(), token.length);
  },
  // Second
  s(date, token) {
    return addLeadingZeros(date.getSeconds(), token.length);
  },
  // Fraction of second
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/format/formatters.mjs







const dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

const formatters = {
  // Era
  G: function (date, token, localize) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return localize.era(era, {
          width: "abbreviated"
        });
      // A, B
      case "GGGGG":
        return localize.era(era, {
          width: "narrow"
        });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return localize.era(era, {
          width: "wide"
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === "yo") {
      const signedYear = date.getFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: "year"
      });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    const signedWeekYear = getWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === "Yo") {
      return localize.ordinalNumber(weekYear, {
        unit: "year"
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    const isoWeekYear = getISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    const year = date.getFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
        return String(quarter);
      // 01, 02, 03, 04
      case "QQ":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return localize.ordinalNumber(quarter, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "q":
        return String(quarter);
      // 01, 02, 03, 04
      case "qq":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return localize.ordinalNumber(quarter, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return localize.ordinalNumber(month + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "MMM":
        return localize.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return localize.month(month, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return localize.month(month, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return String(month + 1);
      // 01, 02, ..., 12
      case "LL":
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return localize.ordinalNumber(month + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "LLL":
        return localize.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return localize.month(month, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return localize.month(month, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    const week = getWeek(date, options);
    if (token === "wo") {
      return localize.ordinalNumber(week, {
        unit: "week"
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    const isoWeek = getISOWeek(date);
    if (token === "Io") {
      return localize.ordinalNumber(isoWeek, {
        unit: "week"
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === "do") {
      return localize.ordinalNumber(date.getDate(), {
        unit: "date"
      });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    const dayOfYear = getDayOfYear(date);
    if (token === "Do") {
      return localize.ordinalNumber(dayOfYear, {
        unit: "dayOfYear"
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(localDayOfWeek);
      // Padded numerical value
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return localize.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "eee":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case "c":
        return String(localDayOfWeek);
      // Padded numerical value
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return localize.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "ccc":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case "i":
        return String(isoDayOfWeek);
      // 02
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case "io":
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: "day"
        });
      // Tue
      case "iii":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token) {
      case "b":
      case "bb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === "Ho") {
      return localize.ordinalNumber(date.getHours(), {
        unit: "hour"
      });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    const hours = date.getHours() % 12;
    if (token === "Ko") {
      return localize.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    let hours = date.getHours();
    if (hours === 0) hours = 24;
    if (token === "ko") {
      return localize.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === "mo") {
      return localize.ordinalNumber(date.getMinutes(), {
        unit: "minute"
      });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === "so") {
      return localize.ordinalNumber(date.getSeconds(), {
        unit: "second"
      });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize) {
    const timestamp = Math.trunc(date.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize) {
    const timestamp = date.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, delimiter) {
  if (offset % 60 === 0) {
    const sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, delimiter);
}
function formatTimezone(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = addLeadingZeros(Math.trunc(absOffset / 60), 2);
  const minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/format/longFormatters.mjs
const dateLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "P":
      return formatLong.date({
        width: "short"
      });
    case "PP":
      return formatLong.date({
        width: "medium"
      });
    case "PPP":
      return formatLong.date({
        width: "long"
      });
    case "PPPP":
    default:
      return formatLong.date({
        width: "full"
      });
  }
};
const timeLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "p":
      return formatLong.time({
        width: "short"
      });
    case "pp":
      return formatLong.time({
        width: "medium"
      });
    case "ppp":
      return formatLong.time({
        width: "long"
      });
    case "pppp":
    default:
      return formatLong.time({
        width: "full"
      });
  }
};
const dateTimeLongFormatter = (pattern, formatLong) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  let dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong.dateTime({
        width: "short"
      });
      break;
    case "PP":
      dateTimeFormat = formatLong.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      dateTimeFormat = formatLong.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong.dateTime({
        width: "full"
      });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};
const longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/protectedTokens.mjs
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;
const throwTokens = ["D", "DD", "YY", "YYYY"];
function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}
function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}
function warnOrThrowProtectedError(token, format, input) {
  const _message = message(token, format, input);
  console.warn(_message);
  if (throwTokens.includes(token)) throw new RangeError(_message);
}
function message(token, format, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/isDate.mjs
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_isDate = ((/* unused pure expression or super */ null && (isDate)));
;// CONCATENATED MODULE: ./node_modules/date-fns/isValid.mjs



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(date) {
  if (!isDate(date) && typeof date !== "number") {
    return false;
  }
  const _date = (0,toDate/* toDate */.Q)(date);
  return !isNaN(Number(_date));
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_isValid = ((/* unused pure expression or super */ null && (isValid)));
;// CONCATENATED MODULE: ./node_modules/date-fns/format.mjs








// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874


// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;


/**
 * The {@link format} function options.
 */

/**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */
function format(date, formatStr, options) {
  const defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  const locale = options?.locale ?? defaultOptions.locale ?? en_US/* enUS */._;
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
  const originalDate = (0,toDate/* toDate */.Q)(date);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  let parts = formatStr.match(longFormattingTokensRegExp).map(substring => {
    const firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      const longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp).map(substring => {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return {
        isToken: false,
        value: "'"
      };
    }
    const firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return {
        isToken: false,
        value: cleanEscapedString(substring)
      };
    }
    if (formatters[firstCharacter]) {
      return {
        isToken: true,
        value: substring
      };
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return {
      isToken: false,
      value: substring
    };
  });

  // invoke localize preprocessor (only for french locales at the moment)
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }
  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale
  };
  return parts.map(part => {
    if (!part.isToken) return part.value;
    const token = part.value;
    if (!options?.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token) || !options?.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
      warnOrThrowProtectedError(token, formatStr, String(date));
    }
    const formatter = formatters[token[0]];
    return formatter(originalDate, token, locale.localize, formatterOptions);
  }).join("");
}
function cleanEscapedString(input) {
  const matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_format = ((/* unused pure expression or super */ null && (format)));

/***/ }),

/***/ 1456:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ enUS; }
});

// UNUSED EXPORTS: default

;// CONCATENATED MODULE: ./node_modules/date-fns/locale/en-US/_lib/formatDistance.mjs
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
const formatDistance = (token, count, options) => {
  let result;
  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
;// CONCATENATED MODULE: ./node_modules/date-fns/locale/_lib/buildFormatLongFn.mjs
function buildFormatLongFn(args) {
  return (options = {}) => {
    // TODO: Remove String()
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/locale/en-US/_lib/formatLong.mjs

const dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
const timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
const dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
;// CONCATENATED MODULE: ./node_modules/date-fns/locale/en-US/_lib/formatRelative.mjs
const formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
const formatRelative = (token, _date, _baseDate, _options) => formatRelativeLocale[token];
;// CONCATENATED MODULE: ./node_modules/date-fns/locale/_lib/buildLocalizeFn.mjs
/* eslint-disable no-unused-vars */

/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */

/**
 * The map of localized values for each width.
 */

/**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */

/**
 * Converts the unit value to the tuple of values.
 */

/**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */

/**
 * The tuple of localized quarter values. The first element represents Q1.
 */

/**
 * The tuple of localized day values. The first element represents Sunday.
 */

/**
 * The tuple of localized month values. The first element represents January.
 */

function buildLocalizeFn(args) {
  return (value, options) => {
    const context = options?.context ? String(options.context) : "standalone";
    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = options?.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = options?.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;

    // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/locale/en-US/_lib/localize.mjs

const eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
const dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
const dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
const formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
const ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
const localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: quarter => quarter - 1
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
;// CONCATENATED MODULE: ./node_modules/date-fns/locale/_lib/buildMatchFn.mjs
function buildMatchFn(args) {
  return (string, options = {}) => {
    const width = options.width;
    const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];
    const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, pattern => pattern.test(matchedString)) :
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    findKey(parsePatterns, pattern => pattern.test(matchedString));
    let value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    options.valueCallback(value) : value;
    const rest = string.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
function findKey(object, predicate) {
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (let key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/locale/_lib/buildMatchPatternFn.mjs
function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];
    const parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    value = options.valueCallback ? options.valueCallback(value) : value;
    const rest = string.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/locale/en-US/_lib/match.mjs


const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;
const matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
const parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
const matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
const matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: value => parseInt(value, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: index => index + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
;// CONCATENATED MODULE: ./node_modules/date-fns/locale/en-US.mjs






/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */
const enUS = {
  code: "en-US",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};

// Fallback for modularized imports:
/* harmony default export */ var en_US = ((/* unused pure expression or super */ null && (enUS)));

/***/ }),

/***/ 62478:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ startOfDay; }
/* harmony export */ });
/* harmony import */ var _toDate_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82070);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(date) {
  const _date = (0,_toDate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .toDate */ .Q)(date);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (startOfDay)));

/***/ }),

/***/ 82070:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ toDate; }
/* harmony export */ });
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  const argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
  } else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") {
    // TODO: Can we get rid of as?
    return new Date(argument);
  } else {
    // TODO: Can we get rid of as?
    return new Date(NaN);
  }
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (toDate)));

/***/ }),

/***/ 78321:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ purify; }
/* harmony export */ });
/*! @license DOMPurify 3.2.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.6/LICENSE */

const {
  entries,
  setPrototypeOf,
  isFrozen,
  getPrototypeOf,
  getOwnPropertyDescriptor
} = Object;
let {
  freeze,
  seal,
  create
} = Object; // eslint-disable-line import/no-mutable-exports
let {
  apply,
  construct
} = typeof Reflect !== 'undefined' && Reflect;
if (!freeze) {
  freeze = function freeze(x) {
    return x;
  };
}
if (!seal) {
  seal = function seal(x) {
    return x;
  };
}
if (!apply) {
  apply = function apply(fun, thisValue, args) {
    return fun.apply(thisValue, args);
  };
}
if (!construct) {
  construct = function construct(Func, args) {
    return new Func(...args);
  };
}
const arrayForEach = unapply(Array.prototype.forEach);
const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
const arrayPop = unapply(Array.prototype.pop);
const arrayPush = unapply(Array.prototype.push);
const arraySplice = unapply(Array.prototype.splice);
const stringToLowerCase = unapply(String.prototype.toLowerCase);
const stringToString = unapply(String.prototype.toString);
const stringMatch = unapply(String.prototype.match);
const stringReplace = unapply(String.prototype.replace);
const stringIndexOf = unapply(String.prototype.indexOf);
const stringTrim = unapply(String.prototype.trim);
const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
const regExpTest = unapply(RegExp.prototype.test);
const typeErrorCreate = unconstruct(TypeError);
/**
 * Creates a new function that calls the given function with a specified thisArg and arguments.
 *
 * @param func - The function to be wrapped and called.
 * @returns A new function that calls the given function with a specified thisArg and arguments.
 */
function unapply(func) {
  return function (thisArg) {
    if (thisArg instanceof RegExp) {
      thisArg.lastIndex = 0;
    }
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return apply(func, thisArg, args);
  };
}
/**
 * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
 *
 * @param func - The constructor function to be wrapped and called.
 * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
 */
function unconstruct(func) {
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return construct(func, args);
  };
}
/**
 * Add properties to a lookup table
 *
 * @param set - The set to which elements will be added.
 * @param array - The array containing elements to be added to the set.
 * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
 * @returns The modified set with added elements.
 */
function addToSet(set, array) {
  let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
  if (setPrototypeOf) {
    // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    setPrototypeOf(set, null);
  }
  let l = array.length;
  while (l--) {
    let element = array[l];
    if (typeof element === 'string') {
      const lcElement = transformCaseFunc(element);
      if (lcElement !== element) {
        // Config presets (e.g. tags.js, attrs.js) are immutable.
        if (!isFrozen(array)) {
          array[l] = lcElement;
        }
        element = lcElement;
      }
    }
    set[element] = true;
  }
  return set;
}
/**
 * Clean up an array to harden against CSPP
 *
 * @param array - The array to be cleaned.
 * @returns The cleaned version of the array
 */
function cleanArray(array) {
  for (let index = 0; index < array.length; index++) {
    const isPropertyExist = objectHasOwnProperty(array, index);
    if (!isPropertyExist) {
      array[index] = null;
    }
  }
  return array;
}
/**
 * Shallow clone an object
 *
 * @param object - The object to be cloned.
 * @returns A new object that copies the original.
 */
function clone(object) {
  const newObject = create(null);
  for (const [property, value] of entries(object)) {
    const isPropertyExist = objectHasOwnProperty(object, property);
    if (isPropertyExist) {
      if (Array.isArray(value)) {
        newObject[property] = cleanArray(value);
      } else if (value && typeof value === 'object' && value.constructor === Object) {
        newObject[property] = clone(value);
      } else {
        newObject[property] = value;
      }
    }
  }
  return newObject;
}
/**
 * This method automatically checks if the prop is function or getter and behaves accordingly.
 *
 * @param object - The object to look up the getter function in its prototype chain.
 * @param prop - The property name for which to find the getter function.
 * @returns The getter function found in the prototype chain or a fallback function.
 */
function lookupGetter(object, prop) {
  while (object !== null) {
    const desc = getOwnPropertyDescriptor(object, prop);
    if (desc) {
      if (desc.get) {
        return unapply(desc.get);
      }
      if (typeof desc.value === 'function') {
        return unapply(desc.value);
      }
    }
    object = getPrototypeOf(object);
  }
  function fallbackValue() {
    return null;
  }
  return fallbackValue;
}
const html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);
const svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
const svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feDropShadow', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);
// List of SVG elements that are disallowed by default.
// We still need to know them so that we can do namespace
// checks properly in case one wants to add them to
// allow-list.
const svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
const mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover', 'mprescripts']);
// Similarly to SVG, we want to know all MathML elements,
// even those that we disallow by default.
const mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
const text = freeze(['#text']);
const html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'popover', 'popovertarget', 'popovertargetaction', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'wrap', 'xmlns', 'slot']);
const svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'amplitude', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'exponent', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'intercept', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'slope', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'tablevalues', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
const mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
const xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

// eslint-disable-next-line unicorn/better-regex
const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
);
const DOCTYPE_NAME = seal(/^html$/i);
const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
var EXPRESSIONS = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ARIA_ATTR: ARIA_ATTR,
  ATTR_WHITESPACE: ATTR_WHITESPACE,
  CUSTOM_ELEMENT: CUSTOM_ELEMENT,
  DATA_ATTR: DATA_ATTR,
  DOCTYPE_NAME: DOCTYPE_NAME,
  ERB_EXPR: ERB_EXPR,
  IS_ALLOWED_URI: IS_ALLOWED_URI,
  IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
  MUSTACHE_EXPR: MUSTACHE_EXPR,
  TMPLIT_EXPR: TMPLIT_EXPR
});

/* eslint-disable @typescript-eslint/indent */
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
const NODE_TYPE = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12 // Deprecated
};
const getGlobal = function getGlobal() {
  return typeof window === 'undefined' ? null : window;
};
/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param trustedTypes The policy factory.
 * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
 * @return The policy created (or null, if Trusted Types
 * are not supported or creating the policy failed).
 */
const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
  if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
    return null;
  }
  // Allow the callers to control the unique policy name
  // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
  // Policy creation with duplicate names throws in Trusted Types.
  let suffix = null;
  const ATTR_NAME = 'data-tt-policy-suffix';
  if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) {
    suffix = purifyHostElement.getAttribute(ATTR_NAME);
  }
  const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
  try {
    return trustedTypes.createPolicy(policyName, {
      createHTML(html) {
        return html;
      },
      createScriptURL(scriptUrl) {
        return scriptUrl;
      }
    });
  } catch (_) {
    // Policy creation failed (most likely another DOMPurify script has
    // already run). Skip creating the policy, as this will only cause errors
    // if TT are enforced.
    console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
    return null;
  }
};
const _createHooksMap = function _createHooksMap() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function createDOMPurify() {
  let window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
  const DOMPurify = root => createDOMPurify(root);
  DOMPurify.version = '3.2.6';
  DOMPurify.removed = [];
  if (!window || !window.document || window.document.nodeType !== NODE_TYPE.document || !window.Element) {
    // Not running in a browser, provide a factory function
    // so that you can pass your own Window
    DOMPurify.isSupported = false;
    return DOMPurify;
  }
  let {
    document
  } = window;
  const originalDocument = document;
  const currentScript = originalDocument.currentScript;
  const {
    DocumentFragment,
    HTMLTemplateElement,
    Node,
    Element,
    NodeFilter,
    NamedNodeMap = window.NamedNodeMap || window.MozNamedAttrMap,
    HTMLFormElement,
    DOMParser,
    trustedTypes
  } = window;
  const ElementPrototype = Element.prototype;
  const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
  const remove = lookupGetter(ElementPrototype, 'remove');
  const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
  const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
  const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
  // As per issue #47, the web-components registry is inherited by a
  // new document created via createHTMLDocument. As per the spec
  // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
  // a new empty registry is used when creating a template contents owner
  // document, so we use that as our parent document to ensure nothing
  // is inherited.
  if (typeof HTMLTemplateElement === 'function') {
    const template = document.createElement('template');
    if (template.content && template.content.ownerDocument) {
      document = template.content.ownerDocument;
    }
  }
  let trustedTypesPolicy;
  let emptyHTML = '';
  const {
    implementation,
    createNodeIterator,
    createDocumentFragment,
    getElementsByTagName
  } = document;
  const {
    importNode
  } = originalDocument;
  let hooks = _createHooksMap();
  /**
   * Expose whether this browser supports running the full DOMPurify.
   */
  DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
  const {
    MUSTACHE_EXPR,
    ERB_EXPR,
    TMPLIT_EXPR,
    DATA_ATTR,
    ARIA_ATTR,
    IS_SCRIPT_OR_DATA,
    ATTR_WHITESPACE,
    CUSTOM_ELEMENT
  } = EXPRESSIONS;
  let {
    IS_ALLOWED_URI: IS_ALLOWED_URI$1
  } = EXPRESSIONS;
  /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */
  /* allowed element names */
  let ALLOWED_TAGS = null;
  const DEFAULT_ALLOWED_TAGS = addToSet({}, [...html$1, ...svg$1, ...svgFilters, ...mathMl$1, ...text]);
  /* Allowed attribute names */
  let ALLOWED_ATTR = null;
  const DEFAULT_ALLOWED_ATTR = addToSet({}, [...html, ...svg, ...mathMl, ...xml]);
  /*
   * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
   * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
   * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
   * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
   */
  let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
    tagNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    attributeNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: false
    }
  }));
  /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
  let FORBID_TAGS = null;
  /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
  let FORBID_ATTR = null;
  /* Decide if ARIA attributes are okay */
  let ALLOW_ARIA_ATTR = true;
  /* Decide if custom data attributes are okay */
  let ALLOW_DATA_ATTR = true;
  /* Decide if unknown protocols are okay */
  let ALLOW_UNKNOWN_PROTOCOLS = false;
  /* Decide if self-closing tags in attributes are allowed.
   * Usually removed due to a mXSS issue in jQuery 3.0 */
  let ALLOW_SELF_CLOSE_IN_ATTR = true;
  /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */
  let SAFE_FOR_TEMPLATES = false;
  /* Output should be safe even for XML used within HTML and alike.
   * This means, DOMPurify removes comments when containing risky content.
   */
  let SAFE_FOR_XML = true;
  /* Decide if document with <html>... should be returned */
  let WHOLE_DOCUMENT = false;
  /* Track whether config is already set on this instance of DOMPurify. */
  let SET_CONFIG = false;
  /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */
  let FORCE_BODY = false;
  /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */
  let RETURN_DOM = false;
  /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */
  let RETURN_DOM_FRAGMENT = false;
  /* Try to return a Trusted Type object instead of a string, return a string in
   * case Trusted Types are not supported  */
  let RETURN_TRUSTED_TYPE = false;
  /* Output should be free from DOM clobbering attacks?
   * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
   */
  let SANITIZE_DOM = true;
  /* Achieve full DOM Clobbering protection by isolating the namespace of named
   * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
   *
   * HTML/DOM spec rules that enable DOM Clobbering:
   *   - Named Access on Window (§7.3.3)
   *   - DOM Tree Accessors (§3.1.5)
   *   - Form Element Parent-Child Relations (§4.10.3)
   *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
   *   - HTMLCollection (§4.2.10.2)
   *
   * Namespace isolation is implemented by prefixing `id` and `name` attributes
   * with a constant string, i.e., `user-content-`
   */
  let SANITIZE_NAMED_PROPS = false;
  const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
  /* Keep element content when removing element? */
  let KEEP_CONTENT = true;
  /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */
  let IN_PLACE = false;
  /* Allow usage of profiles like html, svg and mathMl */
  let USE_PROFILES = {};
  /* Tags to ignore content of when KEEP_CONTENT is true */
  let FORBID_CONTENTS = null;
  const DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
  /* Tags that are safe for data: URIs */
  let DATA_URI_TAGS = null;
  const DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
  /* Attributes safe for values like "javascript:" */
  let URI_SAFE_ATTRIBUTES = null;
  const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
  const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
  const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
  const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
  /* Document namespace */
  let NAMESPACE = HTML_NAMESPACE;
  let IS_EMPTY_INPUT = false;
  /* Allowed XHTML+XML namespaces */
  let ALLOWED_NAMESPACES = null;
  const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
  let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
  let HTML_INTEGRATION_POINTS = addToSet({}, ['annotation-xml']);
  // Certain elements are allowed in both SVG and HTML
  // namespace. We need to specify them explicitly
  // so that they don't get erroneously deleted from
  // HTML namespace.
  const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
  /* Parsing of strict XHTML documents */
  let PARSER_MEDIA_TYPE = null;
  const SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
  const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
  let transformCaseFunc = null;
  /* Keep a reference to config to pass to hooks */
  let CONFIG = null;
  /* Ideally, do not touch anything below this line */
  /* ______________________________________________ */
  const formElement = document.createElement('form');
  const isRegexOrFunction = function isRegexOrFunction(testValue) {
    return testValue instanceof RegExp || testValue instanceof Function;
  };
  /**
   * _parseConfig
   *
   * @param cfg optional config literal
   */
  // eslint-disable-next-line complexity
  const _parseConfig = function _parseConfig() {
    let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (CONFIG && CONFIG === cfg) {
      return;
    }
    /* Shield configuration object from tampering */
    if (!cfg || typeof cfg !== 'object') {
      cfg = {};
    }
    /* Shield configuration object from prototype pollution */
    cfg = clone(cfg);
    PARSER_MEDIA_TYPE =
    // eslint-disable-next-line unicorn/prefer-includes
    SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
    // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
    transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
    /* Set configuration parameters */
    ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
    ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
    ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
    URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
    DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
    FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
    FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : clone({});
    FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : clone({});
    USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
    ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
    ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
    ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
    ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
    SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
    SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
    WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
    RETURN_DOM = cfg.RETURN_DOM || false; // Default false
    RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
    RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
    FORCE_BODY = cfg.FORCE_BODY || false; // Default false
    SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
    SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
    KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
    IN_PLACE = cfg.IN_PLACE || false; // Default false
    IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
    NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
    MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
    HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
    CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
    if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
    }
    if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
    }
    if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
      CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
    }
    if (SAFE_FOR_TEMPLATES) {
      ALLOW_DATA_ATTR = false;
    }
    if (RETURN_DOM_FRAGMENT) {
      RETURN_DOM = true;
    }
    /* Parse profile info */
    if (USE_PROFILES) {
      ALLOWED_TAGS = addToSet({}, text);
      ALLOWED_ATTR = [];
      if (USE_PROFILES.html === true) {
        addToSet(ALLOWED_TAGS, html$1);
        addToSet(ALLOWED_ATTR, html);
      }
      if (USE_PROFILES.svg === true) {
        addToSet(ALLOWED_TAGS, svg$1);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.svgFilters === true) {
        addToSet(ALLOWED_TAGS, svgFilters);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.mathMl === true) {
        addToSet(ALLOWED_TAGS, mathMl$1);
        addToSet(ALLOWED_ATTR, mathMl);
        addToSet(ALLOWED_ATTR, xml);
      }
    }
    /* Merge configuration parameters */
    if (cfg.ADD_TAGS) {
      if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
        ALLOWED_TAGS = clone(ALLOWED_TAGS);
      }
      addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
    }
    if (cfg.ADD_ATTR) {
      if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
        ALLOWED_ATTR = clone(ALLOWED_ATTR);
      }
      addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
    }
    if (cfg.ADD_URI_SAFE_ATTR) {
      addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
    }
    if (cfg.FORBID_CONTENTS) {
      if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
        FORBID_CONTENTS = clone(FORBID_CONTENTS);
      }
      addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
    }
    /* Add #text in case KEEP_CONTENT is set to true */
    if (KEEP_CONTENT) {
      ALLOWED_TAGS['#text'] = true;
    }
    /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
    if (WHOLE_DOCUMENT) {
      addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
    }
    /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
    if (ALLOWED_TAGS.table) {
      addToSet(ALLOWED_TAGS, ['tbody']);
      delete FORBID_TAGS.tbody;
    }
    if (cfg.TRUSTED_TYPES_POLICY) {
      if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      }
      if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      }
      // Overwrite existing TrustedTypes policy.
      trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
      // Sign local variables required by `sanitize`.
      emptyHTML = trustedTypesPolicy.createHTML('');
    } else {
      // Uninitialized policy, attempt to initialize the internal dompurify policy.
      if (trustedTypesPolicy === undefined) {
        trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
      }
      // If creating the internal policy succeeded sign internal variables.
      if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') {
        emptyHTML = trustedTypesPolicy.createHTML('');
      }
    }
    // Prevent further manipulation of configuration.
    // Not available in IE8, Safari 5, etc.
    if (freeze) {
      freeze(cfg);
    }
    CONFIG = cfg;
  };
  /* Keep track of all possible SVG and MathML tags
   * so that we can perform the namespace checks
   * correctly. */
  const ALL_SVG_TAGS = addToSet({}, [...svg$1, ...svgFilters, ...svgDisallowed]);
  const ALL_MATHML_TAGS = addToSet({}, [...mathMl$1, ...mathMlDisallowed]);
  /**
   * @param element a DOM element whose namespace is being checked
   * @returns Return false if the element has a
   *  namespace that a spec-compliant parser would never
   *  return. Return true otherwise.
   */
  const _checkValidNamespace = function _checkValidNamespace(element) {
    let parent = getParentNode(element);
    // In JSDOM, if we're inside shadow DOM, then parentNode
    // can be null. We just simulate parent in this case.
    if (!parent || !parent.tagName) {
      parent = {
        namespaceURI: NAMESPACE,
        tagName: 'template'
      };
    }
    const tagName = stringToLowerCase(element.tagName);
    const parentTagName = stringToLowerCase(parent.tagName);
    if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
      return false;
    }
    if (element.namespaceURI === SVG_NAMESPACE) {
      // The only way to switch from HTML namespace to SVG
      // is via <svg>. If it happens via any other tag, then
      // it should be killed.
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === 'svg';
      }
      // The only way to switch from MathML to SVG is via`
      // svg if parent is either <annotation-xml> or MathML
      // text integration points.
      if (parent.namespaceURI === MATHML_NAMESPACE) {
        return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
      }
      // We only allow elements that are defined in SVG
      // spec. All others are disallowed in SVG namespace.
      return Boolean(ALL_SVG_TAGS[tagName]);
    }
    if (element.namespaceURI === MATHML_NAMESPACE) {
      // The only way to switch from HTML namespace to MathML
      // is via <math>. If it happens via any other tag, then
      // it should be killed.
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === 'math';
      }
      // The only way to switch from SVG to MathML is via
      // <math> and HTML integration points
      if (parent.namespaceURI === SVG_NAMESPACE) {
        return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
      }
      // We only allow elements that are defined in MathML
      // spec. All others are disallowed in MathML namespace.
      return Boolean(ALL_MATHML_TAGS[tagName]);
    }
    if (element.namespaceURI === HTML_NAMESPACE) {
      // The only way to switch from SVG to HTML is via
      // HTML integration points, and from MathML to HTML
      // is via MathML text integration points
      if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
        return false;
      }
      if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
        return false;
      }
      // We disallow tags that are specific for MathML
      // or SVG and should never appear in HTML namespace
      return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
    }
    // For XHTML and XML documents that support custom namespaces
    if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
      return true;
    }
    // The code should never reach this place (this means
    // that the element somehow got namespace that is not
    // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
    // Return false just in case.
    return false;
  };
  /**
   * _forceRemove
   *
   * @param node a DOM node
   */
  const _forceRemove = function _forceRemove(node) {
    arrayPush(DOMPurify.removed, {
      element: node
    });
    try {
      // eslint-disable-next-line unicorn/prefer-dom-node-remove
      getParentNode(node).removeChild(node);
    } catch (_) {
      remove(node);
    }
  };
  /**
   * _removeAttribute
   *
   * @param name an Attribute name
   * @param element a DOM node
   */
  const _removeAttribute = function _removeAttribute(name, element) {
    try {
      arrayPush(DOMPurify.removed, {
        attribute: element.getAttributeNode(name),
        from: element
      });
    } catch (_) {
      arrayPush(DOMPurify.removed, {
        attribute: null,
        from: element
      });
    }
    element.removeAttribute(name);
    // We void attribute values for unremovable "is" attributes
    if (name === 'is') {
      if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
        try {
          _forceRemove(element);
        } catch (_) {}
      } else {
        try {
          element.setAttribute(name, '');
        } catch (_) {}
      }
    }
  };
  /**
   * _initDocument
   *
   * @param dirty - a string of dirty markup
   * @return a DOM, filled with the dirty markup
   */
  const _initDocument = function _initDocument(dirty) {
    /* Create a HTML document */
    let doc = null;
    let leadingWhitespace = null;
    if (FORCE_BODY) {
      dirty = '<remove></remove>' + dirty;
    } else {
      /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
      const matches = stringMatch(dirty, /^[\r\n\t ]+/);
      leadingWhitespace = matches && matches[0];
    }
    if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
      // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
      dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
    }
    const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
    /*
     * Use the DOMParser API by default, fallback later if needs be
     * DOMParser not work for svg when has multiple root element.
     */
    if (NAMESPACE === HTML_NAMESPACE) {
      try {
        doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
      } catch (_) {}
    }
    /* Use createHTMLDocument in case DOMParser is not available */
    if (!doc || !doc.documentElement) {
      doc = implementation.createDocument(NAMESPACE, 'template', null);
      try {
        doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
      } catch (_) {
        // Syntax error if dirtyPayload is invalid xml
      }
    }
    const body = doc.body || doc.documentElement;
    if (dirty && leadingWhitespace) {
      body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
    }
    /* Work on whole document or just its body */
    if (NAMESPACE === HTML_NAMESPACE) {
      return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
    }
    return WHOLE_DOCUMENT ? doc.documentElement : body;
  };
  /**
   * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
   *
   * @param root The root element or node to start traversing on.
   * @return The created NodeIterator
   */
  const _createNodeIterator = function _createNodeIterator(root) {
    return createNodeIterator.call(root.ownerDocument || root, root,
    // eslint-disable-next-line no-bitwise
    NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
  };
  /**
   * _isClobbered
   *
   * @param element element to check for clobbering attacks
   * @return true if clobbered, false if safe
   */
  const _isClobbered = function _isClobbered(element) {
    return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
  };
  /**
   * Checks whether the given object is a DOM node.
   *
   * @param value object to check whether it's a DOM node
   * @return true is object is a DOM node
   */
  const _isNode = function _isNode(value) {
    return typeof Node === 'function' && value instanceof Node;
  };
  function _executeHooks(hooks, currentNode, data) {
    arrayForEach(hooks, hook => {
      hook.call(DOMPurify, currentNode, data, CONFIG);
    });
  }
  /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   * @param currentNode to check for permission to exist
   * @return true if node was killed, false if left alive
   */
  const _sanitizeElements = function _sanitizeElements(currentNode) {
    let content = null;
    /* Execute a hook if present */
    _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
    /* Check if element is clobbered or can clobber */
    if (_isClobbered(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Now let's check the element's type and name */
    const tagName = transformCaseFunc(currentNode.nodeName);
    /* Execute a hook if present */
    _executeHooks(hooks.uponSanitizeElement, currentNode, {
      tagName,
      allowedTags: ALLOWED_TAGS
    });
    /* Detect mXSS attempts abusing namespace confusion */
    if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Remove any occurrence of processing instructions */
    if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
      _forceRemove(currentNode);
      return true;
    }
    /* Remove any kind of possibly harmful comments */
    if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Remove element if anything forbids its presence */
    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
      /* Check if we have a custom element to handle */
      if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) {
          return false;
        }
        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) {
          return false;
        }
      }
      /* Keep content except for bad-listed elements */
      if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
        const parentNode = getParentNode(currentNode) || currentNode.parentNode;
        const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
        if (childNodes && parentNode) {
          const childCount = childNodes.length;
          for (let i = childCount - 1; i >= 0; --i) {
            const childClone = cloneNode(childNodes[i], true);
            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
            parentNode.insertBefore(childClone, getNextSibling(currentNode));
          }
        }
      }
      _forceRemove(currentNode);
      return true;
    }
    /* Check whether element has a valid namespace */
    if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Make sure that older browsers don't get fallback-tag mXSS */
    if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Sanitize element content to be template-safe */
    if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
      /* Get the element's text content */
      content = currentNode.textContent;
      arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
        content = stringReplace(content, expr, ' ');
      });
      if (currentNode.textContent !== content) {
        arrayPush(DOMPurify.removed, {
          element: currentNode.cloneNode()
        });
        currentNode.textContent = content;
      }
    }
    /* Execute a hook if present */
    _executeHooks(hooks.afterSanitizeElements, currentNode, null);
    return false;
  };
  /**
   * _isValidAttribute
   *
   * @param lcTag Lowercase tag name of containing element.
   * @param lcName Lowercase attribute name.
   * @param value Attribute value.
   * @return Returns true if `value` is valid, otherwise false.
   */
  // eslint-disable-next-line complexity
  const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
    /* Make sure attribute cannot clobber */
    if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
      return false;
    }
    /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */
    if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
      if (
      // First condition does a very basic check if a) it's basically a valid custom element tagname AND
      // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
      // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
      _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) ||
      // Alternative, second condition checks if it's an `is`-attribute, AND
      // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
      lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;else {
        return false;
      }
      /* Check value is safe. First, is attr inert? If so, is safe */
    } else if (URI_SAFE_ATTRIBUTES[lcName]) ;else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ;else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ;else if (value) {
      return false;
    } else ;
    return true;
  };
  /**
   * _isBasicCustomElement
   * checks if at least one dash is included in tagName, and it's not the first char
   * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
   *
   * @param tagName name of the tag of the node to sanitize
   * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
   */
  const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
    return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
  };
  /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param currentNode to sanitize
   */
  const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
    /* Execute a hook if present */
    _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
    const {
      attributes
    } = currentNode;
    /* Check if we have attributes; if not we might have a text node */
    if (!attributes || _isClobbered(currentNode)) {
      return;
    }
    const hookEvent = {
      attrName: '',
      attrValue: '',
      keepAttr: true,
      allowedAttributes: ALLOWED_ATTR,
      forceKeepAttr: undefined
    };
    let l = attributes.length;
    /* Go backwards over all attributes; safely remove bad ones */
    while (l--) {
      const attr = attributes[l];
      const {
        name,
        namespaceURI,
        value: attrValue
      } = attr;
      const lcName = transformCaseFunc(name);
      const initValue = attrValue;
      let value = name === 'value' ? initValue : stringTrim(initValue);
      /* Execute a hook if present */
      hookEvent.attrName = lcName;
      hookEvent.attrValue = value;
      hookEvent.keepAttr = true;
      hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
      _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
      value = hookEvent.attrValue;
      /* Full DOM Clobbering protection via namespace isolation,
       * Prefix id and name attributes with `user-content-`
       */
      if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
        // Remove the attribute with this value
        _removeAttribute(name, currentNode);
        // Prefix the value and later re-create the attribute with the sanitized value
        value = SANITIZE_NAMED_PROPS_PREFIX + value;
      }
      /* Work around a security issue with comments inside attributes */
      if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      /* Did the hooks approve of the attribute? */
      if (hookEvent.forceKeepAttr) {
        continue;
      }
      /* Did the hooks approve of the attribute? */
      if (!hookEvent.keepAttr) {
        _removeAttribute(name, currentNode);
        continue;
      }
      /* Work around a security issue in jQuery 3.0 */
      if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      /* Sanitize attribute content to be template-safe */
      if (SAFE_FOR_TEMPLATES) {
        arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
          value = stringReplace(value, expr, ' ');
        });
      }
      /* Is `value` valid for this attribute? */
      const lcTag = transformCaseFunc(currentNode.nodeName);
      if (!_isValidAttribute(lcTag, lcName, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      /* Handle attributes that require Trusted Types */
      if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
        if (namespaceURI) ;else {
          switch (trustedTypes.getAttributeType(lcTag, lcName)) {
            case 'TrustedHTML':
              {
                value = trustedTypesPolicy.createHTML(value);
                break;
              }
            case 'TrustedScriptURL':
              {
                value = trustedTypesPolicy.createScriptURL(value);
                break;
              }
          }
        }
      }
      /* Handle invalid data-* attribute set by try-catching it */
      if (value !== initValue) {
        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }
          if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
          } else {
            arrayPop(DOMPurify.removed);
          }
        } catch (_) {
          _removeAttribute(name, currentNode);
        }
      }
    }
    /* Execute a hook if present */
    _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
  };
  /**
   * _sanitizeShadowDOM
   *
   * @param fragment to iterate over recursively
   */
  const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
    let shadowNode = null;
    const shadowIterator = _createNodeIterator(fragment);
    /* Execute a hook if present */
    _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
    while (shadowNode = shadowIterator.nextNode()) {
      /* Execute a hook if present */
      _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
      /* Sanitize tags and elements */
      _sanitizeElements(shadowNode);
      /* Check attributes next */
      _sanitizeAttributes(shadowNode);
      /* Deep shadow DOM detected */
      if (shadowNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(shadowNode.content);
      }
    }
    /* Execute a hook if present */
    _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
  };
  // eslint-disable-next-line complexity
  DOMPurify.sanitize = function (dirty) {
    let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let body = null;
    let importedNode = null;
    let currentNode = null;
    let returnNode = null;
    /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */
    IS_EMPTY_INPUT = !dirty;
    if (IS_EMPTY_INPUT) {
      dirty = '<!-->';
    }
    /* Stringify, in case dirty is an object */
    if (typeof dirty !== 'string' && !_isNode(dirty)) {
      if (typeof dirty.toString === 'function') {
        dirty = dirty.toString();
        if (typeof dirty !== 'string') {
          throw typeErrorCreate('dirty is not a string, aborting');
        }
      } else {
        throw typeErrorCreate('toString is not a function');
      }
    }
    /* Return dirty HTML if DOMPurify cannot run */
    if (!DOMPurify.isSupported) {
      return dirty;
    }
    /* Assign config vars */
    if (!SET_CONFIG) {
      _parseConfig(cfg);
    }
    /* Clean up removed elements */
    DOMPurify.removed = [];
    /* Check if dirty is correctly typed for IN_PLACE */
    if (typeof dirty === 'string') {
      IN_PLACE = false;
    }
    if (IN_PLACE) {
      /* Do some early pre-sanitization to avoid unsafe root nodes */
      if (dirty.nodeName) {
        const tagName = transformCaseFunc(dirty.nodeName);
        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
          throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
        }
      }
    } else if (dirty instanceof Node) {
      /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */
      body = _initDocument('<!---->');
      importedNode = body.ownerDocument.importNode(dirty, true);
      if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') {
        /* Node is already a body, use as is */
        body = importedNode;
      } else if (importedNode.nodeName === 'HTML') {
        body = importedNode;
      } else {
        // eslint-disable-next-line unicorn/prefer-dom-node-append
        body.appendChild(importedNode);
      }
    } else {
      /* Exit directly if we have nothing to do */
      if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
      // eslint-disable-next-line unicorn/prefer-includes
      dirty.indexOf('<') === -1) {
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
      }
      /* Initialize the document to work on */
      body = _initDocument(dirty);
      /* Check we have a DOM node from the data */
      if (!body) {
        return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
      }
    }
    /* Remove first element node (ours) if FORCE_BODY is set */
    if (body && FORCE_BODY) {
      _forceRemove(body.firstChild);
    }
    /* Get node iterator */
    const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
    /* Now start iterating over the created document */
    while (currentNode = nodeIterator.nextNode()) {
      /* Sanitize tags and elements */
      _sanitizeElements(currentNode);
      /* Check attributes next */
      _sanitizeAttributes(currentNode);
      /* Shadow DOM detected, sanitize it */
      if (currentNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(currentNode.content);
      }
    }
    /* If we sanitized `dirty` in-place, return it. */
    if (IN_PLACE) {
      return dirty;
    }
    /* Return sanitized string or DOM */
    if (RETURN_DOM) {
      if (RETURN_DOM_FRAGMENT) {
        returnNode = createDocumentFragment.call(body.ownerDocument);
        while (body.firstChild) {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          returnNode.appendChild(body.firstChild);
        }
      } else {
        returnNode = body;
      }
      if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) {
        /*
          AdoptNode() is not used because internal state is not reset
          (e.g. the past names map of a HTMLFormElement), this is safe
          in theory but we would rather not risk another attack vector.
          The state that is cloned by importNode() is explicitly defined
          by the specs.
        */
        returnNode = importNode.call(originalDocument, returnNode, true);
      }
      return returnNode;
    }
    let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
    /* Serialize doctype if allowed */
    if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
      serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
    }
    /* Sanitize final string template-safe */
    if (SAFE_FOR_TEMPLATES) {
      arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
        serializedHTML = stringReplace(serializedHTML, expr, ' ');
      });
    }
    return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
  };
  DOMPurify.setConfig = function () {
    let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _parseConfig(cfg);
    SET_CONFIG = true;
  };
  DOMPurify.clearConfig = function () {
    CONFIG = null;
    SET_CONFIG = false;
  };
  DOMPurify.isValidAttribute = function (tag, attr, value) {
    /* Initialize shared config vars if necessary. */
    if (!CONFIG) {
      _parseConfig({});
    }
    const lcTag = transformCaseFunc(tag);
    const lcName = transformCaseFunc(attr);
    return _isValidAttribute(lcTag, lcName, value);
  };
  DOMPurify.addHook = function (entryPoint, hookFunction) {
    if (typeof hookFunction !== 'function') {
      return;
    }
    arrayPush(hooks[entryPoint], hookFunction);
  };
  DOMPurify.removeHook = function (entryPoint, hookFunction) {
    if (hookFunction !== undefined) {
      const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
      return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
    }
    return arrayPop(hooks[entryPoint]);
  };
  DOMPurify.removeHooks = function (entryPoint) {
    hooks[entryPoint] = [];
  };
  DOMPurify.removeAllHooks = function () {
    hooks = _createHooksMap();
  };
  return DOMPurify;
}
var purify = createDOMPurify();


/***/ }),

/***/ 30606:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QE": function() { return /* binding */ pn; },
/* harmony export */   "aS": function() { return /* binding */ cn; },
/* harmony export */   "mv": function() { return /* binding */ r; },
/* harmony export */   "o$": function() { return /* binding */ t; },
/* harmony export */   "pV": function() { return /* binding */ F; },
/* harmony export */   "vI": function() { return /* binding */ T; }
/* harmony export */ });
/* unused harmony exports Immer, castDraft, castImmutable, createDraft, current, enableAllPlugins, enableMapSet, finishDraft, freeze, immerable, nothing, original, produce, setAutoFreeze, setUseProxies */
function n(n) {
  for (var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++) t[e - 1] = arguments[e];
  if (false) { var i, o; }
  throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function (n) {
    return "'" + n + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
  return !!n && !!n[Q];
}
function t(n) {
  var r;
  return !!n && (function (n) {
    if (!n || "object" != typeof n) return !1;
    var r = Object.getPrototypeOf(n);
    if (null === r) return !0;
    var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
    return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
  }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
  return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
  void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function (e) {
    t && "symbol" == typeof e || r(e, n[e], n);
  }) : n.forEach(function (t, e) {
    return r(e, t, n);
  });
}
function o(n) {
  var r = n[Q];
  return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
  return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
  return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
  var e = o(n);
  2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
  return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
  return X && n instanceof Map;
}
function v(n) {
  return q && n instanceof Set;
}
function p(n) {
  return n.o || n.t;
}
function l(n) {
  if (Array.isArray(n)) return Array.prototype.slice.call(n);
  var r = rn(n);
  delete r[Q];
  for (var t = nn(r), e = 0; e < t.length; e++) {
    var i = t[e],
      o = r[i];
    !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
      configurable: !0,
      writable: !0,
      enumerable: o.enumerable,
      value: n[i]
    });
  }
  return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
  return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function (n, r) {
    return d(r, !0);
  }, !0)), n;
}
function h() {
  n(2);
}
function y(n) {
  return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
  var t = tn[r];
  return t || n(18, r), t;
}
function m(n, r) {
  tn[n] || (tn[n] = r);
}
function _() {
  return  true || 0, U;
}
function j(n, r) {
  r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
  O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
  n === U && (U = n.l);
}
function w(n) {
  return U = {
    p: [],
    l: U,
    h: n,
    m: !0,
    _: 0
  };
}
function S(n) {
  var r = n[Q];
  0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
  e._ = e.p.length;
  var i = e.p[0],
    o = void 0 !== r && r !== i;
  return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
  if (y(r)) return r;
  var e = r[Q];
  if (!e) return i(r, function (i, o) {
    return A(n, e, r, i, o, t);
  }, !0), r;
  if (e.A !== n) return r;
  if (!e.P) return x(n, e.t, !0), e.t;
  if (!e.I) {
    e.I = !0, e.A._--;
    var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o,
      u = o,
      a = !1;
    3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function (r, i) {
      return A(n, e, o, r, i, t, a);
    }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
  }
  return e.o;
}
function A(e, i, o, a, c, s, v) {
  if ( false && 0, r(c)) {
    var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
    if (f(o, a, p), !r(p)) return;
    e.m = !1;
  } else v && o.add(c);
  if (t(c) && !y(c)) {
    if (!e.h.D && e._ < 1) return;
    M(e, c), i && i.A.l || x(e, c);
  }
}
function x(n, r, t) {
  void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
  var t = n[Q];
  return (t ? p(t) : n)[r];
}
function I(n, r) {
  if (r in n) for (var t = Object.getPrototypeOf(n); t;) {
    var e = Object.getOwnPropertyDescriptor(t, r);
    if (e) return e;
    t = Object.getPrototypeOf(t);
  }
}
function k(n) {
  n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
  n.o || (n.o = l(n.t));
}
function N(n, r, t) {
  var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function (n, r) {
    var t = Array.isArray(n),
      e = {
        i: t ? 1 : 0,
        A: r ? r.A : _(),
        P: !1,
        I: !1,
        R: {},
        l: r,
        t: n,
        k: null,
        o: null,
        j: null,
        C: !1
      },
      i = e,
      o = en;
    t && (i = [e], o = on);
    var u = Proxy.revocable(i, o),
      a = u.revoke,
      f = u.proxy;
    return e.k = f, e.j = a, f;
  }(r, t) : b("ES5").J(r, t);
  return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
  return r(e) || n(22, e), function n(r) {
    if (!t(r)) return r;
    var e,
      u = r[Q],
      c = o(r);
    if (u) {
      if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
      u.I = !0, e = D(r, c), u.I = !1;
    } else e = D(r, c);
    return i(e, function (r, t) {
      u && a(u.t, r) === t || f(e, r, n(t));
    }), 3 === c ? new Set(e) : e;
  }(e);
}
function D(n, r) {
  switch (r) {
    case 2:
      return new Map(n);
    case 3:
      return Array.from(n);
  }
  return l(n);
}
function F() {
  function t(n, r) {
    var t = s[n];
    return t ? t.enumerable = r : s[n] = t = {
      configurable: !0,
      enumerable: r,
      get: function () {
        var r = this[Q];
        return  false && 0, en.get(r, n);
      },
      set: function (r) {
        var t = this[Q];
         false && 0, en.set(t, n, r);
      }
    }, t;
  }
  function e(n) {
    for (var r = n.length - 1; r >= 0; r--) {
      var t = n[r][Q];
      if (!t.P) switch (t.i) {
        case 5:
          a(t) && k(t);
          break;
        case 4:
          o(t) && k(t);
      }
    }
  }
  function o(n) {
    for (var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--) {
      var o = e[i];
      if (o !== Q) {
        var a = r[o];
        if (void 0 === a && !u(r, o)) return !0;
        var f = t[o],
          s = f && f[Q];
        if (s ? s.t !== a : !c(f, a)) return !0;
      }
    }
    var v = !!r[Q];
    return e.length !== nn(r).length + (v ? 0 : 1);
  }
  function a(n) {
    var r = n.k;
    if (r.length !== n.t.length) return !0;
    var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
    if (t && !t.get) return !0;
    for (var e = 0; e < r.length; e++) if (!r.hasOwnProperty(e)) return !0;
    return !1;
  }
  function f(r) {
    r.g && n(3, JSON.stringify(p(r)));
  }
  var s = {};
  m("ES5", {
    J: function (n, r) {
      var e = Array.isArray(n),
        i = function (n, r) {
          if (n) {
            for (var e = Array(r.length), i = 0; i < r.length; i++) Object.defineProperty(e, "" + i, t(i, !0));
            return e;
          }
          var o = rn(r);
          delete o[Q];
          for (var u = nn(o), a = 0; a < u.length; a++) {
            var f = u[a];
            o[f] = t(f, n || !!o[f].enumerable);
          }
          return Object.create(Object.getPrototypeOf(r), o);
        }(e, n),
        o = {
          i: e ? 5 : 4,
          A: r ? r.A : _(),
          P: !1,
          I: !1,
          R: {},
          l: r,
          t: n,
          k: i,
          o: null,
          g: !1,
          C: !1
        };
      return Object.defineProperty(i, Q, {
        value: o,
        writable: !0
      }), i;
    },
    S: function (n, t, o) {
      o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
        if (r && "object" == typeof r) {
          var t = r[Q];
          if (t) {
            var e = t.t,
              o = t.k,
              f = t.R,
              c = t.i;
            if (4 === c) i(o, function (r) {
              r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
            }), i(e, function (n) {
              void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
            });else if (5 === c) {
              if (a(t) && (k(t), f.length = !0), o.length < e.length) for (var s = o.length; s < e.length; s++) f[s] = !1;else for (var v = e.length; v < o.length; v++) f[v] = !0;
              for (var p = Math.min(o.length, e.length), l = 0; l < p; l++) o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
            }
          }
        }
      }(n.p[0]), e(n.p));
    },
    K: function (n) {
      return 4 === n.i ? o(n) : a(n);
    }
  });
}
function T() {
  function e(n) {
    if (!t(n)) return n;
    if (Array.isArray(n)) return n.map(e);
    if (s(n)) return new Map(Array.from(n.entries()).map(function (n) {
      return [n[0], e(n[1])];
    }));
    if (v(n)) return new Set(Array.from(n).map(e));
    var r = Object.create(Object.getPrototypeOf(n));
    for (var i in n) r[i] = e(n[i]);
    return u(n, L) && (r[L] = n[L]), r;
  }
  function f(n) {
    return r(n) ? e(n) : n;
  }
  var c = "add";
  m("Patches", {
    $: function (r, t) {
      return t.forEach(function (t) {
        for (var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++) {
          var v = o(f),
            p = i[s];
          "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
        }
        var l = o(f),
          d = e(t.value),
          h = i[i.length - 1];
        switch (u) {
          case "replace":
            switch (l) {
              case 2:
                return f.set(h, d);
              case 3:
                n(16);
              default:
                return f[h] = d;
            }
          case c:
            switch (l) {
              case 1:
                return "-" === h ? f.push(d) : f.splice(h, 0, d);
              case 2:
                return f.set(h, d);
              case 3:
                return f.add(d);
              default:
                return f[h] = d;
            }
          case "remove":
            switch (l) {
              case 1:
                return f.splice(h, 1);
              case 2:
                return f.delete(h);
              case 3:
                return f.delete(t.value);
              default:
                return delete f[h];
            }
          default:
            n(17, u);
        }
      }), r;
    },
    N: function (n, r, t, e) {
      switch (n.i) {
        case 0:
        case 4:
        case 2:
          return function (n, r, t, e) {
            var o = n.t,
              s = n.o;
            i(n.R, function (n, i) {
              var v = a(o, n),
                p = a(s, n),
                l = i ? u(o, n) ? "replace" : c : "remove";
              if (v !== p || "replace" !== l) {
                var d = r.concat(n);
                t.push("remove" === l ? {
                  op: l,
                  path: d
                } : {
                  op: l,
                  path: d,
                  value: p
                }), e.push(l === c ? {
                  op: "remove",
                  path: d
                } : "remove" === l ? {
                  op: c,
                  path: d,
                  value: f(v)
                } : {
                  op: "replace",
                  path: d,
                  value: f(v)
                });
              }
            });
          }(n, r, t, e);
        case 5:
        case 1:
          return function (n, r, t, e) {
            var i = n.t,
              o = n.R,
              u = n.o;
            if (u.length < i.length) {
              var a = [u, i];
              i = a[0], u = a[1];
              var s = [e, t];
              t = s[0], e = s[1];
            }
            for (var v = 0; v < i.length; v++) if (o[v] && u[v] !== i[v]) {
              var p = r.concat([v]);
              t.push({
                op: "replace",
                path: p,
                value: f(u[v])
              }), e.push({
                op: "replace",
                path: p,
                value: f(i[v])
              });
            }
            for (var l = i.length; l < u.length; l++) {
              var d = r.concat([l]);
              t.push({
                op: c,
                path: d,
                value: f(u[l])
              });
            }
            i.length < u.length && e.push({
              op: "replace",
              path: r.concat(["length"]),
              value: i.length
            });
          }(n, r, t, e);
        case 3:
          return function (n, r, t, e) {
            var i = n.t,
              o = n.o,
              u = 0;
            i.forEach(function (n) {
              if (!o.has(n)) {
                var i = r.concat([u]);
                t.push({
                  op: "remove",
                  path: i,
                  value: n
                }), e.unshift({
                  op: c,
                  path: i,
                  value: n
                });
              }
              u++;
            }), u = 0, o.forEach(function (n) {
              if (!i.has(n)) {
                var o = r.concat([u]);
                t.push({
                  op: c,
                  path: o,
                  value: n
                }), e.unshift({
                  op: "remove",
                  path: o,
                  value: n
                });
              }
              u++;
            });
          }(n, r, t, e);
      }
    },
    M: function (n, r, t, e) {
      t.push({
        op: "replace",
        path: [],
        value: r === H ? void 0 : r
      }), e.push({
        op: "replace",
        path: [],
        value: n
      });
    }
  });
}
function C() {
  function r(n, r) {
    function t() {
      this.constructor = n;
    }
    a(n, r), n.prototype = (t.prototype = r.prototype, new t());
  }
  function e(n) {
    n.o || (n.R = new Map(), n.o = new Map(n.t));
  }
  function o(n) {
    n.o || (n.o = new Set(), n.t.forEach(function (r) {
      if (t(r)) {
        var e = N(n.A.h, r, n);
        n.p.set(r, e), n.o.add(e);
      } else n.o.add(r);
    }));
  }
  function u(r) {
    r.g && n(3, JSON.stringify(p(r)));
  }
  var a = function (n, r) {
      return (a = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (n, r) {
        n.__proto__ = r;
      } || function (n, r) {
        for (var t in r) r.hasOwnProperty(t) && (n[t] = r[t]);
      })(n, r);
    },
    f = function () {
      function n(n, r) {
        return this[Q] = {
          i: 2,
          l: r,
          A: r ? r.A : _(),
          P: !1,
          I: !1,
          o: void 0,
          R: void 0,
          t: n,
          k: this,
          C: !1,
          g: !1
        }, this;
      }
      r(n, Map);
      var o = n.prototype;
      return Object.defineProperty(o, "size", {
        get: function () {
          return p(this[Q]).size;
        }
      }), o.has = function (n) {
        return p(this[Q]).has(n);
      }, o.set = function (n, r) {
        var t = this[Q];
        return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
      }, o.delete = function (n) {
        if (!this.has(n)) return !1;
        var r = this[Q];
        return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
      }, o.clear = function () {
        var n = this[Q];
        u(n), p(n).size && (e(n), k(n), n.R = new Map(), i(n.t, function (r) {
          n.R.set(r, !1);
        }), n.o.clear());
      }, o.forEach = function (n, r) {
        var t = this;
        p(this[Q]).forEach(function (e, i) {
          n.call(r, t.get(i), i, t);
        });
      }, o.get = function (n) {
        var r = this[Q];
        u(r);
        var i = p(r).get(n);
        if (r.I || !t(i)) return i;
        if (i !== r.t.get(n)) return i;
        var o = N(r.A.h, i, r);
        return e(r), r.o.set(n, o), o;
      }, o.keys = function () {
        return p(this[Q]).keys();
      }, o.values = function () {
        var n,
          r = this,
          t = this.keys();
        return (n = {})[V] = function () {
          return r.values();
        }, n.next = function () {
          var n = t.next();
          return n.done ? n : {
            done: !1,
            value: r.get(n.value)
          };
        }, n;
      }, o.entries = function () {
        var n,
          r = this,
          t = this.keys();
        return (n = {})[V] = function () {
          return r.entries();
        }, n.next = function () {
          var n = t.next();
          if (n.done) return n;
          var e = r.get(n.value);
          return {
            done: !1,
            value: [n.value, e]
          };
        }, n;
      }, o[V] = function () {
        return this.entries();
      }, n;
    }(),
    c = function () {
      function n(n, r) {
        return this[Q] = {
          i: 3,
          l: r,
          A: r ? r.A : _(),
          P: !1,
          I: !1,
          o: void 0,
          t: n,
          k: this,
          p: new Map(),
          g: !1,
          C: !1
        }, this;
      }
      r(n, Set);
      var t = n.prototype;
      return Object.defineProperty(t, "size", {
        get: function () {
          return p(this[Q]).size;
        }
      }), t.has = function (n) {
        var r = this[Q];
        return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
      }, t.add = function (n) {
        var r = this[Q];
        return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
      }, t.delete = function (n) {
        if (!this.has(n)) return !1;
        var r = this[Q];
        return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
      }, t.clear = function () {
        var n = this[Q];
        u(n), p(n).size && (o(n), k(n), n.o.clear());
      }, t.values = function () {
        var n = this[Q];
        return u(n), o(n), n.o.values();
      }, t.entries = function () {
        var n = this[Q];
        return u(n), o(n), n.o.entries();
      }, t.keys = function () {
        return this.values();
      }, t[V] = function () {
        return this.values();
      }, t.forEach = function (n, r) {
        for (var t = this.values(), e = t.next(); !e.done;) n.call(r, e.value, e.value, this), e = t.next();
      }, n;
    }();
  m("MapSet", {
    F: function (n, r) {
      return new f(n, r);
    },
    T: function (n, r) {
      return new c(n, r);
    }
  });
}
function J() {
  F(), C(), T();
}
function K(n) {
  return n;
}
function $(n) {
  return n;
}
var G,
  U,
  W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"),
  X = "undefined" != typeof Map,
  q = "undefined" != typeof Set,
  B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect,
  H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G),
  L = W ? Symbol.for("immer-draftable") : "__$immer_draftable",
  Q = W ? Symbol.for("immer-state") : "__$immer_state",
  V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator",
  Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function (n) {
      return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function (n) {
      return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function (n) {
      return "Unsupported patch operation: " + n;
    },
    18: function (n) {
      return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function (n) {
      return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function (n) {
      return "'current' expects a draft, got: " + n;
    },
    23: function (n) {
      return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
  },
  Z = "" + Object.prototype.constructor,
  nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function (n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
  } : Object.getOwnPropertyNames,
  rn = Object.getOwnPropertyDescriptors || function (n) {
    var r = {};
    return nn(n).forEach(function (t) {
      r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
  },
  tn = {},
  en = {
    get: function (n, r) {
      if (r === Q) return n;
      var e = p(n);
      if (!u(e, r)) return function (n, r, t) {
        var e,
          i = I(r, t);
        return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
      }(n, e, r);
      var i = e[r];
      return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function (n, r) {
      return r in p(n);
    },
    ownKeys: function (n) {
      return Reflect.ownKeys(p(n));
    },
    set: function (n, r, t) {
      var e = I(p(n), r);
      if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
      if (!n.P) {
        var i = z(p(n), r),
          o = null == i ? void 0 : i[Q];
        if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
        if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
        E(n), k(n);
      }
      return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function (n, r) {
      return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function (n, r) {
      var t = p(n),
        e = Reflect.getOwnPropertyDescriptor(t, r);
      return e ? {
        writable: !0,
        configurable: 1 !== n.i || "length" !== r,
        enumerable: e.enumerable,
        value: t[r]
      } : e;
    },
    defineProperty: function () {
      n(11);
    },
    getPrototypeOf: function (n) {
      return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function () {
      n(12);
    }
  },
  on = {};
i(en, function (n, r) {
  on[n] = function () {
    return arguments[0] = arguments[0][0], r.apply(this, arguments);
  };
}), on.deleteProperty = function (r, t) {
  return  false && 0, on.set.call(this, r, t, void 0);
}, on.set = function (r, t, e) {
  return  false && 0, en.set.call(this, r[0], t, e, r[0]);
};
var un = function () {
    function e(r) {
      var e = this;
      this.O = B, this.D = !0, this.produce = function (r, i, o) {
        if ("function" == typeof r && "function" != typeof i) {
          var u = i;
          i = r;
          var a = e;
          return function (n) {
            var r = this;
            void 0 === n && (n = u);
            for (var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++) e[o - 1] = arguments[o];
            return a.produce(n, function (n) {
              var t;
              return (t = i).call.apply(t, [r, n].concat(e));
            });
          };
        }
        var f;
        if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
          var c = w(e),
            s = N(e, r, void 0),
            v = !0;
          try {
            f = i(s), v = !1;
          } finally {
            v ? g(c) : O(c);
          }
          return "undefined" != typeof Promise && f instanceof Promise ? f.then(function (n) {
            return j(c, o), P(n, c);
          }, function (n) {
            throw g(c), n;
          }) : (j(c, o), P(f, c));
        }
        if (!r || "object" != typeof r) {
          if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
            var p = [],
              l = [];
            b("Patches").M(r, f, p, l), o(p, l);
          }
          return f;
        }
        n(21, r);
      }, this.produceWithPatches = function (n, r) {
        if ("function" == typeof n) return function (r) {
          for (var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++) i[o - 1] = arguments[o];
          return e.produceWithPatches(r, function (r) {
            return n.apply(void 0, [r].concat(i));
          });
        };
        var t,
          i,
          o = e.produce(n, r, function (n, r) {
            t = n, i = r;
          });
        return "undefined" != typeof Promise && o instanceof Promise ? o.then(function (n) {
          return [n, t, i];
        }) : [o, t, i];
      }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function (e) {
      t(e) || n(8), r(e) && (e = R(e));
      var i = w(this),
        o = N(this, e, void 0);
      return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function (r, t) {
      var e = r && r[Q];
       false && (0);
      var i = e.A;
      return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function (n) {
      this.D = n;
    }, i.setUseProxies = function (r) {
      r && !B && n(20), this.O = r;
    }, i.applyPatches = function (n, t) {
      var e;
      for (e = t.length - 1; e >= 0; e--) {
        var i = t[e];
        if (0 === i.path.length && "replace" === i.op) {
          n = i.value;
          break;
        }
      }
      e > -1 && (t = t.slice(e + 1));
      var o = b("Patches").$;
      return r(n) ? o(n, t) : this.produce(n, function (n) {
        return o(n, t);
      });
    }, e;
  }(),
  an = new un(),
  fn = an.produce,
  cn = an.produceWithPatches.bind(an),
  sn = an.setAutoFreeze.bind(an),
  vn = an.setUseProxies.bind(an),
  pn = an.applyPatches.bind(an),
  ln = an.createDraft.bind(an),
  dn = an.finishDraft.bind(an);
/* harmony default export */ __webpack_exports__["ZP"] = (fn);


/***/ }),

/***/ 93268:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MultiToken": function() { return /* binding */ MultiToken; },
/* harmony export */   "Options": function() { return /* binding */ Options; },
/* harmony export */   "State": function() { return /* binding */ State; },
/* harmony export */   "createTokenClass": function() { return /* binding */ createTokenClass; },
/* harmony export */   "find": function() { return /* binding */ find; },
/* harmony export */   "init": function() { return /* binding */ init; },
/* harmony export */   "multi": function() { return /* binding */ multi; },
/* harmony export */   "options": function() { return /* binding */ options; },
/* harmony export */   "regexp": function() { return /* binding */ regexp; },
/* harmony export */   "registerCustomProtocol": function() { return /* binding */ registerCustomProtocol; },
/* harmony export */   "registerPlugin": function() { return /* binding */ registerPlugin; },
/* harmony export */   "registerTokenPlugin": function() { return /* binding */ registerTokenPlugin; },
/* harmony export */   "reset": function() { return /* binding */ reset; },
/* harmony export */   "stringToArray": function() { return /* binding */ stringToArray; },
/* harmony export */   "test": function() { return /* binding */ test; },
/* harmony export */   "text": function() { return /* binding */ multi; },
/* harmony export */   "tokenize": function() { return /* binding */ tokenize; }
/* harmony export */ });
// THIS FILE IS AUTOMATICALLY GENERATED DO NOT EDIT DIRECTLY
// See update-tlds.js for encoding/decoding format
// https://data.iana.org/TLD/tlds-alpha-by-domain.txt
const encodedTlds = 'aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2';
// Internationalized domain names containing non-ASCII
const encodedUtlds = 'ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2';

/**
 * Finite State Machine generation utilities
 */

/**
 * @template T
 * @typedef {{ [group: string]: T[] }} Collections
 */

/**
 * @typedef {{ [group: string]: true }} Flags
 */

// Keys in scanner Collections instances
const numeric = 'numeric';
const ascii = 'ascii';
const alpha = 'alpha';
const asciinumeric = 'asciinumeric';
const alphanumeric = 'alphanumeric';
const domain = 'domain';
const emoji = 'emoji';
const scheme = 'scheme';
const slashscheme = 'slashscheme';
const whitespace = 'whitespace';

/**
 * @template T
 * @param {string} name
 * @param {Collections<T>} groups to register in
 * @returns {T[]} Current list of tokens in the given collection
 */
function registerGroup(name, groups) {
  if (!(name in groups)) {
    groups[name] = [];
  }
  return groups[name];
}

/**
 * @template T
 * @param {T} t token to add
 * @param {Collections<T>} groups
 * @param {Flags} flags
 */
function addToGroups(t, flags, groups) {
  if (flags[numeric]) {
    flags[asciinumeric] = true;
    flags[alphanumeric] = true;
  }
  if (flags[ascii]) {
    flags[asciinumeric] = true;
    flags[alpha] = true;
  }
  if (flags[asciinumeric]) {
    flags[alphanumeric] = true;
  }
  if (flags[alpha]) {
    flags[alphanumeric] = true;
  }
  if (flags[alphanumeric]) {
    flags[domain] = true;
  }
  if (flags[emoji]) {
    flags[domain] = true;
  }
  for (const k in flags) {
    const group = registerGroup(k, groups);
    if (group.indexOf(t) < 0) {
      group.push(t);
    }
  }
}

/**
 * @template T
 * @param {T} t token to check
 * @param {Collections<T>} groups
 * @returns {Flags} group flags that contain this token
 */
function flagsForToken(t, groups) {
  const result = {};
  for (const c in groups) {
    if (groups[c].indexOf(t) >= 0) {
      result[c] = true;
    }
  }
  return result;
}

/**
 * @template T
 * @typedef {null | T } Transition
 */

/**
 * Define a basic state machine state. j is the list of character transitions,
 * jr is the list of regex-match transitions, jd is the default state to
 * transition to t is the accepting token type, if any. If this is the terminal
 * state, then it does not emit a token.
 *
 * The template type T represents the type of the token this state accepts. This
 * should be a string (such as of the token exports in `text.js`) or a
 * MultiToken subclass (from `multi.js`)
 *
 * @template T
 * @param {T} [token] Token that this state emits
 */
function State(token = null) {
  // this.n = null; // DEBUG: State name
  /** @type {{ [input: string]: State<T> }} j */
  this.j = {}; // IMPLEMENTATION 1
  // this.j = []; // IMPLEMENTATION 2
  /** @type {[RegExp, State<T>][]} jr */
  this.jr = [];
  /** @type {?State<T>} jd */
  this.jd = null;
  /** @type {?T} t */
  this.t = token;
}

/**
 * Scanner token groups
 * @type Collections<string>
 */
State.groups = {};
State.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(input) {
    const state = this;
    const nextState = state.j[input];
    if (nextState) {
      return nextState;
    }
    for (let i = 0; i < state.jr.length; i++) {
      const regex = state.jr[i][0];
      const nextState = state.jr[i][1]; // note: might be empty to prevent default jump
      if (nextState && regex.test(input)) {
        return nextState;
      }
    }
    // Nowhere left to jump! Return default, if any
    return state.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(input, exactOnly = false) {
    return exactOnly ? input in this.j : !!this.go(input);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(inputs, next, flags, groups) {
    for (let i = 0; i < inputs.length; i++) {
      this.tt(inputs[i], next, flags, groups);
    }
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(regexp, next, flags, groups) {
    groups = groups || State.groups;
    let nextState;
    if (next && next.j) {
      nextState = next;
    } else {
      // Token with maybe token groups
      nextState = new State(next);
      if (flags && groups) {
        addToGroups(next, flags, groups);
      }
    }
    this.jr.push([regexp, nextState]);
    return nextState;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(input, next, flags, groups) {
    let state = this;
    const len = input.length;
    if (!len) {
      return state;
    }
    for (let i = 0; i < len - 1; i++) {
      state = state.tt(input[i]);
    }
    return state.tt(input[len - 1], next, flags, groups);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(input, next, flags, groups) {
    groups = groups || State.groups;
    const state = this;

    // Check if existing state given, just a basic transition
    if (next && next.j) {
      state.j[input] = next;
      return next;
    }
    const t = next;

    // Take the transition with the usual default mechanisms and use that as
    // a template for creating the next state
    let nextState,
      templateState = state.go(input);
    if (templateState) {
      nextState = new State();
      Object.assign(nextState.j, templateState.j);
      nextState.jr.push.apply(nextState.jr, templateState.jr);
      nextState.jd = templateState.jd;
      nextState.t = templateState.t;
    } else {
      nextState = new State();
    }
    if (t) {
      // Ensure newly token is in the same groups as the old token
      if (groups) {
        if (nextState.t && typeof nextState.t === 'string') {
          const allFlags = Object.assign(flagsForToken(nextState.t, groups), flags);
          addToGroups(t, allFlags, groups);
        } else if (flags) {
          addToGroups(t, flags, groups);
        }
      }
      nextState.t = t; // overwrite anything that was previously there
    }
    state.j[input] = nextState;
    return nextState;
  }
};

// Helper functions to improve minification (not exported outside linkifyjs module)

/**
 * @template T
 * @param {State<T>} state
 * @param {string | string[]} input
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */
const ta = (state, input, next, flags, groups) => state.ta(input, next, flags, groups);

/**
 * @template T
 * @param {State<T>} state
 * @param {RegExp} regexp
 * @param {T | State<T>} [next]
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */
const tr = (state, regexp, next, flags, groups) => state.tr(regexp, next, flags, groups);

/**
 * @template T
 * @param {State<T>} state
 * @param {string | string[]} input
 * @param {T | State<T>} [next]
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */
const ts = (state, input, next, flags, groups) => state.ts(input, next, flags, groups);

/**
 * @template T
 * @param {State<T>} state
 * @param {string} input
 * @param {T | State<T>} [next]
 * @param {Collections<T>} [groups]
 * @param {Flags} [flags]
 */
const tt = (state, input, next, flags, groups) => state.tt(input, next, flags, groups);

/******************************************************************************
Text Tokens
Identifiers for token outputs from the regexp scanner
******************************************************************************/

// A valid web domain token
const WORD = 'WORD'; // only contains a-z
const UWORD = 'UWORD'; // contains letters other than a-z, used for IDN
const ASCIINUMERICAL = 'ASCIINUMERICAL'; // contains a-z, 0-9
const ALPHANUMERICAL = 'ALPHANUMERICAL'; // contains numbers and letters other than a-z, used for IDN

// Special case of word
const LOCALHOST = 'LOCALHOST';

// Valid top-level domain, special case of WORD (see tlds.js)
const TLD = 'TLD';

// Valid IDN TLD, special case of UWORD (see tlds.js)
const UTLD = 'UTLD';

// The scheme portion of a web URI protocol. Supported types include: `mailto`,
// `file`, and user-defined custom protocols. Limited to schemes that contain
// only letters
const SCHEME = 'SCHEME';

// Similar to SCHEME, except makes distinction for schemes that must always be
// followed by `://`, not just `:`. Supported types include `http`, `https`,
// `ftp`, `ftps`
const SLASH_SCHEME = 'SLASH_SCHEME';

// Any sequence of digits 0-9
const NUM = 'NUM';

// Any number of consecutive whitespace characters that are not newline
const WS = 'WS';

// New line (unix style)
const NL = 'NL'; // \n

// Opening/closing bracket classes
// TODO: Rename OPEN -> LEFT and CLOSE -> RIGHT in v5 to fit with Unicode names
// Also rename angle brackes to LESSTHAN and GREATER THAN
const OPENBRACE = 'OPENBRACE'; // {
const CLOSEBRACE = 'CLOSEBRACE'; // }
const OPENBRACKET = 'OPENBRACKET'; // [
const CLOSEBRACKET = 'CLOSEBRACKET'; // ]
const OPENPAREN = 'OPENPAREN'; // (
const CLOSEPAREN = 'CLOSEPAREN'; // )
const OPENANGLEBRACKET = 'OPENANGLEBRACKET'; // <
const CLOSEANGLEBRACKET = 'CLOSEANGLEBRACKET'; // >
const FULLWIDTHLEFTPAREN = 'FULLWIDTHLEFTPAREN'; // （
const FULLWIDTHRIGHTPAREN = 'FULLWIDTHRIGHTPAREN'; // ）
const LEFTCORNERBRACKET = 'LEFTCORNERBRACKET'; // 「
const RIGHTCORNERBRACKET = 'RIGHTCORNERBRACKET'; // 」
const LEFTWHITECORNERBRACKET = 'LEFTWHITECORNERBRACKET'; // 『
const RIGHTWHITECORNERBRACKET = 'RIGHTWHITECORNERBRACKET'; // 』
const FULLWIDTHLESSTHAN = 'FULLWIDTHLESSTHAN'; // ＜
const FULLWIDTHGREATERTHAN = 'FULLWIDTHGREATERTHAN'; // ＞

// Various symbols
const AMPERSAND = 'AMPERSAND'; // &
const APOSTROPHE = 'APOSTROPHE'; // '
const ASTERISK = 'ASTERISK'; // *
const AT = 'AT'; // @
const BACKSLASH = 'BACKSLASH'; // \
const BACKTICK = 'BACKTICK'; // `
const CARET = 'CARET'; // ^
const COLON = 'COLON'; // :
const COMMA = 'COMMA'; // ,
const DOLLAR = 'DOLLAR'; // $
const DOT = 'DOT'; // .
const EQUALS = 'EQUALS'; // =
const EXCLAMATION = 'EXCLAMATION'; // !
const HYPHEN = 'HYPHEN'; // -
const PERCENT = 'PERCENT'; // %
const PIPE = 'PIPE'; // |
const PLUS = 'PLUS'; // +
const POUND = 'POUND'; // #
const QUERY = 'QUERY'; // ?
const QUOTE = 'QUOTE'; // "
const FULLWIDTHMIDDLEDOT = 'FULLWIDTHMIDDLEDOT'; // ・

const SEMI = 'SEMI'; // ;
const SLASH = 'SLASH'; // /
const TILDE = 'TILDE'; // ~
const UNDERSCORE = 'UNDERSCORE'; // _

// Emoji symbol
const EMOJI$1 = 'EMOJI';

// Default token - anything that is not one of the above
const SYM = 'SYM';
var tk = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ALPHANUMERICAL: ALPHANUMERICAL,
  AMPERSAND: AMPERSAND,
  APOSTROPHE: APOSTROPHE,
  ASCIINUMERICAL: ASCIINUMERICAL,
  ASTERISK: ASTERISK,
  AT: AT,
  BACKSLASH: BACKSLASH,
  BACKTICK: BACKTICK,
  CARET: CARET,
  CLOSEANGLEBRACKET: CLOSEANGLEBRACKET,
  CLOSEBRACE: CLOSEBRACE,
  CLOSEBRACKET: CLOSEBRACKET,
  CLOSEPAREN: CLOSEPAREN,
  COLON: COLON,
  COMMA: COMMA,
  DOLLAR: DOLLAR,
  DOT: DOT,
  EMOJI: EMOJI$1,
  EQUALS: EQUALS,
  EXCLAMATION: EXCLAMATION,
  FULLWIDTHGREATERTHAN: FULLWIDTHGREATERTHAN,
  FULLWIDTHLEFTPAREN: FULLWIDTHLEFTPAREN,
  FULLWIDTHLESSTHAN: FULLWIDTHLESSTHAN,
  FULLWIDTHMIDDLEDOT: FULLWIDTHMIDDLEDOT,
  FULLWIDTHRIGHTPAREN: FULLWIDTHRIGHTPAREN,
  HYPHEN: HYPHEN,
  LEFTCORNERBRACKET: LEFTCORNERBRACKET,
  LEFTWHITECORNERBRACKET: LEFTWHITECORNERBRACKET,
  LOCALHOST: LOCALHOST,
  NL: NL,
  NUM: NUM,
  OPENANGLEBRACKET: OPENANGLEBRACKET,
  OPENBRACE: OPENBRACE,
  OPENBRACKET: OPENBRACKET,
  OPENPAREN: OPENPAREN,
  PERCENT: PERCENT,
  PIPE: PIPE,
  PLUS: PLUS,
  POUND: POUND,
  QUERY: QUERY,
  QUOTE: QUOTE,
  RIGHTCORNERBRACKET: RIGHTCORNERBRACKET,
  RIGHTWHITECORNERBRACKET: RIGHTWHITECORNERBRACKET,
  SCHEME: SCHEME,
  SEMI: SEMI,
  SLASH: SLASH,
  SLASH_SCHEME: SLASH_SCHEME,
  SYM: SYM,
  TILDE: TILDE,
  TLD: TLD,
  UNDERSCORE: UNDERSCORE,
  UTLD: UTLD,
  UWORD: UWORD,
  WORD: WORD,
  WS: WS
});

// Note that these two Unicode ones expand into a really big one with Babel
const ASCII_LETTER = /[a-z]/;
const LETTER = /\p{L}/u; // Any Unicode character with letter data type
const EMOJI = /\p{Emoji}/u; // Any Unicode emoji character
const EMOJI_VARIATION$1 = /\ufe0f/;
const DIGIT = /\d/;
const SPACE = /\s/;
var regexp = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ASCII_LETTER: ASCII_LETTER,
  DIGIT: DIGIT,
  EMOJI: EMOJI,
  EMOJI_VARIATION: EMOJI_VARIATION$1,
  LETTER: LETTER,
  SPACE: SPACE
});

/**
	The scanner provides an interface that takes a string of text as input, and
	outputs an array of tokens instances that can be used for easy URL parsing.
*/

const CR = '\r'; // carriage-return character
const LF = '\n'; // line-feed character
const EMOJI_VARIATION = '\ufe0f'; // Variation selector, follows heart and others
const EMOJI_JOINER = '\u200d'; // zero-width joiner
const OBJECT_REPLACEMENT = '\ufffc'; // whitespace placeholder that sometimes appears in rich text editors

let tlds = null,
  utlds = null; // don't change so only have to be computed once

/**
 * Scanner output token:
 * - `t` is the token name (e.g., 'NUM', 'EMOJI', 'TLD')
 * - `v` is the value of the token (e.g., '123', '❤️', 'com')
 * - `s` is the start index of the token in the original string
 * - `e` is the end index of the token in the original string
 * @typedef {{t: string, v: string, s: number, e: number}} Token
 */

/**
 * @template T
 * @typedef {{ [collection: string]: T[] }} Collections
 */

/**
 * Initialize the scanner character-based state machine for the given start
 * state
 * @param {[string, boolean][]} customSchemes List of custom schemes, where each
 * item is a length-2 tuple with the first element set to the string scheme, and
 * the second element set to `true` if the `://` after the scheme is optional
 */
function init$2(customSchemes = []) {
  // Frequently used states (name argument removed during minification)
  /** @type Collections<string> */
  const groups = {}; // of tokens
  State.groups = groups;
  /** @type State<string> */
  const Start = new State();
  if (tlds == null) {
    tlds = decodeTlds(encodedTlds);
  }
  if (utlds == null) {
    utlds = decodeTlds(encodedUtlds);
  }

  // States for special URL symbols that accept immediately after start
  tt(Start, "'", APOSTROPHE);
  tt(Start, '{', OPENBRACE);
  tt(Start, '}', CLOSEBRACE);
  tt(Start, '[', OPENBRACKET);
  tt(Start, ']', CLOSEBRACKET);
  tt(Start, '(', OPENPAREN);
  tt(Start, ')', CLOSEPAREN);
  tt(Start, '<', OPENANGLEBRACKET);
  tt(Start, '>', CLOSEANGLEBRACKET);
  tt(Start, '（', FULLWIDTHLEFTPAREN);
  tt(Start, '）', FULLWIDTHRIGHTPAREN);
  tt(Start, '「', LEFTCORNERBRACKET);
  tt(Start, '」', RIGHTCORNERBRACKET);
  tt(Start, '『', LEFTWHITECORNERBRACKET);
  tt(Start, '』', RIGHTWHITECORNERBRACKET);
  tt(Start, '＜', FULLWIDTHLESSTHAN);
  tt(Start, '＞', FULLWIDTHGREATERTHAN);
  tt(Start, '&', AMPERSAND);
  tt(Start, '*', ASTERISK);
  tt(Start, '@', AT);
  tt(Start, '`', BACKTICK);
  tt(Start, '^', CARET);
  tt(Start, ':', COLON);
  tt(Start, ',', COMMA);
  tt(Start, '$', DOLLAR);
  tt(Start, '.', DOT);
  tt(Start, '=', EQUALS);
  tt(Start, '!', EXCLAMATION);
  tt(Start, '-', HYPHEN);
  tt(Start, '%', PERCENT);
  tt(Start, '|', PIPE);
  tt(Start, '+', PLUS);
  tt(Start, '#', POUND);
  tt(Start, '?', QUERY);
  tt(Start, '"', QUOTE);
  tt(Start, '/', SLASH);
  tt(Start, ';', SEMI);
  tt(Start, '~', TILDE);
  tt(Start, '_', UNDERSCORE);
  tt(Start, '\\', BACKSLASH);
  tt(Start, '・', FULLWIDTHMIDDLEDOT);
  const Num = tr(Start, DIGIT, NUM, {
    [numeric]: true
  });
  tr(Num, DIGIT, Num);
  const Asciinumeric = tr(Num, ASCII_LETTER, ASCIINUMERICAL, {
    [asciinumeric]: true
  });
  const Alphanumeric = tr(Num, LETTER, ALPHANUMERICAL, {
    [alphanumeric]: true
  });

  // State which emits a word token
  const Word = tr(Start, ASCII_LETTER, WORD, {
    [ascii]: true
  });
  tr(Word, DIGIT, Asciinumeric);
  tr(Word, ASCII_LETTER, Word);
  tr(Asciinumeric, DIGIT, Asciinumeric);
  tr(Asciinumeric, ASCII_LETTER, Asciinumeric);

  // Same as previous, but specific to non-fsm.ascii alphabet words
  const UWord = tr(Start, LETTER, UWORD, {
    [alpha]: true
  });
  tr(UWord, ASCII_LETTER); // Non-accepting
  tr(UWord, DIGIT, Alphanumeric);
  tr(UWord, LETTER, UWord);
  tr(Alphanumeric, DIGIT, Alphanumeric);
  tr(Alphanumeric, ASCII_LETTER); // Non-accepting
  tr(Alphanumeric, LETTER, Alphanumeric); // Non-accepting

  // Whitespace jumps
  // Tokens of only non-newline whitespace are arbitrarily long
  // If any whitespace except newline, more whitespace!
  const Nl = tt(Start, LF, NL, {
    [whitespace]: true
  });
  const Cr = tt(Start, CR, WS, {
    [whitespace]: true
  });
  const Ws = tr(Start, SPACE, WS, {
    [whitespace]: true
  });
  tt(Start, OBJECT_REPLACEMENT, Ws);
  tt(Cr, LF, Nl); // \r\n
  tt(Cr, OBJECT_REPLACEMENT, Ws);
  tr(Cr, SPACE, Ws);
  tt(Ws, CR); // non-accepting state to avoid mixing whitespaces
  tt(Ws, LF); // non-accepting state to avoid mixing whitespaces
  tr(Ws, SPACE, Ws);
  tt(Ws, OBJECT_REPLACEMENT, Ws);

  // Emoji tokens. They are not grouped by the scanner except in cases where a
  // zero-width joiner is present
  const Emoji = tr(Start, EMOJI, EMOJI$1, {
    [emoji]: true
  });
  tt(Emoji, '#'); // no transition, emoji regex seems to match #
  tr(Emoji, EMOJI, Emoji);
  tt(Emoji, EMOJI_VARIATION, Emoji);
  // tt(Start, EMOJI_VARIATION, Emoji); // This one is sketchy

  const EmojiJoiner = tt(Emoji, EMOJI_JOINER);
  tt(EmojiJoiner, '#');
  tr(EmojiJoiner, EMOJI, Emoji);
  // tt(EmojiJoiner, EMOJI_VARIATION, Emoji); // also sketchy

  // Generates states for top-level domains
  // Note that this is most accurate when tlds are in alphabetical order
  const wordjr = [[ASCII_LETTER, Word], [DIGIT, Asciinumeric]];
  const uwordjr = [[ASCII_LETTER, null], [LETTER, UWord], [DIGIT, Alphanumeric]];
  for (let i = 0; i < tlds.length; i++) {
    fastts(Start, tlds[i], TLD, WORD, wordjr);
  }
  for (let i = 0; i < utlds.length; i++) {
    fastts(Start, utlds[i], UTLD, UWORD, uwordjr);
  }
  addToGroups(TLD, {
    tld: true,
    ascii: true
  }, groups);
  addToGroups(UTLD, {
    utld: true,
    alpha: true
  }, groups);

  // Collect the states generated by different protocols. NOTE: If any new TLDs
  // get added that are also protocols, set the token to be the same as the
  // protocol to ensure parsing works as expected.
  fastts(Start, 'file', SCHEME, WORD, wordjr);
  fastts(Start, 'mailto', SCHEME, WORD, wordjr);
  fastts(Start, 'http', SLASH_SCHEME, WORD, wordjr);
  fastts(Start, 'https', SLASH_SCHEME, WORD, wordjr);
  fastts(Start, 'ftp', SLASH_SCHEME, WORD, wordjr);
  fastts(Start, 'ftps', SLASH_SCHEME, WORD, wordjr);
  addToGroups(SCHEME, {
    scheme: true,
    ascii: true
  }, groups);
  addToGroups(SLASH_SCHEME, {
    slashscheme: true,
    ascii: true
  }, groups);

  // Register custom schemes. Assumes each scheme is asciinumeric with hyphens
  customSchemes = customSchemes.sort((a, b) => a[0] > b[0] ? 1 : -1);
  for (let i = 0; i < customSchemes.length; i++) {
    const sch = customSchemes[i][0];
    const optionalSlashSlash = customSchemes[i][1];
    const flags = optionalSlashSlash ? {
      [scheme]: true
    } : {
      [slashscheme]: true
    };
    if (sch.indexOf('-') >= 0) {
      flags[domain] = true;
    } else if (!ASCII_LETTER.test(sch)) {
      flags[numeric] = true; // numbers only
    } else if (DIGIT.test(sch)) {
      flags[asciinumeric] = true;
    } else {
      flags[ascii] = true;
    }
    ts(Start, sch, sch, flags);
  }

  // Localhost token
  ts(Start, 'localhost', LOCALHOST, {
    ascii: true
  });

  // Set default transition for start state (some symbol)
  Start.jd = new State(SYM);
  return {
    start: Start,
    tokens: Object.assign({
      groups
    }, tk)
  };
}

/**
	Given a string, returns an array of TOKEN instances representing the
	composition of that string.

	@method run
	@param {State<string>} start scanner starting state
	@param {string} str input string to scan
	@return {Token[]} list of tokens, each with a type and value
*/
function run$1(start, str) {
  // State machine is not case sensitive, so input is tokenized in lowercased
  // form (still returns regular case). Uses selective `toLowerCase` because
  // lowercasing the entire string causes the length and character position to
  // vary in some non-English strings with V8-based runtimes.
  const iterable = stringToArray(str.replace(/[A-Z]/g, c => c.toLowerCase()));
  const charCount = iterable.length; // <= len if there are emojis, etc
  const tokens = []; // return value

  // cursor through the string itself, accounting for characters that have
  // width with length 2 such as emojis
  let cursor = 0;

  // Cursor through the array-representation of the string
  let charCursor = 0;

  // Tokenize the string
  while (charCursor < charCount) {
    let state = start;
    let nextState = null;
    let tokenLength = 0;
    let latestAccepting = null;
    let sinceAccepts = -1;
    let charsSinceAccepts = -1;
    while (charCursor < charCount && (nextState = state.go(iterable[charCursor]))) {
      state = nextState;

      // Keep track of the latest accepting state
      if (state.accepts()) {
        sinceAccepts = 0;
        charsSinceAccepts = 0;
        latestAccepting = state;
      } else if (sinceAccepts >= 0) {
        sinceAccepts += iterable[charCursor].length;
        charsSinceAccepts++;
      }
      tokenLength += iterable[charCursor].length;
      cursor += iterable[charCursor].length;
      charCursor++;
    }

    // Roll back to the latest accepting state
    cursor -= sinceAccepts;
    charCursor -= charsSinceAccepts;
    tokenLength -= sinceAccepts;

    // No more jumps, just make a new token from the last accepting one
    tokens.push({
      t: latestAccepting.t,
      // token type/name
      v: str.slice(cursor - tokenLength, cursor),
      // string value
      s: cursor - tokenLength,
      // start index
      e: cursor // end index (excluding)
    });
  }
  return tokens;
}

/**
 * Convert a String to an Array of characters, taking into account that some
 * characters like emojis take up two string indexes.
 *
 * Adapted from core-js (MIT license)
 * https://github.com/zloirock/core-js/blob/2d69cf5f99ab3ea3463c395df81e5a15b68f49d9/packages/core-js/internals/string-multibyte.js
 *
 * @function stringToArray
 * @param {string} str
 * @returns {string[]}
 */
function stringToArray(str) {
  const result = [];
  const len = str.length;
  let index = 0;
  while (index < len) {
    let first = str.charCodeAt(index);
    let second;
    let char = first < 0xd800 || first > 0xdbff || index + 1 === len || (second = str.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? str[index] // single character
    : str.slice(index, index + 2); // two-index characters
    result.push(char);
    index += char.length;
  }
  return result;
}

/**
 * Fast version of ts function for when transition defaults are well known
 * @param {State<string>} state
 * @param {string} input
 * @param {string} t
 * @param {string} defaultt
 * @param {[RegExp, State<string>][]} jr
 * @returns {State<string>}
 */
function fastts(state, input, t, defaultt, jr) {
  let next;
  const len = input.length;
  for (let i = 0; i < len - 1; i++) {
    const char = input[i];
    if (state.j[char]) {
      next = state.j[char];
    } else {
      next = new State(defaultt);
      next.jr = jr.slice();
      state.j[char] = next;
    }
    state = next;
  }
  next = new State(t);
  next.jr = jr.slice();
  state.j[input[len - 1]] = next;
  return next;
}

/**
 * Converts a string of Top-Level Domain names encoded in update-tlds.js back
 * into a list of strings.
 * @param {str} encoded encoded TLDs string
 * @returns {str[]} original TLDs list
 */
function decodeTlds(encoded) {
  const words = [];
  const stack = [];
  let i = 0;
  let digits = '0123456789';
  while (i < encoded.length) {
    let popDigitCount = 0;
    while (digits.indexOf(encoded[i + popDigitCount]) >= 0) {
      popDigitCount++; // encountered some digits, have to pop to go one level up trie
    }
    if (popDigitCount > 0) {
      words.push(stack.join('')); // whatever preceded the pop digits must be a word
      for (let popCount = parseInt(encoded.substring(i, i + popDigitCount), 10); popCount > 0; popCount--) {
        stack.pop();
      }
      i += popDigitCount;
    } else {
      stack.push(encoded[i]); // drop down a level into the trie
      i++;
    }
  }
  return words;
}

/**
 * An object where each key is a valid DOM Event Name such as `click` or `focus`
 * and each value is an event handler function.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Element#events
 * @typedef {?{ [event: string]: Function }} EventListeners
 */

/**
 * All formatted properties required to render a link, including `tagName`,
 * `attributes`, `content` and `eventListeners`.
 * @typedef {{ tagName: any, attributes: {[attr: string]: any}, content: string,
 * eventListeners: EventListeners }} IntermediateRepresentation
 */

/**
 * Specify either an object described by the template type `O` or a function.
 *
 * The function takes a string value (usually the link's href attribute), the
 * link type (`'url'`, `'hashtag`', etc.) and an internal token representation
 * of the link. It should return an object of the template type `O`
 * @template O
 * @typedef {O | ((value: string, type: string, token: MultiToken) => O)} OptObj
 */

/**
 * Specify either a function described by template type `F` or an object.
 *
 * Each key in the object should be a link type (`'url'`, `'hashtag`', etc.). Each
 * value should be a function with template type `F` that is called when the
 * corresponding link type is encountered.
 * @template F
 * @typedef {F | { [type: string]: F}} OptFn
 */

/**
 * Specify either a value with template type `V`, a function that returns `V` or
 * an object where each value resolves to `V`.
 *
 * The function takes a string value (usually the link's href attribute), the
 * link type (`'url'`, `'hashtag`', etc.) and an internal token representation
 * of the link. It should return an object of the template type `V`
 *
 * For the object, each key should be a link type (`'url'`, `'hashtag`', etc.).
 * Each value should either have type `V` or a function that returns V. This
 * function similarly takes a string value and a token.
 *
 * Example valid types for `Opt<string>`:
 *
 * ```js
 * 'hello'
 * (value, type, token) => 'world'
 * { url: 'hello', email: (value, token) => 'world'}
 * ```
 * @template V
 * @typedef {V | ((value: string, type: string, token: MultiToken) => V) | { [type: string]: V | ((value: string, token: MultiToken) => V) }} Opt
 */

/**
 * See available options: https://linkify.js.org/docs/options.html
 * @typedef {{
 * 	defaultProtocol?: string,
 *  events?: OptObj<EventListeners>,
 * 	format?: Opt<string>,
 * 	formatHref?: Opt<string>,
 * 	nl2br?: boolean,
 * 	tagName?: Opt<any>,
 * 	target?: Opt<string>,
 * 	rel?: Opt<string>,
 * 	validate?: Opt<boolean>,
 * 	truncate?: Opt<number>,
 * 	className?: Opt<string>,
 * 	attributes?: OptObj<({ [attr: string]: any })>,
 *  ignoreTags?: string[],
 * 	render?: OptFn<((ir: IntermediateRepresentation) => any)>
 * }} Opts
 */

/**
 * @type Required<Opts>
 */
const defaults = {
  defaultProtocol: 'http',
  events: null,
  format: noop,
  formatHref: noop,
  nl2br: false,
  tagName: 'a',
  target: null,
  rel: null,
  validate: true,
  truncate: Infinity,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};

/**
 * Utility class for linkify interfaces to apply specified
 * {@link Opts formatting and rendering options}.
 *
 * @param {Opts | Options} [opts] Option value overrides.
 * @param {(ir: IntermediateRepresentation) => any} [defaultRender] (For
 *   internal use) default render function that determines how to generate an
 *   HTML element based on a link token's derived tagName, attributes and HTML.
 *   Similar to render option
 */
function Options(opts, defaultRender = null) {
  let o = Object.assign({}, defaults);
  if (opts) {
    o = Object.assign(o, opts instanceof Options ? opts.o : opts);
  }

  // Ensure all ignored tags are uppercase
  const ignoredTags = o.ignoreTags;
  const uppercaseIgnoredTags = [];
  for (let i = 0; i < ignoredTags.length; i++) {
    uppercaseIgnoredTags.push(ignoredTags[i].toUpperCase());
  }
  /** @protected */
  this.o = o;
  if (defaultRender) {
    this.defaultRender = defaultRender;
  }
  this.ignoreTags = uppercaseIgnoredTags;
}
Options.prototype = {
  o: defaults,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(ir) {
    return ir;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(token) {
    return this.get('validate', token.toString(), token);
  },
  // Private methods

  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(key, operator, token) {
    const isCallable = operator != null;
    let option = this.o[key];
    if (!option) {
      return option;
    }
    if (typeof option === 'object') {
      option = token.t in option ? option[token.t] : defaults[key];
      if (typeof option === 'function' && isCallable) {
        option = option(operator, token);
      }
    } else if (typeof option === 'function' && isCallable) {
      option = option(operator, token.t, token);
    }
    return option;
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(key, operator, token) {
    let obj = this.o[key];
    if (typeof obj === 'function' && operator != null) {
      obj = obj(operator, token.t, token);
    }
    return obj;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(token) {
    const ir = token.render(this); // intermediate representation
    const renderFn = this.get('render', null, token) || this.defaultRender;
    return renderFn(ir, token.t, token);
  }
};
function noop(val) {
  return val;
}
var options = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Options: Options,
  defaults: defaults
});

/******************************************************************************
	Multi-Tokens
	Tokens composed of arrays of TextTokens
******************************************************************************/

/**
 * @param {string} value
 * @param {Token[]} tokens
 */
function MultiToken(value, tokens) {
  this.t = 'token';
  this.v = value;
  this.tk = tokens;
}

/**
 * Abstract class used for manufacturing tokens of text tokens. That is rather
 * than the value for a token being a small string of text, it's value an array
 * of text tokens.
 *
 * Used for grouping together URLs, emails, hashtags, and other potential
 * creations.
 * @class MultiToken
 * @property {string} t
 * @property {string} v
 * @property {Token[]} tk
 * @abstract
 */
MultiToken.prototype = {
  isLink: false,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(scheme) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(options) {
    const val = this.toString();
    const truncate = options.get('truncate', val, this);
    const formatted = options.get('format', val, this);
    return truncate && formatted.length > truncate ? formatted.substring(0, truncate) + '…' : formatted;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(options) {
    return options.get('formatHref', this.toHref(options.get('defaultProtocol')), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(protocol = defaults.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(protocol),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(options) {
    return {
      type: this.t,
      value: this.toFormattedString(options),
      isLink: this.isLink,
      href: this.toFormattedHref(options),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(options) {
    return options.get('validate', this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(options) {
    const token = this;
    const href = this.toHref(options.get('defaultProtocol'));
    const formattedHref = options.get('formatHref', href, this);
    const tagName = options.get('tagName', href, token);
    const content = this.toFormattedString(options);
    const attributes = {};
    const className = options.get('className', href, token);
    const target = options.get('target', href, token);
    const rel = options.get('rel', href, token);
    const attrs = options.getObj('attributes', href, token);
    const eventListeners = options.getObj('events', href, token);
    attributes.href = formattedHref;
    if (className) {
      attributes.class = className;
    }
    if (target) {
      attributes.target = target;
    }
    if (rel) {
      attributes.rel = rel;
    }
    if (attrs) {
      Object.assign(attributes, attrs);
    }
    return {
      tagName,
      attributes,
      content,
      eventListeners
    };
  }
};

/**
 * Create a new token that can be emitted by the parser state machine
 * @param {string} type readable type of the token
 * @param {object} props properties to assign or override, including isLink = true or false
 * @returns {new (value: string, tokens: Token[]) => MultiToken} new token class
 */
function createTokenClass(type, props) {
  class Token extends MultiToken {
    constructor(value, tokens) {
      super(value, tokens);
      this.t = type;
    }
  }
  for (const p in props) {
    Token.prototype[p] = props[p];
  }
  Token.t = type;
  return Token;
}

/**
	Represents a list of tokens making up a valid email address
*/
const Email = createTokenClass('email', {
  isLink: true,
  toHref() {
    return 'mailto:' + this.toString();
  }
});

/**
	Represents some plain text
*/
const Text = createTokenClass('text');

/**
	Multi-linebreak token - represents a line break
	@class Nl
*/
const Nl = createTokenClass('nl');

/**
	Represents a list of text tokens making up a valid URL
	@class Url
*/
const Url = createTokenClass('url', {
  isLink: true,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(scheme = defaults.defaultProtocol) {
    // Check if already has a prefix scheme
    return this.hasProtocol() ? this.v : `${scheme}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const tokens = this.tk;
    return tokens.length >= 2 && tokens[0].t !== LOCALHOST && tokens[1].t === COLON;
  }
});
var multi = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Base: MultiToken,
  Email: Email,
  MultiToken: MultiToken,
  Nl: Nl,
  Text: Text,
  Url: Url,
  createTokenClass: createTokenClass
});

/**
	Not exactly parser, more like the second-stage scanner (although we can
	theoretically hotswap the code here with a real parser in the future... but
	for a little URL-finding utility abstract syntax trees may be a little
	overkill).

	URL format: http://en.wikipedia.org/wiki/URI_scheme
	Email format: http://en.wikipedia.org/wiki/EmailAddress (links to RFC in
	reference)

	@module linkify
	@submodule parser
	@main run
*/

const makeState = arg => new State(arg);

/**
 * Generate the parser multi token-based state machine
 * @param {{ groups: Collections<string> }} tokens
 */
function init$1({
  groups
}) {
  // Types of characters the URL can definitely end in
  const qsAccepting = groups.domain.concat([AMPERSAND, ASTERISK, AT, BACKSLASH, BACKTICK, CARET, DOLLAR, EQUALS, HYPHEN, NUM, PERCENT, PIPE, PLUS, POUND, SLASH, SYM, TILDE, UNDERSCORE]);

  // Types of tokens that can follow a URL and be part of the query string
  // but cannot be the very last characters
  // Characters that cannot appear in the URL at all should be excluded
  const qsNonAccepting = [APOSTROPHE, COLON, COMMA, DOT, EXCLAMATION, PERCENT, QUERY, QUOTE, SEMI, OPENANGLEBRACKET, CLOSEANGLEBRACKET, OPENBRACE, CLOSEBRACE, CLOSEBRACKET, OPENBRACKET, OPENPAREN, CLOSEPAREN, FULLWIDTHLEFTPAREN, FULLWIDTHRIGHTPAREN, LEFTCORNERBRACKET, RIGHTCORNERBRACKET, LEFTWHITECORNERBRACKET, RIGHTWHITECORNERBRACKET, FULLWIDTHLESSTHAN, FULLWIDTHGREATERTHAN];

  // For addresses without the mailto prefix
  // Tokens allowed in the localpart of the email
  const localpartAccepting = [AMPERSAND, APOSTROPHE, ASTERISK, BACKSLASH, BACKTICK, CARET, DOLLAR, EQUALS, HYPHEN, OPENBRACE, CLOSEBRACE, PERCENT, PIPE, PLUS, POUND, QUERY, SLASH, SYM, TILDE, UNDERSCORE];

  // The universal starting state.
  /**
   * @type State<Token>
   */
  const Start = makeState();
  const Localpart = tt(Start, TILDE); // Local part of the email address
  ta(Localpart, localpartAccepting, Localpart);
  ta(Localpart, groups.domain, Localpart);
  const Domain = makeState(),
    Scheme = makeState(),
    SlashScheme = makeState();
  ta(Start, groups.domain, Domain); // parsed string ends with a potential domain name (A)
  ta(Start, groups.scheme, Scheme); // e.g., 'mailto'
  ta(Start, groups.slashscheme, SlashScheme); // e.g., 'http'

  ta(Domain, localpartAccepting, Localpart);
  ta(Domain, groups.domain, Domain);
  const LocalpartAt = tt(Domain, AT); // Local part of the email address plus @

  tt(Localpart, AT, LocalpartAt); // close to an email address now

  // Local part of an email address can be e.g. 'http' or 'mailto'
  tt(Scheme, AT, LocalpartAt);
  tt(SlashScheme, AT, LocalpartAt);
  const LocalpartDot = tt(Localpart, DOT); // Local part of the email address plus '.' (localpart cannot end in .)
  ta(LocalpartDot, localpartAccepting, Localpart);
  ta(LocalpartDot, groups.domain, Localpart);
  const EmailDomain = makeState();
  ta(LocalpartAt, groups.domain, EmailDomain); // parsed string starts with local email info + @ with a potential domain name
  ta(EmailDomain, groups.domain, EmailDomain);
  const EmailDomainDot = tt(EmailDomain, DOT); // domain followed by DOT
  ta(EmailDomainDot, groups.domain, EmailDomain);
  const Email$1 = makeState(Email); // Possible email address (could have more tlds)
  ta(EmailDomainDot, groups.tld, Email$1);
  ta(EmailDomainDot, groups.utld, Email$1);
  tt(LocalpartAt, LOCALHOST, Email$1);

  // Hyphen can jump back to a domain name
  const EmailDomainHyphen = tt(EmailDomain, HYPHEN); // parsed string starts with local email info + @ with a potential domain name
  tt(EmailDomainHyphen, HYPHEN, EmailDomainHyphen);
  ta(EmailDomainHyphen, groups.domain, EmailDomain);
  ta(Email$1, groups.domain, EmailDomain);
  tt(Email$1, DOT, EmailDomainDot);
  tt(Email$1, HYPHEN, EmailDomainHyphen);

  // Final possible email states
  const EmailColon = tt(Email$1, COLON); // URL followed by colon (potential port number here)
  /*const EmailColonPort = */
  ta(EmailColon, groups.numeric, Email); // URL followed by colon and port number

  // Account for dots and hyphens. Hyphens are usually parts of domain names
  // (but not TLDs)
  const DomainHyphen = tt(Domain, HYPHEN); // domain followed by hyphen
  const DomainDot = tt(Domain, DOT); // domain followed by DOT
  tt(DomainHyphen, HYPHEN, DomainHyphen);
  ta(DomainHyphen, groups.domain, Domain);
  ta(DomainDot, localpartAccepting, Localpart);
  ta(DomainDot, groups.domain, Domain);
  const DomainDotTld = makeState(Url); // Simplest possible URL with no query string
  ta(DomainDot, groups.tld, DomainDotTld);
  ta(DomainDot, groups.utld, DomainDotTld);
  ta(DomainDotTld, groups.domain, Domain);
  ta(DomainDotTld, localpartAccepting, Localpart);
  tt(DomainDotTld, DOT, DomainDot);
  tt(DomainDotTld, HYPHEN, DomainHyphen);
  tt(DomainDotTld, AT, LocalpartAt);
  const DomainDotTldColon = tt(DomainDotTld, COLON); // URL followed by colon (potential port number here)
  const DomainDotTldColonPort = makeState(Url); // TLD followed by a port number
  ta(DomainDotTldColon, groups.numeric, DomainDotTldColonPort);

  // Long URL with optional port and maybe query string
  const Url$1 = makeState(Url);

  // URL with extra symbols at the end, followed by an opening bracket
  const UrlNonaccept = makeState(); // URL followed by some symbols (will not be part of the final URL)

  // Query strings
  ta(Url$1, qsAccepting, Url$1);
  ta(Url$1, qsNonAccepting, UrlNonaccept);
  ta(UrlNonaccept, qsAccepting, Url$1);
  ta(UrlNonaccept, qsNonAccepting, UrlNonaccept);

  // Become real URLs after `SLASH` or `COLON NUM SLASH`
  // Here works with or without scheme:// prefix
  tt(DomainDotTld, SLASH, Url$1);
  tt(DomainDotTldColonPort, SLASH, Url$1);

  // Note that domains that begin with schemes are treated slighly differently
  const SchemeColon = tt(Scheme, COLON); // e.g., 'mailto:'
  const SlashSchemeColon = tt(SlashScheme, COLON); // e.g., 'http:'
  const SlashSchemeColonSlash = tt(SlashSchemeColon, SLASH); // e.g., 'http:/'

  const UriPrefix = tt(SlashSchemeColonSlash, SLASH); // e.g., 'http://'

  // Scheme states can transition to domain states
  ta(Scheme, groups.domain, Domain);
  tt(Scheme, DOT, DomainDot);
  tt(Scheme, HYPHEN, DomainHyphen);
  ta(SlashScheme, groups.domain, Domain);
  tt(SlashScheme, DOT, DomainDot);
  tt(SlashScheme, HYPHEN, DomainHyphen);

  // Force URL with scheme prefix followed by anything sane
  ta(SchemeColon, groups.domain, Url$1);
  tt(SchemeColon, SLASH, Url$1);
  tt(SchemeColon, QUERY, Url$1);
  ta(UriPrefix, groups.domain, Url$1);
  ta(UriPrefix, qsAccepting, Url$1);
  tt(UriPrefix, SLASH, Url$1);
  const bracketPairs = [[OPENBRACE, CLOSEBRACE],
  // {}
  [OPENBRACKET, CLOSEBRACKET],
  // []
  [OPENPAREN, CLOSEPAREN],
  // ()
  [OPENANGLEBRACKET, CLOSEANGLEBRACKET],
  // <>
  [FULLWIDTHLEFTPAREN, FULLWIDTHRIGHTPAREN],
  // （）
  [LEFTCORNERBRACKET, RIGHTCORNERBRACKET],
  // 「」
  [LEFTWHITECORNERBRACKET, RIGHTWHITECORNERBRACKET],
  // 『』
  [FULLWIDTHLESSTHAN, FULLWIDTHGREATERTHAN] // ＜＞
  ];
  for (let i = 0; i < bracketPairs.length; i++) {
    const [OPEN, CLOSE] = bracketPairs[i];
    const UrlOpen = tt(Url$1, OPEN); // URL followed by open bracket

    // Continue not accepting for open brackets
    tt(UrlNonaccept, OPEN, UrlOpen);

    // Closing bracket component. This character WILL be included in the URL
    tt(UrlOpen, CLOSE, Url$1);

    // URL that beings with an opening bracket, followed by a symbols.
    // Note that the final state can still be `UrlOpen` (if the URL has a
    // single opening bracket for some reason).
    const UrlOpenQ = makeState(Url);
    ta(UrlOpen, qsAccepting, UrlOpenQ);
    const UrlOpenSyms = makeState(); // UrlOpen followed by some symbols it cannot end it
    ta(UrlOpen, qsNonAccepting);

    // URL that begins with an opening bracket, followed by some symbols
    ta(UrlOpenQ, qsAccepting, UrlOpenQ);
    ta(UrlOpenQ, qsNonAccepting, UrlOpenSyms);
    ta(UrlOpenSyms, qsAccepting, UrlOpenQ);
    ta(UrlOpenSyms, qsNonAccepting, UrlOpenSyms);

    // Close brace/bracket to become regular URL
    tt(UrlOpenQ, CLOSE, Url$1);
    tt(UrlOpenSyms, CLOSE, Url$1);
  }
  tt(Start, LOCALHOST, DomainDotTld); // localhost is a valid URL state
  tt(Start, NL, Nl); // single new line

  return {
    start: Start,
    tokens: tk
  };
}

/**
 * Run the parser state machine on a list of scanned string-based tokens to
 * create a list of multi tokens, each of which represents a URL, email address,
 * plain text, etc.
 *
 * @param {State<MultiToken>} start parser start state
 * @param {string} input the original input used to generate the given tokens
 * @param {Token[]} tokens list of scanned tokens
 * @returns {MultiToken[]}
 */
function run(start, input, tokens) {
  let len = tokens.length;
  let cursor = 0;
  let multis = [];
  let textTokens = [];
  while (cursor < len) {
    let state = start;
    let secondState = null;
    let nextState = null;
    let multiLength = 0;
    let latestAccepting = null;
    let sinceAccepts = -1;
    while (cursor < len && !(secondState = state.go(tokens[cursor].t))) {
      // Starting tokens with nowhere to jump to.
      // Consider these to be just plain text
      textTokens.push(tokens[cursor++]);
    }
    while (cursor < len && (nextState = secondState || state.go(tokens[cursor].t))) {
      // Get the next state
      secondState = null;
      state = nextState;

      // Keep track of the latest accepting state
      if (state.accepts()) {
        sinceAccepts = 0;
        latestAccepting = state;
      } else if (sinceAccepts >= 0) {
        sinceAccepts++;
      }
      cursor++;
      multiLength++;
    }
    if (sinceAccepts < 0) {
      // No accepting state was found, part of a regular text token add
      // the first text token to the text tokens array and try again from
      // the next
      cursor -= multiLength;
      if (cursor < len) {
        textTokens.push(tokens[cursor]);
        cursor++;
      }
    } else {
      // Accepting state!
      // First close off the textTokens (if available)
      if (textTokens.length > 0) {
        multis.push(initMultiToken(Text, input, textTokens));
        textTokens = [];
      }

      // Roll back to the latest accepting state
      cursor -= sinceAccepts;
      multiLength -= sinceAccepts;

      // Create a new multitoken
      const Multi = latestAccepting.t;
      const subtokens = tokens.slice(cursor - multiLength, cursor);
      multis.push(initMultiToken(Multi, input, subtokens));
    }
  }

  // Finally close off the textTokens (if available)
  if (textTokens.length > 0) {
    multis.push(initMultiToken(Text, input, textTokens));
  }
  return multis;
}

/**
 * Utility function for instantiating a new multitoken with all the relevant
 * fields during parsing.
 * @param {new (value: string, tokens: Token[]) => MultiToken} Multi class to instantiate
 * @param {string} input original input string
 * @param {Token[]} tokens consecutive tokens scanned from input string
 * @returns {MultiToken}
 */
function initMultiToken(Multi, input, tokens) {
  const startIdx = tokens[0].s;
  const endIdx = tokens[tokens.length - 1].e;
  const value = input.slice(startIdx, endIdx);
  return new Multi(value, tokens);
}
const warn = typeof console !== 'undefined' && console && console.warn || (() => {});
const warnAdvice = 'until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.';

// Side-effect initialization state
const INIT = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: false
};

/**
 * @typedef {{
 * 	start: State<string>,
 * 	tokens: { groups: Collections<string> } & typeof tk
 * }} ScannerInit
 */

/**
 * @typedef {{
 * 	start: State<MultiToken>,
 * 	tokens: typeof multi
 * }} ParserInit
 */

/**
 * @typedef {(arg: { scanner: ScannerInit }) => void} TokenPlugin
 */

/**
 * @typedef {(arg: { scanner: ScannerInit, parser: ParserInit }) => void} Plugin
 */

/**
 * De-register all plugins and reset the internal state-machine. Used for
 * testing; not required in practice.
 * @private
 */
function reset() {
  State.groups = {};
  INIT.scanner = null;
  INIT.parser = null;
  INIT.tokenQueue = [];
  INIT.pluginQueue = [];
  INIT.customSchemes = [];
  INIT.initialized = false;
  return INIT;
}

/**
 * Register a token plugin to allow the scanner to recognize additional token
 * types before the parser state machine is constructed from the results.
 * @param {string} name of plugin to register
 * @param {TokenPlugin} plugin function that accepts the scanner state machine
 * and available scanner tokens and collections and extends the state machine to
 * recognize additional tokens or groups.
 */
function registerTokenPlugin(name, plugin) {
  if (typeof plugin !== 'function') {
    throw new Error(`linkifyjs: Invalid token plugin ${plugin} (expects function)`);
  }
  for (let i = 0; i < INIT.tokenQueue.length; i++) {
    if (name === INIT.tokenQueue[i][0]) {
      warn(`linkifyjs: token plugin "${name}" already registered - will be overwritten`);
      INIT.tokenQueue[i] = [name, plugin];
      return;
    }
  }
  INIT.tokenQueue.push([name, plugin]);
  if (INIT.initialized) {
    warn(`linkifyjs: already initialized - will not register token plugin "${name}" ${warnAdvice}`);
  }
}

/**
 * Register a linkify plugin
 * @param {string} name of plugin to register
 * @param {Plugin} plugin function that accepts the parser state machine and
 * extends the parser to recognize additional link types
 */
function registerPlugin(name, plugin) {
  if (typeof plugin !== 'function') {
    throw new Error(`linkifyjs: Invalid plugin ${plugin} (expects function)`);
  }
  for (let i = 0; i < INIT.pluginQueue.length; i++) {
    if (name === INIT.pluginQueue[i][0]) {
      warn(`linkifyjs: plugin "${name}" already registered - will be overwritten`);
      INIT.pluginQueue[i] = [name, plugin];
      return;
    }
  }
  INIT.pluginQueue.push([name, plugin]);
  if (INIT.initialized) {
    warn(`linkifyjs: already initialized - will not register plugin "${name}" ${warnAdvice}`);
  }
}

/**
 * Detect URLs with the following additional protocol. Anything with format
 * "protocol://..." will be considered a link. If `optionalSlashSlash` is set to
 * `true`, anything with format "protocol:..." will be considered a link.
 * @param {string} scheme
 * @param {boolean} [optionalSlashSlash]
 */
function registerCustomProtocol(scheme, optionalSlashSlash = false) {
  if (INIT.initialized) {
    warn(`linkifyjs: already initialized - will not register custom scheme "${scheme}" ${warnAdvice}`);
  }
  if (!/^[0-9a-z]+(-[0-9a-z]+)*$/.test(scheme)) {
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  }
  INIT.customSchemes.push([scheme, optionalSlashSlash]);
}

/**
 * Initialize the linkify state machine. Called automatically the first time
 * linkify is called on a string, but may be called manually as well.
 */
function init() {
  // Initialize scanner state machine and plugins
  INIT.scanner = init$2(INIT.customSchemes);
  for (let i = 0; i < INIT.tokenQueue.length; i++) {
    INIT.tokenQueue[i][1]({
      scanner: INIT.scanner
    });
  }

  // Initialize parser state machine and plugins
  INIT.parser = init$1(INIT.scanner.tokens);
  for (let i = 0; i < INIT.pluginQueue.length; i++) {
    INIT.pluginQueue[i][1]({
      scanner: INIT.scanner,
      parser: INIT.parser
    });
  }
  INIT.initialized = true;
  return INIT;
}

/**
 * Parse a string into tokens that represent linkable and non-linkable sub-components
 * @param {string} str
 * @return {MultiToken[]} tokens
 */
function tokenize(str) {
  if (!INIT.initialized) {
    init();
  }
  return run(INIT.parser.start, str, run$1(INIT.scanner.start, str));
}
tokenize.scan = run$1; // for testing

/**
 * Find a list of linkable items in the given string.
 * @param {string} str string to find links in
 * @param {string | Opts} [type] either formatting options or specific type of
 * links to find, e.g., 'url' or 'email'
 * @param {Opts} [opts] formatting options for final output. Cannot be specified
 * if opts already provided in `type` argument
 */
function find(str, type = null, opts = null) {
  if (type && typeof type === 'object') {
    if (opts) {
      throw Error(`linkifyjs: Invalid link type ${type}; must be a string`);
    }
    opts = type;
    type = null;
  }
  const options = new Options(opts);
  const tokens = tokenize(str);
  const filtered = [];
  for (let i = 0; i < tokens.length; i++) {
    const token = tokens[i];
    if (token.isLink && (!type || token.t === type) && options.check(token)) {
      filtered.push(token.toFormattedObject(options));
    }
  }
  return filtered;
}

/**
 * Is the given string valid linkable text of some sort. Note that this does not
 * trim the text for you.
 *
 * Optionally pass in a second `type` param, which is the type of link to test
 * for.
 *
 * For example,
 *
 *     linkify.test(str, 'email');
 *
 * Returns `true` if str is a valid email.
 * @param {string} str string to test for links
 * @param {string} [type] optional specific link type to look for
 * @returns boolean true/false
 */
function test(str, type = null) {
  const tokens = tokenize(str);
  return tokens.length === 1 && tokens[0].isLink && (!type || tokens[0].t === type);
}


/***/ }),

/***/ 75367:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dq": function() { return /* binding */ useFieldArray; },
/* harmony export */   "Gc": function() { return /* binding */ useFormContext; },
/* harmony export */   "KN": function() { return /* binding */ appendErrors; },
/* harmony export */   "Qr": function() { return /* binding */ Controller; },
/* harmony export */   "RV": function() { return /* binding */ FormProvider; },
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "cI": function() { return /* binding */ useForm; },
/* harmony export */   "t8": function() { return /* binding */ set; }
/* harmony export */ });
/* unused harmony exports Form, useController, useFormState, useWatch */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);

var isCheckBoxInput = element => element.type === 'checkbox';
var isDateObject = value => value instanceof Date;
var isNullOrUndefined = value => value == null;
const isObjectType = value => typeof value === 'object';
var isObject = value => !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !isDateObject(value);
var getEventValue = event => isObject(event) && event.target ? isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var getNodeParentName = name => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));
var isPlainObject = tempObject => {
  const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
  return isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function cloneObject(data) {
  let copy;
  const isArray = Array.isArray(data);
  if (data instanceof Date) {
    copy = new Date(data);
  } else if (data instanceof Set) {
    copy = new Set(data);
  } else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || isObject(data))) {
    copy = isArray ? [] : {};
    if (!isArray && !isPlainObject(data)) {
      copy = data;
    } else {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          copy[key] = cloneObject(data[key]);
        }
      }
    }
  } else {
    return data;
  }
  return copy;
}
var compact = value => Array.isArray(value) ? value.filter(Boolean) : [];
var isUndefined = val => val === undefined;
var get = (obj, path, defaultValue) => {
  if (!path || !isObject(obj)) {
    return defaultValue;
  }
  const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], obj);
  return isUndefined(result) || result === obj ? isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};
var isBoolean = value => typeof value === 'boolean';
const EVENTS = {
  BLUR: 'blur',
  FOCUS_OUT: 'focusout',
  CHANGE: 'change'
};
const VALIDATION_MODE = {
  onBlur: 'onBlur',
  onChange: 'onChange',
  onSubmit: 'onSubmit',
  onTouched: 'onTouched',
  all: 'all'
};
const INPUT_VALIDATION_RULES = {
  max: 'max',
  min: 'min',
  maxLength: 'maxLength',
  minLength: 'minLength',
  pattern: 'pattern',
  required: 'required',
  validate: 'validate'
};
const HookFormContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const useFormContext = () => react__WEBPACK_IMPORTED_MODULE_0__.useContext(HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const FormProvider = props => {
  const {
    children,
    ...data
  } = props;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(HookFormContext.Provider, {
    value: data
  }, children);
};
var getProxyFormState = (formState, control, localProxyFormState, isRoot = true) => {
  const result = {
    defaultValues: control._defaultValues
  };
  for (const key in formState) {
    Object.defineProperty(result, key, {
      get: () => {
        const _key = key;
        if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
          control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
        }
        localProxyFormState && (localProxyFormState[_key] = true);
        return formState[_key];
      }
    });
  }
  return result;
};
var isEmptyObject = value => isObject(value) && !Object.keys(value).length;
var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot) => {
  updateFormState(formStateData);
  const {
    name,
    ...formState
  } = formStateData;
  return isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find(key => _proxyFormState[key] === (!isRoot || VALIDATION_MODE.all));
};
var convertToArrayPayload = value => Array.isArray(value) ? value : [value];
var shouldSubscribeByName = (name, signalName, exact) => !name || !signalName || name === signalName || convertToArrayPayload(name).some(currentName => currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function useSubscribe(props) {
  const _props = react__WEBPACK_IMPORTED_MODULE_0__.useRef(props);
  _props.current = props;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
      next: _props.current.next
    });
    return () => {
      subscription && subscription.unsubscribe();
    };
  }, [props.disabled]);
}

/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFormState(props) {
  const methods = useFormContext();
  const {
    control = methods.control,
    disabled,
    name,
    exact
  } = props || {};
  const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState(control._formState);
  const _mounted = react__WEBPACK_IMPORTED_MODULE_0__.useRef(true);
  const _localProxyFormState = react__WEBPACK_IMPORTED_MODULE_0__.useRef({
    isDirty: false,
    isLoading: false,
    dirtyFields: false,
    touchedFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  });
  const _name = react__WEBPACK_IMPORTED_MODULE_0__.useRef(name);
  _name.current = name;
  useSubscribe({
    disabled,
    next: value => _mounted.current && shouldSubscribeByName(_name.current, value.name, exact) && shouldRenderFormState(value, _localProxyFormState.current, control._updateFormState) && updateFormState({
      ...control._formState,
      ...value
    }),
    subject: control._subjects.state
  });
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    _mounted.current = true;
    _localProxyFormState.current.isValid && control._updateValid(true);
    return () => {
      _mounted.current = false;
    };
  }, [control]);
  return getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var isString = value => typeof value === 'string';
var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue) => {
  if (isString(names)) {
    isGlobal && _names.watch.add(names);
    return get(formValues, names, defaultValue);
  }
  if (Array.isArray(names)) {
    return names.map(fieldName => (isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
  }
  isGlobal && (_names.watchAll = true);
  return formValues;
};

/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */
function useWatch(props) {
  const methods = useFormContext();
  const {
    control = methods.control,
    name,
    defaultValue,
    disabled,
    exact
  } = props || {};
  const _name = react__WEBPACK_IMPORTED_MODULE_0__.useRef(name);
  _name.current = name;
  useSubscribe({
    disabled,
    subject: control._subjects.values,
    next: formState => {
      if (shouldSubscribeByName(_name.current, formState.name, exact)) {
        updateValue(cloneObject(generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
      }
    }
  });
  const [value, updateValue] = react__WEBPACK_IMPORTED_MODULE_0__.useState(control._getWatch(name, defaultValue));
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => control._removeUnmounted());
  return value;
}
var isKey = value => /^\w*$/.test(value);
var stringToPath = input => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
function set(object, path, value) {
  let index = -1;
  const tempPath = isKey(path) ? [path] : stringToPath(path);
  const length = tempPath.length;
  const lastIndex = length - 1;
  while (++index < length) {
    const key = tempPath[index];
    let newValue = value;
    if (index !== lastIndex) {
      const objValue = object[key];
      newValue = isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
    }
    object[key] = newValue;
    object = object[key];
  }
  return object;
}

/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */
function useController(props) {
  const methods = useFormContext();
  const {
    name,
    disabled,
    control = methods.control,
    shouldUnregister
  } = props;
  const isArrayField = isNameInFieldArray(control._names.array, name);
  const value = useWatch({
    control,
    name,
    defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
    exact: true
  });
  const formState = useFormState({
    control,
    name
  });
  const _registerProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef(control.register(name, {
    ...props.rules,
    value
  }));
  _registerProps.current = control.register(name, props.rules);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
    const updateMounted = (name, value) => {
      const field = get(control._fields, name);
      if (field) {
        field._f.mount = value;
      }
    };
    updateMounted(name, true);
    if (_shouldUnregisterField) {
      const value = cloneObject(get(control._options.defaultValues, name));
      set(control._defaultValues, name, value);
      if (isUndefined(get(control._formValues, name))) {
        set(control._formValues, name, value);
      }
    }
    return () => {
      (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
    };
  }, [name, control, isArrayField, shouldUnregister]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (get(control._fields, name)) {
      control._updateDisabledField({
        disabled,
        fields: control._fields,
        name,
        value: get(control._fields, name)._f.value
      });
    }
  }, [disabled, name, control]);
  return {
    field: {
      name,
      value,
      ...(isBoolean(disabled) || isBoolean(formState.disabled) ? {
        disabled: formState.disabled || disabled
      } : {}),
      onChange: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(event => _registerProps.current.onChange({
        target: {
          value: getEventValue(event),
          name: name
        },
        type: EVENTS.CHANGE
      }), [name]),
      onBlur: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => _registerProps.current.onBlur({
        target: {
          value: get(control._formValues, name),
          name: name
        },
        type: EVENTS.BLUR
      }), [name, control]),
      ref: elm => {
        const field = get(control._fields, name);
        if (field && elm) {
          field._f.ref = {
            focus: () => elm.focus(),
            select: () => elm.select(),
            setCustomValidity: message => elm.setCustomValidity(message),
            reportValidity: () => elm.reportValidity()
          };
        }
      }
    },
    formState,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: true,
        get: () => !!get(formState.errors, name)
      },
      isDirty: {
        enumerable: true,
        get: () => !!get(formState.dirtyFields, name)
      },
      isTouched: {
        enumerable: true,
        get: () => !!get(formState.touchedFields, name)
      },
      error: {
        enumerable: true,
        get: () => get(formState.errors, name)
      }
    })
  };
}

/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */
const Controller = props => props.render(useController(props));
const POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */
function Form(props) {
  const methods = useFormContext();
  const [mounted, setMounted] = React.useState(false);
  const {
    control = methods.control,
    onSubmit,
    children,
    action,
    method = POST_REQUEST,
    headers,
    encType,
    onError,
    render,
    onSuccess,
    validateStatus,
    ...rest
  } = props;
  const submit = async event => {
    let hasError = false;
    let type = '';
    await control.handleSubmit(async data => {
      const formData = new FormData();
      let formDataJson = '';
      try {
        formDataJson = JSON.stringify(data);
      } catch (_a) {}
      for (const name of control._names.mount) {
        formData.append(name, get(data, name));
      }
      if (onSubmit) {
        await onSubmit({
          data,
          event,
          method,
          formData,
          formDataJson
        });
      }
      if (action) {
        try {
          const shouldStringifySubmissionData = [headers && headers['Content-Type'], encType].some(value => value && value.includes('json'));
          const response = await fetch(action, {
            method,
            headers: {
              ...headers,
              ...(encType ? {
                'Content-Type': encType
              } : {})
            },
            body: shouldStringifySubmissionData ? formDataJson : formData
          });
          if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
            hasError = true;
            onError && onError({
              response
            });
            type = String(response.status);
          } else {
            onSuccess && onSuccess({
              response
            });
          }
        } catch (error) {
          hasError = true;
          onError && onError({
            error
          });
        }
      }
    })(event);
    if (hasError && props.control) {
      props.control._subjects.state.next({
        isSubmitSuccessful: false
      });
      props.control.setError('root.server', {
        type
      });
    }
  };
  React.useEffect(() => {
    setMounted(true);
  }, []);
  return render ? React.createElement(React.Fragment, null, render({
    submit
  })) : React.createElement("form", {
    noValidate: mounted,
    action: action,
    method: method,
    encType: encType,
    onSubmit: submit,
    ...rest
  }, children);
}
var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria ? {
  ...errors[name],
  types: {
    ...(errors[name] && errors[name].types ? errors[name].types : {}),
    [type]: message || true
  }
} : {};
var generateId = () => {
  const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16 + d) % 16 | 0;
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
};
var getFocusFieldName = (name, index, options = {}) => options.shouldFocus || isUndefined(options.shouldFocus) ? options.focusName || `${name}.${isUndefined(options.focusIndex) ? index : options.focusIndex}.` : '';
var getValidationModes = mode => ({
  isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
  isOnBlur: mode === VALIDATION_MODE.onBlur,
  isOnChange: mode === VALIDATION_MODE.onChange,
  isOnAll: mode === VALIDATION_MODE.all,
  isOnTouch: mode === VALIDATION_MODE.onTouched
});
var isWatched = (name, _names, isBlurEvent) => !isBlurEvent && (_names.watchAll || _names.watch.has(name) || [..._names.watch].some(watchName => name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const iterateFieldsByAction = (fields, action, fieldsNames, abortEarly) => {
  for (const key of fieldsNames || Object.keys(fields)) {
    const field = get(fields, key);
    if (field) {
      const {
        _f,
        ...currentField
      } = field;
      if (_f) {
        if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) {
          break;
        } else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) {
          break;
        }
      } else if (isObject(currentField)) {
        iterateFieldsByAction(currentField, action);
      }
    }
  }
};
var updateFieldArrayRootError = (errors, error, name) => {
  const fieldArrayErrors = compact(get(errors, name));
  set(fieldArrayErrors, 'root', error[name]);
  set(errors, name, fieldArrayErrors);
  return errors;
};
var isFileInput = element => element.type === 'file';
var isFunction = value => typeof value === 'function';
var isHTMLElement = value => {
  if (!isWeb) {
    return false;
  }
  const owner = value ? value.ownerDocument : 0;
  return value instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var isMessage = value => isString(value);
var isRadioInput = element => element.type === 'radio';
var isRegex = value => value instanceof RegExp;
const defaultResult = {
  value: false,
  isValid: false
};
const validResult = {
  value: true,
  isValid: true
};
var getCheckboxValue = options => {
  if (Array.isArray(options)) {
    if (options.length > 1) {
      const values = options.filter(option => option && option.checked && !option.disabled).map(option => option.value);
      return {
        value: values,
        isValid: !!values.length
      };
    }
    return options[0].checked && !options[0].disabled ?
    // @ts-expect-error expected to work in the browser
    options[0].attributes && !isUndefined(options[0].attributes.value) ? isUndefined(options[0].value) || options[0].value === '' ? validResult : {
      value: options[0].value,
      isValid: true
    } : validResult : defaultResult;
  }
  return defaultResult;
};
const defaultReturn = {
  isValid: false,
  value: null
};
var getRadioValue = options => Array.isArray(options) ? options.reduce((previous, option) => option && option.checked && !option.disabled ? {
  isValid: true,
  value: option.value
} : previous, defaultReturn) : defaultReturn;
function getValidateError(result, ref, type = 'validate') {
  if (isMessage(result) || Array.isArray(result) && result.every(isMessage) || isBoolean(result) && !result) {
    return {
      type,
      message: isMessage(result) ? result : '',
      ref
    };
  }
}
var getValueAndMessage = validationData => isObject(validationData) && !isRegex(validationData) ? validationData : {
  value: validationData,
  message: ''
};
var validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
  const {
    ref,
    refs,
    required,
    maxLength,
    minLength,
    min,
    max,
    pattern,
    validate,
    name,
    valueAsNumber,
    mount,
    disabled
  } = field._f;
  const inputValue = get(formValues, name);
  if (!mount || disabled) {
    return {};
  }
  const inputRef = refs ? refs[0] : ref;
  const setCustomValidity = message => {
    if (shouldUseNativeValidation && inputRef.reportValidity) {
      inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
      inputRef.reportValidity();
    }
  };
  const error = {};
  const isRadio = isRadioInput(ref);
  const isCheckBox = isCheckBoxInput(ref);
  const isRadioOrCheckbox = isRadio || isCheckBox;
  const isEmpty = (valueAsNumber || isFileInput(ref)) && isUndefined(ref.value) && isUndefined(inputValue) || isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
  const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
  const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
    const message = exceedMax ? maxLengthMessage : minLengthMessage;
    error[name] = {
      type: exceedMax ? maxType : minType,
      message,
      ref,
      ...appendErrorsCurry(exceedMax ? maxType : minType, message)
    };
  };
  if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue)) || isBoolean(inputValue) && !inputValue || isCheckBox && !getCheckboxValue(refs).isValid || isRadio && !getRadioValue(refs).isValid)) {
    const {
      value,
      message
    } = isMessage(required) ? {
      value: !!required,
      message: required
    } : getValueAndMessage(required);
    if (value) {
      error[name] = {
        type: INPUT_VALIDATION_RULES.required,
        message,
        ref: inputRef,
        ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message)
      };
      if (!validateAllFieldCriteria) {
        setCustomValidity(message);
        return error;
      }
    }
  }
  if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
    let exceedMax;
    let exceedMin;
    const maxOutput = getValueAndMessage(max);
    const minOutput = getValueAndMessage(min);
    if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
      const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
      if (!isNullOrUndefined(maxOutput.value)) {
        exceedMax = valueNumber > maxOutput.value;
      }
      if (!isNullOrUndefined(minOutput.value)) {
        exceedMin = valueNumber < minOutput.value;
      }
    } else {
      const valueDate = ref.valueAsDate || new Date(inputValue);
      const convertTimeToDate = time => new Date(new Date().toDateString() + ' ' + time);
      const isTime = ref.type == 'time';
      const isWeek = ref.type == 'week';
      if (isString(maxOutput.value) && inputValue) {
        exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
      }
      if (isString(minOutput.value) && inputValue) {
        exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
      }
    }
    if (exceedMax || exceedMin) {
      getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
      if (!validateAllFieldCriteria) {
        setCustomValidity(error[name].message);
        return error;
      }
    }
  }
  if ((maxLength || minLength) && !isEmpty && (isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
    const maxLengthOutput = getValueAndMessage(maxLength);
    const minLengthOutput = getValueAndMessage(minLength);
    const exceedMax = !isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
    const exceedMin = !isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
    if (exceedMax || exceedMin) {
      getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
      if (!validateAllFieldCriteria) {
        setCustomValidity(error[name].message);
        return error;
      }
    }
  }
  if (pattern && !isEmpty && isString(inputValue)) {
    const {
      value: patternValue,
      message
    } = getValueAndMessage(pattern);
    if (isRegex(patternValue) && !inputValue.match(patternValue)) {
      error[name] = {
        type: INPUT_VALIDATION_RULES.pattern,
        message,
        ref,
        ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message)
      };
      if (!validateAllFieldCriteria) {
        setCustomValidity(message);
        return error;
      }
    }
  }
  if (validate) {
    if (isFunction(validate)) {
      const result = await validate(inputValue, formValues);
      const validateError = getValidateError(result, inputRef);
      if (validateError) {
        error[name] = {
          ...validateError,
          ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message)
        };
        if (!validateAllFieldCriteria) {
          setCustomValidity(validateError.message);
          return error;
        }
      }
    } else if (isObject(validate)) {
      let validationResult = {};
      for (const key in validate) {
        if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
          break;
        }
        const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
        if (validateError) {
          validationResult = {
            ...validateError,
            ...appendErrorsCurry(key, validateError.message)
          };
          setCustomValidity(validateError.message);
          if (validateAllFieldCriteria) {
            error[name] = validationResult;
          }
        }
      }
      if (!isEmptyObject(validationResult)) {
        error[name] = {
          ref: inputRef,
          ...validationResult
        };
        if (!validateAllFieldCriteria) {
          return error;
        }
      }
    }
  }
  setCustomValidity(true);
  return error;
};
function append(data, value) {
  return [...data, ...convertToArrayPayload(value)];
}
var fillEmptyArray = value => Array.isArray(value) ? value.map(() => undefined) : undefined;
function insert(data, index, value) {
  return [...data.slice(0, index), ...convertToArrayPayload(value), ...data.slice(index)];
}
var moveArrayAt = (data, from, to) => {
  if (!Array.isArray(data)) {
    return [];
  }
  if (isUndefined(data[to])) {
    data[to] = undefined;
  }
  data.splice(to, 0, data.splice(from, 1)[0]);
  return data;
};
function prepend(data, value) {
  return [...convertToArrayPayload(value), ...convertToArrayPayload(data)];
}
function removeAtIndexes(data, indexes) {
  let i = 0;
  const temp = [...data];
  for (const index of indexes) {
    temp.splice(index - i, 1);
    i++;
  }
  return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index) => isUndefined(index) ? [] : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b) => a - b));
var swapArrayAt = (data, indexA, indexB) => {
  data[indexA] = [data[indexB], data[indexB] = data[indexA]][0];
};
function baseGet(object, updatePath) {
  const length = updatePath.slice(0, -1).length;
  let index = 0;
  while (index < length) {
    object = isUndefined(object) ? index++ : object[updatePath[index++]];
  }
  return object;
}
function isEmptyArray(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) {
      return false;
    }
  }
  return true;
}
function unset(object, path) {
  const paths = Array.isArray(path) ? path : isKey(path) ? [path] : stringToPath(path);
  const childObject = paths.length === 1 ? object : baseGet(object, paths);
  const index = paths.length - 1;
  const key = paths[index];
  if (childObject) {
    delete childObject[key];
  }
  if (index !== 0 && (isObject(childObject) && isEmptyObject(childObject) || Array.isArray(childObject) && isEmptyArray(childObject))) {
    unset(object, paths.slice(0, -1));
  }
  return object;
}
var updateAt = (fieldValues, index, value) => {
  fieldValues[index] = value;
  return fieldValues;
};

/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFieldArray(props) {
  const methods = useFormContext();
  const {
    control = methods.control,
    name,
    keyName = 'id',
    shouldUnregister
  } = props;
  const [fields, setFields] = react__WEBPACK_IMPORTED_MODULE_0__.useState(control._getFieldArray(name));
  const ids = react__WEBPACK_IMPORTED_MODULE_0__.useRef(control._getFieldArray(name).map(generateId));
  const _fieldIds = react__WEBPACK_IMPORTED_MODULE_0__.useRef(fields);
  const _name = react__WEBPACK_IMPORTED_MODULE_0__.useRef(name);
  const _actioned = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  _name.current = name;
  _fieldIds.current = fields;
  control._names.array.add(name);
  props.rules && control.register(name, props.rules);
  useSubscribe({
    next: ({
      values,
      name: fieldArrayName
    }) => {
      if (fieldArrayName === _name.current || !fieldArrayName) {
        const fieldValues = get(values, _name.current);
        if (Array.isArray(fieldValues)) {
          setFields(fieldValues);
          ids.current = fieldValues.map(generateId);
        }
      }
    },
    subject: control._subjects.array
  });
  const updateValues = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(updatedFieldArrayValues => {
    _actioned.current = true;
    control._updateFieldArray(name, updatedFieldArrayValues);
  }, [control, name]);
  const append$1 = (value, options) => {
    const appendValue = convertToArrayPayload(cloneObject(value));
    const updatedFieldArrayValues = append(control._getFieldArray(name), appendValue);
    control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
    ids.current = append(ids.current, appendValue.map(generateId));
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);
    control._updateFieldArray(name, updatedFieldArrayValues, append, {
      argA: fillEmptyArray(value)
    });
  };
  const prepend$1 = (value, options) => {
    const prependValue = convertToArrayPayload(cloneObject(value));
    const updatedFieldArrayValues = prepend(control._getFieldArray(name), prependValue);
    control._names.focus = getFocusFieldName(name, 0, options);
    ids.current = prepend(ids.current, prependValue.map(generateId));
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);
    control._updateFieldArray(name, updatedFieldArrayValues, prepend, {
      argA: fillEmptyArray(value)
    });
  };
  const remove = index => {
    const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
    ids.current = removeArrayAt(ids.current, index);
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);
    control._updateFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
      argA: index
    });
  };
  const insert$1 = (index, value, options) => {
    const insertValue = convertToArrayPayload(cloneObject(value));
    const updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
    control._names.focus = getFocusFieldName(name, index, options);
    ids.current = insert(ids.current, index, insertValue.map(generateId));
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);
    control._updateFieldArray(name, updatedFieldArrayValues, insert, {
      argA: index,
      argB: fillEmptyArray(value)
    });
  };
  const swap = (indexA, indexB) => {
    const updatedFieldArrayValues = control._getFieldArray(name);
    swapArrayAt(updatedFieldArrayValues, indexA, indexB);
    swapArrayAt(ids.current, indexA, indexB);
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);
    control._updateFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
      argA: indexA,
      argB: indexB
    }, false);
  };
  const move = (from, to) => {
    const updatedFieldArrayValues = control._getFieldArray(name);
    moveArrayAt(updatedFieldArrayValues, from, to);
    moveArrayAt(ids.current, from, to);
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);
    control._updateFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
      argA: from,
      argB: to
    }, false);
  };
  const update = (index, value) => {
    const updateValue = cloneObject(value);
    const updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
    ids.current = [...updatedFieldArrayValues].map((item, i) => !item || i === index ? generateId() : ids.current[i]);
    updateValues(updatedFieldArrayValues);
    setFields([...updatedFieldArrayValues]);
    control._updateFieldArray(name, updatedFieldArrayValues, updateAt, {
      argA: index,
      argB: updateValue
    }, true, false);
  };
  const replace = value => {
    const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value));
    ids.current = updatedFieldArrayValues.map(generateId);
    updateValues([...updatedFieldArrayValues]);
    setFields([...updatedFieldArrayValues]);
    control._updateFieldArray(name, [...updatedFieldArrayValues], data => data, {}, true, false);
  };
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    control._state.action = false;
    isWatched(name, control._names) && control._subjects.state.next({
      ...control._formState
    });
    if (_actioned.current && (!getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
      if (control._options.resolver) {
        control._executeSchema([name]).then(result => {
          const error = get(result.errors, name);
          const existingError = get(control._formState.errors, name);
          if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
            error ? set(control._formState.errors, name, error) : unset(control._formState.errors, name);
            control._subjects.state.next({
              errors: control._formState.errors
            });
          }
        });
      } else {
        const field = get(control._fields, name);
        if (field && field._f) {
          validateField(field, control._formValues, control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then(error => !isEmptyObject(error) && control._subjects.state.next({
            errors: updateFieldArrayRootError(control._formState.errors, error, name)
          }));
        }
      }
    }
    control._subjects.values.next({
      name,
      values: {
        ...control._formValues
      }
    });
    control._names.focus && iterateFieldsByAction(control._fields, (ref, key) => {
      if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
        ref.focus();
        return 1;
      }
      return;
    });
    control._names.focus = '';
    control._updateValid();
    _actioned.current = false;
  }, [fields, name, control]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    !get(control._formValues, name) && control._updateFieldArray(name);
    return () => {
      (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
    };
  }, [name, control, keyName, shouldUnregister]);
  return {
    swap: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(swap, [updateValues, name, control]),
    move: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(move, [updateValues, name, control]),
    prepend: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(prepend$1, [updateValues, name, control]),
    append: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(append$1, [updateValues, name, control]),
    remove: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(remove, [updateValues, name, control]),
    insert: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(insert$1, [updateValues, name, control]),
    update: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(update, [updateValues, name, control]),
    replace: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(replace, [updateValues, name, control]),
    fields: react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => fields.map((field, index) => ({
      ...field,
      [keyName]: ids.current[index] || generateId()
    })), [fields, keyName])
  };
}
function createSubject() {
  let _observers = [];
  const next = value => {
    for (const observer of _observers) {
      observer.next && observer.next(value);
    }
  };
  const subscribe = observer => {
    _observers.push(observer);
    return {
      unsubscribe: () => {
        _observers = _observers.filter(o => o !== observer);
      }
    };
  };
  const unsubscribe = () => {
    _observers = [];
  };
  return {
    get observers() {
      return _observers;
    },
    next,
    subscribe,
    unsubscribe
  };
}
var isPrimitive = value => isNullOrUndefined(value) || !isObjectType(value);
function deepEqual(object1, object2) {
  if (isPrimitive(object1) || isPrimitive(object2)) {
    return object1 === object2;
  }
  if (isDateObject(object1) && isDateObject(object2)) {
    return object1.getTime() === object2.getTime();
  }
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const key of keys1) {
    const val1 = object1[key];
    if (!keys2.includes(key)) {
      return false;
    }
    if (key !== 'ref') {
      const val2 = object2[key];
      if (isDateObject(val1) && isDateObject(val2) || isObject(val1) && isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !deepEqual(val1, val2) : val1 !== val2) {
        return false;
      }
    }
  }
  return true;
}
var isMultipleSelect = element => element.type === `select-multiple`;
var isRadioOrCheckbox = ref => isRadioInput(ref) || isCheckBoxInput(ref);
var live = ref => isHTMLElement(ref) && ref.isConnected;
var objectHasFunction = data => {
  for (const key in data) {
    if (isFunction(data[key])) {
      return true;
    }
  }
  return false;
};
function markFieldsDirty(data, fields = {}) {
  const isParentNodeArray = Array.isArray(data);
  if (isObject(data) || isParentNodeArray) {
    for (const key in data) {
      if (Array.isArray(data[key]) || isObject(data[key]) && !objectHasFunction(data[key])) {
        fields[key] = Array.isArray(data[key]) ? [] : {};
        markFieldsDirty(data[key], fields[key]);
      } else if (!isNullOrUndefined(data[key])) {
        fields[key] = true;
      }
    }
  }
  return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
  const isParentNodeArray = Array.isArray(data);
  if (isObject(data) || isParentNodeArray) {
    for (const key in data) {
      if (Array.isArray(data[key]) || isObject(data[key]) && !objectHasFunction(data[key])) {
        if (isUndefined(formValues) || isPrimitive(dirtyFieldsFromValues[key])) {
          dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? markFieldsDirty(data[key], []) : {
            ...markFieldsDirty(data[key])
          };
        } else {
          getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        }
      } else {
        dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
      }
    }
  }
  return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));
var getFieldValueAs = (value, {
  valueAsNumber,
  valueAsDate,
  setValueAs
}) => isUndefined(value) ? value : valueAsNumber ? value === '' ? NaN : value ? +value : value : valueAsDate && isString(value) ? new Date(value) : setValueAs ? setValueAs(value) : value;
function getFieldValue(_f) {
  const ref = _f.ref;
  if (_f.refs ? _f.refs.every(ref => ref.disabled) : ref.disabled) {
    return;
  }
  if (isFileInput(ref)) {
    return ref.files;
  }
  if (isRadioInput(ref)) {
    return getRadioValue(_f.refs).value;
  }
  if (isMultipleSelect(ref)) {
    return [...ref.selectedOptions].map(({
      value
    }) => value);
  }
  if (isCheckBoxInput(ref)) {
    return getCheckboxValue(_f.refs).value;
  }
  return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
  const fields = {};
  for (const name of fieldsNames) {
    const field = get(_fields, name);
    field && set(fields, name, field._f);
  }
  return {
    criteriaMode,
    names: [...fieldsNames],
    fields,
    shouldUseNativeValidation
  };
};
var getRuleValue = rule => isUndefined(rule) ? rule : isRegex(rule) ? rule.source : isObject(rule) ? isRegex(rule.value) ? rule.value.source : rule.value : rule;
var hasValidation = options => options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function schemaErrorLookup(errors, _fields, name) {
  const error = get(errors, name);
  if (error || isKey(name)) {
    return {
      error,
      name
    };
  }
  const names = name.split('.');
  while (names.length) {
    const fieldName = names.join('.');
    const field = get(_fields, fieldName);
    const foundError = get(errors, fieldName);
    if (field && !Array.isArray(field) && name !== fieldName) {
      return {
        name
      };
    }
    if (foundError && foundError.type) {
      return {
        name: fieldName,
        error: foundError
      };
    }
    names.pop();
  }
  return {
    name
  };
}
var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
  if (mode.isOnAll) {
    return false;
  } else if (!isSubmitted && mode.isOnTouch) {
    return !(isTouched || isBlurEvent);
  } else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
    return !isBlurEvent;
  } else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
    return isBlurEvent;
  }
  return true;
};
var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);
const defaultOptions = {
  mode: VALIDATION_MODE.onSubmit,
  reValidateMode: VALIDATION_MODE.onChange,
  shouldFocusError: true
};
function createFormControl(props = {}, flushRootRender) {
  let _options = {
    ...defaultOptions,
    ...props
  };
  let _formState = {
    submitCount: 0,
    isDirty: false,
    isLoading: isFunction(_options.defaultValues),
    isValidating: false,
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    touchedFields: {},
    dirtyFields: {},
    errors: {},
    disabled: false
  };
  let _fields = {};
  let _defaultValues = isObject(_options.defaultValues) || isObject(_options.values) ? cloneObject(_options.defaultValues || _options.values) || {} : {};
  let _formValues = _options.shouldUnregister ? {} : cloneObject(_defaultValues);
  let _state = {
    action: false,
    mount: false,
    watch: false
  };
  let _names = {
    mount: new Set(),
    unMount: new Set(),
    array: new Set(),
    watch: new Set()
  };
  let delayErrorCallback;
  let timer = 0;
  const _proxyFormState = {
    isDirty: false,
    dirtyFields: false,
    touchedFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  };
  const _subjects = {
    values: createSubject(),
    array: createSubject(),
    state: createSubject()
  };
  const shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
  const validationModeBeforeSubmit = getValidationModes(_options.mode);
  const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
  const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
  const debounce = callback => wait => {
    clearTimeout(timer);
    timer = setTimeout(callback, wait);
  };
  const _updateValid = async shouldUpdateValid => {
    if (_proxyFormState.isValid || shouldUpdateValid) {
      const isValid = _options.resolver ? isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
      if (isValid !== _formState.isValid) {
        _subjects.state.next({
          isValid
        });
      }
    }
  };
  const _updateIsValidating = value => _proxyFormState.isValidating && _subjects.state.next({
    isValidating: value
  });
  const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
    if (args && method) {
      _state.action = true;
      if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
        const fieldValues = method(get(_fields, name), args.argA, args.argB);
        shouldSetValues && set(_fields, name, fieldValues);
      }
      if (shouldUpdateFieldsAndState && Array.isArray(get(_formState.errors, name))) {
        const errors = method(get(_formState.errors, name), args.argA, args.argB);
        shouldSetValues && set(_formState.errors, name, errors);
        unsetEmptyArray(_formState.errors, name);
      }
      if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray(get(_formState.touchedFields, name))) {
        const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
        shouldSetValues && set(_formState.touchedFields, name, touchedFields);
      }
      if (_proxyFormState.dirtyFields) {
        _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
      }
      _subjects.state.next({
        name,
        isDirty: _getDirty(name, values),
        dirtyFields: _formState.dirtyFields,
        errors: _formState.errors,
        isValid: _formState.isValid
      });
    } else {
      set(_formValues, name, values);
    }
  };
  const updateErrors = (name, error) => {
    set(_formState.errors, name, error);
    _subjects.state.next({
      errors: _formState.errors
    });
  };
  const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
    const field = get(_fields, name);
    if (field) {
      const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
      isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f)) : setFieldValue(name, defaultValue);
      _state.mount && _updateValid();
    }
  };
  const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
    let shouldUpdateField = false;
    let isPreviousDirty = false;
    const output = {
      name
    };
    if (!isBlurEvent || shouldDirty) {
      if (_proxyFormState.isDirty) {
        isPreviousDirty = _formState.isDirty;
        _formState.isDirty = output.isDirty = _getDirty();
        shouldUpdateField = isPreviousDirty !== output.isDirty;
      }
      const isCurrentFieldPristine = deepEqual(get(_defaultValues, name), fieldValue);
      isPreviousDirty = get(_formState.dirtyFields, name);
      isCurrentFieldPristine ? unset(_formState.dirtyFields, name) : set(_formState.dirtyFields, name, true);
      output.dirtyFields = _formState.dirtyFields;
      shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
    }
    if (isBlurEvent) {
      const isPreviousFieldTouched = get(_formState.touchedFields, name);
      if (!isPreviousFieldTouched) {
        set(_formState.touchedFields, name, isBlurEvent);
        output.touchedFields = _formState.touchedFields;
        shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
      }
    }
    shouldUpdateField && shouldRender && _subjects.state.next(output);
    return shouldUpdateField ? output : {};
  };
  const shouldRenderByError = (name, isValid, error, fieldState) => {
    const previousFieldError = get(_formState.errors, name);
    const shouldUpdateValid = _proxyFormState.isValid && isBoolean(isValid) && _formState.isValid !== isValid;
    if (props.delayError && error) {
      delayErrorCallback = debounce(() => updateErrors(name, error));
      delayErrorCallback(props.delayError);
    } else {
      clearTimeout(timer);
      delayErrorCallback = null;
      error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
    }
    if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) || !isEmptyObject(fieldState) || shouldUpdateValid) {
      const updatedFormState = {
        ...fieldState,
        ...(shouldUpdateValid && isBoolean(isValid) ? {
          isValid
        } : {}),
        errors: _formState.errors,
        name
      };
      _formState = {
        ..._formState,
        ...updatedFormState
      };
      _subjects.state.next(updatedFormState);
    }
    _updateIsValidating(false);
  };
  const _executeSchema = async name => _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
  const executeSchemaAndUpdateState = async names => {
    const {
      errors
    } = await _executeSchema(names);
    if (names) {
      for (const name of names) {
        const error = get(errors, name);
        error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
      }
    } else {
      _formState.errors = errors;
    }
    return errors;
  };
  const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
    valid: true
  }) => {
    for (const name in fields) {
      const field = fields[name];
      if (field) {
        const {
          _f,
          ...fieldValue
        } = field;
        if (_f) {
          const isFieldArrayRoot = _names.array.has(_f.name);
          const fieldError = await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
          if (fieldError[_f.name]) {
            context.valid = false;
            if (shouldOnlyCheckValid) {
              break;
            }
          }
          !shouldOnlyCheckValid && (get(fieldError, _f.name) ? isFieldArrayRoot ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : set(_formState.errors, _f.name, fieldError[_f.name]) : unset(_formState.errors, _f.name));
        }
        fieldValue && (await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
      }
    }
    return context.valid;
  };
  const _removeUnmounted = () => {
    for (const name of _names.unMount) {
      const field = get(_fields, name);
      field && (field._f.refs ? field._f.refs.every(ref => !live(ref)) : !live(field._f.ref)) && unregister(name);
    }
    _names.unMount = new Set();
  };
  const _getDirty = (name, data) => (name && data && set(_formValues, name, data), !deepEqual(getValues(), _defaultValues));
  const _getWatch = (names, defaultValue, isGlobal) => generateWatchOutput(names, _names, {
    ...(_state.mount ? _formValues : isUndefined(defaultValue) ? _defaultValues : isString(names) ? {
      [names]: defaultValue
    } : defaultValue)
  }, isGlobal, defaultValue);
  const _getFieldArray = name => compact(get(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
  const setFieldValue = (name, value, options = {}) => {
    const field = get(_fields, name);
    let fieldValue = value;
    if (field) {
      const fieldReference = field._f;
      if (fieldReference) {
        !fieldReference.disabled && set(_formValues, name, getFieldValueAs(value, fieldReference));
        fieldValue = isHTMLElement(fieldReference.ref) && isNullOrUndefined(value) ? '' : value;
        if (isMultipleSelect(fieldReference.ref)) {
          [...fieldReference.ref.options].forEach(optionRef => optionRef.selected = fieldValue.includes(optionRef.value));
        } else if (fieldReference.refs) {
          if (isCheckBoxInput(fieldReference.ref)) {
            fieldReference.refs.length > 1 ? fieldReference.refs.forEach(checkboxRef => (!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find(data => data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
          } else {
            fieldReference.refs.forEach(radioRef => radioRef.checked = radioRef.value === fieldValue);
          }
        } else if (isFileInput(fieldReference.ref)) {
          fieldReference.ref.value = '';
        } else {
          fieldReference.ref.value = fieldValue;
          if (!fieldReference.ref.type) {
            _subjects.values.next({
              name,
              values: {
                ..._formValues
              }
            });
          }
        }
      }
    }
    (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
    options.shouldValidate && trigger(name);
  };
  const setValues = (name, value, options) => {
    for (const fieldKey in value) {
      const fieldValue = value[fieldKey];
      const fieldName = `${name}.${fieldKey}`;
      const field = get(_fields, fieldName);
      (_names.array.has(name) || !isPrimitive(fieldValue) || field && !field._f) && !isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
    }
  };
  const setValue = (name, value, options = {}) => {
    const field = get(_fields, name);
    const isFieldArray = _names.array.has(name);
    const cloneValue = cloneObject(value);
    set(_formValues, name, cloneValue);
    if (isFieldArray) {
      _subjects.array.next({
        name,
        values: {
          ..._formValues
        }
      });
      if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) {
        _subjects.state.next({
          name,
          dirtyFields: getDirtyFields(_defaultValues, _formValues),
          isDirty: _getDirty(name, cloneValue)
        });
      }
    } else {
      field && !field._f && !isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
    }
    isWatched(name, _names) && _subjects.state.next({
      ..._formState
    });
    _subjects.values.next({
      name,
      values: {
        ..._formValues
      }
    });
    !_state.mount && flushRootRender();
  };
  const onChange = async event => {
    const target = event.target;
    let name = target.name;
    let isFieldValueUpdated = true;
    const field = get(_fields, name);
    const getCurrentFieldValue = () => target.type ? getFieldValue(field._f) : getEventValue(event);
    const _updateIsFieldValueUpdated = fieldValue => {
      isFieldValueUpdated = Number.isNaN(fieldValue) || fieldValue === get(_formValues, name, fieldValue);
    };
    if (field) {
      let error;
      let isValid;
      const fieldValue = getCurrentFieldValue();
      const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
      const shouldSkipValidation = !hasValidation(field._f) && !_options.resolver && !get(_formState.errors, name) && !field._f.deps || skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
      const watched = isWatched(name, _names, isBlurEvent);
      set(_formValues, name, fieldValue);
      if (isBlurEvent) {
        field._f.onBlur && field._f.onBlur(event);
        delayErrorCallback && delayErrorCallback(0);
      } else if (field._f.onChange) {
        field._f.onChange(event);
      }
      const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
      const shouldRender = !isEmptyObject(fieldState) || watched;
      !isBlurEvent && _subjects.values.next({
        name,
        type: event.type,
        values: {
          ..._formValues
        }
      });
      if (shouldSkipValidation) {
        _proxyFormState.isValid && _updateValid();
        return shouldRender && _subjects.state.next({
          name,
          ...(watched ? {} : fieldState)
        });
      }
      !isBlurEvent && watched && _subjects.state.next({
        ..._formState
      });
      _updateIsValidating(true);
      if (_options.resolver) {
        const {
          errors
        } = await _executeSchema([name]);
        _updateIsFieldValueUpdated(fieldValue);
        if (isFieldValueUpdated) {
          const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
          const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
          error = errorLookupResult.error;
          name = errorLookupResult.name;
          isValid = isEmptyObject(errors);
        }
      } else {
        error = (await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
        _updateIsFieldValueUpdated(fieldValue);
        if (isFieldValueUpdated) {
          if (error) {
            isValid = false;
          } else if (_proxyFormState.isValid) {
            isValid = await executeBuiltInValidation(_fields, true);
          }
        }
      }
      if (isFieldValueUpdated) {
        field._f.deps && trigger(field._f.deps);
        shouldRenderByError(name, isValid, error, fieldState);
      }
    }
  };
  const _focusInput = (ref, key) => {
    if (get(_formState.errors, key) && ref.focus) {
      ref.focus();
      return 1;
    }
    return;
  };
  const trigger = async (name, options = {}) => {
    let isValid;
    let validationResult;
    const fieldNames = convertToArrayPayload(name);
    _updateIsValidating(true);
    if (_options.resolver) {
      const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
      isValid = isEmptyObject(errors);
      validationResult = name ? !fieldNames.some(name => get(errors, name)) : isValid;
    } else if (name) {
      validationResult = (await Promise.all(fieldNames.map(async fieldName => {
        const field = get(_fields, fieldName);
        return await executeBuiltInValidation(field && field._f ? {
          [fieldName]: field
        } : field);
      }))).every(Boolean);
      !(!validationResult && !_formState.isValid) && _updateValid();
    } else {
      validationResult = isValid = await executeBuiltInValidation(_fields);
    }
    _subjects.state.next({
      ...(!isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
        name
      }),
      ...(_options.resolver || !name ? {
        isValid
      } : {}),
      errors: _formState.errors,
      isValidating: false
    });
    options.shouldFocus && !validationResult && iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
    return validationResult;
  };
  const getValues = fieldNames => {
    const values = {
      ..._defaultValues,
      ...(_state.mount ? _formValues : {})
    };
    return isUndefined(fieldNames) ? values : isString(fieldNames) ? get(values, fieldNames) : fieldNames.map(name => get(values, name));
  };
  const getFieldState = (name, formState) => ({
    invalid: !!get((formState || _formState).errors, name),
    isDirty: !!get((formState || _formState).dirtyFields, name),
    isTouched: !!get((formState || _formState).touchedFields, name),
    error: get((formState || _formState).errors, name)
  });
  const clearErrors = name => {
    name && convertToArrayPayload(name).forEach(inputName => unset(_formState.errors, inputName));
    _subjects.state.next({
      errors: name ? _formState.errors : {}
    });
  };
  const setError = (name, error, options) => {
    const ref = (get(_fields, name, {
      _f: {}
    })._f || {}).ref;
    set(_formState.errors, name, {
      ...error,
      ref
    });
    _subjects.state.next({
      name,
      errors: _formState.errors,
      isValid: false
    });
    options && options.shouldFocus && ref && ref.focus && ref.focus();
  };
  const watch = (name, defaultValue) => isFunction(name) ? _subjects.values.subscribe({
    next: payload => name(_getWatch(undefined, defaultValue), payload)
  }) : _getWatch(name, defaultValue, true);
  const unregister = (name, options = {}) => {
    for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
      _names.mount.delete(fieldName);
      _names.array.delete(fieldName);
      if (!options.keepValue) {
        unset(_fields, fieldName);
        unset(_formValues, fieldName);
      }
      !options.keepError && unset(_formState.errors, fieldName);
      !options.keepDirty && unset(_formState.dirtyFields, fieldName);
      !options.keepTouched && unset(_formState.touchedFields, fieldName);
      !_options.shouldUnregister && !options.keepDefaultValue && unset(_defaultValues, fieldName);
    }
    _subjects.values.next({
      values: {
        ..._formValues
      }
    });
    _subjects.state.next({
      ..._formState,
      ...(!options.keepDirty ? {} : {
        isDirty: _getDirty()
      })
    });
    !options.keepIsValid && _updateValid();
  };
  const _updateDisabledField = ({
    disabled,
    name,
    field,
    fields,
    value
  }) => {
    if (isBoolean(disabled)) {
      const inputValue = disabled ? undefined : isUndefined(value) ? getFieldValue(field ? field._f : get(fields, name)._f) : value;
      set(_formValues, name, inputValue);
      updateTouchAndDirty(name, inputValue, false, false, true);
    }
  };
  const register = (name, options = {}) => {
    let field = get(_fields, name);
    const disabledIsDefined = isBoolean(options.disabled);
    set(_fields, name, {
      ...(field || {}),
      _f: {
        ...(field && field._f ? field._f : {
          ref: {
            name
          }
        }),
        name,
        mount: true,
        ...options
      }
    });
    _names.mount.add(name);
    if (field) {
      _updateDisabledField({
        field,
        disabled: options.disabled,
        name
      });
    } else {
      updateValidAndValue(name, true, options.value);
    }
    return {
      ...(disabledIsDefined ? {
        disabled: options.disabled
      } : {}),
      ...(_options.progressive ? {
        required: !!options.required,
        min: getRuleValue(options.min),
        max: getRuleValue(options.max),
        minLength: getRuleValue(options.minLength),
        maxLength: getRuleValue(options.maxLength),
        pattern: getRuleValue(options.pattern)
      } : {}),
      name,
      onChange,
      onBlur: onChange,
      ref: ref => {
        if (ref) {
          register(name, options);
          field = get(_fields, name);
          const fieldRef = isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
          const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
          const refs = field._f.refs || [];
          if (radioOrCheckbox ? refs.find(option => option === fieldRef) : fieldRef === field._f.ref) {
            return;
          }
          set(_fields, name, {
            _f: {
              ...field._f,
              ...(radioOrCheckbox ? {
                refs: [...refs.filter(live), fieldRef, ...(Array.isArray(get(_defaultValues, name)) ? [{}] : [])],
                ref: {
                  type: fieldRef.type,
                  name
                }
              } : {
                ref: fieldRef
              })
            }
          });
          updateValidAndValue(name, false, undefined, fieldRef);
        } else {
          field = get(_fields, name, {});
          if (field._f) {
            field._f.mount = false;
          }
          (_options.shouldUnregister || options.shouldUnregister) && !(isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
        }
      }
    };
  };
  const _focusError = () => _options.shouldFocusError && iterateFieldsByAction(_fields, _focusInput, _names.mount);
  const _disableForm = disabled => {
    if (isBoolean(disabled)) {
      _subjects.state.next({
        disabled
      });
      iterateFieldsByAction(_fields, ref => {
        ref.disabled = disabled;
      }, 0, false);
    }
  };
  const handleSubmit = (onValid, onInvalid) => async e => {
    if (e) {
      e.preventDefault && e.preventDefault();
      e.persist && e.persist();
    }
    let fieldValues = cloneObject(_formValues);
    _subjects.state.next({
      isSubmitting: true
    });
    if (_options.resolver) {
      const {
        errors,
        values
      } = await _executeSchema();
      _formState.errors = errors;
      fieldValues = values;
    } else {
      await executeBuiltInValidation(_fields);
    }
    unset(_formState.errors, 'root');
    if (isEmptyObject(_formState.errors)) {
      _subjects.state.next({
        errors: {}
      });
      await onValid(fieldValues, e);
    } else {
      if (onInvalid) {
        await onInvalid({
          ..._formState.errors
        }, e);
      }
      _focusError();
      setTimeout(_focusError);
    }
    _subjects.state.next({
      isSubmitted: true,
      isSubmitting: false,
      isSubmitSuccessful: isEmptyObject(_formState.errors),
      submitCount: _formState.submitCount + 1,
      errors: _formState.errors
    });
  };
  const resetField = (name, options = {}) => {
    if (get(_fields, name)) {
      if (isUndefined(options.defaultValue)) {
        setValue(name, get(_defaultValues, name));
      } else {
        setValue(name, options.defaultValue);
        set(_defaultValues, name, options.defaultValue);
      }
      if (!options.keepTouched) {
        unset(_formState.touchedFields, name);
      }
      if (!options.keepDirty) {
        unset(_formState.dirtyFields, name);
        _formState.isDirty = options.defaultValue ? _getDirty(name, get(_defaultValues, name)) : _getDirty();
      }
      if (!options.keepError) {
        unset(_formState.errors, name);
        _proxyFormState.isValid && _updateValid();
      }
      _subjects.state.next({
        ..._formState
      });
    }
  };
  const _reset = (formValues, keepStateOptions = {}) => {
    const updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
    const cloneUpdatedValues = cloneObject(updatedValues);
    const values = formValues && !isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
    if (!keepStateOptions.keepDefaultValues) {
      _defaultValues = updatedValues;
    }
    if (!keepStateOptions.keepValues) {
      if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) {
        for (const fieldName of _names.mount) {
          get(_formState.dirtyFields, fieldName) ? set(values, fieldName, get(_formValues, fieldName)) : setValue(fieldName, get(values, fieldName));
        }
      } else {
        if (isWeb && isUndefined(formValues)) {
          for (const name of _names.mount) {
            const field = get(_fields, name);
            if (field && field._f) {
              const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
              if (isHTMLElement(fieldReference)) {
                const form = fieldReference.closest('form');
                if (form) {
                  form.reset();
                  break;
                }
              }
            }
          }
        }
        _fields = {};
      }
      _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? cloneObject(_defaultValues) : {} : cloneObject(values);
      _subjects.array.next({
        values: {
          ...values
        }
      });
      _subjects.values.next({
        values: {
          ...values
        }
      });
    }
    _names = {
      mount: new Set(),
      unMount: new Set(),
      array: new Set(),
      watch: new Set(),
      watchAll: false,
      focus: ''
    };
    !_state.mount && flushRootRender();
    _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
    _state.watch = !!props.shouldUnregister;
    _subjects.state.next({
      submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
      isDirty: keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !deepEqual(formValues, _defaultValues)),
      isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
      dirtyFields: keepStateOptions.keepDirtyValues ? _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? getDirtyFields(_defaultValues, formValues) : {},
      touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
      errors: keepStateOptions.keepErrors ? _formState.errors : {},
      isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
      isSubmitting: false
    });
  };
  const reset = (formValues, keepStateOptions) => _reset(isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
  const setFocus = (name, options = {}) => {
    const field = get(_fields, name);
    const fieldReference = field && field._f;
    if (fieldReference) {
      const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
      if (fieldRef.focus) {
        fieldRef.focus();
        options.shouldSelect && fieldRef.select();
      }
    }
  };
  const _updateFormState = updatedFormState => {
    _formState = {
      ..._formState,
      ...updatedFormState
    };
  };
  const _resetDefaultValues = () => isFunction(_options.defaultValues) && _options.defaultValues().then(values => {
    reset(values, _options.resetOptions);
    _subjects.state.next({
      isLoading: false
    });
  });
  return {
    control: {
      register,
      unregister,
      getFieldState,
      handleSubmit,
      setError,
      _executeSchema,
      _getWatch,
      _getDirty,
      _updateValid,
      _removeUnmounted,
      _updateFieldArray,
      _updateDisabledField,
      _getFieldArray,
      _reset,
      _resetDefaultValues,
      _updateFormState,
      _disableForm,
      _subjects,
      _proxyFormState,
      get _fields() {
        return _fields;
      },
      get _formValues() {
        return _formValues;
      },
      get _state() {
        return _state;
      },
      set _state(value) {
        _state = value;
      },
      get _defaultValues() {
        return _defaultValues;
      },
      get _names() {
        return _names;
      },
      set _names(value) {
        _names = value;
      },
      get _formState() {
        return _formState;
      },
      set _formState(value) {
        _formState = value;
      },
      get _options() {
        return _options;
      },
      set _options(value) {
        _options = {
          ..._options,
          ...value
        };
      }
    },
    trigger,
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    resetField,
    clearErrors,
    unregister,
    setError,
    setFocus,
    getFieldState
  };
}

/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */
function useForm(props = {}) {
  const _formControl = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const _values = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    isDirty: false,
    isValidating: false,
    isLoading: isFunction(props.defaultValues),
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    errors: {},
    disabled: false,
    defaultValues: isFunction(props.defaultValues) ? undefined : props.defaultValues
  });
  if (!_formControl.current) {
    _formControl.current = {
      ...createFormControl(props, () => updateFormState(formState => ({
        ...formState
      }))),
      formState
    };
  }
  const control = _formControl.current.control;
  control._options = props;
  useSubscribe({
    subject: control._subjects.state,
    next: value => {
      if (shouldRenderFormState(value, control._proxyFormState, control._updateFormState, true)) {
        updateFormState({
          ...control._formState
        });
      }
    }
  });
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => control._disableForm(props.disabled), [control, props.disabled]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (control._proxyFormState.isDirty) {
      const isDirty = control._getDirty();
      if (isDirty !== formState.isDirty) {
        control._subjects.state.next({
          isDirty
        });
      }
    }
  }, [control, formState.isDirty]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (props.values && !deepEqual(props.values, _values.current)) {
      control._reset(props.values, control._options.resetOptions);
      _values.current = props.values;
    } else {
      control._resetDefaultValues();
    }
  }, [props.values, control]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!control._state.mount) {
      control._updateValid();
      control._state.mount = true;
    }
    if (control._state.watch) {
      control._state.watch = false;
      control._subjects.state.next({
        ...control._formState
      });
    }
    control._removeUnmounted();
  });
  _formControl.current.formState = getProxyFormState(formState, control);
  return _formControl.current;
}


/***/ }),

/***/ 72808:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x7": function() { return /* binding */ Fe; },
  "ZP": function() { return /* binding */ zt; },
  "Am": function() { return /* binding */ dist_n; }
});

// UNUSED EXPORTS: CheckmarkIcon, ErrorIcon, LoaderIcon, ToastBar, ToastIcon, resolveValue, useToaster, useToasterStore

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/goober/dist/goober.modern.js
let e = {
    data: ""
  },
  t = t => "object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
    innerHTML: " ",
    id: "_goober"
  })).firstChild : t || e,
  r = e => {
    let r = t(e),
      l = r.data;
    return r.data = "", l;
  },
  l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g,
  a = /\/\*[^]*?\*\/|  +/g,
  n = /\n+/g,
  o = (e, t) => {
    let r = "",
      l = "",
      a = "";
    for (let n in e) {
      let c = e[n];
      "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? o(c, n) : n + "{" + o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += o(c, t ? t.replace(/([^,])+/g, e => n.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, t => /&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += o.p ? o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
  },
  c = {},
  s = e => {
    if ("object" == typeof e) {
      let t = "";
      for (let r in e) t += r + s(e[r]);
      return t;
    }
    return e;
  },
  i = (e, t, r, i, p) => {
    let u = s(e),
      d = c[u] || (c[u] = (e => {
        let t = 0,
          r = 11;
        for (; t < e.length;) r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
      })(u));
    if (!c[d]) {
      let t = u !== e ? e : (e => {
        let t,
          r,
          o = [{}];
        for (; t = l.exec(e.replace(a, ""));) t[4] ? o.shift() : t[3] ? (r = t[3].replace(n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace(n, " ").trim();
        return o[0];
      })(e);
      c[d] = o(p ? {
        ["@keyframes " + d]: t
      } : t, r ? "" : "." + d);
    }
    let f = r && c.g ? c.g : null;
    return r && (c.g = c[d]), ((e, t, r, l) => {
      l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })(c[d], t, i, f), d;
  },
  p = (e, t, r) => e.reduce((e, l, a) => {
    let n = t[a];
    if (n && n.call) {
      let e = n(r),
        t = e && e.props && e.props.className || /^go/.test(e) && e;
      n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : o(e, "") : !1 === e ? "" : e;
    }
    return e + l + (null == n ? "" : n);
  }, "");
function u(e) {
  let r = this || {},
    l = e.call ? e(r.p) : e;
  return i(l.unshift ? l.raw ? p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t) => Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, t(r.target), r.g, r.o, r.k);
}
let d,
  f,
  g,
  b = u.bind({
    g: 1
  }),
  h = u.bind({
    k: 1
  });
function m(e, t, r, l) {
  o.p = t, d = e, f = r, g = l;
}
function j(e, t) {
  let r = this || {};
  return function () {
    let l = arguments;
    function a(n, o) {
      let c = Object.assign({}, n),
        s = c.className || a.className;
      r.p = Object.assign({
        theme: f && f()
      }, c), r.o = / *go\d+/.test(s), c.className = u.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
      let i = e;
      return e[0] && (i = c.as || e, delete c.as), g && i[0] && g(c), d(i, c);
    }
    return t ? t(a) : a;
  };
}

;// CONCATENATED MODULE: ./node_modules/react-hot-toast/dist/index.mjs
"use client";

var Z = e => typeof e == "function",
  dist_h = (e, t) => Z(e) ? e(t) : e;
var W = (() => {
    let e = 0;
    return () => (++e).toString();
  })(),
  E = (() => {
    let e;
    return () => {
      if (e === void 0 && typeof window < "u") {
        let t = matchMedia("(prefers-reduced-motion: reduce)");
        e = !t || t.matches;
      }
      return e;
    };
  })();

var re = 20,
  k = "default";
var H = (e, t) => {
    let {
      toastLimit: o
    } = e.settings;
    switch (t.type) {
      case 0:
        return {
          ...e,
          toasts: [t.toast, ...e.toasts].slice(0, o)
        };
      case 1:
        return {
          ...e,
          toasts: e.toasts.map(r => r.id === t.toast.id ? {
            ...r,
            ...t.toast
          } : r)
        };
      case 2:
        let {
          toast: s
        } = t;
        return H(e, {
          type: e.toasts.find(r => r.id === s.id) ? 1 : 0,
          toast: s
        });
      case 3:
        let {
          toastId: a
        } = t;
        return {
          ...e,
          toasts: e.toasts.map(r => r.id === a || a === void 0 ? {
            ...r,
            dismissed: !0,
            visible: !1
          } : r)
        };
      case 4:
        return t.toastId === void 0 ? {
          ...e,
          toasts: []
        } : {
          ...e,
          toasts: e.toasts.filter(r => r.id !== t.toastId)
        };
      case 5:
        return {
          ...e,
          pausedAt: t.time
        };
      case 6:
        let i = t.time - (e.pausedAt || 0);
        return {
          ...e,
          pausedAt: void 0,
          toasts: e.toasts.map(r => ({
            ...r,
            pauseDuration: r.pauseDuration + i
          }))
        };
    }
  },
  v = [],
  dist_j = {
    toasts: [],
    pausedAt: void 0,
    settings: {
      toastLimit: re
    }
  },
  dist_f = {},
  Y = (e, t = k) => {
    dist_f[t] = H(dist_f[t] || dist_j, e), v.forEach(([o, s]) => {
      o === t && s(dist_f[t]);
    });
  },
  _ = e => Object.keys(dist_f).forEach(t => Y(e, t)),
  Q = e => Object.keys(dist_f).find(t => dist_f[t].toasts.some(o => o.id === e)),
  S = (e = k) => t => {
    Y(t, e);
  },
  se = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
  },
  V = (e = {}, t = k) => {
    let [o, s] = (0,react.useState)(dist_f[t] || dist_j),
      a = (0,react.useRef)(dist_f[t]);
    (0,react.useEffect)(() => (a.current !== dist_f[t] && s(dist_f[t]), v.push([t, s]), () => {
      let r = v.findIndex(([l]) => l === t);
      r > -1 && v.splice(r, 1);
    }), [t]);
    let i = o.toasts.map(r => {
      var l, g, T;
      return {
        ...e,
        ...e[r.type],
        ...r,
        removeDelay: r.removeDelay || ((l = e[r.type]) == null ? void 0 : l.removeDelay) || (e == null ? void 0 : e.removeDelay),
        duration: r.duration || ((g = e[r.type]) == null ? void 0 : g.duration) || (e == null ? void 0 : e.duration) || se[r.type],
        style: {
          ...e.style,
          ...((T = e[r.type]) == null ? void 0 : T.style),
          ...r.style
        }
      };
    });
    return {
      ...o,
      toasts: i
    };
  };
var ie = (e, t = "blank", o) => ({
    createdAt: Date.now(),
    visible: !0,
    dismissed: !1,
    type: t,
    ariaProps: {
      role: "status",
      "aria-live": "polite"
    },
    message: e,
    pauseDuration: 0,
    ...o,
    id: (o == null ? void 0 : o.id) || W()
  }),
  P = e => (t, o) => {
    let s = ie(t, e, o);
    return S(s.toasterId || Q(s.id))({
      type: 2,
      toast: s
    }), s.id;
  },
  dist_n = (e, t) => P("blank")(e, t);
dist_n.error = P("error");
dist_n.success = P("success");
dist_n.loading = P("loading");
dist_n.custom = P("custom");
dist_n.dismiss = (e, t) => {
  let o = {
    type: 3,
    toastId: e
  };
  t ? S(t)(o) : _(o);
};
dist_n.dismissAll = e => dist_n.dismiss(void 0, e);
dist_n.remove = (e, t) => {
  let o = {
    type: 4,
    toastId: e
  };
  t ? S(t)(o) : _(o);
};
dist_n.removeAll = e => dist_n.remove(void 0, e);
dist_n.promise = (e, t, o) => {
  let s = dist_n.loading(t.loading, {
    ...o,
    ...(o == null ? void 0 : o.loading)
  });
  return typeof e == "function" && (e = e()), e.then(a => {
    let i = t.success ? dist_h(t.success, a) : void 0;
    return i ? dist_n.success(i, {
      id: s,
      ...o,
      ...(o == null ? void 0 : o.success)
    }) : dist_n.dismiss(s), a;
  }).catch(a => {
    let i = t.error ? dist_h(t.error, a) : void 0;
    i ? dist_n.error(i, {
      id: s,
      ...o,
      ...(o == null ? void 0 : o.error)
    }) : dist_n.dismiss(s);
  }), e;
};

var ce = 1e3,
  w = (e, t = "default") => {
    let {
        toasts: o,
        pausedAt: s
      } = V(e, t),
      a = (0,react.useRef)(new Map()).current,
      i = (0,react.useCallback)((c, m = ce) => {
        if (a.has(c)) return;
        let p = setTimeout(() => {
          a.delete(c), r({
            type: 4,
            toastId: c
          });
        }, m);
        a.set(c, p);
      }, []);
    (0,react.useEffect)(() => {
      if (s) return;
      let c = Date.now(),
        m = o.map(p => {
          if (p.duration === 1 / 0) return;
          let R = (p.duration || 0) + p.pauseDuration - (c - p.createdAt);
          if (R < 0) {
            p.visible && dist_n.dismiss(p.id);
            return;
          }
          return setTimeout(() => dist_n.dismiss(p.id, t), R);
        });
      return () => {
        m.forEach(p => p && clearTimeout(p));
      };
    }, [o, s, t]);
    let r = (0,react.useCallback)(S(t), [t]),
      l = (0,react.useCallback)(() => {
        r({
          type: 5,
          time: Date.now()
        });
      }, [r]),
      g = (0,react.useCallback)((c, m) => {
        r({
          type: 1,
          toast: {
            id: c,
            height: m
          }
        });
      }, [r]),
      T = (0,react.useCallback)(() => {
        s && r({
          type: 6,
          time: Date.now()
        });
      }, [s, r]),
      d = (0,react.useCallback)((c, m) => {
        let {
            reverseOrder: p = !1,
            gutter: R = 8,
            defaultPosition: z
          } = m || {},
          O = o.filter(u => (u.position || z) === (c.position || z) && u.height),
          K = O.findIndex(u => u.id === c.id),
          B = O.filter((u, I) => I < K && u.visible).length;
        return O.filter(u => u.visible).slice(...(p ? [B + 1] : [0, B])).reduce((u, I) => u + (I.height || 0) + R, 0);
      }, [o]);
    return (0,react.useEffect)(() => {
      o.forEach(c => {
        if (c.dismissed) i(c.id, c.removeDelay);else {
          let m = a.get(c.id);
          m && (clearTimeout(m), a.delete(c.id));
        }
      });
    }, [o, i]), {
      toasts: o,
      handlers: {
        updateHeight: g,
        startPause: l,
        endPause: T,
        calculateOffset: d
      }
    };
  };





var de = h`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`,
  me = h`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`,
  le = h`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`,
  C = j("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${e => e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${de} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${me} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${e => e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${le} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;

var Te = h`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`,
  F = j("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${e => e.secondary || "#e0e0e0"};
  border-right-color: ${e => e.primary || "#616161"};
  animation: ${Te} 1s linear infinite;
`;

var ge = h`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`,
  he = h`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`,
  L = j("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${e => e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${ge} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${he} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${e => e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var be = j("div")`
  position: absolute;
`,
  Se = j("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`,
  Ae = h`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`,
  Pe = j("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${Ae} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`,
  $ = ({
    toast: e
  }) => {
    let {
      icon: t,
      type: o,
      iconTheme: s
    } = e;
    return t !== void 0 ? typeof t == "string" ? react.createElement(Pe, null, t) : t : o === "blank" ? null : react.createElement(Se, null, react.createElement(F, {
      ...s
    }), o !== "loading" && react.createElement(be, null, o === "error" ? react.createElement(C, {
      ...s
    }) : react.createElement(L, {
      ...s
    })));
  };
var Re = e => `
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`,
  Ee = e => `
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`,
  ve = "0%{opacity:0;} 100%{opacity:1;}",
  De = "0%{opacity:1;} 100%{opacity:0;}",
  Oe = j("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`,
  Ie = j("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`,
  ke = (e, t) => {
    let s = e.includes("top") ? 1 : -1,
      [a, i] = E() ? [ve, De] : [Re(s), Ee(s)];
    return {
      animation: t ? `${h(a)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${h(i)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
  },
  N = react.memo(({
    toast: e,
    position: t,
    style: o,
    children: s
  }) => {
    let a = e.height ? ke(e.position || t || "top-center", e.visible) : {
        opacity: 0
      },
      i = react.createElement($, {
        toast: e
      }),
      r = react.createElement(Ie, {
        ...e.ariaProps
      }, dist_h(e.message, e));
    return react.createElement(Oe, {
      className: e.className,
      style: {
        ...a,
        ...o,
        ...e.style
      }
    }, typeof s == "function" ? s({
      icon: i,
      message: r
    }) : react.createElement(react.Fragment, null, i, r));
  });


m(react.createElement);
var we = ({
    id: e,
    className: t,
    style: o,
    onHeightUpdate: s,
    children: a
  }) => {
    let i = react.useCallback(r => {
      if (r) {
        let l = () => {
          let g = r.getBoundingClientRect().height;
          s(e, g);
        };
        l(), new MutationObserver(l).observe(r, {
          subtree: !0,
          childList: !0,
          characterData: !0
        });
      }
    }, [e, s]);
    return react.createElement("div", {
      ref: i,
      className: t,
      style: o
    }, a);
  },
  Me = (e, t) => {
    let o = e.includes("top"),
      s = o ? {
        top: 0
      } : {
        bottom: 0
      },
      a = e.includes("center") ? {
        justifyContent: "center"
      } : e.includes("right") ? {
        justifyContent: "flex-end"
      } : {};
    return {
      left: 0,
      right: 0,
      display: "flex",
      position: "absolute",
      transition: E() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
      transform: `translateY(${t * (o ? 1 : -1)}px)`,
      ...s,
      ...a
    };
  },
  Ce = u`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`,
  D = 16,
  Fe = ({
    reverseOrder: e,
    position: t = "top-center",
    toastOptions: o,
    gutter: s,
    children: a,
    toasterId: i,
    containerStyle: r,
    containerClassName: l
  }) => {
    let {
      toasts: g,
      handlers: T
    } = w(o, i);
    return react.createElement("div", {
      "data-rht-toaster": i || "",
      style: {
        position: "fixed",
        zIndex: 9999,
        top: D,
        left: D,
        right: D,
        bottom: D,
        pointerEvents: "none",
        ...r
      },
      className: l,
      onMouseEnter: T.startPause,
      onMouseLeave: T.endPause
    }, g.map(d => {
      let c = d.position || t,
        m = T.calculateOffset(d, {
          reverseOrder: e,
          gutter: s,
          defaultPosition: t
        }),
        p = Me(c, m);
      return react.createElement(we, {
        id: d.id,
        key: d.id,
        onHeightUpdate: T.updateHeight,
        className: d.visible ? Ce : "",
        style: p
      }, d.type === "custom" ? dist_h(d.message, d) : a ? a(d) : react.createElement(N, {
        toast: d,
        position: c
      }));
    }));
  };
var zt = dist_n;


/***/ }),

/***/ 99422:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ debounce; }
/* harmony export */ });
/* unused harmony export throttle */
/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */
function throttle(delay, callback, options) {
  var _ref = options || {},
    _ref$noTrailing = _ref.noTrailing,
    noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing,
    _ref$noLeading = _ref.noLeading,
    noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading,
    _ref$debounceMode = _ref.debounceMode,
    debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false;

  // Keep track of the last time `callback` was executed.
  var lastExec = 0;

  // Function to clear existing timeout
  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  }

  // Function to cancel next exec
  function cancel(options) {
    var _ref2 = options || {},
      _ref2$upcomingOnly = _ref2.upcomingOnly,
      upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
    clearExistingTimeout();
    cancelled = !upcomingOnly;
  }

  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */
  function wrapper() {
    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }
    var self = this;
    var elapsed = Date.now() - lastExec;
    if (cancelled) {
      return;
    }

    // Execute `callback` and update the `lastExec` timestamp.
    function exec() {
      lastExec = Date.now();
      callback.apply(self, arguments_);
    }

    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */
    function clear() {
      timeoutID = undefined;
    }
    if (!noLeading && debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */
      exec();
    }
    clearExistingTimeout();
    if (debounceMode === undefined && elapsed > delay) {
      if (noLeading) {
        /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */
        lastExec = Date.now();
        if (!noTrailing) {
          timeoutID = setTimeout(debounceMode ? clear : exec, delay);
        }
      } else {
        /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */
        exec();
      }
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }
  wrapper.cancel = cancel;

  // Return the wrapper function.
  return wrapper;
}

/* eslint-disable no-undefined */

/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */
function debounce(delay, callback, options) {
  var _ref = options || {},
    _ref$atBegin = _ref.atBegin,
    atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
  return throttle(delay, callback, {
    debounceMode: atBegin !== false
  });
}


/***/ }),

/***/ 20959:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"code":"404|000000","message":"Not Found"},{"code":"304|000000","message":"Not Modified"},{"code":"401|000000","message":"Unauthorized"},{"code":"403|000000","message":"Forbidden"},{"code":"400|000000","message":"Bad Request"},{"code":"403|000005","message":"Forbidden Inactive"},{"code":"403|000008","message":"Forbidden Blocked"},{"code":"403|000010","message":"The Number Of Logins Has Been Exceeded"},{"code":"422|000405","message":"Unprocess Entity"},{"code":"400|010004","message":"Student Not Found"},{"code":"400|010008","message":"Your Account Has Been Blocked"},{"code":"400|010009","message":"User Has Not Permission For Resource"},{"code":"400|010401","message":"Username Already Exists"},{"code":"400|010433","message":"User Account Incorrect"},{"code":"400|010501","message":"Email Already Exists"},{"code":"400|010601","message":"Phone Already Exists"},{"code":"400|010704","message":"Level Of Student Not Found"},{"code":"400|010833","message":"User Password Incorrect"},{"code":"400|020004","message":"Staff Not Found"},{"code":"400|020501","message":"Email Already Exists"},{"code":"400|030004","message":"Question Not Found"},{"code":"400|030008","message":"Question Without Belong To"},{"code":"400|030022","message":"Test/Quiz/Case Study Included The Question(s)"},{"code":"400|030108","message":"Question Can Not Be Updated"},{"code":"400|030208","message":"Question Can Not Be Deleted"},{"code":"400|030312","message":"Question Category Not Found"},{"code":"400|030412","message":"Question Answer Not Found"},{"code":"400|030512","message":"Question Requirement Not Found"},{"code":"400|030612","message":"Duplicate Answers For A Requirement"},{"code":"400|040004","message":"User Session Not Found"},{"code":"400|050004","message":"Case Study Story Not Found"},{"code":"400|050005","message":"Topic Added And Removed At The Same Time"},{"code":"400|050022","message":"Case Study Story Already In Used"},{"code":"400|060001","message":"Please Change Status Of Entrance Test {QUIZ_NAME} From {FROM_STATUS} To {TO_STATUS} Before Changing This One"},{"code":"400|060002","message":"Course Include Quiz Already Passed"},{"code":"400|060004","message":"Quiz Not Found"},{"code":"400|060005","message":"Invalid Quiz"},{"code":"400|060022","message":"Quiz Already In Used"},{"code":"400|060034","message":"Quiz Used In Belong To"},{"code":"400|060104","message":"Quiz Questions Not Found"},{"code":"400|060205","message":"Invalid Course For Quiz"},{"code":"400|060305","message":"Invalid Part For Quiz"},{"code":"400|060405","message":"Invalid Quiz Status"},{"code":"403|060406","message":"Authorization For User"},{"code":"400|060409","message":"Locked Quiz Status"},{"code":"400|060505","message":"Invalid Quiz Type"},{"code":"400|060604","message":"Quiz Section Category Not Found"},{"code":"400|060711","message":"Invalid Quiz Setting Minimum Grading"},{"code":"400|060904","message":"Quiz Attempt Not Found"},{"code":"403|060908","message":"Quiz Attempt Block Access"},{"code":"400|060910","message":"Maximum Quiz Attempt Reached"},{"code":"400|060915","message":"Quiz Attempt Not Pass"},{"code":"400|061004","message":"Quiz Attempt Answer Not Found"},{"code":"400|061101","message":"Question Already Existed In Quiz Section"},{"code":"400|070004","message":"Course Not Found"},{"code":"400|070005","message":"Invalid Course"},{"code":"400|070022","message":"Course Already In Used"},{"code":"400|070023","message":"Course Has Student Completed"},{"code":"400|070205","message":"Invalid Foundation Course"},{"code":"400|070208","message":"Non Foundation Course With Level"},{"code":"400|070218","message":"Foundation Class Can Not Be Modified"},{"code":"400|070224","message":"Graded test/quiz can not be created due to course completion of students"},{"code":"400|070206","message":"Course already has Mock Test. You can not change type of course"},{"code":"400|070305","message":"Invalid Course Type"},{"code":"400|070403","message":"Course Code Already Existed"},{"code":"400|070505","message":"Invalid Total Points"},{"code":"400|070703","message":"Course Part Code Already Existed"},{"code":"400|070704","message":"Course Part Not Found"},{"code":"400|070803","message":"Course Chapter Code Already Existed"},{"code":"400|070804","message":"Course Chapter Not Found"},{"code":"400|070903","message":"Course Unit Code Already Existed"},{"code":"400|070904","message":"Course Chapter Not Found"},{"code":"400|071003","message":"Course Activity Code Already Existed"},{"code":"400|071004","message":"Course Activity Not Found"},{"code":"400|071005","message":"Invalid Course Activity"},{"code":"400|071204","message":"Course Tab Document Not Found"},{"code":"400|071205","message":"Course Section Link Not Found"},{"code":"400|071206","message":"Course Section Link Nested Between Two Course Sections"},{"code":"400|071207","message":"Course Tab Document Type Can Not Be Changed"},{"code":"400|071304","message":"Course Learning Outcome Not Found"},{"code":"422|071324","message":"Course Learning Outcome Connected To Course Section"},{"code":"400|071404","message":"Course Outcome Not Found"},{"code":"400|071412","message":"Course Outcome Not Empty"},{"code":"400|071424","message":"Course Outcome Connected With Activity"},{"code":"400|071504","message":"Course Tag Not Found"},{"code":"400|071509","message":"Locked Course Status"},{"code":"400|071510","message":"Maximum 3 Course Tags"},{"code":"400|071604","message":"Course Level Not Found"},{"code":"400|071605","message":"Invalid Course Level"},{"code":"404|071704","message":"Course Section Note Not Found"},{"code":"404|071804","message":"Course Discussion Or Parent Discussion Not Found"},{"code":"400|071901","message":"Linked Course Content Existed In Course"},{"code":"400|071905","message":"Invalid Course Section"},{"code":"400|071907","message":"Course Sections Type Not Match"},{"code":"400|072001","message":"Foundation Course Connected With Normal Course"},{"code":"400|072005","message":"Invalid Connection Between Courses"},{"code":"400|080004","message":"Course Category Not Found"},{"code":"400|080104","message":"Invalid Course Category For Examination"},{"code":"400|080201","message":"Course Category Name Already Existed"},{"code":"422|080324","message":"Course Category Connected To Course"},{"code":"400|090001","message":"Role Already Exist"},{"code":"400|090004","message":"Role Not Found"},{"code":"400|090101","message":"Permission Already Exits"},{"code":"400|090104","message":"Permission Not Found"},{"code":"400|100004","message":"Class Not Found"},{"code":"400|100016","message":"Class Is Not Activated"},{"code":"400|100021","message":"Class Has Ended"},{"code":"400|100104","message":"Create Class Examination Id Not Found"},{"code":"400|100107","message":"Course Category And Examination Not Match"},{"code":"400|100204","message":"Class Facility Not Found"},{"code":"400|100304","message":"Class Teacher Not Found"},{"code":"400|100314","message":"Students Have Learned This Course Content"},{"code":"400|100318","message":"Student Not Allowed To Transfer"},{"code":"400|100319","message":"Student Not Allowed To Active Course"},{"code":"400|100320","message":"Student Not Allowed To Extend Course"},{"code":"400|100322","message":"Student Is Studying In This Class"},{"code":"400|100327","message":"Student Not In Class"},{"code":"400|100329","message":"Class Has Student"},{"code":"400|100330","message":"Student Is Studying This Course In Another Class"},{"code":"400|100401","message":"Trial Class With The Same Course Already Existed"},{"code":"400|100417","message":"Trial Class With Fixed Duration"},{"code":"400|100505","message":"Invalid Flexible Day For Flexible Class"},{"code":"400|100704","message":"Revision Class Not Found"},{"code":"400|100710","message":"Maximum Revision Class Capacity Reached"},{"code":"400|100807","message":"Course And Class Type Not Match"},{"code":"400|100910","message":"Maximum Class Capacity Reached"},{"code":"400|101005","message":"Invalid Class Schedule"},{"code":"400|101105","message":"Invalid Class Status"},{"code":"400|101207","message":"Student And Foundation Level Not Match"},{"code":"400|101304","message":"Class Mentor Not Found"},{"code":"400|101305","message":"Class With Multiple Main Mentor"},{"code":"400|101312","message":"Class With No Main Mentor"},{"code":"400|101315","message":"Student Can Not Add This Class Because Of Hubspot Enrollment Not Allow It"},{"code":"400|101428","message":"Finished At Large Than Started At"},{"code":"400|101701","message":"Class Code Already Existed"},{"code":"400|101815","message":"Student Not Pass Foundation"},{"code":"400|101904","message":"Create Class Course Id Not Found"},{"code":"400|101905","message":"Room status cannot be updated when the room has a calendar"},{"code":"404|110004","message":"Certificate Not Found"},{"code":"403|110008","message":"Certificate Can Not Be Used When Blocked"},{"code":"403|110114","message":"Certificate Status Can Not Be Changed"},{"code":"400|120004","message":"Notification Already Exist"},{"code":"400|120018","message":"Notification Can Not Be Modified"},{"code":"400|120105","message":"Invalid Notification Timer"},{"code":"400|120205","message":"Invalid Notification Status"},{"code":"400|120304","message":"Notification Pinned No Finish Time"},{"code":"400|120305","message":"Notification Overwrite Current Pinned"},{"code":"400|120306","message":"Notification Overlap Pinned Duration"},{"code":"400|130001","message":"Student Was Added In The Test"},{"code":"400|130030","message":"Student Was Added In The Test With The Same Subject"},{"code":"400|140104","message":"Cloudflare Token Already Exist"},{"code":"400|150001","message":"Resource Already Exist"},{"code":"400|150004","message":"Resource Not Found"},{"code":"400|150022","message":"Resource In Used"},{"code":"400|150025","message":"Resource Can Not Be Deleted"},{"code":"400|150031","message":"Selecting Duplicate Videos Is Not Allowed"},{"code":"400|150202","message":"Token Download Not Exist"},{"code":"400|150302","message":"File Key Not Exist"},{"code":"400|160004","message":"Group Not Found"},{"code":"400|170104","message":"Classification Already Exist"},{"code":"400|170226","message":"Deal Not Associated To Contact"},{"code":"400|170304","message":"Lifecycle Contact Not Found"},{"code":"400|180004","message":"Question Tag Not Found"},{"code":"400|190004","message":"Question Topic Not Found"},{"code":"400|190127","message":"Question Topic With No Question"},{"code":"400|200001","message":"Duplicate Examination Season"},{"code":"400|200004","message":"Examination Not Found"},{"code":"400|200005","message":"Invalid Examination Season"},{"code":"400|200012","message":"Examination Season Not Found"},{"code":"400|200022","message":"Examination Used In Class"},{"code":"400|200104","message":"Examination Type Not Found"},{"code":"400|200201","message":"Revision Class For This Exam Has Already Existed"},{"code":"400|210002","message":"Otp Code Not Found"},{"code":"400|210005","message":"Invalid Otp Code"},{"code":"400|360004","message":"Subject Not Found"},{"code":"400|370004","message":"Mail Log Not Found"},{"code":"400|380001","message":"Support Group Already Existed"},{"code":"400|380004","message":"Support Group Not Found"},{"code":"400|380014","message":"Support Group Can Not Be Updated"},{"code":"404|400004","message":"Caching Setting Not Found"},{"code":"404|410004","message":"Setting Quiz In Class Not Found"},{"code":"404|410104","message":"Setting Quiz For User Not Found"},{"code":"404|410205","message":"Invalid Setting Quiz Time"},{"code":"404|410305","message":"Invalid Setting User Quiz Time"},{"code":"400|420001","message":"Examination Already Existed"},{"code":"400|420204","message":"Cfa Examination Early Registration Date Not Found"},{"code":"400|420212","message":"Cfa Examination Registration Start Date Not Found"},{"code":"400|420213","message":"Cfa Examination Standard Registration Date Not Found"},{"code":"400|420305","message":"Examination For Subject Invalid Start Date"},{"code":"400|420312","message":"Cma Examination Registration End Date Not Found"},{"code":"400|420404","message":"Examination For Subject Not Found"},{"code":"400|420413","message":"Examination For Subject Start Date Not Found"},{"code":"400|420431","message":"Duplicate Subject In Examination"},{"code":"400|430001","message":"Event Test Existed"},{"code":"400|430036","message":"Event Test Not Opened"},{"code":"400|440104","message":"S3 Key Not Found"},{"code":"400|450035","message":"Event Expired"},{"code":"400|450050","message":"This promotion code can\'t be modified, because it has been attached to some Orders."},{"code":"400|340001","message":"Product Existed"},{"code":"404|340004","message":"The Product Not Found"},{"code":"400|350001","message":"The Product Category Existed"},{"code":"404|350004","message":"The Product Category Not Found"},{"code":"400|320001","message":"The Event Sponsor Existed"},{"code":"404|320004","message":"The Event Sponsor Not Found"},{"code":"400|280001","message":"The Faq Question Existed"},{"code":"404|280004","message":"The Faq Question Not Found"},{"code":"404|280025","message":"The FAQ Question Is Blocked"},{"code":"400|260001","message":"The Faq Existed"},{"code":"404|260004","message":"The Faq Not Found"},{"code":"404|260025","message":"The FAQ Is Blocked"},{"code":"400|270001","message":"The Faq Category Existed"},{"code":"404|270004","message":"The Faq Category Not Found"},{"code":"404|270025","message":"The Faq Category Can Not Be Deleted"},{"code":"400|310001","message":"The Event Category Existed"},{"code":"404|310004","message":"The Event Category Not Found"},{"code":"400|310002","message":"The Event Category Children Existed"},{"code":"400|310003","message":"The Event Primary And Other Category Is Duplicate"},{"code":"400|310004","message":"The Event Primary Category Update Itself"},{"code":"400|290001","message":"The Event Existed"},{"code":"404|290004","message":"The Event Not Found"},{"code":"400|300001","message":"The Event Speaker Existed"},{"code":"404|300004","message":"The Event Speaker Not Found"},{"code":"400|240001","message":"Blog Tag Existed"},{"code":"404|240004","message":"Blog Tag Not Found"},{"code":"400|360001","message":"Blog Existed"},{"code":"404|360004","message":"Blog Not Found"},{"code":"400|250001","message":"Blog Author Existed"},{"code":"404|250004","message":"Blog Author Not Found"},{"code":"400|230001","message":"Blog Category Existed"},{"code":"404|230004","message":"Blog Category Not Found"},{"code":"404|450004","message":"Event Test Not Found"},{"code":"403|000000","message":"Tạm thời bạn không có quyền thực hiện thao tác này"},{"code":"400|010010","message":"User Is Not Sysn To Keycloak"},{"code":"400|010804","message":"User Teacher Status Not Found"},{"code":"400|010805","message":"Staff Manager Not Found"},{"code":"400|010806","message":"User Teacher Subject Duplicate"},{"code":"400|010807","message":"User Teacher Teachable Not Match Data"},{"code":"400|010808","message":"User Teacher Please Choose Teachables"},{"code":"400|010809","message":"User Teacher Not Choose Type User"},{"code":"400|010810","message":"User Teacher Not Choose Employee Code"},{"code":"400|010811","message":"User Teacher Please Choose Course Category"},{"code":"400|010812","message":"User Teacher Feature Section Duplicate"},{"code":"400|010904","message":"User Student Not Choose Subject"},{"code":"400|010905","message":"User Student Not Choose Teacher Status"},{"code":"400|010906","message":"User Student Not Choose Staff"},{"code":"400|010907","message":"User Course Not Choose Course Category"},{"code":"400|040008","message":"User Not Choose Employee Code"},{"code":"400|040009","message":"User Not Choose Hubspot Contact Id"},{"code":"400|040010","message":"User Please Choose Employee Code"},{"code":"400|040011","message":"User Please Choose Hubspot Contact Id"},{"code":"400|040905","message":"User Student Please Choose Type User"},{"code":"400|060800","message":"Quiz Attempt Grading Not Found"},{"code":"400|060801","message":"Quiz Attempt Question Grading Not Found"},{"code":"400|060802","message":"Invalid Grading Payload"},{"code":"400|060803","message":"Can Not Grade"},{"code":"400|060804","message":"Can Not Ungrade"},{"code":"400|060805","message":"Quiz Attempt Answer Grading Not Found"},{"code":"400|060806","message":"Grading Item Not Found"},{"code":"400|100022","message":"Class Has Been Sold"},{"code":"400|350004","message":"Lecturer Not Found"},{"code":"400|360005","message":"Feature Section Not Found"},{"code":"400|410401","message":"Class Quiz Setting Has Mentor"},{"code":"400|100301","message":"Facility Name existed"},{"code":"400|100404","message":"The Facility Code Existed"},{"code":"400|100405","message":"The Facility Cannot Delete"},{"code":"400|101204","message":"Room Not Found"},{"code":"400|101301","message":"Room Name Exists"},{"code":"400|101405","message":"Invalid Room Capacity"},{"code":"400|101505","message":"Room Cannot Delete"},{"code":"400|100501","message":"The facility has some active class"},{"code":"400|370101","message":"Subject Name Exists"},{"code":"400|360022","message":"Subject In Used"},{"code":"400|370001","message":"Subject Code Exists"},{"code":"400|101605","message":"Room Status Can Not Be Updated When Facility Closed"},{"code":"401|010833","message":"User Password Incorrect"},{"code":"400|010931","message":"Duplicate Staff"},{"code":"400|060807","message":"Grading Score Exceeds Question\'s Maximum Score {MAX_SCORE}"},{"code":"400|470001","message":"Facility Name Exist"},{"code":"400|470003","message":"Facility Code Exist"},{"code":"400|470004","message":"Facility Not Found"},{"code":"400|470005","message":"Facility Required For Offline Or Blended Class"},{"code":"400|470022","message":"Facility Has Active Class"},{"code":"400|470104","message":"Province Not Found"},{"code":"400|470204","message":"District Not Found"},{"code":"400|470304","message":"Ward Not Found"},{"code":"400|041105","message":"User Import Check Duplicate Contact Invalid"},{"code":"400|010912","message":"User Teacher Not Choose Facility"},{"code":"400|101309","message":"Class Mentor Has Quizzes For Grading"},{"code":"400|310005","message":"The Event Primary Category Update Itself"},{"code":"404|450004","message":"The event does not found"},{"code":"404|450022","message":"The event in used"},{"code":"404|490004","message":"The event phase does not found"},{"code":"400|450035","message":"The event expired."},{"code":"400|450037","message":"The event link is deactived test"},{"code":"400|170305","message":"Hubspot Contact Data Invalid"},{"code":"400|060808","message":"Quiz Attempt Question Grading Not Allowed For Non Mentor"},{"code":"400|041005","message":"User Examination Result Invalid"},{"code":"400|041205","message":"User Student Not Change Subject Examination Final"},{"code":"400|100309","message":"Examination Is Finalized"},{"code":"400|100409","message":"Class User Not Create Ticket Hubspot"},{"code":"400|101705","message":"Room Mode Missing Field"},{"code":"400|171305","message":"Hubspot Contact Email Invalid"},{"code":"400|420007","message":"Subject And Examination Not Match"},{"code":"400|430037","message":"Can Not Calculate Score"},{"code":"400|480004","message":"Department Not Found"},{"code":"400|480005","message":"Invalid Department Type"},{"code":"400|480006","message":"Department No Parent"},{"code":"400|480007","message":"Invalid Department Unit"},{"code":"400|480008","message":"Department With Child Department"},{"code":"400|480016","message":"Unable to edit the receptionist as they are assigned to a shift in an existing request. Please check the related request"},{"code":"400|480024","message":"Invalid Department Parent"},{"code":"400|480106","message":"Department Related To Staff"},{"code":"400|480206","message":"Department Related To Support Group"},{"code":"400|481004","message":"University Not Found"},{"code":"400|482004","message":"Major Not Found"},{"code":"400|483004","message":"University Program Not Found"},{"code":"400|490004","message":"Start Date Of The Next Recurrence Overlaps With The End Date Of The Previous Recurrence"},{"code":"400|480604","message":"Room Schedule Cannot Modify Old Schedule"},{"code":"400|480704","message":"Room Schedule End Date Repeat Over 2 Years"},{"code":"400|480804","message":"Room Schedule Not Found"},{"code":"400|480904","message":"Room Schedule Rental Update Invalid Input"},{"code":"400|481904","message":"Room Schedule The Loop Interval"},{"code":"400|482904","message":"Room Schedule Not Clear Occurred Exception"},{"code":"400|490104","message":"Schedule Start Date Is Less Than End Date"},{"code":"400|490204","message":"Schedule End Date Is Less Than End Date Repeat"},{"code":"400|490304","message":"Schedule Start Date Is More Than Date Now"},{"code":"400|491004","message":"Schedule Holiday Has Been Taken Place"},{"code":"400|500005","message":"Course Section Prerequisite Itself"},{"code":"400|500006","message":"Course Section Circular Prerequisite"},{"code":"400|500024","message":"Course Section Used As Prerequisite"},{"code":"400|500105","message":"Course Section Prerequisite Different Parent"},{"code":"400|500107","message":"Course Section Prerequisite Different Type"},{"code":"400|510004","message":"Course Timeline Not Found"},{"code":"400|510006","message":"Course Timeline Invalid Section Order"},{"code":"400|510008","message":"Course Section Already Scheduled"},{"code":"400|510012","message":"Course Timeline Invalid Course Content"},{"code":"400|510033","message":"Course Timeline Duplicate Name"},{"code":"400|510104","message":"Course Schedule Version Not Found"},{"code":"400|510116","message":"Course Timeline Version Not Active"},{"code":"400|510210","message":"Course Timeline Multiple Section"},{"code":"400|520004","message":"Class Timeline Not Found"},{"code":"400|520104","message":"Class Schedule Version Not Found"},{"code":"404|450009","message":"Product Not Found"},{"code":"404|450005","message":"Promotion Not Found"},{"code":"400|450006","message":"Promotion Can Not Combine"},{"code":"400|450007","message":"Secure Hash Does Not Match"},{"code":"404|450008","message":"Order Not Found"},{"code":"400|450031","message":"Order Expired"},{"code":"400|450036","message":"Invalid Payment Option"},{"code":"400|450037","message":"Product Existed"},{"code":"400|450038","message":"Product Code Existed"},{"code":"400|450039","message":"Promotion Discount Invalid"},{"code":"400|450040","message":"Invalid Start Date or End Date, please check again"},{"code":"400|450046","message":"The Combo\'s name existed"},{"code":"400|450049","message":"The Promotion\'s code existed"},{"code":"400|600004","message":"Teacher Schedule Not Found"},{"code":"400|600005","message":"Teacher Schedule Already Passed"},{"code":"400|600007","message":"Can Not Delete Teacher Schedule"},{"code":"400|450001","message":"Busy Schedule Existed"},{"code":"400|460001","message":"Request Schedule Existed"},{"code":"400|460004","message":"Request Schedule Not Found"},{"code":"400|460005","message":"Weekly Norm Existed"},{"code":"400|460006","message":"Can Not Delete Request"},{"code":"400|460007","message":"Weekly Norm Invalid Data"},{"code":"400|460009","message":"Invalid Status Transition"},{"code":"400|460010","message":"Can Not Update Request"},{"code":"400|490104","message":"Schedule start date is less than end date."},{"code":"400|490204","message":"The schedule end date must be after the repeat end date."},{"code":"400|490304","message":"The start date must be on or before today"},{"code":"400|480204","message":"Room schedule duplicate calendar {TOTAL_DATE}, such as {DATE_MESSAGE}"},{"code":"400|480304","message":"The room schedule contains multiple duplicate entries in the calendar."},{"code":"400|480404","message":"The start date exceeds the allowed repeat range."},{"code":"400|480504","message":"The old room schedule could not be found."},{"code":"400|480604","message":"The old room schedule cannot be modified."},{"code":"400|480704","message":"The repeat end date cannot be more than 2 years away."},{"code":"400|480804","message":"Room schedule not found."},{"code":"400|480904","message":"Invalid input for room rental schedule update."},{"code":"400|481904","message":"Scheduled time is outside the allowed loop interval."},{"code":"400|482904","message":"Failed to clear the room schedule due to an exception."},{"code":"400|100312","message":"Empty Examination Change Reason"},{"code":"400|420008","message":"User Examination Out Of Range"},{"code":"400|420010","message":"Maximum 2 Examination Change"},{"code":"400|480104","message":"Lessee Tag Not Found"},{"code":"400|490011","message":"Number of parts is out of bounds"},{"code":"400|071206","message":"Course section link nested within two course sections"},{"code":"400|490016","message":"Invalid date in course section link"},{"code":"400|490007","message":"Course section parent not added to class"},{"code":"400|490006","message":"Course section already exists in class"},{"code":"400|490005","message":"Can Not Delete Past Schedule"},{"code":"400|490015","message":"Invalid Class Standard Schedules"},{"code":"400|490012","message":"Class Schedule Has Been Started"},{"code":"400|490013","message":"Cannot Edit Past Schedules"},{"code":"400|490014","message":"Invalid Learning Mode Switch"},{"code":"400|490023","message":"Link Meeting Required"},{"code":"400|490024","message":"Lesson date is in the past"},{"code":"400|490017","message":"Invalid Time Range"},{"code":"400|490010","message":"Maximum Schedule Per Day"},{"code":"400|490019","message":"Class schedule is conflicted"},{"code":"400|490018","message":"Schedule Conflict"},{"code":"400|490020","message":"Teacher schedule is conflicted"},{"code":"400|490021","message":"Deadline In Past"},{"code":"400|530003","message":"Invalid Date Format"},{"code":"400|530002","message":"Invalid Custom Price"},{"code":"400|530000","message":"Class schedule not found"},{"code":"400|530005","message":"Cannot delete past schedule exception"},{"code":"400|490005","message":"Schedule not found"},{"code":"400|100609","message":"Please Add Learning Schedule Before Choosing Teacher"},{"code":"400|100709","message":"Teacher Schedule Has More Than 3 Overlapping Lessions"},{"code":"400|041305","message":"Teacher cannot change the featured section by assigning a course section."},{"code":"400|011905","message":"Teacher Does Not Belong To This Facility"},{"code":"400|020938","message":"Facility Manager cannot be deleted."},{"code":"400|020901","message":"Staff Assigned To Facility"},{"code":"400|020916","message":"Facility is not active."},{"code":"400|020934","message":"Part-time receptionist belongs to another facility."},{"code":"400|020918","message":"Part-time receptionist cannot be a Facility Manager."},{"code":"400|020904","message":"Trying to transfer or remove, but staff is not in the facility."},{"code":"400|530001","message":"The Payment Option is invalid."},{"code":"400|530002","message":"The Custom Price is invalid."},{"code":"400|530003","message":"The Date Format is invalid."},{"code":"400|530004","message":"The length of text must be less or equal than 200 Characters"},{"code":"400|530101","message":"The Product has existed."},{"code":"400|530102","message":"The Product Code has existed."},{"code":"400|530103","message":"The Product is not found or inactive."},{"code":"404|530104","message":"The Product is not found."},{"code":"404|530201","message":"The Promotion is not found."},{"code":"400|530202","message":"The Promotion is unable to combine."},{"code":"400|530203","message":"The Promotion Dicount is invalid."},{"code":"400|530204","message":"The Promotion Code\'s Start Date or End Date is invalid."},{"code":"400|530205","message":"The Promotion is out of Quantity."},{"code":"400|530206","message":"Some Promotions are invalid."},{"code":"400|530207","message":"The Promotion has existed."},{"code":"400|530208","message":"The Promotion can not be edited."},{"code":"400|530209","message":"The Promotion is non-editable because it has been attached or redeemed."},{"code":"400|530210","message":"The new quantity must be larger or equal the original quantity."},{"code":"400|530211","message":"The new start date can not be before the first time that this promotion is attached to an order."},{"code":"400|530212","message":"The new end date can not be before the last time that this promotion is attached to an order."},{"code":"400|530301","message":"The Deal ID has existed."},{"code":"404|530302","message":"The Order is not found."},{"code":"400|530303","message":"The Order has expired."},{"code":"400|530304","message":"The Order is non-editable."},{"code":"400|530305","message":"The Order Price is mis-calculated. Please contact the Admin, or select another Products, Combos, Promotions."},{"code":"400|530306","message":"The installment option requires the final price is larger or equal 3 000 000 VND."},{"code":"400|530307","message":"The same promotion cannot be used for both a product and a combo containing that product"},{"code":"400|530401","message":"The Combo is not found."},{"code":"400|530402","message":"The Combo has existed."},{"code":"401|530501","message":"VNPay gets an error. Please contact the staff or Admin."},{"code":"404|530502","message":"VNPay gets an error. Please contact the staff or Admin."},{"code":"400|530503","message":"VNPay gets an error. Please contact the staff or Admin."},{"code":"400|530504","message":"VNPay gets an error. Please contact the staff or Admin."},{"code":"400|530505","message":"VNPay gets an error. Please contact the staff or Admin."},{"code":"400|530506","message":"VNPay gets an error. Please contact the staff or Admin."},{"code":"400|50001","message":"All class schedules have already assigned!"},{"code":"400|460021","message":"Registered the maximum allowed number of requests"},{"code":"400|020039","message":"Staff Block Not Allowed"},{"code":"400|010908","message":"Invalid User Facility"},{"code":"400|020139","message":"Invalid Staff Department Facility Manager"},{"code":"400|020939","message":"Staff Facility Can Not Add All Receptionist Parttime"},{"code":"400|021005","message":"Staff Course Category Invalid With Department"},{"code":"400|021104","message":"Staff Position Not Found"},{"code":"400|021133","message":"Staff Position Incorrect With Department"},{"code":"400|021139","message":"Invalid Staff Position Facility Manager"},{"code":"400|021204","message":"Staff Level Not Found"},{"code":"400|071305","message":"Course Learning Outcome Invalid"},{"code":"403|071838","message":"Course Discussion Supporter Not Permission"},{"code":"400|072204","message":"Course Copy Content Log Not Found"},{"code":"422|072205","message":"Course Section Id Not Suitable"},{"code":"400|073907","message":"Course Section Not Change Feature Section"},{"code":"400|100509","message":"Class Lecturer Duplicate Course Section"},{"code":"400|100809","message":"Class Hybrid Not Add Teacher"},{"code":"400|101805","message":"Room Not Active"},{"code":"400|102005","message":"Class Link Meeting Required When Update Classroom"},{"code":"400|102007","message":"Facility And Room Mismatch"},{"code":"400|230005","message":"Category Cycle Exist"},{"code":"400|290035","message":"Shop Event Invalid Date"},{"code":"404|360010","message":"Staff Details Not Found"},{"code":"400|360011","message":"Invalid Business Unit"},{"code":"400|360012","message":"Pipeline Is Not Existed"},{"code":"400|360013","message":"Cannot Determine Staff Owner"},{"code":"500|360015","message":"Failed To Save Ticket"},{"code":"404|360016","message":"Ticket Not Found"},{"code":"404|360017","message":"No Matching Records"},{"code":"422|360017","message":"Owner Not In Facility"},{"code":"404|360018","message":"No Classes Found"},{"code":"404|360019","message":"No Class Schedule Course Section Found"},{"code":"404|360020","message":"Course Section Not Found"},{"code":"500|360021","message":"Failed To Save Class Teaching Progress"},{"code":"404|360021","message":"Base Class Schedule Not Found"},{"code":"404|360022","message":"No Uncompensated Course Sections Found"},{"code":"404|360023","message":"No Class Teaching Progress Found"},{"code":"500|360099","message":"Failed To Save Class Teaching Progress Compensation"},{"code":"400|460000","message":"Class Schedule Not Found"},{"code":"404|460004","message":"Request Schedule Not Found"},{"code":"400|460008","message":"Weekly Norm Not Found"},{"code":"400|460012","message":"Request Instances Not Found"},{"code":"400|460013","message":"Not Found Weekly Norm"},{"code":"400|460015","message":"Cannot Delete Request With Invalid Status"},{"code":"400|460016","message":"Can Not Create Request"},{"code":"400|460018","message":"Schedules Not In Same Class"},{"code":"400|460019","message":"Staff Assignee Not Found"},{"code":"400|460020","message":"Can Not Upload Attachment File"},{"code":"400|460022","message":"Max Attachment Files Per Request Exceeded"},{"code":"400|460023","message":"All Receptionist Schedules Already Assigned"},{"code":"400|460024","message":"Dates Must Be Greater Than Or Equal To Today"},{"code":"400|460105","message":"Room schedule is conflicted"},{"code":"400|460404","message":"Class Schedule Teacher Not Found"},{"code":"400|470025","message":"Facility Cannot Delete"},{"code":"400|470122","message":"Teacher Lms Has Not Permission For This Class"},{"code":"400|471122","message":"Teacher Lms Has Not Permission"},{"code":"400|480001","message":"Department Existed"},{"code":"400|480010","message":"Receptionist Schedule Has Been Fully Booked"},{"code":"404|480011","message":"Receptionist Schedule Not Found"},{"code":"400|480012","message":"Receptionist Schedules Not In Same Week"},{"code":"400|480013","message":"Max Shift Registration Exceeded"},{"code":"400|480014","message":"Cannot Register Receptionist Schedule"},{"code":"400|480015","message":"Cannot Cancel Receptionist Schedule Registration"},{"code":"400|480016","message":"Unable to edit the receptionist as they are assigned to a shift in an existing request. Please check the related request"},{"code":"400|480017","message":"Cannot Update Receptionist Schedule"},{"code":"400|481104","message":"Lessee Contact Not Found"},{"code":"400|482104","message":"Lessee Contact Phone Exist"},{"code":"400|490003","message":"Class Schedule Change Empty Reason"},{"code":"400|490408","message":"Teacher Not Authorized To Teach Course Section"},{"code":"400|491005","message":"Holiday schedule exists"},{"code":"400|500004","message":"Calendar Student Not Found"},{"code":"400|520105","message":"Class Not Met Condition"},{"code":"400|520106","message":"Link Meeting Is Required For Live Online Mode"},{"code":"400|530014","message":"Request Schedule Is Due"},{"code":"400|530015","message":"Cannot Update Because Arrange Type Is Not Auto"},{"code":"400|530400","message":"Request Schedule Status Invalid"},{"code":"400|600006","message":"Teacher Schedule Overlaps"},{"code":"400|530016","message":"Invalid Class Code"},{"code":"403|071909","message":"Locked Course Content"},{"code":"400|100909","message":"The Maximum Number Of Lessons The Teacher Can Take Has Been Reached"},{"code":"404|550400","message":"Enrollment Rules Not Found"},{"code":"400|540000","message":"Enrollment Time Range Overlaps"}]');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(86075), __webpack_exec__(6840), __webpack_exec__(73053); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);